require=(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({"event-stream":[function(require,module,exports){
"use strict";

module.exports = window.eventStream;
if (window.eventStream) module.exports["default"] = window.eventStream;

},{}],"katex":[function(require,module,exports){
"use strict";

module.exports = window.katex;
if (window.katex) module.exports["default"] = window.katex;

},{}],226:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _dexie = _interopRequireDefault(require("dexie"));
var DexieJsDBManage = {};

// indexedDB.databases().then(databases => {
//   databases.forEach(dbInfo => {
//       if (dbInfo.name === "dexie_db_9_3_0") {
//           // 使用 IndexedDB 的 deleteDatabase 方法删除数据库
//           indexedDB.deleteDatabase(dbInfo.name).then(() => {
//               console.log("Database deleted successfully");
//           }).catch(error => {
//               console.error("Error deleting database:", error);
//           });
//       }
//   });
// }).catch(error => {
//   console.error("Error retrieving database list:", error);
// });

// 直接删除指定名称的数据库
var dbName = "dexie_db_9_3_0";
_dexie["default"]["delete"](dbName).then(function () {
  console.log("Database deleted successfully");
})["catch"](function (error) {
  console.error("Error deleting database:", error);
});
DexieJsDBManage.init = function () {
  var db = new _dexie["default"]("ai_dexie_db");
  var aiTextHistoryTable = {
    "aiTextHistory": "++id, que, ans, time, userId",
    "aiDB": "++id, fileId, type, text, status, userId"
  };
  db.version(1).stores(aiTextHistoryTable);
  db.open();
  return db;
};
// DexieJsDBManage.init()
var _default = exports["default"] = DexieJsDBManage;

},{"1184":1184,"1454":1454,"dexie":"dexie"}],"dexie":[function(require,module,exports){
"use strict";

module.exports = window.Dexie;
if (window.Dexie) module.exports["default"] = window.Dexie;

},{}],225:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1463);
require(1471);
require(1439);
// if (!window.indexedDB) {
//     console.log("Your browser doesn't support a stable version of IndexedDB. Such and such feature will not be available.");
// }

var DBManage = {};
DBManage.openDB = function () {
  return new Promise(function (resolve, reject) {
    if (window.INDEXEDDB_DB_RET) {
      resolve(true);
    }
    var indexedDB = window.indexedDB || window.webkitindexedDB;
    var dbName = "user_local_db";
    // 打开我们的数据库
    var request = indexedDB.open(dbName, 4); //1换成userId,可以用来区别每个用户，为每个用户创建对应数据库

    request.onerror = function (e) {
      console.error(e.currentTarget.error.message);
      reject(false);
    };
    request.onsuccess = function (e) {
      window.INDEXEDDB_DB_RET = e.target.result;
      console.log('成功建立并打开数据库:' + dbName + ' version' + 4);
      resolve(true);
    };
    request.onupgradeneeded = function (event) {
      var db = event.target.result;
      // 建立一个对象仓库来存储我们客户的相关信息，我们选择 ssn 作为键路径（key path）
      // 因为 ssn 可以保证是不重复的
      var objectStore;
      if (db.objectStoreNames.contains('filelist')) {
        db.deleteObjectStore("filelist");
      }
      if (db.objectStoreNames.contains('fileHistory')) {
        db.deleteObjectStore("fileHistory");
      }
      console.error('怎么一直在调用');
      // if (!db.objectStoreNames.contains('filelist')) {
      //使用自增主键，保证按照先后存储时间排列
      // objectStore = db.createObjectStore('filelist', {keyPath: "fileId"});
      objectStore = db.createObjectStore('filelist', {
        autoIncrement: true
      });
      // 同一个file可能对于不同的文件目录  根目录及部门
      objectStore.createIndex("fileId", "fileId", {
        unique: false
      });
      objectStore.createIndex('locationHash', 'locationHash', {
        unique: false
      });
      objectStore = db.createObjectStore('fileHistory', {
        autoIncrement: true
      });
      // 同一个file可能对于不同的文件目录  根目录及部门
      objectStore.createIndex("fileId", "fileId", {
        unique: false
      });
      objectStore.createIndex('locationHash', 'locationHash', {
        unique: false
      });

      // 使用事务的 oncomplete 事件确保在插入数据前对象仓库已经创建完毕
      objectStore.transaction.oncomplete = function (event) {};
      // }
    };
    window.INDEXEDDB_DB = indexedDB;
  });
};
DBManage.putData = function (storename, data, success) {
  DBManage.openDB().then(function (ready) {
    console.log(data);
    var store = INDEXEDDB_DB_RET.transaction(storename, 'readwrite').objectStore(storename);
    var saveDatas = function saveDatas(data, index, store) {
      var request = store.put(data[index]);
      request.onerror = function (e) {
        console.error('put添加数据库中已有该数据');
        console.log(e);
      };
      request.onsuccess = function () {
        //   console.log('put添加数据已存入数据库')
        //   console.log(data[index].fileId)
        index++;
        if (index < data.length) {
          saveDatas(data, index, store);
        } else {
          success && success();
        }
      };
    };
    saveDatas(data, 0, store);

    //    for (let i = 0; i < data.length; i++) {
    //        let request = store.put(data[i]);
    //        request.onerror = function () {
    //            console.error('put添加数据库中已有该数据')
    //        };
    //        request.onsuccess = function () {
    //            console.log('put添加数据已存入数据库')
    //        };
    //    }			
  });
};
DBManage.readData = function (storename, targetObj) {
  return DBManage.openDB().then(function (ready) {
    return new Promise(function (resolve, reject) {
      var objectStore = INDEXEDDB_DB_RET.transaction(storename).objectStore(storename);
      var index = objectStore.index(targetObj.name);
      var c = index.openCursor(IDBKeyRange.only(targetObj.value));
      c.onerror = function (event) {
        reject(event);
      };
      var result = [];
      c.onsuccess = function (event) {
        // 对 request.result 做些操作！
        var cursor = event.target.result;
        if (cursor) {
          // cursor.value就是数据对象
          // 游标没有遍历完，继续
          result.push(cursor.value);
          cursor["continue"]();
        } else {
          // 如果全部遍历完毕...
          resolve(result);
        }
      };
    });
  });
};
DBManage.removeData = function (storename, targetObj, success) {
  DBManage.openDB().then(function (ready) {
    var objectStore = INDEXEDDB_DB_RET.transaction([storename], 'readwrite').objectStore(storename);
    var index = objectStore.index(targetObj.name);
    var c = index.openCursor(IDBKeyRange.only(targetObj.value));
    c.onerror = function (event) {
      reject(event);
    };
    var result = [];
    c.onsuccess = function (event) {
      // 对 request.result 做些操作！
      var cursor = event.target.result;
      if (cursor) {
        // if(deleteIds.indexOf(cursor.key) > -1) {
        cursor["delete"]();
        // }
        // cursor.value就是数据对象
        // 游标没有遍历完，继续        
        cursor["continue"]();
      } else {
        // 如果全部遍历完毕...
        console.log('如果全部遍历完毕');
        success();
      }
    };
  });
};
DBManage.clearData = function () {
  DBManage.openDB().then(function (ready) {
    if (ready) {
      var storename = 'filelist';
      var store = INDEXEDDB_DB_RET.transaction(storename, 'readwrite').objectStore(storename);
      store.clear();
      console.log('已删除存储空间' + storename + '全部记录');
    }
  });
};
DBManage.clearHistoryData = function () {
  DBManage.openDB().then(function (ready) {
    if (ready) {
      var storename = 'fileHistory';
      var store = INDEXEDDB_DB_RET.transaction(storename, 'readwrite').objectStore(storename);
      store.clear();
      console.log('已删除存储空间' + storename + '全部记录');
    }
  });
};
window.DBManage = DBManage;
var _default = exports["default"] = DBManage;

},{"1439":1439,"1454":1454,"1463":1463,"1471":1471}],569:[function(require,module,exports){
"use strict";

require(1475);
require(1429);
require(1439);
require(1477);
require(1503);
require(1500);
require(1502);
require(1422);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1423);
require(1463);
require(1480);
require(1487);
require(1538);
require(1437);
require(1478);
require(1417);
require(1419);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MMFileInfoCollection = _interopRequireDefault(require(298));
var _MDShareFileWindowView = _interopRequireDefault(require(695));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDPaginationView = _interopRequireDefault(require(61));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MEDepartChooseView = _interopRequireDefault(require(138));
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } //
// WebContent/javascript/moladisk/views/file/fileinfo/MDDepShareFileListWinView.js
//
var MDDepShareFileListWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDDepShareFileListWinView, _MDWindowView);
  function MDDepShareFileListWinView() {
    (0, _classCallCheck2["default"])(this, MDDepShareFileListWinView);
    return _callSuper(this, MDDepShareFileListWinView, arguments);
  }
  (0, _createClass2["default"])(MDDepShareFileListWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n\t\t\t<div class=\"button-block flex-align between\">\n\t\t\t\t<span class=\"mgb-10\"><%=(isdep? BabelStr.str(2850): BabelStr.str(22053))%></span>\n\t\t\t\t<div class=\"btns\">\n          <%if(isdep && canManageFilePermission){%>\n            <button class=\"text-button done export-excel mgr-10\"><%=BabelStr.str(6017)%></button>\n          <%}%>\n\t\t\t\t\t<button class=\"button done show-share mgr-10\"><%=BabelStr.str(2845)%></button>\n          <%if(canManageFilePermission){%>\n            <button class=\"button done close-share\"><%=BabelStr.str(2846)%></button>\n          <%}%>\n\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"flex-align search-wrap row mgb-10\">\n\t\t\t\t\t<div class=\"search-c mgr-10 search-box  col-4\">\n\t\t\t\t\t\t<div class=\"icon-search\"></div>\n\t\t\t\t\t\t<input id=\"search-file-name\" placeholder='<%=BabelStr.str(4532)%>'>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"departs-tree  mgr-10  col-4 cursor-p\"></div>\n\t\t\t</div>\n\t\t\t<div class=\"file-list\">\n\t\t\t\t<div class=\"row file-head\">\n\t\t\t\t\t<div class=\"col-5 flex-align middle\">\n\t\t\t\t\t\t<div class=\"m-chb\"><div class=\"box\"></div></div>\n\t\t\t\t\t\t<span><%=BabelStr.str(49)%></span>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"col-3\"><%=BabelStr.str(2847)%></div>\n\t\t\t\t\t<div class=\"col-2\"><%=BabelStr.str(3215)%></div>\n\t\t\t\t\t<div class=\"col-2\"><%=BabelStr.str(2848)%></div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"list-body fileinfo\"></div>\n\t\t\t\t<div class=\"page-bar fileinfo marginT-10\"></div>\n\n\t\t\t\t<div class=\"empty flex-align middle center\">\n\t\t\t\t\t<span class=\"help-block mgtb-20\"><%=BabelStr.str(2851)%></span>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t";
    }
  }, {
    key: "renderItem",
    value: function renderItem(data) {
      return "\n\t\t\t<div class=\"row file-item\" data-id=\"".concat(data.fileId, "\" data-parentid=\"").concat(data.parentId, "\">\n\t\t\t\t<div class=\"col-5 flex-align middle\">\n\t\t\t\t\t<div class=\"m-chb\"><div class=\"box\"></div></div>\n\t\t\t\t\t<span class=\"filename150 text-overflow\" data-tooltip=\"").concat(data.fileName, "\">").concat(data.fileName, "</span>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-3 filename150 text-overflow\" data-tooltip=\"").concat(data.sharerName, "\">").concat(data.sharerName, "</div>\n\t\t\t\t<div class=\"col-2 filename150 text-overflow\" data-tooltip=\"").concat(data.depName || "--", "\">").concat(data.depName || "--", "</div>\n\t\t\t\t<div class=\"col-2 open-folder\">\n\t\t\t\t\t<span class=\"text-button done\">").concat(BabelStr.str(265), "</span>\n\t\t\t\t</div>\n\t\t\t</div>");
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepShareFileListWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " file-share-list-win");
    }
  }, {
    key: "initProps",
    value: function initProps(props) {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepShareFileListWinView.prototype), "initProps", this).call(this, props);
      return _.extend(superP, {
        fileInfo: 0,
        fileInforCollection: null,
        pageSize: 10,
        width: 800,
        selectedFiles: new Set()
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepShareFileListWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .file-item': this._clickfileItemHandle,
        'click .file-head': this._clickfileHeadHandle,
        'click .close-share': this._closeShareHandle,
        'click .show-share': this._disShareFile,
        'click .open-folder': this._openFolderHandle,
        'keyup #search-file-name': this.kerWordsChanged,
        'click .export-excel': this._exportExcel
      });
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        isdep: this.fileInfo.isDepartmentFolder(),
        canManageFilePermission: this.fileInfo.canManageFilePermission()
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepShareFileListWinView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.title = BabelStr.str(2842);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepShareFileListWinView.prototype), "initialize", this).call(this, props);
      this.$('.show-share').hide();
      this.$('.close-share').disable();
      this.listenTo(this.fileInforCollection, "add", this._addHandle);
      this.pageIndex = 0;
      this.pageSize = 10;
      this.renderPageBar();
      this.folderId = this.fileInfo.getFileId();
      this.parentId = this.fileInfo.get('departmentId');
      if (this.fileInfo.isDepartmentFolder()) {
        this.departSelectView = new _MEDepartChooseView["default"]({
          selectedDepartId: this.parentId,
          rootId: this.parentId,
          needAddDefault: false,
          readonly: true,
          placeholder: BabelStr.str(3097),
          /*'选择部门',*/
          required: true,
          needRoot: true,
          canEditParentDepart: false,
          onChange: function onChange(node) {
            if (_this.parentId != node.id) {
              _this.parentId = node.id;
              _this.folderId = node.original.folderId;
              _this.initData();
            }
          }
        });
        this.addSubView(this.departSelectView, this.$('.departs-tree')[0], true);
      }
      this.initData();
      _czc && _czc.push(["_trackEvent", "部门管理", "查看分享", "", "", ""]);
    }
  }, {
    key: "_exportExcel",
    value: function _exportExcel() {
      var _this2 = this;
      var keys = _.escape(this.$('#search-file-name').val());
      var options = {
        key: keys,
        fileId: this.folderId,
        departmentName: encodeURI(encodeURI(this.fileInfo.getFileName()))
      };
      this.$('.export-excel').attr("disabled", true);
      setBabelTimeout(function () {
        _this2.$('.export-excel').attr("disabled", false);
      }, 1000 * 60);
      MMEnterpriseController.downloadDepShareFileList(options);
      console.log(options);
    }
  }, {
    key: "renderPageBar",
    value: function renderPageBar() {
      var _this3 = this;
      this.pageBarView = new _MDPaginationView["default"]({
        enableStepButton: true,
        showJumpToPage: false,
        silentInit: true,
        showSelectSizeList: false,
        align: 'left',
        pageSize: this.pageSize,
        onPageChanged: function onPageChanged(curPageIndex) {
          _this3._pageChanged(curPageIndex);
        }
      });
      this.addSubView(this.pageBarView, this.$(".page-bar")[0]);
    }
  }, {
    key: "refreshPageBar",
    value: function refreshPageBar(count) {
      this.paginationBarView.setLength(count, true, this.pageIndex);
      if (count > 0) {
        this.paginationBarView.show();
      } else {
        this.paginationBarView.hide();
      }
    }

    // getShareInDepartment() {
    // 	MDSpinnerloaderView.showIn(this.$('.list-body')[0])
    // 	MMEnterpriseController.getShareInDepartment(this.fileInfo.getFileId(), fileInforCollection => {
    // 		MDSpinnerloaderView.clearFrom(this.$('.list-body')[0])
    // 		let tmpl = '';
    // 		fileInforCollection.each(fileInfo => {
    // 			let data = {
    // 				fileId: fileInfo.getFileId(),
    // 				fileName: fileInfo.getFileName(),
    // 				sharerName: fileInfo.get("sharerId") == 0 ? '--' : fileInfo.get("sharerName"),
    // 				depName: '部门',
    // 				parentId: fileInfo.get("parentId")
    // 			}
    // 			tmpl += this.renderItem(data)
    // 		})
    // 		this.$('.list-body').html(tmpl)
    // 		this.fileInforCollection = fileInforCollection;
    // 		if(this.fileInforCollection.length < 1) {
    // 			this.$('.empty').show();
    // 			this.$('.btns').hide();
    // 			this.$('.row').hide()
    // 		}else {
    // 			this.$('.empty').hide()
    // 			this.$('.show-share').hide()
    // 		}
    // 	})
    // }
  }, {
    key: "_pageChanged",
    value: function _pageChanged(pgIndex) {
      this.pageIndex = pgIndex * this.pageSize;
      this.refreshData();
    }
  }, {
    key: "refreshData",
    value: function refreshData() {
      var _this4 = this;
      var keys = _.escape(this.$('#search-file-name').val());
      this.$('.list-body').empty();
      this.$('.list-body').show();
      this.$('.empty').hide();
      _MDSpinnerloaderView["default"].showIn(this.$('.list-body')[0]);
      var request = MMEnterpriseController.getShareInCommonFolder;
      if (this.fileInfo.isDepartmentFolder()) {
        request = MMEnterpriseController.getShareInDepartment;
      }
      request({
        key: keys,
        fileId: this.folderId,
        startIndex: this.pageIndex,
        pageSize: this.pageSize
      }, function (fileInforCollection, count) {
        _this4.selectedFiles.clear();
        _MDSpinnerloaderView["default"].clearFrom(_this4.$('.list-body')[0]);
        var tmpl = '';
        fileInforCollection.each(function (fileInfo) {
          var data = {
            fileId: fileInfo.getFileId(),
            fileName: fileInfo.getFileName(),
            sharerName: fileInfo.get("sharerId") == 0 ? '--' : fileInfo.get("sharerName"),
            depName: fileInfo.get("departmentName"),
            parentId: fileInfo.get("parentId")
          };
          tmpl += _this4.renderItem(data);
        });
        _this4.$('.list-body').html(tmpl);
        _this4.fileInforCollection = fileInforCollection;
        if (_this4.fileInforCollection.length < 1) {
          _this4.$('.empty').show();
          _this4.$('.btns').hide();
          _this4.$('.fileinfo').hide();
        } else {
          _this4.$('.fileinfo').show();
          _this4.$('.empty').hide();
          _this4.$('.show-share').hide();
          _this4.$('.btns').show();
        }
        _this4.pageBarView.setLength(count, true, _this4.pageIndex);
      }, function () {
        _MDSpinnerloaderView["default"].clearFrom(_this4.$('.list-body')[0]);
        _MDSnackbarView["default"].show(BabelStr.str(168));
      });
    }
  }, {
    key: "initData",
    value: function initData() {
      this.pageIndex = 0;
      this.refreshData();
    }
  }, {
    key: "kerWordsChanged",
    value: function kerWordsChanged(e) {
      var code = e.keyCode;
      if (code == 13) {
        this.initData();
      }
    }
  }, {
    key: "_clickfileItemHandle",
    value: function _clickfileItemHandle($e) {
      var $item = $($e.target).closest('.file-item');
      var id = $item.data("id").toString();
      if ($item.hasClass("checked")) {
        $item.removeClass("checked");
        $item.find(".m-chb").removeClass("checked");
        this.selectedFiles["delete"](id);
      } else {
        $item.addClass("checked");
        $item.find(".m-chb").addClass("checked");
        this.selectedFiles.add(id);
      }
      if (this.selectedFiles.size == this.fileInforCollection.length) {
        this.$('.file-head').addClass("checked");
        this.$('.file-head').find(".m-chb").addClass("checked");
      } else {
        this.$('.file-head').removeClass("checked");
        this.$('.file-head').find(".m-chb").removeClass("checked");
      }
      if (this.selectedFiles.size == 1) {
        this.$('.show-share').show();
      } else {
        this.$('.show-share').hide();
      }
      this._refreshCloseBtnStatus();
      console.log(this.selectedFiles);
    }
  }, {
    key: "_clickfileHeadHandle",
    value: function _clickfileHeadHandle($e) {
      var $item = $($e.target).closest('.file-head');
      if ($item.hasClass("checked")) {
        $item.removeClass("checked");
        $item.find(".m-chb").removeClass("checked");
        this.$('.file-item').removeClass("checked");
        this.$('.file-item').find(".m-chb").removeClass("checked");
        this.selectedFiles.clear();
      } else {
        $item.addClass("checked");
        $item.find(".m-chb").addClass("checked");
        this.$('.file-item').addClass("checked");
        this.$('.file-item').find(".m-chb").addClass("checked");
        var ids = this.fileInforCollection.pluck("fileId");
        this.selectedFiles = new Set(ids);
      }
      this.$('.show-share').hide();
      console.log(this.selectedFiles);
      this._refreshCloseBtnStatus();
    }
  }, {
    key: "_refreshCloseBtnStatus",
    value: function _refreshCloseBtnStatus() {
      if (this.selectedFiles.size > 0) {
        this.$('.close-share').enable();
      } else {
        this.$('.close-share').disable();
      }
    }
  }, {
    key: "_closeShareHandle",
    value: function _closeShareHandle() {
      var _this5 = this;
      var fileIds = Array.from(this.selectedFiles);
      MMEnterpriseController.closeShare(fileIds, function () {
        var _iterator = _createForOfIteratorHelper(_this5.selectedFiles),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var id = _step.value;
            var file = _this5.fileInforCollection.findWhere({
              "fileId": id
            });
            _this5.fileInforCollection.remove(file);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        _this5.$(".file-list .row.checked").remove();
        console.log('success');
        if (_this5.fileInforCollection.length < 1) {
          _this5.$('.empty').show();
          _this5.$('.btns').hide();
        } else {
          _this5.$('.empty').hide();
          _this5.$('.show-share').hide();
        }
        _this5.selectedFiles.clear();
        _MDSnackbarView["default"].show(BabelStr.str(308));
      }, function () {
        console.log('success');
      });
    }
  }, {
    key: "_openFolderHandle",
    value: function _openFolderHandle($e) {
      var $item = $($e.target).closest('.file-item');
      var fileId = $item.data("parentid").toString();
      app.pathRouter.openNewTabByFileId(fileId);
    }
  }, {
    key: "_disShareFile",
    value: function _disShareFile() {
      var fid = Array.from(this.selectedFiles)[0];
      var fileInfor = this.fileInforCollection.findWhere({
        "fileId": fid
      });
      var shareWin = new _MDShareFileWindowView["default"]({
        fileInfor: fileInfor
      });
      shareWin.show();
    }
  }]);
  return MDDepShareFileListWinView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"138":138,"1412":1412,"1417":1417,"1419":1419,"1422":1422,"1423":1423,"1429":1429,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"1477":1477,"1478":1478,"1480":1480,"1487":1487,"1500":1500,"1502":1502,"1503":1503,"1538":1538,"298":298,"61":61,"695":695,"72":72,"76":76,"93":93}],695:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMFileInfo = _interopRequireDefault(require(297));
var _MDShareFileWindowInvPanelView = _interopRequireDefault(require(694));
var _MDWindowView = _interopRequireDefault(require(93));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDShareFilePermissionInfoView = _interopRequireDefault(require(692));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDEvents = _interopRequireDefault(require(325));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDOneUserFileLogPageView = _interopRequireDefault(require(591));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MDInviteShareTabPanelView = _interopRequireDefault(require(679));
var _MDLinkShareTabPanelView = _interopRequireDefault(require(681));
var _MDTabView = _interopRequireDefault(require(82));
var _MDShareFileView = _interopRequireDefault(require(693));
var _MDEditalbeTextDiv = _interopRequireDefault(require(29));
var _MDSwitchView = _interopRequireDefault(require(79));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
/**
 *  Window for share file
 *  Created by manjun.han
 *  2015.9.14
 *  javascript/moladisk/views/file/share/MDShareFileWindowView.js
 *  rewrite by jichao
 *  2016.9.25
 *  rewrite by jiang
 *  2019-3-12
 */

var MDShareFileWindowView = _MDWindowView["default"].extend({
  className: function className() {
    var superCls = _MDWindowView["default"].prototype.className.call(this);
    return superCls + ' share-file-window share-win have2linehead with-left-title';
  },
  contentTmpl: "<div class=\"share-container\" >\n  </div>\n  ",
  events: function events() {
    var superE = _MDWindowView["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click #manage-user': this.changeToSharePanel
    });
  },
  initProps: function initProps() {
    var opt = _MDWindowView["default"].prototype.initProps.call(this);
    return _.extend(opt, {
      invPanel: null,
      linkPanel: null,
      canManageShare: false
    });
  },
  initialize: function initialize(opt) {
    var _this = this;
    var self = this;
    opt = _.extend({}, opt);
    this.bindSelf(this.changeToSharePanel, this.loadFinished, this.showRolesInfo, this.changeFileLog);
    this.bindSelf(this.changeToLinkPanel);
    this.bindSelf(this._setOpenShare);
    this.fileInfor = opt.fileInfor;
    opt.title = BabelStr.str(6359) + this.fileInfor.getFileName();
    opt.width = 720;
    _MDWindowView["default"].prototype.initialize.call(this, opt);
    this.shareView = new _MDShareFileView["default"]({
      fileInfor: opt.fileInfor,
      loadCallback: function loadCallback() {
        if (app && app.isEpVersion && app.isEpVersion()) {
          _this.$(".other-setting").removeClass("f-hide");
        }
      },
      close: function close() {
        _this.close();
      }
    });
    this.addSubView(this.shareView, this.$('.share-container')[0]);
    _Dispatcher["default"].trigger(_MDEvents["default"].Disable3DWheel);
  },
  viewDidRendered: function viewDidRendered() {
    _MDWindowView["default"].prototype.viewDidRendered.call(this);
    var $target = this.$('.window-header .title');
    var w = $target[0].offsetWidth;
    var tw = $target[0].scrollWidth;
    if (tw > w) {
      $target.attr('data-tooltip', this.fileInfor.getFileName());
    }
  },
  viewDidUnRendered: function viewDidUnRendered() {
    _MDWindowView["default"].prototype.viewDidUnRendered.call(this);
    _Dispatcher["default"].trigger(_MDEvents["default"].Enable3DWheel);
    _MMCommonFun["default"].removeTextInputInEditor('sharePanel');
  }
}, {
  showWindForClent: function showWindForClent(fileObj) {
    console.log('---------------- show wind');
    if (!fileObj || !fileObj.fileName) {
      return;
    }
    ;
    var fileInfo = new _MMFileInfo["default"]();
    fileInfo.set('fileId', fileObj.fileId);
    fileInfo.set('fileName', fileObj.fileName);
    // fileInfo.isClientShare = true;

    var wind = new MDShareFileWindowView({
      fileInfor: fileInfo
    });
    wind.show();
  }
});
_Dispatcher["default"].on(_MDEvents["default"].ClientShare_LocalFile, function (fileObj) {
  MDShareFileWindowView.showWindForClent(fileObj);
});
var _default = exports["default"] = MDShareFileWindowView;

},{"1098":1098,"1104":1104,"1184":1184,"1454":1454,"18":18,"29":29,"297":297,"325":325,"591":591,"679":679,"681":681,"692":692,"693":693,"694":694,"72":72,"76":76,"79":79,"812":812,"82":82,"93":93}],693:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1463);
require(1471);
require(1426);
require(1423);
require(1487);
require(1538);
var _MMFileInfo = _interopRequireDefault(require(297));
var _MDShareFileOperateManageView = _interopRequireDefault(require(691));
var _MDShareFileWindowInvPanelView = _interopRequireDefault(require(694));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDShareFilePermissionInfoView = _interopRequireDefault(require(692));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDEvents = _interopRequireDefault(require(325));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDOneUserFileLogPageView = _interopRequireDefault(require(591));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MDInviteShareTabPanelView = _interopRequireDefault(require(679));
var _MDLinkShareTabPanelView = _interopRequireDefault(require(681));
var _MDTabView = _interopRequireDefault(require(82));
var _MMViewBase = _interopRequireDefault(require(22));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDMolaUser = _interopRequireDefault(require(272));
/**
 *  Window for share file
 *  Created by manjun.han
 *  2015.9.14
 *  javascript/moladisk/views/file/share/MDShareFileView.js
 *  rewrite by jichao
 *  2016.9.25
 *  rewrite by jiang
 *  2019-3-12
 */

var MDShareFileView = _MMViewBase["default"].extend({
  el: '<div class="share-file-view">' + '<div id="share-window" >' + '<div class="share-win"></div>' + '<div class="loading"></div>' + '</div>' + '</div>',
  className: function className() {
    var superCls = _MMViewBase["default"].prototype.className.call(this);
    return superCls + ' ';
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click #manage-user': this.changeToSharePanel
    });
  },
  initProps: function initProps() {
    var opt = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(opt, {
      invPanel: null,
      linkPanel: null,
      canManageShare: false
    });
  },
  initialize: function initialize(opt) {
    var _this = this;
    var self = this;
    opt = _.extend({}, opt);
    this.bindSelf(this.changeToSharePanel, this.loadFinished, this.showRolesInfo, this.changeFileLog);
    this.bindSelf(this.changeToLinkPanel);
    this.bindSelf(this._setOpenShare);
    this.fileInfor = opt.fileInfor;
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    var getEnterpriseAttrPromise = new Promise(function (resolve, reject) {
      _MMEnterpriseController["default"].getEnterpriseAttr(function () {
        if (_this.fileInfor.isClientShare) {
          _this._initWithFakeFile(function () {
            resolve();
            // this._initTabPanels();
          });
        } else {
          _this.requestFileInfor(_this.fileInfor.getFileId(), function () {
            // this._initTabPanels();
            resolve();
          });
          _this.loading();
        }
      });
    });
    var getOutShareApproversPromise = new Promise(function (resolve, reject) {
      // if(this.fileInfor.get("outShareApprovers")) {
      //   resolve()
      //   return
      // }
      _MMEnterpriseController["default"].getOutShareApprovers(_this.fileInfor.getFileId(), function (outShareApprovers) {
        outShareApprovers.approvers = _.map(outShareApprovers.approvers, function (user) {
          return new _MDMolaUser["default"](user);
        });
        _this.fileInfor.set("outShareApprovers", outShareApprovers);
        resolve();
      }, function () {
        reject();
      });
    });
    Promise.all([getEnterpriseAttrPromise, getOutShareApproversPromise]).then(function (results) {
      // 所有 Promise 成功时执行
      // results 是按输入顺序排列的结果数组
      _this._initTabPanels();
    })["catch"](function (error) {
      // 任意一个 Promise 失败时立即执行
      // 返回第一个失败的 Promise 的错误
    });
  },
  _initTabPanels: function _initTabPanels() {
    var _this2 = this;
    var tabs = [];
    _MMNetDiskDataController["default"].isLinkParticipant(this.fileInfor.getFileId(), function (flag) {
      if (!flag) {
        _this2.inviteShareTabPanel = new _MDInviteShareTabPanelView["default"]({
          fileInfor: _this2.fileInfor,
          roles: _this2.roles,
          canManageShare: _this2.canManageShare,
          defaultRole: _this2.defaultRole,
          showFileLog: _this2.changeFileLog,
          changeToLinkPanel: _this2.changeToLinkPanel,
          close: _this2.close,
          loadFinished: _this2.loadFinished,
          changeFileInfor: _this2.changeFileInfor
        });
        tabs = [{
          title: BabelStr.str(7294),
          tabPanelView: _this2.inviteShareTabPanel,
          active: true
        }];
      }
      // && this.fileInfor.canShareout()
      var showCloseLinkShare = !_this2.fileInfor.canShareout();
      // app.ep.isShareAnoymousClosed() || !this.fileInfor.canShareout()
      if (_this2.fileInfor.canShowLinkShare()) {
        var canmanageLinkShare = _this2.canManageShare;
        if (canmanageLinkShare) {
          canmanageLinkShare = !_this2.fileInfor.isLinkNeedApproval();
        }
        _this2.linkShareTabPanel = new _MDLinkShareTabPanelView["default"]({
          showCloseLinkShare: showCloseLinkShare,
          fileInfor: _this2.fileInfor,
          roles: _this2.roles,
          canManageShare: canmanageLinkShare,
          defaultRole: _this2.defaultRole,
          showFileLog: _this2.changeFileLog,
          changeToLinkPanel: _this2.changeToLinkPanel,
          close: _this2.close,
          loadFinished: _this2.loadFinished,
          changeFileInfor: _this2.changeFileInfor
        });
        tabs.push({
          title: BabelStr.str(7295),
          tabPanelView: _this2.linkShareTabPanel
        });
      }
      var forClient = _this2.fileInfor.get('forClient');
      var cls = forClient ? '' : ' tab-win';
      _this2.sharePanel = new _MDTabView["default"]({
        className: 'share-tabs blue-style-tab1 block' + cls,
        tabBarDividerPosition: 2,
        fullMode: false,
        enableActivebar: false,
        tabs: tabs
      });
      _this2.addSubView(_this2.sharePanel, _this2.$('.share-win')[0]);
    });
  },
  loading: function loading() {
    this.placeholder = new _MDSpinnerloaderView["default"]();
    _MDSpinnerloaderView["default"].showIn(this.$(".loading"));
    this.$(".share-win").hide();
  },
  loadFinished: function loadFinished() {
    this.$(".share-win").show();
    _MDSpinnerloaderView["default"].clearFrom(this.$(".loading"));
    _.isFunction(this.loadCallback) && this.loadCallback();
  },
  requestFileInfor: function requestFileInfor(fid, callback) {
    var self = this;
    // if(this.fileInfor.isShortcuts()){
    //   fid = this.fileInfor.getShortCutsTargetFileId();
    // }
    _MMNetDiskDataController["default"].getFileInfoFromServer(fid, function (newFileInfor) {
      // self.fileInfor.set("newShareAll" , newFileInfor.get("newShareAll"));
      self.fileInfor.set("ownerId", newFileInfor.get("ownerId"));
      self.fileInfor.set("inviteShareControl", newFileInfor.get("inviteShareControl"));
      self.changeLinkStatu(newFileInfor.get("newShareAll"), newFileInfor.get("fileId"));
      self.fileInfor.set("extraStatus", newFileInfor.get("extraStatus"));
      self.fileInfor.set("anonymousVisit", newFileInfor.get("anonymousVisit"));
      self.fileInfor.set("isSharing", newFileInfor.get("isSharing"));
      self.fileInfor.set("newShareAll", newFileInfor.get("newShareAll"));
      self._canCurrentUserManageShare(fid, callback);
    }, function () {});
  },
  _initWithFakeFile: function _initWithFakeFile(callback) {
    var self = this;
    var fileInfor = self.fileInfor;
    self.fileInfor.set("ownerId", app.currentUser.getId());
    self.fileInfor.set("inviteShareControl", true);
    self.fileInfor.set("newShareAll", false);
    self.canManageShare = true;
    self.getRoles(callback);
  },
  changeLinkStatu: function changeLinkStatu(newShareAll, fileId) {
    var self = this;
    _MMNetDiskDataController["default"].isLinkOpenClosed(newShareAll, fileId, function (opened) {
      if (self.fileInfor.get("newShareAll") == 2) {} else {
        self.fileInfor.set("newShareAll", opened);
      }
    }, function () {});
  },
  _canCurrentUserManageShare: function _canCurrentUserManageShare(fid, callback) {
    var self = this;
    _MMNetDiskDataController["default"].canCurrentUserManageShare(fid, function (canShareout, managerInfos) {
      self.fileInfor.set("canShareout", canShareout);
      self.fileInfor.set("managerInfos", managerInfos);
      self.canManageShare = true;
      // self.canManageShare = false;
      self.getRoles(callback);
    }, function (canShareout, managerInfos) {
      self.fileInfor.set("canShareout", canShareout);
      self.fileInfor.set("managerInfos", managerInfos);
      self.canManageShare = false;
      self.getRoles(callback);
    });
  },
  changeToLinkPanel: function changeToLinkPanel(askLinkShareState) {
    this.loading();
    if (!this.activePanel) {
      return;
    } else {
      this.removeSubView(this.activePanel);
    }
    this.initLinkPanel(askLinkShareState);
    this.addSubView(this.activePanel, this.$(".share-win")[0]);
  },
  changeToSharePanel: function changeToSharePanel() {
    if (!this.logView) {
      return;
    } else {
      this.removeSubView(this.logView);
    }
    this.sharePanel.show();
    // this.addSubView(this.sharePanel, this.$(".share-win")[0]);
  },
  changeFileLog: function changeFileLog(user) {
    this.sharePanel.hide();
    this.logView = new _MDOneUserFileLogPageView["default"]({
      isOneFile: true,
      cancle: this.changeToSharePanel,
      user: user,
      fileInfor: this.fileInfor
    });
    this.addSubView(this.logView, this.$(".share-win")[0]);
  },
  initLinkPanel: function initLinkPanel(askLinkShareState) {
    if (!_.isBoolean(askLinkShareState)) {
      askLinkShareState = false;
    }
    this.activePanel = new _MDShareFileOperateManageView["default"]({
      askLinkShareState: askLinkShareState,
      fileInfor: this.fileInfor,
      roles: this.roles,
      canManageShare: this.canManageShare,
      defaultRole: this.defaultRole,
      changeFileInfor: this.changeFileInfor,
      changeToSharePanel: this.changeToSharePanel,
      close: this.close,
      loadFinished: this.loadFinished,
      showRolesInfo: this.showRolesInfo
    });
  },
  initInvPanel: function initInvPanel() {
    this.activePanel = new _MDShareFileWindowInvPanelView["default"]({
      fileInfor: this.fileInfor,
      roles: this.roles,
      canManageShare: this.canManageShare,
      showFileLog: this.changeFileLog,
      changeToLinkPanel: this.changeToLinkPanel,
      close: this.close,
      loadFinished: this.loadFinished,
      changeFileInfor: this.changeFileInfor
    });
  },
  changeFileInfor: function changeFileInfor(fileInfor) {
    this.fileInfor.set("isSharing", fileInfor.get("isSharing"));
    this.fileInfor.set("shareAll", fileInfor.get("shareAll"));
    this.fileInfor.set("shareRoleId", fileInfor.get("shareRoleId"));
    this.fileInfor.set("shareId", fileInfor.get("shareId"));
    this.fileInfor.set("shareName", fileInfor.get("shareName"));
  },
  getRoles: function getRoles(callback) {
    var self = this;
    var _initRoles = function _initRoles(roleCollection, defaultRole) {
      var shareRoles = [];
      roleCollection.each(function (roleInfo) {
        // var permission = roleInfo.getPermission();
        shareRoles.push(roleInfo);
      });
      self.roles = shareRoles;
      self.defaultRole = defaultRole;
      // self.initLinkPanel();
      // self.addSubView(self.activePanel, self.$(".share-win")[0]);
    };
    if (this.fileInfor.isClientShare) {
      _MMNetDiskDataController["default"].getAllRoles(function (roleCollection, defaultRole) {
        _initRoles(roleCollection, defaultRole);
        callback();
      }, function () {
        _MDSnackbarView["default"].show(BabelStr.str(7296));
      });
    } else {
      var fid = this.fileInfor.getFileId();
      _MMNetDiskDataController["default"].getRoles(fid, function (roleCollection, defaultRole) {
        _initRoles(roleCollection, defaultRole);
        callback();
      }, function () {
        _MDSnackbarView["default"].show(BabelStr.str(7296));
      });
    }
  },
  showRolesInfo: function showRolesInfo(param) {
    var self = this;
    _MDShareFilePermissionInfoView["default"].show();
  },
  viewDidUnRendered: function viewDidUnRendered() {
    _MMViewBase["default"].prototype.viewDidUnRendered.call(this);
  }
});
var _default = exports["default"] = MDShareFileView;

},{"1098":1098,"1104":1104,"1184":1184,"1423":1423,"1426":1426,"1454":1454,"1463":1463,"1471":1471,"1487":1487,"1538":1538,"18":18,"22":22,"272":272,"297":297,"325":325,"591":591,"679":679,"681":681,"691":691,"692":692,"694":694,"72":72,"76":76,"812":812,"82":82}],694:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1439);
require(1437);
require(1478);
require(1421);
var _FILE_ROLE_ID = _interopRequireDefault(require(236));
var _MMViewBase = _interopRequireDefault(require(22));
var _MDShareByLinkUserListItemView = _interopRequireDefault(require(687));
var _MDShareByInvUserListItemView = _interopRequireDefault(require(686));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _regexp = _interopRequireDefault(require(106));
// 已弃用
/**
 *  Window for share file
 *  Created by jichao
 *  2016.9.28
 */

/**
 * 管理参与者Panel
 */
var MDShareFileWindowInvPanelView = _MMViewBase["default"].extend({
  tmpl: '<div class="header"></div> \
    <div id="m-manage-panel"> \
      <div class="link-manage br-2"> \
        <div class="hd"> \
        </div> \
        <div class="bd f-hide"> \
          <div id="anonymousUsers"><%=anonymous%>(<span>0</span>)</div>\
          <div id="registerUsers"><%=registered%>(<span>0</span>)</div>\
          <div id="u-link-list"> \
            <div class="m-share-link-userlist"> \
                  <ul class="share-link-ulist flex-align with-wrap start"></ul> \
            </div> \
          </div> \
        </div> \
      </div> \
      <div class="line"></div> \
      <div class="invite-manage br-2"> \
        <div class="hd" > \
        <div class="hd-0 f-hide"> \
        </div> \
      </div> \
      <div class="bd"> \
        <div class="userlist"> \
            <div class="m-share-inv-userlist f-clb"> \
              <ul class="share-ulist"></ul> \
              <ul class="share-list-no-per"></ul> \
            </div> \
        </div> \
        </div> \
      </div> \
        <div class="ft"> \
            <button  id="returnLinkPanel"><span class="blue"><%=goBack%></span></button> \
        </div> \
    </div>',
  events: function events() {
    return {
      'click .link-manage .hd-1': this._toggleManagePanelItem,
      'click .invite-manage .hd': this._toggleInvManagePanelItem,
      'click .link-manage .hd-0 .right': this._changeToLinkPanelWithState,
      'click #returnLinkPanel': this._changeToLinkPanel,
      'click #closeInvShare': this._closeInvShareClick,
      'click #closeShareLink': this._closeLinkShareClick,
      'click #requestInvShare': this._changeToLinkPanel,
      'keyup .select': this._renderInvUser
    };
  },
  initProps: function initProps() {
    var opt = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(opt, {
      roleArr: [],
      canManageShare: false,
      askLinkShareState: false,
      changeToLinkPanel: _.noop,
      close: _.noop,
      loadFinished: _.noop,
      changeFileInfor: _.noop,
      data: {
        anonymous: BabelStr.str(722),
        // 匿名用户
        registered: BabelStr.str(723),
        // 注册用户
        goBack: BabelStr.str(74) // 返回
      }
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.bindSelf(this._removeInvUser, this._closeInvShare, this._closeLinkShare);
    if (this.fileInfor.get("ownerId") == app.currentUser.get("id")) {
      this.$(".header").html(BabelStr.str(90)); // ("管理参与者");
    } else if (this.fileInfor.belongsToTeam()) {
      this.$(".header").html(BabelStr.str(90)); // ("管理参与者");
    } else {
      this.$(".header").html(BabelStr.str(400)); // ("查看参与者");

      var ownerInfo = this.fileInfor.get("ownerName");
      var fileEntId = this.fileInfor.getEnterpriseId();
      if (fileEntId != 0) {
        if (fileEntId == app.ep.getEpID()) {
          ownerInfo += '(' + BabelStr.str(397) + ')'; // '(本公司)';
        } else {
          ownerInfo += '(' + BabelStr.str(398) + ')'; // '(外部公司)';
        }
      } else {
        ownerInfo += '(' + BabelStr.str(399) + ')'; // '(个人)';
      }
    }
    if (this.fileInfor.canShowLinkShare()) {
      if (this.canManageShare) {
        if (this.fileInfor.get('newShareAll') == 1) {
          this.initLinkManageHd();
        } else {
          this.initNoLinkManageHd();
        }
        this.initInvManageHd();
        var foundInvite = BabelStr.str(98); // 查找受邀用户
        this.$(".invite-manage .bd").prepend('<div class="select flex-align middle br-2"><i class="icon search"></i><input placeholder="' + foundInvite + '"></input></div>');
      } else {
        if (this.fileInfor.get('newShareAll')) {
          this.initLinkNoManageHd();
        } else {
          this.initNoPerLinkManageHd();
        }
        this.initNoInvManageHd();
      }
    } else {
      this.$(".link-manage").hide();
    }
    for (var i = 0; i < this.roles.length; i++) {
      var role = this.roles[i];
      var str = {
        label: role.get("description"),
        canSelected: true,
        linkRoleId: role.getRoleId()
      };
      self.roleArr.push(str);
    }
    this.$invitedList = this.$('#invitedList');
    this.shareUserInvCollection = new _MDMolaUserCollection["default"]();
    this.listenTo(this.shareUserInvCollection, 'remove', this._removeInvCollectionItemHandler);
    this.$invList = this.$('.share-ulist');
    this._requestInvUser();
    this.shareUserLinkCollection = new _MDMolaUserCollection["default"]();
    this.listenTo(this.shareUserLinkCollection, 'remove', this._removeLinkCollectionItemHandler);
    this.$linkList = this.$('.share-link-ulist');
    if (this.fileInfor.canShowLinkShare()) {
      this._requestLinkUser();
    }
  },
  className: function className() {
    var superCls = _MMViewBase["default"].prototype.className.call(this);
    return superCls + " share-manage";
  },
  _removeInvCollectionItemHandler: function _removeInvCollectionItemHandler(model, collection, options) {
    var index = -1;
    for (var i = 0; i < this.subViews.length; i++) {
      if (this.subViews[i].user.getId() == model.getId()) {
        index = i;
        break;
      }
    }
    if (this.shareUserInvCollection.length == 1 && this.shareUserInvCollection.models[0].getUserId() == this.fileInfor.getOwnerId() || this.shareUserInvCollection.length == 0) {
      self.$("#closeInvShare").hide();
      if (this.fileInfor.get("newShareAll") != 1) {
        this.fileInfor.changeShareState(false);
        Dispatcher.trigger(MDEvents.ShareStatusChanged, this.fileInfor, true);
        Dispatcher.trigger(MDEvents.ShareChanged);
      }
    }
    this.removeSubViewAt(index);
    this.$("#invUserNumber").text(this.shareUserInvCollection.length);
  },
  _toggleManagePanelItem: function _toggleManagePanelItem() {
    if (this.$(".link-manage .bd").hasClass("f-hide")) {
      this.linkPanelItemShow();
    } else {
      this.linkPanelItemHide();
    }
  },
  linkPanelItemShow: function linkPanelItemShow() {
    this.$(".link-manage .bd").removeClass("f-hide").hide().slideDown();
  },
  linkPanelItemHide: function linkPanelItemHide() {
    var self = this;
    this.$(".link-manage .bd").slideUp(function () {
      self.$(".link-manage .bd").addClass("f-hide");
    });
  },
  _toggleInvManagePanelItem: function _toggleInvManagePanelItem() {
    if (this.$(".invite-manage .bd").hasClass("f-hide")) {
      this.invPanelItemShow();
    } else {
      this.invPanelItemHide();
    }
  },
  invPanelItemShow: function invPanelItemShow() {
    this.$(".invite-manage .bd").removeClass("f-hide").hide().slideDown();
  },
  invPanelItemHide: function invPanelItemHide() {
    var self = this;
    this.$(".invite-manage .bd").slideUp(function () {
      self.$(".invite-manage .bd").addClass("f-hide");
    });
  },
  _changeToLinkPanel: function _changeToLinkPanel() {
    this.changeToLinkPanel(false);
  },
  _changeToLinkPanelWithState: function _changeToLinkPanelWithState() {
    this.changeToLinkPanel(true);
  },
  _closeInvShareClick: function _closeInvShareClick(e) {
    e.stopPropagation();
    var self = this;
    var alert = new _MDAlertView["default"]({
      // className: 'm-close-share-win'
    });
    var fileName = this.fileInfor.getFileName();
    // alert.show({
    //   title: '关闭“' + fileName + '的邀请分享”',
    //   message: '<div class="content">关闭邀请分享后，受邀用户将全部移除。<br>文件本身及其子目录内容也将从受邀用户账号移除</div>',
    //   className: 'm-delAlertWin',
    //   buttons: [{
    //     label: '关闭邀请分享',
    //     type: 'done',
    //     onClick: self._closeInvShare
    //   }, {
    //     label: '取消'
    //   }]
    // });

    var opt = {
      title: BabelStr.str(715, {
        'file': fileName
      }),
      // 关闭"{-file-}的邀请分享
      message: '<div class="content">' + BabelStr.str(718) + '</div>',
      okFun: function okFun() {
        self._closeInvShare();
      }
    };
    _MDAlertView["default"].showStandardSelection(opt);
  },
  _closeLinkShareClick: function _closeLinkShareClick(e) {
    e.stopPropagation();
    var self = this;
    var alert = new _MDAlertView["default"]({
      // className: 'm-close-share-win'
    });
    var fileName = this.fileInfor.getFileName();
    var opt = {
      title: BabelStr.str(713, {
        'file': fileName
      }),
      // 关闭"{-file-}的链接分享
      message: '<div class="content">' + BabelStr.str(714) + '</div>',
      okFun: function okFun() {
        self._closeLinkShare();
      }
    };
    _MDAlertView["default"].showStandardSelection(opt);
  },
  _closeLinkShare: function _closeLinkShare() {
    var self = this;
    _MMNetDiskDataController["default"].closeLinkShare(self.fileInfor.getFileId(), function () {
      self.fileInfor.set("newShareAll", 0);
      self.fileInfor.changeShareState(false);
      self.fileInfor.set('shareAll', false);
      Dispatcher.trigger(MDEvents.ShareStatusChanged, self.fileInfor, false);
      Dispatcher.trigger(MDEvents.ShareChanged);
      self.changeFileInfor(self.fileInfor);
      self.initNoLinkManageHd();
      self.linkPanelItemHide();
    }, function () {
      _MDSnackbarView["default"].show(BabelStr.str(309)); //('关闭分享失败，请稍后重试');
      self.openShareView.on(true);
    });
  },
  _closeInvShare: function _closeInvShare() {
    var self = this;
    _MMNetDiskDataController["default"].closeInvShare(this.fileInfor.getFileId(), function () {
      _MDSnackbarView["default"].show(BabelStr.str(308)); //('关闭邀请分享成功');
      self.$("#closeInvShare").hide();
      var curEmail = app.currentUser.get("email");
      for (var i = 0; i < self.shareUserInvCollection.length; i++) {
        var user = self.shareUserInvCollection.models[i];
        if (user.get("email") != curEmail) {
          self.shareUserInvCollection.remove(user);
          i--;
        }
      }
      if (self.shareUserInvCollection.length == 1 && self.fileInfor.belongsToTeam()) {
        var manager = self.shareUserInvCollection.models[0];
        self.shareUserInvCollection.remove(manager);
      }
    }, function () {
      _MDSnackbarView["default"].show(BabelStr.str(309)); //('关闭邀请分享失败，请重试');
    });
  },
  initNoLinkManageHd: function initNoLinkManageHd() {
    var notOpened = BabelStr.str(716); // 链接分享未开启
    var toOpen = BabelStr.str(717); // 前往开启
    this.$el.find('.link-manage .hd').html("");
    this.$div = $('<div class="hd-0">' + '<div class="left f-fl">' + notOpened + '</div>' + '<div class="right f-fr"><button class="mark">' + toOpen + '</button></div>' + '</div>'), this.$el.find('.link-manage .hd').append(this.$div);
  },
  initLinkManageHd: function initLinkManageHd() {
    var byLink = BabelStr.str(95); // 通过链接访问
    var closeLink = BabelStr.str(96); // 关闭链接分享
    this.$div = $('<div class="hd-1 f-clb">' + '<div class="left f-fl totalUser text-button done">' + byLink + '(<span id="linkUserNumber"></span>)</div>' + '<div class="right f-fr">' + '<button id="closeShareLink" class="mark text-button done">' + closeLink + '</button>' + '</div>' + '</div>'), this.$el.find('.link-manage .hd').append(this.$div);
  },
  initLinkNoManageHd: function initLinkNoManageHd() {
    var byLink = BabelStr.str(95); // 通过链接访问
    this.$div = $('<div class="hd-1 f-clb">' + '<div class="left f-fl totalUser text-button done">' + byLink + '(<span id="linkUserNumber"></span>)</div>' + '</div>'), this.$el.find('.link-manage .hd').append(this.$div);
  },
  initNoPerLinkManageHd: function initNoPerLinkManageHd() {
    var notOpened = BabelStr.str(719); // 所有者未开启链接分享
    var apply = BabelStr.str(424); // 请求开启
    this.$div = $('<div class="hd-0 f-clb">' + '<div class="left f-fl">' + notOpened + '</div>' + '<div class="right f-fr"><span class="mark"><button id="askLinkShare">' + apply + '</button></span></div>' + '</div>'), this.$el.find('.link-manage .hd').append(this.$div);
  },
  initNoInvManageHd: function initNoInvManageHd() {
    var invite = BabelStr.str(97); // 邀请共享用户
    var send = BabelStr.str(720); // 请求邀请
    this.$div = $('<div class="hd-0 ">' + '<div class="left f-inline-block f-fl totalUser">' + invite + '(<span id="invUserNumber"></span>)</div>' + '<div class="right f-fr" id="requestInvShare"><button class="mark">' + send + '</button></div>' + '</div>'), this.$el.find('.invite-manage .hd').append(this.$div);
  },
  initInvManageHd: function initInvManageHd() {
    var invite = BabelStr.str(97); // 邀请共享用户
    var close = BabelStr.str(721); // 关闭邀请分享
    this.$div = $('<div class="hd-1">' + '<div class="left f-inline-block f-fl totalUser text-button done" >' + invite + '(<span id="invUserNumber"></span>)</div>' + '<div class="right f-fr" id="closeInvShare"><button class="mark text-button done">' + close + '</button></div>' + '</div>'), this.$el.find('.invite-manage .hd').append(this.$div);
  },
  _requestInvUser: function _requestInvUser() {
    var self = this;
    _MMNetDiskDataController["default"].getInvitationList(this.fileInfor.getFileId(), function (userCollect) {
      var contactArr = [];
      if (self.fileInfor.belongsToTeam()) {
        if (userCollect.length == 1) {
          if (userCollect.models[0].get("roleId") == _FILE_ROLE_ID["default"].ROOT_ROLE) {
            userCollect.shift();
          }
        }
      }
      userCollect.each(function (user) {
        var email = user.getOriginalEmail();
        var contact = {
          'avatarImageURL': app.getAvatarImageURL(user.get("participantId")),
          // "avatartype": user.get("avatarType"),
          "email": email,
          "userId": user.get("participantId"),
          "name": user.get("participantName"),
          "participantType": user.get('participantType'),
          // "sharerId": self.fileInfor.getSharerId(),
          "roleId": user.get("roleId"),
          "roleName": user.get("roleName"),
          "id": user.get("babelshareId"),
          "babelshareId": user.get("babelshareId"),
          "guest": user.get("guest"),
          "registered": user.get('registered'),
          "belongToEnterprise": user.get('belongToEnterprise'),
          "endtime": user.get('endtime')
        };
        if (contact["name"] == '-1') {
          var name = _regexp["default"].isEmail(user.getOriginalEmail()) ? user.getOriginalEmail() : user.getPhone();
          contact["name"] = name;
          contact['avatarImageURL'] = 'img/avatar/anonymous.jpg';
        }
        if (contact.userId == self.fileInfor.getOwnerId() || contact.roleId == _FILE_ROLE_ID["default"].ROOT_ROLE) {
          contactArr.unshift(contact);
        } else {
          contactArr.push(contact);
        }
      });
      if (contactArr.length == 1 && contactArr[0].userId == self.fileInfor.getOwnerId() || contactArr.length == 0) {
        self.$("#closeInvShare").hide();
      }
      self.loadFinished();
      self.shareUserInvCollection.add(contactArr);
      self._renderUserInvListItem();
      self.$("#invUserNumber").text(self.shareUserInvCollection.length);
    }, function (err, msg) {
      var message = msg || BabelStr.str(309);
      _MDSnackbarView["default"].show(message); // ('获取邀请人失败');
    });
  },
  _renderUserLinkListItem: function _renderUserLinkListItem() {
    var self = this;
    this.shareUserLinkCollection.each(function (user, index) {
      var shareUserLinkListItemView = new _MDShareByLinkUserListItemView["default"]({
        canManageShare: self.canManageShare,
        showFileLog: self.showFileLog,
        fileInfor: self.fileInfor,
        user: user,
        roleArr: self.roleArr,
        removeInvuser: self._removeInvUser
      });
      self.addSubView(shareUserLinkListItemView, self.$linkList[0]);
    });
  },
  _requestLinkUser: function _requestLinkUser() {
    var self = this;
    _MMNetDiskDataController["default"].getLinkShareParticipant(this.fileInfor.getFileId(), function (participantInfo) {
      var contactArr = [];
      var userCollect = participantInfo.collection;
      var anonymouseCount = participantInfo.anonymouseCount;
      if (anonymouseCount == undefined) {
        anonymouseCount = 0;
      }
      ;
      userCollect.each(function (user) {
        var contact = {
          'avatarImageURL': app.getAvatarImageURL(user.get("id")),
          "avatartype": user.get("avatarType"),
          "email": user.get("email"),
          "userId": user.get("id"),
          "name": user.get("name"),
          "registerTime": user.get("registerTime"),
          "registered": user.get('registered')
        };
        contactArr.push(contact);
      });
      self.shareUserLinkCollection.add(contactArr);
      if (self.shareUserLinkCollection.length > 0) {
        self._renderUserLinkListItem();
      }
      var registerUserCount = self.shareUserLinkCollection.length;
      self.$("#linkUserNumber").text(anonymouseCount + registerUserCount);
      self.$("#anonymousUsers span").text(anonymouseCount);
      self.$("#registerUsers span").text(registerUserCount);
    }, function () {
      _MDSnackbarView["default"].show(BabelStr.str(309)); // ('获取邀请人失败');
    });
  },
  _renderUserInvListItem: function _renderUserInvListItem() {
    var self = this;
    if (!this.canManageShare) {
      this.$invList.addClass("flex-align with-wrap");
    }
    this.shareUserInvCollection.each(function (user, index) {
      var shareUserInvListItemView = new _MDShareByInvUserListItemView["default"]({
        showFileLog: self.showFileLog,
        fileInfor: self.fileInfor,
        user: user,
        roleArr: self.roleArr,
        roles: self.roles,
        removeInvuser: self._removeInvUser,
        canManageShare: self.canManageShare
      });
      self.addSubView(shareUserInvListItemView, self.$invList[0]);
    });
  },
  showFileLog: function showFileLog(user) {
    this.showFileLog(user);
  },
  _removeInvUser: function _removeInvUser(babelshareId) {
    var self = this;
    _MMNetDiskDataController["default"].removeInvitations(this.fileInfor.getFileId(), babelshareId, function () {
      var user = self.shareUserInvCollection.findWhere({
        "babelshareId": babelshareId[0]
      });
      self.shareUserInvCollection.remove(user);
      if (self.shareUserInvCollection.length == 1 && self.fileInfor.belongsToTeam()) {
        var manager = self.shareUserInvCollection.models[0];
        self.shareUserInvCollection.remove(manager);
      }
      _MDSnackbarView["default"].show(BabelStr.str(308)); //('删除成功');
    }, function () {
      _MDSnackbarView["default"].show(BabelStr.str(309)); //('删除失败');
    });
  },
  _renderInvUser: function _renderInvUser() {
    var userList = this.$(".inv-userLIst-item");
    var content = this.$(".select input").val().toString();
    for (var i = 0; i < userList.length; i++) {
      var name = userList.eq(i).find(".name").html();
      var email = userList.eq(i).find(".mail").html();
      if (name.indexOf(content) == -1 && email.indexOf(content) == -1) {
        userList.eq(i).addClass("f-hide");
      } else {
        userList.eq(i).removeClass("f-hide");
      }
    }
  }
});
var _default = exports["default"] = MDShareFileWindowInvPanelView;

},{"106":106,"1104":1104,"1184":1184,"1417":1417,"1421":1421,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1478":1478,"22":22,"236":236,"273":273,"32":32,"686":686,"687":687,"72":72}],691:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1437);
require(1478);
var _FILE_ROLE_ID = _interopRequireDefault(require(236));
var _MMViewBase = _interopRequireDefault(require(22));
var _MDShareFileOperateManageOwnerView = _interopRequireDefault(require(689));
var _MDShareFileOperateManageUserView = _interopRequireDefault(require(690));
var _MDShareFileInvMaileInfoView = _interopRequireDefault(require(688));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _regexp = _interopRequireDefault(require(106));
/**
 *  Window for share file
 *  Created by jichao
 *  2016.9.26
 */

var MDShareFileOperateManageView = _MMViewBase["default"].extend({
  tmpl: '<div class="caption"><%=owner%></div>\
      <div>\
          <section class="block share-setting">\
          </section>\
          <div id="funTab">\
              <div>\
                  <div>\
                      <header class="block-hd f-clb"><span class="f-emph"><%=inviteTarget%></span>\
                      <div class="help-block flex-align file-address">\
                        <span class="form-line"><%=BabelStr.str(7291)%></span>\
                        <span class="col-auto flex-align"><input class="form-control file-link" readonly /></span>\
                      </div>\
                      <div id="inv-per-user" class="help-block"></div>\
                      <div id="no-inv-per-help"></div>\
                      </header>\
                      <div class="block-bd">\
                      </div>\
                      <footer class="foot">\
                          <div class="right">\
                              <a class="f-fr manage-a">\
                                  <span id="manage-user"><%=mgrParticipant%></span>\
                                  <div class="point-po ">\
                                      <div class="intro"><%=tip%></div>\
                                 </div>\
                              </a>\
                          </div>\
                      </footer>\
                  </div>\
              </div>\
          </div>\
      </div>',
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      askLinkShareState: false,
      hasInvPermission: true,
      hasLinkPermission: true,
      canManageShare: false,
      roles: [],
      changeFileInfor: _.noop,
      changeToInvPanel: _.noop,
      close: _.noop,
      loadFinished: _.noop
    });
  },
  events: function events() {
    return {
      'mouseenter .manage-a': this._showManagePoint,
      'mouseleave .manage-a': this._hideManagePoint,
      'click #manage-user': this._changePanel,
      'click #sendInvBtn': this._sendInvitation
    };
  },
  initialize: function initialize(opt) {
    var self = this;
    opt = _.extend({}, opt);
    opt.data = _.extend({
      'owner': BabelStr.str(396),
      // 所有者
      'inviteTarget': BabelStr.str(83),
      // 邀请共享人
      'mgrParticipant': BabelStr.str(90),
      // 管理参与者
      'tip': BabelStr.str(92) // 打开分享链接和邀请分享后，可以分别控制和管理每个受邀共享者的访问权限
    }, opt.data);
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.bindSelf(this.renderUserInfo, this.ownerInit);
    this.$funTab = this.$('#funTab');
    if (this.canManageShare) {
      this.ownerInit();
    } else {
      this.IsJoinedByLink();
    }
    if (this.fileInfor.get("ownerId") == app.currentUser.get("id") || this.fileInfor.belongsToTeam()) {
      this.$(".caption").hide();
    } else {
      var ownerInfo = this.fileInfor.get("ownerName");
      var fileEntId = this.fileInfor.getEnterpriseId();
      if (fileEntId != 0) {
        if (fileEntId == app.ep.getEpID()) {
          ownerInfo += "(".concat(BabelStr.str(397), ")"); //'(本公司)';
        } else {
          ownerInfo += '(' + BabelStr.str(398) + ')'; //'(外部公司)';
        }
      } else {
        ownerInfo += "(".concat(BabelStr.str(399), ")"); //'(个人)';
      }
      this.$(".caption").html(BabelStr.str(396) + "：  " + ownerInfo); // 所有者: xxx
    }
    if (this.canManageShare) {
      this.$("#manage-user").html(BabelStr.str(90)); // ("管理参与者");
    } else {
      this.$("#manage-user").html(BabelStr.str(400)); // ("查看参与者");
    }
    self.$(".file-address").hide();
  },
  IsJoinedByLink: function IsJoinedByLink() {
    var self = this;
    _MMNetDiskDataController["default"].isLinkParticipant(this.fileInfor.getFileId(), function (flag) {
      if (flag) {
        console.log("该用户是通过链接分享加入的");
        self.$("#funTab").remove("#funTab");
        self.linkShareForOwner = new _MDShareFileOperateManageOwnerView["default"]({
          canManageShare: self.canManageShare,
          roles: self.roles,
          fileInfor: self.fileInfor,
          changeFileInfor: self.changeFileInfor,
          isJoinedByLink: true,
          loadFinished: self.loadFinished,
          showRolesInfo: self.showRolesInfo,
          linkRoleId: self.defaultRole,
          close: self.close
        });
        self.addSubView(self.linkShareForOwner, self.$(".share-setting")[0]);
      } else {
        console.log("该用户是通过邀请分享加入的");
        if (!self.canManageShare) {
          var tip = BabelStr.str(401); // 你没有邀请用户加入分享的权限，但你可以发送一个请求给内容所有者，请求他邀请
          self.$("#no-inv-per-help").html('<div class="help-inline red">' + tip + '</div>');
        } else {
          self._requestInvUser();
        }
        // if (self.fileInfor.get('newShareAll')==1 || self.fileInfor.get('inOtherPersonSharingFolder')){
        self.shareInvMailInfo = new _MDShareFileInvMaileInfoView["default"]({
          roles: self.roles,
          fileInfor: self.fileInfor,
          canManageShare: self.canManageShare,
          close: self.close,
          showRolesInfo: self.showRolesInfo,
          renderUserInfo: self.renderUserInfo,
          defaultRole: self.defaultRole
        });
        self.addSubView(self.shareInvMailInfo, self.$("#funTab .block-bd")[0]);
        if (self.fileInfor.canShowLinkShare()) {
          //拥有看到链接分享的权限
          if (self.fileInfor.get('newShareAll') == 1) {
            self.linkShareForOwner = new _MDShareFileOperateManageOwnerView["default"]({
              canManageShare: self.canManageShare,
              roles: self.roles,
              fileInfor: self.fileInfor,
              changeFileInfor: self.changeFileInfor,
              loadFinished: self.loadFinished,
              showRolesInfo: self.showRolesInfo,
              linkRoleId: self.defaultRole,
              close: self.close
            });
            self.addSubView(self.linkShareForOwner, self.$(".share-setting")[0]);
          } else {
            self.loadFinished();
            self.$el.find('.share-setting').remove();
            if (!self.canManageShare) {
              self.loadFinished();
              self.linkShareForUser = new _MDShareFileOperateManageUserView["default"]({
                askLinkShareState: self.askLinkShareState,
                canManageShare: self.canManageShare,
                fileInfor: self.fileInfor,
                close: self.close,
                _setOpenShare: self._setOpenShare
              });
              self.addSubView(self.linkShareForUser, self.$(".share-setting")[0]);
            } else {
              self.linkShareForOwner = new _MDShareFileOperateManageOwnerView["default"]({
                canManageShare: self.canManageShare,
                roles: self.roles,
                fileInfor: self.fileInfor,
                changeFileInfor: self.changeFileInfor,
                loadFinished: self.loadFinished,
                showRolesInfo: self.showRolesInfo,
                linkRoleId: self.defaultRole,
                close: self.close
              });
              self.addSubView(self.linkShareForOwner, self.$(".share-setting")[0]);
            }
          }
        } else {
          self.$(".share-setting").remove();
          self.loadFinished();
        }
      }
    }, function () {});
  },
  ownerInit: function ownerInit() {
    this._requestInvUser();
    if (this.fileInfor.canShowLinkShare()) {
      this.linkShareForOwner = new _MDShareFileOperateManageOwnerView["default"]({
        canManageShare: this.canManageShare,
        roles: this.roles,
        fileInfor: this.fileInfor,
        changeFileInfor: this.changeFileInfor,
        loadFinished: this.loadFinished,
        showRolesInfo: this.showRolesInfo,
        linkRoleId: this.defaultRole,
        close: this.close
      });
      this.addSubView(this.linkShareForOwner, this.$(".share-setting")[0]);
      this._initLink();
    } else {
      this.$('.share-setting').remove();
      this.loadFinished();
    }
    this.shareInvMailInfo = new _MDShareFileInvMaileInfoView["default"]({
      roles: this.roles,
      fileInfor: this.fileInfor,
      canManageShare: this.canManageShare,
      close: this.close,
      showRolesInfo: this.showRolesInfo,
      renderUserInfo: this.renderUserInfo,
      defaultRole: this.defaultRole
    });
    this.addSubView(this.shareInvMailInfo, this.$("#funTab .block-bd")[0]);
  },
  _initLink: function _initLink() {
    var self = this;
    var fid = self.fileInfor.getFileId();
    var isHttps;
    if (location.protocol == "https:") {
      isHttps = true;
    } else {
      isHttps = false;
    }
    _MMNetDiskDataController["default"].getShareUrl(fid, isHttps, function (shareURL, linkRoleId, password) {
      self.shareURL = shareURL;
      self.linkRoleId = linkRoleId;
      if (password && password.length > 0) {
        self.linkPwd = password;
      }
      self.$(".file-address .file-link").val(shareURL);
      _.isFunction(self.onRequestSuccess) && self.onRequestSuccess();
    }, function () {
      _.isFunction(self.onRequestFail) && self.onRequestFail();
    });
  },
  _showManagePoint: function _showManagePoint($e) {
    var self = this;
    var $qpopup = this.$(".point-po");
    if ($qpopup.hasClass("opened")) {
      return;
    }
    $qpopup.show();
    $qpopup[0].offsetWidth;
    $qpopup.addClass("opened");
    return false;
  },
  renderUserInfo: function renderUserInfo() {
    this._requestInvUser();
  },
  _requestInvUser: function _requestInvUser() {
    var self = this;
    if (this.fileInfor.isClientShare) {
      return;
    }
    ;
    var fileId = this.fileInfor.getFileId();
    var isEpVersion = app.isEpVersion();
    _MMNetDiskDataController["default"].getInvitationList(fileId, function (userCollect) {
      if (userCollect.length == 1) {
        if (self.fileInfor.getCreatorId() == userCollect.at(0).getUserId()) {
          userCollect.shift();
        }
      }
      var contactArr = [];
      var length = userCollect.length;
      userCollect.each(function (user) {
        if (user.get("participantName") == "-1") {
          var name = _regexp["default"].isEmail(user.getOriginalEmail()) ? user.getOriginalEmail() : user.getPhone();
          user.set("participantName", name);
        }
        if (self.fileInfor.belongsToTeam()) {
          if (user.get("roleId") != _FILE_ROLE_ID["default"].ROOT_ROLE) {
            contactArr.push(user.get("participantName"));
          }
        } else if (user.get("participantId") != self.fileInfor.getOwnerId()) {
          contactArr.push(user.get("participantName"));
        }
      });
      var string = BabelStr.str(402) + " "; // "已邀请 ";
      var len = Math.min(contactArr.length + 1, length);
      if (contactArr.toString().length > 46) {
        var param = {
          'num': "<span class='mark'>" + len + "</span>"
        };
        var str = BabelStr.str(403, param); //"... 等" + "<span class='mark'>" + len + "</span>" + "人。";
        string += contactArr.toString().substring(0, 46) + str;
      } else {
        string += contactArr.toString();
      }
      if (contactArr.length > 0) {
        self.$("#inv-per-user").html(string);
        if (self.fileInfor.canShowLinkShare()) {
          self.$(".file-address").show();
        }
      } else {
        self.$(".file-address").hide();
      }
    }, function (error, msg) {
      var message = msg || BabelStr.str(404);
      _MDSnackbarView["default"].show(message); // ('获取邀请人失败');
    });
  },
  _hideManagePoint: function _hideManagePoint($e) {
    var self = this;
    var $qpopup = self.$('.point-po');
    var $mqpopup = self.$('.manage-a');
    var popDOM = $mqpopup.get(0);
    if ($qpopup.css("display") == "none") {
      return;
    }
    $qpopup.transitionEndOnce(function () {
      !$qpopup.hasClass("opened") && $qpopup.hide();
    });
    $qpopup.removeClass("opened");
  }
});
var _default = exports["default"] = MDShareFileOperateManageView;

},{"106":106,"1104":1104,"1184":1184,"1417":1417,"1437":1437,"1454":1454,"1463":1463,"1478":1478,"22":22,"236":236,"688":688,"689":689,"690":690,"72":72}],681:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDTabPanelView = _interopRequireDefault(require(81));
var _ErrorCode = _interopRequireDefault(require(1087));
var _MDFileActionController = _interopRequireDefault(require(492));
var _MDLinkShareManagePanelView = _interopRequireDefault(require(680));
var _MDParticipantsByLinkListView = _interopRequireDefault(require(683));
var _MDSnapshotLinkFileWindowView = _interopRequireDefault(require(697));
/**
 * 链接分享的 tab 页
 * jiang
 * 2019-3-13
 */

var MDLinkShareTabPanelView = _MDTabPanelView["default"].extend({
  tmpl: "<div class=\"link-share \">\n      <div class=\"help-block promptstr manage-per\">\n      <%=BabelStr.str(7281)%>\n      </div>\n      <div class='f-tr text-button snapshot manage-per'><%=BabelStr.str(6340)%></div>\n      <div class=\"action-zone manage-per\"></div>\n      <div class=\"userlist\"></div>\n    </div>\n    ",
  initialize: function initialize(opt) {
    _MDTabPanelView["default"].prototype.initialize.call(this, opt);
    this.$('.tab-panel-wrapper').addClass('block');
  },
  events: function events() {
    var superE = _MDTabPanelView["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click .snapshot': this._showSnapshot
    });
  },
  onActived: function onActived() {
    var _this = this;
    var self = this;
    var errorFunc = function errorFunc(error) {
      self.requestFailed(error);
    };
    if (!this.userListPanel && this.fileInfor.get('newShareAll') == "1") {
      this.userListPanel = new _MDParticipantsByLinkListView["default"]({
        fileInfor: this.fileInfor,
        roles: this.roles,
        showCloseLinkShare: this.showCloseLinkShare,
        canManageShare: this.canManageShare,
        showFileLog: this.showFileLog,
        loadFinished: this.loadFinished,
        onRequestFail: errorFunc,
        changeFileInfor: this.changeFileInfor
      });
      this.addSubView(this.userListPanel, this.$('.userlist'));
    }
    if (!this.linkManagePanel && !this.showCloseLinkShare) {
      this.linkManagePanel = new _MDLinkShareManagePanelView["default"]({
        fileInfor: this.fileInfor,
        roles: this.roles,
        canManageShare: this.canManageShare,
        defaultRole: this.defaultRole,
        changeFileInfor: this.changeFileInfor,
        changeToInvPanel: this.changeToInvPanel,
        close: this.close,
        loadFinished: this.loadFinished,
        showRolesInfo: this.showRolesInfo,
        onRequestFail: errorFunc,
        onShareClosed: function onShareClosed() {
          _this.userListPanel && _this.userListPanel.hide();
        }
      });
      this.addSubView(this.linkManagePanel, this.$('.action-zone'));
    }
    if (this.showCloseLinkShare) {
      this.$('.manage-per').addClass('f-hide');
    }
    if (!this.canManageShare) {
      this.$(".promptstr").empty();
      if (this.fileInfor.get("newShareAll") == 2) {
        this.$(".promptstr").text(BabelStr.str(20002));
      }
      this.$(".snapshot").addClass('f-hide');
    }
    if (this.$('.manage-per').hasClass('f-hide') && !this.userListPanel && !this.linkManagePanel) {
      this.loadFinished();
      if (this.$(".no-link-msg")) {
        this.$(".no-link-msg").remove();
      }
      this.$el.append("<div class=\"f-tc mgtb-20 no-link-msg\">".concat(BabelStr.str(12121), "</div>"));
    }
  },
  _showSnapshot: function _showSnapshot() {
    var _this2 = this;
    var ctl = new _MDFileActionController["default"]({});
    ctl.setFileInfors([this.fileInfor]);
    ctl.snapshotLinkShareFile(function (success) {
      success && _this2.close();
    });
  },
  requestFailed: function requestFailed(errorcode) {
    if (this.userListPanel) {
      this.userListPanel.remove();
    }
    if (errorcode == _ErrorCode["default"].ACCESS_DENIED && !this.fileInfor.canManageSharePermission()) {
      this.$(".promptstr").text(BabelStr.str(20002));
      if (this.linkManagePanel) {
        this.linkManagePanel.remove();
      }
    }
  }
});
var _default = exports["default"] = MDLinkShareTabPanelView;

},{"1087":1087,"1184":1184,"1454":1454,"492":492,"680":680,"683":683,"697":697,"81":81}],683:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1437);
require(1478);
require(1421);
var _FILE_ROLE_ID = _interopRequireDefault(require(236));
var _MMViewBase = _interopRequireDefault(require(22));
var _MDShareByLinkUserListItemView = _interopRequireDefault(require(687));
var _MDShareByInvUserListItemView = _interopRequireDefault(require(686));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _regexp = _interopRequireDefault(require(106));
/**
 *  Window for share file
 *  Created by jichao
 *  2016.9.28
 */

/**
 * 管理参与者Panel
 */
var MDShareFileWindowInvPanelView = _MMViewBase["default"].extend({
  tmpl: '<div id="m-manage-panel"> \
      <div class="link-manage br-2"> \
        <div class="hd"> \
        </div> \
        <div class="bd f-hide"> \
          <div id="anonymousUsers"><%=anonymous%>(<span>0</span>)</div>\
          <div id="registerUsers"><%=registered%>(<span>0</span>)</div>\
          <div id="u-link-list"> \
            <div class="m-share-link-userlist"> \
                  <ul class="share-link-ulist flex-align with-wrap start"></ul> \
            </div> \
          </div> \
        </div> \
      </div> \
    </div>',
  events: function events() {
    return {
      'click .link-manage .hd-1': this._toggleManagePanelItem,
      'click .link-manage .hd-0 .right': this._changeToLinkPanelWithState,
      'click #returnLinkPanel': this._changeToLinkPanel,
      'click #closeInvShare': this._closeInvShareClick,
      'click #closeShareLink': this._closeLinkShareClick,
      'click #requestInvShare': this._changeToLinkPanel,
      'keyup .select': this._renderInvUser
    };
  },
  initProps: function initProps() {
    var opt = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(opt, {
      roleArr: [],
      canManageShare: false,
      askLinkShareState: false,
      changeToLinkPanel: _.noop,
      close: _.noop,
      loadFinished: _.noop,
      changeFileInfor: _.noop,
      data: {
        anonymous: BabelStr.str(722),
        // 匿名用户
        registered: BabelStr.str(723),
        // 注册用户
        goBack: BabelStr.str(74) // 返回
      }
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.bindSelf(this._removeInvUser, this._closeInvShare, this._closeLinkShare);
    if (this.fileInfor.get("ownerId") == app.currentUser.get("id")) {
      this.$(".header").html(BabelStr.str(90)); // ("管理参与者");
    } else if (this.fileInfor.belongsToTeam()) {
      this.$(".header").html(BabelStr.str(90)); // ("管理参与者");
    } else {
      this.$(".header").html(BabelStr.str(400)); // ("查看参与者");

      var ownerInfo = this.fileInfor.get("ownerName");
      var fileEntId = this.fileInfor.getEnterpriseId();
      if (fileEntId != 0) {
        if (fileEntId == app.ep.getEpID()) {
          ownerInfo += '(' + BabelStr.str(397) + ')'; // '(本公司)';
        } else {
          ownerInfo += '(' + BabelStr.str(398) + ')'; // '(外部公司)';
        }
      } else {
        ownerInfo += '(' + BabelStr.str(399) + ')'; // '(个人)';
      }
    }
    if (this.fileInfor.canShowLinkShare()) {
      if (this.canManageShare) {
        if (this.fileInfor.get('newShareAll') == 1) {
          this.initLinkManageHd();
        } else {
          this.initNoLinkManageHd();
        }
      } else {
        if (this.fileInfor.get('newShareAll')) {
          this.initLinkNoManageHd();
        } else {
          this.initNoPerLinkManageHd();
        }
      }
    } else {
      this.$(".link-manage").hide();
    }
    for (var i = 0; i < this.roles.length; i++) {
      var role = this.roles[i];
      var str = {
        label: role.get("description"),
        canSelected: true,
        linkRoleId: role.getRoleId()
      };
      self.roleArr.push(str);
    }
    this.$invList = this.$('.share-ulist');
    this.shareUserLinkCollection = new _MDMolaUserCollection["default"]();
    this.listenTo(this.shareUserLinkCollection, 'remove', this._removeLinkCollectionItemHandler);
    this.$linkList = this.$('.share-link-ulist');
    if (this.fileInfor.canShowLinkShare()) {
      this._requestLinkUser();
    }
    if (this.showCloseLinkShare) {
      this.loadFinished();
    }
  },
  className: function className() {
    var superCls = _MMViewBase["default"].prototype.className.call(this);
    return superCls + " share-manage";
  },
  _removeInvCollectionItemHandler: function _removeInvCollectionItemHandler(model, collection, options) {
    var index = -1;
    for (var i = 0; i < this.subViews.length; i++) {
      if (this.subViews[i].user.getId() == model.getId()) {
        index = i;
        break;
      }
    }
    if (this.shareUserInvCollection.length == 1 && this.shareUserInvCollection.models[0].getUserId() == this.fileInfor.getOwnerId() || this.shareUserInvCollection.length == 0) {
      self.$("#closeInvShare").hide();
      if (this.fileInfor.get("newShareAll") != 1) {
        this.fileInfor.changeShareState(false);
        Dispatcher.trigger(MDEvents.ShareStatusChanged, this.fileInfor, true);
        Dispatcher.trigger(MDEvents.ShareChanged);
      }
    }
    this.removeSubViewAt(index);
    this.$("#invUserNumber").text(this.shareUserInvCollection.length);
  },
  _toggleManagePanelItem: function _toggleManagePanelItem() {
    if (this.$(".link-manage .bd").hasClass("f-hide")) {
      this.linkPanelItemShow();
    } else {
      this.linkPanelItemHide();
    }
  },
  linkPanelItemShow: function linkPanelItemShow() {
    this.$(".link-manage .bd").removeClass("f-hide").hide().slideDown();
  },
  linkPanelItemHide: function linkPanelItemHide() {
    var self = this;
    this.$(".link-manage .bd").slideUp(function () {
      self.$(".link-manage .bd").addClass("f-hide");
    });
  },
  _toggleInvManagePanelItem: function _toggleInvManagePanelItem() {
    if (this.$(".invite-manage .bd").hasClass("f-hide")) {
      this.invPanelItemShow();
    } else {
      this.invPanelItemHide();
    }
  },
  invPanelItemShow: function invPanelItemShow() {
    this.$(".invite-manage .bd").removeClass("f-hide").hide().slideDown();
  },
  invPanelItemHide: function invPanelItemHide() {
    var self = this;
    this.$(".invite-manage .bd").slideUp(function () {
      self.$(".invite-manage .bd").addClass("f-hide");
    });
  },
  _changeToLinkPanel: function _changeToLinkPanel() {
    this.changeToLinkPanel(false);
  },
  _changeToLinkPanelWithState: function _changeToLinkPanelWithState() {
    this.changeToLinkPanel(true);
  },
  _closeInvShareClick: function _closeInvShareClick(e) {
    e.stopPropagation();
    var self = this;
    var alert = new _MDAlertView["default"]({
      // className: 'm-close-share-win'
    });
    var fileName = this.fileInfor.getFileName();
    // alert.show({
    //   title: '关闭“' + fileName + '的邀请分享”',
    //   message: '<div class="content">关闭邀请分享后，受邀用户将全部移除。<br>文件本身及其子目录内容也将从受邀用户账号移除</div>',
    //   className: 'm-delAlertWin',
    //   buttons: [{
    //     label: '关闭邀请分享',
    //     type: 'done',
    //     onClick: self._closeInvShare
    //   }, {
    //     label: '取消'
    //   }]
    // });

    var opt = {
      title: BabelStr.str(715, {
        'file': fileName
      }),
      // 关闭"{-file-}的邀请分享
      message: '<div class="content">' + BabelStr.str(718) + '</div>',
      okFun: function okFun() {
        self._closeInvShare();
      }
    };
    _MDAlertView["default"].showStandardSelection(opt);
  },
  _closeLinkShareClick: function _closeLinkShareClick(e) {
    e.stopPropagation();
    var self = this;
    var alert = new _MDAlertView["default"]({
      // className: 'm-close-share-win'
    });
    var fileName = this.fileInfor.getFileName();
    var opt = {
      title: BabelStr.str(713, {
        'file': fileName
      }),
      // 关闭"{-file-}的链接分享
      message: '<div class="content">' + BabelStr.str(714) + '</div>',
      okFun: function okFun() {
        self._closeLinkShare();
      }
    };
    _MDAlertView["default"].showStandardSelection(opt);
  },
  _closeLinkShare: function _closeLinkShare() {
    var self = this;
    _MMNetDiskDataController["default"].closeLinkShare(self.fileInfor.getFileId(), function () {
      self.fileInfor.set("newShareAll", 0);
      self.fileInfor.changeShareState(false);
      self.fileInfor.set('shareAll', false);
      Dispatcher.trigger(MDEvents.ShareStatusChanged, self.fileInfor, false);
      Dispatcher.trigger(MDEvents.ShareChanged);
      self.changeFileInfor(self.fileInfor);
      self.initNoLinkManageHd();
      self.linkPanelItemHide();
    }, function () {
      _MDSnackbarView["default"].show(BabelStr.str(309)); //('关闭分享失败，请稍后重试');
      self.openShareView.on(true);
    });
  },
  _closeInvShare: function _closeInvShare() {
    var self = this;
    _MMNetDiskDataController["default"].closeInvShare(this.fileInfor.getFileId(), function () {
      _MDSnackbarView["default"].show(BabelStr.str(308)); //('关闭邀请分享成功');
      self.$("#closeInvShare").hide();
      var curEmail = app.currentUser.get("email");
      for (var i = 0; i < self.shareUserInvCollection.length; i++) {
        var user = self.shareUserInvCollection.models[i];
        if (user.get("email") != curEmail) {
          self.shareUserInvCollection.remove(user);
          i--;
        }
      }
      if (self.shareUserInvCollection.length == 1 && self.fileInfor.belongsToTeam()) {
        var manager = self.shareUserInvCollection.models[0];
        self.shareUserInvCollection.remove(manager);
      }
    }, function () {
      _MDSnackbarView["default"].show(BabelStr.str(309)); //('关闭邀请分享失败，请重试');
    });
  },
  initNoLinkManageHd: function initNoLinkManageHd() {
    var notOpened = BabelStr.str(716); // 链接分享未开启
    var toOpen = BabelStr.str(717); // 前往开启
    var openBtn = '';
    if (!this.showCloseLinkShare) {
      openBtn = '<div class="right f-fr"><button class="mark">' + toOpen + '</button></div>';
    }
    this.$el.find('.link-manage .hd').html("");
    this.$div = $('<div class="hd-0">' + '<div class="left f-fl">' + notOpened + '</div>' + openBtn + '</div>'), this.$el.find('.link-manage .hd').append(this.$div);
  },
  initLinkManageHd: function initLinkManageHd() {
    var byLink = BabelStr.str(95); // 通过链接访问
    var closeLink = BabelStr.str(96); // 关闭链接分享
    var closeBtn = '';
    if (this.showCloseLinkShare) {
      closeBtn = '<button id="closeShareLink" class="mark text-button done">' + closeLink + '</button>';
    }
    this.$div = $('<div class="hd-1 f-clb">' + '<div class="left f-fl totalUser text-button done">' + byLink + '(<span id="linkUserNumber"></span>)</div>' + '<div class="right f-fr">' + closeBtn + '</div>' + '</div>'), this.$el.find('.link-manage .hd').append(this.$div);
  },
  initLinkNoManageHd: function initLinkNoManageHd() {
    var byLink = BabelStr.str(95); // 通过链接访问
    this.$div = $('<div class="hd-1 f-clb">' + '<div class="left f-fl totalUser text-button done">' + byLink + '(<span id="linkUserNumber"></span>)</div>' + '</div>'), this.$el.find('.link-manage .hd').append(this.$div);
  },
  initNoPerLinkManageHd: function initNoPerLinkManageHd() {
    var notOpened = BabelStr.str(719); // 所有者未开启链接分享
    var apply = BabelStr.str(424); // 请求开启
    this.$div = $('<div class="hd-0 f-clb">' + '<div class="left f-fl">' + notOpened + '</div>' + '<div class="right f-fr"><span class="mark"><button id="askLinkShare">' + apply + '</button></span></div>' + '</div>'), this.$el.find('.link-manage .hd').append(this.$div);
  },
  _renderUserLinkListItem: function _renderUserLinkListItem() {
    var self = this;
    this.shareUserLinkCollection.each(function (user, index) {
      var shareUserLinkListItemView = new _MDShareByLinkUserListItemView["default"]({
        canManageShare: self.canManageShare,
        showFileLog: self.showFileLog,
        fileInfor: self.fileInfor,
        user: user,
        roleArr: self.roleArr,
        removeInvuser: self._removeInvUser
      });
      self.addSubView(shareUserLinkListItemView, self.$linkList[0]);
    });
  },
  _requestLinkUser: function _requestLinkUser() {
    var self = this;
    _MMNetDiskDataController["default"].getLinkShareParticipant(this.fileInfor.getFileId(), function (participantInfo) {
      var contactArr = [];
      var userCollect = participantInfo.collection;
      var anonymouseCount = participantInfo.anonymouseCount;
      if (anonymouseCount == undefined) {
        anonymouseCount = 0;
      }
      ;
      userCollect.each(function (user) {
        var contact = {
          'avatarImageURL': app.getAvatarImageURL(user.get("id")),
          "avatartype": user.get("avatarType"),
          "email": user.get("email"),
          "userId": user.get("id"),
          "name": user.get("name"),
          "registerTime": user.get("registerTime"),
          "registered": user.get('registered')
        };
        contactArr.push(contact);
      });
      self.shareUserLinkCollection.add(contactArr);
      if (self.shareUserLinkCollection.length > 0) {
        self._renderUserLinkListItem();
      }
      var registerUserCount = self.shareUserLinkCollection.length;
      self.$("#linkUserNumber").text(anonymouseCount + registerUserCount);
      self.$("#anonymousUsers span").text(anonymouseCount);
      self.$("#registerUsers span").text(registerUserCount);
    }, function () {
      _MDSnackbarView["default"].show(BabelStr.str(309)); // ('获取邀请人失败');
    });
  },
  _renderUserInvListItem: function _renderUserInvListItem() {
    var self = this;
    if (!this.canManageShare) {
      this.$invList.addClass("flex-align with-wrap");
    }
    this.shareUserInvCollection.each(function (user, index) {
      var shareUserInvListItemView = new _MDShareByInvUserListItemView["default"]({
        showFileLog: self.showFileLog,
        fileInfor: self.fileInfor,
        user: user,
        roleArr: self.roleArr,
        roles: self.roles,
        removeInvuser: self._removeInvUser,
        canManageShare: self.canManageShare
      });
      self.addSubView(shareUserInvListItemView, self.$invList[0]);
    });
  },
  showFileLog: function showFileLog(user) {
    this.showFileLog(user);
  },
  _removeInvUser: function _removeInvUser(babelshareId) {
    var self = this;
    _MMNetDiskDataController["default"].removeInvitations(this.fileInfor.getFileId(), babelshareId, function () {
      var user = self.shareUserInvCollection.findWhere({
        "babelshareId": babelshareId[0]
      });
      self.shareUserInvCollection.remove(user);
      if (self.shareUserInvCollection.length == 1 && self.fileInfor.belongsToTeam()) {
        var manager = self.shareUserInvCollection.models[0];
        self.shareUserInvCollection.remove(manager);
      }
      _MDSnackbarView["default"].show(BabelStr.str(308)); //('删除成功');
    }, function () {
      _MDSnackbarView["default"].show(BabelStr.str(309)); //('删除失败');
    });
  },
  _renderInvUser: function _renderInvUser() {
    var userList = this.$(".inv-userLIst-item");
    var content = this.$(".select input").val().toString();
    for (var i = 0; i < userList.length; i++) {
      var name = userList.eq(i).find(".name").html();
      var email = userList.eq(i).find(".mail").html();
      if (name.indexOf(content) == -1 && email.indexOf(content) == -1) {
        userList.eq(i).addClass("f-hide");
      } else {
        userList.eq(i).removeClass("f-hide");
      }
    }
  }
});
var _default = exports["default"] = MDShareFileWindowInvPanelView;

},{"106":106,"1104":1104,"1184":1184,"1417":1417,"1421":1421,"1437":1437,"1454":1454,"1463":1463,"1478":1478,"22":22,"236":236,"273":273,"32":32,"686":686,"687":687,"72":72}],680:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
var _FILE_ROLE_ID = _interopRequireDefault(require(236));
var _MMViewBase = _interopRequireDefault(require(22));
var _MDShareFileOperateManageOwnerView = _interopRequireDefault(require(689));
var _MDShareFileOperateManageUserView = _interopRequireDefault(require(690));
var _MDShareFileInvMaileInfoView = _interopRequireDefault(require(688));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _regexp = _interopRequireDefault(require(106));
/**
 *  Window for share file
 *  Created by jiang
 *
 *  2019.3.13
 */

var MDShareFileOperateManageView = _MMViewBase["default"].extend({
  tmpl: '<div>\
          <section class="block share-setting">\
          </section>\
      </div>',
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      askLinkShareState: false,
      hasInvPermission: true,
      hasLinkPermission: true,
      canManageShare: false,
      roles: [],
      changeFileInfor: _.noop,
      changeToInvPanel: _.noop,
      onRequestFail: _.noop,
      close: _.noop,
      loadFinished: _.noop
    });
  },
  events: function events() {
    return {
      'mouseenter .manage-a': this._showManagePoint,
      'mouseleave .manage-a': this._hideManagePoint
    };
  },
  initialize: function initialize(opt) {
    var self = this;
    opt = _.extend({}, opt);
    opt.data = _.extend({
      'owner': BabelStr.str(396),
      // 所有者
      'inviteTarget': BabelStr.str(83),
      // 邀请共享人
      'mgrParticipant': BabelStr.str(90),
      // 管理参与者
      'tip': BabelStr.str(92) // 打开分享链接和邀请分享后，可以分别控制和管理每个受邀共享者的访问权限
    }, opt.data);
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.bindSelf(this.renderUserInfo, this.ownerInit);
    this.$funTab = this.$('#funTab');
    if (this.canManageShare) {
      this.ownerInit();
    } else {
      this.IsJoinedByLink();
    }

    // if (this.fileInfor.get("ownerId") == app.currentUser.get("id") || this.fileInfor.belongsToTeam()) {
    //   this.$(".caption").hide();
    // } else {
    //   var ownerInfo = this.fileInfor.get("ownerName");
    //   var fileEntId = this.fileInfor.getEnterpriseId();
    //   if (fileEntId != 0) {
    //     if (fileEntId == app.ep.getEpID()) {
    //       ownerInfo += `(${BabelStr.str(397)})` //'(本公司)';
    //     } else {
    //       ownerInfo += '(' + BabelStr.str(398) + ')'; //'(外部公司)';
    //     }
    //   } else {
    //     ownerInfo += `(${BabelStr.str(399)})` //'(个人)';
    //   }
    //   this.$(".caption").html(BabelStr.str(396) + "：  " + ownerInfo); // 所有者: xxx
    // }
  },
  IsJoinedByLink: function IsJoinedByLink() {
    var self = this;
    _MMNetDiskDataController["default"].isLinkParticipant(this.fileInfor.getFileId(), function (flag) {
      if (flag) {
        console.log("该用户是通过链接分享加入的");
        self.linkShareForOwner = new _MDShareFileOperateManageOwnerView["default"]({
          canManageShare: self.canManageShare,
          roles: self.roles,
          fileInfor: self.fileInfor,
          changeFileInfor: self.changeFileInfor,
          isJoinedByLink: true,
          loadFinished: self.loadFinished,
          showRolesInfo: self.showRolesInfo,
          onRequestFail: self.onRequestFail,
          linkRoleId: self.defaultRole,
          close: self.close
        });
        self.addSubView(self.linkShareForOwner, self.$(".share-setting")[0]);
      } else {
        console.log("该用户是通过邀请分享加入的");
        if (self.fileInfor.canShowLinkShare()) {
          //拥有看到链接分享的权限
          if (self.fileInfor.get('newShareAll') == 1) {
            self.linkShareForOwner = new _MDShareFileOperateManageOwnerView["default"]({
              canManageShare: self.canManageShare,
              roles: self.roles,
              fileInfor: self.fileInfor,
              changeFileInfor: self.changeFileInfor,
              loadFinished: self.loadFinished,
              showRolesInfo: self.showRolesInfo,
              linkRoleId: self.defaultRole,
              // onShareClosed: this.onShareClosed
              onShareClosed: _.noop(),
              close: self.close
            });
            self.addSubView(self.linkShareForOwner, self.$(".share-setting")[0]);
          } else {
            self.loadFinished();
            self.$el.find('.share-setting').remove();
            if (!self.canManageShare) {
              self.loadFinished();
              self.linkShareForUser = new _MDShareFileOperateManageUserView["default"]({
                askLinkShareState: self.askLinkShareState,
                canManageShare: self.canManageShare,
                fileInfor: self.fileInfor,
                close: self.close,
                _setOpenShare: self._setOpenShare
              });
              self.addSubView(self.linkShareForUser, self.$(".share-setting")[0]);
            } else {
              self.linkShareForOwner = new _MDShareFileOperateManageOwnerView["default"]({
                canManageShare: self.canManageShare,
                roles: self.roles,
                fileInfor: self.fileInfor,
                changeFileInfor: self.changeFileInfor,
                loadFinished: self.loadFinished,
                showRolesInfo: self.showRolesInfo,
                linkRoleId: self.defaultRole,
                onShareClosed: this.onShareClosed,
                close: self.close
              });
              self.addSubView(self.linkShareForOwner, self.$(".share-setting")[0]);
            }
          }
        } else {
          self.$(".share-setting").remove();
          self.loadFinished();
        }
      }
    }, function () {});
  },
  ownerInit: function ownerInit() {
    if (this.fileInfor.canShowLinkShare()) {
      this.linkShareForOwner = new _MDShareFileOperateManageOwnerView["default"]({
        canManageShare: this.canManageShare,
        roles: this.roles,
        fileInfor: this.fileInfor,
        changeFileInfor: this.changeFileInfor,
        loadFinished: this.loadFinished,
        showRolesInfo: this.showRolesInfo,
        linkRoleId: this.defaultRole,
        onShareClosed: this.onShareClosed,
        close: this.close
      });
      this.addSubView(this.linkShareForOwner, this.$(".share-setting")[0]);
      this._initLink();
    } else {
      this.$('.share-setting').remove();
      this.loadFinished();
    }
  },
  _initLink: function _initLink() {
    var self = this;
    var fid = self.fileInfor.getFileId();
    var isHttps;
    if (location.protocol == "https:") {
      isHttps = true;
    } else {
      isHttps = false;
    }
    _MMNetDiskDataController["default"].getShareUrl(fid, isHttps, function (shareURL, linkRoleId, password) {
      self.shareURL = shareURL;
      self.linkRoleId = linkRoleId;
      if (password && password.length > 0) {
        self.linkPwd = password;
      }
      _.isFunction(self.onRequestSuccess) && self.onRequestSuccess();
    }, function (error) {
      _.isFunction(self.onRequestFail) && self.onRequestFail(error);
    });
  },
  _showManagePoint: function _showManagePoint($e) {
    var self = this;
    var $qpopup = this.$(".point-po");
    if ($qpopup.hasClass("opened")) {
      return;
    }
    $qpopup.show();
    $qpopup[0].offsetWidth;
    $qpopup.addClass("opened");
    return false;
  },
  renderUserInfo: function renderUserInfo() {
    this._requestInvUser();
  },
  _hideManagePoint: function _hideManagePoint($e) {
    var self = this;
    var $qpopup = self.$('.point-po');
    var $mqpopup = self.$('.manage-a');
    var popDOM = $mqpopup.get(0);
    if ($qpopup.css("display") == "none") {
      return;
    }
    $qpopup.transitionEndOnce(function () {
      !$qpopup.hasClass("opened") && $qpopup.hide();
    });
    $qpopup.removeClass("opened");
  }
});
var _default = exports["default"] = MDShareFileOperateManageView;

},{"106":106,"1104":1104,"1184":1184,"1417":1417,"1454":1454,"1463":1463,"22":22,"236":236,"688":688,"689":689,"690":690,"72":72}],689:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1437);
require(1541);
require(1412);
var _MMViewBase = _interopRequireDefault(require(22));
var _MDSwitchView = _interopRequireDefault(require(79));
var _MDChooserView = _interopRequireDefault(require(38));
var _MDCheckboxView = _interopRequireDefault(require(37));
var _MDshareFileLinkConditionInitView = _interopRequireDefault(require(698));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDSendLinkWindow = _interopRequireDefault(require(685));
var _MDFileTypeIconMap = _interopRequireDefault(require(258));
var _MDAlertView = _interopRequireDefault(require(32));
/**
 *  panel for share file ,to manage link share
 *  Created by jichao
 *  2016.9.28
 */

var MDShareFileOperateManageOwnerView = _MMViewBase["default"].extend({
  tmpl: '<div class="block-bd">' + '<div class="list-group share-set">' + '<div class="item setting mgb-10">' + "</div>" + "</div> " + "</div> " + "<div class='copy-thumb-wrapper' style='width=\"50px\"; height: \"50px\";position:\"relative\" '></div>",
  copyTmpl: "<table cellspacing=\"0\" cellpadding=\"0\" min-width=\"350\" max-width=\"350\" height=\"94\" style=\"background-color: rgb(248, 248, 248);\">\n    <tbody>\n        <tr>\n            <td height=\"40\" min-width=\"180\" style=\"min-width: 180px;\"><span style=\"display: none; max-height: 0px; font-size: 0px; overflow: hidden;\">\u5206\u4EAB\u5185\u5BB9:</span><a id=\"fileLinks\" href=\"<%=url%>\" target=\"_blank\" title=\"2021-11-30 15:40\u521B\u5EFA\u7684\u94FE\u63A5\" style=\"cursor: pointer; margin-left: 8px; font-size: 16px; font-weight: bold; color: rgb(5, 15, 40); text-decoration: none; display: inline-block; margin-top: 10px;\">\n <%=fileName%>\n </a><br><span style=\"display: none; max-height: 0px; font-size: 0px; overflow: hidden;\">\n &nbsp;\u94FE\u63A5\u5730\u5740:<%=url%>\n </span></td>\n            <td rowspan=\"2\" align=\"left\" width=\"68\"><a width=\"52\" href=\"<%=url%>\" target=\"_blank\" style=\"text-decoration: none;\"><input type=\"button\" value=\"\u67E5\u770B\" width=\"52\" height=\"24\" style=\"pointer-events: none; color: rgb(255, 255, 255); margin: 20px 12px 8px; font-size: 14px; background: rgb(44, 125, 241); border-radius: 2px; width: 52px; height: 24px; border: none; cursor: pointer;\"></a></td>\n        </tr>\n        <tr>\n            <td height=\"20\" id=\"LinkFileSizes\" align=\"left\" style=\"font-size: 12px; color: rgb(103, 112, 124); height: 20px; line-height: 20px; padding-right: 1px; margin-left: 4px; display: inline-block; margin-top: 6px; margin-bottom: 6px;\"><span>\n            <%if(password){%>\n              &nbsp;\u63D0\u53D6\u7801:</span><span style=\"margin-right: 6px;\"><%=password%></span>\n            <%}%>\n            <%if(endTime){%>\n              <span>\u5230\u671F\u65E5:</span><span><%=endTime%></span></td>\n            <%}%>\n        </tr>\n        <tr>\n            <td height=\"30\" colspan=\"3\" style=\"font-size: 12px; background-color: rgb(248, 248, 248); border-top: 1px solid rgb(234, 234, 234);\"><span target=\"_blank\" style=\"text-decoration: none; color: rgb(146, 156, 169);\">\n &nbsp;\u6765\u81EA\u4E8E:&nbsp;<%=userName%>\n </span></td>\n        </tr>\n    </tbody>\n</table>",
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      linkPwd: "",
      fileInfor: null,
      isJoinedByLink: false,
      onRequestSuccess: _.noop,
      onRequestFail: _.noop,
      loadFinished: _.noop,
      linkRoleId: 9
    });
  },
  events: function events() {
    return {
      "mouseenter .qrcode-btn": this._showQRCodePopup,
      "mouseleave .qrcode-btn": this._hideQRCodePopup,
      "click .qrcode-canvas canvas": this._copyQrcode,
      "click .copy-qrcode": this._copyQrcode,
      "click #copyBtn": this._copy
    };
  },
  initialize: function initialize(opt) {
    var self = this;
    opt = _.extend({}, opt);
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.$el.find(".role").hide();
    this.bindSelf(this._setOpenShare, this.changePwd, this.listenToCopyNew);
    this.$qrCodeBtn = this.$(".qrcode-btn");
    this.toggleShareCb = opt.toggleShareCb || _.noop;
    // this.fileInfor.setIconForDiv(this.$('.copy-thumb-wrapper'));
    if (this.canManageShare && !this.isJoinedByLink) {
      this.$(".setting").html('<div class="left f-emph">' + BabelStr.str(75) + "</div>" +
      // 使用链接分享
      '<div class="right"></div>');
    } else {
      this.$(".setting").html('<div class="left">' + BabelStr.str(75) + "</div>" // 使用链接分享
      );
    }
    this.openShareView = new _MDSwitchView["default"]({
      onChange: this._setOpenShare,
      className: "tooltipped-tc linkshare-switch",
      attrs: {
        "data-tooltip": BabelStr.str(408) //  '打开分享以允许其他人查看此文件'
      }
    });
    this.openShareView.renderTo(this.$(".setting .right"));
    var fid = this.fileInfor.getFileId();

    // replace *[
    // if (this.fileInfor.get('newShareAll') == "1") {
    // ]* with *[
    if (this.fileInfor.isSharing() && this.fileInfor.get("newShareAll") == "1") {
      // ]*  by jiang. 2020.12.11.
      this.openShareView.open(true);
      this.initLink();
    } else {
      this.openShareView.close(true);
      self.loadFinished();
    }
    this.renderShareBtnToolTip();
  },
  renderShareBtnToolTip: function renderShareBtnToolTip() {
    if (!this.openShareView) {
      return;
    }
    var tooltip = BabelStr.str(408);
    if (this.openShareView.isChecked()) {
      tooltip = BabelStr.str(96);
    }
    this.openShareView.setAttr({
      "data-tooltip": tooltip
    });
  },
  _changePanel: function _changePanel() {
    this.changeToInvPanel();
  },
  _copyQrcode: function _copyQrcode(e) {
    var self = this;
    var target = this.$(".qrcode-canvas canvas")[0];
    MMCommonFun.clipboardCopyCanvas(target, function () {
      console.log("success");
      MDMessageView.success(BabelStr.str(5415), self.$el);
    }, function () {
      MDMessageView.error(BabelStr.str(5418), self.$el);
      console.log("fail");
    });
  },
  _showQRCodePopup: function _showQRCodePopup($e) {
    var self = this;
    var $qpopup = this.$(".qrcode-pop");
    if ($qpopup.hasClass("opened")) {
      return;
    }
    $qpopup.show();
    $qpopup[0].offsetWidth;
    $qpopup.addClass("opened");
    return false;
  },
  _hideQRCodePopup: function _hideQRCodePopup($e) {
    var self = this;
    var $qpopup = self.$(".qrcode-pop");
    var $mqpopup = self.$(".qrcode-btn");
    var popDOM = $mqpopup.get(0);
    if ($qpopup.css("display") == "none") {
      return;
    }
    $qpopup.transitionEndOnce(function () {
      !$qpopup.hasClass("opened") && $qpopup.hide();
    });
    $qpopup.removeClass("opened");
  },
  showTooltip: function showTooltip(el, msg) {
    var $el = $(el).find("span");
    $el.addClass("tooltipped tooltipped-bc");
    $el.attr("aria-label", msg);
    $el.one("mouseleave", function () {
      $el.removeClass("tooltipped tooltipped-bc");
      $el.removeAttr("aria-label");
    });
  },
  _copy: function _copy(e) {
    document.addEventListener("copy", this.listenToCopyNew);
    document.execCommand("copy");
    document.removeEventListener("copy", this.listenToCopyNew);
  },
  listenToCopyNew: function listenToCopyNew(e) {
    var size;
    if (this.fileInfor.isFolder()) {
      size = "--";
    } else {
      size = app.getFileSizeDescription(this.fileInfor.get("currentVersionSize"));
    }
    var endTime = this.fileInfor.getLinkShareExpireTime();
    if (endTime) {
      endTime = new Date(endTime).format("yyyy-MM-dd");
    } else {
      endTime = "";
    }
    var data = {
      url: this.shareURL,
      // blob: this.imgDataUrl,
      now: new Date().format("yyyy-MM-dd HH:mm"),
      password: this.linkPwd,
      endTime: endTime,
      userName: app.currentUser.getUserName(),
      size: size,
      fileName: this.fileInfor.getFileName()
    };
    var str;
    if (this.linkPwd) {
      var linkCap = BabelStr.str(409); // 链接
      var pwdCap = BabelStr.str(394); // 密码
      // return BabelStr.str(825, {name: this.fileInfor.getFileName()}) +
      str = linkCap + " : " + this.shareURL + " " + pwdCap + " : " + this.linkPwd;
    } else {
      // return BabelStr.str(825, {name: this.fileInfor.getFileName()}) +
      str = this.shareURL;
    }
    var tmpl = _.template(this.copyTmpl)(data);
    e.clipboardData.setData("text/html", tmpl);
    e.clipboardData.setData("text/plain", str);
    MDMessageView.success(BabelStr.str(411), this.$el);

    // })

    e.preventDefault();
  },
  listenToCopy: function listenToCopy() {
    var self = this;
    var $btn = this.$("#copyBtn");
    var clipboard = new Clipboard($btn.get(0), {
      text: function text() {
        if (self.linkPwd) {
          var linkCap = BabelStr.str(409); // 链接
          var pwdCap = BabelStr.str(394); // 密码
          // return BabelStr.str(825, {name: self.fileInfor.getFileName()}) +
          var str = linkCap + " : " + self.shareURL + " " + pwdCap + " : " + self.linkPwd;
          return str;
        } else {
          // return BabelStr.str(825, {name: self.fileInfor.getFileName()}) +
          return self.shareURL;
        }
      }
    });

    // var clipboard2 = new Clipboard($btn.get(0), {

    //   target: function() {
    //     return $('.copy-text')[0]
    //   }
    // });

    clipboard.on("success", function (e) {
      e.clearSelection();
      var copyCap0 = BabelStr.str(410); // 链接和密码已拷贝到剪贴板
      var copyCap1 = BabelStr.str(411); // 链接已拷贝到剪贴板
      var tip = self.linkPwd.length > 0 ? copyCap0 : copyCap1;
      self.showTooltip($btn, tip);
    });
    clipboard.on("error", function (e) {
      var tip = "";
      if (app.os.mac) {
        tip = BabelStr.str(412); //  "请按 ⌘+C  拷贝链接";
      } else {
        tip = BabelStr.str(413); //  "请按 Ctrl+C 拷贝链接";
      }
      self.$("#link").select();
      self.showTooltip($btn, tip);
    });
    this.clipboard = clipboard;
  },
  initLink: function initLink() {
    var self = this;
    var fid = self.fileInfor.getFileId();
    var isHttps;
    this.$qrCodeBtn.prop("disable", true);
    if (location.protocol == "https:") {
      isHttps = true;
    } else {
      isHttps = false;
    }
    _MMNetDiskDataController["default"].getShareUrl(fid, isHttps, function (shareURL, linkRoleId, password) {
      self.$("#link").val(shareURL);
      self.shareURL = shareURL;
      self.linkRoleId = linkRoleId;
      self.$qrCodeBtn.prop("disable", false);
      if (password && password.length > 0) {
        self.linkPwd = password;
      }
      self._openSetRoleComponent();
      self.$(".qrcode-canvas").empty().qrcode({
        width: 160,
        height: 160,
        text: self.shareURL
      });
      self.loadFinished();
      _.isFunction(self.onRequestSuccess) && self.onRequestSuccess();
    }, function (errorCode) {
      _.isFunction(self.onRequestFail) && self.onRequestFail(errorCode);
      self.loadFinished();
    });
  },
  _setShareOpenToAnyone: function _setShareOpenToAnyone(notToAnyone) {
    var self = this;
    _MMNetDiskDataController["default"].setShareOpenToAnyone(self.fileInfor.getFileId(), !notToAnyone, function () {
      self.fileInfor.setShareAll(!notToAnyone);
      Dispatcher.trigger(MDEvents.ShareToAllChanged, self.fileInfor);
    }, function () {
      _MDSnackbarView["default"].show(BabelStr.str(414)); // ("设置私密分享失败，请稍后重试");
    });
  },
  _setOpenShare: function _setOpenShare(opened) {
    var _this = this;
    var self = this;
    var successCb = function successCb() {
      var isHttps;
      if (location.protocol == "https:") {
        isHttps = true;
      } else {
        isHttps = false;
      }
      if (opened) {
        _czc && _czc.push(["_trackEvent", "文件操作", "打开链接分享", "", "", ""]);
        _MMNetDiskDataController["default"].openLinkShare(self.fileInfor.getFileId(), self.linkRoleId, isHttps, function (shareURL, shareRoleId, fileInfo) {
          self.$("#link").val(shareURL);
          self.fileInfor.set("newShareAll", 1);
          self.fileInfor.setSharerId(app.currentUser.getUserId());
          self.fileInfor.setSharerName(app.currentUser.getUserName());
          self.fileInfor.changeShareState(1);
          self.fileInfor.set("shareAll", true);
          self.fileInfor.setRoleId(shareRoleId);
          if (app.isEpVersion()) {
            self.fileInfor.set("anonymousVisit", fileInfo.anonymousVisit);
          }
          if (self.canManageShare) {
            self.initLink();
          }
          Dispatcher.trigger(MDEvents.ShareStatusChanged, self.fileInfor, true);
          Dispatcher.trigger(MDEvents.ShareChanged);
          self.changeFileInfor(self.fileInfor);
          var noShareExpireTime = localStorage.getItem("noShareExpireTime");
          if (!noShareExpireTime) {
            setTimeout(function () {
              self.linkConditionInit.setExpireTime(true);
            }, 500);
          }
          self.renderShareBtnToolTip();
        }, function (errorCode, msg) {
          if (errorCode == 12) {
            _MDSnackbarView["default"].show(BabelStr.str(8356)); // ("你没有权限或者该文件配置不支持此操作");
          } else {
            msg = msg || BabelStr.str(168);
            _MDSnackbarView["default"].show(msg); // ("分享失败，请稍后重试");
          }
          self.openShareView.off(true);
          self.renderShareBtnToolTip();
        });
      } else {
        _czc && _czc.push(["_trackEvent", "文件操作", "关闭链接分享", "", "", ""]);
        _MMNetDiskDataController["default"].closeLinkShare(self.fileInfor.getFileId(), function () {
          self._closeSetRoleComponent();
          self.fileInfor.set("newShareAll", 0);
          self.changeFileInfor(self.fileInfor);
          _MMNetDiskDataController["default"].getInvitationList(self.fileInfor.getFileId(), function (userCollect) {
            if (userCollect.length <= 0) {
              self.fileInfor.changeShareState(false);
              self.fileInfor.set("newShareAll", 0);
              Dispatcher.trigger(MDEvents.ShareStatusChanged, self.fileInfor, false);
              Dispatcher.trigger(MDEvents.ShareChanged);
            }
            self.onShareClosed();
            self.renderShareBtnToolTip();
          }, function () {});
          if (self.fileInfor.isNeedApproval()) {
            _.isFunction(self.close) && self.close();
          }
        }, function (error, msg) {
          var message = msg || BabelStr.str(168);
          _MDSnackbarView["default"].show(message); // ('获取邀请人失败');

          self.openShareView.on(true);
          self.renderShareBtnToolTip();
        });
      }
    };
    if (!opened && this.fileInfor.isNeedApproval()) {
      _MDAlertView["default"].showStandardSelection({
        message: BabelStr.str(28229),
        okStr: BabelStr.str(156),
        okFun: function okFun() {
          successCb();
        },
        cancelFun: function cancelFun() {
          _this.openShareView.open(true);
        }
      });
    } else {
      successCb();
    }
  },
  _openSetRoleComponent: function _openSetRoleComponent() {
    var self = this;
    var scanCap0 = BabelStr.str(415); // 扫描二维码快速加入
    var scanCap1 = BabelStr.str(416); // 扫描二维码加入
    var openWeiCh = BabelStr.str(417); // 打开微信
    var userFind = BabelStr.str(418); // 点击底部的“发现”
    var scanQR = BabelStr.str(419); // 使用“扫描QR Code”
    var openBabel = BabelStr.str(420); // 打开巴别鸟
    var allFile = BabelStr.str(421); // 点击底部的“全部文件”
    var scanScan = BabelStr.str(422); // →使用左上角的“扫一扫”。
    var copyLink = BabelStr.str(80); // 复制链接

    this.$el.find(".share-set .role").remove();
    var tpl = "<div class=\"item role\" >\n                <input id=\"link\" class=\"form-control br-2\" readonly/>\n                <div class=\"list1 f-clb\">\n                  <ul>\n                    <li class=\"list1-left setting-left\"></li>\n                    <li class=\"list1-right m-qrcode f-fr\">\n                      <button class=\"qrcode-btn icon\" title=\"".concat(scanCap0, "\">\n                        <div class=\"qrcode-pop f-tc\" title=\"").concat(scanCap1, "\">\n                        <div class=\"qrcode-canvas\"></div>\n                        <div class=\"intro\">\n                          <p>").concat(BabelStr.str(5417), "</p>\n                          <p class=\"text-button copy-qrcode\">").concat(BabelStr.str(5416), "</p>\n                        </div>\n                        </div>\n                      </button>\n                    </li>\n                    <li class=\"list1-right\">\n                      <a id=\"copyBtn\" class=\"input-group-btn button done\">\n                        <span>").concat(copyLink, "</span>\n                      </a>\n                    </li>\n                  </ul>\n                </div>\n                <button id=\"send-link\" class=\"f-fr mgt-10 blue\" data-tooltip-dir=\"top\" data-tooltip=\"").concat(BabelStr.str(7289), "\">").concat(BabelStr.str(7289), "</button>\n              </div>");
    this.$div = $(tpl);
    this.$el.find(".share-set").append(this.$div);
    self.$("#link").val(self.shareURL);
    if (app.browser && app.browser.safari) {
      self.listenToCopy();
    }
    // self.listenToCopy();

    if (this.canManageShare && !this.isJoinedByLink) {
      this.linkConditionInit = new _MDshareFileLinkConditionInitView["default"]({
        fileInfor: self.fileInfor,
        password: self.linkPwd,
        linkRoleId: self.linkRoleId,
        roles: self.roles,
        showRolesInfo: self.showRolesInfo,
        changePwd: self.changePwd
      });
      this.addSubView(this.linkConditionInit, this.$(".list1-left"));
    }
    if (!app.isEpVersion()) {
      this.$el.find("#send-link").remove();
    }
    this.$el.find("#send-link").on("click", function (e) {
      self.sendLink();
    });
    var foundRole = false;
    for (var i = 0; i < self.roles.length; i++) {
      var role = self.roles[i];
      if (role.getRoleId() == self.linkRoleId) {
        foundRole = true;
        break;
      }
    }
    if (!foundRole) {
      self.$(".setting-left").remove();
    }
  },
  changePwd: function changePwd(linkPwd) {
    this.linkPwd = linkPwd;
  },
  _closeSetRoleComponent: function _closeSetRoleComponent() {
    var self = this;
    this.$el.find(".share-set .role").remove();
  },
  sendLink: function sendLink(e) {
    var link = this.$el.find("#link").val();
    var sendWin = new _MDSendLinkWindow["default"]({
      fid: this.fileInfor.getFileId(),
      link: link,
      fileInfor: this.fileInfor
    });
    sendWin.show();
  }
});
var _default = exports["default"] = MDShareFileOperateManageOwnerView;

},{"1104":1104,"1184":1184,"1412":1412,"1417":1417,"1437":1437,"1454":1454,"1463":1463,"1541":1541,"22":22,"258":258,"32":32,"37":37,"38":38,"685":685,"698":698,"72":72,"79":79}],698:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1421);
require(1498);
require(1541);
require(1429);
require(1437);
require(1463);
require(1478);
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MMViewBase = _interopRequireDefault(require(22));
var _MDSwitchView = _interopRequireDefault(require(79));
var _MDChooserView = _interopRequireDefault(require(38));
var _MDCheckboxView = _interopRequireDefault(require(37));
var _MDDropDownSelectRoleView = _interopRequireDefault(require(50));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDAlertView = _interopRequireDefault(require(32));
var _MMCommonFun = _interopRequireDefault(require(812));
var MDshareFileLinkConditionInitView = _MMViewBase["default"].extend({
  tmpl: '<div class="per-select" id = "select2"></div>' + "<div>" + '<div class="checkbox-link4">' + '<div class="item-1 f-hide"><input class="password" disabled="true" /><button class="text-button done" id="setpwd"><%=reset%></button></div>' + "</div>" + "<div>" + '<div class="checkbox-link5">' + '<div class="item-1 f-hide">' + '<span class = "datepicker">' + '<input type="text" class="date-expire"  placeholder="<%=endTime%>">' + '<i class = "icon ep-expire-date"></i>' + "</span>" + "</div>" + "</div>" + '<div class="checkbox-link6">' + "</div>" + '<div class="link-watermark-checkbox"></div>' + '<div class="anonymous-upload f-none">' + '<div class="flex-align middle with-wrap">' + '<div class="checkbox-link7 mgr-10"></div><div class="err-msg"><%=BabelStr.str(3481)%></div>' + "</div>" + '<div class="help-block upload-block red f-none"><%=BabelStr.str(3480)%></div>' + "</div>" + '<div class="checkbox-link8">' + "</div>" + '<div class="checkbox-link9">' + "</div>" + "</div>" + "<%if(!isShareFileWatermarkCannotCustom){%>\n     <div class=\"other-setting f-hide mgb-20 pdb-10\">\n    <div class=\"flex-align between\">\n      <span class=\"text-button done other-setting-btn\"><%=BabelStr.str(12100)%></span>\n      <span class=\"text-button done close-other-setting\"><%=BabelStr.str(3219)%></span>\n    </div>\n    <div class=\"watermark-block\">\n      <div class=\"flex-align between mgt-10\">\n        <div class=\"boldfont2\"><%=BabelStr.str(40117)%></div>\n        <div class=\"mark-switch\"></div>\n      </div>\n      <div class=\"watermard-div f-hide\">\n        <div class=\"flex-align middle opacity-block color-block-bd mgt-10\">\n          <div class=\"mark-title boldfont2\"><%=BabelStr.str(40139)%></div>\n          <div class=\"fullfill color-block flex-align\">\n          <input class=\"watermark-input form-control\" placeholder=\"<%=BabelStr.str(40114)%>\">\n          </div>\n        </div>\n        <div class=\"flex-align middle bb-solid pos-block mgt-10\">\n          <div class=\"mark-title\"><div class=\"boldfont2 \"><%=BabelStr.str(3241)%></div></div>\n          <div class=\"fullfill pos-setting radio-group\">\n              <div class=\"setting-item radio-box mgr-10 checked\"><%=BabelStr.str(40140)%></div>\n              <div class=\"setting-item radio-box mgr-10\"><%=BabelStr.str(3243)%></div>\n              <div class=\"setting-item radio-box mgr-10\"><%=BabelStr.str(3244)%></div>\n          </div>\n        </div>\n        <div class=\"flex-align middle opacity-block color-block-bd mgt-10\">\n          <div class=\"mark-title boldfont2\"><%=BabelStr.str(3245)%></div>\n          <div class=\"fullfill color-block flex-align gap-10\">\n            <input type=\"text\" class=\"form-control opacity-value\" onkeyup=\"this.value=this.value.replace(/D/g,'')\" >\n            <span class=\"mgr-15\">%</span>\n          </div>\n        </div>\n        <div class=\"flex-align middle opacity-block color-block-bd mgt-10\">\n          <div class=\"mark-title boldfont2\"><%=BabelStr.str(7474)%></div>\n          <div class=\"fullfill color-block flex-align\">\n          <input class=\"color-picker form-control\" value=\"000000\" data-jscolor=\"\">\n          </div>\n        </div>\n      </div>\n    </div>\n  </div> <%}%>",
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      password: "",
      roleIds: [],
      changePwd: _.noop,
      data: {
        reset: BabelStr.str(724),
        // 重置密码
        endTime: BabelStr.str(176) // 截止日期
      }
    });
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      // 'click #select2 li:last-child': this.aboutPermission,
      "click .datepicker i": this.showDatePicker,
      "click #setpwd": this._setAddPwd,
      "click .other-setting-btn": this._showOtherSetting,
      "click .close-other-setting": this._closeOtherSetting,
      "click .setting-item": this._characterSettingItemClickHandle,
      "blur .watermark-input": this._watermarkBlur,
      'keyup .watermark-input': this.onInputKeyup,
      "blur .opacity-value": this._opacityBlur,
      "keyup .opacity-value": this._opacityKeyup
    });
  },
  initialize: function initialize(opt) {
    var _this = this;
    var self = this;
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.bindSelf(this.setLinkRoleId, this._watermarkChanged, this._setShareWatermark, this._modifyLinkShareRole, this._selectThisCondition, this.setExpireTime, this._setSendAccessInfoToLinkedIn);

    // if(!app.isEpVersion() && app.currentUser.inFreeEdition()) {
    //   this.$(".checkbox-link8").addClass('f-hide')
    // }

    this.checkbox4 = new _MDCheckboxView["default"]({
      label: BabelStr.str(82),
      // "访问此链接需要输入密码",
      isBlockLevel: false,
      onChanged: this._selectThisCondition
    });
    this.addSubView(this.checkbox4, this.$(".checkbox-link4")[0]);
    this.anonymousVisit = new _MDCheckboxView["default"]({
      label: BabelStr.str(6328),
      // "允许匿名访问",
      isBlockLevel: false,
      onChanged: function onChanged(checked) {
        if (!app.isEpVersion() && app.currentUser.inFreeEdition() && checked) {
          _this.anonymousVisit.setChecked(!checked, true);
          _MDSnackbarView["default"].show(BabelStr.str(827));
          return;
        } else if (app.isEpVersion() && app.ep.isAnoymousClosed() && checked) {
          _this.anonymousVisit.setChecked(!checked, true);
          _MDSnackbarView["default"].show(BabelStr.str(6654));
          return;
        }
        _this.setAnonymousVisit(checked);
      }
    });
    this.addSubView(this.anonymousVisit, this.$(".checkbox-link8")[0]);
    if (app.isEpVersion()) {
      this.withinEp = new _MDCheckboxView["default"]({
        label: BabelStr.str(21921),
        // "仅允许企业内人员访问",
        isBlockLevel: false,
        checked: this.fileInfor.isShareWithinEnt(),
        onChanged: function onChanged(checked) {
          _this.setwithinEp(checked);
        }
      });
      this.addSubView(this.withinEp, this.$(".checkbox-link9")[0]);
    }
    //如果有保密部门，就不允许匿名上传
    if (app.isEpVersion() || !app.currentUser.inFreeEdition()) {
      this.anonymousUpload = new _MDCheckboxView["default"]({
        label: BabelStr.str(3479),
        // "访问此链接需要输入密码",
        // isBlockLevel: false,
        onChanged: function onChanged(checked) {
          if (app.isEpVersion() && app.ep.isAnoymousClosed()) {
            _this.anonymousUpload.setChecked(!checked, true);
            _MDSnackbarView["default"].show(BabelStr.str(6654));
            return;
          }
          _this._anonymousUploadCondChanged(checked, app.isEpVersion() && app.currentUser.get("hasSecret"));
        }
      });
      this.addSubView(this.anonymousUpload, this.$(".checkbox-link7")[0]);
    }

    // if(app.isEpVersion() && app.ep.getIsNeedShowEnableWatermarkButton()){
    //   this.linkCheckboxWatermark = new MDCheckboxView({
    //       label: "开启水印",
    //       onChanged: this._setShareWatermark,
    //       checked: this.fileInfor.getOpenWatermark()
    //     });
    //   this.addSubView(this.linkCheckboxWatermark, this.$(".link-watermark-checkbox")[0]);
    // }

    if (app.isEpVersion()) {
      _MMEnterpriseController["default"].getEnterpriseWaterMark(function (watermark) {
        if (watermark["watermarkType"] != 0 && watermark["watermarkScope"] == 2) {
          self.linkCheckboxWatermark = new _MDCheckboxView["default"]({
            label: BabelStr.str(708),
            // "开启水印",
            onChanged: self._setShareWatermark,
            checked: self.fileInfor.getOpenWatermark()
          });
          self.addSubView(self.linkCheckboxWatermark, self.$(".link-watermark-checkbox")[0]);
        }
      }, function () {});
    }
    this.initExpireTime();
    this.initSendInformation();
    var roleArr = [];
    for (var i = 0; i < this.roles.length; i++) {
      var role = this.roles[i];
      var param = {
        "do": role.getRoleName()
      };
      var des = BabelStr.str(725, param); //"知道此链接的任何人都可以" + role.getRoleName()
      var str = {
        label: des,
        canSelected: true,
        linkRoleId: role.getRoleId(),
        permission: role.get("permission"),
        systemdefault: role.get("systemdefault")
      };
      self.roleIds.push(role.getRoleId());
      roleArr.push(str);
    }
    if (this.fileInfor.canAnonymousUpload()) {
      this.anonymousUpload && this.anonymousUpload.setChecked(true, true);
      this.renderPwdAndDateBtn(true);
      this.renderAnoymouseVisitBtn(true);
    }
    if (this.fileInfor.get("anonymousVisit")) {
      if (!app.isEpVersion() && app.currentUser.inFreeEdition()) {
        //个人版默认设置不允许
        // this.$(".checkbox-link8").addClass('f-hide')
        _MMNetDiskDataController["default"].setAnonymousVisit(this.fileInfor.getFileId(), 0, function () {
          _this.fileInfor.set("anonymousVisit", 0);
        }, function () {});
      } else {
        this.anonymousVisit.setChecked(true, true);
        this.withinEp && this.fileInfor.isShareWithinEnt() && this.withinEp.setChecked(false);
      }
    }
    var forClient = this.fileInfor.get("forClient");
    var index = _.indexOf(this.roleIds, this.linkRoleId);
    this.select2 = new _MDDropDownSelectRoleView["default"]({
      index: index,
      bd: roleArr,
      roles: this.roles,
      invite: false,
      minW: "510px",
      showHelp: !forClient,
      onChange: function onChange(item) {
        self._modifyLinkShareRole(self.fileInfor.getFileId(), item.linkRoleId);
        self._renderAnonymousUploadBlock(item.permission);
      }
    });
    this.addSubView(this.select2, this.$("#select2")[0]);
    this.setState(this.fileInfor, this.password, this.linkRoleId, true);
    this.listenTo(this.fileInfor, "change:openWatermark", this._watermarkChanged);
    this.markSwitch = new _MDSwitchView["default"]({
      onChange: function onChange(state) {
        _this.refreshWaterMarkContent(state);
        var wordWaterMark = _this.$(".watermark-input").val().trim();
        if (!state || wordWaterMark) {
          _this.updateWatermark();
        }
      }
    });
    this.addSubView(this.markSwitch, this.$(".mark-switch"));
    // jscolor(this.$(".color-picker")[0]);

    if (!app.ep.isShareFileWatermarkCannotCustom()) {
      var colorPicker = new jscolor(this.$(".color-picker")[0], {
        hash: true,
        // URL hash 联动
        onChange: function onChange(hex) {
          _this.updateWatermark(hex); // 颜色变化时触发保存
        }
        // onInput: function(hex) {
        //   this.updateWatermark(hex);  // 颜色变化时触发保存
        // }
      });
      this.getWatermark4File();
    }
  },
  render: function render(data) {
    data = data || {};
    data.isShareFileWatermarkCannotCustom = app.ep.isShareFileWatermarkCannotCustom();
    _MMViewBase["default"].prototype.render.call(this, data);
  },
  _characterSettingItemClickHandle: function _characterSettingItemClickHandle($e) {
    var $curItem = $($e.target);
    if ($curItem.hasClass("checked")) {
      return;
    } else {
      $curItem.siblings().removeClass("checked");
      $curItem.addClass("checked");
      this.updateWatermark();
    }
  },
  _watermarkBlur: function _watermarkBlur($e) {
    var wordWaterMark = this.$(".watermark-input").val().trim();
    if (wordWaterMark != this.wordWaterMark) {
      this.updateWatermark();
    }
  },
  _opacityBlur: function _opacityBlur($e) {
    var watermarkTransparent = this.$(".opacity-value").val().trim();
    if (watermarkTransparent != this.watermarkTransparent) {
      this.updateWatermark();
    }
  },
  _opacityKeyup: function _opacityKeyup(e) {
    if (e.which === 13 || e.keyCode === 13) {
      // Enter 键
      e.preventDefault(); // 阻止默认行为（如表单提交）
      var watermarkTransparent = this.$(".opacity-value").val().trim();
      if (watermarkTransparent != this.watermarkTransparent) {
        this.updateWatermark();
      }
    }
  },
  onInputKeyup: function onInputKeyup(e) {
    if (e.which === 13 || e.keyCode === 13) {
      // Enter 键
      e.preventDefault(); // 阻止默认行为（如表单提交）
      var wordWaterMark = this.$(".watermark-input").val().trim();
      if (wordWaterMark != this.wordWaterMark) {
        this.updateWatermark();
      }
    }
  },
  _itemClassChanged: function _itemClassChanged(e) {},
  _showOtherSetting: function _showOtherSetting() {
    this.$(".other-setting").addClass("opened");
  },
  _closeOtherSetting: function _closeOtherSetting() {
    this.$(".other-setting").removeClass("opened");
  },
  updateWatermark: function updateWatermark() {
    var _this2 = this;
    if (this.updateWatermarkTimer) {
      clearTimeout(this.updateWatermarkTimer);
    }
    this.updateWatermarkTimer = setTimeout(function () {
      if (_this2.markSwitch.isChecked()) {
        var wordWaterMark = _this2.$(".watermark-input").val().trim();
        if (!wordWaterMark) {
          _this2.deleteWatermark4File();
        } else {
          var request;
          if (_this2.hasWaterMark) {
            request = _MMEnterpriseController["default"].updateWatermark4File;
          } else {
            request = _MMEnterpriseController["default"].createDefaultWatermakr4File;
          }
          var color = $(".color-picker").val();
          color = color.slice(1, color.length);
          var $checkPosItem = _this2.$(".pos-block .radio-box.checked");
          var watermarkTransparent = _this2.$(".opacity-value").val().trim();
          var param = {
            fileId: _this2.fileInfor.getFileId(),
            color: color,
            wordWaterMark: wordWaterMark,
            watermarkPositionType: $checkPosItem.index(),
            watermarkTransparent: watermarkTransparent
          };
          request(param, function () {
            _MDSnackbarView["default"].show(BabelStr.str(308));
            _this2.wordWaterMark = param.wordWaterMark;
            _this2.hasWaterMark = true;
          }, function (err) {
            _MDSnackbarView["default"].show(err.msg || BabelStr.str(309));
          });
        }
      } else {
        _this2.deleteWatermark4File();
      }
    }, 400);
  },
  deleteWatermark4File: function deleteWatermark4File() {
    var _this3 = this;
    if (!this.hasWaterMark) {
      return false;
    }
    _MMEnterpriseController["default"].deleteWatermark4File(this.fileInfor.getFileId(), function () {
      _MDSnackbarView["default"].show(BabelStr.str(308));
      _this3.wordWaterMark = "";
      _this3.hasWaterMark = false;
    }, function () {
      _MDSnackbarView["default"].show(BabelStr.str(309));
    });
  },
  getWatermark4File: function getWatermark4File() {
    var _this4 = this;
    _MMEnterpriseController["default"].getWatermark4File(this.fileInfor.getFileId(), function (watermark) {
      if (watermark) {
        _this4.markSwitch.open(true);
        _this4.refreshWaterMarkContent(true);
        _this4.$(".watermark-input").val(watermark.wordWaterMark);
        _this4.$(".opacity-value").val(watermark.watermarkTransparent);
        var color = watermark.strColor || "000000";
        color = color.toString(16);
        _this4.$(".color-picker")[0].jscolor.fromString(color);
        _this4.$(".pos-setting .setting-item").removeClass("checked").eq(watermark.watermarkPositionType).addClass("checked");
        _this4.hasWaterMark = true;
        _this4.wordWaterMark = watermark.wordWaterMark;
      } else {}
    }, function () {});
  },
  refreshWaterMarkContent: function refreshWaterMarkContent(show) {
    if (show) {
      this.$(".watermard-div").removeClass("f-hide");
    } else {
      this.$(".watermard-div").addClass("f-hide");
    }
  },
  _renderAnonymousUploadBlock: function _renderAnonymousUploadBlock(per) {
    var canUpload = per & 258;
    if (canUpload && this.anonymousUpload) {
      // && this.fileInfor.isFolder()) {
      this.$(".anonymous-upload").show();
    } else {
      this.$(".anonymous-upload").hide();
      this.renderAnoymouseVisitBtn(false);
      this.fileInfor.setAnonymousUpload(false);
      this.anonymousUpload && this.anonymousUpload.setChecked(false, true);
    }
    if (canUpload && this.fileInfor.isFolder() && this.fileInfor.canAnonymousUpload()) {
      if (!this.expireCheckBox.isChecked()) {
        this.expireCheckBox.setChecked(true);
        this.expireCheckBox.setDisabled(true);
      }
    } else {
      this.expireCheckBox.setDisabled(false);
    }
  },
  _anonymousUploadCondChanged: function _anonymousUploadCondChanged(checked, hasSecret) {
    var _this5 = this;
    if (hasSecret && checked) {
      _MDSnackbarView["default"].show(BabelStr.str(6571));
      this.anonymousUpload && this.anonymousUpload.setChecked(false, true);
      return;
    }
    var self = this;

    // anonymous-block
    var linkShareExpireTime = this.fileInfor.getLinkShareExpireTime();
    var extraStatus = this.fileInfor.get("extraStatus");
    var readme = "";
    var btn = "";
    if (this.fileInfor.get("anonymousVisit")) {
      this.anonymousVisit.setChecked(true, true);
    }
    var anonymousVisit = this.fileInfor.get("anonymousVisit");
    if (checked) {
      var _ne;
      if (!linkShareExpireTime) {
        this._setDefaultExpireTime(function () {
          _this5.expireCheckBox.setChecked(true, true);
          _this5._enableAnonymouseUpload(true);
        }, function () {});
        // this.anonymousUpload.setChecked(false, true)
      } else {
        this._enableAnonymouseUpload(true);
      }
      if (!anonymousVisit) {
        this.setAnonymousVisit(1, function () {
          _this5.anonymousVisit.setChecked(true, true);
          if (linkShareExpireTime) {
            _this5._enableAnonymouseUpload(true);
          }
        });
      }
    } else {
      this._enableAnonymouseUpload(false);
    }
  },
  setAnonymousVisit: function setAnonymousVisit(sign, success) {
    var _this6 = this;
    sign = sign ? 1 : 0;
    var self = this;
    _MMNetDiskDataController["default"].setAnonymousVisit(this.fileInfor.getFileId(), sign, function () {
      _.isFunction(success) && success();
      _this6.fileInfor.set("anonymousVisit", sign);
      _MDSnackbarView["default"].show(BabelStr.str(308));
      if (sign) {
        _this6.withinEp && _this6.fileInfor.isShareWithinEnt() && _this6.withinEp.setChecked(false);
      }
    }, function (code) {
      if (sign) {
        _this6.anonymousVisit.setChecked(false, true);
      } else {
        _this6.anonymousVisit.setChecked(true, true);
      }
      if (code == 20000) {
        _MDSnackbarView["default"].show(BabelStr.str(21230));
      } else {
        _MDSnackbarView["default"].show(BabelStr.str(309));
      }
    });
  },
  setwithinEp: function setwithinEp(sign, success) {
    var _this7 = this;
    sign = sign ? 1 : 0;
    var self = this;
    _MMEnterpriseController["default"].setShareWithinEnt(this.fileInfor.getFileId(), sign, function () {
      _.isFunction(success) && success();
      _this7.fileInfor.setShareWithinEnt(sign);
      _MDSnackbarView["default"].show(BabelStr.str(308));
      if (sign) {
        _this7.anonymousUpload && _this7.anonymousUpload.isChecked() && _this7.anonymousUpload.setChecked(false);
        _this7.anonymousVisit && _this7.fileInfor.get("anonymousVisit") && _this7.anonymousVisit.setChecked(false);
      }
    }, function (code) {
      if (sign) {
        _this7.withinEp.setChecked(false, true);
      } else {
        _this7.withinEp.setChecked(true, true);
      }
      if (code == 20000) {
        _MDSnackbarView["default"].show(BabelStr.str(21230));
      } else {
        _MDSnackbarView["default"].show(BabelStr.str(309));
      }
    });
  },
  _enableAnonymouseUpload: function _enableAnonymouseUpload(enable, scucess, fail) {
    var _this8 = this;
    var val = enable ? 1 : 0;
    _MMEnterpriseController["default"].setFileAnonymouseUpload(this.fileInfor.getFileId(), val, function () {
      _MDSnackbarView["default"].show(BabelStr.str(308));
      _this8.renderPwdAndDateBtn(enable);
      _this8.renderAnoymouseVisitBtn(enable);
      _this8.fileInfor.setAnonymousUpload(enable);
      scucess && scucess();
    }, function (code, msg) {
      _MDSnackbarView["default"].show(BabelStr.str(309));
      _this8.anonymousUpload && _this8.anonymousUpload.setChecked(!enable, true);
      fail && fail();
    });
  },
  renderAnoymouseVisitBtn: function renderAnoymouseVisitBtn(sign) {
    this.anonymousVisit.setDisabled(sign);
  },
  renderPwdAndDateBtn: function renderPwdAndDateBtn(sign) {
    this.expireCheckBox.setDisabled(sign);
    // this.checkbox4.setDisabled(sign)
    if (sign) {
      this.$(".upload-block").show();
    } else {
      this.$(".upload-block").hide();
    }
  },
  _setShareWatermark: function _setShareWatermark(checked) {
    var sign = checked ? 1 : 0;
    var self = this;
    _MMNetDiskDataController["default"].setShareWatermark(this.fileInfor.getFileId(), sign, function () {
      console.log("watermark: " + checked);
      self.fileInfor.setOpenWatermark(sign);
    }, function () {});
  },
  _watermarkChanged: function _watermarkChanged() {
    var sign;
    if (this.fileInfor.getOpenWatermark()) {
      sign = true;
    } else {
      sign = false;
    }
    this.linkCheckboxWatermark && this.linkCheckboxWatermark.setChecked(sign, true);
  },
  initExpireTime: function initExpireTime() {
    var self = this;
    this.expireCheckBox = new _MDCheckboxView["default"]({
      label: BabelStr.str(726),
      //  "设置分享截止日期",
      isBlockLevel: false,
      onChanged: this.setExpireTime,
      onClickedAfter: function onClickedAfter(checked) {
        if (checked) {
          localStorage.removeItem("noShareExpireTime");
        } else {
          localStorage.setItem("noShareExpireTime", 1);
        }
      }
    });
    this.addSubView(this.expireCheckBox, this.$(".checkbox-link5")[0]);
    var $expireTimeBox = this.$(".date-expire");
    $expireTimeBox.datepicker({
      minDate: 1
    }).on("change", function () {
      var exDate = $expireTimeBox.datepicker("getDate");
      _MMNetDiskDataController["default"].setLinkShareExpireTime(self.fileInfor.getFileId(), exDate.getTime() / 1000, function () {
        _MDSnackbarView["default"].show(BabelStr.str(308)); // ("设置截止日期成功！");

        self.fileInfor.setLinkShareExpireTime(exDate.getTime());
      }, function () {
        _MDSnackbarView["default"].show(BabelStr.str(309)); // ("设置失败，请稍后重试");
      });
    });
    var expireTime = this.fileInfor.getLinkShareExpireTime();
    if (expireTime) {
      this.expireCheckBox.setChecked(true, true);
      expireTime = new Date(expireTime);
      this._onExpireTimeSetted(expireTime);
    }
  },
  initSendInformation: function initSendInformation() {
    var self = this;
    this.informCheckBox = new _MDCheckboxView["default"]({
      label: BabelStr.str(727),
      // "发送分享参与动态信息给通过链接加入者",
      isBlockLevel: false,
      onChanged: this._setSendAccessInfoToLinkedIn
    });
    this.addSubView(this.informCheckBox, this.$(".checkbox-link6")[0]);
    var informCheck = this.fileInfor.getSendAccessInfoToLinkedIn();
    if (informCheck) {
      this.informCheckBox.setChecked(true, true);
    }
  },
  aboutPermission: function aboutPermission($e) {
    this.showRolesInfo();
  },
  showDatePicker: function showDatePicker() {
    var $expireTimeBox = self.$(".date-expire");
    $expireTimeBox.focus();
  },
  _modifyLinkShareRole: function _modifyLinkShareRole(fileId, linkRoleId) {
    var self = this;
    _MMNetDiskDataController["default"].modifyLinkShareRole(fileId, linkRoleId, function () {
      console.log("成功修改linkRoleId");
    }, function () {});
  },
  setState: function setState(fileInfor, password, linkRoleId, opt_silent) {
    var index = _.indexOf(this.roleIds, linkRoleId);
    if (index != -1) {
      this.$(".setting-left").show();
      this.select2.selectByIndex(index, opt_silent);
      var selectRole = this.select2.getDataByIndex(index);
      this._renderAnonymousUploadBlock(selectRole.permission);
      if (password) {
        this.checkbox4.setChecked(true);
      } else {
        this.checkbox4.setChecked(false);
      }
    } else {
      this.$(".setting-left").hide();
    }
  },
  initLinkCondition: function initLinkCondition() {
    this.setLinkRoleId();
  },
  _setSendAccessInfoToLinkedIn: function _setSendAccessInfoToLinkedIn(checked) {
    var self = this;
    var isHttps;
    var value = checked ? 1 : 0;
    _MMNetDiskDataController["default"].setSendAccessInfoToLinkedIn(self.fileInfor.getFileId(), value, function () {
      self.fileInfor.setSendAccessInfoToLinkedIn(checked);
    }, function () {
      _MDSnackbarView["default"].show(BabelStr.str(309)); // ("设置发送通知失败，请稍后重试");
      self.informCheckBox.setChecked(!checked, true);
    });
  },
  setExpireTime: function setExpireTime(checked) {
    var self = this;
    var isHttps;
    if (!this.expireCheckBox) {
      return;
    }
    if (checked) {
      this._setDefaultExpireTime(function (expireTime) {
        self.expireCheckBox.setChecked(true, true);
      }, function () {
        self.expireCheckBox.setChecked(false, true);
      });
    } else {
      _MMNetDiskDataController["default"].setLinkShareExpireTime(self.fileInfor.getFileId(), undefined, function () {
        self.$(".checkbox-link5 .item-1").removeClass("f-inline-block");
        self.$(".checkbox-link5 .item-1 ").addClass("f-hide");
        self.fileInfor.setLinkShareExpireTime(0);
      }, function () {
        _MDSnackbarView["default"].show(BabelStr.str(309)); // ("关闭截止日期失败，请稍后重试");
        self.expireCheckBox.setChecked(true, true);
      });
    }
  },
  _onExpireTimeSetted: function _onExpireTimeSetted(expireTime) {
    var self = this;
    self.$(".checkbox-link5 .item-1 ").addClass("f-inline-block");
    self.$(".checkbox-link5 .item-1").removeClass("f-hide");
    var $expireTimeBox = self.$(".datepicker");
    $expireTimeBox.datepicker("setDate", expireTime);
    self.$(".datepicker input").val(expireTime.format("yyyy-MM-dd"));
  },
  _setDefaultExpireTime: function _setDefaultExpireTime(scucess, fail) {
    var self = this;

    // var today = new Date();
    // var expireTime = new Date(today.valueOf());
    // expireTime.setDate(today.getDate() + 7);

    // // expireTime = expireTime.format("yyyy-MM-dd")
    // if (scucess) {
    //   scucess(expireTime);
    // };

    _MMNetDiskDataController["default"].setDefaultExpireTime(self.fileInfor.getFileId(), function (expireTime) {
      expireTime = new Date(expireTime);
      self.fileInfor.setLinkShareExpireTime(expireTime.getTime());
      self._onExpireTimeSetted(expireTime);
      _MDSnackbarView["default"].show(BabelStr.str(728)); //("成功设置7天后自动关闭！");
      if (scucess) {
        scucess(expireTime);
      }
    }, function () {
      _MDSnackbarView["default"].show(BabelStr.str(309)); // ("设置失败，请稍后重试");
      if (fail) fail();
    });
  },
  _selectThisCondition: function _selectThisCondition(checked) {
    var self = this;
    var isHttps;
    if (!this.checkbox4) {
      return;
    }
    if (checked) {
      this.checkbox4.setLabel(BabelStr.str(729)); //("访问密码");
      if (this.password) {
        this.$(".password").val(this.password);
      } else {
        this._setAddPwd();
      }
      this.$(".checkbox-link4 .item-1 ").addClass("f-inline-block");
      this.$(".checkbox-link4 .item-1").removeClass("f-hide");
    } else {
      this.checkbox4.setLabel(BabelStr.str(3304));
      this.$(".checkbox-link4 .item-1").removeClass("f-inline-block");
      this.$(".checkbox-link4 .item-1 ").addClass("f-hide");
      if (location.protocol == "https:") {
        isHttps = true;
      } else {
        isHttps = false;
      }
      _MMNetDiskDataController["default"].setFilePassword(self.fileInfor.getFileId(), "", isHttps, function (shareURL) {
        self.$(".password").val("");
        self.password = "";
        self.changePwd(self.password);
      }, function () {
        _MDSnackbarView["default"].show(BabelStr.str(3305));
      });
    }
  },
  _setAddPwd: function _setAddPwd(checked) {
    var self = this;
    var isHttps = false;
    var password = _MMCommonFun["default"].generateRandomString(5);
    if (location.protocol == "https:") {
      isHttps = true;
    } else {
      isHttps = false;
    }
    _MMNetDiskDataController["default"].setFilePassword(self.fileInfor.getFileId(), password, isHttps, function (shareURL) {
      self.$("#link").val(shareURL);
      self.$(".password").val(password);
      self.linkPwd = password;
      self.password = password;
      self.changePwd(password);
      _MDSnackbarView["default"].show(BabelStr.str(3306));
    }, function () {
      _MDSnackbarView["default"].show(BabelStr.str(3307));
    });
  },
  changePwd: function changePwd(password) {
    this.changePwd(password);
  }
});
var _default = exports["default"] = MDshareFileLinkConditionInitView;

},{"1098":1098,"1104":1104,"1184":1184,"1421":1421,"1429":1429,"1437":1437,"1454":1454,"1463":1463,"1478":1478,"1498":1498,"1541":1541,"22":22,"32":32,"37":37,"38":38,"50":50,"72":72,"79":79,"812":812}],492:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1458);
require(1426);
require(1412);
require(1413);
require(1463);
require(1424);
require(1471);
require(1439);
require(1429);
require(1421);
require(1418);
require(1537);
require(1461);
require(1417);
require(1541);
require(1436);
require(1546);
require(1477);
require(1492);
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDClientDownloadWinView = _interopRequireDefault(require(484));
var _MDOfficeEditor4PC = _interopRequireDefault(require(419));
var _MDFileCompareWinView = _interopRequireDefault(require(549));
var _ErrorCode = _interopRequireDefault(require(1087));
var _MMFileInfo = _interopRequireDefault(require(297));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDEvents = _interopRequireDefault(require(325));
var _MDRenameWindowView = _interopRequireDefault(require(514));
var _MDBatchRenameWinView = _interopRequireDefault(require(539));
var _MDMoveFileWindowView = _interopRequireDefault(require(508));
var _MDMoveArchiveWindowView = _interopRequireDefault(require(530));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDShareFileWindowView = _interopRequireDefault(require(695));
var _MDSnapshotLinkFileWindowView = _interopRequireDefault(require(697));
var _MDDownloadFileController = _interopRequireDefault(require(412));
var _MDCreateFolderWindowView = _interopRequireDefault(require(486));
var _MDLocalFileCollector = _interopRequireDefault(require(330));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MMBasicData = _interopRequireDefault(require(811));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDLoadMaskView = _interopRequireDefault(require(49));
var _MDEvalutionStartView = _interopRequireDefault(require(473));
var _MDEvaluationListWinView = _interopRequireDefault(require(468));
var _MDManuscriptBoxView = _interopRequireDefault(require(176));
var _MDMsBoxCreateSelectWinView = _interopRequireDefault(require(185));
var _MDMsAnonyBoxTabWinView = _interopRequireDefault(require(184));
var _MDChannelType = _interopRequireDefault(require(717));
var _MDNewEntBroadcastView = _interopRequireDefault(require(151));
var _MDAddTagBigWindow = _interopRequireDefault(require(781));
var _MDFileOperationManager = _interopRequireDefault(require(326));
var _MDInputFileNamePanel = _interopRequireDefault(require(1125));
var _MDNetDriveFileHandler = _interopRequireDefault(require(1091));
var _MDBorrowPanelView = _interopRequireDefault(require(528));
var _MDProjectCreateWinView = _interopRequireDefault(require(652));
var _MDDepControlFileListWinView = _interopRequireDefault(require(562));
var _MDDepSecretFileListWinView = _interopRequireDefault(require(568));
var _MDDepShareFileListWinView = _interopRequireDefault(require(569));
var _MDDepEvaluationSettingWinView = _interopRequireDefault(require(132));
var _MDApplicationRenamePerWinView = _interopRequireDefault(require(479));
var _MDApplicationMovePerWinView = _interopRequireDefault(require(477));
var _MDApplicationPerWinView = _interopRequireDefault(require(478));
var _MDArchiveReadingRoomCreateWinView = _interopRequireDefault(require(527));
var _MDShowLinkFileWinView = _interopRequireDefault(require(632));
var _MDFileOpStatisitcsWindow = _interopRequireDefault(require(577));
var _MDFocusFileWinView = _interopRequireDefault(require(635));
var _MDShareJumpOption = _interopRequireDefault(require(520));
var _MDTextEditorController = _interopRequireDefault(require(1128));
var _MDKityMinderEditorController = _interopRequireDefault(require(228));
var _MDManageSecurityWindowView = _interopRequireDefault(require(590));
var _MDUnzipFileWinView = _interopRequireDefault(require(707));
var _MDHQSMManageNavWinView = _interopRequireDefault(require(641));
var _MDSendHQSNFileWinView = _interopRequireDefault(require(657));
var _MDTransmittalInfoWinView = _interopRequireDefault(require(660));
var _MDSendHistoryWinView = _interopRequireDefault(require(658));
var _MDMDisplayFileController = _interopRequireDefault(require(352));
var _MDTeamSettingWindowView = _interopRequireDefault(require(763));
var _MEDepartMemberDownLimitWinView = _interopRequireDefault(require(141));
var _MDClientSyncSelectWinView = _interopRequireDefault(require(485));
var _MDTransferFileWinView = _interopRequireDefault(require(524));
var _MDTransferFileByPortWinView = _interopRequireDefault(require(523));
var _MDDownloadPathForClientWinView = _interopRequireDefault(require(489));
var _MDDepFilePermissionWinView = _interopRequireDefault(require(565));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDDrawioEditorController = _interopRequireDefault(require(113));
var _MDClassifyCreateWinView = _interopRequireDefault(require(623));
var _MDSubLibraryCreateWinView = _interopRequireDefault(require(630));
var _MDApplyLibraryWinView = _interopRequireDefault(require(617));
var _MDApplyDownloadView = _interopRequireDefault(require(615));
var _MDBatchEditClassifyWinView = _interopRequireDefault(require(618));
var _MDBatchEditLibraryWinView = _interopRequireDefault(require(620));
var _MDApplyJoinWinView = _interopRequireDefault(require(616));
var _MDTiptapEditorControllerJs = _interopRequireDefault(require(1133));
var _MDAddAITagWinView = _interopRequireDefault(require(560));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDCreateLinkView = _interopRequireDefault(require(487));
var _app = _interopRequireDefault(require(17));
var _MDcreateEncryptedFolderWindowView = _interopRequireDefault(require(558));
var _MDFileActionController = _interopRequireDefault(require(493));
var _MDClassificationSelectWinView = _interopRequireDefault(require(540));
var _MDSurveyFrameView = _interopRequireDefault(require(699));
/**
 * File Action controller , define the logic of the files.
 *
 * javascript/moladisk/views/file/MDFileActionController.js
 * Created by manjun.han
 * 2016.1.25
 */

// import MDDepShareFileListWinView from './fileinfo/MDDepShareFileListWinView.js'

/**
 * 此处必须添加一个命名空间
 * The Compiler renames properties and variables independently,
 * 此处是按property处理，
 */
function MDFileActionController(params) {
  this.channel = _MDChannelType["default"].home;
  this.channel = -1;
  this.initialize(params);
}
var simpleEditor = localStorage.getItem("simpleEditor");
if (simpleEditor) {
  $("body").addClass("simple-editor");
}
window.MDFileActionController = MDFileActionController;
/**
 * 如果不添加命名空间,此处按照变量处理
 */
MDFileActionController.extend = Backbone.Model.extend;
_.extend(MDFileActionController.prototype, _MDFileActionController["default"]);
_.extend(MDFileActionController.prototype, {
  initialize: function initialize(props) {
    Backbone.Model.prototype.initialize.call(this, props);
    if (props) {
      var _props = Object.getOwnPropertyNames(props);
      for (var i = 0; i < _props.length; i++) {
        var name = _props[i];
        this[name] = props[name];
      }
    }

    // console.log('----------> init action:', this.channel);
  },
  openSurveyPreview: function openSurveyPreview(fileInfo, callback) {
    this.openSurveyFile(fileInfo, "preview", callback);
  },
  openSurveySummary: function openSurveySummary(fileInfo, callback) {
    this.openSurveyFile(fileInfo, "summary", callback);
  },
  openSurveyEdit: function openSurveyEdit(fileInfo, callback) {
    this.openSurveyFile(fileInfo, "edit", callback);
  },
  openSurveyFile: function openSurveyFile(fileInfo, mode, callback) {
    if (!fileInfo) {
      return;
    }
    _MDSurveyFrameView["default"].open(fileInfo, mode, callback);
  },
  copySurveyAndEdit: function copySurveyAndEdit(fileInfo) {
    if (!fileInfo) {
      return;
    }
    var self = this;
    _MMEnterpriseController["default"].copyFormbricksSurvey(fileInfo.getFileId(), function (responseData) {
      // 文件记录在服务端已落库，但列表视图不会自动感知，必须主动刷新当前文件夹
      var folder = _app["default"].pathRouter && _app["default"].pathRouter.getCurrentFolder ? _app["default"].pathRouter.getCurrentFolder() : _app["default"].currentFolder || {};
      self._refreshFolder(folder);
      self.openSurveyEdit({
        getFileId: function getFileId() {
          return responseData.fileId;
        },
        getFileName: function getFileName() {
          return responseData.fileName || "";
        }
      });
    }, function (err) {
      var detail = err && (err.msg || err.message || err.code || err.responseText || err.statusText);
      if (detail && detail.length > 180) {
        detail = err.status + " " + err.statusText;
      }
      if (window.console && console.error) {
        console.error("copyFormbricksSurvey failed", err && err.status, err && err.responseText);
      }
      _MDSnackbarView["default"].show(BabelStr.str(50102) + "失败" + (detail ? "（" + detail + "）" : ""));
    });
  },
  createSurveyFile: function createSurveyFile() {
    var self = this;
    var folder = _app["default"].pathRouter && _app["default"].pathRouter.getCurrentFolder ? _app["default"].pathRouter.getCurrentFolder() : _app["default"].currentFolder || {};
    var parentFolderId = folder.getFileId ? folder.getFileId() : folder.get ? folder.get("fileId") : folder.id || folder._id || null;
    // 创建请求在面板关闭前就发出,连点确定或回车会重复创建,必须防重
    var requesting = false;
    var inputFileNamePanel = new _MDInputFileNamePanel["default"]({
      defaultFileName: BabelStr.str(50106),
      saveFile: function saveFile(fileName) {
        if (requesting) {
          return;
        }
        requesting = true;
        _MMEnterpriseController["default"].createFormbricksSurvey(fileName, parentFolderId, function (responseData) {
          inputFileNamePanel.close();
          // 文件记录在服务端已落库，但列表视图不会自动感知，必须主动刷新当前文件夹
          self._refreshFolder(folder);
          self.openSurveyEdit({
            getFileId: function getFileId() {
              return responseData.fileId;
            },
            getFileName: function getFileName() {
              return responseData.fileName || fileName + ".survey";
            }
          });
        }, function (err) {
          requesting = false; // 失败后允许重试
          var detail = err && (err.msg || err.message || err.code || err.responseText || err.statusText);
          if (detail && detail.length > 180) {
            detail = err.status + " " + err.statusText;
          }
          if (window.console && console.error) {
            console.error("createFormbricksSurvey failed", err && err.status, err && err.responseText);
          }
          _MDSnackbarView["default"].show(BabelStr.str(50105) + "创建失败" + (detail ? "（" + detail + "）" : ""));
        });
      }
    });
    inputFileNamePanel.show();
  },
  canShowAISearchImg: function canShowAISearchImg() {
    if (this.fileInfors.length != 1) {
      return false;
    }
    var fileInfo = this.fileInfors[0];
    if (fileInfo.isAiImg() && !fileInfo.isArchived() && !_app["default"].currentUser.isCloseAI() && !_app["default"].currentUser.isAnonymous() && window.supportAI) {
      return true;
    } else {
      return false;
    }
  },
  startAISearchImg: function startAISearchImg() {
    _MDMessageView["default"].infor(BabelStr.str(26037));
    var fileInfo = this.fileInfors[0];
    // MMEnterpriseController.getImageTokenByFileId(fileInfo.getFileId(), (token)=>{
    window.AIImgSearchObj = {
      fileId: fileInfo.getFileId()
    };
    _app["default"].pathRouter.navigateToPath("webai/imgSearch", true);
    // }, err=>{
    //   MDSnackbarView.show(err,msg)
    // })
  },
  unZipFile: function unZipFile() {
    var win = new _MDUnzipFileWinView["default"]();
    win.show();
  },
  showSendHistory: function showSendHistory() {
    var win = new _MDSendHistoryWinView["default"]({
      fileInfor: this.fileInfors[0]
    });
    win.show();
  },
  sendFile: function sendFile() {
    if (this.fileInfors.length > 5) {
      var opt = {
        message: BabelStr.str(6838)
      };
      _MDAlertView["default"].showStandardPrompt(opt);
      return false;
    }
    var ids = _.map(this.fileInfors, function (file) {
      return file.getFileId();
    });
    var win = new _MDTransferFileWinView["default"]({
      fileIds: ids
    });
    win.show();
  },
  transferFile: function transferFile() {
    if (window.portInfos.length < 1) {
      var opt = {
        message: BabelStr.str(6902)
      };
      _MDAlertView["default"].showStandardPrompt(opt);
      return false;
    }
    var ids = _.map(this.fileInfors, function (file) {
      return file.getFileId();
    });
    var win = new _MDTransferFileByPortWinView["default"]({
      fileIds: ids
    });
    win.show();
  },
  sendHQSMFile: function sendHQSMFile() {
    var win = new _MDSendHQSNFileWinView["default"]({
      fileInfors: this.fileInfors
    });
    win.show();
  },
  createTransmittal: function createTransmittal() {
    var win = new _MDTransmittalInfoWinView["default"]({
      fileInfors: this.fileInfors
    });
    win.show();
  },
  showPerWinView: function showPerWinView(data) {
    if (!data) {
      data = {};
    }
    data.fileInfors = this.fileInfors;
    var win = new _MDApplicationPerWinView["default"](data);
    win.show();
  },
  setFileInfors: function setFileInfors(fileInfors) {
    this.fileInfors = fileInfors || [];
    return this;
  },
  unfocusFile: function unfocusFile() {
    var fileInfors = this.fileInfors;
    var fileIds = _.map(fileInfors, function (fileInfor) {
      return fileInfor.getFileId();
    });
    _MMNetDiskDataController["default"].removeMyFileFocus(fileIds, function () {
      _Dispatcher["default"].trigger(_MDEvents["default"].refreshMyFocusFiles);
      _MDSnackbarView["default"].show(BabelStr.str(308)); // ('删除星标成功');
      _.each(fileInfors, function (fileInfo) {
        fileInfo.setIsFocusFile(false);
        var count = fileInfo.getFocusCount();
        fileInfo.setFocusCount(count - 1);
      });
    }, function () {
      _MDSnackbarView["default"].show(BabelStr.str(309)); // ('删除星标失败');
    });
  },
  canShowClearCacheBtn: function canShowClearCacheBtn() {
    if (!_app["default"].isInClient()) {
      return;
    }
    var electron = window["ElectronRequire"]("electron");
    if (!electron.remote.require("./utils/cppAPI").clearCacheItem) {
      return;
    }
    if (this.fileInfors && this.fileInfors.length == 1) {
      var fileInfor = this.fileInfors[0];
      if (fileInfor.isArchived()) {
        return false;
      } else {
        var isClient = _app["default"].isInClient();
        if (isClient) {
          return fileInfor.canDownload() && !fileInfor.isFolder() && this.canUploadVersion();
        }
      }
    } else {
      return false;
    }
  },
  showClientDownloadWin: function showClientDownloadWin() {
    var downloadWin = new _MDClientDownloadWinView["default"]({
      title: BabelStr.str(5183, {
        multiFilesCount: window.multiFilesCount,
        multiFilesSize: _MMCommonFun["default"].getDispStorageIntStr(window.multiFilesSize)
      })
    });
    downloadWin.show();
  },
  canShowClearAllCacheBtn: function canShowClearAllCacheBtn() {
    if (!_app["default"].isInClient()) {
      return;
    }
    var electron = window["ElectronRequire"]("electron");
    if (!electron.remote.require("./utils/cppAPI").clearAllCacheItem) {
      return;
    }
    return true;
  },
  showEditProject: function showEditProject() {
    var fileInfor = this.fileInfors[0];
    if (fileInfor.isProject()) {
      var win = new _MDProjectCreateWinView["default"]({
        type: 1,
        fileId: fileInfor.getFileId(),
        isProjectAssist: fileInfor.get("isProjectAssist"),
        originFile: fileInfor
      });
      win.show();
    } else {
      this.manageHQSMProject(fileInfor);
    }
  },
  showEditClassify: function showEditClassify() {
    var fileInfor = this.fileInfors[0];
    var win = new _MDClassifyCreateWinView["default"]({
      forEdit: true,
      fileId: fileInfor.getFileId(),
      fileInfor: fileInfor
    });
    win.show();
  },
  showBatchEditClassify: function showBatchEditClassify() {
    var win = new _MDBatchEditClassifyWinView["default"]({
      fileInfors: this.fileInfors
    });
    win.show();
  },
  showBatchEditLibrary: function showBatchEditLibrary() {
    var win = new _MDBatchEditLibraryWinView["default"]({
      fileInfors: this.fileInfors
    });
    win.show();
  },
  showEditLibrary: function showEditLibrary() {
    var fileInfor = this.fileInfors[0];
    var win = new _MDSubLibraryCreateWinView["default"]({
      forEdit: true,
      fileId: fileInfor.getFileId(),
      fileInfor: fileInfor,
      isProjectAssist: fileInfor.get("isProjectAssist")
    });
    win.show();
  },
  showApplyLibrary: function showApplyLibrary() {
    var fileInfor = this.fileInfors[0];
    var win = new _MDApplyLibraryWinView["default"]({
      forEdit: true,
      fileId: fileInfor.getFileId(),
      fileInfor: fileInfor
    });
    win.show();
  },
  showApplyDownload: function showApplyDownload() {
    var win = new _MDApplyDownloadView["default"]({
      fileInfors: this.fileInfors
    });
    win.show();
  },
  showApplyJoin: function showApplyJoin() {
    var win = new _MDApplyJoinWinView["default"]({
      fileInfor: this.fileInfors[0]
    });
    win.show();
  },
  showTransformProjectToUser: function showTransformProjectToUser() {
    var fileInfor = this.fileInfors[0];
    var win = new _MDProjectCreateWinView["default"]({
      type: 5,
      fileId: fileInfor.getFileId()
    });
    win.show();
  },
  /**
   * 开启评审
   */

  ShowStartEvaluation: function ShowStartEvaluation() {
    var opt;
    if (!_app["default"].ep.canShowEvalModel()) {
      opt = {
        message: BabelStr.str(6117)
      };
      _MDAlertView["default"].showStandardPrompt(opt);
      return;
    }
    if (_app["default"].isEpVersion()) {
      var evalutionWinView = new _MDEvalutionStartView["default"]({
        fileInfors: this.fileInfors
      });
      evalutionWinView.show();
    } else {
      opt = {
        message: BabelStr.str(199) // 只有企业版支持文件审批功能，您可以开启企业版使用此功能
      };
      _MDAlertView["default"].showStandardPrompt(opt);
    }
  },
  showDepEvaluationWin: function showDepEvaluationWin() {
    var fileInfo = this.fileInfors[0];
    var win = new _MDDepEvaluationSettingWinView["default"]({
      depId: fileInfo.get("departmentId"),
      canCreate: false,
      dataInit: false,
      isRoot: fileInfo.get("parentId") == "0"
    });
    win.show();
  },
  ShowDoingvaluation: function ShowDoingvaluation() {
    var evaluationListWin = new _MDEvaluationListWinView["default"]({
      fileInfo: this.fileInfors[0]
    });
    evaluationListWin.show();
  },
  ShowAbolishEvaluation: function ShowAbolishEvaluation() {
    return true;
  },
  showControlFileWinView: function showControlFileWinView(params) {
    var fileControlWinView = new _MDDepFilePermissionWinView["default"]({
      fileInfo: this.fileInfors[0],
      params: params
    });
    fileControlWinView.show();
  },
  showControlFileListWinView: function showControlFileListWinView() {
    var fileControlWinView = new _MDDepControlFileListWinView["default"]({
      fileInfo: this.fileInfors[0]
    });
    fileControlWinView.show();
  },
  showShareFileListWinView: function showShareFileListWinView() {
    var fileControlWinView = new _MDDepShareFileListWinView["default"]({
      fileInfo: this.fileInfors[0]
    });
    fileControlWinView.show();
  },
  showSecretFileListWinView: function showSecretFileListWinView() {
    var fileControlWinView = new _MDDepSecretFileListWinView["default"]({
      fileInfo: this.fileInfors[0]
    });
    fileControlWinView.show();
  },
  downloadFileForClient: function downloadFileForClient(fileInfors, callback) {
    var win = new _MDDownloadPathForClientWinView["default"]({
      fileInfors: this.fileInfors || fileInfors,
      callback: callback
    });
    win.show();
  },
  downloadFile: function downloadFile(opt) {
    if (this.downloading) {
      return;
    }
    if (!this.canDownload()) {
      this.showPerWinView();
      return;
    }
    var self = this;
    if (this.fileInfors.length == 1 && this.fileInfors[0].isOfficeFile()) {
      var url = "/netdrive/isDocEditedByOnlyOffice.do";
      var postData = {
        fileId: this.fileInfors[0].getFileId()
      };
      $.ajax({
        method: "post",
        dataType: "json",
        url: url,
        data: postData,
        success: function success(responseData, textStatus, jqXHR) {
          if (responseData["success"] === true) {
            var isEditing = responseData["isEditing"];
            if (isEditing) {
              _MDAlertView["default"].showDangerSelection({
                message: BabelStr.str(21306),
                okStr: BabelStr.str(21307),
                okFun: function okFun() {
                  self.fileInfors[0].set("doNotOnlyoffice", true);
                  self._downloadFile(opt);
                }
              });
            } else {
              self._downloadFile(opt);
            }
          }
        }
      });
    } else {
      this._downloadFile(opt);
    }
  },
  /**
   * 下载文件
   */
  _downloadFile: function _downloadFile(opt) {
    var _this = this;
    if (_app["default"].currentUser && !_app["default"].currentUser.logined() && _app["default"].isInClient()) {
      // if (!MMCommonFun.isTheClientSupportAnonymouseDownload()) {
      //   MDAlertView.showAlert(BabelStr.str(21700)); //("个人版不支持文件收集箱，请升级到企业版！");
      //   return;
      // }
      if (!_MMCommonFun["default"].isTheClientSupportAnonymouseDownload()) {
        window.downloadPanelforAnonymousShareView.pushFiles(this.fileInfors);
        return;
      }
    }

    // if (app.currentUser && app.currentUser.logined() && app.isInClient()) {
    if (_app["default"].isInClient()) {
      var electron = window["ElectronRequire"]("electron");
      var download = electron.remote.require("./utils/cppAPI").downloadFile;
      if (download) {
        var down = function down() {
          _app["default"].getDownloadFileTargetForClient(_this.fileInfors, function (path) {
            var result = [];
            for (var i = 0; i < _this.fileInfors.length; i++) {
              fileInfo = _this.fileInfors[i];
              if (fileInfo.isShortcuts()) {
                fileInfo = fileInfo.clone();
                fileInfo.setFileId(fileInfo.getShortCutsTargetFileId());
              }
              result.push({
                fileId: fileInfo.getFileId(),
                fileName: fileInfo.getFileName(),
                fileSize: fileInfo.get("fileSize") || fileInfo.get("currentVersionSize") || 1,
                isFolder: fileInfo.isFolder(),
                version: fileInfo.getCurVersion()
              });
            }
            download(result, path);
          });
        };
        if (_app["default"].ep.isArchive()) {
          down();
        } else {
          _MMEnterpriseController["default"].isIpAllowDownload(_app["default"].currentFolder.getFileId(), function () {
            down();
          }, function (err) {
            _MDAlertView["default"].showStandardPrompt({
              message: err.msg
            });
          });
        }
        return;
      }
    }
    var fileInfo = null;
    var that = this;
    this.downloading = true;
    // if (this.fileInfors.length != 1 || !this.fileInfors[0].isFolder()) {
    //   var loadingView = new MDLoadMaskView();
    //   loadingView.show();
    // setBabelTimeout(function () {
    // that.downloading = false;
    // loadingView.remove();
    // }, 2000);
    // }

    if (this.fileInfors.length >= 1) {
      if (this.fileInfors.length == 1 && !this.fileInfors[0].isFolder()) {
        _MDLoadMaskView["default"].show();
        setBabelTimeout(function () {
          that.downloading = false;
          _MDLoadMaskView["default"].remove();
        }, 2000);
        fileInfo = this.fileInfors[0];
        if (fileInfo.isDeleteVersion()) {
          var fid = fileInfo.getFileId();
          var fver = fileInfo.getDeleteVersion();
          var fname = fileInfo.getFileName();
          fileInfo.set('toDownloadVer', fileInfo.getDeleteVersion());
          window.downloadPanelView.pushFiles([fileInfo]);
        }
        // else if(fileInfo.isArchived() && fileInfo.canCoverToPdf()) {
        //   that.downloadArchiveFile()
        // }
        else if (fileInfo.isShortcuts()) {
          _MMFileInfo["default"].prepareLinkedFileInfo(fileInfo, function (f) {
            if (!!f.get("status") == true) {
              var opt = {
                message: BabelStr.str(552)
              };
              _MDAlertView["default"].showStandardPrompt(opt);
              return;
            }
            if (f.isArchived() && !_app["default"].ep.isArchive()) {
              if (_app["default"].ep.canShowArchiveModel()) {
                var opt = {
                  width: 490,
                  message: BabelStr.str(778),
                  //    你要下载的是归档文件，需要到档案库去下载，点击确定转到档案库
                  okFun: function okFun() {
                    _app["default"].pathRouter.openNetTab("/archive.do#archive/" + f.getParentFolderId());
                  }
                };
                _MDAlertView["default"].showStandardSelection(opt);
              } else {
                var opt = {
                  message: BabelStr.str(6119)
                };
                _MDAlertView["default"].showStandardPrompt(opt);
              }
            } else if (f.isTeamFolder()) {
              _MDAlertView["default"].showStandardPrompt({
                message: BabelStr.str(786)
              });
            } else if (!f.canDownload()) {
              _MDAlertView["default"].showStandardPrompt({
                message: BabelStr.str(786)
              });
            } else {
              var fid = fileInfo.getShortCutsTargetFileId();
              var fver = fileInfo.getShortCutsTargetFile().getCurVersion();
              var fver = -1;
              var fname = fileInfo.getFileName();
              window.downloadPanelView.pushFiles([new _MMFileInfo["default"]({
                fileId: fid,
                toDownloadVer: -1,
                fileName: fname
              })]);
            }
          });
        } else {
          window.downloadPanelView.pushFiles([fileInfo]);
          _MMNetDiskDataController["default"].clearFileVersionUnreadMark(fileInfo);
        }
      } else if (this.fileInfors.length == 1 && this.fileInfors[0].isFolder()) {
        fileInfo = this.fileInfors[0];
        if (fileInfo.isShortcuts()) {
          _MMFileInfo["default"].prepareLinkedFileInfo(fileInfo, function (f) {
            if (!!f.get("status") == true || f.get("delTime")) {
              var opt = {
                message: BabelStr.str(552)
              };
              _MDAlertView["default"].showStandardPrompt(opt);
              _this.downloading = false;
              return;
            }
            if (f.isArchived() && !_app["default"].ep.isArchive()) {
              if (_app["default"].ep.canShowArchiveModel()) {
                var opt = {
                  width: 490,
                  message: BabelStr.str(778),
                  //    你要下载的是归档文件，需要到档案库去下载，点击确定转到档案库
                  okFun: function okFun() {
                    _app["default"].pathRouter.openNetTab("/archive.do#archive/" + f.getParentFolderId());
                  }
                };
                _MDAlertView["default"].showStandardSelection(opt);
              } else {
                var opt = {
                  message: BabelStr.str(6119)
                };
                _MDAlertView["default"].showStandardPrompt(opt);
              }
              _this.downloading = false;
            }
          });
          return;
        }
        var serverFun;
        if (window.user.useAdvancedSearch) {
          serverFun = _MMEnterpriseController["default"].getFileNumInFolder2New;
        } else {
          serverFun = _MMNetDiskDataController["default"].getFileNumInFolder;
        }
        _MDLoadMaskView["default"].show(undefined, {
          bodyMsg: BabelStr.str(5182),
          width: BabelStr.isRu() ? 400 : 220
        });
        serverFun(this.fileInfors[0].getFileId(), function (fileCount, fileSize) {
          that.downloading = false;
          _this.fileInfors[0].set("fileSize", fileSize);
          if (fileCount > window.multiFilesCount || fileSize > window.multiFilesSize) {
            // if(fileCount > 1 || fileSize > 1 ) {
            if (_app["default"].isShareApp && _app["default"].ep.isPrivateCloud()) {
              _MDSnackbarView["default"].show(BabelStr.str(5183, {
                multiFilesCount: window.multiFilesCount,
                multiFilesSize: _MMCommonFun["default"].getDispStorageIntStr(window.multiFilesSize)
              }));
            } else {
              var downloadWin = new _MDClientDownloadWinView["default"]({
                title: BabelStr.str(5183, {
                  multiFilesCount: window.multiFilesCount,
                  multiFilesSize: _MMCommonFun["default"].getDispStorageIntStr(window.multiFilesSize)
                })
              });
              downloadWin.show();
            }
            _MDLoadMaskView["default"].remove();
            _this.downloading = false;
            return;
          }
          var ids = [];
          var files = [];
          for (var i = 0; i < _this.fileInfors.length; i++) {
            fileInfo = _this.fileInfors[i];
            // if (!fileInfo.isFolder()) {
            if (fileInfo.isShortcuts()) {
              fileInfo = fileInfo.clone();
              fileInfo.setFileId(fileInfo.getShortCutsTargetFileId());
            }
            ids.push(fileInfo.getFileId());
            files.push(fileInfo);
            // };
          }
          // MDDownloadFileController.downloadFileWithFileIds(ids);

          window.downloadPanelView.pushFiles(files);
          _MMNetDiskDataController["default"].clearFilesUnreadMarks(files);
        }, function (msg) {
          that.downloading = false;
          _MDLoadMaskView["default"].remove();
          _MDSnackbarView["default"].show(msg);
        });
      } else {
        var ids = [];
        var files = [];
        if (this.fileInfors.length > 100) {
          var downloadWin = new _MDClientDownloadWinView["default"]({
            title: "".concat(BabelStr.str(6130))
          });
          downloadWin.show();
          this.downloading = false;
          return;
        }
        for (var i = 0; i < this.fileInfors.length; i++) {
          fileInfo = this.fileInfors[i];
          // if (!fileInfo.isFolder()) {
          if (fileInfo.isShortcuts()) {
            fileInfo = fileInfo.clone();
            fileInfo.setFileId(fileInfo.getShortCutsTargetFileId());
          }
          if (fileInfo.isFolder()) {
            var downloadWin = new _MDClientDownloadWinView["default"]({
              title: BabelStr.str(6132)
            });
            downloadWin.show();
            this.downloading = false;
            return;
          }
          ids.push(fileInfo.getFileId());
          files.push(fileInfo);
        }
        _MDLoadMaskView["default"].show();
        setBabelTimeout(function () {
          that.downloading = false;
          _MDLoadMaskView["default"].remove();
        }, 2000);
        // _.each(ids, (id) => {
        //   MDDownloadFileController.downloadFileWithFileIds(id);
        // });
        window.downloadPanelView.pushFiles(files);
        _MMNetDiskDataController["default"].clearFilesUnreadMarks(files);
      }
    }
  },
  downloadMarkedPdf: function downloadMarkedPdf(ignoreIp) {
    var that = this;
    if (this.downloading) {
      return;
    }
    this.downloading = true;
    _MDLoadMaskView["default"].show();
    setBabelTimeout(function () {
      that.downloading = false;
      _MDLoadMaskView["default"].remove();
    }, 2000);
    var fileInfo = this.fileInfors[0];
    var currentVersion = fileInfo.getCurVersion();
    var fid = fileInfo.getFileId();
    _MMEnterpriseController["default"].readFileConvertStatus(fid, currentVersion, function () {
      var realUrl = "/netdrive/downloadWaterMarkPdf.do?fileId=".concat(fid, "&version=").concat(currentVersion);
      var $iframe = $("#file-downloader");
      if ($iframe.length == 0) {
        $iframe = $("<iframe>");
        $iframe.attr("id", "file-downloader").appendTo("body");
        $iframe.width(0).height(0).css("visibility", "hidden");
      }

      //限制ip后给出提示信息
      var param = "fileId=" + fid + "&version=" + currentVersion;
      var url = "/netdrive/getOriginFileUrl.do?" + param;
      if (ignoreIp) {
        $iframe.attr("src", realUrl);
        return;
      }
      _MMCommonFun["default"].getRealRequestURL(url, function (newRealUrl) {
        // callback(realUrl);
        $iframe.attr("src", realUrl);
      }, function (response) {
        if (response["code"] == "10006") {
          response["msg"] = BabelStr.str(5542);
          _MDSnackbarView["default"].show(response["msg"]);
        } else {
          $iframe.attr("src", realUrl);
        }
      });
    }, function (err) {
      _MDSnackbarView["default"].show(err.msg);
    });
    return true;
  },
  downloadArchivePdf: function downloadArchivePdf(type) {
    var that = this;
    if (this.downloading) {
      return;
    }
    this.downloading = true;
    _MDLoadMaskView["default"].show();
    setBabelTimeout(function () {
      that.downloading = false;
      _MDLoadMaskView["default"].remove();
    }, 2000);
    this.downloadArchiveFile(type);
  },
  downloadArchiveFile: function downloadArchiveFile(type) {
    var fileInfo = this.fileInfors[0];
    var that = this;
    var currentVersion = fileInfo.getCurVersion();
    var fid = fileInfo.getFileId();
    var realUrl = "";
    if (type) {
      realUrl = "/netdrive/downloadSignatureFile.do?fileId=".concat(fid, "&version=").concat(currentVersion);
    } else {
      realUrl = "/netdrive/downloadArchiveFile.do?fileId=".concat(fid, "&version=").concat(currentVersion);
    }
    var $iframe = $("#file-downloader");
    if ($iframe.length == 0) {
      $iframe = $("<iframe>");
      $iframe.attr("id", "file-downloader").appendTo("body");
      $iframe.width(0).height(0).css("visibility", "hidden");
    }
    //限制ip后给出提示信息
    var param = "fileId=" + fid + "&version=" + currentVersion;
    var url = "/netdrive/getOriginFileUrl.do?" + param;
    _MMCommonFun["default"].getRealRequestURL(url, function () {
      // callback(realUrl);
      $iframe.attr("src", realUrl);
    }, function (response) {
      if (response["code"] == "10006") {
        response["msg"] = BabelStr.str(5542);
        _MDSnackbarView["default"].show(response["msg"]);
      } else {
        $iframe.attr("src", realUrl);
      }
    });
    return true;
  },
  stickonTop: function stickonTop() {
    console.log("----------> to top");
  },
  showManageTeam: function showManageTeam() {
    var wind = new _MDTeamSettingWindowView["default"]({
      teamFolderId: this.fileInfors[0].getFileId()
    });
    wind.show();
  },
  showAddStarMark: function showAddStarMark() {
    var deleteMark = _.every(this.fileInfors, function (fileInfor) {
      return fileInfor.getStarmark();
    });
    return !deleteMark;
  },
  moveFiles: function moveFiles(deleteAfterMove) {
    if (!this.canMove()) {
      // this.showPerWinView();
      var win = new _MDApplicationMovePerWinView["default"]({
        fileInfor: this.fileInfors[0]
      });
      win.show();
      return;
    }
    var parentId = 0;
    // if (app.pathRouter.isInFileChannel()) {
    parentId = _app["default"].pathRouter.getCurrentFolder().getFileId();
    // }

    var self = this;
    if (_app["default"].ep && _app["default"].ep.isArchive()) {
      var wind = new _MDMoveArchiveWindowView["default"]({
        fileInfors: self.fileInfors,
        deleteAfterMove: deleteAfterMove,
        parentId: parentId
      });
      wind.show();
    } else {
      var wind = new _MDMoveFileWindowView["default"]({
        fileInfors: self.fileInfors,
        deleteAfterMove: deleteAfterMove,
        parentId: parentId
      });
      wind.show();
    }
  },
  cutFiles: function cutFiles(deleteAfterMove) {
    var parentId = 0;
    parentId = _app["default"].pathRouter.getCurrentFolder().getFileId();
    self.fileInfors;
    window.pasteObj = {
      isMove: true,
      originParent: parentId,
      files: this.fileInfors,
      entId: _app["default"].currentFolder.getEnterpriseId()
    };
  },
  quickCopyFiles: function quickCopyFiles(deleteAfterMove) {
    var parentId = 0;
    parentId = _app["default"].pathRouter.getCurrentFolder().getFileId();
    self.fileInfors;
    window.pasteObj = {
      isMove: false,
      originParent: parentId,
      files: this.fileInfors,
      entId: _app["default"].currentFolder.getEnterpriseId()
    };
  },
  pastFiles: function pastFiles() {
    var _this2 = this;
    if (!window.pasteObj || window.pasteObj.stop) {
      return;
    }
    window.pasteObj.stop = true;
    this.testManuscriptLimits(_app["default"].currentFolder).then(function (limits) {
      console.log(limits);
      var names = _.map(_this2.fileInfors, function (file) {
        return file.getFileName();
      });
      var limitsResult = _.every(names, function (name) {
        return _MMCommonFun["default"].validateFileType(name, limits) == true;
      });
      if (!limitsResult) {
        var type = limits[0]["type"];
        var str = _.pluck(limits, "stringLimit").join(",");
        var message = BabelStr.str(6865, {
          str: str
        });
        var alert = new _MDAlertView["default"]({
          title: BabelStr.str(170),
          width: 600,
          message: message,
          onHide: function onHide() {
            alert = null;
          },
          buttons: [{
            label: BabelStr.str(154) // ----- '跳过',
          }]
        });
        alert.show();
      } else {
        _MMNetDiskDataController["default"].checkFolderSize(_app["default"].currentFolder.getFileId(), function () {
          var ids = _.map(window.pasteObj.files, function (file) {
            return file.getFileId();
          });
          if (!window.pasteObj.isMove) {
            _MDFileOperationManager["default"].copyFileIntoFolder(window.pasteObj.files, _app["default"].currentFolder.getFileId(), function (err) {
              if (!err) {
                window.pasteObj = null;
              } else {
                window.pasteObj.stop = false;
              }
            });
          } else {
            var sourceFolderId = window.pasteObj.files[0].get("parentId");
            var targetEntId = _app["default"].currentFolder.getEnterpriseId();
            var sourceEntId = window.pasteObj.entId;
            var mixEnt = targetEntId != sourceEntId;
            _MDFileOperationManager["default"].moveFileIntoFolder(ids, _app["default"].currentFolder.getFileId(), sourceFolderId, mixEnt, function (err) {
              if (!err) {
                window.pasteObj = null;
                window.DBManage.clearHistoryData();
                window.filelistHistory && window.filelistHistory.reset();
              } else {
                window.pasteObj.stop = false;
              }
            });
          }
        }, function (error, msg) {
          window.pasteObj.stop = false;
          if (error == 7) {
            _MDAlertView["default"].showStandardPrompt({
              message: BabelStr.str(7524)
            });
          } else {
            _MDAlertView["default"].showStandardPrompt({
              message: msg
            });
          }
        });
      }
    });
  },
  testManuscriptLimits: function testManuscriptLimits(currentFile) {
    return new Promise(function (resolve, rejected) {
      if (currentFile.getFileId() == 0) {
        resolve([]);
        return;
      }
      var sign = false;
      if (currentFile.isManuscriptBox() && !currentFile.get("limitsState")) {
        sign = true;
        _MMNetDiskDataController["default"].getMsBoxLimits(targetFolderId, function (limits) {
          resolve(limits);
        });
      } else if (currentFile.isManuscriptBox() && currentFile.get("limitsState")) {
        sign = true;
        resolve(currentFile.get("limits"));
      } else if (!currentFile.isManuscriptBox()) {
        var paths = _app["default"].pathRouter.filePaths;
        for (var i = 0; i < paths.length; i++) {
          if (paths[i].getFileId() != "0") {
            var file = paths[i];
            if (file.isManuscriptBox() && !file.get("limitsState")) {
              sign = true;
              _MMNetDiskDataController["default"].getMsBoxLimits(file.getFileId(), function (limits) {
                resolve(limits);
              });
            }
          }
        }
      }
      if (!sign) {
        resolve([]);
      }
    });
  },
  editLink: function editLink() {
    var parentId = 0;
    // if (app.pathRouter.isInFileChannel()) {
    parentId = _app["default"].pathRouter.getCurrentFolder().getFileId();
    // }
    var wind = new _MDCreateLinkView["default"]({
      parentId: parentId,
      fileInfor: this.fileInfors[0]
    });
    wind.show();
  },
  manageSecurity: function manageSecurity() {
    var wind = new _MDManageSecurityWindowView["default"]({
      fileInfors: this.fileInfors
    });
    wind.show();
  },
  addStarMark: function addStarMark(success, fail) {
    var fileInfors = this.fileInfors;
    var fileIds = _.map(this.fileInfors, function (fileInfor) {
      return fileInfor.getFileId();
    });
    _MMNetDiskDataController["default"].addStarmarkFile(fileIds, function () {
      _.each(fileInfors, function (fileInfor) {
        fileInfor.set("starmark", 1);
      });
      _Dispatcher["default"].trigger(_MDEvents["default"].StarmarkChanged);
      _MDSnackbarView["default"].show(BabelStr.str(308)); // ('添加星标成功');
      if (_.isFunction(success)) {
        success();
      }
    }, function () {
      if (_.isFunction(fail)) {
        fail();
      }
      _MDSnackbarView["default"].show(BabelStr.str(309)); // ('添加星标失败');
    });
  },
  addTag: function addTag() {
    var fileInfors = this.fileInfors;
    var addTagWin = new _MDAddTagBigWindow["default"]({
      fileInfos: fileInfors
    });
    addTagWin.show();
  },
  addAITag: function addAITag($btn) {
    var _this3 = this;
    var fileInfors = this.fileInfors;
    var showWarn = localStorage.getItem("add_ai_tag_warn_".concat(_app["default"].currentUser.getUserId()));
    if (!showWarn) {
      var win = new _MDAddAITagWinView["default"]({
        fileInfos: fileInfors,
        addCallback: function addCallback() {
          _this3._addAITag($btn);
        },
        toAddCallback: function toAddCallback() {
          _this3.addTag();
        }
      });
      win.show();
    } else {
      this._addAITag($btn);
    }
  },
  _addAITag: function _addAITag($btn) {
    var _this4 = this;
    var fileInfors = this.fileInfors;
    var error = function error(msg) {
      _MDMessageView["default"].error(msg || BabelStr.str(309));
      if ($btn) {
        $btn.removeClass("loading");
      } else {
        // MDLoadMaskView.remove();
      }
    };
    var fids = [];
    _.each(fileInfors, function (file) {
      if (file.canUseAITaginal()) {
        fids.push(file.getFileId());
      }
    });
    if ($btn) {
      $btn.addClass("loading");
    } else {
      // MDLoadMaskView.show();
      _MDMessageView["default"].infor(BabelStr.str(12661));
    }
    _MMEnterpriseController["default"].aiAddtags(fids, function (content) {
      _MMNetDiskDataController["default"].getFileInfosFromServer(fids, false, function (files) {
        for (var i = 0; i < fileInfors.length; i++) {
          for (var j = 0; j < files.length; j++) {
            if (fileInfors[i].getFileId() == files[j].getFileId()) {
              var tagCollection = fileInfors[i].getTagCollection();
              tagCollection.reset();
              tagCollection.add(files[j].get("tags"));
            }
          }
        }
        // let tagCollection = this.fileInfor.getTagCollection();
        // tagCollection.add(file.get("tags"))
        if ($btn) {
          $btn.removeClass("loading");
        } else {
          // MDLoadMaskView.remove();
        }
        _MDMessageView["default"].success(BabelStr.str(308), _this4.$body);
      }, error);
    }, function (err) {
      error(err);
    });
  },
  focusFile: function focusFile() {
    var fileInfor = this.fileInfors[0];
    var focusWin = new _MDFocusFileWinView["default"]({
      fileInfo: function fileInfo() {
        return fileInfor;
      }
    });
    focusWin.show();
  },
  renameFile: function renameFile(opt) {
    var fileInfor = this.fileInfors[0];
    if (!this.canRename()) {
      // this.showPerWinView({
      //   rename: true
      // });

      var win = new _MDApplicationRenamePerWinView["default"]({
        fileInfor: fileInfor
      });
      win.show();
      return;
    }
    var wind = new _MDRenameWindowView["default"]({
      fileInfor: fileInfor
    });
    wind.show();
  },
  batchRenameFile: function batchRenameFile(opt) {
    var wind = new _MDBatchRenameWinView["default"]({
      fileInfors: this.fileInfors
    });
    wind.show();
  },
  renameMultFile: function renameMultFile() {
    var fileInfor = this.fileInfors[0];
    var wind = new _MDRenameWindowView["default"]({
      fileInfor: fileInfor
    });
    wind.show();
  },
  closeShare: function closeShare() {
    var self = this;
    var alerView = new _MDAlertView["default"]();
    var fileInfors = this.fileInfors;
    var sure = BabelStr.str(3429); // 确定取消分享吗?
    var opt = {
      width: 490,
      message: '<p class="title">' + sure + "</p>",
      okFun: function okFun() {
        var fileIds = fileInfors.map(function (fileInfor) {
          return fileInfor.getFileId();
        });
        _MDLoadMaskView["default"].show(undefined, {
          bodyMsg: BabelStr.str(22055),
          noClose: true
        });
        _MMEnterpriseController["default"].closeShare(fileIds, function () {
          _MDLoadMaskView["default"].remove();
          _.each(fileInfors, function (fileInfor) {
            fileInfor.collection.remove(fileInfor);
          });
          _MDSnackbarView["default"].show(BabelStr.str(308));
        }, function (code) {
          _MDLoadMaskView["default"].remove();
          _MDSnackbarView["default"].show(BabelStr.str(309), {
            code: code
          }); //("取消分享失败，请稍后重试");
        });
      }
    };
    _MDAlertView["default"].showStandardSelection(opt);
  },
  removeStarMark: function removeStarMark(success, fail) {
    var fileInfors = this.fileInfors;
    var fileIds = _.map(fileInfors, function (fileInfor) {
      return fileInfor.getFileId();
    });
    _MMNetDiskDataController["default"].removeStarmarkFile(fileIds, function () {
      _.each(fileInfors, function (fileInfor) {
        fileInfor.set("starmark", 0);
      });
      _Dispatcher["default"].trigger(_MDEvents["default"].StarmarkChanged);
      if (_.isFunction(success)) {
        success();
      }
      _MDSnackbarView["default"].show(BabelStr.str(308)); // ('删除星标成功');
    }, function () {
      if (_.isFunction(fail)) {
        fail();
      }
      _MDSnackbarView["default"].show(BabelStr.str(309)); // ('删除星标失败');
    });
  },
  shareFile: function shareFile() {
    var fileId = this.fileInfors[0].getFileId();
    var shareWin = new _MDShareFileWindowView["default"]({
      fileInfor: this.fileInfors[0]
    });
    shareWin.show();
  },
  snapshotLinkShareFile: function snapshotLinkShareFile(callback) {
    var _this5 = this;
    var fileId = this.fileInfors[0].getFileId();
    _MMNetDiskDataController["default"].canCurrentUserManageShare(fileId, function () {
      var shareWin = new _MDSnapshotLinkFileWindowView["default"]({
        fileInfor: _this5.fileInfors[0]
      });
      shareWin.show();
      callback && callback(true);
    }, function () {
      var message = BabelStr.str(21302);
      _MDAlertView["default"].showStandardPrompt({
        message: "<p>" + message + "</p>",
        width: 400,
        okFun: function okFun() {}
      });
      callback && callback(false);
    });
  },
  createFolder: function createFolder() {
    var win = new _MDCreateFolderWindowView["default"]();
    win.show();
  },
  createEncryptedFolder: function createEncryptedFolder() {
    var win = new _MDcreateEncryptedFolderWindowView["default"]();
    win.show();
  },
  createSubDepartment: function createSubDepartment() {
    var win = new _MDCreateFolderWindowView["default"]({
      createDep: true
    });
    win.show();
  },
  clearFileVersionUnreadMark: function clearFileVersionUnreadMark() {
    _MMNetDiskDataController["default"].clearFilesUnreadMarks(this.fileInfors, function () {
      _Dispatcher["default"].trigger(_MDEvents["default"].UpdateChannleUnreadNum);
    });
  },
  openOriginFolder: function openOriginFolder() {
    var fileInfor = this.fileInfors[0];
    var linkedFileId = fileInfor.getShortCutsTargetFileId();
    _MMNetDiskDataController["default"].getFileInfoFromServerWithoutTrash(linkedFileId, function succeess(fileInfor) {
      var folderId = fileInfor.getParentFolderId();
      var path;
      if (fileInfor.isArchived()) {
        path = "/archive.do#archive/" + folderId;
        _app["default"].pathRouter.openNetTab(path);
      } else {
        _app["default"].pathRouter.openFileByIdWithOutChannel(folderId);

        // path = '/file/' + folderId;
        // if (folderId == 0) {
        //   path = '';
        // }
        // app.pathRouter.navigate(path, { trigger: true });
      }
    }, function fail(errCode, errMsg) {
      if (errCode == _MMNetDiskDataController["default"].code.ERROR_FILE_ACCESS_DENIED) {
        _MDSnackbarView["default"].show(_MDLocalString["default"].getLocalString(151));
      } else if (errCode == _MMNetDiskDataController["default"].code.ERROR_FILE_NOT_FOUND) {
        _MDSnackbarView["default"].show(errMsg);
      }
    });
  },
  createMsBox: function createMsBox(fileInfo) {
    if (_app["default"].isEpVersion()) {
      if (_app["default"].currentUser.get("hasSecret")) {
        var _win = new _MDManuscriptBoxView["default"]({
          fileInfo: fileInfo
        });
        _win.show();
      } else {
        var win = new _MDMsBoxCreateSelectWinView["default"]({
          fileInfo: fileInfo
        });
        win.show();
      }
    } else {
      _MDAlertView["default"].showAlert(BabelStr.str(198)); //("个人版不支持文件收集箱，请升级到企业版！");
    }
  },
  manageMsBox: function manageMsBox() {
    var fileInfo = this.fileInfors[0];
    if (fileInfo.isMsAnonyBox()) {
      var _win2 = new _MDMsAnonyBoxTabWinView["default"]({
        fileInfo: fileInfo,
        curIndex: 1
      });
      _win2.show();
    } else {
      var win = new _MDManuscriptBoxView["default"]({
        fileInfo: fileInfo
      });
      win.show();
    }
  },
  createEntBC: function createEntBC(initFiles) {
    if (_app["default"].isEpVersion()) {
      var win = new _MDNewEntBroadcastView["default"]({
        createBC: true
      });
      if (initFiles) {
        win.setFileInfors(this.fileInfors);
      }
      win.show();
    }
  },
  canEditReadingRoom: function canEditReadingRoom() {
    var fileInfo = this.fileInfors[0];
    if (fileInfo.isReadingRoom() && fileInfo.canArchive()) {
      return true;
    }
    return false;
  },
  editReadingRoom: function editReadingRoom() {
    var _this6 = this;
    var fileInfo = this.fileInfors[0];
    var readingScopes = fileInfo.get("readingScopes");
    var win = new _MDArchiveReadingRoomCreateWinView["default"]({
      readingScopes: readingScopes,
      edit: true,
      fileInfor: fileInfo,
      refreshReadingRoomScope: function refreshReadingRoomScope() {
        _this6.getReadingRoomScope(fileInfo);
      }
    });
    win.show();
  },
  getReadingRoomScope: function getReadingRoomScope(fileInfo) {
    if (!fileInfo.isReadingRoom()) {
      return;
    }
    fileInfo.unset("readingScopes", {
      silent: true
    });
    _MMEnterpriseController["default"].getReadingRoomScope(fileInfo.getFileId(), function (result) {
      fileInfo.set("readingScopes", result);
    }, function () {});
  },
  showManageDepPopUp: function showManageDepPopUp($e) {
    var fileInfo = this.fileInfors[0];
    _MDShareJumpOption["default"].show($e.currentTarget, fileInfo);
  },
  manageDepMember: function manageDepMember() {
    var fileInfo = this.fileInfors[0];
    if (!fileInfo.get("departmentId")) {
      _MDAlertView["default"].showStandardPrompt({
        message: BabelStr.str(20163)
      });
      return;
    }
    // if(!app.pathRouter.inDepartment()){
    viewManager.get("mainPanelView").dispDepManager(fileInfo.get("departmentId"), fileInfo.getFileName(), fileInfo.getFileId(), fileInfo);
    // }else{
    //   var departId = fileInfo.get('departmentId');
    //   var departName = fileInfo.getFileName();
    //   var serveForSingleDep = !app.currentUser.isEpAdminUser() && fileInfo.canManageDepMember();
    //   var rootNavigationPageView = new MEStaffNavigationPageView({
    //     departId: departId,
    //     departName: departName,
    //     serveForSingleDep: serveForSingleDep
    //   });
    //   var mainView = viewManager.get("mainPanelView");
    //   mainView.navigationView.push(rootNavigationPageView);
    // }
  },
  manageDepInfo: function manageDepInfo() {
    var fileInfo = this.fileInfors[0];
    viewManager.get("mainPanelView").dispDepManageInfo(fileInfo.get("departmentId"), fileInfo.getFileName(), fileInfo.getFileId(), fileInfo);
  },
  showTransmittalList: function showTransmittalList() {
    var fileInfo = this.fileInfors[0];
    viewManager.get("mainPanelView").navToTransmittalList(fileInfo.get("departmentId"), fileInfo.getFileName(), fileInfo.getFileId(), fileInfo);
  },
  manageHQSMProject: function manageHQSMProject(file) {
    // var width = 710;
    // if (MDLocalString.getCurrentLanguage() != 'cn') {
    //   width = 720
    // }
    var win = new _MDHQSMManageNavWinView["default"]({
      fileInfor: file
    });
    win.show();
  },
  showUserStatisticsWin: function showUserStatisticsWin() {
    // let win = new MDShowUsersStatisticsWinView({
    //   fileInfor: this.fileInfors[0]
    // });
    // win.show()
    var win = new _MDFileOpStatisitcsWindow["default"]({
      fileInfor: this.fileInfors[0]
    });
    win.show();
  },
  bantchCancelFileShare: function bantchCancelFileShare() {
    var self = this;
    var alerView = new _MDAlertView["default"]();
    var fileInfors = this.fileInfors;
    var sure = BabelStr.str(681); // 确定取消分享吗?
    var tip = BabelStr.str(682); // 提示:取消分享后，分享链接将失效。
    var opt = {
      width: 490,
      message: '<p class="title">' + sure + '</p><p class="help-block">' + tip + "</p>",
      okFun: function okFun() {
        var fileIds = fileInfors.map(function (fileInfor) {
          return fileInfor.getFileId();
        });
        _MMNetDiskDataController["default"].closeMultipleShareLink(fileIds, function () {
          _.each(fileInfors, function (fileInfor) {
            fileInfor.collection.remove(fileInfor);
          });
        }, function () {
          _MDSnackbarView["default"].show(BabelStr.str(309)); //("取消分享失败，请稍后重试");
        });
      }
    };
    _MDAlertView["default"].showStandardSelection(opt);
  },
  openShare: function openShare() {
    var fileInfor = this.fileInfors[0];
    // var wind = new MDShareFileSettingWindowView({
    //         fileInfor:fileInfor
    //     });
    //     wind.show();
    var wind = new _MDShareFileWindowView["default"]({
      fileInfor: fileInfor
    });
    wind.show();
  },
  /**
   * 打开父文件夹  （搜索结果使用）
   */
  openParent: function openParent() {
    var fileInfor = this.fileInfors[0];
    if (!fileInfor) {
      return;
    }
    if (fileInfor.isDeletedOrgin()) {
      var path = "trash";
      if (fileInfor.get("extraStatus") & 64) {
        path = "trash/index/3";
      } else if (fileInfor.get("deleteByUserId") != _app["default"].currentUser.getUserId()) {
        path = "trash/index/2";
      }
      _app["default"].pathRouter.openNetTab("/main.do#" + path);
      return;
    }
    var parentId = fileInfor.getParentFolderId();
    // app.pathRouter.openFileByIdWithOutChannel(parentId)
    // // Dispatcher.trigger(MDEvents.OpenFile, { fileId: parentId });
    // Dispatcher.trigger(MDEvents.OpenFolderFromOtherChannel, { fileId: parentId, fileInfo: fileInfor })
    _app["default"].pathRouter.openNewTabByFileId(parentId);
  },
  lockFile: function lockFile() {
    var fileInfo = this.fileInfors[0];
    var opt = {
      width: 490,
      message: BabelStr.str(683),
      //  锁定文件将只允许自己上传新版本,
      okFun: function okFun() {
        _MMNetDiskDataController["default"].lockFile(fileInfo.getFileId(), function (user) {
          if (user["id"] == _app["default"].currentUser.getUserId()) {
            _MDSnackbarView["default"].show(BabelStr.str(308)); //('锁定成功')
          } else {
            _MDSnackbarView["default"].show(BabelStr.str(684)); //('锁定失败，已被他人锁定')
          }
          fileInfo.setFileLockUser(user["id"], user["name"]);
        }, function () {
          _MDSnackbarView["default"].show(BabelStr.str(309)); //('锁定失败')
        });
      }
    };
    _MDAlertView["default"].showStandardSelection(opt);
  },
  unlockFile: function unlockFile(fileInfo) {
    var fileInfo = this.fileInfors ? this.fileInfors[0] : fileInfo;
    _MMNetDiskDataController["default"].unlockFile(fileInfo.getFileId(), function (user) {
      _MDSnackbarView["default"].show(BabelStr.str(308)); //('解锁成功')
      fileInfo.setFileLockUser(0, "");
    }, function (code, msg) {
      if (code == 142) {
        _MDSnackbarView["default"].show(BabelStr.str(21404)); //('被他人锁定')
      } else {
        _MDSnackbarView["default"].show(msg); //('解锁失败')
      }
    });
  },
  /**
   * 恢复文件，删除后使用
   */
  restoreFile: function restoreFile(opt) {
    var self = this;
    opt = _.extend({
      success: _.noop,
      fail: _.noop
    }, opt);
    var fileIds = [];
    var trashCollection = this.fileInfors[0].collection;
    var deleteInfos = this.fileInfors.slice();
    var fidArr = [];
    var deleteVersionIds = [];
    var sortedFileInfos = this.fileInfors.slice();
    // 文件排序，先恢复父再恢复子
    for (var i = 0; i < sortedFileInfos.length - 1; i++) {
      var f0 = sortedFileInfos[i];
      for (var j = i + 1; j < sortedFileInfos.length; j++) {
        var f1 = sortedFileInfos[j];
        if (f0.get("path").indexOf(f1.get("path")) > 0) {
          sortedFileInfos[i] = f1;
          sortedFileInfos[j] = f0;
          f0 = f1;
        }
      }
    }
    _.each(sortedFileInfos, function (fileInfo) {
      if (fileInfo.get("deleteVersionId")) {
        deleteVersionIds.push(fileInfo.get("deleteVersionId"));
      } else {
        fidArr.push(fileInfo.getFileId());
      }
    });
    _MDSnackbarView["default"].show(BabelStr.str(685)); //('文件恢复中...');
    _MDLoadMaskView["default"].show(undefined, {
      bodyMsg: BabelStr.str(685) + "...",
      noClose: true
    });
    var trashType = "myTrash"; //myTrash, commonOther, entOther, entRoot
    var type = viewManager.viewList.curFileTableView.getType();
    if (type == 2) {
      if (_app["default"].isEpVersion()) {
        trashType = "entOther";
      } else {
        trashType = "commonOther";
      }
    } else if (type == 3) {
      trashType = "entRoot";
    }
    _MMEnterpriseController["default"].restoreSelectedFilesInTrash(deleteVersionIds, fidArr, trashType, function success() {
      _MDLoadMaskView["default"].remove();
      var toRemove = [];
      trashCollection.forEach(function (fileInfo) {
        if (fileInfo && (_.indexOf(deleteVersionIds, fileInfo.get("deleteVersionId")) !== -1 || _.indexOf(fidArr, fileInfo.get("fileId")) !== -1)) {
          toRemove.push(fileInfo);
        }
      });
      // trashCollection.remove(toRemove);
      _Dispatcher["default"].trigger(_MDEvents["default"].trashRemove, toRemove);
      _MDSnackbarView["default"].show(BabelStr.str(686)); //("文件已经恢复至原处");
      _MDNetDriveFileHandler["default"]._notifyFormbricksSurveyState(sortedFileInfos.map(function (fileInfo) {
        return fileInfo.getFileId();
      }), "restore");
      opt.success();
    }, function fail(code, msg, errorList, finished) {
      _MDLoadMaskView["default"].remove();
      var message = msg;
      deleteInfos.forEach(function (deleteInfo) {
        var fid = deleteInfo.get("fileId");
        var error = _.findWhere(errorList, {
          fid: fid
        });
        var removed = false;
        if (finished) {
          for (var _i = 0; _i < finished.length; _i++) {
            var _id = finished[_i];
            if (_id == fid) {
              removed = true;
            }
          }
        }
        if (error) {} else if (removed) {
          trashCollection.remove(deleteInfo);
          return;
        }
        if (error && error.code === _MMNetDiskDataController["default"].code.ERROR_PARENT_STILL_IN_TRASH) {
          var msg = JSON.parse(error.msg);
          if (!msg) {}
          var parentInfo = trashCollection.find({
            fileId: msg["fileId"]
          });
          if (parentInfo) {
            var param = {
              folder: parentInfo.getFileName()
            };
            var tip = BabelStr.str(687, param); // "文件已经恢复, 但是其所在父文件夹 \"" + parentInfo.getFileName() + "\" 还在回收站中<br>"
            _MDSnackbarView["default"].show(tip, true);
          }
          trashCollection.remove(deleteInfo);
          return;
        } else if (error && error.code == _MMNetDiskDataController["default"].code.ERROR_DB_FILE_NOT_EXIST) {
          _MDSnackbarView["default"].show(BabelStr.str(688)); //("恢复失败，该文件的上级文件夹已经被永久删除");
        } else {
          _MDSnackbarView["default"].show(message);
        }
      });
      opt.fail();
    });
  },
  deleteFiles: function deleteFiles() {
    var self = this;
    var fileInfors = self.fileInfors;
    _MDFileOperationManager["default"].deleteFiles(fileInfors);
  },
  archiveFiles: function archiveFiles() {
    var self = this;
    var fileInfors = self.fileInfors;
    if (fileInfors.length == 0) {
      return;
    }
    if (!_app["default"].ep.canShowArchiveModel()) {
      var _opt = {
        message: BabelStr.str(6119)
      };
      _MDAlertView["default"].showStandardPrompt(_opt);
      return;
    }
    var parentId = fileInfors[0].getParentFolderId();
    var fileIds = [];
    for (var i = 0; i < fileInfors.length; i++) {
      var fileInfo = fileInfors[i];
      fileIds.push(fileInfo.getFileId());
    }
    var successCB = function successCB() {};
    var opt = {
      width: 490,
      message: BabelStr.str(759),
      //  	759: '文件归档后，将不允许修改和删除，文件只能到档案管理界面进行访问'
      okFun: function okFun() {
        self.selectClassification(function (classificationIds) {
          _MDLoadMaskView["default"].show(undefined, {
            bodyMsg: BabelStr.str(6315),
            noClose: true
          });
          _MDNetDriveFileHandler["default"].archiveFiles({
            fileIds: fileIds,
            classificationIds: classificationIds
          }, function (key) {
            if (key) {
              self._progressChanged(key, parentId, successCB);
            } else {
              successCB();
              _MDLoadMaskView["default"].remove();
              _MDSnackbarView["default"].show(BabelStr.str(308));
              _Dispatcher["default"].trigger(_MDEvents["default"].FileArchived, {
                folderId: parentId
              });
            }
          }, function () {
            _MDLoadMaskView["default"].remove();
            _MDSnackbarView["default"].show(BabelStr.str(309)); //("恢复失败，该文件的上级文件夹已经被永久删除");
          });
        });
      }
    };
    _MDAlertView["default"].showStandardSelection(opt);

    // var fileInfors = self.fileInfors;
    // MDFileOperationManager.archiveFiles(fileInfors);
  },
  selectClassification: function selectClassification(callback) {
    var win = new _MDClassificationSelectWinView["default"]({
      confirmCallback: callback,
      showNodeActions: true
    });
    win.show();
    return;
  },
  archiveLocalFiles: function archiveLocalFiles() {
    var self = this;
    var fileInfors = self.fileInfors;
    if (fileInfors.length == 0) {
      return;
    }
    if (!_app["default"].ep.canShowArchiveModel()) {
      var _opt2 = {
        message: BabelStr.str(6119)
      };
      _MDAlertView["default"].showStandardPrompt(_opt2);
      return;
    }
    var parentId = fileInfors[0].getParentFolderId();
    var fileIds = [];
    for (var i = 0; i < fileInfors.length; i++) {
      var fileInfo = fileInfors[i];
      fileIds.push(fileInfo.getFileId());
    }
    var opt = {
      width: 490,
      message: BabelStr.str(6805),
      //    759: '文件归档后，将不允许修改和删除，文件只能到档案管理界面进行访问'
      okFun: function okFun() {
        _MDLoadMaskView["default"].show(undefined, {
          bodyMsg: BabelStr.str(6315),
          noClose: true
        });
        _MDNetDriveFileHandler["default"].localArchiveFile(fileIds, function (key) {
          for (var _i2 = 0; _i2 < fileInfors.length; _i2++) {
            var fileInfo = fileInfors[_i2];
            fileInfo.setLocalArchived();
          }
          if (key) {
            self._progressChanged(key, parentId);
          } else {
            _MDLoadMaskView["default"].remove();
            _MDSnackbarView["default"].show(BabelStr.str(308));
            // Dispatcher.trigger(MDEvents.FileArchived, { folderId: parentId})
          }
        }, function () {
          _MDLoadMaskView["default"].remove();
          _MDSnackbarView["default"].show(BabelStr.str(309)); //("恢复失败，该文件的上级文件夹已经被永久删除");
        });
      }
    };
    _MDAlertView["default"].showStandardSelection(opt);

    // var fileInfors = self.fileInfors;
    // MDFileOperationManager.archiveFiles(fileInfors);
  },
  _progressChanged: function _progressChanged(key, parentId, callback) {
    var _this7 = this;
    _MMEnterpriseController["default"].getProgressInfo(key, function (completed, total) {
      var progress = completed / total;
      if (progress < 1) {
        setTimeout(function () {
          _this7._progressChanged(key, parentId);
        }, 400);
      } else {
        setTimeout(function () {
          callback && callback();
          _MDLoadMaskView["default"].remove();
          _MDSnackbarView["default"].show(BabelStr.str(308));
          _Dispatcher["default"].trigger(_MDEvents["default"].FileArchived, {
            folderId: parentId
          });
        }, 400);
      }
    });
  },
  showDeplimitWin: function showDeplimitWin() {
    var win = new _MEDepartMemberDownLimitWinView["default"]({
      fileInfor: this.fileInfors[0]
    });
    win.show();
  },
  translateProject: function translateProject() {
    var fileInfor = this.fileInfors[0];
    var win = new _MDProjectCreateWinView["default"]({
      type: 2,
      fileId: fileInfor.getFileId()
    });
    win.show();
  },
  openUploadWindow: function openUploadWindow() {
    _MDLocalFileCollector["default"].openFileFinderWindow();
  },
  openUploadFolderWindow: function openUploadFolderWindow() {
    _MDLocalFileCollector["default"].openFileFinderWindow(null, true);
  },
  deleteForever: function deleteForever(onSuccess, onFail) {
    var self = this;
    var alertView = new _MDAlertView["default"]();
    var collection = self.fileInfors[0].collection;
    var fileInfors = self.fileInfors.slice();
    var sure = BabelStr.str(689); // 文件删除后将无法恢复,确定要删除吗?
    var tip = BabelStr.str(380); // 警告:此行为无法撤销!
    var param = {
      message: '<p class="title">' + sure + '</p><span class="help-block emphasize">' + tip + "</span>",
      okFun: function okFun() {
        var fidArr = [];
        var deleteVersionIds = [];
        _.each(fileInfors, function (fileInfo) {
          if (fileInfo.get("deleteVersionId")) {
            deleteVersionIds.push(fileInfo.get("deleteVersionId"));
          } else {
            fidArr.push(fileInfo.getFileId());
          }
        });
        _MDSnackbarView["default"].show(BabelStr.str(690)); // ('文件删除中');
        _MDLoadMaskView["default"].show(undefined, {
          bodyMsg: BabelStr.str(257) + "...",
          noClose: true
        });
        var request = _MMNetDiskDataController["default"].deleteFilesInTrash;
        try {
          var type = viewManager.viewList.curFileTableView.getType();
          if (type == 3) {
            request = _MMNetDiskDataController["default"].deleteEntFileInTrash;
          }
        } catch (error) {
          console.error(error);
        }
        request({
          deleteVersionIds: deleteVersionIds,
          fidArr: fidArr
        }, function () {
          _MDLoadMaskView["default"].remove();
          // collection.remove(fileInfors);
          viewManager.viewList.curFileTableView.requestFolder(_app["default"].pathRouter.getCurrentFolder());
          // viewManager.viewList.curFileTableView.triggerRowSelected()
          _MDSnackbarView["default"].show(BabelStr.str(308)); // ('文件已彻底删除');
          _.isFunction(onSuccess) && onSuccess();
        }, function (errCode, errMsg) {
          _MDLoadMaskView["default"].remove();
          _MDSnackbarView["default"].show(errMsg),
          // ('文件删除失败,请稍后重试。错误码：'+errCode);
          _.isFunction(onFail) && onFail();
        });
      }
    };
    _MDAlertView["default"].showDangerSelection(param);
  },
  /**
   * 显示可预览文件
   */
  openFileInEditor: function openFileInEditor(fileInfor, isHomeTableRow, openInOtherChannel) {
    // Dispatcher.trigger(MDEvents.OpenFile, { fileId: fileInfor.get("fileId"), fileInfo: fileInfor });
    // return;
    var self = this;
    if (fileInfor && _.isFunction(fileInfor.isSurveyFile) && fileInfor.isSurveyFile()) {
      if (!_.isFunction(fileInfor.canRead) || !fileInfor.canRead()) {
        return;
      }
      this.openSurveyPreview(fileInfor);
      return;
    }
    var isLinkfile = false;
    if (!openInOtherChannel) {
      _Dispatcher["default"].trigger(_MDEvents["default"].OpenFile, {
        fileId: fileInfor.getFileId(),
        fileInfo: fileInfor
      });
    } else {
      _MMFileInfo["default"].prepareLinkedFileInfo(fileInfor, function () {
        var targetFile = fileInfor;
        if (targetFile.isShortcuts()) {
          targetFile = targetFile.getShortCutsTargetFile();
          isLinkfile = true;
        }
        if (targetFile.isArchived() && !_app["default"].ep.isArchive()) {
          //非档案频道打开档案文件
          if (_app["default"].ep.canShowArchiveModel()) {
            var opt = {
              width: 490,
              message: BabelStr.str(762),
              //    你要查看的是归档文件，需要到档案库去查看，点击确定转到档案库
              okFun: function okFun() {
                _app["default"].pathRouter.openNetTab("/archive.do#archive/" + targetFile.getFileId());
              }
            };
            _MDAlertView["default"].showStandardSelection(opt);
          } else {
            var opt = {
              message: BabelStr.str(6119)
            };
            _MDAlertView["default"].showStandardPrompt(opt);
          }
        } else if (targetFile.isArchiveHouse) {
          _app["default"].pathRouter.openNetTab("/archive.do");
        } else if (isLinkfile) {
          _app["default"].pathRouter.openNewTabByFileId(fileInfor.getFileId());
        } else if (!targetFile.isFolder()) {
          var $mask = $('<div class="editor-mask"><div>');
          // $('body').append($mask);

          _.delay(function () {
            if (_app["default"].isMobile()) {
              var displayController = new _MDMDisplayFileController["default"]();
              displayController.openFiles4Mobile({}, fileInfor, undefined, function () {}, function () {});
            } else {
              var fid = fileInfor.getFileId();
              _MMCommonFun["default"].getOpenPath(fid, undefined, function (path, channel) {
                if (channel == _app["default"].pathRouter.curChannel) {
                  _Dispatcher["default"].trigger(_MDEvents["default"].OpenFile, {
                    fileId: fileInfor.getFileId(),
                    fileInfo: fileInfor
                  });
                } else {
                  _app["default"].pathRouter.navigateToPath(path);
                }
              });
            }
          });
        } else {
          var fid = fileInfor.getFileId();
          _MMCommonFun["default"].getOpenPath(fid, undefined, function (path, channel) {
            if (channel == _app["default"].pathRouter.curChannel) {
              _Dispatcher["default"].trigger(_MDEvents["default"].OpenFile, {
                fileId: fileInfor.getFileId(),
                fileInfo: fileInfor
              });
            } else {
              _app["default"].pathRouter.navigateToPath(path);
            }
          });

          // app.pathRouter.openFileByIdWithOutChannel(fid,()=>{

          // })
          // if(fileInfor.isOwner()) {
          //    app.pathRouter.navigateToPath(`personfile/${fid}`)
          // } else {
          //   app.pathRouter.navigateToPath(`epfile/${fid}`)
          // }

          // Dispatcher.trigger(MDEvents.OpenFolderFromOtherChannel, { fileId: fileInfor.get("fileId"), fileInfo: fileInfor });
        }
      });
    }
  },
  /**
   * 编辑文件 在线编辑/本地编辑
   */
  editFile: function editFile(ver, onSuccess, file) {
    var isClient = _app["default"].isInClient();
    var self = this;
    var fileInfo = this.fileInfors ? this.fileInfors[0] : file;
    if (fileInfo && isClient) {
      this.lockedByMe = false;
      this._chek4Client(fileInfo, function () {
        _MMNetDiskDataController["default"].lockFile(fileInfo.getFileId(), function (user) {
          _MMNetDiskDataController["default"].getFileInfoFromServer(fileInfo.getFileId(), function (file) {
            fileInfo.setCurVersion(file.getCurVersion(), file);
            console.log(fileInfo);
            if (user["id"] == _app["default"].currentUser.getUserId()) {
              _MDSnackbarView["default"].show(BabelStr.str(691)); // ('加锁成功')
              _MMNetDiskDataController["default"].clearFileVersionUnreadMark(fileInfo, null, function () {
                fileInfo.clearUnReadCount();
              }, function () {});
              self.lockedByMe = true;
              if (!isClient) {
                self.editor.editFile(fileInfo, ver);
              } else {
                self._editFileInClient(true);
              }
            } else {
              var alert = new _MDAlertView["default"]();
              var z_startIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
              $(alert.el).css("z-index", z_startIndex);
              var userName = user["name"];
              var param = {
                userName: userName
              };
              var title = BabelStr.str(692, param); //  "文件已被其他人锁定，您不能编辑！"
              alert.show({
                title: BabelStr.str(170),
                //  '提示',
                message: '<p class="title">' + title + "</p>",
                className: "m-delAlertWin",
                buttons: [{
                  label: BabelStr.str(154),
                  // '确定',
                  type: "done",
                  onClick: function onClick() {
                    if (!isClient) {
                      self.editor.close(true);
                    } else {
                      self._editFileInClient(false);
                    }
                  }
                }]
              });
            }
            fileInfo.setFileLockUser(user["id"], user["name"]);
          }, function () {});
        }, function (code) {
          var alert = new _MDAlertView["default"]();
          var z_startIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
          $(alert.el).css("z-index", z_startIndex);
          var title = BabelStr.str(5073) + code;
          alert.show({
            title: BabelStr.str(170),
            //  '提示',
            message: '<p class="title">' + title + "</p>",
            className: "m-delAlertWin",
            buttons: [{
              label: BabelStr.str(154),
              // '确定',
              type: "done",
              onClick: function onClick() {
                self.editor && self.editor.close();
              }
            }]
          });
        });
      });
    }
  },
  onlineEditFile: function onlineEditFile(ver, onSuccess, file) {
    var isClient = _app["default"].isInClient();
    var self = this;
    var fileInfo = this.fileInfors ? this.fileInfors[0] : file;
    if (!fileInfo) {
      return;
    }
    // if(!app.isEpVersion() && app.currentUser.inFreeEdition() && !fileInfo.canUseOnlyOffice()){
    //   MDAlertView.showAlert(BabelStr.str(827));
    //   return
    // }
    function edit() {
      _MMFileInfo["default"].prepareLinkedFileInfo(fileInfo, function (file) {
        if (fileInfo.isShortcuts()) {
          fileInfo = file;
          if (!fileInfo.canUploadVersionIgnoreLocked()) {
            var opt = {
              message: BabelStr.str(6807)
            };
            _MDAlertView["default"].showStandardPrompt(opt);
            return;
          }
        }
        if (fileInfo && _.isFunction(fileInfo.isSurveyFile) && fileInfo.isSurveyFile()) {
          if (!_.isFunction(fileInfo.canRead) || !fileInfo.canRead()) {
            return;
          }
          if (!_.isFunction(fileInfo.canUploadVersionIgnoreLocked) || !fileInfo.canUploadVersionIgnoreLocked()) {
            return;
          }
          self.openSurveyEdit(fileInfo, onSuccess);
        } else if (fileInfo && fileInfo.isMDFile()) {
          _MDTextEditorController["default"].initEditorWithFileInfo(fileInfo);
        } else if (fileInfo && fileInfo.canDispWithKityMinder()) {
          _MDKityMinderEditorController["default"].initEditorWithFileInfo(fileInfo, ver, onSuccess);
        } else if (fileInfo && fileInfo.isBabelOffice()) {
          _MDTiptapEditorControllerJs["default"].editBabelOfficeFile(fileInfo);
        } else if (fileInfo && fileInfo.isDrawio()) {
          _MDDrawioEditorController["default"].openFile(fileInfo, ver, onSuccess);
        } else if (fileInfo && (fileInfo.isOfficeFile() || fileInfo.isPdf())) {
          // if(!isClient) {
          if (window.canUseOnlyOffice || true) {
            // --------- demo 企业才可用 --> ep.id == 172
            // if (ep) { // --------- demo 企业才可用 --> ep.id == 172
            // if (fileInfo.hasPassword()) {
            //   var opt = {
            //     message: BabelStr.str(6223),
            //   };
            //   MDAlertView.showStandardPrompt(opt);
            // } else {
            // var editor = new MDOnlyOfficeEditor();
            // editor.editFile(fileInfo, ver);
            // window.open("/netdrive/openFileByBabelOffice.do?fileId=" + fileInfo.getFileId());

            var url = '/netdrive/getOnlyOfficeFileEditUrl.do';
            var postData = {};
            postData['fileId'] = fileInfo.getFileId();
            postData['version'] = fileInfo.getCurVersion();
            $.ajax({
              method: 'post',
              url: url,
              data: postData,
              success: function success(responseData, textStatus, jqXHR) {
                if (responseData["code"] == 851) {
                  var message = BabelStr.str(12117);
                  _MDAlertView["default"].showStandardPrompt({
                    message: "<p>" + message + "</p>",
                    width: 400,
                    okFun: function okFun() {}
                  });
                } else {
                  _MMCommonFun["default"].openOffice2Edit(fileInfo.getFileId());
                }
              }
            });

            // }
          } else {
            var downloadWin = new _MDClientDownloadWinView["default"]({
              forOffice: true
            });
            downloadWin.show();
          }
          return;
          // }
        } else if (fileInfo && fileInfo.canEditWithTextEditer()) {
          _MDTextEditorController["default"].initEditorWithFileInfo(fileInfo);
        }
      });
    }
    if (fileInfo.isBabelOffice()) {
      _MMEnterpriseController["default"].canUploadFileVersion(fileInfo.getFileId(), function (res) {
        edit();
      }, function (err) {
        _MDSnackbarView["default"].show(err.msg);
      });
    } else if (fileInfo.isBannedFile()) {
      _MMEnterpriseController["default"].getEntBannedWordsStrategy(function (strategy) {
        if (strategy & 2) {
          _MDAlertView["default"].showAlert(BabelStr.str(28248));
        } else {
          edit();
        }
      }, function () {
        edit();
      });
    } else {
      edit();
    }
  },
  _chek4Client: function _chek4Client(fileInfo, callback) {
    var isClient = _app["default"].isInClient();
    if (isClient && fileInfo.isOfficeFile()) {
      var url = "/netdrive/docOpenedByOnlyOffice.do";

      // /netdrive/isDocEditedByOnlyOffice.do 表示文件被 onlyoffice 修改了
      var postData = {
        fileId: fileInfo.getFileId()
      };
      $.ajax({
        method: "post",
        url: url,
        data: postData,
        success: function success(responseData, textStatus, jqXHR) {
          if (responseData["success"] === true) {
            var isOpenning = responseData["isOpenning"];
            if (isOpenning) {
              _MDAlertView["default"].showStandardPrompt({
                message: BabelStr.str(7217)
              });
            } else {
              callback();
            }
          } else {
            _MDAlertView["default"].showStandardPrompt({
              message: BabelStr.str(7218)
            });
          }
        }
      });
    } else {
      callback();
    }
  },
  /**
   * 客户端文件同步
   */
  synchronize: function synchronize(isSynced) {
    var self = this;
    var folder = this.fileInfors[0];
    if (!folder.isFolder()) {
      return;
    }
    //  文件夹同步的代码...
    if (_app["default"].currentUser.isCloseSync()) {
      _MDAlertView["default"].showStandardPrompt({
        message: BabelStr.str(40075)
      });
      return;
    }
    if (_app["default"].isInClient()) {
      var electron = window["ElectronRequire"]("electron");
      var ipc = electron.ipcRenderer;
      var folderInfo = folder.toJSON();
      folderInfo.isSynced = isSynced;
      if (isSynced) {
        var alert = new _MDAlertView["default"]();
        alert.show({
          title: BabelStr.str(170),
          //  '提示',
          message: BabelStr.str(4731),
          buttons: [{
            label: BabelStr.str(154),
            // '确定',
            type: "done",
            onClick: function onClick() {
              electron.remote.require("./utils/cppAPI").createSync(folderInfo, function () {
                _Dispatcher["default"].trigger(_MDEvents["default"].FileSyncStateChanged, folder.getFileId(), self);
              });
            }
          }, {
            label: BabelStr.str(3081) // '确定',
          }]
        });
      } else {
        var win = new _MDClientSyncSelectWinView["default"]({
          onSave: function onSave(type) {
            folderInfo.syncType = type;
            electron.remote.require("./utils/cppAPI").createSync(folderInfo, function () {
              _Dispatcher["default"].trigger(_MDEvents["default"].FileSyncStateChanged, folder.getFileId(), self);
            });
            //ipc.send('createSync', folderInfo);
          }
        });
        win.show();
      }
    } else {
      var downloadWin = new _MDClientDownloadWinView["default"]();
      downloadWin.show();
    }
  },
  clearChche: function clearChche() {
    var electron = window["ElectronRequire"]("electron");
    var file = this.fileInfors[0];
    electron.remote.require("./utils/cppAPI").clearCacheItem(file.getFileId(), function () {
      // Dispatcher.trigger(MDEvents.FileSyncStateChanged, folder.getFileId(), self);
    });
  },
  clearAllChche: function clearAllChche() {
    var electron = window["ElectronRequire"]("electron");
    electron.remote.require("./utils/cppAPI").clearAllCacheItem(function () {
      // Dispatcher.trigger(MDEvents.FileSyncStateChanged, folder.getFileId(), self);
    });
  },
  _editFileInClient: function _editFileInClient(canEdit) {
    var self = this;
    var file = this.fileInfors[0];
    if (file.isFolder() || !file.canUploadVersion() || !canEdit) {
      return;
    }
    _MMNetDiskDataController["default"].addFileAccessUser(file.getFileId(), _app["default"].currentUser.getUserId());
    //  启动客户端程序编辑文件
    var electron = window["ElectronRequire"]("electron");
    var ffInfo = {
      fileId: file.getFileId(),
      fileName: file.getFileName(),
      currentVersion: file.getCurVersion(),
      parentId: file.getParentFolderId(),
      size: file.get("currentVersionSize") || 1
    };
    electron.remote.require("./utils/cppAPI").editFile(ffInfo, function (needRefresh) {
      //jiang:刷新页面-----上传新版本
      // if (needRefresh) {
      //     self._refreshFolder(app.currentFolder);
      // }
    });
  },
  /**
   * 打开本地文件
   */
  openLocalFolder: function openLocalFolder() {
    var self = this;
    var folder = this.fileInfors[0];
    if (!folder.isFolder()) {
      return;
    }
    var pathNameArr = [];
    var folderId = folder.getFileId();
    if (!folder.isFolderSynced() && _app["default"].pathRouter.isInSyncFolderPath()) {
      var pathArr = _app["default"].pathRouter.getFilePaths();
      for (var i = pathArr.length - 1; i > 0; i--) {
        //根目录不需要判断
        pathNameArr.push(pathArr[i].getFileName());
        if (pathArr[i].isFolderSynced()) {
          folderId = pathArr[i].getFileId();
          pathNameArr.unshift(folder.getFileName());
          break;
        }
      }
      if (i = 0) {
        return;
      }
    }
    console.error("-----------> mashixiong to do");
    var electron = window["ElectronRequire"]("electron");
    electron.remote.require("./utils/cppAPI").openLocal(folderId, pathNameArr);
  },
  // canLocalOPen: function() {
  //   var folder = this.fileInfors[0];
  //   return this.canDownload() || folder.isFolderSynced()
  // },

  readonlyOpen: function readonlyOpen() {
    var _this8 = this;
    if (this.opening) {
      return;
    }
    setTimeout(function () {
      _this8.opening = false;
    }, 400);
    this.opening = true;
    var cb = function cb() {
      // MDSnackbarView.show(BabelStr.str(27029))
    };
    var self = this;
    var fileInfo = self.fileInfors[0];
    _MMNetDiskDataController["default"].getFileInfoFromServer(fileInfo.getFileId(), function (file) {
      fileInfo.setCurVersion(file.getCurVersion(), file);
      console.log(fileInfo);
      var succeess = function succeess() {
        var ffInfo = {
          fileId: fileInfo.getFileId(),
          fileName: fileInfo.getFileName(),
          currentVersion: fileInfo.getCurVersion(),
          parentId: fileInfo.getParentFolderId(),
          size: fileInfo.get("currentVersionSize") || 1
        };
        var electron = window["ElectronRequire"]("electron");
        electron.remote.require("./utils/cppAPI").readonlyOpen(ffInfo);
      };
      _MMEnterpriseController["default"].needInputEncryptPassword(fileInfo.getFileId(), function (res) {
        if (res.needInput) {
          _MMEnterpriseController["default"].checkFilesSequentially(res.noPassFiles, function () {
            succeess();
          }, function () {
            cb();
          });
        } else {
          succeess();
        }
      }, function (code, msg) {
        cb();
      });
    }, function () {});
  },
  openLink: function openLink() {
    var url = this.fileInfors[0].getLinkFileUrl();
    if (_app["default"].isInClient()) {
      if (url.indexOf("https") == 0) {
        url = url.replace("https", "http"); // -------- 不止为啥 https 客户端打不开
      }
    }
    _app["default"].pathRouter.openNetTabWithoutHead(url);
  },
  openCompareWinView: function openCompareWinView() {
    var self = this;
    if (_app["default"].isInClient() && _app["default"].isClientHasCompareFun()) {
      var fileInfor = this.fileInfors[0];
      var compareView = new _MDFileCompareWinView["default"]({
        fileInfor: fileInfor
      });
      compareView.show();
    } else {
      var downloadWin = new _MDClientDownloadWinView["default"]();
      downloadWin.show();
    }
  },
  createOnlyOfficeWordFile: function createOnlyOfficeWordFile() {
    this._createOnlyOfficeFile("docx");
  },
  createOnlyOfficeExcelFile: function createOnlyOfficeExcelFile() {
    this._createOnlyOfficeFile("xlsx");
  },
  createOnlyOfficePPTFile: function createOnlyOfficePPTFile() {
    this._createOnlyOfficeFile("pptx");
  },
  _createOnlyOfficeFile: function _createOnlyOfficeFile(fileType) {
    var self = this;
    if (_app["default"].isInClient()) {
      return;
    }

    // if(!app.isEpVersion() && app.currentUser.inFreeEdition()){
    //   MDAlertView.showAlert(BabelStr.str(827));
    //   return
    // }

    var limitsObj;
    var inputFileNamePanel = new _MDInputFileNamePanel["default"]({
      saveFile: function saveFile(fileName) {
        fileName = fileName + "." + fileType;
        try {
          limitsObj = _app["default"].pathRouter.getLimitsInPath();
        } catch (e) {
          limitsObj = null;
        }
        var limits = limitsObj && limitsObj.limits;
        var name = limitsObj && limitsObj.name;
        var file = limitsObj && limitsObj.file;
        var type;
        if (_.isArray(limits) && limits[0]) {
          type = limits[0]["type"];
          _.each(limits, function (item) {
            item.stringLimit = item.stringLimit.toLocaleLowerCase();
          });
        }
        var limitsResult = _MMCommonFun["default"].validateFileType(fileName, limits);
        var message = "";
        if (!limitsResult) {
          var str = _.pluck(limits, "stringLimit").join(",");
          if (type == 1) {
            message = BabelStr.str(2873, {
              str: str,
              fileName: fileName,
              name: file.getFileName()
            });
            _MDAlertView["default"].showAlert(message);
            return;
          } else if (type == 2) {
            message = BabelStr.str(2874, {
              str: str,
              fileName: fileName,
              name: file.getFileName()
            });
            _MDAlertView["default"].showAlert(message);
            return;
          }
        }
        _MMEnterpriseController["default"].createOfficeFile(_app["default"].currentFolder.getFileId(), fileName, function (res) {
          // window.open("/netdrive/openFileByBabelOffice.do?fileId=" + res.fileId);
          _MMCommonFun["default"].openOffice2Edit(res.fileId);
        }, function (code, msg) {
          console.log("--------> code:" + code);
          if (code == _ErrorCode["default"].UploadFileTypeForbidden) {
            _MDSnackbarView["default"].show(BabelStr.str(20003));
          } else if (code == 20001) {
            _MDSnackbarView["default"].show(BabelStr.str(7506));
          } else {
            _MDSnackbarView["default"].show(msg);
          }
        });
        inputFileNamePanel.close();
      }
    });
    inputFileNamePanel.show();
  },
  createMindMap: function createMindMap(fileType) {
    var self = this;
    var limitsObj;
    var inputFileNamePanel = new _MDInputFileNamePanel["default"]({
      saveFile: function saveFile(fileName) {
        fileName = fileName + "." + fileType;
        try {
          limitsObj = _app["default"].pathRouter.getLimitsInPath();
        } catch (e) {
          limitsObj = null;
        }
        var limits = limitsObj && limitsObj.limits;
        var name = limitsObj && limitsObj.name;
        var file = limitsObj && limitsObj.file;
        var type;
        if (_.isArray(limits) && limits[0]) {
          type = limits[0]["type"];
          _.each(limits, function (item) {
            item.stringLimit = item.stringLimit.toLocaleLowerCase();
          });
        }
        var limitsResult = _MMCommonFun["default"].validateFileType(fileName, limits);
        var message = "";
        if (!limitsResult) {
          var str = _.pluck(limits, "stringLimit").join(",");
          if (type == 1) {
            message = BabelStr.str(2873, {
              str: str,
              fileName: fileName,
              name: file.getFileName()
            });
            _MDAlertView["default"].showAlert(message);
            return;
          } else if (type == 2) {
            message = BabelStr.str(2874, {
              str: str,
              fileName: fileName,
              name: file.getFileName()
            });
            _MDAlertView["default"].showAlert(message);
            return;
          }
        }
        _MMCommonFun["default"].openMindMap2Edit(res.fileId);
        inputFileNamePanel.close();
      }
    });
    inputFileNamePanel.show();
  },
  createTextFile: function createTextFile() {
    this._createFile(0);
  },
  createWordFile: function createWordFile() {
    this._createFile(1);
  },
  createExcelFile: function createExcelFile() {
    this._createFile(2);
  },
  createPPTFile: function createPPTFile() {
    this._createFile(3);
  },
  _createFile: function _createFile(fileType) {
    var self = this;
    if (!_app["default"].isInClient()) {
      return;
    }
    // if(!app.isEpVersion() && app.currentUser.inFreeEdition()){
    //   MDAlertView.showAlert(BabelStr.str(827));
    //   return
    // }
    var inputFileNamePanel = new _MDInputFileNamePanel["default"]({
      saveFile: function saveFile(fileName) {
        var ppFolder = {
          fileId: _app["default"].currentFolder.getFileId()
        };
        // ------- mashixiong to do
        var electron = window["ElectronRequire"]("electron");
        electron.remote.require("./utils/cppAPI").createFile(ppFolder, fileType, fileName, function (needRefresh) {
          if (needRefresh) {
            self._refreshFolder(_app["default"].currentFolder);
          }
        });
        inputFileNamePanel.close();
      }
    });
    inputFileNamePanel.show();
  },
  createBabelOffice: function createBabelOffice() {
    var self = this;
    var postData = {
      folderId: _app["default"].currentFolder.getFileId(),
      fileName: "file.sdoc",
      fileSize: 100
    };
    $.ajax({
      method: "post",
      url: "/file/filePreUpload.do",
      data: postData,
      success: function success(responseData, textStatus, jaXHR) {
        if (responseData.code == 0) {
          var inputFileNamePanel = new _MDInputFileNamePanel["default"]({
            saveFile: function saveFile(fileName) {
              var fileId = _app["default"].currentFolder.getFileId();
              _MDTiptapEditorControllerJs["default"].createBabelOfficeFile(fileId, fileName);
              // return
              // MMEnterpriseController.createBabelOffice(fileId, fileName, fileId=>{
              //   MDTiptapEditorController.editBabelOfficeFile();
              // })

              inputFileNamePanel.close();
            }
          });
          inputFileNamePanel.show();
        } else {
          if (responseData.code == 10002) {
            responseData.msg = BabelStr.str(20003);
          }
          _MDSnackbarView["default"].show(responseData.msg);
        }
      },
      fail: function fail(res) {
        console.log(res);
      }
    });
  },
  _refreshFolder: function _refreshFolder(fileInfo) {
    // 各频道的表格视图不一定有 reloadFolder，统一走操作管理器的守卫刷新
    return _MDFileOperationManager["default"].requestFolder(fileInfo);
  },
  apply2Read: function apply2Read() {
    this.apply2Borrow(0);
  },
  /**
   * 能否申请下载档案
   */
  canApplyDownload: function canApplyDownload() {
    var length = this.fileInfors.length;
    if (length > 1 || length == 0) {
      return false;
    }
    var can = true;
    for (var i = 0; i < this.fileInfors.length; i++) {
      var f = this.fileInfors[i];
      if (!f.isArchived() || f.getBorrowStatus() == 1 || f.getBorrowStatus() >= 3) {
        can = false;
        break;
      }
    }
    return can;
  },
  apply2Download: function apply2Download() {
    this.apply2Borrow(1);
  },
  apply2Copy: function apply2Copy() {
    this.apply2Borrow(2);
  },
  apply2Borrow: function apply2Borrow(type) {
    var length = this.fileInfors.length;
    if (length > 1 || length == 0) {
      return false;
    }
    var fileIds = [];
    for (var i = 0; i < this.fileInfors.length; i++) {
      var fileInfo = this.fileInfors[i];
      fileIds.push(fileInfo.getFileId());
    }
    _MDNetDriveFileHandler["default"].apply2BorrowFiles(fileIds, type, function () {
      var opt = {
        message: BabelStr.str(766) // 申请已经发送，请等待
      };
      _MDAlertView["default"].showStandardPrompt(opt);
    }, function () {
      _MDSnackbarView["default"].show(BabelStr.str(309));
    });
  },
  showBorrowPanel: function showBorrowPanel() {
    console.log("-------> borrwo panel!");
    _MDBorrowPanelView["default"].borrowFiles(this.fileInfors);
  },
  createProject: function createProject(opt) {
    console.log("---------创建项目窗口----------");
    var type;
    console.warn(this.fileInfors);
    var file;
    if (opt) {
      type = 7;
      file = this.fileInfors[0];
    } else {
      if (_app["default"].ep.get("supportTransmittal")) {
        type = 0;
      } else {
        type = 6;
      }
      if (_app["default"].currentFolder.isProject()) {
        type = 6;
      }
    }
    var win = new _MDProjectCreateWinView["default"]({
      type: type,
      originFile: file
    });
    win.show();
  },
  createClassify: function createClassify() {
    var fileInfor = this.fileInfors[0];
    var win = new _MDClassifyCreateWinView["default"]({
      parentId: fileInfor.getFileId(),
      parentFolder: fileInfor
      // fileInfor: fileInfor
    });
    win.show();
  },
  createLibrary: function createLibrary() {
    var fileInfor = this.fileInfors[0];
    var win = new _MDSubLibraryCreateWinView["default"]({
      parentId: fileInfor.getFileId(),
      parentFolder: fileInfor
    });
    win.show();
  },
  createReadingRoom: function createReadingRoom() {
    console.log("---------创建阅览室窗口----------");
    var win = new _MDArchiveReadingRoomCreateWinView["default"]({
      edit: false
    });
    win.show();
  },
  createLinkFileWin: function createLinkFileWin() {
    console.log("-------------------");
    var win = new _MDShowLinkFileWinView["default"]({
      fileInfor: this.fileInfors[0]
      // edit: false
    });
    win.show();
  }
});
MDFileActionController.deleteFiles = function (fileInforCollection, filesDeleting) {
  var fileIds = [];
  var joinedFileId = [];
  var shareCanLeaved = [];
  var fileCanDel = [];
  _.each(filesDeleting, function (fileInfor) {
    if (fileInfor.isRoot()) {
      if (fileInfor.isMine()) {
        fileIds.push(fileInfor.getFileId());
        fileCanDel.push(fileInfor);
      } else {
        joinedFileId.push(fileInfor.getFileId());
        if (fileInfor.canLeaveShare()) {
          shareCanLeaved.push(fileInfor.getFileId());
          fileCanDel.push(fileInfor);
        }
      }
    } else {
      if (_app["default"].pathRouter.hasTeamFolder() || _app["default"].pathRouter.hasDepartmentFolder()) {
        fileIds.push(fileInfor.getFileId());
        fileCanDel.push(fileInfor);
      } else {
        if (fileInfor.canDelete() && !fileInfor.isSharing() || fileInfor.isOwner()) {
          fileIds.push(fileInfor.getFileId());
          fileCanDel.push(fileInfor);
        } else {
          joinedFileId.push(fileInfor.getFileId());
          if (fileInfor.canLeaveShare()) {
            shareCanLeaved.push(fileInfor.getFileId());
            fileCanDel.push(fileInfor);
          }
        }
      }
    }
  });
  if (fileIds.length >= 1) {
    var del = BabelStr.str(690); // 文件删除中
    _MDSnackbarView["default"].show(del + "...");
    _MMNetDiskDataController["default"].deleteFilesByIds({
      fileArray: fileIds
    }, function success() {
      fileInforCollection.remove(fileCanDel);
      _Dispatcher["default"].trigger(_MDEvents["default"].FolderDeleted, fileCanDel);
      _MDSnackbarView["default"].show(BabelStr.str(308)); // ('文件删除成功');
    }, function fail(e, errFileList) {
      if (e == _MMNetDiskDataController["default"].code.ERROR_FILE_HAS_SHARING_CHILDREN) {
        //todo: message that some folder to delete had a sharing child
        var alert = new _MDAlertView["default"]();
        var z_startIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
        $(alert.el).css("z-index", z_startIndex);
        var title = BabelStr.str(694); //  "含有共享文件(夹)的，请先关闭其分享！"
        alert.show({
          title: BabelStr.str(170),
          //  '提示',
          message: '<p class="title">' + title + "</p>",
          className: "m-delAlertWin",
          onHide: function onHide() {
            var filePathNavView = viewManager.get("filePathNavView");
            filePathNavView.refreshCurFolder();
          },
          buttons: [{
            label: BabelStr.str(154) //  '知道了'
          }]
        });
        _MDSnackbarView["default"].dismiss();
      }
    });
  }
  for (var i = 0; i < shareCanLeaved.length; i++) {
    _MMNetDiskDataController["default"].leaveSharedFile(shareCanLeaved[i], function () {
      fileInforCollection.remove(fileCanDel);
      _Dispatcher["default"].trigger(_MDEvents["default"].FolderDeleted, fileCanDel);
    }, function () {});
  }
  if (shareCanLeaved.length != joinedFileId.length) {
    _MDSnackbarView["default"].showStandardMsg(40);
  }
};
var _default = exports["default"] = MDFileActionController;

},{"1087":1087,"1091":1091,"1098":1098,"1104":1104,"1125":1125,"1128":1128,"113":113,"1133":1133,"1150":1150,"1184":1184,"132":132,"141":141,"1412":1412,"1413":1413,"1417":1417,"1418":1418,"1421":1421,"1424":1424,"1426":1426,"1429":1429,"1436":1436,"1439":1439,"1454":1454,"1458":1458,"1461":1461,"1463":1463,"1471":1471,"1477":1477,"1492":1492,"151":151,"1537":1537,"1541":1541,"1546":1546,"17":17,"176":176,"18":18,"184":184,"185":185,"228":228,"297":297,"32":32,"325":325,"326":326,"330":330,"352":352,"412":412,"419":419,"468":468,"473":473,"477":477,"478":478,"479":479,"484":484,"485":485,"486":486,"487":487,"489":489,"49":49,"493":493,"508":508,"514":514,"520":520,"523":523,"524":524,"527":527,"528":528,"530":530,"539":539,"540":540,"549":549,"55":55,"558":558,"560":560,"562":562,"565":565,"568":568,"569":569,"577":577,"590":590,"615":615,"616":616,"617":617,"618":618,"620":620,"623":623,"630":630,"632":632,"635":635,"641":641,"652":652,"657":657,"658":658,"660":660,"695":695,"697":697,"699":699,"707":707,"717":717,"72":72,"76":76,"763":763,"781":781,"811":811,"812":812}],1458:[function(require,module,exports){
var $ = require(1270);
var fails = require(1271);
var getOwnPropertyNames = require(1330).f;

// eslint-disable-next-line es/no-object-getownpropertynames -- required for testing
var FAILS_ON_PRIMITIVES = fails(function () { return !Object.getOwnPropertyNames(1); });

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  getOwnPropertyNames: getOwnPropertyNames
});

},{"1270":1270,"1271":1271,"1330":1330}],699:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1438);
require(1417);
require(1463);
require(1421);
var _MDLoadMaskView = _interopRequireDefault(require(49));
var _MDSurveyStatusLoader = _interopRequireDefault(require(700));
/**
 * Formbricks 的页面容器，生命周期参考 MDDrawioEditorController。
 * 预览、编辑和创建都通过该容器挂载到 .app-root。
 */
var MDSurveyFrameView = {
  open: function open(fileInfo, mode, callback) {
    this.removeFromSuperview();
    this.fileInfo = fileInfo || null;
    this.mode = mode || "preview";
    this.callback = callback;
    this.initPanel();
    this.initFrame();
  },
  // 查看表单时浏览器标签页不再显示工作空间名，改为显示问卷文件名，关闭时还原。
  changeTitle: function changeTitle(title) {
    if (this._prevDocTitle == null) {
      this._prevDocTitle = document.title;
    }
    document.title = title + " - " + BabelStr.str(700);
  },
  restoreTitle: function restoreTitle() {
    if (this._prevDocTitle != null) {
      document.title = this._prevDocTitle;
      this._prevDocTitle = null;
    }
  },
  initPanel: function initPanel() {
    this.$el = $('<div class="text-editor-root survey-frame-root">' + '<div class="text-panel survey-frame-panel">' + '<div class="survey-frame-toolbar">' + '<span class="survey-frame-title"></span>' + '<button type="button" class="survey-frame-close" aria-label="' + BabelStr.str(50108) + '">×</button>' + '</div>' + '<iframe class="survey-frame" title="' + BabelStr.str(50105) + '" frameborder="0" allow="clipboard-write *"></iframe>' + '</div>' + '</div>');
    $(".app-root").append(this.$el);
    this.$el.on("click", ".survey-frame-close", this.close.bind(this));
    this.$el.find(".survey-frame").on("load", this.onLoad.bind(this));
    if (this.fileInfo && this.fileInfo.getFileName) {
      this.$el.find(".survey-frame-title").text(this.fileInfo.getFileName());
      this.changeTitle(this.fileInfo.getFileName());
    } else {
      this.$el.find(".survey-frame-title").text(BabelStr.str(50105));
      this.changeTitle(BabelStr.str(50105));
    }
  },
  initFrame: function initFrame() {
    if (!this.fileInfo || !this.fileInfo.getFileId) {
      this.onError();
      return;
    }
    _MDLoadMaskView["default"].show();
    $.ajax({
      method: "post",
      url: this.mode == "edit" ? "/netdrive/getFormbricksSurveyEditUrl.do" : this.mode == "summary" ? "/netdrive/getFormbricksSurveySummaryUrl.do" : "/netdrive/getFormbricksSurveyViewUrl.do",
      data: {
        fileId: this.fileInfo.getFileId()
      },
      success: this.onBridgeLoaded.bind(this),
      error: this.onError.bind(this)
    });
  },
  onBridgeLoaded: function onBridgeLoaded(responseData) {
    var bridgeUrl = responseData && responseData.bridgeUrl;
    if (!responseData || responseData.success !== true || typeof bridgeUrl !== "string" || bridgeUrl.indexOf("/netdrive/openFormbricksSurvey.do?") !== 0) {
      this.onError();
      return;
    }
    this.$el.find(".survey-frame").attr("src", bridgeUrl);
  },
  onLoad: function onLoad() {
    _MDLoadMaskView["default"].remove();
    if (_.isFunction(this.callback)) {
      this.callback(true);
    }
  },
  onError: function onError() {
    _MDLoadMaskView["default"].remove();
    if (window.MDSnackbarView) {
      MDSnackbarView.show(BabelStr.str(50103));
    }
    if (_.isFunction(this.callback)) {
      this.callback(false);
    }
  },
  close: function close() {
    _MDSurveyStatusLoader["default"].invalidate();
    this.removeFromSuperview();
  },
  removeFromSuperview: function removeFromSuperview() {
    _MDLoadMaskView["default"].remove();
    if (this.$el) {
      this.$el.off();
      this.$el.remove();
    }
    this.$el = null;
    this.fileInfo = null;
    this.callback = null;
    this.restoreTitle();
  }
};
var _default = exports["default"] = MDSurveyFrameView;

},{"1184":1184,"1417":1417,"1421":1421,"1438":1438,"1454":1454,"1463":1463,"49":49,"700":700}],493:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require(1180));
var _toConsumableArray2 = _interopRequireDefault(require(1194));
require(1413);
require(1463);
require(1430);
require(1418);
require(1537);
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDClientDownloadWinView = _interopRequireDefault(require(484));
var _MDOfficeEditor4PC = _interopRequireDefault(require(419));
var _MDFileCompareWinView = _interopRequireDefault(require(549));
var _ErrorCode = _interopRequireDefault(require(1087));
var _MMFileInfo = _interopRequireDefault(require(297));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDEvents = _interopRequireDefault(require(325));
var _MDRenameWindowView = _interopRequireDefault(require(514));
var _MDBatchRenameWinView = _interopRequireDefault(require(539));
var _MDMoveFileWindowView = _interopRequireDefault(require(508));
var _MDMoveArchiveWindowView = _interopRequireDefault(require(530));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDShareFileWindowView = _interopRequireDefault(require(695));
var _MDSnapshotLinkFileWindowView = _interopRequireDefault(require(697));
var _MDDownloadFileController = _interopRequireDefault(require(412));
var _MDCreateFolderWindowView = _interopRequireDefault(require(486));
var _MDLocalFileCollector = _interopRequireDefault(require(330));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MMBasicData = _interopRequireDefault(require(811));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDLoadMaskView = _interopRequireDefault(require(49));
var _MDEvalutionStartView = _interopRequireDefault(require(473));
var _MDEvaluationListWinView = _interopRequireDefault(require(468));
var _MDManuscriptBoxView = _interopRequireDefault(require(176));
var _MDMsBoxCreateSelectWinView = _interopRequireDefault(require(185));
var _MDMsAnonyBoxTabWinView = _interopRequireDefault(require(184));
var _MDChannelType = _interopRequireDefault(require(717));
var _MDNewEntBroadcastView = _interopRequireDefault(require(151));
var _MDAddTagBigWindow = _interopRequireDefault(require(781));
var _MDFileOperationManager = _interopRequireDefault(require(326));
var _MDInputFileNamePanel = _interopRequireDefault(require(1125));
var _MDNetDriveFileHandler = _interopRequireDefault(require(1091));
var _MDBorrowPanelView = _interopRequireDefault(require(528));
var _MDProjectCreateWinView = _interopRequireDefault(require(652));
var _MDDepControlFileListWinView = _interopRequireDefault(require(562));
var _MDDepSecretFileListWinView = _interopRequireDefault(require(568));
var _MDDepShareFileListWinView = _interopRequireDefault(require(569));
var _MDDepEvaluationSettingWinView = _interopRequireDefault(require(132));
var _MDApplicationRenamePerWinView = _interopRequireDefault(require(479));
var _MDApplicationMovePerWinView = _interopRequireDefault(require(477));
var _MDApplicationPerWinView = _interopRequireDefault(require(478));
var _MDArchiveReadingRoomCreateWinView = _interopRequireDefault(require(527));
var _MDShowLinkFileWinView = _interopRequireDefault(require(632));
var _MDFileOpStatisitcsWindow = _interopRequireDefault(require(577));
var _MDFocusFileWinView = _interopRequireDefault(require(635));
var _MDShareJumpOption = _interopRequireDefault(require(520));
var _MDTextEditorController = _interopRequireDefault(require(1128));
var _MDKityMinderEditorController = _interopRequireDefault(require(228));
var _MDManageSecurityWindowView = _interopRequireDefault(require(590));
var _MDUnzipFileWinView = _interopRequireDefault(require(707));
var _MDHQSMManageNavWinView = _interopRequireDefault(require(641));
var _MDSendHQSNFileWinView = _interopRequireDefault(require(657));
var _MDTransmittalInfoWinView = _interopRequireDefault(require(660));
var _MDSendHistoryWinView = _interopRequireDefault(require(658));
var _MDMDisplayFileController = _interopRequireDefault(require(352));
var _MDTeamSettingWindowView = _interopRequireDefault(require(763));
var _MEDepartMemberDownLimitWinView = _interopRequireDefault(require(141));
var _MDClientSyncSelectWinView = _interopRequireDefault(require(485));
var _MDTransferFileWinView = _interopRequireDefault(require(524));
var _MDTransferFileByPortWinView = _interopRequireDefault(require(523));
var _MDDownloadPathForClientWinView = _interopRequireDefault(require(489));
var _MDDepFilePermissionWinView = _interopRequireDefault(require(565));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDDrawioEditorController = _interopRequireDefault(require(113));
var _MDClassifyCreateWinView = _interopRequireDefault(require(623));
var _MDSubLibraryCreateWinView = _interopRequireDefault(require(630));
var _MDApplyLibraryWinView = _interopRequireDefault(require(617));
var _MDApplyDownloadView = _interopRequireDefault(require(615));
var _MDBatchEditClassifyWinView = _interopRequireDefault(require(618));
var _MDBatchEditLibraryWinView = _interopRequireDefault(require(620));
var _MDApplyJoinWinView = _interopRequireDefault(require(616));
var _MDTiptapEditorControllerJs = _interopRequireDefault(require(1133));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDCreateLinkView = _interopRequireDefault(require(487));
var _app = _interopRequireDefault(require(17));
var _MDcreateEncryptedFolderWindowView = _interopRequireDefault(require(558));
var _MDAutoClearCreateWinView = _interopRequireDefault(require(534));
var _MDAutoRenameCreateWinView = _interopRequireDefault(require(537));
var _MDAutoOrganizeCreateWinView = _interopRequireDefault(require(536));
var _MDAutoConvertCreateWinView = _interopRequireDefault(require(535));
var _MDDownloadLinkWinView = _interopRequireDefault(require(554));
var _MDEditArchiveLibraryWinView = _interopRequireDefault(require(532));
var _MDEditFileAttrWinView = _interopRequireDefault(require(597));
var _MDFileActionControll;
/**
 * File Action controller , define the logic of the files.
 *
 * javascript/moladisk/views/file/MDFileActionController.js
 * Created by manjun.han
 * 2016.1.25
 */
// import MDDepShareFileListWinView from './fileinfo/MDDepShareFileListWinView.js'
var MDFileActionController2 = (_MDFileActionControll = {
  canSendHQSMFile: function canSendHQSMFile() {
    if (this.fileInfors) {
      var can = true;
      for (var i = 0; i < this.fileInfors.length; i++) {
        var fileInfo = this.fileInfors[i];
        if (!fileInfo.canSendTransmittal()) {
          can = false;
        }
      }
      return can;
    } else {
      return false;
    }
    return _app["default"].pathRouter.getHQSMProjectByPath();
  },
  canShowSendHistory: function canShowSendHistory() {
    return _app["default"].pathRouter.getHQSMProjectByPath() && this.fileInfors.length == 1 && !this.fileInfors[0].isFolder() && !this.fileInfors[0].isShortcuts();
  },
  canShowUnfocus: function canShowUnfocus() {
    return _app["default"].pathRouter.isInMyfocus();
  },
  canSendFile: function canSendFile() {
    var fileInfor;
    if (!_app["default"].isEpVersion()) {
      return;
    }
    if (this.canSendHQSMFile()) {
      return false;
    }
    for (var i = 0; i < this.fileInfors.length; i++) {
      fileInfor = this.fileInfors[i];
      if (!fileInfor.canSendFile()) {
        return false;
      }
    }
    return true;
  },
  canShowStartEvaluation: function canShowStartEvaluation() {
    var fileInfor;
    for (var i = 0; i < this.fileInfors.length; i++) {
      fileInfor = this.fileInfors[i];
      if (fileInfor.isArchiveHouse || fileInfor.isDeleted()) {
        return false;
      }
      if (!(fileInfor.isWaitToStartEvaluation() && fileInfor.canStartEvaluation() || !_app["default"].isEpVersion() && fileInfor.isWaitToStartEvaluation())) {
        return false;
      }
    }
    return true;
  },
  canshowEditProject: function canshowEditProject() {
    if (this.fileInfors && this.fileInfors.length == 1) {
      var fileInfor = this.fileInfors[0];
      if (!fileInfor.isProject() && !fileInfor.isHQSMProject()) {
        return false;
      } else {
        return fileInfor.canEditProject();
      }
    } else {
      return false;
    }
  },
  canshowEditClassify: function canshowEditClassify() {
    if (this.fileInfors && this.fileInfors.length == 1) {
      var fileInfor = this.fileInfors[0];
      if (!fileInfor.isMaterialClass()) {
        return false;
      } else {
        return fileInfor.canEditProject();
      }
    } else {
      return false;
    }
  },
  canshowBatchEditClassify: function canshowBatchEditClassify() {
    if (this.fileInfors && this.fileInfors.length > 1) {
      var canEdit = _.every(this.fileInfors, function (fileInfor) {
        return fileInfor.isMaterialClass() && fileInfor.canEditProject();
      });
      return canEdit;
    }
  },
  canshowEditLibrary: function canshowEditLibrary() {
    if (this.fileInfors && this.fileInfors.length == 1) {
      var fileInfor = this.fileInfors[0];
      if (!fileInfor.isMaterialLibraryFolder()) {
        return false;
      } else {
        return fileInfor.canEditProject();
      }
    } else {
      return false;
    }
  },
  canshowBatchEditLibrary: function canshowBatchEditLibrary() {
    if (this.fileInfors && this.fileInfors.length > 1) {
      var canEdit = _.every(this.fileInfors, function (fileInfor) {
        return fileInfor.isMaterialLibraryFolder() && fileInfor.canEditProject();
      });
      return canEdit;
    }
  },
  canshowApplyLibrary: function canshowApplyLibrary() {
    if (this.fileInfors && this.fileInfors.length == 1) {
      var fileInfor = this.fileInfors[0];
      return fileInfor.needApply();
    } else {
      return false;
    }
  },
  canshowApplyDownload: function canshowApplyDownload() {
    if (this.fileInfors) {
      return _.every(this.fileInfors, function (file) {
        return file.getDownloadNeedApply();
      });
    } else {
      return false;
    }
  },
  canshowApplyJoin: function canshowApplyJoin() {
    if (this.fileInfors.length == 1) {
      // return _.every(this.fileInfors, function(file) {
      return this.fileInfors[0].getCanApplyJoin();
      // });
    } else {
      return false;
    }
  },
  canFocus: function canFocus() {
    if (this.fileInfors && this.fileInfors.length == 1) {
      var fileInfor = this.fileInfors[0];
      return !fileInfor.isDeleted() && fileInfor.canFocus() && fileInfor.canReadCommentOnlyByAction();
    } else {
      return false;
    }
  },
  canToProject: function canToProject() {
    if (!_app["default"].isEpVersion()) {
      return false;
    }
    if (this.fileInfors && this.fileInfors.length == 1) {
      var fileInfor = this.fileInfors[0];
      if (fileInfor.isShortcuts() || fileInfor.isDeleted() || !fileInfor.isFolder() || fileInfor.get("teamMark") || fileInfor.isEpPublicFolder()) {
        return false;
      }
      return fileInfor.isOwner() && _app["default"].pathRouter.isInRoot() && _app["default"].pathRouter.isInPersonFileChannel() || _app["default"].currentFolder.isDepartmentFolder() && fileInfor.canManageFilePermission();
    } else {
      return false;
    }
  },
  /**
   *
   * 编辑
   */
  canShowEditBtn: function canShowEditBtn() {
    if (this.fileInfors && this.fileInfors.length == 1) {
      var fileInfor = this.fileInfors[0];
      if (fileInfor.isArchived()) {
        return false;
      } else {
        var isClient = _app["default"].isInClient();
        if (isClient) {
          return fileInfor.canDownload() && !fileInfor.isFolder() && !fileInfor.isBabelOffice() && this.canUploadVersion();
        }
      }
    } else {
      return false;
    }
  },
  canShowOnlineEditBtn: function canShowOnlineEditBtn() {
    if (this.fileInfors && this.fileInfors.length == 1) {
      var fileInfor = this.fileInfors[0];
      // if(app.currentUser.inFreeEdition() && fileInfor.isOfficeFile()) {
      //   return true
      // }
      if (fileInfor.isVsdx()) {
        return false;
      }
      if (fileInfor.isPdf() && fileInfor.canUploadVersion() && _app["default"].ep.isSupportPdfUseOnlyEdit()) {
        return true;
      }
      if (fileInfor.isOfficeFile() && (_app["default"].currentUser.inFreeEdition() && !fileInfor.canUseOnlyOffice() || _app["default"].currentUser.getId() == fileInfor.getOwnerId() && !window.canUseOnlyOffice)) {
        return false;
      }
      if (fileInfor.isArchived() || fileInfor.isLocalArchived()) {
        return false;
      } else {
        var isClient = _app["default"].isInClient();
        // if(window.isSharePage) {
        //   return fileInfor.canEditWithTextEditer() && fileInfor.canDispWithKityMinder() && this.canUploadVersion();
        // } else
        if (_app["default"].ep && _app["default"].ep.isPrivateCloud()) {
          return (fileInfor.isOfficeFile() && !window.user.disableOnlyOfficeEdit || fileInfor.canEditWithTextEditer() || fileInfor.isDrawio() || fileInfor.isBabelOffice() || fileInfor.canDispWithKityMinder()) && (fileInfor.canUploadVersionIgnoreLocked() || fileInfor.isShortcuts());
        } else {
          return (fileInfor.isOfficeFile() && !window.user.disableOnlyOfficeEdit || fileInfor.canEditWithTextEditer() || fileInfor.isDrawio() || fileInfor.isBabelOffice() || fileInfor.canDispWithKityMinder()) && (fileInfor.canUploadVersionIgnoreLocked() || fileInfor.isShortcuts());
        }
      }
    } else {
      return false;
    }
  },
  canShowOnlineEditHelpBtn: function canShowOnlineEditHelpBtn() {
    if (this.canShowOnlineEditBtn()) {
      return false;
    }
    if (this.fileInfors && this.fileInfors.length == 1) {
      var fileInfor = this.fileInfors[0];
      if (fileInfor.isArchived() || fileInfor.isLocalArchived()) {
        return false;
      } else {
        return (fileInfor.isOfficeFile() || fileInfor.canEditWithTextEditer()) && (!this.canUploadVersion() || !this.canDownload());
      }
    } else {
      return false;
    }
  }
}, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_MDFileActionControll, "canShowStartEvaluation", function canShowStartEvaluation() {
  var fileInfor;
  for (var i = 0; i < this.fileInfors.length; i++) {
    fileInfor = this.fileInfors[i];
    if (fileInfor.isArchiveHouse || fileInfor.isDeleted()) {
      return false;
    }
    if (!(fileInfor.isWaitToStartEvaluation() && fileInfor.canStartEvaluation() || !_app["default"].isEpVersion() && fileInfor.isWaitToStartEvaluation())) {
      return false;
    }
  }
  return true;
}), "canCreateLinkFile", function canCreateLinkFile() {
  if (this.fileInfors.length == 1) {
    if (!this.fileInfors[0].isDeleted() && this.fileInfors[0].canRename() && !this.fileInfors[0].isFolder()) {
      return true;
    }
  } else {
    return false;
  }
}), "canShowReStartEvaluation", function canShowReStartEvaluation() {
  if (this.fileInfors.length == 1) {
    return this.fileInfors[0].isWaitToReStartEvaluation() && this.fileInfors[0].canStartEvaluation();
  } else {
    return false;
  }
}), "canShowFileControl", function canShowFileControl() {
  if (this.fileInfors.length == 1) {
    return !this.fileInfors[0].isTemplateStore() && !this.fileInfors[0].isManuscriptBox() && !this.fileInfors[0].belongMsBox() && !this.fileInfors[0].belongAnonymousBox() && _app["default"].pathRouter && _app["default"].pathRouter.isInMsgBoxFolderPath && !_app["default"].pathRouter.isInMsgBoxFolderPath() && !this.fileInfors[0].get("templateStoreFolderId") && !this.fileInfors[0].isDeleted() && this.fileInfors[0].canManageFilePermission() && !this.fileInfors[0].isEpPublicFolder() && !this.fileInfors[0].belongEnterprisePub();
  } else {
    return false;
  }
}), "canDepShowFileControl", function canDepShowFileControl() {
  if (this.canShowFileControl() && this.fileInfors[0].isDepartmentFolder()) {
    return true;
  } else {
    return false;
  }
}), "canShowStatistics", function canShowStatistics() {
  if (this.fileInfors.length != 1) {
    return false;
  }
  if (this.canDepShowFileControl() || this.fileInfors[0].teamCreateByMe()) {
    return true;
  } else {
    return false;
  }
}), "canSendEpBroadcast", function canSendEpBroadcast() {
  var sign = true;
  if (!_app["default"].isEpVersion()) {
    sign = false;
  }
  _.each(this.fileInfors, function (fileInfor) {
    if (fileInfor.isFolder() || !fileInfor.canDownload() || fileInfor.isShortcuts() || !fileInfor.isDepartmentFolder() && fileInfor.getSecretLevelId() == 4) {
      sign = false;
    }
  });
  return sign;
}), "canShowDoingvaluation", function canShowDoingvaluation(doingEvaluationMenuItem) {
  if (this.fileInfors.length == 1 && !this.fileInfors[0].isFolder()) {
    var passed = this.fileInfors[0].isPassed();
    var rejected = this.fileInfors[0].isRejected();
    var isDoing = this.fileInfors[0].isEvaluating();
    var isWaitRestart = this.fileInfors[0].isWaitToReStartEvaluation();
    if (passed) {
      doingEvaluationMenuItem.caption = BabelStr.str(678); // "已定稿（点击查看结果）"
    } else if (rejected) {
      if (isWaitRestart) {
        return false;
      } else {
        doingEvaluationMenuItem.caption = BabelStr.str(679); // "已驳回（点击查看结果）"
      }
    }
    return passed || rejected || isDoing;
  } else {
    return false;
  }
}), "canShowAbolishEvaluation", function canShowAbolishEvaluation() {
  if (this.fileInfors.length == 1) {
    return this.fileInfors[0].isPassed();
  } else {
    return false;
  }
}), "canShowStar", function canShowStar() {
  return this.fileInfors.length > 0 && !_MMCommonFun["default"].hasGodEye();
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_MDFileActionControll, "canShowVersion", function canShowVersion() {
  var length = this.fileInfors.length;
  var fileInfor = this.fileInfors[0];
  if (length == 1) {
    return !fileInfor.isDeleted() && !fileInfor.isLocalArchived() && !fileInfor.isFolder() && !fileInfor.isDeleteVersion() && !fileInfor.isShortcuts() && fileInfor.canUploadVersion();
  }
  return false;
}), "canShowInfor", function canShowInfor() {
  return !this.fileInfors[0].isArchiveHouse;
}), "canGetShareLink", function canGetShareLink(success) {
  var length = this.fileInfors.length;
  if (length == 0 || length > 1) {
    return;
  }
  var fileInfor = this.fileInfors[0];
  if (fileInfor.isDeleted() || fileInfor.get("teamMark") != 0 || fileInfor.isArchived()) {
    return;
  }
  var newShareAll = fileInfor.get("newShareAll");
  var linkState;
  if (newShareAll == 0) {
    linkState = false;
  } else if (newShareAll == 1) {
    linkState = true;
  } else if (newShareAll == 2) {
    linkState = _app["default"].pathRouter.isOpenedShareByLink();
  }
  if (linkState) {
    success && success();
  } else {
    // var shareId = fileInfor.get("belongLinkShareId");
    // if (shareId) {
    //   success && success();
    // } else {
    _MMNetDiskDataController["default"].getBelongShareLink(fileInfor.getFileId(), function (filedata) {
      fileInfor.set("belongLinkShareId", filedata.fileId);
      success && success();
    });
    // }
  }
}), "canDelete", function canDelete() {
  if (_MMCommonFun["default"].hasGodEye()) {
    return false;
  }
  var length = this.fileInfors.length;
  var can = length > 0 && _.every(this.fileInfors, function (fileInfor) {
    return (fileInfor.canDelete() || fileInfor.canLeaveShare()) && !fileInfor.isDeleted();
  });
  if (can && this.fileInfors.length > 1) {
    var allIsCommonFile = _.every(this.fileInfors, function (fileInfor) {
      return !fileInfor.isDepartmentFolder();
    });
    can = can && allIsCommonFile;
  }
  return can;
}), "canUploadVersion", function canUploadVersion() {
  if (_MMCommonFun["default"].hasGodEye()) {
    return false;
  }
  var length = this.fileInfors.length;
  var fileInfor = this.fileInfors[0];
  if (length == 1) {
    return fileInfor.canUploadVersion() && !fileInfor.isBabelOffice() && !fileInfor.isDeleted() && !fileInfor.isLocalArchived();
  }
  return false;
}), "canShowUploadVersionBtn", function canShowUploadVersionBtn() {
  if (_MMCommonFun["default"].hasGodEye()) {
    return false;
  }
  var length = this.fileInfors.length;
  if (length == 1) {
    var fileInfor = this.fileInfors[0];
    if (!fileInfor.canRead() || fileInfor.isDeleted() || fileInfor.isFileLocked() || fileInfor.getLinkFileUrl() || fileInfor.isSnapshotFile() || fileInfor.isBabelOffice() || fileInfor.isLocalArchived()) {
      return false;
    }
    if (fileInfor.isArchived() || fileInfor.getEnterprisePub() || fileInfor.isShortcuts() || fileInfor.isFolder() || fileInfor.belongQuickSend() || fileInfor.get("evaluationStatus") || fileInfor.bloneManuscript() || fileInfor.belongEnterprisePub()) {
      return false;
    }
    return true;
  }
  return false;
}), "canShowAskMoveBtn", function canShowAskMoveBtn() {
  if (this.fileInfors.length == 1 && this.fileInfors[0].belongDepartment() && !this.fileInfors[0].isDepartmentFolder() && !this.fileInfors[0].isDeleted() && !this.fileInfors[0].isProject() && !this.fileInfors[0].isHQSMProject() && !this.fileInfors[0].getEvaluationStatus()) {
    return true;
  } else {
    return false;
  }
  // if (this.channel == MDChannelType.joinshare || app.ep && app.ep.isArchive()) {
  //   return false;
  // }

  // if(this.canshowAskPer() && this.fileInfors.length) {
  //   if(this.fileInfors[0].get('evaluationStatus') || this.fileInfors[0].isShortcuts()) {
  //     return false
  //   } else {
  //     return true
  //   }
  // }
  // return false
}), "isShortcuts", function isShortcuts() {
  if (_MMCommonFun["default"].hasGodEye()) {
    return false;
  }
  var length = this.fileInfors.length;
  var isLinkedFiles = _.every(this.fileInfors, function (file) {
    return file.isShortcuts() && !file.isArchiveHouse;
  });
  return isLinkedFiles;
}), "canCreateLinkForFile", function canCreateLinkForFile() {
  var noCreate = _.some(this.fileInfors, function (file) {
    return file.getEnterprisePub() || file.getLinkFileUrl();
  });
  if (noCreate) {
    return false;
  }
  return !this.isShortcuts();
}), "canDownload", function canDownload() {
  var length = this.fileInfors.length;
  if (_app["default"].pathRouter.isInTrash() && length > 1) {
    return false;
  }
  var canDownload = length > 0 && _.every(this.fileInfors, function (fileInfor) {
    return !fileInfor.getLinkFileUrl() && !fileInfor.isDeleted() && fileInfor.canDownload()
    // &&!fileInfor.isDepartmentFolder()
    ;
  });
  if (this.channel == _MDChannelType["default"].trash) {
    // if (length > 1) {
    //   return false;
    // };
    canDownload = canDownload && length > 0 && _.every(this.fileInfors, function (fileInfor) {
      return true;
    });
  } else {}
  return canDownload;
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_MDFileActionControll, "canOpenLocalFolder", function canOpenLocalFolder() {
  var length = this.fileInfors.length;
  if (_app["default"].pathRouter.isInTrash() && length > 1) {
    return false;
  }
  var canOpenLocalFolder = length > 0 && _.every(this.fileInfors, function (fileInfor) {
    return !fileInfor.isDeleted() && fileInfor.canDownload() || fileInfor.isDepartmentFolder();
  });
  if (this.channel == _MDChannelType["default"].trash) {
    // if (length > 1) {
    //   return false;
    // };
    canOpenLocalFolder = canOpenLocalFolder && length > 0 && _.every(this.fileInfors, function (fileInfor) {
      return true;
    });
  } else {}
  return canOpenLocalFolder;
}), "canDownloadPassedPdf", function canDownloadPassedPdf() {
  return false;
  var length = this.fileInfors.length;
  if (length != 1) {
    return false;
  }
  return this.fileInfors[0].canDownloadPassedPdf();
}), "canDownloadMarkedPdf", function canDownloadMarkedPdf() {
  var length = this.fileInfors.length;
  if (length != 1) {
    return false;
  }
  if (window.user.hasWindowsServer == 0 && this.fileInfors[0].ifNeedWindowsServer()) {
    return false;
  }
  return this.fileInfors[0].canPrint() && this.fileInfors[0].canDownload() && this.fileInfors[0].canCoverToPdf() && !this.fileInfors[0].isShortcuts();
}), "canSync", function canSync() {
  if (this.canDownload()) {
    return true;
  } else if (this.fileInfors.length == 1 && this.fileInfors[0].isDepartmentFolder()) {
    return true;
  } else if (this.fileInfors.length == 1 && this.fileInfors[0].isTeamFolder()) {
    return true;
  } else if (this.fileInfors.length == 1 && this.fileInfors[0].isProject()) {
    return true;
  }
  return false;
}), "canPreview", function canPreview() {
  var length = this.fileInfors.length;
  var fileInfor = this.fileInfors[0];
  return length == 1 && !fileInfor.isFolder() && fileInfor.canDispInEditor() && fileInfor.isReady();
}), "canGobackParent", function canGobackParent() {
  var fileInfor = this.fileInfors[0];
  if (this.fileInfors.length == 1) {
    if (fileInfor.getEvaluationFlowId()) {
      return fileInfor.isOwner();
    } else if (fileInfor.isManuscriptBox() && !fileInfor.canManageMsBox()) {
      return false;
    } else {
      return true;
    }
  }
  return false;
}), "canRenamMultFile", function canRenamMultFile() {
  if (this.fileInfors.length != 1) {
    return false;
  }
  if (this.fileInfors[0].get("multFile") && this.fileInfors[0].isOwner()) {
    return true;
  }
  return false;
}), "showFileInfor", function showFileInfor(fileInfor) {
  var file = fileInfor;
  if (!file && this.fileInfors.length == 1) {
    file = this.fileInfors[0];
  }
  _Dispatcher["default"].trigger(_MDEvents["default"].ShowInforPanel, {
    fileInfor: file,
    at: 1
  });
  // Dispatcher.trigger(MDEvents.FileTableRowChanged)
}), "gobackToParent", function gobackToParent() {
  var fileInfor = this.fileInfors[0];
  var parentId = fileInfor.get("parentId");
  var path = "";
  if (fileInfor.isSharing() && !fileInfor.isOwner()) {
    path = "";
  } else {
    path = "file/" + parentId;
    if (parentId == 0) {
      path = "";
    }
  }
  _app["default"].pathRouter.navigate(path, {
    trigger: true
  });
}), "showFileVersion", function showFileVersion() {
  _Dispatcher["default"].trigger(_MDEvents["default"].showVerListPanel, {
    fileInfor: this.fileInfors[0],
    at: 3
  });
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_MDFileActionControll, "createNewFileVersion", function createNewFileVersion() {
  var fileInfor = this.fileInfors[0];
  if (!this.canUploadVersion()) {
    this.showPerWinView();
    return;
  }
  if (fileInfor.isFileLocked() && !fileInfor.isFileLockedByMe()) {
    var alertView = new _MDAlertView["default"]();
    var msg = '<p class="title">' + _MDLocalString["default"].getLocalString(189, {
      user: fileInfor.getFileLockerDispName()
    }) + "</p>";
    alertView.show({
      title: BabelStr.str(680),
      // '不能上传新版本',
      message: msg,
      className: "m-delAlertWin",
      onHide: function onHide() {
        alertView = null;
      },
      buttons: [{
        label: BabelStr.str(154),
        // '确定',
        type: "done"
      }]
    });
  } else {
    _MDLocalFileCollector["default"].openNewVersionFileFinder(this.fileInfors[0]);
  }
}), "canCancelFileShare", function canCancelFileShare() {
  return this.fileInfors.length > 0;
}), "canClearReadMark", function canClearReadMark() {
  if (_MMCommonFun["default"].hasGodEye()) {
    return false;
  }
  var length = this.fileInfors.length;
  if (length == 0) return false;
  var hasFolder = _.some(this.fileInfors, function (fileInfor) {
    return fileInfor.isFolder();
  });
  // if (hasFolder) return false;
  var hasUnread = _.some(this.fileInfors, function (fileInfor) {
    return fileInfor.getUnReadCount() > 0;
  });
  var hasNotRead = _.some(this.fileInfors, function (fileInfor) {
    return !fileInfor.canRead();
  });
  if (hasNotRead) return false;
  if (!hasUnread) return false;
  return true;
}), "canCreateFolder", function canCreateFolder() {
  if (_MMCommonFun["default"].hasGodEye()) {
    return false;
  }
  var length = this.fileInfors.length;
  var fileInfor = this.fileInfors[0];
  return length == 1 && fileInfor.canCreateFolder();
}), "canUpload", function canUpload() {
  if (_MMCommonFun["default"].hasGodEye()) {
    return false;
  }
  var length = this.fileInfors.length;
  var fileInfor = this.fileInfors[0];
  return length == 1 && fileInfor.canUpload();
}), "canPaste", function canPaste() {
  if (!window.pasteObj) {
    return false;
  }
  var forLibrary = _.every(window.pasteObj.files, function (fileInfo) {
    return fileInfo.isMaterialLibraryFolder() || fileInfo.isMaterialClass();
  });
  var beloneMaterialLibrary = _.every(window.pasteObj.files, function (fileInfo) {
    return fileInfo.beloneMaterialLibrary();
  });
  var fileInfor = this.fileInfors[0];
  if (beloneMaterialLibrary) {
    return (fileInfor.isMaterialLibraryFolder() || fileInfor.beloneMaterialLibrary()) && fileInfor.canUploadOnlyActions() && _app["default"].currentFolder.getFileId() != window.pasteObj.originParent;
  } else if (forLibrary) {
    return (fileInfor.isMaterialLibrary() || fileInfor.isMaterialClass()) && fileInfor.canUploadOnlyActions() && _app["default"].currentFolder.getFileId() != window.pasteObj.originParent;
  } else {
    return fileInfor.canUpload();
  }
}), "canCopy", function canCopy() {
  var length = this.fileInfors.length;
  return length > 0 && _.every(this.fileInfors, function (fileInfor) {
    return fileInfor.canCopy() && !fileInfor.isArchived();
    ;
  });
}), "canAddTag", function canAddTag() {
  var length = this.fileInfors.length;
  return length > 0 && _.every(this.fileInfors, function (fileInfor) {
    return fileInfor.canReadCommentOnlyByAction() && !fileInfor.isDeleted() && !fileInfor.isArchived();
    x; // fileInfor.canAddTag();
  });
}), "canAddAITag", function canAddAITag() {
  var length = this.fileInfors.length;
  return length > 1 && _.some(this.fileInfors, function (fileInfor) {
    return fileInfor.canReadCommentOnlyByAction() && !fileInfor.isDeleted() && fileInfor.canUseAITaginal(); // fileInfor.canAddTag();
  });
}), "canShare", function canShare() {
  if (_MMCommonFun["default"].hasGodEye()) {
    return false;
  }
  var length = this.fileInfors.length;
  var fileInfor = this.fileInfors[0];
  if (length == 1) {
    return fileInfor.canShare();
  } else {
    return false;
  }
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_MDFileActionControll, "canSnapshotShare", function canSnapshotShare() {
  if (_MMCommonFun["default"].hasGodEye()) {
    return false;
  }
  var length = this.fileInfors.length;
  var fileInfor = this.fileInfors[0];
  if (length == 1) {
    return fileInfor.canShare() && !fileInfor.isEncryptedFolder() && !fileInfor.isBeloneEncryptedFolder();
  } else {
    return false;
  }
}), "canCloseShare", function canCloseShare() {
  if (_MMCommonFun["default"].hasGodEye()) {
    return false;
  }
  var length = this.fileInfors.length;
  return length > 0;
}), "canManageMsBox", function canManageMsBox() {
  if (_MMCommonFun["default"].hasGodEye()) {
    return false;
  }
  var length = this.fileInfors.length;
  var fileInfor = this.fileInfors[0];
  if (length == 1) {
    return fileInfor.canManageMsBox();
  } else {
    return false;
  }
}), "canManageDep", function canManageDep() {
  var length = this.fileInfors.length;
  var fileInfor = this.fileInfors[0];
  if (length == 1) {
    return fileInfor.canManageDepMember();
  } else {
    return false;
  }
}), "canShowParent", function canShowParent() {
  if (_MMCommonFun["default"].hasGodEye()) {
    return false;
  }
  var length = this.fileInfors.length;
  var fileInfor = this.fileInfors[0];
  if (fileInfor.get("multFile")) {
    return;
  }
  if (fileInfor.get("showParentMenu") && !fileInfor.isFolder()) {
    return true;
  }
  if (length == 1 && window.showSubFolderFiles) {
    if (_app["default"].currentFolder && fileInfor.getParentFolderId() != _app["default"].currentFolder.getFileId()) {
      return true;
    } else {
      return false;
    }
  }
  if (length == 1 && _app["default"].pathRouter.isInStartEvaluation()) {
    return true;
  } else {
    return false;
  }
}), "canOpenOriginFolder", function canOpenOriginFolder() {
  if (_MMCommonFun["default"].hasGodEye()) {
    return false;
  }
  var length = this.fileInfors.length;
  var fileInfor = this.fileInfors[0];
  if (length == 1) {
    if (fileInfor.isShortcuts()) {
      return true;
    }
    return false;
  } else {
    return false;
  }
}), "canMove", function canMove() {
  if (this.channel == _MDChannelType["default"].joinshare && _app["default"].pathRouter.isInRoot()) {
    return false;
  }
  if (this.channel == _MDChannelType["default"].depart && _app["default"].pathRouter.isInRoot()) {
    return false;
  }
  var length = this.fileInfors.length;
  return length > 0 && _.every(this.fileInfors, function (fileInfor) {
    return fileInfor.canMove() && !fileInfor.isArchived();
  });
}), "canManageSecurity", function canManageSecurity() {
  if (!_app["default"].ep.canShowSecurityPolicyModel()) {
    return false;
  }
  if (_app["default"].pathRouter.isInRoot()) {
    return false;
  }
  var length = this.fileInfors.length;
  return length > 0 && _.every(this.fileInfors, function (fileInfor) {
    return !fileInfor.isDeleted() && fileInfor.canManageSecret() && !fileInfor.isEpPublicFolder();
  });
}), "canArchive", function canArchive() {
  var length = this.fileInfors.length;
  return length > 0 && _.every(this.fileInfors, function (fileInfor) {
    return fileInfor.canArchive() && !fileInfor.isLocalArchived();
  });
}), "canLocalArchive", function canLocalArchive() {
  var length = this.fileInfors.length;
  return length > 0 && _.every(this.fileInfors, function (fileInfor) {
    return fileInfor.canArchive() && !fileInfor.isLocalArchived();
  });
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_MDFileActionControll, "canTranslateProject", function canTranslateProject() {
  var length = this.fileInfors.length;
  if (length == 1 && this.fileInfors[0].isProject() && this.fileInfors[0].canEditProject() && !this.fileInfors[0].get("isProjectAssist")) {
    return true;
  }
  return false;
}), "canRename", function canRename() {
  if (_MMCommonFun["default"].hasGodEye()) {
    return false;
  }
  var length = this.fileInfors.length;
  var fileInfor = this.fileInfors[0];
  if (length == 1) {
    return fileInfor.canRename() && !fileInfor.isDeleted();
  }
  return false;
}), "canBatchRename", function canBatchRename() {
  if (_MMCommonFun["default"].hasGodEye()) {
    return false;
  }
  if (this.fileInfors.length < 2) {
    return false;
  }
  for (var i = 0; i < this.fileInfors.length; i++) {
    var fileInfor = this.fileInfors[i];
    if (!fileInfor.canRename() || fileInfor.isDeleted()) {
      return false;
    }
  }
  return true;
}), "canRead", function canRead() {
  var length = this.fileInfors.length;
  if (!length) {
    return false;
  }
  for (var i = 0; i < this.fileInfors.length; i++) {
    var fileInfor = this.fileInfors[i];
    if (!fileInfor.canRead()) {
      return false;
    }
  }
  return true;
}), "canLockFile", function canLockFile() {
  var length = this.fileInfors.length;
  if (length > 1 || length == 0) {
    return false;
  }
  var fileInfo = this.fileInfors[0];
  if (!fileInfo.isLocalArchived() && !fileInfo.isDeleted() && !fileInfo.isFolder() && !fileInfo.isFileLocked() && fileInfo.canUploadVersion() && !fileInfo.isEvaluating() && !fileInfo.isPassed() && !fileInfo.isOfficeFile()) {
    return true;
  }
  return false;
}), "canUnlockFile", function canUnlockFile() {
  var length = this.fileInfors.length;
  if (length > 1 || length == 0) {
    return false;
  }
  var fileInfo = this.fileInfors[0];
  if (!fileInfo.isLocalArchived() && !fileInfo.isDeleted() && !fileInfo.isFolder() && (fileInfo.isFileLockedByMe() || fileInfo.isFileLocked() && fileInfo.canUnlock())) {
    return true;
  }
  return false;
}), "canshowAskPer", function canshowAskPer(needOneFile) {
  if (needOneFile && this.fileInfors.length > 1) {
    return false;
  }
  if (_app["default"].ep && _app["default"].ep.isArchive()) {
    return false;
  }
  for (var i = 0; i < this.fileInfors.length; i++) {
    if (this.fileInfors[i].getEnterprisePub() || this.fileInfors[i].isDepartmentFolder() || this.fileInfors[i].isManuscriptBox() || this.fileInfors[i].isTeamFolder() || this.fileInfors[i].isProject() || this.fileInfors[i].getLinkFileUrl() || this.fileInfors[0].isShortcuts() || this.fileInfors[i].isTransitStation() || this.fileInfors[i].isArchiveHouse || this.fileInfors[i].belongEnterprisePub() || this.fileInfors[i].belongQuickSend() || this.fileInfors[i].bloneManuscript() || this.fileInfors[i].get("multFile") || !this.fileInfors[i].canRead() || this.fileInfors[i].isHQSMProject() || this.fileInfors[i].isDeleted() || this.fileInfors[i].isSnapshotFile() || this.fileInfors[i].isTemplateStore()) {
      return false;
    }
  }
  return true;
}), "canManageTeam", function canManageTeam() {
  if (this.fileInfors.length != 1) {
    return false;
  }
  return this.fileInfors[0].isTeamFolder() && this.fileInfors[0].canRead();
}), "createLinkForFile", function createLinkForFile() {
  var parentId = 0;
  // if (app.pathRouter.isInFileChannel()) {
  parentId = _app["default"].pathRouter.getCurrentFolder().getFileId();
  // }
  var wind = new _MDMoveFileWindowView["default"]({
    fileInfors: this.fileInfors,
    parentId: parentId,
    isLinkFileAction: true
  });
  wind.show();
}), "createLink", function createLink() {
  var parentId = 0;
  // if (app.pathRouter.isInFileChannel()) {
  parentId = _app["default"].pathRouter.getCurrentFolder().getFileId();
  // }
  var wind = new _MDCreateLinkView["default"]({
    parentId: parentId
  });
  wind.show();
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_MDFileActionControll, "canEditLink", function canEditLink() {
  if (this.fileInfors.length == 1 && this.fileInfors[0].getLinkFileUrl()) {
    if (this.fileInfors[0].canRename() || this.fileInfors[0].canUploadVersionOnlyActions()) {
      return true;
    }
  }
}), "copyFiles", function copyFiles() {
  if (!this.canCopy()) {
    this.showPerWinView();
    return;
  }
  var parentId = 0;
  // if (app.pathRouter.isInFileChannel()) {
  parentId = _app["default"].pathRouter.getCurrentFolder().getFileId();
  // }
  var wind = new _MDMoveFileWindowView["default"]({
    fileInfors: this.fileInfors,
    isCopyAction: true,
    parentId: parentId,
    forMove: false
  });
  wind.show();
}), "canRestore", function canRestore() {
  if (!this.fileInfors.length) {
    return false;
  }
  var fileInfor;
  for (var i = 0; i < this.fileInfors.length; i++) {
    fileInfor = this.fileInfors[0];
    if (!fileInfor.isDeletedOrgin()) {
      return false;
    }
  }
  return true;
}), "canDeleteForever", function canDeleteForever() {
  if (!this.fileInfors.length) {
    return false;
  }
  var fileInfor;
  for (var i = 0; i < this.fileInfors.length; i++) {
    fileInfor = this.fileInfors[0];
    if (!fileInfor.isDeletedOrgin()) {
      return false;
    }
  }
  return true;
}), "canShowSyncBtn", function canShowSyncBtn() {
  // return true
  if (this.channel == _MDChannelType["default"].trash || this.fileInfors.length == 0 || !this.fileInfors[0].isFolder()) {
    return;
  }
  if (this.fileInfors.length > 1) {
    return;
  }
  if (this.fileInfors[0].isBeloneEncryptedFolder()) {
    return;
  }
  if (this.fileInfors[0].isEncryptedFolder()) {
    return;
  }
  if (!this.fileInfors[0].canRead()) {
    return;
  }
  if (this.fileInfors[0].isMultFile()) {
    return;
  }
  if (_app["default"].isUnSupportSync()) {
    return;
  }
  if (!_app["default"].isInClient()) {
    return;
  }
  // if(app.pathRouter.isInRoot()) {
  //   return
  // }
  var isSynced = _app["default"].isFolderSynced(this.fileInfors[0].getFileId());
  var isInSyncFolderPath = !this.fileInfors[0].isFolderSynced() && _app["default"].pathRouter.isInSyncFolderPath();
  if (isInSyncFolderPath) {
    return;
  }
  return true;
}), "canShowCompareBtn", function canShowCompareBtn() {
  if (this.fileInfors.length > 1) {
    return false;
  }
  if (this.fileInfors[0].isOfficeFile()) {
    return true;
  }
  return false;
}), "canShowReadonlyOpen", function canShowReadonlyOpen() {
  if (this.fileInfors.length > 1 || !_app["default"].isInClient()) {
    return false;
  }
  if (this.fileInfors[0].getLinkFileUrl()) {
    return false;
  }
  if (!this.fileInfors[0].isFolder() && !this.fileInfors[0].isShortcuts() && this.fileInfors[0].canDownload()) {
    return true;
  }
  return false;
}), "canShowOpenLink", function canShowOpenLink() {
  if (this.fileInfors.length > 1) {
    return false;
  }
  if (this.fileInfors[0].getLinkFileUrl() && this.fileInfors[0].canRead()) {
    return true;
  }
  return false;
}), "canApplyRead", function canApplyRead() {
  var length = this.fileInfors.length;
  if (length > 1 || length == 0) {
    return false;
  }
  var can = true;
  for (var i = 0; i < this.fileInfors.length; i++) {
    var f = this.fileInfors[i];
    if (!f.isArchived() || f.isArchived() && !f.canDispInEditor() || f.getBorrowStatus() >= 1) {
      can = false;
      break;
    }
  }
  return can;
}), "canApplyCopy", function canApplyCopy() {
  var length = this.fileInfors.length;
  if (length > 1 || length == 0) {
    return false;
  }
  var can = true;
  for (var i = 0; i < this.fileInfors.length; i++) {
    var f = this.fileInfors[i];
    if (!f.isArchived() || f.getBorrowStatus() == 1 || f.getBorrowStatus() >= 4) {
      can = false;
      break;
    }
  }
  return can;
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_MDFileActionControll, "canBorrow", function canBorrow() {
  var length = this.fileInfors.length;
  if (length > 1 || length == 0) {
    return false;
  }
  var can = true;
  for (var i = 0; i < this.fileInfors.length; i++) {
    var f = this.fileInfors[i];
    if (!f.isArchived() || f.getBorrowStatus() != 0 || f.canRead() && f.canDownload()) {
      can = false;
      break;
    }
  }
  return can;
}), "canShowTaskClear", function canShowTaskClear() {
  var length = this.fileInfors.length;
  if (length > 1 || length == 0) {
    return false;
  }
  if (this.fileInfors[0].isDeleted() || this.fileInfors[0].isMultFile()) {
    return false;
  }
  return this.fileInfors[0].isFolder() && (this.fileInfors[0].canManageFilePermission() || this.fileInfors[0].canEditProject() || this.fileInfors[0].isOwner()) && !this.fileInfors[0].getTaskDELid();
}), "canShowTaskRename", function canShowTaskRename() {
  var length = this.fileInfors.length;
  if (length > 1 || length == 0) {
    return false;
  }
  if (this.fileInfors[0].isDeleted() || this.fileInfors[0].isMultFile()) {
    return false;
  }
  return this.fileInfors[0].isFolder() && (this.fileInfors[0].canManageFilePermission() || this.fileInfors[0].canEditProject() || this.fileInfors[0].isOwner()) && !this.fileInfors[0].getTaskRENid();
}), "taskRename", function taskRename() {
  console.log('clear');
  var win = new _MDAutoRenameCreateWinView["default"]({
    fileInfor: this.fileInfors[0]
  });
  win.show();
}), "taskClear", function taskClear() {
  console.log('clear');
  var win = new _MDAutoClearCreateWinView["default"]({
    fileInfor: this.fileInfors[0]
  });
  win.show();
}), "canEditTaskClear", function canEditTaskClear() {
  var length = this.fileInfors.length;
  if (length > 1 || length == 0) {
    return false;
  }
  if (this.fileInfors[0].isDeleted() || this.fileInfors[0].isMultFile()) {
    return false;
  }
  return this.fileInfors[0].getTaskDELid() && (this.fileInfors[0].isOwner() || this.fileInfors[0].canManageFilePermission() || this.fileInfors[0].canEditProject());
}), "editTaskClear", function editTaskClear() {
  console.log('clear');
  var win = new _MDAutoClearCreateWinView["default"]({
    fileInfor: this.fileInfors[0],
    taskDELid: this.fileInfors[0].getTaskDELid()
  });
  win.show();
}), "canEditTaskRename", function canEditTaskRename() {
  var length = this.fileInfors.length;
  if (length > 1 || length == 0) {
    return false;
  }
  if (this.fileInfors[0].isDeleted() || this.fileInfors[0].isMultFile()) {
    return false;
  }
  return this.fileInfors[0].getTaskRENid() && (this.fileInfors[0].isOwner() || this.fileInfors[0].canManageFilePermission() || this.fileInfors[0].canEditProject());
}), "editTaskRename", function editTaskRename() {
  console.log('clear');
  var win = new _MDAutoRenameCreateWinView["default"]({
    fileInfor: this.fileInfors[0],
    taskRENid: this.fileInfors[0].getTaskRENid()
  });
  win.show();
}), "canShowTaskOrganize", function canShowTaskOrganize() {
  var length = this.fileInfors.length;
  if (length > 1 || length == 0) {
    return false;
  }
  if (this.fileInfors[0].isDeleted() || this.fileInfors[0].isMultFile()) {
    return false;
  }
  return this.fileInfors[0].isFolder() && (this.fileInfors[0].canManageFilePermission() || this.fileInfors[0].canEditProject() || this.fileInfors[0].isOwner()) && !this.fileInfors[0].getTaskORGid();
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_MDFileActionControll, "taskOrganize", function taskOrganize() {
  console.log('clear');
  var win = new _MDAutoOrganizeCreateWinView["default"]({
    fileInfor: this.fileInfors[0]
  });
  win.show();
}), "canEditTaskOrganize", function canEditTaskOrganize() {
  var length = this.fileInfors.length;
  if (length > 1 || length == 0) {
    return false;
  }
  if (this.fileInfors[0].isDeleted() || this.fileInfors[0].isMultFile()) {
    return false;
  }
  return this.fileInfors[0].getTaskORGid() && (this.fileInfors[0].isOwner() || this.fileInfors[0].canManageFilePermission() || this.fileInfors[0].canEditProject());
}), "editTaskOrganize", function editTaskOrganize() {
  console.log('clear');
  var win = new _MDAutoOrganizeCreateWinView["default"]({
    fileInfor: this.fileInfors[0],
    taskORGid: this.fileInfors[0].getTaskORGid()
  });
  win.show();
}), "canShowTaskCON", function canShowTaskCON() {
  var length = this.fileInfors.length;
  if (length > 1 || length == 0) {
    return false;
  }
  if (this.fileInfors[0].isDeleted() || this.fileInfors[0].isMultFile()) {
    return false;
  }
  return this.fileInfors[0].isFolder() && (this.fileInfors[0].canManageFilePermission() || this.fileInfors[0].canEditProject() || this.fileInfors[0].isOwner()) && !this.fileInfors[0].getTaskCONid();
}), "taskCON", function taskCON() {
  console.log('clear');
  var win = new _MDAutoConvertCreateWinView["default"]({
    fileInfor: this.fileInfors[0]
  });
  win.show();
}), "canEditTaskCON", function canEditTaskCON() {
  var length = this.fileInfors.length;
  if (length > 1 || length == 0) {
    return false;
  }
  if (this.fileInfors[0].isDeleted() || this.fileInfors[0].isMultFile()) {
    return false;
  }
  return this.fileInfors[0].getTaskCONid() && (this.fileInfors[0].isOwner() || this.fileInfors[0].canManageFilePermission() || this.fileInfors[0].canEditProject());
}), "editTaskCON", function editTaskCON() {
  console.log('clear');
  var win = new _MDAutoConvertCreateWinView["default"]({
    fileInfor: this.fileInfors[0],
    taskCONid: this.fileInfors[0].getTaskCONid()
  });
  win.show();
}), "showDownloadLink", function showDownloadLink() {
  var win = new _MDDownloadLinkWinView["default"]({
    fileInfor: this.fileInfors[0]
  });
  win.show();
}), "editArchiveLibrarys", function editArchiveLibrarys() {
  var win = new _MDEditArchiveLibraryWinView["default"]({
    fileInfors: this.fileInfors,
    onAddSubFolderCallback: function onAddSubFolderCallback(parentId) {
      console.log('添加子分类到：', parentId);
      // 弹出对话框创建子分类
    }
  });
  win.show();
}), "canEditAttr", function canEditAttr() {
  if (!_app["default"].isEpVersion()) {
    return false;
  }
  var canedit = _.every(this.fileInfors, function (file) {
    return !file.isFolder() && !file.isDeleted();
    // && file.canManageFilePermission()
  });
  return canedit;
}), (0, _defineProperty2["default"])(_MDFileActionControll, "editFileAttr", function editFileAttr() {
  var _this = this;
  var fileAttrs = [];
  if (this.fileInfors.length === 1) {
    var cached = this.fileInfors[0].get("customAttrs");
    if (cached) {
      fileAttrs.push.apply(fileAttrs, (0, _toConsumableArray2["default"])(cached));
    }
  }
  var win = new _MDEditFileAttrWinView["default"]({
    fileInfors: this.fileInfors,
    fileAttrs: fileAttrs,
    onSave: function onSave(updatedAttrs) {
      _this.fileInfors.forEach(function (file) {
        file.set("customAttrs", updatedAttrs);
      });
    }
  });
  win.show();
}));
var _default = exports["default"] = MDFileActionController2;

},{"1087":1087,"1091":1091,"1098":1098,"1104":1104,"1125":1125,"1128":1128,"113":113,"1133":1133,"1150":1150,"1180":1180,"1184":1184,"1194":1194,"132":132,"141":141,"1413":1413,"1418":1418,"1430":1430,"1454":1454,"1463":1463,"151":151,"1537":1537,"17":17,"176":176,"18":18,"184":184,"185":185,"228":228,"297":297,"32":32,"325":325,"326":326,"330":330,"352":352,"412":412,"419":419,"468":468,"473":473,"477":477,"478":478,"479":479,"484":484,"485":485,"486":486,"487":487,"489":489,"49":49,"508":508,"514":514,"520":520,"523":523,"524":524,"527":527,"528":528,"530":530,"532":532,"534":534,"535":535,"536":536,"537":537,"539":539,"549":549,"55":55,"554":554,"558":558,"562":562,"565":565,"568":568,"569":569,"577":577,"590":590,"597":597,"615":615,"616":616,"617":617,"618":618,"620":620,"623":623,"630":630,"632":632,"635":635,"641":641,"652":652,"657":657,"658":658,"660":660,"695":695,"697":697,"707":707,"717":717,"72":72,"76":76,"763":763,"781":781,"811":811,"812":812}],1133:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1417);
require(1463);
require(1477);
require(1541);
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDInputFileNamePanel = _interopRequireDefault(require(1125));
var _MDfileUploadList = _interopRequireDefault(require(345));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDLoadMaskView = _interopRequireDefault(require(49));
var _MDShareFileWindowView = _interopRequireDefault(require(695));
var MDTiptapEditorController = {
  editor: null,
  editBabelOfficeFile: function editBabelOfficeFile(fileInfo) {
    this.fileInfo = fileInfo;
    var fileId = fileInfo.getFileId();
    this.tiptapServerUrl = "/netdrive/editBabelOffice.do?fileId=".concat(fileId);
    // this.tiptapServerUrl = `http://localhost:3000/`
    initPanel.call(this);
    _MDLoadMaskView["default"].show();
    this.initTiptap(fileInfo);
  },
  createBabelOfficeFile: function createBabelOfficeFile(parentFolderId, fileName) {
    this.tiptapServerUrl = "/netdrive/createBabelOffice.do?parentFolderId=".concat(parentFolderId, "&fileName=").concat(fileName);
    // this.tiptapServerUrl = `http://localhost:3000/`
    initPanel.call(this);
    _MDLoadMaskView["default"].show();
    this.initTiptap();
  },
  initTiptap: function initTiptap(fileInfo) {
    Dispatcher.on(MDEvents.tiptopUploadFile, _newUpload, this);
    this.iframe = document.createElement('iframe');
    this.iframe.style.width = '100%';
    this.iframe.style.height = '100%';
    this.iframe.style.border = 'none';
    this.iframe.src = this.tiptapServerUrl;
    var originFolder = app.currentFolder;

    // 监听来自 iframe 的消息
    // window.addEventListener('message', this.handleIframeMessage.bind(this));
    var self = this;
    this.$el.find('.tiptap-panel').append(this.iframe);
    _MDLoadMaskView["default"].remove();
    window.addEventListener('message', handleIframeMessage);
    function handleIframeMessage(event) {
      // 验证消息来源
      // if (event.origin !== this.tiptapServerUrl) return;

      switch (event.data.type) {
        case 'UPLOAD_FILE':
          handleFileUpload(event.data.file);
          break;
        case 'CLOSE_PANEL':
          handleClose();
          break;
        case 'SHARE_FILE':
          handleShare();
          break;
        case 'EDITOR_CONTENT_CHANGE':
          console.log(event.data.content);
          // this.model.set('content', event.data.content);
          break;
      }
    }
    this.handleIframeMessage = handleIframeMessage;
    function handleClose() {
      closeBtnClicked.call(self);
    }
    function handleShare() {
      var wind = new _MDShareFileWindowView["default"]({
        fileInfor: fileInfo
      });
      wind.show();
    }
    function handleFileUpload(file) {
      app.currentFolder = MMNetDiskDataController.getHomeDir();
      if (!app.currentFolder.canUpload()) {
        MDMessageView.error(BabelStr.str(13120));
        return;
      }
      app.currentFolder.set("fotTiptap", true);
      _MDfileUploadList["default"].pushFile(file, undefined, undefined, undefined);
      return;
    }
    function _newUpload(fileInfo) {
      var disUrl = location.origin + MMCommonFun.getImageDispPath(fileInfo.getFileId(), -1) + "&needJump2Url=2";
      this.iframe.contentWindow.postMessage({
        type: 'UPLOAD_SUCCESS',
        fileUrl: disUrl // 假设返回中包含文件 URL
      }, this.tiptapServerUrl);
    }
  },
  setFileName: function setFileName(name) {
    if (name) {
      var ext = MMCommonFun.getFileExtension(name);
      var reg = /^\d*$/;
      if (ext.length == 0 || ext[ext.length - 1].length == 0 || reg.test(ext[ext.length - 1])) {
        name += ".drawio";
      }
      this.fileName = name;
      // this.$el.find('.text-file-name').text(name);
    } else {
      this.fileName = null;
    }
  },
  removeFromSuperview: function removeFromSuperview() {
    this.$el.remove();
    // this.editor.removeFromSuperview();
    this.editor = null;
    this.fileInfo = null;
    this.fileName = null;
    MDTiptapEditorController.url = null;
    unregisterEvent.call(this);
    window.removeEventListener('message', this.handleIframeMessage);
    if (this.newVersionUploaded && this.refreshBrowserFun) {
      this.refreshBrowserFun();
    }
    this.refreshBrowserFun = undefined;
  }
};

// ---------------------  private function

function initPanel() {
  var text = "<div class=\"text-editor-root\">\n  <div class=\"text-panel\">\n\n  <div class=\"tiptap-panel\">\n  </div>\n\n  </div>\n\n</div>";
  // var text = `<div class="drawio-panel flex-align center middle">
  //   正在加载中
  // </div>`
  this.$el = $(text);
  $(".app-root").append(this.$el);
  registerEvent.call(this);
}
function registerEvent() {
  var self = this;
  this.$el.find(".back-home").on("click", function (e) {
    location.href = "main.do";
  });
  this.$el.find(".text-close").on("click", function (e) {
    closeBtnClicked.call(self, e);
  });
}
function unregisterEvent() {
  this.$el.find(".text-close").off("click");
  this.$el.find(".text-save").off("click");
  $(window).off("beforeunload.km");
}
function closeBtnClicked(e) {
  var _this = this;
  this.removeFromSuperview();
  return;
  if (_.isEqual(this.originKmFileData, data)) {
    this.removeFromSuperview();
  } else {
    var alert = new _MDAlertView["default"]();
    alert.show({
      title: BabelStr.str(170),
      message: "<p class=\"title\">".concat(BabelStr.str(5108), "</p>"),
      className: "m-delAlertWin",
      width: 350,
      buttons: [{
        label: BabelStr.str(3080),
        type: "done",
        onClick: function onClick() {
          saveFile.call(_this, function () {
            _this.removeFromSuperview();
          });
        }
      }, {
        label: BabelStr.str(5109),
        type: "done",
        onClick: function onClick() {
          _this.removeFromSuperview();
        }
      }, {
        label: BabelStr.str(155)
      }]
    });
  }
}
function saveBtnClicked(e) {
  saveFile.call(this);
}
function exportClicked(e) {
  var win = new MDExportKityminderWinView({
    minder: this.editor.minder,
    name: this.fileName
  });
  win.show();
}
function saveFile(callback) {
  var _this2 = this;
  if (MDTiptapEditorController.fileName == null) {
    var text = MDTiptapEditorController.newSvgData;
    if (!text || text.length == 0) {
      _MDSnackbarView["default"].show(BabelStr.str(5110));
      return;
    }
    var inputFileNamePanel = new _MDInputFileNamePanel["default"]({
      saveFile: function saveFile(fileName) {
        _czc && _czc.push(["_trackEvent", "创建", "创建 md 文件", "", fileName, ""]);
        MDTiptapEditorController.setFileName(fileName);
        uploadNewFile.call(_this2);
        inputFileNamePanel.close();
        if (callback) {
          callback();
        }
      }
    });
    inputFileNamePanel.show();
  } else {
    uploadNewVersion.call(this, callback);
  }
}
function uploadNewFile() {
  var _this3 = this;
  if (!this.uploading) {
    this.uploading = true;
  }
  setTimeout(function () {
    _this3.uploading = false;
  }, 2000);
  var data = MDTiptapEditorController.newSvgData;

  // var dataInfo = {};
  // dataInfo.fileName = this.fileName;
  // dataInfo.name = this.fileName;
  // dataInfo.type = "text";
  // dataInfo.size = data.length;
  // dataInfo.text = data;

  var blob = new Blob([data], {
    type: 'text/plain'
  });
  var dataInfo = new File([blob], this.fileName);
  dataInfo.needCheckFileName = true;
  _MDfileUploadList["default"].pushFile(dataInfo, function (fileInfo) {
    // this.originKmFileData = this.newSvgData;
    _this3.fileInfo = fileInfo;
    // this.originDrawioData = data
    if (fileInfo) {
      // this.editor && this.editor.markClean();
    } else {
      MDTiptapEditorController.setFileName(null);
    }
    console.error("上传完毕");
    _MDAlertView["default"].showStandardPrompt({
      message: BabelStr.str(3556)
    });
  }, undefined, undefined, {
    len: 1
  });
}
function uploadNewVersion(callback) {
  var self = this;
  if (!this.fileInfo) {
    return;
  }
  var data = MDTiptapEditorController.newSvgData;

  // if(data == this.originDrawioData) {
  //   console.log('数据相同')
  //   return
  // }

  // var dataInfo = {};
  // dataInfo.fileName = this.fileName;
  // dataInfo.name = this.fileName;
  // dataInfo.type = "text";
  // dataInfo.size = data.length;
  // dataInfo.text = data;

  var blob = new Blob([data], {
    type: 'text/plain'
  });
  var dataInfo = new File([blob], this.fileName);
  _MDfileUploadList["default"].pushFile(dataInfo, this.fileInfo, function () {
    // this.originDrawioData = data
    console.error("上传完毕");
    _MDAlertView["default"].showStandardPrompt({
      message: BabelStr.str(3556)
    });
    if (callback) {
      callback();
    }
  });
}
var _default = exports["default"] = MDTiptapEditorController;

},{"1125":1125,"1184":1184,"1412":1412,"1417":1417,"1454":1454,"1463":1463,"1477":1477,"1541":1541,"32":32,"345":345,"49":49,"695":695,"72":72}],707:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDUnzipFileTableView = _interopRequireDefault(require(706));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDUnzipFilePathNavView = _interopRequireDefault(require(704));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 *  在线解压
 *  Created by jichao
 *  2020.10.10
 */
var MDUnzipFileWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDUnzipFileWinView, _MDWindowView);
  function MDUnzipFileWinView() {
    (0, _classCallCheck2["default"])(this, MDUnzipFileWinView);
    return _callSuper(this, MDUnzipFileWinView, arguments);
  }
  (0, _createClass2["default"])(MDUnzipFileWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<div>\n      <div class=\"path-block\"></div>\n    </div>\n    <div class=\"help-block f-tr load-num-content\"></div>\n    <div class=\"file-table-content\"></div>";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUnzipFileWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " file-unzip-win");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUnzipFileWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {});
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUnzipFileWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .add-staff, .change-staff, .user-input': this.searchStaff,
        'click .view-file': this._lookPersonFile
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      var userInfo = props.userInfo;
      props.size = "large";
      props.title = BabelStr.str(7471); //  "转移文件归属";
      props.buttons = [{
        label: BabelStr.str(7471),
        type: 'done',
        onClick: this.submit
      }, {
        label: BabelStr.str(3081) // '取消'
      }];
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUnzipFileWinView.prototype), "initialize", this).call(this, props);
      this.navView = new _MDUnzipFilePathNavView["default"]({
        openFolder: function openFolder(folderId) {
          _this.openFolder(folderId);
        }
      });
      this.addSubView(this.navView, this.$('.path-block')[0]);
      this.tableView = new _MDUnzipFileTableView["default"]({
        openFolder: function openFolder(file) {
          _this.navView.pushFileInfor(file);
        }
      });
      this.addSubView(this.tableView, this.$('.file-table-content'));
    }
  }, {
    key: "openFolder",
    value: function openFolder(folderId) {
      this.tableView.requestFolder(folderId);
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUnzipFileWinView.prototype), "viewDidRendered", this).call(this);
    }
  }]);
  return MDUnzipFileWinView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"704":704,"706":706,"93":93}],706:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDUnzipFileTableRowView = _interopRequireDefault(require(705));
var _MDTableView = _interopRequireDefault(require(89));
var _SortDirection = _interopRequireDefault(require(91));
var _PropType = _interopRequireDefault(require(90));
var MDUnzipFileTableView = _MDTableView["default"].extend({
  className: function className() {
    var superCls = _MDTableView["default"].prototype.className.call(this);
    return superCls + ' table-striped';
  },
  initProps: function initProps(opt) {
    var superP = _MDTableView["default"].prototype.initProps.call(this, opt);
    return _.extend(superP, {});
  },
  initialize: function initialize(opt) {
    var self = this;
    opt = _.extend({
      onContextmenu: function onContextmenu(e) {
        return self.createContextmenu(e);
      },
      rowClass: _MDUnzipFileTableRowView["default"],
      sorters: [{
        dataIndex: 'fileName',
        direction: _SortDirection["default"].Asc,
        propType: _PropType["default"].String,
        name: BabelStr.str(158),
        // '名称'
        sortFn: function sortFn(pre, next, order) {
          return MMFileInfo.comparer(pre, next, {
            order: order,
            fieldName: "fileName",
            propType: _PropType["default"].String
          });
        }
      }],
      columns: [{
        name: BabelStr.str(158),
        //  '名称',
        dataIndex: 'fileName',
        flex: 1,
        cellCls: 'title-col'
      }, {
        name: BabelStr.str(27),
        // '大小',

        dataIndex: 'fileSize',
        width: 100
      }]
    }, opt);
    opt.onRowSelectionChanged = this._onRowSelectionChanged;
    _MDTableView["default"].prototype.initialize.call(this, opt);
    this.requestFolder('0');
  },
  requestFolder: function requestFolder(fileId, success, fail) {
    var self = this;
    this.startLoadingState();
    MMNetDiskDataController.getHomeFiles(fileId, MMNetDiskDataController.LISTTYPES.ALL, function (fileInforCollection) {
      self.clearLoadingState();
      self.setActiveSorter({
        dataIndex: 'latestVersionTime'
      }, false, false);
      self.setDataCollection(fileInforCollection, true);
      if (_.isFunction(success)) {
        success();
      }
    }, function (e) {
      self.clearLoadingState();
      MDSnackbarView.show(BabelStr.str(7027));
      if (_.isFunction(fail)) {
        fail();
      }
    }, function () {});
  }
});
var _default = exports["default"] = MDUnzipFileTableView;

},{"1184":1184,"1454":1454,"705":705,"89":89,"90":90,"91":91}],705:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1424);
var _MDTableRowView = _interopRequireDefault(require(88));
var _MDChooseFolderWindow = _interopRequireDefault(require(483));
var MDUnzipFileTableRowView = _MDTableRowView["default"].extend({
  initProps: function initProps() {
    var superP = _MDTableRowView["default"].prototype.initProps.call(this);
    var self = this;
    return _.extend(superP, {
      isHomeTableRowView: false,
      fileInfor: null,
      columnRenders: function columnRenders() {
        return [{
          name: BabelStr.str(158),
          //'名称',
          cellCls: 'title-col',
          dataIndex: 'fileName',
          flex: 3,
          render: function render(name, f, index) {
            var fileName = f.escape("fileName");
            var fileSize = f.get("fileSize");
            var btns = self.createDispBtn();
            var tmpl = " <div>\n                <div class=\"thumbWrapper file-icon-root\">\n                </div>\n                <div class=\"contentWrapper\">\n                  <div class=\"content\">\n                    <div class=\"name-wrapp\">\n                      <div class=\"inner\">\n                        <span class=\"name notclick\" title=\"".concat(name, " \"> ").concat(name, "</span>\n                      </div>\n                      </div>\n                    </div>\n                  </div>\n                  <div class=\"btns\">\n                    ").concat(btns.join(), "\n                  </div>\n                </div>\n                <div class = \"extra-attr\"></div>\n              </div>");
            return tmpl;
          }
        }, {
          name: BabelStr.str(227),
          //'大小',
          dataIndex: 'fileSize',
          flex: 1,
          render: function render(name, model, index) {
            var fileInfor = model;
            if (fileInfor.isFolder()) {
              return "--";
            } else {
              return app.getFileSizeDescription(fileInfor.get('fileSize'));
            }
          }
        }];
      }
    });
  },
  events: function events() {
    var superE = _MDTableRowView["default"].prototype.events.call(this);
    return _.extend(superE, {
      "click .unzip": this._unzipFile,
      "click .download": this._downloadFile,
      'dblclick': this.openFolder
    });
  },
  initialize: function initialize(opt) {
    _MDTableRowView["default"].prototype.initialize.call(this, opt);
    this.fileInfor = opt.rowModel;
    var thumbDiv = this.$(".thumbWrapper");
    this.fileInfor.setIconForDiv(thumbDiv);
  },
  openFolder: function openFolder() {
    if (this.fileInfor.isFolder()) {
      this.tableView.openFolder(this.fileInfor);
    }
  },
  _downloadFile: function _downloadFile($e) {
    $e.stopPropagation();
  },
  _unzipFile: function _unzipFile($e) {
    var _this = this;
    var folderView = new _MDChooseFolderWindow["default"]({
      onchecked: function onchecked(folderId, pathStr) {
        _this.checkFolderCallback(folderId, pathStr);
      }
    });
    folderView.show();
    $e.stopPropagation();
  },
  createDispBtn: function createDispBtn(f, showStickTop) {
    var unzip = BabelStr.str(7472);
    var download = BabelStr.str(29);
    return ['<button class="unzip button small mgr-10" title="' + unzip + '">' + unzip + '</button><button class="download button small mgr-20" title="' + download + '">' + download + '</button>'];
  }
});
var _default = exports["default"] = MDUnzipFileTableRowView;

},{"1184":1184,"1412":1412,"1424":1424,"1454":1454,"483":483,"88":88}],704:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1432);
require(1424);
require(1412);
require(1429);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMViewBase2 = _interopRequireDefault(require(22));
var _MDFilePathManager = _interopRequireDefault(require(1090));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDUnzipFilePathNavView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MDUnzipFilePathNavView, _MMViewBase);
  function MDUnzipFilePathNavView() {
    (0, _classCallCheck2["default"])(this, MDUnzipFilePathNavView);
    return _callSuper(this, MDUnzipFilePathNavView, arguments);
  }
  (0, _createClass2["default"])(MDUnzipFilePathNavView, [{
    key: "tmpl",
    value: function tmpl() {
      return '<ul class="filePaths f-clb"></ul>';
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUnzipFilePathNavView.prototype), "events", this);
      return _.extend(superE, {
        'click a[href]': this._navigateToFolder,
        'click li.up': this._navigateBack,
        'click .back-to-home': this._backtoHomePanelFromSearch
      });
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUnzipFilePathNavView.prototype), "initialize", this).call(this, opt);
      this.$filePaths = this.$(".filePaths");
      this.renderPaths();
    }
  }, {
    key: "gotoRoot",
    value: function gotoRoot() {
      var curPaths = this.getFilePaths();
      curPaths.splice(1, curPaths.length - 1);
      this.renderPaths();
    }
  }, {
    key: "builderPath",
    value: function builderPath(toIndex) {
      var stringBuilder = [];
      var fileInfor = null;
      var curPaths = this.getFilePaths();
      if (toIndex == 1) {
        stringBuilder.push('#');
      } else {
        for (var i = 0; i < toIndex; i++) {
          fileInfor = curPaths[i];
          stringBuilder.push('/');
          stringBuilder.push(fileInfor.escape('fileName'));
        }
      }
      return stringBuilder.join("");
    }
  }, {
    key: "pushFileInfor",
    value: function pushFileInfor(fileInfor) {
      var curPaths = this.getFilePaths();
      curPaths.push(fileInfor);
      this.renderPaths();
    }
  }, {
    key: "_navigateToFolder",
    value: function _navigateToFolder($e) {
      var fileId = $($e.target.parentNode).data("fileId");
      this.openFolder(fileId);
    }
  }, {
    key: "_navigateToPathLevel",
    value: function _navigateToPathLevel(index) {
      var curPaths = this.getFilePaths();
      var count = curPaths.length - (index + 1);
      curPaths.splice(index + 1, count);
      index = index < 0 ? 0 : index;
      var fileId = curPaths[curPaths.length - 1].get("fileId");
      this.openFolder(fileId);
    }
  }, {
    key: "renderPaths",
    value: function renderPaths() {
      var self = this;
      this.$filePaths.empty();
      var curPaths = this.getFilePaths();
      var l = curPaths.length;
      var finalRenderPaths = curPaths;
      if (curPaths.length > 4) {
        finalRenderPaths = [];
        finalRenderPaths = finalRenderPaths.concat(curPaths.slice(0, 1));
        finalRenderPaths = finalRenderPaths.concat(curPaths.slice(curPaths.length - 9, curPaths.length));
      }
      var needCutPath = curPaths.length != finalRenderPaths.length;
      var pathLength = finalRenderPaths.length;
      _.each(finalRenderPaths, function (fileInfor, index) {
        var fileName = fileInfor.escape("fileName");
        var id = fileInfor.getFileId();
        var stringBuilder = [];
        // 添加返回上级目录
        if (index == 0 && l > 1) {
          var ret = BabelStr.str(362); // 返回上一级目录
          var upFolder = BabelStr.str(10); // 上级目录
          self.$filePaths.append("<li class='up f-fl'>[<a title='".concat(ret, "'>").concat(upFolder, "<span class='icon up'></span></a>]</li>"));
        }
        stringBuilder.push("<li class='f-fl'>");
        if (index >= 1) {
          stringBuilder.push("<i>›</i>");
        }
        if (index < l) {
          var appendStr = '';
          stringBuilder.push("<a title='" + fileName + "' href='" + self.builderPath(index + 1) + "'>" + fileName + "</a>");
        } else {
          stringBuilder.push("<a title='" + fileName + "'>" + fileName + "</a>");
        }
        stringBuilder.push("</li>");
        var $li = $(stringBuilder.join(""));
        $li.data('fileId', id);
        $li.data("fileInfor", fileInfor);
        self.$filePaths.append($li);
        if (index == 0 && needCutPath) {
          self.$filePaths.append("<li><i>›</i>...</li>");
        }
      });
    }
  }, {
    key: "getFilePaths",
    value: function getFilePaths() {
      return _MDFilePathManager["default"].getFilePaths();
    }
  }, {
    key: "_navigateBack",
    value: function _navigateBack() {
      var index = this.getFilePaths().length - 2;
      index = index < 0 ? 0 : index;
      this._navigateToPathLevel(index);
    }
  }]);
  return MDUnzipFilePathNavView;
}(_MMViewBase2["default"]);

},{"1090":1090,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1424":1424,"1429":1429,"1432":1432,"1454":1454,"1463":1463,"1475":1475,"22":22}],697:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1439);
require(1437);
var _MDWindowView = _interopRequireDefault(require(93));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MDSnapshotLinkFileItemView = _interopRequireDefault(require(696));
var _MDSpinnerloaderLayerView = _interopRequireDefault(require(75));
var MDSnapshotLinkFileWindowView = _MDWindowView["default"].extend({
  className: function className() {
    var superCls = _MDWindowView["default"].prototype.className.call(this);
    return superCls + " snapshotLink-file-window share-win with-left-title";
  },
  contentTmpl: "<div class=\"help-block\"><%=BabelStr.str(6341)%></div>\n  <div class=\"flex-align between middle\" >\n    <div class='flex-align middle'>\n      <div class=\"mgr-10 list-show f-none\"><%=BabelStr.str(6346)%>:</div>\n      <div class='empty-snapshot help-block'><%=BabelStr.str(3251)%></div>\n      <div class='list-select-contain list-show f-none'></div>\n    </div>\n    <span class='text-button new-snapshot'><%=BabelStr.str(6342)%></span>\n  </div>\n\n  <div class='snapshot-info list-group'></div>\n  ",
  events: function events() {
    var superE = _MDWindowView["default"].prototype.events.call(this);
    return _.extend(superE, {
      "click .new-snapshot": this._newSnapshot
    });
  },
  initProps: function initProps() {
    var opt = _MDWindowView["default"].prototype.initProps.call(this);
    return _.extend(opt, {});
  },
  initialize: function initialize(opt) {
    var _this = this;
    var self = this;
    opt = _.extend({}, opt);
    this.fileInfor = opt.fileInfor;
    opt.width = 720;
    opt.title = BabelStr.str(6360) + this.fileInfor.getFileName();
    _MDWindowView["default"].prototype.initialize.call(this, opt);
    MMEnterpriseController.getRolesForSnapshotFile(this.fileInfor.getFileId(), function (roles, defaultRole) {
      _this.defaultRoleId = defaultRole.id;
      _this.roles = roles;
      _this.roleIds = [];
      var roleArr = [];
      for (var i = 0; i < _this.roles.length; i++) {
        var role = _this.roles[i];
        var param = {
          "do": role.name
        };
        var des = BabelStr.str(725, param); //"知道此链接的任何人都可以" + role.getRoleName()
        var str = {
          label: des,
          canSelected: true,
          linkRoleId: role.id,
          permission: role.permission,
          systemdefault: role.systemdefault
        };
        _this.roleIds.push(role.id);
        roleArr.push(str);
      }
      _this.roleArr = roleArr;
      _this.renderAllSnapsshot();
      _this.snapshotListView = new _MDDropdownSelectListView["default"]({
        dataProvider: [],
        isFixed: true,
        labelField: "snapshotName",
        onChange: function onChange(data) {
          if (data.snapshotId != -1) {
            _this.currentFileInfo = data.file;
            _this.snapshotItemView && _this.snapshotItemView.remove();
            _this.snapshotItemView = new _MDSnapshotLinkFileItemView["default"]({
              file: data.file,
              fileInfor: _this.fileInfor,
              roleArr: _this.roleArr,
              roleIds: _this.roleIds,
              body: _this.$body,
              ondel: function ondel() {
                _this.renderAllSnapsshot();
              }
            });
            _this.addSubView(_this.snapshotItemView, _this.$(".snapshot-info"));
          }
        }
      });
      _this.addSubView(_this.snapshotListView, _this.$(".list-select-contain")[0]);
    });
  },
  _newSnapshot: function _newSnapshot() {
    var _this2 = this;
    _MDSpinnerloaderLayerView["default"].showIn(this.$body);
    // return
    MMEnterpriseController.createSnapshotLinkShare(this.fileInfor.getFileId(), this.defaultRoleId, function () {
      MDMessageView.success(BabelStr.str(308), _this2.$body);
      _MDSpinnerloaderLayerView["default"].clearFrom(_this2.$body);
      _this2.renderAllSnapsshot();
    }, function (code, msg, res) {
      _MDSpinnerloaderLayerView["default"].clearFrom(_this2.$body);
      if (code == 801) {
        msg = BabelStr.str(21512, {
          limit: res.limit
        });
      }
      MDMessageView.error(msg, _this2.$body);
    });
  },
  viewDidUnRendered: function viewDidUnRendered() {
    _MDWindowView["default"].prototype.viewDidUnRendered.call(this);
  },
  viewDidRendered: function viewDidRendered() {
    _MDWindowView["default"].prototype.viewDidRendered.call(this);
    var $target = this.$(".window-header .title");
    var w = $target[0].offsetWidth;
    var tw = $target[0].scrollWidth;
    if (tw > w) {
      $target.attr("data-tooltip", this.fileInfor.getFileName());
    }
  },
  renderAllSnapsshot: function renderAllSnapsshot() {
    var _this3 = this;
    MMEnterpriseController.getAllSnapshotLinkShares(this.fileInfor.getFileId(), function (shareInfoCollection) {
      if (!shareInfoCollection.length) {
        _this3.$(".empty-snapshot").html(BabelStr.str(6343)).show();
        _this3.$(".list-show").hide();
        _this3.snapshotItemView && _this3.snapshotItemView.remove();
      } else {
        _this3.$(".empty-snapshot").hide();
        _this3.$(".list-show").show();
      }
      var snapshotList = [];
      var snapshotName;
      shareInfoCollection.each(function (file) {
        snapshotName = BabelStr.str(6345) + new Date(file.get("snapTime")).format("yyyy-MM-dd HH:mm:ss");
        snapshotList.push({
          snapshotName: snapshotName,
          snapshotId: file.get("snapshotId"),
          file: file
        });
      });
      _this3.snapshotListView.setDataProvider(snapshotList);
      _this3.snapshotListView.selectItemAt(0);
    }, function (code, msg, res) {
      MDMessageView.error(msg, _this3.$body);
    });
  }
});
var _default = exports["default"] = MDSnapshotLinkFileWindowView;

},{"1184":1184,"1437":1437,"1439":1439,"1454":1454,"67":67,"696":696,"75":75,"93":93}],696:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1436);
require(1546);
require(1437);
require(1421);
require(1417);
require(1463);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMViewBase2 = _interopRequireDefault(require(22));
var _MDCheckboxView = _interopRequireDefault(require(37));
var _MDDropDownSelectRoleView = _interopRequireDefault(require(50));
var _MDFileTypeIconMap = _interopRequireDefault(require(258));
var _MDSendLinkWindow = _interopRequireDefault(require(685));
var _MDSnackbarView = _interopRequireDefault(require(72));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDSnapshotLinkFileItemView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MDSnapshotLinkFileItemView, _MMViewBase);
  function MDSnapshotLinkFileItemView() {
    (0, _classCallCheck2["default"])(this, MDSnapshotLinkFileItemView);
    return _callSuper(this, MDSnapshotLinkFileItemView, arguments);
  }
  (0, _createClass2["default"])(MDSnapshotLinkFileItemView, [{
    key: "tmpl",
    value: function tmpl() {
      var searchUser = BabelStr.str(3109); // 搜索用户名...
      return "\n      <div class='flex-align  between mgb-10'>\n        <div class='flex-align'>\n          <span class=\"mgr-10\"><%=BabelStr.str(6347)%>:</span>\n          <span class=\"mgr-10\"><%=snapTime%></span>\n        </div>\n        <div class=\"flex-align middle\">\n          <span><%=BabelStr.str(12300)%></span>\n          <span class='text-button edit mglr-10'><%=BabelStr.str(2503)%></span>\n          <span><%=BabelStr.str(12301)%></span>\n        </div>\n      </div>\n      <div class=\"item role\" >\n        <input id=\"link\" class=\"form-control br-2\" value=\"<%=shareUrl%>\" readonly/>\n        <div class=\"list1 f-clb\">\n          <ul>\n            <li class=\"list1-left setting-left\">\n            <div class=\"per-select\" id = \"select2\"></div>\n            <div>\n             <div class=\"checkbox-link4\">\n             <div class=\"item-1 f-hide\"><input class=\"password\" disabled=\"true\" /><button id=\"setpwd\" class=\"text-button done\"><%=reset%></button></div>\n            </div>\n            <div>\n             <div class=\"checkbox-link5\">\n               <div class=\"item-1 f-hide\">\n                 <span class = \"datepicker\">\n                   <input type=\"text\" class=\"date-expire\"  placeholder=\"<%=endTime%>\">\n                   <i class = \"icon ep-expire-date\"></i>\n                 </span>\n               </div>\n             </div>\n             <div class=\"checkbox-link6\">\n             </div>\n             <div class=\"link-watermark-checkbox\"></div>\n             <div class=\"anonymous-upload f-none\">\n               <div class=\"flex-align middle with-wrap\">\n                 <div class=\"checkbox-link7 mgr-10\"></div><div class=\"err-msg\"><%=BabelStr.str(3481)%></div>\n               </div>\n               <div class=\"help-block upload-block red f-none\"><%=BabelStr.str(3480)%></div>\n               </div>\n             <div class=\"checkbox-link8\">\n             </div>\n\n            </div>\n            </li>\n            <li class=\"list1-right m-qrcode f-fr\">\n              <button class=\"qrcode-btn icon\" title=\"<%=BabelStr.str(415)%>\">\n                <div class=\"qrcode-pop f-tc\" title=\"<%=BabelStr.str(416)%>\">\n                <div class=\"qrcode-canvas\"></div>\n                <div class=\"intro\">\n                  <p><%=BabelStr.str(5417)%></p>\n                  <p class=\"text-button copy-qrcode\"><%=BabelStr.str(5416)%></p>\n                </div>\n                </div>\n              </button>\n            </li>\n            <li class=\"list1-right\">\n              <a id=\"copyBtn\" class=\"input-group-btn button done\">\n                <span><%=BabelStr.str(80)%></span>\n              </a>\n            </li>\n          </ul>\n        </div>\n        <div class='flex-align between middle'>\n          <div class='text-button del'><%=BabelStr.str(6348)%></div>\n          <button id=\"send-link\" class=\"f-fr mgt-10 blue\" data-tooltip-dir=\"top\" data-tooltip=\"<%=BabelStr.str(7289)%>\"><%=BabelStr.str(7289)%></button>\n        </div>\n         <div class='flex-align end mgt-10'>\n          <span class=\"button cancel mgr-15\"><%=BabelStr.str(155)%></span>\n          <span class=\"button done save\"><%=BabelStr.str(3080)%></span>\n        </div>\n      </div>\n      ";
    }
  }, {
    key: "copyTmpl",
    value: function copyTmpl() {
      return "<table cellspacing=\"0\" cellpadding=\"0\" min-width=\"350\" max-width=\"350\" height=\"94\" style=\"background-color: rgb(248, 248, 248);\">\n        <tbody>\n            <tr>\n                <td height=\"40\" min-width=\"180\" style=\"min-width: 180px;\"><span style=\"display: none; max-height: 0px; font-size: 0px; overflow: hidden;\">\u5206\u4EAB\u5185\u5BB9:</span><a id=\"fileLinks\" href=\"<%=url%>\" target=\"_blank\" title=\"2021-11-30 15:40\u521B\u5EFA\u7684\u94FE\u63A5\" style=\"cursor: pointer; font-size: 16px; font-weight: bold; color: rgb(5, 15, 40); margin-left: 8px; text-decoration: none; display: inline-block; margin-top: 10px;\">\n <%=fileName%>\n </a><br><span style=\"display: none; max-height: 0px; font-size: 0px; overflow: hidden;\">\n &nbsp;\u94FE\u63A5\u5730\u5740:<%=url%>\n </span></td>\n                <td rowspan=\"2\" align=\"left\" width=\"68\"><a width=\"52\" href=\"<%=url%>\" target=\"_blank\" style=\"text-decoration: none;\"><input type=\"button\" value=\"\u67E5\u770B\" width=\"52\" height=\"24\" style=\"pointer-events: none; color: rgb(255, 255, 255); margin: 20px 12px 8px; font-size: 14px; background: rgb(44, 125, 241); border-radius: 2px; width: 52px; height: 24px; border: none; cursor: pointer;\"></a></td>\n            </tr>\n            <tr>\n                <td height=\"20\" id=\"LinkFileSizes\" align=\"left\" style=\"font-size: 12px; color: rgb(103, 112, 124); height: 20px; line-height: 20px; padding-right: 1px; margin-left: 4px; display: inline-block; margin-top: 6px; margin-bottom: 6px;\"><span>\n                <%if(password){%>\n                  &nbsp;\u63D0\u53D6\u7801:</span><span style=\"margin-right: 6px;\"><%=password%></span>\n                <%}%>\n                <%if(endTime){%>\n                  <span>\u5230\u671F\u65E5:</span><span><%=endTime%></span></td>\n                <%}%>\n            </tr>\n            <tr>\n                <td height=\"30\" colspan=\"3\" style=\"font-size: 12px; background-color: rgb(248, 248, 248); border-top: 1px solid rgb(234, 234, 234);\"><span target=\"_blank\" style=\"margin-left: 4px; text-decoration: none; color: rgb(146, 156, 169);\">\n &nbsp;\u6765\u81EA\u4E8E:&nbsp;<%=userName%>\n </span></td>\n            </tr>\n        </tbody>\n    </table>";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSnapshotLinkFileItemView.prototype), "className", this).call(this);
      return "".concat(superCls, " snapshot-item-info");
    }
  }, {
    key: "render",
    value: function render(data) {
      var _this = this;
      var self = this;
      var file = this.file.toJSON();
      data = _.extend(file, {
        snapTime: new Date(file.snapTime).format("yyyy-MM-dd HH:mm:ss"),
        reset: BabelStr.str(724),
        // 重置密码
        endTime: BabelStr.str(176)
      });
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSnapshotLinkFileItemView.prototype), "render", this).call(this, data);
      this.checkbox4 = new _MDCheckboxView["default"]({
        label: BabelStr.str(82),
        // "访问此链接需要输入密码",
        // isBlockLevel: false,
        editable: false,
        onChanged: function onChanged(checked) {
          _this._pwdOnChanged(checked);
        }
      });
      this.addSubView(this.checkbox4, this.$(".checkbox-link4")[0]);
      this.initExpireTime();
      this.initSendInformation();
      this.anonymousVisit = new _MDCheckboxView["default"]({
        label: BabelStr.str(6328),
        // "允许匿名访问",
        // isBlockLevel: false,
        editable: false,
        onChanged: function onChanged(checked) {
          1;
          if (!app.isEpVersion() && app.currentUser.inFreeEdition()) {
            _this.anonymousVisit.setChecked(!checked, true);
            _MDSnackbarView["default"].show(BabelStr.str(827));
            return;
          }
          if (app.isEpVersion() && app.ep.isAnoymousClosed() && checked) {
            _this.anonymousVisit.setChecked(!checked, true);
            _MDSnackbarView["default"].show(BabelStr.str(6654));
            return;
          }
          var value = checked ? 1 : 0;
          _this.file.set("anonymousVisit", value);
        }
      });
      this.addSubView(this.anonymousVisit, this.$(".checkbox-link8")[0]);
      var index = _.indexOf(this.roleIds, this.file.get("linkRoleId"));
      this.select2 = new _MDDropDownSelectRoleView["default"]({
        index: index,
        bd: this.roleArr,
        // roles: this.roles,
        invite: false,
        minW: "510px",
        showHelp: true,
        onChange: function onChange(item) {
          self.file.set("linkRoleId", item.linkRoleId);
        }
      });
      this.addSubView(this.select2, this.$("#select2")[0]);
      if (this.file.get("password")) {
        this.checkbox4.setChecked(true);
      }
      if (this.file.get("anonymousVisit")) {
        this.anonymousVisit.setChecked(true, true);
      }
      this.$(".qrcode-canvas").empty().qrcode({
        width: 160,
        height: 160,
        text: this.file.get("shareUrl")
      });
      if (!app.isEpVersion()) {
        this.$el.find("#send-link").remove();
      }
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSnapshotLinkFileItemView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click #setpwd": this._setAddPwd,
        "click .del": this._del,
        "click .edit": this._edit,
        "click .cancel": this._cancel,
        "click .save": this._save,
        "mouseenter .qrcode-btn": this._showQRCodePopup,
        "mouseleave .qrcode-btn": this._hideQRCodePopup,
        "click .qrcode-canvas canvas": this._copyQrcode,
        "click .copy-qrcode": this._copyQrcode,
        "click #copyBtn": this._copy,
        "click #send-link": this.sendLink,
        "click .datepicker i": this.showDatePicker
      });
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      this.props = opt;
      var file = this.props.file.clone();
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSnapshotLinkFileItemView.prototype), "initialize", this).call(this, opt);
      this.props.file = file;
      this.bindSelf(this.listenToCopyNew);
      if (app.browser && app.browser.safari) {
        // if(app.browser && app.browser.chrome ) {
        this.listenToCopy();
      }
    }
  }, {
    key: "showDatePicker",
    value: function showDatePicker() {
      var $expireTimeBox = this.$(".date-expire");
      $expireTimeBox.focus();
    }
  }, {
    key: "initExpireTime",
    value: function initExpireTime() {
      var _this2 = this;
      var self = this;
      this.expireCheckBox = new _MDCheckboxView["default"]({
        label: BabelStr.str(726),
        //  "设置分享截止日期",
        // isBlockLevel: false,
        editable: false,
        onChanged: function onChanged(checked) {
          _this2.setExpireTime(checked);
        }
      });
      this.addSubView(this.expireCheckBox, this.$(".checkbox-link5")[0]);
      var $expireTimeBox = this.$(".date-expire");
      $expireTimeBox.datepicker({
        minDate: 1
      }).on("change", function () {
        var exDate = $expireTimeBox.datepicker("getDate");
        self.file.setLinkShareExpireTime(exDate.getTime());
      });
      var expireTime = this.file.getLinkShareExpireTime();
      if (expireTime) {
        this.expireCheckBox.setChecked(true, true);
        expireTime = new Date(expireTime);
        this._onExpireTimeSetted(expireTime);
      }
    }
  }, {
    key: "setExpireTime",
    value: function setExpireTime(checked) {
      var self = this;
      var isHttps;
      if (!this.expireCheckBox) {
        return;
      }
      if (checked) {
        this._setDefaultExpireTime(function (expireTime) {
          self.expireCheckBox.setChecked(true, true);
        }, function () {
          self.expireCheckBox.setChecked(false, true);
        });
      } else {
        self.file.setLinkShareExpireTime(0);
      }
    }
  }, {
    key: "_setDefaultExpireTime",
    value: function _setDefaultExpireTime() {
      var now = new Date();
      var defaultTime = now.setDate(now.getDate() + 7);
      var localDefault = new Date(defaultTime).toLocaleDateString();
      var expireTime = new Date(localDefault).getTime() + 1000 * 60 * 60 * 24 - 1;
      this.file.setLinkShareExpireTime(expireTime);
      this._onExpireTimeSetted(expireTime);
    }
  }, {
    key: "_onExpireTimeSetted",
    value: function _onExpireTimeSetted(expireTime) {
      var self = this;
      self.$(".checkbox-link5 .item-1 ").addClass("f-inline-block");
      self.$(".checkbox-link5 .item-1").removeClass("f-hide");
      var $expireTimeBox = self.$(".datepicker");
      $expireTimeBox.datepicker("setDate", expireTime);
      self.$(".datepicker input").val(new Date(expireTime).format("yyyy-MM-dd"));
    }
  }, {
    key: "initSendInformation",
    value: function initSendInformation() {
      var _this3 = this;
      var self = this;
      this.informCheckBox = new _MDCheckboxView["default"]({
        label: BabelStr.str(727),
        // "发送分享参与动态信息给通过链接加入者",
        // isBlockLevel: false,
        editable: false,
        onChanged: function onChanged(checked) {
          var value = checked ? 1 : 0;
          _this3.file.set("sendAccessInfo", value);
        }
      });
      this.addSubView(this.informCheckBox, this.$(".checkbox-link6")[0]);
      var informCheck = this.file.getSendAccessInfoToLinkedIn();
      if (informCheck) {
        this.informCheckBox.setChecked(true, true);
      }
    }
  }, {
    key: "_setAddPwd",
    value: function _setAddPwd() {
      var password = MMCommonFun.generateRandomString(5);
      this.$(".password").val(password);
      this.file.set("password", password);
    }
  }, {
    key: "_pwdOnChanged",
    value: function _pwdOnChanged(checked) {
      var self = this;
      var isHttps;
      if (!this.checkbox4) {
        return;
      }
      if (checked) {
        this.checkbox4.setLabel(BabelStr.str(729)); //("访问密码");
        if (this.file.get("password")) {
          this.$(".password").val(this.file.get("password"));
        } else {
          this._setAddPwd();
        }
        this.$(".checkbox-link4 .item-1 ").addClass("f-inline-block");
        this.$(".checkbox-link4 .item-1").removeClass("f-hide");
      } else {
        this.checkbox4.setLabel(BabelStr.str(3304));
        this.$(".checkbox-link4 .item-1").removeClass("f-inline-block");
        this.$(".checkbox-link4 .item-1 ").addClass("f-hide");
        self.$(".password").val("");
        this.file.set("password", "");
      }
    }
  }, {
    key: "_edit",
    value: function _edit() {
      this.$el.addClass("edit-mode");
      this.checkbox4.setEditable(true);
      this.anonymousVisit.setEditable(true);
      this.expireCheckBox.setEditable(true);
      this.informCheckBox.setEditable(true);
    }
  }, {
    key: "_cancel",
    value: function _cancel() {
      this.$el.removeClass("edit-mode");
      this.file = this.props.file.clone();
      this.refresh();
      // this.checkbox4.setEditable(false)
      // this.anonymousVisit.setEditable(false)
      // this.expireCheckBox.setEditable(false)
      // this.informCheckBox.setEditable(false)
    }
  }, {
    key: "_del",
    value: function _del() {
      var _this4 = this;
      MMEnterpriseController.removeSnapshotLinkShare(this.file.get("snapshotId"), function () {
        _this4.ondel();
        MDMessageView.success(BabelStr.str(308), _this4.body);
      }, function (code, msg, res) {
        MDMessageView.error(BabelStr.str(msg), _this4.body);
      });
    }
  }, {
    key: "_save",
    value: function _save() {
      var _this5 = this;
      var param = {
        snapshotId: this.file.get("snapshotId"),
        linkRoleId: this.file.get("linkRoleId"),
        anonymousVisit: this.file.get("anonymousVisit"),
        expireTime: this.file.getLinkShareExpireTime() / 1000,
        password: this.file.get("password"),
        sendAccessInfo: this.file.get("sendAccessInfo")
      };
      MMEnterpriseController.updateSnapshotShareOption(param, function () {
        MDMessageView.success(BabelStr.str(308), _this5.body);
        _this5.$el.removeClass("edit-mode");
      }, function (code, msg, res) {
        MDMessageView.error(msg, _this5.body);
      });
    }
  }, {
    key: "_copyQrcode",
    value: function _copyQrcode(e) {
      var self = this;
      var target = this.$(".qrcode-canvas canvas")[0];
      MMCommonFun.clipboardCopyCanvas(target, function () {
        console.log("success");
        MDMessageView.success(BabelStr.str(5415), self.body);
      }, function () {
        MDMessageView.error(BabelStr.str(5418), self.body);
        console.log("fail");
      });
    }
  }, {
    key: "_showQRCodePopup",
    value: function _showQRCodePopup($e) {
      var self = this;
      var $qpopup = this.$(".qrcode-pop");
      if ($qpopup.hasClass("opened")) {
        return;
      }
      $qpopup.show();
      $qpopup[0].offsetWidth;
      $qpopup.addClass("opened");
      return false;
    }
  }, {
    key: "_copy",
    value: function _copy(e) {
      var self = this;
      var listenToCopyNew = function listenToCopyNew(e) {
        self.listenToCopyNew(e);
      };
      document.addEventListener("copy", listenToCopyNew);
      document.execCommand("copy");
      document.removeEventListener("copy", listenToCopyNew);
    }
  }, {
    key: "listenToCopyNew",
    value: function listenToCopyNew(e) {
      var size;
      if (this.file.isFolder()) {
        size = "--";
      } else {
        size = app.getFileSizeDescription(this.file.get("currentVersionSize"));
      }
      var endTime = this.file.getLinkShareExpireTime();
      if (endTime) {
        endTime = new Date(endTime).format("yyyy-MM-dd");
      } else {
        endTime = "";
      }
      var data = {
        url: this.file.get("shareUrl"),
        // blob: this.imgDataUrl,
        now: new Date().format("yyyy-MM-dd HH:mm"),
        password: this.file.get("password"),
        endTime: endTime,
        userName: app.currentUser.getUserName(),
        size: size,
        fileName: BabelStr.str(6340) + "--" + this.fileInfor.getFileName()
      };
      var str;
      if (this.linkPwd) {
        var linkCap = BabelStr.str(409); // 链接
        var pwdCap = BabelStr.str(394); // 密码
        // return BabelStr.str(825, {name: this.fileInfor.getFileName()}) +
        str = linkCap + " : " + this.file.get("shareUrl") + " " + pwdCap + " : " + this.file.get("password");
      } else {
        // return BabelStr.str(825, {name: this.fileInfor.getFileName()}) +
        str = this.file.get("shareUrl");
      }
      var tmpl = _.template(this.copyTmpl())(data);
      e.clipboardData.setData("text/html", tmpl);
      e.clipboardData.setData("text/plain", str);
      MDMessageView.success(BabelStr.str(411), this.$el);
      e.preventDefault();
    }
  }, {
    key: "listenToCopy",
    value: function listenToCopy() {
      var self = this;
      var $btn = this.$("#copyBtn");
      var clipboard = new Clipboard($btn.get(0), {
        text: function text() {
          if (self.file.get("password")) {
            var linkCap = BabelStr.str(409); // 链接
            var pwdCap = BabelStr.str(394); // 密码
            // return BabelStr.str(825, {name: self.fileInfor.getFileName()}) +
            var str = linkCap + " : " + self.file.get("shareUrl") + " " + pwdCap + " : " + self.file.get("password");
            return str;
          } else {
            // return BabelStr.str(825, {name: self.fileInfor.getFileName()}) +
            return self.file.get("shareUrl");
          }
        }
      });
      clipboard.on("success", function (e) {
        e.clearSelection();
        var copyCap0 = BabelStr.str(410); // 链接和密码已拷贝到剪贴板
        var copyCap1 = BabelStr.str(411); // 链接已拷贝到剪贴板
        var tip = self.file.get("password").length > 0 ? copyCap0 : copyCap1;
        self.showTooltip($btn, tip);
      });
      clipboard.on("error", function (e) {
        var tip = "";
        if (app.os.mac) {
          tip = BabelStr.str(412); //  "请按 ⌘+C  拷贝链接";
        } else {
          tip = BabelStr.str(413); //  "请按 Ctrl+C 拷贝链接";
        }
        self.$("#link").select();
        self.showTooltip($btn, tip);
      });
      this.clipboard = clipboard;
    }
  }, {
    key: "showTooltip",
    value: function showTooltip(el, msg) {
      var $el = $(el).find("span");
      $el.addClass("tooltipped tooltipped-bc");
      $el.attr("aria-label", msg);
      $el.one("mouseleave", function () {
        $el.removeClass("tooltipped tooltipped-bc");
        $el.removeAttr("aria-label");
      });
    }
  }, {
    key: "_hideQRCodePopup",
    value: function _hideQRCodePopup($e) {
      var self = this;
      var $qpopup = self.$(".qrcode-pop");
      var $mqpopup = self.$(".qrcode-btn");
      var popDOM = $mqpopup.get(0);
      if ($qpopup.css("display") == "none") {
        return;
      }
      $qpopup.transitionEndOnce(function () {
        !$qpopup.hasClass("opened") && $qpopup.hide();
      });
      $qpopup.removeClass("opened");
    }
  }, {
    key: "sendLink",
    value: function sendLink(e) {
      var link = this.$el.find("#link").val();
      var sendWin = new _MDSendLinkWindow["default"]({
        fid: this.file.getFileId(),
        link: link,
        fileInfor: this.file
      });
      sendWin.show();
    }
  }]);
  return MDSnapshotLinkFileItemView;
}(_MMViewBase2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1417":1417,"1421":1421,"1436":1436,"1437":1437,"1454":1454,"1463":1463,"1475":1475,"1546":1546,"22":22,"258":258,"37":37,"50":50,"685":685,"72":72}],685:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1488);
var _MDWindowView = _interopRequireDefault(require(93));
var _MDEnterpriseShareTabView = _interopRequireDefault(require(675));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _regexp = _interopRequireDefault(require(106));
var _MDChooserView = _interopRequireDefault(require(38));
var MDSendLinkWindow = _MDWindowView["default"].extend({
  className: function className() {
    var superCls = _MDWindowView["default"].prototype.className.call(this);
    return superCls + ' send-link-window';
  },
  contentTmpl: '<div class="send-link-root" >' + '<div class="share-win">' + '<div class="chooser-wrapper"></div>' + '</div>' + "<form class=\"comment-form\">\n        <textarea name=\"comment\" class=\"form-control mgt-20 textinput appendMsg\" placeholder=\"<%=BabelStr.str(2802)%>\" id=\"\" cols=\"30\" rows=\"10\" maxlength=\"60\"></textarea>\n      </form>\n      " + '<div class="form-button-groups">' + '<button class="button done f-fr bt-send"><%=sendbtn%></button>' + '</div>' + '</div>',
  events: function events() {
    var superE = _MDWindowView["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click #manage-user': this.changeToInvPanel,
      'click .bt-send': this.sendLink
    });
  },
  initProps: function initProps() {
    var opt = _MDWindowView["default"].prototype.initProps.call(this);
    return _.extend(opt, {
      data: {
        sendbtn: BabelStr.str(406)
      }
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    opt = _.extend({}, opt);
    opt.title = BabelStr.str(7285);
    opt.width = 720;
    _MDWindowView["default"].prototype.initialize.call(this, opt);
    this.chooserView = new _MDEnterpriseShareTabView["default"]({
      needFrequentUserTab: !this.fileInfor.get('forClient'),
      canManageShare: false,
      canSelDepartment: false,
      canSelGroup: !(app.isEpVersion() && app.currentUser.get("hasSecret")),
      showUserList: true,
      used2sendPubShareLink: true,
      // 用于发送公开的分享链接
      onChange: function onChange(mails) {
        if (mails.length > 0) {
          self.$('.bt-send').removeClass('disabled');
          self.$('.bt-send').attr('disabled', false);
        } else {
          self.$('.bt-send').addClass('disabled');
          self.$('.bt-send').attr('disabled', true);
        }
      }
    });
    this.addSubView(this.chooserView, this.$('.chooser-wrapper'));
    this.$('.bt-send').addClass('disabled');
    self.$('.bt-send').attr('disabled', true);
  },
  sendLink: function sendLink(e) {
    var value = this.chooserView.getInputVal();
    var contact = this.chooserView.getTargetEmails();
    if (!_MDChooserView["default"].checkAlertInputValid(contact.invalidNames)) {
      return;
    }
    var form = this.$('.comment-form');
    if (!form.validate().form()) {
      return;
    }
    if (_regexp["default"].isEmail(value)) {
      contact.emails.push(value);
    } else if (_regexp["default"].isPhone(value)) {
      contact.emails.push(value);
    }
    var $sendInvBtn = $('.bt-send');
    var sending = BabelStr.str(711); // 发送中...
    $sendInvBtn.prop('disabled', true).text(sending);
    var participantInfo = {
      targetEmails: contact.emails,
      targetPhones: contact.phones,
      depIds: contact.deps,
      groupIds: contact.groupIds
    };
    if (participantInfo.targetEmails.length || participantInfo.targetPhones.length || participantInfo.depIds.length || participantInfo.groupIds.length) {
      var send = BabelStr.str(406); // 发送
      var link = this.link;
      var fid = this.fid;
      var self = this;
      var leaveMessage = this.$('.appendMsg').val();
      MMNetDiskDataController.sendShareLink(fid, participantInfo, link, leaveMessage, function () {
        _MDSnackbarView["default"].show(BabelStr.str(308)); //('发送邀请成功');

        $sendInvBtn.prop('disabled', false).text(send);
        self.close();
      }, function (code, msg) {
        self.close();
        _MDSnackbarView["default"].show(msg);
      });
    }
  }
}, {});
var _default = exports["default"] = MDSendLinkWindow;

},{"106":106,"1150":1150,"1184":1184,"1454":1454,"1488":1488,"38":38,"675":675,"72":72,"93":93}],1488:[function(require,module,exports){
'use strict';
var $ = require(1270);
var createHTML = require(1241);
var forcedStringHTMLMethod = require(1368);

// `String.prototype.link` method
// https://tc39.es/ecma262/#sec-string.prototype.link
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('link') }, {
  link: function link(url) {
    return createHTML(this, 'a', 'href', url);
  }
});

},{"1241":1241,"1270":1270,"1368":1368}],658:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1412);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDFileInfoShowView = _interopRequireDefault(require(497));
var _MDTransmittalInfoWinView = _interopRequireDefault(require(660));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDSendHistoryWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDSendHistoryWinView, _MDWindowView);
  function MDSendHistoryWinView() {
    (0, _classCallCheck2["default"])(this, MDSendHistoryWinView);
    return _callSuper(this, MDSendHistoryWinView, arguments);
  }
  (0, _createClass2["default"])(MDSendHistoryWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<div class=\"flex-align between\">\n      <div class=\"file-show\"></div>\n      <div class=\"flex-align middle no-shrink\">\n        <span><%=BabelStr.str(5166)%></span>\n      </div>\n    </div>\n    <div class=\"history-list pdtb-20\">\n      <div class=\"header-block file-row\">\n        <div class=\"number\"><%=BabelStr.str(5296)%></div>        \n        <div class=\"reciver\"><%=BabelStr.str(3162)%></div>\n        <div class=\"sender\"><%=BabelStr.str(5297)%></div>\n        <div class=\"date\"><%=BabelStr.str(5298)%></div>\n        <div class=\"ver\"><%=BabelStr.str(5299)%></div>\n      </div>\n      <div class=\"file-body-block\">\n\n      </div>        \n    </div>\n    ";
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSendHistoryWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .show': this._showTransmittal
      });
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSendHistoryWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        fileInfor: null
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.title = BabelStr.str(5286);
      props.size = 'large';
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSendHistoryWinView.prototype), "initialize", this).call(this, props);
      var fileView = new _MDFileInfoShowView["default"]({
        onlyName: true,
        fileInfo: this.fileInfor
      });
      this.addSubView(fileView, this.$('.file-show')[0], true);
      MMEnterpriseController.getTransmittalFileSendedRecoders(this.fileInfor.getFileId(), function (files) {
        _this.renderdFiles(files);
      });
    }
  }, {
    key: "renderdFiles",
    value: function renderdFiles(fileInfors) {
      var _this2 = this;
      var resutl = '';
      _.each(fileInfors, function (file) {
        var tmpl = _this2.getFileItemTmpl(file);
        resutl += tmpl;
      });
      // return resutl
      this.$('.file-body-block').append(resutl);
    }
  }, {
    key: "getFileItemTmpl",
    value: function getFileItemTmpl(file) {
      var time = new Date(file.time);
      time = time.format('yyyy-MM-dd');
      return "<div class=\"file-row\">\n        <div class=\"number text-button done show\" data-no=\"".concat(file.transmittalNo, "\" data-id=\"").concat(file.transmittalId, "\">").concat(file.transmittalNo, "</div>        \n        <div class=\"reciver\">").concat(file.transmittalReceiverName, "</div>\n        <div class=\"sender\">").concat(file.senderName, "</div>\n        <div class=\"date\">").concat(time, "</div>\n        <div class=\"ver\">").concat(file.fileVersionNo, "</div>\n      </div>");
    }
  }, {
    key: "_showTransmittal",
    value: function _showTransmittal($e) {
      var id = $($e.target).data('id') + '';
      var transmittalNo = $($e.target).data('no');
      var win = new _MDTransmittalInfoWinView["default"]({
        transmittalId: id,
        transmittalNo: transmittalNo
      });
      win.show();
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSendHistoryWinView.prototype), "viewDidRendered", this).call(this);
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSendHistoryWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " send-history-win");
    }
  }]);
  return MDSendHistoryWinView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1437":1437,"1454":1454,"1463":1463,"1475":1475,"497":497,"660":660,"93":93}],660:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDTransmittalInfoPageView = _interopRequireDefault(require(659));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDTransmittalInfoWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDTransmittalInfoWinView, _MDWindowView);
  function MDTransmittalInfoWinView() {
    (0, _classCallCheck2["default"])(this, MDTransmittalInfoWinView);
    return _callSuper(this, MDTransmittalInfoWinView, arguments);
  }
  (0, _createClass2["default"])(MDTransmittalInfoWinView, [{
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDTransmittalInfoWinView.prototype), "events", this).call(this);
      return _.extend(superE, {});
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      props.title = props.transmittalNo;
      props.width = '1000';
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDTransmittalInfoWinView.prototype), "initialize", this).call(this, props);
      var view = new _MDTransmittalInfoPageView["default"]({
        transmittalId: this.transmittalId
      });
      this.addSubView(view);
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDTransmittalInfoWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " transmittla-info-win");
    }
  }]);
  return MDTransmittalInfoWinView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"659":659,"93":93}],657:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationWindowView = _interopRequireDefault(require(92));
var _MDSendHQSMFilePanelView = _interopRequireDefault(require(656));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDSendHQSNFileWinView = exports["default"] = /*#__PURE__*/function (_MDNavigationWindowVi) {
  (0, _inherits2["default"])(MDSendHQSNFileWinView, _MDNavigationWindowVi);
  function MDSendHQSNFileWinView() {
    (0, _classCallCheck2["default"])(this, MDSendHQSNFileWinView);
    return _callSuper(this, MDSendHQSNFileWinView, arguments);
  }
  (0, _createClass2["default"])(MDSendHQSNFileWinView, [{
    key: "initialize",
    value: function initialize(props) {
      props.title = BabelStr.str(6839);
      props.width = 1000;
      props.rootNavigationPageView = new _MDSendHQSMFilePanelView["default"](props);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSendHQSNFileWinView.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSendHQSNFileWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " send-hqsm-file-win");
    }
  }]);
  return MDSendHQSNFileWinView;
}(_MDNavigationWindowView["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"656":656,"92":92}],656:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1423);
require(1463);
require(1480);
require(1487);
require(1538);
require(1541);
require(1413);
require(1498);
require(1426);
require(1424);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _RenderProxy = _interopRequireDefault(require(25));
var _MDHQSMFileItemView = _interopRequireDefault(require(640));
var _MDHqsmProjectMemberSelectPageView = _interopRequireDefault(require(647));
var _MDTransmittalSendSuccessPageView = _interopRequireDefault(require(664));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDAlertView = _interopRequireDefault(require(32));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDSendHQSMFilePanelView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDSendHQSMFilePanelView, _MDNavigationPageView);
  function MDSendHQSMFilePanelView() {
    (0, _classCallCheck2["default"])(this, MDSendHQSMFilePanelView);
    return _callSuper(this, MDSendHQSMFilePanelView, arguments);
  }
  (0, _createClass2["default"])(MDSendHQSMFilePanelView, [{
    key: "_contentTmpl",
    value: function _contentTmpl() {
      return "\n    <form>\n    <div class=\"flex-align between item-block info-item\">\n      <div class=\"flex-align middle w-50 no-shrink\">\n        <span class=\"no-shrink mgr-10 w-60p\"><%=BabelStr.str(699)%>\uFF1A</span>\n        <div class=\"receive-block\"></div>\n      </div>\n      <div class=\"flex-align middle w-50 no-shrink\">\n        <span class=\"no-shrink mgr-10 w-60p\">ATTN:</span>\n        <span class=\"no-shrink attn\"></span>\n\n      </div>\n    </div>\n    <div class=\"flex-align item-block copy-item\">\n      <span class=\"no-shrink mgr-10  w-60p\"><%=BabelStr.str(5255)%>\uFF1A</span>\n      <div class=\"fullfill\"><input type=\"text\" class=\"form-control emails isEmails\" placeholder=\"<%=BabelStr.str(5293)%>\"></div>\n    </div>\n    <div class=\"flex-align item-block number-item-block\">\n      <span class=\"mgr-10 no-shrink\">TRANSMITTAL NO.\uFF1A</span>\n      <div class=\"mgr-10 number-show\"></div>\n      <div class=\"number-input-block fullfill mgr-10\">\n        <input type=\"text\" class=\"_validate-error form-control number-input mgr-10\">\n        <p class=\"_validate-error\"><%=BabelStr.str(5292)%></p>\n      </div>\n      <span>\n        <button class=\"text-button done no-shrink edit-number\"><%=BabelStr.str(3070)%></button>\n        <button class=\"text-button done no-shrink save-number\"><%=BabelStr.str(3096)%></button>\n      </span>\n    </div>\n    <div class='item-block'><%=BabelStr.str(5256)%>\uFF1A</div>\n    <div class=\"radio-group item-block\">\n      <div data-type=0 class=\"setting-item mgr-10 radio-box checked\"><%=BabelStr.str(5257)%></div>\n      <div data-type=1 class=\"setting-item mgr-10 radio-box \"><%=BabelStr.str(5258)%></div>\n      <div data-type=2 class=\"setting-item mgr-10 radio-box\"><%=BabelStr.str(5259)%></div>\n      <div data-type=3 class=\"setting-item mgr-10 radio-box\"><%=BabelStr.str(5260)%></div>\n    </div>\n    <div class=\"item-block\"><%=BabelStr.str(6112)%>\uFF1A</div>\n    <div class=\"send-files-list item-block\">\n      <div class=\"header-block file-row\">\n        <div class=\"num\"><%=BabelStr.str(5313)%></div>\n        <div class=\"m-chb number\">\n          <span class=\"label text-hide\"><%=BabelStr.str(5261)%></span>\n        </div>\n        <div class=\"version\"><%=BabelStr.str(5312)%></div>\n        <div class=\"desc\"><%=BabelStr.str(5262)%></div>\n        <div class=\"ope\"><%=BabelStr.str(5263)%></div>\n      </div>\n      <div class=\"loading-indicator\">\n        <div class=\"spinner-loader\" style=\"\">\n          <div class=\"spinner spinner-small\">\n            <div class=\"bounce1\"></div>\n            <div class=\"bounce2\"></div>\n            <div class=\"bounce3\"></div>\n          </div>\n        </div>\n      </div>\n      <div class=\"body-block files-transmittal\">\n      </div>\n    </div>\n    <div class=\"flex-align between item-block people-item\">\n      <div class=\"flex-align middle w-50\">\n        <span class=\"mgr-10 w-60p\"><%=BabelStr.str(5264)%>\uFF1A</span>\n        <span class=\"mgr-10 confirmer\"><%=BabelStr.str(5266)%></span>\n        <button class=\"text-button done confirmer-btn\"><%=BabelStr.str(3070)%></button>\n      </div>\n      <div class=\"flex-align middle w-50\">\n        <span class=\"mgr-10\"><%=BabelStr.str(5265)%>\uFF1A</span>\n        <span class=\"mgr-10 committer\"><%=BabelStr.str(5266)%></span>\n        <button class=\"text-button done committer-btn\"><%=BabelStr.str(3070)%></button>\n      </div>\n    </div>\n    <div class=\"flex-align item-block\">\n      <div class=\"no-shrink mgr-10 w-60p\"><%=BabelStr.str(6062)%>\uFF1A</div>\n      <div class=\"fullfill\">\n        <textarea name=\"comment\" class=\"form-control comment-textarea textinput\" placeholder=\"<%=BabelStr.str(5267)%>\"></textarea>\n      </div>\n    </div>\n    </form>\n    <div class=\"flex-align end\">\n      <button class=\"button done send \" disabled><%=BabelStr.str(5268)%></button>\n    </div>\n    ";
    }
  }, {
    key: "_errorTmpl",
    value: function _errorTmpl() {
      return "<div class=\" pdtb-20 f-tc\"><%=BabelStr.str(5307)%></div>\n      <div class=\"flex-align end\">\n        <button class=\"button close\"><%=BabelStr.str(156)%></button>\n      </div>   ";
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSendHQSMFilePanelView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .header-block .m-chb': this._toggleAllChecked,
        'click .setting-item': this._checkSettingItem,
        'click .confirmer-btn': this._addConfirmer,
        'click .committer-btn': this._addCommitter,
        'click .edit-number': this._editNumber,
        'click .save-number': this._saveNumber,
        'click .send': this._save,
        'click .close': this._close,
        'input .number-input': this._onNumInput

        // 'blur .number-input': this._blurNumberInput
      });
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSendHQSMFilePanelView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        reciveTypeArr: [{
          name: BabelStr.str(5228),
          type: 1
        }, {
          name: BabelStr.str(5229),
          type: 2
        }],
        fileInfors: [],
        selectedFiles: new Set(),
        fileStyle: 0
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.title = BabelStr.str(6839);
      props.size = 'large';
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSendHQSMFilePanelView.prototype), "initialize", this).call(this, props);
      _MDSpinnerloaderView["default"].showIn(this.$('.page-content')[0]);
      this.currentProject = app.pathRouter.getHQSMProjectByPath();
      MMEnterpriseController.getTransmittalReceiverInProjectByProjectId(this.fileInfors[0].getTransmittalProjectId(), function (transmittalReceivers) {
        _MDSpinnerloaderView["default"].clearFrom(_this.$('.page-content')[0]);
        _this.transmittalReceivers = transmittalReceivers;
        var tmpl;
        if (transmittalReceivers.length) {
          tmpl = _.template(_this._contentTmpl());
        } else {
          tmpl = _.template(_this._errorTmpl());
        }
        _this.$('.page-content').html(tmpl);
        if (transmittalReceivers.length) {
          _this.initReciverTypeSelect(transmittalReceivers);
        }
        setTimeout(function () {
          _this.navigationWindowView && _this.navigationWindowView.refreshWindow();
        });
        _this.getVersionInfoForTransmittal();
      }, function () {
        _MDSpinnerloaderView["default"].clearFrom(_this.$('.page-content')[0]);
        _MDSnackbarView["default"].show(309);
      });
      this.confirmerUser = app.currentUser;
      this.committerUser = app.currentUser;
      this.$('.send').disable();
    }
  }, {
    key: "_close",
    value: function _close() {
      this.navigationWindowView && this.navigationWindowView.close();
    }
  }, {
    key: "_editNumber",
    value: function _editNumber() {
      this.$('.number-item-block').addClass('edit');
    }
  }, {
    key: "_onNumInput",
    value: function _onNumInput() {
      this.$('.number-item-block').removeClass('error');
    }
  }, {
    key: "_addConfirmer",
    value: function _addConfirmer() {
      var _this2 = this;
      var view = new _MDHqsmProjectMemberSelectPageView["default"]({
        singleSelection: true,
        title: BabelStr.str(5310),
        fileInfor: this.fileInfors[0],
        onSelected: function onSelected(users) {
          if (users.length) {
            _this2.confirmerUser = users[0];
            _this2.$('.confirmer').html(_this2.confirmerUser.get('userName'));
          }
          _this2.confirmerUser = users[0];
        }
      });
      this.navigationWindowView.push(view);
    }
  }, {
    key: "_addCommitter",
    value: function _addCommitter() {
      var _this3 = this;
      var view = new _MDHqsmProjectMemberSelectPageView["default"]({
        title: BabelStr.str(5310),
        singleSelection: true,
        fileInfor: this.fileInfors[0],
        onSelected: function onSelected(users) {
          if (users.length) {
            _this3.committerUser = users[0];
            _this3.$('.committer').html(_this3.committerUser.get('userName'));
          }
        }
      });
      this.navigationWindowView.push(view);
    }
  }, {
    key: "typeChanged",
    value: function typeChanged(id, type) {
      var _this4 = this;
      if (this.selectedFiles.has(id) && this.selectedFiles.size > 1) {
        _.each(this.subViews, function (subView) {
          if (subView instanceof _MDHQSMFileItemView["default"]) {
            var fileId = subView.getFileId();
            if (_this4.selectedFiles.has(fileId) && id != fileId) {
              subView.selectItemType(type, true);
            }
          }
        });
        this.setFileOpeType(type);
      } else {
        this.setFileOpeType(type);
      }
    }
  }, {
    key: "setFileOpeType",
    value: function setFileOpeType() {}
  }, {
    key: "_toggleAllChecked",
    value: function _toggleAllChecked($e) {
      var _this5 = this;
      var ids = _.pluck(this.versionInfos, "fileNo");
      if ($($e.target).closest('.m-chb').hasClass('checked')) {
        _.each(this.subViews, function (subView) {
          if (subView instanceof _MDHQSMFileItemView["default"]) {
            subView.removeChecked(true);
          }
        });
        _.each(ids, function (id) {
          _this5.selectedFiles["delete"](id);
        });
      } else {
        _.each(this.subViews, function (subView) {
          if (subView instanceof _MDHQSMFileItemView["default"]) {
            subView.addChecked(true);
          }
        });
        _.each(ids, function (id) {
          _this5.selectedFiles.add(id);
        });
      }
      this.selectChanged();
    }
  }, {
    key: "selectChanged",
    value: function selectChanged($e) {
      var _this6 = this;
      var ids = _.pluck(this.versionInfos, "fileNo");
      this.$('.checked-item').removeClass('first');
      this.$('.checked-item').eq(0).addClass('first');
      var checkAll = _.every(this.versionInfos, function (file) {
        return _this6.selectedFiles.has(file.fileNo);
      });
      if (this.selectedFiles.size > 1) {
        this.$('.send-files-list .body-block').addClass('mult-select');
      } else {
        this.$('.send-files-list .body-block').removeClass('mult-select');
      }
      if (checkAll) {
        this.$('.header-block .m-chb').addClass("checked");
      } else {
        this.$('.header-block .m-chb').removeClass("checked");
      }
    }
  }, {
    key: "_checkSettingItem",
    value: function _checkSettingItem(e) {
      var $curItem = $(e.target);
      if ($curItem.hasClass("checked")) {
        return;
      } else {
        $curItem.siblings().removeClass("checked");
        $curItem.addClass("checked");
        var type = $curItem.data('type');
        this.fileStyle = type;
      }
    }
  }, {
    key: "initReciverTypeSelect",
    value: function initReciverTypeSelect(transmittalReceivers) {
      var _this7 = this;
      var reciverTypeView = new _MDDropdownSelectListView["default"]({
        dataProvider: transmittalReceivers,
        labelField: "name",
        silentInit: false,
        onChange: function onChange(obj) {
          _this7.$('.attn').html(obj.ATTN);
          _this7.sendTo = obj.id;
          _this7.getValidTransmittalNo(obj.transmittalProjectId, obj.id);
        }
      });
      this.addSubView(reciverTypeView, this.$('.receive-block')[0]);
    }
  }, {
    key: "getValidTransmittalNo",
    value: function getValidTransmittalNo(transmittalProjectId, transmittalReceiverId) {
      var _this8 = this;
      var depId = this.fileInfors[0].get("departmentId");
      MMEnterpriseController.getValidTransmittalNo(transmittalProjectId, transmittalReceiverId, depId, function (data) {
        _this8.transmittalNo = data.transmittalNo;
        _this8.transmittalNoTemplate = data.transmittalNoTemplate;
        _this8.$('.number-show').html(_this8.transmittalNo);
        _this8.$('.number-input').val(_this8.transmittalNo);
        _this8.$('.number-input')[0].focus();
      });
    }
  }, {
    key: "_saveNumber",
    value: function _saveNumber() {
      var _this9 = this;
      var transmittalNo = this.$('.number-input').val();
      if (!transmittalNo || transmittalNo.length == 0) {
        this.$('.number-item-block').addClass('error');
        return;
      }
      transmittalNo = transmittalNo.trim();
      MMEnterpriseController.checkTransmittalNoValid(this.sendTo, transmittalNo, this.transmittalNoTemplate, function (sign) {
        if (sign) {
          _this9.$('.number-show').html(transmittalNo);
          _this9.$('.number-item-block').removeClass('error');
          _this9.$('.number-item-block').removeClass('edit');
        } else {
          _this9.$('.number-item-block').addClass('error');
        }
      });
    }
    // _toggleHeaderChecked($e) {
    //   let checked;
    // 	let target = $($e.target).closest('.m-chb')
    // 	if(target.hasClass('checked')) {
    // 		checked = false;
    // 	} else {
    // 		checked = true;
    // 	}
    //  	this.toggleHeaderChecked(checked)
    // }

    // toggleHeaderChecked(checked) {
    // 	if(!checked) {
    // 		target.removeClass("checked")
    // 		this.$el.removeClass("checked-item")
    // 	} else {
    // 		target.addClass("checked")
    // 		this.$el.addClass("checked-item")
    // 	}
    // }
  }, {
    key: "getVersionInfoForTransmittal",
    value: function getVersionInfoForTransmittal() {
      var _this10 = this;
      var self = this;
      var fids = _.map(this.fileInfors, function (file) {
        return file.getFileId();
      });
      this.$('.send').disable();
      MMEnterpriseController.getVersionInfoForTransmittal(this.fileInfors[0].getTransmittalProjectId(), this.fileInfors[0].get("departmentId"), fids, function (versionInfos) {
        _this10.versionInfos = versionInfos;
        _this10.renderFileInfors(versionInfos);
        _this10.$(".spinner-loader").remove();
      }, function (err, msg) {
        _this10.$(".spinner-loader").remove();
        _MDSnackbarView["default"].show(msg);
      });
    }
  }, {
    key: "showEmptyFiles",
    value: function showEmptyFiles() {
      this.$('.files-transmittal').empty().append('<div class="red">' + BabelStr.str(20023) + '</div>');
      this.navigationWindowView.refreshWindow();
    }
  }, {
    key: "renderFileInfors",
    value: function renderFileInfors(versionInfos) {
      var _this11 = this;
      if (!versionInfos) {
        return;
      }
      if (versionInfos && versionInfos.length == 0) {
        this.showEmptyFiles();
        return;
      }
      this.$('.send').enable();
      var buffer = document.createDocumentFragment();
      _.each(versionInfos, function (file, index) {
        var item = new _MDHQSMFileItemView["default"]({
          fileInfor: file,
          No: index + 1,
          onSelectChanged: function onSelectChanged(id, selected) {
            if (selected) {
              _this11.selectedFiles.add(id);
            } else {
              _this11.selectedFiles["delete"](id);
            }
            _this11.selectChanged();
          },
          onTypeChanged: function onTypeChanged(id, type) {
            _this11.typeChanged(id, type);
          }
        });
        _this11.addSubView(item, function () {
          _RenderProxy["default"].buildViewDom(item);
          buffer.appendChild(item.el);
        }, false, true);
      });
      this.eachSubViews(function (view) {
        if (view instanceof _MDHQSMFileItemView["default"]) {
          _RenderProxy["default"].viewWillRendered(view);
        }
      });
      this.$('.send-files-list .body-block').empty().append(buffer);
      this.eachSubViews(function (view) {
        if (view instanceof _MDHQSMFileItemView["default"]) {
          _RenderProxy["default"].viewDidRendered(view);
        }
      });
      this.navigationWindowView.refreshWindow();
    }
  }, {
    key: "getVersionInfos",
    value: function getVersionInfos() {
      _.each(this.subViews, function (view) {
        if (view instanceof _MDHQSMFileItemView["default"]) {
          view.updateFile();
        }
      });
      return this.versionInfos;
    }
  }, {
    key: "_save",
    value: function _save() {
      var _this12 = this;
      var validate = this.$('form').validate();
      if (!validate.form()) {
        this.navigationWindowView && this.navigationWindowView.refreshWindow();
        return;
      }
      var comment = this.$('.comment-textarea').val() || '';
      comment = _.escape(comment.trim());
      var emails = this.$('.emails').val() || '';
      emails = emails.trim();
      var copyTo = emails.split('；').join(';');
      var transmittalNo = this.$('.number-input').val() || '';
      transmittalNo = transmittalNo.trim();
      if (transmittalNo.length == 0) {
        _MDAlertView["default"].showStandardPrompt({
          message: BabelStr.str(20025)
        });
        return;
      }
      var versionInfos = this.getVersionInfos();
      if (!versionInfos || versionInfos.length == 0) {
        _MDAlertView["default"].showStandardPrompt({
          message: BabelStr.str(20026)
        });
        return;
      }
      var data = {
        transmittalProjectId: this.fileInfors[0].getTransmittalProjectId(),
        transmittalNo: transmittalNo,
        sendTo: this.sendTo,
        copyTo: copyTo,
        versionSendInfos: versionInfos,
        // 里面新增用户输入的 sendAs， comment
        fileStyle: this.fileStyle,
        // 提交的文件类型
        confirmerId: this.confirmerUser.getUserId(),
        //  确认人
        committerId: this.committerUser.getUserId(),
        // 提交人
        comment: comment,
        needSign: 1,
        departmentId: this.fileInfors[0].get("departmentId")
      };
      console.log(data);
      MMEnterpriseController.sendTransmittal(data, function (data) {
        console.warn(data);
        var view = new _MDTransmittalSendSuccessPageView["default"]({
          transmittalId: data.transmittalId
        });
        _this12.navigationWindowView.initWithRootNavigationPageView(view);
        _this12.navigationWindowView.refreshWindow();
      }, function (errcode, msg) {
        if (errcode == 803) {
          // -------- 接收人没有设置邮箱
          _MDSnackbarView["default"].show(BabelStr.str(20031));
        } else {
          _MDSnackbarView["default"].show(msg);
        }
      });
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSendHQSMFilePanelView.prototype), "viewDidRendered", this).call(this);
      this.renderFileInfors();
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSendHQSMFilePanelView.prototype), "className", this).call(this);
      return "".concat(superCls, " send-hqsm-file-win");
    }
  }]);
  return MDSendHQSMFilePanelView;
}(_MDNavigationPageView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1413":1413,"1423":1423,"1424":1424,"1426":1426,"1454":1454,"1463":1463,"1475":1475,"1480":1480,"1487":1487,"1498":1498,"1538":1538,"1541":1541,"25":25,"32":32,"56":56,"640":640,"647":647,"664":664,"67":67,"72":72,"76":76}],664:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDTransmittalInfoPageView = _interopRequireDefault(require(659));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDTransmittalSendSuccessPageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDTransmittalSendSuccessPageView, _MDNavigationPageView);
  function MDTransmittalSendSuccessPageView() {
    (0, _classCallCheck2["default"])(this, MDTransmittalSendSuccessPageView);
    return _callSuper(this, MDTransmittalSendSuccessPageView, arguments);
  }
  (0, _createClass2["default"])(MDTransmittalSendSuccessPageView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<p class=\"f-tc pd-20\"><%=BabelStr.str(5295)%></p>\n    \t<div class=\"flex-align end\">\n    \t\t<button class=\"button mgr-10 close\"><%=BabelStr.str(156)%></button>\n    \t\t<button class=\"button done show\"><%=BabelStr.str(2005)%></button>\n    \t</div>\n    ";
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDTransmittalSendSuccessPageView.prototype), "initialize", this).call(this, props);
      this.setTitle(BabelStr.str(5294));
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDTransmittalSendSuccessPageView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .close': this.close,
        'click .show': this.show
      });
    }
  }, {
    key: "close",
    value: function close() {
      this.navigationWindowView.close();
    }
  }, {
    key: "show",
    value: function show() {
      var view = new _MDTransmittalInfoPageView["default"]({
        transmittalId: this.transmittalId
      });
      this.navigationWindowView.initWithRootNavigationPageView(view);
      // this.navigationWindowView.popToRoot()
      this.navigationWindowView.refreshWindow();
    }
  }]);
  return MDTransmittalSendSuccessPageView;
}(_MDNavigationPageView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"56":56,"659":659}],659:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1437);
require(1439);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDHQSMFileItemView = _interopRequireDefault(require(640));
var _RenderProxy = _interopRequireDefault(require(25));
var _MDSnackbarView = _interopRequireDefault(require(72));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDTransmittalInfoPageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDTransmittalInfoPageView, _MDNavigationPageView);
  function MDTransmittalInfoPageView() {
    (0, _classCallCheck2["default"])(this, MDTransmittalInfoPageView);
    return _callSuper(this, MDTransmittalInfoPageView, arguments);
  }
  (0, _createClass2["default"])(MDTransmittalInfoPageView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<div class=\"container\"></div>";
    }
  }, {
    key: "infotmpl",
    value: function infotmpl() {
      return "<div class=\"flex-align\">\n    <div class=\"mgr-10 mgr-20 pdr-20\">\n      <span><%=BabelStr.str(3715)%>\uFF1A</span>\n      <span><%=senderName%></span>\n    </div>\n    <div class=\"mgr-10\">\n      <span><%=BabelStr.str(5275)%>\uFF1A</span>\n      <span><%=time%></span>\n    </div>  \n  </div>\n  <div class=\"comments\">\n    <%=comment%>\n  </div>\n  <div class=\"file-block mgt-20\">\n    <div><%=BabelStr.str(5276)%></div>\n    <div class=\"file-list flex-align between with-wrap\"></div>\n  </div>\n  <div class=\"transmittal-block\">\n    <div><%=BabelStr.str(5277)%></div>\n    <div class=\"transmittal-info\">\n       <div class=\"flex-align between title-line\">\n         <div class=\"name\"><%=transmittalTitle%></div>\n         <button class=\"text-button done export-pdf mgl-10 no-shrink\"><%=BabelStr.str(5278)%></button>\n       </div>\n       <div class=\"pdtb-20 log-block flex-align center middle\">\n          <div class=\"app-logo mgr-10\"></div>\n          <div class=\"ep-name\">\n            <div class=\"title boldfont bigfont3\"><%=epName%></div>\n            <div class=\"font3\"><%=projectComment%></div>\n          </div>\n          \n       </div>\n       <div class=\"bd-t mglr-15 mgb-10\"></div>\n       <div class=\"flex-align between info-line\">\n         <div class=\"w-50 flex-align\">\n           <div class=\"_name\"><%=BabelStr.str(699)%>\uFF1A</div>\n           <div class=\"_value\"><%=name%></div>\n         </div>\n         <div class=\"w-50 flex-align\">\n           <div class=\"_name\"><%=BabelStr.str(5279)%>\uFF1A</div>\n           <div class=\"_value\"><%=transmittalNo%></div>\n         </div>\n       </div>\n       <div class=\"flex-align between info-line\">\n         <div class=\"w-50 flex-align\">\n           <div class=\"_name\">ATTN\uFF1A</div>\n           <div class=\"_value\"><%=ATTN%></div>\n         </div>\n         <div class=\"w-50 flex-align\">\n           <div class=\"_name\"><%=BabelStr.str(3286)%>\uFF1A</div>\n           <div class=\"_value\"><%=time%></div>\n         </div>\n       </div> \n       <div class=\"flex-align between info-line\">\n         <div class=\"w-50 flex-align\">\n           <div class=\"_name\"><%=BabelStr.str(2827)%>\uFF1A</div>\n           <div class=\"_value\"><%=transmittalTitle%></div>\n         </div>\n       </div> \n       <div class=\"text-center info-line mgtb-20 boldfont1\"><%=BabelStr.str(5277)%></div>\n       <div class=\"info-line \"><%=BabelStr.str(5281)%></div>\n       <div class=\"info-line radio-group\">\n            <div class=\"setting-item mgr-10 <%=(fileStyle == 0 ? 'checked' : '')%> radio-box\"><%=BabelStr.str(5257)%></div>\n            <div class=\"setting-item mgr-10 <%=(fileStyle == 1 ? 'checked' : '')%> radio-box \"><%=BabelStr.str(5258)%></div>\n            <div class=\"setting-item mgr-10 <%=(fileStyle == 2 ? 'checked' : '')%> radio-box\"><%=BabelStr.str(5259)%></div>\n            <div class=\"setting-item mgr-10 <%=(fileStyle == 3 ? 'checked' : '')%> radio-box\"><%=BabelStr.str(5260)%></div>      \n       </div>\n       <div class=\"send-files-list item-block\">\n        <div class=\"header-block file-row\">\n          <div class=\"num\"><%=BabelStr.str(5313)%></div>     \n          <div class=\"number\"><%=BabelStr.str(5261)%></div>        \n          <div class=\"version\"><%=BabelStr.str(20029)%></div>\n          <div class=\"desc\"><%=BabelStr.str(5262)%></div>\n          <div class=\"ope\"><%=BabelStr.str(5263)%></div>\n        </div>\n        <div class=\"body-block\">\n      \n        </div>\n      </div>\n       <div class=\"info-line flex-align\">\n         <span class=\"w-50 boldfont2\"><%=BabelStr.str(5264)%></span>\n         <span class=\"w-50 boldfont2\"><%=BabelStr.str(5282)%></span>\n       </div>\n       <div class=\"info-line flex-align\">\n         <div class=\"w-50\">\n          <span class=\"mgr-10\"><%=BabelStr.str(5283)%>:</span>\n          <span><%=confirmerName%></span>\n        </div>\n        <div class=\"w-50\">\n          <span class=\"mgr-10\"><%=BabelStr.str(5283)%>:</span>\n          <span><%=committerName%></span>\n        </div>      \n       </div>\n       <div class=\"info-line flex-align\">\n         <div class=\"w-50\">\n          <span class=\"mgr-10\"><%=BabelStr.str(5284)%>:</span>\n          <span><%=confirmerUserType%></span>\n        </div>\n        <div class=\"w-50\">\n          <span class=\"mgr-10\"><%=BabelStr.str(5284)%>:</span>\n          <span><%=committerUserType%></span>\n        </div>      \n       </div>       \n       \n       <div class=\"info-line flex-align\">\n         <div class=\"w-50\">\n          <span class=\"mgr-10\"><%=BabelStr.str(3286)%>:</span>\n          <span><%=time%></span>\n        </div>\n        <div class=\"w-50\">\n          <span class=\"mgr-10\"><%=BabelStr.str(3286)%>:</span>\n          <span><%=time%></span>\n        </div>      \n       </div>       \n       <div class=\"bd-t mglr-15 pdtb-20 mgt-20\"></div>      \n    </div>\n  </div>\n    ";
    }
  }, {
    key: "error",
    value: function error() {
      return "<div class=\"mgr-10 text-center\">\n              <span><%=BabelStr.str(20022)%></span>\n          </div> ";
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDTransmittalInfoPageView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .header-block .m-chb': this._toggleAllChecked,
        'click .setting-item': this._checkSettingItem,
        'click .download': this._download,
        'click .export-pdf': this._exportPdf
      });
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDTransmittalInfoPageView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        fileInfors: [],
        transmittalId: undefined
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDTransmittalInfoPageView.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "_download",
    value: function _download($e) {
      var id = $($e.target).data('id') + '';
      MMEnterpriseController.downloadTransmittalFile(this.transmittalId, id, function () {}, function (error) {
        if (error['code'] == '10006') {
          error['msg'] = BabelStr.str(5542);
        }
        _MDSnackbarView["default"].show(error.msg);
      });
    }
  }, {
    key: "renderDownloadFiles",
    value: function renderDownloadFiles(fileInfors, permission) {
      var _this = this;
      var resutl = '';
      _.each(fileInfors, function (file) {
        var tmpl = _this.getFileItemTmpl(file, permission);
        resutl += tmpl;
      });
      // return resutl
      this.$('.file-list').append(resutl);
    }
  }, {
    key: "getFileItemTmpl",
    value: function getFileItemTmpl(file, permission) {
      var dispStr = file.fileNo;
      if (!dispStr || dispStr.length == 0) {
        dispStr = file.fileName;
      }
      var canDownload = true;
      if (permission) {
        canDownload = permission.canDownload;
      }
      var htmlStr = "<div class=\"flex-align download-item middle no-shrink\">\n    <div class=\"text-hide mgr-10\">".concat(dispStr, "</div>");
      // if (canDownload) {
      htmlStr += "<button class=\"text-button done download no-shrink\" data-id=\"".concat(file.fileId, "\">").concat(BabelStr.str(4733), "</button>");
      // } 
      htmlStr += "</div>";
      return htmlStr;
    }
  }, {
    key: "renderFileInfors",
    value: function renderFileInfors(fileInfors) {
      var _this2 = this;
      var buffer = document.createDocumentFragment();
      _.each(fileInfors, function (file, index) {
        var item = new _MDHQSMFileItemView["default"]({
          fileInfor: file,
          needChecked: false,
          edit: false,
          No: index + 1
        });
        _this2.addSubView(item, function () {
          _RenderProxy["default"].buildViewDom(item);
          buffer.appendChild(item.el);
        }, false, true);
      });
      this.eachSubViews(function (view) {
        if (view instanceof _MDHQSMFileItemView["default"]) {
          _RenderProxy["default"].viewWillRendered(view);
        }
      });
      this.$('.send-files-list .body-block').empty().append(buffer);
      this.eachSubViews(function (view) {
        if (view instanceof _MDHQSMFileItemView["default"]) {
          _RenderProxy["default"].viewDidRendered(view);
        }
      });
    }
  }, {
    key: "getTransmittalById",
    value: function getTransmittalById() {
      var _this3 = this;
      MMEnterpriseController.getTransmittalById(this.transmittalId, app.ep.getEpID(), function (fileInfors, transmittalInfos) {
        var time = transmittalInfos.transmittal.creationTime;
        time = new Date(time);
        time = time.format("yyyy-MM-dd");
        var receiver = transmittalInfos.receiver[0];
        var transmittalTitle = transmittalInfos.project.transmittalTitle;
        _this3.transmittalTitle = transmittalTitle;
        _this3.transmittalNo = transmittalInfos.transmittal.transmittalNo;
        var data = {
          senderName: transmittalInfos.transmittal.senderName,
          time: time,
          comment: transmittalInfos.transmittal.comment,
          projectComment: transmittalInfos.project.comment,
          name: receiver.name,
          ATTN: receiver.ATTN,
          transmittalNo: _this3.transmittalNo,
          transmittalTitle: transmittalTitle,
          fileStyle: transmittalInfos.transmittal.fileStyle,
          committerName: transmittalInfos.transmittal.committerName,
          confirmerName: transmittalInfos.transmittal.confirmerName,
          url: app.ep.getLogoURL(),
          epName: app.ep.getEpName(),
          committerUserType: _this3.getDescByType(transmittalInfos.transmittal.committerUserType),
          confirmerUserType: _this3.getDescByType(transmittalInfos.transmittal.confirmerUserType)
        };
        var tmpl = _.template(_this3.infotmpl())(data);
        _this3.$('.container').html(tmpl);
        _this3.renderDownloadFiles(fileInfors, transmittalInfos.permission);
        _this3.renderFileInfors(fileInfors);
        _this3.setTitle(transmittalTitle);
        var img = new Image();
        // img.src = url;
        img.crossOrigin = "Anonymous";
        img.src = app.ep.getLogoURL();
        img.onload = function () {
          var canvas = document.createElement("canvas");
          var ctx = canvas.getContext('2d');
          canvas.width = 60;
          canvas.height = 60;
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          _this3.$('.app-logo').html(canvas);
        };
        _this3.navigationWindowView && _this3.navigationWindowView.refreshWindow();
      }, function () {
        var tmpl = _.template(_this3.error())();
        _this3.$('.container').html(tmpl);
      });
    }
  }, {
    key: "getDescByType",
    value: function getDescByType(type) {
      var result = BabelStr.str(5315);
      switch (type) {
        case 2:
          result = BabelStr.str(5208);
          break;
        case 1:
          result = BabelStr.str(5206);
          break;
        case 0:
          result = BabelStr.str(5210);
          break;
        case 4:
          result = BabelStr.str(3478);
          break;
        case 3:
          result = BabelStr.str(3201);
          break;
      }
      return result;
    }
  }, {
    key: "_exportPdf",
    value: function _exportPdf() {
      var _this4 = this;
      var target = this.$('.transmittal-info')[0];
      target.style.background = "#FFFFFF";
      html2canvas(target, {
        tainttest: true,
        //检测每张图片都已经加载完成
        useCORS: true,
        allowTaint: true,
        ignoreElements: function ignoreElements(element) {
          // console.warn(element)
          if (element == _this4.$('.export-pdf')[0]) {
            return true;
          }
        }
      }).then(function (canvas) {
        // console.log('23322333223')
        //  console.log(canvas.toDataURL()) 
        // document.body.appendChild(canvas);
        var contentWidth = canvas.width;
        var contentHeight = canvas.height;
        //一页pdf显示html页面生成的canvas高度;
        var pageHeight = contentWidth / 592.28 * 841.89;
        //未生成pdf的html页面高度
        var leftHeight = contentHeight;
        //页面偏移
        var position = 0;
        //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
        var imgWidth = 595.28;
        var imgHeight = 592.28 / contentWidth * contentHeight;
        var pageData = canvas.toDataURL('image/jpeg', 1.0);
        var pdf = new jspdf.jsPDF('', 'pt', 'a4');

        //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
        //当内容未超过pdf一页显示的范围，无需分页
        if (leftHeight < pageHeight) {
          pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
        } else {
          while (leftHeight > 0) {
            pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= 841.89;
            //避免添加空白页
            if (leftHeight > 0) {
              pdf.addPage();
            }
          }
        }
        var name = _this4.transmittalNo + ".pdf";
        pdf.save(name);
      });
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDTransmittalInfoPageView.prototype), "viewDidRendered", this).call(this);
      this.getTransmittalById();
      if (this.navigationWindowView) {
        this.navigationWindowView.$el.addClass('transmittla-info-win').removeClass('send-hqsm-file-win');
        this.navigationWindowView.refreshWindow();
      }
    }
  }]);
  return MDTransmittalInfoPageView;
}(_MDNavigationPageView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"25":25,"56":56,"640":640,"72":72}],647:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1439);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MDHqsmProjectMemberSelectTableView = _interopRequireDefault(require(649));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDHqsmProjectMemberSelectPageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDHqsmProjectMemberSelectPageView, _MDNavigationPageView);
  function MDHqsmProjectMemberSelectPageView() {
    (0, _classCallCheck2["default"])(this, MDHqsmProjectMemberSelectPageView);
    return _callSuper(this, MDHqsmProjectMemberSelectPageView, arguments);
  }
  (0, _createClass2["default"])(MDHqsmProjectMemberSelectPageView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n  \t\t<div class=\"table-wrap f-clb\"></div>\n\t\t\t\t<div class=\"flex-align end\t mgt-15\">\n\t\t\t\t<button class=\"button mgr-10 cancel\"><%=BabelStr.str(3081)%></button>\n\t\t\t\t<button class=\"button done save\"><%=BabelStr.str(154)%></button>\n\t\t\t</div>";
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHqsmProjectMemberSelectPageView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .save': this._saveHandle,
        'click .cancel': this._cancelHandle
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHqsmProjectMemberSelectPageView.prototype), "initialize", this).call(this, props);
      this.tableView = new _MDHqsmProjectMemberSelectTableView["default"]({
        singleSelect: this.singleSelection,
        enableDragSelection: false,
        onRowSelectionChanged: function onRowSelectionChanged(selectedModels) {
          _this._onRowSelectionChanged(selectedModels);
        }
      });
      this.addSubView(this.tableView, this.$('.table-wrap')[0]);
    }
  }, {
    key: "_onRowSelectionChanged",
    value: function _onRowSelectionChanged(selectedUsers) {
      this.selectedUsers = selectedUsers;
    }
  }, {
    key: "getMembers",
    value: function getMembers() {
      var _this2 = this;
      var net = _MMEnterpriseController["default"];
      this.tableView.startLoadingState();
      _MMEnterpriseController["default"].getTransmittalProjectMember(this.fileInfor.get('transmittalProjectId'), this.fileInfor.get('departmentId'), function (members, manager, currentUserInfo) {
        var userCollection = new _MDMolaUserCollection["default"](members);
        manager.userName = manager.name;
        manager && userCollection.add(manager);
        _this2.tableView.setDataCollection(userCollection, false, true);
        _this2.tableView.clearLoadingState();
        _this2.navigationWindowView && _this2.navigationWindowView.refreshWindow();
      }, function (err, msg) {
        MDSnackbarView.show(msg);
      });
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHqsmProjectMemberSelectPageView.prototype), "viewDidRendered", this).call(this);
      this.getMembers();
    }
  }, {
    key: "_saveHandle",
    value: function _saveHandle() {
      this.navigationWindowView.pop();
      this.onSelected(this.selectedUsers);
    }
  }, {
    key: "_cancelHandle",
    value: function _cancelHandle() {
      this.navigationWindowView.pop();
    }
  }]);
  return MDHqsmProjectMemberSelectPageView;
}(_MDNavigationPageView2["default"]);

},{"1098":1098,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"273":273,"56":56,"649":649}],649:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTableView2 = _interopRequireDefault(require(89));
var _MDHqsmProjectMemberSelectTableRowView = _interopRequireDefault(require(648));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDHqsmProjectMemberSelectTableView = exports["default"] = /*#__PURE__*/function (_MDTableView) {
  (0, _inherits2["default"])(MDHqsmProjectMemberSelectTableView, _MDTableView);
  function MDHqsmProjectMemberSelectTableView() {
    (0, _classCallCheck2["default"])(this, MDHqsmProjectMemberSelectTableView);
    return _callSuper(this, MDHqsmProjectMemberSelectTableView, arguments);
  }
  (0, _createClass2["default"])(MDHqsmProjectMemberSelectTableView, [{
    key: "emptyTmpl",
    value: function emptyTmpl() {
      return "<div class=\"m-empty page-empty\" style=\"display: block;padding: 19px 0;\">\n              <p class=\"title\">".concat(BabelStr.str(3126), "</p>\n              <p class=\"info\">").concat(BabelStr.str(3127), "</p>\n            </div>");
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHqsmProjectMemberSelectTableView.prototype), "className", this).call(this);
      return "".concat(superCls, " table-striped staff-search-table");
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      props = _.extend({
        blankRenderer: this.emptyTmpl(),
        bodyCls: 'userRows',
        // rowCls: 'row',
        headerCls: 'headerWrapper',
        rowClass: _MDHqsmProjectMemberSelectTableRowView["default"],
        unSelectRowWhenClickOutside: false,
        columns: [{
          name: BabelStr.str(3128),
          dataIndex: 'name',
          flex: 1,
          cellCls: 'name-col'
        }]
      }, props);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHqsmProjectMemberSelectTableView.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "setSelectedModels",
    value: function setSelectedModels(selectedUsers) {
      this.selectedUsers = selectedUsers;
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MDHqsmProjectMemberSelectTableView';
    }
  }]);
  return MDHqsmProjectMemberSelectTableView;
}(_MDTableView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1454":1454,"1463":1463,"1475":1475,"648":648,"89":89}],648:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTableRowView2 = _interopRequireDefault(require(88));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDHqsmProjectMemberSelectTableRowView = exports["default"] = /*#__PURE__*/function (_MDTableRowView) {
  (0, _inherits2["default"])(MDHqsmProjectMemberSelectTableRowView, _MDTableRowView);
  function MDHqsmProjectMemberSelectTableRowView() {
    (0, _classCallCheck2["default"])(this, MDHqsmProjectMemberSelectTableRowView);
    return _callSuper(this, MDHqsmProjectMemberSelectTableRowView, arguments);
  }
  (0, _createClass2["default"])(MDHqsmProjectMemberSelectTableRowView, [{
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHqsmProjectMemberSelectTableRowView.prototype), "initProps", this).call(this);
      var mgr = BabelStr.str(72); // 管理员
      return _.extend(superP, {
        userInfo: null,
        columnRenders: function columnRenders() {
          return [{
            dataIndex: 'name',
            cellCls: 'name-col',
            render: function render(name, userInfo, index) {
              var name = userInfo.get('userName');
              var mail = userInfo.getAccount();
              var renderStr = "";
              renderStr += "<img src=\"".concat(userInfo.getAvatarImageURL(), "\"  class=\"avatar s36\" />\n                             <span class=\"name blue\">").concat(name, "</span>\n                             <span class=\"email\">(").concat(mail, ")</span>");
              return renderStr;
            }
          }];
        }
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHqsmProjectMemberSelectTableRowView.prototype), "events", this).call(this);
      return _.extend(superE, {});
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHqsmProjectMemberSelectTableRowView.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHqsmProjectMemberSelectTableRowView.prototype), "viewDidRendered", this).call(this);
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MDHqsmProjectMemberSelectTableRowView';
    }
  }]);
  return MDHqsmProjectMemberSelectTableRowView;
}(_MDTableRowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1454":1454,"1463":1463,"1475":1475,"88":88}],640:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1439);
require(1498);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMViewBase2 = _interopRequireDefault(require(22));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDHQSMFileItemView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MDHQSMFileItemView, _MMViewBase);
  function MDHQSMFileItemView() {
    (0, _classCallCheck2["default"])(this, MDHQSMFileItemView);
    return _callSuper(this, MDHQSMFileItemView, arguments);
  }
  (0, _createClass2["default"])(MDHQSMFileItemView, [{
    key: "el",
    value: function el() {
      return "<div class=\"file-row\"></div>";
    }
  }, {
    key: "tmpl",
    value: function tmpl() {
      return "<%if(needChecked){%>\n\t\t\t<div class=\"m-chb number text-hide\">\n\t\t\t\t<div class=\"box\"></div>\n\t\t\t  <span class=\"label mgl-10 text-hide file-no\" data-tooltip=\"<%=number%>\"><%=number%></span>\n\t\t\t</div>\n\t\t\t<%} else {%>\n        <div class=\"num\"><%=No%></div>\n      \t<div class=\"number\"><%=number%></div>\n      <%}%>\n      <div class=\"version\" data-tooltip=\"<%=version%>\"><%=version%></div>\n      <div class=\"desc\">\n        <%if(edit){%>\n          <input type=\"text\" name=\"num-<%=number%>\" class=\"form-control comment textinput\" placeholder=\"<%=BabelStr.str(5274)%>\">\n        <%} else {%>\n          <%=desc%>\n        <%}%>\n      </div>\n      <%if(edit){%>\n        <div class=\"ope\"></div>\n      <%} else {%>\n        <div class=\"ope\"><%=opeStr%></div>\n      <%}%>\n\n    ";
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHQSMFileItemView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .m-chb': this._toggleChecked
      });
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHQSMFileItemView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        fileInfor: null,
        needChecked: false,
        edit: true,
        opeTypeArr: [{
          name: BabelStr.str(5272),
          type: 0
        }, {
          name: BabelStr.str(5273),
          type: 1
        }, {
          name: BabelStr.str(5270),
          type: 2
        }, {
          name: BabelStr.str(5271),
          type: 3
        }]
      });
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        needChecked: this.needChecked,
        number: this.fileInfor.fileNo || this.fileInfor.fileName,
        version: this.fileInfor.versionNo,
        opeStr: this.getOpeNameByType(this.fileInfor.sendAs),
        edit: this.edit,
        desc: this.fileInfor.comment,
        No: this.No
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHQSMFileItemView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "getOpeNameByType",
    value: function getOpeNameByType(type) {
      var name = '';
      _.each(this.opeTypeArr, function (item) {
        if (item.type == type) {
          name = item.name;
        }
      });
      return name;
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHQSMFileItemView.prototype), "initialize", this).call(this, props);
      if (this.edit) {
        this.initOpeTypeView();
      }
      this.$(".comment").val(this.fileInfor.comment);
    }
  }, {
    key: "getFileId",
    value: function getFileId() {
      return this.fileInfor.fileNo;
    }
  }, {
    key: "_toggleChecked",
    value: function _toggleChecked($e) {
      var checked;
      var target = $($e.target).closest('.m-chb');
      if (target.hasClass('checked')) {
        target.removeClass("checked");
        this.$el.removeClass("checked-item");
        checked = false;
      } else {
        target.addClass("checked");
        this.$el.addClass("checked-item");
        checked = true;
      }
      _.isFunction(this.onSelectChanged) && this.onSelectChanged(this.fileInfor.fileNo, checked);
    }
  }, {
    key: "addChecked",
    value: function addChecked() {
      this.$('.m-chb').addClass("checked");
      this.$el.addClass("checked-item");
    }
  }, {
    key: "removeChecked",
    value: function removeChecked() {
      this.$('.m-chb').removeClass("checked");
      this.$el.removeClass("checked-item");
    }
  }, {
    key: "initOpeTypeView",
    value: function initOpeTypeView() {
      var _this = this;
      this.opeTypeView = new _MDDropdownSelectListView["default"]({
        dataProvider: this.opeTypeArr,
        labelField: "name",
        silentInit: false,
        isFixed: true,
        onChange: function onChange(obj) {
          _this.fileInfor.sendAs = obj.type;
          _.isFunction(_this.onTypeChanged) && _this.onTypeChanged(_this.fileInfor.fileNo, obj.type);
        }
      });
      this.addSubView(this.opeTypeView, this.$('.ope')[0]);
    }
  }, {
    key: "selectItemType",
    value: function selectItemType(type, silent) {
      var index = -1;
      for (var i = 0; i < this.opeTypeArr.length; i++) {
        if (type == this.opeTypeArr[i].type) {
          index = i;
        }
      }
      this.fileInfor.sendAs = type;
      this.opeTypeView.selectItemAt(index, silent);
    }
  }, {
    key: "updateFile",
    value: function updateFile() {
      var comment = this.$('.comment').val() || '';
      comment = comment.trim();
      this.fileInfor.comment = comment;
    }
  }]);
  return MDHQSMFileItemView;
}(_MMViewBase2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"1498":1498,"22":22,"67":67}],641:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDHQSMProjectInfoPageView = _interopRequireDefault(require(643));
var _MDNavigationWindowView = _interopRequireDefault(require(92));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDHQSMManageNavWinView = exports["default"] = /*#__PURE__*/function (_MDNavigationWindowVi) {
  (0, _inherits2["default"])(MDHQSMManageNavWinView, _MDNavigationWindowVi);
  function MDHQSMManageNavWinView() {
    (0, _classCallCheck2["default"])(this, MDHQSMManageNavWinView);
    return _callSuper(this, MDHQSMManageNavWinView, arguments);
  }
  (0, _createClass2["default"])(MDHQSMManageNavWinView, [{
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHQSMManageNavWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {});
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHQSMManageNavWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " hqsm-manage-win");
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      props.size = 'large';
      props.rootNavigationPageView = new _MDHQSMProjectInfoPageView["default"]({
        fileInfor: props.fileInfor
      });
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHQSMManageNavWinView.prototype), "initialize", this).call(this, props);
      // let view = new MDHQSMProjectInfoPageView({
      //   isEdit: true
      // });

      // this.addSubView(view)
      this.props = props;
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MDHQSMManageNavWinView';
    }
  }]);
  return MDHQSMManageNavWinView;
}(_MDNavigationWindowView["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"643":643,"92":92}],643:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1416);
require(1412);
require(1415);
require(1463);
require(1498);
require(1423);
require(1480);
require(1487);
require(1538);
require(1426);
var _toConsumableArray2 = _interopRequireDefault(require(1194));
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MDAddProjectMemberPageView = _interopRequireDefault(require(639));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MDUserItem = _interopRequireDefault(require(667));
var _MDHQSMReciverPageView = _interopRequireDefault(require(646));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDMolaUser = _interopRequireDefault(require(272));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 *	created by jichao
 *	2021.2.1
 */
var MDHQSMProjectInfoPageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDHQSMProjectInfoPageView, _MDNavigationPageView);
  function MDHQSMProjectInfoPageView() {
    (0, _classCallCheck2["default"])(this, MDHQSMProjectInfoPageView);
    return _callSuper(this, MDHQSMProjectInfoPageView, arguments);
  }
  (0, _createClass2["default"])(MDHQSMProjectInfoPageView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n      <form>\n      <div class=\"project-info\">\n\n      </div>\n      </form>\n      <div class=\" created-block bd-top flex-align\">\n        <div class=\"create-title\"><%=BabelStr.str(3201)%></div>\n        <div class=\"flex-align between created-user-info middle\">\n\n        </div>\n      </div>\n\n      <div class=\"reciver-block bd-top\">\n        <div class=\"section-title\"><%=BabelStr.str(699)%></div>\n        <div class=\"flex-align between\">\n          <div class=\"help-text reciver-str\"><%=BabelStr.str(5247, {num: 0})%></div>\n          <div class=\"text-button manage-reciver\"><%=BabelStr.str(5248)%></div>\n        </div>\n      </div>\n\n      <div class=\"members-block bd-top pdt-15\">\n        <div class=\"section-title\"><%=BabelStr.str(5249)%></div>\n        <div class=\"mamager-content lh-40 bd-top pdt-15\">\n          <div class=\"flex-align between\">\n          <div class=\"member-title\"><%=BabelStr.str(6097)%></div>\n          <div class=\"manager\"></div>\n          <div class=\"text-button add-manage\"><%=BabelStr.str(5250)%></div>\n          </div>\n        </div>\n\n        <div class=\"secretary-content bd-top pdt-15\">\n          <div class=\"flex-align between\">\n            <div class=\"member-title\"><%=BabelStr.str(5206)%>\uFF1A</div>\n            <div class=\"text-button add-secretary\"><%=BabelStr.str(5251)%></div>\n          </div>\n          <div class=\"secretary-list pdt-10 users-list data-type=1\"></div>\n        </div>\n        <div class=\"control-member-content bd-top pdt-15\">\n          <div class=\"flex-align between\">\n            <div class=\"member-title\"><%=BabelStr.str(5208)%>\uFF1A</div>\n            <div class=\"text-button file-control\"><%=BabelStr.str(5252)%></div>\n          </div>\n          <div class=\"control-member-list pdt-10 users-list data-type=2\"></div>\n        </div>\n        <div class=\"other-member-content bd-top pdt-15\">\n          <div class=\"flex-align between\">\n            <div class=\"member-title\"><%=BabelStr.str(5210)%>\uFF1A</div>\n            <div class=\"text-button other-member\"><%=BabelStr.str(5253)%></div>\n          </div>\n          <div class=\"other-member-list pdt-10 users-list data-type=3\"></div>\n        </div>\n      </div>\n      <div class=\"flex-align end info-item\">\n        <div class=\"button close mgr-10\"><%=BabelStr.str(156)%></div>\n        <div class=\"button done save-members\"><%=BabelStr.str(154)%></div>\n      </div>\n    ";
    }

    // <div class="flex-align between manage-content pdb-15">
    //   <div class="member-title"><%=BabelStr.str(6097)%></div>
    //   <div class="manager"></div>
    //   <div class="text-button add-manage"><%=BabelStr.str(5250)%></div>
    // </div>
  }, {
    key: "projectTmpl",
    value: function projectTmpl() {
      return "        <div class=\"section-title\"><%=BabelStr.str(5246)%></div>\n        <div class=\"info-item flex-align\">\n          <div class=\"item-title form-required\"><%=BabelStr.str(6095)%></div>\n          <div class=\"info\">\n            <input name=\"name\" class=\"form-control project-name transmittal-title testFileNameEnd testFileName\" value=\"<%=transmittalTitle%>\" required placeholder=\"<%=BabelStr.str(2813)%>\"/>\n          </div>\n        </div>\n        <div class=\"info-item flex-align discipline-block\">\n          <div class=\"item-title\"><%=BabelStr.str(5211)%></div>\n          <div class=\"info flex-align\">\n            <div>\n              <input name=\"role\" type=\"text\" value=\"<%=inputRule%>\" class=\"form-control textinput template-title\" placeholder=\"<%=BabelStr.str(5212)%>\"/>\n            </div>\n            <div class=\"discipline-select-block\"></div>\n          </div>\n        </div>\n        <div class=\"info-item flex-align\">\n          <div class=\"item-title\"><%=BabelStr.str(3013)%></div>\n          <div class=\"info\">\n           <textarea class=\"form-control comment textinput\" name=\"comment\" placeholder=\"<%=BabelStr.str(5213)%>\" ></textarea>\n          </div>\n        </div>\n        <div class=\"flex-align end info-item\">\n        <div class=\"button close mgr-10\"><%=BabelStr.str(156)%></div>\n        <div class=\"button done save-base-info\"><%=BabelStr.str(154)%></div>\n        </div>";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHQSMProjectInfoPageView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        // secretaryCollection: new MDMolaUserCollection(),
        // fileControlCollection: new MDMolaUserCollection(),
        // otherMemberCollection: new MDMolaUserCollection(),
        memberCollection: new _MDMolaUserCollection["default"](),
        fileInfor: undefined,
        originMangerId: undefined,
        transmittalArrr: [{
          value: "{-num3-}",
          name: BabelStr.str(5308)
        }, {
          value: "{-num4-}",
          name: BabelStr.str(5309)
        }, {
          value: "{-date-}",
          name: BabelStr.str(5290)
        }, {
          value: "{-num-}",
          name: BabelStr.str(5216)
        }, {
          value: "{-letter-}",
          name: BabelStr.str(5215)
        }]
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHQSMProjectInfoPageView.prototype), "className", this).call(this);
      return "".concat(superCls, " hqsm-project-edit-panel");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHQSMProjectInfoPageView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .close": this.close,
        "click .add-manage": this._addManagerHandle,
        "click .add-secretary": this._addSecretary,
        "click .file-control": this._addFileControl,
        "click .other-member": this._addOtherMember,
        "click .manage-reciver": this._manageReciver,
        "click .save-members": this._saveMembers,
        "click .save-base-info": this._saveBaseInfo
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHQSMProjectInfoPageView.prototype), "initialize", this).call(this, props);
      this.setTitle(BabelStr.str(5254));
      // this.renderDiscipline()
      this.getRoles();
      this.listenTo(this.memberCollection, "add", this.appendMemberItemUser);
      this.listenTo(this.memberCollection, "remove", this.removeMemberItemUser);
      // this.listenTo(this.secretaryCollection, 'add', this.appendSecretaryItemUser);
      // this.listenTo(this.secretaryCollection, 'remove', this.removeSecretaryItemUser);

      // this.listenTo(this.fileControlCollection, 'add', this.appendFileControlItemUser);
      // this.listenTo(this.fileControlCollection, 'remove', this.removeFileControlItemUser);

      // this.listenTo(this.otherMemberCollection, 'add', this.appendOtherMemberItemUser);
      // this.listenTo(this.otherMemberCollection, 'remove', this.removeOtherMemberItemUser)
      MMEnterpriseController.getTransmittalProjectByFolder(this.fileInfor.getFileId(), function (project) {
        var reg1 = /{-.*?-}/g;
        var rules = project.versionTemplate.split("{}");
        if (rules.length == 1) {
          rules.unshift("");
        }
        var data = _.extend(project, {
          inputRule: rules[0]
        });
        var tmpl = _.template(_this.projectTmpl())(data);
        _this.$(".project-info").html(tmpl);
        _this.$(".comment").val(_.unescape(data.comment));
        var rule = rules[1];
        var index = _.findIndex(_this.transmittalArrr, {
          value: rule
        });
        _this.renderDiscipline(index);
        var name = project.creatorName;
        var src = app.getAvatarImageURL(project.creator, 30, true);
        _this.$(".created-user-info").html("<img data-src=\"".concat(src, "\" alt=\"\" src=\"").concat(src, "\" >\n        <span>").concat(name, "</span>"));
        _this.navigationWindowView && _this.navigationWindowView.refreshWindow();
      });
    }
  }, {
    key: "appendMemberItemUser",
    value: function appendMemberItemUser(user) {
      var userType = user.get("userType");
      if (userType == 2) {
        this.appendFileControlItemUser(user);
      } else if (userType == 1) {
        this.appendSecretaryItemUser(user);
      } else {
        this.appendOtherMemberItemUser(user);
      }
    }
  }, {
    key: "removeMemberItemUser",
    value: function removeMemberItemUser(user) {
      // let userType = user.get('userType')
      // if(userType == 2) {
      //   this.removeFileControlItemUser(user)
      // } else if(userType == 1) {
      //   this.removeSecretaryItemUser(user)
      // } else {
      //   this.removeOtherMemberItemUser(user)
      // }
      var id = user.getUserId();
      _.each(this.subViews, function (view) {
        if (view instanceof _MDUserItem["default"]) {
          if (view.getUserId() == id) {
            view.remove();
          }
        }
      });
    }
  }, {
    key: "appendSecretaryItemUser",
    value: function appendSecretaryItemUser(user) {
      this.appendItemUser(this.$(".secretary-list"), user);
    }
  }, {
    key: "removeSecretaryItemUser",
    value: function removeSecretaryItemUser(user) {
      var id = user.getUserId();
      // let $item = this.$(`.secretary .uset-item-comp[data-id="${id}"]`)
      // $item.remove()
    }
  }, {
    key: "appendFileControlItemUser",
    value: function appendFileControlItemUser(user) {
      this.appendItemUser(this.$(".control-member-list"), user);
    }
  }, {
    key: "removeFileControlItemUser",
    value: function removeFileControlItemUser(user) {
      var id = user.getUserId();
      var $item = this.$(".file-control .uset-item-comp[data-id=\"".concat(id, "\"]"));
      $item.remove();
    }
  }, {
    key: "appendOtherMemberItemUser",
    value: function appendOtherMemberItemUser(user) {
      this.appendItemUser(this.$(".other-member-list"), user);
    }
  }, {
    key: "removeOtherMemberItemUser",
    value: function removeOtherMemberItemUser(user) {
      var id = user.getUserId();
      var $item = this.$(".other-member-list .uset-item-comp[data-id=\"".concat(id, "\"]"));
      $item.remove();
    }
  }, {
    key: "_addSecretary",
    value: function _addSecretary() {
      var _this2 = this;
      this.selectEpMemeber(1, function (users) {
        _this2.memberCollection.add(users);
      });
    }
  }, {
    key: "_addFileControl",
    value: function _addFileControl() {
      var _this3 = this;
      this.selectEpMemeber(2, function (users) {
        _this3.memberCollection.add(users);
      });
    }
  }, {
    key: "_addOtherMember",
    value: function _addOtherMember() {
      var _this4 = this;
      this.selectEpMemeber(0, function (users) {
        _this4.memberCollection.add(users);
      });
    }
  }, {
    key: "selectEpMemeber",
    value: function selectEpMemeber(type, callback) {
      var _this5 = this;
      var view = new _MDAddProjectMemberPageView["default"]({
        userEpSelectComp: true,
        onSelected: function onSelected(users) {
          users = _.filter(users, function (user) {
            user.set("userId", user.getUserId());
            var oldUser = _this5.memberCollection.findWhere({
              userId: user.getUserId()
            });
            if (oldUser) {
              _this5.memberCollection.remove(oldUser.cid);
            }
            user.set("userType", type);
            if (type == 1) {
              user.setRoleId(-1);
              user.set("needRoleAndEndTime", false);
            } else {
              user.set("needRoleAndEndTime", true);
            }
            if (!_this5.managerUser) {
              return true;
            }
            return user.getUserId() != _this5.managerUser.getUserId();
          });
          callback(users);
        }
      });
      this.navigationWindowView.push(view);
    }
  }, {
    key: "_addManagerHandle",
    value: function _addManagerHandle() {
      var _this6 = this;
      var view = new _MDAddProjectMemberPageView["default"]({
        addManager: true,
        userEpSelectComp: true,
        onSelected: function onSelected(users) {
          if (users.length) {
            // if(this.managerUser) {
            var user = _this6.memberCollection.findWhere({
              id: users[0].getUserId()
            });
            if (user) {
              _this6.memberCollection.remove(user);
            }
            // }
            _this6.managerUser = users[0];
            _this6.managerUser.set("isAdmin", true);
            _this6.renderManager();
          }
        }
      });
      this.navigationWindowView.push(view);
    }
  }, {
    key: "renderManager",
    value: function renderManager() {
      var $contain = this.$(".manager");
      $contain.empty();
      this.appendItemUser($contain, this.managerUser);
    }
  }, {
    key: "appendItemUser",
    value: function appendItemUser($contain, user) {
      var _this7 = this;
      if (user.getRoleId() == -1) {
        user.setRoleId(11);
      }
      // if(user.get('userType') != 1 &&  user.getRoleId() == -1) {
      // 	user.setRoleId(11)
      // }
      var needRoleAndEndTime;
      if (user.get("needRoleAndEndTime") || _.isUndefined(user.get("needRoleAndEndTime"))) {
        needRoleAndEndTime = true;
      }
      var item = new _MDUserItem["default"]({
        user: user,
        roles: this.roles,
        roleArr: this.roleArr,
        onlyUser: true,
        notForce: true,
        needRoleAndEndTime: needRoleAndEndTime,
        removeCallback: function removeCallback(id) {
          var user = _this7.memberCollection.findWhere({
            userId: id
          });
          _this7.memberCollection.remove(user);
          // this.removeSubView(item)
        }
      });
      this.addSubView(item, $contain);
      this.navigationWindowView.refreshWindow();
    }
  }, {
    key: "renderDiscipline",
    value: function renderDiscipline(index) {
      var _this8 = this;
      var disciplineView = new _MDDropdownSelectListView["default"]({
        dataProvider: this.transmittalArrr,
        labelField: "name",
        selectedIndex: index,
        silentInit: false,
        onChange: function onChange(obj) {
          _this8.templateNo = obj.value;
          console.warn(obj);
        }
      });
      this.addSubView(disciplineView, this.$(".discipline-select-block")[0]);
    }
  }, {
    key: "close",
    value: function close() {
      this.navigationWindowView.close();
    }
  }, {
    key: "getRoles",
    value: function getRoles() {
      var self = this;
      var _initRoles = function _initRoles(roleCollection, defaultRole) {
        var shareRoles = [];
        roleCollection.each(function (roleInfo) {
          shareRoles.push(roleInfo);
        });
        self.roles = shareRoles;
        self.roleArr = [];
        for (var i = 0; i < self.roles.length; i++) {
          var role = self.roles[i];
          var str = {
            label: role.get("description"),
            canSelected: true,
            linkRoleId: role.getRoleId(),
            systemdefault: role.get("systemdefault")
          };
          self.roleArr.push(str);
        }
        MMEnterpriseController.getTransmittalProjectMember(self.fileInfor.get("transmittalProjectId"), self.fileInfor.get("departmentId"), function (members, manager, currentUserInfo) {
          self.staticMembers = new _MDMolaUserCollection["default"](_.clone(members));
          _.each(members, function (user) {
            if (user.userType == 1) {
              user.roleId = -1;
              user.needRoleAndEndTime = false;
            } else {
              user.needRoleAndEndTime = true;
            }
          });
          self.memberCollection.add(members);
          if (manager) {
            self.managerUser = new _MDMolaUser["default"](manager);
            self.managerUser.set("isAdmin", true);
            self.renderManager();
            self.originMangerId = manager.id;
          }
          var cls = "";
          if (currentUserInfo.isManager) {
            cls = "isManager";
          } else if (currentUserInfo.isTransmittalManager) {
            cls = "isTransmittalManager";
          } else if (currentUserInfo.isTransmittalMember) {
            cls = "isTransmittalMember";
          }
          self.$el.addClass(cls);
        }, function (err, msg) {
          _MDSnackbarView["default"].show(msg);
        });
      };
      MMNetDiskDataController.getAllRoles(function (roleCollection, defaultRole) {
        _initRoles(roleCollection, defaultRole);
      }, function () {
        _MDSnackbarView["default"].show(BabelStr.str(7270));
      });
    }
  }, {
    key: "_saveBaseInfo",
    value: function _saveBaseInfo() {
      var _this9 = this;
      if (this.saveingBaseInfo) {
        return;
      }
      this.saveingBaseInfo = true;
      var $form = this.$("form");
      var $btn = this.$(".save-base-info");
      $btn.attr("disabled", true);
      if (!$form.validate().form()) {
        this.saveingBaseInfo = false;
        $btn.attr("disabled", false);
        return;
      }
      var transmittalTitle = this.$(".transmittal-title").val();
      transmittalTitle = _.escape(transmittalTitle.trim());
      var comment = this.$(".comment").val();
      comment = _.escape(comment.trim());
      var templateTitle = this.$(".template-title").val();
      templateTitle = templateTitle.trim();
      var versionTemplate = this.templateNo;
      if (templateTitle) {
        versionTemplate = _.escape(templateTitle) + "{}" + this.templateNo;
      }
      var data = {
        transmittalTitle: transmittalTitle,
        fileId: this.fileInfor.getFileId(),
        transmittalProjectId: this.fileInfor.get("transmittalProjectId"),
        comment: comment,
        versionTemplate: versionTemplate,
        departmentId: this.fileInfor.get("departmentId")
      };
      MMEnterpriseController.updateTransmittalProject(data, function () {
        _MDSnackbarView["default"].show(BabelStr.str(308), _this9.el);
        _this9.saveingBaseInfo = false;
        $btn.attr("disabled", false);
        _this9.fileInfor.setFileName(transmittalTitle);
      }, function (code, msg) {
        if (code == 20001) {
          _MDSnackbarView["default"].show(BabelStr.str(7506));
        } else {
          _MDSnackbarView["default"].show(BabelStr.str(309));
        }
        console.log("验证通过");
        _this9.saveingBaseInfo = false;
        $btn.attr("disabled", false);
      });
    }
  }, {
    key: "formatUser",
    value: function formatUser(user) {
      return {
        userId: user.getUserId(),
        roleId: user.getRoleId(),
        endTime: user.get("endTime"),
        userType: user.get("userType")
      };
    }
  }, {
    key: "_saveMembers",
    value: function _saveMembers() {
      var _ref,
        _ref2,
        _this10 = this;
      if (this.savingMembers) {
        return;
      }
      this.savingMembers = true;
      var userInfos = [];
      var updateUserInfos = [];
      var oldIds = this.staticMembers.pluck("userId");
      var ids = this.memberCollection.pluck("userId");
      var addIds = (_ref = _).without.apply(_ref, [ids].concat((0, _toConsumableArray2["default"])(oldIds)));
      addIds = new Set(addIds);
      var removeUserIds = (_ref2 = _).without.apply(_ref2, [oldIds].concat((0, _toConsumableArray2["default"])(ids)));
      var removeUserInfos = _.map(removeUserIds, function (id) {
        var u = _this10.staticMembers.findWhere({
          userId: id
        });
        return {
          userId: u.get("userId"),
          userType: u.get("userType")
        };
      });
      this.memberCollection.each(function (member) {
        var user = _this10.formatUser(member);
        if (addIds.has(user.userId)) {
          userInfos.push(user);
        } else {
          var oldUser = _this10.staticMembers.findWhere({
            userId: user.userId
          });
          if (oldUser) {
            oldUser = _this10.formatUser(oldUser);
            if (!_.isEqual(oldUser, user) && user.userType != 1) {
              updateUserInfos.push(user);
            }
          }
        }
      });
      var data = {
        fileId: this.fileInfor.getFileId(),
        transmittalProjectId: this.fileInfor.get("transmittalProjectId"),
        participantInfo: {
          userInfos: userInfos
        },
        updateUserInfos: updateUserInfos,
        removeUserInfos: removeUserInfos,
        departmentId: this.fileInfor.get("departmentId")
      };
      if (this.originMangerId != this.managerUser.get("id")) {
        data.managerId = this.managerUser.get("id");
      }
      MMEnterpriseController.updateTransmittalProject(data, function () {
        _this10.savingMembers = false;
        _MDSnackbarView["default"].show(BabelStr.str(308), _this10.el);
        _this10.navigationWindowView && _this10.navigationWindowView.close();
      }, function (code, msg) {
        _this10.savingMembers = false;
        _MDSnackbarView["default"].show(msg, _this10.el);
      });
    }
  }, {
    key: "_manageReciver",
    value: function _manageReciver() {
      var view = new _MDHQSMReciverPageView["default"]({
        fileInfor: this.fileInfor
      });
      this.navigationWindowView.push(view);
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      var _this11 = this;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHQSMProjectInfoPageView.prototype), "viewDidRendered", this).call(this);
      MMEnterpriseController.getTransmittalReceiverInProjectByFolderId(this.fileInfor.getFileId(), function (transmittalReceivers) {
        _this11.$(".reciver-str").html(BabelStr.str(5247, {
          num: transmittalReceivers.length
        }));
      });
    }
  }], [{
    key: "className",
    value: function className() {
      return "MDHQSMProjectInfoPageView";
    }
  }]);
  return MDHQSMProjectInfoPageView;
}(_MDNavigationPageView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1194":1194,"1412":1412,"1415":1415,"1416":1416,"1423":1423,"1426":1426,"1454":1454,"1463":1463,"1475":1475,"1480":1480,"1487":1487,"1498":1498,"1538":1538,"272":272,"273":273,"56":56,"639":639,"646":646,"667":667,"67":67,"72":72}],646:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDHQSMProjectInfoPanelView = _interopRequireDefault(require(644));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDAlertView = _interopRequireDefault(require(32));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 *	created by jichao
 *	2021.2.1
 */
var MDHQSMReciverPageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDHQSMReciverPageView, _MDNavigationPageView);
  function MDHQSMReciverPageView() {
    (0, _classCallCheck2["default"])(this, MDHQSMReciverPageView);
    return _callSuper(this, MDHQSMReciverPageView, arguments);
  }
  (0, _createClass2["default"])(MDHQSMReciverPageView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n      <div class=\"section-title\"><%=BabelStr.str(699)%></div>\n      <div class=\"section-block\"></div>\n      <div class=\"flex-align end info-item\">\n        <button class=\"button close mgr-10\"><%=BabelStr.str(156)%></button>\n        <button class=\"button done save\"><%=BabelStr.str(154)%></button>\n      </div>\n    ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHQSMReciverPageView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        fileInfor: undefined
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHQSMReciverPageView.prototype), "className", this).call(this);
      return "".concat(superCls, " hqsm-project-edit-panel");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHQSMReciverPageView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .close': this.close,
        'click .save': this._save
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHQSMReciverPageView.prototype), "initialize", this).call(this, props);
      this.setTitle(BabelStr.str(5254));
      this.view = new _MDHQSMProjectInfoPanelView["default"]({
        fileInfor: this.fileInfor
      });
      this.addSubView(this.view, this.$('.section-block')[0]);
    }
  }, {
    key: "close",
    value: function close() {
      this.navigationWindowView && this.navigationWindowView.close();
    }
  }, {
    key: "_save",
    value: function _save() {
      var _this = this;
      var data = this.view.getReciversForUpdate();
      if (!data) {
        this.view.resetParams();
        return;
      }
      MMEnterpriseController.updateTransmittalReceiverInProject(data, function () {
        _this.view.resetParams();
        _MDSnackbarView["default"].show(BabelStr.str(308), _this.el);
        _this.navigationWindowView && _this.navigationWindowView.pop();
      }, function (code, msg) {
        _this.view.resetParams();
        _MDSnackbarView["default"].show(msg, _this.el);
        // this.navigationWindowView && this.navigationWindowView.pop()
      });
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MDHQSMReciverPageView';
    }
  }]);
  return MDHQSMReciverPageView;
}(_MDNavigationPageView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"32":32,"56":56,"644":644,"72":72}],630:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationWindowView = _interopRequireDefault(require(92));
var _MDSubLibraryCreateInfoPageView = _interopRequireDefault(require(629));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDSubLibraryCreateWinView = exports["default"] = /*#__PURE__*/function (_MDNavigationWindowVi) {
  (0, _inherits2["default"])(MDSubLibraryCreateWinView, _MDNavigationWindowVi);
  function MDSubLibraryCreateWinView() {
    (0, _classCallCheck2["default"])(this, MDSubLibraryCreateWinView);
    return _callSuper(this, MDSubLibraryCreateWinView, arguments);
  }
  (0, _createClass2["default"])(MDSubLibraryCreateWinView, [{
    key: "initialize",
    value: function initialize(props) {
      props.size = 'large';
      props.rootNavigationPageView = new _MDSubLibraryCreateInfoPageView["default"](props);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSubLibraryCreateWinView.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSubLibraryCreateWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " library-win");
    }
  }]);
  return MDSubLibraryCreateWinView;
}(_MDNavigationWindowView["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"629":629,"92":92}],629:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1439);
require(1437);
require(1429);
require(1412);
require(1416);
require(1426);
require(1415);
require(1463);
require(1466);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MDAddProjectMemberPageView = _interopRequireDefault(require(639));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MDUploadTypeSettingsPageView = _interopRequireDefault(require(665));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDUserItem = _interopRequireDefault(require(667));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDLibraryApplyUsersPageView = _interopRequireDefault(require(627));
var _MDMolaUser = _interopRequireDefault(require(272));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDSubLibraryCreateInfoPageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDSubLibraryCreateInfoPageView, _MDNavigationPageView);
  function MDSubLibraryCreateInfoPageView() {
    (0, _classCallCheck2["default"])(this, MDSubLibraryCreateInfoPageView);
    return _callSuper(this, MDSubLibraryCreateInfoPageView, arguments);
  }
  (0, _createClass2["default"])(MDSubLibraryCreateInfoPageView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<div></div>\n    <%if(forApply){%>\n      <div class=\"red mgb-10 applymsg\"></div>\n    <%} else if(!isEdit){%>\n      <div class=\"red mgb-10 canCreate-msg <%=(canCreate ? \"f-hide\" : \"\")%>\"><%=BabelStr.str(12555)%></div>\n      <div class=\"inv-manager-block flex-align middle mgb-10 line-item <%=(canCreate ? \"f-hide\" : \"\")%>\">\n        <div class=\"manager-title line-title\"><%=BabelStr.str(21215)%></div>\n        <div class=\"inv-manager-list flex-align with-wrap gap-10\"></div>\n      </div>\n    <%}%>\n    <form>\n    <div class=\"flex-align middle between mgb-10 line-item\">\n      <div class=\"line-title no-shrink\"><%=BabelStr.str(158)%></div>\n      <div class=\"fullfill\">\n        <input name=\"materialFolderName\" type=\"text\" required  testFileName  class=\"form-control testFileNameEnd testFileName name notempty\" placeholder=\"<%=BabelStr.str(12516)%>\" maxlength=\"100\"/>\n      </div>\n    </div>\n    <div class=\"flex-align middle between mgb-10 line-item\">\n      <div class=\"line-title no-shrink\"><%=BabelStr.str(2814)%></div>\n      <input type=\"\" class=\"form-control manager\" placeholder=\"<%=BabelStr.str(2815)%>\"/>\n    </div>\n    <div class=\"flex-align middle line-item mgb-10\">\n      <div class=\"line-title no-shrink\"><%=BabelStr.str(12519)%></div>\n      <div class=\"flex-align middle line-item\">\n        <div class=\"select-type mgr-20\"></div>\n        <div class=\"type-comment help-block\"></div>\n      </div>\n    </div>\n    <div class=\"flex-align middle line-item\">\n      <div class=\"line-title no-shrink\"></div>\n      <div>\n        <div class=\"normal-option check-option f-none\">\n          <div class=\"down-checkbox check-item flex-align middle\" data-sign=\"0\">\n            <div class=\"checkbox no-shrink\"></div>\n            <div class=\"name \"><%=BabelStr.str(12520)%></div>\n          </div>\n        </div>\n        <div class=\"apply-option check-option f-none\">\n          <div class=\"down-checkbox check-item flex-align middle\" data-sign=\"0\">\n            <div class=\"checkbox no-shrink\"></div>\n            <div class=\"name \"><%=BabelStr.str(12520)%></div>\n          </div>\n          <div class=\"down-checkbox check-item flex-align middle\" data-sign=\"1\">\n            <div class=\"checkbox no-shrink\"></div>\n            <div class=\"name \"><%=BabelStr.str(12528)%></div>\n          </div>\n          <div class=\"down-checkbox check-item flex-align middle\" data-sign=\"2\">\n            <div class=\"checkbox no-shrink\"></div>\n            <div class=\"name \"><%=BabelStr.str(12529)%></div>\n          </div>\n        </div>\n        <div class=\"secrecy-option check-option f-none\">\n          <div class=\"down-checkbox check-item flex-align middle\" data-sign=\"1\">\n            <div class=\"checkbox no-shrink\"></div>\n            <div class=\"name\"><%=BabelStr.str(12528)%></div>\n          </div>\n          <div class=\"down-checkbox check-item flex-align middle\" data-sign=\"2\">\n            <div class=\"checkbox no-shrink\"></div>\n            <div class=\"name\"><%=BabelStr.str(12529)%></div>\n          </div>\n          <div class=\"down-checkbox check-item flex-align middle\" data-sign=\"3\">\n            <div class=\"checkbox no-shrink\"></div>\n            <div class=\"name\"><%=BabelStr.str(12530)%></div>\n          </div>\n          <div class=\"down-checkbox check-item flex-align middle\" data-sign=\"6\">\n            <div class=\"checkbox no-shrink\"></div>\n            <div class=\"name\"><%=BabelStr.str(12583)%></div>\n          </div>\n          <div class=\"down-checkbox check-item flex-align middle\" data-sign=\"4\">\n            <div class=\"checkbox no-shrink\"></div>\n            <div class=\"name\"><%=BabelStr.str(12531)%></div>\n            <div class=\"time-content flex-align middle f-hide\">\n              <span class=\"no-shrink\"><%=BabelStr.str(176)%></span>\n              <span class = \"datepicker\">\n                <input type=\"text\" class=\"date-expire\"  placeholder=\"<%=BabelStr.str(176)%>\">\n                <i class = \"icon ep-expire-date\"></i>\n              </span>\n            </div>\n          </div>\n\n          <div class=\"end-block f-hide\">\n            <div class=\"flex-align middle\">\n              <span class=\"mgr-10\"><%=BabelStr.str(12532)%></span>\n              <div class=\"next-access-type\"></div>\n            </div>\n            <div class=\"down-checkbox check-item flex-align middle\" data-sign=\"5\">\n              <div class=\"checkbox no-shrink\"></div>\n              <div class=\"name text-hide\"><%=BabelStr.str(12533)%></div>\n            </div>\n          </div>\n\n        </div>\n      </div>\n    </div>\n    <div class=\"flex-align between mgt-10 add-title\">\n      <span><%=BabelStr.str(12534)%></span>\n      <div class=\"text-button done add-library-assistant\"><%=BabelStr.str(12518)%></div>\n    </div>\n    <div class=\"help-block\"><%=BabelStr.str(12536)%></div>\n    <div class=\"assistant-user-list-contain users-list\"></div>\n\n    <div class=\"flex-align between mgt-10 add-title\">\n      <span><%=BabelStr.str(12537)%></span>\n      <div class=\"text-button done add-library-member\"><%=BabelStr.str(7268)%></div>\n    </div>\n    <div class=\"help-block\"><%=BabelStr.str(12535)%></div>\n    <div class=\"user-list-contain users-list\"></div>\n\n  </form>\n    <div class=\"flex-align between middle pdb-10\">\n      <div class=\"flex-align\">\n        <div class=\"text-button upload-setting done\"><%=BabelStr.str(12100)%></div>\n        <%if(!forApply){%>\n          <%if(isEdit){%>\n            <div class=\"text-button apply-users done mgl-20\"><%=BabelStr.str(12559)%></div>\n          <%}%>\n        <%}%>\n      </div>\n\n      <%if(!forApply){%>\n        <div class=\"flex-align between btns middle\">\n          <button class=\"button mgr-15 cancel\"><%=BabelStr.str(156)%></button>\n          <%if(isEdit){%>\n            <button class=\"button done save\"><%=BabelStr.str(3080)%></button>\n          <%} else {%>\n            <button class=\"button done create <%=(canCreate? \"\": \"f-hide\")%>\"><%=BabelStr.str(3229)%></button>\n            <button class=\"button done apply <%=(canCreate? \"f-hide\": \"\")%>\"><%=BabelStr.str(12542)%></button>\n          <%}%>\n        </div>\n      <%}%>\n    </div>\n    <%if(forApply){%>\n      <div class=\"flex-align end apply-btns\">\n        <button class=\"button done mgr-10 accept\"><%=BabelStr.str(346)%></button>\n        <button class=\"button refuse\"><%=BabelStr.str(342)%></button>\n      </div>\n      <div class=\"mgb-20 apply-results\">\n        <div class=\"flex-align mgb-10\">\n          <span class='mgr-20 no-shrink review-title'><%=BabelStr.str(4567)%>:</span>\n          <span class=\"reviewResult\"></span>\n        </div>\n        <div class=\"flex-align mgb-10\">\n          <span class='mgr-20 no-shrink review-title'><%=BabelStr.str(4568)%>:</span>\n          <span class=\"reviewerName text-hide\"></span>\n        </div>\n        <div class=\"flex-align mgb-10\">\n          <span class='mgr-20 no-shrink review-title'><%=BabelStr.str(4569)%>:</span>\n          <span class=\"reviewTime\"></span>\n        </div>\n      </div>\n    <%}%>\n    ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSubLibraryCreateInfoPageView.prototype), "className", this).call(this);
      return "".concat(superCls, " create-library-page");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSubLibraryCreateInfoPageView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        fileId: "",
        fileInfor: undefined,
        conditionArr: [{
          type: 0,
          name: BabelStr.str(3350),
          comment: BabelStr.str(12525)
        }, {
          type: 1,
          name: BabelStr.str(12523),
          comment: BabelStr.str(12526)
        }, {
          type: 4,
          name: BabelStr.str(12524),
          comment: BabelStr.str(12527)
        }],
        nextconditionArr: [{
          type: 0,
          name: BabelStr.str(3350),
          comment: BabelStr.str(12525)
        }, {
          type: 1,
          name: BabelStr.str(12523),
          comment: BabelStr.str(12526)
        }],
        canCreate: true,
        forEdit: false,
        userCollection: new _MDMolaUserCollection["default"]()
      });
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        forApply: this.applyModel,
        canCreate: this.canCreate,
        isEdit: !!this.fileId
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSubLibraryCreateInfoPageView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSubLibraryCreateInfoPageView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "mousedown .check-item": this._checkItemClickHandler,
        "mousedown .time-content": this._timeContentClickHandle,
        "click .cancel": this._cancel,
        "click .create": this._createHandle,
        "click .apply": this._applyHandle,
        "click .accept": this._acceptHandle,
        "click .refuse": this._refuseHandle,
        "click .save": this._updateHandle,
        "click .add-library-assistant": this._addAssistantHandle,
        "click .add-library-member": this._addMemberHandle,
        "click .manager": this._addManagerHandle,
        "click .upload-setting": this._uploadSetting,
        "click .apply-users": this._showApplyUsers,
        "click .datepicker i": this.showDatePicker
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.title = BabelStr.str(12512);
      if (props.fileId) {
        props.title = BabelStr.str(12540);
      }
      props.canCreate = props.parentFolder && props.parentFolder.canUploadOnlyActions();
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSubLibraryCreateInfoPageView.prototype), "initialize", this).call(this, props);
      this.conditionSelectView = new _MDDropdownSelectListView["default"]({
        dataProvider: this.conditionArr,
        labelField: "name",
        silentInit: false,
        onChange: function onChange(obj) {
          _this.type = obj.type;
          _this.typeName = obj.name;
          _this.$('.type-comment').html(obj.comment);
          _this.renderTypeContent();
        }
      });
      this.addSubView(this.conditionSelectView, this.$(".select-type")[0]);
      this.nextTypeSelectView = new _MDDropdownSelectListView["default"]({
        dataProvider: this.nextconditionArr,
        labelField: "name",
        silentInit: false,
        onChange: function onChange(obj) {
          _this.nextAccessType = obj.type;
        }
      });
      this.addSubView(this.nextTypeSelectView, this.$(".next-access-type")[0]);
      var now = new Date();
      // 创建一个新的 Date 对象，表示7天后的时间
      var sevenDaysLater = new Date(now);
      sevenDaysLater.setDate(now.getDate() + 7);

      // 将时间设置为当天的0点
      // sevenDaysLater.setHours(0, 0, 0, 0);
      console.log("sevenDaysLater", sevenDaysLater);
      this.$('.date-expire').datepicker({
        defaultDate: '+7d',
        dateFormat: "yy-mm-dd"
      });
      this.$('.date-expire').datepicker("setDate", sevenDaysLater);
      this.$assistantContain = this.$(".assistant-user-list-contain");
      this.$contain = this.$(".user-list-contain");
      this.listenTo(this.userCollection, "add", this.appendItemUser);
      this.listenTo(this.userCollection, "remove", this.removeItemUser);
      this.getRoles();
      if (!this.isProjectAssist) {
        this.$(".add-library-assistant").removeClass("f-hide");
      } else {
        this.$(".add-library-assistant").addClass("f-hide");
      }
      if (!this.canCreate && this.parentFolder) {
        _MMEnterpriseController["default"].getMaterialApprovers(this.parentFolder.getFileId(), function (approverInfos) {
          _this.renderInvManager(approverInfos);
        });
      }
      // if(this.forEdit) {
      this.initData();
      // }
    }
  }, {
    key: "renderInvManager",
    value: function renderInvManager(managerInfos) {
      if (!managerInfos || !managerInfos.length) {
        return;
      }
      managerInfos = managerInfos.slice(0, 5);
      var tmpl = '';
      _.each(managerInfos, function (user) {
        tmpl += "\n        <div class=\"manager-item flex-align middle\">\n          <div class=\"manager-icon icon no-shrink\"></div>\n          <span class=\"name middle-ellipsis\">".concat(user.userName || user.phone, "</span>\n        </div>\n      ");
      });
      this.$(".inv-manager-list").html(tmpl);
      this.$(".inv-manager-block").removeClass("f-hide");
    }
  }, {
    key: "initData",
    value: function initData() {
      var _this2 = this;
      if (this.applyModel) {
        _MMEnterpriseController["default"].getMaterialApplyInfo(this.applyModel.getMsgFileId(), function (applyInfo) {
          _this2.applyMaterialClass = applyInfo.applyMaterialClass;
          var members = applyInfo.members;
          _.each(members, function (item) {
            item.id = item.userId;
            item.endTime = item.dueTime;
          });
          var parentId = _this2.applyMaterialClass.parentFileId;
          var parentFolder = _.findWhere(applyInfo.parentFilePath, {
            fileId: parentId
          });
          var typeStr = parentFolder.enterprisePub == 4 ? BabelStr.str(12541) : BabelStr.str(12500);
          _this2.$('.applymsg').html(BabelStr.str(24006, {
            name: _this2.applyModel.getUserInfoName(),
            type: typeStr,
            file: "<span class = \"file-name text-button done\" data-fileId = \"".concat(parentFolder.fileId, "\">").concat(parentFolder.name, "</span>")
          }));
          _this2.$('.name').val(_this2.applyMaterialClass.name);
          if (_.isNumber(_this2.applyMaterialClass.reviewResult)) {
            _this2.$('.apply-btns').hide();
            var resultStr = _this2.applyMaterialClass.reviewResult ? BabelStr.str(346) : BabelStr.str(342);
            _this2.$('.reviewResult').html(resultStr);
            var resultUser = _.findWhere(applyInfo.userInfos, {
              id: _this2.applyMaterialClass.reviewer
            });
            _this2.$('.reviewerName').html(resultUser.name);
            var reviewTime = new Date(_this2.applyMaterialClass.reviewTime).format('yyyy-MM-dd HH:mm');
            _this2.$('.reviewTime').html(reviewTime);
          } else {
            _this2.$('.apply-results').hide();
          }
          _this2.originBlacklist = applyInfo.blacklist || [];
          _this2.originWhitelist = applyInfo.whitelist || [];
          _this2.curBlacklist = _this2.originBlacklist;
          _this2.curWhitelist = _this2.originWhitelist;
          _this2.type = _this2.applyMaterialClass.accessType;
          var conditionIndex = _.findIndex(_this2.conditionArr, function (item) {
            return item.type == _this2.type;
          });
          _this2.conditionSelectView.selectItemAt(conditionIndex);
          _this2.renderTypeContent();
          _this2.nextAccessType = _this2.applyMaterialClass.nextAccessType;
          var nextTypeIndex = _.findIndex(_this2.conditionArr, function (item) {
            return item.type == _this2.nextAccessType;
          });
          _this2.nextTypeSelectView.selectItemAt(nextTypeIndex);
          var option = _this2.applyMaterialClass.otherOptions;
          for (var i = 0; i < 7; i++) {
            if (option & Math.pow(2, i)) {
              _this2.$(".check-option .check-item[data-sign=\"".concat(i, "\"]")).addClass('checked');
            }
          }
          if (_this2.applyMaterialClass.dueTime) {
            var time = _this2.applyMaterialClass.dueTime * 1000;
            _this2.$('.date-expire').datepicker("setDate", new Date(time));
          }
          _this2.renderEndBlock();
          _this2.originUserIds = _.pluck(members, 'userId');
          _this2.originMembers = members;
          if (_this2.roleArr) {
            _this2.userCollection.add(members);
          } else {
            _this2.needRenderedUsers = members;
          }
          _this2.manager = _.findWhere(members, {
            type: 1
          });
          _this2.manager = new _MDMolaUser["default"](_this2.manager);
          if (!_this2.manager) {
            console.error('怎么没有manager');
          }
          _this2.originManagerId = _this2.manager.getUserId();
          _this2.$(".manager").val(_.unescape(_this2.manager.getUserName()));
          _this2.$('form').addClass('un-clickable');
          _this2.$('.add-library-assistant').hide();
          _this2.$('.add-library-member').hide();
          _this2.$('.list-item.remove').hide();
        }, function (code, msg) {
          _MDSnackbarView["default"].show(msg);
        });
        return;
      }
      if (!this.fileId) {
        _MMEnterpriseController["default"].getMaterialPublicInfo(this.parentFolder.getFileId(), function (materialClassDispInfo) {
          if (materialClassDispInfo.managerInfo.length) {
            _this2.manager = new _MDMolaUser["default"](materialClassDispInfo.managerInfo[0]);
            _this2.$(".manager").val(_.unescape(_this2.manager.getUserName()));
          }
          if (materialClassDispInfo.basicInfo) {
            var otherOptions = materialClassDispInfo.basicInfo.otherOptions - 0;
            var managerInfo = materialClassDispInfo.managerInfo || [];
            var isManager = false;
            if (managerInfo.length) {
              var manager = _.findWhere(managerInfo, {
                "userId": app.currentUser.getUserId()
              });
              console.log(manager);
              if (manager) {
                isManager = true;
              }
            }
            if (otherOptions & Math.pow(2, 7) || app.currentUser.isEpManager() || isManager) {
              _this2.$(".canCreate-msg").addClass("f-hide");
              _this2.$(".create").removeClass("f-hide");
              _this2.$(".apply").addClass("f-hide");
              _this2.canCreate = true;
            } else {
              _this2.canCreate = false;
              _this2.$(".canCreate-msg").removeClass("f-hide");
              _this2.$(".create").addClass("f-hide");
              _this2.$(".apply").removeClass("f-hide");
              // if(materialClassDispInfo.approverInfos.length) {
              //   this.renderInvManager(materialClassDispInfo.approverInfos)
              // }
            }
            _this2.navigationWindowView && _this2.navigationWindowView.refreshWindow();
          }
        }, function (code, msg) {
          console.error(msg);
        });
        return;
      }
      _MMEnterpriseController["default"].getMaterialFolderDispInfo(this.fileId, function (data) {
        var materialFolder = data.materialFolder;
        var members = data.members;
        _.each(members, function (item) {
          item.id = item.userId;
          item.endTime = item.dueTime;
        });
        _this2.$('.name').val(materialFolder.name);
        _this2.originName = materialFolder.name;
        _this2.originBlacklist = data.blacklist || [];
        _this2.originWhitelist = data.whitelist || [];
        _this2.curBlacklist = _this2.originBlacklist;
        _this2.curWhitelist = _this2.originWhitelist;
        _this2.readers = data.readers;
        _this2.filesDownloadApplied = data.filesDownloadApplied;
        _this2.type = materialFolder.accessType;
        var conditionIndex = _.findIndex(_this2.conditionArr, function (item) {
          return item.type == _this2.type;
        });
        _this2.conditionSelectView.selectItemAt(conditionIndex);
        _this2.renderTypeContent();
        _this2.nextAccessType = materialFolder.nextAccessType;
        var nextTypeIndex = _.findIndex(_this2.conditionArr, function (item) {
          return item.type == _this2.nextAccessType;
        });
        _this2.nextTypeSelectView.selectItemAt(nextTypeIndex);
        var option = materialFolder.otherOptions;
        _this2.originOption = option;
        for (var i = 0; i < 7; i++) {
          if (option & Math.pow(2, i)) {
            _this2.$(".check-option .check-item[data-sign=\"".concat(i, "\"]")).addClass('checked');
          }
        }
        if (materialFolder.dueTime) {
          var time = materialFolder.dueTime * 1000;
          _this2.$('.date-expire').datepicker("setDate", new Date(time));
        }
        _this2.renderEndBlock();
        _this2.originUserIds = _.pluck(members, 'userId');
        _this2.originMembers = members;
        if (_this2.roleArr) {
          _this2.userCollection.add(members);
        } else {
          _this2.needRenderedUsers = members;
        }
        _this2.manager = _.findWhere(members, {
          type: 1
        });
        _this2.manager = new _MDMolaUser["default"](_this2.manager);
        if (!_this2.manager) {
          console.error('怎么没有manager');
        }
        _this2.originManagerId = _this2.manager.getUserId();
        _this2.$(".manager").val(_.unescape(_this2.manager.getUserName()));
      }, function (code, msg) {
        _MDMessageView["default"].error(msg, _this2.navigationWindowView.$body);
      });
      _MMEnterpriseController["default"].countApplyDownloadsInMaterialfolder(this.fileId, function (count) {
        _this2.applyCount = count;
      });
    }
  }, {
    key: "getRoles",
    value: function getRoles() {
      var self = this;
      var _initRoles = function _initRoles(roleCollection, defaultRole) {
        var shareRoles = [];
        roleCollection.each(function (roleInfo) {
          shareRoles.push(roleInfo);
        });
        self.roles = shareRoles;
        self.roleArr = [];
        for (var i = 0; i < self.roles.length; i++) {
          var role = self.roles[i];
          var str = {
            label: role.get("description"),
            canSelected: true,
            linkRoleId: role.getRoleId(),
            systemdefault: role.get("systemdefault")
          };
          self.roleArr.push(str);
        }
        if (self.needRenderedUsers) {
          self.userCollection.add(self.needRenderedUsers);
        }
      };
      MMNetDiskDataController.getAllRoles(function (roleCollection, defaultRole) {
        _initRoles(roleCollection, defaultRole);
      }, function () {
        _MDSnackbarView["default"].show(BabelStr.str(7270));
      });
    }
  }, {
    key: "showDatePicker",
    value: function showDatePicker() {
      var $expireTimeBox = this.$(".date-expire");
      $expireTimeBox.focus();
    }
  }, {
    key: "_addManagerHandle",
    value: function _addManagerHandle() {
      var _this3 = this;
      if (this.isProjectAssist) {
        return;
      }
      this.addmanagerView = new _MDAddProjectMemberPageView["default"]({
        addManager: true,
        onSelected: function onSelected(users) {
          _this3.manager = users[0];
          var oldManager = _this3.userCollection.findWhere({
            type: 1
          });
          _this3.userCollection.remove(oldManager);
          // this.manager.set("isAdmin", true);
          _this3.manager.set("type", 1);
          _this3.userCollection.add(_this3.manager);
          _this3.$(".manager").val(_.unescape(_this3.manager.getUserName()));
        }
      });
      this.$(".user-list-contain").show();
      this.$(".empty").addClass("f-hide");
      this.navigationWindowView.push(this.addmanagerView);
    }
  }, {
    key: "_addAssistantHandle",
    value: function _addAssistantHandle() {
      var _this4 = this;
      this.addMemberView = new _MDAddProjectMemberPageView["default"]({
        userEpSelectComp: true,
        title: BabelStr.str(12518),
        onSelected: function onSelected(users) {
          users = _.map(users, function (user) {
            user.set("userId", user.getId());
            return user;
          });
          users = _.filter(users, function (user) {
            var oldUser = _this4.userCollection.findWhere({
              id: user.getUserId()
            });
            if (oldUser && oldUser.get("type") != 1) {
              _this4.userCollection.remove(oldUser.cid);
            }
            user.set("type", 2);
            var filtered = false;
            if (!_this4.manager) {
              filtered = true;
            }
            filtered = filtered || user.getUserId() != _this4.manager.getUserId();
            if (!filtered) {
              _MDSnackbarView["default"].show(BabelStr.str(20156));
            }
            return filtered;
          });
          _this4.userCollection.add(users);
        }
      });
      this.navigationWindowView.push(this.addMemberView);
    }
  }, {
    key: "_addMemberHandle",
    value: function _addMemberHandle() {
      var _this5 = this;
      this.addMemberView = new _MDAddProjectMemberPageView["default"]({
        // canSelDepartment: false,
        // canSelGroup: false,
        title: BabelStr.str(12557),
        userEpSelectComp: true,
        onSelected: function onSelected(users) {
          users = _.map(users, function (user) {
            user.set("userId", user.getId());
            return user;
          });
          users = _.filter(users, function (user) {
            var oldUser = _this5.userCollection.findWhere({
              id: user.id
            });
            if (oldUser && oldUser.get("type") != 1) {
              if (_this5.isProjectAssist && oldUser.get("type") == 2) {
                return false;
              }
              _this5.userCollection.remove(oldUser.cid);
            }
            user.set("type", 0);
            if (!_this5.manager) {
              return true;
            }
            return user.id != _this5.manager.getUserId();
          });
          _this5.userCollection.add(users);
        }
      });
      this.$(".user-list-contain").show();
      this.navigationWindowView.push(this.addMemberView);
    }
  }, {
    key: "_uploadSetting",
    value: function _uploadSetting() {
      var _this6 = this;
      // let success = ()=>{
      this.uploadTypeSettingsView = new _MDUploadTypeSettingsPageView["default"]({
        originBlacklist: this.curBlacklist,
        originWhitelist: this.curWhitelist,
        readOnly: this.applyModel,
        onCheckCallback: function onCheckCallback(data) {
          console.log(data);
          _this6.curBlacklist = data.newBlackExts;
          _this6.curWhitelist = data.newWhiteExts;
          _this6.uploadSetting = data;
        }
      });
      this.navigationWindowView.push(this.uploadTypeSettingsView);
      // }
      // if(!this.originFile) {
      //   MMNetDiskDataController.getFileInfoByFileId(this.fileId, (file)=>{
      //     this.originFile = file
      //     success()
      //   })
      // } else {
      //   success()
      // }
    }
  }, {
    key: "_showApplyUsers",
    value: function _showApplyUsers() {
      this.applyUserView = new _MDLibraryApplyUsersPageView["default"]({
        fileInfor: this.fileInfor,
        readers: this.readers,
        filesDownloadApplied: this.filesDownloadApplied,
        updateApplyUserCallback: function updateApplyUserCallback(count) {
          // this.fileInfor.set("applyDownloadCount", count)
        }
      });
      this.navigationWindowView.push(this.applyUserView);
    }
  }, {
    key: "renderTypeContent",
    value: function renderTypeContent() {
      if (this.type == 4) {
        this.$('.secrecy-option').show();
        this.$('.normal-option').hide();
        this.$('.apply-option').hide();
      } else if (this.type == 0) {
        this.$('.normal-option').show();
        this.$('.secrecy-option').hide();
        this.$('.apply-option').hide();
      } else {
        this.$('.normal-option').hide();
        this.$('.secrecy-option').hide();
        this.$('.apply-option').show();
      }
      this.navigationWindowView && this.navigationWindowView.reLayout();
    }
  }, {
    key: "_checkItemClickHandler",
    value: function _checkItemClickHandler($e) {
      var $item = $($e.target).closest(".check-item");
      $item.toggleClass("checked");
      var sign = $item.data("sign");
      if (sign == 4) {
        this.renderEndBlock();
      }
    }
  }, {
    key: "_timeContentClickHandle",
    value: function _timeContentClickHandle($e) {
      $e.stopPropagation();
    }
  }, {
    key: "renderEndBlock",
    value: function renderEndBlock() {
      var $item = this.$('.check-item[data-sign="4"]');
      if ($item.hasClass('checked')) {
        this.$('.time-content').removeClass('f-hide');
        this.$('.end-block').removeClass('f-hide');
      } else {
        this.$('.time-content').addClass('f-hide');
        this.$('.end-block').addClass('f-hide');
      }
      this.navigationWindowView && this.navigationWindowView.reLayout();
    }
  }, {
    key: "appendItemUser",
    value: function appendItemUser(user) {
      var _this7 = this;
      if (user.getRoleId() == -1 && user.get("type") == 0) {
        user.setRoleId(11);
      }
      if (_.isNull(user.get("type"))) {
        user.set("type", 0);
      }
      var item = new _MDUserItem["default"]({
        user: user,
        roles: this.roles,
        roleArr: this.roleArr,
        needRoleAndEndTime: user.get("type") == 0,
        // showDes: user.get("type") == 1 || user.get("type") == 2,
        description: user.get("type") == 1 ? "" : undefined,
        canRemove: !this.isProjectAssist || user.get("type") == 0,
        removeCallback: function removeCallback(id) {
          _this7.removeUser(id);
          // this.removeSubView(item)
        }
      });
      if (user.get("type") == 1) {
        // this.addSubViewAt(item, 0, this.$manageContain);
        return;
      } else if (user.get("type") == 2) {
        this.addSubViewAt(item, 0, this.$assistantContain);
      } else {
        this.addSubView(item, this.$contain);
      }
      this.$(".empty").addClass("f-hide");
      this.$(".user-list-contain").show();
      this.navigationWindowView && this.navigationWindowView.refreshWindow();
    }
  }, {
    key: "removeUser",
    value: function removeUser(userId) {
      var user = this.userCollection.findWhere({
        userId: userId
      });
      this.userCollection.remove(user);
      this.deleteIds = _.union(this.deleteIds, [userId]);
    }
  }, {
    key: "removeItemUser",
    value: function removeItemUser(user) {
      var id = user.getUserId();
      // this.$(`.user-list-contain >.item[data-id=${id}]`).remove();
      _.each(this.subViews, function (view) {
        if (view instanceof _MDUserItem["default"]) {
          if (view.getUserId() == id) {
            view.remove();
          }
        }
      });
      this.navigationWindowView.refreshWindow();
    }
  }, {
    key: "_cancel",
    value: function _cancel() {
      this.navigationWindowView.close();
    }
  }, {
    key: "_applyHandle",
    value: function _applyHandle() {
      // isApply
      this._createHandle();
    }
  }, {
    key: "_createHandle",
    value: function _createHandle() {
      var _this8 = this;
      var validator = this.$('form').validate();
      if (!validator.form()) {
        return;
      }
      if (!this.manager) {
        _MDMessageView["default"].error(BabelStr.str(12538), this.navigationWindowView.$body);
        return;
      }
      var name = this.$('.name').val();
      // let chooseData = this.chooserView.getTargetIds()

      var assistantIds = [];
      var memberInfos = [];
      this.userCollection.each(function (user) {
        if (user.get("type") == 1) {
          return;
        } else if (user.get("type") == 2) {
          assistantIds.push(user.getUserId());
        } else {
          memberInfos.push({
            userId: user.getUserId(),
            roleId: user.getRoleId(),
            dueTime: user.get("endTime")
          });
        }
      });
      var params = {
        destDirFileId: this.parentId,
        // app.currentFolder.getFileId(),
        managerIds: [this.manager.getUserId()],
        assistantIds: assistantIds,
        memberInfos: memberInfos,
        name: name,
        accessType: this.type
        // managerIds: chooseData.userIds,
        // departmentIds: chooseData.deps
      };
      if (!this.canCreate) {
        params.isApply = true;
      }
      var option = 0;
      if (this.type == 0) {
        if (this.$('.normal-option .check-item').hasClass('checked')) {
          option = option | 1;
        }
      } else if (this.type == 1) {
        var $checkItems = this.$('.apply-option .check-item.checked');
        for (var i = 0; i < $checkItems.length; i++) {
          var sign = $checkItems.eq(i).data('sign');
          sign = parseInt(sign);
          option = option | Math.pow(2, sign);
        }
      } else if (this.type == 4) {
        var _$checkItems = this.$('.secrecy-option .check-item.checked');
        for (var _i = 0; _i < _$checkItems.length; _i++) {
          var _sign = _$checkItems.eq(_i).data('sign');
          _sign = parseInt(_sign);
          option = option | Math.pow(2, _sign);
        }
      }
      if (option & 16) {
        params.nextAccessType = this.nextAccessType || 0;
        var dueTime = this.$('.date-expire').datepicker("getDate");
        dueTime.setHours(23, 59, 59, 0);
        params.dueTime = dueTime.getTime() / 1000;
      } else {
        if (option & 32) {
          option = option ^ 32;
        }
      }
      params.otherOptions = option;
      if (this.uploadSetting) {
        params.blacklist = this.uploadSetting.newBlackExts;
        params.whitelist = this.uploadSetting.newWhiteExts;
      }
      console.log(params);
      // return
      _MMEnterpriseController["default"].createMaterialFolder(params, function (materialFolder) {
        // let fileId = materialFolder.fileId
        // app.pathRouter.navigateToPath(`library/${fileId}`)

        if (_this8.canCreate) {
          var fileId = materialFolder.fileId;
          app.pathRouter.navigateToPath("library/".concat(fileId));
        }
        _this8.navigationWindowView.close();
        _MDSnackbarView["default"].show(BabelStr.str(308));
      }, function (code, msg) {
        if (params.isApply && code == 231) {
          msg = BabelStr.str(12556);
          _MDAlertView["default"].showStandardPrompt({
            message: msg
          });
        } else {
          _MDMessageView["default"].error(msg, _this8.navigationWindowView.$body);
        }
      });
    }
  }, {
    key: "_updateHandle",
    value: function _updateHandle() {
      var _this9 = this;
      var validator = this.$('form').validate();
      if (!validator.form()) {
        return;
      }
      if (!this.manager) {
        _MDMessageView["default"].error(BabelStr.str(12538), this.navigationWindowView.$body);
        return;
      }
      var name = this.$('.name').val();
      var add_assistantIds = [];
      var add_memberInfos = [];
      this.userCollection.each(function (user) {
        if (user.get("type") == 1) {
          return;
        } else if (user.get("type") == 2) {
          var originAssistant = _.filter(_this9.originMembers, function (item) {
            return item.userId == user.getUserId() && item.type == 2;
          });
          if (!originAssistant.length) {
            add_assistantIds.push(user.getUserId());
          }
        } else {
          var originUser = _.filter(_this9.originMembers, function (item) {
            return item.userId == user.getUserId() && item.type == 0 && item.roleId == user.getRoleId() && item.dueTime == user.get("endTime");
          });
          if (!originUser.length) {
            add_memberInfos.push({
              userId: user.getUserId(),
              roleId: user.getRoleId(),
              dueTime: user.get("endTime")
            });
          }
        }
      });
      var curUserIds = this.userCollection.pluck("userId");
      var remove_userIds = _.difference(this.originUserIds, curUserIds);
      var params = {
        fileId: this.fileId,
        accessType: this.type,
        add_assistantIds: add_assistantIds,
        add_memberInfos: add_memberInfos,
        remove_userIds: remove_userIds
      };
      if (name != this.originName) {
        params.name = name;
      }
      var managerId = this.manager.getUserId();
      if (this.originManagerId != managerId) {
        params.add_managerIds = [managerId];
      }
      var option = 0;
      if (this.type == 0) {
        if (this.$('.normal-option .check-item').hasClass('checked')) {
          option = option | 1;
        }
      } else if (this.type == 1) {
        var $checkItems = this.$('.apply-option .check-item.checked');
        for (var i = 0; i < $checkItems.length; i++) {
          var sign = $checkItems.eq(i).data('sign');
          sign = parseInt(sign);
          option = option | Math.pow(2, sign);
        }
      } else if (this.type == 4) {
        var _$checkItems2 = this.$('.secrecy-option .check-item.checked');
        for (var _i2 = 0; _i2 < _$checkItems2.length; _i2++) {
          var _sign2 = _$checkItems2.eq(_i2).data('sign');
          _sign2 = parseInt(_sign2);
          option = option | Math.pow(2, _sign2);
        }
      }
      if (option & 16) {
        params.nextAccessType = this.nextAccessType || 0;
        var dueTime = this.$('.date-expire').datepicker("getDate");
        dueTime.setHours(23, 59, 59, 0);
        params.dueTime = dueTime.getTime() / 1000;
      } else {
        if (option & 32) {
          option = option ^ 32;
        }
      }
      params.options = option;
      if (this.uploadSetting) {
        params.add_blacklist = _.difference(this.uploadSetting.newBlackExts, this.originBlacklist);
        params.remove_blacklist = _.difference(this.originBlacklist, this.uploadSetting.newBlackExts);
        params.add_whitelist = _.difference(this.uploadSetting.newWhiteExts, this.originWhitelist);
        params.remove_whitelist = _.difference(this.originWhitelist, this.uploadSetting.newWhiteExts);
      }
      if (this.applyCount) {
        if (this.originOption & 1 && !(option & 1) || this.originOption & 8 && !(option & 8)) {
          var alert = new _MDAlertView["default"]();
          alert.show({
            title: BabelStr.str(170),
            message: "<p class=\"title\">".concat(BabelStr.str(12552), "</p>"),
            className: "m-delAlertWin",
            width: 550,
            buttons: [{
              label: BabelStr.str(155)
            }, {
              label: BabelStr.str(12554),
              type: "done",
              onClick: function onClick() {
                _this9.updateMaterialFolder(params);
              }
            }, {
              label: BabelStr.str(12553),
              type: "done",
              onClick: function onClick() {
                params.clearAllDownloadApply = true;
                _this9.updateMaterialFolder(params);
              }
            }]
          });
        } else {
          this.updateMaterialFolder(params);
        }
      } else {
        this.updateMaterialFolder(params);
      }
    }
  }, {
    key: "updateMaterialFolder",
    value: function updateMaterialFolder(params) {
      var _this10 = this;
      console.log(params);
      // return
      _MMEnterpriseController["default"].updateMaterialFolder(params, function (materialClass) {
        // let fileId = materialClass.fileId
        // app.pathRouter.navigateToPath(`library/${fileId}`)
        if (params.name) {
          _this10.fileInfor && _this10.fileInfor.setFileName(params.name);
        }
        _this10.fileInfor && _this10.fileInfor.setAccessType(params.accessType);
        _MDSnackbarView["default"].show(BabelStr.str(308));
        _this10.navigationWindowView.close();
      }, function (code, msg) {
        _MDMessageView["default"].error(msg, _this10.navigationWindowView.$body);
      });
    }
  }, {
    key: "_acceptHandle",
    value: function _acceptHandle() {
      this.reviewMaterialApplyInfo(1);
    }
  }, {
    key: "_refuseHandle",
    value: function _refuseHandle() {
      this.reviewMaterialApplyInfo(0);
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSubLibraryCreateInfoPageView.prototype), "viewDidRendered", this).call(this);
      console.log("MDLibraryApplyUsersPageView viewDidRendered");
      this.navigationWindowView && this.navigationWindowView.$el.removeClass('fullbody');
    }
  }, {
    key: "reviewMaterialApplyInfo",
    value: function reviewMaterialApplyInfo(sign) {
      var _this11 = this;
      _MMEnterpriseController["default"].reviewMaterialApplyInfo(this.applyModel.getMsgFileId(), sign, function (materialClass) {
        _MDSnackbarView["default"].show(BabelStr.str(308));
        _.isFunction(_this11.onSuccess) && _this11.onSuccess(_this11.applyModel);
        _this11.navigationWindowView.close();
      }, function (code, msg) {
        _MDMessageView["default"].error(msg, _this11.navigationWindowView.$body);
      });
    }
  }]);
  return MDSubLibraryCreateInfoPageView;
}(_MDNavigationPageView2["default"]);

},{"1098":1098,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1415":1415,"1416":1416,"1426":1426,"1429":1429,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1466":1466,"1475":1475,"272":272,"273":273,"32":32,"55":55,"56":56,"627":627,"639":639,"665":665,"667":667,"67":67,"72":72}],627:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTabView = _interopRequireDefault(require(82));
var _MDLibraryApplyAccessTabPanelView = _interopRequireDefault(require(624));
var _MDLibraryApplyDownloadTabPanelView = _interopRequireDefault(require(626));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDLibraryApplyUsersPageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDLibraryApplyUsersPageView, _MDNavigationPageView);
  function MDLibraryApplyUsersPageView() {
    (0, _classCallCheck2["default"])(this, MDLibraryApplyUsersPageView);
    return _callSuper(this, MDLibraryApplyUsersPageView, arguments);
  }
  (0, _createClass2["default"])(MDLibraryApplyUsersPageView, [{
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDLibraryApplyUsersPageView.prototype), "className", this).call(this);
      return superCls + ' ';
    }
  }, {
    key: "contentTmpl",
    value: function contentTmpl() {
      return '<div class="apply-container" >' + '</div>';
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      opt.title = BabelStr.str(12563);
      opt.width = 900;
      opt.needFooter = false;
      opt.curIndex = opt.curIndex || 0;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDLibraryApplyUsersPageView.prototype), "initialize", this).call(this, opt);
      this._initTabPanels();
      this.navigationWindowView && this.navigationWindowView.$el.addClass('fullbody');
    }
  }, {
    key: "_initTabPanels",
    value: function _initTabPanels() {
      var _this = this;
      this.applyDownload = new _MDLibraryApplyDownloadTabPanelView["default"]({
        fileInfor: this.fileInfor,
        filesDownloadApplied: this.filesDownloadApplied,
        updateApplyUserCallback: function updateApplyUserCallback(count) {
          _this.updateApplyUserCallback && _this.updateApplyUserCallback();
        }
      });
      this.applyAccess = new _MDLibraryApplyAccessTabPanelView["default"]({
        fileInfor: this.fileInfor,
        readers: this.readers
      });
      this.tabContainer = new _MDTabView["default"]({
        className: 'statistic-tabs blue-style-tab1 block',
        tabBarDividerPosition: 2,
        fullMode: false,
        enableActivebar: false,
        activeIndex: this.curIndex,
        tabs: [{
          title: BabelStr.str(12560),
          tabPanelView: this.applyAccess,
          active: true
        }, {
          title: BabelStr.str(12561),
          tabPanelView: this.applyDownload
        }]
      });
      this.tabContainer.activeTabAt(this.curIndex);
      this.addSubView(this.tabContainer, this.$('.apply-container'));
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDLibraryApplyUsersPageView.prototype), "viewDidRendered", this).call(this);
      console.log("MDLibraryApplyUsersPageView viewDidRendered");
      this.navigationWindowView && this.navigationWindowView.$el.addClass('fullbody');
      this.navigationWindowView && this.navigationWindowView.refreshWindow();
    }
  }]);
  return MDLibraryApplyUsersPageView;
}(_MDNavigationPageView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"56":56,"624":624,"626":626,"82":82}],623:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationWindowView = _interopRequireDefault(require(92));
var _MDClassifyCreateInfoPageView = _interopRequireDefault(require(622));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDClassifyCreateWinView = exports["default"] = /*#__PURE__*/function (_MDNavigationWindowVi) {
  (0, _inherits2["default"])(MDClassifyCreateWinView, _MDNavigationWindowVi);
  function MDClassifyCreateWinView() {
    (0, _classCallCheck2["default"])(this, MDClassifyCreateWinView);
    return _callSuper(this, MDClassifyCreateWinView, arguments);
  }
  (0, _createClass2["default"])(MDClassifyCreateWinView, [{
    key: "initialize",
    value: function initialize(props) {
      // props.width = 360;
      props.rootNavigationPageView = new _MDClassifyCreateInfoPageView["default"](props);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDClassifyCreateWinView.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDClassifyCreateWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " create-classify-win");
    }
  }]);
  return MDClassifyCreateWinView;
}(_MDNavigationWindowView["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"622":622,"92":92}],622:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1439);
require(1429);
require(1412);
require(1437);
require(1463);
require(1478);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDEnterpriseShareTabView = _interopRequireDefault(require(675));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDParticipantInfoCollection = _interopRequireDefault(require(277));
var _MDParticipantInfo = _interopRequireDefault(require(276));
var _MDClassifyApplyUsersPageView = _interopRequireDefault(require(621));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 *
 *  Created by jichao
 *  2024.10.22
 */
var MDClassifyCreateInfoPageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDClassifyCreateInfoPageView, _MDNavigationPageView);
  function MDClassifyCreateInfoPageView() {
    (0, _classCallCheck2["default"])(this, MDClassifyCreateInfoPageView);
    return _callSuper(this, MDClassifyCreateInfoPageView, arguments);
  }
  (0, _createClass2["default"])(MDClassifyCreateInfoPageView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<div class=\"flex-align middle center pd-20 msg\">\n      <img src=\"/img/mdisk/back_classify.svg\" alt=\"\" class=\"classify\"/>\n    </div>\n    <%if(!forEdit){%>\n      <%if(forApply){%>\n        <div class=\"red mgb-10 applymsg\"></div>\n      <%} else if(canCreate){%>\n        <div class=\"help-block mgb-10\"><%=BabelStr.str(12508)%></div>\n      <%} else {%>\n        <div class=\"red mgb-10\"><%=BabelStr.str(12513)%></div>\n        <div class=\"inv-manager-block mgb-10 gap-10 mgt-10 f-hide flex-align middle with-wrap\">\n          <div class=\"manager-title\"><%=BabelStr.str(21215)%></div>\n          <div class=\"inv-manager-list flex-align with-wrap gap-10\"></div>\n        </div>\n      <%}%>\n    <%}%>\n  <form>\n    <div class=\"mgb-20\">\n      <input name=\"classifyName\" type=\"text\"  testFileName  class=\"form-control testFileNameEnd testFileName name notempty\" required placeholder=\"<%=BabelStr.str(12509)%>\" maxlength=\"100\"/>\n    </div>\n    <div class=\"block-title boldfont mgb-10\"><%=BabelStr.str(12510)%></div>\n    <div class=\"select-type mgb-20\"></div>\n    <div class=\"dep-select-content f-none\">\n      <div class=\"block-title boldfont mgb-10\"><%=BabelStr.str(3449)%></div>\n      <div class=\"dep-select\"></div>\n    </div>\n\n\n    <div class=\"block-title boldfont mgb-10\"><%=BabelStr.str(12511)%></div>\n    <div class=\"manager-block mgb-10\"></div>\n\n    <div class=\"setting-option check-option mgb-20\">\n      <div class=\"eval-checkbox check-item flex-align middle checked\">\n        <div class=\"checkbox no-shrink\"></div>\n        <div class=\"name\"><%=BabelStr.str(27007)%></div>\n      </div>\n    </div>\n\n  </form>\n\n  <%if(forApply){%>\n    <div class=\"flex-align end apply-btns\">\n      <button class=\"button done mgr-10 accept\"><%=BabelStr.str(346)%></button>\n      <button class=\"button refuse\"><%=BabelStr.str(342)%></button>\n    </div>\n    <div class=\"mgb-20 apply-results\">\n      <div class=\"flex-align mgb-10\">\n        <span class='mgr-20 no-shrink review-title'><%=BabelStr.str(4567)%>:</span>\n        <span class=\"reviewResult\"></span>\n      </div>\n      <div class=\"flex-align mgb-10\">\n        <span class='mgr-20 no-shrink review-title'><%=BabelStr.str(4568)%>:</span>\n        <span class=\"reviewerName text-hide\"></span>\n      </div>\n      <div class=\"flex-align mgb-10\">\n        <span class='mgr-20 no-shrink review-title'><%=BabelStr.str(4569)%>:</span>\n        <span class=\"reviewTime\"></span>\n      </div>\n    </div>\n  <%} else {%>\n    <div class=\"flex-align center mgb-20\">\n      <%if(forEdit){%>\n        <button class=\"done fullfill button save\"><%=BabelStr.str(3080)%></button>\n      <%} else {%>\n        <%if(canCreate){%>\n          <button class=\"done fullfill button create\"><%=BabelStr.str(12507)%></button>\n        <%} else {%>\n          <button class=\"done fullfill button apply\"><%=BabelStr.str(12514)%></button>\n        <%}%>\n      <%}%>\n    </div>\n    <%if(forEdit){%>\n      <div class=\"text-button apply-users done\"><%=BabelStr.str(12559)%></div>\n    <%} %>\n\n  <%}%>\n\n\n    ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDClassifyCreateInfoPageView.prototype), "className", this).call(this);
      return "".concat(superCls, " ");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDClassifyCreateInfoPageView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        conditionArr: [{
          type: 0,
          name: BabelStr.str(3350)
        }, {
          type: 1,
          name: BabelStr.str(21217)
        }, {
          type: 2,
          name: BabelStr.str(12521)
        }, {
          type: 3,
          name: BabelStr.str(12522)
        }],
        applyModel: undefined,
        canCreate: true,
        forEdit: false,
        fileId: "",
        fileInfor: undefined,
        parentFolder: undefined
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDClassifyCreateInfoPageView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .create": this._createHandle,
        "click .apply": this._applyHandle,
        "click .save": this._saveHandle,
        "click .accept": this._acceptHandle,
        "click .refuse": this._refuseHandle,
        'click .file-name': this.fileNameClickHandler,
        "click .apply-users": this._showApplyUsers,
        "mousedown .check-item": this._checkItemClickHandler
      });
    }
  }, {
    key: "_checkItemClickHandler",
    value: function _checkItemClickHandler($e) {
      var $item = $($e.target).closest(".check-item");
      $item.toggleClass("checked");
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        forApply: this.applyModel,
        canCreate: this.canCreate,
        forEdit: this.forEdit
        // canCreate: this.parentFolder && this.parentFolder.canUploadOnlyActions()
      };
      // if(this.applyModel) {
      //   let userName = this.applyModel.getUserInfoName()

      //   data.applyMsg = ``
      // }
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDClassifyCreateInfoPageView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      if (props.forEdit) {
        props.title = BabelStr.str(12515);
      } else {
        props.title = BabelStr.str(12507);
      }
      props.width = 360;
      props.canCreate = props.parentFolder && props.parentFolder.canUploadOnlyActions();
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDClassifyCreateInfoPageView.prototype), "initialize", this).call(this, props);
      this.chooserView = new _MDEnterpriseShareTabView["default"]({
        ignoreIsShowingStructor: this.ignoreIsShowingStructor,
        canSelDepartment: false,
        inputFullWidth: true,
        notIncludeGuest: true,
        needGroupTreeTab: false,
        needFrequentUserTab: false,
        needRoleTab: false,
        fromStr: BabelStr.str(2404),
        // isTabsOpened: true,
        isSelectOnlyInEp: true,
        onChange: function onChange(mails) {}
      });
      this.addSubView(this.chooserView, this.$(".manager-block")[0]);
      this.conditionSelectView = new _MDDropdownSelectListView["default"]({
        dataProvider: this.conditionArr,
        labelField: "name",
        silentInit: false,
        onChange: function onChange(obj) {
          _this.type = obj.type;
          _this.typeName = obj.name;
          if (obj.type == 1 || obj.type == 0) {
            _this.$('.dep-select-content').hide();
          } else {
            _this.$('.dep-select-content').show();
          }
          _this.navigationWindowView && _this.navigationWindowView.reLayout();
          // this.conditionChanged();
        }
      });
      this.addSubView(this.conditionSelectView, this.$(".select-type")[0]);
      this.depSelect = new _MDEnterpriseShareTabView["default"]({
        inputName: "reading-room-create",
        canSelDepartment: true,
        notIncludeGuest: true,
        hideSelectWhenInput: true,
        needFrequentUserTab: false,
        needGroupTreeTab: false,
        canSelRole: false,
        canSelectDepUser: false,
        canSelGroup: false,
        inputFullWidth: true,
        isSelectOnlyInEp: true,
        placeholder: BabelStr.str(6702),
        fromStr: BabelStr.str(3455),
        emptySearchStr: BabelStr.str(3457)
        // initDepIds: ["201", "226", "1121"]
      });
      this.addSubView(this.depSelect, this.$('.dep-select')[0]);
      this.initData();
      this.$(".classify").on('load', function () {
        console.log("img onload");
        _this.navigationWindowView && _this.navigationWindowView.reLayout();
      });
    }
  }, {
    key: "renderInvManager",
    value: function renderInvManager(managerInfos) {
      if (!managerInfos || !managerInfos.length) {
        return;
      }
      managerInfos = managerInfos.slice(0, 5);
      var tmpl = '';
      _.each(managerInfos, function (user) {
        tmpl += "\n        <div class=\"manager-item flex-align middle\">\n          <div class=\"manager-icon icon no-shrink\"></div>\n          <span class=\"name middle-ellipsis\">".concat(user.userName || user.phone, "</span>\n        </div>\n      ");
      });
      this.$(".inv-manager-list").html(tmpl);
      this.$(".inv-manager-block").removeClass("f-hide");
    }
  }, {
    key: "initData",
    value: function initData() {
      var _this2 = this;
      if (this.applyModel) {
        _MMEnterpriseController["default"].getMaterialApplyInfo(this.applyModel.getMsgFileId(), function (applyInfo) {
          _this2.applyMaterialClass = applyInfo.applyMaterialClass;
          var parentId = _this2.applyMaterialClass.parentFileId;
          var parentFolder = _.findWhere(applyInfo.parentFilePath, {
            fileId: parentId
          });
          var typeStr = parentFolder.enterprisePub == 4 ? BabelStr.str(12541) : BabelStr.str(12500);
          _this2.$('.applymsg').html(BabelStr.str(24003, {
            name: _this2.applyModel.getUserInfoName(),
            type: typeStr,
            file: "<span class = \"file-name text-button done\" data-fileId = \"".concat(parentFolder.fileId, "\">").concat(parentFolder.name, "</span>")
          }));
          var otherOptions = _this2.applyMaterialClass.otherOptions - 0;
          if (otherOptions & 128) {
            _this2.$(".eval-checkbox").removeClass("checked");
          } else {
            _this2.$(".eval-checkbox").addClass("checked");
          }
          if (_.isNumber(_this2.applyMaterialClass.reviewResult)) {
            _this2.$('.apply-btns').hide();
            var resultStr = _this2.applyMaterialClass.reviewResult ? BabelStr.str(346) : BabelStr.str(342);
            _this2.$('.reviewResult').html(resultStr);
            var resultUser = _.findWhere(applyInfo.userInfos, {
              id: _this2.applyMaterialClass.reviewer
            });
            _this2.$('.reviewerName').html(resultUser.name);
            var reviewTime = new Date(_this2.applyMaterialClass.reviewTime).format('yyyy-MM-dd HH:mm');
            _this2.$('.reviewTime').html(reviewTime);
          } else {
            _this2.$('.apply-results').hide();
          }
          var participantCollection = new _MDParticipantInfoCollection["default"]();
          var participantDepCollection = new _MDParticipantInfoCollection["default"]();
          _this2.statisticDepIds = [];
          _this2.statisticUserIds = [];
          _this2.conditionSelectView.selectItemAt(_this2.applyMaterialClass.accessType);
          _this2.$('.name').val(_this2.applyMaterialClass.name);
          _.each(applyInfo.applyDepInfo, function (dep) {
            var applyDepInfo = _MDParticipantInfo["default"].createFromDep(dep);
            participantDepCollection.add(applyDepInfo);
            _this2.statisticDepIds.push(dep.id);
          });
          _.each(applyInfo.members, function (user) {
            var userInfo = _MDParticipantInfo["default"].createFromUser(user);
            participantCollection.add(userInfo);
            _this2.statisticUserIds.push(user.userId);
          });
          _this2.depSelect.setDefaultParticipantInfoCollectio(participantDepCollection);
          _this2.chooserView.setDefaultParticipantInfoCollectio(participantCollection);
          _this2.$('form').addClass('un-clickable');
          _this2.$('.add-entrance').hide();
          _this2.navigationWindowView && _this2.navigationWindowView.reLayout();
        }, function (code, msg) {
          _MDSnackbarView["default"].show(msg);
        });
        return;
      }
      if (!this.fileId) {
        if (this.parentId && this.parentFolder.isMaterialClass()) {
          _MMEnterpriseController["default"].getMaterialClassDispInfo(this.parentId, function (materialClassDispInfo) {
            var participantDepCollection = new _MDParticipantInfoCollection["default"]();
            _this2.conditionSelectView.selectItemAt(materialClassDispInfo.materialClass.accessType);
            _.each(materialClassDispInfo.depInfo, function (dep) {
              var depInfo = _MDParticipantInfo["default"].createFromDep(dep);
              participantDepCollection.add(depInfo);
            });
            _this2.depSelect.setDefaultParticipantInfoCollectio(participantDepCollection);
            _this2.navigationWindowView && _this2.navigationWindowView.reLayout();
          }, function (code, msg) {
            // MDSnackbarView.show(msg)
          });
        }
        if (!this.canCreate && this.parentId) {
          _MMEnterpriseController["default"].getMaterialApprovers(this.parentId, function (approverInfos) {
            _this2.renderInvManager(approverInfos);
          });
        }
        return;
      }
      _MMEnterpriseController["default"].getMaterialClassDispInfo(this.fileId, function (materialClassDispInfo) {
        var participantCollection = new _MDParticipantInfoCollection["default"]();
        var participantDepCollection = new _MDParticipantInfoCollection["default"]();
        _this2.statisticDepIds = [];
        _this2.statisticUserIds = [];
        _this2.materialClass = materialClassDispInfo.materialClass;
        _this2.readers = materialClassDispInfo.readers || [];
        _this2.conditionSelectView.selectItemAt(_this2.materialClass.accessType);
        _this2.$('.name').val(_this2.materialClass.name);
        var otherOptions = _this2.materialClass.otherOptions - 0;
        if (otherOptions & 128) {
          _this2.$(".eval-checkbox").removeClass("checked");
        } else {
          _this2.$(".eval-checkbox").addClass("checked");
        }
        _.each(materialClassDispInfo.depInfo, function (dep) {
          var depInfo = _MDParticipantInfo["default"].createFromDep(dep);
          participantDepCollection.add(depInfo);
          _this2.statisticDepIds.push(dep.id);
        });
        _.each(materialClassDispInfo.managerInfo, function (user) {
          var userInfo = _MDParticipantInfo["default"].createFromUser(user);
          participantCollection.add(userInfo);
          _this2.statisticUserIds.push(user.userId);
        });
        _this2.depSelect.setDefaultParticipantInfoCollectio(participantDepCollection);
        _this2.chooserView.setDefaultParticipantInfoCollectio(participantCollection);
        _this2.navigationWindowView && _this2.navigationWindowView.reLayout();
      }, function (code, msg) {
        _MDSnackbarView["default"].show(msg);
      });
    }
  }, {
    key: "_createHandle",
    value: function _createHandle() {
      var _this3 = this;
      if (this.saving) {
        return;
      }
      var validator = this.$('form').validate();
      if (!validator.form()) {
        return;
      }
      // console.log('aaa')
      // return
      var name = this.$('.name').val();
      var chooseData = this.chooserView.getTargetIds();
      var needEval = this.$(".eval-checkbox").hasClass("checked");
      var params = {
        destDirFileId: this.parentId,
        // app.currentFolder.getFileId(),
        name: name,
        accessType: this.type,
        managerIds: chooseData.userIds,
        otherOptions: needEval ? 0 : Math.pow(2, 7)
        // departmentIds: chooseData.deps
      };
      if (this.type == 2 || this.type == 3) {
        var targetObj = this.depSelect.getTargetObj();
        params.departmentIds = targetObj.deps;
        if (!params.departmentIds.length) {
          _MDMessageView["default"].error(BabelStr.str(12558), this.navigationWindowView.$body);
          return;
        }
      }
      if (!this.canCreate) {
        params.isApply = true;
      }
      console.log(params);
      this.saving = true;
      _MMEnterpriseController["default"].createMaterialClass(params, function (materialClass) {
        _this3.saving = false;
        if (_this3.canCreate) {
          var fileId = materialClass.fileId;
          app.pathRouter.navigateToPath("library/".concat(fileId));
        }
        _MDSnackbarView["default"].show(BabelStr.str(308));
        _this3.navigationWindowView.close();
      }, function (code, msg) {
        _this3.saving = false;
        if (params.isApply && code == 231) {
          msg = BabelStr.str(12567);
        }
        _MDMessageView["default"].error(msg, _this3.navigationWindowView.$body);
      });
    }
  }, {
    key: "_acceptHandle",
    value: function _acceptHandle() {
      this.reviewMaterialApplyInfo(1);
    }
  }, {
    key: "_refuseHandle",
    value: function _refuseHandle() {
      this.reviewMaterialApplyInfo(0);
    }
  }, {
    key: "reviewMaterialApplyInfo",
    value: function reviewMaterialApplyInfo(sign) {
      var _this4 = this;
      _MMEnterpriseController["default"].reviewMaterialApplyInfo(this.applyModel.getMsgFileId(), sign, function (materialClass) {
        _MDSnackbarView["default"].show(BabelStr.str(308));
        _.isFunction(_this4.onSuccess) && _this4.onSuccess(_this4.applyModel);
        _this4.navigationWindowView.close();
      }, function (code, msg) {
        _MDMessageView["default"].error(msg, _this4.navigationWindowView.$body);
      });
    }
  }, {
    key: "_applyHandle",
    value: function _applyHandle() {
      // isApply
      this._createHandle();
    }
  }, {
    key: "_saveHandle",
    value: function _saveHandle() {
      var _this5 = this;
      var validator = this.$('form').validate();
      if (!validator.form()) {
        return;
      }
      var name = this.$('.name').val();
      var chooseData = this.chooserView.getTargetIds();
      var userIds = chooseData.userIds;
      // let depIds = chooseData.deps

      var targetObj = this.depSelect.getTargetObj();
      var depIds = targetObj.deps;
      if (this.type == 2 || this.type == 3) {
        if (!depIds.length) {
          _MDMessageView["default"].error(BabelStr.str(12558), this.navigationWindowView.$body);
          return;
        }
      }
      var addedUserIds = _.difference(userIds, this.statisticUserIds); // 新增的元素
      var removedUserIds = _.difference(this.statisticUserIds, userIds); // 删除的元素

      var addedDepIds = _.difference(depIds, this.statisticDepIds); // 新增的元素
      var removedDepIds = _.difference(this.statisticDepIds, depIds); // 删除的元素
      var needEval = this.$(".eval-checkbox").hasClass("checked");
      var params = {
        fileId: this.fileId,
        accessType: this.type,
        add_depIds: addedDepIds,
        remove_depIds: removedDepIds,
        add_managerIds: addedUserIds,
        remove_managerIds: removedUserIds,
        otherOptions: needEval ? 0 : Math.pow(2, 7)
      };
      if (name != this.materialClass.name) {
        params.name = name;
      }
      console.log(params);
      _MMEnterpriseController["default"].updateMaterialClass(params, function (materialClass) {
        // let fileId = materialClass.fileId
        // app.pathRouter.navigateToPath(`library/${fileId}`)
        if (params.name) {
          _this5.fileInfor.setFileName(params.name);
        }
        _this5.fileInfor.setAccessType(params.accessType);
        _this5.navigationWindowView.close();
        _MDSnackbarView["default"].show(BabelStr.str(308));
      }, function (code, msg) {
        _MDMessageView["default"].error(msg, _this5.navigationWindowView.$body);
      });
    }
  }, {
    key: "fileNameClickHandler",
    value: function fileNameClickHandler($e) {
      $e.stopPropagation();
      var fileId = $($e.target).data("fileid").toString();
      var self = this;
      if (fileId == '0') {
        return;
      }
      this.navigationWindowView.close();
      app.pathRouter.openFileByIdWithOutChannel(fileId, function () {});
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDClassifyCreateInfoPageView.prototype), "viewDidRendered", this).call(this);
      console.log("MDLibraryApplyUsersPageView viewDidRendered");
      this.navigationWindowView && this.navigationWindowView.$el.removeClass('fullbody');
    }
  }, {
    key: "_showApplyUsers",
    value: function _showApplyUsers() {
      this.applyUserView = new _MDClassifyApplyUsersPageView["default"]({
        fileInfor: this.fileInfor,
        readers: this.readers,
        filesDownloadApplied: this.filesDownloadApplied,
        updateApplyUserCallback: function updateApplyUserCallback(count) {
          // this.fileInfor.set("applyDownloadCount", count)
        }
      });
      this.navigationWindowView.push(this.applyUserView);
    }
  }]);
  return MDClassifyCreateInfoPageView;
}(_MDNavigationPageView2["default"]);

},{"1098":1098,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1429":1429,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"1478":1478,"276":276,"277":277,"55":55,"56":56,"621":621,"67":67,"675":675,"72":72}],621:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTabView = _interopRequireDefault(require(82));
var _MDLibraryApplyAccessTabPanelView = _interopRequireDefault(require(624));
var _MDLibraryApplyDownloadTabPanelView = _interopRequireDefault(require(626));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDClassifyApplyUsersPageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDClassifyApplyUsersPageView, _MDNavigationPageView);
  function MDClassifyApplyUsersPageView() {
    (0, _classCallCheck2["default"])(this, MDClassifyApplyUsersPageView);
    return _callSuper(this, MDClassifyApplyUsersPageView, arguments);
  }
  (0, _createClass2["default"])(MDClassifyApplyUsersPageView, [{
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDClassifyApplyUsersPageView.prototype), "className", this).call(this);
      return superCls + ' ';
    }
  }, {
    key: "contentTmpl",
    value: function contentTmpl() {
      return '<div class="apply-container" >' + '</div>';
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      opt.title = BabelStr.str(12560);
      opt.width = 900;
      opt.needFooter = false;
      opt.curIndex = opt.curIndex || 0;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDClassifyApplyUsersPageView.prototype), "initialize", this).call(this, opt);
      this.applyAccess = new _MDLibraryApplyAccessTabPanelView["default"]({
        fileInfor: this.fileInfor,
        readers: this.readers,
        forClass: true
      });
      this.addSubView(this.applyAccess, this.$('.apply-container'));
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDClassifyApplyUsersPageView.prototype), "viewDidRendered", this).call(this);
      console.log("MDClassifyApplyUsersPageView viewDidRendered");
      this.navigationWindowView && this.navigationWindowView.$el.addClass('fullbody');
      this.navigationWindowView && this.navigationWindowView.refreshWindow();
    }
  }]);
  return MDClassifyApplyUsersPageView;
}(_MDNavigationPageView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"56":56,"624":624,"626":626,"82":82}],626:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1541);
require(1437);
require(1463);
require(1478);
require(1498);
require(1421);
require(1439);
require(1412);
require(1416);
require(1432);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _app = _interopRequireDefault(require(17));
var _MDPaginationView = _interopRequireDefault(require(61));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MMFileInfoCollection = _interopRequireDefault(require(298));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDLibraryApplyDownloadForFilePageView = _interopRequireDefault(require(625));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDLibraryApplyDownloadTabPanelView = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(MDLibraryApplyDownloadTabPanelView, _MDTabPanelView);
  function MDLibraryApplyDownloadTabPanelView() {
    (0, _classCallCheck2["default"])(this, MDLibraryApplyDownloadTabPanelView);
    return _callSuper(this, MDLibraryApplyDownloadTabPanelView, arguments);
  }
  (0, _createClass2["default"])(MDLibraryApplyDownloadTabPanelView, [{
    key: "tmpl",
    value: function tmpl() {
      return "<input type=\"\" class=\"form-control file-name-input mgt-20\" placeholder=\"<%=BabelStr.str(12582)%>\"/>\n    <div class=\"files-list\"></div>\n    <div class=\"empty f-none pd-20 f-tc\"><%=BabelStr.str(2622)%></div>\n    <div class=\"table-wrap\"></div>\n\t\t";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDLibraryApplyDownloadTabPanelView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        fileInforCollection: new _MMFileInfoCollection["default"](),
        pageIndex: 0,
        pageSize: 10,
        removeIds: []
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDLibraryApplyDownloadTabPanelView.prototype), "className", this).call(this);
      return "".concat(superCls, " create-classify-win");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDLibraryApplyDownloadTabPanelView.prototype), "events", this).call(this);
      return _.extend(superE, {
        // "click .remove": this.removeUserItem,
        "click .file-name": this._fileNameClicked,
        "click .down-user-btn": this._showDownUsers,
        "keyup .file-name-input": this._fileNameInputHandle
      });
    }
  }, {
    key: "_fileNameInputHandle",
    value: function _fileNameInputHandle() {
      var _this = this;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(function () {
        var val = _this.$(".file-name-input").val().toString();
        val = val.trim();
        _.each(_this.filesDownloadApplied, function (file) {
          if (val && file.name.indexOf(val) < 0) {
            file.hide = true;
          } else {
            file.hide = false;
          }
        });
        _this.renderFiles();
        _this.timer = null;
      }, 400);
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      props.title = BabelStr.str(12551);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDLibraryApplyDownloadTabPanelView.prototype), "initialize", this).call(this, props);
      this.renderFiles();
      if (!this.filesDownloadApplied.length) {
        this.$(".empty").show();
        this.$(".file-name-input").hide();
      }
    }
  }, {
    key: "onActived",
    value: function onActived() {
      this.navigationWindowView && this.navigationWindowView.refreshWindow();
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.close();
    }
  }, {
    key: "renderFiles",
    value: function renderFiles() {
      var _this2 = this;
      var tmpl = '';
      _.each(this.filesDownloadApplied, function (file) {
        if (!file.hide) {
          tmpl += _this2.getFileItemTmpl(file);
        }
      });
      this.$('.files-list').html(tmpl);
      this.navigationWindowView && this.navigationWindowView.refreshWindow();
    }
  }, {
    key: "getFileItemTmpl",
    value: function getFileItemTmpl(file) {
      return "<div class=\"file-info flex-align middle between file-item\" data-id=\"".concat(file.fileId, "\">\n      <div class=\"file-name text-hide text-button done mgr-20\">").concat(file.name, "</div>\n      <div class=\"down-user-btn text-button no-shrink done\">").concat(BabelStr.str(12562), "</div>\n    </div>");
    }
  }, {
    key: "_fileNameClicked",
    value: function _fileNameClicked($e) {
      var fileId = $($e.target).closest('.file-info').data("id").toString();
      _app["default"].pathRouter.openNewTabByFileId(fileId);
    }
  }, {
    key: "_showDownUsers",
    value: function _showDownUsers($e) {
      var _this3 = this;
      var fileId = $($e.target).closest('.file-info').data("id").toString();
      var usersView = new _MDLibraryApplyDownloadForFilePageView["default"]({
        fileId: fileId,
        onRemove: function onRemove() {
          console.error("remove" + fileId);
          var $item = _this3.$(".file-info[data-id=\"".concat(fileId, "\"]"));
          $item.remove();
          var index = _.findIndex(_this3.filesDownloadApplied, function (item) {
            return fileId == item.fileId;
          });
          if (index > -1) {
            _this3.filesDownloadApplied.splice(index, 1);
          }
          if (!_this3.filesDownloadApplied.length) {
            _this3.$(".empty").show();
            _this3.$(".file-name-input").hide();
          }
        }
      });
      this.navigationWindowView.push(usersView);
    }
  }, {
    key: "removeUserItem",
    value: function removeUserItem($e) {
      var id = $($e.target).closest(".item").data("id").toString();
      console.log(id);
      this.removeIds.push(id);
      var $item = $($e.target).closest(".item");
      this._save($item);
    }

    // _save($item) {
    //   if(!this.removeIds.length) {
    //     return
    //   }
    //   console.log(this.removeIds)
    //   MMEnterpriseController.listEnterpriseFiles(this.fileInfor.getFileId(), this.removeIds, ()=>{
    //     $item.remove()
    //     MDSnackbarView.show(BabelStr.str(308))
    //     // this.close()
    //     this.getDownloadAppliedUsers()
    //   }, (code, msg)=>{
    //     MDMessageView.error(msg, this.$body)
    //   })
    // }
  }], [{
    key: "className",
    value: function className() {
      return 'MDLibraryApplyDownloadTabPanelView';
    }
  }]);
  return MDLibraryApplyDownloadTabPanelView;
}(_MDTabPanelView2["default"]);

},{"1098":1098,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1416":1416,"1421":1421,"1432":1432,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"1478":1478,"1498":1498,"1541":1541,"17":17,"273":273,"298":298,"61":61,"625":625,"76":76,"81":81}],625:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDPaginationView = _interopRequireDefault(require(61));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDLibraryApplyDownloadForFilePageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDLibraryApplyDownloadForFilePageView, _MDNavigationPageView);
  function MDLibraryApplyDownloadForFilePageView() {
    (0, _classCallCheck2["default"])(this, MDLibraryApplyDownloadForFilePageView);
    return _callSuper(this, MDLibraryApplyDownloadForFilePageView, arguments);
  }
  (0, _createClass2["default"])(MDLibraryApplyDownloadForFilePageView, [{
    key: "tmpl",
    value: function tmpl() {
      return "<div class=\"users-list\"></div>\n    <div class=\"empty f-none pd-20 f-tc\"><%=BabelStr.str(2622)%></div>\n    <div class=\"table-wrap\"></div>\n\t\t";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDLibraryApplyDownloadForFilePageView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        userCollection: new _MDMolaUserCollection["default"](),
        fileId: '',
        pageIndex: 0,
        pageSize: 10,
        removeIds: []
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDLibraryApplyDownloadForFilePageView.prototype), "className", this).call(this);
      return "".concat(superCls, " create-classify-win");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDLibraryApplyDownloadForFilePageView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .remove": this.removeUserItem
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.title = BabelStr.str(12551);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDLibraryApplyDownloadForFilePageView.prototype), "initialize", this).call(this, props);
      this.paginationBarView = new _MDPaginationView["default"]({
        silentInit: true,
        pageSize: this.pageSize,
        onPageChanged: function onPageChanged(curPageIndex) {
          _this.pageIndex = curPageIndex;
          _this.getDownloadAppliedUsers();
        },
        onPageSizeChanged: function onPageSizeChanged(newPageSize) {
          _this.pageSize = newPageSize;
          _this.pageIndex = 0;
          _this.getDownloadAppliedUsers();
        }
      });
      // this.paginationBarView.hide();
      this.addSubView(this.paginationBarView, this.$(".table-wrap")[0]);
      this.getDownloadAppliedUsers();
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.close();
    }
  }, {
    key: "getDownloadAppliedUsers",
    value: function getDownloadAppliedUsers() {
      var _this2 = this;
      var params = {
        fileId: this.fileId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      _MDSpinnerloaderView["default"].showIn(this.$el);
      _MMEnterpriseController["default"].getDownloadAppliedUsers(params, function (userCollection, total) {
        _this2.total = total;
        _this2.userCollection = userCollection;
        _this2.renderUsers();
        _this2.paginationBarView.setLength(total, true, _this2.pageIndex * _this2.pageSize);
        _this2.paginationBarView.show();
        _MDSpinnerloaderView["default"].clearFrom(_this2.$el);
        if (_this2.total == 0) {
          _this2.$(".empty").show();
          _.isFunction(_this2.onRemove) && _this2.onRemove();
        }
        _this2.navigationWindowView && _this2.navigationWindowView.refreshWindow();
      }, function (code, msg) {
        MDMessageView.error(msg["this"].$el);
        _MDSpinnerloaderView["default"].clearFrom(_this2.$el);
      });
    }
  }, {
    key: "renderUsers",
    value: function renderUsers() {
      var tmpl = '';
      this.userCollection.each(function (user) {
        tmpl += user.getUserItemHtmlStr({
          canRemove: true
        });
      });
      this.$('.users-list').html(tmpl);
      this.navigationWindowView.refreshWindow();
    }
  }, {
    key: "removeUserItem",
    value: function removeUserItem($e) {
      var _this3 = this;
      this.removeIds = [];
      var id = $($e.target).closest(".item").data("id").toString();
      console.log(id);
      this.removeIds.push(id);
      var $item = $($e.target).closest(".item");
      this.showAlert(function () {
        _this3._save($item);
      });
    }
  }, {
    key: "showAlert",
    value: function showAlert(callback) {
      // if(!this.alert) {
      this.alert = new _MDAlertView["default"]({
        title: BabelStr.str(170),
        message: "<p class=\"title\">".concat(BabelStr.str(12565), "</p>"),
        className: "m-delAlertWin",
        width: 550,
        buttons: [{
          label: BabelStr.str(155)
        }, {
          label: BabelStr.str(32),
          type: "danger",
          onClick: function onClick() {
            callback();
          }
        }]
      });
      // }
      this.alert.show();
    }
  }, {
    key: "_save",
    value: function _save($item) {
      var _this4 = this;
      if (!this.removeIds.length) {
        return;
      }
      console.log(this.removeIds);
      _MMEnterpriseController["default"].removeUserDownloadAppliedFileId(this.fileId, this.removeIds, function () {
        $item.remove();
        _MDSnackbarView["default"].show(BabelStr.str(308));
        // this.close()
        _this4.getDownloadAppliedUsers();
      }, function (code, msg) {
        MDMessageView.error(msg, _this4.$el);
      });
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MDLibraryApplyDownloadForFilePageView';
    }
  }]);
  return MDLibraryApplyDownloadForFilePageView;
}(_MDNavigationPageView2["default"]);

},{"1098":1098,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1437":1437,"1454":1454,"1463":1463,"1475":1475,"1478":1478,"273":273,"32":32,"56":56,"61":61,"72":72,"76":76}],624:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1541);
require(1437);
require(1463);
require(1478);
require(1498);
require(1421);
require(1416);
require(1432);
require(1426);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDPaginationView = _interopRequireDefault(require(61));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
var _MEStaffSearchWindowView = _interopRequireDefault(require(200));
var _MDMolaUser = _interopRequireDefault(require(272));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDAddProjectMemberPageView = _interopRequireDefault(require(639));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDLibraryApplyAccessTabPanelView = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(MDLibraryApplyAccessTabPanelView, _MDTabPanelView);
  function MDLibraryApplyAccessTabPanelView() {
    (0, _classCallCheck2["default"])(this, MDLibraryApplyAccessTabPanelView);
    return _callSuper(this, MDLibraryApplyAccessTabPanelView, arguments);
  }
  (0, _createClass2["default"])(MDLibraryApplyAccessTabPanelView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n    <div class=\"flex-align end mgt-20\">\n      <span class=\"text-button add-user done\"><%=BabelStr.str(25000)%></span>\n    </div>\n    <input type=\"\" class=\"form-control file-name-input mgt-10\" placeholder=\"<%=BabelStr.str(12587)%>\"/>\n    <div class=\"users-list\"></div>\n    <div class=\"empty f-none pd-20 f-tc\"><%=BabelStr.str(2622)%></div>\n    <div class=\"table-wrap\"></div>\n\t\t";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDLibraryApplyAccessTabPanelView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        userCollection: new _MDMolaUserCollection["default"](),
        pageIndex: 0,
        pageSize: 10,
        removeIds: []
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDLibraryApplyAccessTabPanelView.prototype), "className", this).call(this);
      return "".concat(superCls, " create-classify-win");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDLibraryApplyAccessTabPanelView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .remove": this.removeUserItem,
        "click .add-user": this.addUser,
        "keyup .file-name-input": this._fileNameInputHandle
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      props.title = BabelStr.str(12551);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDLibraryApplyAccessTabPanelView.prototype), "initialize", this).call(this, props);
      this.userCollection = new _MDMolaUserCollection["default"](this.readers);
      this.renderUsers();
      if (!this.readers.length) {
        this.$(".empty").show();
        this.$(".file-name-input").hide();
      }
    }
  }, {
    key: "onActived",
    value: function onActived() {
      this.navigationWindowView && this.navigationWindowView.refreshWindow();
    }
  }, {
    key: "addUser",
    value: function addUser() {
      var _this = this;
      // let win = new MEStaffSearchWindowView({
      //   // singleSelection: true,
      //   includeNumberInfo: false,
      //   onChoose: (users) => {
      //     console.log(users);
      //     this.addlMaterialReaders(users)
      //   }
      // });
      // win.show();

      this.addmanagerView = new _MDAddProjectMemberPageView["default"]({
        addManager: false,
        excludeOutsider: true,
        notIncludeGuest: true,
        title: BabelStr.str(25000),
        needRoleSelectList: false,
        onSelected: function onSelected(users) {
          console.log(users);
          _this.addlMaterialReaders(users);
        }
      });
      this.$(".user-list-contain").show();
      this.$(".empty").addClass("f-hide");
      this.navigationWindowView.push(this.addmanagerView);
    }
  }, {
    key: "_fileNameInputHandle",
    value: function _fileNameInputHandle() {
      var _this2 = this;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(function () {
        var val = _this2.$(".file-name-input").val().toString();
        val = val.trim();
        _this2.userCollection.each(function (user) {
          var userStr = user.getUserName() + user.getAccount();
          if (val && userStr.indexOf(val) < 0) {
            user.hide = true;
          } else {
            user.hide = false;
          }
        });
        _this2.renderUsers();
        _this2.timer = null;
      }, 400);
    }
  }, {
    key: "renderUsers",
    value: function renderUsers() {
      var tmpl = '';
      this.userCollection.each(function (user) {
        if (!user.hide) {
          tmpl += user.getUserItemHtmlStr({
            canRemove: true
          });
        }
      });
      this.$('.users-list').html(tmpl);
      this.navigationWindowView && this.navigationWindowView.refreshWindow();
    }
  }, {
    key: "removeUserItem",
    value: function removeUserItem($e) {
      var _this3 = this;
      var id = $($e.target).closest(".item").data("id").toString();
      console.log(id);
      this.removeIds.push(id);
      var $item = $($e.target).closest(".item");
      this.showAlert(function () {
        _this3._save($item);
      });
    }
  }, {
    key: "showAlert",
    value: function showAlert(callback) {
      // if(!this.alert) {
      var msg = BabelStr.str(12564);
      if (this.forClass) {
        msg = BabelStr.str(12581);
      }
      this.alert = new _MDAlertView["default"]({
        title: BabelStr.str(170),
        message: "<p class=\"title\">".concat(msg, "</p>"),
        className: "m-delAlertWin",
        width: 550,
        buttons: [{
          label: BabelStr.str(155)
        }, {
          label: BabelStr.str(32),
          type: "danger",
          onClick: function onClick() {
            callback();
          }
        }]
      });
      // }
      this.alert.show();
    }
  }, {
    key: "_save",
    value: function _save($item) {
      var _this4 = this;
      if (!this.removeIds.length) {
        return;
      }
      console.log(this.removeIds);
      _MMEnterpriseController["default"].removeUserAppliedAccess(this.fileInfor.getFileId(), this.removeIds, function () {
        $item.remove();
        _MDSnackbarView["default"].show(BabelStr.str(308));
        var index = _.findIndex(_this4.readers, function (item) {
          return item.userId == _this4.removeIds[0];
        });
        if (index > -1) {
          _this4.readers.splice(index, 1);
        }
        if (!_this4.readers.length) {
          _this4.$(".empty").show();
          _this4.$(".file-name-input").hide();
        }
        _this4.navigationWindowView && _this4.navigationWindowView.refreshWindow();
      }, function (code, msg) {
        MDMessageView.error(msg, _this4.$body);
      });
    }
  }, {
    key: "addlMaterialReaders",
    value: function addlMaterialReaders(userArr) {
      var _this5 = this;
      var users = [];
      var readerIds = [];
      var originIds = _.map(this.readers, function (item) {
        return item.userId;
      });
      _.each(userArr, function (user) {
        if (user instanceof _MDMolaUser["default"]) {} else {
          user = new _MDMolaUser["default"](user);
        }
        var index = _.findIndex(originIds, function (userId) {
          return userId == user.getUserId();
        });
        if (index == -1) {
          users.push(user);
          readerIds.push(user.getUserId());
        }
      });
      if (!readerIds.length) {
        return;
      }
      _MMEnterpriseController["default"].addlMaterialReaders(this.fileInfor.getFileId(), readerIds, function () {
        _.each(users, function (user) {
          _this5.readers.push(user);
        });
        _this5.userCollection = new _MDMolaUserCollection["default"](_this5.readers);
        _this5.renderUsers();
        _MDSnackbarView["default"].show(BabelStr.str(308));
        _this5.navigationWindowView && _this5.navigationWindowView.refreshWindow();
      }, function (code, msg) {
        MDMessageView.error(msg, _this5.$body);
      });
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MDLibraryApplyAccessTabPanelView';
    }
  }]);
  return MDLibraryApplyAccessTabPanelView;
}(_MDTabPanelView2["default"]);

},{"1098":1098,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1416":1416,"1421":1421,"1426":1426,"1432":1432,"1437":1437,"1454":1454,"1463":1463,"1475":1475,"1478":1478,"1498":1498,"1541":1541,"200":200,"272":272,"273":273,"32":32,"61":61,"639":639,"72":72,"76":76,"81":81}],620:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationWindowView = _interopRequireDefault(require(92));
var _MDBatchEditLibraryInfoView = _interopRequireDefault(require(619));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDBatchEditLibraryWinView = exports["default"] = /*#__PURE__*/function (_MDNavigationWindowVi) {
  (0, _inherits2["default"])(MDBatchEditLibraryWinView, _MDNavigationWindowVi);
  function MDBatchEditLibraryWinView() {
    (0, _classCallCheck2["default"])(this, MDBatchEditLibraryWinView);
    return _callSuper(this, MDBatchEditLibraryWinView, arguments);
  }
  (0, _createClass2["default"])(MDBatchEditLibraryWinView, [{
    key: "initialize",
    value: function initialize(props) {
      props.title = BabelStr.str(12572);
      props.size = 'large';
      props.rootNavigationPageView = new _MDBatchEditLibraryInfoView["default"](props);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBatchEditLibraryWinView.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBatchEditLibraryWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " library-win");
    }
  }]);
  return MDBatchEditLibraryWinView;
}(_MDNavigationWindowView["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"619":619,"92":92}],619:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1426);
require(1439);
require(1437);
require(1415);
require(1463);
require(1466);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MDAddProjectMemberPageView = _interopRequireDefault(require(639));
var _MDUserItem = _interopRequireDefault(require(667));
var _MDEnterpriseShareTabView = _interopRequireDefault(require(675));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDBatchEditLibraryInfoView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDBatchEditLibraryInfoView, _MDNavigationPageView);
  function MDBatchEditLibraryInfoView() {
    (0, _classCallCheck2["default"])(this, MDBatchEditLibraryInfoView);
    return _callSuper(this, MDBatchEditLibraryInfoView, arguments);
  }
  (0, _createClass2["default"])(MDBatchEditLibraryInfoView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<div class=\"flex-align middle center pd-20 msg\">\n      <img class=\"thumb-img\" src=\"/img/mdisk/back_library.svg\" alt=\"\"/>\n    </div>\n    <div class=\"flex-align middle line-item mgb-10\">\n      <div class=\"line-title no-shrink\"><%=BabelStr.str(12519)%></div>\n      <div class=\"flex-align middle line-item\">\n        <div class=\"select-type mgr-20\"></div>\n        <div class=\"type-comment help-block\"></div>\n      </div>\n    </div>\n\n    <div class=\"flex-align middle between mgb-10 line-item\">\n      <div class=\"line-title no-shrink\"><%=BabelStr.str(2814)%></div>\n      <input type=\"\" class=\"form-control manager\" placeholder=\"<%=BabelStr.str(12578)%>\"/>\n    </div>\n\n    <div class=\"flex-align middle line-item\">\n      <div class=\"line-title no-shrink\"></div>\n      <div>\n        <div class=\"normal-option check-option f-none\">\n          <div class=\"down-checkbox check-item flex-align middle\" data-sign=\"0\">\n            <div class=\"checkbox no-shrink\"></div>\n            <div class=\"name \"><%=BabelStr.str(12520)%></div>\n          </div>\n        </div>\n        <div class=\"apply-option check-option f-none\">\n          <div class=\"down-checkbox check-item flex-align middle\" data-sign=\"0\">\n            <div class=\"checkbox no-shrink\"></div>\n            <div class=\"name \"><%=BabelStr.str(12520)%></div>\n          </div>\n          <div class=\"down-checkbox check-item flex-align middle\" data-sign=\"1\">\n            <div class=\"checkbox no-shrink\"></div>\n            <div class=\"name \"><%=BabelStr.str(12528)%></div>\n          </div>\n          <div class=\"down-checkbox check-item flex-align middle\" data-sign=\"2\">\n            <div class=\"checkbox no-shrink\"></div>\n            <div class=\"name \"><%=BabelStr.str(12529)%></div>\n          </div>\n        </div>\n        <div class=\"secrecy-option check-option f-none\">\n          <div class=\"down-checkbox check-item flex-align middle\" data-sign=\"1\">\n            <div class=\"checkbox no-shrink\"></div>\n            <div class=\"name \"><%=BabelStr.str(12528)%></div>\n          </div>\n          <div class=\"down-checkbox check-item flex-align middle\" data-sign=\"2\">\n            <div class=\"checkbox no-shrink\"></div>\n            <div class=\"name \"><%=BabelStr.str(12529)%></div>\n          </div>\n          <div class=\"down-checkbox check-item flex-align middle\" data-sign=\"3\">\n            <div class=\"checkbox no-shrink\"></div>\n            <div class=\"name \"><%=BabelStr.str(12530)%></div>\n          </div>\n          <div class=\"down-checkbox check-item flex-align middle\" data-sign=\"6\">\n            <div class=\"checkbox no-shrink\"></div>\n            <div class=\"name \"><%=BabelStr.str(12583)%></div>\n          </div>\n          <div class=\"down-checkbox check-item flex-align middle\" data-sign=\"4\">\n            <div class=\"checkbox no-shrink\"></div>\n            <div class=\"name \"><%=BabelStr.str(12531)%></div>\n            <div class=\"time-content flex-align middle f-hide\">\n              <span class=\"no-shrink\"><%=BabelStr.str(176)%></span>\n              <span class = \"datepicker\">\n                <input type=\"text\" class=\"date-expire\"  placeholder=\"<%=BabelStr.str(176)%>\">\n                <i class = \"icon ep-expire-date\"></i>\n              </span>\n            </div>\n          </div>\n\n          <div class=\"end-block f-hide\">\n            <div class=\"flex-align middle\">\n              <span class=\"mgr-10\"><%=BabelStr.str(12532)%></span>\n              <div class=\"next-access-type\"></div>\n            </div>\n            <div class=\"down-checkbox check-item flex-align middle\" data-sign=\"5\">\n              <div class=\"checkbox no-shrink\"></div>\n              <div class=\"name \"><%=BabelStr.str(12533)%></div>\n            </div>\n          </div>\n\n        </div>\n      </div>\n    </div>\n\n\n\n\n    <div class=\"flex-align between mgt-10 add-title\">\n      <span><%=BabelStr.str(12534)%></span>\n      <div class=\"text-button done add-library-assistant\"><%=BabelStr.str(12518)%></div>\n    </div>\n    <div class=\"help-block\"><%=BabelStr.str(12536)%></div>\n    <div class=\"assistant-user-list-contain users-list\"></div>\n\n    <div class=\"flex-align between mgt-10 add-title\">\n      <span><%=BabelStr.str(12537)%></span>\n      <div class=\"text-button done add-library-member\"><%=BabelStr.str(7268)%></div>\n    </div>\n    <div class=\"help-block\"><%=BabelStr.str(12535)%></div>\n    <div class=\"user-list-contain users-list mgb-20\"></div>\n\n\n    <div class=\"bottom-block\">\n      <div class=\"warn-msg red f-tc\"><%=BabelStr.str(12579)%></div>\n    </div>\n    <div class=\"flex-align end btns-block\">\n      <button class=\"button done mgr-10 save\"><%=BabelStr.str(3080)%></button>\n    </div>\n    ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBatchEditLibraryInfoView.prototype), "className", this).call(this);
      return "".concat(superCls, " create-classify-win batch create-library-page");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBatchEditLibraryInfoView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        conditionArr: [{
          type: 0,
          name: BabelStr.str(3350),
          comment: BabelStr.str(12525)
        }, {
          type: 1,
          name: BabelStr.str(12523),
          comment: BabelStr.str(12526)
        }, {
          type: 4,
          name: BabelStr.str(12524),
          comment: BabelStr.str(12527)
        }],
        nextconditionArr: [{
          type: 0,
          name: BabelStr.str(3350),
          comment: BabelStr.str(12525)
        }, {
          type: 1,
          name: BabelStr.str(12523),
          comment: BabelStr.str(12526)
        }],
        userCollection: new _MDMolaUserCollection["default"]()
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBatchEditLibraryInfoView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .save": this._saveHandle,
        "click .manager": this._addManagerHandle,
        "mousedown .check-item": this._checkItemClickHandler,
        "mousedown .time-content": this._timeContentClickHandle,
        "click .add-library-assistant": this._addAssistantHandle,
        "click .add-library-member": this._addMemberHandle
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.title = BabelStr.str(12572);
      props.width = 410;
      // props.buttons = [{
      //   type: "done",
      //   label: BabelStr.str(3080),
      //   autoClose: false,
      //   onClick: ()=>{
      //     this._saveHandle()
      //   }
      // }]
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBatchEditLibraryInfoView.prototype), "initialize", this).call(this, props);
      var names = _.map(this.fileInfors, function (file) {
        return file.getFileName();
      });
      var nameStr = '';
      if (names.length > 2) {
        nameStr = BabelStr.str(12576, {
          name1: names[0],
          name2: names[1],
          len: names.length
        });
      } else {
        nameStr = BabelStr.str(12577, {
          name1: names[0],
          name2: names[1],
          len: names.length
        });
      }
      this.$(".name-tip").html(nameStr);
      this.conditionSelectView = new _MDDropdownSelectListView["default"]({
        dataProvider: this.conditionArr,
        labelField: "name",
        silentInit: false,
        onChange: function onChange(obj) {
          _this.type = obj.type;
          _this.typeName = obj.name;
          _this.$('.type-comment').html(obj.comment);
          _this.renderTypeContent();
        }
      });
      this.addSubView(this.conditionSelectView, this.$(".select-type")[0]);
      this.nextTypeSelectView = new _MDDropdownSelectListView["default"]({
        dataProvider: this.nextconditionArr,
        labelField: "name",
        silentInit: false,
        onChange: function onChange(obj) {
          _this.nextAccessType = obj.type;
        }
      });
      this.addSubView(this.nextTypeSelectView, this.$(".next-access-type")[0]);

      // this.chooserView = new MDEnterpriseShareTabView({
      //   ignoreIsShowingStructor: true,
      //   canSelDepartment: false,
      //   inputFullWidth: true,
      //   notIncludeGuest: true,
      //   needGroupTreeTab: true,
      //   canSelGroup: false,
      //   needFrequentUserTab: true,
      //   needRoleTab: false,
      //   fromStr: BabelStr.str(2404),
      //   placeholder: BabelStr.str(12578),
      //   // isTabsOpened: true,
      //   isSelectOnlyInEp: true,
      //   onlyOne: true,
      //   onChange: function(mails) {
      //   }
      // })
      // this.addSubView(this.chooserView,this.$(".manager-block")[0])
      var now = new Date();
      // 创建一个新的 Date 对象，表示7天后的时间
      var sevenDaysLater = new Date(now);
      sevenDaysLater.setDate(now.getDate() + 7);
      this.$('.date-expire').datepicker({
        defaultDate: '+7d',
        dateFormat: "yy-mm-dd"
      });
      this.$('.date-expire').datepicker("setDate", sevenDaysLater);
      this.$assistantContain = this.$(".assistant-user-list-contain");
      this.$contain = this.$(".user-list-contain");
      this.listenTo(this.userCollection, "add", this.appendItemUser);
      this.listenTo(this.userCollection, "remove", this.removeItemUser);
      this.getRoles();
    }
  }, {
    key: "appendItemUser",
    value: function appendItemUser(user) {
      var _this2 = this;
      if (user.getRoleId() == -1 && user.get("type") == 0) {
        user.setRoleId(11);
      }
      if (_.isNull(user.get("type"))) {
        user.set("type", 0);
      }
      var item = new _MDUserItem["default"]({
        user: user,
        roles: this.roles,
        roleArr: this.roleArr,
        needRoleAndEndTime: user.get("type") == 0,
        // showDes: user.get("type") == 1 || user.get("type") == 2,
        description: user.get("type") == 1 ? "" : undefined,
        canRemove: !this.isProjectAssist || user.get("type") == 0,
        removeCallback: function removeCallback(id) {
          _this2.removeUser(id);
          // this.removeSubView(item)
        }
      });
      if (user.get("type") == 1) {
        // this.addSubViewAt(item, 0, this.$manageContain);
        return;
      } else if (user.get("type") == 2) {
        this.addSubViewAt(item, 0, this.$assistantContain);
      } else {
        this.addSubView(item, this.$contain);
      }
      this.$(".empty").addClass("f-hide");
      this.$(".user-list-contain").show();
      this.navigationWindowView && this.navigationWindowView.refreshWindow();
    }
  }, {
    key: "getRoles",
    value: function getRoles() {
      var self = this;
      var _initRoles = function _initRoles(roleCollection, defaultRole) {
        var shareRoles = [];
        roleCollection.each(function (roleInfo) {
          shareRoles.push(roleInfo);
        });
        self.roles = shareRoles;
        self.roleArr = [];
        for (var i = 0; i < self.roles.length; i++) {
          var role = self.roles[i];
          var str = {
            label: role.get("description"),
            canSelected: true,
            linkRoleId: role.getRoleId(),
            systemdefault: role.get("systemdefault")
          };
          self.roleArr.push(str);
        }
        if (self.needRenderedUsers) {
          self.userCollection.add(self.needRenderedUsers);
        }
        self.navigationWindowView && self.navigationWindowView.reLayout();
      };
      MMNetDiskDataController.getAllRoles(function (roleCollection, defaultRole) {
        _initRoles(roleCollection, defaultRole);
      }, function () {
        _MDSnackbarView["default"].show(BabelStr.str(7270));
      });
    }
  }, {
    key: "removeUser",
    value: function removeUser(userId) {
      var user = this.userCollection.findWhere({
        userId: userId
      });
      this.userCollection.remove(user);
      this.deleteIds = _.union(this.deleteIds, [userId]);
    }
  }, {
    key: "removeItemUser",
    value: function removeItemUser(user) {
      var id = user.getUserId();
      // this.$(`.user-list-contain >.item[data-id=${id}]`).remove();
      _.each(this.subViews, function (view) {
        if (view instanceof _MDUserItem["default"]) {
          if (view.getUserId() == id) {
            view.remove();
          }
        }
      });
      this.navigationWindowView.refreshWindow();
    }
  }, {
    key: "_addAssistantHandle",
    value: function _addAssistantHandle() {
      var _this3 = this;
      this.addMemberView = new _MDAddProjectMemberPageView["default"]({
        userEpSelectComp: true,
        title: BabelStr.str(12518),
        onSelected: function onSelected(users) {
          users = _.map(users, function (user) {
            user.set("userId", user.getId());
            return user;
          });
          users = _.filter(users, function (user) {
            var oldUser = _this3.userCollection.findWhere({
              id: user.getUserId()
            });
            if (oldUser && oldUser.get("type") != 1) {
              _this3.userCollection.remove(oldUser.cid);
            }
            user.set("type", 2);
            var filtered = false;
            if (!_this3.manager) {
              filtered = true;
            }
            filtered = filtered || user.getUserId() != _this3.manager.getUserId();
            if (!filtered) {
              _MDSnackbarView["default"].show(BabelStr.str(20156));
            }
            return filtered;
          });
          _this3.userCollection.add(users);
        }
      });
      this.navigationWindowView.push(this.addMemberView);
    }
  }, {
    key: "_addMemberHandle",
    value: function _addMemberHandle() {
      var _this4 = this;
      this.addMemberView = new _MDAddProjectMemberPageView["default"]({
        // canSelDepartment: false,
        // canSelGroup: false,
        title: BabelStr.str(12557),
        userEpSelectComp: true,
        onSelected: function onSelected(users) {
          users = _.map(users, function (user) {
            user.set("userId", user.getId());
            return user;
          });
          users = _.filter(users, function (user) {
            var oldUser = _this4.userCollection.findWhere({
              id: user.id
            });
            if (oldUser && oldUser.get("type") != 1) {
              if (_this4.isProjectAssist && oldUser.get("type") == 2) {
                return false;
              }
              _this4.userCollection.remove(oldUser.cid);
            }
            user.set("type", 0);
            if (!_this4.manager) {
              return true;
            }
            return user.id != _this4.manager.getUserId();
          });
          _this4.userCollection.add(users);
        }
      });
      this.$(".user-list-contain").show();
      this.navigationWindowView.push(this.addMemberView);
    }
  }, {
    key: "_checkItemClickHandler",
    value: function _checkItemClickHandler($e) {
      var $item = $($e.target).closest(".check-item");
      $item.toggleClass("checked");
      var sign = $item.data("sign");
      if (sign == 4) {
        this.renderEndBlock();
      }
    }
  }, {
    key: "_timeContentClickHandle",
    value: function _timeContentClickHandle($e) {
      $e.stopPropagation();
    }
  }, {
    key: "renderEndBlock",
    value: function renderEndBlock() {
      var $item = this.$('.check-item[data-sign="4"]');
      if ($item.hasClass('checked')) {
        this.$('.time-content').removeClass('f-hide');
        this.$('.end-block').removeClass('f-hide');
      } else {
        this.$('.time-content').addClass('f-hide');
        this.$('.end-block').addClass('f-hide');
      }
      this.navigationWindowView && this.navigationWindowView.reLayout();
    }
  }, {
    key: "renderTypeContent",
    value: function renderTypeContent() {
      if (this.type == 4) {
        this.$('.secrecy-option').show();
        this.$('.normal-option').hide();
        this.$('.apply-option').hide();
      } else if (this.type == 0) {
        this.$('.normal-option').show();
        this.$('.secrecy-option').hide();
        this.$('.apply-option').hide();
      } else {
        this.$('.normal-option').hide();
        this.$('.secrecy-option').hide();
        this.$('.apply-option').show();
      }
      this.navigationWindowView && this.navigationWindowView.reLayout();
    }
  }, {
    key: "_addManagerHandle",
    value: function _addManagerHandle() {
      var _this5 = this;
      if (this.isProjectAssist) {
        return;
      }
      this.addmanagerView = new _MDAddProjectMemberPageView["default"]({
        addManager: true,
        onSelected: function onSelected(users) {
          _this5.manager = users[0];
          var oldManager = _this5.userCollection.findWhere({
            type: 1
          });
          _this5.userCollection.remove(oldManager);
          // this.manager.set("isAdmin", true);
          _this5.manager.set("type", 1);
          _this5.userCollection.add(_this5.manager);
          _this5.$(".manager").val(_.unescape(_this5.manager.getUserName()));
        }
      });
      this.$(".user-list-contain").show();
      this.$(".empty").addClass("f-hide");
      this.navigationWindowView.push(this.addmanagerView);
    }
  }, {
    key: "_saveHandle",
    value: function _saveHandle() {
      var _this6 = this;
      var ids = _.map(this.fileInfors, function (file) {
        return file.getFileId();
      });
      var assistantIds = [];
      var memberInfos = [];
      this.userCollection.each(function (user) {
        if (user.get("type") == 1) {
          return;
        } else if (user.get("type") == 2) {
          assistantIds.push(user.getUserId());
        } else {
          memberInfos.push({
            userId: user.getUserId(),
            roleId: user.getRoleId(),
            dueTime: user.get("endTime")
          });
        }
      });
      var params = {
        fileIds: ids,
        // app.currentFolder.getFileId(),
        managerIds: this.manager ? [this.manager.getUserId()] : undefined,
        assistantIds: assistantIds.length ? assistantIds : undefined,
        memberInfos: memberInfos.length ? memberInfos : undefined,
        accessType: this.type
        // managerIds: chooseData.userIds,
        // departmentIds: chooseData.deps
      };
      var option = 0;
      if (this.type == 0) {
        if (this.$('.normal-option .check-item').hasClass('checked')) {
          option = option | 1;
        }
      } else if (this.type == 1) {
        var $checkItems = this.$('.apply-option .check-item.checked');
        for (var i = 0; i < $checkItems.length; i++) {
          var sign = $checkItems.eq(i).data('sign');
          sign = parseInt(sign);
          option = option | Math.pow(2, sign);
        }
      } else if (this.type == 4) {
        var _$checkItems = this.$('.secrecy-option .check-item.checked');
        for (var _i = 0; _i < _$checkItems.length; _i++) {
          var _sign = _$checkItems.eq(_i).data('sign');
          _sign = parseInt(_sign);
          option = option | Math.pow(2, _sign);
        }
      }
      if (option & 16) {
        params.nextAccessType = this.nextAccessType || 0;
        var dueTime = this.$('.date-expire').datepicker("getDate");
        dueTime.setHours(23, 59, 59, 0);
        params.dueTime = dueTime.getTime() / 1000;
      } else {
        if (option & 32) {
          option = option ^ 32;
        }
      }
      params.otherOptions = option;
      console.log(params);
      // return
      MMEnterpriseController.updateForClassOrFolders(params, function (materialFolder) {
        _.each(_this6.fileInfors, function (file) {
          file.setAccessType(params.accessType);
        });
        _this6.navigationWindowView.close();
        _MDSnackbarView["default"].show(BabelStr.str(308));
      }, function (code, msg) {
        MDMessageView.error(msg, _this6.$body);
      });
    }
  }]);
  return MDBatchEditLibraryInfoView;
}(_MDNavigationPageView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1415":1415,"1426":1426,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1466":1466,"1475":1475,"273":273,"56":56,"639":639,"667":667,"67":67,"675":675,"72":72}],618:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1426);
require(1439);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDEnterpriseShareTabView = _interopRequireDefault(require(675));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDBatchEditClassifyWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDBatchEditClassifyWinView, _MDWindowView);
  function MDBatchEditClassifyWinView() {
    (0, _classCallCheck2["default"])(this, MDBatchEditClassifyWinView);
    return _callSuper(this, MDBatchEditClassifyWinView, arguments);
  }
  (0, _createClass2["default"])(MDBatchEditClassifyWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<div class=\"flex-align middle center pd-20 msg\">\n      <img src=\"/img/mdisk/back_classify.svg\" alt=\"\" class=\"classify\"/>\n    </div>\n    <div class=\"help-block f-tc name-tip mgb-20\"></div>\n\n    <div class=\"block-title boldfont mgb-10\"><%=BabelStr.str(12510)%></div>\n    <div class=\"select-type mgb-20\"></div>\n    <div class=\"dep-select-content f-none\">\n      <div class=\"block-title boldfont mgb-10\"><%=BabelStr.str(3449)%></div>\n      <div class=\"dep-select\"></div>\n    </div>\n\n\n    <div class=\"block-title boldfont mgb-10\"><%=BabelStr.str(12511)%></div>\n    <div class=\"manager-block mgb-20\"></div>\n\n    <div class=\"setting-option check-option mgb-20\">\n      <div class=\"eval-checkbox check-item flex-align middle checked\">\n        <div class=\"checkbox no-shrink\"></div>\n        <div class=\"name\"><%=BabelStr.str(27007)%></div>\n      </div>\n    </div>\n\n    <div class=\"bottom-block\">\n      <div class=\"warn-msg red f-tc\"><%=BabelStr.str(12575)%></div>\n    </div>\n\n    ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBatchEditClassifyWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        conditionArr: [{
          type: 0,
          name: BabelStr.str(3350)
        }, {
          type: 1,
          name: BabelStr.str(21217)
        }, {
          type: 2,
          name: BabelStr.str(12521)
        }, {
          type: 3,
          name: BabelStr.str(12522)
        }]
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBatchEditClassifyWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        // "click .save": this._saveHandle,
        "mousedown .check-item": this._checkItemClickHandler
      });
    }
  }, {
    key: "_checkItemClickHandler",
    value: function _checkItemClickHandler($e) {
      var $item = $($e.target).closest(".check-item");
      $item.toggleClass("checked");
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.title = BabelStr.str(12571);
      props.width = 410;
      props.buttons = [{
        type: "done",
        label: BabelStr.str(3080),
        autoClose: false,
        onClick: function onClick() {
          _this._saveHandle();
        }
      }];
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBatchEditClassifyWinView.prototype), "initialize", this).call(this, props);
      var names = _.map(this.fileInfors, function (file) {
        return file.getFileName();
      });
      var nameStr = '';
      if (names.length > 2) {
        nameStr = BabelStr.str(12573, {
          name1: names[0],
          name2: names[1],
          len: names.length
        });
      } else {
        nameStr = BabelStr.str(12573, {
          name1: names[0],
          name2: names[1],
          len: names.length
        });
      }
      this.$(".name-tip").html(nameStr);
      this.chooserView = new _MDEnterpriseShareTabView["default"]({
        ignoreIsShowingStructor: this.ignoreIsShowingStructor,
        canSelDepartment: false,
        placeholder: BabelStr.str(12580),
        inputFullWidth: true,
        notIncludeGuest: true,
        needGroupTreeTab: true,
        canSelGroup: false,
        needFrequentUserTab: true,
        needRoleTab: false,
        fromStr: BabelStr.str(2404),
        // isTabsOpened: true,
        isSelectOnlyInEp: true,
        onChange: function onChange(mails) {}
      });
      this.addSubView(this.chooserView, this.$(".manager-block")[0]);
      this.conditionSelectView = new _MDDropdownSelectListView["default"]({
        dataProvider: this.conditionArr,
        labelField: "name",
        silentInit: false,
        onChange: function onChange(obj) {
          _this.type = obj.type;
          _this.typeName = obj.name;
          if (obj.type == 1 || obj.type == 0) {
            _this.$('.dep-select-content').hide();
          } else {
            _this.$('.dep-select-content').show();
          }

          // this.conditionChanged();
        }
      });
      this.addSubView(this.conditionSelectView, this.$(".select-type")[0]);
      this.depSelect = new _MDEnterpriseShareTabView["default"]({
        inputName: "reading-room-create",
        canSelDepartment: true,
        notIncludeGuest: true,
        hideSelectWhenInput: true,
        needFrequentUserTab: false,
        needGroupTreeTab: false,
        canSelRole: false,
        canSelectDepUser: false,
        canSelGroup: false,
        inputFullWidth: true,
        isSelectOnlyInEp: true,
        placeholder: BabelStr.str(6702),
        fromStr: BabelStr.str(3455),
        emptySearchStr: BabelStr.str(3457)
        // initDepIds: ["201", "226", "1121"]
      });
      this.addSubView(this.depSelect, this.$('.dep-select')[0]);
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBatchEditClassifyWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " create-classify-win batch");
    }
  }, {
    key: "_saveHandle",
    value: function _saveHandle() {
      var _this2 = this;
      if (this.saving) {
        return;
      }
      var chooseData = this.chooserView.getTargetIds();
      var ids = _.map(this.fileInfors, function (file) {
        return file.getFileId();
      });
      var managerIds = chooseData.userIds.length ? chooseData.userIds : undefined;
      var needEval = this.$(".eval-checkbox").hasClass("checked");
      var params = {
        fileIds: ids,
        accessType: this.type,
        managerIds: managerIds,
        otherOptions: needEval ? 0 : Math.pow(2, 7)
        // departmentIds: chooseData.deps
      };
      if (this.type == 2 || this.type == 3) {
        var targetObj = this.depSelect.getTargetObj();
        params.departmentIds = targetObj.deps;
        if (!params.departmentIds.length) {
          MDMessageView.error(BabelStr.str(12558), this.$body);
          return;
        }
      }
      console.log(params);
      this.saving = true;
      MMEnterpriseController.updateForClassOrFolders(params, function () {
        _this2.saving = false;
        _.each(_this2.fileInfors, function (file) {
          file.setAccessType(params.accessType);
        });
        _MDSnackbarView["default"].show(BabelStr.str(308));
        _this2.close();
      }, function (code, msg) {
        _this2.saving = false;
        MDMessageView.error(msg, _this2.$body);
      });
    }
  }]);
  return MDBatchEditClassifyWinView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1426":1426,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"67":67,"675":675,"72":72,"93":93}],617:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1429);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 *
 *  Created by jichao
 *  2024.10.22
 */
var MDApplyLibraryWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDApplyLibraryWinView, _MDWindowView);
  function MDApplyLibraryWinView() {
    (0, _classCallCheck2["default"])(this, MDApplyLibraryWinView);
    return _callSuper(this, MDApplyLibraryWinView, arguments);
  }
  (0, _createClass2["default"])(MDApplyLibraryWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<form>\n      <div class=\"flex-align mgtb-20 msg\">\n        <div class=\"item-title no-shrink pdl-20 mgr-10\"><%=BabelStr.str(158)%></div>\n        <div><%=fileName%></div>\n      </div>\n      <div class=\"inv-manager-block gap-10 mgt-10 f-hide flex-align mgb-20\">\n        <div class=\"item-title no-shrink pdl-20\"><%=BabelStr.str(21215)%></div>\n        <div class=\"inv-manager-list gap-10 flex-align with-wrap\"></div>\n      </div>\n      <div class=\"flex-align msg\">\n        <div class=\"item-title no-shrink pdl-20 mgr-10\"><%=BabelStr.str(2721)%></div>\n        <div class=\"fullfill\">\n          <textarea name=\"comment\" required notempty id=\"\" class=\"comment notempty form-control\" cols=\"\" rows=\"\"></textarea>\n        </div>\n      </div>\n    </form>\n\n    <div class=\"flex-align end btns-block\">\n\n      <button class=\"done button cancel\"><%=BabelStr.str(156)%></button>\n      <button class=\"done button apply\"><%=BabelStr.str(12544)%></button>\n\n    </div>\n\n\n\n    ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDApplyLibraryWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " create-classify-win");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDApplyLibraryWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        fileId: "",
        fileInfor: undefined,
        parentFolder: undefined
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDApplyLibraryWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .cancel": this.cancel,
        "click .apply": this._applyHandle
      });
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        fileName: this.fileInfor.getFileName()
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDApplyLibraryWinView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.title = BabelStr.str(12543);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDApplyLibraryWinView.prototype), "initialize", this).call(this, props);
      _MMEnterpriseController["default"].getMaterialApprovers(this.fileId, function (approverInfos) {
        _this.renderInvManager(approverInfos);
      });
    }
  }, {
    key: "renderInvManager",
    value: function renderInvManager(managerInfos) {
      if (!managerInfos || !managerInfos.length) {
        return;
      }
      managerInfos = managerInfos.slice(0, 5);
      var tmpl = '';
      _.each(managerInfos, function (user) {
        tmpl += "\n        <div class=\"manager-item flex-align middle\">\n          <div class=\"manager-icon icon no-shrink\"></div>\n          <span class=\"name middle-ellipsis\">".concat(user.userName || user.phone, "</span>\n        </div>\n      ");
      });
      this.$(".inv-manager-list").html(tmpl);
      this.$(".inv-manager-block").removeClass("f-hide");
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.close();
    }
  }, {
    key: "_applyHandle",
    value: function _applyHandle() {
      var _this2 = this;
      if (this.saving) {
        return;
      }
      this.saving = true;
      var validator = this.$('form').validate();
      if (!validator.form()) {
        this.saving = false;
        return;
      }
      var comment = this.$('.comment').val();
      console.log(comment);
      _MMEnterpriseController["default"].applyAccess(this.fileId, comment, function () {
        _this2.saving = false;
        _MDSnackbarView["default"].show(BabelStr.str(308));
        _this2.close();
      }, function (code, msg) {
        _this2.saving = false;
        _MDMessageView["default"].error(msg, _this2.$body);
      });
    }
  }]);
  return MDApplyLibraryWinView;
}(_MDWindowView2["default"]);

},{"1098":1098,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1429":1429,"1454":1454,"1463":1463,"1475":1475,"55":55,"72":72,"93":93}],616:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1429);
require(1417);
require(1463);
require(1498);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDRoleSelectView = _interopRequireDefault(require(515));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 *
 *  Created by jichao
 *  2024.10.22
 */
var MDApplyJoinWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDApplyJoinWinView, _MDWindowView);
  function MDApplyJoinWinView() {
    (0, _classCallCheck2["default"])(this, MDApplyJoinWinView);
    return _callSuper(this, MDApplyJoinWinView, arguments);
  }
  (0, _createClass2["default"])(MDApplyJoinWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<div><%=nameStr%></div>\n    <div class=\"row inv-manager-block mgt-10 f-hide flex-align mgb-20\">\n      <div class=\"item-title no-shrink col-3\"><%=BabelStr.str(21215)%></div>\n      <div class=\"inv-manager-list gap-10 col-9 flex-align with-wrap\"></div>\n    </div>\n    <div class=\"row mgb-10 mgt-20\">\n      <div class=\"col-3\"><%=BabelStr.str(4722)%></div>\n      <div class=\"select-container col-4\"></div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-3\"><%=BabelStr.str(4723)%></div>\n      <div class=\"col-9\">\n        <textarea name=\"\" maxlength=\"100\" id=\"\" cols=\"30\" rows=\"10\" class=\"form-control textinput\"></textarea>\n      </div>\n    </div>\n\n    <div class=\"flex-align end btns-block\">\n\n      <button class=\"done button cancel\"><%=BabelStr.str(156)%></button>\n      <button class=\"done button apply\"><%=BabelStr.str(12544)%></button>\n\n    </div>\n    ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDApplyJoinWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " application-per-win");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDApplyJoinWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        fileInfor: undefined
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDApplyJoinWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .cancel": this.cancel,
        "click .apply": this._applyHandle
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.title = BabelStr.str(12585);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDApplyJoinWinView.prototype), "initialize", this).call(this, props);
      this.renderRoleSelect();
      _MMEnterpriseController["default"].getMaterialApprovers(this.fileInfor.getFileId(), function (approverInfos) {
        _this.renderInvManager(approverInfos);
      });
    }
  }, {
    key: "renderInvManager",
    value: function renderInvManager(managerInfos) {
      if (!managerInfos || !managerInfos.length) {
        return;
      }
      managerInfos = managerInfos.slice(0, 5);
      var tmpl = '';
      _.each(managerInfos, function (user) {
        tmpl += "\n        <div class=\"manager-item flex-align middle\">\n          <div class=\"manager-icon icon no-shrink\"></div>\n          <span class=\"name middle-ellipsis\">".concat(user.userName || user.phone, "</span>\n        </div>\n      ");
      });
      this.$(".inv-manager-list").html(tmpl);
      this.$(".inv-manager-block").removeClass("f-hide");
    }
  }, {
    key: "render",
    value: function render(data) {
      var nameStr = BabelStr.str(12586, {
        name: this.fileInfor.getFileName()
      });
      data = {
        nameStr: nameStr
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDApplyJoinWinView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "renderRoleSelect",
    value: function renderRoleSelect() {
      var _this2 = this;
      var epId = this.fileInfor.getEnterpriseId();
      MMNetDiskDataController.getAllRolesByEpId(epId, function (roleCollection, defaultRoleId) {
        var roles = roleCollection.models;
        _this2.roleSelectView = new _MDRoleSelectView["default"]({
          onRoleChanged: function onRoleChanged(role) {
            _this2.checkedRoleId = role.getRoleId();
            console.log(_this2.checkedRoleId);
          }
        });
        _this2.roleSelectView.setRoles(roles);
        var defaultRole = _.find(roles, function (role) {
          return role.get('id') == defaultRoleId;
        });
        defaultRole = defaultRole || roles[0];
        _this2.roleSelectView.selectRole(defaultRole);
        _this2.addSubView(_this2.roleSelectView, _this2.$('.select-container')[0]);
      });
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.close();
    }
  }, {
    key: "_applyHandle",
    value: function _applyHandle() {
      var _this3 = this;
      if (this.saving) {
        return;
      }
      this.saving = true;
      var msg = this.$('textarea').val().trim();
      _MMEnterpriseController["default"].applyJoinMember(this.fileInfor.getFileId(), this.checkedRoleId, msg, function () {
        _MDSnackbarView["default"].show(BabelStr.str(308));
        _this3.saving = false;
        _this3.close();
      }, function (code, msg) {
        _this3.saving = false;
        if (code == 801) {
          _MDSnackbarView["default"].show(BabelStr.str(3734));
        } else {
          _MDSnackbarView["default"].show(msg);
        }
      });
    }
  }]);
  return MDApplyJoinWinView;
}(_MDWindowView2["default"]);

},{"1098":1098,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1417":1417,"1429":1429,"1454":1454,"1463":1463,"1475":1475,"1498":1498,"515":515,"55":55,"72":72,"93":93}],615:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1429);
require(1439);
require(1426);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDFileInfoShowView = _interopRequireDefault(require(497));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 *
 *  Created by jichao
 *  2024.10.22
 */
var MDApplyDownloadView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDApplyDownloadView, _MDWindowView);
  function MDApplyDownloadView() {
    (0, _classCallCheck2["default"])(this, MDApplyDownloadView);
    return _callSuper(this, MDApplyDownloadView, arguments);
  }
  (0, _createClass2["default"])(MDApplyDownloadView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<div class=\"mgt-20\"><%=BabelStr.str(12549)%></div>\n    <div class=\"file-list\"></div>\n    <div class=\"row inv-manager-block mgt-10 f-hide flex-align mgb-20\">\n      <div class=\"item-title no-shrink col-3\"><%=BabelStr.str(21215)%></div>\n      <div class=\"inv-manager-list gap-10 col-9 flex-align with-wrap\"></div>\n    </div>\n    <div class=\"flex-align end btns-block\">\n\n      <button class=\"done button cancel\"><%=BabelStr.str(156)%></button>\n      <button class=\"done button apply\"><%=BabelStr.str(12544)%></button>\n\n    </div>\n    ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDApplyDownloadView.prototype), "className", this).call(this);
      return "".concat(superCls, " create-classify-win");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDApplyDownloadView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        fileInfors: []
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDApplyDownloadView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .cancel": this.cancel,
        "click .apply": this._applyHandle
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.title = BabelStr.str(764);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDApplyDownloadView.prototype), "initialize", this).call(this, props);
      _.each(this.fileInfors, function (file) {
        var fileInfoView = new _MDFileInfoShowView["default"]({
          fileInfo: file
        });
        _this.addSubView(fileInfoView, _this.$('.file-list')[0]);
      });
      _MMEnterpriseController["default"].getEditFileApprovers(this.fileInfors[0].getFileId(), function (approverInfos) {
        _this.renderEditManager(approverInfos);
      });
    }
  }, {
    key: "renderEditManager",
    value: function renderEditManager(managerInfos) {
      if (!managerInfos || !managerInfos.length) {
        return;
      }
      managerInfos = managerInfos.slice(0, 5);
      var tmpl = '';
      _.each(managerInfos, function (user) {
        tmpl += "\n        <div class=\"manager-item flex-align middle\">\n          <div class=\"manager-icon icon no-shrink\"></div>\n          <span class=\"name middle-ellipsis\">".concat(user.name || user.phone, "</span>\n        </div>\n      ");
      });
      this.$(".inv-manager-list").html(tmpl);
      this.$(".inv-manager-block").removeClass("f-hide");
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.close();
    }
  }, {
    key: "_applyHandle",
    value: function _applyHandle() {
      var _this2 = this;
      if (this.saving) {
        return;
      }
      this.saving = true;
      var fileIds = _.map(this.fileInfors, function (file) {
        return file.getFileId();
      });
      _MMEnterpriseController["default"].applyDownloadFile(fileIds, function () {
        _MDSnackbarView["default"].show(BabelStr.str(308));
        _this2.close();
        _this2.saving = false;
      }, function (code, msg) {
        _this2.saving = false;
        _MDMessageView["default"].error(msg, _this2.$body);
      });
    }
  }]);
  return MDApplyDownloadView;
}(_MDWindowView2["default"]);

},{"1098":1098,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1426":1426,"1429":1429,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"497":497,"55":55,"72":72,"93":93}],590:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1416);
require(1412);
require(1463);
require(1471);
require(1430);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDAlertView = _interopRequireDefault(require(32));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 *  window to  edit department  /*enterprise
 *  Created by jichao
 *  2017.11.10
 */
var MDManageSecurityWindowView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDManageSecurityWindowView, _MDWindowView);
  function MDManageSecurityWindowView() {
    (0, _classCallCheck2["default"])(this, MDManageSecurityWindowView);
    return _callSuper(this, MDManageSecurityWindowView, arguments);
  }
  (0, _createClass2["default"])(MDManageSecurityWindowView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n      <div class=\"contain\" >\n      </div>\n      <div class=\"about-secrity done mgt-10 text-button\"><%=BabelStr.str(2556)%></div>";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDManageSecurityWindowView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        checkedIndex: 0
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDManageSecurityWindowView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .radio-box': this._radioBoxClickHandle,
        'click .about-secrity': this._showAboutSecrity
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDManageSecurityWindowView.prototype), "className", this).call(this);
      return "".concat(superCls, " add-role-ep-win");
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      opt.size = 'normal';
      opt.title = BabelStr.str(3337);
      opt.buttons = [{
        type: 'done',
        label: BabelStr.str(154),
        autoClose: false,
        onClick: function onClick() {
          self.submit();
        }
      }, {
        type: 'cancel',
        label: BabelStr.str(155),
        autoClose: true
      }];
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDManageSecurityWindowView.prototype), "initialize", this).call(this, opt);
      this.rebderSecretLevelList();
      var self = this;
    }
  }, {
    key: "_showAboutSecrity",
    value: function _showAboutSecrity() {
      _MDAlertView["default"].showAboutSecurity();
    }
  }, {
    key: "rebderSecretLevelList",
    value: function rebderSecretLevelList() {
      var _this = this;
      var file = this.fileInfors.length == 1 ? this.fileInfors[0] : app.currentFolder;
      file.getSecretLevelsForFile(function (list) {
        var secretLevelId = file.getSecretLevelId();
        var index = _.findIndex(list, {
          id: secretLevelId
        });
        var tmpl = "";
        for (var i = 0; i < list.length; i++) {
          var checked = '';
          if (index == i) {
            checked = 'checked';
            _this.checkedIndex = list[i].id;
          }
          tmpl += "<div index=".concat(list[i].id, " class=\"radio-box ").concat(checked, "\">").concat(list[i].comment, "</div>");
        }
        _this.$('.contain').html(tmpl);
      });
    }
  }, {
    key: "_radioBoxClickHandle",
    value: function _radioBoxClickHandle($e) {
      var $target = $($e.target).closest(".radio-box");
      var index = $target.attr("index");
      if ($target.hasClass("checked")) {
        return;
      } else {
        this.$(".radio-box").removeClass("checked");
        $target.addClass("checked");
        this.checkedIndex = index - 0;
      }
    }
  }, {
    key: "submit",
    value: function submit() {
      var _this2 = this;
      var promise = new Promise(function (resolve, rejected) {
        var hasFolder = _.some(_this2.fileInfors, function (fileInfor) {
          return fileInfor.isFolder();
        });
        if (!hasFolder) {
          resolve();
        } else {
          var alertView = new _MDAlertView["default"]();
          alertView.show({
            message: "<p>".concat(BabelStr.str(5406), "</p> <p class=\"f-tc red\">(").concat(BabelStr.str(5409), ")</p>"),
            className: 'm-delAlertWin',
            buttons: [{
              label: BabelStr.str(5408),
              onClick: function onClick() {
                resolve();
              }
            }, {
              label: BabelStr.str(5407),
              // '确定',
              type: 'danger',
              onClick: function onClick() {
                resolve(true);
              }
            }]
          });
        }
      });
      promise.then(function (coverAll) {
        var index = 0;
        var _loop = function _loop(i) {
          MMEnterpriseController.setFileSecret(_this2.fileInfors[i].getFileId(), _this2.checkedIndex, function () {
            _this2.fileInfors[i].setSecretLevelId(_this2.checkedIndex);
            index++;
            if (index == _this2.fileInfors.length) {
              MMNetDiskDataController.getFileInfoFromServer(_this2.fileInfors[0].getFileId(), function (file) {
                for (var j = 0; j < _this2.fileInfors.length; j++) {
                  _this2.fileInfors[j].setSecretLevelId(file.getSecretLevelId());
                }
              });
            }
          }, function () {
            // MDSnackbarView.show(BabelStr.str(3622))
            index++;
            if (index == _this2.fileInfors.length) {
              MMNetDiskDataController.getFileInfoFromServer(_this2.fileInfors[0].getFileId(), function (file) {
                for (var j = 0; j < _this2.fileInfors.length; j++) {
                  _this2.fileInfors[j].setSecretLevelId(file.getSecretLevelId());
                }
              });
            }
          }, {
            coverAll: coverAll
          });
        };
        for (var i = 0; i < _this2.fileInfors.length; i++) {
          _loop(i);
        }
      });
      this.close();
    }
  }]);
  return MDManageSecurityWindowView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1416":1416,"1430":1430,"1454":1454,"1463":1463,"1471":1471,"1475":1475,"32":32,"93":93}],558:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1498);
var _app = _interopRequireDefault(require(17));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDWindowView = _interopRequireDefault(require(93));
var _MDEvents = _interopRequireDefault(require(325));
var _MDFileOperationManager = _interopRequireDefault(require(326));
var MDcreateEncryptedFolderWindowView = _MDWindowView["default"].extend({
  contentTmpl: "\n    <div class=\"flex-align thumb middle center\">\n\n    </div>\n    <div class=\"help-block\"><%=BabelStr.str(27019)%></div>\n    <div class=\"mgt-20 boldfont mgb-10\"><%=BabelStr.str(27020)%></div>\n    <form>\n      <input type=\"\" class=\"form-control mglr-10 notempty encryped-name testFileName\" name=\"encryped-name\" required placeholder=\"<%=BabelStr.str(27021)%>\"/>\n      <div class=\"red mgt-20 f-tc\"><%=BabelStr.str(27022)%></div>\n      <div class=\"red mgb-10 f-tc\"><%=BabelStr.str(27023)%></div>\n      <div class=\"form-item row\">\n        <input id=\"js-encryped-pwd\" name=\"encryped-pwd\" class=\"form-control encryped-pwd\" type=\"password\" autocomplete=\"off\" placeholder=\"<%=BabelStr.str(27024)%>\"/>\n        <span class=\"pwd-menu icon icon30 opend\"></span>\n      </div>\n      <div class=\"form-item row\">\n        <input id=\"js-encryped-pwd2\" name=\"encryped-pwd2\" class=\"form-control encryped-pwd\" type=\"password\" maxlength=\"20\" autocomplete=\"off\" placeholder=\"<%=BabelStr.str(27025)%>\"/>\n        <span class=\"pwd-menu icon icon30 opend\"></span>\n      </div>\n      <div class=\"pwd-help f-tc help-text\"><%=BabelStr.str(27026)%></div>\n      <div class=\"down-msg red f-tc\"><%=BabelStr.str(27027)%></div>\n    </form>\n\n  ",
  className: function className() {
    var superCls = _MDWindowView["default"].prototype.className.call(this);
    return superCls + " m-encrypted-createFolderWin";
  },
  events: function events() {
    var superE = _MDWindowView["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click .pwd-menu': this._togglePwd
    });
  },
  initProps: function initProps() {
    var props = _MDWindowView["default"].prototype.initProps.call(this);
    return _.extend(props, {
      parentFolder: _app["default"].pathRouter.getCurrentFolder()
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    opt.title = BabelStr.str(27018);
    opt.buttons = [{
      label: BabelStr.str(155),
      // '取消',
      type: 'default'
    }, {
      label: BabelStr.str(154),
      //  '确认',
      type: 'done',
      autoClose: false,
      onClick: function onClick($e) {
        self._submit();
      }
    }];
    _MDWindowView["default"].prototype.initialize.call(this, opt);
    var $buttons = this.getActionButtons();
    this.$doneBtn = $buttons.eq(1);
  },
  _togglePwd: function _togglePwd($e) {
    if ($($e.target).closest('.pwd-menu').hasClass("opend")) {
      $($e.target).siblings('input').attr("type", 'text');
      $($e.target).closest('.pwd-menu').removeClass("opend").addClass('closed');
    } else {
      $($e.target).siblings('input').attr("type", 'password');
      $($e.target).closest('.pwd-menu').addClass("opend").removeClass('closed');
    }
  },
  _submit: function _submit() {
    var self = this;
    var newName = $.trim(self.$("#nameInput").val());
    var validator = this.$('form').validate();
    if (validator.form()) {
      self._postCreateFolder(newName);
      // self.close();
    }
  },
  _postCreateFolder: function _postCreateFolder(text) {
    var self = this;
    if (this.creating) {
      return;
    }
    this.creating = true;
    this.$doneBtn.prop('disabled', true);
    var pwd = this.$("#js-encryped-pwd").val().trim();
    var name = this.$(".encryped-name").val().trim();
    var params = {
      "dirName": name,
      "destDir": _app["default"].currentFolder.getFileId(),
      "permission": 0,
      "dontNotify": false,
      "forceRename": 0,
      "device": "web",
      "isEncrypted": true,
      "encrypted_password": MMCommonFun.encrptDesCbc2(pwd)
    };
    MMEnterpriseController.createDir(params, function (fileInfo) {
      var fileInforCollection = _MDFileOperationManager["default"].getDispFileInfoCollection();

      // if (app.pathRouter.isInFileChannel &&　app.pathRouter.isInFileChannel() || app.pathRouter.isInArchiveChannel && app.pathRouter.isInArchiveChannel()) {
      fileInforCollection.addFileBlowStickonTop(fileInfo);
      _Dispatcher["default"].trigger(_MDEvents["default"].FolderCreated, fileInfo);
      self.close();
      _MDSnackbarView["default"].show(BabelStr.str(308));
    }, function (code, msg) {
      self.creating = false;
      self.$doneBtn.prop('disabled', false);
      MDMessageView.error(msg, self.$body);
    });
  },
  viewDidRendered: function viewDidRendered() {
    _MDWindowView["default"].prototype.viewDidRendered.call(this);
    this.$('form').validate({
      rules: {
        'encryped-pwd': {
          'required': true,
          'lowpassword': true,
          'password': false
        },
        'encryped-pwd2': {
          'required': true,
          'lowpassword': true,
          'password': false,
          'equalTo': "#js-encryped-pwd"
        }
      },
      messages: {
        'encryped-pwd': {
          'required': BabelStr.str(2351),
          //'请输入新密码',
          'lowpassword': BabelStr.str(27028) // '密码格式错误，密码为6到20位字母，数字组成'
        },
        'encryped-pwd2': {
          'required': BabelStr.str(2352),
          //'请输入确认密码',
          'lowpassword': BabelStr.str(27028),
          // ''密码格式错误，密码为6到20位字母，数字组成',
          'equalTo': BabelStr.str(2353) // ''两次输入的密码不一致'
        }
      }
    });

    // var self = this;
    // setBabelTimeout(function() {
    //   self.$("#nameInput").focus();
    // }, 100);
  },
  _submitOnEnter: function _submitOnEnter($e) {
    var disabled = this.$doneBtn.prop('disabled');
    if (disabled) {
      return;
    }
    if (keycode.isEnterKey($e.keyCode)) {
      this._submit();
      return false;
    }
  }
});
var _default = exports["default"] = MDcreateEncryptedFolderWindowView;

},{"1184":1184,"1454":1454,"1498":1498,"17":17,"18":18,"325":325,"326":326,"72":72,"93":93}],554:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1477);
require(1492);
require(1449);
require(1446);
require(1437);
require(1435);
require(1412);
require(1416);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MDSpinnerloaderLayerView = _interopRequireDefault(require(75));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _menusvg = _interopRequireDefault(require(1119));
var _MDSwitchView = _interopRequireDefault(require(79));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDDownloadLinkWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDDownloadLinkWinView, _MDWindowView);
  function MDDownloadLinkWinView() {
    (0, _classCallCheck2["default"])(this, MDDownloadLinkWinView);
    return _callSuper(this, MDDownloadLinkWinView, arguments);
  }
  (0, _createClass2["default"])(MDDownloadLinkWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n      <div class=\"warn-block flex-align gap-10\">\n        <span class=\"warn-svg\">\n        <%=menu_download_link%>\n        </span>\n        <span><%=BabelStr.str(40120)%></span>\n      </div>\n      <div class=\"flex-align between middle mgb-10 mgt-15\">\n        <div class=\"boldfont\"><%=BabelStr.str(40121)%></div>\n        <div class=\"link-switch\"></div>\n      </div>\n      <div class=\"link-content-block mgb-20 f-hide\">\n        <div class=\"flex-align middle gap-10\">\n          <div class=\"url-block fullfill\">\n            <div class=\"url\"></div>\n          </div>\n          <div class=\"button done copyBtn\"><%=BabelStr.str(80)%></div>\n          <div class=\"m-qrcode\">\n            <button class=\"qrcode-btn icon\" title=\"<%=BabelStr.str(415)%>\">\n              <div class=\"qrcode-pop f-tc\" title=\"<%=BabelStr.str(416)%>\">\n              <div class=\"qrcode-canvas\"></div>\n              <div class=\"intro\">\n                <p><%=BabelStr.str(5417)%></p>\n                <p class=\"text-button copy-qrcode\"><%=BabelStr.str(5416)%></p>\n              </div>\n              </div>\n            </button>\n          </div>\n        </div>\n\n        <div class=\"boldfont mgb-10 mgt-15\"><%=BabelStr.str(40122)%></div>\n        <div class=\"flex-align middle gap-10\">\n          <span class=\"left-title\"><%=BabelStr.str(40123)%></span>\n          <span class = \"datepicker\">\n            <input type=\"text\" class=\"date-expire\"  placeholder=\"<%=endTime%>\">\n            <i class = \"icon ep-expire-date\"></i>\n          </span>\n        </div>\n        <div class=\"flex-align middle gap-10 mgt-10 \">\n          <span class=\"left-title\"><%=BabelStr.str(40124)%></span>\n          <div class=\"max-num-block\"></div>\n          <div class=\"donw-num-msg f-hide\"></div>\n        </div>\n        <div class=\"mgt-10 empty-block red f-hide\"><%=BabelStr.str(40138)%></div>\n      </div>\n\n\n    ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDownloadLinkWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " down-link-win");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDownloadLinkWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        // showFooter: false,
        maxNumArr: [{
          name: BabelStr.str(40128),
          value: 0
        }, {
          name: BabelStr.str(40129),
          value: 10
        }, {
          name: BabelStr.str(40130),
          value: 50
        }, {
          name: BabelStr.str(40131),
          value: 100
        }, {
          name: BabelStr.str(40133),
          placeholder: BabelStr.str(40132),
          value: "",
          contenteditable: true,
          onChecked: function onChecked(item, callback) {
            item.value = item.value.replace(/[^\d.]/g, '') // ✅ 保留数字和小数点
            .replace(/(\..*)\./g, '$1') // ✅ 多余小数点只留第一个
            .replace(/^\./, ''); // ✅ 开头的小数点去掉
            callback(item);
          }
        }]
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDownloadLinkWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "mouseenter .qrcode-btn": this._showQRCodePopup,
        "mouseleave .qrcode-btn": this._hideQRCodePopup,
        "click .qrcode-canvas canvas": this._copyQrcode,
        "click .copy-qrcode": this._copyQrcode,
        "click .copyBtn": this._copy,
        "click .ep-expire-date": this.showExpire
      });
    }
  }, {
    key: "render",
    value: function render(data) {
      data.menu_download_link = _menusvg["default"].menu_download_link;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDownloadLinkWinView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.title = BabelStr.str(40119, {
        name: props.fileInfor.getFileName()
      });
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDownloadLinkWinView.prototype), "initialize", this).call(this, props);
      this.maxNumView = new _MDDropdownSelectListView["default"]({
        dataProvider: this.maxNumArr,
        labelField: "name",
        silentInit: true,
        isFixed: true,
        selectedIndex: 0,
        onChange: function onChange(obj) {
          if (!obj.value) {
            return;
          }
          var param = {
            maxDownload: obj.value,
            fileId: _this.fileInfor.getFileId()
          };
          _this.updateAnonymouseDownloadUrl(param);
        }
      });
      this.addSubView(this.maxNumView, this.$(".max-num-block"));
      this.linkSwitch = new _MDSwitchView["default"]({
        onChange: function onChange(state) {
          _this.onLinkStateChanged(state);
        }
      });
      this.addSubView(this.linkSwitch, this.$(".link-switch"));
      var $expireTimeBox = this.$(".date-expire");
      $expireTimeBox.datepicker({
        minDate: 1
      }).on("change", function () {
        var exDate = $expireTimeBox.datepicker("getDate");
        var param = {
          endTime: Number.parseInt(exDate.getTime() / 1000),
          fileId: _this.fileInfor.getFileId()
        };
        _this.updateAnonymouseDownloadUrl(param);
      });
      this.getInitLinkData();
    }
  }, {
    key: "showExpire",
    value: function showExpire() {
      this.$(".date-expire").focus();
    }
  }, {
    key: "onLinkStateChanged",
    value: function onLinkStateChanged(open) {
      var _this2 = this;
      var param = {
        fileId: this.fileInfor.getFileId()
      };
      if (open) {
        this.getInitLinkData(false, {
          createIfNotExist: 1,
          endTime: Number.parseInt(new Date(Date.now() + 6 * 86400000 - 1).getTime() / 1000),
          maxDownload: 0
        });
      } else {
        _MMEnterpriseController["default"].deleteAnonymousDownloadUrl(param, function () {
          _MDMessageView["default"].success(BabelStr.str(308), _this2.$body);
          _this2.$(".link-content-block").addClass("f-hide");
        }, function () {
          _MDMessageView["default"].error(BabelStr.str(309), _this2.$body);
          if (open) {
            _this2.linkSwitch.close(true);
          } else {
            _this2.linkSwitch.open(true);
          }
        });
      }
    }
  }, {
    key: "getInitLinkData",
    value: function getInitLinkData(onlyRefreshLink, param) {
      var _this3 = this;
      param = param || {};
      param.fileId = this.fileInfor.getFileId();
      if (!onlyRefreshLink) {
        _MDSpinnerloaderLayerView["default"].showIn(this.$body);
      }
      this.getAnonymouseDownloadUrl(param, function (res) {
        if (res.url) {
          _this3.linkSwitch.open(true);
          _this3.$(".link-content-block").removeClass("f-hide");
          _this3.downloadLink = res.url;
          _this3.$(".qrcode-canvas").empty().qrcode({
            width: 160,
            height: 160,
            text: _this3.downloadLink
          });
          _this3.$(".url").html(_this3.downloadLink);
          if (res.downloadCount) {
            var downloadMsg;
            if (res.maxDownload) {
              downloadMsg = "".concat(BabelStr.str(40137), " ").concat(res.downloadCount, "/").concat(res.maxDownload);
            } else {
              downloadMsg = "".concat(BabelStr.str(40137), " ").concat(res.downloadCount);
            }
            _this3.$(".donw-num-msg").html(downloadMsg).removeClass("f-hide");
            if (res.downloadCount == res.maxDownload) {
              _this3.$(".empty-block").removeClass("f-hide");
            }
          } else {
            _this3.$(".empty-block").addClass("f-hide");
          }
          if (onlyRefreshLink) {
            return;
          }
          if (res.endTime) {
            var time = res.endTime.time;
            time = new Date(time);
            var $expireTimeBox = _this3.$(".datepicker");
            $expireTimeBox.datepicker("setDate", time);
            _this3.$(".datepicker input").val(time.format("yyyy-MM-dd"));
          }
          var maxDownload = res.maxDownload;
          var index = _.findIndex(_this3.maxNumArr, {
            value: maxDownload
          });
          if (index < 0) {
            index = 4;
            _this3.maxNumArr[4].value = maxDownload;
            _this3.maxNumView.setDataProvider(_this3.maxNumArr);
            _this3.maxNumView.selectItemAt(index, true);
          } else {
            _this3.maxNumView.selectItemAt(index, true);
          }
        } else {}
      });
    }
  }, {
    key: "updateAnonymouseDownloadUrl",
    value: function updateAnonymouseDownloadUrl(param) {
      var _this4 = this;
      if (_.isEqual(this.lastParam, param)) {
        return;
      }
      _MMEnterpriseController["default"].updateAnonymouseDownloadUrl(param, function () {
        _this4.lastParam = param;
        _MDMessageView["default"].success(BabelStr.str(308), _this4.$body);
        _this4.getInitLinkData(true);
      }, function () {
        _MDMessageView["default"].error(BabelStr.str(309), _this4.$body);
      });
    }
  }, {
    key: "_copyQrcode",
    value: function _copyQrcode(e) {
      var self = this;
      var target = this.$(".qrcode-canvas canvas")[0];
      MMCommonFun.clipboardCopyCanvas(target, function () {
        console.log("success");
        _MDMessageView["default"].success(BabelStr.str(5415), self.body);
      }, function () {
        _MDMessageView["default"].error(BabelStr.str(5418), self.body);
        console.log("fail");
      });
    }
  }, {
    key: "getAnonymouseDownloadUrl",
    value: function getAnonymouseDownloadUrl(param, callback) {
      var _this5 = this;
      _MMEnterpriseController["default"].getAnonymouseDownloadUrl(param, function (res) {
        callback(res);
        _MDSpinnerloaderLayerView["default"].clearFrom(_this5.$body);
      }, function (err) {
        _MDSpinnerloaderLayerView["default"].clearFrom(_this5.$body);
        var msg = err.msg;
        if (err.code == 207 || err.code == 12) {
          msg = BabelStr.str(40135);
        }
        _MDAlertView["default"].showStandardPrompt({
          message: msg
        });
        _this5.close();
      });
    }
  }, {
    key: "_showQRCodePopup",
    value: function _showQRCodePopup($e) {
      var self = this;
      var $qpopup = this.$(".qrcode-pop");
      if ($qpopup.hasClass("opened")) {
        return;
      }
      $qpopup.show();
      $qpopup[0].offsetWidth;
      $qpopup.addClass("opened");
      return false;
    }
  }, {
    key: "_copy",
    value: function _copy(e) {
      var content = this.$(".url");
      // 创建一个临时的 textarea 元素
      var tempTextArea = document.createElement("textarea");
      tempTextArea.value = content.text();

      // 将 textarea 添加到文档中（不可见）
      document.body.appendChild(tempTextArea);

      // 选中并复制文本
      tempTextArea.select();
      document.execCommand("copy");

      // 移除临时的 textarea 元素
      document.body.removeChild(tempTextArea);
      _MDMessageView["default"].success(BabelStr.str(40134), this.$el);
    }
  }, {
    key: "_hideQRCodePopup",
    value: function _hideQRCodePopup($e) {
      var self = this;
      var $qpopup = self.$(".qrcode-pop");
      var $mqpopup = self.$(".qrcode-btn");
      var popDOM = $mqpopup.get(0);
      if ($qpopup.css("display") == "none") {
        return;
      }
      $qpopup.transitionEndOnce(function () {
        !$qpopup.hasClass("opened") && $qpopup.hide();
      });
      $qpopup.removeClass("opened");
    }
  }]);
  return MDDownloadLinkWinView;
}(_MDWindowView2["default"]);

},{"1098":1098,"1119":1119,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1416":1416,"1435":1435,"1437":1437,"1446":1446,"1449":1449,"1454":1454,"1463":1463,"1475":1475,"1477":1477,"1492":1492,"32":32,"55":55,"67":67,"75":75,"79":79,"93":93}],539:[function(require,module,exports){
"use strict";

require(1475);
require(1419);
require(1487);
require(1503);
require(1500);
require(1502);
require(1423);
require(1538);
require(1422);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1417);
require(1463);
require(1498);
require(1541);
require(1420);
require(1439);
require(1477);
require(1492);
require(1466);
require(1424);
require(1490);
require(1437);
require(1478);
require(1476);
require(1429);
require(1432);
require(1471);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MMFileInfoCollection = _interopRequireDefault(require(298));
var _MDMessageView = _interopRequireDefault(require(55));
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDBatchRenameWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDBatchRenameWinView, _MDWindowView);
  function MDBatchRenameWinView() {
    (0, _classCallCheck2["default"])(this, MDBatchRenameWinView);
    return _callSuper(this, MDBatchRenameWinView, arguments);
  }
  (0, _createClass2["default"])(MDBatchRenameWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<div class=\"flex-align between\">\n      <div class=\"left-block\">\n\n      <div><%=BabelStr.str(21952)%></div>\n      <div class=\"rename-type mgt-10\"></div>\n\n      <div class=\"rename-type-custom-content rename-type-content\">\n        <div><%=BabelStr.str(21958)%></div>\n        <input type=\"\" class=\"form-control new-file-name\" placeholder=\"<%=BabelStr.str(21965)%>\"/>\n      </div>\n\n      <div class=\"rename-type-insert-content rename-type-content f-hide\">\n        <div><%=BabelStr.str(21990)%></div>\n        <div class=\"radio-group\">\n          <div class=\"setting-item mgr-10 radio-box checked\"><%=BabelStr.str(21991)%></div>\n          <div class=\"setting-item mgr-10 radio-box\"><%=BabelStr.str(21992)%></div>\n          <div class=\"setting-item mgr-10 radio-box mgt-10\"><%=BabelStr.str(22004)%></div>\n        </div>\n        <div class=\"for-content\">\n          <div><%=BabelStr.str(21993)%></div>\n          <input type=\"\" class=\"form-control new-insert-name mgt-10\" placeholder=\"<%=BabelStr.str(21991)%>\"/>\n        </div>\n        <div class=\"for-attr f-hide\">\n          <div class=\"mgt-10\"><%=BabelStr.str(22008)%></div>\n          <div class=\"attr-select mgt-10\"></div>\n        </div>\n        <div class=\"for-num f-hide\">\n          <div><%=BabelStr.str(21966)%></div>\n          <div class=\"flex-align with-wrap middle mgt-10\">\n            <span class=\"no-shrink\"><%=BabelStr.str(21967)%></span>\n            <input type=\"\" class=\"form-control mglr-10 num-input start-num\" value=1 />\n            <span class=\"no-shrink help-text\"><%=BabelStr.str(21968)%></span>\n          </div>\n          <div class=\"flex-align with-wrap middle mgt-10 \">\n            <span class=\"no-shrink\"><%=BabelStr.str(21969)%>:</span>\n            <input type=\"\" class=\"form-control mglr-10 num-input add-num\" value=1 />\n            <span class=\"no-shrink help-text\"><%=BabelStr.str(21970)%></span>\n          </div>\n          <div class=\"flex-align with-wrap middle mgt-10 \">\n            <span class=\"no-shrink\"><%=BabelStr.str(21971)%>:</span>\n            <input type=\"\" class=\"form-control mglr-10 num-input num-length\" value=3 />\n            <span class=\"no-shrink help-text\"><%=BabelStr.str(21972)%></span>\n          </div>\n        </div>\n        <div class=\"mgt-10\"><%=BabelStr.str(21989)%></div>\n        <div class=\"flex-align mgt-10 num-pos-block\">\n          <div class=\"num-pos\"></div>\n          <div class=\"num-input-block\">\n            <input type=\"\" class=\"num-input num-pos-input form-control\" value=1 />\n            <div class=\"add-num\"></div>\n            <div class=\"minus-num\"></div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"rename-type-del-content rename-type-content f-hide\">\n        <div><%=BabelStr.str(22000)%>\uFF1A</div>\n        <div class=\"del-type\"></div>\n\n        <div class=\"for-name-pos f-hide\">\n          <div><%=BabelStr.str(22001)%>\uFF1A</div>\n          <div class=\"num-input-block mgt-10\">\n            <input type=\"\" class=\"num-input pos-start-input form-control\" value=1 />\n            <div class=\"add-num\"></div>\n            <div class=\"minus-num\"></div>\n          </div>\n          <div class=\"mgt-10\"><%=BabelStr.str(22002)%>\uFF1A</div>\n          <div class=\"num-input-block mgt-10\">\n            <input type=\"\" class=\"num-input pos-length-input form-control\" value=2 />\n            <div class=\"add-num\"></div>\n            <div class=\"minus-num\"></div>\n          </div>\n        </div>\n        <div class=\"for-custom\">\n          <div><%=BabelStr.str(22003)%>\uFF1A</div>\n          <input type=\"\" class=\"form-control custom-text mgt-10 text-input\" placeholder=\"<%=BabelStr.str(21995)%>\"/>\n        </div>\n\n      </div>\n\n      <div class=\"rename-type-replace-content rename-type-content f-hide\">\n        <div><%=BabelStr.str(21994)%>\uFF1A</div>\n        <input type=\"\" class=\"form-control old-replace-text mgt-10 text-input\" placeholder=\"<%=BabelStr.str(21994)%>\"/>\n        <div><%=BabelStr.str(21995)%>\uFF1A</div>\n        <input type=\"\" class=\"form-control new-replace-text mgt-10 text-input\" placeholder=\"<%=BabelStr.str(21995)%>\"/>\n      </div>\n\n      <div class=\"rename-type-time-content rename-type-content f-hide\">\n        <div><%=BabelStr.str(21977)%></div>\n        <div class=\"time-source\"></div>\n        <div><%=BabelStr.str(21981)%></div>\n        <div class=\"time-format\"></div>\n        <div><%=BabelStr.str(21983)%></div>\n        <div class=\"time-pos\"></div>\n        <div class=\"for-del-name-add-num f-hide\">\n          <div class=\"flex-align with-wrap middle mgt-10\">\n            <span class=\"no-shrink\"><%=BabelStr.str(21967)%></span>\n            <input type=\"\" class=\"form-control mglr-10 num-input start-num\" value=1 />\n            <span class=\"no-shrink help-text\"><%=BabelStr.str(21968)%></span>\n          </div>\n          <div class=\"flex-align with-wrap middle mgt-10 \">\n            <span class=\"no-shrink\"><%=BabelStr.str(21969)%>:</span>\n            <input type=\"\" class=\"form-control mglr-10 num-input add-num\" value=1 />\n            <span class=\"no-shrink help-text\"><%=BabelStr.str(21970)%></span>\n          </div>\n          <div class=\"flex-align with-wrap middle mgt-10 \">\n            <span class=\"no-shrink\"><%=BabelStr.str(21971)%>:</span>\n            <input type=\"\" class=\"form-control mglr-10 num-input num-length\" value=3 />\n            <span class=\"no-shrink help-text\"><%=BabelStr.str(21972)%></span>\n          </div>\n          <div class=\"mgt-10\"><%=BabelStr.str(21989)%></div>\n          <div class=\"flex-align mgt-10 num-pos-block\">\n            <div class=\"num-pos\"></div>\n            <div class=\"num-input-block\">\n              <input type=\"\" class=\"num-input num-pos-input form-control\" value=1 />\n              <div class=\"add-num\"></div>\n              <div class=\"minus-num\"></div>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"mgt-10\"><%=BabelStr.str(21959)%></div>\n      <div class=\"letter-case mgt-10 \"></div>\n      <div class=\"rename-type-custom-content rename-type-content\">\n        <div><%=BabelStr.str(21966)%></div>\n        <div class=\"flex-align with-wrap middle\">\n          <span class=\"no-shrink\"><%=BabelStr.str(21967)%></span>\n          <input type=\"\" class=\"form-control mglr-10 num-input start-num\" value=1 />\n          <span class=\"no-shrink help-text\"><%=BabelStr.str(21968)%></span>\n        </div>\n        <div class=\"flex-align with-wrap middle middle\">\n          <span class=\"no-shrink\"><%=BabelStr.str(21969)%>:</span>\n          <input type=\"\" class=\"form-control mglr-10 num-input add-num\" value=1 />\n          <span class=\"no-shrink help-text\"><%=BabelStr.str(21970)%></span>\n        </div>\n        <div class=\"flex-align with-wrap middle middle\">\n          <span class=\"no-shrink\"><%=BabelStr.str(21971)%>:</span>\n          <input type=\"\" class=\"form-control mglr-10 num-input num-length\" value=3 />\n          <span class=\"no-shrink help-text\"><%=BabelStr.str(21972)%></span>\n        </div>\n      </div>\n      </div>\n      <div class=\"main-block\">\n        <div class=\"header-content flex-align between\">\n          <div class=\"flex-align middle\">\n            <div><%=BabelStr.str(21951)%>\uFF1A </div>\n            <div class=\"file-num\"></div>\n          </div>\n          <button class=\"button done start-rename disabled\"><%=BabelStr.str(21973)%></button>\n        </div>\n        <div class=\"main-content mgt-15\">\n          <div class=\"table-header\">\n            <div class=\"t-row\">\n              <div class=\"origin-item\"><%=BabelStr.str(21974)%></div>\n              <div class=\"cur-item\"><%=BabelStr.str(21975)%></div>\n              <div class=\"status-item\"><%=BabelStr.str(21976)%></div>\n            </div>\n          </div>\n          <div class=\"table-body\"></div>\n        </div>\n      </div>\n    </div>\n    ";
    }
  }, {
    key: "fileTmpl",
    value: function fileTmpl(file) {
      var cls = "file";
      if (file.isFolder()) {
        cls = "folder";
      }
      return "<div class=\"t-row\" data-id=\"".concat(file.getFileId(), "\">\n      <div class=\"origin-item\">\n        <div class=\"thumbWrapper icon ic-file-26 ").concat(cls, "\"></div>\n        <div class=\"name origin-name\">").concat(file.getFileName(), "</div>\n      </div>\n      <div class=\"cur-item\">\n        <div class=\"thumbWrapper icon ic-file-26 ").concat(cls, "\"></div>\n        <div class=\"name new-name\">").concat(file.get("renamingName") || file.getFileName(), "</div>\n      </div>\n      <div class=\"status-item\">\n        <span class=\"no-start\">").concat(BabelStr.str(22009), "</span>\n        <span class=\"success icon f-hide\"></span>\n        <span class=\"error f-hide icon\"></span>\n      </div>\n    </div>");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBatchRenameWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        activeRenameType: 0,
        timeRenameType: 4,
        delRenameType: 3,
        insertRenameType: 2,
        replaceRenameType: 1,
        customRenameType: 0,
        letterType: 0,
        resultParams: {
          0: {
            name: "",
            startNum: 1,
            numAdd: 1,
            numLength: 3
          },
          1: {
            oldText: "",
            newText: ""
          },
          2: {
            insertType: 0,
            insertText: "",
            attr: "creatorName",
            startNum: 1,
            numAdd: 1,
            numLength: 3,
            numPos: 0,
            numPosNum: 1
          },
          3: {
            delType: 0,
            delText: "",
            delStart: 1,
            delLength: 2
          },
          4: {
            sourceIndex: "ctime",
            timeFormat: "yyyy-MM-dd",
            timePos: 0,
            startNum: 1,
            numAdd: 1,
            numLength: 3,
            numPos: 0,
            numPosNum: 1
          }
        },
        fileAttrArr: [{
          id: 0,
          name: BabelStr.str(22005),
          sourceIndex: "creatorName"
        }, {
          id: 1,
          name: BabelStr.str(22006),
          sourceIndex: "managerName"
        }, {
          id: 2,
          name: BabelStr.str(22007),
          sourceIndex: "currentVerCommitterName"
        }],
        renameTypeArr: [{
          id: 0,
          name: BabelStr.str(21953)
        }, {
          id: 1,
          name: BabelStr.str(21954)
        }, {
          id: 2,
          name: BabelStr.str(21955)
        }, {
          id: 3,
          name: BabelStr.str(21956)
        }, {
          id: 4,
          name: BabelStr.str(21957)
        }],
        delTypeArr: [{
          id: 0,
          name: BabelStr.str(21991)
        }, {
          id: 1,
          name: BabelStr.str(21996)
        }, {
          id: 2,
          name: BabelStr.str(21997)
        }, {
          id: 3,
          name: BabelStr.str(21998)
        }, {
          id: 4,
          name: BabelStr.str(21999)
        }],
        LetterCaseArr: [{
          id: 0,
          name: BabelStr.str(21960)
        }, {
          id: 1,
          name: BabelStr.str(21961)
        }, {
          id: 2,
          name: BabelStr.str(21962)
        }, {
          id: 3,
          name: BabelStr.str(21963)
        }, {
          id: 4,
          name: BabelStr.str(21964)
        }],
        timeSourceArr: [{
          id: 0,
          name: BabelStr.str(21978),
          sourceIndex: "ctime"
        }, {
          id: 1,
          name: BabelStr.str(21979),
          sourceIndex: "mtime"
        }, {
          id: 2,
          name: BabelStr.str(21980),
          sourceIndex: "now"
        }],
        timeFormatArr: [{
          id: 0,
          name: "yyyy-mm-dd",
          format: "yyyy-MM-dd"
        }, {
          id: 1,
          name: "yyyy-mm-dd-hh-mm",
          format: "yyyy-MM-dd-HH-mm"
        }, {
          id: 2,
          name: "yyyymmddhhmmss",
          format: "yyyyMMddHHmmss"
        }, {
          id: 3,
          name: BabelStr.str(21982),
          format: BabelStr.str(21988)
        }, {
          id: 3,
          name: "dd-mm-yyyy",
          format: "dd-MM-yyyy"
        }],
        timePosArr: [{
          id: 0,
          name: BabelStr.str(21984)
        }, {
          id: 1,
          name: BabelStr.str(21985)
        }, {
          id: 2,
          name: BabelStr.str(21986)
        }, {
          id: 3,
          name: BabelStr.str(21987)
        }],
        numPosArr: [{
          id: 0,
          name: BabelStr.str(21953)
        }, {
          id: 1,
          name: BabelStr.str(21984)
        }, {
          id: 2,
          name: BabelStr.str(21985)
        }]
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBatchRenameWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .cancel': this._cancelClickHandle,
        'keyup .num-input': this._validateInput,
        'change .rename-type-time-content .start-num': this._timeStartNumChanged,
        'change .rename-type-time-content .add-num': this._timeAddNumChanged,
        'change .rename-type-time-content .num-length': this._timeNumLengthChanged,
        'change .rename-type-time-content .num-pos-input': this._timeNumPosChanged,
        'change .rename-type-insert-content .start-num': this._insertStartNumChanged,
        'change .rename-type-insert-content .add-num': this._insertAddNumChanged,
        'change .rename-type-insert-content .num-length': this._insertNumLengthChanged,
        'change .rename-type-insert-content .num-pos-input': this._insertNumPosChanged,
        'click .rename-type-insert-content .setting-item': this._insertTypeChanged,
        'keyup .rename-type-insert-content .new-insert-name': this._insertNameInput,
        'keyup .rename-type-replace-content .old-replace-text': this._oldReplaceNameInput,
        'keyup .rename-type-replace-content .new-replace-text': this._newReplaceNameInput,
        'keyup .rename-type-del-content .custom-text': this._newDelTextInput,
        'keyup .rename-type-del-content .pos-start-input': this._newDelPosStartInput,
        'keyup .rename-type-del-content .pos-length-input': this._newDelPosLengthInput,
        'change .rename-type-del-content .pos-start-input': this._newDelPosStartInput,
        'change .rename-type-del-content .pos-length-input': this._newDelPosLengthInput,
        'change .rename-type-custom-content .start-num': this._customStartNumChanged,
        'change .rename-type-custom-content .add-num': this._customAddNumChanged,
        'change .rename-type-custom-content .num-length': this._customNumLengthChanged,
        'keyup .rename-type-custom-content .new-file-name': this._newCustomTextInput,
        "click .add-num": this._addNum,
        "click .minus-num": this._minusNum,
        "click .start-rename": this._startRename
      });
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        fileName: this.fileName
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBatchRenameWinView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBatchRenameWinView.prototype), "className", this).call(this);
      return superCls + ' batch-rename-win';
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      props.title = BabelStr.str(21950);
      props.width = 900;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBatchRenameWinView.prototype), "initialize", this).call(this, props);
      this.fileTmplArr = [];
      this.fileInforCollection = new _MMFileInfoCollection["default"](this.fileInfors);
      this.$(".file-num").html(this.fileInforCollection.length);
      this.renderFileLIst();
      this.renderRenameType();
      this.renderLetterCaseType();
      this.renderTimeSelect();
      this.renderInsertSelect();
      this.renderReplaceSelect();
      this.renderDelSelect();
      this.onParamsChanged();
    }
  }, {
    key: "renderRenameType",
    value: function renderRenameType() {
      var _this = this;
      this.renameTypeView = new _MDDropdownSelectListView["default"]({
        selectedIndex: 0,
        // silentInit: false,
        dataProvider: this.renameTypeArr,
        labelField: "name",
        onChange: function onChange(obj) {
          _this.activeRenameType = obj.id;
          if (obj.id == _this.timeRenameType) {
            _this.$(".rename-type-content").addClass("f-hide");
            _this.$(".rename-type-time-content").removeClass("f-hide");
          } else if (obj.id == _this.insertRenameType) {
            _this.$(".rename-type-content").addClass("f-hide");
            _this.$(".rename-type-insert-content").removeClass("f-hide");
          } else if (obj.id == _this.replaceRenameType) {
            _this.$(".rename-type-content").addClass("f-hide");
            _this.$(".rename-type-replace-content").removeClass("f-hide");
          } else if (obj.id == _this.delRenameType) {
            _this.$(".rename-type-content").addClass("f-hide");
            _this.$(".rename-type-del-content").removeClass("f-hide");
          } else {
            _this.$(".rename-type-content").addClass("f-hide");
            _this.$(".rename-type-custom-content").removeClass("f-hide");
          }
          _this.onParamsChanged();
        }
      });
      this.addSubView(this.renameTypeView, this.$(".rename-type")[0]);
    }
  }, {
    key: "renderLetterCaseType",
    value: function renderLetterCaseType() {
      var _this2 = this;
      this.letterCaseView = new _MDDropdownSelectListView["default"]({
        selectedIndex: 0,
        // silentInit: false,
        dataProvider: this.LetterCaseArr,
        labelField: "name",
        onChange: function onChange(obj) {
          _this2.letterType = obj.id;
          _this2.onParamsChanged();
        }
      });
      this.addSubView(this.letterCaseView, this.$(".letter-case")[0]);
    }
  }, {
    key: "renderTimeSelect",
    value: function renderTimeSelect() {
      var _this3 = this;
      this.timeSource = new _MDDropdownSelectListView["default"]({
        selectedIndex: 0,
        // silentInit: false,
        dataProvider: this.timeSourceArr,
        labelField: "name",
        onChange: function onChange(obj) {
          _this3.resultParams[_this3.timeRenameType].sourceIndex = obj.sourceIndex;
          _this3.onParamsChanged();
        }
      });
      this.addSubView(this.timeSource, this.$(".rename-type-time-content .time-source")[0]);
      this.timeFormat = new _MDDropdownSelectListView["default"]({
        selectedIndex: 0,
        // silentInit: false,
        dataProvider: this.timeFormatArr,
        labelField: "name",
        onChange: function onChange(obj) {
          _this3.resultParams[_this3.timeRenameType].timeFormat = obj.format;
          _this3.onParamsChanged();
        }
      });
      this.addSubView(this.timeFormat, this.$(".rename-type-time-content .time-format")[0]);
      this.timepos = new _MDDropdownSelectListView["default"]({
        selectedIndex: 0,
        // silentInit: false,
        dataProvider: this.timePosArr,
        labelField: "name",
        onChange: function onChange(obj) {
          if (obj.id == 3) {
            _this3.$(".rename-type-time-content .for-del-name-add-num").removeClass("f-hide");
          } else {
            _this3.$(".rename-type-time-content .for-del-name-add-num").addClass("f-hide");
          }
          _this3.resultParams[_this3.timeRenameType].timePos = obj.id;
          _this3.onParamsChanged();
        }
      });
      this.addSubView(this.timepos, this.$(".rename-type-time-content .time-pos")[0]);
      this.numpos = new _MDDropdownSelectListView["default"]({
        selectedIndex: 0,
        // silentInit: false,
        dataProvider: this.numPosArr,
        labelField: "name",
        onChange: function onChange(obj) {
          if (obj.id == 0) {
            _this3.$(".rename-type-time-content .num-input-block").removeClass("f-hide");
          } else {
            _this3.$(".rename-type-time-content .num-input-block").addClass("f-hide");
          }
          _this3.resultParams[_this3.timeRenameType].numPos = obj.id;
          _this3.onParamsChanged();
        }
      });
      this.addSubView(this.numpos, this.$(".rename-type-time-content .num-pos")[0]);
      // this.timeLetterCaseView = new MDDropdownSelectListView({
      //   selectedIndex: 0,
      //   // silentInit: false,
      //   dataProvider: this.LetterCaseArr,
      //   labelField: "name",
      //   onChange: (obj) => {
      //     this.resultParams[this.timeRenameType].letterType = obj.id
      //     this.onParamsChanged()
      //   },
      // });
      // this.addSubView(
      //   this.timeLetterCaseView,
      //   this.$(".rename-type-time-content .letter-case")[0]
      // );
    }
  }, {
    key: "renderInsertSelect",
    value: function renderInsertSelect() {
      var _this4 = this;
      this.insertNumpos = new _MDDropdownSelectListView["default"]({
        selectedIndex: 0,
        // silentInit: false,
        dataProvider: this.numPosArr,
        labelField: "name",
        onChange: function onChange(obj) {
          if (obj.id == 0) {
            _this4.$(".rename-type-insert-content .num-input-block").removeClass("f-hide");
          } else {
            _this4.$(".rename-type-insert-content .num-input-block").addClass("f-hide");
          }
          _this4.resultParams[_this4.insertRenameType].numPos = obj.id;
          _this4.onParamsChanged();
        }
      });
      this.addSubView(this.insertNumpos, this.$(".rename-type-insert-content .num-pos")[0]);
      this.insertAttrpos = new _MDDropdownSelectListView["default"]({
        selectedIndex: 0,
        // silentInit: false,
        dataProvider: this.fileAttrArr,
        labelField: "name",
        onChange: function onChange(obj) {
          _this4.resultParams[_this4.insertRenameType].attr = obj.sourceIndex;
          _this4.onParamsChanged();
        }
      });
      this.addSubView(this.insertAttrpos, this.$(".rename-type-insert-content .for-attr")[0]);
      // this.insertLetterCaseView = new MDDropdownSelectListView({
      //   selectedIndex: 0,
      //   // silentInit: false,
      //   dataProvider: this.LetterCaseArr,
      //   labelField: "name",
      //   onChange: (obj) => {
      //     this.resultParams[this.insertRenameType].letterType = obj.id
      //     this.onParamsChanged()
      //   },
      // });
      // this.addSubView(
      //   this.insertLetterCaseView,
      //   this.$(".rename-type-insert-content .letter-case")[0]
      // );
    }
  }, {
    key: "renderReplaceSelect",
    value: function renderReplaceSelect() {
      // this.replaceLetterCaseView = new MDDropdownSelectListView({
      //   selectedIndex: 0,
      //   // silentInit: false,
      //   dataProvider: this.LetterCaseArr,
      //   labelField: "name",
      //   onChange: (obj) => {
      //     this.resultParams[this.replaceRenameType].letterType = obj.id
      //     this.onParamsChanged()
      //   },
      // });
      // this.addSubView(
      //   this.replaceLetterCaseView,
      //   this.$(".rename-type-replace-content .letter-case")[0]
      // );
    }
  }, {
    key: "renderDelSelect",
    value: function renderDelSelect() {
      var _this5 = this;
      this.delTypeView = new _MDDropdownSelectListView["default"]({
        selectedIndex: 0,
        // silentInit: false,
        dataProvider: this.delTypeArr,
        labelField: "name",
        onChange: function onChange(obj) {
          if (obj.id == 0) {
            _this5.$(".rename-type-del-content .for-custom").removeClass("f-hide");
            _this5.$(".rename-type-del-content .for-name-pos").addClass("f-hide");
          } else if (obj.id == 1) {
            _this5.$(".rename-type-del-content .for-custom").addClass("f-hide");
            _this5.$(".rename-type-del-content .for-name-pos").removeClass("f-hide");
          } else {
            _this5.$(".rename-type-del-content .for-custom").addClass("f-hide");
            _this5.$(".rename-type-del-content .for-name-pos").addClass("f-hide");
          }
          _this5.resultParams[_this5.delRenameType].delType = obj.id;
          _this5.onParamsChanged();
        }
      });
      this.addSubView(this.delTypeView, this.$(".rename-type-del-content .del-type")[0]);
    }
  }, {
    key: "renderFileLIst",
    value: function renderFileLIst() {
      var _this6 = this;
      var $contain = this.$(".table-body");
      this.fileInforCollection.each(function (file) {
        var tmpl = _this6.fileTmpl(file);
        var $tmpl = $(tmpl);
        // file.setIconForDiv($tmpl.find(".thumbWrapper"), null, 26);
        $contain.append($tmpl);
        _this6.fileTmplArr.push({
          file: file,
          $originFileName: $tmpl.find(".origin-name"),
          $fileName: $tmpl.find(".new-name"),
          fileName: file.getFileName(),
          $status: $tmpl.find(".status-item")
        });
      });
    }
  }, {
    key: "_timeStartNumChanged",
    value: function _timeStartNumChanged($e) {
      var val = $($e.target).val();
      val = val.trim();
      this.resultParams[this.timeRenameType].startNum = val;
      this.onParamsChanged();
    }
  }, {
    key: "_timeNumLengthChanged",
    value: function _timeNumLengthChanged($e) {
      var val = $($e.target).val();
      val = val.trim();
      this.resultParams[this.timeRenameType].numLength = val;
      this.onParamsChanged();
    }
  }, {
    key: "_timeAddNumChanged",
    value: function _timeAddNumChanged($e) {
      var val = $($e.target).val();
      val = val.trim();
      this.resultParams[this.timeRenameType].numAdd = val;
      this.onParamsChanged();
    }
  }, {
    key: "_timeNumPosChanged",
    value: function _timeNumPosChanged($e) {
      var val = $($e.target).val();
      val = val.trim();
      this.resultParams[this.timeRenameType].numPosNum = val;
      this.onParamsChanged();
    }
  }, {
    key: "_insertStartNumChanged",
    value: function _insertStartNumChanged($e) {
      var val = $($e.target).val();
      val = val.trim();
      this.resultParams[this.insertRenameType].startNum = val;
      this.onParamsChanged();
    }
  }, {
    key: "_insertNumLengthChanged",
    value: function _insertNumLengthChanged($e) {
      var val = $($e.target).val();
      val = val.trim();
      this.resultParams[this.insertRenameType].numLength = val;
      this.onParamsChanged();
    }
  }, {
    key: "_insertAddNumChanged",
    value: function _insertAddNumChanged($e) {
      var val = $($e.target).val();
      val = val.trim();
      this.resultParams[this.insertRenameType].numAdd = val;
      this.onParamsChanged();
    }
  }, {
    key: "_insertNumPosChanged",
    value: function _insertNumPosChanged($e) {
      var val = $($e.target).val();
      val = val.trim();
      this.resultParams[this.insertRenameType].numPosNum = val;
      this.onParamsChanged();
    }
  }, {
    key: "_insertTypeChanged",
    value: function _insertTypeChanged($e) {
      var $cur = $($e.target);
      if ($cur.hasClass("checked")) {
        return;
      }
      this.$(".rename-type-insert-content .setting-item").removeClass("checked");
      $cur.addClass("checked");
      this.resultParams[this.insertRenameType].insertType = $cur.index();
      if ($cur.index() == 0) {
        this.$(".rename-type-insert-content .for-content").removeClass("f-hide");
        this.$(".rename-type-insert-content .for-num").addClass("f-hide");
        this.$(".rename-type-insert-content .for-attr").addClass("f-hide");
      } else if ($cur.index() == 1) {
        this.$(".rename-type-insert-content .for-content").addClass("f-hide");
        this.$(".rename-type-insert-content .for-num").removeClass("f-hide");
        this.$(".rename-type-insert-content .for-attr").addClass("f-hide");
      } else {
        this.$(".rename-type-insert-content .for-content").addClass("f-hide");
        this.$(".rename-type-insert-content .for-num").addClass("f-hide");
        this.$(".rename-type-insert-content .for-attr").removeClass("f-hide");
      }
      this.onParamsChanged();
      // console.log($cur.index())
    }
  }, {
    key: "_insertNameInput",
    value: function _insertNameInput($e) {
      var _this7 = this;
      if (this.insertTimer) {
        clearTimeout(this.insertTimer);
      }
      this.insertTimer = setTimeout(function () {
        var val = $($e.target).val();
        val = val.trim();
        var result = "";
        var filterArr = ['\\', '/', ':', '*', '?', '"', '<', '>', '|'];
        for (var i = 0; i < val.length; i++) {
          if (val.charCodeAt(i) < 32 || filterArr.includes(val[i])) {
            // return false
          } else {
            result += val[i];
          }
        }
        _this7.resultParams[_this7.insertRenameType].insertText = result;
        _this7.onParamsChanged();
      }, 1000);
    }
  }, {
    key: "_oldReplaceNameInput",
    value: function _oldReplaceNameInput($e) {
      var _this8 = this;
      if (this.oldReplaceTimer) {
        clearTimeout(this.oldReplaceTimer);
      }
      this.oldReplaceTimer = setTimeout(function () {
        var val = $($e.target).val();
        val = val.trim();
        _this8.resultParams[_this8.replaceRenameType].oldText = val;
        _this8.onParamsChanged();
      }, 1000);
    }
  }, {
    key: "_newReplaceNameInput",
    value: function _newReplaceNameInput($e) {
      var _this9 = this;
      if (this.newReplaceTimer) {
        clearTimeout(this.newReplaceTimer);
      }
      this.newReplaceTimer = setTimeout(function () {
        var val = $($e.target).val();
        val = val.trim();
        var result = "";
        var filterArr = ['\\', '/', ':', '*', '?', '"', '<', '>', '|'];
        for (var i = 0; i < val.length; i++) {
          if (val.charCodeAt(i) < 32 || filterArr.includes(val[i])) {
            // return false
          } else {
            result += val[i];
          }
        }
        _this9.resultParams[_this9.replaceRenameType].newText = result;
        _this9.onParamsChanged();
      }, 1000);
    }
  }, {
    key: "_newDelTextInput",
    value: function _newDelTextInput($e) {
      var _this10 = this;
      if (this.newDelTextTimer) {
        clearTimeout(this.newDelTextTimer);
      }
      this.newDelTextTimer = setTimeout(function () {
        var val = $($e.target).val();
        val = val.trim();
        _this10.resultParams[_this10.delRenameType].delText = val;
        _this10.onParamsChanged();
      }, 1000);
    }
  }, {
    key: "_newDelPosStartInput",
    value: function _newDelPosStartInput($e) {
      var _this11 = this;
      if (this.newDelStartTimer) {
        clearTimeout(this.newDelStartTimer);
      }
      this.newDelStartTimer = setTimeout(function () {
        var val = $($e.target).val();
        val = val.trim();
        // if(val < 1) {
        //   val = 1
        // }
        // $e.target.value = 1
        if (_this11.resultParams[_this11.delRenameType].delStart != val) {
          _this11.resultParams[_this11.delRenameType].delStart = val;
          _this11.onParamsChanged();
        }
      }, 1000);
    }
  }, {
    key: "_newDelPosLengthInput",
    value: function _newDelPosLengthInput($e) {
      var _this12 = this;
      if (this.newDelLengthTimer) {
        clearTimeout(this.newDelLengthTimer);
      }
      this.newDelLengthTimer = setTimeout(function () {
        var val = $($e.target).val();
        val = val.trim();
        // if(val < 1) {
        //   val = 1
        // }
        // $e.target.value = 1

        if (_this12.resultParams[_this12.delRenameType].delLength != val) {
          _this12.resultParams[_this12.delRenameType].delLength = val;
          _this12.onParamsChanged();
        }
      }, 1000);
    }
  }, {
    key: "_customStartNumChanged",
    value: function _customStartNumChanged($e) {
      var val = $($e.target).val();
      val = val.trim();
      this.resultParams[this.customRenameType].startNum = val;
      this.onParamsChanged();
    }
  }, {
    key: "_customNumLengthChanged",
    value: function _customNumLengthChanged($e) {
      var val = $($e.target).val();
      val = val.trim();
      this.resultParams[this.customRenameType].numLength = val;
      this.onParamsChanged();
    }
  }, {
    key: "_customAddNumChanged",
    value: function _customAddNumChanged($e) {
      var val = $($e.target).val();
      val = val.trim();
      this.resultParams[this.customRenameType].numAdd = val;
      this.onParamsChanged();
    }
  }, {
    key: "_newCustomTextInput",
    value: function _newCustomTextInput($e) {
      var _this13 = this;
      if (this.customNameTimer) {
        clearTimeout(this.customNameTimer);
      }
      this.customNameTimer = setTimeout(function () {
        var val = $($e.target).val();
        val = val.trim();
        var result = "";
        var filterArr = ['\\', '/', ':', '*', '?', '"', '<', '>', '|'];
        for (var i = 0; i < val.length; i++) {
          if (val.charCodeAt(i) < 32 || filterArr.includes(val[i])) {
            // return false
          } else {
            result += val[i];
          }
        }
        if (_this13.resultParams[_this13.customRenameType].name != result) {
          _this13.resultParams[_this13.customRenameType].name = result;
          _this13.onParamsChanged();
        }
      }, 1000);
    }
  }, {
    key: "_validateInput",
    value: function _validateInput($e) {
      var val = $e.target.value.replace(/[^\d]/g, '');
      if (parseInt(val) < 1 || _.isNaN(parseInt(val))) {
        val = 1;
      }
      $e.target.value = val;
    }
  }, {
    key: "onParamsChanged",
    value: function onParamsChanged() {
      console.log(this.resultParams);
      this.refreshFileName();
    }

    // this.fileTmplArr[file.getFileId()] = {
    //   file: file,
    //   $fileName: $tmpl.find(".new-name"),
    //   fileName: file.getFileName()
    // }
  }, {
    key: "refreshFileName",
    value: function refreshFileName() {
      var curCondition = this.resultParams[this.activeRenameType];
      this.curNum = curCondition.startNum || 0;
      var hasChanged = false;
      var _iterator = _createForOfIteratorHelper(this.fileTmplArr),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          // if (Object.hasOwnProperty.call(this.fileTmplArr, key)) {
          // let item = this.fileTmplArr[key];
          var newName = this.getNameByCondition(item.file, curCondition);
          var arr = newName.split('.');
          var name = "";
          if (!item.file.isFolder() && arr.length > 1) {
            arr.pop();
            name = arr.join(".");
            if (!name.length) {
              newName = item.file.getFileName();
            }
          } else if (!newName.length) {
            newName = item.file.getFileName();
          }
          item.file.set("targetName", newName);
          item.$fileName.html(newName);
          // }
          item.$status.find("span").addClass("f-hide");
          item.$status.find(".no-start").removeClass("f-hide");
          if (item.file.getFileName() != item.file.get("targetName")) {
            hasChanged = true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var firtFile = this.fileTmplArr[0].file;
      if (hasChanged) {
        this.$(".start-rename").removeClass("disabled");
      } else {
        this.$(".start-rename").addClass("disabled");
      }
    }
  }, {
    key: "getNameByCondition",
    value: function getNameByCondition(file, curCondition) {
      var newName;
      if (this.activeRenameType == this.timeRenameType) {
        newName = this.getTimeConditonNewName(file, curCondition);
      } else if (this.activeRenameType == this.insertRenameType) {
        newName = this.getInsertConditonNewName(file, curCondition);
      } else if (this.activeRenameType == this.replaceRenameType) {
        newName = this.getReplaceConditonNewName(file, curCondition);
      } else if (this.activeRenameType == this.delRenameType) {
        newName = this.getDelConditonNewName(file, curCondition);
      } else if (this.activeRenameType == this.customRenameType) {
        newName = this.getCustomConditonNewName(file, curCondition);
      }
      return newName;
    }
  }, {
    key: "getCustomConditonNewName",
    value: function getCustomConditonNewName(file, params) {
      var arr = file.getFileName().split('.');
      var ext = "";
      if (arr.length > 1 && !file.isFolder()) {
        ext = "." + arr[arr.length - 1];
      }
      var name = params.name;
      var num = this.curNum;
      var numStr = num.toString().padStart(params.numLength, '0');
      this.curNum = parseInt(this.curNum) + parseInt(params.numAdd);
      name = name + numStr;
      name = this.doCaseConversion(name, this.letterType);
      name += ext;
      return name;
    }
  }, {
    key: "getDelConditonNewName",
    value: function getDelConditonNewName(file, params) {
      var text;
      var name = file.getFileName();
      var arr = name.split('.');
      var ext = '';
      if (!file.isFolder() && arr.length > 1) {
        ext = "." + arr.pop();
        name = arr.join(".");
      }
      if (params.delType == 0) {
        text = name.replace(new RegExp(params.delText, 'g'), "");
      } else if (params.delType == 1) {
        var start = params.delStart - 1;
        start = start < 0 ? 0 : start;
        var length = parseInt(params.delLength);
        if (start + length >= name.length) {
          text = name;
        } else if (length > 0 && start >= 0) {
          text = name.substring(0, start) + name.substring(start + length);
        } else {
          text = name;
        }
      } else if (params.delType == 2) {
        text = name.replace(/\s/g, '');
      } else if (params.delType == 3) {
        text = name.replace(/\d/g, '');
      } else if (params.delType == 4) {
        text = name.replace(/['"‘“’”]/g, '');
      }
      name = this.doCaseConversion(text, this.letterType);
      name += ext;
      return name;
    }
  }, {
    key: "getReplaceConditonNewName",
    value: function getReplaceConditonNewName(file, params) {
      var name = file.getFileName();
      var arr = name.split('.');
      var ext = '';
      if (!file.isFolder() && arr.length > 1) {
        ext = "." + arr.pop();
        name = arr.join(".");
      }
      if (params.oldText && params.newText) {
        name = name.replace(new RegExp(params.oldText, 'g'), params.newText);
      }
      name = this.doCaseConversion(name, this.letterType);
      name += ext;
      return name;
    }
  }, {
    key: "getInsertConditonNewName",
    value: function getInsertConditonNewName(file, params) {
      var text;
      var name = file.getFileName();
      var arr = name.split('.');
      var ext = '';
      if (!file.isFolder() && arr.length > 1) {
        ext = "." + arr.pop();
        name = arr.join(".");
      }
      if (params.insertType == 0) {
        text = this.inserStr(name, params.insertText, params, file);
      } else if (params.insertType == 1) {
        text = this.inserNum(name, params, file);
      } else {
        var newText = file.get(params.attr);
        text = this.inserStr(name, newText, params, file);
      }
      name = this.doCaseConversion(text, this.letterType);
      name += ext;
      return name;
    }
  }, {
    key: "getTimeConditonNewName",
    value: function getTimeConditonNewName(file, params) {
      var time;
      var name = file.getFileName();
      var arr = name.split('.');
      var ext = '';
      if (!file.isFolder() && arr.length > 1) {
        ext = "." + arr.pop();
        name = arr.join(".");
      }
      if (params.sourceIndex == 'now') {
        time = new Date();
      } else {
        time = new Date(file.get(params.sourceIndex) * 1000);
      }
      var timeStr = time.format(params.timeFormat);
      if (params.timePos == 0) {
        name = timeStr + name;
      } else if (params.timePos == 1) {
        if (arr.length > 1 && !file.isFolder()) {
          name += timeStr;
        } else {
          name = name + timeStr;
        }
      } else if (params.timePos == 2) {
        if (arr.length > 1 && !file.isFolder()) {
          name = timeStr;
        } else {
          name = timeStr;
        }
      } else {
        if (arr.length > 1 && !file.isFolder()) {
          name = timeStr;
        } else {
          name = timeStr;
        }
        name = this.inserNum(name, params, file);
      }
      name = this.doCaseConversion(name, this.letterType);
      name += ext;
      return name;
    }
  }, {
    key: "doCaseConversion",
    value: function doCaseConversion(str, letterType) {
      switch (letterType) {
        case 1:
          str = str.toUpperCase();
          break;
        case 2:
          str = str.toLowerCase();
          break;
        case 3:
          str = str.slice(0, 1).toUpperCase() + str.slice(1);
          break;
        case 4:
          str = str.slice(0, 1).toLowerCase() + str.slice(1);
          break;
      }
      return str;
    }
  }, {
    key: "inserNum",
    value: function inserNum(str, params, file) {
      var num = this.curNum;
      var numStr = num.toString().padStart(params.numLength, '0');
      var pos;
      if (params.numPos == 1) {
        str = numStr + str;
      } else if (params.numPos == 2) {
        var arr = str.split('.');
        if (arr.length > 1 && !file.isFolder()) {
          arr[arr.length - 2] += numStr;
          str = arr.join('.');
        } else {
          str = str + numStr;
        }
      } else {
        str = this.insertString(str, params.numPosNum - 1, numStr);
      }
      this.curNum = parseInt(this.curNum) + parseInt(params.numAdd);
      return str;
    }
  }, {
    key: "inserStr",
    value: function inserStr(str, newStr, params, file) {
      if (params.numPos == 1) {
        str = newStr + str;
      } else if (params.numPos == 2) {
        var arr = str.split('.');
        if (arr.length > 1 && !file.isFolder()) {
          arr[arr.length - 2] += newStr;
          str = arr.join('.');
        } else {
          str = str + newStr;
        }
      } else {
        str = this.insertString(str, params.numPosNum - 1, newStr);
      }
      return str;
    }
  }, {
    key: "insertString",
    value: function insertString(str, index, newStr) {
      var arr = str.split('');
      arr.splice(index, 0, newStr);
      return arr.join('');
    }
  }, {
    key: "_addNum",
    value: function _addNum($e) {
      var $target = $($e.target).siblings(".num-input");
      var oldVal = $target.val();
      var newVal = oldVal - 0 + 1;
      $target.val(newVal);
      $target.trigger("change");
    }
  }, {
    key: "_minusNum",
    value: function _minusNum($e) {
      var $target = $($e.target).siblings(".num-input");
      var oldVal = $target.val();
      var newVal = oldVal - 1;
      newVal = newVal < 1 ? 1 : newVal;
      $target.val(newVal);
      $target.trigger("change");
    }
  }, {
    key: "_startRename",
    value: function _startRename() {
      var _this14 = this;
      if (this.$(".start-rename").hasClass("disabled")) {
        console.log("名称未发生改变");
        return;
      }
      var msgview = _MDMessageView["default"].infor(BabelStr.str(22010), this.$body);
      this.$('.left-block').addClass("un-clickable");
      this.$(".start-rename").addClass("disabled");
      this.renameFileByIndex(0, function () {
        msgview && msgview.close();
        _MDMessageView["default"].success(BabelStr.str(22011), _this14.$body);
        _this14.$('.left-block').removeClass("un-clickable");
      });
    }
  }, {
    key: "renameFileByIndex",
    value: function renameFileByIndex(index, callback) {
      var _this15 = this;
      var item = this.fileTmplArr[index];
      if (!item) {
        callback();
        return;
      }
      var file = item.file;
      var promise = new Promise(function (resolve, reject) {
        // 模拟异步操作，例如setTimeout
        _this15.renameFile(file, function () {
          item.file.set("fileName", file.get("targetName"));
          item.$originFileName.html(file.get("targetName"));
          item.$status.find("span").addClass("f-hide");
          item.$status.find(".success").removeClass("f-hide");
          resolve(index + 1, callback);
        }, function (code, msg) {
          item.$status.find("span").addClass("f-hide");
          item.$status.find(".error").removeClass("f-hide");
          item.$status.find(".error").attr("data-tooltip", msg);
          resolve(index + 1, callback);
        });
      });
      promise.then(function () {
        _this15.renameFileByIndex(index + 1, callback);
      })["catch"](function (error) {
        console.log(error); // 如果Promise被拒绝，这里的代码会被执行
        // resolve(index + 1, callback)
      });
    }
  }, {
    key: "renameFile",
    value: function renameFile(file, success, fail) {
      var name = file.get("targetName");
      if (file.getFileName() == name) {
        success();
        console.log('文件名未发生变动：' + name);
        return;
      }
      if (file.get("targetName").length > 100) {
        fail(404, BabelStr.str(22012));
        return;
      }
      var data;
      if (file.isHQSMProject()) {
        data = {
          transmittalTitle: name,
          fileId: file.getFileId(),
          transmittalProjectId: file.get("transmittalProjectId"),
          departmentId: file.get("departmentId")
        };
        MMEnterpriseController.updateTransmittalProject(data, function () {
          success();
        }, function (code, msg) {
          fail(code, msg);
        });
      } else if (file.isProject()) {
        data = {
          fileId: file.getFileId(),
          name: name,
          participantInfo: {
            phoneInfos: [],
            emailInfos: [],
            userInfos: [],
            groupInfos: [],
            depInfos: []
          },
          removeUserInfos: [],
          updateUserInfos: []
        };
        console.log(params);
        MMEnterpriseController.project.updateProject(params, function () {
          success();
        }, function (msg, code) {
          fail(code, msg);
        });
      } else if (file.isDepartmentFolder()) {
        MMEnterpriseController.department.changeDepartmentInfo(file.get("departmentId"), {
          name: name
        }, success, function fail(code, msg) {
          fail(code, msg);
        });
      } else {
        MMNetDiskDataController.renameFile(file.getFileId(), file.getCurVersion(), name, function () {
          success();
        }, function (code, msg) {
          fail(code, msg);
        });
      }
    }
  }]);
  return MDBatchRenameWinView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1417":1417,"1419":1419,"1420":1420,"1422":1422,"1423":1423,"1424":1424,"1429":1429,"1432":1432,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1466":1466,"1471":1471,"1475":1475,"1476":1476,"1477":1477,"1478":1478,"1487":1487,"1490":1490,"1492":1492,"1498":1498,"1500":1500,"1502":1502,"1503":1503,"1538":1538,"1541":1541,"298":298,"55":55,"67":67,"93":93}],537:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1417);
require(1463);
require(1416);
require(1429);
require(1439);
require(1466);
require(1541);
require(1490);
require(1437);
require(1478);
require(1477);
require(1492);
require(1424);
require(1498);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDCheckboxView = _interopRequireDefault(require(37));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MDDropdownSelectSplitListView = _interopRequireDefault(require(68));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MMFileIconMaker = _interopRequireDefault(require(296));
var _MMFileInfo = _interopRequireDefault(require(297));
var _menusvg = _interopRequireDefault(require(1119));
var _MDMoveFileWindowView = _interopRequireDefault(require(508));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDAutoRenameCreateWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDAutoRenameCreateWinView, _MDWindowView);
  function MDAutoRenameCreateWinView() {
    (0, _classCallCheck2["default"])(this, MDAutoRenameCreateWinView);
    return _callSuper(this, MDAutoRenameCreateWinView, arguments);
  }
  (0, _createClass2["default"])(MDAutoRenameCreateWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n      <div class=\"section\">\n        <%if(taskRENid){%>\n          <div class=\"flex-align between middle mgb-10\">\n            <div class=\"section-title\"><%=BabelStr.str(28062)%></div>\n            <div class=\"f-pointer red del-task no-shrink\"><%=BabelStr.str(28063)%></div>\n          </div>\n\n          <div class=\"file-item flex-align middle mgb-10\">\n            <div class=\"file-thumb no-shrink\"></div>\n            <div class=\"file-name text-hide\"></div>\n          </div>\n        <%} else {%>\n          <div class=\"section-title mgb-10\"><%=BabelStr.str(28013)%></div>\n          <div class=\"folder-group mgb-10\">\n              <div class=\"has-selected  flex-align between middle\">\n                <div class=\"file-item flex-align middle\">\n                  <div class=\"file-thumb no-shrink\"></div>\n                  <div class=\"file-name text-hide\"></div>\n                </div>\n                <div class=\"text-button done select-folder no-shrink\"><%=BabelStr.str(28019)%></div>\n              </div>\n              <div class=\"no-selected\">\n                <div class=\"text-button done select-folder\"><%=BabelStr.str(28014)%></div>\n              </div>\n          </div>\n        <%}%>\n        <div class=\"checkbox-group all-folder flex-align middle with-wrap gap-10 mgb-10\">\n            <div class=\"checkbox-slot\"></div>\n            <div class=\"info-desc\"><%=BabelStr.str(28162)%></div>\n        </div>\n        <div class=\"checkbox-group cur-folder-use f-hide flex-align middle with-wrap gap-10 mgb-10\">\n          <div class=\"checkbox-slot\"></div>\n          <div class=\"info-desc\"><%=BabelStr.str(28075)%></div>\n        </div>\n    </div>\n\n    <div class=\"split-line mgb-10\"></div>\n\n    <div class=\"temp-file flex-align middle mgb-10\">\n      <div class=\"icon temp-file-ic\"></div>\n      <div class=\"temp-file-name\"><%=tempFileName%>.pdf</div>\n    </div>\n    <div class=\"flex-align middle mgb-10\">\n      <div class=\"info-desc\"><%=BabelStr.str(28077)%></div>\n    </div>\n    <div class=\"select-contain\"></div>\n\n    <form class=\"rule-list\"></form>\n    <div class=\"mgb-10 flex-align\">\n      <div class=\"add-rule flex-align middle \">\n        <div class=\"add-ic icon\"></div>\n        <div><%=BabelStr.str(28094)%></div>\n      </div>\n    </div>\n\n\n    <div class=\"split-line mgb-10\"></div>\n\n    <div class=\"other-rule-item flex-align middle mgb-10 gap-10\">\n      <div class=\"case-checkbox\"></div>\n      <div class=\"case-select\"></div>\n    </div>\n    <div class=\"other-rule-item flex-align middle mgb-10 gap-10\">\n      <div class=\"split-checkbox\"></div>\n      <div class=\"split-select\"></div>\n    </div>\n\n    ";
    }
  }, {
    key: "fileNameRuleTmpl",
    value: function fileNameRuleTmpl(id) {
      return "\n      <div class=\"rule-item name-item\" data-id=\"".concat(id, "\">\n        <div class=\"flex-align start gap-10 \">\n          <div class=\"flex-align start gap-10 fullfill\">\n            <div class=\"rule-title no-shrink\"><%=BabelStr.str(28099)%></div>\n            <div class=\"flex-align start with-wrap gap-10\">\n              <div class=\"rule-select\"></div>\n              <div class=\"name-rule-types\">\n                <div class=\"name-rule-type-item f-hide type-0 flex-align start gap-10\">\n                  <div>\n                    <input name=\"name-old-key\" class=\"form-control name-old-key\" required placeholder=\"<%=BabelStr.str(28100)%>\"/>\n                  </div>\n                  <div>\n                    <input name=\"name-new-key\" class=\"form-control name-new-key\" required placeholder=\"<%=BabelStr.str(28101)%>\"/>\n                  </div>\n\n                </div>\n                <div class=\"name-rule-type-item f-hide type-1 flex-align start gap-10\">\n                  <div>\n                    <input name=\"name-del-key\" class=\"form-control name-del-key\" required placeholder=\"<%=BabelStr.str(28102)%>\"/>\n                  </div>\n                </div>\n\n                <div class=\"name-rule-type-item f-hide type-2 flex-align start gap-10\">\n                  <div class=\"del-name-key-type\"></div>\n                </div>\n\n              </div>\n            </div>\n          </div>\n          <div class=\"opes flex-align no-shrink end\">\n            <div class=\"ope-btn move drag-handle\">").concat(_menusvg["default"].menu_tool_move, "</div>\n          </div>\n        </div>\n\n      </div>\n    ");
    }
  }, {
    key: "insertRuleTmpl",
    value: function insertRuleTmpl(id) {
      return "<div class=\"rule-item \" data-id=\"".concat(id, "\">\n      <div class=\"flex-align start gap-10 \">\n        <div class=\"rule-condition-select\">\n        </div>\n        <div class=\"rule-condition-content fullfill\">\n\n          <div class=\"flex-align middle gap-10 rule-type rule-type-1 with-wrap f-hide\">\n            <div class=\"flex-align middle gap-10\">\n              <span class=\"no-shrink\"><%=BabelStr.str(28107)%></span>\n              <div class=\"num-input-block\">\n                <input name=\"number-start-").concat(id, "\" class=\"form-control num-input number-start\" required />\n              </div>\n            </div>\n            <div class=\"flex-align middle gap-10\">\n              <span class=\"no-shrink\"><%=BabelStr.str(28108)%></span>\n              <div class=\"num-input-block\">\n                <input name=\"number-step-").concat(id, "\" class=\"form-control num-input number-step\" required />\n              </div>\n            </div>\n            <div class=\"flex-align middle gap-10\">\n              <span class=\"no-shrink\"><%=BabelStr.str(28109)%></span>\n              <div class=\"num-input-block\">\n                <input name=\"number-length-").concat(id, "\" class=\"form-control num-input number-length\" required />\n              </div>\n            </div>\n            <div class=\"info ope-btn\" data-tooltip=\"<%=BabelStr.str(28110)%>\">").concat(_menusvg["default"].menu_tool_info, "</div>\n          </div>\n\n          <div class=\"flex-align middle gap-10 rule-type rule-type-2 f-hide\">\n            <div>\n              <input name=\"custom-string-").concat(id, "\" class=\"form-control custom-string\"  placeholder=\"<%=BabelStr.str(28111)%>\"  required notempty/>\n            </div>\n          </div>\n\n          <div class=\"flex-align middle gap-10 rule-type rule-type-6 rule-type-10 f-hide\">\n            <div class=\"time-format-select\"></div>\n\n          </div>\n\n        </div>\n        <div class=\"opes flex-align no-shrink end\">\n          <div class=\"ope-btn remove-rule\">").concat(_menusvg["default"].menu_tool_remove, "</div>\n          <div class=\"ope-btn move drag-handle\">").concat(_menusvg["default"].menu_tool_move, "</div>\n        </div>\n\n      </div>\n      <div class=\"checkbox-slot rule-time-checkbox f-hide\"></div>\n\n\n    </div>\n    ");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var props = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAutoRenameCreateWinView.prototype), "initProps", this).call(this);
      return _.extend(props, {
        conditionArr: [{
          type: -1,
          name: BabelStr.str(28078)
        },
        // 选择规则，这里 type -1 作为特殊标识，可根据实际调整

        // 以下按照新规则修正 type
        {
          type: 1,
          name: BabelStr.str(28080)
        },
        // 编号对应自动编号
        {
          type: 2,
          name: BabelStr.str(28081)
        },
        // 自定义内容
        {
          type: 3,
          name: BabelStr.str(28082)
        },
        // 文件上传者
        {
          type: 4,
          name: BabelStr.str(28083)
        },
        // 文件负责人
        {
          type: 5,
          name: BabelStr.str(28084)
        },
        // 上级文件夹
        {
          type: 6,
          name: BabelStr.str(28085)
        } // 上传时间

        // 媒体元数据是类别，下面具体项分别对应
        // 重新准确对应
        ],
        nameConditionArr: [{
          type: -1,
          name: BabelStr.str(28095)
        }, {
          type: 0,
          name: BabelStr.str(28096)
        }, {
          type: 1,
          name: BabelStr.str(28097)
        }, {
          type: 2,
          name: BabelStr.str(28098)
        }],
        nameDelTypeArr: [{
          type: 0,
          name: BabelStr.str(28103)
        }, {
          type: 1,
          name: BabelStr.str(28104)
        }, {
          type: 2,
          name: BabelStr.str(28105)
        }, {
          type: 3,
          name: BabelStr.str(28106)
        }],
        timeFormatTypeArr: [{
          type: 0,
          name: BabelStr.str(28112)
        }, {
          type: 1,
          name: BabelStr.str(28113)
        }, {
          type: 2,
          name: BabelStr.str(28114)
        }, {
          type: 3,
          name: BabelStr.str(28115)
        }, {
          type: 4,
          name: BabelStr.str(28116)
        }, {
          type: 5,
          name: BabelStr.str(28117)
        }],
        caseTypeArr: [{
          type: 0,
          name: BabelStr.str(28120)
        }, {
          type: 1,
          name: BabelStr.str(28121)
        }, {
          type: 2,
          name: BabelStr.str(28122)
        }, {
          type: 3,
          name: BabelStr.str(28123)
        }],
        splitTypeArr: [{
          type: 0,
          name: BabelStr.str(28125)
        }, {
          type: 1,
          name: BabelStr.str(28126)
        }, {
          type: 2,
          name: BabelStr.str(28127)
        }],
        rulesObj: {},
        ruleId: 0,
        hyphen: -1,
        hyphenChecked: true,
        upperLower: -1,
        upperLowerChecked: true,
        applyToOldFile: true,
        includeSub: true,
        replaceOldTime: true,
        tempFileName: BabelStr.str(28076)
      });
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        taskRENid: this.taskRENid,
        tempFileName: this.tempFileName
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAutoRenameCreateWinView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAutoRenameCreateWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " auto-rename-create-win task-create-win");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAutoRenameCreateWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .select-folder": this._selectFolder,
        "click .add-rule": this._addRule,
        "click .remove-rule": this._removeRule,
        "keypress .num-input": this._onlyNum,
        "blur input": this.refreshTmplName,
        "click .del-task": this._delTask,
        "submit form": this.noSubmit
      });
    }
  }, {
    key: "noSubmit",
    value: function noSubmit(e) {
      e.preventDefault(); // 阻止表单提交
      console.log("表单已拦截，执行自定义逻辑");
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      if (props.taskRENid) {
        props.title = BabelStr.str(28128);
      } else {
        props.title = BabelStr.str(28071);
      }
      props.size = "large";
      props.buttons = [{
        label: BabelStr.str(3081),
        type: "default"
      }, {
        label: BabelStr.str(3080),
        type: "done",
        autoClose: false,
        onClick: function onClick(button, $e) {
          this._saveClicked();
        }
      }];
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAutoRenameCreateWinView.prototype), "initialize", this).call(this, props);
      if (window.user.useAdvancedSearch) {
        this.conditionArr = this.conditionArr.concat([{
          type: 10,
          name: BabelStr.str(28087)
        },
        // 拍摄日期对应拍摄时间
        {
          type: 11,
          name: BabelStr.str(28088)
        },
        // 相机制造商
        {
          type: 12,
          name: BabelStr.str(28089)
        },
        // 相机型号
        {
          type: 13,
          name: BabelStr.str(28090)
        },
        // 镜头型号
        {
          type: 14,
          name: BabelStr.str(28091)
        },
        // 尺寸
        {
          type: 15,
          name: BabelStr.str(28092)
        },
        // 每英寸点数（DPI）
        {
          type: 16,
          name: BabelStr.str(28093)
        } // 每厘米点数（DPCM）
        ]);
      }
      this.renderFileInfo();
      this.allSubFolderView = new _MDCheckboxView["default"]({
        label: BabelStr.str(28015),
        checked: this.includeSub,
        onChanged: function onChanged(checked) {
          _this.includeSub = checked;
        }
      });
      this.addSubView(this.allSubFolderView, this.$(".all-folder .checkbox-slot")[0]);
      this.curFolderUseView = new _MDCheckboxView["default"]({
        label: BabelStr.str(28074),
        checked: this.applyToOldFile,
        onChanged: function onChanged(checked) {
          _this.applyToOldFile = checked;
        }
      });
      this.addSubView(this.curFolderUseView, this.$(".cur-folder-use .checkbox-slot")[0]);
      this.caseBoxView = new _MDCheckboxView["default"]({
        label: BabelStr.str(28119),
        checked: true,
        onChanged: function onChanged(checked) {
          _this.upperLowerChecked = checked;
          _this.refreshTmplName();
          if (checked) {
            _this.$(".case-select").removeClass("f-hide");
          } else {
            _this.$(".case-select").addClass("f-hide");
          }
        }
      });
      this.addSubView(this.caseBoxView, this.$(".case-checkbox")[0]);
      this.caseSelectView = new _MDDropdownSelectListView["default"]({
        dataProvider: this.caseTypeArr,
        labelField: "name",
        silentInit: false,
        onChange: function onChange(obj) {
          _this.upperLower = obj.type;
          _this.refreshTmplName();
        }
      });
      this.addSubView(this.caseSelectView, this.$(".case-select")[0]);
      this.splitBoxView = new _MDCheckboxView["default"]({
        label: BabelStr.str(28124),
        checked: true,
        onChanged: function onChanged(checked) {
          _this.hyphenChecked = checked;
          _this.refreshTmplName();
          if (checked) {
            _this.$(".split-select").removeClass("f-hide");
          } else {
            _this.$(".split-select").addClass("f-hide");
          }
        }
      });
      this.addSubView(this.splitBoxView, this.$(".split-checkbox")[0]);
      this.splitSelectView = new _MDDropdownSelectListView["default"]({
        dataProvider: this.splitTypeArr,
        labelField: "name",
        silentInit: false,
        onChange: function onChange(obj) {
          _this.hyphen = obj.type;
          _this.refreshTmplName();
        }
      });
      this.addSubView(this.splitSelectView, this.$(".split-select")[0]);
      if (this.taskRENid) {
        this.findTaskRENByFileId();
      } else {
        this.addFileNameRuleItem();
        this.$(".cur-folder-use").removeClass("f-hide");
      }
      this.initDragEvents();
    }
  }, {
    key: "findTaskRENByFileId",
    value: function findTaskRENByFileId() {
      var _this2 = this;
      MMEnterpriseController.findTaskRENByFileId(this.fileInfor.getFileId(), function (value) {
        _this2.taskData = value[0];
        _this2.allSubFolderView.setChecked(_this2.taskData.includeSub);
        _this2.curFolderUseView.setChecked(_this2.taskData.applyToOldFile);
        _this2.splitBoxView.setChecked(_this2.taskData.hyphen != -1);
        _this2.caseBoxView.setChecked(_this2.taskData.upperLower != -1);
        if (_this2.taskData.hyphen > -1) {
          _this2.splitSelectView.selectItemAt(_this2.taskData.hyphen);
        }
        if (_this2.taskData.upperLower > -1) {
          _this2.caseSelectView.selectItemAt(_this2.taskData.upperLower);
        }
        _.each(_this2.taskData.rename_rules, function (rule) {
          if (rule.type == 0 || rule.type == 7) {
            _this2.addFileNameRuleItem(rule);
          } else {
            _this2.addInsertRuleItem(rule);
          }
        });
      }, function (code, msg) {
        _this2.requesting = false;
        _MDMessageView["default"].error(msg, _this2.$body);
      });
    }
  }, {
    key: "addFileNameRuleItem",
    value: function addFileNameRuleItem(rule) {
      var _this3 = this;
      var id = this.getIncrementRuleId();
      var tmpl = _.template(this.fileNameRuleTmpl(id));
      this.$(".rule-list").append(tmpl);
      this.nameConditionSelectView = new _MDDropdownSelectListView["default"]({
        dataProvider: this.nameConditionArr,
        labelField: "name",
        silentInit: false,
        onChange: function onChange(obj) {
          _this3.nameModifyType = obj.type;
          _this3.onNameTypeChanged(obj);
          _this3.refreshTmplName();
        }
      });
      this.addSubView(this.nameConditionSelectView, this.$(".name-item .rule-select")[0]);
      this.nameDelKeyTypeSelectView = new _MDDropdownSelectListView["default"]({
        dataProvider: this.nameDelTypeArr,
        labelField: "name",
        silentInit: false,
        onChange: function onChange(obj) {
          _this3.nameModifyCharType = obj.type;
          _this3.refreshTmplName();
        }
      });
      this.addSubView(this.nameDelKeyTypeSelectView, this.$(".del-name-key-type")[0]);
      if (rule && rule.modifyRule) {
        this.nameConditionSelectView.selectItemAt(rule.modifyRule.mtype + 1);
        if (rule.modifyRule.mtype == 0) {
          this.$(".name-old-key").val(rule.modifyRule.oldStr || "");
          this.$(".name-new-key").val(rule.modifyRule.newStr || "");
        } else if (rule.modifyRule.mtype == 1) {
          this.$(".name-del-key").val(rule.modifyRule.oldStr || "");
        } else if (rule.modifyRule.mtype == 2) {
          this.nameDelKeyTypeSelectView.selectItemAt(rule.modifyRule.charType);
        }
      }
    }
  }, {
    key: "_removeRule",
    value: function _removeRule($e) {
      var $item = $($e.target).closest(".rule-item");
      var id = $item.data("id");
      _.each(this.rulesObj[id].subviews, function (view) {
        view.removeFromSuperView();
      });
      delete this.rulesObj[id];
      $item.remove();
      console.log(this.rulesObj);
      this.refreshTmplName();
    }
  }, {
    key: "addInsertRuleItem",
    value: function addInsertRuleItem(rule) {
      var _this4 = this;
      var id = this.getIncrementRuleId();
      var tmpl = _.template(this.insertRuleTmpl(id));
      this.$(".rule-list").append(tmpl);
      this.rulesObj[id] = {
        subviews: []
      };
      var $item = this.$(".rule-item[data-id=\"".concat(id, "\"]"));
      var replaceOldTimeView = new _MDCheckboxView["default"]({
        label: BabelStr.str(28118),
        checked: true,
        silentInit: false,
        onChanged: function onChanged(checked) {
          _this4.replaceOldTime = checked;
        }
      });
      this.addSubView(replaceOldTimeView, $item.find(".checkbox-slot")[0]);
      this.rulesObj[id].subviews.push(replaceOldTimeView);
      var conditionSelectView;
      var breakPoints = [];
      if (window.user.useAdvancedSearch) {
        breakPoints = [6];
      }
      conditionSelectView = new _MDDropdownSelectSplitListView["default"]({
        dataProvider: this.conditionArr,
        placeholder: BabelStr.str(28078),
        breakPoints: breakPoints,
        blockTitles: [BabelStr.str(28079), BabelStr.str(28086)],
        labelField: "name",
        silentInit: false,
        onChange: function onChange(obj) {
          _this4.onRuleTypeChanged(obj, id);
          _this4.refreshTmplName();
        }
      });
      this.addSubView(conditionSelectView, $item.find(".rule-condition-select")[0]);
      this.rulesObj[id].subviews.push(conditionSelectView);
      var timeFormatTypeSelectView = new _MDDropdownSelectListView["default"]({
        dataProvider: this.timeFormatTypeArr,
        labelField: "name",
        silentInit: false,
        onChange: function onChange(obj) {
          _this4.rulesObj[id].timeFormat = obj.type;
          _this4.refreshTmplName();
        }
      });
      this.addSubView(timeFormatTypeSelectView, $item.find(".time-format-select")[0]);
      this.rulesObj[id].subviews.push(timeFormatTypeSelectView);
      if (rule) {
        var index = _.findIndex(this.conditionArr, {
          type: rule.type
        });
        conditionSelectView.selectItemAt(index);
        if (rule.type == 1 && rule.numberRule) {
          $item.find(".number-start").val(rule.numberRule.start);
          $item.find(".number-step").val(rule.numberRule.step);
          $item.find(".number-length").val(rule.numberRule["length"]);
        } else if (rule.type == 2) {
          $item.find(".custom-string").val(rule.customString);
        } else if (rule.type == 6 || rule.type == 10) {
          var timeIndex = _.findIndex(this.timeFormatTypeArr, {
            type: rule.timeFormat
          });
          timeFormatTypeSelectView.selectItemAt(timeIndex);
          replaceOldTimeView.setChecked(rule.replaceOldTime);
        }
      }
    }
  }, {
    key: "onRuleTypeChanged",
    value: function onRuleTypeChanged(obj, id) {
      this.rulesObj[id].type = obj.type;
      this.$(".rule-item[data-id=\"".concat(id, "\"] .rule-type")).addClass("f-hide");
      if (obj.type > -1) {
        this.$(".rule-item[data-id=\"".concat(id, "\"] .rule-type.rule-type-").concat(obj.type)).removeClass("f-hide");
      }
      if (obj.type == 6 || obj.type == 10) {
        if (!this.$(".rule-item .checkbox-slot.rule-time-checkbox:not(.f-hide)").length) {
          this.$(".rule-item[data-id=\"".concat(id, "\"] .checkbox-slot.rule-time-checkbox")).removeClass("f-hide");
        }
      } else {
        this.$(".rule-item[data-id=\"".concat(id, "\"] .checkbox-slot.rule-time-checkbox")).addClass("f-hide");
      }
    }
  }, {
    key: "onNameTypeChanged",
    value: function onNameTypeChanged(obj) {
      this.$(".name-item .name-rule-type-item").addClass("f-hide");
      if (obj.type > -1) {
        this.$(".name-item .name-rule-type-item.type-".concat(obj.type)).removeClass("f-hide");
      }
    }
  }, {
    key: "_selectFolder",
    value: function _selectFolder() {
      var _this5 = this;
      var win = new _MDMoveFileWindowView["default"]({
        forChooseFolder: true,
        forMove: false,
        title: BabelStr.str(28013),
        unselectableHandle: function unselectableHandle(file) {
          if (file.getFileId().slice(0, 5) === "0--00") {
            return false;
          }
          return !(file.canManageFilePermission() || file.isOwner());
        },
        fileIntercept: function fileIntercept(file) {
          // if(file.getFileId().slice(0, 5) === "0--00") {
          //   return false
          // }
          return false;
          // return !file.canDelete();
        },
        intercept: function intercept(targetFolderId) {
          if (targetFolderId.slice(0, 5) === "0--00") {
            return {
              isOK: false,
              msg: BabelStr.str(6851)
            };
          } else {
            return {
              isOK: true
            };
          }
        },
        chooseCallback: function chooseCallback(result) {
          console.log(result);
          var file = new _MMFileInfo["default"]({
            fileId: result.id,
            fileName: result.name,
            teamMark: result.teamMark
          });
          _this5.fileInfor = file;
          _this5.renderFileInfo();
        }
      });
      win.show();
    }
  }, {
    key: "renderFileInfo",
    value: function renderFileInfo() {
      if (!this.fileInfor) {
        this.$(".folder-group").removeClass("selected");
        return;
      }
      _MMFileIconMaker["default"].setTypeIconForFileInfoNotCalcDevice(this.fileInfor, this.$(".file-thumb"), undefined, undefined, 20);
      this.$(".file-name").html(this.fileInfor.getFileName());
      this.$(".folder-group").addClass("selected");
    }
  }, {
    key: "_addRule",
    value: function _addRule() {
      this.addInsertRuleItem();
    }
  }, {
    key: "getIncrementRuleId",
    value: function getIncrementRuleId() {
      this.ruleId++;
      return "ruleid-".concat(this.ruleId);
    }
  }, {
    key: "initDragEvents",
    value: function initDragEvents() {
      var _this6 = this;
      var containers = [this.$('.rule-list')[0]];
      console.log(containers);
      dragula(containers, {
        moves: function moves(el, container, handle) {
          return handle.classList.contains('drag-handle');
        }
      }).on('dragend', function (el) {
        // this.updateCardOrder()
        _this6.refreshTmplName();
      });
    }
  }, {
    key: "_onlyNum",
    value: function _onlyNum(e) {
      // 允许：退格、删除、Tab、ESC、方向键
      if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
      // 允许：Ctrl+A, Ctrl+C, Ctrl+X
      e.keyCode === 65 && e.ctrlKey === true || e.keyCode === 67 && e.ctrlKey === true || e.keyCode === 88 && e.ctrlKey === true ||
      // 允许：数字键
      e.keyCode >= 48 && e.keyCode <= 57) {
        return;
      }
      e.preventDefault();
      var value = $(e.target).val();
      var num = parseInt(value, 10);
      // 检查范围
      if (num < 0) {
        $(e.target).val(0);
      } else if (num > 99999) {
        $(e.target).val(99999);
      }
    }
  }, {
    key: "_saveClicked",
    value: function _saveClicked() {
      var _this7 = this;
      var validator = this.$("form").validate();
      if (!validator.form()) {
        console.error("验证失败了");
        return;
      }
      if (!this.fileInfor) {
        _MDMessageView["default"].error(BabelStr.str(4780), this.$body);
        return;
      }
      console.log("验证通过了");
      var params = this.getResultParams();
      console.log(params);
      // if(this.requesting) {
      //   return
      // }
      // this.requesting = true
      // console.log("验证通过了");

      MMEnterpriseController.insertUpdateTaskREN(params, function (value) {
        _this7.requesting = false;
        _this7.close();
        if (!_this7.taskData) {
          _this7.fileInfor.set("taskRENid", value[0]._id);
          Dispatcher.trigger(MDEvents.TaskCreated, {
            fileId: _this7.fileInfor.getFileId(),
            taskRENid: value[0]._id
          });
        }
        _MDSnackbarView["default"].show(BabelStr.str(308));
      }, function (code, msg) {
        _this7.requesting = false;
        _MDMessageView["default"].error(msg, _this7.$body);
      });
    }
  }, {
    key: "refreshTmplName",
    value: function refreshTmplName() {
      var _this8 = this;
      if (this.refreshTmplNameTimer) {
        clearTimeout(this.refreshTmplNameTimer);
      }
      this.refreshTmplNameTimer = setTimeout(function () {
        var params = _this8.getResultParams();
        var name = _this8.tempFileName;
        var out = [];
        var split = "";
        if (params.hyphen == 1) {
          split = "_";
        } else if (params.hyphen == 2) {
          split = "-";
        }
        for (var i = 0; i < params.rename_rules.length; i++) {
          var rule = params.rename_rules[i];
          if (rule.type == 0) {
            out.push(name);
          } else if (rule.type == 1) {
            if (!_.isNaN(rule.numberRule.start) && !_.isNaN(rule.numberRule.length)) {
              out.push(rule.numberRule.start.toString().padStart(rule.numberRule.length, '0'));
            }
          } else if (rule.type == 2) {
            out.push(rule.customString);
          } else if (rule.type == 3) {
            out.push(BabelStr.str(28082));
          } else if (rule.type == 4) {
            out.push(BabelStr.str(28083));
          } else if (rule.type == 5) {
            out.push(BabelStr.str(28084));
          } else if (rule.type == 6 || rule.type == 10) {
            out.push(_this8.getTimeStr(rule.timeFormat));
          } else if (rule.type == 11) {
            out.push(BabelStr.str(28088));
          } else if (rule.type == 12) {
            out.push(BabelStr.str(28089));
          } else if (rule.type == 13) {
            out.push(BabelStr.str(28090));
          } else if (rule.type == 14) {
            out.push(BabelStr.str(28091));
          } else if (rule.type == 15) {
            out.push(BabelStr.str(28092));
          } else if (rule.type == 16) {
            out.push(BabelStr.str(28093));
          } else if (rule.type == 7) {
            name = name.replace(rule.modifyRule.oldStr || "", rule.modifyRule.newStr || "");
            out.push(name);
          }
        }
        out = out.join(split);
        if (params.upperLower > -1) {
          out = _this8.transformString(out, params.upperLower);
        }
        out += ".pdf";
        _this8.$(".temp-file-name").html(out);
        _this8.refreshTmplNameTimer = undefined;
      }, 400);
    }
  }, {
    key: "transformString",
    value: function transformString(str, type) {
      switch (type) {
        case '首字母大写':
          if (str.length === 0) return str;
          return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        case '首字母小写':
          if (str.length === 0) return str;
          return str.charAt(0).toLowerCase() + str.slice(1);
        case '全部大写':
          return str.toUpperCase();
        case '全部小写':
          return str.toLowerCase();
        default:
          return str;
        // 如果没有匹配的 type，返回原始字符串
      }
    }
  }, {
    key: "getTimeStr",
    value: function getTimeStr(type) {
      var pattern;
      switch (type) {
        case 0:
          pattern = "yyyy-MM-dd";
          break;
        case 1:
          pattern = "yyyy-MM";
          break;
        case 2:
          pattern = "yyyyMMdd";
          break;
        case 3:
          pattern = "yyyy-MM-dd-HH.mm";
          break;
        case 4:
          pattern = "yyyyMMdd-HH.mm";
          break;
        case 5:
          pattern = "MM-dd-HH.mm.ss";
          break;
      }
      var time = new Date().format(pattern);
      return time;
    }
  }, {
    key: "getResultParams",
    value: function getResultParams() {
      var params = {
        fileId: this.fileInfor && this.fileInfor.getFileId(),
        includeSub: this.includeSub,
        hyphen: this.hyphenChecked ? this.hyphen : -1,
        upperLower: this.upperLowerChecked ? this.upperLower : -1,
        rename_rules: this.getReanmeRule()
      };
      if (!this.taskRENid) {
        params.applyToOldFile = this.applyToOldFile;
      }
      return params;
    }
  }, {
    key: "getReanmeRule",
    value: function getReanmeRule() {
      var rename_rules = [];
      var $ruleItems = this.$(".rule-item");
      for (var i = 0; i < $ruleItems.length; i++) {
        var $item = $ruleItems.eq(i);
        var id = $item.data("id");
        var rule = {};
        if ($item.hasClass("name-item")) {
          var nameModifyType = this.nameModifyType;
          if (nameModifyType == -1) {
            rule = {
              type: 0
            };
          } else if (nameModifyType == 0) {
            rule = {
              type: 7,
              modifyRule: {
                mtype: nameModifyType,
                oldStr: this.$(".name-old-key").val(),
                newStr: this.$(".name-new-key").val()
              }
            };
          } else if (nameModifyType == 1) {
            rule = {
              type: 7,
              modifyRule: {
                mtype: nameModifyType,
                oldStr: this.$(".name-del-key").val()
              }
            };
          } else if (nameModifyType == 2) {
            rule = {
              type: 7,
              modifyRule: {
                mtype: nameModifyType,
                charType: this.nameModifyCharType
              }
            };
          }
          rename_rules.push(rule);
        } else {
          var ruleObj = this.rulesObj[id];
          var type = ruleObj.type;
          if (type == -1) {
            continue;
          }
          rule = {
            type: type
          };
          var _$item = this.$(".rule-item[data-id=\"".concat(id, "\"]"));
          if (type == 1) {
            rule.numberRule = {
              start: parseInt(_$item.find(".number-start").val().trim()),
              step: parseInt(_$item.find(".number-step").val().trim()),
              length: parseInt(_$item.find(".number-length").val().trim())
            };
          } else if (type == 2) {
            rule.customString = _$item.find(".custom-string").val().trim();
          } else if (type == 6 || type == 10) {
            rule.timeFormat = ruleObj.timeFormat;
            rule.replaceOldTime = this.replaceOldTime;
          }
          rename_rules.push(rule);
        }
      }
      return rename_rules;
    }
  }, {
    key: "_delTask",
    value: function _delTask() {
      var _this9 = this;
      if (this.requesting) {
        return;
      }
      this.requesting = true;
      _MDAlertView["default"].showStandardSelection({
        message: BabelStr.str(28069),
        cancelFun: function cancelFun() {
          _this9.requesting = false;
        },
        okFun: function okFun() {
          _this9.delTask();
        }
      });
    }
  }, {
    key: "delTask",
    value: function delTask() {
      var _this10 = this;
      MMEnterpriseController.delTaskRENByFileId(this.fileInfor.getFileId(), function () {
        _this10.fileInfor.set("taskRENid", null);
        _this10.close();
        _MDSnackbarView["default"].show(BabelStr.str(308));
      }, function (code, msg) {
        _this10.requesting = false;
        _MDMessageView["default"].error(msg, _this10.$body);
      });
    }
  }], [{
    key: "className",
    value: function className() {
      return "MDAutoRenameCreateWinView";
    }
  }]);
  return MDAutoRenameCreateWinView;
}(_MDWindowView2["default"]);

},{"1119":1119,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1416":1416,"1417":1417,"1424":1424,"1429":1429,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1466":1466,"1475":1475,"1477":1477,"1478":1478,"1490":1490,"1492":1492,"1498":1498,"1541":1541,"296":296,"297":297,"32":32,"37":37,"508":508,"55":55,"67":67,"68":68,"72":72,"93":93}],536:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1417);
require(1463);
require(1429);
require(1439);
require(1423);
require(1480);
require(1487);
require(1538);
require(1498);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDCheckboxView = _interopRequireDefault(require(37));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MDDropdownSelectSplitListView = _interopRequireDefault(require(68));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MMFileIconMaker = _interopRequireDefault(require(296));
var _MMFileInfo = _interopRequireDefault(require(297));
var _menusvg = _interopRequireDefault(require(1119));
var _MDMoveFileWindowView = _interopRequireDefault(require(508));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDAutoOrganizeCreateWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDAutoOrganizeCreateWinView, _MDWindowView);
  function MDAutoOrganizeCreateWinView() {
    (0, _classCallCheck2["default"])(this, MDAutoOrganizeCreateWinView);
    return _callSuper(this, MDAutoOrganizeCreateWinView, arguments);
  }
  (0, _createClass2["default"])(MDAutoOrganizeCreateWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n      <div class=\"section\">\n        <%if(taskORGid){%>\n          <div class=\"flex-align between middle mgb-10\">\n            <div class=\"section-title\"><%=BabelStr.str(28062)%></div>\n            <div class=\"f-pointer red del-task no-shrink\"><%=BabelStr.str(28063)%></div>\n          </div>\n\n          <div class=\"file-item flex-align middle mgb-10\">\n            <div class=\"file-thumb root no-shrink\"></div>\n            <div class=\"file-name text-hide\"></div>\n          </div>\n        <%} else {%>\n          <div class=\"section-title mgb-10\"><%=BabelStr.str(28013)%></div>\n          <div class=\"folder-group for-all-folder-group mgb-10\">\n              <div class=\"has-selected  flex-align between middle\">\n                <div class=\"file-item flex-align middle\">\n                  <div class=\"file-thumb root no-shrink\"></div>\n                  <div class=\"file-name text-hide\"></div>\n                </div>\n                <div class=\"text-button done select-folder no-shrink\"><%=BabelStr.str(28019)%></div>\n              </div>\n              <div class=\"no-selected\">\n                <div class=\"text-button done select-folder\"><%=BabelStr.str(28014)%></div>\n              </div>\n          </div>\n        <%}%>\n        <div class=\"checkbox-group all-folder flex-align middle with-wrap gap-10 mgb-10\">\n            <div class=\"checkbox-slot\"></div>\n            <div class=\"info-desc\"><%=BabelStr.str(28162)%></div>\n        </div>\n        <div class=\"checkbox-group cur-folder-use f-hide flex-align middle with-wrap gap-10 mgb-10\">\n          <div class=\"checkbox-slot\"></div>\n          <div class=\"info-desc\"><%=BabelStr.str(28075)%></div>\n        </div>\n    </div>\n\n    <div class=\"split-line mgb-10\"></div>\n\n    <div class=\"section mgtb-10\">\n      <div class=\"section-title mgb-10\"><%=BabelStr.str(28017)%></div>\n      <div class=\"select-contain\">\n      </div>\n    </div>\n    <div class=\"section mgtb-10\">\n      <div class=\"section-title mgb-10\"><%=BabelStr.str(28132)%></div>\n      <div class=\"organize-type-select-contain mgb-10\">\n      </div>\n    </div>\n\n    <div class=\"key-block mgb-10 for-type-2\">\n      <div class=\"info-desc\"><%=BabelStr.str(28139)%></div>\n    </div>\n\n    <form class=\"rule-list mgb-10 for-type-2\"></form>\n\n    <div class=\"mgb-10 flex-align for-type-2\">\n      <div class=\"add-rule flex-align middle \">\n        <div class=\"add-ic icon\"></div>\n        <div><%=BabelStr.str(28140)%></div>\n      </div>\n    </div>\n    <div class=\"split-line mgb-10 for-type-2\"></div>\n    ";
    }
  }, {
    key: "insertRuleTmpl",
    value: function insertRuleTmpl(id) {
      return "<div class=\"rule-item mgb-10\" data-id=\"".concat(id, "\">\n      <div class=\"flex-align start gap-10 \">\n        <div class=\"fullfill \">\n          <input name=\"key-rule-").concat(id, "\" class=\"form-control key-rule\" required placeholder=\"<%=BabelStr.str(28143)%>\" />\n        </div>\n        <span class=\"no-shrink item-txt\"><%=BabelStr.str(28141)%></span>\n        <div class=\"fullfill folder-group-block\">\n          <div class=\"folder-group flex-align between middle fullfill\">\n            <div class=\"file-item flex-align middle\">\n              <div class=\"file-thumb no-shrink\"></div>\n              <div class=\"file-name text-hide\"><%=BabelStr.str(28144)%></div>\n            </div>\n            <div class=\"text-button done select-item-folder no-shrink\"><%=BabelStr.str(28142)%></div>\n            <div class=\"text-button done change-folder \"><%=BabelStr.str(28019)%></div>\n          </div>\n          <p id=\"key-rule-").concat(id, "-error\" class=\"error-msg\"><%=BabelStr.str(28145)%></p>\n        </div>\n        <span class=\"no-shrink ope-btn remove-rule\">\n          ").concat(_menusvg["default"].menu_tool_remove, "\n        </span>\n      </div>\n    </div>\n    ");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var props = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAutoOrganizeCreateWinView.prototype), "initProps", this).call(this);
      return _.extend(props, {
        conditionArr: [{
          type: 0,
          name: BabelStr.str(28021)
        }],
        organizeConditionArr: [
        // { type: -1, name: BabelStr.str(28132), desc: "" },
        {
          type: 0,
          name: BabelStr.str(28133),
          desc: BabelStr.str(28134)
        }, {
          type: 1,
          name: BabelStr.str(28135),
          desc: BabelStr.str(28136)
        }, {
          type: 2,
          name: BabelStr.str(28137),
          desc: BabelStr.str(28138)
        }],
        rulesObj: {},
        ruleId: 0,
        hyphen: -1,
        hyphenChecked: true,
        upperLower: -1,
        upperLowerChecked: true,
        applyToOldFile: true,
        includeSub: true,
        replaceOldTime: true,
        tempFileName: BabelStr.str(28076)
      });
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        taskORGid: this.taskORGid,
        tempFileName: this.tempFileName
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAutoOrganizeCreateWinView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAutoOrganizeCreateWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " auto-originize-create-win task-create-win");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAutoOrganizeCreateWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .select-folder": this._selectFolder,
        "click .select-item-folder": this._selectItemFolder,
        "click .change-folder": this._selectItemFolder,
        "click .add-rule": this._addRule,
        "click .remove-rule": this._removeRule,
        "click .del-task": this._delTask,
        "submit form": this.noSubmit
      });
    }
  }, {
    key: "noSubmit",
    value: function noSubmit(e) {
      e.preventDefault(); // 阻止表单提交
      console.log("表单已拦截，执行自定义逻辑");
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      if (props.taskORGid) {
        props.title = BabelStr.str(28131);
      } else {
        props.title = BabelStr.str(28129);
      }
      props.size = "large";
      props.buttons = [{
        label: BabelStr.str(3081),
        type: "default"
      }, {
        label: BabelStr.str(3080),
        type: "done",
        autoClose: false,
        onClick: function onClick(button, $e) {
          this._saveClicked();
        }
      }];
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAutoOrganizeCreateWinView.prototype), "initialize", this).call(this, props);
      this.renderFileInfo();
      this.allSubFolderView = new _MDCheckboxView["default"]({
        label: BabelStr.str(28015),
        checked: this.includeSub,
        onChanged: function onChanged(checked) {
          _this.includeSub = checked;
        }
      });
      this.addSubView(this.allSubFolderView, this.$(".all-folder .checkbox-slot")[0]);
      this.curFolderUseView = new _MDCheckboxView["default"]({
        label: BabelStr.str(28074),
        checked: this.applyToOldFile,
        onChanged: function onChanged(checked) {
          _this.applyToOldFile = checked;
        }
      });
      this.addSubView(this.curFolderUseView, this.$(".cur-folder-use .checkbox-slot")[0]);
      if (this.taskORGid) {
        this.findTaskORGByFileId();
      } else {
        this.addInsertRuleItem();
        this.$(".cur-folder-use").removeClass("f-hide");
      }
      this.conditionSelectView = new _MDDropdownSelectListView["default"]({
        dataProvider: this.conditionArr,
        labelField: "name",
        silentInit: false,
        onChange: function onChange(obj) {
          // this.onTaskTypeChanged(obj);
        }
      });
      this.addSubView(this.conditionSelectView, this.$(".select-contain")[0]);
      this.organizeTypeConditionSelectView = new _MDDropdownSelectListView["default"]({
        dataProvider: this.organizeConditionArr,
        labelField: "name",
        silentInit: false,
        onChange: function onChange(obj) {
          _this.onTaskTypeChanged(obj);
          _this.keyRuleType = obj.type;
        }
      });
      this.addSubView(this.organizeTypeConditionSelectView, this.$(".organize-type-select-contain")[0]);
    }
  }, {
    key: "onTaskTypeChanged",
    value: function onTaskTypeChanged(obj) {
      if (obj.type == 2) {
        this.$(".for-type-2").removeClass("f-hide");
      } else {
        this.$(".for-type-2").addClass("f-hide");
      }
    }
  }, {
    key: "findTaskORGByFileId",
    value: function findTaskORGByFileId() {
      var _this2 = this;
      MMEnterpriseController.findTaskORGByFileId(this.fileInfor.getFileId(), function (value) {
        _this2.taskData = value[0];
        _this2.allSubFolderView.setChecked(_this2.taskData.includeSub);
        _this2.curFolderUseView.setChecked(_this2.taskData.applyToOldFile);
        var rule = _this2.taskData.org_rules[0];
        _this2.organizeTypeConditionSelectView.selectItemAt(rule.type);
        if (rule.type == 2) {
          _.each(rule.keyRules, function (item) {
            _this2.addInsertRuleItem(item);
          });
        }
      }, function (code, msg) {
        _this2.requesting = false;
        _MDMessageView["default"].error(msg, _this2.$body);
      });
    }
  }, {
    key: "_removeRule",
    value: function _removeRule($e) {
      var $item = $($e.target).closest(".rule-item");
      var id = $item.data("id");
      _.each(this.rulesObj[id].subviews, function (view) {
        view.removeFromSuperView();
      });
      delete this.rulesObj[id];
      $item.remove();
      console.log(this.rulesObj);
    }
  }, {
    key: "addInsertRuleItem",
    value: function addInsertRuleItem(rule) {
      var id = this.getIncrementRuleId();
      var tmpl = _.template(this.insertRuleTmpl(id));
      this.$(".rule-list").append(tmpl);
      this.rulesObj[id] = {
        subviews: []
      };
      var $item = this.$(".rule-item[data-id=\"".concat(id, "\"]"));
      var file = new _MMFileInfo["default"]();
      _MMFileIconMaker["default"].setTypeIconForFileInfoNotCalcDevice(file, $item.find(".file-thumb"), undefined, undefined, 20);
      if (rule) {
        $item.find(".key-rule").val(rule.key);
        $item.find(".file-name").html(rule.fileName);
        this.rulesObj[id].targetFileId = rule.targetFileId;
      }
    }
  }, {
    key: "_selectFolder",
    value: function _selectFolder() {
      var _this3 = this;
      var win = new _MDMoveFileWindowView["default"]({
        forChooseFolder: true,
        forMove: false,
        title: BabelStr.str(28013),
        unselectableHandle: function unselectableHandle(file) {
          if (file.getFileId().slice(0, 5) === "0--00") {
            return false;
          }
          return !(file.canManageFilePermission() || file.isOwner());
        },
        fileIntercept: function fileIntercept(file) {
          // if(file.getFileId().slice(0, 5) === "0--00") {
          //   return false
          // }
          return false;
          // return !file.canDelete();
        },
        intercept: function intercept(targetFolderId) {
          if (targetFolderId.slice(0, 5) === "0--00") {
            return {
              isOK: false,
              msg: BabelStr.str(6851)
            };
          } else {
            return {
              isOK: true
            };
          }
        },
        chooseCallback: function chooseCallback(result) {
          console.log(result);
          var file = new _MMFileInfo["default"]({
            fileId: result.id,
            fileName: result.name,
            teamMark: result.teamMark
          });
          _this3.fileInfor = file;
          _this3.renderFileInfo();
        }
      });
      win.show();
    }
  }, {
    key: "_selectItemFolder",
    value: function _selectItemFolder($e) {
      var _this4 = this;
      var $item = $($e.target).closest(".rule-item");
      var id = $item.data("id");
      var win = new _MDMoveFileWindowView["default"]({
        forChooseFolder: true,
        forMove: false,
        title: BabelStr.str(28013),
        unselectableHandle: function unselectableHandle(file) {
          return !file.canUpload();
        },
        fileIntercept: function fileIntercept(file) {
          if (_this4.fileInfor && !_this4.fileInfor.isOwner() && file.isOwner()) {
            return true;
          }
          return false;
          // return !file.canDelete();
        },
        intercept: function intercept(targetFolderId) {
          if (targetFolderId.slice(0, 5) === "0--00") {
            return {
              isOK: false,
              msg: BabelStr.str(6851)
            };
          } else {
            return {
              isOK: true
            };
          }
        },
        chooseCallback: function chooseCallback(result) {
          console.log(result);
          var file = new _MMFileInfo["default"]({
            fileId: result.id,
            fileName: result.name,
            teamMark: result.teamMark
          });
          _this4.rulesObj[id].targetFileId = result.id;
          _this4.renderItemFileInfo(file, $item);
        }
      });
      win.show();
    }
  }, {
    key: "renderFileInfo",
    value: function renderFileInfo() {
      if (!this.fileInfor) {
        this.$(".folder-group.for-all-folder-group").removeClass("selected");
        return;
      }
      _MMFileIconMaker["default"].setTypeIconForFileInfoNotCalcDevice(this.fileInfor, this.$(".for-all-folder-group .file-thumb.root"), undefined, undefined, 20);
      this.$(".for-all-folder-group .file-name").html(this.fileInfor.getFileName());
      this.$(".folder-group.for-all-folder-group").addClass("selected");
    }
  }, {
    key: "renderItemFileInfo",
    value: function renderItemFileInfo(file, $item) {
      if (!file) {
        $item.find(".folder-group").removeClass("has-selected");
        return;
      }
      $item.find(".folder-group-block").removeClass("error");
      _MMFileIconMaker["default"].setTypeIconForFileInfoNotCalcDevice(file, $item.find(".file-thumb"), undefined, undefined, 20);
      $item.find(".file-name").html(file.getFileName());
      $item.find(".folder-group").addClass("has-selected");
    }
  }, {
    key: "_addRule",
    value: function _addRule() {
      this.addInsertRuleItem();
    }
  }, {
    key: "getIncrementRuleId",
    value: function getIncrementRuleId() {
      this.ruleId++;
      return "ruleid-".concat(this.ruleId);
    }
  }, {
    key: "_saveClicked",
    value: function _saveClicked() {
      var _this5 = this;
      var validator = this.$("form").validate();
      var validate = validator.form();
      if (this.keyRuleType == 2) {
        var $ruleItems = this.$(".rule-item");
        for (var i = 0; i < $ruleItems.length; i++) {
          var $item = $ruleItems.eq(i);
          var id = $item.data("id");
          if (!this.rulesObj[id].targetFileId) {
            $item.find(".folder-group-block").addClass("error");
            validate = false;
          }
        }
      }
      if (!validate) {
        console.error("验证失败了");
        return;
      }
      if (!this.fileInfor) {
        _MDMessageView["default"].error(BabelStr.str(4780), this.$body);
        return;
      }
      console.log("验证通过了");
      var params = this.getResultParams();
      console.log(params);
      var orgRule = params.org_rules[0];
      if (orgRule.type == 2) {
        var keyRules = orgRule.keyRules;
        var keySet = new Set();
        for (var _i = 0; _i < keyRules.length; _i++) {
          var element = keyRules[_i];
          keySet.add(element.key);
        }
        if (keyRules.length != keySet.size) {
          _MDMessageView["default"].error(BabelStr.str(28146), this.$body);
          return;
        }
      }
      // return
      if (this.requesting) {
        return;
      }
      this.requesting = true;
      console.log("验证通过了");
      MMEnterpriseController.insertUpdateTaskORG(params, function (value) {
        _this5.requesting = false;
        _this5.close();
        if (!_this5.taskData) {
          _this5.fileInfor.set("taskORGid", value[0]._id);
          Dispatcher.trigger(MDEvents.TaskCreated, {
            fileId: _this5.fileInfor.getFileId(),
            taskORGid: value[0]._id
          });
        }
        _MDSnackbarView["default"].show(BabelStr.str(308));
      }, function (code, msg) {
        _this5.requesting = false;
        if (code == 12) {
          msg = BabelStr.str(28165);
        }
        _MDMessageView["default"].error(msg, _this5.$body);
      });
    }
  }, {
    key: "getResultParams",
    value: function getResultParams() {
      var params = {
        fileId: this.fileInfor && this.fileInfor.getFileId(),
        includeSub: this.includeSub,
        org_rules: this.getOrgRules()
      };
      if (!this.taskORGid) {
        params.applyToOldFile = this.applyToOldFile;
      }
      return params;
    }
  }, {
    key: "getOrgRules",
    value: function getOrgRules() {
      var org_rule = {
        type: this.keyRuleType
      };
      if (this.keyRuleType == 2) {
        var $ruleItems = this.$(".rule-item");
        org_rule.keyRules = [];
        for (var i = 0; i < $ruleItems.length; i++) {
          var $item = $ruleItems.eq(i);
          var id = $item.data("id");
          var rule = {};
          rule.key = $item.find(".key-rule").val().trim();
          rule.targetFileId = this.rulesObj[id].targetFileId;
          org_rule.keyRules.push(rule);
        }
      }
      return [org_rule];
    }
  }, {
    key: "_delTask",
    value: function _delTask() {
      var _this6 = this;
      if (this.requesting) {
        return;
      }
      this.requesting = true;
      _MDAlertView["default"].showStandardSelection({
        message: BabelStr.str(28069),
        cancelFun: function cancelFun() {
          _this6.requesting = false;
        },
        okFun: function okFun() {
          _this6.delTask();
        }
      });
    }
  }, {
    key: "delTask",
    value: function delTask() {
      var _this7 = this;
      MMEnterpriseController.delTaskORGByFileId(this.fileInfor.getFileId(), function () {
        _this7.fileInfor.set("taskORGid", null);
        _this7.close();
        _MDSnackbarView["default"].show(BabelStr.str(308));
      }, function (code, msg) {
        _this7.requesting = false;
        _MDMessageView["default"].error(msg, _this7.$body);
      });
    }
  }], [{
    key: "className",
    value: function className() {
      return "MDAutoOrganizeCreateWinView";
    }
  }]);
  return MDAutoOrganizeCreateWinView;
}(_MDWindowView2["default"]); // MMNetDiskDataController.request("netDrive.autoTaskHandler.insertUpdateTaskORG",
// {
//   fileId: 5190262340166014,
//   includeSub: true,
//   applyToOldFile: true,
//     // rule: {
//     //     type: Number,       // 0 - 按年分类）
//     //                              1 - 按月分类 2 - 按关键字分类
//     //     keyRules: {        // type = 2 有效,可以设置多个
//     //         key: String,   // 关键字
//     //         targetFileId: String,   // 目标文件夹的ID
//     //      },
//     // },
//   org_rules: [
//     {type: 0}  // 按年分类
//   ]
// },
// function (res) {
//   console.log(res)
// },
// function name(params) {
//   console.error(params)
// })

},{"1119":1119,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1417":1417,"1423":1423,"1429":1429,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"1480":1480,"1487":1487,"1498":1498,"1538":1538,"296":296,"297":297,"32":32,"37":37,"508":508,"55":55,"67":67,"68":68,"72":72,"93":93}],535:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1429);
require(1439);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDCheckboxView = _interopRequireDefault(require(37));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MDDropdownSelectSplitListView = _interopRequireDefault(require(68));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MMFileIconMaker = _interopRequireDefault(require(296));
var _MMFileInfo = _interopRequireDefault(require(297));
var _menusvg = _interopRequireDefault(require(1119));
var _MDMoveFileWindowView = _interopRequireDefault(require(508));
var _MDConvertTypeDropDownView = _interopRequireDefault(require(538));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDAutoConvertCreateWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDAutoConvertCreateWinView, _MDWindowView);
  function MDAutoConvertCreateWinView() {
    (0, _classCallCheck2["default"])(this, MDAutoConvertCreateWinView);
    return _callSuper(this, MDAutoConvertCreateWinView, arguments);
  }
  (0, _createClass2["default"])(MDAutoConvertCreateWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n      <div class=\"section\">\n        <div class=\"section-title mgb-10\"><%=BabelStr.str(28147)%></div>\n        <%if(taskCONid){%>\n          <div class=\"flex-align between middle mgb-10\">\n            <div class=\"section-title\"><%=BabelStr.str(28062)%></div>\n            <div class=\"f-pointer red del-task no-shrink\"><%=BabelStr.str(28063)%></div>\n          </div>\n\n          <div class=\"file-item flex-align middle mgb-10\">\n            <div class=\"file-thumb root no-shrink\"></div>\n            <div class=\"file-name text-hide\"></div>\n          </div>\n        <%} else {%>\n\n          <div class=\"folder-group mgb-10\">\n              <div class=\"has-selected  flex-align between middle\">\n                <div class=\"file-item flex-align middle\">\n                  <div class=\"file-thumb root no-shrink\"></div>\n                  <div class=\"file-name text-hide\"></div>\n                </div>\n                <div class=\"text-button done select-folder no-shrink\"><%=BabelStr.str(28019)%></div>\n              </div>\n              <div class=\"no-selected\">\n                <div class=\"text-button done select-folder\"><%=BabelStr.str(28014)%></div>\n              </div>\n          </div>\n        <%}%>\n        <div class=\"checkbox-group all-folder flex-align middle with-wrap gap-10 mgb-10\">\n            <div class=\"checkbox-slot\"></div>\n            <div class=\"info-desc\"><%=BabelStr.str(28162)%></div>\n        </div>\n        <div class=\"checkbox-group cur-folder-use f-hide flex-align middle with-wrap gap-10 mgb-10\">\n          <div class=\"checkbox-slot\"></div>\n          <div class=\"info-desc\"><%=BabelStr.str(28075)%></div>\n        </div>\n    </div>\n\n    <div class=\"split-line mgb-10\"></div>\n\n    <div class=\"section mgtb-10\">\n      <div class=\"section-title mgb-10\"><%=BabelStr.str(28150)%></div>\n      <div class=\"flex-align mgb-10 middle gap-10\">\n        <div class=\"select-contain\">\n        </div>\n        <div><%=BabelStr.str(28152)%></div>\n      </div>\n      <div class=\"info-desc\"><%=BabelStr.str(28153)%></div>\n    </div>\n    <div class=\"del-origin-checkbox\"></div>\n    ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var props = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAutoConvertCreateWinView.prototype), "initProps", this).call(this);
      return _.extend(props, {
        applyToOldFile: true,
        includeSub: true,
        remove_original: true,
        replaceOldTime: true
      });
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        taskCONid: this.taskCONid
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAutoConvertCreateWinView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAutoConvertCreateWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " auto-convert-create-win task-create-win");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAutoConvertCreateWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .select-folder": this._selectFolder,
        "click .select-item-folder": this._selectItemFolder,
        "click .add-rule": this._addRule,
        "click .remove-rule": this._removeRule,
        "click .del-task": this._delTask
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      if (props.taskCONid) {
        props.title = BabelStr.str(28149);
      } else {
        props.title = BabelStr.str(28148);
      }
      props.size = "large";
      props.buttons = [{
        label: BabelStr.str(3081),
        type: "default"
      }, {
        label: BabelStr.str(3080),
        type: "done",
        autoClose: false,
        onClick: function onClick(button, $e) {
          this._saveClicked();
        }
      }];
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAutoConvertCreateWinView.prototype), "initialize", this).call(this, props);
      this.renderFileInfo();
      this.allSubFolderView = new _MDCheckboxView["default"]({
        label: BabelStr.str(28015),
        checked: this.includeSub,
        onChanged: function onChanged(checked) {
          _this.includeSub = checked;
        }
      });
      this.addSubView(this.allSubFolderView, this.$(".all-folder .checkbox-slot")[0]);
      this.curFolderUseView = new _MDCheckboxView["default"]({
        label: BabelStr.str(28074),
        checked: this.applyToOldFile,
        onChanged: function onChanged(checked) {
          _this.applyToOldFile = checked;
        }
      });
      this.addSubView(this.curFolderUseView, this.$(".cur-folder-use .checkbox-slot")[0]);
      this.conditionSelectView = new _MDConvertTypeDropDownView["default"]({
        placeholder: BabelStr.str(28150)
      });
      this.addSubView(this.conditionSelectView, this.$(".select-contain")[0]);
      if (this.taskCONid) {
        this.findTaskCONByFileId();
      } else {
        this.$(".cur-folder-use").removeClass("f-hide");
        this.conditionSelectView.initSelectAll();
      }
      this.delOriginView = new _MDCheckboxView["default"]({
        label: BabelStr.str(28154),
        checked: this.remove_original,
        onChanged: function onChanged(checked) {
          _this.remove_original = checked;
        }
      });
      this.addSubView(this.delOriginView, this.$(".del-origin-checkbox")[0]);
    }
  }, {
    key: "onTaskTypeChanged",
    value: function onTaskTypeChanged(obj) {
      if (obj.type == 2) {
        this.$(".for-type-2").removeClass("f-hide");
      } else {
        this.$(".for-type-2").addClass("f-hide");
      }
    }
  }, {
    key: "findTaskCONByFileId",
    value: function findTaskCONByFileId() {
      var _this2 = this;
      MMEnterpriseController.findTaskCONByFileId(this.fileInfor.getFileId(), function (value) {
        _this2.taskData = value[0];
        _this2.allSubFolderView.setChecked(_this2.taskData.includeSub);
        _this2.curFolderUseView.setChecked(_this2.taskData.applyToOldFile);
        _this2.delOriginView.setChecked(_this2.taskData.remove_original);
        _this2.source_filetypes = _this2.taskData.source_filetypes;
        _this2.conditionSelectView.setSelectTypes(_this2.source_filetypes);
      }, function (code, msg) {
        _this2.requesting = false;
        _MDMessageView["default"].error(msg, _this2.$body);
      });
    }
  }, {
    key: "_selectFolder",
    value: function _selectFolder() {
      var _this3 = this;
      var win = new _MDMoveFileWindowView["default"]({
        forChooseFolder: true,
        forMove: false,
        title: BabelStr.str(28013),
        unselectableHandle: function unselectableHandle(file) {
          if (file.getFileId().slice(0, 5) === "0--00") {
            return false;
          }
          return !(file.canManageFilePermission() || file.isOwner());
        },
        fileIntercept: function fileIntercept(file) {
          // if(file.getFileId().slice(0, 5) === "0--00") {
          //   return false
          // }
          return false;
          // return !file.canDelete();
        },
        intercept: function intercept(targetFolderId) {
          if (targetFolderId.slice(0, 5) === "0--00") {
            return {
              isOK: false,
              msg: BabelStr.str(6851)
            };
          } else {
            return {
              isOK: true
            };
          }
        },
        chooseCallback: function chooseCallback(result) {
          console.log(result);
          var file = new _MMFileInfo["default"]({
            fileId: result.id,
            fileName: result.name,
            teamMark: result.teamMark
          });
          _this3.fileInfor = file;
          _this3.renderFileInfo();
        }
      });
      win.show();
    }
  }, {
    key: "renderFileInfo",
    value: function renderFileInfo() {
      if (!this.fileInfor) {
        this.$(".folder-group").removeClass("selected");
        return;
      }
      _MMFileIconMaker["default"].setTypeIconForFileInfoNotCalcDevice(this.fileInfor, this.$(".file-thumb.root"), undefined, undefined, 20);
      this.$(".file-name").html(this.fileInfor.getFileName());
      this.$(".folder-group").addClass("selected");
    }
  }, {
    key: "_saveClicked",
    value: function _saveClicked() {
      var _this4 = this;
      if (!this.fileInfor) {
        _MDMessageView["default"].error(BabelStr.str(4780), this.$body);
        return;
      }
      console.log("验证通过了");
      var params = this.getResultParams();
      console.log(params);
      if (!params.source_filetypes.length) {
        _MDMessageView["default"].error(BabelStr.str(28161), this.$body);
        return;
      }
      // return
      // return
      if (this.requesting) {
        return;
      }
      this.requesting = true;
      console.log("验证通过了");
      MMEnterpriseController.insertUpdateTaskCON(params, function (value) {
        _this4.requesting = false;
        _this4.close();
        if (!_this4.taskData) {
          _this4.fileInfor.set("taskCONid", value[0]._id);
          Dispatcher.trigger(MDEvents.TaskCreated, {
            fileId: _this4.fileInfor.getFileId(),
            taskCONid: value[0]._id
          });
        }
        _MDSnackbarView["default"].show(BabelStr.str(308));
      }, function (code, msg) {
        _this4.requesting = false;
        _MDMessageView["default"].error(msg, _this4.$body);
      });
    }
  }, {
    key: "getResultParams",
    value: function getResultParams() {
      var params = {
        fileId: this.fileInfor && this.fileInfor.getFileId(),
        includeSub: this.includeSub,
        remove_original: this.remove_original,
        target_type: "pdf",
        source_filetypes: this.conditionSelectView.getSelectTypes()
      };
      if (!this.taskCONid) {
        params.applyToOldFile = this.applyToOldFile;
      }
      return params;
    }
  }, {
    key: "_delTask",
    value: function _delTask() {
      var _this5 = this;
      if (this.requesting) {
        return;
      }
      this.requesting = true;
      _MDAlertView["default"].showStandardSelection({
        message: BabelStr.str(28069),
        cancelFun: function cancelFun() {
          _this5.requesting = false;
        },
        okFun: function okFun() {
          _this5.delTask();
        }
      });
    }
  }, {
    key: "delTask",
    value: function delTask() {
      var _this6 = this;
      MMEnterpriseController.delTaskCONByFileId(this.fileInfor.getFileId(), function () {
        _this6.fileInfor.set("taskCONid", null);
        _this6.close();
        _MDSnackbarView["default"].show(BabelStr.str(308));
      }, function (code, msg) {
        _this6.requesting = false;
        _MDMessageView["default"].error(msg, _this6.$body);
      });
    }
  }], [{
    key: "className",
    value: function className() {
      return "MDAutoConvertCreateWinView";
    }
  }]);
  return MDAutoConvertCreateWinView;
}(_MDWindowView2["default"]); // MMNetDiskDataController.request("netDrive.autoTaskHandler.insertUpdateTaskCON",
// {
//   fileId: 5190262340166014,
//   includeSub: true,
//   applyToOldFile: true,
//   target_type: "pdf",         //  目标类型，如 "pdf", "jpg", "png" 等
//   // source_filetypes: Array,        // 规则，数组，按照顺序执行，顺序也是文件名各元素的相对位置
//     // filetype: String,        // 文件扩展名，小写
//   source_filetypes: [
//     "xlsx", "docx"
//   ],
//   remove_original: false   // 转码完成后是否删除原文件
// },
// function (res) {
//   console.log(res)
// },
// function name(params) {
//   console.error(params)
// })

},{"1119":1119,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1429":1429,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"296":296,"297":297,"32":32,"37":37,"508":508,"538":538,"55":55,"67":67,"68":68,"72":72,"93":93}],538:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1424);
require(1429);
require(1437);
require(1463);
require(1478);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDDropdownView2 = _interopRequireDefault(require(39));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDConvertTypeDropDownView = exports["default"] = /*#__PURE__*/function (_MDDropdownView) {
  (0, _inherits2["default"])(MDConvertTypeDropDownView, _MDDropdownView);
  function MDConvertTypeDropDownView() {
    (0, _classCallCheck2["default"])(this, MDConvertTypeDropDownView);
    return _callSuper(this, MDConvertTypeDropDownView, arguments);
  }
  (0, _createClass2["default"])(MDConvertTypeDropDownView, [{
    key: "tmpl",
    value: function tmpl() {
      return "<div class=\"form-control cur-selected-opt\">\n      <div class=\"selected-opt-value\"></div>\n        <span class=\"arrow down\"></span>\n      </div>\n    </div>\n    <div class=\"dropdown-block select-opt-list\">\n      <div class=\"flex-align between\">\n        <div class=\"info-desc\"><%=BabelStr.str(28155)%></div>\n        <div class=\"text-button done f-hide cancel-select-all\"><%=BabelStr.str(28158)%></div>\n        <div class=\"text-button done select-all\"><%=BabelStr.str(2611)%></div>\n      </div>\n      <div class=\"check-list images-list\"></div>\n      <div class=\"split-line mgtb-10\"></div>\n      <div class=\"info-desc\"><%=BabelStr.str(28156)%></div>\n      <div class=\"check-list documents-list\"></div>\n      <div class=\"split-line mgtb-10\"></div>\n      <div class=\"info-desc\"><%=BabelStr.str(28157)%></div>\n      <div class=\"check-list graphics-list\"></div>\n    </div>";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDConvertTypeDropDownView.prototype), "className", this).call(this);
      return "".concat(superCls, " select-control convert-type-select");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var props = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDConvertTypeDropDownView.prototype), "initProps", this).call(this);
      return _.extend(props, {
        dropdownContainer: '.dropdown-block',
        dropdownAnchor: '.cur-selected-opt',
        images: ["bmp", "png", "webp", "avif", "gif", "jpeg", "jpg", "ico", "svg"],
        documents: ["doc", "docx", "ppt", "pptx", "xls", "xlsx", "txt", "rtf", "wps", "wpt", "dps", "dpt", "et", "ett", "epub", "ofd"],
        graphics: ["ai", "eps", "dwg", "dwt", "dxf", "indd", "indt", "idml"]
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDConvertTypeDropDownView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "mousedown .type-item": this._typeItemClickHandler,
        "click .select-item-folder": this._selectItemFolder,
        "click .select-all": this._selectAll,
        "click .cancel-select-all": this._cancelSelectAll,
        "click .del-task": this._delTask
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDConvertTypeDropDownView.prototype), "initialize", this).call(this, props);
      if (this.placeholder) {
        this.$(".selected-opt-value").html("\n        <div class=\"placeholder\">".concat(this.placeholder, "</div>\n      "));
      }
      this.validateExts();
      this.renderCheckboxs();
      this._selectAll();
    }
  }, {
    key: "validateExts",
    value: function validateExts() {
      if (window.convertPdfExts) {
        // 分类计算
        var categorized = {
          images: _.intersection(window.convertPdfExts, this.images),
          graphics: _.intersection(window.convertPdfExts, this.graphics),
          documents: _.difference(window.convertPdfExts, _.union(this.images, this.graphics) // 排除 images 和 graphics 的所有扩展名
          )
        };
        this.images = categorized.images;
        this.graphics = categorized.graphics;
        this.documents = categorized.documents;
        console.log(categorized);
      }
    }
  }, {
    key: "renderCheckboxs",
    value: function renderCheckboxs() {
      var tmpl = "";
      _.each(this.images, function (type) {
        tmpl += "<div class=\"type-item flex-align middle\" data-type=\"".concat(type, "\">\n      <div class=\"check-box no-shrink\"></div>\n\n      <div class=\"name text-hide\">").concat(type, "</div>\n    </div>");
      });
      this.$(".images-list").html(tmpl);
      tmpl = "";
      _.each(this.documents, function (type) {
        tmpl += "<div class=\"type-item flex-align middle\" data-type=\"".concat(type, "\">\n      <div class=\"check-box no-shrink\"></div>\n\n      <div class=\"name text-hide\">").concat(type, "</div>\n    </div>");
      });
      this.$(".documents-list").html(tmpl);
      tmpl = "";
      _.each(this.graphics, function (type) {
        tmpl += "<div class=\"type-item flex-align middle\" data-type=\"".concat(type, "\">\n      <div class=\"check-box no-shrink\"></div>\n\n      <div class=\"name text-hide\">").concat(type, "</div>\n    </div>");
      });
      this.$(".graphics-list").html(tmpl);
    }
  }, {
    key: "_typeItemClickHandler",
    value: function _typeItemClickHandler($e) {
      $($e.target).closest(".type-item").toggleClass("checked");
      if (_.isFunction(this.onSelectChanged)) {
        var result = this.getSelectionData();
        this.onSelectChanged(result);
      }
      this.refreshBtns();
    }
  }, {
    key: "refreshBtns",
    value: function refreshBtns() {
      if (this.$(".type-item").length == this.$(".type-item.checked").length) {
        this.$(".select-all").addClass("f-hide");
        this.$(".cancel-select-all").removeClass("f-hide");
      } else {
        this.$(".select-all").removeClass("f-hide");
        this.$(".cancel-select-all").addClass("f-hide");
      }
    }
  }, {
    key: "_cancelSelectAll",
    value: function _cancelSelectAll() {
      this.$(".type-item").removeClass("checked");
      this.refreshBtns();
    }
  }, {
    key: "_selectAll",
    value: function _selectAll() {
      this.$(".type-item").addClass("checked");
      this.refreshBtns();
    }
  }, {
    key: "initSelectAll",
    value: function initSelectAll() {
      this._selectAll();
      this.onClose();
    }
  }, {
    key: "onClose",
    value: function onClose() {
      var types = this.getSelectTypes();
      var selectStr = "";
      if (!types.length) {
        this.$(".selected-opt-value").html("\n        <div class=\"placeholder\">".concat(this.placeholder, "</div>\n      "));
        return;
      } else if (types.length < 3) {
        selectStr = BabelStr.str(28159, {
          exts: types.join(','),
          num: types.length
        });
      } else if (types.length == this.$(".type-item").length) {
        selectStr = BabelStr.str(28151);
      } else {
        selectStr = BabelStr.str(28160, {
          exts: types.slice(0, 2).join(','),
          num: types.length
        });
      }
      this.$(".selected-opt-value").html(selectStr);
    }
  }, {
    key: "getSelectTypes",
    value: function getSelectTypes() {
      var $checked = this.$(".type-item.checked");
      var types = [];
      for (var i = 0; i < $checked.length; i++) {
        var $item = $checked.eq(i);
        var type = $item.data("type").toString();
        types.push(type);
      }
      return types;
    }
  }, {
    key: "setSelectTypes",
    value: function setSelectTypes(types) {
      var _this = this;
      this.$(".type-item").removeClass("checked");
      _.each(types, function (type) {
        _this.$(".type-item[data-type=\"".concat(type, "\"]")).addClass("checked");
      });
      this.refreshBtns();
      this.onClose();
    }
  }]);
  return MDConvertTypeDropDownView;
}(_MDDropdownView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1424":1424,"1429":1429,"1437":1437,"1454":1454,"1463":1463,"1475":1475,"1478":1478,"39":39}],534:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1429);
require(1439);
require(1416);
require(1466);
require(1420);
require(1485);
require(1477);
require(1492);
require(1424);
require(1496);
require(1465);
require(1498);
require(1437);
require(1463);
require(1478);
require(1426);
require(1446);
require(1412);
require(1450);
require(1490);
var _slicedToArray2 = _interopRequireDefault(require(1192));
var _defineProperty2 = _interopRequireDefault(require(1180));
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDCheckboxView = _interopRequireDefault(require(37));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MMFileIconMaker = _interopRequireDefault(require(296));
var _MMFileInfo = _interopRequireDefault(require(297));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _menusvg = _interopRequireDefault(require(1119));
var _MDEvents = _interopRequireDefault(require(325));
var _MDMoveFileWindowView = _interopRequireDefault(require(508));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDAutoClearCreateWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDAutoClearCreateWinView, _MDWindowView);
  function MDAutoClearCreateWinView() {
    (0, _classCallCheck2["default"])(this, MDAutoClearCreateWinView);
    return _callSuper(this, MDAutoClearCreateWinView, arguments);
  }
  (0, _createClass2["default"])(MDAutoClearCreateWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n      <div class=\"section\">\n        <%if(taskDELid){%>\n          <div class=\"flex-align between middle mgb-10\">\n            <div class=\"section-title\"><%=BabelStr.str(28062)%></div>\n            <div class=\"f-pointer red del-task no-shrink\"><%=BabelStr.str(28063)%></div>\n          </div>\n\n          <div class=\"file-item flex-align middle mgb-10\">\n            <div class=\"file-thumb no-shrink\"></div>\n            <div class=\"file-name text-hide\"></div>\n          </div>\n\n\n        <%} else {%>\n          <div class=\"section-title mgb-10\"><%=BabelStr.str(28013)%></div>\n          <div class=\"folder-group mgb-10\">\n              <div class=\"has-selected  flex-align between middle\">\n                <div class=\"file-item flex-align middle\">\n                  <div class=\"file-thumb no-shrink\"></div>\n                  <div class=\"file-name text-hide\"></div>\n                </div>\n                <div class=\"text-button done select-folder no-shrink\"><%=BabelStr.str(28019)%></div>\n              </div>\n              <div class=\"no-selected\">\n                <div class=\"text-button done select-folder\"><%=BabelStr.str(28014)%></div>\n              </div>\n          </div>\n        <%}%>\n\n          <div class=\"checkbox-group all-folder flex-align middle with-wrap gap-10 mgb-10\">\n              <div class=\"checkbox-slot\"></div>\n              <div class=\"info-desc\"><%=BabelStr.str(28016)%></div>\n          </div>\n\n      </div>\n\n      <div class=\"split-line\"></div>\n\n      <div class=\"section mgtb-10\">\n          <div class=\"section-title mgb-10\"><%=BabelStr.str(28017)%></div>\n          <div class=\"select-contain\">\n          </div>\n      </div>\n\n\n\n      <form class=\"tasks-section mgt-10\">\n\n      </form>\n\n    ";
    }
  }, {
    key: "task0Tmpl",
    value: function task0Tmpl() {
      return "<div class=\"task-0 task-item\">\n    <div class=\"section-title mgb-10\"><%=BabelStr.str(28026)%></div>\n    <div class=\"timer-type-select mgb-10\"></div>\n    <div class=\"time-interval time-type-item f-hide flex-align start mgb-10 gap-10 input-line\">\n      <span><%=BabelStr.str(28035)%></span>\n      <div class=\"num-input-block\">\n        <input name=\"time-interval-input\" required notempty class=\"form-control notempty time-interval-input num-input only-num\"/>\n      </div>\n      <div class=\"time-unit-select\"></div>\n    </div>\n    <div class=\"time-period flex-align start gap-10 time-type-item f-hide mgb-10 input-line\">\n      <span><%=BabelStr.str(28049)%></span>\n      <div class=\"time-period-select\"></div>\n      <div class=\"time-picker-input-block need-validate\">\n        <span class=\"time-svg\">".concat(_menusvg["default"].menu_task_time, "</span>\n        <input type=\"text\" required id=\"time-period-picker\" name=\"time-period-picker\" class=\"notempty form-control ui-time-picker\" placeholder=\"<%=BabelStr.str(28052)%>\"  autocomplete=\"off\">\n      </div>\n    </div>\n    <div class=\"section-title mgb-10\"><%=BabelStr.str(28036)%></div>\n    <div class=\"flex-align gap-10 mgb-10 middle\">\n      <div class=\"del-area-select\"></div>\n      <div class=\"del-area-comment red\"></div>\n    </div>\n    <div class=\"del-area-list\">\n      <div class=\"del-area-item area-key f-hide mgb-10\">\n        <textarea name=\"area-desc-input1\" required notempty id=\"\"class=\" form-control del-area-names\" placeholder=\"<%=BabelStr.str(28041)%>\"></textarea>\n      </div>\n      <div class=\"del-area-item area-ext f-hide mgb-10\">\n        <textarea name=\"area-desc-input2\" required notempty id=\"\"class=\" form-control del-area-exts\" placeholder=\"<%=BabelStr.str(28040)%>\"></textarea>\n      </div>\n      <div class=\"f-hide mgb-10 del-area-item area-size flex-align start with-wrap gap-10 input-line\">\n        <span><%=BabelStr.str(28043)%></span>\n        <div class=\"start-block flex-align start gap-10\">\n          <div class=\"num-input-block\">\n            <input name=\"startUnitInput\" required class=\"form-control start-unit-input num-input only-num\"/>\n          </div>\n          <div class=\"start-unit-select\"></div>\n        </div>\n        <span><%=BabelStr.str(28044)%></span>\n        <div class=\"end-block flex-align start gap-10\">\n          <div class=\"num-input-block\">\n            <input name=\"endUnitInput\" required class=\"form-control end-unit-input num-input only-num\"/>\n          </div>\n          <div class=\"end-unit-select\"></div>\n        </div>\n        <span><%=BabelStr.str(28045)%></span>\n      </div>\n    </div>\n    <div class=\"checkbox-group only-file f-hide mgb-10\">\n      <div class=\"checkbox-slot\"></div>\n  </div>\n  </div>");
    }
  }, {
    key: "task1Tmpl",
    value: function task1Tmpl() {
      return "<div class=\"task-1 task-item\">\n    <div class=\"section-title mgb-10\"><%=BabelStr.str(28026)%></div>\n    <div class=\"timer-type-select mgb-10\"></div>\n    <div class=\"time-interval time-type-item flex-align start mgb-10 gap-10 input-line\">\n      <span><%=BabelStr.str(28035)%></span>\n      <div class=\"num-input-block\">\n        <input name=\"task1-time-interval-input\" required class=\"form-control time-interval-input num-input only-num\"/>\n      </div>\n      <div class=\"time-unit-select\"></div>\n      <div class=\"red\"><%=BabelStr.str(28034)%></div>\n    </div>\n\n  </div>";
    }
  }, {
    key: "task2Tmpl",
    value: function task2Tmpl() {
      return "<div class=\"task-2 task-item\">\n\n    <div class=\"file-num flex-align start mgb-10 gap-10 input-line\">\n      <span><%=BabelStr.str(28055)%></span>\n      <div>\n        <input name=\"file-num-input\" required notempty class=\"form-control file-num-input num-input only-num\"/>\n      </div>\n    </div>\n    <div class=\"info-desc\"><%=BabelStr.str(28056)%></div>\n  </div>";
    }
  }, {
    key: "task3Tmpl",
    value: function task3Tmpl() {
      return "<div class=\"task-3 task-item\">\n\n    <div class=\"file-num flex-align start mgb-10 gap-10 input-line\">\n      <span><%=BabelStr.str(28057)%></span>\n      <div>\n        <input required notempty name=\"file-size-input\" class=\"form-control file-size-input num-input\"/>\n      </div>\n      <span>GB</span>\n      <span class=\"red\"><%=BabelStr.str(28164)%></span>\n    </div>\n    <div class=\"info-desc\"><%=BabelStr.str(28056)%></div>\n  </div>";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var props = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAutoClearCreateWinView.prototype), "initProps", this).call(this);
      return _.extend(props, {
        conditionArr: [{
          type: -1,
          name: BabelStr.str(28025)
        }, {
          type: 0,
          name: BabelStr.str(28020)
        }, {
          type: 1,
          name: BabelStr.str(28021)
        }, {
          type: 2,
          name: BabelStr.str(28022)
        }, {
          type: 3,
          name: BabelStr.str(28023)
        }],
        delAreaArr1: [{
          type: 0,
          name: BabelStr.str(28029),
          comment: BabelStr.str(28037)
        }, {
          type: 1,
          name: BabelStr.str(28030),
          comment: BabelStr.str(28042)
        }, {
          type: 2,
          name: BabelStr.str(28031),
          comment: BabelStr.str(28046)
        }, {
          type: 3,
          name: BabelStr.str(28032),
          comment: BabelStr.str(28038)
        }, {
          type: 4,
          name: BabelStr.str(28033),
          comment: BabelStr.str(28039)
        }],
        delAreaArr2: [{
          type: 0,
          name: BabelStr.str(28034)
        }],
        timerTypeArr: [{
          type: 0,
          name: BabelStr.str(28027)
        }, {
          type: 1,
          name: BabelStr.str(28028)
        }],
        timerTypeArr1: [{
          type: 0,
          name: BabelStr.str(28027)
        }],
        timeUnitArr: [
        // { type: 0, name: BabelStr.str(28060) },
        // { type: 1, name: BabelStr.str(21904) },
        {
          type: 2,
          name: BabelStr.str(21905)
        }, {
          type: 3,
          name: BabelStr.str(21906)
        }, {
          type: 4,
          name: BabelStr.str(21907)
        }, {
          type: 5,
          name: BabelStr.str(21908)
        }, {
          type: 6,
          name: BabelStr.str(28061)
        }],
        timeCycleArr: [{
          type: 0,
          name: BabelStr.str(28047)
        }, {
          type: 1,
          name: BabelStr.str(28048)
        }, {
          type: 2,
          name: BabelStr.str(28050)
        }, {
          type: 3,
          name: BabelStr.str(28051)
        }],
        sizeUnitArea: [(0, _defineProperty2["default"])({
          value: 0,
          name: "KB"
        }, "value", 1024), (0, _defineProperty2["default"])({
          value: 1,
          name: "MB"
        }, "value", 1024 * 1024), (0, _defineProperty2["default"])({
          value: 2,
          name: "Gb"
        }, "value", 1024 * 1024 * 1024)],
        includeSub: 1,
        triggerType: 0,
        delFolder: false,
        delType: 0,
        resultLoadedStatus: {}
      });
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        taskDELid: this.taskDELid
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAutoClearCreateWinView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAutoClearCreateWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " auto-clear-create-win task-create-win");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAutoClearCreateWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .select-folder": this._selectFolder,
        "input .only-num": this._validateInputNum,
        "keypress .num-input": this._onlyNum,
        "input .file-num-input ": this._validateFileNumInputNum,
        // "input .file-size-input ": this._validateFileNumInputNum,
        "input .file-size-input ": this.validateDecimalInput,
        "click .del-task": this._delTask,
        "submit form": this.noSubmit
      });
    }
  }, {
    key: "noSubmit",
    value: function noSubmit(e) {
      e.preventDefault(); // 阻止表单提交
      console.log("表单已拦截，执行自定义逻辑");
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      if (props.taskDELid) {
        props.title = BabelStr.str(28059);
      } else {
        props.title = BabelStr.str(28012);
      }
      props.size = "large";
      props.buttons = [{
        label: BabelStr.str(3081),
        type: "default"
      }, {
        label: BabelStr.str(3080),
        type: "done",
        autoClose: false,
        onClick: function onClick(button, $e) {
          this._saveClicked();
        }
      }];
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAutoClearCreateWinView.prototype), "initialize", this).call(this, props);
      this.renderFileInfo();
      this.allSubFolderView = new _MDCheckboxView["default"]({
        label: BabelStr.str(28015),
        checked: true,
        silentInit: false,
        onChanged: function onChanged(checked) {
          _this.includeSub = checked;
          _this.refreshOnlyFileStatus();
        }
      });
      this.addSubView(this.allSubFolderView, this.$(".all-folder .checkbox-slot")[0]);
      this.conditionSelectView = new _MDDropdownSelectListView["default"]({
        dataProvider: this.conditionArr,
        labelField: "name",
        silentInit: false,
        onChange: function onChange(obj) {
          _this.onTaskTypeChanged(obj);
        }
      });
      this.addSubView(this.conditionSelectView, this.$(".select-contain")[0]);

      // this.loadResult0()
      if (this.taskDELid) {
        this.findTaskDELByFileId();
      }
    }
  }, {
    key: "refreshOnlyFileStatus",
    value: function refreshOnlyFileStatus() {
      if (this.includeSub && this.scopeType == 0) {
        this.$(".only-file").removeClass("f-hide");
      } else {
        this.$(".only-file").addClass("f-hide");
      }
    }
  }, {
    key: "onTaskTypeChanged",
    value: function onTaskTypeChanged(obj) {
      this.triggerType = obj.type;
      if (obj.type == 0) {
        this.loadResult0();
      } else if (obj.type == 1) {
        this.loadResult1();
      } else if (obj.type == 2) {
        this.loadResult2();
      } else if (obj.type == 3) {
        this.loadResult3();
      }
    }
  }, {
    key: "renderFileInfo",
    value: function renderFileInfo() {
      if (!this.fileInfor) {
        this.$(".folder-group").removeClass("selected");
        return;
      }
      _MMFileIconMaker["default"].setTypeIconForFileInfoNotCalcDevice(this.fileInfor, this.$(".file-thumb"), undefined, undefined, 20);
      this.$(".file-name").html(this.fileInfor.getFileName());
      this.$(".folder-group").addClass("selected");
    }
  }, {
    key: "_selectFolder",
    value: function _selectFolder() {
      var _this2 = this;
      var win = new _MDMoveFileWindowView["default"]({
        forChooseFolder: true,
        forMove: false,
        title: BabelStr.str(28013),
        unselectableHandle: function unselectableHandle(file) {
          if (file.getFileId().slice(0, 5) === "0--00") {
            return false;
          }
          return !(file.canManageFilePermission() || file.isOwner());
        },
        fileIntercept: function fileIntercept(file) {
          // if(file.getFileId().slice(0, 5) === "0--00") {
          //   return false
          // }
          return false;
          // return !file.canDelete();
        },
        intercept: function intercept(targetFolderId) {
          if (targetFolderId.slice(0, 5) === "0--00") {
            return {
              isOK: false,
              msg: BabelStr.str(6851)
            };
          } else {
            return {
              isOK: true
            };
          }
        },
        chooseCallback: function chooseCallback(result) {
          console.log(result);
          var file = new _MMFileInfo["default"]({
            fileId: result.id,
            fileName: result.name,
            teamMark: result.teamMark
          });
          _this2.fileInfor = file;
          _this2.renderFileInfo();
        }
      });
      win.show();
    }
  }, {
    key: "loadResult0",
    value: function loadResult0() {
      var _this3 = this;
      this.$(".task-item").addClass("f-hide");
      if (this.resultLoadedStatus[0]) {
        this.$(".task-0").removeClass("f-hide");
      } else {
        this.resultLoadedStatus[0] = true;
        var tmpl = _.template(this.task0Tmpl());
        this.$(".tasks-section").append(tmpl);
        var timerTypeSelect = new _MDDropdownSelectListView["default"]({
          dataProvider: this.timerTypeArr,
          labelField: "name",
          selectedIndex: 0,
          silentInit: false,
          onChange: function onChange(obj) {
            _this3.timerType = obj.type;
            _this3.refreshTimeTypeBlock(obj);
            console.log(obj);
          }
        });
        this.addSubView(timerTypeSelect, this.$(".task-0 .timer-type-select")[0]);
        var areaStartSelect = new _MDDropdownSelectListView["default"]({
          dataProvider: this.sizeUnitArea,
          labelField: "name",
          selectedIndex: 1,
          silentInit: false,
          onChange: function onChange(obj) {
            _this3.sizeStartUnit = obj.value;
          }
        });
        this.addSubView(areaStartSelect, this.$(".start-unit-select")[0]);
        var areaEndSelect = new _MDDropdownSelectListView["default"]({
          dataProvider: this.sizeUnitArea,
          labelField: "name",
          selectedIndex: 1,
          silentInit: false,
          onChange: function onChange(obj) {
            _this3.sizeEndUnit = obj.value;
          }
        });
        this.addSubView(areaEndSelect, this.$(".end-unit-select")[0]);
        var timerUnitSelect = new _MDDropdownSelectListView["default"]({
          dataProvider: this.timeUnitArr,
          labelField: "name",
          silentInit: false,
          onChange: function onChange(obj) {
            _this3.task0TimerUnit = obj.type;
          }
        });
        this.addSubView(timerUnitSelect, this.$(".task-0 .time-unit-select")[0]);
        var timerPeriodSelect = new _MDDropdownSelectListView["default"]({
          dataProvider: this.timeCycleArr,
          labelField: "name",
          silentInit: false,
          onChange: function onChange(obj) {
            _this3.timeCycle = obj.type;
          }
        });
        this.addSubView(timerPeriodSelect, this.$(".time-period-select")[0]);
        var delIndex = _.findIndex(this.delAreaArr1, {
          type: this.delType
        });
        var delAreaSelect = new _MDDropdownSelectListView["default"]({
          dataProvider: this.delAreaArr1,
          labelField: "name",
          silentInit: false,
          // selectedIndex: delIndex,
          onChange: function onChange(obj) {
            // this.pickConditionChanged(obj);

            _this3.$(".del-area-comment").html(obj.comment || "");
            console.log(obj);
            _this3.refreshDelAreaContent(obj);
            _this3.scopeType = obj.type;
            _this3.refreshOnlyFileStatus();
          }
        });
        this.addSubView(delAreaSelect, this.$(".del-area-select")[0]);
        var onlyFileView = new _MDCheckboxView["default"]({
          label: BabelStr.str(28024),
          silentInit: false,
          checked: !this.delFolder,
          onChanged: function onChanged(checked) {
            _this3.delFolder = !checked;
          }
        });
        this.addSubView(onlyFileView, this.$(".only-file .checkbox-slot")[0]);
        this.$("#time-period-picker").timepicker({
          timeFormat: "HH:mm",
          // 24小时制
          stepHour: 1,
          // 小时间隔
          stepMinute: 10,
          // 分钟间隔
          showButtonPanel: false,
          // 是否显示按钮面板
          timeOnlyTitle: BabelStr.str(28052)
        });
      }
      this.refreshOnlyFileStatus();
      if (this.taskData && this.taskData.triger.type == 0) {
        timerTypeSelect && timerTypeSelect.selectItemAt(this.taskData.triger.timer.type);
        delAreaSelect.selectItemAt(this.taskData.scope[0].type || 0);
        var scopeValue = this.taskData.scope[0].value;
        if (this.taskData.scope[0].type == 1) {
          var valueArr = scopeValue.split("-");
          var start = valueArr[0];
          var end = valueArr[1];
          if (start < 1024 * 1024) {
            areaStartSelect.selectItemAt(0);
            start = parseInt(start / 1024);
          } else if (start < 1024 * 1024 * 1024) {
            areaStartSelect.selectItemAt(1);
            start = parseInt(start / 1024 / 1024);
          } else {
            areaStartSelect.selectItemAt(2);
            start = parseInt(start / 1024 / 1024 / 1024);
          }
          if (end < 1024 * 1024) {
            areaEndSelect.selectItemAt(0);
            end = parseInt(end / 1024);
          } else if (end < 1024 * 1024 * 1024) {
            areaEndSelect.selectItemAt(1);
            end = parseInt(end / 1024 / 1024);
          } else {
            areaEndSelect.selectItemAt(2);
            end = parseInt(end / 1024 / 1024 / 1024);
          }
          this.$(".start-unit-input").val(start);
          this.$(".end-unit-input").val(end);
        } else if (this.taskData.scope[0].type == 2) {
          this.$(".del-area-exts").val(scopeValue);
        } else if (this.taskData.scope[0].type == 3) {
          this.$(".del-area-names").val(scopeValue);
        }
        this.$(".task-0 .time-interval-input").val(this.taskData.triger.timer.interval || "");
        var unitIndex = _.findIndex(this.timeUnitArr, function (item) {
          return item.type == _this3.taskData.triger.timer.inter_unit;
        });
        timerUnitSelect.selectItemAt(unitIndex || 0);
        timerPeriodSelect.selectItemAt(this.taskData.triger.timer.time_cycle || 0);
        onlyFileView.setChecked(!this.taskData.delFolder);
        if (this.taskData.triger.timer.clock) {
          var time = this.minutesToTimeString(this.taskData.triger.timer.clock);
          this.$("#time-period-picker").val(time);
        }
      }
    }
  }, {
    key: "loadResult1",
    value: function loadResult1() {
      var _this4 = this;
      this.$(".task-item").addClass("f-hide");
      if (this.resultLoadedStatus[1]) {
        this.$(".task-1").removeClass("f-hide");
      } else {
        this.resultLoadedStatus[1] = true;
        var tmpl = _.template(this.task1Tmpl());
        this.$(".tasks-section").append(tmpl);
        var timerTypeSelect = new _MDDropdownSelectListView["default"]({
          dataProvider: this.timerTypeArr1,
          labelField: "name",
          selectedIndex: 0,
          silentInit: false,
          onChange: function onChange(obj) {
            // this.pickConditionChanged(obj);
            // this.refreshTimeTypeBlock(obj)
            console.log(obj);
          }
        });
        this.addSubView(timerTypeSelect, this.$(".task-1 .timer-type-select")[0]);
        var timerUnitSelect = new _MDDropdownSelectListView["default"]({
          dataProvider: this.timeUnitArr,
          labelField: "name",
          silentInit: false,
          onChange: function onChange(obj) {
            // this.pickConditionChanged(obj);
            // console.log(obj);
            _this4.task1TimerUnit = obj.type;
          }
        });
        this.addSubView(timerUnitSelect, this.$(".task-1 .time-unit-select")[0]);
        // let includeSubFolder = new MDCheckboxView({
        //   label: BabelStr.str(28054),
        //   onChanged: (checked) => {
        //     // this.saveToPersonTmpl = checked;
        //   },
        // });
        // this.addSubView(
        //   includeSubFolder,
        //   this.$(".include-sub-folder .checkbox-slot")[0]
        // );
      }
      if (this.taskData && this.taskData.triger.type == 1) {
        this.$(".task-1 .time-interval-input").val(this.taskData.triger.timer.interval);
        var unitIndex = _.findIndex(this.timeUnitArr, function (item) {
          return item.type == _this4.taskData.triger.timer.inter_unit;
        });
        timerUnitSelect.selectItemAt(unitIndex || 0);
      }
    }
  }, {
    key: "loadResult2",
    value: function loadResult2() {
      this.$(".task-item").addClass("f-hide");
      if (this.resultLoadedStatus[2]) {
        this.$(".task-2").removeClass("f-hide");
      } else {
        this.resultLoadedStatus[2] = true;
        var tmpl = _.template(this.task2Tmpl());
        this.$(".tasks-section").append(tmpl);
      }
      if (this.taskData && this.taskData.triger.type == 2) {
        this.$(".file-num-input").val(this.taskData.triger.threshhode.number);
      }
    }
  }, {
    key: "loadResult3",
    value: function loadResult3() {
      this.$(".task-item").addClass("f-hide");
      if (this.resultLoadedStatus[3]) {
        this.$(".task-3").removeClass("f-hide");
      } else {
        this.resultLoadedStatus[3] = true;
        var tmpl = _.template(this.task3Tmpl());
        this.$(".tasks-section").append(tmpl);
      }
      if (this.taskData && this.taskData.triger.type == 3) {
        this.$(".file-size-input").val(this.taskData.triger.threshhode.number);
      }
    }
  }, {
    key: "refreshDelAreaContent",
    value: function refreshDelAreaContent(obj) {
      this.$(".del-area-item").addClass("f-hide");
      if (obj.type == 1) {
        this.$(".area-size").removeClass("f-hide");
      } else if (obj.type == 2) {
        this.$(".area-ext").removeClass("f-hide");
      } else if (obj.type == 3) {
        this.$(".area-key").removeClass("f-hide");
      }
    }
  }, {
    key: "refreshTimeTypeBlock",
    value: function refreshTimeTypeBlock(obj) {
      this.$(".task-0 .time-type-item").addClass("f-hide");
      if (obj.type == 1) {
        this.$(".task-0 .time-period").removeClass("f-hide");
      } else if (obj.type == 0) {
        this.$(".task-0 .time-interval").removeClass("f-hide");
      }
    }
  }, {
    key: "_onlyNum",
    value: function _onlyNum(e) {
      var allowedKeys = [8, 9, 13, 27, 46,
      // 退格、Tab、Enter、ESC、删除
      37, 38, 39, 40,
      // 方向键
      110, 190 // 小数点（主键盘和小键盘）
      ];

      // 允许 Ctrl+A, Ctrl+C, Ctrl+X
      if (e.ctrlKey && [65, 67, 88].includes(e.keyCode)) {
        return;
      }

      // 允许数字键（主键盘和小键盘）
      if (e.keyCode >= 48 && e.keyCode <= 57 || e.keyCode >= 96 && e.keyCode <= 105) {
        return;
      }

      // 允许小数点（但不能重复输入）
      if ((e.keyCode === 110 || e.keyCode === 190) && e.target.value.includes('.')) {
        e.preventDefault();
        return;
      }

      // 禁止其他按键（如汉字、负号、特殊符号等）
      if (!allowedKeys.includes(e.keyCode)) {
        e.preventDefault();
      }
    }
  }, {
    key: "validateDecimalInput",
    value: function validateDecimalInput(e) {
      var input = e.target;
      // 替换所有非数字、非小数点的字符
      var value = input.value.replace(/[^0-9.]/g, '');

      // 确保只有一个小数点
      var decimalParts = value.split('.');
      if (decimalParts.length > 2) {
        value = decimalParts[0] + '.' + decimalParts.slice(1).join('');
      }

      // 如果输入以 "." 开头，自动补 "0"（如 ".5" → "0.5"）
      if (value.startsWith('.')) {
        value = '0' + value;
      }
      var num = parseFloat(value, 10);
      // 检查范围
      if (num < 1) {
        input.value = 1;
      } else if (num > 99999) {
        input.value = 99999;
      } else {
        input.value = value;
      }
    }
  }, {
    key: "_validateInputNum",
    value: function _validateInputNum(e) {
      // 过滤非数字字符（处理粘贴、拖拽等非键盘输入）
      var value = $(e.target).val();
      var numericValue = value.replace(/[^0-9]/g, "");
      if (value !== numericValue) {
        $(e.target).val(numericValue);
      }
      if (value == 0) {
        $(e.target).val(1);
      }
    }
  }, {
    key: "_validateFileNumInputNum",
    value: function _validateFileNumInputNum(e) {
      var value = $(e.target).val();
      var num = parseInt(value, 10);
      // 检查范围
      if (num < 1) {
        $(e.target).val(1);
      } else if (num > 99999) {
        $(e.target).val(99999);
      }
    }
  }, {
    key: "_saveClicked",
    value: function _saveClicked() {
      var _this5 = this;
      var validator = this.$("form").validate();
      if (!validator.form()) {
        console.error("验证失败了");
        return;
      }
      if (!this.fileInfor) {
        _MDMessageView["default"].error(BabelStr.str(4780), this.$body);
        return;
      }
      if (this.triggerType == -1) {
        _MDMessageView["default"].error(BabelStr.str(28058), this.$body);
        return;
      }
      if (this.requesting) {
        return;
      }
      this.requesting = true;
      console.log("验证通过了");
      var params = this.getResultParams();
      console.log(params);
      _MMEnterpriseController["default"].insertUpdateTaskDEL(params, function (value) {
        _this5.requesting = false;
        _this5.close();
        if (!_this5.taskData) {
          _this5.fileInfor.set("taskDELid", value[0]._id);
          _Dispatcher["default"].trigger(_MDEvents["default"].TaskCreated, {
            fileId: _this5.fileInfor.getFileId(),
            taskDELid: value[0]._id
          });
        }
        _MDSnackbarView["default"].show(BabelStr.str(308));
      }, function (code, msg) {
        _this5.requesting = false;
        _MDMessageView["default"].error(msg, _this5.$body);
      });
    }
  }, {
    key: "getResultParams",
    value: function getResultParams() {
      var params = {
        fileId: this.fileInfor.getFileId(),
        includeSub: this.includeSub,
        delFolder: !!this.delFolder,
        triger: {
          type: this.triggerType
        }
      };
      if (this.triggerType == 0) {
        var interval = this.$(".task-0 .time-interval-input").val().toString().trim();
        var timeStr = this.$("#time-period-picker").val().trim();
        params.triger.timer = {
          type: this.timerType,
          interval: interval,
          inter_unit: this.task0TimerUnit,
          time_cycle: this.timeCycle
        };
        if (timeStr) {
          var _timeStr$split$map = timeStr.split(':').map(Number),
            _timeStr$split$map2 = (0, _slicedToArray2["default"])(_timeStr$split$map, 2),
            hours = _timeStr$split$map2[0],
            minutes = _timeStr$split$map2[1];
          var totalMinutes = hours * 60 + minutes;
          params.triger.timer.clock = totalMinutes;
        }
        params.scope = [{
          type: this.scopeType
        }];
        if (this.scopeType == 1) {
          var start = parseInt(this.$(".start-unit-input").val()) * this.sizeStartUnit;
          var end = parseInt(this.$(".end-unit-input").val()) * this.sizeEndUnit;
          params.scope[0].value = "".concat(start, "-").concat(end);
        } else if (this.scopeType == 2) {
          params.scope[0].value = this.$(".del-area-exts").val().trim().split("，").join(",");
        } else if (this.scopeType == 3) {
          params.scope[0].value = this.$(".del-area-names").val().trim().split("，").join(",");
        }
      } else if (this.triggerType == 1) {
        var _interval = this.$(".task-1 .time-interval-input").val().toString().trim();
        params.triger.timer = {
          type: 0,
          interval: _interval,
          inter_unit: this.task1TimerUnit
        };
      } else if (this.triggerType == 2) {
        params.triger.threshhode = {
          number: parseInt(this.$(".file-num-input").val().toString().trim())
        };
      } else if (this.triggerType == 3) {
        params.triger.threshhode = {
          number: parseFloat(this.$(".file-size-input").val()).toFixed(2) - 0,
          unit: 3
        };
      }
      return params;
    }
  }, {
    key: "findTaskDELByFileId",
    value: function findTaskDELByFileId() {
      var _this6 = this;
      _MMEnterpriseController["default"].findTaskDELByFileId(this.fileInfor.getFileId(), function (value) {
        _this6.taskData = value[0];
        _this6.allSubFolderView.setChecked(_this6.taskData.includeSub);
        _this6.conditionSelectView.selectItemAt(_this6.taskData.triger.type + 1);
        // if(this.taskData.triger.type == 0) {
        //   this.onTaskTypeChanged({
        //     type: 0
        //   });
        // }
      }, function (code, msg) {
        _this6.requesting = false;
        _MDMessageView["default"].error(msg, _this6.$body);
      });
    }
  }, {
    key: "_delTask",
    value: function _delTask() {
      var _this7 = this;
      if (this.requesting) {
        return;
      }
      this.requesting = true;
      _MDAlertView["default"].showStandardSelection({
        message: BabelStr.str(28069),
        cancelFun: function cancelFun() {
          _this7.requesting = false;
        },
        okFun: function okFun() {
          _this7.delTask();
        }
      });
    }
  }, {
    key: "delTask",
    value: function delTask() {
      var _this8 = this;
      _MMEnterpriseController["default"].delTaskDELByFileId(this.fileInfor.getFileId(), function () {
        _this8.fileInfor.set("taskDELid", null);
        _this8.close();
        _MDSnackbarView["default"].show(BabelStr.str(308));
      }, function (code, msg) {
        _this8.requesting = false;
        _MDMessageView["default"].error(msg, _this8.$body);
      });
    }
  }, {
    key: "minutesToTimeString",
    value: function minutesToTimeString(minutes) {
      var hours = Math.floor(minutes / 60);
      var mins = minutes % 60;

      // 使用 padStart 确保两位数格式（如 '2' → '02'）
      return "".concat(hours.toString().padStart(2, '0'), ":").concat(mins.toString().padStart(2, '0'));
    }
  }], [{
    key: "className",
    value: function className() {
      return "MDAutoClearCreateWinView";
    }
  }]);
  return MDAutoClearCreateWinView;
}(_MDWindowView2["default"]);

},{"1098":1098,"1119":1119,"1175":1175,"1179":1179,"1180":1180,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1192":1192,"1412":1412,"1416":1416,"1420":1420,"1424":1424,"1426":1426,"1429":1429,"1437":1437,"1439":1439,"1446":1446,"1450":1450,"1454":1454,"1463":1463,"1465":1465,"1466":1466,"1475":1475,"1477":1477,"1478":1478,"1485":1485,"1490":1490,"1492":1492,"1496":1496,"1498":1498,"18":18,"296":296,"297":297,"32":32,"325":325,"37":37,"508":508,"55":55,"67":67,"72":72,"93":93}],1490:[function(require,module,exports){
'use strict';
var $ = require(1270);
var $padStart = require(1371).start;
var WEBKIT_BUG = require(1370);

// `String.prototype.padStart` method
// https://tc39.es/ecma262/#sec-string.prototype.padstart
$({ target: 'String', proto: true, forced: WEBKIT_BUG }, {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $padStart(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
  }
});

},{"1270":1270,"1370":1370,"1371":1371}],1371:[function(require,module,exports){
// https://github.com/tc39/proposal-string-pad-start-end
var uncurryThis = require(1281);
var toLength = require(1386);
var toString = require(1393);
var $repeat = require(1373);
var requireObjectCoercible = require(1359);

var repeat = uncurryThis($repeat);
var stringSlice = uncurryThis(''.slice);
var ceil = Math.ceil;

// `String.prototype.{ padStart, padEnd }` methods implementation
var createMethod = function (IS_END) {
  return function ($this, maxLength, fillString) {
    var S = toString(requireObjectCoercible($this));
    var intMaxLength = toLength(maxLength);
    var stringLength = S.length;
    var fillStr = fillString === undefined ? ' ' : toString(fillString);
    var fillLen, stringFiller;
    if (intMaxLength <= stringLength || fillStr == '') return S;
    fillLen = intMaxLength - stringLength;
    stringFiller = repeat(fillStr, ceil(fillLen / fillStr.length));
    if (stringFiller.length > fillLen) stringFiller = stringSlice(stringFiller, 0, fillLen);
    return IS_END ? S + stringFiller : stringFiller + S;
  };
};

module.exports = {
  // `String.prototype.padStart` method
  // https://tc39.es/ecma262/#sec-string.prototype.padstart
  start: createMethod(false),
  // `String.prototype.padEnd` method
  // https://tc39.es/ecma262/#sec-string.prototype.padend
  end: createMethod(true)
};

},{"1281":1281,"1359":1359,"1373":1373,"1386":1386,"1393":1393}],1370:[function(require,module,exports){
// https://github.com/zloirock/core-js/issues/280
var userAgent = require(1266);

module.exports = /Version\/10(?:\.\d+){1,2}(?: [\w./]+)?(?: Mobile\/\w+)? Safari\//.test(userAgent);

},{"1266":1266}],532:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1438);
require(1429);
require(1439);
require(1421);
require(1426);
require(1424);
var _MDWindowView = _interopRequireDefault(require(93));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDCreateFolderWindowView = _interopRequireDefault(require(486));
var _MMFileInfo = _interopRequireDefault(require(297));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDFolderTreeView = _interopRequireDefault(require(598));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDEvents = _interopRequireDefault(require(325));
// MDEditArchiveLibraryWinView.js

var MDEditArchiveLibraryWinView = _MDWindowView["default"].extend({
  contentTmpl: "\n    <div class=\"inv-manager-block mgt-10 f-hide flex-align mgb-20 gap-10\">\n      <div class=\"item-title no-shrink\"><%=BabelStr.str(21215)%></div>\n      <div class=\"inv-manager-list gap-10 flex-align with-wrap\"></div>\n    </div>\n    <div class=\"wrapper folder-tree-placeholder\"></div>\n  ",
  className: function className() {
    return _MDWindowView["default"].prototype.className.call(this) + ' m-classification-select-win';
  },
  initProps: function initProps() {
    return _.extend(_MDWindowView["default"].prototype.initProps.call(this), {
      title: BabelStr.str(40159),
      helpText: BabelStr.str(40159),
      selectedIds: [],
      disabledIds: [],
      onlySelectLeaf: false,
      confirmCallback: null,
      cancelCallback: null,
      folderTree: null,
      currentSelectedNodes: [],
      fileInfors: []
    });
  },
  initialize: function initialize(opt) {
    _.extend(this, _.pick(opt, 'title', 'helpText', 'selectedIds', 'disabledIds', 'onlySelectLeaf', 'confirmCallback', 'cancelCallback'));
    var okStr = app.currentUser.canManageArchive() ? BabelStr.str(154) : BabelStr.str(12544);
    var buttons = [{
      label: BabelStr.str(155),
      type: 'default',
      onClick: function () {
        if (_.isFunction(this.cancelCallback)) this.cancelCallback();
        this.close();
      }.bind(this)
    }, {
      label: okStr,
      type: 'done',
      className: 'save',
      autoClose: false,
      onClick: function ($e) {
        var _this = this;
        if ($($e.target).hasClass('disabled')) return;
        $($e.target).addClass('disabled');
        console.log(this.folderTree.getSelectionDiff());
        var params = this.folderTree.getSelectionDiff();
        if (params.classificationIds.length || params.delClassificationIds.length) {
          _MMEnterpriseController["default"].editClassArchive(params, function () {
            $($e.target).removeClass('disabled');
            _MDSnackbarView["default"].show(BabelStr.str(308));
            _Dispatcher["default"].trigger(_MDEvents["default"].RefreshArchiveTable, location.hash);
          }, function (err) {
            $($e.target).removeClass('disabled');
            _MDMessageView["default"].error(err.msg, _this.$body);
          });
        }
        this.close();
      }.bind(this)
    }];
    _MDWindowView["default"].prototype.initialize.call(this, _.extend({}, opt, {
      buttons: buttons,
      width: 800
    }));
    if (!app.currentUser.canManageArchive()) {
      this._fetchArchiveManagers();
    }
  },
  _fetchArchiveManagers: function _fetchArchiveManagers() {
    var self = this;
    _MMEnterpriseController["default"].getEntArchiveManagers(function (managerInfos) {
      self.renderEditManager(managerInfos);
    });
  },
  renderEditManager: function renderEditManager(managerInfos) {
    if (!managerInfos || !managerInfos.length) {
      return;
    }
    managerInfos = managerInfos.slice(0, 5);
    var tmpl = '';
    _.each(managerInfos, function (user) {
      tmpl += '<div class="manager-item flex-align middle">' + '<div class="manager-icon icon no-shrink"></div>' + '<span class="name middle-ellipsis">' + (user.name || user.phone) + '</span>' + '</div>';
    });
    this.$(".inv-manager-list").html(tmpl);
    this.$(".inv-manager-block").removeClass("f-hide");
  },
  render: function render(data) {
    data = {
      title: this.title || BabelStr.str(7200),
      helpText: this.helpText || BabelStr.str(7201)
    };
    _MDWindowView["default"].prototype.render.call(this, data);
  },
  viewDidRendered: function viewDidRendered() {
    this._renderTree();
  },
  _renderTree: function _renderTree() {
    var _this2 = this;
    var self = this;
    var nodeFilter = function nodeFilter(fileInfo) {
      return true;
    };
    var nodeDisabled = function nodeDisabled(fileInfo) {
      var id = fileInfo.getFileId();
      if (self.disabledIds && self.disabledIds.indexOf(id) !== -1) return true;
      if (self.onlySelectLeaf && fileInfo.get('hasChild') === true) return true;
      return false;
    };
    var treeOptions = {
      dataSource: 'classification',
      // 关键：使用分类数据源
      multiSelect: true,
      showCreateFolderBtn: true,
      useCustomIcon: false,
      nodeFilter: nodeFilter,
      nodeDisabled: nodeDisabled,
      folderCreateMode: "append",
      // onSelectionChange: function(data) {
      //   self._onSelectionChange(data.selectedNodes);
      // },
      onFolderAppended: function onFolderAppended(param) {
        var parentId = param.parentId,
          newFolder = param.newFolder,
          node = param.node;
        console.log('添加子分类到：', parentId);
        // 弹出对话框创建子分类
        _Dispatcher["default"].trigger(_MDEvents["default"].RefreshClassifyTreeNode, parentId);
      },
      onEditNodeCallback: function onEditNodeCallback(nodeId) {
        console.log('编辑节点：', nodeId);
      },
      onDeleteNodeCallback: function onDeleteNodeCallback(nodeId) {
        console.log('删除节点：', nodeId);
      },
      openFolder: false,
      testUpload: false,
      pageSize: 100
    };
    this.folderTree = new _MDFolderTreeView["default"](treeOptions);
    this.addSubView(this.folderTree, this.$('.folder-tree-placeholder'), true);
    var ids = _.map(this.fileInfors, function (file) {
      return file.getFileId();
    });
    _MMEnterpriseController["default"].getClassificationsByArchiveIds(ids.join(","), function (data) {
      _this2.folderTree.applyPartialSelectionByClassificationData(data, ids);
    }, function (err) {
      _MDMessageView["default"].error(err.msg, _this2.$body);
    });
  }
});
var _default = exports["default"] = MDEditArchiveLibraryWinView;

},{"1098":1098,"1184":1184,"1421":1421,"1424":1424,"1426":1426,"1429":1429,"1438":1438,"1439":1439,"1454":1454,"18":18,"297":297,"325":325,"486":486,"55":55,"598":598,"72":72,"93":93}],530:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1436);
require(1546);
require(1421);
require(1413);
require(1463);
require(1430);
require(1426);
require(1418);
require(1537);
require(1415);
require(1431);
var _MMFileInfoCollection = _interopRequireDefault(require(298));
var _MDChannelType = _interopRequireDefault(require(717));
var _MDWindowView = _interopRequireDefault(require(93));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDFileOperationManager = _interopRequireDefault(require(326));
var _MDNetDriveFileHandler = _interopRequireDefault(require(1091));
var _MMCommonFun = _interopRequireDefault(require(812));
/**
 *  Window for move file to new folder
 *  Created by manjun.han
 *  2015.9.14
 */

var MDMoveArchiveWindowView = _MDWindowView["default"].extend({
  contentTmpl: '<p class="title">' + BabelStr.str(7167) + '</p>' + '<p class="help-block"></p>' + '<div class="wrapper"><div id="treeView"></div></div>',
  className: function className() {
    var superCls = _MDWindowView["default"].prototype.className.call(this);
    return superCls + ' m-moveFileWin';
  },
  initProps: function initProps() {
    var props = _MDWindowView["default"].prototype.initProps.call(this);
    return _.extend(props, {
      fileInfors: null,
      folderId: -1,
      isCopyAction: false,
      isLinkFileAction: false,
      deleteAfterMove: true,
      ancestorIds: [],
      // 选中界面的祖先界面的id数组
      parentId: "0"
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    if (!opt.openFolder) {
      this.fileInfors = opt.fileInfors;
      this.hasFolder = _.any(this.fileInfors, function (fileInfo) {
        return fileInfo.isFolder();
      });
    }
    ;
    if (opt.openFolder) {} else if (opt.isLinkFileAction) {
      opt.title = BabelStr.str(2623);
    } else if (!opt.isCopyAction) {
      opt.title = BabelStr.str(7168);
    } else {
      opt.title = BabelStr.str(33);
    }
    opt.buttons = [{
      label: BabelStr.str(155),
      type: 'default'
    }, {
      label: BabelStr.str(154),
      type: 'done',
      autoClose: false,
      onClick: function onClick($e) {
        if (self.folderId !== -1) {
          self._executeAction();
        } else {
          self.close();
        }
      }
    }];
    opt.width = 800;
    _MDWindowView["default"].prototype.initialize.call(this, opt);
    this._getTheDepFolderId();
    var rootfile = _MMNetDiskDataController["default"].getArchive();
    this.rootNode = rootfile.getTreeNodeInfo(undefined, true);
    this.rootNode.parent = '#';
    this.rootNode.state.opened = true;
  },
  getPathById: function getPathById() {
    var _this = this;
    var fileId = this.fileInfors[0].getFileId();
    _MMNetDiskDataController["default"].getPathById(fileId, _MDChannelType["default"].archive, null, function (data) {
      var option = {};
      _this.pathIds = option.pathIds = [];
      data.each(function (file) {
        var id = file.getFileId();
        if (_this.parentId != id) {
          option.pathIds.push(id);
        }
      });
      _this.pathIds.push('0');
      _this._renderFolderTree([]);
      // option.fileId = this.depFolder.getFileId();
      // option.type = MMNetDiskDataController.LISTTYPES.FOLDER;
      // this.getInitFoldersData(option);
    }, function () {});

    // var self = this;
    // var _ready2CallInit = function() {
    //   let option = {};
    //   self.pathIds = option.pathIds = [self.depFolder.getFileId() + ""];

    //   option.depFolderId = self.depFolder.getFileId() + "";
    //   option.type = MMNetDiskDataController.LISTTYPES.FOLDER;
    //   self.getInitFoldersData(option);
    // }

    // if (this.depFolder.getFileId() == 0) {
    //   MMEnterpriseController.getRootDepartment(function(dep){
    //     self.depFolder.setFileId(dep.folderId);

    //     _ready2CallInit();
    //   }, function(){

    //   })
    // } else {
    //   _ready2CallInit();
    // }
  },
  viewDidRendered: function viewDidRendered() {
    this.getPathById();
  },
  getInitFoldersData: function getInitFoldersData(option) {
    var _this2 = this;
    var files = [this.depFolder.toJSON()];
    if (app.pathRouter.getFilePaths().length > 0 && app.pathRouter.inFile()) {
      files = [app.pathRouter.getFilePaths()[0].toJSON()];
    }
    MMEnterpriseController.getFilePathTree(option, function (tree) {
      tree.push({
        fileId: "-1",
        files: files
      });
      _this2.dispNodesArr = [], _.each(tree, function (item) {
        var dispNodes = {
          nodes: [],
          parentId: ""
        };
        var fileInforCollection = new _MMFileInfoCollection["default"](item.files);
        dispNodes.nodes = _this2._transfromCollectionToJSTreeNodes(fileInforCollection, tree, item.fileId);
        dispNodes.parentId = item.fileId == "-1" ? "#" : item.fileId;
        _.each(dispNodes.nodes, function (node) {
          if (node.id == "0") {
            node.state.opened = true;
          }
          _.each(_this2.pathIds, function (id) {
            if (node.id == id) {
              node.state.opened = true;
            }
          });
        });
        _this2.dispNodesArr.push(dispNodes);
        // let fileInforCollection = new MMFileInfoCollection(item.files);
        // nodes =nodes.concat(this._transfromCollectionToJSTreeNodes(fileInforCollection, tree, item.fileId))
      });
      _this2._renderFolderTree(_this2.dispNodesArr);
    }, function () {});
  },
  _renderFolderTree: function _renderFolderTree(dispNodesArr) {
    var self = this;
    // var root = MMNetDiskDataController.getHomeDir();
    // var rootNode = this._transformToJSTreeNode(root);
    // // 默认打开根目录
    // rootNode['state'] = {
    //   opened: true
    // };

    // var rootId = this.depFolder.getFileId();

    this.$('#treeView').jstree({
      'core': {
        "themes": {
          "dots": false // no connecting dots between dots
        },
        'multiple': false,
        'data': function data(node, cb) {
          // if (node['id'] === "#" || node['id'] === rootId || _.indexOf(self.pathIds, node['id'] )> -1) {
          //   _.each(dispNodesArr, dispNodes => {
          //     if(node['id'] === dispNodes.parentId){
          //       cb(dispNodes.nodes)
          //     }
          //   });
          //     // $('#treeView').jstree().open_node($('#treeView')[0]);
          // } else {
          var fileId = node['id'];
          if (fileId == "#") {
            cb(self.rootNode);
          } else {
            var type = _MMNetDiskDataController["default"].LISTTYPES.FOLDER;
            _MDNetDriveFileHandler["default"].listArchiveDir(fileId, function (fileInforCollection) {
              var nodes = self._transfromCollectionToJSTreeNodes(fileInforCollection);
              _.each(nodes, function (node) {
                if (_.indexOf(self.pathIds, node.id) > -1) {
                  node.state.opened = true;
                }
              });
              cb(nodes);
            }, function () {});
          }

          // }
        }
      }
    });
    var $buttons = this.getActionButtons();
    this.$doneBtn = $buttons.eq(1);
    this.$doneBtn.prop('disabled', true);
    this.$('#treeView').on("changed.jstree", function (e, data) {
      self.folderId = data['node']['id'];
      self.node = data['node'];
      self.ancestorIds = $("#treeView").jstree().get_path(data['node'], false, true);
      self.$doneBtn.prop('disabled', false);
    }).on('load_node.jstree', function (e, data) {
      if (data.node.id == self.pathIds[0]) {
        self.$('#treeView').jstree().select_node({
          id: self.parentId
        });
      }
    });
  },
  _executeAction: function _executeAction() {
    if (this.openFolder) {
      console.log('------------ open clicked!');
      var targetFolderId = this.folderId;
      app.pathRouter.navigateToPath('file/' + targetFolderId);
      this.close();
      if (this.afterOpen) {
        this.afterOpen(targetFolderId);
      }
      ;
    } else if (this.isLinkFileAction) {
      this._createLinkForFile();
    } else {
      // 校验失败，要提示
      if (!this._validateMoveAction()) {
        return;
      }
      if (this.isCopyAction) {
        this._copyFileIntoFolder();
      } else {
        this._moveFileIntoFolder();
      }
    }
  },
  _validateMoveAction: function _validateMoveAction() {
    var self = this;
    var title = BabelStr.str(33);
    var targetFolderId = this.folderId;
    var allInCurFolder = _.every(this.fileInfors, function (fileInfor) {
      return fileInfor.get('parentId') === targetFolderId;
    });

    // 当前选中的文件已经包含在了目标文件夹
    if (allInCurFolder) {
      _MDSnackbarView["default"].show(BabelStr.str(7169));
      return false;
    }
    var moveToSelf = _.some(this.fileInfors, function (fileInfor) {
      return _.some(self.ancestorIds, function (ancestorId, index) {
        return fileInfor.getFileId() == ancestorId;
      });
    });
    // 自己移到自己内部
    if (moveToSelf) {
      if (!this.isCopyAction) {
        title = BabelStr.str(7168);
      }
      _MDSnackbarView["default"].show(BabelStr.str(7170, {
        title: title
      }));
      return false;
    }
    return true;
  },
  _createLinkForFile: function _createLinkForFile() {
    var _this3 = this;
    var fileId = this.fileInfors[0].getFileId();
    var destDir = this.folderId;
    _MMNetDiskDataController["default"].createLinkForFile(destDir, fileId, function (res) {
      _MDSnackbarView["default"].show(BabelStr.str(308));
      console.log(_this3.folderId + '---' + _this3.parentId);
      if (_this3.folderId == _this3.parentId) {
        Dispatcher.trigger(MDEvents.RefreshCurFolder);
      }
      _this3.close();
    }, function (err) {
      _MDSnackbarView["default"].show(err['message']);
    });
  },
  _copyFileIntoFolder: function _copyFileIntoFolder() {
    var folderId = this.folderId;
    var self = this;
    var ids = _.map(this.fileInfors, function (fileInfor) {
      return fileInfor.getFileId();
    });
    _MDFileOperationManager["default"].copyFileIntoFolder(this.fileInfors, folderId);
    self.close();
  },
  _moveFileIntoFolder: function _moveFileIntoFolder() {
    var folderId = this.folderId;
    var self = this;
    var ids = _.map(this.fileInfors, function (fileInfor) {
      return fileInfor.getFileId();
    });
    if (ids.length == 0) {
      return;
    }
    ;
    var sourceFolderId = this.fileInfors[0].getParentFolderId();
    // var sourceEntId = this.fileInfors[0].getEnterpriseId();
    _MDFileOperationManager["default"].moveFileIntoFolder(ids, folderId, sourceFolderId, false);
    self.close();
  },
  _uploadCompleted: function _uploadCompleted(failList) {
    if (failList && failList.length) {
      var message = "";
      failList.forEach(function (fileInfo) {
        message += (message == "" ? "" : ", ") + fileInfo.getFileName();
      });
      _MDSnackbarView["default"].show(BabelStr.str(7171));
    } else {
      _MDSnackbarView["default"].show(BabelStr.str(7172));
    }
  },
  _transformToJSTreeNode: function _transformToJSTreeNode(fileInfor, isRootTree, parentId) {
    var nodeInfo = fileInfor.getTreeNodeInfo(undefined, true);
    var disabled = false;
    if (this.hasFolder && !fileInfor.canCreateFolder()) {
      disabled = true;
    }
    ;
    nodeInfo.children = !disabled;
    nodeInfo['state']['disabled'] = disabled;
    var data = nodeInfo;
    if (isRootTree && !!parentId) {
      data.parent = parentId == "-1" ? "#" : parentId;
    }
    return data;
  },
  _transfromCollectionToJSTreeNodes: function _transfromCollectionToJSTreeNodes(fileInforCollection, isRootTree, parentId) {
    var self = this;
    this.fileInforCollection = fileInforCollection;
    var folders = fileInforCollection.filter(function (fileInfor) {
      // return fileInfor.isFolder() && !fileInfor.isOtherPersonSharingFile() && fileInfor.canUpload();
      return fileInfor.isFolder();
    });
    folders = folders.sort(function (fileInfo1, fileinfo2) {
      var fileName1 = fileInfo1.get('fileName').toLowerCase();
      var fileName2 = fileinfo2.get('fileName').toLowerCase();
      return fileName1.localeCompare(fileName2, 'zh');
      // if (fileName1 > fileName2) {
      //   return 1;
      // } else if (fileName1 < fileName2) {
      //   return -1;
      // } else {
      //   return 0;
      // }
    });
    return _.map(folders, function (fileInfor) {
      return self._transformToJSTreeNode(fileInfor, isRootTree, parentId);
    });
  },
  _getTheDepFolderId: function _getTheDepFolderId() {
    var depFolder = _MMCommonFun["default"].getCurDepfolder();
    console.assert(depFolder != null);
    this.depFolder = depFolder;
  }
}, {
  openFolderWindow: function openFolderWindow(opt, callback) {
    var wind = new MDMoveArchiveWindowView({
      openFolder: true,
      // upload: opt.upload,
      afterOpen: callback,
      title: BabelStr.str(7173),
      parentId: '0'
    });
    wind.show();
  }
});
window.MDMoveArchiveWindowView = MDMoveArchiveWindowView;
var _default = exports["default"] = MDMoveArchiveWindowView;

},{"1091":1091,"1104":1104,"1184":1184,"1413":1413,"1415":1415,"1418":1418,"1421":1421,"1426":1426,"1430":1430,"1431":1431,"1436":1436,"1454":1454,"1463":1463,"1537":1537,"1546":1546,"298":298,"326":326,"717":717,"72":72,"812":812,"93":93}],528:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDFileInfoShowView = _interopRequireDefault(require(497));
var _MDBorrowPanelViewTmpl = _interopRequireDefault(require(529));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDNetDriveFileHandler = _interopRequireDefault(require(1091));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MDAlertView = _interopRequireDefault(require(32));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // MDBorrowPanelView.js
// javascript/moladisk/views/file/archive/MDBorrowPanelView.js
//
// jiang
// 2018-8-30
var MDBorrowPanelView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDBorrowPanelView, _MDWindowView);
  function MDBorrowPanelView() {
    (0, _classCallCheck2["default"])(this, MDBorrowPanelView);
    return _callSuper(this, MDBorrowPanelView, arguments);
  }
  (0, _createClass2["default"])(MDBorrowPanelView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return _MDBorrowPanelViewTmpl["default"].main;
    }
  }, {
    key: "evalutionUnOrderedTmpl",
    value: function evalutionUnOrderedTmpl() {
      return _MDBorrowPanelViewTmpl["default"].evalutionUnOrdered;
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBorrowPanelView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        fileInfo: null,
        commentNum: 150
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBorrowPanelView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .save': this._saveClickHandle,
        'keydown .comment': this._commentInputHandle,
        'input .comment': this._commentInputHandle
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBorrowPanelView.prototype), "className", this).call(this);
      return superCls + ' borrow-win common-file-panel';
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.title = BabelStr.str(769); // "借阅档案"

      props.data = _.extend({
        'caption': BabelStr.str(770),
        // 借阅档案需要相关人员审批，审批通过后档案即可出现在“我的借阅”频道中
        'borrowCap': BabelStr.str(771),
        // 申请借阅
        'postscript': BabelStr.str(774),
        // 借阅理由
        'keyInputCap': BabelStr.str(427, {
          // ------  还可输入 xxx 字
          'num': '<span class="num">150</span>'
        }),
        'commit': BabelStr.str(772),
        // 提交申请
        'morefile': BabelStr.str(1048, {
          count: props.fileInfos.length
        }),
        'borrowType': BabelStr.str(773)
      }, props.data);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBorrowPanelView.prototype), "initialize", this).call(this, props);
      this.$commitBtn = this.$(".save");
      this._renderFileInfo();
      var self = this;
      this.$form = this.$('.eval-form');
      if (this.fileInfos.length <= 1) {
        this.$('.more-file').css("visibility", 'hidden');
      }
      ;
      this.viewTypes = [BabelStr.str(2652),
      // 在线阅读
      BabelStr.str(29) // 下载
      // BabelStr.str(2653),       // 复制
      ];
      this.conditionSelectView = new _MDDropdownSelectListView["default"]({
        dataProvider: this.viewTypes,
        labelField: "name",
        onChange: function onChange(obj) {
          _this.pickViewTypeChanged(obj);
        }
      });
      this.addSubView(this.conditionSelectView, this.$(".select")[0]);
    }
  }, {
    key: "pickViewTypeChanged",
    value: function pickViewTypeChanged(obj) {
      console.log('---------> view type changed!');
    }
  }, {
    key: "addRuleForNewItem",
    value: function addRuleForNewItem(itemView) {
      var $input = itemView.getItemInput();
      $input.rules('add', {
        requiredMember: true,
        diffCurEvaluator: true
      });
    }
  }, {
    key: "_renderFileInfo",
    value: function _renderFileInfo() {
      var fileInfoView = new _MDFileInfoShowView["default"]({
        fileInfo: this.fileInfos[0]
      });
      this.addSubView(fileInfoView, this.$('.file-info-block .file')[0]);
    }
  }, {
    key: "_saveClickHandle",
    value: function _saveClickHandle() {
      var self = this;
      var validator = this.$form.validate();
      if (validator.form()) {
        var index = this.conditionSelectView.selectedIndex;
        var fileIds = [];
        for (var i = 0; i < this.fileInfos.length; i++) {
          var fileInfo = this.fileInfos[i];
          fileIds.push(fileInfo.getFileId());
        }
        var comment = _.escape(this.$('.comment').val());
        self.$(".save").disable();
        _MDNetDriveFileHandler["default"].apply2BorrowFiles(fileIds, index, comment, function () {
          var opt = {
            message: BabelStr.str(766) // 申请已经发送，请等待
          };
          self.close();
          _MDAlertView["default"].showStandardPrompt(opt);
          for (var _i = 0; _i < self.fileInfos.length; _i++) {
            var _fileInfo = self.fileInfos[_i];
            _fileInfo.setBorrowStatus(1);
          }
          self.$(".save").enable();
        }, function (code) {
          self.$(".save").enable();
          if (code == 12) {
            _MDSnackbarView["default"].show(BabelStr.str(2730));
          } else {
            _MDSnackbarView["default"].show(BabelStr.str(309));
          }
        });
      }
    }
  }, {
    key: "_commentInputHandle",
    value: function _commentInputHandle() {
      var comment = this.$(".comment").val().toString();
      var length = comment.length;
      var num = this.commentNum - length;
      if (num < 0) {
        num = 0;
      }
      this.$(".comments-block .num").html(num);
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBorrowPanelView.prototype), "viewDidRendered", this).call(this);
    }
  }]);
  return MDBorrowPanelView;
}(_MDWindowView2["default"]);
MDBorrowPanelView.borrowFiles = function (fileInfos) {
  var panel = new MDBorrowPanelView({
    fileInfos: fileInfos
  });
  panel.show();
};

},{"1091":1091,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1437":1437,"1454":1454,"1463":1463,"1475":1475,"1478":1478,"32":32,"497":497,"529":529,"67":67,"72":72,"93":93}],529:[function(require,module,exports){
module.exports = {"main":"<div class=\"header-block help-block tip-word\">\r    <%=caption%>\r  </div>\r  <div class=\"file-info-block flex-align between \">\r    <div class=\"title-left\"><%=borrowCap%></div>\r    <div class=\"file\"></div>\r    <div class=\"more-file title-right\"><%=morefile%></div>\r  </div>\r  <!-- <div class=\"sequence-block\"></div> -->\r  <form class=\"eval-form\">\r    <div class=\"comments-block\">\r      <div class=\"setting-evalution flex-align between\">\r        <div class=\"title-left\"><%=borrowType%></div>\r        <div class=\"right\">\r          <div class=\"select\"></div>\r        </div>\r      </div>\r    </div>\r    <div class=\"comments-block flex-align between\">\r      <div class=\"title-left\"><%=postscript%></div>\r      <div class=\"right\">\r        <textarea class=\"comment notempty textinput\" required name=\"\" id=\"\" cols=\"30\" rows=\"10\" maxlength=\"150\"></textarea>\r        <div class=\"conment-tip f-fr\"><%=keyInputCap%></div>\r      </div>\r    </div>\r  </form>\r  <div class=\"button-block flex-align between btns-block\">\r    <div class=\"button done save invisible\"></div>\r    <button class=\"button done save\"><%=commit%></button>\r  </div>"};
},{}],524:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1424);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDEnterUserChooseView = _interopRequireDefault(require(459));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDEnterpriseShareTabView = _interopRequireDefault(require(675));
var _MDAlertView = _interopRequireDefault(require(32));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
// MDTransferFileWinView.js 发送文件 网页使用
// jichao
// 2022-11-15
var MDTransferFileWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDTransferFileWinView, _MDWindowView);
  function MDTransferFileWinView() {
    (0, _classCallCheck2["default"])(this, MDTransferFileWinView);
    return _callSuper(this, MDTransferFileWinView, arguments);
  }
  (0, _createClass2["default"])(MDTransferFileWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n        <div class=\"help-block\"><%=BabelStr.str(2601)%><%=BabelStr.str(6824)%></div>\n        <div class=\"choose-block\"></div>\n      ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDTransferFileWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        callback: _.noop
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDTransferFileWinView.prototype), "className", this).call(this);
      return superCls + ' ';
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.title = BabelStr.str(5268);
      props.size = 'large';
      props.buttons = [{
        label: BabelStr.str(406),
        type: "done",
        autoClose: false,
        onClick: function onClick() {
          var data = _this.chooserView.getTargetRegExpEmails();
          var receivers = data.emails.concat(data.phones);
          if (!receivers.length) {
            _MDMessageView["default"].infor(BabelStr.str(6840), _this.$body);
            return;
          }
          _this.sendFilePersonal(receivers);
          console.warn("发送文件");
          console.log(data);
        }
      }];
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDTransferFileWinView.prototype), "initialize", this).call(this, props);
      this.chooserView = new _MDEnterpriseShareTabView["default"]({
        isTabAbsolute: false,
        canSelDepartment: false,
        canSelGroup: false,
        needFrequentUserTab: true,
        maxLength: 5,
        placeholderStr: BabelStr.str(709),
        maxLengthCallback: function maxLengthCallback() {
          _MDMessageView["default"].infor(BabelStr.str(6837), _this.$body);
        }
      });
      this.addSubView(this.chooserView, this.$(".choose-block")[0]);
    }
  }, {
    key: "sendFilePersonal",
    value: function sendFilePersonal(receivers) {
      var _this2 = this;
      receivers = receivers.join(',');
      MMEnterpriseController.sendFilePersonal(receivers, this.fileIds, function (result) {
        if (result && result.needReview) {
          var opt = {
            message: BabelStr.str(21945)
          };
          _MDAlertView["default"].showStandardPrompt(opt);
        } else {
          _MDSnackbarView["default"].show(BabelStr.str(5294));
        }
        _this2.close();
      }, function (code, msg) {
        _MDSnackbarView["default"].show(msg);
      });
    }
  }, {
    key: "viewDidUnRendered",
    value: function viewDidUnRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDTransferFileWinView.prototype), "viewDidUnRendered", this).call(this);
    }
  }]);
  return MDTransferFileWinView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1424":1424,"1454":1454,"1463":1463,"1475":1475,"32":32,"459":459,"55":55,"675":675,"72":72,"93":93}],523:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1498);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDTransferFileByPortWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDTransferFileByPortWinView, _MDWindowView);
  function MDTransferFileByPortWinView() {
    (0, _classCallCheck2["default"])(this, MDTransferFileByPortWinView);
    return _callSuper(this, MDTransferFileByPortWinView, arguments);
  }
  (0, _createClass2["default"])(MDTransferFileByPortWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n        <div class=\"help-block\"><%=BabelStr.str(6894)%></div>\n        <div class=\"flex-align middle mgtb-10\">\n          <div class=\"mgr-20 left-title no-shrink\"><%=BabelStr.str(6857)%>:</div>\n          <div class=\"fullfill port-select\"></div>\n        </div>\n        <div class=\"flex-align middle\">\n          <div class=\"mgr-20 no-shrink left-title\"><%=BabelStr.str(3079)%>:</div>\n          <textarea  id=\"js-comment\" rows=\"4\" maxlength=\"300\" class=\"form-control \"></textarea>\n        </div>\n      ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDTransferFileByPortWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        callback: _.noop
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDTransferFileByPortWinView.prototype), "className", this).call(this);
      return superCls + ' transfer-port-win ';
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.title = BabelStr.str(6893);
      props.size = 'normal';
      props.buttons = [{
        label: BabelStr.str(406),
        type: "done",
        autoClose: false,
        onClick: function onClick() {
          var comment = _this.$('#js-comment').val() || '';
          comment = comment.trim();
          MMEnterpriseController.commitFileToPort(_this.id, _this.fileIds, comment, function () {
            _MDSnackbarView["default"].show(BabelStr.str(5294));
            _this.close();
          }, function (code, msg) {
            _MDSnackbarView["default"].show(msg);
          });
        }
      }];
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDTransferFileByPortWinView.prototype), "initialize", this).call(this, props);
      this.portSelect = new _MDDropdownSelectListView["default"]({
        selectedIndex: 0,
        silentInit: false,
        dataProvider: window.portInfos,
        labelField: "identifier",
        repeatChange: true,
        onChange: function onChange(data) {
          // this.$('.remark').text(data.comment)
          _this.id = data.id;
        }
      });
      this.addSubView(this.portSelect, this.$(".port-select")[0]);
    }
  }, {
    key: "viewDidUnRendered",
    value: function viewDidUnRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDTransferFileByPortWinView.prototype), "viewDidUnRendered", this).call(this);
    }
  }]);
  return MDTransferFileByPortWinView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"1498":1498,"55":55,"67":67,"72":72,"93":93}],520:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDPopupView = _interopRequireDefault(require(64));
var _MDTeamSettingWindowView = _interopRequireDefault(require(763));
var _MDShareFileWindowView = _interopRequireDefault(require(695));
var _MMBasicData = _interopRequireDefault(require(811));
var _MEStaffNavigationPageView = _interopRequireDefault(require(148));
var _MDDepShareFileListWinView = _interopRequireDefault(require(569));
var _MDDepControlFileListWinView = _interopRequireDefault(require(562));
var _MDDepSecretFileListWinView = _interopRequireDefault(require(568));
var _MDChannelType = _interopRequireDefault(require(717));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDAlertView = _interopRequireDefault(require(32));
//
// WebContent/javascript/moladisk/views/file/MDShareJumpOption.js
//

var MDShareJumpOption = _MDPopupView["default"].extend({
  contentTmpl: '<ul class="m-menu"></ul>',
  initProps: function initProps() {
    var superP = _MDPopupView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      zoomSelected: -1,
      $zoomList: null,
      scaleList: [],
      fileInfo: null,
      targetDiv: null,
      gapY: !app.isUseV2022() ? -2 : 4
    });
  },
  events: function events() {
    var superEvents = _MDPopupView["default"].prototype.events.call(this);
    return _.extend(superEvents, {
      "click li": this._menuItemClickHandler
    });
  },
  initialize: function initialize(opt) {
    _MDPopupView["default"].prototype.initialize.call(this, opt);
    this.initList();
  },
  initList: function initList() {
    var html = "";
    if (this.fileInfo.isTeamFolder()) {
      if (app.isEpVersion()) {
        if (app.currentUser.isEpAdminUser()) {
          html += '<li mola-op="manage-team">' + BabelStr.str(186) + " </li>";
        } else {
          html += '<li mola-op="manage-team">' + BabelStr.str(187) + " </li>";
        }
      } else {
        html += '<li mola-op="manage-team">' + BabelStr.str(186) + " </li>";
      }

      // 目前只有团队有讨论组
      html += '<li mola-op="jump-cvs"> ' + BabelStr.str(3315) + " </li>";
    } else if (this.fileInfo.canShare()) {
      html += '<li mola-op="manage-share"> ' + BabelStr.str(13) + " </li>";
    } else if (this.fileInfo.isDepartmentFolder()) {
      if (this.fileInfo.canManageDepMember()) {
        html += "<li mola-op=\"manage-dep\">".concat(BabelStr.str(3316), "</li>");
        html += "<li mola-op=\"manage-dep-info\">".concat(BabelStr.str(2508), "</li>");
      }
      if (this.fileInfo.canManageFilePermission()) {
        html += "<li mola-op=\"list-dep-share\">".concat(BabelStr.str(2842), "</li>");
        html += "<li mola-op=\"list-dep-appfile\">".concat(BabelStr.str(2614), "</li>");
        html += "<li mola-op=\"list-dep-secret\">".concat(BabelStr.str(2856), "</li>");
        html += "<li mola-op=\"list-dep-statistic\">".concat(BabelStr.str(3486), "</li>");
      }
    } else if (this.fileInfo.isProject() && this.fileInfo.canEditProject()) {
      html += "<li mola-op=\"manage-proj\">".concat(BabelStr.str(2833), "</li>");
    }
    this.$(".m-menu").append(html);
    this.$zoomList = $(html);
  },
  _menuItemClickHandler: function _menuItemClickHandler($e) {
    var op = $($e.target).attr("mola-op");
    var fileId = this.fileInfo.getFileId();
    if (op == "manage-team") {
      var teamWin = new _MDTeamSettingWindowView["default"]({
        teamFolderId: fileId
      });
      teamWin.show();
    } else if (op == "manage-share") {
      var $span = $(this.targetDiv);
      var wind = new _MDShareFileWindowView["default"]({
        fileInfor: this.fileInfo,
        toggleShareCb: function toggleShareCb(opened) {
          if (opened) {
            $span.show();
          } else {
            $span.hide();
          }
        }
      });
      wind.show();
    } else if (op == "manage-dep" || op == "list-upload-statistic") {
      this._navigateToAdmin();
    } else if (op == "manage-dep-info") {
      this._manageDepInfo();
    } else if (op == "manage-proj") {
      this._manageProj();
    } else if (op == "list-dep-share") {
      this._popupShareList();
    } else if (op == "list-dep-appfile") {
      this._popupAppendFiles();
    } else if (op == "list-dep-secret") {
      this._popupSecrectsFile();
    } else if (op == "list-dep-statistic") {
      this.showUserStatisticsWin();
    } else if (op == "limit-dep") {
      this.showDeplimitWin();
    } else {
      var path = "message/" + fileId;
      app.pathRouter.navigate(path, {
        trigger: true,
        force: true
      });
    }
    this.close();
  },
  _manageDepInfo: function _manageDepInfo() {
    var actionController = new MDFileActionController({
      channel: _MDChannelType["default"].file
    });
    actionController.setFileInfors([this.fileInfo]);
    actionController.manageDepInfo();
  },
  _navigateToAdmin: function _navigateToAdmin() {
    var actionController = new MDFileActionController({
      channel: _MDChannelType["default"].file
    });
    actionController.setFileInfors([this.fileInfo]);
    actionController.manageDepMember();

    // if(!app.pathRouter.inDepartment()){
    //   viewManager.get("mainPanelView").dispDepManager(this.fileInfo.get("departmentId"), this.fileInfo.getFileName(), this.fileInfo.getFileId(), this.fileInfo);
    // }else{

    //   var departId = this.fileInfo.get('departmentId');
    //   var departName = this.fileInfo.getFileName();
    //   var serveForSingleDep = !app.currentUser.isEpAdminUser() && this.fileInfo.canManageDepMember();
    //   var rootNavigationPageView = new MEStaffNavigationPageView({
    //     departId: departId,
    //     departName: departName,
    //     serveForSingleDep: serveForSingleDep
    //   });
    //   this.navigationView.push(rootNavigationPageView);
    // }
  },
  _popupShareList: function _popupShareList() {
    var fileControlWinView = new _MDDepShareFileListWinView["default"]({
      fileInfo: this.fileInfo
    });
    fileControlWinView.show();
  },
  _popupAppendFiles: function _popupAppendFiles() {
    var fileControlWinView = new _MDDepControlFileListWinView["default"]({
      fileInfo: this.fileInfo
    });
    fileControlWinView.show();
  },
  _popupSecrectsFile: function _popupSecrectsFile() {
    var fileControlWinView = new _MDDepSecretFileListWinView["default"]({
      fileInfo: this.fileInfo
    });
    fileControlWinView.show();
  },
  _manageProj: function _manageProj() {
    var actionController = new MDFileActionController({
      channel: _MDChannelType["default"].file
    });
    actionController.setFileInfors([this.fileInfo]);
    actionController.showEditProject();
  },
  showUserStatisticsWin: function showUserStatisticsWin() {
    var actionController = new MDFileActionController({
      channel: _MDChannelType["default"].file
    });
    actionController.setFileInfors([this.fileInfo]);
    actionController.showUserStatisticsWin();
  },
  showDeplimitWin: function showDeplimitWin() {
    var actionController = new MDFileActionController({
      channel: _MDChannelType["default"].file
    });
    actionController.setFileInfors([this.fileInfo]);
    actionController.showDeplimitWin();
  }
}, {
  show: function show(targetDiv, fileInfo) {
    if (MDShareJumpOption.instance) {
      MDShareJumpOption.instance.remove();
      MDShareJumpOption.instance = null;
    } else {
      MDShareJumpOption.instance = new MDShareJumpOption({
        fileInfo: fileInfo,
        targetDiv: targetDiv
      });
      var z_startIndex = _MMBasicData["default"].getO2OStartLayerZ_index();
      MDShareJumpOption.instance.$el.css("z-index", z_startIndex);
      var width = 160;
      if (_MDLocalString["default"].getCurrentLanguage() == "en") {
        width = 210;
      }
      MDShareJumpOption.instance.show({
        triggerView: targetDiv,
        center: true,
        width: width,
        onClose: function onClose() {
          MDShareJumpOption.instance = null;
        }
      });
    }
  }
});
var _default = exports["default"] = MDShareJumpOption;

},{"1150":1150,"1184":1184,"1454":1454,"148":148,"32":32,"562":562,"568":568,"569":569,"64":64,"695":695,"717":717,"763":763,"811":811}],514:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1498);
var _MDWindowView = _interopRequireDefault(require(93));
var _keycode = _interopRequireDefault(require(104));
var _MDFileOperationManager = _interopRequireDefault(require(326));
var _MDSnackbarView = _interopRequireDefault(require(72));
/**
 *  Window for rename file name
 *  Created by manjun.han
 *  2015.9.14
 */

var MDRenameWindowView = _MDWindowView["default"].extend({
  contentTmpl: "<div class=\"wrapper clear-appearance\">\n    <form action=\"\">\n      <div class=\"form-item\">\n        <p class=\"mgb-10\"><%=BabelStr.str(7262)%></p>\n        <div class=\"__input_parent\">\n          <input name=\"fileName\" testFileName type=\"text\"  id=\"renameInput\" class=\"form-control testFileNameEnd testFileName\" maxlength=\"100\" palceholder=\"<%=BabelStr.str(158)%>\"/>\n        </div>\n      </div>\n      </form>\n    </div>",
  className: function className() {
    var superCls = _MDWindowView["default"].prototype.className.call(this);
    return superCls + ' m-renameWin';
  },
  initProps: function initProps() {
    var props = _MDWindowView["default"].prototype.initProps.call(this);
    return _.extend(props, {
      fileInfors: null,
      folderId: -1,
      width: 460
    });
  },
  events: function events() {
    var superE = _MDWindowView["default"].prototype.events.call(this);
    return _.extend({}, superE, {
      'keyup #renameInput': this._submitOnEnter
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    opt = _.extend({}, opt);
    this.fileInfor = opt.fileInfor;
    opt.title = BabelStr.str(30);
    opt.buttons = [{
      label: BabelStr.str(155),
      type: 'default'
    }, {
      label: BabelStr.str(154),
      type: 'done',
      autoClose: false,
      onClick: function onClick(button, $e) {
        self._submit();
        return false;
      }
    }];
    _MDWindowView["default"].prototype.initialize.call(this, opt);
  },
  _submit: function _submit() {
    var self = this;
    var originName = this.fileInfor.getFileName();
    var newName = $.trim(self.$("#renameInput").val());
    var validator = this.$('form').validate();
    if (validator.form()) {
      if (this.fileInfor.get("multFile")) {
        this.multFileRename(newName);
      } else {
        if (!this.fileInfor.isFolder()) {
          originName = MMCommonFun.getFileNameWithoutExtension(originName);
        }
        if (newName == originName) {
          self.close();
        } else {
          newName = self.fileInfor.isFolder() ? newName : newName + "." + self.fileInfor.getFileExtension();
          self._postRename(newName);
        }
      }
    }
  },
  /**
   * method implemented by Tobias
   * postprozessing on this method should try to rename the file and close the view.s
   */
  _postRename: function _postRename(text) {
    _MDFileOperationManager["default"].rename(this.fileInfor, text);
    this.close();
  },
  multFileRename: function multFileRename(newName) {
    var _this = this;
    MMNetDiskDataController.updateEvaluationFlow(this.fileInfor.getEvaluationFlowId(), newName, undefined, undefined, function () {
      _this.fileInfor.setFileName(newName);
      _this.close();
    }, function (code, msg) {
      if (code == 20001) {
        _MDSnackbarView["default"].show(BabelStr.str(7506));
      } else {
        _MDSnackbarView["default"].show(msg);
      }
    });
  },
  viewDidRendered: function viewDidRendered() {
    this.$input = this.$("input");
    var f = this.fileInfor.getFileName();
    if (!this.fileInfor.isFolder()) {
      f = MMCommonFun.getFileNameWithoutExtension(f);
    }
    this.$input.val(f);
    var self = this;
    if (app.canDispInNormalBrowser()) {
      self.$input.focus();
    }
    this.$('form').submit(false);
    this.$('form').validate({
      rules: {
        'fileName': {
          'required': true,
          'maxlength': 100
        }
      },
      messages: {
        'fileName': {
          'required': BabelStr.str(7198),
          'maxlength': BabelStr.str(7199)
        }
      }
    });
  },
  _submitOnEnter: function _submitOnEnter($e) {
    if (_keycode["default"].isEnterKey($e.keyCode)) {
      this._submit();
    }
  }
});
var _default = exports["default"] = MDRenameWindowView;

},{"104":104,"1184":1184,"1454":1454,"1498":1498,"326":326,"72":72,"93":93}],487:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1423);
require(1463);
require(1487);
require(1538);
require(1545);
require(1543);
require(1498);
require(1496);
require(1439);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDfileUploadList = _interopRequireDefault(require(345));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDCreateLinkView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDCreateLinkView, _MDWindowView);
  function MDCreateLinkView() {
    (0, _classCallCheck2["default"])(this, MDCreateLinkView);
    return _callSuper(this, MDCreateLinkView, arguments);
  }
  (0, _createClass2["default"])(MDCreateLinkView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n      <form class=\"rename-per\">\n        <div class=\"flex-align mgb-10\">\n          <div class=\"left-head no-shrink form-required\"><%=BabelStr.str(27001)%></div>\n          <div class=\"fullfill\">\n            <input type=\"\" name=\"link-file-url\" class=\"islink form-control notempty\" required placeholder=\"<%=BabelStr.str(27008)%>\"/>\n          </div>\n        </div>\n        <div class=\"flex-align mgb-15 \">\n          <div class=\"left-head no-shrink form-required\"><%=BabelStr.str(27002)%></div>\n          <div class=\"fullfill\">\n            <input type=\"\" name=\"link-file-name\" class=\"link-name form-control notempty\" required placeholder=\"<%=BabelStr.str(27009)%>\"/>\n          </div>\n        </div>\n      </form>\n      <div class=\"flex-align upload-ver-per\">\n        <div class=\"left-head no-shrink\"><%=BabelStr.str(27003)%></div>\n        <div class=\"fullfill\">\n          <div class=\"upload\">\n            <div class=\"thumb-upload js-per-judge\">\n              <button type=\"button\" class=\"button done small upload-btn\"><%=BabelStr.str(3032)%></button>            <!-- \u9009\u62E9\u56FE\u7247 -->\n              <input type=\"file\" class=\"thumb-input f-hide\" id=\"thumbInput\" name=\"thumb_file\" accept=\".jpg,.jpeg,.png,.bmp\">\n            </div>\n            <div class=\"help-block\"><%=BabelStr.str(3033)%></div>\n          </div>\n          <img id=\"\" class=\"f-hide upload-btn preview\" data-tooltip-dir=\"top\" data-tooltip=\"".concat(BabelStr.str(3032), "\">\n        </div>\n      </div>\n    ");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var props = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDCreateLinkView.prototype), "initProps", this).call(this);
      return _.extend(props, {
        parentId: ""
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDCreateLinkView.prototype), "events", this).call(this);
      return _.extend({
        "click .upload-btn": this._upload
      }, superP);
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.title = BabelStr.str(27000);
      if (props.fileInfor) {
        props.title = BabelStr.str(27011);
      }
      props.buttons = [{
        label: BabelStr.str(155),
        type: 'default'
      }, {
        label: BabelStr.str(154),
        type: 'done',
        autoClose: false,
        onClick: function onClick(button, $e) {
          _this._submit();
          return false;
        }
      }];
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDCreateLinkView.prototype), "initialize", this).call(this, props);
      this.$(".thumb-input")[0].addEventListener('change', function (e) {
        _this.onChangeImg(e);
      });
      var self = this;
      if (this.fileInfor) {
        this.$(".islink").val(this.fileInfor.getLinkFileUrl());
        this.$(".link-name").val(this.fileInfor.getFileName());
        if (!this.fileInfor.canRename()) {
          this.$(".rename-per").addClass("f-hide");
        }
        if (!this.fileInfor.canUploadVersionOnlyActions()) {
          this.$(".upload-ver-per").addClass("f-hide");
        }
        var url = MMCommonFun.getImageDispPath(this.fileInfor.getFileId(), -1);
        // 创建Image对象
        var img = new Image();

        // 允许跨域请求（如果需要）
        img.crossOrigin = 'Anonymous';

        // 监听加载完成事件
        img.onload = function () {
          // 创建canvas元素
          var canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;

          // 绘制图像到canvas
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);

          // 将canvas转换为Blob对象
          canvas.toBlob(function (blob) {
            // 创建对象URL
            var url = URL.createObjectURL(blob);
            var img = self.$(".preview");
            img.attr("src", url);
            self.$(".upload").addClass("f-hide");
            img.removeClass("f-hide");
          }, 'image/png');
        };

        // 监听加载错误事件
        img.onerror = function () {
          //  loadingStatus.textContent = 'Failed to load image.';
          console.error('Error loading image:');
        };

        // 开始加载图片
        img.src = url;
      }
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDCreateLinkView.prototype), "className", this).call(this);
      return "".concat(superCls, " create-link-win");
    }
  }, {
    key: "_upload",
    value: function _upload() {
      this.$(".thumb-input").click();
    }
  }, {
    key: "onChangeImg",
    value: function onChangeImg(e) {
      var _this2 = this;
      var file = e.target.files[0];
      if (!file) return;
      var maxSize = 5 * 1024 * 1024;
      if (file.size > maxSize) {
        _MDSnackbarView["default"].show(BabelStr.str(27014));
        return;
      }
      this.imgFile = file;
      // 预览图片
      var reader = new FileReader();
      reader.onload = function (event) {
        var img = _this2.$(".preview");
        img.attr("src", event.target.result);
        img[0].onload = function () {
          _this2.$(".upload").addClass("f-hide");
          img.removeClass("f-hide");
        };
      };
      reader.readAsDataURL(file);
    }
  }, {
    key: "_submit",
    value: function _submit() {
      var _this3 = this;
      if (this.saving) {
        return;
      }
      this.saving = true;
      var validate = this.$("form").validate();
      if (!validate.form()) {
        this.saving = false;
        return;
      }

      // return
      this.setActionButtonDisabledByIndex(true, 1);
      var linkFileUrl = this.$(".islink").val().trim();
      if (!linkFileUrl.startsWith("http")) {
        linkFileUrl = "https://" + linkFileUrl;
      }
      var data = {
        folderId: this.parentId,
        linkFileName: this.$(".link-name").val().trim(),
        // fileSize: 141104,

        // linkFileName: "baidu",
        linkFileUrl: linkFileUrl
      };
      if (this.fileInfor) {
        if (this.imgFile) {
          // data.file = this.imgFile
          // data.fileInfor = this.fileInfor
          _MDfileUploadList["default"].pushFile(this.imgFile, this.fileInfor, undefined, undefined, {
            len: 1
          });
        }
        if (data.linkFileName == this.fileInfor.getFileName() && data.linkFileUrl == this.fileInfor.getLinkFileUrl()) {
          this.saving = false;
          this.close();
          return;
        }
        data.fileInfor = this.fileInfor;
        _MMEnterpriseController["default"].changeLinkFile(data, function (res) {
          console.log(res);
          _this3.fileInfor.setFileName(data.linkFileName);
          _this3.fileInfor.set("linkFileUrl", data.linkFileUrl);
          _this3.setActionButtonDisabledByIndex(false, 1);
          _this3.close();
          _MDSnackbarView["default"].show(BabelStr.str(27013));
        }, function (file, code, msg) {
          _this3.saving = false;
          _this3.setActionButtonDisabledByIndex(false, 1);
          _MDMessageView["default"].error(msg || BabelStr.str(27015), _this3.$body);
        }, console.log);
      } else {
        if (this.imgFile) {
          data.fileName = this.imgFile.name;
          data.fileSize = this.imgFile.size;
          // data.file = this.imgFile
        }
        this.calcMD4(function () {
          if (_this3.imgFile) {
            data.fileHash = _this3.imgFile.hash;
            _this3.imgFile.useFullHash = true;
          }
          _MMEnterpriseController["default"].createLinkFile(data, _this3.imgFile, function (res) {
            console.log(res);
            _this3.setActionButtonDisabledByIndex(false, 1);
            _this3.close();
            _MDSnackbarView["default"].show(BabelStr.str(27006));
          }, function (file, code, msg) {
            _this3.saving = false;
            _this3.setActionButtonDisabledByIndex(false, 1);
            _MDMessageView["default"].error(msg || BabelStr.str(27004), _this3.$body);
          }, console.log);
        });
      }
    }
  }, {
    key: "calcMD4",
    value: function calcMD4(callback) {
      var _this4 = this;
      if (!this.imgFile) {
        callback();
        return;
      }
      if (this.imgFile.hash) {
        callback(this.imgFile.hash);
        return;
      }
      MMNetDiskDataController.calcMd5(this.imgFile, function (sign) {
        callback(_this4.imgFile.hash);
      }, function () {
        // progressCB(file, param.uploadId);
      });
    }
  }]);
  return MDCreateLinkView;
}(_MDWindowView2["default"]);

},{"1098":1098,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1423":1423,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"1487":1487,"1496":1496,"1498":1498,"1538":1538,"1543":1543,"1545":1545,"345":345,"55":55,"72":72,"93":93}],485:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDClientSyncSelectWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDClientSyncSelectWinView, _MDWindowView);
  function MDClientSyncSelectWinView() {
    (0, _classCallCheck2["default"])(this, MDClientSyncSelectWinView);
    return _callSuper(this, MDClientSyncSelectWinView, arguments);
  }
  (0, _createClass2["default"])(MDClientSyncSelectWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n      <div class=\"col-9 area-setting radio-group\">\n\n        <div data-synctype=0 class=\"setting-item checked  mgr-10 radio-box\"><%=BabelStr.str(5455)%></div>\n        <p class=\"help-block mgl-20\"><%=BabelStr.str(5456)%></p>\n        <div data-syncType=2 class=\"setting-item mgt-15 mgr-10 radio-box \"><%=BabelStr.str(5457)%></div>\n        <p class=\"help-block mgl-20\"><%=BabelStr.str(5458)%></p>\n      </div>\n      <div class='flex-align end'>\n        <div class='button cancel mgr-10'><%=BabelStr.str(155)%></div>\n        <div class='button done save'><%=BabelStr.str(154)%></div>\n      </div>\n    ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDClientSyncSelectWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " m-client-sync-win");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDClientSyncSelectWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .radio-box': this._radioBoxClickHandle,
        'click .save': this.save,
        'click .cancel': this.cancel
      });
    }
  }, {
    key: "_radioBoxClickHandle",
    value: function _radioBoxClickHandle($e) {
      this.$('.radio-box').removeClass('checked');
      $($e.target).addClass('checked');
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      props.title = BabelStr.str(5454);
      props.width = 600;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDClientSyncSelectWinView.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.close();
    }
  }, {
    key: "save",
    value: function save() {
      var type = this.$('.checked').data('synctype');
      this.onSave(type);
      this.close();
    }
  }]);
  return MDClientSyncSelectWinView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"93":93}],479:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1429);
require(1439);
require(1498);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDRoleSelectView = _interopRequireDefault(require(515));
var _MDSnackbarView = _interopRequireDefault(require(72));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDApplicationRenamePerWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDApplicationRenamePerWinView, _MDWindowView);
  function MDApplicationRenamePerWinView() {
    (0, _classCallCheck2["default"])(this, MDApplicationRenamePerWinView);
    return _callSuper(this, MDApplicationRenamePerWinView, arguments);
  }
  (0, _createClass2["default"])(MDApplicationRenamePerWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<div class=\"help-block\">\n      <%=BabelStr.str(4721)%>\n    </div>\n    <div class=\"row inv-manager-block mgt-10 f-hide flex-align mgb-20\">\n      <div class=\"item-title no-shrink col-3\"><%=BabelStr.str(21215)%></div>\n      <div class=\"inv-manager-list gap-10 col-9 flex-align with-wrap\"></div>\n    </div>\n\n    <div class=\"row mgb-10 mgt-20\">\n      <div class=\"col-3\"><%=BabelStr.str(6311)%></div>\n      <div class=\"col-9\"><%=fileName%></div>\n    </div>\n    <form  >\n    <div class=\"row mgb-10 mgt-20\">\n      <div class=\"col-3\"><%=BabelStr.str(6312)%></div>\n        <div class=\"col-9\">\n          <input name=\"fileName\" testFileName  required type=\"text\"  id=\"renameInput\" class=\"form-control testFileNameEnd notempty testFileName\" maxlength=\"100\" palceholder=\"<%=BabelStr.str(158)%>\"/>\n        </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-3\"><%=BabelStr.str(4723)%></div>\n      <div class=\"col-9\">\n        <textarea name=\"\" maxlength=\"100\" id=\"\" cols=\"30\" rows=\"10\" class=\"form-control textinput\"></textarea>\n      </div>\n    </div>\n    </form>\n    <div class=\"flex-align end mgt-20 btns-block\">\n    <button class=\"button cancel\"><%=BabelStr.str(155)%></button>\n    <button class=\"button done save\"><%=BabelStr.str(4724)%></button>\n    </div>\n    ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDApplicationRenamePerWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {});
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDApplicationRenamePerWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " application-rename-per-win application-per-win");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDApplicationRenamePerWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .cancel': this.close,
        'click .save': this.save
      });
    }
  }, {
    key: "render",
    value: function render() {
      var data = {
        fileName: MMCommonFun.getFileNameWithoutExtension(this.fileInfor.getFileName()),
        rename: this.rename
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDApplicationRenamePerWinView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      var _this = this;
      opt.title = BabelStr.str(6313);
      opt.needFooter = false;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDApplicationRenamePerWinView.prototype), "initialize", this).call(this, opt);
      if (this.rename) {
        this.$('form').submit(false);
        this.$('form').validate({
          rules: {
            'fileName': {
              'required': true,
              'maxlength': 100
            }
          },
          messages: {
            'fileName': {
              'required': BabelStr.str(7198),
              'maxlength': BabelStr.str(7199)
            }
          }
        });
      }
      MMEnterpriseController.getEditFileApprovers(this.fileInfor.getFileId(), function (approverInfos) {
        _this.renderEditManager(approverInfos);
      });
    }
  }, {
    key: "renderEditManager",
    value: function renderEditManager(managerInfos) {
      if (!managerInfos || !managerInfos.length) {
        return;
      }
      managerInfos = managerInfos.slice(0, 5);
      var tmpl = '';
      _.each(managerInfos, function (user) {
        tmpl += "\n        <div class=\"manager-item flex-align middle\">\n          <div class=\"manager-icon icon no-shrink\"></div>\n          <span class=\"name middle-ellipsis\">".concat(user.name || user.phone, "</span>\n        </div>\n      ");
      });
      this.$(".inv-manager-list").html(tmpl);
      this.$(".inv-manager-block").removeClass("f-hide");
    }
  }, {
    key: "save",
    value: function save() {
      var _this2 = this;
      var msg = this.$('textarea').val().trim();
      _czc && _czc.push(["_trackEvent", "权限", "申请增加权限", "", "", ""]);
      var originName = this.fileInfor.getFileName();
      var newName = $.trim(this.$("#renameInput").val());
      var validator = this.$('form').validate();
      if (validator.form()) {
        // if(this.fileInfor.get("multFile")) {
        //   this.multFileRename(newName)
        // } else {
        if (!this.fileInfor.isFolder()) {
          originName = MMCommonFun.getFileNameWithoutExtension(originName);
        }
        if (newName == originName) {
          this.close();
        } else {
          newName = this.fileInfor.isFolder() ? newName : newName + "." + this.fileInfor.getFileExtension();
          // this._postRename( newName);
          console.log(newName);
          MMEnterpriseController.applyRenameFiles(this.fileInfor.getFileId(), newName, msg, function () {
            _MDSnackbarView["default"].show(BabelStr.str(308));
            _this2.close();
          }, function (code, msg) {
            if (code == 20001) {
              _MDSnackbarView["default"].show(BabelStr.str(7506));
              return;
            }
            _MDSnackbarView["default"].show(msg, {
              code: code
            });
          });
        }
        // }
      } //
    }
  }]);
  return MDApplicationRenamePerWinView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1429":1429,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"1498":1498,"515":515,"72":72,"93":93}],478:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1429);
require(1439);
require(1417);
require(1463);
require(1498);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDRoleSelectView = _interopRequireDefault(require(515));
var _MDSnackbarView = _interopRequireDefault(require(72));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDApplicationPerWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDApplicationPerWinView, _MDWindowView);
  function MDApplicationPerWinView() {
    (0, _classCallCheck2["default"])(this, MDApplicationPerWinView);
    return _callSuper(this, MDApplicationPerWinView, arguments);
  }
  (0, _createClass2["default"])(MDApplicationPerWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<div class=\"help-block\">\n\t\t\t<%=BabelStr.str(4735)%>\n\t\t</div>\n    <div class=\"row inv-manager-block mgt-10 f-hide flex-align mgb-10\">\n      <div class=\"item-title no-shrink col-3\"><%=BabelStr.str(21215)%></div>\n      <div class=\"inv-manager-list gap-10 col-9 flex-align with-wrap\"></div>\n    </div>\n\n\t\t<div class=\"row mgb-10 mgt-10\">\n\t\t\t<div class=\"col-3\"><%=BabelStr.str(4722)%></div>\n\t\t\t<div class=\"select-container col-4\"></div>\n\t\t</div>\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-3\"><%=BabelStr.str(4723)%></div>\n\t\t\t<div class=\"col-9\">\n\t\t\t\t<textarea name=\"\" id=\"\" cols=\"30\" rows=\"10\" class=\"form-control\"></textarea>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"flex-align end mgt-20 btns-block\">\n\t\t<button class=\"button cancel\"><%=BabelStr.str(155)%></button>\n\t\t<button class=\"button done save\"><%=BabelStr.str(4724)%></button>\n\t\t</div>\n\t\t";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDApplicationPerWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {});
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDApplicationPerWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " application-per-win");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDApplicationPerWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .cancel': this.close,
        'click .save': this.save
      });
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      var _this = this;
      opt.title = BabelStr.str(4720);
      opt.needFooter = false;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDApplicationPerWinView.prototype), "initialize", this).call(this, opt);
      this.renderRoleSelect();
      MMEnterpriseController.getEditFileApprovers(this.fileInfors[0].getFileId(), function (approverInfos) {
        _this.renderEditManager(approverInfos);
      });
    }
  }, {
    key: "renderEditManager",
    value: function renderEditManager(managerInfos) {
      if (!managerInfos || !managerInfos.length) {
        return;
      }
      managerInfos = managerInfos.slice(0, 5);
      var tmpl = '';
      _.each(managerInfos, function (user) {
        tmpl += "\n        <div class=\"manager-item flex-align middle\">\n          <div class=\"manager-icon icon no-shrink\"></div>\n          <span class=\"name middle-ellipsis\">".concat(user.name || user.phone, "</span>\n        </div>\n      ");
      });
      this.$(".inv-manager-list").html(tmpl);
      this.$(".inv-manager-block").removeClass("f-hide");
    }
  }, {
    key: "renderRoleSelect",
    value: function renderRoleSelect() {
      var _this2 = this;
      var epId = this.fileInfors[0].getEnterpriseId();
      MMNetDiskDataController.getAllRolesByEpId(epId, function (roleCollection, defaultRoleId) {
        var roles = roleCollection.models;
        _this2.roleSelectView = new _MDRoleSelectView["default"]({
          onRoleChanged: function onRoleChanged(role) {
            _this2.checkedRoleId = role.getRoleId();
            console.log(_this2.checkedRoleId);
          }
        });
        _this2.roleSelectView.setRoles(roles);
        var defaultRole = _.find(roles, function (role) {
          return role.get('id') == defaultRoleId;
        });
        defaultRole = defaultRole || roles[0];
        _this2.roleSelectView.selectRole(defaultRole);
        _this2.addSubView(_this2.roleSelectView, _this2.$('.select-container')[0]);
      });
    }
  }, {
    key: "save",
    value: function save() {
      var _this3 = this;
      var msg = this.$('textarea').val().trim();
      _czc && _czc.push(["_trackEvent", "权限", "申请增加权限", "", "", ""]);
      var ids = [];
      for (var i = 0; i < this.fileInfors.length; i++) {
        ids.push(this.fileInfors[i].getFileId());
      }
      MMEnterpriseController.applyRoleForFiles(ids, this.checkedRoleId, msg, function () {
        _MDSnackbarView["default"].show(BabelStr.str(308));
        _this3.close();
      }, function (code, msg) {
        if (code == 801) {
          _MDSnackbarView["default"].show(BabelStr.str(3734));
        } else {
          _MDSnackbarView["default"].show(msg);
        }
      });
    }
  }]);
  return MDApplicationPerWinView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1417":1417,"1429":1429,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"1498":1498,"515":515,"72":72,"93":93}],477:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1429);
require(1439);
require(1498);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDChooseFolderWindow = _interopRequireDefault(require(483));
var _MDRoleSelectView = _interopRequireDefault(require(515));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDMessageView = _interopRequireDefault(require(55));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDApplicationMovePerWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDApplicationMovePerWinView, _MDWindowView);
  function MDApplicationMovePerWinView() {
    (0, _classCallCheck2["default"])(this, MDApplicationMovePerWinView);
    return _callSuper(this, MDApplicationMovePerWinView, arguments);
  }
  (0, _createClass2["default"])(MDApplicationMovePerWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<div class=\"help-block\">\n      <%=BabelStr.str(4732)%>\n    </div>\n    <div class=\"row inv-manager-block mgt-10 f-hide flex-align mgb-20\">\n      <div class=\"item-title no-shrink col-3\"><%=BabelStr.str(21215)%></div>\n      <div class=\"inv-manager-list gap-10 col-9 flex-align with-wrap\"></div>\n    </div>\n    <div class=\"row mgb-10 mgt-20\">\n      <div class=\"col-3\"><%=BabelStr.str(6316)%></div>\n      <label class=\"positionstr\"></label>\n    </div>\n    <div class=\"row mgb-10 mgt-20\">\n      <div class=\"col-3\"><%=BabelStr.str(6317)%></div>\n      <div class=\"col-9\">\n        <label class=\"mgr-20 cur-pos f-hide\"></label>\n        <label class=\"otherPos  text-button done\">  <%=BabelStr.str(3288)%></label>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-3\"><%=BabelStr.str(4723)%></div>\n      <div class=\"col-9\">\n        <textarea name=\"\" maxlength=\"100\" id=\"\" cols=\"30\" rows=\"10\" class=\"form-control\"></textarea>\n      </div>\n    </div>\n    <div class=\"flex-align end mgt-20 btns-block\">\n    <button class=\"button cancel\"><%=BabelStr.str(155)%></button>\n    <button class=\"button done save\"><%=BabelStr.str(4724)%></button>\n    </div>\n    ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDApplicationMovePerWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {});
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDApplicationMovePerWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " application-move-per-win application-per-win");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDApplicationMovePerWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .cancel': this.close,
        'click .save': this.save,
        'click .otherPos': this._checkOtherPosition
      });
    }
  }, {
    key: "render",
    value: function render() {
      var data = {
        rename: this.rename
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDApplicationMovePerWinView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      var _this = this;
      opt.title = BabelStr.str(6314);
      opt.needFooter = false;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDApplicationMovePerWinView.prototype), "initialize", this).call(this, opt);
      var path = app.pathRouter.getFilePathsNameStr();
      this.$(".positionstr").html(path);
      MMEnterpriseController.getEditFileApprovers(this.fileInfor.getFileId(), function (approverInfos) {
        _this.renderEditManager(approverInfos);
      });
    }
  }, {
    key: "_checkOtherPosition",
    value: function _checkOtherPosition() {
      var _this2 = this;
      var folderView = new _MDChooseFolderWindow["default"]({
        onlyDepFolder: true,
        onchecked: function onchecked(folderId, pathStr) {
          _this2.checkFolderCallback(folderId, pathStr);
        }
      });
      folderView.show();
    }
  }, {
    key: "renderEditManager",
    value: function renderEditManager(managerInfos) {
      if (!managerInfos || !managerInfos.length) {
        return;
      }
      managerInfos = managerInfos.slice(0, 5);
      var tmpl = '';
      _.each(managerInfos, function (user) {
        tmpl += "\n        <div class=\"manager-item flex-align middle\">\n          <div class=\"manager-icon icon no-shrink\"></div>\n          <span class=\"name middle-ellipsis\">".concat(user.name || user.phone, "</span>\n        </div>\n      ");
      });
      this.$(".inv-manager-list").html(tmpl);
      this.$(".inv-manager-block").removeClass("f-hide");
    }
  }, {
    key: "checkFolderCallback",
    value: function checkFolderCallback(folderId, pathStr) {
      this.parentId = folderId;
      this.$('.cur-pos').removeClass("f-hide");
      this.$(".cur-pos").html(pathStr);
    }
  }, {
    key: "save",
    value: function save() {
      var _this3 = this;
      if (!this.parentId) {
        this.$('.cur-pos').removeClass("f-hide");
        this.$(".cur-pos").html("<label class=\"red\">".concat(BabelStr.str(7197), "</label>"));
        return;
      }
      if (this.parentId == '0') {
        _MDMessageView["default"].error(BabelStr.str(6326), this.getBody$El());
        this.$('.cur-pos').removeClass("f-hide");
        this.$(".cur-pos").html("<label class=\"red\">".concat(BabelStr.str(7197), "</label>"));
        return;
      }
      var msg = this.$('textarea').val().trim();
      MMEnterpriseController.applyMoveFiles(this.fileInfor.getFileId(), this.parentId, msg, function () {
        _MDSnackbarView["default"].show(BabelStr.str(308));
        _this3.close();
      }, function (code, msg) {
        _MDSnackbarView["default"].show(msg, {
          code: code
        });
      });
    }
  }]);
  return MDApplicationMovePerWinView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1429":1429,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"1498":1498,"483":483,"515":515,"55":55,"72":72,"93":93}],419:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MMViewBase = _interopRequireDefault(require(22));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDCommonFileEditorController = _interopRequireDefault(require(410));
var _MMBasicData = _interopRequireDefault(require(811));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDEvaluationToolbar = _interopRequireDefault(require(470));
/**
 *  file editor view, slide between different files, check comments, add comments
 *  Create by jiang
 *  2015.9.9
 */

var MDOfficeEditor4PC = _MDCommonFileEditorController["default"].extend(function () {
  return {
    el: '<div class="p-editor-root"></div>',
    tmpl: "<iframe id=\"office-frame\" class=\"office-frame\"></iframe>\n            <button id=\"close-office-btn\" class=\"close-office-btn\"><%=BabelStr.str(5070)%>\n            <span class=\"icon ic-close close-btn\"></span>\n          </button>",
    initProps: function initProps() {
      var superP = _MDCommonFileEditorController["default"].prototype.initProps.call(this);
      return _.extend(superP, {});
    },
    initialize: function initialize(opt) {
      _MDCommonFileEditorController["default"].prototype.initialize.call(this, opt);
      var z_startIndex = _MMBasicData["default"].getO2OStartLayerZ_index();
      this.bindSelf(this._windowResizeHandler);
      $(window).on('resize.fileEditor', _.debounce(this._windowResizeHandler, 500));
      application.addSubView(this);
    },
    events: function events() {
      return {
        'click #close-office-btn': this._closeClicked
      };
    },
    _windowResizeHandler: function _windowResizeHandler() {},
    editFile: function editFile(fileInfo, ver) {
      this.fileInfo = fileInfo;
      var self = this;
      var fileId = fileInfo.getFileId();
      var url = '/netdrive/getFileEditUrl.do';
      if (ver == undefined || ver == null) {
        ver = fileInfo.getCurVersion();
      }
      this.ver = ver;
      var postData = {};
      postData['fileId'] = fileId;
      postData['version'] = ver;
      _MDSpinnerloaderView["default"].showIn($('.p-editor-root')[0]);
      $.ajax({
        method: 'post',
        url: url,
        data: postData,
        success: function success(responseData, textStatus, jqXHR) {
          if (responseData["success"] === true) {
            var editorUrl = responseData["url"];
            if (editorUrl) {
              self.$('#office-frame').attr('src', editorUrl);
              self.$('#office-frame')[0].onload = function () {
                _MDSpinnerloaderView["default"].clearFrom($('.p-editor-root')[0]);
                self.$('#office-frame')[0].onload = null;
              };
            } else {
              _MDSpinnerloaderView["default"].clearFrom($('.p-editor-root')[0]);
            }
          } else {
            _MDSpinnerloaderView["default"].clearFrom($('.p-editor-root')[0]);
            var alert = new _MDAlertView["default"]();
            var z_maxIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
            alert.$el.css('z-index', z_maxIndex);
            var title = responseData["msg"];
            var msg = '<p class="title">' + title + '</p>';
            alert.show({
              title: BabelStr.str(170),
              message: msg,
              className: 'm-delAlertWin',
              width: MMCommonFun.isInMobile() ? 300 : 470,
              onHide: function onHide() {},
              buttons: [{
                label: BabelStr.str(154),
                type: 'done',
                onClick: function onClick() {
                  self.close(true);
                }
              }]
            });
          }
        }
      });
    },
    _closeClicked: function _closeClicked(e) {
      this.close();
    },
    close: function close(notUpdate) {
      var self = this;
      if (notUpdate) {
        self.removeFromSuperView();
        if (self.callback) {
          self.callback();
        }
        ;
        return;
      }
      ;
      var fileId = this.fileInfo.getFileId();
      var url = '/netdrive/saveFileAsNewVersion.do';
      var postData = {};
      postData['fileId'] = fileId;
      postData['version'] = this.ver;
      _MDSpinnerloaderView["default"].showIn($('.p-editor-root')[0]);
      $.ajax({
        method: 'post',
        url: url,
        data: postData,
        success: function success(responseData, textStatus, jqXHR) {
          if (responseData["success"] === true) {
            MMNetDiskDataController.updateFileInfoFromServer(self.fileInfo, function () {
              MMWhiteboardController.closeWhiteboard(fileId);
              var fileEditor = viewManager.get('fileEditor');
              if (fileEditor) {
                var ver = self.fileInfo.getCurVersion();
                if (self.fileInfo.getPassowrdByVersion(ver)) {
                  fileEditor.displayFiles(null, self.fileInfo, ver, true);
                } else {
                  fileEditor.close();
                }
              }
            });
          } else {}
          self.removeFromSuperView();
          if (self.callback) {
            self.callback();
          }
          ;
        }
      });
    },
    viewWillUnRendered: function viewWillUnRendered() {
      _MDCommonFileEditorController["default"].prototype.viewWillUnRendered.call(this);
    }
  };
}());
var _default = exports["default"] = MDOfficeEditor4PC;

},{"1184":1184,"1454":1454,"22":22,"32":32,"410":410,"470":470,"72":72,"76":76,"811":811}],352:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDDisplayFileController = _interopRequireDefault(require(411));
var _MDMobileFileEditorController = _interopRequireDefault(require(451));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MMFileInfo = _interopRequireDefault(require(297));
var _MDAlertView = _interopRequireDefault(require(32));
var _MMCommonFun = _interopRequireDefault(require(812));
//
// 类结构图 - 手机版的显示控制 (PC 版参见 MDPCDisplayFileController)
//
// 类结构如下（+ 代表包含）：
//
// MDMDisplayFileController
//           +———  MDMobileFileEditorController
//                      +——— MMNetDiskImageCollectionView - 图片
//                      |     +--- MMNetDiskBoardCell
//                      |     |      +--- MMMobilePageView
//                      |     |
//                      |     +--- MMOperationCenterMobileImage
//                      |
//                      +——— MMPDFCollectionView  - 非图片
//                      |     +--- MMPdfPageCell
//                      |            +--- MMMobilePageView
//                      |            +--- (PC) MDPCPdfPageView
//                      |
//                      |
//                      +--- MDTopToolbar4Wc
//                      +--- MDBottomToolbar4Wc
//                      +--- MDMPdfPageNoBar
//                      |
//                      +--- MDMPdfCommentNumberBar
//

var MDMDisplayFileController = function MDMDisplayFileController() {
  _MDDisplayFileController["default"].apply(this, arguments);
};
MDMDisplayFileController.prototype = new _MDDisplayFileController["default"]();
MDMDisplayFileController.prototype.constructor = MDMDisplayFileController;
_.extend(MDMDisplayFileController.prototype, {
  openFiles4Mobile: function openFiles4Mobile(param, fileInfo, version, onCloseCb, openCb, fileInforChangeCb) {
    var self = this;
    if (window.canUseOnlyOffice && (fileInfo.isExel() && window.readExcelWithOnlyOffice == 1 || fileInfo.isOfficeFile() && window.user.hasWindowsServer == 0)) {
      var v = version;
      if (isNaN(v)) {
        v = -1;
      }
      if (fileInfo.canUploadVersion() && (v == -1 || v == fileInfo.getCurVersion())) {
        _MMCommonFun["default"].openOffice2Edit(fileInfo.getFileId());
      } else {
        _MMCommonFun["default"].openExcel2Read(fileInfo.getFileId(), v, true);
      }

      // window.open("/netdrive/openFileByBabelOffice.do?fileId=" + fileInfo.getFileId() + "&readOnly=1&version=" + v);
      openCb && openCb(true);
      return;
    } else if (fileInfo.dispWithMS360() && window.officeOnlineHost && window.officeOnlineHost.length > 0) {
      var fileId = fileInfo.getFileId();
      var url = '/netdrive/getOfficeOnlineViewUrl.do';
      var ver = fileInfo.getCurVersion();
      var postData = {};
      postData['fileId'] = fileId;
      postData['version'] = ver;
      $.ajax({
        method: 'post',
        url: url,
        data: postData,
        success: function success(responseData, textStatus, jqXHR) {
          if (responseData["success"] === true) {
            var url = responseData["url"];
            if (url) {
              location.href = url;
            }
          } else if (responseData["code"] == 207) {
            _MDAlertView["default"].showStandardPrompt({
              message: "该分享需要登录后再试！"
            });
          } else {
            _MDAlertView["default"].showStandardPrompt({
              message: "该分享已经失效！"
            });
          }
        }
      });
      return;
    } else if (window.isSharePage && fileInfo.canDownload()) {
      // var fileId = fileInfo.getFileId();
      // var url = null;
      // var ver = fileInfo.getCurVersion();
      // var postData = {};
      // postData['fileId'] = fileId;
      // postData['version'] = ver;
      // if (fileInfo.isImage()) {
      //   postData['size'] = 1080;
      //   url = "/netdrive/downloadDisplayImage.do"
      // } else if (fileInfo.isPdf()) {
      //   url = "/netdrive/getOriginFileUrl.do"
      // }
      // if (url) {
      //   $.ajax({
      //     method: 'get',
      //     url: url,
      //     data: postData,
      //     success: function(responseData, textStatus, jqXHR) {
      //       if (responseData["success"] === true) {
      //         var url = responseData["url"];
      //         if (url) {
      //           location.href=url;
      //         }
      //       } else if(responseData["code"] == 207) {
      //         MDAlertView.showStandardPrompt({
      //           message: "该分享需要登录后再试！"
      //         })
      //       } else {
      //         MDAlertView.showStandardPrompt({
      //           message: "该分享已经失效！"
      //         })
      //       }
      //     },
      //   });
      //   return;
      // }
    }

    // if (fileInfo.dispWithMS360()) {
    //   if (fileInfo.canDownload()) {
    //     MMCommonFun.getDownloadRealPath(fileInfo.getFileId(), fileInfo.getCurVersion(), (url)=>{
    //     // ----------  微软不允许 iframe 嵌套
    //     location.href = "https://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(url);
    //   })
    //   } else {
    //     MDAlertView.showStandardPrompt({
    //       message: "手机预览此文件需要下载权限！"
    //     })
    //   }

    //   return;
    // }

    _MMFileInfo["default"].prepareLinkedFileInfo(fileInfo, function () {
      if (fileInfo.isShortcuts()) {
        fileInfo = fileInfo.getShortCutsTargetFile();
      }
      var versionInfo = fileInfo.getVersionInfo(version);
      var checkParam = {
        fileInfo: fileInfo,
        verInfo: versionInfo,
        disableAlert: param.disableAlert
      };
      self.checkToAlertCannotDisp(checkParam, function (canOpen) {
        if (!canOpen) {
          if (_.isFunction(openCb)) {
            openCb(false);
          }
          return;
        }
        var curFileId = fileInfo.getFileId();
        var curFileName = fileInfo.getFileName();
        var curVersion = fileInfo.getCurVersion();
        var fileList = [];
        var parentId = fileInfo.get('parentId');
        fileList = [fileInfo];
        self._dispFilesForMobile(fileList, fileInfo, version, onCloseCb);

        // // 如果选中的是图片，则可以浏览所有图片
        // if (MMCommonFun.isImageName(curFileName)) {
        //   MMNetDiskDataController.getImageFilesInFolder(parentId, function(fileList) {
        //     self._dispFilesForMobile(fileList, fileInfo, version, onCloseCb, fileInforChangeCb);
        //   }, function fail() {
        //     console.error("get display file error!")
        //   });
        //   // 否则，只能单张阅读
        // } else {
        //   fileList = [fileInfo];
        //   self._dispFilesForMobile(fileList, fileInfo, version, onCloseCb);
        // }
      });
    });
    if (_.isFunction(openCb)) {
      openCb(true);
    }
  },
  _dispFilesForMobile: function _dispFilesForMobile(fileList, fileInfo, version, onCloseCb, fileInforChangeCb) {
    var self = this;
    var editor = viewManager.get('fileEditor');
    if (fileList.length > 0 && self._includeFile(fileList, fileInfo.get("fileId"))) {
      if (!editor) {
        editor = new _MDMobileFileEditorController["default"]({
          onClose: function onClose(fileInfo) {
            _.isFunction(onCloseCb) && onCloseCb();
            getPdfPageLoader().clear();
          },
          onFileInforChanged: function onFileInforChanged(fileInfo) {
            if (app.isFromSharePage) {
              _.isFunction(fileInforChangeCb) && fileInforChangeCb(fileInfo);
              return;
            } else {
              var router = 'file/' + fileInfo.getFileId();
              app.pathRouter.navigate(router);
            }
          }
        });
        app.application.addSubView(editor);
        editor.displayFiles(fileList, fileInfo);
      } else {
        editor.displayFiles(fileList, fileInfo);
      }
    }
  },
  /**
   * 打开文件，不支持路由
   * @param  {[type]} fileInfo [description]
   * @param  {[type]} version  [description]
   * @param  {[type]} closeCb  [description]
   * @return {[type]}          [description]
   */
  openFileWithoutRouter: function openFileWithoutRouter(fileInfo, version, closeCb) {
    var self = this;
    var checkParam = {
      fileInfo: fileInfo
    };
    self.checkToAlertCannotDisp(checkParam, function (canOpen) {
      if (!canOpen) {
        return;
      }
      var editor = new _MDMobileFileEditorController["default"]({
        onClose: function onClose(fileInfo) {
          _.isFunction(closeCb) && closeCb();
          getPdfPageLoader().clear();
        }
      });
      application.addSubView(editor);
      editor.displayFiles([fileInfo], fileInfo, version);
    });
  }
});
var _default = exports["default"] = MDMDisplayFileController;

},{"1104":1104,"1184":1184,"1454":1454,"297":297,"32":32,"411":411,"451":451,"812":812}],451:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDEditorOption = _interopRequireDefault(require(905));
var _MMNetDiskImageCollectionView = _interopRequireDefault(require(938));
var _MMPDFCollectionView = _interopRequireDefault(require(931));
var _MDTopToolbar4Wc = _interopRequireDefault(require(452));
var _MMWhiteboardController = _interopRequireDefault(require(1109));
var _MDBottomToolbar4Wc = _interopRequireDefault(require(446));
var _app = _interopRequireDefault(require(17));
var _MDCommonFileEditorController = _interopRequireDefault(require(410));
var _MDMPdfPageNoBar = _interopRequireDefault(require(450));
var _MMOperationCenterMobileMarker = _interopRequireDefault(require(880));
var _MD3DEditor = _interopRequireDefault(require(9));
var _MMBasicData = _interopRequireDefault(require(811));
var _MDMPdfCommentNumberBar = _interopRequireDefault(require(449));
var _MDTouchMenu = _interopRequireDefault(require(339));
var _ObjType = _interopRequireDefault(require(1084));
var _EditorMode = _interopRequireDefault(require(904));
var _MDTextFileBrowser = _interopRequireDefault(require(231));
var _MDKityMinderFileEditor = _interopRequireDefault(require(229));
var _MMImageMarkerCtl = _interopRequireDefault(require(915));
var _MMOperationCenterMobileImage = _interopRequireDefault(require(879));
var _MDAVFileBrowser = _interopRequireDefault(require(16));
var _MDHtmlRender = _interopRequireDefault(require(222));
var _MDMailDisplayView = _interopRequireDefault(require(230));
var _MDMSOfficeEditor = _interopRequireDefault(require(12));
var _MDTipTapEditor = _interopRequireDefault(require(1132));
/**
 *  file editor view, slide between different files, check comments, add comments
 *  Create by jiang
 *  2015.9.9
 */

var MDMobileFileEditorController = _MDCommonFileEditorController["default"].extend({
  el: '<div class="m-editor-root"></div>',
  tmpl: '<div class="m-mobile-mask"></div>' + '<div class="m-editor-zone"></div>' + '<div class="m-progress-root">' + '<div class="m-progress-bar"></div>' + '</div>',
  initProps: function initProps() {
    var superP = _MDCommonFileEditorController["default"].prototype.events.call(this);
    return _.extend(superP, {
      editor: null,
      topToolBar: null,
      bottomToolBar: null,
      pdfPageNoBar: null,
      rightZone: null,
      toggling: false,
      // 是否正在切换打开右侧面板

      progress: 0,
      postClose: null,
      onFileInforChanged: _.noop
    });
  },
  initialize: function initialize(opt) {
    _MDCommonFileEditorController["default"].prototype.initialize.call(this, opt);

    // 微信
    this.inWeChat = _app["default"].isFromWechat();
    var z_startIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
    $(this.$(".m-progress-root")).css('z-index', z_startIndex);
    this.pdfPageNoBar = new _MDMPdfPageNoBar["default"]();
    this.addSubView(this.pdfPageNoBar, this.$(".m-editor-zone")[0]);
    this.pdfCommentCountBar = new _MDMPdfCommentNumberBar["default"]();
    this.addSubView(this.pdfCommentCountBar, this.$(".m-editor-zone")[0]);
    this.topToolBar = new _MDTopToolbar4Wc["default"]();
    this.addSubView(this.topToolBar);
    if (this.inWeChat) {
      this.bottomToolBar = new _MDBottomToolbar4Wc["default"]();
    }
    Dispatcher.on(MDEvents.DISPLAY_PDF_BAR, this.showPdfPageNoBar, this);
    Dispatcher.on(MDEvents.SET_PAGE_INDEX, this._pageChanged, this);
    this.bindSelf(this._windowResizeHandler);
    this._windowResizeHandler = _.throttle(this._windowResizeHandler, 100);
    $(window).on(this.$nsEventName('resize'), this._windowResizeHandler);
    viewManager.set('fileEditor', this);
  },
  _windowResizeHandler: function _windowResizeHandler() {
    this.editor && this.editor.refreshSize();
    _MMImageMarkerCtl["default"].refreshSize();
  },
  setEditorViewCtl: function setEditorViewCtl(editor) {
    var self = this;
    this.editor = editor;
    if (this.topToolBar) this.topToolBar.setEditorViewCtl(self);
    if (this.bottomToolBar) this.bottomToolBar.setEditorViewCtl(self);
    this.pdfPageNoBar.setEditorViewCtl(self);
    this.pdfCommentCountBar.setEditorViewCtl(self);
  },
  _pageChanged: function _pageChanged() {
    this.topToolBar.updatePgInfo();
    var board = this.editor.getCurrentBoard();
    var fileInfor = board.getFileInfo();
    _.isFunction(this.onFileInforChanged) && this.onFileInforChanged(fileInfor);
  },
  _displayeOfficeByMS: function _displayeOfficeByMS(fileInfo, version) {
    var self = this;
    var curFileInfo = fileInfo;
    self.editor = new _MDMSOfficeEditor["default"](self.$(".m-editor-zone")[0]);
    self.editor.openFile(curFileInfo, curFileInfo.getCurVersion(), function () {});
    _MMNetDiskImageCollectionView["default"].setCurrentInstance(self.editor);
    MDPcMobileEditorCommonFun.setMainEditor(self.editor);
    if (self.curPg > 0) {
      self.editor.changeToPage(self.curPg);
    }
    var fileId = curFileInfo.get("fileId");
    var fileName = curFileInfo.getFileName();
    self.topToolBar.displayPageInfo(self.curPg + 1, self.pgCount, fileId, fileName);
  },
  displayFiles: function displayFiles(fileInfos, curFileInfo, version, opt_silent) {
    // MDEditorOption.restorehDefault();

    var self = this;
    if (curFileInfo.dispWithMS360()) {
      this._displayeOfficeByMS(curFileInfo, version);
      return;
    }
    this.openBoards(fileInfos, curFileInfo, function success(boardsOpened) {
      self.versionShowing = curFileInfo.getCurVersion();
      if (fileInfos.length > 1 || fileInfos.length == 1 && fileInfos[0].isImage()) {
        if (self.editor) {
          self.editor.removeFromSuperView();
        }
        ;
        var params = {
          boardArr: boardsOpened,
          containerDiv: self.$(".m-editor-zone")[0],
          editorViewCtl: self,
          curFileIndex: self.curPg
        };
        self.editor = new _MMNetDiskImageCollectionView["default"](params);
      } else if (curFileInfo.canDispInOpenGL()) {
        if (self.editor) {
          self.editor.removeFromSuperView();
        }
        ;
        self.editor = new _MD3DEditor["default"](self.$(".m-editor-zone")[0]);
        var board = boardsOpened[0];
        var commentFile = board;
        board.getDispFilePath(curFileInfo, version, function (path, type, key) {
          self.editor.initWith3DFile(curFileInfo, commentFile, path, function () {
            // if (comment) {
            //   self.editor.focusComment(comment);
            // };
          }, key);
        });
      } else if (curFileInfo.canDispInWebBrowser()) {
        if (window.dispHtmlInIframe) {
          self.editor = new _MDHtmlRender["default"](self.$(".m-editor-zone")[0], {
            editorViewCtl: this
          });
          var board = boardsOpened[0];
          var commentFile = board;

          // board.setVersionShowing(curFileInfo.getCurVersion());

          board.getDispFilePath(curFileInfo, version, function (path) {
            self.editor.initWithHtmlFile(curFileInfo, commentFile, path, function () {

              // if (callback) {
              //   callback();
              // };
            });
          });
        } else {
          self.editor = new _MDTextFileBrowser["default"](self.$(".m-editor-zone")[0]);
          self.editor.openFile(curFileInfo, curFileInfo.getCurVersion());
          Dispatcher.trigger(MDEvents.HIDE_ZOOM_BAR);
        }
      } else if (!curFileInfo.dispNeedWhiteBoard()) {
        if (curFileInfo.canDispWithKityMinder()) {
          self.editor = new _MDKityMinderFileEditor["default"](self.$(".m-editor-zone")[0]);
          self.editor.openFile(curFileInfo, curFileInfo.getCurVersion());
        } else if (curFileInfo.isBabelOffice()) {
          self.editor = new _MDTipTapEditor["default"](self.$(".m-editor-zone")[0]);
          self.editor.openFile(curFileInfo, curFileInfo.getCurVersion());
        } else if (curFileInfo.canDispWithTextBrowser()) {
          self.editor = new _MDTextFileBrowser["default"](self.$(".m-editor-zone")[0]);
          self.editor.openFile(curFileInfo, curFileInfo.getCurVersion());
        } else if (curFileInfo.isVideo() || curFileInfo.isAudio()) {
          self.editor = new _MDAVFileBrowser["default"](self.$(".m-editor-zone")[0]);
          self.editor.openFile(curFileInfo, curFileInfo.getCurVersion(), function () {});
        } else if (curFileInfo.isMail()) {
          self.editor = new _MDMailDisplayView["default"](self.$(".m-editor-zone")[0]);
          self.editor.openFile(curFileInfo, curFileInfo.getCurVersion(), function () {});
        }
        ;
      } else {
        // pdf file

        if (self.editor) {
          self.editor.removeFromSuperView();
        }
        ;
        var params = {
          whiteboard: boardsOpened[0],
          containerDiv: self.$(".m-editor-zone")[0],
          editorViewCtl: self
        };
        self.editor = new _MMPDFCollectionView["default"](params);
        _MMNetDiskImageCollectionView["default"].setCurrentInstance(self.editor);
      }
      MDPcMobileEditorCommonFun.setMainEditor(self.editor);
      self.setEditorViewCtl(self.editor);
      if (self.curPg > 0) {
        self.editor.changeToPage(self.curPg);
      }
      var fileId = curFileInfo.get("fileId");
      var fileName = curFileInfo.getFileName();
      self.topToolBar.displayPageInfo(self.curPg + 1, self.pgCount, fileId, fileName);
    }, function failed() {});
  },
  displayPdfBoard: function displayPdfBoard(board) {
    if (this.editor) {
      this.editor.removeFromSuperView();
    }
    ;
    var params = {
      whiteboard: board,
      containerDiv: self.$(".m-editor-zone")[0],
      editorViewCtl: this
    };
    this.editor = new _MMPDFCollectionView["default"](params);
    this.setEditorViewCtl(this.editor);
  },
  displayFileForVersion: function displayFileForVersion(fileInfo, version, postClose) {
    var self = this;
    this.openSingleBoard(fileInfo, version, postClose, function success(boardsOpened) {
      if (fileInfo.isImage()) {
        var params = {
          boardArr: boardsOpened,
          containerDiv: self.$(".m-editor-zone")[0],
          editorViewCtl: self
        };
        self.editor = new _MMNetDiskImageCollectionView["default"](params);
      } else {
        // pdf file

        var params = {
          whiteboard: boardsOpened[0],
          containerDiv: self.$(".m-editor-zone")[0],
          editorViewCtl: self
        };
        self.editor = new _MMPDFCollectionView["default"](params);
        _MMNetDiskImageCollectionView["default"].setCurrentInstance(self.editor);
      }
      self.setEditorViewCtl(self.editor);
    }, function failed() {});
  },
  getVersionShowing: function getVersionShowing() {
    if (this.editor instanceof _MMNetDiskImageCollectionView["default"]) {
      return this.editor.getCurrentFileVersion();
    }
    return this.versionShowing;
  },
  showPdfPageNoBar: function showPdfPageNoBar() {
    var board = this.editor.getCurrentBoard();
    if (!board || this.pageInfos.length == 0 || this.pageInfos[0].isImage()) {
      return;
    }
    if (board.getPageCount() <= 1) {
      return;
    }
    ;
    if (this.pdfPageNoBar) {
      if (this.pdfPageNoBar.updatePgInfo) {
        this.pdfPageNoBar.updatePgInfo();
      }
    }
    ;
    if (this.pdfCommentCountBar) {
      this.pdfCommentCountBar.updatePgInfo();
    }
    ;
  },
  getCurrentFileInfo: function getCurrentFileInfo() {
    if (!this.editor || !this.editor.getCurrentFileInfo) {
      return null;
    }
    return this.editor.getCurrentFileInfo();
  },
  getCurrentBoard: function getCurrentBoard() {
    return this.editor.getCurrentBoard();
  },
  close: function close() {
    var fileInfo = this.getCurrentFileInfo();
    this.removeFromSuperView();
    if (this.editor) {
      this.editor.removeFromSuperView();
    }
    ;
    _MMWhiteboardController["default"].closeAll();
    _MDTouchMenu["default"].hide();
    _MMNetDiskImageCollectionView["default"].clearCurrentInstance();
    this.onClose.call(this, fileInfo);
  },
  viewDidUnRendered: function viewDidUnRendered() {
    _MDCommonFileEditorController["default"].prototype.viewDidUnRendered.call(this);
    $(window).off(this.$nsEventName('resize'));
    Dispatcher.off(null, null, this);
    viewManager.remove(this);
  },
  showProgressBar: function showProgressBar(progress) {
    var self = this;
    if (progress) {
      if (progress > this.progress) {
        this.progress = progress;
      }
      ;
    }
    ;
    if (this.progTimer) {
      clearTimeout(this.progTimer);
      this.progTimer = null;
    }
    ;
    this.$(".m-progress-root").css("display", "block");
    this.$(".m-progress-bar").css("width", this.progress * 100 + "%");
    if (progress && (this.progress >= 1.0 || Math.abs(this.progress, 1.0) < 0.01)) {
      setBabelTimeout(function () {
        self.hideProgressBar();
      }, 1500);
    } else {
      this.progTimer = setBabelTimeout(function () {
        self.progress += 0.001;
        self.showProgressBar(self.progress);
      }, 40);
    }
  },
  hideProgressBar: function hideProgressBar() {
    $(this.$(".m-progress-root")).css("display", "none");
  },
  createOperationCenter: function createOperationCenter() {
    if (this.editorMode != _EditorMode["default"].mark) {
      return;
    }
    ;
    if (this.operationCenter) {
      this.operationCenter.destroy();
    }
    if (this.editorMode === _EditorMode["default"].mark) {
      this.operationCenterType = _MMOperationCenterMobileMarker["default"];
    } else {
      if (this.mmPicObj.m_objType == _ObjType["default"].Obj_Image) {
        this.operationCenterType = _MMOperationCenterMobileImage["default"];
      }
    }
    this.operationCenter = new this.operationCenterType({
      whiteboard: this.board,
      pageIndex: this.getCurrentFilePageIndex(),
      editor: this,
      mode: 'FULLSCREEN',
      displayedObject: this.mmPicObj
    });
  },
  getCurEditor: function getCurEditor() {
    return this.editor;
  },
  enableMouseWheel: function enableMouseWheel() {}
});
var _default = exports["default"] = MDMobileFileEditorController;

},{"1084":1084,"1109":1109,"1132":1132,"1184":1184,"12":12,"1454":1454,"16":16,"17":17,"222":222,"229":229,"230":230,"231":231,"339":339,"410":410,"446":446,"449":449,"450":450,"452":452,"811":811,"879":879,"880":880,"9":9,"904":904,"905":905,"915":915,"931":931,"938":938}],452:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMViewBase = _interopRequireDefault(require(22));
var _MDZoomPopupView = _interopRequireDefault(require(439));
var _Dispatcher = _interopRequireDefault(require(18));
var _MMBasicData = _interopRequireDefault(require(811));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDDownloadFileController = _interopRequireDefault(require(412));
var _MMFileInfo = _interopRequireDefault(require(297));
/**
 *  file editor view, slide between different files, check comments, add comments
 *  Create by jiang
 *  2015.9.9
 */

var MDTopToolbar4Wc = _MMViewBase["default"].extend({
  el: '<div id="taskBoardToolBar" class="wc-top-toolbar"></div>',
  tmpl: '<div class="icon backArrow mobileBack"></div>' + '<div class="wc-file-toolbar"></div>',
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click .mobileBack': this._closeClicked
    });
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      editorViewCtl: null,
      zoomList: null,
      curTool: ""
    });
  },
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    var z_startIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
    this.$el.css('z-index', z_startIndex);
    _Dispatcher["default"].on(MDEvents.ZOOM_CHANGED, this._zoomChanged, this);
    _Dispatcher["default"].on(MDEvents.NULL_OPERATION, this._clearTool, this);
    _Dispatcher["default"].on(MDEvents.TapOnWhiteSpaceInDoc, this._hideToolbar, this);
    this.displayDownLoadBtn();
  },
  setEditorViewCtl: function setEditorViewCtl(editorViewCtl) {
    this.editorViewCtl = editorViewCtl;
    this.updatePgInfo();
  },
  displayDownLoadBtn: function displayDownLoadBtn() {
    var _this = this;
    this.$downloadBtn = $("<span class=\"download-file-mobile icon menu-download-m icon30\" style=\"position: fixed;right: 20px;bottom: 80px; z-index: 200000001; display: none;\" ></span>");
    this.$el.append(this.$downloadBtn);
    this.$downloadBtn.on('click', function (e) {
      _this._downloadClicked();
    });
  },
  _downloadClicked: function _downloadClicked() {
    if (this.editorViewCtl) {
      var board = this.editorViewCtl.getCurrentBoard();
      var verInfo = null;
      var name = "";
      var curFileId = 0;
      var fileInfo = board.getFileInfo();
      if (fileInfo.isDeleteVersion()) {
        var fid = fileInfo.getFileId();
        var fver = fileInfo.getDeleteVersion();
        var fname = fileInfo.getFileName();
        MMCommonFun.downloadOriginFile(fid, fver, fname);
      } else if (fileInfo.isShortcuts()) {
        _MMFileInfo["default"].prepareLinkedFileInfo(fileInfo, function (f) {
          if (f.isArchived() && !app.ep.isArchive()) {
            var opt = {
              width: 490,
              message: BabelStr.str(778),
              //    你要下载的是归档文件，需要到档案库去下载，点击确定转到档案库
              okFun: function okFun() {
                app.pathRouter.openNetTab('/archive.do#archive/' + f.getParentFolderId());
              }
            };
            MDAlertView.showStandardSelection(opt);
          } else if (f.isTeamFolder()) {
            MDAlertView.showStandardPrompt({
              message: BabelStr.str(786)
            });
          } else if (!f.canDownload()) {
            MDAlertView.showStandardPrompt({
              message: BabelStr.str(786)
            });
          } else {
            var fid = fileInfo.getShortCutsTargetFileId();
            var fver = fileInfo.getShortCutsTargetFile().getCurVersion();
            var fname = fileInfo.getFileName();
            MMCommonFun.downloadOriginFile(fid, fver, fname);
          }
        });
      } else {
        _MDDownloadFileController["default"].downloadFileWithFileInfo(fileInfo);
      }
      ;
    }
    ;
  },
  updatePgInfo: function updatePgInfo() {
    if (!this.editorViewCtl) {
      return;
    }
    ;
    var board = this.editorViewCtl.getCurrentBoard();
    if (!board) {
      return;
    }
    var pgCount = this.editorViewCtl.editor.getCurrentFilePageCount();
    var curPg = this.editorViewCtl.editor.getCurrentFilePageIndex() + 1;
    this.displayPageInfo(curPg, pgCount, board.getStringId(), board.getDisplayName());
    // this.superView.displayFileInfo();

    //!!{ clear unread mark
    var fileInfo = board.getFileInfo();
    var fver = this.editorViewCtl.getVersionShowing();
    _MMNetDiskDataController["default"].clearUnreadMarkWithVerNum(fileInfo, fver);
    //!!} added by jiang, 2016-2-17

    if (fileInfo.canDownload()) {
      this.$('.download-file-mobile').show();
    } else {
      this.$('.download-file-mobile').hide();
    }
  },
  displayPageInfo: function displayPageInfo(curPg, pgCount, fileId, fileName) {
    this.$('#fileNo').text(curPg);
    this.$('#fileCount').text(pgCount);
    this.$('.wc-file-toolbar').text(fileName);
    this._recordReadMark(fileId);
  },
  hidePageInfo: function hidePageInfo() {
    this.$(".wc-file-toolbar").css("display", "none");
  },
  _closeClicked: function _closeClicked(e) {
    // if (app.pathRouter.isPreview()) {
    if ($('.mail-page-iframe').length > 0) {
      $('.mail-page-iframe')[0].contentWindow.history.back();
      $('.mail-page-iframe')[0].contentWindow.history.back();
      return;
    } else {
      // window.close()
    }
    // }

    console.log("close file");
    _Dispatcher["default"].trigger(MDEvents.WHITEBOARD_CLOSED);
    this.getSuperView().close();
  },
  _clearTool: function _clearTool(e) {
    if (this.clearEditTool) this.clearEditTool();
  },
  _recordReadMark: function _recordReadMark(fileId) {
    var usrId = app.currentUser.id;
    _MMNetDiskDataController["default"].addFileAccessUser(fileId, usrId, function () {}, function () {});
  },
  _zoomChanged: function _zoomChanged() {},
  _hideToolbar: function _hideToolbar() {
    if (this.hided) {
      this.hided = false;
      this.$el.show();
    } else {
      this.hided = true;
      this.$el.hide();
    }
  },
  viewiDidUnRendered: function viewiDidUnRendered() {
    _MMViewBase["default"].prototype.viewDidUnRendered.call(this);
    _Dispatcher["default"].off(null, null, this);
  }
});
var _default = exports["default"] = MDTopToolbar4Wc;

},{"1104":1104,"1184":1184,"1454":1454,"18":18,"22":22,"297":297,"412":412,"439":439,"811":811}],450:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMViewBase = _interopRequireDefault(require(22));
var _MMBasicData = _interopRequireDefault(require(811));
/**
 *  file pdf page no. view, slide between different files, check comments, add comments
 *  Create by jiang
 *  2015.9.9
 */

var MDMPdfPageNoBar = _MMViewBase["default"].extend({
  el: '<div class="pdf-curpage"></div>',
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    var z_startIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
    this.$el.css('z-index', z_startIndex);
    this.hide();
  },
  setEditorViewCtl: function setEditorViewCtl(editorViewCtl) {
    this.editorViewCtl = editorViewCtl;
    // this.updatePgInfo();
  },
  updatePgInfo: function updatePgInfo() {
    if (!this.editorViewCtl) {
      return;
    }
    ;
    this.show();
    var pgCount = this.editorViewCtl.editor.getCurPdfPagesCount();
    var curPg = this.editorViewCtl.editor.getCurPdfPage() + 1;
    this.showPageNo(curPg, pgCount);
    var that = this;
    if (this.pageBarTimer) {
      clearTimeout(this.pageBarTimer);
    }
    ;
    this.pageBarTimer = setBabelTimeout(function () {
      that.hide();
    }, 1000);
  },
  showPageNo: function showPageNo(curPage, totalPages) {
    this.$el.text(curPage + "/" + totalPages);
  }
}, {
  className: 'MDMPdfPageNoBar'
});
var _default = exports["default"] = MDMPdfPageNoBar;

},{"1184":1184,"1454":1454,"22":22,"811":811}],449:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMViewBase = _interopRequireDefault(require(22));
var _MMBasicData = _interopRequireDefault(require(811));
var MDMPdfCommentNumberBar = _MMViewBase["default"].extend({
  el: '<div class="pdf-commentsCount"></div>',
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    var z_startIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
    this.$el.css('z-index', z_startIndex);
    this.hide();
  },
  setEditorViewCtl: function setEditorViewCtl(editor) {
    this.editor = editor;
    // this.updatePgInfo();
  },
  updatePgInfo: function updatePgInfo() {
    if (!this.editor) {
      return;
    }
    ;
    var board = this.editor.getCurrentBoard();
    if (!board) {
      return;
    }
    ;
    var ver = this.editor.getVersionShowing();
    var commentNumber = board.getCommentsForVersion(ver).length;
    if (commentNumber > 0) {
      this.show();
      this.showCommentNumber(commentNumber);
      var that = this;
      if (this.pageBarTimer) {
        clearTimeout(this.pageBarTimer);
      }
      ;
      this.pageBarTimer = setBabelTimeout(function () {
        that.hide();
      }, 1000);
    }
    ;
  },
  showCommentNumber: function showCommentNumber(commentNumber) {
    this.$el.text("" + commentNumber + BabelStr.str(5164));
  }
});
var _default = exports["default"] = MDMPdfCommentNumberBar;

},{"1184":1184,"1454":1454,"22":22,"811":811}],446:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1466);
var _MMViewBase = _interopRequireDefault(require(22));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDDownloadFileController = _interopRequireDefault(require(412));
var _MDEditorVersionListPanel4Mobile = _interopRequireDefault(require(448));
var _MMBasicData = _interopRequireDefault(require(811));
/**
 *  file editor view, slide between different files, check comments, add comments
 *  Create by jiang
 *  2015.9.9
 */

var MDBottomToolbar4Wc = _MMViewBase["default"].extend({
  el: '<div id="wc-bottomZone" class="wc-editor-bottomZone"></div>',
  tmpl: '<div class="wc-toolbar-container">' + '<div class="tool-left">' + '<div class="wc-bottom-toolbar">' + '<div id="wc-download" class="wc-tool">' + '<div class="wc-icon"></div>' + '<div class="wc-name">' + BabelStr.str(29) + '</div>' + '</div>' +
  // '<div id="wc-commentList" class="wc-tool">'+
  //     '<div class="wc-icon"></div>'+
  //     '<div class="wc-name">批注列表</div>'+
  // '</div>'+
  '<div id="wc-versions" class="wc-tool">' + '<div class="wc-icon"></div>' + '<div class="wc-name">' + BabelStr.str(5162) + '</div>' + '</div>' + '</div>' + '</div>' + '<div class="tool-right">' + '</div>' + '<div class="wc-controller"> <' + '</div>' + '</div>',
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      "click .wc-controller": this._toggleToolbar,
      "click #wc-download": this._downloadClicked,
      "click #wc-commentList": this._commentListClicked,
      "click #wc-versions": this._versionsClicked,
      'click': this._toggleToolbar
    });
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      editor: null,
      zoomList: null,
      curTool: ""
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    var z_startIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
    this.$el.css('z-index', z_startIndex);
    _Dispatcher["default"].on(MDEvents.ZOOM_CHANGED, this._zoomChanged, this);

    // Dispatcher.on(MDEvents.NULL_OPERATION, this._clearTool, this);
    var $toolLeft = this.$el.find(".tool-left");
    var $toolRight = this.$el.find(".tool-right");
    var $ctl = this.$el.find(".wc-toolbar-container");
  },
  _toggleToolbar: function _toggleToolbar() {
    if (this.toggling) {
      return;
    }
    ;
    this.toggling = true;
    var self = this;
    var $root = this.$el;
    var $toolLeft = this.$el.find(".tool-left");
    var $toolRight = this.$el.find(".tool-right");
    var $ctl = this.$el.find(".wc-controller");
    var $toolbar = this.$el.find(".wc-bottom-toolbar");
    var $container = this.$el.find(".wc-toolbar-container");
    var ctlCenter = $container.width() / 2;
    var ctlRight = parseInt($container.css('right'));
    var ctlBottom = parseInt($container.css('bottom'));
    $toolLeft.css('bottom', ctlBottom + 'px');
    var barWidth = $toolLeft.width();
    var screenW = window.screen.width;
    var duration = 250;
    if (barWidth == 0) {
      $toolLeft.css("right", ctlRight + ctlCenter + 'px');
      $toolLeft.css("left", screenW - ctlRight - ctlCenter + 'px');
      this.oldRight = ctlRight + ctlCenter + 'px';
      var oldRight = parseInt(this.oldRight);

      // $toolbar.css("width", leftToolW - oldRight*2 + "px");

      $toolLeft.animate({
        "left": "0px",
        "right": "0px"
      }, duration, function () {
        self.toggling = false;
      });
      $toolRight.animate({
        "right": '0px'
      }, duration, function () {});
      $ctl.animate({
        //"rotate": "-180deg",
        'opacity': '0'
      }, duration);
      $root.animate({
        "width": "100%",
        "height": "100%"
      }, duration);
    } else {
      $toolLeft.animate({
        "left": screenW - ctlRight - ctlCenter + 'px',
        "right": self.oldRight
      }, duration, function () {
        self.toggling = false;
      });
      $toolRight.animate({
        "width": "0px",
        "left": this.oldRight
      }, duration, function () {});
      $ctl.animate({
        //"rotate": "0deg",
        'opacity': '1'
      }, duration);
      $root.animate({
        "width": "0%",
        "height": "0%"
      }, duration);
    }
  },
  _downloadClicked: function _downloadClicked() {
    // console.log("-------- download clicked");
    //MDDownloadFileController.downloadFileForEditor(this.editor);
    var $dispDlg = $("<div class='wc-download-root'>" + "<div class='wc-download-dlg'>" + "<div class='wc-download-title'>" + BabelStr.str(5163) + "</div>" + "<div class='wc-download-arrow'></div>" + "</div>" + "</div>");
    var $body = $("body");
    $body.append($dispDlg);
    var z_startIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
    $dispDlg.css('z-index', z_startIndex);
    $dispDlg.click(function (e) {
      $dispDlg.remove();
    });
  },
  _versionsClicked: function _versionsClicked() {
    // console.log("-------- version clicked");
    var self = this;
    if (!this.versionList) {
      this.versionList = new _MDEditorVersionListPanel4Mobile["default"]({
        callback: function removed() {
          self.versionList = null;
        }
      });
      this.versionList.setEditorViewCtl(this.editor);
    }
    ;
  },
  _commentListClicked: function _commentListClicked() {
    // console.log("-------- comment clicked");
  },
  _zoomChanged: function _zoomChanged() {},
  setEditorViewCtl: function setEditorViewCtl(editor) {
    this.editor = editor;
  },
  clearEditTool: function clearEditTool() {
    this.curTool = "";
    this.$('.edit-tool').find("li").removeClass("li-focus");
  },
  removeVersionList: function removeVersionList() {
    if (this.versionList) {
      this.versionList.remove();
      this.versionList = null;
    }
    ;
  },
  viewDidUnRendered: function viewDidUnRendered() {
    _MMViewBase["default"].prototype.viewDidUnRendered.call(this);
    _Dispatcher["default"].off(null, null, this);
  }
});
var _default = exports["default"] = MDBottomToolbar4Wc;

},{"1184":1184,"1417":1417,"1454":1454,"1463":1463,"1466":1466,"18":18,"22":22,"412":412,"448":448,"811":811}],448:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
var _MMViewBase = _interopRequireDefault(require(22));
var _MMBasicData = _interopRequireDefault(require(811));
var _MDFileVerListView = _interopRequireDefault(require(584));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
/**
 *  version panel view in editor
 *  Created by jiang
 *  2015.9.2
 */

var MDEditorVersionListPanel4Mobile = _MMViewBase["default"].extend({
  el: '<div class="m-versionlist-root"></div>',
  tmpl: '<div class="m-versionlist-toolbar">' + '<div class="m-version-close">' + '</div>' + '</div>' + '<div class="m-version-zone"></div>',
  events: function events() {
    return {
      "click .m-version-close": this._closeClicked
    };
  },
  editor: null,
  initialize: function initialize(opt) {
    this.callback = opt.callback;
    $('body').append(this.el);
    this.render();
    this.versionList = new _MDFileVerListView["default"]();
    this.versionList.showDispMark = true;
    this.versionList.renderTo(this.$el.find(".m-version-zone"));
    var z_startIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
    $(this.el).css('z-index', z_startIndex);
  },
  setInitialVer: function setInitialVer(version) {
    this.versionList.setInitialVer(version);
  },
  cellInitFinished: function cellInitFinished() {
    this.displayInfo();
  },
  displayInfo: function displayInfo() {
    var that = this;
    this._getVersions(function (versions) {
      that.versionList.setFileVerCollection(versions);
    });
  },
  setEditorViewCtl: function setEditorViewCtl(editor) {
    this.editor = editor;
    if (editor) {
      var curDispVer = editor.getVersionShowing();
      this.setInitialVer(curDispVer);
    }
    ;
    this.displayInfo();
  },
  _getVersions: function _getVersions(callback) {
    if (!this.editor) {
      return;
    }
    ;
    var curBoard = this.editor.getCurrentBoard();
    if (curBoard && this.board != curBoard) {
      this.board = curBoard;
      var fileInfo = curBoard.getFileInfo();
      if (fileInfo.hasVersionList()) {
        if (callback) {
          callback(fileInfo.get('versionList'));
        }
        ;
      } else {
        _MMNetDiskDataController["default"].getFileVersionsByFileInfo(fileInfo, function success(versionInfos) {
          if (callback) {
            callback(versionInfos);
          }
          ;
        }, function failed() {
          console.error("----- get version error");
        });
      }
    }
    ;
  },
  _closeClicked: function _closeClicked() {
    this.remove();
    if (this.callback) {
      this.callback();
    }
    ;
  }
});
var _default = exports["default"] = MDEditorVersionListPanel4Mobile;

},{"1104":1104,"1184":1184,"1417":1417,"1454":1454,"1463":1463,"22":22,"584":584,"811":811}],584:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1418);
require(1463);
require(1537);
require(1417);
require(1466);
var _MDLocalString = _interopRequireDefault(require(1150));
var _MMViewBase = _interopRequireDefault(require(22));
var _MDFileVerItemView = _interopRequireDefault(require(582));
var _MMVersionInfoCollection = _interopRequireDefault(require(311));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _AppLeftMenuType = _interopRequireDefault(require(611));
var _MDPaginationView = _interopRequireDefault(require(61));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
/**
 *  View for file version list
 *  Created by manjun.han
 *  2015.9.11
 *
 *  Changed by jiang
 *  2015.9.22
 */

var MDFileVerListView = _MMViewBase["default"].extend({
  el: '<div class="m-verListPanel"></div>',
  tmpl: "<div class=\"listWrapper\">\n          <ul></ul>\n        </div>\n        <div class=\"page-bar verlist\"></div>\n        ",
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      $list: null,
      fileInfor: null,
      fileVerCollection: null,
      fileSys: _AppLeftMenuType["default"].HOME,
      verItemList: [],
      enableRouterNavigation: true,
      fileVersionRouterCb: _.noop,
      showDispMark: false,
      // 设置是否标志正在显示的版本
      updateDisVerAfterDel: false,
      enableOpenVersion: true,
      pageSize: 10,
      startIndex: 0
    });
  },
  initialize: function initialize(opt) {
    var _this = this;
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.fileSys = _AppLeftMenuType["default"].HOME;
    this.$list = this.$('.listWrapper>ul');
    this.setFileInfor(this.fileInfor);
    this.inEditor = opt.inEditor;
    console.log('-------------->>>>> MDFileVerListView');
    Dispatcher.on(MDEvents.VersionChangedByComment, function (v) {
      console.log('-------------- VersionChangedByComment');
      _this.setDisplayVer(v);
    }, this);
    this.pageBarView = new _MDPaginationView["default"]({
      enableStepButton: true,
      showJumpToPage: false,
      silentInit: true,
      showSelectSizeList: true,
      align: 'left',
      pageSize: this.pageSize,
      pageButtonNum: 0,
      onPageChanged: function onPageChanged(curPageIndex) {
        _this._pageChanged(curPageIndex);
      },
      onPageSizeChanged: function onPageSizeChanged(size) {
        _this._pageSizeChanged(size);
      }
    });
    this.addSubView(this.pageBarView, this.$(".page-bar")[0]);
    this.pageBarView.setLength(100, 0);
    this.pageBarView.hide();
  },
  _pageChanged: function _pageChanged(index) {
    if (this.startIndex != index || this.forceRefresh) {
      this.forceRefresh = false;
      this.startIndex = index;
      this.refresh();
    }
  },
  _pageSizeChanged: function _pageSizeChanged(size) {
    this.pageSize = size;
    this.startIndex = 0;
    this.refresh();
  },
  setTotal: function setTotal(total) {
    this.total = total;
    this.pageBarView.setLength(total);

    // if (!this.fileVerCollection || total == this.fileVerCollection.size()) {
    //   this.pageBarView.hide();
    // } else {
    if (total > 10) {
      this.pageBarView.show();
    }

    // }
  },
  setLength: function setLength(total, startIndex) {
    this.pageBarView.setLength(total, true);
    if (startIndex == 0) {
      this.pageBarView.setCurrentPage(startIndex, true);
    }
  },
  setFileInfor: function setFileInfor(fileInfor, callback) {
    if (!fileInfor) {
      return;
    }
    ;
    this.startIndex = 0;
    this.pageBarView.setCurrentPage(this.startIndex, true);
    if (this.inEditor && fileInfor.isShortcuts()) {
      fileInfor = fileInfor.getShortCutsTargetFile();
    }
    ;
    this.fileInfor = fileInfor;
    this._requestFileVerList(callback);
  },
  setCurrentVersion: function setCurrentVersion(version) {
    if (!_.isNumber(version) || _.isNaN(version)) {
      version = this.fileInfor.getCurVersion();
    }
    this.fileVerCollection.forEach(function (verInfo) {
      verInfo.set('curVersion', version);
    });
    if (!this.fileInfor && this.fileVerCollection.length > 0) {
      var info = this.fileVerCollection.models[0].get("fileInfo");
      if (info) {
        this.fileInfor = info;
      }
      ;
    }
    var versionInfo = this.fileVerCollection.find(function (fileVersion) {
      //
      // javascript中===是严格比较，不做类型转换
      // == 是普通比较，会将等式两边做数据类型转换
      // 此处比较是非严格比较用来容错，但最好是后台数据类型固定后，用严格等来进行判断
      return fileVersion.getVersion() == version;
    });
    if (this.fileInfor) {
      this.fileInfor.setCurVersion(version, versionInfo);
    }
    var that = this;
    var fileId = this.fileInfor.getFileId();
    var newFileInfo = _MMNetDiskDataController["default"].getFileInfoFromServer(fileId, function (rtFileInfo) {
      that.fileInfor.initBy(rtFileInfo);
    });
  },
  setInitialVer: function setInitialVer(version) {
    this.initalVer = null;
    if (this.fileVerCollection) {
      this.setDisplayVer(version);
    } else {
      this.initalVer = version;
    }
  },
  setDisplayVer: function setDisplayVer(version) {
    version = parseInt(version);
    if (!_.isNumber(version) || _.isNaN(version) || version < 0) {
      version = this.fileInfor.getCurVersion();
    }
    if (this.fileVerCollection) {
      this.fileVerCollection.forEach(function (verInfo) {
        verInfo.setDisplayVer(version);
      });
      this.dispVer = version;
    }
  },
  // 正在显示的版本被删除，所以显示文档的当前版本
  displayingVerDeleted: function displayingVerDeleted() {
    var curVer = this.fileInfor.getCurVersion();
    this.setDisplayVer(curVer);
    var verInfo = this.fileVerCollection.find(function (fileVersion) {
      return fileVersion.getVersion() == curVer;
    });
    if (verInfo) {
      if (this.enableRouterNavigation) {
        this.fileVersionRouterCb.call(this, this.fileInfor, curVer);
      } else {
        var fileEditor = viewManager.get('fileEditor');
        fileEditor.displayFiles(null, this.fileInfor, curVer, true);
      }
    }
  },
  setFileVerCollection: function setFileVerCollection(fileVerCollection) {
    var self = this;
    if (this.fileVerCollection === fileVerCollection) {
      return;
    }
    if (fileVerCollection.length > 0) {
      var fileInfo = fileVerCollection.models[0].get('fileInfo');
      if (fileInfo) {
        this.fileInfor = fileInfo;
      }
      ;
    }
    ;
    if (!this.updateHandler && this.fileInfor) {
      this.updateHandler = function (verInfor) {
        this.forceRefresh = true;
        self.fileInfor.set("mtime", verInfor.get('createTime'));
        var index = self.startIndex;
        if (self.fileVerCollection.length < 1 && index > 0) {
          index--;
        }
        self.pageBarView.setCurrentPage(index);
        // self._renderVerItems();
      };
    }
    if (this.fileVerCollection) {
      this.stopListening(this.fileVerCollection);
    }

    // -------  对于分享的参与者或者没有上传权限的人，不能查看历史版本
    if (app.isShareApp || !this.fileInfor.canUploadVersion()) {}
    this.fileVerCollection = fileVerCollection;
    if (this.fileVerCollection) {
      this.listenTo(this.fileVerCollection, 'add', this.updateHandler);
      this.listenTo(this.fileVerCollection, 'remove', this.updateHandler);
    }
    if (this.initalVer != null && this.initalVer != undefined) {
      this.setDisplayVer(this.initalVer);
    }
    this._renderVerItems();
  },
  _requestFileVerList: function _requestFileVerList(callback) {
    var self = this;
    if (!this.fileInfor) {
      return;
    }
    self.$list.empty();
    this.pageBarView.hide();
    _MDSpinnerloaderView["default"].showIn(self.$list);
    if (this.fileInfor.canListVersion()) {
      this.fileInfor.listVersions(this.startIndex * this.pageSize, this.pageSize, function success(versionCollection, total) {
        self.setFileVerCollection(versionCollection);
        self.setTotal(total); // -------------- 必须在 setFileVerCollection 之后调用
        _MDSpinnerloaderView["default"].clearFrom(self.$list);
        if (callback) {
          callback();
        }
        ;
      }, function fail() {
        console.log("could not load versions");
      });
    } else {
      _MDSpinnerloaderView["default"].clearFrom(self.$list);
      self.setFileVerCollection(new _MMVersionInfoCollection["default"]());
    }
  },
  _renderVerItems: function _renderVerItems() {
    this.removeSubViews(_MDFileVerItemView["default"]);
    var self = this;
    this.verItemList = [];
    self.$list.empty();
    if (this.fileVerCollection.length > 0) {
      this.fileVerCollection.each(function (fileVer, index) {
        var verItemView = new _MDFileVerItemView["default"]({
          fileInfor: self.fileInfor,
          fileVerInfo: fileVer,
          index: index,
          collection: self.fileVerCollection,
          showDispMark: self.showDispMark,
          enableRouterNavigation: self.enableRouterNavigation,
          fileVersionRouterCb: self.fileVersionRouterCb,
          updateDisVerAfterDel: self.updateDisVerAfterDel,
          enableOpenVersion: self.enableOpenVersion
        });
        verItemView.setFileSys(self.fileSys);
        self.addSubView(verItemView, self.$list);
        self.verItemList.push(verItemView);
      });
      if (this.dispVer != undefined) {
        this.setDisplayVer(this.dispVer);
      }
      ;
    } else {
      self.$list.empty();
      var cannotlist = _MDLocalString["default"].getLocalString(298); // 由于权限问题，未能列出历史版本！
      self.$list.append($('<div class="empty-verlist">' + '<div>' + cannotlist + '</div>' + '</div>'));
      self.pageBarView.hide();
    }
  },
  setEnableOpenVersion: function setEnableOpenVersion(enabled) {
    this.enableOpenVersion = enabled;
    this.eachSubViews(function (subView, index) {
      subView.setEnableOpenVersion && subView.setEnableOpenVersion(enabled);
    });
  },
  setEnableRouterNavigation: function setEnableRouterNavigation(enabled) {
    this.enableRouterNavigation = enabled;
    this.eachSubViews(function (subView, index) {
      subView.setEnableRouterNavigation && subView.setEnableRouterNavigation(enabled);
    });
  },
  refresh: function refresh() {
    this._requestFileVerList();
  }
}, {
  className: 'MDFileVerListView'
});
var _default = exports["default"] = MDFileVerListView;

},{"1104":1104,"1150":1150,"1184":1184,"1417":1417,"1418":1418,"1454":1454,"1463":1463,"1466":1466,"1537":1537,"22":22,"311":311,"582":582,"61":61,"611":611,"76":76}],582:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1449);
require(1446);
require(1417);
require(1463);
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDNetDriveFileHandler = _interopRequireDefault(require(1091));
var _MMViewBase = _interopRequireDefault(require(22));
var _MMFileInfoCollection = _interopRequireDefault(require(298));
var _MDDownloadFileController = _interopRequireDefault(require(412));
var _MDConstant = _interopRequireDefault(require(321));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDPCDisplayFileController = _interopRequireDefault(require(422));
var _AppLeftMenuType = _interopRequireDefault(require(611));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
var _keycode = _interopRequireDefault(require(104));
var _MDEditalbeInputDiv = _interopRequireDefault(require(28));
var _MDClientDownloadWinView = _interopRequireDefault(require(484));
/**
 *  Item view for file version information
 *  Created by manjun.han
 *  2015.9.16
 */

var MDFileVerItemView = _MMViewBase["default"].extend({
  el: '<li></li>',
  tmpl: "<div class=\"vinfo\">\n          <div class=\"date\">\n            <div class=\"text-hide\">\n              <%=evalHtmlStr%>\n              <%if(belongProject){%>\n                <span class=\"uploader\"><%=versionInfo%></span>\n              <%} else {%>\n                <span class=\"uploader\"><%=fileName%></span>\n              <%}%>\n\n            </div>\n\n            <%if(curVer){%>\n              <span class=\"cur\"><%=currentCap%></span>\n            <%}%>\n          </div>\n          <div class=\"flex-align between\">\n            <div><%=ctime%></div>\n            <div class=\"cName text-hide\"><%=cName%></div>\n          </div>\n          <div class=\"ver-log small-input-style\">\n          </div>\n          <div class=\"btn-group\">\n            <button class=\"downloadBtn text-button done\"><%=downloadCap%></button>\n            <% if(!curVer){%>\n              <button class=\"text-button done set\"><%=setCap%></button>\n              <button class=\"text-button done del\"><%=delCap%></button>\n              <button class=\"text-button done compare\"><%=compare%></button>\n            <%}%>\n          </div>\n      </div>\n    <div class=\"imgWrapper\"></div>",
  render: function render(data) {
    var self = this;
    var f = this.fileVerInfo;
    var committerName = f.getCommitterName();
    var versionNo = f.getVersionNo();
    if (f.isBabelOffice()) {
      var intVersion = Number.parseInt(f.getVersion());
      if (versionNo == intVersion + 1) {
        versionNo = versionNo - 1;
      }
    }
    data = {
      'cName': committerName,
      'ctime': '' + MMCommonFun.formatSec2Date(f.get('createTime')),
      'curVer': f.isCurVersion(),
      'evalHtmlStr': f.createEvalStrHtml(),
      'currentCap': _MDLocalString["default"].getLocalString(299),
      // 当前
      'downloadCap': _MDLocalString["default"].getLocalString(29),
      // 下载
      'setCap': _MDLocalString["default"].getLocalString(300),
      //设置为当前版本
      'delCap': _MDLocalString["default"].getLocalString(32),
      // 删除
      "compare": BabelStr.str(3319),
      //比较
      'fileName': f.getFileName(),
      'belongProject': true || this.fileInfor.belongProject() || this.fileInfor.get('transmittalProjectId'),
      'versionInfo': BabelStr.str(5289, {
        ver: versionNo
      })
    };
    _MMViewBase["default"].prototype.render.call(this, data);
    if (!this.verInputView) {
      this.verInputView = new _MDEditalbeInputDiv["default"]({
        parentDiv: this.$el.find('.ver-log')[0],
        placeholder: _MDLocalString["default"].getLocalString(6129),
        //"版本说明",
        disabelEdit: !app.currentUser.logined(),
        allowEmpty: true,
        maxlength: 140,
        updatedCallback: function updatedCallback(newtext, callback) {
          // newtext = _.escape(newtext)
          self._submitVerLog(newtext, callback);
        }
      });
    }
    ;
    var log = f.getVersionLog();
    if (log) {
      this.verInputView.setInputVal(log);
    }
    ;
    if (!f.canUpload() || !app.currentUser.logined()) {
      this.cannotEditVerLog = true;
      if (!log || log.length == 0) {
        this.verInputView.remove();
      } else {
        this.verInputView.setReadOnly();
      }
    }
    ;
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      'mousedown .downloadBtn': this._downloadClickHandler,
      'mousedown .set': this._setCurVersionClickHandler,
      'mousedown .del': this._delCurVersionClickHandler,
      'mousedown .imgWrapper': this.openFileOfVersion,
      'click .compare': this._compare,
      'click .vinfo': this.openFileOfVersion
    });
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      fileInfor: null,
      fileVerInfo: null,
      index: -1,
      fileSys: _AppLeftMenuType["default"].HOME,
      curVer: -1,
      showDispMark: false,
      collection: null,
      enableRouterNavigation: true,
      fileVersionRouterCb: _.noop,
      // 如果支持router方式来切换版本的话，需要传递router的navigate的具体执行方法
      updateDisVerAfterDel: false,
      enableOpenVersion: true
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this._refreshVersionState();
    if (this.fileVerInfo.isDispalaying() && _MDPcMobileEditorCommonFun["default"].getMainEditor()) {
      this.$el.addClass("selected");
    }
    if (!this.fileVerInfo.canDownload()) {
      this.$(".downloadBtn").remove();
    }
    if (!this.fileInfor.canSetCurrentVersion() || this.fileInfor.isFileLocked() || this.fileVerInfo.isBabelOffice()) {
      this.$(".set").remove();
    }
    this.listenTo(this.fileVerInfo, 'change', this._refreshVersionState);

    // if(this.fileInfor.isOfficeFile()){
    //   this.$(".compare").show();
    // }else {
    this.$(".compare").hide();
    // }
  },
  /**
   * 文件比较，客户端使用
   */
  _compare: function _compare() {
    if (app.isInClient() && app.isClientHasCompareFun()) {
      var srcfile = {
        fileId: this.fileInfor.getFileId(),
        versionId: this.fileInfor.getCurVersion(),
        fileSize: this.fileInfor.get("fileSize"),
        fileName: this.fileInfor.getFileName()
      };
      var tgFile = {
        fileId: this.fileVerInfo.getFileId(),
        versionId: this.fileVerInfo.get("ver"),
        fileSize: this.fileVerInfo.get("fileSize"),
        fileName: this.fileVerInfo.getFileName()
      };
      app.isClientHasCompareFun()(srcfile, tgFile);
    } else {
      var downloadWin = new _MDClientDownloadWinView["default"]();
      downloadWin.show();
    }
  },
  openFileOfVersion: function openFileOfVersion($e) {
    console.log('------ focus:', this.editFocused);
    if (this.editFocused) {
      return;
    }
    ;
    var self = this;
    if (!this.enableOpenVersion) {
      return;
    }
    var commentPanel = viewManager.get("commentSlidePanel");
    var ver = this.fileVerInfo.get("ver");
    var fileInfo = this.fileVerInfo.get('fileInfo');
    fileInfo.dispForVersion = true;
    if (fileInfo.canDispInWebBrowser()) {
      var str = _MDLocalString["default"].getLocalString(293); //HTML 文件不支持点击此处查看历史版本，您可以通过修改当前版本后重新打开文件！
      _MDAlertView["default"].showAlert(str);
      return;
    } else {
      var router;
      var fileEditor;
      if (commentPanel && commentPanel.superView) {
        commentPanel.removeFromSuperView();
      }
      this.superView.setDisplayVer(ver);
      if (this.enableRouterNavigation && this.fileVersionRouterCb) {
        this.fileVersionRouterCb.call(this, fileInfo, ver);
      } else {
        fileEditor = viewManager.get('fileEditor');
        if (fileEditor) {
          fileEditor.displayFiles(null, fileInfo, ver, true);
        } else {
          var displatController = _MDPCDisplayFileController["default"].getSingleton();
          displatController.openFileWithoutRouter(fileInfo, ver);
        }
      }
    }
  },
  setFileSys: function setFileSys(fileSys) {
    this.fileSys = fileSys;
    this._refreshBtnForFileSys();
  },
  _refreshBtnForFileSys: function _refreshBtnForFileSys() {
    if (this.fileSys == _AppLeftMenuType["default"].HOME || this.fileSys == _AppLeftMenuType["default"].MYSHARE || this.fileSys == _AppLeftMenuType["default"].MYJOINSHARE || this.fileSys == _AppLeftMenuType["default"].STAR) {
      this.$('.set').css("display", "inline-block");
      this.$('.del').css("display", "inline-block");
    } else {
      this.$('.set').css("display", "none");
      this.$('.del').css("display", "none");
    }
    if (this.fileVerInfo.isInTrash()) {
      this.$('.set').css("display", "none");
      this.$('.del').css("display", "none");
    }
    ;
  },
  _refreshVersionState: function _refreshVersionState() {
    var self = this;
    if (self.fileVerInfo.isDispalaying() && self.showDispMark) {
      self.$el.addClass("selected");
    } else {
      self.$el.removeClass("selected");
    }
    var curUser = app.currentUser;
    var newVersion = self.fileVerInfo.getCurVersion();
    if (newVersion != self.curVer) {
      self.curVer = newVersion;
      self.$(".set").remove();
      self.$(".del").remove();
      self.$(".cur").remove();
      var currentCap = _MDLocalString["default"].getLocalString(299); // 当前
      var downloadCap = _MDLocalString["default"].getLocalString(29); // 下载
      var setCap = _MDLocalString["default"].getLocalString(300); //设置为当前版本
      var delCap = _MDLocalString["default"].getLocalString(32); // 删除

      if (self.fileVerInfo.isCurVersion()) {
        var $cur = '<span class="cur">' + currentCap + '</span>';
        self.$(".date").before($cur);
      } else if (curUser) {
        if (self.fileVerInfo.canUpload()) {
          var $mainVersion = $('<button class="set text-button done">' + setCap + '</button>');
          self.$(".btn-group").append($mainVersion);
        }
        ;
        if (self.fileVerInfo.canDelete()) {
          var $del = $('<button class="del text-button done">' + delCap + '</button>');
          self.$(".btn-group").append($del);
        }
        ;
      }
    }
    ;
    this._refreshBtnForFileSys();
  },
  _delCurVersionClickHandler: function _delCurVersionClickHandler(e) {
    if (this.editFocused) {
      return;
    }
    ;
    var self = this;
    e.target.blur();
    var collection = self.collection;
    var fileInfo = this.fileVerInfo.getFileInfo();
    var isPassed = fileInfo.isPassed();
    var msg = "";
    if (isPassed) {
      var opt = {
        message: _MDLocalString["default"].getLocalString(303) // 该文件已定稿，不能删除版本
      };
      _MDAlertView["default"].showStandardPrompt(opt);
    } else {
      var opt = {
        message: _MDLocalString["default"].getLocalString(304),
        // 确定要删除选中的版本吗?
        okFun: function okFun() {
          _MMNetDiskDataController["default"].deleteFileById({
            fileId: self.fileVerInfo.get("fileId"),
            version: self.fileVerInfo.get("ver"),
            type: _MDNetDriveFileHandler["default"].DELETEOPTIONS.TO_TRASCH
          }, function success() {
            var superV = self.superView;
            collection.remove(self.fileVerInfo);
            _MDSnackbarView["default"].show(_MDLocalString["default"].getLocalString(305)); // 删除成功
            if (self.updateDisVerAfterDel) {
              if (self.fileVerInfo.isDispalaying()) {
                superV.displayingVerDeleted();
              }
            }
            if (self.collection.length == 1) {
              Dispatcher.trigger(MDEvents.VersionListChanged, self.fileVerInfo.get("fileId"), self);
            }
          }, function fail(e) {
            var title = _MDLocalString["default"].getLocalString(306); //"删除失败";
            if (e == _MMNetDiskDataController["default"].code.ERROR_DELETE_IS_EVALUATING) {
              title = _MDLocalString["default"].getLocalString(307); //"文件正在审批，请先结束审批！";
            }
            _MDSnackbarView["default"].show(title);
          });
        }
      };
      _MDAlertView["default"].showDangerSelection(opt);
    }
    return false;
  },
  _downloadClickHandler: function _downloadClickHandler($e) {
    if (this.editFocused) {
      return;
    }
    ;
    _MDDownloadFileController["default"].downloadFileWithVerInfo(this.fileVerInfo);
    return false;
  },
  _setCurVersionClickHandler: function _setCurVersionClickHandler($e) {
    if (this.editFocused) {
      return;
    }
    ;
    var self = this;
    var fileId = this.fileVerInfo.getFileId();
    var version = this.fileVerInfo.get("ver");
    var fileInfo = this.fileVerInfo.get('fileInfo');
    if (fileInfo && fileInfo.canSetCurrentVersion()) {
      _MMNetDiskDataController["default"].setCurrentVersion(fileId, version, function success() {
        version = Number(version);
        self.superView.setCurrentVersion(version);
        _MDSnackbarView["default"].show(_MDLocalString["default"].getLocalString(308)); // 成功设置为当前版本
        var fileInfo = self.fileVerInfo.getFileInfo();
        fileInfo.setFileStatus(self.fileVerInfo.getFileStatus());
      }, function fail() {
        _MDSnackbarView["default"].show(_MDLocalString["default"].getLocalString(309)); //"设置版本失败！"
      });
    } else {
      var des = _MDLocalString["default"].getLocalString(310); //"您没有设置当前版本的权利";
      if (fileInfo.isPassed()) {
        des = _MDLocalString["default"].getLocalString(311); //"当前文档已定稿，不允许修改版本";
      }
      var opt = {
        message: des
      };
      _MDAlertView["default"].showStandardPrompt(opt);
    }
    return false;
  },
  setEnableOpenVersion: function setEnableOpenVersion(enabled) {
    this.enableOpenVersion = enabled;
  },
  setEnableRouterNavigation: function setEnableRouterNavigation(enabled) {
    this.enableRouterNavigation = enabled;
  },
  viewDidRendered: function viewDidRendered() {
    _MMViewBase["default"].prototype.viewDidRendered.call(this);
    var $imgWrapper = this.$(".imgWrapper");
    this.fileVerInfo.setIconForDiv($imgWrapper);
  },
  _submitVerLog: function _submitVerLog(logStr, callback) {
    var self = this;
    var f = this.fileVerInfo;
    var oldlog = f.getVersionLog();
    if (logStr != oldlog) {
      var fileId = f.getFileId();
      var ver = f.getVersion();
      _MMNetDiskDataController["default"].setFileVersionLog(fileId, ver, logStr, function () {
        f.setVersionLog(logStr);
        callback();
      }, function () {});
    }
    ;
  },
  testClick: function testClick(e) {
    var $e = $(e.currentTarget);
    var $input = $e.find("input");
    console.log("---------- $e:", $e);
  }
});
var _default = exports["default"] = MDFileVerItemView;

},{"104":104,"1091":1091,"1104":1104,"1150":1150,"1184":1184,"1417":1417,"1446":1446,"1449":1449,"1454":1454,"1463":1463,"22":22,"28":28,"298":298,"32":32,"321":321,"412":412,"422":422,"484":484,"611":611,"72":72,"807":807}],611:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _keyMirror = _interopRequireDefault(require(103));
var AppLeftMenuType = (0, _keyMirror["default"])({
  HOME: null,
  TRASH: null,
  MESSAGE: null,
  MYSHARE: null,
  MYJOINSHARE: null,
  TEAM: null,
  STAR: null,
  EVALUATION: null
});
var _default = exports["default"] = AppLeftMenuType;

},{"103":103,"1184":1184,"1454":1454}],422:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1466);
require(1432);
require(1418);
require(1463);
require(1537);
var _MDDisplayFileController = _interopRequireDefault(require(411));
var _MDPCFileEditorController = _interopRequireDefault(require(423));
var _MMWhiteboardController = _interopRequireDefault(require(1109));
var _MMFileInfo = _interopRequireDefault(require(297));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDOnlyOfficeEditor = _interopRequireDefault(require(421));
var _MDOfficeOnlineEditor = _interopRequireDefault(require(420));
var _MDMessageView = _interopRequireDefault(require(55));
var _MMCommonFun = _interopRequireDefault(require(812));
//
//  类结构图 - PC 的显示控制 (手机版在 MDMDisplayFileController)
//
//  类结构如下（+ 代表包含）：
//
// MDPCDisplayFileController
//           +———  MDPCFileEditorController
//           |           +———  MDPCEditorViewController
//           |           |            +——— MMPDFCollectionView - 非图片
//           |           |            |           +--- MMPdfPageCell
//           |           |            |           |        +--- (mobile) MMMobilePageView
//           |           |            |           |        +--- MDPCPdfPageView
//           |           |            |           -        -
//           |           |            |
//           |           |            +——— MMPCImageEditor - 图片
//           |           |            +--- MD3DEditor - 3D
//           |           |            +--- MMWhiteboardController.openWhiteboardByFileInfo
//           |           |            -
//           |           |
//           |           +--- MDTopToolbar4PC
//           |           |            +--- MDEditorFileInfoPanel
//           |           |            |         +--- MDFileVerListView
//           |           |            |         |        +--- MDFileVerItemView
//           |           |            -         -        -
//           |           |
//           |           +--- MDEditorContentPanelView
//           |           |             +——— MDCommentsNavigator
//           |           |             +——— MDPDFToolbar4PC
//           -           -             -
//
//

var MDPCDisplayFileController = function MDPCDisplayFileController() {
  _MDDisplayFileController["default"].apply(this, arguments);
  this.docTitleStack = [];
  this.editors = [];
  var self = this;
  Dispatcher.on(MDEvents.OpenFolderFromOtherChannel, function () {
    self.closeAll();
  });
};
MDPCDisplayFileController.prototype = new _MDDisplayFileController["default"]();
MDPCDisplayFileController.prototype.constructor = MDPCDisplayFileController;
_.extend(MDPCDisplayFileController.prototype, function () {
  /**
  * 打开同文件夹下的可以显示的文档
  * @param {Object} parameters{
  *     fileInfo  -  指向要打开的那个文件的信息
  *     version  - {int} 要打开的那个文件的版本
  *     commentId - 要打开的文件中的那个批注点 ，如果指定这个属性，则会自动忽略 version 指向的版本
  *     closeCb - 关闭文档的回调函数
  *     openCb - 打开文档的回调函数
  * }
  *
  * jiang
  * 2016-10-25
  */
  function _openFiles(parameters) {
    var version = parameters.version;
    var commentId = parameters.commentId;
    var fileInfo = parameters.fileInfo;
    var closeCb = parameters.closeCb;
    var openCb = parameters.openCb;
    if (_tryDispWithOnlyOffice.call(this, fileInfo, version)) {
      return;
    }
    if (commentId != undefined) {
      version = -1;
    } else {
      version = parseInt(version);
      if (_.isNaN(version)) {
        version = -1;
      }
    }
    var versionInfo = fileInfo.getVersionInfo(version);
    var self = this;
    var checkParam = {
      fileInfo: fileInfo,
      verInfo: versionInfo
    };
    self.checkToAlertCannotDisp(checkParam, function (canOpen) {
      if (!canOpen) {
        if (_.isFunction(openCb)) {
          openCb(false);
        }
        return;
      }
      var fileInfoArray = fileInfo.getFilesInSameFolder();
      if (fileInfoArray.length < 1) {
        fileInfoArray.push(fileInfo);
      }
      for (var i = 0; i < fileInfoArray.length; i++) {
        if (versionInfo && fileInfoArray[i] == fileInfo) {
          if (!versionInfo.readyToDisplay()) {
            fileInfoArray.splice(i, 1);
            i--;
          }
        } else if (!fileInfoArray[i].readyToDisplay() && !fileInfoArray[i].canDispInOpenGL() && !fileInfoArray[i].isOfficeFile() && !fileInfoArray[i].canEditWithSVG() && !fileInfoArray[i].isVideoDirectlyPlay() && !fileInfoArray[i].isAudioDirectlyPlay() || !fileInfoArray[i].canRead() || app.ep.isClosedViewVideo() && fileInfoArray[i].isVideoDirectlyPlay()) {
          fileInfoArray.splice(i, 1);
          i--;
        }
      }
      var editor = viewManager.get('fileEditor');
      self.docTitleStack.unshift(document.title);
      var title = fileInfo.getFileName();
      if (window.ep) {
        title = title + ' - ' + window.ep.shortName;
        document.title = title;
      }
      var fileVersionRouterCb = function fileVersionRouterCb(fileInfo, ver) {
        var router = "file/" + fileInfo.getFileId() + "/v/" + ver;
        app.pathRouter.navigate(router);
        editor.changeVersion(ver);
      };
      var onFileInforChanged = function onFileInforChanged(fileInfo) {
        var router = 'file/' + fileInfo.getFileId();
        app.pathRouter.navigate(router);
        var title = fileInfo.getFileName();
        if (window.ep) {
          title = title + ' - ' + window.ep.shortName;
          document.title = title;
        }
      };
      var onClose = function onClose() {
        self.editors.remove(editor);
        if (self._ckeck2RemoveEditorSlot()) {
          var parentId = fileInfo.getParentFolderId();
          var path = 'file/' + parentId;
          if (parentId == 0) {
            path = "";
          }
          app.pathRouter.navigate(path, {
            trigger: false
          });
          getPdfPageLoader().clear();
          document.title = self.docTitleStack.shift();
          if (_.isFunction(closeCb)) {
            closeCb();
          }
        }
        self._removeEditor(editor);
      };
      if (parameters.fileVersionRouterCb) {
        fileVersionRouterCb = parameters.fileVersionRouterCb;
      }
      if (parameters.onFileInforChanged) {
        onFileInforChanged = parameters.onFileInforChanged;
      }
      if (!editor) {
        var editor = new _MDPCFileEditorController["default"]({
          fileVersionRouterCb: fileVersionRouterCb,
          onFileInforChanged: onFileInforChanged,
          onClose: onClose
        });
        self._dispEditor(editor);
        if (commentId == undefined) {
          editor.displayFiles(fileInfoArray, fileInfo, version, true);
        } else if (searchText) {
          editor.displayFilesAndSearchText(fileInfoArray, fileInfo, searchText, true);
        } else {
          editor.displayFilesAndComment(fileInfoArray, fileInfo, commentId, true);
        }
      } else {
        var silent = false;
        if (version > -1) {
          silent = true;
        }
        if (commentId == undefined) {
          editor.displayFiles(fileInfoArray, fileInfo, version, silent);
        } else if (searchText) {
          editor.displayFilesAndSearchText(fileInfoArray, fileInfo, searchText, true);
        } else {
          editor.displayFilesAndComment(fileInfoArray, fileInfo, commentId, silent);
        }
      }
      if (_.isFunction(openCb)) {
        openCb(true);
      }
    });
  }
  ;
  function _tryDispWithOnlyOffice(fileInfo, version) {
    var succ = false;
    if (fileInfo.isOfficeFile() && window.OfficeOnlineFullOpen && window.OfficeOnlineFullOpen.length > 0 && window.officeOnlineHost && window.officeOnlineHost.length > 0) {
      var editor = new _MDOfficeOnlineEditor["default"]();
      // var editor = new MDOnlyOfficeEditor();
      editor.editFile(fileInfo, version);
      succ = true;
    }
    return succ;
  }
  return {
    _check2CreateEditorSlot: function _check2CreateEditorSlot() {
      var self = this;
      var $editorField = $('.editors-field');
      if ($editorField.length == 0) {
        $('.app-root').append("<div class=\"editors-field single \">\n                            <div class=\"editor-slot editor-slot1\"></div>\n                            <div class=\"editor-spliter\"></div>\n                            <div class=\"editor-slot editor-slot2\"></div>\n                          </div>");
        $('.editor-spliter').on('mousedown', function (e) {
          $('.editor-slot').css('pointer-events', 'none');
          self.captured = true;
          self.startX = e.clientX;
          self.startY = e.clientY;
        });
        $('.editors-field, .editor-spliter').on('mousemove', function (e) {
          if (self.captured) {
            var deltaX = e.clientX - self.startX;
            self.splitDeltaX += deltaX;
            self._refreshSlotPosition();
          }
          self.startX = e.clientX;
          self.startY = e.clientY;
        });
        $('.editor-field, .editor-spliter').on('mouseup', function (e) {
          self.captured = false;
          $('.editor-slot').css('pointer-events', 'auto');
          if (self.refreshTimeout) {
            clearTimeout(self.refreshTimeout);
          }
          self.refreshTimeout = setBabelTimeout(function () {
            self._refreshEditor();
          }, 10);
        });
        this.splitDeltaX = 0;
        this._refreshSlotPosition();
        return $('.editor-slot1');
      } else {
        $('.editors-field').removeClass('single');
        this.editors.length > 1 && this.editors[1].close();
        this.splitted = true;
        this._refreshSlotPosition();
        $('.editors-field').addClass('split-horiz');
        return $('.editor-slot2');
      }
    },
    _refreshSlotPosition: function _refreshSlotPosition() {
      var self = this;
      if (this.splitted) {
        var plusMinor = self.splitDeltaX >= 0 ? ' + ' : ' - ';
        var cssStr = 'calc(50%' + plusMinor + Math.abs(self.splitDeltaX) + 'px)';
        $('.editor-slot1').css('width', cssStr);
        $('.editor-spliter').css('left', cssStr);
        $('.editor-slot2').css('left', cssStr);
      } else {
        $('.editor-slot1').css('width', '100%');
        $('.editor-spliter').css('left', "100%");
        $('.editor-slot2').css('left', '100%');
      }
    },
    _refreshEditor: function _refreshEditor() {
      var self = this;
      for (var i = 0; i < self.editors.length; i++) {
        var editor = self.editors[i];
        editor.refreshSize();
      }
    },
    _ckeck2RemoveEditorSlot: function _ckeck2RemoveEditorSlot() {
      var $editors = $('.p-editor-root');
      this.splitted = false;
      this._refreshSlotPosition();
      if ($editors.length == 0) {
        return true;
      } else {
        $('.editors-field').removeClass('split-horiz');
      }
    },
    openFiles4PC: function openFiles4PC(fileInfo, version, closeCb, openCb) {
      var _this = this;
      _MMFileInfo["default"].prepareLinkedFileInfo(fileInfo, function () {
        // html 文件只允许查看当前版本
        if (fileInfo.canDispInWebBrowser()) {
          version = undefined;
        }
        ;
        var param = {
          fileInfo: fileInfo,
          version: version,
          closeCb: closeCb,
          openCb: openCb
        };
        _openFiles.call(_this, param);
      });
    },
    openFiles4Share: function openFiles4Share(fileInfo, version, option) {
      if (window.canUseOnlyOffice && (fileInfo.isExel() && window.readExcelWithOnlyOffice == 1 || fileInfo.isOfficeFile() && window.user.hasWindowsServer == 0)) {
        var v = version;
        if (isNaN(v)) {
          v = -1;
        }
        var fid = fileInfo.getFileId();
        if (fileInfo.isShortcuts()) {
          fid = fileInfo.getShortCutsTargetFileId();
        }
        // if(fileInfo.canUploadVersion() && (v == -1 || v == fileInfo.getCurVersion())) {
        //   MMCommonFun.openOffice2Edit(fid);
        // } else {
        _MMCommonFun["default"].openExcel2Read(fid, v, true);
        // }
        // app.pathRouter.openNetTab("/netdrive/openFileByBabelOffice.do?fileId=" + fid + "&readOnly=1&version=" + v);
        return;
      }
      if (fileInfo.canDispInWebBrowser()) {
        version = undefined;
      }
      ;
      var param = {
        fileInfo: fileInfo,
        version: version,
        closeCb: option.onClose,
        fileVersionRouterCb: option.fileVersionRouterCb,
        onFileInforChanged: option.onFileInforChanged
      };
      _openFiles.call(this, param);
    },
    /**
     *  打开文件时同时打开批注
     *  @param 【必填项】{MMFileInfo} fileInfo
     *  @param 【必填项】{int} commentId  批注的 id
     *  @param 【可选项】{function} closeCb
     *  @param 【可选项】{function} openCb
     */
    openFilesAndComment4PC: function openFilesAndComment4PC(fileInfo, commentId, closeCb, openCb) {
      var param = {
        fileInfo: fileInfo,
        commentId: commentId,
        closeCb: closeCb,
        openCb: openCb
      };
      _openFiles.call(this, param);
    },
    /**
     * 打开文件，不支持路由
     * @param  {[type]} fileInfo [description]
     * @param  {[type]} version  [description]
     * @param  {[type]} closeCb  [description]
     * @return {[type]}          [description]
     */
    openFileWithoutRouter: function openFileWithoutRouter(fileInfo, version, closeCb, commentId, searchText) {
      var self = this;
      _MMFileInfo["default"].prepareLinkedFileInfo(fileInfo, function () {
        if (fileInfo.isShortcuts()) {
          fileInfo = fileInfo.getShortCutsTargetFile();
        }
        var checkParam = {
          fileInfo: fileInfo
        };

        // html 文件只允许查看当前版本
        if (fileInfo.canDispInWebBrowser()) {
          version = undefined;
        }
        ;
        self.checkToAlertCannotDisp(checkParam, function (canOpen) {
          if (!canOpen) {
            return;
          }
          var editor = new _MDPCFileEditorController["default"]({
            enableRouterNavigation: false,
            onClose: function onClose() {
              if (self._ckeck2RemoveEditorSlot()) {
                _.isFunction(closeCb) && closeCb();
                getPdfPageLoader().clear();
              }
              self._removeEditor(editor);
            }
          });
          self._dispEditor(editor);
          if (commentId) {
            editor.displayFilesAndComment(null, fileInfo, commentId, true);
          } else if (searchText) {
            editor.displayFilesAndSearchText(null, fileInfo, searchText, true);
          } else {
            editor.displayFiles(null, fileInfo, version, true);
          }
        });
      });
    },
    openFilesWithoutRouter: function openFilesWithoutRouter(fileInfos, curFileInfo, closeCb) {
      var self = this;
      var checkParam = {
        fileInfo: curFileInfo
      };
      self.checkToAlertCannotDisp(checkParam, function (canOpen) {
        if (!canOpen) {
          return;
        }
        var editor = new _MDPCFileEditorController["default"]({
          enableRouterNavigation: false,
          onClose: function onClose() {
            _.isFunction(closeCb) && closeCb();
            getPdfPageLoader().clear();
            self._removeEditor(editor);
          }
        });
        self._dispEditor(editor);
        var dispInfos = [];
        for (var i = 0; i < fileInfos.length; i++) {
          var fileInfo = fileInfos[i];
          if (fileInfo.canDispInEditor()) {
            dispInfos.push(fileInfo);
          }
          ;
        }
        ;
        editor.displayFiles(dispInfos, curFileInfo, -1, true);
      });
    },
    _dispEditor: function _dispEditor(editor) {
      var self = this;
      var $slot = self._check2CreateEditorSlot();
      application.addSubView(editor, $slot[0]);
      self.editors.push(editor);
      setBabelTimeout(function () {
        self._refreshEditor();
      }, 100);
    },
    _removeEditor: function _removeEditor(editor) {
      var self = this;
      self.editors.remove(editor);
      if (this.editors.length == 0) {
        $('.editor-spliter').off();
        $('.editor-field').off();
        $('.editors-field').remove();
        _MMWhiteboardController["default"].closeAll();
        Dispatcher.off(self);
        MDPCDisplayFileController.singleton = null;
      } else {
        this.editors[0].refreshCurrentMainEditor();
      }
      self._refreshEditor();
    },
    closeAll: function closeAll() {
      this.editors.forEach(function (editor) {
        editor.close();
      });
    }
  };
}());
MDPCDisplayFileController.openFilesWithoutRouter = function (fileInfos, curFileInfo, closeCb) {
  if (window.canUseOnlyOffice && (curFileInfo.isExel() && window.readExcelWithOnlyOffice == 1 || curFileInfo.isOfficeFile() && window.user.hasWindowsServer == 0)) {
    var fid = curFileInfo.getFileId();
    if (curFileInfo.isShortcuts()) {
      fid = curFileInfo.getShortCutsTargetFileId();
    }
    if (curFileInfo.canUploadVersion()) {
      _MMCommonFun["default"].openOffice2Edit(fid);
    } else {
      _MMCommonFun["default"].openExcel2Read(fid);
    }
    // app.pathRouter.openNetTab("/netdrive/openFileByBabelOffice.do?fileId=" + fid + "&readOnly=1");
    return;
  }
  if (!MDPCDisplayFileController.singleton) {
    MDPCDisplayFileController.singleton = new MDPCDisplayFileController();
  }
  ;
  var displayController = MDPCDisplayFileController.singleton;
  _MMFileInfo["default"].prepareLinkedFileInfo(curFileInfo, function () {
    var realFile = curFileInfo;
    if (curFileInfo.isShortcuts()) {
      realFile = curFileInfo.getShortCutsTargetFile();
    }
    var checkParam = {
      fileInfo: realFile
    };
    displayController.checkToAlertCannotDisp(checkParam, function (canOpen) {
      if (!canOpen) {
        MDPCDisplayFileController.singleton = null;
        if (closeCb) {
          closeCb();
        }
        ;
        return;
      }
      displayController.openFilesWithoutRouter(fileInfos, curFileInfo, function closed() {
        MDPCDisplayFileController.singleton = null;
        if (closeCb) {
          closeCb();
        }
        ;
      });
      // displayController.openFileWithoutRouter(self.fileInfor, -1);
    });
  });
};
MDPCDisplayFileController.previewFile = function (fileId) {
  if (!MDPCDisplayFileController.singleton) {
    MDPCDisplayFileController.singleton = new MDPCDisplayFileController();
  }
  ;
  var displayController = MDPCDisplayFileController.singleton;
  _MMNetDiskDataController["default"].getFileInfoByFileId(fileId, function (curFileInfo) {
    _MMFileInfo["default"].prepareLinkedFileInfo(curFileInfo, function () {
      var realFile = curFileInfo;
      if (curFileInfo.isShortcuts()) {
        realFile = curFileInfo.getShortCutsTargetFile();
      }
      var checkParam = {
        fileInfo: realFile
      };
      displayController.checkToAlertCannotDisp(checkParam, function (canOpen) {
        if (!canOpen) {
          MDPCDisplayFileController.singleton = null;
          return;
        }
        displayController.openFilesWithoutRouter([curFileInfo], curFileInfo, function closed() {
          MDPCDisplayFileController.singleton = null;
          if (closeCb) {
            closeCb();
          }
          ;
        });
        // displayController.openFileWithoutRouter(self.fileInfor, -1);
      });
    });
  }, function () {});
};
MDPCDisplayFileController.getSingleton = function () {
  if (!MDPCDisplayFileController.singleton) {
    MDPCDisplayFileController.singleton = new MDPCDisplayFileController();
  }
  return MDPCDisplayFileController.singleton;
};
MDPCDisplayFileController.openSingleFileWithFileId = function (fileId, success, failCb) {
  _MMNetDiskDataController["default"].getFileInfoFromServerWithoutTrash(fileId, function succeess(fileInfor) {
    if (fileInfor.isExel() && window.readExcelWithOnlyOffice == 1) {
      var fid = fileInfor.getFileId();
      if (fileInfor.isShortcuts()) {
        fid = fileInfor.getShortCutsTargetFileId();
      }
      _MMCommonFun["default"].isOfficeFile(fid);
      // app.pathRouter.openNetTab("/netdrive/openFileByBabelOffice.do?fileId=" + fid + "&readOnly=1");
      return;
    }
    if (fileInfor.isFolder()) {} else {
      var displayController = MDPCDisplayFileController.getSingleton();
      var checkParam = {
        fileInfo: fileInfor
      };
      displayController.checkToAlertCannotDisp(checkParam, function (canOpen) {
        if (!canOpen) {
          return;
        }
        displayController.openFileWithoutRouter(fileInfor, -1);
      });
    }
    success && success(fileInfor);
  }, function fail(errCode, errMsg) {
    failCb && failCb(errCode, errMsg);
  });
};
window.MDPCDisplayFileController = MDPCDisplayFileController;
var _default = exports["default"] = MDPCDisplayFileController;

},{"1104":1104,"1109":1109,"1184":1184,"1418":1418,"1432":1432,"1454":1454,"1463":1463,"1466":1466,"1537":1537,"297":297,"411":411,"420":420,"421":421,"423":423,"55":55,"72":72,"812":812}],423:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1446);
require(1416);
require(1466);
require(1432);
var _MDEvaluationStatus = _interopRequireDefault(require(254));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDEvaluationListPaneInEditorView = _interopRequireDefault(require(465));
var _MMViewBase = _interopRequireDefault(require(22));
var _MDTopToolbar4PC = _interopRequireDefault(require(435));
var _MMWhiteboardController = _interopRequireDefault(require(1109));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDCommonFileEditorController = _interopRequireDefault(require(410));
var _MMParticipantCollection = _interopRequireDefault(require(307));
var _MDIntro = _interopRequireDefault(require(329));
var _MDPCEditorViewController = _interopRequireDefault(require(940));
var _MDEditorContentPanelView = _interopRequireDefault(require(414));
var _MMBasicData = _interopRequireDefault(require(811));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDEvaluationToolbar = _interopRequireDefault(require(470));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MDSearchPdfTextToolbar = _interopRequireDefault(require(430));
/**
 *  file editor view, slide between different files, check comments, add comments
 *  Create by jiang
 *  2015.9.9
 */

var MDPCFileEditorController = _MDCommonFileEditorController["default"].extend(function () {
  /**
   * 显示系列文档
   * @param {Object} parameters{
   *     fileInfos  -  文件数组
   *     curFileInfo  - {MMFileInfo} 要打开的那个文件
   *     version - {int} 文件的版本
   *     commentId - 要打开的文件中的那个批注点 ，如果指定这个属性，则会自动忽略 version 指向的版本
   *     opt_silent -
   * }
   *
   */
  function _displayFiles(parameters) {
    var fileInfos = parameters.fileInfos;
    var curFileInfo = parameters.curFileInfo;
    var version = parameters.version;
    var commentId = parameters.commentId;
    var opt_silent = parameters.opt_silent;
    var self = this;
    var curFileIndex = 0;
    version = Number(version); // backbone的findWhere是严格比较
    if (_.isArray(fileInfos)) {
      curFileIndex = -1;
      curFileIndex = _.findIndex(fileInfos, function (fileInfor) {
        return fileInfor == curFileInfo;
      });
      if (curFileIndex == -1) {
        curFileIndex = _.findIndex(fileInfos, function (fileInfor) {
          return fileInfor.getFileId() == curFileInfo.getFileId();
        });
      }
      if (curFileIndex == -1) {
        curFileIndex = 0;
        fileInfos = [curFileInfo];
      }
    } else {
      fileInfos = [curFileInfo];
    }
    parameters.fileInfos = fileInfos;
    if (!self.editorViewCtl) {
      self.editorViewCtl = new _MDPCEditorViewController["default"](self.$(".p-editor-zone")[0]);
    }
    function callback(board, errorCode) {
      if (!board) {
        var msg = "<p class=\"title\">".concat(BabelStr.str(5058), "\uFF01</p>");
        if (errorCode == 134) {
          msg = "<p class=\"title\">".concat(BabelStr.str(5059), "</p>");
        } else if (errorCode == 404) {
          msg = "<p class=\"title\">".concat(BabelStr.str(6145), "</p>");
        } else if (errorCode == 313) {
          msg = "<p class=\"title\">".concat(BabelStr.str(8350), "</p>");
        }
        var alert = new _MDAlertView["default"]();
        alert.show({
          title: BabelStr.str(170),
          message: msg,
          className: "m-delAlertWin",
          buttons: [{
            label: BabelStr.str(156),
            onClick: function onClick() {}
          }]
        });
      } else {
        self.setEditorViewCtl(self.editorViewCtl);
        var fileName = curFileInfo.getFileName();
        self.topToolBar.displayPageInfo(curFileIndex, fileInfos.length, fileName, version);
        if (!curFileInfo.isBabelOffice()) {
          _MDIntro["default"].autoIntroEditor();
        }
        self.$(".p-editor-zone").css(Modernizr.prefixedCSS("user-select"), "text");
        Dispatcher.trigger(MDEvents.afterChangeToNextFile);
        if (!curFileInfo.isVersionUpdatedAfterOnlyOffice()) {
          _MDAlertView["default"].showStandardPrompt({
            message: BabelStr.str(6149),
            okStr: BabelStr.str(3604)
          });
        }
      }
    }
    parameters.callback = callback;
    parameters.curFileIndex = curFileIndex;
    self.editorViewCtl.displayFiles(parameters);
  }
  return {
    el: '<div class="p-editor-root"></div>',
    tmpl: '<div id="editorContentPanelSlot"></div>' + '<div class="p-right-zone"></div>' + '<div class="p-progress-root">' + '<div class="p-progress-bar"></div>' + "</div>" + "\n<div id=\"overlayContainer\" class=\"f-hide\">\n        <div id=\"passwordOverlay\" class=\"container hidden\">\n          <div class=\"dialog\">\n            <div class=\"row\">\n              <p id=\"passwordText\" data-l10n-id=\"password_label\"><%=BabelStr.str(5056)%></p>\n            </div>\n            <div class=\"row\">\n\n            </div>\n            <div class=\"buttonRow\">\n              <button id=\"passwordCancel\" class=\"overlayButton\"><span data-l10n-id=\"password_cancel\"><%=BabelStr.str(155)%></span></button>\n              <button id=\"passwordSubmit\" class=\"overlayButton\"><span data-l10n-id=\"password_ok\"><%=BabelStr.str(154)%></span></button>\n            </div>\n          </div>\n        </div>\n        <div id=\"documentPropertiesOverlay\" class=\"container hidden\">\n          <div class=\"dialog\">\n            <div class=\"row\">\n              <span data-l10n-id=\"document_properties_file_name\"><%=BabelStr.str(49)%>:</span> <p id=\"fileNameField\">-</p>\n            </div>\n            <div class=\"row\">\n              <span data-l10n-id=\"document_properties_file_size\"><%=BabelStr.str(3278)%>:</span> <p id=\"fileSizeField\">-</p>\n            </div>\n            <div class=\"separator\"></div>\n            <div class=\"row\">\n              <span data-l10n-id=\"document_properties_title\"><%=BabelStr.str(3156)%>:</span> <p id=\"titleField\">-</p>\n            </div>\n            <div class=\"row\">\n              <span data-l10n-id=\"document_properties_author\"><%=BabelStr.str(5056)%>:</span> <p id=\"authorField\">-</p>\n            </div>\n            <div class=\"row\">\n              <span data-l10n-id=\"document_properties_subject\"><%=BabelStr.str(3171)%>:</span> <p id=\"subjectField\">-</p>\n            </div>\n            <div class=\"row\">\n              <span data-l10n-id=\"document_properties_keywords\"><%=BabelStr.str(5062)%>:</span> <p id=\"keywordsField\">-</p>\n            </div>\n            <div class=\"row\">\n              <span data-l10n-id=\"document_properties_creation_date\"><%=BabelStr.str(3048)%>:</span> <p id=\"creationDateField\">-</p>\n            </div>\n            <div class=\"row\">\n              <span data-l10n-id=\"document_properties_modification_date\"><%=BabelStr.str(5063)%>:</span> <p id=\"modificationDateField\">-</p>\n            </div>\n            <div class=\"row\">\n              <span data-l10n-id=\"document_properties_creator\"><%=BabelStr.str(68)%>:</span> <p id=\"creatorField\">-</p>\n            </div>\n            <div class=\"separator\"></div>\n            <div class=\"row\">\n              <span data-l10n-id=\"document_properties_producer\">PDF <%=BabelStr.str(5064)%>:</span> <p id=\"producerField\">-</p>\n            </div>\n            <div class=\"row\">\n              <span data-l10n-id=\"document_properties_version\">PDF <%=BabelStr.str(282)%>:</span> <p id=\"versionField\">-</p>\n            </div>\n            <div class=\"row\">\n              <span data-l10n-id=\"document_properties_page_count\"><%=BabelStr.str(5065)%>:</span> <p id=\"pageCountField\">-</p>\n            </div>\n            <div class=\"buttonRow\">\n              <button id=\"documentPropertiesClose\" class=\"overlayButton\"><span data-l10n-id=\"document_properties_close\"><%=BabelStr.str(156)%></span></button>\n            </div>\n          </div>\n        </div>\n        <div id=\"printServiceOverlay\" class=\"container hidden\">\n          <div class=\"dialog\">\n            <div class=\"row\">\n              <span data-l10n-id=\"print_progress_message\"><%=BabelStr.str(5066)%></span>\n            </div>\n            <div class=\"row\">\n              <progress value=\"36\" max=\"100\"></progress>\n              <span data-l10n-id=\"print_progress_percent\" data-l10n-args=\"{ &quot;progress&quot;: 0 }\" class=\"relative-progress\">36%</span>\n            </div>\n            <div class=\"buttonRow\">\n              <button id=\"printCancel\" class=\"overlayButton\"><span data-l10n-id=\"print_progress_close\"><%=BabelStr.str(155)%></span></button>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div id=\"printContainer\"></div>\n      ",
    initProps: function initProps() {
      var superP = _MDCommonFileEditorController["default"].prototype.initProps.call(this);
      return _.extend(superP, {
        editorViewCtl: null,
        topToolBar: null,
        toggling: false,
        // 是否正在切换打开右侧面板

        progress: 0,
        postClose: null,
        pageInfos: [],
        onFileInforChanged: _.noop,
        enableRouterNavigation: true,
        // 是否支持路由

        fileVersionRouterCb: _.noop
      });
    },
    initialize: function initialize(opt) {
      var self = this;
      _MDCommonFileEditorController["default"].prototype.initialize.call(this, opt);
      var z_startIndex = _MMBasicData["default"].getO2OStartLayerZ_index();
      $(this.$(".p-progress-root")).css("z-index", z_startIndex);
      this.topToolBar = new _MDTopToolbar4PC["default"]({
        enableRouterNavigation: this.enableRouterNavigation,
        fileVersionRouterCb: this.fileVersionRouterCb
      });
      this.addSubView(this.topToolBar);
      this.mainEditorView = new _MDEditorContentPanelView["default"]();
      this.addSubView(this.mainEditorView, this.$("#editorContentPanelSlot"), true);
      Dispatcher.on(MDEvents.EditorPageIndexChanged, this._editorPageIndexChanged, this);
      Dispatcher.on(MDEvents.evaluationChanged, this.evaluationInfoChanged, this);
      Dispatcher.on(MDEvents.TileRenderProgress, this.tileDrawingProgress, this);
      Dispatcher.on(MDEvents.Search_pdf_text_cliked, this._textSearchClicked, this);
      this.bindSelf(this._windowResizeHandler);
      $(window).on("resize.fileEditor", _.debounce(this._windowResizeHandler, 500));
      if (app.ep.canShowEvalModel()) {
        this._initEvaluationPanel();
      }
      viewManager.add("fileEditor", this);

      // 注册左右按钮的响应事件
      this.keyDownFun = function (e) {
        if (!_MMCommonFun["default"].hasTextInputInEditor() && e.target.tagName != "INPUT") {
          var keyCode = e.keyCode;
          if (!e.altKey && (keyCode == 37 || keyCode == 39)) {
            e.stopPropagation();
            e.preventDefault();
            console.log("-------------- key down!");
            if (keyCode == 37) {
              //左箭头
              self.change2next(false);
            } else if (keyCode == 39) {
              // 右键头
              self.change2next(true);
            }
          } else if (keyCode == 27) {
            console.log("-------------- escape key down!");
            var fileInfo = self.editorViewCtl && self.editorViewCtl.getCurrentFileInfo();
            if (fileInfo && fileInfo.isImage()) {
              self.close();
            } else if (e.altKey) {
              self.close();
            }
          }
        }
      };
      document.addEventListener("keydown", this.keyDownFun, true);
      console.log("addEventListener -------------- key down!");
      MDPCFileEditorController.addInstance(this);
    },
    showToggleBtn: function showToggleBtn() {
      this.topToolBar && this.topToolBar.showToggleBtn();
    },
    change2next: function change2next(next) {
      if (!this.editorViewCtl) {
        return;
      }
      if (next) {
        this.topToolBar._nextFileClicked();
      } else {
        this.topToolBar._preFileClicked();
      }
    },
    _initEvaluationPanel: function _initEvaluationPanel() {
      this.evalToolbar = new _MDEvaluationToolbar["default"]();
      this.addSubView(this.evalToolbar);
      this.evalToolbar.hide();
      this.evalListPanel = new _MDEvaluationListPaneInEditorView["default"]({
        inEditor: true
      });
      this.addSubView(this.evalListPanel);
      this.evalListPanel.hide(); // ------------测试使用，正式开发应该去除
    },
    _editorPageIndexChanged: function _editorPageIndexChanged() {
      var fileInfor = this.editorViewCtl.getCurrentFileInfo();
      _.isFunction(this.onFileInforChanged) && this.onFileInforChanged(fileInfor);
    },
    _windowResizeHandler: function _windowResizeHandler() {
      this.editorViewCtl.refreshSize();
    },
    setEditorViewCtl: function setEditorViewCtl(editorViewCtl) {
      this.editorViewCtl = editorViewCtl;
      this.topToolBar.setEditorViewCtl(editorViewCtl);
      this.mainEditorView.setEditorViewCtl(editorViewCtl);
      this.evalToolbar && this.evalToolbar.setEditorViewCtl(editorViewCtl);
      this.evalListPanel && this.evalListPanel.setEditorViewCtl(editorViewCtl);
      this.searchBar && this.searchBar.setEditorViewCtl(editorViewCtl);

      /*打开文档后让光标聚焦到当前页面*/
      // this.$(".operate-layer").eq(0).attr("tabindex" , "0")
      // this.$(".operate-layer").eq(0).focus();
      // this.$(".operate-layer").eq(0).css("outline","none")

      $(".p-editor-root").focus();
    },
    displayFiles: function displayFiles(fileInfos, curFileInfo, version, opt_silent) {
      var parameters = {
        fileInfos: fileInfos,
        curFileInfo: curFileInfo,
        version: version,
        opt_silent: opt_silent
      };
      _displayFiles.call(this, parameters);
    },
    displayFilesAndComment: function displayFilesAndComment(fileInfos, curFileInfo, commentId, opt_silent) {
      var parameters = {
        fileInfos: fileInfos,
        curFileInfo: curFileInfo,
        commentId: commentId,
        opt_silent: opt_silent
      };
      _displayFiles.call(this, parameters);
    },
    displayFilesAndSearchText: function displayFilesAndSearchText(fileInfos, curFileInfo, searchText, opt_silent) {
      var parameters = {
        fileInfos: fileInfos,
        curFileInfo: curFileInfo,
        searchText: searchText,
        opt_silent: opt_silent
      };
      _displayFiles.call(this, parameters);
    },
    toggleRightPanel: function toggleRightPanel(animate) {
      var self = this;
      if (animate == undefined || animate == null) {
        animate = true;
      }
      if (this.toggling) {
        return;
      }
      this.toggling = true;
      var editorRight = parseInt(this.$(".p-editor-zone").css("right"));
      var verRight = 0;
      if (editorRight == 0) {
        editorRight = 300;
        verRight = 0;
      } else {
        editorRight = 0;
        verRight = -300;
      }
      if (editorRight > 0) {
        this.$(".p-right-zone").css("display", "block");
      }
      this.changeEditorZoneWidth(animate, editorRight, function finished() {
        self.toggling = false;
        if (self.editorViewCtl) {
          self.editorViewCtl.refreshSize();
        }
      });
      this.changeRightZoneWidth(animate, verRight, function finished() {
        if (editorRight == 0) {
          self.$(".p-right-zone").css("display", "none");
          self.topToolBar.clearToolFocus("version-btn");
        } else {
          self.topToolBar.setToolFocus("version-btn");
        }
      });
      if (editorRight != 0) {
        this.displayFileInfo();
      }
    },
    changeEditorZoneWidth: function changeEditorZoneWidth(animate, editorRight, callback) {
      if (animate) {
        this.$(".p-editor-zone").animate({
          right: editorRight
        }, callback);
      } else {
        this.$(".p-editor-zone").css({
          right: editorRight
        });
        callback();
      }
    },
    changeRightZoneWidth: function changeRightZoneWidth(animate, verRight, callback) {
      if (animate) {
        this.$(".p-right-zone").animate({
          right: verRight
        }, callback);
      } else {
        this.$(".p-right-zone").css({
          right: verRight
        });
        callback();
      }
    },
    close: function close() {
      this.removeFromSuperView();
      var fileInfo = this.editorViewCtl && this.editorViewCtl.getCurrentFileInfo();
      this.onClose.call(this, fileInfo);
      document.removeEventListener("keydown", this.keyDownFun, true);
    },
    viewWillUnRendered: function viewWillUnRendered() {
      _MDCommonFileEditorController["default"].prototype.viewWillUnRendered.call(this);
      Dispatcher.off(null, null, this);
      MDPCFileEditorController.removeInstance(this);
      _MDPCEditorViewController["default"].clearCurrentInstance();
      $(window).off("resize.fileEditor");
      viewManager.remove("fileEditor");
      viewManager.remove("pdfBottomBtn");
      if (this.topToolBar) {
        this.topToolBar.removeFromSuperView();
      }
      if (this.evalListPanel) {
        this.evalListPanel.remove();
      }
    },
    displayFileInfo: function displayFileInfo() {
      var self = this;
      if (!this.editorViewCtl) {
        return;
      }
      if (this.searchBar) {
        this.searchBar.remove();
        this.searchBar = null;
      }
      var fileInfo = this.editorViewCtl.getCurrentFileInfo();
      var _ver = this.editorViewCtl.getVersionShowing();
      var board = this.editorViewCtl.getCurrentBoard();
      window.pdfjsLib && board && board.registerFindController(_ver, this.editorViewCtl.editor);
      var penPanelOpt = {
        show: true
      };
      if (fileInfo.isArchived() || fileInfo.canDispInOpenGL() || fileInfo.canDispInWebBrowser() || !fileInfo.dispNeedWhiteBoard() || fileInfo.isOnlyDisp()) {
        penPanelOpt.show = false;
      } else {}
      this.mainEditorView.showPenListPanel(penPanelOpt);
      var curFileIndex = this.editorViewCtl.getCurrentFileIndex();
      if (curFileIndex < 0 || this.pageInfos.length <= 0) {
        return;
      }
      var curFileId = this.pageInfos[curFileIndex].get("fileId");
      var disp = this.$(".p-right-zone").css("display");
    },
    tileDrawingProgress: function tileDrawingProgress(opt) {
      var self = this;
      var progress = opt.progress;
      var editorViewCtl = opt.editorViewCtl;
      if (editorViewCtl != this.editorViewCtl) {
        return;
      }
      $(this.$(".p-progress-root")).css("display", "block");
      $(this.$(".p-progress-bar")).css("width", progress * 100 + "%");
      if (progress && (progress >= 1.0 || Math.abs(progress, 1.0) < 0.01)) {
        setBabelTimeout(function () {
          self.hideProgressBar();
        }, 1500);
      }
    },
    showProgressBar: function showProgressBar(progress) {
      if (progress) {
        if (progress > this.progress) {
          this.progress = progress;
        }
      }
      var self = this;
      if (this.progTimer) {
        clearTimeout(this.progTimer);
        this.progTimer = null;
      }
      $(this.$(".p-progress-root")).css("display", "block");
      $(this.$(".p-progress-bar")).css("width", this.progress * 100 + "%");
      if (progress && (this.progress >= 1.0 || Math.abs(this.progress, 1.0) < 0.01)) {
        setBabelTimeout(function () {
          self.hideProgressBar();
        }, 1500);
      } else {
        this.progTimer = setBabelTimeout(function () {
          self.progress += 0.001;
          self.showProgressBar();
        }, 40);
      }
    },
    hideProgressBar: function hideProgressBar() {
      $(this.$(".p-progress-root")).css("display", "none");
    },
    toggleAINavigator: function toggleAINavigator(closed) {
      return this.mainEditorView.toggleAINavigator(closed);
    },
    hideAINavigator: function hideAINavigator() {
      return this.mainEditorView.hideAINavigator();
    },
    toggleOCRNavigator: function toggleOCRNavigator(closed) {
      return this.mainEditorView.toggleOCRNavigator(closed);
    },
    hideOCRNavigator: function hideOCRNavigator() {
      return this.mainEditorView.hideOCRNavigator();
    },
    toggleCommentsNavigator: function toggleCommentsNavigator(closed) {
      return this.mainEditorView.toggleCommentsNavigator(closed);
    },
    hideCommentsNavigator: function hideCommentsNavigator() {
      return this.mainEditorView.hideCommentsNavigator();
    },
    showBottomToolBar: function showBottomToolBar() {
      this.mainEditorView.showBottomToolBar();
    },
    // hideCommentsNavigator: function() {
    //   var commentsNaviZoneW = this.$commentsNaviZone.width();
    //   var standNaviW = 360;
    //   var editorL = 0;
    //   if (commentsNaviZoneW != 0) {
    //     commentsNaviZoneW = 0;
    //     editorL = 0;
    //     this.$commentsNaviZone.css("width", commentsNaviZoneW + 'px');
    //     this.$editorZone.css('left', commentsNaviZoneW + 'px');

    //     this.editorViewCtl.refreshSize();
    //   }
    //   return editorL > 0;
    // },

    refreshCommentsNavigator: function refreshCommentsNavigator() {
      this.mainEditorView && this.mainEditorView.refreshCommentsNavigator();
    },
    getCurrentBoard: function getCurrentBoard() {
      if (this.editorViewCtl) {
        return this.editorViewCtl.getCurrentBoard();
      }
    },
    changeVersion: function changeVersion(version, cb) {
      var self = this;
      if (this.editorViewCtl.getVersionShowing() != version) {
        this.editorViewCtl.changeVersion(version, function () {
          self.refreshCommentsNavigator();
          self.evalListPanel && self.evalListPanel.refreshWithVersion(version);
          if (cb) {
            cb();
          }
        });
      } else {
        cb && cb();
      }
    },
    hideEvaluationPanel: function hideEvaluationPanel() {
      if (this.evalToolbar) {
        this.evalToolbar.hide();
      }
      if (this.evalListPanel) {
        this.evalListPanel.hide();
      }
    },
    refreshEvaluationPanelWithCurFile: function refreshEvaluationPanelWithCurFile() {
      var fileInfo = this.editorViewCtl.getCurrentFileInfo();
      if (fileInfo && (fileInfo.getEvaluationFlowId() || !fileInfo.getEvaluationFlowId() && fileInfo.getEvaluationStatus() == _MDEvaluationStatus["default"].PASSED)) {
        if (this.evalListPanel && !this.evalListPanel.isShowing()) {
          this.evalToolbar && this.evalToolbar.show();
        }
        this.evalListPanel && this.evalListPanel.initWithFile(fileInfo);
      } else {
        this.evalToolbar && this.evalToolbar.hide();
      }
    },
    evaluationInfoChanged: function evaluationInfoChanged(fid) {
      var _this = this;
      var fileInfo = this.editorViewCtl.getCurrentFileInfo();
      if (!fileInfo) {
        return;
      }
      var fileId = fileInfo.getFileId();
      if (fileId != fid) {
        return;
      }
      _MDMessageView["default"].show(BabelStr.str(512), "infor", this.el);
      var version = fileInfo.getCurVersion();
      MMNetDiskDataController.getFileInfoFromServer(fileId, function (newFileInfo) {
        fileInfo.setEvaluationStatus(newFileInfo.getEvaluationStatus());
        fileInfo.setCurrentVersionEvaluation(newFileInfo.getCurrentVersionEvaluation());
        _this.refreshEvaluationPanelWithCurFile();
      }, function () {
        _MDSnackbarView["default"].show(BabelStr.str(510));
      });
    },
    refreshSize: function refreshSize() {
      if (this.editorViewCtl) {
        this.editorViewCtl.refreshSize();
      }
    },
    refreshCurrentMainEditor: function refreshCurrentMainEditor() {
      this.editorViewCtl.refreshCurrentMainEditor();
    },
    _textSearchClicked: function _textSearchClicked(options) {
      var editorViewCtl = options.editorViewCtl;
      var searchText = options.searchText;
      if (this.editorViewCtl != editorViewCtl) {
        return;
      }
      if (this.searchBar) {
        this.searchBar.remove();
        this.searchBar = null;
      } else {
        this.searchBar = new _MDSearchPdfTextToolbar["default"]({
          searchText: searchText,
          editorViewCtl: editorViewCtl
        });
        this.addSubView(this.searchBar);
        // this.searchBar.setEditorViewCtl(editorViewCtl)
      }
    }
  };
}());
MDPCFileEditorController.instances = [];
MDPCFileEditorController.addInstance = function (fileEditor) {
  MDPCFileEditorController.instances.push(fileEditor);
};
MDPCFileEditorController.removeInstance = function (fileEditor) {
  var index = -1;
  for (var i = 0; i < MDPCFileEditorController.instances.length; i++) {
    var editor = MDPCFileEditorController.instances[i];
    if (editor == fileEditor) {
      index = i;
      MDPCFileEditorController.instances.splice(i, 1);
    }
  }
  if (fileEditor.editorViewCtl) {
    fileEditor.editorViewCtl.removeFromSuperView();
    var fileInfo = fileEditor.editorViewCtl.getCurrentFileInfo();
    if (fileInfo) {
      var fileId = fileInfo.getFileId();
      var found = false;
      for (var _i = 0; _i < MDPCFileEditorController.instances.length; _i++) {
        var _editor = MDPCFileEditorController.instances[_i];
        var vCtl = _editor.editorViewCtl;
        var f2 = vCtl && vCtl.getCurrentFileInfo();
        if (f2 && f2.getFileId() == fileId) {
          found = true;
        }
      }
      if (!found) {
        _MMWhiteboardController["default"].closeWhiteboard(fileId);
      }
    }
  }
};
var _default = exports["default"] = MDPCFileEditorController;

},{"1109":1109,"1184":1184,"1416":1416,"1432":1432,"1446":1446,"1454":1454,"1466":1466,"22":22,"254":254,"307":307,"32":32,"329":329,"410":410,"414":414,"430":430,"435":435,"465":465,"470":470,"55":55,"72":72,"811":811,"812":812,"940":940}],465:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1412);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDEvaluationListPanel = _interopRequireDefault(require(466));
var _MDBasicToolPanel2 = _interopRequireDefault(require(456));
var _MMBasicData = _interopRequireDefault(require(811));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDEvents = _interopRequireDefault(require(325));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // MDBasicToolPanel.js
// jiang
// 2017-5-11
var MDEvaluationListPaneInEditorView = exports["default"] = /*#__PURE__*/function (_MDBasicToolPanel) {
  (0, _inherits2["default"])(MDEvaluationListPaneInEditorView, _MDBasicToolPanel);
  function MDEvaluationListPaneInEditorView() {
    (0, _classCallCheck2["default"])(this, MDEvaluationListPaneInEditorView);
    return _callSuper(this, MDEvaluationListPaneInEditorView, arguments);
  }
  (0, _createClass2["default"])(MDEvaluationListPaneInEditorView, [{
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.inEditor = true;
      props.closeIsHide = true;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvaluationListPaneInEditorView.prototype), "initialize", this).call(this, props);
      var self = this;
      this.listPanel = new _MDEvaluationListPanel["default"]({
        inEditor: true,
        onWithdraw: function onWithdraw() {
          _this.hide();
        }
      });
      this.addSubView(this.listPanel, this.$(".tool-p-content"));
      this.setTitle(BabelStr.str(508)); // ('审批列表');
      this.showSubTitle();
      _Dispatcher["default"].on(_MDEvents["default"].OpenEvalListPanel, this._epenEvalListPanel, this);
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvaluationListPaneInEditorView.prototype), "className", this).call(this);
      return superCls + ' editor-eval-panel';
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvaluationListPaneInEditorView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .toggle-comment": this.toggleComment
      });
    }
  }, {
    key: "toggleComment",
    value: function toggleComment() {
      this.$(".comment").toggleClass("f-hide");
    }
  }, {
    key: "onHide",
    value: function onHide() {
      if (this.inEditor) {
        _Dispatcher["default"].trigger(_MDEvents["default"].OpenEvalToolbar, {
          editorViewCtl: this.editorViewCtl
        });
      }
      ;
    }
  }, {
    key: "onShow",
    value: function onShow() {
      this.$el.show();
    }
  }, {
    key: "initWithFile",
    value: function initWithFile(fileInfo) {
      this.fileInfo = fileInfo;
      var version = -1; // -1 表示取当前的版本
      this.refreshWithVersion(version);
    }
  }, {
    key: "setEditorViewCtl",
    value: function setEditorViewCtl(editorViewCtl) {
      this.editorViewCtl = editorViewCtl;
    }
  }, {
    key: "refreshWithVersion",
    value: function refreshWithVersion(version) {
      var _this2 = this;
      var fileInfo = this.fileInfo;
      this.$('.tool-p-foot').empty();
      if (!fileInfo) {
        return;
      }
      ;
      if (fileInfo && fileInfo.getEvaluationFlowId()) {
        var fileId = fileInfo.getFileId();
        _MMNetDiskDataController["default"].getEvaluatorsGroup(fileId, version, this.fileInfo.getEvaluationFlowId(), function (evalFlow) {
          fileInfo.setEvalFlowInfo(version, evalFlow);
          _this2.refreshBtn(evalFlow);
          _this2.listPanel.refreshWithCurrentData(evalFlow, fileInfo, evalFlow.getFiles(), _this2.fileInfo.getEvaluationStatus());
        }, function (res) {
          if (res == _MMNetDiskDataController["default"].code.ERROR_EMPTY_EVALUATIONGROUPS) {
            _this2.listPanel.renderEmpty();
          } else {
            _MDSnackbarView["default"].show(BabelStr.str(510)); // ('获取审批信息失败')
          }
        });
      } else {
        this.listPanel.renderEmpty();
      }
    }
  }, {
    key: "_epenEvalListPanel",
    value: function _epenEvalListPanel(opt) {
      if (opt && opt.editorViewCtl != this.editorViewCtl) {
        return;
      }
      this.showPanel();
    }
  }, {
    key: "_initEvaluationListByData",
    value: function _initEvaluationListByData(evaluationFlowInfo) {
      this.evaluationFlowInfo = evaluationFlowInfo;
    }
  }, {
    key: "refreshBtn",
    value: function refreshBtn(evalFlow) {
      var time = new Date(evalFlow.getEndTime() * 1000);
      var creatorCap = BabelStr.str(509); // 发起人
      var timeCap = BabelStr.str(176); // 截止日期
      var creator = evalFlow.get('creatorName');
      var subtitle = '<div>' + creatorCap + '：' + creator + '</div>';
      var self = this;
      var curUserIsCreator = evalFlow.isCurUserCreator();
      var time = new Date(evalFlow.getEndTime() * 1000);
      var completedTime = evalFlow.getCompletedTimeStr();
      var comment = evalFlow.get("comment");
      var commentStr = "";
      if (comment) {
        commentStr = "<div class=\"comment-block \">\n        <div class=\"text-button done toggle-comment\">".concat(BabelStr.str(40093), "</div>\n        <div class=\"comment mgtb-10 f-hide\">").concat(comment, "</div>\n      </div>");
        // this.setSubTitle(subtitle);
      }
      if (completedTime) {
        var str = "<div class=\"complete-t-d\">\n            <span class=\"title-e\">".concat(BabelStr.str(6011), "</span>\n            <span class=\"end-time\">").concat(completedTime, "</span>\n          </div>") + commentStr;
        this.setSubTitle(str);
      } else {
        if (curUserIsCreator && !this.fileInfo.isPassed()) {
          var endtime = '<div>' + timeCap + '：' + '<span class="end-time cursor-p">' + '<input type="text" class="evl-date-end cursor-p" required readonly>' + '<i class="icon ep-expire-date cursor-p"></i>' + '</span>' + '</div>';
          subtitle += endtime;
          subtitle += commentStr;
          this.setSubTitle(subtitle);
          var $expireTimeBox = this.$(".evl-date-end");
          $expireTimeBox.datepicker({}).on("change", function () {
            var exDate = $expireTimeBox.datepicker("getDate");
            var t = exDate.getTime() / 1000;
            _MMNetDiskDataController["default"].updateEvaluationFlowTime(evalFlow.getId(), t, function () {
              _MDSnackbarView["default"].show(BabelStr.str(308));
            }, function () {
              _MDSnackbarView["default"].show(BabelStr.str(168));
            });
          });
          $expireTimeBox.datepicker('setDate', new Date(time));
          this.$('.end-time').on('click', function (e) {
            self.$('.evl-date-end').focus();
          });
          this.$('.end-time').addClass('cursor-p');
        } else {
          subtitle += '<div>' + timeCap + '：' + time.format("yyyy-MM-dd") + '</div>';
          subtitle += commentStr;
          this.setSubTitle(subtitle);
        }
      }
    }
  }]);
  return MDEvaluationListPaneInEditorView;
}(_MDBasicToolPanel2["default"]);

},{"1104":1104,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1437":1437,"1454":1454,"1463":1463,"1475":1475,"18":18,"325":325,"456":456,"466":466,"72":72,"811":811}],435:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require(1197));
require(1417);
require(1463);
require(1541);
require(1416);
require(1439);
require(1465);
require(1471);
require(1423);
require(1487);
require(1538);
require(1545);
require(1543);
var _MDFileActionController = _interopRequireDefault(require(492));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDEditorOption = _interopRequireDefault(require(905));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MMViewBase = _interopRequireDefault(require(22));
var _MMNetDiskImageCollectionView = _interopRequireDefault(require(938));
var _MDZoomPopupView = _interopRequireDefault(require(439));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDFilesNavigator = _interopRequireDefault(require(418));
var _app = _interopRequireDefault(require(17));
var _MDOnlineEventHandler = _interopRequireDefault(require(59));
var _keycode = _interopRequireDefault(require(104));
var _MDShareFileWindowView = _interopRequireDefault(require(695));
var _MMBasicData = _interopRequireDefault(require(811));
var _MMOperationCenter = _interopRequireDefault(require(874));
var _MMObjOperationStrategy = _interopRequireDefault(require(872));
var _OnlineEvent = _interopRequireDefault(require(60));
var _MDDownloadFileController = _interopRequireDefault(require(412));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDTextEditorController = _interopRequireDefault(require(1128));
var _MDKityMinderFileEditor = _interopRequireDefault(require(229));
var _MDIntro = _interopRequireDefault(require(329));
var _MDSalonPanelView = _interopRequireDefault(require(208));
var _MDSalonInfo = _interopRequireDefault(require(204));
var _MDEditorFileInfoPanel = _interopRequireDefault(require(415));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MMPrintServiveView = _interopRequireDefault(require(899));
var _MMPrintProgressView = _interopRequireDefault(require(898));
var _MDPCDisplayFileController = _interopRequireDefault(require(422));
var _MDFileCompareWinView = _interopRequireDefault(require(549));
var _MMCommonFun = _interopRequireDefault(require(812));
var _ErrorCode = _interopRequireDefault(require(1087));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MDAddTagBigWindow = _interopRequireDefault(require(781));
var _MDEvents = _interopRequireDefault(require(325));
var _menusvg = _interopRequireDefault(require(1119));
var _exportWord = _interopRequireDefault(require(232));
/**
 *  file editor view, slide between different files, check comments, add comments
 *  Create by jiang
 *  Path: /WebContent/javascript/moladisk/views/editor/MDTopToolbar4PC.js
 *  2015.9.9
 */

// import MDPdfPrintView from "../../../molasync-source/ui/controller/MDPdfPrintView.js";

// import htmlDocx from 'html-docx-js/dist/html-docx.js';

var MDTopToolbar4PC = _MMViewBase["default"].extend({
  el: '<div id="taskBoardToolBar" class="p-editor-toolbar tool-bar"></div>',
  tmpl: '<div class="left-toolbar">\
        <div class="p-tool-commentList f-fl squareBtn1 margin-10"> \
          <button class="btn-commentList button-icon button-li f-pointer" data-tooltip="<%=commentList%>"></button> \
          <div class="readStatus"></div>\
        </div> \
        <span class="p-tool-fileName f-fl"></span> \
        <span class = "p-tool-eva f-fl"></span>\
        <ul class="edit-tool"> \
          <li class="tool-li hide-tool-li"> \
            <button id="hideToolbarButton" class="button-icon p-tool-hide  button-li  f-pointer" data-tooltip="<%=BabelStr.str(6372)%>"></button> \
          </li> \
          <li class="tool-li full-li"> \
            <button id="fullButton" class="button-icon p-tool-full  button-li  f-pointer" data-tooltip="<%=fullScreen%>"></button> \
          </li> \
          <li class="tool-li"> \
            <button id="visibility" class="button-icon p-tool-visible button-li  f-pointer" data-tooltip="<%=hideComment%>"></button> \
          </li> \
          <li class="tool-li"> \
            <button id="download" class="button-icon p-tool-download button-li  f-pointer" data-tooltip="<%=download%>"></button> \
          </li> \
          <li> \
            <button id="zoomBtn" class="button-li p-tool-zoom"> \
              <span>100%</span> \
              <i class="button-icon selectBoxSmall"></i> \
            </button> \
          </li> \
          <li class="tool-li li-version"> \
            <div id="version-btn" class="p-tool-versions  button-li  button-icon" data-tooltip="<%=verInfo%>"></div> \
          </li> \
         <li class="tool-li"> \
            <button id="shareButton" class="button-icon share-btn  button-li " data-tooltip="<%=shareFile%>"></button> \
          </li> \
         <li class="tool-li"> \
            <button id="editButton" class="button-icon edit-btn  button-li " data-tooltip="<%=editFile%>"></button> \
          </li> \
         <li class="tool-li"> \
            <button id="onlineEditButton" class="button-icon online-edit-btn  button-li " data-tooltip="<%=BabelStr.str(5314)%>"></button> \
          </li> \
         <li class="tool-li"> \
            <button id="salonButton" class="button-icon salon-btn  button-li " data-tooltip="<%=salon%>"></button> \
            <div class="salon-opening"></div> \
          </li> \
          <li class="tool-li"> \
            <button id="printButton" class="button-icon print-btn  button-li " data-tooltip="<%=print%>"></button> \
           </li> \
          <li class="tool-li"> \
            <button id="compareButton" class="button-icon compare-btn  button-li " data-tooltip="<%=compare%>"></button> \
          </li> \
          <li class="tool-li"> \
          <button id="searchButton" class="button-icon p-tool-search   button-li  f-pointer" data-tooltip="<%=BabelStr.str(5159)%>"></button> \
        </li> \
        <li class="tool-li"> \
         <button id="rotateButton" class="button-icon p-tool-rotate   button-li  f-pointer" data-tooltip="<%=BabelStr.str(6055)%>"></button> \
        </li> \
        <li class="tool-li"> \
         <button id="tagButton" class="button-icon p-tool-tag   button-li  f-pointer" data-tooltip="<%=BabelStr.str(106)%>"></button> \
        </li> \
        <li class="tool-li"> \
         <button id="exportWordButton" class="button-icon p-tool-word   button-li  f-pointer" data-tooltip="<%=BabelStr.str(40012)%>"></button> \
        </li> \
        <li class="tool-li"> \
          <button id="linkButton" class="p-tool-link   button-li  f-pointer" data-tooltip="<%=BabelStr.str(27005)%>">\
            <%=menusvg.menu_link_file%>\
          </button> \
         </li> \
        <li class="tool-li encode-block" > \
        </li> \
        <li class="tool-li tool-ai"> \
         <button id="aiButton" class="button-icon p-tool-ai   button-li  f-pointer" data-tooltip="<%=BabelStr.str(11185)%>"></button> \
        </li> \
        <li class="tool-li tool-ocr"> \
        <button id="ocrButton" class="new-icon p-tool-ocr   button-li  f-pointer" data-tooltip="<%=BabelStr.str(12600)%>"></button> \
       </li> \
      </ul> \
      </div>\
      <div class="p-tool-close">\
        <button id="showToolbarButton" class="button-icon p-tool-show  button-li  f-pointer" data-tooltip="<%=BabelStr.str(6373)%>"></button>\
        <button id="aiButton" class="button-icon p-tool-ai tool-ai  button-li  f-pointer" data-tooltip="<%=BabelStr.str(11185)%>"></button> \
        <span  class="button-com button-icon e-close-btn"></span> \
      </div>',
  //  <li class="tool-li"> \
  //    <button id="addTagButton" class="button-icon p-tool-nicetag   button-li  f-pointer" data-tooltip="文字标记"></button> \
  //  </li> \
  //  <li class="tool-li"> \
  //    <button id="textCommentButton" class="button-icon p-tool-textComment  button-li  f-pointer" data-tooltip="文字批注"> \
  //      </utton> \
  //  </li> \
  // <li class="tool-li"> \
  //    <button id="commentButton" class="button-icon p-tool-comment  button-li  f-pointer" data-tooltip="添加批注"></button> \
  //  </li> \

  render: function render(data) {
    data = {
      commentList: _MDLocalString["default"].getLocalString(235),
      fullScreen: _MDLocalString["default"].getLocalString(236),
      hideComment: _MDLocalString["default"].getLocalString(237),
      download: _MDLocalString["default"].getLocalString(29),
      verInfo: _MDLocalString["default"].getLocalString(110),
      shareFile: _MDLocalString["default"].getLocalString(240),
      editFile: _MDLocalString["default"].getLocalString(238),
      salon: _MDLocalString["default"].getLocalString(239),
      print: _MDLocalString["default"].getLocalString(730),
      compare: _MDLocalString["default"].getLocalString(746),
      menusvg: _menusvg["default"]
    };
    _MMViewBase["default"].prototype.render.call(this, data);
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    var self = this;
    this.fullscreenEvtFun = function (e) {
      self._fullScreenChanged(e);
    };
    document.addEventListener("webkitfullscreenchange", this.fullscreenEvtFun, false);
    document.addEventListener("mozfullscreenchange", this.fullscreenEvtFun, false);
    document.addEventListener("fullscreenchange", this.fullscreenEvtFun, false);
    document.addEventListener("MSFullscreenChange", this.fullscreenEvtFun, false);
    return _.extend(superE, {
      "click #fullButton": this._fullScreen,
      "click #hideToolbarButton": this._hideToolbar,
      "click #showToolbarButton": this._showToolbar,
      "click #commentButton": this._commentToolClicked,
      "click #addTagButton": this._tagClicked,
      "click #moveButton": this._moveClicked,
      // "click .p-tool-preFile": this._preFileClicked,
      // "click .p-tool-nextFile": this._nextFileClicked,
      "click .p-tool-versions": this._versionsClicked,
      "click .p-tool-ai": this.aiClicked,
      "click .p-tool-ocr": this.ocrClicked,
      "click .e-close-btn": this._closeClicked,
      "mousedown #zoomBtn": this._zoomClicked,
      "click .p-tool-fileName": this._fileNaviClicked,
      "click .p-tool-commentList": this._fileCommentsListClicked,
      "click .p-tool-visible": this._commentVisibleClicked,
      "click .p-tool-download": this._downloadClicked,
      "click .p-tool-rotate": this._rotateClicked,
      "click .p-tool-textComment": this._textCommentClicked,
      "click .p-tool-search": this._textSearchClicked,
      "click #editButton": this._editClicked,
      "click #onlineEditButton": this._onlineEditClicked,
      "click #shareButton": this._shareButtonClicked,
      "click #salonButton": this._salonClicked,
      "click #printButton": this._printClicked,
      "click #compareButton": this._spliteView,
      "click #dir": this._toogleDir,
      "click #tagButton": this._addTag,
      "click .p-tool-link": this._openlink,
      "click .p-tool-word": this.saveWord
    });
  },
  _toogleDir: function _toogleDir() {},
  removeFromSuperView: function removeFromSuperView() {
    var superE = _MMViewBase["default"].prototype.removeFromSuperView.call(this);
    document.removeEventListener("webkitfullscreenchange", this.fullscreenEvtFun);
    document.removeEventListener("mozfullscreenchange", this.fullscreenEvtFun);
    document.removeEventListener("fullscreenchange", this.fullscreenEvtFun);
    document.removeEventListener("MSFullscreenChange", this.fullscreenEvtFun);
    if (this.$fileChanger) {
      this.$fileChanger.find(".p-tool-preFile").off();
      this.$fileChanger.find(".p-tool-nextFile").off();
      this.$fileChanger.find(".filechanger").off();
      this.$fileChanger.remove();
    }
    if (this.salonPanel) {
      this.salonPanel.remove();
    }
    if (this.editorViewCtl) {
      var editorRoot = this.editorViewCtl.getEditorRootDiv();
      $(editorRoot).off("mousemove.filechange");
    }
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      editor: null,
      zoomList: null,
      curTool: "",
      enableRouterNavigation: true,
      fileVersionRouterCb: _.noop
    });
  },
  initialize: function initialize(opt) {
    var _this = this;
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    _Dispatcher["default"].on(_MDEvents["default"].ZOOM_CHANGED, this._zoomChanged, this);
    _Dispatcher["default"].on(_MDEvents["default"].SHOW_COMMENTS, this.showComments, this);
    _Dispatcher["default"].on(_MDEvents["default"].FileChanged, this.updatePgInfo, this);
    _Dispatcher["default"].on(_MDEvents["default"].COMMENT_CLICKED, this._commentClicked, this);
    _Dispatcher["default"].on(_MDEvents["default"].NULL_OPERATION, this._clearTool, this);
    _Dispatcher["default"].on(_MDEvents["default"].Department_removeMem, this._depMemRemoved, this);
    _Dispatcher["default"].on(_MDEvents["default"].Department_removed, this._depRemoved, this);
    _Dispatcher["default"].on(_MDEvents["default"].Department_update, this._depUpdated, this);
    _Dispatcher["default"].on(_MDEvents["default"].Department_updateMem, this._depMemUpdated, this);
    _Dispatcher["default"].on(_MDEvents["default"].ShareClosed_board, this._shareClosedCurrent, this);
    _Dispatcher["default"].on(_MDEvents["default"].RefreshZoomDisp, this._setZoom, this);
    _Dispatcher["default"].on(_MDEvents["default"].CloseLink, this._shareClosedCurrent, this);
    _Dispatcher["default"].on(_MDEvents["default"].SharePermissionChanged, this._premissionChanged, this);
    _Dispatcher["default"].on(_MDEvents["default"].SALON_MESSAGE, this.salonMsgManage, this);
    _Dispatcher["default"].on(_MDEvents["default"].mailMouseMove, this.showFileChanger, this);
    _Dispatcher["default"].on(_MDEvents["default"].Mouse_over_toolbar, this.mouseOverToolbar, this);
    _Dispatcher["default"].on(_MDEvents["default"].fileHasText, this._onFileHasText, this);
    _Dispatcher["default"].on(_MDEvents["default"].SharePermissionChangedNew, this.permissionChangedNew, this);
    _Dispatcher["default"].on(_MDEvents["default"].closeFileOcrPanel, this._closeOcrPanel, this);
    _Dispatcher["default"].on(_MDEvents["default"].closeFileAIPanel, this._closeAiPanel, this);
    _Dispatcher["default"].on(_MDEvents["default"].CloseEdit, this._closeClicked, this);
    _MMOperationCenter["default"].clearOperation();
    _MMObjOperationStrategy["default"].setCommentHidden(false);
    this.$(".p-tool-fileChanger").hide();
    this._enableShortCut();
    this.listenToOnlineEvent();
    this.$el.find("#zoomBtn").parent().css("width", "90px");
    this.$el.find(".edit-tool").css("display", "none");

    // this.commentToolbar = new MDCommentToolbar();
    // this.$el.append(this.commentToolbar.$el);

    var self = this;
    this.printView = new _MMPrintServiveView["default"]();
    if (_app["default"].isShareApp) {
      this.$el.find("#compareButton").parent().remove();
    }
    this.$(".p-tool-search").parent().hide();
    this.$(".p-tool-rotate").parent().hide();
    this.typeConditionArr = [{
      type: "utf-8",
      name: "utf-8"
    }, {
      type: "utf-16",
      name: "utf-16"
    }, {
      type: "gbk",
      name: "gbk"
    }, {
      type: "utf-16be",
      name: "utf-16be"
    }, {
      type: "utf-16le",
      name: "utf-16le"
    }];
    this.encodingSelect = new _MDDropdownSelectListView["default"]({
      dataProvider: this.typeConditionArr,
      labelField: "name",
      isFixed: true,
      gapY: 1,
      onChange: function onChange(obj) {
        var curEditor = _this.editorViewCtl.getCurEditor();
        var data = curEditor.getOriginData();
        curEditor.encodeToType(data, obj.type);
        if (_this.editorViewCtl) {
          var fileInfo = _this.editorViewCtl.getCurrentFileInfo();
          localStorage.setItem("encodtype" + fileInfo.getFileId(), obj.type);
        }
      }
    });
    this.$el.find(".encode-block").append(this.encodingSelect.$el);
  },
  _addTag: function _addTag() {
    var fileInfo = this.editorViewCtl.getCurrentFileInfo();
    var addTagWin = new _MDAddTagBigWindow["default"]({
      fileInfos: [fileInfo]
    });
    addTagWin.show();
  },
  _initFileChanger: function _initFileChanger() {
    var boards = this.editorViewCtl.getAllBoards();
    if (boards.length == 1) {
      return;
    } else {}
    if (this.$fileChanger) {
      this.$fileChanger.find(".p-tool-preFile").off();
      this.$fileChanger.find(".p-tool-nextFile").off();
      this.$fileChanger.remove();
    }
    var preStr = _MDLocalString["default"].getLocalString(2009);
    var nextStr = _MDLocalString["default"].getLocalString(2012);
    var navStr = _MDLocalString["default"].getLocalString(2010);
    var param = {
      fileNo: '<b id="fileNo" class="top">0</b>',
      fileCount: '<b id="fileCount" class="top">0</b>'
    };
    var fileIndexStr = _MDLocalString["default"].getLocalString(2011, param);
    this.$fileChanger = $('<div class="p-tool-fileChanger top">' + '<button class="button-com filechanger p-tool-preFile  button-icon " data-tooltip="' + preStr + '"></button>' + '<div class="p-tool-filesNavi " title="' + navStr + '">' + "<div>" + fileIndexStr + "</div>" + "</div>" + '<button class="button-com filechanger p-tool-nextFile button-icon " data-tooltip="' + nextStr + '"></button> \
        </div> ');
    $(this.editorViewCtl.containerDiv).append(this.$fileChanger);
    var self = this;
    this.$fileChanger.find(".p-tool-preFile").on("click", function (e) {
      self._preFileClicked(e);
    });
    this.$fileChanger.find(".p-tool-nextFile").on("click", function (e) {
      self._nextFileClicked(e);
    });
    this.$fileChanger.find(".filechanger").on("mouseenter", function (e) {
      self._mouseOverChanger = true;
      self.showFileChanger();
    });
    this.$fileChanger.find(".filechanger").on("mouseleave", function (e) {
      self._mouseOverChanger = false;
      self.showFileChanger();
    });
    var editorRoot = this.editorViewCtl.getEditorRootDiv();
    setBabelTimeout(function () {
      $(editorRoot).on("mousemove.filechange", function (e) {
        // console.log("----------------- mouse moving!");
        self.showFileChanger();
      });
      self.showFileChanger();
    }, 2000);
  },
  _enableShortCut: function _enableShortCut() {
    $("body").on("keydown.editor-keydown", function (event) {
      // 在其他输入框中，则不响应
      if (document.activeElement != document.body) {
        return;
      }
      if (!event.ctrlKey && !event.metaKey) {
        return;
      }
      if (event.keyCode == 37 || event.keyCode == 38) {
        $(".p-tool-preFile").click();
        return false;
      } else if (event.keyCode == 39 || event.keyCode == 40) {
        $(".p-tool-nextFile").click();
        return false;
      }
    });
    document.body.focus();
  },
  listenToOnlineEvent: function listenToOnlineEvent() {
    var onlineEventHandler = new _MDOnlineEventHandler["default"]();
    this.isOnline = onlineEventHandler.isOnline();
    this.listenTo(onlineEventHandler, _OnlineEvent["default"].OnlineStateChange, this._onlineEventHandler);
  },
  _onlineEditClicked: function _onlineEditClicked() {
    var fileInfo = this.editorViewCtl.getCurrentFileInfo();
    var self = this;
    if (fileInfo) {
      var actionCtl = new _MDFileActionController["default"]();
      actionCtl.setFileInfors([fileInfo]);
      actionCtl.onlineEditFile(this.editorViewCtl.getVersionShowing(), function () {
        // console.log('--------> edit office finished!');
        // Dispatcher.trigger(MDEvents.OpenFile, {
        //     fileId: fileInfo.getFileId(),
        //     version: -1,
        //   });
        // })
        // fileInfo.setCurrentVersion('-1')
        // let curEditor = self.editorViewCtl.getCurEditor()
        // curEditor.openFile(fileInfo, fileInfo.getCurVersion())
        //
        self.editorViewCtl.changeVersion(fileInfo.getCurVersion());
      });
    }
  },
  _openlink: function _openlink() {
    var fileInfo = this.editorViewCtl.getCurrentFileInfo();
    if (fileInfo) {
      var actionCtl = new _MDFileActionController["default"]();
      actionCtl.setFileInfors([fileInfo]);
      actionCtl.openLink();
    }
  },
  saveWord: function saveWord($e) {
    var _this2 = this;
    if (this.wordsaveing) {
      return;
    }
    this.wordsaveing = true;
    var timeout = setTimeout(function () {
      _this2.wordsaveing = false;
    }, 2000);
    var curEditor = this.editorViewCtl.getCurEditor();
    if (!curEditor) {
      console.log("怎么没导出内容");
      return;
    }
    var $resultElement = curEditor.$content;
    // let content = $item.data("text")
    if (!$resultElement) {
      console.error("导出怎么没内容了");
      return;
    }
    var name = "";
    var fileInfo = this.editorViewCtl.getCurrentFileInfo();
    if (fileInfo) {
      name = fileInfo.getFileNameWithoutExt();
    }
    (0, _exportWord["default"])($resultElement[0], name);
  },
  _editClicked: function _editClicked() {
    var fileInfo = this.editorViewCtl.getCurrentFileInfo();
    if (fileInfo) {
      if (fileInfo.isOfficeFile() || _app["default"].isInClient()) {
        var actionCtl = new _MDFileActionController["default"]();
        actionCtl.setFileInfors([fileInfo]);
        actionCtl.editFile(this.editorViewCtl.getVersionShowing(), function () {
          console.log("--------> edit office finished!");
        });
      } else {
        this.removeVersionList();
        var self = this;
        var ver = this.editorViewCtl.getVersionShowing();
        _MDTextEditorController["default"].initEditorWithFileInfo(fileInfo, ver, function () {
          self.refreshVersionMark(fileInfo.get("versionList").length);
          self.editorViewCtl.changeVersion(fileInfo.getCurVersion());
        });
      }
    }
  },
  _onlineEventHandler: function _onlineEventHandler(isOnline) {
    if (isOnline) {
      this.$(".p-tool-textComment").prop("disabled", false);
      this.$(".p-tool-comment").prop("disabled", false);
      this.$(".p-tool-nicetag").prop("disabled", false);
    } else {
      this.$(".p-tool-textComment").prop("disabled", true);
      this.$(".p-tool-comment").prop("disabled", true);
      this.$(".p-tool-nicetag ").prop("disabled", true);
    }
  },
  _depRemoved: function _depRemoved(msg) {
    var department = msg["department"];
    var depFolderId = department["folderId"];
    var fileInfo = this.editorViewCtl.getCurrentFileInfo();
    var path = fileInfo.get("path");
    var fileIds = path.split("/");
    var index = _.findIndex(fileIds, function (id) {
      return id == depFolderId;
    });
    var promptStr = _MDLocalString["default"].getLocalString(169);
    if (index != -1) {
      var alertOpt = {
        message: promptStr,
        okFun: function okFun() {
          $(".e-close-btn").click();
        }
      };
      _MDAlertView["default"].showStandardPrompt(alertOpt);
    }
  },
  _depMemUpdated: function _depMemUpdated(msg) {
    var department = msg["department"];
    var depFolderId = department["folderId"];
    var diff = msg.get("diff");
    var fileInfo = this.editorViewCtl.getCurrentFileInfo();
    var path = fileInfo.get("path");
    var fileIds = path.split("/");
    var index = _.findIndex(fileIds, function (id) {
      return id == depFolderId;
    });
    if (index != -1) {
      var alert = new _MDAlertView["default"]();
      _MMNetDiskDataController["default"].getFileInfoFromServer(fileInfo.getFileId(), function (newFileInfo) {
        var permission = newFileInfo.get("permission");
        var actions = newFileInfo.get("actions");
        self.editorViewCtl.getCurrentFileInfo().set("permission", permission);
        self.editorViewCtl.getCurrentFileInfo().set("actions", actions);
        _Dispatcher["default"].trigger(_MDEvents["default"].commentsPerChanged);
        var diffStr = "";
        for (var i = 0; i < diff.length; i++) {
          var d = diff[i];
          if (d.key == "roleName") {
            diffStr = d.value;
          }
        }
        var param = {
          depName: "",
          role: '<em class="tooltips">' + diffStr + "</em>"
        };
        var promptStr = _MDLocalString["default"].getLocalString(2000, param);
        var str2 = _MDLocalString["default"].getLocalString(241);
        promptStr = promptStr + "<br>" + str2;
        var alertOpt = {
          message: promptStr,
          okFun: function okFun() {
            self._checkPermission();
          }
        };
        _MDAlertView["default"].showStandardPrompt(alertOpt);
      }, function () {
        return;
      });
    }
  },
  _depUpdated: function _depUpdated(msg) {
    var department = msg["department"];
    var depFolderId = department["folderId"];
    var changedAttr = msg["options"];
    var changedParentFolderId = changedAttr["parentFolderId"];
    if (changedParentFolderId) {
      var fileInfo = this.editorViewCtl.getCurrentFileInfo();
      var path = fileInfo.get("path");
      var fileIds = path.split("/");
      var index = _.findIndex(fileIds, function (id) {
        return id == depFolderId;
      });
      var promptStr = _MDLocalString["default"].getLocalString(2001);
      if (index != -1) {
        var alertOpt = {
          message: promptStr,
          okFun: function okFun() {
            $(".e-close-btn").click();
          }
        };
        _MDAlertView["default"].showStandardPrompt(alertOpt);
      }
    }
  },
  _depMemRemoved: function _depMemRemoved(msg) {
    var members = msg["members"];
    var department = msg["department"];
    var depFolderId = department["folderId"];
    var fileInfo = this.editorViewCtl.getCurrentFileInfo();
    var path = fileInfo.get("path");
    var fileIds = path.split("/");
    var curUid = _app["default"].currentUser.getUserId();
    for (var i = 0; i < members.length; i++) {
      var mem = members[i];
      if (mem.user.id == curUid) {
        var index = _.findIndex(fileIds, function (id) {
          return id == depFolderId;
        });
        var promptStr = _MDLocalString["default"].getLocalString(169);
        if (index != -1) {
          var alertOpt = {
            message: promptStr,
            okFun: function okFun() {
              $(".e-close-btn").click();
            }
          };
          _MDAlertView["default"].showStandardPrompt(alertOpt);
          break;
        }
      }
    }
  },
  _shareClosedCurrent: function _shareClosedCurrent(data) {
    var fileId = this.editorViewCtl.getCurrentFileInfo().getFileId();
    var shareId = data["fileId"] || data;
    var version = data["version"];
    if (typeof version != "undefined") {
      if (version != this.editorViewCtl.m_board.versionShowing) {
        return;
      }
    }
    var showAlert = function showAlert() {
      var promptStr = _MDLocalString["default"].getLocalString(169);
      var alertOpt = {
        message: promptStr,
        width: 470,
        okFun: function okFun() {
          $(".e-close-btn").click();
        }
      };
      _MDAlertView["default"].showStandardPrompt(alertOpt);
    };
    if ((0, _typeof2["default"])(shareId) == "object") {
      if ($.inArray(fileId, shareId) > -1) {
        showAlert();
      }
    } else if (fileId == shareId) {
      showAlert();
    }
  },
  _premissionChanged: function _premissionChanged(shareId) {
    var self = this;
    var text = "";
    var fileId = this.editorViewCtl.getCurrentFileInfo().getFileId();
    var fileInfo = this.editorViewCtl.getCurrentFileInfo();
    var path = fileInfo.get("path");
    var fileIds = path.split("/");
    var index = _.findIndex(fileIds, function (id) {
      return id == shareId;
    });
    if (index == -1) {
      return;
    }
    var alert = new _MDAlertView["default"]();
    _Dispatcher["default"].trigger(_MDEvents["default"].beforeChangeToNextFile);
    _MMNetDiskDataController["default"].getFileInfoFromServer(fileId, function (newFileInfo) {
      var permission = newFileInfo.get("permission");
      var actions = newFileInfo.get("actions");
      self.editorViewCtl.getCurrentFileInfo().set("permission", permission);
      self.editorViewCtl.getCurrentFileInfo().set("actions", actions);
      _Dispatcher["default"].trigger(_MDEvents["default"].afterChangeToNextFile);

      // self.fileInfoChanged();
      var other = false;
      _Dispatcher["default"].trigger(_MDEvents["default"].commentsPerChanged);
      switch (permission) {
        case 0:
          text = _MDLocalString["default"].getLocalString(2003); // 默认权限
          break;
        case 1:
          text = _MDLocalString["default"].getLocalString(2004); // "查看文件";
          break;
        case 5:
          text = _MDLocalString["default"].getLocalString(2005) + "," + _MDLocalString["default"].getLocalString(29); // "查看、下载";
          break;
        case 33:
          text = _MDLocalString["default"].getLocalString(2005) + "," + _MDLocalString["default"].getLocalString(42); //"查看、批注";
          break;
        case 37:
          text = _MDLocalString["default"].getLocalString(128) + "," + _MDLocalString["default"].getLocalString(29); //"评论、下载";
          break;
        case 63:
          text = _MDLocalString["default"].getLocalString(128) + "," + _MDLocalString["default"].getLocalString(2006); //"评论、上传";
          break;
        default:
          other = true;
      }
      var promptStr = "";
      if (!other) {
        var param = {
          role: '<em class="tooltips">' + text + "</em>"
        };
        promptStr = _MDLocalString["default"].getLocalString(2002, param);
        var str2 = _MDLocalString["default"].getLocalString(241);
        promptStr = promptStr + "<br>" + str2;
      } else {
        promptStr = BabelStr.str(2042);
      }
      var alertOpt = {
        message: promptStr,
        okFun: function okFun() {
          self._checkPermission();
        }
      };
      _MDAlertView["default"].showStandardPrompt(alertOpt);
    }, function (code) {
      if (code == _ErrorCode["default"].ACCESS_DENIED) {
        var msg = '<p class="title">' + _MDLocalString["default"].getLocalString(4509) + "</p>";
        var option = {
          okFun: function okFun() {
            self._closeClicked();
            // this.alertShowing = false;
          },
          message: msg
        };
        _MDAlertView["default"].showStandardPrompt(option);
        // this.alertShowing = true;
      }
      return;
    });
  },
  permissionChangedNew: function permissionChangedNew(opt) {
    var fileId = opt.fileId;
    this._premissionChanged(fileId);
  },
  setEditorViewCtl: function setEditorViewCtl(editorViewCtl) {
    this.$(".p-tool-search").parent().hide();
    this.editorViewCtl = editorViewCtl;
    this.updatePgInfo();
    this._initFileChanger();
  },
  _onFileHasText: function _onFileHasText(editorViewCtl) {
    if (this.editorViewCtl && editorViewCtl && this.editorViewCtl.getCurrentBoard() == editorViewCtl.getCurrentBoard()) {
      this.$(".p-tool-search").parent().show();
    } else {
      this.$(".p-tool-search").parent().hide();
    }
  },
  clearEditTool: function clearEditTool() {
    if (this.curTool != "") {
      this.curTool = "";
      this.$(".edit-tool").find("li").removeClass("li-focus");
    }
    if (this.editorViewCtl) {
      this.editorViewCtl.setCurOperation();
    }
    $(".toolPrompt").remove();
  },
  setToolFocus: function setToolFocus(id) {
    this.$("#" + id).parent().addClass("li-focus");
  },
  clearToolFocus: function clearToolFocus(id) {
    this.$("#" + id).parent().removeClass("li-focus");
  },
  updatePgInfo: function updatePgInfo() {
    var _this3 = this;
    this.$(".salon-opening").hide();
    this.salonInfo = null;
    var curEditor = this.editorViewCtl.getCurEditor();
    if (curEditor && curEditor.hasText && curEditor.hasText()) {
      this.$(".p-tool-search").parent().show();
    } else {
      this.$(".p-tool-search").parent().hide();
    }
    this.$(".p-tool-rotate").parent().hide();
    this.$el.find(".edit-tool").css("display", "block");
    if (!this.editorViewCtl || !this.superView) {
      return;
    }
    var fileInfo = this.editorViewCtl.getCurrentFileInfo();
    if (!fileInfo) {
      return;
    }
    var fileCount = this.editorViewCtl.getFileCount();
    var curPg = this.editorViewCtl.getCurrentFileIndex();
    this.displayPageInfo(curPg, fileCount, fileInfo.getFileName());
    var board = this.editorViewCtl.getCurrentBoard();
    if (!board) {
      return;
    }
    if (!fileInfo.dispNeedWhiteBoard() || board.isCADFile() || fileInfo.canDispInWebBrowser()) {
      this.showZoomList(false);
    } else if (!fileInfo.canDispInOpenGL() && board && board.getPageCount() > 1) {
      this.superView.showBottomToolBar();
      this.showZoomList(true);
    } else {
      if (fileInfo.canDispInOpenGL()) {
        this.showZoomList(false);
      } else {
        this.showZoomList(true);
      }
      if (viewManager.get("pdfBottomBtn")) {
        viewManager.get("pdfBottomBtn").$el.hide();
      }
    }
    this.superView.refreshCommentsNavigator();
    this.superView.displayFileInfo();
    this.clearEditTool();
    if (!fileInfo.canDispInOpenGL() && !fileInfo.canDispInWebBrowser()) {
      this._zoomChanged();
    } else {}
    if (fileInfo.canUseAIFinal()) {
      this.$(".tool-ai").removeClass("f-hide");
    } else {
      this.$(".tool-ai").addClass("f-hide");
    }
    if (fileInfo.canUseOCRFinal()) {
      this.$(".tool-ocr").removeClass("f-hide");
    } else {
      this.$(".tool-ocr").addClass("f-hide");
    }
    this._updateSalonInfo();
    if (this.salonPanel) {
      this.salonPanel._closeHandler();
    }

    // if (curEditor) {

    //   var editorType = curEditor.getClassName();
    //   if (editorType == "MDPCSinglePagePdfView" || editorType == "MMPCImageEditor") {
    //     this.$('.p-tool-rotate').parent().show();
    //   } else {
    //     this.$('.p-tool-rotate').parent().hide();

    //   }
    // }

    var version = this.editorViewCtl.getVersionShowing();
    fileInfo.canCreateCommentForVersion(version, function (can, isEval) {
      if (isEval) {
        _this3.$(".btn-commentList").attr("data-tooltip", BabelStr.str(6045));
      } else {
        _this3.$(".btn-commentList").attr("data-tooltip", _MDLocalString["default"].getLocalString(235));
      }
    });
  },
  listenfileInfoAttr: function listenfileInfoAttr(fileInfo) {
    this.stopListening(fileInfo);
    this.listenTo(fileInfo, "change", this._fileInfoAttrChangedHandle);
  },
  _fileInfoAttrChangedHandle: function _fileInfoAttrChangedHandle(model, options) {
    if (model.hasChanged("currentVersionEvaluation")) {
      this.renderEvaluationStatus(model);
    }
    if (model.hasChanged("fileCommentCount")) {
      this.renderfileCommentCount(model);
    }
  },
  renderfileCommentCount: function renderfileCommentCount(model) {
    var $readStatus = this.$(".readStatus");
    if (model.get("fileCommentCount") > 0 && model.canReadComment()) {
      // if(!this.$('.p-tool-commentList').hasClass('selected')) {
      $readStatus.css("opacity", 1);
      this.openCommentPanel();
      // }
    } else {
      $readStatus.css("opacity", 0);
    }
  },
  renderEvaluationStatus: function renderEvaluationStatus(fileInfo) {
    var self = this;
    var evalInfoStrHtml = fileInfo.createEvalStrHtml();
    if (evalInfoStrHtml.length) {
      this.$(".p-tool-eva").html(evalInfoStrHtml);
      this.$(".eval-btn").on("click", function () {
        _Dispatcher["default"].trigger(_MDEvents["default"].OpenEvalListPanel, {
          editorViewCtl: self.editorViewCtl
        });
      });
    } else {
      this.$(".p-tool-eva").empty();
    }
  },
  displayPageInfo: function displayPageInfo(curPg, fileCount, fileName, version) {
    var self = this;
    var fileInfo = null;
    this.$(".p-tool-fileName").text(fileName);
    this.$(".p-tool-search").parent().hide();
    if (this.$fileChanger) {
      this.$fileChanger.find(".p-tool-filesNavi").show();
      this.$fileChanger.find("#fileNo").text(curPg + 1);
      this.$fileChanger.find("#fileCount").text(fileCount);
      if (this.timerNavi) {
        clearTimeout(this.timerNavi);
      }
      this.timerNavi = setBabelTimeout(function () {
        self.$fileChanger.find(".p-tool-filesNavi").hide();
        self.timerNavi = null;
      }, 3000);
      if (fileCount > 1) {
        this.$fileChanger.show();
      } else {
        this.$fileChanger.hide();
      }
    }
    this._checkPermission();
    fileInfo = this.editorViewCtl.getCurrentFileInfo();
    this.listenfileInfoAttr(fileInfo);
    if (fileInfo.isShortcuts()) {
      fileInfo = fileInfo.getShortCutsTargetFile();
      if (!fileInfo) {
        return;
      }
    }
    if (fileInfo.hasVersionList()) {
      self.refreshVersionMark(fileInfo.get("versionList").length);
    } else {
      _MMNetDiskDataController["default"].getFileVersionsByFileInfo(fileInfo, function success(versionInfos) {
        self.refreshVersionMark(versionInfos.length);
      }, function failed() {
        console.error("----- get version error");
      });
    }
    // 是否显示文字批注工具
    if (this.fileNavi) {
      this.fileNavi.scrollToShowCurPageThumbnail();
    }
    if (this.verListPanel) {
      this.verListPanel.setDisplayVer(version);
    }
    this.superView.refreshEvaluationPanelWithCurFile();
    this.$(".eval-span").remove();
    this.renderEvaluationStatus(fileInfo);
    var board = this.editorViewCtl.getCurrentBoard();
    if (board) {
      var fileInfo = board.getFileInfo();
      var $readStatus = this.$(".readStatus");
      if (fileInfo.get("fileCommentCount") > 0) {
        $readStatus.css("opacity", 1);
        this.openCommentPanel();
      } else {
        $readStatus.css("opacity", 0);
      }
    }
  },
  _checkPermission: function _checkPermission() {
    if (this.editorViewCtl) {
      var fileInfo = this.editorViewCtl.getCurrentFileInfo();
      if (fileInfo.isShortcuts()) {
        fileInfo = fileInfo.getShortCutsTargetFile();
        if (!fileInfo) {
          return;
        }
      }
      if (fileInfo.isExel()) {
        $("body").addClass("simple-editor");
      } else {
        var simpleEditor = localStorage.getItem("simpleEditor");
        if (simpleEditor) {
          $("body").addClass("simple-editor");
        } else {
          $("body").removeClass("simple-editor");
        }
      }
      var fileName = fileInfo.getFileName();
      var ext = fileInfo.getFileExtension().toLowerCase();
      var type = localStorage.getItem("encodtype" + fileInfo.getFileId());
      var selectedIndex = 0;
      if (type) {
        selectedIndex = _.findIndex(this.typeConditionArr, function (item) {
          return item.name == type;
        });
      }
      if (ext == "svg" || ext == "txt") {
        this.$(".encode-block").removeClass("f-hide");
        this.encodingSelect.selectItemAt(selectedIndex, true);
      } else {
        this.$(".encode-block").addClass("f-hide");
      }
      if (!fileInfo.canSalon()) {
        this.$("#salonButton").parent().hide();
      } else {
        this.$("#salonButton").parent().show();
      }
      this.$("#salonButton").parent().hide(); // 暂时隐藏
      if (_app["default"].isInClient()) {
        this.$("#fullButton").parent().hide();
      } else {
        this.$("#fullButton").parent().show();
      }
      if (fileInfo) {
        var curFileId = fileInfo.get("fileId");
        if (fileInfo.canDownload()) {
          this.$("#download").parent().show();
        } else {
          this.$("#download").parent().hide();
        }
        if (fileInfo.canPrint() && !fileInfo.isOnlyDisp()) {
          this.$("#printButton").parent().show();
        } else {
          this.$("#printButton").parent().hide();
        }
        if (this.canShowEditBtn(fileInfo)) {
          this.$("#editButton").parent().show();
        } else {
          this.$("#editButton").parent().hide();
        }
        if (this.canShowOnlineEditBtn(fileInfo)) {
          this.$("#onlineEditButton").parent().show();
        } else {
          this.$("#onlineEditButton").parent().hide();
        }
        if (fileInfo.canListVersion()) {
          this.$("#version-btn").parent().show();
        } else {
          this.$("#version-btn").parent().show();
        }
        if (fileInfo.canAddTag()) {
          this.$(".p-tool-tag").parent().show();
        } else {
          this.$(".p-tool-tag").parent().hide();
        }
        if (fileInfo.getLinkFileUrl()) {
          this.$(".p-tool-link").parent().show();
        } else {
          this.$(".p-tool-link").parent().hide();
        }
        if (fileInfo.isMDFile() && fileInfo.canDownload()) {
          this.$(".p-tool-word").parent().show();
        } else {
          this.$(".p-tool-word").parent().hide();
        }
        if (fileInfo.canReadComment() && !fileInfo.dispWithSVG()) {
          // app.currentUser.logined() && this.$("#salonButton").parent().show();
          if (window.innerWidth > 1094) {
            this.$(".p-tool-commentList").show();
          }
        } else {
          if (window.innerWidth > 1094) {
            this.$(".p-tool-commentList").hide();
          }
          this.superView && this.superView.toggleCommentsNavigator(true);
          this.$("#salonButton").parent().hide();
          if (!fileInfo.dispNeedWhiteBoard() || fileInfo.dispWithSVG()) {
            this.$(".p-tool-commentList").hide();
            this.superView && this.superView.hideCommentsNavigator();
          }
        }
        if (fileInfo.canCreateComment() && !fileInfo.isOnlyDisp()) {
          this.$("#visibility").parent().show();
          this.$("#commentButton").parent().show();
          this.$("#helpButton").parent().show();
          if (fileInfo.canDispInOpenGL()) {
            this.$("#commentButton").parent().hide();
            this.$("#helpButton").parent().hide();
          }
          this.$("#textCommentButton").parent().show();
          if (_MMCommonFun["default"].isImageName(fileName) || fileInfo.canDispInOpenGL() || fileInfo.canDispInWebBrowser()) {
            this.$("#textCommentButton").parent().hide();
          }
          this.$("#addTagButton").parent().show();
          if (fileInfo.canDispInOpenGL() || fileInfo.canDispInWebBrowser()) {
            this.$("#addTagButton").parent().hide();
          }
        } else {
          this.$("#visibility").parent().hide();
          this.$("#commentButton").parent().hide();
          this.$("#helpButton").parent().hide();
          this.$("#textCommentButton").parent().hide();
          this.$("#addTagButton").parent().hide();
          //this.superView.hideCommentsNavigator();
          var $btn = this.$(".p-tool-commentList");
          $btn.removeClass("selected");
        }
      }
      if (_MMCommonFun["default"].hasGodEye()) {
        this.$("#commentButton").parent().hide();
        this.$("#helpButton").parent().hide();
        this.$("#textCommentButton").parent().hide();
        this.$("#addTagButton").parent().hide();
      }
      if (_app["default"].pathRouter.inTrash()) {
        this.$("#shareButton").parent().hide();
        this.$("#salonButton").parent().hide();
        this.$("#commentButton").parent().hide();
        this.$("#textCommentButton").parent().hide();
        this.$("#addTagButton").parent().hide();
      } else {
        if (fileInfo.canShare()) {
          this.$("#shareButton").parent().show();
        } else {
          this.$("#shareButton").parent().hide();
        }
      }
      var curEditor = this.editorViewCtl.getCurEditor();
      if (curEditor) {
        var editorType = curEditor.getClassName();
        if (editorType == "MDPCSinglePagePdfView" || editorType == "MMPCImageEditor" || editorType == "MMPDFCollectionView" && !fileInfo.isOnlyDisp()) {
          this.$(".p-tool-rotate").parent().show();
        } else {
          this.$(".p-tool-rotate").parent().hide();
        }
      }
    }
    this.$(".btn-commentList").attr("data-tooltip", BabelStr.str(235));
  },
  showToggleBtn: function showToggleBtn() {
    this.$(".p-tool-commentList").show();
    this.$(".btn-commentList").attr("data-tooltip", BabelStr.str(2400));
  },
  canShowEditBtn: function canShowEditBtn(fileInfor) {
    var actionCtl = new _MDFileActionController["default"]();
    actionCtl.setFileInfors([fileInfor]);
    return actionCtl.canShowEditBtn();
  },
  canShowOnlineEditBtn: function canShowOnlineEditBtn(fileInfor) {
    var actionCtl = new _MDFileActionController["default"]();
    actionCtl.setFileInfors([fileInfor]);
    return actionCtl.canShowOnlineEditBtn();
  },
  refreshVersionMark: function refreshVersionMark(versionCount) {
    var self = this;
    if (versionCount > 1) {
      self.$("#version-btn").addClass("hasMultiVer");
    } else {
      self.$("#version-btn").removeClass("hasMultiVer");
    }
  },
  hidePageInfo: function hidePageInfo() {
    this.$(".p-tool-fileChanger").css("display", "none");
  },
  _hideToolbar: function _hideToolbar() {
    var _this4 = this;
    $("body").addClass("simple-editor");
    var fileInfo = this.editorViewCtl.getCurrentFileInfo();
    if (!fileInfo.isExel()) {
      localStorage.setItem("simpleEditor", true);
    }
    setTimeout(function () {
      _this4.editorViewCtl.refreshSize();
    }, 200);
  },
  _showToolbar: function _showToolbar() {
    var _this5 = this;
    $("body").removeClass("simple-editor");
    var fileInfo = this.editorViewCtl.getCurrentFileInfo();
    if (!fileInfo.isExel()) {
      localStorage.removeItem("simpleEditor");
    }
    setTimeout(function () {
      _this5.editorViewCtl.refreshSize();
    }, 200);
  },
  _fullScreen: function _fullScreen() {
    this.removeAllTopPanel();

    // if already full screen; exit
    // else go fullscreen
    if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
      var exit = false;
      if (document.exitFullscreen) {
        exit = true;
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        exit = true;
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        exit = true;
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        exit = true;
        document.msExitFullscreen();
      }
    } else {
      this.fullscreen = false;
      $("html").width("100%"); // IE11下显示半屏
      var element = $("html").get(0);
      if (element.requestFullscreen) {
        this.fullscreen = true;
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        this.fullscreen = true;
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        this.fullscreen = true;
        element.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      } else if (element.msRequestFullscreen) {
        this.fullscreen = true;
        element.msRequestFullscreen();
      }
    }
    this.superView.refreshEvaluationPanelWithCurFile();
  },
  _requestFullscreen: function _requestFullscreen() {},
  _fullScreenChanged: function _fullScreenChanged(e) {
    if (this.fullscreen) {
      this.fullscreen = false;
      $(".p-editor-toolbar").css("display", "none");
      $(".editor-content-panel").css("top", "0px");
      this.superView.hideCommentsNavigator();
      var $btn = this.$(".p-tool-commentList");
      $btn.removeClass("selected");
    } else {
      $(".p-editor-toolbar").css("display", "block");
      $(".editor-content-panel").css("top", this.$el.height() + "px");
      $("html").width("auto");
    }
  },
  _shareButtonClicked: function _shareButtonClicked() {
    // var logined = app.currentUser.logined();
    // if (!logined) {
    //   app.popupInnerLogin();
    //   return;
    // }
    var wind = new _MDShareFileWindowView["default"]({
      fileInfor: this.editorViewCtl.getCurrentFileInfo()
    });
    wind.show();
  },
  _textCommentClicked: function _textCommentClicked() {
    var logined = _app["default"].currentUser.logined();
    if (!logined) {
      _app["default"].popupInnerLogin();
      return;
    }
    this.showComments();
    if (this.curTool == "text-mark") {
      this.clearEditTool();
      this.editorViewCtl.setCurOperation();
    } else {
      this.clearEditTool();
      this.curTool = "text-mark";
      this.editorViewCtl.setCurOperation(this.curTool);
      this.setToolFocus("textCommentButton");
      this.showComments();
      this._showTextCommentPrompt();
    }
  },
  _showTextCommentPrompt: function _showTextCommentPrompt() {
    var $btnArea = this.$("#textCommentButton").parent();
    var width = 220;
    var height = 40;
    var left = $btnArea.width() / 2;
    var top = $btnArea.height();
    var posInBody = _MMCommonFun["default"].convertPointBetweenElements($btnArea[0], $("body")[0], {
      x: left,
      y: top - 4
    });
    posInBody.x -= width / 2;
    var $promptDiv = $('<div class="textCommentPrompt toolPrompt" style="position:absolute;left:' + posInBody.x + "px;top:" + posInBody.y + "px;width:" + width + "px;height:" + height + "px;line-height:" + height + "px" + '">' + BabelStr.str(5160) + "</div>");
    $("body").append($promptDiv);
    setBabelTimeout(function () {
      $promptDiv.remove();
    }, 5000);
  },
  _commentToolClicked: function _commentToolClicked(e) {
    var logined = _app["default"].currentUser.logined();
    if (!logined) {
      _app["default"].popupInnerLogin();
      return;
    }
    this.removeAllTopPanel();
    this.showComments();
    if (this.curTool == "comment") {
      this.clearEditTool();
      this.editorViewCtl.setCurOperation();
    } else {
      this.clearEditTool();
      this.curTool = "comment";
      this.editorViewCtl.setCurOperation("comment");
      this.setToolFocus("commentButton");
    }
  },
  _tagClicked: function _tagClicked(e) {
    var logined = _app["default"].currentUser.logined();
    if (!logined) {
      _app["default"].popupInnerLogin();
      return;
    }
    this.showComments();
    this.removeAllTopPanel();
    if (this.curTool == "tag") {
      this.clearEditTool();
      this.editorViewCtl.setCurOperation();
    } else {
      this.clearEditTool();
      this.curTool = "tag";
      this.editorViewCtl.setCurOperation("tag");
      this.setToolFocus("addTagButton");
    }
  },
  _moveClicked: function _moveClicked(e) {
    this.removeAllTopPanel();
    this.clearEditTool();
    this.setToolFocus("moveButton");
  },
  _preFileClicked: function _preFileClicked(e) {
    var _this6 = this;
    if (!this.editorViewCtl) {
      return;
    }
    this.editorViewCtl.canChangeFile(function () {
      _this6.$el.find(".edit-tool").hide();
      var self = _this6;
      if (_this6.editorViewCtl.hasNextFile(false)) {
        _this6.removeAllTopPanel();
        _this6.clearEditTool();
        _this6.editorViewCtl.closeCommentPanel();
        _this6.editorViewCtl.changeToNextFile(false, true, function () {
          self.updatePgInfo();
        });
        self.updatePgInfo();
      } else {
        _this6.$el.find(".edit-tool").show();
        _this6.updatePgInfo();
      }
    }, function () {});
  },
  _nextFileClicked: function _nextFileClicked(e) {
    var _this7 = this;
    if (!this.editorViewCtl) {
      return;
    }
    this.editorViewCtl.canChangeFile(function () {
      _this7.$el.find(".edit-tool").hide();
      var self = _this7;
      if (_this7.editorViewCtl.hasNextFile(true)) {
        _this7.removeAllTopPanel();
        _this7.clearEditTool();
        _this7.editorViewCtl.closeCommentPanel();
        _this7.editorViewCtl.changeToNextFile(true, true, function () {
          self.updatePgInfo();
        });
        self.updatePgInfo();
      } else {
        _this7.$el.find(".edit-tool").show();
        _this7.updatePgInfo();
      }
    }, function () {});
  },
  _zoomClicked: function _zoomClicked(e) {
    this.removeAllTopPanel("exceptZoom");
    if (this.zoomList) {
      this.zoomList.hide();
      this.zoomList = null;
    } else {
      this.zoomList = new _MDZoomPopupView["default"]({
        editor: this.editorViewCtl
      });
      var z_startIndex = _MMBasicData["default"].getO2OStartLayerZ_index();
      this.zoomList.$el.css("z-index", z_startIndex);
      var self = this;
      this.zoomList.show({
        triggerView: e.currentTarget,
        center: true,
        width: 100,
        onClose: function onClose() {
          if (self.zoomList) {
            var zoom = self.zoomList.zoomSelected;
            if (zoom > 0) {
              self._setZoom(zoom);
            }
          }
          self.zoomList = null;
        }
      });
    }
  },
  _setZoom: function _setZoom(zoom) {
    if (zoom < 0) {
      zoom = 0 - zoom;
    }
    if (!zoom) {
      zoom = 1.0;
    } else if (isNaN(zoom)) {
      zoom = parseFloat(zoom);
      if (isNaN(zoom)) {
        zoom = 1.0;
      }
    }
    zoom = Math.round(zoom * 100);
    this.$("#zoomBtn").find("span").text(zoom + "%");
  },
  _zoomChanged: function _zoomChanged(opt) {
    if (opt && opt.editorViewCtl != this.editorViewCtl) {
      return;
    }
    if (!this.editorViewCtl) return;
    var scale = Math.round(this.editorViewCtl.getScale() * 100) / 100;
    this._setZoom(scale);
  },
  // aiClicked: function (e) {
  //   if (!window.isOpenAI) {
  //     app.pathRouter.openNetTab("/p/ai.do");
  //     return;
  //   }
  //   this.removeFileNavi();
  //   this.removeFileinfoPanel();
  //   this.editorViewCtl.closeCommentPanel();
  //   var dispVer = this.editorViewCtl.getVersionShowing();
  //   var fileInfor = this.editorViewCtl.getCurrentFileInfo();
  //   var self = this;
  //   if (!this.aiPanel) {
  //     this.aiPanel = new MDAIMainPanelView({
  //       fileVersion: dispVer,
  //       fileInfor: fileInfor,
  //       fileId: fileInfor.getFileId(),
  //       removeAiPanel: () => {
  //         this.removeAiPanel();
  //       },
  //     });
  //     var editorRoot = this.editorViewCtl.getEditorRootDiv();
  //     var z_maxIndex = MMBasicData.getO2OMaxLayerZ_index() + 1;
  //     this.aiPanel.$el.css("z-index", z_maxIndex);
  //     this.addSubView(
  //       this.aiPanel,
  //       $(editorRoot).find(".editor-content-panel")
  //     );
  //   } else {
  //     this.removeAiPanel();
  //   }
  // },

  aiClicked: function aiClicked(e) {
    if (!window.isOpenAI) {
      _app["default"].pathRouter.openNetTab("/p/ai.do");
      return;
    }
    this.removeFileNavi();
    this.removeOCRPanel();
    if (this.verListPanel) {
      this.verListPanel.removeFromSuperView();
      this.verListPanel = null;
    }
    this.removeFileinfoPanel();
    // this.clearEditTool();
    $(".toolPrompt").remove();
    _MDIntro["default"].exit();
    if (this.superView) {
      this.superView.hideEvaluationPanel();
      this.superView.refreshEvaluationPanelWithCurFile();
    }
    if (this.salonPanel) {
      this.salonPanel.hide();
    }
    var opened = this.superView.toggleAINavigator();
    if (opened) {
      this.$(".p-tool-ai").addClass('checked');
      _MMCommonFun["default"].setTextInputInEditor("aiPanel");
    } else {
      this.$(".p-tool-ai").removeClass('checked');
      _MMCommonFun["default"].removeTextInputInEditor("aiPanel");
    }
    // MMCommonFun.removeTextInputInEditor("fileAttr");

    // var $btn = this.$(".p-tool-commentList");
    // var board = this.editorViewCtl.getCurrentBoard();

    // var fileInfo = board.getFileInfo();
    // if (opened) {
    //   $btn.addClass("selected");
    //   // $readStatus.css('opacity', 0);
    // } else {
    //   $btn.removeClass("selected");
    //   // if(fileInfo.get('unreadedCommentCount') > 0) {
    //   //   $readStatus.css('opacity', 1);
    //   // }
    // }
  },
  _closeAiPanel: function _closeAiPanel(file) {
    var fileInfor = this.editorViewCtl.getCurrentFileInfo();
    if (file == fileInfor) {
      if (this.$(".p-tool-ai").hasClass('checked')) {
        this.aiClicked();
      }
    }
  },
  _closeOcrPanel: function _closeOcrPanel(file) {
    var fileInfor = this.editorViewCtl.getCurrentFileInfo();
    if (file == fileInfor) {
      if (this.$(".p-tool-ocr").hasClass('checked')) {
        this.ocrClicked();
      }
    }
  },
  ocrClicked: function ocrClicked(e) {
    if (!window.isOpenAI) {
      _app["default"].pathRouter.openNetTab("/p/ai.do");
      return;
    }
    this.removeFileNavi();
    this.removeAiPanel();
    if (this.verListPanel) {
      this.verListPanel.removeFromSuperView();
      this.verListPanel = null;
    }
    this.removeFileinfoPanel();
    // this.clearEditTool();
    $(".toolPrompt").remove();
    _MDIntro["default"].exit();
    if (this.superView) {
      this.superView.hideEvaluationPanel();
      this.superView.refreshEvaluationPanelWithCurFile();
    }
    if (this.salonPanel) {
      this.salonPanel.hide();
    }
    var opened = this.superView.toggleOCRNavigator();
    if (opened) {
      this.$(".p-tool-ocr").addClass('checked');
      // MMCommonFun.setTextInputInEditor("aiPanel");
    } else {
      this.$(".p-tool-ocr").removeClass('checked');
      // MMCommonFun.removeTextInputInEditor("aiPanel");
    }
  },
  removeAiPanel: function removeAiPanel() {
    this.superView.toggleAINavigator(true);
    _MMCommonFun["default"].removeTextInputInEditor("aiPanel");
    this.$(".p-tool-ai").removeClass('checked');
  },
  removeOCRPanel: function removeOCRPanel() {
    this.superView.toggleOCRNavigator(true);
    this.$(".p-tool-ocr").removeClass('checked');
    // MMCommonFun.removeTextInputInEditor("aiPanel");
  },
  _versionsClicked: function _versionsClicked(e) {
    this.removeFileNavi();
    this.removeAiPanel();
    this.removeOCRPanel();
    this.editorViewCtl.closeCommentPanel();
    var dispVer = this.editorViewCtl.getVersionShowing();
    var self = this;
    if (!this.fileInfoPanel) {
      this.fileInfoPanel = new _MDEditorFileInfoPanel["default"]({
        fileVersionRouterCb: this.fileVersionRouterCb,
        closeCallback: function closeCallback(argument) {
          self.fileInfoPanel = null;
          _MMCommonFun["default"].removeTextInputInEditor("fileAttr");
        },
        editor: this.editorViewCtl,
        fileInfo: this.editorViewCtl.getCurrentFileInfo(),
        enableRouterNavigation: this.enableRouterNavigation,
        dispVer: dispVer,
        activeIndex: 3
      });
      var editorRoot = this.editorViewCtl.getEditorRootDiv();
      this.addSubView(this.fileInfoPanel, $(editorRoot));
      // this.fileInfoPanel.lookHistory();

      _MMCommonFun["default"].setTextInputInEditor("fileAttr");
    } else {
      this.removeFileinfoPanel();
      _MMCommonFun["default"].removeTextInputInEditor("fileAttr");
    }
  },
  removeFileinfoPanel: function removeFileinfoPanel() {
    if (this.fileInfoPanel) {
      this.fileInfoPanel.removeFromSuperView();
      this.fileInfoPanel = null;
    }
  },
  _closeClicked: function _closeClicked(e) {
    var _this8 = this;
    if (_app["default"].pathRouter.isPreview && _app["default"].pathRouter.isPreview()) {
      window.close();
      return;
    }
    if (this.editorViewCtl && this.editorViewCtl.canChangeFile) {
      this.editorViewCtl.canChangeFile(function () {
        _this8.superView.close();
        _Dispatcher["default"].trigger(_MDEvents["default"].WHITEBOARD_CLOSED);
      }, function () {});
    } else {
      this.superView.close();
      _Dispatcher["default"].trigger(_MDEvents["default"].WHITEBOARD_CLOSED);
    }
  },
  _fileNaviClicked: function _fileNaviClicked(e) {
    var fileCount = this.editorViewCtl.getFileCount();
    if (fileCount <= 1) {
      return;
    }
    this.removeVersionList();
    this.editorViewCtl.closeCommentPanel();
    var self = this;
    if (!this.fileNavi) {
      this.fileNavi = new _MDFilesNavigator["default"]({
        toolbar: this,
        editorViewCtl: this.editorViewCtl,
        closeCallback: function closeCallback() {
          self.fileNavi = null;
          _MMCommonFun["default"].removeTextInputInEditor("fileNaviPanel");
        }
      });
      _MMCommonFun["default"].setTextInputInEditor("fileNaviPanel");
    } else {
      this.removeAllTopPanel();
    }
    return false;
  },
  removeAllTopPanel: function removeAllTopPanel(exceptZoom) {
    this.removeFileNavi();
    this.removeVersionList();
    // this.clearEditTool();
    if (!exceptZoom) {
      this.removeZoomList();
    }
    $(".toolPrompt").remove();
    _MDIntro["default"].exit();
    if (this.superView) {
      this.superView.hideEvaluationPanel();
      this.superView.refreshEvaluationPanelWithCurFile();
    }
    if (this.salonPanel) {
      this.salonPanel.hide();
    }
  },
  removeFileNavi: function removeFileNavi() {
    if (this.fileNavi) {
      this.fileNavi.remove();
      this.fileNavi = null;
    }
  },
  removeVersionList: function removeVersionList() {
    if (this.verListPanel) {
      this.verListPanel.removeFromSuperView();
      this.verListPanel = null;
    }
    this.removeFileinfoPanel();
    this.removeAiPanel();
    this.removeOCRPanel();
  },
  _fileCommentsListClicked: function _fileCommentsListClicked(e) {
    var $readStatus = this.$(".readStatus");
    this.removeAllTopPanel();
    var opened = this.superView.toggleCommentsNavigator();
    var $btn = this.$(".p-tool-commentList");
    // var board = this.editorViewCtl.getCurrentBoard();

    // var fileInfo = board.getFileInfo();
    if (opened) {
      $btn.addClass("selected");
      // $readStatus.css('opacity', 0);
    } else {
      $btn.removeClass("selected");
      // if(fileInfo.get('unreadedCommentCount') > 0) {
      //   $readStatus.css('opacity', 1);
      // }
    }
  },
  openCommentPanel: function openCommentPanel() {
    var $btn = this.$(".p-tool-commentList");
    if (!$btn.hasClass("selected")) {
      this._fileCommentsListClicked();
    }
  },
  _clearTool: function _clearTool(params) {
    var isMarkerEvent = params.isMark;
    var editorViewCtl = params.editorViewCtl;
    if (!isMarkerEvent && this.editorViewCtl == editorViewCtl) {
      this.clearEditTool();
    }
  },
  _commentVisibleClicked: function _commentVisibleClicked(e) {
    this.clearEditTool();
    this.editorViewCtl.setCurOperation();
    if (this.commentHidden) {
      this.showComments();
    } else {
      this.hideComments();
    }
  },
  _rotateClicked: function _rotateClicked(e) {
    this.clearEditTool();
    this.editorViewCtl.getCurEditor().rotate90();
  },
  mouseOverToolbar: function mouseOverToolbar() {
    this.$fileChanger && this.$fileChanger.hide();
  },
  showFileChanger: function showFileChanger() {
    if (!this.$fileChanger) {
      return;
    }
    this.$fileChanger.show();
    if (this.fileChangeTimer) {
      clearTimeout(this.fileChangeTimer);
      this.fileChanger = null;
    }
    if (!this._mouseOverChanger) {
      var self = this;
      this.fileChangeTimer = setBabelTimeout(function () {
        self.$fileChanger.hide();
      }, 2000);
    }
  },
  showComments: function showComments() {
    if (!this.editorViewCtl) {
      return;
    }
    var hideComment = _MDLocalString["default"].getLocalString(111); // '隐藏批注'
    _MDEditorOption["default"].setShowCommentOn(true);
    this.$("#visibility").attr("title", hideComment);
    var $visibility = this.$("#visibility");
    this.commentHidden = false;
    $visibility.removeClass("showcomment");
    _MMObjOperationStrategy["default"].setCommentHidden(false);
    this.editorViewCtl.showCommentLayer();
    this.editorViewCtl.refreshObjsInEditor();
  },
  hideComments: function hideComments() {
    _MDEditorOption["default"].setShowCommentOn(false);
    var showComment = _MDLocalString["default"].getLocalString(2008); // '显示批注'
    this.$("#visibility").attr("title", showComment);
    var $visibility = this.$("#visibility");
    this.commentHidden = true;
    $visibility.addClass("showcomment");
    _MMObjOperationStrategy["default"].setCommentHidden(true);
    this.editorViewCtl.hideCommentLayer();
    this.editorViewCtl.refreshObjsInEditor();
    this.editorViewCtl.closeCommentPanel();
  },
  _downloadClicked: function _downloadClicked() {
    var _this9 = this;
    if (this.editorViewCtl) {
      var board = this.editorViewCtl.getCurrentBoard();
      var verInfo = null;
      var name = "";
      var curFileId = 0;
      if (board) {
        var fileInfo = board.getFileInfo();
        name = board.getDisplayName();
        if (fileInfo.isDeleteVersion()) {
          if (_app["default"].isInClient()) {
            var electron = window["ElectronRequire"]("electron");
            var download = electron.remote.require("./utils/cppAPI").downloadFile;
            if (download) {
              _MMEnterpriseController["default"].isIpAllowDownload(_app["default"].currentFolder.getFileId(), function () {
                _app["default"].getDownloadFileTargetForClient(_this9.fileInfors, function (path) {
                  var result = [];
                  result.push({
                    fileId: fileInfo.getFileId(),
                    fileName: fileInfo.getFileName(),
                    fileSize: fileInfo.get("fileSize") || fileInfo.get("currentVersionSize") || 1,
                    isFolder: fileInfo.isFolder(),
                    version: fileInfo.getDeleteVersion()
                  });
                  download(result, path);
                });
              }, function (err) {
                _MDAlertView["default"].showStandardPrompt({
                  message: err.msg
                });
              });
              return;
            }
          } else {
            _MDDownloadFileController["default"]._downloadFileWithVer(fileInfo.getFileId(), fileInfo.getDeleteVersion(), name, fileInfo);
          }
        } else {
          var showingVer = this.editorViewCtl.getVersionShowing();
          curFileId = board.getStringId();
          verInfo = fileInfo.getVersionInfo(showingVer);
        }
      } else {
        var fileInfo = this.editorViewCtl.getCurrentFileInfo();
        var ver = fileInfo.getCurVersion();
        verInfo = fileInfo.getVersionInfo(ver);
        name = fileInfo.getFileName();
        curFileId = fileInfo.getFileId();
      }
      if (verInfo) {
        if (_app["default"].isInClient()) {
          var electron = window["ElectronRequire"]("electron");
          var download = electron.remote.require("./utils/cppAPI").downloadFile;
          if (download) {
            _MMEnterpriseController["default"].isIpAllowDownload(_app["default"].currentFolder.getFileId(), function () {
              _app["default"].getDownloadFileTargetForClient([verInfo], function (path) {
                var result = [];
                result.push({
                  fileId: verInfo.getFileId(),
                  fileName: verInfo.getFileName(),
                  fileSize: verInfo.get("fileSize") || verInfo.get("currentVersionSize") || 1,
                  isFolder: verInfo.isFolder(),
                  version: verInfo.get("ver")
                });
                download(result, path);
              });
            }, function (err) {
              _MDAlertView["default"].showStandardPrompt({
                message: err.msg
              });
            });
            return;
          }
        } else {
          _MDDownloadFileController["default"].downloadFileWithVerInfo(verInfo, function () {}, function process() {});
        }
      } else if (fileInfo.getCurVersion() == this.editorViewCtl.getVersionShowing()) {
        verInfo = fileInfo.clone();
        verInfo.set("ver", this.editorViewCtl.getVersionShowing());
        if (_app["default"].isInClient()) {
          var electron = window["ElectronRequire"]("electron");
          var download = electron.remote.require("./utils/cppAPI").downloadFile;
          if (download) {
            _MMEnterpriseController["default"].isIpAllowDownload(_app["default"].currentFolder.getFileId(), function () {
              _app["default"].getDownloadFileTargetForClient([verInfo], function (path) {
                var result = [];
                result.push({
                  fileId: verInfo.getFileId(),
                  fileName: verInfo.getFileName(),
                  fileSize: verInfo.get("fileSize") || verInfo.get("currentVersionSize") || 1,
                  isFolder: verInfo.isFolder(),
                  version: verInfo.get("ver")
                });
                download(result, path);
              });
            }, function (err) {
              _MDAlertView["default"].showStandardPrompt({
                message: err.msg
              });
            });
            return;
          }
        } else {
          _MDDownloadFileController["default"].downloadFileWithVerInfo(verInfo, function () {}, function process() {});
        }
      } else {
        console.warn("can not get the version info");
      }
      // 清除未读文档标记
      var fileInfo = this.superView.getFileInfoById(curFileId);
      if (fileInfo) {
        fileInfo.clearUnReadCount();
      }
    }
  },
  _recordReadMark: function _recordReadMark(fileId) {
    var usrId = _app["default"].currentUser.id;
    _MMNetDiskDataController["default"].addFileAccessUser(fileId, usrId, function () {}, function () {});
  },
  viewWillUnRendered: function viewWillUnRendered() {
    _MMViewBase["default"].prototype.viewWillUnRendered.call(this);
    _Dispatcher["default"].off(null, null, this);
    this.removeAllTopPanel();
    _Dispatcher["default"].trigger(_MDEvents["default"].WHITEBOARD_CLOSED);
    $("body").off("keydown.editor-keydown");
  },
  removeZoomList: function removeZoomList() {
    if (this.zoomList) {
      this.zoomList.hide();
      this.zoomList = null;
    }
  },
  showZoomList: function showZoomList(show) {
    if (show) {
      this.$el.find("#zoomBtn").parent().show();
    } else {
      this.$el.find("#zoomBtn").parent().hide();
    }
  },
  _updateSalonInfo: function _updateSalonInfo(callback) {
    var fileInfo = this.editorViewCtl.getCurrentFileInfo();
    this.salonInfo = null;
    fileInfo.setSalonInfo(null);
    var self = this;
    var fileId = fileInfo.getFileId();
    _MMEnterpriseController["default"].getSalonForFile(fileId, function (salonInfo) {
      fileInfo.setSalonInfo(salonInfo);
      var curfileInfo = self.editorViewCtl.getCurrentFileInfo();
      if (fileId == curfileInfo.getFileId()) {
        self.salonInfo = salonInfo;
        if (salonInfo) {
          self.$(".salon-opening").show();
        } else {
          self.$(".salon-opening").hide();
        }
        if (self.salonPanel) {
          self.salonPanel.refreshPanel(salonInfo);
        }
        callback && callback(true);
      } else {
        callback && callback(false);
      }
    }, function () {
      self.$(".salon-opening").hide();
      callback && callback(false);
    });
  },
  _printClicked: function _printClicked() {
    var _this10 = this;
    var self = this;
    var board = this.editorViewCtl.getCurrentBoard();
    var fileInfo = this.editorViewCtl.getCurrentFileInfo();
    var curVersion = this.editorViewCtl.getVersionShowing();
    var imgPdfObjs = board.getImgPdfObjectsForVersion(curVersion);
    _MMEnterpriseController["default"].recordPrintAction(fileInfo.getFileId());
    if (fileInfo.isImage()) {
      var imgObj = imgPdfObjs[0];
      var filePath = imgObj.getDispFilePath();
      $("body").append("<iframe class = \"printContainer\"></iframe>");
      var promise = new Promise(function (resolve, reject) {
        _this10.printImg(filePath, resolve);
      });
      promise.then(function () {
        $("iframe.printContainer").remove();
      });
      // .... TODO
    } else if (board.isOperateOnPDFFile()) {
      // 因为可能需要从服务器下载，此处需要一个 mask 来表示正在下载，避免用户多次点击下载
      // 获得 pdf 和 pages' size information

      var progressView = new _MMPrintProgressView["default"]({
        fileName: fileInfo.getFileName()
      });
      progressView.show();
      this._loadPages(imgPdfObjs, function (pdf, pagesInfo) {
        console.log(pagesInfo);
        var editor = self.editorViewCtl.getCurEditor();
        self.printView.printPdf(pdf, pagesInfo, progressView, editor);
      });
    }
  },
  _spliteView: function _spliteView() {
    var fileInfor = this.editorViewCtl.getCurrentFileInfo();
    var compareView = new _MDFileCompareWinView["default"]({
      fileInfor: fileInfor,
      onlyCompare: true,
      compareFunCb: function compareFunCb(targetFileInfo, version) {
        var dispCtl = _MDPCDisplayFileController["default"].getSingleton();
        dispCtl.openFileWithoutRouter(targetFileInfo, version);
        compareView.remove();
      },
      cancelFunCb: function cancelFunCb() {
        compareView.remove();
      }
    });
    compareView.show();
  },
  printImg: function printImg(url, resolve) {
    var _this11 = this;
    var img = new Image();
    // img.src = url;
    img.crossOrigin = "Anonymous";
    // if ( img.complete || img.complete === undefined ) {
    img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
    img.src = url;
    // }
    // img.setAttribute("crossOrigin",'Anonymous');

    this.scratchCanvas = document.createElement("canvas");
    var imgload = new Promise(function (resolve, reject) {
      img.onload = resolve;
      img.onerror = reject;
    }).then(function () {
      new Promise(function (resolve, reject) {
        _this11.scratchCanvas.width = img.width;
        _this11.scratchCanvas.height = img.height;
        var ctx = _this11.scratchCanvas.getContext("2d");
        // ctx.fillStyle = 'rgb(255, 255, 255)';
        // ctx.fillRect(0, 0, this.scratchCanvas.width, this.scratchCanvas.height);
        ctx.drawImage(img, 0, 0);
        var editor = _this11.editorViewCtl.getCurEditor();
        // MMCommonFun.drawWaterMark(ctx, this.scratchCanvas, editor);
        // // ctx.restore();
        var printImg = document.createElement("img");
        printImg.style.width = img.width;
        printImg.style.height = img.height;
        if ("toBlob" in _this11.scratchCanvas) {
          _this11.scratchCanvas.toBlob(function (blob) {
            printImg.src = URL.createObjectURL(blob);
          }, {
            type: "image/jpg"
          });
        } else {
          printImg.src = _this11.scratchCanvas.toDataURL();
        }
        // let wrapper = document.createElement('div');
        // wrapper.appendChild(printImg);

        $("iframe.printContainer").contents().find("body").append(printImg);
        _this11.pageStyleSheet = document.createElement("style");
        var dir = "";
        // if(img.width < img.height){
        //   dir = "portrait"
        //   // printImg.style = 'height:"100%"';
        //   $(printImg).css({
        //     height: "100%"
        //   })
        // }else {
        //   $(printImg).css({
        //     width: "100%"
        //   })
        //   dir = "portrait"
        // }
        dir = "portrait";
        _this11.pageStyleSheet.textContent =
        // "size:<width> <height>" is what we need. But also add "A4" because
        // Firefox incorrectly reports support for the other value.
        "img { margin: 0 auto; }" + "img { max-width: 100% !important;}" + "img { max-height: 100% !important; }" + "@media print{" +
        // '@page { size: ' + img.width + 'px ' + img.height + 'px;}' +
        "img { page-break-inside: avoid; }" +
        // '@page { margin: 0.5cm; }'+
        "img { max-width: 100% !important;}" + "img {    position: absolute;left: 50%;top: 50%;transform: translate(-50%, -50%)}";
        "img { max-height: 100% !important; }" + "}";
        $("iframe.printContainer").contents().find("body").append(_this11.pageStyleSheet);
        printImg.onload = resolve;
        printImg.onerror = reject;
      }).then(function () {
        if (!!window.ActiveXObject || "ActiveXObject" in window) {
          $("iframe.printContainer")[0].contentWindow.execWB(7, 1);
        } else {
          $("iframe.printContainer")[0].contentWindow.print();
        }
        setBabelTimeout(resolve, 20);
      });
    })["catch"](function (e) {
      console.error(e);
    });

    // var img = new Image();
    // img.src = url;
    // // $("iframe.printContainer").contents().find('body').html(img);
    // img.onload = (e) => {
    //     // if(img.width >= img.height ){
    //     //   $("iframe.printContainer").contents().find("img").css({"width": "100%"});
    //     // }else{
    //     //   $("iframe.printContainer").contents().find("img").css({"height": "100%"});
    //     // }

    //     this.pageStyleSheet = document.createElement('style');
    //     let $img = $("iframe.printContainer").contents().find("img");
    //     let dir = "";
    //     if(img.width < img.height){
    //       dir = "portrait"
    //     }else {
    //       dir = "portrait"
    //     }

    //     this.pageStyleSheet.textContent =
    //       // "size:<width> <height>" is what we need. But also add "A4" because
    //       // Firefox incorrectly reports support for the other value.
    //       '@supports ((size:A4'+dir+') and (size:1pt 1pt)) {' +
    //       '@page { size: ' + img.width + 'pt ' + img.height + 'pt;}' +
    //       '}';
    //     $("iframe.printContainer").contents().find("body").append(this.pageStyleSheet);

    //     $("iframe.printContainer")[0].contentWindow.print();

    //     setBabelTimeout(resolve, 20)
  },
  _loadPages: function _loadPages(imgPdfObjs, callback) {
    var pagesCount = imgPdfObjs.length;
    var pagesInfo = [];
    var i = 0;
    var pdf = null;
    function loadPages(index) {
      if (index >= imgPdfObjs.length) {
        // 已经获得所有 page info
        callback(pdf, pagesInfo);
        return;
      }
      var pdfObj = imgPdfObjs[index];
      pdfObj.getPdfPage(function (page) {
        var viewport = page.getViewport(1.0);
        var pageSizeInfo = {
          width: viewport.width,
          height: viewport.height,
          rotation: viewport.rotation
        };
        pagesInfo.push(pageSizeInfo);
        if (pdf == null) {
          pdf = pdfObj.getPdfDoc();
        }
        loadPages(++index);
      });
    }
    loadPages(0);
  },
  _commentClicked: function _commentClicked(editor, commentObj) {
    if (this.editorViewCtl && this.editorViewCtl.getCurEditor() == editor) {
      this.updatePgInfo();
    }
  },
  _salonClicked: function _salonClicked() {
    var _this12 = this;
    var self = this;
    if (this.salonPanel && this.salonPanel.isShowing()) {
      this.salonPanel.hidePanel();
      return;
    }
    this._updateSalonInfo(function (success) {
      var fileInfo = _this12.editorViewCtl.getCurrentFileInfo();
      if (!_this12.salonPanel) {
        var fileId = fileInfo.getFileId();
        _this12.salonPanel = new _MDSalonPanelView["default"]({
          fileId: fileId,
          fileInfo: fileInfo,
          salonInfo: _this12.salonInfo,
          salonInfoUpdatedCallback: function salonInfoUpdatedCallback(salon_info) {
            if (salon_info) {
              self.$(".salon-opening").show();
            } else {
              self.$(".salon-opening").hide();
              _Dispatcher["default"].trigger(_MDEvents["default"].salonStatusChanged, salon_info);
            }
          }
        });
        _this12.salonPanel.hidePanel();
      } else {
        _this12.salonPanel.refreshWithFileInfo(_this12.salonInfo, fileInfo);
      }
      _this12.salonPanel.showPanel({
        top: "70px",
        right: "10px"
      });
    });
  },
  _textSearchClicked: function _textSearchClicked(e) {
    _Dispatcher["default"].trigger(_MDEvents["default"].Search_pdf_text_cliked, {
      editorViewCtl: this.editorViewCtl
    });
  },
  salonMsgManage: function salonMsgManage(salonMsg) {
    var fileInfor = this.editorViewCtl.getCurrentFileInfo();
    if (fileInfor.getFileId() != salonMsg.getFileId()) {
      return;
    }
    var type = salonMsg.getType();
    switch (type) {
      case MD_SALON_MSG_TYPE.SalonClosed:
      case MD_SALON_MSG_TYPE.SalonCreated:
      case MD_SALON_MSG_TYPE.SalonTransfered:
      case MD_SALON_MSG_TYPE.MemAdded:
      case MD_SALON_MSG_TYPE.MemLeaved:
        this._updateSalonInfo();
        break;
    }
  },
  viewDidUnRendered: function viewDidUnRendered() {
    _MMViewBase["default"].prototype.viewDidUnRendered.call(this);
    $("#print-pdf").remove();
  }
});
var _default = exports["default"] = MDTopToolbar4PC;

},{"104":104,"1087":1087,"1098":1098,"1104":1104,"1119":1119,"1128":1128,"1150":1150,"1184":1184,"1197":1197,"1416":1416,"1417":1417,"1423":1423,"1439":1439,"1454":1454,"1463":1463,"1465":1465,"1471":1471,"1487":1487,"1538":1538,"1541":1541,"1543":1543,"1545":1545,"17":17,"18":18,"204":204,"208":208,"22":22,"229":229,"232":232,"32":32,"325":325,"329":329,"412":412,"415":415,"418":418,"422":422,"439":439,"492":492,"549":549,"59":59,"60":60,"67":67,"695":695,"781":781,"811":811,"812":812,"872":872,"874":874,"898":898,"899":899,"905":905,"938":938}],549:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationWindowView = _interopRequireDefault(require(92));
var _MDAllFileSelectPageView = _interopRequireDefault(require(544));
var _MDFileComparePageView = _interopRequireDefault(require(548));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 *  window , file compare
 *  Created by jichao
 *  2017.12.20
 */
var MDFileCompareWinView = exports["default"] = /*#__PURE__*/function (_MDNavigationWindowVi) {
  (0, _inherits2["default"])(MDFileCompareWinView, _MDNavigationWindowVi);
  function MDFileCompareWinView() {
    (0, _classCallCheck2["default"])(this, MDFileCompareWinView);
    return _callSuper(this, MDFileCompareWinView, arguments);
  }
  (0, _createClass2["default"])(MDFileCompareWinView, [{
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileCompareWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        // fileVerCollection: new MMVersionInfoCollection()
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileCompareWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " compare-file-window");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileCompareWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .radio-box-item': this._radioBoxClickHandle
      });
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      if (opt.onlyCompare) {
        opt.title = BabelStr.str(3391); // "请选择文件进行内容查看比较";    
      } else {
        opt.title = BabelStr.str(3321); // "请选择文件进行内容比较或合并";
      }
      opt.width = 800;
      opt.fileComparePageView = new _MDFileComparePageView["default"]({
        title: opt.title,
        fileInfor: opt.fileInfor,
        onlyCompare: opt.onlyCompare,
        compareFunCb: opt.compareFunCb,
        cancelFunCb: opt.cancelFunCb
      });
      opt.rootNavigationPageView = opt.fileComparePageView;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileCompareWinView.prototype), "initialize", this).call(this, opt);
    }
  }]);
  return MDFileCompareWinView;
}(_MDNavigationWindowView["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"544":544,"548":548,"92":92}],548:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1417);
require(1463);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDFileInfoShowView = _interopRequireDefault(require(497));
var _MDFileVerListSelectionView = _interopRequireDefault(require(550));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDAllFileSelectPageView = _interopRequireDefault(require(544));
var _MDLinkFileListSelectionView = _interopRequireDefault(require(551));
var _MDTabView = _interopRequireDefault(require(82));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 *  window , file compare pageView
 *  Created by jichao
 *  2017.12.20
 */
var MDFileComparePageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDFileComparePageView, _MDNavigationPageView);
  function MDFileComparePageView() {
    (0, _classCallCheck2["default"])(this, MDFileComparePageView);
    return _callSuper(this, MDFileComparePageView, arguments);
  }
  (0, _createClass2["default"])(MDFileComparePageView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n      <div class=\"title mgb-10\">".concat(BabelStr.str(3322), " :</div>\n      <div class=\"file-block mgb-20\"></div>\n      <div class=\"flex-align between\">\n        <span>").concat(BabelStr.str(3323), " :</span>\n        <span class=\"text-button j-select-other done\">").concat(BabelStr.str(3324), "</span>\n      </div>\n      <div class=\"file-list-block\">\n        <div class=\"list-contain\"></div>\n      </div>\n      <div class=\"flex-align between mgt-15\">\n        <div class=\"left\">\n          <span class=\"radio-box-item checked mgr-20\">").concat(BabelStr.str(3328), "</span>\n          <span class=\"radio-box-item\">").concat(BabelStr.str(3329), "</span>\n        </div>\n        <div class=\"button-group\">\n          <button class=\"button cancel\">").concat(BabelStr.str(155), "</button>\n          <button class=\"button done save\">").concat(BabelStr.str(154), "</button>\n        </div>\n      </div>\n    ");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileComparePageView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        // fileVerCollection: new MMVersionInfoCollection()
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileComparePageView.prototype), "className", this).call(this);
      return "".concat(superCls, " compare-file-window");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileComparePageView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .radio-box-item': this._radioBoxClickHandle,
        'click .j-select-other': this.selectFromAllFile,
        'click .cancel': this.cancelHandel,
        'click .save': this.saveHandel
      });
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      var _this = this;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileComparePageView.prototype), "initialize", this).call(this, opt);
      this._renderFileInfo();
      this.verlistView = new _MDFileVerListSelectionView["default"]({
        onlyCompare: opt.onlyCompare,
        selectFromAllFile: function selectFromAllFile() {
          _this.selectFromAllFile();
        }
      });
      this.linkFilelistView = new _MDLinkFileListSelectionView["default"]({
        fileInfo: this.fileInfor
      });
      var tabs = [{
        title: BabelStr.str(3327),
        tabPanelView: this.verlistView
      }, {
        title: BabelStr.str(4565),
        tabPanelView: this.linkFilelistView
      }];
      this.tabview = new _MDTabView["default"]({
        className: 'file-col-tabs column-style-tab',
        tabBarDividerPosition: tabs.length,
        fullMode: false,
        enableActivebar: false,
        tabs: tabs
      });
      this.addSubView(this.tabview, this.$(".list-contain")[0]);
      this._requestFileVerList();
      this.type = 0;
      if (opt.onlyCompare) {
        this.$el.find('.radio-box-item').remove();
      }
    }
  }, {
    key: "_renderFileInfo",
    value: function _renderFileInfo() {
      var fileInfoView = new _MDFileInfoShowView["default"]({
        fileInfo: this.fileInfor,
        onlyName: true
      });
      this.addSubView(fileInfoView, this.$('.file-block')[0]);
    }
  }, {
    key: "_radioBoxClickHandle",
    value: function _radioBoxClickHandle($e) {
      this.$(".radio-box-item").removeClass("checked");
      $($e.target).addClass("checked");
      this.type = $($e.target).index();
    }
  }, {
    key: "_requestFileVerList",
    value: function _requestFileVerList(callback) {
      var _this2 = this;
      if (!this.fileInfor) {
        return;
      }
      if (this.fileInfor.canListVersion()) {
        this.fileInfor.listVersions(function (versionCollection) {
          _this2.verlistView.renderVerList(versionCollection);
        }, function fail() {
          console.log("could not load versions");
        });
      }
    }
  }, {
    key: "selectFromAllFile",
    value: function selectFromAllFile() {
      var _this3 = this;
      var selectFilePageView = new _MDAllFileSelectPageView["default"]({
        onlyCompare: this.onlyCompare,
        onselectedSuccess: function onselectedSuccess(files) {
          _this3.setSelectedFileInfos(files);
        }
      });
      this.navigationWindowView.push(selectFilePageView);
      // this.navigationWindowView.refreshWindow();
    }
  }, {
    key: "setSelectedFileInfos",
    value: function setSelectedFileInfos(fileInfors) {
      this.tabview.activeTabAt(0);
      this.verlistView.setSelectedFileInfo(fileInfors[0]);
    }
  }, {
    key: "cancelHandel",
    value: function cancelHandel() {
      this.cancelFunCb && this.cancelFunCb();
    }
  }, {
    key: "saveHandel",
    value: function saveHandel() {
      var selectedFileInfor = this.tabview.getcurActiveTabPanelView().getSelectedFile();
      // this.verlistView.getSelectedFile();

      if (!selectedFileInfor) {
        this.cancelHandel();
        return;
      }
      if (this.onlyCompare && this.compareFunCb) {
        var targetFileInfo = selectedFileInfor;
        if (selectedFileInfor.getFileId() == this.fileInfor.getFileId()) {
          targetFileInfo = this.fileInfor;
        }
        var ver = selectedFileInfor.get("ver") || selectedFileInfor.getCurVersion();
        this.compareFunCb(targetFileInfo, ver);
        _czc && _czc.push(["_trackEvent", "文件操作", "对比文件", "", "", ""]);
      } else {
        var srcfile = {
          fileId: this.fileInfor.getFileId(),
          versionId: this.fileInfor.getCurVersion(),
          fileSize: this.fileInfor.get("fileSize"),
          fileName: this.fileInfor.getFileName()
        };
        var tgFile = {
          fileId: selectedFileInfor.getFileId(),
          versionId: selectedFileInfor.get("ver") || selectedFileInfor.getCurVersion(),
          fileSize: selectedFileInfor.get("fileSize"),
          fileName: selectedFileInfor.getFileName()
        };
        app.isClientHasCompareFun()(srcfile, tgFile, this.type);
        var data = {
          srcfile: srcfile,
          tgFile: tgFile
        };
        console.warn("文件比较接口");
        console.warn(data);
        // app.isClientHasCompareFun()
      }
    }
  }]);
  return MDFileComparePageView;
}(_MDNavigationPageView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1417":1417,"1454":1454,"1463":1463,"1475":1475,"497":497,"544":544,"550":550,"551":551,"56":56,"82":82}],551:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
require(1417);
require(1418);
require(1537);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
var _MDNetDriveFileHandler = _interopRequireDefault(require(1091));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 *  链接文件文件选择列表
 *  Created by jichao 
 *  2017.12.20
 */
var MDLinkFileListSelectionView = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(MDLinkFileListSelectionView, _MDTabPanelView);
  function MDLinkFileListSelectionView() {
    (0, _classCallCheck2["default"])(this, MDLinkFileListSelectionView);
    return _callSuper(this, MDLinkFileListSelectionView, arguments);
  }
  (0, _createClass2["default"])(MDLinkFileListSelectionView, [{
    key: "emptyTmpl",
    value: function emptyTmpl() {
      return "\n      <div class=\"empty flex-align center middle f-tc\">\n        <div>\n          <p>".concat(BabelStr.str(4564), "</p>\n        </div>\n        \n      </div>\n    ");
    }
  }, {
    key: "linkFileListTmpl",
    value: function linkFileListTmpl() {
      return "\n        <div class=\"flex-align mgb-15 ver-item\" data-fileId=\"<%=fileId%>\">\n          <div class=\"checked-box icon\"></div>\n          <div class='image image-<%=index%>'></div>          \n          <div class='info'>\n            <div class='name text-hide'><%=name%></div>\n            <div class='time text-hide'><%=time%></div>\n          </div>           \n          \n        </div>   \n        \n    ";
    }
  }, {
    key: "oneFIleTmpl",
    value: function oneFIleTmpl() {
      return "\n      <div class=\"flex-align middle one-file checked\">\n        <div class=\"checked-box icon\"></div>\n        <div class=\"image no-shrink\"></div>\n        <div class=\"name text-hide\"><%=name%></div>\n      </div>\n    ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDLinkFileListSelectionView.prototype), "className", this).call(this);
      return "".concat(superCls, " linkfile-selection-block");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDLinkFileListSelectionView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        // fileVerCollection: new MMVersionInfoCollection()
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDLinkFileListSelectionView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .ver-item': this._verItemClickHandle,
        'click .check-other-btn': this._selectFromAllFile
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDLinkFileListSelectionView.prototype), "initialize", this).call(this, props);
      this.$fileRelationList = this.$el;
    }
  }, {
    key: "renderEmpty",
    value: function renderEmpty() {
      var contentTmpl = _.template(this.emptyTmpl());
      this.$el.html(contentTmpl);
    }
  }, {
    key: "_verItemClickHandle",
    value: function _verItemClickHandle($e) {
      var $item = $($e.target).closest(".ver-item");
      if ($item.hasClass("current-item")) {
        return;
      }
      this.$(".ver-item").removeClass("checked");
      $item.addClass("checked");
      var fileId = $item.data("fileid").toString();
      this.selectedFileInfor = _.find(this.relateFileInfos, function (file) {
        return file.get("fileId") == fileId;
      });
      console.log(this.selectedFileInfor);
    }
  }, {
    key: "getSelectedFile",
    value: function getSelectedFile() {
      return this.selectedFileInfor;
    }
  }, {
    key: "renderFileRelations",
    value: function renderFileRelations() {
      var self = this;
      this.$fileRelationList.empty();
      _MDNetDriveFileHandler["default"].getFileRelations(this.fileInfo.getFileId(), function success(fileInfos) {
        self.relateFileInfos = fileInfos;
        fileInfos.forEach(function (fileInfo, index) {
          var fileId = fileInfo.getFileId();
          var obj = {
            'fileId': fileId,
            'name': fileInfo.getFileName(),
            'time': MMCommonFun.formatSec2Date(fileInfo.get('latestVersionTime')),
            'index': index
          };
          var contentTmpl = _.template(self.linkFileListTmpl())(obj);
          self.$el.append(contentTmpl);
          fileInfo.setIconForDiv(self.$(".image-" + index));
        });
        if (!fileInfos.length) {
          self.renderEmpty();
        }
      }, function () {
        MDSpinnerloaderLayerView.clearFrom(self.$fileRelationList[0]);
      });
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDLinkFileListSelectionView.prototype), "viewDidRendered", this).call(this);
      this.renderFileRelations();
    }
  }]);
  return MDLinkFileListSelectionView;
}(_MDTabPanelView2["default"]);

},{"1091":1091,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1417":1417,"1418":1418,"1437":1437,"1454":1454,"1463":1463,"1475":1475,"1478":1478,"1537":1537,"81":81}],550:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 *  文件选择列表
 *  Created by jichao
 *  2017.12.20
 */
var MDFileVerListSelectionView = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(MDFileVerListSelectionView, _MDTabPanelView);
  function MDFileVerListSelectionView() {
    (0, _classCallCheck2["default"])(this, MDFileVerListSelectionView);
    return _callSuper(this, MDFileVerListSelectionView, arguments);
  }
  (0, _createClass2["default"])(MDFileVerListSelectionView, [{
    key: "emptyTmpl",
    value: function emptyTmpl() {
      return "\n      <div class=\"empty flex-align center middle f-tc\">\n        <div>\n          <p>".concat(BabelStr.str(3325), "</p>\n          <p><%=promptStr%></p>\n        </div>\n\n      </div>\n    ");
    }
  }, {
    key: "versionListTmpl",
    value: function versionListTmpl() {
      return "\n        <div class=\"flex-align mgb-15 ver-item <%=(isCurrent?\"current-item\":\"\")%>\" data-version=\"<%=version%>\">\n          <div class=\"checked-box icon\"></div>\n          <div class='image image-<%=index%>'></div>\n          <div class='info'>\n            <div class='flex-align'>\n              <div class='name text-hide'><%=name%></div>\n              <div class='text-hide mgl-20'><%=versionLog%></div>\n            </div>\n            <div class='flex-align'>\n              <div class='time no-shrink text-hide mgr-20'><%=time%></div>\n              <div class='text-hide'><%=committerName%></div>\n            </div>\n          </div>\n          <div class='flex-align fullfill end middle'>\n            <%if(isCurrent){%>\n              <span class='no-shrink mgl-20 button danger small'><%=currentStr%></span>\n            <%}%>\n          </div>\n        </div>\n\n    ";
    }
  }, {
    key: "oneFIleTmpl",
    value: function oneFIleTmpl() {
      return "\n      <div class=\"flex-align middle one-file checked\">\n        <div class=\"checked-box icon\"></div>\n        <div class=\"image no-shrink\"></div>\n        <div class=\"name text-hide\"><%=name%></div>\n      </div>\n    ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileVerListSelectionView.prototype), "className", this).call(this);
      return "".concat(superCls, " verlist-selection-block");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileVerListSelectionView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        // fileVerCollection: new MMVersionInfoCollection()
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileVerListSelectionView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .ver-item': this._verItemClickHandle,
        'click .check-other-btn': this._selectFromAllFile
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileVerListSelectionView.prototype), "initialize", this).call(this, props);
      // this.renderEmpty();
    }
  }, {
    key: "renderEmpty",
    value: function renderEmpty() {
      var checkOther = "<span class=\"text-button done check-other-btn\">".concat(BabelStr.str(3324), "</span>");
      var compare = BabelStr.str(3326, {
        "other": checkOther
      });
      if (this.onlyCompare) {
        compare = BabelStr.str(3396, {
          "other": checkOther
        });
      }
      var data = {
        promptStr: compare
      };
      var contentTmpl = _.template(this.emptyTmpl())(data);
      this.$el.html(contentTmpl);
    }
  }, {
    key: "setSelectedFileInfo",
    value: function setSelectedFileInfo(fileInfor) {
      var data = {
        name: fileInfor.getFileName()
      };
      var contentTmpl = _.template(this.oneFIleTmpl())(data);
      this.$el.html(contentTmpl);
      fileInfor.setIconForDiv(this.$('.image'));
      this.selectedFileInfor = fileInfor;
    }
  }, {
    key: "_selectFromAllFile",
    value: function _selectFromAllFile() {
      this.selectFromAllFile();
    }
  }, {
    key: "_verItemClickHandle",
    value: function _verItemClickHandle($e) {
      var $item = $($e.target).closest(".ver-item");
      if ($item.hasClass("current-item")) {
        return;
      }
      this.$(".ver-item").removeClass("checked");
      $item.addClass("checked");
      var version = $item.data("version").toString();
      this.selectedFileInfor = this.versionCollection.findWhere({
        "ver": version
      });
    }
  }, {
    key: "renderVerList",
    value: function renderVerList(versionCollection) {
      var _this = this;
      this.$el.append("<div class=\"temp-contain\"></div>");
      this.versionCollection = versionCollection;
      if (versionCollection.length < 2) {
        this.renderEmpty();
      } else {
        this.versionCollection.each(function (versionInfo, index) {
          var data = {
            name: versionInfo.getFileName(),
            time: MMCommonFun.formatSec2Date(versionInfo.get('createTime')),
            versionLog: versionInfo.getVersionLog(),
            isCurrent: versionInfo.isCurVersion(),
            currentStr: BabelStr.str(299),
            index: index,
            committerName: versionInfo.get('committerName'),
            version: versionInfo.get("ver")
          };
          if (data.isCurrent) {
            _this.$(".temp-contain").addClass("part").removeClass("full").html(data.versionLog);
          } else {
            _this.$(".temp-contain").addClass("full").removeClass("part").html(data.versionLog);
          }
          var containH = _this.$(".temp-contain").height();
          if (containH > 40) {
            data.overflow = true;
          } else {
            data.overflow = false;
          }
          var contentTmpl = _.template(_this.versionListTmpl())(data);
          _this.$el.append(contentTmpl);
          versionInfo.setIconForDiv(_this.$(".image-" + index));
        });
      }
    }
  }, {
    key: "getSelectedFile",
    value: function getSelectedFile() {
      return this.selectedFileInfor;
    }
  }]);
  return MDFileVerListSelectionView;
}(_MDTabPanelView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1437":1437,"1454":1454,"1463":1463,"1475":1475,"1478":1478,"81":81}],418:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
var _MMViewBase = _interopRequireDefault(require(22));
var _MMBasicData = _interopRequireDefault(require(811));
//
//  文档缩略图导航
//
//  created by jiang
//  2015-12-26
//

var MDFilesNavigator = _MMViewBase["default"].extend({
  el: '<div class="p-files-naviRoot p-files-panelRoot"></div>',
  tmpl: '<div class="p-files-zone mouseevent">' + '<ul class="p-thumbs-list mouseevent"></ul>' + '</div>',
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      editorViewCtl: null,
      curTool: "",
      closeCallback: _.noop,
      toolbar: null
    });
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      "mousedown .mouseevent": this._mouseDown,
      "mousemove .mouseevent": this._mouseMove,
      "mouseup .mouseevent": this._mouseUp,
      "click .p-files-zone": this._zoneClick,
      'click': this._rootClick
    });
  },
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    var z_maxIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
    this.$el.css('z-index', z_maxIndex);
    this.loadFileThumbnails();
    var that = this;
    $('body').on('mousemove.filenavi', function (e) {
      that._mouseOut(e);
    });
    this.scrollToShowCurPageThumbnail();
  },
  render: function render(data) {
    _MMViewBase["default"].prototype.render.call(this, data);
    $('body').append(this.$el);
  },
  scrollToShowCurPageThumbnail: function scrollToShowCurPageThumbnail() {
    this.setSelected();
    var scrollV = this.$('.p-files-zone')[0];
    var $selected = this.$('.selected');
    var selectedPos = MMCommonFun.convertPointBetweenElements($selected[0], scrollV, {
      x: 0,
      y: 0
    });
    scrollV.scrollLeft = selectedPos.x + $selected.width() / 2 - scrollV.offsetWidth / 2;
  },
  setSelected: function setSelected() {
    var curPg = this.editorViewCtl.getCurrentFileIndex() + 1;
    this.$('li').removeClass('selected');
    this.$('li:nth-child(' + curPg + ')').addClass('selected');
  },
  loadFileThumbnails: function loadFileThumbnails() {
    var self = this;
    if (this.editorViewCtl) {
      var thumbnails = this.editorViewCtl.getFileThumbnailsInfo(400, function (thumbInfo, i) {
        self._refreshThumbDiv(thumbInfo, i + 1);
      });
      var list = this.$('.p-thumbs-list')[0];
      if (thumbnails.length > 0) {
        var index = -1;
        for (var i = 0; i < thumbnails.length; i++) {
          if (thumbnails[i]) {
            index = i;
            break;
          }
        }
        ;
        var imgSize = thumbnails[index].imgSize;
        var $listZone = this.$('.p-thumbs-list');
        var divH = $listZone.height();
        var divW = divH * imgSize.x / imgSize.y;
        if (divH / divW > 2) {
          divW = divH * 2 / 3;
        }
        if (divW > $listZone.width() / 3) {
          divW = $listZone.width() / 3;
          if (divW < 400) {
            divW = 400;
          }
          ;
        }
        ;
        this.thumbDivSize = {
          width: divW,
          height: divH
        };
        for (var i = 0; i < thumbnails.length; i++) {
          this.createThumbDiv(thumbnails[i]);
        }
        ;
      }
      ;
    }
    ;
  },
  _refreshThumbDiv: function _refreshThumbDiv(thumbInfo, i) {
    if (!thumbInfo) {
      return;
    }
    ;
    var $thumbDiv = this.$('.p-thumbs-list li:nth-child(' + i + ')');
    var $image = $thumbDiv.find('img');
    $image.attr('src', thumbInfo.url);
    var $fileName = $thumbDiv.find('.thumbFileName');
    $fileName.text(thumbInfo.fileName);
    var self = this;
    $image.on('load', function (e) {
      $thumbDiv.find('.loading-txt').remove();
      $thumbDiv.removeClass('loading');
      var naturalW = $image[0].naturalWidth;
      var naturalH = $image[0].naturalHeight;
      var imgHeight = self.thumbDivSize.width * naturalH / naturalW;
      var margin = (self.thumbDivSize.height - imgHeight) / 2;
      if (margin >= 0) {
        // 高度不能撑满的上下居中
        $image.css({
          'position': 'absolute',
          'left': '0px',
          'right': '0px',
          'top': '0px',
          'bottom': '0px',
          'margin': 'auto'
        });
      }
      ;
      if (margin <= 0) {
        $image.css({
          'position': 'absolute',
          'top': '0px',
          'left': '0px',
          'right': '0px',
          'margin': 'auto'
        });
      }
    });
    $thumbDiv.css('cursor', 'pointer');
    var that = this;
    $thumbDiv.click(function (e) {
      if (that.moveLen < 5) {
        var index = $(e.currentTarget).index();
        that.editorViewCtl.canChangeFile(function success() {
          that.editorViewCtl.scrollToFile(index, true, function () {
            that.toolbar.updatePgInfo();
            that.setSelected();
            that.remove();
            if (that.closeCallback) {
              that.closeCallback();
            }
          });
        }, function () {});
      }
      ;
      return false;
    });
  },
  createThumbDiv: function createThumbDiv(thumbInfo) {
    var url = thumbInfo ? thumbInfo.url : '';
    var fileName = thumbInfo ? thumbInfo.fileName : '';
    var tmpl = '<li class="mouseevent loading" style="width:' + this.thumbDivSize.width + 'px; height:100%">' + '<img class="mouseevent" src="' + url + '"/>' + '<div class="mouseevent thumbFileName" >' + fileName + '</div>';
    '</li>';
    var $thumbDiv = $(tmpl);
    this.$('.p-thumbs-list').append($thumbDiv);
    this._refreshThumbDiv(thumbInfo, $thumbDiv.index() + 1);
    if (url == "") {
      $thumbDiv.append('<div class="loading-txt">' + BabelStr.str(7144) + '...</div>');
    }
    if (url == "*") {
      $thumbDiv.append('<div class="loading-txt">' + BabelStr.str(3576) + '</div>');
    }
  },
  setEditorViewCtl: function setEditorViewCtl(editorViewCtl) {
    this.editorViewCtl = editorViewCtl;
  },
  _rootClick: function _rootClick(e) {
    this.remove();
    if (this.closeCallback) {
      this.closeCallback();
    }
    return false;
  },
  _zoneClick: function _zoneClick(e) {
    return false;
  },
  _mouseDown: function _mouseDown(e) {
    e.preventDefault();
    e.stopPropagation();
    this.prePos = {
      x: e.clientX,
      y: e.clientY
    };
    this.down = true;
    this.moveLen = 0;
  },
  _mouseMove: function _mouseMove(e) {
    if (!this.prePos) return;
    var curPos = {
      x: e.clientX,
      y: e.clientY
    };
    var prePos = this.prePos;
    var dx = curPos.x - prePos.x;
    var dy = curPos.y - prePos.y;
    this.moveLen += Math.sqrt(dx * dx + dy * dy);
    this.prePos = curPos;
    var scroll = this.$('.p-files-zone')[0];
    scroll.scrollLeft -= dx;
    return false;
  },
  _mouseUp: function _mouseUp(e) {
    this.prePos = null;
    return false;
  },
  _mouseOut: function _mouseOut(e) {
    this.prePos = null;
    return false;
  },
  remove: function remove() {
    _MMViewBase["default"].prototype.remove.call(this);
    $('body').off('mousemove.filenavi');
    if (this.closeCallback) {
      this.closeCallback();
    }
  }
});
var _default = exports["default"] = MDFilesNavigator;

},{"1184":1184,"1417":1417,"1454":1454,"1463":1463,"22":22,"811":811}],415:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMViewBase = _interopRequireDefault(require(22));
var _MDFileVerListView = _interopRequireDefault(require(584));
var _MMBasicData = _interopRequireDefault(require(811));
var _MDFileInforSlidePanelView = _interopRequireDefault(require(574));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
/**
 *  file right zone: comments list and version info
 *  Create by jiang
 *  2017.6.29
 */

var MDEditorFileInfoPanel = _MMViewBase["default"].extend({
  el: '<div class="p-verList-root"></div>',
  tmpl: '<div class="p-verList-zone"></div>',
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      editor: null,
      fileTabView: null,
      closeCallback: _.noop,
      fileInfo: null,
      enableRouterNavigation: true,
      updateDisVerAfterDel: true,
      fileVersionRouterCb: _.noop,
      activeIndex: 0
    });
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      "click .p-verList-zone": this._zoneClicked
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    var z_maxIndex = _MMBasicData["default"].getO2OMaxLayerZ_index() + 1;
    this.$el.css("z-index", z_maxIndex);
    this.infoPanel = new _MDFileInforSlidePanelView["default"]({
      forEditor: true,
      fileInfor: opt.fileInfo,
      updateDisVerAfterDel: this.updateDisVerAfterDel,
      enableRouterNavigation: this.enableRouterNavigation,
      enableOpenVersion: true,
      activeIndex: this.activeIndex,
      closeCallback: function closeCallback() {
        self._rootClicked();
      },
      fileVersionRouterCb: this.fileVersionRouterCb,
      showDispMark: true,
      dispVer: this.dispVer
    });
    this.addSubView(this.infoPanel, this.$(".p-verList-zone")[0]);
    var curBoard = this.editor.getCurrentBoard();
    var fileInfo = curBoard.getFileInfo();
    if (curBoard) {
      var fileId = curBoard.getStringId();
    }
    this.$el.on("click", function () {
      // self._rootClicked();
    });
  },
  setDisplayVer: function setDisplayVer(version) {
    // this.listView.setDisplayVer(version);
  },
  render: function render(data) {
    _MMViewBase["default"].prototype.render.call(this, data);
    // $('body').append(this.$el);
  },
  setEditorViewCtl: function setEditorViewCtl(editor) {
    this.editor = editor;
  },
  _zoneClicked: function _zoneClicked(e) {
    e.stopPropagation();
  },
  _rootClicked: function _rootClicked(e) {
    this.remove();
    if (this.closeCallback) {
      this.closeCallback();
    }
  }
});
var _default = exports["default"] = MDEditorFileInfoPanel;

},{"1104":1104,"1184":1184,"1454":1454,"22":22,"574":574,"584":584,"811":811}],574:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1413);
require(1463);
require(1412);
require(1541);
require(1417);
require(1426);
require(1418);
require(1537);
require(1422);
require(1424);
require(1431);
require(1435);
require(1437);
require(1436);
require(1546);
require(1461);
require(1471);
require(1449);
require(1446);
var _MDLocalString = _interopRequireDefault(require(1150));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDNavigationView = _interopRequireDefault(require(57));
var _MMViewBase = _interopRequireDefault(require(22));
var _MDTabView = _interopRequireDefault(require(82));
var _MDTabPanelView = _interopRequireDefault(require(81));
var _MDFileInforPanelView = _interopRequireDefault(require(573));
var _MDFileVerListPanelView = _interopRequireDefault(require(583));
var _MMFileInfo = _interopRequireDefault(require(297));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MDEditalbeTextDiv = _interopRequireDefault(require(29));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDEditFileAttrWinView = _interopRequireDefault(require(597));
/**
 *  Show selected file information panel view
 *  Created by manjun.han
 *  2015.8.25
 */

var MDFileInforSlidePanelView = _MMViewBase["default"].extend({
  el: '<div class="m-inforPanel"></div>',
  tmpl: "<header class=\"name-header\">\n      <div class=\"fileinfo-header\">\n        <div class=\"content flex-align middle\">\n          <span class=\"type no-shrink thumbWrapper\"></span>\n          <span class = \"header-right mgl-10 fullfill\">\n            <div class=\"file-name text-hide \"></div>\n          </span>\n          <button class=\"icon arrowClose\"></button>\n        </div>\n      </div>\n    </header>\n    <section>\n    </section>",
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      fileInfor: null,
      enableOpenVersion: true,
      enableRouterNavigation: false,
      activeIndex: 0
    });
  },
  events: function events() {
    return {
      "click .arrowClose": this._hidePanelView,
      // 'click .calc-btn': this._calcuFileNum
      "click .addtag": this.addtag,
      "click .addAItag": this.addAITag,
      "click .multi-edit-custom-attr": this._editMultiCustomAttr
    };
  },
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.bindSelf(this.changeToFileListPanel, this.changeToFileInforPanel, this._rowSelectionChangedHandler, this._hidePanelView, this._editMultiCustomAttr);
    this.$fileName = this.$("header .content .file-name");
    // this.$lastModified = this.$("header .content  .last-modified small");
    this.bindSelf(this._fileNameChanged);
    this.fileInforView = new _MDFileInforPanelView["default"]({
      fileVersionRouterCb: this.fileVersionRouterCb,
      showDispMark: this.showDispMark,
      dispVer: this.dispVer,
      updateDisVerAfterDel: this.updateDisVerAfterDel,
      enableRouterNavigation: this.enableRouterNavigation,
      enableOpenVersion: this.enableOpenVersion,
      activeIndex: this.activeIndex
    });
    if (this.naviView) {
      this.removeSubView(this.naviView);
    }
    this.naviView = new _MDNavigationView["default"]({
      rootNavigationPageView: this.fileInforView
    });
    this.addSubView(this.naviView, this.$(">section")[0]);
    if (this.fileInfor) {
      this.fileInforView.setFileInfor(this.fileInfor, this.activeIndex);
      this.refreshFileName(this.fileInfor);
    }

    // 在 editor 右侧显示
    if (opt.forEditor) {
      this.fileInfor = null;
      this._showHandler({
        fileInfor: opt.fileInfor
      });

      // setBabelTimeout(()=>{

      //   this.verlistView = new MDFileVerListPanelView({
      //     fileInfor: this.fileInfor,
      //     fileVersionRouterCb: this.fileVersionRouterCb,
      //     showDispMark: this.showDispMark,
      //     dispVer: this.dispVer,
      //     updateDisVerAfterDel: this.updateDisVerAfterDel,
      //     enableRouterNavigation: this.enableRouterNavigation,
      //     enableOpenVersion: this.enableOpenVersion
      //   });
      //   this.naviView.push(this.verlistView)
      // }, 1000);
    } else {
      // 在文件浏览窗口右侧显示

      this.changeToFileInforPanel();
      Dispatcher.on(MDEvents.RowSelection_Changed, this._rowSelectionChangedHandler, this);
      // Dispatcher.on(MDEvents.ShowInforPanel, this._showHandler, this);
      // Dispatcher.on(MDEvents.showVerListPanel, this._showListHandler, this);
      Dispatcher.on(MDEvents.REFRESH_VERSIONS, this.checkToRefresh, this);
      Dispatcher.on(MDEvents.RowSelection_Closed, this._hidePanelView, this);
      Dispatcher.on(MDEvents.FileArchived, this.refreshCurFolder, this);
      Dispatcher.on(MDEvents.RefreshIcon, this._refreshIcon, this);
    }
  },
  _hidePanelView: function _hidePanelView() {
    if (!this.forEditor) {
      var mainPanelView = viewManager.get("mainPanelView", this);
      mainPanelView.closeFileInforPanel();
    } else {
      this.closeCallback && this.closeCallback();
    }
  },
  showEmptyTip: function showEmptyTip(msg) {
    var tipView = '<div class="select-tip"><p>' + msg + "</p></div>";
    this.removeEmptyTipView();
    this.$el.append(tipView);
  },
  removeEmptyTipView: function removeEmptyTipView() {
    this.$(".select-tip").remove();
  },
  addtag: function addtag() {
    if (!this.fileactionctl) {
      console.log("流程不对了");
      return;
    }
    this.fileactionctl.addTag();
  },
  addAITag: function addAITag() {
    if (!this.fileactionctl) {
      console.log("流程不对了");
      return;
    }
    this.fileactionctl.addAITag(this.$(".aitag"));
  },
  showMultiFileSizeView: function showMultiFileSizeView(fileInfos) {
    var _this = this;
    this.fileInforView.setActiveIndex(1);
    var self = this;
    var fileCount = fileInfos.length;
    var fileSize = 0;
    for (var i = 0; i < fileInfos.length; i++) {
      var file = fileInfos[i];
      if (app.pathRouter.inTrash()) {
        fileSize += file.get("fileSize");
      } else {
        fileSize += file.get("currentVersionSize");
      }
    }
    if (this.securitySelect) {
      this.securitySelect.removeFromSuperView();
    }
    var fileStr = _MDLocalString["default"].getLocalString(274);
    var sizePromp = _MDLocalString["default"].getLocalString(275); // 总占用空间
    // var sizeStr = app.getFileSizeDescription(fileSize);
    var sizeStr = _MDLocalString["default"].getLocalString(295);
    this.$fileName.html(fileStr + "：" + fileCount);
    this.$("header .content .type").addClass("mult-file").show();
    this.fileactionctl = new MDFileActionController();
    this.fileactionctl.setFileInfors(fileInfos);
    var tagCls = "";
    var aitagCls = "";
    if (!this.fileactionctl.canAddTag()) {
      tagCls = " f-hide";
    }
    if (!this.fileactionctl.canAddAITag()) {
      aitagCls = " f-hide";
    }
    var isArchive = app.ep && app.ep.isArchive();
    var showMultiCustomAttr = app.isEpVersion() && fileInfos.every(function (f) {
      return !f.isDeleted();
    });
    var aitag = "";
    if (!isArchive) {
      aitag = "<div class=\"flex-align middle end aitag ".concat(aitagCls, "\">\n      <button class=\"blue add-aitag addAItag\">").concat(BabelStr.str(12650), "</button>\n      <div class=\"loading-block mgt-10 mgb-10\">\n        <span class=\"dot\"></span>\n        <span class=\"dot\"></span>\n        <span class=\"dot\"></span>\n        <span class=\"dot\"></span>\n      </div>\n    </div>");
    }
    var multisizeView = '<div class="multi-file pdt-10  m-fileDetail">' + "\n        <div class=\"inforwrapper \">\n        <div class=\"desc\">\n          <div class=\"inforwrapper-head f-emph\">".concat(BabelStr.str(277), "</div>\n          <div class=\"file-remark f-hide\">\n            <div class=\"desc-label\">").concat(BabelStr.str(278), "\uFF1A</div>\n            <div class=\"remarksdiv\">\n            </div>\n          </div>\n          <div class=\"flex-align\">\n            <div class=\"desc-label\">").concat(sizePromp, "\uFF1A</div>\n            <span class=\"filesize\">\n              <button class=\"calc-mul-btn blue\">").concat(BabelStr.str(20157), "</button>\n            </span>\n          </div>\n          <div class=\"flex-align ").concat(tagCls, "\">\n            <div class=\"desc-label\">").concat(BabelStr.str(23), "\uFF1A</div>\n            <div>\n\n              ").concat(aitag, "\n              <button class=\"addtag blue\">").concat(BabelStr.str(106), "</button>\n            </div>\n          </div>\n          <div class=\"flex-align marginT-6 between security-block f-hide\">\n            <span class=\"desc-label no-shrink\">").concat(BabelStr.str(3337), "\uFF1A</span>\n            <div class=\"flex-align between with-wrap fullfill\">\n              <span class=\"security-select fullfill mgr-10\"></span>\n            </div>\n          </div>\n          ").concat(showMultiCustomAttr ? "\n          <div class=\"custom-attr splider-sec\">\n            <div class=\"flex-align between with-wrap\">\n              <div class=\"custom-attr-head\">\n                <span class=\"f-emph custom-attr-ope sign-info close base-desc\">".concat(BabelStr.str(40237), "</span>\n              </div>\n              <span class=\"edit-custom-attr f-fr font-color-blue\">\n                <button class=\"text-button done multi-edit-custom-attr\">").concat(BabelStr.str(2503), "</button>\n              </span>\n            </div>\n            <div class=\"desc custom-attr-contain detail base-desc f-hide\">\n              <div class=\"custom-attr-list\"></div>\n            </div>\n          </div>\n          ") : '', "\n          </div>\n          </div>\n        ") +
    // "<div>" +
    // sizePromp +
    // '：<span class="filesize"><button class="calc-mul-btn blue">' +
    // BabelStr.str(20157) +
    // "</button></span></div>" +
    "</div>";
    this.removeMultiFileSizeView();
    this.$el.append(multisizeView);
    this.fileInfors = fileInfos;
    // this._calcuTotalSize(fileInfos);
    this.fileInforView.setMultFile();
    var firstFile = fileInfos[0];
    setTimeout(function () {
      self.$el.find(".calc-mul-btn").unbind();
      self.$el.find(".calc-mul-btn").on("click", function (e) {
        var calcuCap = _MDLocalString["default"].getLocalString(295);
        var html = calcuCap + '<i class="dot">.</i><i class="dot">.</i><i class="dot">.</i>';
        self.$(".filesize").addClass("text-loading").empty().append(html);
        self._calcuFileNum();
      });
    }, 100);
    if ((firstFile.belongDepartment() || firstFile.belongEnterprisePub()) && !firstFile.isDepartmentFolder() && !firstFile.isProject() && app.ep && !app.ep.isArchive()) {
      firstFile.getSecretLevelsForFile(function (list, curLevelSetted) {
        // let secretLevelId = firstFile.getSecretLevelId();
        // curLevelSetted = _.isUndefined(curLevelSetted)
        //   ? firstFile.getSecretLevelId()
        //   : curLevelSetted;
        // let index = _.findIndex(list, {
        //   id: curLevelSetted,
        // });
        var newList = [{
          id: -1,
          comment: BabelStr.str(21944),
          commentEn: BabelStr.str(21944)
        }].concat(list);
        if (firstFile.canManageSecret() && _this.$(".multi-file .security-select").length) {
          _this.securitySelect = new _MDDropdownSelectListView["default"]({
            dataProvider: newList,
            labelField: "comment",
            selectedIndex: 0,
            interceptor: function interceptor(data) {
              if (app.ep.canShowSecurityPolicyModel()) {
                return true;
              }
              var opt = {
                message: BabelStr.str(6118)
              };
              _MDAlertView["default"].showStandardPrompt(opt);
              return false;
            },
            onChange: function onChange(data) {
              if (data.id == -1) {
                return;
              }
              _this.setFileSecurity(data);
            }
          });
          _this.$(".multi-file .security-select").empty();
          _this.addSubView(_this.securitySelect, _this.$(".multi-file .security-select")[0]);
          _this.$(".multi-file .security-block").removeClass("f-hide");
          console.log("004");
        } else {
          console.log("001");
          // let secretName = list[index].comment;
          // this.$(".security-select").html(secretName);
        }
      }, function () {
        console.log("003");
      });
    } else {
      console.log("002");
    }
    if (firstFile.getCommentStr().length == 0 && !firstFile.canManageFile() && !firstFile.canRename()) {
      // this.$el.find(".file-remark").remove();
    } else {
      this.$(".multi-file .file-remark").removeClass("f-hide");
      if (this.dispRemark) {
        this.dispRemark.removeFromSuperView();
      }
      var fids = [];
      _.each(this.fileInfors, function (file) {
        fids.push(file.getFileId());
      });
      this.dispRemark = new _MDEditalbeTextDiv["default"]({
        parentDiv: this.$(".multi-file .remarksdiv")[0],
        text: firstFile.getCommentStr(),
        disabelEdit: firstFile.isInTrash() || !firstFile.canUpdateFileCommentStr(),
        maxlength: 140,
        placeholder: BabelStr.str(6128),
        updatedCallback: function updatedCallback(newtext) {
          newtext = _.escape(newtext);
          _MMNetDiskDataController["default"].updateFileCommentStr(fids, newtext, function () {
            _.each(self.fileInfors, function (file) {
              // MMNetDiskDataController.getFileInfoFromServer(
              // file.getFileId(),
              // (newtext) => {
              file.setCommentStr(newtext);
              // }
              // );
            });
            _MDSnackbarView["default"].show(BabelStr.str(308));
          }, function () {
            self.dispRemark.setText(self.fileInfor.getCommentStr());
            _.each(self.fileInfors, function (file) {
              self.dispRemark.setText(file.getCommentStr());
            });
            _MDSnackbarView["default"].show(BabelStr.str(5086));
          });
        }
      });
    }
    this._fetchMultiCustomAttr(fileInfos);
  },
  _fetchMultiCustomAttr: function _fetchMultiCustomAttr(fileInfos) {
    if (!app.isEpVersion() || !fileInfos || fileInfos.length === 0) {
      return;
    }
    var allNotDeleted = fileInfos.every(function (f) {
      return !f.isDeleted();
    });
    if (!allNotDeleted) {
      return;
    }
    var self = this;
    this._ensureEntCustomAttrs(function () {
      var allCached = true;
      var allAttrs = [];
      for (var i = 0; i < fileInfos.length; i++) {
        var cached = fileInfos[i].get("customAttrs");
        if (cached) {
          allAttrs.push(cached);
        } else {
          allCached = false;
          break;
        }
      }
      if (allCached) {
        self._renderMultiCustomAttr(allAttrs);
        return;
      }
      var fileIds = fileInfos.map(function (f) {
        return f.getFileId();
      });
      MMEnterpriseController.getFileAttr({
        fileIdArr: fileIds
      }, function (responseData) {
        var allAttrs = [];
        var allHaveData = true;
        fileInfos.forEach(function (f) {
          var attrs = responseData.fileAttrs && responseData.fileAttrs[f.getFileId()];
          if (attrs) {
            f.set("customAttrs", attrs);
            allAttrs.push(attrs);
          } else {
            allHaveData = false;
          }
        });
        if (allHaveData) {
          self._renderMultiCustomAttr(allAttrs);
        }
      }, function () {});
    });
  },
  _renderMultiCustomAttr: function _renderMultiCustomAttr(allAttrs) {
    var $list = this.$(".multi-file .custom-attr-list");
    if (!$list.length) return;
    $list.empty();
    var allSame = this._areAllAttrsEqual(allAttrs);
    if (!allSame) {
      this._toggleMultiCustomAttr(false);
      return;
    }
    var attrs = allAttrs[0] || [];
    if (attrs.length === 0) {
      $list.html('<div class="empty">' + BabelStr.str(48286) + '</div>');
      this._toggleMultiCustomAttr(false);
      return;
    }
    var self = this;
    attrs.forEach(function (attr) {
      var value = attr.value;
      var type = attr.type;
      if (type === 4) {
        value = self._resolveAttrLabel(attr, value);
      } else if (type === 5) {
        value = self._resolveAttrLabels(attr, value);
      } else if (Array.isArray(value)) {
        value = value.join(", ");
      } else if (type === 3 && typeof value === 'number') {
        value = MMCommonFun.formatDate(value, "yyyy-MM-dd");
      }
      var $item = $('<div class="custom-attr-item flex-align between">' + '<span class="custom-attr-label middle-ellipsis">' + _.escape(attr.title) + '：</span>' + '<span class="custom-attr-value middle-ellipsis">' + _.escape(value || '--') + '</span>' + '</div>');
      $list.append($item);
    });
    this._toggleMultiCustomAttr(true);
  },
  _toggleMultiCustomAttr: function _toggleMultiCustomAttr(expand) {
    var $ope = this.$(".multi-file .custom-attr-ope");
    var $contain = this.$(".multi-file .custom-attr-contain");
    if (expand) {
      $contain.removeClass("f-hide");
      $ope.removeClass("close").addClass("open");
    } else {
      $contain.addClass("f-hide");
      $ope.addClass("close").removeClass("open");
    }
  },
  _areAllAttrsEqual: function _areAllAttrsEqual(allAttrs) {
    if (allAttrs.length <= 1) return true;
    var firstJson = JSON.stringify(this._normalizeAttrs(allAttrs[0]));
    for (var i = 1; i < allAttrs.length; i++) {
      var json = JSON.stringify(this._normalizeAttrs(allAttrs[i]));
      if (json !== firstJson) {
        return false;
      }
    }
    return true;
  },
  _normalizeAttrs: function _normalizeAttrs(attrs) {
    if (!attrs) return [];
    return attrs.map(function (a) {
      return {
        attrId: a.attrId,
        value: a.value
      };
    }).sort(function (a, b) {
      return a.attrId - b.attrId;
    });
  },
  _ensureEntCustomAttrs: function _ensureEntCustomAttrs(cb) {
    if (this._entCustomAttrMap) {
      cb();
      return;
    }
    var now = Date.now();
    var cache = window.__MDEditFileAttrCache__;
    if (cache && cache.data && now - cache.time < 10 * 60 * 1000) {
      this._buildEntCustomAttrMap(cache.data);
      cb();
      return;
    }
    var self = this;
    MMEnterpriseController.getEntCustoms(function (customsCollection) {
      var customs = customsCollection.models.map(function (m) {
        return m.toJSON();
      });
      if (!window.__MDEditFileAttrCache__) {
        window.__MDEditFileAttrCache__ = {
          data: null,
          time: 0
        };
      }
      window.__MDEditFileAttrCache__.data = JSON.parse(JSON.stringify(customs));
      window.__MDEditFileAttrCache__.time = Date.now();
      self._buildEntCustomAttrMap(customs);
      cb();
    }, function () {
      cb();
    });
  },
  _buildEntCustomAttrMap: function _buildEntCustomAttrMap(customs) {
    this._entCustomAttrMap = {};
    var self = this;
    customs.forEach(function (attr) {
      var attrId = attr.id || attr.attrId;
      self._entCustomAttrMap[attrId] = attr;
    });
  },
  _resolveAttrLabel: function _resolveAttrLabel(attr, value) {
    if (value === undefined || value === null || value === '') {
      return '--';
    }
    var altEntries = this._getAltEntries(attr);
    var entry = _.find(altEntries, function (e) {
      return e.id == value;
    });
    return entry ? entry.value : value;
  },
  _resolveAttrLabels: function _resolveAttrLabels(attr, value) {
    if (value === undefined || value === null || value === '') {
      return '--';
    }
    var idArr = Array.isArray(value) ? value : String(value).split(',');
    var altEntries = this._getAltEntries(attr);
    var labels = idArr.map(function (id) {
      var entry = _.find(altEntries, function (e) {
        return e.id == id;
      });
      return entry ? entry.value : id;
    });
    return labels.join(', ');
  },
  _getAltEntries: function _getAltEntries(attr) {
    if (this._entCustomAttrMap) {
      var def = this._entCustomAttrMap[attr.attrId];
      if (def && def.altEntries) {
        return def.altEntries;
      }
    }
    return attr.altEntries || [];
  },
  _editMultiCustomAttr: function _editMultiCustomAttr() {
    if (!this.fileInfors || this.fileInfors.length === 0) {
      return;
    }
    var self = this;
    var fileAttrs = [];
    var allCached = true;
    for (var i = 0; i < this.fileInfors.length; i++) {
      var cached = this.fileInfors[i].get("customAttrs");
      if (cached) {
        fileAttrs.push(cached);
      } else {
        allCached = false;
        break;
      }
    }
    var firstAttrs = allCached && this._areAllAttrsEqual(fileAttrs) ? fileAttrs[0] : [];
    var win = new _MDEditFileAttrWinView["default"]({
      fileInfors: this.fileInfors,
      fileAttrs: firstAttrs,
      onSave: function onSave(updatedAttrs) {
        var allAttrs = [];
        self.fileInfors.forEach(function (file) {
          file.set("customAttrs", updatedAttrs);
          allAttrs.push(updatedAttrs);
        });
        self._renderMultiCustomAttr(allAttrs);
      }
    });
    win.show();
  },
  setFileSecurity: function setFileSecurity(data) {
    var _this2 = this;
    _czc && _czc.push(["_trackEvent", "文件操作", "追加权限", "", "", ""]);
    var coverAll;
    var ids = [];
    var promise = new Promise(function (resolve, rejected) {
      var hasFolder = false;
      _.each(_this2.fileInfors, function (file) {
        if (file.isFolder()) {
          hasFolder = true;
        }
        ids.push(file.getFileId());
      });
      if (!hasFolder) {
        resolve();
      } else {
        var alertView = new _MDAlertView["default"]();
        alertView.show({
          message: "<p>".concat(BabelStr.str(5406), "</p> <p class=\"f-tc red\">(").concat(BabelStr.str(5409), ")</p>"),
          className: "m-delAlertWin",
          buttons: [{
            label: BabelStr.str(5408),
            onClick: function onClick() {
              resolve();
            }
          }, {
            label: BabelStr.str(5407),
            // '确定',
            type: "danger",
            onClick: function onClick() {
              resolve(true);
            }
          }]
        });
      }
    });
    promise.then(function (coverAll) {
      MDLoadMaskView.show(undefined, {
        bodyMsg: BabelStr.str(20159) + "...",
        noClose: true
      });
      MMEnterpriseController.setFileSecret(ids, data.id, function () {
        _.each(_this2.fileInfors, function (file) {
          _MMNetDiskDataController["default"].getFileInfoFromServer(file.getFileId(), function (newFile) {
            file.setSecretLevelId(newFile.getSecretLevelId());
          });
        });
        MDLoadMaskView.remove();
        _MDSnackbarView["default"].show(BabelStr.str(308));
      }, function () {
        MDLoadMaskView.remove();
        _MDSnackbarView["default"].show(BabelStr.str(3622));
      }, {
        coverAll: coverAll
      });
    });
  },
  _calcuFileNum: function _calcuFileNum() {
    // this._calcuTotalSize(this.fileInfors);
    this._calcuTotalSizeNew(this.fileInfors);
  },
  _calcuTotalSizeNew: function _calcuTotalSizeNew(fileInfos) {
    var self = this;
    var fileIds = fileInfos.map(function (fileInfo) {
      return fileInfo.getFileId();
    });
    var serverFun;
    if (window.user.useAdvancedSearch) {
      serverFun = MMEnterpriseController.getFileNumInFolder2New;
    } else {
      serverFun = _MMNetDiskDataController["default"].getFileNumInFolder2;
    }
    serverFun(fileIds, function (fileCount, size) {
      var sizeStr = app.getFileSizeDescription(size);
      self.$el.find(".filesize").text(sizeStr);
    }, function (error) {});
  },
  _calcuTotalSize: function _calcuTotalSize(fileInfos) {
    // 初始化所有的等待队列
    this.filesWaitCalcuating = [];
    this.originFiles = fileInfos;
    this.curCalcFileIndex = 0;
    for (var i = 0; i < fileInfos.length; i++) {
      var newFileInfo = fileInfos[i];
      if (newFileInfo.isFolder()) {
        var size = _MMFileInfo["default"].getCachedFolderSize(newFileInfo);
        if (size < 0) {
          if (this.curCalcFile != newFileInfo) {
            this.filesWaitCalcuating.push(newFileInfo);
          }
        } else {
          newFileInfo.setCalcFolderSize(size);
        }
      }
    }
    if (this.filesWaitCalcuating.length > 0) {
      // 首次，没有等待完成的后台调用
      if (!this.curCalcFile) {
        this._getFileSizeFromServerOneByOne(0);
      }
    } else {
      this._updateTotalSize();
    }
  },
  _getFileSizeFromServerOneByOne: function _getFileSizeFromServerOneByOne() {
    var self = this;
    if (this.filesWaitCalcuating.length == 0) {
      this.curCalcFile = null;
      this._updateTotalSize();
      return;
    }
    var fileInfo = this.filesWaitCalcuating.shift();
    this.curCalcFile = fileInfo;
    MMEnterpriseController.getFileNumInFolder(fileInfo.getFileId(), function (fileCount, size) {
      fileInfo.setCalcFolderSize(size);
      // 计算下一个文件夹大小
      self._getFileSizeFromServerOneByOne(); // 从头开始
    }, function (error) {
      // MDSnackbarView.show(BabelStr.str());
    });
  },
  _updateTotalSize: function _updateTotalSize() {
    var totalSize = 0;
    for (var i = 0; i < this.originFiles.length; i++) {
      var fileInfo = this.originFiles[i];
      if (fileInfo.isFolder()) {
        var cachedSize = fileInfo.getCalcFolderSize();
        if (cachedSize == undefined) {
          console.error("--------- 没有找到缓存的文件大小:" + fileInfo.getFileName());
        } else {
          totalSize += Number.parseInt(cachedSize);
        }
      } else {
        totalSize += Number.parseInt(fileInfo.get("fileSize"));
      }
    }
    var sizeStr = app.getFileSizeDescription(totalSize);
    this.$el.find(".filesize").text(sizeStr);
  },
  removeMultiFileSizeView: function removeMultiFileSizeView() {
    this.$(".multi-file").remove();
  },
  _tabChanged: function _tabChanged(payload) {},
  refresh: function refresh() {
    var fileInfors = this.selectedFileInfors;
    var dispFileInfo = null;
    if (!fileInfors || fileInfors.length == 0) {
      var findFolder = false;
      if (app.pathRouter) {
        var path = app.pathRouter.getFilePaths();
        if (path.length > 1) {
          findFolder = true;
          dispFileInfo = path[path.length - 1];
        }
        if (!findFolder) {
          dispFileInfo = _MMNetDiskDataController["default"].getDirByChannelRouter(this.channelRouter);
          // this.showEmptyTip('请选择文件或文件夹，查看详细信息');
        }
      } else {
        this.showEmptyTip(BabelStr.str(706)); // ('请选择文件或文件夹，查看详细信息');
      }
    } else if (fileInfors.length == 1) {
      dispFileInfo = fileInfors[0];
    } else if (fileInfors.length > 1) {
      // this.showMultiFileSizeView(fileInfors);
    } else {
      this.showEmptyTip(_MDLocalString["default"].getLocalString(276));
    }
    if (dispFileInfo) {
      this.setFileInfor(dispFileInfo);
    } else {
      this.setFileInfor(null);
    }
    if (fileInfors.length > 1) {
      this.showMultiFileSizeView(fileInfors);
    }
  },
  checkToRefresh: function checkToRefresh(fileId) {
    if (this.fileInfor && fileId == this.fileInfor.getFileId()) {
      if (this.fileVerListTabPanelView) {
        this.fileVerListTabPanelView.refresh();
      }
    }
  },
  _refreshIcon: function _refreshIcon(params) {
    var fileId = params.fileId;
    if (this.fileInfor && this.fileInfor.getFileId() == fileId) {
      this.fileInfor.setIconForDiv(this.$("header .content .type"), null, 26);
    }
  },
  closeFileInforPanel: function closeFileInforPanel() {
    this.opened = false;
    if (!this.fileInfor) {
      return;
    }
    if (this.fileInfor.hasMultiVersions() && !this.fileInfor.isDeleteVersion() && this.fileInfor.canUploadVersion()) {
      localStorage.setItem("hide-vlist-panel", "1");
    }
    if (this.fileInfor.isTeamFolder() || this.fileInfor.isProject()) {
      localStorage.setItem("hide-msg-panel", "1");
    }
  },
  getOpenState: function getOpenState() {
    return this.opened;
  },
  openFileInforPanel: function openFileInforPanel(payload) {
    this.opened = true;
    if (_.isUndefined(payload) || payload && _.isUndefined(payload.at)) {
      if (payload) {
        payload.at = 1;
      } else {
        payload = {
          at: 1
        };
      }
    }
    this.targetActiveIndex = payload && payload.at;
    if (payload && payload.fileInfor) {
      this.setFileInfor(payload.fileInfor);
    } else {
      this.refresh();
    }
    if (this.fileInfor && this.fileInfor.hasMultiVersions() && !this.fileInfor.isDeleteVersion() && this.fileInfor.canUploadVersion()) {
      localStorage.removeItem("hide-vlist-panel");
    }
  },
  _rowSelectionChangedHandler: function _rowSelectionChangedHandler(payload) {
    var dispFileInfo = null;
    if (_.isUndefined(payload) || payload && _.isUndefined(payload.at)) {
      if (payload) {
        payload.at = this.fileInforView.getActiveIndex();
      } else {
        payload = {
          at: this.fileInforView.getActiveIndex()
        };
      }
    }
    this.targetActiveIndex = payload && payload.at;
    this.selectedFileInfors = payload.selectedFileInfors;
    if (this.opened) {
      this.refresh();
    } else if (this.selectedFileInfors.length == 1 && this.selectedFileInfors[0].hasMultiVersions() && !this.selectedFileInfors[0].isDeleteVersion() && this.selectedFileInfors[0].canUploadVersion()) {
      var hideVlistPanel = localStorage.getItem("hide-vlist-panel");
      if (hideVlistPanel == 1) {
        return;
      }
      Dispatcher.trigger(MDEvents.showVerListPanel, {
        fileInfor: this.selectedFileInfors[0],
        at: 3
      });
    }
  },
  getActiveIndex: function getActiveIndex() {
    return this.fileInforView.getActiveIndex();
  },
  refreshCurFolder: function refreshCurFolder() {
    this.setFileInfor(app.currentFolder);
  },
  setFileInfor: function setFileInfor(fileInfor) {
    var _this3 = this;
    if (fileInfor && fileInfor.isNotCalcActions()) {
      this._setFileInfor(fileInfor);
      setTimeout(function () {
        if (fileInfor.isNotCalcActions()) {
          _MMNetDiskDataController["default"].getFileActions([fileInfor.getFileId()], function (newFiles) {
            var newFile = newFiles[0];
            if (newFile) {
              delete newFile.fileId;
            }
            fileInfor.set(newFile);
            _this3._setFileInfor(fileInfor);
          });
        } else {
          _this3._setFileInfor(fileInfor);
        }
      }, 500);
    } else {
      this._setFileInfor(fileInfor);
    }
  },
  _setFileInfor: function _setFileInfor(fileInfor) {
    if (!this.opened) {
      return;
    }
    if (!fileInfor) {
      this.fileInfor = null;
      this.changeToFileInforPanel();
      this.refreshFileName(null);
      return;
    }
    if (this.fileInfor && this.fileInfor == fileInfor && viewManager && viewManager.viewList && viewManager.viewList.curFileTableView && !viewManager.viewList.curFileTableView.isUsedAdvancedSearch) {
      if (!_.isUndefined(this.targetActiveIndex) && this.targetActiveIndex != this.fileInforView.getActiveIndex()) {
        this.fileInforView.setActiveIndex(this.targetActiveIndex || 0);
      }
      this.refreshFileName(fileInfor);
      return;
    }
    if (this.fileInfor) {
      this.stopListening(this.fileInfor);
    }
    this.removeEmptyTipView();
    this.removeMultiFileSizeView();

    // this.$lastModified.text("修改时间:    " + MMCommonFun.formatsec2DateAndWek(fileInfor.get("mtime")));

    this.fileInfor = fileInfor;
    var animateNavigate = this.naviView.animateNavigate;
    this.naviView.animateNavigate = false;
    this.changeToFileInforPanel();
    this.naviView.animateNavigate = animateNavigate;
    this.listenTo(fileInfor, "change:fileName", this._fileNameChanged);
    this.listenTo(this.fileInfor, "change:currentVersion", this._fileVersionChangded);
    this.refreshFileName(fileInfor);
  },
  refreshFileName: function refreshFileName(fileInfor) {
    var file = null;
    if (!fileInfor) {
      this.$fileName.attr("title", "");
      this.$fileName.html("");
      this.$("header .content .type").hide();
      return;
    }
    // || fileInfor.belongsToTeam() || fileInfor.belongProject()
    if (fileInfor.isTeamFolder() || fileInfor.isProject()) {
      file = app.pathRouter && app.pathRouter.getTeamByPathFromFile(fileInfor) || app.pathRouter && app.pathRouter.getProjectByPathFromFile(fileInfor) || fileInfor;
    }
    if (file) {
      fileInfor = file;
    }
    this.$fileName.attr("title", fileInfor.getFileName());
    this.$("header .content .type").removeClass("mult-file");
    fileInfor.setIconForDiv(this.$("header .content .type"), null, 26);
    var name = fileInfor.getFileName();
    if (file && this.fileInforView.getActiveIndex() == 0) {
      name = name + "-" + BabelStr.str(185);
      this.$(".name-header").addClass("bg-C10");
    } else {
      this.$(".name-header").removeClass("bg-C10");
    }
    this.$fileName.html(name);
  },
  _fileVersionChangded: function _fileVersionChangded(fileInfor) {
    this.$(".header .content .type").empty();
    fileInfor.setIconForDiv(this.$("header .content .type"), null, 26);
  },
  _fileNameChanged: function _fileNameChanged(fileInfor, newName) {
    this.$fileName.html(newName);
    this.$fileName.attr("title", newName);
  },
  _showHandler: function _showHandler(payload) {
    var fileInfor = payload.fileInfor;
    if (!fileInfor) {
      return;
    }
    this.setFileInfor(fileInfor);
    // this.changeToFileListPanel();
  },
  _showListHandler: function _showListHandler(payload) {
    var fileInfor = payload.fileInfor;
    if (!fileInfor) {
      return;
    }
    this.setFileInfor(fileInfor);
    this.changeToFileListPanel();
  },
  setEnableOpenVersion: function setEnableOpenVersion(enabled) {
    this.fileInforView.setEnableOpenVersion(enabled);
  },
  setEnableRouterNavigation: function setEnableRouterNavigation(enabled) {
    this.fileInforView.setEnableRouterNavigation(enabled);
  },
  /**
   * 显示文件历史版本页面
   */
  changeToFileListPanel: function changeToFileListPanel() {
    if (this.naviView.navigationPageViewStack.length < 2) {
      //未打开文件详情面板或者处于文件详情面板（不包括历史详情面板）
      this.naviView.navigationPageViewStack[0].lookHistory();
    }
  },
  /**
   * 显示文件详情页面
   */
  changeToFileInforPanel: function changeToFileInforPanel() {
    if (this.naviView && this.naviView.navigationPageViewStack.length > 1) {
      this.naviView.popToRoot();
    }
    this.fileInforView.setFileInfor(this.fileInfor, this.targetActiveIndex);
    this.targetActiveIndex = undefined;
  }
});
var _default = exports["default"] = MDFileInforSlidePanelView;

},{"1104":1104,"1150":1150,"1184":1184,"1412":1412,"1413":1413,"1417":1417,"1418":1418,"1422":1422,"1424":1424,"1426":1426,"1431":1431,"1435":1435,"1436":1436,"1437":1437,"1446":1446,"1449":1449,"1454":1454,"1461":1461,"1463":1463,"1471":1471,"1537":1537,"1541":1541,"1546":1546,"22":22,"29":29,"297":297,"32":32,"57":57,"573":573,"583":583,"597":597,"67":67,"72":72,"81":81,"82":82}],573:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MDFileVerListPanelView = _interopRequireDefault(require(583));
var _MDNavigationPageView = _interopRequireDefault(require(56));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDEvents = _interopRequireDefault(require(325));
var _MDFileOperationManager = _interopRequireDefault(require(326));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDFileLogWindowView = _interopRequireDefault(require(576));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDEditalbeTextDiv = _interopRequireDefault(require(29));
var _MDAddTagWindow = _interopRequireDefault(require(785));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDDepFilePermissionWinView = _interopRequireDefault(require(565));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDFileInforDetailTabPanelView = _interopRequireDefault(require(572));
var _MDFileReviewDetailTabPanelView = _interopRequireDefault(require(580));
var _MDTabView = _interopRequireDefault(require(82));
var _MDMainPanelMsgPanelView = _interopRequireDefault(require(589));
/**
 *  File information panel view
 *  Created by manjun.han
 *  2015.9.2
 */

var MDFileInforPanelView = _MDNavigationPageView["default"].extend({
  contentTmpl: "<div class=\"info-content\">\n    </div>",
  className: function className() {
    var superCls = _MDNavigationPageView["default"].prototype.className.call(this);
    return superCls + ' m-fileDetail';
  },
  initialize: function initialize(opt) {
    opt.showNavigationBar = false;
    _MDNavigationPageView["default"].prototype.initialize.call(this, opt);
    this.fileInfoTabPanel = new _MDFileInforDetailTabPanelView["default"](opt);
    this.fileReviewTabPanel = new _MDFileReviewDetailTabPanelView["default"]();
    this.msgPanelView = new _MDMainPanelMsgPanelView["default"]();
    this.fileVerList = new _MDFileVerListPanelView["default"]({
      fileInfor: this.fileInfor,
      fileVersionRouterCb: this.fileVersionRouterCb,
      showDispMark: this.showDispMark,
      dispVer: this.dispVer,
      updateDisVerAfterDel: this.updateDisVerAfterDel,
      enableRouterNavigation: this.enableRouterNavigation,
      enableOpenVersion: this.enableOpenVersion
    });
    this.personTabView = new _MDTabView["default"]({
      className: 'person-tabs blue-style-tab1',
      tabBarDividerPosition: 2,
      fullMode: false,
      enableActivebar: false,
      curIndex: this.activeIndex,
      tabs: [{
        title: BabelStr.str(185),
        //讨论组
        tabPanelView: this.msgPanelView
      }, {
        title: BabelStr.str(14),
        tabPanelView: this.fileInfoTabPanel
      }, {
        title: BabelStr.str(128),
        tabPanelView: this.fileReviewTabPanel
      }, {
        title: BabelStr.str(282),
        tabPanelView: this.fileVerList
      }]
    });
    this.addSubView(this.personTabView, this.$('.info-content')[0]);
  },
  setMultFile: function setMultFile() {
    this.personTabView.setTabVisible(0, false);
    var versionViewIndex = this.personTabView.getSubViewIndex(this.fileVerList);
    var filereviewIndex = this.personTabView.getSubViewIndex(this.fileReviewTabPanel);
    var msgViewIndex = this.personTabView.getSubViewIndex(this.msgPanelView);
    this.personTabView.setTabEnabledAt(versionViewIndex);
    this.personTabView.setTabEnabledAt(filereviewIndex);
    this.personTabView.setTabEnabledAt(msgViewIndex);
  },
  getActiveIndex: function getActiveIndex() {
    return this.personTabView.getActiveIndex();
  },
  setActiveIndex: function setActiveIndex(activeIndex) {
    if (activeIndex == 0) {
      this.personTabView.hideTabHead();
    } else {
      this.personTabView.showTabHead();
    }
    this.personTabView.activeTabAt(activeIndex);
  },
  initProps: function initProps() {
    var superP = _MDNavigationPageView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      focusCollection: new _MDMolaUserCollection["default"](),
      activeIndex: 0
    });
  },
  events: function events() {
    var superE = _MDNavigationPageView["default"].prototype.events.call(this);
    return _.extend(superE, {});
  },
  render: function render(data) {
    var self = this;
    var f = this.fileInfor;
    if (!f) {
      return;
    }
  },
  setFileInfor: function setFileInfor(fileInfor, activeIndex) {
    if (!fileInfor) {
      return;
    }
    this.fileInfor = fileInfor;
    this.fileInfoTabPanel.setFileInfor(fileInfor);
    this.fileReviewTabPanel.setFileInfo(fileInfor);
    this.fileVerList.setFileInfor(fileInfor);
    var versionViewIndex = this.personTabView.getSubViewIndex(this.fileVerList);
    var fileInfoViewIndex = this.personTabView.getSubViewIndex(this.fileInfoTabPanel);
    var filereviewIndex = this.personTabView.getSubViewIndex(this.fileReviewTabPanel);
    var msgViewIndex = this.personTabView.getSubViewIndex(this.msgPanelView);
    // (!isFolder && !linkedFile
    this.personTabView.setTabVisible(0, false);
    if (this.fileInfor.isTeamFolder() || this.fileInfor.isProject() || app.pathRouter && (app.pathRouter.getTeamByPathFromFile(this.fileInfor) || app.pathRouter.getProjectByPathFromFile(this.fileInfor))) {
      if (app.ep.isArchive()) {
        this.personTabView.setTabEnabledAt(msgViewIndex, false);
        this.personTabView.showTabHead();
        activeIndex = _.isUndefined(activeIndex) ? fileInfoViewIndex : activeIndex;
      } else {
        var file = app.pathRoute && app.pathRouter.getTeamByPathFromFile(this.fileInfor) || app.pathRoute && app.pathRouter.getProjectByPathFromFile(this.fileInfor) || this.fileInfor;
        if (!file.get("applyForTeamOrProj") && activeIndex === msgViewIndex) {
          this.msgPanelView.setFileInfor(fileInfor);
          this.personTabView.setTabEnabledAt(msgViewIndex, true);
          this.personTabView.hideTabHead();
          activeIndex = _.isUndefined(activeIndex) ? msgViewIndex : activeIndex;
        } else {
          this.personTabView.setTabEnabledAt(msgViewIndex, false);
          this.personTabView.showTabHead();
          activeIndex = _.isUndefined(activeIndex) ? fileInfoViewIndex : activeIndex;
        }
      }
    } else {
      this.personTabView.setTabEnabledAt(msgViewIndex, false);
      this.personTabView.showTabHead();
      if (activeIndex === 0) {
        activeIndex = 1;
      }
      // if(this.personTabView.activeIndex == msgViewIndex) {
      activeIndex = _.isUndefined(activeIndex) ? fileInfoViewIndex : activeIndex;
      // }
    }
    if (fileInfor.isFolder() || fileInfor.isShortcuts() || !fileInfor.canUploadVersionOnlyActions()) {
      this.personTabView.setTabEnabledAt(versionViewIndex, false);
      activeIndex = activeIndex == versionViewIndex ? fileInfoViewIndex : activeIndex;
    } else {
      this.personTabView.setTabEnabledAt(versionViewIndex, true);
      // this.personTabView.activeTabAt(fileInfoViewIndex);
    }
    this.personTabView.activeTabAt(activeIndex);
    if (!fileInfor.canReadComment() || fileInfor.getFileId() == 0 || app.pathRouter && app.pathRouter.inTrash() || app.currentUser.isAnonymous() || fileInfor.isMultFile()) {
      this.personTabView.setTabEnabledAt(filereviewIndex, false);
      this.personTabView.activeTabAt(fileInfoViewIndex);
      // this.personTabView.activeTabAt(0);
    } else {
      this.personTabView.setTabEnabledAt(filereviewIndex, true);
    }
    if (app.pathRouter && app.pathRouter.isInRoot() && fileInfor.isDepartmentFolder() && !fileInfor.canCreateFolderDir()) {
      _MMNetDiskDataController["default"].getFileInfoFromServer(fileInfor.getFileId(), function (res) {
        console.warn(res.canCreateFolderDir());
        fileInfor.setActions(res.getActions());
      }, function () {});
    }
  },
  lookHistory: function lookHistory() {
    this.personTabView.activeTabAt(2);
  },
  displayFileLogClickHandle: function displayFileLogClickHandle() {
    this.filelogView = new _MDFileLogWindowView["default"]({
      fileInfor: this.fileInfor
    });
    this.filelogView.show();
  },
  setEnableOpenVersion: function setEnableOpenVersion(enabled) {
    this.enableOpenVersion = enabled;
    this.fileVerList && this.fileVerList.setEnableOpenVersion(enabled);
  },
  setEnableRouterNavigation: function setEnableRouterNavigation(enabled) {
    this.enableRouterNavigation = enabled;
    this.fileVerList && this.fileVerList.setEnableRouterNavigation(enabled);
  }
});
var _default = exports["default"] = MDFileInforPanelView;

},{"1104":1104,"1150":1150,"1184":1184,"1454":1454,"18":18,"273":273,"29":29,"32":32,"325":325,"326":326,"56":56,"565":565,"572":572,"576":576,"580":580,"583":583,"589":589,"67":67,"72":72,"76":76,"785":785,"82":82}],589:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
var _MDMsgMainPanelView = _interopRequireDefault(require(725));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 * 	文件详情处的团队/项目讨论
 *  Created by jichao
 *  2015.11.18
 */
var MDMainPanelMsgPanelView = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(MDMainPanelMsgPanelView, _MDTabPanelView);
  function MDMainPanelMsgPanelView() {
    (0, _classCallCheck2["default"])(this, MDMainPanelMsgPanelView);
    return _callSuper(this, MDMainPanelMsgPanelView, arguments);
  }
  (0, _createClass2["default"])(MDMainPanelMsgPanelView, [{
    key: "initialize",
    value: function initialize(opt) {
      this.msgMainView = new _MDMsgMainPanelView["default"]();
      this.addSubView(this.msgMainView);
    }
  }, {
    key: "setFileInfor",
    value: function setFileInfor(fileInfor) {
      var file = null;
      if (app.pathRouter) {
        file = app.pathRouter.getTeamByPathFromFile(fileInfor) || app.pathRouter.getProjectByPathFromFile(fileInfor) || fileInfor;
      }
      this.msgMainView.setFileInfo(file);
    }
  }]);
  return MDMainPanelMsgPanelView;
}(_MDTabPanelView2["default"]);

},{"1175":1175,"1179":1179,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"725":725,"81":81}],725:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1439);
require(1466);
var _MMViewBase = _interopRequireDefault(require(22));
var _MDMsgInputFooterView = _interopRequireDefault(require(722));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDConversationParticipantListView = _interopRequireDefault(require(718));
var _MDMessageFileInfoRowView = _interopRequireDefault(require(720));
var _MDPCDisplayFileController = _interopRequireDefault(require(422));
var _MDAddTeamMemberWindowView = _interopRequireDefault(require(476));
var _MDMsgListView = _interopRequireDefault(require(724));
var _MDTransformFileUpload = _interopRequireDefault(require(340));
var _MDTransferFileItemView = _interopRequireDefault(require(727));
var _MDSnackbarView = _interopRequireDefault(require(72));
/**
 * Class description here
 * Created by author's name
 * date here(2015.6.24)
 */

var MDMsgMainPanelView = _MMViewBase["default"].extend({
  el: '<div class="g-main g-msgMain"></div>',
  tmpl: '<div class="shareFile-root">' + '<div class="m-table m-fileTable">' + '<div class="table-body"><div class="table-content"></div></div>' + "</div>" + "</div>" + '<div id="invite-participant" title="' + BabelStr.str(7307) + '"><div class="icon"></div></div>',
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      fileInfo: null
    });
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      "click #invite-participant": this.invitePerson
    });
  },
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.initFileUpload();
    this.msgInputFooterView = new _MDMsgInputFooterView["default"]({
      fileInfo: this.fileInfo,
      onFileUploadAction: function onFileUploadAction() {
        _MDTransformFileUpload["default"].browserFiles();
      },
      onPasteFileUploadAction: function onPasteFileUploadAction(file) {
        _MDTransformFileUpload["default"].pasteFiles(file);
      }
    });
    this.addSubView(this.msgInputFooterView);
    this.msgListView = new _MDMsgListView["default"]({
      fileInfo: this.fileInfo,
      displayController: _MDPCDisplayFileController["default"].getSingleton()
    });
    this.addSubView(this.msgListView);
    this.cvstParticipantListView = new _MDConversationParticipantListView["default"]({
      fileInfo: this.fileInfo
    });
    this.addSubView(this.cvstParticipantListView);
    this.$inviteParticipant = this.$("#invite-participant");
  },
  initFileUpload: function initFileUpload() {
    var self = this;
    _MDTransformFileUpload["default"].initialize({
      fieldName: "transferFile",
      uploadURL: "/netdrive/uploadTransferFile.do",
      onFileAdd: function onFileAdd(e, data) {
        var uploadFileItemView = new _MDTransferFileItemView["default"]({
          fileName: data.files[0].name,
          fileSize: data.files[0].size,
          uploadingMode: true,
          fileId: self.fileInfo.getFileId(),
          inDepConversation: app.isEpVersion()
        });
        uploadFileItemView.setUploader(data);
        _MDTransformFileUpload["default"].setOtherParams({
          uploadFileItemView: uploadFileItemView
        });
        self.msgListView.appendTransformFileItem(uploadFileItemView);
      },
      onFail: function onFail(e, data, otherParams) {
        console.error(e);
        console.error(data);
        var result = data.result;
        if (result.code == "10006") {
          result["msg"] = BabelStr.str(5558);
        }
        _MDSnackbarView["default"].show(result["msg"]);
        otherParams.uploadFileItemView.superView.remove();
      },
      onProgress: function onProgress(e, data) {
        var uploadFileItemView = data.view;
        var progress = parseInt(data.loaded / data.total * 100, 10);
        uploadFileItemView.setProgress(progress);
      },
      onGetParam: function onGetParam(file) {
        return {
          fileId: self.fileInfo.getFileId(),
          fileName: file.name,
          inDepConversation: app.isEpVersion() ? 1 : 0
        };
      },
      onUploadSuccess: function onUploadSuccess(result, data) {
        var uploadFileItemView = data.view;
        var fileRefId = result["fileRefId"];
        var fileName = data.files[0].name;
        var fileSize = data.files[0].size;
        var fileId = self.fileInfo.getFileId();
        uploadFileItemView.setUploadComplete(fileRefId, function () {
          var msgContent = {
            fileName: fileName,
            fileSize: fileSize,
            fileRefId: fileRefId,
            fileId: fileId
          };
          var text = JSON.stringify(msgContent);
          var message = JSON.stringify({
            Type: "File",
            Body: text,
            pageIndex: -1
          });
          function deleteFileIfFailed() {
            $.ajax({
              url: "/netdrive/deleteTransferFile.do",
              method: "post",
              data: {
                fileRefId: fileRefId
              }
            });
            _MDSnackbarView["default"].show(BabelStr.str(464));
          }
          if (app.isEpVersion()) {
            if (self.fileInfo.isProject()) {
              _MMNetDiskDataController["default"].sendProjectChatMessage(fileId, message, _.noop, function () {
                deleteFileIfFailed();
              });
            } else {
              _MMNetDiskDataController["default"].sendDepChatMessage(fileId, message, _.noop, function () {
                deleteFileIfFailed();
              });
            }
          } else {
            _MMNetDiskDataController["default"].sendFileMessage(fileId, message, _.noop, function () {
              deleteFileIfFailed();
            });
          }
        });
      }
    });
  },
  /**
   * @param info {MMFileInfo}
   */
  setFileInfo: function setFileInfo(info, conversitionCollection, callback) {
    if (info == this.fileInfo) {
      return;
    }
    this.fileInfo = info;
    this.msgListView.setFileInfo(info, conversitionCollection, function () {
      if (callback) {
        callback();
      }
    });
    this.msgInputFooterView.setFileInfo(info);
    this.cvstParticipantListView.setFileInfo(info);
    if (info) {
      _MMNetDiskDataController["default"].touchFile(info.getFileId());
    }
    this._displayFileInfo();
    this._displayInvitePrticipant();
    if (this.fileInfo && this.fileInfo.isHQSMProject()) {
      this.$inviteParticipant.addClass("f-hide");
    } else {
      this.$inviteParticipant.removeClass("f-hide");
    }
  },
  _displayFileInfo: function _displayFileInfo() {
    if (this.rowView) {
      this.rowView.removeFromSuperView();
      this.rowView = null;
    }
    if (this.fileInfo) {
      var rowView = new _MDMessageFileInfoRowView["default"]({
        rowModel: this.fileInfo
      });
      this.rowView = rowView;
      this.addSubView(this.rowView, this.$(".table-content")[0]);
    }
  },
  invitePerson: function invitePerson(e) {
    if (this.fileInfo.isTeamFolder() && this.fileInfo.canManageShareMember()) {
      this._openTeamManageView();
    }
  },
  _displayInvitePrticipant: function _displayInvitePrticipant() {
    var self = this;
    var top = 0;
    var show = true;
    if (this.fileInfo) {
      if (this.fileInfo.isTeamFolder()) {
        if (this.fileInfo.canManageShareMember()) {
          top = 56;
          show = true;
        } else {
          top = 0;
          show = false;
        }
      } else if (this.fileInfo.isProject()) {
        show = false;
      } else {
        if (this.fileInfo.isOwner()) {
          show = true;
          top = 56;
        } else {
          show = false;
          top = 0;
        }
      }
    } else {
      top = 0;
      show = false;
    }
    if (app.pathRouter.inFile()) {
      top = 0;
      show = false;
    }
    show ? this.$inviteParticipant.show() : this.$inviteParticipant.hide();
    this.cvstParticipantListView.$el.css("top", top);
  },
  _openTeamManageView: function _openTeamManageView() {
    var teamInfo = this.fileInfo.getTeamInfo();
    var addWin = new _MDAddTeamMemberWindowView["default"]({
      teamId: teamInfo.getId()
    });
    addWin.show();
  }
});
var _default = exports["default"] = MDMsgMainPanelView;

},{"1104":1104,"1184":1184,"1439":1439,"1454":1454,"1466":1466,"22":22,"340":340,"422":422,"476":476,"718":718,"72":72,"720":720,"722":722,"724":724,"727":727}],724:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1437);
require(1421);
require(1432);
var _MMViewBase = _interopRequireDefault(require(22));
var _MDSpacerView = _interopRequireDefault(require(726));
var _MDMsgItemView = _interopRequireDefault(require(723));
var _MDLoadmoreIndicatorView = _interopRequireDefault(require(74));
var _MDCreateTeamWindowView = _interopRequireDefault(require(744));
var _MDMessageType = _interopRequireDefault(require(271));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDMessage = _interopRequireDefault(require(270));
/**
 * Class description here
 * Created by Tobias
 * date here(2015.6.24)
 */

var MDMsgListView = _MMViewBase["default"].extend({
  tmpl: '<div class="more-placeholder"></div>' + '<ul class="g-msgList"></ul>',
  teamEmptyTmpl: function teamEmptyTmpl() {
    var isMobile = app.isMobile();
    var data = {
      'isMobile': isMobile,
      'teamTitle': BabelStr.str(546),
      // 团队讨论是以团队为单位的群组，在这里大家可以展开讨论，协同工作。
      'createTeam': BabelStr.str(547),
      // 新建团队
      'empty': BabelStr.str(548) // 提示: 部门消息为空。
    };
    var tmpl = "<div class=\"emptyMessage\">\n         <div class=\"blank\">\n            <img src=\"/img/mdisk/chat_blank.png\" srcset=\"img/mdisk/chat_blank.png 1x, img/mdisk/chat_blank@2x.png 2x\"/>\n            <div class=\"help-block\">\n              <p><%=teamTitle%></p>\n              \n            </div>\n        </div>\n      </div>";
    return _.template(tmpl)(data);
  },
  departEmptyTmpl: "<div class=\"emptyMessage\">\n      <div class=\"blank\">\n        <img src=\"/img/mdisk/chat_blank.png\" srcset=\"img/mdisk/chat_blank.png 1x, img/mdisk/chat_blank@2x.png 2x\"/>\n        <div class=\"help-block\">\n          <p>".concat(BabelStr.str(2622), "</p>\n        </div>\n      </div>\n    </div>"),
  projectEmptyTmpl: function projectEmptyTmpl(name) {
    return "<div class=\"emptyMessage\">\n      <div class=\"blank\">\n        <img src=\"/img/mdisk/chat_blank.png\" srcset=\"img/mdisk/chat_blank.png 1x, img/mdisk/chat_blank@2x.png 2x\"/>\n        <div class=\"help-block\">\n          <p><span>".concat(name, "</span>").concat(BabelStr.str(6139), "</p>\n        </div>\n      </div>\n    </div>");
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click .create-team': this._createTeamHandler,
      'scroll': this._onScrollHandler
    });
  },
  className: function className() {
    var superCls = _MMViewBase["default"].prototype.className.call(this);
    return superCls + 'm-msgList-container';
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      pageSize: 15,
      $emptyMessage: null,
      displayController: null,
      $morePlaceHolder: null,
      $list: null,
      messageList: [],
      // 消息按照时间的倒叙排序由远及近

      data: {
        'teamTitle': BabelStr.str(546),
        // 团队讨论是以团队为单位的群组，在这里大家可以展开讨论，协同工作。
        'createTeam': BabelStr.str(547),
        // 新建团队
        'empty': BabelStr.str(548) // 提示: 部门消息为空。
      }
    });
  },
  render: function render(data) {
    data = {
      'teamTitle': BabelStr.str(546),
      // 团队讨论是以团队为单位的群组，在这里大家可以展开讨论，协同工作。
      'createTeam': BabelStr.str(547),
      // 新建团队
      'empty': BabelStr.str(548) // 提示: 部门消息为空。
    };
    _MMViewBase["default"].prototype.render.call(this, data);
  },
  initialize: function initialize(opt) {
    var self = this;
    var isEpVersion = app.isEpVersion();
    var guest = app.currentUser.get('guest');
    var isGuest = guest === 1;
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.$list = this.$('.g-msgList');
    this.$morePlaceHolder = this.$('.more-placeholder');
    Dispatcher.on(MDEvents.NewMsgReceived, this._newMessageHandler, this);
    this.loadMoreIndicatorView = new _MDLoadmoreIndicatorView["default"]({
      onLoadMore: function onLoadMore() {
        self.requestMoreMsg(false);
      }
    });
    this.addSubView(this.loadMoreIndicatorView, this.$morePlaceHolder[0]);
    // this.loadMoreIndicatorView.setLoadingState(true);
  },
  _createTeamHandler: function _createTeamHandler($e) {
    var teamWin = new _MDCreateTeamWindowView["default"]();
    teamWin.show();
    return false;
  },
  _newMessageHandler: function _newMessageHandler(shareId, messageModel) {
    if (!messageModel.isConversition()) {
      return;
    }
    if (messageModel.get('senderId') == app.currentUser.getUserId() && !messageModel.get('tempId')) {
      return;
    }
    ;
    var msgType = messageModel.get('type');
    var senderId = messageModel.get('senderId');
    //
    // 过滤文件消息
    //
    if (_MDMessageType["default"].CHAT == msgType) {
      this.$emptyMessage && this.$emptyMessage.hide();
      var msgModel = messageModel.get('msg');
      var chatMessageType = msgModel.get('Type');
      if (chatMessageType == 'File' && senderId == app.currentUser.getUserId()) {
        return;
      }
    }
    var msgFileId = messageModel.get("fileId");
    if (this.fileInfo && msgFileId == this.fileInfo.get("fileId")) {
      var preMessage = this.messageList && this.messageList[0]; // 最新的消息在最显示列表的最下面
      this.messageList.unshift(messageModel); // 插入到最后一个记录
      _MMNetDiskDataController["default"].touchFile(msgFileId);
      this.addMessage(messageModel, preMessage, false);
      this.$emptyMessage && this.$emptyMessage.hide();
      this.scrollToBottom();
    }
  },
  setFileInfo: function setFileInfo(info, conversitionCollection, callback) {
    this.loadMoreIndicatorView.setLoadingState(true);
    var self = this;
    this.fileInfo = info;
    if (this.fileInfo && this.fileInfo.isTeamFolder()) {
      this.$emptyMessage = $(this.teamEmptyTmpl());
    } else if (this.fileInfo && this.fileInfo.isProject()) {
      this.$emptyMessage = $(this.projectEmptyTmpl(this.fileInfo.getFileName()));
    } else {
      this.$emptyMessage = $(this.departEmptyTmpl);
    }
    this.conversitionCollection = conversitionCollection;
    this.messageList = [];
    this.$list.html("");
    if (this.fileInfo) {
      this.requestMoreMsg(true, callback);
    } else {
      this._controlUIState([], false);
    }
  },
  _appendMessageList: function _appendMessageList(newMessageList) {
    var self = this;
    var preMessage = this.messageList && this.messageList[this.messageList.length - 1];
    this.messageList.push.apply(this.messageList, newMessageList);
    _.each(newMessageList, function (message, index) {
      self.addMessage(message, preMessage, true);
      preMessage = message;
    });
  },
  /**
   * 添加一条消息
   * @param {Backbone.Model} message         消息对象
   * @param {Backbone.Model} relativeMessage 当前被插入消息的上一条消息
   * @param {Boolean} insertEarly     是否是插入早期的消息， 如果是true，relativeMessage的时间会比message的时间早
   */
  addMessage: function addMessage(message, relativeMessage, insertEarly) {
    var self = this;
    var msgDay = message.get("time").format("yyyy-MM-dd");
    var relativeDay = relativeMessage && relativeMessage.get("time").format("yyyy-MM-dd");
    var msgItem = new _MDMsgItemView["default"]({
      info: message,
      fileInfo: this.fileInfo,
      displayController: this.displayController
    });
    // 添加更早时间的message
    if (insertEarly) {
      if (relativeDay && relativeDay == msgDay) {
        this.addSubView(msgItem, function (msgItemEl) {
          var firstItem = self.$list.children('li')[0];
          $(firstItem).after(msgItemEl);
        });
      } else {
        this.addSubView(msgItem, function (msgItemEl) {
          self.$list.prepend(msgItemEl);
        });

        // add date spacer view
        var dayItem = new _MDSpacerView["default"]({
          text: msgDay,
          fileInfo: this.fileInfo
        });
        this.$list.prepend(dayItem.el);
      }
      this.$el[0].scrollTop = 0;
      // 添加最新的消息
    } else {
      if (relativeDay !== msgDay) {
        var spaceView = new _MDSpacerView["default"]({
          text: msgDay,
          fileInfo: this.fileInfo
        });
        this.$list.append(spaceView.el);
      }
      this.addSubView(msgItem, function (msgItemEl) {
        self.$list.append(msgItemEl);
      });
      this.scrollToBottom();
    }
  },
  _controlUIState: function _controlUIState(list, scrollToBottom) {
    var self = this;
    if (self.messageList.length == 0) {
      self.loadMoreIndicatorView.hide();
      if (!this.conversitionCollection || this.conversitionCollection.length == 0) {
        self.$emptyMessage.appendTo(this.$list).show();
      }
    } else if (list.length < self.pageSize) {
      self.loadMoreIndicatorView.hide();
    } else {
      self.loadMoreIndicatorView.setLoadingState(false);
    }
    if (scrollToBottom) {
      self.scrollToBottom();
    } else {
      self.scrollToLastViewedMessage();
    }
  },
  requestMoreMsg: function requestMoreMsg(scrollToBottom, callback) {
    var self = this;
    var sharedId = this.fileInfo.get("fileId");
    var startId = 0;
    if (this.messageList && this.messageList.length > 0) {
      startId = this.messageList[this.messageList.length - 1].get('messageId');
    }
    self.loadMoreIndicatorView.show();
    this.loadMoreIndicatorView.setLoadingState(true);
    this.preScrollHeight = this.$el[0].scrollHeight;
    if (this.fileInfo.isDepartmentFolder()) {
      _MMNetDiskDataController["default"].getDepartmentMessages(sharedId, startId, this.pageSize, function success(list) {
        self._appendMessageList(list);
        self._controlUIState(list, scrollToBottom);
        if (callback) {
          callback();
        }
        ;
      }, function fail() {
        if (callback) {
          callback();
        }
        ;
        self.loadMoreIndicatorView.setLoadingState(false);
      });
    } else {
      _MMNetDiskDataController["default"].getFileMessages(sharedId, startId, this.pageSize, function success(list) {
        self._appendMessageList(list);
        self._controlUIState(list, scrollToBottom);
        if (callback) {
          callback();
        }
        ;
      }, function fail() {
        if (callback) {
          callback();
        }
        ;
        self.loadMoreIndicatorView.setLoadingState(false);
      });
    }
  },
  scrollToBottom: function scrollToBottom() {
    this.$el.scrollTop(this.$el[0].scrollHeight);
  },
  scrollToLastViewedMessage: function scrollToLastViewedMessage(msgItemEl) {
    var delta = this.el.scrollHeight - this.preScrollHeight;
    this.$el.scrollTop(delta);
  },
  _onScrollHandler: function _onScrollHandler($e) {
    var self = this;
    var scrollTop = self.$el.scrollTop();
    if (scrollTop < 10) {
      self.loadMoreIndicatorView.triggerLoad();
    }
  },
  /**
   * @public
   * @param {MDTransferFileItemView} transferItemView - 上传文件视图
   */
  appendTransformFileItem: function appendTransformFileItem(transferItemView) {
    var self = this;
    var messageModel = new _MDMessage["default"]({
      type: _MDMessageType["default"].CHAT,
      senderName: app.currentUser.getUserName(),
      senderId: app.currentUser.getUserId(),
      msg: new Backbone.Model({
        'Type': 'File',
        'uploadingMode': true,
        Body: {
          fileId: transferItemView.fileid,
          fileName: transferItemView.fileName
        }
      }),
      'time': new Date()
    });
    this.messageList.unshift(messageModel); // 插入到最后一个记录
    var messageView = new _MDMsgItemView["default"]({
      info: messageModel,
      fileInfo: this.fileInfo
    });
    this.$emptyMessage.hide();
    this.addSubView(messageView, function (el) {
      self.$('.g-msgList').append(el);
    });
    function failUpload() {
      var index = _.indexOf(self.messageList, messageModel);
      if (index > -1) {
        self.messageList.splice(index, 1);
        messageView.removeFromSuperView();
      }
    }
    transferItemView.setOnAbort(failUpload);
    transferItemView.setOnFail(function () {
      _MDSnackbarView["default"].show(BabelStr.str(5155));
      failUpload();
    });
    messageView.appendTransformFileView(transferItemView);
    this.scrollToBottom();
  }
});
var _default = exports["default"] = MDMsgListView;

},{"1104":1104,"1184":1184,"1412":1412,"1421":1421,"1432":1432,"1437":1437,"1454":1454,"22":22,"270":270,"271":271,"72":72,"723":723,"726":726,"74":74,"744":744}],726:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMViewBase = _interopRequireDefault(require(22));
/**
 * Class description here
 * Created by dai
 * date here(2017.4.5)
 */

var MDSpacerView = _MMViewBase["default"].extend({
  el: '<li class="spacer"></li>',
  tmpl: '<div class="timespacer"><span><%=text%></span></div>',
  initialize: function initialize(opt) {
    opt = _.extend({}, opt);
    opt.data = {
      'text': opt.text
    };
    _MMViewBase["default"].prototype.initialize.call(this, opt);
  }
});
var _default = exports["default"] = MDSpacerView;

},{"1184":1184,"1454":1454,"22":22}],723:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1477);
require(1492);
require(1461);
require(1417);
require(1463);
require(1439);
require(1424);
require(1426);
require(1466);
var _typeof2 = _interopRequireDefault(require(1197));
var _MMViewBase = _interopRequireDefault(require(22));
var _utils = _interopRequireDefault(require(108));
var _MDMessageType = _interopRequireDefault(require(271));
var _link = _interopRequireDefault(require(347));
var _MMFileType = _interopRequireDefault(require(303));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDTransferFileItemView = _interopRequireDefault(require(727));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDAudioPlayer = _interopRequireDefault(require(313));
/*jslint browser: true, nomen: true, vars: true*/
/*global goog, MMViewBase, _, $, console, app, MMNetDiskDataController*/
/**
 * Class show one message, good for a chatList, desinged for the MDMsgListView
 * Created by Tobias
 * date here(2015.-9.24)
 */

var MDMsgItemView = _MMViewBase["default"].extend({
  el: '<li class="g-msgItem"></li>',
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      "click .chat-click": this.handleMessageClick,
      "click .sys-parentFolder": this.handleParentClick
    });
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      /**
       * @type {MDMessage}
       */
      info: null,
      fileInfo: null,
      displayController: null
    });
  },
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this._initElements();
  },
  handleParentClick: function handleParentClick(e) {
    var shareId = this.fileInfo.get('fileId');
    var fileId = this.info.get("msg").get('fileId');
    var msgType = this.info.get("type");
    var tempId = this.info.get('tempId');
    var parentId = '0';

    // 分享的创建者
    if (app.currentUser.isFileOwner(this.fileInfo.getOwnerId())) {
      parentId = this.info.get('msg').get('parentId');
    }
    // 分享的参与者
    else if (shareId != fileId) {
      // 如果分享的是文件夹
      parentId = this.info.get('msg').get('parentId');
      if (!parentId) {
        parentId = this.info.get('msg').get('destId');
      }
    }
    if (msgType == _MDMessageType["default"].MOVE_IN) {
      parentId = this.info.get('msg').get('destId');
    }
    if (parentId == 0) {
      app.pathRouter.navigate("", {
        trigger: true
      });
    } else {
      _MMNetDiskDataController["default"].getFileInfosFromServer([parentId], true, function succeess(fileInfors) {
        var fileInfor = fileInfors[0];
        if (!fileInfor) {
          _MDAlertView["default"].showAlert(BabelStr.str(549)); // ('文件不存在！');
          return;
        } else if (fileInfor.isInTrash()) {
          _MDAlertView["default"].showAlert(BabelStr.str(550)); // ('文件夹在回收站中，不能打开！');
          return;
        } else if (!fileInfor.canRead()) {
          _MDAlertView["default"].showAlert(BabelStr.str(551)); // ('文件不存在，可能已经被移走！');
          return;
        }
        app.pathRouter.navigate("file/" + parentId, {
          trigger: true,
          replace: false
        });
      }, function fail() {
        _MDAlertView["default"].showAlert(BabelStr.str(552)); // ('文件已被删除！');
      });
    }
  },
  handleMessageClick: function handleMessageClick(e) {
    var self = this;
    var msgType = this.info.get("type");
    var fileId = this.info.get("msg").get('fileId');
    var shareId = this.fileInfo.get('fileId');
    var version = this.info.get("msg").get('fileVersion');
    var parentFolderId;
    if (version == undefined) {
      version = -1;
    }
    ;
    if (msgType == _MDMessageType["default"].DELETE) {
      fileId = this.info.get('msg').get('parentId');
    }
    _MMNetDiskDataController["default"].getFileInfosFromServer([fileId], false, function succeess(fileInfors) {
      var fileInfor = fileInfors[0];
      if (!fileInfor) {
        _MDAlertView["default"].showAlert(BabelStr.str(549)); //('文件不存在！');
        return;
      } else if (fileInfor.isInTrash()) {
        _MDAlertView["default"].showAlert(BabelStr.str(550)); // ('文件在回收站中，不能打开！');
        return;
      }
      if (fileInfor.isFolder()) {
        app.pathRouter.navigate("file/" + fileId, {
          trigger: true
        });
      } else if (fileInfor.canDispInEditor()) {
        if (msgType == _MDMessageType["default"].MOVE_OUT) {
          parentFolderId = fileInfor.get("parentId");
          app.pathRouter.navigate("file/" + parentFolderId, {
            trigger: true
          });
        } else {
          var checkParam = {
            fileInfo: fileInfor
          };
          self.displayController.checkToAlertCannotDisp(checkParam, function (canOpen) {
            if (!canOpen) {
              return;
            }
            self.displayController.openFileWithoutRouter(fileInfor, version);
          });
        }
      }
      // else if (fileInfor.isVideo()) {
      //   var vPlayerWin = new MDVideoPlayerWin();
      //   vPlayerWin.setFileInfo(fileInfor);
      //   vPlayerWin.show();
      // } else if (fileInfor.isAudio()) {
      //   var aPlayerWin = MDAudioPlayerWin.getInstance();
      //   aPlayerWin.setFileInfo(fileInfor);
      // }
      else {
        parentFolderId = fileInfor.get("parentId");
        app.pathRouter.navigate("file/" + parentFolderId, {
          trigger: true
        });
      }
    }, function fail() {
      _MDAlertView["default"].showAlert(BabelStr.str(552)); // ('文件已被删除！');
    });
  },
  _initElements: function _initElements() {
    this.$msgRoot = $('<div></div>');
    this.$el.append(this.$msgRoot);
    var msg = this.info.get("msg");
    var msgType = this.info.get("type");
    if (msgType == _MDMessageType["default"].CHAT) {
      this.$msgRoot.attr("class", "msgRoot");
      this.$iconGap = $('<div class="iconGap">');
      this.$msgRoot.append(this.$iconGap);
      this.$contentArea = $('<div class="contentArea">');
    } else if (msgType == _MDMessageType["default"].COMMENT_CHAT) {
      this.$msgRoot.attr("class", "sysMsgRoot");
      this.$iconGap = $('<div class="icon comment-iconGap">');
      this.$msgRoot.append(this.$iconGap);
      this.$contentArea = $('<div class="sys-contentArea">');
    } else if (msgType == _MDMessageType["default"].DEPARTMENT_REMOVE) {
      return;
    } else {
      this.$msgRoot.attr("class", "sysMsgRoot");
      this.$iconGap = $('<div class="icon sys-iconGap">');
      this.$msgRoot.append(this.$iconGap);
      this.$contentArea = $('<div class="sys-contentArea">');
    }
    this.$msgRoot.append(this.$contentArea);
    switch (msgType) {
      case _MDMessageType["default"].CHAT:
        this.initChatMessage(msg);
        break;
      case _MDMessageType["default"].CREATE:
        this.initCreateMessage(msg);
        break;
      case _MDMessageType["default"].NEW_VERSION:
        this.initUploadMessage(msg);
        break;
      case _MDMessageType["default"].RENAME:
        this.initRenameMessage(msg);
        break;
      case _MDMessageType["default"].RESTORE:
        this.initRestoreMessage(msg);
        break;
      case _MDMessageType["default"].MOVE:
        this.initMoveMessage(msg);
        break;
      case _MDMessageType["default"].DELETE:
        this.initDeleteMessage(msg);
        break;
      case _MDMessageType["default"].MOVE_IN:
        this.initMoveInMessage(msg);
        break;
      case _MDMessageType["default"].MOVE_OUT:
        this.initMoveOutMessage(msg);
        break;
      case _MDMessageType["default"].SET_CURRENT_VERSION:
        this.initSetCurrentVersionMessage(msg);
        break;
      case _MDMessageType["default"].JOIN_SHARE:
        this.initJoinMessage(msg);
        break;
      case _MDMessageType["default"].JOIN_PROJECT:
        this.initJoinProjectMessage(msg);
        break;
      case _MDMessageType["default"].LEAVE_SHARE:
        this.initLeaveMessage(msg);
        break;
      case _MDMessageType["default"].SHARE:
        this.initShareMessage(msg);
        break;
      case _MDMessageType["default"].STOP_SHARE:
        this.initStopShareMessage(msg);
        break;
      case _MDMessageType["default"].SET_SHARE_DEFAULT_ROLE:
        this.initSetShareRoleMessage(msg);
        break;
      case _MDMessageType["default"].SET_USER_ROLE:
        this.initSetUserShareRoleMessage(msg, false);
        break;
      case _MDMessageType["default"].INVITATION:
        this.initInvitationMessage(msg);
        break;
      case _MDMessageType["default"].REMOVE_INVITATION:
        this.initRemoveInvitationMessage(msg);
        break;
      case _MDMessageType["default"].COMMENT_CREATED:
        this.initCommentCreatedMessage(msg);
        break;
      case _MDMessageType["default"].COMMENT_CHAT:
        this.initCommentChatMessage(msg);
        break;
      case _MDMessageType["default"].COMMENT_DELETE:
        this.initCommentDeleteMessage(msg);
        break;
      case _MDMessageType["default"].ACCEPT_OR_DENY_INVITATION:
        this.initAcceptOrDenyInvitationMessage(msg);
        break;
      case _MDMessageType["default"].COMMENT_COMPLETED:
        this.initCommentCompletedMessage(msg, true);
        break;
      case _MDMessageType["default"].COMMENT_UNCOMPLETED:
        this.initCommentCompletedMessage(msg, false);
        break;
      case _MDMessageType["default"].COPY:
        this.initCopyMessage(msg, false);
        break;
      case _MDMessageType["default"].DEPARTMENT_CREATE:
        this.initDepartmentCreateMessage(msg);
        break;
      case _MDMessageType["default"].DEPARTMENT_ADDMEMBER:
        this.initDepartmentAddMemMessage(msg, false);
        break;
      case _MDMessageType["default"].DEPARTMENT_UPDATE:
        this.initDepartmentUpdateMessage(msg);
        break;
      case _MDMessageType["default"].DEPARTMENT_REMOVE_MEMBER:
        this.initDepartmentDelMemMessage(msg);
        break;
      case _MDMessageType["default"].DEPARTMENT_UPDATE_MEMBER:
        this.initDepartmentUpdateMemMessage(msg);
        break;
      default:
        console.log("unknown Message: ", this.info.attributes);
    }
  },
  _getFileTypeNameByMsg: function _getFileTypeNameByMsg(msg) {
    var type = msg.get('type');
    return this._getFileTypeName(type);
  },
  _getFileTypeName: function _getFileTypeName(type) {
    if (type == _MMFileType["default"].FOLDER) {
      return BabelStr.str(8);
    }
    return BabelStr.str(1);
  },
  _getFileTypeClass: function _getFileTypeClass(type) {
    if ((0, _typeof2["default"])(type) == "object") {
      type = type.get('type');
    }
    if (type == _MMFileType["default"].FOLDER) {
      return "folder";
    }
    return "file";
  },
  _addOpenParentFolderLink: function _addOpenParentFolderLink() {
    var openFolder = BabelStr.str(553); // 打开目标文件夹
    this.$contentArea.append('<span class="sys-parentFolder"><div class="icon "></div>' + openFolder + '</span>');
  },
  initChatMessage: function initChatMessage(msg) {
    if (msg.get('Body').length == 0) {
      console.error('---- msg length == 0');
      return;
    }
    var tempId = this.info.get('tempId');
    var msgType = msg.get('Type');
    this.$iconGap.append('<img class="avatar" />');
    var time = this.info.get("time").format("HH:mm:ss");
    // utils.prettyNewDate(new Date(), this.info.get("time").getTime());
    this.$contentArea.append('<span class="userName">' + this.info.get("senderName") + '<span class="time mgl-20">' + time + '</span>' + '</span>');
    if (msgType === 'Text') {
      var htmlStr = '<span class="text">' + _link["default"]["do"](_.escape(msg.get('Body'))).replace(/\n/g, "<br>") + '</span>';
      this.$contentArea.append(htmlStr);
      var sending = BabelStr.str(2018); // 正在发送
      var fail = BabelStr.str(2019); // 发送失败
      this.$contentArea.append('<span class="sendEcho">' + sending + '...</span>' + '<span class="errorEcho">' + fail + '</span>');
      var self = this;
      if (tempId) {
        var _timeout = setBabelTimeout(function () {
          self.$contentArea.addClass('sending');
        }, 1000);
        Dispatcher.on(MDEvents.ChatMessageSendSuccess, function (type, cbTempId, messageId) {
          if (type == _MDMessageType["default"].CHAT && cbTempId == tempId) {
            clearTimeout(_timeout);
            self.info.set('messageId', messageId);
            self.$contentArea.removeClass('sending');
            Dispatcher.off(null, null, self);
          }
          ;
        }, self);
        Dispatcher.on(MDEvents.ChatMessageSendFailed, function (type, cbTempId) {
          if (type == _MDMessageType["default"].CHAT && cbTempId == tempId) {
            clearTimeout(_timeout);
            self.$contentArea.removeClass('sending');
            self.$contentArea.addClass('fail');
            Dispatcher.off(null, null, self);
          }
          ;
        }, self);
      }
      ;
    } else if (msgType === 'Audio') {
      var audioFile = msg.get('Url');
      var audioPlayer = _MDAudioPlayer["default"].getAudioPlayer(audioFile, msg.get('Body'), this.fileInfo.get("fileId"));
      this.$contentArea.append(audioPlayer);
    } else if (msgType == 'File') {
      var uploadingMode = msg.get('uploadingMode');
      if (!uploadingMode) {
        var body = JSON.parse(msg.get('Body'));
        var transferItemView = new _MDTransferFileItemView["default"]({
          fileName: body['fileName'],
          fileSize: body['fileSize'],
          fileRefId: body['fileRefId'],
          fileId: body['fileId'],
          uploadingMode: false,
          inDepConversation: app.isEpVersion()
        });
        this.appendTransformFileView(transferItemView);
      }
    }
    app.setAvatarImage(this.$iconGap.find('.avatar'), this.info.get('senderId'), 80, true);
  },
  appendTransformFileView: function appendTransformFileView(transferItemView) {
    var self = this;
    this.addSubView(transferItemView, function (el) {
      self.$contentArea.append(el);
    });
  },
  initDepartmentCreateMessage: function initDepartmentCreateMessage(msg) {
    var senderName = this.info.get('senderName');
    var department = msg.get('department');
    var create = BabelStr.str(554); // 创建了部门
    var str = senderName + ' ' + create + department['name'];
    this.$contentArea.append('<span class="text systemMsgFont">' + str + '</span>');
  },
  initDepartmentAddMemMessage: function initDepartmentAddMemMessage(msg) {
    var members = msg.get('members');
    var department = msg.get('department');
    var memNames = '';
    for (var i = 0; i < members.length; i++) {
      memNames += members[i].user.name;
      if (i < members.length - 1) {
        memNames += ',';
      }
      ;
    }
    ;
    var becomeMem = BabelStr.str(555); // 成为部门新成员
    memNames += ' ' + becomeMem;
    this.$contentArea.append('<span class="text systemMsgFont">' + memNames + '</span>');
  },
  initDepartmentUpdateMessage: function initDepartmentUpdateMessage(msg) {
    var department = msg.get('department');
    var options = msg.get('options');
    var parentDepartment = msg.get('parentDepartment');
    var str = department['name'];
    if (options['name']) {
      var beChanged = BabelStr.str(556); // 被更名为
      str += ' ' + beChanged + ' ' + options['name'];
    }
    ;
    if (options['spaceLimit']) {
      var spaceBeChanged = BabelStr.str(557); // 空间被修改为
      str += ' ' + spaceBeChanged + ' ' + MMCommonFun.getDispStorageStr(options['spaceLimit'] * 1024 * 1024);
    }
    ;
    if (options['remarks']) {
      str += BabelStr.str(7305) + options['remarks'];
    }
    ;
    if (parentDepartment) {
      var depBeChanged = BabelStr.str(558); // 所属部门被修改为
      str += ' ' + depBeChanged + ' ' + parentDepartment['name'];
    }
    this.$contentArea.append('<span class="text systemMsgFont">' + str + '</span>');
  },
  initDepartmentDelMemMessage: function initDepartmentDelMemMessage(msg) {
    var members = msg.get('members');
    var department = msg.get('department');
    var memNames = '';
    for (var i = 0; i < members.length; i++) {
      memNames += members[i].user.name;
      if (i < members.length - 1) {
        memNames += ',';
      }
      ;
    }
    ;
    memNames += ' ' + BabelStr.str(559); // '被移出了部门';

    this.$contentArea.append('<span class="text systemMsgFont">' + memNames + '</span>');
  },
  initDepartmentUpdateMemMessage: function initDepartmentUpdateMemMessage(msg) {
    var diff = msg.get('diff');
    var members = msg.get('members');
    var department = msg.get('department');
    var memNames = '';
    for (var i = 0; i < members.length; i++) {
      memNames += members[i].user.name;
      if (i < members.length - 1) {
        memNames += ',';
      }
      ;
    }
    ;
    memNames += '   ';
    var diffStr = '';
    for (var i = 0; i < diff.length; i++) {
      var d = diff[i];
      if (d.roleName) {
        //key of roleName will be reomved next version
        var roleBeSet = BabelStr.str(560); // 角色 被设置为
        diffStr += roleBeSet + ' ' + d.roleName;
      }
      ;
    }
    ;
    if (diffStr.length > 0) {
      this.$contentArea.append('<span class="text systemMsgFont">' + memNames + diffStr + '</span>');
    }
    ;
  },
  initCreateMessage: function initCreateMessage(msg) {
    // this.$iconGap.append('<img class="avatar" src="/img/login-logo.png"/>');
    var senderName = this.info.get('senderName');
    var fileName = msg.get('fileName');
    this.$contentArea.append('<span class="text systemMsgFont">' + '<span class="userName">' + _.escape(senderName) + '</span>' + BabelStr.str(7306) + '<span> <span class="chat-fileName chat-click ' + this._getFileTypeClass(msg) + '"><div class="icon"></div>' + _.escape(fileName) + '</span> </span>' + '</span>');
    this._addOpenParentFolderLink();
  },
  initUploadMessage: function initUploadMessage(msg) {
    // this.$iconGap.append('<img class="avatar" src="/img/login-logo.png"/>');
    this.$contentArea.append('<span class="text systemMsgFont">' + '<span class="userName">' + _.escape(this.info.get('senderName')) + '</span>' + BabelStr.str(7262) + (msg.get('version') === 0 ? BabelStr.str(1003) : BabelStr.str(1004)) + ' <span class="chat-fileName chat-click ' + this._getFileTypeClass(msg) + '"><div class="icon"></div>' + _.escape(msg.get('fileName')) + '</span> </span>');
    this._addOpenParentFolderLink();
  },
  initRenameMessage: function initRenameMessage(msg) {
    // this.$iconGap.append('<img class="avatar" src="/img/login-logo.png"/>');
    var fileTypeName = this._getFileTypeNameByMsg(msg);
    var oldInfo = fileTypeName + ' <span class="chat-fileName chat-click ' + this._getFileTypeClass(msg) + '"><div class="icon"></div>' + _.escape(msg.get('oldName')) + '</span>';
    var newInfo = '<span> <span class="chat-fileName chat-click ' + this._getFileTypeClass(msg) + '"><div class="icon"></div>' + _.escape(msg.get('newName')) + '</span> </span>';
    var param = {
      'file': oldInfo,
      'newName': newInfo
    };
    var _msg = BabelStr.str(1506, param);
    this.$contentArea.append('<span class="text systemMsgFont">' + '<span class="userName">' + _.escape(this.info.get('senderName')) + '</span>' + _msg + '</span>');
  },
  initMoveMessage: function initMoveMessage(msg) {
    // this.$iconGap.append('<img class="avatar" src="/img/login-logo.png"/>');
    var fileTypeName = this._getFileTypeNameByMsg(msg);
    var param = {
      somebody: '<span class="userName">' + _.escape(this.info.get('senderName')) + '</span>',
      file: fileTypeName + ' <span class="chat-fileName ' + this._getFileTypeClass(msg) + '"><div class="icon"></div>' + _.escape(msg.get('fileName')) + '</span>',
      folder: '<span class="chat-click">' + _.escape(msg.get('destName')) + '</span>'
    };
    var _msg = BabelStr.str(7520, param);
    this.$contentArea.append('<span class="text systemMsgFont">' + _msg + '</span>');
    this._addOpenParentFolderLink();
  },
  initJoinMessage: function initJoinMessage(msg) {
    // this.$iconGap.append('<img class="avatar" src="/img/login-logo.png"/>');
    this.$contentArea.append('<span class="text systemMsgFont">' + '<span class="userName">' + _.escape(this.info.get('senderName')) + '</span>' +
    // ' 加入了分享 <span class="chat-fileName '+this._getFileTypeClass(msg)+'">' + _.escape(msg.get('fileName')) + '</span> '+
    ' ' + BabelStr.str(1507) +
    //' 加入了讨论' +
    '</span>');
  },
  initJoinProjectMessage: function initJoinProjectMessage(msg) {
    var targetNames = msg.get('targetNames');
    var targetNameArr = [];
    _.each(targetNames, function (name) {
      targetNameArr.push(_.escape(name));
    });
    this.$contentArea.append('<span class="text systemMsgFont">' + '<span class="userName">' + targetNameArr.join('，') + '</span>' +
    // ' 加入了分享 <span class="chat-fileName '+this._getFileTypeClass(msg)+'">' + _.escape(msg.get('fileName')) + '</span> '+
    ' ' + BabelStr.str(1507) +
    //' 加入了讨论' +
    '</span>');
  },
  initAcceptOrDenyInvitationMessage: function initAcceptOrDenyInvitationMessage(msg) {
    // this.$iconGap.append('<img class="avatar" src="/img/login-logo.png"/>');
    var joined = BabelStr.str(561); // 加入了团队
    var refused = BabelStr.str(562); // 拒绝加入团队
    this.$contentArea.append('<span class="text systemMsgFont">' + '<span class="userName">' + _.escape(this.info.get('senderName')) + '</span>' + (msg.get('accept') ? joined : refused) + '</span>');
  },
  initLeaveMessage: function initLeaveMessage(msg) {
    // this.$iconGap.append('<img class="avatar" src="/img/login-logo.png"/>');
    var removedUsername = msg.get('removedUserName');
    var divStr = '';
    if (removedUsername) {
      if (this.info.get('senderId') != msg.get('removedUserId')) {
        // kicked from team
        var beKicked = BabelStr.str(563); //  被踢出讨论
        divStr = '<span class="text systemMsgFont">' + '<span class="userName">' + _.escape(removedUsername) + '</span>' + beKicked + '</span>';
      } else {
        // leave team himself
        var leaved = BabelStr.str(564); //  退出了团队
        divStr = '<span class="text systemMsgFont">' + '<span class="userName">' + _.escape(removedUsername) + '</span>' + leaved + '</span>';
      }
    } else {
      var leaved = BabelStr.str(1510); //  退出了讨论
      divStr = '<span class="text systemMsgFont">' + '<span class="userName">' + _.escape(this.info.get('senderName')) + '</span>' + leaved + '</span>';
    }
    this.$contentArea.append(divStr);
  },
  initDeleteMessage: function initDeleteMessage(msg) {
    var that = this;
    // this.$iconGap.append('<img class="avatar" src="/img/login-logo.png"/>');
    var names = msg.get('files').map(function (file) {
      var fileTypeName = that._getFileTypeName(file.type);
      var option = {
        file: fileTypeName + ' <span class="chat-fileName ' + that._getFileTypeClass(file.type) + '"><div class="icon"></div>' + _.escape(file['fileName']) + '</span> '
      };
      var _msg0 = option.file;
      if (file['version']) {
        _msg0 = BabelStr.str(1010, option);
      }
      return _msg0;
      // +(file['version'] ? '第 ' + (parseInt(file['version'])+1) + ' 个版本 ' : '');
    }).join(", ");
    var parentName = msg.get('parentName');
    var param = {
      somebody: '<span class="userName">' + _.escape(this.info.get('senderName')) + '</span>',
      folder: parentName ? '<span class="chat-fileName folder"><div class="icon"></div>' + parentName + '</span>' : '',
      file: names
    };
    var _msg = "";
    if (parentName) {
      _msg = BabelStr.str(1007, param);
    } else {
      _msg = BabelStr.str(1009, param);
    }
    this.$contentArea.append('<span class="text systemMsgFont">' + _msg + '</span>');
  },
  initRestoreMessage: function initRestoreMessage(msg) {
    // this.$iconGap.append('<img class="avatar" src="/img/login-logo.png"/>');
    var fileTypeName = this._getFileTypeNameByMsg(msg);
    var param = {
      somebody: '<span class="userName">' + _.escape(this.info.get('senderName')) + '</span>',
      file: fileTypeName + '  <span class="chat-fileName chat-click ' + this._getFileTypeClass(msg) + '"><div class="icon"></div>' + _.escape(msg.get('fileName')) + '</span> '
    };
    var _msg = BabelStr.str(1011, param);
    this.$contentArea.append('<span class="text systemMsgFont">' + _msg + '</span>');
  },
  initSetCurrentVersionMessage: function initSetCurrentVersionMessage(msg) {
    // this.$iconGap.append('<img class="avatar" src="/img/login-logo.png"/>');
    var fileTypeName = this._getFileTypeNameByMsg(msg);
    var ver = msg.get('newVersion');
    if (isNaN(ver)) {
      ver = parseInt(ver);
    }
    ;
    ver++;
    var param = {
      somebody: '<span class="userName">' + _.escape(this.info.get('senderName')) + '</span>',
      file: '<span class="chat-fileName chat-click ' + this._getFileTypeClass(msg) + '"><div class="icon"></div>' + _.escape(msg.get('fileName')) + '</span>'
    };
    var _msg = BabelStr.str(1014, param);
    this.$contentArea.append('<span class="text systemMsgFont">' + _msg + '</span>');
  },
  initShareMessage: function initShareMessage(msg) {
    // this.$iconGap.append('<img class="avatar" src="/img/login-logo.png"/>');
    var fileTypeName = this._getFileTypeNameByMsg(msg);
    var param = {
      file: fileTypeName + ' <span class="chat-fileName chat-click ' + this._getFileTypeClass(msg) + '"><div class="icon"></div>' + _.escape(msg.get('fileName')) + '</span> '
    };
    var _msg = BabelStr.str(param);
    this.$contentArea.append('<span class="text systemMsgFont">' + '<span class="userName">' + _.escape(this.info.get('senderName')) + '</span>' + _msg);
  },
  initStopShareMessage: function initStopShareMessage(msg) {
    // this.$iconGap.append('<img class="avatar" src="/img/login-logo.png"/>');
    var param = {
      somebody: '<span class="userName">' + _.escape(this.info.get('senderName')) + '</span>',
      file: ' <span class="chat-fileName chat-click ' + this._getFileTypeClass(msg) + '"><div class="icon"></div>' + _.escape(msg.get('fileName')) + '</span> '
    };
    var _msg = BabelStr.str(1024, param);
    this.$contentArea.append('<span class="text systemMsgFont">' + _msg);
  },
  initSetShareRoleMessage: function initSetShareRoleMessage(msg) {
    // this.$iconGap.append('<img class="avatar" src="/img/login-logo.png"/>');
    var newRoleName = msg.get('newRoleName');
    if (BabelStr.getCurrentLanguage() == "en") {
      newRoleName = msg.get('newRoleNameEn');
    }
    var param = {
      somebody: '<span class="userName">' + _.escape(this.info.get('senderName')) + '</span>',
      file: '<span class="chat-fileName chat-click ' + this._getFileTypeClass(msg) + '"><div class="icon"></div>' + _.escape(msg.get('fileName')) + '</span> ',
      role: '<span>' + newRoleName + '</span>'
    };
    var _msg = BabelStr.str(7521, param);
    var divStr = '<span class="text systemMsgFont">' + _msg + '</span>';

    // } else {
    //     divStr += '<span>的默认角色由 '+msg.get('oldRoleName')+' 设置为 '+msg.get('newRoleName')+'</span>'
    // }
    this.$contentArea.append($(divStr));
  },
  initSetUserShareRoleMessage: function initSetUserShareRoleMessage(msg) {
    // this.$iconGap.append('<img class="avatar" src="/img/login-logo.png"/>');
    var newRoleName = msg.get('newRoleName');
    if (BabelStr.getCurrentLanguage() == "en") {
      newRoleName = msg.get('newRoleNameEn');
    }
    var param = {
      somebody: '<span class="userName">' + _.escape(this.info.get('senderName')) + '</span>',
      file: '<span> <div class="icon sys-iconGap"></div>' + _.escape(msg.get('userName')) + '</span> ',
      role: '<span>' + newRoleName + '</span>'
    };
    var _msg = BabelStr.str(7521, param);
    var divStr = '<span class="text systemMsgFont">' + _msg + '</span>';
    this.$contentArea.append($(divStr));
  },
  initInvitationMessage: function initInvitationMessage(msg) {
    var targetEmails = msg.get('targetNames');
    if (!targetEmails) {
      targetEmails = msg.get('targetEmails');
    }
    if (!targetEmails || targetEmails.length === 0) {
      return;
    }
    var htmlFrag;
    var apply = BabelStr.str(565); // 申请加入团队
    var invite = BabelStr.str(566); // 邀请了
    if (targetEmails.length == 1 && targetEmails[0] == this.info.get('senderName')) {
      htmlFrag = '<span class="text systemMsgFont">' + '<span class="userName">' + _.escape(this.info.get('senderName')) + '</span>' + apply;
    } else {
      htmlFrag = '<span class="text systemMsgFont">' + '<span class="userName">' + _.escape(this.info.get('senderName')) + '</span>' + invite;
      for (var i = 0; i < targetEmails.length - 1; i++) {
        htmlFrag += '<span class="chat-fileName">' + _.escape(targetEmails[i]) + ', </span>   ';
      }
      htmlFrag += '<span class="chat-fileName">' + _.escape(targetEmails[i]) + '</span>';
    }
    this.$contentArea.append(htmlFrag);
  },
  initRemoveInvitationMessage: function initRemoveInvitationMessage(msg) {
    var targetEmails = msg.get('targetNames');
    if (!targetEmails) {
      targetEmails = msg.get('targetEmails');
    }
    if (!targetEmails || targetEmails.length === 0) {
      return;
    }
    var removed = BabelStr.str(567); // 移除了
    var htmlFrag = '<span class="text systemMsgFont">' + '<span class="userName">' + _.escape(this.info.get('senderName')) + '</span>' + removed;
    for (var i = 0; i < targetEmails.length - 1; i++) {
      htmlFrag += '<span class="chat-fileName ">' + _.escape(targetEmails[i]) + ', </span>   ';
    }
    htmlFrag += '<span class="chat-fileName">' + _.escape(targetEmails[i]) + '</span>';
    this.$contentArea.append(htmlFrag);
  },
  initCommentCreatedMessage: function initCommentCreatedMessage(msg) {
    // this.$iconGap.append('<img class="avatar" src="/img/login-logo.png"/>');
    var param = {
      file: '<span class="chat-fileName chat-click ' + this._getFileTypeClass(msg) + '"><div class="icon"></div>' + _.escape(msg.get('fileName')) + '</span>'
    };
    var _msg = BabelStr.str(1518, param);
    this.$contentArea.append('<span class="text systemMsgFont">' + '<span class="userName">' + _.escape(this.info.get('senderName')) + '</span>' + _msg);
  },
  initCommentChatMessage: function initCommentChatMessage(msg) {
    // this.$iconGap.append('<img class="avatar" src="/img/login-logo.png"/>');
    var messageText = "";
    try {
      var commentContent = JSON.parse(msg.get("commentContent"));
      if (commentContent['Type'] == "Audio") {
        messageText = '<div class="audioPlayer f-noselect" style="display:inline-block; width:60px;">' + '<div id="popCommentListenBtn" class="sprite_pic_speaker-default"></div>' + '<div class="time">' + commentContent['Body'] + '</div>' + '</div>';
      } else {
        messageText = _.escape(commentContent['Body'] || "");
        if (messageText.length) {
          var maxLength = 40;
          if (messageText.length > maxLength) {
            messageText = messageText.substr(0, maxLength) + " ...";
          }
          //messageText = ": " + messageText;
        }
      }
    } catch (e) {}

    // if(!messageText)messageText = " 回复了位于文件 ";

    if (!messageText) messageText = BabelStr.str(1502); //" 绘制了手绘批注 ";
    this.$contentArea.append('<span class="text systemMsgFont">' + '<span class="userName">' + _.escape(this.info.get('senderName')) + ': </span>' + ' <span class="messageText">' + messageText + ' </span>' + '<span class="chat-fileName chat-click ' + this._getFileTypeClass(msg) + '"><div class="icon"></div>' + _.escape(msg.get('fileName')) + '</span>');
  },
  initCommentDeleteMessage: function initCommentDeleteMessage(msg) {
    // this.$iconGap.append('<img class="avatar" src="/img/login-logo.png"/>');
    var param = {
      somebody: '<span class="userName">' + _.escape(this.info.get('senderName')) + '</span>',
      file: '<span class="chat-fileName chat-click ' + this._getFileTypeClass(msg) + '"><div class="icon"></div>' + _.escape(msg.get('fileName')) + '</span>',
      comentType: BabelStr.str(42)
    };
    var _msg = BabelStr.str(1033, param);
    this.$contentArea.append('<span class="text systemMsgFont">' + _msg + '</span>');
  },
  initCommentCompletedMessage: function initCommentCompletedMessage(msg, flag) {
    // this.$iconGap.append('<img class="avatar" src="/img/login-logo.png"/>');
    var param = {
      file: '<span class="chat-fileName chat-click ' + this._getFileTypeClass(msg) + '"><div class="icon"></div>' + _.escape(msg.get('fileName')) + '</span>'
    };
    var index = 1522;
    if (!flag) {
      index = 1523;
    }
    var _msg = BabelStr.str(index, param);
    this.$contentArea.append('<span class="text systemMsgFont">' + '<span class="userName">' + _.escape(this.info.get('senderName')) + '</span>' + _msg);
  },
  initCopyMessage: function initCopyMessage(msg, flag) {
    // this.$iconGap.append('<img class="avatar" src="/img/login-logo.png"/>');

    var copyFiles = msg.get("copyFiles");
    var filesString = copyFiles.map(function (file) {
      return '"' + file['name'] + '"';
    }).join(', ');
    var destName = msg.get('destinationFileName');
    var param = {
      somebody: '<span class="userName">' + _.escape(this.info.get('senderName')) + '</span>',
      file: '<span class="chat-fileName chat-click ' + this._getFileTypeClass(msg) + '">' + filesString + '</span>',
      folder: destName
    };
    var _msg = BabelStr.str(1015, param);
    this.$contentArea.append('<span class="text systemMsgFont">' + _msg + '</span>');
  },
  initMoveInMessage: function initMoveInMessage(msg) {
    // this.$iconGap.append('<img class="avatar" src="/img/login-logo.png"/>');
    var param = {
      file: '<span class="chat-fileName chat-click ' + this._getFileTypeClass(msg) + '">' + '<div class="icon"></div>' + _.escape(msg.get('fileName')) + '</span>'
    };
    var _msg = BabelStr.str(1524, param);
    this.$contentArea.append('<span class="text systemMsgFont">' + '<span class="userName">' + _.escape(this.info.get('senderName')) + '</span>' + _msg);
    this._addOpenParentFolderLink();
  },
  initMoveOutMessage: function initMoveOutMessage(msg) {
    // this.$iconGap.append('<img class="avatar" src="/img/login-logo.png"/>');
    var param = {
      file: '<span class="chat-fileName ' + this._getFileTypeClass(msg) + '"><div class="icon"></div>' + _.escape(msg.get('fileName')) + '</span> '
    };
    var _msg = BabelStr.str(1525, param);
    this.$contentArea.append('<span class="text systemMsgFont">' + '<span class="userName">' + _.escape(this.info.get('senderName')) + '</span>' + _msg);
  }
});
var _default = exports["default"] = MDMsgItemView;

},{"108":108,"1104":1104,"1184":1184,"1197":1197,"1417":1417,"1424":1424,"1426":1426,"1439":1439,"1454":1454,"1461":1461,"1463":1463,"1466":1466,"1477":1477,"1492":1492,"22":22,"271":271,"303":303,"313":313,"32":32,"347":347,"727":727}],722:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1498);
require(1421);
require(1426);
require(1436);
require(1546);
require(1439);
require(1415);
require(1463);
require(1417);
var _MDMsgInputFooterBaseView = _interopRequireDefault(require(721));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDAtWhoView = _interopRequireDefault(require(35));
var _regexp = _interopRequireDefault(require(106));
/**
 *  Class description here
 *  Created by author's name
 *  date here(2015.6.24)
 */

var MDMsgInputFooterView = _MDMsgInputFooterBaseView["default"].extend({
  el: '<div class="msg-panel"></div>',
  tmpl: "\n        <div class=\"msg-toolbar flex-align between middle\">\n          <span id=\"js-upload-file\" class=\"icon ic-attach\" data-tooltip=\"<%=file%>\" data-tooltip-dir=\"top\"></span>\n          <span class=\"linebreak-tip \">shift+enter <%=returnCap%></span>\n        </div>\n        <div class=\"input-panel\">\n          <textarea id=\"js-msg-box\" placeholder=\"<%=sendMsg%>\" maxlength=\"400\"></textarea>\n        </div>\n          ",
  initProps: function initProps() {
    var superP = _MDMsgInputFooterBaseView["default"].prototype.initProps.call(this);
    var selfP = {
      $textarea: null,
      enterSubmit: true,
      onFileUploadAction: _.noop,
      atObj: {}
    };
    return _.extend(superP, selfP);
  },
  events: function events() {
    var superE = _MDMsgInputFooterBaseView["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click .ic-attach': this._uploadAttachFile,
      'keyup textarea': this._textAreaKeyUpHandler,
      'paste .input-panel': this._textareaPasteHandle
    });
  },
  initialize: function initialize(opt) {
    if (!opt.data) {
      opt.data = {};
    }
    ;
    opt.data = _.extend(opt.data, {
      'file': BabelStr.str(325),
      // 文件传输
      'returnCap': BabelStr.str(327),
      // 换行
      'sendMsg': BabelStr.str(326) // 发送消息
    });
    _MDMsgInputFooterBaseView["default"].prototype.initialize.call(this, opt);
    var self = this;
    this.$textarea = this.$('#js-msg-box');
    this.updateView();
    this.bindSelf(this._textAreaKeyDownHandler);
    this.$textarea.on({
      'keydown': self._textAreaKeyDownHandler
    });
  },
  _textareaPasteHandle: function _textareaPasteHandle(ev) {
    var self = this;
    var original = ev.originalEvent;
    if (!original.clipboardData.items) {
      return;
    }
    _.each(original.clipboardData.items, function (item) {
      var file = item.getAsFile();
      if (file) {
        self.onPasteFileUploadAction([file]);
      }
    });

    // var file =  original.clipboardData.items[0].getAsFile();
    // var reader = new FileReader();
    // reader.onload = function (evt) {
    //     var result = evt.target.result;

    //     var arr = result.split(",");
    //     var data = arr[1]; // raw base64
    //     var contentType = arr[0].split(";")[0].split(":")[1];       
    //     $.post("/echo/html/", {
    //         contentType: contentType,
    //         data: data
    //     });

    //     // self.$('.input-panel').append("<img src='" + result + "' />");
    //     self.onPasteFileUploadAction({
    //       file: result,
    //       name: file.name,
    //       size: file.size,
    //       type: file.type
    //     })
    // };

    // reader.readAsDataURL(file);
    console.log(ev);
  },
  _uploadAttachFile: function _uploadAttachFile() {
    if (this.disabled) {
      return;
    }
    this.onFileUploadAction();
  },
  _textAreaKeyDownHandler: function _textAreaKeyDownHandler($e) {
    if ($e.keyCode === 13 && !$e.shiftKey && this.enterSubmit) {
      this.sendMessage();
      return false; // 阻止默认换行行为
    }
  },
  _textAreaKeyUpHandler: function _textAreaKeyUpHandler(e) {
    var self = this;
    var message = self.$textarea[0].value.trim();
    if (e.keyCode == 8) {
      _.each(this.atObj, function (value, key) {
        if (message.indexOf(key) === -1) {
          delete self.atObj[key];
        }
      });
    }
  },
  updateView: function updateView() {
    if (!this.fileInfo) {
      this.disabled = true;
      this.$('.ic-attach').addClass('disabled');
      this.$el.addClass('disabled');
      this.$textarea.prop('disabled', true);
    } else {
      this.$el.removeClass('disabled');
      this.$textarea.prop('disabled', false);
      this.$('.ic-attach').removeClass('disabled');
      this.disabled = false;
      var self = this;
      var fileInfo = this.fileInfo;
      _MMNetDiskDataController["default"].getConversationParticipants(this.fileInfo, function (participants) {
        var userList = _.map(participants.toJSON(), function (userInfo) {
          var account = userInfo['email'];
          if (!_regexp["default"].isEmail(account)) {
            account = userInfo['phone'];
            if (!account) {
              account = "--";
            }
          }
          return {
            id: userInfo['id'],
            name: userInfo['name'],
            email: account,
            url: app.getAvatarImageURL(userInfo['id'])
          };
        });
        userList = _.filter(userList, function (user) {
          return user['id'] != app.currentUser.getUserId();
        });
        var all = BabelStr.str(253); // 所有人
        userList.unshift({
          id: 'All',
          name: all
        });
        self.atwhoView = new _MDAtWhoView["default"]({
          triggerBlock: self.$textarea,
          at: "@",
          data: userList,
          insertTpl: '@<%= name %>',
          displayTpl: '<% if(id != "All") {%>' + '<li data-id="<%= id %>">' + '<img src="<%= url %>">' + '<div class="member-info"><div class="name"><%= name %></div>' + '<div class="email"><%= email %></div></div>' + '</li>' + '<% } else { %>' + '<li class="at-all" data-id="<%= id %>">' + all + '</li>' + '<% } %>',
          displayTimeout: 1000
        });
        self.$textarea.on('inserted.atwho', function (evt, li) {
          var id = li.attr('data-id');
          var name = '@' + li.find('div.name').text();
          if (!self.atObj[name]) {
            self.atObj[name] = id;
          }
        });
        self.$textarea.on('shown.atwho', function (evt) {
          if (self.enterSubmit) {
            self.enterSubmit = false;
          }
        });
        self.$textarea.on('hidden.atwho', function (evt) {
          self.enterSubmit = true;
        });
      }, function () {});
    }
  },
  getAtIds: function getAtIds() {
    var atIds = [];
    _.each(this.atObj, function (id, name) {
      if (id === 'All') {
        atIds = 'All';
        return;
      }
      atIds.push(id);
    });
    return atIds;
  },
  setFileInfo: function setFileInfo(info) {
    this.fileInfo = info;
    this.updateView();
  },
  // 聊天组中的 send chat message
  sendMessage: function sendMessage() {
    var atIds = this.getAtIds();
    var text = this.$textarea.val().trim();
    if (!text) {
      return;
    }
    this.$textarea.val("");
    if (!this.fileInfo) {
      return;
    }
    var fileId = this.fileInfo.get("fileId");
    var msgContent = {
      "Type": "Text",
      "Body": text,
      "atIds": atIds,
      "pageIndex": -1,
      "fileName": this.fileInfo.getFileName()
    };
    _czc && _czc.push(["_trackEvent", "讨论", "发送组讨论信息", "", "", "js-msg-box"]);
    this._sendMessage(msgContent);
    this.atObj = {};
  },
  viewWillUnRendered: function viewWillUnRendered() {
    _MDMsgInputFooterBaseView["default"].prototype.viewWillUnRendered.call(this);
    this.atwhoView && this.atwhoView.destroySelf();
  }
});
var _default = exports["default"] = MDMsgInputFooterView;

},{"106":106,"1104":1104,"1184":1184,"1415":1415,"1417":1417,"1421":1421,"1426":1426,"1436":1436,"1439":1439,"1454":1454,"1463":1463,"1498":1498,"1546":1546,"35":35,"721":721}],721:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
var _MMViewBase = _interopRequireDefault(require(22));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDAtWhoView = _interopRequireDefault(require(35));
var _MDMessageType = _interopRequireDefault(require(271));
var _MDMessage = _interopRequireDefault(require(270));
/**
 *  Class description here
 *  Created by author's name
 *  date here(2015.6.24)
 */

var tempMsgId = 1;
var MDMsgInputFooterBaseView = _MMViewBase["default"].extend({
  _constructMyChatMsg: function _constructMyChatMsg(msgContent) {
    msgContent.msgType = _MDMessageType["default"].CHAT;
    var data = {
      'tempId': tempMsgId++,
      'category': 1,
      'enterpriseId': app.isEpVersion() ? app.ep.getEpID() : 0,
      'fileId': this.fileInfo.getFileId(),
      'msgContent': msgContent,
      'senderId': app.currentUser.getUserId(),
      'senderName': app.currentUser.getUserName(),
      'time': new Date(),
      'type': _MDMessageType["default"].CHAT
    };
    var msg = data["msg"] = new Backbone.Model(data["msgContent"]);
    var messageModel = new _MDMessage["default"](data);
    return messageModel;
  },
  // 聊天组中的 send chat message
  _sendMessage: function _sendMessage(message) {
    var fileId = this.fileInfo.get("fileId");
    _czc && _czc.push(["_trackEvent", "讨论", "发送组讨论信息", "", "", "js-msg-box"]);
    var messageModel = this._constructMyChatMsg(message);
    Dispatcher.trigger(MDEvents.NewMsgReceived, this.fileInfo.getFileId(), messageModel);
    if (this.fileInfo.isDepartmentFolder()) {
      _MMNetDiskDataController["default"].sendDepChatMessage(fileId, JSON.stringify(message), function (messageId) {
        setBabelTimeout(function () {
          Dispatcher.trigger(MDEvents.ChatMessageSendSuccess, _MDMessageType["default"].CHAT, messageModel.get('tempId'), messageId);
        }, 0);
      }, function () {
        Dispatcher.trigger(MDEvents.ChatMessageSendFailed, _MDMessageType["default"].CHAT, messageModel.get('tempId'));
      });
    } else if (this.fileInfo.isProject()) {
      _MMNetDiskDataController["default"].sendProjectChatMessage(fileId, JSON.stringify(message), function (messageId) {
        setBabelTimeout(function () {
          Dispatcher.trigger(MDEvents.ChatMessageSendSuccess, _MDMessageType["default"].CHAT, messageModel.get('tempId'), messageId);
        }, 0);
      }, function () {
        Dispatcher.trigger(MDEvents.ChatMessageSendFailed, _MDMessageType["default"].CHAT, messageModel.get('tempId'));
      });
    } else {
      _MMNetDiskDataController["default"].sendFileMessage(fileId, JSON.stringify(message), function (messageId) {
        Dispatcher.trigger(MDEvents.ChatMessageSendSuccess, _MDMessageType["default"].CHAT, messageModel.get('tempId'), messageId);
      }, function () {
        Dispatcher.trigger(MDEvents.ChatMessageSendFailed, _MDMessageType["default"].CHAT, messageModel.get('tempId'));
      });
    }
  }
});
var _default = exports["default"] = MDMsgInputFooterBaseView;

},{"1104":1104,"1184":1184,"1437":1437,"1454":1454,"22":22,"270":270,"271":271,"35":35}],720:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1424);
require(1412);
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDFileTableRowView = _interopRequireDefault(require(500));
var _MDShareFileWindowView = _interopRequireDefault(require(695));
/**
 *  消息顶部栏的文件行信息
 *  Created by manjun.han
 *  2016.8.12
 */

var MDMessageFileInfoRowView = _MDFileTableRowView["default"].extend({
  initProps: function initProps() {
    var superP = _MDFileTableRowView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      singleSelect: false,
      allowSelect: false,
      index: 0,
      columns: [{
        dataIndex: 'fileName'
      }],
      openSingleFile: true,
      columnRenders: [{
        name: BabelStr.str(158),
        //'名称',
        cellCls: 'title-col',
        dataIndex: 'fileName',
        flex: 3,
        render: function render(name, f, index) {
          var fileName = f.get("fileName");
          var creator = f.get("creatorName");
          var createTime = MMCommonFun.formatSec2Date(f.get("ctime"));
          var isFolder = f.isFolder();
          var btns = [];
          if (!f.isFolder()) {
            var openCap = BabelStr.str(265); //打开所在文件夹
            btns.push('<button class="gotoParentFolder" title="' + openCap + '">' + openCap + '</button>');
          }
          ;
          if (f.isTeamFolder()) {
            if (!app.isEpVersion()) {
              var teamCap = BabelStr.str(187); //查看团队
              btns.push('<button class="manage-team-btn button" title="' + teamCap + '">' + teamCap + '</button>');
            }
          } else if (f.canShare()) {
            var viewCap = BabelStr.str(338); //查看分享设置
            btns.push('<button class="shareBtn" title="' + viewCap + '">' + viewCap + '</button>');
          }
          var commentInfo = [];
          var isUnread = f.getUnReadCount() > 0 ? true : false;
          var unRead = "";
          var btnsStr = btns.length ? "<div class=\"btns\">".concat(btns.join(""), "</div>") : '';
          var createAt = BabelStr.str(41); // 创建于
          var tmpl = "<div>\n              ".concat(unRead, "\n              <div class=\"thumbWrapper file-icon-root file-icon mgr-10\">\n                <i class=\"icon\"></i>\n              </div>\n              <div class=\"contentWrapper msgWin flex-align middle f-tl between\">\n                <div class=\"content\">\n                  <div class=\"name-wrapp msgtab\">\n                    <div class=\"inner\">\n                      <span class=\"name\" title=\"").concat(fileName, "\">").concat(fileName, "</span>\n                    </div>\n                    <div>\n                      <span>").concat(creator, "</span>") + createAt + " <span >".concat(createTime, "</span>\n                      ").concat(commentInfo.join(""), "\n                    </div>\n                    <div class=\"state-wrapper\"></div>\n                  </div>\n\n              </div>\n                ").concat(btnsStr, "\n              </div>\n            </div>");
          return tmpl;
        }
      }]
    });
  },
  initialize: function initialize(opt) {
    _MDFileTableRowView["default"].prototype.initialize.call(this, opt);
    this.listenTo(this.rowModel, 'change', this._homeFileInforChanged);
  },
  events: function events() {
    var superE = _MDFileTableRowView["default"].prototype.events.call(this);
    return _.extend(superE, {
      "click .btns button": this.operationBtnClickHandler
    });
  },
  _homeFileInforChanged: function _homeFileInforChanged() {
    this.refresh();
    // 此处的刷新机制不好，当个界面组件的局部刷新没处理好
    this._refreshShareStatus();
    var thumbDiv = this.$(".thumbWrapper");
    this.fileInfor.setIconForDiv(thumbDiv);
  },
  operationBtnClickHandler: function operationBtnClickHandler($e) {
    var btn = $e.target.className;
    if (btn === 'shareBtn') {
      var wind = new _MDShareFileWindowView["default"]({
        fileInfor: this.fileInfor,
        enableControlShare: false
      });
      wind.show();
    } else {
      _MDFileTableRowView["default"].prototype.operationBtnClickHandler.call(this, $e);
    }
  },
  openFileInEditor: function openFileInEditor() {
    var self = this;
    if (self.fileInfor.isFolder()) {
      var path = 'file/' + self.fileInfor.getFileId();
      app.pathRouter.navigate(path, {
        trigger: true
      });
    } else {
      _MDFileTableRowView["default"].prototype.openFileInEditor.call(this);
    }
  }
});
var _default = exports["default"] = MDMessageFileInfoRowView;

},{"1150":1150,"1184":1184,"1412":1412,"1424":1424,"1454":1454,"500":500,"695":695}],500:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1424);
require(1437);
require(1477);
require(1495);
require(1421);
require(1416);
require(1417);
require(1463);
require(1541);
require(1426);
require(1436);
require(1546);
var _MDEndEvalWindowView = _interopRequireDefault(require(457));
var _MEStaffNavigationPageView = _interopRequireDefault(require(148));
var _MDMsgCommentPopupView = _interopRequireDefault(require(511));
var _MMBasicData = _interopRequireDefault(require(811));
var _MDPopupView = _interopRequireDefault(require(64));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDFileActionController = _interopRequireDefault(require(492));
var _MDPCDisplayFileController = _interopRequireDefault(require(422));
var _MDHomeTableRowView = _interopRequireDefault(require(605));
var _MDShareFileWindowView = _interopRequireDefault(require(695));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDLocalFileCollector = _interopRequireDefault(require(330));
var _MDJoinersPopupView = _interopRequireDefault(require(504));
var _MDProgress = _interopRequireDefault(require(30));
var _MDVideoPlayerWin = _interopRequireDefault(require(437));
var _MDAudioPlayerWin = _interopRequireDefault(require(407));
var _MDFileExtraAttrView = _interopRequireDefault(require(495));
var _MDTeamSettingWindowView = _interopRequireDefault(require(763));
var _MDMenuItemView = _interopRequireDefault(require(51));
var _MDRequestSharelinkPopupView = _interopRequireDefault(require(684));
var _MMFileInfo = _interopRequireDefault(require(297));
var _MDFileCommentListView = _interopRequireDefault(require(543));
var _popupPos = _interopRequireDefault(require(65));
var _MDEvalutionStartView = _interopRequireDefault(require(473));
var _MDEvaluationListWinView = _interopRequireDefault(require(468));
var _MDFilePathManager = _interopRequireDefault(require(1090));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDChannelType = _interopRequireDefault(require(717));
var _MDManuscriptBoxView = _interopRequireDefault(require(176));
var _MDManuscriptStatusChangedWinView = _interopRequireDefault(require(507));
var _MDSurveyStatusLoader = _interopRequireDefault(require(700));
var _MDMessageView = _interopRequireDefault(require(55));
var _app = _interopRequireDefault(require(17));
var _MDTrashFileActionController = _interopRequireDefault(require(703));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _menusvg = _interopRequireDefault(require(1119));
/**
 *  File table row view
 *  Created by manjun.han
 *  date here(2015.6.24)
 */

var MDFileTableRowView = _MDHomeTableRowView["default"].extend({
  getClassName: function getClassName() {
    return "MDFileTableView";
  },
  initProps: function initProps(opt) {
    var self = this;
    var superP = _MDHomeTableRowView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      versionList: null,
      fileInfor: null,
      deleteAfterMove: true,
      isHomeTableRowView: true,
      commentListView: undefined,
      commentClicked: _.noop,
      showStickTop: true,
      columnRenders: function columnRenders() {
        return self._columnRenders();
      }
    });
  },
  mouseEnter: function mouseEnter() {
    if (this.isSelected()) {
      return;
    }
    if (this.isFullNameMode) {
      return;
    }
    var fileName = MMCommonFun.getFileMidDotsString(this.fileInfor.get("fileName"), 16, 3, 20);
    this.$(".name").html(fileName);
  },
  mouseLeave: function mouseLeave() {
    if (this.isFullNameMode) {
      return;
    }
    if (this.isSelected()) {
      return;
    }
    var fileName = MMCommonFun.getFileMidDotsString(this.fileInfor.get("fileName"), 18, 10, 29);
    this.$(".name").html(fileName);
  },
  _createFileNameRenders: function _createFileNameRenders() {
    var self = this;
    var render = {
      name: BabelStr.str(158),
      //'名称',
      dataIndex: "fileName",
      cellCls: "title-col",
      render: function render(name, f, index) {
        var fileName = f.get("fileName");
        // if(app.pathRouter.isInMsAnonyBoxFolderPath() && f.isFolder()) {
        //   fileName = _.escape(fileName)
        // }
        var creator = f.get("creatorName");
        var createTime = MMCommonFun.formatSec2Date(f.get("ctime"));
        var fileSize = f.get("fileSize");
        var isFolder = f.isFolder();
        var isShortcuts = f.isShortcuts();
        var sharerName = f.get("sharerName");
        var comment = f.get("comment");
        var btns = self.createDispBtn(f, self.showStickTop);
        var isUnread = f.getUnReadCount() > 0 ? true : false;
        var unRead = "";
        if (isUnread) {
          unRead = '<span class="unread-mark" data-tooltip="' + BabelStr.str(166) + '" data-tooltip-dir="top"></span>';
        }
        var evalStr = '';
        if (!this.isUsedAdvancedSearch) {
          evalStr = f.createEvalStrHtml();
        }
        var expiredStr = '';
        if (!this.isUsedAdvancedSearch) {
          expiredStr = f.getMsBoxEndTimeDispString();
          if (expiredStr != "") {
            expiredStr = '<span class="end-time msg-end-time">' + expiredStr + "</span>";
          }
        }
        var msgboxComment = "";
        // if (f.isManuscriptBox()) {
        msgboxComment = '<span class="msg-comment-btn" data-tooltip-dir="top">' + " <span class=\"for-cn client-icon\"></span>\n                <span class=\"for-en bg-Cred\">".concat(BabelStr.str(7226), "</span>\n              ") + "</span>";
        // };
        var applyForTeamOrProjStr = "";
        var tempStr = "";
        if (f.get("applyForTeamOrProj") && f.get("manager") != _app["default"].currentUser.getUserId()) {
          tempStr = f.isTeamFolder() ? BabelStr.str(6088) : BabelStr.str(6096);
          applyForTeamOrProjStr = "<sapn class=\"apply-proj-team-state\">".concat(tempStr, "</sapn>");
        }
        var shareState = "";
        if (_app["default"].pathRouter && _app["default"].pathRouter.inMyShare() && f.get(" isInviteSharing")) {
          shareState = "<span class=\"main-color file-flag invited-tip\" data-tooltip=\"".concat(BabelStr.str(7227), "\" data-tooltip-dir=\"top\">").concat(BabelStr.str(7228), "</span>");
        } else if (_app["default"].pathRouter && _app["default"].pathRouter.isInSharePath() && !f.get("newShareAll")) {
          // shareState = `<span class="main-color file-flag">${BabelStr.str(6100)}</span>`
        }
        var manuscriptStatusText = f.getManuscriptStatusText();
        var security = "";
        if (!f.get("multFile")) {
          security = "<span class=\"security f-none\" data-tooltip-dir=\"top\"></span>";
        }
        var style = "";
        var pointerStyle = "";
        if (!f.canRead() && !this.isUsedAdvancedSearch) {
          style = "style=\"opacity: 0.3;\"";
          pointerStyle = "style=\"pointer-events: none;\"";
        }
        var cls = "";
        if (f.isMultFile()) {
          cls = "no-extra-line";
        }
        var trashScope = "";
        if (f.isDeleted()) {
          if (_app["default"].pathRouter.isInTrash()) {
            trashScope = '<span class="file-trash-scope">' + BabelStr.str(5559) + "</span>";
          } else {
            trashScope = '<span class="file-trash-scope">' + BabelStr.str(22) + "</span>";
          }
        }
        var rootDep = "";
        if (f.get("parentId") == "0" && f.isDepartmentFolder()) {
          rootDep = "<div class=\"red f-noshrink\">".concat(BabelStr.str(6092), "</div>");
        } else if (_app["default"].pathRouter.isInRoot() && f.isDepartmentFolder() && _app["default"].pathRouter.isEpfile()) {
          rootDep = "<div class=\"join-dep f-noshrink\">".concat(BabelStr.str(21518), "</div>");
        }
        var snapStr = "";
        if (f.isSnapshotFile()) {
          snapStr = '<span class="snap-file file-mark" data-tooltip-dir="top">' + BabelStr.str(21301) + "</span>";
        }
        var openlink = "";
        var openlinksvg = "";
        if (f.getLinkFileUrl()) {
          // openlink = `<span class="open-link text-button done mgr-10">${BabelStr.str(27005)}</span>`
          openlinksvg = "<div class=\"open-link flex-align middle center svg-ic-parent text-button done\" data-tooltip-dir=\"top\" data-tooltip=\"".concat(BabelStr.str(27005), "\">\n            ").concat(_menusvg["default"].menu_link_file3, "\n          </div>");
        }
        var libraryCls = '';
        if (f.isMaterialClass()) {
          libraryCls = "classify";
        } else if (f.isMaterialLibraryFolder()) {
          libraryCls = "library";
        }
        var tmpl = "<div ".concat(style, " class=\"").concat(cls, "\">\n                ").concat(unRead, "\n                  <div class=\"thumbWrapper file-icon-root\" data-fileid='").concat(f.getFileId(), "'>\n                    <i class=\"icon\"></i>\n                    <div class=\"archive-mark f-hide\"></div>\n                    <div class=\"link-mark icon\"></div>\n                    <div class=\"library-mark icon f-none ").concat(libraryCls, "\"></div>\n                    ").concat(openlinksvg, "\n                  </div>\n                  <div class=\"contentWrapper\">\n                    <div class=\"content\">\n                      <div class=\"name-wrapp\">\n                        <div class=\"inner\">\n                          <span class=\"icon stickonTopMark\"></span>\n                          <span class=\"append-per f-none \" data-tooltip-dir=\"top\" data-tooltip=\"").concat(BabelStr.str(7229), "\">\n                            <span class=\"for-cn\"></span>\n                            <span class=\"for-en bg-Cred\">").concat(BabelStr.str(2615), "</span>\n                          </span>\n                          <span class=\"append-per-from-parent no-shrink f-none bg-Cred\" data-tooltip-dir=\"top\" data-tooltip=\"").concat(BabelStr.str(6852), "\"></span>\n                          ").concat(security, "\n                          ").concat(openlink, "\n                          <span class=\"name\" title=\"").concat(f.get("fileName"), "\">").concat(fileName, "</span>\n                          <span class=\"survey-state\" data-fileid=\"").concat(f.getFileId(), "\"></span>\n                          ").concat(rootDep, "\n                          <span class=\"manuscript-content no-shrink f-hide\">").concat(manuscriptStatusText, "</span>\n                          <span class=\"lock-state name-line f-hide\"></span>\n                          <span class=\"eval-span\">").concat(evalStr, "</span>") + '<span class="project-endTime red f-hide">' + _MDLocalString["default"].getLocalString(6813) + "</span>" + '<span class="file-scope">' + _MDLocalString["default"].getLocalString(178) + "</span>" + '<span class="file-belong">' + _MDLocalString["default"].getLocalString(5010) + "</span>" + '<span class="file-archive f-hide">' + _MDLocalString["default"].getLocalString(6806) + "</span>" + '<span class="file-auto-task f-hide">' + _MDLocalString["default"].getLocalString(28070) + "</span>" + "<span class=\"star-wrap\"><i class=\"icon star-add\" data-tooltip-dir=\"top\" data-tooltip=\"".concat(BabelStr.str(7174), "\"></i></span>") + shareState + applyForTeamOrProjStr + expiredStr + msgboxComment + trashScope + snapStr + "<span class=\"banned-file-mark f-hide\" data-tooltip-dir=\"top\" data-tooltip=\"".concat(BabelStr.str(28225), "\">").concat(_menusvg["default"].banned_file, "</span>") + "<span class=\"state-wrapper\"></span>\n\n                        </div>\n                      </div>\n                    </div>\n                    <div class=\"btns\" ".concat(pointerStyle, ">").concat(btns.join(""), "</div>\n                  </div>\n                  <div class = \"extra-attr\" ").concat(pointerStyle, "></div>\n                </div>");
        return tmpl;
      }
    };
    return render;
  },
  _createTimeRender: function _createTimeRender() {
    var self = this;
    var render = {
      name: BabelStr.str(788),
      //'最近修改',
      dataIndex: "latestVersionTime",
      cellCls: "time-col",
      render: function render(name, fileInfor, index) {
        if (fileInfor.isEpPublicFolder()) {
          return "--";
        }
        var time = fileInfor.get("commitTime") || fileInfor.get("latestVersionTime") || fileInfor.get("mtime");
        fileInfor.set('commitTime', time);
        return "<div>\n                      <div class=\"modify-time C8\">".concat(MMCommonFun.formatSec2Date(time), "</div>\n                      <div class=\"text-hide modify-name modifier H13 C15\" title=\"").concat(fileInfor.get("committerName") || fileInfor.getLastModifyUserName(), "\">").concat(fileInfor.get("committerName") || fileInfor.getLastModifyUserName(), "</div>\n                    </div>");
      }
    };
    return render;
  },
  _createRecentTimeRender: function _createRecentTimeRender() {
    var self = this;
    var render = {
      name: BabelStr.str(732),
      //'最近访问',
      dataIndex: "recentTime",
      cellCls: "time-col",
      render: function render(name, fileInfor, index) {
        return "<div>\n                      <div class=\"modify-time C8\">".concat(MMCommonFun.formatSec2Date(fileInfor.get("recentTime")), "</div>\n                    </div>");
      }
    };
    return render;
  },
  _createFileSizeRender: function _createFileSizeRender() {
    var self = this;
    var render = {
      name: BabelStr.str(27),
      //'大小',
      dataIndex: "currentVersionSize",
      cellCls: "size-col",
      render: function render(name, model, index) {
        var fileInfor = model;
        var size = fileInfor.get("fileSize") || fileInfor.get("currentVersionSize");
        fileInfor.set("currentVersionSize", size - 0);
        if (fileInfor.isFolder()) {
          return "--";
        } else {
          return _app["default"].getFileSizeDescription(size);
        }
      }
    };
    return render;
  },
  _createParentRender: function _createParentRender() {
    var self = this;
    var render = {
      dataIndex: "parentFolder",
      cellCls: "parent-col",
      render: function render(name, model, index) {
        var btn = '<span class="open-parent-folder text-button">' + _MDLocalString["default"].getLocalString(136) + "</span>";
        if (_app["default"].pathRouter.isInMyfocus()) {
          if ((model.isProject() || model.isTeamFolder()) && model.getParentFolderId() == 0 && model.getOwnerId() != _app["default"].currentUser.getUserId()) {
            btn = "--";
          }
        }
        return btn;
      }
    };
    return render;
  },
  _createVersionNoRender: function _createVersionNoRender() {
    var self = this;
    var render = {
      dataIndex: "versionNo",
      cellCls: "version-col text-hide",
      render: function render(name, model, index) {
        return model.getVersionNo();
      }
    };
    return render;
  },
  _createVersionRender: function _createVersionRender() {
    var self = this;
    var render = {
      dataIndex: "version",
      cellCls: "version-col text-hide",
      render: function render(name, model, index) {
        return model.isFolder() ? '--' : model.get('version') - 0 + 1;
      }
    };
    return render;
  },
  _columnRenders: function _columnRenders() {
    var colRenders = [];

    // MDFileTableRowView__columnRenders

    colRenders.push(this._createFileNameRenders());
    colRenders.push(this._createFileSizeRender());
    if (_app["default"].pathRouter.getHQSMProjectByPath()) {
      colRenders.push(this._createVersionNoRender());
    }
    if (this.isUsedAdvancedSearch) {
      colRenders.push(this._createVersionRender());
    }
    if (_app["default"].pathRouter.isRecently()) {
      colRenders.push(this._createRecentTimeRender());
    } else if (!_app["default"].pathRouter.inDepartment()) {
      colRenders.push(this._createTimeRender());
    }
    if (this.isSearch || _app["default"].pathRouter.isAI() || _app["default"].pathRouter.inMyShare() || _app["default"].pathRouter.isInMyfocus() || _app["default"].pathRouter.isRecently()) {
      colRenders.push(this._createParentRender());
    }
    var createrItem = {
      dataIndex: "creatorName",
      cellCls: "creater-col",
      render: function render(name, fileInfor, index) {
        var createrName = fileInfor.get("creatorName");
        var createTime = (fileInfor.get("ctime") - 0) * 1000;
        var creaTimeStr = new Date(createTime).format("MM-dd-HH:mm");
        if (this.channel == _MDChannelType["default"].msbox) {
          return "<div class=\"boldfont2 text-hide C8\">".concat(createrName, "</div>\n                  <div class=\"H13 C15\">").concat(BabelStr.str(41)).concat(creaTimeStr, "</div>\n                ");
        } else {
          return "<div class=\"boldfont2 C8\">".concat(createrName, "</div>\n                  <div class=\"H13 C15\">").concat(BabelStr.str(8343, {
            time: creaTimeStr
          }), "</div>\n                ");
        }
      }
    };
    colRenders.unshift(createrItem);
    return colRenders;
  },
  events: function events() {
    var superE = _MDHomeTableRowView["default"].prototype.events.call(this);
    return _.extend(superE, {
      "click .btns span": this.operationBtnClickHandler,
      "dblclick .row-cells": this._dblclickHandler,
      "click .open-parent-folder": this._openParentFolderHandler,
      "click .eval-btn": this._evalBtnClicked,
      "mouseup .eval-btn": this._evalBtnMouseup,
      "mousedown .eval-btn": this._evalBtnMouseup,
      "click .shareState": this._shareBtnClicked,
      "mouseup .shareState": this._evalBtnMouseup,
      "mousedown .shareState": this._evalBtnMouseup,
      "click .file-scope": this._outsideFileClicked,
      "mouseup .file-scope": this._evalBtnMouseup,
      "mousedown .file-scope": this._evalBtnMouseup,
      "click .manuscript-status": this._manuscriptStatusChanged,
      "click .msg-end-time": this._editMsBoxBtnClicked,
      "click .star-add": this._starBtnClicked,
      "click .append-per": this._appPerBtnClicked,
      "click .append-per-from-parent": this._appPerBtnClicked,
      "click .security": this._securityBtnClicked,
      "click .msg-comment-btn": this._fileCommentClicked,
      "click .stickonTopMark": this._stickOntopClicked,
      "click .lock-state": this._lockIconClicked,
      "click .invited-tip": this._inviteTipIconClicked,
      "click .delBtn": this._deleFile,
      "click .open-link": this.openLink,
      "click .restoreBtn": this._restoreFile,
      "click .file-auto-task": this.showTaskMenus,
      mouseenter: this.mouseEnter,
      mouseleave: this.mouseLeave
    });
  },
  initialize: function initialize(opt) {
    var _this = this;
    this.isSearch = opt.isSearch;
    if (this.channel == undefined || this.channel == null) {
      this.channel == _MDChannelType["default"].file;
    }
    opt = _.extend({
      allowMoveInFolder: true,
      needShareStatus: true
    }, opt);
    var bindMethods = [this.fileNameClickHandler, this.setPraisedUsers, this.commentClickHandler, this._refreshCount, this.commentStrUpHandler, this.commentStrDownHandler];
    this.bindSelf(bindMethods);
    _MDHomeTableRowView["default"].prototype.initialize.call(this, opt);
    this.setFileInfor(opt.rowModel);
    this.openSingleFile = opt.openSingleFile;
    // opt.needShareStatus && this._refreshShareStatus();

    var self = this;
    var thumbDiv = this.$(".thumbWrapper");
    var size = 40;
    if (_app["default"].userClentMode()) {
      size = 30;
    }
    this.fileInfor.setIconForDiv(thumbDiv, undefined, size, true);
    if (this.fileInfor.isShortcuts()) {
      this.$(".thumbWrapper .link-mark").show();
    } else {
      this.$(".thumbWrapper .link-mark").hide();
    }
    if (this.fileInfor.getIsFocusFile()) {
      this.$(".star-wrap").show();
    }
    this._refreshCommentStr();
    if (this.fileInfor.get("versionList") == 1) {
      this._fileVersionListChange(this.fileInfor.getFileId());
    }
    if (_app["default"].isEpVersion() && !this.fileInfor.belongsToCurrentUserEnterprise()) {
      this.$(".file-scope").show();
    } else {
      this.$(".file-scope").hide();
    }
    if (!this.fileInfor.belongDepartment() && !this.fileInfor.belongEnterprisePub() && _app["default"].pathRouter && _app["default"].pathRouter.inJoinShare()) {
      this.$(".file-belong").show();
    } else {
      this.$(".file-belong").hide();
    }
    if (this.fileInfor.isLocalArchived() || this.fileInfor.isArchived() && !_app["default"].ep.isArchive()) {
      this.$(".file-archive").removeClass("f-hide");
      this.$(".archive-mark").removeClass("f-hide");
    } else {
      this.$(".file-archive").addClass("f-hide");
      this.$(".archive-mark").addClass("f-hide");
    }
    this.taskIdChanged();
    this.bannedChanged();
    var dueTime = this.fileInfor.get("dueTime");
    if (dueTime && new Date(dueTime) < new Date()) {
      this.$(".project-endTime").removeClass("f-hide");
    } else {
      this.$(".project-endTime").addClass("f-hide");
    }
    Dispatcher.on(MDEvents.VersionListChanged, this._fileVersionListChange, this);
    Dispatcher.on(MDEvents.FileSyncStateChanged, this._fileVersionListChange, this);
    Dispatcher.on(MDEvents.TaskCreated, this._TaskCreated, this);
    Dispatcher.on(MDEvents.RefreshIcon, this._refreshIcon, this);
    this.registerEvents();

    // if(this.fileInfor.belongDepartment()){
    this.renderSecurity();
    this.renderAppenedPer();
    // }

    if (this.isSearch) {
      if (this.fileInfor.get("score") == 1) {
        var filename = this.fileInfor.getFileName().split(this.fileInfor.get("querystring")).join("<span class='bg-yellow'>" + this.fileInfor.get("querystring") + "</span>");
        this.$(".name").html(filename);
      }
      var searchTextArr = this.fileInfor.get("searchHighlight") || [];
      if (searchTextArr.length > 0) {
        var len = searchTextArr.length < 3 ? searchTextArr.length : 3;
        var reg1 = /((<span>){1}(([\u4e00-\u9fa5]|[a-zA-Z]|[0-9])*<\/span><span>)+([\u4e00-\u9fa5]|[a-zA-Z]|[0-9])*<\/span>)/;
        var reg2 = /(([\u4e00-\u9fa5]|[a-zA-Z]|[0-9])+(?=<\/span>))+/g;
        var reg3 = /(([\u4e00-\u9fa5]|[a-zA-Z]|[0-9])+(?=<\/span>)){1}/g;
        for (var i = 0; i < len; i++) {
          // var searchTextArray = searchTextArr[i].match(reg1);
          var searchText = "";
          // if(_.isArray(searchTextArray) && searchTextArray.length > 0) {
          //   searchText = searchTextArray[i].match(reg2).join('');
          // }else {

          //   searchText = searchTextArr[i].match(reg3)[0]
          // }
          var str = searchTextArr[i].split('<span>').join('+++').split('</span>').join('---');
          var text = "<div class='search-result'>";
          // text = text + '<div class="item">...' + '内容搜索' + '...</div>'
          text += "</div>";
          var $text = $(text);
          // $text.find("span").addClass("mg-10");
          this.$el.append($text);
          str = _.escape(str);
          str = str.split('+++').join('<span>').split('---').join('</span>');
          $text.html('<div class="item">...' + str + "...</div>");
          $text.on("click", function () {
            _this._searchTextClickHandle(searchText);
          });
        }
      }
      if (this.fileInfor.getFileName().indexOf(this.fileInfor.get("querystring")) < 0 && searchTextArr.length < 1) {
        if (this.fileInfor.get("comment").indexOf(this.fileInfor.get("querystring")) > -1) {
          var comment = this.fileInfor.get("comment").split(this.fileInfor.get("querystring")).join("<span class='bg-yellow'>" + this.fileInfor.get("querystring") + "</span>");
          var _text = "<div class='search-result'>";
          _text = _text + '<div class="item">' + BabelStr.str(2676) + "： " + comment + "</div>";
          _text += "</div>";
          var _$text = $(_text);
          // $text.find("span").addClass("mg-10");
          this.$el.append(_$text);
        }
      }
    }
    this.fileNameClicked = false;
    this._refreshCheckStatus();
    this.accessTypeChanged();
  },
  renderAppenedPer: function renderAppenedPer() {
    if (this.fileInfor.get("fileIdHasAppendPermission")) {
      if (this.fileInfor.get("fileIdHasAppendPermission") == this.fileInfor.getFileId()) {
        this.$(".append-per").show();
        this.$(".append-per-from-parent").hide();
      } else {
        this.$(".append-per-from-parent").show();
        this.$(".append-per").hide();
      }
    } else {
      this.$(".append-per").hide();
      this.$(".append-per-from-parent").hide();
    }
  },
  showTaskMenus: function showTaskMenus($e) {
    $e.stopPropagation();
    this._showMoreMenu($e, {
      showOnlySubMeny: true,
      submenuType: "task"
    });
  },
  renderSecurity: function renderSecurity() {
    var $security = this.$(".security");
    var type = Math.floor(Math.random() * 10) % 3;
    var secretLevelId = this.fileInfor.getSecretLevelId();
    _app["default"].getAllSecretLevels(function (list) {
      var index = _.findIndex(list, {
        id: secretLevelId
      });
      if (index >= 0) {
        var text = list[index].text;
        var cls = "";
        var tip = "";
        switch (index) {
          case 3:
            cls = "bg-Cred";
            tip = BabelStr.str(7230);
            break;
          case 2:
            cls = "bg-Orange";
            tip = BabelStr.str(7231);
            break;
          case 1:
            cls = "blue-background";
            tip = BabelStr.str(7232);
        }
        $security.attr("data-tooltip", tip);
        $security.html(text).removeClass("bg-Cred bg-Orange blue-background").addClass(cls).show();
        if (index == 0) {
          $security.hide();
        } else {
          $security.show();
        }
      } else {
        $security.hide();
      }
    });
  },
  commentClickHandler: function commentClickHandler() {
    if (!this.isCommentListViewExist()) {
      this.commentClicked();
      // 每一行独立保存评论展开状态，允许多个评论区同时展开并在滚回时恢复。
      // 状态保存在 body 实例中，避免污染可能被全局缓存的数据模型。
      if (this.superView && this.superView.virtualScroll) {
        this.superView.setVirtualRowState(this.fileInfor, 'commentExpanded', true);
      }
      this._createCommentListView();
    } else {
      this.removeSubView(this.commentListView);
      this.commentListView = undefined;
      // 评论关闭后同步清理虚拟状态，防止滚回可视区时再次恢复。
      this.superView && this.superView.clearVirtualRowState && this.superView.clearVirtualRowState(this.fileInfor, 'commentExpanded');
    }
    // 评论打开或关闭都会改变 row 高度，需要刷新动态高度缓存。
    this.superView && this.superView.refreshVirtualRowHeights && this.superView.refreshVirtualRowHeights();
  },
  isCommentListViewExist: function isCommentListViewExist() {
    return !!this.commentListView;
  },
  // 统一评论 view 的创建入口，供用户点击和虚拟 row 状态恢复共同使用。
  _createCommentListView: function _createCommentListView() {
    if (this.commentListView) {
      return;
    }
    this.commentListView = new _MDFileCommentListView["default"]({
      fileId: this.fileInfor.getFileId(),
      refreshCount: this._refreshCount,
      fileInfor: this.fileInfor
    });
    this.addSubView(this.commentListView);
  },
  removeCommentView: function removeCommentView() {
    this.removeSubView(this.commentListView);
    this.commentListView = undefined;
    // 外部关闭评论时也必须同步清理虚拟状态和图标状态。
    this.superView && this.superView.clearVirtualRowState && this.superView.clearVirtualRowState(this.fileInfor, 'commentExpanded');
    this.extraZone && this.extraZone.setCommentExpanded(false);
    this.superView && this.superView.refreshVirtualRowHeights && this.superView.refreshVirtualRowHeights();
  },
  _refreshCount: function _refreshCount(count) {
    this.extraZone && this.extraZone.refreshCommentCount(count);
  },
  _hoverRow: function _hoverRow(e) {
    // console.log('------------- mouse hovered!');
    if (window.innerWidth < 900) {
      this.$(".row-hover-btn").hide();
    } else {
      this.$(".row-hover-btn").show();
    }
  },
  createTrashDispBtn: function createTrashDispBtn(f, showStickTop) {
    // var filePaths = MDFilePathManager.getFilePaths()
    var delCap = BabelStr.str(32); // 删除
    var restoreCap = BabelStr.str(3063); // 恢复
    if (f.isDeletedOrgin()) {
      return ['<button class="delBtn" title="' + delCap + '">' + delCap + '</button><button class="restoreBtn" title="' + restoreCap + '">' + restoreCap + "</button>"];
    } else {
      return [];
    }
  },
  createDispBtn: function createDispBtn(f, showStickTop) {
    if (this.isUsedAdvancedSearch) {
      return [];
    }
    if (f.isDeleted()) {
      return this.createTrashDispBtn(f, showStickTop);
    }
    var btns = [];
    var shareName = _MDLocalString["default"].getLocalString(13);
    var isClient = _app["default"].isInClient();

    // 编辑
    var ctl = new _MDFileActionController["default"]();
    ctl.setFileInfors([f]);
    btns.push('<span class="mgr-20 row-btn lock-state f-hide"></span>');
    if (ctl.canShowEditBtn()) {
      var txt = _MDLocalString["default"].getLocalString(21530);
      btns.push('<span class="row-btn edit-office-btn row-hover-btn  icon row-edit" data-tooltip="' + txt + '" data-tooltip-dir="top"></span>');
    }
    if (ctl.canShowOnlineEditBtn()) {
      var txt = _MDLocalString["default"].getLocalString(5314);
      btns.push('<span class="row-btn edit-online-office-btn row-hover-btn  icon row-online-edit" data-tooltip="' + txt + '" data-tooltip-dir="top"></span>');
    }
    var toolTip = ctl.canDepShowFileControl() ? _MDLocalString["default"].getLocalString(2508) : _MDLocalString["default"].getLocalString(2530);
    if (f.isDepartmentFolder() && (_app["default"].currentUser.isEpAdminUser() || f.canManageDepMember())) {
      // var txt = MDLocalString.getLocalString(2508);
      btns.push('<span class="row-btn navigate-to-admin row-hover-btn prevent-mouse icon row-team-manage" data-tooltip="' + toolTip + '" data-tooltip-dir="top"></span>');
    }
    if (f.canEditProject() && f.isProject()) {
      console.log("-------- can edit project:" + f.getFileName());
      txt = _MDLocalString["default"].getLocalString(2833);
      btns.push('<span class="row-btn proj-edit-btn row-hover-btn prevent-mouse icon  row-proj-manage" data-tooltip="' + txt + '" data-tooltip-dir="top"></span>');
    }
    if (_app["default"].isInClient()) {
      if (f.canDownload() && !f.getLinkFileUrl()) {
        var txt = _MDLocalString["default"].getLocalString(29);
        btns.push('<span class="row-btn downloadBtn row-hover-btn prevent-mouse icon row-download" data-tooltip="' + txt + '" data-tooltip-dir="top"></span>');
      }
      // 分享
      if (f.canShare()) {
        shareName = _MDLocalString["default"].getLocalString(13);
        btns.push('<span class="row-btn shareBtn row-hover-btn prevent-mouse icon row-share" data-tooltip="' + shareName + '" data-tooltip-dir="top"></span>');
      }
      var txt = _MDLocalString["default"].getLocalString(37);
      if (!this.isUsedAdvancedSearch) {
        btns.push('<span class="row-btn moreBtn icon row-more prevent-mouse"  data-tooltip="' + txt + '" data-tooltip-dir="top"></span>');
      }
      return btns;
    }
    if (this.channel != _MDChannelType["default"].msbox) {
      // 置顶
      if (f.canStickonTop() && showStickTop) {
        if (f.getStickonTop()) {
          var txt = _MDLocalString["default"].getLocalString(183);
          btns.push('<span class="row-btn cancel-top-btn row-hover-btn prevent-mouse icon row-notop"data-tooltip="' + txt + '" data-tooltip-dir="top"></span></span>');
        } else {
          var txt = _MDLocalString["default"].getLocalString(184);
          var txt1 = _MDLocalString["default"].getLocalString(36);
          btns.push('<span class="row-btn stickon-top-btn row-hover-btn prevent-mouse icon row-totop"data-tooltip="' + txt + '" data-tooltip-dir="top"></span>');
        }
      }

      // 下载
      if (f.canDownload() && !f.getLinkFileUrl()) {
        var txt = _MDLocalString["default"].getLocalString(29);
        btns.push('<span class="row-btn downloadBtn row-hover-btn prevent-mouse icon  row-download" data-tooltip="' + txt + '" data-tooltip-dir="top"></span>');
      }
      // 分享
      if (f.canShare()) {
        shareName = _MDLocalString["default"].getLocalString(13);
        btns.push('<span class="row-btn shareBtn row-hover-btn prevent-mouse icon row-share" data-tooltip="' + shareName + '" data-tooltip-dir="top"></span>');
      }

      // 上传新版本
      if (f.canUploadVersion()) {
        var txt = _MDLocalString["default"].getLocalString(28);
        btns.push('<span class="row-btn creNewVerBtn row-hover-btn prevent-mouse icon row-newver" data-tooltip="' + txt + '" data-tooltip-dir="top"></span>');
      }

      // 管理团队或部门
      if (f.isTeamFolder() && !f.get("applyForTeamOrProj")) {
        var txt = _MDLocalString["default"].getLocalString(185);
        btns.push('<span class="jump-cvs-btn row-hover-btn icon row-discuss" data-tooltip="' + txt + '" data-tooltip-dir="top"></span>');
        if (f.isCurUserManager()) {
          var txt = _MDLocalString["default"].getLocalString(186);
          btns.push('<span class="row-btn manage-team-btn row-hover-btn icon  prevent-mouse ic-team-set" data-tooltip="' + txt + '" data-tooltip-dir="top"></span>');
          if (!f.isTimeExpired()) {
            var txt = _MDLocalString["default"].getLocalString(71);
            btns.push('<span class="add-member-btn row-hover-btn icon row-team-add" data-tooltip="' + txt + '" data-tooltip-dir="top"></span>');
          }
        } else if (!_app["default"].isEpVersion()) {
          var txt = _MDLocalString["default"].getLocalString(187);
          btns.push('<span class="row-btn manage-team-btn icon row-hover-btn  prevent-mouse ic-team-set" data-tooltip="' + txt + '" data-tooltip-dir="top"></span>');
        }
      } else if (f.isDepartmentFolder()) {
        // if (app.currentUser.isEpAdminUser() || f.canManageDepMember()) {
        //   var txt = MDLocalString.getLocalString(2508);
        //   btns.push('<span class="navigate-to-admin row-hover-btn prevent-mouse icon row-team-manage" data-tooltip="'+txt+'" data-tooltip-dir="top"></span>');
        // }
      }

      // 讨论组
      if ((f.isTeamFolder() || f.isDepartmentFolder()) && !f.get("applyForTeamOrProj")) {
        var txt = _MDLocalString["default"].getLocalString(185);
        btns.push('<span class="row-btn jump-cvs-btn row-hover-btn icon row-discuss prevent-mouse" data-tooltip="' + txt + '" data-tooltip-dir="top"></span>');
      }

      // 文件收集箱 和 审批
      if (f.canManageMsBox() && f.isManuscriptBox()) {
        var txt = _MDLocalString["default"].getLocalString(180);
        btns.push('<span class="row-btn edit-msgbox-btn row-hover-btn icon row-msgbox-edit prevent-mouse" data-tooltip="' + txt + '" data-tooltip-dir="top"></span>');
      } else if (_app["default"].isEpVersion()) {
        if (f.canShowStartEvaluation() || f.canShowReStartEvaluation()) {
          var txt = _MDLocalString["default"].getLocalString(181);
          btns.push('<span class="row-btn start-eval-btn row-hover-btn icon row-start-eval prevent-mouse" data-tooltip="' + txt + '" data-tooltip-dir="top"></span>');
        } else if (f.canShowDoingvaluation()) {
          var txt = _MDLocalString["default"].getLocalString(182);
          if (f.isFolder() && !f.isPassed()) {
            txt = _MDLocalString["default"].getLocalString(524); //   结束审批
          }
          if (f.get("multFile")) {
            txt = _MDLocalString["default"].getLocalString(182); //   查看审批
          }
          btns.push('<span class="row-btn look-eval-btn icon row-hover-btnicon row-start-eval prevent-mouse" data-tooltip="' + txt + '" data-tooltip-dir="top"></span>');
        }
      }
    } else {
      if (f.canManageMsBox() && f.isManuscriptBox()) {
        var txt = _MDLocalString["default"].getLocalString(180);
        btns.push('<span class="row-btn edit-msgbox-btn row-hover-btn icon row-msgbox-edit prevent-mouse" data-tooltip="' + txt + '" data-tooltip-dir="top"></span>');
      }
    }
    var txt = _MDLocalString["default"].getLocalString(37);
    if (!this.isUsedAdvancedSearch) {
      btns.push('<span class="row-btn moreBtn icon row-more prevent-mouse"  data-tooltip="' + txt + '" data-tooltip-dir="top"></span>');
    }
    return btns;
  },
  refreshBtns: function refreshBtns() {
    this.$(".btns").empty();
    this.$(".btns").append($(this.createDispBtn(this.fileInfor, this.showStickTop).join("")));
    this._refreshCheckStatus();
  },
  registerEvents: function registerEvents() {
    var self = this;
    _MDHomeTableRowView["default"].prototype.registerEvents.call(this);
    if (this.allowMoveInFolder) {
      this.$el.off("click.row");
      this.$el.on("click.row", ".name-wrapp .name", this.fileNameClickHandler);
      // this.$el.on('click.row', '.name-wrapp .stickonTopMark', this.fileNameClickHandler);
      this.$el.on("click.row", ".thumbWrapper", this.fileNameClickHandler);

      // this.$el.off('mousedown.row')
      // this.$el.off('mouseup.row')
      // this.$el.on('mousedown.row', '.msg-comment-btn', this.commentStrDownHandler);
      // this.$el.on('mouseup.row', '.msg-comment-btn', this.commentStrUpHandler);
    }
    this.$el.find(".row-cells").off("mouseover.t-row");
    this.$el.find(".row-cells").on("mouseover.t-row ", function (e) {
      self._hoverRow(e);
    });
  },
  setFileInfor: function setFileInfor(fileInfor) {
    var self = this;
    _MDHomeTableRowView["default"].prototype.setFileInfor.call(this, fileInfor);
    this.listenTo(this.fileInfor, "change", this.fileInforAttrChangedHandler);
    this.listenTo(_app["default"].currentFolder, "change", this.folderShareStatusChange);
    if (!this.fileInfor.isFolder() && this.fileInfor.needLoadFromServer()) {
      this.fileInfor.setUploadStatus("");
      this.fileInfor.setUploadStatus("processNewFile");
    }
    // if(this.fileInfor && this.fileInfor.canReadCommentOnlyByAction() && !app.pathRouter.isInTrash()  || app.pathRouter.isInMyfocus()){
    if (this.fileInfor && !this.fileInfor.isDeleted() && !window.isApprovalView) {
      this.extraZone = new _MDFileExtraAttrView["default"]({
        commentClickHandler: this.commentClickHandler,
        dataCollection: self.dataCollection,
        fileInfo: this.fileInfor
      });
      this.addSubView(this.extraZone, this.$(".extra-attr"));
      // this.extraZone.initWithFileInfo(this.fileInfor);
    }
  },
  _openParentFolderHandler: function _openParentFolderHandler() {
    var parentId = this.fileInfor.getParentFolderId();
    if (this.fileInfor.isDeletedOrgin()) {
      _app["default"].pathRouter.openNetTab("/main.do#trash");
      return;
    } else if (parentId == "0" && this.fileInfor.isDepartmentFolder()) {
      _app["default"].pathRouter.openNetTab("/main.do#epfile");
      return;
    }
    _MMNetDiskDataController["default"].getFileInfoFromServer(this.fileInfor.getFileId(), function (file) {
      console.log(file);
      if (file.canRead()) {
        _app["default"].pathRouter.openNewTabByFileId(parentId);
      } else {
        _MDSnackbarView["default"].show(BabelStr.str(5474));
      }
    }, function (code, msg) {
      _MDSnackbarView["default"].show(msg);
    });
  },
  // _openParentFolderHandler: function ($e) {
  //   var fileId = this.fileInfor.getParentFolderId();
  //   if (this.fileInfor.isDeletedOrgin()) {
  //     app.pathRouter.openNetTab("/main.do#trash");
  //   } else if (
  //     this.fileInfor.get("parentId") == "0" &&
  //     this.fileInfor.isDepartmentFolder()
  //   ) {
  //     app.pathRouter.openNetTab("/main.do#epfile");
  //   } else {
  //     app.pathRouter.openNewTabByFileId(fileId);
  //   }
  //   // Dispatcher.trigger(MDEvents.OpenFolderFromOtherChannel, { fileId: fileId, fileInfo: this.fileInfor });
  // },

  _loadFileInofFromServer: function _loadFileInofFromServer(timeWait) {
    var self = this;
    if (!timeWait) {
      timeWait = 500;
    }
    if (this.fileInfor.needLoadFromServer()) {
      var get2ndFileInfo = false;
      if (this.fileInfor.getUploadStatus && this.fileInfor.getUploadStatus()) {
        get2ndFileInfo = true;
      }
      _MMNetDiskDataController["default"].getFileInfosFromServer([self.fileInfor.getFileId()], get2ndFileInfo, function (newFileInfos) {
        var newFileInfo = newFileInfos[0];
        self.fileInfor.setPermission(newFileInfo.getPermission());
        self.fileInfor.set("pdfPassword", newFileInfo.get("pdfPassword"));
        self.fileInfor.setFileStatus(newFileInfo.getFileStatus());
        self.fileInfor.setCurrentVersionEvaluation(newFileInfo.getCurrentVersionEvaluation());
        if (newFileInfo.needLoadFromServer()) {
          if (!self.timeoutNeedClear) {
            var nextWait = timeWait * 2;
            if (timeWait < 1000 * 60 * 60) {
              self.rollPolling = setBabelTimeout(function () {
                self._loadFileInofFromServer(nextWait);
              }, timeWait);
            }
          } else {
            self.fileInfor.setUploadStatus("finished");
          }
        } else {
          self.fileInfor.setUploadStatus("finished");
        }
      }, function () {});
    } else {
      self.fileInfor.setUploadStatus("finished");
      self.fileInfor.setCurrentVersionEvaluation(0);
    }
  },
  fileInforAttrChangedHandler: function fileInforAttrChangedHandler(model, options) {
    if (this.fileInfor.hasChanged("fileName")) {
      this._fileInNameChangedHandler();
    }
    if (this.fileInfor.hasChanged("fileSize")) {
      this._fileInSizeChangedHandler();
    }
    if (this.fileInfor.hasChanged("currentVersion")) {
      this._fileInVerChangedHandler();
    }
    if (this.fileInfor.hasChanged("versionList")) {
      // if(this.fileInfor.get("versionList").length==1){
      //    this._fileVersionListChange(this.fileInfor.get)
      // }
      // var versionCollection = this.fileInfor.get('versionList');
      // this._fileVersionListChange(versionCollection);
      // var versionList = this.fileInfor.getFileVersionList();
      // if(!this.versionList){
      //  this.stopListening(this.versionList);
      // }
      // if(versionList){
      //  this.listenTo(versionList , 'update' , this._fileVersionListChange);
      //  this.versionList = versionList ;
      // }
    }
    if (this.fileInfor.hasChanged("isSharing")) {
      this._refreshShareStatus();
    }
    if (this.fileInfor.hasChanged("mtime")) {
      // this._updateModifiedTime();
    }
    if (this.fileInfor.hasChanged("lastModifyUserName")) {
      this._updateModifyName();
    }
    if (this.fileInfor.hasChanged("unreadFileCount")) {
      this._unReadMaskChanged();
    }
    if (this.fileInfor.hasChanged("uploadStatus")) {
      this._uploadStatusChanged();
    }
    if (this.fileInfor.hasChanged("isFocusFile")) {
      this.isFocusFIleChanged();
    }
    if (this.fileInfor.hasChanged("currentVersionSize")) {
      this.$(".size-col").text(_app["default"].getFileSizeDescription(this.fileInfor.get("currentVersionSize")));
    }
    if (this.fileInfor.hasChanged("currentVersionEvaluation") || this.fileInfor.hasChanged("evaluationStatus")) {
      this.curEvaluationChanged();
    }
    if (this.extraZone) {
      this.extraZone.fileInforAttrChangedHandler(model, options);
    }
    if (this.fileInfor.hasChanged("manuscriptBoxTime")) {
      this._refreshEndTime();
    }
    if (this.fileInfor.hasChanged("comment")) {
      this._refreshCommentStr();
    }
    if (this.fileInfor.hasChanged("lockedByUser")) {
      this._refreshCheckStatus();
    }
    if (this.fileInfor.hasChanged("secretLevelId")) {
      this.renderSecurity();
    }
    if (this.fileInfor.hasChanged("fileIdHasAppendPermission")) {
      this.renderAppenedPer();
    }
    if (this.fileInfor.hasChanged("borrowStatus")) {
      this.refreshBtns();
      this.renderBorrowStatus();
    }
    if (this.fileInfor.hasChanged("evaluationStepCount")) {
      this.renderRvaluationStepPer();
    }
    if (this.fileInfor.hasChanged("manuscriptStatus")) {
      this.renderManuscriptStatusText();
    }
    if (this.fileInfor.hasChanged("versionNo")) {
      this.refreshVersionNo();
    }
    if (this.fileInfor.hasChanged("extraStatus")) {
      this.extraStatusChanged();
    }
    if (this.fileInfor.hasChanged("taskDELid")) {
      this.taskIdChanged();
    }
    if (this.fileInfor.hasChanged("taskRENid")) {
      this.taskIdChanged();
    }
    if (this.fileInfor.hasChanged("taskORGid")) {
      this.taskIdChanged();
    }
    if (this.fileInfor.hasChanged("taskCONid")) {
      this.taskIdChanged();
    }
    if (this.fileInfor.hasChanged("banned")) {
      this.bannedChanged();
    }
    if (this.fileInfor.hasChanged("dueTime")) {
      this.dueTimeChanged();
    }
    if (this.fileInfor.hasChanged("accessType")) {
      this.accessTypeChanged();
    }
  },
  accessTypeChanged: function accessTypeChanged() {
    var type = this.fileInfor.getAccessType();
    this.$(".library-mark").attr("accesstype", type);
  },
  dueTimeChanged: function dueTimeChanged() {
    var dueTime = this.fileInfor.get("dueTime");
    if (dueTime && new Date(dueTime) < new Date()) {
      this.$(".project-endTime").removeClass("f-hide");
    } else {
      this.$(".project-endTime").addClass("f-hide");
    }
  },
  extraStatusChanged: function extraStatusChanged() {
    this.refreshBtns();
    if (this.fileInfor.isLocalArchived()) {
      this.$(".file-archive").removeClass("f-hide");
      this.$(".archive-mark").removeClass("f-hide");
    } else {
      this.$(".file-archive").addClass("f-hide");
      this.$(".archive-mark").addClass("f-hide");
    }
  },
  taskIdChanged: function taskIdChanged() {
    if (this.fileInfor.getTaskDELid() || this.fileInfor.getTaskRENid() || this.fileInfor.getTaskORGid() || this.fileInfor.getTaskCONid()) {
      this.$(".file-auto-task").removeClass("f-hide");
    } else {
      this.$(".file-auto-task").addClass("f-hide");
    }
  },
  bannedChanged: function bannedChanged() {
    if (this.fileInfor.isBannedFile()) {
      this.$(".banned-file-mark").siblings().not(".name").addClass("f-hide");
      this.$(".banned-file-mark").removeClass("f-hide");
      this.$(".banned-file-mark").siblings().not(".name").addClass("f-hide");
    } else {
      // this.$(".banned-file-mark").siblings().not(".name").removeClass("f-hide")
      this.$(".banned-file-mark").addClass("f-hide");
    }
  },
  refreshVersionNo: function refreshVersionNo() {
    var versionNo = this.fileInfor.getVersionNo();
    this.$(".version-col").text(versionNo);
  },
  renderManuscriptStatusText: function renderManuscriptStatusText() {
    var status = this.fileInfor.getManuscriptStatusText();
    this.$(".manuscript-content").html(status);
  },
  _manuscriptStatusChanged: function _manuscriptStatusChanged(e) {
    var status = this.fileInfor.getManuscriptStatus();
    var canSetManuscriptStatus = this.fileInfor.canSetManuscriptStatus();
    if (status == 0 && !canSetManuscriptStatus) {
      _MDAlertView["default"].showStandardPrompt({
        message: BabelStr.str(8565)
      });
      return;
    }
    var win = new _MDManuscriptStatusChangedWinView["default"]({
      fileInfor: this.fileInfor
    });
    win.show();
  },
  renderRvaluationStepPer: function renderRvaluationStepPer() {
    var str = this.fileInfor.createEvalStrHtml();
    this.$(".eval-span").html(str);
    this.refreshBtns();
  },
  curEvaluationChanged: function curEvaluationChanged() {
    var str = this.fileInfor.createEvalStrHtml();
    this.$(".eval-span").html(str);

    // if(app.pathRouter.isInEvaluation()){
    //   Dispatcher.trigger(MDEvents.evaluationChangedInEvaluationPanel)
    // }
    this.refreshBtns();
  },
  _refreshCommentStr: function _refreshCommentStr() {
    var commentStr = this.fileInfor.getCommentStr();
    // commentStr = _.unescape(commentStr)
    if (!commentStr || commentStr.length == 0) {
      this.$(".msg-comment-btn").hide();
    } else {
      this.$(".msg-comment-btn").show();
      this.$(".msg-comment-btn").attr("data-tooltip", commentStr);
    }
  },
  renderBorrowStatus: function renderBorrowStatus() {},
  //_fileVersionListChange: function(versionCollection){
  _fileVersionListChange: function _fileVersionListChange(fileId) {
    if (this.fileInfor && this.fileInfor.getFileId() == fileId) {
      this.$(".thumbWrapper i").removeClass("ver-icon");
      this._refreshShareStatus();
    }
  },
  _TaskCreated: function _TaskCreated(params) {
    var fileId = params.fileId,
      taskDELid = params.taskDELid,
      taskRENid = params.taskRENid,
      taskORGid = params.taskORGid,
      taskCONid = params.taskCONid;
    if (this.fileInfor && this.fileInfor.getFileId() == fileId) {
      this.fileInfor.set("taskDELid", taskDELid);
      this.fileInfor.set("taskRENid", taskRENid);
      this.fileInfor.set("taskORGid", taskORGid);
      this.fileInfor.set("taskCONid", taskCONid);
    }
  },
  _refreshIcon: function _refreshIcon(params) {
    var fileId = params.fileId;
    if (this.fileInfor && this.fileInfor.getFileId() == fileId) {
      var thumbDiv = this.$(".thumbWrapper");
      var size = 40;
      if (_app["default"].userClentMode()) {
        size = 30;
      }
      this.fileInfor.setIconForDiv(thumbDiv, undefined, size, true);
    }
  },
  isFocusFIleChanged: function isFocusFIleChanged() {
    this.fileInfor.getIsFocusFile() ? this.$(".star-wrap").show() : this.$(".star-wrap").hide();
  },
  _uploadStatusChanged: function _uploadStatusChanged() {
    if (this.fileInfor.isInTrash()) {
      return;
    }
    var self = this;
    // if (this.fileInfor.getUploadStatus() == 'finished') {
    //   this.progress.done(function() {
    //     setBabelTimeout(function() {
    //       self.$el.removeClass('uploading');
    //       self.$('.processNewFile').remove();
    //       self.progress = null;

    //     }, 300);
    //   })
    //   var thumbDiv = this.$(".thumbWrapper");
    //   this.fileInfor.setIconForDiv(thumbDiv);
    //   localStorage['wiatingConverting' + this.fileInfor.getFileId()] = 0;
    // } else if (this.fileInfor.getUploadStatus() == 'processNewFile' && app.pathRouter.curChannel != 'trash') {

    //   if (this.rollPolling) {
    //     clearTimeout(this.rollPolling);
    //   };
    //   this.timeoutNeedClear = false;
    //   this.rollPolling = setBabelTimeout(function() {
    //     self._loadFileInofFromServer();
    //   }, 100);

    //   this.$el.addClass('uploading');
    //   this.$('.processNewFile').remove();
    //   var $waitingServer = $('<div class="processNewFile">' +
    //     '<div class="processTitle">' + MDLocalString.getLocalString(108) + '...</div>' +
    //     '<div class="processProg"></div>' +
    //     '<div>');
    //   this.$('.contentWrapper .content')
    //   this.$('.contentWrapper .content').after($waitingServer);
    //   this.progress = new MDProgress();
    //   this.progress.renderTo($waitingServer.find('.processProg'));
    //   this.progress.start();

    //   var lastMile = localStorage['wiatingConverting' + this.fileInfor.getFileId()];
    //   if (lastMile) {
    //     this.progress.setMile(lastMile);
    //   };
    // }
  },
  _fileIsReady: function _fileIsReady() {
    if (!this.fileInfor) {
      return false;
    }
    var status = this.fileInfor.getUploadStatus();
    if (status == undefined || status == "finished" || status == "processNewFile") {
      return true;
    }
    return false;
  },
  _unReadMaskChanged: function _unReadMaskChanged() {
    if (this.fileInfor.get("unreadFileCount") == 0) {
      this.$(".unread-mark").remove();
    } else {
      this.$(".unread-mark").remove();
      var unreadCap = BabelStr.str(166);
      this.$(".title-col>div").append('<span class="unread-mark"  data-tooltip="' + unreadCap + '" data-tooltip-dir="top"></span>');
    }
  },
  _updateModifiedTime: function _updateModifiedTime() {
    var value = this.fileInfor.get("mtime");
    this.$(".modify-time").text(MMCommonFun.formatSec2Date(value));
  },
  _updateModifyName: function _updateModifyName() {
    var value = this.fileInfor.get("lastModifyUserName");
    this.$(".modify-name").text(value);
  },
  folderShareStatusChange: function folderShareStatusChange() {
    var isSharing = _app["default"].currentFolder.get("isSharing");
    if (_app["default"].currentFolder.hasChanged("isSharing")) {
      if (!isSharing) {
        this.fileInfor.set("isSharing", 0);
        this.fileInfor.set("newShareAll", 2);
      }
      this._refreshShareStatus();
      this._refreshCheckStatus();
    }
  },
  _refreshCheckStatus: function _refreshCheckStatus() {
    var $lockState = this.$(".lock-state");
    $lockState.addClass("f-hide");
    if (this.fileInfor.isFileLocked()) {
      if (this.fileInfor.isFileLockedByMe()) {
        // $lockState.removeClass("f-hide").text( MDLocalString.getLocalString(188) )
        $lockState.removeClass("f-hide").attr("data-tooltip", _MDLocalString["default"].getLocalString(188));
      } else {
        if (this.fileInfor.isFileLockedByOnline()) {
          $lockState.removeClass("f-hide").attr("data-tooltip", _MDLocalString["default"].getLocalString(22018));
        } else {
          var param = {
            user: this.fileInfor.getFileLockerDispName()
          };
          // $lockState.removeClass('f-hide').text( MDLocalString.getLocalString(189, param) )
          $lockState.removeClass("f-hide").attr("data-tooltip", _MDLocalString["default"].getLocalString(189, param));
        }
      }
    }
  },
  _refreshEndTime: function _refreshEndTime() {
    var $endtime = this.$(".end-time");
    var endTimeStr = this.fileInfor.getMsBoxEndTimeDispString();
    if (this.fileInfor.isMsgBoxTimeExpired()) {
      $endtime.css("min-width", "44px");
    } else {
      $endtime.css("min-width", "130px");
    }
    $endtime.text(endTimeStr);
  },
  _refreshShareStatus: function _refreshShareStatus() {
    var isSharing = this.fileInfor.get("isSharing");
    this.fileInfor.refreshFileStatusIcon(this.$(".thumbWrapper"));
  },
  // _refreshShareStatus: function() {
  //   var isSharing = this.fileInfor.get('isSharing');
  //   var $shareState = this.$('.shareState');
  //   var newShareAll = this.fileInfor.get('newShareAll');
  //   var isInSharingPath = app.pathRouter.isInSharePath();
  //   if (isSharing && !this.fileInfor.isTeamFolder()) {
  //     var pathRouter = app.pathRouter;
  //     var filePaths = app.pathRouter.getFilePaths();
  //     var isTopSharingFolder = filePaths[1] && filePaths[1].get("isSharing");

  //     if (!pathRouter.inJoinShare() &&
  //       (app.currentUser.isFileOwner(this.fileInfor.getOwnerId()) || pathRouter.hasTeamFolder() || pathRouter.hasDepartmentFolder() || isTopSharingFolder)) {

  //       var otherPeopleShare = true;
  //       var sharerName = this.fileInfor.getSharerName();

  //       if (app.currentUser.getId() != this.fileInfor.getSharerId()) {

  //         if (this.fileInfor.getSharerId() == 0) {

  //           sharerName = this.fileInfor.getOwnerName();

  //           if (!this.fileInfor.belongsToTeam() && !this.fileInfor.belongDepartment()) {

  //             if (app.currentUser.getId() != this.fileInfor.getOwnerId()) {

  //               otherPeopleShare = true;

  //             } else {

  //               otherPeopleShare = false;

  //             }

  //           } else {

  //             if (this.fileInfor.belongsToTeam()) {
  //               if (this.fileInfor.isCurUserManager()) {

  //                 otherPeopleShare = false;

  //               } else {

  //                 sharerName = "";
  //                 otherPeopleShare = false;

  //               }
  //             } else { // 部门
  //               otherPeopleShare = false;
  //             }

  //           }

  //         } else { // sharer id == 0， 没有人打开分享，只有邀请分享

  //           otherPeopleShare = true;

  //         }

  //         // if (!pathRouter.hasTeamFolder() || (pathRouter.hasTeamFolder() && pathRouter.isCurTeamManager())) {
  //         // }

  //       } else {

  //         otherPeopleShare = false;

  //       }

  //       if (otherPeopleShare) {
  //         var param = {
  //           'user': sharerName
  //         }
  //         $shareState.show().addClass('take').text( MDLocalString.getLocalString(190, param));

  //       } else {

  //         if (sharerName === "") {

  //           $shareState.show().addClass('take').text( MDLocalString.getLocalString(191));

  //         } else {

  //           if (app.pathRouter.hasDepartmentFolder() || app.pathRouter.hasTeamFolder()) {
  //             if (this.fileInfor.getSharerId() == 0) {
  //               $shareState.show().removeClass('take').text( MDLocalString.getLocalString(192));
  //             } else {
  //               $shareState.show().removeClass('take').text( MDLocalString.getLocalString(193));
  //             }

  //           } else {
  //             $shareState.show().removeClass('take').text( MDLocalString.getLocalString(191));
  //           }

  //         }

  //       }

  //     } else {
  //       // 参与者处
  //       // 在别人的分享目录下又有分享的子文件的话，那么就不再显示"分享自XXX"的标记
  //       // 重现步骤，
  //       // 1. PersonA分享目录FA
  //       // 2. PersonB 加入目录 FA
  //       // 3. PersonA在FA下创建FB,并分享FB
  //       // 4. PersonB 的FA下的FB不会显示“分享自PersonA”的标记
  //       var showOthers = (!isTopSharingFolder || pathRouter.inJoinShare());
  //       if (showOthers) {
  //         var param = {
  //           'user': ''
  //         }
  //         if (this.fileInfor.getSharerId() == 0 || this.fileInfor.belongDepartment()) {
  //           param['user'] = this.fileInfor.getOwnerName();
  //         } else {
  //           param['user'] = this.fileInfor.getSharerName();
  //         }
  //         $shareState.show().addClass('take').text( MDLocalString.getLocalString(194, param));
  //         //
  //       }
  //     }

  //   } else if (!isSharing && isInSharingPath && !newShareAll) {
  //     $shareState.show().addClass('take').text( MDLocalString.getLocalString(195));
  //   } else {
  //     $shareState.hide();
  //     this.$('.jump-cvs-btn').remove();
  //   }
  // },

  _dblclickHandler: function _dblclickHandler($e) {
    if (!this._fileIsReady()) {
      return;
    }
    if (!this.isSearch && !(this.fileInfor.canRead() || this.fileInfor.onlyReadName() && this.fileInfor.isFolder())) {
      return;
    }
    if (this.$(".btns").eventIsInner($e)) {
      return;
    }
    if ($($e.target).hasClass("prevent-dblclick") || this.$(".prevent-dblclick").eventIsInner($e)) {
      return;
    }
    this.joinerPopup && this.joinerPopup.close();
    this.fileNameClickHandler($e);
  },
  editFileHandle: function editFileHandle() {
    var ctl = new _MDFileActionController["default"]();
    ctl.setFileInfors([this.fileInfor]);
    if (ctl.canShowEditBtn()) {
      ctl.editFile();
    }
  },
  /**
   * @protected
   */
  fileNameClickHandler: function fileNameClickHandler($e) {
    var _this2 = this;
    var showSubFolderFiles = window.showSubFolderFiles;
    if (!this._fileIsReady()) {
      return;
    }
    if (!_app["default"].pathRouter.isInSearch() && !this.fileInfor.canRead()) {
      if (this.fileInfor.isMaterialClass() || this.fileInfor.isMaterialLibraryFolder()) {
        this._showMoreMenu($e);
      }
      return;
    }
    if (this.fileNameClicked) {
      return;
    }
    this.fileNameClicked = true;
    setTimeout(function () {
      _this2.fileNameClicked = false;
    }, 2000);
    if (this.fileInfor.get("multFile")) {
      this._evalBtnClicked();
      return;
    }
    var tableView = this.getTableView();
    var file = tableView.fileInfor;
    if (file && this.fileInfor.isFolder() && !_app["default"].ep.isArchive()) {
      // 切换文件时记录当前目录
      var scrollTop = tableView.bodyView.getScrollTop();
      var dataCollection = tableView.getDataCollection();
      var paths = _app["default"].pathRouter.getFilePaths();
      var ids = _.map(_app["default"].pathRouter.getFilePaths(), function (file) {
        return file.getFileId();
      });
      var item = {
        id: file.getFileId(),
        scrollTop: scrollTop,
        hashHasFetchAllData: tableView.hasFetchAllData,
        page: tableView.page,
        total: tableView.total,
        pages: tableView.getDataCollection().pages,
        showSubFolderFiles: showSubFolderFiles
      };
      if (window.DBManage && dataCollection.noCatch === false && dataCollection.length > 0) {
        if (this.fileInfor.get("unreadFileCount") > 0) {
          this.fileInfor.set("unreadFileCount", 0);
        }
        var data = dataCollection.toJSON();
        var locationHash = location.hash;
        _.each(data, function (item) {
          item.locationHash = locationHash;
        });
        DBManage.removeData("fileHistory", {
          name: "locationHash",
          value: location.hash
        }, function () {
          // if(showSubFolderFiles) {
          //   console.log("显示了子文件夹")
          //   return
          // }
          DBManage.putData("fileHistory", data, function () {
            window.filelistHistory.addItem(item);
            window.filelistHistory.clearIds(ids);
          });
        });
      }
    }
    if (this.isSearch && this.fileInfor.isFolder()) {
      _app["default"].pathRouter.openNewTabByFileId(this.fileInfor.getFileId());
    } else {
      this.openFileInEditor();
      this.checkToRemoveUnreadMark();
    }
    console.warn("-----------------fileName Clicked ----------------------");
  },
  openFileInEditor: function openFileInEditor() {
    var _this3 = this;
    if (this.fileInfor.isNotCalcActions()) {
      _MMNetDiskDataController["default"].getFileActions([this.fileInfor.getFileId()], function (newFiles) {
        var newFile = newFiles[0];
        if (newFile) {
          delete newFile.fileId;
        }
        _this3.fileInfor.set(newFile);
        _this3._openFileInEditor();
      });
    } else {
      this._openFileInEditor();
    }
  },
  _openFileInEditor: function _openFileInEditor() {
    var self = this;
    var ctl = new _MDFileActionController["default"]();
    ctl.setFileInfors([this.fileInfor]);
    if (this.fileInfor.get("applyForTeamOrProj") && this.fileInfor.get("manager") != _app["default"].currentUser.getUserId()) {
      if (this.fileInfor.isTeamFolder()) {
        _MDMessageView["default"].error(BabelStr.str(6089));
      } else {
        _MDMessageView["default"].error(BabelStr.str(6098));
      }
      return;
    }

    // .survey 双击直接进 Formbricks：指针文件的 canDownload/canUploadVersion 恒为
    // false，不在这里拦截会掉进"暂不支持在线预览"的死胡同
    if (!this.fileInfor.isFolder() && _.isFunction(this.fileInfor.isSurveyFile) && this.fileInfor.isSurveyFile()) {
      // 点击打开使用"查看表单"(summary)界面, 而非预览界面
      if (_.isFunction(this.fileInfor.canRead) && !this.fileInfor.canRead()) {
        return;
      }
      ctl.openSurveySummary(this.fileInfor);
      return;
    }
    if (!this.fileInfor.isFolder() && _app["default"].isInClient()) {
      if (!(!_app["default"].canDispInNormalBrowser() && this.fileInfor.canDispInOpenGL()) && (this.fileInfor.canDispInEditor() || _app["default"].canDispInNormalBrowser() && this.fileInfor.canDispInOpenGL())) {
        ctl.openFileInEditor(this.fileInfor, this.isHomeTableRowView, this.openInOtherChannel);
      } else if (this.fileInfor.canDownload()) {
        var alert = new _MDAlertView["default"]();
        var text = _MDLocalString["default"].getLocalString(6056); //暂不支持在线预览该文件，是否用本地应用程序打开？
        alert.show({
          width: 400,
          title: _MDLocalString["default"].getLocalString(170),
          // --- '提示'
          message: text,
          buttons: [{
            label: _MDLocalString["default"].getLocalString(154),
            //'确认'
            onClick: function onClick() {
              if (self.fileInfor.canUploadVersion()) {
                ctl.editFile();
              } else {
                ctl.readonlyOpen();
              }
            }
          }, {
            label: _MDLocalString["default"].getLocalString(155) //'取消'
          }]
        });
      } else {
        var _alert = new _MDAlertView["default"]();
        var _text2 = _MDLocalString["default"].getLocalString(24022); //暂不支持在线预览该文件
        _alert.show({
          width: 400,
          title: _MDLocalString["default"].getLocalString(170),
          // --- '提示'
          message: _text2,
          buttons: [{
            label: _MDLocalString["default"].getLocalString(154) //'取消'
          }]
        });
      }
    } else {
      ctl.openFileInEditor(this.fileInfor, this.isHomeTableRowView, this.openInOtherChannel);
    }
    console.warn("-----------------fileName openFileInEditor ----------------------");
  },
  viewWillUnRendered: function viewWillUnRendered() {
    _MDHomeTableRowView["default"].prototype.viewWillUnRendered.call(this);
    this.timeoutNeedClear = true;
    if (this.rollPolling) {
      if (this.progress) {
        localStorage["wiatingConverting" + this.fileInfor.getFileId()] = this.progress.getMile();
      }
      clearTimeout(this.rollPolling);
    }
  },
  // btns clicked
  operationBtnClickHandler: function operationBtnClickHandler($e) {
    var _this4 = this;
    var $btn = $($e.target);
    if (this.btnDisabled) {
      return;
    }
    this.btnDisabled = true;
    setTimeout(function () {
      _this4.btnDisabled = false;
    }, 2000);
    // if (this.operationBtnTimer) {
    //   clearTimeout(this.operationBtnTimer);
    // }
    // this.operationBtnTimer = setTimeout(() => {
    if ($btn.hasClass("creNewVerBtn")) {
      _MDLocalFileCollector["default"].openNewVersionFileFinder(this.fileInfor);
    }
    // MMNetDiskDataController.checkEpUserLogined(() => {
    if ($btn.hasClass("shareBtn")) {
      var wind = new _MDShareFileWindowView["default"]({
        fileInfor: this.fileInfor
      });
      wind.show();
    } else if ($btn.hasClass("manage-team-btn")) {
      this._openTeamManageView();
    } else if ($btn.hasClass("jump-cvs-btn")) {
      this._jumpToConversation();
    } else if ($btn.hasClass("gotoParentFolder")) {
      this._jumpToParentFolder();
    } else if ($btn.hasClass("start-eval-btn")) {
      this._startEval($e);
    } else if ($btn.hasClass("restart-eval-btn")) {
      this._restartEval($e);
    } else if ($btn.hasClass("look-eval-btn")) {
      this._evalBtnClicked($e);
    } else if ($btn.hasClass("edit-msgbox-btn")) {
      this._editMsBoxBtnClicked($e);
    } else if ($btn.hasClass("edit-office-btn")) {
      this._editOfficeBtnClicked($e);
    } else if ($btn.hasClass("edit-online-office-btn")) {
      this.onlineEditFile($e);
    } else if ($btn.hasClass("downloadBtn")) {
      this._downloadClicked($e);
    } else if ($btn.hasClass("navigate-to-admin")) {
      this._navigateToAdmin();
    } else if ($btn.hasClass("row-proj-manage")) {
      this._editProject();
    } else {
      _MDHomeTableRowView["default"].prototype.operationBtnClickHandler.call(this, $e);
    }
    //   });
    // }, 300);
  },
  _editProject: function _editProject() {
    var ctl = new _MDFileActionController["default"]({
      fileInfors: [this.fileInfor]
    });
    ctl.showEditProject();
  },
  _navigateToAdmin: function _navigateToAdmin() {
    // if(!app.pathRouter.inDepartment()){
    // viewManager.get("mainPanelView").dispDepManager(this.fileInfor.get("departmentId"), this.fileInfor.getFileName(), this.fileInfor.getFileId(), this.fileInfor);
    var actionController = new _MDFileActionController["default"]({
      channel: _MDChannelType["default"].file
    });
    actionController.setFileInfors([this.fileInfor]);
    if (actionController.canDepShowFileControl()) {
      actionController.manageDepInfo();
    } else {
      actionController.manageDepMember();
    }

    // }else{
    //   var departId = this.fileInfor.get('departmentId');
    //   var departName = this.fileInfor.getFileName();
    //   var folderId = this.fileInfor.getFileId();
    //   var serveForSingleDep = !app.currentUser.isEpAdminUser() && this.fileInfor.canManageDepMember();
    //   var rootNavigationPageView = new MEStaffNavigationPageView({
    //     departId: departId,
    //     departName: departName,
    //     folderId: folderId,
    //     serveForSingleDep: serveForSingleDep,
    //     fileInfo: this.fileInfor
    //   });
    //   this.navigationView.push(rootNavigationPageView);
    // }
  },
  _downloadClicked: function _downloadClicked($e) {
    var ctl = new _MDFileActionController["default"]({
      fileInfors: [this.fileInfor]
    });
    ctl.downloadFile();
  },
  _jumpToParentFolder: function _jumpToParentFolder() {
    var topId = "0";
    var targetId = this.fileInfor.get("parentId");
    if (this.fileInfor.isOwner() || this.fileInfor.isSharer() || this.fileInfor.isCurUserManager()) {
      _app["default"].pathRouter.navigate("file/" + targetId, {
        trigger: true
      });
    } else {
      _app["default"].pathRouter.navigate("", {
        trigger: true
      });
    }
  },
  _openTeamManageView: function _openTeamManageView() {
    var wind = new _MDTeamSettingWindowView["default"]({
      teamFolderId: this.fileInfor.getFileId()
    });
    wind.show();
  },
  _createMoreMenuItem: function _createMoreMenuItem(ctl, menu) {
    var self = this;
    var preMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(38),
      // 预览
      iconCls: "icon menu-icon menu-prevew",
      onAction: function onAction() {
        self.openFileInEditor();
      }
    });
    var renameMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(30),
      // 重命名
      onAction: function onAction() {
        ctl.renameFile();
      }
    });
    var downloadMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(29),
      // 下载
      onAction: function onAction() {
        ctl.downloadFile();
      }
    });
    var delMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(32),
      // 删除
      onAction: function onAction() {
        ctl.deleteFiles();
      }
    });
    var moveMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(31),
      //移动
      onAction: function onAction() {
        ctl.moveFiles(self.deleteAfterMove);
      }
    });
    var shareLinkMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(196),
      // 获取分享链接地址
      iconCls: "icon menu-icon  menu-link",
      onAction: function onAction() {
        var rowView = self;
        var $contentWrapper = rowView.$(".contentWrapper");
        if (!self.requestShareLinkPopup) {
          var requestShareLinkPopup = new _MDRequestSharelinkPopupView["default"]({
            fileInfor: rowView.fileInfor
          });
          self.listenToOnce(self.superView, "scroll", function () {
            requestShareLinkPopup.close();
          });
          requestShareLinkPopup.show({
            width: 400,
            direction: _popupPos["default"].BOTTOM_LEFT,
            triggerView: $contentWrapper.get(0),
            onClose: function onClose() {
              self.requestShareLinkPopup = null;
            }
          });
          self.requestShareLinkPopup = requestShareLinkPopup;
        }
      }
    });
    var verMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(35),
      // '查看版本'
      iconCls: "icon menu-icon menu-ver",
      onAction: function onAction() {
        ctl.showFileVersion();
      }
    });
    var infoMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(40),
      // 查看详情
      iconCls: "icon menu-icon menu-info",
      onAction: function onAction() {
        ctl.showFileInfor();
      }
    });
    ctl.canPreview() && menu.addItem(preMenuItem);
    ctl.canRename() && menu.addItem(renameMenuItem);
    ctl.canDownload() && menu.addItem(downloadMenuItem);
    if (!_app["default"].pathRouter.inMyShare()) {
      ctl.canMove(false) && menu.addItem(moveMenuItem);
    }
    ctl.canDelete() && menu.addItem(delMenuItem);
    ctl.canGetShareLink(function () {
      menu.addItem(shareLinkMenuItem);
    });
    ctl.canShowVersion() && menu.addItem(verMenuItem);
    ctl.canShowInfor() && menu.addItem(infoMenuItem);
    var hasItem = _MDHomeTableRowView["default"].prototype._createMoreMenuItem.call(this, ctl, menu);
    return ctl.canPreview() || ctl.canRename() || ctl.canDownload() || ctl.canMove() || ctl.canDelete() || ctl.canGetShareLink() || ctl.canShowVersion() || ctl.canShowInfor() || hasItem;
  },
  onSelectedChanged: function onSelectedChanged() {
    if (!this.fileInfor) {
      return;
    }
    if (this.isFullNameMode) {
      return;
    }
    var name = "";
    if (this.isSelected()) {
      name = MMCommonFun.getFileMidDotsString(this.fileInfor.getFileName(), 16, 3, 20);
    } else {
      name = MMCommonFun.getFileMidDotsString(this.fileInfor.getFileName(), 18, 10, 29);
    }
    this.$(".name").html(name).attr("title", name);
  },
  refreshWidth: function refreshWidth(force) {
    var table = this.getTableView();
    if (!table || !table.getContentWidth) {
      return;
    }
    var contentWidth = table.getContentWidth();
    if (contentWidth > 800) {
      this.refreshFileName(true, force);
    } else {
      this.refreshFileName(false, force);
    }
  },
  refreshFileName: function refreshFileName(isFullName, force) {
    if (!_.isUndefined(this.isFullNameMode) && this.isFullNameMode == isFullName && !force) {
      return;
    }
    this.isFullNameMode = isFullName;
    var name;
    var value = name = this.fileInfor.escape("fileName");
    if (!isFullName) {
      if (this.isSelected()) {
        name = MMCommonFun.getFileMidDotsString(name, 16, 3, 20);
      } else {
        name = MMCommonFun.getFileMidDotsString(name, 18, 10, 29);
      }
    }
    this.$(".name").html(name).attr("title", value);
  },
  _fileInNameChangedHandler: function _fileInNameChangedHandler() {
    this.refreshWidth(true);
    // var  value = this.fileInfor.escape('fileName');
    // if(this.isSelected()) {
    //   value = MMCommonFun.getFileMidDotsString(value, 16, 3, 20)
    // } else {
    //   value = MMCommonFun.getFileMidDotsString(value, 18, 10, 29)
    // }
    // this.$('.name').html(value).attr('title', value)
  },
  //mashx
  _fileInSizeChangedHandler: function _fileInSizeChangedHandler() {
    var size = this.fileInfor.get("currentVersionSize");
    if (this.fileInfor.isFolder()) {
      size = this.fileInfor.get("fileSize");
    }
    var value = _app["default"].getFileSizeDescription(size);
    this.$(".size-col").text(value);
  },
  _fileInVerChangedHandler: function _fileInVerChangedHandler(fileVersionInfo) {
    var fileSize = _app["default"].getFileSizeDescription(this.fileInfor.getCurrentVersionSize());
    var thumbDiv = this.$(".thumbWrapper");
    this.fileInfor.setIconForDiv(thumbDiv);
    this.$(".size-col").text(fileSize);
    this.$(".modify-time").text(MMCommonFun.formatSec2Date(new Date().getTime() / 1000));
  },
  getFilteredSelectionTrigger: function getFilteredSelectionTrigger() {
    return [".name", ".stickonTopMark", ".thumbWrapper", ".prevent-mouse"];
  },
  viewDidRendered: function viewDidRendered() {
    _MDHomeTableRowView["default"].prototype.viewDidRendered.call(this);
    this.extraZone && this.extraZone.setTableView(this.getTableView());
    // 展开评论 row 重新进入虚拟范围时，恢复评论内容、图标和实际行高。
    if (this.superView && this.superView.virtualScroll && this.superView.getVirtualRowState(this.fileInfor, 'commentExpanded')) {
      this._createCommentListView();
      this.extraZone && this.extraZone.setCommentExpanded(true);
      this.superView.refreshVirtualRowHeights();
    }
    this._renderSurveyState();
    this.refreshWidth();
  },
  // .survey 文件的状态徽标：批量加载器负责合并请求与缓存，重渲染时直接命中。
  _renderSurveyState: function _renderSurveyState() {
    var $state = this.$(".survey-state");
    if ($state.length === 0) return;
    if (!_MDSurveyStatusLoader["default"].isSurveyFile(this.fileInfor.getFileName())) return;
    _MDSurveyStatusLoader["default"].load(this.fileInfor.getFileId(), function (status) {
      var text = _MDSurveyStatusLoader["default"].statusText(status);
      $state.text(text).toggleClass("state-draft", status === "draft").toggleClass("state-inProgress", status === "inProgress").toggleClass("state-paused", status === "paused").toggleClass("state-completed", status === "completed");
    });
  },
  changeIndex: function changeIndex(index) {},
  _evalBtnClicked: function _evalBtnClicked(e) {
    var _this5 = this;
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    if (this.fileInfor.isFolder()) {
      if (this.fileInfor.get("multFile")) {
        var evaluationListWin = new _MDEvaluationListWinView["default"]({
          fileInfo: this.fileInfor
        });
        evaluationListWin.show();
        e && e.stopPropagation();
      } else if (this.fileInfor.isPassed()) {
        var alert = new _MDAlertView["default"]();
        var text = _MDLocalString["default"].getLocalString(3333); //请进入文件夹选择其中的文件进行查看！
        alert.show({
          width: 400,
          title: _MDLocalString["default"].getLocalString(170),
          // --- '提示'
          message: text,
          buttons: [{
            label: _MDLocalString["default"].getLocalString(154),
            //'确认'
            onClick: function onClick() {
              _this5._settingToNotPassed();
            }
          }, {
            label: _MDLocalString["default"].getLocalString(155) //'确认'
          }]
        });
      } else {
        var wind = new _MDEndEvalWindowView["default"]({
          fileInfo: this.fileInfor,
          onHide: function onHide(needRefresh) {
            if (needRefresh) {}
          }
        });
        wind.show();
      }
    } else {
      var evaluationListWin = new _MDEvaluationListWinView["default"]({
        fileInfo: this.fileInfor
      });
      evaluationListWin.show();
      e.stopPropagation();
    }
    return false;
  },
  _settingToNotPassed: function _settingToNotPassed() {
    var _this6 = this;
    var fileId = this.fileInfor.getFileId();
    _MMNetDiskDataController["default"].setEvaluationToUnstart(fileId, function () {
      // this.close();
      _this6.fileInfor.setEvaluationStatus(MDEvaluationStatus.EVALUATING);
      _this6.fileInfor.setCurrentVersionEvaluation(MDEvaluationStatus.EVALUATING);
    }, function (code) {
      console.log(code);
    });
  },
  _editMsBoxBtnClicked: function _editMsBoxBtnClicked(e) {
    var ctl = new _MDFileActionController["default"]({
      fileInfors: [this.fileInfor]
    });
    if (ctl.canManageMsBox()) {
      ctl.manageMsBox();
    }
  },
  _editOfficeBtnClicked: function _editOfficeBtnClicked() {
    var ctl = new _MDFileActionController["default"]({
      fileInfors: [this.fileInfor]
    });
    ctl.editFile();
  },
  onlineEditFile: function onlineEditFile() {
    var ctl = new _MDFileActionController["default"]({
      fileInfors: [this.fileInfor]
    });
    ctl.onlineEditFile();
  },
  _evalBtnMouseup: function _evalBtnMouseup(e) {
    e.stopPropagation();
  },
  _shareBtnClicked: function _shareBtnClicked(e) {
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    var shareWin = new _MDShareFileWindowView["default"]({
      fileInfor: this.fileInfor
    });
    shareWin.show();
    return false;
  },
  _outsideFileClicked: function _outsideFileClicked(e) {
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    var sharShow = false;
    if (this.fileInfor.isSharing()) {
      var shareWin = new _MDShareFileWindowView["default"]({
        fileInfor: this.fileInfor
      });
      shareWin.show();
      sharShow = true;
    } else {
      var filePath = _MDFilePathManager["default"].getFilePaths();
      for (var i = filePath.length - 1; i >= 0; i--) {
        if (filePath[i].isSharing()) {
          var shareWin = new _MDShareFileWindowView["default"]({
            fileInfor: filePath[i]
          });
          shareWin.show();
          sharShow = true;
          break;
        }
      }
    }
    if (!sharShow) {
      var msg = BabelStr.str(7233); //
      var option = {
        message: msg
      };
      _MDAlertView["default"].showStandardPrompt(option);
    }
  },
  _startEval: function _startEval(e) {
    if (_app["default"].isEpVersion()) {
      var ctl = new _MDFileActionController["default"]({
        fileInfors: [this.fileInfor]
      });
      if (ctl.canShowStartEvaluation()) {
        ctl.ShowStartEvaluation();
      } else {
        ctl.ShowDoingvaluation();
      }
      // var evalutionWinView = new MDEvalutionStartView({
      //   fileInfo: this.fileInfor
      // })
      // evalutionWinView.show();
    } else {
      var alert = new _MDAlertView["default"]();
      alert.show({
        title: _MDLocalString["default"].getLocalString(170),
        // '提示'
        message: _MDLocalString["default"].getLocalString(199),
        // '只有企业版支持文件审批功能，您可以开启企业版使用此功能'
        width: 400,
        buttons: [{
          label: _MDLocalString["default"].getLocalString(154)
        } // '确定'
        ]
      });
    }
  },
  _restartEval: function _restartEval(e) {
    this._evalBtnClicked(e);
  },
  _starBtnClicked: function _starBtnClicked(e) {
    var _this7 = this;
    e.stopPropagation();
    var msg = BabelStr.str(7234); //
    var option = {
      okStr: BabelStr.str(243),
      cancelStr: BabelStr.str(7235),
      okFun: function okFun() {
        var ctl = new _MDFileActionController["default"]();
        ctl.setFileInfors([_this7.fileInfor]);
        ctl.unfocusFile();
        _this7.isFocusFIleChanged();
      },
      message: msg
    };
    _MDAlertView["default"].showStandardSelection(option);
  },
  _appPerBtnClicked: function _appPerBtnClicked(e) {
    e.stopPropagation();
    e.preventDefault();
    var ctl = new _MDFileActionController["default"]();
    ctl.setFileInfors([this.fileInfor]);
    if (ctl.canShowFileControl()) {
      ctl.showControlFileWinView();
    }
  },
  commentStrDownHandler: function commentStrDownHandler(e) {
    var self = this;
    self.commentStMouseDown = true;
    e.stopPropagation();
    console.log("--------> comment clicked");
    $("body").on("mouseup.commentstr", function () {
      self.commentStMouseDown = false;
      $("body").off("mouseup.commentstr");
    });
    var commentstr = this.fileInfor.getCommentStr();
    if (this.commentPopupView) {
      this.commentPopupView.hide();
      this.commentPopupView = null;
    } else {
      this.commentPopupView = new _MDMsgCommentPopupView["default"]();
      this.commentPopupView.setTitle(commentstr);
      var z_startIndex = _MMBasicData["default"].getO2OStartLayerZ_index();
      this.commentPopupView.$el.css("z-index", z_startIndex);
      var self = this;
      this.commentPopupView.show({
        triggerView: e.currentTarget,
        center: true,
        width: 400,
        hasArrow: true,
        direction: _popupPos["default"].TOP,
        onClose: function onClose() {
          self.commentPopupView = null;
        }
      });
    }
  },
  commentStrUpHandler: function commentStrUpHandler(e) {
    if (!this.commentStMouseDown) {} else {
      e.stopPropagation();
    }
    // console.log('--------> comment clicked');
  },
  _restoreFile: function _restoreFile($e) {
    $e.stopPropagation();
    var actionController = new _MDTrashFileActionController["default"]();
    actionController.setFileInfors([this.fileInfor]);
    actionController.restoreFile();
  },
  openLink: function openLink($e) {
    $e.stopPropagation();
    var actionController = new _MDFileActionController["default"]();
    actionController.setFileInfors([this.fileInfor]);
    actionController.openLink();
    return false;
  },
  _deleFile: function _deleFile($e) {
    $e.stopPropagation();
    var actionController = new _MDTrashFileActionController["default"]();
    actionController.setFileInfors([this.fileInfor]);
    actionController.deleteForever();
  },
  btnsShowed: function btnsShowed(show) {
    if (this.extraZone) {
      this.extraZone.btnsShowed(show, this.btnsWidth);
    } else {}
  },
  _searchTextClickHandle: function _searchTextClickHandle(str) {
    var fileId = this.fileInfor.getFileId();
    var fileVersion = this.fileInfor.getCurVersion() || -1;
    _MMNetDiskDataController["default"].getFileInfoFromServerWithoutTrash(fileId, function succeess(fileInfor) {
      var displayController = _MDPCDisplayFileController["default"].getSingleton();
      var checkParam = {
        fileInfo: fileInfor
      };
      displayController.checkToAlertCannotDisp(checkParam, function (canOpen) {
        if (!canOpen) {
          if (!fileInfor.isFolder()) {
            _MMNetDiskDataController["default"].clearFilesUnreadMarks([fileInfor]);
          }
          return;
        }
        displayController.openFileWithoutRouter(fileInfor, fileVersion, null, null, str);
      });
    }, function fail(errCode, errMsg) {
      if (errCode == _MMNetDiskDataController["default"].code.ERROR_FILE_ACCESS_DENIED || errCode == _MMNetDiskDataController["default"].code.ERROR_FILE_NOT_FOUND) {
        _MDSnackbarView["default"].show(errMsg);
      }
    });
  },
  _securityBtnClicked: function _securityBtnClicked(e) {
    e.stopPropagation();
    e.preventDefault();
    _MDAlertView["default"].showAboutSecurity();
  },
  _fileCommentClicked: function _fileCommentClicked(e) {
    e.stopPropagation();
    e.preventDefault();
    var msg = BabelStr.str(7236); //
    var option = {
      title: BabelStr.str(2676),
      //
      message: this.fileInfor.getCommentStr()
    };
    _MDAlertView["default"].showStandardPrompt(option);
  },
  _stickOntopClicked: function _stickOntopClicked(e) {
    var _this8 = this;
    e.stopPropagation();
    e.preventDefault();
    var msg = BabelStr.str(7237); //
    var option = {
      okStr: BabelStr.str(183),
      cancelStr: BabelStr.str(7238),
      okFun: function okFun() {
        _this8.callStickonTopToServer(false);
      },
      message: msg
    };
    _MDAlertView["default"].showStandardSelection(option);
  },
  _lockIconClicked: function _lockIconClicked(e) {
    e.stopPropagation();
    e.preventDefault();
    var ctl = new _MDFileActionController["default"]({
      fileInfors: [this.fileInfor]
    });
    if (ctl.canUnlockFile()) {
      if (this.fileInfor.isOfficeFile()) {
        var userName = this.fileInfor.getFileLockerName();
        var msg = "<div>" + BabelStr.str(7239, {
          userName: userName
        }) + "</div>  <div class='gray'>" + BabelStr.str(7240) + "</div>"; // -------------
        if (this.fileInfor.isFileLockedByOnline()) {
          msg = BabelStr.str(22018);
        }
        var option = {
          message: msg
        };
        _MDAlertView["default"].showStandardPrompt(option);
      } else {
        var msg = "<div>" + BabelStr.str(7241) + "</div>  <div class='gray'>" + BabelStr.str(7242) + "</div>"; // ---------
        var option = {
          okStr: BabelStr.str(7243),
          cancelStr: BabelStr.str(7244),
          okFun: function okFun() {
            ctl.unlockFile();
          },
          message: msg
        };
        _MDAlertView["default"].showStandardSelection(option);
      }
    } else {
      var msg = BabelStr.str(7245); //
      if (this.fileInfor.isFileLockedByOnline()) {
        msg = BabelStr.str(22018);
      }
      var option = {
        message: msg
      };
      _MDAlertView["default"].showStandardSelection(option);
    }
  },
  _inviteTipIconClicked: function _inviteTipIconClicked(e) {
    e.stopPropagation();
    e.preventDefault();
    this.openShare();
  }
});
var _default = exports["default"] = MDFileTableRowView;

},{"1090":1090,"1104":1104,"1119":1119,"1150":1150,"1184":1184,"1412":1412,"1416":1416,"1417":1417,"1421":1421,"1424":1424,"1426":1426,"1436":1436,"1437":1437,"1454":1454,"1463":1463,"1477":1477,"148":148,"1495":1495,"1541":1541,"1546":1546,"17":17,"176":176,"297":297,"30":30,"32":32,"330":330,"407":407,"422":422,"437":437,"457":457,"468":468,"473":473,"492":492,"495":495,"504":504,"507":507,"51":51,"511":511,"543":543,"55":55,"605":605,"64":64,"65":65,"684":684,"695":695,"700":700,"703":703,"717":717,"72":72,"763":763,"811":811}],763:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDNavigationWindowView = _interopRequireDefault(require(92));
var _MDTeamManageNavPanelView = _interopRequireDefault(require(762));
var MDTeamSettingWindowView = _MDNavigationWindowView["default"].extend({
  className: function className() {
    var superCls = _MDNavigationWindowView["default"].prototype.className.call(this);
    return superCls + ' team-setting-window';
  },
  initProps: function initProps() {
    var superP = _MDNavigationWindowView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      width: 750,
      title: BabelStr.str(7322),
      showFooter: false,
      teamFolderId: undefined
    });
  },
  initialize: function initialize(opts) {
    opts.rootNavigationPageView = new _MDTeamManageNavPanelView["default"]({
      teamFolderId: opts.teamFolderId
    });
    _MDNavigationWindowView["default"].prototype.initialize.call(this, opts);
  }
});
var _default = exports["default"] = MDTeamSettingWindowView;

},{"1184":1184,"1454":1454,"762":762,"92":92}],762:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1541);
require(1415);
require(1463);
var _MDNavigationPageView = _interopRequireDefault(require(56));
var _MDTeamNavListView = _interopRequireDefault(require(792));
var _MDTeamInfoCollection = _interopRequireDefault(require(290));
var _MDMemberInfoCollection = _interopRequireDefault(require(269));
var _MDTeamDataController = _interopRequireDefault(require(1094));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDTeamInfoPanelView = _interopRequireDefault(require(790));
var _MDCreateTeamNavigationPageView = _interopRequireDefault(require(743));
var _MDMemberManageView = _interopRequireDefault(require(789));
var _MDUpdatePromptWindowView = _interopRequireDefault(require(525));
var _MDSpinnerloaderLayerView = _interopRequireDefault(require(75));
var MDTeamManageNavPanelView = _MDNavigationPageView["default"].extend({
  contentTmpl: '<div class="team-toolbar">\
                  <button class="button done create-team-btn"><%=BabelStr.str(66)%></button>\
                </div>\
                <div class="flex-align manage-panel-inner">\
                  <div class="left-team-nav"></div>\
                  <div class="right-team-info"></div>\
                </div>',
  className: function className() {
    var superCls = _MDNavigationPageView["default"].prototype.className.call(this);
    return superCls + ' team-manage-panel';
  },
  events: function events() {
    var superE = _MDNavigationPageView["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click .create-team-btn': this._gotoCreateTeam
    });
  },
  initProps: function initProps() {
    var superP = _MDNavigationPageView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      title: BabelStr.str(65),
      showNavigationBar: false,
      teamInfoCollection: new _MDTeamInfoCollection["default"](),
      teamMemberCollection: new _MDMemberInfoCollection["default"](),
      teamFolderId: undefined
    });
  },
  initialize: function initialize(opts) {
    var self = this;
    _MDNavigationPageView["default"].prototype.initialize.call(this, opts);
    setTimeout(function () {
      if (app.isEpVersion()) {
        self.$(".create-team-btn").remove();
      }
    }, 100);
  },
  _requestMyTeams: function _requestMyTeams(onSuccess, onFail) {
    var self = this;
    var currentTeam = null;
    _MDSpinnerloaderView["default"].showIn(this.$el[0]);
    _MDTeamDataController["default"].getTeamInfosForCurrentUser(function (teamInfoCollection) {
      self.teamInfoCollection = teamInfoCollection;
      self.teamInfoCollection.sortByCreationTime();
      self.listenTo(self.teamInfoCollection, 'remove', self._teamRemoveHandler);
      _MDSpinnerloaderView["default"].clearFrom(self.$el[0]);
      _.isFunction(onSuccess) && onSuccess();
    }, function () {
      _.isFunction(onFail) && onFail();
      _MDSpinnerloaderView["default"].clearFrom(self.$el[0]);
    });
  },
  _teamRemoveHandler: function _teamRemoveHandler() {
    var self = this;
    var currentTeam;
    if (self.teamInfoCollection.length > 0) {
      currentTeam = self._getDefaultShowTeam();
      self.requestTeamMembers(currentTeam);
    }
    this.teamsView.setCurTeamInfor(currentTeam);
  },
  requestTeamMembers: function requestTeamMembers(teamInfor) {
    var self = this;
    this.teamInfoPanelView.requestTeamMembers(teamInfor);
  },
  _getDefaultShowTeam: function _getDefaultShowTeam() {
    var group = this.teamInfoCollection.groupBy(function (teamInfo) {
      if (teamInfo.getCreatorId() == app.currentUser.getUserId()) {
        return 0;
      } else {
        return 1;
      }
    });
    var myTeams = _.extend([], group[0]);
    var otherTeams = _.extend([], group[1]);
    var currentTeam = myTeams.length > 0 ? myTeams[0] : otherTeams[0];
    return currentTeam;
  },
  _gotoCreateTeam: function _gotoCreateTeam($e) {
    var myTeams = this.teamInfoCollection.filter(function (teamInfo) {
      if (teamInfo.getCreatorId() == app.currentUser.getUserId()) {
        return true;
      }
    });
    if (!app.currentUser.canCreateTeam(myTeams.length)) {
      var updateWin = new _MDUpdatePromptWindowView["default"]({
        content: BabelStr.str(7321)
      });
      updateWin.show();
      return;
    }
    var createTeamPageView = new _MDCreateTeamNavigationPageView["default"]({
      teamInfoCollection: this.teamInfoCollection
    });
    this.navigationWindowView.push(createTeamPageView, true);
  },
  viewDidRendered: function viewDidRendered() {
    var self = this;
    _MDNavigationPageView["default"].prototype.viewDidRendered.call(this);
    this._requestMyTeams(function () {
      if (self.teamFolderId) {
        self.curTeamInfor = self.teamInfoCollection.findWhere({
          'folderId': self.teamFolderId
        });
        self.teamFolderId = undefined;
      } else {
        self.curTeamInfor = self._getDefaultShowTeam();
      }
      self.teamsView = new _MDTeamNavListView["default"]({
        teamInfoCollection: self.teamInfoCollection,
        curTeamInfor: self.curTeamInfor,
        onSelectTeam: function onSelectTeam(teamInfor) {
          self.requestTeamMembers(teamInfor);
        }
      });
      self.addSubView(self.teamsView, self.$('.left-team-nav'));
      self.requestTeamMembers(self.curTeamInfor);
    });
    this.teamInfoPanelView = new _MDTeamInfoPanelView["default"]({
      onCreateTeamCallback: function onCreateTeamCallback() {
        self._gotoCreateTeam();
      },
      onBeforeExitTeam: function onBeforeExitTeam() {
        _MDSpinnerloaderLayerView["default"].showIn(self.$el[0]);
      },
      onCompleteExitTeam: function onCompleteExitTeam() {
        _MDSpinnerloaderLayerView["default"].clearFrom(self.$el[0]);
      }
    });
    this.addSubView(this.teamInfoPanelView, this.$('.right-team-info'));
  },
  viewWillUnRendered: function viewWillUnRendered() {
    _MDNavigationPageView["default"].prototype.viewWillUnRendered.call(this);
    if (this.teamsView && this.teamsView.superView) {
      this.removeSubView(this.teamsView);
    }
    if (this.teamInfoPanelView && this.teamInfoPanelView.superView) {
      this.removeSubView(this.teamInfoPanelView);
    }
  }
});
var _default = exports["default"] = MDTeamManageNavPanelView;

},{"1094":1094,"1184":1184,"1415":1415,"1454":1454,"1463":1463,"1541":1541,"269":269,"290":290,"525":525,"56":56,"743":743,"75":75,"76":76,"789":789,"790":790,"792":792}],792:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1436);
require(1546);
require(1439);
require(1424);
var _MMViewBase = _interopRequireDefault(require(22));
var _MDTeamInfo = _interopRequireDefault(require(289));
/**
 * 团队弹出列表
 * Created by manjun.han
 * File created : 2016.11.4
 * Class created: 2016.3.5
 */

var MDTeamNavListView = _MMViewBase["default"].extend({
  tmpl: function tmpl() {
    var currentUserId = app.currentUser.getUserId();
    var group = this.teamInfoCollection.groupBy(function (teamInfo) {
      if (teamInfo.getCreatorId() == currentUserId) {
        return 0;
      } else {
        return 1;
      }
    });
    var myTeams = _.extend([], group[0]);
    var yourTeams = _.extend([], group[1]);
    var team = null,
      yourTeamsStrBuilder = [],
      myTeamsStrBuilder = [];
    var curInforId = this.curTeamInfor && this.curTeamInfor.getId();
    for (var i = 0; i < myTeams.length; i++) {
      team = myTeams[i].toJSON();
      if (team.id == curInforId) {
        myTeamsStrBuilder.push('<li data-cid="' + myTeams[i].cid + '" title="' + team.name + '" class="selected">' + team.name + '</li>');
      } else {
        myTeamsStrBuilder.push('<li data-cid="' + myTeams[i].cid + '" title="' + team.name + '">' + team.name + '</li>');
      }
    }
    if (myTeams.length == 0) {
      myTeamsStrBuilder.push('<div class="m-blank-state">' + BabelStr.str(7353) + '</div>');
    }
    for (var i = 0; i < yourTeams.length; i++) {
      team = yourTeams[i].toJSON();
      if (team.id == curInforId) {
        yourTeamsStrBuilder.push('<li  data-cid="' + yourTeams[i].cid + '" title="' + team.name + '" class="selected">' + team.name + '</li>');
      } else {
        yourTeamsStrBuilder.push('<li data-cid="' + yourTeams[i].cid + '" title="' + team.name + '">' + team.name + '</li>');
      }
    }
    if (yourTeams.length == 0) {
      yourTeamsStrBuilder.push("<div class=\"m-blank-state\">".concat(BabelStr.str(6063), "</div>"));
    }
    var tmpl = '<div class="team-list-panel nobdt">';

    // if (app.isEpVersion()) {
    //   if (app.currentUser.isEpAdminUser()) {
    //     tmpl += '<ul class="team-list">' + myTeamsStrBuilder.join('') + '</ul>';
    //   } else {
    //     tmpl += '<ul class="team-list">' + yourTeamsStrBuilder.join('') + '</ul>';
    //   }
    // } else {
    tmpl += '<div class="team-header nobdt">' + BabelStr.str(17) + '</div>';
    tmpl += '<ul class="team-list">' + myTeamsStrBuilder.join('') + '</ul>';
    tmpl += '<div class="team-header">' + BabelStr.str(7354) + '</div>' + '<ul class="team-list with-icon">' + yourTeamsStrBuilder.join('') + '</ul>' + '</div>';
    // }
    return tmpl;
  },
  events: function events() {
    var superEvents = _MMViewBase["default"].prototype.events.call(this);
    return _.extend({}, superEvents, {
      'click li': this._menuItemClickHandler
    });
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      teamInfoCollection: null,
      curTeamInfor: new _MDTeamInfo["default"](),
      onSelectTeam: _.noop
    });
  },
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.$teamList = this.$(".teamList");
    this._registerNameChangeEvent();
  },
  _menuItemClickHandler: function _menuItemClickHandler($e) {
    var cid = $($e.currentTarget).data('cid');
    var teamInfor = this.teamInfoCollection.get(cid);
    if (_.isFunction(this.onSelectTeam)) {
      this.onSelectTeam(teamInfor);
    }
    this.$('li').removeClass('selected');
    $($e.currentTarget).addClass('selected');
  },
  setTeamCollection: function setTeamCollection(teamInfoCollection) {
    this.teamInfoCollection = teamInfoCollection;
    this.refresh();
    this._registerNameChangeEvent();
  },
  setCurTeamInfor: function setCurTeamInfor(curTeamInfor) {
    this.curTeamInfor = curTeamInfor;
    this.refresh();
  },
  _registerNameChangeEvent: function _registerNameChangeEvent() {
    var self = this;
    this.teamInfoCollection.each(function (teamInfo) {
      self.stopListening(teamInfo, "change");
    });
    this.teamInfoCollection.each(function (teamInfo) {
      self.listenTo(teamInfo, "change", self._teamInfoChanged);
    });
  },
  _teamInfoChanged: function _teamInfoChanged(teamInfor) {
    if (teamInfor.hasChanged("name")) {
      var $li = this.$('li');
      for (var i = 0; i < $li.length; i++) {
        if ($($li[i]).attr('data-cid') == teamInfor.cid) {
          $($li[i]).text(teamInfor.getName());
        }
      }
      ;
    }
  }
});
var _default = exports["default"] = MDTeamNavListView;

},{"1184":1184,"1424":1424,"1436":1436,"1439":1439,"1454":1454,"1546":1546,"22":22,"289":289}],790:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1436);
require(1546);
require(1503);
require(1500);
require(1498);
require(1432);
require(1541);
require(1439);
var _MMViewBase = _interopRequireDefault(require(22));
var _MDTeamDataController = _interopRequireDefault(require(1094));
var _MDMemberManageView = _interopRequireDefault(require(789));
var _MDMemberInfoCollection = _interopRequireDefault(require(269));
var _MDSpinnerloaderLayerView = _interopRequireDefault(require(75));
var _MMBasicData = _interopRequireDefault(require(811));
var _MDTeamInfoCollection = _interopRequireDefault(require(290));
var _MDTeamInfo = _interopRequireDefault(require(289));
var _popupPos = _interopRequireDefault(require(65));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDEmptyTeamView = _interopRequireDefault(require(788));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDEditalbeInputDiv = _interopRequireDefault(require(28));
var _MDEditalbeTextDiv = _interopRequireDefault(require(29));
var _MDTeamMemberPopupView = _interopRequireDefault(require(791));
var _MDEnterpriseShareTabView = _interopRequireDefault(require(675));
var _MDRoleSelectView = _interopRequireDefault(require(515));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDTeamMemberCtlPopup = _interopRequireDefault(require(186));
var _MDChangeMemerNick = _interopRequireDefault(require(481));
/**
 * 团队信息面板
 * Created by manjun.han
 * 2017.3.3
 */

var MDTeamInfoPanelView = _MMViewBase["default"].extend({
  el: '<div class="team-info-panel"></div>',
  tmpl: "<div class=\"infor-content\">\n          <div class=\"flex-align between team-name-wrap middle\">\n            <div class=\"flex-align middle\">\n              <div class=\"thumbWrapper file-icon\"></div>\n              <div class=\"team-name\"></div>\n            </div>\n            <div class=\"team-operation\">\n              <button class=\"button danger small exit-team \"></button>\n            </div>\n          </div>\n           <div class=\"infor-block\">\n              <div class=\"mgb-10\">\n                <span class=\"label\"><%=BabelStr.str(5077)%>\uFF1A</span>\n                <div class=\"right\">\n                  <span class=\"val\"><%=creatorName%><%= (curUserId == creatorId ? BabelStr.str(5078) : \"\")%> </span>\n                  <span class=\"creator-mail\"> <%=creatorEmail%></span>\n                </div>\n            </div>\n            </div>\n            <div class=\"infor-block\">\n              <div class=\"mgb-10 flex-align\">\n                <span class=\"label no-shrink\"><%=BabelStr.str(5079)%>\uFF1A</span>\n                <div class=\"fullfill mgr-10\">\n                  <div class=\"team-desp\">\n                  </div>\n                </div>\n\n                <button class=\"button done show-link\"><%=BabelStr.str(6080)%></button>\n\n              </div>\n              <div class=\"link-content f-hide mgb-15\">\n                <p class=\"mgb-10 help-block\"><%=BabelStr.str(6083)%></p>\n                <div class=\"flex-align\">\n                  <input type=\"text\" readonly class=\"form-control team-link\" value=\"1234\" />\n                  <button class=\"button done no-shrink mgl-10 copy-link\"><%=BabelStr.str(6081)%></button>\n                  <button class=\"qrcode-btn icon no-shrink mgl-10\" >\n                    <div class=\"qrcode-pop f-tc\" title=\"<%=BabelStr.str(416)%>\">\n                    <div class=\"qrcode-canvas\"></div>\n                    <div class=\"intro\">\n                      <p><%=BabelStr.str(5417)%></p>\n                      <p class=\"text-button copy-qrcode\"><%=BabelStr.str(5416)%></p>\n                    </div>\n                    </div>\n                  </button>\n                </div>\n\n\n              </div>\n            </div>\n          <%if(isCurUserManager && !isExpire){%>\n            <div class=\"add-member-block\">\n              <div class=\"add-member-head\">\n                <span class=\"h-title\"><%=BabelStr.str(71)%>\uFF1A</span>\n                <span class=\"h-help\"><%=BabelStr.str(6065)%></span>\n              </div>\n              <div class=\"add-member-content\"></div>\n\n              <div class=\"flex-align end add-member-btns\">\n                <div class=\"cancel-btn button mglr-10\"><%=BabelStr.str(3081)%></div>\n                <div class=\"done add-btn button\"><%=BabelStr.str(5031)%></div>\n              </div>\n            </div>\n          <%}%>\n\n          <div class=\"member-block\">\n\n            <div class=\"f-clb\">\n                <span class=\"h-title\"><%=BabelStr.str(70)%>\uFF1A</span>\n            </div>\n            <div class=\"team-members\">\n              <table>\n              <tbody>\n              <% if(members.length >0){%>\n                <%for(var i = 0 ; i < members.length ; i++){%>\n                  <tr data-cid=\"<%= members[i].cid%>\">\n                    <td class=\"name-cell\">\n                      <img class=\"avatar\" src=\"<%=members[i].avatarURL%>\" alt=\"\" />\n                      <div class=\"name\">\n                      </div>\n                      <span class=\"mail\" title=\"<%=members[i].mail%>\"><%=(members[i].mail == \"--\" ? members[i].phone || members[i].mail : members[i].mail)%></span>\n                    </td>\n                    <td class=\"role-cell\">\n                      <div class=\"text-right role-wrap\">\n                        <% if(isCurUserManager && !isExpire){%>\n                          <% if(members[i].memId != creatorId){%>\n                              <% if(members[i].memId == curUserId){%>\n                                <a class=\"manager\">\n                                  <span class=\"rolename\"><%=members[i].roleName%></span>\n                                  <i class=\"arrow down\" style=\"display:none;\"></i>\n                                </a>\n                              <%}else{%>\n                                <a id=\"<%=members[i].cid%>\" class=\"auth\">\n                                  <%if(members[i].memberShip == 1){%>\n                                    <span class=\"state\"><%=BabelStr.str(5080)%></span>\n                                  <%} else {%>\n                                    <%if(members[i].memberShip == 2){%>\n                                      <span class=\"state\"><%=BabelStr.str(5081)%></span>\n                                    <%}else {%>\n                                    <%}%>\n                                  <%}%>\n                                  <span class=\"rolename\"><%=members[i].roleName%></span>\n                                  <i class=\"arrow down\"></i>\n                                </a>\n                                <span class=\"icon mglr-10 ic-close-small remove\" data-tooltip=\"<%=BabelStr.str(793)%>\" data-tooltip-dir=\"top\"></span>                              <%}%>\n                          <%}else{%>\n                            <a class=\"manager\">\n                              <span class=\"rolename\"><%=members[i].roleName%></span>\n                              <i class=\"arrow down\" style=\"display:none;\"></i>\n                            </a>\n                          <%}%>\n                        <%}else{%>\n                          <a>\n                            <%if(members[i].memberShip == 1){%><span class=\"state\"><%=BabelStr.str(5090)%></span><%}%>\n                            <%if(members[i].memberShip == 2){%><span class=\"state\"><%=BabelStr.str(5081)%></span><%}%>\n                            <span class=\"rolename\"><%=members[i].roleName%></span>\n                          </a>\n                        <%}%>\n                      </div>\n                    </td>\n                  </tr>\n                <%}%>\n              <%}%>\n            </tbody>\n            </table>\n            </div>\n          </div>\n          </div>\n        </div>",
  events: function events() {
    var superEvents = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superEvents, {
      'mousedown .auth': this.showMemberManagerView,
      'click .exit-team': this._exitTeamClickHandler,
      'click .transfer-team': this._transferTeamClickHandler,
      'click .remove': this.removeClicked,
      'click .more': this._moreMenu,
      'click .add-btn': this._sendInvitation,
      'click .cancel-btn': this._clearSelected,
      'click .show-link': this._showLink,
      // 'click .copy-link': this._copyLink,
      'mouseenter .qrcode-btn': this._showQRCodePopup,
      'mouseleave .qrcode-btn': this._hideQRCodePopup,
      'click .qrcode-canvas canvas': this._copyQrcode,
      'click .copy-qrcode': this._copyQrcode
    });
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      teamInfoCollection: new _MDTeamInfoCollection["default"](),
      teamMemberCollection: new _MDMemberInfoCollection["default"](),
      curTeamInfor: new _MDTeamInfo["default"](),
      onCreateTeamCallback: _.noop,
      onBeforeExitTeam: _.noop,
      onCompleteExitTeam: _.noop
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.$('.infor-content').hide();
    this._prepareRoles();
  },
  _showQRCodePopup: function _showQRCodePopup($e) {
    var self = this;
    var $qpopup = this.$(".qrcode-pop");
    if ($qpopup.hasClass("opened")) {
      return;
    }
    $qpopup.show();
    $qpopup[0].offsetWidth;
    $qpopup.addClass("opened");
    return false;
  },
  _hideQRCodePopup: function _hideQRCodePopup($e) {
    var self = this;
    var $qpopup = self.$('.qrcode-pop');
    var $mqpopup = self.$('.qrcode-btn');
    var popDOM = $mqpopup.get(0);
    if ($qpopup.css("display") == "none") {
      return;
    }
    $qpopup.removeClass("opened");
    $qpopup.hide();
  },
  _copyLink: function _copyLink() {
    var self = this;
    var $btn = this.$('.copy-link');
    this.clipboard = new Clipboard($btn[0], {
      text: function text() {
        return self.$('.team-link').val();
      }
    });
    this.clipboard.on('success', function (e) {
      e.clearSelection();
      var tip = BabelStr.str(6082);
      _MDMessageView["default"].success(tip, self.$el);
    });
    this.clipboard.on('error', function (e) {
      var tip = "";
      if (app.os.mac) {
        tip = BabelStr.str(7149);
      } else {
        tip = BabelStr.str(7150);
      }
      self.$(".team-link").select();
      _MDMessageView["default"].error(tip, self.$el);
    });
  },
  _copyQrcode: function _copyQrcode(e) {
    var self = this;
    var target = this.$('.qrcode-canvas canvas')[0];
    MMCommonFun.clipboardCopyCanvas(target, function () {
      console.log('success');
      _MDMessageView["default"].success(BabelStr.str(5415), self.$el);
    }, function () {
      _MDMessageView["default"].error(BabelStr.str(5418), self.$el);
      console.log('fail');
    });
  },
  _showLink: function _showLink() {
    var _this = this;
    var teamId = this.curTeamInfor.getId();
    var paramStr = "team=".concat(teamId);
    MMEnterpriseController.getTeamInvUrl(paramStr, function (url) {
      _this.$('.team-link').val(url);
      _this.linkUrl = url;
      _this.$(".qrcode-canvas").empty().qrcode({
        width: 160,
        height: 160,
        text: _this.linkUrl
      });
      _this.$('.link-content').removeClass("f-hide");
      _this._copyLink();
      _this.navigationWindowView && _this.navigationWindowView.refreshWindow();
    }, function () {
      _MDMessageView["default"].error(BabelStr.str(309));
    });
  },
  _clearSelected: function _clearSelected() {
    this.chooseView.clear();
    this.chooseView.hideTab();
  },
  _sendInvitation: function _sendInvitation($e) {
    var $sendInvBtn = this.$('.add-btn');
    var self = this;
    var teamId = this.curTeamInfor.getId();
    var targetMails = [];
    var targetObj = this.chooseView.getTargetObj();
    targetMails = targetObj.emails;
    var targetPhones = targetObj.phones;
    if (!targetMails.length && !targetPhones.length) {
      return;
    }
    $sendInvBtn.prop('disabled', true).text(BabelStr.str(711));
    var roleId = this.role.getRoleId();
    var length = targetMails.length + targetPhones.length;
    var memberInfos = [];
    var responseCount = 0;
    var notMemebers = [];
    var inErrors = [];
    var msg = "";
    function success(res, memberInfo) {
      responseCount++;
      $sendInvBtn.prop('disabled', false).text(BabelStr.str(3096));
      memberInfos.push(memberInfo);
      if (responseCount >= length) {
        if (app.isEpVersion()) {
          _MDSnackbarView["default"].show(BabelStr.str(3507));
        } else {
          _MDSnackbarView["default"].show(BabelStr.str(7314));
        }
        self.addMember(memberInfos);
      }
      self.chooseView.clear();
    }
    function fail(errcode, mail) {
      $sendInvBtn.prop('disabled', false).text(BabelStr.str(3096));
      responseCount++;
      if (errcode == MMNetDiskDataController.code.ERROR_NOT_FOUND) {
        notMemebers.push(mail);
      } else if (errcode == MMNetDiskDataController.code.ERROR_ALREADY_IN) {
        inErrors.push(mail);
      }
      if (responseCount == length) {
        if (notMemebers.length > 0) {
          _.each(notMemebers, function (mail, index) {
            if (index > 0) {
              msg += ' , ' + mail;
            } else {
              msg += '<div>' + mail;
            }
          });
          msg += BabelStr.str(7348) + '</div>';
        }
        if (inErrors.length > 0) {
          _.each(inErrors, function (mail, index) {
            if (index > 0) {
              msg += ' , ' + mail;
            } else {
              msg += '<div>' + mail;
            }
          });
          msg += BabelStr.str(7349) + '</div>';
        }
        if (inErrors.length > 0 || notMemebers.length > 0) {
          _MDSnackbarView["default"].show(msg);
        } else {
          if (app.isEpVersion()) {
            _MDSnackbarView["default"].show(BabelStr.str(7350));
          } else {
            _MDSnackbarView["default"].show(BabelStr.str(7351));
          }
        }
      }
    }
    for (var i = 0; i < targetMails.length; i++) {
      _MDTeamDataController["default"].addMember(teamId, targetMails[i], null, roleId, success, fail);
    }
    for (var _i = 0; _i < targetPhones.length; _i++) {
      var phone = targetPhones[_i];
      _MDTeamDataController["default"].addMemberByPhone(teamId, phone, null, roleId, success, fail);
    }
  },
  removeClicked: function removeClicked($e) {
    var cid = $($e.target).closest('tr').data('cid');
    $e.stopPropagation();
    this._removeMember(cid);
  },
  _removeMember: function _removeMember(cid) {
    var self = this;
    var alert = new _MDAlertView["default"]();
    alert.show({
      title: BabelStr.str(170),
      message: "".concat(BabelStr.str(792), "?"),
      buttons: [{
        label: BabelStr.str(154),
        type: 'done',
        onClick: function onClick() {
          var teamId = self.curTeamInfor.getId();
          var memberInfo = self.teamMemberCollection.get(cid);
          var memId = memberInfo.getMemId();
          _MDTeamDataController["default"].removeMembers(teamId, [memId], function success() {
            self.teamMemberCollection.remove(cid);
          }, function fail() {
            _MDSnackbarView["default"].show(BabelStr.str(5082));
          });
        }
      }, {
        label: BabelStr.str(155)
      }]
    });
  },
  _showChangeNickWin: function _showChangeNickWin(cid) {
    var self = this;
    var teamId = self.curTeamInfor.getId();
    var memberInfo = self.teamMemberCollection.get(cid).attributes;
    // console.log('memberInfo', memberInfo);

    var changeNickWin = new _MDChangeMemerNick["default"]({
      memberInfo: memberInfo,
      teamId: teamId,
      renameCallback: function renameCallback(newName) {
        console.log('newName', newName);
        _MDTeamDataController["default"].updateMemberNickname(teamId, memberInfo.memId, newName, function () {
          self.teamMemberCollection.get(cid).set('remark', newName);
          var dispName = self._getDispName(memberInfo);
          self.$('.team-members').find("tr[data-cid=\"".concat(cid, "\"]")).find('.name').text(dispName);
        }, function () {});
      }
    });
    changeNickWin.show();
  },
  _moreMenu: function _moreMenu($e) {
    var _this2 = this;
    var self = this;
    var cid = $($e.target).closest('tr').data('cid');
    $e.stopPropagation();
    var teamInfor = this.curTeamInfor;
    var isUserManger = teamInfor.isCurUserManager(); //是否是管理员
    var memberInfo = self.teamMemberCollection.get(cid).attributes;
    var canEdit = isUserManger && memberInfo.memId != app.currentUser.getId();
    _MDTeamMemberCtlPopup["default"].createPopup({
      triggerView: $($e.target),
      width: 180,
      direction: _popupPos["default"].BOTTOM,
      hasArrow: false,
      outSide: true,
      gapY: 0,
      gapX: -20,
      isUserManger: canEdit,
      editRemarkName: function editRemarkName() {
        console.log('editRemarkName', cid);
        _this2._showChangeNickWin(cid);
      },
      removeMemberFromTeam: function removeMemberFromTeam() {
        _this2._removeMember(cid);
      }
    });
  },
  addMember: function addMember(memberInfos) {
    var self = this;
    if (memberInfos) {
      _.each(memberInfos, function (memberInfo) {
        var res = self.teamMemberCollection.findWhere({
          'mail': memberInfo.getMail()
        });
        if (!res) {
          self.teamMemberCollection.add(memberInfo);
        }
      });
    }
  },
  _prepareRoles: function _prepareRoles() {
    var self = this;
    _MDTeamDataController["default"].getRoles(function (roleCollection, defaultRoleId) {
      self.defaultRoleId = defaultRoleId;
      var shareRoles = [];
      roleCollection.each(function (roleInfo) {
        var permission = roleInfo.getPermission();
        if (permission > 0) {
          shareRoles.push(roleInfo);
        }
        ;
      });
      self.roles = shareRoles;
      var role = _.findWhere(self.roles, {
        'id': self.defaultRoleId
      });
      role = role || self.roles[0];
      if (self.roleSelectView) {
        self.roleSelectView.setRoles(self.roles);
        self.roleSelectView.selectRole(role, true);
      }
      self.role = role;
    }, function () {});
  },
  showMemberManagerView: function showMemberManagerView($e) {
    var cid = $($e.target).closest('tr').data('cid');
    var self = this;
    var $btn = $($e.currentTarget);
    var memberInfo = this.teamMemberCollection.get(cid);
    if ($btn.data("triggered")) {
      $btn.data("popup").close();
      $btn.data("triggered", false).data('popup', null);
    } else {
      var $tr = $($e.target).closest('tr');
      var popup = new _MDMemberManageView["default"]({
        curTeamInfor: this.curTeamInfor,
        memberInfo: memberInfo,
        $tr: $tr,
        roles: self.roles,
        asDropdown: false
      });
      popup.show({
        triggerView: $e.currentTarget,
        hasArrow: false,
        direction: _popupPos["default"].BOTTOM_RIGHT,
        width: 180,
        onClose: function onClose() {
          $btn.data("triggered", false).data('popup', null);
        }
      });
      $btn.data("triggered", true).data('popup', popup);
    }
  },
  requestTeamMembers: function requestTeamMembers(teamInfor) {
    var self = this;
    if (!teamInfor) {
      this._renderBlankState();
      return;
    }
    _MDSpinnerloaderView["default"].showIn(this.$el[0]);
    var creatorId = teamInfor.getCreatorId();
    var curUserId = app.currentUser.getUserId();
    var iamTheCreator = creatorId == curUserId;
    this.$('.infor-content').hide();
    _MDTeamDataController["default"].getMembers(teamInfor.getId(), function success(teamMemberCollection) {
      // 将管理员排在第一位
      var member = teamMemberCollection.findWhere({
        'memId': creatorId
      });
      teamMemberCollection.remove(member);
      teamMemberCollection.add(member, {
        at: 0
      });
      // 将我放在第二位
      if (!iamTheCreator) {
        member = teamMemberCollection.findWhere({
          'memId': curUserId
        });
        teamMemberCollection.remove(member);
        teamMemberCollection.add(member, {
          at: 1
        });
      }
      if (self.teamMemberCollection) {
        self.stopListening(self.teamMemberCollection);
      }
      if (self.curTeamInfor) {
        self.stopListening(self.curTeamInfor.collection);
      }
      self.curTeamInfor = teamInfor;
      self.teamMemberCollection = teamMemberCollection;
      self.listenTo(self.curTeamInfor.collection, 'remove', self._teamRemoveHandler);
      self.refresh();
      self.listenTo(teamMemberCollection, 'remove', self._onMemberRemoved);
      self.listenTo(teamMemberCollection, 'add', self._onMemberAdded);
      if (teamInfor.getCreatorId() == app.currentUser.getUserId()) {
        self.$('.show-link').removeClass("f-hide");
      } else {
        self.$('.show-link').addClass("f-hide");
      }
      _MDSpinnerloaderView["default"].clearFrom(self.$el[0]);
      self.$('.infor-content').show();
    }, function fail() {
      _MDSnackbarView["default"].show(BabelStr.str(5082));
      _MDSpinnerloaderView["default"].clearFrom(self.$el[0]);
    });
  },
  render: function render(data) {
    var teamInfor = this.curTeamInfor;
    var teamJson = this.curTeamInfor.toJSON();
    data = {
      'name': teamInfor.getDisplayName(),
      'memberLimit': teamInfor.getMemLimit(),
      'creatorName': teamInfor.getCreatorName(),
      'creatorId': teamInfor.getCreatorId(),
      'creatorEmail': teamInfor.getCreatorMail(),
      'curUserId': app.currentUser.getUserId(),
      'members': this.teamMemberCollection.toJSON(),
      'isCurUserManager': teamInfor.isCurUserManager(),
      'isExpire': teamInfor.isExpire(),
      'description': teamJson['description'],
      'getRoleName': function getRoleName(roleId) {
        switch (roleId) {
          case 0:
        }
      }
    };
    _MMViewBase["default"].prototype.render.call(this, data);
    if (this.teamNameInputView) {
      this.teamNameInputView.remove();
    }
    ;
    this.teamNameInputView = new _MDEditalbeInputDiv["default"]({
      parentDiv: this.$('.team-name')[0],
      placeholder: BabelStr.str(5083),
      maxlength: 40,
      updatedCallback: function updatedCallback(newtext, callback) {
        newtext = newtext.trim();
        if (!newtext) {
          _MDSnackbarView["default"].show(BabelStr.str(5084));
          return;
        }
        self._updateTeamName(newtext, callback);
      }
    });
    if (this.descInputDiv) {
      this.descInputDiv.remove();
    }
    ;
    var self = this;
    this._renderMemberName();
    this.descInputDiv = new _MDEditalbeTextDiv["default"]({
      parentDiv: this.$el.find('.team-desp')[0],
      text: teamJson['description'],
      placeholder: BabelStr.str(5085),
      maxlength: 100,
      disabelEdit: teamInfor.getCreatorId() != app.currentUser.getUserId(),
      updatedCallback: function updatedCallback(newtext) {
        newtext = newtext.trim();
        var updateParam = {
          'description': newtext
        };
        _MDTeamDataController["default"].update(self.curTeamInfor.getId(), updateParam, function () {
          self.curTeamInfor.setDiscription(newtext);
        }, function () {
          self.descInputDiv.setText(self.curTeamInfor.getDiscription());
          _MDSnackbarView["default"].show(BabelStr.str(5086));
        });
      }
    });
    var isEpVersion = app.isEpVersion();
    var isEpAdmin = app.currentUser.isEpAdminUser();
    // if (!isEpVersion || (isEpVersion && isEpAdmin)) {
    if (teamInfor.isCurUserManager()) {
      this.$el.find('#add-member-btn').show();
      this.$el.find('.exit-team').text(BabelStr.str(67));
    } else {
      this.$el.find('#add-member-btn').hide();
      this.$el.find('.exit-team').text(BabelStr.str(5087));
      this.teamNameInputView.setReadOnly();
    }
    if (teamInfor.getCreatorId() == app.currentUser.getUserId()) {
      this.$el.find('.exit-team').text(BabelStr.str(67));
    } else {
      this.$el.find('.exit-team').text(BabelStr.str(5087));
      this.teamNameInputView.setReadOnly();
    }

    // }

    this.teamNameInputView.setInputVal(teamInfor.getDisplayName());
    if (this.$('.add-member-content').length) {
      this.descInputDiv.setText(teamJson['description']);
      this.chooseView = new _MDEnterpriseShareTabView["default"]({
        notIncludeGuest: true,
        needGroupTreeTab: false,
        needDepTree: false,
        fromStr: BabelStr.str(6064),
        placeholder: BabelStr.str(6066),
        allowEmail: false,
        showErrorInput: false,
        needSearch: false
      });
      this.addSubView(this.chooseView, this.$('.add-member-content')[0]);
      this.roleSelectView = new _MDRoleSelectView["default"]({
        onRoleChanged: function onRoleChanged(role) {
          self.role = role;
        }
      });
      this.addSubView(this.roleSelectView, this.$('.add-member-content'));
      if (_.isArray(this.roles)) {
        var role = _.findWhere(this.roles, {
          'id': this.defaultRoleId
        });
        role = role || this.roles[0];
        this.roleSelectView.setRoles(this.roles);
        this.roleSelectView.selectRole(role, true);
      }
    }
    this.navigationWindowView && this.navigationWindowView.refreshWindow();
  },
  _clearAllNameInputDivs: function _clearAllNameInputDivs() {
    if (this.memberNameInputDivs) {
      for (var i = 0; i < this.memberNameInputDivs.length; i++) {
        var inputDiv = this.memberNameInputDivs[i];
        inputDiv.remove();
      }
    }
    this.memberNameInputDivs = [];
  },
  _renderMemberName: function _renderMemberName() {
    this._clearAllNameInputDivs();
    var self = this;
    this.teamMemberCollection.each(function (memberInfo) {
      self._addNameInputDiv(memberInfo);
    });
  },
  _addNameInputDiv: function _addNameInputDiv(memberInfo) {
    var self = this;
    var teamId = this.curTeamInfor.getId();
    var member = memberInfo.toJSON();
    var cid = memberInfo.cid;
    var userId = memberInfo.getMemId();
    var name = self._getDispName(member);
    var name_tail = member.name_tail;
    var $target = this.$('tr[data-cid="' + cid + '"] .name-cell .name');
    $target.text('');
    var parentDiv = $target[0];
    if (parentDiv) {
      var inputDiv = new _MDEditalbeTextDiv["default"]({
        parentDiv: parentDiv,
        text: name,
        text_tail: name_tail,
        maxlength: 50,
        disabelEdit: false,
        small: true,
        updatedCallback: function updatedCallback(newName) {
          newName = newName.trim();
          _MDTeamDataController["default"].updateMemberNickname(teamId, userId, newName, function () {
            memberInfo = self.teamMemberCollection.get(cid);
            memberInfo.set('remark', newName);
            var dispName = self._getDispName(memberInfo.attributes);
            inputDiv.setText(dispName);
          }, function () {});
        }
      });
      inputDiv.membCid = cid;
      self.memberNameInputDivs.push(inputDiv);
    }
  },
  _onMemberRemoved: function _onMemberRemoved(model, collection, options) {
    var cid = model.cid;
    this.$('tr[data-cid="' + cid + '"]').fadeOut(function () {
      $(this).remove();
    });
    this.navigationWindowView && this.navigationWindowView.refreshWindow();
    for (var i = 0; i < this.memberNameInputDivs.length;) {
      var inputDiv = this.memberNameInputDivs[i];
      if (inputDiv.membCid == cid) {
        inputDiv.remove();
        this.memberNameInputDivs.splice(i, 1);
      } else {
        i++;
      }
    }
  },
  _onMemberAdded: function _onMemberAdded(memberInfo, memberCollection) {
    var _this3 = this;
    var member = memberInfo.toJSON();
    var tmpl = '<tr data-cid="<%= member.cid%>">\
        <td class="name-cell">\
          <img class="avatar" src="<%= member.avatarURL %>" alt="" />\
          <div class="name"><%=(member.remark || member.alias || member.name) %></div>\
          <span class="mail"><%=(member.mail == "--" ? member.phone || member.mail : member.mail)%></span>\
        </td>\
        <td class="role-cell text-right">\
          <a class="auth">\
            <%if(member.memberShip == 1){%><span class="state"><%=BabelStr.str(5080)%></span><%}%>\
            <%if(member.memberShip == 2){%><span class="state"><%=BabelStr.str(5081)%></span><%}%>\
            <span class="rolename"><%=member.roleName%></span>\
            <i class="arrow down"></i>\
          </a>\
            <span class="icon mglr-10 ic-close-small remove" data-tooltip="<%=BabelStr.str(793)%>" data-tooltip-dir="top"></span>\
        </td>\
      </tr>';
    var res = _.template(tmpl)({
      'member': member
    });
    this.$('.team-members table tbody').append(res);
    this.navigationWindowView && this.navigationWindowView.refreshWindow();
    setTimeout(function () {
      _this3._addNameInputDiv(memberInfo);
    }, 100);
  },
  _teamRemoveHandler: function _teamRemoveHandler(teamInfo, teamCollection, options) {
    if (teamCollection.length == 0) {
      this._renderBlankState();
    }
  },
  _renderBlankState: function _renderBlankState() {
    var self = this;
    this.$el.empty();
    var emptyView = new _MDEmptyTeamView["default"]({
      onCreateTeamCallback: function onCreateTeamCallback() {
        _.isFunction(self.onCreateTeamCallback) && self.onCreateTeamCallback();
      }
    });
    this.addSubView(emptyView, this.el);
  },
  _exitTeamClickHandler: function _exitTeamClickHandler($e) {
    var self = this;
    console.log('exit team:', this.curTeamInfor.getName());
    // var msg = '';
    // if (this.curTeamInfor.getCreatorId() == app.currentUser.getUserId()) {
    //   msg = '确认要删除这个团队吗？<br>这将自动删除其所有文件，且不能恢复！'
    // } else {
    //   msg = '确认要离开这个团队吗？'
    // }
    // var alert = new MDAlertView();
    // var z_maxIndex = MMBasicData.getO2OMaxLayerZ_index();
    // alert.$el.css('z-index', z_maxIndex);
    // alert.show({
    //   title: '提示',
    //   message: msg,
    //   className: 'm-delAlertWin',
    //   buttons: [{
    //     label: '确定',
    //     type: 'done',
    //     onClick: function() {
    //       self._removeTeam();
    //     }
    //   }, {
    //     label: '取消'
    //   }]
    // });

    _MDAlertView["default"].showRemoveTeamSelection({
      teamInfo: this.curTeamInfor,
      onRemove: function onRemove() {
        self._removeTeam();
      }
    });
  },
  _getDispName: function _getDispName(memberInfo) {
    var teamInfor = this.curTeamInfor;
    var creatorId = teamInfor.getCreatorId();
    var curUserId = app.currentUser.getUserId();
    var dispName = memberInfo.remark || memberInfo.alias || memberInfo.name;
    var len = dispName.length;
    var mark = "";
    if (memberInfo.memId == creatorId) {
      mark = "(" + BabelStr.str(68) + ")";
    } else {
      if (memberInfo.memId == curUserId) {
        mark = '(' + BabelStr.str(5078) + ')';
      }
    }
    dispName += mark;
    memberInfo.name_tail = mark;
    return dispName;
  },
  _removeTeam: function _removeTeam() {
    var self = this;
    var curTeamInfor = this.curTeamInfor;
    _.isFunction(this.onBeforeExitTeam) && this.onBeforeExitTeam();
    _MDTeamDataController["default"].exitTeam(this.curTeamInfor, function () {
      var teamInfoCollection = self.curTeamInfor.collection;
      teamInfoCollection.remove(self.curTeamInfor);
      Dispatcher.trigger(MDEvents.TeamRemoved, {
        teamInfo: curTeamInfor
      });
      _.isFunction(self.onCompleteExitTeam) && self.onCompleteExitTeam();
    }, function (e) {
      _MDSnackbarView["default"].show(BabelStr.str(5088), {
        curTeamInfor: curTeamInfor
      });
      _.isFunction(self.onCompleteExitTeam) && self.onCompleteExitTeam();
    });
  },
  viewWillUnRendered: function viewWillUnRendered() {
    _MMViewBase["default"].prototype.viewWillUnRendered.call(this);
    // MDAddTeamMemberPopupView.unDelegateCreate(this.el);

    this.descInputDiv.remove();
    this.descInputDiv = null;
    this.teamNameInputView.remove();
    this.teamNameInputView = null;
    this._clearAllNameInputDivs();
  },
  _updateTeamName: function _updateTeamName(name, callback) {
    var self = this;
    var updateParam = {
      name: name
    };
    _MDTeamDataController["default"].update(this.curTeamInfor.getId(), updateParam, function () {
      self.curTeamInfor.setName(name);
      if (callback) {
        callback();
      }
      ;
    }, function () {
      _MDSnackbarView["default"].show(BabelStr.str(5089));
    });
  },
  _transferTeamClickHandler: function _transferTeamClickHandler(e) {
    this.amemberPopup = new _MDTeamMemberPopupView["default"]({
      memberList: this.teamMemberCollection.toJSON(),
      audienceSelectedCallback: function audienceSelectedCallback(member) {
        // MMEnterpriseController.transferSalon(self.salonInfo.getSalonId(), audience.id, self.fileInfo.getFileId(), function(){
        //   self.salonInfo.setAudienceToSpeaker(audience);
        //   self._updateMemInfoAndBtns();
        // }, function(){

        // })
      }
    });
    var z_startIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
    this.amemberPopup.$el.css("z-index", z_startIndex);
    var self = this;
    this.amemberPopup.show({
      triggerView: e.currentTarget,
      center: true,
      width: 100
    });
  }
});
var _default = exports["default"] = MDTeamInfoPanelView;

},{"1094":1094,"1184":1184,"1417":1417,"1432":1432,"1436":1436,"1439":1439,"1454":1454,"1463":1463,"1498":1498,"1500":1500,"1503":1503,"1541":1541,"1546":1546,"186":186,"22":22,"269":269,"28":28,"289":289,"29":29,"290":290,"32":32,"481":481,"515":515,"55":55,"65":65,"675":675,"72":72,"75":75,"76":76,"788":788,"789":789,"791":791,"811":811}],791:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1439);
var _MDPopupView = _interopRequireDefault(require(64));
var _popupPos = _interopRequireDefault(require(65));
/**
 *  Menu for zoom choices
 *  Create by jiang
 *  2017.6.16
 */

var MDTeamMemberPopupView = _MDPopupView["default"].extend({
  contentTmpl: '<ul class="m-menun teammember-popup"></ul>',
  events: function events() {
    var superEvents = _MDPopupView["default"].prototype.events.call(this);
    return _.extend({}, superEvents, {
      'click li': this._menuItemClickHandler
    });
  },
  initProps: function initProps() {
    var superP = _MDPopupView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      audienceSelectedCallback: null
    });
  },
  initialize: function initialize(opt) {
    _.extend(opt, {
      direction: _popupPos["default"].LEFT_TOP
    });
    _MDPopupView["default"].prototype.initialize.call(this, opt);
    this.initMemberList();
  },
  initMemberList: function initMemberList() {
    var html = "";
    if (this.memberList.length > 0) {
      for (var i = 0; i < this.memberList.length; i++) {
        var name = this.memberList[i].name;
        html += "<li >" + name + "</li>";
      }
      ;
    } else {
      html = "<li>" + BabelStr.str(7352) + "</li>";
    }
    this.$(".teammember-popup").append(html);
    this.$memberList = $(html);
  },
  _menuItemClickHandler: function _menuItemClickHandler($e) {
    var index = $($e.target).index();
    this.memberSelected = null;
    if (index < this.memberList.length) {
      this.memberSelected = this.memberList[index];
    }
    ;
    if (this.memberSelected) {
      if (this.audienceSelectedCallback) {
        this.audienceSelectedCallback(this.memberSelected);
      }
      ;
    } else {}
    this.close();
  }
});
var _default = exports["default"] = MDTeamMemberPopupView;

},{"1184":1184,"1439":1439,"1454":1454,"64":64,"65":65}],788:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMViewBase = _interopRequireDefault(require(22));
var _MDCreateTeamWindowView = _interopRequireDefault(require(744));
/**
 *  没有团队时的空提示
 *  Created by manjun.han
 *  2016.4.9
 */

var MDEmptyTeamView = _MMViewBase["default"].extend({
  el: '<div class="team-blankstate  text-center"></div>',
  tmpl: "<div class=\"m-empty page-empty\">\n\n          <%if(!isEpVersion){%>\n            <%if(isInRoot){%>\n              <img src=\"/img/mdisk/empty-team.png\">\n              <h3><%=BabelStr.str(7344)%></h3>\n              <div class=\"btn-group\">\n                <p>\n                  <button class=\"button done small inline create-team\"><%=BabelStr.str(66)%></button>\n                </p>\n              </div>\n            <%} else {%>\n              <h3><%=BabelStr.str(160)%></h3>\n            <%}%>\n\n          <%}else{%>\n            <img src=\"/img/mdisk/empty-team.png\">\n            <%if(isEpAdmin){%>\n              <h3><%=BabelStr.str(7344)%></h3>\n              <div class=\"btn-group\">\n              <p>\n                <button class=\"button done small inline create-team\"><%=BabelStr.str(66)%></button>\n              </p>\n              <p class=\"info\"><%=BabelStr.str(7345)%></p>\n            </div>\n            <%}else{%>\n              <h3><%=BabelStr.str(7347)%></h3>\n              <p class=\"info\"><%=BabelStr.str(7346)%></p>\n            <%}%>\n          <%}%>\n      </div>",
  events: function events() {
    var superP = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superP, {
      'click .create-team': this._createTeamBtnClickHandler
    });
  },
  initProps: function initProps() {
    var superProps = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superProps, {
      onCreateTeamCallback: _.noop
    });
  },
  initialize: function initialize(opt) {
    opt.data = {
      'isEpAdmin': app.currentUser.isEpAdminUser(),
      'isEpVersion': app.isEpVersion(),
      isInRoot: app.pathRouter.isInRoot()
    };
    _MMViewBase["default"].prototype.initialize.call(this, opt);
  },
  _createTeamBtnClickHandler: function _createTeamBtnClickHandler($e) {
    _.isFunction(this.onCreateTeamCallback) && this.onCreateTeamCallback();
  }
});
var _default = exports["default"] = MDEmptyTeamView;

},{"1184":1184,"1454":1454,"22":22,"744":744}],744:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDWindowView = _interopRequireDefault(require(93));
var _MDCreateTeamView = _interopRequireDefault(require(787));
var _MDTeamInfoCollection = _interopRequireDefault(require(290));
var _MDSnackbarView = _interopRequireDefault(require(72));
/**
 *  Create team window
 *  Created by manjun.han
 *  16.3.10
 */

var MDCreateTeamWindowView = _MDWindowView["default"].extend({
  initProps: function initProps() {
    var props = _MDWindowView["default"].prototype.initProps.call(this);
    return _.extend({}, props, {
      teamInfoCollection: new _MDTeamInfoCollection["default"](),
      onCreateTeamCallback: _.noop,
      onJoinCallback: _.noop
    });
  },
  initialize: function initialize(opt) {
    opt = _.extend(opt, {
      title: BabelStr.str(66)
    });
    _MDWindowView["default"].prototype.initialize.call(this, opt);
    this.bindSelf([this._cancelCreateTeam, this._createTeamCallback]);
    this.createTeamView = new _MDCreateTeamView["default"]({
      createTeamCallback: this._createTeamCallback,
      onCancelCreateTeam: this._cancelCreateTeam,
      teamInfoCollection: opt.teamInfoCollection
    });
    this.addSubView(this.createTeamView);
  },
  _cancelCreateTeam: function _cancelCreateTeam() {
    this.close();
  },
  _createTeamCallback: function _createTeamCallback(success, teamInfor, needPay) {
    if (!app.pathRouter.inTeam()) {
      app.pathRouter.navigateToPath('team');
    }
    if (success) {
      _MDSnackbarView["default"].show(BabelStr.str(7318));
      this.onCreateTeamCallback(teamInfor);
      this.close();
    } else {}
  }
});
var _default = exports["default"] = MDCreateTeamWindowView;

},{"1184":1184,"1454":1454,"290":290,"72":72,"787":787,"93":93}],481:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1498);
require(1439);
var _MDWindowView = _interopRequireDefault(require(93));
var _keycode = _interopRequireDefault(require(104));
var _MDFileOperationManager = _interopRequireDefault(require(326));
var _MDSnackbarView = _interopRequireDefault(require(72));
/**
 *  Window for rename file name
 *  Created by manjun.han
 *  2015.9.14
 */

var MDChangeMemerNick = _MDWindowView["default"].extend({
  contentTmpl: "<div class=\"wrapper clear-appearance\">\n    <form action=\"\">\n      <div class=\"form-item\">\n        <p class=\"mgb-10\"><%=BabelStr.str(2330)%></p>\n        <div class=\"__input_parent\">\n          <input name=\"nickname\" testFileName type=\"text\"  id=\"renameInput\" class=\"form-control testFileNameEnd testFileName\" maxlength=\"50\" palceholder=\"<%=BabelStr.str(158)%>\"/>\n        </div>\n      </div>\n      </form>\n    </div>",
  className: function className() {
    var superCls = _MDWindowView["default"].prototype.className.call(this);
    return superCls + ' m-renameWin';
  },
  initProps: function initProps() {
    var props = _MDWindowView["default"].prototype.initProps.call(this);
    return _.extend(props, {
      fileInfors: null,
      folderId: -1,
      width: 460
    });
  },
  events: function events() {
    var superE = _MDWindowView["default"].prototype.events.call(this);
    return _.extend({}, superE, {
      'keyup #renameInput': this._submitOnEnter
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    opt = _.extend({}, opt);
    this.memberInfo = opt.memberInfo;
    opt.title = BabelStr.str(30);
    opt.buttons = [{
      label: BabelStr.str(155),
      type: 'default'
    }, {
      label: BabelStr.str(154),
      type: 'done',
      autoClose: false,
      onClick: function onClick(button, $e) {
        self._submit();
        return false;
      }
    }];
    _MDWindowView["default"].prototype.initialize.call(this, opt);
  },
  _submit: function _submit() {
    var self = this;
    var originName = this._getDispName();
    var newName = $.trim(self.$("#renameInput").val());
    var validator = this.$('form').validate();
    if (validator.form()) {
      this.renameCallback(newName); // rename callback
      this.close();
    }
  },
  _getDispName: function _getDispName() {
    return this.memberInfo.remark || this.memberInfo.alias || this.memberInfo.name;
  },
  viewDidRendered: function viewDidRendered() {
    this.$input = this.$("input");
    var name = this._getDispName();
    this.$input.val(name);
    var self = this;
    if (app.canDispInNormalBrowser()) {
      self.$input.focus();
    }
    this.$('form').submit(false);
    this.$('form').validate({
      rules: {
        'nickname': {
          'maxlength': 50
        }
      },
      messages: {
        'nickname': {
          'maxlength': BabelStr.str(7199)
        }
      }
    });
  },
  _submitOnEnter: function _submitOnEnter($e) {
    if (_keycode["default"].isEnterKey($e.keyCode)) {
      this._submit();
    }
  }
});
var _default = exports["default"] = MDChangeMemerNick;

},{"104":104,"1184":1184,"1439":1439,"1454":1454,"1498":1498,"326":326,"72":72,"93":93}],186:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDPopupView = _interopRequireDefault(require(64));
/**
 *  User information popup
 *  Create by author's name
 *  2012.9.20
 */

var MDTeamMemberCtlPopup = _MDPopupView["default"].extend({
  contentTmpl: "<ul class=\"m-menu create-menu\">\n\n      <li class=\"edit-name\"><%=BabelStr.str(2330)%></li>\n      <%if(isUserManger){%>\n        <li class=\"remove-member\"><%=BabelStr.str(793)%></li>\n      <%}%>\n    </ul>",
  // 去掉中英文切换
  // <li id="lan"><%=BabelStr.str(3383)%></li>

  events: function events() {
    var supE = _MDPopupView["default"].prototype.events.call(this);
    return _.extend({
      "click .edit-name": this._editName,
      "click .remove-member": this._removeMemberFromDepart,
      outSide: this.outSide
    }, supE);
  },
  className: function className() {
    var superCls = _MDPopupView["default"].prototype.className.call(this);
    return superCls + " member-ctl-popup";
  },
  initProps: function initProps() {
    var superP = _MDPopupView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      editDepBtn: true
    });
  },
  initialize: function initialize(opt) {
    _MDPopupView["default"].prototype.initialize.call(this, opt);
  },
  render: function render(data) {
    data = {
      editRemarkName: !_.isUndefined(this.editRemarkName),
      removeMemberFromTeam: !_.isUndefined(this.removeMemberFromTeam),
      isUserManger: this.isUserManger
    };
    _MDPopupView["default"].prototype.render.call(this, data);
  },
  _editName: function _editName() {
    this.close();
    this.editRemarkName();
  },
  _removeMemberFromDepart: function _removeMemberFromDepart() {
    this.removeMemberFromTeam();
    this.close();
  }
});
var _default = exports["default"] = MDTeamMemberCtlPopup;

},{"1184":1184,"1454":1454,"64":64}],789:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1424);
require(1417);
require(1463);
var _MDPopupView = _interopRequireDefault(require(64));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDTeamDataController = _interopRequireDefault(require(1094));
var _MDSnackbarView = _interopRequireDefault(require(72));
/**
 * 团队成员列表
 * Created by manjun.han
 * File created : 2016.11.4
 * Class created: 2016.3.5
 */

var MDMemberManageView = _MDPopupView["default"].extend({
  contentTmpl: function contentTmpl() {
    return '<ul class="m-menu m-manager-view"></ul>';
  },
  initProps: function initProps() {
    var superP = _MDPopupView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      curTeamInfor: null,
      memberInfo: null
    });
  },
  events: function events() {
    var superEvents = _MDPopupView["default"].prototype.events.call(this);
    return _.extend(superEvents, {
      'click li': this._menuItemClickHandler
    });
  },
  initialize: function initialize(opt) {
    _MDPopupView["default"].prototype.initialize.call(this, opt);
    this.$teamList = this.$(".m-manager-view");
    this.curTeamInfor = opt.curTeamInfor;
    this.memberInfo = opt.memberInfo;
    this.roles = opt.roles;
    this.$tr = opt.$tr;
    this._renderMenuItem();
  },
  _renderMenuItem: function _renderMenuItem() {
    if (!this.curTeamInfor.isCurUserManager()) {
      return;
    }
    var $teamList = this.$teamList,
      strBuilder = [];
    if (this.curTeamInfor.isCurUserManager() && this.memberInfo.getMembership() == 2) {
      strBuilder = [];
      strBuilder.push('<li class="accept-member">' + BabelStr.str(5074) + '</li>');
      strBuilder.push('<li class="deny-member">' + BabelStr.str(5075) + '</li>');
    }
    ;
    if (this.curTeamInfor.isCurUserManager() && this.roles && (this.memberInfo.getMembership() == 255 || this.memberInfo.getMembership() == 1 || this.memberInfo.getMembership() == 2)) {
      var cls = '';
      var roleId = this.memberInfo.getRoleId();
      for (var i = 0; i < this.roles.length; i++) {
        cls = '';
        var role = this.roles[i];
        var check = '';
        if (roleId == role.getRoleId()) {
          check = '<i class="icon check menu-icon left"></i>';
        } else if (!role.get('systemdefault')) {
          cls = "f-hide";
        }
        var strHtml = '<li class="member-role ' + cls + '" ' + 'roleId=' + role.getRoleId() + ' roleName="' + role.getRoleName() + '"' + '>' + check + role.getRoleName() + '</li>';
        strBuilder.push(strHtml);
      }
      ;
    }
    ;
    // strBuilder.push('<li class="del-member">移除成员</li>');
    $teamList.append(strBuilder.join(''));
  },
  _findDefaultRole: function _findDefaultRole() {
    for (var i = 0; i < this.roles.length; i++) {
      var role = this.roles[i];
      if (role.getRoleId() == 2) {
        return role;
      }
      ;
    }
    ;
    console.error("-- can't find default role!");
    return null;
  },
  _menuItemClickHandler: function _menuItemClickHandler($e) {
    var self = this;
    var $li = $($e.currentTarget);
    var index = $li.index();
    var teamId = this.curTeamInfor.getId();
    var memId = this.memberInfo.getMemId();
    var memberInfo = this.memberInfo;
    if ($li.hasClass('del-member')) {
      var alertView = new _MDAlertView["default"]();
      alertView.show({
        title: BabelStr.str(170),
        message: '<p class="title">' + BabelStr.str(5076) + '?</p>',
        buttons: [{
          label: BabelStr.str(32),
          type: 'done',
          onClick: function onClick() {
            _MDTeamDataController["default"].removeMembers(teamId, [memId], function success() {
              memberInfo.collection.remove(memberInfo);
            }, function fail() {
              _MDSnackbarView["default"].show(BabelStr.str(168));
            });
          }
        }, {
          label: BabelStr.str(155)
        }]
      });
    } else if ($li.hasClass('accept-member')) {
      _MDTeamDataController["default"].acceptOrDenyApplication(teamId, memId, true, function success() {
        self.memberInfo.setMembership(255);
        self.$tr.find('.state').remove();
        var roleInfo = self._findDefaultRole();
        self.memberInfo.setRoleInfo(roleInfo);
        var roleName = roleInfo.getRoleName();
        var $span = $('<span>' + roleName + '</span>');
        // self.$tr.find('.arrow').before($span);
      }, function fail(errorCode) {
        // MDSnackbarView.show("服务器未知错误，请稍后重试");
      });
    } else if ($li.hasClass('deny-member')) {
      _MDTeamDataController["default"].acceptOrDenyApplication(teamId, memId, false, function success() {
        memberInfo.collection.remove(memberInfo);
      }, function fail() {
        // MDSnackbarView.show("服务器未知错误，请稍后重试");
      });
    } else if ($li.hasClass('member-role')) {
      var roleId = $li.attr('roleId');
      var roleName = $li.attr('roleName');
      if (roleId != self.memberInfo.getRoleId()) {
        _MDTeamDataController["default"].setUserRole(teamId, memId, roleId, function () {
          self.memberInfo.setRoleId(roleId);
          self.memberInfo.setRoleName(roleName);
          self.$tr.find('.auth>.rolename').text(roleName);
        }, function () {});
      }
      ;
    }
    this.close();
  }
});
var _default = exports["default"] = MDMemberManageView;

},{"1094":1094,"1184":1184,"1417":1417,"1424":1424,"1454":1454,"1463":1463,"32":32,"64":64,"72":72}],743:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDNavigationPageView = _interopRequireDefault(require(56));
var _MDTeamInfoCollection = _interopRequireDefault(require(290));
var _MDMemberInfoCollection = _interopRequireDefault(require(269));
var _MDTeamDataController = _interopRequireDefault(require(1094));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDCreateTeamView = _interopRequireDefault(require(787));
var MDCreateTeamNavigationPageView = _MDNavigationPageView["default"].extend({
  className: function className() {
    var superCls = _MDNavigationPageView["default"].prototype.className.call(this);
    return superCls + ' team-create-panel';
  },
  initProps: function initProps() {
    var superP = _MDNavigationPageView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      title: BabelStr.str(66),
      teamInfoCollection: new _MDTeamInfoCollection["default"]()
    });
  },
  initialize: function initialize(opts) {
    var self = this;
    _MDNavigationPageView["default"].prototype.initialize.call(this);
    this.createTeamView = new _MDCreateTeamView["default"]({
      teamInfoCollection: this.teamInfoCollection,
      createTeamCallback: function createTeamCallback(success) {
        if (success) {
          self.navigationWindowView.pop();
        }
      },
      onCancelCreateTeam: function onCancelCreateTeam() {
        self.navigationWindowView.pop();
      }
    });
    this.addSubView(this.createTeamView);
  }
});
var _default = exports["default"] = MDCreateTeamNavigationPageView;

},{"1094":1094,"1184":1184,"1454":1454,"269":269,"290":290,"56":56,"76":76,"787":787}],787:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1498);
var _MMViewBase = _interopRequireDefault(require(22));
var _MDTeamDataController = _interopRequireDefault(require(1094));
var _ValidateHelper = _interopRequireDefault(require(793));
var _MDWindowView = _interopRequireDefault(require(93));
var _MDSpinnerloaderLayerView = _interopRequireDefault(require(75));
var _MDTeamInfoCollection = _interopRequireDefault(require(290));
var _MDTeamInfo = _interopRequireDefault(require(289));
var _MDSnackbarView = _interopRequireDefault(require(72));
/**
 *  创建团队的view
 *  Created by manjun.han
 *  16.3.7
 */

var MDCreateTeamView = _MMViewBase["default"].extend({
  el: '<div class="create-team-container"></div>',
  tmpl: "<div class=\"create-team-panel center-block\">\n        <div>\n          <section class=\"block clear-appearance\">\n            <div class=\"block-bd form-horizontal container\">\n            <form >\n                <div class=\"form-item row\">\n                  <label class=\"col-3\"><%=BabelStr.str(7333)%></label>\n                  <div class=\"col-9\">\n                    <input class=\"form-control input\" id=\"tNameField\" type=\"text\" name=\"name\"\n                    maxlength=\"40\" placeholder=\"<%=BabelStr.str(7334)%>\">\n                  </div>\n                </div>\n                <div class=\"form-item row\">\n                <label class=\"col-3\"><%=BabelStr.str(7335)%></label>\n                  <div class=\"col-9\">\n                    <textarea id=\"tDes\" name=\"description\" cols=\"30\" rows=\"4\"\n                    placeholder=\"<%=BabelStr.str(7336)%>\" maxlength=\"100\" class=\"no-resize form-control input\"></textarea>\n                  </div>\n                </div>\n              </form>\n            </div>\n          </section>\n\n        </div>\n      </div>\n          <div class=\"btns-block flex-align end\">\n            <button id=\"js-cancelBtn\" class=\"button default\"><%=BabelStr.str(155)%></button><button\n            id=\"js-submitCreate\" class=\"button main \"><%=BabelStr.str(3096)%></button>\n          </div>\n      ",
  events: function events() {
    return {
      "click #js-submitCreate": this._submitCreateTeam,
      "blur #tNameField": this._checkTeamName,
      "click #js-cancelBtn": this._cancelCreateTeam,
      "keydown .input": this._checkKey
    };
  },
  DisplayMsg: [BabelStr.str(5084), BabelStr.str(7337), BabelStr.str(7338), BabelStr.str(7339)],
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      createTeamCallback: _.noop,
      $teamNumInfo: null,
      $tNameField: null,
      $tDes: null,
      teamInfoCollection: new _MDTeamInfoCollection["default"](),
      onCancelCreateTeam: _.noop
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.$teamNumInfo = this.$(".teamNumInfo");
    this.$tNameField = this.$("#tNameField");
    this.$tDes = this.$("#tDes");
    this.createTeamCallback = opt.createTeamCallback;
    this.teamInfoCollection = opt.teamInfoCollection;
  },
  _cancelCreateTeam: function _cancelCreateTeam() {
    _.isFunction(this.onCancelCreateTeam) && this.onCancelCreateTeam();
  },
  _checkTeamName: function _checkTeamName($e) {
    var self = this;
    var name = this.getVal(this.$tNameField.val());
    name = $.trim(name);
    if (name.length == 0) {
      this.$tNameField.val("");
      return;
    }
    this.teamExist = false;
    _MDTeamDataController["default"].checkTeamName(name, function success() {
      self.teamExist = false;
    }, function failed(code) {
      var validator = self.$("form").validate();
      if (_.isUndefined(code)) {} else {
        self.teamExist = true;
        validator.showErrors({
          name: self.DisplayMsg[1]
        });
      }
    });
  },
  _checkKey: function _checkKey($e) {
    if (event.keyCode == 13) {
      event.preventDefault();
      return false;
    }
  },
  getVal: function getVal(val) {
    return _.escape($.trim(val));
  },
  _submitCreateTeam: function _submitCreateTeam($e) {
    var self = this;
    var name = this.getVal(this.$tNameField.val());
    var description = this.getVal(this.$tDes.val());
    function success(teamId, orderId, res) {
      teamInfor.setId("id", teamId);
      self.createTeamCallback(true, teamInfor);
      _MDSnackbarView["default"].show(BabelStr.str(7318));
      Dispatcher.trigger(MDEvents.TeamCreated, teamInfor);
    }
    function fail(errorCode, res) {
      if (errorCode != 0) {
        _MDSnackbarView["default"].show(res["message"]);
      }
      self.createTeamCallback(false, errorCode);
    }
    var validator = this.$("form").validate();
    if (!this.teamExist && validator.form()) {
      var teamInfor = new _MDTeamInfo["default"]({
        name: name,
        description: description
      });
      _czc && _czc.push(["_trackEvent", "创建", "创建团队", "", "", ""]);
      this.$("#js-submitCreate").prop("disabled", true).text(BabelStr.str(7340) + "...");
      _MDSpinnerloaderLayerView["default"].showIn(this.el);
      _MDTeamDataController["default"].create(teamInfor, function (teamId, orderId, folderId, res) {
        self.$("#js-submitCreate").prop("disabled", false).text(BabelStr.str(3096));
        _MDSpinnerloaderLayerView["default"].clearFrom(self.el);
        success(teamId, orderId, folderId, res);
      }, function (errorCode, err) {
        self.$("#js-submitCreate").prop("disabled", false).text(BabelStr.str(3096));
        _MDSpinnerloaderLayerView["default"].clearFrom(self.el);
        fail(errorCode, err);
      });
    }
  },
  viewDidRendered: function viewDidRendered() {
    _MMViewBase["default"].prototype.viewDidRendered.call(this);
    this.$("form").validate({
      rules: {
        name: {
          required: true,
          maxlength: 40
        },
        description: {
          maxlength: 100
        }
      },
      messages: {
        name: {
          required: BabelStr.str(7341),
          maxlength: BabelStr.str(7342)
        },
        description: {
          maxlength: BabelStr.str(7343)
        }
      },
      errorPlacement: function errorPlacement(error, element) {
        element.after(error);
      }
    });
  }
});
var _default = exports["default"] = MDCreateTeamView;

},{"1094":1094,"1184":1184,"1454":1454,"1498":1498,"22":22,"289":289,"290":290,"72":72,"75":75,"793":793,"93":93}],700:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1461);
require(1424);
require(1418);
require(1463);
require(1537);
require(1477);
require(1541);
/**
 * 文件列表的问卷状态加载器：把同一屏各 .survey 文件行的状态请求合并成一次
 * /netdrive/getFormbricksSurveyStatusList.do 调用，结果按 fileId 缓存，
 * 虚拟滚动导致的行重渲染直接命中缓存。
 */
var cache = {}; // fileId -> status 字符串（未知时为 ""）
var pending = {}; // fileId -> 待回调数组
var flushTimer = null;
var flush = function flush() {
  flushTimer = null;
  var ids = Object.keys(pending);
  var callbacks = pending;
  pending = {};
  $.ajax({
    method: "post",
    url: "/netdrive/getFormbricksSurveyStatusList.do",
    data: {
      fileIds: ids.join(",")
    },
    success: function success(res) {
      var statuses = res && res.surveyStatuses || {};
      ids.forEach(function (id) {
        cache[id] = typeof statuses[id] === "string" ? statuses[id] : "";
      });
    },
    error: function error() {
      ids.forEach(function (id) {
        cache[id] = "";
      });
    },
    complete: function complete() {
      ids.forEach(function (id) {
        (callbacks[id] || []).forEach(function (cb) {
          cb(cache[id]);
        });
      });
    }
  });
};
var MDSurveyStatusLoader = {
  isSurveyFile: function isSurveyFile(fileName) {
    return /\.survey$/i.test(fileName || "");
  },
  load: function load(fileId, callback) {
    if (cache.hasOwnProperty(fileId)) {
      callback(cache[fileId]);
      return;
    }
    (pending[fileId] = pending[fileId] || []).push(callback);
    if (flushTimer === null) {
      flushTimer = setTimeout(flush, 50);
    }
  },
  statusText: function statusText(status) {
    if (status === "draft") return BabelStr.str(50110);
    if (status === "inProgress") return BabelStr.str(50111);
    if (status === "paused") return BabelStr.str(50112);
    if (status === "completed") return BabelStr.str(50113);
    return "";
  },
  // 用户在编辑器里可能发布/暂停问卷，关闭浮层后缓存的状态不再可信
  invalidate: function invalidate() {
    cache = {};
  }
};
var _default = exports["default"] = MDSurveyStatusLoader;

},{"1418":1418,"1424":1424,"1454":1454,"1461":1461,"1463":1463,"1477":1477,"1537":1537,"1541":1541}],605:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDShareFileWindowView = _interopRequireDefault(require(695));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDLocalFileCollector = _interopRequireDefault(require(330));
var _MDJoinersPopupView = _interopRequireDefault(require(504));
var _MDProgress = _interopRequireDefault(require(30));
var _MDVideoPlayerWin = _interopRequireDefault(require(437));
var _MDAudioPlayerWin = _interopRequireDefault(require(407));
var _MDDragDropController = _interopRequireDefault(require(322));
var _MDFileActionController = _interopRequireDefault(require(492));
var _MDMenuView = _interopRequireDefault(require(53));
var _MDMenuItemView = _interopRequireDefault(require(51));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDBaseFileTableRowView = _interopRequireDefault(require(480));
var _MDChannelType = _interopRequireDefault(require(717));
var _MDHomeFileMenuView = _interopRequireDefault(require(602));
var _MDRequestSharelinkPopupView = _interopRequireDefault(require(684));
var _popupPos = _interopRequireDefault(require(65));
// MDHomeTableRowView.js
/**
 *  文件浏览列表的基类
 *  Created by jiang
 *  date here(2016.6.16)
 */

var MDHomeTableRowView = _MDBaseFileTableRowView["default"].extend({
  initProps: function initProps() {
    var superP = _MDBaseFileTableRowView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      fileInfor: null,
      $btns: null
    });
  },
  events: function events() {
    var superE = _MDBaseFileTableRowView["default"].prototype.events.call(this);
    return _.extend(superE, {
      "click .btns span": this.operationBtnClickHandler,
      'mouseenter': this._onMouseEnterHandler,
      'mouseleave': this._onMouseLeaveHandler
    });
  },
  initialize: function initialize(opt) {
    this.enableDrag = true;
    this.className = 'file-row';
    this.objType = 'MDHomeTableRowView';
    if (MDHomeTableRowView.isNarrow) {
      this.className += ' narrow';
    }
    _MDBaseFileTableRowView["default"].prototype.initialize.call(this, opt);
    this.$btns = this.$('.btns');
    Dispatcher.on(MDEvents.StickOnTop, this._setStickTop, this);
    Dispatcher.on(MDEvents.CancelStickOnTop, this._cancelStickTop, this);
  },
  _setStickTop: function _setStickTop(fileInfo) {
    if (fileInfo != this.fileInfor) {
      return;
    }
    ;
    this.callStickonTopToServer(true);
  },
  _cancelStickTop: function _cancelStickTop(fileInfo) {
    if (fileInfo != this.fileInfor) {
      return;
    }
    ;
    this.callStickonTopToServer(false);
  },
  setFileInfor: function setFileInfor(fileInfor) {
    var self = this;
    this.fileInfor && this.stopListening(this.fileInfor);
    this.fileInfor = fileInfor;
    fileInfor.view = this;
    if (fileInfor.getStickonTop()) {
      this.setStickonTop(true);
    } else {
      this.setStickonTop(false);
    }
    this.registerEvents();
  },
  operationBtnClickHandler: function operationBtnClickHandler($e) {
    var btnName = $e.target.className;
    var $btn = $($e.target);
    if ($btn.hasClass("moreBtn")) {
      this._showMoreMenu($e);
    } else if ($btn.hasClass("stickon-top-btn")) {
      // this.callStickonTopToServer(true);
      Dispatcher.trigger(MDEvents.StickOnTop, this.fileInfor);
    } else if ($btn.hasClass("cancel-top-btn")) {
      Dispatcher.trigger(MDEvents.CancelStickOnTop, this.fileInfor);
      // this.callStickonTopToServer(false);
    }
  },
  _showMoreMenu: function _showMoreMenu($e, param) {
    if (!param) {
      param = {};
    }
    var self = this;
    if (this.moreMenu) {
      this.moreMenu.dismiss();
    } else {
      // MMNetDiskDataController.checkEpUserLogined(()=>{
      var ctl = new _MDFileActionController["default"]({
        fileInfors: [this.fileInfor]
      });
      var menu = new _MDHomeFileMenuView["default"]({
        showOnlySubMeny: param.showOnlySubMeny,
        submenuType: param.submenuType,
        channel: app.pathRouter.curChannel,
        fileInfors: [this.fileInfor],
        onDismiss: function onDismiss() {
          self.moreMenu = null;
        },
        onPreviewFileAction: function onPreviewFileAction(fileInfor, otherTab) {
          if (otherTab) {
            var url = location.origin + "/main.do#file/" + fileInfor.getFileId();
            app.pathRouter.openNetTab(url);
          } else {
            var ctl = new _MDFileActionController["default"]({
              channel: app.pathRouter.curChannel
            });
            ctl.openFileInEditor(fileInfor, self.isHomeTableRowView);
          }
        },
        onShareAction: function onShareAction() {
          var $contentWrapper = self.$el.find(".contentWrapper");
          // 对于GridTableCellView
          if ($contentWrapper.length == 0) {
            $contentWrapper = self.$el;
          }
          if (!self.requestShareLinkPopup) {
            var requestShareLinkPopup = new _MDRequestSharelinkPopupView["default"]({
              fileInfor: self.fileInfor
            });
            self.once("scroll", function () {
              requestShareLinkPopup.close();
            });
            requestShareLinkPopup.show({
              width: 400,
              direction: _popupPos["default"].BOTTOM_LEFT,
              triggerView: $contentWrapper.get(0),
              onClose: function onClose() {
                self.requestShareLinkPopup = null;
              }
            });
            self.requestShareLinkPopup = requestShareLinkPopup;
          } else {
            self.requestShareLinkPopup.close();
          }
        }
      });
      this.moreMenu = menu;
      menu.renderTo(document.body);
      menu.$el.css("z-index", 100);
      menu.showMenu();
      menu.positionWithEvent($e);
      // });
    }
    // return false;
  },
  _createMoreMenuItem: function _createMoreMenuItem(ctl, menu) {
    var self = this;
    if (!self.fileInfor) {
      return;
    }
    ;
    var caption;
    var classStr;
    var teamItem;
    // 置顶的按钮
    if (self.fileInfor.canStickonTop()) {
      caption = _MDLocalString["default"].getLocalString(36); // '置顶'
      classStr = 'imenu-toTop';
      if (self.fileInfor.getStickonTop()) {
        caption = _MDLocalString["default"].getLocalString(183); // '取消置顶'
        classStr = 'menu-c-toTop';
      }
      var toTopMenuItem = this._createMenuItem(caption, classStr, function () {
        self._stickonTopToServer();
      });
      menu.addItem(toTopMenuItem);
    }
    ;

    // 管理团队
    if (self.fileInfor.isTeamFolder() && !app.isEpVersion()) {
      caption = "";
      var className = null;
      if (self.fileInfor.isCurUserManager()) {
        // btns.push('<button class="manage-team-btn" title="管理团队">管理团队</button>');
        caption = _MDLocalString["default"].getLocalString(186); //  "管理团队"
      } else {
        // btns.push('<button class="manage-team-btn" title="查看团队">查看团队</button>');
        caption = _MDLocalString["default"].getLocalString(187); // "查看团队"
      }
      teamItem = this._createMenuItem(caption, className, function () {
        self._openTeamManageView();
      });
      menu.addItem(teamItem);
    }

    // 讨论组
    if (self.fileInfor.isTeamFolder()) {
      // btns.push('<button class="jump-cvs-btn" title="查看讨论组">讨论组</button>');
      var txt = _MDLocalString["default"].getLocalString(185); // 讨论组
      teamItem = this._createMenuItem(txt, null, function () {
        self._jumpToConversation();
      });
      menu.addItem(teamItem);
    }
    return true;
  },
  _createMenuItem: function _createMenuItem(caption, className, action) {
    var classStr = 'icon menu-icon ' + className;
    if (!className) {
      classStr = null;
    }
    ;
    var menuItem = new _MDMenuItemView["default"]({
      caption: caption,
      iconCls: classStr,
      onAction: action
    });
    return menuItem;
  },
  _jumpToConversation: function _jumpToConversation() {
    var self = this;
    var fileId = this.fileInfor.getFileId();
    var alert;
    _MMNetDiskDataController["default"].getConversationParticipants(this.fileInfor, function (userCollection) {
      var curUid = app.currentUser.getUserId();
      var targetMail = app.currentUser.getEmail();
      var found = false;
      userCollection.each(function (user) {
        if (user.getUserId() == curUid) {
          found = true;
          return false;
        }
        ;
      });
      if (found) {
        var path = "message/" + fileId;
        app.pathRouter.navigate(path, {
          trigger: true,
          'force': true
        });
      } else {
        if (!self.fileInfor.isShareAll()) {
          alert = new _MDAlertView["default"]();
          alert.show({
            title: _MDLocalString["default"].getLocalString(170),
            // '提示'
            message: '<p class="title">' + _MDLocalString["default"].getLocalString(200) + '</p>',
            // 该讨论组只允许指定的人进入，请联系管理员
            className: 'm-delAlertWin',
            buttons: [{
              label: _MDLocalString["default"].getLocalString(156),
              // '关闭'
              type: 'done',
              onClick: function onClick() {}
            }]
          });
        } else {
          alert = new _MDAlertView["default"]();
          alert.show({
            title: _MDLocalString["default"].getLocalString(170),
            // '提示'
            message: '<p class="title">' + _MDLocalString["default"].getLocalString(201) + '</p>',
            // 你并没有加入该分享讨论组，请点击分享获取分享链接，通过链接进入
            className: 'm-delAlertWin',
            buttons: [{
              label: _MDLocalString["default"].getLocalString(156),
              // '关闭'
              type: 'done',
              onClick: function onClick() {}
            }]
          });
        }
      }
    }, function () {});
  },
  setStickonTop: function setStickonTop(toTop) {
    this.fileInfor.setStickonTop(toTop);
    if (!toTop) {
      this.$el.removeClass('stickonTop');
    } else {
      this.$el.addClass('stickonTop');
    }
  },
  refreshBtns: function refreshBtns() {},
  _stickonTopToServer: function _stickonTopToServer() {
    var self = this;
    var toTop = !self.fileInfor.getStickonTop();
    this.callStickonTopToServer(toTop);
  },
  /**
   * @protected
   * @param  {Boolean} toTop
   */
  callStickonTopToServer: function callStickonTopToServer(toTop) {
    _czc && _czc.push(["_trackEvent", "文件操作", "置顶文件", "", "", ""]);
    var self = this;
    _MMNetDiskDataController["default"].setFileSticktotop(this.fileInfor.getFileId(), toTop, function success() {
      self.setStickonTop(toTop);
      self.superView.setFileOnTop(self.fileInfor);
    }, function fail() {});
  },
  _onMouseEnterHandler: function _onMouseEnterHandler() {
    var $content = this.$btns.prev();
    this.btnsWidth = this.$btns.addClass('f-show').width();
    this.$btns.removeClass('f-show');

    // $content.css({
    //   'padding-right': this.btnsWidth
    // });

    this.btnsShowed(true);
  },
  _onMouseLeaveHandler: function _onMouseLeaveHandler() {
    var $content = this.$btns.prev();
    $content.css({
      'padding-right': 0
    });
    this.btnsShowed(false);
  },
  btnsShowed: function btnsShowed(show) {}
}, {
  className: 'MDHomeTableRowView',
  isNarrow: _.isUndefined(localStorage["TableRowNarrow"]) ? 1 : localStorage["TableRowNarrow"] == 0 ? 0 : 1,
  canShowAllBtns: function canShowAllBtns() {
    var w = $('body').width();
    if (w < 1000) {
      return false;
    } else {
      return true;
    }
  },
  setNarrowType: function setNarrowType(isNarrow) {
    MDHomeTableRowView.isNarrow = isNarrow;
    if (isNarrow) {
      localStorage["TableRowNarrow"] = 1;
      $('.file-row').addClass('narrow');
    } else {
      localStorage["TableRowNarrow"] = 0;
      $('.file-row').removeClass('narrow');
    }
  }
});
var _default = exports["default"] = MDHomeTableRowView;

},{"1104":1104,"1150":1150,"1184":1184,"1417":1417,"1454":1454,"1463":1463,"30":30,"32":32,"322":322,"330":330,"407":407,"437":437,"480":480,"492":492,"504":504,"51":51,"53":53,"602":602,"65":65,"684":684,"695":695,"717":717}],684:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
var _MDPopupView = _interopRequireDefault(require(64));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
/**
 *  Class description here
 *  Created by author's name
 *  date here(2015.6.24)
 */

var MDRequestSharelinkPopupView = _MDPopupView["default"].extend({
  contentTmpl: '<div>\
    <p><%=BabelStr.str(7283)%> : <span class="help-inline">&nbsp;&nbsp;<%=BabelStr.str(7284)%></span>\
    <p>\
      <div class="input-group">\
       <input id="shareLinkInput" class="form-control" readonly>\
        <a id="copyBtn" class="input-group-btn button done">\
          <span><%=BabelStr.str(2653)%></span>\
          </a>\
      </div>\
    </p>\
    <p class="pwdWrapper hide"><%=BabelStr.str(394)%> : <span id="pwd"></span></p>\
    </div>',
  className: function className() {
    var superCls = _MDPopupView["default"].prototype.className.call(this);
    return superCls + ' m-getLinkPopup';
  },
  initialize: function initialize(opt) {
    opt = _.extend(opt, {
      animate: true,
      hasArrow: true
    });
    _MDPopupView["default"].prototype.initialize.call(this, opt);
    this.shareURL = "";
    this.linkPwd = "";
    this.fileInfor = opt.fileInfor;
  },
  listenToCopy: function listenToCopy() {
    var self = this;
    var $btn = this.$("#copyBtn");
    var clipboard = new Clipboard($btn[0], {
      text: function text() {
        if (self.linkPwd) {
          return BabelStr.str(409) + " : " + self.shareURL + "         " + BabelStr.str(394) + "  : " + self.linkPwd;
        } else {
          return self.shareURL;
        }
      }
    });
    this.clipboard = clipboard;
    clipboard.on('success', function (e) {
      e.clearSelection();
      var tip = self.linkPwd.length > 0 ? BabelStr.str(410) : BabelStr.str(411);
      self.showTooltip($btn, tip);
    });
    clipboard.on('error', function (e) {
      var tip = "";
      if (app.os.mac) {
        tip = BabelStr.str(7149);
      } else {
        tip = BabelStr.str(7150);
      }
      self.$("#shareLinkInput").select();
      self.showTooltip($btn, tip);
    });
  },
  viewWillRendered: function viewWillRendered() {
    _MDPopupView["default"].prototype.viewWillRendered.call(this);
    var self = this;
    var fid = this.fileInfor.getFileId();
    var isHttps = false;
    if (location.protocol == "https:") {
      isHttps = true;
    } else {
      isHttps = false;
    }
    _MMNetDiskDataController["default"].getShareUrl(fid, isHttps, function (shareURL, linkRoleId, password) {
      self.$('#shareLinkInput').val(shareURL);
      self.shareURL = shareURL;
      if (password && password.length > 0) {
        self.$('#pwd').text(password);
        self.linkPwd = password;
        self.$(".pwdWrapper").removeClass('hide');
      } else {
        self.$(".pwdWrapper").hide();
        self.layout();
      }
      self.listenToCopy();
    }, function () {});
  },
  showTooltip: function showTooltip(el, msg) {
    var $el = $(el).find("span");
    $el.addClass("tooltipped tooltipped-tc");
    $el.attr('aria-label', msg);
    $el.one("mouseleave", function () {
      $el.removeClass("tooltipped tooltipped-bc");
      $el.removeAttr("aria-label");
    });
  },
  viewDidUnRendered: function viewDidUnRendered() {
    _MDPopupView["default"].prototype.viewDidUnRendered.call(this);
    this.clipboard && this.clipboard.destroy();
  }
});
var _default = exports["default"] = MDRequestSharelinkPopupView;

},{"1104":1104,"1184":1184,"1417":1417,"1454":1454,"1463":1463,"64":64}],602:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1477);
require(1493);
require(1418);
require(1463);
require(1537);
var _MDEvents = _interopRequireDefault(require(325));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDFileActionController = _interopRequireDefault(require(492));
var _MDMenuView = _interopRequireDefault(require(53));
var _MDHomeFileActionController = _interopRequireDefault(require(601));
var _MDMenuItemView = _interopRequireDefault(require(51));
var _MDTextEditorController = _interopRequireDefault(require(1128));
var _MDChannelType = _interopRequireDefault(require(717));
var _MDTrashFileActionController = _interopRequireDefault(require(703));
var _MDJoinShareFileActionController = _interopRequireDefault(require(607));
var _MDFilePathManager = _interopRequireDefault(require(1090));
var _menusvg = _interopRequireDefault(require(1119));
/**
 *  主目录下的邮件菜单
 *  Created by manjun.han
 *  2016.7.28
 */

var MDHomeFileMenuView = _MDMenuView["default"].extend({
  initProps: function initProps() {
    var superP = _MDMenuView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      fileInfors: [],
      onShareAction: _.noop,
      useSvg: true,
      width: 266,
      showOnlySubMeny: false,
      submenuType: ""
    });
  },
  initialize: function initialize(opt) {
    _MDMenuView["default"].prototype.initialize.call(this, opt);
    this.setFileInfors(this.fileInfors);
  },
  className: function className() {
    return "MDHomeFileMenuView new";
  },
  _createFileActionController: function _createFileActionController() {
    var ctl = null;
    if (this.channel == _MDChannelType["default"].search) {
      if (app.pathRouter.isInTrash()) this.channel = _MDChannelType["default"].trash;
    }
    switch (this.channel) {
      case _MDChannelType["default"].home:
        ctl = new _MDFileActionController["default"]({
          channel: _MDChannelType["default"].home
        });
        break;
      case _MDChannelType["default"].myshare:
        ctl = new _MDFileActionController["default"]({
          channel: _MDChannelType["default"].myshare
        });
        break;
      case _MDChannelType["default"].joinshare:
        ctl = new _MDJoinShareFileActionController["default"]({
          channel: _MDChannelType["default"].joinshare
        });
        break;
      case _MDChannelType["default"].myfocus:
        ctl = new _MDFileActionController["default"]({
          channel: _MDChannelType["default"].myfocus
        });
        break;
      case _MDChannelType["default"].team:
        ctl = new _MDFileActionController["default"]({
          channel: _MDChannelType["default"].team
        });
        break;
      case _MDChannelType["default"].depart:
        ctl = new _MDFileActionController["default"]({
          channel: _MDChannelType["default"].depart
        });
        break;
      case _MDChannelType["default"].trash:
        ctl = new _MDFileActionController["default"]({
          channel: _MDChannelType["default"].trash
        });
        break;
      case _MDChannelType["default"].evaluation:
        ctl = new _MDFileActionController["default"]({
          channel: _MDChannelType["default"].evaluation
        });
        break;
      case _MDChannelType["default"].msbox:
        ctl = new _MDFileActionController["default"]({
          channel: _MDChannelType["default"].msbox
        });
        break;
      case _MDChannelType["default"].recently:
        ctl = new _MDFileActionController["default"]({
          channel: _MDChannelType["default"].recently
        });
        break;
      case _MDChannelType["default"].archive:
      case _MDChannelType["default"].myArchiveApply:
      case _MDChannelType["default"].classificationapproval:
      case _MDChannelType["default"].archiveLibrary:
      case _MDChannelType["default"].receiveArchive:
      case _MDChannelType["default"].epfile:
      case _MDChannelType["default"].personfile:
      case _MDChannelType["default"].project:
      case _MDChannelType["default"].allproject:
      case _MDChannelType["default"].msbox_receive:
      case _MDChannelType["default"].msbox_contribute:
      case _MDChannelType["default"].msbox:
      case _MDChannelType["default"].transfer:
      case _MDChannelType["default"].search:
      case _MDChannelType["default"].library:
      case _MDChannelType["default"].aiSearch:
      case _MDChannelType["default"].ai:
      case _MDChannelType["default"].webai:
        ctl = new _MDFileActionController["default"]({
          channel: this.channel
        });
        break;
    }
    if (ctl) {
      ctl.setFileInfors(this.fileInfors);
    }
    return ctl;
  },
  _createDownloadPdfWithMark: function _createDownloadPdfWithMark(ctl) {
    // if (this.channel == MDChannelType.trash) {
    //   return;
    // };
    var fileInfor = this.fileInfors[0];
    if (fileInfor.isTeamFolder() || fileInfor.isDeleted() || fileInfor.isDepartmentFolder() || !app.isEpVersion()) {
      return;
    }
    var downloadMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(4734),
      //'下载带水印PDF',
      // iconCls: "icon menu-download menu-icon",
      iconSvg: _menusvg["default"].menu_down_pdf,
      onAction: function onAction() {
        ctl.downloadMarkedPdf();
      }
    });
    return ctl.canDownloadMarkedPdf() ? downloadMenuItem : null;
  },
  _createSendHistory: function _createSendHistory(ctl) {
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    var sendFileMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(5287),
      //'HQSM发送文件',
      // iconCls: "icon menu-icon ic-setting",
      iconSvg: _menusvg["default"].menu_send_his,
      onAction: function onAction() {
        ctl.showSendHistory();
      }
    });
    return ctl.canShowSendHistory() ? sendFileMenuItem : null;
  },
  _createTransferFileMenu: function _createTransferFileMenu(ctl) {
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    if (window.ep && !window.ep.enableDispatchFileInterServer) {
      return;
    }
    var sendFileMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(6893),
      //'传送文件',
      // iconCls: "icon menu-icon ic-transfer",
      iconSvg: _menusvg["default"].menu_transform_file,
      onAction: function onAction() {
        ctl.transferFile();
      }
    });
    return ctl.canSendFile() ? sendFileMenuItem : null;
  },
  _createSendFileMenu: function _createSendFileMenu(ctl) {
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    var sendFileMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(5268),
      //'发送文件',
      // iconCls: "icon menu-icon ic-send",
      iconSvg: _menusvg["default"].menu_send,
      onAction: function onAction() {
        ctl.sendFile();
      }
    });
    return ctl.canSendFile() ? sendFileMenuItem : null;
  },
  _createManageTeam: function _createManageTeam(ctl) {
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    var sendFileMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(187),
      //'管理团队',
      // iconCls: "icon menu-icon ic-team-set",
      iconSvg: _menusvg["default"].menu_edit_team,
      onAction: function onAction() {
        ctl.showManageTeam();
      }
    });
    return ctl.canManageTeam() ? sendFileMenuItem : null;
  },
  _createSendHQSMFile: function _createSendHQSMFile(ctl) {
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    var sendFileMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(6839),
      //'发送文控文件',
      // iconCls: "icon menu-icon ic-send",
      iconSvg: _menusvg["default"].menu_send_file,
      onAction: function onAction() {
        ctl.sendHQSMFile();
      }
    });
    return ctl.canSendHQSMFile() ? sendFileMenuItem : null;
  },
  _createTransmittal: function _createTransmittal(ctl) {
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    var sendFileMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(5285),
      //'HQSM发送文件',
      // iconCls: "icon menu-icon ",
      iconSvg: _menusvg["default"].menu_send_file,
      onAction: function onAction() {
        ctl.createTransmittal();
      }
    });
    return sendFileMenuItem;
  },
  _createUnzip: function _createUnzip(ctl) {
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    var unzipMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(7473),
      //'解压',
      iconCls: "icon menu-icon ",
      onAction: function onAction() {
        ctl.unZipFile();
      }
    });
    return unzipMenuItem;
  },
  _createSecurity: function _createSecurity(ctl) {
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    var securityMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(3337),
      //'安全级别',
      // iconCls: "icon menu-icon ic-security",
      iconSvg: _menusvg["default"].menu_security,
      newTool: false,
      onAction: function onAction() {
        ctl.manageSecurity();
      }
    });
    return ctl.canManageSecurity() ? securityMenuItem : null;
  },
  _createAddtag: function _createAddtag(ctl) {
    var securityMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(106),
      //'标签',
      // iconCls: "icon menu-icon ic-security",
      iconSvg: _menusvg["default"].menu_add_tag,
      newTool: false,
      onAction: function onAction() {
        ctl.addTag();
      }
    });
    return ctl.canAddTag() ? securityMenuItem : null;
  },
  _createEditAttr: function _createEditAttr(ctl) {
    var attrMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(40207),
      //'自定义属性',
      // iconCls: "icon menu-icon ic-security",
      iconSvg: _menusvg["default"].menu_attr_search,
      newTool: false,
      onAction: function onAction() {
        ctl.editFileAttr();
      }
    });
    return ctl.canEditAttr() ? attrMenuItem : null;
  },
  _createAIAddtag: function _createAIAddtag(ctl) {
    var aiTagMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(12650),
      //'AI自动打标签',
      // iconCls: "icon menu-icon ic-ai-tag",
      iconSvg: _menusvg["default"].menu_add_tag,
      newTool: true,
      onAction: function onAction() {
        ctl.addAITag();
      }
    });
    return ctl.canAddAITag() ? aiTagMenuItem : null;
  },
  _createFocus: function _createFocus(ctl) {
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    var focusMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(244),
      //'提醒关注',
      // iconCls: "icon menu-icon ic-focus-black",
      iconSvg: _menusvg["default"].menu_focus,
      newTool: false,
      onAction: function onAction() {
        ctl.focusFile();
      }
    });
    return ctl.canFocus() ? focusMenuItem : null;
  },
  _createToProject: function _createToProject(ctl) {
    var projectItem = new _MDMenuItemView["default"]({
      caption: BabelStr.str(6651),
      // iconCls: "icon menu-icon newPro",
      iconSvg: _menusvg["default"].menu_to_project,
      onAction: function onAction() {
        ctl.createProject({
          type: 7
        });
      }
    });
    return ctl.canToProject() ? projectItem : null;
  },
  _createOpenInOtherTab: function _createOpenInOtherTab(ctl) {
    var self = this;
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    var preMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(741),
      // '在新的标签页打开',
      iconCls: "icon menu-icon menu-prevew",
      onAction: function onAction() {
        var fileInfor = self.fileInfors[0];
        _.isFunction(self.onPreviewFileAction) && self.onPreviewFileAction(fileInfor, true);
      }
    });
    // this.addItem(preMenuItem);
    // ctl.canPreview() ? preMenuItem.setEnabled(true) : preMenuItem.setEnabled(false);
  },
  _createPreviewMenuItem: function _createPreviewMenuItem(ctl) {
    var self = this;
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    var preMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(38),
      // '预览',
      // iconCls: "icon menu-icon menu-prevew",
      iconSvg: _menusvg["default"].menu_preview,
      onAction: function onAction() {
        var fileInfor = self.fileInfors[0];
        if (_.isFunction(fileInfor.isSurveyFile) && fileInfor.isSurveyFile()) {
          ctl.openSurveyPreview(fileInfor);
          return;
        }
        _.isFunction(self.onPreviewFileAction) && self.onPreviewFileAction(fileInfor);
      }
    });
    return ctl.canPreview() ? preMenuItem : null;
  },
  _isSurveyFile: function _isSurveyFile() {
    var fileInfo = this.fileInfors[0];
    return this.fileInfors.length == 1 && fileInfo && _.isFunction(fileInfo.isSurveyFile) && fileInfo.isSurveyFile();
  },
  _canPreviewSurvey: function _canPreviewSurvey() {
    var fileInfo = this.fileInfors[0];
    return this._isSurveyFile() && _.isFunction(fileInfo.canRead) && fileInfo.canRead();
  },
  _canEditSurvey: function _canEditSurvey() {
    var fileInfo = this.fileInfors[0];
    return this._canPreviewSurvey() && _.isFunction(fileInfo.canUploadVersionIgnoreLocked) && fileInfo.canUploadVersionIgnoreLocked();
  },
  _canCopySurvey: function _canCopySurvey(ctl) {
    return this._canPreviewSurvey() && ctl && _.isFunction(ctl.canCopy) && ctl.canCopy();
  },
  _createSurveySummaryMenuItem: function _createSurveySummaryMenuItem(ctl) {
    if (this.channel == _MDChannelType["default"].trash || !this._canPreviewSurvey()) {
      return;
    }
    var self = this;
    return new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(50109),
      // 查看表单
      iconSvg: _menusvg["default"].menu_survey_form,
      onAction: function onAction() {
        ctl.openSurveySummary(self.fileInfors[0]);
      }
    });
  },
  _createSurveyPreviewMenuItem: function _createSurveyPreviewMenuItem(ctl) {
    if (this.channel == _MDChannelType["default"].trash || !this._canPreviewSurvey()) {
      return;
    }
    var self = this;
    return new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(38),
      // 预览
      iconSvg: _menusvg["default"].menu_preview,
      onAction: function onAction() {
        ctl.openSurveyPreview(self.fileInfors[0]);
      }
    });
  },
  _createSurveyEditMenuItem: function _createSurveyEditMenuItem(ctl) {
    if (this.channel == _MDChannelType["default"].trash || !this._canEditSurvey()) {
      return;
    }
    var self = this;
    return new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(5314),
      // 在线编辑
      iconSvg: _menusvg["default"].menu_online_edit,
      onAction: function onAction() {
        ctl.openSurveyEdit(self.fileInfors[0]);
      }
    });
  },
  _createSurveyCopyAndEditMenuItem: function _createSurveyCopyAndEditMenuItem(ctl) {
    // ctl.canCopy() 对 .survey 恒为 false(复制脱离映射会成孤儿文件),这里用编辑权限
    // 作准入:复制要求源文件可读 + 文件夹可建,与编辑同级,Java 侧再做精确校验
    if (this.channel == _MDChannelType["default"].trash || !this._canEditSurvey()) {
      return;
    }
    var self = this;
    return new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(50102),
      // 复制并编辑
      iconSvg: _menusvg["default"].menu_quick_copy,
      onAction: function onAction() {
        ctl.copySurveyAndEdit(self.fileInfors[0]);
      }
    });
  },
  _createAiSearchImgMenuItem: function _createAiSearchImgMenuItem(ctl) {
    var self = this;
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    var preMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(26053),
      // '搜索相似图片',
      // iconCls: "icon menu-icon menu-ai-img-search",
      iconSvg: _menusvg["default"].menu_ai_img_search,
      onAction: function onAction() {
        ctl.startAISearchImg();
      }
    });
    return ctl.canShowAISearchImg() ? preMenuItem : null;
  },
  _editLink: function _editLink(ctl) {
    var linkedFile = new _MDMenuItemView["default"]({
      newTool: false,
      caption: _MDLocalString["default"].getLocalString(27011),
      //'编辑链接文件',
      // iconCls: "icon link-file menu-icon",
      iconSvg: _menusvg["default"].menu_link_file,
      onAction: function onAction() {
        ctl.editLink();
      }
    });
    if (ctl.canEditLink()) {
      return linkedFile;
    }
  },
  _createLinkFileMenuItem: function _createLinkFileMenuItem(ctl) {
    var linkedFile = new _MDMenuItemView["default"]({
      newTool: false,
      caption: _MDLocalString["default"].getLocalString(6023),
      //'查看相关文件',
      // iconCls: "icon link-file menu-icon",
      iconSvg: _menusvg["default"].menu_show_link_file,
      onAction: function onAction() {
        ctl.createLinkFileWin();
      }
    });
    if (ctl.canCreateLinkFile()) {
      return linkedFile;
    }
    return null;
  },
  _createEvaluationMenuItem: function _createEvaluationMenuItem(ctl) {
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    var fileInfor;
    for (var i = 0; i < this.fileInfors.length; i++) {
      fileInfor = this.fileInfors[0];
      if (fileInfor.isDeleted() || fileInfor.getLinkFileUrl() || fileInfor.isTeamFolder() || fileInfor.isDepartmentFolder() || fileInfor.isArchiveHouse) {
        return;
      }
    }
    var startEvaluationMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(259),
      //'开启审批',
      // iconCls: "icon ic-evaluation-b menu-icon",
      iconSvg: _menusvg["default"].menu_eval,
      onAction: function onAction() {
        ctl.ShowStartEvaluation();
      }
    });
    if (ctl.canShowStartEvaluation()) {
      return startEvaluationMenuItem;
    }
    var restartEvaluationMenuItem = new _MDMenuItemView["default"]({
      // iconCls: "icon ic-evaluation-b menu-icon",
      iconSvg: _menusvg["default"].menu_eval,
      caption: _MDLocalString["default"].getLocalString(260),
      //'重新开启审批',
      onAction: function onAction() {
        ctl.ShowDoingvaluation();
      }
    });
    if (ctl.canShowReStartEvaluation()) {
      return restartEvaluationMenuItem;
    }
    var doingEvaluationMenuItem = new _MDMenuItemView["default"]({
      // iconCls: "icon ic-evaluation-b menu-icon",
      iconSvg: _menusvg["default"].menu_eval,
      caption: _MDLocalString["default"].getLocalString(261),
      //'审批中(点击查看进度)',
      // caption: '测试',
      onAction: function onAction() {
        ctl.ShowDoingvaluation();
      }
    });
    if (ctl.canShowDoingvaluation(doingEvaluationMenuItem)) {
      return doingEvaluationMenuItem;
    }
    return null;
  },
  _createFileControlMenuItem: function _createFileControlMenuItem(ctl) {
    var fileControlMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(262),
      //'增设文件权限',
      // iconCls: "icon menu-file-ctl menu-icon",
      iconSvg: _menusvg["default"].menu_manage_file_per,
      onAction: function onAction() {
        ctl.showControlFileWinView();
      }
    });
    return ctl.canShowFileControl() ? fileControlMenuItem : null;
  },
  _createEntBcMenuItem: function _createEntBcMenuItem(ctl) {
    var entBc = new _MDMenuItemView["default"]({
      newTool: false,
      caption: _MDLocalString["default"].getLocalString(3714),
      //'作为通知的附件',
      iconCls: "icon newEntBC menu-icon",
      onAction: function onAction() {
        ctl.createEntBC(true);
      }
    });
    if (ctl.canSendEpBroadcast()) {
      return entBc;
    }
  },
  _createStatisticSubMenu: function _createStatisticSubMenu(ctl) {
    if (ctl.canDepShowFileControl()) {
      var statisticSubMenuItem = new _MDMenuItemView["default"]({
        caption: BabelStr.str(2508),
        // iconCls: "icon  menu-icon row-team-manage",
        iconSvg: _menusvg["default"].menu_edit_depart,
        onAction: function onAction() {
          ctl.manageDepInfo();
        }
      });
      return statisticSubMenuItem;
    }
  },
  _createmanageEvaluationMenuItem: function _createmanageEvaluationMenuItem(ctl) {
    var manageEvaluation = new _MDMenuItemView["default"]({
      newTool: false,
      caption: _MDLocalString["default"].getLocalString(3434),
      //'筛选审批流程',
      // iconCls: "icon  menu-icon ic-editproject",
      iconSvg: _menusvg["default"].menu_manage_dep_eval,
      onAction: function onAction() {
        ctl.showDepEvaluationWin();
      }
    });
    return ctl.canDepShowFileControl() ? manageEvaluation : null;
  },
  _createRenameMenuItem: function _createRenameMenuItem(ctl) {
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    var renameMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(30),
      //'重命名',
      // iconCls: "icon menu-rename menu-icon",
      iconSvg: _menusvg["default"].menu_rename,
      onAction: function onAction() {
        ctl.renameFile();
      }
    });
    if (ctl.canRename() || ctl.canshowAskPer(true)) {
      return renameMenuItem;
    }
  },
  _createBatchRenameMenuItem: function _createBatchRenameMenuItem(ctl) {
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    var renameMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(21950),
      //'重命名',
      // iconCls: "icon menu-rename menu-icon",
      iconSvg: _menusvg["default"].menu_batch_rename,
      onAction: function onAction() {
        ctl.batchRenameFile();
      }
    });
    if (ctl.canBatchRename()) {
      return renameMenuItem;
    }
  },
  _createMultFileRenameMenuItem: function _createMultFileRenameMenuItem(ctl) {
    var renameMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(30),
      //'重命名',
      // iconCls: "icon menu-rename menu-icon",
      iconSvg: _menusvg["default"].menu_batch_rename,
      onAction: function onAction() {
        ctl.renameMultFile();
      }
    });
    if (ctl.canRenamMultFile()) {
      return renameMenuItem;
    }
  },
  _createUploadVersion: function _createUploadVersion(ctl) {
    if (this.channel == _MDChannelType["default"].trash || this._isSurveyFile()) {
      return;
    }
    var uploadVerMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(28),
      //'上传新版本',
      // iconCls: "icon menu-newver menu-icon",
      iconSvg: _menusvg["default"].menu_new_ver,
      onAction: function onAction() {
        ctl.createNewFileVersion();
      }
    });
    if (ctl.canUploadVersion() || ctl.canShowUploadVersionBtn()) {
      return uploadVerMenuItem;
    }
  },
  _createDownload: function _createDownload(ctl) {
    // if (this.channel == MDChannelType.trash) {
    //   return;
    // };
    var fileInfor = this.fileInfors[0];
    if (fileInfor.isTeamFolder() || fileInfor.isDeleted() || this._isSurveyFile()) {
      return;
    }
    var downloadMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(29),
      //'下载',
      // iconCls: "icon menu-download menu-icon",
      iconSvg: _menusvg["default"].menu_download,
      onAction: function onAction() {
        ctl.downloadFile();
      }
    });
    var onlyOneFile = app.pathRouter.isInTrash();
    if (ctl.canDownload() || ctl.canshowAskPer(onlyOneFile)) {
      return downloadMenuItem;
    }
  },
  _createCloseShare: function _createCloseShare(ctl) {
    if (this.channel != _MDChannelType["default"].myshare) {
      return;
    }
    var caption = _MDLocalString["default"].getLocalString(2846);
    var closeShareMenuItem = new _MDMenuItemView["default"]({
      caption: caption,
      //'删除',
      // iconCls: "icon menu-icon menu-leave-share",
      iconSvg: _menusvg["default"].menu_quit_share,
      onAction: function onAction() {
        ctl.closeShare();
      }
    });
    return closeShareMenuItem;
  },
  _createDel: function _createDel(ctl) {
    if (this.channel == _MDChannelType["default"].trash || this.channel == _MDChannelType["default"].myshare) {
      return;
    }
    var caption = _MDLocalString["default"].getLocalString(32);
    var canLeaveShare = true;
    this.fileInfors.forEach(function (f) {
      if (!f.isMyJoinedShare()) {
        canLeaveShare = false;
      }
    });
    // let cls = "menu-delete";
    var cls = _menusvg["default"].menu_delete_to_transh;
    if (canLeaveShare) {
      return;
      // caption = MDLocalString.getLocalString(2566);
      // cls = menusvg.menu_quit_share
    }
    var delMenuItem = new _MDMenuItemView["default"]({
      caption: caption,
      //'删除',
      iconSvg: cls,
      onAction: function onAction() {
        ctl.deleteFiles();
      }
    });
    return ctl.canDelete() ? delMenuItem : null;
  },
  _createLeaveShare: function _createLeaveShare(ctl) {
    if (this.channel == _MDChannelType["default"].trash || this.channel == _MDChannelType["default"].myshare) {
      return;
    }
    var caption = _MDLocalString["default"].getLocalString(32);
    var canLeaveShare = true;
    this.fileInfors.forEach(function (f) {
      if (!f.isMyJoinedShare()) {
        canLeaveShare = false;
      }
    });
    // let cls = "menu-delete";
    var cls = _menusvg["default"].menu_delete_to_transh;
    if (canLeaveShare) {
      caption = _MDLocalString["default"].getLocalString(2566);
      cls = _menusvg["default"].menu_quit_share;
    } else {
      return;
    }
    var delMenuItem = new _MDMenuItemView["default"]({
      caption: caption,
      //'删除',
      iconSvg: cls,
      onAction: function onAction() {
        ctl.deleteFiles();
      }
    });
    return ctl.canDelete() ? delMenuItem : null;
  },
  _createMove: function _createMove(ctl) {
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    var moveMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(31),
      //'移动',
      // iconCls: "icon menu-move menu-icon",
      iconSvg: _menusvg["default"].menu_move,
      onAction: function onAction() {
        ctl.moveFiles(true);
      }
    });
    if (ctl.canMove() || ctl.canShowAskMoveBtn()) {
      return moveMenuItem;
    }
  },
  _createCut: function _createCut(ctl) {
    if (this.channel == _MDChannelType["default"].trash || app.ep && app.ep.isArchive() || this._isSurveyFile()) {
      return;
    }
    var moveMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(6863),
      //'剪贴',
      // iconCls: "icon menu-cut menu-icon",
      iconSvg: _menusvg["default"].menu_quick_cut,
      onAction: function onAction() {
        ctl.cutFiles(true);
      }
    });
    if (ctl.canRead() && ctl.canMove()) {
      return moveMenuItem;
    }
  },
  _createCopy: function _createCopy(ctl) {
    // if (this.channel == MDChannelType.trash) {
    //   return;
    // };
    if (this._isSurveyFile()) {
      return;
    }
    var copyMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(33),
      //'复制到',
      // iconCls: "icon menu-copy menu-icon",
      iconSvg: _menusvg["default"].menu_copy_to,
      onAction: function onAction() {
        ctl.copyFiles();
      }
    });
    if (ctl.canCopy() || ctl.canshowAskPer()) {
      return copyMenuItem;
    }
  },
  _createQuickCopy: function _createQuickCopy(ctl) {
    // if (this.channel == MDChannelType.trash) {
    //   return;
    // };
    if (this._isSurveyFile()) {
      return;
    }
    var copyMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(2653),
      //'复制',
      // iconCls: "icon menu-quick-copy menu-icon",
      iconSvg: _menusvg["default"].menu_quick_copy,
      onAction: function onAction() {
        ctl.quickCopyFiles();
      }
    });
    if (ctl.canCopy()) {
      return copyMenuItem;
    }
  },
  createPasteMenu: function createPasteMenu(ctl) {
    if (!window.pasteObj) {
      return;
    }
    // if(app.pathRouter.isInFolderPath(window.pasteObj.originParent)) {
    //   return
    // }
    var pastMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(6864),
      //'粘贴',
      // iconCls: "icon menu-quick-copy menu-icon",
      iconSvg: _menusvg["default"].menu_paste,
      onAction: function onAction() {
        ctl.pastFiles();
      }
    });
    if (ctl.canPaste()) {
      this.addItem(pastMenuItem);
    }
  },
  _createShare: function _createShare(ctl) {
    if (this.channel == _MDChannelType["default"].trash || this._isSurveyFile()) {
      return;
    }
    var shareMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(13),
      //'分享',
      // iconCls: "icon menu-icon menu-share",
      iconSvg: _menusvg["default"].menu_share,
      onAction: function onAction() {
        ctl.shareFile();
      }
    });
    return ctl.canShare() ? shareMenuItem : null;
  },
  _createSnapshotLinkShare: function _createSnapshotLinkShare(ctl) {
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    var shareMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(6340),
      //'快照分享',
      // iconCls: "icon menu-icon menu-share",
      iconSvg: _menusvg["default"].menu_quick_share,
      onAction: function onAction() {
        ctl.snapshotLinkShareFile();
      }
    });
    if (ctl.canSnapshotShare() && (!app.isEpVersion() || !app.ep.isShareAnoymousClosed())) {
      return shareMenuItem;
    }
  },
  _createOpenFolder: function _createOpenFolder(ctl) {
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    var folderMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(265),
      //'打开源文件所在文件夹',
      // iconCls: "icon menu-icon menu-parent-folder",
      iconSvg: _menusvg["default"].menu_open_local_folder,
      newTool: false,
      onAction: function onAction() {
        ctl.openOriginFolder();
      }
    });
    return ctl.canOpenOriginFolder() ? folderMenuItem : null;
  },
  _createSharelink: function _createSharelink(ctl) {
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    var self = this;
    var shareLinkMenuItem = new _MDMenuItemView["default"]({
      // iconCls: "icon menu-icon menu-link",
      iconSvg: _menusvg["default"].menu_share_link,
      caption: _MDLocalString["default"].getLocalString(39),
      //'获取分享链接地址',
      onAction: function onAction() {
        self.onShareAction(self.fileInfors[0]);
      }
    });
    if (self.fileInfors.length == 1 && self.fileInfors[0].canRead()) {
      return shareLinkMenuItem;
    }

    // (!app.isEpVersion() || !app.ep.isShareAnoymousClosed()) &&
    //   ctl.canGetShareLink(() => {
    //     return shareLinkMenuItem;
    //   });
  },
  _createDownloadlink: function _createDownloadlink(ctl) {
    var self = this;
    var downloadLinkMenuItem = new _MDMenuItemView["default"]({
      iconSvg: _menusvg["default"].menu_share_link,
      caption: _MDLocalString["default"].getLocalString(40118),
      //'获取下载地址',
      onAction: function onAction() {
        ctl.showDownloadLink();
      }
    });
    if (self.fileInfors.length == 1 && self.fileInfors[0].canDownload() && !self.fileInfors[0].isFolder()) {
      return downloadLinkMenuItem;
    }
  },
  _createLookVer: function _createLookVer(ctl) {
    var verMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(35),
      //'查看版本',
      // iconCls: "icon menu-icon menu-prever",
      iconSvg: _menusvg["default"].menu_show_ver,
      onAction: function onAction() {
        ctl.showFileVersion();
      }
    });
    return ctl.canShowVersion() ? verMenuItem : null;
  },
  _createLookFileInfo: function _createLookFileInfo(ctl) {
    var infoMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(40),
      //'查看详情',
      // iconCls: "icon menu-icon  menu-info",
      iconSvg: _menusvg["default"].menu_file_info,
      onAction: function onAction() {
        ctl.showFileInfor();
      }
    });
    return ctl.canShowInfor() ? infoMenuItem : null;
  },
  _createLinkForFile: function _createLinkForFile(ctl) {
    if (this.channel == _MDChannelType["default"].trash || app.pathRouter.isInSearch()) {
      return;
    }
    if (this.fileInfors[0].get("multFile")) {
      return;
    }
    if (!this.fileInfors[0].canRead()) {
      return;
    }
    var infoMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(2623),
      //'创建快捷方式',
      // iconCls: "icon menu-icon menu-filelink",
      iconSvg: _menusvg["default"].menu_add_file_link,
      onAction: function onAction() {
        ctl.createLinkForFile();
      }
    });
    return ctl.canCreateLinkForFile() ? infoMenuItem : null;
  },
  _createLock: function _createLock(ctl) {
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    var lockMenuItem = new _MDMenuItemView["default"]({
      // iconCls: "icon menu-icon menu-lock",
      iconSvg: _menusvg["default"].menu_lock_file,
      caption: _MDLocalString["default"].getLocalString(263),
      //'锁定文件',
      onAction: function onAction() {
        ctl.lockFile();
      }
    });
    var unlockMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(264),
      //'解锁文件',
      // iconCls: "icon menu-icon menu-lock",
      iconSvg: _menusvg["default"].menu_unlock_file,
      onAction: function onAction() {
        ctl.unlockFile();
      }
    });
    if (ctl.canLockFile()) {
      return lockMenuItem;
    }
    if (ctl.canUnlockFile()) {
      return unlockMenuItem;
    }
  },
  _manageMsBox: function _manageMsBox(ctl) {
    var self = this;
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    if (ctl.canManageMsBox()) {
      var msBoxMenuItem = new _MDMenuItemView["default"]({
        caption: _MDLocalString["default"].getLocalString(180),
        //'设置投件箱',
        // iconCls: "icon menu-icon row-msgbox-edit",
        iconSvg: _menusvg["default"].menu_msbox,
        onAction: function onAction() {
          ctl.manageMsBox(self.fileInfors[0]);
        }
      });
      return msBoxMenuItem;
    }
  },
  _createRemoveForever: function _createRemoveForever(ctl) {
    var delMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(257),
      //'永久删除',
      // iconCls: "icon menu-icon ic-trash-del",
      iconSvg: _menusvg["default"].menu_delete_fover,
      onAction: function onAction() {
        ctl.deleteForever();
      }
    });
    return ctl.canDeleteForever() ? delMenuItem : null;
  },
  _createRestoreFile: function _createRestoreFile(ctl) {
    var restoreMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(3063),
      //'恢复',
      // iconCls: "icon menu-icon ic-trash-recover",
      iconSvg: _menusvg["default"].menu_recover,
      onAction: function onAction() {
        ctl.restoreFile();
      }
    });
    return ctl.canRestore() ? restoreMenuItem : null;
  },
  _createReturn: function _createReturn(ctl) {
    // if (this.channel == MDChannelType.home || this.channel == MDChannelType.trash || this.channel == MDChannelType.joinshare) {
    //   return;
    // };
    // var fileInfor = this.fileInfors[0];
    // if (fileInfor.isTeamFolder() || fileInfor.isDepartmentFolder()) {
    //   return;
    // };
    // var returnMenuItem = new MDMenuItemView({
    //   caption: MDLocalString.getLocalString(265),   //'打开所在文件夹',
    //   iconCls: 'icon menu-parent-folder menu-icon',
    //   onAction: function() {
    //     ctl.gobackToParent();
    //   }
    // });
    // ctl.canGobackParent() && this.addItem(returnMenuItem);
  },
  /**
   * 置顶
   */
  _createStickOnTop: function _createStickOnTop(ctl) {
    var self = this;
    if (this.channel == _MDChannelType["default"].msbox || this.channel == _MDChannelType["default"].trash || app.pathRouter.isInSearchStatus() || this.menuOption && this.menuOption.hideStickonTop) {
      return;
    }
    if (self.fileInfors.length > 1) {
      return;
    }
    var f = self.fileInfors[0];
    if (!f || f.isDeleted()) {
      return;
    }
    if (f.canStickonTop()) {
      if (!f.getStickonTop()) {
        var txt = _MDLocalString["default"].getLocalString(184);
        var returnMenuItem = new _MDMenuItemView["default"]({
          // iconCls: "icon menu-icon menu-totop",
          iconSvg: _menusvg["default"].menu_stick_top,
          caption: txt,
          onAction: function onAction() {
            _Dispatcher["default"].trigger(_MDEvents["default"].StickOnTop, f);
          }
        });
        return returnMenuItem;
      }
    }
    return null;
  },
  /**
   * 取消置顶
   */
  _createCancelStickOnTop: function _createCancelStickOnTop(ctl) {
    var self = this;
    if (this.channel == _MDChannelType["default"].msbox || this.channel == _MDChannelType["default"].trash || this.menuOption && this.menuOption.hideStickonTop) {
      return;
    }
    if (self.fileInfors.length > 1) {
      return;
    }
    var f = self.fileInfors[0];
    if (!f || f.isDeleted()) {
      return;
    }
    if (f.canStickonTop()) {
      if (f.getStickonTop()) {
        var txt = _MDLocalString["default"].getLocalString(183);
        var returnMenuItem = new _MDMenuItemView["default"]({
          // iconCls: "icon menu-icon menu-c-totop",
          iconSvg: _menusvg["default"].menu_unstick_top,
          caption: txt,
          onAction: function onAction() {
            _Dispatcher["default"].trigger(_MDEvents["default"].CancelStickOnTop, f);
          }
        });
        return returnMenuItem;
      }
    }
  },
  _createOpenLocalFolder: function _createOpenLocalFolder(ctl) {
    if (
    // this.channel != MDChannelType.home && this.channel != MDChannelType.depart ||
    this.fileInfors.length == 0 || !this.fileInfors[0].isFolder() || !app.isInClient() || !this.fileInfors[0].isFolderSynced() && !app.pathRouter.isInSyncFolderPath()) {
      return;
    }

    // var isSynced = app.isFolderSynced(this.fileInfors[0].getFileId());
    // if (!isSynced) {
    //   return;
    // };

    var localMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(266),
      //'本地打开',
      // iconCls: "icon menu-open-local menu-icon",
      iconSvg: _menusvg["default"].menu_open_local_folder,
      onAction: function onAction() {
        ctl.openLocalFolder();
      }
    });
    return ctl.canOpenLocalFolder() ? localMenuItem : null;
  },
  _createSync: function _createSync(ctl) {
    if (!ctl.canShowSyncBtn()) {
      return;
    }
    var isSynced = app.isFolderSynced(this.fileInfors[0].getFileId());
    // var className = "icon menu-sync menu-icon";
    var cls = _menusvg["default"].menu_sync;
    if (isSynced) {
      // className = "icon menu-c-sync menu-icon";
      cls = _menusvg["default"].menu_cancel_sync;
    }
    var syncStr = _MDLocalString["default"].getLocalString(5234); // 同步到本地
    var cancelStr = _MDLocalString["default"].getLocalString(268); //取消同步
    var syncMenuItem = new _MDMenuItemView["default"]({
      caption: isSynced ? cancelStr : syncStr,
      // iconCls: className,
      iconSvg: cls,
      onAction: function onAction() {
        ctl.synchronize(isSynced);
      }
    });

    // app.isInClient() &&
    // !isInSyncFolderPath && ctl.canSync() &&
    return syncMenuItem;
  },
  _createEdit: function _createEdit(ctl) {
    if (this.channel == _MDChannelType["default"].trash || this.fileInfors.length == 0 || this.fileInfors[0].isFolder()) {
      return;
    }
    var caption = _MDLocalString["default"].getLocalString(2503);
    if (app.isInClient()) {
      caption = _MDLocalString["default"].getLocalString(21530);
    }
    var editMenuItem = new _MDMenuItemView["default"]({
      caption: caption,
      //'编辑',
      // iconCls: "icon menu-edit menu-icon",
      iconSvg: _menusvg["default"].menu_edit,
      onAction: function onAction() {
        ctl.editFile();
      }
    });
    return ctl.canShowEditBtn() ? editMenuItem : null;
  },
  _createReadonlyOpen: function _createReadonlyOpen(ctl) {
    var editMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(21531),
      //'本地只读打开',
      // iconCls: "icon menu-local-open menu-icon",
      iconSvg: _menusvg["default"].menu_local_read,
      onAction: function onAction() {
        ctl.readonlyOpen();
      }
    });
    return ctl.canShowReadonlyOpen() ? editMenuItem : null;
  },
  _createOpenLink: function _createOpenLink(ctl) {
    var editMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(27005),
      //'打开链接',
      // iconCls: "icon menu-local-open menu-icon",
      iconSvg: _menusvg["default"].menu_link_file,
      onAction: function onAction() {
        ctl.openLink();
      }
    });
    return ctl.canShowOpenLink() ? editMenuItem : null;
  },
  _createEditOnline: function _createEditOnline(ctl) {
    if (this.channel == _MDChannelType["default"].trash || this.fileInfors.length == 0 || this.fileInfors[0].isFolder()) {
      return;
    }
    var editMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(5314),
      //'在线编辑',
      // iconCls: "icon menu-online menu-icon",
      iconSvg: _menusvg["default"].menu_online_edit,
      onAction: function onAction() {
        ctl.onlineEditFile();
      }
    });
    return ctl.canShowOnlineEditBtn() ? editMenuItem : null;
  },
  _createEditOnlinehelp: function _createEditOnlinehelp(ctl) {
    if (this.channel == _MDChannelType["default"].trash || this.fileInfors.length == 0 || this.fileInfors[0].isFolder()) {
      return;
    }
    var editMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(5314),
      //'在线编辑',
      iconCls: "icon menu-online menu-icon",
      onAction: function onAction() {
        ctl.showClientDownloadWin();
      }
    });
    return ctl.canShowOnlineEditHelpBtn() ? editMenuItem : null;
  },
  _clearCache: function _clearCache(ctl) {
    if (this.channel == _MDChannelType["default"].trash || this.fileInfors.length == 0 || this.fileInfors[0].isFolder()) {
      return;
    }
    var clearCacheMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(6301),
      //'编辑',
      // iconCls: "icon menu-delete menu-icon",
      iconSvg: _menusvg["default"].menu_clear_cache,
      onAction: function onAction() {
        ctl.clearChche();
      }
    });
    return ctl.canShowClearCacheBtn() ? clearCacheMenuItem : null;
  },
  _createShowParent: function _createShowParent(ctl) {
    var editMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(265),
      //'打开所在文件夹',
      // iconCls: "icon menu-parent-folder menu-icon",
      iconSvg: _menusvg["default"].menu_open_local_folder,
      onAction: function onAction() {
        ctl.openParent();
      }
    });
    return ctl.canShowParent() ? editMenuItem : null;
  },
  _createFileCreationMenu: function _createFileCreationMenu(ctl) {
    if (this.channel != _MDChannelType["default"].home) {
      return;
    }
    if (!app.currentFolder || !app.currentFolder.canUpload() || !app.isInClient()) {
      return;
    }
    var textItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(269),
      //'新建文本文件',
      iconCls: "icon menu-icon menu-text",
      onAction: function onAction() {
        ctl.createTextFile();
      }
    });
    this.addItem(textItem);
    var wordItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(270),
      //'新建 Word 文档',
      iconCls: "icon menu-icon menu-word",
      onAction: function onAction() {
        ctl.createWordFile();
      }
    });
    this.addItem(wordItem);
    var textItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(271),
      //'新建 Excel 文档',
      iconCls: "icon menu-icon menu-excel",
      onAction: function onAction() {
        ctl.createExcelFile();
      }
    });
    this.addItem(textItem);
    var textItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(272),
      //'新建 PPT 文档',
      iconCls: "icon menu-icon menu-ppt",
      onAction: function onAction() {
        ctl.createPPTFile();
      }
    });
    this.addItem(textItem);
  },
  compareFile: function compareFile(ctl) {
    var textItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(3320),
      //'比较或合并文档',
      iconCls: "icon menu-icon menu-ppt",
      onAction: function onAction() {
        ctl.openCompareWinView();
      }
    });
    if (ctl.canShowCompareBtn()) {
      // this.addItem(textItem);     //暂时隐藏
    }
  },
  _clearUnReadMark: function _clearUnReadMark(ctl) {
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    if (ctl.canClearReadMark()) {
      var reammarkItem = new _MDMenuItemView["default"]({
        // iconCls: "icon menu-icon menu-clear-read",
        iconSvg: _menusvg["default"].menu_mark_read,
        caption: _MDLocalString["default"].getLocalString(258),
        //'标记已读',
        onAction: function onAction() {
          ctl.clearFileVersionUnreadMark();
        }
      });
      return reammarkItem;
    }
  },
  _createArchive: function _createArchive(ctl) {
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    if (ctl.canArchive()) {
      var reammarkItem = new _MDMenuItemView["default"]({
        caption: _MDLocalString["default"].getLocalString(758),
        //'归档',
        // iconCls: "icon menu-icon menu-arch",
        iconSvg: _menusvg["default"].menu_archive,
        onAction: function onAction() {
          ctl.archiveFiles();
        }
      });
      return reammarkItem;
    }
    return null;
  },
  _createTaskClear: function _createTaskClear(ctl) {
    if (ctl.canShowTaskClear()) {
      var clearItem = new _MDMenuItemView["default"]({
        caption: _MDLocalString["default"].getLocalString(28011),
        //'自动清理文件夹',
        iconSvg: _menusvg["default"].menu_task_clear,
        onAction: function onAction() {
          ctl.taskClear();
        }
      });
      return clearItem;
    }
    return null;
  },
  _createTaskRename: function _createTaskRename(ctl) {
    if (ctl.canShowTaskRename()) {
      var renameItem = new _MDMenuItemView["default"]({
        caption: _MDLocalString["default"].getLocalString(28071),
        //'创建自动重命名任务',
        iconSvg: _menusvg["default"].menu_rename,
        onAction: function onAction() {
          ctl.taskRename();
        }
      });
      return renameItem;
    }
    return null;
  },
  _createEditTaskClear: function _createEditTaskClear(ctl) {
    if (ctl.canEditTaskClear()) {
      var clearItem = new _MDMenuItemView["default"]({
        caption: _MDLocalString["default"].getLocalString(28059),
        //'编辑自动清理',
        iconSvg: _menusvg["default"].menu_task_clear,
        onAction: function onAction() {
          ctl.editTaskClear();
        }
      });
      return clearItem;
    }
    return null;
  },
  _createEditTaskRename: function _createEditTaskRename(ctl) {
    if (ctl.canEditTaskRename()) {
      var renameItem = new _MDMenuItemView["default"]({
        caption: _MDLocalString["default"].getLocalString(28128),
        //'编辑自动重命名任务',
        iconSvg: _menusvg["default"].menu_rename,
        onAction: function onAction() {
          ctl.editTaskRename();
        }
      });
      return renameItem;
    }
    return null;
  },
  _createTaskOrganize: function _createTaskOrganize(ctl) {
    if (ctl.canShowTaskOrganize()) {
      var organizeItem = new _MDMenuItemView["default"]({
        caption: _MDLocalString["default"].getLocalString(28129),
        //'新建自动整理',
        iconSvg: _menusvg["default"].menu_task_organize,
        onAction: function onAction() {
          ctl.taskOrganize();
        }
      });
      return organizeItem;
    }
    return null;
  },
  _createEditTaskOrganize: function _createEditTaskOrganize(ctl) {
    if (ctl.canEditTaskOrganize()) {
      var organizeItem = new _MDMenuItemView["default"]({
        caption: _MDLocalString["default"].getLocalString(28131),
        //'编辑自动整理任务',
        iconSvg: _menusvg["default"].menu_task_organize,
        onAction: function onAction() {
          ctl.editTaskOrganize();
        }
      });
      return organizeItem;
    }
    return null;
  },
  _createTaskCON: function _createTaskCON(ctl) {
    if (ctl.canShowTaskCON()) {
      var CONItem = new _MDMenuItemView["default"]({
        caption: _MDLocalString["default"].getLocalString(28148),
        //'新建自动转PDF',
        iconSvg: _menusvg["default"].menu_down_pdf,
        onAction: function onAction() {
          ctl.taskCON();
        }
      });
      return CONItem;
    }
    return null;
  },
  _createEditTaskCON: function _createEditTaskCON(ctl) {
    if (ctl.canEditTaskCON()) {
      var CONItem = new _MDMenuItemView["default"]({
        caption: _MDLocalString["default"].getLocalString(28149),
        //'编辑自动转PDF',
        iconSvg: _menusvg["default"].menu_down_pdf,
        onAction: function onAction() {
          ctl.editTaskCON();
        }
      });
      return CONItem;
    }
    return null;
  },
  _createLocalArchive: function _createLocalArchive(ctl) {
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    if (ctl.canLocalArchive()) {
      var reammarkItem = new _MDMenuItemView["default"]({
        caption: _MDLocalString["default"].getLocalString(6804),
        //'本地归档',
        // iconCls: "icon menu-icon menu-arch",
        iconSvg: _menusvg["default"].menu_local_archive,
        onAction: function onAction() {
          ctl.archiveLocalFiles();
        }
      });
      return reammarkItem;
    }
    return null;
  },
  _translateProject: function _translateProject(ctl) {
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    if (ctl.canTranslateProject()) {
      var reammarkItem = new _MDMenuItemView["default"]({
        caption: _MDLocalString["default"].getLocalString(2825),
        //'转交',
        // iconCls: "icon menu-icon ic-project-trans",
        iconSvg: _menusvg["default"].menu_transform_project,
        onAction: function onAction() {
          ctl.translateProject();
        }
      });
      return reammarkItem;
    }
  },
  // _trsformProject: function(ctl) {
  //   if (this.channel == MDChannelType.trash) {
  //     return;
  //   };
  //   if (ctl.canshowEditProject()) {
  //     var reammarkItem = new MDMenuItemView({
  //       caption: MDLocalString.getLocalString(2833),   //'转交',
  //       iconCls: 'icon menu-icon ic-project-edit',
  //       onAction: function() {
  //         ctl.showTransformProjectToUser();
  //       }
  //     });
  //     this.addItem(reammarkItem);
  //   }
  // },

  _editProject: function _editProject(ctl) {
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    if (ctl.canshowEditProject()) {
      var reammarkItem = new _MDMenuItemView["default"]({
        caption: _MDLocalString["default"].getLocalString(2833),
        //'管理项目',
        // iconCls: "icon menu-icon ic-project-edit",
        iconSvg: _menusvg["default"].menu_edit_project,
        onAction: function onAction() {
          ctl.showEditProject();
        }
      });
      return reammarkItem;
    }
  },
  _editClassify: function _editClassify(ctl) {
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    if (ctl.canshowEditClassify()) {
      var reammarkItem = new _MDMenuItemView["default"]({
        caption: _MDLocalString["default"].getLocalString(12539),
        //'管理项目',
        // iconCls: "icon menu-icon ic-edit-library",
        iconSvg: _menusvg["default"].menu_edit_classify,
        onAction: function onAction() {
          ctl.showEditClassify();
        }
      });
      return reammarkItem;
    }
  },
  _batchEditClassify: function _batchEditClassify(ctl) {
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    if (ctl.canshowBatchEditClassify()) {
      var reammarkItem = new _MDMenuItemView["default"]({
        caption: _MDLocalString["default"].getLocalString(12571),
        //'批量设置分类',
        // iconCls: "icon menu-icon ic-edit-library",
        iconSvg: _menusvg["default"].menu_batch_edit_classifym,
        onAction: function onAction() {
          ctl.showBatchEditClassify();
        }
      });
      return reammarkItem;
    }
  },
  _batchEditLibrary: function _batchEditLibrary(ctl) {
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    if (ctl.canshowBatchEditLibrary()) {
      var reammarkItem = new _MDMenuItemView["default"]({
        caption: _MDLocalString["default"].getLocalString(12572),
        //'批量设置子素材库',
        // iconCls: "icon menu-icon ic-edit-classify",
        iconSvg: _menusvg["default"].menu_batch_edit_library,
        onAction: function onAction() {
          ctl.showBatchEditLibrary();
        }
      });
      return reammarkItem;
    }
  },
  _editLibrary: function _editLibrary(ctl) {
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    if (ctl.canshowEditLibrary()) {
      var reammarkItem = new _MDMenuItemView["default"]({
        caption: _MDLocalString["default"].getLocalString(12540),
        //'管理项目',
        // iconCls: "icon menu-icon ic-edit-classify",
        iconSvg: _menusvg["default"].menu_edit_library,
        onAction: function onAction() {
          ctl.showEditLibrary();
        }
      });
      return reammarkItem;
    }
  },
  _applyLibrary: function _applyLibrary(ctl) {
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    if (ctl.canshowApplyLibrary()) {
      var reammarkItem = new _MDMenuItemView["default"]({
        caption: _MDLocalString["default"].getLocalString(12543),
        //'管理项目',

        // iconCls: "icon menu-icon ic-edit-classify",
        iconSvg: _menusvg["default"].menu_apply_library,
        onAction: function onAction() {
          ctl.showApplyLibrary();
        }
      });
      return reammarkItem;
    }
  },
  _applyDownload: function _applyDownload(ctl) {
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    if (ctl.canshowApplyDownload()) {
      var reammarkItem = new _MDMenuItemView["default"]({
        caption: _MDLocalString["default"].getLocalString(764),
        //'申请下载',
        // iconCls: "icon menu-icon menu-download",
        iconSvg: _menusvg["default"].menu_apply_download,
        onAction: function onAction() {
          ctl.showApplyDownload();
        }
      });
      return reammarkItem;
    }
  },
  _applyJoin: function _applyJoin(ctl) {
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    if (ctl.canshowApplyJoin()) {
      var reammarkItem = new _MDMenuItemView["default"]({
        caption: _MDLocalString["default"].getLocalString(12584),
        //'申请成为成员',
        // iconCls: "icon menu-icon menu-download",
        iconSvg: _menusvg["default"].menu_apply_classify,
        onAction: function onAction() {
          ctl.showApplyJoin();
        }
      });
      return reammarkItem;
    }
  },
  _testCreateSubMenuItem: function _testCreateSubMenuItem(ctl) {
    var subMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(2833),
      //'管理项目',
      iconCls: "icon menu-icon ic-project-edit",
      onAction: function onAction() {},
      subMenuItems: [new _MDMenuItemView["default"]({
        caption: _MDLocalString["default"].getLocalString(2834),
        //'管理项目',
        iconCls: "icon menu-icon ic-project-edit",
        onAction: function onAction() {},
        subMenuItems: [new _MDMenuItemView["default"]({
          caption: _MDLocalString["default"].getLocalString(2837),
          //'管理项目',
          iconCls: "icon menu-icon ic-project-edit",
          onAction: function onAction() {}
        })]
      }), new _MDMenuItemView["default"]({
        caption: _MDLocalString["default"].getLocalString(2835),
        //'管理项目',
        iconCls: "icon menu-icon ic-project-edit",
        onAction: function onAction() {}
      })]
    });
    return subMenuItem;
  },
  createEmptyItem: function createEmptyItem(ctl) {
    var textItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(6022),
      //'空提示',
      onAction: function onAction() {}
    });
    textItem.setEnabled(false);
    this.addItem(textItem);
  },
  createOpenTypeParentMenuItem: function createOpenTypeParentMenuItem(ctl) {
    if (this._isSurveyFile()) {
      var surveySubs = [this._createSurveySummaryMenuItem(ctl), this._createSurveyPreviewMenuItem(ctl), this._createSurveyEditMenuItem(ctl), this._createSurveyCopyAndEditMenuItem(ctl)];
      surveySubs = _.compact(surveySubs);
      if (!surveySubs.length) {
        return;
      }
      return new _MDMenuItemView["default"]({
        caption: _MDLocalString["default"].getLocalString(8660),
        // 打开方式
        onAction: function onAction() {},
        iconSvg: _menusvg["default"].menu_open_type,
        subMenuItems: surveySubs
      });
    }
    var subs = [this._createEditOnline(ctl), this._createEdit(ctl), this._createPreviewMenuItem(ctl), this._createReadonlyOpen(ctl), this._createOpenLink(ctl)];
    subs = _.compact(subs);
    if (!subs.length) {
      return;
    }
    var textItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(8660),
      //'打开方式',
      onAction: function onAction() {},
      // iconSvg: "icon menu-icon row-more",
      iconSvg: _menusvg["default"].menu_open_type,
      subMenuItems: subs
    });
    return textItem;
  },
  createShareTypeParentMenuItem: function createShareTypeParentMenuItem(ctl) {
    if (this._isSurveyFile()) {
      return;
    }
    var subs = [this._createShare(ctl), this._createSnapshotLinkShare(ctl), this._createSharelink(ctl), this._createDownloadlink(ctl), this._createCloseShare(ctl),
    // this._createDel(ctl),
    this._createLeaveShare(ctl), this._createSendFileMenu(ctl), this._createTransferFileMenu(ctl), this._createLock(ctl)];
    subs = _.compact(subs);
    if (!subs.length) {
      return;
    }
    var textItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(8661),
      //'打开方式',
      onAction: function onAction() {},
      // iconCls: "icon menu-icon row-more",
      iconSvg: _menusvg["default"].menu_share_type,
      subMenuItems: subs
    });
    return textItem;
  },
  createArrangeParentMenuItem: function createArrangeParentMenuItem(ctl) {
    var subs = [this._createStickOnTop(ctl), this._createCancelStickOnTop(ctl),
    //提醒关注
    this._createMove(ctl), this._createCopy(ctl), this._createLinkForFile(ctl), this._createToProject(ctl), this._createArchive(ctl), this._createLocalArchive(ctl)];
    subs = _.compact(subs);
    if (!subs.length) {
      return;
    }
    var textItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(8662),
      //'打开方式',
      onAction: function onAction() {},
      // iconCls: "icon menu-icon row-more",
      iconSvg: _menusvg["default"].menu_arrange,
      subMenuItems: subs
    });
    return textItem;
  },
  createTaskParentMenuItem: function createTaskParentMenuItem(ctl) {
    if (this.channel == _MDChannelType["default"].trash) {
      return;
    }
    var subs = [this._createTaskClear(ctl), this._createEditTaskClear(ctl), this._createTaskRename(ctl), this._createEditTaskRename(ctl), this._createTaskOrganize(ctl), this._createEditTaskOrganize(ctl), this._createTaskCON(ctl), this._createEditTaskCON(ctl)];
    subs = _.compact(subs);
    if (!subs.length) {
      return;
    }
    var textItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(28010),
      //'任务',
      onAction: function onAction() {},
      // iconCls: "icon menu-icon row-more",
      iconSvg: _menusvg["default"].menu_task,
      subMenuItems: subs
    });
    return textItem;
  },
  _createMore: function _createMore(ctl) {
    var subs = [this._createEvaluationMenuItem(ctl), this._createLookVer(ctl), this._createLinkFileMenuItem(ctl), this._clearUnReadMark(ctl), this._createSecurity(ctl)];
    subs = _.compact(subs);
    if (!subs.length) {
      return;
    }
    var subMenuItem = new _MDMenuItemView["default"]({
      caption: _MDLocalString["default"].getLocalString(6862),
      //'更多选项',
      // iconCls: "icon menu-icon row-more",
      iconSvg: _menusvg["default"].menu_more,
      onAction: function onAction() {},
      subMenuItems: subs
    });
    return subMenuItem;
  },
  setFileInfors: function setFileInfors(fileInfors) {
    var self = this;
    this.fileInfors = fileInfors;
    var ctl = this._createFileActionController();
    if (!ctl) {
      return;
    }
    if (this.fileInfors.length > 0) {
      var subs;
      if (this.showOnlySubMeny) {
        if (this.submenuType == "task") {
          subs = [[this._createTaskClear(ctl), this._createEditTaskClear(ctl), this._createTaskRename(ctl), this._createEditTaskRename(ctl), this._createTaskOrganize(ctl), this._createEditTaskOrganize(ctl), this._createTaskCON(ctl), this._createEditTaskCON(ctl)]];
        }
      } else {
        subs = [[this.createOpenTypeParentMenuItem(ctl)], [this._batchEditClassify(ctl), this._batchEditLibrary(ctl), this._editClassify(ctl), this._editLibrary(ctl), this._createStatisticSubMenu(ctl), this._editProject(ctl), this._createManageTeam(ctl), this._manageMsBox(ctl), this._applyLibrary(ctl), this._applyJoin(ctl), this._applyDownload(ctl), this._createmanageEvaluationMenuItem(ctl), this._translateProject(ctl), this._createShowParent(ctl), this._createOpenFolder(ctl), this._editLink(ctl)], [this._createFileControlMenuItem(ctl), this._createSendHQSMFile(ctl), this._createSendHistory(ctl)], [
        //？？？新建部门

        // ？？？新建文件夹

        this._createAiSearchImgMenuItem(ctl),
        //？？？ markdown

        // 图搜图           // ai分支待合并
        this._createAddtag(ctl), this._createEditAttr(ctl),
        // 图搜图           // ai分支待合并
        this._createAIAddtag(ctl), this._createFocus(ctl)], [this._createUploadVersion(ctl),
        // more

        this._createDownload(ctl), this._createDownloadPdfWithMark(ctl), this._createRenameMenuItem(ctl), this._createBatchRenameMenuItem(ctl), this._createMultFileRenameMenuItem(ctl), this._createQuickCopy(ctl), this._createCut(ctl)], [
        //？？？ 粘贴

        this.createShareTypeParentMenuItem(ctl), this.createArrangeParentMenuItem(ctl), this.createTaskParentMenuItem(ctl), this._createLookFileInfo(ctl)], [this._createSync(ctl), this._createOpenLocalFolder(ctl), this._clearCache(ctl)

        // 转为项目
        ], [this._createDel(ctl), this._createRemoveForever(ctl), this._createRestoreFile(ctl), this._createMore(ctl)]];
      }

      // subs = _.compact(subs);

      for (var i = 0; i < subs.length; i++) {
        var subArr = subs[i];
        subArr = _.compact(subArr);
        if (subArr.length) {
          subArr[0].$el.addClass("split");
          for (var j = 0; j < subArr.length; j++) {
            this.addItem(subArr[j]);
          }
        }
      }
      // if (subs.length) {
      //   this._createMore(subs);
      // }

      /*****************************************************/

      // this._createTransmittal(ctl);

      // this._createOpenFolder(ctl);

      // this._createEditOnlinehelp(ctl);

      // this._createPreviewMenuItem(ctl);

      // this._createOpenInOtherTab(ctl);  //未使用

      // this._createEvaluationMenuItem(ctl);

      // this.compareFile(ctl);

      // this._createEntBcMenuItem(ctl)  //作为消息的附件

      // this._createDownloadPdfWithMark(ctl)

      // this._createLookVer(ctl);

      // this._createLinkForFile(ctl);

      // this._createReturn(ctl);

      // this._createArchive(ctl);

      // this._createLocalArchive(ctl)

      // this._createLinkFileMenuItem(ctl);

      // this._createSecurity(ctl);

      // 测试右键子菜单使用
      // this._testCreateSubMenuItem(ctl);

      // if (MMCommonFun.hasGodEye()) {
      //   starMenuItem.setEnabled(true);
      // } else {
      //   starMenuItem.setEnabled(true);
      // }

      if (!this.getItemCount()) {
        this.createEmptyItem(ctl);
      }
    } else {
      ctl.setFileInfors([app.currentFolder]);
      this.createPasteMenu(ctl);
      this._createFileCreationMenu(ctl);
      if (app.pathRouter.isInRoot() && this.channel != _MDChannelType["default"].personfile) {
        this.removeFromSuperView();
        return;
      }
      if (this.channel == _MDChannelType["default"].trash) {
        this.removeFromSuperView();
        return;
      }
      if (this.channel == _MDChannelType["default"].aiSearch || this.channel == _MDChannelType["default"].webai || this.channel == _MDChannelType["default"].ai) {
        this.removeFromSuperView();
        return;
      }
      var createMarkdownItemView = new _MDMenuItemView["default"]({
        caption: _MDLocalString["default"].getLocalString(273),
        //'markdown文件',
        // iconCls: "icon menu-icon menu-create-md",
        iconSvg: _menusvg["default"].menu_create_md,
        onAction: function onAction() {
          _MDTextEditorController["default"].createNewMarkDownFile();
        }
      });
      var createFolderItem = new _MDMenuItemView["default"]({
        caption: _MDLocalString["default"].getLocalString(163),
        //'新建文件夹',
        // iconCls: "icon menu-icon menu-createFolder",
        iconSvg: _menusvg["default"].menu_create_folder,
        onAction: function onAction() {
          ctl.createFolder();
        }
      });
      var uploadItem = new _MDMenuItemView["default"]({
        caption: _MDLocalString["default"].getLocalString(9),
        //'上传文件',
        // iconCls: "icon menu-icon menu-uploadFile",
        iconSvg: _menusvg["default"].menu_new_upload_file,
        onAction: function onAction() {
          ctl.openUploadWindow();
        }
      });
      var clearCacheMenuItem = new _MDMenuItemView["default"]({
        caption: _MDLocalString["default"].getLocalString(6301),
        //'清除本地缓存',
        iconSvg: _menusvg["default"].menu_clear_cache,
        // iconCls: "icon menu-delete menu-icon",
        onAction: function onAction() {
          ctl.clearAllChche();
        }
      });
      ctl.setFileInfors([app.currentFolder]);
      if (app.currentFolder.isMaterialLibrary() || app.currentFolder.isMaterialClass()) {
        var libraryItem = new _MDMenuItemView["default"]({
          caption: _MDLocalString["default"].getLocalString(12512),
          // iconCls: "icon menu-icon new-sub-library",
          iconSvg: _menusvg["default"].menu_new_library,
          onAction: function onAction() {
            ctl.createLibrary();
          }
        });
        this.addItem(libraryItem);
        var classifyItem = new _MDMenuItemView["default"]({
          caption: _MDLocalString["default"].getLocalString(12507),
          // iconCls: "icon menu-icon newClassify",
          iconSvg: _menusvg["default"].menu_new_classify,
          onAction: function onAction() {
            ctl.createClassify();
          }
        });
        this.addItem(classifyItem);
      } else {
        this.addItem(uploadItem);
        this.addItem(createFolderItem);
        this.addItem(createMarkdownItemView);
      }
      ctl.canShowClearAllCacheBtn() && this.addItem(clearCacheMenuItem);
      if (!ctl.canCreateFolder() || window["departmentFolderId"] || app.userBeingViewed) {
        createFolderItem.setEnabled(false);
      } else {
        createFolderItem.setEnabled(true);
      }
      if (!ctl.canUpload() || window["departmentFolderId"] || app.userBeingViewed) {
        uploadItem.setEnabled(false);
        createMarkdownItemView.setEnabled(false);
      } else {
        uploadItem.setEnabled(true);
        createMarkdownItemView.setEnabled(true);
      }
      if (app.isEpVersion() && !app.currentUser.canOwnFile() && app.pathRouter.isInRoot()) {
        createMarkdownItemView.setEnabled(false);
        uploadItem.setEnabled(false);
        // createFolderItem.setEnabled(false);
      }
      if (app.pathRouter.curChannel != _MDChannelType["default"].file && app.pathRouter.curChannel != _MDChannelType["default"].depart || !app.currentFolder.canCreateProject() || app.isEpVersion() && !app.currentUser.canOwnFile() && app.pathRouter.curChannel == _MDChannelType["default"].depart || !app.isEpVersion() || !app.isInClient()) {} else {
        var text = "";
        if (app.currentFolder.isProject()) {
          text = BabelStr.str(2811);
        } else {
          text = BabelStr.str(2810);
        }
        var projectItem = new _MDMenuItemView["default"]({
          caption: text,
          iconCls: "icon menu-icon newPro",
          onAction: function onAction() {
            ctl.createProject();
          }
        });
        this.addItem(projectItem);
      }

      // ctl.canUpload() ? uploadItem.setEnabled(true) : uploadItem.setEnabled(false);
      // ctl.canCreateFolder() ? createFolderItem.setEnabled(true) : createFolderItem.setEnabled(false);
    }
  }
}, {
  className: "MDHomeFileMenuView"
});
var _default = exports["default"] = MDHomeFileMenuView;

},{"1090":1090,"1119":1119,"1128":1128,"1150":1150,"1184":1184,"1418":1418,"1454":1454,"1463":1463,"1477":1477,"1493":1493,"1537":1537,"18":18,"325":325,"492":492,"51":51,"53":53,"601":601,"607":607,"703":703,"717":717}],1128:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1411);
require(1434);
require(1541);
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MMBasicData = _interopRequireDefault(require(811));
var _MDTextEditorTpl = _interopRequireDefault(require(1131));
var _MDTextEditor = _interopRequireDefault(require(1127));
var _MDMdEditor = _interopRequireDefault(require(1126));
var _MDInputFileNamePanel = _interopRequireDefault(require(1125));
var _MDfileUploadList = _interopRequireDefault(require(345));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _exportWord = _interopRequireDefault(require(232));
// MDTextEditorController.js
//
// jiang
// 2017-4-17

// import htmlDocx from 'html-docx-js/dist/html-docx.js';

// import MDTipTapEditor from "../tiptap/MDTipTapEditor.js"
var MDTextEditorController = {
  editor: null,
  initEditorWithFileInfo: function initEditorWithFileInfo(fileInfo, ver, refreshBrowserFun) {
    var _this = this;
    this.fileInfo = fileInfo;
    if (this.editor) {
      this.editor.removeFromSuperview();
    }
    initPanel.call(this);
    var self = this;
    this.scrollFirst = null;
    var cls = _MDMdEditor["default"];
    if (fileInfo) {
      var ext = fileInfo.getFileExtension().toLowerCase();
      if (ext != "md") {
        cls = _MDTextEditor["default"];
        // cls = MDTipTapEditor
        this.$el.find(".text-editor-zone").removeClass("f-hide");
      } else {
        this.$el.find(".markdown-editor-zone").removeClass("f-hide");
        this.$el.find(".export-word").removeClass("f-hide");
      }
    }
    this.editor = new cls({
      parentDiv: this.$el.find(".edit-zone")[0],
      fileInfo: fileInfo,
      ver: ver,
      changedCallback: function changedCallback() {
        self.textChanged();
      },
      scrollCallback: function scrollCallback(e) {
        self._editorScrolled(e);
      }
    });
    var conditionArr = [{
      type: "utf-8",
      name: "utf-8"
    }, {
      type: "utf-16",
      name: "utf-16"
    }, {
      type: "gbk",
      name: "gbk"
    }, {
      type: "utf-16be",
      name: "utf-16be"
    }, {
      type: "utf-16le",
      name: "utf-16le"
    }];
    if (fileInfo) {
      var ext = fileInfo.getFileExtension().toLowerCase();
      if (ext == "txt") {
        this.encodingSelect = new _MDDropdownSelectListView["default"]({
          dataProvider: conditionArr,
          labelField: "name",
          isFixed: true,
          gapY: 1,
          onChange: function onChange(obj) {
            var data = _this.editor.getOriginData();
            _this.encodeToType(data, obj.type);
          }
        });
        this.$el.find(".encode-block").append(this.encodingSelect.$el);
      }
    }
    this.setFileName(fileInfo.getFileName());
    this.refreshBrowserFun = refreshBrowserFun;
    if (!fileInfo.needDoubelView()) {
      this.$el.find(".text-editor-zone").removeClass("markdown-style");
      this.$el.find(".text-editor-zone").addClass("plaintext-style");
      this.$el.find(".preview-zone").remove();
    }
  },
  encodeToType: function encodeToType(data, type) {
    var dataView = new DataView(data);
    // The TextDecoder interface is documented at http://encoding.spec.whatwg.org/#interface-textdecoder
    var decoder = new TextDecoder(type);
    var decodedString = decoder.decode(dataView);
    this.editor.setText(decodedString);
    this.editor.markClean();
  },
  createNewMarkDownFile: function createNewMarkDownFile() {
    if (!this.editor) {
      initPanel.call(this);
      var self = this;
      this.$el.find(".markdown-editor-zone").removeClass("f-hide");
      this.editor = new _MDMdEditor["default"]({
        parentDiv: this.$el.find(".edit-zone")[0],
        changedCallback: function changedCallback() {
          self.textChanged();
        },
        scrollCallback: function scrollCallback(e) {
          self._editorScrolled(e);
        }
      });
      this.fileName = null;
      this.$el.find(".export-word").removeClass("f-hide");
    }
  },
  setFileName: function setFileName(name) {
    if (name) {
      var ext = MMCommonFun.getFileExtension1(name);
      var reg = /^\d*$/;
      if (ext.length == 0) {
        name += ".md";
      }
      this.fileName = name;
      this.$el.find(".text-file-name").text(name);
    } else {
      this.fileName = null;
    }
  },
  removeFromSuperview: function removeFromSuperview() {
    this.$el.remove();
    this.editor.removeFromSuperview();
    this.editor = null;
    this.encodingSelect = null;
    unregisterEvent.call(this);
    if (this.newVersionUploaded && this.refreshBrowserFun) {
      this.refreshBrowserFun();
    }
    this.refreshBrowserFun = null;
  },
  textChanged: function textChanged() {
    if (this.fileInfo && !this.fileInfo.needDoubelView()) {
      return;
    }
    var data = _.escape(this.editor.getText());
    marked(data, function (e, htmlStr) {
      self.$(".preview-zone")[0].innerHTML = htmlStr;
    });
  },
  _editorScrolled: function _editorScrolled(e) {
    if (!this.scrollFirst) {
      this.scrollFirst = "editor";
    }
    if (this.scrollFirst == "editor") {
      var $editorScroll = this.$el.find(".CodeMirror-scroll");
      var pos = $editorScroll[0].scrollTop / $editorScroll[0].scrollHeight;
      var $previewScroll = this.$el.find(".preview-zone");
      if ($previewScroll.length == 0) {
        return;
      }
      $previewScroll[0].scrollTop = $editorScroll[0].scrollHeight * pos;
      var self = this;
      if (this.editorTimeout) {
        clearTimeout(this.editorTimeout);
      }
      this.editorTimeout = setBabelTimeout(function () {
        self.scrollFirst = null;
      }, 100);
    }
  }
};

// ---------------------  private function

function initPanel() {
  var text = _MDTextEditorTpl["default"];
  this.$el = $(text);
  $(".app-root").append(this.$el);
  this.$el.find(".text-save").attr('data-tooltip', BabelStr.str(3080));
  this.$el.find(".export-word").attr('data-tooltip', BabelStr.str(3463));
  this.$el.find(".text-save").attr('data-tooltip', BabelStr.str(3080));
  this.$el.find(".text-close").attr("data-tooltip", BabelStr.str(156));

  // var z_startIndex = MMBasicData.getO2OMaxLayerZ_index();
  //   this.$el.css('z-index', z_startIndex);
  this.$el.find(".back-home").on("click", function (e) {
    location.href = "main.do";
  });
  registerEvent.call(this);
}
function registerEvent() {
  var self = this;
  this.$el.find(".text-close").on("click", function (e) {
    closeBtnClicked.call(self, e);
  });
  this.$el.find(".text-save").on("click", function (e) {
    saveBtnClicked.call(self, e);
  });
  this.$el.find(".export-word").on("click", function (e) {
    saveWord.call(self, e);
  });
  $(window).on("beforeunload.text", function (event) {
    // Cancel the event as stated by the standard.
    event.preventDefault();
    // Chrome requires returnValue to be set.
    if (self.editor && !self.editor.isClean()) {
      event.returnValue = BabelStr.str(4860);
      return BabelStr.str(4860);
    } else {
      event.returnValue = "";
    }
  });
  if (this.fileInfo && !this.fileInfo.needDoubelView()) {
    return;
  }
  this.$el.find(".preview-zone").on("scroll", function (e) {
    if (!self.scrollFirst) {
      self.scrollFirst = "preview";
    }
    if (self.scrollFirst == "preview") {
      var $previewScroll = self.$el.find(".preview-zone");
      var pos = $previewScroll[0].scrollTop / $previewScroll[0].scrollHeight;
      var $editorScroll = self.$el.find(".CodeMirror-scroll");
      $editorScroll[0].scrollTop = $editorScroll[0].scrollHeight * pos;
      if (self.previewTimeout) {
        clearTimeout(self.previewTimeout);
      }
      self.previewTimeout = setBabelTimeout(function () {
        self.scrollFirst = null;
      }, 100);
    }
  });
}
function unregisterEvent() {
  this.$el.find(".text-close").off("click");
  this.$el.find(".text-save").off("click");
  this.$el.find(".preview-zone").off("scroll");
  $(window).off("beforeunload.text");
}
function closeBtnClicked(e) {
  var _this2 = this;
  if (this.editor.isClean()) {
    this.removeFromSuperview();
  } else {
    var alert = new _MDAlertView["default"]();
    alert.show({
      title: BabelStr.str(170),
      message: "<p class=\"title\">".concat(BabelStr.str(5108), "</p>"),
      className: "m-delAlertWin",
      // width: 350,
      buttons: [{
        label: BabelStr.str(3080),
        type: "done",
        onClick: function onClick() {
          saveFile.call(_this2, function () {
            _this2.removeFromSuperview();
          });
        }
      }, {
        label: BabelStr.str(5109),
        type: "done",
        onClick: function onClick() {
          _this2.removeFromSuperview();
        }
      }, {
        label: BabelStr.str(155)
      }]
    });
  }
}
function saveBtnClicked(e) {
  saveFile.call(this);
}
function saveWord($e) {
  var _this3 = this;
  if (this.wordsaveing) {
    return;
  }
  this.wordsaveing = true;
  var timeout = setTimeout(function () {
    _this3.wordsaveing = false;
  }, 2000);
  var $resultElement = this.$el.find(".editormd-preview");
  // let content = $item.data("text")
  if (!$resultElement) {
    console.error("导出怎么没内容了");
    return;
  }
  var name = "";
  if (this.fileInfo) {
    name = this.fileInfo.getFileNameWithoutExt();
  }
  (0, _exportWord["default"])($resultElement[0], name);

  // const blob = htmlDocx.asBlob($resultElement[0].innerHTML);

  // // const blob = new Blob([this.result], { type: 'text/markdown;charset=utf-8' });

  // // 创建一个临时的 a 标签
  // const a = document.createElement('a');
  // a.href = URL.createObjectURL(blob);
  // a.download = 'result.docx'; // 设置下载的文件名

  // // 触发点击事件以下载文件
  // a.click();

  // // 释放 URL 对象
  // URL.revokeObjectURL(a.href);
}
function saveFile(callback) {
  var _this4 = this;
  if (this.fileName == null) {
    var text = this.editor.getText();
    if (!text || text.length == 0) {
      _MDSnackbarView["default"].show(BabelStr.str(5110));
      return;
    }
    var inputFileNamePanel = new _MDInputFileNamePanel["default"]({
      saveFile: function saveFile(fileName) {
        _czc && _czc.push(["_trackEvent", "创建", "创建 md 文件", "", fileName, ""]);
        _this4.setFileName(fileName);
        uploadNewFile.call(_this4);
        inputFileNamePanel.close();
        if (callback) {
          callback();
        }
      }
    });
    inputFileNamePanel.show();
  } else {
    uploadNewVersion.call(this, callback);
  }
}
function uploadNewFile() {
  var _this5 = this;
  // var data = _.escape(this.editor.getText());
  var data = this.editor.getText();
  // console.log('--------> save file:', this.fileName);
  // data = new Blob([data], {type: 'text/plain;charset=utf-8'})

  // var dataInfo = {};
  // dataInfo.fileName = this.fileName;
  // dataInfo.name = this.fileName;
  // dataInfo.type = "text";
  // dataInfo.size = data.length;
  // dataInfo.text = data;
  // dataInfo.needCheckFileName = true
  // var blob = new Blob([data], {
  //   type: 'text/plain'
  // });

  var blob = new Blob([data], {
    type: 'text/plain'
  });
  var dataInfo = new File([blob], this.fileName);
  _MDfileUploadList["default"].pushFile(dataInfo, function (fileInfo) {
    _this5.fileInfo = fileInfo;
    MMEnterpriseController.addFileRecentAccessUser(fileInfo.getFileId());
    if (fileInfo) {
      _this5.editor && _this5.editor.markClean && _this5.editor.markClean();
      _this5.editor && _this5.editor.markSave && _this5.editor.markSave();
    } else {
      _this5.setFileName(null);
    }
    console.error("上传完毕");
    _MDAlertView["default"].showStandardPrompt({
      message: BabelStr.str(3556)
    });
  }, undefined, undefined, {
    len: 1
  });
}
function uploadNewVersion(callback) {
  var _this6 = this;
  if (!this.fileInfo || this.editor.isClean()) {
    return;
  }

  // var data = _.escape(this.editor.getText());
  var data = this.editor.getText();
  var dataInfo = {};
  // dataInfo.fileName = this.fileName;
  // dataInfo.name = this.fileName;
  // dataInfo.type = "text";
  // dataInfo.size = data.length;
  // dataInfo.text = data;

  var blob = new Blob([data], {
    type: 'text/plain'
  });
  var dataInfo = new File([blob], this.fileName);
  _MDfileUploadList["default"].pushFile(dataInfo, this.fileInfo, function () {
    _this6.newVersionUploaded = true;
    _this6.editor && _this6.editor.markClean && _this6.editor.markClean();
    _this6.editor && _this6.editor.markSave && _this6.editor.markSave();
    console.error("上传完毕");
    _MDAlertView["default"].showStandardPrompt({
      message: BabelStr.str(3556)
    });
    if (callback) {
      callback();
    }
  });
}
var _default = exports["default"] = MDTextEditorController;

},{"1125":1125,"1126":1126,"1127":1127,"1131":1131,"1184":1184,"1411":1411,"1417":1417,"1434":1434,"1454":1454,"1463":1463,"1541":1541,"232":232,"32":32,"345":345,"67":67,"72":72,"811":811}],1131:[function(require,module,exports){
module.exports = '<!-- MDTextEditorTpl.html -->\ <!-- jiang -->\ <!-- 2017-4-17 -->\<div class="text-editor-root">\	<div class="text-panel">\		<div class="text-editor-tool">\			<img alt="巴别鸟企业网盘企业私有云盘"   src="/images/logo/logo_nav1_white.png" srcset="/images/logo/logo_nav1_white.png 1x,/images/logo/logo_nav1_white@2x.png 2x" class="clickable  back-home img-bar">\			<div class="text-file-name"></div>\      <div class="text-btns flex-align middle">\        <div class="encode-block mgr-15"  data-tooltip-dir="top"></div>\        <div class="export-word button-com mgr-10 button-icon f-hide" data-tooltip-dir="bottom"></div>\        <div class="text-save button-com button-icon" data-tooltip-dir="bottom"></div>\      </div>\			<div class="text-close button-com button-icon"data-tooltip-dir="bottom"></div>\		</div>\		<div class="text-editor-zone markdown-style f-hide">\			<div id="edit-zone" class="edit-zone"></div>\			<div class="markdown-body preview-zone"></div>\		</div>\		<div class="markdown-editor-zone markdown-style f-hide">\			<div id="markdown-editor" class="edit-zone"></div>\		</div>\	</div>\</div>\<!--\<script>\  const saveButton = document.getElementsByClassName(\'text-save\');\  saveButton.setAttribute(\'data-tooltip\', BabelStr.str(3080));\  const exportButton = document.getElementsByClassName(\'export-word\');\  exportButton.setAttribute(\'data-tooltip\', BabelStr.str(40012));\</script> -->';
},{}],1127:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1466);
var _MMCommonFun = _interopRequireDefault(require(812));
var _MDSnackbarView = _interopRequireDefault(require(72));
// MDTextEditor.js
//
// jiang
// 2017-4-17

var MDTextEditor = function MDTextEditor(param) {
  var parentDiv = param.parentDiv;
  var fileInfo = param.fileInfo;
  var changedCallback = param.changedCallback;
  var scrollCallback = param.scrollCallback;
  this.ver = param.ver;
  var mode = "markdown";
  if (fileInfo) {
    var ext = fileInfo.getFileExtension().toLowerCase();
    if (ext == "js") {
      mode = "javascript";
    } else if (ext == "txt") {
      mode = "txt";
    }
  }
  this.mirrorEditor = CodeMirror(parentDiv, {
    lineNumbers: true,
    mode: mode,
    autoCloseBrackets: true,
    matchBrackets: true,
    smartIndent: true,
    // 自带markdown缩进
    showCursorWhenSelecting: true,
    autofocus: true
  });
  this.mirrorEditor.on("change", function () {
    changedCallback && changedCallback();
  });
  this.mirrorEditor.on("scroll", function (e) {
    scrollCallback && scrollCallback(e);
  });
  this.doc = this.mirrorEditor.getDoc();
  if (fileInfo) {
    var fileId = fileInfo.getFileId();
    var board = fileInfo.getBoard();
    var version = this.ver;
    if (version == undefined || version == null) {
      version = fileInfo.getCurVersion();
    }
    var self = this;
    MMEnterpriseController.getEditOnlineFile(fileId, function (path) {
      MMNetDiskDataController.downLoadFileData(path, function (data) {
        self.originData = data;
        var decodedString = _MMCommonFun["default"].decodeFromUTF8Array(data);
        self.setText(decodedString);
        self.doc.markClean();
      }, function () {});
    }, function (err) {
      if (err.code == 127 && err.limitSize) {
        var maxSize = err.limitSize / (1024 * 1024);
        maxSize = parseInt(maxSize);
        err.msg = BabelStr.str(6814, {
          size: maxSize
        });
      }
      _MDSnackbarView["default"].show(err.msg);
    });
  }
  _MMCommonFun["default"].setTextInputInEditor("textEditor");
};
MDTextEditor.prototype.getOriginData = function () {
  return this.originData;
};
MDTextEditor.prototype.removeFromSuperview = function () {
  _MMCommonFun["default"].removeTextInputInEditor("textEditor");
  console.log("remove fom supervie!");
};
MDTextEditor.prototype.setText = function (data) {
  this.doc.setValue(data);
};
MDTextEditor.prototype.getText = function () {
  return this.doc.getValue();
};
MDTextEditor.prototype.isClean = function () {
  return this.doc.isClean();
};
MDTextEditor.prototype.markClean = function () {
  return this.doc.markClean();
};
var _default = exports["default"] = MDTextEditor;

},{"1184":1184,"1454":1454,"1466":1466,"72":72,"812":812}],1126:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1541);
require(1417);
require(1463);
var _MMCommonFun = _interopRequireDefault(require(812));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDLoadMaskView = _interopRequireDefault(require(49));
var _example = _interopRequireDefault(require(1129));
// MDMdEditor.js
//
// jiang
// 2017-4-17

var MDMdEditor = function MDMdEditor(param) {
  var parentDiv = param.parentDiv;
  var fileInfo = param.fileInfo;
  var changedCallback = param.changedCallback;
  var scrollCallback = param.scrollCallback;
  this.ver = param.ver;
  this.originData = '';
  _MDLoadMaskView["default"].show();
  var self = this;
  this.mirrorEditor = editormd('markdown-editor', {
    width: "100%",
    // height: 640,
    syncScrolling: "single",
    path: "/released-js/editor.md/lib/",
    //你的path路径（原资源文件中lib包在我们项目中所放的位置）
    // previewTheme : "dark",
    theme: "dark",
    editorTheme: "pastel-on-dark",
    // markdown : md,
    codeFold: true,
    //syncScrolling : false,
    saveHTMLToTextarea: false,
    // 保存 HTML 到 Textarea
    searchReplace: true,
    //watch : false,                // 关闭实时预览
    //htmlDecode : "style,script,iframe|on*",            // 开启 HTML 标签解析，为了安全性，默认不开启
    //toolbar  : false,             //关闭工具栏
    //previewCodeHighlight : false, // 关闭预览 HTML 的代码块高亮，默认开启
    emoji: false,
    taskList: true,
    tocm: true,
    // Using [TOCM]
    tex: true,
    // 开启科学公式TeX语言支持，默认关闭
    flowChart: true,
    // 开启流程图支持，默认关闭
    sequenceDiagram: true,
    // 开启时序/序列图支持，默认关闭,
    toolbarIcons: function toolbarIcons() {
      // Or return editormd.toolbarModes[name]; // full, simple, mini
      // Using "||" set icons align right.
      return ["undo", "redo", "|", "bold", "del", "italic", "quote", "ucwords", "uppercase", "lowercase", "|", "h1", "h2", "h3", "h4", "h5", "h6", "|", "list-ul", "list-ol", "hr", "|", "link", "reference-link", "image", "code", "preformatted-text", "code-block", "table", "datetime", "html-entities", "pagebreak", "|", "goto-line", "watch", "preview", "clear", "search", "|", "help"];
    },
    onload: function onload() {
      console.log('onload', this);
      if (fileInfo) {
        var fileId = fileInfo.getFileId();
        var board = fileInfo.getBoard();
        var version = this.ver;
        if (version == undefined || version == null) {
          version = fileInfo.getCurVersion();
        }
        MMEnterpriseController.getEditOnlineFile(fileId, function (path) {
          MMNetDiskDataController.downLoadFileData(path, function (data) {
            // self.originData = data;
            var decodedString = _MMCommonFun["default"].decodeFromUTF8Array(data);
            ;
            self.setText(decodedString);
            self.markSave();
            _MDLoadMaskView["default"].remove();
          }, function () {
            _MDLoadMaskView["default"].remove();
          });
        }, function (err) {
          _MDLoadMaskView["default"].remove();
          _MDSnackbarView["default"].show(err.msg);
        });
      } else {
        self.setText(_example["default"]);
        setTimeout(function () {
          try {
            var textarea = $(".CodeMirror-wrap").children().first().find("textarea")[0];
            var currentValue = textarea.value;
            var newValue = currentValue + "\n";

            // 修改 textarea 的值
            textarea.value = newValue;
            var event = new Event('input', {
              bubbles: true,
              cancelable: true
            });
            textarea.dispatchEvent(event);
          } catch (error) {
            console.log(error);
          }
        }, 2000);
        _MDLoadMaskView["default"].remove();
        // this.markSave()
      }
      _MMCommonFun["default"].setTextInputInEditor('textEditor');
    }
  });
};
MDMdEditor.prototype.getOriginData = function () {
  return this.originData;
};
MDMdEditor.prototype.removeFromSuperview = function () {
  _MMCommonFun["default"].removeTextInputInEditor('textEditor');
  console.log('remove fom supervie!');
};
MDMdEditor.prototype.setText = function (data) {
  this.mirrorEditor.setValue(data);
};
MDMdEditor.prototype.getMarkdown = function () {
  return this.mirrorEditor.getMarkdown();
};
MDMdEditor.prototype.getText = function () {
  return this.mirrorEditor.getValue();
};
MDMdEditor.prototype.isClean = function () {
  return this.mirrorEditor.getValue() == this.originData;
};
MDMdEditor.prototype.markSave = function () {
  this.originData = this.getText();
};
var _default = exports["default"] = MDMdEditor;

},{"1129":1129,"1184":1184,"1417":1417,"1454":1454,"1463":1463,"1541":1541,"49":49,"72":72,"812":812}],1129:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var example = "\n ## \u6B22\u8FCE\u4F7F\u7528\u5DF4\u522B\u9E1FMarkdown\n\n- \u60A8\u53EF\u4EE5\u4E0A\u4F20\u672C\u5730\u56FE\u7247\uFF0C\u6216\u63D2\u5165\u5916\u94FE\u56FE\u7247\u5230\u6587\u6863\u4E2D\uFF0C\u5E76\u901A\u8FC7\u5DF4\u522B\u9E1F\u5206\u4EAB\u94FE\u63A5\u5206\u4EAB\u7ED9\u670B\u53CB\u3002\n- \u53EF\u901A\u8FC7\u4E0A\u65B9\u83DC\u5355\u680F\u7F16\u8F91\u6587\u672C\u6837\u5F0F\uFF1A**\u52A0\u7C97**\u3001**\u659C\u4F53**\u3001~~\u5220\u9664\u7EBF~~\n- \u652F\u6301\u63D2\u5165\u8D85\u94FE\u63A5\uFF1A[\u4E0B\u8F7D\u5DF4\u522B\u9E1F\u5BA2\u6237\u7AEF](https://www.babel.cc/p/download.do)\n- \u652F\u6301LaTeX\u8BED\u6CD5\u516C\u5F0F\uFF1A$$Gamma(z) = int_0^infty t^{z-1}e^{-t}dt,.$$\uFF08\u516C\u5F0F\u4E0B\u65B9\u7559\u7A7A\u884C\uFF0C\u5426\u5219\u4E0D\u751F\u6548\uFF09\n\n- \u82E5\u6709\u5176\u4ED6\u7591\u95EE\uFF0C\u6B22\u8FCE\u54A8\u8BE2\u5B98\u7F51\u5728\u7EBF\u5BA2\u670D\u3002\n\n## Welcome to the Babelbird Markdown\n\n- You can upload images or insert external links to images and share them with friends via the Babelbird sharing link.\n- Edit text styles: **bold**\u3001*italic*\u3001~~Strikethrough~~\n- Support for inserting links: [Download Babelbird](https://www.babel.cc/p/download.do)\n- Support for LaTeX math:$$Gamma(z) = int_0^infty t^{z-1}e^{-t}dt,.$$\n\n- Have any other questions, please contact our official customer service.\n";
var _default = exports["default"] = example;

},{"1454":1454}],703:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDFileActionController = _interopRequireDefault(require(492));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDAlertView = _interopRequireDefault(require(32));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDChannelType = _interopRequireDefault(require(717));
/**
 * trash file action controller , cut from MDFileActionController
 * Created by manjun.han
 * 2016.11.11
 */

var MDTrashFileActionController = _MDFileActionController["default"].extend({
  initialize: function initialize() {
    _MDFileActionController["default"].prototype.initialize.call(this, {
      channel: _MDChannelType["default"].trash
    });
  }
});
var _default = exports["default"] = MDTrashFileActionController;

},{"1104":1104,"1184":1184,"1454":1454,"32":32,"492":492,"717":717,"72":72}],607:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDFileActionController = _interopRequireDefault(require(492));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDChannelType = _interopRequireDefault(require(717));
/**
 * join share file action controller , moved from MDFileActionController
 * Created by manjun.han
 * 2016.11.11
 */

var MDJoinShareFileActionController = window.MDFileActionController.extend({
  initialize: function initialize() {
    _MDFileActionController["default"].prototype.initialize.call(this, {
      channel: _MDChannelType["default"].joinshare
    });
  }

  // deleteFiles: function() {
  //   var self = this;
  //   var fileInfors = self.fileInfors;
  //   var alert = new MDAlertView();
  //   alert.show({
  //     title: BabelStr.str(170),
  //     message: `<p class="title">${BabelStr.str(5044)}?</p>`,
  //     className: 'm-delAlertWin',
  //     buttons: [{
  //       label: BabelStr.str(154),
  //       type: 'done',
  //       onClick: function() {
  //         var fileInforCollection = fileInfors[0].collection;
  //         var fileIds = [];
  //         var canleave = [];

  //         _.each(fileInfors, function(fileInfor) {
  //           if (fileInfor.canLeaveShare()) {
  //             canleave.push(fileInfor);
  //           };
  //         });

  //         _.each(canleave , function(fileToDel){
  //           MMNetDiskDataController.leaveSharedFile(fileToDel.get('fileId'), function() {
  //             fileInforCollection.remove([fileToDel]);
  //           }, function() {});
  //         })

  //         if (canleave.length != fileInfors.length) {
  //           MDSnackbarView.showStandardMsg(40);
  //         };
  //       }
  //     }, {
  //       label: BabelStr.str(155)
  //     }]
  //   });
  // }
});
var _default = exports["default"] = MDJoinShareFileActionController;

},{"1104":1104,"1184":1184,"1454":1454,"32":32,"492":492,"717":717,"72":72}],601:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDFileActionController = _interopRequireDefault(require(492));
var _MDFileOperationManager = _interopRequireDefault(require(326));
var _MDLocalFileCollector = _interopRequireDefault(require(330));
var _MDChannelType = _interopRequireDefault(require(717));
/**
 * home file action controller , moved from MDFileActionController
 * Created by manjun.han
 * 2016.11.11
 */

var MDHomeFileActionController = _MDFileActionController["default"].extend({
  initialize: function initialize(param) {
    param = param || {};
    param = _.extend(param, {
      channel: _MDChannelType["default"].file
    });
    _MDFileActionController["default"].prototype.initialize.call(this, param);
  },
  deleteFiles: function deleteFiles() {
    var self = this;
    var fileInfors = self.fileInfors;
    _MDFileOperationManager["default"].deleteFiles(fileInfors);
  },
  openUploadWindow: function openUploadWindow() {
    _MDLocalFileCollector["default"].openFileFinderWindow();
  },
  openUploadFolderWindow: function openUploadFolderWindow() {
    _MDLocalFileCollector["default"].openFileFinderWindow(null, true);
  }
});
MDHomeFileActionController.singleton = new MDHomeFileActionController();
var _default = exports["default"] = MDHomeFileActionController;

},{"1184":1184,"1454":1454,"326":326,"330":330,"492":492,"717":717}],480:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1418);
require(1463);
require(1537);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDDragDropController = _interopRequireDefault(require(322));
var _MDTableRowView2 = _interopRequireDefault(require(88));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * 文件tablerow 基类
 * Created by manjun.han
 * 2017.5.23
 */
var MDBaseFileTableRowView = exports["default"] = /*#__PURE__*/function (_MDTableRowView) {
  (0, _inherits2["default"])(MDBaseFileTableRowView, _MDTableRowView);
  function MDBaseFileTableRowView() {
    (0, _classCallCheck2["default"])(this, MDBaseFileTableRowView);
    return _callSuper(this, MDBaseFileTableRowView, arguments);
  }
  (0, _createClass2["default"])(MDBaseFileTableRowView, [{
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBaseFileTableRowView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        enableDrag: false
      });
    }
  }, {
    key: "registerEvents",
    value: function registerEvents() {
      var self = this;
      var $dragEventElements;
      if (this.objType == 'MDHomeTableRowView') {
        $dragEventElements = this.$('.title-col');
      } else if (this.objType == 'MDGridTableCellView') {
        $dragEventElements = this.$('.grid-cell-content');
      }
      ;
      var fileInfor = this.fileInfor;
      if (fileInfor && this.enableDrag) {
        // if (fileInfor.isFolder() && fileInfor.canUpload()) {

        //   $dragEventElements.off('dragover');
        //   $dragEventElements.off('dragleave');
        //   $dragEventElements.off('drop');

        //   $dragEventElements.on('dragover', function(e) {
        //     self._dragOverRow(e);
        //   });

        //   $dragEventElements.on('dragleave', function(e) {
        //     self._dragLeaveRow(e);
        //   });

        //   $dragEventElements.on('drop', function(e) {
        //     self._onFileDrop(e);
        //   });

        //   if (this.objType == 'MDHomeTableRowView') {

        //     this.$('.thumbWrapper').off('dragover');
        //     this.$('.thumbWrapper').on('dragover', function(e) {
        //       self._onFileDragoverIcon(e);
        //     });

        //     this.$('.thumbWrapper').off('dragleave');
        //     this.$('.thumbWrapper').on('dragleave', function(e) {
        //       self._onFileDragleaveIcon(e);
        //     });

        //   };

        // };

        $dragEventElements.off('dragstart');
        $dragEventElements.off("mousedown");
        $dragEventElements.on("mousedown", function (e) {
          if (self.isSelected) {
            // e.preventDefault()
            e.stopPropagation();
          }
        });
        if (fileInfor.canMove()) {
          // $dragEventElements.attr('draggable', 'true');
          $dragEventElements.on('dragstart', function (e) {
            // e.preventDefault()
            window.forCilentDrop = true;
            if (fileInfor.isShortcuts()) {
              fileInfor = fileInfor.clone();
              fileInfor.setFileId(fileInfor.getShortCutsTargetFileId());
            }
            var result = {
              fileId: fileInfor.getFileId(),
              fileName: fileInfor.getFileName(),
              fileSize: fileInfor.get("fileSize") || 1,
              isFolder: fileInfor.isFolder(),
              version: fileInfor.getCurVersion()
            };
            window.ipc.send('ondragstart', result);
            console.log(result);
          });
          $dragEventElements.off('dragend');
          $dragEventElements.on('dragend', function (e) {
            e.preventDefault();
            window.forCilentDrop = false;
            return;
          });
        }
        ;
      }
      ;
    }
  }, {
    key: "setSelected",
    value: function setSelected(selected, opt_silent) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBaseFileTableRowView.prototype), "setSelected", this).call(this, selected, opt_silent);
      if (selected && this.fileInfor && this.fileInfor.canMove()) {
        if (this.enableDrag) {
          this.setDraggable(true);
        }
      } else {
        this.setDraggable(false);
      }
    }
  }, {
    key: "setDraggable",
    value: function setDraggable(draggable) {
      var $dragEventElements;
      if (this.objType == 'MDHomeTableRowView') {
        $dragEventElements = this.$('.title-col');
      } else if (this.objType == 'MDGridTableCellView') {
        $dragEventElements = this.$('.grid-cell-content');
      } else {
        return;
      }
      if (draggable) {
        $dragEventElements.attr('draggable', 'true');
      } else {
        $dragEventElements.attr('draggable', 'false');
      }
    }
  }, {
    key: "_dragOverRow",
    value: function _dragOverRow($e) {
      var oe = $e.originalEvent;
      oe.stopPropagation();
      $e.preventDefault();
      this.$el.addClass('dragOver');
    }
  }, {
    key: "_dragLeaveRow",
    value: function _dragLeaveRow($e) {
      var oe = $e.originalEvent;
      oe.stopPropagation();
      $e.preventDefault();
      this._onMouseLeaveHandler();
      this.$el.removeClass('dragOver');
    }
  }, {
    key: "_onFileDragoverIcon",
    value: function _onFileDragoverIcon($e) {
      $e.preventDefault();
      var oe = $e.originalEvent;
      oe.stopPropagation();
      var curFolder = this.fileInfor;
      if (!curFolder.canUpload()) {
        return false;
      }
      this.$('.thumbWrapper').addClass('dragTargetFolder');
      this.$el.addClass('selected');
      if (!this.openFolderAlarm) {
        var self = this;
        this.openFolderAlarm = setBabelTimeout(function () {
          if (self.openFileInEditor) {
            self.openFileInEditor();
          }
          ;
        }, 1000);
      }
      ;
      $e.preventDefault();
    }
  }, {
    key: "_onFileDragleaveIcon",
    value: function _onFileDragleaveIcon($e) {
      $e.preventDefault();
      var oe = $e.originalEvent;
      oe.stopPropagation();
      clearTimeout(this.openFolderAlarm);
      this.openFolderAlarm = null;
      this.$('.thumbWrapper').removeClass('dragTargetFolder');
    }
  }, {
    key: "_onFileDrop",
    value: function _onFileDrop($e) {
      if (this.openFolderAlarm) {
        clearTimeout(this.openFolderAlarm);
        this.openFolderAlarm = null;
      }
      ;
      $e.preventDefault();
      var self = this;
      var originalEvent = $e.originalEvent;
      originalEvent.stopPropagation();
      var dt = originalEvent.dataTransfer;
      _MDDragDropController["default"].onDrop(dt, this.fileInfor);
      this.$('.thumbWrapper').removeClass('dragTargetFolder');
      this.$el.removeClass('dragOver');
      $e.preventDefault(); // 阻止浏览器打开文件行为
    }
  }, {
    key: "_onDragStarted",
    value: function _onDragStarted($e) {
      this.superView.draggingStarted();
      var fileInfos = this.superView.getSelectedModels();
      var ids = [];
      fileInfos.forEach(function (fileInfo) {
        ids.push(fileInfo.getFileId());
      });
      $e.originalEvent.dataTransfer.dropEffect = "move";
      $e.originalEvent.dataTransfer.setData("text", JSON.stringify({
        ids: ids,
        sourceFolderId: app.currentFolder.getFileId()
      }));
    }
  }, {
    key: "_onMouseEnterHandler",
    value: function _onMouseEnterHandler() {}
  }, {
    key: "_onMouseLeaveHandler",
    value: function _onMouseLeaveHandler() {}
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBaseFileTableRowView.prototype), "viewDidRendered", this).call(this);
      this.$('img').attr('draggable', 'false');
    }
  }, {
    key: "checkToRemoveUnreadMark",
    value: function checkToRemoveUnreadMark() {
      var self = this;
      if (this.fileInfor && !this.fileInfor.isFolder() && !this.fileInfor.canDispInEditor() && this.fileInfor.getUnReadCount()) {
        MMNetDiskDataController.clearFileVersionUnreadMark(this.fileInfor, null, function () {
          self.fileInfor.clearUnReadCount();
        }, function () {});
      }
      ;
    }
  }]);
  return MDBaseFileTableRowView;
}(_MDTableRowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1418":1418,"1454":1454,"1463":1463,"1475":1475,"1537":1537,"322":322,"88":88}],322:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1461);
var _MDfileUploadList = _interopRequireDefault(require(345));
var _MDFileOperationManager = _interopRequireDefault(require(326));
// MDDragDropController.js
//
// jiang
// 2017-1-15
//

var MDDragDropController = {
  _moveFilesIntoFolder: function _moveFilesIntoFolder(ids, targetFolderInfo, sourceFolderId) {
    _MDFileOperationManager["default"].moveFileIntoFolder(ids, targetFolderInfo.getFileId(), sourceFolderId, mixEnt);
  },
  onDrop: function onDrop(dataTransfer, targetFolderInfo) {
    var data = dataTransfer.getData('text');
    var filesToMove;
    var sourceFolderId;
    if (data) {
      data = JSON.parse(data);
      filesToMove = data.ids;
      sourceFolderId = data.sourceFolderId;
      if (targetFolderInfo.getFileId() != sourceFolderId) {
        var targetEntId = targetFolderInfo.getEnterpriseId();
        var currentEntId = app.currentFolder.getEnterpriseId();
        var _mixEnt = targetEntId != currentEntId;
        this._moveFilesIntoFolder(filesToMove, targetFolderInfo, sourceFolderId, _mixEnt);
      }
      ;
    } else {
      _MDfileUploadList["default"].onDrop(dataTransfer, targetFolderInfo);
    }
  }
};
var _default = exports["default"] = MDDragDropController;

},{"1184":1184,"1454":1454,"1461":1461,"326":326,"345":345}],511:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDPopupView = _interopRequireDefault(require(64));
/**
 *  Menu for zoom choices
 *  Create by jiang
 *  2017.9.1
 */

var MDMsgCommentPopupView = _MDPopupView["default"].extend({
  contentTmpl: '<div class="msg-comment-popup"></div>',
  events: function events() {
    var superEvents = _MDPopupView["default"].prototype.events.call(this);
    return _.extend({}, superEvents, {});
  },
  initProps: function initProps() {
    var superP = _MDPopupView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      zoomSelected: -1,
      $zoomList: null,
      scaleList: []
    });
  },
  initialize: function initialize(opt) {
    _MDPopupView["default"].prototype.initialize.call(this, opt);
  },
  setTitle: function setTitle(title) {
    this.$('.msg-comment-popup').text(title);
  }
});
var _default = exports["default"] = MDMsgCommentPopupView;

},{"1184":1184,"1454":1454,"64":64}],507:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDSnackbarView = _interopRequireDefault(require(72));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /*-----
*	文件收集箱文件状态
*	jichao
* 2019.5.20
*/
var MDManuscriptStatusChangedWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDManuscriptStatusChangedWinView, _MDWindowView);
  function MDManuscriptStatusChangedWinView() {
    (0, _classCallCheck2["default"])(this, MDManuscriptStatusChangedWinView);
    return _callSuper(this, MDManuscriptStatusChangedWinView, arguments);
  }
  (0, _createClass2["default"])(MDManuscriptStatusChangedWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<div class=\"body-content\"></div>";
    }
  }, {
    key: "content",
    value: function content() {
      return "<div class=\"row mgb-10\">\n\t\t\t<div class=\"col-3\"><%=BabelStr.str(6006)%>\uFF1A</div>\n\t\t\t<div class=\"col-9\">\n\t\t\t\t<%if(status == 0) {%>\n\t\t\t\t\t<div class=\"radio-group\">\n\t\t\t\t\t\t<span class=\"radio-box mgr-10 checked\" data-status=\"1\"><%=BabelStr.str(6004)%></span>\n\t\t\t\t\t\t<span class=\"radio-box\" data-status=\"0\"><%=BabelStr.str(6005)%></span>\n\t\t\t\t\t</div>\n\t\t\t\t<%} else if(status ==1) {%>\n\t\t\t\t\t<span><%=BabelStr.str(6001)%></span>\n\t\t\t\t<%} else if(status ==2) {%>\n\t\t\t\t\t<span><%=BabelStr.str(6002)%></span>\n\t\t\t\t<%}%>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"row mgb-10\">\n\t\t\t<div class=\"col-3\"><%=BabelStr.str(278)%>\uFF1A</div>\n\t\t\t<div class=\"col-9\">\n\t\t\t\t<%if(!status) {%>\n\t\t\t\t\t<textarea class=\"form-control comment\"></textarea>\t\t\t\t\t\n\t\t\t\t<%} else {%>\n\t\t\t\t\t<span><%=comment%></span>\n\t\t\t\t<%}%>\n\t\t\t</div>\n\t\t</div>\n\t\t<%if(!status) {%>\n\t\t\t<div class=\"flex-align end\">\n\t\t\t\t<button class=\"button done save mgr-10\"><%=BabelStr.str(154)%></button>\n\t\t\t\t<button class=\"button cancel\"><%=BabelStr.str(155)%></button>\n\t\t\t</div>\n\t\t<%} else {%>\n\t\t\t<div class=\"row mgb-10\">\n\t\t\t\t<div class=\"col-3\"><%=BabelStr.str(6007)%>\uFF1A</div>\n\t\t\t\t<div class=\"col-9\">\n\t\t\t\t\t<div class=\"operater\"><%=userName%></div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=\"row mgb-10\">\n\t\t\t\t<div class=\"col-3\"><%=BabelStr.str(3172)%>\uFF1A</div>\n\t\t\t\t<div class=\"col-9\">\n\t\t\t\t\t<div class=\"time\"><%=time%></div>\n\t\t\t\t</div>\n\t\t\t</div>\t\t\t\n\t\t\t<div class=\"flex-align end btns-block\">\n\t\t\t\t<button class=\"button close\"><%=BabelStr.str(156)%></button>\n\t\t\t</div>\n\t\t<%}%>\n\n\t\t";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDManuscriptStatusChangedWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        fileInfor: null
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDManuscriptStatusChangedWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .radio-box': this._check,
        'click .save': this._save,
        'click .cancel': this.close,
        'click .close': this.close
      });
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      var _this = this;
      opt.title = BabelStr.str(6003);
      opt.needFooter = false;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDManuscriptStatusChangedWinView.prototype), "initialize", this).call(this, opt);
      var fid = this.fileInfor.getFileId();
      var curVer = this.fileInfor.getCurVersion();
      this.status = this.fileInfor.getManuscriptStatus();
      if (this.status) {
        MMEnterpriseController.getMsBoxFileStatus(fid, curVer, function (data) {
          _this.renderTmpl(data);
        });
      } else {
        this.renderTmpl();
      }
    }
  }, {
    key: "renderTmpl",
    value: function renderTmpl(data) {
      data = data || {
        status: this.status
      };
      var obj = {
        status: data.status,
        userName: data.userName,
        comment: data.comment || BabelStr.str(177),
        time: data.date ? new Date(data.date * 1000).format('yyyy-MM-dd HH:mm:ss') : ''
      };
      var tmpl = _.template(this.content())(obj);
      this.$('.body-content').html(tmpl);
    }
  }, {
    key: "_check",
    value: function _check(e) {
      var $target = $(e.target);
      if ($target.hasClass('checked')) {
        return;
      }
      this.$('.radio-box').removeClass('checked');
      $target.addClass('checked');
    }
  }, {
    key: "_save",
    value: function _save() {
      var _this2 = this;
      var status = this.$('.radio-box.checked').data('status');
      var fid = this.fileInfor.getFileId();
      var curVer = this.fileInfor.getCurVersion();
      var comment = this.$('.comment').val();
      MMEnterpriseController.setMsBoxFileStatus(fid, curVer, status, comment, function () {
        _this2.fileInfor.set('manuscriptStatus', 2 - status); // 0->2, 1->1
        _this2.close();
      }, function () {
        _MDSnackbarView["default"].show(BabelStr.str(309));
      });
    }
  }]);
  return MDManuscriptStatusChangedWinView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1437":1437,"1454":1454,"1463":1463,"1475":1475,"72":72,"93":93}],504:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1424);
var _MDPopupView = _interopRequireDefault(require(64));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
/**
 * 	File joiners avatar popup view
 *  Created by manjun.han
 *  2016.2.26
 */

var MDJoinersPopupView = _MDPopupView["default"].extend({
  contentTmpl: '<div class="wrapper"><ul class="joinerList"></ul></div>',
  className: function className() {
    var superCls = _MDPopupView["default"].prototype.className.call(this);
    return superCls + " m-joinerPopup";
  },
  initProps: function initProps() {
    var superP = _MDPopupView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      fileInfor: null
    });
  },
  readItemTempl: '<li>' + '<a class="avatarWrapper" data-tooltip="<%=name%>" data-tooltip-dir="bottom">' + '<img draggable="false" src="<%=avatarURL %>">' + '</a>' + '</li>',
  initialize: function initialize(opt) {
    opt = _.extend({
      hasArrow: true
    }, opt);
    _MDPopupView["default"].prototype.initialize.call(this, opt);
    this.$joinerList = this.$(".joinerList");
    this.$joinerList.css("display", "inline-block");
    this.requestReaders();
  },
  requestReaders: function requestReaders() {
    var fileId = this.fileInfor.get('fileId');
    var self = this;
    _MMNetDiskDataController["default"].getFileReaders(fileId, function success(userInfos) {
      self.readers = userInfos;
      self.renderReaderList();
    }, function failed() {});
    this.$el.css("max-width", 300);
  },
  renderReaderList: function renderReaderList() {
    var strBuilder = [];
    var self = this;
    var complier = _.template(this.readItemTempl);
    var readers = this.readers;
    _.each(readers, function (user) {
      strBuilder.push(complier({
        'avatarURL': user.getAvatarImageURL(),
        'name': user.get('name')
      }));
    });
    this.$joinerList.append(strBuilder.join(""));
    // 此处的计算方式不妥，和css结合紧密
    var paddingH = 6 * 2;
    self.$el.css("width", 40 * readers.length + paddingH);
    self.layout();
    this.$(".avatarWrapper").SimpleTooltip();
  },
  onAfterLayout: function onAfterLayout() {
    var self = this;
    self.$(".wrapper").mCustomScrollbar('destroy');
    self.$(".wrapper").mCustomScrollbar({
      'advanced': {
        'updateOnContentResize': true
      },
      'scrollbarPosition': 'outside',
      'axis': "x",
      'autoHideScrollbar': true,
      'theme': "dark-thin"
    });
  },
  viewWillUnRendered: function viewWillUnRendered() {
    this.$(".avatarWrapper").SimpleTooltip("clear");
    _MDPopupView["default"].prototype.viewWillUnRendered.call(this);
  }
});
var _default = exports["default"] = MDJoinersPopupView;

},{"1104":1104,"1184":1184,"1424":1424,"1454":1454,"64":64}],495:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1421);
require(1432);
require(1426);
require(1437);
require(1463);
require(1478);
require(1418);
require(1537);
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDFileActionController = _interopRequireDefault(require(492));
var _MMViewBase = _interopRequireDefault(require(22));
var _MDFileRowTagView = _interopRequireDefault(require(786));
var _MDThumbUpPopupView = _interopRequireDefault(require(522));
var _MDTagDataController = _interopRequireDefault(require(1093));
var _MDAddTagBigWindow = _interopRequireDefault(require(781));
var _MDTagCollection = _interopRequireDefault(require(288));
var _MDEvents = _interopRequireDefault(require(325));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDFileTagsPopupView = _interopRequireDefault(require(373));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _popupPos = _interopRequireDefault(require(65));
var _MDTag = _interopRequireDefault(require(287));
var _MDFocusFilePopupView = _interopRequireDefault(require(634));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDFileOperationManager = _interopRequireDefault(require(326));
// MDFileExtraAttrView
//
// jiang
// 2017-2-6
//

var MDFileExtraAttrView = _MMViewBase["default"].extend({
  tmpl: '<div class="extra-attr-root flex-align middle ">\
          <%if(canReadComment){%>\
          <div class="attr-comment-root prevent-mouse gray-h-blue no-shrink">\
            <span class="attr-comment icon icon-comment prevent-dblclick" data-tooltip="<%=disc%>" data-tooltip-dir="top"></span>\
            <span class="attr-comment prevent-dblclick icon-text"><%=disc%></span>\
            <span class="attr-comment-count prevent-dblclick"></span>\
          </div>\
          <div class = "attr-praise prevent-dblclick prevent-mouse gray-h-blue no-shrink" >\
            <span class = "praise-btn icon icon-no-thumbs-up prevent-dblclick" data-tooltip="<%=praiseTip%>" data-tooltip-dir="top"></span>\
            <span class="praise-btn prevent-dblclick icon-text"><%=praise%></span>\
            <span class = "display-thumb-up prevent-dblclick" data-tooltip="<%=person%>" data-tooltip-dir="top"></span>\
          </div>\
          <%}%>\
          <div class = "attr-focus prevent-dblclick prevent-mouse gray-h-blue no-shrink flex-align middle">\
            <span class = "icon ic-no-focus"></span>\
            <span class = "focus-off prevent-mouse" data-tooltip="<%=offFocus%>" data-tooltip-dir="top">\
              <span><%=offFocus%></span>\
            </span>\
            <%if(canFocus){%>\
            <span class = "focus-on prevent-mouse" data-tooltip="<%=focus%>" data-tooltip-dir="top">\
              <span><%=focus%></span>\
              <span class = "focus-user-num"></span>\
            </span>\
            <%}%>\
          </div>\
          <%if(canAddTag){%>\
          <div class ="attr-tag-root "><%=addTag%>\
          </div>\
          <%}%>\
        </div>',
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      tableView: null,
      canPraise: true,
      commentClickHandler: _.noop,
      showFileInfor: _.noop
    });
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click .praise-btn': this.praiseClickHandle,
      'click .attr-tag-more': this._showOtherTag,
      'click .focus-on': this._focusOnClickHandle,
      'click .ic-focus': this._focusOnClickHandle,
      'click .ic-no-focus': this._focusOnClickHandle,
      'click .focus-off': this._focusOffClickHandle,
      'click .attr-comment-root': this._commentClickHandler
    });
  },
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.bindSelf(this.displayPraisePopup, this.removeThisFile, this._showOtherTag, this.showFileInfor);
    var self = this;

    // if (!this.canPraise) {
    this.$('.attr-praise').remove(); // 暂时去除点赞功能
    // }
    _Dispatcher["default"].on(_MDEvents["default"].Tag_Delete_From_File, this.tagRemoveFromFile, this);
    _Dispatcher["default"].on(_MDEvents["default"].TagInfo_Changed, this.tagInfoChangedListener, this);
    this.$el.SimpleTooltip('delegate');
    if (!app.pathRouter.isInMyfocus() || !app.pathRouter.isInRoot()) {
      this.$(".focus-off").remove();
    }
    this.$commentCount = this.$('.attr-comment-count');
    this.refresh();
    if (this.fileInfo.isArchiveHouse) {
      this.$('.attr-tag-root').empty();
      this.$('.attr-tag-root').append('<span class="gray font12">' + BabelStr.str(861) + '</span>');
    }
  },
  render: function render(data) {
    data = {
      'canReadComment': this.fileInfo.canReadCommentOnlyByAction(),
      'disc': _MDLocalString["default"].getLocalString(128),
      // 评论
      'praise': _MDLocalString["default"].getLocalString(248),
      //赞
      'praiseTip': _MDLocalString["default"].getLocalString(44),
      //点赞
      'person': _MDLocalString["default"].getLocalString(242),
      // 查看点赞人员
      'offFocus': _MDLocalString["default"].getLocalString(243),
      // 取消关注
      'focus': _MDLocalString["default"].getLocalString(244),
      // 提醒关注
      'addTag': _MDLocalString["default"].getLocalString(106),
      // 添加标签
      'canFocus': this.fileInfo.canFocus(),
      'canAddTag': this.fileInfo.canAddTag()
    };
    _MMViewBase["default"].prototype.render.call(this, data);
  },
  _commentClickHandler: function _commentClickHandler() {
    this.commentClickHandler();
    this.commentStateChanged();
  },
  commentStateChanged: function commentStateChanged() {
    this.$('.attr-comment').toggleClass('icon-comment-clicked');
  },
  // 虚拟 row 恢复时需要显式设置状态，不能使用 toggle，否则可能反向切换图标。
  setCommentExpanded: function setCommentExpanded(expanded) {
    this.$('.attr-comment').toggleClass('icon-comment-clicked', !!expanded);
  },
  _showOtherTag: function _showOtherTag($e) {
    var ctl = new _MDFileActionController["default"]();
    ctl.showFileInfor(this.fileInfo);
    // var self = this;
    // if (!this.toggleShow) {
    //   this.$('.attr-tag-view').show();
    //   this.$('.attr-tag-more')
    //     .removeClass('icon-tag-expand')
    //     .addClass('icon-tag-shrink')
    //     .attr('data-tooltip', '隐藏更多标签');
    // } else {
    //   this.$('.attr-tag-view').slice(5).hide();
    //   this.$('.attr-tag-more')
    //     .removeClass('icon-tag-shrink')
    //     .addClass('icon-tag-expand')
    //     .attr('data-tooltip', '显示更多标签');
    // }
    // this.toggleShow = !this.toggleShow;
  },
  displayPraisePopup: function displayPraisePopup($e) {
    var self = this;
    if (this.thumbUpPopup) {
      self.thumbUpPopup.close();
    } else {
      this.thumbUpPopup = new _MDThumbUpPopupView["default"]({
        fileInfo: function fileInfo() {
          return self.fileInfo;
        },
        width: 296,
        direction: _popupPos["default"].BOTTOM_LEFT,
        gapX: 20,
        triggerView: $e.target,
        onShow: function onShow(popupView) {
          self.listenToOnce(self.tableView, "scroll", function () {
            popupView.close();
          });
        },
        onClose: function onClose() {
          self.thumbUpPopup = null;
        }
      });
      this.thumbUpPopup.show();
    }
  },
  setTableView: function setTableView(tableView) {
    this.tableView = tableView;
  },
  tagRemoveFromFile: function tagRemoveFromFile(payload) {
    if (!this.fileInfo.canManageFile()) {
      return;
    }
    var tagModel = payload.tagModel;
    this.tagCollection.remove(tagModel);
  },
  fileInforAttrChangedHandler: function fileInforAttrChangedHandler(model, options) {
    if (!this.fileInfo) {
      return;
    }
    ;
    var self = this;
    if (this.fileInfo.hasChanged("praiseArray")) {
      self._initPraise();
    }
    if (this.fileInfo.hasChanged("tagArray")) {
      self._initTags();
    }
    if (this.fileInfo.hasChanged("focusCount")) {
      self.focusCountChanged();
    }
    if (this.fileInfo.hasChanged("isSharing")) {
      self.sharingChanged();
    }
    if (this.fileInfo.hasChanged("fileReviewCount")) {
      self._initComment();
    }
    if (this.fileInfo.hasChanged("isFocusFile")) {
      self._isFocusFileChanged();
    }
    this.$('.attr-comment-root').attr('data-comment-id', this.fileInfo.getFileId());
  },
  tagInfoChangedListener: function tagInfoChangedListener(payload) {
    if (!this.fileInfo.canManageFile() && !payload.refreshAll) {
      return;
    }
    var tag = payload.tagModel;
    var oldId = payload.oldTagId;
    this.fileInfo.replaceTag(oldId, tag);
  },
  _isFocusFileChanged: function _isFocusFileChanged() {
    var $icon = this.$(".attr-focus .icon");
    if (this.fileInfo.getIsFocusFile()) {
      $icon.removeClass("ic-no-focus");
      $icon.addClass("ic-focus");
    } else {
      $icon.addClass("ic-no-focus");
      $icon.removeClass("ic-focus");
    }
  },
  praiseClickHandle: function praiseClickHandle($e) {
    var $tartag = $($e.target).closest(".praise-btn");
    $tartag.prop("disabled", true);
    if ($tartag.hasClass("praised")) {
      this.unpraiseThisFile($tartag);
    } else {
      this.praiseThisFile($tartag);
    }
  },
  /**
   * 给该文件点赞
   */
  praiseThisFile: function praiseThisFile($tartag) {
    var self = this;
    var fid = this.fileInfo.getFileId();
    _MMNetDiskDataController["default"].praiseFile([fid], function () {
      var praiseUserArray = self.fileInfo.getPraisedUsers().concat();
      praiseUserArray.push(app.currentUser);
      self.fileInfo.setPraisedUsers(praiseUserArray);
      $tartag.prop("disabled", false);
    }, function () {
      $tartag.prop("disabled", false);
    });
  },
  /**
   * 取消暂
   */
  unpraiseThisFile: function unpraiseThisFile($tartag) {
    var self = this;
    var fid = this.fileInfo.getFileId();
    _MMNetDiskDataController["default"].unPraiseFile([fid], function () {
      var praiseUserArray = self.fileInfo.getPraisedUsers().concat();
      var currentUser = app.currentUser;
      var index = praiseUserArray.indexOf(currentUser);
      praiseUserArray.splice(index, 1);
      self.fileInfo.setPraisedUsers(praiseUserArray);
      $tartag.prop("disabled", false);
    }, function () {
      $tartag.prop("disabled", false);
    });
  },
  focusCountChanged: function focusCountChanged(slient) {
    var num = this.fileInfo.getFocusCount();
    if (app.pathRouter.isInMyfocus() && num < 1 && !slient) {
      this.removeThisFile();
    }
    this.$(".focus-user-num").html(num);
    if (num > 0) {
      this.$(".focus-on").addClass("red-h-underline");
      // this.$(".attr-focus").removeClass("gray-h-blue");
    } else {
      this.$(".focus-on").removeClass("red-h-underline");
      // this.$(".attr-focus").addClass("gray-h-blue");
    }
    this._markHasFocus();
  },
  _focusOnClickHandle: function _focusOnClickHandle($e) {
    // this.focusFilePopupView = new MDFocusFilePopupView();

    var self = this;
    if (this.focusFilePopupView) {
      self.focusFilePopupView.close();
    } else {
      this.focusFilePopupView = new _MDFocusFilePopupView["default"]({
        fileInfo: function fileInfo() {
          return self.fileInfo;
        },
        direction: _popupPos["default"].BOTTOM_LEFT,
        triggerView: $e.currentTarget,
        onShow: function onShow(popupView) {
          self.listenToOnce(self.tableView, "scroll", function () {
            popupView.close();
          });
        },
        onClose: function onClose() {
          self.focusFilePopupView = null;
        }
      });
      this.focusFilePopupView.show();
    }
  },
  _focusOffClickHandle: function _focusOffClickHandle() {
    var self = this;
    _MMNetDiskDataController["default"].removeFileFocus(this.fileInfo.getFileId(), [app.currentUser.getUserId()], function () {
      self.removeThisFile();
    }, function () {});
  },
  removeThisFile: function removeThisFile() {
    var fileInfo = this.dataCollection.findWhere({
      "fileId": this.fileInfo.getFileId()
    });
    this.dataCollection.remove(fileInfo);
  },
  _initPraise: function _initPraise() {
    var viewPraise = _MDLocalString["default"].getLocalString(242); //查看点赞人员
    var praiseUserArray = this.fileInfo.getPraisedUsers();
    if (praiseUserArray && praiseUserArray.length) {
      this.$(".display-thumb-up").html(praiseUserArray.length);
      this.$(".display-thumb-up").off("click");
      this.$(".display-thumb-up").on("click", this.displayPraisePopup);
      this.$(".display-thumb-up").attr("data-tooltip", viewPraise);
      this.$(".praise-btn").addClass("red-h-underline");
      this.$(".display-thumb-up").addClass("red-h-underline");
    } else {
      this.$(".display-thumb-up").empty();
      this.$(".display-thumb-up").off("click");
      this.$(".display-thumb-up").removeAttr("data-tooltip");
      this.$(".praise-btn").removeClass("red-h-underline");
      this.$(".display-thumb-up").removeClass("red-h-underline");
    }
    var $tartag = this.$(".praise-btn");
    var curUserId = app.currentUser.getUserId();
    if (praiseUserArray) {
      var idArr = _.map(praiseUserArray, function (user) {
        var userId = user.userId | user.id;
        return userId.toString();
      });
      var index = idArr.indexOf(curUserId);
      if (index > -1) {
        $tartag.addClass("praised");
        $tartag.removeClass("icon-no-thumbs-up");
        $tartag.addClass("icon-thumbs-up");
        $tartag.attr("data-tooltip", BabelStr.str(7220));
      } else {
        var praise = _MDLocalString["default"].getLocalString(44); //点赞
        $tartag.removeClass("praised");
        $tartag.addClass("icon-no-thumbs-up");
        $tartag.removeClass("icon-thumbs-up");
        $tartag.attr("data-tooltip", praise);
      }
    }
  },
  // 添加标签

  // initWithFileInfo: function(fileInfo) {
  //   this.fileInfo = fileInfo;
  //   this.refresh();
  // },

  sharingChanged: function sharingChanged() {
    this.initAttrFocus();
  },
  initAttrFocus: function initAttrFocus() {
    if (!this.fileInfo.canFocus()) {
      this.$(".attr-focus").addClass("f-hide");
      // this.fileInfo.setFocusCount(0 , true);
    } else {
      this.$(".attr-focus").removeClass("f-hide");
      var count = this.fileInfo.getFocusCount();
      this.$('.focus-user-num').text(count);
      this.focusCountChanged(true);
    }
  },
  refresh: function refresh() {
    if (!this.fileInfo.canPraise()) {
      this.$('.attr-praise').remove();
    }
    this._initPraise();
    this._initTags();
    this._initComment();
    this.initAttrFocus();
    this._isFocusFileChanged();
    this.delegateEvents();
  },
  _initComment: function _initComment() {
    // 暂时根据能否点赞判断是否显示评论
    if (!this.fileInfo.canReadComment()) {
      this.$('.attr-comment-root').remove();
      return;
    }
    var count = this.fileInfo.getFileReviewCount();
    this.refreshCommentCount(count);
  },
  refreshCommentCount: function refreshCommentCount(count) {
    if (count) {
      this.$commentCount.text(count);
      this.$(".attr-comment").addClass("red-h-underline");
      this.$commentCount.addClass("red-h-underline");
      // this.$(".attr-comment-root").removeClass("gray-h-blue");
    } else {
      this.$commentCount.text('');
      this.$(".attr-comment").removeClass("red-h-underline");
      this.$commentCount.removeClass("red-h-underline");
      // this.$(".attr-comment-root").addClass("gray-h-blue");
    }
    this._markHasComment(count);
  },
  _initTags: function _initTags() {
    var self = this;
    this.stopListening(this.tagCollection);
    this.tagCollection = this.fileInfo.getTagCollection();
    this.removeSubViews();
    this.$('.attr-tag-root').empty();
    var addTag = _MDLocalString["default"].getLocalString(106); // 添加标签
    var moreTag = _MDLocalString["default"].getLocalString(245); // 显示更多标签

    var $addTagBtn = $('<div class="gray-h-blue add-tag"><button class="attr-addtag prevent-dblclick icon prevent-mouse" data-tooltip="' + addTag + '" data-tooltip-dir="top"></button><span class="icon-text attr-addtag prevent-dblclick prevent-mouse">' + addTag + '</span></div>');
    var $moreTagBtn = $('<button class="attr-tag-more icon icon-tag-expand prevent-dblclick prevent-mouse " data-tooltip="' + moreTag + '" data-tooltip-dir="top"></button>');
    this.$('.attr-tag-root').append($moreTagBtn);
    if (this.fileInfo.canAddTag()) {
      this.$('.attr-tag-root').append($addTagBtn);
    }
    $moreTagBtn.hide();
    if (this.fileInfo.canAddTag()) {
      $addTagBtn.on('click', function (e) {
        var addTagWin = new _MDAddTagBigWindow["default"]({
          fileInfos: [self.fileInfo]
        });
        addTagWin.show();
      });

      // MDAddTagPopupView.createPopup({
      //   shouldSearchTag: true,
      //   triggerView: this.$('.attr-addtag'),
      //   width: 160,
      //   direction: POPUP_POS.BOTTOM_LEFT,
      //   hasArrow: true,
      //   gapY: 2,
      //   asDropdown: false,
      //   tagCollection: this.tagCollection,
      //   fileInfo: this.fileInfo,
      //   onShow: function(popupView) {
      //     self.listenToOnce(self.tableView, "scroll", function() {
      //       popupView.close();
      //     })
      //   },
      //   onRemoveAddedTag: function(tagModel, netCb) {
      //     var id = tagModel.getId();
      //     var tagModelLocal = self.tagCollection.get(id);
      //     if(!tagModelLocal.canDelete()){
      //       _.isFunction(netCb.success) && netCb.success();
      //       return;
      //     }
      //     // 删除标签
      //     MDFileOperationManager.delTagForFile(self.fileInfo, tagModel, {
      //       success: function() {
      //         _.isFunction(netCb.success) && netCb.success();
      //         Dispatcher.trigger(MDEvents.Tag_Remove_From_File, {
      //           tagModel: tagModel,
      //           fileInfo: self.fileInfo
      //         });
      //         MDSnackbarView.show(MDLocalString.getLocalString(246));      // '标签删除成功'
      //       },
      //       fail: function() {
      //         _.isFunction(netCb.fail) && netCb.fail();
      //       }
      //     });
      //   },
      //   onAddTag: function(tagModel, netCb) {
      //     var id = tagModel.getId();
      //     var fileId = self.fileInfo.getFileId();
      //     // 添加已有标签
      //     if (id) {
      //       MDTagDataController.addTagForFiles([fileId], id, function() {
      //         netCb.success();
      //         tagModel = new MDTag(tagModel.toJSON())
      //         self.tagCollection.add(tagModel);
      //         Dispatcher.trigger(MDEvents.Tag_Add_To_File, {
      //           tagModel: tagModel
      //         });
      //         MDSnackbarView.show(MDLocalString.getLocalString(247));    // '标签添加成功'
      //       }, function() {
      //         netCb.fail();
      //       });
      //       // 添加新标签
      //     } else {
      //       var color = tagModel.getColorNum();
      //       var text = tagModel.getText();
      //       tagModel.set({
      //         'canDelete': true,
      //         'canAdd': true
      //       })
      //       MDTagDataController.createTagAndAddToFile([fileId], text, color, function(tagInfo) {
      //         netCb.success();
      //         tagModel.setId(tagInfo['tagId']);
      //         self.tagCollection.add(tagModel);
      //         Dispatcher.trigger(MDEvents.Tag_Add_To_File, {
      //           tagModel: tagModel,
      //           fileInfo: self.fileInfo
      //         });
      //       }, function(resultCode) {
      //         netCb.fail();
      //       })
      //     }

      //   }
      // })
    }
    this.tagCollection.forEach(function (tagModel, index) {
      var tagView = new _MDFileRowTagView["default"]({
        fileInfo: self.fileInfo,
        tagModel: tagModel,
        className: 'prevent-mouse'
      });
      self.addSubView(tagView, function (el) {
        if (self.$('.attr-tag-more').length == 1) {
          self.$('.attr-tag-more').before($(el));
        } else {
          self.$('.attr-tag-root').append(el);
        }
        setBabelTimeout(function () {
          var childWidth = 0;
          var parentWidth = self.$('.attr-tag-root').width();
          _.each(self.$('.attr-tag-root').children(), function (child) {
            childWidth += $(child).width();
          });
          if (parentWidth && childWidth >= parentWidth || index > 5) {
            $(el).hide();
            self.$('.attr-tag-more').show();
          }
        }, 500);
      });
    });
    this.listenTo(this.tagCollection, 'add', this.newTagAddToFileListener);
    this.listenTo(this.tagCollection, 'remove', this.tagRemoveListener);
    this.listenTo(this.tagCollection, 'change:canDelete', this.canDeleTagUpdate);
  },
  canDeleTagUpdate: function canDeleTagUpdate(tagModel, value, opt) {
    var subView = this.findSubView(function (subView) {
      return subView.getTagModel() == tagModel;
    });
    subView && subView.setRemovable(value);
  },
  tagRemoveListener: function tagRemoveListener(tagModel, tagCollection, opt) {
    var tagView = this.findSubView(function (tagView) {
      return tagView.getTagModel().getId() == tagModel.getId();
    });
    tagView && tagView.removeFromSuperView();
    if (tagCollection.length == 5) {
      this.$('.attr-tag-more').removeClass('icon-tag-shrink').addClass('icon-tag-expand').hide();
      this.toggleShow = false;
    }
    this.$('.attr-tag-view').eq(4).show();
    this._markHasTags();
  },
  btnsShowed: function btnsShowed(show, btnsWidth) {
    var $tagRoot = this.$('.attr-tag-root');
    if ($tagRoot.length == 0) {
      return;
    }
    var $tagViews = this.$('.attr-tag-view');
    $tagViews.show();
    this.$('.attr-addtag').show();
    this.$('.attr-tag-more').hide();
    var attrWidth = this.$el.width();
    var dispAreaWidth = $tagRoot.width() - btnsWidth;
    if (show) {
      $tagViews.hide();
      var w = this.$('.add-tag').width();
      for (var i = 0; i < $tagViews.length; i++) {
        var element = $tagViews[i];
        w += $(element).width();
        if (w < dispAreaWidth) {
          $(element).show();
        } else {
          if (i > 0) {
            $($tagViews[i - 1]).hide();
            this.$('.attr-tag-more').show();
          } else {
            this.$('.attr-addtag').hide();
          }
          break;
        }
      }
    }
  },
  newTagAddToFileListener: function newTagAddToFileListener(tagModel) {
    var _this = this;
    var self = this;
    this._markHasTags();
    var tagView = this.findSubView(function (tagView) {
      return tagView.getTagModel().getId() == tagModel.getId();
    });
    if (tagView) {
      return;
    }
    setBabelTimeout(function () {
      var tagView = new _MDFileRowTagView["default"]({
        fileInfo: self.fileInfo,
        tagModel: tagModel,
        className: 'prevent-mouse'
      });
      var index = _this.tagCollection.indexOf(tagModel);
      _this.addSubView(tagView, function (el) {
        // self.$('.tag-wrap').append(el);
        if (self.$('.attr-tag-more').length == 1) {
          self.$('.attr-tag-more').before($(el));
        } else {
          self.$('.attr-tag-root').append(el);
        }
        var childWidth = 0;
        var parentWidth = self.$('.attr-tag-root').width();
        _.each(self.$('.attr-tag-root').children(), function (child) {
          childWidth += $(child).width();
        });
        if (childWidth >= parentWidth || index > 5) {
          $(el).hide();
          self.$('.attr-tag-more').show();
        }
      });
    }, 500);
  },
  _markHasTags: function _markHasTags() {
    // if (this.tagCollection.length > 0) {
    //   this.$el.parents('.file-row').addClass("has-tag has-tag1");
    // } else {
    //   this.$el.parents('.file-row').removeClass("has-tag has-tag1");
    // }
  },
  _markHasFocus: function _markHasFocus() {
    // var num = this.fileInfo.getFocusCount();
    // if (num > 0) {
    //   this.$el.parents('.file-row').addClass("has-focus has-focus1");
    // } else {
    //   this.$el.parents('.file-row').removeClass("has-focus has-focus1");
    // }
  },
  _markHasComment: function _markHasComment(count) {
    // if (count > 0) {
    //   this.$el.parents('.file-row').addClass("has-comment has-comment1");
    // } else {
    //   this.$el.parents('.file-row').removeClass("has-comment has-comment1");
    // }
  },
  viewDidUnRendered: function viewDidUnRendered() {
    this.$('.add-tag').off();
  }
});
var _default = exports["default"] = MDFileExtraAttrView;

},{"1093":1093,"1104":1104,"1150":1150,"1184":1184,"1412":1412,"1418":1418,"1421":1421,"1426":1426,"1432":1432,"1437":1437,"1454":1454,"1463":1463,"1478":1478,"1537":1537,"18":18,"22":22,"287":287,"288":288,"325":325,"326":326,"373":373,"492":492,"522":522,"634":634,"65":65,"72":72,"781":781,"786":786}],522:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDPopupView = _interopRequireDefault(require(64));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
/**
 *  prased user list
 *  Created by jichao
 *  2017/2/6
 */

var MDThumbUpPopupView = _MDPopupView["default"].extend({
  contentTmpl: '<div class="contain">\
      <div class = "user-imgs"></div>\
    </div>\
    <div class = "footer ">\
      <div class = "left help-inline"><span class = "usernum">41</span><%=BabelStr.str(7263)%></div>\
      <div class = "right">\
        <div class = "right-item "><span class = "current-page">1</span>/<span class = "total-page">1</span><%=BabelStr.str(2378)%></div>\
        <div class = "right-item pre-page"><%=BabelStr.str(2375)%></div>\
        <div class = "right-item next-page "><%=BabelStr.str(2376)%></div>\
      </div>\
    </div>\
    <div class = loading></div>\
    ',
  className: function className() {
    var superCls = _MDPopupView["default"].prototype.className.call(this);
    return superCls + ' m-thumb-up-popup';
  },
  initProps: function initProps() {
    var superP = _MDPopupView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      currentPage: 1,
      totalPage: 1,
      pageSize: 16
    });
  },
  events: function events() {
    var superE = _MDPopupView["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click .close': this._close,
      'click .pre-page': this._prePageBtnClickHandle,
      'click .next-page': this._nextPageBtnClickHandle
    });
  },
  initialize: function initialize(opt) {
    opt = _.extend(opt, {
      hasArrow: true
    });
    _MDPopupView["default"].prototype.initialize.call(this, opt);
    this.$contain = this.$(".contain .user-imgs");
    this.fileInfo = _.isFunction(this.fileInfo) ? this.fileInfo() : this.fileInfo;
    this.praiseUserArray = this.fileInfo.getPraisedUsers();
    this.renderUsernum(this.praiseUserArray.length);
  },
  loading: function loading() {
    _MDSpinnerloaderView["default"].showIn(this.$(".loading"));
    this.$(".contain").hide();
  },
  loadFinished: function loadFinished() {
    this.$(".contain").show();
    _MDSpinnerloaderView["default"].clearFrom(this.$(".loading"));
  },
  renderUsernum: function renderUsernum(num) {
    this.$(".usernum").html(num);
  },
  initUsersList: function initUsersList() {
    this.$(".header").show();
    this.renderOnePageUserList();
    this.totalPage = Math.ceil(this.praiseUserArray.length / this.pageSize);
    this.totalPage = this.totalPage > 0 ? this.totalPage : 1;
    this.$(".footer .total-page").html(this.totalPage);
    this.$(".pre-page").hide();
    if (this.totalPage < 2) {
      this.$(".next-page").hide();
    }
  },
  renderOnePageUserList: function renderOnePageUserList() {
    var str = "";
    var url = "";
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index;
    var len = this.praiseUserArray.length;
    var resideUserLen = len - (this.currentPage - 1) * this.pageSize;
    var currentPageSize = resideUserLen > this.pageSize ? this.pageSize : resideUserLen;
    var userId;
    var user;
    var userName;
    for (var i = 0; i < currentPageSize; i++) {
      index = startIndex + i;
      user = this.praiseUserArray[index];
      userId = user["userId"] || user["id"];
      userName = user["userName"] || user.get("name");
      url = app.getAvatarImageURL(userId);
      str += '<div class="item">' + '<img  src = "' + url + '" data-tooltip="' + userName + '" data-tooltip-dir="bottom"/>' + '</div>';
    }
    this.$contain.html(str);
    this.$(".footer .current-page").html(this.currentPage);
  },
  _moreClickhandle: function _moreClickhandle() {
    if (this.$el.width() > 342) {
      this.$el.width(342);
    }
    if (this.$(".contain").height > 200) {
      this.$(".contain").height(200);
    }
    this.$(".contain").mCustomScrollbar();
    this.initUsersList();
  },
  _prePageBtnClickHandle: function _prePageBtnClickHandle() {
    this.currentPage--;
    if (this.currentPage <= 1) {
      this.$(".pre-page").hide();
    }
    this.$(".next-page").show();
    this.renderOnePageUserList();
  },
  _nextPageBtnClickHandle: function _nextPageBtnClickHandle() {
    this.currentPage++;
    if (this.currentPage >= this.totalPage) {
      this.$(".next-page").hide();
    }
    this.$(".pre-page").show();
    this.renderOnePageUserList();
  },
  _close: function _close() {
    this.close();
  },
  viewDidRendered: function viewDidRendered() {
    _MDPopupView["default"].prototype.viewDidRendered.call(this);
    this.initUsersList();
  }
});
var _default = exports["default"] = MDThumbUpPopupView;

},{"1184":1184,"1454":1454,"64":64,"76":76}],373:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDPopupView = _interopRequireDefault(require(64));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDFileRowTagView = _interopRequireDefault(require(786));
/**
 *  File tags popup view
 *  Created by jiang
 *  2017.3.8
 */

var MDFileTagsPopupView = _MDPopupView["default"].extend({
  contentTmpl: '<div class="wrapper"><ul class="file-tags-list"></ul></div>',
  className: function className() {
    var superCls = _MDPopupView["default"].prototype.className.call(this);
    return superCls + " m-file-tag-pop";
  },
  initProps: function initProps() {
    var superP = _MDPopupView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      fileInfor: null
    });
  },
  initialize: function initialize(opt) {
    opt = _.extend({
      hasArrow: true
    }, opt);
    _MDPopupView["default"].prototype.initialize.call(this, opt);
    this.$tagList = this.$(".file-tags-list");
    this.$tagList.css("display", "inline-block");
    this.showTags();
  },
  showTags: function showTags() {
    var self = this;
    self.$('.file-tags-list').empty();
    for (var i = this.startIndex; i < this.tagCollection.length; i++) {
      var tagModel = this.tagCollection.at(i);
      var tagView = new _MDFileRowTagView["default"]({
        fileInfo: self.fileInfo,
        tagModel: tagModel
      });
      var $el = tagView.$el;
      if (self.$('.attr-addtag').length == 1) {
        self.$('.attr-addtag').before($el);
      } else {
        self.$('.file-tags-list').append($el);
      }
    }
    ;
    this.$el.css("max-width", 300);
  },
  setStartIndex: function setStartIndex(startIndex) {
    this.startIndex = startIndex;
    this.showTags();
  },
  onAfterLayout: function onAfterLayout() {
    var self = this;
    self.$(".wrapper").mCustomScrollbar('destroy');
    self.$(".wrapper").mCustomScrollbar({
      'advanced': {
        'updateOnContentResize': true
      },
      'scrollbarPosition': 'outside',
      'axis': "x",
      'autoHideScrollbar': true,
      'theme': "dark-thin"
    });
  },
  viewWillUnRendered: function viewWillUnRendered() {
    this.$(".avatarWrapper").SimpleTooltip("clear");
    _MDPopupView["default"].prototype.viewWillUnRendered.call(this);
  }
});
var _default = exports["default"] = MDFileTagsPopupView;

},{"1104":1104,"1184":1184,"1454":1454,"64":64,"786":786}],786:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1436);
require(1546);
var _MMViewBase = _interopRequireDefault(require(22));
var _MDFileOperationManager = _interopRequireDefault(require(326));
var _MDAlertView = _interopRequireDefault(require(32));
// MDFileRowTagView
//
// jiang
// 2017-2-7
//

var MDFileRowTagView = _MMViewBase["default"].extend({
  className: function className() {
    var cls = _MMViewBase["default"].prototype.className.call(this);
    return cls + " attr-tag-view";
  },
  tmpl: '<span class="attr-tag-color" style="background-color:<%=color%>"></span>\
         <span class="attr-tag-name middle-ellipsis"><%=text%></span>\
         <button class="attr-tag-del" data-tag-id="<%=id%>"><span class="top for-del"></span><span class="bottom for-del"></span></button>',
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      fileInfo: null,
      tagModel: null,
      onTagRemove: undefined
    });
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      "click .attr-tag-del": this._delTag
    });
  },
  _delTag: function _delTag($e) {
    var _this = this;
    var alertView = new _MDAlertView["default"]();
    var self = this;
    var tagId = this.tagModel.getId();
    var tagModel = this.tagModel;
    if (_.isFunction(this.onTagRemove)) {
      this.onTagRemove(tagId, tagModel);
      return;
    }
    alertView.show({
      message: BabelStr.str(6229),
      className: "m-delAlertWin",
      buttons: [{
        label: BabelStr.str(155)
      }, {
        label: BabelStr.str(32),
        // '确定',
        type: "danger",
        onClick: function onClick() {
          _MDFileOperationManager["default"].delTagForFile(_this.fileInfo, tagModel, {
            success: function success() {
              Dispatcher.trigger(MDEvents.Tag_Remove_From_File, {
                tagModel: tagModel,
                fileInfo: self.fileInfo
              });
              $($e.target).parent().remove();
            }
          });
        }
      }]
    });
  },
  getTagModel: function getTagModel() {
    return this.tagModel;
  },
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    if (!this.tagModel.canDelete()) {
      this.$el.addClass("disable-eidtable");
      this.$(".attr-tag-del").remove();
    }
    if (this.tagModel.get("enterpriseUsed")) {
      this.$el.addClass('ent-tag');
      this.$el.attr("title", "企业标签");
    }
    if (window.user.userTagStyle.iconSize == 0) {
      this.$(".attr-tag-color").removeClass("mid");
      this.$(".attr-tag-color").removeClass("large");
    } else if (window.user.userTagStyle.iconSize == 1) {
      this.$(".attr-tag-color").addClass("mid");
      this.$(".attr-tag-color").removeClass("large");
    } else {
      this.$(".attr-tag-color").removeClass("mid");
      this.$(".attr-tag-color").addClass("large");
    }
    this.$el.css("background", window.user.userTagStyle.background);
    this.$el.css("color", window.user.userTagStyle.color);
    this.$(".for-del").css("border-color", window.user.userTagStyle.color);
  },
  setRemovable: function setRemovable(canDelete) {
    if (!canDelete) {
      this.$el.addClass("disable-eidtable");
      this.$(".attr-tag-del").remove();
    } else {
      this.$el.removeClass("disable-eidtable");
      this.$el.append($('<button class="attr-tag-del" data-tag-id="<%=id%>"></button>'));
    }
  },
  render: function render(data) {
    data = this.tagModel.toJSON();
    data["color"] = this.tagModel.getColor();
    this.$el.attr("title", this.tagModel.getText());
    _MMViewBase["default"].prototype.render.call(this, data);
  }
});
var _default = exports["default"] = MDFileRowTagView;

},{"1184":1184,"1436":1436,"1454":1454,"1546":1546,"22":22,"32":32,"326":326}],473:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1421);
require(1439);
require(1498);
require(1463);
require(1478);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDEvaluationStatus = _interopRequireDefault(require(254));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDFileInfoShowView = _interopRequireDefault(require(497));
var _MDEvalutionEditWinView = _interopRequireDefault(require(472));
var _MDEvaluterListView = _interopRequireDefault(require(471));
var _MDEvalutionStartViewTmpl = _interopRequireDefault(require(474));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDEvaluationFlowSelectWinView = _interopRequireDefault(require(463));
var _MDCheckboxView = _interopRequireDefault(require(37));
var _MDCombobox = _interopRequireDefault(require(27));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // MDEvalutionStartView.js
// jichao
// 2017-5-15
var MDEvalutionStartView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDEvalutionStartView, _MDWindowView);
  function MDEvalutionStartView() {
    (0, _classCallCheck2["default"])(this, MDEvalutionStartView);
    return _callSuper(this, MDEvalutionStartView, arguments);
  }
  (0, _createClass2["default"])(MDEvalutionStartView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return _MDEvalutionStartViewTmpl["default"].main;
    }
  }, {
    key: "evalutionUnOrderedTmpl",
    value: function evalutionUnOrderedTmpl() {
      return _MDEvalutionStartViewTmpl["default"].evalutionUnOrdered;
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvalutionStartView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        fileInfors: [],
        commentNum: 150,
        saveToPersonTmpl: false,
        width: 700
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvalutionStartView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .save': this._saveClickHandle,
        'click .finish': this._finishClickHandl,
        'keydown .comment': this._commentInputHandle,
        'input .comment': this._commentInputHandle,
        'click .select-tmpl': this.showSelectFlowView
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvalutionStartView.prototype), "className", this).call(this);
      return superCls + ' evalution-start-win common-file-panel';
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.title = BabelStr.str(528); // "发起审批"
      props.size = 'large';
      props.data = _.extend({
        'caption': BabelStr.str(529),
        // 审批通过后的文件状态为定稿，审批中和定稿后的文件不能编辑及上传新版本
        'evalCap': BabelStr.str(511),
        // 审批文件
        'postscript': BabelStr.str(361),
        // 附言
        'keyInputCap': BabelStr.str(427, {
          // ------  还可输入 xxx 字
          'num': '<span class="num">150</span>'
        }),
        'endTime': BabelStr.str(176),
        // 截止日期
        'selTime': BabelStr.str(3231),
        // 请选择日期
        'freeze': BabelStr.str(530),
        // 不审批直接定稿
        'commit': BabelStr.str(531) // 提交开启审批
      }, props.data);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvalutionStartView.prototype), "initialize", this).call(this, props);
      this.$commitBtn = this.$(".save");
      this._renderFileInfors();
      var self = this;
      var curDate = new Date();
      this.$(".date-end").datepicker().on("change", function () {
        self.enddate = this.value;
      });
      var reportTypes = [BabelStr.str(5002), BabelStr.str(5003)];
      this.typeIndex = 0;
      if (this.fileInfors.length == 1 && this.fileInfors[0].isCADFile()) {
        this.typeIndex = 1;
      }
      var width = 100;
      var lan = BabelStr.getCurrentLanguage();
      if (lan == 'en') {
        width = 200;
      }
      this.combobox = new _MDCombobox["default"]({
        parentDiv: this.$('.select-type'),
        itemStrs: reportTypes,
        selectIndex: this.typeIndex,
        width: width,
        popUpWidth: width,
        useNormalFont: true,
        selectCb: function selectCb(index) {
          _this.typeIndex = index;
        }
      });
      var time;
      $.ajax({
        type: 'HEAD',
        async: true
      }).success(function (data, status, xhr) {
        time = xhr.getResponseHeader('Date');
        self.$(".date-end").datepicker("option", "minDate", new Date(time));
      });
      this.$form = this.$('.eval-form');
      this.$form.validate({
        highlight: function highlight(element, errorClass, validClass) {
          if ($(element).closest('.choosed').length) {
            $(element).closest('.choosed').removeClass(validClass).addClass(errorClass);
          } else {
            $(element).removeClass(validClass).addClass(errorClass);
          }
        },
        unhighlight: function unhighlight(element, errorClass, validClass) {
          if ($(element).closest('.choosed').length) {
            $(element).closest('.choosed').removeClass(errorClass).addClass(validClass);
          } else {
            $(element).removeClass(errorClass).addClass(validClass);
          }
        },
        errorPlacement: function errorPlacement(error, element) {
          if (element.attr('name') && element.attr('name').indexOf('evalter-choose-panel') > -1) {
            error.appendTo(element.closest(".input-block"));
            element.closest('.choosed').addClass('validate-error');
          } else {
            element.after(error);
          }
        }
      });
      // if(!this.fileInfo.canManageFilePermission()) {
      //   this.onConditionChanged(true)
      // }
      this.onConditionChanged(false);
      var saveToPersonView = new _MDCheckboxView["default"]({
        label: BabelStr.str(4608),
        onChanged: function onChanged(checked) {
          _this.saveToPersonTmpl = checked;
        }
      });
      this.addSubView(saveToPersonView, this.$('.save-to-person')[0]);
    }
  }, {
    key: "showSelectFlowView",
    value: function showSelectFlowView() {
      var _this2 = this;
      var win = new _MDEvaluationFlowSelectWinView["default"]({
        fileInfors: this.fileInfors,
        canEdit: this.canEdit,
        onSelected: function onSelected(selectModel) {
          if (!selectModel) {
            return;
          }
          _this2.$('.save').attr('disabled', false);
          _this2.$('.name-block').removeClass('f-hide');
          var name = selectModel.getName();
          name = _.unescape(name);
          _this2.$('.tmpl-name').val(name);
          _this2.tmplId = selectModel.get("id");
          _this2.setEvalutionInfo(selectModel);
        }
      });
      win.show();
    }
  }, {
    key: "setEvalutionInfo",
    value: function setEvalutionInfo(data) {
      this.evalModel = data;
      this.name = data.getName();
      this.$('.name').val(this.name);
      this.evaluterListView.renderEvalution(data.getSteps(), data.getFinalizedStep());
    }
  }, {
    key: "addRuleForNewItem",
    value: function addRuleForNewItem(itemView) {
      var $input = itemView.getItemInput();
      $input.rules('add', {
        requiredMember: true,
        diffCurEvaluator: true
      });
    }
  }, {
    key: "_renderFileInfors",
    value: function _renderFileInfors() {
      var _this3 = this;
      _.each(this.fileInfors, function (fileInfo) {
        var fileInfoView = new _MDFileInfoShowView["default"]({
          fileInfo: fileInfo,
          onClick: function onClick(fileInfo) {
            var fid = fileInfo.getFileId();
            app.pathRouter.openNewTabByFileId(fid);
          }
        });
        _this3.addSubView(fileInfoView, _this3.$('.file-info-block .file')[0]);
      });
    }
  }, {
    key: "_renderRevalutionOrdered",
    value: function _renderRevalutionOrdered(canEdit) {
      var _this4 = this;
      var file = this.fileInfors[0];
      this.evaluterListView = new _MDEvaluterListView["default"]({
        // checkSelf: true,
        addRuleForNewItem: this.addRuleForNewItem,
        isNeedCurUser: true,
        isForStart: true,
        // canEdit: this.fileInfo.canManageFilePermission(),
        canSelRole: file.belongDepartment(),
        canEdit: canEdit,
        fileInfo: this.fileInfo,
        onConditionChanged: function onConditionChanged(sign) {
          _this4.onConditionChanged(sign);
        }
      });
      this.addSubView(this.evaluterListView, this.$(".evalution-main-block"));
    }
  }, {
    key: "onConditionChanged",
    value: function onConditionChanged(sign) {
      if (this.fileInfors.length && this.fileInfors[0].canManageFilePermission()) {
        return;
      }
      if (sign) {
        this.$('.comments-block').addClass('f-hide');
        this.$('.end-date-block').addClass('f-hide');
        this.$('.save').attr("disabled", true);
      } else {
        this.$('.comments-block').removeClass("f-hide");
        this.$('.end-date-block').removeClass("f-hide");
        this.$('.save').attr("disabled", false);
      }
    }
  }, {
    key: "_saveClickHandle",
    value: function _saveClickHandle() {
      var _this5 = this;
      var validator = this.$form.validate();
      var nameValidator = this.$('.name-form').validate();
      if (!nameValidator.form()) {
        return;
      }
      if (this.evaluterListView.removeCreatorFromEvaluator()) {
        _MDSnackbarView["default"].show(BabelStr.str(7165));
      }
      if (this.saveToPersonTmpl) {
        this.$('.tmpl-name').attr("required", true);
        var nameValidate = this.$('.name-form').validate();
        if (!nameValidate.form()) {
          return;
        }
      } else {
        this.$('.tmpl-name').attr("required", false);
      }
      var validatorTime = this.$('.end-date-form').validate();
      var name = this.$('.tmpl-name').val() || '';
      if (validator.form() && validatorTime.form()) {
        this.$commitBtn.prop('disabled', true);
        this.$commitBtn.text(BabelStr.str(3303));
        var evaluatorTmplObj = this.evaluterListView.getEvaluatorGroups();
        if (!evaluatorTmplObj.steps.length) {
          _MDMessageView["default"].error(BabelStr.str(4616), this.$body[0]);
          this.$commitBtn.prop('disabled', false);
          this.$commitBtn.text(BabelStr.str(531));
          return;
        }
        var fids = [];
        _.each(this.fileInfors, function (file) {
          fids.push(file.getFileId());
        });
        var options = {
          fileIds: fids,
          steps: evaluatorTmplObj.steps,
          name: name.toString().trim(),
          finalizedStep: evaluatorTmplObj.finalizedStep,
          forEnterprise: 0,
          comment: this.$(".comment").val().toString(),
          endTime: new Date(this.enddate).getTime() / 1000,
          //时间单位  秒
          tmplId: this.tmplId,
          flowType: this.typeIndex
        };
        _MMNetDiskDataController["default"].createEvaluationFlow(options, function (actions, evaluationFlowId, evaluationStatus) {
          console.log("提交成功");
          _this5.$commitBtn.prop('disabled', false);
          _this5.$commitBtn.text(BabelStr.str(531));
          _.each(_this5.fileInfors, function (file) {
            file.setEvaluationFlowId(evaluationFlowId);
            file.setActions(actions);
            file.setCurrentVersionEvaluation(evaluationStatus);
            file.setEvaluationStatus(evaluationStatus);
            file.setEvaluationStepCount(options.steps.length);
          });
          _.isFunction(_this5.successCreate) && _this5.successCreate();
          _this5.close();
          if (_this5.saveToPersonTmpl) {
            _this5.createEvaluationTmpl(options.name, options.steps, options.finalizedStep);
          }
          _MDSnackbarView["default"].show(BabelStr.str(308)); //('开启审批成功');
        }, function (errorCode, step) {
          _this5.$commitBtn.prop('disabled', false);
          _this5.$commitBtn.text(BabelStr.str(531));
          if (errorCode == 330) {
            _MDSnackbarView["default"].show(BabelStr.str(568)); // ('文件已经开启过审批！');
          } else if (errorCode == 12) {
            _MDSnackbarView["default"].show(BabelStr.str(152)); // ('权限不足！');
          } else if (errorCode == 101) {
            _MDSnackbarView["default"].show(BabelStr.str(549)); //('文件不存在！');
          } else {
            if (errorCode == 2 && step) {
              _MDSnackbarView["default"].show(BabelStr.str(4617, {
                title: step.title
              }));
            } else {
              var fail = BabelStr.str(309); // 操作失败
              _MDSnackbarView["default"].show('(' + errorCode + ')' + fail);
            }
          }
        });
        _czc && _czc.push(["_trackEvent", "创建", "发起评审", "", "", ""]);
      }
    }
  }, {
    key: "_finishClickHandl",
    value: function _finishClickHandl() {
      var _this6 = this;
      var fid = this.fileInfo.getFileId();
      this.$commitBtn.prop('disabled', true);
      this.$commitBtn.text(BabelStr.str(3303));
      _MMNetDiskDataController["default"].passTheFileEvaluation(fid, function (actions) {
        _this6.$commitBtn.prop('disabled', false);
        _this6.$commitBtn.text(BabelStr.str(531));
        _this6.fileInfo.setActions(actions);
        _this6.fileInfo.setEvaluationStatus(_MDEvaluationStatus["default"].PASSED);
        _this6.fileInfo.setCurrentVersionEvaluation(_MDEvaluationStatus["default"].PASSED);
        _this6.close();
        console.log("succcess");
        _MDSnackbarView["default"].show(BabelStr.str(308)); //("文件定稿成功");
      }, function () {
        _this6.$commitBtn.prop('disabled', false);
        _this6.$commitBtn.text(BabelStr.str(531));
        _MDSnackbarView["default"].show(BabelStr.str(168)); // ("文件定稿失败，请稍后重试");
      });
    }
  }, {
    key: "_commentInputHandle",
    value: function _commentInputHandle() {
      var comment = this.$(".comment").val().toString();
      var length = comment.length;
      var num = this.commentNum - length;
      if (num < 0) {
        num = 0;
      }
      this.$(".comments-block .num").html(num);
    }
  }, {
    key: "createEvaluationTmpl",
    value: function createEvaluationTmpl(name, steps, finalizedStep) {
      MMEnterpriseController.createEvaluationTmpl(name, steps, finalizedStep, 0, function () {
        console.log("添加成功");
      }, function (errCode) {
        console.error("添加失败" + errCode);
      });
    }
  }, {
    key: "getFileEvaluationType",
    value: function getFileEvaluationType() {
      var _this7 = this;
      MMEnterpriseController.getFileEvaluationType(this.fileInfors[0].getFileId(), function (type) {
        var canEdit = type == 3;
        _this7.canEdit = canEdit;
        _this7._renderRevalutionOrdered(canEdit);
        if (!canEdit) {
          _this7.$('.save-to-person').addClass('f-hidden');
          _this7.$('.name-block').addClass('f-hide');
          _this7.$('.save').attr('disabled', true);
        }
      });
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvalutionStartView.prototype), "viewDidRendered", this).call(this);
      this.getFileEvaluationType();
    }
  }]);
  return MDEvalutionStartView;
}(_MDWindowView2["default"]);

},{"1104":1104,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1421":1421,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"1478":1478,"1498":1498,"254":254,"27":27,"37":37,"463":463,"471":471,"472":472,"474":474,"497":497,"55":55,"72":72,"93":93}],474:[function(require,module,exports){
module.exports = {"main":"<div class=\"header-block help-block tip-word\">\r    <%=caption%>\r  </div>\r  <div class=\"file-info-block flex-align between \">\r    <div class=\"title-left\"><%=evalCap%></div>\r    <div class=\"file\"></div>\r  </div>\r  <div class=\"flex-align middle\">\r    <div class=\"title-left\"><%=BabelStr.str(3185)%></div>\r    <div class=\"select-tmpl text-button done mgl-10\"><%=BabelStr.str(4605)%></div>\r  </div>\r  <form class=\"name-form\" onsubmit=\"return false\">\r    <div class=\"name-block flex-align\">\r      <div class=\"title-left\"><%=BabelStr.str(3190)%></div>\r      <div class=\"right fullfill mgl-10\">\r        <input type=\"text\" class=\"form-control tmpl-name notempty textinput\" placeholder=\"<%=BabelStr.str(542)%>\" required maxlength=\"60\" />\r      </div>\r    </div>\r  </form>\r  <!-- <div class=\"sequence-block\"></div> -->\r  <form class=\"eval-form\" onsubmit=\"return false\">\r    <div class=\"evalution-main-block\"></div>\r    <div class=\"comments-block flex-align between\">\r      <div class=\"title-left\"><%=postscript%></div>\r      <div class=\"right\">\r        <textarea class=\"comment textinput\" name=\"comment\" id=\"\" cols=\"30\" rows=\"10\" maxlength=\"150\"></textarea>\r        <div class=\"conment-tip f-fr\"><%=keyInputCap%></div>\r      </div>\r    </div>\r  </form>\r  <form class=\"end-date-form\">\r    <div class=\"end-date-block flex-align between\">\r      <div class=\"title-left\"><%=endTime%></div>\r      <div class=\"right\">\r        <div class=\"datepicker\">\r          <input type=\"text\" class=\"date-end date\" required readonly placeholder=\"<%=selTime%>\">\r          <i class=\"ep-ic ep-ic-date\"></i>\r        </div>\r      </div>\r    </div>\r  </form>\r  <div class=\"flex-align middle report-div marginT-20\">\r    <div class=\"title-left\"><%=BabelStr.str(5001)%></div>\r    <div class=\"select-type\"></div>\r  </div>\r  <div class=\"flex-align between end btns-block\">\r    <div class=\"save-to-person\"></div>\r    <button class=\"button done save\"><%=commit%></button>\r  </div>"};
},{}],463:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDTabView = _interopRequireDefault(require(82));
var _MDFlowTabView = _interopRequireDefault(require(475));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
// MDEvaluationFlowSelectWinView.js
// jichao
// 2019-3-12
var MDEvaluationFlowSelectWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDEvaluationFlowSelectWinView, _MDWindowView);
  function MDEvaluationFlowSelectWinView() {
    (0, _classCallCheck2["default"])(this, MDEvaluationFlowSelectWinView);
    return _callSuper(this, MDEvaluationFlowSelectWinView, arguments);
  }
  (0, _createClass2["default"])(MDEvaluationFlowSelectWinView, [{
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvaluationFlowSelectWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        canEdit: true,
        fileInfors: []
      });
    }
  }, {
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<div class=\"tab-content\">\n    </div>\n    ";
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvaluationFlowSelectWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .cancel': this.close,
        'click .save': this.save
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvaluationFlowSelectWinView.prototype), "className", this).call(this);
      return superCls + ' flow-select-win';
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.showFooter = false;
      props.title = BabelStr.str(528); // "发起审批"
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvaluationFlowSelectWinView.prototype), "initialize", this).call(this, props);
      this.epFlowView = new _MDFlowTabView["default"]({
        onChecked: function onChecked(data) {
          _this.selectModel = data;
        },
        candel: false
      });
      var tabs = [{
        title: BabelStr.str(4606),
        tabPanelView: this.epFlowView
      }];
      if (this.canEdit) {
        this.peFlowView = new _MDFlowTabView["default"]({
          onChecked: function onChecked(data) {
            _this.selectModel = data;
          },
          isperson: true,
          candel: true
        });
        tabs.push({
          title: BabelStr.str(4607),
          tabPanelView: this.peFlowView
        });
      }
      this.flowTabView = new _MDTabView["default"]({
        className: 'file-col-tabs blue-style-tab1 tab-win',
        fullMode: false,
        enableActivebar: false,
        tabs: tabs
      });
      this.addSubView(this.flowTabView, this.$('.tab-content')[0]);
      this.getFileEvaluationTmpl();
    }
  }, {
    key: "save",
    value: function save() {
      this.close();
      _.isFunction(this.onSelected) && this.onSelected(this.selectModel);
    }
  }, {
    key: "getFileEvaluationTmpl",
    value: function getFileEvaluationTmpl(callback) {
      var _this2 = this;
      var file = this.fileInfors[0];
      MMEnterpriseController.getFileEvaluationTmpl(file.getFileId(), function (collection, type) {
        console.log(collection);
        console.warn(type);
        var epTmpl = [];
        var personTmpl = [];
        collection.each(function (tmpl) {
          if (tmpl.getForEnterprise()) {
            epTmpl.push(tmpl);
          } else {
            personTmpl.push(tmpl);
          }
        });
        _this2.epFlowView.setFlow(epTmpl);
        _this2.peFlowView && _this2.peFlowView.setFlow(personTmpl);
      }, function (res) {
        console.log(res);
      });
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvaluationFlowSelectWinView.prototype), "viewDidRendered", this).call(this);
    }
  }]);
  return MDEvaluationFlowSelectWinView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"475":475,"82":82,"93":93}],475:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1439);
require(1437);
require(1463);
require(1478);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDSpinnerloaderLayerView = _interopRequireDefault(require(75));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDFlowTabView = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(MDFlowTabView, _MDTabPanelView);
  function MDFlowTabView() {
    (0, _classCallCheck2["default"])(this, MDFlowTabView);
    return _callSuper(this, MDFlowTabView, arguments);
  }
  (0, _createClass2["default"])(MDFlowTabView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n\t\t\t<div class=\"main-content\"></div>\n\t    <div class=\"flex-align end mgt-20 btns-block\">\n\t      <button class=\"button cancel\"><%=BabelStr.str(155)%></button>\n\t      <button class=\"button done save\"><%=BabelStr.str(154)%></button>\n\t    </div>\n\t\t";
    }
  }, {
    key: "contentTmpl",
    value: function contentTmpl(data) {
      var tmpl = "<div class=\"flow-item m-chb flex-align between\" data-id=\"".concat(data.id, "\">\n\t\t\t\t<div class=\"text-hide\">\n\t\t\t\t\t<span class=\"box\"></span>\n\t\t\t\t\t<span class=\"name\">").concat(data.name, "</span>\n\t\t\t\t</div>");
      if (data.candel) {
        tmpl += "<span class=\"del text-button danger\">".concat(BabelStr.str(32), "</span>");
      }
      tmpl += "</div>";
      return tmpl;
    }
  }, {
    key: "emptyTmpl",
    value: function emptyTmpl(isperson) {
      var str = BabelStr.str(4609);
      if (isperson) {
        str = BabelStr.str(4619);
      }
      return "<div class=\"flex-align center middle empty f-tc\">\n\t\t\t<span>".concat(str, "</span>\n\t\t</div>");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFlowTabView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        candel: false
      });
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFlowTabView.prototype), "initialize", this).call(this, opt);
      _MDSpinnerloaderLayerView["default"].showIn(this.el);
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFlowTabView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .flow-item': this._selectFlow,
        'click .del': this._deleteEvaluation
      });
    }
  }, {
    key: "setFlow",
    value: function setFlow(datas) {
      var _this = this;
      _MDSpinnerloaderLayerView["default"].clearFrom(this.el);
      this.datas = datas;
      var tmpl = '';
      _.each(datas, function (item) {
        tmpl += _this.contentTmpl({
          name: item.getName(),
          id: item.get("id"),
          candel: _this.candel
        });
      });
      this.$('.main-content').html(tmpl);
      this.renderEmpty();
    }
  }, {
    key: "renderEmpty",
    value: function renderEmpty() {
      if (this.$('.flow-item').length) {
        return;
      }
      var tmpl = this.emptyTmpl(this.isperson);
      this.$el.html(tmpl);
    }
  }, {
    key: "_selectFlow",
    value: function _selectFlow(e) {
      var $current = $(e.target).closest('.flow-item');
      $current.addClass("checked");
      $current.siblings().removeClass("checked ");
      var id = $current.data('id').toString();
      var selectModel = _.findWhere(this.datas, {
        id: id
      });
      if (!selectModel) {
        console.error('出错了');
      }
      _.isFunction(this.onChecked) && this.onChecked(selectModel);
    }
  }, {
    key: "_deleteEvaluation",
    value: function _deleteEvaluation(e) {
      var _this2 = this;
      e.stopPropagation();
      var $current = $(e.target).closest('.flow-item');
      var id = $current.data('id').toString();
      var selectModel = _.findWhere(this.datas, {
        id: id
      });
      if (!selectModel) {
        console.error('出错了');
      }
      var name = selectModel.getName();
      var alert = new _MDAlertView["default"]({
        title: BabelStr.str(220),
        message: BabelStr.str(3187, {
          "name": name
        }) + "\uFF1F",
        buttons: [{
          label: BabelStr.str(3096),
          type: 'done',
          onClick: function onClick() {
            MMEnterpriseController.deleteEvaluationTmpl(id, function () {
              $current.remove();
              MDMessageView.success(BabelStr.str(308));
              _this2.renderEmpty();
            }, function () {
              MDMessageView.error(BabelStr.str(3522));
            });
          }
        }, {
          label: BabelStr.str(155)
        }]
      });
      alert.show();
    }
  }]);
  return MDFlowTabView;
}(_MDTabPanelView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"1478":1478,"32":32,"75":75,"81":81}],468:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1541);
require(1412);
require(1437);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDFileInfoShowView = _interopRequireDefault(require(497));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDEvaluationListPanel = _interopRequireDefault(require(466));
var _MMBasicData = _interopRequireDefault(require(811));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDEvaluationListNaviView = _interopRequireDefault(require(464));
var _MDSpinnerloaderLayerView = _interopRequireDefault(require(75));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // MDEvaluationListWinView.js
// jiang
// 2017-5-11
var MDEvaluationListWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDEvaluationListWinView, _MDWindowView);
  function MDEvaluationListWinView() {
    (0, _classCallCheck2["default"])(this, MDEvaluationListWinView);
    return _callSuper(this, MDEvaluationListWinView, arguments);
  }
  (0, _createClass2["default"])(MDEvaluationListWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n      <div class=\"tool-panel f-hidden\">\n        <div class=\"opinion-list one text-button f-none done\"><%=title%></div>\n        <div class=\"opinion-list multFile text-button f-none done\"><%=BabelStr.str(6112)%></div>\n\n        <div class=\"tool-p-subtitle flex-align middle\">\n          <div class=\"left\"><%=theFile%></div>\n          <div class=\"right\"></div>\n        </div>\n        <div class=\"tool-p-edntime height-30\">\n          <div class=\"float-l line-over-cut col-40\">\n            <span class=\"title-e\"><%=organiser%></span>\n            <span class=\"creator\">xxxxxxx</span>\n          </div>\n          <div class=\"float-r complete-t-d\">\n            <span class=\"title-e\"><%=BabelStr.str(6011)%></span>\n            <span class=\"end-time\"></span>\n          </div>\n        </div>\n        <div class=\"comment-block pdlr-15 f-hide\">\n          <div class=\"text-button done toggle-comment\"><%=BabelStr.str(40093)%></div>\n          <div class=\"comment mgt-10 f-hide\"></div>\n        </div>\n        <div class=\"tool-p-content\"></div>\n      </div>\n    ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvaluationListWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        closeIsHide: false,
        files: [],
        multFileEvaluationStatus: 0
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvaluationListWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .tool-p-close ': this._closeHandler,
        'mousewheel .tool-panel ': this._wheelHandler,
        'click .one ': this._showOpinionList,
        'click .multFile ': this._showFileList,
        'click .close-btn': this.close,
        "click .toggle-comment": this.toggleComment
      });
    }
  }, {
    key: "toggleComment",
    value: function toggleComment() {
      this.$(".comment").toggleClass("f-hide");
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvaluationListWinView.prototype), "className", this).call(this);
      return superCls + ' out-editor-win eval-win';
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.title = BabelStr.str(508); //  '审批列表';
      props.width = 650;
      props.data = _.extend({
        'theFile': BabelStr.str(511),
        // 审批文件
        'organiser': BabelStr.str(509),
        // 发起人
        'endTime': BabelStr.str(176),
        // 截止日期
        'title': BabelStr.str(813) // 意见列表
      }, props.data);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvaluationListWinView.prototype), "initialize", this).call(this, props);
      this.listPanel = new _MDEvaluationListNaviView["default"]({
        close: this.close,
        onRootPageShowing: function onRootPageShowing(rootViewShowing) {
          if (rootViewShowing) {
            // this.$('.opinion-list').show();
            if (_this.files.length) {
              _this.$('.multFile').show();
            } else {
              _this.$('.one').show();
            }
          } else {
            _this.$('.opinion-list').hide();
          }
        }
      });
      this.addSubView(this.listPanel, this.$(".tool-p-content")[0]);
      _MDSpinnerloaderLayerView["default"].showIn(this.$body);
      if (this.fileInfo.get("multFile")) {
        this.renderMultFileEvalInfo();
        this.multFileEvaluationStatus = this.fileInfo.getEvaluationStatus();
      } else {
        this.setFileInfo();
      }
      _Dispatcher["default"].on(MDEvents.evaluationChanged, this.evaluationInfoChanged, this);

      // 暂时隐藏截止日期
      this.$('.end-t-d').hide();
    }
  }, {
    key: "_showOpinionList",
    value: function _showOpinionList() {
      this.$('.opinion-list').hide();
      this.listPanel.showOpionList();
    }
  }, {
    key: "_showFileList",
    value: function _showFileList() {
      this.$('.opinion-list').hide();
      this.listPanel._showFileList(this.files);
    }
  }, {
    key: "evaluationInfoChanged",
    value: function evaluationInfoChanged(fid) {
      var curFid = this.fileInfo.getFileId();
      if (curFid != fid) {
        return;
      }
      var changed = BabelStr.str(512); // 审批信息已改变
      _MDMessageView["default"].show(changed, "infor", this.$(".window-body")[0]);
      this.setFileInfo();
    }
  }, {
    key: "renderMultFileEvalInfo",
    value: function renderMultFileEvalInfo() {
      var _this2 = this;
      // this.fileInfo.get("times")
      MMNetDiskDataController.getMultEvaluatorGroup(this.fileInfo.getEvaluationFlowId(), -1, function (evalFlow) {
        _this2.$(".creator").html(evalFlow.get('creatorName'));
        var completedTime = evalFlow.getCompletedTimeStr();
        if (completedTime) {
          _this2.$('.complete-t-d').show();
          _this2.$('.end-time').html(completedTime);
        } else {
          _this2.$('.complete-t-d').hide();
        }
        var files = evalFlow.getFiles();
        if (files.length) {
          _this2.files = files;
          _this2.$('.one').hide();
          _this2.$('.multFile').show();
          _this2.$('.tool-p-subtitle .left').html(BabelStr.str(6111));
          _this2.$('.tool-p-subtitle .right').html(evalFlow.get("name"));
          _this2.listPanel.refreshWithCurrentData(evalFlow, _this2.files[0], _this2.files, _this2.multFileEvaluationStatus);
        }

        // this.refreshBtn(evalFlow);

        _MDSpinnerloaderLayerView["default"].clearFrom(_this2.$body);
        _this2.$(".tool-panel").removeClass("f-hidden");
      }, function (res) {
        if (res == MMNetDiskDataController.code.ERROR_EMPTY_EVALUATIONGROUPS) {
          _this2.listPanel.renderEmpty();
          _this2.$(".tool-p-edntime").remove();
        } else if (res == 404) {
          _MDSnackbarView["default"].show(BabelStr.str(6143));
          setTimeout(function () {
            _this2.close();
          }, 800);
        } else {
          _MDSnackbarView["default"].show(BabelStr.str(510)); // ('获取审批信息失败')
        }
      });
    }
  }, {
    key: "setFileInfo",
    value: function setFileInfo() {
      var _this3 = this;
      var fileId = this.fileInfo.getFileId();
      var version = this.fileInfo.getCurVersion();
      MMNetDiskDataController.getFileInfoFromServer(fileId, function (fileInfo) {
        _this3.fileInfo.setEvaluationStatus(fileInfo.getEvaluationStatus());
        if (fileInfo && fileInfo.getEvaluationFlowId()) {
          MMNetDiskDataController.getEvaluatorsGroup(fileId, version, fileInfo.getEvaluationFlowId(), function (evalFlow) {
            _this3.$(".creator").html(evalFlow.get('creatorName'));
            var comment = evalFlow.get('comment');
            if (comment) {
              _this3.$(".comment-block").removeClass("f-hide");
              _this3.$(".comment").html(comment);
            }
            var completedTime = evalFlow.getCompletedTimeStr();
            if (completedTime) {
              _this3.$('.complete-t-d').show();
              _this3.$('.end-time').html(completedTime);
            } else {
              _this3.$('.complete-t-d').hide();
            }
            var files = evalFlow.getFiles();
            if (!files.length) {
              _this3.$('.one').show();
              _this3.$('.multFile').hide();
              _this3.$('.tool-p-subtitle .left').html(BabelStr.str(511));
              if (!_this3.fileInfoView) {
                _this3.fileInfoView = new _MDFileInfoShowView["default"]({
                  fileInfo: _this3.fileInfo
                });
                _this3.addSubView(_this3.fileInfoView, _this3.$('.tool-p-subtitle .right')[0]);
              }
            } else {
              _this3.files = files;
              _this3.$('.one').hide();
              _this3.$('.multFile').show();
              _this3.$('.tool-p-subtitle .left').html(BabelStr.str(6111));
              _this3.$('.tool-p-subtitle .right').html(evalFlow.get("name"));
            }

            // this.refreshBtn(evalFlow);
            _this3.listPanel.refreshWithCurrentData(evalFlow, _this3.fileInfo, _this3.files);
            _MDSpinnerloaderLayerView["default"].clearFrom(_this3.$body);
            _this3.$(".tool-panel").removeClass("f-hidden");
          }, function (res) {
            if (res == MMNetDiskDataController.code.ERROR_EMPTY_EVALUATIONGROUPS) {
              _this3.listPanel.renderEmpty();
              _this3.$(".tool-p-edntime").remove();
            } else {
              // MDSnackbarView.show(BabelStr.str(511));    // ('获取审批信息失败')
              _MDSpinnerloaderLayerView["default"].clearFrom(_this3.$body);
              _this3.renderError();
            }
          });
        } else {
          _MDSpinnerloaderLayerView["default"].clearFrom(_this3.$body);
          _this3.$(".tool-panel").removeClass("f-hidden");
          _this3.listPanel.renderEmpty();
          _this3.$(".tool-p-edntime").remove();
        }
      }, function () {
        // MDSnackbarView.show(BabelStr.str(511));    // ('获取审批信息失败')
        _this3.renderError();
      });
    }
  }, {
    key: "renderError",
    value: function renderError() {
      var tmpl = "\n      <div class=\"f-tc mgtb-20 pdt-20\">".concat(BabelStr.str(40092), "</div>\n      <div class=\"flex-align end\">\n        <span class=\"button close-btn mg-20\">").concat(BabelStr.str(156), "</span>\n      </div>\n    ");
      this.$body.html(tmpl);
    }
  }, {
    key: "showSubTitle",
    value: function showSubTitle() {
      this.$('.tool-p-subtitle').show();
    }
  }, {
    key: "hideSubTitle",
    value: function hideSubTitle() {
      this.$('.tool-p-subtitle').hide();
    }
  }, {
    key: "_wheelHandler",
    value: function _wheelHandler(e) {
      e.stopPropagation();
    }
  }, {
    key: "_onmouseDown",
    value: function _onmouseDown(e) {
      this.mousedown = true;
      this.preX = e.screenX;
      this.preY = e.screenY;
      console.log('------ mouse down!');
    }
  }, {
    key: "refreshBtn",
    value: function refreshBtn(evalFlow) {
      var self = this;
      var curUserIsCreator = this.fileInfo.canStartEvaluation();
      var time = new Date(evalFlow.getEndTime() * 1000);
      if (curUserIsCreator) {
        var $datePicker = $('<input type="text" class="evl-date-end cursor-p" required readonly>' + '<i class="ep-ic ep-ic-date cursor-p"></i>');
        this.$(".end-time").html($datePicker);
        // this.$(".date-end").datepicker("option", "minDate", new Date());
        var $expireTimeBox = this.$(".evl-date-end");
        $expireTimeBox.datepicker({}).on("change", function () {
          var exDate = $expireTimeBox.datepicker("getDate");
          var t = exDate.getTime() / 1000;
          MMNetDiskDataController.updateEvaluationFlowTime(evalFlow.getId(), t, function () {
            _MDSnackbarView["default"].show(BabelStr.str(308));
          }, function () {
            _MDSnackbarView["default"].show(BabelStr.str(168));
          });
        });
        $expireTimeBox.datepicker('setDate', new Date(time));
        this.$('.end-time').on('click', function (e) {
          self.$('.evl-date-end').focus();
        });
        this.$('.end-time').addClass('cursor-p');
      } else {
        this.$(".end-time").html(time.format("yyyy-MM-dd"));
      }
    }
  }]);
  return MDEvaluationListWinView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1437":1437,"1454":1454,"1463":1463,"1475":1475,"1541":1541,"18":18,"464":464,"466":466,"497":497,"55":55,"72":72,"75":75,"811":811,"93":93}],464:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDNavigationView = _interopRequireDefault(require(57));
var _MDEvaluationListPanel = _interopRequireDefault(require(466));
var _MMViewBase = _interopRequireDefault(require(22));
var _MDEvalOpinionListPage = _interopRequireDefault(require(461));
var _MDEvalFileListPage = _interopRequireDefault(require(460));
var MDEvaluationListNaviView = _MMViewBase["default"].extend({
  el: '<div class="eval-list-navi"></div>',
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      animateNavigate: true,
      showNavigationBar: true
    });
  },
  initialize: function initialize(opt) {
    var _this = this;
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.listPanel = new _MDEvaluationListPanel["default"](opt);
    this.navView = new _MDNavigationView["default"]({
      animateNavigate: true,
      showNavigationBar: false,
      rootNavigationPageView: this.listPanel,
      onPageViewChanged: function onPageViewChanged(pageView) {
        var rootViewshowing = false;
        if (_this.navView.rootNavigationPageView == pageView) {
          rootViewshowing = true;
        }
        _this.onRootPageShowing && _this.onRootPageShowing(rootViewshowing);
      }
    });
    this.addSubView(this.navView);
  },
  refreshWithCurrentData: function refreshWithCurrentData(evalFlow, fileInfo, files, multFileEvaluationStatus) {
    this.evalFlow = evalFlow;
    this.fileInfo = fileInfo;
    this.files = files;
    this.multFileEvaluationStatus = multFileEvaluationStatus;
    this.listPanel.refreshWithCurrentData(evalFlow, fileInfo, files, multFileEvaluationStatus);
  },
  showOpionList: function showOpionList() {
    var personAdd = new _MDEvalOpinionListPage["default"]({
      evalFlow: this.evalFlow,
      fileInfo: this.fileInfo
    });
    this.listPanel.navigationView.push(personAdd);
  },
  _showFileList: function _showFileList(files) {
    var filesView = new _MDEvalFileListPage["default"]({
      evalFlow: this.evalFlow,
      files: files
    });
    this.listPanel.navigationView.push(filesView);
  }
});
var _default = exports["default"] = MDEvaluationListNaviView;

},{"1184":1184,"1454":1454,"22":22,"460":460,"461":461,"466":466,"57":57}],466:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1412);
require(1417);
require(1463);
require(1423);
require(1411);
require(1530);
require(1505);
require(1506);
require(1507);
require(1508);
require(1510);
require(1509);
require(1512);
require(1513);
require(1514);
require(1516);
require(1517);
require(1518);
require(1519);
require(1521);
require(1520);
require(1522);
require(1523);
require(1524);
require(1525);
require(1526);
require(1527);
require(1528);
require(1529);
require(1461);
require(1477);
require(1492);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDMessageView = _interopRequireDefault(require(55));
var _MMViewBase = _interopRequireDefault(require(22));
var _MDEvaluationListPanelTmpl = _interopRequireDefault(require(467));
var _MMBasicData = _interopRequireDefault(require(811));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDEvaluationRemarkPanel = _interopRequireDefault(require(469));
var _MDFileInfoShowView = _interopRequireDefault(require(497));
var _MDEndEvalWindowView = _interopRequireDefault(require(457));
var _MDEvaluationStatus = _interopRequireDefault(require(254));
var _MDSpinnerloaderLayerView = _interopRequireDefault(require(75));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDEvaluationAddPersonView = _interopRequireDefault(require(462));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MMCommentDataController = _interopRequireDefault(require(1097));
var _MDLoadMaskView = _interopRequireDefault(require(49));
var _MMPdfLoader = _interopRequireDefault(require(897));
var _MDLocalFileCollector = _interopRequireDefault(require(330));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // MDEvaluationListPanel.js
// jiang
// 2017-5-11
var MDEvaluationListPanel = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDEvaluationListPanel, _MDNavigationPageView);
  function MDEvaluationListPanel() {
    (0, _classCallCheck2["default"])(this, MDEvaluationListPanel);
    return _callSuper(this, MDEvaluationListPanel, arguments);
  }
  (0, _createClass2["default"])(MDEvaluationListPanel, [{
    key: "initialize",
    value: function initialize(props) {
      this.strClassName = "MDEvaluationListPanel";
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvaluationListPanel.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvaluationListPanel.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        isUpdate: false,
        close: _.noop,
        inEditor: false,
        files: [],
        multFileEvaluationStatus: 0
      });
    }
  }, {
    key: "renderEmpty",
    value: function renderEmpty() {
      this.$el.addClass("empty-evl flex-align center middle");
      var prompt = BabelStr.str(513); // 该文件为直接定稿文件，无审批人员
      this.$el.html("<div>" + prompt + "</div>");
    }
  }, {
    key: "getProgressTmpl",
    value: function getProgressTmpl(evalFlow, fileInfo) {
      var progress = evalFlow.getProgress();
      var startTime = new Date(evalFlow.getCreateTime() * 1000);
      var startTimeStr = startTime.format("yyyy-MM-dd");
      var endTime = new Date(evalFlow.getEndTime() * 1000);
      var endTimeStr = endTime.format("yyyy-MM-dd");
      var now = new Date();
      var nowStr = now.format("yyyy-MM-dd");
      var spendTimes = (now - startTime) / (1000 * 60 * 60 * 24);
      var spendDays = Math.floor(spendTimes);
      var planTimes = (endTime - startTime) / (1000 * 60 * 60 * 24);
      var planDays = Math.ceil(planTimes);
      var remainingDays = Math.round((endTime - now) / (1000 * 60 * 60 * 24));
      var absRemainingDays = Math.abs(remainingDays);
      var endDayStr = remainingDays > 0 ? BabelStr.str(3494, {
        days: absRemainingDays
      }) : BabelStr.str(3495, {
        days: absRemainingDays
      });
      var nowPer = spendTimes / planTimes * 100;
      nowPer = nowPer > 100 ? 100 : nowPer;
      var startTimeTooltip = this.inEditor ? "data-tooltip=\"".concat(BabelStr.str(616), "\uFF1A").concat(startTimeStr, "\" data-tooltip-dir=\"bottom\"") : "";
      var endTimeTooltip = this.inEditor ? "data-tooltip=\"".concat(BabelStr.str(176), "\uFF1A").concat(endTimeStr, "\" data-tooltip-dir=\"bottom\"") : "";
      var $tmpl = $("<div class=\"progress-eval\">\n      <div class=\"start gray font12\">".concat(BabelStr.str(616), "\uFF1A").concat(startTimeStr, "</div>\n      <div class=\"end gray font12\">\n        <span class=\"title-e\">").concat(BabelStr.str(176), "</span>\n        <span class=\"end-time\">\n          <input type=\"text\" class=\"evl-date-end cursor-p\" required readonly>\n          <i class=\"ep-ic ep-ic-date cursor-p\"></i>\n        </span>\n      </div>\n      <div class=\"end-line\">\n        <div class=\"end-line-before\" ").concat(endTimeTooltip, "></div>\n      </div>\n      <div class=\"bar\">\n      </div>\n      <div class=\"per\">").concat(BabelStr.str(5170)).concat(progress, "%</div>\n      <div class=\"x-axis\"/>\n      <div class=\"time-line\">\n        <div class=\"time-line-before\" ").concat(startTimeTooltip, "></div>\n        <div class=\"time-now\" data-tooltip=\"").concat(BabelStr.str(3499), "\uFF1A").concat(nowStr, "\" data-tooltip-dir=\"bottom\"></div>\n        <div class=\"time-line-after \"></div>\n      </div>\n      <div class=\"before-block  font12 gray\">").concat(BabelStr.str(3493, {
        days: spendDays
      }), "</div>\n      <div class=\"end-block font12 gray\">").concat(endDayStr, "</div>\n    </div>"));
      var maxEndlineRight = this.inEditor ? 92 : 80;
      var timePer = 0;
      if (this.inEditor) {
        timePer = spendTimes < planTimes ? 0 : 1 - planTimes / spendTimes;
      } else {
        timePer = spendTimes < planTimes ? 0.01 : 1 - planTimes / spendTimes;
      }
      var timePerStr = timePer * 100;
      $tmpl.find(".end-line").css({
        right: "".concat(timePerStr < maxEndlineRight ? timePerStr : maxEndlineRight, "%")
      });
      $tmpl.find(".end-line").css({
        right: "".concat(timePerStr < maxEndlineRight ? timePerStr : maxEndlineRight, "%")
      });
      $tmpl.find(".end").css({
        right: "calc(".concat(timePerStr < 72 ? timePerStr : 72, "% - 96px)")
      });
      $tmpl.find(".bar").css({
        width: "".concat(progress, "%")
      });
      $tmpl.find(".time-now").css({
        left: "".concat(nowPer, "%")
      });
      var self = this;
      var canCurUserManegeEval = fileInfo.canStartEvaluation();
      var time = new Date(evalFlow.getEndTime() * 1000);
      if (canCurUserManegeEval) {
        var $datePicker = $('<input type="text" class="evl-date-end cursor-p" required readonly>' + '<i class="ep-ic ep-ic-date cursor-p"></i>');
        var $expireTimeBox = $tmpl.find(".evl-date-end");
        $expireTimeBox.datepicker({}).on("change", function () {
          var exDate = $expireTimeBox.datepicker("getDate");
          var t = exDate.getTime() / 1000;
          MMNetDiskDataController.updateEvaluationFlowTime(evalFlow.getId(), t, function () {
            evalFlow.setEndTime(t);
            self.refreshWithCurrentData(evalFlow, fileInfo, self.files, self.multFileEvaluationStatus);
            _MDSnackbarView["default"].show(BabelStr.str(308));
          }, function () {
            _MDSnackbarView["default"].show(BabelStr.str(168));
          });
        });
        $expireTimeBox.datepicker("setDate", new Date(time));
        $tmpl.find(".end-time").on("click", function (e) {
          $tmpl.find(".evl-date-end").focus();
        });
        $tmpl.find(".end-time").addClass("cursor-p");
      } else {
        $tmpl.find(".end-time").html(time.format("yyyy-MM-dd"));
      }
      return $tmpl;
    }
  }, {
    key: "refreshWithCurrentData",
    value: function refreshWithCurrentData(evalFlow, fileInfo, files, multFileEvaluationStatus) {
      var _this = this;
      this.files = files;
      this.multFileEvaluationStatus = multFileEvaluationStatus;
      if (this.wind) {
        this.wind.close();
      }
      this._clearEvaluatorEvents();
      this.fileInfo = fileInfo;
      this.evalFlow = evalFlow;

      // test
      // MMNetDiskDataController.getFileAllEvaluatorsGroup(fileInfo.getFileId(), (data)=>{
      // }, ()=>{
      // });

      this.$el.empty();
      var evalSteps = this.evalFlow.getSteps();
      var canCurUserManegeEval = fileInfo.canStartEvaluation();
      var finalizedStep = this.evalFlow.getFinalizedStep();
      if (finalizedStep == null || finalizedStep == undefined) {
        finalizedStep = evalSteps.length;
      }
      var needGroupTitle = false;
      if (evalSteps.length > 1) {
        needGroupTitle = true;
      }
      var curStep = this.evalFlow.getCurStep();
      var strHtml = '<ul class = "list-block">';
      this.userIds = [];
      this.evaluations = [];
      for (var i = 0; i < evalSteps.length; i++) {
        if (i == curStep) {
          strHtml += '<div class="val-group cur-val-group">';
        } else if (i < curStep) {
          strHtml += '<div class="val-group passed-group">';
        } else if (i > curStep) {
          strHtml += '<div class="val-group wait-group">';
        }
        var evalGroup = evalSteps[i].get("evaluators");
        var titleData = {
          groupStatus: "",
          className: ""
        };
        if (needGroupTitle) {
          var groupName = evalSteps[i].getTitle();
          if (!groupName) {
            var nameSub = BabelStr.str(256); //  '审批';
            groupName = nameSub + (i + 1);
          }
          var groupStatus = "";
          if (i < curStep) {
            titleData["groupStatus"] = BabelStr.str(514); // '已通过';
            titleData["className"] = "passed";
          } else if (i > curStep) {
            titleData["groupStatus"] = BabelStr.str(515); // '未开始';
            titleData["className"] = "no-input";
          } else {
            if (this.fileInfo.isEvaluating()) {
              titleData["groupStatus"] = BabelStr.str(516); //  '正在审批中...';
              titleData["className"] = "evaluating";
            } else if (this.fileInfo.isRejected()) {
              titleData["groupStatus"] = BabelStr.str(517); //  '已驳回';
              titleData["className"] = "rejected";
            }
          }
          titleData["groupName"] = groupName;
          strHtml += _.template(_MDEvaluationListPanelTmpl["default"].groupTile)(titleData);
        }
        var isPassed = this.fileInfo.isPassed();
        var startTime = evalSteps[i].getStartTime() || evalFlow.getCreateTime();
        for (var k = 0; k < evalGroup.length; k++) {
          var evaluation = evalGroup[k];
          var evalData = {};
          var comment = evaluation.getComment();
          if (!comment) {
            comment = "";
          }
          var followFinalized = i >= finalizedStep; // 是否在定稿步骤的后面
          evalData["className"] = evaluation.getEvaluationClassName();
          evalData["groupIndex"] = i;
          evalData["evalIndex"] = k;
          evalData["rowNum"] = i + 1;
          evalData["userId"] = evaluation.getUserId();
          evalData["userName"] = evaluation.getUserName();
          evalData["status"] = evaluation.getEvaluationStr(isPassed, followFinalized);
          evalData["comment"] = comment;
          if (comment.length) {
            evalData["className"] += " opened";
          }
          evalData["spendsTimeStr"] = evaluation.getSpendsTimeStr(startTime);
          this.userIds.push(evaluation.getUserId());
          this.evaluations.push(evaluation);
          strHtml += _.template(_MDEvaluationListPanelTmpl["default"].evalItem)(evalData);
        }
        var buttonsStr = "";
        var endTime = new Date(evalFlow.getEndTime() * 1000);
        var now = new Date();
        if (!this.inEditor && canCurUserManegeEval && i >= curStep && !this.fileInfo.isPassed() && now < endTime) {
          buttonsStr += '<div class="add-person text-button done inline " data-step="' + i + '">' + BabelStr.str(5171) + "</div>";
        }
        if (evalSteps[i].canBeIgnore() && !this.inEditor && canCurUserManegeEval && i == curStep && !this.fileInfo.isPassed()) {
          var skipStr = BabelStr.str(5172);
          if (i >= evalSteps.length - 1) {
            skipStr = BabelStr.str(5173);
          }
          buttonsStr += '<div class="skip-step text-button done inline " data-step="' + i + '">' + skipStr + "</div>";
        }
        if (buttonsStr.length > 0) {
          strHtml += '<div class="flex-align between middle" >' + buttonsStr + "</div>";
        }

        // var copyToGroup = copyToGroups[i];
        // for(var m = 0; m < copyToGroup.length; m++){
        //   var copyUser = copyToGroup[m];
        //   var data = {
        //     name: copyUser.getUserName(),
        //     copyTo: BabelStr.str(523),    // 抄送者
        //   }
        //   strHtml += _.template(MDEvaluationListPanelTmpl.copyToUserItem)(data);
        // }

        strHtml += "</div>";
      }
      strHtml += "</ul>";
      this.$el.html(strHtml);
      if (this.fileInfo.isEvaluating()) {
        var progeressTmpl = this.getProgressTmpl(evalFlow, fileInfo);
        this.$el.prepend(progeressTmpl);
      }
      this.$(".eval-comment").on("mousedown", function (e) {
        _this._commentIconClicked(e);
      });

      // this.renderComments();

      this.$(".add-person").on("click", function (e) {
        _this._addPerson(e);
      });
      this.$(".skip-step").on("click", function (e) {
        _this._skipStep(e);
      });
      this.initEvalFoot();
      this.listenCurrentUserAttr();
      this.checkEndTime();
    }
  }, {
    key: "_addPerson",
    value: function _addPerson(e) {
      var _this2 = this;
      var step = $(e.target).data("step");
      console.log("-----" + step);
      var personAdd = new _MDEvaluationAddPersonView["default"]({
        oldUserIds: this.userIds,
        personAdded: function personAdded(data) {
          var fileId = _this2.fileInfo.getFileId();
          var filterIds = [];
          var userIds = data.users;
          for (var i = 0; i < userIds.length; i++) {
            var uid = userIds[i];
            var found = false;
            for (var _i = 0; _i < _this2.userIds.length; _i++) {
              var oldId = _this2.userIds[_i];
              if (oldId == uid) {
                found = true;
                break;
              }
            }
            if (!found) {
              filterIds.push(uid);
            }
          }
          if (filterIds.length < userIds.length) {
            _MDMessageView["default"].error(BabelStr.str(7159), _this2.$el);
          }
          if (filterIds.length > 0 || data.emails.length > 0 || data.phones.length > 0) {
            MMNetDiskDataController.addPersonToEvaluation(fileId, step, filterIds, data.emails, data.phones, function () {
              _MDSnackbarView["default"].show(BabelStr.str(308));
              _this2.refreshEvalFlow();
            }, function () {
              _MDSnackbarView["default"].show(BabelStr.str(168));
            });
          }
        }
      });
      this.navigationView.push(personAdd);
    }
  }, {
    key: "_skipStep",
    value: function _skipStep(e) {
      var _this3 = this;
      var fileId = this.fileInfo.getFileId();
      if (this.skipping) {
        return;
      }
      this.skipping = true;
      if (this.files.length) {
        _MMEnterpriseController["default"].skipMultFlowCurrentStep(this.fileInfo.getEvaluationFlowId(), function () {
          _MDSnackbarView["default"].show(BabelStr.str(308));
          _this3.refreshEvalFlow();
          _this3.skipping = false;
        }, function () {
          _MDMessageView["default"].error(BabelStr.str(7160));
        });
      } else {
        MMNetDiskDataController.skip2EvalFlowStep(fileId, function () {
          _MDSnackbarView["default"].show(BabelStr.str(308));
          _this3.refreshEvalFlow();
          _this3.skipping = false;
        }, function () {
          _MDSnackbarView["default"].show(BabelStr.str(168));
          _this3.skipping = false;
        });
      }
    }
  }, {
    key: "checkEndTime",
    value: function checkEndTime() {
      var time = new Date(this.evalFlow.getEndTime() * 1000);
      var today = new Date();
      // if (today > time) {
      // this.$('.eval-btn').prop('disabled', true);
      // this.$('.eval-btn').addClass('disabled');
      // }
    }
  }, {
    key: "listenCurrentUserAttr",
    value: function listenCurrentUserAttr() {
      var curUserEval = this.evalFlow.getCurrentUserEvaluation();
      this.stopListening(curUserEval);
      this.listenTo(curUserEval, "change", this._evaluationAttrChangedHandle);
    }
  }, {
    key: "_evaluationAttrChangedHandle",
    value: function _evaluationAttrChangedHandle(model, options) {
      if (model.hasChanged("evaluation")) {
        this.refreshWithCurrentData(this.evalFlow, this.fileInfo, this.files, this.multFileEvaluationStatus);
      }
    }
  }, {
    key: "initEvalFoot",
    value: function initEvalFoot() {
      var _this4 = this;
      this._clearFootEvents();
      this.$(".tool-p-foot").remove();
      var footData = {
        open: BabelStr.str(259),
        // 开启审批
        close: BabelStr.str(524),
        // 结束审批
        reEnter: BabelStr.str(525),
        // 重新填写审批意见
        myOpinin: BabelStr.str(526),
        // 我的结论
        ok: BabelStr.str(133),
        // 通过
        deny: BabelStr.str(134),
        // 驳回
        withdraw: BabelStr.str(1054),
        // 终止审批
        tip: BabelStr.str(1055),
        // 终止审批的警告提示
        cancel: BabelStr.str(155) // 取消
      };
      var curUserEval = this.evalFlow.getCurrentUserEvaluation();
      var canCurUserManegeEval = this.fileInfo.canStartEvaluation();
      var curUserGroupIndex = this.evalFlow.getCurrentUserGroupIndex();
      var curStep = this.evalFlow.getCurStep();
      if (this.files.length && this.multFileEvaluationStatus == 10) {
        var footHtml = _.template(_MDEvaluationListPanelTmpl["default"].foot)(footData);
        this.$el.append('<div class = "tool-p-foot">' + footHtml + "</div>");
        this.$(".eval-evaluate").remove();
        if (this.evalFlow.get("creatorId") == app.currentUser.getUserId()) {
          this.$(".eval-open").addClass("done");
          this.$(".eval-open").on("mousedown", function (e) {
            _this4._openEvalClicked(e);
          });
        } else {
          this.$(".eval-open").remove();
          // this.$(".tool-p-foot").html(BabelStr.str(518));
        }
        this.$(".eval-withdraw").remove();
      } else if (!this.fileInfo.isPassed() || this.fileInfo.canShowReStartEvaluation()) {
        if (curUserEval && curStep == curUserGroupIndex && !this.fileInfo.isRejected()) {
          var _footHtml = _.template(_MDEvaluationListPanelTmpl["default"].foot)(footData);
          this.$el.append('<div class = "tool-p-foot">' + _footHtml + "</div>");
          this.$(".eval-open").remove();
          // this.$('.eval-end').remove();

          if (curUserEval.isNoInput()) {
            this.$(".eval-reeval").hide();
          } else {
            this.$(".eval-input").hide();
          }
          this.$(".eval-pass").on("mousedown", function (e) {
            _this4._passClicked(e);
          });
          this.$(".eval-reject").on("mousedown", function (e) {
            _this4._rejectClicked(e);
          });
          this.$(".eval-reeval").on("mousedown", function (e) {
            _this4._reEvalClicked(e);
          });
        } else if (canCurUserManegeEval || this.fileInfo.canStartEvaluation() && curStep == -1) {
          var _footHtml2 = _.template(_MDEvaluationListPanelTmpl["default"].foot)(footData);
          this.$el.append('<div class = "tool-p-foot">' + _footHtml2 + "</div>");
          this.$(".eval-evaluate").remove();
          if (this.fileInfo.isEvaluating()) {
            this.$(".eval-open").remove();
          } else if (this.fileInfo.isWaitToReStartEvaluation()) {
            // this.$('.eval-end').remove();
            this.$(".eval-open").addClass("done");
          } else if (this.fileInfo.isPassed()) {
            this.$(".eval-open").remove();
            // this.$('.eval-end').remove();
          } else if (this.fileInfo.isRejected()) {
            this.$(".tool-p-foot").html(BabelStr.str(518)); // ("该文件已被驳回，可通过上传新版本重新开启审批");
          }
          this.$(".eval-open").on("mousedown", function (e) {
            _this4._openEvalClicked(e);
          });
          // this.$('.eval-end').on('mousedown', (e) => {
          //   this._endEvalClicked(e);
          // })
        } else if (curUserEval && curStep < curUserGroupIndex) {
          var p = BabelStr.str(519); // 当前阶段您还不能进行审批
          this.$el.append('<div class = "tool-p-foot">' + p + "</div>");
        } else if (curUserEval && curStep > curUserGroupIndex) {
          var p = BabelStr.str(520); // 已审批
          this.$el.append('<div class = "tool-p-foot">' + p + "</div>");
        } else if (this.fileInfo.isRejected()) {
          var p = BabelStr.str(521); // 文件已驳回，审批结束
          this.$el.append('<div class = "tool-p-foot">' + p + "</div>");
        }
        if (canCurUserManegeEval && this.fileInfo.isEvaluating()) {
          this.$(".eval-withdraw").on("mousedown", function (e) {
            _this4._withdrawEvalClicked(e);
          });
        } else {
          this.$(".eval-withdraw").remove();
        }
      } else if (canCurUserManegeEval) {
        this.$(".eval-withdraw").remove();
        var p = BabelStr.str(522); // 审批已完成
        var str1 = "";
        if (this.fileInfo.canStartEvaluation()) {
          // 可以设置为未通过
          // str1 = `<button class="button setting-not-pass done">${BabelStr.str(3332)}</button>`
        }
        var str = "<div class=\"flex-align between pd-15 eval-foot\">\n        <span>".concat(p, "</span>\n        <div>\n          ").concat(str1, "\n          <button class=\"button show-val done\">").concat(BabelStr.str(7161), "</button>\n        </div>\n      </div>");
        this.$el.append(str);
        this.$(".setting-not-pass").on("mousedown", function (e) {
          _this4._settingToNotPassed(e);
        });
        this.$(".show-val").on("mousedown", function (e) {
          _this4._showEvalFile(e);
        });
      }
    }
  }, {
    key: "_settingToNotPassed",
    value: function _settingToNotPassed($e) {
      var _this5 = this;
      $e.stopPropagation();
      var fileId = this.fileInfo.getFileId();
      MMNetDiskDataController.setEvaluationToUnstart(fileId, function () {
        _this5.close();
        _this5.fileInfo.setEvaluationStatus(_MDEvaluationStatus["default"].REJECTED);
        _this5.fileInfo.setCurrentVersionEvaluation(_MDEvaluationStatus["default"].REJECTED);
        _this5.refreshWithCurrentData(_this5.evalFlow, _this5.fileInfo, _this5.files, _this5.multFileEvaluationStatus);
      }, function (code) {
        console.log(code);
      });
    }

    // 测试使用， 打开本地 pdf 进行显示
  }, {
    key: "_openPdf",
    value: function _openPdf(canvas) {
      var self = this;
      _MDLocalFileCollector["default"].openFileFinderWindow(function (files) {
        _MMPdfLoader["default"].ensurePDFJS(function () {
          var file = files[0];
          var reader = new FileReader();
          reader.onload = function (e) {
            var contents = e.target.result;
            // Display file content

            if (typeof contents == "string") {
              var str2ab = function str2ab(s, f) {
                s = decodeURI(s);
                var b = new Blob([s], {
                  type: "application/pdf"
                });
                var r = new FileReader();
                r.readAsArrayBuffer(b);
                r.onload = function () {
                  if (f) f.call(null, r.result);
                };
              };
              str2ab(contents, function (result) {
                var uint8array = new Uint8Array(result);
                self._readUintArrDrawPdf(canvas, uint8array);
              });

              // const str2ab = function(str) {
              //   var buf = new ArrayBuffer(str.length * 2); // 每个字符占用2个字节
              //   var bufView = new Uint16Array(buf);
              //   for (var i = 0, strLen = str.length; i < strLen; i++) {
              //     bufView[i] = str.charCodeAt(i);
              //   }
              //   return buf;
              // }
              // var arrb = str2ab(contents);
              // var uint8array = new Uint8Array(arrb);
              // readDrawPdf(uint8array);

              // var blob = new Blob([contents], { type: 'application/pdf' });

              // // create an object URL from the Blob
              // var URL = window.URL || window.webkitURL;
              // var downloadUrl = URL.createObjectURL(blob);
              // self._readUintArrDrawPdf(canvas, downloadUrl);
            } else {
              var uint8array = new Uint8Array(contents);
              self._readUintArrDrawPdf(canvas, uint8array);
            }
          };
          // reader.readAsText(file);
          reader.readAsArrayBuffer(file);
        });
      });
    }
  }, {
    key: "_readUintArrDrawPdf",
    value: function _readUintArrDrawPdf(canvas, uint8array) {
      this.task = pdfjsLib.getDocument({
        BinaryData: uint8array,
        cMapUrl: pdfjsLib.cMapUrl,
        cMapPacked: pdfjsLib.cMapPacked,
        disableRange: true
      });
      this.task.promise.then(function (pdf) {
        console.log("*********  pdf loaded");
        _MDLoadMaskView["default"].remove();
        pdf.getPage(1).then(function (page) {
          var scale = 1;
          var viewport = page.getViewport(scale);
          var context = canvas.getContext("2d");
          canvas.height = viewport.height;
          canvas.width = viewport.width;
          page.render({
            canvasContext: context,
            viewport: viewport
          });
        });
      }, function () {
        _MDLoadMaskView["default"].remove();
      });
    }
  }, {
    key: "_downloadEvalFile",
    value: function _downloadEvalFile($e) {
      var _this6 = this;
      var $printDiv = $('<div class="rep-mask" style="">' + '<canvas id="rep-canvas" width="768px" height="1024"/>' + '<button class="rep-close button danger" > ' + BabelStr.str(156) + " </button>" + "</div>");
      $(".app-root").append($printDiv);
      var canvas = $printDiv.find("canvas")[0];
      $printDiv.find(".rep-close").on("click", function (e) {
        $printDiv.remove();
      });
      $printDiv.find(".rep-print").on("click", function (e) {
        var dataUrl = canvas.toDataURL(); //attempt to save base64 string to server using this var
        var windowContent = "<!DOCTYPE html>";
        windowContent += "<html>";
        windowContent += "<head><title>Print canvas</title></head>";
        windowContent += "<body>";
        windowContent += '<img src="' + dataUrl + '">';
        windowContent += "</body>";
        windowContent += "</html>";
        var printWin = window.open("", "", "width=768,height=1024");
        printWin.document.open();
        printWin.document.write(windowContent);
        printWin.document.close();
        printWin.focus();
        printWin.onload = function () {
          printWin.print();
          printWin.close();
        };
      });
      _MDLoadMaskView["default"].show();
      _MMPdfLoader["default"].ensurePDFJS(function () {
        _this6._loadPdfAndDraw(canvas);
        // this._openPdf(canvas);
      });
    }
  }, {
    key: "_showEvalFile",
    value: function _showEvalFile() {
      var _this7 = this;
      var flowType = !this.evalFlow.get("flowType");
      var downFileStr = "";
      if (!this.files.length) {
        downFileStr = "<button class=\"rep-down button done\" >".concat(BabelStr.str(29), "</button>");
      }
      var $printDiv = $("<div class=\"rep-mask\" style=\"\">\n      <div id=\"rep-contents\">\n        <div class=\"line flex-align with-wrap center\">\n          <div class=\"item\">\n            <span class=\"l-title\">".concat(BabelStr.str(49), "\uFF1A</span>\n            <span>").concat(this.fileInfo.getFileName(), "</span>\n          </div>\n        </div>\n        <div class=\"title\">").concat(BabelStr.str(6044), "</div>\n        <table class=\"comments-block\"></table>\n        <div class=\"title mgt-10\">").concat(flowType ? BabelStr.str(6048) : BabelStr.str(6045), "</div>\n        <table class=\"eval-block\"></table>\n        ").concat(downFileStr, "\n        <button class=\"rep-close button danger\" > ").concat(BabelStr.str(156), " </button>\n      </div>\n    </div>"));
      $("body").append($printDiv);
      $printDiv.find(".rep-close").on("click", function (e) {
        $printDiv.remove();
      });
      $printDiv.find(".rep-down").on("click", function (e) {
        // $printDiv.remove();

        var fileId = _this7.fileInfo.getFileId();
        var fileName = encodeURI(encodeURI(_this7.fileInfo.getFileName()));
        var url = "/downloadEvalReport.do?fileId=" + fileId + "&fileName=" + fileName + "&version=" + _this7.fileInfo.getCurVersion();
        _MDLoadMaskView["default"].remove();
        // 创建一个a标签
        var a = document.createElement("a");
        // 设置下载链接的href属性为Blob对象的URL
        a.href = url;
        // 设置下载文件的名称
        a.download = fileName;

        // 触发下载
        document.body.appendChild(a);
        a.click();

        // 清理：从DOM中移除a标签，并撤销URL对象
        document.body.removeChild(a);
      });
      this._renderEvals($printDiv);
      _MMCommentDataController["default"].getFileCommentInfos(this.fileInfo.getFileId(), function (commentInfos) {
        var out = [];
        var i;
        for (i = 0; i < commentInfos.length; i++) {
          var info = commentInfos[i];
          // if (info.visibleScope >= 8) {
          out.push(info);
          // };
        }
        _MDSpinnerloaderLayerView["default"].clearFrom(_this7.$el[0]);
        _this7._renderOpinions(out, $printDiv);
      }, function () {
        _MDSpinnerloaderLayerView["default"].clearFrom(_this7.$el[0]);
        _this7._renderOpinions([]);
      });
    }
  }, {
    key: "_renderEvals",
    value: function _renderEvals($parent) {
      var flowType = this.evalFlow.get("flowType");
      console.log("flowType ----------- " + flowType);
      var $content = $parent.find(".eval-block");
      var steps = this.evalFlow.getSteps();
      var time = new Date(this.evalFlow.getCreateTime() * 1000).format("yyyy-MM-dd HH:mm:ss");
      var tmpl = "<tr>\n        <td style=\"width: 25%\">".concat(BabelStr.str(3094), "</td>\n        <td style=\"width: 25%\">").concat(BabelStr.str(3073), "</td>");
      if (flowType) {
        tmpl += "<td style=\"width: 25%\">".concat(BabelStr.str(6046), "</td>");
      }
      tmpl += "<td style=\"width: 25%\">".concat(BabelStr.str(3286), "</td>\n      </tr>");
      if (flowType) {
        tmpl += "<tr>\n          <td class=\"createrDepName\"></td>\n          <td>".concat(this.evalFlow.get("creatorName"), "</td>\n          <td>").concat(BabelStr.str(6047), "</td>\n          <td>").concat(time, "</td>\n        </tr>");
      }
      _.each(steps, function (step) {
        var evalInfos = step.getEvalInfos();
        _.each(evalInfos, function (evalInfo) {
          var userName = evalInfo.getUserName();
          var userDepName = evalInfo.getUserDepName() || "";
          var evaluation = "--";
          var time = new Date(evalInfo.getTime() * 1000).format("yyyy-MM-dd HH:mm:ss");
          if (evalInfo.isPassed()) {
            evaluation = BabelStr.str(133);
          } else if (evalInfo.isRejected()) {
            evaluation = BabelStr.str(134);
          }
          tmpl += "<tr>\n          <td>".concat(userDepName, "</td>\n          <td>").concat(userName, "</td>");
          if (flowType) {
            tmpl += "<td>".concat(evaluation, "</td>");
          }
          tmpl += "<td>".concat(time, "</td>\n        </tr>");
        });
      });
      $content.append(tmpl);
      _MMEnterpriseController["default"].roleAndUsers.getUserInfoById(this.evalFlow.get("creatorId"), function (userInfo) {
        try {
          var dep = userInfo.departments[0];
          var depName = dep.departmentName;
          $content.find(".createrDepName").html(depName);
        } catch (e) {}
      }, console.log);
    }
  }, {
    key: "_renderOpinions",
    value: function _renderOpinions(comments, $parent) {
      var $content = $parent.find(".comments-block");
      var tmpl = "<tr>\n        <td style=\"width: 200px\">".concat(BabelStr.str(6041), "</td>\n        <td>").concat(BabelStr.str(6042), "</td>\n        <td style=\"width: 200px\">").concat(BabelStr.str(6043), "</td>\n      </tr>\n    ");
      _.each(comments, function (comment) {
        var name = comment.creatorName;
        var time = new Date(comment.createTime).format("yyyy-MM-dd HH:mm:ss");
        var jsonObj = JSON.parse(comment.message);
        var text = jsonObj.Body;
        if (!text) {
          if (jsonObj.Type == "Mark") {
            text = BabelStr.str(7060);
          } else if (jsonObj.Type == "File") {
            text = BabelStr.str(7061);
          } else {
            text = "<cannot display>";
          }
        }
        var result = "--";
        if (comment.completed) {
          result = comment.completed == 2 ? BabelStr.str(807) : BabelStr.str(808);
        }
        tmpl += "<tr>\n        <td>".concat(name, "</td>\n        <td>").concat(text, "</td>\n        <td>").concat(result, "</td>\n      </tr>");
      });
      $content.append(tmpl);
    }
  }, {
    key: "_loadPdfAndDraw",
    value: function _loadPdfAndDraw(canvas) {
      var self = this;
      _MDLoadMaskView["default"].show();
      var fileId = this.fileInfo.getFileId();
      var fileName = encodeURI(encodeURI(this.fileInfo.getFileName()));
      var postData = {
        fileId: fileId,
        fileName: fileName,
        version: this.fileInfo.getCurVersion()
      };
      // $.ajax({
      //   method: 'post',
      //   url: "/downloadEvalReport.do",
      //   data: postData,
      //   success: function(responseData, textStatus, jqXHR) {
      //     console.log('*********  return from /downloadEvalReport.do:');
      //     if (textStatus == "success") {
      //       function str2ab(s,f){
      //         var b = new Blob([s], {type:'text/plain'});
      //         var r = new FileReader();
      //         r.readAsArrayBuffer(b);
      //         r.onload = function() {
      //           if(f) f.call(null, r.result);
      //         }
      //       }

      //       str2ab(responseData, (result)=>{

      //         var uint8array = new Uint8Array(result);
      //         self._readUintArrDrawPdf(canvas, uint8array);

      //       })
      //     } else {
      //       fail(responseData);
      //       // MMNetDiskDataController.errorProcess(responseData, fail);
      //     }
      //   }
      // });
      var url = "/downloadEvalReport.do?fileId=" + fileId + "&fileName=" + fileName + "&version=" + this.fileInfo.getCurVersion();
      self._readUintArrDrawPdf(canvas, url);
    }
  }, {
    key: "_loadPdfByBrowser",
    value: function _loadPdfByBrowser() {
      var self = this;
      var fileId = this.fileInfo.getFileId();
      var fileName = encodeURI(encodeURI(this.fileInfo.getFileName()));
      var postData = {
        fileId: fileId,
        fileName: fileName,
        version: this.fileInfo.getCurVersion()
      };
      var url = "/downloadEvalReport.do?fileId=" + fileId + "&fileName=" + fileName + "&version=" + this.fileInfo.getCurVersion();
      window.open(url, "_blank", "fullscreen=yes");
    }
  }, {
    key: "createDownloadParams",
    value: function createDownloadParams(commentInfos) {
      var evals = [];
      var i;
      for (i = 0; i < commentInfos.length; i++) {
        var info = commentInfos[i];
        if (info.visibleScope >= 8) {
          var op = this._createDownloadOpinions(info);
          evals.push(info);
        }
      }
      var signatures = [];
      for (var _i2 = 0; _i2 < this.evaluations.length; _i2++) {
        var evalInfo = this.evaluations[_i2];
        if (evalInfo.isPassed()) {
          signatures.push({
            department: evalInfo.getUserDepName(),
            name: evalInfo.getUserName(),
            signDate: evalInfo.getDateStr()
          });
        }
      }
      var param = {
        label: "CH-SP6-QP01-F02",
        fileName: this.fileInfo.getFileName(),
        fileNumber: " ",
        fileType: " ",
        // 新建还是新版本
        modifyDate: this.fileInfo.getModifyDateStr(),
        ideaReview: evals,
        meetSignature: signatures
      };
    }
  }, {
    key: "_createDownloadOpinions",
    value: function _createDownloadOpinions(info) {
      try {
        message = JSON.parse(info.message);
      } catch (e) {
        return null;
      }
      var messageDisplay;
      if (message["Type"] == "Audio") {
        var audioUrl = _MMCommonFun["default"].getRemoteDURL(this.fileInfo.getCreatorId(), this.fileInfo.getFileId(), message["Url"]);
        messageDisplay = MDAudioPlayer.getAudioPlayer(audioUrl, message["Body"], "", true); // true to get a prototype
      } else if (message["Type"] == "Text") {
        messageDisplay = _.escape(message["Body"]).replace(/\n/g, "<br>");
      } else if (message["Type"] == "Mark") {
        messageDisplay = _.escape(message["Text"] || "").replace(/\n/g, "<br>");
        if (messageDisplay.length == 0) messageDisplay = BabelStr.str(5153);
      }
      var out = {
        ideaProvider: info.creatorName,
        description: messageDisplay,
        ideaProcess: function () {
          if (info.completed == 2) {
            return BabelStr.str(807);
          } else if (info.completed == 3) {
            return BabelStr.str(808);
          } else {
            return "";
          }
        }()
      };
      return out;
    }
  }, {
    key: "renderComments",
    value: function renderComments() {}
  }, {
    key: "_commentIconClicked",
    value: function _commentIconClicked(e) {
      // e.stopPropagation();

      // var $div = $(e.currentTarget);
      // var groupIndex = $div.attr('groupIndex');
      // var evalIndex = $div.attr('evalIndex');
      // var evalSteps = this.evalFlow.getEvaluationGroups();
      // var evalObj = evalSteps[groupIndex][evalIndex];

      // console.log('-----------> comment clicked, ', evalObj);
      // var wind = new MDEvaluationRemarkPanel({
      //   evalType: undefined,
      //   evaluationInfo: evalObj,

      //   doneSuccess: () => {
      //     this.$('.eval-input').hide();
      //     this.$('.eval-reeval').show();
      //   }
      // });
      // wind.show();

      e.stopPropagation();
      // this.$(".comment-item-e").remove();
      var $div = $(e.currentTarget);
      var $li = $div.closest("li");
      if ($li.hasClass("opened")) {
        $li.removeClass("opened");
      } else {
        $li.addClass("opened");
        // $li.addClass("opened");
        // var groupIndex = $div.attr("groupIndex");
        // var evalIndex = $div.attr("evalIndex");
        // var evalSteps = this.evalFlow.getSteps();

        // var evalObj = evalSteps[groupIndex].getEvalInfos()[evalIndex];
        // var comments = evalObj.getComment();
        // var contentTmpl = _.template(MDEvaluationListPanelTmpl.comments)({
        //   comments: comments,
        // });
        // $(contentTmpl).insertAfter($li).hide().slideDown();
      }
    }
  }, {
    key: "remove",
    value: function remove(opt_removeRef) {
      this._clearFootEvents();
      this._clearEvaluatorEvents();
      this.$(".cancel").off();
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvaluationListPanel.prototype), "remove", this).call(this, opt_removeRef);
    }
  }, {
    key: "_clearEvaluatorEvents",
    value: function _clearEvaluatorEvents() {
      this.$(".add-person").off();
      this.$(".skip-step").off();
      this.$(".eval-comment").off();
    }
  }, {
    key: "_clearFootEvents",
    value: function _clearFootEvents() {
      this.$(".eval-pass").off();
      this.$(".eval-open").off();
      this.$(".eval-reject").off();
      this.$(".eval-reeval").off();
      this.$(".eval-withdraw").off();
      this.$(".did-withdraw").off();
      this.$(".setting-not-pass").off();
      this.$(".download-val").off();
    }
  }, {
    key: "_passClicked",
    value: function _passClicked(e) {
      var _this8 = this;
      var curUserEval = this.evalFlow.getCurrentUserEvaluation();
      if (!curUserEval) {
        console.error("*** 数据错误，没有该人的审批信息");
        // return;
      }
      this.wind = new _MDEvaluationRemarkPanel["default"]({
        evalType: "pass",
        evaluationInfo: curUserEval,
        fileInfo: this.fileInfo,
        files: this.files,
        isUpdate: this.isUpdate,
        doneSuccess: function doneSuccess(obj) {
          curUserEval.setEvaluationId(obj.fileEvaluationId);
          curUserEval.setComment(obj.comment);
          curUserEval.setEvaluation(obj.evaluation, {
            silent: true
          });
          if (_this8.evalFlow.isAllPassed()) {
            _this8.fileInfo.setEvaluationStatus(_MDEvaluationStatus["default"].PASSED);
            _this8.fileInfo.setCurrentVersionEvaluation(_MDEvaluationStatus["default"].PASSED);
          }
          if (_this8.evalFlow.isCurStepAllPassed()) {
            _this8.evalFlow.setCurStep(_this8.evalFlow.getCurStep() - 0 + 1);
          } else if (_this8.evalFlow.isCurStepAllEvaluationWithNot()) {
            _this8.fileInfo.setEvaluationStatus(_MDEvaluationStatus["default"].REJECTED);
            _this8.fileInfo.setCurrentVersionEvaluation(_MDEvaluationStatus["default"].REJECTED);
          }
          _this8.refreshWithCurrentData(_this8.evalFlow, _this8.fileInfo, _this8.files, _this8.multFileEvaluationStatus);
          _this8.isUpdate = true;
          _Dispatcher["default"].trigger(MDEvents.evaluationChangedInEvaluationPanel);
        }
      });
      this.wind.show();
      e.stopPropagation();
    }
  }, {
    key: "_rejectClicked",
    value: function _rejectClicked(e) {
      var _this9 = this;
      var curUserEval = this.evalFlow.getCurrentUserEvaluation();
      if (!curUserEval) {
        console.error("*** 数据错误，没有该人的审批信息");
        // return;
      }
      this.wind = new _MDEvaluationRemarkPanel["default"]({
        evalType: "reject",
        evaluationInfo: curUserEval,
        fileInfo: this.fileInfo,
        files: this.files,
        isUpdate: this.isUpdate,
        doneSuccess: function doneSuccess(obj) {
          curUserEval.setEvaluationId(obj.fileEvaluationId);
          curUserEval.setComment(obj.comment);
          curUserEval.setEvaluation(obj.evaluation, {
            silent: true
          });
          if (_this9.evalFlow.isCurStepAllEvaluationWithNot()) {
            _this9.fileInfo.setEvaluationStatus(_MDEvaluationStatus["default"].REJECTED);
            _this9.fileInfo.setCurrentVersionEvaluation(_MDEvaluationStatus["default"].REJECTED);
          }
          _this9.refreshWithCurrentData(_this9.evalFlow, _this9.fileInfo, _this9.files, _this9.multFileEvaluationStatus);
          _this9.isUpdate = true;
          _Dispatcher["default"].trigger(MDEvents.evaluationChangedInEvaluationPanel);
        }
      });
      this.wind.show();
      e.stopPropagation();
    }
  }, {
    key: "_reEvalClicked",
    value: function _reEvalClicked(e) {
      this.isUpdate = true;
      this.$(".eval-input").show();
      this.$(".eval-reeval").hide();
      e.stopPropagation();
    }
  }, {
    key: "_openEvalClicked",
    value: function _openEvalClicked(e) {
      var _this10 = this;
      var fid = this.fileInfo.getFileId();
      if (this.files.length) {
        MMNetDiskDataController.restartMultFileEvaluation(this.fileInfo.getEvaluationFlowId(), function () {
          _this10.evalFlow.setCurStep(0);
          _this10.fileInfo.setEvaluationStatus(_MDEvaluationStatus["default"].EVALUATING);
          _this10.fileInfo.setCurrentVersionEvaluation(_MDEvaluationStatus["default"].EVALUATING);
          _this10.$(".eval-input").hide();
          _this10.$(".eval-reeval").show();
          _this10.refreshWithCurrentData(_this10.evalFlow, _this10.fileInfo, _this10.files, _this10.multFileEvaluationStatus);
          _this10.close();
          console.log("succcess");
        }, function () {
          _MDMessageView["default"].error(BabelStr.str(7162));
        });
      } else {
        MMNetDiskDataController.restartEvaluation(fid, function () {
          _this10.evalFlow.setCurStep(0);
          _this10.fileInfo.setEvaluationStatus(_MDEvaluationStatus["default"].EVALUATING);
          _this10.fileInfo.setCurrentVersionEvaluation(_MDEvaluationStatus["default"].EVALUATING);
          _this10.$(".eval-input").hide();
          _this10.$(".eval-reeval").show();
          _this10.refreshWithCurrentData(_this10.evalFlow, _this10.fileInfo, _this10.files, _this10.multFileEvaluationStatus);
          _this10.close();
          console.log("succcess");
        }, function () {
          _MDMessageView["default"].error(BabelStr.str(7162));
        });
      }
    }
  }, {
    key: "_endEvalClicked",
    value: function _endEvalClicked(e) {
      var _this11 = this;
      var wind = new _MDEndEvalWindowView["default"]({
        fileInfo: this.fileInfo,
        onHide: function onHide(needRefresh) {
          if (needRefresh) {
            if (_this11.inEditor) {
              _this11.refreshWithCurrentData(_this11.evalFlow, _this11.fileInfo, _this11.files, _this11.multFileEvaluationStatus);
            } else {
              _this11.close();
            }
          }
        }
      });
      wind.show();

      // let fid = this.fileInfo.getFileId();
      // MMNetDiskDataController.finalizeFileEvaluaiton(fid, () => {
      //   this.fileInfo.setEvaluationStatus(MDEvaluationStatus.PASSED);
      //   this.fileInfo.setCurrentVersionEvaluation(MDEvaluationStatus.PASSED);
      //   if (this.inEditor) {
      //     this.refreshWithCurrentData(this.evalFlow, this.fileInfo)
      //   } else {
      //     this.close();
      //   }

      // }, () => {
      //   console.log("fail")
      // })
    }
  }, {
    key: "_withdrawEvalClicked",
    value: function _withdrawEvalClicked(e) {
      var _this12 = this;
      var self = this;
      this.$(".withdraw-div").addClass("show-tip");
      this.$(".eval-withdraw").addClass("did-withdraw");
      this.$(".cancel").on("click", function (e) {
        _this12.$(".withdraw-div").removeClass("show-tip");
        _this12.$(".eval-withdraw").removeClass("did-withdraw");
        _this12.$(".did-withdraw").off("click.withdraw");
        _this12.$(".cancel").off();
      });
      this.$(".did-withdraw").off("click.withdraw");
      this.$(".did-withdraw").on("click.withdraw", function (e) {
        console.log("did withdraw!");
        _this12.close();
        var fileId = _this12.fileInfo.getFileId();
        if (_this12.files.length) {
          MMNetDiskDataController.cleanFlowEvaluationStatus(_this12.fileInfo.getEvaluationFlowId(), function () {
            // if(app.pathRouter.inFile()) {
            viewManager.viewList.curFileTableView.refreshCurFolder();
            // } else {
            //   self.needRefresh = true;
            //   self.fileInfo.setEvaluationFlowId(null);
            //   self.fileInfo.setEvaluationStatus(MDEvaluationStatus.NOT_START)
            //   self.fileInfo.setCurrentVersionEvaluation(MDEvaluationStatus.NOT_START);
            //   MMNetDiskDataController.updateFileInfoFromServer(self.fileInfo);

            //   self.onWithdraw && self.onWithdraw();
            // }
          }, function () {
            _MDMessageView["default"].error(BabelStr.str(7155));
          });
        } else {
          MMNetDiskDataController.cleanFileEvaluationStatus(fileId, function () {
            self.needRefresh = true;
            self.fileInfo.setEvaluationFlowId(null);
            self.fileInfo.setEvaluationStatus(_MDEvaluationStatus["default"].NOT_START);
            self.fileInfo.setCurrentVersionEvaluation(_MDEvaluationStatus["default"].NOT_START);
            MMNetDiskDataController.updateFileInfoFromServer(self.fileInfo);
            self.onWithdraw && self.onWithdraw();
          }, function () {
            _MDMessageView["default"].error(BabelStr.str(7155));
          });
        }
      });
    }
  }, {
    key: "refreshEvalFlow",
    value: function refreshEvalFlow() {
      var _this13 = this;
      var fileId = this.fileInfo.getFileId();
      var version = this.fileInfo.getCurVersion();
      MMNetDiskDataController.getEvaluatorsGroup(fileId, version, this.fileInfo.getEvaluationFlowId(), function (evalFlow) {
        _this13.evalFlow = evalFlow;
        _this13.refreshWithCurrentData(_this13.evalFlow, _this13.fileInfo, _this13.files, _this13.multFileEvaluationStatus);
      }, function (res) {
        _MDSnackbarView["default"].show(BabelStr.str(511)); // ('获取审批信息失败')
      });
    }
  }]);
  return MDEvaluationListPanel;
}(_MDNavigationPageView2["default"]);

},{"1097":1097,"1098":1098,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1411":1411,"1412":1412,"1417":1417,"1423":1423,"1437":1437,"1454":1454,"1461":1461,"1463":1463,"1475":1475,"1477":1477,"1492":1492,"1505":1505,"1506":1506,"1507":1507,"1508":1508,"1509":1509,"1510":1510,"1512":1512,"1513":1513,"1514":1514,"1516":1516,"1517":1517,"1518":1518,"1519":1519,"1520":1520,"1521":1521,"1522":1522,"1523":1523,"1524":1524,"1525":1525,"1526":1526,"1527":1527,"1528":1528,"1529":1529,"1530":1530,"18":18,"22":22,"254":254,"330":330,"457":457,"462":462,"467":467,"469":469,"49":49,"497":497,"55":55,"56":56,"72":72,"75":75,"811":811,"812":812,"897":897}],469:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDWindowView = _interopRequireDefault(require(93));
var _MDEvaluationInfo = _interopRequireDefault(require(253));
var _MDEvaluationStatus = _interopRequireDefault(require(254));
var _MMCommonFun = _interopRequireDefault(require(812));
// MDEvaluationRemarkPanel.js
// javascript/moladisk/views/evaluation/MDEvaluationRemarkPanel.js
// jiang
// 2017-5-15

var MDEvaluationRemarkPanel = _MDWindowView["default"].extend({
  className: function className() {
    var superCls = _MDWindowView["default"].prototype.className.call(this);
    return superCls + ' eval-remark-window';
  },
  contentTmpl: '<form class="eval-remark-area" >' + '<div class="remark-title help-block"><%=keyCap%></div>' + '<textarea name="remark" class="remark-box textinput form-control" maxlength="140"></textarea>' + '</form>',
  // '<div class="eval-remark-foot">' +
  //   '<button class="cancel-remark">取消</button>'+
  //   '<button class="ok-remark">通过</button>'+
  //   '<button class="reject-remark">驳回</button>'+
  //   '<button class="close-remark">确定</button>'+
  // '</div>',

  events: function events() {
    var superE = _MDWindowView["default"].prototype.events.call(this);
    return _.extend(superE, {
      'keydown .remark-box': this._checkInput,
      'input .remark-box': this._checkInput
    });
  },
  initProps: function initProps() {
    var opt = _MDWindowView["default"].prototype.initProps.call(this);
    return _.extend(opt, {
      doneSuccess: _.noop
    });
  },
  initialize: function initialize(opt) {
    var _this = this;
    this.doneSuccess = opt.doneSuccess;
    var self = this;
    opt = _.extend({}, opt);
    var caption = BabelStr.str(427, {
      // 还可以输入<span>140</span>字
      num: '<span>140</span>'
    });
    opt.data = _.extend({
      keyCap: caption
    }, opt.data);
    opt.title = BabelStr.str(527); //  "审批结论";
    opt.width = 520;
    if ($('.app-root').length > 0) {
      opt.parent = $('body')[0]; //$('.app-root')[0];
    }
    ;
    if (opt.evalType == "pass") {
      opt.buttons = [{
        id: 'passbtn',
        type: 'pass',
        label: BabelStr.str(133),
        // '通过',
        autoClose: false,
        onClick: function onClick() {
          self._passFun();
        }
      }, {
        type: 'cancel',
        label: BabelStr.str(155),
        // '取消',
        autoClose: true
      }];
    } else if (opt.evalType == "reject") {
      opt.buttons = [{
        id: 'rejectbtn',
        type: 'reject',
        label: BabelStr.str(134),
        // '驳回',
        autoClose: false,
        onClick: function onClick() {
          self._rejectFun();
        }
      }, {
        type: 'cancel',
        label: BabelStr.str(155),
        // '取消',
        autoClose: true
      }];
    } else {
      opt.buttons = [{
        type: 'done',
        label: BabelStr.str(154),
        // '确定',
        autoClose: true,
        onClick: function onClick() {
          self._closeFun();
        }
      }];
    }
    _MDWindowView["default"].prototype.initialize.call(this, opt);

    // 测试数据
    // this.evaluationInfo = new MDEvaluationInfo();
    // this.evaluationInfo.setComment("good morning!");

    if (!opt.evalType) {
      this.$('.remark-title').remove();
      this.$('.remark-box').attr('readonly', true);
    }
    ;
    if (this.evaluationInfo) {
      this.$('.remark-box').val(this.evaluationInfo.getComment());
    }
    ;
    this._checkInput();
    setBabelTimeout(function () {
      _this.$('.remark-box').focus();
    }, 10);
    _MMCommonFun["default"].setTextInputInEditor('approvePanel');
  },
  validate: function validate() {
    var validator = this.$('form').validate();
    if (!validator.form()) {
      return false;
    }
    return true;
  },
  _passFun: function _passFun() {
    var _this2 = this;
    if (!this.validate()) {
      return;
    }
    console.log('-----------> pass');
    this.$("#passbtn").prop("disabled", true);
    this._callServerToPassOrReject(true, function (obj) {
      _this2.$("#passbtn").prop("disabled", false);
      if (_this2.doneSuccess) {
        _this2.doneSuccess(obj);
      }
      ;
      _this2.close();
    }, function () {
      _this2.$("#passbtn").prop("disabled", false);
    });
  },
  _rejectFun: function _rejectFun() {
    var _this3 = this;
    if (!this.validate()) {
      return;
    }
    console.log('-----------> reject');
    this.$("#rejectbtn").prop("disabled", true);
    this._callServerToPassOrReject(false, function (obj) {
      if (_this3.doneSuccess) {
        _this3.doneSuccess(obj);
      }
      ;
      _this3.$("#rejectbtn").prop("disabled", false);
      _this3.close();
    }, function () {
      _this3.$("#rejectbtn").prop("disabled", false);
    });
  },
  _callServerToPassOrReject: function _callServerToPassOrReject(passed, success, fail) {
    var _this4 = this;
    _czc && _czc.push(["_trackEvent", "讨论", "发送评审意见", "", "", ""]);
    var evaluation;
    if (passed) {
      evaluation = _MDEvaluationStatus["default"].PASSED;
    } else {
      evaluation = _MDEvaluationStatus["default"].REJECTED;
    }
    var commentStr = this.$(".remark-box").val();
    commentStr = commentStr;
    var obj = {
      comment: commentStr,
      evaluation: evaluation
    };
    if (this.isUpdate) {
      var fileEvaluationId = this.evaluationInfo.getEvaluationId();
      obj.fileEvaluationId = fileEvaluationId;
      if (this.files.length) {
        MMNetDiskDataController.updateMultEvaluation(fileEvaluationId, evaluation, commentStr, function () {
          console.log("成功");
          _this4.close();
          // MMNetDiskDataController.updateFileInfoFromServer(this.fileInfo);
          success(obj);
        }, function () {
          _MDSnackbarView["default"].show(BabelStr.str(168)); //("操作失败，请刷新后重试");
          fail();
        });
      } else {
        MMNetDiskDataController.updateEvaluation(fileEvaluationId, evaluation, commentStr, function () {
          console.log("成功");
          _this4.close();
          MMNetDiskDataController.updateFileInfoFromServer(_this4.fileInfo);
          success(obj);
        }, function () {
          _MDSnackbarView["default"].show(BabelStr.str(168)); //("操作失败，请刷新后重试");
          fail();
        });
      }
    } else {
      var evaluationFlowId = this.fileInfo.getEvaluationFlowId();
      var fid = this.fileInfo.getFileId();
      if (this.files.length) {
        MMNetDiskDataController.createMultiFileEvaluation(evaluationFlowId, evaluation, commentStr, function (fileEvaluationId) {
          console.log("成功");
          _this4.close();
          MMNetDiskDataController.updateFileInfoFromServer(_this4.fileInfo);
          obj.fileEvaluationId = fileEvaluationId;
          success(obj);
        }, function () {
          _MDSnackbarView["default"].show(BabelStr.str(168)); //("操作失败，请刷新后重试");
          fail();
        });
      } else {
        MMNetDiskDataController.createEvaluation(evaluationFlowId, fid, evaluation, commentStr, function (fileEvaluationId) {
          console.log("成功");
          _this4.close();
          MMNetDiskDataController.updateFileInfoFromServer(_this4.fileInfo);
          obj.fileEvaluationId = fileEvaluationId;
          success(obj);
        }, function () {
          _MDSnackbarView["default"].show(BabelStr.str(168)); //("操作失败，请刷新后重试");
          fail();
        });
      }
    }
  },
  _closeFun: function _closeFun() {
    console.log('-----------> close');
  },
  viewDidUnRendered: function viewDidUnRendered() {
    console.log('----------------> did unrendered!');
    _MDWindowView["default"].prototype.viewDidUnRendered.call(this);
    this.doneSuccess = null;
    _MMCommonFun["default"].removeTextInputInEditor('approvePanel');
  },
  _checkInput: function _checkInput(e) {
    var text = this.$('.remark-box').val();
    var leftLen = 140 - text.length;
    this.$('.remark-title span').text(leftLen);
    if (leftLen < 0) {
      this.$('.remark-title span').addClass('red');
    } else {
      this.$('.remark-title span').removeClass('red');
    }
  }
});
var _default = exports["default"] = MDEvaluationRemarkPanel;

},{"1184":1184,"1454":1454,"253":253,"254":254,"72":72,"812":812,"93":93}],467:[function(require,module,exports){
module.exports = {"content":"<ul class=\"eval-list-content\">\r\t\t<li>\r\t\t\t<span class='eval-num'>1</span>\r\t\t\t<span class='eval-name'>姓名1</span>\r\t\t\t<span class='eval-status'>待审批...</span>\r\t\t\t<span class='eval-comment'></span>\r\t\t</li>\r\t\t<li>\r\t\t\t<span class='eval-num'>2</span>\r\t\t\t<span class='eval-name'>姓名2</span>\r\t\t\t<span class='eval-status'>待审批...</span>\r\t\t\t<span class='eval-comment'></span>\r\t\t</li>\r\t\t<li>\r\t\t\t<span class='eval-num'>3</span>\r\t\t\t<span class='eval-name'>姓名3</span>\r\t\t\t<span class='eval-status'>待审批...</span>\r\t\t\t<span class='eval-comment'></span>\r\t\t</li>\r\t\t<li>\r\t\t\t<span class='eval-num'>4</span>\r\t\t\t<span class='eval-name'>姓名4</span>\r\t\t\t<span class='eval-status'>待审批...</span>\r\t\t\t<span class='eval-comment'></span>\r\t\t</li>\r\t</ul>","foot":"<!-- <div class=\"flex-align between\"> -->\r\t<button class=\"eval-open button\"><%=open%></button>\r\t<!-- <button class=\"eval-end button done\"><%=close%></button> -->\r\t<div class=\"withdraw-div flex-align between mgb-10\">\r\t\t<!-- <div class=\"line\"> -->\r\t\t\t<div class=\"tip withdraw-tip\"><%=tip%></div>\r\t\t<!-- </div> -->\r\t\t<div class=\"line\">\r\t\t\t<button class=\"eval-withdraw button done\"><%=withdraw%></button>\r\t\t\t<button class=\"did-withdraw button done withdraw-tip\"><%=withdraw%></button>\r\t\t\t<button class=\"cancel button withdraw-tip\"><%=cancel%></button>\r\t\t</div>\r\t</div>\r\t<div class=\"eval-evaluate eval-reeval\"><%=reEnter%></div>\r\t<div class=\"eval-evaluate eval-input\">\r\t\t<div class=\"eval-promt\"><%=myOpinin%>：</div>\r\t\t<button class=\"eval-pass eval-btn\"><%=ok%></button>\r\t\t<button class=\"eval-reject eval-btn\"><%=deny%></button>\r\t</div>\r<!-- </div> -->","evalItem":"<li class='<%=className%> flex-align between middle' userId='<%=userId%>' groupIndex='<%=groupIndex%>' evalIndex='<%=evalIndex%>'>\r<!-- \t<span class=\"eval-num\"><%=rowNum%></span>\r -->\r <span class='eval-name col-auto text-hide' title='<%=userName%>'><%=userName%></span>\r\t<span class='eval-status'><%=status%></span>\r\t<%if(spendsTimeStr){%>\r\t\t<span class=\"mgl-10\"><%=spendsTimeStr%></span>\r\t<%}%>\r\t<%if(status.length && comment.length){%>\r\t\t<span class='eval-comment icon' groupIndex='<%=groupIndex%>' evalIndex='<%=evalIndex%>'></span>\r\t<%}%>\r</li>\r<%if(status.length && comment.length){%>\r<li class=\"comment-item-e flex-align middle\">\r\t<%=comment%>\r</li>\r<%}%>","groupTile":"<li class='group-title <%=className%>'>\r\t<span class='group-name'><%=groupName%></span>\r\t<span class='group-status'><%=groupStatus%></span>\r</li>","comments":"<li class=\"comment-item-e flex-align middle\">\r\t<%=comments%>\r</li>","copyToUserItem":"<li class=\"copy-user-item flex-align between middle\">\r\t<span class=\"name\"><%=name%></span><span><%=copyTo%></span>\r</li>"};
},{}],462:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDEnterpriseShareTabView = _interopRequireDefault(require(675));
var _MDMolaUser = _interopRequireDefault(require(272));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDEvaluationAddPersonView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDEvaluationAddPersonView, _MDNavigationPageView);
  function MDEvaluationAddPersonView() {
    (0, _classCallCheck2["default"])(this, MDEvaluationAddPersonView);
    return _callSuper(this, MDEvaluationAddPersonView, arguments);
  }
  (0, _createClass2["default"])(MDEvaluationAddPersonView, [{
    key: "el",
    value: function el() {
      return '<div class="add-eval-person"></div>';
    }
  }, {
    key: "tmpl",
    value: function tmpl() {
      return "<div class=\"body\">\n            <div class=\"title\"><%=BabelStr.str(5171)%></div>\n            <div class=\"input-slot share-win\"></div>\n            <div class=\"foot btns-block\">\n              <button class=\"text-button done btn-rt\"><%=BabelStr.str(74)%></button>\n              <button class=\"button done btn-ok\"><%=BabelStr.str(2806)%></button>\n            </div>\n            </div>";
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      this.strClassName = 'MDEvaluationAddPersonView';
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvaluationAddPersonView.prototype), "initialize", this).call(this, props);
      this.targetUsers = null;
      var curUserId = app.currentUser.getUserId_Int();
      this.epPersonList = new _MDEnterpriseShareTabView["default"]({
        // notIncludeGuest: true,
        // inputDisabled: false,
        // hideSelectWhenInput: true,
        // needFrequentUserTab: false,
        canSelDepartment: false,
        canSelGroup: false,
        canSelRole: false,
        // isTabAbsolute: true,
        needRoleTab: this.canSelRole,
        isNeedCurUser: true,
        // isSelectOnlyInEp: true,
        onChange: function onChange(users) {
          var newUsers = [];
          var newTypes = [];
          var emails = [];
          var phones = [];
          var obj = {};
          users.each(function (user) {
            if (user.participantId()) {
              newUsers.push(user.participantId());
            } else if (user.originalEmail()) {
              emails.push(user.originalEmail());
            } else if (user.phone()) {
              phones.push(user.phone());
            }
          });
          obj.users = newUsers;
          obj.emails = emails;
          obj.phones = phones;
          _this.targetUsers = obj;
        },
        beforeSelect: function beforeSelect(user) {
          var uid = user.participantId();
          // if (user.participantType() == 0 && uid == curUserId) {
          //   MDMessageView.error(BabelStr.str(5168), this.$el);
          //   return false;
          // } else {
          var found = false;
          for (var i = 0; i < _this.oldUserIds.length; i++) {
            var oldId = _this.oldUserIds[i];
            if (oldId == uid) {
              found = true;
              break;
            }
          }
          if (found) {
            MDMessageView.error(BabelStr.str(5169), _this.$el);
            return false;
          } else {
            return true;
          }
          // }
        }
      });
      this.addSubView(this.epPersonList, this.$(".input-slot")[0]);
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvaluationAddPersonView.prototype), "initProps", this).call(this);
      return _.extend(superP, {});
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvaluationAddPersonView.prototype), "events", this).call(this);
      return _.extend(superE, {
        // 'click #select1 li:last-child': this.aboutPermission,
        'click .btn-rt': this._return,
        'click .btn-ok': this._ok
      });
    }
  }, {
    key: "_return",
    value: function _return(e) {
      this.navigationView.pop();
    }
  }, {
    key: "_ok",
    value: function _ok(e) {
      if (!this.targetUsers) {
        return;
      }
      // var userIds = [];
      // var userInfos = [];
      // for (let i = 0; i < this.targetUsers.length; i++) {
      //   const user = this.targetUsers.at(i);
      //   if (user.get("participantId")) {
      //     userIds.push(user.get("participantId"));
      //     userInfos.push(new MDMolaUser({
      //       id: user.get("participantId"),
      //       name: user.get("name"),
      //       email: user.get("mail"),
      //     }))
      //   }
      // }
      // var contact = this.epPersonList.getTargetEmails();
      this.navigationView.pop();
      if (this.personAdded) {
        this.personAdded(this.targetUsers);
      }
    }
  }]);
  return MDEvaluationAddPersonView;
}(_MDNavigationPageView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"272":272,"56":56,"675":675}],461:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDEnterpriseShareTabView = _interopRequireDefault(require(675));
var _MMCommentDataController = _interopRequireDefault(require(1097));
var _MDEvalOpInfoView = _interopRequireDefault(require(323));
var _MDSpinnerloaderLayerView = _interopRequireDefault(require(75));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } //
// WebContent/javascript/moladisk/views/evaluation/MDEvalOpinionListPage.js
//  展示审批意见的处理列表
// jiang
// 2019-3-8
//
var MDEvalOpinionListPage = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDEvalOpinionListPage, _MDNavigationPageView);
  function MDEvalOpinionListPage() {
    (0, _classCallCheck2["default"])(this, MDEvalOpinionListPage);
    return _callSuper(this, MDEvalOpinionListPage, arguments);
  }
  (0, _createClass2["default"])(MDEvalOpinionListPage, [{
    key: "el",
    value: function el() {
      return '<div class="eval-opinion"></div>';
    }
  }, {
    key: "tmpl",
    value: function tmpl() {
      return "<div class=\"body\">\n            <div class=\"title float-l\"><%=title%></div>\n            <div class=\"content\"></div>\n            <div class=\"foot\">\n              <button class=\"text-button done btn-rt\"><%=BabelStr.str(74)%></button>\n            </div>\n            </div>";
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      this.strClassName = 'MDEvalOpinionListPage';
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvalOpinionListPage.prototype), "initialize", this).call(this, props);
      _MDSpinnerloaderLayerView["default"].showIn(this.$el[0]);
      var fileId = this.fileInfo.getFileId();
      this.isCurUserCreator = this.evalFlow.isCurUserCreator();
      _MMCommentDataController["default"].getFileCommentInfos(fileId, function (commentInfos) {
        var out = [];
        var i;
        for (i = 0; i < commentInfos.length; i++) {
          var info = commentInfos[i];
          // if (info.visibleScope >= 8) {
          out.push(info);
          // };
        }
        ;
        _MDSpinnerloaderLayerView["default"].clearFrom(_this.$el[0]);
        _this._renderOpinions(out);
      }, function () {
        _MDSpinnerloaderLayerView["default"].clearFrom(_this.$el[0]);
        _this._renderOpinions([]);
      });
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvalOpinionListPage.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        data: {
          'title': BabelStr.str(813) // 审批意见列表
        }
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvalOpinionListPage.prototype), "events", this).call(this);
      return _.extend(superE, {
        // 'click #select1 li:last-child': this.aboutPermission,
        'click .btn-rt': this._return
      });
    }
  }, {
    key: "_return",
    value: function _return(e) {
      this.navigationView.pop();
    }
  }, {
    key: "_renderOpinions",
    value: function _renderOpinions(opinions) {
      var curVer = this.fileInfo.getCurVersion();
      this.$('.content').empty();
      if (!opinions || opinions.length == 0) {
        this.$('.content').append('<div class="empty">' + BabelStr.str(7158) + ' </div>');
        return;
      }
      var htmlStr = '';
      var vername = BabelStr.str(5165);
      // var ver = opinions[opinions.length - 1].version;
      var ver = -1;
      var $listBody;
      for (var i = 0; i < opinions.length; i++) {
        var opinion = opinions[i];

        // -----------------------------------------------  显示版本信息
        var htmlStr;
        var v = opinion.version;
        if (v != ver) {
          ver = v;
          var verStr;
          if (v == curVer) {
            verStr = BabelStr.str(5166);
          } else {
            verStr = BabelStr.str(5167, {
              v: v + 1
            });
          }
          htmlStr = '<div class="eval-ver">' + verStr + '</div>';
          $listBody = $('<ul class="opnion-list-body"></ul>');
          this.$('.content').append($(htmlStr));
          this.$('.content').append($listBody);
        }

        // --------------------------------------------- 显示一条审批意见
        var opinionItem = new _MDEvalOpInfoView["default"]({
          opinion: opinion,
          evalFlow: this.evalFlow,
          fileInfo: this.fileInfo
        });
        this.addSubView(opinionItem, $listBody);
      }
    }
  }]);
  return MDEvalOpinionListPage;
}(_MDNavigationPageView2["default"]);

},{"1097":1097,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"323":323,"56":56,"675":675,"75":75}],323:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1466);
require(1463);
require(1478);
require(1461);
var _MDLocalString = _interopRequireDefault(require(1150));
var _ObjVisibleScope = _interopRequireDefault(require(1085));
var _MMViewBase = _interopRequireDefault(require(22));
var _MDEvents = _interopRequireDefault(require(325));
var _CommentStatus = _interopRequireDefault(require(1036));
var _app = _interopRequireDefault(require(17));
var _MDAudioPlayer = _interopRequireDefault(require(313));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MMObjOperationStrategy = _interopRequireDefault(require(872));
var _MMOperationType = _interopRequireDefault(require(882));
var _MDCommonListPopupView = _interopRequireDefault(require(62));
var _MDCommentActionManager = _interopRequireDefault(require(5));
/**
 *  批注列表中的一项.
 *  WebContent/javascript/moladisk/common/MDEvalOpInfoView.js
 *  Create by jiang
 *  2014.12.30
 */

var MDEvalOpInfoView = _MMViewBase["default"].extend({
  el: "<li></li>",
  tmpl: '<div class="comment-info">' + '<img class="userAvatar _user-profile-picture f-round"/>' + '<div class="readStatus"></div>' + '<div class="commentInfo">' + '<div class="f-clb">' + '<div class="username"></div>' + '<div class="time"></div>' + "</div>" + '<div class="firstText"></div>' + "</div>" + '<div class="check-zone">' + '<div class="eval-status"></div>' + "</div>" + "</div>" + "",
  render: function render() {
    var data = {
      delCap: _MDLocalString["default"].getLocalString(32) // 删除
    };
    _MMViewBase["default"].prototype.render.call(this, data);
  },
  className: function className() {
    var superCls = _MMViewBase["default"].prototype.className.call(this);
    return superCls + " comment-item";
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      comment: null
    });
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      "click .eval-status": this.changeStatusHandler,
      "click .commentInfo": this.click2ShowComment
    });
  },
  initialize: function initialize(options) {
    var self = this;
    _MMViewBase["default"].prototype.initialize.call(this, options);
    this.$username = this.$(".username");
    this.$answerCount = this.$(".answerCount");
    this.$firstText = this.$(".firstText");
    this.$userAvatar = this.$(".userAvatar");
    this.$statusDott = this.$(".statusDott");
    this.$time = this.$(".time");
    this.update();
    var editorViewCtl = this.editorViewCtl;
    var curFile = this.fileInfo;
    var commentCreatorId = this.opinion.creator;
    var strategy = _MMObjOperationStrategy["default"].getOperationTypeForComment(this.opinion, commentCreatorId, this.fileInfo);
    if (curFile != this.fileInfo || strategy != _MMOperationType["default"].Operation_editable || _app["default"].pathRouter.inTrash()) {
      this.$(".delete-btn").remove();
    }
  },
  clickHandler: function clickHandler($e) {
    this.editorViewCtl.refreshCurrentMainEditor();
    Dispatcher.trigger(_MDEvents["default"].SHOW_COMMENTS);
    _MDPcMobileEditorCommonFun["default"].UIActions.openComment(this.fileInfo, this.opinion.id);
    this.trigger(_MDEvents["default"].CLICK, this);
    this.$(".readStatus").css("opacity", 0);
  },
  click2ShowComment: function click2ShowComment() {
    _app["default"].pathRouter.openNetTab("/main.do##file/" + this.fileInfo.getFileId() + "/v/" + this.opinion.version);
  },
  update: function update() {
    var $readStatus = this.$(".readStatus");
    var opacity = "1";
    var data = this.fetchData();
    if (!data) return;
    this.data = data;
    this.$username.html(data.username);
    this.$username.attr("title", data.username.length > 10 ? data.username : "");
    this.$answerCount.text(data.answerCount + " reply");
    if (data.time > 0) {
      this.$time.html(new Date(parseInt(data.time.toString())).toRelativeTimeDOMObj());
    }
    this.$firstText.html(data.firstText);
    switch (data.readStatus) {
      case _CommentStatus["default"].Comment_unread:
        break;
      case _CommentStatus["default"].Comment_read:
        opacity = "0";
        break;
      case _CommentStatus["default"].Comment_newReply:
        break;
    }
    $readStatus.css("opacity", opacity);
    _app["default"].setAvatarImage(this.$userAvatar, data.userId, 80, true);
    var status = data.completed;
    if (!this.evalFlow.isCurUserCreator()) {
      if (status == 2) {
        this.$(".eval-status").addClass("green");
      } else if (status == 3) {
        this.$(".eval-status").addClass("red");
      } else {
        this.$(".eval-status").addClass("gray");
      }
    } else if (this.evalFlow.isCurUserCreator() && !this.fileInfo.isPassed()) {
      this.$(".eval-status").addClass("done text-button");
    }
    this._refreshStatusText(status);
  },
  _refreshStatusText: function _refreshStatusText(status) {
    var str = BabelStr.str(812);
    if (status == 2) {
      str = BabelStr.str(807);
    } else if (status == 3) {
      str = BabelStr.str(808);
    }
    this.$(".eval-status").text(str);
  },
  fetchData: function fetchData() {
    //todo: read data from commentObj
    return this._fetchCommentData();
  },
  _fetchNiceTagData: function _fetchNiceTagData() {
    var messageDisplay = this.opinion.getLabel();
    var uid = this.opinion.getCreator();
    if (uid !== -1) {
      uid = uid.toDecString();
    }
    var out = {
      username: BabelStr.str(7059),
      firstText: messageDisplay,
      answerCount: 0,
      readStatus: _CommentStatus["default"].Comment_read,
      completed: true,
      userId: uid,
      time: 0
    };
    return out;
  },
  _fetchCommentData: function _fetchCommentData() {
    var message = null;
    try {
      message = JSON.parse(this.opinion.message);
    } catch (e) {
      return null;
    }
    var messageDisplay;
    if (message["Type"] == "Audio") {
      var audioUrl = MMCommonFun.getRemoteDURL(this.fileInfo.getCreatorId(), this.fileInfo.getFileId(), message["Url"]);
      messageDisplay = _MDAudioPlayer["default"].getAudioPlayer(audioUrl, message["Body"], "", true); // true to get a prototype
    } else if (message["Type"] == "Text") {
      messageDisplay = message["Body"];
    } else if (message["Type"] == "Mark") {
      messageDisplay = message["Text"] || "";
      if (messageDisplay.length == 0) messageDisplay = BabelStr.str(7060);
    } else if (message["Type"] == "File") {
      messageDisplay = message["Text"] || "";
      if (messageDisplay.length == 0) messageDisplay = BabelStr.str(7061);
    }

    // var readStatus = this.opinion.getReadStatus(app.currentUser.getUserId_Int());
    var readStatus = _CommentStatus["default"].Comment_read;
    if (this.opinion.unreadedCount > 0) {
      readStatus = _CommentStatus["default"].Comment_unread;
    }
    var uid = this.opinion.creator;
    var out = {
      username: this.opinion.creatorName,
      firstText: messageDisplay,
      answerCount: 0,
      readStatus: readStatus,
      completed: this.opinion.completed,
      userId: this.opinion.creator,
      time: this.opinion.createTime,
      visibleScope: this.opinion.visibleScope
    };
    return out;
  },
  changeStatusHandler: function changeStatusHandler(e) {
    var _this = this;
    if (this.fileInfo.isPassed()) {
      return;
    }
    var selIndex = this.opinion.completed - 2;
    if (this.evalFlow.isCurUserCreator()) {
      var $bt = $(e.target);
      _MDCommonListPopupView["default"].show({
        triggerView: $bt,
        items: [BabelStr.str(7064), BabelStr.str(342)],
        selIndex: selIndex,
        onItemClicked: function onItemClicked(index) {
          var val = index + 2;
          if (_this.opinion.completed != val) {
            var fileId = _this.fileInfo.getFileId();
            var id = _this.opinion.id;
            _MDCommentActionManager["default"].setEvalStatus(fileId, id, val, function () {
              _MDSnackbarView["default"].show(BabelStr.str(308));
              _this.opinion.completed = val;
              _this._refreshStatusText(val);
            }, function () {
              _MDSnackbarView["default"].show(BabelStr.str(168));
            });
          }
        }
      });
    }
  }
});
var _default = exports["default"] = MDEvalOpInfoView;

},{"1036":1036,"1085":1085,"1150":1150,"1184":1184,"1437":1437,"1454":1454,"1461":1461,"1463":1463,"1466":1466,"1478":1478,"17":17,"22":22,"313":313,"325":325,"5":5,"62":62,"72":72,"807":807,"872":872,"882":882}],460:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDFileInfoShowView = _interopRequireDefault(require(497));
var _MDSpinnerloaderLayerView = _interopRequireDefault(require(75));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } //
//
var MDEvalFileListPage = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDEvalFileListPage, _MDNavigationPageView);
  function MDEvalFileListPage() {
    (0, _classCallCheck2["default"])(this, MDEvalFileListPage);
    return _callSuper(this, MDEvalFileListPage, arguments);
  }
  (0, _createClass2["default"])(MDEvalFileListPage, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n            <div class=\"content multFile-list-block pd-15\"></div>\n            <div class=\"foot\">\n              <button class=\"text-button done btn-rt\"><%=BabelStr.str(74)%></button>\n            </div>";
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      this.strClassName = 'MDEvalFileListPage';
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvalFileListPage.prototype), "initialize", this).call(this, props);
      for (var i = 0; i < this.files.length; i++) {
        var fileInfoView = new _MDFileInfoShowView["default"]({
          fileInfo: this.files[i],
          onClick: function onClick(fileInfo) {
            var fid = fileInfo.getFileId();
            app.pathRouter.openNewTabByFileId(fid);
          }
        });
        this.addSubView(fileInfoView, this.$('.content')[0]);
      }
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvalFileListPage.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        files: []
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvalFileListPage.prototype), "events", this).call(this);
      return _.extend(superE, {
        // 'click #select1 li:last-child': this.aboutPermission,
        'click .btn-rt': this._return
      });
    }
  }, {
    key: "_return",
    value: function _return(e) {
      this.navigationView.pop();
    }
  }]);
  return MDEvalFileListPage;
}(_MDNavigationPageView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"497":497,"56":56,"75":75}],457:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDEndEvalWindowViewTpl = _interopRequireDefault(require(458));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDEvaluationStatus = _interopRequireDefault(require(254));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 * 关闭审批的选择窗口
 * Created by jiang
 * 2017.6.5
 */
var MDEndEvalWindowView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDEndEvalWindowView, _MDWindowView);
  function MDEndEvalWindowView() {
    (0, _classCallCheck2["default"])(this, MDEndEvalWindowView);
    return _callSuper(this, MDEndEvalWindowView, arguments);
  }
  (0, _createClass2["default"])(MDEndEvalWindowView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return _MDEndEvalWindowViewTpl["default"];
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEndEvalWindowView.prototype), "className", this).call(this);
      return "".concat(superCls, " m-outer-person-win end-eval-win");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEndEvalWindowView.prototype), "initProps", this).call(this);
      return _.extend(superP, {});
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEndEvalWindowView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .eval-opt': this.optClicked
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.title = BabelStr.str(524);
      props.width = 420;
      props.buttonsAlign = 'right';
      props.buttons = [{
        label: BabelStr.str(3081)
      }, {
        label: BabelStr.str(524),
        type: 'done',
        autoClose: false,
        onClick: function onClick() {
          _this.stopEvaluation();
        }
      }];
      if ($('.app-root').length > 0) {
        props.parent = $('body')[0]; //$('.app-root')[0];
      }
      ;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEndEvalWindowView.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "optClicked",
    value: function optClicked(e) {
      $(e.currentTarget).find('input')[0].checked = true;
    }
  }, {
    key: "stopEvaluation",
    value: function stopEvaluation() {
      var $input = this.$('.end-val-win input');
      var selected = 0;
      for (var i = 0; i < $input.length; i++) {
        if ($input[i].checked) {
          selected = i;
          break;
        }
        ;
      }
      ;
      var fileId = this.fileInfo.getFileId();
      var self = this;
      this.needRefresh = false;
      switch (selected) {
        case 0:
          //定稿
          MMNetDiskDataController.passTheFileEvaluation(fileId, function () {
            self.needRefresh = true;
            self.fileInfo.setEvaluationStatus(_MDEvaluationStatus["default"].PASSED);
            self.fileInfo.setCurrentVersionEvaluation(_MDEvaluationStatus["default"].PASSED);
            MMNetDiskDataController.updateFileInfoFromServer(self.fileInfo);
            self.close();
          }, function () {
            _MDMessageView["default"].error(BabelStr.str(7155));
          });
          break;
        case 1:
          //驳回
          MMNetDiskDataController.rejectTheFileEvaluation(fileId, function () {
            self.needRefresh = true;
            self.fileInfo.setEvaluationStatus(_MDEvaluationStatus["default"].REJECTED);
            self.fileInfo.setCurrentVersionEvaluation(_MDEvaluationStatus["default"].REJECTED);
            MMNetDiskDataController.updateFileInfoFromServer(self.fileInfo);
            self.close();
          }, function () {
            _MDMessageView["default"].error(BabelStr.str(7155));
          });
          break;
        case 2:
          //删除评审信息
          MMNetDiskDataController.deleteEvaluationRecordForFile(fileId, function () {
            self.needRefresh = true;
            self.fileInfo.setEvaluationStatus(_MDEvaluationStatus["default"].NOT_START);
            self.fileInfo.setCurrentVersionEvaluation(_MDEvaluationStatus["default"].NOT_START);
            MMNetDiskDataController.updateFileInfoFromServer(self.fileInfo);
            self.close();
          }, function () {
            _MDMessageView["default"].error(BabelStr.str(7155));
          });
      }
    }
  }, {
    key: "close",
    value: function close() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEndEvalWindowView.prototype), "close", this).call(this);
      if (this.onHide) {
        this.onHide(this.needRefresh);
        this.onHide = null;
      }
      ;
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MDEndEvalWindowView';
    }
  }]);
  return MDEndEvalWindowView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1417":1417,"1454":1454,"1463":1463,"1475":1475,"254":254,"458":458,"55":55,"93":93}],458:[function(require,module,exports){
module.exports = '<div class="end-val-win">\	<div class="end-val-title"><%=BabelStr.str(7156)%></div>\	<div class="end-val-line" >\		<div class="eval-opt">\  		<input type="radio" name="endType" value="0" checked="true" /> <span><%=BabelStr.str(433)%></span>\  	</div>\	</div>\	<div class="end-val-line">\		<div class="eval-opt">\ 	 		<input type="radio" name="endType" value="1" /> <%=BabelStr.str(134)%><br />\ 	 	</div>\	</div>\	<div class="end-val-line">\		<div class="eval-opt">\	 	 <input type="radio" name="endType" value="2" /> <%=BabelStr.str(7157)%>)<br />\		</div>\	</div>\</div>';
},{}],437:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
var _MMViewBase = _interopRequireDefault(require(22));
var _MMBasicData = _interopRequireDefault(require(811));
/**
 * 	display vedio
 *  Created by jiang
 *
 */

var MDVideoPlayerWin = _MMViewBase["default"].extend({
  el: '<div class="g-video-root">' + '<div class="g-video-container">' + '<video width="400" controls>' + '<source src="" type="video/mp4">' + 'Your browser does not support HTML5 video.' + '</video>' + '<button class="icon closeBtn"></button>' + '</div>' + '</div>',
  events: function events() {
    var events = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(events, {
      'click .closeBtn': this.close,
      'mousedown .g-video-container': this.mousedown,
      'mousemove .g-video-container': this.mousemove,
      'mouseup .g-video-container': this.mouseup
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    var z_maxIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
    this.$el.css('z-index', z_maxIndex);
    this.$el.find('video').on('loadeddata', function () {
      var $c = self.$el.find('.g-video-container');
      var $v = self.$el.find('video');
      var w = $v.width();
      var h = $v.height();
      console.log('------------ videl loaded, w:', w, ' h :', h);

      // $c.css('width', w);
    });
    $('body').append(this.$el);
    this.$container = this.$el.find('.g-video-container');
    $('.g-video-root').on('mousemove', function (e) {
      self.mousemove(e);
    });
    $('.g-video-root').on('mouseup', function (e) {
      self.mouseup(e);
    });
  },
  setFileInfo: function setFileInfo(fileInfo) {
    this.fileInfo = fileInfo;
    var self = this;
    MMCommonFun.getDownloadRealPath(fileInfo.getFileId(), fileInfo.getCurVersion(), function (url) {
      self.$el.find('source').attr('src', url);
      self.$el.find('source').attr('type', fileInfo.getMediaType());
      self.$el.find('video')[0].load();
      self.$el.find('video')[0].play();
    });
  },
  close: function close() {
    this.$el.remove();
  },
  mousedown: function mousedown(e) {
    this.down = true;
    this.x = e.clientX;
    this.y = e.clientY;
  },
  mousemove: function mousemove(e) {
    if (this.down) {
      var left = this.$container[0].offsetLeft;
      var top = this.$container[0].offsetTop;
      var x = e.clientX;
      var y = e.clientY;
      var dx = x - this.x;
      var dy = y - this.y;
      left += dx;
      top += dy;
      this.$container.css('left', left + 'px');
      this.$container.css('top', top + 'px');

      // this.$container.css('transform', 'translate(0px, 0px)');
      this.x = x;
      this.y = y;
    }
    ;
  },
  mouseup: function mouseup(e) {
    this.down = false;
  }
});
var _default = exports["default"] = MDVideoPlayerWin;

},{"1184":1184,"1417":1417,"1454":1454,"1463":1463,"22":22,"811":811}],407:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
var _MMViewBase = _interopRequireDefault(require(22));
var _MDMousemoveDivMaker = _interopRequireDefault(require(332));
var _MMBasicData = _interopRequireDefault(require(811));
/**
 *  display vedio
 *  Created by jiang
 *
 */

var MDAudioPlayerWin = _MMViewBase["default"].extend({
  el: '<div class="g-audio-root">' + '<button class="icon moveBtn"></button>' + '<audio width="200" controls>' + '<source src="av/Misty Mountains.mp3" type="audio/mp3">' + 'Your browser does not support HTML5 audio.' + '</audio>' + '<button class="icon closeBtn"></button>' + '</div>',
  events: function events() {
    var events = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(events, {
      'click .closeBtn': this.close
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    var z_maxIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
    this.$el.css('z-index', z_maxIndex);
    this.$el.find('audio').on('loadeddata', function () {
      console.log('------------ audio loaded');
    });
    $('body').append(this.$el);
    this.$container = this.$el.find('.g-audio-container');
    _MDMousemoveDivMaker["default"].makeMouseMovable($('.g-audio-root'));
  },
  setFileInfo: function setFileInfo(fileInfo) {
    this.fileInfo = fileInfo;
    var self = this;
    MMCommonFun.getDownloadRealPath(fileInfo.getFileId(), fileInfo.getCurVersion(), function (url) {
      self.$el.find('source').attr('src', url);
      self.$el.find('source').attr('type', fileInfo.getMediaType());
      self.$el.find('audio')[0].load();
      self.$el.find('audio')[0].play();
    });
  },
  close: function close() {
    this.$el.remove();
    MDAudioPlayerWin.close();
  }
}, {
  className: 'MDAudioPlayerWin',
  instance: null,
  getInstance: function getInstance() {
    if (MDAudioPlayerWin.instance == null) {
      MDAudioPlayerWin.instance = new MDAudioPlayerWin();
    }
    return MDAudioPlayerWin.instance;
  },
  close: function close() {
    MDAudioPlayerWin.instance = null;
  }
});
var _default = exports["default"] = MDAudioPlayerWin;

},{"1184":1184,"1417":1417,"1454":1454,"1463":1463,"22":22,"332":332,"811":811}],332:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * 	display vedio
 *  Created by jiang
 *
 */

var MDMousemoveDivMaker = {
  $div: null,
  listenBody: function listenBody() {
    $('body').on('mousemove', function (e) {
      MDMousemoveDivMaker.mousemove(e);
    });
    $('body').on('mouseup', function (e) {
      MDMousemoveDivMaker.mouseup(e);
    });
  },
  makeMouseMovable: function makeMouseMovable($div) {
    $div.on('mousedown', function (e) {
      MDMousemoveDivMaker.$div = $(e.currentTarget);
      MDMousemoveDivMaker.x = e.clientX;
      MDMousemoveDivMaker.y = e.clientY;
    });
    $div.on('mousemove', function (e) {
      MDMousemoveDivMaker.mousemove(e);
    });
    $div.on('mouseup', function (e) {
      MDMousemoveDivMaker.mouseup(e);
    });
  },
  mousemove: function mousemove(e) {
    if (MDMousemoveDivMaker.$div) {
      var left = MDMousemoveDivMaker.$div[0].offsetLeft;
      var top = MDMousemoveDivMaker.$div[0].offsetTop;
      var x = e.clientX;
      var y = e.clientY;
      var dx = x - MDMousemoveDivMaker.x;
      var dy = y - MDMousemoveDivMaker.y;
      left += dx;
      top += dy;
      MDMousemoveDivMaker.$div.css('right', 'auto');
      MDMousemoveDivMaker.$div.css('bottom', 'auto');
      MDMousemoveDivMaker.$div.css('left', left + 'px');
      MDMousemoveDivMaker.$div.css('top', top + 'px');

      // this.$container.css('transform', 'translate(0px, 0px)');
      MDMousemoveDivMaker.x = x;
      MDMousemoveDivMaker.y = y;
    }
  },
  mouseup: function mouseup(e) {
    MDMousemoveDivMaker.$div = null;
  }
};
MDMousemoveDivMaker.listenBody();
var _default = exports["default"] = MDMousemoveDivMaker;

},{"1454":1454}],718:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1418);
require(1463);
require(1537);
require(1417);
var _MMViewBase = _interopRequireDefault(require(22));
var _MDParticipantInfoPopupView = _interopRequireDefault(require(425));
var _MMBasicData = _interopRequireDefault(require(811));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _popupPos = _interopRequireDefault(require(65));
/*jslint browser: true*/
/*global $, MMNetDiskDataController, goog, MMViewBase,MDMolaUserCollection */

/**
 * Participant list view
 * Created by Tobias
 * 2015.11.23
 */

var MDConversationParticipantListView = _MMViewBase["default"].extend({
  el: '<div class="g-cvstParticipantList" style="overflow:hidden;"></div>',
  tmpl: '<ul class="g-participantList" style=""></ul>',
  events: function events() {
    var superEvents = _MMViewBase["default"].prototype.events.call(this);
    return _.extend({}, superEvents, {
      'mousedown .m-ptcp': this._avatarClicked
    });
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      fileInfo: null,
      participants: new _MDMolaUserCollection["default"]()
    });
  },
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this);
    this.fileInfo = opt.fileInfo;
    this.$participantList = this.$(".g-participantList");
    this._addScrollEvent();
  },
  _addScrollEvent: function _addScrollEvent() {
    var self = this;
    this.$el.on("mousemove", function (e) {
      var listHeight = self.$participantList.height();
      var areaHeight = self.$el.height();
      var difference = self.$el.offset().top - $(e.target).offset().top;
      var Yposition = e.offsetY - difference;
      if (areaHeight >= listHeight) {
        self.$participantList.css("top", "0px");
        return;
      }
      var scrollHeight = listHeight - areaHeight;
      var scrollPosRelative = Yposition / areaHeight;
      var newScrollPos = scrollHeight * scrollPosRelative;
      self.$participantList.css("top", "-" + newScrollPos + "px");
    });
  },
  setFileInfo: function setFileInfo(newFileInfo) {
    if (this.fileInfo === newFileInfo) {
      return;
    }
    this.fileInfo = newFileInfo;
    this.refresh();
  },
  refresh: function refresh() {
    var self = this;
    this.$participantList.html("");
    if (this.fileInfo) {
      var fileInfo = this.fileInfo;
      MMNetDiskDataController.getConversationParticipants(this.fileInfo, function success(participants) {
        if (fileInfo === self.fileInfo) {
          self.participants = participants;
          self.participants.forEach(function (userInfo) {
            var imageURL = userInfo.getAvatarImageURL(80, true);
            var name = userInfo.get('name');
            name = _.escape(name);
            var $el = $('<li class="m-ptcp" usrId="' + userInfo.getUserId() + '">' + '<img class="avatar" src="' + imageURL + '" data-tooltip="' + name + '" data-tooltip-dir="left" >' + '</li>');
            self.$participantList.append($el);
          });
        }
      }, function fail() {});
    }
  },
  _avatarClicked: function _avatarClicked(e) {
    var $target = $(e.currentTarget);
    var usrId = $target.attr('usrId');
    var self = this;
    var targetUserInfor = this.participants.find(function (userInfo) {
      return userInfo.getUserId() == usrId;
    });
    if (this.targetUserInfor && this.targetUserInfor == targetUserInfor) {
      if (this.participantInfoView) {
        this.participantInfoView.close();
      }
      return;
    }
    if (this.participantInfoView) {
      this.participantInfoView.close();
    }
    if (this.targetUserInfor != targetUserInfor) {
      this.participantInfoView = new _MDParticipantInfoPopupView["default"]({
        avatar: targetUserInfor.getAvatarImageURL(60, true),
        name: targetUserInfor.get('name'),
        mail: targetUserInfor.getEmail(),
        phone: targetUserInfor.get('phone'),
        guest: targetUserInfor.get('guest'),
        userId: usrId,
        folderId: this.fileInfo.getFileId(),
        depId: this.fileInfo.get('departmentId'),
        isProject: this.fileInfo.isProject()
      });
      this.participantInfoView.show({
        triggerView: e.currentTarget,
        center: true,
        width: 280,
        hasArrow: true,
        direction: _popupPos["default"].LEFT,
        onClose: function onClose() {
          self.targetUserInfor = null;
          self.participantInfoView = null;
        }
      });
    }
    this.targetUserInfor = targetUserInfor;
  }
});
var _default = exports["default"] = MDConversationParticipantListView;

},{"1184":1184,"1417":1417,"1418":1418,"1454":1454,"1463":1463,"1537":1537,"22":22,"273":273,"425":425,"65":65,"811":811}],425:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1439);
var _MDPopupView = _interopRequireDefault(require(64));
var _MDFilesUploadedByUserPopupWin = _interopRequireDefault(require(711));
var _MDLocalString = _interopRequireDefault(require(1150));
/**
 *  Menu for zoom choices
 *  javascript/moladisk/views/editor/MDParticipantInfoPopupView.js
 *  Create by jiang
 *  2015.9.15
 */

var MDParticipantInfoPopupView = _MDPopupView["default"].extend({
  contentTmpl: "<div class=\"participant-infor-root\">\n      <img class=\"part-avatar _user-profile-picture show-upload\" data-tooltip=\"<%=toolTip%>\"></img>\n      <div class=\"part-right\">\n        <div class=\"part-name\"></div>\n        <div class=\"part-mail\"></div>\n        <div class=\"part-phone\"></div>\n      </div>\n    </div>",
  initProps: function initProps() {
    var superP = _MDPopupView["default"].prototype.initProps.call(this);
    var tip = "";
    if (app.isEpVersion()) {
      tip = BabelStr.str(3400);
    } else {
      tip = BabelStr.str(3401);
    }
    return _.extend(superP, {
      data: {
        toolTip: tip
      }
    });
  },
  events: function events() {
    var superE = _MDPopupView["default"].prototype.events.call(this);
    return _.extend(superE, {
      "click .show-upload": this._showUploadListWin
    });
  },
  initialize: function initialize(opt) {
    _MDPopupView["default"].prototype.initialize.call(this, opt);
    if (this.isProject) {
      var str = BabelStr.str(3403);
      this.$(".show-upload").attr("data-tooltip", str);
    }
    this.avatar = opt.avatar;
    this.name = opt.name;
    this.mail = opt.mail;
    this.phone = opt.phone ? opt.phone : "";
    this._initPanel();
  },
  _initPanel: function _initPanel() {
    var phone = this.phone ? this.phone : "--";
    this.$(".part-avatar").attr("src", this.avatar);
    this.$(".part-name").html(this.name);
    this.$(".part-mail").text(BabelStr.str(3030) + ": " + this.mail);
    this.$(".part-phone").text(BabelStr.str(7148) + ": " + phone);
  },
  _showUploadListWin: function _showUploadListWin() {
    // this.close();
    _MDFilesUploadedByUserPopupWin["default"].show({
      userId: this.userId,
      folderId: this.folderId,
      depId: this.depId,
      userName: this.name
    });
  }
});
var _default = exports["default"] = MDParticipantInfoPopupView;

},{"1150":1150,"1184":1184,"1439":1439,"1454":1454,"64":64,"711":711}],476:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDWindowView = _interopRequireDefault(require(93));
var _MDAddTeamMemberPanelView = _interopRequireDefault(require(737));
var MDAddTeamMemberWindowView = _MDWindowView["default"].extend({
  initialize: function initialize(opt) {
    var self = this;
    opt.title = BabelStr.str(7196);
    opt.width = 600;
    opt.showFooter = false;
    _MDWindowView["default"].prototype.initialize.call(this, opt);
    this.addMemberPanelView = new _MDAddTeamMemberPanelView["default"]({
      teamId: this.teamId,
      onSuccessSendInvitation: function onSuccessSendInvitation(memberInfos) {
        self.close();
      },
      onCancel: function onCancel() {
        self.close();
      }
    });
    this.addSubView(this.addMemberPanelView);
  }
});
var _default = exports["default"] = MDAddTeamMemberWindowView;

},{"1184":1184,"1454":1454,"737":737,"93":93}],737:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require(1180));
require(1436);
require(1546);
require(1415);
require(1463);
require(1439);
require(1421);
require(1417);
require(1426);
var _regexp = _interopRequireDefault(require(106));
var _MMViewBase = _interopRequireDefault(require(22));
var _MDChooserView2 = _interopRequireDefault(require(38));
var _MDRoleSelectView = _interopRequireDefault(require(515));
var _MDContactCollection = _interopRequireDefault(require(244));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDTeamDataController = _interopRequireDefault(require(1094));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDSnackbarView = _interopRequireDefault(require(72));
var MDAddTeamMemberPanelView = _MMViewBase["default"].extend({
  tmpl: '<div class="loading-wrap"></div>\
          <section id="content-bk" class="block f-clb ">\
          <header class="block-hd f-clb">\
          <span class="help-inline f-fl no-margin"><%=BabelStr.str(7310)%></span>\
              <span class="f-fr help-inline no-margin" id="added"></span>\
          </header>\
          <div id="role-section-wrap" class="block-bd">\
              <div class="chooser-wrapper"></div>\
              <div id="role-slot"></div>\
          </div>\
      </section> \
      <footer class="mgt-20 text-right">\
          <button class="button default mgr-10"><%=BabelStr.str(3081)%></button><button id="sendInvBtn" class="button done"><%=BabelStr.str(3096)%></button>\
      </footer>',
  events: function events() {
    var superEvents = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superEvents, {
      'click .default': this._cancelButtonClickHandler,
      'click .done': this._sendInvitation
    });
  },
  className: function className() {
    var cls = _MMViewBase["default"].prototype.className.call(this);
    return cls + " add-member-panel";
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      teamInfor: null,
      onSuccessSendInvitation: _.noop,
      onFailSendInvitation: _.noop,
      contactCollection: new _MDContactCollection["default"](),
      teamId: null,
      dispParticpant: null,
      roles: [],
      roleId: 0,
      roleSelectView: null,
      onCancel: _.noop
    });
  },
  initialize: function initialize(opt) {
    var _MDChooserView;
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.$roleWrap = this.$('.role-wrap');
    var self = this;
    var datas = app.application.contactList.toJSON();
    var maxInputNumber = 10;
    var emailReg = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
    this.chooserView = new _MDChooserView2["default"]((_MDChooserView = {
      textField: 'email',
      placeholder: BabelStr.str(7311)
    }, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_MDChooserView, "placeholder", BabelStr.str(7312)), "datas", datas), "autoChoose", false), "blurToChoose", true), "keepText", false), "dropDownMaxHeight", 200), "backspaceOnceToRemove", true), "maxInputNumber", maxInputNumber), "enableAutoFilter", true), "filterFun", function filterFun(datas, text) {
      var res = _.filter(datas, function (data) {
        var name = data['name'];
        var email = data['email'];
        var res = name.indexOf(text) >= 0 || email.indexOf(text) >= 0;
        return res;
      });
      return res;
    }), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_MDChooserView, "validateInput", function validateInput(data) {
      return _MDChooserView2["default"].validateInputUserContactStr(data);
    }), "chosenItemRenderer", function chosenItemRenderer(data) {
      if (_.isString(data)) {
        return '<a>' + data + '</a>';
      } else {
        if (data['id'] == '-1') {
          return '<a>' + BabelStr.str(710) + '<span>' + data['email'] + '</span></a>';
        } else {
          return '<a>' + data['name'] + '</a>';
        }
      }
      return false;
    }), "dropdownRenderer", function dropdownRenderer(data) {
      var hasMail = _.find(datas, function (value) {
        return value['email'] == data;
      });
      var checked = this.hasChosen(data) || hasMail;
      checked = checked ? " checked " : "";
      return '<div class="c-contact contact-infor">' + '<div class="infor-col">' + '<div class="chb"><input type="checkbox" ' + checked + '><label></label></div>' + '<img src="' + data['avatarImageURL'] + '"/>' + '<span class="name">' + data['name'] + '</span>' + '<span class="mail">' + data['email'] + '</span>' + '</div>' + '</div>';
    }), "onChange", function onChange(data, add) {
      var info = this.dropdownViewHasData(data);
      var el = info.dom;
      var $checkbox;
      if (info.index > -1) {
        $checkbox = $(el).find('input[type="checkbox"]');
        $checkbox.prop('checked', add);
      }
      var length = this.getChosen().length;
      if (length > 0) {
        self.$("#added").html("<span>" + BabelStr.str(7313, {
          num: length
        }) + "</span>");
      } else {
        self.$("#added").html("");
      }
    }), "delegateEvents", {
      'click .c-contact': function clickCContact($e) {
        var $chb = $($e.currentTarget).find('.chb input');
        var data = $chb.closest('li').data('data-item');
        var checked = $chb.prop('checked');
        $chb.prop('checked', !checked);
        if (checked) {
          this.removeChoose(data);
        } else {
          if (this.hasReachMaxLength()) {
            $e.preventDefault();
            $chb.prop('checked', false);
            return false;
          }
          this.addChoose(data);
        }
      }
    })));
    this.addSubView(this.chooserView, this.$('.chooser-wrapper'));
    this.roleSelectView = new _MDRoleSelectView["default"]({
      onRoleChanged: function onRoleChanged(role) {
        self.role = role;
      }
    });
    this.addSubView(this.roleSelectView, this.$('#role-slot'), true);
    this.$contentBk = this.$('#content-bk');
    this.$contentBk.hide();
    this._prepareRoles();
  },
  _cancelButtonClickHandler: function _cancelButtonClickHandler($e) {
    _.isFunction(this.onCancel) && this.onCancel();
  },
  _prepareRoles: function _prepareRoles() {
    var self = this;
    _MDSpinnerloaderView["default"].showIn(this.$('.loading-wrap'));
    _MDTeamDataController["default"].getRoles(function (roleCollection, defaultRoleId) {
      defaultRoleId = 11;
      var shareRoles = [];
      roleCollection.each(function (roleInfo) {
        var permission = roleInfo.getPermission();
        if (permission > 0) {
          shareRoles.push(roleInfo);
        }
        ;
      });
      self.roles = shareRoles;
      self.$contentBk.show();
      var role = roleCollection.findWhere({
        'id': defaultRoleId
      });
      role = role || roleCollection.at(0);
      self.roleSelectView.setRoles(shareRoles);
      self.roleSelectView.selectRole(role, true);
      self.role = role;
      _MDSpinnerloaderView["default"].clearFrom(self.$('.loading-wrap'));
    }, function () {
      _MDSpinnerloaderView["default"].clearFrom(self.$('.loading-wrap'));
    });
  },
  _sendInvitation: function _sendInvitation($e) {
    var self = this;
    var teamId = _.isFunction(this.teamId) ? this.teamId() : this.teamId;
    var targetMails = [];
    var val = this.chooserView.getTextVal();
    this.chooserView.addChoose(val);
    var contacts = this.chooserView.getChosen();
    if (contacts.length == 0) return;
    var $sendInvBtn = this.$('#sendInvBtn');
    $sendInvBtn.prop('disabled', true).text(BabelStr.str(711));
    this.chooserView.setEnabled(false);
    var roleId = this.role.getRoleId();
    var invalidNames = [];
    _.map(contacts, function (val) {
      if (_.isString(val)) {
        if (_MDChooserView2["default"].validateInputUserContactStr(val)) {
          targetMails.push(val);
        } else {
          invalidNames.push(val);
        }
      } else {
        targetMails.push(val['email']);
      }
    });
    _MDChooserView2["default"].Check2filterInvalid(invalidNames);
    var length = targetMails.length;
    var memberInfos = [];
    var responseCount = 0;
    var notMemebers = [];
    var inErrors = [];
    var msg = "";
    function success(res, memberInfo) {
      responseCount++;
      $sendInvBtn.prop('disabled', false).text(BabelStr.str(3096));
      memberInfos.push(memberInfo);
      if (responseCount == length) {
        if (app.isEpVersion()) {
          _MDSnackbarView["default"].show(BabelStr.str(3507));
        } else {
          _MDSnackbarView["default"].show(BabelStr.str(7314));
        }
        _.isFunction(self.onSuccessSendInvitation) && self.onSuccessSendInvitation(memberInfos);
      }
    }
    function fail(errcode, mail) {
      $sendInvBtn.prop('disabled', false).text(BabelStr.str(3096));
      responseCount++;
      if (errcode == _MMNetDiskDataController["default"].code.ERROR_NOT_FOUND) {
        notMemebers.push(mail);
      } else if (errcode == _MMNetDiskDataController["default"].code.ERROR_ALREADY_IN) {
        inErrors.push(mail);
      }
      if (responseCount == length) {
        if (notMemebers.length > 0) {
          _.each(notMemebers, function (mail, index) {
            if (index > 0) {
              msg += ' , ' + mail;
            } else {
              msg += '<div>' + mail;
            }
          });
          msg += BabelStr.str(7315) + '</div>';
        }
        if (inErrors.length > 0) {
          _.each(inErrors, function (mail, index) {
            if (index > 0) {
              msg += ' , ' + mail;
            } else {
              msg += '<div>' + mail;
            }
          });
          msg += BabelStr.str(7316) + '</div>';
        }
        if (inErrors.length > 0 || notMemebers.length > 0) {
          _MDSnackbarView["default"].show(msg);
        } else {
          if (app.isEpVersion()) {
            _MDSnackbarView["default"].show(BabelStr.str(3500));
          } else {
            _MDSnackbarView["default"].show(BabelStr.str(7317));
          }
        }
      }
    }
    for (var i = 0; i < targetMails.length; i++) {
      _MDTeamDataController["default"].addMember(teamId, targetMails[i], null, roleId, success, fail);
    }
  },
  viewWillUnRendered: function viewWillUnRendered() {
    _MMViewBase["default"].prototype.viewWillUnRendered.call(this);
  }
});
var _default = exports["default"] = MDAddTeamMemberPanelView;

},{"106":106,"1094":1094,"1104":1104,"1180":1180,"1184":1184,"1415":1415,"1417":1417,"1421":1421,"1426":1426,"1436":1436,"1439":1439,"1454":1454,"1463":1463,"1546":1546,"22":22,"244":244,"38":38,"515":515,"72":72,"76":76}],244:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MDContact = _interopRequireDefault(require(243));
var MDContactCollection = _MDMolaUserCollection["default"].extend({
  model: _MDContact["default"]
});
var _default = exports["default"] = MDContactCollection;

},{"1184":1184,"1454":1454,"243":243,"273":273}],580:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MDFileVerListPanelView = _interopRequireDefault(require(583));
var _MDTabPanelView = _interopRequireDefault(require(81));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDEvents = _interopRequireDefault(require(325));
var _MDFileOperationManager = _interopRequireDefault(require(326));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDFileLogWindowView = _interopRequireDefault(require(576));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDEditalbeTextDiv = _interopRequireDefault(require(29));
var _MDAddTagWindow = _interopRequireDefault(require(785));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDDepFilePermissionWinView = _interopRequireDefault(require(565));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDFileCommentListView = _interopRequireDefault(require(543));
/**
 *  File information panel view
 *  Created by jiang
 *  2015.9.2
 */

var MDFileReviewDetailTabPanelView = _MDTabPanelView["default"].extend({
  tmpl: "<div class=\"review-content\">\n\n    </div>",
  className: function className() {
    var superCls = _MDTabPanelView["default"].prototype.className.call(this);
    return superCls + ' m-file-review';
  },
  initialize: function initialize(opt) {
    opt.showNavigationBar = false;
    _MDTabPanelView["default"].prototype.initialize.call(this, opt);
  },
  initProps: function initProps() {
    var superP = _MDTabPanelView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      focusCollection: new _MDMolaUserCollection["default"]()
    });
  },
  events: function events() {
    var superE = _MDTabPanelView["default"].prototype.events.call(this);
    return _.extend(superE, {});
  },
  setFileInfo: function setFileInfo(info) {
    this.fileInfo = info;
    if (!this.review) {
      this.review = new _MDFileCommentListView["default"]({
        fileId: info.getFileId(),
        inReviewPanel: true,
        fileInfor: info
      });
      this.addSubView(this.review, this.$(".review-content"), true);
    }
    this.review.refreshFile(info.getFileId());
  },
  onActived: function onActived() {
    if (this.review) {
      this.review.onActived();
    }
  },
  onHidden: function onHidden() {
    if (this.review) {
      this.review.onHidden();
    }
  }
});
var _default = exports["default"] = MDFileReviewDetailTabPanelView;

},{"1104":1104,"1150":1150,"1184":1184,"1454":1454,"18":18,"273":273,"29":29,"32":32,"325":325,"326":326,"543":543,"565":565,"576":576,"583":583,"67":67,"72":72,"76":76,"785":785,"81":81}],785:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1436);
require(1546);
var _MDWindowView = _interopRequireDefault(require(93));
var _MDAddTagCommonView = _interopRequireDefault(require(784));
var _MDTagCollection = _interopRequireDefault(require(288));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDTag = _interopRequireDefault(require(287));
var _MDTagDataController = _interopRequireDefault(require(1093));
var _MDSnackbarView = _interopRequireDefault(require(72));
/**
 * 添加标签
 * Created by jiang
 * 2017.6.13
 */

var MDAddTagWindow = _MDWindowView["default"].extend({
  className: function className() {
    var superCls = _MDWindowView["default"].prototype.className.call(this);
    return superCls + ' m-add-tag-window';
  },
  events: function events() {
    var superE = _MDWindowView["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click >header .u-nav-back-btn': this.pop
    });
  },
  initProps: function initProps() {
    var superP = _MDWindowView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      fileInfos: [],
      title: BabelStr.str(106) //  "添加标签"
    });
  },
  _setWidowTransitionAni: function _setWidowTransitionAni(enable) {
    if (!enable) {
      this.$el.addClass('disable-tran');
    } else {
      this.$el.removeClass('disable-tran');
    }
  },
  /**
   * @param {object} opt
   * @param {MDNavigationPageView} opt.rootNavigationPageView - 根nav页面
   */
  initialize: function initialize(props) {
    _MDWindowView["default"].prototype.initialize.call(this, props);
    var fileIds = [];
    for (var i = 0; i < this.fileInfos.length; i++) {
      fileIds.push(this.fileInfos[i].getFileId());
    }
    ;
    var self = this;
    var param = {
      shouldSearchTag: true,
      fileInfos: this.fileInfos,
      tagCollection: new _MDTagCollection["default"](),
      addTagCallback: function addTagCallback() {
        self.close();
      },
      removeTagCallback: function removeTagCallback() {
        self.close();
      },
      layout: function layout() {},
      // tagCollection: this.tagCollection,

      onRemoveAddedTag: function onRemoveAddedTag(tagModel, netCb) {
        // 删除标签
      },
      onAddTag: function onAddTag(tagModel, netCb) {
        var id = tagModel.getId();

        // 添加已有标签
        if (id) {
          _MDTagDataController["default"].addTagForFiles(fileIds, id, function () {
            netCb.success();
            tagModel = new _MDTag["default"](tagModel.toJSON());
            for (var i = 0; i < self.fileInfos.length; i++) {
              var tagCollection = self.fileInfos[i].getTagCollection();
              tagCollection.add(tagModel);
            }
            ;
            _Dispatcher["default"].trigger(MDEvents.Tag_Add_To_File, {
              tagModel: tagModel
            });
            _MDSnackbarView["default"].show(BabelStr.str(308)); // ('标签添加成功');
          }, function () {
            netCb.fail();
          });
          // 添加新标签
        } else {
          var color = tagModel.getColorNum();
          var text = tagModel.getText();
          tagModel.set({
            'canDelete': true,
            'canAdd': true
          });
          _MDTagDataController["default"].createTagAndAddToFile(fileIds, text, color, function (tagInfo) {
            netCb.success();
            tagModel.setId(tagInfo['tagId']);
            for (var i = 0; i < self.fileInfos.length; i++) {
              var tagCollection = self.fileInfos[i].getTagCollection();
              tagCollection.add(tagModel);
            }
            ;
            _Dispatcher["default"].trigger(MDEvents.Tag_Add_To_File, {
              tagModel: tagModel,
              fileInfo: self.fileInfo
            });
          }, function (resultCode) {
            netCb.fail();
          });
        }
      }
    };
    this.addTagCommonView = new _MDAddTagCommonView["default"](param);
    this.addSubView(this.addTagCommonView, this.$('.window-body'));
  },
  close: function close() {
    _MDWindowView["default"].prototype.close.call(this);
    if (this.closeCallback) {
      this.closeCallback();
    }
    ;
  }
});
var _default = exports["default"] = MDAddTagWindow;

},{"1093":1093,"1184":1184,"1436":1436,"1454":1454,"1546":1546,"18":18,"287":287,"288":288,"72":72,"784":784,"93":93}],784:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1415);
require(1463);
require(1421);
require(1436);
require(1546);
require(1417);
require(1477);
require(1492);
require(1476);
require(1478);
require(1424);
var _MDLocalString = _interopRequireDefault(require(1150));
var _keycode = _interopRequireDefault(require(104));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDTag = _interopRequireDefault(require(287));
var _MDTagCollection = _interopRequireDefault(require(288));
var _MDTagDataController = _interopRequireDefault(require(1093));
var _MDAddTagBigWindow = _interopRequireDefault(require(781));
var _MDAddTagCommonBaseView = _interopRequireDefault(require(782));
/**
 * 添加标签
 * Created by jiang copied from han's MDAddTagPopupView.js
 * 2017.6.13
 */

var MDAddTagCommonView = _MDAddTagCommonBaseView["default"].extend({
  el: '<div class="add-tag-root"></div>',
  contentTmpl: function contentTmpl() {
    return '<div class="tag-input-block">\
          <form autocomplete="false" onsubmit="return false">\
            <div class="form-item" >\
              <div class="tag-name-input-wrap mgb-10">\
                <i class="tag-color-circle tag-select-color-circle" ></i>\
                <input name="<%=tagName%>" type="text" class="form-control tag-name-input"  autocomplete="false" \
                  placeholder="<%=placeholder%>" maxlength="140" \
                  >\
              </div>\
            </div>\
          </form>\
        </div>\
        <div class="tag-prop-block">\
          <div class="tag-prop-block-inner">\
            <ul class="tag-color-list">\
            <% for(var i = 0 ; i < colors.length ; i++) {%>\
                <li class="tag-color-circle" data-tag-color="<%=colors[i]%>" style="background-color:<%=colors[i]%>"></li>\
            <% }%>  \
            </ul>\
            <button class="button done add-tag-btn"><%=addTag%></button>\
          </div>\
        </div>\
        <div class="tag-search-block">\
          <ul class="tag-search-list"></ul>\
        </div>';
  },
  tagItem: '<li data-tag-id="<%=id%>">\
                    <i class="tag-color-circle" style="background-color:<%=color%>"></i>\
                    <span class="tag-name"><%=htmlText%></span>\
                    <span data-tagid="<%=id%>" class="tag-checked f-fr icon <%if(selected){%>icon-check-blue<%}%>"></span>\
                  </li>',
  className: function className() {
    var superCls = _MDAddTagCommonBaseView["default"].prototype.className.call(this);
    return superCls + ' ';
  },
  initProps: function initProps() {
    var superP = _MDAddTagCommonBaseView["default"].prototype.initProps.call(this);
    return _.extend(superP, {});
  },
  events: function events() {
    var superE = _MDAddTagCommonBaseView["default"].prototype.events.call(this);
    return _.extend(superE, {});
  },
  initialize: function initialize(options) {
    options.width = 360;
    var self = this;
    this.$tagSearchList = this.$('.tag-search-list');
    _MDAddTagCommonBaseView["default"].prototype.initialize.call(this, options);
    this._initTagList();
  },
  _initTagList: function _initTagList() {
    _MDAddTagCommonBaseView["default"].prototype._initTagList.call(this);
    var self = this;
    this.bindSelf(this._onTagListItemClickHandler, this._onTagListScrollHandler);
    if (this.shouldSearchTag) {
      this.$('.tag-search-list').on('click', 'li', this._onTagListItemClickHandler);
      this.$('.tag-search-list').on('scroll', this._onTagListScrollHandler);
    } else {
      this.$tagSearchList.parent().remove();
    }
  },
  _getSpinParent: function _getSpinParent() {
    return this.$('.tag-search-list');
  },
  renderTagCollectionICanChoose: function renderTagCollectionICanChoose(tagSearchName) {
    var hasAddTagCollection = this.tagCollectionSelected;
    var compiler = _.template(this.tagItem);
    var html = [];
    var tagCollection = this.tagCollectionICanChoose;
    // 过滤掉不匹配的
    if (tagSearchName) {
      tagCollection = tagCollection.filter(function (tagModel) {
        return tagModel.getText().indexOf(tagSearchName) > -1;
      });
      tagCollection = new _MDTagCollection["default"](tagCollection);
    }
    tagCollection.each(function (tagModel) {
      var tagInfo = tagModel.toJSON();
      // 是否已选择
      var selectedTag = hasAddTagCollection.find(function (tagModel) {
        return tagModel.getId() == tagInfo['id'];
      });
      var selected = selectedTag != undefined ? true : false;
      tagModel.setSelected(selected);
      tagInfo['color'] = tagModel.getColor();
      tagInfo['selected'] = selected;
      tagInfo['htmlText'] = tagInfo['text'].replace(new RegExp(tagSearchName, 'g'), function (match) {
        if (match) {
          return '<span class="emp">' + match + '</span>';
        } else {
          return match;
        }
      });
      var snippet = compiler(tagInfo);
      html.push(snippet);
    });
    this.$('.tag-search-list').empty().append(html.join(''));
    this.curSelectedIndex = undefined;
  },
  _onTagListItemClickHandler: function _onTagListItemClickHandler($e) {
    var self = this;
    var $li = $($e.currentTarget);
    var tagId = $li.data('tagId');
    var tagModel = this.tagCollectionICanChoose.find(function (tagModel) {
      return tagModel.getId() == tagId;
    });
    // 点击已选中的标签，删除标签
    if (tagModel.isSelected()) {
      this._executeRemoveTag(tagModel);
      // 添加已有标签
    } else {
      this._executeAddTag(tagModel);
    }
  },
  _onTagListScrollHandler: function _onTagListScrollHandler($e) {
    if (!app.isEpVersion() || this.createBtnIsShowing) {
      return;
    }
    var self = this;
    if (!this.$openWinBtn) {
      this.$openWinBtn = $('<button class="openTagWin button btnhover">' + BabelStr.str(2610) + '</div>');
      this.$('.tag-search-block').append(this.$openWinBtn);
      this.$openWinBtn.on("click", function (e) {
        console.log('--- open big window!');
        self._openBigTagWindow();
      });
    }
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
    }
    // this.hideTimer = setBabelTimeout(function() {
    //   self.$openWinBtn.remove();
    //   self.$openWinBtn = null;
    // }, 1000);
  },
  _openBigTagWindow: function _openBigTagWindow() {
    var addTagWin = new _MDAddTagBigWindow["default"]({
      fileInfos: this.fileInfos
    });
    addTagWin.show();
    this.getSuperView().remove();
  },
  _executeAddTag: function _executeAddTag(tagModel) {
    var self = this;
    var validator = this.$('form').validate();
    self.$addButton.prop('disabled', true);
    _.isFunction(this.onAddTag) && this.onAddTag(tagModel, {
      success: function success() {
        self.addTagCallback();
      },
      fail: function fail(errorMsg) {
        if (error) {
          var error = {};
          error[this.tagInputName] = errorMsg;
          validator.showErrors(error);
        }
        self.$addButton.prop('disabled', false);
      }
    });
  },
  _executeRemoveTag: function _executeRemoveTag(tagModel) {
    var self = this;
    var validator = this.$('form').validate();
    _.isFunction(this.onRemoveAddedTag) && this.onRemoveAddedTag(tagModel, {
      success: function success() {
        self.removeTagCallback();
      },
      fail: function fail(errorMsg) {
        if (error) {
          var error = {};
          error[this.tagInputName] = errorMsg;
          validator.showErrors(error);
        }
      }
    });
  },
  _onArrowUp: function _onArrowUp() {
    this.curSelectedIndex = _.isUndefined(this.curSelectedIndex) ? -1 : this.curSelectedIndex;
    this.curSelectedIndex--;
    this.curSelectedIndex = this.curSelectedIndex < 0 ? this.$('.tag-search-list').children().length - 1 : this.curSelectedIndex;
    this._scrollToIndex(this.curSelectedIndex, true);
  },
  _onArrowDown: function _onArrowDown() {
    this.curSelectedIndex = _.isUndefined(this.curSelectedIndex) ? -1 : this.curSelectedIndex;
    this.curSelectedIndex++;
    this.curSelectedIndex = this.curSelectedIndex > this.$('.tag-search-list li').length - 1 ? 0 : this.curSelectedIndex;
    this._scrollToIndex(this.curSelectedIndex, false);
  },
  _scrollToIndex: function _scrollToIndex(curSelectedIndex, up) {
    var $children = this.$('.tag-search-list').children();
    var $item = $children.eq(curSelectedIndex);
    var length = $children.length;
    var $viewPort = this.$('.tag-search-list');
    var scrollTop = 0;
    $children.removeClass('selected');
    $item.addClass('selected');
    if (!this._itemTotalInViewPort($item)) {
      if (up) {
        if (curSelectedIndex < length - 1) {
          scrollTop = $item[0].offsetTop;
        } else {
          scrollTop = $viewPort[0].scrollHeight - $viewPort.height();
        }
      } else {
        if (curSelectedIndex > 0) {
          scrollTop = $item[0].offsetTop + $item.outerHeight() - $viewPort.height();
        } else {
          scrollTop = 0;
        }
      }
      $viewPort.scrollTop(scrollTop);
    }
  },
  _itemTotalInViewPort: function _itemTotalInViewPort(item) {
    var $item = $(item);
    var itemHeight = $item.outerHeight();
    var $viewPort = this.$('.tag-search-list');
    var viewPortHeight = $viewPort.outerHeight();
    var scrollTop = $viewPort.scrollTop();
    var y = $item[0].offsetTop - scrollTop;
    return y >= 0 && y + itemHeight <= viewPortHeight;
  },
  _refreshSelectStatus: function _refreshSelectStatus() {
    var $selectMark = self.$(".tag-checked");
    for (var i = 0; i < $selectMark.length; i++) {
      var element = $selectMark[i];
      $(element).removeClass("icon-check-blue");
    }
    this.tagCollectionSelected.each(function (tagModel) {
      for (var _i = 0; _i < $selectMark.length; _i++) {
        var _element = $selectMark[_i];
        if (_element.dataset['tagid'] == tagModel.getId()) {
          $(_element).addClass("icon-check-blue");
        }
      }
    });
  },
  getClassName: function getClassName() {
    return "MDAddTagCommonView";
  }
}, {});
var _default = exports["default"] = MDAddTagCommonView;

},{"104":104,"1093":1093,"1150":1150,"1184":1184,"1415":1415,"1417":1417,"1421":1421,"1424":1424,"1436":1436,"1454":1454,"1463":1463,"1476":1476,"1477":1477,"1478":1478,"1492":1492,"1546":1546,"287":287,"288":288,"76":76,"781":781,"782":782}],543:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1498);
require(1437);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MMViewBase2 = _interopRequireDefault(require(22));
var _MDFileCommentItemView = _interopRequireDefault(require(542));
var _MDFileCommentInputView = _interopRequireDefault(require(541));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDSpinnerloaderLayerView = _interopRequireDefault(require(75));
var _regexp = _interopRequireDefault(require(106));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDFileCommentListView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MDFileCommentListView, _MMViewBase);
  function MDFileCommentListView() {
    (0, _classCallCheck2["default"])(this, MDFileCommentListView);
    return _callSuper(this, MDFileCommentListView, arguments);
  }
  (0, _createClass2["default"])(MDFileCommentListView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n      <div class=\"file-comment-list\"></div>\n      <div class=\"flex-align middle send-comment-wrap\">\n        <div class=\"input-slot\"></div>\n        <button class=\"button done send-comment-btn\"><%=BabelStr.str(406)%></button>\n      </div>\n    ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileCommentListView.prototype), "className", this).call(this);
      return "".concat(superCls, " file-comment-wrap prevent-mouse");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileCommentListView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        commentCollection: new Backbone.Collection(),
        fileId: '',
        refreshCount: _.noop,
        close: _.noop
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileCommentListView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .send-comment-btn': this._sendComment
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileCommentListView.prototype), "initialize", this).call(this, props);
      this.$commentList = this.$('.file-comment-list');
      this.$sendCommentWrap = this.$('.send-comment-wrap');
      this.inputView = new _MDFileCommentInputView["default"]({
        fileId: this.fileId,
        onEnter: function onEnter() {
          _this._sendComment();
        }
      });
      this.addSubView(this.inputView, this.$('.input-slot'));
      this.itemViews = [];
      var self = this;
      Dispatcher.on(MDEvents.FileReviewAdded, function (fileId, sender) {
        console.log("review changed --> fileId:" + fileId);
        if (self.active) {
          if (self.$('.file-comment-list').length > 0) {
            self.$('.file-comment-list')[0].scrollTop = 100000000000;
          }
        }
        if (sender != self) {
          self._renderCommentList();
        }
      });
    }
  }, {
    key: "refreshFile",
    value: function refreshFile(fileId) {
      this.fileId = fileId;
      this._renderCommentList();
    }
  }, {
    key: "_renderCommentList",
    value: function _renderCommentList() {
      var _this2 = this;
      var self = this;
      this.$sendCommentWrap.hide();
      _MDSpinnerloaderLayerView["default"].showIn(this.el);
      _MMNetDiskDataController["default"].getFileReviews(this.fileId, null, undefined, function (reviews) {
        for (var _i = 0; _i < self.itemViews.length; _i++) {
          var $item = self.itemViews[_i];
          $item.remove();
        }
        self.$('.file-comment-list').empty();
        self.$sendCommentWrap.show();
        self.$sendCommentWrap.css('display', 'flex');
        _MDSpinnerloaderLayerView["default"].clearFrom(self.el);
        self.commentCollection = reviews;
        self.refreshCount(self.commentCollection.length);
        self.listenTo(self.commentCollection, 'add', self._addCommentHandler);
        if (!reviews.length) {
          self._renderBlank();
          return;
        }
        for (var i = 0; i < self.commentCollection.length; i++) {
          var commentItemView = new _MDFileCommentItemView["default"]({
            commentInfo: self.commentCollection.at(i),
            inReviewPanel: self.inReviewPanel,
            fileInfor: _this2.fileInfor
          });
          self.addSubView(commentItemView, self.$commentList[0]);
          self.itemViews.push(commentItemView);
        }
        if (self.$('.file-comment-list').length > 0) {
          self.$('.file-comment-list')[0].scrollTop = 100000000000;
        }
      }, function (code) {
        if (code = 12) {
          // MDSnackbarView.show('无权访问该文件');
          _MDSpinnerloaderLayerView["default"].clearFrom(self.el);
          var noPermStr = _MDLocalString["default"].getLocalString(255); // 无权评论该文件
          var noPer = '<div class="m-empty">' + '<div class="info">' + noPermStr + '</div>' + '</div>';
          self.$('.file-comment-list').html(noPer);
        } else {
          _MDSnackbarView["default"].show(_MDLocalString["default"].getLocalString(168));
        }
      });
    }
  }, {
    key: "_renderBlank",
    value: function _renderBlank() {
      var noCommentStr = _MDLocalString["default"].getLocalString(254);
      this.$commentList.empty().append('<div class="no-comment text-center">' + noCommentStr + '</div>');
    }
  }, {
    key: "_sendComment",
    value: function _sendComment() {
      var _this3 = this;
      var text = this.inputView.getText() || "";
      var atIds = this.inputView.getAtIds();
      text = text.trim();
      if (!text) {
        return;
      }
      if (!_regexp["default"].validateTextinput(text)) {
        _MDSnackbarView["default"].show(BabelStr.str(12202));
        return;
      }
      _czc && _czc.push(["_trackEvent", "讨论", "发表评论", "文件", "", ".send-comment-btn"]);
      _MMNetDiskDataController["default"].sendFileReview(this.fileId, JSON.stringify({
        "Type": "Text",
        "Body": text,
        "atIds": atIds,
        "pageIndex": -1
      }), function () {
        _this3.$('.no-comment') && _this3.$('.no-comment').remove();
        var data = {
          'userId': app.currentUser.getUserId(),
          'time': new Date().getTime() / 1000,
          'userName': app.currentUser.getUserName(),
          'review': JSON.stringify({
            Body: _this3.inputView.getText()
          })
        };
        var commentInfo = new Backbone.Model(data);
        _this3.commentItemView = new _MDFileCommentItemView["default"]({
          commentInfo: commentInfo,
          inReviewPanel: _this3.inReviewPanel,
          fileInfor: _this3.fileInfor
        });
        _this3.addSubView(_this3.commentItemView, _this3.$commentList[0]);
        _this3.commentCollection.add(commentInfo);
        _this3.inputView.setText('');
        _this3.inputView.setAtObjEmpty();
        Dispatcher.trigger(MDEvents.FileReviewAdded, _this3.fileId, _this3);
      }, function () {
        _MDSnackbarView["default"].show(_MDLocalString["default"].getLocalString(168));
      });
    }
  }, {
    key: "_addCommentHandler",
    value: function _addCommentHandler(model, collection) {
      this.refreshCount && this.refreshCount(collection.length);
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileCommentListView.prototype), "viewDidRendered", this).call(this);
      this._renderCommentList();
    }
  }, {
    key: "onActived",
    value: function onActived() {
      this.active = true;
      if (this.$('.file-comment-list').length > 0) {
        this.$('.file-comment-list')[0].scrollTop = 100000000000;
      }
    }
  }, {
    key: "onHidden",
    value: function onHidden() {
      this.active = false;
    }
  }]);
  return MDFileCommentListView;
}(_MMViewBase2["default"]);

},{"106":106,"1104":1104,"1150":1150,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1437":1437,"1454":1454,"1463":1463,"1475":1475,"1498":1498,"22":22,"541":541,"542":542,"72":72,"75":75}],542:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1461);
require(1437);
require(1436);
require(1546);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMViewBase2 = _interopRequireDefault(require(22));
var _app = _interopRequireDefault(require(17));
var _link = _interopRequireDefault(require(347));
var _utils = _interopRequireDefault(require(108));
var _MDSnackbarView = _interopRequireDefault(require(72));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDFileCommentItemView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MDFileCommentItemView, _MMViewBase);
  function MDFileCommentItemView() {
    (0, _classCallCheck2["default"])(this, MDFileCommentItemView);
    return _callSuper(this, MDFileCommentItemView, arguments);
  }
  (0, _createClass2["default"])(MDFileCommentItemView, [{
    key: "leftTmpl",
    value: function leftTmpl() {
      // return `
      //   <div class="user-info">
      //     <img src="<%= avatarUrl %>" alt="" />
      //   </div>
      //   <div class="comment-content">
      //     <div>
      //       <span class="sender"><%= userName %></span>
      //       <span class="time time-right"><%= commentTime %></span>
      //     </div>
      //     <div class="comment-message"><%= commentText %></div>
      //   </div>
      // `
      return "\n      <div class=\"comment-content flex-align between\">\n        <div class=\"f-fl word-zone\" style=\"\">\n          <span class=\"sender\"><%= userName %>:</span>\n          <span class=\"comment-message\"><%= commentText %></span>\n        </div>\n        <div class=\"flex-align\">\n          <span><%= commentTime %></span>\n          <%if(canRemove){%>\n            <span class=\"text-button del del-item\"><%= BabelStr.str(120)%></span>\n          <%} else {%>\n            <span class=\"del-item\">-- </span>\n          <%}%>\n        </div>\n      </div>\n    ";
    }
  }, {
    key: "rightTmpl",
    value: function rightTmpl() {
      return "\n      <div class=\"comment-content\">\n        <div class=\"f-clb\">\n          <span class=\"sender f-fr\"><%= userName %></span>\n          <span class=\"time time-left f-fr\"><%= commentTime %></span>\n        </div>\n        <div class=\"comment-message text-right\"><%= commentText %></div>\n      </div>\n      <div class=\"user-info\">\n        <img src=\"<%= avatarUrl %>\" alt=\"\" />\n      </div>\n    ";
    }
  }, {
    key: "userTimeTmpl",
    value: function userTimeTmpl() {
      return "\n      <div class=\"comment-content\">\n        <div class=\"f-clb\">\n          <div class=\"user-info f-fl\">\n            <img class=\"_user-profile-picture\" src=\"<%= avatarUrl %>\" alt=\"\" />\n          </div>\n          <span class=\"sender f-fl\"><%= userName %></span>\n          <span class=\"time time-left f-fl\"><%= commentTime %></span>\n        </div>\n        <div class=\"comment-message\"><%= commentText %></div>\n      </div>\n       ";
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileCommentItemView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .del": this._delComent
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileCommentItemView.prototype), "className", this).call(this);
      return "".concat(superCls, " flex-align file-comment-item");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileCommentItemView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        commentInfo: new Backbone.Model()
      });
    }
  }, {
    key: "_delComent",
    value: function _delComent() {
      var _this = this;
      MMEnterpriseController.removeFileReview(this.fileInfor.getFileId(), this.commentInfo.get("id"), function () {
        _this.remove();
        var num = _this.fileInfor.getFileReviewCount();
        num = num - 1;
        num = num < 0 ? 0 : num;
        _this.fileInfor.setFileReviewCount(num);
      }, function () {
        _MDSnackbarView["default"].show(BabelStr.str(7155));
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileCommentItemView.prototype), "initialize", this).call(this, props);
      var userId = this.commentInfo.get("userId");
      var avatarUrl = _app["default"].getAvatarImageURL(userId);
      var commentContent = JSON.parse(this.commentInfo.get("review"));
      var commentText = _link["default"]["do"](commentContent["Body"]);
      this.commentInfo.set("avatarUrl", avatarUrl);
      this.commentInfo.set("commentTime", _utils["default"].prettyShortDate(new Date(), this.commentInfo.get("time") * 1000));
      this.commentInfo.set("commentText", commentText);
      var data = this.commentInfo.toJSON();
      if (this.fileInfor && this.commentInfo.get("id")) {
        data.canRemove = this.fileInfor.canDelMyComment();
        // ||
        // this.commentInfo.get("userId") == app.currentUser.getUserId();
      } else {
        data.canRemove = false;
      }
      var html = _.template(this.leftTmpl())(data);
      if (this.inReviewPanel) {
        html = _.template(this.userTimeTmpl())(data);
      }
      this.$el.append(html);
    }
  }]);
  return MDFileCommentItemView;
}(_MMViewBase2["default"]);

},{"108":108,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1436":1436,"1437":1437,"1454":1454,"1461":1461,"1463":1463,"1475":1475,"1546":1546,"17":17,"22":22,"347":347,"72":72}],541:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1498);
require(1421);
require(1426);
require(1439);
require(1417);
require(1463);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MMViewBase2 = _interopRequireDefault(require(22));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDAtWhoView = _interopRequireDefault(require(35));
var _keycode = _interopRequireDefault(require(104));
var _regexp = _interopRequireDefault(require(106));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDFileCommentInputView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MDFileCommentInputView, _MMViewBase);
  function MDFileCommentInputView() {
    (0, _classCallCheck2["default"])(this, MDFileCommentInputView);
    return _callSuper(this, MDFileCommentInputView, arguments);
  }
  (0, _createClass2["default"])(MDFileCommentInputView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n      <input type=\"text\" class=\"form-control comment-input\" placeholder=\"<%=placeholder%>...\" maxlength=\"400\" />\n    ";
    }
  }, {
    key: "render",
    value: function render() {
      var data = {
        'placeholder': _MDLocalString["default"].getLocalString(252)
      };
      _MMViewBase2["default"].prototype.render.call(this, data);
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileCommentInputView.prototype), "className", this).call(this);
      return "".concat(superCls, " m-input");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileCommentInputView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        fileId: '',
        atObj: {}
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileCommentInputView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'keyup input': this._inputKeyUpHandler,
        'keydown input': this._inputKeyDownHandler
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileCommentInputView.prototype), "initialize", this).call(this, props);
      this.$commentInput = this.$('.comment-input');
    }
  }, {
    key: "_inputKeyUpHandler",
    value: function _inputKeyUpHandler(e) {
      var self = this;
      var message = this.$commentInput.val().trim();
      if (e.keyCode == 8) {
        _.each(this.atObj, function (value, key) {
          if (message.indexOf(key) === -1) {
            delete self.atObj[key];
          }
        });
      }
    }

    // prevent action of table
  }, {
    key: "_inputKeyDownHandler",
    value: function _inputKeyDownHandler(e) {
      if (_keycode["default"].isEnterKey(e.keyCode) && !this.atwhoView.isPopupShown()) {
        this.onEnter && this.onEnter();
      }
      e.stopPropagation();
    }
  }, {
    key: "setText",
    value: function setText(text) {
      this.$commentInput.val(text);
    }
  }, {
    key: "getText",
    value: function getText() {
      return this.$commentInput.val();
    }
  }, {
    key: "getAtIds",
    value: function getAtIds() {
      var atIds = [];
      _.each(this.atObj, function (id, name) {
        if (id === 'All') {
          atIds = 'All';
          return;
        }
        atIds.push(id);
      });
      return atIds;
    }
  }, {
    key: "setAtObjEmpty",
    value: function setAtObjEmpty() {
      this.atObj = {};
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      var _this = this;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileCommentInputView.prototype), "viewDidRendered", this).call(this);
      if (app.canDispInNormalBrowser()) {
        _MMNetDiskDataController["default"].getAtTargetUserList(this.fileId, function (userInfos) {
          var userList = _.map(userInfos, function (userInfo) {
            var account = userInfo['email'];
            if (!_regexp["default"].isEmail(account)) {
              account = userInfo['phone'];
              if (!account) {
                account = "--";
              }
            }
            return {
              id: userInfo['id'],
              name: userInfo['name'],
              email: account,
              url: app.getAvatarImageURL(userInfo['id'])
            };
          });
          var all = _MDLocalString["default"].getLocalString(253);
          userList.unshift({
            id: 'All',
            name: all
          });
          _this.atwhoView = new _MDAtWhoView["default"]({
            triggerBlock: _this.$commentInput,
            at: "@",
            data: userList,
            insertTpl: '@<%= name %>',
            displayTpl: '<% if(id != "All") {%>' + '<li data-id="<%= id %>">' + '<img src="<%= url %>">' + '<div class="member-info"><div class="name"><%= name %></div>' + '<div class="email"><%= email %></div></div>' + '</li>' + '<% } else { %>' + '<li class="at-all" data-id="<%= id %>">' + all + '</li>' + '<% } %>',
            displayTimeout: 1000
          });
          _this.$commentInput.on('inserted.atwho', function (evt, li) {
            var id = li.attr('data-id');
            var name = '@' + li.find('div.name').text();
            if (!_this.atObj[name]) {
              _this.atObj[name] = id;
            }
          });
        }, function () {});
      }
    }
  }, {
    key: "viewWillUnRendered",
    value: function viewWillUnRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileCommentInputView.prototype), "viewWillUnRendered", this).call(this);
      this.atwhoView && this.atwhoView.destroySelf();
    }
  }]);
  return MDFileCommentInputView;
}(_MMViewBase2["default"]);

},{"104":104,"106":106,"1104":1104,"1150":1150,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1417":1417,"1421":1421,"1426":1426,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"1498":1498,"22":22,"35":35}],572:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1541);
require(1435);
require(1437);
require(1426);
require(1436);
require(1546);
require(1461);
require(1418);
require(1463);
require(1537);
require(1422);
require(1424);
require(1412);
require(1417);
require(1415);
require(1428);
require(1416);
require(1471);
require(1466);
require(1439);
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MDFileVerListPanelView = _interopRequireDefault(require(583));
var _MDTabPanelView = _interopRequireDefault(require(81));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDEvents = _interopRequireDefault(require(325));
var _MDFileOperationManager = _interopRequireDefault(require(326));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDFileLogWindowView = _interopRequireDefault(require(576));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDEditalbeTextDiv = _interopRequireDefault(require(29));
var _MDAddTagBigWindow = _interopRequireDefault(require(781));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDDepFilePermissionWinView = _interopRequireDefault(require(565));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDFocusFilePopupView = _interopRequireDefault(require(634));
var _popupPos = _interopRequireDefault(require(65));
var _MDNetDriveFileHandler = _interopRequireDefault(require(1091));
var _MDFileRelationListView = _interopRequireDefault(require(579));
var _MDProgressBar = _interopRequireDefault(require(338));
var _MDFileActionController = _interopRequireDefault(require(492));
var _MDEditResponsiblePersonWinView = _interopRequireDefault(require(570));
var _MDProjectCreateWinView = _interopRequireDefault(require(652));
var _MDDepControlFileListWinView = _interopRequireDefault(require(562));
var _MDDepSecretFileListWinView = _interopRequireDefault(require(568));
var _MDDepShareFileListWinView = _interopRequireDefault(require(569));
var _MEStaffNavigationPageView = _interopRequireDefault(require(148));
var _MDArchiveReadingRoomCreateWinView = _interopRequireDefault(require(527));
var _MDFileOpStatisitcsWindow = _interopRequireDefault(require(577));
var _MDChannelType = _interopRequireDefault(require(717));
var _MDLoadMaskView = _interopRequireDefault(require(49));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDManageApplyUserWinView = _interopRequireDefault(require(628));
var _MDAddAITagWinView = _interopRequireDefault(require(560));
var _MDFileThumbEditWinView = _interopRequireDefault(require(581));
var _MDRecoverFileThumbWinView = _interopRequireDefault(require(592));
var _MDEditFileAttrWinView = _interopRequireDefault(require(597));
/**
 *  File information panel view
 *  Created by manjun.han
 *  2015.9.2
 */

var MDFileInforDetailTabPanelView = _MDTabPanelView["default"].extend({
  tmpl: "<div class=\"info-content\">\n      <div class=\"inforwrapper\">\n\n      <div class=\"desc base-desc base-sec splider-sec\">\n        <div class = \"inforwrapper-head base-desc flex-align between\">\n          <span class = \"f-emph\"><%=commonCap%></span>\n\n          <button class=\"text-button done create-dir\n          <%if(!canCreateFolderDir || forClient){%>\n            f-none\n          <%}%>\n          \"><%=BabelStr.str(2624)%></button>\n\n        </div>\n        <%if(manuscriptStatusStr) {%>\n          <div class=\"flex-align\">\n            <div class=\"desc-label\"><%=BabelStr.str(6008)%>\uFF1A</div>\n            <div class=\"manuscriptStatus-text\"><%=manuscriptStatusStr%></div>\n          </div>\n        <%}%>\n        <div class=\"progress-bar-block mgtb-10 f-none\"></div>\n        <div class=\"file-remark\">\n          <div class=\"desc-label\"><%=tipCap%>\uFF1A</div>\n          <div class=\"remarksdiv\">\n          </div>\n        </div>\n        <div class=\"flex-align between \">\n          <span class=\"desc-label\"><%=typeCap%>\uFF1A</span>\n          <div class=\"flex-align between fullfill with-wrap\">\n            <span class='mgr-20'><%=fileType%></span>\n            <%if(subProject && canEditProject && !forClient) {%>\n                <button class=\"text-button done to-root-project\"><%=BabelStr.str(2830)%></button>\n            <%} else if(rootProject && canEditProject && !forClient){%>\n                <button class=\"text-button done to-sub-project\"><%=BabelStr.str(2829)%></button>\n            <%} else if(isManuscriptBox && canManageMsBox && !forClient){%>\n              <button class=\"text-button done manage-msbox\"><%=BabelStr.str(180)%></button>\n            <%}%>\n          </div>\n\n        </div>\n        <%if(!multFile){%>\n          <div class=\"hide-4-link\"><span class=\"desc-label\"><%=sizeCap%>\uFF1A</span><span class=\"f-size\"><%=fileSize%></span></div>\n        <%}%>\n\n        <%if(!inTrash){%>\n          <div id=\"js-share-state\" class=\"hide-4-link flex-align between\">\n            <div class=\"flex-align\">\n              <span class=\"desc-label\"><%=shareCap%>\uFF1A</span>\n              <span id=\"shareState\" class=\"text-over\"></span>\n            </div>\n            <%if(canShare){%>\n              <span id=\"share-btn\" class=\"f-fr done text-button\"><%=BabelStr.str(13)%></span>\n            <%}%>\n          </div>\n        <%}%>\n        <div id=\"js-lock-state\">\n\n        </div>\n        <%if(deleteVersion || inTrash){%>\n          <div class=\"flex-align\"><span class=\"desc-label no-shrink\"><%=deleteByCap%>\uFF1A</span><span class=\"middle-ellipsis\"><%=deletor%></span></div>\n          <div class=\"flex-align\"><span class=\"desc-label no-shrink\"><%=delTimeCap%>\uFF1A</span><span class=\"mtime middle-ellipsis\"><%=deleteTime%></span></div>\n          <%if (!isFolder && !deleteVersion && !linkedFile) {%>\n            <div><span class=\"desc-label\"><%=verCap%>\uFF1A</span><span><%=verIndexCap%></span></div>\n          <%}%>\n          <div class=\"flex-align\"><span class=\"desc-label no-shrink\"><%=BabelStr.str(48285)%>\uFF1A</span><span class=\"middle-ellipsis origin-path\"><%=originPath%></span></div>          \n          <div class=\"flex-align\"><span class=\"desc-label no-shrink\"></span><span class=\"text-button done show-full-path\"><%=BabelStr.str(42888)%></span></div>\n\n        <%}else{%>\n          <div class=\"attr-line\"><span class=\"desc-label\"><%=creatorCap%>\uFF1A</span><span class=\"span-220 text-over middle-ellipsis\"><%=creator%></span></div>\n          <%if(isLibrary || isClassify){%>\n            <div class=\"attr-line\"><span class=\"desc-label\"><%=BabelStr.str(1053)%>\uFF1A</span><span class=\"span-220 text-over manager-text\" data-tooltip-dir=\"top\">...</span></div>\n          <%}%>\n          <%if(isFolder && !multFile){%>\n            <div class=\"hide-4-link flex-align\"><span class=\"desc-label\"><%=includeCap%>\uFF1A</span><span class=\"text-loading sub-files-num\"><button class=\"calc-btn text-button\"><%=clickCalc%></button></span></div>\n          <%}%>\n          <div><span class=\"desc-label\"><%=createTimeCap%>\uFF1A</span><span><%=createTime%></span></div>\n          <div><span class=\"desc-label\"><%=modifyTimeCap%>\uFF1A</span><span class=\"mtime\"><%=lastModified%></span></div>\n          <%if(showManagerStyle) {%>\n            <div class=\"flex-align between middle editorResPersonContain\">\n              <span class=\"attr-line flex-align\">\n                <span class=\"desc-label\"><%=BabelStr.str(2747)%>\uFF1A</span>\n                <span class='managerName text-hide'><%=managerName%></span>\n              </span>\n              <button class=\"text-button done f-fr no-shrink editorResPerson\"><%=BabelStr.str(2748)%></button>\n            </div>\n          <%}%>\n          <%if (!isFolder && !linkedFile){%>\n            <div><span class=\"desc-label\"><%=verCap%>\uFF1A</span><span><%=verIndexCap%></span></div>\n          <%}%>\n          <%if(showSecrity && !isArchive && !forClient){%>\n            <div class=\"flex-align marginT-6 between\">\n              <span class=\"desc-label no-shrink\"><%=BabelStr.str(3337)%>\uFF1A</span>\n              <div class=\"flex-align between with-wrap fullfill\">\n                <span class=\"security-select fullfill mgr-10\"></span>\n                <span class=\"about-secrity text-button done no-shrink\"><%=BabelStr.str(7385)%></span>\n                </div>\n            </div>\n          <%}%>\n          <%if(isReadingRoom) {%>\n            <div>\n              <span class=\"desc-label\"><%=BabelStr.str(2575)%>\uFF1A</span>\n              <span class=\"reading-room-type\"></span>\n              <%if(canArchive) {%>\n                <button class=\"text-button done mgl-20 edit-reading-room\"><%=BabelStr.str(2503)%></button>\n              <%}%>\n            </div>\n            <div class=\"flex-align archive-limit-dep-block\">\n              <span class=\"no-shrink desc-label><%=BabelStr.str(2576)%>\uFF1A</span>\n              <span class=\"archive-limit-dep\"></span>\n            </div>\n          <%}%>\n\n        <%}%>\n        <%if(fileLocked){%>\n          <div><span class=\"desc-label pdr-10\"><%=fileLockedCap%></span></div>\n\n        <%}%>\n        <%if(isManuscriptBox){%>\n          <div id=\"js-review-end\">\n            <div><span class=\"desc-label\"><%=endtimeCap%>\uFF1A</span><span><%=endTime%></span></div>\n          </div>\n        <%}%>\n      </div>\n      <div class = \"meta-wrapper splider-sec desc\">\n        <div class = \"between flex-align meta-wrapper-head\">\n          <span class = \"meta-ope f-emph sign-info open\"><%=BabelStr.str(8539)%></span>\n        </div>\n        <div class=\"detail\">\n          <div class=\"flex-align\">\n            <span class=\"desc-label no-shrink\"><%=BabelStr.str(8533)%>\uFF1A</span>\n            <span class=\"shooting-time text-hide\"></span>\n          </div>\n          <div class=\"flex-align\">\n            <span class=\"desc-label no-shrink\"><%=BabelStr.str(8534)%>\uFF1A</span>\n            <span class=\"size-info text-hide\"></span>\n          </div>\n          <div class=\"flex-align\">\n            <span class=\"desc-label no-shrink\"><%=BabelStr.str(8535)%>\uFF1A</span>\n            <span class=\"resolving-power text-hide\"></span>\n          </div>\n          <div class=\"flex-align\">\n            <span class=\"desc-label no-shrink\"><%=BabelStr.str(8536)%>\uFF1A</span>\n            <span class=\"equipment-model text-hide\"></span>\n          </div>\n          <div class=\"flex-align\">\n            <span class=\"desc-label no-shrink\"><%=BabelStr.str(8537)%>\uFF1A</span>\n            <span class=\"color-space text-hide\"></span>\n          </div>\n          <div class=\"flex-align\">\n            <span class=\"desc-label no-shrink\"><%=BabelStr.str(8538)%>\uFF1A</span>\n            <span class=\"place\"></span>\n          </div>\n        </div>\n\n      </div>\n      <%if(showCustomAttr){%>\n        <div class = \"custom-attr splider-sec\">\n          <div class=\"flex-align between with-wrap\">\n            <div class = \"custom-attr-head\">\n              <span class = \"f-emph custom-attr-ope sign-info close base-desc\"><%=customAttrCap%></span>\n            </div>\n            <span class = \"edit-custom-attr f-fr font-color-blue\">\n                <button class='text-button done'><%=customAttrEditCap%></button>\n            </span>\n          </div>\n          <div class = \"desc custom-attr-contain detail base-desc f-hide\">\n            <div class=\"custom-attr-list\"></div>\n          </div>\n        </div>\n      <%}%>\n    <%if(!inTrash && !isArchive ){%>\n      <%if(canReadComment && !forClient){%>\n        <div class=\"tag-wrapper base-sec splider-sec base-desc\">\n          <div class = \"tag-wrapper-head flex-align between\">\n            <span class = \"f-emph tag-ope sign-info open\"><%=tagCap%>(<span class = \"tag-count\"><%=tagCount%></span>)</span>\n            <div class=\"flex-align middle end aitag f-hide\">\n              <div class=\"text-button done add-aitag small\"><%=BabelStr.str(12650)%></div>\n              <div class=\"loading-block\">\n                <span class=\"dot\"></span>\n                <span class=\"dot\"></span>\n                <span class=\"dot\"></span>\n                <span class=\"dot\"></span>\n              </div>\n            </div>\n          </div>\n          <div class = \"tag-contain detail flex-align with-wrap middle\">    </div>\n        </div>\n        <%}%>\n\n      <%if(canFocus){%>\n        <div class = \"focus-wrapper splider-sec\">\n          <div class = \"between flex-align focus-wrapper-head\">\n            <span class = \"focus-ope f-emph sign-info open\"><%=focusCap%>(<span class = \"focus-count\">0</span>)</span>\n            <span class = \"edit-focus f-fr font-color-blue\">\n              <button class='text-button done'><%=focus%></button>\n            </span>\n            </div>\n          <div class = \"focus-contain detail\">    </div>\n        </div>\n      <%}%>\n\n      <%if(canReadFileLog || canReadComment){%>\n        <div class = \"access-log splider-sec\">\n          <div class=\"flex-align between with-wrap\">\n            <%if(canReadComment){%>\n              <div class = \"access-log-head\">\n                <span class = \"f-emph access-log-ope sign-info close base-desc\"><%=censusCap%></span>\n              </div>\n            <%}%>\n            <%if(canReadFileLog){%>\n              <span class = \"display-file-log f-fr font-color-blue\">\n                  <button class='text-button done'><%=viewLogCap%></button>\n              </span>\n            <%}%>\n          </div>\n          <%if(canReadComment){%>\n            <div class = \"desc access-log-contain detail f-hide base-desc\">\n              <%if(beloneLibrary){%>\n                <div class=\"desc-item flex-align between apply-download-block\">\n                  <div class=\"no-shrink\">\n                    <span class=\"desc-label\"> <%=BabelStr.str(12550)%>\uFF1A</span><span id=\"js-apply-download-count\"><%=BabelStr.str(3251)%></span>\n                  </div>\n                  <span class=\"text-button done f-none manage-apply-download\"><%=BabelStr.str(12551)%></span>\n                </div>\n              <%}%>\n\n              <div class=\"flex-align between with-wrap\">\n                <div class=\"desc-item\">\n                  <span class=\"desc-label hide-4-link\"> <%=commentNumCap%>\uFF1A</span><span id=\"js-comment-total-count\"><%=BabelStr.str(3251)%></span>\n                </div>\n                <div class=\"desc-item\">\n                  <span class=\"desc-label\"> <%=readCap%>\uFF1A</span><span id=\"js-access-user-count\"> <%=BabelStr.str(3251)%></span>\n                </div>\n              </div>\n              <div class=\"flex-align between with-wrap\">\n                <div class=\"desc-item\">\n                  <span class=\"desc-label\"> <%=openCap%>\uFF1A</span><span id=\"js-open-count\"> <%=BabelStr.str(3251)%></span>\n                </div>\n              </div>\n              <div class=\"desc-item\">\n                <div><span class=\"desc-label\"><%=visitorsCap%>\uFF1A</span><span class = \"f-hide empty\">--</span></div>\n              </div>\n              <div class=\"user-list\"></div>\n            </div>\n            <%}%>\n        </div>\n      <%}%>\n      <%if(isFolder && isEpVersion){%>\n        <div class=\"thumb-block splider-sec pdb-10\">\n          <div class=\"flex-align between with-wrap\">\n            <div class = \"thumb-block-head\">\n              <span class = \"f-emph thumb-block-ope sign-info close base-desc\"><%=BabelStr.str(40100)%></span>\n            </div>\n            <span class = \"change-thumb f-fr font-color-blue\">\n                <button class='text-button done'><%=BabelStr.str(40101)%></button>\n            </span>\n          </div>\n          <div class=\"flex-align middle center detail mgt-10\">\n            <div class=\"custom-thumn thumb-60\"></div>\n          </div>\n          <div class=\"flex-align center recover-block\">\n            <div class=\"recover-thumb text-button done\"><%=BabelStr.str(40112)%></div>\n          </div>\n        </div>\n      <%}%>\n      <div class = \"file-relation-sec base-sec splider-sec\">\n      <div class = \"relation-head\">\n      <span class = \"f-emph file-relation-ope sign-info open base-desc\"><%=relateCap%></span>\n\n      </div>\n      <div class = \"desc file-relate-contain detail base-desc\">\n      <div>hehehe</div>\n      </div>\n      </div>\n\n      <div class=\"manage-btns  mgb-10\">\n        <%if(canManageFilePermission && !forClient){%>\n\n          <%if(!noFileControl){%>\n            <div class = \"dep-file-permission  base-desc\">\n              <button class=\"text-button dep-per-btn done shwoFilePermission\"><%=BabelStr.str(262)%></button>\n            </div>\n          <%}%>\n          <%if(isFolder){%>\n            <div class = \"dep-file-share  base-desc\">\n            <button class=\"text-button dep-per-btn done shwoFileShare \"><%=BabelStr.str(2842)%></button>\n            </div>\n          <%}%>\n          <%if(isDepFolder){%>\n            <div class = \"dep-user-manage  base-desc\">\n              <button class=\"text-button dep-per-btn done manageDepInfo \"><%=BabelStr.str(2508)%></button>\n            </div>\n            <div class = \"dep-user-manage  base-desc\">\n              <button class=\"text-button dep-per-btn done manageDepUser \"><%=BabelStr.str(3316)%></button>\n            </div>\n            <div class = \"dep-file-list  base-desc\">\n            <button class=\"text-button dep-per-btn done shwoFileList \"><%=BabelStr.str(2614)%></button>\n            </div>\n            <div class = \"dep-file-list  base-desc \">\n            <button class=\"text-button dep-per-btn done shwoSecricFileList \"><%=BabelStr.str(2856)%></button>\n            </div>\n            <div class = \"dep-file-list  base-desc\">\n            <button class=\"text-button dep-per-btn done shwoStatistic \"><%=BabelStr.str(3486)%></button>\n            </div>\n          <%}%>\n\n       <%}%>\n\n      <%if(canshowEditProject && !forClient){%>\n        <div class = \"dep-file-list  base-desc \">\n          <button class=\"text-button done dep-per-btn  showEditProject\"><%=BabelStr.str(2833)%></button>\n        </div>\n      <%}%>\n      <%if(canshowEditTransmittalProject && !forClient){%>\n        <div class = \"dep-file-list  base-desc \">\n          <button class=\"text-button done dep-per-btn showEditTrProject\"><%=BabelStr.str(2833)%></button>\n        </div>\n      <%}%>\n      <%if(canShowFileControl){%>\n      <div class = \"dep-file-list  base-desc \">\n        <button class=\"text-button done dep-per-btn showUserPerInfo\"><%=BabelStr.str(8571)%></button>\n      </div>\n      <%}%>\n      <%if(canShowFileControl && canShare){%>\n        <div class = \"dep-file-list  base-desc \">\n          <button class=\"text-button done dep-per-btn showSharePerInfo\"><%=BabelStr.str(21922)%></button>\n        </div>\n        <%}%>\n    </div>\n  <%}%>\n  </div>",
  className: function className() {
    var superCls = _MDTabPanelView["default"].prototype.className.call(this);
    return superCls + " m-fileDetail";
  },
  initialize: function initialize(opt) {
    opt.showNavigationBar = false;
    _MDTabPanelView["default"].prototype.initialize.call(this, opt);
    this.$(".dep-file-permission").hide();
    _Dispatcher["default"].on(_MDEvents["default"].RefreshIcon, this._refreshIcon, this);
  },
  _refreshIcon: function _refreshIcon(params) {
    var fileId = params.fileId;
    if (this.fileInfor && this.fileInfor.getFileId() == fileId) {
      this.fileInfor.setIconForDiv(this.$(".custom-thumn"), null, 60);
    }
  },
  _fileInfoActionsChanged: function _fileInfoActionsChanged() {
    if (this.fileInfor.canCreateFolderDir() && !app.pathRouter.isInTrash()) {
      this.$(".create-dir").show();
    } else {
      this.$(".create-dir").hide();
    }
    if (this.fileInfor.canManageFilePermission() && app.isEpVersion() && !app.pathRouter.inTrash() && !this.fileInfor.isEpPublicFolder() && !this.fileInfor.belongEnterprisePub()) {
      this.$(".dep-file-permission").show();
    } else {
      this.$(".dep-file-permission").hide();
    }
    console.warn("22222");
  },
  createProgress: function createProgress() {
    var _this = this;
    _MDProgressBar["default"].createProgressbarInDom(this.$(".progress-bar-block"));
    setTimeout(function () {
      _MDProgressBar["default"].setProgress(_this.$(".progress-bar-block"), 0.5);
    }, 400);
  },
  initProps: function initProps() {
    var superP = _MDTabPanelView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      focusCollection: new _MDMolaUserCollection["default"]()
    });
  },
  events: function events() {
    var superE = _MDTabPanelView["default"].prototype.events.call(this);
    return _.extend(superE, {
      "click .tag-del ": this.removeTagCLickHandle,
      "click .focus-item-ope ": this.removeFocusUserCLickHandle,
      "click .display-file-log": this.displayFileLogClickHandle,
      "click .attr-addtag": this.addTagToFile,
      "click .sign-info": this.toggleContain,
      // 'click .access-log-ope': this.toggleAccessContain,

      "click .shwoFilePermission": this._showFilePermissionExtraWin,
      "click .about-secrity": this._showAboutSecrity,
      "click .edit-focus": this._editFocus,
      "click .create-dir": this._createDir,
      "click #share-btn": this._shareFile,
      "click .editorResPerson": this._editorResPerson,
      "click .to-sub-project": this._toSubProject,
      "click .to-root-project": this._toRootProject,
      "click .shwoSecricFileList": this._shwoSecricFileList,
      "click .shwoFileList": this._shwoFileList,
      "click .shwoFileShare": this._shwoFileShare,
      "click .manage-msbox": this.editMasuscriptBox,
      "click .showEditProject": this._showEditProject,
      "click .showEditTrProject": this._showEditTrProject,
      "click .manageDepInfo": this._manageDepInfo,
      "click .manageDepUser": this._manageDepUser,
      "click .edit-reading-room": this._showReadingRoom,
      "click .shwoStatistic": this._showStatisticWin,
      "click .shwoUpload": this._manageDepUser,
      "click .calc-btn": this._calcuFileNum,
      "click .showUserPerInfo": this._showUserPerInfo,
      "click .showSharePerInfo": this._showSharePerInfo,
      "click .manage-apply-download": this._manageApplyDownloadUser,
      "click .add-aitag": this._addAiTag,
      "click .change-thumb": this.changeThumb,
      "click .recover-thumb": this.recoverThumb,
      "click .edit-custom-attr": this._editCustomAttr,
      "click .show-full-path": this._showFullPath
    });
  },
  recoverThumb: function recoverThumb() {
    var win = new _MDRecoverFileThumbWinView["default"]({
      fileInfor: this.fileInfor
    });
    win.show();
  },
  _fetchCustomAttr: function _fetchCustomAttr() {
    var _this2 = this;
    if (!app.isEpVersion() || !this.fileInfor) {
      return;
    }
    this._ensureEntCustomAttrs(function () {
      var cached = _this2.fileInfor.get("customAttrs");
      if (cached) {
        _this2._customAttrData = cached;
        _this2._renderCustomAttr(cached);
        _this2._autoExpandCustomAttr(cached);
        return;
      }
      var fileId = _this2.fileInfor.getFileId();
      _MMEnterpriseController["default"].getFileAttr({
        fileIdArr: [fileId]
      }, function (responseData) {
        if (responseData.fileAttrs && responseData.fileAttrs[fileId]) {
          var attrs = responseData.fileAttrs[fileId];
          _this2.fileInfor.set("customAttrs", attrs);
          _this2._customAttrData = attrs;
          _this2._renderCustomAttr(attrs);
          _this2._autoExpandCustomAttr(attrs);
        }
      }, function () {});
    });
  },
  _autoExpandCustomAttr: function _autoExpandCustomAttr(attrs) {
    var $ope = this.$(".custom-attr-ope");
    var $contain = this.$(".custom-attr-contain");
    $contain.removeClass("f-hide");
    $ope.removeClass("close").addClass("open");
  },
  _ensureEntCustomAttrs: function _ensureEntCustomAttrs(cb) {
    var _this3 = this;
    if (this._entCustomAttrMap) {
      cb();
      return;
    }
    var now = Date.now();
    var cache = window.__MDEditFileAttrCache__;
    if (cache && cache.data && now - cache.time < 10 * 60 * 1000) {
      this._buildEntCustomAttrMap(cache.data);
      cb();
      return;
    }
    _MMEnterpriseController["default"].getEntCustoms(function (customsCollection) {
      var customs = customsCollection.models.map(function (m) {
        return m.toJSON();
      });
      if (!window.__MDEditFileAttrCache__) {
        window.__MDEditFileAttrCache__ = {
          data: null,
          time: 0
        };
      }
      window.__MDEditFileAttrCache__.data = JSON.parse(JSON.stringify(customs));
      window.__MDEditFileAttrCache__.time = Date.now();
      _this3._buildEntCustomAttrMap(customs);
      cb();
    }, function () {
      cb();
    });
  },
  _buildEntCustomAttrMap: function _buildEntCustomAttrMap(customs) {
    var _this4 = this;
    this._entCustomAttrMap = {};
    customs.forEach(function (attr) {
      var attrId = attr.id || attr.attrId;
      _this4._entCustomAttrMap[attrId] = attr;
    });
  },
  _onCustomAttrsChanged: function _onCustomAttrsChanged() {
    var $contain = this.$(".custom-attr-contain");
    if (!$contain.length) return;
    var attrs = this.fileInfor.get("customAttrs");
    this._customAttrData = attrs || [];
    this._renderCustomAttr(this._customAttrData);
    this._autoExpandCustomAttr(this._customAttrData);
  },
  _renderCustomAttr: function _renderCustomAttr(attrs) {
    var _this5 = this;
    var $list = this.$(".custom-attr-list");
    $list.empty();
    if (!attrs || attrs.length === 0) {
      $list.html("<div class=\"empty help-text pdlr-15\">".concat(BabelStr.str(48286), "</div>"));
      return;
    }
    attrs.forEach(function (attr) {
      var value = attr.value;
      var type = attr.type;
      if (type === 4) {
        value = _this5._resolveAttrLabel(attr, value);
      } else if (type === 5) {
        value = _this5._resolveAttrLabels(attr, value);
      } else if (Array.isArray(value)) {
        value = value.join(", ");
      } else if (type === 3 && typeof value === 'number') {
        value = MMCommonFun.formatDate(value, "yyyy-MM-dd");
      }
      var $item = $("<div class=\"custom-attr-item flex-align between\">\n        <span class=\"custom-attr-label middle-ellipsis\">".concat(attr.title, "\uFF1A</span>\n        <span class=\"custom-attr-value middle-ellipsis\">").concat(value || '--', "</span>\n      </div>"));
      $list.append($item);
    });
  },
  _resolveAttrLabel: function _resolveAttrLabel(attr, value) {
    if (value === undefined || value === null || value === '') {
      return '--';
    }
    var altEntries = this._getAltEntries(attr);
    var entry = _.find(altEntries, function (e) {
      return e.id == value;
    });
    return entry ? entry.value : value;
  },
  _resolveAttrLabels: function _resolveAttrLabels(attr, value) {
    if (value === undefined || value === null || value === '') {
      return '--';
    }
    var idArr = Array.isArray(value) ? value : String(value).split(',');
    var altEntries = this._getAltEntries(attr);
    var labels = idArr.map(function (id) {
      var entry = _.find(altEntries, function (e) {
        return e.id == id;
      });
      return entry ? entry.value : id;
    });
    return labels.join(', ');
  },
  _getAltEntries: function _getAltEntries(attr) {
    if (this._entCustomAttrMap) {
      var def = this._entCustomAttrMap[attr.attrId];
      if (def && def.altEntries) {
        return def.altEntries;
      }
    }
    return attr.altEntries || [];
  },
  _editCustomAttr: function _editCustomAttr() {
    var _this6 = this;
    var win = new _MDEditFileAttrWinView["default"]({
      fileInfors: [this.fileInfor],
      fileAttrs: this._customAttrData || [],
      onSave: function onSave(updatedAttrs) {
        _this6.fileInfor.set("customAttrs", updatedAttrs);
        _this6._customAttrData = updatedAttrs;
        _this6._renderCustomAttr(updatedAttrs);
      }
    });
    win.show();
  },
  changeThumb: function changeThumb() {
    var win = new _MDFileThumbEditWinView["default"]({
      fileInfor: this.fileInfor
    });
    win.show();
  },
  render: function render(data) {
    var self = this;
    var f = this.fileInfor;
    if (!f) {
      return;
    }
    this.$el.empty();
    if (f.getFileId() == "0") {
      return;
    }
    _MDSpinnerloaderView["default"].showIn(this.el);
    // var filePathNavView = viewManager.get("filePathNavView");
    var fileName = this.fileInfor.getFileName();
    var sharing = this.fileInfor.isSharing();
    if (app.currentFolder == this.fileInfor) {
      fileName = "";
    }
    var topName = _MMNetDiskDataController["default"].getHomeDir().getFileName();
    var path = "";
    // var fileSize = f.isFolder() ? "--" : app.getFileSizeDescription(f.get('currentVersionSize'));
    var fileSize = app.getFileSizeDescription(f.get("fileSize") || f.get("currentVersionSize"));
    if (f.isDepartmentFolder()) {
      fileSize = "--";
    }
    if (f.isFolder()) {
      fileSize = "<button class=\"calc-btn text-button\">".concat(BabelStr.str(20157), "</button>");
    }
    var unreadedCommentCount = f.get("unreadedCommentCount");
    var totalCommentCount = f.get("commentCount");
    var endTime;
    if (f.getEndTime()) {
      endTime = MMCommonFun.formatSec2Date(f.getEndTime());
    } else {
      endTime = BabelStr.str(177);
    }
    var folderStr = _MDLocalString["default"].getLocalString(8); // 文件夹
    var fileStr = ""; // MDLocalString.getLocalString(1); // 文件

    var verno = f.get("currentVersion");
    if (f.isBabelOffice()) {
      verno--;
    }
    var param = {
      index: verno + 1
    };
    this.fileactionctl = new _MDFileActionController["default"]();
    this.fileactionctl.setFileInfors([f]);
    var verIndexStr = _MDLocalString["default"].getLocalString(283, param);
    var fileType = f.isFolder() ? folderStr : MMCommonFun.getFileExtension1(f.getFileName()) + fileStr;
    if (f.isShortcuts()) {
      fileType = BabelStr.str(2625);
    } else if (f.isSubProject()) {
      fileType = BabelStr.str(2828);
    } else if (f.isProject()) {
      fileType = BabelStr.str(2827);
    } else if (f.isDepartmentFolder()) {
      fileType = BabelStr.str(3215);
    } else if (f.isManuscriptBox()) {
      fileType = BabelStr.str(370);
    } else if (f.isHQSMProject()) {
      fileType = BabelStr.str(5411);
    } else if (f.isMaterialClass()) {
      fileType = BabelStr.str(12541);
    } else if (f.isMaterialLibraryFolder() || f.isMaterialLibrary()) {
      fileType = BabelStr.str(12500);
    }
    var viewLogStr = _MDLocalString["default"].getLocalString(288); // 查看文件日志
    if (this.fileactionctl.canShowStatistics()) {
      viewLogStr = BabelStr.str(7180);
    }
    data = {
      canCreateFolderDir: f.canCreateFolderDir() && f.isFolder() && app.pathRouter && !app.pathRouter.isInTrash(),
      isTeamRootFolder: f.isTeamFolder() && f.getParentFolderId(),
      fileType: fileType,
      isFolder: f.isFolder(),
      linkedFile: f.isShortcuts() || f.getLinkFileUrl(),
      path: path,
      sharing: f.isSharing(),
      creator: f.get("creatorName") || "--",
      createTime: MMCommonFun.formatSec2Date(f.get("ctime")),
      lastModified: MMCommonFun.formatSec2Date(f.get("latestVersionTime")),
      fileSize: fileSize,
      tagCount: f.getTagCollection.length,
      history: f.get("currentVersion") + 1,
      openedCount: 10,
      //临时数据
      dwonloadCount: 20,
      //临时数据
      commentCount: f.get("commentCount"),
      openCount: f.getOpenCount(),
      accessUserCount: f.getAccessUserCount(),
      downloadCount: f.getDownloadCount(),
      canReadFileLog: f.canReadFileLog(),
      isEpVersion: app.isEpVersion(),
      inTrash: app.pathRouter && app.pathRouter.inTrash() && !f.get("searchResult"),
      multFile: f.get("multFile"),
      canReadComment: f.canReadCommentOnlyByAction(),
      isPermissionReadonly: f.isPermissionReadonly(),
      unreadedCommentCount: unreadedCommentCount,
      totalCommentCount: totalCommentCount,
      fileLocked: f.isFileLocked(),
      isManuscriptBox: f.isManuscriptBox(),
      endTime: endTime,
      belongDepartment: f.belongDepartment(),
      showSecrity: (this.fileInfor.belongDepartment() || this.fileInfor.belongEnterprisePub()) && !this.fileInfor.isDepartmentFolder() && !this.fileInfor.isProject(),
      commonCap: _MDLocalString["default"].getLocalString(277),
      // 通用
      tipCap: _MDLocalString["default"].getLocalString(278),
      // 说明
      typeCap: _MDLocalString["default"].getLocalString(279),
      // 类型
      sizeCap: _MDLocalString["default"].getLocalString(27, {
        LowerCase1st: true
      }),
      // 大小
      shareCap: _MDLocalString["default"].getLocalString(13),
      // 分享
      deleteByCap: _MDLocalString["default"].getLocalString(280),
      // 删除人
      delTimeCap: _MDLocalString["default"].getLocalString(281),
      // 删除时间
      verCap: _MDLocalString["default"].getLocalString(282),
      // 版本
      verIndexCap: verIndexStr,
      // 第{-index-}个版本
      viewVerCap: _MDLocalString["default"].getLocalString(284),
      //查看历史版本
      creatorCap: _MDLocalString["default"].getLocalString(68),
      // 创建者
      includeCap: _MDLocalString["default"].getLocalString(5303),
      // 包含
      calcuCap: _MDLocalString["default"].getLocalString(295),
      // 计算中
      createTimeCap: _MDLocalString["default"].getLocalString(296),
      // 创建时间
      modifyTimeCap: _MDLocalString["default"].getLocalString(788),
      // 修改时间
      fileLockedCap: _MDLocalString["default"].getLocalString(285),
      //文件已锁定
      endtimeCap: _MDLocalString["default"].getLocalString(176),
      // 截止日期
      tagCap: _MDLocalString["default"].getLocalString(23),
      // 标签
      focusCap: _MDLocalString["default"].getLocalString(286),
      // 关注者
      censusCap: _MDLocalString["default"].getLocalString(287),
      // 访问统计
      viewLogCap: viewLogStr,
      commentNumCap: _MDLocalString["default"].getLocalString(289),
      // 批注数量
      downloadsCap: _MDLocalString["default"].getLocalString(290),
      //下载次数
      openCap: _MDLocalString["default"].getLocalString(291),
      // 打开次数
      readCap: _MDLocalString["default"].getLocalString(292),
      // 访问人数
      visitorsCap: _MDLocalString["default"].getLocalString(293),
      // 访问人员
      setPermCap: _MDLocalString["default"].getLocalString(262),
      // 增设部门文件权限
      isEpPublicFolder: f.isEpPublicFolder(),
      belongEnterprisePub: f.belongEnterprisePub(),
      canManageFilePermission: f.canManageFilePermission(),
      focus: _MDLocalString["default"].getLocalString(244),
      // 提醒关注
      canFocus: f.canFocus() && f.canReadCommentOnlyByAction() && app.currentUser.logined(),
      relateCap: BabelStr.str(7386),
      canShare: f.canShare(),
      managerName: f.getManagerName() || "--",
      canRanme: f.canRename(),
      rootProject: f.isProject(),
      subProject: f.isSubProject(),
      canEditProject: f.canEditProject() && !f.get("isProjectAssist"),
      isProject: f.isProject(),
      isDepFolder: this.fileInfor.isDepartmentFolder(),
      canManageMsBox: f.canManageMsBox(),
      canshowEditProject: f.isProject() && f.canEditProject(),
      canshowEditTransmittalProject: f.isHQSMProject() && f.canEditProject(),
      canArchive: f.canArchive(),
      isReadingRoom: f.isReadingRoom(),
      isArchive: app.ep && app.ep.isArchive(),
      forClient: f.get("forClient"),
      manuscriptStatusStr: f.getManuscriptStatusText(),
      showManagerStyle: !(app.ep && app.ep.isArchive()) && !f.isHQSMProject(),
      clickCalc: BabelStr.str(20157),
      noFileControl: f.get("templateStoreFolderId") || f.isTemplateStore(),
      canShowFileControl: this.fileactionctl.canShowFileControl(),
      beloneLibrary: f.beloneMaterialLibrary(),
      isLibrary: f.isMaterialLibraryFolder(),
      isClassify: f.isMaterialClass(),
      showCustomAttr: app.isEpVersion() && !f.isDeleted(),
      customAttrCap: BabelStr.str(40237),
      customAttrEditCap: BabelStr.str(2503),
      originPath: f.get("originPath") || "..."
    };
    data["deleteVersion"] = false;
    data["deletor"] = "--";
    if (f.isDeleteVersion()) {
      data["deleteVersion"] = true;
      data["deletor"] = f.get("deleteByUsername") || "--";
      data["deleteTime"] = MMCommonFun.formatSec2Date(f.get("delTime"));
    } else if (f.isInTrash()) {
      data["deleteVersion"] = false;
      data["inTrash"] = true;
      data["deletor"] = f.get("deleteByUsername") || "--";
      data["deleteTime"] = MMCommonFun.formatSec2Date(f.get("delTime"));
    }
    function render() {
      _MDTabPanelView["default"].prototype.render.call(self, data);
      var pathRouter = app.pathRouter;
      if (pathRouter) {
        if (pathRouter.hasTeamFolder() || f.isTeamFolder()) {
          self.$el.find(".file-owner").css("display", "none");
        }
      }
      _MDSpinnerloaderView["default"].clearFrom(self.el);
      self.initRemarks();
      self.initTag();
      self.getAccessUserList(function () {
        self.getFileFocusUsers(function () {
          self.getReadingRoomScope();
        });
      });
    }
    render();
    self._fetchOriginPath();
    // // setTimeout(() => {
    //   if (this.fileInfor.canManageFilePermission() && !this.fileInfor.isEpPublicFolder() && !this.fileInfor.belongEnterprisePub()) {
    //     this.$('.dep-file-permission').show();
    //   } else {
    //     this.$('.dep-file-permission').hide();
    //   }
    // // }, 500);

    if (f.isShortcuts()) {
      this.$(".hide-4-link").addClass("f-none");
    } else {
      this.$(".hide-4-link").removeClass("f-none");
    }
    if ((f.canCreateFolderDir() || f.canEditProject() && f.isProject()) && app.pathRouter && !app.pathRouter.isInTrash() && f.isFolder()) {
      this.$(".create-dir").html(BabelStr.str(2624));
      this.$(".create-dir").removeClass("f-none");
    } else {
      this.$(".create-dir").addClass("f-none");
    }
  },
  _calcuFileNum: function _calcuFileNum() {
    this.requestSubFilesNum();
  },
  _fetchOriginPath: function _fetchOriginPath() {
    var self = this;
    var f = this.fileInfor;
    if (!f || !f.isInTrash() && !f.isDeleteVersion()) return;

    // Check if already cached
    if (f.get("originPath")) {
      this._renderOriginPath(f.get("originPath"));
      return;
    }
    var path = f.get("path");
    if (!path) return;

    // Parse path string like "/123/456/789/0/"
    var ids = path.split("/").filter(function (id) {
      return id;
    });
    if (ids.length === 0) return;

    // Separate "0" (root) from other file ids
    var rootIds = ids.filter(function (id) {
      return id === "0";
    });
    var fileIds = ids.filter(function (id) {
      return id !== "0";
    });

    // Determine root name based on file type
    var rootName = "";
    if (f.belongDepartment()) {
      rootName = BabelStr.str(337); // 企业文件
    } else if (f.isOwner()) {
      rootName = BabelStr.str(388); // 个人文件夹
    } else {
      rootName = BabelStr.str(337); // 默认企业文件
    }
    if (fileIds.length === 0) {
      // Only root, show just root name
      var originPath = "/" + rootName;
      f.set("originPath", originPath);
      self._renderOriginPath(originPath);
      return;
    }
    _MDNetDriveFileHandler["default"].getFileInfosFromServer(fileIds, false, function (fileInfos) {
      if (!fileInfos || fileInfos.length === 0) return;
      var nameMap = {};
      fileInfos.forEach(function (fileInfo) {
        nameMap[fileInfo.getFileId()] = fileInfo.getFileName();
      });

      // Build path names array (excluding "0")
      var pathNames = [];
      ids.forEach(function (id) {
        if (id === "0") return;
        if (nameMap[id]) {
          pathNames.push(nameMap[id]);
        }
      });

      // Reverse the path to show from root to leaf
      pathNames.reverse();

      // Build final path with root name
      var originPath = "/" + rootName + "/" + pathNames.join("/");
      f.set("originPath", originPath);
      self._renderOriginPath(originPath);
    }, function () {
      // Failed to fetch, keep showing ...
    });
  },
  _renderOriginPath: function _renderOriginPath(originPath) {
    if (originPath) {
      this.$(".origin-path").html(originPath);
      // this.$(".origin-path").attr("title", originPath);
    }
  },
  _showFullPath: function _showFullPath() {
    var f = this.fileInfor;
    if (!f) return;
    var originPath = f.get("originPath") || "";
    var alert = new _MDAlertView["default"]();
    alert.show({
      title: BabelStr.str(48285),
      message: '<p class="title">' + _.escape(originPath) + '</p>',
      className: 'm-delAlertWin',
      width: 500,
      buttons: [{
        label: BabelStr.str(154),
        type: 'done'
      }]
    });
  },
  _showReadingRoom: function _showReadingRoom() {
    var _this7 = this;
    var readingScopes = this.fileInfor.get("readingScopes");
    var win = new _MDArchiveReadingRoomCreateWinView["default"]({
      readingScopes: readingScopes,
      edit: true,
      fileInfor: this.fileInfor,
      refreshReadingRoomScope: function refreshReadingRoomScope() {
        _this7.getReadingRoomScope();
      }
    });
    win.show();
  },
  getReadingRoomScope: function getReadingRoomScope() {
    var _this8 = this;
    if (!this.fileInfor.isReadingRoom()) {
      return;
    }
    this.fileInfor.unset("readingScopes", {
      silent: true
    });
    _MMEnterpriseController["default"].getReadingRoomScope(this.fileInfor.getFileId(), function (result) {
      _this8.fileInfor.set("readingScopes", result);
      // this.renderReadingRoom()
    }, function () {});
  },
  renderReadingRoom: function renderReadingRoom() {
    var readingScopes = this.fileInfor.get("readingScopes");
    var levelData = {
      1: BabelStr.str(3350),
      //公开
      2: BabelStr.str(3471),
      //需要借阅
      3: BabelStr.str(3473),
      //限定部门内公开
      4: BabelStr.str(3472) //限定部门内可借阅
    };
    var type = readingScopes.style.openType;
    var typeStr = levelData[type];
    this.$(".reading-room-type").html(typeStr);
    if (type == 1 || type == 2) {
      this.$(".archive-limit-dep-block").remove();
    } else if (type == 3 || type == 4) {
      var deps = _.pluck(readingScopes.departments, "name");
      var depStrs = deps.join("，") || "暂无";
      this.$(".archive-limit-dep").html(depStrs);
    }
  },
  _addAiTag: function _addAiTag() {
    var ctl = new _MDFileActionController["default"]();
    ctl.setFileInfors([this.fileInfor]);
    ctl.addAITag(this.$(".aitag"));
  },
  _toSubProject: function _toSubProject() {
    var win = new _MDProjectCreateWinView["default"]({
      type: 3,
      fileId: this.fileInfor.getFileId()
    });
    win.show();
  },
  _toRootProject: function _toRootProject() {
    var win = new _MDProjectCreateWinView["default"]({
      type: 4,
      fileId: this.fileInfor.getFileId()
    });
    win.show();
  },
  /**
   * 安全级别介绍
   */
  _showAboutSecrity: function _showAboutSecrity() {
    _MDAlertView["default"].showAboutSecurity();
  },
  _createDir: function _createDir() {
    var _this9 = this;
    // this.$('.progress-bar-block').show();
    // this.createProgress();
    this.$(".create-dir").attr("disabled", true);
    this.$(".create-dir").html(BabelStr.str(5461)).addClass("loading");
    _MMEnterpriseController["default"].generateExcelOfFileStruct(this.fileInfor.getFileId(), function (url) {
      var curFolderId = app.pathRouter.getFilePaths()[app.pathRouter.getFilePaths().length - 1].getFileId();
      if (_this9.fileInfor.getFileId() == curFolderId) {
        _Dispatcher["default"].trigger(_MDEvents["default"].RefreshCurFolder);
      } else {
        // app.pathRouter.navigateToPath('file/' + this.fileInfor.getFileId());
        _Dispatcher["default"].trigger(_MDEvents["default"].OpenFile, {
          fileId: _this9.fileInfor.getFileId(),
          fileInfo: _this9.fileInfor
        });
      }
      _this9.downloadFile(url);
      _this9.$(".create-dir").attr("disabled", false);
      _this9.$(".create-dir").html(BabelStr.str(2624)).removeClass("loading");
    }, function (err) {
      _MDSnackbarView["default"].show(err["msg"]);
      _this9.$(".create-dir").attr("disabled", false);
      _this9.$(".create-dir").html(BabelStr.str(2624)).removeClass("loading");
    });
  },
  downloadFile: function downloadFile(url) {
    var $a = $("<a href=\"".concat(url, "\">").concat(BabelStr.str(29), "</a>"));
    $("body").append($a);
    $a[0].click();
    $a.remove();
  },
  setFileInfor: function setFileInfor(fileInfor) {
    var _this10 = this;
    if (!fileInfor) {
      return;
    }
    this.accessLoaded = false;
    this._customAttrData = null;
    if (this.fileInfor) {
      this.stopListening(this.fileInfor, "change:mtime");
      this.stopListening(fileInfor, "change:focusCount");
      this.stopListening(this.fileInfor, "change:customAttrs");
    }
    this.listenTo(fileInfor, "change", this.fileInforAttrChangedHandler);
    this.listenTo(fileInfor, "change:customAttrs", this._onCustomAttrsChanged);
    this.fileInfor = fileInfor;
    this.tagCollection = this.fileInfor.getTagCollection();
    this.stopListening(this.tagCollection);
    this.listenTo(this.tagCollection, "add", this.initTag);
    this.listenTo(this.tagCollection, "remove", this.initTag);
    this.listenTo(this.tagCollection, "change:canDelete", this.initTag);
    this.listenTo(app.currentFolder, "change", this.folderShareStatusChange);
    this.listenTo(this.fileInfor, "change:actions", this._fileInfoActionsChanged);
    this.listenTo(this.fileInfor, "change:readingScopes", this.renderReadingRoom);
    this.render();
    this._fetchOriginPath();
    this._fetchCustomAttr();
    if (fileInfor.getFileId() == "0") {
      this.$(".base-desc").addClass("f-none");
    } else {
      this.$(".base-desc").removeClass("f-none");
    }
    if (!this.fileInfor.get("forClient") && this.fileInfor.canManageFilePermission() && app.isEpVersion() && !app.pathRouter.inTrash() && !this.fileInfor.isEpPublicFolder() && !this.fileInfor.belongEnterprisePub()) {
      this.$(".dep-file-permission").show();
      this.$(".editorResPerson").show();
    } else {
      this.$(".dep-file-permission").hide();
      this.$(".editorResPerson").hide();
    }
    if (this.fileInfor.isDepartmentFolder() || this.fileInfor.isProject() || this.fileInfor.get("forClient") || !app.ep.getUseFileManager() || app.ep.isArchive() || this.fileInfor.isEpPublicFolder()) {
      this.$(".editorResPersonContain").addClass("f-hide");
    } else {
      this.$(".editorResPersonContain").removeClass("f-hide");
    }
    if (this.fileInfor.canRead()) {
      this.$(".hide-4-link").removeClass("f-hide");
    } else {
      this.$(".hide-4-link").addClass("f-hide");
    }
    if (this.verlistView) {
      this.verlistView.setFileInfor(fileInfor);
    }
    this._refreshShareStatus();
    this._refreshCheckStatus();
    if ((this.fileInfor.belongDepartment() || this.fileInfor.belongEnterprisePub()) && app.ep && !app.ep.isArchive()) {
      this.fileInfor.getSecretLevelsForFile(function (list, curLevelSetted) {
        // let secretLevelId = this.fileInfor.getSecretLevelId();
        curLevelSetted = _.isUndefined(curLevelSetted) ? _this10.fileInfor.getSecretLevelId() : curLevelSetted;
        var index = _.findIndex(list, {
          id: curLevelSetted
        });
        if (index < 0) {
          index = 0;
          list = [{
            id: -1,
            comment: BabelStr.str(21944),
            commentEn: BabelStr.str(21944)
          }].concat(list);
        }
        if (_this10.fileInfor.canManageSecret() && _this10.$(".security-select").length) {
          _this10.securitySelect = new _MDDropdownSelectListView["default"]({
            dataProvider: list,
            labelField: "comment",
            selectedIndex: index,
            interceptor: function interceptor(data) {
              if (app.ep.canShowSecurityPolicyModel()) {
                return true;
              }
              var opt = {
                message: BabelStr.str(6118)
              };
              _MDAlertView["default"].showStandardPrompt(opt);
              return false;
            },
            onChange: function onChange(data) {
              _this10.setFileSecurity(data);
            }
          });
          _this10.$(".security-select").empty();
          _this10.addSubView(_this10.securitySelect, _this10.$(".security-select")[0]);
        } else if (index > -1) {
          var secretName = list[index].comment;
          _this10.$(".security-select").html(secretName);
        }
      });
    } else {
      this.$(".security-select").hide();
    }

    // if (fileInfor.canReadCommentOnlyByAction()) {
    //   MDNetDriveFileHandler.updateFileVisitInfo(fileInfor);
    // }

    if (fileInfor.isFolder()) {
      this.$(".file-relation-sec").hide();
      fileInfor.setIconForDiv(this.$(".custom-thumn"), null, 60);
    } else {
      this.$(".file-relation-sec").show();
      if (this.fileRelationListView) {
        this.fileRelationListView.removeFromSuperView();
      }
      this.$(".file-relate-contain").empty();
      if (!this.fileInfor.isInTrash() && this.fileInfor.canReadCommentOnlyByAction()) {
        this.fileRelationListView = new _MDFileRelationListView["default"]({
          fileInfo: this.fileInfor
        });
        this.addSubView(this.fileRelationListView, this.$(".file-relate-contain"));
      } else {
        this.$(".file-relation-sec").remove();
      }
    }
    this.$('.manage-apply-download').hide();
    this.refreshMetaData(fileInfor);
    if (fileInfor.isMaterialLibraryFolder() || fileInfor.isMaterialClass()) {
      _MMEnterpriseController["default"].getMaterialManagers(fileInfor.getFileId(), function (managers) {
        var names = _.pluck(managers, "name");
        var nameStr = names.join('、') || '--';
        _this10.$(".manager-text").html(nameStr).attr("data-tooltip", nameStr);
      });
    }
    this.refreshRecoverBtn(fileInfor);
  },
  refreshRecoverBtn: function refreshRecoverBtn(fileInfor) {
    var customIcon4File = fileInfor.get("customIcon4File");
    if (customIcon4File) {
      if (customIcon4File.customIconId || customIcon4File.asIconType) {
        this.$(".recover-thumb").removeClass("f-hide");
      } else {
        this.$(".recover-thumb").addClass("f-hide");
      }
    }
  },
  refreshMetaData: function refreshMetaData(fileInfor) {
    var _this11 = this;
    if (fileInfor.hasMetaData() && window.user.useAdvancedSearch) {
      this.$(".meta-wrapper").removeClass("f-hide");
      var metaData = fileInfor.get("metaData");
      if (metaData) {
        this.renderMetaData(metaData, fileInfor);
      } else {
        _MMEnterpriseController["default"].getMetaData(fileInfor.getFileId(), fileInfor.getCurVersion(), function (metaData) {
          fileInfor.set("metaData", metaData);
          _this11.renderMetaData(metaData, fileInfor);
        }, console.error);
      }
    } else {
      this.$(".meta-wrapper").addClass("f-hide");
    }
  },
  renderMetaData: function renderMetaData(metaData, fileInfor) {
    var _this12 = this;
    if (!metaData) {
      return;
    }
    var data = metaData.meta_data;
    if (!data) {
      this.$(".meta-wrapper").addClass("f-hide");
      return;
    }
    var capture_time = new Date(data.capture_time).format("yyyy-MM-dd HH:mm");
    capture_time = data.capture_time ? capture_time : BabelStr.str(177);
    this.$(".shooting-time").html(capture_time);
    var sizeInfo = data.width && data.height ? data.width + "x" + data.height : BabelStr.str(177);
    this.$(".size-info").html(sizeInfo);
    var resolution = data.resolution ? data.resolution + "dpi" : BabelStr.str(177);
    this.$(".resolving-power").html(resolution);
    var color_space = data.color_space && data.color_space != "Undefined" ? data.color_space : BabelStr.str(177);
    this.$(".color-space").html(color_space);
    var device_model = data.device_model ? data.device_model : BabelStr.str(177);
    this.$(".equipment-model").html(device_model);
    var place;
    if (data.lat) {
      if (fileInfor.get("maybePosition")) {
        this.$(".place").html(fileInfor.get("maybePosition"));
      } else {
        if (window.BMapGL) {
          var myGeo = new BMapGL.Geocoder();
          // 根据坐标得到地址描述    下面输入坐标。
          myGeo.getLocation(new BMapGL.Point(data.lon, data.lat), function (result) {
            if (result && result.address) {
              console.log(result);
              var address = result.addressComponents;
              var out = address.province;
              out += address.city == address.province ? "" : address.city;
              out += address.district == address.city ? "" : address.district;
              fileInfor.set("maybePosition", out);
              _this12.$(".place").html(out);
            } else {
              _this12.$(".place").html("".concat(data.lat, "(lat), ").concat(data.lon, "(lon)"));
            }
          });
        } else {
          this.$(".place").html("".concat(data.lat, "(lat), ").concat(data.lon, "(lon)"));
        }
      }
    } else {
      this.$(".place").html(BabelStr.str(177));
    }
  },
  setFileSecurity: function setFileSecurity(data) {
    var _this13 = this;
    _czc && _czc.push(["_trackEvent", "文件操作", "追加权限", "", "", ""]);
    var coverAll;
    var promise = new Promise(function (resolve, rejected) {
      if (!_this13.fileInfor.isFolder()) {
        resolve();
      } else {
        var alertView = new _MDAlertView["default"]();
        alertView.show({
          message: "<p>".concat(BabelStr.str(5406), "</p> <p class=\"f-tc red\">(").concat(BabelStr.str(5409), ")</p>"),
          className: "m-delAlertWin",
          buttons: [{
            label: BabelStr.str(5408),
            onClick: function onClick() {
              resolve();
            }
          }, {
            label: BabelStr.str(5407),
            // '确定',
            type: "danger",
            onClick: function onClick() {
              resolve(true);
            }
          }]
        });
      }
    });
    promise.then(function (coverAll) {
      _MDLoadMaskView["default"].show(undefined, {
        bodyMsg: BabelStr.str(20159) + "...",
        noClose: true
      });
      _MMEnterpriseController["default"].setFileSecret(_this13.fileInfor.getFileId(), data.id, function () {
        _MMNetDiskDataController["default"].getFileInfoFromServer(_this13.fileInfor.getFileId(), function (file) {
          _this13.fileInfor.setSecretLevelId(file.getSecretLevelId());
        });
        _MDLoadMaskView["default"].remove();
        _MDSnackbarView["default"].show(BabelStr.str(308));
      }, function () {
        _MDLoadMaskView["default"].remove();
        _MDSnackbarView["default"].show(BabelStr.str(3622));
      }, {
        coverAll: coverAll
      });
    });
  },
  folderShareStatusChange: function folderShareStatusChange() {
    var isSharing = app.currentFolder.get("isSharing");
    if (app.currentFolder.hasChanged("isSharing")) {
      this._refreshShareStatus();
      this._refreshCheckStatus();
    }
  },
  fileInforAttrChangedHandler: function fileInforAttrChangedHandler(model, options) {
    if (this.fileInfor.hasChanged("mtime")) {
      this._updateModifiedTime(model, options);
    }
    if (this.fileInfor.hasChanged("focusCount")) {
      this.getFileFocusUsers();
    }
    if (this.fileInfor.hasChanged("isSharing")) {
      this._refreshShareStatus();
    }
    if (this.fileInfor.hasChanged("commentCount") || this.fileInfor.hasChanged("unreadedCommentCount") || this.fileInfor.hasChanged("applyDownloadCount")) {
      this._commentCountChanged();
    }
    if (this.fileInfor.hasChanged("lockedByUser")) {
      this._refreshCheckStatus();
    }
    if (this.fileInfor.hasChanged("manuscriptBoxTime")) {
      this._refreshEndTime();
    }
    if (this.fileInfor.hasChanged("accessUserCount")) {
      this._refreshAccessUserCount();
    }
    if (this.fileInfor.hasChanged("openCount")) {
      this._refreshOpenCount();
    }
    if (this.fileInfor.hasChanged("downloadCount")) {
      this._downloadCountChanged();
    }
    if (this.fileInfor.hasChanged("customIcon4File")) {
      this.refreshRecoverBtn(this.fileInfor);
    }
  },
  _showFilePermissionExtraWin: function _showFilePermissionExtraWin() {
    // console.warn("显示增设文件权限窗口")
    var fileControlWinView = new _MDDepFilePermissionWinView["default"]({
      fileInfo: this.fileInfor
    });
    fileControlWinView.show();
  },
  _refreshEndTime: function _refreshEndTime() {
    var $endtime = this.$("#js-review-end");
    var endTimeStr = _MDLocalString["default"].getLocalString(177);
    if (this.fileInfor.getEndTime()) {
      endTimeStr = MMCommonFun.formatSec2Date(this.fileInfor.getEndTime());
    }
    $endtime.empty().append("<div><span class=\"desc-label\">".concat(BabelStr.str(176), "\uFF1A</span><span>").concat(endTimeStr, "</span></div>"));
  },
  _commentCountChanged: function _commentCountChanged() {
    var f = this.fileInfor;
    var unreadedCommentCount = f.get("unreadedCommentCount");
    var totalCommentCount = f.get("commentCount");
    var applyDownloadCount = f.get("applyDownloadCount") || 0;
    if (!this.fileInfor.isPermissionReadonly()) {
      if (totalCommentCount >= 0) {
        this.$("#js-comment-total-count").text(totalCommentCount);
        if (unreadedCommentCount >= 0) {
          this.$("#js-comment-total-count").text(totalCommentCount + "(" + unreadedCommentCount + ")");
        }
      }
      this.$("#js-apply-download-count").text(applyDownloadCount);
      if (applyDownloadCount > 0) {
        this.$(".apply-download-block").show();
        if (this.fileInfor.canEditProject() && this.fileInfor.beloneMaterialLibrary()) {
          this.$('.manage-apply-download').show();
        } else {
          this.$('.manage-apply-download').hide();
        }
      } else {
        this.$(".apply-download-block").hide();
      }
    }
  },
  _downloadCountChanged: function _downloadCountChanged() {
    var f = this.fileInfor;
    var downloadCount = f.get("downloadCount");
    this.$("#f-download-count").text(downloadCount);
  },
  _refreshCheckStatus: function _refreshCheckStatus() {
    var $lockState = this.$("#js-lock-state");
    $lockState.empty();
    if (this.fileInfor.isFileLocked()) {
      if (this.fileInfor.isFileLockedByMe()) {
        $lockState.append("<div class=\"text-hide\"><span class=\"desc-label\">".concat(BabelStr.str(7181), "\uFF1A</span><span>").concat(_MDLocalString["default"].getLocalString(188), "</span></div>"));
      } else {
        var param = {
          user: this.fileInfor.getFileLockerDispName()
        };
        $lockState.append("<div class=\"text-hide\"><span class=\"desc-label\">".concat(BabelStr.str(7181), "\uFF1A</span><span>").concat(_MDLocalString["default"].getLocalString(189, param), "</span></div>"));
      }
    }
  },
  /**
   * 获取分享状态
   */
  _refreshShareStatus: function _refreshShareStatus() {
    var $shareState = this.$("#shareState");
    $shareState.attr("title", "");
    if (window.isSharePage) {
      var title = _MDLocalString["default"].getLocalString(194, {
        user: this.fileInfor.getSharerName()
      });
      $shareState.html(title);
      $shareState.attr("title", title);
    }
    if (!app.pathRouter || !app.pathRouter.getFilePaths) {
      this.$("#js-share-state").addClass("f-hide");
      return;
    }
    this.$("#js-share-state").remove("f-none");
    var isSharing = this.fileInfor.get("isSharing");
    // this.$('#js-share-state').hide();

    var newShareAll = this.fileInfor.get("newShareAll");
    var isInSharingPath = _.isFunction(app.pathRouter.isInSharePath) ? app.pathRouter.isInSharePath() : true;
    if (isSharing && !this.fileInfor.isTeamFolder()) {
      var pathRouter = app.pathRouter;
      var filePaths = app.pathRouter.getFilePaths();
      var isTopSharingFolder = filePaths[1] && filePaths[1].get("isSharing");
      if (!pathRouter.inJoinShare() && (app.currentUser.isFileOwner(this.fileInfor.getOwnerId()) || pathRouter.hasTeamFolder() || pathRouter.hasDepartmentFolder() || isTopSharingFolder)) {
        var otherPeopleShare = true;
        var sharerName = this.fileInfor.getSharerName();
        if (app.currentUser.getId() != this.fileInfor.getSharerId()) {
          if (this.fileInfor.getSharerId() == 0) {
            sharerName = this.fileInfor.getOwnerName();
            if (!this.fileInfor.belongsToTeam() && !this.fileInfor.belongDepartment()) {
              if (app.currentUser.getId() != this.fileInfor.getOwnerId()) {
                otherPeopleShare = true;
              } else {
                otherPeopleShare = false;
              }
            } else {
              if (this.fileInfor.belongsToTeam()) {
                if (this.fileInfor.isCurUserManager()) {
                  otherPeopleShare = false;
                } else {
                  sharerName = "";
                  otherPeopleShare = false;
                }
              } else {
                // 部门
                otherPeopleShare = false;
              }
            }
          } else {
            // sharer id == 0， 没有人打开分享，只有邀请分享

            otherPeopleShare = true;
          }
        } else {
          otherPeopleShare = false;
        }
        if (otherPeopleShare) {
          var param = {
            user: sharerName
          };
          var title = _MDLocalString["default"].getLocalString(190, param);
          $shareState.text(title);
          $shareState.attr("title", title);
        } else {
          if (sharerName === "") {
            $shareState.text(_MDLocalString["default"].getLocalString(191));
          } else {
            if (app.pathRouter.hasDepartmentFolder() || app.pathRouter.hasTeamFolder()) {
              if (this.fileInfor.getSharerId() == 0) {
                $shareState.text(_MDLocalString["default"].getLocalString(192));
              } else {
                $shareState.text(_MDLocalString["default"].getLocalString(193));
              }
            } else {
              $shareState.text(_MDLocalString["default"].getLocalString(191));
            }
          }
        }
      } else {
        // 参与者处
        // 在别人的分享目录下又有分享的子文件的话，那么就不再显示"分享自XXX"的标记
        // 重现步骤，
        // 1. PersonA分享目录F
        // 2. PersonB 加入目录 FA
        // 3. PersonA在FA下创建FB,并分享FB
        // 4. PersonB 的FA下的FB不会显示“分享自PersonA”的标记
        var showOthers = !isTopSharingFolder || pathRouter.inJoinShare();
        if (showOthers) {
          var param = {
            user: ""
          };
          if (this.fileInfor.getSharerId() == 0 || this.fileInfor.belongDepartment()) {
            param["user"] = this.fileInfor.getOwnerName();
          } else {
            param["user"] = this.fileInfor.getSharerName();
          }
          var title = _MDLocalString["default"].getLocalString(194, param);
          $shareState.html(title);
          $shareState.attr("title", title);
        }
      }
    } else if (!isSharing && isInSharingPath && !newShareAll) {
      $shareState.text(_MDLocalString["default"].getLocalString(195));
    } else {
      $shareState.text(BabelStr.str(3584));
    }
  },
  requestSubFilesNum: function requestSubFilesNum(cb) {
    var self = this;
    if (this.fileInfor && this.fileInfor.isFolder()) {
      var calcuCap = _MDLocalString["default"].getLocalString(295);
      var html = calcuCap + '<i class="dot">.</i><i class="dot">.</i><i class="dot">.</i>';
      self.$(".sub-files-num").addClass("text-loading").empty().append(html);
      self.$(".f-size").addClass("text-loading").empty().append(html);
      var serverFun;
      if (window.user.useAdvancedSearch) {
        serverFun = _MMEnterpriseController["default"].getFileNumInFolder2;
      } else {
        serverFun = _MMNetDiskDataController["default"].getFileNumInFolder;
      }
      if (app.ep && app.ep.isArchive()) {
        serverFun = _MMNetDiskDataController["default"].getArchiveFileNumInFolder;
      } else {}
      serverFun(this.fileInfor.getFileId(), function (fileCount, fileSize, folderCount) {
        self.$(".sub-files-num").removeClass("text-loading").empty().append(BabelStr.str(3585, {
          fileCount: fileCount,
          folderCount: folderCount
        }));
        self.$(".f-size").removeClass("text-loading").empty();
        if (fileSize != undefined) {
          self.fileInfor.set("fileSize", parseInt(fileSize));
          var fSize = app.getFileSizeDescription(self.fileInfor.get("fileSize"));
          self.$(".f-size").text(fSize);
        }
        cb && cb();
      }, function () {
        cb && cb();
      });
    } else {
      cb && cb();
    }
  },
  _updateModifiedTime: function _updateModifiedTime(fileInfor, options) {
    this.$(".mtime").text(MMCommonFun.formatSec2Date(fileInfor.get("mtime")));
  },
  initRemarks: function initRemarks() {
    if (this.fileInfor.getCommentStr().length == 0 && !this.fileInfor.canManageFile() && !this.fileInfor.canRename()) {
      this.$el.find(".file-remark").remove();
    } else {
      if (this.dispRemark) {
        this.dispRemark.removeFromSuperView();
      }
      var self = this;
      this.dispRemark = new _MDEditalbeTextDiv["default"]({
        parentDiv: this.$el.find(".remarksdiv")[0],
        text: this.fileInfor.getCommentStr(),
        disabelEdit: this.fileInfor.isInTrash() || !this.fileInfor.canUpdateFileCommentStr(),
        maxlength: 140,
        placeholder: BabelStr.str(6128),
        updatedCallback: function updatedCallback(newtext) {
          newtext = _.escape(newtext);
          _MMNetDiskDataController["default"].updateFileCommentStr(self.fileInfor.getFileId(), newtext, function () {
            self.fileInfor.setCommentStr(newtext);
            _czc && _czc.push(["_trackEvent", "文件操作", "修改文件说明", "", "", ""]);
          }, function () {
            self.dispRemark.setText(self.fileInfor.getCommentStr());
            _MDSnackbarView["default"].show(BabelStr.str(5086));
          });
        }
      });
    }
  },
  initTag: function initTag() {
    if (this.fileInfor.get("forClient")) {
      return;
    }
    var self = this;
    this.$(".tag-contain").empty();
    var $tagCount = this.$(".tag-count");
    $tagCount.html(this.tagCollection.length);
    var str = "";
    var len = this.tagCollection.length;
    var manageStr = "";
    var candelete = "";
    var strArr = this.tagCollection.map(function (tagModel) {
      if (tagModel.canDelete() && app.currentUser && app.currentUser.logined()) {
        manageStr = '<span class="tag-del icon icon20"></span>';
        candelete = "can-del";
      } else {
        candelete = "";
        manageStr = "";
      }
      var cls = "";
      if (tagModel.get("enterpriseUsed")) {
        cls = ' ent-tag';
      }
      return '<div class = "tag-div ' + candelete + cls + '"  tagId = "' + tagModel.getId() + '" title="' + tagModel.getText() + '">\
                <span class = "tag-color-circle" style = "background-color :' + tagModel.getColor() + '"></span>\
                <span class = "tag-name middle-ellipsis">' + tagModel.getText() + "</span>" + manageStr + "</div>";
    });
    for (var i = 0; i < len; i++) {
      str += strArr[i];
    }
    this.$(".tag-contain").append(str);
    // this.$(".tag-contain .tag-name").map(function (index, tagname) {
    //   if ($(tagname).width() < 200) {
    //     $(tagname).css({
    //       width: "auto",
    //     });
    //   }
    // });

    if (!this.fileInfor.get("forClient") && this.fileInfor.canAddTag()) {
      this.$(".tag-contain").append('<button class="attr-addtag icon" data-tooltip="' + BabelStr.str(106) + '" data-tooltip-dir="bottom"></button>');
      if (window.isOpenOneFileAI && !app.currentUser.isCloseAI() && !app.currentUser.isAnonymous() && window.supportAI) {
        this.$(".aitag").removeClass("f-hide");
      } else {
        this.$(".aitag").addClass("f-hide");
      }
    } else {
      this.$(".aitag").addClass("f-hide");
    }
  },
  initFocusUser: function initFocusUser() {
    var self = this;
    this.$(".focus-contain").empty();
    var $focusCount = this.$(".focus-count");
    $focusCount.html(this.focusCollection.length);
    var str = "";
    var len = this.focusCollection.length;
    var manageStr = "";
    var candelete = "";
    var strArr = this.focusCollection.map(function (user) {
      var closeBtn = "";
      if (app.currentUser.logined()) {
        closeBtn = '<span class = "focus-item-ope"><span class = "icon ic-close-small"></span></span>';
      }
      return "<div class = \"focus-item\"  data-userid = \"".concat(user.getUserId(), "\">\n                <span class = \"focus-user-name\">").concat(user.getUserName(), " </span>\n                ").concat(closeBtn, "\n              </div>");
    });
    for (var i = 0; i < len; i++) {
      str += strArr[i];
    }
    this.$(".focus-contain").append(str);
    this.$(".focus-contain .focus-user-name").map(function (index, focusname) {
      if ($(focusname).width() < 200) {
        $(focusname).css({
          width: "auto"
        });
      }
    });
  },
  getFileFocusUsers: function getFileFocusUsers(cb) {
    var self = this;
    _MMNetDiskDataController["default"].getFileFocusUsers(this.fileInfor.getFileId(), function (focusCollection) {
      if (self.fileInfor.getFocusCount() != focusCollection.length) {
        self.fileInfor.setFocusCount(focusCollection.length);
      }
      self.focusCollection = focusCollection;
      self.initFocusUser();
      cb && cb();
    }, function () {
      cb && cb();
    });
  },
  removeFocusUserCLickHandle: function removeFocusUserCLickHandle($e) {
    var self = this;
    var $curUser = $($e.target).closest(".focus-item");
    var fid = this.fileInfor.getFileId();
    var userId = $curUser.data("userid");
    var user;
    var count = self.fileInfor.getFocusCount;
    _MMNetDiskDataController["default"].removeFileFocus(this.fileInfor.getFileId(), userId, function () {
      if (app.pathRouter && app.pathRouter.isInMyfocus) {
        if (app.pathRouter.isInMyfocus() && userId == app.currentUser && app.currentUser.getUserId()) {
          count = 0;
        } else {
          count--;
        }
        self.fileInfor.setFocusCount(count);
      } else if (self.fileInfor.get("forClient")) {
        count--;
        self.fileInfor.setFocusCount(count);
      }
      if (userId == app.currentUser.getUserId()) {
        self.fileInfor.setIsFocusFile(false);
      }
    }, function () {});
  },
  initAccessUser: function initAccessUser(data) {
    var str = "";
    var url = "";
    var name = "";
    var len = data.length;
    this.$(".user-list").empty();
    if (len < 1) {
      this.$(".access-log .empty").show();
    } else {
      this.$(".access-log .empty").hide();
    }
    for (var i = 0; i < len; i++) {
      url = app.getAvatarImageURL(data[i].get("userId"));
      name = data[i].get("name");
      str += '<span class = user-item >\
                <img class="_user-profile-picture" src = "' + url + '" data-tooltip="' + name + '" data-tooltip-dir="bottom">\
              </span>';
    }
    this.$(".user-list").append(str);
  },
  getAccessUserList: function getAccessUserList(cb) {
    var self = this;
    var fid = this.fileInfor.getFileId();

    // MMNetDiskDataController.getFileTagPraiseInfo(fid, function(infos) {
    //   self.updateAccessInfo(infos[0])
    // })

    _MMNetDiskDataController["default"].getFileReaders(fid, function (users) {
      self.initAccessUser(users);
      cb && cb();
    }, function () {
      cb && cb();
    });
  },
  updateAccessInfo: function updateAccessInfo(f) {
    if (!f) {
      return;
    }
    this.fileInfor.setAccessUserCount(f.getAccessUserCount());
    this.fileInfor.setOpenCount(f.getOpenCount());
  },
  _refreshAccessUserCount: function _refreshAccessUserCount() {
    this.$("#js-access-user-count").html(this.fileInfor.getAccessUserCount());
  },
  _refreshOpenCount: function _refreshOpenCount() {
    this.$("#js-open-count").html(this.fileInfor.getOpenCount());
  },
  removeTagItem: function removeTagItem($e) {
    $($e.target).closest(".tag-div").remove();
  },
  removeTagFromFile: function removeTagFromFile(fid, tag, $curTag) {
    var self = this;
    _MDFileOperationManager["default"].delTagForFile(self.fileInfor, tag);
  },
  removeTagCLickHandle: function removeTagCLickHandle($e) {
    var self = this;
    var $curTag = $($e.target).closest(".tag-div");
    var fid = this.fileInfor.getFileId();
    var tagId = $curTag.attr("tagId");
    var tagStr = $curTag.find(".tag-name").text();
    var tagCollection = this.fileInfor.getTagCollection();
    var tag = tagCollection.findWhere({
      id: tagId
    });
    var alertView = new _MDAlertView["default"]();
    alertView.show({
      message: BabelStr.str(6229),
      className: "m-delAlertWin",
      buttons: [{
        label: BabelStr.str(155)
      }, {
        label: BabelStr.str(32),
        // '确定',
        type: "danger",
        onClick: function onClick() {
          self.removeTagFromFile(fid, tag, $curTag);
        }
      }]
    });
  },
  addTagToFile: function addTagToFile($e) {
    var self = this;
    if (!app.currentUser.logined()) {
      app.popupInnerLogin();
      return;
    }
    // if (app.isEpVersion()) {
    var addTagWin = new _MDAddTagBigWindow["default"]({
      fileInfos: [this.fileInfor]
    });
    // } else {
    //   var addTagWin = new MDAddTagWindow({
    //     fileInfos: [this.fileInfor],
    //     tagCollection: this.fileInfor.getTagCollection()
    //   });
    // }

    addTagWin.show();
  },
  lookHistory: function lookHistory() {
    this.verlistView = new _MDFileVerListPanelView["default"]({
      fileInfor: this.fileInfor,
      fileVersionRouterCb: this.fileVersionRouterCb,
      showDispMark: this.showDispMark,
      dispVer: this.dispVer,
      updateDisVerAfterDel: this.updateDisVerAfterDel,
      enableRouterNavigation: this.enableRouterNavigation,
      enableOpenVersion: this.enableOpenVersion
    });
    this.navigationView.push(this.verlistView);
  },
  toggleTagList: function toggleTagList() {
    var $tagContain = this.$(".tag-contain");
    if ($tagContain.hasClass("f-hide")) {
      $tagContain.removeClass("f-hide");
      this.$(".tag-wrapper .sign-info").removeClass("close");
      this.$(".tag-wrapper .sign-info").addClass("open");
    } else {
      $tagContain.addClass("f-hide");
      this.$(".tag-wrapper .sign-info").addClass("close");
      this.$(".tag-wrapper .sign-info").removeClass("open");
    }
  },
  toggleFocusList: function toggleFocusList() {
    var $focusContain = this.$(".focus-contain");
    if ($focusContain.hasClass("f-hide")) {
      $focusContain.removeClass("f-hide");
      this.$(".focus-wrapper .sign-info").removeClass("close");
      this.$(".focus-wrapper .sign-info").addClass("open");
    } else {
      $focusContain.addClass("f-hide");
      this.$(".focus-wrapper .sign-info").addClass("close");
      this.$(".focus-wrapper .sign-info").removeClass("open");
    }
  },
  toggleAccessLogInfo: function toggleAccessLogInfo() {
    var $AccessLogContain = this.$(".access-log-contain");
    if ($AccessLogContain.hasClass("f-hide")) {
      $AccessLogContain.removeClass("f-hide");
      this.$(".access-log .sign-info").removeClass("close");
      this.$(".access-log .sign-info").addClass("open");
    } else {
      $AccessLogContain.addClass("f-hide");
      this.$(".access-log .sign-info").addClass("close");
      this.$(".access-log .sign-info").removeClass("open");
    }
  },
  toggleAccessContain: function toggleAccessContain(e) {
    this.toggleContain(e);
    if (this.fileInfor.canReadCommentOnlyByAction() && !this.accessLoaded) {
      _MDNetDriveFileHandler["default"].updateFileVisitInfo(this.fileInfor);
    }
    this.accessLoaded = true;
  },
  toggleContain: function toggleContain(e) {
    var _this14 = this;
    if ($(e.target).hasClass("access-log-ope")) {
      if (this.fileInfor.canReadCommentOnlyByAction() && !this.accessLoaded) {
        _MDNetDriveFileHandler["default"].updateFileVisitInfo(this.fileInfor, function () {
          _this14._commentCountChanged();
          _this14._refreshAccessUserCount();
          _this14._refreshOpenCount();
          _this14._downloadCountChanged();
        });
        _MMEnterpriseController["default"].countDownloadAppliedUsers(this.fileInfor.getFileId(), function (applyDownloadCount) {
          _this14.fileInfor.set('applyDownloadCount', applyDownloadCount);
        });
      }
      this.accessLoaded = true;
    }
    var $currentDom = $(e.currentTarget);
    var $tagContain = $currentDom.closest(".splider-sec").find(".detail");
    if ($tagContain.hasClass("f-hide")) {
      $tagContain.removeClass("f-hide");
      $currentDom.removeClass("close");
      $currentDom.addClass("open");
      if ($tagContain.hasClass("perm-table")) {
        // this.filePermissionPanel.showTable();
      }
      this.$(".info-content").scrollTop(99999);
    } else {
      $tagContain.addClass("f-hide");
      $currentDom.addClass("close");
      $currentDom.removeClass("open");
    }
    return false;
  },
  displayFileLogClickHandle: function displayFileLogClickHandle() {
    if (this.fileInfor.get("forClient")) {
      console.warn("显示文件日志页--showFilelog");
      var cppAPI = this.getcppAPI();
      if (cppAPI.showFilelog) {
        cppAPI.showFilelog(this.fileInfor.getFileId());
      }
      return;
    }
    if (this.fileactionctl.canShowStatistics()) {
      var statisWind = new _MDFileOpStatisitcsWindow["default"]({
        fileInfor: this.fileInfor
      });
      statisWind.show();
    } else {
      this.filelogView = new _MDFileLogWindowView["default"]({
        fileInfor: this.fileInfor
      });
      this.filelogView.show();
    }
  },
  setEnableOpenVersion: function setEnableOpenVersion(enabled) {
    this.enableOpenVersion = enabled;
    this.verlistView && this.verlistView.setEnableOpenVersion(enabled);
  },
  setEnableRouterNavigation: function setEnableRouterNavigation(enabled) {
    this.enableRouterNavigation = enabled;
    this.verlistView && this.verlistView.setEnableRouterNavigation(enabled);
  },
  _editFocus: function _editFocus($e) {
    if (this.fileInfor.get("forClient")) {
      console.warn("显示关注人员--showFileFocus");
      var cppAPI = this.getcppAPI();
      if (cppAPI.showFileFocus) {
        cppAPI.showFileFocus(this.fileInfor.getFileId());
      }
      return;
    }
    var self = this;
    if (this.focusFilePopupView) {
      self.focusFilePopupView.close();
    } else {
      this.focusFilePopupView = new _MDFocusFilePopupView["default"]({
        fileInfo: function fileInfo() {
          return self.fileInfor;
        },
        direction: _popupPos["default"].RIGHT_BOTTOM,
        triggerView: $e.currentTarget,
        onShow: function onShow(popupView) {
          self.listenToOnce(self.tableView, "scroll", function () {
            popupView.close();
          });
        },
        onClose: function onClose() {
          self.focusFilePopupView = null;
        }
      });
      this.focusFilePopupView.show();
    }
  },
  _shareFile: function _shareFile() {
    if (this.fileInfor.get("forClient")) {
      console.warn("显示分享页--shareFile");
      var cppAPI = this.getcppAPI();
      if (cppAPI.shareFile) {
        cppAPI.shareFile(this.fileInfor.getFileId());
      }
      return;
    }
    var self = this;
    var ctl = new _MDFileActionController["default"]();
    ctl.setFileInfors([this.fileInfor]);
    ctl.shareFile();
  },
  editMasuscriptBox: function editMasuscriptBox() {
    var self = this;
    var ctl = new _MDFileActionController["default"]();
    ctl.setFileInfors([this.fileInfor]);
    ctl.manageMsBox(this.fileInfor);
  },
  _editorResPerson: function _editorResPerson() {
    var _this15 = this;
    var win = new _MDEditResponsiblePersonWinView["default"]({
      fileInfo: this.fileInfor,
      updateManager: function updateManager(options) {
        console.log(options);
        _this15.fileInfor.setManager(options.id), _this15.fileInfor.setManagerName(options.name);
        _this15.$(".managerName").html(options.name);
      }
    });
    win.show();
  },
  _shwoSecricFileList: function _shwoSecricFileList() {
    var fileControlWinView = new _MDDepSecretFileListWinView["default"]({
      fileInfo: this.fileInfor
    });
    fileControlWinView.show();
  },
  _showStatisticWin: function _showStatisticWin() {
    var actionController = new _MDFileActionController["default"]({
      channel: _MDChannelType["default"].file
    });
    actionController.setFileInfors([this.fileInfor]);
    actionController.showUserStatisticsWin();
  },
  _showUserPerInfo: function _showUserPerInfo() {
    var actionController = new _MDFileActionController["default"]({
      channel: _MDChannelType["default"].file
    });
    actionController.setFileInfors([this.fileInfor]);
    actionController.showControlFileWinView({
      showUserInfo: true
    });
  },
  _showSharePerInfo: function _showSharePerInfo() {
    var actionController = new _MDFileActionController["default"]({
      channel: _MDChannelType["default"].file
    });
    actionController.setFileInfors([this.fileInfor]);
    actionController.showControlFileWinView({
      showsharePerInfo: true
    });
  },
  _manageApplyDownloadUser: function _manageApplyDownloadUser() {
    var _this16 = this;
    var win = new _MDManageApplyUserWinView["default"]({
      fileInfor: this.fileInfor,
      updateApplyUserCallback: function updateApplyUserCallback(count) {
        _this16.fileInfor.set("applyDownloadCount", count);
      }
    });
    win.show();
  },
  _shwoFileList: function _shwoFileList() {
    var fileControlWinView = new _MDDepControlFileListWinView["default"]({
      fileInfo: this.fileInfor
    });
    fileControlWinView.show();
  },
  _shwoFileShare: function _shwoFileShare() {
    var fileControlWinView = new _MDDepShareFileListWinView["default"]({
      fileInfo: this.fileInfor
    });
    fileControlWinView.show();
  },
  _manageDepInfo: function _manageDepInfo() {
    viewManager.get("mainPanelView").dispDepManageInfo(this.fileInfor.get("departmentId"), this.fileInfor.getFileName(), this.fileInfor.getFileId(), this.fileInfor);
  },
  _manageDepUser: function _manageDepUser() {
    if (!app.pathRouter.inDepartment()) {
      viewManager.get("mainPanelView").dispDepManager(this.fileInfor.get("departmentId"), this.fileInfor.getFileName(), this.fileInfor.getFileId(), this.fileInfor);
    } else {
      var departId = this.fileInfor.get("departmentId");
      var departName = this.fileInfor.getFileName();
      var serveForSingleDep = !app.currentUser.isEpAdminUser() && this.fileInfor.canManageDepMember();
      var rootNavigationPageView = new _MEStaffNavigationPageView["default"]({
        departId: departId,
        departName: departName,
        serveForSingleDep: serveForSingleDep
      });
      viewManager.get("mainPanelView").getCurShownTableView().navigationView.push(rootNavigationPageView);
    }
  },
  _showEditProject: function _showEditProject() {
    var win = new _MDProjectCreateWinView["default"]({
      type: 1,
      fileId: this.fileInfor.getFileId(),
      isProjectAssist: this.fileInfor.get("isProjectAssist")
    });
    win.show();
  },
  _showEditTrProject: function _showEditTrProject() {
    var actionCtl = new _MDFileActionController["default"]({
      fileInfors: [this.fileInfor]
    });
    actionCtl.manageHQSMProject(this.fileInfor);
  },
  getcppAPI: function getcppAPI() {
    var cppAPI;
    try {
      cppAPI = window["ElectronRequire"]("electron").remote.require("./utils/cppAPI");
    } catch (e) {
      cppAPI = {};
    }
    return cppAPI;
  }
});
var _default = exports["default"] = MDFileInforDetailTabPanelView;

},{"1091":1091,"1098":1098,"1104":1104,"1150":1150,"1184":1184,"1412":1412,"1415":1415,"1416":1416,"1417":1417,"1418":1418,"1422":1422,"1424":1424,"1426":1426,"1428":1428,"1435":1435,"1436":1436,"1437":1437,"1439":1439,"1454":1454,"1461":1461,"1463":1463,"1466":1466,"1471":1471,"148":148,"1537":1537,"1541":1541,"1546":1546,"18":18,"273":273,"29":29,"32":32,"325":325,"326":326,"338":338,"49":49,"492":492,"527":527,"560":560,"562":562,"565":565,"568":568,"569":569,"570":570,"576":576,"577":577,"579":579,"581":581,"583":583,"592":592,"597":597,"628":628,"634":634,"65":65,"652":652,"67":67,"717":717,"72":72,"76":76,"781":781,"81":81}],781:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1426);
var _MDWindowView = _interopRequireDefault(require(93));
var _MDAddTagCommonBigView = _interopRequireDefault(require(783));
var _MDTagCollection = _interopRequireDefault(require(288));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDTag = _interopRequireDefault(require(287));
var _MDTagDataController = _interopRequireDefault(require(1093));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDMessageView = _interopRequireDefault(require(55));
/**
 * 添加标签
 * Created by jiang
 * 2018.6.20
 */

var MDAddTagBigWindow = _MDWindowView["default"].extend({
  className: function className() {
    var superCls = _MDWindowView["default"].prototype.className.call(this);
    return superCls + ' m-add-tag-big-window';
  },
  events: function events() {
    var superE = _MDWindowView["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click >header .u-nav-back-btn': this.pop
    });
  },
  initProps: function initProps() {
    var superP = _MDWindowView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      fileInfos: [],
      title: BabelStr.str(106),
      //  "添加标签"
      width: 900
    });
  },
  _setWidowTransitionAni: function _setWidowTransitionAni(enable) {
    if (!enable) {
      this.$el.addClass('disable-tran');
    } else {
      this.$el.removeClass('disable-tran');
    }
  },
  /**
   * @param {object} opt
   * @param {MDNavigationPageView} opt.rootNavigationPageView - 根nav页面
   */
  initialize: function initialize(props) {
    props.hiddenClose = true;
    _MDWindowView["default"].prototype.initialize.call(this, props);
    this.fileIds = [];
    for (var i = 0; i < this.fileInfos.length; i++) {
      this.fileIds.push(this.fileInfos[i].getFileId());
    }
    ;

    // add event listen
    for (var _i = 0; _i < this.fileInfos.length; _i++) {
      var tagCollection = this.fileInfos[_i].getTagCollection();
      this.listenTo(tagCollection, 'add', this._selectionChanged);
      this.listenTo(tagCollection, 'remove', this._selectionChanged);
    }
    var self = this;
    var param = {
      shouldSearchTag: true,
      showAitag: this.fileInfos.length == 1 && this.fileInfos[0].canUseAITaginal(),
      layout: function layout() {},
      tagCollectionSelected: this.tagCollection,
      onRemoveAddedTag: function onRemoveAddedTag(tagModel, netCb) {
        // var id = tagModel.getId();
        // // 删除标签
        // MDTagDataController.removeTagFromFiles(fileIds, id, function() {
        //   netCb.success();
        //   tagModel.setSelected(false);
        //   for (var i = 0; i < self.fileInfos.length; i++) {
        //     var tagCollection = self.fileInfos[i].getTagCollection();
        //     tagCollection.remove({id: id});
        //   };
        // Dispatcher.trigger(MDEvents.Tag_Delete_From_File, {
        //     tagModel: tagModel
        //   });
        //   MDSnackbarView.show(BabelStr.str(308));        // ('标签添加成功');
        // }, function() {
        //   netCb.fail();
        // });

        if (netCb && netCb.success) {
          netCb.success();
        }
      },
      addAItag: function addAItag(cb) {
        var error = function error(msg) {
          var $content = self.$body;
          if (self.viewRemoved) {
            $content = null;
          }
          _MDMessageView["default"].error(msg || BabelStr.str(309), $content);
          cb(false);
        };
        var fid = self.fileInfos[0].getFileId();
        _MMEnterpriseController["default"].aiAddtags(fid, function (content) {
          _MMNetDiskDataController["default"].getFileInfoFromServer(fid, function (file) {
            var tagCollection = self.fileInfos[0].getTagCollection();
            tagCollection.reset();
            tagCollection.add(file.get("tags"));
            cb(true);
            _MDMessageView["default"].success(BabelStr.str(308), self.$body);
          }, error);
        }, function (err) {
          error(err);
        });
      },
      onAddTag: function onAddTag(tagModel, netCb) {
        if (_MDAddTagCommonBigView["default"].isTempTagId(tagModel.getId())) {
          var color = tagModel.getColorNum();
          var text = tagModel.getText();
          _MDTagDataController["default"].createNewTag(text, color, function (tagInfo) {
            tagModel.setId(tagInfo['tagId']);
            netCb.success();
            self.addTagCommonView && self.addTagCommonView.tagSelectionChanged();
            self.addTagCommonView && self.addTagCommonView.tagNameInputHandler();

            // var tag = new MDTag(tagInfo);
            // self.addTagToPanel(tag);
          }, function (resultCode) {
            netCb.fail();
          });
        } else {
          if (netCb && netCb.success) {
            netCb.success();
          }
        }
      },
      onOkClose: function onOkClose() {
        console.log('----> ok');
        self._checkToUpdateTagsForFiles();
        self.close();
      },
      onCancelClose: function onCancelClose() {
        console.log('----> cancel');
        self.close();
      },
      checkCanDelTag: function checkCanDelTag(tagId) {
        var can = true;
        for (var _i2 = 0; _i2 < self.fileInfos.length; _i2++) {
          var fileInfo = self.fileInfos[_i2];
          if (!fileInfo.canDelTag(tagId)) {
            can = false;
            break;
          }
        }
        return can;
      }
    };
    this.addTagCommonView = new _MDAddTagCommonBigView["default"](param);
    this.addSubView(this.addTagCommonView, this.$('.window-body'));
    this._selectionChanged();
  },
  _checkToUpdateTagsForFiles: function _checkToUpdateTagsForFiles() {
    this._collectFileSelectedTags();
    var oldSelectedTags = this.tagCollectionSelected;
    var newSelectedTags = this.addTagCommonView.tagCollectionSelected;
    var tags2add = new _MDTagCollection["default"]();
    var tags2create = new _MDTagCollection["default"]();
    var tags2del = new _MDTagCollection["default"]();
    newSelectedTags.each(function (tag0) {
      var tag1 = oldSelectedTags.find({
        id: tag0.id
      });
      if (!tag1) {
        if (_MDAddTagCommonBigView["default"].isTempTagId(tag0.id)) {
          tags2create.add(tag0);
        } else {
          tags2add.add(tag0);
        }
      }
    });
    oldSelectedTags.each(function (tag0) {
      var tag1 = newSelectedTags.find({
        id: tag0.id
      });
      if (!tag1) {
        tags2del.add(tag0);
      }
    });
    console.log('need add:' + tags2add.length);
    console.log('need create:' + tags2create.length);
    console.log('need del:' + tags2del.length);
    this._addTags(tags2add);
    this._createTags(tags2create);
    this._removeTags(tags2del);
  },
  _addTags: function _addTags(tagsAdded) {
    var self = this;
    if (tagsAdded && tagsAdded.length > 0) {
      _czc && _czc.push(["_trackEvent", "文件操作", "添加标签", "", "", ""]);
      _MDTagDataController["default"].addTagsForFiles(this.fileIds, tagsAdded.map('id'), tagsAdded.map('customColorId'), function () {
        for (var i = 0; i < self.fileInfos.length; i++) {
          var tagCollection = self.fileInfos[i].getTagCollection();
          for (var k = 0; k < tagsAdded.length; k++) {
            var element = tagsAdded.at(k);
            tagCollection.add(element);
          }
        }
      }, function () {});
    }
  },
  _createTags: function _createTags(tagsCreate) {
    var self = this;
    if (tagsCreate && tagsCreate.length > 0) {
      var colors = [];
      tagsCreate.each(function (tag) {
        colors.push(tag.getColorNum());
      });
      _czc && _czc.push(["_trackEvent", "文件操作", "创建并添加标签", "", "", ""]);
      _MDTagDataController["default"].createTagsAndAddToFiles(this.fileIds, tagsCreate.map('text'), colors, function (tags) {
        for (var k = 0; k < tags.length; k++) {
          var tag = tags[k];
          for (var i = 0; i < self.fileInfos.length; i++) {
            var tagCollection = self.fileInfos[i].getTagCollection();
            tagCollection.add(tag);
          }
        }
      }, function () {});
    }
  },
  _removeTags: function _removeTags(tagsRemoved) {
    var self = this;
    if (tagsRemoved && tagsRemoved.length > 0) {
      _czc && _czc.push(["_trackEvent", "文件操作", "移除标签", "", "", ""]);
      _MDTagDataController["default"].removeTagsFromFiles(this.fileIds, tagsRemoved.map('id'), function () {
        for (var i = 0; i < self.fileInfos.length; i++) {
          var tagCollection = self.fileInfos[i].getTagCollection();
          for (var k = 0; k < tagsRemoved.length; k++) {
            var element = tagsRemoved.at(k);
            tagCollection.remove({
              id: element.id
            });
          }
        }
      }, function () {});
    }
  },
  _collectFileSelectedTags: function _collectFileSelectedTags() {
    var self = this;
    this.tagCollectionSelected = new _MDTagCollection["default"]();
    var tagCollection = this.fileInfos[0].getTagCollection();
    tagCollection.each(function (tag) {
      var isPublicTag = true;
      for (var i = 0; i < self.fileInfos.length; i++) {
        var tagCollection2 = self.fileInfos[i].getTagCollection();
        var found = tagCollection2.find(function (tag2) {
          return tag2.getId() == tag.getId();
        });
        if (!found) {
          isPublicTag = false;
          break;
        }
      }
      if (isPublicTag) {
        self.tagCollectionSelected.add(tag);
      }
    });
  },
  _selectionChanged: function _selectionChanged() {
    this._collectFileSelectedTags();
    this.addTagCommonView.selectionChangedFromOutside(this.tagCollectionSelected);
  },
  show: function show(opt) {
    _MDWindowView["default"].prototype.show.call(this, opt);
    var layer = 700000000;
    this.$winLayoutWrapper.css('z-index', layer);
    this.$overlayer.css('z-index', layer);
  },
  viewWillUnRendered: function viewWillUnRendered(param) {
    // stop event listen
    for (var i = 0; i < this.fileInfos.length; i++) {
      var tagCollection = this.fileInfos[i].getTagCollection();
      this.stopListening(tagCollection);
      // this.stopListening(tagCollection, 'remove', this._selectionChanged);
    }
    this.viewRemoved = true;
    _MDWindowView["default"].prototype.viewWillUnRendered.call(this, param);
  },
  close: function close() {
    _MDWindowView["default"].prototype.close.call(this);
    if (this.closeCallback) {
      this.closeCallback();
    }
    ;
  }
});
var _default = exports["default"] = MDAddTagBigWindow;

},{"1093":1093,"1098":1098,"1104":1104,"1184":1184,"1417":1417,"1426":1426,"1454":1454,"1463":1463,"18":18,"287":287,"288":288,"55":55,"72":72,"783":783,"93":93}],783:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1415);
require(1463);
require(1421);
require(1436);
require(1546);
require(1477);
require(1492);
require(1476);
require(1478);
require(1424);
require(1417);
var _MDTagCollection = _interopRequireDefault(require(288));
var _MDAddTagCommonBaseView = _interopRequireDefault(require(782));
/**
 * 添加标签
 * Created by jiang copied from han's MDAddTagPopupView.js
 * 2017.6.13
 */

var MDAddTagCommonBigView = _MDAddTagCommonBaseView["default"].extend({
  el: '<div class="add-tag-big-root"></div>',
  contentTmpl: function contentTmpl() {
    return "\n    <div class=\"flex-align middle  search-condition-block disabled f-hide\">\n      <span class=\"icon union-icon con-item checked\" data-type=\"1\" data-tooltip=\"<%=BabelStr.str(21900)%>\" data-tooltip-dir=\"bottom\"></span>\n      <div class=\"split-solid-right\"></div>\n      <span class=\"icon intersection-icon con-item\" data-type=\"2\" data-tooltip=\"<%=BabelStr.str(21901)%>\" data-tooltip-dir=\"bottom\"></span>\n      <div class=\"split-solid-right\"></div>\n      <span class=\"icon difference-icon con-item\" data-type=\"3\" data-tooltip=\"<%=BabelStr.str(21902)%>\" data-tooltip-dir=\"bottom\"></span>\n    </div>\n    <div class=\"flex-align middle end aitag f-hide mgb-10\">\n      <div class=\"button done add-aitag small\"><%=BabelStr.str(12650)%></div>\n      <div class=\"loading-block\">\n        <span class=\"dot\"></span>\n        <span class=\"dot\"></span>\n        <span class=\"dot\"></span>\n        <span class=\"dot\"></span>\n      </div>\n    </div>\n    " + '<ul class="tag-selected-block flex-align middle gap-10"></ul>\
        <div class="tag-input-block">\
          <form autocomplete="false" onsubmit="return false">\
            <div class="form-item" >\
              <div class="tag-name-input-wrap mgb-10">\
                <i class="tag-color-circle tag-select-color-circle" ></i>\
                <input name="<%=tagName%>" type="text" class="form-control tag-name-input"  autocomplete="false" \
                  placeholder="<%=placeholder%>" maxlength="140" \
                  >\
              </div>\
            </div>\
          </form>\
        </div>\
        <div class="tag-column-section">\
          <div class="tag-column-root between flex-align">\
              <div class="tag-column"><%=BabelStr.str(373)%></div>\
              <div class="tag-column"><%=BabelStr.str(373)%></div>\
              <div class="tag-column"><%=BabelStr.str(373)%></div>\
              <div class="tag-column"><%=BabelStr.str(373)%></div>\
              <div class="tag-column"><%=BabelStr.str(373)%></div>\
              <div class="tag-column"><%=BabelStr.str(373)%></div>\
              <div class="tag-column"><%=BabelStr.str(373)%></div>\
          </div>\
        </div>\
        <div class="tag-prop-block">\
          <div class="tag-prop-block-inner">\
            <ul class="tag-color-list">\
            <% for(var i = 0 ; i < colors.length ; i++) {%>\
                <li class="tag-color-circle" data-tag-color="<%=colors[i]%>" style="background-color:<%=colors[i]%>"></li>\
            <% }%>  \
            </ul>\
            <button class="button done add-tag-btn"><%=addTag%></button>\
          </div>\
        </div>\
        <div class="btns-block form-button-groups  flex-align end">\
            <div class="tag-sample">\
              <span class="ent-sample"><%=BabelStr.str(21800)%></span>\
              <span class="person-sample"><%=BabelStr.str(21801)%></span>\
            </div>\
          <button class="btn-cancel button"><%=BabelStr.str(156)%></button>\
          <button class="btn-ok button done" disabled><%=BabelStr.str(154)%></dib>\
        </div>';
  },
  tagItem: '<li data-tag-id="<%=id%>" class="tag-line <%=tagClass%>" title="<%=text%>">\
                <div class="chb-col <%=disable%>">\
                  <div class="chb">\
                      <%if(selected){%>\
                        <input type="checkbox" id="<%=id%>" checked="true" /><label></label>\
                      <%}else{%>\
                        <input type="checkbox" id="<%=id%>"/><label></label>\
                      <%}%>\
                    </div>\
                </div>\
                <i class="tag-color-circle" style="background-color:<%=color%>" title="<%=title%>"></i>\
                <span class="tag-name middle-ellipsis"><%=htmlText%></span>\
              </li>',
  selectedTagItem: '<li data-tag-id="<%=id%>" class="tag-div <%=canDel%>" title="<%=text%>">\
                      <span class="tag-color-circle" style="background-color:<%=color%>"></span>\
                      <span class="tag-name middle-ellipsis"><%=htmlText%></span>\
                      <span class="tag-del icon icon20"></span>\
                    </li>',
  className: function className() {
    var superCls = _MDAddTagCommonBaseView["default"].prototype.className.call(this);
    return superCls + 'add-tag-common ';
  },
  initProps: function initProps() {
    var superP = _MDAddTagCommonBaseView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      showSearchCondition: false
    });
  },
  events: function events() {
    var superE = _MDAddTagCommonBaseView["default"].prototype.events.call(this);
    return _.extend(superE, {
      "click .btn-ok": this.okClicked,
      'click .btn-cancel': this.cancelClicked,
      "mousedown .con-item": this._conItemClickHandler,
      "click .add-aitag": this._addAiTag
    });
  },
  initialize: function initialize(options) {
    options.width = 360;
    var self = this;
    _MDAddTagCommonBaseView["default"].prototype.initialize.call(this, options);
    if (!this.tagCollectionSelected) {
      this.tagCollectionSelected = new _MDTagCollection["default"]();
    }

    // if(this.showSearchCondition) {
    //   this.$(".search-condition-block").removeClass("f-hide")
    // }
    this.$('.tag-sample').hide();
    this._initColumns();
    this._initTagList();
    if (this.showAitag) {
      this.$(".aitag").removeClass("f-hide");
    }
  },
  _addAiTag: function _addAiTag() {
    var _this = this;
    this.$(".aitag").addClass("loading");
    _.isFunction(this.addAItag) && this.addAItag(function (sign) {
      _this.$(".aitag").removeClass("loading");
    });
  },
  _conItemClickHandler: function _conItemClickHandler($e) {
    if (this.$('.condition-block').hasClass("disabled")) {
      return;
    }
    this.$('.con-item').removeClass("checked");
    $($e.target).closest(".con-item").addClass("checked");
    this.setOp = this.$('.con-item.checked').index();
    console.log(this.setOp);
  },
  getSetOp: function getSetOp() {
    return this.setOp;
  },
  _initColumns: function _initColumns() {
    var colors = _MDAddTagCommonBaseView["default"].defaultColors;
    var $colRoot = this.$(".tag-column-root");
    $colRoot.empty();
    for (var i = 0; i < colors.length; i++) {
      var color = colors[i];
      var $c = $('<div class="tag-column">' + '<div class="tag-column-t" style="background-color:' + color + '"></div>' + '<ul class="tag-list"></ul>' + '</div>');
      $colRoot.append($c);
    }
  },
  _initTagList: function _initTagList() {
    this.bindSelf(this._onTagListItemClickHandler);
    this.bindSelf(this._onDelClickHandler);
    _MDAddTagCommonBaseView["default"].prototype._initTagList.call(this);
    this.$('.tag-list').on('click', 'li', this._onTagListItemClickHandler);
    this.$('.tag-selected-block').on('click', '.tag-del', this._onDelClickHandler);
  },
  viewDidUnRendered: function viewDidUnRendered() {
    _MDAddTagCommonBaseView["default"].prototype.viewDidUnRendered.call(this);
    this.$('.tag-list').off();
    this.$('.tag-selected-block').off();
  },
  _getSpinParent: function _getSpinParent() {
    return this.$('.tag-column-section');
  },
  _initSelectedTagInfo: function _initSelectedTagInfo() {
    _MDAddTagCommonBaseView["default"].prototype._initSelectedTagInfo.call(this);
    this.renderSelectedTag();
  },
  renderTagCollectionICanChoose: function renderTagCollectionICanChoose(tagSearchName) {
    var _this2 = this;
    var self = this;
    var tagCollection = this.tagCollectionICanChoose;
    var compiler = _.template(this.tagItem);
    var hasEnterpriseTag = false;

    // 过滤掉不匹配的
    if (tagSearchName) {
      tagCollection = tagCollection.filter(function (tagModel) {
        return tagModel.getText().indexOf(tagSearchName) > -1;
      });
      tagCollection = new _MDTagCollection["default"](tagCollection);
    }
    var colors = _MDAddTagCommonBaseView["default"].defaultColors;
    var _loop = function _loop() {
        html = [];
        var color = colors[i];
        tagCollection.each(function (tagModel) {
          var tagColor = tagModel.getColor().toUpperCase();
          var disabled = "";
          if (!self._canDelTag(tagModel)) {
            disabled = "disable";
          }
          if (tagColor == color) {
            if (tagModel.get('enterpriseUsed')) {
              hasEnterpriseTag = true;
            }
            var tagInfo = tagModel.toJSON();
            var selected = tagModel.isSelected();
            tagInfo['color'] = tagModel.getColor();
            tagInfo['selected'] = selected;
            tagInfo['disable'] = disabled;
            tagInfo['tagClass'] = tagModel.get('enterpriseUsed') ? "ent-tag" : "";
            tagInfo['title'] = tagModel.get('enterpriseUsed') ? "企业标签" : "个人标签";
            tagInfo['htmlText'] = tagInfo['text'].replace(new RegExp(tagSearchName, 'g'), function (match) {
              if (match) {
                return '<span class="emp">' + match + '</span>';
              } else {
                return match;
              }
            });
            var snippet = compiler(tagInfo);
            html.push(snippet);
          }
        });
        $(_this2.$('.tag-list')[i]).empty().append(html.join(''));
      },
      html;
    for (var i = 0; i < colors.length; i++) {
      _loop();
    }
    if (hasEnterpriseTag) {
      this.$('.tag-sample').show();
    } else {
      this.$('.tag-sample').hide();
    }
    this.curSelectedIndex = undefined;
  },
  renderSelectedTag: function renderSelectedTag() {
    var self = this;
    var tagCollection = this.tagCollectionSelected;
    if (!this.tagsDisplayed) {
      this.tagsDisplayed = this.tagCollectionSelected;
    } else {
      this.tagsDisplayed.each(function (tag) {
        if (tag) {
          var t0 = self.tagCollectionSelected.find({
            id: tag.id
          });
          if (!t0) {
            self.tagsDisplayed.remove(tag);
          }
        }
      });
      this.tagCollectionSelected.each(function (tag) {
        var t0 = self.tagsDisplayed.find({
          id: tag.id
        });
        if (!t0) {
          self.tagsDisplayed.add(tag);
        }
      });
    }
    var compiler = _.template(this.selectedTagItem);
    var html = [];
    this.tagsDisplayed.each(function (tagModel) {
      var tagInfo = tagModel.toJSON();
      var canDel = "";
      if (self._canDelTag(tagModel)) {
        canDel = "can-del";
      }
      tagInfo['color'] = tagModel.getColor();
      tagInfo['canDel'] = canDel;
      tagInfo['htmlText'] = tagInfo['text'];
      tagInfo['tagClass'] = tagModel.get('enterpriseUsed') ? "ent-tag" : "";
      tagInfo['title'] = tagModel.get('enterpriseUsed') ? "企业标签" : "";
      var snippet = compiler(tagInfo);
      html.push(snippet);
    });
    this.$('.tag-selected-block').empty().append(html.join(''));
  },
  selectionChangedFromOutside: function selectionChangedFromOutside(selectTagCollection) {
    if (this.tagCollectionSelected.length == 0 && this.tagCollectionICanChoose.length == 0) {
      this.tagCollectionSelected = selectTagCollection;
      return;
    }
    var self = this;
    var tagCollection = this.tagCollectionICanChoose;
    var needRefresh = false;
    selectTagCollection.each(function (tag0) {
      var tag1 = tagCollection.find({
        id: tag0.id
      });
      if (tag1 && !tag1.isSelected()) {
        tag1.setSelected(true);
        needRefresh = true;
      }
    });
    needRefresh && this.tagSelectionChanged();
  },
  tagSelectionChanged: function tagSelectionChanged() {
    this.tagCollectionSelected = new _MDTagCollection["default"]();
    var tagCollection = this.tagCollectionICanChoose;
    var self = this;
    tagCollection.each(function (tag) {
      if (tag.isSelected()) {
        self.tagCollectionSelected.add(tag);
      }
    });
    this._initSelectedTagInfo();
    this._refreshSelectStatus();
  },
  validateTagName: function validateTagName(tagName) {
    var tagModel = this.tagCollectionICanChoose.find(function (tagModel) {
      return tagModel.getText() == tagName;
    });
    if (tagModel) {
      tagModel.setSelected(true);
      this._executeAddTag(tagModel);
      this.tagSelectionChanged();
      this.$(".tag-name-input").val("");
      this.tagNameInputHandler();
      return false;
    }
    return true;
  },
  _executeAddTag: function _executeAddTag(tagModel, refresh) {
    var self = this;
    var validator = this.$('form').validate();
    self.$addButton.prop('disabled', true);
    if (!tagModel.id) {
      tagModel.setId(MDAddTagCommonBigView.getNextTempTagId());
      tagModel.setSelected(true);
      this.tagCollectionICanChoose.add(tagModel);
      this.tagSelectionChanged();
    }
    if (_.isFunction(this.onAddTag)) {
      this.onAddTag(tagModel, {
        success: function success() {
          self.$addButton.prop('disabled', false);
        },
        fail: function fail(errorMsg) {
          if (error) {
            var error = {};
            error[this.tagInputName] = errorMsg;
            validator.showErrors(error);
          }
          self.$addButton.prop('disabled', false);
        }
      });
    } else {
      self.$addButton.prop('disabled', false);
    }
  },
  _executeRemoveTag: function _executeRemoveTag(tagModel) {
    var self = this;
    var validator = this.$('form').validate();
    _.isFunction(this.onRemoveAddedTag) && this.onRemoveAddedTag(tagModel, {
      success: function success() {},
      fail: function fail(errorMsg) {
        if (error) {
          var error = {};
          error[this.tagInputName] = errorMsg;
          validator.showErrors(error);
        }
      }
    });
  },
  _canDelTag: function _canDelTag(tagModel) {
    var self = this;
    if (self.checkCanDelTag(tagModel.getId())) {
      return true;
    }
    return false;
  },
  _onTagListItemClickHandler: function _onTagListItemClickHandler($e) {
    var self = this;
    var $li = $($e.currentTarget);
    var tagId = $li.data('tagId');
    var tagModel = this.tagCollectionICanChoose.find(function (tagModel) {
      return tagModel.getId() == tagId;
    });
    console.log('-------- clicked:' + tagId);

    // 点击已选中的标签，删除标签
    if (tagModel.isSelected()) {
      var selTag = this.tagCollectionSelected.find(function (tagModel) {
        return tagModel.getId() == tagId;
      });
      if (this._canDelTag(selTag)) {
        tagModel.setSelected(false);
        this._executeRemoveTag(tagModel);
        this.tagSelectionChanged();
      }
      // 添加已有标签
    } else {
      tagModel.setSelected(true);
      this._executeAddTag(tagModel);
      this.tagSelectionChanged();
    }
    this.$(".btn-ok").attr("disabled", false);
  },
  _onDelClickHandler: function _onDelClickHandler($e) {
    var self = this;
    var $li = $($e.currentTarget).parent();
    var tagId = $li.data('tagId');
    var tagModel = this.tagCollectionICanChoose.find(function (tagModel) {
      return tagModel.getId() == tagId;
    });
    tagModel.setSelected(false);
    this._executeRemoveTag(tagModel);
    this.tagSelectionChanged();
    this.$(".btn-ok").attr("disabled", false);
  },
  _refreshSelectStatus: function _refreshSelectStatus() {
    var self = this;
    var $checkboxes = self.$(":checkbox");
    for (var i = 0; i < $checkboxes.length; i++) {
      var element = $checkboxes[i];
      $(element).removeProp("checked");
    }
    this.tagCollectionSelected.each(function (tagModel) {
      for (var _i = 0; _i < $checkboxes.length; _i++) {
        var _element = $checkboxes[_i];
        if (_element.id == tagModel.getId()) {
          if (!self._canDelTag(tagModel)) {
            $(_element).parents(".chb-col").addClass('disable');
          }
          $(_element).prop("checked", true);
        }
      }
    });
    this.renderSelectedTag();
  },
  _showCreateTagBtn: function _showCreateTagBtn(show) {
    _MDAddTagCommonBaseView["default"].prototype._showCreateTagBtn.call(this, show);
    // if (show) {
    //   this.$('.tag-column-section').hide();
    // } else {
    //   this.$('.tag-column-section').show();
    // }
  },
  okClicked: function okClicked(e) {
    if (this.onOkClose) {
      this.onOkClose();
    }
  },
  cancelClicked: function cancelClicked(e) {
    if (this.onCancelClose) {
      this.onCancelClose();
    }
  },
  onCreateTagBtnStatusChanged: function onCreateTagBtnStatusChanged() {
    // if (this.createBtnIsShowing) {
    //   this.$('.btn-ok').prop('disabled', true);
    // } else {
    //   this.$('.btn-ok').prop('disabled', false);
    // }
  },
  getClassName: function getClassName() {
    return "MDAddTagCommonBigView";
  }
}, {
  tempTagId: 0,
  getNextTempTagId: function getNextTempTagId() {
    var id = MDAddTagCommonBigView.tempTagId++;
    return "temp" + id;
  },
  isTempTagId: function isTempTagId(id) {
    var idstr = id + "";
    return idstr.indexOf('temp') == 0;
  }
});
var _default = exports["default"] = MDAddTagCommonBigView;

},{"1184":1184,"1415":1415,"1417":1417,"1421":1421,"1424":1424,"1436":1436,"1454":1454,"1463":1463,"1476":1476,"1477":1477,"1478":1478,"1492":1492,"1546":1546,"288":288,"782":782}],782:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1424);
require(1431);
require(1417);
require(1463);
require(1498);
require(1421);
var _MDLocalString = _interopRequireDefault(require(1150));
var _MMViewBase = _interopRequireDefault(require(22));
var _keycode = _interopRequireDefault(require(104));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDTag = _interopRequireDefault(require(287));
var _MDTagCollection = _interopRequireDefault(require(288));
var _MDTagDataController = _interopRequireDefault(require(1093));
var _MDAddTagBigWindow = _interopRequireDefault(require(781));
var _regexp = _interopRequireDefault(require(106));
var _MDSnackbarView = _interopRequireDefault(require(72));
/**
 * 添加标签
 * Created by jiang copied from han's MDAddTagPopupView.js
 * 2017.6.13
 */

var MDAddTagCommonBaseView = _MMViewBase["default"].extend({
  tmpl: function tmpl() {
    var stringBuilder = [];
    var content = "";
    stringBuilder.push('<div class="content"><i class="popup-arrow"></i><div class="content-inner">');
    if (_.isFunction(this.contentTmpl)) {
      content = this.contentTmpl();
    } else {
      content = this.contentTmpl;
    }
    stringBuilder.push(content);
    stringBuilder.push('</div></div>');
    return stringBuilder.join('');
  },
  className: function className() {
    var superCls = _MMViewBase["default"].prototype.className.call(this);
    return superCls + ' ';
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      shouldSearchTag: false,
      tagModel: new _MDTag["default"](),
      placeholder: BabelStr.str(458),
      // '请输入要搜索的或要新建的标签名称',

      /**
       * @typedef {onAddTagCallback}
       *
       * @param {MDTag}  tagModel - 新标签的对象
       * @param {function} [net.success] - 发送添加请求成功后的处理
       * @param {function} [net.fail] - 发送失败后的处理
       */
      onAddTag: _.noop,
      createBtnIsShowing: false,
      onRemoveAddedTag: _.noop,
      tagCollectionICanChoose: new _MDTagCollection["default"](),
      tagCollectionSelected: null,
      /**
       * 是否是后台管理使用
       * @type {boolean}
       */
      usedInEp: false,
      /**
       * @callback Validator
       * @param {string} tagName - 新标签名称
       * @return {{
       *
       *    validate: boolean,
       *    message: string
       * }}
       */
      /**
       * @type {Validator}
       */
      validator: undefined
    });
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click .add-tag-btn': this.addTagButtonClickHandler,
      'click .tag-color-list .tag-color-circle': this._tagColorClickHandler
    });
  },
  initialize: function initialize(options) {
    options.width = 360;
    var self = this;
    _MMViewBase["default"].prototype.initialize.call(this, options);
  },
  // _selectionChanged: function() {

  //   var self = this;

  //   this.tagCollectionSelected = new MDTagCollection();
  //   if (this.fileInfos.length == 0) {
  //     for (let i = 0; i < this.tagCollectionICanChoose.length; i++) {
  //       const tagModel = this.tagCollectionICanChoose[i];
  //       if (tagModel.isSelected()) {
  //         this.tagCollectionSelected.add(tagModel);
  //       }
  //     }
  //   } else {
  //     const tagCollection = this.fileInfos[0].getTagCollection();
  //     tagCollection.each(function(tag){
  //       var isPublicTag = true;
  //       for (let i = 1; i < self.fileInfos.length; i++) {
  //         const tagCollection2 = self.fileInfos[i].getTagCollection();
  //         var found = tagCollection2.find(function(tag2){
  //           return tag2.getId() == tag.getId();
  //         });
  //         if (!found) {
  //           isPublicTag = false;
  //           break;
  //         }
  //       }
  //       if (isPublicTag) {
  //         self.tagCollectionSelected.add(tag);
  //       }
  //     })
  //   }
  //   this._initSelectedTagInfo();
  //   this._refreshSelectStatus();
  // },

  _refreshSelectStatus: function _refreshSelectStatus() {},
  _initTagList: function _initTagList() {
    var self = this;
    this.bindSelf(this.inputKeyupHandler, this.inputKeydownHandler);
    this.$tagPropBlock = this.$('.tag-prop-block');
    this.$tagInput = this.$('.tag-name-input');
    this.$addButton = this.$('.add-tag-btn');
    var $spinParent = this._getSpinParent();
    if (this.shouldSearchTag) {
      this.$el.on('keyup', '.tag-name-input', this.inputKeyupHandler);
      this.$el.on('keydown', '.tag-name-input', this.inputKeydownHandler);
      this.$('.tag-prop-block').hide();
      this.$('.tag-select-color-circle').hide();
      _MDSpinnerloaderView["default"].showIn($spinParent[0], {
        autoHeight: true
      });
      if (app.isEpVersion() && !app.ep.getTagLimit() || !app.isEpVersion()) {
        _MDTagDataController["default"].getAllTagsICanSee(function (tags) {
          _MDSpinnerloaderView["default"].clearFrom($spinParent[0]);
          self.tagCollectionICanChoose.add(tags);
          self._initSelectedTagInfo(true);
          self.renderTagCollectionICanChoose();
          self.layout();
        }, function () {
          _MDSpinnerloaderView["default"].showIn($spinParent[0]);
        });
      } else {
        _MDTagDataController["default"].getAllTagsEntUsed(function (tags) {
          _MDSpinnerloaderView["default"].clearFrom($spinParent[0]);
          self.tagCollectionICanChoose.add(tags);
          self._initSelectedTagInfo(true);
          self.renderTagCollectionICanChoose();
          self.layout();
        }, function () {
          _MDSpinnerloaderView["default"].clearFrom($spinParent[0]);
        });
      }
    } else {
      this.createBtnIsShowing = true;
      this.$el.addClass('without-search');
      this.$el.on('keyup', '.tag-name-input', this.inputKeyupHandler);
      this.$tagPropBlock.show();
      this.$('form').validate({
        errorPlacement: function errorPlacement(error, element) {
          $(error).appendTo($(element).closest('.form-item'));
        }
      });
      var prompStr = _MDLocalString["default"].getLocalString(249);
      this.$('input').rules('add', {
        'required': true,
        'notempty': true,
        messages: {
          'required': prompStr,
          'notempty': prompStr
        }
      });
    }
    var index = localStorage.getItem('tag-color-index');
    if (index == null || index == undefined || index >= MDAddTagCommonBaseView.defaultColors.length) {
      index = 0;
    }
    this.selectColor(MDAddTagCommonBaseView.defaultColors[index]);
  },
  _initSelectedTagInfo: function _initSelectedTagInfo(init) {
    this.tagCollectionICanChoose.comparator = 'text';
    this.tagCollectionICanChoose.sort();
    var tagSelected = this.tagCollectionSelected;
    var tagCollection = this.tagCollectionICanChoose;
    tagCollection.each(function (model) {
      model.setSelected(false);
    });
    if (tagSelected) {
      tagSelected.each(function (tagModel) {
        var tId = tagModel.getId();
        var selectedTag = tagCollection.find(function (tagModel1) {
          return tagModel1.getId() == tId;
        });
        if (selectedTag) {
          selectedTag.setSelected(true);
        }
      });
    } else {
      console.error('------> tagCollectionSelected 没有赋值！');
    }
  },
  _canAddTag: function _canAddTag() {
    return (!app.isEpVersion() || !app.ep.getTagLimit() || app.currentUser.isEpAdminUser()) && !this.cannotCreateTag;
  },
  tagNameInputHandler: function tagNameInputHandler() {
    var inputText = this.$tagInput.val();
    inputText = inputText.trim();
    this.renderTagCollectionICanChoose(inputText);
    var hasMatched = this.tagCollectionICanChoose.find(function (tagModel) {
      return tagModel.getText().indexOf(inputText) > -1;
    });
    if (inputText.length > 0 && this._canAddTag()) {
      this._showCreateTagBtn(true);
    } else {
      this._showCreateTagBtn(false);
    }
  },
  _showCreateTagBtn: function _showCreateTagBtn(show) {
    if (show) {
      this.createBtnIsShowing = true;
      this.$('.tag-prop-block').show();
      this.$('.tag-select-color-circle').show();
      this._removeBitBtn();
    } else {
      this.createBtnIsShowing = false;
      this.$('.tag-prop-block').hide();
      this.$('.tag-select-color-circle').hide();
    }
    this.onCreateTagBtnStatusChanged();
  },
  onCreateTagBtnStatusChanged: function onCreateTagBtnStatusChanged() {},
  inputKeydownHandler: function inputKeydownHandler($e) {
    if (this.$('.tag-search-list').children().length == 0) {
      return;
    }
    if (_keycode["default"].codes.UP == $e.which) {
      this._onArrowUp();
    } else if (_keycode["default"].codes.DOWN == $e.which) {
      this._onArrowDown();
    }
  },
  inputKeyupHandler: function inputKeyupHandler($e) {
    var text = this.$tagInput.val();
    if (_keycode["default"].isEnterKey($e.which)) {
      this._onEnter();
    } else {
      this.tagNameInputHandler();
    }
  },
  _onEnter: function _onEnter() {
    // if(this.$(".tag-list li").length) {
    //   this.$(".tag-list li").eq(0).click()
    //   this.$(".tag-name-input").val("")
    //   this.tagNameInputHandler();
    // } else {
    this.addTagButtonClickHandler();
    // }
    // this.$('.btn-ok').prop('disabled', false);
  },
  selectColor: function selectColor(color) {
    var index = _.indexOf(MDAddTagCommonBaseView.defaultColors, color);
    if (index > -1) {
      var $circles = this.$('.tag-color-list').children();
      $circles.eq(index).addClass('selected').siblings().removeClass('selected');
      localStorage.setItem('tag-color-index', index);
    }
    this.selectedColor = color;
    this.$('.tag-select-color-circle').css('background-color', color);
  },
  _removeBitBtn: function _removeBitBtn() {
    var self = this;
    if (this.$openWinBtn) {
      self.$openWinBtn.remove();
      self.$openWinBtn = null;
    }
  },
  _openBigTagWindow: function _openBigTagWindow() {
    var addTagWin = new _MDAddTagBigWindow["default"]({
      fileInfos: [this.fileInfo],
      tagCollection: this.tagCollection
    });
    addTagWin.show();
    this.getSuperView().remove();
  },
  validateTagName: function validateTagName(tagName) {
    var tagModel = this.tagCollectionICanChoose.find(function (tagModel) {
      return tagModel.getText() == tagName;
    });
    if (tagModel) {
      tagModel.setSelected(true);
      this._executeAddTag(tagModel);
      this.$(".tag-name-input").val("");
      this.tagNameInputHandler();
      return false;
    }
    return true;
  },
  addTagButtonClickHandler: function addTagButtonClickHandler($e) {
    if (!this._canAddTag()) {
      return;
    }
    this.$('.btn-ok').prop('disabled', false);
    var self = this;
    var tagModel;
    var tagId;
    var selectedColor = this.selectedColor;
    var tagModel = new _MDTag["default"]();
    var tagName = this.$tagInput.val().trim();
    if (!this.validateTagName(tagName)) {
      return;
    }
    if (!_regexp["default"].validateTextinput(tagName)) {
      _MDSnackbarView["default"].show(BabelStr.str(12202));
      return;
    }
    tagModel.set({
      'color': selectedColor,
      'text': _.escape(tagName)
    });
    //
    // 开启搜索条件下的添加标签
    //
    if (this.shouldSearchTag) {
      //
      // 添加已有标签
      //
      if (this.curSelectedIndex > -1) {
        tagId = this.$('.tag-search-list').children().eq(this.curSelectedIndex).data('tagId');
        tagModel = this.tagCollectionICanChoose.find(function (tagModel) {
          return tagModel.getId() == tagId;
        });
        if (tagModel.isSelected()) {
          this._executeRemoveTag(tagModel);
        } else {
          this._executeAddTag(tagModel);
        }

        // 创建标签，并添加标签
      } else {
        if (this.validateInput(this.tagCollectionICanChoose)) {
          this._executeAddTag(tagModel);
        }
      }
      // 直接添加标签
    } else {
      if (!this.validateInput(this.tagCollection)) {
        return;
      }
      this._executeAddTag(tagModel);
    }
    this.$tagInput.val('');
    this.tagNameInputHandler();
  },
  validateInput: function validateInput(tagCollection) {
    var tagName = this.$tagInput.val().trim();
    var validator = this.$('form').validate();
    validator.element(this.$('input'));
    var error = {};
    if (!validator.valid()) {
      return false;
    }
    if (this.shouldSearchTag && tagName.length == 0) {
      return;
    }
    var hasSameName = false;
    if (_.isFunction(this.isTagExist)) {
      hasSameName = this.isTagExist(tagName);
    } else {
      hasSameName = !!tagCollection.find(function (tagModel) {
        if (tagModel.getText() == tagName) {
          return true;
        }
      });
    }
    if (hasSameName) {
      if (this.processSameTag && this.processSameTag(tagName)) {
        return false;
      }
      error[this.tagInputName] = _MDLocalString["default"].getLocalString(250);
      validator.showErrors(error);
      return false;
    }
    if (_.isFunction(this.validator)) {
      var res = this.validator(tagName);
      if (!res.validate) {
        error[this.tagInputName] = res.message;
        validator.showErrors(error);
        return false;
      }
    }
    return true;
  },
  _executeAddTag: function _executeAddTag(tagModel) {
    var self = this;
    var validator = this.$('form').validate();
    self.$addButton.prop('disabled', true);
    if (_.isFunction(this.onAddTag)) {
      this.onAddTag(tagModel, {
        success: function success() {
          self.addTagCallback();
          self.$addButton.prop('disabled', false);
        },
        fail: function fail(errorMsg) {
          if (error) {
            var error = {};
            error[this.tagInputName] = errorMsg;
            validator.showErrors(error);
          }
          self.$addButton.prop('disabled', false);
        }
      });
    } else {
      self.$addButton.prop('disabled', false);
    }
  },
  _executeRemoveTag: function _executeRemoveTag(tagModel) {
    var self = this;
    var validator = this.$('form').validate();
    _.isFunction(this.onRemoveAddedTag) && this.onRemoveAddedTag(tagModel, {
      success: function success() {
        self.removeTagCallback();
      },
      fail: function fail(errorMsg) {
        if (error) {
          var error = {};
          error[this.tagInputName] = errorMsg;
          validator.showErrors(error);
        }
      }
    });
  },
  _tagColorClickHandler: function _tagColorClickHandler($e) {
    var $circle = $($e.target);
    var selectedColor = $circle.data('tagColor');
    this.selectColor(selectedColor);
  },
  render: function render() {
    this.tagInputName = this.cid + '-tag-input';
    var data = {
      'colors': MDAddTagCommonBaseView.defaultColors,
      'placeholder': this.placeholder,
      'tagName': this.tagInputName,
      'addTag': _MDLocalString["default"].getLocalString(748)
    };
    _MMViewBase["default"].prototype.render.call(this, data);
  },
  viewDidRendered: function viewDidRendered() {
    _MMViewBase["default"].prototype.viewDidRendered.call(this);
    var self = this;
    setBabelTimeout(function () {
      self.$tagInput[0].focus();
    }, 100);
  },
  viewWillUnRendered: function viewWillUnRendered(param) {
    _MMViewBase["default"].prototype.viewWillUnRendered.call(this, param);
  },
  getClassName: function getClassName() {
    return "MDAddTagCommonBaseView";
  }
}, {
  defaultColors: ['#59BDF9', '#FF665C', '#FFAA4D', '#FED754', '#85E167', '#D68FE7', '#A4A4A7']
});
var _default = exports["default"] = MDAddTagCommonBaseView;

},{"104":104,"106":106,"1093":1093,"1150":1150,"1184":1184,"1417":1417,"1421":1421,"1424":1424,"1431":1431,"1454":1454,"1463":1463,"1498":1498,"22":22,"287":287,"288":288,"72":72,"76":76,"781":781}],652:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationWindowView = _interopRequireDefault(require(92));
var _MDProjectCreateInfoPageView = _interopRequireDefault(require(650));
var _MDProjectTransforPageView = _interopRequireDefault(require(654));
var _MDProjectTransforToUsedrPageView = _interopRequireDefault(require(655));
var _MDProjectCreateSelectPageView = _interopRequireDefault(require(651));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDProjectCreateWinView = exports["default"] = /*#__PURE__*/function (_MDNavigationWindowVi) {
  (0, _inherits2["default"])(MDProjectCreateWinView, _MDNavigationWindowVi);
  function MDProjectCreateWinView() {
    (0, _classCallCheck2["default"])(this, MDProjectCreateWinView);
    return _callSuper(this, MDProjectCreateWinView, arguments);
  }
  (0, _createClass2["default"])(MDProjectCreateWinView, [{
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDProjectCreateWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        type: 2 // 0 : 新增, 1 : 编辑, 2: 转交给部门人员, 3: 转换为子项目， 4：转换为父项目  5 转交给项目人员
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      // props.title =
      props.size = 'large';
      switch (props.type) {
        case 2:
        case 3:
        case 4:
          props.rootNavigationPageView = new _MDProjectTransforPageView["default"](props);
          // props.width = 480;
          break;
        case 5:
          props.rootNavigationPageView = new _MDProjectTransforToUsedrPageView["default"](props);
          break;
        case 0:
          props.rootNavigationPageView = new _MDProjectCreateSelectPageView["default"](props);
          break;
        case 6:
          props.type = 0;
          props.nextStepCallback = function (fileInfo) {
            _this.pushEditProjectInfoView(fileInfo);
          };
          props.rootNavigationPageView = new _MDProjectCreateInfoPageView["default"](props);
          break;
        case 7:
          props.type = 0;
          // props.type = 1
          // props.fileId = props.originFile.getFileId()

          props.nextStepCallback = function (fileInfo, models) {
            _this.pushEditProjectInfoView(fileInfo, models);
          };
          props.rootNavigationPageView = new _MDProjectCreateInfoPageView["default"](props);
          break;
        default:
          // if(props.type == 0) {
          // 	props.nextStepCallback = (fileInfo)=>{
          // 		this.pushEditProjectInfoView(fileInfo)
          // 	}
          // }
          props.rootNavigationPageView = new _MDProjectCreateInfoPageView["default"](props);
          break;
      }
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDProjectCreateWinView.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "pushEditProjectInfoView",
    value: function pushEditProjectInfoView(fileInfo, models) {
      var pageView = new _MDProjectCreateInfoPageView["default"]({
        type: 1,
        fileId: fileInfo['fileId'],
        showCreateProjectSuccess: true,
        users: models
      });
      this.hideBackBtn = true;
      this.push(pageView);
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDProjectCreateWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " project-win");
    }
  }]);
  return MDProjectCreateWinView;
}(_MDNavigationWindowView["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"650":650,"651":651,"654":654,"655":655,"92":92}],651:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDProjectCreateInfoPageView = _interopRequireDefault(require(650));
var _MDProjectTransforPageView = _interopRequireDefault(require(654));
var _MDProjectTransforToUsedrPageView = _interopRequireDefault(require(655));
var _MDHQSMProjectCreatePageView = _interopRequireDefault(require(642));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 *	new Project window
 *	created by jichao
 *	2018.11.22
 */
var MDProjectCreateSelectPageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDProjectCreateSelectPageView, _MDNavigationPageView);
  function MDProjectCreateSelectPageView() {
    (0, _classCallCheck2["default"])(this, MDProjectCreateSelectPageView);
    return _callSuper(this, MDProjectCreateSelectPageView, arguments);
  }
  (0, _createClass2["default"])(MDProjectCreateSelectPageView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n\t  \n\t\t\t<div class=\"select-project-block flex-align center\">\n\t\t\t\t<div class=\"item generalProject\">\n          <div class=\"card\">\n            <div class=\"project-icon\"></div>\n            <div class=\"f-tc name\"><%=BabelStr.str(5202)%></div>          \n          </div>\n          <div class=\"help-words\"><%=BabelStr.str(5204)%></div>\n        </div>\n\t\t\t\t<div class=\"item HQSMProject\">\n          <div class=\"card\">\n            <div class=\"project-icon\"></div>\n            <div class=\"f-tc name\"><%=BabelStr.str(5203)%></div>\n          </div>\n          <div class=\"help-words\"><%=BabelStr.str(5205)%></div>\n        </div>\n\t\t\t</div>\n\t\t";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDProjectCreateSelectPageView.prototype), "initProps", this).call(this);
      return _.extend(superP, {});
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDProjectCreateSelectPageView.prototype), "className", this).call(this);
      return "".concat(superCls, " project-select-panel");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDProjectCreateSelectPageView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .generalProject': this._createGeneralProject,
        'click .HQSMProject': this._createHQSMProject
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDProjectCreateSelectPageView.prototype), "initialize", this).call(this, props);
      this.setTitle(BabelStr.str(5201));
      this.props = props;
    }
  }, {
    key: "close",
    value: function close() {
      this.navigationWindowView.close();
    }
  }, {
    key: "_createGeneralProject",
    value: function _createGeneralProject() {
      var _this = this;
      var params = this.props;
      params = _.extend(params, {
        nextStepCallback: function nextStepCallback(fileInfo) {
          _this.pushEditProjectInfoView(fileInfo);
        }
      });
      var view = new _MDProjectCreateInfoPageView["default"](params);
      this.navigationWindowView.push(view);
    }
  }, {
    key: "_createHQSMProject",
    value: function _createHQSMProject() {
      var view = new _MDHQSMProjectCreatePageView["default"]();
      this.navigationWindowView.push(view);
    }
  }, {
    key: "pushEditProjectInfoView",
    value: function pushEditProjectInfoView(fileInfo) {
      var pageView = new _MDProjectCreateInfoPageView["default"]({
        type: 1,
        fileId: fileInfo['fileId'],
        showCreateProjectSuccess: true
      });
      this.navigationWindowView.push(pageView);
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MDProjectCreateSelectPageView';
    }
  }]);
  return MDProjectCreateSelectPageView;
}(_MDNavigationPageView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"56":56,"642":642,"650":650,"654":654,"655":655}],655:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1439);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDAddProjectMemberPageView = _interopRequireDefault(require(639));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MEDepartChooseView = _interopRequireDefault(require(138));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MDSnackbarView = _interopRequireDefault(require(72));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 *	new Project window
 *	created by jichao
 *	2018.11.22
 */
var MDProjectTransforToUsedrPageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDProjectTransforToUsedrPageView, _MDNavigationPageView);
  function MDProjectTransforToUsedrPageView() {
    (0, _classCallCheck2["default"])(this, MDProjectTransforToUsedrPageView);
    return _callSuper(this, MDProjectTransforToUsedrPageView, arguments);
  }
  (0, _createClass2["default"])(MDProjectTransforToUsedrPageView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n\t\t\t<div class=\"row mgb-10\">\n\t\t\t\t<div class=\"flex-align middle col-6\">\n          <label class=\"no-shrink left-label\"><%=BabelStr.str(158)%></label>\n          <div class=\"pro-name\"></div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"flex-align col-6 middle\">\n\t\t\t\t\t<span class=\"no-shrink left-label f-tr pdr-20\"><%=BabelStr.str(2822)%></span>\n\t\t\t\t\t<div class=\"directorName text-hide\"></div || app.currentUser>\n\t\t\t\t</div>\t\t\t\t\t\n\t\t\t</div>\n      <div class=\"flex-align\">\n        <div class=\"left-label\"><%=BabelStr.str(2824)%>:</div>\n        <div class=\"target-name\"></div>\n      </div>\n      <div class=\"user-block users-list\"></div>\n\t\t\t<div class=\"btns-block flex-align end\">\n\t\t\t\t<button class=\"button cancel\"><%=BabelStr.str(155)%></button>\n\t\t\t\t<button class=\"save button done\" disabled ><%=BabelStr.str(154)%></button>\n\t\t\t</div>\n\t\t";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDProjectTransforToUsedrPageView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        userCollection: new _MDMolaUserCollection["default"](),
        type: 2,
        projectInfo: {},
        destDirId: undefined
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDProjectTransforToUsedrPageView.prototype), "className", this).call(this);
      return "".concat(superCls, " project-info-panel");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDProjectTransforToUsedrPageView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .item': this.checkItem,
        'click .save': this.transformProject,
        'click .cancel': this.close
      });
    }
  }, {
    key: "render",
    value: function render(data) {
      var option = {
        type: this.type
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDProjectTransforToUsedrPageView.prototype), "render", this).call(this, option);
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDProjectTransforToUsedrPageView.prototype), "initialize", this).call(this, props);
      this.setTitle(BabelStr.str(6038));
      MMEnterpriseController.project.getProjectByFileId(this.fileId, function (project) {
        _this.$('.pro-name').html(project[0].name);
        _this.$('.directorName').html(project[0].directorName || app.currentUser.getUserName());
      }, function () {
        console.error('fail');
      });
      MMEnterpriseController.project.getProjectMembers(this.fileId, function (members) {
        _this.staticMembers = new _MDMolaUserCollection["default"](_.clone(members));
        var tmpl = '';
        _this.staticMembers.each(function (user) {
          tmpl += user.getUserItemHtmlStr();
        });
        _this.$('.users-list').html(tmpl);
        _this.navigationWindowView.refreshWindow();
      }, function () {});
    }
  }, {
    key: "close",
    value: function close() {
      this.navigationWindowView.close();
    }
  }, {
    key: "checkItem",
    value: function checkItem(e) {
      var id = $(e.target).closest('.item').data('id') + '';
      this.directorId = id;
      var user = this.staticMembers.findWhere({
        id: id
      });
      this.$('.target-name').html(user.getUserName());
      this.$('.save').attr('disabled', false);
    }
  }, {
    key: "transformProject",
    value: function transformProject() {
      var _this2 = this;
      var options = {
        fileId: this.fileId,
        destDirId: undefined,
        directorId: this.directorId == this.staticDirectorId ? undefined : this.directorId
      };
      MMEnterpriseController.project.transformProject(options, function () {
        _MDSnackbarView["default"].show(BabelStr.str(308));
        _this2.navigationWindowView.close();
      }, function (err, code) {
        if (code == 323) {
          _MDSnackbarView["default"].show(BabelStr.str(2839));
        } else {
          _MDSnackbarView["default"].show(err);
        }
      });
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDProjectTransforToUsedrPageView.prototype), "viewDidRendered", this).call(this);
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MDProjectTransforToUsedrPageView';
    }
  }]);
  return MDProjectTransforToUsedrPageView;
}(_MDNavigationPageView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"138":138,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"273":273,"56":56,"639":639,"67":67,"72":72}],654:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1439);
require(1415);
require(1463);
require(1417);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDProjectMemberSelectPageView = _interopRequireDefault(require(653));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MEDepartChooseView = _interopRequireDefault(require(138));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDCheckboxView = _interopRequireDefault(require(37));
var _MDAddProjectMemberPageView = _interopRequireDefault(require(639));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 *	new Project window
 *	created by jichao
 *	2018.11.22
 */
var MDProjectTransforPageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDProjectTransforPageView, _MDNavigationPageView);
  function MDProjectTransforPageView() {
    (0, _classCallCheck2["default"])(this, MDProjectTransforPageView);
    return _callSuper(this, MDProjectTransforPageView, arguments);
  }
  (0, _createClass2["default"])(MDProjectTransforPageView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n\t\t\t<form>\n\t\t\t\t<div class=\"flex-align middle mgb-10\">\n\t\t\t\t\t<label class=\"no-shrink left-label\"><%=BabelStr.str(158)%></label>\n\t\t\t\t\t<div class=\"pro-name col-7 \"></div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"row mgb-10\">\n\t\t\t\t\t<div class=\"flex-align middle col-6\">\n\t\t\t\t\t\t<span class=\"no-shrink left-label\"><%=BabelStr.str(6037)%></span>\n\t\t\t\t\t\t<div class=\"belongDepName text-hide\"></div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"flex-align col-6 middle\">\n\t\t\t\t\t\t<span class=\"no-shrink left-label f-tr pdr-20\"><%=BabelStr.str(2822)%></span>\n\t\t\t\t\t\t<div class=\"directorName text-hide\"></div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<%if(type == 2){%>\n\t\t\t\t\t<div class=\"flex-align middle mgb-10\">\n\t\t\t\t\t\t<label class=\"no-shrink left-label\"><%=BabelStr.str(2823)%></label>\n\t\t\t\t\t\t<div class=\"dep-select-contain\"></div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"flex-align middle mgb-10\">\n\t\t\t\t\t\t<label class=\"no-shrink left-label\"><%=BabelStr.str(2824)%></label>\n\t\t\t\t\t\t<input type=\"text\" class=\"col-7 form-control manager\" placeholder=\"<%=BabelStr.str(12302)%>\"/>\n\t\t\t\t\t</div>\n\n\t\t\t\t<%} else if(type == 3) {%>\n\t\t\t\t\t<div class=\"flex-align mgb-10 project-block\">\n\t\t\t\t\t\t<label class=\"no-shrink left-label\"><%=BabelStr.str(2831)%></label>\n\t\t\t\t\t\t<div class=\"project-select-contain\" name=\"project\"></div>\n\t\t\t\t\t</div>\n\t\t\t\t<%}%>\n\t\t\t</form>\n\t\t\t<div class=\"btns-block flex-align between\">\n        <div class='to-member'></div>\n\t\t\t\t<div class='no-shrink'>\n          <button class=\"button cancel\"><%=BabelStr.str(155)%></button>\n          <button class=\"save button done\"><%=BabelStr.str(154)%></button>\n        </div>\n\t\t\t</div>\n\t\t";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDProjectTransforPageView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        userCollection: new _MDMolaUserCollection["default"](),
        type: 2,
        projectInfo: {},
        destDirId: undefined,
        remainOwner: false
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDProjectTransforPageView.prototype), "className", this).call(this);
      return "".concat(superCls, " project-info-panel");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDProjectTransforPageView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .manager': this._addManagerHandle,
        'click .save': this.transformProject,
        'click .cancel': this.close
      });
    }
  }, {
    key: "render",
    value: function render(data) {
      var option = {
        type: this.type
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDProjectTransforPageView.prototype), "render", this).call(this, option);
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDProjectTransforPageView.prototype), "initialize", this).call(this, props);
      var titleNum;
      switch (props.type) {
        case 2:
          titleNum = 2817; //转交
          break;
        case 3:
          titleNum = 2829; // 父转子
          break;
        case 4:
          titleNum = 2830; // 自转父
          break;
      }
      this.setTitle(BabelStr.str(titleNum));
      MMEnterpriseController.project.getProjectByFileId(this.fileId, function (project) {
        _this.$('.pro-name').html(project[0].name);
        _this.$('.belongDepName').html(project[0].belongDepName || BabelStr.str(5010));
        _this.$('.directorName').html(project[0].directorName);
        var folderId = project[0].folderId;
        var belongDepId = project[0].belongDepId;
        _this.staticDestDepId = belongDepId;
        _this.staticDirectorId = project[0].directorId;
        _this.staticDirectorUserType = project[0].directorUserType;
        if (_this.type == 3) {
          _this.renderProjectList(belongDepId);
        } else if (_this.type == 4) {
          // this.destDirId = folderId
        } else if (_this.type == 2) {
          _this.renderDepList();
          _this.toMember = new _MDCheckboxView["default"]({
            label: BabelStr.str(6757),
            // "允许匿名访问",
            isBlockLevel: true,
            editable: true,
            onChanged: function onChanged(checked) {
              _this.remainOwner = checked;
            }
          });
          _this.addSubView(_this.toMember, _this.$(".to-member")[0]);
        }
        _this.navigationWindowView.refreshWindow();
      }, function () {
        console.error('fail');
      });
    }
  }, {
    key: "close",
    value: function close() {
      this.navigationWindowView.close();
    }
  }, {
    key: "renderDepList",
    value: function renderDepList(id) {
      var _this2 = this;
      this.departView = new _MEDepartChooseView["default"]({
        readonly: true,
        needRoot: true,
        fixed: true,
        needAddDefault: true,
        placeholder: BabelStr.str(2838),
        selectedDepartId: id,
        onChange: function onChange(node) {
          _this2.destDirId = node['original']['folderId'];
          _this2.destDepID = node['original']['id'];
        },
        loadError: function loadError() {
          _this2.removeSubView(_this2.departView);
          _this2.$('.dep-select-contain').addClass("red").html(BabelStr.str(11345));
        }
      });
      this.addSubView(this.departView, this.$('.dep-select-contain')[0]);
      this.navigationWindowView.refreshWindow();
    }
  }, {
    key: "renderProjectList",
    value: function renderProjectList(id) {
      var _this3 = this;
      MMEnterpriseController.project.getDepartmentProjects(id, function (projects) {
        projects = _.filter(projects, function (project) {
          return project.folderId != _this3.fileId;
        });
        if (projects.length) {
          projects.unshift({
            name: BabelStr.str(2832)
          });
          var select = new _MDDropdownSelectListView["default"]({
            dataProvider: projects,
            labelField: 'name',
            isFixed: true,
            onChange: function onChange(item) {
              _this3.destDirId = item.folderId;
              _this3.removeError(_this3.$('.project-select-contain')[0]);
              _this3.navigationWindowView.refreshWindow();
            }
          });
          _this3.addSubView(select, _this3.$('.project-select-contain')[0]);
        } else {
          _this3.$('.project-select-contain').addClass("red").html(BabelStr.str(40051));
          _this3.$('.save').attr('disabled', true);
        }

        // this.navigationWindowView.refreshWindow()
        console.log('success');
      }, function () {
        console.log('fail');
        _this3.$('.project-select-contain').addClass("red").html(BabelStr.str(40051));
        _this3.$('.save').attr('disabled', true);
      });
    }
  }, {
    key: "removeError",
    value: function removeError(el) {
      var $el = $(el);
      var $msgContain = $el.find('.err-msg-append').remove();
      $el.removeClass('has-error-append');
    }
  }, {
    key: "showError",
    value: function showError(el, msg) {
      var $el = $(el);
      var $msgContain = $el.find('.err-msg-append');
      if ($msgContain.length > 0) {
        $msgContain.html(msg);
      } else {
        $msgContain = "<p class=\"err-msg-append\">".concat(msg, "</p>");
        $el.append($msgContain);
      }
      $el.addClass('has-error-append');
    }
  }, {
    key: "transformProject",
    value: function transformProject() {
      var _this4 = this;
      if (this.startCommit) {
        return;
      }
      this.startCommit = true;
      var validator = this.$('form').validate();
      if (this.type == 3 && !this.destDirId) {
        this.showError(this.$('.project-select-contain')[0], BabelStr.str(2834));
        this.navigationWindowView.refreshWindow();
        this.startCommit = false;
        return;
      }
      this.$('.save').html(BabelStr.str(4749));
      this.$('.save').attr('disabled', true);
      if (this.type == 4) {
        MMEnterpriseController.project.transformProjectToParent(this.fileId, function () {
          Dispatcher.trigger(MDEvents.RefreshCurFolder);
          _MDSnackbarView["default"].show(BabelStr.str(308));
          _this4.$('.save').html(BabelStr.str(154));
          _this4.$('.save').attr('disabled', false);
          _this4.navigationWindowView.close();
        }, function (err) {
          _this4.startCommit = false;
          _this4.$('.save').html(BabelStr.str(154));
          _this4.$('.save').attr('disabled', false);
          _MDSnackbarView["default"].show(err);
        });
        return;
      }
      var options = {
        fileId: this.fileId,
        destDirId: this.destDepID == this.staticDestDepId ? undefined : this.destDirId,
        directorId: this.directorId == this.staticDirectorId ? undefined : this.directorId,
        directorUserType: this.directorId == this.staticDirectorId && this.directorUserType == this.staticDirectorUserType ? undefined : this.directorUserType
      };
      if (this.type == 2) {
        if (!options.destDirId && !options.directorId) {
          this.navigationWindowView.close();
          this.startCommit = false;
          return;
        }
      }
      options.remainOwner = this.remainOwner;
      MMEnterpriseController.project.transformProject(options, function () {
        Dispatcher.trigger(MDEvents.RefreshCurFolder);
        _MDSnackbarView["default"].show(BabelStr.str(308));
        _this4.startCommit = false;
        _this4.$('.save').html(BabelStr.str(154));
        _this4.$('.save').attr('disabled', false);
        _this4.navigationWindowView.close();
      }, function (err, code) {
        _this4.startCommit = false;
        _this4.$('.save').html(BabelStr.str(154));
        _this4.$('.save').attr('disabled', false);
        if (code == 323) {
          _MDSnackbarView["default"].show(BabelStr.str(2839));
        } else {
          _MDSnackbarView["default"].show(err);
        }
      });
    }
  }, {
    key: "_addManagerHandle",
    value: function _addManagerHandle() {
      var _this5 = this;
      this.addmanagerView = new _MDAddProjectMemberPageView["default"]({
        // addManager: true,
        canSelDepartment: false,
        notIncludeGuest: true,
        onlyOne: true,
        onSelected: function onSelected(users) {
          _this5.manager = users[0];

          // this.addmanagerView = new MDProjectMemberSelectPageView({
          //   fileId: this.fileId,
          //   onSelected: (user) => {
          // this.manager = user
          _this5.$('.manager').val(_.unescape(_this5.manager.name));
          _this5.directorId = _this5.manager.id;
          _this5.directorUserType = _this5.manager.userType;
        }
      });
      // this.$('.user-list-contain').show();
      // this.$('.empty').hide();
      this.navigationWindowView.push(this.addmanagerView);
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDProjectTransforPageView.prototype), "viewDidRendered", this).call(this);
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MDProjectTransforPageView';
    }
  }]);
  return MDProjectTransforPageView;
}(_MDNavigationPageView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"138":138,"1415":1415,"1417":1417,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"273":273,"37":37,"56":56,"639":639,"653":653,"67":67,"72":72}],653:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1498);
require(1541);
require(1420);
require(1485);
require(1439);
require(1412);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MDUserItem = _interopRequireDefault(require(667));
var _MDPaginationView = _interopRequireDefault(require(61));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 *	select Project Member
 *	created by jichao
 *	2022-8-29
 */
var MDProjectMemberSelectPageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDProjectMemberSelectPageView, _MDNavigationPageView);
  function MDProjectMemberSelectPageView() {
    (0, _classCallCheck2["default"])(this, MDProjectMemberSelectPageView);
    return _callSuper(this, MDProjectMemberSelectPageView, arguments);
  }
  (0, _createClass2["default"])(MDProjectMemberSelectPageView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n        <input type=\"\" name=\"\" class=\"searchkey form-control mgb-10\" placeholder=\"<%=BabelStr.str(709)%>\">\n        <div class=\"users-list radio-group\"></div>\n        <div class=\"table-wrap\"></div>\n        <div class=\"flex-align end pdb-10\">\n           <button class=\"button cancel mgr-15\"><%=BabelStr.str(155)%></button>\n           <button class=\"save button done\" disabled><%=BabelStr.str(154)%></button>\n         </div>\n         ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDProjectMemberSelectPageView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        userCollection: new _MDMolaUserCollection["default"](),
        pageIndex: 0,
        pageSize: 10,
        searchKey: ''
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDProjectMemberSelectPageView.prototype), "className", this).call(this);
      return "".concat(superCls, " project-member-select-panel");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDProjectMemberSelectPageView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .uset-item-comp': this.selectItem,
        'click .save': this.save,
        'click .cancel': this.cancel,
        'input .searchkey': this._search
      });
    }
  }, {
    key: "_search",
    value: function _search() {
      var val = this.$('.searchkey').val() || '';
      val = val.trim();
      this.searchKey = val;
      this.debounceSearchProjectPersonalMembers();
    }
  }, {
    key: "render",
    value: function render(data) {
      var option = {
        type: this.type
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDProjectMemberSelectPageView.prototype), "render", this).call(this, option);
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDProjectMemberSelectPageView.prototype), "initialize", this).call(this, props);
      this.setTitle(BabelStr.str(2817));
      setTimeout(function () {
        _MDMessageView["default"].infor(BabelStr.str(6800), _this.$el);
      }, 400);
      this.debounceSearchProjectPersonalMembers = _.debounce(this.searchProjectPersonalMembers, 400);
      // this.paginationBarView = new MDPaginationView({
      //   silentInit: true,
      //   pageSize: this.pageSize,
      //   currentPage: 0,
      //   stepOffset: 3,
      //   onPageChanged: (curPageIndex) => {
      //     this.pageIndex = curPageIndex;
      //     this.searchProjectPersonalMembers();
      //   },
      //   onPageSizeChanged: (newPageSize) => {
      //     this.pageSize = newPageSize;
      //     this.pageIndex = 0;
      //     this.searchProjectPersonalMembers();
      //   }
      // });
      // this.paginationBarView.hide()
      // this.addSubView(this.paginationBarView, this.$('.table-wrap')[0]);
      this.getProjectMembers();
    }
  }, {
    key: "searchProjectPersonalMembers",
    value: function searchProjectPersonalMembers() {
      var _this2 = this;
      if (!this.searchKey) {
        this.$(".uset-item-comp").removeClass("f-hide");
        return;
      }
      var isEmpty = true;
      this.userCollection.each(function (user) {
        var name = user.get("name") || "";
        var email = user.get("email") || "";
        var phone = user.get("phone") || "";
        if (name.includes(_this2.searchKey) || email.includes(_this2.searchKey) || phone.includes(_this2.searchKey)) {
          isEmpty = false;
          _this2.$(".uset-item-comp[data-id=\"".concat(user.get("id"), "\"]")).removeClass("f-hide");
        } else {
          _this2.$(".uset-item-comp[data-id=\"".concat(user.get("id"), "\"]")).addClass("f-hide");
        }
      });
      if (isEmpty) {
        this.$('.users-list .empty').removeClass("f-hide");
      } else {
        this.$('.users-list .empty').addClass("f-hide");
      }
    }
  }, {
    key: "getProjectMembers",
    value: function getProjectMembers() {
      var _this3 = this;
      _MDSpinnerloaderView["default"].showIn(this.$('.users-list'));
      MMEnterpriseController.project.getProjectMembers(this.fileId, function (members) {
        _MDSpinnerloaderView["default"].clearFrom(_this3.$('.users-list'));
        _.each(members.groups, function (group) {
          group.name = group.groupName;
        });
        var list = members.users.concat(members.groups);
        _this3.userCollection.set(list);
        // this.$('.users-list').empty()
        // for (var i = 0; i < this.subViews.length; i++) {
        //   if(this.subViews[i] instanceof MDUserItem) {
        //     this.removeSubView(this.subViews[i]);
        //     i--;
        //   }
        // }
        if (_this3.userCollection.length < 1) {
          // if(this.searchKey) {
          //   this.$('.users-list').html(`<div class="mgtb-20 pdtb-20 f-tc empty">${BabelStr.str(6803)}</div>`)
          // } else {
          _this3.$('.users-list').html("<div class=\"mgtb-20 pdtb-20 f-tc \">".concat(BabelStr.str(6801), "</div>"));
          // }
          // this.paginationBarView.hide()
        } else {
          // this.paginationBarView.setLength(members.total, true)
          _this3.$('.users-list').html("<div class=\"mgtb-20 pdtb-20 f-tc empty f-hide\">".concat(BabelStr.str(6803), "</div>"));
          // this.paginationBarView.show()
        }
        _this3.userCollection.each(function (user) {
          var item = new _MDUserItem["default"]({
            user: user,
            roles: [],
            roleArr: [],
            needRoleAndEndTime: false,
            showDes: false,
            description: undefined,
            canRemove: false
          });
          _this3.addSubView(item, _this3.$('.users-list'));
        });
        _this3.navigationWindowView.refreshWindow();
      }, function () {
        _MDSpinnerloaderView["default"].clearFrom(_this3.$('.users-list'));
      });
    }
  }, {
    key: "selectItem",
    value: function selectItem($e) {
      this.$('.uset-item-comp').removeClass('checked');
      $($e.target).closest('.uset-item-comp').addClass('checked');
      this.$('.save').attr('disabled', false);
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.navigationWindowView.pop();
    }
  }, {
    key: "save",
    value: function save() {
      var user;
      _.each(this.subViews, function (view) {
        if (view.$el.hasClass('checked')) {
          user = view.user;
        }
      });
      this.navigationWindowView.pop();
      this.onSelected(user);
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDProjectMemberSelectPageView.prototype), "viewDidRendered", this).call(this);
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MDProjectMemberSelectPageView';
    }
  }]);
  return MDProjectMemberSelectPageView;
}(_MDNavigationPageView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1420":1420,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"1485":1485,"1498":1498,"1541":1541,"273":273,"55":55,"56":56,"61":61,"667":667,"76":76}],642:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
require(1412);
require(1415);
require(1498);
require(1426);
require(1417);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDAddProjectMemberPageView = _interopRequireDefault(require(639));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MDDropDownSelectRoleView = _interopRequireDefault(require(50));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MDHQSMProjectInfoPanelView = _interopRequireDefault(require(644));
var _MDEvents = _interopRequireDefault(require(325));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDAlertView = _interopRequireDefault(require(32));
var _MEDepartChooseView = _interopRequireDefault(require(138));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 *	new Project window
 *	created by jichao
 *	2021.2.1
 */
var MDHQSMProjectCreatePageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDHQSMProjectCreatePageView, _MDNavigationPageView);
  function MDHQSMProjectCreatePageView() {
    (0, _classCallCheck2["default"])(this, MDHQSMProjectCreatePageView);
    return _callSuper(this, MDHQSMProjectCreatePageView, arguments);
  }
  (0, _createClass2["default"])(MDHQSMProjectCreatePageView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n      <form>\n\t    <div class=\"project-info\">\n\n        <div class=\"info-item flex-align middle\">\n          <div class=\"item-title form-required\"><%=BabelStr.str(6095)%></div>\n          <div class=\"info\">\n            <input name=\"folderName\" class=\"form-control transmittal-title testFileName testFileNameEnd notempty\" testFileName notempty required placeholder=\"<%=BabelStr.str(2813)%>\"/>\n          </div>\n        </div>\n        <div class=\"info-item flex-align middle\">\n          <div class=\"item-title form-required\"><%=BabelStr.str(2814)%></div>\n          <div class=\"info manager \" name=\"manager\">\n\n            <input name=\"manager\" tabIndex=-1 type=\"text\" class=\"form-control project-manager notempty\" notempty required placeholder=\"<%=BabelStr.str(2815)%>\"/>\n          </div>\n        </div>\n        <div class=\"info-item flex-align middle for-pro-pos f-hide\">\n          <div class=\"item-title form-required\"><%=BabelStr.str(794)%></div>\n          <div class=\"dep-select-contain\"></div>\n        </div>\n        <div class=\"info-item flex-align\">\n          <div class=\"item-title\"><%=BabelStr.str(5206)%></div>\n          <div class=\"info secretary multiple requiredHQSMMember\"  name=\"secretary\">\n              <p class=\"placeholder f-none\"><%=BabelStr.str(5207)%></p>\n          </div>\n        </div>\n        <div class=\"info-item flex-align file-control-block\">\n          <div class=\"item-title\"><%=BabelStr.str(5208)%></div>\n          <div class=\"info file-control multiple requiredHQSMMember\" name='control'>\n              <p class=\"placeholder f-none\"><%=BabelStr.str(5209)%></p>\n          </div>\n          <div class=\"role-select-block\"></div>\n        </div>\n        <div class=\"info-item flex-align other-member-block\">\n          <div class=\"item-title\"><%=BabelStr.str(5210)%></div>\n          <div class=\"info other-member multiple requiredHQSMMember\">\n              <p class=\"placeholder f-none\"><%=BabelStr.str(5214)%></p>\n          </div>\n          <div class=\"role-select-block\"></div>\n        </div>\n\n        <div class=\"info-item flex-align discipline-block\">\n          <div class=\"item-title\"><%=BabelStr.str(5211)%></div>\n          <div class=\"info flex-align\">\n            <div>\n              <input type=\"text\" class=\"form-control template-title\" placeholder=\"<%=BabelStr.str(5212)%>\"/>\n            </div>\n            <div class=\"discipline-select-block\"></div>\n          </div>\n        </div>\n        <div class=\"info-item flex-align\">\n          <div class=\"item-title\"><%=BabelStr.str(3013)%></div>\n          <div class=\"info\">\n           <textarea class=\"form-control comment\" placeholder=\"<%=BabelStr.str(5213)%>\"></textarea>\n          </div>\n        </div>\n      </div>\n      </form>\n      <div class=\"recive-list-parent\">\n\n      </div>\n\n\n      <div class=\"flex-align end\">\n        <button class=\"button done create\"><%=BabelStr.str(5231)%></button>\n      </div>\n\t\t";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHQSMProjectCreatePageView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        secretaryCollection: new _MDMolaUserCollection["default"](),
        fileControlCollection: new _MDMolaUserCollection["default"](),
        otherMemberCollection: new _MDMolaUserCollection["default"](),
        memberCollection: new _MDMolaUserCollection["default"](),
        transmittalArrr: [{
          type: -1,
          name: BabelStr.str(5222)
        }, {
          type: 0,
          name: BabelStr.str(5223)
        }, {
          type: 1,
          name: BabelStr.str(5224)
        }, {
          type: 2,
          name: BabelStr.str(5225)
        }, {
          type: 3,
          name: BabelStr.str(5226)
        }, {
          type: 4,
          name: BabelStr.str(5227)
        }],
        reciveTypeArr: [{
          type: 0,
          name: BabelStr.str(5228)
        }, {
          type: 1,
          name: BabelStr.str(5229)
        }]
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHQSMProjectCreatePageView.prototype), "className", this).call(this);
      return "".concat(superCls, " hqsm-project-info-panel");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHQSMProjectCreatePageView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .secretary': this._addSecretary,
        'click .secretary .ope': this._removeSecretaryItemHandle,
        'click .file-control': this._addFileControl,
        'click .file-control .ope': this._removeFileControlItemHandle,
        'click .other-member': this._addOtherMember,
        'click .other-member .ope': this._removeOtherMemberItemHandle,
        'click .manager': this._addManager,
        // 'click .reciver-list-item .add': this._appendTransmittal,
        'click .create': this._create
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHQSMProjectCreatePageView.prototype), "initialize", this).call(this, props);
      this.setTitle(BabelStr.str(2812));
      // this.listenTo(this.secretaryCollection, 'add', this.appendSecretaryItemUser);
      // this.listenTo(this.secretaryCollection, 'remove', this.removeSecretaryItemUser);

      // this.listenTo(this.fileControlCollection, 'add', this.appendFileControlItemUser);
      // this.listenTo(this.fileControlCollection, 'remove', this.removeFileControlItemUser);

      // this.listenTo(this.otherMemberCollection, 'add', this.appendOtherMemberItemUser);
      // this.listenTo(this.otherMemberCollection, 'remove', this.removeOtherMemberItemUser)

      this.listenTo(this.memberCollection, 'add', this.appendMemberItemUser);
      this.listenTo(this.memberCollection, 'remove', this.removeMemberItemUser);
      this.getRoles();
      this.renderDiscipline();
      // this.appendReciverListItem()
      this.initReciverList();
      this.navigationWindowView && this.navigationWindowView.refreshWindow();
      this.$form = this.$('form');
      this.$form.validate({
        highlight: function highlight(element, errorClass, validClass) {
          if ($(element).closest('.multiple').length) {
            $(element).closest('.multiple').removeClass(validClass).addClass(errorClass);
          } else {
            $(element).removeClass(validClass).addClass(errorClass);
          }
        },
        unhighlight: function unhighlight(element, errorClass, validClass) {
          if ($(element).closest('.multiple').length) {
            $(element).closest('.multiple').removeClass(errorClass).addClass(validClass);
          } else {
            $(element).removeClass(errorClass).addClass(validClass);
          }
        }
      });
      if (app.pathRouter.isProjectChannel() && app.pathRouter.isInRoot()) {
        this.$(".for-pro-pos").removeClass("f-hide");
        this.renderDepSelect();
      } else {
        this.$(".for-pro-pos").addClass("f-hide");
      }
      var currentFolder = app.pathRouter.getCurrentFolder() || MMNetDiskDataController.getHomeDir();
      this.curFolderId = currentFolder.getFileId();
    }
  }, {
    key: "renderDepSelect",
    value: function renderDepSelect(departId) {
      var _this = this;
      var opts = {
        readonly: true,
        // needRoot: true,
        fixed: true,
        needAddDefault: true,
        placeholder: BabelStr.str(5010),
        needRoot: true,
        selectedDepartId: departId,
        onChange: function onChange(node) {
          _this.curFolderId = node["original"]["folderId"] || "0";
          // this.destDepID = node['original']['id'];
        },
        onReady: function onReady() {
          if (!app.currentUser.canOwnFile()) {
            _this.departView.selectRoot();
          }
        }
      };
      if (!app.currentUser.canOwnFile()) {
        opts.needAddDefault = false;
      }
      this.departView = new _MEDepartChooseView["default"](opts);
      this.addSubView(this.departView, this.$(".dep-select-contain")[0]);
    }
  }, {
    key: "initReciverList",
    value: function initReciverList() {
      this.reciverView = new _MDHQSMProjectInfoPanelView["default"]();
      this.addSubView(this.reciverView, this.$('.recive-list-parent')[0]);
      this.reciverView.appendReciverListItem();
    }
  }, {
    key: "initTransmittalList",
    value: function initTransmittalList($contain) {
      for (var i = 2; i >= 0; i--) {
        this.createTransmittalViewItem($contain);
      }
    }
  }, {
    key: "initReciverTypeSelect",
    value: function initReciverTypeSelect($contain) {
      var reciverTypeView = new _MDDropdownSelectListView["default"]({
        dataProvider: this.reciveTypeArr,
        labelField: "name",
        onChange: function onChange(obj) {
          console.warn(obj);
        }
      });
      this.addSubView(reciverTypeView, $contain[0]);
    }

    // _appendTransmittal($e) {
    //   let $contain = $($e.target).closest('.info').find('.transmittal-list')
    //   this.createTransmittalViewItem($contain)
    //   this.navigationWindowView && this.navigationWindowView.refreshWindow()
    // }
  }, {
    key: "createTransmittalViewItem",
    value: function createTransmittalViewItem($contain) {
      var transmittalView = new _MDDropdownSelectListView["default"]({
        dataProvider: this.transmittalArrr,
        labelField: "name",
        onChange: function onChange(obj) {
          // this.pickConditionChanged(obj);
          console.warn(obj);
        }
      });
      this.addSubView(transmittalView, $contain[0]);
    }
  }, {
    key: "_removeOtherMemberItemHandle",
    value: function _removeOtherMemberItemHandle($e) {
      $e.stopPropagation();
      var $item = $($e.target).closest('.user-item');
      var id = $item.data("id").toString();
      var user = this.memberCollection.findWhere({
        id: id
      });
      this.memberCollection.remove(user);
    }
  }, {
    key: "_removeSecretaryItemHandle",
    value: function _removeSecretaryItemHandle($e) {
      $e.stopPropagation();
      var $item = $($e.target).closest('.user-item');
      var id = $item.data("id").toString();
      var user = this.memberCollection.findWhere({
        id: id
      });
      this.memberCollection.remove(user);
    }
  }, {
    key: "_removeFileControlItemHandle",
    value: function _removeFileControlItemHandle($e) {
      $e.stopPropagation();
      var $item = $($e.target).closest('.user-item');
      var id = $item.data("id").toString();
      var user = this.memberCollection.findWhere({
        id: id
      });
      this.memberCollection.remove(user);
    }
  }, {
    key: "appendSecretaryItemUser",
    value: function appendSecretaryItemUser(user) {
      this.appendItem(this.$('.secretary'), user);
    }
  }, {
    key: "removeSecretaryItemUser",
    value: function removeSecretaryItemUser(user) {
      var id = user.getUserId();
      var $item = this.$(".secretary .user-item[data-id=\"".concat(id, "\"]"));
      $item.remove();
    }
  }, {
    key: "appendFileControlItemUser",
    value: function appendFileControlItemUser(user) {
      this.appendItem(this.$('.file-control'), user);
    }
  }, {
    key: "removeFileControlItemUser",
    value: function removeFileControlItemUser(user) {
      var id = user.getUserId();
      var $item = this.$(".file-control .user-item[data-id=\"".concat(id, "\"]"));
      $item.remove();
    }
  }, {
    key: "appendOtherMemberItemUser",
    value: function appendOtherMemberItemUser(user) {
      this.appendItem(this.$('.other-member'), user);
    }
  }, {
    key: "removeOtherMemberItemUser",
    value: function removeOtherMemberItemUser(user) {
      var id = user.getUserId();
      var $item = this.$(".other-member .user-item[data-id=\"".concat(id, "\"]"));
      $item.remove();
    }
  }, {
    key: "removeMemberItemUser",
    value: function removeMemberItemUser(user) {
      var userType = user.get('userType');
      if (userType == 2) {
        this.removeFileControlItemUser(user);
      } else if (userType == 1) {
        this.removeSecretaryItemUser(user);
      } else {
        this.removeOtherMemberItemUser(user);
      }
    }
  }, {
    key: "appendMemberItemUser",
    value: function appendMemberItemUser(user) {
      var userType = user.get('userType');
      if (userType == 2) {
        this.appendFileControlItemUser(user);
      } else if (userType == 1) {
        this.appendSecretaryItemUser(user);
      } else {
        this.appendOtherMemberItemUser(user);
      }
    }
  }, {
    key: "appendItem",
    value: function appendItem($parent, user) {
      var id = user.getUserId();
      var name = user.getUserName();
      var tmpl = "<div class=\"user-item\" data-id=\"".concat(id, "\">\n          <span class=\"user\">").concat(name, "</span>\n          <span class=\"ope\">\xD7</span>\n      </div>");
      $parent.append(tmpl);
    }
  }, {
    key: "_addSecretary",
    value: function _addSecretary() {
      var _this2 = this;
      this.removeLists();
      this.selectEpMemeber(1, function (users) {
        _this2.memberCollection.add(users);
      });
    }
  }, {
    key: "_addFileControl",
    value: function _addFileControl() {
      var _this3 = this;
      this.removeLists();
      this.selectEpMemeber(2, function (users) {
        _this3.memberCollection.add(users);
      });
    }
  }, {
    key: "_addOtherMember",
    value: function _addOtherMember() {
      var _this4 = this;
      this.removeLists();
      this.selectEpMemeber(0, function (users) {
        _this4.memberCollection.add(users);
      });
    }
  }, {
    key: "renderDiscipline",
    value: function renderDiscipline() {
      var _this5 = this;
      var conditionArr = [{
        value: '{-num3-}',
        name: BabelStr.str(5308)
      }, {
        value: '{-num4-}',
        name: BabelStr.str(5309)
      }, {
        value: '{-date-}',
        name: BabelStr.str(5290)
      }, {
        value: '{-num-}',
        name: BabelStr.str(5216)
      }, {
        value: '{-letter-}',
        name: BabelStr.str(5215)
      }];
      var disciplineView = new _MDDropdownSelectListView["default"]({
        dataProvider: conditionArr,
        labelField: "name",
        silentInit: false,
        onChange: function onChange(obj) {
          _this5.templateNo = obj.value;
          console.warn(obj);
        }
      });
      this.addSubView(disciplineView, this.$('.discipline-select-block')[0]);
    }
  }, {
    key: "_addManager",
    value: function _addManager() {
      var _this6 = this;
      this.removeLists();
      var view = new _MDAddProjectMemberPageView["default"]({
        addManager: true,
        onSelected: function onSelected(users) {
          if (users.length) {
            if (_this6.managerUser) {
              var user = _this6.memberCollection.findWhere({
                id: _this6.managerUser.getUserId()
              });
              if (user) {
                _this6.memberCollection.remove(user);
              }
            }
            _this6.managerUser = users[0];
            _this6.renderManager();
          }
        }
      });
      this.navigationWindowView.push(view);
    }
  }, {
    key: "removeLists",
    value: function removeLists() {
      _.each(this.subViews, function (view) {
        if (view instanceof _MDDropDownSelectRoleView["default"]) {
          view.removeList();
        }
      });
    }
  }, {
    key: "renderManager",
    value: function renderManager() {
      this.$('.project-manager').val(this.managerUser.getUserName());
    }
  }, {
    key: "selectEpMemeber",
    value: function selectEpMemeber(type, callback) {
      var _this7 = this;
      var view = new _MDAddProjectMemberPageView["default"]({
        userEpSelectComp: true,
        title: BabelStr.str(5310),
        onSelected: function onSelected(users) {
          users = _.filter(users, function (user) {
            var oldUser = _this7.memberCollection.findWhere({
              id: user.getUserId()
            });
            if (oldUser) {
              _this7.memberCollection.remove(oldUser);
            }
            user.set('userType', type);
            if (!_this7.managerUser) {
              return true;
            }
            return user.getUserId() != _this7.managerUser.getUserId();
          });
          callback(users);
          _this7.requiredHQSMMember(true);
        }
      });
      this.navigationWindowView.push(view);
    }
  }, {
    key: "renderSelect",
    value: function renderSelect() {}
  }, {
    key: "close",
    value: function close() {
      this.navigationWindowView.close();
    }
  }, {
    key: "getRoles",
    value: function getRoles() {
      var self = this;
      var _initRoles = function _initRoles(roleCollection, defaultRole) {
        var shareRoles = [];
        roleCollection.each(function (roleInfo) {
          shareRoles.push(roleInfo);
        });
        self.roles = shareRoles;
        self.roleArr = [];
        for (var i = 0; i < self.roles.length; i++) {
          var role = self.roles[i];
          var str = {
            label: role.get("description"),
            canSelected: true,
            linkRoleId: role.getRoleId(),
            systemdefault: role.get('systemdefault')
          };
          self.roleArr.push(str);
        }
        var index = -1;
        _.each(self.roleArr, function (roleInfo, i) {
          if (roleInfo["linkRoleId"] == defaultRole) {
            index = i;
          }
        });
        index = index < 0 ? 0 : index;
        self.fileControlRoleId = self.roleArr[index].linkRoleId;
        self.memberRoleId = self.roleArr[index].linkRoleId;
        var fileControlPermission = new _MDDropDownSelectRoleView["default"]({
          index: index,
          bd: self.roleArr,
          roles: self.roles,
          invite: true,
          // minW: '162px',
          onChange: function onChange(item) {
            self.fileControlRoleId = item.linkRoleId;
          }
        });
        self.addSubView(fileControlPermission, self.$('.file-control-block .role-select-block')[0]);
        var otherMemberPermission = new _MDDropDownSelectRoleView["default"]({
          index: index,
          bd: self.roleArr,
          roles: self.roles,
          invite: true,
          // minW: '162px',
          onChange: function onChange(item) {
            self.memberRoleId = item.linkRoleId;
          }
        });
        self.addSubView(otherMemberPermission, self.$('.other-member-block .role-select-block')[0]);
      };
      MMNetDiskDataController.getAllRoles(function (roleCollection, defaultRole) {
        _initRoles(roleCollection, defaultRole);
        //    if(app.pathRouter && app.pathRouter.isInRoot() && app.pathRouter.inFile()) {
        //  self.userCollection.add(self.manager)
        // }
      }, function () {
        _MDSnackbarView["default"].show(BabelStr.str(7270));
      });
    }
  }, {
    key: "_create",
    value: function _create() {
      var _this8 = this;
      if (this.creating) {
        return;
      }
      if (!this.managerUser) {
        _MDSnackbarView["default"].show(BabelStr.str(2835));
        console.log('没有管理员');
        return;
      }
      var reciverValidate = this.reciverView.validateRecivers();
      if (!reciverValidate) {
        _MDAlertView["default"].showStandardPrompt({
          message: BabelStr.str(20030)
        });
        return;
      }
      this.creating = true;
      this.$('.save').attr("disabled", true);

      // let memberValidate = this.requiredHQSMMember()
      if (!this.$("form").validate().form()
      // || !memberValidate
      ) {
        this.navigationWindowView.refreshWindow();
        this.$('.save').attr("disabled", false);
        this.creating = false;
        return;
      }
      //managerId, parentId, transmittalTitle, participantInfo, versionTemplate, comment, time

      var transmittalTitle = this.$('.transmittal-title').val();
      transmittalTitle = _.escape(transmittalTitle.trim());
      var comment = this.$('.comment').val();
      comment = _.escape(comment.trim());
      var templateTitle = this.$('.template-title').val();
      templateTitle = templateTitle.trim();
      var versionTemplate = this.templateNo;
      if (templateTitle.length) {
        versionTemplate = _.escape(templateTitle) + '{}' + versionTemplate;
      }
      var userInfos = this.memberCollection.map(function (user) {
        return _this8.formatUser(user);
      });
      var recivers = this.reciverView.getRecivers();
      var hasError = false;
      for (var i = 0; i < recivers.length; i++) {
        var receiver = recivers[i];
        if (!receiver) {
          hasError = true;
          break;
        }
      }
      if (hasError) {
        _MDAlertView["default"].showStandardPrompt({
          message: BabelStr.str(20030)
        });
        this.$('.save').attr("disabled", false);
        this.creating = false;
        return;
      }
      var data = {
        managerId: this.managerUser.getUserId(),
        parentId: this.curFolderId,
        transmittalTitle: transmittalTitle,
        participantInfo: {
          userInfos: userInfos
        },
        versionTemplate: versionTemplate,
        comment: comment,
        transmittalReceivers: recivers
      };
      console.error(data);
      MMEnterpriseController.createTransmittalProject(data, function (res) {
        // if(data.managerId == app.currentUser.getUserId()) {
        app.pathRouter.openFileByIdWithOutChannel(res.fileInfo.fileId);
        // }
        _MDSnackbarView["default"].show(BabelStr.str(308));
        _this8.close();
        // Dispatcher.trigger(MDEvents.addFileInCurrentFolder, {parentId: app.currentFolder.getFileId()})
      }, function (code, err) {
        _this8.$('.save').attr("disabled", false);
        _this8.creating = false;
        if (code == 2) {
          _MDSnackbarView["default"].show(BabelStr.str(2835));
        } else if (code == 12) {
          _MDSnackbarView["default"].show(BabelStr.str(2837));
        } else if (code == 20001) {
          _MDSnackbarView["default"].show(BabelStr.str(7506));
        } else {
          _MDSnackbarView["default"].show(err);
        }
      });
    }
  }, {
    key: "requiredHQSMMember",
    value: function requiredHQSMMember(onlyRemove) {
      var list = this.$('.requiredHQSMMember');
      var validate = true;
      _.each(list, function (item) {
        var items = $(item).find('.user-item');
        var $item = $(item).closest('.info-item');
        if (items.length < 1 && !onlyRemove) {
          if (!$(item).hasClass('_validate-error')) {
            $(item).addClass('_validate-error');
            $("<p class=\"_validate-error\">".concat(BabelStr.str(7503), "</p>")).insertAfter($item);
            validate = false;
          }
        } else if (items.length > 0) {
          $(item).removeClass('_validate-error');
          $(item).closest('.info-item').next('._validate-error').remove();
        }
      });
      return validate;
    }
  }, {
    key: "formatUser",
    value: function formatUser(user) {
      var userType = user.get('userType');
      var roleId = -1;
      if (userType == 2) {
        roleId = this.fileControlRoleId;
      } else if (userType == 0) {
        roleId = this.memberRoleId;
      }
      return {
        userId: user.getUserId(),
        roleId: roleId,
        userType: userType
      };
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MDHQSMProjectCreatePageView';
    }
  }]);
  return MDHQSMProjectCreatePageView;
}(_MDNavigationPageView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"138":138,"1412":1412,"1415":1415,"1417":1417,"1426":1426,"1437":1437,"1454":1454,"1463":1463,"1475":1475,"1478":1478,"1498":1498,"18":18,"273":273,"32":32,"325":325,"50":50,"56":56,"639":639,"644":644,"67":67,"72":72}],644:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1432);
require(1413);
require(1463);
require(1412);
var _toConsumableArray2 = _interopRequireDefault(require(1194));
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMViewBase2 = _interopRequireDefault(require(22));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDHQSMReciverItemView = _interopRequireDefault(require(645));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDHQSMProjectInfoPanelView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MDHQSMProjectInfoPanelView, _MMViewBase);
  function MDHQSMProjectInfoPanelView() {
    (0, _classCallCheck2["default"])(this, MDHQSMProjectInfoPanelView);
    return _callSuper(this, MDHQSMProjectInfoPanelView, arguments);
  }
  (0, _createClass2["default"])(MDHQSMProjectInfoPanelView, [{
    key: "tmpl",
    value: function tmpl() {
      return "<div class=\"reciver-list-block\">\n\n    </div>\n    <div class=\"flex-align add-reciver-item add-item\">\n      <div class=\"ep-ic ep-ic-add add \"></div>\n      <span><%=BabelStr.str(5230)%></span>\n    </div>\n    ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHQSMProjectInfoPanelView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        fileInfor: undefined,
        params: {
          tranmittalProjectId: '',
          addTransmittalReceiverInfos: [],
          removeReceiverIds: [],
          updateTransmittalReceiverInfos: [],
          leftoverReceiverIds: [],
          orginReciverIds: []
        }
        // addTransmittalReceiverInfos ：{ name, ATTN, transmittalNoTemplate, emails}
        // updateTransmittalReceiverInfos: {transmittalReceiverId, name, ATTN, transmittalNoTemplate, tag, addEmails, removeEmails}      
        // removeReceiverIds：{transmittalReceiverIds}
      });
    }
  }, {
    key: "resetParams",
    value: function resetParams() {
      this.params.addTransmittalReceiverInfos.splice(0, this.params.addTransmittalReceiverInfos.length);
      this.params.removeReceiverIds.splice(0, this.params.removeReceiverIds.length);
      this.params.updateTransmittalReceiverInfos.splice(0, this.params.updateTransmittalReceiverInfos.length);
      this.params.leftoverReceiverIds.splice(0, this.params.leftoverReceiverIds.length);
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHQSMProjectInfoPanelView.prototype), "className", this).call(this);
      return "".concat(superCls, " hqsm-reciver-list-panel");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHQSMProjectInfoPanelView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .add-reciver-item': this._addReciverItem
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHQSMProjectInfoPanelView.prototype), "initialize", this).call(this, props);
      // this.appendReciverListItem()
      if (this.fileInfor) {
        MMEnterpriseController.getTransmittalReceiverInProjectByFolderId(this.fileInfor.getFileId(), function (transmittalReceivers) {
          _.each(transmittalReceivers, function (item) {
            _this.params.orginReciverIds.push(item.id);
            _this.appendReciverListItem(true, item);
          });
        });
      }
    }
  }, {
    key: "_addReciverItem",
    value: function _addReciverItem() {
      this.appendReciverListItem();
    }
  }, {
    key: "appendReciverListItem",
    value: function appendReciverListItem(init, item) {
      var view = new _MDHQSMReciverItemView["default"]({
        transmittalReceiver: item,
        init: init,
        params: this.params
      });
      this.addSubView(view, this.$('.reciver-list-block')[0]);
      this.navigationWindowView && this.navigationWindowView.refreshWindow();
    }
  }, {
    key: "getRecivers",
    value: function getRecivers() {
      var out = [];
      var subviews = this.getSubViews();
      _.each(subviews, function (view) {
        var info = view.getReciverInfo();
        out.push(info);
      });
      return out;
    }
  }, {
    key: "validateRecivers",
    value: function validateRecivers() {
      var subViews = this.getSubViews();
      var result = _.every(subViews, function (view) {
        return view.validateItem();
      });
      return result;
    }
  }, {
    key: "getReciversForUpdate",
    value: function getReciversForUpdate() {
      var _ref;
      this.params.addTransmittalReceiverInfos.splice(0, this.params.addTransmittalReceiverInfos.length);
      var subviews = this.getSubViews();
      var success = true;
      _.each(subviews, function (view) {
        var s = view.getReciverInfoForUpdate();
        if (!s) {
          success = false;
        }
      });
      if (!success) {
        _MDAlertView["default"].showStandardPrompt({
          message: BabelStr.str(20030)
        });
        return null;
      }
      var removeReceiverIds = (_ref = _).without.apply(_ref, [this.params.orginReciverIds].concat((0, _toConsumableArray2["default"])(this.params.leftoverReceiverIds)));
      var out = {
        transmittalProjectId: this.fileInfor.get("transmittalProjectId"),
        addTransmittalReceiverInfos: this.params.addTransmittalReceiverInfos,
        removeReceiverIds: removeReceiverIds,
        updateTransmittalReceiverInfos: this.params.updateTransmittalReceiverInfos
      };
      return out;
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MDHQSMProjectInfoPageView';
    }
  }]);
  return MDHQSMProjectInfoPanelView;
}(_MMViewBase2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1194":1194,"1412":1412,"1413":1413,"1432":1432,"1454":1454,"1463":1463,"1475":1475,"22":22,"32":32,"645":645}],645:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1477);
require(1492);
require(1498);
require(1439);
require(1424);
require(1416);
require(1423);
require(1463);
require(1480);
require(1487);
require(1538);
require(1417);
var _toConsumableArray2 = _interopRequireDefault(require(1194));
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMViewBase2 = _interopRequireDefault(require(22));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _regexp = _interopRequireDefault(require(106));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDHQSMReciverItemView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MDHQSMReciverItemView, _MMViewBase);
  function MDHQSMReciverItemView() {
    (0, _classCallCheck2["default"])(this, MDHQSMReciverItemView);
    return _callSuper(this, MDHQSMReciverItemView, arguments);
  }
  (0, _createClass2["default"])(MDHQSMReciverItemView, [{
    key: "el",
    value: function el() {
      return "<div class=\"reciver-list-item\"></div>";
    }
  }, {
    key: "tmpl",
    value: function tmpl() {
      return "\n      <div class=\"info-item flex-align\">\n        <div class=\"item-title form-required\">".concat(BabelStr.str(5217), "</div>\n        <div class=\"info flex-align middle fullfill\">\n          <input class=\"form-control form-required recive-name name\" value=\"<%=name%>\" placeholder=\"").concat(BabelStr.str(5218), "\"/>\n          <input class=\"form-control recive-mail emailstr\" value=\"<%=emailstr%>\" placeholder=\"").concat(BabelStr.str(5219), "\"/>\n          <span class=\"no-shrink \">ATTN:</span>\n          <input class=\"form-control attn\" value=\"<%=ATTN%>\" placeholder=\"").concat(BabelStr.str(5220), "\"/>\n        </div>\n      </div>\n      <div class=\"info-item flex-align transmittal-block\">\n        <div class=\"item-title\">").concat(BabelStr.str(5221), "</div>\n        <div class=\"info flex-align\">\n          <div class=\"transmittal-list flex-align with-wrap\">\n\n          </div>\n          <div class=\"ep-ic ep-ic-add add\"></div>\n        </div>\n      </div>\n      <div class=\"info-item flex-align between middle\">\n          <div class=\"flex-align\">\n            <div class=\"item-title\">").concat(BabelStr.str(5291), "</div>\n            <div class=\"info reciver-type-select-block\">\n            </div>\n          </div>\n          <button class=\"text-button del-item danger-c\">").concat(BabelStr.str(32), "</button>\n      </div>");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHQSMReciverItemView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        transmittalArrr: [{
          value: undefined,
          name: BabelStr.str(5222)
        }, {
          value: '{-num3-}',
          name: BabelStr.str(5308)
        }, {
          value: '{-num4-}',
          name: BabelStr.str(5309)
        }, {
          value: '{-date-}',
          name: BabelStr.str(5290)
        }, {
          value: '{-num-}',
          name: BabelStr.str(5216)
        }, {
          value: '{-letter-}',
          name: BabelStr.str(5215)
        }, {
          value: '',
          name: BabelStr.str(5226),
          contenteditable: true,
          onChecked: function onChecked(item, callback) {
            var reg = /{|}/g;
            item.value = item.value.replace(reg, '');
            item.value = item.value.trim();
            item.value = _.escape(item.value);
            callback(item);
          }
        }],
        reciveTypeArr: [{
          type: 0,
          name: BabelStr.str(5228)
        }, {
          type: 1,
          name: BabelStr.str(5229)
        }]
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHQSMReciverItemView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .del-item': this._delItem,
        'click  .add': this._appendTransmittal,
        'input .recive-name': this._nameInputed,
        'input .emailstr': this._emailInputed
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      if (!props.transmittalReceiver) {
        props.transmittalReceiver = {
          ATTN: "",
          id: "",
          name: "",
          status: 0,
          tag: "承包方",
          transmittalNoTemplate: "",
          transmittalProjectId: "",
          emails: []
        };
      }
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHQSMReciverItemView.prototype), "initialize", this).call(this, props);
      this.props = props;
      this.initReciverTypeSelect(this.$('.reciver-type-select-block'));
      if (this.init) {
        this.transmittalReceiverOrigin = {
          ATTN: this.transmittalReceiver.ATTN,
          emails: this.transmittalReceiver.emails,
          name: this.transmittalReceiver.name,
          tag: this.transmittalReceiver.tag,
          transmittalNoTemplate: this.transmittalReceiver.transmittalNoTemplate
        };
        this.initTransmittalListWithData();
      } else {
        this.initTransmittalList(this.$('.transmittal-list'));
      }
    }
  }, {
    key: "render",
    value: function render(data) {
      data = _.extend(this.transmittalReceiver, {
        emailstr: this.transmittalReceiver.emails.join(';')
      });
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDHQSMReciverItemView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "_appendTransmittal",
    value: function _appendTransmittal($e) {
      var $contain = this.$('.transmittal-list');
      var transmittalArrr = _.clone(this.transmittalArrr);
      transmittalArrr[6] = {
        value: '',
        name: BabelStr.str(5226),
        contenteditable: true,
        onChecked: function onChecked(item, callback) {
          var reg = /{|}/g;
          item.value = item.value.replace(reg, '');
          item.value = item.value.trim();
          item.value = _.escape(item.value);
          callback(item);
        }
      };
      this.createTransmittalViewItem($contain, 0, transmittalArrr);
      this.navigationWindowView && this.navigationWindowView.refreshWindow();
    }
  }, {
    key: "_nameInputed",
    value: function _nameInputed($e) {
      this.$(".recive-name").removeClass("validate-error");
    }
  }, {
    key: "_emailInputed",
    value: function _emailInputed($e) {
      this.$(".emailstr").removeClass("validate-error");
    }
  }, {
    key: "_delItem",
    value: function _delItem() {
      this.removeFromSuperView();
    }
  }, {
    key: "initTransmittalList",
    value: function initTransmittalList($contain) {
      for (var i = 2; i >= 0; i--) {
        this._appendTransmittal();
      }
    }
  }, {
    key: "initTransmittalListWithData",
    value: function initTransmittalListWithData() {
      var _this = this;
      // let reg1 = /{-\w*-}|[\w\u4e00-\u9fa5]+/g
      var reg2 = /{-.*?-}/;
      var rules = this.transmittalReceiver.transmittalNoTemplate.split('{}');
      var index = 0;
      _.each(rules, function (item) {
        var transmittalArrr = _this.transmittalArrr;
        if (item) {
          if (reg2.test(item)) {
            index = _.findIndex(_this.transmittalArrr, {
              value: item
            });
          } else {
            index = 6;
            transmittalArrr = _.clone(transmittalArrr);
            transmittalArrr[6] = {
              value: item,
              name: BabelStr.str(5226),
              contenteditable: true,
              onChecked: function onChecked(item, callback) {
                var reg = /{|}/g;
                item.value = item.value.replace(reg, '');
                item.value = item.value.trim();
                item.value = _.escape(item.value);
                callback(item);
              }
            };
          }
          _this.createTransmittalViewItem(_this.$('.transmittal-list'), index, transmittalArrr);
        }
      });
    }
  }, {
    key: "initReciverTypeSelect",
    value: function initReciverTypeSelect($contain) {
      var _this2 = this;
      var index = 0;
      for (var i = 0; i < this.reciveTypeArr.length; i++) {
        if (this.reciveTypeArr[i].name == this.transmittalReceiver.tag) {
          index = i;
        }
      }
      var reciverTypeView = new _MDDropdownSelectListView["default"]({
        dataProvider: this.reciveTypeArr,
        labelField: "name",
        silentInit: false,
        isFixed: true,
        selectedIndex: index,
        onChange: function onChange(obj) {
          _this2.type = obj.name;
        }
      });
      this.addSubView(reciverTypeView, $contain[0]);
    }
  }, {
    key: "createTransmittalViewItem",
    value: function createTransmittalViewItem($contain, index, transmittalArrr) {
      var _this3 = this;
      // transmittalArrr = JSON.parse(JSON.stringify(transmittalArrr))
      var transmittalView = new _MDDropdownSelectListView["default"]({
        selectedIndex: index,
        dataProvider: transmittalArrr,
        labelField: "name",
        isFixed: true,
        repeatChange: true,
        onChange: function onChange(obj) {
          _this3.templateNo = obj.value;
          console.warn(obj);
        }
      });
      this.addSubView(transmittalView, $contain[0]);
    }
  }, {
    key: "getReciverInfo",
    value: function getReciverInfo() {
      var _this4 = this;
      // name, ATTN, transmittalNoTemplate, tag, emails
      var name = this.$('.name').val();
      name = name.trim();
      var attn = this.$('.attn').val();
      attn = attn.trim();
      var subviews = this.getSubViews();
      var tmpls = new Set();
      _.each(subviews, function (view) {
        if (_this4.$('.transmittal-list').find(view.$el).length) {
          var selected = view.getSelectedItem();
          if (selected.value) {
            tmpls.add(selected.value);
          }
        }
      });
      tmpls = (0, _toConsumableArray2["default"])(tmpls);
      var transmittalNoTemplate = tmpls.join('{}').trim();
      var emailstr = this.$('.emailstr').val();
      emailstr = emailstr.trim();
      var emailSet = new Set();
      emailstr = emailstr.split(",").join(";");
      emailstr = emailstr.split("，").join(";");
      emailstr = emailstr.split("；").join(";");
      var emails = emailstr.split(';');
      _.each(emails, function (mail) {
        if (_regexp["default"].isEmail(mail)) {
          emailSet.add(mail);
        }
      });
      if (!transmittalNoTemplate || transmittalNoTemplate.length == 0) {
        transmittalNoTemplate = "{-date-}";
      }
      var data = {
        name: name,
        ATTN: attn,
        transmittalNoTemplate: transmittalNoTemplate,
        tag: this.type,
        emails: (0, _toConsumableArray2["default"])(emailSet)
      };
      if (!data.name || data.name.length == 0 || data.emails.length == 0) {
        if (!data.name || data.name.length == 0) {
          this.$(".recive-name").addClass("validate-error");
        }
        if (data.emails.length == 0) {
          this.$(".recive-mail").addClass("validate-error");
        }
        return null;
      }
      return data;
    }
  }, {
    key: "validateItem",
    value: function validateItem() {
      var data = this.getReciverInfo();
      return data != null;
    }
  }, {
    key: "getReciverInfoForUpdate",
    value: function getReciverInfoForUpdate() {
      var data = this.getReciverInfo();
      if (!data) {
        return false;
      }
      if (!data.transmittalNoTemplate || data.transmittalNoTemplate.length == 0) {
        data.transmittalNoTemplate = '{-date-}';
      }
      var out = {
        name: _.escape(data.name),
        ATTN: _.escape(data.ATTN),
        transmittalNoTemplate: data.transmittalNoTemplate,
        tag: data.tag
      };
      if (!this.init) {
        out.emails = data.emails;
        this.params.addTransmittalReceiverInfos.push(out);
        return true;
      } else if (_.isEqual(data, this.transmittalReceiverOrigin)) {
        //数据没有发生变化
        this.params.leftoverReceiverIds.push(this.transmittalReceiver.id);
        return true;
      }
      this.params.leftoverReceiverIds.push(this.transmittalReceiver.id);
      out.transmittalReceiverId = this.transmittalReceiver.id;
      if (!_.isEqual(data.emails, this.transmittalReceiverOrigin.emails)) {
        var _ref, _ref2;
        //数据改变
        var addEmails = (_ref = _).without.apply(_ref, [data.emails].concat((0, _toConsumableArray2["default"])(this.transmittalReceiverOrigin.emails)));
        var removeEmails = (_ref2 = _).without.apply(_ref2, [this.transmittalReceiverOrigin.emails].concat((0, _toConsumableArray2["default"])(data.emails)));
        out.addEmails = addEmails;
        out.removeEmails = removeEmails;
      }
      this.params.updateTransmittalReceiverInfos.push(out);
      return true;
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MDHQSMReciverItemView';
    }
  }]);
  return MDHQSMReciverItemView;
}(_MMViewBase2["default"]);

},{"106":106,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1194":1194,"1412":1412,"1416":1416,"1417":1417,"1423":1423,"1424":1424,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"1477":1477,"1480":1480,"1487":1487,"1492":1492,"1498":1498,"1538":1538,"22":22,"67":67}],650:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1436);
require(1546);
require(1439);
require(1437);
require(1426);
require(1412);
require(1415);
require(1541);
require(1421);
require(1498);
require(1478);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDAddProjectMemberPageView = _interopRequireDefault(require(639));
var _MDUploadTypeSettingsPageView = _interopRequireDefault(require(665));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _FILE_ROLE_ID = _interopRequireDefault(require(236));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MDUserItem = _interopRequireDefault(require(667));
var _MDMolaUser = _interopRequireDefault(require(272));
var _MEDepartChooseView = _interopRequireDefault(require(138));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDProjectCreateWinView = _interopRequireDefault(require(652));
var _MDOneGroupPopupView = _interopRequireDefault(require(753));
var _popupPos = _interopRequireDefault(require(65));
var _MDEvents = _interopRequireDefault(require(325));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 *	new Project window
 *	created by jichao
 *	2018.11.22
 */
var MDProjectCreateInfoPageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDProjectCreateInfoPageView, _MDNavigationPageView);
  function MDProjectCreateInfoPageView() {
    (0, _classCallCheck2["default"])(this, MDProjectCreateInfoPageView);
    return _callSuper(this, MDProjectCreateInfoPageView, arguments);
  }
  (0, _createClass2["default"])(MDProjectCreateInfoPageView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n\t\t\t<div class=\"help-block mgb-15\">\n\t\t\t\t<%=BabelStr.str(3469)%>\n\t\t\t</div>\n\t\t\t<form>\n\t\t\t\t\t<div class=\"flex-align middle mgb-10 name-block\">\n\t\t\t\t\t\t<label class=\"no-shrink left-label\"><%=BabelStr.str(158)%></label>\n\t\t\t\t\t\t<div class=\"fullfill\"><input type=\"text\" required class=\"form-control testFileNameEnd testFileName col-7 name testFileName notempty\" testFileName placeholder=\"<%=BabelStr.str(2813)%>\"/></div>\n\t\t\t\t\t</div>\n\n\t\t\t\t<%if(type == 0 && !noSelectManager) {%>\n\t\t\t\t\t<div class=\"flex-align middle mgb-10\">\n\t\t\t\t\t\t<label class=\"no-shrink left-label\"><%=BabelStr.str(2814)%></label>\n\t\t\t\t\t\t<div class=\"fullfill\"><input type=\"text\" class=\"form-control manager\" placeholder=\"<%=BabelStr.str(2815)%>\"/></div>\n\n\t\t\t\t\t</div>\n\t\t\t\t<%}%>\n\n\t\t\t\t<div class=\"row mgb-10\">\n\t\t\t\t\t<div class=\"flex-align middle col-6\">\n\t\t\t\t\t\t<span class=\"no-shrink left-label\"><%=BabelStr.str(616)%></span>\n\t\t\t\t\t\t<div  class=\"datepicker\">\n\t\t\t\t      <input type=\"text\" class=\"start-time\">\n\t\t\t\t      <i class = \"ep-ic ep-ic-date\"></i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"flex-align col-6 middle\">\n\t\t\t\t\t\t<span class=\"no-shrink left-label f-tr pdr-20\"><%=BabelStr.str(617)%></span>\n\t\t\t\t\t\t<div  class=\"datepicker\">\n\t\t\t\t      <input type=\"text\" class=\"end-time\">\n\t\t\t\t      <i class = \"ep-ic ep-ic-date\"></i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n        <div class=\" flex-align middle mgb-10 help-block between\">\n          <div class=\"endTime-tip red\"><%=BabelStr.str(3735)%></div>\n          <%if(type == 1) {%>\n            <div class=\"f-pointer clear-end-date f-none text-button done\"><%=BabelStr.str(6911)%></div>\n          <%}%>\n        </div>\n\n\t\t\t\t<%if(type == 0) {%>\n\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t<%if(noSelectManager){%>\n\t\t\t\t\t\t\t<div class=\"flex-align middle mgb-10 col-6 uset-item-comp\">\n\t\t\t\t\t\t\t\t<label class=\"no-shrink left-label  proj-position\"><%=BabelStr.str(2814)%></label>\n\t\t\t\t\t\t\t\t<span class=\"manager-name name text-hide\"></span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<%}%>\n\t\t\t\t\t</div>\n\t\t\t\t<%}%>\n\n\t\t\t\t<%if(type == 1) {%>\n\t\t\t\t\t<div class=\"row manage-row\">\n\t\t\t\t\t\t<div class=\"flex-align middle mgb-10 col-6\">\n\t\t\t\t\t\t\t<label class=\"no-shrink left-label\"><%=BabelStr.str(6037)%></label>\n\t\t\t\t\t\t\t<span class=\"tar-name\"></span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"flex-align middle mgb-10 col-6 uset-item-comp\">\n\t\t\t\t\t\t\t<label class=\"no-shrink left-label f-tr pdr-20\"><%=BabelStr.str(2814)%></label>\n\t\t\t\t\t\t\t<span class=\"icon pro-icon manage-group-ic f-hide\"></span>\n              <span class=\"manager-name name text-hide\"></span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class=\"row flex-align mgb-10\">\n\t\t\t\t\t<div class=\"col-6\"></div>\n\t\t\t\t\t\t<div class=\"col-6 f-tr\"><div class=\" text-button done show-link\"><%=BabelStr.str(6080)%></div></div>\n\t\t\t\t\t</div>\n          <div class=\"row link-content mgb-15 f-hide\">\n            <p class=\"mgb-10 col-12 help-block\"><%=BabelStr.str(6093)%></p>\n            <div class=\"flex-align col-12\">\n              <input type=\"text\" readonly class=\"form-control team-link\" value=\"1234\" />\n              <div class=\"button done no-shrink mgl-10 copy-link\"><%=BabelStr.str(6081)%></div>\n              <div class=\"qrcode-btn icon no-shrink mgl-10\" >\n                <div class=\"qrcode-pop f-tc\" title=\"<%=BabelStr.str(416)%>\">\n                <div class=\"qrcode-canvas\"></div>\n                <div class=\"intro\">\n                  <p><%=BabelStr.str(5417)%></p>\n                  <p class=\"text-button copy-qrcode\"><%=BabelStr.str(5416)%></p>\n                </div>\n                </div>\n              </div>\n            </div>\n          </div>\n\t\t\t\t<%}%>\n\t\t\t</form>\n\t\t\t<%if(type == 1) {%>\n\t\t\t<div class=\"block-title add-title\"><%=BabelStr.str(2816)%></div>\n\n\t\t\t<div class=\"flex-align manager-block middle users-list\">\n        <div class=\"member-title mgr-20\"><%=BabelStr.str(6097)%></div>\n        <div class=\"manager-show\"></div>\n        <div class='fullfill f-tr no-shrink'><button class=\"text-button done transfer-project\"><%=BabelStr.str(6038)%></button></div>\n      </div>\n\t\t\t<div class=\"flex-align between mgt-10 add-title\">\n\t\t\t\t<span><%=BabelStr.str(4738)%></span>\n\t\t\t\t<button class=\"text-button done add-project-assistant\"><%=BabelStr.str(4742)%></button>\n\t\t\t</div>\n\t\t\t<div class=\"help-block\"><%=BabelStr.str(4775)%></div>\n\t\t\t<div class=\"assistant-user-list-contain users-list\"></div>\n\n\t\t\t<div class=\"flex-align between mgt-10 add-title\">\n\t\t\t\t<span><%=BabelStr.str(6758)%></span>\n\t\t\t\t<button class=\"text-button done add-project-member\"><%=BabelStr.str(7268)%></button>\n\t\t\t</div>\n\t\t\t<div class=\"user-list-contain users-list\"></div>\n\t\t\t<div class=\"empty flex-align center middle gray f-hide\">\n\t\t\t\t<span><%=BabelStr.str(2819)%></span>\n\t\t\t</div>\n\n\t\t\t<%}%>\n      <div class=\"btns-block flex-align between pdb-10\">\n        <button class=\"text-button upload-setting f-hidden\"><%=BabelStr.str(12100)%></button>\n        <div class=\"flex-align fullfill end\">\n  \t\t\t\t<button class=\"button cancel\"><%=BabelStr.str(156)%></button>\n  \t\t\t\t<button class=\"button done save\"><%=BabelStr.str(154)%></button>\n  \t\t\t</div>\n      </div>\n\n\n\t\t";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDProjectCreateInfoPageView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        userCollection: new _MDMolaUserCollection["default"](),
        manager: new _MDMolaUser["default"](),
        assistant: new _MDMolaUser["default"](),
        deleteIds: [],
        staticProjectName: ""
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDProjectCreateInfoPageView.prototype), "className", this).call(this);
      return "".concat(superCls, " project-info-panel");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDProjectCreateInfoPageView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .add-project-member": this._addMemberHandle,
        "click .manager": this._addManagerHandle,
        "click .transfer-project": this._transferProject,
        "click .edit-manager": this._editManagerHandle,
        "click .add-project-assistant": this._addAssistantHandle,
        "click .save": this._saveHandle,
        "click .cancel": this.close,
        "click .show-link": this._showLink,
        // 'click .copy-link': this._copyLink,
        "mouseenter .qrcode-btn": this._showQRCodePopup,
        "mouseleave .qrcode-btn": this._hideQRCodePopup,
        "click .qrcode-canvas canvas": this._copyQrcode,
        "click .copy-qrcode": this._copyQrcode,
        "click .clear-end-date": this._clearEndDate,
        "click .pro-icon": this.showGroupPopup,
        "click .upload-setting": this._uploadSetting
      });
    }
  }, {
    key: "showGroupPopup",
    value: function showGroupPopup($e) {
      var $btn = $($e.target);
      if ($btn.hasClass("with-popup")) {
        var view = $btn.data("popupView");
        view.close();
        return;
      }
      var $item = $btn.closest(".uset-item-comp");
      var id = $item.data("id");
      _MDOneGroupPopupView["default"].show({
        groupName: $item.find(".name").text(),
        triggerView: $btn,
        direction: _popupPos["default"].TOP_LEFT,
        groupId: id
        // $container: this.getNavigationView().$el
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      if (props.type == 1) {
        props.showNavigationBar = false;
      }
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDProjectCreateInfoPageView.prototype), "initialize", this).call(this, props);
      this.setTitle(BabelStr.str(2812));
      this.$contain = this.$(".user-list-contain");
      this.$manageContain = this.$(".manager-show");
      this.$assistantContain = this.$(".assistant-user-list-contain");
      this.listenTo(this.userCollection, "add", this.appendItemUser);
      this.listenTo(this.userCollection, "remove", this.removeItemUser);
      if (this.type == 0) {
        this.$(".save").text(BabelStr.str(3139));
      }
      if (!this.isProjectAssist) {
        this.$(".add-project-assistant").removeClass("f-hide");
        this.$(".transfer-project").removeClass("f-hide");
      } else {
        this.$(".add-project-assistant").addClass("f-hide");
        this.$(".transfer-project").addClass("f-hide");
      }
      this.initDate();
      if (this.type == 0) {
        var currentFolder = app.pathRouter.getCurrentFolder() || MMNetDiskDataController.getHomeDir();
        // if (!app.pathRouter.isInFileChannel()) {
        // 	currentFolder = MMNetDiskDataController.getHomeDir();
        // }

        this.$(".proj-position-div").hide();
        this.departId = currentFolder.getFileId();
        if (this.departId == 0) {
          this.$(".proj-position-tip").text(BabelStr.str(6037));
          // this.$('.dep-select-contain').html(BabelStr.str(5010));
          this.renderDepSelect();
        } else {
          this.$(".dep-select-contain").html(currentFolder.getFileName());
        }
        // if(app.pathRouter && app.pathRouter.isInRoot() && (app.pathRouter.inFile() || app.pathRouter.inDepartment())	|| app.currentFolder.getOwnerId() == app.currentUser.getUserId()) {
        this.manager = new _MDMolaUser["default"](app.currentUser.toJSON());
        this.manager.set("isAdmin", true);
        this.$(".manager-name").html(app.currentUser.getUserName());
        this.$(".manager-name").closest(".uset-item-comp").data("id", app.currentUser.getUserId());

        // }
        if (this.originFile) {
          this.$(".name-block").remove();
        }
      }
      this.getRoles();
      if (this.type == 1) {
        this.$(".upload-setting").removeClass('f-hidden');
        MMEnterpriseController.project.getProjectByFileId(this.fileId, function (projects) {
          var project = projects[0];
          _this.projectId = project.id;
          _this.staticProjectName = project.name;
          _this.startTime = _this.staticStartTime = project.startTime;
          _this.endTime = _this.staticEndTime = project.endTime;
          _this.$(".name").val(project.name);
          // let curFolder = app.pathRouter.getCurrentFolder();
          _this.$(".tar-name").text(project.belongDepName || BabelStr.str(5010));
          console.log(project);
          if (project.startTime) {
            _this.$(".start-time").datepicker("setDate", new Date(project.startTime * 1000));
          }
          if (project.endTime) {
            _this.$(".end-time").datepicker("setDate", new Date(project.endTime * 1000));
            _this.renderEndTimeTip();
          }
          if (project.endTime) {
            _this.$(".clear-end-date").show();
          } else {
            _this.$(".clear-end-date").hide();
          }
          var user = new _MDMolaUser["default"]({
            name: project.directorName,
            id: project.directorId,
            isAdmin: true,
            userType: project.directorUserType
          });
          _this.manager = user;
          _this.$(".manager-name").html(project.directorName);
          _this.$(".manager-name").closest(".uset-item-comp").data("id", project.directorId);
          if (project.directorUserType == 2) {
            _this.$(".manage-group-ic").removeClass("f-hide");
          }
          MMEnterpriseController.project.getProjectMembers(_this.fileId, function (members) {
            var groups = _.map(members.groups, function (item) {
              item.name = item.groupName;
              return item;
            });
            var AllMembers = members.users.concat(members.departments).concat(groups);
            _this.staticMembers = new _MDMolaUserCollection["default"](_.clone(AllMembers));
            _this.stateDeps = new _MDMolaUserCollection["default"](_.clone(AllMembers));
            _this.userCollection.add(AllMembers);
            _this.userCollection.add(_this.manager);
          }, function () {});
        }, function () {
          console.log("fail");
        });
        this._copyLink();
      }
      if (this.type == 0 && this.originFile) {
        this.staticMembers = new _MDMolaUserCollection["default"]();
        if (this.originFile.isSharing() && this.originFile.get("newShareAll") == "1") {
          //文件开启链接分享
          var isHttps;
          if (location.protocol == "https:") {
            isHttps = true;
          } else {
            isHttps = false;
          }
          MMNetDiskDataController.getShareUrl(this.originFile.getFileId(), isHttps, function (shareURL, linkRoleId, password) {
            // self.linkRoleId = linkRoleId;

            MMNetDiskDataController.getLinkShareUsers(_this.originFile.getFileId(), function (userCollection) {
              userCollection.each(function (user) {
                user.set("roleId", linkRoleId);
                user.set("type", 0);
              });
              _this.staticMembers.add(_.clone(userCollection.models));
              _this.userCollection.add(userCollection.models);
            });
          }, function (errorCode) {});
        }
        MMNetDiskDataController.getInvitationList(this.originFile.getFileId(), function (userCollection) {
          userCollection.each(function (user) {
            user.set("id", user.get("participantId"));
            user.set("userName", user.get("participantName"));
            // user.set('email', user.get('participantId'))
            user.set("userType", user.get("participantType"));
            user.set("type", 0);
            user.set("endTime", user.get("endtime"));
          });
          _this.staticMembers.add(_.clone(userCollection.models));
          _this.userCollection.add(userCollection.models);
        });
      }
      if (this.showCreateProjectSuccess) {
        MDMessageView.success(BabelStr.str(7269), $(".project-win")[0]);
      }
      this.$(".pro-icon").attr("data-tooltip", BabelStr.str(2578));
      this.$(".pro-icon").addClass("f-pointer");
    }
  }, {
    key: "refreshUsers",
    value: function refreshUsers() {
      var _this2 = this;
      MMEnterpriseController.project.getProjectMembers(this.fileId, function (members) {
        var groups = _.map(members.groups, function (item) {
          item.name = item.groupName;
          return item;
        });
        var AllMembers = members.users.concat(members.departments).concat(groups);
        _this2.staticMembers = new _MDMolaUserCollection["default"](_.clone(AllMembers));
        _this2.stateDeps = new _MDMolaUserCollection["default"](_.clone(AllMembers));
        _this2.userCollection.reset();
        _this2.$(".user-list-contain").empty();
        _this2.$(".assistant-user-list-contain").empty();
        _this2.$(".manager-show").empty();
        _this2.userCollection.add(AllMembers);
        _this2.userCollection.add(_this2.manager);
      }, function () {});
    }
  }, {
    key: "_clearEndDate",
    value: function _clearEndDate() {
      this.clearEndTime = true;
      var $to = this.$(".end-time");
      $to.datepicker("setDate", "");
      this.renderEndTimeTip();
    }
  }, {
    key: "renderEndTimeTip",
    value: function renderEndTimeTip() {
      var endDate = new Date(this.endTime * 1000);
      if (endDate > new Date()) {
        this.$(".endTime-tip").html(BabelStr.str(3735));
      } else {
        this.$(".endTime-tip").html(BabelStr.str(3735));
      }
    }
  }, {
    key: "_copyQrcode",
    value: function _copyQrcode(e) {
      var self = this;
      var target = this.$(".qrcode-canvas canvas")[0];
      MMCommonFun.clipboardCopyCanvas(target, function () {
        console.log("success");
        MDMessageView.success(BabelStr.str(5415), self.$el);
      }, function () {
        MDMessageView.error(BabelStr.str(5418), self.$el);
        console.log("fail");
      });
    }
  }, {
    key: "_showQRCodePopup",
    value: function _showQRCodePopup($e) {
      var self = this;
      var $qpopup = this.$(".qrcode-pop");
      if ($qpopup.hasClass("opened")) {
        return;
      }
      $qpopup.show();
      $qpopup[0].offsetWidth;
      $qpopup.addClass("opened");
      return false;
    }
  }, {
    key: "_hideQRCodePopup",
    value: function _hideQRCodePopup($e) {
      var self = this;
      var $qpopup = self.$(".qrcode-pop");
      var $mqpopup = self.$(".qrcode-btn");
      var popDOM = $mqpopup.get(0);
      if ($qpopup.css("display") == "none") {
        return;
      }
      $qpopup.removeClass("opened");
      $qpopup.hide();
    }
  }, {
    key: "_showLink",
    value: function _showLink() {
      var _this3 = this;
      var paramStr = "proj=".concat(this.projectId);
      MMEnterpriseController.getTeamInvUrl(paramStr, function (url) {
        _this3.linkUrl = url;
        _this3.$(".team-link").val(url);
        _this3.$(".link-content").removeClass("f-hide");
        _this3.navigationWindowView.refreshWindow();
        _this3.$(".qrcode-canvas").empty().qrcode({
          width: 160,
          height: 160,
          text: _this3.linkUrl
        });
      }, function () {
        MDMessageView.error(BabelStr.str(309));
      });
    }
  }, {
    key: "_copyLink",
    value: function _copyLink() {
      var self = this;
      var $btn = this.$(".copy-link");
      this.clipboard = new Clipboard($btn[0], {
        text: function text() {
          return self.$(".team-link").val();
        }
      });
      this.clipboard.on("success", function (e) {
        e.clearSelection();
        var tip = BabelStr.str(6082);
        MDMessageView.success(tip, self.$el);
      });
      this.clipboard.on("error", function (e) {
        var tip = "";
        if (app.os.mac) {
          tip = BabelStr.str(7149);
        } else {
          tip = BabelStr.str(7150);
        }
        self.$(".team-link").select();
        MDMessageView.error(tip, self.$el);
      });
    }
  }, {
    key: "render",
    value: function render(data) {
      // let noSelectManager = app.pathRouter && app.pathRouter.isInRoot() && (app.pathRouter.inFile() || app.pathRouter.inDepartment())
      // 	|| app.currentFolder.getOwnerId() == app.currentUser.getUserId()

      data = {
        type: this.type,
        noSelectManager: true
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDProjectCreateInfoPageView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "close",
    value: function close() {
      this.navigationWindowView.close();
    }
  }, {
    key: "renderDepSelect",
    value: function renderDepSelect(departId) {
      var _this4 = this;
      var opts = {
        readonly: true,
        // needRoot: true,
        fixed: true,
        needAddDefault: true,
        placeholder: BabelStr.str(5010),
        needRoot: true,
        selectedDepartId: departId,
        onChange: function onChange(node) {
          _this4.departId = node["original"]["folderId"] || "0";
          // this.destDepID = node['original']['id'];
        },
        onReady: function onReady() {
          if (!app.currentUser.canOwnFile()) {
            _this4.departView.selectRoot();
          }
        }
      };
      if (!app.currentUser.canOwnFile()) {
        opts.needAddDefault = false;
      }
      if (this.type != 0) {
        this.departView = new _MEDepartChooseView["default"](opts);
        this.addSubView(this.departView, this.$(".dep-select-contain")[0]);
      }

      // this.departView = new MEDepartChooseView({
      //     needAddDefault: false,
      //     readonly: true,
      //     // placeholder:  MDLocalString.getLocalString(3097),    /*'选择部门',*/
      //     // required: true,
      //     needRoot: true,
      //     fixed: true,
      //     selectedDepartId: departId || undefined,
      //     onChange: (node) => {
      //       this.departId = node['id'];

      //     }
      //   });
    }
  }, {
    key: "_addMemberHandle",
    value: function _addMemberHandle() {
      var _this5 = this;
      this.addMemberView = new _MDAddProjectMemberPageView["default"]({
        onSelected: function onSelected(users) {
          users = _.map(users, function (user) {
            user.id = user.id || user.phone || user.email;
            return user;
          });
          users = _.filter(users, function (user) {
            var oldUser = _this5.userCollection.findWhere({
              id: user.id
            });
            if (oldUser && !oldUser.get("isAdmin")) {
              if (_this5.isProjectAssist && oldUser.get("type") == 1) {
                return false;
              }
              _this5.userCollection.remove(oldUser.cid);
            }
            user.type = 0;
            if (!_this5.manager) {
              return true;
            }
            return user.id != _this5.manager.getUserId();
          });
          _this5.userCollection.add(users);
          setTimeout(function () {
            _this5.updateProject(true);
          }, 400);
        }
      });
      this.$(".user-list-contain").show();
      // this.$('.empty').hide();
      this.navigationWindowView.push(this.addMemberView);
    }
  }, {
    key: "_uploadSetting",
    value: function _uploadSetting() {
      var _this6 = this;
      var success = function success() {
        _this6.uploadTypeSettingsView = new _MDUploadTypeSettingsPageView["default"]({
          fileInfo: _this6.originFile
        });
        _this6.navigationWindowView.push(_this6.uploadTypeSettingsView);
      };
      if (!this.originFile) {
        MMNetDiskDataController.getFileInfoByFileId(this.fileId, function (file) {
          _this6.originFile = file;
          success();
        });
      } else {
        success();
      }
    }
  }, {
    key: "_addAssistantHandle",
    value: function _addAssistantHandle() {
      var _this7 = this;
      this.addMemberView = new _MDAddProjectMemberPageView["default"]({
        // userEpSelectComp: true,
        canSelDepartment: false,
        notIncludeGuest: true,
        title: BabelStr.str(4742),
        onSelected: function onSelected(users) {
          users = _.filter(users, function (user) {
            var oldUser = _this7.userCollection.findWhere({
              id: user.id
            });
            if (oldUser && !oldUser.get("isAdmin")) {
              _this7.userCollection.remove(oldUser.cid);
            }
            user.type = 1;
            var filtered = false;
            if (!_this7.manager) {
              filtered = true;
            }
            filtered = filtered || user.id != _this7.manager.getUserId();
            if (!filtered) {
              _MDSnackbarView["default"].show(BabelStr.str(20156));
            }
            return filtered;
          });
          _this7.userCollection.add(users);
          setTimeout(function () {
            _this7.updateProject(true);
          }, 400);
        }
      });
      // this.$('.assistant-user-list-contain').show();
      // this.$('.empty').hide();
      this.navigationWindowView.push(this.addMemberView);
    }
  }, {
    key: "_transferProject",
    value: function _transferProject() {
      var win = new _MDProjectCreateWinView["default"]({
        type: 2,
        fileId: this.fileId
      });
      win.show();
      this.navigationWindowView.close();
    }
  }, {
    key: "_addManagerHandle",
    value: function _addManagerHandle() {
      var _this8 = this;
      this.addmanagerView = new _MDAddProjectMemberPageView["default"]({
        addManager: true,
        onSelected: function onSelected(users) {
          _this8.manager = users[0];
          var oldManager = _this8.userCollection.findWhere({
            isAdmin: true
          });
          _this8.userCollection.remove(oldManager);
          _this8.manager.set("isAdmin", true);
          _this8.userCollection.add(_this8.manager);
          _this8.$(".manager").val(_.unescape(_this8.manager.getUserName()));
        }
      });
      this.$(".user-list-contain").show();
      this.$(".empty").addClass("f-hide");
      this.navigationWindowView.push(this.addmanagerView);
    }
  }, {
    key: "_editManagerHandle",
    value: function _editManagerHandle() {
      var _this9 = this;
      this.addmanagerView = new _MDAddProjectMemberPageView["default"]({
        addManager: true,
        onSelected: function onSelected(users) {
          _this9.manager = users[0];
          var oldManager = _this9.userCollection.findWhere({
            isAdmin: true
          });
          _this9.userCollection.remove(oldManager);
          _this9.manager.set("isAdmin", true);
          _this9.userCollection.add(_this9.manager);
          // this.$('.manager').val(_.unescape(this.manager.getUserName()))
        }
      });
      // this.$('.user-list-contain').show();
      // this.$('.empty').hide();
      this.navigationWindowView.push(this.addmanagerView);
    }
  }, {
    key: "initDate",
    value: function initDate() {
      var $from = this.$(".start-time");
      var $to = this.$(".end-time");
      var self = this;
      var date;
      $from.datepicker().on("change", function () {
        $to.datepicker("option", "minDate", this.value);
        date = $from.datepicker("getDate");
        if (date) {
          self.startTime = date.getTime() / 1000;
          if (self.endTime && self.startTime > self.endTime) {
            self.endTime = (date.getTime() + 7 * 24 * 60 * 60 * 1000 - 60 * 60 * 1000) / 1000;
          }
        } else {
          self.startTime = undefined;
        }
        self.renderEndTimeTip();
      });
      $to.datepicker().on("change", function () {
        $from.datepicker("option", "maxDate", this.value);
        date = $to.datepicker("getDate");
        if (date) {
          self.endTime = (date.getTime() + 23 * 60 * 60 * 1000) / 1000;
          self.clearEndTime = false;
        } else {
          self.endTime = undefined;
        }
        self.renderEndTimeTip();
      });
    }
  }, {
    key: "appendItemUser",
    value: function appendItemUser(user) {
      var _this10 = this;
      if (user.getRoleId() == -1 && user.get("type") == 0) {
        user.setRoleId(11);
      }
      if (_.isNull(user.get("type"))) {
        user.set("type", 0);
      }
      var item = new _MDUserItem["default"]({
        user: user,
        roles: this.roles,
        roleArr: this.roleArr,
        needRoleAndEndTime: user.get("type") == 0 && !user.get("isAdmin"),
        showDes: user.get("type") == 1 || user.get("isAdmin"),
        description: user.get("type") == 1 ? "" : undefined,
        canRemove: !this.isProjectAssist || user.get("type") == 0,
        removeCallback: function removeCallback(id) {
          _this10.removeUser(id);
          // this.removeSubView(item)
        }
      });
      if (user.get("isAdmin")) {
        this.addSubViewAt(item, 0, this.$manageContain);
      } else if (user.get("type") == 1) {
        this.addSubViewAt(item, 0, this.$assistantContain);
      } else {
        this.addSubView(item, this.$contain);
      }
      this.$(".empty").addClass("f-hide");
      this.$(".user-list-contain").show();
      this.$(".pro-icon").attr("data-tooltip", BabelStr.str(2578));
      this.navigationWindowView && this.navigationWindowView.refreshWindow();
    }
  }, {
    key: "removeUser",
    value: function removeUser(userId) {
      var user = this.userCollection.findWhere({
        id: userId
      });
      this.userCollection.remove(user);
      this.deleteIds = _.union(this.deleteIds, [userId]);
    }
  }, {
    key: "removeItemUser",
    value: function removeItemUser(user) {
      var id = user.getUserId();
      // this.$(`.user-list-contain >.item[data-id=${id}]`).remove();
      _.each(this.subViews, function (view) {
        if (view instanceof _MDUserItem["default"]) {
          if (view.getUserId() == id) {
            view.remove();
          }
        }
      });
      this.navigationWindowView.refreshWindow();
    }
  }, {
    key: "_saveHandle",
    value: function _saveHandle() {
      if (this.type == 0) {
        if (this.originFile) {
          this.changeFolder2Project();
        } else {
          this.createProject();
        }
      } else {
        this.updateProject();
      }
    }
  }, {
    key: "updateProject",
    value: function updateProject(keepWin) {
      var _this11 = this;
      var validate = this.$("form").validate();
      if (!validate.form()) {
        this.navigationWindowView && this.navigationWindowView.refreshWindow();
        return;
      }
      this.$(".save").attr("disabled", true);
      console.log(this.userCollection.toJSON());
      console.warn(this.staticMembers);
      if (this.updating) {
        return;
      }
      this.updating = true;
      var addUserInfos = [];
      var removeUserIds = [];
      var updateUserInfos = [];
      var oldIds = this.staticMembers.pluck("id");
      var ids = [];
      this.userCollection.each(function (item) {
        if (!item.get("isAdmin") && !item.get("accountType")) {
          //排除手机号和邮箱
          ids.push(item.get("id"));
        }
      });
      removeUserIds = _.difference(oldIds, ids); //删除的用户
      var removeUserInfos = _.map(removeUserIds, function (id) {
        var u = _this11.staticMembers.findWhere({
          id: id
        });
        return {
          userId: u.getUserId(),
          type: u.get("type"),
          participantType: u.get("userType")
        };
      });
      var newIDs = _.difference(ids, oldIds); //新增的用户
      var otherIds = _.difference(ids, newIDs);
      var u;
      var participantInfo = {
        phoneInfos: [],
        emailInfos: [],
        userInfos: [],
        groupInfos: [],
        depInfos: []
      };
      this.userCollection.each(function (user) {
        if (user.get("accountType") == 1) {
          // email
          participantInfo.emailInfos.push({
            email: user.getEmail(),
            roleId: user.getRoleId(),
            endTime: user.get("endTime")
          });
        } else if (user.get("accountType") == 2) {
          //phone
          participantInfo.phoneInfos.push({
            phone: user.getPhone(),
            roleId: user.getRoleId(),
            endTime: user.get("endTime")
          });
        } else if (!user.get("accountType")) {
          var id = user.getUserId();
          if (_.indexOf(newIDs, id) > -1) {
            if (user.get("userType") == 1) {
              //dep
              participantInfo.depInfos.push({
                depId: user.getId(),
                roleId: user.getRoleId(),
                endTime: user.get("endTime")
              });
            } else if (user.get("userType") == 2) {
              //group
              participantInfo.groupInfos.push({
                groupId: user.getId(),
                roleId: user.getRoleId(),
                endTime: user.get("endTime"),
                type: user.get("type")
              });
            } else {
              user = _this11.formatUser(user);
              participantInfo.userInfos.push(user);
            }
          } else if (_.indexOf(otherIds, id) > -1) {
            user = _this11.formatUser(user);
            var oldUser = _this11.staticMembers.findWhere({
              id: id
            });
            oldUser = _this11.formatUser(oldUser);
            if (!_.isEqual(oldUser, user)) {
              updateUserInfos.push(user);
            }
          }
        }
      });
      var startTime = this.staticStartTime == this.startTime ? undefined : this.startTime;
      var endTime = this.staticEndTime == this.endTime ? undefined : this.endTime;
      if (this.clearEndTime) {
        endTime = -1;
      }
      var name = this.$(".name").val().toString().trim();
      name = name == this.staticProjectName ? undefined : name;
      var params = {
        fileId: this.fileId,
        name: name,
        startTime: startTime,
        endTime: endTime,
        participantInfo: participantInfo,
        removeUserInfos: removeUserInfos,
        updateUserInfos: updateUserInfos
      };
      console.log(params);
      MMEnterpriseController.project.updateProject(params, function () {
        console.log("success");
        if (!keepWin) {
          _this11.navigationWindowView.close();
        } else {
          // this.staticMembers.reset(_.clone(this.userCollection.models))
          _this11.refreshUsers();
        }
        _this11.$(".save").attr("disabled", false);
        _this11.updating = false;
        var endDate;
        if (endTime == -1) {
          endDate = undefined;
        } else {
          endDate = new Date(endTime * 1000);
        }
        _this11.originFile && _this11.originFile.set("dueTime", endDate);
        if (name && _this11.originFile) {
          _this11.originFile.setFileName(name);
          Dispatcher.trigger(_MDEvents["default"].FolderRenamed, _this11.originFile.getFileId(), name);
        }
      }, function (msg, code) {
        console.log("fail");
        if (code == 20001) {
          _MDSnackbarView["default"].show(BabelStr.str(7506));
        } else {
          _MDSnackbarView["default"].show(msg);
        }
        _this11.$(".save").attr("disabled", false);
        _this11.updating = false;
      });
    }
  }, {
    key: "formatUser",
    value: function formatUser(user) {
      return {
        userId: user.getUserId(),
        roleId: user.getRoleId(),
        endTime: user.get("endTime"),
        type: user.get("type"),
        userType: user.get("userType")
      };
    }
  }, {
    key: "getRoles",
    value: function getRoles() {
      var self = this;
      var _initRoles = function _initRoles(roleCollection, defaultRole) {
        var shareRoles = [];
        roleCollection.each(function (roleInfo) {
          shareRoles.push(roleInfo);
        });
        self.roles = shareRoles;
        self.roleArr = [];
        for (var i = 0; i < self.roles.length; i++) {
          var role = self.roles[i];
          var str = {
            label: role.get("description"),
            canSelected: true,
            linkRoleId: role.getRoleId(),
            systemdefault: role.get("systemdefault")
          };
          self.roleArr.push(str);
        }
        if (self.type == 1 && self.users) {
          self.userCollection.add(self.users);
        }
        // this.userPermission = new MDDropDownSelectRoleView({
        //   index: index,
        //   bd: this.roleArr,
        //   roles: this.roles,
        //   invite: true,
        //   minW: '162px',
        //   onChange: (item)=>{
        //   	this._changeRole(item)
        //   },
        //   className: 'with-no-border'
        // });
        // this.addSubView(this.userPermission, this.$('.role-select-block')[0]);
      };
      MMNetDiskDataController.getAllRoles(function (roleCollection, defaultRole) {
        _initRoles(roleCollection, defaultRole);
        //    if(app.pathRouter && app.pathRouter.isInRoot() && app.pathRouter.inFile()) {
        // 	self.userCollection.add(self.manager)
        // }
      }, function () {
        _MDSnackbarView["default"].show(BabelStr.str(7270));
      });
    }
  }, {
    key: "createProject",
    value: function createProject() {
      var _this12 = this;
      // if (this.nextStepCallback) {
      // 	this.nextStepCallback(fileInfo)
      // }
      // return

      this.$(".save").attr("disabled", true);
      if (this.creating) {
        return;
      }
      this.creating = true;
      var name = this.$(".name").val().toString().trim();
      var participantInfo = {
        phoneInfos: [],
        emailInfos: [],
        userInfos: [],
        groupInfos: [],
        depInfos: []
      };
      // this.userCollection.each(user=>{
      // if(user.get('accountType') == 1) { // email
      //     participantInfo.emailInfos.push({
      //       email: user.getEmail(),
      //       roleId: user.getRoleId(),
      //       endTime: user.get("endTime")
      //     })
      //   } else if(user.get('accountType') == 2) { //phone
      //     participantInfo.phoneInfos.push({
      //       phone: user.getPhone(),
      //       roleId: user.getRoleId(),
      //       endTime: user.get("endTime")
      //     })
      //   } else if(user.get('userType') == 1) { //dep
      //     participantInfo.depInfos.push({
      //       depId: user.getId(),
      //       roleId: user.getRoleId(),
      //       endTime: user.get("endTime")
      //     })
      //   } else if(user.get('userType') == 2) { //group
      //     participantInfo.groupInfos.push({
      //       groupId: user.getId(),
      //       roleId: user.getRoleId(),
      //       endTime: user.get("endTime")
      //     })
      //   } else if(!user.get('accountType')) {
      //     let id = user.getUserId();
      //     user = this.formatUser(user)
      //     // if(_.indexOf(newIDs, id) > -1) {
      //       participantInfo.userInfos.push(user)
      //     // } else if(_.indexOf(otherIds, id) > -1) {
      //     //   let oldUser = this.staticMembers.findWhere({id: id});
      //     //   oldUser = this.formatUser(oldUser)
      //     //   if(!_.isEqual(oldUser, user)) {
      //     //       updateUserInfos.push(user)
      //     //   }
      //     // }
      //   }
      // })
      var options = {
        directorId: this.manager.getUserId(),
        name: name,
        startTime: this.startTime,
        endTime: this.endTime,
        parentId: this.departId,
        participantInfo: participantInfo
      };
      if (!this.$("form").validate().form()) {
        this.navigationWindowView.refreshWindow();
        this.creating = false;
        this.$(".save").attr("disabled", false);
        return;
      }
      _czc && _czc.push(["_trackEvent", "创建", "创建项目", "", "", ""]);
      console.log(options);
      // return;
      MMEnterpriseController.project.createProject(options, function (fileInfo) {
        _MDSnackbarView["default"].show(BabelStr.str(308));
        app.pathRouter.openFileByIdWithOutChannel(fileInfo.fileId);
        // Dispatcher.trigger(MDEvents.addFileInCurrentFolder, {
        //   parentId: this.departId,
        // });
        // this.navigationWindowView.close();
        // this.$('.save').attr("disabled", false);
        // this.creating = false;
        // console.log('------------> creating! false')
        if (_this12.nextStepCallback) {
          _this12.nextStepCallback(fileInfo);
        }
      }, function (err, code) {
        if (code == 2) {
          _MDSnackbarView["default"].show(BabelStr.str(2835));
        } else if (code == 12) {
          _MDSnackbarView["default"].show(BabelStr.str(2837));
        } else if (code == 20001) {
          _MDSnackbarView["default"].show(BabelStr.str(7506));
        } else {
          _MDSnackbarView["default"].show(err);
        }
        _this12.$(".save").attr("disabled", false);
        _this12.creating = false;
      });
    }
  }, {
    key: "changeFolder2Project",
    value: function changeFolder2Project() {
      var _this13 = this;
      // if (this.nextStepCallback) {
      //  this.nextStepCallback(fileInfo)
      // }
      // return

      this.$(".save").attr("disabled", true);
      if (this.creating) {
        return;
      }
      this.creating = true;
      var participantInfo = {
        phoneInfos: [],
        emailInfos: [],
        userInfos: [],
        groupInfos: [],
        depInfos: []
      };
      var options = {
        directorId: this.manager.getUserId(),
        startTime: this.startTime,
        endTime: this.endTime,
        folderId: this.originFile.getFileId(),
        participantInfo: participantInfo
      };
      if (!this.$("form").validate().form()) {
        this.navigationWindowView.refreshWindow();
        this.creating = false;
        this.$(".save").attr("disabled", false);
        return;
      }
      _czc && _czc.push(["_trackEvent", "创建", "转为项目", "", "", ""]);
      console.log(options);
      // return;
      MMEnterpriseController.project.changeFolder2Project(options, function (fileInfo) {
        _MDSnackbarView["default"].show(BabelStr.str(308));
        Dispatcher.trigger(_MDEvents["default"].addFileInCurrentFolder, {
          parentId: _this13.departId
        });
        if (_this13.nextStepCallback) {
          _this13.nextStepCallback(fileInfo, _this13.userCollection.models);
        }
      }, function (err, code) {
        if (code == 2) {
          _MDSnackbarView["default"].show(BabelStr.str(2835));
        } else if (code == 12) {
          _MDSnackbarView["default"].show(BabelStr.str(2837));
        } else if (code == 20001) {
          _MDSnackbarView["default"].show(BabelStr.str(7506));
        } else {
          _MDSnackbarView["default"].show(err);
        }
        _this13.$(".save").attr("disabled", false);
        _this13.creating = false;
      });
    }
  }, {
    key: "viewWillRendered",
    value: function viewWillRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDProjectCreateInfoPageView.prototype), "viewWillRendered", this).call(this);
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDProjectCreateInfoPageView.prototype), "viewDidRendered", this).call(this);
      this.navigationWindowView && this.navigationWindowView.refreshWindow();
    }
  }]);
  return MDProjectCreateInfoPageView;
}(_MDNavigationPageView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"138":138,"1412":1412,"1415":1415,"1417":1417,"1421":1421,"1426":1426,"1436":1436,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"1478":1478,"1498":1498,"1541":1541,"1546":1546,"236":236,"272":272,"273":273,"325":325,"56":56,"639":639,"65":65,"652":652,"665":665,"667":667,"67":67,"72":72,"753":753}],667:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1503);
require(1500);
require(1421);
require(1437);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMViewBase2 = _interopRequireDefault(require(22));
var _MDMolaUser = _interopRequireDefault(require(272));
var _MDDropDownSelectRoleView = _interopRequireDefault(require(50));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDUserItem = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MDUserItem, _MMViewBase);
  function MDUserItem() {
    (0, _classCallCheck2["default"])(this, MDUserItem);
    return _callSuper(this, MDUserItem, arguments);
  }
  (0, _createClass2["default"])(MDUserItem, [{
    key: "el",
    value: function el() {
      return "<li class=\"uset-item-comp radio-box flex-align middle\"></li>";
    }
  }, {
    key: "tmpl",
    value: function tmpl() {
      return "\n\n\t    \t<div class=\"list-item img no-shrink\">\n         <%if(userType == 1){%>\n            <div class=\"dep-icon\"></div>\n          <%} else if(userType == 2){%>\n            <div class=\"icon pro-icon\"></div>\n          <%} else {%>\n           <img data-src=\"<%=avatarUrl%>\" alt=\"\" src=\"<%=avatarUrl%>\" style=\"display: inline;\">\n          <%}%>\n\t    \t</div>\n\t    \t<div class=\"flex-align middle text-hide\">\n\t    \t\t<%if(guest){ %>\n\t    \t\t\t<span class=\"guest\"><%=BabelStr.str(7039)%></span>\n\t    \t\t<%}%>\n\t    \t\t<span class=\"list-item name text-hide\"><%=userName%></span>\n\t    \t</div>\n\n\t\t\t\t<%if(showDes){ %>\n\t\t\t\t\t<span class=\"mgl-10 red\"><%=description%></span>\n\t\t\t\t\t<%if(!isAdmin) {%>\n\t\t\t\t\t\t<span class=\"list-item email col-auto text-hide\">(<%=email%>)</span>\n\t\t\t\t\t<%}%>\n\t\t\t\t<%} else {%>\n\t\t\t\t\t<span class=\"list-item email col-auto text-hide\">(<%=email%>)</span>\n\t\t\t\t\t<%if(needRoleAndEndTime){%>\n\t\t\t\t\t<%if(!needReview || reviewResult == 1) {%>\n\n\t\t\t\t\t<div class=\"flex-align\">\n\t\t\t\t\t\t<div class=\"role-select-block mgr-10\"></div>\n\t\t\t      <div class=\"u-deadline end-time flex-align middle\">\n\t\t\t        <span><%=BabelStr.str(176)%></span>\n\t\t\t        <div class=\"datepicker-slot\">\n\t\t\t\t\t\t\t\t<input class=\"endtime-datepicker blue\" data-tooltip=\"<%=BabelStr.str(2694)%>\" readonly></input>\n\t\t\t          <span class=\"endtime-slot blue\"><%=BabelStr.str(177)%></span>\n\t\t   \t\t\t\t\t<span class=\"remove-time icon\" data-tooltip=\"<%=BabelStr.str(2695)%>\"></span>\n\t\t\t        </div>\n\n\t\t\t      </div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<%}%>\n\n\n\t\t\t\t\t<%}%>\n\t    \t<%}%>\n\t    \t<%if(needReview && reviewResult != 1) {%>\n\t    \t\t<div class=\"pdlr-20 mglr-20\"><%=(reviewResult == 0 ? BabelStr.str(5462) : BabelStr.str(5463))%></div>\n\t    \t<%}%>\n\t    \t<%if(canRemove && !isAdmin) {%>\n\t    \t\t<span class=\"list-item icon remove no-shrink\"></span>\n\t    \t<%}%>\n\n\t\t";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUserItem.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        user: new _MDMolaUser["default"](),
        roles: [],
        roleArr: [],
        canRemove: true,
        removeCallback: _.noop,
        notForce: false,
        onlyUser: false,
        needRoleAndEndTime: true,
        description: BabelStr.str(3478)
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUserItem.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .remove-time": this._removeEndTimeHandle,
        "click .remove": this._removeHandle
      });
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        avatarUrl: this.user.getAvatarImageURL(40, this.notForce),
        userName: this.user.getUserName() || this.user.get("userName"),
        email: this.user.getEmail(),
        canRemove: this.canRemove,
        endtime: this.user.get("endTime"),
        isAdmin: this.user.get("isAdmin"),
        userType: this.onlyUser ? 0 : this.user.get("userType"),
        needRoleAndEndTime: this.needRoleAndEndTime,
        description: this.description,
        needReview: this.user.get("needReview"),
        reviewResult: this.user.get("reviewResult"),
        showDes: this.user.get("isAdmin") || this.showDes,
        guest: this.user.get("userType") == 0 && this.user.get("registered") == 0
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUserItem.prototype), "render", this).call(this, data);
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.description = !_.isUndefined(props.description) ? props.description : BabelStr.str(3478);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUserItem.prototype), "initialize", this).call(this, props);
      var self = this;
      this.$el.attr("data-id", this.getUserId());
      if (this.user.get("isAdmin") || !this.needRoleAndEndTime) {
        return;
      }
      var $datepicker = this.$(".endtime-datepicker");
      $datepicker.datepicker().on("change", function () {
        var exDate = $datepicker.datepicker("getDate");
        exDate.setHours(23, 59, 59, 0);
        self.user.set("endTime", exDate.getTime() / 1000);
        self.renderTime();
      });
      var roleIds = [];
      for (var i = 0; i < this.roleArr.length; i++) {
        roleIds.push(this.roleArr[i].linkRoleId);
      }
      var index = _.indexOf(roleIds, this.user.get("roleId"));
      if (this.$(".role-select-block").length) {
        this.userPermission = new _MDDropDownSelectRoleView["default"]({
          index: index,
          bd: this.roleArr,
          roles: this.roles,
          invite: true,
          minW: "162px",
          onChange: function onChange(item) {
            _this._changeRole(item);
          },
          className: "with-no-border"
        });
        this.addSubView(this.userPermission, this.$(".role-select-block")[0]);
      }
      this.renderTime();
    }
  }, {
    key: "_removeEndTimeHandle",
    value: function _removeEndTimeHandle() {
      this.user.set("endTime", null);
      this.renderTime();
    }
  }, {
    key: "getUserId",
    value: function getUserId() {
      return this.user.getUserId();
    }
  }, {
    key: "renderTime",
    value: function renderTime() {
      if (!this.$(".endtime-slot").length) {
        return;
      }
      var time = this.user.get("endTime");
      if (time) {
        var exDate = time * 1000;
        var str = new Date(exDate);
        str = str.format("yyyy-MM-dd");
        this.$(".endtime-slot").html(str);
        this.$(".remove-time").show();
      } else {
        this.$(".endtime-slot").html(BabelStr.str(177));
        this.$(".remove-time").hide();
      }
    }
  }, {
    key: "_changeRole",
    value: function _changeRole(item) {
      this.user.setRoleId(item.linkRoleId);
    }
  }, {
    key: "_removeHandle",
    value: function _removeHandle() {
      var id = this.user.getUserId();
      this.removeCallback(id);
    }
  }]);
  return MDUserItem;
}(_MMViewBase2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1421":1421,"1437":1437,"1454":1454,"1463":1463,"1475":1475,"1500":1500,"1503":1503,"22":22,"272":272,"50":50}],665:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1424);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDUploadTypeSettingsView = _interopRequireDefault(require(666));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDUploadTypeSettingsPageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDUploadTypeSettingsPageView, _MDNavigationPageView);
  function MDUploadTypeSettingsPageView() {
    (0, _classCallCheck2["default"])(this, MDUploadTypeSettingsPageView);
    return _callSuper(this, MDUploadTypeSettingsPageView, arguments);
  }
  (0, _createClass2["default"])(MDUploadTypeSettingsPageView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n      <div class=\"setting\"></div>\n\n\t\t\t<div class=\"flex-align end mgt-15 btns-block\">\n\t\t\t\t<button class=\"button cancel\"><%=BabelStr.str(3081)%></button>\n\t\t\t\t<button class=\"button done save\"><%=BabelStr.str(154)%></button>\n\t\t\t</div>\n\t\t";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUploadTypeSettingsPageView.prototype), "className", this).call(this);
      return "".concat(superCls, " upload-type-setting-page");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUploadTypeSettingsPageView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .save': this._saveHandle,
        'click .cancel': this._cancelHandle
      });
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUploadTypeSettingsPageView.prototype), "initProps", this).call(this);
      return _.extend(superP, {});
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      props.title = BabelStr.str(12100);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUploadTypeSettingsPageView.prototype), "initialize", this).call(this, props);
      this.settingView = new _MDUploadTypeSettingsView["default"]({
        originBlacklist: this.originBlacklist,
        originWhitelist: this.originWhitelist,
        fileInfo: this.fileInfo,
        msgContain: this.$el,
        immediatelyMerge: false,
        readOnly: this.readOnly
      });
      this.addSubView(this.settingView, this.$(".setting"));
    }
  }, {
    key: "_saveHandle",
    value: function _saveHandle() {
      var data = this.settingView.getResultData();
      if (!this.fileInfo) {
        this.onCheckCallback && this.onCheckCallback(data);
        this.navigationWindowView.pop();
        return;
      }
      console.log(data);
      var newWhiteExts = data.newWhiteExts,
        newBlackExts = data.newBlackExts,
        delIds = data.delIds;
      if (newWhiteExts.length) {
        this.addExts(newWhiteExts, 1);
      }
      if (newBlackExts.length) {
        this.addExts(newBlackExts, 0);
      }
      MMEnterpriseController.delFileBlackListForFolder({
        blacklist_ids: delIds,
        fileId: this.fileInfo.getFileId()
      }, function () {}, function (res) {});
      _MDMessageView["default"].success(BabelStr.str(308), this.navigationWindowView.$body);
      this.navigationWindowView.pop();
    }
  }, {
    key: "addExts",
    value: function addExts(exts, type) {
      MMEnterpriseController.addFileBlackListForFolder({
        ext: exts.join(','),
        fileId: this.fileInfo.getFileId(),
        type: type
      }, function () {}, function (res) {});
    }
  }, {
    key: "_cancelHandle",
    value: function _cancelHandle() {
      this.navigationWindowView.pop();
    }
  }]);
  return MDUploadTypeSettingsPageView;
}(_MDNavigationPageView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1424":1424,"1454":1454,"1463":1463,"1475":1475,"55":55,"56":56,"666":666}],666:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1498);
require(1417);
require(1463);
require(1426);
require(1415);
require(1421);
require(1424);
require(1477);
require(1492);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMViewBase2 = _interopRequireDefault(require(22));
var _MDMessageView = _interopRequireDefault(require(55));
var _keycode = _interopRequireDefault(require(104));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDUploadTypeSettingsView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MDUploadTypeSettingsView, _MMViewBase);
  function MDUploadTypeSettingsView() {
    (0, _classCallCheck2["default"])(this, MDUploadTypeSettingsView);
    return _callSuper(this, MDUploadTypeSettingsView, arguments);
  }
  (0, _createClass2["default"])(MDUploadTypeSettingsView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n      <div class=\"flex-align between\">\n        <div class=\"title\"><%=BabelStr.str(12101)%></div>\n        <div class=\"whitelist-ope\"></div>\n      </div>\n      <div class=\"help-text\"><%=BabelStr.str(12103)%></div>\n      <div class=\"whitelist-block\">\n        <div class=\"help-text\"><%=BabelStr.str(12104)%></div>\n        <div class=\"flex-align between mgtb-10\">\n          <input type=\"text\" class=\"form-control ext-input whitelist-input\" placeholder=\"<%=BabelStr.str(12105)%>\"/>\n          <div class=\"placeholder-block\"></div>\n          <%if(!readOnly){%>\n            <button class=\"button done whitelist-add\"><%=BabelStr.str(5031)%></button>\n          <%}%>\n  \t\t\t</div>\n        <div class=\"help-text\"><%=BabelStr.str(12106)%></div>\n        <div class=\"whitelist-content flex-align with-wrap\"></div>\n      </div>\n\n      <div class=\"flex-align between\">\n        <div class=\"title\"><%=BabelStr.str(12102)%></div>\n        <div class=\"blacklist-ope\"></div>\n      </div>\n      <div class=\"help-text\"><%=BabelStr.str(12107)%></div>\n      <div class=\"blacklist-block\">\n\n        <div class=\"flex-align between mgtb-10\">\n          <input type=\"text\" class=\"form-control ext-input blacklist-input\" placeholder=\"<%=BabelStr.str(12108)%>\"/>\n          <div class=\"placeholder-block\"></div>\n          <%if(!readOnly){%>\n            <button class=\"button done blacklist-add\"><%=BabelStr.str(5031)%></button>\n          <%}%>\n        </div>\n        <div class=\"help-text\"><%=BabelStr.str(12106)%></div>\n        <div class=\"blacklist-content flex-align with-wrap\"></div>\n      </div>\n\t\t";
    }
  }, {
    key: "extItem",
    value: function extItem(ext, type) {
      var del = '';
      if (!this.readOnly) {
        del = "<span class = \"icon ic-close-small\"></span>";
      }
      return "<div class=\"ext-item flex-align middle\" data-type=".concat(type, ">\n      <span class = \"ext-text\">").concat(ext, " </span>\n      ").concat(del, "\n    </div>");
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUploadTypeSettingsView.prototype), "className", this).call(this);
      return "".concat(superCls, " upload-type-setting");
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        readOnly: this.readOnly
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUploadTypeSettingsView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUploadTypeSettingsView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .whitelist-add': this._whitelistChanged,
        'click .blacklist-add': this._blacklistChanged,
        'input .ext-input': this._validateInput,
        'keyup .whitelist-input': this._whitelistKeyup,
        'keyup .blacklist-input': this._blacklistKeyup,
        'click .ic-close-small': this._del
      });
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUploadTypeSettingsView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        immediatelyMerge: true,
        readOnly: false
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUploadTypeSettingsView.prototype), "initialize", this).call(this, props);
      if (this.fileInfo) {
        this.getFileBlackListForFolder();
      }
      this.renderInitData();
      if (this.readOnly) {
        this.$('.ext-input').attr("readOnly", true);
      }
    }
  }, {
    key: "getFileBlackListForFolder",
    value: function getFileBlackListForFolder() {
      var _this = this;
      MMEnterpriseController.getFileBlackListForFolder(this.fileInfo.getFileId(), function (datas) {
        _this.datas = datas;
        _this.renderDataList(datas);
      });
    }
  }, {
    key: "_del",
    value: function _del($e) {
      var $target = $($e.target).closest('.ext-item');
      var type = $target.data('type') - 0;
      var ext = $target.find(".ext-text").text().trim();
      var oldItem = _.find(this.datas, function (item) {
        return item.type == type && item.ext == ext;
      });
      if (this.immediatelyMerge) {
        $target.hide();
        this.delExts([oldItem.id], function () {
          $target.remove();
        });
      } else {
        $target.remove();
      }
    }
  }, {
    key: "getResultData",
    value: function getResultData() {
      var originWhiteExts = [];
      var originBlackExts = [];
      var originWhite = [];
      var originBlack = [];
      _.each(this.datas, function (item) {
        if (item.type == 1) {
          originWhiteExts.push(item.ext);
          originWhite.push(item);
        } else {
          originBlackExts.push(item.ext);
          originBlack.push(item);
        }
      });
      var $whiteExtTags = this.$('.ext-item[data-type=1] .ext-text');
      var whiteExts = [];
      for (var i = 0; i < $whiteExtTags.length; i++) {
        whiteExts.push($whiteExtTags.eq(i).text().trim());
      }
      console.log(whiteExts);
      var $blackExtTags = this.$('.ext-item[data-type=0] .ext-text');
      var blackExts = [];
      for (var _i = 0; _i < $blackExtTags.length; _i++) {
        blackExts.push($blackExtTags.eq(_i).text().trim());
      }
      console.log(blackExts);
      var newWhiteExts = _.difference(whiteExts, originWhiteExts);
      var newBlackExts = _.difference(blackExts, originBlackExts);
      var delWhiteExts = _.difference(originWhiteExts, whiteExts);
      var delBlackExts = _.difference(originBlackExts, blackExts);
      var delWhiteIds = _.map(delWhiteExts, function (ext) {
        var item = _.findWhere(originWhite, {
          ext: ext
        });
        return item.id;
      });
      var delBlackIds = _.map(delBlackExts, function (ext) {
        var item = _.findWhere(originBlack, {
          ext: ext
        });
        return item.id;
      });
      var delIds = delWhiteIds.concat(delBlackIds);
      console.log(newWhiteExts, delBlackExts, delIds);
      return {
        newWhiteExts: newWhiteExts,
        newBlackExts: newBlackExts,
        delIds: delIds
      };
    }
  }, {
    key: "addExts",
    value: function addExts(exts, type) {
      var _this2 = this;
      MMEnterpriseController.addFileBlackListForFolder({
        ext: exts,
        fileId: this.fileInfo.getFileId(),
        type: type
      }, function () {
        _MDMessageView["default"].success(BabelStr.str(308), _this2.msgContain);
        _this2.getFileBlackListForFolder();
      }, function (res) {
        _MDMessageView["default"].success(res.message, _this2.msgContain);
      });
    }
  }, {
    key: "delExts",
    value: function delExts(blacklist_ids, callback) {
      var _this3 = this;
      MMEnterpriseController.delFileBlackListForFolder({
        blacklist_ids: blacklist_ids,
        fileId: this.fileInfo.getFileId()
      }, function () {
        callback && callback();
        _MDMessageView["default"].success(BabelStr.str(308), _this3.msgContain);
      }, function (res) {
        _MDMessageView["default"].success(res.message, _this3.msgContain);
      });
    }
  }, {
    key: "renderDataList",
    value: function renderDataList(datas) {
      var _this4 = this;
      var whitelistTmpl = '';
      var blacklistTmpl = '';
      _.each(datas, function (item) {
        var ext = _.escape(item.ext);
        if (item.type == 1) {
          whitelistTmpl += _this4.extItem(ext, 1);
        } else {
          blacklistTmpl += _this4.extItem(ext, 0);
        }
      });
      this.$('.whitelist-content').html(whitelistTmpl);
      this.$('.blacklist-content').html(blacklistTmpl);
    }
  }, {
    key: "renderInitData",
    value: function renderInitData() {
      var _this5 = this;
      var tmpl = '';
      if (this.originWhitelist) {
        _.each(this.originWhitelist, function (item) {
          tmpl += _this5.extItem(item, 1);
        });
        this.$('.whitelist-content').append(tmpl);
      }
      if (this.originBlacklist) {
        tmpl = '';
        _.each(this.originBlacklist, function (item) {
          tmpl += _this5.extItem(item, 0);
        });
        this.$('.blacklist-content').append(tmpl);
      }
    }
  }, {
    key: "_whitelistChanged",
    value: function _whitelistChanged() {
      if (this.readOnly) {
        return;
      }
      var $whiteExtTags = this.$('.ext-item[data-type=1] .ext-text');
      var whiteExts = [];
      for (var i = 0; i < $whiteExtTags.length; i++) {
        whiteExts.push($whiteExtTags.eq(i).text().trim());
      }
      console.log(whiteExts);
      var val = this.$('.whitelist-input').val().trim();
      val = val.toLowerCase();
      var extArr = val.split(';');
      extArr = _.filter(extArr, function (item) {
        item = item.trim();
        return item !== '' && _.indexOf(whiteExts, item) < 0;
      });
      this.$('.whitelist-input').val("");
      if (!extArr.length) {
        return;
      }
      var tmpl = '';
      if (this.immediatelyMerge) {
        this.addExts(extArr.join(','), 1);
        return;
      }
      for (var _i2 = 0; _i2 < extArr.length; _i2++) {
        var ext = extArr[_i2];
        tmpl += this.extItem(ext, 1);
      }
      this.$('.whitelist-content').append(tmpl);
      this.navigationWindowView && this.navigationWindowView.refreshWindow();
    }
  }, {
    key: "_blacklistChanged",
    value: function _blacklistChanged() {
      if (this.readOnly) {
        return;
      }
      var $blackExtTags = this.$('.ext-item[data-type=0] .ext-text');
      var blackExts = [];
      for (var i = 0; i < $blackExtTags.length; i++) {
        blackExts.push($blackExtTags.eq(i).text().trim());
      }
      console.log(blackExts);
      var val = this.$('.blacklist-input').val().trim();
      val = val.toLowerCase();
      var extArr = val.split(';');
      extArr = _.filter(extArr, function (item) {
        item = item.trim();
        return item !== '' && _.indexOf(blackExts, item) < 0;
      });
      this.$('.blacklist-input').val("");
      if (!extArr.length) {
        return;
      }
      var tmpl = '';
      if (this.immediatelyMerge) {
        this.addExts(extArr.join(','), 0);
        return;
      }
      for (var _i3 = 0; _i3 < extArr.length; _i3++) {
        var ext = extArr[_i3];
        tmpl += this.extItem(ext, 0);
      }
      this.$('.blacklist-content').append(tmpl);
      this.navigationWindowView && this.navigationWindowView.refreshWindow();
    }
  }, {
    key: "_validateInput",
    value: function _validateInput(e) {
      // 使用正则表达式来匹配允许的字符
      // 这里允许的是字母（a-zA-Z）和分号（;）
      var regex = /[^a-zA-Z0-9;]/g;
      // 如果输入不符合规则，则替换掉非法字符
      // if (!regex.test(e.target.value)) {
      // 去除最后一个输入的非法字符
      e.target.value = e.target.value.replace(regex, '');
      // }
    }
  }, {
    key: "_whitelistKeyup",
    value: function _whitelistKeyup($e) {
      if (_keycode["default"].isEnterKey($e.keyCode)) {
        this._whitelistChanged();
        return false;
      }
    }
  }, {
    key: "_blacklistKeyup",
    value: function _blacklistKeyup($e) {
      if (_keycode["default"].isEnterKey($e.keyCode)) {
        this._blacklistChanged();
        return false;
      }
    }
  }, {
    key: "_saveHandle",
    value: function _saveHandle() {
      this.navigationWindowView.pop();
    }
  }, {
    key: "_cancelHandle",
    value: function _cancelHandle() {
      this.navigationWindowView.pop();
    }
  }]);
  return MDUploadTypeSettingsView;
}(_MMViewBase2["default"]);

},{"104":104,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1415":1415,"1417":1417,"1421":1421,"1424":1424,"1426":1426,"1454":1454,"1463":1463,"1475":1475,"1477":1477,"1492":1492,"1498":1498,"22":22,"55":55}],639:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDEnterpriseShareTabView = _interopRequireDefault(require(675));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MEStaffSearchPanelView = _interopRequireDefault(require(197));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDAddProjectMemberPageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDAddProjectMemberPageView, _MDNavigationPageView);
  function MDAddProjectMemberPageView() {
    (0, _classCallCheck2["default"])(this, MDAddProjectMemberPageView);
    return _callSuper(this, MDAddProjectMemberPageView, arguments);
  }
  (0, _createClass2["default"])(MDAddProjectMemberPageView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n\t\t\t<div class=\"content\"></div>\n\t\t\t<div class=\"flex-align end\t mgt-15\">\n\t\t\t\t<button class=\"button mgr-10 cancel\"><%=BabelStr.str(3081)%></button>\n\t\t\t\t<button class=\"button done save\"><%=BabelStr.str(154)%></button>\n\t\t\t</div>\n\t\t";
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAddProjectMemberPageView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .save': this._saveHandle,
        'click .cancel': this._cancelHandle
      });
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAddProjectMemberPageView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        addManager: false,
        canSelDepartment: true,
        needRoleSelectList: true,
        excludeOutsider: false,
        notIncludeGuest: false,
        canSelGroup: !(app.isEpVersion() && app.currentUser.get("hasSecret"))
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAddProjectMemberPageView.prototype), "initialize", this).call(this, props);
      var title;
      if (this.addManager) {
        title = BabelStr.str(2817);
      }
      if (props.title) {
        title = props.title;
      } else if (this.addManager) {
        title = BabelStr.str(2817);
      } else {
        title = BabelStr.str(2818);
      }
      this.setTitle(title);
      var self = this;
      console.log(12345);
      if (this.addManager || this.userEpSelectComp) {
        if (this.canSearchEpMember()) {
          this.searchView = new _MEStaffSearchPanelView["default"]({
            singleSelection: this.addManager || this.singleSelection,
            needFreeze: false,
            disabledDepChoose: !app.currentUser.get('isShowingStructor'),
            // initLoaded: app.currentUser.get('isShowingStructor'),
            chooseChangeCb: function chooseChangeCb() {
              _this.navigationWindowView.refreshWindow();
            },
            onConditionChanged: function onConditionChanged() {
              _this.navigationWindowView.refreshWindow();
            }
          });
          this.addSubView(this.searchView, this.$('.content'));
        } else {
          var placeholder = undefined;
          if (this.canSelGroup) {
            placeholder = BabelStr.str(40079);
            if (this.canSelDepartment) {
              placeholder = BabelStr.str(40080);
            }
          }
          this.chooserView = new _MDEnterpriseShareTabView["default"]({
            isSelectOnlyInEp: true,
            canSelDepartment: false,
            excludeOutsider: true,
            notIncludeGuest: true,
            inputFullWidth: true,
            canSelGroup: false,
            // needFrequentUserTab: false,
            needRoleTab: false,
            placeholder: placeholder,
            // needFrequentUserTab: !this.fileInfor.get('forClient'),
            onChange: function onChange(mails) {
              self.navigationWindowView && self.navigationWindowView.refreshWindow();
            }
          });
          this.addSubView(this.chooserView, this.$('.content'));
          this.chooserView.showTab();
        }
      } else {
        var _placeholder = undefined;
        if (this.canSelGroup) {
          _placeholder = BabelStr.str(40079);
          if (this.canSelDepartment) {
            _placeholder = BabelStr.str(40080);
          }
        }
        this.chooserView = new _MDEnterpriseShareTabView["default"]({
          canSelDepartment: this.canSelDepartment,
          canSelGroup: this.canSelGroup,
          excludeOutsider: this.excludeOutsider,
          notIncludeGuest: this.notIncludeGuest,
          onlyOne: this.onlyOne,
          //     canSelDepartment: false,
          // canSelGroup: false,
          placeholder: _placeholder,
          needRoleSelectList: this.needRoleSelectList,
          inputFullWidth: true,
          // needFrequentUserTab: !this.fileInfor.get('forClient'),
          onChange: function onChange(mails) {
            self.navigationWindowView && self.navigationWindowView.refreshWindow();
          }
        });
        this.addSubView(this.chooserView, this.$('.content'));
        this.chooserView.showTab();
      }
    }
  }, {
    key: "canSearchEpMember",
    value: function canSearchEpMember() {
      return app.currentUser.canManageEpMember();
    }
  }, {
    key: "_saveHandle",
    value: function _saveHandle() {
      var users = [];
      if (this.addManager || this.userEpSelectComp) {
        if (this.canSearchEpMember()) {
          users = this.searchView.getSearchedPersons();
        } else {
          users = this.chooserView.getSelectedMolaUsers();
        }
      } else {
        users = this.chooserView.getSelectedUsers();
      }
      // console.warn(users)
      this.navigationWindowView.pop();
      this.onSelected(users);
    }
  }, {
    key: "_cancelHandle",
    value: function _cancelHandle() {
      this.navigationWindowView.pop();
    }
  }]);
  return MDAddProjectMemberPageView;
}(_MDNavigationPageView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"197":197,"56":56,"675":675}],634:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDPopupView = _interopRequireDefault(require(64));
var _MDFocusFilePanelView = _interopRequireDefault(require(633));
/**
 * 提醒关注
 * Created by jichao
 * 2017.4.14
 */

var MDFocusFilePopupView = _MDPopupView["default"].extend({
  className: function className() {
    var superCls = _MDPopupView["default"].prototype.className.call(this);
    return superCls + ' m-focus-popup-view';
  },
  initialize: function initialize(options) {
    var _this = this;
    options.width = 360;
    options.hasArrow = true;
    _MDPopupView["default"].prototype.initialize.call(this, options);
    this.$('.showWin').addClass("hidden");
    var opt = _.extend({
      layout: function layout() {
        _this.layout();
      },
      close: function close() {
        _this.close();
      }
    }, options);
    this.panel = new _MDFocusFilePanelView["default"](opt);
    this.addSubView(this.panel);
  }
});
var _default = exports["default"] = MDFocusFilePopupView;

},{"1184":1184,"1454":1454,"633":633,"64":64}],633:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1421);
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _keycode = _interopRequireDefault(require(104));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDFocusFileWinView = _interopRequireDefault(require(635));
var _MMViewBase = _interopRequireDefault(require(22));
/**
 * 提醒关注
 * Created by jichao
 * 2017.4.14
 */

var MDFocusFilePanelView = _MMViewBase["default"].extend({
  tmpl: "<div class=\"flex-align with-column h-100 main-content\">\n        <input type=\"text\" class=\"no-shrink search\" placeholder=\"<%=placeholder%>\" />\n        <div class=\"col-auto user-list-block h-100\">\n          <ul class=\"user-list h-100\"></ul>\n        </div>\n        <div class=\"flex-align between pd-10\">\n          <div class=\"button btnhover small showWin\"><%=BabelStr.str(2610)%></div>\n          <div>\n            <button id=\"js-cancel\" class=\"button default small\"><%=cancel%></button>\n            <button class=\"button done small send-result\"><%=ok%></button>\n          </div>\n        </div>\n        </div>",
  render: function render(data) {
    data = {
      placeholder: _MDLocalString["default"].getLocalString(251),
      //选择要提醒的人或直接输入
      ok: _MDLocalString["default"].getLocalString(154),
      // 确定
      cancel: _MDLocalString["default"].getLocalString(155) //
    };
    _MMViewBase["default"].prototype.render.call(this, data);
  },
  className: function className() {
    var superCls = _MMViewBase["default"].prototype.className.call(this);
    return superCls + " m-focus-popup-view";
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      userCollection: new _MDMolaUserCollection["default"](),
      fileInfo: null
    });
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      "input .search": this._searchInputHandle,
      "click .user-item": this._userItemClickHandle,
      "click .send-result": this._sendResult,
      "click #js-cancel": this._close,
      "click .showWin": this._showWinHandle
    });
  },
  initialize: function initialize(options) {
    options.width = 360;
    options.hasArrow = true;
    _MMViewBase["default"].prototype.initialize.call(this, options);
    this.$(".showWin").addClass("hidden");
  },
  _close: function _close() {
    _.isFunction(this.close) && this.close();
  },
  _showWinHandle: function _showWinHandle() {
    var win = new _MDFocusFileWinView["default"]({
      fileInfo: this.fileInfo,
      userCollection: this.userCollection
    });
    win.show();
    this.close();
  },
  renderUserList: function renderUserList(argument) {
    var str = "";
    var isChecked;
    this.userCollection.each(function (user) {
      if (user.get("searched")) {
        isChecked = user.get("isFocusFile");
        str += '<li class = "user-item ' + (isChecked ? "checked" : "") + '" data-userId="' + user.getUserId() + '">\
              <span class = "checkbox "></span>\
              <img src="" alt="" class = "user-img _user-profile-picture " data-src = "' + user.getAvatarImageURL() + '" />\
              <span class = "user-info text-hide">\
                <span class = "user-name">' + user.getUserName() + '</span>\
                <span class = "user-email">' + user.getAccount() + "</span>\
              </span>\
            </li>";
      }
    });
    this.$(".user-list").html(str);
    this.$(".user-img").imageLoader();
    _.isFunction(this.layout) && this.layout();
  },
  getUsersCanFocusFile: function getUsersCanFocusFile() {
    var self = this;
    _MDSpinnerloaderView["default"].showIn(this.$(".user-list-block"), {
      autoHeight: false
    });
    var noNeedDepInfo = true;
    _MMNetDiskDataController["default"].getUsersCanFocusFile(this.fileInfo().getFileId(), noNeedDepInfo, this.fileInfo().getOrganizationInfo(), function (userCollection) {
      if (app.isEpVersion() && userCollection.length > 5 && !self.fileInfo().get("forClient")) {
        self.$(".showWin").removeClass("hidden");
      }
      userCollection.each(function (user) {
        user.set("searched", true);
      });
      self.userCollection = userCollection;
      self.oldFocusedUsers = [];
      userCollection.each(function (user) {
        var isChecked = user.get("isFocusFile");
        if (isChecked) {
          self.oldFocusedUsers.push(user.getUserId());
        }
      });
      self.renderUserList();
      _MDSpinnerloaderView["default"].clearFrom(self.$(".user-list-block"));
    }, function () {
      _MDSpinnerloaderView["default"].clearFrom(self.$(".user-list-block"));
    });
  },
  _userItemClickHandle: function _userItemClickHandle($e) {
    var $curUserItem = $($e.target).closest(".user-item");
    var userId = $curUserItem.data("userid");
    if ($curUserItem.hasClass("checked")) {
      this.removeFileFocus(userId, $curUserItem);
    } else {
      this.focusFile(userId, $curUserItem);
    }
  },
  removeFileFocus: function removeFileFocus(userId, $curUserItem) {
    $curUserItem.removeClass("checked");
    this.userCollection.each(function (user) {
      if (user.getUserId() == userId) {
        user.set("isFocusFile", 0);
      }
    });
  },
  focusFile: function focusFile(userId, $curUserItem) {
    $curUserItem.addClass("checked");
    this.userCollection.each(function (user) {
      if (user.getUserId() == userId) {
        user.set("isFocusFile", 1);
      }
    });
  },
  removeFileFocusToServer: function removeFileFocusToServer(userIds) {
    if (userIds.length == 0) {
      return;
    }
    var fid = this.fileInfo().getFileId();
    var self = this;
    _MMNetDiskDataController["default"].removeFileFocus(fid, userIds, function () {
      var findCurUser = false;
      for (var i = 0; i < userIds.length; i++) {
        if (userIds[i] == app.currentUser.getUserId()) {
          findCurUser = true;
          break;
        }
      }
      var focusCount = self.fileInfo().getFocusCount();
      if (app.pathRouter && app.pathRouter.isInMyfocus() && findCurUser) {
        focusCount = 0;
      } else {
        focusCount -= userIds.length;
      }
      focusCount = focusCount < 0 ? 0 : focusCount;
      self.fileInfo().setFocusCount(focusCount);
      if (findCurUser) {
        self.fileInfo().setIsFocusFile(false);
      }
    }, function () {
      console.log("移除关注操作失败");
    });
  },
  focusFileToServer: function focusFileToServer(userIds) {
    if (userIds.length == 0) {
      return;
    }
    var fid = this.fileInfo().getFileId();
    var self = this;
    var focusCount = 0;
    _czc && _czc.push(["_trackEvent", "文件操作", "提醒关注", "", userIds.length + "", ""]);
    _MMNetDiskDataController["default"].focusFile(fid, userIds, function () {
      for (var i = 0; i < userIds.length; i++) {
        if (userIds[i] == app.currentUser.getUserId()) {
          self.fileInfo().setIsFocusFile(true);
          break;
        }
      }
      focusCount = self.fileInfo().getFocusCount() + userIds.length;
      self.fileInfo().setFocusCount(focusCount);
    }, function () {
      console.log("提醒关注操作失败");
    });
  },
  _searchInputHandle: function _searchInputHandle($e) {
    var value = this.$(".search").val();
    var str = "";
    var index = -1;
    this.userCollection.each(function (user) {
      str = user.getUserName() + user.getAccount();
      str = str.toLowerCase();
      value = value.toLowerCase();
      index = str.indexOf(value);
      if (index < 0) {
        user.set("searched", false);
      } else {
        user.set("searched", true);
      }
    });
    this.renderUserList();
  },
  viewWillRendered: function viewWillRendered() {
    _MMViewBase["default"].prototype.viewWillRendered.call(this);
    this.getUsersCanFocusFile();
  },
  viewDidRendered: function viewDidRendered() {
    _MMViewBase["default"].prototype.viewDidRendered.call(this);
    this.getUsersCanFocusFile();
  },
  _sendResult: function _sendResult() {
    console.log("---------> send result!");
    var userAdded = [];
    var userRemoved = [];
    var self = this;
    this.userCollection.each(function (user) {
      var found = false;
      for (var i = 0; i < self.oldFocusedUsers.length; i++) {
        if (self.oldFocusedUsers[i] == user.getUserId()) {
          found = true;
          break;
        }
      }
      var isChecked = user.get("isFocusFile");
      if (!found && isChecked) {
        userAdded.push(user.getUserId());
      } else if (found && !isChecked) {
        userRemoved.push(user.getUserId());
      }
    });
    this.focusFileToServer(userAdded);
    this.removeFileFocusToServer(userRemoved);
    _.isFunction(this.close) && this.close();
  }
});
var _default = exports["default"] = MDFocusFilePanelView;

},{"104":104,"1104":1104,"1150":1150,"1184":1184,"1421":1421,"1454":1454,"22":22,"273":273,"635":635,"76":76}],635:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1421);
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _keycode = _interopRequireDefault(require(104));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDWindowView = _interopRequireDefault(require(93));
/**
 * 提醒关注
 * Created by jichao
 * 2017.4.14
 */

var MDFocusFileWinView = _MDWindowView["default"].extend({
  contentTmpl: "<div class=\"flex-align with-column \">\n        <input type=\"text\" class=\"no-shrink search search-c\" placeholder=\"<%=placeholder%>\" />\n        <div class=\"col-auto user-list-block\">\n          <ul class=\"list-block\"></ul>\n        </div>\n        <div class=\"flex-align end btns-block\">\n          <div>\n            <button id=\"js-cancel\" class=\"button default \"><%=cancel%></button>\n            <button class=\"button done  send-result\"><%=ok%></button>\n          </div>\n        </div>\n        </div>",
  render: function render(data) {
    data = {
      placeholder: _MDLocalString["default"].getLocalString(251),
      //选择要提醒的人或直接输入
      ok: _MDLocalString["default"].getLocalString(154),
      // 确定
      cancel: _MDLocalString["default"].getLocalString(155) //
    };
    _MDWindowView["default"].prototype.render.call(this, data);
  },
  className: function className() {
    var superCls = _MDWindowView["default"].prototype.className.call(this);
    return superCls + " m-focus-win";
  },
  initProps: function initProps() {
    var superP = _MDWindowView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      userCollection: new _MDMolaUserCollection["default"](),
      fileInfo: _.noop,
      departArr: []
    });
  },
  events: function events() {
    var superE = _MDWindowView["default"].prototype.events.call(this);
    return _.extend(superE, {
      "input .search": this._searchInputHandle,
      "click .user-item": this._userItemClickHandle,
      "click .send-result": this._sendResult,
      "click #js-cancel": this.close,
      // 'click .dep-title': this._toogleUserBlock,
      "click .select-dep": this._selectDepHandle,
      "click .opt-btn": this._toogleUserBlock
    });
  },
  initialize: function initialize(options) {
    options.width = 600;
    options.hasArrow = true;
    options.title = BabelStr.str(244);
    this.selectobj = {};
    _MDWindowView["default"].prototype.initialize.call(this, options);
  },
  _toogleUserBlock: function _toogleUserBlock($e) {
    var $block = this.$($e.target).closest(".depart-block");
    $block.toggleClass("open");
  },
  // renderUserList: function(argument) {
  //   var str = ""
  //   var isChecked;
  //   this.userCollection.each(function(user) {
  //     if (user.get("searched")) {
  //       isChecked = user.get("isFocusFile");
  //       str += '<li class = "user-item ' + (isChecked ? 'checked' : '') + '" data-userId="' + user.getUserId() + '">\
  //             <span class = "checkbox "></span>\
  //             <img src="" alt="" class = "user-img" data-src = "' + user.getAvatarImageURL() + '" />\
  //             <span class = "user-info text-hide">\
  //               <span class = "user-name">' + user.getUserName() + '</span>\
  //               <span class = "user-email">' + user.getEmail() + '</span>\
  //             </span>\
  //           </li>';
  //     }

  //   })
  //   this.$(".user-list").html(str);
  //   this.$(".user-img").imageLoader();
  //   this.layout();
  // },

  renderUserList: function renderUserList() {
    var _this = this;
    var result = "";
    _.each(this.departArr, function (depart) {
      var tmpl = "";
      _this.userCollection.each(function (user) {
        var dep = user.get("departments")[0];
        var depId = dep && dep.departmentId;
        if (user.get("searched") && depId == depart.departmentId) {
          var isChecked = user.get("isFocusFile");
          tmpl += '<li class = "user-item ' + (isChecked ? "checked" : "") + '" data-userId="' + user.getUserId() + '">\
                <span class = "checkbox "></span>\
                <img src="" alt="" class = "user-img _user-profile-picture" data-src = "' + user.getAvatarImageURL() + '" />\
                <span class = "user-info text-hide">\
                  <span class = "user-name">' + user.getUserName() + '</span>\
                  <span class = "user-email">' + user.getAccount() + "</span>\
                </span>\
              </li>";
        }
      });
      result += "<div class=\"depart-block open\">\n        <div class=\"dep-title flex-align\">\n          <div class=\"opt-btn\"></div>\n          <div class=\"select-dep\" data-depId=\"".concat(depart.departmentId, "\">").concat(depart.departmentName, "</div>\n        </div>\n        <div class=\"user-list \">").concat(tmpl, "</div>\n\n      </div>");
    });
    this.$(".list-block").html(result);
    this.$(".user-img").imageLoader();
  },
  getUsersCanFocusFile: function getUsersCanFocusFile(belongDepId) {
    var self = this;
    _MDSpinnerloaderView["default"].showIn(this.$(".user-list-block"), {
      autoHeight: false
    });
    var noNeedDepInfo = false;
    var belongDep = null;
    _MMNetDiskDataController["default"].getUsersCanFocusFile(this.fileInfo().getFileId(), noNeedDepInfo, this.fileInfo().getOrganizationInfo(), function (userCollection) {
      self.userCollection = userCollection;
      self.userCollection.each(function (user) {
        var departments = user.get("departments");
        var department;
        if (_.isArray(departments)) {
          department = departments[0];
          var depId = department && department.departmentId;
          if (depId) {
            if (depId != belongDepId) {
              if (!_.findWhere(self.departArr, {
                departmentId: depId
              })) {
                self.departArr.unshift(department);
              }
            } else {
              belongDep = department;
            }
          } else {
            if (!_.findWhere(self.departArr, {
              departmentId: null
            })) {
              var titleStr = BabelStr.str(2618);
              if (!app.isEpVersion()) {
                titleStr = BabelStr.str(6054); //'参与分享的人员'
              }
              self.departArr.push({
                departmentId: null,
                departmentName: titleStr
              });
            }
          }
        }
        user.set("searched", true);
      });
      if (belongDep) {
        self.departArr.unshift(belongDep);
      }
      self.oldFocusedUsers = [];
      self.userCollection.each(function (user) {
        var isChecked = user.get("isFocusFile");
        if (isChecked) {
          self.oldFocusedUsers.push(user.getUserId());
        }
      });
      self.renderUserList();
      _MDSpinnerloaderView["default"].clearFrom(self.$(".user-list-block"));
    }, function () {
      _MDSpinnerloaderView["default"].clearFrom(self.$(".user-list-block"));
    });
  },
  _userItemClickHandle: function _userItemClickHandle($e) {
    var $curUserItem = $($e.target).closest(".user-item");
    var userId = $curUserItem.data("userid");
    if ($curUserItem.hasClass("checked")) {
      this.removeFileFocus(userId, $curUserItem);
    } else {
      this.focusFile(userId, $curUserItem);
    }
  },
  _selectDepHandle: function _selectDepHandle($e) {
    var self = this;
    var selectId = $($e.target).data("depid");
    this.selectobj[selectId] = !this.selectobj[selectId];
    this.userCollection.each(function (user) {
      var departments = user.get("departments");
      var department;
      if (_.isArray(departments)) {
        department = departments[0];
        if (!department) {
          console.log(11111);
        }
        var depId = department ? department.departmentId : null;
        if (depId == selectId) {
          if (self.selectobj[selectId]) {
            user.set("isFocusFile", 1);
            self.$(".user-item[data-userid=".concat(user.getUserId(), "]")).addClass("checked");
          } else {
            user.set("isFocusFile", 0);
            self.$(".user-item[data-userid=".concat(user.getUserId(), "]")).removeClass("checked");
          }
        }
      }
    });
  },
  removeFileFocus: function removeFileFocus(userId, $curUserItem) {
    $curUserItem.removeClass("checked");
    this.userCollection.each(function (user) {
      if (user.getUserId() == userId) {
        user.set("isFocusFile", 0);
      }
    });
  },
  focusFile: function focusFile(userId, $curUserItem) {
    $curUserItem.addClass("checked");
    this.userCollection.each(function (user) {
      if (user.getUserId() == userId) {
        user.set("isFocusFile", 1);
      }
    });
  },
  removeFileFocusToServer: function removeFileFocusToServer(userIds) {
    if (userIds.length == 0) {
      return;
    }
    var fid = this.fileInfo().getFileId();
    var self = this;
    _MMNetDiskDataController["default"].removeFileFocus(fid, userIds, function () {
      var findCurUser = false;
      for (var i = 0; i < userIds.length; i++) {
        if (userIds[i] == app.currentUser.getUserId()) {
          findCurUser = true;
          break;
        }
      }
      var focusCount = self.fileInfo().getFocusCount();
      if (app.pathRouter.isInMyfocus() && findCurUser) {
        focusCount = 0;
      } else {
        focusCount -= userIds.length;
      }
      focusCount = focusCount < 0 ? 0 : focusCount;
      self.fileInfo().setFocusCount(focusCount);
      if (findCurUser) {
        self.fileInfo().setIsFocusFile(false);
      }
    }, function () {
      console.log("移除关注操作失败");
    });
  },
  focusFileToServer: function focusFileToServer(userIds) {
    if (userIds.length == 0) {
      return;
    }
    var fid = this.fileInfo().getFileId();
    var self = this;
    var focusCount = 0;
    _czc && _czc.push(["_trackEvent", "文件操作", "提醒关注", "", userIds.length + "", ""]);
    _MMNetDiskDataController["default"].focusFile(fid, userIds, function () {
      for (var i = 0; i < userIds.length; i++) {
        if (userIds[i] == app.currentUser.getUserId()) {
          self.fileInfo().setIsFocusFile(true);
          break;
        }
      }
      focusCount = self.fileInfo().getFocusCount() + userIds.length;
      self.fileInfo().setFocusCount(focusCount);
    }, function () {
      console.log("提醒关注操作失败");
    });
  },
  _searchInputHandle: function _searchInputHandle($e) {
    var value = this.$(".search").val();
    var str = "";
    var index = -1;
    this.userCollection.each(function (user) {
      str = user.getUserName() + user.getAccount();
      str = str.toLowerCase();
      value = value.toLowerCase();
      index = str.indexOf(value);
      if (index < 0) {
        user.set("searched", false);
      } else {
        user.set("searched", true);
      }
    });
    this.renderUserList();
  },
  getFileBelongDepartment: function getFileBelongDepartment() {
    var _this2 = this;
    MMEnterpriseController.getFileBelongDepartment(this.fileInfo().getFileId(), function (department) {
      var id = department && department.id || null;
      _this2.getUsersCanFocusFile(id);
    });
  },
  viewDidRendered: function viewDidRendered() {
    _MDWindowView["default"].prototype.viewDidRendered.call(this);
    this.getFileBelongDepartment();
  },
  _sendResult: function _sendResult() {
    console.log("---------> send result!");
    var userAdded = [];
    var userRemoved = [];
    var self = this;
    this.userCollection.each(function (user) {
      var found = false;
      for (var i = 0; i < self.oldFocusedUsers.length; i++) {
        if (self.oldFocusedUsers[i] == user.getUserId()) {
          found = true;
          break;
        }
      }
      var isChecked = user.get("isFocusFile");
      if (!found && isChecked) {
        userAdded.push(user.getUserId());
      } else if (found && !isChecked) {
        userRemoved.push(user.getUserId());
      }
    });
    this.focusFileToServer(userAdded);
    this.removeFileFocusToServer(userRemoved);
    this.close();
  }
});
var _default = exports["default"] = MDFocusFileWinView;

},{"104":104,"1104":1104,"1150":1150,"1184":1184,"1412":1412,"1421":1421,"1454":1454,"273":273,"76":76,"93":93}],628:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDPaginationView = _interopRequireDefault(require(61));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDFileInfoShowView = _interopRequireDefault(require(497));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 *
 *  Created by jichao
 *  2024.10.22
 */
var MDManageApplyUserWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDManageApplyUserWinView, _MDWindowView);
  function MDManageApplyUserWinView() {
    (0, _classCallCheck2["default"])(this, MDManageApplyUserWinView);
    return _callSuper(this, MDManageApplyUserWinView, arguments);
  }
  (0, _createClass2["default"])(MDManageApplyUserWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<div class=\"users-list\"></div>\n    <div class=\"empty f-none pd-20 f-tc\"><%=BabelStr.str(2622)%></div>\n    <div class=\"table-wrap\"></div>\n    ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDManageApplyUserWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " create-classify-win");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDManageApplyUserWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        userCollection: new _MDMolaUserCollection["default"](),
        pageIndex: 0,
        pageSize: 10,
        removeIds: []
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDManageApplyUserWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        // "click .cancel": this.cancel,
        "click .remove": this.removeUserItem
        // "click .save": this._save,
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.title = BabelStr.str(12551);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDManageApplyUserWinView.prototype), "initialize", this).call(this, props);
      this.paginationBarView = new _MDPaginationView["default"]({
        silentInit: true,
        pageSize: this.pageSize,
        onPageChanged: function onPageChanged(curPageIndex) {
          _this.pageIndex = curPageIndex;
          _this.getDownloadAppliedUsers();
        },
        onPageSizeChanged: function onPageSizeChanged(newPageSize) {
          _this.pageSize = newPageSize;
          _this.pageIndex = 0;
          _this.getDownloadAppliedUsers();
        }
      });
      // this.paginationBarView.hide();
      this.addSubView(this.paginationBarView, this.$(".table-wrap")[0]);
      this.getDownloadAppliedUsers();
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.close();
    }
  }, {
    key: "getDownloadAppliedUsers",
    value: function getDownloadAppliedUsers() {
      var _this2 = this;
      var params = {
        fileId: this.fileInfor.getFileId(),
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      _MDSpinnerloaderView["default"].showIn(this.$body);
      _MMEnterpriseController["default"].getDownloadAppliedUsers(params, function (userCollection, total) {
        _this2.total = total;
        _this2.userCollection = userCollection;
        _this2.renderUsers();
        _this2.paginationBarView.setLength(total, true, _this2.pageIndex * _this2.pageSize);
        _this2.paginationBarView.show();
        _MDSpinnerloaderView["default"].clearFrom(_this2.$body);
        if (_this2.total == 0) {
          _this2.$(".empty").show();
        }
      }, function (code, msg) {
        _MDMessageView["default"].error(msg["this"].$body);
        _MDSpinnerloaderView["default"].clearFrom(_this2.$body);
      });
    }
  }, {
    key: "renderUsers",
    value: function renderUsers() {
      var tmpl = '';
      this.userCollection.each(function (user) {
        tmpl += user.getUserItemHtmlStr({
          canRemove: true
        });
      });
      this.$('.users-list').html(tmpl);
    }
  }, {
    key: "removeUserItem",
    value: function removeUserItem($e) {
      var _this3 = this;
      var id = $($e.target).closest(".item").data("id").toString();
      console.log(id);
      this.removeIds.push(id);
      var $item = $($e.target).closest(".item");
      this.showAlert(function () {
        _this3._save($item);
      });
    }
  }, {
    key: "showAlert",
    value: function showAlert(callback) {
      // if(!this.alert) {
      this.alert = new _MDAlertView["default"]({
        title: BabelStr.str(170),
        message: "<p class=\"title\">".concat(BabelStr.str(12565), "</p>"),
        className: "m-delAlertWin",
        width: 550,
        buttons: [{
          label: BabelStr.str(155)
        }, {
          label: BabelStr.str(32),
          type: "danger",
          onClick: function onClick() {
            callback();
          }
        }]
      });
      // }
      this.alert.show();
    }
  }, {
    key: "_save",
    value: function _save($item) {
      var _this4 = this;
      if (!this.removeIds.length) {
        return;
      }
      console.log(this.removeIds);
      _MMEnterpriseController["default"].removeUserDownloadAppliedFileId(this.fileInfor.getFileId(), this.removeIds, function () {
        $item.remove();
        _MDSnackbarView["default"].show(BabelStr.str(308));
        // this.close()
        _this4.getDownloadAppliedUsers();
      }, function (code, msg) {
        _MDMessageView["default"].error(msg, _this4.$body);
      });
    }
  }]);
  return MDManageApplyUserWinView;
}(_MDWindowView2["default"]);

},{"1098":1098,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1437":1437,"1454":1454,"1463":1463,"1475":1475,"1478":1478,"273":273,"32":32,"497":497,"55":55,"61":61,"72":72,"76":76,"93":93}],497:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMViewBase2 = _interopRequireDefault(require(22));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // MDFileInfoShowView.js 文件显示组件
// jichao
// 2017-5-18
var MDFileInfoShowView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MDFileInfoShowView, _MMViewBase);
  function MDFileInfoShowView() {
    (0, _classCallCheck2["default"])(this, MDFileInfoShowView);
    return _callSuper(this, MDFileInfoShowView, arguments);
  }
  (0, _createClass2["default"])(MDFileInfoShowView, [{
    key: "fileInfoTmpl",
    value: function fileInfoTmpl() {
      return "\n          <div class=\"file-info flex-align middle\">\n            <div class=\"image\"></div>\n            <div class=\"info\">\n              <div class=\"name middle-ellipsis f-pointer\"><%=name%></div>\n              <%if(!onlyName){%>\n                <div class=\"des text-hide\"><%=describe%></div>\n              <%}%>\n            </div>\n          </div>\n      ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileInfoShowView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        fileInfo: null,
        onlyName: false
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileInfoShowView.prototype), "className", this).call(this);
      return superCls + ' fileinfo-show-view';
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileInfoShowView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .file-info': this._elClickHandle
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileInfoShowView.prototype), "initialize", this).call(this, props);
      var fileInfo = this.fileInfo;
      var describe = fileInfo.get('creatorName') + BabelStr.str(41) + MMCommonFun.formatTime(fileInfo.get('ctime'));
      var data = {
        name: fileInfo.getFileName(),
        describe: describe,
        onlyName: this.onlyName
      };
      var contentTmpl = _.template(this.fileInfoTmpl())(data);
      this.$el.html(contentTmpl);
      fileInfo.setIconForDiv(this.$('.image'));
    }
  }, {
    key: "_elClickHandle",
    value: function _elClickHandle() {
      _.isFunction(this.onClick) && this.onClick(this.fileInfo);
    }
  }]);
  return MDFileInfoShowView;
}(_MMViewBase2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"22":22}],597:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1438);
require(1429);
require(1439);
require(1437);
require(1463);
require(1478);
require(1435);
require(1461);
require(1426);
require(1436);
require(1546);
require(1418);
require(1537);
require(1421);
require(1412);
require(1424);
require(1417);
require(1420);
require(1485);
require(1446);
require(1422);
require(1541);
require(1498);
require(1415);
require(1477);
require(1492);
var _toConsumableArray2 = _interopRequireDefault(require(1194));
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDInputView = _interopRequireDefault(require(46));
var _MDDatePickerView = _interopRequireDefault(require(45));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MDMultSelectView = _interopRequireDefault(require(69));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDSpinnerloaderLayerView = _interopRequireDefault(require(75));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MEFileSettingPanelView = _interopRequireDefault(require(158));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /*
 * @Author: jichao
 * @Date: 2026-07-08 22:00:00
 * @FilePath: \WebContent\javascript\moladisk\views\file\fileinfo\attr\MDEditFileAttrWinView.js
 */
var _ENT_CUSTOMS_CACHE_TTL = 10 * 60 * 1000;
function _getCache() {
  if (!window.__MDEditFileAttrCache__) {
    window.__MDEditFileAttrCache__ = {
      data: null,
      time: 0
    };
  }
  return window.__MDEditFileAttrCache__;
}
var MDEditFileAttrWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDEditFileAttrWinView, _MDWindowView);
  function MDEditFileAttrWinView() {
    (0, _classCallCheck2["default"])(this, MDEditFileAttrWinView);
    return _callSuper(this, MDEditFileAttrWinView, arguments);
  }
  (0, _createClass2["default"])(MDEditFileAttrWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n      <div class=\"edit-file-attr-content\">\n        <div class=\"review-file-info mgb-10\"></div>\n        <div class=\"inv-manager-block mgt-10 f-hide flex-align mgb-20 gap-10\">\n          <div class=\"item-title no-shrink\"><%= BabelStr.str(21215) %>:</div>\n          <div class=\"inv-manager-list gap-10 fullfill flex-align with-wrap\"></div>\n        </div>\n        <div class=\"search-box mgb-10\">\n          <i class=\"icon-search\"></i>\n          <input type=\"text\"\n                 class=\"form-control search-input\"\n                 placeholder=\"<%= BabelStr.str(40201) %>\" />\n        </div>\n        <div class=\"search-result-tip\"></div>\n        <div class=\"attr-list\"></div>\n        <div class=\"form-tip\">\n          <span class=\"required-mark\">*</span><%= BabelStr.str(40226) %>\n        </div>\n\n        <div class=\"review-result-info mgt-10\"></div>\n      </div>\n    ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEditFileAttrWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " edit-file-attr-win");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEditFileAttrWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        onSave: _.noop,
        onClose: _.noop,
        fileId: null,
        fileInfors: [],
        fileAttrs: [],
        fileIds: '',
        fileNames: '',
        applicantName: '',
        reviewMode: false,
        applyId: null,
        status: 0,
        reviewerName: '',
        reviewTime: '',
        _customAttrs: [],
        _filteredAttrs: [],
        _subViews: {},
        _attrValues: {},
        _fileAttrs: {},
        _isEdit: false,
        eventPenetrateSubView: false,
        _loadingCount: 0
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEditFileAttrWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'input .search-input': this._onSearchInput,
        'click .go-ep-manage-btn': this._goToEpManagePage,
        'click .file-name': this._onFileNameClick
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      if (props) {
        _.extend(this, props);
      }
      props.title = this.reviewMode ? BabelStr.str(40207) : BabelStr.str(40207);
      props.size = 'large';
      var okStr = '';
      if (this.fileInfors && this.fileInfors[0] && (this.fileInfors[0].canManageFilePermission() || this.fileInfors[0].isOwner())) {
        okStr = BabelStr.str(154);
      } else {
        okStr = BabelStr.str(12544);
      }
      if (this.reviewMode) {
        if (this.status === 0) {
          props.buttons = [{
            label: BabelStr.str(6918),
            autoClose: false,
            onClick: this._onRejectClick.bind(this)
          }, {
            label: BabelStr.str(6917),
            type: 'done',
            autoClose: false,
            onClick: this._onApproveClick.bind(this)
          }];
        } else {
          props.buttons = [];
        }
      } else {
        props.buttons = [{
          label: BabelStr.str(155),
          onClick: this._onCancelClick.bind(this)
        }, {
          label: okStr,
          type: 'done',
          autoClose: false,
          onClick: this._onSaveClick.bind(this)
        }];
      }
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEditFileAttrWinView.prototype), "initialize", this).call(this, props);
      if (this._isApplyMode()) {
        _MMEnterpriseController["default"].getEditFileApprovers(this.fileInfors[0].getFileId(), function (approverInfos) {
          _this.renderEditManager(approverInfos);
        });
      }
      this._fetchCustomAttrs();
    }
  }, {
    key: "_isApplyMode",
    value: function _isApplyMode() {
      if (this.reviewMode) return false;
      if (!this.fileInfors || !this.fileInfors[0]) return false;
      return !(this.fileInfors[0].canManageFilePermission() || this.fileInfors[0].isOwner());
    }
  }, {
    key: "renderEditManager",
    value: function renderEditManager(managerInfos) {
      if (!managerInfos || !managerInfos.length) {
        return;
      }
      managerInfos = managerInfos.slice(0, 5);
      var tmpl = '';
      _.each(managerInfos, function (user) {
        tmpl += "\n        <div class=\"manager-item flex-align middle\">\n          <div class=\"manager-icon icon no-shrink\"></div>\n          <span class=\"name middle-ellipsis\">".concat(user.name || user.phone, "</span>\n        </div>\n      ");
      });
      this.$(".inv-manager-list").html(tmpl);
      this.$(".inv-manager-block").removeClass("f-hide");
    }
  }, {
    key: "_startLoading",
    value: function _startLoading() {
      this._loadingCount++;
      if (this._loadingCount === 1) {
        _MDSpinnerloaderLayerView["default"].showIn(this.$('.attr-list'), {
          expandParentHeight: true
        });
      }
    }
  }, {
    key: "_stopLoading",
    value: function _stopLoading() {
      this._loadingCount--;
      if (this._loadingCount <= 0) {
        this._loadingCount = 0;
        _MDSpinnerloaderLayerView["default"].clearFrom(this.$('.attr-list'));
      }
    }

    // 企业是否未定义任何自定义属性
  }, {
    key: "_isCustomAttrsEmpty",
    value: function _isCustomAttrsEmpty() {
      return !this._customAttrs || this._customAttrs.length === 0;
    }

    // 企业无自定义属性时的空状态：按是否能登录后台区分提示
  }, {
    key: "_renderEmptyState",
    value: function _renderEmptyState() {
      this._renderReviewResult();
      this._renderReviewFileInfo();
      // 空状态下搜索框、表单提示无意义，隐藏
      this.$('.search-box').hide();
      this.$('.form-tip').hide();
      this.$('.search-result-tip').empty().hide();
      var isAdmin = app.currentUser.isEpManager();
      var html = '<div class="empty-attr-state">';
      if (isAdmin) {
        html += '<div class="empty-attr-tip">' + _.escape(BabelStr.str(40282)) + '</div>';
        html += '<button class="button done go-ep-manage-btn">' + _.escape(BabelStr.str(40284)) + '</button>';
      } else {
        html += '<div class="empty-attr-tip">' + _.escape(BabelStr.str(40283)) + '</div>';
      }
      html += '</div>';
      this.$('.attr-list').html(html);

      // 空状态隐藏整个底部按钮栏
      this.$footer.addClass('f-hide');
    }

    // 跳转到企业后台"文件配置"模块（管理员可见"文件属性"标签）
  }, {
    key: "_goToEpManagePage",
    value: function _goToEpManagePage() {
      var activeIndex = _MEFileSettingPanelView["default"].getFileAttrTabIndex();
      app.pathRouter.openNetTab('/enterpriseIndex.do#evaluation/' + activeIndex);
      this.close();
    }
  }, {
    key: "_onFileNameClick",
    value: function _onFileNameClick($e) {
      $e.stopPropagation();
      var fileId = $($e.target).data("fileid").toString();
      if (fileId === '0' || !fileId) return;
      app.pathRouter.openNewTabByFileId(fileId, function () {});
    }
  }, {
    key: "_fetchCustomAttrs",
    value: function _fetchCustomAttrs() {
      var _this2 = this;
      this._startLoading();
      var now = Date.now();
      var cache = _getCache();
      if (cache.data && now - cache.time < _ENT_CUSTOMS_CACHE_TTL) {
        this._customAttrs = JSON.parse(JSON.stringify(cache.data));
        this._filteredAttrs = (0, _toConsumableArray2["default"])(this._customAttrs);
        if (this._isCustomAttrsEmpty()) {
          this._renderEmptyState();
          this._stopLoading();
          return;
        }
        if (this.reviewMode) {
          this._isEdit = true;
          this._applyReviewFileAttr();
        } else if (this.fileInfors.length === 1) {
          this._isEdit = true;
          this._fetchFileAttr();
        } else {
          this._renderAttrs();
          this._stopLoading();
        }
        return;
      }
      _MMEnterpriseController["default"].getEntCustoms(function (customsCollection) {
        _this2._customAttrs = customsCollection.models.map(function (model) {
          return model.toJSON();
        });
        _this2._filteredAttrs = (0, _toConsumableArray2["default"])(_this2._customAttrs);
        cache.data = JSON.parse(JSON.stringify(_this2._customAttrs));
        cache.time = now;
        if (_this2._isCustomAttrsEmpty()) {
          _this2._renderEmptyState();
          _this2._stopLoading();
          return;
        }
        if (_this2.reviewMode) {
          _this2._isEdit = true;
          _this2._applyReviewFileAttr();
        } else if (_this2.fileInfors.length === 1) {
          _this2._isEdit = true;
          _this2._fetchFileAttr();
        } else {
          _this2._renderAttrs();
          _this2._stopLoading();
        }
      }, function () {
        _this2._stopLoading();
        _MDMessageView["default"].error(BabelStr.str(3525));
      });
    }
  }, {
    key: "_fetchFileAttr",
    value: function _fetchFileAttr() {
      var _this3 = this;
      if (this.fileAttrs && this.fileAttrs.length > 0) {
        this.fileAttrs.forEach(function (attr) {
          _this3._fileAttrs[attr.attrId] = attr;
          _this3._attrValues[attr.attrId] = attr.value;
        });
        this._renderAttrs();
        this._stopLoading();
        return;
      }
      this._startLoading();
      var fileId = this.fileInfors[0].getFileId();
      _MMEnterpriseController["default"].getFileAttr({
        fileIdArr: [fileId]
      }, function (responseData) {
        if (responseData.fileAttrs && responseData.fileAttrs[fileId]) {
          var attrs = responseData.fileAttrs[fileId];
          attrs.forEach(function (attr) {
            _this3._fileAttrs[attr.attrId] = attr;
            _this3._attrValues[attr.attrId] = attr.value;
          });
        }
        _this3._renderAttrs();
        _this3._stopLoading();
      }, function () {
        _this3._stopLoading();
        _MDMessageView["default"].error(BabelStr.str(3525));
        _this3._renderAttrs();
      });
    }
  }, {
    key: "_applyReviewFileAttr",
    value: function _applyReviewFileAttr() {
      var _this4 = this;
      if (this.fileAttrs && this.fileAttrs.length > 0) {
        this.fileAttrs.forEach(function (attr) {
          _this4._fileAttrs[attr.attrId] = attr;
          _this4._attrValues[attr.attrId] = attr.value;
        });
      } else if (this.fileAttrs && this.fileAttrs.attrIds && this.fileAttrs.attrValues) {
        var idArr = String(this.fileAttrs.attrIds).split(';');
        var valArr = String(this.fileAttrs.attrValues).split(';');
        var attrTypeMap = {};
        this._customAttrs.forEach(function (attr) {
          var aId = attr.id || attr.attrId;
          attrTypeMap[aId] = attr.type;
        });
        idArr.forEach(function (attrId, idx) {
          if (attrId && idx < valArr.length) {
            var attrValue = valArr[idx];
            var attrType = attrTypeMap[attrId];
            if (attrType === 5 && attrValue.indexOf(',') > -1) {
              attrValue = attrValue.split(',');
            }
            _this4._fileAttrs[attrId] = {
              attrId: attrId,
              value: attrValue
            };
            _this4._attrValues[attrId] = attrValue;
          }
        });
      }
      this._renderAttrs();
      this._stopLoading();
    }
  }, {
    key: "_renderReviewResult",
    value: function _renderReviewResult() {
      var $reviewInfo = this.$('.review-result-info');
      if (!this.reviewMode || this.status === 0) {
        $reviewInfo.empty();
        return;
      }
      var statusText = this.status === 1 ? BabelStr.str(6917) : BabelStr.str(6918);
      var statusClass = this.status === 1 ? 'review-pass' : 'review-reject';
      $reviewInfo.html("\n      <div class=\"review-result-box ".concat(statusClass, "\">\n        <div class=\"review-result-status mgb-10\">\n          <span class=\"review-status-label\">").concat(BabelStr.str(40245), "\uFF1A</span>\n          <span class=\"review-status-value\">").concat(statusText, "</span>\n        </div>\n        <div class=\"review-result-reviewer mgb-10\">\n          <span class=\"review-reviewer-label\">").concat(BabelStr.str(40246), "\uFF1A</span>\n          <span class=\"review-reviewer-value\">").concat(this.reviewerName || '--', "</span>\n        </div>\n        <div class=\"review-result-time mgb-10\">\n          <span class=\"review-time-label\">").concat(BabelStr.str(40247), "\uFF1A</span>\n          <span class=\"review-time-value\">").concat(this.reviewTime || '--', "</span>\n        </div>\n      </div>\n    "));
    }
  }, {
    key: "_renderReviewFileInfo",
    value: function _renderReviewFileInfo() {
      var $fileInfo = this.$('.review-file-info');
      if (!this.reviewMode || !this.fileNames) {
        $fileInfo.empty();
        return;
      }
      var headerText = BabelStr.str(40285, {
        applicantName: this.applicantName || ''
      });
      $fileInfo.empty();
      $fileInfo.append('<div class="review-file-info-header">' + _.escape(headerText) + '</div>');
      var nameArr = this.fileNames;
      var idArr = this.fileIds ? String(this.fileIds).split(',') : [];
      var items = nameArr.map(function (name, idx) {
        var fid = idArr[idx] || '';
        return '<span class="file-name text-button" data-fileid="' + _.escape(fid) + '">' + _.escape(name) + '</span>';
      });
      $fileInfo.append('<div class="review-file-list">' + items.join('、') + '</div>');
    }
  }, {
    key: "_renderAttrs",
    value: function _renderAttrs() {
      var _this5 = this;
      this._renderReviewResult();
      this._renderReviewFileInfo();
      var $attrList = this.$('.attr-list');
      $attrList.empty();
      this._filteredAttrs.forEach(function (attr, index) {
        var attrId = attr.id || attr.attrId;
        var $item = $("<div class=\"attr-item\" data-attr-id=\"".concat(attrId, "\">\n          <div class=\"attr-title\">\n            <span>").concat(attr.title, "</span>\n            ").concat(attr.notNull ? '<span class="required-mark">*</span>' : '', "\n          </div>\n          <div class=\"attr-input-wrapper\"></div>\n        </div>\n      "));
        $attrList.append($item);
        _this5._createAttrInput(attr, $item.find('.attr-input-wrapper'), attrId);
      });
    }
  }, {
    key: "_createAttrInput",
    value: function _createAttrInput(attr, $container, attrId) {
      var _this6 = this;
      var type = attr.type || 0;
      var altEntries = attr.altEntries || [];
      var fileAttr = this._fileAttrs[attrId];
      var inputView = null;
      switch (type) {
        case 0:
        case 1:
        case 2:
          var inputType = type === 1 ? 'float' : type === 2 ? 'number' : 'string';
          var defaultValue = fileAttr ? fileAttr.value : '';
          var attrMaxLength = attr.maxLength || 100;
          var inputOptions = {
            defaultValue: defaultValue,
            required: !!attr.notNull,
            type: inputType,
            maxLength: attrMaxLength,
            onChange: function onChange(data) {
              _this6._attrValues[attrId] = data.value;
            }
          };
          if (inputType === 'string') {
            inputOptions.helperText = BabelStr.str(40240, {
              num: attrMaxLength
            });
            inputOptions.validator = function (value) {
              if (value.includes(';')) {
                return {
                  valid: false,
                  message: BabelStr.str(40240, {
                    num: attrMaxLength
                  })
                };
              }
              return true;
            };
          }
          inputView = new _MDInputView["default"](inputOptions);
          break;
        case 3:
          inputView = new _MDDatePickerView["default"]({
            required: !!attr.notNull,
            defaultDate: fileAttr && new Date(fileAttr.value),
            onChange: function onChange(data) {
              _this6._attrValues[attrId] = data.timestamp;
            }
          });
          break;
        case 4:
          var dropdownItems = altEntries.map(function (entry, idx) {
            return {
              label: entry.value,
              value: entry.id,
              checked: idx === 0
            };
          });
          inputView = new _MDDropdownSelectListView["default"]({
            selectedIndex: -1,
            dataProvider: dropdownItems,
            onChange: function onChange(selectedItem) {
              _this6._attrValues[attrId] = selectedItem ? selectedItem.value : '';
            }
          });
          if (fileAttr && fileAttr.value !== undefined && fileAttr.value !== null && fileAttr.value !== '') {
            inputView.setSelectedValue(Number(fileAttr.value));
          }
          break;
        case 5:
          var multiselectItems = altEntries.map(function (entry) {
            return {
              label: entry.value,
              value: entry.id,
              checked: false
            };
          });
          inputView = new _MDMultSelectView["default"]({
            items: multiselectItems,
            required: !!attr.notNull
          });
          inputView.on('selectionChange', function (values) {
            _this6._attrValues[attrId] = values;
          });
          if (fileAttr && fileAttr.value !== undefined && fileAttr.value !== null && fileAttr.value !== '') {
            var rawVal = Array.isArray(fileAttr.value) ? fileAttr.value : [fileAttr.value];
            var values = rawVal.map(function (v) {
              return Number(v);
            });
            inputView.setSelectedValues(values);
          }
          break;
        default:
          var defaultVal = fileAttr ? fileAttr.value : '';
          inputView = new _MDInputView["default"]({
            placeholder: '',
            defaultValue: defaultVal,
            required: !!attr.notNull,
            type: 'string',
            onChange: function onChange(data) {
              _this6._attrValues[attrId] = data.value;
            }
          });
      }
      if (inputView) {
        this.addSubView(inputView, $container);
        this._subViews[attrId] = inputView;
      }
    }
  }, {
    key: "_onSearchInput",
    value: function _onSearchInput(e) {
      var _this7 = this;
      // 清除之前的定时器
      if (this._searchTimer) {
        clearTimeout(this._searchTimer);
      }

      // 设置新的定时器，延迟执行
      this._searchTimer = setTimeout(function () {
        var keyword = e.target.value.trim().toLowerCase();
        if (!keyword) {
          _this7._filteredAttrs = (0, _toConsumableArray2["default"])(_this7._customAttrs);
          _this7._updateSearchTip('');
        } else {
          _this7._filteredAttrs = _this7._customAttrs.filter(function (attr) {
            return attr.title.toLowerCase().indexOf(keyword) !== -1;
          });
          if (_this7._filteredAttrs.length > 0) {
            var tip = BabelStr.str(40227).replace('{-num-}', _this7._filteredAttrs.length);
            _this7._updateSearchTip(tip);
          } else {
            _this7._updateSearchTip(BabelStr.str(40228));
          }
        }
        _this7._renderAttrs();
        _this7._searchTimer = null;
      }, 300);
    }
  }, {
    key: "_updateSearchTip",
    value: function _updateSearchTip(text) {
      var $tip = this.$('.search-result-tip');
      $tip.text(text);
      $tip.toggleClass('hidden', !text);
    }
  }, {
    key: "_onCancelClick",
    value: function _onCancelClick() {
      this.close();
      if (_.isFunction(this.onClose)) {
        this.onClose();
      }
    }
  }, {
    key: "_onRejectClick",
    value: function _onRejectClick() {
      this._reviewFileAttrs(false);
    }
  }, {
    key: "_onApproveClick",
    value: function _onApproveClick() {
      if (!this._validateAll()) {
        return;
      }
      this._reviewFileAttrs(true);
    }
  }, {
    key: "_onSaveClick",
    value: function _onSaveClick() {
      if (!this._validateAll()) {
        return;
      }
      this._saveFileAttrs();
    }
  }, {
    key: "_validateAll",
    value: function _validateAll() {
      var _this8 = this;
      var isValid = true;
      this._filteredAttrs.forEach(function (attr) {
        var attrId = attr.id || attr.attrId;
        var subView = _this8._subViews[attrId];
        if (subView && typeof subView.validate === 'function') {
          var viewValid = subView.validate();
          if (!viewValid) {
            isValid = false;
          }
        }
      });
      return isValid;
    }
  }, {
    key: "_saveFileAttrs",
    value: function _saveFileAttrs() {
      var _this9 = this;
      var $saveBtn = this.getActionButtons().eq(1);
      var originalText = $saveBtn.text();
      $saveBtn.text(BabelStr.str(40238)).prop('disabled', true).addClass('disabled');
      var attrIdArr = [];
      var attrValueArr = [];
      this._filteredAttrs.forEach(function (attr) {
        var attrId = attr.id || attr.attrId;
        var value = _this9._attrValues[attrId];
        if (value !== undefined && value !== null) {
          attrIdArr.push(attrId);
          var attrValue = value;
          if (Array.isArray(value)) {
            attrValue = value.join(',');
          }
          attrValueArr.push(attrValue);
        }
      });
      var fids = _.map(this.fileInfors, function (file) {
        return file.getFileId();
      });
      _MMEnterpriseController["default"].updateFilesAttrs({
        fileIdArr: fids,
        attrIdArr: attrIdArr,
        attrValueArr: attrValueArr
      }, function () {
        $saveBtn.text(originalText).prop('disabled', false).removeClass('disabled');
        _MDMessageView["default"].success(BabelStr.str(308), _this9.$body);
        if (_.isFunction(_this9.onSave)) {
          var updatedAttrs = [];
          _this9._filteredAttrs.forEach(function (attr) {
            var attrId = attr.id || attr.attrId;
            var value = _this9._attrValues[attrId];
            if (value !== undefined && value !== null) {
              updatedAttrs.push({
                attrId: attrId,
                valueType: attr.valueType || attr.type,
                title: attr.title,
                type: attr.type,
                value: value
              });
            }
          });
          _this9.onSave(updatedAttrs);
        }
        _this9.close();
      }, function () {
        $saveBtn.text(originalText).prop('disabled', false).removeClass('disabled');
        _MDMessageView["default"].error(BabelStr.str(3525));
      });
    }
  }, {
    key: "_reviewFileAttrs",
    value: function _reviewFileAttrs(reviewResult) {
      var _this10 = this;
      var self = this;
      var btnIndex = reviewResult ? 1 : 0;
      var $btn = this.getActionButtons().eq(btnIndex);
      var originalText = $btn.text();
      $btn.prop('disabled', true).addClass('disabled');
      var attrIdArr = [];
      var attrValueArr = [];
      var fids = _.map(this.fileInfors, function (file) {
        return file.getFileId();
      });
      var updateParams = {
        applyId: this.applyId,
        fileIdArr: fids
      };
      if (reviewResult) {
        this._filteredAttrs.forEach(function (attr) {
          var attrId = attr.id || attr.attrId;
          var value = _this10._attrValues[attrId];
          if (value !== undefined && value !== null) {
            attrIdArr.push(attrId);
            var attrValue = value;
            if (Array.isArray(value)) {
              attrValue = value.join(',');
            }
            attrValueArr.push(attrValue);
          }
        });
        updateParams.attrIdArr = attrIdArr;
        updateParams.attrValueArr = attrValueArr;
      } else {
        updateParams.applyStatus = 2;
      }
      _MMEnterpriseController["default"].updateFilesAttrs(updateParams, function () {
        $btn.text(originalText).prop('disabled', false).removeClass('disabled');
        _MDMessageView["default"].success(BabelStr.str(308));
        _this10.close();
      }, function () {
        $btn.text(originalText).prop('disabled', false).removeClass('disabled');
        _MDMessageView["default"].error(BabelStr.str(3525), _this10.$body);
      });
    }
  }, {
    key: "viewWillUnRendered",
    value: function viewWillUnRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEditFileAttrWinView.prototype), "viewWillUnRendered", this).call(this);
      this._subViews = {};
      this._attrValues = {};
      this._customAttrs = [];
      this._filteredAttrs = [];
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MDEditFileAttrWinView';
    }
  }]);
  return MDEditFileAttrWinView;
}(_MDWindowView2["default"]);

},{"1098":1098,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1194":1194,"1412":1412,"1415":1415,"1417":1417,"1418":1418,"1420":1420,"1421":1421,"1422":1422,"1424":1424,"1426":1426,"1429":1429,"1435":1435,"1436":1436,"1437":1437,"1438":1438,"1439":1439,"1446":1446,"1454":1454,"1461":1461,"1463":1463,"1475":1475,"1477":1477,"1478":1478,"1485":1485,"1492":1492,"1498":1498,"1537":1537,"1541":1541,"1546":1546,"158":158,"45":45,"46":46,"55":55,"67":67,"69":69,"75":75,"93":93}],158:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1466);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMViewBase2 = _interopRequireDefault(require(22));
var _MDTabView = _interopRequireDefault(require(82));
var _MEFileAttrSettingTabPanelView = _interopRequireDefault(require(167));
var _MEEvaluationManageTabPanelView = _interopRequireDefault(require(154));
var _MEFileBlacklistTabPanelView = _interopRequireDefault(require(157));
var _MEFileWhiteLIstTabPanelView = _interopRequireDefault(require(159));
var _MESensitiveRecognizeTabPanelView = _interopRequireDefault(require(162));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 * 文件配置
 * Created by jichao
 * 2020.12.16
 */
var MEFileSettingPanelView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MEFileSettingPanelView, _MMViewBase);
  function MEFileSettingPanelView() {
    (0, _classCallCheck2["default"])(this, MEFileSettingPanelView);
    return _callSuper(this, MEFileSettingPanelView, arguments);
  }
  (0, _createClass2["default"])(MEFileSettingPanelView, [{
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEFileSettingPanelView.prototype), "className", this).call(this);
      return "".concat(superCls, " app-panel ");
    }
  }, {
    key: "tmpl",
    value: function tmpl() {
      return '';
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEFileSettingPanelView.prototype), "events", this).call(this);
      return _.extend(superE, {});
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEFileSettingPanelView.prototype), "initialize", this).call(this, props);
      var activeIndex = props && props.activeIndex || 0;
      activeIndex = parseInt(activeIndex);
      var tabs = [{
        title: BabelStr.str(3006),
        tabPanelView: new _MEEvaluationManageTabPanelView["default"]()
      }, {
        title: BabelStr.str(3727),
        tabPanelView: new _MEFileBlacklistTabPanelView["default"]()
      }, {
        title: BabelStr.str(21939),
        tabPanelView: new _MEFileWhiteLIstTabPanelView["default"]()
      }];
      if (window.user.useAdvancedSearch && app.currentUser.isEpManager()) {
        tabs.push({
          title: BabelStr.str(28189),
          tabPanelView: new _MESensitiveRecognizeTabPanelView["default"]()
        });
      }
      if (app.currentUser.isEpManager()) {
        tabs.push({
          title: BabelStr.str(40200),
          tabPanelView: new _MEFileAttrSettingTabPanelView["default"]()
        });
      }
      tabs[activeIndex].active = true;
      this.fileSettingTabView = new _MDTabView["default"]({
        className: 'person-tabs blue-style-tab pdtb-20',
        tabBarDividerPosition: 2,
        fullMode: false,
        enableActivebar: false,
        tabs: tabs,
        onTabChanged: function onTabChanged(index) {
          window.appRouter.silentNavigateToPath('evaluation/' + index);
        }
      });
      this.addSubView(this.fileSettingTabView);
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEFileSettingPanelView.prototype), "viewDidRendered", this).call(this);
    }

    /**
     * 获取“文件属性”Tab的索引（静态方法，供外部调用）
     * 规则：
     * 0: 评语管理
     * 1: 黑名单
     * 2: 白名单
     * 3: 敏感词（仅当 useAdvancedSearch && isEpManager 时存在）
     * 4: 文件属性（仅当 isEpManager 时存在）
     */
  }], [{
    key: "getFileAttrTabIndex",
    value: function getFileAttrTabIndex() {
      // 文件属性是最后一个 Tab
      // 默认索引为 3（前 3 个 Tab + 可选的敏感词 Tab）
      var index = 3;
      if (window.user.useAdvancedSearch && app.currentUser.isEpManager()) {
        // 如果存在敏感词 Tab，文件属性的索引增加 1
        index = 4;
      }
      return index;
    }
  }]);
  return MEFileSettingPanelView;
}(_MMViewBase2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1466":1466,"1475":1475,"154":154,"157":157,"159":159,"162":162,"167":167,"22":22,"82":82}],167:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
var _MDFileAttrTabelView = _interopRequireDefault(require(164));
var _MDNewCustomeAttrWinView = _interopRequireDefault(require(166));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 * Created by jichao
 * 2026-7-6
 */
var MEFileAttrSettingTabPanelView = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(MEFileAttrSettingTabPanelView, _MDTabPanelView);
  function MEFileAttrSettingTabPanelView() {
    (0, _classCallCheck2["default"])(this, MEFileAttrSettingTabPanelView);
    return _callSuper(this, MEFileAttrSettingTabPanelView, arguments);
  }
  (0, _createClass2["default"])(MEFileAttrSettingTabPanelView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n      <div class=\"header mgb-10 flex-align middle between\">\n        <div class=\"h-title\">".concat(BabelStr.str(40200), "</div>\n        <div class=\"js-per-judge\"><button class=\"button done new-attr-btn\">").concat(BabelStr.str(40202), "</button></div>\n      </div>\n      <div class=\"flex-align end mgb-10 help-block num-block\"></div>\n      <div class=\"table-wrap\"></div>\n    ");
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEFileAttrSettingTabPanelView.prototype), "className", this).call(this);
      return "".concat(superCls, " app-attr-manage-panel pd-20");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEFileAttrSettingTabPanelView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .new-attr-btn': this._newAttr
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEFileAttrSettingTabPanelView.prototype), "initialize", this).call(this, props);
      this.$newAttrBtn = this.$('.new-attr-btn');
      this.tableView = new _MDFileAttrTabelView["default"]({
        $numBlock: this.$(".num-block"),
        onLoadSuccess: function onLoadSuccess(evaluations) {},
        onLoadFailed: function onLoadFailed() {}
      });
      this.addSubView(this.tableView, this.$('.table-wrap')[0]);
      if (!app.currentUser.isEpManager()) {
        this.$(".js-per-judge").remove();
      }
    }
  }, {
    key: "refreshTableView",
    value: function refreshTableView() {
      // this.$newAttrBtn.prop('disabled', true);
      this.tableView.getEntCustoms();
    }
  }, {
    key: "_newAttr",
    value: function _newAttr() {
      var _this = this;
      this.newAttrWin = new _MDNewCustomeAttrWinView["default"]({
        onUpdated: function onUpdated() {
          _this.refreshTableView();
        }
      });
      this.newAttrWin.show();
    }
  }, {
    key: "onActived",
    value: function onActived() {
      if (!this.loaded) {
        this.loaded = true;
        this.refreshTableView();
      }
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEFileAttrSettingTabPanelView.prototype), "viewDidRendered", this).call(this);
    }
  }]);
  return MEFileAttrSettingTabPanelView;
}(_MDTabPanelView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1454":1454,"1463":1463,"1475":1475,"164":164,"166":166,"81":81}],164:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1439);
require(1420);
require(1485);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTableView2 = _interopRequireDefault(require(89));
var _MDFileAttrTableRowView = _interopRequireDefault(require(165));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /*
 * @Author: jichao
 * @Date: 2026-07-07 15:45:10
 * @FilePath: \WebContent\javascript\enterprise\view\fileattr\MDFileAttrTabelView.js
 */
var MDFileAttrTabelView = exports["default"] = /*#__PURE__*/function (_MDTableView) {
  (0, _inherits2["default"])(MDFileAttrTabelView, _MDTableView);
  function MDFileAttrTabelView() {
    (0, _classCallCheck2["default"])(this, MDFileAttrTabelView);
    return _callSuper(this, MDFileAttrTabelView, arguments);
  }
  (0, _createClass2["default"])(MDFileAttrTabelView, [{
    key: "emptyTmpl",
    value: function emptyTmpl() {
      return "<div class=\"m-empty page-empty\" style=\"display: block;padding: 20px 0;\">\n        <p class=\"title\">".concat(BabelStr.str(42889), "</p>\n        <p class=\"info\">").concat(BabelStr.str(42890), "</p>\n      </div>");
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileAttrTabelView.prototype), "className", this).call(this);
      return "".concat(superCls, " table-striped ver-mid-align group-table");
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.pageSize = 99999;
      props = _.extend({
        blankRenderer: function blankRenderer() {
          return _this.emptyTmpl();
        },
        bodyCls: "groupRows",
        rowCls: "row",
        headerCls: "headerWrapper",
        rowClass: _MDFileAttrTableRowView["default"],
        allowSelect: false,
        columns: this.getClumns()
      }, props);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileAttrTabelView.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "getClumns",
    value: function getClumns() {
      var clumnArr = [{
        name: BabelStr.str(40204),
        dataIndex: "title",
        width: 200
      }, {
        name: BabelStr.str(40205),
        dataIndex: "notNull",
        width: 200
      }, {
        name: BabelStr.str(40206),
        dataIndex: "type",
        cellCls: "text-hide",
        width: 200
      }, {
        name: BabelStr.str(40225),
        dataIndex: "altEntries",
        flex: 1
      }];
      if (app.currentUser.isEpManager()) {
        clumnArr.push({
          name: BabelStr.str(217),
          dataIndex: "operate",
          width: 120
        });
      }
      return clumnArr;
    }
  }, {
    key: "searchGroup",
    value: function searchGroup(opt) {
      var num = 0;
      var val = opt.name.toLowerCase();
      this.dataCollection.each(function (group) {
        var name = group.get("groupName").toLowerCase();
        if (!opt.name || name.includes(val)) {
          group.set("hidden", false);
          num++;
        } else {
          group.set("hidden", true);
        }
      });
      this.$numBlock.html(BabelStr.str(40224, {
        num: num
      }));
    }
  }, {
    key: "refreshTableView",
    value: function refreshTableView() {
      this.getEntCustoms();
    }
  }, {
    key: "getEntCustoms",
    value: function getEntCustoms(onSuccess, onFail) {
      var _this2 = this;
      this.startLoadingState();
      MMEnterpriseController.getEntCustoms(function (customsCollection) {
        _this2.clearLoadingState();
        _this2.setDataCollection(customsCollection, true, false);
        _this2.refreshTotalNum();
        _.isFunction(_this2.onLoadSuccess) && _this2.onLoadSuccess(customsCollection);
        _.isFunction(onSuccess) && onSuccess(customsCollection);
      }, function () {
        _this2.clearLoadingState();
        _.isFunction(_this2.onLoadFailed) && _this2.onLoadFailed();
        _.isFunction(onFail) && onFail();
        MDMessageView.error(BabelStr.str(3525));
      });
    }
  }, {
    key: "refreshTotalNum",
    value: function refreshTotalNum() {
      var num = this.dataCollection.length;
      this.$numBlock.html(BabelStr.str(40224, {
        num: num
      }));
    }
  }]);
  return MDFileAttrTabelView;
}(_MDTableView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1420":1420,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"1485":1485,"165":165,"89":89}],165:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1424);
require(1426);
require(1412);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDTableRowView2 = _interopRequireDefault(require(88));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _customAttr = _interopRequireDefault(require(168));
var _MDNewCustomeAttrWinView = _interopRequireDefault(require(166));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDFileAttrTableRowView = exports["default"] = /*#__PURE__*/function (_MDTableRowView) {
  (0, _inherits2["default"])(MDFileAttrTableRowView, _MDTableRowView);
  function MDFileAttrTableRowView() {
    (0, _classCallCheck2["default"])(this, MDFileAttrTableRowView);
    return _callSuper(this, MDFileAttrTableRowView, arguments);
  }
  (0, _createClass2["default"])(MDFileAttrTableRowView, [{
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileAttrTableRowView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        groupModel: null,
        columnRenders: function columnRenders() {
          var clumns = [{
            dataIndex: 'title',
            cellCls: 'name-col'
          }, {
            dataIndex: 'notNull',
            cellCls: 'count-col',
            render: function render(name, attrInfo, index) {
              var notNull = attrInfo.get('notNull');
              return notNull ? BabelStr.str(3355) : BabelStr.str(3356);
            }
          }, {
            dataIndex: 'type',
            cellCls: '',
            render: function render(name, attrInfo, index) {
              var type = attrInfo.get('type');
              return _customAttr["default"].getNameByValue(type);
            }
          }, {
            dataIndex: 'altEntries',
            cellCls: '',
            render: function render(name, attrInfo, index) {
              var altEntries = attrInfo.get('altEntries');
              if (!altEntries || !altEntries.length) {
                return '--';
              }
              return altEntries.map(function (item) {
                return item.value;
              }).join(', ');
            }
          }];
          if (app.currentUser.canManageEpGroup()) {
            clumns.push({
              dataIndex: 'operate',
              cellCls: 'operate-col',
              render: function render(name, attrInfo, index) {
                var id = attrInfo.get('id');
                var aName = attrInfo.get('title');
                return "\n                <button class=\"text-button done edit-btn\">".concat(BabelStr.str(2503), "</button>\n                <button class=\"text-button danger mgl-10 del-btn\" data-id=\"").concat(id, "\"\n                                                                 data-name=\"").concat(aName, "\"\n                                                                 data-index=\"").concat(index, "\">").concat(BabelStr.str(32), "</button>\n              ");
              }
            });
          }
          return clumns;
        }
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileAttrTableRowView.prototype), "initialize", this).call(this, props);
      this.attrInfo = this.rowModel;
      this.listenTo(this.attrInfo, 'change', this._attrModelChanged);
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileAttrTableRowView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .edit-btn': this._editAttrHandler,
        'click .del-btn': this._delAttrHandler,
        "click .name-col": this._editAttrHandler
      });
    }
  }, {
    key: "_editAttrHandler",
    value: function _editAttrHandler() {
      var _this = this;
      var win = new _MDNewCustomeAttrWinView["default"]({
        attrInfo: this.attrInfo,
        onUpdated: function onUpdated() {
          _this.getTableView().refreshTableView();
        }
      });
      win.show();
    }
  }, {
    key: "_delAttrHandler",
    value: function _delAttrHandler($e) {
      var _this2 = this;
      var $button = $($e.target);
      var id = $button.data('id') + '';
      var name = $button.data('name');
      var index = $button.data('index');
      var alert = new _MDAlertView["default"]({
        title: BabelStr.str(220),
        message: BabelStr.str(40223, {
          "name": name
        }) + "\uFF1F",
        buttons: [{
          label: BabelStr.str(3096),
          type: 'done',
          onClick: function onClick() {
            _MMEnterpriseController["default"].deleteCustomEntAttr({
              attrId: id
            }, function () {
              var tableView = _this2.getTableView();
              var group = tableView.dataCollection.at(index);
              tableView.dataCollection.remove(group);
              tableView.refreshTotalNum();
              _MDMessageView["default"].success(BabelStr.str(308));
            }, function () {
              _MDMessageView["default"].error(BabelStr.str(309));
            });
          }
        }, {
          label: BabelStr.str(155)
        }]
      });
      alert.show();
    }
  }, {
    key: "_attrModelChanged",
    value: function _attrModelChanged(groupModel) {
      if (groupModel.hasChanged('groupName')) {
        var name = groupModel.get('groupName');
        this.$('.name-col').empty().append(name);
      } else if (groupModel.hasChanged('memberNum')) {
        var length = groupModel.get('memberNum');
        this.$('.count-col').empty().append(length);
      }
      if (groupModel.hasChanged('hidden')) {
        if (groupModel.get("hidden")) {
          this.$el.hide();
        } else {
          this.$el.show();
        }
      }
    }
  }]);
  return MDFileAttrTableRowView;
}(_MDTableRowView2["default"]);

},{"1098":1098,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1424":1424,"1426":1426,"1454":1454,"1463":1463,"1475":1475,"166":166,"168":168,"32":32,"55":55,"88":88}],166:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1439);
require(1417);
require(1463);
require(1416);
require(1541);
require(1435);
require(1437);
require(1415);
require(1426);
require(1498);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDMultInputWithEditView = _interopRequireDefault(require(47));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDRadioBoxView = _interopRequireDefault(require(66));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDInputView = _interopRequireDefault(require(46));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _customAttr = _interopRequireDefault(require(168));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /*
 * Created on Tue Jul 07 2026
 *
 * created by jichao
 */
var MDNewCustomeAttrWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDNewCustomeAttrWinView, _MDWindowView);
  function MDNewCustomeAttrWinView() {
    (0, _classCallCheck2["default"])(this, MDNewCustomeAttrWinView);
    return _callSuper(this, MDNewCustomeAttrWinView, arguments);
  }
  (0, _createClass2["default"])(MDNewCustomeAttrWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<%if(isEdit){%>\n      <div class=\"auto-save-tip mgb-15\"><%=BabelStr.str(40236)%></div>\n    <%}%>\n    <form class=\"eval-form\">\n      <div class=\"item mgb-15 flex-align start \">\n        <div class=\"item-title no-shrink\"><%=BabelStr.str(40204)%></div>\n        <div class=\"fullfill custom-name-container\"></div>\n      </div>      </form>\n      <%if(isEdit){%>\n        <div class=\"item mgb-15 flex-align start \">\n          <div class=\"item-title no-shrink\"><%=BabelStr.str(40208)%></div>\n          <div class=\"type-display\"></div>\n        </div>\n      <%}%>\n      <div class=\"item mgb-15 flex-align start  group-line flex-align can-pass-group\">\n        <div class=\"item-title no-shrink\"><%=BabelStr.str(40205)%></div>\n        <div class=\"radio-block\">\n        </div>\n      </div>\n      <%if(!isEdit){%>\n        <div class=\"item mgb-15 flex-align start \">\n          <div class=\"item-title no-shrink\"><%=BabelStr.str(40208)%></div>\n          <div class=\"type-select\"></div>\n        </div>\n      <%}%>\n      <div class=\"for-select f-hide flex-align start\">\n        <div class=\"item-title mgb-10\"><%=BabelStr.str(40215)%></div>\n        <div class=\"for-select-content fullfill\"></div>\n      </div>\n    ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDNewCustomeAttrWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        onSuccess: _.noop,
        isEdit: false,
        typeConditions: _customAttr["default"].getTypeConditions(),
        attrInfo: null,
        _saveTimeout: null,
        _altEntryEditTimeout: null,
        _hasChanges: false,
        _savedAltEntryValues: {}
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDNewCustomeAttrWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "input .name": this._nameInputHandle
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDNewCustomeAttrWinView.prototype), "className", this).call(this);
      return superCls + " custome-attr-create-win";
    }
  }, {
    key: "render",
    value: function render(data) {
      data = _.extend(data, {
        isEdit: this.isEdit
      });
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDNewCustomeAttrWinView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.isEdit = !!props.attrInfo;
      props.title = props.isEdit ? BabelStr.str(40207) : BabelStr.str(40202);
      if (!props.isEdit) {
        props.buttons = [{
          id: "savebtn",
          type: "done",
          label: BabelStr.str(6871),
          autoClose: false,
          onClick: function onClick() {
            _this._saveClickHandle();
          }
        }];
      }
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDNewCustomeAttrWinView.prototype), "initialize", this).call(this, props);
      var defaultValue = this.isEdit && this.attrInfo ? this.attrInfo.get("title") : "";
      this.nameInputView = new _MDInputView["default"]({
        defaultValue: defaultValue,
        maxLength: 20,
        required: true,
        type: 'string',
        onChange: function onChange() {
          if (_this.isEdit) {
            _this._scheduleSave();
          }
        }
      });
      this.addSubView(this.nameInputView, this.$(".custom-name-container")[0]);
      if (!this.isEdit) {
        this.conditionSelectView = new _MDDropdownSelectListView["default"]({
          selectedIndex: 0,
          dataProvider: this.typeConditions,
          labelField: "name",
          onChange: function onChange(obj) {
            _this.type = obj.value;
            _this.strategyName = obj.name;
            if (obj.value == 4 || obj.value == 5) {
              _this.toggleOptionsSettingBtn(true);
            } else {
              _this.toggleOptionsSettingBtn(false);
            }
          }
        });
        this.addSubView(this.conditionSelectView, this.$(".type-select")[0]);
        this.type = 0;
      } else {
        var _this$attrInfo;
        this.type = ((_this$attrInfo = this.attrInfo) === null || _this$attrInfo === void 0 ? void 0 : _this$attrInfo.get("type")) || 0;
        var typeName = this.typeConditions.find(function (c) {
          return c.value === _this.type;
        });
        this.$(".type-display").html('<span class="type-text">' + _.escape(typeName ? typeName.name : '') + '</span>');
        if (this.type == 4 || this.type == 5) {
          this.toggleOptionsSettingBtn(true);
        }
      }
      var initialItems = this.isEdit && this.attrInfo ? this.attrInfo.get("altEntries") : [];
      this.multiInput = new _MDMultInputWithEditView["default"]({
        items: initialItems,
        duplicate: false,
        onChange: function onChange(data) {
          if (!_this.isEdit) return;
          switch (data.type) {
            case "add":
              _this._onAltEntryAdd(data.value);
              break;
            case "edit":
              _this._onAltEntryEdit(data.value, data.oldValue);
              break;
            case "remove":
              _this._onAltEntryRemove(data.value);
              break;
            case "reorder":
              _this._onAltEntryReorder(data.items);
              break;
              _onAltEntryEdit;
          }
        },
        onItemBlur: function onItemBlur() {
          if (_this.isEdit) {
            _this._savePendingAltEntry();
          }
        },
        onError: function onError(type, detail) {
          if (type === "maxItems") {
            alert("已达到最大条目数（" + detail + "）");
          } else if (type === "duplicate") {
            alert('条目 "' + detail + '" 已存在');
          }
        }
      });
      this.addSubView(this.multiInput, this.$(".for-select-content"));
      var radioSelected = this.isEdit && this.attrInfo ? this.attrInfo.get("notNull") : 1;
      this.radio = new _MDRadioBoxView["default"]({
        options: [{
          label: BabelStr.str(3355),
          value: 1
        }, {
          label: BabelStr.str(3356),
          value: 0
        }],
        selected: radioSelected,
        onChange: function onChange(value, option) {
          if (_this.isEdit) {
            _this._scheduleSave();
          }
        }
      });
      this.addSubView(this.radio, this.$(".radio-block"), true);
    }
  }, {
    key: "toggleOptionsSettingBtn",
    value: function toggleOptionsSettingBtn(sign) {
      if (sign) {
        this.$(".for-select").removeClass("f-hide");
      } else {
        this.$(".for-select").addClass("f-hide");
      }
    }
  }, {
    key: "_onAltEntryAdd",
    value: function _onAltEntryAdd(item) {
      var _this2 = this;
      var inputItems = this.multiInput.getItems();
      var index = inputItems.findIndex(function (i) {
        return i.id === item.id && i.value === item.value;
      });
      var param = {
        attrId: this.attrInfo.get("id"),
        valueArr: [item.value],
        orderArr: [index]
      };
      _MMEnterpriseController["default"].insertEntAltEntries(param, function (response) {
        if (response && response.altEntryId) {
          _this2._savedAltEntryValues[response.altEntryId] = item.value;
        }
        _this2._hasChanges = true;
        _MDMessageView["default"].success(BabelStr.str(308), _this2.$body);
      });
    }
  }, {
    key: "_onAltEntryEdit",
    value: function _onAltEntryEdit(item, oldValue) {
      var _this3 = this;
      if (this._altEntryEditTimeout) {
        clearTimeout(this._altEntryEditTimeout);
      }
      this._pendingAltEntry = item;
      this._altEntryEditTimeout = setTimeout(function () {
        _this3._savePendingAltEntry();
      }, 5000);
    }
  }, {
    key: "_savePendingAltEntry",
    value: function _savePendingAltEntry() {
      var _this4 = this;
      if (!this._pendingAltEntry) return;
      var item = this._pendingAltEntry;
      this._pendingAltEntry = null;
      var itemId = item.id || "new_".concat(Date.now());
      if (this._savedAltEntryValues[itemId] === item.value) {
        return;
      }
      var inputItems = this.multiInput.getItems();
      var index = inputItems.findIndex(function (i) {
        return i.id === item.id;
      });
      var param = {
        attrId: this.attrInfo.get("id"),
        altIdArr: [item.id],
        valueArr: [item.value],
        orderArr: [index]
      };
      _MMEnterpriseController["default"].updateCustomEntAttrAltEntries(param, function () {
        _this4._savedAltEntryValues[itemId] = item.value;
        _this4._hasChanges = true;
        _MDMessageView["default"].success(BabelStr.str(308), _this4.$body);
      });
    }
  }, {
    key: "_onAltEntryRemove",
    value: function _onAltEntryRemove(item) {
      var _this5 = this;
      var param = {
        attrId: this.attrInfo.get("id"),
        altIdArr: [item.id]
      };
      _MMEnterpriseController["default"].deleteCustomEntAttrAltEntry(param, function () {
        if (item.id) {
          delete _this5._savedAltEntryValues[item.id];
        }
        _this5._hasChanges = true;
        _MDMessageView["default"].success(BabelStr.str(308), _this5.$body);
      });
    }
  }, {
    key: "_onAltEntryReorder",
    value: function _onAltEntryReorder(items) {
      var _this6 = this;
      var param = {
        attrId: this.attrInfo.get("id"),
        altIdArr: items.map(function (item) {
          return item.id;
        }).filter(function (id) {
          return id !== null;
        }),
        orderArr: items.map(function (item, index) {
          return index;
        })
      };
      _MMEnterpriseController["default"].updateCustomEntAttrAltEntryOrders(param, function () {
        _this6._hasChanges = true;
        _MDMessageView["default"].success(BabelStr.str(308), _this6.$body);
      });
    }
  }, {
    key: "_scheduleSave",
    value: function _scheduleSave() {
      var _this7 = this;
      if (this._saveTimeout) {
        clearTimeout(this._saveTimeout);
      }
      this._saveTimeout = setTimeout(function () {
        _this7._autoSave();
      }, 5000);
    }
  }, {
    key: "_autoSave",
    value: function _autoSave() {
      var _this8 = this;
      var title = this.nameInputView.getValue().trim();
      var radioValue = this.radio.getSelected();
      var param = {
        attrId: this.attrInfo.get("id"),
        title: title,
        notNull: radioValue
      };
      _MMEnterpriseController["default"].updateCusttomEntAttr(param, function () {
        _this8._hasChanges = true;
        _MDMessageView["default"].success(BabelStr.str(308), _this8.$body);
      }, function () {});
    }
  }, {
    key: "close",
    value: function close() {
      if (this.isEdit) {
        this._savePendingAltEntry();
        if (this._hasChanges) {
          _.isFunction(this.onUpdated) && this.onUpdated();
        }
      }
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDNewCustomeAttrWinView.prototype), "close", this).call(this);
    }
  }, {
    key: "_saveClickHandle",
    value: function _saveClickHandle() {
      var passed = true;
      if (!this.nameInputView.validate()) {
        passed = false;
      }
      if ((this.type == 4 || this.type == 5) && !this.multiInput.validateNonEmpty()) {
        passed = false;
      }
      if (!passed) {
        return;
      }
      if (!this.attrInfo) {
        this._createAttr();
      } else {
        this._editAttr();
      }
    }
  }, {
    key: "_createAttr",
    value: function _createAttr() {
      var _this9 = this;
      var title = this.nameInputView.getValue().trim();
      var radioValue = this.radio.getSelected();
      var param = {
        title: title,
        notNull: radioValue,
        type: this.type || 0
      };
      _MMEnterpriseController["default"].createCusttomEntAttr(param, function (attrInfo) {
        _this9.attrInfo = attrInfo;
        if (param.type == 4 || param.type == 5) {
          _this9.insertEntAltEntries();
        } else {
          _this9.close();
          _MDMessageView["default"].success(BabelStr.str(308));
          _.isFunction(_this9.onUpdated) && _this9.onUpdated();
        }
      }, function () {});
    }
  }, {
    key: "_editAttr",
    value: function _editAttr() {
      var _this10 = this;
      var title = this.nameInputView.getValue().trim();
      var radioValue = this.radio.getSelected();
      var param = {
        attrId: this.attrInfo.get("id"),
        title: title,
        notNull: radioValue
      };
      _MMEnterpriseController["default"].updateCusttomEntAttr(param, function () {
        _this10.updateEntAltEntries();
      }, function () {});
    }
  }, {
    key: "updateEntAltEntries",
    value: function updateEntAltEntries() {
      var _this11 = this;
      var inputItems = this.multiInput.getItems();
      var altIdArr = inputItems.map(function (item) {
        return item.id;
      }).filter(function (id) {
        return id !== null;
      });
      var valueArr = inputItems.map(function (item) {
        return item.value;
      });
      var orderArr = inputItems.map(function (item, index) {
        return index;
      });
      var param = {
        attrId: this.attrInfo.get("id"),
        altIdArr: altIdArr,
        valueArr: valueArr,
        orderArr: orderArr
      };
      _MMEnterpriseController["default"].updateCustomEntAttrAltEntries(param, function () {
        _this11.close();
        _MDMessageView["default"].success(BabelStr.str(308));
        _.isFunction(_this11.onUpdated) && _this11.onUpdated();
      });
    }
  }, {
    key: "insertEntAltEntries",
    value: function insertEntAltEntries() {
      var _this12 = this;
      var inputItems = this.multiInput.getItems();
      var valueArr = inputItems.map(function (item) {
        return item.value;
      });
      var orderArr = inputItems.map(function (item, index) {
        return index;
      });
      var param = {
        attrId: this.attrInfo.get("id"),
        valueArr: valueArr,
        orderArr: orderArr
      };
      _MMEnterpriseController["default"].insertEntAltEntries(param, function () {
        _this12.close();
        _MDMessageView["default"].success(BabelStr.str(308));
        _.isFunction(_this12.onUpdated) && _this12.onUpdated();
      });
    }
  }]);
  return MDNewCustomeAttrWinView;
}(_MDWindowView2["default"]);

},{"1098":1098,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1415":1415,"1416":1416,"1417":1417,"1426":1426,"1435":1435,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"1498":1498,"1541":1541,"168":168,"46":46,"47":47,"55":55,"66":66,"67":67,"93":93}],168:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1439);
var custom = {
  typeConditions: [{
    value: 0,
    name: BabelStr.str(40209)
  }, {
    value: 1,
    name: BabelStr.str(40210)
  }, {
    value: 2,
    name: BabelStr.str(40211)
  }, {
    value: 3,
    name: BabelStr.str(40212)
  }, {
    value: 4,
    name: BabelStr.str(40213)
  }, {
    value: 5,
    name: BabelStr.str(40214)
  }],
  // 获取整个 typeConditions 数组
  getTypeConditions: function getTypeConditions() {
    return this.typeConditions;
  },
  // 根据 value 查找并返回对应的项（若只需要 name，可改为 return found?.name）
  getByValue: function getByValue(value) {
    return this.typeConditions.find(function (item) {
      return item.value === value;
    });
  },
  // 仅返回名称
  getNameByValue: function getNameByValue(value) {
    var found = this.typeConditions.find(function (item) {
      return item.value === value;
    });
    return found ? found.name : undefined;
  }
};
var _default = exports["default"] = custom;

},{"1417":1417,"1439":1439,"1454":1454,"1463":1463}],162:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1498);
require(1477);
require(1489);
require(1418);
require(1463);
require(1537);
require(1541);
require(1466);
require(1439);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDPaginationView = _interopRequireDefault(require(61));
var _MDSwitchView = _interopRequireDefault(require(79));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _menusvg = _interopRequireDefault(require(1119));
var _MESensitiveFileTableView = _interopRequireDefault(require(161));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MESensitiveRecognizeTabPanelView = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(MESensitiveRecognizeTabPanelView, _MDTabPanelView);
  function MESensitiveRecognizeTabPanelView() {
    (0, _classCallCheck2["default"])(this, MESensitiveRecognizeTabPanelView);
    return _callSuper(this, MESensitiveRecognizeTabPanelView, arguments);
  }
  (0, _createClass2["default"])(MESensitiveRecognizeTabPanelView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n      <div class=\"flex-align middle between\">\n        <div class=\"flex-align middle gap-10\">\n          <span class=\"boldfont\"><%=BabelStr.str(28185)%></span>\n          <div class=\"switch-contain\"></div>\n        </div>\n        <div class=\"button done show-sensitive-file for-opened f-hide\"><%=BabelStr.str(28186)%></div>\n      </div>\n      <div class=\"for-opened f-hide\">\n        <div class=\"boldfont mgt-20\"><%=BabelStr.str(28187)%></div>\n        <div class=\"__input_parent mgt-10 textarea-input\">\n          <textarea name=\"\" placeholder=\"<%=BabelStr.str(28188)%>\" id=\"\" cols=\"\" rows=\"\"  maxlength=\"500\" class=\"form-control sensitive-word\"></textarea>\n        </div>\n        <div class=\"textarea-shower mgt-10 f-hide\">\n        </div>\n\n        <div class=\"help-block mgt-10\"><%=BabelStr.str(28190)%></div>\n        <div class=\"flex-align mgt-20 middle gap-10\">\n          <span class=\"boldfont\"><%=BabelStr.str(28191)%></span>\n          <span class=\"flex-align middle status-block\">\n            <span class=\"status-txt f-hide\"></span>\n            <span class=\"file-error f-hide flex-align middle\" data-tooltip=\"<%=BabelStr.str(28206)%>\"><%=error_cicle%></span>\n          </span>\n          <span class=\"text-button done upload\"><%=BabelStr.str(2006)%></span>\n        </div>\n        <input type=\"file\" class=\"file-input\" style=\"display: none;\" accept=\".txt\">\n        <div class=\"help-block mgt-10\">\n          <div><%=BabelStr.str(28192)%></div>\n          <div><%=BabelStr.str(28193)%></div>\n        </div>\n        <div class=\"boldfont mgt-20\"><%=BabelStr.str(28194)%></div>\n        <div class=\"check-box-group\">\n          <div class=\"flex-align\">\n            <div class=\"type-item flex-align middle\" data-type=\"0\">\n              <div class=\"check-box no-shrink\"></div>\n              <div class=\"name text-hide\"><%=BabelStr.str(28195)%></div>\n            </div>\n          </div>\n          <div class=\"flex-align\">\n            <div class=\"type-item flex-align middle\" data-type=\"1\">\n              <div class=\"check-box no-shrink\"></div>\n              <div class=\"name text-hide\"><%=BabelStr.str(28196)%></div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"boldfont mgt-20 sensitive-file-block\"><%=BabelStr.str(28198)%></div>\n        <div class=\"flex-align between middle mgt-10\">\n          <div class=\"flex-align middle gap-10\">\n          <div class=\"search-box search-box-inline\">\n            <i class=\"icon-search\"></i>\n            <input type=\"text\" class=\"search-input\" placeholder=\"<%=BabelStr.str(28199)%>\">\n          </div>\n          <div class=\"button done search\"><%=BabelStr.str(3491)%></div>\n        </div>\n        <div class=\"button done disabled f-hide\" disabled><%=BabelStr.str(217)%></div>\n        </div>\n        <div class=\"table-wrap mgt-10\"></div>\n      </div>\n\n\n    ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MESensitiveRecognizeTabPanelView.prototype), "className", this).call(this);
      return "".concat(superCls, " sensitive-panel app-file-setting-panel");
    }
  }, {
    key: "render",
    value: function render() {
      var data = {
        error_cicle: _menusvg["default"].error_cicle
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MESensitiveRecognizeTabPanelView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MESensitiveRecognizeTabPanelView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        pageIndex: 0,
        pageSize: 10,
        key: ""
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MESensitiveRecognizeTabPanelView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "mousedown .type-item": this._typeItemClickHandler,
        "change .file-input": this._onFileChanged,
        "click .upload": this._upload,
        "blur .sensitive-word": this._showSensitive,
        "click .textarea-shower": this._inputSensitive,
        "click .search": this._search,
        "click .show-sensitive-file": this.showSensitiveFile,
        "keydown .search-input": this._keyDown
      });
    }
  }, {
    key: "showSensitiveFile",
    value: function showSensitiveFile() {
      this.$(".sensitive-file-block")[0].scrollIntoView({
        behavior: 'smooth' // 平滑滚动，可选 'auto' 立即滚动
      });
    }
  }, {
    key: "_keyDown",
    value: function _keyDown(event) {
      if (event.key === 'Enter') {
        this._search();
      }
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MESensitiveRecognizeTabPanelView.prototype), "initialize", this).call(this, props);
      this.switchView = new _MDSwitchView["default"]({
        onChange: function onChange(state) {
          if (state) {
            _this.$(".for-opened").removeClass("f-hide");
          } else {
            _this.$(".for-opened").addClass("f-hide");
          }
          _this.setEnableBannedWordsFilter(state);
        },
        checked: app.ep.isEnableBannedWordsFilter(),
        className: "tooltipped tooltipped-tc",
        attrs: {
          "aria-label": BabelStr.str(28185)
        }
      });
      this.switchView.renderTo(this.$(".switch-contain"));
      if (app.ep.isEnableBannedWordsFilter()) {
        this.$(".for-opened").removeClass("f-hide");
      } else {
        this.$(".for-opened").addClass("f-hide");
      }
      this.tableView = new _MESensitiveFileTableView["default"]({
        onLoadFailed: function onLoadFailed() {},
        onSort: function onSort() {
          _this.pageIndex = 0;
          _this.refreshTableView();
        }
      });
      this.addSubView(this.tableView, this.$('.table-wrap')[0]);
      this.paginationBarView = new _MDPaginationView["default"]({
        silentInit: true,
        pageSize: this.pageSize,
        onPageChanged: function onPageChanged(curPageIndex) {
          _this._pageChanged(curPageIndex);
        },
        onPageSizeChanged: function onPageSizeChanged(newPageSize) {
          _this.pageSize = newPageSize;
          _this.pageIndex = 0;
          _this.refreshTableView();
        }
      });
      this.addSubView(this.paginationBarView, this.$(".table-wrap")[0]);
      this.listenTo(app.ep, "change", this.epStatusChange);
    }
  }, {
    key: "epStatusChange",
    value: function epStatusChange(ep, opt) {
      if (ep.hasChanged("entAttr")) {
        if (app.ep.isEnableBannedWordsFilter()) {
          this.switchView.open(true);
          this.$(".for-opened").removeClass("f-hide");
        } else {
          this.switchView.close(true);
          this.$(".for-opened").addClass("f-hide");
        }
      }
    }
  }, {
    key: "_search",
    value: function _search() {
      var val = this.$(".search-input").val().trim();
      if (val == this.lastSearch) {
        return;
      }
      this.lastSearch = val;
      this.key = val;
      this.pageIndex = 0;
      this.refreshTableView();
    }
  }, {
    key: "_pageChanged",
    value: function _pageChanged(curPageIndex) {
      this.pageIndex = curPageIndex;
      this.refreshTableView();
    }
  }, {
    key: "refreshTableView",
    value: function refreshTableView() {
      var _this2 = this;
      this.paginationBarView.hide();
      this.tableView.getBannedFiles({
        key: this.key,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex
      }, function (collection, count) {
        _this2.paginationBarView.setLength(count, true, _this2.pageIndex);
        if (count) {
          _this2.paginationBarView.show();
        }
      });
    }
  }, {
    key: "onActived",
    value: function onActived() {
      if (!this.loaded) {
        this.loaded = true;
        this.getEntBannedWords();
        this.refreshTableView();
      }
    }
  }, {
    key: "getEntBannedWords",
    value: function getEntBannedWords() {
      var _this3 = this;
      _MMEnterpriseController["default"].getEntBannedWords(function (data) {
        var strategy = data.strategy;
        if (strategy & 1) {
          _this3.$(".type-item[data-type=\"0\"]").addClass("checked");
        }
        if (strategy & 2) {
          _this3.$(".type-item[data-type=\"1\"]").addClass("checked");
        }
        _this3.$(".sensitive-word").val(data.bannedWords);
        _this3.currentBannedWords = data.bannedWords;
        _this3._showSensitive(undefined, true);
      }, function () {});
    }
  }, {
    key: "_inputSensitive",
    value: function _inputSensitive() {
      this.$(".textarea-shower").addClass("f-hide");
      this.$(".textarea-input").removeClass("f-hide");
      this.$(".sensitive-word").focus();
    }
  }, {
    key: "_showSensitive",
    value: function _showSensitive(e, silent) {
      var _this4 = this;
      var inputValue = this.$(".sensitive-word").val();
      inputValue = inputValue.trim();
      // 使用正则表达式匹配以逗号或空格分隔的单词
      var words = inputValue.match(/[\w\u4e00-\u9fa5]+/g) || [];
      var outputText = '';
      words.forEach(function (word) {
        if (word.length > 10) {
          outputText += "<span class=\"long-word red\">".concat(word, "</span> ");
        } else {
          outputText += word + ' ';
        }
      });
      outputText = outputText.trim();
      this.$(".textarea-shower").html(outputText.trim());
      if (outputText.length) {
        this.$(".textarea-input").addClass("f-hide");
        this.$(".textarea-shower").removeClass("f-hide");
      } else {
        this.$(".textarea-shower").addClass("f-hide");
        this.$(".textarea-input").removeClass("f-hide");
      }
      // inputValue &&
      if (!silent && this.currentBannedWords != inputValue) {
        this.showChangedAlert(function () {
          _this4.updateStrategy(inputValue);
        });
      }
    }
  }, {
    key: "showChangedAlert",
    value: function showChangedAlert(callback) {
      _MDAlertView["default"].showDangerSelection({
        message: BabelStr.str(28236),
        okFun: function okFun() {
          callback();
        }
      });
    }
  }, {
    key: "setEnableBannedWordsFilter",
    value: function setEnableBannedWordsFilter(state) {
      var _this5 = this;
      state = state ? 1 : 0;
      _MMEnterpriseController["default"].setEnableBannedWordsFilter(state, function () {
        _MDMessageView["default"].success(BabelStr.str(308));
        app.ep.setEntattr(14, state);
      }, function (code, msg) {
        _MDMessageView["default"].error(msg);
        if (state) {
          _this5.switchView.close(true);
        } else {
          _this5.switchView.open(true);
        }
        if (!state) {
          _this5.$(".for-opened").removeClass("f-hide");
        } else {
          _this5.$(".for-opened").addClass("f-hide");
        }
      });
    }
  }, {
    key: "_typeItemClickHandler",
    value: function _typeItemClickHandler($e) {
      $($e.target).closest(".type-item").toggleClass("checked");
      this.updateStrategy();
    }
  }, {
    key: "updateStrategy",
    value: function updateStrategy() {
      var _this6 = this;
      if (this.updateStrategyTimer) {
        clearTimeout(this.updateStrategyTimer);
      }
      this.updateStrategyTimer = setTimeout(function () {
        var bannedWords = _this6.$(".sensitive-word").val();
        bannedWords = bannedWords.trim();
        var patt = /(<|>)/;
        if (patt.test(bannedWords)) {
          _MDMessageView["default"].error(BabelStr.str(28239), _this6.$el);
          return;
        }
        var strategy = 0;
        var checkedItems = _this6.$(".type-item.checked");
        for (var i = 0; i < checkedItems.length; i++) {
          var element = checkedItems.eq(i);
          var type = parseInt(element.data("type"));
          strategy = strategy | Math.pow(2, type);
        }
        console.log(strategy);
        _MMEnterpriseController["default"].setOrUpdateEntBannedWords({
          strategy: strategy,
          bannedWords: bannedWords
        }, function () {
          _MDMessageView["default"].success(BabelStr.str(308));
          _this6.currentBannedWords = bannedWords;
        }, function (code, msg) {
          if (code == 2) {
            msg = BabelStr.str(28239);
          }
          _MDMessageView["default"].error(msg);
          // this._inputSensitive()
        });
      }, 400);
    }
  }, {
    key: "_upload",
    value: function _upload() {
      this.$(".file-input").click();
    }
  }, {
    key: "_onFileChanged",
    value: function _onFileChanged(e) {
      var _this7 = this;
      var file = e.target.files[0];
      if (file) {
        // 检查文件扩展名
        var fileName = file.name;
        var fileExt = fileName.split('.').pop().toLowerCase();

        // 检查 MIME 类型（可选）
        var isValidExt = fileExt === 'txt';
        var isValidMime = file.type === 'text/plain' || file.type === '';
        if (!isValidExt || !isValidMime) {
          _MDMessageView["default"].error(BabelStr.str(28204));
          e.target.value = ''; // 清空选择
        }
        var reader = new FileReader();
        reader.onload = function (e) {
          if (!e.target.result.trim()) {
            _this7.$(".file-error").removeClass("f-hide");
          } else {
            _this7.$(".sensitive-word").val(e.target.result.substring(0, 500));
            _this7._inputSensitive();
          }
        };
        reader.onerror = function () {
          alert('读取文件时出错');
        };

        // 以文本形式读取文件
        reader.readAsText(file);
        this.$(".file-error").addClass("f-hide");
        this.$(".status-txt").text(fileName);
        this.$(".status-txt").removeClass("f-hide");
        this.$(".upload").text(BabelStr.str(28205));
      }
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MESensitiveRecognizeTabPanelView.prototype), "viewDidRendered", this).call(this);
    }
  }]);
  return MESensitiveRecognizeTabPanelView;
}(_MDTabPanelView2["default"]);

},{"1098":1098,"1119":1119,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1418":1418,"1439":1439,"1454":1454,"1463":1463,"1466":1466,"1475":1475,"1477":1477,"1489":1489,"1498":1498,"1537":1537,"1541":1541,"161":161,"32":32,"55":55,"61":61,"79":79,"81":81}],161:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTableView2 = _interopRequireDefault(require(89));
var _PropType = _interopRequireDefault(require(90));
var _SortDirection = _interopRequireDefault(require(91));
var _MMNormalCollection = _interopRequireDefault(require(305));
var _MESensitiveFileTableRowView = _interopRequireDefault(require(160));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 * 审批管理table
 * Created by dai
 * 2017.5.15
 */
var MESensitiveFileTableView = exports["default"] = /*#__PURE__*/function (_MDTableView) {
  (0, _inherits2["default"])(MESensitiveFileTableView, _MDTableView);
  function MESensitiveFileTableView() {
    (0, _classCallCheck2["default"])(this, MESensitiveFileTableView);
    return _callSuper(this, MESensitiveFileTableView, arguments);
  }
  (0, _createClass2["default"])(MESensitiveFileTableView, [{
    key: "emptyTmpl",
    value: function emptyTmpl() {
      return "<div class=\"m-empty page-empty\" style=\"display: block;padding: 20px 0;\">\n        <p class=\"title\">".concat(BabelStr.str(28203), "</p>\n      </div>");
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MESensitiveFileTableView.prototype), "className", this).call(this);
      return "".concat(superCls, " table-striped ver-mid-align file-table");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MESensitiveFileTableView.prototype), "events", this).call(this);
      return _.extend(superE, {});
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props = _.extend({
        onAfterSort: _.noop,
        blankRenderer: function blankRenderer() {
          return _this.emptyTmpl();
        },
        bodyCls: 'fileRows',
        rowCls: 'row',
        sortBy: "name",
        sortDesc: _SortDirection["default"].Desc,
        headerCls: 'headerWrapper',
        allowSelect: false,
        rowClass: _MESensitiveFileTableRowView["default"],
        columns: this.getClumns(),
        sorters: [{
          dataIndex: "name",
          direction: _SortDirection["default"].Desc,
          propType: _PropType["default"].String,
          active: true,
          name: BabelStr.str(3128),
          useComparator: false,
          sortFn: function sortFn(direction, dataIndex) {
            _this._sortHandler(direction, dataIndex);
          }
        }, {
          dataIndex: "size",
          direction: _SortDirection["default"].Desc,
          propType: _PropType["default"].Number,
          useComparator: false,
          sortFn: function sortFn(direction, dataIndex) {
            _this._sortHandler(direction, dataIndex);
          }
        }, {
          dataIndex: "fileBelong",
          direction: _SortDirection["default"].Desc,
          propType: _PropType["default"].Number,
          useComparator: false,
          sortFn: function sortFn(direction, dataIndex) {
            _this._sortHandler(direction, dataIndex);
          }
        }, {
          dataIndex: "committerName",
          direction: _SortDirection["default"].Desc,
          propType: _PropType["default"].String,
          useComparator: false,
          sortFn: function sortFn(direction, dataIndex) {
            _this._sortHandler(direction, dataIndex);
          }
        }, {
          dataIndex: "time",
          direction: _SortDirection["default"].Desc,
          propType: _PropType["default"].Date,
          useComparator: false,
          sortFn: function sortFn(direction, dataIndex) {
            _this._sortHandler(direction, dataIndex);
          }
        }]
      }, props);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MESensitiveFileTableView.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "getClumns",
    value: function getClumns() {
      var clumns = [{
        name: BabelStr.str(7153),
        dataIndex: 'name',
        flex: 1
      }, {
        name: BabelStr.str(3278),
        dataIndex: 'size',
        width: 100
      }, {
        name: BabelStr.str(28202),
        dataIndex: 'fileBelong',
        width: 160
      }, {
        name: BabelStr.str(8526),
        dataIndex: 'committerName',
        width: 100
      }, {
        name: BabelStr.str(28085),
        dataIndex: 'time',
        width: 160
      }];
      if (app.currentUser.isEpManager()) {
        clumns.push({
          name: BabelStr.str(217),
          dataIndex: 'operate',
          width: 120
        });
      }
      return clumns;
    }
  }, {
    key: "_sortHandler",
    value: function _sortHandler(direction, dataIndex) {
      console.log(direction);
      this.sortDesc = direction;
      this.sortBy = dataIndex;
      this.onSort();
      // this.getBannedFiles({})
    }
  }, {
    key: "getBannedFiles",
    value: function getBannedFiles(params, onSuccess, onFail) {
      var _this2 = this;
      this.startLoadingState();
      _.extend(this, params);
      _.isFunction(this.beforeRequest) && this.beforeRequest();
      MMEnterpriseController.getBannedFiles({
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
        sort: this.sortBy,
        keyword: this.key,
        order: this.sortDesc.toLowerCase()
      }, function (files, count) {
        _this2.clearLoadingState();
        var collection = new _MMNormalCollection["default"](files);
        _this2.setDataCollection(collection, false, false);
        _.isFunction(_this2.onLoadSuccess) && _this2.onLoadSuccess(files, count);
        _.isFunction(onSuccess) && onSuccess(collection, count);
      }, function () {
        _.isFunction(_this2.onLoadFailed) && _this2.onLoadFailed();
        _.isFunction(onFail) && onFail();
      });
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MESensitiveFileTableView.prototype), "viewDidRendered", this).call(this);
    }
  }]);
  return MESensitiveFileTableView;
}(_MDTableView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"160":160,"305":305,"89":89,"90":90,"91":91}],160:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1437);
require(1541);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDTableRowView2 = _interopRequireDefault(require(88));
var _MDNetDriveFileHandler = _interopRequireDefault(require(1091));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MESensitiveFileTableRowView = exports["default"] = /*#__PURE__*/function (_MDTableRowView) {
  (0, _inherits2["default"])(MESensitiveFileTableRowView, _MDTableRowView);
  function MESensitiveFileTableRowView() {
    (0, _classCallCheck2["default"])(this, MESensitiveFileTableRowView);
    return _callSuper(this, MESensitiveFileTableRowView, arguments);
  }
  (0, _createClass2["default"])(MESensitiveFileTableRowView, [{
    key: "initProps",
    value: function initProps() {
      var _this = this;
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MESensitiveFileTableRowView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        columnRenders: function columnRenders() {
          var clumns = [{
            dataIndex: 'name',
            cellCls: 'name-col text-hide',
            render: function render(name, data, index) {
              var ignoredCls = data.get("ignored") ? "" : "f-hide";
              return "\n              <div class=\"flex-align middle gap-10\">\n                <span class=\"name\">".concat(data.get("fileName"), "</span>\n                <span class=\"red ignored-state ").concat(ignoredCls, "\">").concat(BabelStr.str(28233), "</span>\n              </div>\n            ");
            }
          }, {
            dataIndex: 'size',
            cellCls: 'evaluator-col',
            render: function render(name, data, index) {
              return app.getFileSizeDescription(data.get("size"));
            }
          }, {
            dataIndex: 'fileBelong',
            render: function render(name, data, index) {
              return _this.getFolderType(data.get("fileBelong"));
            }
          }, {
            dataIndex: 'committerName',
            cellCls: 'text-hide',
            render: function render(name, data, index) {
              return data.get("committerName");
            }
          }, {
            dataIndex: 'time',
            render: function render(name, data, index) {
              return new Date(data.get("time")).format("yyyy-MM-dd HH:mm");
            }
          }];
          if (app.currentUser.isEpManager()) {
            clumns.push({
              dataIndex: 'operate',
              cellCls: 'operate-col f-tl',
              render: function render(name, data, index) {
                var ignoredCls = data.get("ignored") ? "f-hide" : "";
                var notdel = data.get("fileBelong") == 0 && data.get("owner") != app.currentUser.getUserId();
                var delCls = notdel ? "f-hide" : "";
                return "\n                <button class=\"text-button done mgr-10 ignore-btn ".concat(ignoredCls, "\">").concat(BabelStr.str(9950), "</button>\n                <button class=\"text-button danger ").concat(delCls, "  delete-btn\">").concat(BabelStr.str(28201), "</button>\n              ");
              }
            });
          }
          return clumns;
        }
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MESensitiveFileTableRowView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .ignore-btn': this._ignore,
        'click .delete-btn': this._del
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MESensitiveFileTableRowView.prototype), "initialize", this).call(this, props);
      this.file = this.rowModel;
    }
  }, {
    key: "getFolderType",
    value: function getFolderType(fileBelong) {
      var num;
      switch (fileBelong) {
        case 0:
          num = 5010;
          break;
        case 1:
          num = 334;
          break;
        case 2:
          num = 12500;
          break;
        case 3:
          num = 28226;
          break;
      }
      return BabelStr.str(num);
    }
  }, {
    key: "_ignore",
    value: function _ignore() {
      var _this2 = this;
      if (this.requesting) {
        return;
      }
      this.requesting = true;
      setTimeout(function () {
        _this2.requesting = false;
      }, 2000);
      _MDAlertView["default"].showDangerSelection({
        message: BabelStr.str(28234),
        okFun: function okFun() {
          _MMEnterpriseController["default"].setBannedIgnoreFile({
            fileId: _this2.file.get("fileId"),
            versionId: _this2.file.get("versionId"),
            ignored: 1
          }, function () {
            _MDMessageView["default"].success(BabelStr.str(308));
            _this2.$(".ignore-btn").addClass("f-hide");
            _this2.$(".ignored-state").removeClass("f-hide");
          }, function (code, msg) {
            _MDMessageView["default"].error(msg);
          });
        }
      });
    }
  }, {
    key: "_del",
    value: function _del() {
      var _this3 = this;
      if (this.requesting) {
        return;
      }
      this.requesting = true;
      setTimeout(function () {
        _this3.requesting = false;
      }, 2000);
      _MDAlertView["default"].showDangerSelection({
        message: BabelStr.str(28235),
        okFun: function okFun() {
          _MMNetDiskDataController["default"].deleteFileById({
            fileId: _this3.file.get("fileId"),
            version: _this3.file.get("version"),
            type: _MDNetDriveFileHandler["default"].DELETEOPTIONS.TO_TRASCH
          }, function () {
            _MDMessageView["default"].success(BabelStr.str(308));
            _this3.getTableView().getBannedFiles();
          }, function (code, msg) {
            if (code == 317) {
              _MMNetDiskDataController["default"].deleteFilesByIds({
                fileArray: [_this3.file.get("fileId")]
              }, function () {
                _MDMessageView["default"].success(BabelStr.str(308));
                _this3.getTableView().getBannedFiles();
              }, function (code, msg) {
                _MDMessageView["default"].error(msg);
              });
            } else {
              _MDMessageView["default"].error(msg);
            }
          });
        }
      });
    }
  }]);
  return MESensitiveFileTableRowView;
}(_MDTableRowView2["default"]);

},{"1091":1091,"1098":1098,"1104":1104,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1437":1437,"1454":1454,"1463":1463,"1475":1475,"1541":1541,"32":32,"55":55,"88":88}],159:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1477);
require(1492);
require(1498);
require(1415);
require(1463);
require(1421);
require(1412);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDEvalutionEditWinView = _interopRequireDefault(require(472));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
var _MEEvaluationTableView = _interopRequireDefault(require(156));
var _MDMessageView = _interopRequireDefault(require(55));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 * 审批管理
 * Created by dai
 * 2017.5.15
 */
var MEFileWhiteLIstTabPanelView = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(MEFileWhiteLIstTabPanelView, _MDTabPanelView);
  function MEFileWhiteLIstTabPanelView() {
    (0, _classCallCheck2["default"])(this, MEFileWhiteLIstTabPanelView);
    return _callSuper(this, MEFileWhiteLIstTabPanelView, arguments);
  }
  (0, _createClass2["default"])(MEFileWhiteLIstTabPanelView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n      <div class=\"help-block\"><%=BabelStr.str(21940)%></div>\n      <div class=\"help-block\"><%=BabelStr.str(21943)%></div>\n      <%if(epManager){%>\n        <div class=\"flex-align input-block\">\n          <input maxlength ='50' placeholder=\"<%=BabelStr.str(21941)%>\" class='form-control ext-input' name=\"\">\n          <button class=\"button done add mgl-10\"><%=BabelStr.str(5031)%></button>\n        </div>\n      <%}%>\n      <div class=\"title mgtb-10\"><%=BabelStr.str(21942)%></div>\n      <div class=\"flex-align input-block\">\n        <input placeholder=\"<%=BabelStr.str(3731)%>\" class='form-control search-input' name=\"\">\n        <button class=\"button search done mgl-10\"><%=BabelStr.str(363)%></button>\n      </div>\n      <div class=\"item-list\"></div>\n    ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEFileWhiteLIstTabPanelView.prototype), "className", this).call(this);
      return "".concat(superCls, " app-file-setting-panel");
    }
  }, {
    key: "render",
    value: function render() {
      var data = {
        epManager: app.currentUser.isEpManager()
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEFileWhiteLIstTabPanelView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEFileWhiteLIstTabPanelView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .del': this._delItem,
        'click .add': this._addItem,
        'click .search': this._search,
        'keyup .ext-input': this.extInputinputHandler,
        'keyup .search-input': this.searchInputinputHandler
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEFileWhiteLIstTabPanelView.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "extInputinputHandler",
    value: function extInputinputHandler($e) {
      var code = $e.which;
      // $e.target.value = $e.target.value.replace(/；/g, ';');
      var regex = /[^a-zA-Z0-9]/g;
      $e.target.value = $e.target.value.replace(regex, '');
      if (code == 13) {
        this._addItem();
      }
    }
  }, {
    key: "searchInputinputHandler",
    value: function searchInputinputHandler($e) {
      var code = $e.which;
      if (code == 13) {
        this._search();
      }
    }
  }, {
    key: "_addItem",
    value: function _addItem() {
      var _this = this;
      var ext = this.$('.ext-input').val() || '';
      ext = ext.trim();
      if (ext.length) {
        var old = _.findWhere(this.datas, {
          ext: ext
        });
        if (old) {
          _MDMessageView["default"].error(BabelStr.str(3736));
          return;
        }
        MMEnterpriseController.addFileWhiteList(ext, function () {
          _this.loadList();
          _this.$('.ext-input').val('');
          _MDMessageView["default"].success(BabelStr.str(308));
        }, function () {
          _MDMessageView["default"].error(BabelStr.str(309));
        });
      }
    }
  }, {
    key: "_search",
    value: function _search() {
      var ext = this.$('.search-input').val() || '';
      ext = ext.trim();
      if (!ext.length) {
        this.renderDataList(this.datas);
      } else {
        var datas = _.filter(this.datas, function (item) {
          return item.ext.indexOf(ext) > -1;
        });
        this.renderDataList(datas);
      }
    }
  }, {
    key: "onActived",
    value: function onActived() {
      if (!this.loaded) {
        this.loaded = true;
        this.loadList();
      }
    }
  }, {
    key: "loadList",
    value: function loadList() {
      var _this2 = this;
      MMEnterpriseController.getFileWhiteList(function (datas) {
        _this2.datas = datas;
        _this2.renderDataList(datas);
      });
    }
  }, {
    key: "_delItem",
    value: function _delItem($e) {
      var _this3 = this;
      var id = $($e.target).data('id');
      MMEnterpriseController.delFileBlackList(id, function () {
        $($e.target).closest('.item').remove();
        _this3.datas = _.filter(_this3.datas, function (item) {
          return item.id != id;
        });
        _MDMessageView["default"].success(BabelStr.str(308));
      }, function () {
        _MDMessageView["default"].success(BabelStr.str(309));
      });
    }
  }, {
    key: "renderDataList",
    value: function renderDataList(datas) {
      var tmpl = '';
      var isEpManager = app.currentUser.isEpManager();
      _.each(datas, function (item) {
        var ext = _.escape(item.ext);
        var str = '';
        if (isEpManager) {
          str = "<div class=\"del icon\" data-id=\"".concat(item.id, "\"></div>");
        }
        tmpl += "<div class=\"item flex-align between\" >\n        <div class=\"fullfill\">".concat(ext, "</div>\n        ").concat(str, "\n      </div>");
      });
      this.$('.item-list').html(tmpl);
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEFileWhiteLIstTabPanelView.prototype), "viewDidRendered", this).call(this);
    }
  }]);
  return MEFileWhiteLIstTabPanelView;
}(_MDTabPanelView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1415":1415,"1421":1421,"1454":1454,"1463":1463,"1475":1475,"1477":1477,"1492":1492,"1498":1498,"156":156,"472":472,"55":55,"81":81}],157:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1477);
require(1492);
require(1498);
require(1415);
require(1463);
require(1421);
require(1412);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDEvalutionEditWinView = _interopRequireDefault(require(472));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
var _MEEvaluationTableView = _interopRequireDefault(require(156));
var _MDMessageView = _interopRequireDefault(require(55));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 * 审批管理
 * Created by dai
 * 2017.5.15
 */
var MEFileBlacklistTabPanelView = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(MEFileBlacklistTabPanelView, _MDTabPanelView);
  function MEFileBlacklistTabPanelView() {
    (0, _classCallCheck2["default"])(this, MEFileBlacklistTabPanelView);
    return _callSuper(this, MEFileBlacklistTabPanelView, arguments);
  }
  (0, _createClass2["default"])(MEFileBlacklistTabPanelView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n      <div class=\"help-block\"><%=BabelStr.str(3728)%></div>\n      <div class=\"help-block\"><%=BabelStr.str(12119)%></div>\n      <%if(epManager){%>\n        <div class=\"flex-align input-block\">\n          <input maxlength ='50' placeholder=\"<%=BabelStr.str(3729)%>\" class='form-control ext-input' name=\"\">\n          <button class=\"button done add mgl-10\"><%=BabelStr.str(5031)%></button>\n        </div>\n      <%}%>\n      <div class=\"title mgtb-10\"><%=BabelStr.str(3730)%></div>\n      <div class=\"flex-align input-block\">\n        <input placeholder=\"<%=BabelStr.str(3731)%>\" class='form-control search-input' name=\"\">\n        <button class=\"button search done mgl-10\"><%=BabelStr.str(363)%></button>\n      </div>\n      <div class=\"item-list\"></div>\n    ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEFileBlacklistTabPanelView.prototype), "className", this).call(this);
      return "".concat(superCls, " app-file-setting-panel");
    }
  }, {
    key: "render",
    value: function render() {
      var data = {
        epManager: app.currentUser.isEpManager()
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEFileBlacklistTabPanelView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEFileBlacklistTabPanelView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .del': this._delItem,
        'click .add': this._addItem,
        'click .search': this._search,
        'keyup .ext-input': this.extInputinputHandler,
        'keyup .search-input': this.searchInputinputHandler
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEFileBlacklistTabPanelView.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "extInputinputHandler",
    value: function extInputinputHandler($e) {
      var code = $e.which;
      // $e.target.value = $e.target.value.replace(/；/g, ';');
      var regex = /[^a-zA-Z0-9]/g;
      $e.target.value = $e.target.value.replace(regex, '');
      if (code == 13) {
        this._addItem();
      }
    }
  }, {
    key: "searchInputinputHandler",
    value: function searchInputinputHandler($e) {
      var code = $e.which;
      if (code == 13) {
        this._search();
      }
    }
  }, {
    key: "_addItem",
    value: function _addItem() {
      var _this = this;
      var ext = this.$('.ext-input').val() || '';
      ext = ext.trim();
      if (ext.length) {
        var old = _.findWhere(this.datas, {
          ext: ext
        });
        if (old) {
          _MDMessageView["default"].error(BabelStr.str(3732));
          return;
        }
        MMEnterpriseController.addFileBlackList(ext, function () {
          _this.loadList();
          _this.$('.ext-input').val('');
          _MDMessageView["default"].success(BabelStr.str(308));
        }, function () {
          _MDMessageView["default"].error(BabelStr.str(309));
        });
      }
    }
  }, {
    key: "_search",
    value: function _search() {
      var ext = this.$('.search-input').val() || '';
      ext = ext.trim();
      if (!ext.length) {
        this.renderDataList(this.datas);
      } else {
        var datas = _.filter(this.datas, function (item) {
          return item.ext.indexOf(ext) > -1;
        });
        this.renderDataList(datas);
      }
    }
  }, {
    key: "onActived",
    value: function onActived() {
      if (!this.loaded) {
        this.loaded = true;
        this.loadList();
      }
    }
  }, {
    key: "loadList",
    value: function loadList() {
      var _this2 = this;
      MMEnterpriseController.getFileBlackList(function (datas) {
        _this2.datas = datas;
        _this2.renderDataList(datas);
      });
    }
  }, {
    key: "_delItem",
    value: function _delItem($e) {
      var _this3 = this;
      var id = $($e.target).data('id');
      MMEnterpriseController.delFileBlackList(id, function () {
        $($e.target).closest('.item').remove();
        _this3.datas = _.filter(_this3.datas, function (item) {
          return item.id != id;
        });
        _MDMessageView["default"].success(BabelStr.str(308));
      }, function () {
        _MDMessageView["default"].success(BabelStr.str(309));
      });
    }
  }, {
    key: "renderDataList",
    value: function renderDataList(datas) {
      var tmpl = '';
      var isEpManager = app.currentUser.isEpManager();
      _.each(datas, function (item) {
        var ext = _.escape(item.ext);
        var str = '';
        if (isEpManager) {
          str = "<div class=\"del icon\" data-id=\"".concat(item.id, "\"></div>");
        }
        tmpl += "<div class=\"item flex-align between\" >\n        <div class=\"fullfill\">".concat(ext, "</div>\n        ").concat(str, "\n      </div>");
      });
      this.$('.item-list').html(tmpl);
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEFileBlacklistTabPanelView.prototype), "viewDidRendered", this).call(this);
    }
  }]);
  return MEFileBlacklistTabPanelView;
}(_MDTabPanelView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1415":1415,"1421":1421,"1454":1454,"1463":1463,"1475":1475,"1477":1477,"1492":1492,"1498":1498,"156":156,"472":472,"55":55,"81":81}],154:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDEvalutionEditWinView = _interopRequireDefault(require(472));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
var _MEEvaluationTableView = _interopRequireDefault(require(156));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 * 审批管理
 * Created by dai
 * 2017.5.15
 */
var MEEvaluationManageTabPanelView = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(MEEvaluationManageTabPanelView, _MDTabPanelView);
  function MEEvaluationManageTabPanelView() {
    (0, _classCallCheck2["default"])(this, MEEvaluationManageTabPanelView);
    return _callSuper(this, MEEvaluationManageTabPanelView, arguments);
  }
  (0, _createClass2["default"])(MEEvaluationManageTabPanelView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n      <div class=\"header f-clb\">\n        <div class=\"f-fl h-title\">".concat(BabelStr.str(3185), "</div>\n        <div class=\"f-fr js-per-judge\"><button class=\"button done new-eval-btn\" disabled>").concat(BabelStr.str(3186), "</button></div>\n      </div>\n      <div class=\"table-wrap\"></div>\n    ");
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEEvaluationManageTabPanelView.prototype), "className", this).call(this);
      return "".concat(superCls, " app-eval-manage-panel");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEEvaluationManageTabPanelView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .new-eval-btn': this._newEvaluate
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEEvaluationManageTabPanelView.prototype), "initialize", this).call(this, props);
      this.$newEvaluateBtn = this.$('.new-eval-btn');
      this.tableView = new _MEEvaluationTableView["default"]({
        onLoadSuccess: function onLoadSuccess(evaluations) {
          _this.$newEvaluateBtn.prop('disabled', false);
        },
        onLoadFailed: function onLoadFailed() {}
      });
      this.addSubView(this.tableView, this.$('.table-wrap')[0]);
      if (!app.currentUser.canManageEpEvaluation()) {
        this.$(".js-per-judge").remove();
      }
    }
  }, {
    key: "refreshTableView",
    value: function refreshTableView() {
      this.$newEvaluateBtn.prop('disabled', true);
      this.tableView.requestUser();
    }
  }, {
    key: "_newEvaluate",
    value: function _newEvaluate() {
      var _this2 = this;
      this.newEvaluationWin = new _MDEvalutionEditWinView["default"]({
        onSuccess: function onSuccess() {
          _this2.refreshTableView();
        }
      });
      this.newEvaluationWin.show();
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEEvaluationManageTabPanelView.prototype), "viewDidRendered", this).call(this);
      this.refreshTableView();
    }
  }]);
  return MEEvaluationManageTabPanelView;
}(_MDTabPanelView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1454":1454,"1463":1463,"1475":1475,"156":156,"472":472,"81":81}],156:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTableView2 = _interopRequireDefault(require(89));
var _MEEvaluationTableRowView = _interopRequireDefault(require(155));
var _MDMessageView = _interopRequireDefault(require(55));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 * 审批管理table
 * Created by dai
 * 2017.5.15
 */
var MEReviewTableView = exports["default"] = /*#__PURE__*/function (_MDTableView) {
  (0, _inherits2["default"])(MEReviewTableView, _MDTableView);
  function MEReviewTableView() {
    (0, _classCallCheck2["default"])(this, MEReviewTableView);
    return _callSuper(this, MEReviewTableView, arguments);
  }
  (0, _createClass2["default"])(MEReviewTableView, [{
    key: "emptyTmpl",
    value: function emptyTmpl() {
      return "<div class=\"m-empty page-empty\" style=\"display: block;padding: 20px 0;\">\n        <p class=\"title\">".concat(BabelStr.str(4614), "</p>\n        <p class=\"info\">").concat(BabelStr.str(4615), "</p>\n      </div>");
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEReviewTableView.prototype), "className", this).call(this);
      return "".concat(superCls, " table-striped ver-mid-align evaluation-table");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEReviewTableView.prototype), "events", this).call(this);
      return _.extend(superE, {});
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props = _.extend({
        blankRenderer: function blankRenderer() {
          return _this.emptyTmpl();
        },
        bodyCls: 'evalRows',
        rowCls: 'row',
        headerCls: 'headerWrapper',
        allowSelect: false,
        rowClass: _MEEvaluationTableRowView["default"],
        columns: this.getClumns()
      }, props);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEReviewTableView.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "getClumns",
    value: function getClumns() {
      var clumns = [{
        name: BabelStr.str(3190),
        dataIndex: 'name',
        width: 200
      }, {
        name: BabelStr.str(3191),
        dataIndex: 'evaluator',
        flex: 1
      }, {
        name: BabelStr.str(3192),
        dataIndex: 'usedCount',
        width: 120
      }];
      if (app.currentUser.canManageEpEvaluation()) {
        clumns.push({
          name: BabelStr.str(217),
          dataIndex: 'operate',
          width: 120
        });
      }
      return clumns;
    }
  }, {
    key: "requestUser",
    value: function requestUser(onSuccess, onFail) {
      var _this2 = this;
      this.startLoadingState();
      _MMEnterpriseController["default"].getAllEvaluationTmpls(function (evaluations) {
        _this2.clearLoadingState();
        _this2.setDataCollection(evaluations, true, false);
        _.isFunction(_this2.onLoadSuccess) && _this2.onLoadSuccess(evaluations);
        _.isFunction(onSuccess) && onSuccess(evaluations);
      }, function () {
        _this2.clearLoadingState();
        _.isFunction(_this2.onLoadFailed) && _this2.onLoadFailed();
        _.isFunction(onFail) && onFail();
        _MDMessageView["default"].error(BabelStr.str(3523));
      });
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEReviewTableView.prototype), "viewDidRendered", this).call(this);
    }
  }]);
  return MEReviewTableView;
}(_MDTableView2["default"]);

},{"1098":1098,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1454":1454,"1463":1463,"1475":1475,"155":155,"55":55,"89":89}],155:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1426);
require(1412);
require(1439);
require(1424);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTableRowView2 = _interopRequireDefault(require(88));
var _MDEvalutionEditWinView = _interopRequireDefault(require(472));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDMessageView = _interopRequireDefault(require(55));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MEEvaluationTableRowView = exports["default"] = /*#__PURE__*/function (_MDTableRowView) {
  (0, _inherits2["default"])(MEEvaluationTableRowView, _MDTableRowView);
  function MEEvaluationTableRowView() {
    (0, _classCallCheck2["default"])(this, MEEvaluationTableRowView);
    return _callSuper(this, MEEvaluationTableRowView, arguments);
  }
  (0, _createClass2["default"])(MEEvaluationTableRowView, [{
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEEvaluationTableRowView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        evalModel: null,
        columnRenders: function columnRenders() {
          var clumns = [{
            dataIndex: 'name',
            cellCls: 'name-col text-hide'
          }, {
            dataIndex: 'evaluator',
            cellCls: 'evaluator-col flex-align with-wrap gap-10',
            render: function render(name, evalInfo, index) {
              var steps = evalInfo.get("steps");
              var renderStr = '';
              var groups = _.map(steps, function (step) {
                return step.groups;
              });
              groups = _.flatten(groups);
              groups = _.compact(groups);
              groups = groups || [];
              var groupNames = _.map(groups, function (group) {
                return "<div class=\"user-item-with-type\" usrId=".concat(group.groupId, ">\n                <span class=\"icon grp-s-icon\"></span>\n                <span class=\"user-name text-button\">").concat(group.name, "</span>\n              </div>");
              });
              var users = _.map(steps, function (step) {
                return step.users;
              });
              users = _.flatten(users);
              var userNames = _.map(users, function (user) {
                return "<div class=\"user-item-with-type\" usrId=".concat(user.id, ">\n                <span class=\"icon user-s-icon\"></span>\n                <span class=\"user-name text-button\">").concat(user.name, "</span>\n              </div>");
              });
              var roles = _.map(steps, function (step) {
                return step.roles;
              });
              roles = _.flatten(roles);
              var roleNames = _.map(roles, function (role) {
                return "<span class=\"main-color\">".concat(role.name, "</span>");
              });
              renderStr = groupNames.join('') + userNames.join('') + roleNames.join('');
              return renderStr;
            }
          }, {
            dataIndex: 'usedCount',
            cellCls: 'usedCount-col'
          }];
          if (app.currentUser.canManageEpEvaluation()) {
            clumns.push({
              dataIndex: 'operate',
              cellCls: 'operate-col',
              render: function render(name, evalInfo, index) {
                var id = evalInfo.get("id");
                var eName = evalInfo.getName();
                return "\n                <button class=\"text-button done edit-eval-btn\">".concat(BabelStr.str(2503), "</button>\n                <button class=\"text-button danger mgl-10 delete-eval-btn\" data-id=\"").concat(id, "\"\n                                                                 data-name=\"").concat(eName, "\"\n                                                                 data-index=\"").concat(index, "\">").concat(BabelStr.str(32), "</button>\n              ");
              }
            });
          }
          return clumns;
        }
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEEvaluationTableRowView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .edit-eval-btn': this._editEvaluation,
        'click .delete-eval-btn': this._deleteEvaluation,
        'click': this._editEvaluation
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEEvaluationTableRowView.prototype), "initialize", this).call(this, props);
      this.evalModel = this.rowModel;
      this.listenTo(this.evalModel, 'change', this._evalModelChanged);
    }
  }, {
    key: "_editEvaluation",
    value: function _editEvaluation(e) {
      var _this = this;
      console.log(this);
      e.stopPropagation();
      if (!app.currentUser.canManageEpEvaluation()) {
        return;
      }
      var win = new _MDEvalutionEditWinView["default"]({
        isEdit: true,
        evalModel: this.evalModel,
        onSuccess: function onSuccess() {
          _this.getTableView().requestUser();
        }
      });
      win.show();
    }
  }, {
    key: "_deleteEvaluation",
    value: function _deleteEvaluation($e) {
      var _this2 = this;
      $e.stopPropagation();
      var $button = $($e.target);
      var tmplId = $button.data('id') + '';
      var name = this.rowModel.getName();
      var alert = new _MDAlertView["default"]({
        title: BabelStr.str(220),
        message: BabelStr.str(3187, {
          "name": name
        }) + "\uFF1F",
        buttons: [{
          label: BabelStr.str(3096),
          type: 'done',
          onClick: function onClick() {
            _MMEnterpriseController["default"].deleteEvaluationTmpl(tmplId, function () {
              var tableView = _this2.getTableView();
              var evaluation = tableView.dataCollection.findWhere({
                id: tmplId
              });
              tableView.dataCollection.remove(evaluation);
            }, function () {
              _MDMessageView["default"].error(BabelStr.str(3522));
            });
          }
        }, {
          label: BabelStr.str(155)
        }]
      });
      alert.show();
    }
  }, {
    key: "_evalModelChanged",
    value: function _evalModelChanged(evalModel, model) {
      if (evalModel.hasChanged('name')) {
        var name = evalModel.getName();
        this.$('.name-col').empty().append(name);
      } else if (evalModel.hasChanged('evaluatorGroups')) {
        var evaluators = evalModel.getEvaluatorGroups();
        var renderStr = '';
        _.each(evaluators, function (userArrays) {
          _.each(userArrays, function (userInfo) {
            renderStr += "<span>".concat(userInfo.name, "</span>");
          });
        });
        this.$('.evaluator-col').empty().append(renderStr);
      }
    }
  }]);
  return MEEvaluationTableRowView;
}(_MDTableRowView2["default"]);

},{"1098":1098,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1424":1424,"1426":1426,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"32":32,"472":472,"55":55,"88":88}],472:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1421);
require(1461);
require(1439);
require(1437);
require(1463);
require(1478);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDEvaluterListView = _interopRequireDefault(require(471));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDMessageView = _interopRequireDefault(require(55));
var _ErrorCode = _interopRequireDefault(require(1087));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // MDEvalutionEditWinView.js
// jichao
// 2017-5-15
var MDEvalutionEditWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDEvalutionEditWinView, _MDWindowView);
  function MDEvalutionEditWinView() {
    (0, _classCallCheck2["default"])(this, MDEvalutionEditWinView);
    return _callSuper(this, MDEvalutionEditWinView, arguments);
  }
  (0, _createClass2["default"])(MDEvalutionEditWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<form class=\"eval-form\">\n            <div class=\"header-block help-block tip-word\">\n              <%=tip%>\n            </div>\n            <div class=\"name-block flex-align between\">\n              <div class=\"title-left\"><%=name%></div>\n              <div class=\"right\">\n                <input type=\"text\" class=\"form-control name notempty\" placeholder=\"<%=placeholder%>\" required maxlength=\"60\" />\n              </div>\n            </div>\n            <div class=\"main-block\"></div>\n\n            </form>\n            ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvalutionEditWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        data: {
          name: BabelStr.str(3190),
          // '流程名称',
          onSuccess: _.noop,
          isEdit: false,
          dataCollection: [],
          evalModel: null,
          tip: BabelStr.str(541),
          // 添加的审批流程在文件审批时可以直接选择，并快速开启审批
          placeholder: BabelStr.str(542) // 为流程取个名字，方便使用
        }
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvalutionEditWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'input .name': this._nameInputHandle
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvalutionEditWinView.prototype), "className", this).call(this);
      return superCls + ' evalution-edit-win';
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.size = 'large';
      props.buttons = [{
        id: 'savebtn',
        type: 'done',
        label: BabelStr.str(3080),
        // '保存',
        autoClose: false,
        onClick: function onClick() {
          _this._saveClickHandle();
        }
      }];
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvalutionEditWinView.prototype), "initialize", this).call(this, props);
      this.$form = this.$('.eval-form');
      this.$form.validate({
        highlight: function highlight(element, errorClass, validClass) {
          if ($(element).closest('.choosed').length) {
            $(element).closest('.choosed').removeClass(validClass).addClass(errorClass);
          } else {
            $(element).removeClass(validClass).addClass(errorClass);
          }
        },
        unhighlight: function unhighlight(element, errorClass, validClass) {
          if ($(element).closest('.choosed').length) {
            $(element).closest('.choosed').removeClass(errorClass).addClass(validClass);
          } else {
            $(element).removeClass(errorClass).addClass(validClass);
          }
        },
        errorPlacement: function errorPlacement(error, element) {
          if (element.attr('name') && element.attr('name').indexOf('evalter-choose-panel') > -1) {
            error.appendTo(element.closest(".input-block"));
            element.closest('.choosed').addClass('validate-error');
          } else {
            element.after(error);
          }
        }
      });
      if (!this.isEdit) {
        this.title = BabelStr.str(3186); // "添加审批流程";
      } else {
        this.title = BabelStr.str(543); // "修改审批流程";
      }
    }
  }, {
    key: "setEvalutionInfo",
    value: function setEvalutionInfo(data) {
      // newData.clone()
      this.evalModel = data;
      var newData = JSON.parse(JSON.stringify(data));
      this.name = newData.name;
      this.$('.name').val(_.unescape(this.name));
      this.evaluterListView.renderEvalution(newData.steps, newData.finalizedStep);
    }
  }, {
    key: "_nameInputHandle",
    value: function _nameInputHandle() {
      this.name = _.escape(this.$(".name").val().toString());
    }
  }, {
    key: "addRuleForNewItem",
    value: function addRuleForNewItem(itemView) {
      var $input = itemView.getItemInput();
      $input.rules('add', {
        requiredMember: true
      });
    }
  }, {
    key: "_saveClickHandle",
    value: function _saveClickHandle() {
      var _this2 = this;
      var validator = this.$form.validate();
      var evaluatorTmplObj = this.evaluterListView.getEvaluatorGroups();
      if (validator.form()) {
        if (!evaluatorTmplObj.steps.length) {
          _MDMessageView["default"].error(BabelStr.str(4616), this.$body[0]);
          this.$commitBtn.prop('disabled', false);
          this.$commitBtn.text(BabelStr.str(531));
          return;
        }
        this.$("#savebtn").prop("disabled", true);
        if (this.isEdit) {
          var id = this.evalModel.get("id");
          MMEnterpriseController.updateEvaluationTmpl(id, this.name, evaluatorTmplObj.steps, evaluatorTmplObj.finalizedStep, function () {
            console.log("success");
            _this2.onSuccess();
            _this2.close();
            _this2.$("#savebtn").prop("disabled", false);
          }, function (errCode) {
            if (errCode == _ErrorCode["default"].Eval_Tmpl_Exist) {
              var hasExist = BabelStr.str(544); // 模板名已存在
              _MDMessageView["default"].error(hasExist, _this2.$body);
            } else {
              var fail = BabelStr.str(545); // 保存失败，请重试
              _MDMessageView["default"].error(fail, _this2.$body);
            }
            _this2.$("#savebtn").prop("disabled", false);
          });
        } else {
          MMEnterpriseController.createEvaluationTmpl(this.name, evaluatorTmplObj.steps, evaluatorTmplObj.finalizedStep, 1, function () {
            _this2.onSuccess();
            console.log("添加成功");
            _this2.$("#savebtn").prop("disabled", false);
            _this2.close();
          }, function (errCode) {
            if (errCode == _ErrorCode["default"].Eval_Tmpl_Exist) {
              var hasExist = BabelStr.str(544); // 模板名已存在
              _MDMessageView["default"].error(hasExist, _this2.$body);
            } else {
              var fail = BabelStr.str(545); // 保存失败，请重试
              _MDMessageView["default"].error(fail, _this2.$body);
            }
            _this2.$("#savebtn").prop("disabled", false);
          });
        }
      }
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvalutionEditWinView.prototype), "viewDidRendered", this).call(this);
      this.evaluterListView = new _MDEvaluterListView["default"]({
        isEditEvalution: true,
        isNeedCurUser: true,
        isEdit: this.isEdit,
        addRuleForNewItem: this.addRuleForNewItem,
        ignoreIsShowingStructor: true
      });
      this.addSubView(this.evaluterListView, this.$(".main-block")[0]);
      if (this.isEdit) {
        this.setEvalutionInfo(this.evalModel);
      }
    }
  }]);
  return MDEvalutionEditWinView;
}(_MDWindowView2["default"]);

},{"1087":1087,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1421":1421,"1437":1437,"1439":1439,"1454":1454,"1461":1461,"1463":1463,"1475":1475,"1478":1478,"471":471,"55":55,"93":93}],471:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1426);
require(1417);
require(1463);
require(1432);
require(1424);
require(1428);
require(1429);
require(1466);
require(1412);
require(1439);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDParticipantInfoCollection = _interopRequireDefault(require(277));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MDEnterUserChooseView = _interopRequireDefault(require(459));
var _MDEnterpriseShareTabView = _interopRequireDefault(require(675));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MMViewBase2 = _interopRequireDefault(require(22));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDEditalbeInputDiv = _interopRequireDefault(require(28));
var _MDParticipantInfo = _interopRequireDefault(require(276));
var _MDMoveFileWindowView = _interopRequireDefault(require(508));
var _MMNetDiskBoardCell = _interopRequireDefault(require(937));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDChannelType = _interopRequireDefault(require(717));
var _popupPos = _interopRequireDefault(require(65));
var _MDOneGroupPopupView = _interopRequireDefault(require(753));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
// MDEvaluterListView.js
// WebContent/javascript/moladisk/views/evaluation/MDEvaluterListView.js
// jichao
// 2017-5-15
var MDEvaluterListView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MDEvaluterListView, _MMViewBase);
  function MDEvaluterListView() {
    (0, _classCallCheck2["default"])(this, MDEvaluterListView);
    return _callSuper(this, MDEvaluterListView, arguments);
  }
  (0, _createClass2["default"])(MDEvaluterListView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n      <div class=\"header-block\">\n\n      </div>\n      <div class=\"main-contain\"></div>\n      <%if(canEdit){%>\n        <div class=\"add-evalution\">\n          <span class=\"ep-ic ep-ic-add\"></span>\n          <span><%=title%></span>\n        </div>\n      <%}%>\n   ";
    }
  }, {
    key: "evalutionOrderedItemTmpl",
    value: function evalutionOrderedItemTmpl() {
      return "<div class=\"eva-user-item <%=editStr%>\">\n\n      <div class=\"item group-line\">\n        <%if(canEdit){%>\n          <div class=\"name-slot\"></div>\n        <%}else{%>\n          <%=title%>\n        <%}%>\n      </div>\n      <div class=\"item group-line flex-align between \">\n        <div class=\"title-left\"><%=BabelStr.str(2711)%></div>\n        <div class=\"input-block  <%= !canEdit && \"flex-align middle with-wrap gap-10\" %> \">\n        </div>\n      </div>\n      <div class=\"item limit-num\">\n        <span><%=BabelStr.str(4601)%></span>\n        <%if(canEdit) {%>\n          <input type=\"text\" class=\"form-control limits isNumber\" value=\"<%=minNum%>\" isNumber />\n          <span class=\"right-span\">%</span>\n        <%}else {%>\n          <span><%=minNum%>%</span>\n        <%}%>\n      </div>\n      <div class=\"item group-line flex-align can-pass-group\">\n        <div><%=BabelStr.str(4600)%></div>\n        <%if(canEdit) {%>\n          <div class=\"radio-group flex-align mgl-15\">\n            <div class=\"radio-box mgr-20 <%=(canBeIgnore ? 'checked' : '')%>\"><%=BabelStr.str(3355)%></div>\n            <div class=\"radio-box <%=(!canBeIgnore ? 'checked' : '')%>\"><%=BabelStr.str(3356)%></div>\n          </div>\n         <%}else {%>\n            <span><%=(canBeIgnore ? BabelStr.str(3355) : BabelStr.str(3356) )%></span>\n         <%}%>\n      </div>\n      <div class=\"item group-line flex-align is-end-group \">\n        <div><%=BabelStr.str(4602)%></div>\n        <%if(canEdit) {%>\n          <div class=\"radio-group flex-align no-shrink mgl-10\">\n            <div class=\"radio-box canPass mgr-20 <%=(isEnd ? 'checked' : '')%>\"><%=BabelStr.str(3355)%></div>\n            <div class=\"radio-box noPass <%=(!isEnd ? 'checked' : '')%>\"><%=BabelStr.str(3356)%></div>\n          </div>\n        <%}else {%>\n          <span class=\"no-shrink\"><%=(isEnd ? BabelStr.str(3355) : BabelStr.str(3356) )%></span>\n        <%}%>\n      </div>\n      <%if(isForTargetFolder){%>\n        <div class=\"item group-line flex-align target-folder-group with-wrap \">\n          <div><%=BabelStr.str(21935)%></div>\n          <%if(canEdit) {%>\n            <div class=\"radio-group flex-align no-shrink mgl-10\">\n              <div class=\"radio-box  mgr-20 checked\"><%=BabelStr.str(21936)%></div>\n              <div class=\"radio-box\"><%=BabelStr.str(21937)%></div>\n            </div>\n          <%}else {%>\n            <span class=\"target-folder-result-no-per\"><%=BabelStr.str(21947)%></span>\n          <%}%>\n        </div>\n\n        <div class=\"item group-line flex-align target-folder-result f-hide with-wrap\">\n          <div><%=BabelStr.str(21938)%></div>\n          <div>\n            <div class=\"target-folder-name mglr-10\"></div>\n            <span class=\"text-button done edit-target-folder mglr-10\"><%=BabelStr.str(3070)%></span>\n          </div>\n        </div>\n      <%}%>\n      <%if(canEdit) {%>\n        <div class=\"right-btns\">\n          <span class=\"up-btn mgr-10\" data-tooltip=\"<%=BabelStr.str(4611)%>\" data-tooltip-dir=\"top\"></span>\n          <span class=\"down-btn mgr-10\" data-tooltip=\"<%=BabelStr.str(4612)%>\" data-tooltip-dir=\"top\"></span>\n          <span class=\"icon del-btn\"></span>\n        </div>\n\n      <%}%>\n    </div>\n      ";
    }
  }, {
    key: "startEvalutionHeaderTmpl",
    value: function startEvalutionHeaderTmpl() {
      return "<div class=\"user-block flex-align between\">\n              <div class=\"title-left\"><%=worker%></div>\n              <div class=\"tips help-block right tip-word\"></div>\n            </div>\n          ";
    }
  }, {
    key: "editEvalutionTmpl",
    value: function editEvalutionTmpl() {
      return "\n              <div class=\"user-block flex-align between\">\n                <div class=\"title-left\"><%=workers%></div>\n                <div class=\"tips right help-block tip-word\"><%=tip%></div>\n              </div>\n            ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvaluterListView.prototype), "initProps", this).call(this);
      var selP = BabelStr.str(538); // 请选择审批流程
      return _.extend(superP, {
        isOrdered: false,
        isEditEvalution: false,
        isNeedCurUser: false,
        isForTargetFolder: true,
        isEdit: false,
        dataCollection: [],
        copyCollection: [],
        conditionArr: [{
          id: '-1',
          name: selP,
          evaluatorGroups: [],
          copyToGroups: []
        }],
        addRuleForNewItem: _.noop,
        canEdit: true,
        fileInfo: null,
        evalArr: [],
        //Array of evalObj
        finalizedStep: null,
        canSelRole: false
        // evalObj : {
        //   name: '',
        //   dataCollection: [],
        //   limit: 100,
        //   canBeIgnore: true,
        //   isEnd: false
        // }
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      props = props || {};
      props.data = _.extend({
        'title': BabelStr.str(532) // 新增审批
      }, props.data);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvaluterListView.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvaluterListView.prototype), "className", this).call(this);
      return superCls + ' evaluter-list-block';
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvaluterListView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .add-evalution': this._addEvaluterClickHandle,
        // 'click .del-btn': this._delGroupClickHandle,
        'click .up-btn': this._upGroupClickHandle,
        'click .down-btn': this._downGroupClickHandle,
        "click .group-item": this.showGroupPopup
      });
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        canEdit: this.canEdit,
        'title': BabelStr.str(532)
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvaluterListView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "renderEvalutionOrderedItemTmpl",
    value: function renderEvalutionOrderedItemTmpl(evalObj, index) {
      var data = _.extend({
        canEdit: this.canEdit,
        editStr: this.canEdit ? ' ' : " disabled-edit",
        isEnd: this.finalizedStep == index,
        minNum: 100,
        canBeIgnore: false,
        isForTargetFolder: this.isForTargetFolder
      }, evalObj);
      var contentTmpl = _.template(this.evalutionOrderedItemTmpl())(data);
      return contentTmpl;
    }
  }, {
    key: "renderItemBlock",
    value: function renderItemBlock(length) {
      var buffer = '';
      var itemHtmls = [];
      for (var i = 0; i < length; i++) {
        buffer += this.renderEvalutionOrderedItemTmpl(i, this.canEdit);
      }
      this.$(".main-contain").append(buffer);
    }
  }, {
    key: "renderEvalution",
    value: function renderEvalution(steps, finalizedStep) {
      this.evalArr = steps;
      this.finalizedStep = finalizedStep;
      this.removeSubViews();
      this.$('.main-contain').empty(); //清除掉view上的所有全局事件
      this.$(".tip-word").empty();
      if (steps.length < 1) {
        var evalObj = this.getInitEvalObj(1);
        this.evalArr.push(evalObj);
        this.addEvaluter(this.evalArr[0], 0);
        // this.renderIsOrderedStatus(false);
      } else {
        for (var i = 0; i < steps.length; i++) {
          this.addEvaluter(steps[i], i);
        }
      }
    }
  }, {
    key: "_addEvaluterClickHandle",
    value: function _addEvaluterClickHandle() {
      var index = this.$(".main-contain >.eva-user-item").length;
      var evalObj = this.getInitEvalObj(index + 1);
      this.evalArr.push(evalObj);
      this.addEvaluter(this.evalArr[index], index);
      this.renderIsOrderedStatus(true);
      // this.$addBtn.prop("disabled", true)
      // this.$addBtn.addClass("disabled");
    }
  }, {
    key: "getInitEvalObj",
    value: function getInitEvalObj(index) {
      return {
        title: BabelStr.str(4604) + index,
        users: [],
        roles: [],
        minNum: 100,
        canBeIgnore: false
        // isEnd: false
      };
    }
  }, {
    key: "renderIsOrderedStatus",
    value: function renderIsOrderedStatus(isordered) {
      if (!this.isEditEvalution) {
        if (isordered) {
          var tip = BabelStr.str(539); // 顺序审批可以进行会签，审批1审批后审批2才能收到审批通知，以此类推
          this.$('.main-contain >.item >.title-left').css({
            "visibility": "visible"
          });
          this.$('.user-block .tips').html(tip);
        } else {
          var tip = BabelStr.str(540); // 审批者可以看到参与讨论的成员信息及文件上所有批注
          this.$('.main-contain >.item >.title-left').css({
            "visibility": "hidden"
          });
          this.$('.user-block .tips').html(tip);
        }
      }
    }
  }, {
    key: "validateUser",
    value: function validateUser(users) {
      var curId = app.currentUser.getUserId();
      users = _.map(users, function (user) {
        if (user instanceof _MDParticipantInfo["default"]) {
          return user.participantId() == curId ? null : user;
        } else {
          return user.userId == curId ? null : user;
        }
      });
      return _.compact(users);
    }
  }, {
    key: "addEvaluter",
    value: function addEvaluter(evalObj, index) {
      var _this = this;
      var initEvalObj = this.getInitEvalObj(index + 1);
      var newevalObj = _.extend(initEvalObj, evalObj);
      _.extend(evalObj, newevalObj);
      var buffer = this.renderEvalutionOrderedItemTmpl(evalObj, index);
      var $buffer = $(buffer);
      this.$(".main-contain").append($buffer);
      if (!this.isNeedCurUser) {
        evalObj.users = this.validateUser(evalObj.users);
      }
      if (!this.canEdit) {
        this.renderUserList(evalObj, index, $buffer);
        this._renderFolder(evalObj, $buffer);
        return;
      }
      var participantsInfoCollection = _MDParticipantInfoCollection["default"].createFromUserCollection(evalObj.users);
      var participantsInfoCollection2 = _MDParticipantInfoCollection["default"].createFromRoleCollection(evalObj.roles);
      var participantsInfoCollection3 = _MDParticipantInfoCollection["default"].createFromGroupCollection(evalObj.groups);
      participantsInfoCollection.add(participantsInfoCollection2.models);
      participantsInfoCollection.add(participantsInfoCollection3.models);
      var curUserId = app.currentUser.getUserId();
      var userListItemView = new _MDEnterpriseShareTabView["default"]({
        defaultParticipantInfoCollection: participantsInfoCollection,
        inputName: "evalter-choose-panel" + index,
        // notIncludeGuest: true,
        // inputDisabled: false,
        // hideSelectWhenInput: true,
        // needFrequentUserTab: false,
        canSelDepartment: false,
        canSelGroup: true,
        canSelRole: false,
        isTabAbsolute: true,
        needRoleTab: false,
        ignoreIsShowingStructor: this.ignoreIsShowingStructor,
        isNeedCurUser: this.isNeedCurUser,
        // isSelectOnlyInEp: true,
        onChange: function onChange(users) {
          //users = new MDMolauserCollection
          var newUsers = [];
          var newTypes = [];
          var emails = [];
          var phones = [];
          users.each(function (user) {
            if (user.participantType() == 10) {
              newTypes.push(user);
            } else if (user.participantId()) {
              newUsers.push(user);
            } else if (user.originalEmail()) {
              emails.push(user.originalEmail());
            } else if (user.phone()) {
              phones.push(user.phone());
            }
          });
          // evalObj.groups = newUsers;
          evalObj.users = newUsers;
          evalObj.roles = newTypes;
          evalObj.emails = emails;
          evalObj.phones = phones;
          _this._checkToEnableAddGroup();
        },
        beforeSelect: function beforeSelect(user) {
          if (_this.checkSelf && user.participantType() == 0 && user.participantId() == curUserId) {
            _MDMessageView["default"].error(BabelStr.str(5168), _this.$(".main-contain"));
            return false;
          } else {
            return true;
          }
        }
      });
      this.addSubView(userListItemView, this.$(".eva-user-item").eq(index).find(" .input-block")[0]); //审批组

      var nameInputView = new _MDEditalbeInputDiv["default"]({
        parentDiv: this.$(".eva-user-item").eq(index).find(" .name-slot")[0],
        placeholder: BabelStr.str(4603),
        //"分组名称不能为空",
        maxlength: 30,
        allowEmpty: false,
        emptyErrorMsg: BabelStr.str(4603),
        //"分组名称不能为空",
        updatedCallback: function updatedCallback(newtext, callback) {
          evalObj.title = newtext;
          callback();
        }
      });
      nameInputView.setInputVal(evalObj.title);
      // this.addSubView(nameInputView, this.$(".eva-user-item").eq(index).find(" .name-slot")[0]); //审批组

      this.addRuleForNewItem(userListItemView);
      this._checkToShowDelBtn();
      var obj = {
        userListItemView: userListItemView
      };
      if (!this.groupItemViewArr) {
        this.groupItemViewArr = [obj];
      } else {
        this.groupItemViewArr.push(obj);
      }
      $buffer.find('.del-btn').on("click", function (e) {
        var index = $(e.target).closest('.eva-user-item').index();
        $buffer.remove();
        nameInputView.remove();
        userListItemView.remove();
        _this.evalArr.splice(index, 1);
      });
      console.log(this.evalArr);
      $buffer.find('.can-pass-group .radio-box').on("click", function (e) {
        console.log($buffer);
        var index = $(e.target).index(); // 0 是  1 否
        evalObj.canBeIgnore = !index;
        _this._itemClassChanged(e);
      });
      $buffer.find('.is-end-group .radio-box').on("click", function (e) {
        var index = $(e.target).index(); // 0 是  1 否
        var steps = $buffer.index();
        var $curItem = $(e.target);
        if (!index) {
          if (_this.finalizedStep == steps) {
            return;
          }
          _this.finalizedStep = steps;
          _this.$('.canPass').removeClass('checked');
          _this.$('.noPass').addClass('checked');
          $curItem.siblings().removeClass("checked");
          $curItem.addClass("checked");
        } else {
          if (_this.finalizedStep == steps) {
            _this.finalizedStep = null;
          }
          $curItem.siblings().removeClass("checked");
          $curItem.addClass("checked");
        }
        _this._itemClassChanged(e);
      });
      $buffer.find('.target-folder-group .radio-box').on("click", function (e) {
        var index = $(e.target).index(); // 0 是  1 否
        var steps = $buffer.index();
        var $curItem = $(e.target);
        $buffer.find('.target-folder-group .radio-box').removeClass("checked");
        $curItem.addClass("checked");
        if (evalObj.targetFolderObj) {
          evalObj.targetFolderObj = index;
        } else {
          evalObj.targetFolderObj = {
            type: index
          };
        }
        if (index == 1) {
          $buffer.find(".target-folder-result").removeClass("f-hide ");
          if (evalObj.targetFolderObj && evalObj.targetFolderObj.targetFolderId) {} else {
            _this.chooseTargetFolderHandle(evalObj, $buffer);
          }
        } else {
          $buffer.find(".target-folder-result").addClass("f-hide ");
        }
        console.log(evalObj);
      });
      $buffer.find('.edit-target-folder').on("click", function (e) {
        _this.chooseTargetFolderHandle(evalObj, $buffer);
      });
      $buffer.find('.limits').on("input", function (e) {
        _this._validateLimits(e);
        console.log($(e.target).val());
        evalObj.minNum = $(e.target).val();
      });
      this._renderFolder(evalObj, $buffer);
      // if(this.isForTargetFolder) {
      //   if(evalObj.targetFolderId) {
      //     evalObj.targetFolderObj = {
      //       type: 1,
      //       targetFolderId: evalObj.targetFolderId
      //     }
      //     $buffer.find(".target-folder-result").removeClass("f-hide ")
      //     $buffer.find('.target-folder-group .radio-box').removeClass("checked")
      //     $buffer.find('.target-folder-group .radio-box').eq(1).addClass("checked")
      //     this.renderTargetFolder(evalObj.targetFolderId,$buffer.find(".target-folder-name"))
      //   }
      // }

      return userListItemView;
    }
  }, {
    key: "_renderFolder",
    value: function _renderFolder(evalObj, $buffer) {
      if (this.isForTargetFolder) {
        if (evalObj.targetFolderId) {
          evalObj.targetFolderObj = {
            type: 1,
            targetFolderId: evalObj.targetFolderId
          };
          if (this.canEdit) {
            $buffer.find(".target-folder-result").removeClass("f-hide ");
            $buffer.find('.target-folder-group .radio-box').removeClass("checked");
            $buffer.find('.target-folder-group .radio-box').eq(1).addClass("checked");
          }
          if (evalObj.targetFolderPath && evalObj.targetFolderPath.length) {
            // let name = ""
            _.each(evalObj.targetFolderPath, function (file) {
              if (file.status != 0) {
                file.fileName += "(<span class=\"red\">".concat(BabelStr.str(5559), "</span>)");
              }
            });
            var pathArr = _.pluck(evalObj.targetFolderPath, "fileName");
            var path = pathArr.join("  ›  ");
            $buffer.find(".target-folder-name").html(path);
            $buffer.find(".target-folder-result-no-per").html(path);
          } else {
            evalObj.targetFolderObj.targetFolderId = undefined;
            // this.renderTargetFolder(evalObj.targetFolderId,$buffer.find(".target-folder-name"), $buffer.find(".target-folder-result-no-per"))
            $buffer.find(".target-folder-name").html("<span class=\"red\">".concat(BabelStr.str(21948), "</span>"));
            $buffer.find(".target-folder-result-no-per").html("<span class=\"red\">".concat(BabelStr.str(21948), "</span>"));
          }
        } else {
          $buffer.find(".target-folder-result-no-per").html(BabelStr.str(21947));
        }
      }
    }
  }, {
    key: "renderTargetFolder",
    value: function renderTargetFolder(fid, $contain, $noPerPath) {
      _MMNetDiskDataController["default"].getPathById(fid, _MDChannelType["default"].epfile, undefined, function (data) {
        console.log(data);
        var pathArr = data.pluck("fileName").reverse();
        var path = pathArr.join("  ›  ");
        $contain.html(path);
        $noPerPath.html(path);
      });
    }
  }, {
    key: "chooseTargetFolderHandle",
    value: function chooseTargetFolderHandle(evalObj, $contain) {
      var win = new _MDMoveFileWindowView["default"]({
        forChooseFolder: true,
        forMove: false,
        onlyEp: true,
        title: BabelStr.str(6850),
        fileIntercept: function fileIntercept(file) {
          return !file.canUpload();
        },
        intercept: function intercept(targetFolderId) {
          if (targetFolderId.slice(0, 5) === "0--00") {
            return {
              isOK: false,
              msg: BabelStr.str(6851)
            };
          } else {
            return {
              isOK: true
            };
          }
        },
        chooseCallback: function chooseCallback(result) {
          console.log(result);
          // this.parentId = result.id;
          var path = result.path.split("/").join("  ›  ");
          $contain.find(".target-folder-name").html(path);
          evalObj.targetFolderObj.targetFolderId = result.id;
          console.log(evalObj);
        },
        onClose: function onClose() {
          if (!evalObj.targetFolderObj.targetFolderId) {
            $contain.find('.target-folder-group .radio-box').eq(0).click();
          }
        }
      });
      win.show();
    }
  }, {
    key: "_itemClassChanged",
    value: function _itemClassChanged(e) {
      var $curItem = $(e.target);
      if ($curItem.hasClass("checked")) {
        return;
      } else {
        $curItem.siblings().removeClass("checked");
        $curItem.addClass("checked");
      }
    }
  }, {
    key: "_validateLimits",
    value: function _validateLimits($e) {
      var num = parseInt($($e.target).val());
      var index = $($e.target).data("index") - 1;
      var max = 100;
      if (num >= 0 && num <= max) {
        $($e.target).val(num);
        console.log('调用了几次');
        return;
      }
      if (!num) {
        $($e.target).val(0);
      } else {
        if (num < 0) {
          $($e.target).val(0);
        } else {
          $($e.target).val(max);
        }
      }
    }
  }, {
    key: "showGroupPopup",
    value: function showGroupPopup($e) {
      var $btn = $($e.currentTarget);
      if ($btn.hasClass("with-popup")) {
        var view = $btn.data("popupView");
        view.close();
        return;
      }
      var id = $btn.attr("usrId");
      _MDOneGroupPopupView["default"].show({
        groupName: $btn.find(".user-name").text(),
        triggerView: $btn,
        hasArrow: true,
        direction: _popupPos["default"].TOP,
        groupId: id
        // $container: this.getNavigationView().$el
      });
    }
  }, {
    key: "renderUserList",
    value: function renderUserList(evalObj, index, $buffer) {
      console.log(evalObj);
      var userNames = _.map(evalObj.users, function (user) {
        return "<div class=\"user-item-with-type\" usrId=".concat(user.id, ">\n        <span class=\"icon user-s-icon\"></span>\n        <span class=\"user-name text-button\">").concat(user.name, "</span>\n      </div>");
      });
      var roleNames = _.map(evalObj.roles, function (role) {
        return "<span class=\"main-color\">".concat(role.name, "</span>");
      });
      var groups = _.map(evalObj.groups, function (group) {
        return "<div class=\"user-item-with-type group-item f-pointer\" data-tooltip=\"".concat(BabelStr.str(2578), "\" usrId=").concat(group.groupId, ">\n        <span class=\"icon grp-s-icon\"></span>\n        <span class=\"user-name text-button\">").concat(group.name, "</span>\n      </div>");
      });
      var items = groups.concat(roleNames).concat(userNames);
      var str = items.join("") || BabelStr.str(3457);
      $buffer.find(".input-block").html(str);
      var participantsInfoCollection = _MDParticipantInfoCollection["default"].createFromUserCollection(evalObj.users);
      var participantsInfoCollection2 = _MDParticipantInfoCollection["default"].createFromGroupCollection(evalObj.groups);
      evalObj.users = participantsInfoCollection.models.concat(participantsInfoCollection2.models);
      evalObj.roles = _MDParticipantInfoCollection["default"].createFromRoleCollection(evalObj.roles).models;

      // let copyStr = copyCollection.pluck("name").join("，") || '暂无';
      // this.$(".eva-user-item").eq(index).find(".input-block").eq(0).html(userStr)
      // this.$(".eva-user-item").eq(index).find(" .input-block").eq(1).html(copyStr)
      // if(maxLength) {
      //   let lenStr = maxLength.minNum ? BabelStr.str(3439) + maxLength.minNum + BabelStr.str(3440) : ''
      //   this.$(".eva-user-item").eq(index).find(".limit-num").html(lenStr)
      // }
    }
  }, {
    key: "_checkToShowDelBtn",
    value: function _checkToShowDelBtn() {
      // if (this.$('.group-line').length > 1) {
      //   this.$('.group-line').addClass('multi-line');
      // } else {
      //   this.$('.group-line').removeClass('multi-line');
      // }
    }
  }, {
    key: "_checkToEnableAddGroup",
    value: function _checkToEnableAddGroup() {
      // var canAdd = true;
      // for (var i = 0; i < this.dataCollection.length; i++) {
      //   if (this.dataCollection[i].length == 0) {
      //     canAdd = false;
      //   }
      // };

      // if (canAdd) {
      // this.$addBtn.prop("disabled", false)
      // this.$addBtn.removeClass("disabled");
      // } else {
      // this.$addBtn.prop("disabled", true)
      // this.$addBtn.addClass("disabled");
      // }
    }
  }, {
    key: "changeAddBtnStatus",
    value: function changeAddBtnStatus(status) {
      this.$(".add-evalution").prop("disabled", status);
    }
  }, {
    key: "pickConditionChanged",
    value: function pickConditionChanged(opt) {
      var sign = opt.id != '-1' ? false : true;
      _.isFunction(this.onConditionChanged) && this.onConditionChanged(sign);
      this.tmplId = opt.id;
      var evaluaters = this._removeCurUserFromEvaluatorGroups(opt.evaluatorGroups);
      this.dataCollection = evaluaters;
      this.copyCollection = opt.copyToGroups;
      this.steps = opt.steps;
      this.renderEvalution(this.dataCollection, this.copyCollection, opt.steps);
    }
  }, {
    key: "_removeCurUserFromEvaluatorGroups",
    value: function _removeCurUserFromEvaluatorGroups(evaluatorGroups) {
      var _this2 = this;
      var curUserId = app.currentUser.getUserId();
      var results = [];
      var curUserRemoved = false;
      for (var i = 0; i < evaluatorGroups.length; i++) {
        var group = evaluatorGroups[i];
        var g = [];
        for (var k = 0; k < group.length; k++) {
          var u = group[k];
          if (u.id != curUserId) {
            g.push(u);
          } else {
            curUserRemoved = true;
          }
        }
        results.push(g);
      }
      if (curUserRemoved) {
        setBabelTimeout(function () {
          _MDMessageView["default"].success(BabelStr.str(7164), _this2.$(".main-contain"));
        }, 100);
      }
      return results;
    }
  }, {
    key: "getTmplId",
    value: function getTmplId() {
      return this.tmplId;
    }
  }, {
    key: "getEvaluatorGroups",
    value: function getEvaluatorGroups() {
      var _this3 = this;
      // let allUserId = [];
      var evaluationTmplObj = {
        steps: [],
        finalizedStep: null
      };
      var _loop = function _loop() {
        var oneline = _this3.evalArr[i];
        var userIds = [];
        var groupIds = [];
        _.each(oneline.users, function (user) {
          if (user instanceof _MDParticipantInfo["default"]) {
            if (user.isGroup()) {
              groupIds.push(user.participantId());
            } else {
              userIds.push(user.participantId());
            }
          } else {
            userIds.push(user.userId);
            console.log("error user model", user.userId);
          }
        });
        var roleIds = _.map(oneline.roles, function (role) {
          if (role instanceof _MDParticipantInfo["default"]) {
            return role.participantId();
          } else {
            return role.id;
          }
        });
        var targetFolderId;
        if (oneline.targetFolderObj && _this3.isForTargetFolder) {
          if (oneline.targetFolderObj.type == 0) {
            targetFolderId = undefined;
          } else {
            targetFolderId = oneline.targetFolderObj.targetFolderId;
          }
        }
        var out = {
          step: i,
          userIds: userIds,
          roleIds: roleIds,
          groupIds: groupIds,
          emails: oneline.emails,
          phones: oneline.phones,
          title: oneline.title,
          minNum: oneline.minNum - 0,
          canBeIgnore: oneline.canBeIgnore ? 1 : 0
        };
        if (_this3.isForTargetFolder) {
          // targetFolderId = targetFolderId || app.currentFolder.getFileId()
          out.targetFolderId = targetFolderId;
        }
        evaluationTmplObj.steps.unshift(out);
      };
      for (var i = this.evalArr.length - 1; i >= 0; i--) {
        _loop();
      }
      evaluationTmplObj.finalizedStep = this.finalizedStep;
      return evaluationTmplObj;
    }
  }, {
    key: "getEvaluatorGroupsWithName",
    value: function getEvaluatorGroupsWithName() {
      var obj = {
        evaluation: this.dataCollection,
        copy: this.copyCollection,
        maxLength: undefined
      };
      return obj;
    }
  }, {
    key: "removeCreatorFromEvaluator",
    value: function removeCreatorFromEvaluator() {
      var curUserId = app.currentUser.getUserId();
    }
  }, {
    key: "getFileEvaluationTmpl",
    value: function getFileEvaluationTmpl(callback) {
      var _this4 = this;
      _MMEnterpriseController["default"].getFileEvaluationTmpl(this.fileInfo.getFileId(), function (datas, type) {
        datas.each(function (evaluationTmpl) {
          var condition = {
            id: evaluationTmpl.getId(),
            name: evaluationTmpl.getName(),
            evaluatorGroups: evaluationTmpl.getEvaluatorGroups(),
            copyToGroups: evaluationTmpl.getCopyToGroups(),
            steps: evaluationTmpl.get("steps")
          };
          _this4.conditionArr.push(condition);
        });
        _this4.conditionSelectView = new _MDDropdownSelectListView["default"]({
          dataProvider: _this4.conditionArr,
          labelField: "name",
          onChange: function onChange(obj) {
            _this4.pickConditionChanged(obj);
          }
        });
        _this4.addSubView(_this4.conditionSelectView, _this4.$(".select")[0]);
        _.isFunction(callback) && callback(type);
      }, function (res) {
        console.log(res);
      });
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEvaluterListView.prototype), "viewDidRendered", this).call(this);
      // this.$addBtn = this.$(".add-evalution");
      // this.$addBtn.prop("disabled", true)
      // this.$addBtn.addClass("disabled");
      if (this.isEditEvalution) {
        var data = {
          'workers': BabelStr.str(3191),
          //  审批者
          'tip': BabelStr.str(537) // 如不需要按顺序审批(会签方式)，可将全部审批人员添加到审批1
        };
        var contentTmpl = _.template(this.editEvalutionTmpl())(data);
        this.$('.header-block').html(contentTmpl);
        if (!this.isEdit) {
          var evalObj = this.getInitEvalObj(1);
          this.evalArr.push(evalObj);
          this.addEvaluter(this.evalArr[0], 0);
        }
      } else {
        var data = {
          'preDefine': BabelStr.str(535),
          // 预设流程
          'worker': BabelStr.str(536) // 审批人员
        };
        var _contentTmpl = _.template(this.startEvalutionHeaderTmpl())(data);
        this.$('.header-block').html(_contentTmpl);
        if (this.canEdit) {
          var _evalObj = this.getInitEvalObj(1);
          this.evalArr.push(_evalObj);
          this.addEvaluter(this.evalArr[0], 0);
        } else {
          this.$(".tip-word").html(BabelStr.str(4610));
        }

        // this.getFileEvaluationTmpl((type)=>{
        //   this.canEdit = type == 3 || this.fileInfo.canManageFilePermission()
        //   if(!this.canEdit) {
        //     this.$(".add-evalution").remove()
        //   }
        //   _.isFunction(this.onConditionChanged) && this.onConditionChanged(!this.canEdit)
        //   let evalObj = this.getInitEvalObj(1);
        //   this.evalArr.push(evalObj)
        //   this.addEvaluter(this.evalArr[0], 0);
        // });
      }
    }
  }, {
    key: "_delGroupClickHandle",
    value: function _delGroupClickHandle(e) {
      var target = e.currentTarget;
      var index = -1;
      for (var i = 0; i < this.$('.del-btn').length; i++) {
        var btn = this.$('.del-btn')[i];
        if (target == btn) {
          index = i;
          break;
        }
        ;
      }
      ;
      if (index != -1) {
        this.removeSubView(this.groupItemViewArr[index].userListItemView);
        // this.removeSubView(this.groupItemViewArr[index].copyToItemView);
        this.groupItemViewArr.splice(index, 1);
        $(this.$('.eva-user-item')[index]).remove();
        this._checkToShowDelBtn();
        this.evalArr.splice(index, 1);
        var groupName = BabelStr.str(533); // 审批组
        var copyGroup = BabelStr.str(534); // 抄送组

        // for (var i = 0; i < this.$('.eva-user-item').length; i++) {
        //   let $contain=this.$('.eva-user-item').eq(i);
        //   $contain.find('.group-line .title-left').eq(0).text(groupName + (i + 1));
        //   $contain.find('.group-line .title-left').eq(1).text(copyGroup + (i + 1));
        // };
      }
      ;
      this._checkToEnableAddGroup();
    }
  }, {
    key: "_upGroupClickHandle",
    value: function _upGroupClickHandle(e) {
      var target = e.currentTarget;
      var index = $(e.target).closest('.eva-user-item').index();
      if (this.finalizedStep == index) {
        this.finalizedStep = index - 1;
      } else if (this.finalizedStep == index - 1) {
        this.finalizedStep = index;
      }
      if (index > 0) {
        var curItem = this.$('.eva-user-item')[index];
        var tarItem = this.$('.eva-user-item')[index - 1];
        var parent = this.$('.main-contain')[0];
        parent.removeChild(curItem); //原生js移除节点，防止清除已绑定事件

        $(curItem).insertBefore(tarItem);
        this._checkToShowDelBtn();
        var _ref = [this.evalArr[index - 1], this.evalArr[index]];
        this.evalArr[index] = _ref[0];
        this.evalArr[index - 1] = _ref[1];
      }
      ;
      this._checkToEnableAddGroup();
      console.warn(this.evalArr);
    }
  }, {
    key: "_downGroupClickHandle",
    value: function _downGroupClickHandle(e) {
      var index = $(e.target).closest('.eva-user-item').index();
      var max = this.$('.eva-user-item').length;
      if (index < max - 1) {
        if (this.finalizedStep == index) {
          this.finalizedStep = index + 1;
        } else if (this.finalizedStep == index + 1) {
          this.finalizedStep = index;
        }
        var curItem = this.$('.eva-user-item')[index];
        var tarItem = this.$('.eva-user-item')[index + 1];
        var parent = this.$('.main-contain')[0];
        parent.removeChild(curItem); //原生js移除节点，防止清除已绑定事件

        $(curItem).insertAfter(tarItem);
        this._checkToShowDelBtn();
        var _ref2 = [this.evalArr[index + 1], this.evalArr[index]];
        this.evalArr[index] = _ref2[0];
        this.evalArr[index + 1] = _ref2[1];
      }
      ;
      console.warn(this.evalArr);
      this._checkToEnableAddGroup();
    }
  }]);
  return MDEvaluterListView;
}(_MMViewBase2["default"]);

},{"1098":1098,"1104":1104,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1417":1417,"1424":1424,"1426":1426,"1428":1428,"1429":1429,"1432":1432,"1439":1439,"1454":1454,"1463":1463,"1466":1466,"1475":1475,"22":22,"273":273,"276":276,"277":277,"28":28,"459":459,"508":508,"55":55,"65":65,"67":67,"675":675,"717":717,"753":753,"937":937}],592:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require(1199));
var _asyncToGenerator2 = _interopRequireDefault(require(1172));
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDCheckboxView = _interopRequireDefault(require(37));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDRecoverFileThumbWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDRecoverFileThumbWinView, _MDWindowView);
  function MDRecoverFileThumbWinView() {
    (0, _classCallCheck2["default"])(this, MDRecoverFileThumbWinView);
    return _callSuper(this, MDRecoverFileThumbWinView, arguments);
  }
  (0, _createClass2["default"])(MDRecoverFileThumbWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n    <div class=\"msg\"><%=BabelStr.str(40136)%></div>\n    <div class=\"other-options mgtb-15\">\n        <div class=\"option-1 mgb-10\"></div>\n        <div class=\"option-2\"></div>\n    </div>\n    <div class=\"flex-align end middle gap-10\">\n      <div class=\"button cancel\"><%=BabelStr.str(155)%></div>\n      <div class=\"button done save\"><%=BabelStr.str(154)%></div>\n    </div>\n    ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDRecoverFileThumbWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        coverSubFiles: 0,
        apply2sameType: 0
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDRecoverFileThumbWinView.prototype), "className", this).call(this);
      return superCls + ' thumb-recover-window';
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDRecoverFileThumbWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .cancel': this.close,
        "click .save": this._save
      });
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      opt.title = BabelStr.str(40112); // "恢复默认图标";

      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDRecoverFileThumbWinView.prototype), "initialize", this).call(this, opt);
      this.refreshCheckbox();
    }
  }, {
    key: "refreshCheckbox",
    value: function () {
      var _refreshCheckbox = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _this = this;
        var out, customIcon4File, useSameTypeRecover, fileIdSetting, applySub, applyType;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _MDSpinnerloaderView["default"].showIn(this.$(".other-options"));
              _context.next = 3;
              return _MMEnterpriseController["default"].dedupGetGetCustomIcon4File(this.fileInfor.getFileId());
            case 3:
              out = _context.sent;
              customIcon4File = out.customIcon4File || {};
              _MDSpinnerloaderView["default"].clearFrom(this.$(".other-options"));
              useSameTypeRecover = false;
              if (customIcon4File) {
                fileIdSetting = customIcon4File.fileIdSetting;
                if (!fileIdSetting) {
                  useSameTypeRecover = true;
                }
              }
              if (!useSameTypeRecover) {
                applySub = new _MDCheckboxView["default"]({
                  label: BabelStr.str(40104),
                  onChanged: function onChanged(checked) {
                    _this.coverSubFiles = checked ? 1 : 0;
                  }
                });
                this.addSubView(applySub, this.$(".option-1"));
              }
              applyType = new _MDCheckboxView["default"]({
                label: BabelStr.str(40105),
                onChanged: function onChanged(checked) {
                  _this.apply2sameType = checked ? 1 : 0;
                }
              });
              this.addSubView(applyType, this.$(".option-2"));
              if (useSameTypeRecover) {
                applyType.setChecked(true);
                applyType.setEditable(false);
                applyType.setDisabled(true);
              }
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function refreshCheckbox() {
        return _refreshCheckbox.apply(this, arguments);
      }
      return refreshCheckbox;
    }()
  }, {
    key: "_save",
    value: function _save() {
      var _this2 = this;
      var params = {
        fileId: this.fileInfor.getFileId(),
        coverSubFiles: this.coverSubFiles,
        apply2sameType: this.apply2sameType
      };
      _MMEnterpriseController["default"].removeCustomIcon4File(params, function () {
        _this2.close();
        _MDSnackbarView["default"].show(BabelStr.str(308));
        try {
          if (_this2.coverSubFiles || _this2.apply2sameType) {
            window.dexieDB.file_default_thumbs.clear();
          } else {
            window.dexieDB.file_default_thumbs["delete"](_this2.fileInfor.getFileId());
          }
          if (_this2.apply2sameType) {
            Dispatcher.trigger(MDEvents.RefreshCurFolder);
          }
        } catch (error) {
          console.log(error);
        }
        Dispatcher.trigger(MDEvents.RefreshIcon, {
          fileId: params.fileId
        });
      }, function (err) {
        _MDMessageView["default"].success(err.msg || BabelStr.str(309), _this2.$body);
      });
    }
  }]);
  return MDRecoverFileThumbWinView;
}(_MDWindowView2["default"]);

},{"1098":1098,"1172":1172,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1199":1199,"1454":1454,"1463":1463,"1475":1475,"37":37,"55":55,"72":72,"76":76,"93":93}],583:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDTabPanelView = _interopRequireDefault(require(81));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDEvents = _interopRequireDefault(require(325));
var _MDFileVerListView = _interopRequireDefault(require(584));
/**
 *  文件版本
 *  Create by manjun.han
 *  2015.9.2
 */

var MDFileVerListPanelView = _MDTabPanelView["default"].extend({
  tmpl: '<div class="contain"></div>',
  events: function events() {
    var superE = _MDTabPanelView["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click .cancle-fileinfo ': this.cancleClickHandle
    });
  },
  className: function className() {
    var superCls = _MDTabPanelView["default"].prototype.className.call(this);
    return superCls + " m-version";
  },
  initProps: function initProps() {
    var superP = _MDTabPanelView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      listView: null
    });
  },
  initialize: function initialize(opt) {
    _MDTabPanelView["default"].prototype.initialize.call(this, opt);
    var fileVersionRouterCb = this.fileVersionRouterCb;
    if (!fileVersionRouterCb) {
      fileVersionRouterCb = function fileVersionRouterCb(fileInfo, ver) {
        _Dispatcher["default"].trigger(_MDEvents["default"].OpenFile, {
          fileId: fileInfo.getFileId(),
          version: ver,
          fileInfo: fileInfo
        });
      };
    }
    ;
    this.listView = new _MDFileVerListView["default"]({
      fileInfor: this.fileInfor,
      enableOpenVersion: this.enableOpenVersion,
      enableRouterNavigation: this.enableRouterNavigation,
      fileVersionRouterCb: fileVersionRouterCb,
      showDispMark: this.showDispMark,
      dispVer: this.dispVer,
      updateDisVerAfterDel: this.updateDisVerAfterDel
    });
    this.addSubView(this.listView, this.$(".contain")[0]);
  },
  setFileInfor: function setFileInfor(fileInfor) {
    var self = this;
    this.listView.setFileInfor(fileInfor, function () {
      viewManager.add('versionListView', self.listView);
    });
  },
  setInitialVer: function setInitialVer(version) {
    this.listView.setInitialVer(version);
  },
  setEnableOpenVersion: function setEnableOpenVersion(enabled) {
    this.listView.setEnableOpenVersion(enabled);
  },
  clearFileVersionList: function clearFileVersionList() {
    if (this.listView) {
      this.listView.removeSubViews();
    }
  },
  cancleClickHandle: function cancleClickHandle() {
    this.changeToFileInforPanel();
  },
  setEnableRouterNavigation: function setEnableRouterNavigation(enabled) {
    this.listView.setEnableRouterNavigation(enabled);
  },
  refresh: function refresh() {
    this.listView.refresh();
  }
});
var _default = exports["default"] = MDFileVerListPanelView;

},{"1184":1184,"1454":1454,"18":18,"325":325,"584":584,"81":81}],581:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require(1199));
require(1412);
require(1439);
require(1425);
require(1420);
require(1463);
require(1471);
require(1477);
require(1489);
require(1423);
require(1411);
require(1530);
require(1505);
require(1506);
require(1507);
require(1508);
require(1510);
require(1509);
require(1512);
require(1513);
require(1514);
require(1516);
require(1517);
require(1518);
require(1519);
require(1521);
require(1520);
require(1522);
require(1523);
require(1524);
require(1525);
require(1526);
require(1527);
require(1528);
require(1529);
require(1437);
var _asyncToGenerator2 = _interopRequireDefault(require(1172));
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _app = _interopRequireDefault(require(17));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDCheckboxView = _interopRequireDefault(require(37));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _menusvg = _interopRequireDefault(require(1119));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDFileThumbEditWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDFileThumbEditWinView, _MDWindowView);
  function MDFileThumbEditWinView() {
    (0, _classCallCheck2["default"])(this, MDFileThumbEditWinView);
    return _callSuper(this, MDFileThumbEditWinView, arguments);
  }
  (0, _createClass2["default"])(MDFileThumbEditWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<div class=\"flex-align\">\n      <div class=\"thumb-list-block\">\n        <div class=\"mgb-10\"><%=BabelStr.str(40102)%></div>\n        <div class=\"thumb-list flex-align middle with-wrap gap-10\"></div>\n      </div>\n      <div class=\"split\"></div>\n      <div class=\"thumb-edit-block\">\n        <div class=\"rendering-block\">\n          <div class=\"preview-title\"><%=BabelStr.str(40110)%></div>\n          <div class=\"thumb-rendering flex-align middle center\">\n            <div class=\"thumb-rendering-content checked-thumb default-icon \"></div>\n          </div>\n          <div class=\"flex-align center middle gap-10\">\n            <div class=\"temp-file-thumb checked-thumb default-icon \"></div>\n            <div class=\"temp-file-name\"><%=BabelStr.str(40106)%></div>\n          </div>\n        </div>\n        <div class=\"upload-title mgt-10 mgb-15\"><%=BabelStr.str(40103)%></div>\n\n        <div class=\"dropArea mgt-10 flex-align center middle with-column\">\n          <div class=\"new-icon icon30 ic-local-choose\"></div>\n          <div class=\"mgb-10\"><%=BabelStr.str(28184)%></div>\n          <div class=\"desc\"><%=BabelStr.str(40107)%></div>\n          <div class=\"desc\"><%=BabelStr.str(40108)%></div>\n        </div>\n        <input class=\"f-hide file-input\" type=\"file\" name=\"file\" accept=\".jpg,.jpeg,.png,.svg\">\n        <div class=\"other-options mgtb-15\"></div>\n        <div class=\"flex-align end middle gap-10\">\n          <div class=\"button cancel\"><%=BabelStr.str(155)%></div>\n          <div class=\"button done save\"><%=BabelStr.str(154)%></div>\n        </div>\n      </div>\n\n    </div>\n    ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileThumbEditWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        coverSubFiles: 0,
        apply2sameType: 0
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileThumbEditWinView.prototype), "className", this).call(this);
      return superCls + ' thumb-edit-window';
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileThumbEditWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .cancel': this.close,
        "click .thumb-item": this._checkThumbItem,
        "click .dropArea": this.localUpload,
        "click .delete": this._delete,
        "click .save": this._save
      });
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      var _this = this;
      opt.title = BabelStr.str(40101); // "更改文件夹图标";
      opt.width = 850;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileThumbEditWinView.prototype), "initialize", this).call(this, opt);
      this.renderThumbs();
      this.applySub = new _MDCheckboxView["default"]({
        label: BabelStr.str(40104),
        onChanged: function onChanged(checked) {
          _this.coverSubFiles = checked ? 1 : 0;
          if (checked) {
            _this.applyType && _this.applyType.setChecked(false);
          }
        }
      });
      this.addSubView(this.applySub, this.$(".other-options"));
      if (_app["default"].currentUser.isEpManager()) {
        this.applyType = new _MDCheckboxView["default"]({
          label: BabelStr.str(40105),
          onChanged: function onChanged(checked) {
            _this.apply2sameType = checked ? 1 : 0;
            if (checked) {
              _this.applySub.setChecked(false);
            }
          }
        });
        this.addSubView(this.applyType, this.$(".other-options"));
      }
      this.registerDropEvents();
    }
  }, {
    key: "checkDefault",
    value: function checkDefault() {
      var customIcon4File = this.fileInfor.get("customIcon4File");
      var i;
      var $item;
      if (customIcon4File.fileUrl) {
        $item = this.$(".thumb-item[data-id=\"".concat(customIcon4File.customIconId, "\"]"));
        i = $item.index();
      } else if (customIcon4File.asIconType) {
        i = customIcon4File.asIconType;
      } else {
        i = this.getPosByFileInfo();
      }
      this.$(".thumb-item").eq(i).click();
    }
  }, {
    key: "getPosByFileInfo",
    value: function getPosByFileInfo() {
      var file = this.fileInfor;
      var i = 4; // 文件夹

      if (file.isProject()) {
        i = 0;
      } else if (file.isManuscriptBox()) {
        i = 16;
      } else if (file.isEncryptedFolder()) {
        i = 18;
      } else if (file.isMaterialClass()) {
        i = 7;
      } else if (file.isMaterialLibrary() || file.isMaterialLibraryFolder()) {
        i = 6;
      } else if (file.isTeamFolder()) {
        i = 10;
        // }
      } else if (file.isDepartmentFolder()) {
        i = 15;
      } else if (file.isEpPublicFolder()) {
        i = 17;
      } else if (file.isHQSMProject()) {
        i = 5;
      } else if (file.isArchiveHouse) {
        i = 3;
      } else if (file.isReadingRoom()) {
        i = 3;
      }
      return i;
    }
  }, {
    key: "localUpload",
    value: function localUpload() {
      this.$('.file-input').click();
    }
  }, {
    key: "renderThumbs",
    value: function renderThumbs() {
      var _this2 = this;
      this.renderDefaultThumbs();
      _MMEnterpriseController["default"].getEntCustomIcons(function (res) {
        _this2.renderCustomIcons(res.customIcons);
        _this2.checkDefault();
      }, function () {});
    }
  }, {
    key: "_checkThumbItem",
    value: function _checkThumbItem($e) {
      var $currentTarget = $($e.currentTarget);
      this.$(".thumb-item").removeClass("checked");
      $currentTarget.addClass("checked");
      var i = $currentTarget.index();
      if ($currentTarget.hasClass("custome-thumb")) {
        this.renderCustomeCheckedThumb($currentTarget);
      } else {
        this.renderDefaultCheckedThumb(i);
      }
    }
  }, {
    key: "_delete",
    value: function _delete($e) {
      var _this3 = this;
      if (this.removing) {
        return;
      }
      this.removing = true;
      $e.stopPropagation();
      _MDAlertView["default"].showStandardSelection({
        message: BabelStr.str(40111),
        onClose: function onClose() {
          _this3.removing = false;
        },
        okFun: function okFun() {
          _this3.removing = false;
          var $item = $($e.target).closest(".thumb-item");
          var id = $item.data("id");
          _MMEnterpriseController["default"].removeCustomIcon(id, function () {
            _MDMessageView["default"].success(BabelStr.str(308), _this3.$body);
            if ($item.hasClass("checked")) {
              _this3.checkDefault();
              try {
                window.dexieDB.file_default_thumbs["delete"](fileInfo.getFileId());
              } catch (error) {
                console.log("file_default_thumbs 消失了");
              }
              Dispatcher.trigger(MDEvents.RefreshIcon, {
                fileId: _this3.fileInfor.getFileId()
              });
            }
            $item.remove();
          }, function (err) {
            _MDMessageView["default"].success(err.msg || BabelStr.str(309), _this3.$body);
          });
        }
      });
    }
  }, {
    key: "renderCustomeCheckedThumb",
    value: function renderCustomeCheckedThumb($currentTarget) {
      this.$(".checked-thumb").html("<div class=\"flex-align middle center img-solt\">\n        ".concat($currentTarget.html(), "\n      </div>\n    "));
    }
  }, {
    key: "renderDefaultCheckedThumb",
    value: function renderDefaultCheckedThumb(i) {
      var x = -i * 40 % 400;
      var y = -Math.floor(i / 10) * 40;
      this.$(".thumb-rendering-content").css({
        "background-position": "".concat(2 * x, "px ").concat(2 * y, "px")
      });
      this.$(".temp-file-thumb").css({
        "background-position": "".concat(0.5 * x, "px ").concat(0.5 * y, "px")
      });
      this.$(".checked-thumb").html("");
    }
  }, {
    key: "renderDefaultThumbs",
    value: function renderDefaultThumbs() {
      var result = "";
      var x = 0;
      var y = 0;
      for (var i = 0; i < 26; i++) {
        x = -i * 40 % 400;
        y = -Math.floor(i / 10) * 40;
        result += "<div class=\"thumb-item flex-align middle center\">\n        <div class=\"default-icon\" style=\"background-position: ".concat(x, "px ").concat(y, "px;\"></div>\n      </div>");
      }
      this.$(".thumb-list").append(result);
    }
  }, {
    key: "renderCustomIcons",
    value: function renderCustomIcons(customIcons) {
      var result = "";
      for (var i = 0; i < customIcons.length; i++) {
        var element = customIcons[i];
        result += this.getCustomeItem(element.fileUrl, element.id);
      }
      this.$(".thumb-list").append(result);
    }
  }, {
    key: "appendCustomeItem",
    value: function appendCustomeItem(imageDataUrl, id) {
      var result = this.getCustomeItem(imageDataUrl, id);
      this.$(".thumb-list").append(result);
    }
  }, {
    key: "getCustomeItem",
    value: function getCustomeItem(imageDataUrl, id) {
      var result = "";
      result += "<div class=\"thumb-item flex-align middle center custome-thumb\" data-id=\"".concat(id, "\">\n      <img src=\"").concat(imageDataUrl, "\" alt=\"\"/>\n      <div class=\"delete hover\" data-tooltip=\"").concat(BabelStr.str(32), "\" data-tooltip-dir=\"top\">").concat(_menusvg["default"].menu_del_cicle, "</div>\n    </div>");
      return result;
    }
  }, {
    key: "registerDropEvents",
    value: function registerDropEvents() {
      var dropArea = this.$('.dropArea');
      var fileInput = this.$('.file-input');
      var self = this;
      // 文件选择变化
      fileInput.change(function () {
        if (this.files.length > 0) {
          self.handleFile(this.files[0]);
        }
      });

      // 拖放相关事件
      dropArea.on('dragover', function (e) {
        e.preventDefault();
        $(this).addClass("active");
        e.stopPropagation();
      });
      dropArea.on('dragleave', function (e) {
        e.preventDefault();
        $(this).removeClass("active");
      });
      dropArea.on('drop', function (e) {
        e.preventDefault();
        $(this).removeClass("active");
        var files = e.originalEvent.dataTransfer.files;
        if (files.length > 0) {
          self.handleFile(files[0]);
        }
      });
    }

    // 处理文件
  }, {
    key: "handleFile",
    value: function handleFile(file) {
      var _this4 = this;
      var MAX_SIZE = 120 * 1024; // 120k
      if (file) {
        var allowedExtensions = [".jpg", ".jpeg", ".png", ".svg"];
        var ext = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
        if (!allowedExtensions.includes(ext)) {
          _MDSnackbarView["default"].show("请选择图片文件（.jpg, .jpeg, .png, .svg）");
          return;
        }
        var reader = new FileReader();
        reader.onload = /*#__PURE__*/function () {
          var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(e) {
            var imageDataUrl, fileToUpload;
            return _regenerator["default"].wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  imageDataUrl = e.target.result; // 压缩图片（如果超过 1.8MB）
                  if (!(file.size > MAX_SIZE)) {
                    _context.next = 5;
                    break;
                  }
                  _context.next = 4;
                  return _this4.compressImage(imageDataUrl, MAX_SIZE);
                case 4:
                  imageDataUrl = _context.sent;
                case 5:
                  fileToUpload = _this4.dataURLToFile(imageDataUrl, file.name);
                  _MMEnterpriseController["default"].uploadCustomIcon(file.name, fileToUpload, function (res) {
                    console.log(res);
                    var customIcon = res.customIcon;
                    var id = customIcon.id;
                    _this4.appendCustomeItem(imageDataUrl, id);
                    _this4.$(".custome-thumb").last().click();
                  }, function (err) {
                    console.log(err);
                  });
                case 7:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }();
        reader.readAsDataURL(file);
      }
    }
  }, {
    key: "compressImage",
    value: function compressImage(dataUrl, maxSize) {
      return new Promise(function (resolve) {
        var img = new Image();
        img.onload = function () {
          var canvas = document.createElement("canvas");
          var ctx = canvas.getContext("2d");
          var SIZE = 300; // 最终输出尺寸

          // 1️⃣ 中心裁剪成正方形
          var minSide = Math.min(img.width, img.height);
          var sx = (img.width - minSide) / 2; // 裁剪起点 x
          var sy = (img.height - minSide) / 2; // 裁剪起点 y

          canvas.width = SIZE;
          canvas.height = SIZE;

          // 2️⃣ 从原图中心裁剪并绘制到 canvas（自动缩放到 300x300）
          ctx.drawImage(img, sx, sy, minSide, minSide, 0, 0, SIZE, SIZE);

          // 3️⃣ 递归压缩直到文件大小符合要求
          var quality = 0.9;
          var compressedDataUrl = canvas.toDataURL("image/jpeg", quality);
          var checkSize = function checkSize() {
            if (compressedDataUrl.length > maxSize && quality > 0.1) {
              quality -= 0.1;
              compressedDataUrl = canvas.toDataURL("image/jpeg", quality);
              checkSize();
            } else {
              resolve(compressedDataUrl);
            }
          };
          checkSize();
        };
        img.src = dataUrl;
      });
    }
  }, {
    key: "dataURLToFile",
    value: function dataURLToFile(dataUrl, filename) {
      var arr = dataUrl.split(",");
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {
        type: mime
      });
    }
  }, {
    key: "_save",
    value: function _save() {
      var _this5 = this;
      var $checkItem = this.$(".thumb-item.checked");
      var id;
      var pos = -1;
      var params = {
        fileId: this.fileInfor.getFileId(),
        coverSubFiles: this.coverSubFiles,
        apply2sameType: this.apply2sameType
      };
      if ($checkItem.hasClass("custome-thumb")) {
        id = $checkItem.data("id");
        params.customIconId = id;
      } else {
        pos = $checkItem.index();
        params.asIconType = pos;
      }
      _MMEnterpriseController["default"].setCustomIcon4File(params, function () {
        _this5.close();
        _MDSnackbarView["default"].show(BabelStr.str(308));
        try {
          if (_this5.coverSubFiles || _this5.apply2sameType) {
            window.dexieDB.file_default_thumbs.clear();
          } else {
            var curTime = new Date().getTime();
            window.dexieDB.file_default_thumbs.put({
              fileId: _this5.fileInfor.getFileId(),
              asIconType: params.asIconType,
              customIconId: params.customIconId,
              time: curTime
            });
          }
        } catch (error) {
          console.log(error);
        }
        Dispatcher.trigger(MDEvents.RefreshIcon, {
          fileId: params.fileId
        });
        if (_this5.apply2sameType) {
          Dispatcher.trigger(MDEvents.RefreshCurFolder);
        }
      }, function (err) {
        _MDMessageView["default"].success(err.msg || BabelStr.str(309), _this5.$body);
      });
    }
  }]);
  return MDFileThumbEditWinView;
}(_MDWindowView2["default"]);

},{"1098":1098,"1119":1119,"1172":1172,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1199":1199,"1411":1411,"1412":1412,"1420":1420,"1423":1423,"1425":1425,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1471":1471,"1475":1475,"1477":1477,"1489":1489,"1505":1505,"1506":1506,"1507":1507,"1508":1508,"1509":1509,"1510":1510,"1512":1512,"1513":1513,"1514":1514,"1516":1516,"1517":1517,"1518":1518,"1519":1519,"1520":1520,"1521":1521,"1522":1522,"1523":1523,"1524":1524,"1525":1525,"1526":1526,"1527":1527,"1528":1528,"1529":1529,"1530":1530,"17":17,"32":32,"37":37,"55":55,"72":72,"93":93}],579:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1418);
require(1463);
require(1537);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDSpinnerloaderLayerView = _interopRequireDefault(require(75));
var _MDNetDriveFileHandler = _interopRequireDefault(require(1091));
var _MDPaginationView = _interopRequireDefault(require(61));
var _MMViewBase2 = _interopRequireDefault(require(22));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDRelateFileContextMenu = _interopRequireDefault(require(593));
var _MMBasicData = _interopRequireDefault(require(811));
var _popupPos = _interopRequireDefault(require(65));
var _MDShowLinkFileWinView = _interopRequireDefault(require(632));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 *  view , file relation list
 *  Created by jiang
 *  2018.4.27
 */
var MDFileRelationListView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MDFileRelationListView, _MMViewBase);
  function MDFileRelationListView() {
    (0, _classCallCheck2["default"])(this, MDFileRelationListView);
    return _callSuper(this, MDFileRelationListView, arguments);
  }
  (0, _createClass2["default"])(MDFileRelationListView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n      <ul class=\"file-relation-list\"></ul>\n    ";
    }
  }, {
    key: "refItemTmpl",
    value: function refItemTmpl() {
      return "\n    <li id=\"<%=fileId%>\" data-id=\"<%=fileId%>\" class=\"file-ref-1 flex-align\">\n      <div class=\"file-icon openf icon30\"></div>\n      <div class=\"file-name openf fullfill mgl-10\">\n        <span><%=name%></span>\n      </div>\n      <%if(fromAddWin) {%>\n        <div data-id=\"<%=fileId%>\" class=\"open-folder\"><%=BabelStr.str(265)%></div>\n      <%}%>\n      <%if (canDel){%>\n        <button id=\"<%=fileId%>\" class=\"icon icon-del\" data-tooltip=\"<%=delprompt%>\" ></button>\n      <%}%>\n    </li>";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileRelationListView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        fromAddWin: false
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileRelationListView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .icon-del': this._delBtnClicked,
        'click .attr-addrel': this._addRelation,
        'click .openf': this._fileClicked,
        'contextmenu .file-ref-1': this._onContextMenu,
        'click .open-folder': this._openFolderHandle
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileRelationListView.prototype), "className", this).call(this);
      return "".concat(superCls, " file-relation-contaier");
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileRelationListView.prototype), "initialize", this).call(this, opt);
      this.$fileRelationList = this.$(".file-relation-list");
      this.renderFileRelations();
    }
  }, {
    key: "renderEmpty",
    value: function renderEmpty() {
      this.$('.file-relation-list').html("<div class=\"mgtb-20 pdtb-20 f-tc\">".concat(BabelStr.str(3454), "</div>"));
    }
  }, {
    key: "_openFolderHandle",
    value: function _openFolderHandle(e) {
      console.log('------------- right clicked!');
      e.preventDefault();
      e.stopPropagation();
      var $target = $(e.target);
      var fileId = $target.data("id");
      var fileInfo = this._getFilInfoById(fileId);
      var folderId = fileInfo.getParentFolderId();
      app.pathRouter.openNewTabByFileId(folderId);
      // Dispatcher.trigger(MDEvents.OpenFolderFromOtherChannel, { fileId: fileId, fileInfo: this.fileInfo });
    }
  }, {
    key: "_addRelation",
    value: function _addRelation(e) {
      var self = this;
      var win = new _MDShowLinkFileWinView["default"]({
        fileInfor: this.fileInfo,
        onClose: function onClose() {
          self.renderFileRelations();
        }
        // edit: false
      });
      win.show();
    }
  }, {
    key: "addRelationFile",
    value: function addRelationFile(fileInfo) {
      _czc && _czc.push(["_trackEvent", "文件操作", "建立关联", "", "", ""]);
      var self = this;
      _MDSpinnerloaderLayerView["default"].showIn(this.$fileRelationList[0]);
      _MDNetDriveFileHandler["default"].createFileRelation(this.fileInfo.getFileId(), fileInfo.getFileId(), function () {
        _MDSpinnerloaderLayerView["default"].clearFrom(self.$fileRelationList[0]);
        _MDSnackbarView["default"].showStandardMsg(6);
        self.renderFileRelations();
      }, function () {
        _MDSpinnerloaderLayerView["default"].clearFrom(self.$fileRelationList[0]);
        _MDSnackbarView["default"].showStandardMsg(5);
      });
    }
  }, {
    key: "renderFileRelations",
    value: function renderFileRelations() {
      var self = this;
      this.$fileRelationList.empty();
      _MDSpinnerloaderLayerView["default"].showIn(this.$fileRelationList[0]);
      _MDNetDriveFileHandler["default"].getFileRelations(this.fileInfo.getFileId(), function success(fileInfos) {
        self.relateFileInfos = fileInfos;
        _MDSpinnerloaderLayerView["default"].clearFrom(self.$fileRelationList[0]);
        var tmpl = self.refItemTmpl();
        fileInfos.forEach(function (fileInfo) {
          var fileId = fileInfo.getFileId();
          var obj = {
            'fileId': fileId,
            'name': fileInfo.getFileName(),
            'canDel': self.fileInfo.canRename(),
            'delprompt': BabelStr.str(5071),
            'fromAddWin': self.fromAddWin
          };
          var refHtml = _.template(tmpl)(obj);
          self.$fileRelationList.append(refHtml);
          var $icon = self.$('#' + fileId + ' .file-icon');
          fileInfo.setIconForDiv($icon, false, 30);
        });
        if (self.fileInfo.canRename() && !self.fromAddWin && !self.fileInfo.get('forClient')) {
          self.$fileRelationList.append('<button class="attr-addrel icon" data-tooltip="' + BabelStr.str(3452) + '" data-tooltip-dir="bottom"></button>');
        }
        if (!fileInfos.length && self.fromAddWin) {
          self.renderEmpty();
        }
        self.navigationWindowView && self.navigationWindowView.refreshWindow();
      }, function () {
        _MDSpinnerloaderLayerView["default"].clearFrom(self.$fileRelationList[0]);
      });
    }
  }, {
    key: "_delBtnClicked",
    value: function _delBtnClicked(e) {
      var target = e.target;
      var fileId = target.id;
      var self = this;
      e.preventDefault();
      e.stopPropagation();
      _MDAlertView["default"].showStandardSelection({
        message: BabelStr.str(5072),
        okFun: function okFun() {
          _MDSpinnerloaderLayerView["default"].showIn(self.$fileRelationList[0]);
          _MDNetDriveFileHandler["default"].deleteFileRelation(self.fileInfo.getFileId(), fileId, function () {
            _MDSpinnerloaderLayerView["default"].clearFrom(self.$fileRelationList[0]);
            _MDSnackbarView["default"].showStandardMsg(6);
            self.renderFileRelations();
          }, function () {
            _MDSnackbarView["default"].showStandardMsg(5);
            _MDSpinnerloaderLayerView["default"].clearFrom(self.$fileRelationList[0]);
          });
        }
      });
      console.log('------------ deleted!');
    }
  }, {
    key: "_fileClicked",
    value: function _fileClicked(e) {
      e.preventDefault();
      e.stopPropagation();
      var $target = $(e.target).closest('.file-ref-1');
      var fileId = $target.data('id');
      if (this.fromAddWin) {
        app.pathRouter.openNewTabByFileId(fileId);
        return;
      }
      var fileInfo = this._getFilInfoById(fileId);
      if (fileInfo) {
        var dispCtl = MDPCDisplayFileController.getSingleton();
        dispCtl.openFileWithoutRouter(fileInfo, -1);
      }
    }
  }, {
    key: "_getFilInfoById",
    value: function _getFilInfoById(fileId) {
      var fileInfo = null;
      for (var i = 0; i < this.relateFileInfos.length; i++) {
        var f = this.relateFileInfos[i];
        if (f.getFileId() == fileId) {
          fileInfo = f;
          break;
        }
      }
      return fileInfo;
    }
  }, {
    key: "_onContextMenu",
    value: function _onContextMenu(e) {
      console.log('------------- right clicked!');
      e.preventDefault();
      e.stopPropagation();
      if (this.fromAddWin) {
        return;
      }
      var target = e.currentTarget;
      var fileId = target.id;
      var fileInfo = this._getFilInfoById(fileId);
      var contextmenu = new _MDRelateFileContextMenu["default"]({
        fileInfo: fileInfo
      });
      var z_startIndex = _MMBasicData["default"].getO2OStartLayerZ_index();
      contextmenu.$el.css("z-index", z_startIndex);
      var self = this;
      contextmenu.show({
        triggerView: e.currentTarget,
        direction: _popupPos["default"].TOP,
        center: true,
        width: 200,
        onClose: function onClose() {}
      });
    }
  }]);
  return MDFileRelationListView;
}(_MMViewBase2["default"]);

},{"1091":1091,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1418":1418,"1454":1454,"1463":1463,"1475":1475,"1537":1537,"22":22,"32":32,"593":593,"61":61,"632":632,"65":65,"72":72,"75":75,"811":811}],632:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationWindowView = _interopRequireDefault(require(92));
var _MDLinkFilesPanelView = _interopRequireDefault(require(631));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDShowLinkFileWinView = exports["default"] = /*#__PURE__*/function (_MDNavigationWindowVi) {
  (0, _inherits2["default"])(MDShowLinkFileWinView, _MDNavigationWindowVi);
  function MDShowLinkFileWinView() {
    (0, _classCallCheck2["default"])(this, MDShowLinkFileWinView);
    return _callSuper(this, MDShowLinkFileWinView, arguments);
  }
  (0, _createClass2["default"])(MDShowLinkFileWinView, [{
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDShowLinkFileWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        fileInfor: null
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDShowLinkFileWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " link-file-win");
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      opt.width = 830;
      opt.needFooter = false;
      opt.title = BabelStr.str(6023);
      opt.rootNavigationPageView = new _MDLinkFilesPanelView["default"](opt);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDShowLinkFileWinView.prototype), "initialize", this).call(this, opt);
    }
  }, {
    key: "setFileInfors",
    value: function setFileInfors(fileInfors) {
      this.rootNavigationPageView.setSelectedFileInfos(fileInfors);
    }
  }]);
  return MDShowLinkFileWinView;
}(_MDNavigationWindowView["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"631":631,"92":92}],631:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDFileRelationListView = _interopRequireDefault(require(579));
var _MDAllFileSelectPageView = _interopRequireDefault(require(544));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDLinkFilesPanelView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDLinkFilesPanelView, _MDNavigationPageView);
  function MDLinkFilesPanelView() {
    (0, _classCallCheck2["default"])(this, MDLinkFilesPanelView);
    return _callSuper(this, MDLinkFilesPanelView, arguments);
  }
  (0, _createClass2["default"])(MDLinkFilesPanelView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n\t\t\t<div class=\"flex-align between middle\">\n\t\t\t\t<div class=\"mgb-10\"><%=BabelStr.str(3453)%>:</div>\n\t\t\t\t<button class=\"text-button done add-link mgtb-10\"><%=BabelStr.str(3452)%></button>\n\t\t\t</div>\n\t\t\t<div class=\"file-content\"></div>\n\t\t\t<div class=\"flex-align end btns-block\">\n\t\t\t\t<button class=\"button done cancel\"><%=BabelStr.str(156)%></button>\n\t\t\t</div>\n\t\t";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDLinkFilesPanelView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        fileInfor: null
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDLinkFilesPanelView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .add-link': this._addLinkFile,
        'click .cancel': this._close
      });
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDLinkFilesPanelView.prototype), "initialize", this).call(this, opt);
      this.linkListView = new _MDFileRelationListView["default"]({
        fileInfo: this.fileInfor,
        fromAddWin: true
      });
      this.addSubView(this.linkListView, this.$('.file-content')[0]);
    }
  }, {
    key: "_close",
    value: function _close() {
      this.navigationWindowView.close();
    }
  }, {
    key: "_addLinkFile",
    value: function _addLinkFile() {
      var _this = this;
      console.log('添加相关文件' + this.fileInfor.getFileName());
      var selectFilePageView = new _MDAllFileSelectPageView["default"]({
        title: BabelStr.str(3707),
        multiple: false,
        onselectedSuccess: function onselectedSuccess(files) {
          console.log(files);
          _this.linkListView.addRelationFile(files[0]);
        }
      });
      this.navigationWindowView.push(selectFilePageView);
    }
  }]);
  return MDLinkFilesPanelView;
}(_MDNavigationPageView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"544":544,"56":56,"579":579}],593:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDPopupView = _interopRequireDefault(require(64));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDEvents = _interopRequireDefault(require(325));
/**
 *  Menu for 相关文件的鼠标右键
 *  Create by jiang
 *  2018.7.11
 */

var MDRelateFileContextMenu = _MDPopupView["default"].extend({
  contentTmpl: '<ul class="m-menu"></ul>',
  events: function events() {
    var superEvents = _MDPopupView["default"].prototype.events.call(this);
    return _.extend({}, superEvents, {
      'click li': this._menuItemClickHandler
    });
  },
  initProps: function initProps() {
    var superP = _MDPopupView["default"].prototype.initProps.call(this);
    return _.extend(superP, {});
  },
  initialize: function initialize(opt) {
    _MDPopupView["default"].prototype.initialize.call(this, opt);
    this.initMenuList();
  },
  initMenuList: function initMenuList() {
    this.menuItems = [BabelStr.str(265)];
    if (this.$menuList) {
      this.$menuList.remove();
    }
    var html = "";
    for (var i = 0; i < this.menuItems.length; i++) {
      var item = this.menuItems[i];
      html += "<li >" + item + "</li>";
    }
    ;
    this.$(".m-menu").append(html);
    this.$menuList = $(html);
  },
  _menuItemClickHandler: function _menuItemClickHandler($e) {
    var index = $($e.target).index();
    var fileId = this.fileInfo.getParentFolderId();
    _Dispatcher["default"].trigger(_MDEvents["default"].OpenFolderFromOtherChannel, {
      fileId: fileId,
      fileInfo: this.fileInfo
    });
    this.close();
  }
});
var _default = exports["default"] = MDRelateFileContextMenu;

},{"1184":1184,"1454":1454,"18":18,"325":325,"64":64}],577:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDFilelogPanelView = _interopRequireDefault(require(586));
var _MEStatisticsPersonTabPanelView = _interopRequireDefault(require(214));
var _MEStatisticsPersonTabPanelViewNew = _interopRequireDefault(require(215));
var _MDFileLogTabPanel = _interopRequireDefault(require(575));
var _MDTabView = _interopRequireDefault(require(82));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 *  window , file log
 *  Created jiang
 *  2019.5.24
 */
var MDFileOpStatisitcsWindow = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDFileOpStatisitcsWindow, _MDWindowView);
  function MDFileOpStatisitcsWindow() {
    (0, _classCallCheck2["default"])(this, MDFileOpStatisitcsWindow);
    return _callSuper(this, MDFileOpStatisitcsWindow, arguments);
  }
  (0, _createClass2["default"])(MDFileOpStatisitcsWindow, [{
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileOpStatisitcsWindow.prototype), "className", this).call(this);
      return superCls + ' file-op-statistic user-statistics-win';
    }
  }, {
    key: "contentTmpl",
    value: function contentTmpl() {
      return '<div class="statis-container" >' + '</div>';
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      opt.title = BabelStr.str(7180);
      opt.width = 900;
      opt.needFooter = false;
      opt.curIndex = opt.curIndex || 0;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileOpStatisitcsWindow.prototype), "initialize", this).call(this, opt);
      this._initTabPanels();
    }
  }, {
    key: "_initTabPanels",
    value: function _initTabPanels() {
      var cls;
      if (window.user.useAdvancedSearch) {
        cls = _MEStatisticsPersonTabPanelViewNew["default"];
      } else {
        cls = _MEStatisticsPersonTabPanelView["default"];
      }
      this.statisticPanel = new cls({
        showDep: false,
        depFolderId: this.fileInfor.getFileId(),
        depId: this.fileInfor.get('departmentId')
      });
      this.logPanle = new _MDFileLogTabPanel["default"]({
        fileInfor: this.fileInfor
      });
      this.tabContainer = new _MDTabView["default"]({
        className: 'statistic-tabs blue-style-tab1 block tab-win',
        tabBarDividerPosition: 2,
        fullMode: false,
        enableActivebar: false,
        activeIndex: this.curIndex,
        tabs: [{
          title: BabelStr.str(7183),
          tabPanelView: this.statisticPanel,
          active: true
        }, {
          title: BabelStr.str(3575),
          tabPanelView: this.logPanle
        }]
      });
      this.tabContainer.activeTabAt(this.curIndex);
      this.addSubView(this.tabContainer, this.$('.statis-container'));
    }
  }]);
  return MDFileOpStatisitcsWindow;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"214":214,"215":215,"575":575,"586":586,"82":82,"93":93}],575:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDTabPanelView = _interopRequireDefault(require(81));
var _MDFilelogPanelView = _interopRequireDefault(require(586));
var MDFileLogTabPanel = _MDTabPanelView["default"].extend({
  tmpl: "\n  <div class=\"file-log-container\"></div>\n  ",
  initialize: function initialize(opt) {
    _MDTabPanelView["default"].prototype.initialize.call(this, opt);
    this.$('.tab-panel-wrapper').addClass('block');
  },
  onActived: function onActived() {
    if (!this.logPanel) {
      this.logPanel = new _MDFilelogPanelView["default"]({
        fileInfor: this.fileInfor
      });
      this.addSubView(this.logPanel, this.$('.file-log-container'));
    }
  }
});
var _default = exports["default"] = MDFileLogTabPanel;

},{"1184":1184,"1454":1454,"586":586,"81":81}],215:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1437);
require(1466);
require(1463);
require(1478);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MEDepartChooseView = _interopRequireDefault(require(138));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDPaginationView = _interopRequireDefault(require(61));
var _MEStatisticsFileListTabPanelView = _interopRequireDefault(require(213));
var _regexp = _interopRequireDefault(require(106));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /*
	人员工作量
	create by jichao
	2019.5.13
*/
var MEStatisticsPersonTabPanelViewNew = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(MEStatisticsPersonTabPanelViewNew, _MDTabPanelView);
  function MEStatisticsPersonTabPanelViewNew() {
    (0, _classCallCheck2["default"])(this, MEStatisticsPersonTabPanelViewNew);
    return _callSuper(this, MEStatisticsPersonTabPanelViewNew, arguments);
  }
  (0, _createClass2["default"])(MEStatisticsPersonTabPanelViewNew, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n      <div class=\"statistics-block\">\n        <div class=\"select-block flex-align middle mgtb-20\">\n          <%if(showDep){%>\n            <span class=\"mgr-20\"><%=BabelStr.str(20150)%>:</span>\n            <div class=\"dep-content mgr-20\"></div>\n          <%}%>\n          <span class=\"mgr-15 no-shrink\"><%=BabelStr.str(2670)%></span>\n          <span class = \"datepicker mgr-10\">\n            <input type=\"text\" class=\"date-from\"  placeholder=\"<%=BabelStr.str(616)%>\" readonly>\n            <i class = \"ep-ic ep-ic-date\"></i>\n          </span>\n          <span class = \"datepicker mgr-15\">\n            <input type=\"text\" class=\"date-to\" placeholder=\"<%= BabelStr.str(617)%>\" readonly>\n            <i class = \"ep-ic ep-ic-date\"></i>\n          </span>\n          <button class=\"button done search\"><%=BabelStr.str(3491)%></button>\n        </div>\n        <div class=\"person-block\"></div>\n        <div class=\"empty f-none\"><%=BabelStr.str(3485)%></div>\n        <div class=\"page-bar mgt-10\"></div>\n      </div>\n      <div class=\"user-statistics-container f-none\">\n        <div class=\"flex-align between middle mgt-20 mgb-10\">\n          <div class=\"type-text\"></div>\n          <div class=\"text-button done cancel\"><%=BabelStr.str(74)%></div>\n        </div>\n        <div class=\"user-statistics-block\"></div>\n\n      </div>\n\t\t";
    }
  }, {
    key: "tableTmpl",
    value: function tableTmpl(data) {
      var tmpl = '';
      if (data.length) {
        for (var i = 0; i < data.length; i++) {
          tmpl += "<tr\">\n          <td class='item' data-type='0'>".concat(data[i].label, "</td>\n          <td class='item' data-type='3'>").concat(data[i].doc_count, "</td>\n        </tr>");
        }
        return "<table>\n      <tr>\n        <th>".concat(BabelStr.str(279), "</th>\n        <th>").concat(BabelStr.str(598), "</th>\n      </tr>\n      ").concat(tmpl, "\n      </table>");
      }
      return "<div class=\"pdtb-20 f-tc\">".concat(BabelStr.str(2622), "</div>");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStatisticsPersonTabPanelViewNew.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        fileId: '',
        showDep: true,
        pageSize: 10,
        startIndex: 0
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStatisticsPersonTabPanelViewNew.prototype), "className", this).call(this);
      return "".concat(superCls, " statistics-person-panel");
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        showDep: this.showDep
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStatisticsPersonTabPanelViewNew.prototype), "render", this).call(this, data);
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStatisticsPersonTabPanelViewNew.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .search': this.renderDataTable,
        // 'click .item': this._showInfo,         // --------------------  暂时去掉数字的鼠标点击事件
        'click .cancel': this._cancel
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStatisticsPersonTabPanelViewNew.prototype), "initialize", this).call(this, props);
      var $from = this.$(".date-from");
      var $to = this.$(".date-to");
      var self = this;
      $from.datepicker().on("change", function () {
        $to.datepicker("option", "minDate", this.value);
        self.startTime = MMCommonFun.getStartTime($from.datepicker("getDate")).getTime() / 1000;
        if (!self.startTime) {
          self.startTime = undefined;
        }
        console.log(self.startTime);
      });
      $to.datepicker().on("change", function () {
        $from.datepicker("option", "maxDate", this.value);
        self.endTime = MMCommonFun.getEndTime($to.datepicker("getDate")).getTime() / 1000;
        if (!self.endTime) {
          self.endTime = undefined;
        }
        console.log(self.startTime);
      });
      var now = new Date().getTime();
      var from = now - 1000 * 60 * 60 * 24 * 7;
      this.startTime = MMCommonFun.getStartTime(from) / 1000;
      this.endTime = MMCommonFun.getEndTime(now) / 1000;
      $from.datepicker("setDate", new Date(from));
      $to.datepicker("setDate", new Date(now));
    }
  }, {
    key: "renderDataTable",
    value: function renderDataTable() {
      var _this = this;
      if (!this.endTime || !this.startTime) {
        return;
      }
      var series0 = BabelStr.str(3484);
      var title = BabelStr.str(3486);
      this.$('.person-block').empty();
      _MDSpinnerloaderView["default"].showIn(this.$('.person-block')[0]);
      var options = {
        depFolderId: this.depFolderId,
        startTime: this.startTime,
        endTime: this.endTime
      };
      MMEnterpriseController.statistics.countCreationInDepartmentByES(options, function (teamMarks, types) {
        _MDSpinnerloaderView["default"].clearFrom(_this.$('.person-block')[0]);
        var data = teamMarks.concat(types);
        var tmpl = _this.tableTmpl(data);
        _this.$('.person-block').html(tmpl);
        // this.paginationBarView.setLength(count, true, this.startIndex);
        // if (count > 0) {
        //   this.paginationBarView.show();
        // }else{
        //   this.paginationBarView.hide();
        // }
      }, function () {});
    }
  }, {
    key: "_showInfo",
    value: function _showInfo(e) {
      var count = parseInt($(e.target).html());
      console.log(count);
      if (!count) {
        return;
      }
      var type = parseInt($(e.target).data('type'));
      var id = $(e.target).closest('tr').data('id').toString();
      this.userView = new _MEStatisticsFileListTabPanelView["default"]({
        fileId: this.depFolderId,
        count: count,
        type: type,
        userId: id,
        startTime: this.startTime,
        endTime: this.endTime
      });
      this.addSubView(this.userView, this.$('.user-statistics-block')[0]);
      this.$('.statistics-block').hide();
      var typeText = '';
      switch (type) {
        case 0:
          typeText = BabelStr.str(6016);
          break;
        case 1:
          typeText = BabelStr.str(6017);
          break;
        case 2:
          typeText = BabelStr.str(6018);
          break;
        case 3:
          typeText = BabelStr.str(6019);
          break;
        case 4:
          typeText = BabelStr.str(6020);
          break;
      }
      this.$('.type-text').text(typeText);
      this.$('.user-statistics-container').show();
    }
  }, {
    key: "onActived",
    value: function onActived() {
      var _this2 = this;
      if (!this.loaded) {
        this.loaded = true;
        if (this.showDep) {
          this.departChooseView = new _MEDepartChooseView["default"]({
            readonly: true,
            needRoot: true,
            monitoredScroller: '.app-person-panel',
            onReady: function onReady() {
              _this2.departChooseView.selectRoot();
              var rootNode = _this2.departChooseView.getRootNode();
              _this2.depId = rootNode.id;
              _this2.depFolderId = rootNode.folderId;
              _this2.renderDataTable();
            },
            onInputChange: function onInputChange(text) {
              if (text === '') {
                _this2.depFolderId = null;
              }
            },
            onChange: function onChange(departInfo, originNode) {
              _this2.depId = departInfo.id;
              _this2.depFolderId = originNode.folderId;
            }
          });
          this.addSubView(this.departChooseView, this.$('.dep-content')[0]);
        } else {
          this.renderDataTable();
        }

        // this.paginationBarView = new MDPaginationView({
        //   silentInit: true,
        //   pageSize: this.pageSize,
        //   onPageChanged: curPageIndex => {
        //     this.startIndex=curPageIndex * this.pageSize;
        //     this.renderDataTable();
        //   },
        //   onPageSizeChanged: (newPageSize) => {
        //     this.pageSize = newPageSize;
        //     this.startIndex = 0;
        //     this.renderDataTable();
        //   }
        // });
        // this.addSubView(this.paginationBarView, this.$('.page-bar')[0]);
      }
    }
  }, {
    key: "_cancel",
    value: function _cancel() {
      this.$('.user-statistics-container').hide();
      this.$('.statistics-block').show();
      if (this.userView) {
        this.removeSubView(this.userView);
      }
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStatisticsPersonTabPanelViewNew.prototype), "viewDidRendered", this).call(this);
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MEStatisticsPersonTabPanelViewNew';
    }
  }]);
  return MEStatisticsPersonTabPanelViewNew;
}(_MDTabPanelView2["default"]);

},{"106":106,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"138":138,"1412":1412,"1437":1437,"1454":1454,"1463":1463,"1466":1466,"1475":1475,"1478":1478,"213":213,"61":61,"76":76,"81":81}],214:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1466);
require(1412);
require(1437);
require(1463);
require(1478);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MEDepartChooseView = _interopRequireDefault(require(138));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDPaginationView = _interopRequireDefault(require(61));
var _MEStatisticsFileListTabPanelView = _interopRequireDefault(require(213));
var _regexp = _interopRequireDefault(require(106));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /*
  人员工作量
  create by jichao
  2019.5.13
*/
var MEStatisticsPersonTabPanelView = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(MEStatisticsPersonTabPanelView, _MDTabPanelView);
  function MEStatisticsPersonTabPanelView() {
    (0, _classCallCheck2["default"])(this, MEStatisticsPersonTabPanelView);
    return _callSuper(this, MEStatisticsPersonTabPanelView, arguments);
  }
  (0, _createClass2["default"])(MEStatisticsPersonTabPanelView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n      <div class=\"statistics-block\">\n        <div class=\"select-block flex-align middle mgtb-20\">\n          <%if(showDep){%>\n            <span class=\"mgr-20\"><%=BabelStr.str(20150)%>:</span>\n            <div class=\"dep-content mgr-20\"></div>\n          <%}%>\n          <span class=\"mgr-15 no-shrink\"><%=BabelStr.str(2670)%></span>\n          <span class = \"datepicker mgr-10\">\n            <input type=\"text\" class=\"date-from\"  placeholder=\"<%=BabelStr.str(616)%>\" readonly>\n            <i class = \"ep-ic ep-ic-date\"></i>\n          </span>\n          <span class = \"datepicker mgr-15\">\n            <input type=\"text\" class=\"date-to\" placeholder=\"<%= BabelStr.str(617)%>\" readonly>\n            <i class = \"ep-ic ep-ic-date\"></i>\n          </span>\n          <button class=\"button done search\"><%=BabelStr.str(3491)%></button>\n        </div>\n        <div class=\"person-block\"></div>\n        <div class=\"empty f-none\"><%=BabelStr.str(3485)%></div>\n        <div class=\"page-bar mgt-10\"></div>\n      </div>\n      <div class=\"user-statistics-container f-none\">\n        <div class=\"flex-align between middle mgt-20 mgb-10\">\n          <div class=\"type-text\"></div>\n          <div class=\"text-button done cancel\"><%=BabelStr.str(74)%></div>\n        </div>\n        <div class=\"user-statistics-block\"></div>\n\n      </div>\n    ";
    }
  }, {
    key: "tableTmpl",
    value: function tableTmpl(folderCounts, fileCount) {
      var tmpl = '';
      var classesStr = "pointer text-button bright-blue";
      classesStr = ""; // ----------------------- 暂时去掉可以鼠标点击的样式

      var folderC = _.findWhere(folderCounts, {
        teamMark: 0
      }) || {};
      folderC = folderC.count || 0;
      folderC = parseInt(folderC);
      var depC = _.findWhere(folderCounts, {
        teamMark: 2
      }) || {};
      depC = depC.count || 0;
      depC = parseInt(depC);
      var proC = _.findWhere(folderCounts, {
        teamMark: 5
      }) || {};
      proC = proC.count || 0;
      proC = parseInt(proC);
      var hProC = _.findWhere(folderCounts, {
        teamMark: 7
      }) || {};
      hProC = hProC.count || 0;
      hProC = parseInt(hProC);
      var projectC = proC + hProC;
      tmpl = "<tr\">\n        <td class='item ".concat(fileCount ? classesStr : "", "' data-type='2'>").concat(fileCount || 0, "</td>\n        <td class='item ").concat(folderC ? classesStr : "", "' data-type='1'>").concat(folderC || 0, "</td>\n        <td class='item ").concat(projectC ? classesStr : "", "' data-type='0'>").concat(projectC || 0, "</td>\n        <td class='item ").concat(depC ? classesStr : "", "' data-type='3'>").concat(depC || 0, "</td>\n      </tr>");
      return "<table>\n      <tr>\n        <th>".concat(BabelStr.str(9), "</th>\n        <th>").concat(BabelStr.str(20153), "</th>\n        <th>").concat(BabelStr.str(20152), "</th>\n        <th>").concat(BabelStr.str(20151), "</th>\n      </tr>\n      ").concat(tmpl, "\n      </table>");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStatisticsPersonTabPanelView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        fileId: '',
        showDep: true,
        pageSize: 10,
        startIndex: 0
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStatisticsPersonTabPanelView.prototype), "className", this).call(this);
      return "".concat(superCls, " statistics-person-panel");
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        showDep: this.showDep
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStatisticsPersonTabPanelView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStatisticsPersonTabPanelView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .search': this.renderDataTable,
        // 'click .item': this._showInfo,         // --------------------  暂时去掉数字的鼠标点击事件
        'click .cancel': this._cancel
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStatisticsPersonTabPanelView.prototype), "initialize", this).call(this, props);
      var $from = this.$(".date-from");
      var $to = this.$(".date-to");
      var self = this;
      $from.datepicker().on("change", function () {
        $to.datepicker("option", "minDate", this.value);
        self.startTime = MMCommonFun.getStartTime($from.datepicker("getDate")).getTime() / 1000;
        if (!self.startTime) {
          self.startTime = undefined;
        }
        console.log(self.startTime);
      });
      $to.datepicker().on("change", function () {
        $from.datepicker("option", "maxDate", this.value);
        self.endTime = MMCommonFun.getEndTime($to.datepicker("getDate")).getTime() / 1000;
        if (!self.endTime) {
          self.endTime = undefined;
        }
        console.log(self.startTime);
      });
      var now = new Date().getTime();
      var from = now - 1000 * 60 * 60 * 24 * 7;
      this.startTime = MMCommonFun.getStartTime(from) / 1000;
      this.endTime = MMCommonFun.getEndTime(now) / 1000;
      $from.datepicker("setDate", new Date(from));
      $to.datepicker("setDate", new Date(now));
    }
  }, {
    key: "renderDataTable",
    value: function renderDataTable() {
      var _this = this;
      if (!this.endTime || !this.startTime) {
        return;
      }
      var series0 = BabelStr.str(3484);
      var title = BabelStr.str(3486);
      this.$('.person-block').empty();
      _MDSpinnerloaderView["default"].showIn(this.$('.person-block')[0]);
      var options = {
        depId: this.depId,
        depFolderId: this.depFolderId,
        startIndex: this.startIndex,
        pageSize: this.pageSize,
        startTime: this.startTime,
        endTime: this.endTime
      };
      MMEnterpriseController.statistics.countCreationInDepartment(options, function (folderCounts, fileCount) {
        _MDSpinnerloaderView["default"].clearFrom(_this.$('.person-block')[0]);
        var tmpl = _this.tableTmpl(folderCounts, fileCount);
        _this.$('.person-block').html(tmpl);
        // this.paginationBarView.setLength(count, true, this.startIndex);
        // if (count > 0) {
        //   this.paginationBarView.show();
        // }else{
        //   this.paginationBarView.hide();
        // }
      }, function () {});
    }
  }, {
    key: "_showInfo",
    value: function _showInfo(e) {
      var count = parseInt($(e.target).html());
      console.log(count);
      if (!count) {
        return;
      }
      var type = parseInt($(e.target).data('type'));
      var id = $(e.target).closest('tr').data('id').toString();
      this.userView = new _MEStatisticsFileListTabPanelView["default"]({
        fileId: this.depFolderId,
        count: count,
        type: type,
        userId: id,
        startTime: this.startTime,
        endTime: this.endTime
      });
      this.addSubView(this.userView, this.$('.user-statistics-block')[0]);
      this.$('.statistics-block').hide();
      var typeText = '';
      switch (type) {
        case 0:
          typeText = BabelStr.str(6016);
          break;
        case 1:
          typeText = BabelStr.str(6017);
          break;
        case 2:
          typeText = BabelStr.str(6018);
          break;
        case 3:
          typeText = BabelStr.str(6019);
          break;
        case 4:
          typeText = BabelStr.str(6020);
          break;
      }
      this.$('.type-text').text(typeText);
      this.$('.user-statistics-container').show();
    }
  }, {
    key: "onActived",
    value: function onActived() {
      var _this2 = this;
      if (!this.loaded) {
        this.loaded = true;
        if (this.showDep) {
          this.departChooseView = new _MEDepartChooseView["default"]({
            readonly: true,
            needRoot: true,
            monitoredScroller: '.app-person-panel',
            onReady: function onReady() {
              _this2.departChooseView.selectRoot();
              var rootNode = _this2.departChooseView.getRootNode();
              _this2.depId = rootNode.id;
              _this2.depFolderId = rootNode.folderId;
              _this2.renderDataTable();
            },
            onInputChange: function onInputChange(text) {
              if (text === '') {
                _this2.depFolderId = null;
              }
            },
            onChange: function onChange(departInfo, originNode) {
              _this2.depId = departInfo.id;
              _this2.depFolderId = originNode.folderId;
            }
          });
          this.addSubView(this.departChooseView, this.$('.dep-content')[0]);
        } else {
          this.renderDataTable();
        }

        // this.paginationBarView = new MDPaginationView({
        //   silentInit: true,
        //   pageSize: this.pageSize,
        //   onPageChanged: curPageIndex => {
        //     this.startIndex=curPageIndex * this.pageSize;
        //     this.renderDataTable();
        //   },
        //   onPageSizeChanged: (newPageSize) => {
        //     this.pageSize = newPageSize;
        //     this.startIndex = 0;
        //     this.renderDataTable();
        //   }
        // });
        // this.addSubView(this.paginationBarView, this.$('.page-bar')[0]);
      }
    }
  }, {
    key: "_cancel",
    value: function _cancel() {
      this.$('.user-statistics-container').hide();
      this.$('.statistics-block').show();
      if (this.userView) {
        this.removeSubView(this.userView);
      }
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStatisticsPersonTabPanelView.prototype), "viewDidRendered", this).call(this);
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MEStatisticsPersonTabPanelView';
    }
  }]);
  return MEStatisticsPersonTabPanelView;
}(_MDTabPanelView2["default"]);

},{"106":106,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"138":138,"1412":1412,"1437":1437,"1454":1454,"1463":1463,"1466":1466,"1475":1475,"1478":1478,"213":213,"61":61,"76":76,"81":81}],213:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1437);
require(1463);
require(1478);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDPaginationView = _interopRequireDefault(require(61));
var _MDPCDisplayFileController = _interopRequireDefault(require(422));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MMViewBase2 = _interopRequireDefault(require(22));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MEStatisticsFileListTabPanelView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MEStatisticsFileListTabPanelView, _MMViewBase);
  function MEStatisticsFileListTabPanelView() {
    (0, _classCallCheck2["default"])(this, MEStatisticsFileListTabPanelView);
    return _callSuper(this, MEStatisticsFileListTabPanelView, arguments);
  }
  (0, _createClass2["default"])(MEStatisticsFileListTabPanelView, [{
    key: "tmpl",
    value: function tmpl() {
      return "<div class=\"file-list\"></div>\n\t\t  <div class=\"page-bar mgt-10\"></div>";
    }
  }, {
    key: "listTmpl",
    value: function listTmpl(data) {
      var tmpl = "<div class=\"flex-align middle between item\">\n\t\t\t\t<div class=\"name fullfill\">".concat(BabelStr.str(49), "</div>\n\t\t\t\t<div class=\"time no-shrink\">").concat(BabelStr.str(3172), "</div>\n\t\t\t\t<div class=\"folder-title no-shrink\">").concat(BabelStr.str(136), "</div>\n\t\t\t</div>");
      for (var i = 0; i < data.length; i++) {
        var time = tmpl += "<div class=\"flex-align middle between item\">\n\t\t\t\t<div class=\"name pointer fullfill main-color\" data-id=\"".concat(data[i].fileId, "\">").concat(data[i].fileName, "</div>\n\t\t\t\t<div class=\"time no-shrink\">").concat(new Date(data[i].time * 1000).format('yyyy-MM-dd'), "</div>\n\t\t\t\t<div class=\"folder pointer no-shrink\" data-id=\"").concat(data[i].parentId, "\">").concat(BabelStr.str(136), "</div>\n\t\t\t</div>");
      }
      return tmpl;
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStatisticsFileListTabPanelView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        pageSize: 10,
        startIndex: 0
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStatisticsFileListTabPanelView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .name': this._openFile,
        'click .folder': this._openFile
      });
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      var _this = this;
      var title = '';
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStatisticsFileListTabPanelView.prototype), "initialize", this).call(this, opt);
      this.paginationBarView = new _MDPaginationView["default"]({
        silentInit: true,
        pageSize: this.pageSize,
        onPageChanged: function onPageChanged(curPageIndex) {
          _this.startIndex = curPageIndex * _this.pageSize;
          _this.renderData();
        },
        onPageSizeChanged: function onPageSizeChanged(newPageSize) {
          _this.pageSize = newPageSize;
          _this.startIndex = 0;
          _this.renderData();
        }
      });
      this.addSubView(this.paginationBarView, this.$('.page-bar')[0]);
      this.paginationBarView.setLength(this.count, true, this.startIndex);
      this.renderData();
    }
  }, {
    key: "renderData",
    value: function renderData() {
      var _this2 = this;
      var options = {
        fileId: this.fileId,
        startIndex: this.startIndex,
        pageSize: this.pageSize,
        startTime: this.startTime,
        endTime: this.endTime,
        type: this.type,
        userId: this.userId
      };
      _MDSpinnerloaderView["default"].showIn(this.$('.file-list')[0]);
      MMEnterpriseController.statisFileWorkloadDetail(options, function (data) {
        _MDSpinnerloaderView["default"].clearFrom(_this2.$('.file-list')[0]);
        var tmpl = _this2.listTmpl(data);
        _this2.$('.file-list').html(tmpl);
      });
    }
  }, {
    key: "_openFile",
    value: function _openFile(e) {
      var fileId = $(e.target).data('id').toString();
      if (app.pathRouter) {
        app.pathRouter.openNewTabByFileId(fileId);
      } else {
        var href = '';
        href = '/main.do#file/' + fileId;
        var origin = location.origin;
        href = origin + href;
        window.open(href);
      }
    }
  }]);
  return MEStatisticsFileListTabPanelView;
}(_MMViewBase2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1437":1437,"1454":1454,"1463":1463,"1475":1475,"1478":1478,"22":22,"422":422,"61":61,"72":72,"76":76}],576:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDFilelogPanelView = _interopRequireDefault(require(586));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 *  window , file log
 *  Created by jichao
 *  2017.4.27
 */
var MDFileLogWindowView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDFileLogWindowView, _MDWindowView);
  function MDFileLogWindowView() {
    (0, _classCallCheck2["default"])(this, MDFileLogWindowView);
    return _callSuper(this, MDFileLogWindowView, arguments);
  }
  (0, _createClass2["default"])(MDFileLogWindowView, [{
    key: "classNmae",
    value: function classNmae() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileLogWindowView.prototype), "className", this).call(this);
      return superCls + ' file-log-window';
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      opt.title = BabelStr.str(3116); // "文件日志";
      opt.size = 'large';
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileLogWindowView.prototype), "initialize", this).call(this, opt);
      this.panelView = new _MDFilelogPanelView["default"](opt);
      this.addSubView(this.panelView);
    }
  }]);
  return MDFileLogWindowView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"586":586,"93":93}],586:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1541);
require(1437);
require(1463);
require(1478);
require(1439);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _keycode = _interopRequireDefault(require(104));
var _MDFilelogListView = _interopRequireDefault(require(585));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDAlertView = _interopRequireDefault(require(32));
var _MMViewBase2 = _interopRequireDefault(require(22));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 *  window , file log
 *  Created by jichao
 *  2017.4.27
 */
var MDFilelogPanelView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MDFilelogPanelView, _MMViewBase);
  function MDFilelogPanelView() {
    (0, _classCallCheck2["default"])(this, MDFilelogPanelView);
    return _callSuper(this, MDFilelogPanelView, arguments);
  }
  (0, _createClass2["default"])(MDFilelogPanelView, [{
    key: "tmpl",
    value: function tmpl() {
      var searchUser = BabelStr.str(3109); // 搜索用户名...
      return "\n      <div class=\"header onlyfile\">\n        <div class=\"flex-align between middle\">\n          <div class=\"file-name text-hide\"></div>\n          <%if(canManageFilePermission){%>\n            <button class=\"button done download\"><%=BabelStr.str(3461)%></button>\n          <%}%>\n        </div>\n        <div class=\"search-block log-search-block flex-align between middle\">\n          <div class=\"searchbox-contain \">\n            <input class=\"search-input\" type=\"text\" placeholder = '".concat(searchUser, "'/>\n            <span class=\"search-sign icon search\"></span>\n          </div>\n          <div class=\"select-contain\">\n\n          </div>\n        </div>\n      </div>\n      <div class=\"file-log-list-contain\"></div>\n    ");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var all = BabelStr.str(3110); // 查看所有记录
      var access = BabelStr.str(3111); // 仅查看访问记录
      var upload = BabelStr.str(3112); // 仅查看上传下载
      var anonymouse = BabelStr.str(3113); // 仅查看匿名用户
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFilelogPanelView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        fileInfor: null,
        pageSize: 6,
        conditionArr: [{
          type: 0,
          name: all
        }, {
          type: 1,
          name: access
        }, {
          type: 2,
          name: upload
        }, {
          type: 3,
          name: anonymouse
        }, {
          type: 4,
          name: BabelStr.str(4773)
        }, {
          type: 5,
          name: BabelStr.str(20170)
        }],
        type: 0,
        typesStr: all,
        userName: "",
        total: 0
      });
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        canManageFilePermission: this.fileInfor.canManageFilePermission()
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFilelogPanelView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFilelogPanelView.prototype), "className", this).call(this);
      return "".concat(superCls, " file-log-window");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFilelogPanelView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .search": this.searcFilelogByUserName,
        "keyup .search-input": this.searchInputKeydownHandle,
        "click .download": this._downloadFilelog
      });
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      var _this = this;
      opt.title = BabelStr.str(3116); // "文件日志";
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFilelogPanelView.prototype), "initialize", this).call(this, opt);
      this.bindSelf(this.getLogsForFile);
      this.conditionSelectView = new _MDDropdownSelectListView["default"]({
        dataProvider: this.conditionArr,
        labelField: "name",
        onChange: function onChange(obj) {
          _this.pickConditionChanged(obj);
        }
      });
      this.addSubView(this.conditionSelectView, this.$(".select-contain")[0]);
      this.filelogListView = new _MDFilelogListView["default"]({
        isAccessUser: true,
        pageSize: this.pageSize,
        refreshFileLog: function refreshFileLog(startIndex, pageSize) {
          _this.pageSize = pageSize;
          _this.getLogsForFile(startIndex);
        }
      });
      this.addSubView(this.filelogListView, this.$(".file-log-list-contain")[0]);
      this.$(".file-name").html(this.fileInfor.getFileName());
      this.getLogsForFile(0);
      if (this.fileInfor.getFileId() == 0) {
        this.$(".onlyfile").hide();
      }
    }
  }, {
    key: "getLogsForFile",
    value: function getLogsForFile(startIndex) {
      var _this2 = this;
      this.filelogListView.startRenderFileList();
      _MMNetDiskDataController["default"].getLogsForFile(this.fileInfor.getFileId(), startIndex, this.pageSize, this.type, this.userName, function (dataCollection, total) {
        _this2.filelogListView.setLogCollection(dataCollection);
        _this2.filelogListView.setLength(total, startIndex);
        _this2.total = total;
        setTimeout(function () {
          _this2.navigationWindowView && _this2.navigationWindowView.refreshWindow();
        });
      }, function (code, msg) {
        _this2.filelogListView.showErrorMsg(msg);
      });
    }
  }, {
    key: "_downloadFilelog",
    value: function _downloadFilelog() {
      var self = this;
      if (this.total > 2000 && !this.fileInfor.get("forClient")) {
        var alert = new _MDAlertView["default"]();
        alert.show({
          title: BabelStr.str(170),
          message: BabelStr.str(3462),
          width: 480,
          hideCloseBtn: true,
          buttons: [{
            label: BabelStr.str(3463),
            type: "done",
            onClick: function onClick() {
              self.download();
            }
          }, {
            label: BabelStr.str(155)
          }]
        });
      } else {
        self.download();
      }
    }
  }, {
    key: "download",
    value: function download() {
      MMEnterpriseController.downloadFilelogByFileId({
        fileId: this.fileInfor.getFileId(),
        types: this.type,
        typesStr: this.typesStr,
        keyword: this.userName
      });
    }
  }, {
    key: "searcFilelogByUserName",
    value: function searcFilelogByUserName() {
      this.userName = this.$(".search-input").val().toString();
      this.getLogsForFile(0);
    }
  }, {
    key: "searchInputKeydownHandle",
    value: function searchInputKeydownHandle($e) {
      this.userName = this.$(".search-input").val().toString();
      if (_keycode["default"].isEnterKey($e.keyCode)) {
        this.getLogsForFile(0);
      } else if (this.userName.length < 1) {
        this.getLogsForFile(0);
      }
    }
  }, {
    key: "pickConditionChanged",
    value: function pickConditionChanged(obj) {
      this.type = obj.type;
      this.typesStr = obj.name;
      this.getLogsForFile(0);
    }
  }]);
  return MDFilelogPanelView;
}(_MMViewBase2["default"]);

},{"104":104,"1104":1104,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"1478":1478,"1541":1541,"22":22,"32":32,"585":585,"67":67}],570:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1421);
require(1437);
require(1463);
require(1478);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MEStaffSearchTableView = _interopRequireDefault(require(199));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDNetDriveFileHandler = _interopRequireDefault(require(1091));
var _MDSnackbarView = _interopRequireDefault(require(72));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
* 转换文件负责人
* created by jichao
*	2018.10.8
*/
var MDEditResponsiblePersonWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDEditResponsiblePersonWinView, _MDWindowView);
  function MDEditResponsiblePersonWinView() {
    (0, _classCallCheck2["default"])(this, MDEditResponsiblePersonWinView);
    return _callSuper(this, MDEditResponsiblePersonWinView, arguments);
  }
  (0, _createClass2["default"])(MDEditResponsiblePersonWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n\t\t\t<input type=\"text\" class=\"form-control search\" placeholder='<%=BabelStr.str(2750)%>'/>\n\t\t\t<div class=\"user-list\"></div>\n\t\t\t<div class=\"btns-block flex-align end mgt-15\">\n\t\t\t\t<button class=\"button cancel\"><%=BabelStr.str(3081)%></button>\n\t\t\t\t<button class=\"button done save\"><%=BabelStr.str(3080)%></button>\n\t\t\t</div>\n\t\t";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEditResponsiblePersonWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        fileInfo: null,
        userCollection: null,
        checkedUserId: ''
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEditResponsiblePersonWinView.prototype), "className", this).call(this);
      return superCls + ' edit-res-person-win';
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEditResponsiblePersonWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .user-item': this._userItemClickHandle,
        "input .search": this._searchInputHandle,
        'click .save': this._saveHandle,
        'click .cancel': this._cancelHandle
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      props.title = BabelStr.str(2749);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEditResponsiblePersonWinView.prototype), "initialize", this).call(this, props);
      this.checkedUserId = this.fileInfo.getManager();
      this.getUserList();
    }
  }, {
    key: "getUserList",
    value: function getUserList() {
      var _this = this;
      var self = this;
      _MDSpinnerloaderView["default"].showIn(this.$('.user-list'));
      var noNeedDepInfo = true;
      MMNetDiskDataController.getUsersCanFocusFile(this.fileInfo.getFileId(), noNeedDepInfo, this.fileInfo.getOrganizationInfo(), function (userCollection) {
        _MDSpinnerloaderView["default"].clearFrom(_this.$('.user-list'));
        userCollection.each(function (user) {
          user.set("searched", true);
          self.userCollection = userCollection;
          self.renderUserList();
        });
      });
    }
  }, {
    key: "renderUserList",
    value: function renderUserList() {
      var str = "";
      var isChecked;
      var self = this;
      this.userCollection.each(function (user) {
        isChecked = self.checkedUserId == user.getUserId();
        if (user.get("searched")) {
          str += '<li class = "user-item ' + (isChecked ? 'checked' : '') + '" data-userId="' + user.getUserId() + '">\
              <span class = "checkbox "></span>\
              <img src="" alt="" class = "user-img" data-src = "' + user.getAvatarImageURL() + '" />\
              <span class = "user-info text-hide">\
                <span class = "user-name">' + user.getUserName() + '</span>\
                <span class = "user-email">' + user.getEmail() + '</span>\
              </span>\
            </li>';
        }
      });
      this.$(".user-list").html(str);
      this.$(".user-img").imageLoader();
    }
  }, {
    key: "_searchInputHandle",
    value: function _searchInputHandle($e) {
      var value = this.$(".search").val();
      var str = "";
      var index = -1;
      this.userCollection.each(function (user) {
        str = user.getUserName() + user.getEmail();
        index = str.indexOf(value);
        if (index < 0) {
          user.set("searched", false);
        } else {
          user.set("searched", true);
        }
      });
      this.renderUserList();
    }
  }, {
    key: "_saveHandle",
    value: function _saveHandle() {
      var _this2 = this;
      if (this.checkedUserId == this.fileInfo.getManager()) {
        this.close();
        return;
      }
      _MDNetDriveFileHandler["default"].shiftFileManager(this.fileInfo.getFileId(), this.checkedUserId, function () {
        _MDSnackbarView["default"].show(BabelStr.str(308));
        var user = _this2.userCollection.findWhere({
          "id": _this2.checkedUserId
        });
        _this2.updateManager({
          id: user.getUserId(),
          name: user.getUserName()
        });
        _this2.close();
      }, function () {
        _MDSnackbarView["default"].show(BabelStr.str(309));
      });
    }
  }, {
    key: "_cancelHandle",
    value: function _cancelHandle() {
      this.close();
    }
  }, {
    key: "_userItemClickHandle",
    value: function _userItemClickHandle($e) {
      var $item = this.$($e.target.closest('.user-item'));
      var userId = $item.data('userid').toString();
      this.checkedUserId = userId;
      this.$('.user-item').removeClass('checked');
      $item.addClass('checked');
    }
  }]);
  return MDEditResponsiblePersonWinView;
}(_MDWindowView2["default"]);

},{"1091":1091,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1421":1421,"1437":1437,"1454":1454,"1463":1463,"1475":1475,"1478":1478,"199":199,"72":72,"76":76,"93":93}],560:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1430);
require(1463);
require(1424);
var _MDCheckboxView = _interopRequireDefault(require(37));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDWindowView = _interopRequireDefault(require(93));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
/**
 * 添加标签
 * 2025.5.12
 */

var MDAddAITagWinView = _MDWindowView["default"].extend({
  className: function className() {
    var superCls = _MDWindowView["default"].prototype.className.call(this);
    return superCls + ' m-add-ai-tag-window';
  },
  _addTagInfoTmpl: function _addTagInfoTmpl() {
    return "\n      <div class=\"info \">".concat(BabelStr.str(12651), "</div>\n      <div class=\"help-success red mgt-15\">").concat(BabelStr.str(12652), "</div>\n      <div class=\"check-box-block mgt-15\"></div>\n      <div class=\"btns-block flex-align end\">\n        <div class=\"button cancel\">").concat(BabelStr.str(155), "</div>\n        <div class=\"button done save\">").concat(BabelStr.str(154), "</div>\n      </div>\n    ");
  },
  _emptyTagInfoTmpl: function _emptyTagInfoTmpl() {
    return "\n      <div class=\"empty-title f-tc boldfont1 \">".concat(BabelStr.str(12653), "</div>\n      <div class=\"help-text mgt-15\">").concat(BabelStr.str(12654), "</div>\n      <div class=\"flex-align middle center mgt-15 mgb-20\">\n        <div class=\"text-button done to-add\">").concat(BabelStr.str(12655), "</div>\n      </div>\n\n    ");
  },
  _cannotAddTagTmpl: function _cannotAddTagTmpl() {
    return "\n      <div class=\"empty-title f-tc boldfont1\">".concat(BabelStr.str(12657), "</div>\n\n      <div class=\"flex-align middle center mgt-15 mgb-20\">\n        <div class=\"text-button done commit\">").concat(BabelStr.str(12658), "</div>\n      </div>\n\n    ");
  },
  events: function events() {
    var superE = _MDWindowView["default"].prototype.events.call(this);
    return _.extend(superE, {
      "click .cancel": this.close,
      "click .save": this.save,
      "click .to-add": this.add,
      "click .commit": this.commit
    });
  },
  initProps: function initProps() {
    var superP = _MDWindowView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      title: BabelStr.str(12650),
      //  "AI自动打标签"
      fileInfos: []
    });
  },
  /**
   * @param {object} opt
   * @param {MDNavigationPageView} opt.rootNavigationPageView - 根nav页面
   */
  initialize: function initialize(props) {
    var _this = this;
    var superP = _MDWindowView["default"].prototype.initialize.call(this, props);
    if (!this.canUseAIFinal()) {
      var tmpl = this._cannotAddTagTmpl();
      this.$body.html(tmpl);
      return;
    }
    _MDSpinnerloaderView["default"].showIn(this.$body, {
      autoHeight: true
    });
    var request;
    if (app.isEpVersion() && !app.ep.getTagLimit() || !app.isEpVersion()) {
      request = MDTagDataController.getAllTagsICanSee;
    } else {
      request = MDTagDataController.getAllTagsEntUsed;
    }
    request(function (tags) {
      if (tags.length) {
        _this.showAddTagInfo();
      } else {
        _this.showEmpty();
      }
      _MDSpinnerloaderView["default"].clearFrom(_this.$body);
    }, function () {
      _this.showEmpty();
      _MDSpinnerloaderView["default"].clearFrom(_this.$body);
    });
  },
  canUseAIFinal: function canUseAIFinal() {
    return _.some(this.fileInfos, function (file) {
      return file.canUseAITaginal();
    });
  },
  showAddTagInfo: function showAddTagInfo() {
    var _this2 = this;
    var tmpl = this._addTagInfoTmpl();
    this.$body.html(tmpl);
    var check = new _MDCheckboxView["default"]({
      label: BabelStr.str(12656),
      onChanged: function onChanged(checked) {
        _this2.aiChecked = checked;
      }
    });
    this.addSubView(check, this.$(".check-box-block"));
  },
  save: function save() {
    if (this.aiChecked) {
      localStorage.setItem("add_ai_tag_warn_".concat(app.currentUser.getUserId()), 1);
    }
    _.isFunction(this.addCallback) && this.addCallback();
    this.close();
  },
  commit: function commit() {
    this.close();
    var exts = [];
    _.each(this.fileInfos, function (file) {
      if (!file.canUseAITaginal()) {
        if (!file.isFolder()) {
          exts.push(file.getLowerCaseExt());
        } else {
          exts.push('文件夹');
        }
      }
    });
    console.log(exts);
    _MMEnterpriseController["default"].addUserExpect({
      expect: "AI-tags",
      comment: exts.join(',')
    });
  },
  add: function add() {
    _.isFunction(this.toAddCallback) && this.toAddCallback();
    this.close();
  },
  showEmpty: function showEmpty() {
    var tmpl = this._emptyTagInfoTmpl();
    this.$body.html(tmpl);
  },
  viewWillUnRendered: function viewWillUnRendered(param) {}
});
var _default = exports["default"] = MDAddAITagWinView;

},{"1098":1098,"1184":1184,"1412":1412,"1424":1424,"1430":1430,"1454":1454,"1463":1463,"37":37,"76":76,"93":93}],527:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
require(1426);
require(1541);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MDEnterpriseShareTabView = _interopRequireDefault(require(675));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDParticipantInfoCollection = _interopRequireDefault(require(277));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
*	archive reading room  , create and edit
*	created by jichao
*	2019.4.8
*/
var MDArchiveReadingRoomCreateWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDArchiveReadingRoomCreateWinView, _MDWindowView);
  function MDArchiveReadingRoomCreateWinView() {
    (0, _classCallCheck2["default"])(this, MDArchiveReadingRoomCreateWinView);
    return _callSuper(this, MDArchiveReadingRoomCreateWinView, arguments);
  }
  (0, _createClass2["default"])(MDArchiveReadingRoomCreateWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n\t\t<form>\n\t\t\t<div class=\"help-block\"><%=BabelStr.str(3447)%></div>\n\t\t\t<div class=\"row mgb-10\">\n\t\t\t\t<div class=\"col-3\"><%=BabelStr.str(158)%></div>\n\t\t\t\t<div class=\"col-9\"><input type=\"text\" class=\"form-control r-rome-name\" name=\"name\"  /></div>\n\t\t\t</div>\n\t\t\t<div class=\"row mgb-10\">\n\t\t\t\t<div class=\"col-3\"><%=BabelStr.str(3448)%></div>\n\t\t\t\t<div class=\"col-9 level\"></div>\n\t\t\t</div>\n\t\t\t<div class=\"row dep-select-content f-none\">\n\t\t\t\t<div class=\"col-3\"><%=BabelStr.str(3449)%></div>\n\t\t\t\t<div class=\"col-9 dep-select\"></div>\n\t\t\t</div>\n\t\t\t<dov class=\"help-block type-info\"></dov>\n\t\t</form>\n\t\t<div class=\"flex-align mgt-20 end btns-block\">\n\t\t\t<button class=\"button done create\"><%=BabelStr.str(3080)%></button>\n\t\t\t<button class=\"button done cancel\"><%=BabelStr.str(155)%></button>\n\t\t</div>\n\n\t\t";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDArchiveReadingRoomCreateWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " share-win reading-room-win");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDArchiveReadingRoomCreateWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .cancel': this.close,
        'click .create': this._create
      });
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDArchiveReadingRoomCreateWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        levelData: [{
          label: BabelStr.str(3350),
          //公开
          value: 1,
          readme: BabelStr.str(3474)
        }, {
          label: BabelStr.str(3471),
          //需要借阅
          value: 2,
          readme: BabelStr.str(3475)
        }, {
          label: BabelStr.str(3473),
          //限定部门内公开
          value: 3,
          readme: BabelStr.str(3476)
        }, {
          label: BabelStr.str(3472),
          //限定部门内可借阅
          value: 4,
          readme: BabelStr.str(3477)
        }],
        edit: false,
        openType: undefined,
        readingScopes: null,
        fileInfor: null
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.title = BabelStr.str(3446);
      if (props.edit) {
        props.title = BabelStr.str(3451);
      }
      props.needFooter = false;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDArchiveReadingRoomCreateWinView.prototype), "initialize", this).call(this, props);
      this.levelSelect = new _MDDropdownSelectListView["default"]({
        dataProvider: this.levelData,
        silentInit: false,
        onChange: function onChange(item) {
          if (item.value == 1 || item.value == 2) {
            _this.$('.dep-select-content').hide();
          } else {
            _this.$('.dep-select-content').show();
          }
          _this.openType = item.value;
          _this.$('.type-info').html(item.readme);
        }
      });
      this.addSubView(this.levelSelect, this.$('.level')[0]);
      this.depSelect = new _MDEnterpriseShareTabView["default"]({
        inputName: "reading-room-create",
        canSelDepartment: true,
        notIncludeGuest: true,
        hideSelectWhenInput: true,
        needFrequentUserTab: false,
        needGroupTreeTab: false,
        canSelRole: false,
        canSelectDepUser: false,
        canSelGroup: false,
        inputFullWidth: true,
        isSelectOnlyInEp: true,
        placeholder: BabelStr.str(6702),
        fromStr: BabelStr.str(3455),
        emptySearchStr: BabelStr.str(3457)
        // initDepIds: ["201", "226", "1121"]
      });
      this.addSubView(this.depSelect, this.$('.dep-select')[0]);
      this.$('form').validate({
        rules: {
          'name': 'required',
          'reading-room-create': {
            requiredMember: true
          }
        },
        errorPlacement: function errorPlacement(error, element) {
          if (element.attr('name') == 'reading-room-create') {
            error.appendTo(element.closest(".dep-select"));
            element.closest('.choose-contain').addClass('validate-error');
          } else {
            element.after(error);
          }
        },
        highlight: function highlight(element, errorClass, validClass) {
          if ($(element).closest('.choose-contain').length) {
            $(element).closest('.choose-contain').removeClass(validClass).addClass(errorClass);
          } else {
            $(element).removeClass(validClass).addClass(errorClass);
          }
        },
        unhighlight: function unhighlight(element, errorClass, validClass) {
          if ($(element).closest('.choose-contain').length) {
            $(element).closest('.choose-contain').removeClass(errorClass).addClass(validClass);
          } else {
            $(element).removeClass(errorClass).addClass(validClass);
          }
        }
      });
    }
  }, {
    key: "_create",
    value: function _create() {
      var validate = this.$("form").validate();
      if (!validate.form()) {
        return;
      }
      // console.warn('------创建阅览室----')
      // if(this.create) {
      this.createReadingRoom();
      // }
    }
  }, {
    key: "createReadingRoom",
    value: function createReadingRoom() {
      var _this2 = this;
      var name = this.$('.r-rome-name').val().toString();
      var targets;
      if (this.openType == 3 || this.openType == 4) {
        var targetObj = this.depSelect.getTargetObj();
        targets = _.map(targetObj.deps, function (id) {
          return {
            targetId: id,
            targetType: 1
          };
        });
      }
      this.$('.create').attr("disabled", true);
      if (this.edit) {
        MMEnterpriseController.updateReadingRoom({
          fileId: this.fileInfor.getFileId(),
          name: name,
          targets: targets,
          openType: this.openType
        }, function () {
          console.log('success');
          _MDSnackbarView["default"].show(BabelStr.str(308));
          _this2.close();
          _this2.fileInfor.setFileName(name);
          _this2.refreshReadingRoomScope();
        }, function () {
          _this2.$('.create').attr("disabled", false);
        });
      } else {
        MMEnterpriseController.createReadingRoom({
          name: name,
          targets: targets,
          openType: this.openType
        }, function () {
          var fileInfor = app.pathRouter.getCurrentFolder();
          viewManager.viewList.archiveTableView && viewManager.viewList.archiveTableView.requestFolder(fileInfor);
          _MDSnackbarView["default"].show(BabelStr.str(308));
          _this2.close();
        }, function () {
          _this2.$('.create').attr("disabled", false);
        });
      }
    }
  }, {
    key: "renderInitData",
    value: function renderInitData(result) {
      var depIds = _.pluck(result.departments, 'id');
      var type = result.style.openType; // 1 --> 0,  2-->1
      // let name =
      this.levelSelect.selectItemAt(type - 1);
      var defaultParticipantInfoCollection = _MDParticipantInfoCollection["default"].createFromDepCollection(result.departments);
      this.depSelect.setDefaultParticipantInfoCollectio(defaultParticipantInfoCollection);
      var name = this.fileInfor.getFileName();
      this.$('.r-rome-name').val(name);
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      var _this3 = this;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDArchiveReadingRoomCreateWinView.prototype), "viewDidRendered", this).call(this);
      if (this.edit) {
        if (this.readingScopes) {
          setTimeout(function () {
            _this3.renderInitData(_this3.readingScopes);
          });
        } else {
          MMEnterpriseController.getReadingRoomScope(this.fileInfor.getFileId(), function (result) {
            _this3.renderInitData(result);
          }, function () {});
        }
      }
    }
  }]);
  return MDArchiveReadingRoomCreateWinView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1426":1426,"1437":1437,"1454":1454,"1463":1463,"1475":1475,"1478":1478,"1541":1541,"277":277,"67":67,"675":675,"72":72,"93":93}],232:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1498);
require(1420);
require(1466);
require(1418);
require(1463);
require(1537);
require(1412);
require(1423);
require(1487);
require(1538);
require(1545);
require(1543);
var _docx = _interopRequireDefault(require("docx"));
var exportWord = function exportWord(tempDiv, fileName) {
  // 将Markdown内容转换为Word文档内容
  function createWordContent(tempDiv) {
    // 存储Word文档的段落和其他元素
    var docElements = [];

    // 设置文档默认样式
    // 使用微软雅黑作为中文字体，Arial作为英文字体
    var defaultFont = "微软雅黑, Arial";
    var defaultFontSize = 11;
    var defaultLineSpacing = 1.6;

    // 递归处理HTML节点
    processNode(tempDiv, docElements, {
      font: defaultFont,
      fontSize: defaultFontSize,
      lineSpacing: defaultLineSpacing
    });
    return docElements;
  }
  // 递归处理HTML节点并转换为Word文档元素
  function processNode(node, docElements, styles) {
    // 遍历所有子节点
    for (var i = 0; i < node.childNodes.length; i++) {
      var child = node.childNodes[i];

      // 根据节点类型处理
      if (child.nodeType === Node.TEXT_NODE) {
        // 文本节点
        var text = child.textContent.trim();
        if (text) {
          // 如果父节点不是特殊元素，则创建普通段落
          if (!["H1", "H2", "H3", "H4", "H5", "H6", "LI", "BLOCKQUOTE"].includes(node.nodeName)) {
            docElements.push(new _docx["default"].Paragraph({
              children: [new _docx["default"].TextRun({
                text: text,
                font: styles.font,
                size: styles.fontSize * 2 // docx使用的是半点大小
              })],
              spacing: {
                line: Math.round(styles.lineSpacing * 240),
                // 行间距
                before: 120,
                after: 120
              }
            }));
          }
        }
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        // 元素节点
        switch (child.nodeName) {
          case "H1":
          case "H2":
          case "H3":
          case "H4":
          case "H5":
          case "H6":
            var headingLevel = parseInt(child.nodeName.substring(1));
            var headingSize = styles.fontSize * (2.5 - (headingLevel - 1) * 0.25); // H1最大，依次减小

            docElements.push(new _docx["default"].Paragraph({
              children: [new _docx["default"].TextRun({
                text: child.textContent,
                font: styles.font,
                size: headingSize * 2,
                bold: true
              })],
              heading: _docx["default"].HeadingLevel[child.nodeName],
              spacing: {
                before: 240,
                after: 120
              },
              border: {
                bottom: {
                  color: "#AAAAAA",
                  space: 1,
                  style: _docx["default"].BorderStyle.SINGLE,
                  size: 6
                }
              }
            }));
            break;
          case "P":
            docElements.push(new _docx["default"].Paragraph({
              children: [new _docx["default"].TextRun({
                text: child.textContent,
                font: styles.font,
                size: styles.fontSize * 2
              })],
              spacing: {
                line: Math.round(styles.lineSpacing * 240),
                before: 120,
                after: 120
              }
            }));
            break;
          case "BLOCKQUOTE":
            docElements.push(new _docx["default"].Paragraph({
              children: [new _docx["default"].TextRun({
                text: child.textContent,
                font: styles.font,
                size: styles.fontSize * 2,
                italics: true
              })],
              spacing: {
                line: Math.round(styles.lineSpacing * 240),
                before: 120,
                after: 120
              },
              border: {
                left: {
                  color: "#AAAAAA",
                  space: 12,
                  style: _docx["default"].BorderStyle.SINGLE,
                  size: 12
                }
              },
              indent: {
                left: 240
              }
            }));
            break;
          case "PRE":
            // 代码块
            var codeElement = child.querySelector("code");
            if (codeElement) {
              docElements.push(new _docx["default"].Paragraph({
                children: [new _docx["default"].TextRun({
                  text: codeElement.textContent,
                  font: "Courier New",
                  // 代码块保持使用等宽字体
                  size: styles.fontSize * 2
                })],
                spacing: {
                  line: Math.round(styles.lineSpacing * 240),
                  before: 120,
                  after: 120
                },
                shading: {
                  type: _docx["default"].ShadingType.SOLID,
                  color: "#F0F0F0"
                }
              }));
            }
            break;
          case "UL":
          case "OL":
            processListItems(child, docElements, styles, child.nodeName === "OL");
            break;
          case "A":
            processLink(child, docElements, styles);
            break;
          case "IMG":
            // 图片处理（简化版，仅添加图片描述）
            docElements.push(new _docx["default"].Paragraph({
              children: [new _docx["default"].TextRun({
                text: "[\u56FE\u7247: ".concat(child.alt || "无描述", "]"),
                font: styles.font,
                size: styles.fontSize * 2,
                italics: true
              })],
              spacing: {
                line: Math.round(styles.lineSpacing * 240),
                before: 120,
                after: 120
              }
            }));
            break;
          case "TABLE":
            processTable(child, docElements, styles);
            break;
          case "HR":
            // 水平线
            docElements.push(new _docx["default"].Paragraph({
              children: [],
              border: {
                bottom: {
                  color: "#AAAAAA",
                  space: 1,
                  style: _docx["default"].BorderStyle.SINGLE,
                  size: 6
                }
              },
              spacing: {
                before: 240,
                after: 240
              }
            }));
            break;
          default:
            // 递归处理其他元素
            processNode(child, docElements, styles);
            break;
        }
      }
    }
  }

  // 处理链接
  function processLink(node, docElements, styles) {
    docElements.push(new _docx["default"].Paragraph({
      children: [new _docx["default"].ExternalHyperlink({
        children: [new _docx["default"].TextRun({
          text: node.textContent,
          style: "Hyperlink",
          font: styles.font,
          size: styles.fontSize * 2
        })],
        link: node.href
      })],
      spacing: {
        line: Math.round(styles.lineSpacing * 240),
        before: 120,
        after: 120
      }
    }));
  }

  // 处理列表项
  function processListItems(node, docElements, styles, isOrdered) {
    var items = node.querySelectorAll("li");
    items.forEach(function (item, index) {
      docElements.push(new _docx["default"].Paragraph({
        children: [new _docx["default"].TextRun({
          text: "".concat(isOrdered ? index + 1 + ". " : "• ").concat(item.textContent),
          font: styles.font,
          size: styles.fontSize * 2
        })],
        spacing: {
          line: Math.round(styles.lineSpacing * 240),
          before: 60,
          after: 60
        },
        indent: {
          left: 240
        }
      }));
    });
  }

  // 处理表格
  function processTable(node, docElements, styles) {
    var rows = node.querySelectorAll("tr");
    if (rows.length === 0) return;
    var tableRows = [];
    var hasHeader = false;

    // 检查是否有表头
    if (node.querySelector("thead")) {
      hasHeader = true;
    }

    // 处理所有行
    rows.forEach(function (row, rowIndex) {
      var cells = row.querySelectorAll("th, td");
      var tableCells = [];
      cells.forEach(function (cell) {
        var isHeader = cell.nodeName === "TH" || rowIndex === 0 && hasHeader;
        tableCells.push(new _docx["default"].TableCell({
          children: [new _docx["default"].Paragraph({
            children: [new _docx["default"].TextRun({
              text: cell.textContent,
              font: styles.font,
              size: styles.fontSize * 2,
              bold: isHeader
            })],
            alignment: isHeader ? _docx["default"].AlignmentType.CENTER : _docx["default"].AlignmentType.LEFT
          })],
          shading: {
            type: _docx["default"].ShadingType.SOLID,
            color: isHeader ? "#EEEEEE" : rowIndex % 2 === 1 ? "#F9F9F9" : "#FFFFFF"
          },
          margins: {
            top: 100,
            bottom: 100,
            left: 100,
            right: 100
          }
        }));
      });
      tableRows.push(new _docx["default"].TableRow({
        children: tableCells
      }));
    });
    docElements.push(new _docx["default"].Table({
      rows: tableRows,
      width: {
        size: 100,
        type: _docx["default"].WidthType.PERCENTAGE
      },
      borders: {
        top: {
          style: _docx["default"].BorderStyle.SINGLE,
          size: 1,
          color: "#CCCCCC"
        },
        bottom: {
          style: _docx["default"].BorderStyle.SINGLE,
          size: 1,
          color: "#CCCCCC"
        },
        left: {
          style: _docx["default"].BorderStyle.SINGLE,
          size: 1,
          color: "#CCCCCC"
        },
        right: {
          style: _docx["default"].BorderStyle.SINGLE,
          size: 1,
          color: "#CCCCCC"
        },
        insideHorizontal: {
          style: _docx["default"].BorderStyle.SINGLE,
          size: 1,
          color: "#CCCCCC"
        },
        insideVertical: {
          style: _docx["default"].BorderStyle.SINGLE,
          size: 1,
          color: "#CCCCCC"
        }
      }
    }));
  }
  function saveAs(blob, name) {
    var a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = name; // 设置下载的文件名
    // 触发点击事件以下载文件
    a.click();
    // 释放 URL 对象
    URL.revokeObjectURL(a.href);
  }
  var doc = new _docx["default"].Document({
    sections: [{
      properties: {},
      children: createWordContent(tempDiv)
    }]
  });

  // 生成Word文档并下载
  _docx["default"].Packer.toBlob(doc).then(function (blob) {
    saveAs(blob, "".concat(fileName || "document", ".docx"));
  });
};
var _default = exports["default"] = exportWord;

},{"1184":1184,"1412":1412,"1418":1418,"1420":1420,"1423":1423,"1454":1454,"1463":1463,"1466":1466,"1487":1487,"1498":1498,"1537":1537,"1538":1538,"1543":1543,"1545":1545,"docx":"docx"}],"docx":[function(require,module,exports){
"use strict";

module.exports = window.docx;
if (window.docx) module.exports["default"] = window.docx;

},{}],208:[function(require,module,exports){
"use strict";

require(1475);
require(1429);
require(1478);
require(1419);
require(1487);
require(1477);
require(1503);
require(1500);
require(1502);
require(1423);
require(1538);
require(1422);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1438);
require(1412);
require(1437);
require(1498);
require(1417);
require(1463);
require(1439);
require(1418);
require(1537);
require(1471);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDBasicToolPanel2 = _interopRequireDefault(require(456));
var _MDSalonPanelViewTmpl = _interopRequireDefault(require(209));
var _MDSalonInfo = _interopRequireDefault(require(204));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDEvents = _interopRequireDefault(require(325));
var _MMBasicData = _interopRequireDefault(require(811));
var _MDAudiencePopupView = _interopRequireDefault(require(202));
var _MDAlertView = _interopRequireDefault(require(32));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDMessageView = _interopRequireDefault(require(55));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MD_SALON_MSG_TYPE = _interopRequireDefault(require(212));
var _MDSalonOperationToolPanel = _interopRequireDefault(require(206));
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // MDSalonPanelView.js
// jiang
// 2017-6-15
var MDSalonPanelView = exports["default"] = /*#__PURE__*/function (_MDBasicToolPanel) {
  (0, _inherits2["default"])(MDSalonPanelView, _MDBasicToolPanel);
  function MDSalonPanelView() {
    (0, _classCallCheck2["default"])(this, MDSalonPanelView);
    return _callSuper(this, MDSalonPanelView, arguments);
  }
  (0, _createClass2["default"])(MDSalonPanelView, [{
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSalonPanelView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        salonInfo: null
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSalonPanelView.prototype), "events", this).call(this);
      return _.extend(superE, {
        // "mousedown .start-sl-btn": this._startSalonClicked
      });
    }
  }, {
    key: "remove",
    value: function remove(opt_removeRef) {
      this.$('.start-sl-btn').off();
      this.$('button').off();
      this.$('input').off();
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSalonPanelView.prototype), "remove", this).call(this, opt_removeRef);
      $(window).off('beforeunload.salon');
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      this.strClassName = 'MDSalonPanelView';
      _.extend(props, {
        inEditor: true,
        closeIsHide: true
      });
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSalonPanelView.prototype), "initialize", this).call(this, props);
      this.salonInfo = null;
      this.refreshPanel(props.salonInfo);
      $('body').append(this.$el);
      _Dispatcher["default"].on(_MDEvents["default"].SALON_MESSAGE, this.salonMsgManage, this);
      var self = this;
      // window.onbeforeunload = function(event)
      // {
      //     return confirm("Confirm refresh");
      // };

      $(window).bind('beforeunload', function () {
        self._checkToCloseSalon();
        return console.log('>>>>>Before You Go<<<<<<<< \n Your custom message go here');
      });
    }
  }, {
    key: "refreshPanel",
    value: function refreshPanel(salonInfo) {
      var initForNewFile = false;
      if (!salonInfo || !this.salonInfo || this.salonInfo.getFileId() != salonInfo.getFileId()) {
        initForNewFile = true;
      }
      ;
      this.salonInfo = salonInfo;
      if (initForNewFile) {
        if (this.salonInfo) {
          this._initBySalonInfo();
        } else {
          this._showStartSalon();
        }
      } else {
        this._updateMemInfoAndBtns();
      }
    }
  }, {
    key: "refreshWithFileInfo",
    value: function refreshWithFileInfo(salonInfo, fileInfo) {
      this.salonInfo = salonInfo;
      this.fileInfo = fileInfo;
      this.fileId = fileInfo.getFileId();
      this.refreshPanel(salonInfo);
    }
  }, {
    key: "registerMouseEvents",
    value: function registerMouseEvents() {
      var _this = this;
      this.$('.chat-zone').off();
      this.$('.add-salon').off();
      this.$('.leave-salon').off();
      this.$('.transfer-speaker').off();
      this.$('.salon-op-btn').off();
      this.$('.close-salon').off();
      this.$('.msg-input').off();
      var self = this;
      this.$('.chat-zone').on('mousedown', function (e) {
        e.stopPropagation();
      });
      this.$('.chat-zone').on('mousemove', function (e) {
        e.stopPropagation();
      });
      this.$('.chat-zone').on('mouseup', function (e) {
        e.stopPropagation();
      });
      this.$('.add-salon').on('mousedown', function (e) {
        e.stopPropagation();
        _this._joinSalon();
      });
      this.$('.leave-salon').on('mousedown', function (e) {
        e.stopPropagation();
        _this._leaveSalon();
      });
      this.$('.transfer-speaker').on('mousedown', function (e) {
        e.stopPropagation();
        _this._transferSalon(e);
      });
      this.$('.salon-op-btn').on('mousedown', function (e) {
        e.stopPropagation();
        _this._toggleSalonToolbar(e);
      });
      this.$('.close-salon').on('mousedown', function (e) {
        e.stopPropagation();
        setBabelTimeout(function () {
          self._closeSalon();
        }, 10);
      });
      this.$('.msg-input').on('keydown', function (e) {
        e.stopPropagation();
        _this._keyDown(e);
      });
    }
  }, {
    key: "_initBySalonInfo",
    value: function _initBySalonInfo() {
      var showStr = _MDLocalString["default"].getLocalString(2013);
      this.setTitle(showStr + '...');
      this.hideSubTitle();
      var salonInfo = {
        'speakerName': this.salonInfo.getSpeakerName(),
        'audience': this.salonInfo.getAudiences(),
        'changeSpeaker': _MDLocalString["default"].getLocalString(2034),
        'close': _MDLocalString["default"].getLocalString(2035),
        'look': _MDLocalString["default"].getLocalString(2036),
        'leave': _MDLocalString["default"].getLocalString(2037),
        'chatInput': _MDLocalString["default"].getLocalString(2038)
      };
      var html = _.template(_MDSalonPanelViewTmpl["default"].showing)(salonInfo);
      this.$('.tool-p-content').empty().append($(html));
      this._updateMemInfoAndBtns();
      this.$('.msg-input').focus();
    }
  }, {
    key: "_checkToCloseSalon",
    value: function _checkToCloseSalon() {
      var self = this;
      var salonId = this.salonInfo.getSalonId();
      if (this.salonInfo.isCurrentUserSpeaker()) {
        _MMEnterpriseController["default"].closeSalon(salonId, self.fileInfo.getFileId(), function () {}, function () {});
      }
      ;
    }
  }, {
    key: "_updateBtnState",
    value: function _updateBtnState() {
      this.$('.button-zone button').show();
      if (this.salonInfo.isCurrentUserSpeaker()) {
        this.$('.add-salon, .leave-salon').hide();
      } else {
        this.$('.transfer-speaker, .close-salon').hide();
        if (this.salonInfo.isCurrentUserAudience()) {
          this.$('.add-salon').hide();
        } else {
          this.$('.leave-salon').hide();
        }
      }
      if (app.currentUser.isEpAdminUser() || this.fileInfo.isOwner()) {
        this.$('.transfer-speaker, .close-salon').show();
      }
      ;
      if (this.salonInfo.isCurrentUserAudience() || this.salonInfo.isCurrentUserSpeaker()) {
        this.$('.chat-zone').show();
      } else {
        this.$('.chat-zone').hide();
      }
      this.registerMouseEvents();
      _Dispatcher["default"].trigger(_MDEvents["default"].salonStatusChanged, this.salonInfo);
    }
  }, {
    key: "_updateMemInfoAndBtns",
    value: function _updateMemInfoAndBtns() {
      var memInfo = {
        'speakerName': this.salonInfo.getSpeakerName(),
        'audience': this.salonInfo.getAudiences(),
        'speaker': _MDLocalString["default"].getLocalString(2033),
        // 主讲人
        'audi': _MDLocalString["default"].getLocalString(2039) // 观众
      };
      var memHtml = _.template(_MDSalonPanelViewTmpl["default"].salonMem)(memInfo);
      this.$('.salon-mem').empty().html(memHtml);
      this._updateBtnState();
    }
  }, {
    key: "_showStartSalon",
    value: function _showStartSalon() {
      var _this2 = this;
      var titleStr = _MDLocalString["default"].getLocalString(2014); // '演播模式'
      this.setTitle(titleStr);
      var data = {
        'open': _MDLocalString["default"].getLocalString(2032) // 开启演播
      };
      var startHtml = _.template(_MDSalonPanelViewTmpl["default"].noStart)(data);
      this.$('.tool-p-content').empty().html(startHtml);
      var subTitle = _MDLocalString["default"].getLocalString(2015); //'发起演播后，当前文档的围观的观众的屏幕显示文档的位置与发起人同步'
      this.setSubTitle(subTitle);
      this.$('.start-sl-btn').on('mousedown', function (e) {
        _this2._startSalonClicked(e);
      });
      _Dispatcher["default"].trigger(_MDEvents["default"].salonStatusChanged, this.salonInfo);
    }
  }, {
    key: "_startSalonClicked",
    value: function _startSalonClicked(e) {
      console.log('---------> start salon');
      e.stopPropagation();
      var self = this;
      _MMEnterpriseController["default"].setUpSalon(this.fileId, function (salonInfo) {
        self.fileInfo.setSalonInfo(salonInfo);
        self.salonInfoUpdatedCallback(salonInfo);
        self.salonInfo = salonInfo;
        self._initBySalonInfo();
        self.prepareForAudioChat(self.salonInfo);
      }, function () {});
    }
  }, {
    key: "_joinSalon",
    value: function _joinSalon(e) {
      var self = this;
      _MMEnterpriseController["default"].addSalon(self.salonInfo.getSalonId(), function () {
        self.salonInfo.addCurrentUserAudience();
        self._initBySalonInfo();
        self.prepareForAudioChat(self.salonInfo);
      }, function () {});
    }
  }, {
    key: "_leaveSalon",
    value: function _leaveSalon(e) {
      var self = this;
      var promptStr = _MDLocalString["default"].getLocalString(2016);
      var alertOpt = {
        message: promptStr,
        okFun: function okFun() {
          _MMEnterpriseController["default"].leaveSalon(self.salonInfo.getSalonId(), function () {
            self.salonInfo.leaveAudience();
            self._initBySalonInfo();
          }, function () {
            _MDMessageView["default"].error(_MDLocalString["default"].getLocalString(168));
          });
          self.closeAllAudio();
        }
      };
      _MDAlertView["default"].showStandardSelection(alertOpt);
    }
  }, {
    key: "prepareForAudioChat",
    value: function prepareForAudioChat(salonInfo) {
      var self = this;
      // 获取我们coturn的临时用户名密码
      _MMEnterpriseController["default"].getTurnCredentials(function (config) {
        createLocalStream(function (err, stream) {
          if (err) {
            handleGetUserMediaError(err);
            return;
          }
          self.localStream = stream;
          // 被呼叫
          self.webRtcCallee = new Callee(salonInfo, config);
          // 呼叫者
          self.webRtcCaller = new Caller(salonInfo, config);
          // 向其他用户发送呼叫
          self.requestAudioChat(salonInfo);
        });
      }, function (resultCode) {
        console.error('get turn config error ' + resultCode);
      });
    }
  }, {
    key: "requestAudioChat",
    value: function requestAudioChat(salonInfo) {
      var users = [salonInfo.getSpeaker()].concat(salonInfo.getAudiences());
      var currentUser = app.currentUser.getUserId();
      // 发送给所有人
      var _iterator = _createForOfIteratorHelper(users),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var user = _step.value;
          if (currentUser !== user.id) {
            this.webRtcCaller.createPeerConnection(user.id, this.localStream);
          }
        }
        // 发送给host
        /*
        if (salonInfo.getSpeaker().id !== currentUser) {
          this.webRtcCaller.createPeerConnection(salonInfo.getSpeaker().id, this.localStream);
        }
        */
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "closeAllAudio",
    value: function closeAllAudio() {
      if (this.webRtcCallee) {
        this.webRtcCallee.close();
      }
      if (this.webRtcCaller) {
        this.webRtcCaller.close();
      }
      this.localStream = null;
    }
  }, {
    key: "_transferSalon",
    value: function _transferSalon(e) {
      var self = this;
      this.audiencePopup = new _MDAudiencePopupView["default"]({
        audienceList: this.salonInfo.getAudiences(),
        audienceSelectedCallback: function audienceSelectedCallback(audience) {
          _MMEnterpriseController["default"].transferSalon(self.salonInfo.getSalonId(), audience.id, self.fileInfo.getFileId(), function () {
            self.salonInfo.setAudienceToSpeaker(audience);
            self._updateMemInfoAndBtns();
          }, function () {});
        }
      });
      var z_startIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
      this.audiencePopup.$el.css("z-index", z_startIndex);
      var self = this;
      this.audiencePopup.show({
        triggerView: e.currentTarget,
        center: true,
        width: 100
      });
    }
  }, {
    key: "_closeSalon",
    value: function _closeSalon() {
      var self = this;
      var salonId = this.salonInfo.getSalonId();
      var promptStr = _MDLocalString["default"].getLocalString(2017); // 确认要关闭演播？
      var alertOpt = {
        message: promptStr,
        okFun: function okFun() {
          _MMEnterpriseController["default"].closeSalon(salonId, self.fileInfo.getFileId(), function () {
            self.salonInfo = null;
            self.fileInfo.setSalonInfo(null);
            self.salonInfoUpdatedCallback(null);
            self._showStartSalon();
          }, function () {
            _MDMessageView["default"].error(_MDLocalString["default"].getLocalString(168)); // '关闭失败，请刷新后重试'
          });
          self.closeAllAudio();
        }
      };
      _MDAlertView["default"].showStandardSelection(alertOpt);
    }
  }, {
    key: "_keyDown",
    value: function _keyDown(e) {
      if (e.keyCode == 13) {
        var msg = this.$('.msg-input').val();
        this.$('.msg-input').val('');
        var uId = app.currentUser.getUserId();
        var uName = app.currentUser.getUserName();
        var time = new Date().getTime() / 1000;
        this.appendMsg(uId, uName, time, msg);
      }
      ;
    }
  }, {
    key: "_toggleSalonToolbar",
    value: function _toggleSalonToolbar(e) {
      if (!this.salonToolPanel) {
        this.salonToolPanel = new _MDSalonOperationToolPanel["default"]();
      } else {
        this.salonToolPanel.setShow(!this.salonToolPanel.isShow());
      }
    }
  }, {
    key: "appendMsg",
    value: function appendMsg(uId, uName, time, text) {
      if (!text || text.trim().length == 0) {
        return;
      }
      ;
      var msgInfo = {
        'type': _MD_SALON_MSG_TYPE["default"].ChatMsg,
        'salonId': this.salonInfo.getSalonId(),
        'fileId': this.salonInfo.getFileId(),
        'uId': uId,
        'uName': uName,
        'time': _MMCommonFun["default"].formatOnlyTime(time),
        'text': text
      };
      var self = this;
      var $msgHtml = $(_.template(_MDSalonPanelViewTmpl["default"].salonMsg)(msgInfo));
      this.$('.message-list').append($msgHtml);
      if (uId !== app.currentUser.getUserId()) {} else {
        $msgHtml.addClass('my-msg');
        var sending = _MDLocalString["default"].getLocalString(2018); //  "正在发送"
        var fail = _MDLocalString["default"].getLocalString(2019); //  "发送失败"
        var timeout = setBabelTimeout(function () {
          $msgHtml.addClass('s-sending');
          $msgHtml.find('.status').text(sending + '...');
        }, 1000);
        msgInfo['time'] = time;
        _MMEnterpriseController["default"].broadCastSalonMsg(this.fileId, msgInfo, function () {
          $msgHtml.removeClass('s-sending');
          clearTimeout(timeout);
        }, function () {
          clearTimeout(timeout);
          $msgHtml.removeClass('s-sending');
          $msgHtml.addClass('s-fail');
          $msgHtml.find('.status').text(fail);
        });
      }
      setBabelTimeout(function () {
        self.$('.message-list')[0].scrollTop = 1000000; // scroll to the end
      }, 100);
    }
  }, {
    key: "salonMsgManage",
    value: function salonMsgManage(salonMsg) {
      var self = this;
      var fileId = salonMsg.getFileId();
      if (!this.salonInfo || this.salonInfo && this.salonInfo.getFileId() != fileId) {
        return;
      }
      ;
      var type = salonMsg.getType();
      switch (type) {
        case _MD_SALON_MSG_TYPE["default"].SalonClosed:
          if (this.isVisible()) {
            var alertOpt = {
              okFun: function okFun() {
                self.salonInfo = null;
                self._showStartSalon();
                self.closeAllAudio();
              },
              message: _MDLocalString["default"].getLocalString(2020)
            };
            _MDAlertView["default"].showStandardPrompt(alertOpt);
          }
          ;
          break;
        case _MD_SALON_MSG_TYPE["default"].ChatMsg:
          var uId = salonMsg.getUId();
          var uName = salonMsg.getUName();
          var text = salonMsg.getText();
          var time = salonMsg.getTime();
          this.appendMsg(uId, uName, time, text);
          break;
        case _MD_SALON_MSG_TYPE["default"].SalonPenAdd:
          break;
        case _MD_SALON_MSG_TYPE["default"].SalonEaraser:
          break;
      }

      // WebRTC 相关消息
      var currentUser = app.currentUser.getUserId();
      if (salonMsg.getTargetUid() == currentUser) {
        var errorMsg = "";
        var notReady = _MDLocalString["default"].getLocalString(2021);
        switch (type) {
          case _MD_SALON_MSG_TYPE["default"].SessionOffer:
            if (this.webRtcCallee) {
              this.webRtcCallee.onOfferMsg(salonMsg.getUId(), salonMsg.getSdp(), this.localStream);
            } else {
              errorMsg = notReady;
            }
            break;
          case _MD_SALON_MSG_TYPE["default"].SessionAnswer:
            if (this.webRtcCaller) {
              this.webRtcCaller.onAnswerMsg(salonMsg.getUId(), salonMsg.getSdp());
            } else {
              errorMsg = notReady;
            }
            break;
          case _MD_SALON_MSG_TYPE["default"].IceCandidateOffer:
            if (this.webRtcCallee) {
              this.webRtcCallee.onICECandidateArrive(salonMsg.getUId(), salonMsg.getCandidate());
            } else {
              errorMsg = notReady;
            }
            break;
          case _MD_SALON_MSG_TYPE["default"].IceCandidateAnswer:
            if (this.webRtcCaller) {
              this.webRtcCaller.onICECandidateArrive(salonMsg.getUId(), salonMsg.getCandidate());
            } else {
              errorMsg = notReady;
            }
            break;
        }
        if (errorMsg.length) {
          _MDSnackbarView["default"].show(errorMsg);
        }
        ;
      }
    }
  }]);
  return MDSalonPanelView;
}(_MDBasicToolPanel2["default"]);
/**
 * 创建本地视频流
 * @param {Callback} cb
 */
function createLocalStream(cb) {
  navigator.mediaDevices.getUserMedia({
    audio: true,
    // 是否包含视频
    video: false // 是否包含音频
  }).then(function (stream) {
    cb(null, stream);
  })["catch"](cb);
}
/**
 * 处理访问本地摄像头和麦克风时出现的错误
 * @param {Error} e
 */
function handleGetUserMediaError(e) {
  var errorMsg = e.message;
  //todo: 错误处理
  switch (e.name) {
    case "NotFoundError":
      //设备没找到
      errorMsg = _MDLocalString["default"].getLocalString(2022);
      break;
    case "SecurityError":
      errorMsg = 'no security';
      break;
    case "PermissionDeniedError":
      //用户禁止
      errorMsg = _MDLocalString["default"].getLocalString(2024); //'用户禁止了语音请求';
      break;
    case "NotSupportedError":
      if (e.code == 9) {
        errorMsg = _MDLocalString["default"].getLocalString(2025); //"启动语音失败，语音通话需要 https 协议"
      }
      ;
    default:
      break;
  }
  _MDSnackbarView["default"].show(errorMsg);
}

/**
 * turn 服务器
 */
var stunUrl = "stun:turnserver.babel.cc";
var turnUrl = "turn:turnserver.babel.cc";
function log(msg) {
  console.log(msg);
}
function getIceServers(config) {
  return [{
    urls: stunUrl,
    username: config.username,
    // turn 服务器的验证信息, optional
    credential: config.password // turn 服务器的验证信息，optional
  }, {
    urls: turnUrl,
    // string or array of string, stun or turn 服务器地址
    username: config.username,
    // turn 服务器的验证信息, optional
    credential: config.password // turn 服务器的验证信息，optional
  }];
}
var BaseCall = /*#__PURE__*/function () {
  function BaseCall(salonInfo, config) {
    (0, _classCallCheck2["default"])(this, BaseCall);
    this.salonInfo = salonInfo;
    this.config = config;
    this.connections = [];
    this.connMap = {};
  }
  (0, _createClass2["default"])(BaseCall, [{
    key: "close",
    value: function close() {
      var _iterator2 = _createForOfIteratorHelper(this.connections),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var connection = _step2.value;
          connection.close();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var body = document.querySelector('body');
      for (var uid in this.connMap) {
        this.removeConnUser(uid);
      }
      this.connections = [];
      this.connMap = {};
    }
  }, {
    key: "removeConnUser",
    value: function removeConnUser(user) {
      var body = document.body;
      var vid = "salon_".concat(user, "_video");
      var video = document.getElementById(vid);
      if (video) {
        video.srcObject.getTracks().forEach(function (track) {
          return track.stop();
        });
        video.srcObject = null;
        document.body.removeChild(video);
      }
    }
  }, {
    key: "handleICECandidateEvent",
    value: function handleICECandidateEvent(user) {
      var _this3 = this;
      return function (event) {
        if (event.candidate) {
          log('Outgoing ICE candidate: ' + event.candidate.candidate);
          // 通过服务端发送 candidate
          _this3.sendICECandidate(user, event.candidate);
        }
      };
    }
  }, {
    key: "handleTrackEvent",
    value: function handleTrackEvent(user) {
      var _this4 = this;
      return function (event) {
        var stream = event.streams[0];
        //todo: 显示stream
        log('callee receive stream');
        _this4.playStream(user, stream);
      };
    }
    /**
     * 接收到了对方的语音
     * @param {string} user
     */
  }, {
    key: "handleAddStreamEvent",
    value: function handleAddStreamEvent(user) {
      var _this5 = this;
      return function (event) {
        var stream = event.stream;
        //todo: 显示stream
        log('caller receive stream');
        _this5.playStream(user, stream);
      };
    }
  }, {
    key: "handleRemoveStreamEvent",
    value: function handleRemoveStreamEvent(user) {
      var _this6 = this;
      return function (event) {
        _this6.removeConnUser(user);
      };
    }
  }, {
    key: "handleICEConnectionStateChangeEvent",
    value: function handleICEConnectionStateChangeEvent(user) {
      var _this7 = this;
      return function (event) {
        var connection = _this7.connMap[user];
        if (connection) {
          switch (connection.iceConnectionState) {
            case "closed":
            case "failed":
            case "disconnected":
              delete _this7.connMap[user];
              _this7.removeConnUser(user);
              break;
          }
        }
      };
    }
  }, {
    key: "handleSignalingStateChangeEvent",
    value: function handleSignalingStateChangeEvent(user) {
      var _this8 = this;
      return function (event) {
        var connection = _this8.connMap[user];
        if (connection) {
          switch (connection.signalingState) {
            case "closed":
              delete _this8.connMap[user];
              _this8.removeConnUser(user);
              break;
          }
        }
      };
    }
  }, {
    key: "playStream",
    value: function playStream(user, stream) {
      var video = document.createElement("audio");
      var root = document.querySelector("body");
      root.appendChild(video);
      video.setAttribute("id", "salon_".concat(user, "_video"));
      video.srcObject = stream;
      video.onloadedmetadata = function (e) {
        video.play();
      };
    }

    /**
     * 服务端将对方的candidate传来
     * @param {string} candidate
     * @param {Callback} cb
     */
  }, {
    key: "onICECandidateArrive",
    value: function onICECandidateArrive(user, candidate) {
      var connection = this.connMap[user];
      var iceCandidate = new RTCIceCandidate(candidate);
      connection.addIceCandidate(iceCandidate)["catch"](function (err) {
        console.error('caller add IceCandidate error ' + err);
      });
      log('receive candidate:' + JSON.stringify(candidate));
    }
  }]);
  return BaseCall;
}();
var Callee = /*#__PURE__*/function (_BaseCall) {
  (0, _inherits2["default"])(Callee, _BaseCall);
  function Callee(salonInfo, config) {
    (0, _classCallCheck2["default"])(this, Callee);
    return _callSuper(this, Callee, [salonInfo, config]);
  }
  (0, _createClass2["default"])(Callee, [{
    key: "sendSessionDesc",
    value: function sendSessionDesc(user, sdp) {
      var _this9 = this;
      return new Promise(function (resolve, reject) {
        var currentUser = app.currentUser.getUserId();
        var salonMsg = {
          "type": _MD_SALON_MSG_TYPE["default"].SessionAnswer,
          "targetUid": user,
          "uId": currentUser,
          "sdp": sdp,
          "salonId": _this9.salonInfo.getSalonId(),
          "fileId": _this9.salonInfo.getFileId()
        };
        _MMEnterpriseController["default"].sendSalonMsgTo(_this9.salonInfo.getFileId(), salonMsg, user, function () {
          resolve();
        }, function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "sendICECandidate",
    value: function sendICECandidate(user, candidate) {
      var currentUser = app.currentUser.getUserId();
      var msg = {
        "type": _MD_SALON_MSG_TYPE["default"].IceCandidateAnswer,
        "candidate": candidate,
        "targetUid": user,
        "uId": currentUser,
        "salonId": this.salonInfo.getSalonId(),
        "fileId": this.salonInfo.getFileId()
      };
      _MMEnterpriseController["default"].sendSalonMsgTo(this.salonInfo.getFileId(), msg, user, function () {}, function (err) {});
    }

    // 相应服务器事件

    /**
     * 接收到caller的description时
     * @param {object} user
     * @param {string} description
     * @param {Callback} cb
     */
  }, {
    key: "onOfferMsg",
    value: function onOfferMsg(user, description, localStream) {
      var _this10 = this;
      if (localStream == undefined) {
        console.error(_MDLocalString["default"].getLocalString(2026)); //'有人想和你进行语音通话，但是你并没有打开语音'
        return;
      }
      if (this.connMap[user]) {
        return;
      }
      // todo: 此处可以拒绝通信
      var connection = new RTCPeerConnection({
        // 使用我们自己的turn服务器，用来确定自己的公网ip信息
        iceServers: getIceServers(this.config)
      });
      this.connections.push(connection);
      this.connMap[user] = connection;
      var hasAddTrack = connection.addTrack !== undefined;

      // 自己的ice准备好时被调用，然后通过服务器传给对方
      connection.onicecandidate = this.handleICECandidateEvent(user);

      // 接收到了对方语音流事件
      if (hasAddTrack) {
        connection.ontrack = this.handleTrackEvent(user);
      } else {
        connection.onaddstream = this.handleAddStreamEvent(user);
      }
      // 丢失对方流
      connection.onremovestream = this.handleRemoveStreamEvent(user);
      // 链接状态
      connection.oniceconnectionstatechange = this.handleICEConnectionStateChangeEvent(user);
      connection.onsignalingstatechange = this.handleSignalingStateChangeEvent(user);

      /**
       * RTCSessionDescription 包含需要传输数据的相关信息，例如分辨率，格式，编码等
       * 这样双方可以更好的理解对方的数据内容
       */
      var desc = new RTCSessionDescription(description);
      connection.setRemoteDescription(desc).then(function () {
        // addStream要先于createAnswer, 因为创建RTCSessionDescription需要首先理解要传输的内容信息
        connection.addStream(localStream); // 在caller的onaddstream消息会收到localStream
      }).then(function () {
        return connection.createAnswer();
      }).then(function (answer) {
        return connection.setLocalDescription(answer);
      }).then(function () {
        // send to remote
        return _this10.sendSessionDesc(user, connection.localDescription);
      })["catch"](function (err) {
        console.error('callee onOfferMsg error ' + err);
      });
      log('callee receive offer: ' + JSON.stringify(description));
    }
  }]);
  return Callee;
}(BaseCall);
var Caller = /*#__PURE__*/function (_BaseCall2) {
  (0, _inherits2["default"])(Caller, _BaseCall2);
  function Caller(salonInfo, config) {
    (0, _classCallCheck2["default"])(this, Caller);
    return _callSuper(this, Caller, [salonInfo, config]);
  }

  /**
   * 向目标用户发起语音请求
   * @param {string} user
   * @param {Stream} localStream
   */
  (0, _createClass2["default"])(Caller, [{
    key: "createPeerConnection",
    value: function createPeerConnection(user, localStream) {
      var _this11 = this;
      if (localStream == undefined) {
        console.error(_MDLocalString["default"].getLocalString(2026)); //'您想向别人发起语音通话，但是并没有打开本地语音'
        return;
      }
      if (this.connMap[user]) {
        // 连接已经建立
        return;
      }
      log('Setting up connection...');
      var connection = new RTCPeerConnection({
        // 链接我们自己的turn服务器，用来确定自己的公网ip信息
        iceServers: getIceServers(this.config)
      });
      this.connections.push(connection);
      this.connMap[user] = connection;
      var hasAddTrack = connection.addTrack !== undefined;
      // 当对方添加视频流时调用，用来显示对方流内容
      if (hasAddTrack) {
        connection.ontrack = this.handleTrackEvent(user);
      } else {
        connection.onaddstream = this.handleAddStreamEvent(user);
      }

      // 自己的ice准备好时被调用，然后通过服务器传给对方
      connection.onicecandidate = this.handleICECandidateEvent(user);

      // 对方音频流移除事件
      connection.onremovestream = this.handleRemoveStreamEvent(user);
      // ice状态改变
      connection.oniceconnectionstatechange = this.handleICEConnectionStateChangeEvent(user);
      connection.onsignalingstatechange = this.handleSignalingStateChangeEvent(user);
      connection.addStream(localStream);
      // 生成sdp，并发给对方
      connection.createOffer().then(function (offer) {
        return connection.setLocalDescription(offer);
      }).then(function () {
        log('sending offer to salon host');
        // 通过服务端发送 sdp
        return _this11.sendSessionDesc(user, connection.localDescription);
      })["catch"](function (err) {
        // log error
      });
    }
  }, {
    key: "sendSessionDesc",
    value: function sendSessionDesc(user, sdp) {
      var _this12 = this;
      return new Promise(function (resolve, reject) {
        var currentUser = app.currentUser.getUserId();
        var salonMsg = {
          "type": _MD_SALON_MSG_TYPE["default"].SessionOffer,
          "targetUid": user,
          "uId": currentUser,
          "sdp": sdp,
          "salonId": _this12.salonInfo.getSalonId(),
          "fileId": _this12.salonInfo.getFileId()
        };
        _MMEnterpriseController["default"].sendSalonMsgTo(_this12.salonInfo.getFileId(), salonMsg, user, function () {
          resolve();
        }, function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "sendICECandidate",
    value: function sendICECandidate(user, candidate) {
      var currentUser = app.currentUser.getUserId();
      var msg = {
        "type": _MD_SALON_MSG_TYPE["default"].IceCandidateOffer,
        "candidate": candidate,
        "uId": currentUser,
        "targetUid": user,
        "salonId": this.salonInfo.getSalonId(),
        "fileId": this.salonInfo.getFileId()
      };
      _MMEnterpriseController["default"].sendSalonMsgTo(this.salonInfo.getFileId(), msg, user, function () {}, function (err) {});
    }

    // 服务端事件

    /**
     * 服务端将对方sdp传来
     * @param {string} description
     * @param {Callback} cb
     */
  }, {
    key: "onAnswerMsg",
    value: function onAnswerMsg(user, description) {
      var connection = this.connMap[user];
      var remoteDesc = new RTCSessionDescription(description);
      connection.setRemoteDescription(remoteDesc)["catch"](function (err) {
        console.error('caller set remote sdp error ' + err);
      });
      log('receive answer:' + JSON.stringify(description));
    }
  }]);
  return Caller;
}(BaseCall);

},{"1098":1098,"1150":1150,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1417":1417,"1418":1418,"1419":1419,"1422":1422,"1423":1423,"1429":1429,"1437":1437,"1438":1438,"1439":1439,"1454":1454,"1463":1463,"1471":1471,"1475":1475,"1477":1477,"1478":1478,"1487":1487,"1498":1498,"1500":1500,"1502":1502,"1503":1503,"1537":1537,"1538":1538,"18":18,"202":202,"204":204,"206":206,"209":209,"212":212,"32":32,"325":325,"456":456,"55":55,"72":72,"811":811,"812":812}],209:[function(require,module,exports){
module.exports = {"noStart":"<div class=\"salon-no-start\">\r\t<button class=\"button done start-sl-btn\"><%=open%></button>\r</div>","showing":"<div class=\"salon-broadcast\">\r\t<div class=\"salon-mem\"></div>\r\t<div class=\"button-zone\">\r<!-- \t\t<button class=\"button done salon-op-btn \">工具箱</button>\r -->\t\t<button class=\"button done transfer-speaker \"><%=changeSpeaker%></button>\r\t\t<button class=\"button done close-salon\"><%=close%></button>\r\t\t<button class=\"button done add-salon\"><%=look%></button>\r\t\t<button class=\"button done leave-salon\"><%=leave%></button>\r\t</div>\r\t<div class=\"chat-zone\">\r\t\t<ul class=\"message-list\"></ul>\r\t\t<div class=\"input-zone\">\r\t\t\t<input type=\"text\" placeholder=\"<%=chatInput%>\" class=\"form-control msg-input\">\r\t\t</div>\r\t</div>\r</div>","salonMem":"<div><%=speaker%>：<span class=\"speaker-name\"><%=speakerName %></span></div>\r\t<div class=\"audience-root\">\r\t\t<div><%=audi%>(<span><%=audience.length%></span>)</div>\r\t\t<div class=\"audience-list\">\r\t\t\t<% for(var i = 0; i < audience.length; i++) {%>\r\t\t\t<span><%=audience[i].name%></span>\r\t\t\t<%}%>\r\t\t</div>\r\t</div>","salonMsg":"<div class=\"salon-msg-div\">\r\t<div class=\"user-info\">\r\t\t<span class=\"u-name\"><%=uName%></span>\r\t\t<span><%=time%></span>\r\t</div>\r\t<div class=\"salon-msg-t\"><%=text%><span class=\"status\"></span></div>\r</div>"};
},{}],206:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1461);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDBasicToolPanel2 = _interopRequireDefault(require(456));
var _MDSalonOperationToolPanelTmpl = _interopRequireDefault(require(207));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDEvents = _interopRequireDefault(require(325));
var _MMBasicData = _interopRequireDefault(require(811));
var _MDAlertView = _interopRequireDefault(require(32));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDMessageView = _interopRequireDefault(require(55));
var _MMCommonFun = _interopRequireDefault(require(812));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // MDSalonOperationToolPanel.js
// jiang
// 2017-6-15
var MDSalonOperationToolPanel = exports["default"] = /*#__PURE__*/function (_MDBasicToolPanel) {
  (0, _inherits2["default"])(MDSalonOperationToolPanel, _MDBasicToolPanel);
  function MDSalonOperationToolPanel() {
    (0, _classCallCheck2["default"])(this, MDSalonOperationToolPanel);
    return _callSuper(this, MDSalonOperationToolPanel, arguments);
  }
  (0, _createClass2["default"])(MDSalonOperationToolPanel, [{
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSalonOperationToolPanel.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        salonInfo: null
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSalonOperationToolPanel.prototype), "events", this).call(this);
      return _.extend(superE, {
        // "mousedown .start-sl-btn": this._startSalonClicked
        'click .button': this._buttonClicked
      });
    }
  }, {
    key: "remove",
    value: function remove(opt_removeRef) {
      this.$('.start-sl-btn').off();
      this.$('button').off();
      this.$('input').off();
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSalonOperationToolPanel.prototype), "remove", this).call(this, opt_removeRef);
      this.setTitle(BabelStr.str(3256));
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      this.elClassName = 'salon-op-p';
      _.extend(props, {
        inEditor: true,
        closeIsHide: true
      });
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSalonOperationToolPanel.prototype), "initialize", this).call(this, props);
      var html = _.template(_MDSalonOperationToolPanelTmpl["default"])();
      this.$('.tool-p-content').empty().append($(html));
      $('body').append(this.$el);
    }
  }, {
    key: "setShow",
    value: function setShow(show) {}
  }, {
    key: "_buttonClicked",
    value: function _buttonClicked(e) {
      var $target = $(e.currentTarget);
      var eventMap = {
        'op-rect': _MDEvents["default"].Salon_op_rect,
        'op-circle': _MDEvents["default"].Salon_op_circle,
        'op-text': _MDEvents["default"].Salon_op_text,
        'op-del': _MDEvents["default"].Salon_op_del
      };
      var keys = Object.keys(eventMap);
      for (var i = 0; i < keys.length; i++) {
        if ($target.hasClass(keys[i])) {
          _Dispatcher["default"].trigger(eventMap[keys[i]]);
          break;
        }
      }
      ;
    }
  }]);
  return MDSalonOperationToolPanel;
}(_MDBasicToolPanel2["default"]);

},{"1098":1098,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1461":1461,"1463":1463,"1475":1475,"18":18,"207":207,"32":32,"325":325,"456":456,"55":55,"811":811,"812":812}],207:[function(require,module,exports){
module.exports = '<div class="salon-op-root">\	<div class="salon-tool-root">\		<!-- <span class="op-rect button">矩形</span>\		<span class="op-circle button">圆形</span>\		<span class="op-text button">文字</span>\		<span class="op-del button">删除</span> -->\		<span class="op-rect button"><%=Babel.str(3257)%></span>\		<span class="op-circle button"><%=Babel.str(3258)%></span>\		<span class="op-text button"><%=Babel.str(3259)%></span>\		<span class="op-del button"><%=Babel.str(32)%></span>\	</div>\	<div class="salon-op-attr">\		<span>\			<!-- <span class="w-s button">细</span>\			<span class="w-m button">中</span>\			<span class="w-l button">粗</span> -->\			<span class="w-s button"><%=Babel.str(3260)%></span>\			<span class="w-m button"><%=Babel.str(3261)%></span>\			<span class="w-l button"><%=Babel.str(3262)%></span>\		</span>\		<span>\			<!-- <span class="c-r button">红</span>\			<span class="c-g button">绿</span>\			<span class="c-b button">蓝</span>\			<span class="c-white button">白</span>\			<span class="c-gray button">灰</span>\			<span class="c-gray button">黑</span> -->\			<span class="c-r button"><%=Babel.str(3263)%></span>\			<span class="c-g button"><%=Babel.str(3264)%></span>\			<span class="c-b button"><%=Babel.str(3265)%></span>\			<span class="c-white button"><%=Babel.str(3266)%></span>\			<span class="c-gray button"><%=Babel.str(3267)%></span>\			<span class="c-gray button"><%=Babel.str(3268)%></span>\		</span>\	</div>\</div>';
},{}],202:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1439);
var _MDPopupView = _interopRequireDefault(require(64));
var _popupPos = _interopRequireDefault(require(65));
/**
 *  Menu for zoom choices
 *  Create by jiang
 *  2017.6.16
 */

var MDAudiencePopupView = _MDPopupView["default"].extend({
  contentTmpl: '<ul class="m-menun audience-popup"></ul>',
  events: function events() {
    var superEvents = _MDPopupView["default"].prototype.events.call(this);
    return _.extend({}, superEvents, {
      'click li': this._menuItemClickHandler
    });
  },
  initProps: function initProps() {
    var superP = _MDPopupView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      audienceSelectedCallback: null
    });
  },
  initialize: function initialize(opt) {
    _.extend(opt, {
      direction: _popupPos["default"].LEFT_TOP
    });
    _MDPopupView["default"].prototype.initialize.call(this, opt);
    this.initAudienceList();
  },
  initAudienceList: function initAudienceList() {
    var html = "";
    if (this.audienceList.length > 0) {
      for (var i = 0; i < this.audienceList.length; i++) {
        var name = this.audienceList[i].name;
        html += "<li >" + name + "</li>";
      }
      ;
    } else {
      html = "<li>" + BabelStr.str(3254) + "<br>" + BabelStr.str(3255) + "</li>";
    }
    this.$(".audience-popup").append(html);
    this.$audienceList = $(html);
  },
  _menuItemClickHandler: function _menuItemClickHandler($e) {
    var index = $($e.target).index();
    this.audienSelected = null;
    if (index < this.audienceList.length) {
      this.audienSelected = this.audienceList[index];
    }
    ;
    if (this.audienSelected) {
      if (this.audienceSelectedCallback) {
        this.audienceSelectedCallback(this.audienSelected);
      }
      ;
    } else {}
    this.close();
  }
});
var _default = exports["default"] = MDAudiencePopupView;

},{"1184":1184,"1439":1439,"1454":1454,"64":64,"65":65}],430:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1498);
require(1541);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _keycode = _interopRequireDefault(require(104));
var _MMViewBase2 = _interopRequireDefault(require(22));
var _MMBasicData = _interopRequireDefault(require(811));
var _Dispatcher = _interopRequireDefault(require(18));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // MDBasicToolPanel.js
// jiang
// 2017-5-11
// import {PDFFindController} from './pdfplugin/pdf_find_controller.js';
// import {PDFLinkService} from './pdfplugin/pdf_link_service.js';
var MDSearchPdfTextToolbar = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MDSearchPdfTextToolbar, _MMViewBase);
  function MDSearchPdfTextToolbar() {
    (0, _classCallCheck2["default"])(this, MDSearchPdfTextToolbar);
    return _callSuper(this, MDSearchPdfTextToolbar, arguments);
  }
  (0, _createClass2["default"])(MDSearchPdfTextToolbar, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n      <div class=\"tool-search-root\">\n        <div class=\"input-container flex-align middle\">\n          <input id=\"findInput\"  class=\"toolbarField \" title=\"<%=BabelStr.str(2687)%>\" placeholder=\"<%=BabelStr.str(2682)%>\" tabindex=\"91\" data-l10n-id=\"find_input\" data-status=\"\">\n          <div class=\"splitToolbarButton inline-b\">\n            <button id=\"findPrevious\" class=\"toolbarButton findPrevious inline-b icon prev\" data-tooltip-dir=\"top\" data-tooltip=\"<%=BabelStr.str(2683)%>\" tabindex=\"92\"></button>\n            <button id=\"findNext\" class=\"toolbarButton findNext inline-b icon next\" data-tooltip-dir=\"top\" data-tooltip=\"<%=BabelStr.str(2684)%>\" tabindex=\"93\" ></button>\n          </div>\n\n          <input type=\"checkbox\" class=\"match-case mgl-10\" />\n          <span class=\"mgr-10\"><%=BabelStr.str(2690)%></span>\n\n          <input type=\"checkbox\" class=\"highlight mgl-10\" />\n          <span class=\"mgr-10\"><%=BabelStr.str(2688)%></span>\n\n          <input type=\"checkbox\" class=\"whole-word mgl-10\" />\n          <span class=\"mgr-10\"><%=BabelStr.str(2689)%></span>\n          <div class=\"num\">0/0</div>\n        </div>\n      </div>\n      ";
    }
  }, {
    key: "className",
    value: function className() {
      return "tool-search-bar tool-panel-pallet";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSearchPdfTextToolbar.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        closeIsHide: false,
        closeIsShowBtn: false,
        caseSensitive: false,
        entireWord: false,
        highlightAll: false,
        findPrevious: false,
        searchText: "",
        editorViewCtl: ""
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSearchPdfTextToolbar.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .tool-p-close ": this._closeHandler,
        "mousewheel .tool-panel ": this._wheelHandler,
        "click .display-btn": this.hideDisBtn,
        "click .findNext": this._findNext,
        "click .findPrevious": this._findPrevious,
        "keydown #findInput": this.keydown,
        "input #findInput": this.input,
        "click .highlight": this._highlightHandle,
        "click .whole-word": this._wholeWorddHandle,
        "click .match-case": this._matchCaseHandle
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      this.strClassName = "MDBasicToolPanel";
      this.bindSelf(this._updateNum);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSearchPdfTextToolbar.prototype), "initialize", this).call(this, props);
      if (this.hideCloseBtn) {
        this.$(".tool-p-close").remove();
      }
      if (this.width) {
        this.$(".tool-panel").width(this.width);
      }
      if (this.elClassName) {
        this.$(".tool-panel").addClass(this.elClassName);
      }
      if (props.normalEditorPanel) {
        this.$(".tool-panel").addClass("normal-editor-panel");
      }
      $(window).resize(this._winResizeFun);
      this.$el.css({
        "z-index": 9999999
      });
      this.editorViewCtl.getCurrentBoard().eventBus.on("updatefindmatchescount", function (options) {
        var matchesCount = options.matchesCount;
        _this.$(".num").html("".concat(matchesCount.current, "/").concat(matchesCount.total));
      });
      if (this.searchText && this.editorViewCtl) {
        this.$("#findInput").val(this.searchText);
        this.findString(this.searchText, "find");
      }
    }
  }, {
    key: "_matchCaseHandle",
    value: function _matchCaseHandle($e) {
      this.caseSensitive = $e.target.checked;
      this._find();
    }
  }, {
    key: "_highlightHandle",
    value: function _highlightHandle($e) {
      this.highlightAll = $e.target.checked;
      this._find();
    }
  }, {
    key: "_wholeWorddHandle",
    value: function _wholeWorddHandle($e) {
      this.entireWord = $e.target.checked;
      this._find();
    }
  }, {
    key: "_updateNum",
    value: function _updateNum(options) {}
  }, {
    key: "_find",
    value: function _find() {
      var val = this.$("#findInput").val().trim();
      this.findString(val, "find");
    }
  }, {
    key: "_findNext",
    value: function _findNext() {
      var val = this.$("#findInput").val().trim();
      this.findString(val, "again", false);
    }
  }, {
    key: "_findPrevious",
    value: function _findPrevious() {
      var val = this.$("#findInput").val().trim();
      this.findString(val, "again", true);
    }
  }, {
    key: "findString",
    value: function findString(val, type, findPrevious) {
      if (!this.editorViewCtl.getCurrentBoard().pdfLinkService) {
        return;
      }
      this.editorViewCtl.getCurrentBoard().pdfLinkService.setEditor(this.editorViewCtl.editor);
      this.editorViewCtl.getCurrentBoard().eventBus.dispatch("find", {
        source: this,
        type: type,
        query: val,
        caseSensitive: this.caseSensitive,
        entireWord: this.entireWord,
        highlightAll: this.highlightAll,
        findPrevious: findPrevious
      });

      // this.editorViewCtl.getCurrentBoard().findController.executeCommand(type, {
      //   query: val,
      //   phraseSearch: true,
      //   caseSensitive: this.caseSensitive,
      //   entireWord: this.entireWord,
      //   highlightAll: this.highlightAll,
      //   findPrevious: findPrevious
      // });
    }
  }, {
    key: "openPdfLink",
    value: function openPdfLink(obj) {
      var mainEditor = MDPcMobileEditorCommonFun.getMainEditor();
      if (mainEditor.removeCommentPanel) {
        mainEditor.removeCommentPanel();
      }
      this.editorViewCtl.editor.scrollToShowPdfLink(obj);
    }
  }, {
    key: "_loadPages",
    value: function _loadPages(imgPdfObjs, callback) {
      var pagesCount = imgPdfObjs.length;
      var pagesInfo = [];
      var i = 0;
      var pdf = null;
      function loadPages(index) {
        if (index >= imgPdfObjs.length) {
          // 已经获得所有 page info
          callback(pdf, pagesInfo);
          return;
        }
        var pdfObj = imgPdfObjs[index];
        pdfObj.getPdfPage(function (page) {
          var viewport = page.getViewport(1.0);
          var pageSizeInfo = {
            width: viewport.width,
            height: viewport.height,
            rotation: viewport.rotation
          };
          pagesInfo.push(pageSizeInfo);
          if (pdf == null) {
            pdf = pdfObj.getPdfDoc();
          }
          loadPages(++index);
        });
      }
      loadPages(0);
    }
  }, {
    key: "refreshDirByFile",
    value: function refreshDirByFile() {
      var self = this;
      var board = this.editorViewCtl.getCurrentBoard();
      if (board.isOperateOnPDFFile()) {
        var fileInfo = this.editorViewCtl.getCurrentFileInfo();
        var curVersion = this.editorViewCtl.getVersionShowing();
        var imgPdfObjs = board.getImgPdfObjectsForVersion(curVersion);
        this._loadPages(imgPdfObjs, function (pdf, pagesInfo) {
          self.pdfLinkService.setDocument(pdf);
          self.findController.setDocument(pdf);
        });
      } else {}
    }
  }, {
    key: "keydown",
    value: function keydown($e) {
      var _this2 = this;
      if (_keycode["default"].codes.LEFT == $e.keyCode || _keycode["default"].codes.RIGHT == $e.keyCode) {
        return false;
      }
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        if ($e.keyCode == 13) {
          _this2._findNext();
        }
      }, 400);
      $e.stopPropagation();
    }
  }, {
    key: "input",
    value: function input($e) {
      $e.stopPropagation();
      if ($e.keyCode == 13) {
        this._findNext();
      } else {
        this._find();
      }
    }
  }, {
    key: "viewWillUnRendered",
    value: function viewWillUnRendered() {
      this.findString("", "find");
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSearchPdfTextToolbar.prototype), "viewWillUnRendered", this).call(this);
    }
  }, {
    key: "setEditorViewCtl",
    value: function setEditorViewCtl(editorViewCtl) {
      this.editorViewCtl = editorViewCtl;
      // this.refreshDirByFile();
      // this.pdfLinkService.setEditor(editorViewCtl.editor)
    }
  }]);
  return MDSearchPdfTextToolbar;
}(_MMViewBase2["default"]);

},{"104":104,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1454":1454,"1463":1463,"1475":1475,"1498":1498,"1541":1541,"18":18,"22":22,"811":811}],414:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
var _MDSalonToolbar = _interopRequireDefault(require(429));
var _MDCommentToolbar = _interopRequireDefault(require(218));
var _MMViewBase = _interopRequireDefault(require(22));
var _MDEditorLeftPanleView = _interopRequireDefault(require(445));
var _MDPDFToolbar4PC = _interopRequireDefault(require(424));
var _MDZoomToolbar = _interopRequireDefault(require(440));
var _MDPenToolbar = _interopRequireDefault(require(427));
var _MDPenListPanelView = _interopRequireDefault(require(426));
var _MDGraphicToolTabView = _interopRequireDefault(require(442));
var _MDWelMarkSettingWindow = _interopRequireDefault(require(438));
var _aiLoader = _interopRequireDefault(require(346));
var _MDSigSavePanelView = _interopRequireDefault(require(431));
/**
 *  moladisk/views/editor/MDEditorContentPanelView.js
 *  Created by author's name
 *  date here(2015.6.24)
 */

// import MDAIMainPanelView from '../ai/MDAIMainPanelView.js';

var MDEditorContentPanelView = _MMViewBase["default"].extend({
  tmpl: '<div class="p-commentsNavi-zone r-shadow1"></div>' + '<div class="p-editor-zone"></div>' + '<div class="p-ai-zone"></div>' + '<div class="p-ocr-zone"></div>',
  className: function className() {
    var superCls = _MMViewBase["default"].prototype.className.call(this);
    return superCls + ' editor-content-panel';
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      $commentsNaviZone: null,
      $editorZone: null,
      aiZone: null,
      editorViewCtl: null,
      bottomToolBar: null,
      bottomBarTimer: -1
    });
  },
  initialize: function initialize(opt) {
    var _this = this;
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.bindSelf(this.toggleCommentsNavigator, this.toggleAINavigator);
    this.$commentsNaviZone = this.$('.p-commentsNavi-zone');
    this.$editorZone = this.$('.p-editor-zone');
    this.$aiZone = this.$('.p-ai-zone');
    this.$ocrZone = this.$('.p-ocr-zone');
    this.editorLeftPanel = new _MDEditorLeftPanleView["default"]({
      showToggleBtn: function showToggleBtn() {
        _this.superView && _this.superView.showToggleBtn();
      }
    });
    this.addSubView(this.editorLeftPanel, this.$commentsNaviZone[0]);
    this.bottomToolBar = new _MDPDFToolbar4PC["default"]();
    this.addSubView(this.bottomToolBar, this.$(".p-editor-zone")[0]);
    this.bottomToolBar.hide();
    this.zoomToolbar = new _MDZoomToolbar["default"]();
    this.addSubView(this.zoomToolbar, this.$(".p-editor-zone")[0]);
    this.zoomToolbar.hide();
    this.commentToolbar = new _MDCommentToolbar["default"]();
    this.addSubView(this.commentToolbar, this.$(".p-editor-zone")[0]);
    // this.$el.append(this.commentToolbar.$el);

    this.salonToolbar = new _MDSalonToolbar["default"]();
    this.addSubView(this.salonToolbar, this.$(".p-editor-zone")[0]);
    this.$(".p-editor-zone").append("<div class=\"editor-right-top-btn-block\"></div>");
    this.sigSavePanel = new _MDSigSavePanelView["default"]();
    this.sigSavePanel.hide();
    this.addSubView(this.sigSavePanel, this.$(".editor-right-top-btn-block")[0]);
    this.penList = new _MDPenListPanelView["default"]();
    this.penList.hide();
    this.addSubView(this.penList, this.$(".editor-right-top-btn-block")[0]);

    // this.penList.showPanel('topRight');
    Dispatcher.on(MDEvents.DISPLAY_PDF_BAR, this.showBottomToolBar, this);
    Dispatcher.on(MDEvents.DISPLAY_ZOOM_BAR, this.showZoomToolBar, this);
    Dispatcher.on(MDEvents.HIDE_ZOOM_BAR, this.hideZoomToolBar, this);
    Dispatcher.on(MDEvents.toolbarChanged, this.onToolChanged, this);
    Dispatcher.on(MDEvents.beforeChangeToNextFile, this._beforeFileChanged, this);
    Dispatcher.on(MDEvents.NULL_OPERATION, this._clearTool, this);
    Dispatcher.on(MDEvents.OcrFile, this.showOcr, this);
  },
  setEditorViewCtl: function setEditorViewCtl(editorViewCtl) {
    this.editorViewCtl = editorViewCtl;
    this.bottomToolBar.setEditorViewCtl(editorViewCtl);
    this.editorLeftPanel.setEditorViewCtl(editorViewCtl);
    // this.aiPanel.setEditorViewCtl(editorViewCtl);

    this.zoomToolbar.setEditorViewCtl(editorViewCtl);
    this.commentToolbar.setEditorViewCtl(editorViewCtl);
    this.salonToolbar.setEditorViewCtl(editorViewCtl);
    this.penList.setEditorViewCtl(editorViewCtl);
    this.sigSavePanel.setEditorViewCtl(editorViewCtl);
    if (editorViewCtl.getCurrentFileInfo().dispNeedWhiteBoard()) {
      this.penList.show();
    } else {
      this.penList.hide();
    }

    // this.sigSavePanel.show()

    this.penToolbar && this.penToolbar.setEditorViewCtl(editorViewCtl);
    this.graphicToolTabView && this.graphicToolTabView.setEditorViewCtl(this.editorViewCtl);
    this.penZoneCtl = editorViewCtl.getPenZoneCtl(); // 获取对应的手绘批注管理器
    var fileInfo = this.editorViewCtl.getCurrentFileInfo();
    if (this.penZoneCtl.userMarkLgRects.length) {
      this.penZoneCtl.refreshData();
      this.penList.hideDisBtn();
    } else {
      this.penList.showDisBtn();
    }
    var editorClass = this.editorViewCtl.getCurEditor().getClassName();
    if (editorClass == 'MMPDFCollectionView') {
      this.showBottomToolBar();
    }
    ;
  },
  showZoomToolBar: function showZoomToolBar() {
    if (!this.editorViewCtl) return;
    if (this.editorViewCtl.getCurEditor && this.editorViewCtl.getCurEditor() && this.editorViewCtl.getCurEditor().getClassName() == 'MDSWFEditor') {
      return;
    }
    var board = this.editorViewCtl.getCurrentBoard();
    if (!board) {
      return;
    }
    if (board.getPageCount() > 1) {
      return;
    }
    ;
    this.zoomToolbar.show();
  },
  hideZoomToolBar: function hideZoomToolBar() {
    this.zoomToolbar.hide();
  },
  hideCommentToolBar: function hideCommentToolBar() {
    this.commentToolbar.hide();
  },
  showCommentToolBar: function showCommentToolBar() {
    this.commentToolbar.show();
  },
  showBottomToolBar: function showBottomToolBar() {
    if (!this.editorViewCtl) return;
    var board = this.editorViewCtl.getCurrentBoard();
    if (!board) {
      return;
    }
    if (board.getPageCount() <= 1) {
      return;
    }
    ;
    if (this.bottomBarTimer) {
      clearTimeout(this.bottomBarTimer);
    }
    ;
    this.zoomToolbar.hide();
    this.bottomToolBar.show();
    this.bottomToolBar.updatePgInfo();
    var self = this;
    this.bottomBarTimer = setBabelTimeout(function () {
      self.bottomToolBar.hide();
    }, 1000);
  },
  onToolChanged: function onToolChanged(toolName, editorViewCtl) {
    if (editorViewCtl != this.editorViewCtl) {
      return;
    }
    console.log('------------- tool name:' + toolName);
    if (toolName == "penComment" || toolName == "penEraser") {
      if (!this.penToolbar) {
        this.penToolbar = new _MDPenToolbar["default"]();
        this.addSubView(this.penToolbar, this.$(".p-editor-zone")[0]);
        this.penToolbar.setEditorViewCtl(this.editorViewCtl);
      }
      this.commentToolbar.setPenSelected();
    } else {
      if (this.penToolbar) {
        this.penToolbar.remove();
        this.penToolbar = null;
      }
    }
    if (toolName == 'graphic') {
      if (!this.graphicToolTabView) {
        this.graphicToolTabView = new _MDGraphicToolTabView["default"]();
        this.addSubView(this.graphicToolTabView, this.$(".p-editor-zone")[0]);
        this.graphicToolTabView.setEditorViewCtl(this.editorViewCtl);
      }
    } else {
      if (this.graphicToolTabView) {
        this.removeSubView(this.graphicToolTabView);
        this.graphicToolTabView = null;
      }
    }

    // test

    // MDWelMarkSettingWindow.show();
  },
  _clearTool: function _clearTool() {
    if (this.penToolbar) {
      this.penToolbar.remove();
      this.penToolbar = null;
    }
    if (this.graphicToolTabView) {
      this.removeSubView(this.graphicToolTabView);
      this.graphicToolTabView = null;
    }
  },
  _beforeFileChanged: function _beforeFileChanged() {
    if (this.graphicToolTabView) {
      this.removeSubView(this.graphicToolTabView);
      this.graphicToolTabView = null;
    }
  },
  toggleCommentsNavigator: function toggleCommentsNavigator(closed) {
    var commentsNaviZoneW = this.$commentsNaviZone.width();
    var standNaviW = 360;
    var editorL = 0;
    if (commentsNaviZoneW == 0) {
      commentsNaviZoneW = standNaviW;
      editorL = standNaviW;
    } else {
      commentsNaviZoneW = 0;
      editorL = 0;
    }
    if (closed) {
      commentsNaviZoneW = 0;
      editorL = 0;
    }
    this.$commentsNaviZone.css("width", commentsNaviZoneW + 'px');
    this.$editorZone.css('left', commentsNaviZoneW + 'px');
    this.editorViewCtl && this.editorViewCtl.refreshSize(true);
    if (commentsNaviZoneW) {
      this.editorLeftPanel.refreshCommentsList();
      this.hideAINavigator();
    }
    ;
    return editorL > 0;
  },
  toggleAINavigator: function toggleAINavigator(closed) {
    var _this2 = this;
    if (!this.aiPanel) {
      return (0, _aiLoader["default"])().then(function (MDAI) {
        _this2.aiPanel = new MDAI.MDEditorAIPanelView({
          removeAiPanel: function removeAiPanel() {
            return _this2.toggleAINavigator(true);
          }
        });
        _this2.addSubView(_this2.aiPanel, _this2.$aiZone[0]);
        return _this2.toggleAINavigator(closed);
      })["catch"](console.error);
    }
    var aiZoneW = this.$aiZone.width();
    var standNaviW = 360;
    var editorL = 0;
    if (aiZoneW <= 10) {
      aiZoneW = standNaviW;
      editorL = standNaviW;
      this.aiPanel.setEditorViewCtl(this.editorViewCtl || this.superView.editorViewCtl);
      // this.ocrPanel.setEditorViewCtl(this.editorViewCtl);
    } else {
      aiZoneW = 0;
      editorL = 0;
    }
    if (closed) {
      aiZoneW = 0;
      editorL = 0;
    }
    var $closeBtnBlock = this.$el.siblings(".p-editor-toolbar").find(".p-tool-close");

    // $closeBtnBlock.css('right', aiZoneW + 'px');

    this.$aiZone.css("width", aiZoneW + 'px');
    this.$editorZone.css('right', aiZoneW + 'px');
    this.editorViewCtl && this.editorViewCtl.refreshSize();
    if (aiZoneW) {
      // this.editorLeftPanel.refreshCommentsList();
      this.hideCommentsNavigator();
    }
    ;
    return editorL > 0;
  },
  showOcr: function showOcr() {
    var ocrZoneW = this.$ocrZone.width();
    if (ocrZoneW <= 10) {
      this.toggleOCRNavigator();
    }
  },
  toggleOCRNavigator: function toggleOCRNavigator(closed) {
    var _this3 = this;
    if (!this.ocrPanel) {
      return (0, _aiLoader["default"])().then(function (MDAI) {
        _this3.ocrPanel = new MDAI.MDEditorOCRPanelView({
          removeOCRPanel: function removeOCRPanel() {
            return _this3.toggleOCRNavigator(true);
          }
        });
        _this3.addSubView(_this3.ocrPanel, _this3.$ocrZone[0]);
        return _this3.toggleOCRNavigator(closed);
      })["catch"](console.error);
    }
    var ocrZoneW = this.$ocrZone.width();
    var standNaviW = 500;
    var editorL = 0;
    if (ocrZoneW <= 10) {
      ocrZoneW = standNaviW;
      editorL = standNaviW;
      this.ocrPanel.setEditorViewCtl(this.editorViewCtl);
    } else {
      ocrZoneW = 0;
      editorL = 0;
    }
    if (closed) {
      ocrZoneW = 0;
      editorL = 0;
    }
    this.$ocrZone.css("width", ocrZoneW + 'px');
    this.$editorZone.css('right', ocrZoneW + 'px');
    this.editorViewCtl && this.editorViewCtl.refreshSize();
    if (ocrZoneW) {
      // this.editorLeftPanel.refreshCommentsList();
      this.hideCommentsNavigator();
    }
    ;
    return editorL > 0;
  },
  hideAINavigator: function hideAINavigator() {
    if (!this.$aiZone) {
      return;
    }
    ;
    var aiNaviZoneW = this.$aiZone.width();
    if (aiNaviZoneW > 0) {
      return this.toggleAINavigator();
    }
  },
  hideOCRNavigator: function hideOCRNavigator() {
    if (!this.$ocrZone) {
      return;
    }
    ;
    var ocrNaviZoneW = this.$ocrZone.width();
    if (ocrNaviZoneW > 0) {
      return this.toggleOCRNavigator();
    }
  },
  hideCommentsNavigator: function hideCommentsNavigator() {
    if (!this.$commentsNaviZone) {
      return;
    }
    ;
    var commentsNaviZoneW = this.$commentsNaviZone.width();
    if (commentsNaviZoneW > 0) {
      return this.toggleCommentsNavigator();
    }
  },
  refreshCommentsNavigator: function refreshCommentsNavigator() {
    var commentsNaviZoneW = this.$commentsNaviZone.width();
    if (commentsNaviZoneW == 0) {} else if (this.editorLeftPanel) {
      this.editorLeftPanel.refreshCommentsList();
    }
  },
  showPenListPanel: function showPenListPanel(opt) {
    if (opt.show) {
      this.penList.show();
      if (this.penZoneCtl && this.penZoneCtl.userMarkLgRects.length) {
        this.penZoneCtl.refreshData();
        this.penList.hideDisBtn();
      }
    } else {
      this.penList.hide();
    }
  }
});
var _default = exports["default"] = MDEditorContentPanelView;

},{"1184":1184,"1417":1417,"1454":1454,"1463":1463,"218":218,"22":22,"346":346,"424":424,"426":426,"427":427,"429":429,"431":431,"438":438,"440":440,"442":442,"445":445}],445:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDTabView = _interopRequireDefault(require(82));
var _TabBarPosition = _interopRequireDefault(require(84));
var _MDEditorCommentListTabPanelView = _interopRequireDefault(require(443));
var _MDEditorFileDirListTabPanelView = _interopRequireDefault(require(444));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 * 显示pdf时， 批注列表及目录索引
 * Created by jichao
 * 2018.9.27
 */
var MDEditorLeftPanleView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDEditorLeftPanleView, _MDNavigationPageView);
  function MDEditorLeftPanleView() {
    (0, _classCallCheck2["default"])(this, MDEditorLeftPanleView);
    return _callSuper(this, MDEditorLeftPanleView, arguments);
  }
  (0, _createClass2["default"])(MDEditorLeftPanleView, [{
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEditorLeftPanleView.prototype), "className", this).call(this);
      return "".concat(superCls, " editor-left-panel");
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var self = this;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEditorLeftPanleView.prototype), "initialize", this).call(this, props);
      this.commentlistView = new _MDEditorCommentListTabPanelView["default"]({
        updateParentTitle: function updateParentTitle(param) {
          if (param.isInEval) {
            self.tabView.setTabTitle(0, BabelStr.str(813)); //813: '审批意见列表',
          } else {
            self.tabView.setTabTitle(0, BabelStr.str(235)); ////批注列表
          }
        }
      });
      this.dirListView = new _MDEditorFileDirListTabPanelView["default"]({
        refreshTab: function refreshTab(show) {
          self.refreshTab(show);
        }
      });
      var tabArr = [{
        title: BabelStr.str(235),
        //批注列表
        tabPanelView: this.commentlistView,
        active: true
      }, {
        title: BabelStr.str(2400),
        //文件目录
        tabPanelView: this.dirListView
      }];
      this.tabView = new _MDTabView["default"]({
        className: ' blue-style-tab',
        tabBarDividerPosition: 2,
        fullMode: false,
        enableActivebar: false,
        // tabBarPosition: TabBarPosition.TOP,
        tabs: tabArr
      });
      this.addSubView(this.tabView);
      this.refreshTab(false);
      Dispatcher.on(MDEvents.afterChangeToNextFile, this._afterFileChanged, this);
    }
  }, {
    key: "setEditorViewCtl",
    value: function setEditorViewCtl(editorViewCtl) {
      this.editorViewCtl = editorViewCtl;
      this.commentlistView.setEditorViewCtl(editorViewCtl);
      this.dirListView.setEditorViewCtl(editorViewCtl);
      this.dirListView.refreshDirByFile();
      var fileInfo = this.editorViewCtl.getCurrentFileInfo();
      if (fileInfo.canReadComment() && !fileInfo.dispWithSVG()) {
        // app.currentUser.logined() && this.$("#salonButton").parent().show();
        this.tabView.toggleTabAt(0, true);
        this.tabView.activeTabAt(0);
      } else {
        this.tabView.toggleTabAt(0, false);
        this.tabView.activeTabAt(1);
      }
    }
  }, {
    key: "_afterFileChanged",
    value: function _afterFileChanged() {
      this.refreshCommentsList();
    }
  }, {
    key: "refreshCommentsList",
    value: function refreshCommentsList() {
      if (!this.editorViewCtl) {
        return;
      }
      this.commentlistView.refreshCommentsList();
      this.dirListView.refreshDirByFile();
      var fileInfo = this.editorViewCtl.getCurrentFileInfo();
      if (fileInfo.canReadComment() && !fileInfo.dispWithSVG()) {
        // app.currentUser.logined() && this.$("#salonButton").parent().show();
        this.tabView.toggleTabAt(0, true);
        this.tabView.activeTabAt(0);
      } else {
        this.tabView.toggleTabAt(0, false);
        this.tabView.activeTabAt(1);
      }
    }

    // 隐藏文件列表选项,同时隐藏 tab 区域
  }, {
    key: "refreshTab",
    value: function refreshTab(show) {
      if (!show) {
        this.tabView.setTabVisible(1, false);
        this.$el.addClass("only-comment");
      } else {
        this.showToggleBtn();
        this.tabView.setTabVisible(1, true);
        this.$el.removeClass("only-comment");
      }
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEditorLeftPanleView.prototype), "viewDidRendered", this).call(this);
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MDEditorLeftPanleView';
    }
  }]);
  return MDEditorLeftPanleView;
}(_MDNavigationPageView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"443":443,"444":444,"56":56,"82":82,"84":84}],444:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
var _pdf_outline_viewer = require(1142);
var _pdf_link_service = require(1141);
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /*
   批注列表
  create by jichao
  2018.9.27
*/ // import { PDFOutlineViewer } from '../pdfplugin/pdf_outline_viewer.js'
// import { PDFLinkService } from '../pdfplugin/pdf_link_service.js'
var MDEditorFileDirListTabPanelView = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(MDEditorFileDirListTabPanelView, _MDTabPanelView);
  function MDEditorFileDirListTabPanelView() {
    (0, _classCallCheck2["default"])(this, MDEditorFileDirListTabPanelView);
    return _callSuper(this, MDEditorFileDirListTabPanelView, arguments);
  }
  (0, _createClass2["default"])(MDEditorFileDirListTabPanelView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n    ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEditorFileDirListTabPanelView.prototype), "className", this).call(this);
      return "".concat(superCls, " p-filedir-panel");
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEditorFileDirListTabPanelView.prototype), "initialize", this).call(this, opt);
    }
  }, {
    key: "openPdfLink",
    value: function openPdfLink(obj) {
      var mainEditor = _MDPcMobileEditorCommonFun["default"].getMainEditor();
      if (mainEditor.removeCommentPanel) {
        mainEditor.removeCommentPanel();
      }
      this.editorViewCtl.editor.scrollToShowPdfLink(obj);
    }
  }, {
    key: "_loadPages",
    value: function _loadPages(imgPdfObjs, callback) {
      var pagesCount = imgPdfObjs.length;
      var pagesInfo = [];
      var i = 0;
      var pdf = null;
      function loadPages(index) {
        if (index >= imgPdfObjs.length) {
          // 已经获得所有 page info
          callback(pdf, pagesInfo);
          return;
        }
        var pdfObj = imgPdfObjs[index];
        pdfObj.getPdfPage(function (page) {
          var viewport = page.getViewport(1.0);
          var pageSizeInfo = {
            width: viewport.width,
            height: viewport.height,
            rotation: viewport.rotation
          };
          pagesInfo.push(pageSizeInfo);
          if (pdf == null) {
            pdf = pdfObj.getPdfDoc();
          }
          loadPages(++index);
        });
      }
      loadPages(0);
    }
  }, {
    key: "setEditorViewCtl",
    value: function setEditorViewCtl(editorViewCtl) {
      this.editorViewCtl = editorViewCtl;
    }
  }, {
    key: "refreshDirByFile",
    value: function refreshDirByFile() {
      if (!this.editorViewCtl) {
        return;
      }
      var self = this;
      var board = this.editorViewCtl.getCurrentBoard();
      var fileInfo = this.editorViewCtl.getCurrentFileInfo();
      if (!fileInfo) {
        return;
      }
      var eventBus = this.editorViewCtl.getCurrentBoard().eventBus;
      var pdfLinkService = this.editorViewCtl.getCurrentBoard().pdfLinkService;
      if (board.isOperateOnPDFFile() && !fileInfo.isCADFile() && eventBus && pdfLinkService) {
        if (!this.outlineView) {
          this.outlineView = new _pdf_outline_viewer.PDFOutlineViewer({
            container: this.el,
            eventBus: eventBus,
            linkService: pdfLinkService
          });
        }
        var curVersion = this.editorViewCtl.getVersionShowing();
        var imgPdfObjs = board.getImgPdfObjectsForVersion(curVersion);
        this._loadPages(imgPdfObjs, function (pdfDocument, pagesInfo) {
          pdfDocument.getOutline().then(function (outline) {
            if (outline && outline.length > 0) {
              self.refreshTab(true);
            } else {
              self.refreshTab(false);
            }
            self.outlineView && self.outlineView.render({
              outline: outline,
              pdfDocument: pdfDocument
            });
          });
          // self.pdfLinkService.setDocument(pdf);
        });
      } else {
        self.outlineView && self.outlineView.render({
          outline: []
        });
        if (self.refreshTab) {
          self.refreshTab(false);
        }
      }
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEditorFileDirListTabPanelView.prototype), "viewDidRendered", this).call(this);
    }
  }], [{
    key: "className",
    value: function className() {
      return "MDEditorFileDirListTabPanelView";
    }
  }]);
  return MDEditorFileDirListTabPanelView;
}(_MDTabPanelView2["default"]);

},{"1141":1141,"1142":1142,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"807":807,"81":81}],1142:[function(require,module,exports){
"use strict";

require(1475);
require(1429);
require(1437);
require(1478);
require(1439);
require(1419);
require(1477);
require(1503);
require(1500);
require(1502);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFOutlineViewer = void 0;
var _regenerator = _interopRequireDefault(require(1199));
require(1438);
require(1481);
require(1486);
require(1423);
require(1443);
require(1463);
require(1487);
require(1538);
require(1422);
require(1447);
require(1446);
var _typeof2 = _interopRequireDefault(require(1197));
var _slicedToArray2 = _interopRequireDefault(require(1192));
var _asyncToGenerator2 = _interopRequireDefault(require(1172));
var _toConsumableArray2 = _interopRequireDefault(require(1194));
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _assertThisInitialized2 = _interopRequireDefault(require(1171));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _base_tree_viewer = require(1137);
var _ui_utils = require(1146);
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /* Copyright 2012 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // import { PromiseCapability } from "pdfjs-lib";
/**
 * @typedef {Object} PDFOutlineViewerOptions
 * @property {HTMLDivElement} container - The viewer element.
 * @property {EventBus} eventBus - The application event bus.
 * @property {IPDFLinkService} linkService - The navigation/linking service.
 * @property {DownloadManager} downloadManager - The download manager.
 */
/**
 * @typedef {Object} PDFOutlineViewerRenderParameters
 * @property {Array|null} outline - An array of outline objects.
 * @property {PDFDocument} pdfDocument - A {PDFDocument} instance.
 */
var PDFOutlineViewer = exports.PDFOutlineViewer = /*#__PURE__*/function (_BaseTreeViewer) {
  (0, _inherits2["default"])(PDFOutlineViewer, _BaseTreeViewer);
  /**
   * @param {PDFOutlineViewerOptions} options
   */
  function PDFOutlineViewer(options) {
    var _this;
    (0, _classCallCheck2["default"])(this, PDFOutlineViewer);
    _this = _callSuper(this, PDFOutlineViewer, [options]);
    _this.linkService = options.linkService;
    _this.downloadManager = options.downloadManager;
    _this.eventBus._on("toggleoutlinetree", _this._toggleAllTreeItems.bind((0, _assertThisInitialized2["default"])(_this)));
    _this.eventBus._on("currentoutlineitem", _this._currentOutlineItem.bind((0, _assertThisInitialized2["default"])(_this)));
    _this.eventBus._on("pagechanging", function (evt) {
      _this._currentPageNumber = evt.pageNumber;
    });
    _this.eventBus._on("pagesloaded", function (evt) {
      _this._isPagesLoaded = !!evt.pagesCount;

      // If the capability is still pending, see the `_dispatchEvent`-method,
      // we know that the `currentOutlineItem`-button can be enabled here.
      if (_this._currentOutlineItemCapability && !_this._currentOutlineItemCapability.settled) {
        _this._currentOutlineItemCapability.resolve( /* enabled = */_this._isPagesLoaded);
      }
    });
    _this.eventBus._on("sidebarviewchanged", function (evt) {
      _this._sidebarView = evt.view;
    });
    return _this;
  }
  (0, _createClass2["default"])(PDFOutlineViewer, [{
    key: "reset",
    value: function reset() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(PDFOutlineViewer.prototype), "reset", this).call(this);
      this._outline = null;
      this._pageNumberToDestHashCapability = null;
      this._currentPageNumber = 1;
      this._isPagesLoaded = null;
      if (this._currentOutlineItemCapability && !this._currentOutlineItemCapability.settled) {
        this._currentOutlineItemCapability.resolve( /* enabled = */false);
      }
      this._currentOutlineItemCapability = null;
    }

    /**
     * @private
     */
  }, {
    key: "_dispatchEvent",
    value: function _dispatchEvent(outlineCount) {
      var _this$_pdfDocument;
      this._currentOutlineItemCapability = new window.pdfjsLib.PromiseCapability();
      if (outlineCount === 0 || (_this$_pdfDocument = this._pdfDocument) !== null && _this$_pdfDocument !== void 0 && _this$_pdfDocument.loadingParams.disableAutoFetch) {
        this._currentOutlineItemCapability.resolve( /* enabled = */false);
      } else if (this._isPagesLoaded !== null) {
        this._currentOutlineItemCapability.resolve( /* enabled = */this._isPagesLoaded);
      }
      this.eventBus.dispatch("outlineloaded", {
        source: this,
        outlineCount: outlineCount,
        currentOutlineItemPromise: this._currentOutlineItemCapability.promise
      });
    }

    /**
     * @private
     */
  }, {
    key: "_bindLink",
    value: function _bindLink(element, _ref) {
      var _this2 = this;
      var url = _ref.url,
        newWindow = _ref.newWindow,
        action = _ref.action,
        attachment = _ref.attachment,
        dest = _ref.dest,
        setOCGState = _ref.setOCGState;
      var linkService = this.linkService;
      if (url) {
        linkService.addLinkAttributes(element, url, newWindow);
        return;
      }
      if (action) {
        element.href = linkService.getAnchorUrl("");
        element.onclick = function () {
          linkService.executeNamedAction(action);
          return false;
        };
        return;
      }
      if (attachment) {
        element.href = linkService.getAnchorUrl("");
        element.onclick = function () {
          _this2.downloadManager.openOrDownloadData(element, attachment.content, attachment.filename);
          return false;
        };
        return;
      }
      if (setOCGState) {
        element.href = linkService.getAnchorUrl("");
        element.onclick = function () {
          linkService.executeSetOCGState(setOCGState);
          return false;
        };
        return;
      }
      element.href = linkService.getDestinationHash(dest);
      element.onclick = function (evt) {
        _this2._updateCurrentTreeItem(evt.target.parentNode);
        if (dest) {
          linkService.goToDestination(dest);
        }
        return false;
      };
    }

    /**
     * @private
     */
  }, {
    key: "_setStyles",
    value: function _setStyles(element, _ref2) {
      var bold = _ref2.bold,
        italic = _ref2.italic;
      if (bold) {
        element.style.fontWeight = "bold";
      }
      if (italic) {
        element.style.fontStyle = "italic";
      }
    }

    /**
     * @private
     */
  }, {
    key: "_addToggleButton",
    value: function _addToggleButton(div, _ref3) {
      var count = _ref3.count,
        items = _ref3.items;
      var hidden = false;
      if (count < 0) {
        var totalCount = items.length;
        if (totalCount > 0) {
          var queue = (0, _toConsumableArray2["default"])(items);
          while (queue.length > 0) {
            var _queue$shift = queue.shift(),
              nestedCount = _queue$shift.count,
              nestedItems = _queue$shift.items;
            if (nestedCount > 0 && nestedItems.length > 0) {
              totalCount += nestedItems.length;
              queue.push.apply(queue, (0, _toConsumableArray2["default"])(nestedItems));
            }
          }
        }
        if (Math.abs(count) === totalCount) {
          hidden = true;
        }
      }
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(PDFOutlineViewer.prototype), "_addToggleButton", this).call(this, div, hidden);
    }

    /**
     * @private
     */
  }, {
    key: "_toggleAllTreeItems",
    value: function _toggleAllTreeItems() {
      if (!this._outline) {
        return;
      }
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(PDFOutlineViewer.prototype), "_toggleAllTreeItems", this).call(this);
    }

    /**
     * @param {PDFOutlineViewerRenderParameters} params
     */
  }, {
    key: "render",
    value: function render(_ref4) {
      var outline = _ref4.outline,
        pdfDocument = _ref4.pdfDocument;
      if (this._outline) {
        this.reset();
      }
      this._outline = outline || null;
      this._pdfDocument = pdfDocument || null;
      if (!outline) {
        this._dispatchEvent( /* outlineCount = */0);
        return;
      }
      var fragment = document.createDocumentFragment();
      var queue = [{
        parent: fragment,
        items: outline
      }];
      var outlineCount = 0,
        hasAnyNesting = false;
      while (queue.length > 0) {
        var levelData = queue.shift();
        var _iterator = _createForOfIteratorHelper(levelData.items),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            var div = document.createElement("div");
            div.className = "treeItem";
            var element = document.createElement("a");
            this._bindLink(element, item);
            this._setStyles(element, item);
            element.textContent = this._normalizeTextContent(item.title);
            div.append(element);
            if (item.items.length > 0) {
              hasAnyNesting = true;
              this._addToggleButton(div, item);
              var itemsDiv = document.createElement("div");
              itemsDiv.className = "treeItems";
              div.append(itemsDiv);
              queue.push({
                parent: itemsDiv,
                items: item.items
              });
            }
            levelData.parent.append(div);
            outlineCount++;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      this._finishRendering(fragment, outlineCount, hasAnyNesting);
    }

    /**
     * Find/highlight the current outline item, corresponding to the active page.
     * @private
     */
  }, {
    key: "_currentOutlineItem",
    value: (function () {
      var _currentOutlineItem2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var pageNumberToDestHash, i, destHash, linkElement;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this._isPagesLoaded) {
                _context.next = 2;
                break;
              }
              throw new Error("_currentOutlineItem: All pages have not been loaded.");
            case 2:
              if (!(!this._outline || !this._pdfDocument)) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              _context.next = 6;
              return this._getPageNumberToDestHash(this._pdfDocument);
            case 6:
              pageNumberToDestHash = _context.sent;
              if (pageNumberToDestHash) {
                _context.next = 9;
                break;
              }
              return _context.abrupt("return");
            case 9:
              this._updateCurrentTreeItem( /* treeItem = */null);
              if (!(this._sidebarView !== _ui_utils.SidebarView.OUTLINE)) {
                _context.next = 12;
                break;
              }
              return _context.abrupt("return");
            case 12:
              i = this._currentPageNumber;
            case 13:
              if (!(i > 0)) {
                _context.next = 25;
                break;
              }
              destHash = pageNumberToDestHash.get(i);
              if (destHash) {
                _context.next = 17;
                break;
              }
              return _context.abrupt("continue", 22);
            case 17:
              linkElement = this.container.querySelector("a[href=\"".concat(destHash, "\"]"));
              if (linkElement) {
                _context.next = 20;
                break;
              }
              return _context.abrupt("continue", 22);
            case 20:
              this._scrollToCurrentTreeItem(linkElement.parentNode);
              return _context.abrupt("break", 25);
            case 22:
              i--;
              _context.next = 13;
              break;
            case 25:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function _currentOutlineItem() {
        return _currentOutlineItem2.apply(this, arguments);
      }
      return _currentOutlineItem;
    }()
    /**
     * To (significantly) simplify the overall implementation, we will only
     * consider *one* destination per page when finding/highlighting the current
     * outline item (similar to e.g. Adobe Reader); more specifically, we choose
     * the *first* outline item at the *lowest* level of the outline tree.
     * @private
     */
    )
  }, {
    key: "_getPageNumberToDestHash",
    value: (function () {
      var _getPageNumberToDestHash2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(pdfDocument) {
        var pageNumberToDestHash, pageNumberNesting, queue, levelData, currentNesting, _iterator2, _step2, _step2$value, dest, items, explicitDest, pageNumber, _explicitDest, _explicitDest2, destRef, destHash;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!this._pageNumberToDestHashCapability) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", this._pageNumberToDestHashCapability.promise);
            case 2:
              this._pageNumberToDestHashCapability = new window.pdfjsLib.PromiseCapability();
              pageNumberToDestHash = new Map(), pageNumberNesting = new Map();
              queue = [{
                nesting: 0,
                items: this._outline
              }];
            case 5:
              if (!(queue.length > 0)) {
                _context2.next = 56;
                break;
              }
              levelData = queue.shift(), currentNesting = levelData.nesting;
              _iterator2 = _createForOfIteratorHelper(levelData.items);
              _context2.prev = 8;
              _iterator2.s();
            case 10:
              if ((_step2 = _iterator2.n()).done) {
                _context2.next = 46;
                break;
              }
              _step2$value = _step2.value, dest = _step2$value.dest, items = _step2$value.items;
              explicitDest = void 0, pageNumber = void 0;
              if (!(typeof dest === "string")) {
                _context2.next = 21;
                break;
              }
              _context2.next = 16;
              return pdfDocument.getDestination(dest);
            case 16:
              explicitDest = _context2.sent;
              if (!(pdfDocument !== this._pdfDocument)) {
                _context2.next = 19;
                break;
              }
              return _context2.abrupt("return", null);
            case 19:
              _context2.next = 22;
              break;
            case 21:
              explicitDest = dest;
            case 22:
              if (!Array.isArray(explicitDest)) {
                _context2.next = 43;
                break;
              }
              _explicitDest = explicitDest, _explicitDest2 = (0, _slicedToArray2["default"])(_explicitDest, 1), destRef = _explicitDest2[0];
              if (!((0, _typeof2["default"])(destRef) === "object" && destRef !== null)) {
                _context2.next = 41;
                break;
              }
              pageNumber = this.linkService._cachedPageNumber(destRef);
              if (pageNumber) {
                _context2.next = 39;
                break;
              }
              _context2.prev = 27;
              _context2.next = 30;
              return pdfDocument.getPageIndex(destRef);
            case 30:
              _context2.t0 = _context2.sent;
              pageNumber = _context2.t0 + 1;
              if (!(pdfDocument !== this._pdfDocument)) {
                _context2.next = 34;
                break;
              }
              return _context2.abrupt("return", null);
            case 34:
              this.linkService.cachePageRef(pageNumber, destRef);
              _context2.next = 39;
              break;
            case 37:
              _context2.prev = 37;
              _context2.t1 = _context2["catch"](27);
            case 39:
              _context2.next = 42;
              break;
            case 41:
              if (Number.isInteger(destRef)) {
                pageNumber = destRef + 1;
              }
            case 42:
              if (Number.isInteger(pageNumber) && (!pageNumberToDestHash.has(pageNumber) || currentNesting > pageNumberNesting.get(pageNumber))) {
                destHash = this.linkService.getDestinationHash(dest);
                pageNumberToDestHash.set(pageNumber, destHash);
                pageNumberNesting.set(pageNumber, currentNesting);
              }
            case 43:
              if (items.length > 0) {
                queue.push({
                  nesting: currentNesting + 1,
                  items: items
                });
              }
            case 44:
              _context2.next = 10;
              break;
            case 46:
              _context2.next = 51;
              break;
            case 48:
              _context2.prev = 48;
              _context2.t2 = _context2["catch"](8);
              _iterator2.e(_context2.t2);
            case 51:
              _context2.prev = 51;
              _iterator2.f();
              return _context2.finish(51);
            case 54:
              _context2.next = 5;
              break;
            case 56:
              this._pageNumberToDestHashCapability.resolve(pageNumberToDestHash.size > 0 ? pageNumberToDestHash : null);
              return _context2.abrupt("return", this._pageNumberToDestHashCapability.promise);
            case 58:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[8, 48, 51, 54], [27, 37]]);
      }));
      function _getPageNumberToDestHash(_x) {
        return _getPageNumberToDestHash2.apply(this, arguments);
      }
      return _getPageNumberToDestHash;
    }())
  }]);
  return PDFOutlineViewer;
}(_base_tree_viewer.BaseTreeViewer);

},{"1137":1137,"1146":1146,"1171":1171,"1172":1172,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1192":1192,"1194":1194,"1197":1197,"1199":1199,"1419":1419,"1422":1422,"1423":1423,"1429":1429,"1437":1437,"1438":1438,"1439":1439,"1443":1443,"1446":1446,"1447":1447,"1454":1454,"1463":1463,"1475":1475,"1477":1477,"1478":1478,"1481":1481,"1486":1486,"1487":1487,"1500":1500,"1502":1502,"1503":1503,"1538":1538}],1486:[function(require,module,exports){
'use strict';
var $ = require(1270);
var createHTML = require(1241);
var forcedStringHTMLMethod = require(1368);

// `String.prototype.italics` method
// https://tc39.es/ecma262/#sec-string.prototype.italics
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('italics') }, {
  italics: function italics() {
    return createHTML(this, 'i', '', '');
  }
});

},{"1241":1241,"1270":1270,"1368":1368}],1481:[function(require,module,exports){
'use strict';
var $ = require(1270);
var createHTML = require(1241);
var forcedStringHTMLMethod = require(1368);

// `String.prototype.bold` method
// https://tc39.es/ecma262/#sec-string.prototype.bold
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('bold') }, {
  bold: function bold() {
    return createHTML(this, 'b', '', '');
  }
});

},{"1241":1241,"1270":1270,"1368":1368}],1137:[function(require,module,exports){
"use strict";

require(1429);
require(1437);
require(1463);
require(1478);
require(1439);
require(1419);
require(1487);
require(1477);
require(1503);
require(1500);
require(1502);
require(1423);
require(1538);
require(1422);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseTreeViewer = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _ui_utils = require(1146);
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; } /* Copyright 2020 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TREEITEM_OFFSET_TOP = -100; // px
var TREEITEM_SELECTED_CLASS = "selected";
var BaseTreeViewer = exports.BaseTreeViewer = /*#__PURE__*/function () {
  function BaseTreeViewer(options) {
    (0, _classCallCheck2["default"])(this, BaseTreeViewer);
    if (this.constructor === BaseTreeViewer) {
      throw new Error("Cannot initialize BaseTreeViewer.");
    }
    this.container = options.container;
    this.eventBus = options.eventBus;
    this.reset();
  }
  (0, _createClass2["default"])(BaseTreeViewer, [{
    key: "reset",
    value: function reset() {
      this._pdfDocument = null;
      this._lastToggleIsShow = true;
      this._currentTreeItem = null;

      // Remove the tree from the DOM.
      this.container.textContent = "";
      // Ensure that the left (right in RTL locales) margin is always reset,
      // to prevent incorrect tree alignment if a new document is opened.
      this.container.classList.remove("treeWithDeepNesting");
    }

    /**
     * @private
     */
  }, {
    key: "_dispatchEvent",
    value: function _dispatchEvent(count) {
      throw new Error("Not implemented: _dispatchEvent");
    }

    /**
     * @private
     */
  }, {
    key: "_bindLink",
    value: function _bindLink(element, params) {
      throw new Error("Not implemented: _bindLink");
    }

    /**
     * @private
     */
  }, {
    key: "_normalizeTextContent",
    value: function _normalizeTextContent(str) {
      // Chars in range [0x01-0x1F] will be replaced with a white space
      // and 0x00 by "".
      return (0, _ui_utils.removeNullCharacters)(str, /* replaceInvisible */true) || /* en dash = */"\u2013";
    }

    /**
     * Prepend a button before a tree item which allows the user to collapse or
     * expand all tree items at that level; see `_toggleTreeItem`.
     * @private
     */
  }, {
    key: "_addToggleButton",
    value: function _addToggleButton(div) {
      var _this = this;
      var hidden = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var toggler = document.createElement("div");
      toggler.className = "treeItemToggler";
      if (hidden) {
        toggler.classList.add("treeItemsHidden");
      }
      toggler.onclick = function (evt) {
        evt.stopPropagation();
        toggler.classList.toggle("treeItemsHidden");
        if (evt.shiftKey) {
          var shouldShowAll = !toggler.classList.contains("treeItemsHidden");
          _this._toggleTreeItem(div, shouldShowAll);
        }
      };
      div.prepend(toggler);
    }

    /**
     * Collapse or expand the subtree of a tree item.
     *
     * @param {Element} root - the root of the item (sub)tree.
     * @param {boolean} show - whether to show the item (sub)tree. If false,
     *   the item subtree rooted at `root` will be collapsed.
     * @private
     */
  }, {
    key: "_toggleTreeItem",
    value: function _toggleTreeItem(root) {
      var show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this._lastToggleIsShow = show;
      var _iterator = _createForOfIteratorHelper(root.querySelectorAll(".treeItemToggler")),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var toggler = _step.value;
          toggler.classList.toggle("treeItemsHidden", !show);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    /**
     * Collapse or expand all subtrees of the `container`.
     * @private
     */
  }, {
    key: "_toggleAllTreeItems",
    value: function _toggleAllTreeItems() {
      this._toggleTreeItem(this.container, !this._lastToggleIsShow);
    }

    /**
     * @private
     */
  }, {
    key: "_finishRendering",
    value: function _finishRendering(fragment, count) {
      var hasAnyNesting = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (hasAnyNesting) {
        this.container.classList.add("treeWithDeepNesting");
        this._lastToggleIsShow = !fragment.querySelector(".treeItemsHidden");
      }
      this.container.append(fragment);
      this._dispatchEvent(count);
    }
  }, {
    key: "render",
    value: function render(params) {
      throw new Error("Not implemented: render");
    }

    /**
     * @private
     */
  }, {
    key: "_updateCurrentTreeItem",
    value: function _updateCurrentTreeItem() {
      var treeItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (this._currentTreeItem) {
        // Ensure that the current treeItem-selection is always removed.
        this._currentTreeItem.classList.remove(TREEITEM_SELECTED_CLASS);
        this._currentTreeItem = null;
      }
      if (treeItem) {
        treeItem.classList.add(TREEITEM_SELECTED_CLASS);
        this._currentTreeItem = treeItem;
      }
    }

    /**
     * @private
     */
  }, {
    key: "_scrollToCurrentTreeItem",
    value: function _scrollToCurrentTreeItem(treeItem) {
      if (!treeItem) {
        return;
      }
      // Ensure that the treeItem is *fully* expanded, such that it will first of
      // all be visible and secondly that scrolling it into view works correctly.
      var currentNode = treeItem.parentNode;
      while (currentNode && currentNode !== this.container) {
        if (currentNode.classList.contains("treeItem")) {
          var toggler = currentNode.firstElementChild;
          toggler === null || toggler === void 0 || toggler.classList.remove("treeItemsHidden");
        }
        currentNode = currentNode.parentNode;
      }
      this._updateCurrentTreeItem(treeItem);
      this.container.scrollTo(treeItem.offsetLeft, treeItem.offsetTop + TREEITEM_OFFSET_TOP);
    }
  }]);
  return BaseTreeViewer;
}();

},{"1146":1146,"1175":1175,"1179":1179,"1184":1184,"1419":1419,"1422":1422,"1423":1423,"1429":1429,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1477":1477,"1478":1478,"1487":1487,"1500":1500,"1502":1502,"1503":1503,"1538":1538}],443:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1432);
require(1541);
require(1438);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
var _MDCommentInfoView = _interopRequireDefault(require(318));
var _MMBasicData = _interopRequireDefault(require(811));
var _MMCommentDataController = _interopRequireDefault(require(1097));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
var _MDCommentsFilterList = _interopRequireDefault(require(409));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /*
	 批注列表
	create by jichao
	2018.9.27
*/
var g_commentFilters = [BabelStr.str(116),
//'全部批注',
BabelStr.str(117),
//'未读批注',
BabelStr.str(114),
//'当前文档批注',
BabelStr.str(115) //'当前文档未读批注'
];
var MDEditorCommentListTabPanelView = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(MDEditorCommentListTabPanelView, _MDTabPanelView);
  function MDEditorCommentListTabPanelView() {
    (0, _classCallCheck2["default"])(this, MDEditorCommentListTabPanelView);
    return _callSuper(this, MDEditorCommentListTabPanelView, arguments);
  }
  (0, _createClass2["default"])(MDEditorCommentListTabPanelView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n      <div class=\"p-comments-top blackBoldText0\">\n        <div class=\"p-comments-total\"></div>\n        <div class=\"p-comments-filter blackText1\">\n          <span> <%=BabelStr.str(114)%></span>\n          <i class=\"button-icon selectBoxSmall\"></i>\n        </div>\n        <div class=\"p-current-version\">".concat(BabelStr.str(24100), "</div>\n\n      </div>\n      <ul class=\"p-comments-body whiteText0\"></ul>\n\t\t");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEditorCommentListTabPanelView.prototype), "initProps", this).call(this, this);
      return _.extend(superP, {
        editorViewCtl: null,
        curFilter: 2
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEditorCommentListTabPanelView.prototype), "className", this).call(this);
      return "".concat(superCls, " p-comments-naviRoot");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEditorCommentListTabPanelView.prototype), "events", this).call(this, this);
      return _.extend(superE, {
        "mousedown .p-comments-filter": this._filterClick,
        "mousedown .p-current-version": this._currentClick,
        "mouseenter": this._mouseEnter,
        "mouseleave": this._mouseLeave
      });
    }
  }, {
    key: "render",
    value: function render(data) {
      // var param = {
      //   'num': '<b id="commentsNum" class="top">0</b>'
      // }
      // var commentCountCap = BabelStr.str(113, param);
      // var data = {
      //   commentCountCap: commentCountCap
      // }
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEditorCommentListTabPanelView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "_mouseEnter",
    value: function _mouseEnter() {
      _MDPcMobileEditorCommonFun["default"].getMainEditor().enableMouseWheel(false);
    }
  }, {
    key: "_mouseLeave",
    value: function _mouseLeave() {
      _MDPcMobileEditorCommonFun["default"].getMainEditor().checkToEnablePrivateMouseWheel();
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      var self = this;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEditorCommentListTabPanelView.prototype), "initialize", this).call(this, opt);
      this.$listBody = this.$('.p-comments-body');
      var title = g_commentFilters[this.curFilter];
      this.$('.p-comments-filter>span').text(title);

      // 暂时去除多文件筛选
      this.$('.p-comments-filter').remove();
      this.$('.p-current-version').hide();
      Dispatcher.on(MDEvents.NEW_MESSAGE, this.refreshCommentsList, this);
      Dispatcher.on(MDEvents.Comment_changed, this.refreshCommentsList, this);
      Dispatcher.on(MDEvents.COMMENT_REMOVE, this.refreshCommentsList, this);
      Dispatcher.on(MDEvents.DisplayOldVersion, this.dispCurVersionBtn, this);
      Dispatcher.on(MDEvents.DisplayCurVersion, this.hideCurVersionBtn, this);
    }
  }, {
    key: "setEditorViewCtl",
    value: function setEditorViewCtl(editorViewCtl) {
      this.editorViewCtl = editorViewCtl;
      this.refreshCommentsList();
    }
  }, {
    key: "_filterClick",
    value: function _filterClick(e) {
      var that = this;
      if (this.filterList) {
        this.filterList.remove();
        this.filterList = null;
      } else {
        this.filterList = new _MDCommentsFilterList["default"]({
          callback: function callback(index, text) {
            if (that.curFilter != index) {
              that.curFilter = index;
              that.refreshCommentsList();
              var $filterName = that.$('.p-comments-filter').find('span');
              $filterName.text(text);
            }
            ;
            that.filterList.remove();
            that.filterList = null;
          },
          items: g_commentFilters
        });
        // this.filterList.renderTo(this.$("#zoomBtn").parent());
        var z_startIndex = _MMBasicData["default"].getO2OStartLayerZ_index();
        this.filterList.$el.css("z-index", z_startIndex);
        this.filterList.show({
          triggerView: e.currentTarget,
          center: true,
          width: 156,
          onClose: function onClose() {
            that.filterList = null;
          }
        });
      }
      return false;
    }
  }, {
    key: "_currentClick",
    value: function _currentClick(e) {
      var _this = this;
      console.log('currentClick');
      var mainEditor = _MDPcMobileEditorCommonFun["default"].getMainEditor();
      console.log('currentClick');
      if (mainEditor.removeCommentPanel) mainEditor.removeCommentPanel(); // 隐藏评论面板
      mainEditor.changeVersion2currentVersion(function () {
        Dispatcher.trigger(MDEvents.VersionChangedByComment, mainEditor.getVersionShowing());
        _this.hideCurVersionBtn(); // 隐藏当前版本按钮
        setBabelTimeout(function () {
          Dispatcher.trigger(MDEvents.FileChanged);
        }, 100);
      });
    }
  }, {
    key: "_fetchCommentsFileByFile",
    value: function _fetchCommentsFileByFile(arrfileInfos, data, callback, index) {
      if (index == undefined) {
        index = 0;
      }
      ;
      if (index >= arrfileInfos.length) {
        callback(data);
        return;
      }
      ;
      var self = this;
      var fileInfo = arrfileInfos[index];
      var board = fileInfo.getBoard();
      var ver = fileInfo.getCurVersion();
      if (board) {
        ver = this.editorViewCtl.getVersionShowing();
      }
      ;
      ver = -1;
      fileInfo.getFileVersionList(true, function (verInfos) {
        var verList = fileInfo.getFileVersionList();
        console.log('----------->  verList:' + verList.size());
        if (verList.size() > 0) {
          _MMCommentDataController["default"].getFileCommentInfosForVersion(fileInfo.getFileId(), ver, function (comments) {
            var file = self.editorViewCtl.getCurrentFileInfo();
            file.set("fileCommentCount", comments.length);
            if (comments.length > 0) {
              for (var _i = 0; _i < comments.length; _i++) {
                var element = comments[_i];
                var v = element.version;
                var found = false;
                for (var _k = 0; _k < verList.size(); _k++) {
                  var verInfo = verList.at(_k);
                  if (verInfo.getVersion() == v) {
                    found = true;
                    break;
                  }
                }
                if (!found) {
                  comments.splice(_i, 1);
                }
              }
              var dispComments = [];
              if (self.curFilter % 2 == 0) {
                // 全部批注
                dispComments = comments;
              } else {
                for (var i = 0; i < comments.length; i++) {
                  if (comments[i].unreadedCount) {
                    dispComments.push(comments[i]);
                  }
                }
                ;
              }
              if (dispComments.length > 0) {
                var fileName = fileInfo.getFileName();
                data.push(fileName);
              }
              for (var k = 0; k < dispComments.length; k++) {
                var comment = dispComments[k];
                if (self.isInEval && comment.visibleScope < 8) {
                  continue;
                }
                data.push({
                  fileInfo: fileInfo,
                  comment: comment
                });
              }
              ;
            }
            ;
            self._fetchCommentsFileByFile(arrfileInfos, data, callback, index + 1);
          }, function () {
            self._fetchCommentsFileByFile(arrfileInfos, data, callback, index + 1);
          });
        }
      });
    }
  }, {
    key: "_refreshCommentsFileByFile",
    value: function _refreshCommentsFileByFile(arrfileInfos) {
      var commentsNum = 0;
      var data = [];
      var self = this;
      this._fetchCommentsFileByFile(arrfileInfos, data, function (data) {
        var top = self.$listBody[0].scrollTop;
        self.$listBody.empty();
        var unreadedCount = 0;
        for (var i = 0; i < data.length; i++) {
          var d = data[i];
          if (d instanceof Object) {
            if (!d.fileInfo.canUploadVersion() && d.fileInfo.getCurVersion() != d.comment.version) {
              continue;
            }
            commentsNum++;
            self._createItemForComment(d.fileInfo, d.comment);
            if (d.comment.unreadedCount > 0) {
              unreadedCount++;
            }
          } else {
            var fileName = d;
            self._createItemForFileName(fileName);
          }
          var board = self.editorViewCtl.getCurrentBoard();
          var fileInfo = board.getFileInfo();
          fileInfo.set('unreadedCommentCount', unreadedCount);
        }
        ;
        self.$el.find('#commentsNum').text(commentsNum);
        self.$listBody[0].scrollTop = top;
      }, 0);
    }
  }, {
    key: "refreshCommentsList",
    value: function refreshCommentsList() {
      var _this2 = this;
      if (this.refreshTimer) {
        clearTimeout(this.refreshTimer);
      }
      this.refreshTimer = setTimeout(function () {
        var commentsNaviZoneW = _this2.$el.width();
        // if (commentsNaviZoneW == 0) {
        //   return;
        // };
        var fileInfos = [];
        var editorViewCtl = _this2.editorViewCtl;
        if (!editorViewCtl) {
          return;
        }
        ;
        if (g_commentFilters.length <= 2 || _this2.curFilter > 1) {
          if (editorViewCtl) {
            fileInfos.push(editorViewCtl.getCurrentFileInfo());
          }
          ;
        } else {
          fileInfos = editorViewCtl.getAllFileInfo();
        }
        if (app.ep.canShowEvalModel()) {
          _this2._refreshTitleByEvaluation(function () {
            _this2._refreshCommentsFileByFile(fileInfos);
          });
        } else {
          _this2._refreshCommentsFileByFile(fileInfos);
        }
        _this2.refreshTimer = null;
      }, 2000);
    }
  }, {
    key: "_refreshTitleByEvaluation",
    value: function _refreshTitleByEvaluation(callback) {
      var _this3 = this;
      var editorViewCtl = this.editorViewCtl;
      var fileInfo = editorViewCtl.getCurrentFileInfo();
      var version = editorViewCtl.getVersionShowing();
      fileInfo.getEvalFlowInfo(version, function (evalFlow) {
        _this3.evalFlow = evalFlow;
        var isInEval = false;
        if (evalFlow) {
          isInEval = true;
        }
        if (_this3.$('#commentsNum').length == 0 || _this3.isInEval != isInEval) {
          var param = {
            'num': '<b id="commentsNum" class="top">0</b>'
          };
          if (evalFlow) {
            var commentCountCap = BabelStr.str(814, param);
            _this3.$('.p-comments-total').html(commentCountCap);
          } else {
            var commentCountCap = BabelStr.str(113, param);
            _this3.$('.p-comments-total').html(commentCountCap);
          }
        }
        _this3.isInEval = isInEval;
        _this3.updateParentTitle && _this3.updateParentTitle({
          isInEval: _this3.isInEval
        });
        callback && callback();
      });
    }
  }, {
    key: "_createItemForFileName",
    value: function _createItemForFileName(name) {
      // var $div = '<li class="fileName"> ' + name + '</li>';
      // this.$listBody.append($div);
    }
  }, {
    key: "_createItemForComment",
    value: function _createItemForComment(fileInfo, comment) {
      if (!fileInfo.canUploadVersion() && fileInfo.getCurVersion() != comment.version) {
        return;
      }
      var editorViewCtl = this.editorViewCtl;
      var newShownCommetnInfoView = new _MDCommentInfoView["default"]({
        commentInfo: comment,
        fileInfo: fileInfo,
        editorViewCtl: editorViewCtl,
        evalFlow: this.evalFlow
      });
      newShownCommetnInfoView.on(MDEvents.CLICK, function (infoView) {
        _.delay(function () {
          if (this.curFilter == 1) {
            infoView.remove();
          }
          ;
        }.bind(this), 100);
      }.bind(this));
      this.$listBody.append(newShownCommetnInfoView.el);
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEditorCommentListTabPanelView.prototype), "viewDidRendered", this).call(this);
    }
  }, {
    key: "dispCurVersionBtn",
    value: function dispCurVersionBtn() {
      this.$('.p-current-version').show();
    }
  }, {
    key: "hideCurVersionBtn",
    value: function hideCurVersionBtn() {
      this.$('.p-current-version').hide();
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MDEditorCommentListTabPanelView';
    }
  }]);
  return MDEditorCommentListTabPanelView;
}(_MDTabPanelView2["default"]);

},{"1097":1097,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1417":1417,"1432":1432,"1438":1438,"1454":1454,"1463":1463,"1475":1475,"1541":1541,"318":318,"409":409,"807":807,"81":81,"811":811}],409:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDPopupView = _interopRequireDefault(require(64));
/**
 * 	Menu for zoom choices
 *  Create by jiang
 *  2015.12.26
 */

var MDCommentsFilterList = _MDPopupView["default"].extend({
  contentTmpl: '<ul class="m-menu"></ul>',
  initProps: function initProps() {
    var superP = _MDPopupView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      zoomSelected: -1,
      $zoomList: null,
      scaleList: []
    });
  },
  events: function events() {
    var superEvents = _MDPopupView["default"].prototype.events.call(this);
    return _.extend({}, superEvents, {
      'click li': this._menuItemClickHandler
    });
  },
  initialize: function initialize(opt) {
    _MDPopupView["default"].prototype.initialize.call(this, opt);
    this.initZoomList(opt.items);
    this.selectedCallback = opt.callback;
  },
  initZoomList: function initZoomList(items) {
    var htmlStr = '';
    for (var i = 0; i < items.length; i++) {
      htmlStr += '<li>' + items[i] + '</li>';
    }
    ;
    this.$html = $(htmlStr);
    this.$(".m-menu").append(this.$html);
    this.$zoomList = this.$html;
  },
  _menuItemClickHandler: function _menuItemClickHandler($e) {
    var index = $($e.target).index();
    var text = $($e.target).text();
    if (this.selectedCallback) {
      this.selectedCallback(index, text);
    }
    ;
  }
});
var _default = exports["default"] = MDCommentsFilterList;

},{"1184":1184,"1454":1454,"64":64}],318:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1466);
require(1463);
require(1478);
require(1461);
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDAlertView = _interopRequireDefault(require(32));
var _ObjVisibleScope = _interopRequireDefault(require(1085));
var _MMViewBase = _interopRequireDefault(require(22));
var _MDEvents = _interopRequireDefault(require(325));
var _CommentStatus = _interopRequireDefault(require(1036));
var _app = _interopRequireDefault(require(17));
var _MDAudioPlayer = _interopRequireDefault(require(313));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MMObjOperationStrategy = _interopRequireDefault(require(872));
var _MMOperationType = _interopRequireDefault(require(882));
/**
 *  批注列表中的一项.
 *  WebContent/javascript/moladisk/common/MDCommentInfoView.js
 *  Create by jiang
 *  2014.12.30
 */

var MDCommentInfoView = _MMViewBase["default"].extend({
  el: '<li></li>',
  tmpl: '<div class="title-zone">' + '<div class="eval-title"></div>' + '<div class="delete-btn"><%=delCap%></div>' + '</div>' + '<div class="comment-info">' + '<img class="userAvatar f-round"/>' + '<div class="readStatus"></div>' + '<div class="commentInfo">' + '<div class="f-clb">' + '<div class="username" ></div>' + '<div class="verInfo" data-tooltip="' + BabelStr.str(7062) + '" data-tooltip-dir="right">' + BabelStr.str(7063) + '</div>' + '<div class="time"></div>' + '<div class="finished">' + BabelStr.str(131) + '</div>' + '</div>' + '<div class="firstText"></div>' + '</div>' + '<div class="statusDott" class="f-round"></div>' + '<div class="visibleScope"></div>' + '</div>' + '',
  render: function render() {
    var data = {
      'delCap': _MDLocalString["default"].getLocalString(32) // 删除
    };
    _MMViewBase["default"].prototype.render.call(this, data);
  },
  className: function className() {
    var superCls = _MMViewBase["default"].prototype.className.call(this);
    return superCls + ' comment-item';
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      comment: null
    });
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click': this.clickHandler,
      'click .delete-btn': this.delHandler
    });
  },
  initialize: function initialize(options) {
    var self = this;
    _MMViewBase["default"].prototype.initialize.call(this, options);
    this.$username = this.$('.username');
    this.$answerCount = this.$('.answerCount');
    this.$firstText = this.$('.firstText');
    this.$userAvatar = this.$('.userAvatar');
    this.$statusDott = this.$('.statusDott');
    this.$time = this.$('.time');
    this.update();
    var editorViewCtl = this.editorViewCtl;
    var curFile = editorViewCtl.getCurrentFileInfo();
    var commentCreatorId = this.commentInfo.creator;
    var strategy = _MMObjOperationStrategy["default"].getOperationTypeForComment(this.commentInfo, commentCreatorId, this.fileInfo);
    if (curFile != this.fileInfo || strategy != _MMOperationType["default"].Operation_editable || _app["default"].pathRouter.inTrash()) {
      this.$('.delete-btn').remove();
    }
    if (!this.commentInfo.completed) {
      this.$('.finished').hide();
    }
  },
  clickHandler: function clickHandler($e) {
    this.editorViewCtl.refreshCurrentMainEditor();
    Dispatcher.trigger(_MDEvents["default"].SHOW_COMMENTS);
    _MDPcMobileEditorCommonFun["default"].UIActions.openComment(this.fileInfo, this.commentInfo.id);
    this.trigger(_MDEvents["default"].CLICK, this);
    this.$('.readStatus').css('opacity', 0);
  },
  deleteComment: function deleteComment() {
    var editorViewCtl = this.editorViewCtl;
    var board = editorViewCtl && editorViewCtl.getCurrentBoard();
    if (!board) {
      return;
    }
    ;
    if (board.getFileInfo() != this.fileInfo) {
      return;
    }
    ;
    var self = this;
    board.deleteCommentById(this.commentInfo.id, function () {
      self.$el.remove();
      Dispatcher.trigger(_MDEvents["default"].COMMENT_REMOVE, board);
    }, function () {
      _MDSnackbarView["default"].show(_MDLocalString["default"].getLocalString(309));
    });
  },
  delHandler: function delHandler($e) {
    var commentSlidePanel = viewManager.get("commentSlidePanel");
    if (commentSlidePanel) {
      commentSlidePanel.remove();
    }
    var self = this;
    var alertOpt = {
      okFun: function okFun() {
        self.deleteComment();
      },
      message: _MDLocalString["default"].getLocalString(312) // 确定删除该批注点？
    };
    _MDAlertView["default"].showStandardSelection(alertOpt);
    console.log('------------ del comment');
    return false;
  },
  update: function update() {
    var $readStatus = this.$('.readStatus');
    var opacity = '1';
    var data = this.fetchData();
    if (!data) return;
    this.data = data;
    this.$username.html(this.commentInfo.messageSenderName);
    this.$username.attr("title", this.commentInfo.messageSenderName.length > 10 ? this.commentInfo.messageSenderName : '');
    this.$answerCount.html(data.answerCount + ' reply');
    var commentV = this.commentInfo.version;
    var dispV = this.fileInfo.getCurVersion(); //this.editorViewCtl.getVersionShowing();
    if (commentV != dispV) {
      this.$('.verInfo').show();
    } else {
      this.$('.verInfo').hide();
    }
    if (data.time > 0) {
      this.$time.html(new Date(parseInt(data.time.toString())).toRelativeTimeDOMObj());
    }
    ;
    this.$firstText.html(data.firstText);
    switch (data.readStatus) {
      case _CommentStatus["default"].Comment_unread:
        break;
      case _CommentStatus["default"].Comment_read:
        opacity = '0';
        break;
      case _CommentStatus["default"].Comment_newReply:
        break;
    }
    $readStatus.css('opacity', opacity);
    _app["default"].setAvatarImage(this.$userAvatar, this.commentInfo.messageSender, 80, true);
    if (_app["default"].isEpVersion() && !_app["default"].currentUser.isEnterpriseGuest() && _MDPcMobileEditorCommonFun["default"].currentFileBelongsToCurUserEnterprise()) {
      if (data.visibleScope == _ObjVisibleScope["default"].publicObject) {
        this.$el.addClass('pub-comment');
      } else if (data.visibleScope == _ObjVisibleScope["default"].protectedObject) {
        this.$el.addClass('ent-comment');
      } else if (data.visibleScope == _ObjVisibleScope["default"].privateObject) {
        this.$el.addClass('pri-comment');
      }
    }
    if (this.evalFlow) {
      this.$('.eval-title').show();
      var status = data.completed;
      var str = BabelStr.str(812);
      if (status == 2) {
        str = BabelStr.str(807);
        this.$(".eval-title").addClass("eval-acc");
      } else if (status == 3) {
        str = BabelStr.str(808);
        this.$(".eval-title").addClass("eval-acc");
      } else {
        this.$(".eval-title").addClass("ev-no-color");
      }
      this.$('.eval-title').html(str);
    } else {
      this.$('.eval-title').hide();
    }
  },
  fetchData: function fetchData() {
    //todo: read data from commentObj
    //fetch chatlogInfo
    var mainEditor = this.editorViewCtl;
    if (!mainEditor) return;

    // if (this.commentInfo.getObjType() == ObjType.Obj_niceTag) {
    //   return this._fetchNiceTagData();
    // } else {
    return this._fetchCommentData();
    // }
  },
  _fetchNiceTagData: function _fetchNiceTagData() {
    var messageDisplay = this.commentInfo.getLabel();
    var uid = this.commentInfo.getCreator();
    if (uid !== -1) {
      uid = uid.toDecString();
    }
    var out = {
      username: BabelStr.str(7059),
      firstText: messageDisplay,
      answerCount: 0,
      readStatus: _CommentStatus["default"].Comment_read,
      completed: true,
      userId: uid,
      time: 0
    };
    return out;
  },
  _fetchCommentData: function _fetchCommentData() {
    var message = null;
    try {
      message = JSON.parse(this.commentInfo.message);
    } catch (e) {
      return null;
    }
    var messageDisplay;
    if (message['Type'] == 'Audio') {
      var audioUrl = MMCommonFun.getRemoteDURL(this.fileInfo.getCreatorId(), this.fileInfo.getFileId(), message['Url']);
      messageDisplay = _MDAudioPlayer["default"].getAudioPlayer(audioUrl, message['Body'], "", true); // true to get a prototype
    } else if (message['Type'] == 'Text') {
      messageDisplay = message['Body'];
    } else if (message['Type'] == 'Mark') {
      messageDisplay = message['Text'] || "";
      if (messageDisplay.length == 0) messageDisplay = BabelStr.str(5153);
    }

    // var readStatus = this.commentInfo.getReadStatus(app.currentUser.getUserId_Int());
    var readStatus = _CommentStatus["default"].Comment_read;
    if (this.commentInfo.unreadedCount > 0) {
      readStatus = _CommentStatus["default"].Comment_unread;
    }
    ;
    var uid = this.commentInfo.creator;
    var out = {
      username: this.commentInfo.creatorName,
      firstText: messageDisplay,
      answerCount: 0,
      readStatus: readStatus,
      completed: this.commentInfo.completed,
      userId: this.commentInfo.creator,
      time: this.commentInfo.createTime,
      visibleScope: this.commentInfo.visibleScope
    };
    return out;
  }
});
var _default = exports["default"] = MDCommentInfoView;

},{"1036":1036,"1085":1085,"1150":1150,"1184":1184,"1437":1437,"1454":1454,"1461":1461,"1463":1463,"1466":1466,"1478":1478,"17":17,"22":22,"313":313,"32":32,"325":325,"72":72,"807":807,"872":872,"882":882}],442:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDBasicToolPanel2 = _interopRequireDefault(require(456));
var _MDTabView = _interopRequireDefault(require(82));
var _MDGraphicToolTabPanelView = _interopRequireDefault(require(441));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // MDBasicToolPanel
//created by jichao
//2018.10.16
var MDGraphicToolTabView = exports["default"] = /*#__PURE__*/function (_MDBasicToolPanel) {
  (0, _inherits2["default"])(MDGraphicToolTabView, _MDBasicToolPanel);
  function MDGraphicToolTabView() {
    (0, _classCallCheck2["default"])(this, MDGraphicToolTabView);
    return _callSuper(this, MDGraphicToolTabView, arguments);
  }
  (0, _createClass2["default"])(MDGraphicToolTabView, [{
    key: "className",
    value: function className() {
      var superC = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDGraphicToolTabView.prototype), "className", this).call(this);
      return "".concat(superC, " graphic-tabs-panel");
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      props.inEditor = true;
      props.hideCloseBtn = true;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDGraphicToolTabView.prototype), "initialize", this).call(this, props);
      this.basic = new _MDGraphicToolTabPanelView["default"]();
      this.graphicTabView = new _MDTabView["default"]({
        className: 'graphic-tabs',
        tabBarDividerPosition: 2,
        fullMode: false,
        enableActivebar: false,
        tabs: [{
          title: BabelStr.str(2742),
          tabPanelView: this.basic,
          active: true
        }]
      });
      this.addSubView(this.graphicTabView, this.$('.tool-p-content')[0]);
      Dispatcher.on(MDEvents.beforeChangeToNextFile, this._beforeFileChanged, this);
    }
  }, {
    key: "setEditorViewCtl",
    value: function setEditorViewCtl(editorViewCtl) {
      this.editorViewCtl = editorViewCtl;
      this.basic.setEditorViewCtl(editorViewCtl);
    }
  }]);
  return MDGraphicToolTabView;
}(_MDBasicToolPanel2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"441":441,"456":456,"82":82}],441:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDGraphicToolTabPanelView = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(MDGraphicToolTabPanelView, _MDTabPanelView);
  function MDGraphicToolTabPanelView() {
    (0, _classCallCheck2["default"])(this, MDGraphicToolTabPanelView);
    return _callSuper(this, MDGraphicToolTabPanelView, arguments);
  }
  (0, _createClass2["default"])(MDGraphicToolTabPanelView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n\t\t\t<div class=\"title-tip\"><%=BabelStr.str(2743)%></div>\n\t\t\t<div class=\"gb-block\">\n\t\t\t\t<% for(var i = 1 ; i < 18 ; i++) { %>\n\t\t\t\t\t<img class=\"gb-img\" src=\"img/gb/<%=i%> copy 2.svg\" alt=\"\" data-id=\"<%=i%>\" />\n\t\t\t\t<% } %>\n\t\t\t</div>\n\t\t\t\n\t\t";
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDGraphicToolTabPanelView.prototype), "initialize", this).call(this);
      console.log('MDGraphicToolTabPanelView called');
      Dispatcher.on(MDEvents.weldMarkInserted, this._removeChecked, this);
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDGraphicToolTabPanelView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .gb-img': this._gbimgClickHandle
      });
    }
  }, {
    key: "_gbimgClickHandle",
    value: function _gbimgClickHandle($e) {
      var $target = $($e.target);
      var id = $target.data('id');
      console.log(id);
      this.$('.gb-img').removeClass('checked');
      $target.addClass('checked');
      this.editorViewCtl.setGraphicToolType(id);
      this.editorViewCtl.setGraphicToolCreateState(true);
    }
  }, {
    key: "_removeChecked",
    value: function _removeChecked(opt) {
      var fileInfo = this.editorViewCtl.getCurrentFileInfo();
      var _fid = this.editorViewCtl.getCurrentFileInfo().getFileId();
      var _ver = this.editorViewCtl.getVersionShowing();
      if (opt.ver == _ver && opt.fid == _fid) {
        this.$('.gb-img').removeClass('checked');
      }
    }
  }, {
    key: "setEditorViewCtl",
    value: function setEditorViewCtl(editorViewCtl) {
      this.editorViewCtl = editorViewCtl;
      console.log(1111);
      console.log(editorViewCtl);
    }
  }]);
  return MDGraphicToolTabPanelView;
}(_MDTabPanelView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"81":81}],440:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
var _MMBasicData = _interopRequireDefault(require(811));
var _Dispatcher = _interopRequireDefault(require(18));
var _MMViewBase = _interopRequireDefault(require(22));
var _MMCommonEditorView = _interopRequireDefault(require(914));
// MDZoomToolbar.js
// jiang
// 2017-5-23

var MDZoomToolbar = _MMViewBase["default"].extend({
  el: '<div id="toolbar-zoom" class="tool-bar toolbar-zoom"></div>',
  tmpl: '<button class="btn-zoomout icon"></button>' + '<button class="btn-zoomfit icon"></button>' + '<button class="btn-zoomin icon"></button>' + '<button class="btn-zoomrect icon"></button>' +
  // '<button class="btn-rotate icon"></button>' +
  '</button>',
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      editorViewCtl: null
    });
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      "click .btn-zoomin": this._zoomInClicked,
      "click .btn-zoomfit": this._zoomFitClicked,
      "mouseover ": this._mouseOver,
      "mouseout ": this._mouseOut,
      "click .btn-zoomout": this._zoomOutClicked,
      "click .btn-zoomrect": this._zoomRectClicked,
      "click .btn-rotate": this._rotatePage
    });
  },
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    var z_startIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
    $(this.el).css('z-index', z_startIndex);

    // Dispatcher.on(MDEvents.OpenEvalToolbar, this.showToolbar, this);
    _Dispatcher["default"].on(MDEvents.ZOOM_CHANGED, this._zoomChanged, this);
    _Dispatcher["default"].on(MDEvents.HideZoomRectLayer, this.zoomLayerHided, this);
    this.scaleList = [0.25, 0.50, 0.75, 1.0, 1.25, 1.50, 1.75, 2.0, 3.0, 4.0];
  },
  _zoomInClicked: function _zoomInClicked() {
    if (!this.editorViewCtl) {
      return;
    }
    ;
    if (this.doing) {
      return;
    }
    this.doing = true;
    this.editorViewCtl.disableZoomRectLayer();
    var scale = this.editorViewCtl.getScale();
    // this.scaleList = this.editorViewCtl.getZoomList();
    if (!this.scaleList) {
      return;
    }
    ;
    var self = this;
    if (this.editorViewCtl.getCurrentFileInfo().isCADFile()) {
      var tarScale = this.editorViewCtl.editor.calcFinalScale(1.25);
      this.editorViewCtl.changeScale(tarScale * scale, function () {
        setBabelTimeout(function () {
          self.doing = false;
        }, 200);
      });
    } else {
      for (var i = 0; i < this.scaleList.length; i++) {
        if (this.scaleList[i] > scale) {
          this.editorViewCtl.changeScale(this.scaleList[i], function () {
            setBabelTimeout(function () {
              self.doing = false;
            }, 200);
          });
          break;
        }
      }
      ;
      if (i >= this.scaleList.length) {
        this.doing = false;
      }
    }
  },
  _zoomFitClicked: function _zoomFitClicked() {
    if (!this.editorViewCtl) {
      return;
    }
    ;
    this.editorViewCtl.zoomToFit();
    this.editorViewCtl.disableZoomRectLayer();
    this.updateZoomRectStatus();
  },
  _rotatePage: function _rotatePage() {
    if (!this.editorViewCtl) {
      return;
    }
    ;
    this.editorViewCtl.rotatePage();
    this.editorViewCtl.disableZoomRectLayer();
    this.updateZoomRectStatus();
  },
  _zoomOutClicked: function _zoomOutClicked() {
    var self = this;
    if (!this.editorViewCtl) {
      return;
    }
    ;
    if (this.doing) {
      return;
    }
    this.doing = true;
    var scale = this.editorViewCtl.getScale();
    if (this.editorViewCtl.getCurrentFileInfo().isCADFile()) {
      var tarScale = this.editorViewCtl.editor.calcFinalScale(0.75);
      this.editorViewCtl.changeScale(tarScale * scale, function () {
        setBabelTimeout(function () {
          self.doing = false;
        }, 200);
      });
    } else {
      for (var i = this.scaleList.length - 1; i >= 0; i--) {
        if (this.scaleList[i] < scale) {
          this.editorViewCtl.changeScale(this.scaleList[i], function () {
            setBabelTimeout(function () {
              self.doing = false;
            }, 200);
          });
          break;
        }
      }
      ;
      if (i <= 0) {
        this.doing = false;
      }
    }
    this.editorViewCtl.disableZoomRectLayer();
    this.updateZoomRectStatus();
  },
  _zoomChanged: function _zoomChanged(opt) {
    if (!this.editorViewCtl) {
      return;
    }
    ;
    if (opt && opt.editorViewCtl != this.editorViewCtl) {
      return;
    }
    var scale = this.editorViewCtl.getScale();
    console.log('---- scale:', scale);
  },
  _zoomRectClicked: function _zoomRectClicked() {
    if (!this.editorViewCtl) {
      return;
    }
    var show = this.editorViewCtl.toggleZoomRect();
    this.updateZoomRectStatus();
  },
  hide: function hide() {
    this.$el.hide();
  },
  show: function show() {
    this.$el.show();
    if (this.timer) {
      clearTimeout(this.timer);
    }
    ;
    var self = this;
    this.timer = setBabelTimeout(function () {
      if (self.maitainShow) {
        return;
      }
      ;
      self.hide();
    }, 1000);
    if (this.editorViewCtl) {
      var show = this.editorViewCtl.canShowZoomRectTool();
      if (show) {
        this.$el.find('.btn-zoomrect').show();
      } else {
        this.$el.find('.btn-zoomrect').hide();
      }
    }
    this.updateZoomRectStatus();
  },
  setEditorViewCtl: function setEditorViewCtl(editorViewCtl) {
    this.editorViewCtl = editorViewCtl;
    if (editorViewCtl) {
      var show = editorViewCtl.canShowZoomRectTool();
      if (show) {
        this.$el.find('.btn-zoomrect').show();
      } else {
        this.$el.find('.btn-zoomrect').hide();
      }
    }
  },
  updateZoomRectStatus: function updateZoomRectStatus() {
    var show = this.editorViewCtl.canShowZoomRectTool() && this.editorViewCtl.isShowingZoomRect();
    if (show) {
      this.$el.find(".btn-zoomrect").addClass('select');
    } else {
      this.$el.find('.btn-zoomrect').removeClass('select');
    }
  },
  zoomLayerHided: function zoomLayerHided() {
    this.updateZoomRectStatus();
  },
  _mouseOver: function _mouseOver(e) {
    this.maitainShow = true;
    this.show();
  },
  _mouseOut: function _mouseOut(e) {
    this.maitainShow = false;
    this.show();
  }
}, {
  className: 'MDZoomToolbar'
});
var _default = exports["default"] = MDZoomToolbar;

},{"1184":1184,"1417":1417,"1454":1454,"1463":1463,"18":18,"22":22,"811":811,"914":914}],431:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1426);
require(1541);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDCommonListPopupView = _interopRequireDefault(require(62));
var _MDBasicToolPanel2 = _interopRequireDefault(require(456));
var _popupPos = _interopRequireDefault(require(65));
var _MMUserDataController = _interopRequireDefault(require(1108));
var _MDLoadMaskView = _interopRequireDefault(require(49));
var _MMFileInfo = _interopRequireDefault(require(297));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDEvents = _interopRequireDefault(require(325));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDAlertView = _interopRequireDefault(require(32));
var _MMCommonFun = _interopRequireDefault(require(812));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDSigSavePanelView = exports["default"] = /*#__PURE__*/function (_MDBasicToolPanel) {
  (0, _inherits2["default"])(MDSigSavePanelView, _MDBasicToolPanel);
  function MDSigSavePanelView() {
    (0, _classCallCheck2["default"])(this, MDSigSavePanelView);
    return _callSuper(this, MDSigSavePanelView, arguments);
  }
  (0, _createClass2["default"])(MDSigSavePanelView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n      <div class=\"show-save-list button done\"><%=BabelStr.str(11319)%></div>\n\t\t";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSigSavePanelView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        userObj: {},
        anchorPoint: 'topRight',
        signSavePanelOnHide: _.noop
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.inEditor = true;
      props.closeIsShowBtn = true;
      props.anchorPoint = 'topRight';
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSigSavePanelView.prototype), "initialize", this).call(this, props);
      _MDCommonListPopupView["default"].createPopup({
        triggerView: this.$('.show-save-list'),
        items: [BabelStr.str(11319), BabelStr.str(11320)],
        selIndex: 0,
        width: BabelStr.isRu() ? 252 : 100,
        direction: _popupPos["default"].BOTTOM_RIGHT,
        cls: 'sig-save-popup',
        onItemClicked: function onItemClicked(index) {
          console.log(_this.editorViewCtl);
          if (index == 0) {
            // this.showTagSettingWindow()
            _this.download();
          } else {
            _this.save();
            // this.showTagStyleWin()
          }
        }
      });
      _Dispatcher["default"].on(_MDEvents["default"].FileSignatureChanged, this._fileSealChanged, this);
      _Dispatcher["default"].on(_MDEvents["default"].fileSealChanged, this._fileSealChanged, this);
      _Dispatcher["default"].on(_MDEvents["default"].beforeChangeToNextFile, this._beforeFileChanged, this);
      _Dispatcher["default"].on(_MDEvents["default"].afterChangeToNextFile, this._fileChanged, this);
      _Dispatcher["default"].on(_MDEvents["default"].DATA_READY, this._fileChanged, this);
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSigSavePanelView.prototype), "events", this).call(this);
      return _.extend(superE, {});
    }
  }, {
    key: "className",
    value: function className() {
      var superC = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSigSavePanelView.prototype), "className", this).call(this);
      return "".concat(superC, " sig-save-panel");
    }

    // var sealData = [{
    //   seal_sign_id: 2,
    //   pageIndex: 0,
    //   x: 0.60,
    //   y: 0.60,
    //   width: 0.15,
    //   height: 0.15
    // }]
  }, {
    key: "download",
    value: function download(forceSeal) {
      this.sealFile(0, forceSeal || 0, function (sealedId, fileInfo) {
        var file = new _MMFileInfo["default"]({
          fileId: sealedId,
          toDownloadVer: -1,
          type: 1,
          fileName: fileInfo.getFileNameWithoutExt() + "-" + BabelStr.str(11326) + ".pdf",
          downloadBySealedStatus: true
        });
        window.downloadPanelView.pushFiles([file]);
      });
    }
  }, {
    key: "save",
    value: function save() {
      var _this2 = this;
      this.sealFile(1, 0, function (sealedId, fileInfo) {
        _this2.getSealedStatus(sealedId, fileInfo);
      });
    }
  }, {
    key: "sealFile",
    value: function sealFile(copyToCurrentFolder, forceSeal, callback) {
      var _this3 = this;
      var sealData = this.getSealDatas();
      console.log(sealData);
      _MDLoadMaskView["default"].show(undefined, {
        bodyMsg: BabelStr.str(11324),
        width: "auto"
      });
      var fileInfo = this.editorViewCtl.getCurrentFileInfo();
      var fid = fileInfo.getFileId();
      var v = this.editorViewCtl.getVersionShowing();
      _MMUserDataController["default"].sealFile(sealData, copyToCurrentFolder, fid, v, forceSeal, function (res) {
        var sealedId = res.sealedId;
        callback(sealedId, fileInfo);
        // this.getSealedStatus(sealedId, fileInfo)
      }, function (err) {
        if (err.code == 10004) {
          _this3.showAlert(copyToCurrentFolder, err.downloadUrl, err.fileName);
        } else {
          _MDSnackbarView["default"].show(err.msg || BabelStr.str(309));
        }
        _MDLoadMaskView["default"].remove();
      });
    }
  }, {
    key: "showAlert",
    value: function showAlert(copyToCurrentFolder, downloadUrl, fileName) {
      var _this4 = this;
      var alert = new _MDAlertView["default"]();
      alert.show({
        title: BabelStr.str(170),
        message: '<p class="title">' + BabelStr.str(11339) + '</p>',
        className: 'm-delAlertWin',
        width: 470,
        hideCloseBtn: true,
        buttons: [{
          label: BabelStr.str(155)
        }, {
          label: BabelStr.str(11321),
          onClick: function onClick() {
            var file = new _MMFileInfo["default"]({
              fileId: new Date().getTime(),
              toDownloadVer: -1,
              type: 1,
              fileName: fileName,
              downloadUrl: downloadUrl
            });
            window.downloadPanelView.pushFiles([file]);
          }
        }, {
          label: BabelStr.str(11341),
          type: 'done',
          onClick: function onClick() {
            if (copyToCurrentFolder) {
              _this4.sealFile(copyToCurrentFolder, 1, function (sealedId, fileInfo) {
                _this4.getSealedStatus(sealedId, fileInfo);
              });
            } else {
              _this4.download(1);
            }
          }
        }]
      });
    }
  }, {
    key: "getSealDatas",
    value: function getSealDatas() {
      var seals = this.editorViewCtl.getCurrentBoard().getAllSigFrames();
      return _.map(seals, function (seal) {
        return _.extend({
          commentId: seal.getSealedId(),
          seal_sign_id: seal.getSigData().getId(),
          pageIndex: seal.getPageIndex()
        }, seal.getSealSizeData());
      });
    }
  }, {
    key: "_fileSealChanged",
    value: function _fileSealChanged(param) {
      var fileId = param.fileId,
        version = param.version;
      if (!this.editorViewCtl) {
        return;
      }
      var file = this.editorViewCtl.getCurrentFileInfo();
      if (file.isDeleted()) {
        this.hide();
        return;
      }
      var fid = file.getFileId();
      var v = this.editorViewCtl.getVersionShowing();
      if (fileId == fid && version == v && file.canDownload() && !file.isArchived()) {
        var seals = this.editorViewCtl.getCurrentBoard().getAllSigFrames();
        if (seals.length) {
          this.show();
        } else {
          this.hide();
        }
      }
    }
  }, {
    key: "getSealedStatus",
    value: function getSealedStatus(sealedId, fileInfo) {
      var _this5 = this;
      _MMUserDataController["default"].getSealedStatus(sealedId, function (res) {
        if (res.status == -1) {
          setTimeout(function () {
            _this5.getSealedStatus(sealedId);
          }, 5000);
        } else if (res.status == 0) {
          console.log("成功了");
          _Dispatcher["default"].trigger(_MDEvents["default"].RefreshCurFolder);
          // let url = res.downloadUrl
          // MMCommonFun.downloadFileByUrl(url)
          _MDLoadMaskView["default"].remove();
          _MDSnackbarView["default"].show(BabelStr.str(3556));
        } else {
          _MDSnackbarView["default"].show(res.msg || BabelStr.str(11325));
          _MDLoadMaskView["default"].remove();
        }
      }, function (res) {
        _MDLoadMaskView["default"].remove();
      });
    }
  }, {
    key: "onHide",
    value: function onHide() {
      this.signSavePanelOnHide();
    }
  }, {
    key: "setEditorViewCtl",
    value: function setEditorViewCtl(ctl) {
      this.editorViewCtl = ctl;
      this._fileChanged();
    }
  }, {
    key: "_beforeFileChanged",
    value: function _beforeFileChanged() {
      this.hide();
    }
  }, {
    key: "_fileChanged",
    value: function _fileChanged() {
      if (!this.editorViewCtl) {
        return;
      }
      var file = this.editorViewCtl.getCurrentFileInfo();
      try {
        if (file.canDownload() && !file.isDeleted() && !file.isArchived()) {
          var seals = this.editorViewCtl.getCurrentBoard().getAllSigFrames();
          if (seals.length) {
            this.show();
          } else {
            this.hide();
          }
        }
      } catch (error) {}
    }
  }]);
  return MDSigSavePanelView;
}(_MDBasicToolPanel2["default"]);

},{"1108":1108,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1426":1426,"1437":1437,"1454":1454,"1463":1463,"1475":1475,"1541":1541,"18":18,"297":297,"32":32,"325":325,"456":456,"49":49,"62":62,"65":65,"72":72,"812":812}],429:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDEditorVerticalToolbar = _interopRequireDefault(require(417));
// MDSalonToolbar.js
// jiang
// 2017-10-14

var MDSalonToolbar = _MDEditorVerticalToolbar["default"].extend({
  toolTmp: function toolTmp() {
    return '<li class="b-salon-pen">' + '<button class="button-icon p-salon-pen  button-li  f-pointer" tool-name="salon-pen" data-tooltip="<%=pen%>"></button>' + '</li>' + '<li class="b-salon-eraser">' + '<button class="button-icon p-salon-eraser  button-li  f-pointer" tool-name="salon-eraser" data-tooltip="<%=eraser%>"></button>' + '</li>' + '';
  },
  render: function render(data) {
    data = {
      'pen': _MDLocalString["default"].getLocalString(2040),
      'eraser': _MDLocalString["default"].getLocalString(2041)
    };
    _MDEditorVerticalToolbar["default"].prototype.render.call(this, data);
  },
  initProps: function initProps() {
    var superP = _MDEditorVerticalToolbar["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      editorViewCtl: null
    });
  },
  events: function events() {
    var superE = _MDEditorVerticalToolbar["default"].prototype.events.call(this);
    return _.extend(superE, {});
  },
  initialize: function initialize(opt) {
    _MDEditorVerticalToolbar["default"].prototype.initialize.call(this, opt);
    this.$el.css('left', '50px');
    this.hide();
    Dispatcher.on(MDEvents.salonStatusChanged, this._salonStatusChanged, this);
  },
  setEditorViewCtl: function setEditorViewCtl(editorViewCtl) {
    _MDEditorVerticalToolbar["default"].prototype.setEditorViewCtl.call(this, editorViewCtl);
  },
  _salonStatusChanged: function _salonStatusChanged(salonInfo) {
    if (salonInfo && salonInfo.isCurrentUserSpeaker()) {
      this.$el.show();
      this.clearSelect();
    } else {
      this.$el.hide();
      this.clearSelect();
    }
    this.editorViewCtl.setCurOperation();
  },
  _beforeFileChanged: function _beforeFileChanged(e) {
    _MDEditorVerticalToolbar["default"].prototype._beforeFileChanged.call(this, e);
  },
  _afterFileChanged: function _afterFileChanged(e) {
    _MDEditorVerticalToolbar["default"].prototype._afterFileChanged.call(this, e);
    var fileInfo = this.editorViewCtl.getCurrentFileInfo();
    if (fileInfo.canSalon()) {}
    ;
  },
  // comment tool selected
  _toolSelected: function _toolSelected(e) {
    var selected = _MDEditorVerticalToolbar["default"].prototype._toolSelected.call(this, e);
    if (selected) {} else {}
  },
  _onFileHasText: function _onFileHasText(e) {
    this.$('.b-sel-text').show();
  }
}, {
  className: 'MDSalonToolbar'
});
var _default = exports["default"] = MDSalonToolbar;

},{"1150":1150,"1184":1184,"1454":1454,"417":417}],426:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1423);
require(1538);
require(1412);
require(1439);
var _toConsumableArray2 = _interopRequireDefault(require(1194));
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDBasicToolPanel2 = _interopRequireDefault(require(456));
var _MDAlertView = _interopRequireDefault(require(32));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } //MDPenListPanelView
// javascript/moladisk/views/editor/MDPenListPanelView.js
//jichao
//2018-10-9
var MDPenListPanelView = exports["default"] = /*#__PURE__*/function (_MDBasicToolPanel) {
  (0, _inherits2["default"])(MDPenListPanelView, _MDBasicToolPanel);
  function MDPenListPanelView() {
    (0, _classCallCheck2["default"])(this, MDPenListPanelView);
    return _callSuper(this, MDPenListPanelView, arguments);
  }
  (0, _createClass2["default"])(MDPenListPanelView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n\t\t\t<%for(var i = 0 ; i < data.length ; i++) {%>\n\t\t\t\t<div class=\"pen-item show-inner-item\" data-userid=\"<%=data[i]['userId']%>\">\n\t\t\t\t\t<div class=\"title-item flex-align middle\" data-id=\"000\">\n\t\t\t\t\t\t<img class=\"user-img\" src=\"\" alt=\"\" data-userid=\"<%=data[i]['userId']%>\"/>\t\t\t\t\t\t\n\t\t\t\t\t\t<span class=\"icon sign\"></span>\n\t\t\t\t\t\t<span class=\"fullfill user-name\"><%=userObj[data[i]['userId']] || ''%></span>\n\t\t\t\t\t\t<span class=\"del-user icon deletePer disabled\" data-tooltip=\"<%=BabelStr.str(32)%>\" data-tooltip-dir=\"top\"></span>\n\t\t\t\t\t\t<span class=\"view-user icon review-pen-item\" data-tooltip=\"<%=BabelStr.str(2736)%>\" data-tooltip-dir=\"top\"></span>\n\t\t\t\t\t</div>\n\t\t\t\t\t<%for(var j = 0 ; j < data[i]['rects'].length; j++){%>\n\t\t\t\t\t\t<div class=\"inner-item flex-align\" data-index=\"<%=j%>\">\n\t\t\t\t\t\t\t<span class=\"del icon deletePer disabled\" data-tooltip=\"<%=BabelStr.str(32)%>\" data-tooltip-dir=\"top\"></span>\n\t\t\t\t\t\t\t<img class=\"loc-icon\" src=\"img/mdisk/location<%=i%6+1%>.svg\"></img>\n\t\t\t\t\t\t\t<span class=\"fullfill rect-name\">" + BabelStr.str(9952) + "<%=j + 1%></span>\n\t\t\t\t\t\t\t<span class=\"view icon review-pen-item\" data-tooltip=\"<%=BabelStr.str(2736)%>\" data-tooltip-dir=\"top\"></span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t<%}%>\n\t\t\t\t</div>\n\t\t\t<%}%>\n\t\t";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDPenListPanelView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        userObj: {},
        anchorPoint: 'topRight',
        penListPanleOnHide: _.noop
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      props.inEditor = true;
      props.closeIsShowBtn = true;
      props.anchorPoint = 'topRight';
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDPenListPanelView.prototype), "initialize", this).call(this, props);
      this.setTitle(BabelStr.str(2737));
      this.setDisButtonText(BabelStr.str(2675));
      this.showDisBtn();
      Dispatcher.on(MDEvents.refreshPenList, this.refreshData, this);
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDPenListPanelView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .title-item': this._toggleInnerBlock,
        'click .del': this._delClickHandle,
        'click .del-user': this._delUserClickHandle,
        'click .view': this._viewClickHandle,
        'click .view-user': this._ViewUserClickHandle,
        'click .rect-name': this._rectNameClickHandle
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superC = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDPenListPanelView.prototype), "className", this).call(this);
      return "".concat(superC, " pen-list-panel");
    }
  }, {
    key: "renderUserImgs",
    value: function renderUserImgs() {
      var $imgs = this.$('.user-img');
      for (var i = 0; i < $imgs.length; i++) {
        var $item = $imgs.eq(i);
        var userId = $item.data('userid');
        app.setAvatarImage($item, userId);
      }
    }
  }, {
    key: "renderUserNameById",
    value: function renderUserNameById(userId) {
      var $penItem = this.$(".pen-item[data-userid=".concat(userId, "]"));
      $penItem.find('.user-name').html(this.userObj[userId]);
    }
  }, {
    key: "renderTmpl",
    value: function renderTmpl() {
      var data = {
        data: this.datas,
        userObj: this.userObj
      };
      var contentTmpl = _.template(this.contentTmpl())(data);
      this.$('.tool-p-content').html(contentTmpl);
      this.renderUserImgs();
    }
  }, {
    key: "refreshData",
    value: function refreshData(opt) {
      var editViewCtl = this.editorViewCtl;
      if (!editViewCtl) {
        return;
      }
      var curDispVer = editViewCtl.getVersionShowing();
      var fileId = editViewCtl.getCurrentFileInfo().getFileId();
      if (fileId != opt.fileId || curDispVer != opt.version) {
        return;
      }
      if (opt.pens.length < 1) {
        this.showDisBtn();
      }
      console.log(opt);
      this.datas = opt.pens;
      this.formateData();
    }
  }, {
    key: "_delClickHandle",
    value: function _delClickHandle($e) {
      $e.stopPropagation();
      var editViewCtl = this.editorViewCtl;
      var alertOpt = {
        okFun: function okFun() {
          var penZoneCtl = editViewCtl.getPenZoneCtl();
          var $targetItem = $($e.target).closest('.inner-item');
          var index = $targetItem.data('index');
          var userId = $targetItem.closest('.pen-item').data('userid');
          console.log({
            userId: userId,
            index: index
          });
          penZoneCtl.removeSections(userId, index, function () {
            $targetItem.remove();
          });
        },
        message: BabelStr.str(2052) // 确定要删除这些笔画吗？
      };
      _MDAlertView["default"].showStandardSelection(alertOpt);
    }
  }, {
    key: "_delUserClickHandle",
    value: function _delUserClickHandle($e) {
      $e.stopPropagation();
      var editViewCtl = this.editorViewCtl;
      var alertOpt = {
        okFun: function okFun() {
          var penZoneCtl = editViewCtl.getPenZoneCtl();
          var $targetItem = $($e.target).closest('.title-item');
          var index = $targetItem.data('index');
          var userId = $targetItem.closest('.pen-item').data('userid');
          console.log({
            userId: userId,
            index: index
          });
          penZoneCtl.removeSections(userId, -1, function () {
            $targetItem.closest('.pen-item').remove();
          });
        },
        message: BabelStr.str(2053) // 确定要删除此人的所有笔画吗？
      };
      _MDAlertView["default"].showStandardSelection(alertOpt);
    }
  }, {
    key: "_rectNameClickHandle",
    value: function _rectNameClickHandle($e) {
      $e.stopPropagation();
      var editViewCtl = this.editorViewCtl;
      var penZoneCtl = editViewCtl.getPenZoneCtl();
      var $targetItem = $($e.target).closest('.inner-item');
      var index = $targetItem.data('index');
      var userId = $targetItem.closest('.pen-item').data('userid');
      console.log({
        userId: userId,
        index: index
      });
      penZoneCtl.focusUserSection(userId, index);
    }
  }, {
    key: "formateData",
    value: function formateData() {
      var _ref,
        _this = this;
      var ids = _.pluck(this.datas, 'userId');
      var oldIds = _.keys(this.userObj);
      var newIds = (_ref = _).without.apply(_ref, [ids].concat((0, _toConsumableArray2["default"])(oldIds)));
      this.renderTmpl();
      if (!newIds.length) {
        return;
      }
      MMEnterpriseController.getUsersByIds(newIds, false, function (users) {
        console.warn(users);
        _.each(users, function (user) {
          _this.userObj[user.id] = user.name;
          _this.renderUserNameById(user.id);
        });
      }, function () {});
    }
  }, {
    key: "_viewClickHandle",
    value: function _viewClickHandle($e) {
      var editViewCtl = this.editorViewCtl;
      var penZoneCtl = editViewCtl.getPenZoneCtl();
      var $targetItem = $($e.target).closest('.inner-item');
      var index = $targetItem.data('index');
      var userId = $targetItem.closest('.pen-item').data('userid');
      console.log({
        userId: userId,
        index: index
      });
      if ($targetItem.hasClass('hide-item')) {
        $targetItem.removeClass('hide-item');
        console.warn('显示手绘笔迹');
        penZoneCtl.showHideScribbles(userId, index);
        $($e.target).data('tooltip', BabelStr.str(2736));
        $($e.target).attr('data-tooltip', BabelStr.str(2736));
      } else {
        $targetItem.addClass('hide-item');
        console.warn('隐藏手绘笔迹');
        penZoneCtl.showHideScribbles(userId, index, 'hide');
        $($e.target).data('tooltip', BabelStr.str(2738));
        $($e.target).attr('data-tooltip', BabelStr.str(2738));
      }
    }
  }, {
    key: "_ViewUserClickHandle",
    value: function _ViewUserClickHandle($e) {
      $e.stopPropagation();
      var editViewCtl = this.editorViewCtl;
      var penZoneCtl = editViewCtl.getPenZoneCtl();
      var $targetItem = $($e.target).closest('.title-item');
      var userId = $targetItem.closest('.pen-item').data('userid');
      if ($targetItem.hasClass('hide-item')) {
        $targetItem.removeClass('hide-item');
        console.warn('显示手绘笔迹');
        penZoneCtl.showHideScribbles(userId, -1);
        $($e.target).data('tooltip', BabelStr.str(2736));
        $($e.target).attr('data-tooltip', BabelStr.str(2736));
        $targetItem.parent().find('.inner-item').removeClass('hide-item');
        $targetItem.parent().find('.inner-item .view').data('tooltip', BabelStr.str(2736)).attr('data-tooltip', BabelStr.str(2736));
      } else {
        $targetItem.addClass('hide-item');
        console.warn('隐藏手绘笔迹');
        penZoneCtl.showHideScribbles(userId, -1, 'hide');
        $($e.target).data('tooltip', BabelStr.str(2738));
        $($e.target).attr('data-tooltip', BabelStr.str(2738));
        $targetItem.parent().find('.inner-item').addClass('hide-item');
        $targetItem.parent().find('.inner-item .view').data('tooltip', BabelStr.str(2738)).attr('data-tooltip', BabelStr.str(2738));
      }
    }
  }, {
    key: "onHide",
    value: function onHide() {
      this.penListPanleOnHide();
    }
  }, {
    key: "setEditorViewCtl",
    value: function setEditorViewCtl(ctl) {
      this.editorViewCtl = ctl;
    }
  }, {
    key: "_toggleInnerBlock",
    value: function _toggleInnerBlock($e) {
      $($e.target).closest('.pen-item').toggleClass('show-inner-item');
    }
  }]);
  return MDPenListPanelView;
}(_MDBasicToolPanel2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1194":1194,"1412":1412,"1417":1417,"1423":1423,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"1538":1538,"32":32,"456":456}],424:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMViewBase = _interopRequireDefault(require(22));
var _MMNetDiskImageCollectionView = _interopRequireDefault(require(938));
var _MMBasicData = _interopRequireDefault(require(811));
/**
 * 	pdf page changer toolbar, slide between different files
 *  Create by jiang
 *  2015.9.9
 */

var MDPDFToolbar4PC = _MMViewBase["default"].extend({
  el: '<div id="pdfToolBar" class="p-pdf-container"></div>',
  tmpl: '<div class="p-pdf-toolbar">' + '<div class="p-pdf-pageChanger top">' + '<button class="p-pdf-prePage button-bottom  icon "></button>' + '<b id="pageNo" class="top">0</b> / <b id="pageCount" class="top">100</b>' + '<button class="p-pdf-nextPage button-bottom icon"></button>' + '</div>' + '</div>',
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      editorViewCtl: null,
      maitainShow: false
    });
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      "click .p-pdf-prePage": this._prePageClicked,
      "click .p-pdf-nextPage": this._nextPageClicked,
      "mouseover .p-pdf-toolbar": this._mouseOver,
      "mouseout .p-pdf-toolbar": this._mouseOut
    });
  },
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    var z_startIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
    $(this.el).css('z-index', z_startIndex);
    this.maitainShow = false;
  },
  setEditorViewCtl: function setEditorViewCtl(editorViewCtl) {
    this.editorViewCtl = editorViewCtl;
    this.updatePgInfo();
  },
  updatePgInfo: function updatePgInfo() {
    if (!this.editorViewCtl) {
      return;
    }
    var pgCount = this.editorViewCtl.getCurrentFilePageCount();
    var curPg = this.editorViewCtl.getCurrentFilePageIndex() + 1;
    if (pgCount <= 1) {
      this.$el.hide();
    }
    viewManager.set("pdfBottomBtn", this);
    this.$('#pageNo').text(curPg);
    this.$('#pageCount').text(pgCount);
  },
  _moveClicked: function _moveClicked(e) {
    console.log(" pan clicked!");
  },
  _mouseOver: function _mouseOver(e) {
    this.maitainShow = true;
    this.superView.showBottomToolBar();
  },
  _mouseOut: function _mouseOut(e) {
    this.maitainShow = false;
    this.superView.showBottomToolBar();
  },
  _prePageClicked: function _prePageClicked(e) {
    console.log("pre file");
    var that = this;
    var pdfEditor = this.editorViewCtl.getCurFileEditor();
    if (pdfEditor) {
      pdfEditor.scrollToNextPage(false, true, function () {
        that.updatePgInfo();
      });
    }
    ;
  },
  _nextPageClicked: function _nextPageClicked(e) {
    console.log("next file");
    var that = this;
    var pdfEditor = this.editorViewCtl.getCurFileEditor();
    if (pdfEditor) {
      pdfEditor.scrollToNextPage(true, true, function () {
        that.updatePgInfo();
      });
    }
    ;
  },
  hide: function hide() {
    if (!this.maitainShow) {
      _MMViewBase["default"].prototype.hide.call(this);
    }
    ;
  }
});
var _default = exports["default"] = MDPDFToolbar4PC;

},{"1184":1184,"1454":1454,"22":22,"811":811,"938":938}],218:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDEditorVerticalToolbar = _interopRequireDefault(require(417));
var _MDBasicToolbar = _interopRequireDefault(require(804));
var _MMBasicData = _interopRequireDefault(require(811));
// MDCommentToolbar.js
// jiang
// 2017-10-5

var MDCommentToolbar = _MDEditorVerticalToolbar["default"].extend({
  toolTmp: function toolTmp() {
    return '<li class="b-comment-normal">' + '<button class="button-icon p-comment  button-li  f-pointer" tool-name="comment" data-tooltip="<%=comment%>" data-tooltip-dir="right"></button>' + '</li>' + '<li class="b-pen-comment">' + '<button class="button-icon p-pen-comment  button-li  f-pointer" tool-name="penComment" data-tooltip="<%=pen%>" data-tooltip-dir="right"></button>' + '</li>' + '<li class="b-graphic-tool">' + '<button class="button-icon button-li p-graphic-tool f-pointer" tool-name="graphic" data-tooltip="<%=BabelStr.str(2741)%>" data-tooltip-dir="right"></button>' + '</li>' + '<li class="b-rect-comment">' + '<button class="button-icon p-rect-comment  button-li  f-pointer" tool-name="rectComment" data-tooltip="<%=rect%>" data-tooltip-dir="right"></button>' + '</li>' + '<li class="b-ellipse-comment">' + '<button class="button-icon p-ellipse-comment  button-li  f-pointer" tool-name="ellipseComment"  data-tooltip="<%=circle%>" data-tooltip-dir="right"></button>' + '</li>' + '<li class="b-arrow-comment">' + '<button class="button-icon p-arrow-comment  button-li  f-pointer" tool-name="arrowComment"  data-tooltip="<%=arrow%>" data-tooltip-dir="right"></button>' + '</li>' + '<li class="b-tag-comment">' + '<button class="button-icon p-tag-comment  button-li  f-pointer" tool-name="tag"  data-tooltip="<%=tag%>" data-tooltip-dir="right"></button>' + '</li>' + '<li class="b-text-comment">' + '<button class="button-icon p-text-comment  button-li  f-pointer" tool-name="text-mark"  data-tooltip="<%=text%>" data-tooltip-dir="right"></button>' + '</li>' +
    // '<li class="b-sel-text">' +
    // '<button class="button-icon p-sel-text  button-li  f-pointer" data-tooltip="选取文字"></button>' +
    // '</li>' +
    '';
  },
  render: function render(data) {
    var data = {
      'comment': _MDLocalString["default"].getLocalString(2027),
      // 添加批注
      'rect': _MDLocalString["default"].getLocalString(2028),
      // 矩形框批注
      'circle': _MDLocalString["default"].getLocalString(2029),
      // 圆形批注
      'arrow': _MDLocalString["default"].getLocalString(2030),
      // 箭头批注
      'tag': _MDLocalString["default"].getLocalString(2031),
      // 标签标注
      'text': _MDLocalString["default"].getLocalString(109),
      // 文字批注
      'pen': _MDLocalString["default"].getLocalString(787) // 文字批注
    };
    _MDEditorVerticalToolbar["default"].prototype.render.call(this, data);
  },
  initProps: function initProps() {
    var superP = _MDEditorVerticalToolbar["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      editorViewCtl: null
    });
  },
  events: function events() {
    var superE = _MDEditorVerticalToolbar["default"].prototype.events.call(this);
    return _.extend(superE, {});
  },
  initialize: function initialize(opt) {
    _MDEditorVerticalToolbar["default"].prototype.initialize.call(this, opt);
    Dispatcher.on(MDEvents.fileHasText, this._onFileHasText, this);
    Dispatcher.on(MDEvents.CommentToolChangedNotByClick, this._changedByOthers, this);
    Dispatcher.on(MDEvents.NULL_OPERATION, this._clearTool, this);
    this.$('.b-text-comment').hide();
    this.$el.hide();
    if (!isPrivateCloud && (!app.isEpVersion() || app.ep.getEpID() != 162)) {
      // 非企业版以及非画擎的企业版不能使用焊接符号
      this.$('.b-graphic-tool').remove();
    } else {}
  },
  setEditorViewCtl: function setEditorViewCtl(editorViewCtl) {
    _MDEditorVerticalToolbar["default"].prototype.setEditorViewCtl.call(this, editorViewCtl);
    this.$('.b-text-comment').hide();
    var curEditor = editorViewCtl.getCurEditor();
    if (curEditor && curEditor.hasText && curEditor.hasText()) {
      this.$('.b-text-comment').show();
    }
    ;
  },
  _changedByOthers: function _changedByOthers(toolName) {
    if (toolName == 'comment') {
      // this.setToolSelected(0);
      // this.editorViewCtl.setCurOperation('comment');
      this.clearSelect();
    }
    ;
  },
  _clearTool: function _clearTool(params) {
    var isMarkerEvent = params.isMark;
    var editorViewCtl = params.editorViewCtl;
    if (!isMarkerEvent && this.editorViewCtl == editorViewCtl) {
      this.clearSelect();
    }
    ;
  },
  _beforeFileChanged: function _beforeFileChanged(e) {
    _MDEditorVerticalToolbar["default"].prototype._beforeFileChanged.call(this, e);
    this.$('.b-text-comment').hide();
    this.clearSelect();
  },
  _afterFileChanged: function _afterFileChanged(e) {
    var _this = this;
    _MDEditorVerticalToolbar["default"].prototype._afterFileChanged.call(this, e);
    var fileInfo = this.editorViewCtl.getCurrentFileInfo();
    if (fileInfo.canDispInOpenGL() || !fileInfo.canCreateComment() || this.editorViewCtl.getCurEditor().getClassName() == "MDSWFEditor") {
      this.$el.hide();
    } else {
      if (fileInfo.canDispInWebBrowser() || fileInfo.dispNeedWhiteBoard()) {
        var showToolbar = true;
        if (fileInfo.canDispInWebBrowser()) {
          this.$el.find('.b-tag-comment').hide();
          this.$el.find('.b-pen-comment').hide();
          this.$('.b-graphic-tool').hide();
        } else {
          this.$el.find('.b-tag-comment').show();
          this.$el.find('.b-pen-comment').show();
          this.$('.b-graphic-tool').show();
        }
        if (fileInfo.isOnlyDisp()) {
          showToolbar = false;
        }
        // 匿名用户不支持 html 批注
        if (fileInfo.canDispInWebBrowser() && app.currentUser.isAnonymous()) {
          showToolbar = false;
        } else {
          var version = this.editorViewCtl.getVersionShowing();
          fileInfo.canCreateCommentForVersion(version, function (can, isEval) {
            if (!can) {
              showToolbar = false;
            }
            if (showToolbar) {
              _this._showToolbar(isEval);
            } else {
              _this.$el.hide();
            }
          });
        }
      }
      ;
    }
  },
  _showToolbar: function _showToolbar(isEval) {
    this.$el.show();
    if (isEval) {
      this.$('.p-comment').attr('data-tooltip', BabelStr.str(5145));
      this.$('.p-rect-comment').attr('data-tooltip', BabelStr.str(5146));
      this.$('.p-ellipse-comment').attr('data-tooltip', BabelStr.str(5147));
      this.$('.p-arrow-comment').attr('data-tooltip', BabelStr.str(5148));
      this.$('.p-text-comment').attr('data-tooltip', BabelStr.str(5149));
    } else {
      this.$('.p-comment').attr('data-tooltip', _MDLocalString["default"].getLocalString(2027));
      this.$('.p-rect-comment').attr('data-tooltip', _MDLocalString["default"].getLocalString(2028)); // 矩形框批注
      this.$('.p-ellipse-comment').attr('data-tooltip', _MDLocalString["default"].getLocalString(2029)); // 圆形批注
      this.$('.p-arrow-comment').attr('data-tooltip', _MDLocalString["default"].getLocalString(2030)); // 箭头批注
      this.$('.p-text-comment').attr('data-tooltip', _MDLocalString["default"].getLocalString(109)); // 文字批注
    }
  },
  // comment tool selected
  _toolSelected: function _toolSelected(e) {
    this.editorViewCtl.disableZoomRectLayer();
    Dispatcher.trigger(MDEvents.HideZoomRectLayer);
    var selected = _MDEditorVerticalToolbar["default"].prototype._toolSelected.call(this, e);
    if (selected) {
      Dispatcher.trigger(MDEvents.SHOW_COMMENTS);
    }
  },
  _onFileHasText: function _onFileHasText(editorViewCtl) {
    if (this.editorViewCtl && editorViewCtl && this.editorViewCtl.getCurrentBoard() == editorViewCtl.getCurrentBoard()) {
      this.$('.b-text-comment').show();
    }
    ;
  },
  setPenSelected: function setPenSelected() {
    this.setToolSelected(1);
  }
}, {
  className: 'MDCommentToolbar'
});
var _default = exports["default"] = MDCommentToolbar;

},{"1150":1150,"1184":1184,"1417":1417,"1454":1454,"1463":1463,"417":417,"804":804,"811":811}],329:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require(1180));
require(1412);
require(1432);
require(1417);
require(1463);
var _app = _interopRequireDefault(require(17));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDAccountSettingWindowView = _interopRequireDefault(require(734));
/**
 * MDIntro 显示界面提示
 *
 * WebContent/javascript/moladisk/common/MDIntro.js
 * Created by manjun.han
 * 2016.1.8
 */

var _config = window['_config'] || {};

/**
 * Introjs plugin
 *
 * @see https://github.com/usablica/intro.js
 */
var MDIntro = {
  autoIntroHome: function autoIntroHome() {
    if (_config['introHome']) {
      MDIntro.introHome();
    }
  },
  autoIntroEditor: function autoIntroEditor() {
    _MMNetDiskDataController["default"].isEditorCourseDisplayed(function success(finished) {
      if (!finished) {
        MDIntro.introEditor();
      }
      ;
    });
  },
  introHome: function introHome() {
    if (!_app["default"].currentUser.hasBindEmail()) {
      MDIntro.showBindPhoneTip(function () {
        MDIntro.introHomeStart();
      });
    } else {
      MDIntro.introHomeStart();
    }
  },
  showBindPhoneTip: function showBindPhoneTip(callback) {
    _MDAlertView["default"].showStandardSelection({
      title: BabelStr.str(2338),
      message: BabelStr.str(7070),
      okStr: BabelStr.str(7071),
      okFun: function okFun() {
        var accountWindowView = new _MDAccountSettingWindowView["default"]({
          callback: callback
        });
        accountWindowView.show();
      },
      cancelStr: BabelStr.str(7072),
      cancelFun: function cancelFun() {
        callback && callback();
      }
    });
  },
  introHomeStart: function introHomeStart() {
    var intro = introJs();
    var isEpVersion = _app["default"].isEpVersion();
    var guest = _app["default"].currentUser.get('guest');
    var isGuest = guest == 1;
    var godEyeDepartment = window['departmentFolderId'];
    var godEyePerson = false;
    var remain;
    if (!window['departmentFolderId'] && _app["default"].userBeingViewed) {
      godEyePerson = true;
    }
    ;
    var steps = [{
      intro: "<h3 class='title'><i>1</i>" + BabelStr.str(7073) + "</h3><p>" + BabelStr.str(7074) + "</p>"
    }, {
      element: $('.createBtn').get(0),
      titleStr: BabelStr.str(7),
      introStr: BabelStr.str(7075)
    }, {
      element: $(".m-nav .channel-all").get(0),
      titleStr: BabelStr.str(2004),
      introStr: BabelStr.str(7076)
    }, {
      element: $('.m-nav .channel-depart').get(0),
      titleStr: BabelStr.str(7077),
      introStr: BabelStr.str(7078)
    }, {
      element: $('.m-nav .channel-team').get(0),
      titleStr: BabelStr.str(17),
      introStr: BabelStr.str(7079)
    }, {
      element: $('.m-nav .channel-myshare').get(0),
      titleStr: BabelStr.str(19),
      introStr: BabelStr.str(7080)
    }, {
      element: $('.m-nav .channel-joinshare').get(0),
      titleStr: BabelStr.str(20),
      introStr: BabelStr.str(7081)
    }, {
      element: $('.m-nav .channel-myfocus').get(0),
      titleStr: BabelStr.str(144),
      introStr: BabelStr.str(7082)
    }];
    if (_app["default"].isEpVersion()) {
      steps.push({
        element: $('.m-nav .channel-msbox').get(0),
        titleStr: BabelStr.str(370),
        introStr: BabelStr.str(7083)
      });
    }
    steps = steps.concat([{
      element: $('.m-nav .channel-evaluation').get(0),
      titleStr: BabelStr.str(7084),
      introStr: BabelStr.str(7085)
    }, {
      element: $('.m-nav .channel-trash').get(0),
      titleStr: BabelStr.str(22),
      introStr: BabelStr.str(7086)
    }]);
    if (_app["default"].userClentMode()) {
      steps.push((0, _defineProperty2["default"])({
        // element: $('.for-client-nav').get(0),
        element: $('.for-client-nav .mCSB_container').get(0),
        position: 'bottom-middle-aligned',
        titleStr: BabelStr.str(7087),
        introStr: BabelStr.str(7088)
      }, "position", 'right'));
    } else {
      steps.push({
        element: $('.m-moduleTabs').get(0),
        position: 'bottom-middle-aligned',
        titleStr: BabelStr.str(7087),
        introStr: BabelStr.str(7088)
      });
    }
    steps.push({
      element: $('.m-homeHd .home').get(0),
      titleStr: BabelStr.str(7089),
      introStr: BabelStr.str(7090)
    });
    for (var i = 1; i < steps.length;) {
      if (!steps[i].element) {
        steps.splice(i, 1);
      } else {
        i++;
      }
    }
    ;
    for (var i = 1; i < steps.length; i++) {
      steps[i].intro = '<h3 class="title"><i>' + (i + 1) + '</i>' + steps[i].titleStr + '</h3><p>' + steps[i].introStr + '</p>';
    }
    ;
    intro.setOptions({
      nextLabel: BabelStr.str(3139),
      prevLabel: BabelStr.str(652),
      skipLabel: BabelStr.str(156),
      doneLabel: BabelStr.str(156),
      exitOnEsc: true,
      tooltipClass: "intro-tooltip-panel",
      keyboardNavigation: true,
      showStepNumbers: false,
      disableInteraction: true,
      showBullets: false,
      steps: steps
    });
    intro.start();
  },
  introEditor: function introEditor() {
    var list = [{
      intro: "<h3 class='title'><i>1</i>" + BabelStr.str(7091) + "</h3><p>" + BabelStr.str(7092) + "</p>"
    }];
    if ($('.p-tool-commentList').css('display') != 'none') {
      list.push({
        element: $('.p-tool-commentList')[0],
        intro: "<h3 class='title'><i></i>" + BabelStr.str(7093) + "</h3><p>" + BabelStr.str(7094) + "</p>"
      });
    }
    ;
    var changer = [{
      position: 'bottom-middle-aligned',
      element: $('.p-tool-fileName')[0],
      intro: "<h3 class='title'><i></i>" + BabelStr.str(7087) + "</h3><p>" + BabelStr.str(7095) + "</p>"
    }
    // , {
    //   position: 'bottom-middle-aligned',
    //   element: $('.p-tool-nextFile')[0],
    //   intro: "<h3 class='title'><i></i>文档切换</h3><p>切换文档 - 查看同一个文件夹中的下一个文档</p>"
    // }
    ];
    if ($('.p-tool-fileChanger').css('display') != 'none') {
      list = list.concat(changer);
    }
    ;
    var intros = [{
      id: 'rotateButton',
      intro: "<h3 class='title'><i></i>" + BabelStr.str(6055) + "</h3><p>" + BabelStr.str(7096) + "</p>"
    }, {
      id: 'compareButton',
      intro: "<h3 class='title'><i></i>" + BabelStr.str(746) + "</h3><p>" + BabelStr.str(7097) + "</p>"
    }, {
      id: 'printButton',
      intro: "<h3 class='title'><i></i>" + BabelStr.str(730) + "</h3><p>" + BabelStr.str(7098) + "</p>"
    }, {
      id: 'shareButton',
      intro: "<h3 class='title'><i></i>" + BabelStr.str(13) + "</h3><p>" + BabelStr.str(7099) + "</p>"
    }, {
      id: 'version-btn',
      intro: "<h3 class='title'><i></i>" + BabelStr.str(7062) + "</h3><p>" + BabelStr.str(7100) + "</p>"
    }, {
      id: 'download',
      intro: "<h3 class='title'><i></i>" + BabelStr.str(29) + "</h3><p>" + BabelStr.str(7101) + "</p>"
    }, {
      id: 'visibility',
      intro: "<h3 class='title'><i></i>" + BabelStr.str(7102) + "</h3><p>" + BabelStr.str(7103) + "</p>"
    }, {
      id: 'fullButton',
      intro: "<h3 class='title'><i></i>" + BabelStr.str(236) + "</h3><p>" + BabelStr.str(7104) + "</p>"
    }

    // { id: 'commentButton', intro: "<h3 class='title'><i></i>新建批注</h3><p>可以在文档的任意位置点击建立批注</p>" },
    ];
    var editTool = [];
    var position = "bottom-middle-aligned";
    for (var i = 0; i < intros.length; i++) {
      var introInfo = intros[i];
      var $tool = $('#' + introInfo.id);
      if ($tool.parent().css('display') == 'none') {
        continue;
      }
      ;
      if ($tool.length > 0 && $tool.parent().find('button').css('display') != 'none') {
        if (introInfo.id == "version-btn" || introInfo.id == "visibility" || introInfo.id == "helpButton") {
          position = "bottom-right-aligned";
        }
        editTool.push({
          position: position,
          element: $tool[0],
          intro: introInfo.intro
        });
      }
    }
    ;
    list = list.concat(editTool);
    var intro = introJs();
    if (this.intro) {
      this.intro.exit();
    }
    ;
    this.intro = intro;
    intro.setOptions({
      exitOnEsc: true,
      nextLabel: BabelStr.str(3139),
      prevLabel: BabelStr.str(652),
      skipLabel: BabelStr.str(156),
      doneLabel: BabelStr.str(156),
      tooltipClass: "intro-tooltip-panel",
      keyboardNavigation: true,
      showStepNumbers: false,
      showBullets: false,
      disableInteraction: true,
      steps: list
    });
    // 首次的callback滞后于提示面板的显示
    // 第一个锚点需要手工设置顺序 1
    intro.onafterchange(function () {
      var step = this._currentStep;
      var $copy = $(this._introItems[step].intro);
      $copy.find("i").text(step + 1);
      this._introItems[step].intro = $("<div>").append($copy).html();
      console.log(this);
    });
    intro.start();
    _MMNetDiskDataController["default"].setEditorCourseDisplayed();
  },
  introEntManager: function introEntManager() {
    var intros = [{
      id: 'user-manager-content',
      intro: "<h3 class='title'><i></i>" + "<a class=\"blue\" href=\"/enterpriseIndex.do\" target=\"_blank\">".concat(BabelStr.str(381), "</a>") + "</h3><p>" + BabelStr.str(7105) + "<a class=\"blue\"  onclick=\"localStorage.setItem('enterprise-setting-clicked', 1)\" href=\"/enterpriseIndex.do\" target=\"_blank\">".concat(BabelStr.str(381), "</a>") + BabelStr.str(7106) + "</p>"
    }];
    var editTool = [];
    var position = "bottom-right-aligned";
    for (var i = 0; i < intros.length; i++) {
      var introInfo = intros[i];
      var $tool = $('#' + introInfo.id);
      if ($tool.length > 0 && $tool.parent().find('button').css('display') != 'none') {
        if (introInfo.id == "version-btn" || introInfo.id == "visibility" || introInfo.id == "helpButton") {
          position = "bottom-right-aligned";
        }
        editTool.push({
          position: position,
          element: $tool[0],
          intro: introInfo.intro
        });
      }
    }
    ;
    var list = editTool;
    var intro = introJs();
    if (this.intro) {
      this.intro.exit();
    }
    ;
    this.intro = intro;
    intro.setOptions({
      exitOnEsc: true,
      tooltipClass: "intro-manager-panel",
      keyboardNavigation: true,
      showStepNumbers: false,
      showBullets: false,
      showButtons: false,
      disableInteraction: true,
      overlayOpacity: 0,
      steps: list
    });
    intro.start();
  },
  exit: function exit() {
    if (this.intro) {
      this.intro.exit();
    }
    ;
  }
};
window.MDIntro = MDIntro;
var _default = exports["default"] = MDIntro;

},{"1104":1104,"1180":1180,"1184":1184,"1412":1412,"1417":1417,"1432":1432,"1454":1454,"1463":1463,"17":17,"32":32,"734":734}],421:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1541);
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MMViewBase = _interopRequireDefault(require(22));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDCommonFileEditorController = _interopRequireDefault(require(410));
var _MMBasicData = _interopRequireDefault(require(811));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDLoadMaskView = _interopRequireDefault(require(49));
var _MDEvaluationToolbar = _interopRequireDefault(require(470));
/**
 *  file editor view, slide between different files, check comments, add comments
 *   WebContent/javascript/moladisk/views/editor/MDOnlyOfficeEditor.js
 *  Create by jiang
 *  2015.9.9
 */

var MDOnlyOfficeEditor = _MDCommonFileEditorController["default"].extend(function () {
  return {
    el: '<div class="p-editor-root"></div>',
    tmpl: "<div id=\"office-frame\" class=\"office-frame\"></div>\n            <div class=\"only-icon\"/>\n            <button id=\"close-office-btn\" class=\"close-only-btn\"><%=BabelStr.str(5070)%>\n              <span class=\"icon ic-close close-btn\"></span>\n          </button>",
    initProps: function initProps() {
      var superP = _MDCommonFileEditorController["default"].prototype.initProps.call(this);
      return _.extend(superP, {});
    },
    initialize: function initialize(opt) {
      _MDCommonFileEditorController["default"].prototype.initialize.call(this, opt);
      var z_startIndex = _MMBasicData["default"].getO2OStartLayerZ_index();
      this.bindSelf(this._windowResizeHandler);
      $(window).on('resize.fileEditor', _.debounce(this._windowResizeHandler, 500));
      application.addSubView(this);
      $("body").on("keydown.onlyoffice", this.onkeydown);
    },
    events: function events() {
      return {
        'click #close-office-btn': this._closeClicked
      };
    },
    _windowResizeHandler: function _windowResizeHandler() {},
    _forcesave: function _forcesave() {},
    editFile: function editFile(fileInfo, ver) {
      this.fileInfo = fileInfo;
      var self = this;
      if (fileInfo.isWord()) {
        this.$(".only-icon").addClass("word");
        this.$(".close-only-btn").addClass("word");
      } else if (fileInfo.isExel()) {
        this.$(".only-icon").addClass("excel");
        this.$(".close-only-btn").addClass("excel");
      } else {
        this.$(".only-icon").addClass("ppt");
        this.$(".close-only-btn").addClass("ppt");
      }
      var fileId = fileInfo.getFileId();
      var url = '/netdrive/getOnlyOfficeFileEditUrl.do';
      // var url = '/netdrive/getFileEditUrl.do';

      if (ver == undefined || ver == null) {
        ver = fileInfo.getCurVersion();
      }
      this.ver = ver;
      var postData = {};
      postData['fileId'] = fileId;
      postData['version'] = ver;
      _MDSpinnerloaderView["default"].showIn($('.p-editor-root')[0]);
      $.ajax({
        method: 'post',
        url: url,
        data: postData,
        success: function success(responseData, textStatus, jqXHR) {
          if (responseData["success"] === true) {
            var config = responseData["config"];
            if (config) {
              _MDSpinnerloaderView["default"].clearFrom($('.p-editor-root')[0]);
              console.log(config);
              self._displayOnlyOfficeEditor(config);
              self.filekey = config.document.key;
              self.token = config.token;
            } else {
              _MDSpinnerloaderView["default"].clearFrom($('.p-editor-root')[0]);
            }
            self.forceCommand = responseData["forceCommand"];
          } else {
            _MDSpinnerloaderView["default"].clearFrom($('.p-editor-root')[0]);
            var alert = new _MDAlertView["default"]();
            var z_maxIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
            alert.$el.css('z-index', z_maxIndex);
            var title = responseData["msg"];
            if (responseData["code"] == 138) {
              // 文件被锁定
              title = "文件被锁定，无法完成操作，可能有人正在使用客户端编辑此文件，需要等待其编辑完成后，再尝试此操作";
            }
            var msg = '<p class="title">' + title + '</p>';
            alert.show({
              title: BabelStr.str(170),
              message: msg,
              className: 'm-delAlertWin',
              width: MMCommonFun.isInMobile() ? 300 : 470,
              onHide: function onHide() {},
              buttons: [{
                label: BabelStr.str(154),
                type: 'done',
                onClick: function onClick() {
                  self.close(true);
                }
              }]
            });
          }
        }
      });
    },
    onkeydown: function onkeydown() {
      this.fileInfo.onlyOfficeSaved(false);
    },
    _displayOnlyOfficeEditor: function _displayOnlyOfficeEditor(config) {
      var self = this;
      // var config = {
      //   "document": {
      //       "fileType": "xlsx",
      //       "key": "9B9F6EFE8937",
      //       "title": "Example Document Title.xlsx",
      //       "url": editorUrl
      //   },
      //   "documentType": "text",
      //   "editorConfig": {
      //       "callbackUrl": "https://example.com/url-to-callback.ashx"
      //   },

      //   "editorConfig": {
      //     "mode": "view"
      //   },
      //   "height": "100%",
      //   "width": "100%"
      // };

      // 追加监听消息！
      var events = {
        "onDocumentStateChange": function onDocumentStateChange(status) {
          // MDSnackbarView.show("document changed! -" + status.data);
          if (status.data) {
            self.fileInfo.onOnlyOfficeEdited();
            var postData = {
              fileId: self.fileInfo.getFileId()
            };
            var url = "/netdrive/setDocEditedByOnlyOffice.do";
            $.ajax({
              method: 'post',
              url: url,
              data: postData,
              success: function success(responseData, textStatus, jqXHR) {}
            });
          }
        }
      };
      config.events = events;
      window.docEditor = new DocsAPI.DocEditor("office-frame", config);
      MMNetDiskDataController.clearFilesUnreadMarks([this.fileInfo]);
      var fileId = this.fileInfo.getFileId();
      var usrId = app.currentUser.id;
      MMNetDiskDataController.addFileAccessUser(fileId, usrId, function () {}, function () {});
    },
    _closeClicked: function _closeClicked(e) {
      var self = this;
      var closeOnlyUrl = location.protocol + "//" + window.onlyOfficeDocServer + "/coauthoring/CommandService.ashx";
      var postData = {
        "c": "forcesave",
        "key": this.filekey,
        "token": this.token,
        "userdata:": "force save " + new Date()
      };
      // var postData = this.forceCommand;
      $.ajax({
        method: 'post',
        dataType: "json",
        contentType: "application/json;charset=utf-8",
        url: closeOnlyUrl,
        data: postData,
        success: function success(responseData, textStatus, jqXHR) {
          // MDSnackbarView.show(responseData);
          self._closeClicked2();
        }
      });
      // this._closeClicked2(e);
    },
    _closeClicked2: function _closeClicked2(e) {
      $("body").click();
      var self = this;
      var _closeFunc = function _closeFunc() {
        window.docEditor.destroyEditor();
        self.close();
        if (self.fileInfo.hasChangedByOnlyOffice()) {
          var timeoutFunc = null;
          var count = 0;
          var updateFileInfoFunc = function updateFileInfoFunc() {
            count++;
            if (timeoutFunc) {
              clearTimeout(timeoutFunc);
            }
            timeoutFunc = setTimeout(function () {
              MMNetDiskDataController.getFileInfoFromServer(self.fileInfo.getFileId(), function (info) {
                self.fileInfo.initBy(info);
                if (!self.fileInfo.isVersionUpdatedAfterOnlyOffice() && count < 10) {
                  updateFileInfoFunc();
                } else {}
              }, function () {
                if (count < 10) {
                  updateFileInfoFunc();
                }
              });
              _MDLoadMaskView["default"].remove();
            }, 1000 * 10);
          };
          updateFileInfoFunc();
        }
      };
      if (true || this.fileInfo.isOnlyOfficeSaved()) {
        setTimeout(_closeFunc);
      } else {
        _MDAlertView["default"].showStandardSelection({
          title: BabelStr.str(7145),
          message: BabelStr.str(7146),
          okStr: BabelStr.str(7147),
          okFun: function okFun() {
            _closeFunc();
          },
          cancelStr: BabelStr.str(155),
          cancelFun: function cancelFun() {}
        });
      }
    },
    close: function close(notUpdate) {
      $("body").off("keydown.onlyoffice");
      var self = this;
      if (notUpdate) {
        self.removeFromSuperView();
        if (self.callback) {
          self.callback();
        }
        ;
        return;
      }
      ;
      self.removeFromSuperView();
      var fileEditor = viewManager.get('fileEditor');
      fileEditor && fileEditor.close();
    },
    viewWillUnRendered: function viewWillUnRendered() {
      _MDCommonFileEditorController["default"].prototype.viewWillUnRendered.call(this);
    }
  };
}());
var _default = exports["default"] = MDOnlyOfficeEditor;

},{"1184":1184,"1437":1437,"1454":1454,"1541":1541,"22":22,"32":32,"410":410,"470":470,"49":49,"72":72,"76":76,"811":811}],420:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MMViewBase = _interopRequireDefault(require(22));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDCommonFileEditorController = _interopRequireDefault(require(410));
var _MMBasicData = _interopRequireDefault(require(811));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDEvaluationToolbar = _interopRequireDefault(require(470));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
/**
 *  file editor view, slide between different files, check comments, add comments
 *  Create by jiang
 *  2015.9.9
 */

var MDOfficeOnlineEditor = _MDCommonFileEditorController["default"].extend(function () {
  return {
    el: '<div class="p-editor-root"></div>',
    tmpl: "<iframe id=\"office-frame\" class=\"office-frame\"></iframe>\n            <button id=\"close-office-btn\" class=\"close-office-btn\" style=\"width:100px\"><%=BabelStr.str(156)%>\n            <span class=\"icon ic-close close-btn\"></span>\n          </button>",
    initProps: function initProps() {
      var superP = _MDCommonFileEditorController["default"].prototype.initProps.call(this);
      return _.extend(superP, {});
    },
    initialize: function initialize(opt) {
      _MDCommonFileEditorController["default"].prototype.initialize.call(this, opt);
      var z_startIndex = _MMBasicData["default"].getO2OStartLayerZ_index();
      this.bindSelf(this._windowResizeHandler);
      $(window).on('resize.fileEditor', _.debounce(this._windowResizeHandler, 500));
      application.addSubView(this);
    },
    events: function events() {
      return {
        'click #close-office-btn': this._closeClicked
      };
    },
    _windowResizeHandler: function _windowResizeHandler() {},
    editFile: function editFile(fileInfo, ver) {
      this.fileInfo = fileInfo;
      var self = this;
      var fileId = fileInfo.getFileId();
      var url = '/netdrive/getOfficeOnlineViewUrl.do';
      // var url = '/netdrive/getFileEditUrl.do';

      if (ver == undefined || ver == null) {
        ver = fileInfo.getCurVersion();
      }
      this.ver = ver;
      var postData = {};
      postData['fileId'] = fileId;
      postData['version'] = ver;
      _MDSpinnerloaderView["default"].showIn($('.p-editor-root')[0]);
      $.ajax({
        method: 'post',
        url: url,
        data: postData,
        success: function success(responseData, textStatus, jqXHR) {
          if (responseData["success"] === true) {
            var url = responseData["url"];
            if (url) {
              _MDSpinnerloaderView["default"].clearFrom($('.p-editor-root')[0]);
              console.log(url);
              self._displayOfficeOnlineEditor(url);
            } else {
              _MDSpinnerloaderView["default"].clearFrom($('.p-editor-root')[0]);
            }
          } else {
            _MDSpinnerloaderView["default"].clearFrom($('.p-editor-root')[0]);
            var alert = new _MDAlertView["default"]();
            var z_maxIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
            alert.$el.css('z-index', z_maxIndex);
            var title = responseData["msg"];
            var msg = '<p class="title">' + title + '</p>';
            alert.show({
              title: BabelStr.str(170),
              message: msg,
              className: 'm-delAlertWin',
              width: MMCommonFun.isInMobile() ? 300 : 470,
              onHide: function onHide() {},
              buttons: [{
                label: BabelStr.str(154),
                type: 'done',
                onClick: function onClick() {
                  self.close(true);
                }
              }]
            });
          }
        }
      });
    },
    _displayOfficeOnlineEditor: function _displayOfficeOnlineEditor(url) {
      this.$("#office-frame").attr("src", url);
      _MMNetDiskDataController["default"].clearFilesUnreadMarks([this.fileInfo]);
      var fileId = this.fileInfo.getFileId();
      var usrId = app.currentUser.id;
      _MMNetDiskDataController["default"].addFileAccessUser(fileId, usrId, function () {}, function () {});
    },
    _closeClicked: function _closeClicked(e) {
      this.close();
    },
    close: function close(notUpdate) {
      var self = this;
      if (notUpdate) {
        self.removeFromSuperView();
        if (self.callback) {
          self.callback();
        }
        ;
        return;
      }
      ;
      self.removeFromSuperView();
      var fileEditor = viewManager.get('fileEditor');
      fileEditor && fileEditor.close();
    },
    viewWillUnRendered: function viewWillUnRendered() {
      _MDCommonFileEditorController["default"].prototype.viewWillUnRendered.call(this);
    }
  };
}());
var _default = exports["default"] = MDOfficeOnlineEditor;

},{"1104":1104,"1184":1184,"1454":1454,"22":22,"32":32,"410":410,"470":470,"72":72,"76":76,"811":811}],470:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMBasicData = _interopRequireDefault(require(811));
var _Dispatcher = _interopRequireDefault(require(18));
var _MMViewBase = _interopRequireDefault(require(22));
// MD3DToolbar.js
// jiang
// 2016-10-23

var MDEvaluationToolbar = _MMViewBase["default"].extend({
  el: '<button class="toolbar-eval" class="tool-bar"></button>',
  tmpl: '<div class="p-evl-toolbar">' + BabelStr.str(7163) + '</div>',
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      editor: null
    });
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      "click ": this._showListPanel
    });
  },
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    var z_startIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
    $(this.el).css('z-index', z_startIndex);
    _Dispatcher["default"].on(MDEvents.OpenEvalListPanel, this.hide, this);
    _Dispatcher["default"].on(MDEvents.OpenEvalToolbar, this.showToolbar, this);
  },
  setEditorViewCtl: function setEditorViewCtl(editorViewCtl) {
    this.editorViewCtl = editorViewCtl;
  },
  _showListPanel: function _showListPanel() {
    this.$el.hide();
    _Dispatcher["default"].trigger(MDEvents.OpenEvalListPanel, {
      editorViewCtl: this.editorViewCtl
    });
  },
  showToolbar: function showToolbar(opt) {
    if (opt && opt.editorViewCtl != this.editorViewCtl) {
      return;
    }
    this.$el.show();
  },
  hide: function hide(opt) {
    if (opt && opt.editorViewCtl != this.editorViewCtl) {
      return;
    }
    this.$el.hide();
  }
}, {
  className: 'MDEvaluationToolbar'
});
var _default = exports["default"] = MDEvaluationToolbar;

},{"1184":1184,"1454":1454,"18":18,"22":22,"811":811}],412:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1450);
require(1436);
require(1546);
var _MDAlertView = _interopRequireDefault(require(32));
var _MDDownload4Mobile = _interopRequireDefault(require(447));
var _MMBasicData = _interopRequireDefault(require(811));
var _MDLoadMaskView = _interopRequireDefault(require(49));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDMobileFileEditorController = _interopRequireDefault(require(451));
var _MMFileInfo = _interopRequireDefault(require(297));
/**
 *  file display controller, open the file to display in the editor
 *  Create by jiang
 *  2015.10.15
 */

var MDDownloadFileController = {
  downloadFileWithFileInfo: function downloadFileWithFileInfo(fileInfo, callback) {
    var fid = fileInfo.get("fileId");
    var fver = -1;
    // var fver = fileInfo.getCurVersion();
    var fname = fileInfo.getFileName();
    MDDownloadFileController._downloadFileWithFileAndVersion(fid, fver, fname, fileInfo, function finished() {
      callback && callback();
    }, function process() {
      callback && callback();
    });

    // 清除未读文档标记
    _MMNetDiskDataController["default"].clearFileVersionUnreadMark(fileInfo);
  },
  downloadFileWithFileIds: function downloadFileWithFileIds(ids, callback) {
    MMCommonFun.downloadOriginFile(ids, -1, "", function () {
      callback && callback();
    }, function () {
      callback && callback();
    });
  },
  downloadFileForEditor: function downloadFileForEditor(editor) {
    if (!editor) {
      return;
    }
    var board = editor.getCurrentBoard();
    if (!board) {
      return;
    }
    var alert = new _MDAlertView["default"]();
    var z_startIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
    $(alert.el).css("z-index", z_startIndex);
    var fileInfo = board.getFileInfo();
    var size = (fileInfo.get("currentVersionSize") / (1024 * 1024)).toFixed(2);
    var title = BabelStr.str(5037) + "（" + size + "M）？";
    alert.show({
      title: BabelStr.str(170),
      message: '<p class="title">' + title + "</p>",
      className: "m-delAlertWin",
      buttons: [{
        label: BabelStr.str(29),
        onClick: function onClick() {
          var fid = board.getStringId();
          var fver = editor.getVersionShowing();
          var fname = board.getDisplayName();
          var editorCtl = _MDMobileFileEditorController["default"].get();
          MMCommonFun.downloadOriginFile(fid, fver, fname, function finished() {
            if (editorCtl) {
              editorCtl.hideProgressBar();
            }
          }, function process(p) {
            if (editorCtl) {
              editorCtl.showProgressBar(p);
            }
          });
        }
      }, {
        label: BabelStr.str(5038),
        onClick: function onClick() {}
      }]
    });
  },
  downloadFileWithVerInfo: function downloadFileWithVerInfo(verInfo, callback) {
    var fid = verInfo.get("fileId");
    var fver = verInfo.get("ver");
    var fname = verInfo.getFileName();
    if (MDDownloadFileController.downloading) {
      return;
    }
    if (app.currentUser && !app.currentUser.logined() && app.isInClient()) {
      verInfo.set("toDownloadVer", fver);
      window.downloadPanelforAnonymousShareView.pushFiles([verInfo]);
      return;
    }
    if (app.isInClient()) {
      var electron = window["ElectronRequire"]("electron");
      var download = electron.remote.require("./utils/cppAPI").downloadFile;
      if (download) {
        MMEnterpriseController.isIpAllowDownload(fid, function () {
          app.getDownloadFileTargetForClient([verInfo], function (path) {
            var result = [];
            result.push({
              fileId: fid,
              fileName: fname,
              fileSize: verInfo.get("fileSize") || verInfo.get("currentVersionSize") || 1,
              isFolder: verInfo.isFolder(),
              version: fver
            });
            download(result, path);
          });
        }, function (err) {
          _MDAlertView["default"].showStandardPrompt({
            message: err.msg
          });
        });
        return;
      }
    }
    // MDDownloadFileController.downloading = true;

    // var loadingView = new MDLoadMaskView();
    // loadingView.show();
    // var that = MDDownloadFileController;
    // setBabelTimeout(function() {
    //   that.downloading = false;
    //   loadingView.remove();
    // }, 2000);
    // MDDownloadFileController._downloadFileWithFileAndVersion(fid, fver, fname, verInfo.get('fileInfo'), function finished() {
    // }, function process() {
    // });
    MDDownloadFileController._downloadFileWithVer(fid, fver, fname, verInfo.get("fileInfo"), callback);
    // 清除未读文档标记
    verInfo.clearUnReadCount();
    _MMNetDiskDataController["default"].clearFileVersionUnreadMark(verInfo.get("fileInfo"), verInfo);
  },
  _downloadFileWithVer: function _downloadFileWithVer(fid, fver, fname, fileInfo, callback) {
    if (MDDownloadFileController.downloading) {
      return;
    }
    MDDownloadFileController.downloading = true;
    var loadingView = new _MDLoadMaskView["default"]();
    loadingView.show();
    var that = MDDownloadFileController;
    setBabelTimeout(function () {
      that.downloading = false;
      loadingView.remove();
    }, 2000);
    setBabelTimeout(function () {
      MDDownloadFileController._downloadFileWithFileAndVersion(fid, fver, fname, fileInfo, function finished() {
        callback && callback();
      }, function process() {
        callback && callback();
      });
    }, 10);
  },
  _downloadFileWithFileAndVersion: function _downloadFileWithFileAndVersion(fid, fver, fname, fileinfo, finished, process) {
    var self = this;
    if (fver == -1 && fileinfo.isOfficeFile() && !fileinfo.get("doNotOnlyoffice")) {
      var url = "/netdrive/isDocEditedByOnlyOffice.do";
      var postData = {
        fileId: fileinfo.getFileId()
      };
      $.ajax({
        method: "post",
        dataType: "json",
        url: url,
        data: postData,
        success: function success(responseData, textStatus, jqXHR) {
          if (responseData["success"] === true) {
            var isEditing = responseData["isEditing"];
            if (isEditing) {
              _MDAlertView["default"].showDangerSelection({
                message: BabelStr.str(21306),
                okStr: BabelStr.str(21307),
                okFun: function okFun() {
                  self._execDownloadFileWithFileAndVersion(fid, fver, fname, fileinfo, finished, process);
                }
              });
            } else {
              self._execDownloadFileWithFileAndVersion(fid, fver, fname, fileinfo, finished, process);
            }
          }
        }
      });
    } else {
      this._execDownloadFileWithFileAndVersion(fid, fver, fname, fileinfo, finished, process);
    }
  },
  _execDownloadFileWithFileAndVersion: function _execDownloadFileWithFileAndVersion(fid, fver, fname, fileinfo, finished, process) {
    if (!app.canDispInNormalBrowser()) {
      if (app.isFromWechat()) {
        // var userBrowser = BabelStr.str(5039, {type: 'safari'});
        // if (!MMCommonFun.isIOSDevice()) {
        var userBrowser = BabelStr.str(5040);
        // };

        var $dispDlg = $("<div class='wc-download-root'>" + "<div class='wc-download-dlg'>" + "<div class='wc-download-title'>" + BabelStr.str(5041) + ":" + userBrowser + "</div>" + "<div class='wc-download-arrow'></div>" + "</div>" + "</div>");
        var $body = $("body");
        $body.append($dispDlg);
        var z_startIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
        $dispDlg.css("z-index", z_startIndex);
        $dispDlg.click(function (e) {
          $dispDlg.remove();
        });
      } else {
        _MDDownload4Mobile["default"].downloadFile(fid, fver, fname, fileinfo);
      }
    } else {
      var fileJson;
      if (fileinfo) {
        fileJson = fileinfo.toJSON();
        fileJson.toDownloadVer = fver;
      } else {
        fileJson = {
          toDownloadVer: fver,
          fileName: fname,
          fileId: fid
        };
      }
      window.downloadPanelView.pushFiles([new _MMFileInfo["default"](fileJson)]);
      // MMCommonFun.downloadOriginFile(fid, fver, fname, finished, process);
    }
  }
};
var _default = exports["default"] = MDDownloadFileController;

},{"1104":1104,"1184":1184,"1436":1436,"1450":1450,"1454":1454,"1546":1546,"297":297,"32":32,"447":447,"451":451,"49":49,"811":811}],447:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDSnackbarView = _interopRequireDefault(require(72));
//
//  jiang
//  2015-11-18
//

var MDDownload4Mobile = {
  downloadFile: function downloadFile(fid, fver, fname, fileinfo) {
    MMCommonFun.getDownloadRealPath(fid, fver, function (downloadPath) {
      var dispPath = "";
      var fileType = 'commonFile';
      if (fileinfo.canDispInEditor()) {
        if (fileinfo.isImage()) {
          fileType = 'image';
        } else {
          fileType = 'document';
        }
      }
      ;
      switch (fileType) {
        case "image":
          dispPath = MMCommonFun.getImageDispPath(fid, fver);
          MDDownload4Mobile._downloadImageFile(dispPath, downloadPath);
          break;
        case "document":
          dispPath = MMCommonFun.getDocumentDispPath(fid, fver);
          MDDownload4Mobile._downloadImageFile(dispPath, downloadPath);
          break;
        default:
          MDDownload4Mobile._downloadNoneDispFile(fname, fileinfo.get('currentVersionSize'), downloadPath);
      }
    }, function errorCallback(response) {
      if (response && response.success == false && response['msg']) {
        if (response['code'] == '10006') {
          response['msg'] = BabelStr.str(5542);
        }
        _MDSnackbarView["default"].show(response['msg']);
      }
    });

    // MMCommonFun.downloadOriginFile(fid, fver, fname);
  },
  _downloadImageFile: function _downloadImageFile(dispPath, downloadPath) {
    // var link = document.createElement('a');
    // link.href = downloadPath;
    // link.target = "_top";
    // var body = document.getElementsByTagName('body')[0];
    // body.appendChild(link);
    // var e = document.createEvent('MouseEvents');
    // e.initEvent('click', true, true);
    // link.dispatchEvent(e);

    // link.onload=function(){
    //   console.log('-----------> loaded')
    // }

    window.location = downloadPath;
  },
  _downloadNoneDispFile: function _downloadNoneDispFile(fileName, fileSize, downloadPath) {
    MDDownload4Mobile._downloadImageFile("", downloadPath);
  }
};
var _default = exports["default"] = MDDownload4Mobile;

},{"1184":1184,"1454":1454,"72":72}],410:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMViewBase = _interopRequireDefault(require(22));
var _MDLoadMaskView = _interopRequireDefault(require(49));
var _MMWhiteboardController = _interopRequireDefault(require(1109));
var _MDSnackbarView = _interopRequireDefault(require(72));
/**
 *  file editor view, slide between different files, check comments, add comments
 *  Create by jiang
 *  2015.11.5
 */

//
//  类继承关系图(< 代表继承):
//
//  MDCommonFileEditorController
//      |
//      |<--- MDPCFileEditorController
//      |
//      |<--- MDMobileFileEditorController
//
//

var MDCommonFileEditorController = _MMViewBase["default"].extend({
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      onClose: _.noop,
      pageInfos: [],
      versionFileInfo: null
    });
  },
  hasFile: function hasFile(fid) {
    var found = false;
    for (var i = 0; i < this.pageInfos.length; i++) {
      var fileInfo = this.pageInfos[i];
      if (fileInfo.get("fileId") == fid) {
        found = true;
        break;
      }
      ;
    }
    ;
    if (!found) {
      if (this.versionFileInfo && this.versionFileInfo.getFileId() == fid) {
        found = true;
      }
      ;
    }
    ;
    return found;
  },
  getFileInfoById: function getFileInfoById(fid) {
    var rt = null;
    for (var i = 0; i < this.pageInfos.length; i++) {
      var fileInfo = this.pageInfos[i];
      if (fileInfo.get("fileId") == fid) {
        rt = fileInfo;
        break;
      }
      ;
    }
    ;
    if (!rt) {
      if (this.versionFileInfo && this.versionFileInfo.getFileId() == fid) {
        rt = this.versionFileInfo.get('fileInfo');
      }
      ;
    }
    ;
    return rt;
  },
  openBoards: function openBoards(fileInfos, curFileInfo, successCall, failCall) {
    if (this.editor) {
      this.editor.removeFromSuperView();
    }
    ;
    var self = this;
    this.progress = 0.0;
    this.pageInfos = fileInfos;
    this.versionDisplay = false;
    self.showProgressBar(0);
    var pgCount = fileInfos.length;
    var curPg = 0;
    for (var i = 0; i < fileInfos.length; i++) {
      if (fileInfos[i] == curFileInfo) {
        curPg = i;
        break;
      }
    }
    ;
    self.topToolBar.displayPageInfo(curPg + 1, pgCount, curFileInfo.get("fileId"), curFileInfo.getFileName());
    _MDLoadMaskView["default"].show();
    _MMWhiteboardController["default"].openWhiteboardsByFiles(fileInfos, function success(boardsOpened) {
      _MDLoadMaskView["default"].remove();
      self.pgCount = boardsOpened.length;
      self.curPg = -1;
      for (var i = 0; i < boardsOpened.length; i++) {
        if (boardsOpened[i].getStringId() == curFileInfo.getFileId()) {
          self.curPg = i;
          break;
        }
      }
      if (self.curPg != -1) {
        if (successCall) {
          successCall(boardsOpened);
        }
      } else {
        _MDSnackbarView["default"].show(BabelStr.str(5157));
        if (failCall) {
          failCall();
        }
      }
    }, function failed() {
      _MDSnackbarView["default"].show(BabelStr.str(5157));
      if (failCall) {
        failCall();
      }
      ;
    }, function progress(ratio) {
      self.showProgressBar(ratio);
    });
  },
  openSingleBoard: function openSingleBoard(fileInfo, version, successCall, failCall) {
    if (this.editor) {
      this.editor.removeFromSuperView();
    }
    ;
    var self = this;
    this.versionDisplay = true;
    this.progress = 0.0;
    this.versionFileInfo = fileInfo;
    self.showProgressBar(0);
    _MDLoadMaskView["default"].show();
    _MMWhiteboardController["default"].openWhiteboardsByFiles([fileInfo], function success(boardsOpened) {
      _MDLoadMaskView["default"].remove();
      if (boardsOpened.length == 0) {
        _MDSnackbarView["default"].show(BabelStr.str(5157));
        if (failCall) {
          failCall();
        }
        ;
      } else {
        boardsOpened[0].setVersionShowing(version);
        self.topToolBar.displayPageInfo(0, 0, fileInfo.getFileName());
        if (successCall) {
          successCall(boardsOpened);
        }
        ;
      }
    }, function failed() {
      _MDLoadMaskView["default"].remove();
      _MDSnackbarView["default"].show(BabelStr.str(5157));
    }, function progress(ratio) {
      self.showProgressBar(ratio);
    });
  }
});
var _default = exports["default"] = MDCommonFileEditorController;

},{"1109":1109,"1184":1184,"1454":1454,"22":22,"49":49,"72":72}],411:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1541);
var _MMDClass = _interopRequireDefault(require(813));
var _MDWaitingConvertionView = _interopRequireDefault(require(34));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDCheckStatusFromServer = _interopRequireDefault(require(33));
var _MDUpdatePromptWindowView = _interopRequireDefault(require(525));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDMessageView = _interopRequireDefault(require(55));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDClientDownloadWinView = _interopRequireDefault(require(484));
/**
 *  file display controller, open the file to display in the editor
 *  Create by jiang
 *  2015.10.15
 */

var MDDisplayFileController = function MDDisplayFileController() {};
_.extend(MDDisplayFileController.prototype, {
  constructor: MDDisplayFileController,
  _checkFromServer: function _checkFromServer(fileInfo, fileVersion, success, fail) {
    _MDCheckStatusFromServer["default"].checkFromServer(fileInfo, fileVersion, success, fail);
  },
  _showUpgradeEditionPrompt: function _showUpgradeEditionPrompt(str) {
    var alert = new _MDUpdatePromptWindowView["default"]({
      title: BabelStr.str(5067),
      content: str
    });
    alert.show();
  },
  /**
   * 检测当前fileInfor是否能够打开
   * @param  {MMFileInfor}   fileInfo 文件信息
   * @param  {Number}   verInfo  文件版本
   * @param  {Function} callback(canOpen) 回调处理
   */
  checkToAlertCannotDisp: function checkToAlertCannotDisp(param, callback) {
    var fileInfo = param.fileInfo;
    var verInfo = param.verInfo;
    var self = this;
    var file = fileInfo;
    if (fileInfo.isShortcuts()) {
      file = fileInfo.getShortCutsTargetFile();
    }
    var ver = -1;
    if (verInfo) {
      ver = verInfo.getVersion();
    } else if (param.fileVersion != undefined) {
      ver = param.fileVersion;
    }
    var fid = file.getFileId();
    // if (file.isCADFile() && app.currentUser.isCadSupport()) {
    //   app.pathRouter.openNetTab(
    //     "/netdrive/openFileByGStarCAD.do?fileId=" + fid + "&version=" + ver
    //   );
    //   return;
    // }
    if (app.ep.isClosedViewVideo() && fileInfo.isVideoDirectlyPlay()) {
      _MDAlertView["default"].showStandardPrompt({
        message: BabelStr.str(40072)
      });
      return;
    } else if (fileInfo.isVideoDirectlyPlay() || fileInfo.isAudioDirectlyPlay()) {
      callback(true);
      return;
    } else if (fileInfo.isVideo() && !fileInfo.isMp4()) {
      _MDAlertView["default"].showStandardPrompt({
        title: BabelStr.str(170),
        message: BabelStr.str(21519)
      });
      return;
    }
    this._wasEditedByOnlyOffice(fileInfo, function () {
      var alert;
      // 关于cad 预览
      // 网页端   公有云  用浩辰打开

      //         私有云   支持浩辰 》 用浩辰打开
      //                 不支持 ？ 弹新提示       以前提示客户端打开

      // 客户端   公有云  用浩辰打开

      //         私有云   支持浩辰 》 用浩辰打开
      //                 不支持 ？
      //                      老版本客户端  用swf和pdf方式打开
      //                      新版客户端  弹新提示
      if (!app.isInClient() && app.ep.isPrivateCloud() && !app.currentUser.isCadSupport() && fileInfo.isCADFile()) {
        _MDAlertView["default"].showStandardPrompt({
          message: BabelStr.str(21946)
        });
        return;
      } else if (app.isInClient() && app.ep.isPrivateCloud() && !app.currentUser.isCadSupport() && fileInfo.isCADFile()) {
        var version = window['ElectronRequire']('electron').remote.require('./package.json').version;
        if (version.split(".")[0] >= 7) {
          _MDAlertView["default"].showStandardPrompt({
            message: BabelStr.str(22013)
          });
        }
        return;
      }

      // if (
      //   !app.isInClient() &&
      //   fileInfo.isCADFile() &&
      //   !app.currentUser.isCadSupport() &&
      //   !(app.ep.isPrivateCloud() && app.isShareApp)
      // ) {
      //   var downloadWin = new MDClientDownloadWinView({
      //     title: BabelStr.str(4747),
      //   });
      //   downloadWin.show();
      //   _.isFunction(callback) && callback(false);
      //   return;
      // }
      if (_.isFunction(verInfo)) {
        callback = verInfo;
        verInfo = null;
      }
      if (!fileInfo.canRead()) {
        var msg = "<p class=\"title\">".concat(BabelStr.str(5068), "</p>");
        if (fileInfo.isArchived()) {
          msg = BabelStr.str(782); // 归档文件需要借阅后才能查看
        }
        var opt = {
          title: BabelStr.str(5067),
          message: msg
        };
        _MDAlertView["default"].showStandardPrompt(opt);
        _.isFunction(callback) && callback(false);
        return;
      }
      if (!fileInfo.isVersionUpdatedAfterOnlyOffice()) {
        _MDAlertView["default"].showStandardPrompt({
          message: BabelStr.str(6149),
          okStr: BabelStr.str(3604)
        });
      }

      // if (fileInfo.isInTrash() && !app.pathRouter.inTrash()) {
      //   alert = new MDAlertView();
      //   alert.show({
      //     title: BabelStr.str(5067),
      //     message: `<p class="title">${BabelStr.str(552)}</p>`,
      //     className: 'm-delAlertWin',
      //     buttons: [{
      //       label: BabelStr.str(156)
      //     }]
      //   });
      //   _.isFunction(callback) && callback(false);
      //   return;
      // };

      callback = _.isFunction(callback) ? callback : _.noop;
      if (fileInfo.canDispWithTextBrowser() || fileInfo.canDispWithKityMinder() || fileInfo.isBabelOffice()) {
        callback(true);
        return;
      }
      if (!(!app.canDispInNormalBrowser() && fileInfo.canDispInOpenGL()) && (fileInfo.canDispInEditor() || app.canDispInNormalBrowser() && fileInfo.canDispInOpenGL())) {
        var target = fileInfo;
        var ver = -1;
        if (verInfo) {
          target = verInfo;
          ver = verInfo.getVersion();
        } else if (param.fileVersion != undefined) {
          ver = param.fileVersion;
        }
        var fileId = fileInfo.getFileId();
        // if (fileInfo.isShortcuts()) {
        //   fileId = fileInfo.getShortCutsTargetFileId();
        // };

        self._checkFromServer(fileInfo, ver, function (isOk) {
          fileInfo.clearUnReadCount();
          // var isOk = target.isFileStatusOK();
          if (isOk) {
            callback(true);
          } else {
            callback(false);
          }
        }, function () {
          _.isFunction(callback) && callback(false);
        });
      } else {
        if (!param.disableAlert) {
          alert = new _MDAlertView["default"]();
          alert.show({
            title: BabelStr.str(170),
            message: "<p class=\"title\">".concat(BabelStr.str(5069), "</p>"),
            className: "m-delAlertWin",
            buttons: [{
              label: BabelStr.str(154)
            }]
          });
        }
        _.isFunction(callback) && callback(false);
      }
    });
  },
  // _alertFileStatus: function(fileInfo) {
  //   var des = fileInfo.getFileStatusDes();
  //   var alert = new MDAlertView();
  //   var width = app.canDispInNormalBrowser() ? 500 : 300;
  //   alert.show({
  //     title: '打开文件失败',
  //     message: '<p class="title">' + des + '</p>',
  //     className: 'm-delAlertWin',
  //     width: width,
  //     buttons: [{
  //       label: '关闭'
  //     }]
  //   });
  // },

  _includeFile: function _includeFile(fileList, fileId) {
    for (var i = 0; i < fileList.length; i++) {
      var fileInfo = fileList[i];
      if (fileInfo.getFileId() == fileId) {
        return true;
      }
    }
    return false;
  },
  isEditorDisplaying: function isEditorDisplaying() {
    return !!viewManager.get("fileEditor");
  },
  hasFile: function hasFile(fileId) {
    if (MDDisplayFileController.editor) {
      return MDDisplayFileController.editor.hasFile(fileId);
    }
    return false;
  },
  /**
   * To be override by sub class
   *
   * @param  {[type]} fileInfo [description]
   * @param  {[type]} version  [description]
   * @param  {[type]} closeCb  [description]
   * @return {[type]}          [description]
   */
  openFileWithoutRouter: function openFileWithoutRouter(fileInfo, version, closeCb) {},
  _wasEditedByOnlyOffice: function _wasEditedByOnlyOffice(fileInfo, callback) {
    if (fileInfo.isOfficeFile() && window.canUseOnlyOffice) {
      var url = "/netdrive/isDocEditedByOnlyOffice.do";
      var postData = {
        fileId: fileInfo.getFileId()
      };
      $.ajax({
        method: "post",
        dataType: "json",
        // contentType: "application/json;charset=utf-8",
        url: url,
        data: postData,
        success: function success(responseData, textStatus, jqXHR) {
          if (responseData["success"] === true) {
            var isEditing = responseData["isEditing"];
            if (isEditing) {
              fileInfo.onOnlyOfficeEdited();
              var timeoutFunc = null;
              var count = 0;
              var updateFileInfoFunc = function updateFileInfoFunc() {
                count++;
                if (timeoutFunc) {
                  clearTimeout(timeoutFunc);
                }
                timeoutFunc = setTimeout(function () {
                  _MMNetDiskDataController["default"].getFileInfoFromServer(fileInfo.getFileId(), function (info) {
                    fileInfo.initBy(info);
                    if (!fileInfo.isVersionUpdatedAfterOnlyOffice() && count < 10) {
                      updateFileInfoFunc();
                    } else {}
                  }, function () {
                    if (count < 10) {
                      updateFileInfoFunc();
                    }
                  });
                  MDLoadMaskView.remove();
                }, 1000 * 10);
              };
              updateFileInfoFunc();
            }
          }
          callback();
        }
      });
    } else {
      callback();
    }
  }
});
var _default = exports["default"] = MDDisplayFileController;

},{"1104":1104,"1184":1184,"1454":1454,"1541":1541,"32":32,"33":33,"34":34,"484":484,"525":525,"55":55,"72":72,"813":813}],813:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMGraphCommentData = _interopRequireDefault(require(1051));
var _MMGraphComment = _interopRequireDefault(require(1012));
var _MMChatMessage = _interopRequireDefault(require(950));
var _MMStrokeType = _interopRequireDefault(require(798));
var _MMShadowType = _interopRequireDefault(require(797));
var _MMGradient = _interopRequireDefault(require(796));
var _MMFillType = _interopRequireDefault(require(795));
var _MMColor = _interopRequireDefault(require(794));
var _MMScribble = _interopRequireDefault(require(1028));
var _MMScribbleData = _interopRequireDefault(require(1067));
var _MMText = _interopRequireDefault(require(1031));
var _MMTextData = _interopRequireDefault(require(1072));
var _MMHalfRoundRect = _interopRequireDefault(require(1014));
var _MMHalfRoundRectData = _interopRequireDefault(require(1053));
var _MMHexagon = _interopRequireDefault(require(1015));
var _MMHexagonData = _interopRequireDefault(require(1054));
var _MMIndicateArrow = _interopRequireDefault(require(1017));
var _MMIndicateArrowData = _interopRequireDefault(require(1056));
var _MMPentagon = _interopRequireDefault(require(1022));
var _MMPentagonData = _interopRequireDefault(require(1061));
var _MMRectangle = _interopRequireDefault(require(1026));
var _MMRectangleData = _interopRequireDefault(require(1065));
var _MMRoundRect = _interopRequireDefault(require(1027));
var _MMRoundRectData = _interopRequireDefault(require(1066));
var _MMTriangle = _interopRequireDefault(require(1033));
var _MMTriangleData = _interopRequireDefault(require(1073));
var _MMCloud = _interopRequireDefault(require(1004));
var _MMCloudData = _interopRequireDefault(require(1042));
var _MMBrokenLine = _interopRequireDefault(require(1001));
var _MMBrokenLineData = _interopRequireDefault(require(1039));
var _MMCircle = _interopRequireDefault(require(1002));
var _MMCircleData = _interopRequireDefault(require(1040));
var _MMCircleMark = _interopRequireDefault(require(1003));
var _MMCircleMarkData = _interopRequireDefault(require(1041));
var _MMDiamond = _interopRequireDefault(require(1006));
var _MMDiamondData = _interopRequireDefault(require(1045));
var _MMDirectionArrow = _interopRequireDefault(require(1007));
var _MMDirectionArrowData = _interopRequireDefault(require(1046));
var _MMDoc = _interopRequireDefault(require(1008));
var _MMDocData = _interopRequireDefault(require(1047));
var _MMFivestar = _interopRequireDefault(require(1011));
var _MMFivestarData = _interopRequireDefault(require(1050));
var _MMSegment = _interopRequireDefault(require(1029));
var _MMSegmentData = _interopRequireDefault(require(1069));
var _MMImage = _interopRequireDefault(require(1016));
var _MMImageData = _interopRequireDefault(require(1055));
var _MMRectMark = _interopRequireDefault(require(1025));
var _MMRectMarkData = _interopRequireDefault(require(1064));
var _MMNote = _interopRequireDefault(require(1020));
var _MMNoteData = _interopRequireDefault(require(1059));
var _MMPDFDocument = _interopRequireDefault(require(1021));
var _MMPDFDocumentData = _interopRequireDefault(require(1060));
var _MMRecorder = _interopRequireDefault(require(1024));
var _MMEmojiText = _interopRequireDefault(require(1010));
var _MMEmojiTextData = _interopRequireDefault(require(1049));
var _MMDocument = _interopRequireDefault(require(1009));
var _MMDocumentData = _interopRequireDefault(require(1048));
var _MMNitePen = _interopRequireDefault(require(1019));
var _MMNitePenData = _interopRequireDefault(require(1058));
var _MMCommentObj = _interopRequireDefault(require(1005));
var _MMCommentObjData = _interopRequireDefault(require(1044));
var _MMNiceTag = _interopRequireDefault(require(1018));
var _MMNiceTagData = _interopRequireDefault(require(1057));
var _MMTextComment = _interopRequireDefault(require(1032));
var _MMTextCommentData = _interopRequireDefault(require(1071));
var _MMCreateInfo = _interopRequireDefault(require(971));
var _MMCreateAction = _interopRequireDefault(require(970));
var _MMDeleteInfo = _interopRequireDefault(require(973));
var _MMDeleteAction = _interopRequireDefault(require(972));
var _MMInsertInfo = _interopRequireDefault(require(976));
var _MMInsertAction = _interopRequireDefault(require(975));
var _MMUpdateInfos = require(996);
var _MMPageInfo = _interopRequireDefault(require(984));
var _MMPageAction = _interopRequireDefault(require(979));
var _MMCoopInfo = _interopRequireDefault(require(969));
var _MMCoopAction = _interopRequireDefault(require(968));
var _MMPasteInfo = _interopRequireDefault(require(986));
var _MMPasteAction = _interopRequireDefault(require(985));
var _MMPromptInfo = _interopRequireDefault(require(987));
var _MMChatMessageInfo = _interopRequireDefault(require(967));
var _MMChatMessageAction = _interopRequireDefault(require(966));
var _MMPageAddInfo = _interopRequireDefault(require(981));
var _MMPageAddAction = _interopRequireDefault(require(980));
var _MMPageBkGrdInfo = _interopRequireDefault(require(983));
var _MMPageBkGrdAction = _interopRequireDefault(require(982));
var _MMLayerInfo = _interopRequireDefault(require(978));
var _MMLayerAction = _interopRequireDefault(require(977));
var _MMFetchInfo = _interopRequireDefault(require(974));
var _MMRoundInfo = _interopRequireDefault(require(991));
var _MMRoundAction = _interopRequireDefault(require(990));
var _MMReadInfo = _interopRequireDefault(require(989));
var _MMReadAction = _interopRequireDefault(require(988));
var _MMProcessMessage = _interopRequireDefault(require(849));
var _MMRProcessMessage = _interopRequireDefault(require(851));
var _MMBProcessMessage = _interopRequireDefault(require(842));
var _MMPromptMessage = _interopRequireDefault(require(850));
var _MMBpromptMessage = _interopRequireDefault(require(843));
var _MMJoinCollabMessage = _interopRequireDefault(require(845));
var _MMJoinGlobalRespMessage = _interopRequireDefault(require(846));
var _MMJoinSequenceRespMessage = _interopRequireDefault(require(847));
var _MMSendActionMessage = _interopRequireDefault(require(853));
var _MMSendActionRespMessage = _interopRequireDefault(require(855));
var _MMSendActionPushMessage = _interopRequireDefault(require(854));
var _MMDatablockMessage = _interopRequireDefault(require(844));
var _MMRdatablockMessage = _interopRequireDefault(require(852));
var _map = _interopRequireDefault(require(821));
var _MMJoinZoneRespMessage = _interopRequireDefault(require(848));
// goog.require('Map ');
// goog.require('MMProcessMessage');
// goog.require('MMJoinCollabMessage');
// goog.require('MMBpromptMessage');

// goog.require('MMCreateInfo');
// goog.require('MMDeleteInfo');
// goog.require('MMInsertInfo');
// goog.require('MMUpdateInfo');
// goog.require('MMPasteInfo');
// goog.require('MMPageInfo');
// goog.require('MMLayerInfo');
// goog.require('MMCoopInfo');
// goog.require('MMChatMessageInfo');
// goog.require('MMFetchInfo');

// goog.require('MMPromptInfo');

// goog.require('MMRectangle');
// goog.require('MMRectangleData');
// goog.require('MMCircle');
// goog.require('MMCircleData');
// goog.require('MMCircleMark');
// goog.require('MMCircleMarkData');
// goog.require('MMScribble');
// goog.require('MMScribbleData');
// goog.require('MMRoundRect');
// goog.require('MMRoundRectData');
// goog.require('MMHalfRoundRect');
// goog.require('MMHalfRoundRectData');
// goog.require('MMCloud');
// goog.require('MMCloudData');
// goog.require('MMDirectionArrow');
// goog.require('MMDirectionArrowData');
// goog.require('MMFivestar');
// goog.require('MMFivestarData');
// goog.require('MMSegment');
// goog.require('MMSegmentData');
// goog.require('MMBrokenLine');
// goog.require('MMBrokenLineData');
// goog.require('MMText');
// goog.require('MMTextData');
// goog.require('MMImage');
// goog.require('MMImageData');
// goog.require('MMDoc');
// goog.require('MMDocData');
// goog.require('MMNitePen');
// goog.require('MMNitePenData');
// goog.require('MMNote');
// goog.require('MMNoteData');
// goog.require('MMRectMark');
// goog.require('MMRectMarkData');
// goog.require('MMEmojiText');
// goog.require('MMEmojiTextData');
// goog.require('MMDocument');
// goog.require('MMDocumentData');
// goog.require('MMPDFDocument');
// goog.require('MMPDFDocumentData');
// goog.require('MMRecorder');
// goog.require('MMRecorderData');

// goog.require('MMCommentObj');
// goog.require('MMCommentObjData');
// goog.require('MMNiceTag');
// goog.require('MMNiceTagData');
// goog.require('MMTextComment');
// goog.require('MMTextCommentData');
// goog.require('MMTriangle');
// goog.require('MMTriangleData');
// goog.require('MMHexagon');
// goog.require('MMHexagonData');
// goog.require('MMDiamond');
// goog.require('MMDiamondData');
// goog.require('MMPentagon');
// goog.require('MMPentagonData');
// goog.require('MMIndicateArrow');
// goog.require('MMIndicateArrowData');

// goog.require('MMColor');
// goog.require('MMFillType');
// goog.require('MMGradient');
// goog.require('MMShadowType');
// goog.require('MMStrokeType');

// goog.require('MMChatMessage');

// goog.require('MMSendActionMessage');
// goog.require('MMSendActionRespMessage');
// goog.require('MMSendActionPushMessage');

// // added by tobias, it was required before in MMConnection, witch is removed
// goog.require('MMJoinGlobalRespMessage');

var MMDClass = {
  m_id2name: null,
  m_name2id: null,
  m_id2class: null,
  getClassName: function getClassName(clzss) {
    console.assert(clzss.getClassName);
    return clzss.getClassName();
  },
  getClassId: function getClassId(clzss) {
    var _className = MMDClass.getClassName(clzss);
    return MMDClass.m_name2id.get(_className);
  },
  newObject: function newObject(classId_, whiteboard_) {
    var class_ = MMDClass.m_id2class.get(classId_); //whiteboard_.getObjsById(classId_)[0];
    var _retObj = new class_(null);
    if (_retObj && _retObj.initWithWihteBoard) {
      _retObj.initWithWihteBoard(whiteboard_);
    }
    return _retObj;
  },
  initiate: function initiate() {
    MMDClass.m_id2name = new _map["default"]();
    MMDClass.m_name2id = new _map["default"]();
    MMDClass.m_id2class = new _map["default"]();

    //MMDClass.__set(1, 'MMTestClass',MMTestClass); // commentedByTobias
    MMDClass.__set(4, 'MMChatMessage', _MMChatMessage["default"]); //对应  mola_message

    MMDClass.__set(50, "MMStrokeType", _MMStrokeType["default"]);
    MMDClass.__set(51, "MMShadowType", _MMShadowType["default"]);
    MMDClass.__set(52, "MMGradient", _MMGradient["default"]);
    MMDClass.__set(53, "MMFillType", _MMFillType["default"]);
    MMDClass.__set(54, "MMColor", _MMColor["default"]);
    //
    MMDClass.__set(100, "MMScribble", _MMScribble["default"]);
    MMDClass.__set(101, "MMScribbleData", _MMScribbleData["default"]);
    //
    MMDClass.__set(102, "MMText", _MMText["default"]);
    MMDClass.__set(103, "MMTextData", _MMTextData["default"]);
    MMDClass.__set(104, "MMHalfRoundRect", _MMHalfRoundRect["default"]);
    MMDClass.__set(105, "MMHalfRoundRectData", _MMHalfRoundRectData["default"]);
    MMDClass.__set(106, 'MMHexagon', _MMHexagon["default"]);
    MMDClass.__set(107, 'MMHexagonData', _MMHexagonData["default"]);
    MMDClass.__set(108, 'MMIndicateArrow', _MMIndicateArrow["default"]);
    MMDClass.__set(109, 'MMIndicateArrowData', _MMIndicateArrowData["default"]);
    MMDClass.__set(110, 'MMPentagon', _MMPentagon["default"]);
    MMDClass.__set(111, 'MMPentagonData', _MMPentagonData["default"]);
    MMDClass.__set(112, 'MMRectangle', _MMRectangle["default"]);
    MMDClass.__set(113, 'MMRectangleData', _MMRectangleData["default"]);
    MMDClass.__set(114, 'MMRoundRect', _MMRoundRect["default"]);
    MMDClass.__set(115, 'MMRoundRectData', _MMRoundRectData["default"]);
    MMDClass.__set(116, 'MMTriangle', _MMTriangle["default"]);
    MMDClass.__set(117, 'MMTriangleData', _MMTriangleData["default"]);
    MMDClass.__set(118, 'MMCloud', _MMCloud["default"]);
    MMDClass.__set(119, 'MMCloudData', _MMCloudData["default"]);
    MMDClass.__set(120, 'MMBrokenLine', _MMBrokenLine["default"]);
    MMDClass.__set(121, 'MMBrokenLineData', _MMBrokenLineData["default"]);
    //
    MMDClass.__set(122, 'MMCircle', _MMCircle["default"]);
    MMDClass.__set(123, 'MMCircleData', _MMCircleData["default"]);
    //
    MMDClass.__set(124, 'MMCircleMark', _MMCircleMark["default"]);
    MMDClass.__set(125, 'MMCircleMarkData', _MMCircleMarkData["default"]);
    MMDClass.__set(126, 'MMDiamond', _MMDiamond["default"]);
    MMDClass.__set(127, 'MMDiamondData', _MMDiamondData["default"]);
    MMDClass.__set(128, 'MMDirectionArrow', _MMDirectionArrow["default"]);
    MMDClass.__set(129, 'MMDirectionArrowData', _MMDirectionArrowData["default"]);
    MMDClass.__set(130, 'MMDoc', _MMDoc["default"]);
    MMDClass.__set(131, 'MMDocData', _MMDocData["default"]);
    MMDClass.__set(132, 'MMFivestar', _MMFivestar["default"]);
    MMDClass.__set(133, 'MMFivestarData', _MMFivestarData["default"]);
    MMDClass.__set(134, 'MMSegment', _MMSegment["default"]);
    MMDClass.__set(135, 'MMSegmentData', _MMSegmentData["default"]);
    MMDClass.__set(136, "MMImage", _MMImage["default"]);
    MMDClass.__set(137, "MMImageData", _MMImageData["default"]);
    MMDClass.__set(138, "MMRectMark", _MMRectMark["default"]);
    MMDClass.__set(139, "MMRectMarkData", _MMRectMarkData["default"]);
    MMDClass.__set(140, "MMNote", _MMNote["default"]);
    MMDClass.__set(141, "MMNoteData", _MMNoteData["default"]);
    MMDClass.__set(142, "MMPDFDocument", _MMPDFDocument["default"]);
    MMDClass.__set(143, "MMPDFDocumentData", _MMPDFDocumentData["default"]);
    MMDClass.__set(144, "MMRecorder", _MMRecorder["default"]);
    MMDClass.__set(145, "MMRecorderData", _MMImageData["default"]);
    MMDClass.__set(146, "MMEmojiText", _MMEmojiText["default"]);
    MMDClass.__set(147, "MMEmojiTextData", _MMEmojiTextData["default"]);
    MMDClass.__set(148, "MMDocument", _MMDocument["default"]);
    MMDClass.__set(149, "MMDocumentData", _MMDocumentData["default"]);
    MMDClass.__set(150, "MMNitePen", _MMNitePen["default"]);
    MMDClass.__set(151, "MMNitePenData", _MMNitePenData["default"]);

    //      MMDClass.__set(152, MMCoordinateTransformer);
    //      MMDClass.__set(153, MMCooperation);
    //      MMDClass.__set(154, MMMacTransformer);

    MMDClass.__set(157, "MMCommentObj", _MMCommentObj["default"]);
    MMDClass.__set(158, "MMCommentObjData", _MMCommentObjData["default"]);
    MMDClass.__set(159, "MMNiceTag", _MMNiceTag["default"]);
    MMDClass.__set(160, "MMNiceTagData", _MMNiceTagData["default"]);
    MMDClass.__set(161, "MMTextComment", _MMTextComment["default"]);
    MMDClass.__set(162, "MMTextCommentData", _MMTextCommentData["default"]);
    MMDClass.__set(163, "MMGraphComment", _MMGraphComment["default"]);
    MMDClass.__set(164, "MMGraphCommentData", _MMGraphCommentData["default"]);

    //
    MMDClass.__set(200, 'MMCreateInfo', _MMCreateInfo["default"]);
    MMDClass.m_name2id.set('MMCreateAction', 200);
    MMDClass.__set(201, 'MMDeleteInfo', _MMDeleteInfo["default"]);
    MMDClass.m_name2id.set('MMDeleteAction', 201);
    MMDClass.__set(202, 'MMInsertInfo', _MMInsertInfo["default"]);
    MMDClass.m_name2id.set('MMInsertAction', 202);
    MMDClass.__set(203, 'MMMoveUpdateInfo', _MMUpdateInfos.MMMoveUpdateInfo);
    MMDClass.m_name2id.set('MMMoveAction', 203);
    MMDClass.__set(204, 'MMScaleUpdateInfo', _MMUpdateInfos.MMScaleUpdateInfo);
    MMDClass.m_name2id.set('MMScaleAction', 204);
    MMDClass.__set(205, 'MMRotateUpdateInfo', _MMUpdateInfos.MMRotateUpdateInfo);
    MMDClass.m_name2id.set('MMRotateAction', 205);
    MMDClass.__set(206, 'MMFillUpdateInfo', _MMUpdateInfos.MMFillUpdateInfo);
    MMDClass.m_name2id.set('MMFillAction', 206);
    MMDClass.__set(207, 'MMStrokeUpdateInfo', _MMUpdateInfos.MMStrokeUpdateInfo);
    MMDClass.m_name2id.set('MMStrokeAction', 207);
    MMDClass.__set(208, 'MMShadowUpdateInfo', _MMUpdateInfos.MMShadowUpdateInfo);
    MMDClass.m_name2id.set('MMShadowAction', 208);
    MMDClass.__set(209, 'MMStyleUpdateInfo', _MMUpdateInfos.MMStyleUpdateInfo);
    MMDClass.m_name2id.set('MMStyleAction', 209);
    MMDClass.__set(210, 'MMFontUpdateInfo', _MMUpdateInfos.MMFontUpdateInfo);
    MMDClass.m_name2id.set('MMFontAction', 210);
    MMDClass.__set(211, 'MMTextUpdateInfo', _MMUpdateInfos.MMTextUpdateInfo);
    MMDClass.m_name2id.set('MMTextAction', 211);
    MMDClass.__set(212, 'MMTextColorUpdateInfo', _MMUpdateInfos.MMTextColorUpdateInfo);
    MMDClass.m_name2id.set('MMTextColorAction', 212);
    MMDClass.__set(213, 'MMYellowPtMoveUpdateInfo', _MMUpdateInfos.MMYellowPtMoveUpdateInfo);
    MMDClass.m_name2id.set('MMYellowPtMoveAction', 213);
    MMDClass.__set(214, 'MMPageInfo', _MMPageInfo["default"]);
    MMDClass.m_name2id.set('MMPageAction', 214);
    MMDClass.__set(215, 'MMCoopInfo', _MMCoopInfo["default"]);
    MMDClass.m_name2id.set('MMCoopAction', 215);
    MMDClass.__set(216, 'MMPasteInfo', _MMPasteInfo["default"]);
    MMDClass.m_name2id.set('MMPasteAction', 216);
    MMDClass.__set(217, 'MMPromptInfo', _MMPromptInfo["default"]);
    MMDClass.__set(218, 'MMChatMessageInfo', _MMChatMessageInfo["default"]);
    MMDClass.m_name2id.set('MMChatMessageAction', 218);
    MMDClass.__set(219, 'MMColorUpdateInfo', _MMUpdateInfos.MMColorUpdateInfo);
    MMDClass.m_name2id.set('MMColorAction', 219);
    MMDClass.__set(220, 'MMPageAddInfo', _MMPageAddInfo["default"]);
    MMDClass.m_name2id.set('MMPageAddAction', 220);
    MMDClass.__set(221, 'MMPageBkGrdInfo', _MMPageBkGrdInfo["default"]);
    MMDClass.m_name2id.set('MMPageBkGrdAction', 221);
    MMDClass.__set(222, 'MMLayerInfo', _MMLayerInfo["default"]);
    MMDClass.m_name2id.set('MMLayerAction', 222);
    MMDClass.__set(223, 'MMObjLockUpdateInfo', _MMUpdateInfos.MMObjLockUpdateInfo);
    MMDClass.m_name2id.set('MMObjLockAction', 223);
    MMDClass.__set(225, 'MMFetchInfo', _MMFetchInfo["default"]);
    //

    MMDClass.__set(226, 'MMRoundInfo', _MMRoundInfo["default"]);
    MMDClass.m_name2id.set('MMRoundAction', 226);
    MMDClass.__set(227, 'MMReadInfo', _MMReadInfo["default"]);
    MMDClass.m_name2id.set('MMReadAction', 227);
    MMDClass.__set(228, 'MMCommentCompleteInfo', _MMUpdateInfos.MMCommentCompleteInfo);
    MMDClass.m_name2id.set('MMCommentCompleteAction', 228);
    MMDClass.__set(229, 'MMCommentPraiseInfo', _MMUpdateInfos.MMCommentPraiseInfo);
    MMDClass.m_name2id.set('MMCommentPraiseAction', 229);
    MMDClass.__set(505, 'MMProcessMessage', _MMProcessMessage["default"]);
    MMDClass.__set(506, 'MMRProcessMessage', _MMRProcessMessage["default"]);
    MMDClass.__set(507, 'MMBProcessMessage', _MMBProcessMessage["default"]);
    MMDClass.__set(508, 'MMPromptMessage', _MMPromptMessage["default"]);
    MMDClass.__set(509, 'MMBpromptMessage', _MMBpromptMessage["default"]);
    MMDClass.__set(663, 'MMJoinCollabMessage', _MMJoinCollabMessage["default"]);
    // MMDClass.__set(664, 'MMJoinCollabRespMessage', MMJoinCollabRespMessage);
    MMDClass.__set(665, 'MMJoinGlobalRespMessage', _MMJoinGlobalRespMessage["default"]);
    MMDClass.__set(666, 'MMJoinZoneRespMessage', _MMJoinZoneRespMessage["default"]);
    MMDClass.__set(667, 'MMJoinSequenceRespMessage', _MMJoinSequenceRespMessage["default"]);
    // MMDClass.__set(668, 'MMJoinPushMessage', MMJoinPushMessage);
    MMDClass.__set(669, 'MMSendActionMessage', _MMSendActionMessage["default"]);
    MMDClass.__set(670, 'MMSendActionRespMessage', _MMSendActionRespMessage["default"]);
    MMDClass.__set(671, 'MMSendActionPushMessage', _MMSendActionPushMessage["default"]);
    MMDClass.__set(650, "MMDatablockMessage", _MMDatablockMessage["default"]);
    MMDClass.__set(651, "MMRdatablockMessage", _MMRdatablockMessage["default"]);
  },
  __set: function __set(classId, name_, class_) {
    MMDClass.m_id2name.set(classId, name_);
    MMDClass.m_name2id.set(name_, classId);
    MMDClass.m_id2class.set(classId, class_);
  }
};
window['MMDClass'] = MMDClass;
MMDClass.initiate();
var _default = exports["default"] = MMDClass;

},{"1001":1001,"1002":1002,"1003":1003,"1004":1004,"1005":1005,"1006":1006,"1007":1007,"1008":1008,"1009":1009,"1010":1010,"1011":1011,"1012":1012,"1014":1014,"1015":1015,"1016":1016,"1017":1017,"1018":1018,"1019":1019,"1020":1020,"1021":1021,"1022":1022,"1024":1024,"1025":1025,"1026":1026,"1027":1027,"1028":1028,"1029":1029,"1031":1031,"1032":1032,"1033":1033,"1039":1039,"1040":1040,"1041":1041,"1042":1042,"1044":1044,"1045":1045,"1046":1046,"1047":1047,"1048":1048,"1049":1049,"1050":1050,"1051":1051,"1053":1053,"1054":1054,"1055":1055,"1056":1056,"1057":1057,"1058":1058,"1059":1059,"1060":1060,"1061":1061,"1064":1064,"1065":1065,"1066":1066,"1067":1067,"1069":1069,"1071":1071,"1072":1072,"1073":1073,"1184":1184,"1454":1454,"794":794,"795":795,"796":796,"797":797,"798":798,"821":821,"842":842,"843":843,"844":844,"845":845,"846":846,"847":847,"848":848,"849":849,"850":850,"851":851,"852":852,"853":853,"854":854,"855":855,"950":950,"966":966,"967":967,"968":968,"969":969,"970":970,"971":971,"972":972,"973":973,"974":974,"975":975,"976":976,"977":977,"978":978,"979":979,"980":980,"981":981,"982":982,"983":983,"984":984,"985":985,"986":986,"987":987,"988":988,"989":989,"990":990,"991":991,"996":996}],1051:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ObjType = _interopRequireDefault(require(1084));
var _MMCommentObjData = _interopRequireDefault(require(1044));
/**
 *
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMCircleData}
 */

function MMGraphCommentData(board, init) {
  _MMCommentObjData["default"].call(this, board, init);
  this.m_objType = _ObjType["default"].Obj_graphComment;
  this.m_className = 'MMGraphCommentData';
}
;
MMGraphCommentData.prototype = new _MMCommentObjData["default"]();
MMGraphCommentData.superclass = _MMCommentObjData["default"].prototype;
var _default = exports["default"] = MMGraphCommentData;

},{"1044":1044,"1084":1084,"1184":1184,"1454":1454}],1033:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMGraphics = _interopRequireDefault(require(1013));
var _ObjType = _interopRequireDefault(require(1084));
/**
 * @author lishusheng 2014-06-04
 * @param board
 * @returns {MMTriangle}
 */
function MMTriangle(board) {
  _MMGraphics["default"].call(this, board);
  this.m_objType = _ObjType["default"].GObj_triangle;
}
;
MMTriangle.prototype = new _MMGraphics["default"]();
MMTriangle.superclass = _MMGraphics["default"].prototype;
MMTriangle.prototype.encode = function (enc_) {
  MMTriangle.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMTriangle.prototype.m_className = 'MMTriangle';
MMTriangle.prototype.decode = function (dec_, ver_) {
  MMTriangle.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
MMTriangle.prototype.draw = function (ctx, trsfm, pgindex) {
  MMTriangle.superclass.draw.call(this, ctx, trsfm, pgindex);
};
var _default = exports["default"] = MMTriangle;

},{"1013":1013,"1084":1084,"1184":1184,"1454":1454}],1025:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1477);
require(1489);
var _MMYellowObj = _interopRequireDefault(require(1035));
var _ObjType = _interopRequireDefault(require(1084));
/**
 * @author lishusheng,2014-06-06
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMRectMark}
 */
function MMRectMark(board) {
  _MMYellowObj["default"].call(this, board); //
  this.m_className = 'MMRectMark';
  this.m_objType = _ObjType["default"].GObj_rectMark;
}
;
MMRectMark.prototype = new _MMYellowObj["default"](); //
MMRectMark.superclass = _MMYellowObj["default"].prototype;
MMRectMark.prototype.encode = function (enc_) {
  MMRectMark.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMRectMark.prototype.decode = function (dec_, ver_) {
  MMRectMark.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
MMRectMark.prototype.drawInCanvas = function (ctx, trsfm, pgindex) {
  MMRectMark.superclass.drawInCanvas.call(this, ctx, trsfm, pgindex);
  var textObj = this.getObjData().m_textObj;
  if (textObj != null && textObj != undefined) {
    textObj.draw(ctx, trsfm, pgindex);
  }
};

/**
 * 当前标注框的平移变换
 */
MMRectMark.prototype.move = function (offset_, moveAll_) {
  var data = this.getObjData();
  data.move(offset_, moveAll_);
  this.m_rect = data.getRect();
  this.m_expandRect = data.getExpandRect();
};
MMRectMark.prototype.getTextObj = function () {
  var data = this.getObjData();
  return data.getTextObj();
};
MMRectMark.prototype.match = function (reg_) {
  var textObj = this.getObjData().m_textObj;
  if (textObj) {
    return textObj.match(reg_);
  }
  return null;
};
var _default = exports["default"] = MMRectMark;

},{"1035":1035,"1084":1084,"1184":1184,"1454":1454,"1477":1477,"1489":1489}],1024:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1477);
require(1489);
var _MMBlockObj = _interopRequireDefault(require(1000));
var _MMRecorderIconCtl = _interopRequireDefault(require(900));
var _MMCommonFun = _interopRequireDefault(require(812));
var _ObjType = _interopRequireDefault(require(1084));
function MMRecorder(board, init) {
  _MMBlockObj["default"].call(this, board, init); //
  this.m_objType = _ObjType["default"].Obj_Recorder;

  //  this.m_filePath ;//string
  //    this.m_recorderCreateTime ;// string
  //    this.m_recorderFileName ;//string
  //    this.m_showPlayerPanel ;//bool
  //    this.m_durationTime;//double
  //    this.m_displayTime;//string
  //    this.m_fileSize;//string
  //    this.m_fileType;//string
}
;
MMRecorder.prototype = new _MMBlockObj["default"](); //
MMRecorder.superclass = _MMBlockObj["default"].prototype;
MMRecorder.prototype.m_className = 'MMRecorder';
MMRecorder.prototype.encode = function (enc_) {
  MMRecorder.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMRecorder.prototype.decode = function (dec_, ver_) {
  MMRecorder.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
MMRecorder.prototype.draw = function (ctx, trsfm, pgindex) {
  this.drawInDiv(ctx, trsfm, pgindex);
};
MMRecorder.prototype.drawInDiv = function (editor, trsfm, pgindex) {
  if (this.dispCtl == null) {
    this.dispCtl = new _MMRecorderIconCtl["default"](this);
  }
  this.dispCtl.displayInDiv(trsfm, pgindex, trsfm.$viewcontent[0]);
};
MMRecorder.prototype.getFileName = function () {
  var recData = this.getObjData();
  return recData.m_recorderFileName;
};
MMRecorder.prototype.getFileSize = function () {
  var recData = this.getObjData();
  var durtime = recData.m_durationTime;
  return _MMCommonFun["default"].secondToShowTime(durtime);
};
MMRecorder.prototype.getIconName = function () {
  return "url(img/file_icon/REC7.png)";
};
MMRecorder.prototype.getLinkfileName = function () {
  var recData = this.getObjData();
  return recData.getFilePath();
};
MMRecorder.prototype.match = function (reg_) {
  var data = this.getObjData();
  var txt = data.m_recorderFileName;
  var matches = txt.match(reg_);
  return matches;
};
var _default = exports["default"] = MMRecorder;

},{"1000":1000,"1084":1084,"1184":1184,"1454":1454,"1477":1477,"1489":1489,"812":812,"900":900}],900:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1438);
var _goog = _interopRequireDefault(require(823));
var _MMObjIconCtl = _interopRequireDefault(require(894));
var _MMCloseIcon = _interopRequireDefault(require(945));
/**
 * 此类用于管理显示 MMRecorder 在屏幕上的图标，响应鼠标点击事件
 */

function MMRecorderIconCtl(obj, parentDiv) {
  _MMObjIconCtl["default"].call(this, obj, parentDiv);
  this.filedata = null;
  this.audioBuffer = null;
  this.source = null;
  this.audioCtx = null;
}
;
_goog["default"].inherits(MMRecorderIconCtl, _MMObjIconCtl["default"]);
MMRecorderIconCtl.prototype.addEventHandler = function () {
  var _that = this;
  // goog.events.listen(this.$div[0], goog.events.EventType.CLICK, function(e) {
  //   _that.userClick(e);
  // });
  this.$div.click(function (e) {
    _that.userClick(e);
  });
};

// 点击打开 pdf 文件显示内容
MMRecorderIconCtl.prototype.userClick = function (e) {
  var $div = $(e.currentTarget);
  var $audio;
  var $container = $div.children(".audio-container");
  if ($container.length == 0) {
    var size = {
      left: $div.css('left'),
      top: $div.css('top'),
      height: $div.height(),
      width: $div.width()
    };
    var filename = $div.attr("filename");
    if (filename != undefined || filename.length > 0) {
      //      // 使用 audioContext 播放，（ firefox 不支持 m4a，放弃这个方案，使用原来简单的方案，而由服务器进行转码）
      //      this.processFileForAudioContext(filename);
      //      return;

      var $container = $("<div class='audio-container' style='position:absolute; left:0px;top:0px'>" + "<audio  controls='controls' >" + "<source src='" + filename + "' type='audio/mpeg'>" +
      //                    "<source src='audio/rec.m4a' type='audio/mp4'>" +
      "</audio>" + "<div class='win_close_bt' ></div>" + "</div>");
      $div.append($container);
      var closeW = 10;
      var $close;
      $container.width(size.width * 2);
      $container.height(size.height);
      $audio = $container.children("audio");
      $audio.width(size.width * 2);
      $audio.height(size.height);
      $audio.css("left", "0px");
      $audio.css("top", "0px");
      $audio.css("position", "absolute");
      $audio.bind("stalled", function (e) {
        var audio = e.currentTarget;
        audio.load();

        // Threw in these two lines for good measure.
        audio.play();
      });
      $close = $container.children(".win_close_bt");
      $close.css("left", size.width * 2 - 10 + "px");
      $close.css("top", "0px");
      $close.width(closeW);
      $close.height(closeW);
      //      $close.css("flow", "left");
      $close.css("position", "absolute");
      $container.css('transform', 'rotate(' + -this.mmobj.getAngle() + 'deg)');
      $close.click('click', function ($e) {
        MMRecorderIconCtl.closeBtClicked($e);
      });
    }
  }
  ;
};
MMRecorderIconCtl.closeBtClicked = function (e) {
  var bt = e.currentTarget;
  var $parent = $(bt).parent();
  $parent.remove();
  e.stopPropagation();
};
MMRecorderIconCtl.prototype.processFileForAudioContext = function (filename) {
  if (this.filedata == null) {
    var that = this;
    var httpReqst = new XMLHttpRequest();
    httpReqst.responseType = 'arraybuffer';
    httpReqst.onreadystatechange = function (e) {
      if (httpReqst.readyState == 4 && httpReqst.status == 200) {
        var dataUrl = this.response;

        //              var binaryAudio = atob(dataUrl);
        //              var length = binaryAudio.length;
        //              var ab = new ArrayBuffer(length);
        //              var ua = new Uint8Array(ab);
        //              for (var i = 0; i < length; i++) {
        //                  ua[i] = binaryAudio.charCodeAt(i);
        //              }

        that.filedata = dataUrl;
        that.decodeFileData();
      }
      ;
    };
    httpReqst.open("POST", filename);
    httpReqst.send();
  } else {
    this.displayAudioWithContext();
  }
};
MMRecorderIconCtl.prototype.decodeFileData = function () {
  if (this.audioCtx == null) {
    try {
      this.audioCtx = new AudioContext();
    } catch (e) {
      console.log(e);
    }
    var that = this;
    this.audioCtx.decodeAudioData(this.filedata, function (buffer) {
      that.audioBuffer = buffer;
      that.displayAudioWithContext();
    }, function (e) {
      console.log("error--->" + e);
    });
  }
};
MMRecorderIconCtl.prototype.displayAudioWithContext = function () {
  console.log("decode successfully");
  var audioContext = this.audioCtx;
  var buffer = this.audioBuffer;
  var audioBufferSouceNode = audioContext.createBufferSource(),
    analyser = audioContext.createAnalyser(),
    that = this;

  /*-------*    connect   *----------*    connect   *-------------*
  | source | ============>| analyser | ============>| destination |
  *--------*              *----------*              *-------------*/
  //connect the source to the analyser
  audioBufferSouceNode.connect(analyser);
  //connect the analyser to the destination(the speaker), or we won't hear the sound
  analyser.connect(audioContext.destination);
  //then assign the buffer to the buffer source node
  audioBufferSouceNode.buffer = buffer;
  //play the source
  if (!audioBufferSouceNode.start) {
    audioBufferSouceNode.start = audioBufferSouceNode.noteOn; //in old browsers use noteOn method
    audioBufferSouceNode.stop = audioBufferSouceNode.noteOff; //in old browsers use noteOn method
  }
  ;
  audioBufferSouceNode.start(0);
  audioBufferSouceNode.onended = function () {};

  //stop the previous sound if any
  if (this.source !== null) {
    this.forceStop = true;
    this.source.stop(0);
  }
  this.source = audioBufferSouceNode;
};
var _default = exports["default"] = MMRecorderIconCtl;

},{"1184":1184,"1438":1438,"1454":1454,"823":823,"894":894,"945":945}],945:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * 本类使用 canvas 绘制一个叉
 */

function MMCloseIcon(parentDiv) {
  this.parentDiv = parentDiv;
  this.$cvs = $("<canvas width='100%' height='100%'></canvas>");
  $(parentDiv).append(this.$cvs);
  this.drawCross();
}
;
MMCloseIcon.prototype.drawCross = function () {
  var ctx = this.$cvs[0].getContext('2d');
  var w = $(this.parentDiv).width();
  var h = $(this.parentDiv).height();
  this.$cvs.attr('width', w + 'px');
  this.$cvs.attr('height', h + 'px');
  var p = 0.1;
  var l = w * p;
  var t = h * p;
  var dx = w * (1 - 2 * p);
  var dy = h * (1 - 2 * p);
  ctx.strokeStyle = "#ffffff";
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.moveTo(l, t);
  ctx.lineTo(l + dx, t + dy);
  ctx.moveTo(l, t + dy);
  ctx.lineTo(l + dx, t);
  ctx.stroke();
};
var _default = exports["default"] = MMCloseIcon;

},{"1454":1454}],1022:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMGraphics = _interopRequireDefault(require(1013));
var _ObjType = _interopRequireDefault(require(1084));
/**
 * @author lishusheng 2014-06-04
 * @param board
 * @returns {MMPentagon}
 */
function MMPentagon(board) {
  _MMGraphics["default"].call(this, board);
  this.m_className = 'MMPentagon';
  this.m_objType = _ObjType["default"].GObj_pentagon;
}
;
MMPentagon.prototype = new _MMGraphics["default"]();
MMPentagon.superclass = _MMGraphics["default"].prototype;
MMPentagon.prototype.encode = function (enc_) {
  MMPentagon.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMPentagon.prototype.decode = function (dec_, ver_) {
  MMPentagon.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
var _default = exports["default"] = MMPentagon;

},{"1013":1013,"1084":1084,"1184":1184,"1454":1454}],1020:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1477);
require(1489);
var _MMBezierObj = _interopRequireDefault(require(999));
var _ObjType = _interopRequireDefault(require(1084));
var _MMShadowType = _interopRequireDefault(require(797));
var _MMColor = _interopRequireDefault(require(794));
var _MMPathDrawer = _interopRequireDefault(require(896));
/**
 * @author lishusheng,2014-06-06
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMNote}
 */
function MMNote(board) {
  _MMBezierObj["default"].call(this, board); //
  this.m_className = 'MMNote';
  this.m_objType = _ObjType["default"].GObj_note;
  this.m_textRect = null; //MMLgRect

  this.m_cornerPoint = null; //MMDvPoint
  this.m_width = 0.0; // --------------double 记录初始进来便签的宽度

  this.triangleShadow = new _MMShadowType["default"]();
  this.triangleShadow.m_hasShadow = true;
  this.triangleShadow.m_blur = 4;
  this.triangleShadow.m_offsetX = -2;
  this.triangleShadow.m_offsetY = -2;
  this.triangleShadow.m_ShadowColor = new _MMColor["default"]();
  this.triangleShadow.m_ShadowColor.m_alpha = 0.5;
}
;
MMNote.prototype = new _MMBezierObj["default"](); //
MMNote.superclass = _MMBezierObj["default"].prototype;
MMNote.prototype.encode = function (enc_) {
  MMNote.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
  enc_.encodeMMRect(this.m_textRect);
  enc_.encodeFloat(this.m_width);
};
MMNote.prototype.decode = function (dec_, ver_) {
  MMNote.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
  this.m_textRect = dec_.decodeFromMMRect(ver_);
  this.m_width = dec_.decodeFromFloat(ver_);
};
/**
 * 当前便签框的平移变换
 */
MMNote.prototype.move = function (offset_, moveAll_) {
  var data = this.getObjData();
  data.move(offset_, moveAll_);
  this.m_rect = data.getRect();
  this.m_expandRect = data.getExpandRect();
};
MMNote.prototype.getTextObj = function () {
  var data = this.getObjData();
  return data.getTextObj();
};
MMNote.prototype.drawInCanvas = function (ctx, trsfm, pgindex) {
  var data = this.getObjData();
  if (data == null || data == undefined || data.m_arrPoints == undefined || data.m_arrPoints == null || data.m_arrPoints.length == 0) return;
  var lastPt = data.m_arrPoints.pop();
  MMNote.superclass.drawInCanvas.call(this, ctx, trsfm, pgindex);
  data.m_arrPoints.push(lastPt);
  try {
    var pts = this.getArrPoints();
    var drawer = new _MMPathDrawer["default"](ctx, data.m_strokeType, data.m_fillType, this.triangleShadow, trsfm, pgindex);
    drawer.drawPolyline(data.m_arrPoints, data.m_arrPoints.length - 3, 3, true);

    //      this.triangleShadow.setContext(ctx, trsfm);
    //      data.m_fillType.setContext(ctx, trsfm);
    //
    //      // 最后三个点形成小折角
    //      ctx.beginPath();
    //      var startPt = trsfm.lg2dvPoint(pts[pts.length - 1], pgindex);
    //      ctx.moveTo(startPt.x, startPt.y);
    //      for(var i=2; i < 4; i++){
    //
    //        var pt = trsfm.lg2dvPoint(pts[pts.length - i], pgindex);
    //
    //        ctx.lineTo(pt.x, pt.y);
    //
    //      }
    //
    //      ctx.closePath();
    //      ctx.fill();
  } catch (e) {}
  var textObj = this.getObjData().m_textObj;
  if (textObj != null && textObj != undefined) {
    textObj.draw(ctx, trsfm, pgindex);
  }
};
//transform操作
MMNote.prototype.transform = function (option, basePt_,
// 参考点 MMLgPoint
scale_,
// 拉伸比例 MMLgPoint
angleInfect_,
// 缩放时是否受原有角度影响？在多个对象同时被选中拉伸时，此参数置为 false
alpha_,
// 相对旋转角度(0, 360) float
offset_ // 相对位移 MMLgPoint
) {
  var objData = this.getObjData();
  var scale = objData.transform(option, basePt_, scale_, angleInfect_, alpha_, offset_);
  this.m_rect = objData.getRect();
  this.m_expandRect = objData.getExpandRect();
  return scale;
};
MMNote.prototype.match = function (reg_) {
  var textObj = this.getObjData().m_textObj;
  if (textObj) {
    return textObj.match(reg_);
  }
  return null;
};
var _default = exports["default"] = MMNote;

},{"1084":1084,"1184":1184,"1454":1454,"1477":1477,"1489":1489,"794":794,"797":797,"896":896,"999":999}],1019:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMSegment = _interopRequireDefault(require(1029));
var _ObjType = _interopRequireDefault(require(1084));
/**
 * @author lishusheng，2014-06-06
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMNitePen}
 */
function MMNitePen(board) {
  _MMSegment["default"].call(this, board); //
  this.m_className = 'MMNitePen';
  this.m_objType = _ObjType["default"].GObj_nitePen;
}
;
MMNitePen.prototype = new _MMSegment["default"](); //
MMNitePen.superclass = _MMSegment["default"].prototype;
MMNitePen.prototype.encode = function (enc_) {
  MMNitePen.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMNitePen.prototype.decode = function (dec_, ver_) {
  MMNitePen.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
var _default = exports["default"] = MMNitePen;

},{"1029":1029,"1084":1084,"1184":1184,"1454":1454}],1017:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMGraphics = _interopRequireDefault(require(1013));
var _ObjType = _interopRequireDefault(require(1084));
/**
 * @author lishusheng 2014-06-05
 * @param board
 * @returns {MMIndicateArrow}
 */
function MMIndicateArrow(board) {
  _MMGraphics["default"].call(this, board);
  this.m_className = 'MMIndicateArrow';
  this.m_objType = _ObjType["default"].GObj_indicateline;
}
;
MMIndicateArrow.prototype = new _MMGraphics["default"]();
MMIndicateArrow.superclass = _MMGraphics["default"].prototype;
MMIndicateArrow.prototype.encode = function (enc_) {
  MMIndicateArrow.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMIndicateArrow.prototype.decode = function (dec_, ver_) {
  MMIndicateArrow.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
MMIndicateArrow.prototype.drawInCanvas = function (ctx, trsfm, pgindex) {
  MMIndicateArrow.superclass.drawInCanvas.call(this, ctx, trsfm, pgindex);
};
var _default = exports["default"] = MMIndicateArrow;

},{"1013":1013,"1084":1084,"1184":1184,"1454":1454}],1015:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMGraphics = _interopRequireDefault(require(1013));
var _ObjType = _interopRequireDefault(require(1084));
/**
 * @author lishusheng,2014-06-04
 * @param board
 * @returns {MMHexagon}
 */
function MMHexagon(board) {
  _MMGraphics["default"].call(this, board);
  this.m_className = 'MMHexagon';
  this.m_objType = _ObjType["default"].GObj_hexagon;
}
;
MMHexagon.prototype = new _MMGraphics["default"]();
MMHexagon.superclass = _MMGraphics["default"].prototype;
MMHexagon.prototype.encode = function (enc_) {
  MMHexagon.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMHexagon.prototype.decode = function (dec_, ver_) {
  MMHexagon.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
MMHexagon.prototype.draw = function (ctx, trsfm, pgindex) {
  MMHexagon.superclass.draw.call(this, ctx, trsfm, pgindex);
};
var _default = exports["default"] = MMHexagon;

},{"1013":1013,"1084":1084,"1184":1184,"1454":1454}],1014:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ObjType = _interopRequireDefault(require(1084));
var _MMRoundRect = _interopRequireDefault(require(1027));
/**
 * @author lishusheng 2014-06-04
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMHalfRoundRect}
 */
function MMHalfRoundRect(board) {
  _MMRoundRect["default"].call(this, board); //
  this.m_className = 'MMHalfRoundRect';
  this.m_objType = _ObjType["default"].GObj_halfroundrect;
}
;
MMHalfRoundRect.prototype = new _MMRoundRect["default"](); //
MMHalfRoundRect.superclass = _MMRoundRect["default"].prototype; //

MMHalfRoundRect.prototype.encode = function (enc_) {
  MMHalfRoundRect.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMHalfRoundRect.prototype.decode = function (dec_, ver_) {
  MMHalfRoundRect.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
var _default = exports["default"] = MMHalfRoundRect;

},{"1027":1027,"1084":1084,"1184":1184,"1454":1454}],1027:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMCircle = _interopRequireDefault(require(1002));
var _ObjType = _interopRequireDefault(require(1084));
/**
 * @author lishusheng 2014-06-04
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMRoundRect}
 */
function MMRoundRect(board) {
  _MMCircle["default"].call(this, board); //
  this.m_className = 'MMRoundRect';
  this.m_objType = _ObjType["default"].GObj_roundrect;
}
;
MMRoundRect.prototype = new _MMCircle["default"](); //
MMRoundRect.superclass = _MMCircle["default"].prototype; //

MMRoundRect.prototype.encode = function (enc_) {
  MMRoundRect.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMRoundRect.prototype.decode = function (dec_, ver_) {
  MMRoundRect.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
var _default = exports["default"] = MMRoundRect;

},{"1002":1002,"1084":1084,"1184":1184,"1454":1454}],1011:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ObjType = _interopRequireDefault(require(1084));
var _MMCircle = _interopRequireDefault(require(1002));
/**
 * @author lishusheng 2014-06-04
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMFivestar}
 */
function MMFivestar(board) {
  _MMCircle["default"].call(this, board); //
  this.m_className = 'MMFivestar';
  this.m_objType = _ObjType["default"].GObj_fivestar;
}
;
MMFivestar.prototype = new _MMCircle["default"](); //
MMFivestar.superclass = _MMCircle["default"].prototype; //

MMFivestar.prototype.encode = function (enc_) {
  MMFivestar.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMFivestar.prototype.decode = function (dec_, ver_) {
  MMFivestar.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
MMFivestar.prototype.draw = function (ctx, trsfm, pgindex) {
  ctx.save();
  MMFivestar.superclass.draw.call(this, ctx, trsfm, pgindex);
  ctx.restore();
};
MMFivestar.prototype.drawInCanvas = function (ctx, trsfm, pgindex) {
  MMFivestar.superclass.drawInCanvas.call(this, ctx, trsfm, pgindex);
};
var _default = exports["default"] = MMFivestar;

},{"1002":1002,"1084":1084,"1184":1184,"1454":1454}],1010:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMText = _interopRequireDefault(require(1031));
var _ObjType = _interopRequireDefault(require(1084));
/**
 * @author lishusheng，2014-06-06
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMEmojiText}
 */

function MMEmojiText(board, init) {
  _MMText["default"].call(this, board, init);
  this.m_className = 'MMEmojiText';
  this.m_objType = _ObjType["default"].GObj_emoji;
}
;
MMEmojiText.prototype = new _MMText["default"](); //

MMEmojiText.superclass = _MMText["default"].prototype;
MMEmojiText.prototype.encode = function (enc_) {
  MMEmojiText.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMEmojiText.prototype.decode = function (dec_, ver_) {
  MMEmojiText.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
var _default = exports["default"] = MMEmojiText;

},{"1031":1031,"1084":1084,"1184":1184,"1454":1454}],1031:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1484);
require(1477);
require(1489);
var _MMBlockObj = _interopRequireDefault(require(1000));
var _TextAlignment = _interopRequireDefault(require(819));
var _MMBezierObj = _interopRequireDefault(require(999));
var _MMTextAreaCtl = _interopRequireDefault(require(901));
var _MMTextDrawer = _interopRequireDefault(require(902));
var _MMObjElementsController = _interopRequireDefault(require(893));
var _ObjType = _interopRequireDefault(require(1084));
/**
 * @constructor
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMText}
 */
function MMText(board, init) {
  _MMBezierObj["default"].call(this, board, init); //
  this.m_objType = _ObjType["default"].GObj_text;
  this.angle = 0;
  this.fontname = 'Arial';
  this.fontsize = 0.5;
  this.fontColor = 'black';
  this.m_className = 'MMText';
  // 显示时使用的变量
  this.$textarea = null;
}
;
MMText.prototype = new _MMBezierObj["default"]();
MMText.superclass = _MMBezierObj["default"].prototype;
MMText.prototype.encode = function (enc_) {
  MMText.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMText.prototype.decode = function (dec_, ver_) {
  MMText.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
MMText.prototype.setAngle = function (angle) {
  var data = this.getObjData();
  data.angle = angle;
  this.angle = angle;
};
/**
 *
 * @param color { MMColor }
 */
MMText.prototype.setTextColor = function (color) {
  var data = this.getObjData();
  data.setTextColor(color);
};
/**
 *
 * @returns  { MMColor }
 */
MMText.prototype.getTextColor = function () {
  var data = this.getObjData();
  return data.getTextColor();
};

/**
 *
 * @param font { MMFont }
 */
MMText.prototype.setLgFont = function (font) {
  var data = this.getObjData();
  data.setLgFont(font);
};
/**
 *
 * @returns  { MMFont }
 */
MMText.prototype.getLgFont = function () {
  var data = this.getObjData();
  return data.getLgFont();
};

/**
 *
 * @param alignment { TextAlignment}
 */
MMText.prototype.setAlignment = function (alignment) {
  var textAlign = 0;
  if (alignment == _TextAlignment["default"].Left) {} else if (alignment == _TextAlignment["default"].Center) {
    textAlign = 1;
  } else {
    textAlign = 2;
  }
  var data = this.getObjData();
  data.setAlignment(textAlign);
};
/**
 *
 * @returns  { TextAlignment
TextAlignment
TextAlignment }
 */
MMText.prototype.getAlignment = function () {
  var data = this.getObjData();
  var textAlign = data.getAlignment();
  var alignment = _TextAlignment["default"].Left;
  if (textAlign.textAlignment == 0) {
    alignment = _TextAlignment["default"].Left;
  } else if (textAlign.textAlignment == 1) {
    alignment = _TextAlignment["default"].Center;
  } else if (textAlign.textAlignment == 2) {
    alignment = _TextAlignment["default"].Right;
  }
  return alignment;
};
MMText.prototype.setText = function (text) {
  var data = this.getObjData();
  data.setText(text);
  this.text = text;
};
MMText.prototype.getText = function () {
  var data = this.getObjData();
  this.text = data.getText();
  return this.text;
};
MMText.prototype.getFontSize = function () {
  var data = this.getObjData();
  this.fontSize = data.m_font.m_fontSize;
  return this.fontSize;
};
MMText.prototype.draw = function (ctx, trsfm, pgindex) {
  //  this.drawInTextArea(ctx, trsfm, pgindex);
  //  return;

  _MMBlockObj["default"].prototype.drawInCanvas.call(this, ctx, trsfm, pgindex);
  //  this.drawInCanvas(ctx, trsfm, pgindex);
};
MMText.prototype.drawObjInRct = function (ctx, trsfm, pgindex, rect) {
  var data = this.getObjData();

  //    console.log("=========================> draw text");
  //    rect.debugOutput("text  rect:");

  if (data == null || data == undefined || data.m_text == null || data.m_text == undefined || data.m_text.length == 0) return;
  this.fontsize = data.m_font.m_fontSize;
  var mmfont = this.fontsize;
  var dvfont = Math.round(trsfm.lg2dvLen(mmfont));
  //  console.log("font size:"+dvfont);

  var alignment = this.getAlignment();
  var txt = data.m_text;
  if (txt != undefined && txt != null && txt.length > 0) {
    data.m_strokeType.setContext(ctx, trsfm);
    data.m_shadowType.setContext(ctx, trsfm);
    data.m_fillType.setContext(ctx, trsfm);
    var arc = 0; //this.getObjData().m_angle * Math.PI / 180;
    _MMTextDrawer["default"].drawTextInRect(ctx, dvfont, data.m_font.m_fontName, txt, rect, alignment, arc);

    //    console.log("display font name:" + data.m_font.m_fontName);

    //    ctx.font = dvfont + "px " + this.fontname;
    //
    //    var ratio = 1.0;
    //    if(dvfont < 12){
    //      ratio = dvfont / 12;
    //      dvfont = 12;
    //    }
    //    ctx.scale(ratio, ratio);
    //
    //    data.m_strokeType.setContext(ctx, trsfm);
    //    data.m_shadowType.setContext(ctx, trsfm);
    //    data.m_fillType.setContext(ctx, trsfm);
    //
    ////    console.log("draw text:" + txt);
    //    var lines = String(txt).split(/\r\n|\r|\n/g);
    //    var lines_disp = new Array;
    //    for(var i=0; i<lines.length; i++){
    //      var line = lines[i];
    //      var sublines = splitByWidth(ctx, line, rect.getWidth() / ratio);
    //      lines_disp = lines_disp.concat(sublines);
    //    }
    //
    //    var left = rect.left / ratio;
    //    var top = rect.top / ratio;
    ////
    ////    ctx.fillRect(left, top, rect.getWidth() / ratio, rect.getHeight() / ratio);
    ////
    //    var y = top + dvfont;
    //    for(i=0; i<lines_disp.length;i++){
    //      ctx.fillText(lines_disp[i],left,y);
    //      y += dvfont;
    //    }
  }
};

//MMText.prototype.drawInCanvas = function(ctx, trsfm, pgindex){
//  var lgrct = new MMCenterRect();
//  lgrct.setRect(this.m_rect);
//  lgrct.setAngle(this.angle);
//
//  var dvrct = trsfm.lg2dvCenterRect(lgrct, pgindex);
//  var dvfont = Math.round(trsfm.lg2dvLen(this.fontsize));
//  console.log("font size:"+dvfont);
//
//  ctx.font = dvfont + "px " + this.fontname;
//
//  var txt= this.text;
//  var lines = String(txt).split(/\r\n|\r|\n/g);
//  var lines_disp = new Array;
//  for(var i=0; i<lines.length; i++){
//    var line = lines[i];
//    var sublines = splitByWidth(ctx, line, dvrct.width);
//    lines_disp = lines_disp.concat(sublines);
//  }
//
//  var cx = dvrct.center.x;
//  var cy = dvrct.center.y;
//
//  ctx.translate(cx, cy);
//  ctx.rotate(dvrct.angle * Math.PI / 180);
//  ctx.translate(-cx, -cy);
//
//  ctx.fillStyle = "#cccccc";
//
//  var left = dvrct.getLeftTop().x;
//  var top = dvrct.getLeftTop().y;
//
//  ctx.fillRect(left, top, dvrct.width, dvrct.height);
//
//  ctx.fillStyle='#0000FF';
//  var y = top + dvfont;
//  for(i=0; i<lines_disp.length;i++){
//    ctx.fillText(lines_disp[i],left,y);
//    y += dvfont;
//  }
//
//
//
//  ctx.setTransform(1, 0, 0, 1, 0, 0);
//};
MMText.prototype.drawInDiv = function (editor, trsfm, pgindex) {
  var elementsCtl = _MMObjElementsController["default"].getSingleInstance();
  elementsCtl.displayInDiv(editor, this, trsfm, pgindex);
};
MMText.prototype.drawInTextArea = function (ctx, trsfm, pgindex) {
  if (this.dispCtl == null) {
    this.dispCtl = new _MMTextAreaCtl["default"](this, trsfm.$viewcontent[0]);
  }
  this.dispCtl.displayInDiv(trsfm, pgindex);
};
/**
 *
 * @param realtionGraphic_  {MMObjData}
 */
MMText.prototype.setCorrelationGraphic = function (realtionGraphic_) {
  var data = this.getObjData();
  if (data) {
    data.setCorrelationGraphic(realtionGraphic_);
  }
};
/**
 *
 * @param range {MMRange} 位置信息（以字节为单位）
 * @param newStr {String}  新文本
 * @param rect {MMRect} 新矩形框
 * @param size {float} 新字体大小
 */
MMText.prototype.replaceText = function (range, newStr, rect, size) {
  //待实现
  var data = this.getObjData();
  if (data) {
    data.replaceText(range, newStr, rect, size);
    this.m_rect = data.getRect();
    this.m_expandRect = data.getExpandRect();
  }
};
MMText.prototype.match = function (reg_) {
  var data = this.getObjData();
  var txt = data.m_text;
  var matches = txt.match(reg_);
  return matches;
};
window.MMText = MMText;
var _default = exports["default"] = MMText;

},{"1000":1000,"1084":1084,"1184":1184,"1454":1454,"1477":1477,"1484":1484,"1489":1489,"819":819,"893":893,"901":901,"902":902,"999":999}],901:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1484);
var _goog = _interopRequireDefault(require(823));
var _MMObjElementController = _interopRequireDefault(require(892));
/**
 * 本类用于控制 MMText 对象使用 text area 进行显示和输入
 */

function MMTextAreaCtl(obj, parentDiv) {
  _MMObjElementController["default"].call(this, obj, parentDiv);
}
;
_goog["default"].inherits(MMTextAreaCtl, _MMObjElementController["default"]);
MMTextAreaCtl.prototype.createDiv = function () {
  return $("<textarea style='-webkit-text-size-adjust:none; position:absolute' readonly='readonly'>" + this.mmobj.text + "</textarea>");
};
MMTextAreaCtl.prototype.displayInDiv = function (trsfm, pgindex) {
  MMTextAreaCtl.superClass_.displayInDiv.call(this, trsfm, pgindex);
  var dvfont = Math.round(trsfm.lg2dvLen(this.mmobj.fontsize));
  this.$div.css("font-size", dvfont + "pt");
  this.$div.css("resize", "none");
  this.$div.css("border-width", "5px");
};
var _default = exports["default"] = MMTextAreaCtl;

},{"1184":1184,"1454":1454,"1484":1484,"823":823,"892":892}],1484:[function(require,module,exports){
'use strict';
var $ = require(1270);
var createHTML = require(1241);
var forcedStringHTMLMethod = require(1368);

// `String.prototype.fontsize` method
// https://tc39.es/ecma262/#sec-string.prototype.fontsize
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('fontsize') }, {
  fontsize: function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  }
});

},{"1241":1241,"1270":1270,"1368":1368}],1009:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1477);
require(1489);
var _MMBlockObj = _interopRequireDefault(require(1000));
var _ObjType = _interopRequireDefault(require(1084));
var _MMDocIconCtl = _interopRequireDefault(require(889));
/**
 * @author lishusheng ,2014-06-06
 * @param  init {bool}
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMDocument}
 */
function MMDocument(board, init) {
  _MMBlockObj["default"].call(this, board, init); //
  this.m_className = 'MMDocument';
  this.m_objType = _ObjType["default"].Obj_Document;
  this.m_image = null; //ios5
  this.m_imageNext = null; //ios5

  this.m_fileSize; //string
  this.m_filePath; //string
  this.m_fileName; //string
}
;
MMDocument.prototype = new _MMBlockObj["default"](); //
MMDocument.superclass = _MMBlockObj["default"].prototype;
MMDocument.prototype.encode = function (enc_) {
  MMDocument.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMDocument.prototype.decode = function (dec_, ver_) {
  MMDocument.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
MMDocument.prototype.draw = function (ctx, trsfm, pgindex) {
  this.drawInDiv(ctx, trsfm, pgindex);
};
MMDocument.prototype.drawInDiv = function (editor, trsfm, pgindex) {
  if (this.dispCtl == null) {
    this.dispCtl = new _MMDocIconCtl["default"](this);
  }
  this.dispCtl.displayInDiv(trsfm, pgindex, trsfm.$viewcontent[0]);
};
MMDocument.prototype.changeEditable = function (trsfm) {};
MMDocument.prototype.getFileName = function () {
  var docData = this.getObjData();
  return docData.m_fileName;
};
MMDocument.prototype.getFileSize = function () {
  var docData = this.getObjData();
  return docData.m_fileSize;
};
MMDocument.prototype.getIconName = function () {
  var type = this.getFileType().substr(0, 3);
  var iconName = "url(img/file_icon/pdf_s.png)";
  if (type.length > 0) {
    if (type == 'pdf') {} else if (type == 'mov') {
      iconName = "url(img/file_icon/mov_s.png)";
    } else {
      iconName = "url(img/file_icon/" + type + "_s.png)";
    }
  }
  return iconName;
};
MMDocument.prototype.getLinkfileName = function () {
  var docData = this.getObjData();
  return docData.getFilePath();
  return "img/test.pdf";
};
MMDocument.prototype.getFileType = function () {
  var docData = this.getObjData();
  return docData.m_fileType;
};
MMDocument.prototype.match = function (reg_) {
  var data = this.getObjData();
  var txt = data.m_fileName;
  var matches = txt.match(reg_);
  return matches;
};
var _default = exports["default"] = MMDocument;

},{"1000":1000,"1084":1084,"1184":1184,"1454":1454,"1477":1477,"1489":1489,"889":889}],1008:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMCircle = _interopRequireDefault(require(1002));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MMDocIconCtl = _interopRequireDefault(require(889));
var _ObjType = _interopRequireDefault(require(1084));
var _MMRect = _interopRequireDefault(require(831));
/**
 * 本类用于记录嵌入的文档，显示为一个文档图标
 */

function MMDoc(board) {
  _MMCircle["default"].call(this, board); //
  this.m_className = 'MMDoc';
  this.m_objType = _ObjType["default"].GObj_doc;
  this.angle = 0;

  // pixel: 140 * 35, 此处记录逻辑值
  this.width = 140 * 20 / 1024;
  this.height = 35 * 20 / 1024;
  this.fontSize = 15 * 20 / 1024;
  this.$div = null; // 绘制对象使用的浏览器元素
}
;
MMDoc.prototype = new _MMCircle["default"](); //
MMDoc.superclass = _MMCircle["default"].prototype; //

MMDoc.prototype.setOriginPoint = function (x, y) {
  if (this.m_rect == null) {
    this.m_rect = new _MMRect["default"]();
  }
  this.m_rect.setRct(x, y, this.width, this.height);
};
MMDoc.prototype.setTitle = function (title) {
  var data = this.getObjData();
  data.title = title;
};
MMDoc.prototype.getTitle = function () {
  var data = this.getObjData();
  return data.title;
};
MMDoc.prototype.setFileSize = function (size) {
  var data = this.getObjData();
  data.filesize = size;
};
MMDoc.prototype.getFileSize = function () {
  var data = this.getObjData();
  return data.filesize;
};
MMDoc.prototype.encode = function (enc_) {
  MMDoc.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMDoc.prototype.decode = function (dec_, ver_) {
  MMDoc.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
MMDoc.prototype.drawInCanvas = function (ctx, trsfm, pgindex) {
  MMDoc.superclass.drawInCanvas.call(this, ctx, trsfm, pgindex);
};
var _default = exports["default"] = MMDoc;

},{"1002":1002,"1084":1084,"1184":1184,"1454":1454,"812":812,"831":831,"889":889}],889:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _goog = _interopRequireDefault(require(823));
var _MMObjIconCtl = _interopRequireDefault(require(894));
/**
 * 此类用于管理显示 MMDoc 在屏幕上的图标，响应鼠标点击事件
 */

function MMDocIconCtl(obj, parentDiv) {
  _MMObjIconCtl["default"].call(this, obj, parentDiv);
}
;

//MMDocIconCtl.prototype = new MMObjElementController() ;//
//MMDocIconCtl.superclass = MMObject.prototype ;//

_goog["default"].inherits(MMDocIconCtl, _MMObjIconCtl["default"]);
MMDocIconCtl.prototype.createDiv = function () {
  var $div = MMDocIconCtl.superClass_.createDiv.call();
  $div.append("<form method='post' action='' target='_blank'> </form>"); // action 需要在后面动态填充

  return $div;
};
MMDocIconCtl.prototype.addEventHandler = function () {
  // goog.events.listen(this.$div[0], goog.events.EventType.CLICK, MMDocIconCtl.userClick);
  this.$div.click(function (e) {
    MMDocIconCtl.userClick(e);
  });
};

/**
 * 在 div 中显示 doc 对象的图标
 * @param {MMTransform} trsfm 坐标转换器
 * @param {Number} pgindex  当前显示的是逻辑第几页
 */
MMDocIconCtl.prototype.displayInDiv = function (trsfm, pgindex) {
  MMDocIconCtl.superClass_.displayInDiv.call(this, trsfm, pgindex);
  this.$div.attr("file-type", this.mmobj.getFileType());
  this.$div.children("form").attr("action", this.mmobj.getLinkfileName());
};

// 点击打开 pdf 文件显示内容
MMDocIconCtl.userClick = function (e) {
  var $div = $(e.currentTarget);
  var $form = $div.children("form");
  $form[0].submit();
};
var _default = exports["default"] = MMDocIconCtl;

},{"1184":1184,"1454":1454,"823":823,"894":894}],894:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _goog = _interopRequireDefault(require(823));
var _MMBasicData = _interopRequireDefault(require(811));
var _MMObjElementController = _interopRequireDefault(require(892));
/**
 * 此类用于管理显示 MMDoc 在屏幕上的图标，响应鼠标点击事件
 */

function MMObjIconCtl(obj, parentDiv) {
  _MMObjElementController["default"].call(this, obj, parentDiv);
}
;

//MMObjIconCtl.prototype = new MMObjElementController() ;//
//MMObjIconCtl.superclass = MMObject.prototype ;//

_goog["default"].inherits(MMObjIconCtl, _MMObjElementController["default"]);
MMObjIconCtl.prototype.createDiv = function () {
  var index = _MMBasicData["default"].getEditorMaxZ_index();
  return $("<div class='doc-icon' style='position:absolute;z-index:" + index + "'  filename='' >" +
  // filename 需要在后面动态填充
  "<div class='icon' style='height:90%;pointer-events:none'></div>" + "<div class='file-name' style='height:50%;pointer-events:none;overflow:hidden'></div>" + "<div class='file-size' style='pointer-events:none'></div>" + "</div>");
};

/**
 * 在 div 中显示 doc 对象的图标
 * @param {MMTransform} trsfm 坐标转换器
 * @param {Number} pgindex  当前显示的是逻辑第几页
 */
MMObjIconCtl.prototype.displayInDiv = function (trsfm, pgindex) {
  MMObjIconCtl.superClass_.displayInDiv.call(this, trsfm, pgindex);
  this.$div.attr("filename", this.mmobj.getLinkfileName()); // 动态填充 filename

  this.$div.css("background-color", "white");
  this.$div.css("box-shadow", "0px 0px 10px #000000");
  var $childs = this.$div.children();
  var $icon = $($childs[0]);
  var $file_name = $($childs[1]);
  var $file_size = $($childs[2]);
  $icon.width($icon.height());
  $icon.css("background-image", this.mmobj.getIconName());
  $icon.css("background-repeat", "no-repeat");
  $icon.css("background-position", "center");
  $icon.css("background-size", "100% 100%");
  $icon.css("float", "left");

  // file name
  $file_name.css("float", "left");
  $file_name.css("text-align", "right");
  //  $file_name.css("padding-left", "10px");
  $file_name.css("padding-right", "10px");
  $file_name.text(this.mmobj.getFileName());
  var fontsize = trsfm.lg2dvLen(this.mmobj.fontSize);
  $file_name.css("font-size", fontsize + 'px');
  $file_size.css("float", "left");
  $file_size.css("text-align", "right");
  //  $file_size.css("padding-left", "10px");
  $file_size.css("padding-right", "10px");

  //  $file_size.css("background-color", "white");

  $file_size.css("font-size", fontsize + 'px');
  $file_size.text(this.mmobj.getFileSize());

  // calcu file name size
  var file_name_height = this.$div.height() * 0.5;
  var width = this.$div.width() - $icon.width();
  var ratio = width / file_name_height;
  if (file_name_height >= 12) {
    width = width - 10; // 10 px padding
    $file_name.css("position", "static");
    $file_name.css("transform", "scale(1, 1)");
    $file_name.width(width);
    $file_name.height(file_name_height);

    // file size
    $file_size.css("position", "static");
    $file_size.css("transform", "scale(1, 1)");
    $file_size.width(width);
    $file_size.height(file_name_height);
  } else {
    //    $file_size.css("background-color", "grey");
    //    $file_name.css("background-color", "grey");

    var s = file_name_height / 12;
    $file_name.height(12);
    $file_name.width(12 * ratio - 10);
    MMCommonFun.placeScaledDiv($file_name[0], s, $icon.width(), 0);
    $file_size.height($file_name.height());
    $file_size.width($file_name.width());
    MMCommonFun.placeScaledDiv($file_size[0], s, $icon.width(), file_name_height);
  }
};
var _default = exports["default"] = MMObjIconCtl;

},{"1184":1184,"1454":1454,"811":811,"823":823,"892":892}],1007:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMCircle = _interopRequireDefault(require(1002));
var _ObjType = _interopRequireDefault(require(1084));
/**
 * @author lishusheng 2014-06-04
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMDirectionArrow}
 */
function MMDirectionArrow(board) {
  _MMCircle["default"].call(this, board); //
  this.m_className = 'MMDirectionArrow';
  this.m_objType = _ObjType["default"].GObj_cloud;
}
;
MMDirectionArrow.prototype = new _MMCircle["default"](); //
MMDirectionArrow.superclass = _MMCircle["default"].prototype; //

MMDirectionArrow.prototype.encode = function (enc_) {
  MMDirectionArrow.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMDirectionArrow.prototype.decode = function (dec_, ver_) {
  MMDirectionArrow.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
MMDirectionArrow.prototype.draw = function (ctx, trsfm, pgindex) {
  MMDirectionArrow.superclass.draw.call(this, ctx, trsfm, pgindex);
};
MMDirectionArrow.prototype.drawInCanvas = function (ctx, trsfm, pgindex) {
  MMDirectionArrow.superclass.drawInCanvas.call(this, ctx, trsfm, pgindex);
};
var _default = exports["default"] = MMDirectionArrow;

},{"1002":1002,"1084":1084,"1184":1184,"1454":1454}],1006:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMGraphics = _interopRequireDefault(require(1013));
var _ObjType = _interopRequireDefault(require(1084));
/**
 * @author lishusheng 2014-06-04
 * @param board
 * @returns {MMDiamond}
 */
function MMDiamond(board) {
  _MMGraphics["default"].call(this, board);
  this.m_objType = _ObjType["default"].GObj_diamond;
}
;
MMDiamond.prototype = new _MMGraphics["default"]();
MMDiamond.superclass = _MMGraphics["default"].prototype;
MMDiamond.prototype.m_className = 'MMDiamond';
MMDiamond.prototype.encode = function (enc_) {
  MMDiamond.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMDiamond.prototype.decode = function (dec_, ver_) {
  MMDiamond.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
var _default = exports["default"] = MMDiamond;

},{"1013":1013,"1084":1084,"1184":1184,"1454":1454}],1004:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMCircle = _interopRequireDefault(require(1002));
var _ObjType = _interopRequireDefault(require(1084));
/**
 * @author lishusheng 2014-06-04
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMCloud}
 */
function MMCloud(board) {
  _MMCircle["default"].call(this, board); //
  this.m_className = 'MMCloud';
  this.m_objType = _ObjType["default"].GObj_cloud;
}
;
MMCloud.prototype = new _MMCircle["default"](); //
MMCloud.superclass = _MMCircle["default"].prototype; //

MMCloud.prototype.encode = function (enc_) {
  MMCloud.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMCloud.prototype.decode = function (dec_, ver_) {
  MMCloud.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
var _default = exports["default"] = MMCloud;

},{"1002":1002,"1084":1084,"1184":1184,"1454":1454}],1003:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMCircle = _interopRequireDefault(require(1002));
var _ObjType = _interopRequireDefault(require(1084));
/**
 * @author lishusheng 2014-06-04
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMCircleMark}
 */
function MMCircleMark(board) {
  _MMCircle["default"].call(this, board); //
  this.m_className = 'MMCircleMark';
  this.m_objType = _ObjType["default"].GObj_circlemark;
}
;
MMCircleMark.prototype = new _MMCircle["default"](); //
MMCircleMark.superclass = _MMCircle["default"].prototype; //

MMCircleMark.prototype.encode = function (enc_) {
  MMCircleMark.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMCircleMark.prototype.decode = function (dec_, ver_) {
  MMCircleMark.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
var _default = exports["default"] = MMCircleMark;

},{"1002":1002,"1084":1084,"1184":1184,"1454":1454}],1002:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMYellowObj = _interopRequireDefault(require(1035));
var _ObjType = _interopRequireDefault(require(1084));
/**
 * MMCircle 是所有需要绘制 bezier 曲线的基础类
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMCircle}
 */
function MMCircle(board) {
  _MMYellowObj["default"].call(this, board); //
  this.m_objType = _ObjType["default"].GObj_circle;
  this.m_className = 'MMCircle';
}
;
MMCircle.prototype = new _MMYellowObj["default"](); //
MMCircle.superclass = _MMYellowObj["default"].prototype;
MMCircle.prototype.encode = function (enc_) {
  MMCircle.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMCircle.prototype.decode = function (dec_, ver_) {
  MMCircle.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
MMCircle.prototype.draw = function (ctx, trsfm, pgindex) {
  ctx.save();
  this.drawInCanvas(ctx, trsfm, pgindex);
  ctx.restore();
};
var _default = exports["default"] = MMCircle;

},{"1035":1035,"1084":1084,"1184":1184,"1454":1454}],1001:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMSegment = _interopRequireDefault(require(1029));
var _ObjType = _interopRequireDefault(require(1084));
/**
 *
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMBrokenLine}
 */
function MMBrokenLine(board) {
  _MMSegment["default"].call(this, board); //
  this.m_className = 'MMBrokenLine';
  this.m_objType = _ObjType["default"].GObj_brokenline;
}
;
MMBrokenLine.prototype = new _MMSegment["default"](); //
MMBrokenLine.superclass = _MMSegment["default"].prototype;
MMBrokenLine.prototype.encode = function (enc_) {
  MMBrokenLine.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMBrokenLine.prototype.decode = function (dec_, ver_) {
  MMBrokenLine.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
var _default = exports["default"] = MMBrokenLine;

},{"1029":1029,"1084":1084,"1184":1184,"1454":1454}],987:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMMeta = _interopRequireDefault(require(1080));
/**
 * @author lishusheng,2014-06-20
 */
function MMPromptInfo(pos_, prompt_, collabID_) {
  _MMMeta["default"].call(this);
  this.m_className = "MMPromptInfo";
  this.m_position = pos_; //MMPoint
  this.m_prompt = prompt_; //String
  this.m_coopid = collabID_;
}
;
MMPromptInfo.prototype = new _MMMeta["default"]();
MMPromptInfo.superclass = _MMMeta["default"].prototype;
MMPromptInfo.prototype.encode = function (enc_) {
  MMPromptInfo.superclass.encode.call(this, enc_);
  enc_.encodeMMPoint(this.m_position);
  enc_.encodeString(this.m_prompt);
  enc_.encode8Bytes(this.m_coopid);
};
MMPromptInfo.prototype.decode = function (dec_, ver_) {
  MMPromptInfo.superclass.decode.call(this, dec_, ver_);
  this.m_position = dec_.decodeFromMMPoint(ver_);
  this.m_prompt = dec_.decodeFromString(ver_);
  this.m_coopid = dec_.decodeFrom8Bytes(ver_);
};
var _default = exports["default"] = MMPromptInfo;

},{"1080":1080,"1184":1184,"1454":1454}],985:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMAction = _interopRequireDefault(require(963));
var _ObjType = _interopRequireDefault(require(1084));
var _MMRect = _interopRequireDefault(require(831));
var _MMUndoInfo = _interopRequireDefault(require(992));
var _MMObject = _interopRequireDefault(require(1081));
var _MMPasteInfo = _interopRequireDefault(require(986));
var _Decoder = _interopRequireDefault(require(799));
function MMPasteAction(data_, length_, count_) {
  _MMAction["default"].call(this);
  /*
   *剪贴板
   */
  this.m_info; //paste_info*
  this.m_position; //MMLgPoint

  this.m_data = data_; //arrayBuffer  unsigned char*
  this.m_length = length_; //int   js的arrayBuffer中含有length，这里不需要
  this.m_count = count_; // int
}
;
MMPasteAction.prototype = new _MMAction["default"]();
MMPasteAction.superclass = _MMAction["default"].prototype;
MMPasteAction.prototype.getClassName = function () {
  return 'MMPasteAction';
};

/**
 *
 * @param curBoard_ {MMWhiteBoard}
 * @returns {Array<MMObject>}
 */
MMPasteAction.prototype.getPastedItem = function (curBoard_) {
  var _objs = new Array(); //Array<MMObject>
  var _dec = new _Decoder["default"]();
  var ___MM_DOC_VERSION__ = 8;
  _dec.setStream(this.m_data);
  var _maxRect = new _MMRect["default"](0, 0, 0, 0);
  for (var i = 0; i < this.m_count; i++) {
    var _obj = new _MMObject["default"]();
    _obj = _dec.decodeFromObject(___MM_DOC_VERSION__);
    _obj.getObjData().decode(_dec, ___MM_DOC_VERSION__);
    var _objRect = _obj.getLogicRect();
    if (i == 0) {
      _maxRect = _objRect;
    } else {
      _maxRect.expandToInclude(_objRect); //并集
    }
    _objs.push(_obj);
  }
  var _offset = this.m_position.clone();
  _offset.subtract(_maxRect.getCenter());
  //  var _offset = this.m_position - _maxRect.getCenter();

  for (var i = 0; i < _objs.length; i++) {
    var _object = _objs[i];
    if (_object.getObjType() == _ObjType["default"].Obj_Image || _object.getObjType() == _ObjType["default"].Obj_PDF) {
      var filePath = _object.getFilePath();
      //      string _newFilePath = curBoard_->getResourceMgr()->findFilePath(filePath_);
      //            _object->setFilePath(_newFilePath);
    }
    if (_object.getObjType() == _ObjType["default"].Obj_Recorder || _object.getObjType() == _ObjType["default"].Obj_Document) {
      //待实现
    }
    if (_object != null) {
      _object.move(_offset);
    }
  }

  //将粘贴后的对象置为选中状态.......//待实现
  return _objs;
};

/*
 */

MMPasteAction.prototype.execute = function (whiteboard_) {
  /*
   */
  alert("执行PasteAction");
  var _objs = this.getPastedItem(whiteboard_);
  for (var i = 0; i < _objs.length; i++) {
    var _id = whiteboard_.__addObject(_objs[i]);
    this.m_ids.push(_id);
    //    MMCommonFun::addPageIfNeed(*_iter,false);
    //
  }
  this.calcObjsRect(_objs);

  /*
   */
  this.m_collabId = whiteboard_.getCollabIds(this.m_ids); //协作，同步
};

/*
 */
MMPasteAction.prototype.postExecuteA = function (whiteboard_) {
  MMPasteAction.superclass.postExecuteA.call(this, whiteboard_);
  /*
   */
  //  this.__createDataImg() ;
  //  whiteboard_.__notifyAction(this) ;
};

/*
 */

MMPasteAction.prototype.postExecuteP = function (whiteboard_) {
  /*
   */
  //  whiteboard_.shuffle(this.m_ids, this.m_baseObj) ;//重新排列对象
  return this.getRefreshRect();
};

//MMPasteAction.prototype.__createDataImg = function () {
//  var _enc = new Coder.Encoder ;
//  _enc.encode4Bytes(___MM_DOC_VERSION__) ;
//
//  var _count = this.m_objects.length ;
//  _enc.encode4Bytes(_count) ;
//  for (var i = 0 ; i < _count ; i ++) {
//    var _object = this.m_objects[i] ;
//    _enc.encodeObject(_object) ;
//    /*
//     *
//     */
//    if (!_object.getIncludeData()) {
//      var _objData = _object.getObjData() ;
//      _objData.encode(_enc) ;
//    }
//  }
//  this.m_image = _enc.getStream() ;
//} ;

/*

 */
MMPasteAction.prototype.encode = function (enc_) {
  /*
   */
  var _PasteInfo = new _MMPasteInfo["default"](this);
  _PasteInfo.encode(enc_);
};

//MMPasteAction.prototype.decode = function (dec_, ver_) {
//
//} ;
/**
 *
 */
MMPasteAction.prototype.getRefreshRect = function () {
  var info = new _MMUndoInfo["default"]();
  info.m_refreshRcts = this.m_objsRect;
  return info;
};
var _default = exports["default"] = MMPasteAction;

},{"1081":1081,"1084":1084,"1184":1184,"1454":1454,"799":799,"831":831,"963":963,"986":986,"992":992}],986:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMActionInfo = _interopRequireDefault(require(1077));
var _MMPasteAction = _interopRequireDefault(require(985));
var _ACTION_TYPE = _interopRequireDefault(require(1076));
var _ACTION_SOURCE = _interopRequireDefault(require(1075));
var _Decoder = _interopRequireDefault(require(799));
/**
 * @param {Array.<MMObject>}
 */
function MMPasteInfo(PasteAction_) {
  _MMActionInfo["default"].call(this, PasteAction_);
  this.m_className = 'MMPasteInfo';
  this.m_type = _ACTION_TYPE["default"].PASTE;
  this.m_source = _ACTION_SOURCE["default"].LOCAL;
  this.m_data; //arrayBuffer  unsigned char*
  this.m_length; //int   js的arrayBuffer中含有length，这里不需要
  this.m_count; // int

  if (PasteAction_ instanceof _MMPasteAction["default"]) {
    this.m_data = PasteAction_.m_data;
    this.m_length = PasteAction_.m_length;
    this.m_count = PasteAction_.m_count;
  }
}
;
MMPasteInfo.prototype = new _MMActionInfo["default"]();
MMPasteInfo.superclass = _MMActionInfo["default"].prototype;
MMPasteInfo.prototype.__getObjects = function (whiteboard_) {
  var _ret = new Array();
  if (this.m_dataImage == null) {
    return null;
  }
  var _dec = new _Decoder["default"](whiteboard_);
  _dec.setStream(this.m_dataImage);
  var _ver = _dec.decodeFrom4Bytes(___MM_DOC_VERSION__);
  var _size = _dec.decodeFrom4Bytes(_ver);
  for (var i = 0; i < _size; i++) {
    var _object = _dec.decodeFromObject(_ver);
    if (!_object.getIncludeData()) {
      _object.setIncludeData(true);
      var _objData = _object.getObjData();
      _objData.decode(_dec, _ver);
    }
    _ret.push(_object);
  }
  return _ret;
};
MMPasteInfo.prototype.encode = function (enc_) {
  MMPasteInfo.superclass.encode.call(this, enc_);
};
MMPasteInfo.prototype.decode = function (dec_, ver_) {
  MMPasteInfo.superclass.decode.call(this, dec_, ver_);
};
MMPasteInfo.prototype.getCompatible = function (whiteboard_) {
  return new _MMPasteAction["default"](this.m_data, this.m_length, this.m_count);
};
var _default = exports["default"] = MMPasteInfo;

},{"1075":1075,"1076":1076,"1077":1077,"1184":1184,"1454":1454,"799":799,"985":985}],983:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1418);
require(1463);
require(1537);
var _MMPageAction = _interopRequireDefault(require(979));
var _MMActionInfo = _interopRequireDefault(require(1077));
var _ACTION_TYPE = _interopRequireDefault(require(1076));
var _MMPageInfo = _interopRequireDefault(require(984));
var _MMPageBkGrdAction = _interopRequireDefault(require(982));
var _Page_Oper = _interopRequireDefault(require(998));
var _BackgroundPaperAttr = _interopRequireDefault(require(946));
var _map = _interopRequireDefault(require(821));
var INDEX = {
  ALL: -1
};
window.INDEX = INDEX;
/**
 * @author lishusheng,2014-06-18
 */
function MMPageBkGrdInfo(pageBkGrdAction_) {
  _MMPageInfo["default"].call(this, pageBkGrdAction_);
  this.m_className = 'MMPageBkGrdInfo';
  this.m_type = _ACTION_TYPE["default"].BACKGROUND;
  this.m_oper = _Page_Oper["default"].SET_BACKGROUND; //int32  {OPER}

  this.m_oldDefaultBackGround; //BackgroundPaperAttr
  this.m_oldMapSpecialBackGrounds; //map<unsigned, BackgroundPaperAttr>
  this.m_oldSpecialBackGround; // BackgroundPaperAttr
  this.m_paper; //BackgroundPaperAttr
  this.m_pageindex; //INDEX

  if (pageBkGrdAction_ instanceof _MMPageBkGrdAction["default"]) {
    this.m_oldDefaultBackGround = pageBkGrdAction_.m_oldDefaultBackGround;
    this.m_oldMapSpecialBackGrounds = pageBkGrdAction_.m_oldMapSpecialBackGrounds;
    this.m_oldSpecialBackGround = pageBkGrdAction_.m_oldSpecialBackGround;
    this.m_paper = pageBkGrdAction_.m_paper;
    this.m_pageindex = pageBkGrdAction_.m_pageindex;
  }
}
;
MMPageBkGrdInfo.prototype = new _MMPageInfo["default"]();
MMPageBkGrdInfo.superclass = _MMPageInfo["default"].prototype;
MMPageBkGrdInfo.prototype.getClassName = function () {
  return this.m_className;
};
MMPageBkGrdInfo.prototype.getOper = function () {
  return this.m_oper;
};
MMPageBkGrdInfo.prototype.encode = function (enc_) {
  MMPageBkGrdInfo.superclass.encode.call(this, enc_);
  enc_.encode4Bytes(this.m_paper.m_type);
  enc_.encodeString(this.m_paper.m_name);
  enc_.encodeVec4(this.m_paper.m_color, "Float");
  enc_.encode4Bytes(this.m_pageindex);
  this.m_oldSpecialBackGround.encode(enc_);
  this.m_oldDefaultBackGround.encode(enc_);
  var _length = this.m_oldMapSpecialBackGrounds.getCount();
  enc_.encode4Bytes(_length);
  this.m_oldMapSpecialBackGrounds.forEach(function (value_, key_) {
    enc_.encode4Bytes(key_);
    value_.encode(enc_);
  });
};
MMPageBkGrdInfo.prototype.decode = function (dec_, ver_) {
  MMPageBkGrdInfo.superclass.decode.call(this, dec_, ver_);
  this.m_paper = new _BackgroundPaperAttr["default"]();
  this.m_paper.m_type = dec_.decodeFrom4Bytes(ver_);
  this.m_paper.m_fileName = dec_.decodeFromString(ver_);
  this.m_paper.m_color = dec_.decodeFromVec4(ver_, "Float");
  this.m_pageindex = dec_.decodeFrom4Bytes(ver_);
  this.m_oldSpecialBackGround = new _BackgroundPaperAttr["default"]();
  this.m_oldDefaultBackGround = new _BackgroundPaperAttr["default"]();
  this.m_oldSpecialBackGround.decode(dec_, ver_);
  this.m_oldDefaultBackGround.decode(dec_, ver_);
  var _retMap = new _map["default"]();
  var _length = dec_.decodeFrom4Bytes(ver_);
  for (var i = 0; i < _length; i++) {
    var _key = dec_.decodeFrom4Bytes(ver_);
    var _value = new _BackgroundPaperAttr["default"]();
    _value.decode(dec_, ver_);
    _retMap.set(_key, _value);
  }
  this.m_oldMapSpecialBackGrounds = _retMap;
};
MMPageBkGrdInfo.prototype.getCompatible = function (whiteboard_) {
  return new _MMPageBkGrdAction["default"](this.m_oper, this.m_oldDefaultBackGround, this.m_oldMapSpecialBackGrounds, this.m_oldSpecialBackGround, this.m_paper, this.m_pageindex);
};
window.MMPageBkGrdInfo = MMPageBkGrdInfo;
var _default = exports["default"] = MMPageBkGrdInfo;

},{"1076":1076,"1077":1077,"1184":1184,"1418":1418,"1454":1454,"1463":1463,"1537":1537,"821":821,"946":946,"979":979,"982":982,"984":984,"998":998}],978:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMActionInfo = _interopRequireDefault(require(1077));
var _MMLayerAction = _interopRequireDefault(require(977));
var _ACTION_TYPE = _interopRequireDefault(require(1076));
var _ACTION_SOURCE = _interopRequireDefault(require(1075));
var Undo_Redo_Type = {
  MM_DO: 0,
  MM_UNDO: 1
};
window.Undo_Redo_Type = Undo_Redo_Type;

/**
 * @author lishusheng,2014-06-18
 */
function MMLayerInfo(layerAction_) {
  _MMActionInfo["default"].call(this, layerAction_);
  this.m_className = 'MMLayerInfo';
  this.m_type = _ACTION_TYPE["default"].CHAHANGELAYER;
  this.m_source = _ACTION_SOURCE["default"].LOCAL;
  this.m_oldIndex; //std::vector<__uint32_t>
  this.m_newStart; //__uint32_t
  this.m_id; //  vector<OBJ_ID>
  this.m_do; // 1 do, 2 undo  Undo_Redo_Type

  if (layerAction_ instanceof _MMLayerAction["default"]) {
    this.m_oldIndex = layerAction_.m_oldIndex;
    this.m_newStart = layerAction_.m_newStart;
    this.m_id = layerAction_.m_id;
    this.m_do = layerAction_.m_do;
  }
}
;
MMLayerInfo.prototype = new _MMActionInfo["default"]();
MMLayerInfo.superclass = _MMActionInfo["default"].prototype;
MMLayerInfo.prototype.getClassName = function () {
  return this.m_className;
};
MMLayerInfo.prototype.encode = function (enc_) {
  MMLayerInfo.superclass.encode.call(this, enc_);
  enc_.encodeArray(this.m_oldIndex, "4Bytes");
  enc_.encode4Bytes(this.m_newStart);
  enc_.encodeArray(this.m_id, "ObjID");
  enc_.encode1Byte(this.m_do);
};
MMLayerInfo.prototype.decode = function (dec_, ver_) {
  MMLayerInfo.superclass.decode.call(this, dec_, ver_);
  this.m_oldIndex = dec_.decodeFromArray(ver_, "4Bytes");
  this.m_newStart = dec_.decodeFrom4Bytes(ver_);
  this.m_id = dec_.decodeFromArray(ver_, "ObjID");
  this.m_do = dec_.decodeFrom1Byte(ver_);
};
MMLayerInfo.prototype.getCompatible = function (whiteboard_) {
  return new _MMLayerAction["default"](this.m_oldIndex, this.m_newStart, this.m_id, this.m_do);
};
window.MMLayerInfo = MMLayerInfo;
var _default = exports["default"] = MMLayerInfo;

},{"1075":1075,"1076":1076,"1077":1077,"1184":1184,"1454":1454,"977":977}],974:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMActionInfo = _interopRequireDefault(require(1077));
var _ACTION_TYPE = _interopRequireDefault(require(1076));
var _ACTION_SOURCE = _interopRequireDefault(require(1075));
/**
 * @author lishusheng,2014-06-20
 * @param {}
 */
function MMFetchInfo(id_) {
  _MMActionInfo["default"].call(this);
  this.m_className = 'MMFetchInfo';
  this.m_type = _ACTION_TYPE["default"].FETCH;
  this.m_source = _ACTION_SOURCE["default"].LOCAL;
  this.m_id = id_; //ObjID
}
;
MMFetchInfo.prototype = new _MMActionInfo["default"]();
MMFetchInfo.superclass = _MMActionInfo["default"].prototype;
MMFetchInfo.prototype.encode = function (enc_) {
  MMFetchInfo.superclass.encode.call(this, enc_);
  enc_.encodeObjID(this.m_id);
};
MMFetchInfo.prototype.decode = function (dec_, ver_) {
  MMFetchInfo.superclass.decode.call(this, dec_, ver_);
  this.m_id = dec_.decodeFromObjID(ver_);
};
MMFetchInfo.prototype.getCompatible = function (whiteboard_) {
  return this;
};
MMFetchInfo.prototype.compDetail_deprecated = function (info_) {};
var _default = exports["default"] = MMFetchInfo;

},{"1075":1075,"1076":1076,"1077":1077,"1184":1184,"1454":1454}],968:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMCoopInfo = _interopRequireDefault(require(969));
var _MMAction = _interopRequireDefault(require(963));
var _MMUndoInfo = _interopRequireDefault(require(992));
/**
 * @author lishusheng,2014-06-18
 * @param oldIndex_
 * @returns {MMCoopAction}
 */
function MMCoopAction(collabInfo_) {
  _MMAction["default"].call(this);

  //保存info的属性
  this.m_CollabInfo = collabInfo_; //
  this.m_collabIds.add(this.m_CollabInfo.getId());
}
;
MMCoopAction.prototype = new _MMAction["default"]();
MMCoopAction.superclass = _MMAction["default"].prototype;
MMCoopAction.prototype.getClassName = function () {
  return 'MMCoopAction';
};

/**
 * @param whiteboard_
 * @param active_  {bool}
 */
MMCoopAction.prototype.execute = function (whiteboard_, active_) {
  /*
   */
  console.log("MMCoopAction.execute");
  //  var arrayObjects = this.m_objects.getValues();//MMObject
  //  for (var i = 0 ; i < arrayObjects.length ; i ++) {
  //    var _id = whiteboard_.__addObject(arrayObjects[i]);
  //    this.m_ids.push(_id);
  //  }
  //
  //
  //  /*
  //   */
  //  this.m_collabId = whiteboard_.getCollabIds(this.m_ids) ;
};
MMCoopAction.prototype.postExecuteA = function (whiteboard_) {};
MMCoopAction.prototype.postExecuteP = function (whiteboard_) {
  //  whiteboard_.shuffle(this.m_ids, this.m_baseObj) ;
  return this.getRefreshRect();
};
MMCoopAction.prototype.encode = function (enc_) {
  var _coopInfo = new _MMCoopInfo["default"](this);
  _coopInfo.encode(enc_);
};

//MMCoopAction.prototype.decode = function (dec_, ver_) {
//
//} ;
/**
 *
 * @returns {MMUndoInfo}
 */
MMCoopAction.prototype.getRefreshRect = function () {
  var info = new _MMUndoInfo["default"]();
  info.m_refreshRcts = this.m_objsRect;
  return info;
};
var _default = exports["default"] = MMCoopAction;

},{"1184":1184,"1454":1454,"963":963,"969":969,"992":992}],969:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMActionInfo = _interopRequireDefault(require(1077));
var _MMCoopAction = _interopRequireDefault(require(968));
var _ACTION_TYPE = _interopRequireDefault(require(1076));
var _ACTION_SOURCE = _interopRequireDefault(require(1075));
/**
 * @author lishusheng,2014-06-18
 */
function MMCoopInfo(CoopAction_) {
  _MMActionInfo["default"].call(this, CoopAction_);
  this.m_className = 'MMCoopInfo';
  this.m_type = _ACTION_TYPE["default"].ADDCOOP;
  this.m_source = _ACTION_SOURCE["default"].LOCAL;
  this.m_ver = 1; //

  this.m_CollabInfo; //{MMCollabInfoTest}

  if (CoopAction_ instanceof _MMCoopAction["default"]) {
    this.m_CollabInfo = CoopAction_.m_CollabInfo;
  }
}
;
MMCoopInfo.prototype = new _MMActionInfo["default"]();
MMCoopInfo.superclass = _MMActionInfo["default"].prototype;
MMCoopInfo.prototype.getClassName = function () {
  return this.m_className;
};
MMCoopInfo.prototype.encode = function (enc_) {
  MMCoopInfo.superclass.encode.call(this, enc_);
  enc_.encodeObject(this.m_CollabInfo);
};
MMCoopInfo.prototype.decode = function (dec_, ver_) {
  MMCoopInfo.superclass.decode.call(this, dec_, ver_);
  if (ver_ < 4) {
    /*
     *xcode中  之前的版本，数据变量是MMCooperation,而非mola_session
     */
    this.m_CollabInfo = dec_.decodeFromObject(ver_); //这里后面还需要修改，以兼容以前版本
  } else {
    this.m_CollabInfo = dec_.decodeFromObject(ver_);
  }
};
MMCoopInfo.prototype.getCompatible = function (whiteboard_) {
  return new _MMCoopAction["default"](this.m_CollabInfo);
};
var _default = exports["default"] = MMCoopInfo;

},{"1075":1075,"1076":1076,"1077":1077,"1184":1184,"1454":1454,"968":968}],854:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMMessage = _interopRequireDefault(require(1079));
var _MMWhiteboard = _interopRequireDefault(require(960));
function MMSendActionPushMessage() {
  _MMMessage["default"].call(this);
  this.m_className = 'MMSendActionPushMessage';
  this.m_action;
}
;
MMSendActionPushMessage.prototype = new _MMMessage["default"]();
MMSendActionPushMessage.superclass = _MMMessage["default"].prototype;
MMSendActionPushMessage.prototype.encode = function (enc_) {
  MMSendActionPushMessage.superclass.encode.call(this, enc_);
  enc_.encodeObject(this.m_action);
};
MMSendActionPushMessage.prototype.decode = function (dec_, ver_) {
  MMSendActionPushMessage.superclass.decode.call(this, dec_, ver_);
  this.m_action = dec_.decodeFromObject(ver_);
};
MMSendActionPushMessage.prototype.respond = function (whiteboard_, conn_) {
  console.assert(whiteboard_ instanceof _MMWhiteboard["default"]);
  whiteboard_.performAction(this.m_action);
};
var _default = exports["default"] = MMSendActionPushMessage;

},{"1079":1079,"1184":1184,"1454":1454,"960":960}],852:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMMessage = _interopRequireDefault(require(1079));
function MMRdatablockMessage() {
  _MMMessage["default"].call(this);
  this.m_className = 'MMRdatablockMessage';
  this.m_image = null; //ArrayBuffer
  this.m_length = 1; //js 中字节流长度可以通过ArrayBuffer得到

  this.m_mainboard = 1; //int_64
  this.m_block = 1; // int_64
}
;
MMRdatablockMessage.prototype = new _MMMessage["default"]();
MMRdatablockMessage.prototype.encode = function (enc_) {
  _MMMessage["default"].prototype.encode.call(this, enc_);
  enc_.encode8Bytes(this.m_mainboard);
  enc_.encode8Bytes(this.m_block);
  enc_.encodeBuffer(this.m_image);
};
MMRdatablockMessage.prototype.decode = function (dec_, ver_) {
  _MMMessage["default"].prototype.decode.call(this, dec_, ver_);
  this.m_mainboard = dec_.decodeFrom8Bytes(ver_);
  this.m_block = dec_.decodeFrom8Bytes(ver_);
  this.m_image = dec_.decodeFromBuffer(ver_);
};
MMRdatablockMessage.prototype.getStream = function () {
  return this.m_image;
};
var _default = exports["default"] = MMRdatablockMessage;

},{"1079":1079,"1184":1184,"1454":1454}],850:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMServerMessage = _interopRequireDefault(require(1083));
var _MMClientMessage = _interopRequireDefault(require(1078));
/**
 * @returns {MMPromptMessage}
 */
function MMPromptMessage() {
  _MMServerMessage["default"].call(this);
  this.m_className = 'MMPromptMessage';
  this.m_coopboard; //ID
  this.m_mainboard; //ID
  this.m_prompt; //MMPromptInfo
}
;
MMPromptMessage.prototype = new _MMClientMessage["default"]();
MMPromptMessage.supperClass = _MMClientMessage["default"].prototype;
MMPromptMessage.prototype.encode = function (enc_) {
  MMPromptMessage.supperClass.encode.call(this, enc_);
  enc_.encode8Bytes(this.m_coopboard);
  enc_.encode8Bytes(this.m_mainboard);
  enc_.encodeObject(this.m_prompt);
};
MMPromptMessage.prototype.decode = function (dec_, ver_) {
  MMPromptMessage.supperClass.decode.call(this, dec_, ver_);
  this.m_coopboard = dec_.decodeFrom8Bytes(ver_);
  this.m_mainboard = dec_.decodeFrom8Bytes(ver_);
  this.m_prompt = dec_.decodeFromObject(ver_);
};
MMPromptMessage.prototype.respond = function (whiteboard_, conn_) {
  // console.assert(whiteboard_ instanceof MMWhiteboard);
};
var _default = exports["default"] = MMPromptMessage;

},{"1078":1078,"1083":1083,"1184":1184,"1454":1454}],1078:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMMessage = _interopRequireDefault(require(1079));
function MMClientMessage() {
  _MMMessage["default"].call(this);
}
;
MMClientMessage.prototype = new _MMMessage["default"]();
MMClientMessage.superclass = _MMMessage["default"].prototype;
MMClientMessage.prototype.encode = function (enc_) {
  MMClientMessage.superclass.encode.call(this, enc_);
};
MMClientMessage.prototype.decode = function (dec_, ver_) {
  MMClientMessage.superclass.decode.call(this, dec_, ver_);
};
var _default = exports["default"] = MMClientMessage;

},{"1079":1079,"1184":1184,"1454":1454}],849:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMMessage = _interopRequireDefault(require(1079));
function MMProcessMessage(userId_, coopId_, mainId_, actionInfo_) {
  _MMMessage["default"].call(this);
  this.m_className = 'MMProcessMessage';
  this.m_userId = userId_;
  this.m_coopBoard = coopId_;
  this.m_mainBoard = mainId_;
  this.m_action = actionInfo_;
}
;
MMProcessMessage.prototype = new _MMMessage["default"]();
MMProcessMessage.superclass = _MMMessage["default"].prototype;
MMProcessMessage.prototype.encode = function (enc_) {
  MMProcessMessage.superclass.encode.call(this, enc_);
  enc_.encode8Bytes(this.m_userId);
  enc_.encode8Bytes(this.m_coopBoard);
  enc_.encode8Bytes(this.m_mainBoard);
  enc_.encodeObject(this.m_action);
};
MMProcessMessage.prototype.decode = function (dec_, ver_) {
  MMProcessMessage.superclass.decode.call(this, dec_, ver_);
  this.m_userId = dec_.decodeFrom8Bytes(ver_);
  this.m_coopBoard = dec_.decodeFrom8Bytes(ver_);
  this.m_mainBoard = dec_.decodeFrom8Bytes(ver_);
  this.m_action = dec_.decodeFromObject(ver_);
};
var _default = exports["default"] = MMProcessMessage;

},{"1079":1079,"1184":1184,"1454":1454}],848:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMMessage = _interopRequireDefault(require(1079));
var _MMWhiteboard = _interopRequireDefault(require(960));
function MMJoinZoneRespMessage(buffer) {
  _MMMessage["default"].call(this);
  this.m_className = 'MMJoinZoneRespMessage';
  this.buffer = buffer; //suppose to be arraybuffer
}
;
MMJoinZoneRespMessage.prototype = new _MMMessage["default"]();
MMJoinZoneRespMessage.prototype.encode = function (enc_) {
  _MMMessage["default"].prototype.encode.call(this, enc_);
  enc_.encodeBuffer(this.buffer);
};
MMJoinZoneRespMessage.prototype = new _MMMessage["default"]();
MMJoinZoneRespMessage.prototype.decode = function (dec_, ver_) {
  _MMMessage["default"].prototype.decode.call(this, dec_, ver_);
  this.buffer = dec_.decodeFromBuffer(ver_);
};
MMJoinZoneRespMessage.prototype.respond = function (whiteboard_, conn_) {
  console.assert(whiteboard_ instanceof _MMWhiteboard["default"]);
  whiteboard_.initFromNetwork(conn_, this.buffer);
};
var _default = exports["default"] = MMJoinZoneRespMessage;

},{"1079":1079,"1184":1184,"1454":1454,"960":960}],847:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMMessage = _interopRequireDefault(require(1079));
var _MMWhiteboard = _interopRequireDefault(require(960));
function MMJoinSequenceRespMessage(actionArr) {
  _MMMessage["default"].call(this);
  this.m_className = 'MMJoinSequenceRespMessage';
  this.actionArr = actionArr; //suppose to be arrayactionArr
}
;
MMJoinSequenceRespMessage.prototype = new _MMMessage["default"]();
MMJoinSequenceRespMessage.prototype.encode = function (enc_) {
  _MMMessage["default"].prototype.encode.call(this, enc_);
  enc_.encodeArray(this.actionArr, 'Meta');
};
MMJoinSequenceRespMessage.prototype.decode = function (dec_, ver_) {
  _MMMessage["default"].prototype.decode.call(this, dec_, ver_);
  this.actionArr = dec_.decodeFromArray(ver_, 'Meta');

  //connsole.assert(actionArr instanceof MMWhiteboard);
};
MMJoinSequenceRespMessage.prototype.respond = function (whiteboard_, conn_) {
  console.assert(whiteboard_ instanceof _MMWhiteboard["default"]);
  whiteboard_.initFromActionArray(conn_, this.actionArr);
};
var _default = exports["default"] = MMJoinSequenceRespMessage;

},{"1079":1079,"1184":1184,"1454":1454,"960":960}],846:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMMessage = _interopRequireDefault(require(1079));
var _MMWhiteboard = _interopRequireDefault(require(960));
function MMJoinGlobalRespMessage(buffer) {
  _MMMessage["default"].call(this);
  this.m_className = 'MMJoinGlobalRespMessage';
  this.buffer = buffer; //suppose to be arraybuffer
}
;
MMJoinGlobalRespMessage.prototype = new _MMMessage["default"]();
MMJoinGlobalRespMessage.prototype.encode = function (enc_) {
  _MMMessage["default"].prototype.encode.call(this, enc_);
  enc_.encodeBuffer(this.buffer);
};
MMJoinGlobalRespMessage.prototype.decode = function (dec_, ver_) {
  _MMMessage["default"].prototype.decode.call(this, dec_, ver_);
  this.buffer = dec_.decodeFromBuffer(ver_);
};
MMJoinGlobalRespMessage.prototype.respond = function (whiteboard_, conn_) {
  console.assert(whiteboard_ instanceof _MMWhiteboard["default"]);
  whiteboard_.initFromNetwork(conn_, this.buffer);
};
var _default = exports["default"] = MMJoinGlobalRespMessage;

},{"1079":1079,"1184":1184,"1454":1454,"960":960}],843:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMServerMessage = _interopRequireDefault(require(1083));
/**
 *
 * @returns {MMBpromptMessage}
 */
function MMBpromptMessage() {
  _MMServerMessage["default"].call(this);
  this.m_className = 'MMBpromptMessage';
  this.m_sourceid; //ID
  this.m_sourcename; //string
  this.m_coopboard; //ID
  this.m_mainboard; //ID
  this.m_prompt; //MMPromptInfo
}
;
MMBpromptMessage.prototype = new _MMServerMessage["default"]();
MMBpromptMessage.supperClass = _MMServerMessage["default"].prototype;
MMBpromptMessage.prototype.encode = function (enc_) {
  MMBpromptMessage.supperClass.encode.call(this, enc_);
  enc_.encode8Bytes(this.m_sourceid);
  enc_.encodeString(this.m_sourcename);
  enc_.encode8Bytes(this.m_coopboard);
  enc_.encode8Bytes(this.m_mainboard);
  enc_.encodeObject(this.m_prompt);
};
MMBpromptMessage.prototype.decode = function (dec_, ver_) {
  MMBpromptMessage.supperClass.decode.call(this, dec_, ver_);
  this.m_sourceid = dec_.decodeFrom8Bytes(ver_);
  this.m_sourcename = dec_.decodeFromString(ver_);
  this.m_coopboard = dec_.decodeFrom8Bytes(ver_);
  this.m_mainboard = dec_.decodeFrom8Bytes(ver_);
  this.m_prompt = dec_.decodeFromObject(ver_);
};
MMBpromptMessage.prototype.respond = function (whiteboard_, conn_) {
  // console.assert(whiteboard_ instanceof MMWhiteboard);
};
var _default = exports["default"] = MMBpromptMessage;

},{"1083":1083,"1184":1184,"1454":1454}],1083:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMMessage = _interopRequireDefault(require(1079));
function MMServerMessage() {
  _MMMessage["default"].call(this);
}
;
MMServerMessage.prototype = new _MMMessage["default"]();
MMServerMessage.superclass = _MMMessage["default"].prototype;
MMServerMessage.prototype.encode = function (enc_) {
  MMServerMessage.superclass.encode.call(this, enc_);
};
MMServerMessage.prototype.decode = function (dec_, ver_) {
  MMServerMessage.superclass.decode.call(this, dec_, ver_);
};
var _default = exports["default"] = MMServerMessage;

},{"1079":1079,"1184":1184,"1454":1454}],842:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMWhiteboard = _interopRequireDefault(require(960));
var _MMMessage = _interopRequireDefault(require(1079));
function MMBProcessMessage() {
  _MMMessage["default"].call(this);
  this.m_className = 'MMBProcessMessage';
  this.m_userId;
  this.m_coopBoard;
  this.m_mainBoard;
  this.m_action;
}
;
MMBProcessMessage.prototype = new _MMMessage["default"]();
MMBProcessMessage.superclass = _MMMessage["default"].prototype;
MMBProcessMessage.prototype.encode = function (enc_) {
  MMBProcessMessage.superclass.encode.call(this, enc_);
  enc_.encode8Bytes(this.m_userId);
  enc_.encode8Bytes(this.m_coopBoard);
  enc_.encode8Bytes(this.m_mainBoard);
  enc_.encodeObject(this.m_action);
};
MMBProcessMessage.prototype.decode = function (dec_, ver_) {
  MMBProcessMessage.superclass.decode.call(this, dec_, ver_);
  this.m_userId = dec_.decodeFrom8Bytes(ver_);
  this.m_coopBoard = dec_.decodeFrom8Bytes(ver_);
  this.m_mainBoard = dec_.decodeFrom8Bytes(ver_);
  this.m_action = dec_.decodeFromObject(ver_);
};
MMBProcessMessage.prototype.respond = function (whiteboard_, conn_) {
  console.assert(whiteboard_ instanceof _MMWhiteboard["default"]);
  whiteboard_.performAction(this.m_action);
};
var _default = exports["default"] = MMBProcessMessage;

},{"1079":1079,"1184":1184,"1454":1454,"960":960}],228:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1461);
require(1477);
require(1412);
require(1417);
require(1463);
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDInputFileNamePanel = _interopRequireDefault(require(1125));
var _MDfileUploadList = _interopRequireDefault(require(345));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDLoadMaskView = _interopRequireDefault(require(49));
var _xmindToJson = _interopRequireDefault(require(1149));
var _jsonToXmind = _interopRequireDefault(require(1147));
var _MDExportKityminderWinView = _interopRequireDefault(require(227));
// import MDTextEditor from './MDTextEditor.js';

// const xmindparser = require('xmindparser');

var MDKityMinderEditorController = {
  editor: null,
  minder: null,
  createNewKityMinderFile: function createNewKityMinderFile() {
    if (!this.editor) {
      initPanel.call(this);
    }
  },
  initEditorWithFileInfo: function initEditorWithFileInfo(fileInfo, ver, refreshBrowserFun) {
    ver = ver || -1;
    this.refreshBrowserFun = refreshBrowserFun;
    this.fileInfo = fileInfo;
    this.fileName = this.fileInfo.getFileName();
    var self = this;
    // let data = this.fileInfo.get('kmFileData')
    // if(!data) {
    _MDLoadMaskView["default"].show();
    MMCommonFun.getDocumentDispPath(fileInfo.getFileId(), ver, function (url) {
      MMNetDiskDataController.downLoadFileData(url, function (data) {
        var decodedString = MMCommonFun.decodeFromUTF8Array(data);
        console.log(decodedString);
        if (fileInfo.getLowerCaseExt() == "xmind") {
          var blob = new Blob([data]);
          var parse = new _xmindToJson["default"]();
          parse.xmindToJSON(blob).then(function (json) {
            console.error("xmind2json");
            console.log(json);
            self.renderData(json);
          });
          // ow.kityminder.data.getRegisterProtocol('xmind').decode(blob).then(function(c) {
          //               console.warn(c)
          //               self.renderData(c)
          //             }, function(e) {
          //               console.log(e)
          //             })
        } else {
          var decodedString = MMCommonFun.decodeFromUTF8Array(data);
          self.renderData(decodedString);
        }
      }, function () {
        _MDLoadMaskView["default"].remove();
      });
    }, function (errorCode, msg) {
      _MDLoadMaskView["default"].remove();
      if (errorCode == 227) {
        _MDSnackbarView["default"].show(msg);
      } else {
        _MDSnackbarView["default"].show("[" + errorCode + "]" + BabelStr.str(5150) + "！");
      }
    });
    // } else {
    //   this.renderData(data)
    // }
  },
  renderData: function renderData(data) {
    // this.fileInfo.set('kmFileData', data)
    if (_.isString(data)) {
      data = JSON.parse(data);
    }
    if (this.editor) {
      this.editor.minder.importJson(data);
      this.originKmFileData = this.editor.minder.exportJson();
      return;
    }
    initPanel.call(this);
    this.editor.minder.importJson(data);
    this.originKmFileData = this.editor.minder.exportJson();
    _MDLoadMaskView["default"].remove();
  },
  setFileName: function setFileName(name) {
    if (name) {
      var ext = MMCommonFun.getFileExtension(name);
      var reg = /^\d*$/;
      if (ext.length == 0 || ext[ext.length - 1].length == 0 || reg.test(ext[ext.length - 1])) {
        name += ".km";
      }
      this.fileName = name;
      // this.$el.find('.text-file-name').text(name);
    } else {
      this.fileName = null;
    }
  },
  removeFromSuperview: function removeFromSuperview() {
    this.$el[0].removeEventListener('keydown', keyDownHandle);
    this.$el.remove();
    // this.editor.removeFromSuperview();
    this.editor = null;
    this.fileInfo = null;
    this.fileName = null;
    unregisterEvent.call(this);
    if (this.newVersionUploaded && this.refreshBrowserFun) {
      this.refreshBrowserFun();
    }
    this.refreshBrowserFun = undefined;
  }
};

// ---------------------  private function

function keyDownHandle() {
  console.log('Child element keydown event triggered.');
  event.stopPropagation(); // 阻止事件冒泡
}
function initPanel() {
  var text = "<div class=\"text-editor-root\">\n  <div class=\"text-panel\">\n\n    <div class=\"text-editor-tool\">\n      <img alt=\"\u5DF4\u522B\u9E1F\u4F01\u4E1A\u7F51\u76D8\u4F01\u4E1A\u79C1\u6709\u4E91\u76D8\"    src=\"/images/logo/logo_nav1_white.png\" srcset=\"/images/logo/logo_nav1_white.png 1x,/images/logo/logo_nav1_white@2x.png 2x\" class=\"clickable back-home img-bar\">\n      <div class=\"text-file-name\"></div>\n      <div class=\"text-btns flex-align middle\">\n        <div class=\"text-export button-com icon mgr-10\" data-tooltip=\"".concat(BabelStr.str(3463), "\" data-tooltip-dir=\"bottom\"></div>\n        <div class=\"text-save button-com button-icon\" data-tooltip=\"").concat(BabelStr.str(3080), "\" data-tooltip-dir=\"bottom\"></div>\n      </div>\n\n      <div class=\"text-close button-com button-icon\" data-tooltip=\"").concat(BabelStr.str(156), "\" data-tooltip-dir=\"bottom\"></div>\n\n\n    </div>\n  <div class=\"md-browser kityminder-body\" style=\"\">\n    <div class=\"kityminder-app\"  ng-app=\"kityminderDemo\" ng-controller=\"MainController\">\n      <kityminder-editor on-init=\"initEditor(editor, minder)\"></kityminder-editor>\n    </div>\n  </div>\n\n  </div>\n\n</div>");
  this.$el = $(text);
  $(".app-root").append(this.$el);
  registerEvent.call(this);
}
function registerEvent() {
  var self = this;
  this.$el.find(".back-home").on("click", function (e) {
    location.href = "main.do";
  });
  this.$el.find(".text-close").on("click", function (e) {
    closeBtnClicked.call(self, e);
  });
  this.$el.find(".text-save").on("click", function (e) {
    saveBtnClicked.call(self, e);
  });
  this.$el.find(".text-export").on("click", function (e) {
    exportClicked.call(self, e);
  });
  angular.module("kityminderDemo", ["kityminderEditor"]).config(["configProvider", function (e) {}]).controller("MainController", ["$scope", function ($scope) {
    $scope.initEditor = function (editor, minder) {
      self.editor = editor, self.minder = minder;
    };
  }]);
  this.$el[0].addEventListener('keydown', keyDownHandle);
  angular.bootstrap($(".kityminder-app"), ["kityminderDemo"]);
  // self.editor.minder.importJson(JSON.parse(data))

  $(window).on("beforeunload.km", function (event) {
    // Cancel the event as stated by the standard.
    event.preventDefault();
    // Chrome requires returnValue to be set.
    var data = self.editor.minder.exportJson();
    if (!_.isEqual(self.originKmFileData, data)) {
      event.returnValue = BabelStr.str(4860);
      return BabelStr.str(4860);
    } else {
      event.returnValue = "";
    }
  });
}
function unregisterEvent() {
  this.$el.find(".text-close").off("click");
  this.$el.find(".text-save").off("click");
  $(window).off("beforeunload.km");
}
function closeBtnClicked(e) {
  var _this = this;
  var data = this.editor.minder.exportJson();
  // data = JSON.stringify(data)

  if (_.isEqual(this.originKmFileData, data)) {
    this.removeFromSuperview();
  } else {
    var alert = new _MDAlertView["default"]();
    alert.show({
      title: BabelStr.str(170),
      message: "<p class=\"title\">".concat(BabelStr.str(5108), "</p>"),
      className: "m-delAlertWin",
      // width: 350,
      buttons: [{
        label: BabelStr.str(3080),
        type: "done",
        onClick: function onClick() {
          saveFile.call(_this, function () {
            _this.removeFromSuperview();
          });
        }
      }, {
        label: BabelStr.str(5109),
        type: "done",
        onClick: function onClick() {
          _this.removeFromSuperview();
        }
      }, {
        label: BabelStr.str(155)
      }]
    });
  }
}
function saveBtnClicked(e) {
  saveFile.call(this);
}
function exportClicked(e) {
  var win = new _MDExportKityminderWinView["default"]({
    minder: this.editor.minder,
    name: this.fileName
  });
  win.show();
}
function saveFile(callback) {
  var _this2 = this;
  if (this.fileName == null) {
    var text = this.editor.minder.exportJson();
    text = JSON.stringify(text);
    if (!text || text.length == 0) {
      _MDSnackbarView["default"].show(BabelStr.str(5110));
      return;
    }
    var inputFileNamePanel = new _MDInputFileNamePanel["default"]({
      saveFile: function saveFile(fileName) {
        _czc && _czc.push(["_trackEvent", "创建", "创建 md 文件", "", fileName, ""]);
        _this2.setFileName(fileName);
        uploadNewFile.call(_this2);
        inputFileNamePanel.close();
        if (callback) {
          callback();
        }
      }
    });
    inputFileNamePanel.show();
  } else {
    uploadNewVersion.call(this, callback);
  }
}
function uploadNewFile() {
  var _this3 = this;
  // var data = _.escape(this.editor.getText());
  var dataJson = this.editor.minder.exportJson();
  var data = JSON.stringify(dataJson);
  // console.log('--------> save file:', this.fileName);
  // data = new Blob([data], {type: 'text/plain;charset=utf-8'})

  // var dataInfo = {};
  // dataInfo.fileName = this.fileName;
  // dataInfo.name = this.fileName;
  // dataInfo.type = "text";
  // dataInfo.size = data.length;
  // dataInfo.text = data;
  // dataInfo.needCheckFileName = true

  var blob = new Blob([data], {
    type: 'text/plain'
  });
  var dataInfo = new File([blob], this.fileName);
  dataInfo.needCheckFileName = true;
  _MDfileUploadList["default"].pushFile(dataInfo, function (fileInfo) {
    _this3.originKmFileData = dataJson;
    _this3.fileInfo = fileInfo;
    if (fileInfo) {
      // this.editor && this.editor.markClean();
    } else {
      _this3.setFileName(null);
    }
    console.error("上传完毕");
    _MDAlertView["default"].showStandardPrompt({
      message: BabelStr.str(3556)
    });
  }, undefined, undefined, {
    len: 1
  });
}
function uploadNewVersion(callback) {
  var _this4 = this;
  var self = this;
  if (!this.fileInfo) {
    return;
  }

  // var data = _.escape(this.editor.getText());
  var dataJson = this.editor.minder.exportJson();
  if (_.isEqual(this.originKmFileData, dataJson)) {
    return;
  }
  var data = JSON.stringify(dataJson);
  if (this.fileInfo.getLowerCaseExt() == "xmind") {
    var parser = new _jsonToXmind["default"]();
    var newFile = new File([], this.fileName);
    parser.JSONToXmind(dataJson, newFile).then(function (data) {
      console.error("json2xmind");
      console.log(data);
      newFile = new File([data], _this4.fileName);
      _MDfileUploadList["default"].pushFile(newFile, self.fileInfo, function () {
        self.newVersionUploaded = true;
        self.originKmFileData = dataJson;
        // this.editor && this.editor.markClean();
        console.error("上传完毕");
        _MDAlertView["default"].showStandardPrompt({
          message: BabelStr.str(3556)
        });
        if (callback) {
          callback();
        }
      });
    });
    return;
  }
  var blob = new Blob([data], {
    type: 'text/plain'
  });
  var dataInfo = new File([blob], this.fileName);
  _MDfileUploadList["default"].pushFile(dataInfo, this.fileInfo, function () {
    _this4.newVersionUploaded = true;
    _this4.originKmFileData = dataJson;
    // this.editor && this.editor.markClean();
    console.error("上传完毕");
    _MDAlertView["default"].showStandardPrompt({
      message: BabelStr.str(3556)
    });
    if (callback) {
      callback();
    }
  });
}
var _default = exports["default"] = MDKityMinderEditorController;

},{"1125":1125,"1147":1147,"1149":1149,"1184":1184,"1412":1412,"1417":1417,"1454":1454,"1461":1461,"1463":1463,"1477":1477,"227":227,"32":32,"345":345,"49":49,"72":72}],227:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1439);
require(1424);
require(1423);
require(1463);
require(1487);
require(1538);
require(1545);
require(1543);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _jsonToXmind = _interopRequireDefault(require(1147));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 *
 *  Created by jichao
 *  2022-4-20
 */
var MDExportKityminderWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDExportKityminderWinView, _MDWindowView);
  function MDExportKityminderWinView() {
    (0, _classCallCheck2["default"])(this, MDExportKityminderWinView);
    return _callSuper(this, MDExportKityminderWinView, arguments);
  }
  (0, _createClass2["default"])(MDExportKityminderWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<ul>\n      <li data-type=\"json\"><%=BabelStr.str(6565)%></li>\n      <li data-type=\"text\"><%=BabelStr.str(6566)%></li>\n      <li data-type=\"markdown\"><%=BabelStr.str(6567)%></li>\n      <li data-type=\"svg\"><%=BabelStr.str(6568)%></li>\n      <li data-type=\"png\"><%=BabelStr.str(6569)%></li>\n      <li data-type=\"xmind\"><%=BabelStr.str(6570)%></li>\n    </ul>\n\n    ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDExportKityminderWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {});
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDExportKityminderWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click li': this._export
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDExportKityminderWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " export-kityMinder-win");
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      // opt.size = 'small'
      opt.title = BabelStr.str(6564);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDExportKityminderWinView.prototype), "initialize", this).call(this, opt);
      var self = this;
      if (this.name) {
        var nameArr = this.name.split('.');
        nameArr.pop();
        this.name = nameArr.join('.');
      } else {
        this.name = BabelStr.str(6361);
      }
    }
  }, {
    key: "_export",
    value: function _export($e) {
      var self = this;
      var type = $($e.target).data('type');
      if (type == 'xmind') {
        var dataJson = self.minder.exportJson();
        var newFile = new File([], 'a.xmind');
        var parser = new _jsonToXmind["default"]();
        parser.JSONToXmind(dataJson, newFile).then(function (data) {
          console.error('json2xmind');
          console.log(data);
          var blob = new Blob([data], {
            type: "application/octet-stream"
          });
          self.fileDownload(blob, self.name, '.xmind');
        });
        return;
      }
      var params = kityminder.data.getRegisterProtocol(type);
      var fileName = this.name;
      switch (params.name) {
        case 'json':
        case 'markdown':
        case 'text':
        case 'svg':
          this.minder.exportData(params.name).then(function (data) {
            var blob = new Blob([data], {
              type: params.mineType
            });
            self.fileDownload(blob, self.name, params.fileExtension);
          });
          break;
        case 'png':
          this.minder.exportData(params.name).then(function (data) {
            self.downloadBase64(data, self.name, params.fileExtension);
          });
          break;
      }
    }
  }, {
    key: "fileDownload",
    value: function fileDownload(blob, name, suffix) {
      var fullName = "".concat(name + suffix);
      // IE10+ 浏览器特殊处理
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, fullName);
      } else {
        var href = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = href;
        a.download = fullName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(href);
        document.body.removeChild(a);
      }
    }
  }, {
    key: "downloadBase64",
    value: function downloadBase64(href, name, suffix) {
      var fullName = "".concat(name + suffix);
      var a = document.createElement('a');
      a.href = href;
      a.download = fullName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  }]);
  return MDExportKityminderWinView;
}(_MDWindowView2["default"]);

},{"1147":1147,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1423":1423,"1424":1424,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"1487":1487,"1538":1538,"1543":1543,"1545":1545,"93":93}],1147:[function(require,module,exports){
(function (process,__dirname){(function (){
"use strict";

require(1475);
require(1429);
require(1437);
require(1478);
require(1439);
require(1419);
require(1487);
require(1477);
require(1503);
require(1500);
require(1502);
require(1423);
require(1538);
require(1422);
var _interopRequireDefault = require(1184);
var _regenerator = _interopRequireDefault(require(1199));
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
require(1463);
require(1471);
require(1424);
require(1541);
require(1427);
require(1412);
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
var JSZip = require("jszip");

// const xmind = require('xmind');

// const library = Object.keys(xmind).length ? xmind : window;
var _window = window,
  Workbook = _window.Workbook,
  Topic = _window.Topic,
  Dumper = _window.Dumper,
  Marker = _window.Marker,
  Zipper = _window.Zipper;
var workbook = new Workbook(),
  marker = new Marker();
var path = require(1551);
var utils = require(1148);
var parser = /*#__PURE__*/function (_utils) {
  (0, _inherits2["default"])(parser, _utils);
  function parser() {
    (0, _classCallCheck2["default"])(this, parser);
    return _callSuper(this, parser, arguments);
  }
  (0, _createClass2["default"])(parser, [{
    key: "JSONToXmind",
    value: function JSONToXmind() {
      var _this2 = this;
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var filePath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : path.join(__dirname, '../');
      var _superprop_getGuid = function _superprop_getGuid() {
          return (0, _get2["default"])((0, _getPrototypeOf2["default"])(parser.prototype), "guid", _this2);
        },
        _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _res$root, root, data, _ref, text, id, sheetTitle, zip, topic, list, cidData, addData, zipper, status, dumper, files, _iterator, _step, file, blob;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              //任务进度
              _res$root = res.root, root = _res$root === void 0 ? {} : _res$root;
              data = root.data;
              _ref = data || {}, text = _ref.text, id = _ref.id;
              sheetTitle = _superprop_getGuid().call(_this);
              zip = new JSZip();
              topic = new Topic({
                sheet: workbook.createSheet(sheetTitle, text)
              }); //添加优先级
              _this.setMarker(topic, data); //children数据数组转换
              list = _this.treeShapeToObj(root.children, id); //cid记录层次，避免层次不对
              cidData = {}; // 手动写入xmind数据
              addData = function addData() {
                var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var res = list[index];
                if (!res) return;
                var _res$data = res.data,
                  id = _res$data.id,
                  text = _res$data.text;
                topic.on(cidData[res.parentId]);
                cidData[id] = topic.add({
                  title: text
                }).cid();
                _this.setMarker(topic, res.data, cidData[id]);
                addData(++index);
              };
              addData();
              if (!(typeof window === 'undefined')) {
                _context.next = 21;
                break;
              }
              zipper = new Zipper({
                path: filePath,
                workbook: workbook,
                filename: sheetTitle
              });
              _context.next = 16;
              return zipper.save();
            case 16:
              status = _context.sent;
              setTimeout(function () {
                return process.exit(status ? 0 : 1);
              });
              return _context.abrupt("return", Promise.resolve(filePath));
            case 21:
              //生成文件夹
              dumper = new Dumper({
                workbook: workbook
              });
              files = dumper.dumping();
              _iterator = _createForOfIteratorHelper(files);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  file = _step.value;
                  zip.file(file.filename, file.value);
                } //压缩脑图json数据如果有直接返回
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              zip.file(_this.kityminder, JSON.stringify(res)); //压缩成xmind文件
              _context.next = 28;
              return zip.generateAsync({
                type: 'blob'
              });
            case 28:
              blob = _context.sent;
              return _context.abrupt("return", Promise.resolve(blob));
            case 30:
              _context.next = 35;
              break;
            case 32:
              _context.prev = 32;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", Promise.reject(_context.t0));
            case 35:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 32]]);
      }))();
    } // 树形结构转数组
  }, {
    key: "treeShapeToObj",
    value: function treeShapeToObj() {
      var _this3 = this;
      var child = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var parentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _get2["default"])((0, _getPrototypeOf2["default"])(parser.prototype), "guid", this).call(this);
      return child.reduce(function (arr, res) {
        var children = res.children,
          data = res.data;
        if (!data.id) data.id = (0, _get2["default"])((0, _getPrototypeOf2["default"])(parser.prototype), "guid", _this3).call(_this3);
        return arr.concat([{
          data: data,
          parentId: parentId
        }], _this3.treeShapeToObj(children, data.id));
      }, []);
    } //设置额外的标记属性，如链接，图片，进度等
  }, {
    key: "setMarker",
    value: function setMarker(topic, data, cid) {
      var priority = data.priority,
        progress = data.progress,
        note = data.note;
      topic.on(cid).marker(marker.priority(priority)) //任务进度
      .marker(marker.task(this.task[progress - 1])) //添加备注
      .note(note);
    }
  }]);
  return parser;
}(utils);
module.exports = parser;

}).call(this)}).call(this,require(1552),"/javascript/vendor/xmind")
},{"1148":1148,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1199":1199,"1412":1412,"1419":1419,"1422":1422,"1423":1423,"1424":1424,"1427":1427,"1429":1429,"1437":1437,"1439":1439,"1463":1463,"1471":1471,"1475":1475,"1477":1477,"1478":1478,"1487":1487,"1500":1500,"1502":1502,"1503":1503,"1538":1538,"1541":1541,"1551":1551,"1552":1552,"jszip":"jszip"}],1427:[function(require,module,exports){
'use strict';
var $ = require(1270);
var $reduce = require(1224).left;
var arrayMethodIsStrict = require(1223);
var CHROME_VERSION = require(1267);
var IS_NODE = require(1264);

var STRICT_METHOD = arrayMethodIsStrict('reduce');
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || CHROME_BUG }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});

},{"1223":1223,"1224":1224,"1264":1264,"1267":1267,"1270":1270}],185:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDManuscriptBoxView = _interopRequireDefault(require(176));
var _MDCreateMsAnonyBoxWinView = _interopRequireDefault(require(173));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDMsBoxCreateSelectWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDMsBoxCreateSelectWinView, _MDWindowView);
  function MDMsBoxCreateSelectWinView() {
    (0, _classCallCheck2["default"])(this, MDMsBoxCreateSelectWinView);
    return _callSuper(this, MDMsBoxCreateSelectWinView, arguments);
  }
  (0, _createClass2["default"])(MDMsBoxCreateSelectWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<div><%=BabelStr.str(4751)%></div>\n      <div class=\"radio-group\">\n        <div class=\"setting-item\">\n          <div class=\"radio-box checked\" data-type='1'><%=BabelStr.str(4752)%></div>        \n          <div><%=BabelStr.str(4754)%></div>\n        </div>\n        <div class=\"setting-item\">\n          <div class=\"radio-box\" data-type='2'><%=BabelStr.str(4753)%></div>\n          <div><%=BabelStr.str(4755)%></div>\n        </div>\n\n      </div>\n      <div class=\"flex-align end mgt-20\">\n        <span class=\"button cancel mgr-10\"><%=BabelStr.str(155)%></span>\n        <span class=\"button done save\"><%=BabelStr.str(3139)%></span>\n      </div>\n\t\t";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMsBoxCreateSelectWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {});
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMsBoxCreateSelectWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " msbox-select-win");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMsBoxCreateSelectWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .setting-item': this._itemHandle,
        'click .cancel': this.close,
        'click .save': this._nextHandle
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMsBoxCreateSelectWinView.prototype), "initialize", this).call(this, props);
      this.setTitle(BabelStr.str(370));
      this.props = props;
    }
  }, {
    key: "_itemHandle",
    value: function _itemHandle($e) {
      var $curItem = $($e.target).closest('.setting-item').find('.radio-box');
      if ($curItem.hasClass("checked")) {
        return;
      } else {
        this.$('.radio-box').removeClass("checked");
        $curItem.addClass("checked");
      }
    }
  }, {
    key: "_nextHandle",
    value: function _nextHandle() {
      var type = this.$('.checked').data('type');
      console.log(type);
      if (type == 2) {
        var win = new _MDManuscriptBoxView["default"]({
          fileInfo: this.fileInfo
        });
        win.show();
      } else {
        var _win = new _MDCreateMsAnonyBoxWinView["default"]({
          fileInfo: this.fileInfo
        });
        _win.show();
      }
      this.close();
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MDProjectCreateSelectPageView';
    }
  }]);
  return MDMsBoxCreateSelectWinView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1417":1417,"1454":1454,"1463":1463,"1475":1475,"173":173,"176":176,"93":93}],173:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationWindowView = _interopRequireDefault(require(92));
var _MDCreateMSAnonyBoxPageView = _interopRequireDefault(require(172));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
// import MDCreateMSAnonyBoxInfoPageView from './MDCreateMSAnonyBoxInfoPageView.js'
var MDCreateMsAnonyBoxWinView = exports["default"] = /*#__PURE__*/function (_MDNavigationWindowVi) {
  (0, _inherits2["default"])(MDCreateMsAnonyBoxWinView, _MDNavigationWindowVi);
  function MDCreateMsAnonyBoxWinView() {
    (0, _classCallCheck2["default"])(this, MDCreateMsAnonyBoxWinView);
    return _callSuper(this, MDCreateMsAnonyBoxWinView, arguments);
  }
  (0, _createClass2["default"])(MDCreateMsAnonyBoxWinView, [{
    key: "initialize",
    value: function initialize(props) {
      // props.size = 'large'     
      props.rootNavigationPageView = new _MDCreateMSAnonyBoxPageView["default"](props);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDCreateMsAnonyBoxWinView.prototype), "initialize", this).call(this, props);
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MDCreateMsAnonyBoxWinView';
    }
  }]);
  return MDCreateMsAnonyBoxWinView;
}(_MDNavigationWindowView["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"172":172,"92":92}],172:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
require(1498);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDChooseFolderWindow = _interopRequireDefault(require(483));
var _MDCreateMSAnonyBoxInfoPageView = _interopRequireDefault(require(171));
var _MDFileOperationManager = _interopRequireDefault(require(326));
var _MDSnackbarView = _interopRequireDefault(require(72));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDCreateMSAnonyBoxPageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDCreateMSAnonyBoxPageView, _MDNavigationPageView);
  function MDCreateMSAnonyBoxPageView() {
    (0, _classCallCheck2["default"])(this, MDCreateMSAnonyBoxPageView);
    return _callSuper(this, MDCreateMSAnonyBoxPageView, arguments);
  }
  (0, _createClass2["default"])(MDCreateMSAnonyBoxPageView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<form>\n    <div><%=BabelStr.str(4754)%></div>\n      <div class=\"boxpos-block mgb-10 row mgt-20\">\n        <label class=\"col-3\"><%=BabelStr.str(3287)%></label>\n        <div class=\"col-9 flex-align between\">\n          <label class=\"positionstr\"></label>\n          <label class=\"otherPos text-button done\">  <%=BabelStr.str(3288)%></label>\n        </div>\n      </div>\n      <div class=\"boxname-block mgb-10 row\">\n        <label class=\"col-3\"><%=nameStr%></label>\n        <div class=\"col-9\">\n          <input type=\"text\" id=\"msbox-name\" name=\"box-name\" class=\"form-control testFileNameEnd testFileName notempty\" required maxlength=\"100\" testFileName placeholder=\"<%=nameStr%> \">\n        </div>\n      </div>\n      <div class=\"comments-block mgb-10 row\">\n        <label class=\"col-3\"><%=remarkStr%></label>\n        <div class=\"col-9\">\n          <textarea class = \"form-control comment textinput\" maxlength=\"100\" name=\"box-message\" id=\"\" cols=\"30\" rows=\"4\" placeholder=\"<%=BabelStr.str(7026)%>\"></textarea>\n\n            <div class=\"conment-tip text-right help-block\"><%=numBefore%><span class=\"num\">100</span><%=numAfter%></div>\n\n        </div>\n      </div>\n      <div class=\"end-date-block mgb-10 row\">\n        <label class=\"col-3\"><%=endTimeStr%></label><!-- \u622A\u6B62\u65E5\u671F -->\n        <div class=\"col-7\">\n          <div class = \"datepicker \">\n            <input type=\"text\" class=\"date-end\" name=\"end-date\" required  placeholder=\"<%=dateStr%>\">\n              <i class = \"ep-ic ep-ic-date\"></i>\n          </div>\n        </div>\n      </div>\n      </form>\n      <div class=\"flex-align end mgtb-20\">\n        <span class=\"button cancel mgr-10\"><%=BabelStr.str(155)%></span>\n        <span class=\"button done save\"><%=BabelStr.str(3139)%></span>\n      </div>\n\t\t";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDCreateMSAnonyBoxPageView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        parentId: '0',
        commentNum: 100
      });
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        "nameStr": BabelStr.str(3226),
        "remarkStr": BabelStr.str(361),
        "numBefore": BabelStr.str(3160),
        "numAfter": BabelStr.str(3161),
        "endTimeStr": BabelStr.str(176),
        "dateStr": BabelStr.str(3231)
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDCreateMSAnonyBoxPageView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDCreateMSAnonyBoxPageView.prototype), "className", this).call(this);
      return "".concat(superCls, " msbox-select-win");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDCreateMSAnonyBoxPageView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .setting-item': this._itemHandle,
        'click .cancel': this.close,
        'click .save': this._nextHandle,
        'keyup .comment': this._commentInputHandle,
        'click .otherPos': this._checkOtherPosition
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      props.size = 'large';
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDCreateMSAnonyBoxPageView.prototype), "initialize", this).call(this, props);
      var self = this;
      this.setTitle(BabelStr.str(4756));
      this.props = props;
      // this.parentId = this.fileInfo.getParentFolderId();
      this.datePicker = this.$(".date-end").datepicker().on("change", function () {
        self.enddate = this.value;
      });
      this.parentId = app.currentFolder.getFileId();
      if (this.isOnlyDepFolder()) {
        this.$(".positionstr").html("<span class=\"red\">".concat(BabelStr.str(7197), "</span>"));
        this.parentId = -1;
      } else {
        var path = app.pathRouter.getFilePathsNameStr();
        this.$(".positionstr").html(path);
      }
      this.$(".date-end").datepicker("option", "minDate", new Date());
      this.$createBtn = this.$('.save');
    }
  }, {
    key: "isOnlyDepFolder",
    value: function isOnlyDepFolder() {
      return app.pathRouter.isInRoot() && app.pathRouter.isInMsBox() && !app.currentUser.canOwnFile();
    }
  }, {
    key: "_commentInputHandle",
    value: function _commentInputHandle() {
      var comment = this.$(".comment").val().toString();
      var length = comment.length;
      var num = this.commentNum - length;
      if (num < 0) {
        num = 0;
        comment = comment.substring(0, this.commentNum);
        this.$(".comment").val(comment);
      }
      this.$(".comments-block .num").html(num);
    }
  }, {
    key: "_checkOtherPosition",
    value: function _checkOtherPosition() {
      var _this = this;
      var folderView = new _MDChooseFolderWindow["default"]({
        onlyEp: this.isOnlyDepFolder(),
        onchecked: function onchecked(folderId, pathStr) {
          _this.checkFolderCallback(folderId, pathStr);
        }
      });
      folderView.show();
    }
  }, {
    key: "checkFolderCallback",
    value: function checkFolderCallback(folderId, pathStr) {
      this.parentId = folderId;
      this.$(".positionstr").html(pathStr);
    }
  }, {
    key: "close",
    value: function close() {
      this.navigationWindowView.close();
    }
  }, {
    key: "_nextHandle",
    value: function _nextHandle() {
      var _this2 = this;
      //  let page = new MDCreateMSAnonyBoxInfoPageView({boxId: 25, close: ()=>{
      //     this.navigationWindowView.close()
      //   },
      //   hideCloseBtn: ()=>{
      //     this.navigationWindowView.hideCloseBtn()
      //   }
      // })
      //   this.navigationWindowView.push(page)
      //   return

      if (this.parentId == -1) {
        MDMessageView.error(BabelStr.str(7197), this.navigationWindowView.$body);
        return;
      }
      this.$createBtn.prop('disabled', true);
      this.$createBtn.text(BabelStr.str(3303));
      if (!this.$("form").validate().form()) {
        this.$createBtn.prop('disabled', false);
        this.$createBtn.text(BabelStr.str(3229));
        this.navigationWindowView && this.navigationWindowView.refreshWindow();
        return;
      }
      // return
      var commentStr = this.$(".comment").val() || '';
      commentStr = commentStr.trim();
      var name = this.$("#msbox-name").val() || '';
      name = name.trim();
      var endTime = this.$('.date-end').val();
      endTime = new Date(endTime);
      endTime.setHours(23);
      endTime.setMinutes(59);
      endTime = endTime.getTime() / 1000;
      var isHttps;
      if (location.protocol == "https:") {
        isHttps = true;
      } else {
        isHttps = false;
      }
      MMEnterpriseController.createAnonyBox(name, isHttps, endTime, commentStr, this.parentId, function (data) {
        var page = new _MDCreateMSAnonyBoxInfoPageView["default"]({
          boxId: data.anonyBoxId,
          close: function close() {
            _this2.navigationWindowView.close();
          },
          hideCloseBtn: function hideCloseBtn() {
            _this2.navigationWindowView.hideCloseBtn();
          }
        });
        _this2.navigationWindowView.push(page);
        if (app.currentFolder.getFileId() == _this2.parentId) {
          var fileInforCollection = _MDFileOperationManager["default"].getDispFileInfoCollection();
          fileInforCollection.addFileBlowStickonTop(data.fileInfo);
          _MDSnackbarView["default"].show(BabelStr.str(3586));
        }
      }, function (code, msg) {
        if (code == 20001) {
          msg = BabelStr.str(7506);
        }
        if (!msg) {
          msg = code + ":" + BabelStr.str(309);
        }
        _this2.$createBtn.prop('disabled', false);
        _this2.$createBtn.text(BabelStr.str(3229));
        _MDSnackbarView["default"].show(msg);
      });
      this.navigationWindowView.refreshWindow();
    }
  }]);
  return MDCreateMSAnonyBoxPageView;
}(_MDNavigationPageView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1437":1437,"1454":1454,"1463":1463,"1475":1475,"1478":1478,"1498":1498,"171":171,"326":326,"483":483,"56":56,"72":72}],171:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1498);
require(1412);
require(1417);
require(1463);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDMsAnonyBoxShowInfoPageView = _interopRequireDefault(require(182));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDCreateMSAnonyBoxInfoPageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDCreateMSAnonyBoxInfoPageView, _MDNavigationPageView);
  function MDCreateMSAnonyBoxInfoPageView() {
    (0, _classCallCheck2["default"])(this, MDCreateMSAnonyBoxInfoPageView);
    return _callSuper(this, MDCreateMSAnonyBoxInfoPageView, arguments);
  }
  (0, _createClass2["default"])(MDCreateMSAnonyBoxInfoPageView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n      <div class=\"qrcode\"></div>\n      <p class=\"text-button f-tc copy-qrcode\"><%=BabelStr.str(5416)%></p>\n      <div class=\"f-tc f-link\"></div>\n      <div class=\"f-tc help-block\"><%=BabelStr.str(4767)%></div>\n      <div class=\"flex-align between mgt-20 pdt-10\">\n        <span><%=BabelStr.str(4757)%></span>\n      </div>\n      <div class=\" help-block\"><%=BabelStr.str(4771)%></div>\n      <form class=\"info-list\"></form>\n      <span class=\"text-button done add-info-item mgt-10\"><%=BabelStr.str(4760)%></span>\n      <div class=\"flex-align end mgtb-20\">\n        <span class=\"button done save\"><%=BabelStr.str(3080)%></span>\n      </div>\n\t\t";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDCreateMSAnonyBoxInfoPageView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        initData: [{
          caption: BabelStr.str(4758),
          placeholder: BabelStr.str(4759, {
            name: BabelStr.str(4758)
          })
        }, {
          caption: BabelStr.str(5313),
          placeholder: BabelStr.str(4759, {
            name: BabelStr.str(5313)
          })
        }]
      });
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        "nameStr": BabelStr.str(3226),
        "remarkStr": BabelStr.str(361),
        "numBefore": BabelStr.str(3160),
        "numAfter": BabelStr.str(3161),
        "endTimeStr": BabelStr.str(176),
        "dateStr": BabelStr.str(3231)
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDCreateMSAnonyBoxInfoPageView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDCreateMSAnonyBoxInfoPageView.prototype), "className", this).call(this);
      return "".concat(superCls, " ms-anony-box-info");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDCreateMSAnonyBoxInfoPageView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .add-info-item': this._addItemHandle,
        'click .cancel': this.close,
        'click .save': this._nextHandle,
        // 'blur ._caption': this._blurCaptionHandle,
        'click .show-info': this.showInfo,
        'click .remove-item': this._removeItemHandle,
        'click .edit-item-btn': this._startEditItem,
        'click .edit-save-btn': this._endEditItem,
        'click .qrcode-canvas canvas': this._copyQrcode,
        'click .copy-qrcode': this._copyQrcode
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      // props.size = 'large'
      props.showNavigationBar = false;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDCreateMSAnonyBoxInfoPageView.prototype), "initialize", this).call(this, props);
      this.hideCloseBtn();
      this.nameVar = 0;
      var self = this;
      this.setTitle(BabelStr.str(4756));
      this.props = props;
      this.renderQrcode();
      this.addInit();

      // $('body').on('click', $e=>{
      //   if($($e.target).hasClass('edit-item-btn')) {
      //     return
      //   }
      //   if($($e.target).closest('.ms-anony-box-info .info-item.edit').length) {
      //     return
      //   }
      //   if(!$($e.target).find('.ms-anony-box-info .edit').length) {
      //     this.$('.edit').removeClass('edit')
      //   }
      // })
    }
  }, {
    key: "_copyQrcode",
    value: function _copyQrcode(e) {
      var self = this;
      var target = this.$('.qrcode canvas')[0];
      MMCommonFun.clipboardCopyCanvas(target, function () {
        console.log('success');
        MDMessageView.success(BabelStr.str(5415), self.$el);
      }, function () {
        MDMessageView.error(BabelStr.str(5418), self.$el);
        console.log('fail');
      });
    }
  }, {
    key: "_blurCaptionHandle",
    value: function _blurCaptionHandle($e) {
      var val = $($e.target).val() || '';
      val = val.trim();
      var $placeholder = $($e.target).siblings('._placeholder');
      $placeholder.val(BabelStr.str(4759, {
        name: val
      }));
    }
  }, {
    key: "getLink",
    value: function getLink(callback) {
      MMEnterpriseController.getMsAnonyBoxUrl(this.boxId, function (url) {
        callback(url);
      });
    }
  }, {
    key: "renderQrcode",
    value: function renderQrcode() {
      var _this = this;
      this.getLink(function (link) {
        _this.$(".qrcode").empty().qrcode({
          width: 100,
          height: 100,
          text: link
        });
        _this.$('.f-link').text(link);
        _this.navigationWindowView && _this.navigationWindowView.refreshWindow();
      });
    }
  }, {
    key: "_addItemHandle",
    value: function _addItemHandle($e) {
      $e.stopPropagation();
      this._endEditItem();
      this.addInfoItem('', '', true);
      this.navigationWindowView.refreshWindow();
    }
  }, {
    key: "addInfoItem",
    value: function addInfoItem(caption, placeholder, edit) {
      var cls = edit ? 'edit' : '';
      var tmpl = "<div class=\"info-item flex-align ".concat(cls, "\">\n        <div class=\"input-contain fullfill\">\n          <div class='__input_parent'>\n            <input type=\"text\" maxlength=\"20\" name=\"_caption").concat(this.nameVar, "\"  required notempty class=\"_caption\" placeholder=\"").concat(BabelStr.str(4761), "\" value='").concat(caption, "'>\n          </div>\n          <div class='__input_parent'>\n            <input type=\"text\" maxlength=\"20\" name=\"_placeholder").concat(this.nameVar, "\" class=\"_placeholder\" placeholder=\"").concat(BabelStr.str(4762), "\" value=\"").concat(placeholder, "\">\n          </div>\n        </div>\n        <span class='edit-item-btn'>").concat(BabelStr.str(3070), "</span>\n        <span class='edit-save-btn'>").concat(BabelStr.str(154), "</span>\n        <span class='remove-item'></span>\n      </div>");
      this.$('.info-list').append(tmpl);
      this.nameVar++;
    }
  }, {
    key: "_removeItemHandle",
    value: function _removeItemHandle($e) {
      var $target = $($e.target).closest('.info-item');
      $target.remove();
      this.navigationWindowView.refreshWindow();
    }
  }, {
    key: "addInit",
    value: function addInit() {
      for (var i = 0; i < this.initData.length; i++) {
        this.addInfoItem(this.initData[i].caption, this.initData[i].placeholder);
      }
    }
  }, {
    key: "getInputs",
    value: function getInputs() {
      var $items = this.$('.info-item');
      var out = [];
      for (var i = 0; i < $items.length; i++) {
        var caption = $items.eq(i).find('._caption').val() || '';
        caption = caption.trim();
        if (caption) {
          var placeholder = $items.eq(i).find('._placeholder').val() || '';
          placeholder = placeholder.trim();
          out.push({
            caption: caption,
            placeholder: placeholder
          });
        }
      }
      return out;
    }
  }, {
    key: "showInfo",
    value: function showInfo() {
      var inputs = this.getInputs();
      var page = new _MDMsAnonyBoxShowInfoPageView["default"]({
        inputs: inputs
      });
      this.navigationWindowView.push(page);
    }
  }, {
    key: "close",
    value: function close() {
      this.close();
    }
  }, {
    key: "_nextHandle",
    value: function _nextHandle() {
      var _this2 = this;
      if (this.saving) {
        return;
      }
      var validate = this.$('form').validate();
      if (!validate.form()) {
        this.navigationWindowView && this.navigationWindowView.refreshWindow();
        return;
      }
      this.saving = true;
      var out = this.getInputs();
      var data = {
        addMetaData: out,
        msBoxId: this.boxId,
        deleteIds: [],
        updateMetaData: []
      };
      MMEnterpriseController.updateMsAnonyBoxUploaderMetaData(data, function () {
        _this2.saving = false;
        _this2.close();
      }, function () {
        _this2.saving = false;
      });
    }
  }, {
    key: "_startEditItem",
    value: function _startEditItem($e) {
      this._endEditItem();
      this.$('.save').attr('disabled', true);
      var $item = $($e.target).closest('.info-item');
      $item.addClass('edit');
    }
  }, {
    key: "_endEditItem",
    value: function _endEditItem() {
      var validate = this.$('form').validate();
      if (!validate.form()) {
        this.navigationWindowView.refreshWindow();
        return;
      }
      this.$('.edit').removeClass('edit');
      this.$('.save').attr('disabled', false);
    }
  }]);
  return MDCreateMSAnonyBoxInfoPageView;
}(_MDNavigationPageView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1417":1417,"1454":1454,"1463":1463,"1475":1475,"1498":1498,"182":182,"56":56}],184:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDTabView = _interopRequireDefault(require(82));
var _MDMsAnonyBoxBascInfoTabPanelView = _interopRequireDefault(require(181));
var _MDMSAnonyBoxInputTabPanelView = _interopRequireDefault(require(174));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDMsAnonyBoxTabWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDMsAnonyBoxTabWinView, _MDWindowView);
  function MDMsAnonyBoxTabWinView() {
    (0, _classCallCheck2["default"])(this, MDMsAnonyBoxTabWinView);
    return _callSuper(this, MDMsAnonyBoxTabWinView, arguments);
  }
  (0, _createClass2["default"])(MDMsAnonyBoxTabWinView, [{
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMsAnonyBoxTabWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        width: 710,
        createMsBox: true,
        canEdit: true
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMsAnonyBoxTabWinView.prototype), "className", this).call(this);
      return superCls + ' msAnony-tab-win';
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      var _this = this;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMsAnonyBoxTabWinView.prototype), "initialize", this).call(this, opt);
      var tabs = [];
      opt.close = function () {
        _this.close();
      };
      var self = this;
      _MDSpinnerloaderView["default"].showIn(this.$body);
      MMEnterpriseController.getAnonyBoxByFolder(this.fileInfo.getFileId(), function (data) {
        _MDSpinnerloaderView["default"].clearFrom(_this.$body);
        opt.data = data;
        opt.close = function () {
          self.close();
        };
        _this.settingPanelView = new _MDMsAnonyBoxBascInfoTabPanelView["default"](opt);
        tabs.push({
          title: BabelStr.str(2382),
          tabPanelView: _this.settingPanelView,
          active: true
        });
        _this.inputsPanelView = new _MDMSAnonyBoxInputTabPanelView["default"](opt);
        tabs.push({
          title: BabelStr.str(4768),
          tabPanelView: _this.inputsPanelView
        });
        _this.tabView = new _MDTabView["default"]({
          className: 'share-win blue-style-tab1 block tab-win',
          tabBarDividerPosition: 2,
          fullMode: false,
          enableActivebar: false,
          tabs: tabs
        });
        _this.addSubView(_this.tabView);
      });
    }
  }]);
  return MDMsAnonyBoxTabWinView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"174":174,"181":181,"76":76,"82":82,"93":93}],181:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
require(1428);
require(1498);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
var _MDChannelType = _interopRequireDefault(require(717));
var _MMFileInfo = _interopRequireDefault(require(297));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDChooseFolderWindow = _interopRequireDefault(require(483));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDMsAnonyBoxBascInfoTabPanelView = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(MDMsAnonyBoxBascInfoTabPanelView, _MDTabPanelView);
  function MDMsAnonyBoxBascInfoTabPanelView() {
    (0, _classCallCheck2["default"])(this, MDMsAnonyBoxBascInfoTabPanelView);
    return _callSuper(this, MDMsAnonyBoxBascInfoTabPanelView, arguments);
  }
  (0, _createClass2["default"])(MDMsAnonyBoxBascInfoTabPanelView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n      <div class=\"f-tc qrcode\"></div>\n      <p class=\"text-button f-tc copy-qrcode\"><%=BabelStr.str(6914)%></p>\n        <div class=\"f-tc f-link\"></div>\n        <div class=\"f-tc help-block\"><%=BabelStr.str(4767)%></div>\n    <form>\n    <div><%=BabelStr.str(4754)%></div>\n      <div class=\"boxpos-block mgb-10 row mgt-20\">\n        <label class=\"col-3\"><%=BabelStr.str(3287)%></label>\n        <div class=\"col-9 flex-align between\">\n          <label class=\"positionstr\"></label>\n          <label class=\"otherPos text-button done\">  <%=BabelStr.str(3288)%></label>\n        </div>\n      </div>\n      <div class=\"boxname-block mgb-10 row\">\n        <label class=\"col-3\"><%=nameStr%></label>\n        <div class=\"col-9\">\n          <input type=\"text\" id=\"msbox-name\" name=\"box-name\" class=\"form-control testFileNameEnd testFileName notempty\" required  maxlength=\"100\" testFileName placeholder=\"<%=nameStr%> \">\n        </div>\n      </div>\n      <div class=\"comments-block mgb-10 row\">\n        <label class=\"col-3\"><%=remarkStr%></label>\n        <div class=\"col-9\">\n          <textarea class = \"form-control comment textinput\" maxlength=\"200\" name=\"box-message\" id=\"\" cols=\"30\" rows=\"4\" placeholder=\"<%=BabelStr.str(7026)%>\"></textarea>\n\n            <div class=\"conment-tip text-right help-block\"><%=numBefore%><span class=\"num\">100</span><%=numAfter%></div>\n\n        </div>\n      </div>\n      <div class=\"end-date-block mgb-10 row\">\n        <label class=\"col-3\"><%=endTimeStr%></label><!-- \u622A\u6B62\u65E5\u671F -->\n        <div class=\"col-5\">\n          <div class = \"datepicker \">\n            <input type=\"text\" class=\"date-end\" required name=\"end-date\"  placeholder=\"<%=dateStr%>\">\n              <i class = \"ep-ic ep-ic-date\"></i>\n          </div>\n        </div>\n      </div>\n      </form>\n      <div class=\"flex-align end mgtb-20\">\n        <span class=\"button cancel mgr-10\"><%=BabelStr.str(156)%></span>\n        <span class=\"button done save\"><%=BabelStr.str(3080)%></span>\n      </div> ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMsAnonyBoxBascInfoTabPanelView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        parentId: undefined,
        commentNum: 100
      });
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        "nameStr": BabelStr.str(3226),
        "remarkStr": BabelStr.str(361),
        "numBefore": BabelStr.str(3160),
        "numAfter": BabelStr.str(3161),
        "endTimeStr": BabelStr.str(176),
        "dateStr": BabelStr.str(3231)
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMsAnonyBoxBascInfoTabPanelView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMsAnonyBoxBascInfoTabPanelView.prototype), "className", this).call(this);
      return "".concat(superCls, " msbox-select-win");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMsAnonyBoxBascInfoTabPanelView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .setting-item': this._itemHandle,
        'click .cancel': this.close,
        'click .save': this._saveHandle,
        'keyup .comment': this._commentInputHandle,
        'click .otherPos': this._checkOtherPosition,
        'click .qrcode canvas': this._copyQrcode,
        'click .copy-qrcode': this._copyQrcode
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      props.size = 'large';
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMsAnonyBoxBascInfoTabPanelView.prototype), "initialize", this).call(this, props);
      var self = this;
      this.props = props;
      // this.parentId = this.fileInfo.getParentFolderId();
      this.datePicker = this.$(".date-end").datepicker().on("change", function () {
        self.enddate = this.value;
      });
      this.getPathById();
      this.$(".date-end").datepicker("option", "minDate", new Date());
      var data = this.data;
      console.log(data);
      this.$('#msbox-name').val(data.title);
      this.$('.comment').val(data.memo);
      this.$(".date-end").datepicker("option", "minDate", new Date(data.endTime));
      this.$(".date-end").datepicker('setDate', new Date(data.endTime));
      this.$createBtn = this.$('.save');
      this.boxId = data.id;
      this._commentInputHandle();
      this.renderQrcode();
    }
  }, {
    key: "_copyQrcode",
    value: function _copyQrcode(e) {
      var self = this;
      var target = this.$('.qrcode canvas')[0];
      var linkDiv = this.$(".f-link")[0];
      MMCommonFun.clipboardCopyCanvasAndDiv(target, linkDiv, function () {
        console.log('success');
        MDMessageView.success(BabelStr.str(5415), self.$el);
      }, function () {
        MDMessageView.error(BabelStr.str(5418), self.$el);
        console.log('fail');
      });
    }
  }, {
    key: "renderQrcode",
    value: function renderQrcode() {
      var _this = this;
      this.getLink(function (link) {
        _this.$(".qrcode").empty().qrcode({
          width: 100,
          height: 100,
          text: link
        });
        _this.$('.f-link').text(link);
      });
    }
  }, {
    key: "getLink",
    value: function getLink(callback) {
      MMEnterpriseController.getMsAnonyBoxUrl(this.boxId, function (url) {
        callback(url);
      });
    }
  }, {
    key: "_commentInputHandle",
    value: function _commentInputHandle() {
      var comment = this.$(".comment").val().toString();
      var length = comment.length;
      var num = this.commentNum - length;
      if (num < 0) {
        num = 0;
        comment = comment.substring(0, this.commentNum);
        this.$(".comment").val(comment);
      }
      this.$(".comments-block .num").html(num);
    }
  }, {
    key: "_checkOtherPosition",
    value: function _checkOtherPosition() {
      var _this2 = this;
      var folderView = new _MDChooseFolderWindow["default"]({
        onchecked: function onchecked(folderId, pathStr) {
          _this2.checkFolderCallback(folderId, pathStr);
        }
      });
      folderView.show();
    }
  }, {
    key: "checkFolderCallback",
    value: function checkFolderCallback(folderId, pathStr) {
      this.parentId = folderId;
      this.$(".positionstr").html(pathStr);
    }
  }, {
    key: "close",
    value: function close() {
      this.close();
    }
  }, {
    key: "getPathById",
    value: function getPathById() {
      var _this3 = this;
      MMNetDiskDataController.getPathById(this.fileInfo.getFileId(), _MDChannelType["default"].home, null, function (data) {
        var rootPath = new _MMFileInfo["default"]();
        data.models.reverse().pop();
        if (!data.models.length || data.models[0].isOwner()) {
          rootPath.setFileName(BabelStr.str(5010));
        } else {
          rootPath.setFileName(BabelStr.str(337));
        }
        data.unshift(rootPath);
        var path = app.pathRouter.getFilePathsNameStr(data.models);
        _this3.$(".positionstr").html(path);
      }, function () {
        console.log(error);
      });
    }
  }, {
    key: "_saveHandle",
    value: function _saveHandle() {
      var _this4 = this;
      this.$createBtn.prop('disabled', true);
      this.$createBtn.text(BabelStr.str(3303));
      if (!this.$("form").validate().form()) {
        this.$createBtn.prop('disabled', false);
        this.$createBtn.text(BabelStr.str(3080));
        return;
      }
      // return
      var commentStr = this.$(".comment").val() || '';
      commentStr = commentStr.trim();
      var name = this.$("#msbox-name").val() || '';
      name = name.trim();
      var endTime = this.$('.date-end').val();
      endTime = new Date(endTime);
      endTime.setHours(23);
      endTime.setMinutes(59);
      endTime = endTime.getTime() / 1000;
      MMEnterpriseController.updateAnonyBox(this.fileInfo.getFileId(), this.boxId, name, endTime, commentStr, this.parentId, function () {
        _MDSnackbarView["default"].show(BabelStr.str(308));
        _this4.$createBtn.prop('disabled', false);
        _this4.$createBtn.text(BabelStr.str(3080));
      }, function (code, msg) {
        _this4.$createBtn.prop('disabled', false);
        _this4.$createBtn.text(BabelStr.str(3080));
        if (code == 336) {
          _MDSnackbarView["default"].show(BabelStr.str(3617) + ': ' + BabelStr.str(3615));
        } else if (code == 20001) {
          _MDSnackbarView["default"].show(BabelStr.str(7506));
        } else {
          _MDSnackbarView["default"].show(BabelStr.str(3536));
        }
      });
    }
  }]);
  return MDMsAnonyBoxBascInfoTabPanelView;
}(_MDTabPanelView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1428":1428,"1437":1437,"1454":1454,"1463":1463,"1475":1475,"1478":1478,"1498":1498,"297":297,"483":483,"717":717,"72":72,"81":81}],174:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1498);
require(1412);
require(1417);
require(1463);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
var _MDChannelType = _interopRequireDefault(require(717));
var _MMFileInfo = _interopRequireDefault(require(297));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDMsAnonyBoxTabWinView = _interopRequireDefault(require(184));
var _MDMsAnonyBoxShowInfoPageWinView = _interopRequireDefault(require(183));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDMSAnonyBoxInputTabPanelView = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(MDMSAnonyBoxInputTabPanelView, _MDTabPanelView);
  function MDMSAnonyBoxInputTabPanelView() {
    (0, _classCallCheck2["default"])(this, MDMSAnonyBoxInputTabPanelView);
    return _callSuper(this, MDMSAnonyBoxInputTabPanelView, arguments);
  }
  (0, _createClass2["default"])(MDMSAnonyBoxInputTabPanelView, [{
    key: "tmpl",
    value: function tmpl() {
      return "<div class=\"flex-align between mgt-20 pdt-10\">\n        <span><%=BabelStr.str(4757)%></span>\n      </div>\n      <div class=\" help-block\"><%=BabelStr.str(4771)%></div>\n      <form class=\"info-list\"></form>\n      <span class=\"text-button done add-info-item mgt-10\"><%=BabelStr.str(4760)%></span>\n      <div class=\"flex-align end mgtb-20\">\n        <span class=\"button cancel mgr-10\"><%=BabelStr.str(156)%></span>\n        <span class=\"button done save\"><%=BabelStr.str(3080)%></span>\n      </div> ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMSAnonyBoxInputTabPanelView.prototype), "initProps", this).call(this);
      return _.extend(superP, {});
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {};
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMSAnonyBoxInputTabPanelView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMSAnonyBoxInputTabPanelView.prototype), "className", this).call(this);
      return "".concat(superCls, " ms-anony-box-info");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMSAnonyBoxInputTabPanelView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .add-info-item': this._addItemHandle,
        // 'blur ._caption': this._blurCaptionHandle,
        'click .cancel': this.close,
        'click .remove-item': this._removeItemHandle,
        'click .save': this._save,
        'click .show-info': this.showInfo,
        'click .edit-item-btn': this._startEditItem,
        'click .edit-save-btn': this._endEditItem
        // 'click .qrcode canvas': this._copyQrcode,
        // 'click .copy-qrcode': this._copyQrcode
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMSAnonyBoxInputTabPanelView.prototype), "initialize", this).call(this, props);
      this.boxId = this.data.id;
      this.nameVar = 0;
      MMEnterpriseController.getMsAnonyBoxUploaderMetaData(this.boxId, function (datas) {
        _this.oprginData = datas;
        _.each(datas, function (item) {
          _this.addInfoItem(item);
        });
      });
      // this.renderQrcode()
      // $('body').on('click', $e=>{
      //   if($($e.target).hasClass('edit-item-btn')) {
      //     return
      //   }
      //   if($($e.target).closest('.ms-anony-box-info .info-item.edit').length) {
      //     return
      //   }
      //   if(!$($e.target).find('.ms-anony-box-info .edit').length) {
      //     this.$('.edit').removeClass('edit')
      //   }
      // })
    }

    // _copyQrcode(e) {
    //   var self = this
    //   var target = this.$('.qrcode canvas')[0]
    //   MMCommonFun.clipboardCopyCanvas(target, ()=>{
    //   console.log('success')
    //   MDMessageView.success(BabelStr.str(5415), self.$el)
    //   }, ()=>{
    //     MDMessageView.error(BabelStr.str(5418), self.$el)
    //       console.log('fail')
    //   })
    // }
  }, {
    key: "close",
    value: function close() {
      this.close();
    }
    // getLink(callback) {
    //   MMEnterpriseController.getMsAnonyBoxUrl(this.boxId, (url)=>{
    //     callback(url)
    //   })
    // }

    // renderQrcode() {
    //   this.getLink((link)=>{
    //     this.$(".qrcode").empty().qrcode({
    //       width: 100,
    //       height: 100,
    //       text: link
    //     });
    //     this.$('.f-link').text(link)
    //   })

    // }
  }, {
    key: "_blurCaptionHandle",
    value: function _blurCaptionHandle($e) {
      var val = $($e.target).val() || '';
      val = val.trim();
      if (!val) {
        return;
      }
      var $placeholder = $($e.target).siblings('._placeholder');
      $placeholder.val(BabelStr.str(4759, {
        name: val
      }));
      // let validate = this.$('form').validate()
      // validate.form()
    }
  }, {
    key: "addInfoItem",
    value: function addInfoItem(options) {
      var cls = options.edit ? 'edit' : '';
      var tmpl = "<div class=\"info-item flex-align ".concat(cls, "\" data-id=\"").concat(options.id, "\">\n        <div class=\"input-contain fullfill\">\n          <div class='__input_parent'>\n            <input type=\"text\" maxlength=\"20\" name=\"_caption").concat(this.nameVar, "\"  required notempty class=\"_caption\" placeholder=\"").concat(BabelStr.str(4761), "\" value='").concat(_.escape(options.caption), "'>\n          </div>\n          <div class='__input_parent'>\n            <input type=\"text\" maxlength=\"20\" name=\"_placeholder").concat(this.nameVar, "\" class=\"_placeholder\" placeholder=\"").concat(BabelStr.str(4762), "\" value=\"").concat(_.escape(options.placeholder), "\">\n          </div>\n        </div>\n        <span class='edit-item-btn'>").concat(BabelStr.str(3070), "</span>\n        <span class='edit-save-btn'>").concat(BabelStr.str(154), "</span>\n        <span class='remove-item'></span>\n      </div>");
      this.$('.info-list').append(tmpl);
      this.nameVar++;
    }
  }, {
    key: "_removeItemHandle",
    value: function _removeItemHandle($e) {
      var $target = $($e.target).closest('.info-item');
      $target.remove();
      this.navigationWindowView && this.navigationWindowView.refreshWindow();
    }
  }, {
    key: "getInputs",
    value: function getInputs() {
      var $items = this.$('.info-item');
      var out = [];
      for (var i = 0; i < $items.length; i++) {
        var id = $items.eq(i).data('id');
        if (id) {}
        var caption = $items.eq(i).find('._caption').val() || '';
        caption = caption.trim();
        if (caption) {
          var placeholder = $items.eq(i).find('._placeholder').val() || '';
          placeholder = placeholder.trim();
          out.push({
            caption: caption,
            placeholder: placeholder
          });
        }
      }
      return out;
    }
  }, {
    key: "_save",
    value: function _save() {
      var _ref,
        _this2 = this;
      var $items = this.$('.info-item');
      var validate = this.$('form').validate();
      if (!validate.form()) {
        return;
      }
      if (this.saving) {
        return;
      }
      this.saving = true;
      var data = {
        addMetaData: [],
        msBoxId: this.boxId,
        deleteIds: [],
        updateMetaData: []
      };
      var resultIds = [];
      for (var i = 0; i < $items.length; i++) {
        var caption = $items.eq(i).find('._caption').val() || '';
        caption = caption.trim();
        var placeholder = $items.eq(i).find('._placeholder').val() || '';
        placeholder = placeholder.trim();
        var id = $items.eq(i).data('id') + '';
        if (id) {
          resultIds.push(id);
          data.updateMetaData.push({
            id: id,
            caption: caption,
            placeholder: placeholder
          });
        } else {
          data.addMetaData.push({
            caption: caption,
            placeholder: placeholder
          });
        }
      }
      var oldIds = _.pluck(this.oprginData, 'id');
      var deleteIds = (_ref = _).without.apply(_ref, [oldIds].concat(resultIds));
      data.deleteIds = deleteIds;
      console.log(data);
      MMEnterpriseController.updateMsAnonyBoxUploaderMetaData(data, function () {
        _MDSnackbarView["default"].show(BabelStr.str(308));
        MMEnterpriseController.getMsAnonyBoxUploaderMetaData(_this2.boxId, function (datas) {
          _this2.oprginData = datas;
          _this2.saving = false;
        });
      }, function () {
        _MDSnackbarView["default"].show(BabelStr.str(309));
        _this2.saving = false;
      });
    }
  }, {
    key: "_addItemHandle",
    value: function _addItemHandle($e) {
      $e.stopPropagation();
      this._endEditItem();
      this.addInfoItem({
        id: '',
        caption: '',
        placeholder: '',
        edit: true
      });
    }
  }, {
    key: "showInfo",
    value: function showInfo() {
      var inputs = this.getInputs();
      var view = new _MDMsAnonyBoxShowInfoPageWinView["default"]({
        inputs: inputs,
        fileInfo: this.fileInfo
      });
      view.show();
    }
  }, {
    key: "_startEditItem",
    value: function _startEditItem($e) {
      this._endEditItem();
      this.$('.save').attr('disabled', true);
      var $item = $($e.target).closest('.info-item');
      $item.addClass('edit');
    }
  }, {
    key: "_endEditItem",
    value: function _endEditItem() {
      var validate = this.$('form').validate();
      if (!validate.form()) {
        return;
      }
      this.$('.edit').removeClass('edit');
      this.$('.save').attr('disabled', false);
    }
  }]);
  return MDMSAnonyBoxInputTabPanelView;
}(_MDTabPanelView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1417":1417,"1454":1454,"1463":1463,"1475":1475,"1498":1498,"183":183,"184":184,"297":297,"717":717,"72":72,"81":81}],183:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDMsAnonyBoxShowInfoPageView = _interopRequireDefault(require(182));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDMsAnonyBoxShowInfoPageWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDMsAnonyBoxShowInfoPageWinView, _MDWindowView);
  function MDMsAnonyBoxShowInfoPageWinView() {
    (0, _classCallCheck2["default"])(this, MDMsAnonyBoxShowInfoPageWinView);
    return _callSuper(this, MDMsAnonyBoxShowInfoPageWinView, arguments);
  }
  (0, _createClass2["default"])(MDMsAnonyBoxShowInfoPageWinView, [{
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMsAnonyBoxShowInfoPageWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {});
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMsAnonyBoxShowInfoPageWinView.prototype), "className", this).call(this);
      return superCls + ' msbox-create-win';
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      opt.title = BabelStr.str(4763);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMsAnonyBoxShowInfoPageWinView.prototype), "initialize", this).call(this, opt);
      var view = new _MDMsAnonyBoxShowInfoPageView["default"](opt);
      this.addSubView(view);
    }
  }]);
  return MDMsAnonyBoxShowInfoPageWinView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"182":182,"93":93}],182:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDMsAnonyBoxShowInfoPageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDMsAnonyBoxShowInfoPageView, _MDNavigationPageView);
  function MDMsAnonyBoxShowInfoPageView() {
    (0, _classCallCheck2["default"])(this, MDMsAnonyBoxShowInfoPageView);
    return _callSuper(this, MDMsAnonyBoxShowInfoPageView, arguments);
  }
  (0, _createClass2["default"])(MDMsAnonyBoxShowInfoPageView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n      <div class=\"mgb-20\"><%=BabelStr.str(4764)%></div>\n      <%for(var item of inputs){%>\n        <div class=\"_title\"><%=item.caption%></div>\n        <input class=\"form-control\" placeholder=\"<%=item.placeholder%>\">\n      <%}%>\n      <div class=\"flex-align end mgtb-20\">\n        <span class=\"button cancel mgr-10\"><%=BabelStr.str(74)%></span>        \n      </div>      \n\t\t";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMsAnonyBoxShowInfoPageView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        inputs: []
      });
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        inputs: this.inputs
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMsAnonyBoxShowInfoPageView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMsAnonyBoxShowInfoPageView.prototype), "className", this).call(this);
      return "".concat(superCls, " ms-anony-box-show-info");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMsAnonyBoxShowInfoPageView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .cancel': this.cancel
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      props.size = 'large';
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMsAnonyBoxShowInfoPageView.prototype), "initialize", this).call(this, props);
      var self = this;
      this.setTitle(BabelStr.str(4763));
      this.props = props;

      // this.addInit()
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.navigationWindowView.pop();
    }
  }]);
  return MDMsAnonyBoxShowInfoPageView;
}(_MDNavigationPageView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"56":56}],176:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDTabView = _interopRequireDefault(require(82));
var _MDManuscriptBoxTabPanelView = _interopRequireDefault(require(175));
var _MDManuscriptStatisticTabPanelView = _interopRequireDefault(require(178));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // MDManuscriptBoxView.js
// jiang
// 2017-6-6
var MDManuscriptBoxView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDManuscriptBoxView, _MDWindowView);
  function MDManuscriptBoxView() {
    (0, _classCallCheck2["default"])(this, MDManuscriptBoxView);
    return _callSuper(this, MDManuscriptBoxView, arguments);
  }
  (0, _createClass2["default"])(MDManuscriptBoxView, [{
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDManuscriptBoxView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        width: 710,
        createMsBox: true,
        canEdit: true
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDManuscriptBoxView.prototype), "className", this).call(this);
      return superCls + ' msbox-create-win';
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      var _this = this;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDManuscriptBoxView.prototype), "initialize", this).call(this, opt);
      if (opt.fileInfo) {
        opt.createMsBox = false;
        this.fileId = opt.fileInfo.getFileId();
      } else {
        opt.createMsBox = true;
      }
      var tabs = [];
      var title = BabelStr.str(2381);
      if (!opt.createMsBox) {
        title = BabelStr.str(2382);
      }
      ;
      if (!_.isUndefined(opt.canEdit) && !opt.canEdit) {
        title = BabelStr.str(6021);
      }
      opt.close = function () {
        _this.close();
      };
      this.settingPanelView = new _MDManuscriptBoxTabPanelView["default"](opt);
      tabs.push({
        title: title,
        tabPanelView: this.settingPanelView,
        active: true
      });
      if (opt.fileInfo && opt.fileInfo.canManageMsBox()) {
        this.statisticView = new _MDManuscriptStatisticTabPanelView["default"](opt);
        tabs.push({
          title: BabelStr.str(6074),
          tabPanelView: this.statisticView
          // active: true
        });
      }
      this.tabView = new _MDTabView["default"]({
        className: 'share-win blue-style-tab1 block tab-win',
        tabBarDividerPosition: 2,
        fullMode: false,
        enableActivebar: false,
        tabs: tabs
      });
      this.addSubView(this.tabView);
    }
  }]);
  return MDManuscriptBoxView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"175":175,"178":178,"82":82,"93":93}],178:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
var _MDPaginationView = _interopRequireDefault(require(61));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDManuscriptStatisticTableView = _interopRequireDefault(require(180));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDManuscriptStatisticTabPanelView = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(MDManuscriptStatisticTabPanelView, _MDTabPanelView);
  function MDManuscriptStatisticTabPanelView() {
    (0, _classCallCheck2["default"])(this, MDManuscriptStatisticTabPanelView);
    return _callSuper(this, MDManuscriptStatisticTabPanelView, arguments);
  }
  (0, _createClass2["default"])(MDManuscriptStatisticTabPanelView, [{
    key: "tmpl",
    value: function tmpl() {
      return "<div class=\"head-block flex-align\">\n\t\t\t\t<div class=\"item mgr-20\"><%=BabelStr.str(6069)%> <span class=\"submitted text-button done\">0</span> <%=BabelStr.str(6072)%></div>\n \t\t\t\t\t<div class=\"item mgr-20\"><%=BabelStr.str(6070)%> <span class=\"notSubmitted text-button done\">0</span> <%=BabelStr.str(6072)%></div>\n\t\t\t\t\t<div class=\"item mgr-20\"><%=BabelStr.str(6071)%> <span class=\"totalSubmitted text-button done\">0</span> <%=BabelStr.str(6072)%></div>\n\t\t\t</div>\n\t\t\t<div class=\"content-block\">\n\t\t\t</div>\t\t\t\n\t\t\t<div class=\"page-bar mgt-10\"></div>\n\t\t\t";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDManuscriptStatisticTabPanelView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        startIndex: 0,
        pageSize: 10,
        fileInfo: null,
        type: 0,
        sortBy: 'name',
        desc: 0
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDManuscriptStatisticTabPanelView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .submitted': this._submittedClicked,
        'click .notSubmitted': this._notSubmittedClicked,
        'click .totalSubmitted': this._totalSubmittedClicked
      });
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      var _this = this;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDManuscriptStatisticTabPanelView.prototype), "initialize", this).call(this, opt);
      var firstRequest = true;
      opt.success = function (totalSubmitted, submitted) {
        var notSubmitted = totalSubmitted - submitted;
        if (firstRequest) {
          _this.$('.submitted').html(submitted);
          _this.$('.notSubmitted').html(notSubmitted);
          _this.$('.totalSubmitted').html(totalSubmitted);
          firstRequest = false;
        }
        _this.paginationBarView.setLength(totalSubmitted, true, _this.startIndex);
      };
      opt.refreshTable = function () {
        _this.refreshTable();
      };
      this.tableView = new _MDManuscriptStatisticTableView["default"](opt);
      this.addSubView(this.tableView, this.$('.content-block')[0]);
      this.paginationBarView = new _MDPaginationView["default"]({
        silentInit: true,
        pageSize: this.pageSize,
        onPageChanged: function onPageChanged(curPageIndex) {
          _this.startIndex = curPageIndex * _this.pageSize;
          _this.refreshTable();
        },
        onPageSizeChanged: function onPageSizeChanged(newPageSize) {
          _this.pageSize = newPageSize;
          _this.startIndex = 0;
          _this.refreshTable();
        }
      });
      this.addSubView(this.paginationBarView, this.$('.page-bar')[0]);
      this.tableView.getAllUserState({
        startIndex: this.startIndex,
        pageSize: this.pageSize
      });
    }
  }, {
    key: "refreshTable",
    value: function refreshTable() {
      this.tableView.getAllUserState({
        startIndex: this.startIndex,
        pageSize: this.pageSize,
        type: this.type
      });
    }
  }, {
    key: "_submittedClicked",
    value: function _submittedClicked() {
      this.type = 1;
      this.refreshTable();
    }
  }, {
    key: "_notSubmittedClicked",
    value: function _notSubmittedClicked() {
      this.type = 2;
      this.refreshTable();
    }
  }, {
    key: "_totalSubmittedClicked",
    value: function _totalSubmittedClicked() {
      this.type = 0;
      this.refreshTable();
    }
  }]);
  return MDManuscriptStatisticTabPanelView;
}(_MDTabPanelView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"180":180,"61":61,"76":76,"81":81}],180:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTableView2 = _interopRequireDefault(require(89));
var _MDManuscriptStatisticTableRowView = _interopRequireDefault(require(179));
var _SortDirection = _interopRequireDefault(require(91));
var _PropType = _interopRequireDefault(require(90));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDManuscriptStatisticTableView = exports["default"] = /*#__PURE__*/function (_MDTableView) {
  (0, _inherits2["default"])(MDManuscriptStatisticTableView, _MDTableView);
  function MDManuscriptStatisticTableView() {
    (0, _classCallCheck2["default"])(this, MDManuscriptStatisticTableView);
    return _callSuper(this, MDManuscriptStatisticTableView, arguments);
  }
  (0, _createClass2["default"])(MDManuscriptStatisticTableView, [{
    key: "emptyTmpl",
    value: function emptyTmpl() {
      return "<div class=\"m-empty page-empty\" style=\"display: block;padding: 19px 0;\">\n              <p>".concat(BabelStr.str(6077), "</p> \n            </div>");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDManuscriptStatisticTableView.prototype), "initProps", this).call(this);
      return _.extend({
        fileInfo: null,
        type: 0,
        sortBy: 'name',
        desc: 0
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props = _.extend({
        blankRenderer: this.emptyTmpl(),
        bodyCls: 'userRows',
        rowCls: 'row',
        headerCls: 'headerWrapper',
        rowClass: _MDManuscriptStatisticTableRowView["default"],
        allowSelect: false,
        sorters: [{
          dataIndex: 'name',
          direction: _SortDirection["default"].Asc,
          propType: _PropType["default"].String,
          active: true,
          useComparator: false,
          sortFn: function sortFn(direction, dataIndex) {
            _this._sortHandler(direction, dataIndex);
          }
        }, {
          dataIndex: 'isCommitter',
          direction: _SortDirection["default"].Asc,
          propType: _PropType["default"].Number,
          name: BabelStr.str(3068),
          useComparator: false,
          sortFn: function sortFn(direction, dataIndex) {
            _this._sortHandler(direction, dataIndex);
          }
        }],
        unSelectRowWhenClickOutside: false,
        columns: [{
          name: BabelStr.str(3128),
          dataIndex: 'name',
          width: 510,
          cellCls: 'name-col'
        }, {
          name: BabelStr.str(6073),
          dataIndex: 'isCommitter',
          width: 120
        }]
      }, props);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDManuscriptStatisticTableView.prototype), "initialize", this).call(this, props);
      this.fileId = this.fileInfo.getFileId();
    }
  }, {
    key: "getAllUserState",
    value: function getAllUserState(options) {
      var _this2 = this;
      options = _.extend({
        fileId: this.fileId,
        type: this.type,
        sortBy: this.sortBy,
        desc: this.desc
      }, options);
      _MDSpinnerloaderView["default"].showIn(this.$('.content-block'));
      MMEnterpriseController.getMsBoxCommitStatus(options, function (users, total, commitedNum) {
        total = total > commitedNum ? total : commitedNum;
        _MDSpinnerloaderView["default"].clearFrom(_this2.$('.content-block'));
        _this2.setDataCollection(users, false, false);
        _.isFunction(_this2.success) && _this2.success(total, commitedNum);
      }, function () {});
    }
  }, {
    key: "_sortHandler",
    value: function _sortHandler(direction, sortBy) {
      var sortDesc = direction == _SortDirection["default"].Desc ? 1 : 0;
      sortBy = sortBy == "isCommitter" ? "committer" : sortBy;
      this.sortBy = sortBy;
      this.desc = sortDesc;
      this.clearRow(true);
      this.refreshTable();
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MDManuscriptStatisticTableView';
    }
  }]);
  return MDManuscriptStatisticTableView;
}(_MDTableView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"179":179,"76":76,"89":89,"90":90,"91":91}],179:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTableRowView2 = _interopRequireDefault(require(88));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDManuscriptStatisticTableRowView = exports["default"] = /*#__PURE__*/function (_MDTableRowView) {
  (0, _inherits2["default"])(MDManuscriptStatisticTableRowView, _MDTableRowView);
  function MDManuscriptStatisticTableRowView() {
    (0, _classCallCheck2["default"])(this, MDManuscriptStatisticTableRowView);
    return _callSuper(this, MDManuscriptStatisticTableRowView, arguments);
  }
  (0, _createClass2["default"])(MDManuscriptStatisticTableRowView, [{
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDManuscriptStatisticTableRowView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        userInfo: null,
        columnRenders: function columnRenders() {
          return [{
            dataIndex: 'name',
            cellCls: 'name-col text-hide',
            render: function render(name, userInfo, index) {
              var name = userInfo.get('name');
              var mail = userInfo.getAccount();
              var renderStr = "";
              renderStr += "<img data-src=\"".concat(userInfo.getAvatarImageURL(), "\" src=\"").concat(userInfo.getAvatarImageURL(), "\"  class=\"avatar s36\" />\n              <span class=\"name blue\">").concat(name, "</span>\n              <span class=\"email\">(").concat(mail, ")</span>\n            ");
              return renderStr;
            }
          }, {
            dataIndex: 'isCommitter',
            render: function render(name, userInfo, index) {
              var isCommitter = userInfo.get('isCommitter');
              if (isCommitter) {
                return "<span class=\"blue\">".concat(BabelStr.str(6076), "</span>");
              }
              return '--';
            }
          }];
        }
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDManuscriptStatisticTableRowView.prototype), "events", this).call(this);
      return _.extend(superE, {});
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDManuscriptStatisticTableRowView.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDManuscriptStatisticTableRowView.prototype), "viewDidRendered", this).call(this);
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MDManuscriptStatisticTableRowView';
    }
  }]);
  return MDManuscriptStatisticTableRowView;
}(_MDTableRowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1454":1454,"1463":1463,"1475":1475,"88":88}],175:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1428);
require(1498);
require(1463);
require(1478);
require(1424);
require(1426);
require(1439);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMFileInfo = _interopRequireDefault(require(297));
var _MDChannelType = _interopRequireDefault(require(717));
var _MDChooseFolderWindow = _interopRequireDefault(require(483));
var _MDManuscriptBoxViewTmpl = _interopRequireDefault(require(177));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDFileOperationManager = _interopRequireDefault(require(326));
var _MDParticipantInfoCollection = _interopRequireDefault(require(277));
var _MDEnterpriseShareTabView = _interopRequireDefault(require(675));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
var _MDMessageView = _interopRequireDefault(require(55));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDManuscriptBoxTabPanelView = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(MDManuscriptBoxTabPanelView, _MDTabPanelView);
  function MDManuscriptBoxTabPanelView() {
    (0, _classCallCheck2["default"])(this, MDManuscriptBoxTabPanelView);
    return _callSuper(this, MDManuscriptBoxTabPanelView, arguments);
  }
  (0, _createClass2["default"])(MDManuscriptBoxTabPanelView, [{
    key: "tmpl",
    value: function tmpl() {
      return _MDManuscriptBoxViewTmpl["default"].main;
    }
  }, {
    key: "evalutionUnOrderedTmpl",
    value: function evalutionUnOrderedTmpl() {
      return _MDManuscriptBoxViewTmpl["default"].evalutionUnOrdered;
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDManuscriptBoxTabPanelView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        fileInfo: null,
        commentNum: 100,
        // --------------- 文字说明的字数限制
        createMsBox: true,
        parentId: app.currentFolder.getFileId(),
        oldParentId: app.currentFolder.getFileId(),
        canMove: true,
        width: 710,
        canEdit: true
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDManuscriptBoxTabPanelView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .create-msbox': this._saveClickHandle,
        'keyup .comment': this._commentInputHandle,
        'click .show-more-btn': this._toggleMoreInput,
        'click .otherPos': this._checkOtherPosition,
        'click .setting-item': this._settingUploadType,
        'click .cancel': this._close
        // 'input .upload-condition': this._validateInput,
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      if (props.fileInfo) {
        props.createMsBox = false;
        this.fileId = props.fileInfo.getFileId();
      } else {
        props.createMsBox = true;
      }
      this.tempInputs = {}; // 保存不同限制类型中用户输入的不同的数据

      this.contributors = [];
      props.title = BabelStr.str(2381);
      if (!props.createMsBox) {
        props.title = BabelStr.str(2382);
      }
      ;
      if (!_.isUndefined(props.canEdit) && !props.canEdit) {
        props.title = BabelStr.str(6021);
      }
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDManuscriptBoxTabPanelView.prototype), "initialize", this).call(this, props);
      if (this.fileInfo) {
        this.parentId = this.fileInfo.getParentFolderId();
      }
      this.oldParentId = this.parentId;
      var self = this;
      this.datePicker = this.$(".date-end").datepicker().on("change", function () {
        self.enddate = this.value;
      });
      if (!this.createMsBox) {
        this.$('.create-msbox').text(BabelStr.str(3080));
        this.getPathById();
      } else {
        if (app.pathRouter.isInRoot() && app.pathRouter.isInMsBox() && !app.currentUser.canOwnFile()) {
          this.$(".positionstr").html("<span class=\"red\">".concat(BabelStr.str(7197), "</span>"));
          this.parentId = -1;
        } else {
          var path = app.pathRouter.getFilePathsNameStr();
          this.$(".positionstr").html(path);
        }
        this.$(".date-end").datepicker("option", "minDate", new Date());
      }
      this.initData(function (participantArr, receiverArr) {
        if (_this.canEdit) {
          _this.renderContributors(participantArr);
          _this.renderReceivers(receiverArr);
        }
      });
      this.$('.more-opt').hide();
      this.$createBtn = this.$(".create-msbox");
      this.$conForm = this.$('.condition-form');
    }

    // _validateInput(e) {

    //   e.target.value = e.target.value.replace(/，/g, ',');

    //   // 使用正则表达式来匹配允许的字符
    //   // 这里允许的是字母（a-zA-Z）和分号（;）
    //   var regex = /[^a-zA-Z0-9,]/g
    //   // 如果输入不符合规则，则替换掉非法字符
    //   // if (!regex.test(e.target.value)) {
    //     // 去除最后一个输入的非法字符
    //     e.target.value = e.target.value.replace(regex, '')
    // }
  }, {
    key: "isOnlyDepFolder",
    value: function isOnlyDepFolder() {
      return app.pathRouter.isInRoot() && app.pathRouter.isInMsBox() && !app.currentUser.canOwnFile();
    }
  }, {
    key: "_settingUploadType",
    value: function _settingUploadType($e) {
      var $current = $($e.target).closest('.setting-item');
      this.tempInputs[this.curType] = this.$('.upload-condition').val();
      this.curType = $current.index();
      this.setUploadTypeByIndex(this.curType);
    }
  }, {
    key: "setUploadTypeByIndex",
    value: function setUploadTypeByIndex(index) {
      this.$('.setting-item').removeClass('checked');
      this.$('.setting-item').eq(index).addClass('checked');
      switch (index) {
        case 0:
          this.$('.condition-block').addClass("f-hide");
          break;
        case 1:
          this.$('.upload-condition').attr("placeholder", BabelStr.str(801));
          this.$('.condition-block').removeClass("f-hide");
          break;
        case 2:
          this.$('.upload-condition').attr("placeholder", BabelStr.str(802));
          this.$('.condition-block').removeClass("f-hide");
          break;
      }
      var oldVal = this.tempInputs[index];
      if (oldVal) {
        this.$('.upload-condition').val(oldVal);
      } else {
        this.$('.upload-condition').val('');
      }
    }
  }, {
    key: "getPathById",
    value: function getPathById() {
      var _this2 = this;
      MMNetDiskDataController.getPathById(this.fileInfo.getFileId(), _MDChannelType["default"].home, null, function (data) {
        var rootPath = new _MMFileInfo["default"]();
        // rootPath.set("parentId", -1);
        // var pathArr = data.add(rootPath);
        data.models.reverse().pop();
        if (!data.models.length || data.models[0].isOwner()) {
          rootPath.setFileName(BabelStr.str(5010));
        } else {
          rootPath.setFileName(BabelStr.str(337));
        }
        data.unshift(rootPath);
        var path = app.pathRouter.getFilePathsNameStr(data.models);
        _this2.$(".positionstr").html(path);
      }, function () {
        console.log(error);
      });
    }
  }, {
    key: "render",
    value: function render(data) {
      if (this.fileInfo) {
        this.canMove = this.fileInfo.canMove();
      }
      data = {
        "canMove": this.canMove,
        "str1": BabelStr.str(3225),
        "nameStr": BabelStr.str(3226),
        "remarkStr": BabelStr.str(361),
        "numBefore": BabelStr.str(3160),
        "numAfter": BabelStr.str(3161),
        "endTimeStr": BabelStr.str(176),
        "senderStr": BabelStr.str(2500),
        "moreStr": BabelStr.str(3218),
        "otherStr": BabelStr.str(3227),
        "checkOtherStr": BabelStr.str(3221),
        "tipStr1": BabelStr.str(3228),
        "createStr": BabelStr.str(3229),
        "dateStr": BabelStr.str(3231),
        "checkUserStr": BabelStr.str(3230),
        canEdit: this.canEdit
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDManuscriptBoxTabPanelView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "_toggleMoreInput",
    value: function _toggleMoreInput() {
      if (this.showMore) {
        this.showMore = false;
        this.$('.more-opt').hide();
        this.$('.show-more-btn').text(BabelStr.str(3218));
      } else {
        this.showMore = true;
        this.$('.more-opt').show();
        this.$('.show-more-btn').text(BabelStr.str(3219));
      }
    }
  }, {
    key: "renderContributors",
    value: function renderContributors(participantArr) {
      if (!participantArr) {
        participantArr = [];
      }
      this.contributors = participantArr;
      if (this.contributorListItemView) {
        this.contributorListItemView.close();
      }
      ;
      this.contributorListItemView = new _MDEnterpriseShareTabView["default"]({
        defaultParticipantInfoCollection: new _MDParticipantInfoCollection["default"](participantArr),
        inputName: "contributor-choose-panel",
        placeholder: BabelStr.str(3220),
        notIncludeGuest: false,
        inputDisabled: false,
        hideSelectWhenInput: true,
        needFrequentUserTab: true,
        canSelDepartment: true,
        canSelGroup: true,
        canSelRole: this.canSelRole,
        // isTabAbsolute: true,
        needRoleTab: this.canSelRole,
        isNeedCurUser: this.isNeedCurUser,
        isSelectOnlyInEp: false,
        needGroupTreeTab: true,
        fromStr: BabelStr.str(2404),
        onChange: function onChange(userCollection) {}
      });
      this.addSubView(this.contributorListItemView, this.$(".contibutor-input")[0]);
      return this.contributorListItemView;
    }
  }, {
    key: "_close",
    value: function _close() {
      this.close();
    }
  }, {
    key: "renderReceivers",
    value: function renderReceivers(receivers) {
      if (!receivers) {
        receivers = [];
      }
      this.receivers = receivers;
      this.receiverListItemView = new _MDEnterpriseShareTabView["default"]({
        defaultParticipantInfoCollection: new _MDParticipantInfoCollection["default"](receivers),
        inputName: "receiver-choose-panel",
        placeholder: BabelStr.str(3221),
        notIncludeGuest: true,
        inputDisabled: false,
        hideSelectWhenInput: true,
        needFrequentUserTab: false,
        canSelDepartment: false,
        canSelGroup: false,
        canSelRole: this.canSelRole,
        isTabAbsolute: true,
        needRoleTab: this.canSelRole,
        isNeedCurUser: this.isNeedCurUser,
        isSelectOnlyInEp: true,
        needGroupTreeTab: true,
        fromStr: BabelStr.str(2404),
        onChange: function onChange(userCollection) {}
      });
      this.addSubView(this.receiverListItemView, this.$(".receiver-input")[0]);
      return this.receiverListItemView;
    }
  }, {
    key: "_saveClickHandle",
    value: function _saveClickHandle() {
      if (this.parentId == -1) {
        _MDMessageView["default"].error(BabelStr.str(7197), this.$el);
        return;
      }
      var self = this;
      this.$createBtn.prop('disabled', true);
      this.$createBtn.text(BabelStr.str(3303));
      var boxName = this.$('#msbox-name').val().trim();
      this.$('#msbox-name').val(boxName);
      var targetUsers = this.contributorListItemView.getTargetIds();
      var receiverUsers = this.receiverListItemView.getTargetEmails();
      var commentStr = this.$('.comment').val();
      var endTime = this.$('.date-end').val();
      endTime = new Date(endTime);
      endTime.setHours(23);
      endTime.setMinutes(59);
      endTime = endTime.getTime() / 1000;
      var type = this.curType;
      var limtStr = this.$('.upload-condition').val().toString().trim();
      var limits = [];
      if (type == 1) {
        var limtArr = limtStr.split("，").join(",").split(",");
        var tempArr = _.map(limtArr, function (item) {
          return item.trim();
        });
        tempArr = _.uniq(tempArr);
        tempArr = _.compact(tempArr);
        _.each(tempArr, function (item) {
          limits.push({
            type: 1,
            string: item
          });
        });
      } else if (type == 2) {
        limits.push({
          type: 2,
          string: limtStr
        });
      }
      if (!this.$(".form-horizontal").validate().form()) {
        this.$createBtn.prop('disabled', false);
        self.$createBtn.text(BabelStr.str(3229));
        return;
      }
      if (type == 1 || type == 2) {
        if (!this.$conForm.validate().form()) {
          this.$createBtn.prop('disabled', false);
          this.$createBtn.text(BabelStr.str(3229));
          return;
        }
      }
      if (this.createMsBox) {
        var boxInfo = {
          parentId: this.parentId,
          boxName: boxName,
          commentStr: commentStr,
          endTime: endTime,
          userIds: targetUsers.userIds,
          depIds: targetUsers.deps,
          groupIds: targetUsers.groupIds,
          receiverIds: receiverUsers.userIds,
          limits: limits,
          addPhones: targetUsers.phones,
          addEmails: targetUsers.emails
        };
        _czc && _czc.push(["_trackEvent", "创建", "创建文件收集箱", "", "", ""]);
        _MDSpinnerloaderView["default"].showIn(self.$('.header-block')[0]);
        _MDFileOperationManager["default"].createMsBox(boxInfo, app.currentFolder, function (suc) {
          _MDSpinnerloaderView["default"].clearFrom(self.$('.header-block')[0]);
          self.$createBtn.prop('disabled', false);
          self.$createBtn.text(BabelStr.str(3229));
          if (suc) {
            self.close();
          } else {
            self.$createBtn.prop('disabled', false);
            self.$createBtn.text(BabelStr.str(3229));
          }
        });
      } else {
        var updateParam = {};
        if (boxName != this.boxInfo['name']) {
          updateParam.name = boxName;
        }
        ;
        if (commentStr != this.boxInfo['comment']) {
          updateParam.comment = commentStr;
        }
        ;
        if (endTime != this.boxInfo['endtime']) {
          updateParam.endtime = endTime;
        }
        ;
        if (targetUsers.userIds) {
          for (var i = 0; i < targetUsers.userIds.length; i++) {
            var uid = targetUsers.userIds[i];
            var found = false;
            for (var k = 0; k < this.boxInfo.contributors.length; k++) {
              var oldC = this.boxInfo.contributors[k];
              if (oldC.participantType == 0 && uid == oldC.participantId) {
                oldC.remain = true;
                found = true;
                break;
              }
            }
            ;
            if (!found) {
              if (!updateParam.addUserIds) {
                updateParam.addUserIds = [uid];
              } else {
                updateParam.addUserIds.push(uid);
              }
            }
            ;
          }
          ;
        }
        ;
        if (targetUsers.deps) {
          for (var i = 0; i < targetUsers.deps.length; i++) {
            var did = targetUsers.deps[i];
            var found = false;
            for (var k = 0; k < this.boxInfo.contributors.length; k++) {
              var oldC = this.boxInfo.contributors[k];
              if (oldC.participantType == 1 && did == oldC.participantId) {
                oldC.remain = true;
                found = true;
                break;
              }
            }
            ;
            if (!found) {
              if (!updateParam.addDepIds) {
                updateParam.addDepIds = [did];
              } else {
                updateParam.addDepIds.push(did);
              }
            }
            ;
          }
          ;
        }
        ;
        if (targetUsers.groupIds) {
          for (var i = 0; i < targetUsers.groupIds.length; i++) {
            var gid = targetUsers.groupIds[i];
            var found = false;
            for (var k = 0; k < this.boxInfo.contributors.length; k++) {
              var oldC = this.boxInfo.contributors[k];
              if (oldC.participantType == 2 && gid == oldC.participantId) {
                oldC.remain = true;
                found = true;
                break;
              }
            }
            ;
            if (!found) {
              if (!updateParam.addGroupIds) {
                updateParam.addGroupIds = [gid];
              } else {
                updateParam.addGroupIds.push(gid);
              }
            }
            ;
          }
          ;
        }
        ;
        if (receiverUsers && receiverUsers.userIds) {
          for (var i = 0; i < receiverUsers.userIds.length; i++) {
            var uid = receiverUsers.userIds[i];
            var found = false;
            if (this.boxInfo.receivers) {
              for (var k = 0; k < this.boxInfo.receivers.length; k++) {
                var oldC = this.boxInfo.receivers[k];
                if (uid == oldC.participantId) {
                  oldC.remain = true;
                  found = true;
                  break;
                }
              }
              ;
            }
            ;
            if (!found) {
              if (!updateParam.addReceiverIds) {
                updateParam.addReceiverIds = [uid];
              } else {
                updateParam.addReceiverIds.push(uid);
              }
            }
            ;
          }
          ;
        }
        ;
        for (var i = 0; i < this.boxInfo.contributors.length; i++) {
          if (!this.boxInfo.contributors[i].remain) {
            var id = this.boxInfo.contributors[i].participantId;
            if (this.boxInfo.contributors[i].participantType == 0) {
              if (updateParam.removeUserIds) {
                updateParam.removeUserIds.push(id);
              } else {
                updateParam.removeUserIds = [id];
              }
            } else if (this.boxInfo.contributors[i].participantType == 1) {
              if (updateParam.removeDepIds) {
                updateParam.removeDepIds.push(id);
              } else {
                updateParam.removeDepIds = [id];
              }
            } else if (this.boxInfo.contributors[i].participantType == 2) {
              if (updateParam.removeGroupIds) {
                updateParam.removeGroupIds.push(id);
              } else {
                updateParam.removeGroupIds = [id];
              }
            }
            ;
          }
        }
        ;
        for (var i = 0; i < this.boxInfo.receivers.length; i++) {
          if (!this.boxInfo.receivers[i].remain) {
            var id = this.boxInfo.receivers[i].participantId;
            if (updateParam.removeReceiverIds) {
              updateParam.removeReceiverIds.push(id);
            } else {
              updateParam.removeReceiverIds = [id];
            }
          }
        }
        ;
        if (self.parentId != self.oldParentId) {
          updateParam.folderId = this.parentId;
        } else {
          updateParam.folderId = null;
        }
        var removeLimitIds = [];
        var addLimits = [];
        var addLimitArr = [];
        if (this.curType != this.originType) {
          removeLimitIds = this.orginLimitIds;
          addLimitArr = limits;
        } else if (this.curType == 1) {
          var removeTypes = [];
          addLimits = _.difference(tempArr, self.orginLimitStrs);
          removeTypes = _.difference(self.orginLimitStrs, tempArr);
          _.each(this.originLimits, function (item) {
            _.each(removeTypes, function (type) {
              if (item.stringLimit == type) {
                removeLimitIds.push(item.id);
              }
            });
          });
          _.each(addLimits, function (item) {
            addLimitArr.push({
              type: 1,
              string: item
            });
          });
        } else if (this.curType == 2) {
          if (limits[0] && limits[0].string != this.orginLimitStrs[0]) {
            removeLimitIds = this.orginLimitIds;
            addLimitArr = limits;
          }
        }
        updateParam.removeLimitIds = removeLimitIds || [];
        updateParam.addLimits = addLimitArr || [];
        updateParam.addPhones = targetUsers.phones, updateParam.addEmails = targetUsers.emails;
        console.error(updateParam);
        _MDSpinnerloaderView["default"].showIn(self.$('.header-block')[0]);
        _MMEnterpriseController["default"].updateMsBox(this.fileId, updateParam, function () {
          _MDSpinnerloaderView["default"].clearFrom(self.$('.header-block')[0]);
          self.close();
          if (updateParam.name) {
            self.fileInfo.setFileName(updateParam.name);
          }
          ;
          if (updateParam.comment) {
            self.fileInfo.setCommentStr(updateParam.comment);
          }
          ;
          if (updateParam.endtime) {
            self.fileInfo.setEndTime(updateParam.endtime);
          }
          ;
          if (self.parentId != self.oldParentId) {
            Dispatcher.trigger(MDEvents.DelFileFormCurFolder, self.fileId);
          }
          self.$createBtn.prop('disabled', false);
          self.$createBtn.text(BabelStr.str(3080));
        }, function (code, msg) {
          self.$createBtn.prop('disabled', false);
          self.$createBtn.text(BabelStr.str(3080));
          _MDSpinnerloaderView["default"].clearFrom(self.$('.header-block')[0]);
          if (code == 336) {
            _MDSnackbarView["default"].show(BabelStr.str(3617) + ': ' + BabelStr.str(3615));
          } else if (code == 20001) {
            _MDSnackbarView["default"].show(BabelStr.str(7506));
          } else {
            _MDSnackbarView["default"].show(BabelStr.str(3536));
          }
        });
      }
    }
  }, {
    key: "initData",
    value: function initData(callback) {
      var self = this;
      if (!this.createMsBox) {
        _MMEnterpriseController["default"].getMsBoxInfoById(this.fileId, function (boxInfo) {
          self.boxInfo = boxInfo;
          self.$('#msbox-name').val(boxInfo.name);
          self.$('.comment').val(boxInfo.comment);
          var length = (boxInfo.comment || "").length;
          self.$(".comments-block .num").html(self.commentNum - length);
          self.$(".date-end").datepicker("option", "minDate", new Date(boxInfo.endtime * 1000));
          self.$(".date-end").datepicker('setDate', new Date(boxInfo.endtime * 1000));
          self.originLimits = boxInfo.limits;
          if (_.isArray(self.originLimits)) {
            if (self.originLimits.length) {
              self.curType = self.originType = self.originLimits[0]["type"];
              self.setUploadTypeByIndex(self.originType);
              self.orginLimitStrs = _.pluck(self.originLimits, 'stringLimit');
              self.orginLimitIds = _.pluck(self.originLimits, 'id');
              self.$('.upload-condition').val(self.orginLimitStrs.join(','));
            }
          }
          var participantArr = [];
          for (var i = 0; i < boxInfo.contributors.length; i++) {
            participantArr.push(boxInfo.contributors[i]);
          }
          ;
          if (!boxInfo.receivers) {
            boxInfo.receivers = [];
          }
          ;
          var receiverArr = [];
          for (var i = 0; i < boxInfo.receivers.length; i++) {
            receiverArr.push(boxInfo.receivers[i]);
          }
          ;
          if (callback) {
            callback(participantArr, receiverArr);
          }
          ;
        }, function () {});
      } else {
        if (callback) {
          callback([]);
        }
        ;
      }
    }
  }, {
    key: "_commentInputHandle",
    value: function _commentInputHandle() {
      var comment = this.$(".comment").val().toString();
      var length = comment.length;
      var num = this.commentNum - length;
      if (num < 0) {
        num = 0;
        comment = comment.substring(0, this.commentNum);
        this.$(".comment").val(comment);
      }
      this.$(".comments-block .num").html(num);
    }
  }, {
    key: "_checkOtherPosition",
    value: function _checkOtherPosition() {
      var _this3 = this;
      var folderView = new _MDChooseFolderWindow["default"]({
        onlyEp: this.isOnlyDepFolder(),
        onchecked: function onchecked(folderId, pathStr) {
          _this3.checkFolderCallback(folderId, pathStr);
        }
      });
      folderView.show();
    }
  }, {
    key: "checkFolderCallback",
    value: function checkFolderCallback(folderId, pathStr) {
      this.parentId = folderId;
      this.$(".positionstr").html(pathStr);
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDManuscriptBoxTabPanelView.prototype), "viewDidRendered", this).call(this);
      this.$('.form-horizontal').validate({
        'errorPlacement': function errorPlacement(error, element) {
          var $formItem = $(element).closest('.col-10');
          if (element.attr('name') == 'box-message') {
            element.after(error);
            return;
          }
          if ($formItem.length > 0) {
            error.appendTo($formItem);
          } else {
            element.after(error);
          }
        },
        highlight: function highlight(element, errorClass, validClass) {
          if ($(element).closest('.choose-contain').length) {
            $(element).closest('.choose-contain').removeClass(validClass).addClass(errorClass);
          } else {
            $(element).removeClass(validClass).addClass(errorClass);
          }
        },
        unhighlight: function unhighlight(element, errorClass, validClass) {
          if ($(element).closest('.choose-contain').length) {
            $(element).closest('.choose-contain').removeClass(errorClass).addClass(validClass);
          } else {
            $(element).removeClass(errorClass).addClass(validClass);
          }
        },
        rules: {
          'box-name': {
            'required': true
          },
          'box-message': {
            'required': false
          },
          'end-date': {
            'required': true
          },
          'contributor-choose-panel': {
            'requiredMember': true
          }
        },
        messages: {
          'box-name': {
            'required': BabelStr.str(3222)
          },
          'box-message': {
            'required': BabelStr.str(3223)
          },
          'end-date': {
            'required': BabelStr.str(3224)
          },
          'contributor-choose-panel': {
            'requiredMember': BabelStr.str(3220)
          }
        }
      });
    }
  }]);
  return MDManuscriptBoxTabPanelView;
}(_MDTabPanelView2["default"]);

},{"1098":1098,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1424":1424,"1426":1426,"1428":1428,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"1478":1478,"1498":1498,"177":177,"273":273,"277":277,"297":297,"32":32,"326":326,"483":483,"55":55,"675":675,"717":717,"72":72,"76":76,"81":81}],483:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1429);
require(1426);
require(1432);
require(1412);
require(1415);
require(1463);
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDWindowView = _interopRequireDefault(require(93));
var _MMFileInfoCollection = _interopRequireDefault(require(298));
var _MDMessageView = _interopRequireDefault(require(55));
/**
 *  Window for move file to new folder
 *  Created by manjun.han
 *  2015.9.14
 */

var MDChooseFolderWindow = _MDWindowView["default"].extend({
  contentTmpl: '<p class="title">' + BabelStr.str(7200) + '</p>' + '<p class="help-block">' + BabelStr.str(7201) + '</p>' + '<div class="wrapper"><div id="treeView"></div></div>',
  className: function className() {
    var superCls = _MDWindowView["default"].prototype.className.call(this);
    return superCls + ' m-moveFileWin';
  },
  initProps: function initProps() {
    var props = _MDWindowView["default"].prototype.initProps.call(this);
    return _.extend(props, {
      fileInforCollection: new _MMFileInfoCollection["default"](),
      fileInfors: null,
      folderId: -1,
      isCopyAction: false,
      deleteAfterMove: true,
      onlyEp: false,
      pathStr: ""
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    opt.title = BabelStr.str(3289);
    opt.buttons = [{
      label: BabelStr.str(155),
      type: 'default'
    }, {
      label: BabelStr.str(154),
      type: 'done',
      autoClose: false,
      onClick: function onClick($e) {
        var targetFolderId = self.folderId;
        if (targetFolderId.slice(0, 5) === '0--00') {
          var type = targetFolderId[5];
          if (type != '2') {
            _MDMessageView["default"].error(BabelStr.str(4779), this.$body);
            this.$('.save').removeClass('disabled');
            return;
          } else {
            targetFolderId = '0';
          }
        } else if (targetFolderId == "load_more") {
          _MDMessageView["default"].error(BabelStr.str(4780), this.$body);
          this.$('.save').removeClass('disabled');
          return;
        }
        self.onchecked(targetFolderId, self.pathStr);
        self.close();
      }
    }];
    opt.width = 800;
    _MDWindowView["default"].prototype.initialize.call(this, opt);
  },
  viewDidRendered: function viewDidRendered() {
    var _this = this;
    var self = this;
    this.$('#treeView').jstree({
      'core': {
        "themes": {
          "dots": false // no connecting dots between dots
        },
        'multiple': false,
        worker: false,
        'data': function data(node, cb) {
          var fileId = node['id'];
          self._getSubfolders(fileId, 0, function (fileInforCollection, pages) {
            var nodes = self._transfromCollectionToJSTreeNodes(fileInforCollection);
            if (pages > 1) {
              var loadMoreNode = {
                id: fileId + '_load_more',
                text: BabelStr.str(477),
                children: false,
                data: {
                  pages: pages,
                  curPage: 0,
                  id: fileId,
                  loadMore: true
                },
                icon: 'load-more icon'
              };
              nodes.push(loadMoreNode);
            }
            self.fileInforCollection.add(fileInforCollection.models);
            cb(nodes);
          });
        }
      }
    });
    var $buttons = this.getActionButtons();
    this.$doneBtn = $buttons.eq(1);
    this.$doneBtn.prop('disabled', true);
    $('#treeView').on("changed.jstree", function (e, data) {
      if (data.action != "select_node") {
        return;
      }
      var node = data.node;
      if (node.data && node.data.loadMore) {
        var page = node.data.curPage + 1;
        var pages = node.data.pages;
        var fileId = node.data.id;
        var parent = self.jsTree.get_node(node.parent);
        self._getSubfolders(fileId, page, function (fileInfoCollection, pages) {
          var newNodes = self._transfromCollectionToJSTreeNodes(fileInfoCollection, false, node.parent);
          var originNodes = _.map(parent.children, function (item) {
            return self.jsTree._model.data[item];
          });
          var loadMoreNode = originNodes.splice(originNodes.length - 1, 1);
          var loadMoreNodeData = loadMoreNode[0].data;
          var nodes = originNodes.concat(newNodes);
          if (loadMoreNodeData.curPage + 2 < pages) {
            nodes = nodes.concat(loadMoreNode);
          }
          self.jsTree._append_json_data(parent, nodes, function (status) {
            if (loadMoreNodeData.curPage + 1 < pages) {
              node.data = loadMoreNodeData;
              node.data.curPage++;
            }
          });
          self.fileInforCollection.add(fileInfoCollection.models);
        });
        self.folderId = "load_more";
        return;
      }
      console.log(data);
      self.folderId = data['node']['id'];
      self.node = data['node'];
      self.pathStr = $("#treeView").jstree().get_path(data['node'], "/");
      self.$doneBtn.prop('disabled', false);
    }).on('open_node.jstree', function (e, data) {
      var curNode = data.node;
      var curId = curNode.id;
      if (curId.slice(0, 5) !== '0--00') {
        return;
      }
      var rootNode = _this.jsTree.get_node('#');
      var idArr = rootNode.children;
      _.each(idArr, function (id) {
        if (id != curNode.id) {
          var _node = _this.jsTree.get_node(id);
          if (_node.state.opened == true) {
            _this.jsTree.close_node(_node);
          }
        }
      });
      var node = data.node;
      console.log(node);
      _this.a = 1;
    });
    this.jsTree = this.$('#treeView').jstree();
  },
  _getSubfolders: function _getSubfolders(fileId, page, success, fail) {
    var type = _MMNetDiskDataController["default"].LISTTYPES.FOLDER;
    var request = this.getRequestById(fileId);
    if (fileId.slice(0, 5) === '0--00') {
      fileId = '0';
    }
    request(fileId, app.currentUser.get('defaultSortIndex'), true, page, this.pageSize, function (fileInforCollection, pages) {
      fileInforCollection = new _MMFileInfoCollection["default"](fileInforCollection.filter(function (fileInfo) {
        return !(fileInfo.isShortcuts() && !fileInfo.isFolder());
      }));
      if (success) {
        success(fileInforCollection, pages);
      }
      ;
    }, function () {
      fail();
    }, {
      type: 2
    });
  },
  getRequestById: function getRequestById(id) {
    var request;
    if (id == '#') {
      if (this.onlyEp) {
        request = _MMNetDiskDataController["default"].getFileTreeRootFoldersOnlyEp;
      } else {
        request = _MMNetDiskDataController["default"].getFileTreeRootFolders;
      }
    } else if (id.slice(0, 5) === '0--00') {
      var type = id[5];
      switch (type) {
        case "1":
          request = MMEnterpriseController.listEnterpriseFiles;
          break;
        case "2":
          request = MMEnterpriseController.listPersonalFiles;
          break;
        case "3":
          request = MMEnterpriseController.listProjectFiles;
          break;
        case "4":
          request = MMEnterpriseController.listJoinShareFiles;
          break;
        case "5":
          request = MMEnterpriseController.getMyTeamFolders;
          break;
        case "6":
          request = MMEnterpriseController.getAllProjectFoldersInEnterpriseInPage;
          break;
      }
    } else {
      var file = this.fileInforCollection.findWhere({
        fileId: id
      });
      if (file.isOwner()) {
        request = MMEnterpriseController.listPersonalFiles;
      } else {
        request = MMEnterpriseController.listEnterpriseFiles;
      }
    }
    return request;
  },
  _transformToJSTreeNode: function _transformToJSTreeNode(fileInfor) {
    var nodeInfo = fileInfor.getTreeNodeInfo();
    var disabled = false;
    if (this.onlyDepFolder && !fileInfor.isDepartmentFolder() && !fileInfor.belongDepartment() && fileInfor.getFileId() != '0') {
      disabled = true;
    }
    if (!fileInfor.canUpload() || this.hasFolder && !fileInfor.canCreateFolder()) {
      disabled = true;
    }
    ;
    nodeInfo.children = !disabled;
    nodeInfo['state']['disabled'] = disabled;
    return nodeInfo;
  },
  _transfromCollectionToJSTreeNodes: function _transfromCollectionToJSTreeNodes(fileInforCollection) {
    var self = this;
    this.fileInforCollection = fileInforCollection;
    var folders = fileInforCollection.filter(function (fileInfor) {
      // return fileInfor.isFolder() && !fileInfor.isOtherPersonSharingFile() && fileInfor.canUpload();
      return fileInfor.isFolder();
    });
    return _.map(folders, function (fileInfor) {
      return self._transformToJSTreeNode(fileInfor);
    });
  }
});
var _default = exports["default"] = MDChooseFolderWindow;

},{"1104":1104,"1184":1184,"1412":1412,"1415":1415,"1426":1426,"1429":1429,"1432":1432,"1454":1454,"1463":1463,"298":298,"55":55,"72":72,"93":93}],177:[function(require,module,exports){
module.exports = {"main":"<div class=\"inner-content\">\r  <form class=\"form-horizontal\">\r    <div class=\"header-block\"></div>\r    <div class=\"row\">\r      <div class=\"col-12 marginB-6\">\r        <div class=\"help-block\"><%=str1%></div> <!-- 投件人可以上传文件（稿件）到投件箱，看到并管理自己的稿件，但不能访问其他投件人的稿件 -->\r      </div>\r    </div>\r    <div class=\"boxpos-block form-item row\">\r      <label class=\"col-3\"><%=BabelStr.str(3287)%></label>\r      <div class=\"col-9 flex-align between middle\">\r        <div class=\"positionstr\"></div>\r        <%if(canMove){%>\r            <label class=\"otherPos text-button done\">  <%=BabelStr.str(3288)%></label>\r        <%}%>\r      </div>\r    </div>\r    <div class=\"boxname-block form-item row\">\r      <label class=\"col-3\"><%=nameStr%></label>\r      <div class=\"col-9\">\r        <div class=\"__input_parent\">\r          <input type=\"text\" id=\"msbox-name\" name=\"box-name\" class=\"form-control testFileName testFileNameEnd\" maxlength=\"100\" testFileName placeholder=\"<%=nameStr%> \" <%=(canEdit ? \"\" : \"disabled\")%>>\r        </div>\r      </div>\r    </div>\r    <div class=\"comments-block form-item row\">\r      <label class=\"col-3\"><%=remarkStr%></label>\r      <div class=\"col-9\">\r        <textarea class = \"form-control comment textinput\" <%=(canEdit ? \"\" : \"disabled\")%> name=\"box-message\" id=\"\" cols=\"30\" rows=\"4\" placeholder=\"<%=BabelStr.str(7026)%>\"></textarea>\r        <%if(canEdit) {%>\r          <div class=\"conment-tip text-right help-block\"><%=numBefore%><span class=\"num\">100</span><%=numAfter%></div>\r        <%}%>\r      </div>\r    </div>\r    <div class=\"end-date-block form-item row\">\r      <label class=\"col-3\"><%=endTimeStr%></label><!-- 截止日期 -->\r      <div class=\"col-9\">\r        <div class = \"datepicker \">\r          <input type=\"text\" class=\"date-end\" name=\"end-date\"  placeholder=\"<%=dateStr%>\" <%=(canEdit ? \"\" : \"disabled\")%>>\r          <%if(canEdit) {%>\r            <i class = \"ep-ic ep-ic-date\"></i>\r          <%}%>\r        </div>\r      </div>\r    </div>\r  <%if(canEdit) {%>\r    <div class=\"box-mem-block form-item row\">\r      <label class=\"col-3\"><%=senderStr%></label>\r      <div class=\"col-9\">\r        <div class=\"contibutor-input form-control\" placeholder=\"<%=checkUserStr%>\" name=\"contributor-choose-panel0\" readonly=\"\"></div>\r      </div>\r    </div>\r    <div class=\"box-mem-block form-item row\">\r      <span class=\"blue-text-btn padding-h5 show-more-btn\"><%=moreStr%></span>\r    </div>\r    <div class=\"box-mem-block form-item row more-opt\">\r      <label class=\"col-3\"><%=otherStr%></label>\r      <div class=\"col-9\">\r        <div class=\"receiver-input form-control\" placeholder=\"<%=checkOtherStr%>\" name=\"receiver-choose-panel0\" readonly=\"\"></div>\r      </div>\r      <div class=\"col-12\">\r        <div class=\"help-block\"><%=tipStr1%></div>\r      </div>\r    </div>\r    <div class=\"box-mem-block form-item row more-opt\">\r      <label class=\"col-12\"><%=BabelStr.str(795)%></label>\r    </div>\r    <div class=\"box-mem-block form-item row more-opt flex-align\">\r      <label class=\"col-3\"><%=BabelStr.str(796)%></label>\r      <div class=\"col-9 flex-align radio-group between pdt-5 with-wrap gap-10\">\r            <div class=\"setting-item radio-box checked\"><%=BabelStr.str(798)%></div>\r            <div class=\"setting-item radio-box \"><%=BabelStr.str(799)%></div>\r            <div class=\"setting-item radio-box\"><%=BabelStr.str(800)%></div>\r      </div>\r    </div>\r  </form>\r  <form class=\"condition-form mgt-10\">\r    <div class=\"box-mem-block form-item row more-opt condition-block f-hide\">\r      <label class=\"col-3 marginT-5\"><%=BabelStr.str(797)%></label>\r      <div class=\"col-9 form-item\">\r        <input name=\"condition\" type=\"text\" placeholder=\"<%=BabelStr.str(801)%>\" textinput required notempty class=\"form-control upload-condition textinput f-none notempty\">\r      </div>\r    </div>\r  <%}%>\r  </form>\r  <div class=\"button-block msblock text-right btns-block\">\r    <%if(canEdit) {%>\r      <button class=\"button done create-msbox\"><%=createStr%></button>\r    <%} else {%>\r      <button class=\"button cancel\"><%=BabelStr.str(156)%></button>\r    <%}%>\r  </div>\r</div>"};
},{}],151:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDEnterpriseShareTabView = _interopRequireDefault(require(675));
var _MDNewEntBroadcastViewTmpl = _interopRequireDefault(require(152));
var _MDNavigationWindowView = _interopRequireDefault(require(92));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDParticipantInfoCollection = _interopRequireDefault(require(277));
var _MDNewEntBroadcastPageView = _interopRequireDefault(require(150));
var _MDShowEntBroadcastPageView = _interopRequireDefault(require(153));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // MDNewEntBroadcastView.js
// jiang 
// 2017-6-6
var MDNewEntBroadcastView = exports["default"] = /*#__PURE__*/function (_MDNavigationWindowVi) {
  (0, _inherits2["default"])(MDNewEntBroadcastView, _MDNavigationWindowVi);
  function MDNewEntBroadcastView() {
    (0, _classCallCheck2["default"])(this, MDNewEntBroadcastView);
    return _callSuper(this, MDNewEntBroadcastView, arguments);
  }
  (0, _createClass2["default"])(MDNewEntBroadcastView, [{
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDNewEntBroadcastView.prototype), "initProps", this).call(this);
      return _.extend(superP, {});
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDNewEntBroadcastView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .upload-file': this.uploadFileHandle
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDNewEntBroadcastView.prototype), "className", this).call(this);
      return superCls + ' entbc-create-win ';
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      opt.width = 840;
      opt.needFooter = false;
      if (!opt.createBC) {
        opt.title = _MDLocalString["default"].getLocalString(3153);
        opt.rootNavigationPageView = new _MDShowEntBroadcastPageView["default"](opt);
      } else {
        opt.rootNavigationPageView = new _MDNewEntBroadcastPageView["default"](opt);
      }
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDNewEntBroadcastView.prototype), "initialize", this).call(this, opt);
    }
  }, {
    key: "setFileInfors",
    value: function setFileInfors(fileInfors) {
      this.rootNavigationPageView.setSelectedFileInfos(fileInfors);
    }
  }]);
  return MDNewEntBroadcastView;
}(_MDNavigationWindowView["default"]);

},{"1098":1098,"1150":1150,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"150":150,"152":152,"153":153,"273":273,"277":277,"55":55,"675":675,"72":72,"92":92}],153:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1424);
require(1426);
require(1439);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDNewEntBroadcastPageView = _interopRequireDefault(require(150));
var _MDParticipantInfoCollection = _interopRequireDefault(require(277));
var _MMFileInfoCollection = _interopRequireDefault(require(298));
var _MDMolaUser = _interopRequireDefault(require(272));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // MDShowEntBroadcastPageView.js
// jichao
// 2019.4.3
var MDShowEntBroadcastPageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDShowEntBroadcastPageView, _MDNavigationPageView);
  function MDShowEntBroadcastPageView() {
    (0, _classCallCheck2["default"])(this, MDShowEntBroadcastPageView);
    return _callSuper(this, MDShowEntBroadcastPageView, arguments);
  }
  (0, _createClass2["default"])(MDShowEntBroadcastPageView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<div class=\"main-content show-entbc\"></div>";
    }
  }, {
    key: "mainTmpl",
    value: function mainTmpl() {
      return "\n      <div class=\"row\">\n        <div class=\"col-2\"><%=BabelStr.str(3156)%></div>\n        <div class=\"col-10\">\n          <%=title%>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-2\"><%=BabelStr.str(3715)%></div>\n        <div class=\"col-10\">\n          <%=creatorName%>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-2\"><%=BabelStr.str(3172)%></div>\n        <div class=\"col-10\">\n          <%=createTime%>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-2\"><%=BabelStr.str(699)%></div>\n        <div class=\"col-10\">\n          <%=participantNames%>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-2\"><%=BabelStr.str(3158)%></div>\n        <div class=\"col-10\">\n          <%=text%>\n        </div>\n      </div>\n      <%if(files && files.length) {%>\n        <div class=\"row\">\n          <div class=\"col-2\"><%=BabelStr.str(3710)%></div>\n          <div class=\"col-10 file-list\">\n            <%for(var i = 0 ; i < files.length ; i++) {%>\n              <div class=\"file-item\" data-id=\"<%=files[i].targetAttachId%>\">\n                <span class=\"text-button done mgr-20 name\"><%=files[i].name%></span>\n                <span class=\"text-button done download\">".concat(BabelStr.str(29), "</span>\n              </div>\n            <%}%>\n          </div>\n        </div>\n      <%}%>\n      <div class=\"btns-block flex-align end\">\n        <button class=\"button done translate\"><%=BabelStr.str(3716)%></button>\n        <button class=\"button done reply\"><%=BabelStr.str(124)%></button>\n      </div>\n    ");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDShowEntBroadcastPageView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        entBCId: null,
        wordMaxLen: 150,
        // --------------- 文字说明的字数限制
        createBC: true,
        placeholder: '',
        onPublishSuccess: _.noop,
        multiple: true,
        download: true
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDShowEntBroadcastPageView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .download': this._downloadFile,
        'click .name': this._openFile,
        'click .translate': this._translateEntBc,
        'click .reply': this._replyEntBc
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      props.btnText = BabelStr.str(156);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDShowEntBroadcastPageView.prototype), "initialize", this).call(this, props);
      this.initData();
    }
  }, {
    key: "_downloadFile",
    value: function _downloadFile($e) {
      var id = $($e.target).closest('.file-item').data("id");
      MMCommonFun.downloadOriginFile(id, -1);
    }
  }, {
    key: "_openFile",
    value: function _openFile($e) {
      var id = $($e.target).closest('.file-item').data("id");
      if (app.pathRouter) {
        app.pathRouter.openNewTabByFileId(id);
      } else if (!app.isInClient) {
        MMCommonFun.downloadOriginFile(id, -1);
      } else {
        window.open(location.origin + '/main.do#file/' + id);
      }
    }
  }, {
    key: "initData",
    value: function initData(callback) {
      var _this = this;
      MMEnterpriseController.getEntBroadcastById(this.entBCId, function (bcInfo) {
        var names = names = _.pluck(bcInfo.participantInfos, 'name');
        _this.user = new _MDMolaUser["default"]({
          id: bcInfo.creator,
          name: bcInfo.creatorName
        });
        _this.data = {
          title: bcInfo['title'],
          creatorName: bcInfo.creatorName,
          createTime: new Date(bcInfo.createTime).format("yyyy-MM-dd HH:mm"),
          participantNames: names.join('，'),
          text: bcInfo['text'],
          files: bcInfo.files
        };
        var contentTmpl = _.template(_this.mainTmpl())(_this.data);
        _this.$('.main-content').html(contentTmpl);
        _this.navigationWindowView.refreshWindow();
      }, function () {});
    }
  }, {
    key: "_translateEntBc",
    value: function _translateEntBc() {
      var pageView = new _MDNewEntBroadcastPageView["default"]({
        entBCTitle: this.data.title,
        entBCText: this.data.text,
        ignoreIsShowingStructor: this.ignoreIsShowingStructor
      });
      var files = this.data.files || [];
      files = _.map(files, function (file) {
        return {
          fileId: file.targetAttachId,
          fileName: file.name
        };
      });
      var fileCollection = new _MMFileInfoCollection["default"](files);
      pageView.setSelectedFileInfos(fileCollection.models);
      this.navigationWindowView.push(pageView);
    }
  }, {
    key: "_replyEntBc",
    value: function _replyEntBc() {
      var pageView = new _MDNewEntBroadcastPageView["default"]({
        defaultUsers: [this.user],
        ignoreIsShowingStructor: this.ignoreIsShowingStructor
      });
      this.navigationWindowView.push(pageView);
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {}
  }]);
  return MDShowEntBroadcastPageView;
}(_MDNavigationPageView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1424":1424,"1426":1426,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"150":150,"272":272,"277":277,"298":298,"56":56,"72":72}],150:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1421);
require(1541);
require(1426);
require(1437);
require(1463);
require(1478);
require(1412);
require(1417);
require(1498);
require(1439);
var _typeof2 = _interopRequireDefault(require(1197));
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDEnterpriseShareTabView = _interopRequireDefault(require(675));
var _MDNewEntBroadcastViewTmpl = _interopRequireDefault(require(152));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDParticipantInfoCollection = _interopRequireDefault(require(277));
var _MDAllFileSelectPageView = _interopRequireDefault(require(544));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // MDNewEntBroadcastPageView.js
// jichao
// 2019.3.29
var MDNewEntBroadcastPageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDNewEntBroadcastPageView, _MDNavigationPageView);
  function MDNewEntBroadcastPageView() {
    (0, _classCallCheck2["default"])(this, MDNewEntBroadcastPageView);
    return _callSuper(this, MDNewEntBroadcastPageView, arguments);
  }
  (0, _createClass2["default"])(MDNewEntBroadcastPageView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return _MDNewEntBroadcastViewTmpl["default"].main;
    }
  }, {
    key: "evalutionUnOrderedTmpl",
    value: function evalutionUnOrderedTmpl() {
      return _MDNewEntBroadcastViewTmpl["default"].evalutionUnOrdered;
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDNewEntBroadcastPageView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        entBCId: null,
        wordMaxLen: 150,
        // --------------- 文字说明的字数限制
        createBC: true,
        placeholder: "",
        onPublishSuccess: _.noop,
        multiple: true,
        download: true,
        entBCText: "",
        entBCTitle: "",
        defaultUsers: []
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDNewEntBroadcastPageView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .upload-file": this.uploadFileHandle,
        "click .publish": this._publishClickHandle,
        'input .textinput': this.textInput
      });
    }

    // className() {
    //   var superCls = super.className();
    //   // return superCls + ' entbc-create-win'
    // }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        titleTipStr: BabelStr.str(3155),
        titleStr: BabelStr.str(3156),
        inputStr: BabelStr.str(3157),
        innerStr: BabelStr.str(3158),
        textareaStr: BabelStr.str(3159),
        numBeforeStr: BabelStr.str(3160),
        numAfterStr: BabelStr.str(3161),
        accessStr: BabelStr.str(3162),
        accessInputStr: BabelStr.str(3163),
        timeStr: BabelStr.str(4521),
        btnText: this.btnText,
        createBC: this.createBC,
        entBCTitle: this.entBCTitle,
        entBCText: this.entBCText
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDNewEntBroadcastPageView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      if (props.fileInfo) {
        props.createMsBox = false;
        this.fileId = props.fileInfo.getFileId();
      }
      props.title = BabelStr.str(3706);
      this.targetUsers = [];
      props.btnText = BabelStr.str(406);
      // if (!props.createBC) {
      //   props.btnText = BabelStr.str(156);
      // };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDNewEntBroadcastPageView.prototype), "initialize", this).call(this, props);
      this.$bcForm = this.$(".broadcast-form");
      this.$bcForm.validate({
        highlight: function highlight(element, errorClass, validClass) {
          if ($(element).closest(".choose-contain").length) {
            $(element).closest(".choose-contain").removeClass(validClass).addClass(errorClass);
          } else {
            $(element).removeClass(validClass).addClass(errorClass);
          }
          // this.navigationWindowView && this.navigationWindowView.refreshWindow()
        },
        unhighlight: function unhighlight(element, errorClass, validClass) {
          if ($(element).closest(".choose-contain").length) {
            $(element).closest(".choose-contain").removeClass(errorClass).addClass(validClass);
          } else {
            $(element).removeClass(errorClass).addClass(validClass);
          }
        },
        errorPlacement: function errorPlacement(error, element) {
          if (element.attr("name") && element.attr("name").indexOf("choose-panel") > -1) {
            error.appendTo(element.closest(".col-10"));
          } else {
            element.after(error);
          }
        }
      });
      // this.initData((participantArr) => {
      var participantArr = [];
      if (this.defaultUsers.length) {
        var participantCollection = _MDParticipantInfoCollection["default"].createFromUserCollection(this.defaultUsers);
        participantArr = participantCollection.models;
      }
      this.renderContributors(participantArr);
      // });
    }
  }, {
    key: "textInput",
    value: function textInput(e) {
      var _this = this;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(function () {
        _this.navigationWindowView && _this.navigationWindowView.refreshWindow();
      }, 400);
    }
  }, {
    key: "uploadFileHandle",
    value: function uploadFileHandle() {
      var _this2 = this;
      // let sourceType = new MDSelectFileSourceTypePageView();
      // this.navigationWindowView.push(sourceType)
      var selectFilePageView = new _MDAllFileSelectPageView["default"]({
        title: BabelStr.str(3707),
        multiple: this.multiple,
        download: this.download,
        intercept: function intercept(file) {
          return !file.isDepartmentFolder() && file.getSecretLevelId() == 4;
        },
        onselectedSuccess: function onselectedSuccess(files) {
          _this2.setSelectedFileInfos(files);
        }
      });
      this.navigationWindowView.push(selectFilePageView);
    }
  }, {
    key: "setSelectedFileInfos",
    value: function setSelectedFileInfos(fileInfors) {
      var _this3 = this;
      var ids = _.map(this.$(".file-item"), function (item) {
        return $(item).data("id").toString();
      });
      _.each(fileInfors, function (fileInfor) {
        var fileId = fileInfor.getFileId();
        if (_.indexOf(ids, fileId) > -1) {
          return;
        }
        var fileName = fileInfor.getFileName();
        var $file = $("<div class=\"mgb-10 file-item\" data-id=\"".concat(fileId, "\">\n                    <span class=\"text-button mgr-20 name \">").concat(fileName, "</span>\n                    <span class=\"text-button done del\">").concat(BabelStr.str(32), "</span>\n                  </div>\n                  "));
        _this3.$(".file-list").append($file);
        $file.find(".del").on("click", function ($e) {
          $($e.target).closest(".file-item").remove();
          _this3.navigationWindowView.refreshWindow();
        });
      });
    }
  }, {
    key: "getAppendFileIds",
    value: function getAppendFileIds() {
      return _.map(this.$(".file-item"), function (item) {
        return {
          attachId: $(item).data("id"),
          attachType: 0,
          name: $(item).find(".name").text().trim()
        };
      });
    }
  }, {
    key: "renderContributors",
    value: function renderContributors(participantArr) {
      var _this4 = this;
      if (!participantArr) {
        participantArr = [];
      }
      if (this.createBC) {
        this.targetUsers = participantArr;
        this.contributorListItemView = new _MDEnterpriseShareTabView["default"]({
          defaultParticipantInfoCollection: new _MDParticipantInfoCollection["default"](participantArr),
          inputName: "bc-tg-choose-panel",
          placeholder: BabelStr.str(3154),
          ignoreIsShowingStructor: this.ignoreIsShowingStructor,
          notIncludeGuest: true,
          canSelGroup: true,
          needFrequentUserTab: false,
          isSelectOnlyInEp: true,
          tabHeight: 240,
          onChange: function onChange(userCollection) {
            setTimeout(function () {
              _this4.navigationWindowView.refreshWindow();
            });
          },
          onTabShow: function onTabShow() {
            setTimeout(function () {
              _this4.navigationWindowView.refreshWindow();
            });
          },
          onTabHide: function onTabHide() {
            setTimeout(function () {
              _this4.navigationWindowView.refreshWindow();
            });
          }
        });
        this.addSubView(this.contributorListItemView, this.$(".bc-tg-input")[0]);
        // this.contributorListItemView.hideTab();
        this._addRuleForNewItem();
      } else {
        var names = "";
        _.each(participantArr, function (participant) {
          var name = participant.name;
          names += "<span class=\"user-name \">".concat(name, "</span>");
        });
        this.$(".bc-tg-input").append(names);
      }
    }
  }, {
    key: "_addRuleForNewItem",
    value: function _addRuleForNewItem() {
      var $input = this.contributorListItemView.getItemInput();
      $input.rules("add", {
        requiredMember: true
      });
    }
  }, {
    key: "_publishClickHandle",
    value: function _publishClickHandle() {
      var _this5 = this;
      if (this.createBC) {
        this.$("#bc-title").val(this.$("#bc-title").val().trim());
        this.$(".content").val(this.$(".content").val().trim());
        var validator = this.$bcForm.validate();
        if (!validator.form()) {
          return;
        }
        var title = _.escape(this.$("#bc-title").val());
        var contentStr = _.escape(this.$(".content").val());
        // var title = (this.$('#bc-title').val());
        // var contentStr = (this.$('.content').val());

        var targetUsers = this.contributorListItemView.getTargetEmails();
        var files = this.getAppendFileIds();
        _czc && _czc.push(["_trackEvent", "通知与消息", "发送企业消息", "", "", ""]);
        if (!targetUsers.userIds.length && !targetUsers.deps.length && !targetUsers.groupIds.length) {
          _MDMessageView["default"].error(BabelStr.str(4856), this.$el);
          return;
        }
        _MMEnterpriseController["default"].publishEntBC(title, contentStr, targetUsers.userIds, targetUsers.deps, targetUsers.groupIds, files, function () {
          _this5.navigationWindowView.close();
          _this5.onPublishSuccess && _this5.onPublishSuccess();
          _MDMessageView["default"].success(BabelStr.str(3516));
        }, function () {
          _MDMessageView["default"].error(BabelStr.str(3517), _this5.$el);
        });
      } else {
        this.navigationWindowView.close();
      }
    }
  }, {
    key: "initData",
    value: function initData(callback) {
      var _this6 = this;
      if (!this.createBC) {
        _MMEnterpriseController["default"].getEntBroadcastById(this.entBCId, function (bcInfo) {
          _this6.$("#bc-title").val(_.unescape(bcInfo["title"]));
          _this6.$(".content").val(_.unescape(bcInfo["text"]));
          var dtype = (0, _typeof2["default"])(bcInfo.createTime);
          if (dtype == "string" || dtype == "number") {
            bcInfo.createTime = new Date(bcInfo.createTime).format("yyyy-MM-dd HH:mm");
          }
          _this6.$(".pubTime").text(bcInfo.createTime);
          var participantArr = bcInfo.participantInfos;
          _this6.renderFileInfos(bcInfo.files || []);
          if (callback) {
            callback(participantArr);
          }
          _this6.navigationWindowView.refreshWindow();
        }, function () {});
      } else {
        this.$(".bc-time").remove();
        if (callback) {
          callback([]);
        }
      }
    }
  }, {
    key: "renderFileInfos",
    value: function renderFileInfos(files) {
      var _this7 = this;
      // return
      if (!files.length) {
        this.$(".file-list").closest(".row").hide();
      }
      _.each(files, function (file) {
        var fileId = file.targetAttachId;
        var fileName = file.name;
        var $file = $("<div class=\"mgb-10 file-item\" data-id=\"".concat(fileId, "\">\n                    <span class=\"text-button done mgr-20 name\">").concat(fileName, "</span>\n                    <span class=\"text-button done download\">").concat(BabelStr.str(29), "</span>\n                  </div>\n                  "));
        _this7.$(".file-list").append($file);
        $file.find(".download").on("click", function ($e) {
          var id = $($e.target).closest(".file-item").data("id");
          MMCommonFun.downloadOriginFile(id, -1);
        });
        $file.find(".name").on("click", function ($e) {
          var id = $($e.target).closest(".file-item").data("id");
          if (app.pathRouter) {
            app.pathRouter.openNewTabByFileId(id);
          } else if (!app.isInClient) {
            MMCommonFun.downloadOriginFile(id, -1);
          } else {
            window.open(location.origin + "/main.do#file/" + id);
          }
        });
      });
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      if (!this.createBC) {
        this.$(".help-block, .content-tip").remove();
        this.$("#bc-title").attr("readonly", "true");
        this.$("textarea").attr("readonly", "true");
      }
    }
  }]);
  return MDNewEntBroadcastPageView;
}(_MDNavigationPageView2["default"]);

},{"1098":1098,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1197":1197,"1412":1412,"1417":1417,"1421":1421,"1426":1426,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"1478":1478,"1498":1498,"152":152,"1541":1541,"273":273,"277":277,"544":544,"55":55,"56":56,"675":675,"72":72}],544:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDWindowView = _interopRequireDefault(require(93));
var _MDAllFileTreePanelView = _interopRequireDefault(require(547));
var _MDAllFileSelectTableView = _interopRequireDefault(require(545));
var _MDAllFileSelectView = _interopRequireDefault(require(546));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 *  选择文件窗口
 *  Created by jichao 
 *  2017.12.22
 */
// 1.fileInfoCollection 通过树形目录按需获取（双击目录获取）
// 2.右侧文件列表所需的fileInfoCollection通过trigger
var MDAllFileSelectPageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDAllFileSelectPageView, _MDNavigationPageView);
  function MDAllFileSelectPageView() {
    (0, _classCallCheck2["default"])(this, MDAllFileSelectPageView);
    return _callSuper(this, MDAllFileSelectPageView, arguments);
  }
  (0, _createClass2["default"])(MDAllFileSelectPageView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n    <div class=\"select-root\">\n     \n \n    </div>\n      ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAllFileSelectPageView.prototype), "className", this).call(this);
      return "".concat(superCls, " file-selection-block");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAllFileSelectPageView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        multiple: false,
        download: false,
        intercept: function intercept() {
          return false;
        },
        onselectedSuccess: _.noop
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAllFileSelectPageView.prototype), "events", this).call(this);
      return _.extend(superE, {});
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      if (props.title) {} else if (props.onlyCompare) {
        props.title = BabelStr.str(3391); // "请选择文件进行内容查看比较";    
      } else {
        props.title = BabelStr.str(3321); // "请选择文件进行内容比较或合并";
      }
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAllFileSelectPageView.prototype), "initialize", this).call(this, props);
      var self = this;

      // this.renderEmpty();
      this.selectView = new _MDAllFileSelectView["default"](_.extend(props, {
        multiple: this.multiple,
        download: this.download,
        onlyDep: this.onlyDep,
        openedNodes: this.openedNodes,
        intercept: function intercept(file) {
          return _this.intercept(file);
        },
        _nextBtnClicked: function next(params) {
          self._nextFileClickHandle(params);
        },
        _canelBtnClicked: function _canelBtnClicked() {
          self._cancelClickHandle();
        }
      }));
      this.addSubView(this.selectView, this.$(".select-root"));
    }
  }, {
    key: "_openFileClickHandle",
    value: function _openFileClickHandle() {
      var folderId = this.fileInfor.getFileId();
      this.displayFilesByFolderId(folderId);
    }
  }, {
    key: "_cancelClickHandle",
    value: function _cancelClickHandle() {
      if (_.isFunction(this.closeCallback)) {
        this.closeCallback();
      } else {
        this.navigationWindowView.pop();
      }
    }
  }, {
    key: "_nextFileClickHandle",
    value: function _nextFileClickHandle(fileInfos) {
      // let rootView = this.navigationView.navigationPageViewStack[0]
      // rootView.setSelectedFileInfos(fileInfos);
      _.isFunction(this.onselectedSuccess) && this.onselectedSuccess(fileInfos);
      this.navigationWindowView && this.navigationWindowView.pop();
      console.log(this.navigationWindowView);
    }
  }]);
  return MDAllFileSelectPageView;
}(_MDNavigationPageView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"545":545,"546":546,"547":547,"56":56,"93":93}],546:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1429);
require(1498);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMViewBase2 = _interopRequireDefault(require(22));
var _MDWindowView = _interopRequireDefault(require(93));
var _MDAllFileTreePanelView = _interopRequireDefault(require(547));
var _MDAllFileSelectTableView = _interopRequireDefault(require(545));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _keycode = _interopRequireDefault(require(104));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 *  选择文件窗口
 *  Created by jichao
 *  2017.12.22
 */
// 1.fileInfoCollection 通过树形目录按需获取（双击目录获取）
// 2.右侧文件列表所需的fileInfoCollection通过trigger
var MDAllFileSelectView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MDAllFileSelectView, _MMViewBase);
  function MDAllFileSelectView() {
    (0, _classCallCheck2["default"])(this, MDAllFileSelectView);
    return _callSuper(this, MDAllFileSelectView, arguments);
  }
  (0, _createClass2["default"])(MDAllFileSelectView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n    <div class=\"search-block\">\n      <input type=\"\" class=\"form-control search-input\" placeholder=\"<%=BabelStr.str(28163)%>\"/>\n      <div class=\"search-close icon\"></div>\n    </div>\n    <div class=\"inner-block\">\n     <div class=\"flex-align between title\">\n        <span>".concat(BabelStr.str(3323), " :</span>\n        <div class=\"tool-block\">\n          <div class=\"new-icon icon30 grid\"></div>\n          <div class=\"new-icon icon30 list\"></div>\n        </div>\n      </div>\n      <div class=\"flex-align between normal-list-block\">\n        <div class=\"left-block no-shrink\"></div>\n        <div class=\"no-shrink fullfill p-re\">\n          <div class=\"main-block \"></div>\n          <div class=\"pading-wrap flex-align center middle\"></div>\n        </div>\n      </div>\n      <div class=\"search-list-block\"></div>\n    </div>\n\n\n\n    <div class=\"button-block flex-align end btns-block\">\n      <button class=\"button cancel-btn\">").concat(BabelStr.str(155), "</button>\n      <button class=\"button done open-file\">").concat(BabelStr.str(3331), "</button>\n      <button class=\"button done next-step\">").concat(BabelStr.str(3139), "</button>\n    </div>\n      ");
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAllFileSelectView.prototype), "className", this).call(this);
      return "".concat(superCls, " file-selection-block file-selection-page");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAllFileSelectView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        multiple: false,
        download: false,
        canSelectLinkfile: false,
        canSelectFolder: false
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAllFileSelectView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .open-file': this._openFileClickHandle,
        'click .next-step': this._nextFileClickHandle,
        'click .cancel-btn': this._cancelClickHandle,
        "click .list": this._showList,
        "click .grid": this._showGrid,
        "keydown .search-input": this._searchInputKeydownHandler,
        "keyup .search-input": this._searchInputKeyupHandler,
        "click .search-close": this._closeSearch
      });
    }
  }, {
    key: "_searchInputKeydownHandler",
    value: function _searchInputKeydownHandler($e) {
      var code = $e.which;
      if (_keycode["default"].isEnterKey(code)) {
        this.enterKey = true;
      } else {
        this.enterKey = false;
      }
    }
  }, {
    key: "_searchInputKeyupHandler",
    value: function _searchInputKeyupHandler($e) {
      var code = $e.which;
      if (this.enterKey && _keycode["default"].isEnterKey(code)) {
        this._searchKeys();
      }
    }
  }, {
    key: "_searchKeys",
    value: function _searchKeys() {
      var parentId = this.currentFolderId;
      if (this.currentFolderId.slice(0, 5) === "0--00") {
        parentId = 0;
      }
      var queryString = this.$(".search-input").val().trim();
      this.searchFileOptions = {
        scope: 3,
        queryString: queryString,
        pageSize: 99999,
        parentId: parentId,
        type: 1,
        // scopePageSize: this.scopePageSize,
        orderBy: app.currentUser.get("defaultSortIndex"),
        isAsc: app.currentUser.getDefaultSortDirIsAsc(),
        // channel: this.getSearchChannel(this.keyWords),
        advancedOption: {}
      };
      this.originFileInfos = this.fileInfors;
      this.searchPanel.setDisplayCollection([], true);
      this.searchFromLoadedData();
      this.$el.addClass("search");
      // }
    }
  }, {
    key: "searchFromLoadedData",
    value: function searchFromLoadedData() {
      this.useAdvancedSearchFileByName1request();
    }
  }, {
    key: "useAdvancedSearchFileByName1request",
    value: function useAdvancedSearchFileByName1request(callback) {
      var self = this;
      this.searchPanel.startLoading();
      this.renderSelectFile([]);
      _MMNetDiskDataController["default"].useAdvancedSearchsearchFileByName(this.searchFileOptions, function (fileInforCollection, scopeTotal, text, res) {
        console.log(fileInforCollection);
        var files = [];
        if (!self.canSelectFolder) {
          fileInforCollection.each(function (file) {
            if (!file.isFolder()) {
              files.push(file);
            }
          });
        } else {
          files = fileInforCollection.models;
        }
        self.searchPanel.setDisplayCollection(files);
        // this.renderSelectFile();
        self.searchPanel.endLoading();
      }, function (code, text) {
        self.searchPanel.endLoading();
        self.searchPanel.setDisplayCollection(fileInforCollection.models);
      });
    }
  }, {
    key: "_closeSearch",
    value: function _closeSearch() {
      this.$el.removeClass("search");
      this.$(".search-input").val("");
      if (this.originFileInfos) {
        this.renderSelectFile(this.originFileInfos);
      }
    }
  }, {
    key: "searchFromServer",
    value: function searchFromServer() {
      console.log("从服务器搜");
    }
  }, {
    key: "_showList",
    value: function _showList() {
      this.$el.addClass("list-mode");
    }
  }, {
    key: "_showGrid",
    value: function _showGrid() {
      this.$el.removeClass("list-mode");
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      if (props.onlyCompare) {
        props.title = BabelStr.str(3391); // "请选择文件进行内容查看比较";
      } else {
        props.title = BabelStr.str(3321); // "请选择文件进行内容比较或合并";
      }
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAllFileSelectView.prototype), "initialize", this).call(this, props);
      if (!this.multiple || !this.canSelectFolder) {
        this.$el.addClass("no-select-all");
      }
      if (props.onlyForSelect) {
        this.$('.next-step').text(BabelStr.str(154));
      }

      // this.renderEmpty();
      this.leftPanel = new _MDAllFileTreePanelView["default"]({
        canSelectFolder: this.canSelectFolder,
        setDisplayCollection: function setDisplayCollection(fileInforCollection, folderId, parent) {
          _this.$(".main-block")[0].scrollTop = 0;
          _this.setDisplayCollection(fileInforCollection);
          _this.currentFolderId = folderId;
          _this.hasFetchAllData = false;
          console.log(_this.currentFolderId);
          if (parent.getFileId().slice(0, 5) === "0--00") {
            if (parent.getFileId() == "0--002") {
              _this.renderSelectFile([parent]);
            }
          } else {
            _this.renderSelectFile([parent]);
          }
        },
        appendDisplayCollection: function appendDisplayCollection(fileInforCollection, hasFetchAllData) {
          _this.appendDisplayCollection(fileInforCollection);
          // if(!fileInforCollection.length) {
          _this.hasFetchAllData = hasFetchAllData;
          // }
        },
        onlyDep: this.onlyDep,
        openedNodes: this.openedNodes || ["0--001"]
      });
      this.addSubView(this.leftPanel, this.$(".left-block")[0]);
      this.mainPanel = new _MDAllFileSelectTableView["default"]({
        multiple: this.multiple,
        canSelectFolder: this.canSelectFolder,
        download: this.download,
        intercept: function intercept(file) {
          if (_.isFunction(_this.intercept)) {
            return _this.intercept(file);
          }
          return false;
        },
        canSelectLinkfile: this.canSelectLinkfile,
        displayFilesByFolderId: function displayFilesByFolderId(folderId) {
          _this.displayFilesByFolderId(folderId);
        },
        renderSelectFile: function renderSelectFile(fileInfors) {
          _this.renderSelectFile(fileInfors);
        }
      });
      this.addSubView(this.mainPanel, this.$(".main-block")[0]);
      this.searchPanel = new _MDAllFileSelectTableView["default"]({
        multiple: this.multiple,
        canSelectFolder: this.canSelectFolder,
        download: this.download,
        isSearch: true,
        intercept: function intercept(file) {
          if (_.isFunction(_this.intercept)) {
            return _this.intercept(file);
          }
          return false;
        },
        canSelectLinkfile: this.canSelectLinkfile,
        displayFilesByFolderId: function displayFilesByFolderId(folderId) {
          // this.displayFilesByFolderId(folderId)
        },
        renderSelectFile: function renderSelectFile(fileInfors) {
          _this.renderSelectFile(fileInfors);
        }
      });
      this.addSubView(this.searchPanel, this.$(".search-list-block")[0]);
      this.$open = this.$('.open-file');
      this.$next = this.$('.next-step');
      this.renderSelectFile();
      this.$(".main-block").on("scroll", function () {
        var scrollTop = _this.$(".main-block").scrollTop();
        if (scrollTop < 100) {
          return;
        }
        var scrollBottom = _this.$(".main-block")[0].scrollHeight - _this.$(".main-block").height() - scrollTop;
        _this.onTableScroll(scrollTop, scrollBottom);
      });
    }
  }, {
    key: "startPagitionLoading",
    value: function startPagitionLoading() {
      this.loading = true;
      this.$('.pading-wrap').show();
      _MDSpinnerloaderView["default"].showIn(this.$('.pading-wrap'));
    }
  }, {
    key: "clearPaginationLoading",
    value: function clearPaginationLoading() {
      this.loading = false;
      this.$('.pading-wrap').hide();
      _MDSpinnerloaderView["default"].clearFrom(this.$('.pading-wrap'));
    }
  }, {
    key: "onTableScroll",
    value: function onTableScroll(scrollTop, scrollBottom) {
      var _this2 = this;
      var self = this;
      if (this.loading) {
        return;
      }
      if (scrollBottom < 100 && !this.hasFetchAllData) {
        this.startPagitionLoading();
        this.leftPanel.loadNextPageById(this.currentFolderId, function () {
          _this2.clearPaginationLoading();
        });
      }
    }
  }, {
    key: "displayFilesByFolderId",
    value: function displayFilesByFolderId(folderId) {
      this.leftPanel.openNodeByFileId(folderId);
    }
  }, {
    key: "setDisplayCollection",
    value: function setDisplayCollection(fileInforCollection) {
      this.mainPanel.setDisplayCollection(fileInforCollection);
      this.renderSelectFile();
      this.clearPaginationLoading();
    }
  }, {
    key: "appendDisplayCollection",
    value: function appendDisplayCollection(fileInforCollection) {
      this.mainPanel.appendDisplayCollection(fileInforCollection);
      this.clearPaginationLoading();
    }
  }, {
    key: "_openFileClickHandle",
    value: function _openFileClickHandle() {
      var folderId = this.fileInfors[0].getFileId();
      this.displayFilesByFolderId(folderId);
    }
  }, {
    key: "_cancelClickHandle",
    value: function _cancelClickHandle() {
      if (this._canelBtnClicked) {
        this._canelBtnClicked();
      }
    }
  }, {
    key: "renderSelectFile",
    value: function renderSelectFile(fileInfors) {
      if (!fileInfors || !fileInfors.length) {
        this.fileInfors = [];
        this.$next.hide();
        this.$open.show().attr("disabled", true);
        return;
      }
      this.fileInfors = fileInfors;
      if (this.fileInfors.length == 1 && this.fileInfors[0].isFolder() && !this.canSelectFolder) {
        this.$next.hide();
        this.$open.show().attr("disabled", false);
      } else {
        this.$next.show();
        this.$open.hide();
      }
      console.log(this.fileInfors);
    }
  }, {
    key: "_nextFileClickHandle",
    value: function _nextFileClickHandle() {
      if (this._nextBtnClicked) {
        this._nextBtnClicked(this.fileInfors);
      }
    }
  }, {
    key: "detachSubView",
    value: function detachSubView(view) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAllFileSelectView.prototype), "detachSubView", this).call(this, view);
    }
  }]);
  return MDAllFileSelectView;
}(_MMViewBase2["default"]);

},{"104":104,"1104":1104,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1429":1429,"1454":1454,"1463":1463,"1475":1475,"1498":1498,"22":22,"545":545,"547":547,"76":76,"93":93}],547:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1415);
require(1463);
require(1426);
require(1429);
require(1412);
require(1432);
require(1421);
var _MMViewBase = _interopRequireDefault(require(22));
var _MMFileInfoCollection = _interopRequireDefault(require(298));
/**
 *  文件选择界面树形目录
 *  Created by jichao
 *  2017.12.22
 */

// import MDCombobox from '../../../../base/component/MDCombobox.js'

var MDAllFileTreePanelView = _MMViewBase["default"].extend({
  className: function className() {
    var superCls = _MMViewBase["default"].prototype.className.call(this);
    return superCls + ' m-file-tree';
  },
  tmpl:
  // '<div class="tree-tool-bar">'+'</div>'+
  '<div class="tree-wrap mgt-15">' + '<div id="fileTreeView" class="file-tree-view"></div>' + '</div>',
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      allfileCollection: new _MMFileInfoCollection["default"](),
      pageSize: 20,
      onlyFolder: false,
      openedNodes: []
    });
  },
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    if (!this.openedNodes) {
      this.openedNodes = [];
    }
  },
  openNodeByFileId: function openNodeByFileId(folderId) {
    var treeView = this.$('#fileTreeView').jstree();
    treeView.open_node(folderId);
    treeView.select_node(folderId);
  },
  loadFileTreeNode: function loadFileTreeNode(node, callback, selected) {
    var self = this;
    var $jsTree = this.$('#fileTreeView').jstree();
    // open_node会直接请求数据
    $jsTree.open_node && $jsTree.open_node(node['id'], function () {
      _.delay(function () {
        //刷新页面时，二级目录无法加载的问题
        callback();
      }, 0);
      if (selected) {
        self.selectNodeByFileId(node['id']);
      }
    });
  },
  _transformToJSTreeNode: function _transformToJSTreeNode(fileInfor, isRootTree, parentId) {
    var nodeInfo = fileInfor.getTreeNodeInfo(parentId);
    if (isRootTree && !!parentId) {
      nodeInfo.parent = parentId == "-1" ? "#" : parentId;
    }
    return nodeInfo;
  },
  _transfromCollectionToJSTreeNodes: function _transfromCollectionToJSTreeNodes(fileInforCollection, isRootTree, parentId) {
    var self = this;
    var folders = fileInforCollection.filter(function (fileInfor) {
      return fileInfor.isFolder();
    });
    return _.map(folders, function (fileInfor) {
      return self._transformToJSTreeNode(fileInfor, isRootTree, parentId);
    });
  },
  _getSubfolders: function _getSubfolders(fileId, page, success, fail) {
    var type = MMNetDiskDataController.LISTTYPES.FOLDER;
    var request = this.getRequestById(fileId);
    var idOrigin = fileId;
    if (fileId.slice(0, 5) === '0--00') {
      fileId = '0';
    }
    request(fileId, app.currentUser.get('defaultSortIndex'), true, page, this.pageSize, function (fileInforCollection, total, pages) {
      fileInforCollection = new _MMFileInfoCollection["default"](fileInforCollection.filter(function (fileInfo) {
        fileInfo.set('parentFolderId', idOrigin);
        return !(fileInfo.isShortcuts() && !fileInfo.isFolder());
      }));
      fileInforCollection = new _MMFileInfoCollection["default"](fileInforCollection.filter(function (file) {
        return !file.get('applyForTeamOrProj');
      }));
      if (success) {
        success(fileInforCollection, pages);
      }
      ;
    }, function () {
      fail();
    }, {
      // type: this.onlyFolder? 2: undefined
    });
  },
  getRequestById: function getRequestById(id) {
    var request;
    if (id == '#') {
      if (this.onlyDep) {
        request = MMNetDiskDataController.getFileTreeRootFoldersOnlyDep;
      } else {
        request = MMNetDiskDataController.getFileTreeRootFolders;
      }
    } else if (id.slice(0, 5) === '0--00') {
      var type = id[5];
      switch (type) {
        case "1":
          request = MMEnterpriseController.listEnterpriseFiles;
          break;
        case "2":
          request = MMEnterpriseController.listPersonalFiles;
          break;
        case "3":
          request = MMEnterpriseController.listProjectFiles;
          break;
        case "4":
          request = MMEnterpriseController.listJoinShareFiles;
          break;
        case "5":
          request = MMEnterpriseController.getMyTeamFolders;
          break;
        case "6":
          request = MMEnterpriseController.getAllProjectFoldersInEnterpriseInPage;
          break;
      }
    } else {
      var file = this.allfileCollection.findWhere({
        fileId: id
      });
      if (file.isOwner()) {
        request = MMEnterpriseController.listPersonalFiles;
      } else {
        request = MMEnterpriseController.listEnterpriseFiles;
      }
    }
    return request;
  },
  getRootNode: function getRootNode(cb) {
    var _this = this;
    var self = this;
    var option = {
      fileId: '0',
      pathIds: [],
      type: MMNetDiskDataController.LISTTYPES.ALL
    };
    MMEnterpriseController.getFilePathTree(option, function (tree) {
      var nodeArr = [];
      _.each(tree, function (item) {
        var nodes = [];
        var fileInforCollection = new _MMFileInfoCollection["default"](item.files);
        fileInforCollection.each(function (file) {
          file.set('parentFolderId', '0');
        });
        fileInforCollection.sortByName();
        self.allfileCollection.add(fileInforCollection.models);
        nodes = _this._transfromCollectionToJSTreeNodes(fileInforCollection);
        nodeArr = nodeArr.concat(nodes);
      });
      cb(nodeArr);
    }, function () {});
  },
  _renderFolderTree: function _renderFolderTree() {
    var _this2 = this;
    var self = this;
    if (this.jsTree) {
      this.$('#fileTreeView').empty();
    }
    ;
    this.jsTree = this.$('#fileTreeView').jstree({
      'core': {
        "themes": {
          // 'stripes': true ,
          "dots": false // no connecting dots between dots
        },
        'expand_selected_onload': false,
        'multiple': false,
        worker: false,
        'data': function data(node, cb) {
          var fileId = node['id'];
          self._getSubfolders(fileId, 0, function (fileInforCollection, pages) {
            var nodes = self._transfromCollectionToJSTreeNodes(fileInforCollection);
            if (self.openedNodes.length) {
              _.each(nodes, function (node) {
                if (node.id == self.openedNodes[0]) {
                  self.openedNodes.shift();
                  node.state.opened = true;
                }
              });
            }
            if (pages > 1) {
              var loadMoreNode = {
                id: fileId + '_load_more',
                text: BabelStr.str(477),
                children: false,
                data: {
                  pages: pages,
                  curPage: 0,
                  id: fileId,
                  loadMore: true
                },
                icon: 'load-more icon'
              };
              nodes.push(loadMoreNode);
            }
            self.allfileCollection.add(fileInforCollection.models);
            cb(nodes);
          }, function () {
            cb([]);
          });
        }
      },
      'plugins': ['contextmenu', 'dnd']
    });
    this.jsTree = this.$('#fileTreeView').jstree();
    this.$('#fileTreeView').on('loaded.jstree', function (e, data) {
      self.$('#fileTreeView').jstree().open_node("0");
    }).on('select_node.jstree', function (e, data) {
      var node = data.node;
      if (node.data && node.data.loadMore) {
        // let page = node.data.curPage + 1;
        // let pages = node.data.pages;
        // let fileId = node.data.id;
        // let parent = self.jsTree.get_node(node.parent)
        // self._getSubfolders(fileId, page, function(fileInfoCollection, pages) {
        //   var newNodes = self._transfromCollectionToJSTreeNodes(fileInfoCollection, false, node.parent);
        //   let originNodes = _.map(parent.children, item => {
        //     return self.jsTree._model.data[item]
        //   })
        //   let loadMoreNode = originNodes.splice(originNodes.length-1, 1)
        //   let loadMoreNodeData = loadMoreNode[0].data
        //   let nodes = originNodes.concat(newNodes)
        //   if(loadMoreNodeData.curPage + 2 < pages) {
        //       nodes = nodes.concat(loadMoreNode)
        //   }
        //   self.jsTree._append_json_data(parent, nodes, function (status) {
        //     if(loadMoreNodeData.curPage + 1 < pages) {
        //         node.data = loadMoreNodeData;
        //         node.data.curPage++
        //     }
        //   });
        //   self.allfileCollection.add(fileInfoCollection.models)
        //   self.appendDisplayCollection(fileInfoCollection)
        // })

        self.loadMoreBtnselectHandle(node);
        self.folderId = "load_more";
        return;
      }
      var parentId = node.id;
      if (node.state.loaded) {
        self.openFolder(parentId);
      } else {
        self.jsTree.open_node(parentId, function (node, result) {
          if (node.children.length < 1) {
            var _parentId = node.id;
            self.openFolder(_parentId);
            console.log(data);
          }
        });
      }
    }).on("after_open.jstree", function (e, data) {
      var node = data['node'];
      var parentId = node.id;
      self.openFolder(parentId);
      console.log(data);
    }).on('open_node.jstree', function (e, data) {
      var curNode = data.node;
      var curId = curNode.id;
      if (curId.slice(0, 5) !== '0--00') {
        return;
      }
      var rootNode = _this2.jsTree.get_node('#');
      var idArr = rootNode.children;
      _.each(idArr, function (id) {
        if (id != curNode.id) {
          var _node = _this2.jsTree.get_node(id);
          if (_node.state.opened == true) {
            _this2.jsTree.close_node(_node);
          }
        }
      });
      var node = data.node;
      console.log(node);
      _this2.a = 1;
    });
  },
  viewDidRendered: function viewDidRendered() {
    this._renderFolderTree();
  },
  isNodeLoadedAll: function isNodeLoadedAll(id) {
    var node = this.jsTree.get_node("".concat(id, "_load_more"));
    return !node;
  },
  loadTargetNodeByLoadedParent: function loadTargetNodeByLoadedParent(id, parentId, success) {
    var _this3 = this;
    var node = this.jsTree.get_node("".concat(parentId, "_load_more"));
    this.loadMoreBtnselectHandle(node, function (newNodes) {
      var pathNode = _.findWhere(newNodes, {
        id: id
      });
      if (!pathNode) {
        _this3.loadTargetNodeByLoadedParent(id, parentId, success);
      } else {
        success(pathNode);
      }
    });
  },
  loadMoreBtnselectHandle: function loadMoreBtnselectHandle(node, loadedCallback) {
    var self = this;
    var page = node.data.curPage + 1;
    var pages = node.data.pages;
    var fileId = node.data.id;
    var parent = self.jsTree.get_node(node.parent);
    self._getSubfolders(fileId, page, function (fileInfoCollection, pages) {
      var newNodes = self._transfromCollectionToJSTreeNodes(fileInfoCollection, false, node.parent);
      var originNodes = _.map(parent.children, function (item) {
        return self.jsTree._model.data[item];
      });
      var loadMoreNode = originNodes.splice(Math.max(originNodes.length - 1, 0), 1);
      var loadMoreNodeData = loadMoreNode[0].data;
      var nodes = originNodes.concat(newNodes);
      var hasFetchAllData = false;
      if (loadMoreNodeData.curPage + 2 < pages) {
        nodes = nodes.concat(loadMoreNode);
      } else {
        hasFetchAllData = true;
      }
      self.jsTree._append_json_data(parent, nodes, function (status) {
        if (loadMoreNodeData.curPage + 1 < pages) {
          node.data = loadMoreNodeData;
          node.data.curPage++;
        }
        self.allfileCollection.add(fileInfoCollection.models);
        self.appendDisplayCollection(fileInfoCollection, hasFetchAllData);
        _.isFunction(loadedCallback) && loadedCallback(newNodes);
      });
    });
  },
  loadNextPageById: function loadNextPageById(parentId, callback) {
    var node = this.jsTree.get_node("".concat(parentId, "_load_more"));
    if (node) {
      this.loadMoreBtnselectHandle(node);
    } else {
      callback && callback();
    }
  },
  openFolder: function openFolder(parentId) {
    var self = this;
    var node = this.jsTree.get_node(parentId);
    var parent = null;
    var chiledNodeIds = node.children;
    var disFileCollection = _.filter(self.allfileCollection.models, function (file) {
      if (file.getFileId() == parentId) {
        parent = file;
      }
      if (file.get("parentFolderId") == parentId || _.indexOf(chiledNodeIds, file.getFileId()) > -1) {
        return true;
      } else {
        return false;
      }
    });
    self.setDisplayCollection(disFileCollection, parentId, parent);
  }
});
var _default = exports["default"] = MDAllFileTreePanelView;

},{"1184":1184,"1412":1412,"1415":1415,"1421":1421,"1426":1426,"1429":1429,"1432":1432,"1454":1454,"1463":1463,"22":22,"298":298}],545:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1423);
require(1463);
require(1480);
require(1487);
require(1538);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMViewBase3 = _interopRequireDefault(require(22));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MMFileInfoCollection = _interopRequireDefault(require(298));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
// import MDAllFileSelectFileItemView from './MDAllFileSelectFileItemView.js'
/**
 *  选择文件窗口
 *  Created by jichao
 *  2017.12.22
 */
var MDAllFileSelectTableView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MDAllFileSelectTableView, _MMViewBase);
  function MDAllFileSelectTableView() {
    (0, _classCallCheck2["default"])(this, MDAllFileSelectTableView);
    return _callSuper(this, MDAllFileSelectTableView, arguments);
  }
  (0, _createClass2["default"])(MDAllFileSelectTableView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n    <div class=\"header-block flex-align middle list-head\">\n\n      <div class=\"check-box no-shrink select-all\"></div>\n\n      <div class=\"name-block\">\n        <div class=\"text-hide f-tc\"><%=BabelStr.str(158)%></div>\n      </div>\n\n      <div class=\"size-block f-tc\"><%=BabelStr.str(27)%></div>\n    </div>\n    <div class=\"header-block flex-align middle grid-head \">\n\n      <div class=\"check-box no-shrink select-all\"></div>\n      <div><%=BabelStr.str(2611)%></div>\n\n    </div>\n    <div class=\"body-block\"></div>\n      ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAllFileSelectTableView.prototype), "className", this).call(this);
      return "".concat(superCls, " file-select-list");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAllFileSelectTableView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        fileInforCollection: new _MMFileInfoCollection["default"](),
        selectedIds: new Set(),
        multiple: false,
        download: false,
        canSelectLinkfile: false
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAllFileSelectTableView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .select-all": this._toggleSelectAll
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      props.title = BabelStr.str(3321); // "请选择文件进行内容比较或合并";
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAllFileSelectTableView.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "startLoading",
    value: function startLoading() {
      this.$(".body-block").html("");
      _MDSpinnerloaderView["default"].showIn(this.$el);
    }
  }, {
    key: "endLoading",
    value: function endLoading() {
      _MDSpinnerloaderView["default"].clearFrom(this.$el);
    }
  }, {
    key: "setDisplayCollection",
    value: function setDisplayCollection(fileInfoCollection, silent) {
      this.fileInforCollection.set(fileInfoCollection);
      this._renderFileLists();
      if (!fileInfoCollection.length && !silent) {
        var emptyMsg = BabelStr.str(330);
        if (this.isSearch) {
          emptyMsg = BabelStr.str(9509);
        }
        this.$(".body-block").html("\n        <div class=\"empty help-msg mgt-20 f-tc\" style=\"width: 100%\">".concat(emptyMsg, "</div>\n      "));
      }
    }
  }, {
    key: "appendDisplayCollection",
    value: function appendDisplayCollection(fileInforCollection) {
      this._appendFileLists(fileInforCollection);
    }
  }, {
    key: "_appendFileLists",
    value: function _appendFileLists(fileInforCollection) {
      var _this = this;
      fileInforCollection.each(function (fileInfor) {
        if (_this.intercept(fileInfor)) {
          return;
        }
        var fileItemView = new FileItemView({
          fileInfor: fileInfor,
          onOpenFile: function onOpenFile(fileInfor) {
            _this.openFile(fileInfor);
          },
          onCheckFile: function onCheckFile(fileInfor) {
            _this.checkFile(fileInfor);
          }
        });
        _this.addSubView(fileItemView, _this.$(".body-block"));
      });
    }
  }, {
    key: "_renderFileLists",
    value: function _renderFileLists() {
      var _this2 = this;
      this.removeSubViews();
      this.$(".body-block").empty();
      this.fileInforCollection.each(function (fileInfor) {
        if (_this2.intercept(fileInfor)) {
          return;
        }
        var fileItemView = new FileItemView({
          fileInfor: fileInfor,
          onOpenFile: function onOpenFile(fileInfor) {
            _this2.openFile(fileInfor);
          },
          onCheckFile: function onCheckFile(fileInfor) {
            _this2.checkFile(fileInfor);
          }
        });
        _this2.addSubView(fileItemView, _this2.$(".body-block"));
      });
    }
  }, {
    key: "isFileCanShow",
    value: function isFileCanShow(fileInfor) {
      if (this.download && !fileinfor.isFolder()) {
        return fileInfor.canDownload();
      }
      if (!fileInfor.canSelectLinkfile()) {
        return !fileInfor.isShortcuts();
      }
      return true;
    }
  }, {
    key: "openFile",
    value: function openFile(fileInfor) {
      if (fileInfor.isFolder()) {
        this.displayFilesByFolderId(fileInfor.getFileId());
      } else {
        this.checkOneFile(fileInfor);
      }
    }
  }, {
    key: "checkOneFile",
    value: function checkOneFile(fileInfor) {
      var _this3 = this;
      var fid = fileInfor.getFileId();
      if (!this.canSelectFolder) {
        if (!this.multiple || fileInfor.isFolder()) {
          this.selectedIds.clear();
          this.selectedIds.add(fid);
        } else {
          if (this.selectedIds.has(fid)) {
            this.selectedIds["delete"](fid);
          } else {
            this.selectedIds.add(fid);
          }
        }
      } else {
        if (!this.multiple) {
          this.selectedIds.clear();
          this.selectedIds.add(fid);
        } else {
          if (this.selectedIds.has(fid)) {
            this.selectedIds["delete"](fid);
          } else {
            this.selectedIds.add(fid);
          }
        }
      }
      var selectedFileInfors = [];
      _.each(this.subViews, function (view) {
        if (_this3.selectedIds.has(view.fileInfor.getFileId())) {
          if (!_this3.canSelectFolder) {
            if (!view.fileInfor.isFolder() || view.fileInfor.isFolder() && _this3.selectedIds.size == 1) {
              view.setSelect();
              selectedFileInfors.push(view.fileInfor);
            } else {
              view.setNoSelected();
            }
          } else {
            view.setSelect();
            selectedFileInfors.push(view.fileInfor);
          }
        } else {
          view.setNoSelected();
        }
      });
      this.renderSelectFile(selectedFileInfors);
      this.refreshSelectAll();
    }
  }, {
    key: "_toggleSelectAll",
    value: function _toggleSelectAll() {
      if (this.selectedIds.size != this.subViews.length) {
        this.selectAll();
      } else {
        this.clearSelectAll();
      }
    }
  }, {
    key: "selectAll",
    value: function selectAll() {
      var _this4 = this;
      var selectedFileInfors = [];
      _.each(this.subViews, function (view) {
        var fid = view.fileInfor.getFileId();
        _this4.selectedIds.add(fid);
        view.setSelect();
        selectedFileInfors.push(view.fileInfor);
      });
      this.renderSelectFile(selectedFileInfors);
      this.$(".select-all").addClass("selected");
    }
  }, {
    key: "clearSelectAll",
    value: function clearSelectAll() {
      var selectedFileInfors = [];
      this.selectedIds.clear();
      _.each(this.subViews, function (view) {
        view.setNoSelected();
      });
      this.renderSelectFile(selectedFileInfors);
      this.$(".select-all").removeClass("selected");
    }
  }, {
    key: "refreshSelectAll",
    value: function refreshSelectAll() {
      if (this.selectedIds.size != this.subViews.length) {
        this.$(".select-all").removeClass("selected");
      } else {
        this.$(".select-all").addClass("selected");
      }
    }
  }, {
    key: "checkFile",
    value: function checkFile(fileInfor) {
      this.checkOneFile(fileInfor);
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAllFileSelectTableView.prototype), "viewDidRendered", this).call(this);
      // this.$el.mCustomScrollbar({
      //   theme: "dark", // 可选主题（如 "minimal"、"dark"、"light" 等）
      //   scrollButtons: { // 可选：显示滚动按钮
      //     enable: true
      //   },
      //   advanced: {
      //     updateOnContentResize: true // 内容变化时自动更新滚动条
      //   }
      // });
    }
  }]);
  return MDAllFileSelectTableView;
}(_MMViewBase3["default"]);
var FileItemView = /*#__PURE__*/function (_MMViewBase2) {
  (0, _inherits2["default"])(FileItemView, _MMViewBase2);
  function FileItemView() {
    (0, _classCallCheck2["default"])(this, FileItemView);
    return _callSuper(this, FileItemView, arguments);
  }
  (0, _createClass2["default"])(FileItemView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n    <div class=\"check-box no-shrink\"></div>\n\n    <div class=\"name-block\">\n      <div class=\"cell-thunmb-wrap center middle flex-align\">\n        <div class=\"img \"></div>\n      </div>\n      <div class=\"name text-hide f-tc\"><%=name%></div>\n    </div>\n\n    <div class=\"size-block f-tc\"><%=size%></div>\n\n\n\n    ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(FileItemView.prototype), "className", this).call(this);
      return "".concat(superCls, " file-list-item");
    }
  }, {
    key: "render",
    value: function render(data) {
      var size = this.fileInfor.get("fileSize") || this.fileInfor.get("currentVersionSize");
      data = {
        name: this.fileInfor.getFileName(),
        size: this.fileInfor.isFolder() ? "--" : app.getFileSizeDescription(size)
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(FileItemView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(FileItemView.prototype), "initialize", this).call(this, opt);
      this.fileInfor.setIconForDiv(this.$(".img"), true, 60, undefined, undefined, {
        defaultSize: 60
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(FileItemView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "dblclick": this._openHandle,
        'click': this._checkedHandle
      });
    }
  }, {
    key: "setNoSelected",
    value: function setNoSelected() {
      this.$el.removeClass("selected");
    }
  }, {
    key: "setSelect",
    value: function setSelect() {
      this.$el.addClass("selected");
    }
  }, {
    key: "_openHandle",
    value: function _openHandle() {
      this.onOpenFile(this.fileInfor);
    }
  }, {
    key: "_checkedHandle",
    value: function _checkedHandle() {
      this.onCheckFile(this.fileInfor);
      // this.$el.addClass("selected");
    }
  }]);
  return FileItemView;
}(_MMViewBase3["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1423":1423,"1454":1454,"1463":1463,"1475":1475,"1480":1480,"1487":1487,"1538":1538,"22":22,"298":298,"76":76}],152:[function(require,module,exports){
module.exports = {"main":"<form class=\"broadcast-form container form-horizontal \">\r<div class=\"help-block row\">\r  <div class=\"col-10 col-offset-2\"><%=titleTipStr%></div>\r</div>\r  <div class=\"form-item  row bc-tg-block bc-block\">\r    <label class=\"col-2\"><%=accessStr%></label>\r    <div class=\"col-10 right enterprise-user-tab\">\r      <div class=\"bc-tg-input form-control\" placeholder=\"<%=accessInputStr%>\" name=\"bc-tg-choose-panel\" readonly=\"\"></div>\r    </div>\r  </div>\r  <div class=\"form-item row bc-block\">\r    <label class=\"col-2\"><%=titleStr%></label>\r    <div class=\"col-10\">\r      <input type=\"text\" id=\"bc-title\" class=\"form-control textinput\" maxlength=\"100\" required placeholder=\"<%=inputStr%>\" value=\"<%=entBCTitle%>\">\r    </div>\r  </div>\r  <div class=\"form-item  row content-block bc-block\">\r    <label class=\"col-2\"><%=innerStr%></label>\r    <div class=\"col-10\">\r      <textarea class=\"content form-control textinput\" name=\"\" id=\"\" cols=\"30\" rows=\"10\" required placeholder=\"<%=textareaStr%>\"><%=entBCText%></textarea>\r    </div>\r  </div>\r<!--   <div class=\"form-item  row \">\r    <label class=\"col-2 no-pdt\"><%=BabelStr.str(3710)%></label>\r    <div class=\"col-10 right\">\r      <div class=\"file-list\"></div>\r      <%if(createBC){%>\r        <button class=\"text-button done upload-file\" type=\"button\"><%=BabelStr.str(5004)%></button>\r      <%}%>\r    </div>\r  </div> -->\r  <div class=\"btns-block flex-align end\">\r    <button class=\"button done publish\" type=\"button\"><%=btnText%></button>\r  </div>\r</form>"};
},{}],141:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MEDepartMemberDownLimitView = _interopRequireDefault(require(140));
var _MDWindowView2 = _interopRequireDefault(require(93));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MEDepartMemberDownLimitWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MEDepartMemberDownLimitWinView, _MDWindowView);
  function MEDepartMemberDownLimitWinView() {
    (0, _classCallCheck2["default"])(this, MEDepartMemberDownLimitWinView);
    return _callSuper(this, MEDepartMemberDownLimitWinView, arguments);
  }
  (0, _createClass2["default"])(MEDepartMemberDownLimitWinView, [{
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEDepartMemberDownLimitWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {});
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      props.size = 'large';
      props.title = BabelStr.str(4844);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEDepartMemberDownLimitWinView.prototype), "initialize", this).call(this, props);
      var view = new _MEDepartMemberDownLimitView["default"]();
      this.addSubView(view);
      this.$('.dep-member-down-limit').addClass('flex-align with-wrap center pdb-20');
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEDepartMemberDownLimitWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " dep-member-down-limit-win");
    }
  }]);
  return MEDepartMemberDownLimitWinView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"140":140,"1454":1454,"1463":1463,"1475":1475,"93":93}],679:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDTabPanelView = _interopRequireDefault(require(81));
var _MDParticipantsByInviteListView = _interopRequireDefault(require(682));
var _MDInvite2shareView = _interopRequireDefault(require(678));
/**
 * 邀请分享的 tab 页
 * jiang
 * 2019-3-13
 */

var MDInviteShareTabPanelView = _MDTabPanelView["default"].extend({
  tmpl: "<div class=\"help-block\">\n    <%=BabelStr.str(7280)%>\n    </div>\n\n    <div class=\"action-zone\"></div>\n    <div class=\"userlist\"></div>\n    ",
  initialize: function initialize(opt) {
    _MDTabPanelView["default"].prototype.initialize.call(this, opt);
    this.$('.tab-panel-wrapper').addClass('block');
  },
  onActived: function onActived() {
    var _this = this;
    if (!this.userListPanel) {
      this.userListPanel = new _MDParticipantsByInviteListView["default"]({
        fileInfor: this.fileInfor,
        roles: this.roles,
        canManageShare: this.canManageShare,
        showFileLog: this.showFileLog,
        loadFinished: this.loadFinished,
        changeFileInfor: this.changeFileInfor
      });
      this.addSubView(this.userListPanel, this.$('.userlist'));
    }
    if (!this.inviteSettingVew) {
      this.inviteSettingVew = new _MDInvite2shareView["default"]({
        fileInfor: this.fileInfor,
        roles: this.roles,
        canManageShare: this.canManageShare,
        defaultRole: this.defaultRole,
        changeFileInfor: this.changeFileInfor,
        changeToInvPanel: this.changeToInvPanel,
        close: this.close,
        loadFinished: this.loadFinished,
        showRolesInfo: this.showRolesInfo,
        onUsersChaned: function onUsersChaned() {
          _this.userListPanel.refreshUsers();
        }
      });
      this.addSubView(this.inviteSettingVew, this.$('.action-zone'));
    }
  }
});
var _default = exports["default"] = MDInviteShareTabPanelView;

},{"1184":1184,"1454":1454,"678":678,"682":682,"81":81}],682:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1439);
require(1437);
require(1478);
require(1421);
var _FILE_ROLE_ID = _interopRequireDefault(require(236));
var _MMViewBase = _interopRequireDefault(require(22));
var _MDShareByLinkUserListItemView = _interopRequireDefault(require(687));
var _MDShareByInvUserListItemView = _interopRequireDefault(require(686));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _regexp = _interopRequireDefault(require(106));
/**
 *  Window for share file
 *  Created by jichao
 *  2016.9.28
 */

/**
 * 管理参与者Panel
 */
var MDParticipantsByInviteListView = _MMViewBase["default"].extend({
  tmpl: '<div class="header">\
      <span class="name"><%=BabelStr.str(7282)%></span>\
      <span>(<span id="invUserNumber"></span>)</span>\
    </div> \
    <div id="m-manage-panel"> \
      <div class="bd"> \
        <div class="userlist"> \
            <div class="m-share-inv-userlist f-clb"> \
              <ul class="share-ulist"></ul> \
              <ul class="share-list-no-per"></ul> \
            </div> \
        </div> \
        </div> \
      </div> \
    </div>',
  events: function events() {
    return {
      'click .link-manage .hd-1': this._toggleManagePanelItem,
      'click .invite-manage .hd': this._toggleInvManagePanelItem,
      'click .link-manage .hd-0 .right': this._changeToLinkPanelWithState,
      'click #returnLinkPanel': this._changeToLinkPanel,
      'click #closeInvShare': this._closeInvShareClick,
      'click #closeShareLink': this._closeLinkShareClick,
      'click #requestInvShare': this._changeToLinkPanel,
      'keyup .select': this._renderInvUser
    };
  },
  initProps: function initProps() {
    var opt = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(opt, {
      roleArr: [],
      canManageShare: false,
      askLinkShareState: false,
      changeToLinkPanel: _.noop,
      close: _.noop,
      loadFinished: _.noop,
      changeFileInfor: _.noop,
      data: {
        anonymous: BabelStr.str(722),
        // 匿名用户
        registered: BabelStr.str(723),
        // 注册用户
        goBack: BabelStr.str(74) // 返回
      }
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.bindSelf(this._removeInvUser, this._closeInvShare, this._closeLinkShare);
    for (var i = 0; i < this.roles.length; i++) {
      var role = this.roles[i];
      var str = {
        label: role.get("description"),
        canSelected: true,
        linkRoleId: role.getRoleId(),
        systemdefault: role.get('systemdefault')
      };
      self.roleArr.push(str);
    }
    this.$invitedList = this.$('#invitedList');
    this.shareUserInvCollection = new _MDMolaUserCollection["default"]();
    this.listenTo(this.shareUserInvCollection, 'remove', this._removeInvCollectionItemHandler);
    this.$invList = this.$('.share-ulist');
    this._requestInvUser();
    if (this.canManageShare) {
      this.initInvManageHd();
      var foundInvite = BabelStr.str(98); // 查找受邀用户
      this.$(".invite-manage .bd").prepend('<div class="select flex-align middle br-2"><i class="icon search"></i><input placeholder="' + foundInvite + '"></input></div>');
    }
  },
  className: function className() {
    var superCls = _MMViewBase["default"].prototype.className.call(this);
    return superCls + " share-manage";
  },
  _removeInvCollectionItemHandler: function _removeInvCollectionItemHandler(model, collection, options) {
    var index = -1;
    for (var i = 0; i < this.subViews.length; i++) {
      if (this.subViews[i].user.getId() == model.getId()) {
        index = i;
        break;
      }
    }
    if (this.shareUserInvCollection.length == 1 && this.shareUserInvCollection.models[0].getUserId() == this.fileInfor.getOwnerId() || this.shareUserInvCollection.length == 0) {
      self.$("#closeInvShare").hide();
      if (this.fileInfor.get("newShareAll") != 1) {
        this.fileInfor.changeShareState(false);
        Dispatcher.trigger(MDEvents.ShareStatusChanged, this.fileInfor, true);
        Dispatcher.trigger(MDEvents.ShareChanged);
      }
    }
    this.removeSubViewAt(index);
    this.$("#invUserNumber").text(this.shareUserInvCollection.length);
  },
  _toggleManagePanelItem: function _toggleManagePanelItem() {
    if (this.$(".link-manage .bd").hasClass("f-hide")) {
      this.linkPanelItemShow();
    } else {
      this.linkPanelItemHide();
    }
  },
  linkPanelItemShow: function linkPanelItemShow() {
    this.$(".link-manage .bd").removeClass("f-hide").hide().slideDown();
  },
  linkPanelItemHide: function linkPanelItemHide() {
    var self = this;
    this.$(".link-manage .bd").slideUp(function () {
      self.$(".link-manage .bd").addClass("f-hide");
    });
  },
  _toggleInvManagePanelItem: function _toggleInvManagePanelItem() {
    if (this.$(".invite-manage .bd").hasClass("f-hide")) {
      this.invPanelItemShow();
    } else {
      this.invPanelItemHide();
    }
  },
  invPanelItemShow: function invPanelItemShow() {
    this.$(".invite-manage .bd").removeClass("f-hide").hide().slideDown();
  },
  invPanelItemHide: function invPanelItemHide() {
    var self = this;
    this.$(".invite-manage .bd").slideUp(function () {
      self.$(".invite-manage .bd").addClass("f-hide");
    });
  },
  _changeToLinkPanel: function _changeToLinkPanel() {
    this.changeToLinkPanel(false);
  },
  _changeToLinkPanelWithState: function _changeToLinkPanelWithState() {
    this.changeToLinkPanel(true);
  },
  _closeInvShareClick: function _closeInvShareClick(e) {
    e.stopPropagation();
    var self = this;
    var alert = new _MDAlertView["default"]({
      // className: 'm-close-share-win'
    });
    var fileName = this.fileInfor.getFileName();
    // alert.show({
    //   title: '关闭“' + fileName + '的邀请分享”',
    //   message: '<div class="content">关闭邀请分享后，受邀用户将全部移除。<br>文件本身及其子目录内容也将从受邀用户账号移除</div>',
    //   className: 'm-delAlertWin',
    //   buttons: [{
    //     label: '关闭邀请分享',
    //     type: 'done',
    //     onClick: self._closeInvShare
    //   }, {
    //     label: '取消'
    //   }]
    // });

    var opt = {
      title: BabelStr.str(715, {
        'file': fileName
      }),
      // 关闭"{-file-}的邀请分享
      message: '<div class="content">' + BabelStr.str(718) + '</div>',
      okFun: function okFun() {
        self._closeInvShare();
      }
    };
    _MDAlertView["default"].showStandardSelection(opt);
  },
  _closeInvShare: function _closeInvShare() {
    var self = this;
    _MMNetDiskDataController["default"].closeInvShare(this.fileInfor.getFileId(), function () {
      _MDSnackbarView["default"].show(BabelStr.str(308)); //('关闭邀请分享成功');
      self.$("#closeInvShare").hide();
      var curEmail = app.currentUser.get("email");
      for (var i = 0; i < self.shareUserInvCollection.length; i++) {
        var user = self.shareUserInvCollection.models[i];
        if (user.get("email") != curEmail) {
          self.shareUserInvCollection.remove(user);
          i--;
        }
      }
      if (self.shareUserInvCollection.length == 1 && self.fileInfor.belongsToTeam()) {
        var manager = self.shareUserInvCollection.models[0];
        self.shareUserInvCollection.remove(manager);
      }
    }, function () {
      _MDSnackbarView["default"].show(BabelStr.str(309)); //('关闭邀请分享失败，请重试');
    });
  },
  initInvManageHd: function initInvManageHd() {
    var invite = BabelStr.str(97); // 邀请共享用户
    var close = BabelStr.str(721); // 关闭邀请分享
    this.$div = $('<div class="right f-fr" id="closeInvShare"><button class="mark text-button done">' + close + '</button></div>' + ''), this.$el.find('.header').append(this.$div);
  },
  refreshUsers: function refreshUsers() {
    this._requestInvUser();
  },
  _requestInvUser: function _requestInvUser() {
    var self = this;
    _MMNetDiskDataController["default"].getInvitationList(this.fileInfor.getFileId(), function (userCollect) {
      var contactArr = [];
      if (self.fileInfor.belongsToTeam()) {
        if (userCollect.length == 1) {
          if (userCollect.models[0].get("roleId") == _FILE_ROLE_ID["default"].ROOT_ROLE) {
            userCollect.shift();
          }
        }
      }
      userCollect.each(function (user) {
        var email = user.getOriginalEmail();
        var contact = {
          'avatarImageURL': app.getAvatarImageURL(user.get("participantId")),
          // "avatartype": user.get("avatarType"),
          "email": email,
          "userId": user.get("participantId"),
          "name": user.get("participantName"),
          "participantType": user.get('participantType'),
          // "sharerId": self.fileInfor.getSharerId(),
          "roleId": user.get("roleId"),
          "roleName": user.get("roleName"),
          "id": user.get("babelshareId"),
          "babelshareId": user.get("babelshareId"),
          "guest": user.get("guest"),
          "registered": user.get('registered'),
          "belongToEnterprise": user.get('belongToEnterprise'),
          "endtime": user.get('endtime'),
          needReview: user.get('needReview'),
          reviewResult: user.get('reviewResult')
        };
        if (contact["name"] == '-1') {
          var name = _regexp["default"].isEmail(user.getOriginalEmail()) ? user.getOriginalEmail() : user.getPhone();
          contact["name"] = name;
          contact['avatarImageURL'] = 'img/avatar/anonymous.jpg';
        }
        if (contact.userId == self.fileInfor.getOwnerId() || contact.roleId == _FILE_ROLE_ID["default"].ROOT_ROLE) {
          contactArr.unshift(contact);
        } else {
          contactArr.push(contact);
        }
      });
      if (contactArr.length == 1 && contactArr[0].userId == self.fileInfor.getOwnerId() || contactArr.length == 0) {
        self.$("#closeInvShare").hide();
      }
      self.loadFinished();
      self.shareUserInvCollection.add(contactArr);
      self._renderUserInvListItem();
      self.$("#invUserNumber").text(self.shareUserInvCollection.length);
    }, function (error, msg) {
      var message = msg || BabelStr.str(309);
      _MDSnackbarView["default"].show(message); // ('获取邀请人失败');
    });
  },
  _renderUserInvListItem: function _renderUserInvListItem() {
    var self = this;
    if (!this.canManageShare) {
      this.$invList.addClass("flex-align with-wrap");
    }

    // self.$invList.empty();
    this.removeSubViews();
    this.shareUserInvCollection.each(function (user, index) {
      var shareUserInvListItemView = new _MDShareByInvUserListItemView["default"]({
        showFileLog: self.showFileLog,
        fileInfor: self.fileInfor,
        user: user,
        roleArr: self.roleArr,
        roles: self.roles,
        removeInvuser: self._removeInvUser,
        canManageShare: self.canManageShare
      });
      self.addSubView(shareUserInvListItemView, self.$invList[0]);
    });
  },
  // showFileLog: function(user) {
  //   this.showFileLog(user);
  // },

  _removeInvUser: function _removeInvUser(babelshareId) {
    var self = this;
    _MMNetDiskDataController["default"].removeInvitations(this.fileInfor.getFileId(), babelshareId, function () {
      var user = self.shareUserInvCollection.findWhere({
        "babelshareId": babelshareId[0]
      });
      self.shareUserInvCollection.remove(user);
      if (self.shareUserInvCollection.length == 1 && self.fileInfor.belongsToTeam()) {
        var manager = self.shareUserInvCollection.models[0];
        self.shareUserInvCollection.remove(manager);
      }
      _MDSnackbarView["default"].show(BabelStr.str(308)); //('删除成功');
    }, function () {
      _MDSnackbarView["default"].show(BabelStr.str(309)); //('删除失败');
    });
  },
  _renderInvUser: function _renderInvUser() {
    var userList = this.$(".inv-userLIst-item");
    var content = this.$(".select input").val().toString();
    for (var i = 0; i < userList.length; i++) {
      var name = userList.eq(i).find(".name").html();
      var email = userList.eq(i).find(".mail").html();
      if (name.indexOf(content) == -1 && email.indexOf(content) == -1) {
        userList.eq(i).addClass("f-hide");
      } else {
        userList.eq(i).removeClass("f-hide");
      }
    }
  }
});
var _default = exports["default"] = MDParticipantsByInviteListView;

},{"106":106,"1104":1104,"1184":1184,"1417":1417,"1421":1421,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1478":1478,"22":22,"236":236,"273":273,"32":32,"686":686,"687":687,"72":72}],687:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
var _MMViewBase = _interopRequireDefault(require(22));
/**
 *  share windown : userListItem,joined by link
 *   Created by jichao
 *  2016.9.27
 */

var MDShareByLinkUserListItemView = _MMViewBase["default"].extend({
  el: '<li></li>',
  className: function className() {
    var superCls = _MMViewBase["default"].prototype.className.call(this);
    var cls = this.canManageShare ? "userlist-item" : "no-per-userlist-item";
    return "".concat(superCls, " flex-align middle ").concat(cls);
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      /**
       * @type {MDMolaUser}
       */
      user: null,
      fileInfor: null,
      canManageShare: false
    });
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click .u-file-log': this._showUserfileLog
    });
  },
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    var imgUrl = this.user.get("avatarImageURL");
    var name = this.user.get("name");
    var email = this.user.getEmail();
    var itemTmpl = "<img class=\"avatar s40 u-avatar\" src=\"".concat(imgUrl, "\" alt=\"\">\n            <div class=\"text-hide u-info\">\n              <div class=\"text-hide name\">").concat(name, "</div>\n              <%if(showEmail){%>\n                  <div class=\"text-hide email\">").concat(email, "</div>\n              <%}%>\n            </div>\n            <%if(canReadFileLog){%>\n              <div class=\"u-file-log icon\"></div>\n            <%}%>");
    itemTmpl = _.template(itemTmpl)({
      showEmail: this.canManageShare,
      canReadFileLog: this.fileInfor.canReadFileLog()
    });
    this.$el.html(itemTmpl);
  },
  _showUserfileLog: function _showUserfileLog() {
    this.showFileLog(this.user);
  }
});
var _default = exports["default"] = MDShareByLinkUserListItemView;

},{"1184":1184,"1412":1412,"1454":1454,"22":22}],686:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1421);
require(1437);
var _regexp = _interopRequireDefault(require(106));
var _FILE_ROLE_ID = _interopRequireDefault(require(236));
var _MMViewBase = _interopRequireDefault(require(22));
var _MDDropDownSelectRoleView = _interopRequireDefault(require(50));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDFilesUploadedByUserPopupWin = _interopRequireDefault(require(711));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDOneGroupPopupView = _interopRequireDefault(require(753));
var _popupPos = _interopRequireDefault(require(65));
/**
 *  share windown : userListItem,joined by invited
 *  javascript/moladisk/views/file/share/MDShareByInvUserListItemView.js
 *  Created by jichao
 *  2016.9.27
 */

var MDShareByInvUserListItemView = _MMViewBase["default"].extend({
  el: '<li></li>',
  className: function className() {
    var cls = _MMViewBase["default"].prototype.className.call(this);
    cls += ' flex-align middle';
    if (!this.canManageShare) {
      cls += ' with-inline';
    }
    return cls;
  },
  tmpl: function tmpl() {
    if (this.canManageShare) {
      return this.avatarTpl + this.editTpl;
    } else {
      return this.avatarTpl + this.readTpl;
    }
  },
  avatarTpl: "\n            <div class=\"u-avatar no-shrink\">\n              <%if(type == 2){%>\n                  <div class=\"icon group-icon f-pointer\" data-tooltip=\"<%=BabelStr.str(2578)%>\"></div>\n              <%} else if(type ==1){%>\n                <div class=\"file-icon dep-icon\"></div>\n              <%} else {%>\n                <img class=\"avatar s40\" src=\"<%=img%>\" alt=\"\">\n              <%}%>\n            </div>\n            ",
  readTpl: "\n      <div class=\"u-info\">\n        <div class=\"username\">\n          <span class=\"name\"><%=username%></span>\n          <%if(isOwner){%>\n            <span class=\"help-inline\">(<%=BabelStr.str(396)%>)</span>\n          <%}%>\n        </div>\n      </div>",
  editTpl: "\n      <div class=\"u-info\">\n        <div class=\"flex-align middle\">\n          <%if(enterpriceUser){%>\n            <%if(!registered){%>\n              <span class=\"guest\"><%=BabelStr.str(7039)%></span>\n            <%} else if(guest){%>\n              <span class=\"guest\"><%=BabelStr.str(7286)%></span>\n            <%}%>\n          <%} else{%>\n              <%if(!registered){%>\n                <span class=\"guest\"><%=BabelStr.str(7039)%></span>\n              <%}%>\n            <%}%>\n          <span class=\"name\"><%=username%></span>\n        </div>\n        <div class=\"mail text-hide\"><%=email%></div>\n      </div>\n      <%if(isShareManager){%>\n        <%if(canReadFileLog && type==0){%>\n          <div class = 'u-file-log icon no-shrink' data-tooltip=\"<%=BabelStr.str(7287)%>\" data-tooltip-dir=\"top\"></div>\n        <%}%>\n        <div class=\"u-owner\"><%=roleName%><div>\n      <%}else{%>\n          <%if(!needReview || reviewResult == 1) {%>\n            <%if(canReadFileLog  && type==0){%>\n              <div class='u-file-log icon no-shrink' data-tooltip=\"<%=BabelStr.str(7287)%>\" data-tooltip-dir=\"top\"></div>\n            <%}%>\n            <div class=\"u-per no-shrink\">\n              <div class=\"per-slot\"></div>\n            </div>\n            <div class=\"u-deadline end-time\">\n              <span><%=BabelStr.str(176)%></span>\n              <div class=\"datepicker-slot\">\n                <input class=\"endtime-datepicker blue\" data-tooltip=\"<%=BabelStr.str(2694)%>\" readonly></input>\n                <div class=\"endtime-slot blue\"><%=BabelStr.str(177)%></div>\n                <div class=\"remove-time icon\" data-tooltip=\"<%=BabelStr.str(2695)%>\"></div>\n              </div>\n            </div>\n          <%} else {%>\n            <div class=\"pdlr-20 mglr-20\"><%=(reviewResult == 0 ? BabelStr.str(5462) : BabelStr.str(5463))%></div>\n          <%}%>\n\n          <div class=\"u-opera f-tc no-shrink removeUser\">\n            <button class=\"icon\" data-tooltip=\"<%=BabelStr.str(7288)%>\" data-tooltip-dir=\"top\"></button>\n          </div>\n      <%}%>",
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      user: null,
      fileInfor: null,
      canManageShare: false,
      enterpriceUser: app.isEpVersion(),
      showFileLog: _.noop
    });
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click .removeUser': this._removeThisUser,
      'click .u-file-log': this._showUserfileLog,
      'click .u-file-log-owner': this._showUserfileLog,
      'click .show-upload': this._showUploadedFiles,
      'click .remove-time': this._removeEndTime,
      "click .group-icon": this.showGroupPopup
    });
  },
  showGroupPopup: function showGroupPopup($e) {
    var $btn = this.$el.find(".group-icon");
    if ($btn.hasClass("with-popup")) {
      var view = $btn.data("popupView");
      view.close();
      return;
    }
    var id = this.user.getUserId();
    _MDOneGroupPopupView["default"].show({
      groupName: this.user.getUserName(),
      triggerView: $btn,
      direction: _popupPos["default"].TOP_LEFT,
      groupId: id
      // $container: this.getNavigationView().$el
    });
  },
  _showUploadedFiles: function _showUploadedFiles() {
    var folderId = this.fileInfor.getFileId();
    var userId = this.user.getUserId();
    _MDFilesUploadedByUserPopupWin["default"].show({
      userId: userId,
      folderId: folderId,
      userName: this.user.getUserName(),
      userType: this.user.get("participantType")
    });
  },
  render: function render() {
    var name = this.user.getUserName();
    if (!name) {
      name = _regexp["default"].isEmail(this.user.getOriginalEmail()) ? this.user.getOriginalEmail() : this.user.getPhone() || this.user.getEmail();
    }
    var data = {
      'username': this.user.getUserName(),
      'email': this.user.getEmail(),
      'img': this.user.getAvatarImageURL(),
      'canManageShare': this.canManageShare,
      'roleName': this.fileInfor.belongsToTeam() ? BabelStr.str(1053) : BabelStr.str(68),
      'enterpriceUser': this.enterpriceUser,
      'guest': this.user.get("guest"),
      'canReadFileLog': this.fileInfor.canReadFileLog(),
      'isShareManager': this.user.getRoleId() == _FILE_ROLE_ID["default"].ROOT_ROLE,
      'registered': this.user.isActivedUser(),
      'isOwner': this.user.get("userId") == this.fileInfor.getOwnerId() ? true : false,
      'type': this.user.get("participantType"),
      'belongToEnterprise': this.user.get("belongToEnterprise"),
      'endtime': this.user.get('endtime'),
      needReview: this.user.get('needReview'),
      reviewResult: this.user.get('reviewResult')
    };
    _MMViewBase["default"].prototype.render.call(this, data);
  },
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.bindSelf(this._fileSetRole);
    var self = this;
    var roleId = this.user.getRoleId();
    var img = this.user.getAvatarImageURL();
    if (this.canManageShare) {
      if (this.user.getRoleId() == _FILE_ROLE_ID["default"].ROOT_ROLE) {
        this.$el.addClass('with-share-admin');
      }
      if (this.fileInfor.isFolder()) {
        var str = BabelStr.str(2050);
        this.$('.name').addClass('show-upload cursor-p');
        this.$('.name').attr('data-tooltip', str);
      }
      this.$el.addClass("inv-userLIst-item");
      if (this.user.get("roleId") != _FILE_ROLE_ID["default"].ROOT_ROLE) {
        var roleIds = [];
        for (var i = 0; i < this.roleArr.length; i++) {
          roleIds.push(this.roleArr[i].linkRoleId);
        }
        var index = _.indexOf(roleIds, this.user.get("roleId"));
        if (index > -1) {
          this.userPermission = new _MDDropDownSelectRoleView["default"]({
            index: index,
            bd: self.roleArr,
            roles: self.roles,
            invite: true,
            onChange: self._fileSetRole,
            className: 'with-no-border',
            minW: '162px'
          });
          this.addSubView(this.userPermission, this.$(".per-slot")[0], true);
        } else {
          str = "<div class = 'f-tr pdr-20'>" + this.user.get("roleName") + "</div>";
          this.$(".u-per").html(str);
        }
      }
      var $expireTimeBox = this.$('.endtime-datepicker');
      this.$('.endtime-datepicker').datepicker({
        'minDate': 1
      }).on("change", function () {
        var exDate = $expireTimeBox.datepicker("getDate");
        _MMNetDiskDataController["default"].setParticipantExpireTime(self.fileInfor.getFileId(), self.user.get("babelshareId"), exDate.getTime() / 1000, function () {
          self.user.set('endtime', exDate.getTime() / 1000);
          self._dispEndTime();
        }, function () {
          _MDSnackbarView["default"].show(BabelStr.str(168));
        });
      });
    } else {
      var isOwner = this.user.get("userId") == self.fileInfor.getOwnerId() ? true : false;
      this.$el.addClass("no-per-inv-userlist-item");
    }
    this._dispEndTime();
  },
  _dispEndTime: function _dispEndTime() {
    var endtime = this.user.get('endtime') * 1000;
    if (!endtime) {
      this.$el.find('.endtime-slot').text(BabelStr.str(177));
      this.$el.find('.remove-time').hide();
    } else {
      var expireTime = new Date(endtime);
      var $expireTimeBox = self.$('.datepicker');
      $expireTimeBox.datepicker('setDate', expireTime);
      var day = expireTime.getDate();
      var monthIndex = expireTime.getMonth() + 1;
      var year = expireTime.getFullYear();
      var dateStr = year + '-' + monthIndex + '-' + day;
      this.$el.find('.endtime-slot').text(dateStr);
      this.$el.find('.remove-time').show();
    }
  },
  _removeThisUser: function _removeThisUser() {
    var babelshareIds = [];
    babelshareIds[0] = this.user.get("babelshareId");
    this.removeInvuser(babelshareIds);
  },
  _fileSetRole: function _fileSetRole(item) {
    var self = this;
    _MMNetDiskDataController["default"].setRole(this.fileInfor.getFileId(), this.user.get("babelshareId"), item.linkRoleId, function () {
      console.log("改变用户权限成功");
    }, function () {
      console.log("改变用户权限失败");
    });
  },
  _showUserfileLog: function _showUserfileLog() {
    this.showFileLog(this.user);
  },
  _removeEndTime: function _removeEndTime() {
    var self = this;
    _MMNetDiskDataController["default"].setParticipantExpireTime(this.fileInfor.getFileId(), this.user.get("babelshareId"), 0, function () {
      self.user.set('endtime', null);
      self._dispEndTime();
    }, function () {
      _MDSnackbarView["default"].show(BabelStr.str(168));
    });
  }
});
var _default = exports["default"] = MDShareByInvUserListItemView;

},{"106":106,"1104":1104,"1184":1184,"1417":1417,"1421":1421,"1437":1437,"1454":1454,"1463":1463,"22":22,"236":236,"50":50,"65":65,"711":711,"72":72,"753":753}],678:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1429);
require(1439);
var _FILE_ROLE_ID = _interopRequireDefault(require(236));
var _MMViewBase = _interopRequireDefault(require(22));
var _MDShareFileOperateManageUserView = _interopRequireDefault(require(690));
var _MDShareFileInvMaileInfoView = _interopRequireDefault(require(688));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _regexp = _interopRequireDefault(require(106));
/**
 *  Window for share file
 *  Created by jiang
 *  2019.3.13
 */

var MDInvite2shareView = _MMViewBase["default"].extend({
  tmpl: '<div>\
          <div id="funTab">\
              <div>\
                  <div>\
                      <header class="block-hd f-clb"><span class="f-emph"><%=inviteTarget%></span>\
                      <div class="help-block flex-align file-address">\
                        <span class="form-line"><%=BabelStr.str(7279)%></span>\
                        <span class="col-auto flex-align"><input class="form-control file-link" readonly /></span>\
                      </div>\
                      <div id="inv-per-user" class="help-block"></div>\
                      <div id="no-inv-per-help"></div>\
                      <div class="inv-manager-block gap-10 mgt-10 f-hide flex-align middle with-wrap">\
                        <div class="manager-title"><%=BabelStr.str(21215)%></div>\
                        <div class="inv-manager-list gap-10"></div>\
                      </div>\
                      </header>\
                      <div class="block-bd">\
                      </div>\
                  </div>\
              </div>\
          </div>\
      </div>',
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      askLinkShareState: false,
      hasInvPermission: true,
      hasLinkPermission: true,
      canManageShare: false,
      roles: [],
      changeFileInfor: _.noop,
      changeToInvPanel: _.noop,
      onUsersChaned: _.noop,
      close: _.noop,
      loadFinished: _.noop
    });
  },
  events: function events() {
    return {
      'mouseenter .manage-a': this._showManagePoint,
      'mouseleave .manage-a': this._hideManagePoint,
      'click #sendInvBtn': this._sendInvitation
    };
  },
  initialize: function initialize(opt) {
    var self = this;
    opt = _.extend({}, opt);
    opt.data = _.extend({
      'owner': BabelStr.str(396),
      // 所有者
      'inviteTarget': BabelStr.str(83),
      // 邀请共享人
      'mgrParticipant': BabelStr.str(90),
      // 管理参与者
      'tip': BabelStr.str(92) // 打开分享链接和邀请分享后，可以分别控制和管理每个受邀共享者的访问权限
    }, opt.data);
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.bindSelf(this.renderUserInfo, this.ownerInit);
    this.$funTab = this.$('#funTab');
    if (this.canManageShare) {
      this.ownerInit();
    } else {
      this.IsJoinedByLink();
    }
    if (this.fileInfor.get("ownerId") == app.currentUser.get("id") || this.fileInfor.belongsToTeam()) {
      this.$(".caption").hide();
    } else {
      var ownerInfo = this.fileInfor.get("ownerName");
      var fileEntId = this.fileInfor.getEnterpriseId();
      if (fileEntId != 0) {
        if (fileEntId == app.ep.getEpID()) {
          ownerInfo += "(".concat(BabelStr.str(397), ")"); //'(本公司)';
        } else {
          ownerInfo += '(' + BabelStr.str(398) + ')'; //'(外部公司)';
        }
      } else {
        ownerInfo += "(".concat(BabelStr.str(399), ")"); //'(个人)';
      }
      this.$(".caption").html(BabelStr.str(396) + "：  " + ownerInfo); // 所有者: xxx
    }
    self.$(".file-address").hide();
  },
  IsJoinedByLink: function IsJoinedByLink() {
    var _this = this;
    var self = this;

    // MMNetDiskDataController.isLinkParticipant(this.fileInfor.getFileId(), function(flag) {

    //   if (!flag) {
    //     console.log("该用户是通过邀请分享加入的");

    if (!self.canManageShare) {
      var tip = BabelStr.str(401); // 你没有邀请用户加入分享的权限，但你可以发送一个请求给内容所有者，请求他邀请
      self.$("#no-inv-per-help").html('<div class="help-inline red">' + tip + '</div>');
      self.renderInvManager();
    } else {}
    // if (self.fileInfor.get('newShareAll')==1 || self.fileInfor.get('inOtherPersonSharingFolder')){
    self.shareInvMailInfo = new _MDShareFileInvMaileInfoView["default"]({
      roles: self.roles,
      fileInfor: self.fileInfor,
      canManageShare: self.canManageShare,
      close: self.close,
      showRolesInfo: self.showRolesInfo,
      renderUserInfo: self.renderUserInfo,
      defaultRole: self.defaultRole,
      mesContainer: self.$el,
      inviteOutUser: function inviteOutUser(invited) {
        if (invited && !self.canManageShare) {
          _this.$(".inv-manager-block").addClass("f-hide");
        } else {
          _this.$(".inv-manager-block").removeClass("f-hide");
        }
      }
    });
    self.addSubView(self.shareInvMailInfo, self.$("#funTab .block-bd")[0]);
    self.loadFinished();
    //   }
    // }, function() {

    // });
  },
  renderInvManager: function renderInvManager() {
    var managerInfos = this.fileInfor.get("managerInfos");
    if (!managerInfos || !managerInfos.length) {
      return;
    }
    managerInfos = managerInfos.slice(0, 5);
    var tmpl = '';
    _.each(managerInfos, function (user) {
      tmpl += "\n        <div class=\"manager-item flex-align middle\">\n          <div class=\"manager-icon icon no-shrink\"></div>\n          <span class=\"name middle-ellipsis\">".concat(user.name || user.phone, "</span>\n        </div>\n      ");
    });
    this.$(".inv-manager-list").html(tmpl);
    this.$(".inv-manager-block").removeClass("f-hide");
  },
  ownerInit: function ownerInit() {
    // this.loadFinished();

    this.shareInvMailInfo = new _MDShareFileInvMaileInfoView["default"]({
      roles: this.roles,
      fileInfor: this.fileInfor,
      canManageShare: this.canManageShare,
      close: this.close,
      showRolesInfo: this.showRolesInfo,
      renderUserInfo: this.renderUserInfo,
      defaultRole: this.defaultRole,
      mesContainer: self.$el
    });
    this.addSubView(this.shareInvMailInfo, this.$("#funTab .block-bd")[0]);
  },
  _showManagePoint: function _showManagePoint($e) {
    var self = this;
    var $qpopup = this.$(".point-po");
    if ($qpopup.hasClass("opened")) {
      return;
    }
    $qpopup.show();
    $qpopup[0].offsetWidth;
    $qpopup.addClass("opened");
    return false;
  },
  renderUserInfo: function renderUserInfo() {
    console.log('---------------- to refresh invited userlist!!!');
    this.onUsersChaned();
  },
  _hideManagePoint: function _hideManagePoint($e) {
    var self = this;
    var $qpopup = self.$('.point-po');
    var $mqpopup = self.$('.manage-a');
    var popDOM = $mqpopup.get(0);
    if ($qpopup.css("display") == "none") {
      return;
    }
    $qpopup.transitionEndOnce(function () {
      !$qpopup.hasClass("opened") && $qpopup.hide();
    });
    $qpopup.removeClass("opened");
  }
});
var _default = exports["default"] = MDInvite2shareView;

},{"106":106,"1104":1104,"1184":1184,"1429":1429,"1439":1439,"1454":1454,"22":22,"236":236,"688":688,"690":690,"72":72}],690:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
var _MMViewBase = _interopRequireDefault(require(22));
var _MDSwitchView = _interopRequireDefault(require(79));
var _MDChooserView = _interopRequireDefault(require(38));
var _MDCheckboxView = _interopRequireDefault(require(37));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDMessageView = _interopRequireDefault(require(55));
/**
 *  panel for share file ,who not has the permission to manage link share
 *  Created by jichao
 *  2016.9.28
 */

var MDShareFileOperateManagUserView = _MMViewBase["default"].extend({
  tmpl: "<div class=\"block-bd\">\n      <div class=\"list-group\" id=\"link-share\">\n        <div class=\"setting-item setting\">\n          <div class=\"left\"><%=useLink%><span class=\"help-inline\">(<%=ownerOpen%>)</span></div>\n          <div class=\"right\"><button id=\"open-btn\" class=\"button done\"><%=apply%></button></div>\n        </div>\n        <div class=\"content f-hide\">\n          <div class=\"help-block\"><%=applyCap%></div>\n          <div class=\"bd f-clb\">\n            <textarea name=\"\" id=\"message\" placeholder=\"<%=msg%>...\" rows=\"4\" class=\"form-control\" maxlength=\"120\" ></textarea>\n            <div class=\"help-block\"><%=wordsLeft%></div>\n          </div>\n          <div class=\"need-approval f-hide mgt-10\">\n            <div class=\"f-emph\"><%=BabelStr.str(28214)%></div>\n            <div class=\"red mgt-10\"><%=BabelStr.str(28166)%></div>\n            <div class=\"users-list approval-user-list\"></div>\n          </div>\n          <div class=\"form-button-groups with-btn-left\">\n            <button class=\"button done\" id=\"sendbtn\"><%=send%></button>\n            <button class = \"button\" id=\"canclebtn\"><%=cancel%></button>\n          </div>\n        </div>\n      </div>\n    </div>",
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      fileInfor: null,
      askLinkShareState: false,
      maxLength: 120
    });
  },
  events: function events() {
    return {
      'click #open-btn': this._displayAskInfo,
      'click #sendbtn': this._sendRequestLinkShare,
      'click #canclebtn': this._cancle,
      'keyup #message': this._refreshMsgLength,
      "click .approval-user-list .item": this.checkApprovalUserItem
    };
  },
  initialize: function initialize(opt) {
    var wordsLeft = BabelStr.str(427, {
      'num': '<span class="length">120</span>'
    }); // 还可以输入 xxx 个字
    var self = this;
    opt.data = _.extend({
      'useLink': BabelStr.str(75),
      // 使用链接分享
      'ownerOpen': BabelStr.str(423),
      // 所有者未开启此文件链接分享
      'apply': BabelStr.str(424),
      // 请求开启
      'applyCap': BabelStr.str(425),
      // 留言请求文件所有者开启链接分享，即可获得此文件的分享链接地址。
      'msg': BabelStr.str(426),
      // 添加留言
      'wordsLeft': wordsLeft,
      'send': BabelStr.str(428),
      // 发送请求
      'cancel': BabelStr.str(155) // 取消
    }, opt.data);
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.toggleShareCb = opt.toggleShareCb || _.noop;
    if (this.askLinkShareState) {
      this._displayAskInfo();
    }
    this.renderApprovalUsers();
    if (this.fileInfor.isNeedApproval()) {
      self.$(".need-approval").removeClass("f-hide");
    } else {
      self.$(".need-approval").addClass("f-hide");
    }
  },
  renderApprovalUsers: function renderApprovalUsers() {
    var _this = this;
    this.approvalUsers = [];
    var outShareApprovers = this.fileInfor.get("outShareApprovers");
    if (outShareApprovers.strategy == 2 && outShareApprovers.approvers.length) {
      this.approvalUsers = outShareApprovers.approvers;
    }
    var tmpl = '';
    _.each(this.approvalUsers, function (user) {
      tmpl += user.getUserItemHtmlStr({
        canRemove: false,
        needChecked: true
      });
      _this.$(".approval-user-list").html(tmpl);
    });
  },
  checkApprovalUserItem: function checkApprovalUserItem($e) {
    $($e.target).closest(".item").toggleClass("checked");
  },
  _refreshMsgLength: function _refreshMsgLength() {
    var str = this.$("#message").val().toString();
    this.$(".length").html(this.maxLength - str.length);
  },
  _sendRequestLinkShare: function _sendRequestLinkShare() {
    var self = this;
    var approvers = [];
    if (this.fileInfor.isNeedApproval()) {
      var $approvers = this.$(".approval-user-list .item.checked");
      for (var i = 0; i < $approvers.length; i++) {
        var id = $approvers.eq(i).data("id").toString();
        approvers.push(id);
      }
      if (!approvers.length) {
        _MDMessageView["default"].error(BabelStr.str(28227), this.$el);
        return;
      }
    }
    var message = this.$("#message").val();
    message = message.substring(0, this.maxLength);
    _MMNetDiskDataController["default"].requestForLinkShare(this.fileInfor.getFileId(), 10, message, approvers, function () {
      _MDSnackbarView["default"].show(BabelStr.str(308)); //("请求发送成功");
      self.$("#message").val("");
      self._cancle();
      self.close && self.close();
    }, function () {
      _MDSnackbarView["default"].show(BabelStr.str(168)); //("请求发送失败，请稍后重试");
    });
  },
  _cancle: function _cancle() {
    this.$(".content").addClass("f-hide");
    this.$("#open-btn").removeClass("f-hide");
    this.$("#message").val("");
    this.$(".length").val(this.maxLength);
  },
  _displayAskInfo: function _displayAskInfo() {
    this.$(".content").removeClass("f-hide");
    this.$("#open-btn").addClass("f-hide");
    this._refreshMsgLength();
  }
});
var _default = exports["default"] = MDShareFileOperateManagUserView;

},{"1104":1104,"1184":1184,"1437":1437,"1454":1454,"1463":1463,"1478":1478,"22":22,"37":37,"38":38,"55":55,"72":72,"79":79}],688:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1430);
require(1463);
require(1426);
require(1436);
require(1546);
require(1415);
require(1439);
require(1421);
require(1417);
require(1437);
require(1478);
require(1461);
require(1432);
require(1424);
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDParticipantInfo = _interopRequireDefault(require(276));
var _FILE_ROLE_ID = _interopRequireDefault(require(236));
var _MMViewBase = _interopRequireDefault(require(22));
var _MDSwitchView = _interopRequireDefault(require(79));
var _MDChooserView = _interopRequireDefault(require(38));
var _MDCheckboxView = _interopRequireDefault(require(37));
var _MDDropDownSelectRoleView = _interopRequireDefault(require(50));
var _MDEnterpriseShareTabView = _interopRequireDefault(require(675));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _regexp = _interopRequireDefault(require(106));
var _MDShareFilePermissionInfoView = _interopRequireDefault(require(692));
var _MDMessageView = _interopRequireDefault(require(55));
/**
 *  panel for share file email
 *  Created by jichao
 *  2016.9.28
 */

var MDShareFileInvMaileInfoView = _MMViewBase["default"].extend({
  tmpl: "<div class=\"red need-approval f-hide mgb-10\"><%=BabelStr.str(28218)%></div>\n  <div class=\"f-clb choose-a\">\n      <div>\n\n        <div class=\"chooser-wrapper\"></div>\n        <div class=\"btn-group f-fr\" id=\"select1\"></div>\n      </div>\n      <div id=\"added\" class=\"help-block f-none\"></div>\n    </div>\n    <div class=\"right\"></div>\n      <div id=\"no-inv-per-msg\" class=\"f-hide \">\n        <textarea name=\"\" id=\"invmessage\" cols=\"30\" placeholder=\"<%=letters%>...\" rows=\"10\" maxlength=\"500\"></textarea>\n        <div id=\"js-help\" class=\"help-block\"><%=wordsNum%></div>\n        </div>\n    <div class=\"need-approval f-hide mgt-10\">\n      <div class=\"f-emph\"><%=BabelStr.str(28214)%></div>\n      <div class=\"red mgt-10\"><%=BabelStr.str(28166)%></div>\n      <div class=\"users-list approval-user-list\"></div>\n    </div>\n    <div id=\"inv-sent-btns\" class=\"form-button-groups  with-btn-left\"></div>\n    <div class=\"checkbox-link3\" ></div>\n    <div class=\"checkbox-invite-watermark\" ></div>\n    ",
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    var wordsNum = BabelStr.str(427, {
      // 还可以输入个字
      num: '<span class="length">500</span>'
    });
    return _.extend(superP, {
      hasInvPermission: true,
      showRolesInfo: _.noop,
      roleId: 11,
      close: _.noop,
      onShareHandleSuccess: _.noop,
      inviteOutUser: _.noop,
      answerInvshare: false,
      contactCollection: null,
      targetUserInfos: [],
      enterpriceUser: true,
      canManageShare: true,
      renderUserInfo: _.noop,
      defaultRole: -1,
      data: {
        letters: BabelStr.str(426),
        // 添加留言
        wordsNum: wordsNum
      }
    });
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      // 'click #select1 li:last-child': this.aboutPermission,
      "click #enterpriseSendInvBtn": this._enterpriseSendInvitation,
      "click #sendInvBtn": this._sendInvitation,
      "click #askPermissionBtn": this.requestForInviteShare,
      "click #closeInvBtn": this.closeInvBtnClickHandler,
      "click #agreeUserRequestBtn": this._agreeUserRequest,
      "click #refuseUserRequestBtn": this._refuseUserRequest,
      "click #invmessage": this._invmessageClickHandle,
      "keyup #invmessage": this._refreshMsgLength,
      "click .approval-user-list .item": this.checkApprovalUserItem
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.bindSelf(this._manipulateReshare, this._setRoleId, this._setShareWatermark, this._watermarkChanged, this._sendInvitationWithDepartmentMemberCallback);
    this.enterpriceUser = app.isEpVersion() && !app.currentUser.isEnterpriseGuest() && this.fileInfor.belongsToCurrentUserEnterprise();
    this.$funTab = this.$("#funTab");
    var finish = BabelStr.str(89); // 完成
    if (!this.canManageShare) {
      this.$("#inv-sent-btns").html('<a class="button done " id="closeInvBtn"><span>' + finish + "</span></a>");
      this.$(".chooser-wrapper").css({
        width: "100%"
      });
      if (this.enterpriceUser) {
        this.$(".chooser-wrapper .choose-contain").css({
          width: "100%"
        });
      }
      self.$("#inv-sent-btns").addClass("f-hide");
    } else if (this.canManageShare && this.enterpriceUser) {
      this.$(".chooser-wrapper").css({
        width: "100%"
      });
      this.$("#select1").addClass("position-right-top");
      this.$("#inv-sent-btns").html('<a class="button done " id="closeInvBtn"><span>' + finish + "</span></a>");
      self.$("#inv-sent-btns").addClass("f-hide");
    } else {
      this.$("#inv-sent-btns").html('<a class="button done " id="closeInvBtn"><span>' + finish + "</span></a>");
      self.$("#inv-sent-btns").addClass("f-hide");
    }
    if (this.answerInvshare) {
      var agree = BabelStr.str(346); // 同意
      var reject = BabelStr.str(342); // 拒绝
      this.$("#no-inv-per-msg").addClass("f-hide");
      self.$("#inv-sent-btns").removeClass("f-hide");
      this.$("#inv-sent-btns").html('<a class="button done" id="agreeUserRequestBtn" ><span>' + agree + "</span></a>" + '<a class="button done" id="refuseUserRequestBtn" ><span>' + reject + "</span></a>");
    }
    this.contactCollection = new _MDMolaUserCollection["default"]();
    this._requestInvUser();
    if (this.enterpriceUser) {
      this.enterpriceUserChoose();
    } else {
      this._ordinaryUserChoose();
    }
    this.$invitedList = this.$("#invitedList");
    this.listenTo(this.fileInfor, "change:openWatermark", this._watermarkChanged);
    this.renderApprovalUsers();
  },
  renderApprovalUsers: function renderApprovalUsers() {
    var _this = this;
    this.approvalUsers = [];
    var outShareApprovers = this.fileInfor.get("outShareApprovers");
    if (outShareApprovers.strategy == 2 && outShareApprovers.approvers.length) {
      this.approvalUsers = outShareApprovers.approvers;
    }
    var tmpl = '';
    _.each(this.approvalUsers, function (user) {
      tmpl += user.getUserItemHtmlStr({
        canRemove: false,
        needChecked: true
      });
      _this.$(".approval-user-list").html(tmpl);
    });
  },
  checkApprovalUserItem: function checkApprovalUserItem($e) {
    $($e.target).closest(".item").toggleClass("checked");
    // let id = $($e.target).closest(".item").data("id").toString();
    // let user = _.findWhere(this.approvalUsers, user=>{
    //   return user.getUserId() == id
    // })
    // console.log(user)
  },
  _invmessageClickHandle: function _invmessageClickHandle() {
    this.$("#invmessage").focus();
  },
  enterpriceUserChoose: function enterpriceUserChoose() {
    var _this2 = this;
    var self = this;
    var sendRq = BabelStr.str(428); // 发送请求
    var send = BabelStr.str(406); // 发送
    var finish = BabelStr.str(89); // 完成
    var canSelDepartment = this.answerInvshare ? false : true;
    var canSelGroup = this.answerInvshare ? false : true;
    this.chooserView = new _MDEnterpriseShareTabView["default"]({
      canManageShare: this.canManageShare,
      // notIncludeGuest: app.ep.isShareAnoymousClosed() || !this.fileInfor.canShareout(),
      // isSelectOnlyInEp: app.ep.isShareAnoymousClosed()|| !this.fileInfor.canShareout(),
      notIncludeGuest: !this.fileInfor.canShareout(),
      isSelectOnlyInEp: !this.fileInfor.canShareout(),
      // canSelDepartment: this.canManageShare,
      // canSelGroup: this.canManageShare,
      canSelDepartment: canSelDepartment,
      filterCurrentUser: true,
      canSelGroup: canSelGroup ? !(app.isEpVersion() && app.currentUser.get("hasSecret")) : false,
      needFrequentUserTab: !this.fileInfor.get("forClient"),
      beforeSelect: function beforeSelect(user) {
        console.log(user);
        if (user.isGroup() && !user.isBelongToEnterprise() && self.fileInfor.isNeedApproval()) {
          _MDMessageView["default"].error(BabelStr.str(40091), _this2.$el.closest(".tab-panel-wrapper"));
          return false;
        } else {
          return true;
        }
      },
      onChange: function onChange(mails) {
        console.log(mails);
        if (mails.length > 0) {
          if (!self.answerInvshare) {
            if (!self.canManageShare) {
              self.$("#inv-sent-btns").html('<a class="button done" id="askPermissionBtn" ><span>' + sendRq + "</span></a>");
              self.$("#no-inv-per-msg").removeClass("f-hide");
              self.$("#inv-sent-btns").removeClass("f-hide");
            } else {
              self.$("#no-inv-per-msg").css({
                "margin-top": "22px"
              });
              self.$("#no-inv-per-msg").removeClass("f-hide");
              self.$("#inv-sent-btns").html('<a class="button done " id="enterpriseSendInvBtn"><span>' + send + "</span></a>");
              self.$("#inv-sent-btns").removeClass("f-hide");
            }
          }
        } else {
          self.$("#no-inv-per-msg").addClass("f-hide");
          self.$("#inv-sent-btns").html('<a class="button done " id="closeInvBtn"><span>' + finish + "</span></a>");
          self.$("#inv-sent-btns").addClass("f-hide");
        }
        var isGuest = _.some(mails.models, function (user) {
          return user.isGuest();
        });
        if (isGuest && self.fileInfor.isNeedApproval()) {
          self.$(".need-approval").removeClass("f-hide");
          self.inviteOutUser(true);
          self.inviteGuest = true;
        } else {
          self.$(".need-approval").addClass("f-hide");
          self.inviteOutUser(false);
          self.inviteGuest = false;
        }
      }
    });
    this.addSubView(this.chooserView, this.$(".chooser-wrapper"));
    if (_.isArray(this.targetUserInfos)) {
      this.targetUserInfos = new _MDMolaUserCollection["default"](this.targetUserInfos);
    }
    this.targetUserInfos.map(function (userInfor) {
      var user = self.chooserView.initParticipantInfo({
        id: userInfor.get("id"),
        type: _MDParticipantInfo["default"].USER_TYPE,
        name: userInfor.get("name"),
        email: userInfor.get("email"),
        phone: userInfor.get("phone"),
        guest: userInfor.get("guest")
      });
      self.chooserView.addItem(user, true);
    });
  },
  _ordinaryUserChoose: function _ordinaryUserChoose() {
    var self = this;
    if (app.application.contactList) {
      var datas = app.application.contactList.toJSON();
    } else {
      var datas = [];
    }
    var placeholder = BabelStr.str(709); // 输入姓名,邮件,或手机号

    var maxInputNumber = 10;
    this.chooserView = new _MDChooserView["default"]({
      textField: "email",
      placeholder: placeholder + "...",
      datas: datas,
      autoChoose: false,
      blurToChoose: true,
      keepText: false,
      dropDownMaxHeight: 200,
      backspaceOnceToRemove: true,
      maxInputNumber: maxInputNumber,
      enableAutoFilter: true,
      filterFun: function filterFun(datas, text) {
        var res = _.filter(datas, function (data) {
          var name = data["name"];
          var email = data["email"];
          var phone = data["phone"];
          var res = name.indexOf(text) >= 0 || email.indexOf(text) >= 0 || phone && phone.indexOf(text) >= 0;
          return res;
        });
        return res;
      },
      formateChoosedData: function formateChoosedData(data) {
        var user = {};
        var textField = this.textField;
        var isString = $.type(data) === "string";
        if (isString && data.length > 0) {
          $.each(this.datas, function () {
            if (this["email"] == data || this["phone"] == data) {
              data = this;
              return false;
            }
          });
          if ($.type(data) === "string") {
            if (_regexp["default"].isEmail(data)) {
              user["email"] = data;
              user["name"] = data;
              return user;
            } else if (_regexp["default"].isPhone(data)) {
              user["phone"] = data;
              user["name"] = data;
              return user;
            } else {
              user["name"] = data;
              return user;
            }
          }
        }
        return data;
      },
      // onEnterbeforeAdd: function(data){
      //   if(_.isString(data)){
      //     return {}
      //   }
      // }

      validateInput: function validateInput(data) {
        if (_.isString(data)) {
          if (!_regexp["default"].isEmail(data) && !_regexp["default"].isPhone(data)) return false;
        }
        return true;
      },
      chosenItemRenderer: function chosenItemRenderer(data) {
        var unReg = BabelStr.str(710); // 未注册用户
        if (_.isString(data)) {
          return "<a>" + data + "</a>";
        } else {
          if (data["userId"] == "-1") {
            return "<a>" + unReg + "<span>" + data["email"] + "</span></a>";
          } else {
            return "<a>" + data["name"] + "</a>";
          }
        }
        return false;
      },
      dropdownRenderer: function dropdownRenderer(data) {
        var hasMail = _.find(datas, function (value) {
          return value["email"] == data;
        });
        var checked = this.hasChosen(data) || hasMail;
        checked = checked ? " checked " : "";
        return '<div class="c-contact contact-infor">' + '<div class="infor-col">' + '<div class="chb"><input type="checkbox" ' + checked + "><label></label></div>" + '<img src="' + data["avatarImageURL"] + '"/>' + '<span class="name">' + data["name"] + "</span>" + '<span class="mail">' + data["email"] + "</span>" + "</div>" + "</div>";
      },
      onChange: function onChange(data, add) {
        var info = this.dropdownViewHasData(data);
        var el = info.dom;
        var $checkbox;
        if (info.index > -1) {
          $checkbox = $(el).find('input[type="checkbox"]');
          $checkbox.prop("checked", add);
        }
        var length = this.getChosen().length;
        var stringl = "";
        var sendRq = BabelStr.str(428); // 发送请求
        var send = BabelStr.str(406); // 发送
        var finish = BabelStr.str(89); // 完成

        if (length > 0) {
          for (var i = 0; i < length; i++) {
            if (i == 0) {
              stringl += this.getChosen()[0].name;
            } else {
              stringl += "、" + this.getChosen()[i].name;
            }
          }
          var addStr = BabelStr.str(91, {
            // 已输入 {-curCount-} 人，最多 {-maxCount-} 人
            curCount: "<em>" + length + "</em>",
            maxCount: 10
          });
          self.$("#added").show();
          self.$("#added").html(addStr);
          if (!self.answerInvshare) {
            self.$("#no-inv-per-msg").removeClass("f-hide");
            if (!self.canManageShare) {
              self.$("#inv-sent-btns").html('<a class="button done" id="askPermissionBtn" ><span>' + sendRq + "</span></a>");
            } else {
              self.$("#inv-sent-btns").html('<a class="button done" id="sendInvBtn" ><span>' + send + "</span></a>");
            }
            self.$("#inv-sent-btns").removeClass("f-hide");
          }
        } else {
          self.$("#no-inv-per-msg").addClass("f-hide");
          self.$("#added").hide();
          self.$("#added").html(" ");
          self.$("#inv-sent-btns").html('<a class="button done " id="closeInvBtn"><span>' + finish + "</span></a>");
          self.$("#inv-sent-btns").addClass("f-hide");
        }
      },
      delegateEvents: {
        "mousedown .c-contact": function mousedownCContact($e) {
          var $chb = $($e.currentTarget).find(".chb input");
          var data = $chb.closest("li").data("data-item");
          var checked = $chb.prop("checked");
          $chb.prop("checked", !checked);
          if (checked) {
            this.removeChoose(data);
          } else {
            if (this.hasReachMaxLength()) {
              $e.preventDefault();
              $chb.prop("checked", false);
              return false;
            }
            this.addChoose(data);
          }
        }
      }
    });
    this.addSubView(this.chooserView, this.$(".chooser-wrapper"));
    for (var i = 0; i < this.targetUserInfos.length; i++) {
      self.chooserView.addChoose(this.targetUserInfos[i]);
    }
  },
  _refreshMsgLength: function _refreshMsgLength() {
    var str = this.$("#invmessage").val().toString();
    // str = str.substring(0, 500);
    // this.$("#invmessage").val(str);
    this.$("#js-help .length").html(500 - str.length);
  },
  initInvManageInfo: function initInvManageInfo() {
    var _this3 = this;
    var self = this;
    if (this.fileInfor.isOwner() || this.fileInfor.canManageSharePermission()) {
      this.checkbox3 = new _MDCheckboxView["default"]({
        label: BabelStr.str(93),
        //  "禁止编辑者修改权限和添加新用户",
        onChanged: this._manipulateReshare,
        checked: !this.fileInfor.get("inviteShareControl")
      });
      this.addSubView(this.checkbox3, this.$(".checkbox-link3")[0]);
      // if (app.isEpVersion() && app.ep.getIsNeedShowEnableWatermarkButton()) {
      //   this.checkboxWatermark = new MDCheckboxView({
      //     label: "开启水印",
      //     onChanged: this._setShareWatermark,
      //     checked: this.fileInfor.getOpenWatermark()
      //   });
      //   this.addSubView(this.checkboxWatermark, this.$(".checkbox-invite-watermark")[0]);
      // }
      if (app.isEpVersion()) {
        _MMEnterpriseController["default"].getEnterpriseWaterMark(function (watermark) {
          if (watermark["watermarkType"] != 0 && watermark["watermarkScope"] == 2) {
            self.checkboxWatermark = new _MDCheckboxView["default"]({
              label: BabelStr.str(708),
              //  "开启水印",
              onChanged: self._setShareWatermark,
              checked: self.fileInfor.getOpenWatermark()
            });
            self.addSubView(self.checkboxWatermark, self.$(".checkbox-invite-watermark")[0]);
          }
        }, function () {});
      }
    }
    if (this.canManageShare || this.answerInvshare) {
      var roleArr = [];
      // self.roleIds = [];
      for (var i = 0; i < this.roles.length; i++) {
        var role = this.roles[i];
        var str = {
          label: role.get("description"),
          canSelected: true,
          linkRoleId: role.getRoleId(),
          systemdefault: role.get("systemdefault")
        };
        roleArr.push(str);
      }

      // var permCap = BabelStr.str(81);     // 了解权限
      // roleArr.push({ label: permCap + '...', canSelected: false });
      var index = -1;
      _.each(roleArr, function (roleInfo, i) {
        if (roleInfo["linkRoleId"] == _this3.defaultRole) {
          index = i;
        }
      });
      index = index < 0 ? 0 : index;
      this.roleId = roleArr[index].linkRoleId;
      var forClient = this.fileInfor.get("forClient");
      this.shareLinkPermissionDropdown = new _MDDropDownSelectRoleView["default"]({
        index: index,
        roles: this.roles,
        invite: true,
        bd: roleArr,
        onChange: self._setRoleId,
        minW: "162px",
        showHelp: !forClient
      });
      this.addSubView(this.shareLinkPermissionDropdown, this.$("#select1")[0]);
    } else {
      // this.$("#added").addClass("f-hide");
    }
  },
  _setShareWatermark: function _setShareWatermark(checked) {
    var sign = checked ? 1 : 0;
    var self = this;
    _MMNetDiskDataController["default"].setShareWatermark(this.fileInfor.getFileId(), sign, function () {
      console.log("watermark: " + checked);
      self.fileInfor.setOpenWatermark(sign);
    }, function () {});
  },
  _watermarkChanged: function _watermarkChanged() {
    var sign;
    if (this.fileInfor.getOpenWatermark()) {
      sign = true;
    } else {
      sign = false;
    }
    this.checkboxWatermark && this.checkboxWatermark.setChecked(sign, true);
  },
  _setRoleId: function _setRoleId(item) {
    this.roleId = item.linkRoleId;
  },
  _manipulateReshare: function _manipulateReshare(checked) {
    var self = this;
    if (checked) {
      _MMNetDiskDataController["default"].manipulateReshare(this.fileInfor.getFileId(), 0, function () {
        console.log("禁止用户再分发");
        _MDSnackbarView["default"].show(BabelStr.str(308));
      }, function () {});
    } else {
      _MMNetDiskDataController["default"].manipulateReshare(this.fileInfor.getFileId(), 1, function () {
        console.log("允许用户再分发");
        _MDSnackbarView["default"].show(BabelStr.str(308));
      }, function () {});
    }
  },
  validateEmailAndPhones: function validateEmailAndPhones(contact, isEp) {
    //后台过滤

    // var mails = [];
    // var mol = this.contactCollection.models;
    // var self = this;
    // for (var i = 0; i < mol.length; i++) {
    //   mails.push(mol[i].id);
    // }
    var self = this;
    // if (isEp) {
    this.targetPhones = contact.phones;
    this.targetMails = contact.emails;
    //   if (contact.emails.length == 0 && contact.phones.length == 0 && contact.deps.length == 0 && contact.groupIds.length == 0) return false;
    //   _.map(contact.emails, function(mail) {
    //     if (mail != app.currentUser.getEmail()) {
    //       // if ($.inArray(mail, mails) == -1) { //去掉前台对已加入分享用户的过滤，过滤后台实现
    //       self.targetMails.push(mail)
    //       // } else {
    //       // return;
    //       // }
    //     }
    //   });
    //   _.map(contact.phones, function(phone) {
    //     if (phone != app.currentUser.getPhone()) {
    //       self.targetPhones.push(phone)
    //     }
    //   });
    //   if (self.targetMails.length == 0 && self.targetPhones.length == 0 && contact.deps.length == 0 && contact.groupIds.length == 0) {
    //     self.chooserView.clear();
    //     return false;
    //   }
    // } else {
    //   if (contact.length == 0) return false;
    //   _.map(contact, function(user) {
    //     var mail = user["email"];
    //     var phone = user["phone"]
    //     if (mail && mail != app.currentUser.getOriginalEmail()) {
    // //       if ($.inArray(mail, mails) == -1) {
    //         self.targetMails.push(mail)
    //       // }
    // //         return;
    // //       }
    //     } else if (phone && phone != app.currentUser.getPhone()) {
    //       self.targetPhones.push(phone)
    //     }
    //   });
    // //   if (self.targetMails.length == 0 && self.targetPhones.length == 0) {
    // //     self.chooserView.clear();
    // //     return false;
    // //   }
    // }

    var arrIsEmpty = true;
    var keys = Object.keys(contact);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var attr = contact[key];
      if (attr.length) {
        arrIsEmpty = false;
      }
    }
    return !arrIsEmpty;
  },
  aboutPermission: function aboutPermission($e) {
    _MDShareFilePermissionInfoView["default"].show();
  },
  requestForInviteShare: function requestForInviteShare($e) {
    var self = this;
    var message = this.$("#invmessage").val();
    message = message.substring(0, 500);
    if (!_regexp["default"].validateTextinput(message)) {
      _MDSnackbarView["default"].show(BabelStr.str(12202));
      return;
    }
    var fid = this.fileInfor.getFileId();
    this.targetMails = [];
    this.targetPhones = [];
    var val;
    var contact;
    var validated;
    var depIds = [];
    var groupIds = [];
    var approvers;
    if (this.enterpriceUser) {
      val = this.chooserView.getInputVal();
      this.chooserView.addUserEmailItem(val);
      contact = this.chooserView.getTargetEmails();
      validated = this.validateEmailAndPhones(contact, true);
      depIds = contact.deps;
      groupIds = contact.groupIds;
      approvers = [];
      if (this.fileInfor.isNeedApproval() && this.inviteGuest) {
        var $approvers = this.$(".approval-user-list .item.checked");
        for (var i = 0; i < $approvers.length; i++) {
          var id = $approvers.eq(i).data("id").toString();
          approvers.push(id);
        }
        if (!approvers.length) {
          _MDMessageView["default"].error(BabelStr.str(28227), this.mesContainer || this.$el);
          return;
        }
      }
    } else {
      val = this.chooserView.getTextVal();
      this.chooserView.addChoose(val);
      contact = this.chooserView.getContact();
      validated = this.validateEmailAndPhones(contact, false);
    }
    if (!validated) {
      return;
    }
    if (!this._checkInputValid(contact)) {
      return;
    }
    var $sendInvBtn = $("#sendInvBtn");
    var sending = BabelStr.str(711); // 发送中...
    var send = BabelStr.str(428); // 发送请求
    $sendInvBtn.prop("disabled", true).text(sending);
    _MMNetDiskDataController["default"].requestForInviteShare(fid, self.roleId, self.targetMails, self.targetPhones, groupIds, depIds, message, approvers, function () {
      _MDSnackbarView["default"].show(BabelStr.str(308)); //('发送请求成功');
      $sendInvBtn.prop("disabled", false).text(send);
      if (self.enterpriceUser) {
        app.application.requestContact(function (contactList) {
          self.chooserView.resetFrequentList(contactList.toJSON());
        });
        self.chooserView.clear();
      } else {
        self.chooserView.setEnabled(true);
        app.application.requestContact(function (contactList) {
          self.chooserView.reset(contactList.toJSON());
        });
        self.chooserView.clear();
      }
      self.$("#invmessage").val("");
    }, function () {
      var send = BabelStr.str(406); // 发送
      _MDSnackbarView["default"].show(BabelStr.str(309)); //('发送请求失败，请稍后重试');
      $sendInvBtn.prop("disabled", false).text(send);
      self.chooserView.setEnabled(true);
      app.application.requestContact(function (contactList) {
        self.chooserView.reset(contactList.toJSON());
      });
    });
  },
  _sendInvitation: function _sendInvitation($e) {
    var self = this;
    var fid = this.fileInfor.getFileId();
    this.targetMails = [];
    this.targetPhones = [];
    var message = this.$("#invmessage").val();
    var val = this.chooserView.getTextVal();
    this.chooserView.addChoose(val);
    var contact = null;
    if (!_regexp["default"].validateTextinput(message)) {
      _MDSnackbarView["default"].show(BabelStr.str(12202));
      return;
    }
    if (!this.enterpriceUser) {
      contact = this.chooserView.getContact();
    } else {
      contact = this.chooserView.getTargetEmails();
    }
    var targetPhones = [];
    var validated = this.validateEmailAndPhones(contact, false);
    if (!validated) {
      return;
    }
    if (!this._checkInputValid(contact)) {
      return;
    }
    var $sendInvBtn = $("#sendInvBtn");
    var sending = BabelStr.str(711); // 发送中...
    $sendInvBtn.prop("disabled", true).text(sending);
    this.chooserView.setEnabled(false);
    var participantInfo = {
      targetEmails: self.targetMails,
      targetPhones: self.targetPhones,
      depIds: contact.depIds,
      groupIds: contact.groupIds
    };
    var send = BabelStr.str(406); // 发送

    _czc && _czc.push(["_trackEvent", "文件操作", "邀请参与分享", "", "", ""]);
    _MMNetDiskDataController["default"].sendInvitations({
      fid: fid,
      participantInfo: participantInfo,
      roleId: self.roleId,
      leaveMessage: message
    }, function (addUserIds, departmentUserCollection, sendApprove) {
      if (sendApprove) {
        var alert = new _MDAlertView["default"]({
          message: BabelStr.str(2573),
          title: BabelStr.str(170),
          buttons: [{
            label: BabelStr.str(3096),
            type: "done"
          }]
        });
        alert.show();
      }
      _MDSnackbarView["default"].show(BabelStr.str(308)); //('发送邀请成功');
      self.renderUserInfo();
      self.fileInfor.changeShareState(1);
      Dispatcher.trigger(MDEvents.ShareStatusChanged, self.fileInfor, true);
      Dispatcher.trigger(MDEvents.ShareChanged);
      $sendInvBtn.prop("disabled", false).text(send);
      self.chooserView.setEnabled(true);
      app.application.requestContact(function (contactList) {
        self.chooserView.reset(contactList.toJSON());
      });
      self.chooserView.clear();
      self.$("#invmessage").val("");
    }, function (code, msg) {
      _MDSnackbarView["default"].show(msg);
      $sendInvBtn.prop("disabled", false).text(send);
      self.chooserView.setEnabled(true);
      app.application.requestContact(function (contactList) {
        self.chooserView.reset(contactList.toJSON());
      });
    });
  },
  _checkInputValid: function _checkInputValid(contact) {
    return _MDChooserView["default"].checkAlertInputValid(contact.invalidNames);
  },
  _enterpriseSendInvitation: function _enterpriseSendInvitation() {
    var self = this;
    var fid = this.fileInfor.getFileId();
    this.targetMails = [];
    this.targetPhones = [];
    var message = this.$("#invmessage").val();
    var contact = this.chooserView.getTargetEmails();
    var validated = this.validateEmailAndPhones(contact, true);
    if (!validated) {
      return;
    }
    if (!this._checkInputValid(contact)) {
      return;
    }
    if (!_regexp["default"].validateTextinput(message)) {
      _MDSnackbarView["default"].show(BabelStr.str(12202));
      return;
    }
    var approvers = [];
    if (this.fileInfor.isNeedApproval() && this.inviteGuest) {
      var $approvers = this.$(".approval-user-list .item.checked");
      for (var i = 0; i < $approvers.length; i++) {
        var id = $approvers.eq(i).data("id").toString();
        approvers.push(id);
      }
      if (!approvers.length) {
        _MDMessageView["default"].error(BabelStr.str(28227), this.mesContainer || this.$el);
        return;
      }
    }
    var $sendInvBtn = $("#enterpriseSendInvBtn");
    var sending = BabelStr.str(711); // 发送中...
    $sendInvBtn.prop("disabled", true).text(sending);
    var participantInfo = {
      targetEmails: self.targetMails,
      targetPhones: self.targetPhones,
      depIds: contact.deps,
      groupIds: contact.groupIds
    };
    var send = BabelStr.str(406); // 发送

    _czc && _czc.push(["_trackEvent", "文件操作", "请求邀请某人参与分享", "", "", ""]);
    _MMNetDiskDataController["default"].sendInvitations({
      fid: fid,
      approvers: approvers,
      participantInfo: participantInfo,
      roleId: self.roleId,
      leaveMessage: message
    }, function (addUserIds, departmentUserCollection, sendApprove) {
      if (sendApprove) {
        var alert = new _MDAlertView["default"]({
          message: BabelStr.str(2573),
          title: BabelStr.str(170),
          buttons: [{
            label: BabelStr.str(3096),
            type: "done"
          }]
        });
        alert.show();
      }
      _MDSnackbarView["default"].show(BabelStr.str(308)); //('发送邀请成功');
      self.renderUserInfo();
      self.fileInfor.changeShareState(1);
      Dispatcher.trigger(MDEvents.ShareStatusChanged, self.fileInfor, true);
      Dispatcher.trigger(MDEvents.ShareChanged);
      $sendInvBtn.prop("disabled", false).text(send);
      app.application.requestContact(function (contactList) {
        self.chooserView.resetFrequentList(contactList.toJSON());
      });
      self.chooserView.clear();
      self.$("#invmessage").val("");
      self._sendInvitationWithDepartmentMemberCallback(departmentUserCollection);
    }, function (code, msg) {
      $sendInvBtn.prop("disabled", false).text(send);
      _MDSnackbarView["default"].show(msg);
    });
  },
  _sendInvitationWithDepartmentMemberCallback: function _sendInvitationWithDepartmentMemberCallback(departmentUserCollection) {
    var alert = new _MDAlertView["default"]();
    var names = departmentUserCollection.pluck("name");
    var nameStr = "";
    if (names.length > 5) {
      var length = names.length;
      var nameArr = names.splice(0, 5);
      nameStr = names.join(",");
      nameStr += BabelStr.str(403, {
        //"等"+length+ "人";
        num: length
      });
    } else {
      nameStr = names.join(",");
    }
    var userIds = departmentUserCollection.pluck("id");
    // let name = this.department.getName();
    // let departId = this.department.getId();
    var self = this;
    if (departmentUserCollection.length > 0) {
      var message = BabelStr.str(712, {
        // {-somebody-}是该文件所在部门的成员，无需邀请即可以直接访问该文件，你是否想要提醒他们关注该文件？
        somebody: "<strong>" + nameStr + "</strong>"
      });
      var opt = {
        message: "<p>" + message + "</p>",
        width: 400,
        okFun: function okFun() {
          _MMNetDiskDataController["default"].focusFile(self.fileInfor.getFileId(), userIds, function () {
            var focusCount = self.fileInfor.getFocusCount() + userIds.length;
            self.fileInfor.setFocusCount(focusCount);
            _MDSnackbarView["default"].show(BabelStr.str(308)); //("提醒关注成功");
          }, function () {
            _MDSnackbarView["default"].show(BabelStr.str(309)); //("提醒关注失败");
          });
        }
      };
      _MDAlertView["default"].showStandardSelection(opt);
    }
  },
  _agreeUserRequest: function _agreeUserRequest($e) {
    var self = this;
    var val;
    var contact;
    this.targetMails = [];
    this.targetPhones = [];
    if (this.enterpriceUser) {
      val = this.chooserView.getInputVal();
      this.chooserView.addUserEmailItem(val);
      contact = this.chooserView.getTargetEmails();
      var validated = this.validateEmailAndPhones(contact, true);
    } else {
      val = this.chooserView.getTextVal();
      this.chooserView.addChoose(val);
      contact = this.chooserView.getContact();
      var validated = this.validateEmailAndPhones(contact, false);
    }
    if (!validated) {
      return;
    }
    _czc && _czc.push(["_trackEvent", "文件操作", "同意参与邀请", "", "", ""]);
    _MMNetDiskDataController["default"].answerRequestForInviteShare(self.requestShareId, 1, this.targetMails, this.targetPhones, self.roleId, function () {
      self.close();
      self.onShareHandleSuccess();
      app.application.requestContact(function (contactList) {
        if (self.enterpriceUser) {
          self.chooserView.resetFrequentList(contactList.toJSON());
        } else {
          self.chooserView.reset(contactList.toJSON());
        }
      });
      _MDSnackbarView["default"].show(BabelStr.str(308)); //('发送邀请成功');
    }, function () {
      _MDSnackbarView["default"].show(BabelStr.str(309)); //('发送邀请失败，请稍后重试');
      app.application.requestContact(function (contactList) {
        if (self.enterpriceUser) {
          self.chooserView.resetFrequentList(contactList.toJSON());
        } else {
          self.chooserView.reset(contactList.toJSON());
        }
      });
    });
  },
  _refuseUserRequest: function _refuseUserRequest($e) {
    var self = this;
    this.targetMails = [];
    _czc && _czc.push(["_trackEvent", "文件操作", "拒绝参与邀请", "", "", ""]);
    _MMNetDiskDataController["default"].answerRequestForInviteShare(this.requestShareId, 0, this.targetMails, [], self.roleId, function () {
      self.close();
      self.onShareHandleSuccess();
      _MDSnackbarView["default"].show(BabelStr.str(308)); //('操作成功');
    }, function () {
      _MDSnackbarView["default"].show(BabelStr.str(309)); //('操作失败，请稍后重试');
    });
  },
  closeInvBtnClickHandler: function closeInvBtnClickHandler() {
    this.chooserView.onEnter();
    if (!this.answerInvshare) {
      if (this.canManageShare) {
        if (this.enterpriceUser) {
          this._enterpriseSendInvitation();
        } else {
          this._sendInvitation();
        }
      } else {
        this.requestForInviteShare();
      }
    } else {
      this._agreeUserRequest();
    }
    this.close();
  },
  _requestInvUser: function _requestInvUser() {
    var self = this;
    _MMNetDiskDataController["default"].getInvitationList(this.fileInfor.getFileId(), function (userCollect) {
      userCollect.each(function (user) {
        user.setId(user.get("email"));
        user.set("sharerId", self.fileInfor.getSharerId());
        if (user.get("participantId") == app.currentUser.getUserId()) {
          self.curRoleId = user.getRoleId();
        }
      });
      self.contactCollection = userCollect;
      self.initInvManageInfo();
    }, function (error, msg) {
      var message = msg || BabelStr.str(309);
      _MDSnackbarView["default"].show(message); // ('获取邀请人失败');
    });
  }
});
var _default = exports["default"] = MDShareFileInvMaileInfoView;

},{"106":106,"1098":1098,"1104":1104,"1184":1184,"1415":1415,"1417":1417,"1421":1421,"1424":1424,"1426":1426,"1430":1430,"1432":1432,"1436":1436,"1437":1437,"1439":1439,"1454":1454,"1461":1461,"1463":1463,"1478":1478,"1546":1546,"22":22,"236":236,"273":273,"276":276,"32":32,"37":37,"38":38,"50":50,"55":55,"675":675,"692":692,"72":72,"79":79}],236:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  EDIT_ROLE: 12,
  //编辑
  COMMENT_DOWNLOAD_ROLE: 11,
  //批注并下载
  COMMENT_ROLE: 10,
  //批注
  LOOK_ROLE: 9,
  //查看
  UPLOAD_ROLE: 14,
  //上传
  ROOT_ROLE: 13 //管理员||文件拥有者
};

},{"1454":1454}],568:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1437);
require(1463);
require(1478);
require(1416);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MMFileInfoCollection = _interopRequireDefault(require(298));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MDPaginationView = _interopRequireDefault(require(61));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDAlertView = _interopRequireDefault(require(32));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDDepSecretFileListWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDDepSecretFileListWinView, _MDWindowView);
  function MDDepSecretFileListWinView() {
    (0, _classCallCheck2["default"])(this, MDDepSecretFileListWinView);
    return _callSuper(this, MDDepSecretFileListWinView, arguments);
  }
  (0, _createClass2["default"])(MDDepSecretFileListWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n\t\t\t<div class=\"button-block flex-align between\">\n\t\t\t\t<span class=\"help-block\"><%=BabelStr.str(2855)%></span>\n        <%if(canManageFilePermission){%>\n          <button class=\"text-button done export-excel\"><%=BabelStr.str(6017)%></button>\n        <%}%>\n\t\t\t</div>\n\t\t\t<div class=\"file-list\">\n\t\t\t\t<div class=\"row file-head\">\n\t\t\t\t\t<div class=\"col-6 flex-align middle\">\n\t\t\t\t\t\t<span><%=BabelStr.str(49)%></span>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"col-3 sec-title\"><%=BabelStr.str(2852)%></div>\n\t\t\t\t\t<div class=\"col-3 f-tr\"><%=BabelStr.str(2848)%></div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"list-body\"></div>\n\t\t\t\t<div class=\"page-wrap mgt-10\"></div>\n\t\t\t</div>\n\t\t\t<div class=\"empty flex-align middle center\">\n\t\t\t\t<span class=\"help-block mgtb-20\"><%=BabelStr.str(2854)%></span>\n\t\t\t</div>\n\t\t";
    }
  }, {
    key: "renderItem",
    value: function renderItem(data) {
      return "\n\t\t\t<div class=\"row file-item\" data-id=\"".concat(data.fileId, "\" data-parentid=\"").concat(data.parentId, "\">\n\t\t\t\t<div class=\"col-6 flex-align middle\">\n\t\t\t\t\t<span class=\"text-overflow\" data-tooltip=\"").concat(data.fileName, "\">").concat(data.fileName, "</span>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-3 security-block\"></div>\n\t\t\t\t<div class=\"col-3 f-tr\">\n\t\t\t\t\t<span class=\"text-button done open-folder\">").concat(BabelStr.str(265), "</span>\n\t\t\t\t</div>\n\t\t\t</div>");
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        canManageFilePermission: this.fileInfo.canManageFilePermission()
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepSecretFileListWinView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepSecretFileListWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " file-secret-list-win");
    }
  }, {
    key: "initProps",
    value: function initProps(props) {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepSecretFileListWinView.prototype), "initProps", this).call(this, props);
      return _.extend(superP, {
        fileInfo: 0,
        fileInforCollection: null,
        size: 'large',
        pageIndex: 0,
        pageSize: 10
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepSecretFileListWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .open-folder': this._openFolderHandle,
        'click .export-excel': this._exportExcel
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.title = BabelStr.str(2853);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepSecretFileListWinView.prototype), "initialize", this).call(this, props);
      this.getDepartmentSecretFiles();
      this.$('.show-share').hide();
      _czc && _czc.push(["_trackEvent", "部门管理", "查看密级文件", "", "", ""]);
      this.paginationBarView = new _MDPaginationView["default"]({
        silentInit: true,
        pageSize: this.pageSize,
        onPageChanged: function onPageChanged(curPageIndex) {
          _this.pageIndex = curPageIndex;
          _this.getDepartmentSecretFiles();
        },
        onPageSizeChanged: function onPageSizeChanged(newPageSize) {
          _this.pageSize = newPageSize;
          _this.pageIndex = 0;
          _this.getDepartmentSecretFiles();
        }
      });
      this.addSubView(this.paginationBarView, this.$('.page-wrap')[0]);
    }
  }, {
    key: "_exportExcel",
    value: function _exportExcel() {
      var _this2 = this;
      var options = {
        fileId: this.fileInfo.getFileId(),
        departmentName: encodeURI(encodeURI(this.fileInfo.getFileName()))
      };
      MMEnterpriseController.downloadDepSecretFileList(options);
      this.$('.export-excel').attr("disabled", true);
      setBabelTimeout(function () {
        _this2.$('.export-excel').attr("disabled", false);
      }, 1000 * 60);
    }
  }, {
    key: "getDepartmentSecretFiles",
    value: function getDepartmentSecretFiles() {
      var _this3 = this;
      _MDSpinnerloaderView["default"].showIn(this.$('.list-body')[0]);
      this.$('.empty').hide();
      MMEnterpriseController.getDepartmentSecretFiles(this.fileInfo.getFileId(), this.pageIndex, this.pageSize, function (fileInforCollection, count) {
        _MDSpinnerloaderView["default"].clearFrom(_this3.$('.list-body')[0]);
        var tmpl = '';
        fileInforCollection.each(function (fileInfo) {
          var data = {
            fileId: fileInfo.getFileId(),
            fileName: fileInfo.getFileName(),
            parentId: fileInfo.get("parentId")
          };
          tmpl += _this3.renderItem(data);
        });
        _this3.$('.list-body').html(tmpl);
        _this3.fileInforCollection = fileInforCollection;
        if (_this3.fileInforCollection.length < 1) {
          _this3.$(".file-list").hide();
          _this3.$(".empty").show();
          _this3.$(".export-excel").hide();
        } else {
          _this3.$(".empty").hide();
          _this3.$(".export-excel").show();
        }
        _this3.renderSecretSelect();
        _this3.paginationBarView.setLength(count, true, _this3.pageIndex);
        if (count > 0) {
          _this3.paginationBarView.show();
        } else {
          _this3.paginationBarView.hide();
        }
      });
    }
  }, {
    key: "_openFolderHandle",
    value: function _openFolderHandle($e) {
      var $item = $($e.target).closest('.file-item');
      var fileId = $item.data("parentid").toString();
      app.pathRouter.openNewTabByFileId(fileId);
    }
  }, {
    key: "setFileSecurity",
    value: function setFileSecurity(id, fileId) {
      MMEnterpriseController.setFileSecret(fileId, id, function () {
        _MDSnackbarView["default"].show(BabelStr.str(308));
      }, function () {
        _MDSnackbarView["default"].show(BabelStr.str(3622));
      });
    }
  }, {
    key: "renderSecretSelect",
    value: function renderSecretSelect() {
      var _this4 = this;
      MMEnterpriseController.getSecretLevelsForFile(this.fileInfo.getFileId(), function (list) {
        _this4.fileInforCollection.each(function (fileInfor) {
          var secretLevelId = fileInfor.getSecretLevelId();
          var fid = fileInfor.getFileId();
          var index = _.findIndex(list, {
            id: secretLevelId
          });
          var $contain = _this4.$(".file-item[data-id=\"".concat(fid, "\"] .security-block"));
          if (_this4.fileInfo.canManageFilePermission()) {
            var securitySelect = new _MDDropdownSelectListView["default"]({
              dataProvider: list,
              labelField: "comment",
              selectedIndex: index,
              interceptor: function interceptor(data) {
                if (app.ep.canShowSecurityPolicyModel()) {
                  return true;
                }
                var opt = {
                  message: BabelStr.str(6118)
                };
                _MDAlertView["default"].showStandardPrompt(opt);
                return false;
              },
              onChange: function onChange(data) {
                _this4.setFileSecurity(data.id, fid);
              }
            });
            _this4.addSubView(securitySelect, $contain[0]);
          } else {
            $contain.html(list[index].comment);
          }
        }, function () {});
      });
    }
  }]);
  return MDDepSecretFileListWinView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1416":1416,"1437":1437,"1454":1454,"1463":1463,"1475":1475,"1478":1478,"298":298,"32":32,"61":61,"67":67,"72":72,"76":76,"93":93}],562:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _FileAddPerItemView = _interopRequireDefault(require(730));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDLocalString = _interopRequireDefault(require(1150));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDDepControlFileListWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDDepControlFileListWinView, _MDWindowView);
  function MDDepControlFileListWinView() {
    (0, _classCallCheck2["default"])(this, MDDepControlFileListWinView);
    return _callSuper(this, MDDepControlFileListWinView, arguments);
  }
  (0, _createClass2["default"])(MDDepControlFileListWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n\t\t\t<div class=\"help-block\"><%=BabelStr.str(2843)%></div>\n\t\t\t<div class=\"file-list\"></div>\n\t\t\t<div class=\"empty  flex-align middle center\">\n\t\t\t\t<span><%=BabelStr.str(2844)%></span>\n\t\t\t</div>\n\t\t\t<div class=\"flex-align end mgt-20 btns-block\">\n\t\t\t\t<button class=\"button close\"><%=BabelStr.str(156)%></button>\n\t\t\t</div>\n    ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepControlFileListWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        fileInfo: null,
        width: 600
      });
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        canManageFilePermission: this.fileInfo.canManageFilePermission()
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepControlFileListWinView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepControlFileListWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .close': this._close
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepControlFileListWinView.prototype), "className", this).call(this);
      if (_MDLocalString["default"].getLanguage()) {} else {}
      return "".concat(superCls, " control-file-win");
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.title = BabelStr.str(2614);
      props.showFooter = false;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepControlFileListWinView.prototype), "initialize", this).call(this, props);
      this.$('.empty').hide();
      _MDSpinnerloaderView["default"].showIn(this.$('.file-list')[0]);
      MMEnterpriseController.getDepAppendedPermissionFiles(this.fileInfo.getFileId(), function (fileInfoCollection) {
        _MDSpinnerloaderView["default"].clearFrom(_this.$('.file-list')[0]);
        if (fileInfoCollection.length < 1) {
          _this.$('.empty').show();
          _this.$('.file-list').hide();
        } else {
          fileInfoCollection.each(function (file) {
            var view = new _FileAddPerItemView["default"]({
              fileInfor: file,
              size: 30
            });
            _this.addSubView(view, _this.$('.file-list'));
          });
        }
      }, function (code) {
        _MDSnackbarView["default"].show(BabelStr.str(309), {
          code: code
        });
        _MDSpinnerloaderView["default"].clearFrom(_this.$('.file-list')[0]);
      });
      _czc && _czc.push(["_trackEvent", "部门管理", "查看追加权限文件", "", "", ""]);
    }
  }, {
    key: "_close",
    value: function _close() {
      this.close();
    }
  }]);
  return MDDepControlFileListWinView;
}(_MDWindowView2["default"]);

},{"1150":1150,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"72":72,"730":730,"76":76,"93":93}],730:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMViewBase2 = _interopRequireDefault(require(22));
var _MDDepFilePermissionWinView = _interopRequireDefault(require(565));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var FileAddPerItemView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(FileAddPerItemView, _MMViewBase);
  function FileAddPerItemView() {
    (0, _classCallCheck2["default"])(this, FileAddPerItemView);
    return _callSuper(this, FileAddPerItemView, arguments);
  }
  (0, _createClass2["default"])(FileAddPerItemView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n\n        <div class=\"flex-align fullfill\">\n          <div class=\"img \"></div>\n          <div class=\"name text-hide mglr-10\" data-tooltip=\"<%=name%>\"><%=name%></div>\n        </div>\n        <div class=\"btns noshrinkl\">\n\t\t\t\t\t<span class=\"epen-folder text-button done mgr-10\" data-tooltip=\"<%=BabelStr.str(265)%>\" data-tooltip-dir=\"top\"><%=BabelStr.str(265)%></span>\n          <%if(canManageFilePermission){%>\n\t\t\t\t\t  <span class=\"add-per text-button done\" data-tooltip=\"<%=BabelStr.str(262)%>\" data-tooltip-dir=\"top\"><%=BabelStr.str(262)%></span>\n          <%}%>\n        </div>\n      ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(FileAddPerItemView.prototype), "className", this).call(this);
      return "".concat(superCls, " file-add-per-item flex-align between middle");
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        name: this.fileInfor.getFileName(),
        canManageFilePermission: this.fileInfor.canManageFilePermission()
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(FileAddPerItemView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(FileAddPerItemView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        size: 40
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(FileAddPerItemView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .epen-folder": this._openFolderHandle,
        "click .add-per": this._showControlFileWinView
      });
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(FileAddPerItemView.prototype), "initialize", this).call(this, opt);
      this.fileInfor.setIconForDiv(this.$(".img"), undefined, this.size);
    }
  }, {
    key: "_openFolderHandle",
    value: function _openFolderHandle() {
      var fileId = this.fileInfor.getParentFolderId();
      app.pathRouter.openNetTab("/main.do#file/" + fileId);
      // Dispatcher.trigger(MDEvents.OpenFolderFromOtherChannel, { fileId: fileId, fileInfo: this.fileInfor });
      // Dispatcher.trigger(MDEvents.CloseSettingWin);
    }
  }, {
    key: "_showControlFileWinView",
    value: function _showControlFileWinView() {
      var fileControlWinView = new _MDDepFilePermissionWinView["default"]({
        fileInfo: this.fileInfor
      });
      fileControlWinView.show();
    }
  }]);
  return FileAddPerItemView;
}(_MMViewBase2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"22":22,"565":565}],565:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDDepFilePermissionNavPageView = _interopRequireDefault(require(564));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MMCommonFun = _interopRequireDefault(require(812));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 * 部门文件附加权限设置窗口
 * Created by jichao
 * 2018.1.15
 */ // import MDNavigationWindowView from '../../../../base/component/window/MDNavigationWindowView.js'
// import MDShareFileWindowView from "../share/MDShareFileWindowView.js";
var MDDepFilePermissionWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDDepFilePermissionWinView, _MDWindowView);
  function MDDepFilePermissionWinView() {
    (0, _classCallCheck2["default"])(this, MDDepFilePermissionWinView);
    return _callSuper(this, MDDepFilePermissionWinView, arguments);
  }
  (0, _createClass2["default"])(MDDepFilePermissionWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<div class=\"help-inline help-folder\"></div> ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = _MDWindowView2["default"].prototype.className.call(this);
      return superCls + " dep-file-per-window";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepFilePermissionWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        width: 1000,
        title: BabelStr.str(262),
        showFooter: false
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepFilePermissionWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .share-btn": this.shareFile
      });
    }
  }, {
    key: "initialize",
    value: function initialize(opts) {
      opts.showFooter = true;
      opts.buttons = [{
        label: BabelStr.str(156)
      }];
      opts.onClose = this.onClose;
      var title = _MMCommonFun["default"].getFileMidDotsString(opts.fileInfo.getFileName(), 30, 10, 40);
      var cls;
      if (opts.fileInfo.isDepartmentFolder()) {
        cls = "icon title-dep-icon";
      } else if (opts.fileInfo.isFolder()) {
        cls = "icon title-folder-icon";
      } else {
        cls = "icon title-file-icon";
      }
      title = "<div class=\"flex-align middle center\">\n      <span class=\"title-icon ".concat(cls, "\"></span>\n      <span>").concat(title, "</span>\n    </div>");
      opts.title = title;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepFilePermissionWinView.prototype), "initialize", this).call(this, opts);
      if (opts.fileInfo.isFolder()) {
        var str = BabelStr.str(752); //此处所设置的权限会自动应用到所有子文件和文件夹
        if (opts.fileInfo.belongProject() && opts.fileInfo.belongDepartment()) {
          //部门内普通项目
          this.$(".share-btn").addClass("folder-in-pro");
        } else {
          str += BabelStr.str(4748);
        }
        this.$(".help-folder").html(str);
      } else {
        this.$(".help-folder").remove();
      }
      if (opts.fileInfo.canShare()) {
        var btnText;
        if (opts.fileInfo.belongProject() || opts.fileInfo.belongTransmittalProject()) {
          btnText = BabelStr.str(21502);
        } else {
          btnText = BabelStr.str(21501);
        }
        this.$(".btn-text").html(btnText);
        this.$(".share-btn").removeClass("f-hide");
      }
      var view = new _MDDepFilePermissionNavPageView["default"]({
        fileInfo: opts.fileInfo,
        params: this.params,
        msgContainer: this.$body
      });
      this.addSubView(view, this.$body[0]);
    }
  }, {
    key: "shareFile",
    value: function shareFile() {
      var ctl = new window.MDFileActionController();
      ctl.setFileInfors([this.fileInfo]);
      ctl.shareFile();
    }
  }, {
    key: "onClose",
    value: function onClose() {
      var _this = this;
      MMNetDiskDataController.getFileInfoFromServer(this.fileInfo.getFileId(), function (file) {
        _this.fileInfo.set("fileIdHasAppendPermission", file.get("fileIdHasAppendPermission"));
        // this.fileInfo.set("hasAppendedPermission", file.get("hasAppendedPermission"))
      }, function () {});
    }
  }]);
  return MDDepFilePermissionWinView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1454":1454,"1463":1463,"1475":1475,"564":564,"812":812,"93":93}],564:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1541);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTabView = _interopRequireDefault(require(82));
var _MDNavigationPageView = _interopRequireDefault(require(56));
var _MDDepMemberFilePermissionTabView = _interopRequireDefault(require(566));
var _TabBarPosition = _interopRequireDefault(require(84));
var _MDGroupFilePermissionPageView = _interopRequireDefault(require(587));
var _MMViewBase2 = _interopRequireDefault(require(22));
var _MDRoleInfo = _interopRequireDefault(require(281));
var _MDDepRolePermissionPageView = _interopRequireDefault(require(567));
var _MDUserInFilePermissionInfoTabView = _interopRequireDefault(require(595));
var _MDShareApprovalPageView = _interopRequireDefault(require(594));
var _MDCheckboxView = _interopRequireDefault(require(37));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDSnackbarView = _interopRequireDefault(require(72));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } //
// 部门文件权限设置navpage
// Created by jichao
// 2018.15
//
var MDDepFilePermissionNavPageView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MDDepFilePermissionNavPageView, _MMViewBase);
  function MDDepFilePermissionNavPageView() {
    (0, _classCallCheck2["default"])(this, MDDepFilePermissionNavPageView);
    return _callSuper(this, MDDepFilePermissionNavPageView, arguments);
  }
  (0, _createClass2["default"])(MDDepFilePermissionNavPageView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n      <div class=\"tab-panel-list\"></div>\n      <div class=\"mgt-10 ope-type-content f-hide\"></div>\n    ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepFilePermissionNavPageView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        activeIndex: 0
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepFilePermissionNavPageView.prototype), "initialize", this).call(this, props);
      var self = this;
      var depMember = BabelStr.str(2530); //部门人员
      var group = BabelStr.str(2531); //分组人员

      MMNetDiskDataController.getAllRoles(function (roleCollection, defId) {
        self.rolesCol = roleCollection;
        // self.rolesCol.add(new MDRoleInfo({name: BabelStr.str(731),id: '0'}), {at: 0}); //
        // self.rolesCol.add(new MDRoleInfo({name: BabelStr.str(177),id: '-1'}), {at: 0}); // 把无权限放在第一位

        self.roleArr = [{
          linkRoleId: -1,
          label: BabelStr.str(6150),
          // 把无权限放在第一位
          canSelected: true
        }, {
          linkRoleId: 0,
          label: BabelStr.str(731),
          canSelected: true
        }];
        // self.originRoleArr =[];
        self.rolesCol.each(function (roleInfo) {
          var roleItem = {
            linkRoleId: roleInfo.getRoleId(),
            label: roleInfo.getRoleName(),
            canSelected: true,
            systemdefault: roleInfo.get("systemdefault")
          };
          if (self.fileInfo.isFolder() || !roleInfo.onlyForFolder()) {
            self.roleArr.push(roleItem);
          }
        });
        var depRoleView;
        var depMemberTab = new _MDDepMemberFilePermissionTabView["default"]({
          subCheckbox: self.subCheckbox,
          fileInfo: self.fileInfo,
          roleArr: self.roleArr,
          roles: self.rolesCol.models,
          onTabActived: function onTabActived() {
            self.$(".ope-type-content").removeClass("f-hide");
          },
          onAllUserPermissionChanged: function onAllUserPermissionChanged(id) {
            depRoleView && depRoleView.onAllUserPermissionChanged(id);
          }
        });
        var tabArr = [];
        var title = BabelStr.str(2875);
        if (self.fileInfo.belongProject() || self.fileInfo.belongTransmittalProject()) {
          title = BabelStr.str(6030);
        }
        tabArr.push({
          title: title,
          tabPanelView: depMemberTab,
          active: !(self.params && self.params.showUserInfo || self.params && self.params.showsharePerInfo)
        });
        if (!self.fileInfo.belongProject() && !self.fileInfo.belongTransmittalProject()) {
          depRoleView = new _MDDepRolePermissionPageView["default"]({
            fileInfo: self.fileInfo,
            roleArr: self.roleArr,
            roles: self.rolesCol.models,
            onTabActived: function onTabActived() {
              self.$(".ope-type-content").removeClass("f-hide");
            }
          }), tabArr.push({
            title: BabelStr.str(2876),
            tabPanelView: depRoleView
          });
        }
        var perInfoTab = new _MDUserInFilePermissionInfoTabView["default"]({
          fileInfo: self.fileInfo
        });
        tabArr.push({
          title: BabelStr.str(8571),
          titleCls: "user-file-per-info",
          tabPanelView: perInfoTab,
          active: !!self.params && self.params.showUserInfo
        });
        if (self.fileInfo.canShare()) {
          var btnText = '';
          if (self.fileInfo.belongProject() || self.fileInfo.belongTransmittalProject()) {
            btnText = BabelStr.str(21502);
          } else {
            btnText = BabelStr.str(21501);
          }
          tabArr.push({
            title: "<div class=\"flex-align middle\">\n            <span class=\"new-icon ic-new-share\"></span>\n            <span class=\"btn-text\">".concat(btnText, "</span>\n          </div>"),
            titleCls: "user-file-per-info",
            isLink: true,
            onActived: function onActived() {
              var ctl = new window.MDFileActionController();
              ctl.setFileInfors([self.fileInfo]);
              ctl.shareFile();
            }
          });
          tabArr.push({
            title: BabelStr.str(21922),
            titleCls: "user-file-per-info",
            active: !!self.params && self.params.showsharePerInfo,
            tabPanelView: new _MDShareApprovalPageView["default"]({
              fileInfo: self.fileInfo,
              msgContainer: self.msgContainer
            })
          });
        }
        self.settingTabView = new _MDTabView["default"]({
          className: "setting-tabs",
          enableActivebar: false,
          activeIndex: self.activeIndex,
          // tabBarPosition: TabBarPosition.LEFT,
          tabs: tabArr,
          onTabChanged: function onTabChanged(index) {
            self.$(".ope-type-content").addClass("f-hide");
          }
        });
        self.addSubView(self.settingTabView);
        // self._checkRoleWithFileType();
      }, function () {
        console.log("------------- get roles error!");
      });
      if (this.fileInfo.isFolder()) {
        this.$(".ope-type-content").removeClass("f-hide");
        this.subCheckbox = new _MDCheckboxView["default"]({
          label: BabelStr.str(11347),
          onChanged: function onChanged(checked) {
            _this.setFileExPermissionInheritation(checked);
          }
        });
        this.addSubView(this.subCheckbox, this.$(".ope-type-content")[0]);
      }
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepFilePermissionNavPageView.prototype), "className", this).call(this);
      return superCls + " dep-file-permission-nav-page";
    }
  }, {
    key: "activeEditGroup",
    value: function activeEditGroup() {
      this.settingTabView.activeTabAt(0);
    }
  }, {
    key: "setFileExPermissionInheritation",
    value: function setFileExPermissionInheritation(checked) {
      var _this2 = this;
      if (this.setFileExPermissionInheritationTimer) {
        clearTimeout(this.setFileExPermissionInheritationTimer);
      }
      this.setFileExPermissionInheritationTimer = setTimeout(function () {
        _MDAlertView["default"].showStandardSelection({
          message: BabelStr.str(11348),
          okFun: function okFun() {
            _this2._setFileExPermissionInheritation(checked);
          },
          cancelFun: function cancelFun() {
            _this2.subCheckbox.setChecked(!checked, true);
          }
        });
      }, 200);
    }
  }, {
    key: "_setFileExPermissionInheritation",
    value: function _setFileExPermissionInheritation(checked) {
      var _this3 = this;
      this.setFileExPermissionInheritationTimer = null;
      checked = checked ? 1 : 0;
      MMEnterpriseController.setFileExPermissionInheritation(this.fileInfo.getFileId(), checked, function () {
        _MDSnackbarView["default"].show(BabelStr.str(308));
      }, function (err) {
        _MDSnackbarView["default"].show(err.msg || BabelStr.str(309));
        _this3.subCheckbox.setChecked(!checked, true);
      });
    }
  }]);
  return MDDepFilePermissionNavPageView;
}(_MMViewBase2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"1541":1541,"22":22,"281":281,"32":32,"37":37,"56":56,"566":566,"567":567,"587":587,"594":594,"595":595,"72":72,"82":82,"84":84}],595:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1423);
require(1463);
require(1480);
require(1487);
require(1538);
require(1541);
require(1412);
require(1439);
require(1424);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
var _MDPaginationView = _interopRequireDefault(require(61));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _FILE_ACTION_BITS = _interopRequireDefault(require(235));
var _MDLoadMaskView = _interopRequireDefault(require(49));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } //
// 人员权限详情
// Created by jichao
// 2023.3.29
var MDUserInFilePermissionInfoTabView = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(MDUserInFilePermissionInfoTabView, _MDTabPanelView);
  function MDUserInFilePermissionInfoTabView() {
    (0, _classCallCheck2["default"])(this, MDUserInFilePermissionInfoTabView);
    return _callSuper(this, MDUserInFilePermissionInfoTabView, arguments);
  }
  (0, _createClass2["default"])(MDUserInFilePermissionInfoTabView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n      <div class = \"perm-disp\">\n\n        <div class=\"mgtb-10\">\n          <div class=\"search-box mgt-10\">\n            <i class=\"icon-search\"></i>\n            <input type=\"text\" class=\"search-input\" placeholder=<%=BabelStr.str(579)%>>\n          </div>\n        </div>\n        <div class = \"table-root\">\n          <table class=\"table with-layout-fixed f-tc\">\n            <thead>\n              <tr class=\"head\">\n                <td class=\"name\"><%=BabelStr.str(577)%></td>\n                <td><%=BabelStr.str(8572)%></td>\n                <td><%=BabelStr.str(38)%></td>\n                <td><%=BabelStr.str(29)%></td>\n                <td><%=BabelStr.str(2006)%></td>\n                <td><%=BabelStr.str(32)%></td>\n                <td><%=BabelStr.str(30)%></td>\n                <td><%=BabelStr.str(31)%></td>\n                <td><%=BabelStr.str(730)%></td>\n                <td><%=BabelStr.str(8573)%></td>\n                <td><%=BabelStr.str(42)%></td>\n              </tr>\n            </thead>\n            <tbody class=\"table-content user-list\"></tbody>\n          </table>\n\n        </div>\n\n        <div class=\"page-bar\"></div>\n      </div>";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUserInFilePermissionInfoTabView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        inWin: false,
        startIndex: 0,
        pageSize: 10,
        data: {},
        selectedUsers: new Set()
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUserInFilePermissionInfoTabView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'input .search-input': this.conditionChanged
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUserInFilePermissionInfoTabView.prototype), "className", this).call(this);
      return "".concat(superCls, " dep-file-perm-info");
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      this.$('.loader').hide();
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUserInFilePermissionInfoTabView.prototype), "initialize", this).call(this, opt);
      this.permissionItems = [];
      this.$('.line').remove();
      var self = this;
      this.renderPageBar();
    }
  }, {
    key: "onActived",
    value: function onActived() {
      this.getUserPermissionListForFile();
    }
  }, {
    key: "conditionChanged",
    value: function conditionChanged() {
      var _this = this;
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this.getUserPermissionListForFile();
      }, 400);
    }
  }, {
    key: "getUserPermissionListForFile",
    value: function getUserPermissionListForFile() {
      var self = this;
      var searchKey = this.$(".search-input").val();
      _MDSpinnerloaderView["default"].clearFrom(this.$('.loader')[0]);
      var $el = this.$el;
      // MDSpinnerloaderView.showIn(this.$('.loader')[0])
      // self.$('.table-content').hide()
      // self.$('.table-root').hide()
      this.$('.loader').hide();
      var maskTimeout = setTimeout(function () {
        maskTimeout = null;
        _MDLoadMaskView["default"].show();
      }, 500);
      MMEnterpriseController.getUserPermissionListForFile(this.fileInfo.getFileId(), searchKey, this.startIndex, this.pageSize, function (data) {
        if (maskTimeout) {
          clearTimeout(maskTimeout);
        } else {
          _MDLoadMaskView["default"].remove();
        }
        self.userInfos = data.userInfos;
        self.$('.table-content').show();
        self.$('.table-root').show();
        self.$('.loader').hide();
        self._refresh(self.userInfos);
        self.setLength(data.total, self.startIndex);
      }, function (codeError) {
        if (maskTimeout) {
          clearTimeout(maskTimeout);
        } else {
          _MDLoadMaskView["default"].remove();
        }
        // MDSpinnerloaderView.clearFrom($el[0])
        _MDSnackbarView["default"].show(BabelStr.str(309)); // ('获取文件权限失败')
      });
      self.$('.perm-disp').show();
    }
  }, {
    key: "_refresh",
    value: function _refresh(data, alluser) {
      var result = '';
      for (var i = 0; i < data.length; i++) {
        var user = data[i];
        result += this.createItem(user);
      }
      ;
      this.$('.table-content').html(result);
    }
  }, {
    key: "createItem",
    value: function createItem(user) {
      var scopeTmpl = this.getScopeTmpl(user.shareScope);
      var canRead = user.actions & _FILE_ACTION_BITS["default"].READ;
      var showUnreadName = false;
      if (!canRead) {
        // ------------ 不能读文件时才检测是否显示名字
        showUnreadName = user.actions & _FILE_ACTION_BITS["default"].ONLY_READ_NAME;
      }
      return "<tr class=\"\">\n      <td class=\"name\">".concat(user.name, "</td>\n      <td>").concat(scopeTmpl, "</td>\n      <td class=\"").concat(canRead && 'checked', "\"><span></span></td>\n      <td class=\"").concat(user.actions & _FILE_ACTION_BITS["default"].DOWNLOAD && 'checked', "\"><span></span></td>\n      <td class=\"").concat((user.actions & _FILE_ACTION_BITS["default"].UPLOAD || user.actions & _FILE_ACTION_BITS["default"].UPLOADVERSION) && 'checked', "\"><span></span></td>\n      <td class=\"").concat(user.actions & _FILE_ACTION_BITS["default"].DELETE && 'checked', "\"><span></span></td>\n      <td class=\"").concat(user.actions & _FILE_ACTION_BITS["default"].RENAME && 'checked', "\"><span></span></td>\n      <td class=\"").concat(user.actions & _FILE_ACTION_BITS["default"].MOVE && 'checked', "\"><span></span></td>\n      <td class=\"").concat(user.actions & _FILE_ACTION_BITS["default"].PRINT && 'checked', "\"><span></span></td>\n      <td class=\"").concat(showUnreadName && 'checked', "\"><span></span></td>\n      <td class=\"").concat(user.actions & _FILE_ACTION_BITS["default"].COMMENT_CREATE && 'checked', "\"><span></span></td>\n    </tr>");
    }
  }, {
    key: "getScopeTmpl",
    value: function getScopeTmpl(scopeArr) {
      var result = [];
      var name;
      var label;
      _.each(scopeArr, function (scope) {
        switch (scope) {
          case 0:
            name = BabelStr.str(7018);
            label = 'D';
            break;
          case 1:
            name = BabelStr.str(3046);
            label = 'F';
            break;
          case 2:
          case 4:
            name = BabelStr.str(8574);
            label = 'P';
            break;
          case 3:
            name = BabelStr.str(8575);
            label = 'S';
            break;
        }
        result.push("<span class=\"mgr-10 f-pointer\" data-tooltip=\"".concat(name, "\" data-tooltip-dir=\"top\">").concat(label, "</span>"));
      });
      return result.join('');
    }
  }, {
    key: "setLength",
    value: function setLength(total, startIndex) {
      this.pageBarView.setLength(total, true);
      if (startIndex == 0) {
        this.pageBarView.setCurrentPage(startIndex, true);
      }
    }
  }, {
    key: "renderPageBar",
    value: function renderPageBar() {
      var _this2 = this;
      this.pageBarView = new _MDPaginationView["default"]({
        enableStepButton: true,
        showJumpToPage: false,
        silentInit: true,
        showSelectSizeList: false,
        align: 'left',
        pageSize: this.pageSize,
        onPageChanged: function onPageChanged(curPageIndex) {
          _this2.startIndex = curPageIndex * _this2.pageSize;
          _this2.getUserPermissionListForFile();
        }
      });
      this.addSubView(this.pageBarView, this.$('.page-bar')[0]);
    }
  }]);
  return MDUserInFilePermissionInfoTabView;
}(_MDTabPanelView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1423":1423,"1424":1424,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"1480":1480,"1487":1487,"1538":1538,"1541":1541,"235":235,"49":49,"61":61,"72":72,"76":76,"81":81}],594:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1423);
require(1463);
require(1480);
require(1487);
require(1538);
require(1421);
require(1437);
require(1412);
require(1417);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
var _MEStaffSearchWindowView = _interopRequireDefault(require(200));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDMolaUser = _interopRequireDefault(require(272));
var _MDUsersICanSeeWinView = _interopRequireDefault(require(637));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } //
// 人员权限详情
// Created by jichao
// 2023.3.29
var MDShareApprovalPageView = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(MDShareApprovalPageView, _MDTabPanelView);
  function MDShareApprovalPageView() {
    (0, _classCallCheck2["default"])(this, MDShareApprovalPageView);
    return _callSuper(this, MDShareApprovalPageView, arguments);
  }
  (0, _createClass2["default"])(MDShareApprovalPageView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n    <div class=\"help-block mgtb-10\"><%=BabelStr.str(21934)%></div>\n    <div class=\"help-block mgtb-10 operator f-hide\"></div>\n    <div class=\"flex-align mgb-10 between\">\n    <div class=\"title\"><%=BabelStr.str(21923)%></div>\n    <div class=\"text-button done clear\"><%=BabelStr.str(21928)%></div>\n  </div>\n      <div class=\"flex-align middle mgt-10 check-item share-type\">\n        <span class=\"checkbox\"></span>\n        <label><%=BabelStr.str(21924)%></label>\n      </div>\n      <div class=\"flex-align middle mgb-20 mgt-10 check-item share-type\">\n        <span class=\"checkbox\"></span>\n        <label><%=BabelStr.str(21925)%></label>\n      </div>\n      <div class=\"flex-align mgb-10 between\">\n        <div class=\"title\"><%=BabelStr.str(21926)%>\n        </div>\n        <div class=\"text-button done add-new-member\"><%=BabelStr.str(21927)%></div>\n      </div>\n      <div class=\"flex-align middle mgb-20 mgt-10 marginL-10 check-item option-type\">\n        <span class=\"checkbox\"></span>\n        <label><%=BabelStr.str(2651)%></label>\n      </div>\n      <ul class=\"users-list mgtb-10\"></ul>\n    ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDShareApprovalPageView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        userIdSet: new Set(),
        reviewType: 0
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDShareApprovalPageView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .add-new-member': this._addNewMemberClickHandle,
        "click .share-type": this._checkItemClickHandle,
        "click .option-type": this._optionClickHandle,
        "click .clear": this._clear
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDShareApprovalPageView.prototype), "className", this).call(this);
      return "".concat(superCls, " share-file-perm-info");
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDShareApprovalPageView.prototype), "initialize", this).call(this, opt);
    }
  }, {
    key: "onActived",
    value: function onActived() {
      if (!this.dataInit) {
        this.dataInit = true;
        this.getInitData();
      }
    }
  }, {
    key: "getInitData",
    value: function getInitData() {
      var _this = this;
      _MMEnterpriseController["default"].getReviewConfig4File(this.fileInfo.getFileId(), function (data) {
        if (data) {
          console.log(data);
          var reviewType = data.config.reviewType;
          _this.reviewId = data.config.id;
          if (reviewType & 1) {
            _this.$(".share-type").eq(0).addClass("checked");
          }
          if (reviewType & 2) {
            _this.$(".share-type").eq(1).addClass("checked");
          }
          _this.reviewType = reviewType;
          _this.options = data.config.options;
          if (_this.options & 1) {
            _this.$(".option-type").addClass("checked");
          }
          var users = [];
          _this.$(".users-list").empty();
          var operator;
          var operateTime;
          _.each(data.userInfos, function (user) {
            if (_.indexOf(data.userIds, user.id) > -1) {
              _this.userIdSet.add(user.id);
              users.push(new _MDMolaUser["default"](user));
            }
            if (data.config.operator == user.id) {
              operator = new _MDMolaUser["default"](user);
              operateTime = new Date(data.config.time);
            }
          });
          _this.renderUserList(users);
          if (operator) {
            _this.renderOperator(operator, operateTime);
          }
        }
        _this.renderClearBtnStatus();
      }, function (code, msg) {
        _MDMessageView["default"].error(msg, _this.msgContainer);
      });
    }
  }, {
    key: "renderOperator",
    value: function renderOperator(user, time) {
      if (!this.reviewId) {
        this.$(".operator").addClass("f-hide");
      } else {
        this.$(".operator").removeClass("f-hide");
      }
      user = user || app.currentUser;
      time = time || new Date();
      var account = user.getAccount();
      account = account ? account : "--";
      this.$(".operator").html(BabelStr.str(21929, {
        user: "".concat(user.getUserName(), "(").concat(account, ")"),
        time: time.format("yyyy-MM-dd HH:mm:ss")
      }));
    }
  }, {
    key: "renderUserList",
    value: function renderUserList(users) {
      var _this2 = this;
      var $contain = this.$(".users-list");
      var canRemove = true;
      var tmpl = '';
      _.each(users, function (user) {
        tmpl = user.getUserItemHtmlStr({
          canRemove: canRemove
        });
        $contain.append(tmpl);
      });
      $contain.find('.remove').on('click', function (e) {
        _this2._removeUser(e);
      });
    }
  }, {
    key: "_removeUser",
    value: function _removeUser($e) {
      var $target = $($e.target).closest(".item");
      var id = $target.data("id");
      this.updateReviewConfig4File([], [id], this.reviewType, this.options, function () {
        $target.remove();
      });
    }
  }, {
    key: "updateReviewConfig4File",
    value: function updateReviewConfig4File(addReviewerId, delReviewerId, reviewType, options, success) {
      var _this3 = this;
      _MMEnterpriseController["default"].updateReviewConfig4File(this.reviewId, addReviewerId, delReviewerId, reviewType, options, function () {
        _MDMessageView["default"].success(BabelStr.str(308), _this3.msgContainer);
        _this3.reviewType = reviewType;
        success && success();
        _this3.renderOperator();
        _this3.renderClearBtnStatus();
      }, function (code, msg) {
        _MDMessageView["default"].success(msg, _this3.msgContainer);
      });
    }
  }, {
    key: "setReviewConfigOptions",
    value: function setReviewConfigOptions(options, success) {
      var _this4 = this;
      _MMEnterpriseController["default"].setReviewConfigOptions(this.reviewId, options, function () {
        _MDMessageView["default"].success(BabelStr.str(308), _this4.msgContainer);
        _this4.options = options;
        success && success();
        _this4.renderOperator();
        _this4.renderClearBtnStatus();
      }, function (code, msg) {
        _MDMessageView["default"].success(msg, _this4.msgContainer);
      });
    }
  }, {
    key: "addReviewConfig4File",
    value: function addReviewConfig4File(fileIds, reviewerIds, reviewType, options) {
      var _this5 = this;
      _MMEnterpriseController["default"].addReviewConfig4File(fileIds, reviewerIds, reviewType, options, function () {
        _this5.getInitData();
        _MDMessageView["default"].success(BabelStr.str(308), _this5.msgContainer);
      }, function (code, msg) {
        _MDMessageView["default"].success(msg, _this5.msgContainer);
      });
    }
  }, {
    key: "_addNewMemberClickHandle",
    value: function _addNewMemberClickHandle() {
      var _this6 = this;
      var win = new _MDUsersICanSeeWinView["default"]({
        fileInfo: function fileInfo() {
          return _this6.fileInfo;
        },
        onChoose: function onChoose(users) {
          var newUsers = [];
          var ids = [];
          for (var i = 0; i < users.length; i++) {
            var element = users[i];
            if (!_this6.userIdSet.has(element)) {
              newUsers.push(element);
              ids.push(element.getUserId());
            }
          }
          _this6.renderUserList(newUsers);
          if (!_this6.reviewId) {
            _this6.addReviewConfig4File([_this6.fileInfo.getFileId()], ids, _this6.reviewType, _this6.options);
          } else {
            _this6.updateReviewConfig4File(ids, [], _this6.reviewType, _this6.options);
          }
        }
      });
      win.show();
    }
  }, {
    key: "_clear",
    value: function _clear() {
      var _this7 = this;
      if (this.$('.clear').hasClass("disabled")) {
        return;
      }
      if (!this.reviewId) {
        _MDMessageView["default"].success(BabelStr.str(308), this.msgContainer);
        return;
      }
      _MMEnterpriseController["default"].removeReviewConfig4File(this.reviewId, function () {
        _MDMessageView["default"].success(BabelStr.str(308), _this7.msgContainer);
        _this7.$(".users-list").empty();
        _this7.$(".share-type").removeClass("checked");
        _this7.$(".option-type").removeClass("checked");
        _this7.reviewType = 0;
        _this7.userIdSet.clear();
        _this7.reviewId = undefined;
        _this7.renderOperator();
        _this7.renderClearBtnStatus();
      }, function (code, msg) {
        _MDMessageView["default"].success(msg, _this7.msgContainer);
      });
    }
  }, {
    key: "_checkItemClickHandle",
    value: function _checkItemClickHandle($e) {
      $($e.target).closest(".share-type").toggleClass("checked");
      var $items = this.$(".share-type");
      var reviewType = 0;
      for (var i = 0; i < $items.length; i++) {
        if ($items.eq(i).hasClass("checked")) {
          reviewType = reviewType | Math.pow(2, i);
        }
      }
      if (!this.reviewId) {
        this.addReviewConfig4File([this.fileInfo.getFileId()], [], reviewType, this.options);
      } else {
        this.updateReviewConfig4File([], [], reviewType, this.options);
      }
    }
  }, {
    key: "_optionClickHandle",
    value: function _optionClickHandle($e) {
      $($e.target).closest(".option-type").toggleClass("checked");
      var $items = this.$(".option-type");
      var options = 0;
      if ($items.hasClass("checked")) {
        options = 1;
      }
      if (!this.reviewId) {
        this.addReviewConfig4File([this.fileInfo.getFileId()], [], this.reviewType, options);
      } else {
        this.setReviewConfigOptions(options);
      }
    }
  }, {
    key: "renderClearBtnStatus",
    value: function renderClearBtnStatus() {
      // let $items = this.$(".check-item.checked")
      // let $users = this.$(".users-list .item")
      // if(!$items.length && !$users.length) {
      if (!this.reviewId) {
        this.$('.clear').addClass("disabled");
      } else {
        this.$('.clear').removeClass("disabled");
      }
    }
  }]);
  return MDShareApprovalPageView;
}(_MDTabPanelView2["default"]);

},{"1098":1098,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1417":1417,"1421":1421,"1423":1423,"1437":1437,"1454":1454,"1463":1463,"1475":1475,"1480":1480,"1487":1487,"1538":1538,"200":200,"272":272,"55":55,"637":637,"81":81}],637:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDUsersICanSeePanelView = _interopRequireDefault(require(636));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } //
// 文件可见人员选择
// Created by jichao
// 2024-1-3
var MDUsersICanSeeWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDUsersICanSeeWinView, _MDWindowView);
  function MDUsersICanSeeWinView() {
    (0, _classCallCheck2["default"])(this, MDUsersICanSeeWinView);
    return _callSuper(this, MDUsersICanSeeWinView, arguments);
  }
  (0, _createClass2["default"])(MDUsersICanSeeWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n    <div class=\"content-user-block\"></div>\n    <div class=\"flex-align end btns-block\">\n      <button id=\"js-cancel\" class=\"button default \"><%=BabelStr.str(155)%></button>\n      <button class=\"button done  send-result\"><%=BabelStr.str(154)%></button>\n    </div>";
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        placeholder: BabelStr.str(5610) //选择要提醒的人或直接输入
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUsersICanSeeWinView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUsersICanSeeWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {});
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUsersICanSeeWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .send-result": this._sendResult,
        "click #js-cancel": this.close
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUsersICanSeeWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " icansee-users-win");
    }
  }, {
    key: "initialize",
    value: function initialize(options) {
      options.width = 600;
      options.hasArrow = true;
      options.title = BabelStr.str(5310);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUsersICanSeeWinView.prototype), "initialize", this).call(this, options);
      this.panel = new _MDUsersICanSeePanelView["default"]({
        fileInfo: options.fileInfo
      });
      this.addSubView(this.panel, this.$(".content-user-block"));
    }
  }, {
    key: "_sendResult",
    value: function _sendResult() {
      var users = this.panel.getSelectedUser();
      this.onChoose && this.onChoose(users);
      this.close();
    }
  }]);
  return MDUsersICanSeeWinView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"636":636,"93":93}],636:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1421);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MMViewBase2 = _interopRequireDefault(require(22));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } //
// 文件可见人员选择
// Created by jichao
// 2024-1-3
var MDUsersICanSeePanelView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MDUsersICanSeePanelView, _MMViewBase);
  function MDUsersICanSeePanelView() {
    (0, _classCallCheck2["default"])(this, MDUsersICanSeePanelView);
    return _callSuper(this, MDUsersICanSeePanelView, arguments);
  }
  (0, _createClass2["default"])(MDUsersICanSeePanelView, [{
    key: "tmpl",
    value: function tmpl() {
      return "<div class=\"flex-align with-column \">\n    <input type=\"text\" class=\"no-shrink search search-c\" placeholder=\"<%=placeholder%>\" />\n    <div class=\"col-auto user-list-block\">\n      <ul class=\"list-block\"></ul>\n    </div>\n    </div>";
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        placeholder: BabelStr.str(5310) //选择要提醒的人或直接输入
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUsersICanSeePanelView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUsersICanSeePanelView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        userCollection: new _MDMolaUserCollection["default"](),
        fileInfo: _.noop,
        departArr: []
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUsersICanSeePanelView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "input .search": this._searchInputHandle,
        "click .user-item": this._userItemClickHandle,
        // 'click .dep-title': this._toogleUserBlock,
        "click .select-dep": this._selectDepHandle,
        "click .opt-btn": this._toogleUserBlock
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUsersICanSeePanelView.prototype), "className", this).call(this);
      return "".concat(superCls, " icansee-users");
    }
  }, {
    key: "initialize",
    value: function initialize(options) {
      options.width = 600;
      options.hasArrow = true;
      options.title = BabelStr.str(244);
      this.selectobj = {};
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUsersICanSeePanelView.prototype), "initialize", this).call(this, options);
    }
  }, {
    key: "_toogleUserBlock",
    value: function _toogleUserBlock($e) {
      var $block = this.$($e.target).closest(".depart-block");
      $block.toggleClass("open");
    }
  }, {
    key: "renderUserList",
    value: function renderUserList() {
      var _this = this;
      var result = "";
      _.each(this.departArr, function (depart) {
        var tmpl = "";
        _this.userCollection.each(function (user) {
          var dep = user.get("departments")[0];
          var depId = dep && dep.departmentId;
          if (user.get("searched") && depId == depart.departmentId) {
            var isChecked = user.get("isFocusFile");
            tmpl += '<li class = "user-item ' + (isChecked ? "checked" : "") + '" data-userId="' + user.getUserId() + '">\
                <span class = "checkbox "></span>\
                <img src="" alt="" class = "user-img _user-profile-picture" data-src = "' + user.getAvatarImageURL() + '" />\
                <span class = "user-info text-hide">\
                  <span class = "user-name">' + user.getUserName() + '</span>\
                  <span class = "user-email">' + user.getAccount() + "</span>\
                </span>\
              </li>";
          }
        });
        result += "<div class=\"depart-block open\">\n        <div class=\"dep-title flex-align\">\n          <div class=\"opt-btn\"></div>\n          <div class=\"select-dep\" data-depId=\"".concat(depart.departmentId, "\">").concat(depart.departmentName, "</div>\n        </div>\n        <div class=\"user-list \">").concat(tmpl, "</div>\n\n      </div>");
      });
      this.$(".list-block").html(result);
      this.$(".user-img").imageLoader();
    }
  }, {
    key: "getUsersCanFocusFile",
    value: function getUsersCanFocusFile(belongDepId) {
      var self = this;
      _MDSpinnerloaderView["default"].showIn(this.$(".user-list-block"), {
        autoHeight: false
      });
      var noNeedDepInfo = false;
      var belongDep = null;
      _MMNetDiskDataController["default"].getUsersCanFocusFile(this.fileInfo().getFileId(), noNeedDepInfo, this.fileInfo().getOrganizationInfo(), function (userCollection) {
        self.userCollection = userCollection;
        self.userCollection.each(function (user) {
          var departments = user.get("departments");
          var department;
          if (_.isArray(departments)) {
            department = departments[0];
            var depId = department && department.departmentId;
            if (depId) {
              if (depId != belongDepId) {
                if (!_.findWhere(self.departArr, {
                  departmentId: depId
                })) {
                  self.departArr.unshift(department);
                }
              } else {
                belongDep = department;
              }
            } else {
              if (!_.findWhere(self.departArr, {
                departmentId: null
              })) {
                var titleStr = BabelStr.str(2618);
                if (!app.isEpVersion()) {
                  titleStr = BabelStr.str(6054); //'参与分享的人员'
                }
                self.departArr.push({
                  departmentId: null,
                  departmentName: titleStr
                });
              }
            }
          }
          user.set("searched", true);
        });
        if (belongDep) {
          self.departArr.unshift(belongDep);
        }
        self.oldFocusedUsers = [];
        self.userCollection.each(function (user) {
          var isChecked = user.get("isFocusFile");
          if (isChecked) {
            self.oldFocusedUsers.push(user.getUserId());
          }
        });
        self.renderUserList();
        _MDSpinnerloaderView["default"].clearFrom(self.$(".user-list-block"));
      }, function () {
        _MDSpinnerloaderView["default"].clearFrom(self.$(".user-list-block"));
      });
    }
  }, {
    key: "_userItemClickHandle",
    value: function _userItemClickHandle($e) {
      var $curUserItem = $($e.target).closest(".user-item");
      var userId = $curUserItem.data("userid");
      if ($curUserItem.hasClass("checked")) {
        this.removeFileFocus(userId, $curUserItem);
      } else {
        this.focusFile(userId, $curUserItem);
      }
    }
  }, {
    key: "_selectDepHandle",
    value: function _selectDepHandle($e) {
      var self = this;
      var selectId = $($e.target).data("depid");
      this.selectobj[selectId] = !this.selectobj[selectId];
      this.userCollection.each(function (user) {
        var departments = user.get("departments");
        var department;
        if (_.isArray(departments)) {
          department = departments[0];
          if (!department) {
            console.log(11111);
          }
          var depId = department ? department.departmentId : null;
          if (depId == selectId) {
            if (self.selectobj[selectId]) {
              user.set("isFocusFile", 1);
              self.$(".user-item[data-userid=".concat(user.getUserId(), "]")).addClass("checked");
            } else {
              user.set("isFocusFile", 0);
              self.$(".user-item[data-userid=".concat(user.getUserId(), "]")).removeClass("checked");
            }
          }
        }
      });
    }
  }, {
    key: "removeFileFocus",
    value: function removeFileFocus(userId, $curUserItem) {
      $curUserItem.removeClass("checked");
      this.userCollection.each(function (user) {
        if (user.getUserId() == userId) {
          user.set("isFocusFile", 0);
        }
      });
    }
  }, {
    key: "focusFile",
    value: function focusFile(userId, $curUserItem) {
      $curUserItem.addClass("checked");
      this.userCollection.each(function (user) {
        if (user.getUserId() == userId) {
          user.set("isFocusFile", 1);
        }
      });
    }
  }, {
    key: "_searchInputHandle",
    value: function _searchInputHandle($e) {
      var value = this.$(".search").val();
      var str = "";
      var index = -1;
      this.userCollection.each(function (user) {
        str = user.getUserName() + user.getAccount();
        str = str.toLowerCase();
        value = value.toLowerCase();
        index = str.indexOf(value);
        if (index < 0) {
          user.set("searched", false);
        } else {
          user.set("searched", true);
        }
      });
      this.renderUserList();
    }
  }, {
    key: "getFileBelongDepartment",
    value: function getFileBelongDepartment() {
      var _this2 = this;
      MMEnterpriseController.getFileBelongDepartment(this.fileInfo().getFileId(), function (department) {
        var id = department && department.id || null;
        _this2.getUsersCanFocusFile(id);
      });
    }
  }, {
    key: "getSelectedUser",
    value: function getSelectedUser() {
      var users = [];
      this.userCollection.each(function (user) {
        var isChecked = user.get("isFocusFile");
        if (isChecked) {
          users.push(user);
        }
      });
      return users;
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUsersICanSeePanelView.prototype), "viewDidRendered", this).call(this);
      this.getFileBelongDepartment();
    }
  }]);
  return MDUsersICanSeePanelView;
}(_MMViewBase2["default"]);

},{"1104":1104,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1421":1421,"1454":1454,"1463":1463,"1475":1475,"22":22,"273":273,"76":76}],587:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDTabPanelView = _interopRequireDefault(require(81));
var _MDAddPermissionView = _interopRequireDefault(require(561));
var _MDDepFilePermissionItem = _interopRequireDefault(require(563));
//
// 部门文件附加权限-分组页
// Created by jichao
// 2018.1.15

var MDGroupFilePermissionPageView = _MDTabPanelView["default"].extend({
  // el: '<div class="group--perm-root"></div>',

  tmpl: '<div class = "perm-disp">\
            <div class = "table-root">\
              <div class="table with-layout-fixed f-tc">\
                <div class="head row">\
                  <div class="col-4"><%=user%></div>\
                  <div class="col-4"><%=perm%></div> \
                  <div class="col-4"><%=endTime%></div> \
                </div>\
              </div>  \
            </div>\
            <div class="table-content"></div>\
          </div>\
          <div class="empty flex-align center middle">\
            <span><%=BabelStr.str(7184)%></span>\
          </div>' + "<div class=\"button-group add-content\">\n              <button class=\"button add small done\"><%=BabelStr.str(3193)%></button>\n          </div>\n          <div class=\"group-content\"></div>",
  initProps: function initProps() {
    var superP = _MDTabPanelView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      inWin: false,
      pageSize: 10,
      data: {
        'user': BabelStr.str(577),
        // 用户
        'perm': BabelStr.str(2510),
        // 权限
        'defaultRrole': BabelStr.str(2509),
        'endTime': BabelStr.str(2511)
      }
    });
  },
  className: function className() {
    var superCls = _MDTabPanelView["default"].prototype.className.call(this);
    return "".concat(superCls, " group--perm-root");
  },
  initialize: function initialize(opt) {
    _MDTabPanelView["default"].prototype.initialize.call(this, opt);
    // this.permissionItems = [];
    // this.$('.line').remove();
    // var self = this;

    // MMNetDiskDataController.getAllRoles(function(roleCollection,defId){
    //   self.rolesCol = roleCollection;
    //   self.rolesCol.add(new MDRoleInfo(), {at: 0}); // 把无权限访问放在第一位
    //   self.roleArr = [];
    //   self.originRoleArr =[];
    //   self.rolesCol.each(function(roleInfo){
    //     var roleItem = {
    //       linkRoleId: roleInfo.getRoleId(),
    //       label: roleInfo.getRoleName(),
    //       canSelected: true
    //     };

    //     self.roleArr.push(roleItem);
    //     self.originRoleArr.push(roleItem);
    //   })
    //   self._checkRoleWithFileType();
    // }, function(){
    //   console.log('------------- get roles error!')
    // })

    // this.renderPageBar();
    this.$('.empty').hide();
    this.getGroups();
  },
  events: function events() {
    var superE = _MDTabPanelView["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click .add': this._addClickHandle
    });
  },
  getGroups: function getGroups() {
    var self = this;
    MMEnterpriseController.getGroupsWithoutMember(function (groupInfoArr) {
      console.log(groupInfoArr);
      // if (self.fileInfo == fileInfo) {
      self.groupsArr = groupInfoArr;
      self.$('.perm-disp .add').removeAttr('disabled');
      // };
    }, function () {
      console.error('获取分子失败');
      // MDSpinnerloaderView.clearFrom($el[0]);
      // MDSnackbarView.show(BabelStr.str(309));    // ('获取分组失败')
    });
  },
  _addClickHandle: function _addClickHandle($e) {
    var _this = this;
    this.$(".add").hide();
    this.groupView = new _MDAddPermissionView["default"]({
      addfilePermission: function addfilePermission(data) {
        _this.addfilePermission(data);
      },
      closeCallback: function closeCallback() {
        _this.$(".add").show();
        _this.groupView.remove();
      }
    });
    this.groupView.initByFileInfo(this.fileInfo, this.groupsArr);
    this.addSubView(this.groupView, this.$('.group-content')[0]);
  },
  loadForFile: function loadForFile(fileInfo) {
    var fileInfo = this.fileInfo;
    var self = this;

    // MDSpinnerloaderView.clearFrom(self.$el[0])
    var $el = this.$el;
    // MDSpinnerloaderView.showIn($el[0])

    MMEnterpriseController.getSpecialFilePermission(fileInfo.getFileId(), function (groups) {
      if (groups.length < 1) {
        self.$('.perm-disp').hide();
        self.$('.empty').show();
      }
      self._refresh(groups);
    }, function (codeError) {
      // MDSpinnerloaderView.clearFrom($el[0])
      console.log(BabelStr.str(309)); // ('获取文件权限失败')
    });
    self.$('.perm-disp').show();
  },
  _refresh: function _refresh(data) {
    var _this2 = this;
    this.removeSubViews();
    for (var i = 0; i < data.length; i++) {
      var groupItem = data[i];
      var permissionItem = new _MDDepFilePermissionItem["default"]({
        fileInfo: this.fileInfo,
        data: groupItem,
        roleArr: this.roleArr,
        isUser: false,
        needBasicRoleLine: false,
        deleteCallback: function deleteCallback() {
          if (_this2.$('.table-content .line').length < 2) {
            _this2.$('.empty').show();
            self.$('.perm-disp').hide();
          }
        }
      });
      this.addSubView(permissionItem, this.$('.table-content')[0]);
      // this.$('.table-content').append(permissionItem.$el); 
      // this.permissionItems.push(permissionItem);  
    }
    ;
  },
  addfilePermission: function addfilePermission(data) {
    var _this3 = this;
    this.$('.perm-disp').show();
    this.$('.empty').hide();
    var idStr = '#' + data.id;
    if (this.$('.table-content .line ' + idStr).length > 0) {
      return;
    }
    var permissionItem = new _MDDepFilePermissionItem["default"]({
      fileInfo: this.fileInfo,
      data: data,
      roleArr: this.roleArr,
      isUser: false,
      needBasicRoleLine: false,
      isSilent: false,
      deleteCallback: function deleteCallback() {
        if (_this3.$('.table-content .line').length < 2) {
          _this3.$('.empty').show();
          _this3.$('.perm-disp').hide();
        }
      }
    });
    this.addSubView(permissionItem, this.$('.table-content')[0]);
  },
  _pageChanged: function _pageChanged() {
    console.warn('请求下一页');
  },
  showTable: function showTable() {
    this.$('.perm-disp').show();
  },
  viewDidRendered: function viewDidRendered() {
    _MDTabPanelView["default"].prototype.viewDidRendered.call(this);
    this.loadForFile(this.fileInfo);
  }
});
var _default = exports["default"] = MDGroupFilePermissionPageView;

},{"1184":1184,"1454":1454,"561":561,"563":563,"81":81}],561:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMViewBase = _interopRequireDefault(require(22));
var _MDUserListTabPanel = _interopRequireDefault(require(596));
var _MDGroupListView = _interopRequireDefault(require(588));
/**
 * 增设文件权限
 */
// import MDDepFilePermission from './MDDepFilePermission.js'

var MDAddPermissionView = _MMViewBase["default"].extend({
  tmpl: '<div class="button-zone">\
          <button class="button done small close"><%=cancel%></button>\
        </div>\
        <div class="tab-root app-tab-theme"></div>\
        <div class="add-per-con">\
      </div>',
  initialize: function initialize(opt) {
    var self = this;
    opt.data = _.extend({
      'cancel': BabelStr.str(155) // 取消
    });
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    if (this.inWin) {
      this.$(".button-zone button").html(BabelStr.str(3219)); //("收起");
      this.$el.addClass("pos-ab");
    }
    // this.initByFileInfo(this.fileInfo);  
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      inWin: false
    });
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click .close': this._closeBtnClicked
    });
  },
  _closeBtnClicked: function _closeBtnClicked(e) {
    this.closeCallback();
    this.removeFromSuperView();
  },
  initByFileInfo: function initByFileInfo(fileInfo, groups) {
    var _this = this;
    var self = this;

    // this.callback = callback;

    this.fileInfo = fileInfo;
    if (this.tabview) {
      this.tabview.remove();
    }
    ;

    // this.participantsView = new MDUserListTabPanel({
    //   checkUser: function(userInfo) {
    // self.callback(MDDepFilePermission.userType, userInfo)
    //   },
    // });

    // this.participantsView.setUserList(targetUsers.toJSON());

    this.groupListView = new _MDGroupListView["default"]({
      groupList: groups,
      checkGroup: function checkGroup(group) {
        console.log(group);
        var data = {
          id: group.get('id'),
          name: group.get('groupName'),
          appendedRoleId: 0,
          appendedDeadline: null
        };
        self.addfilePermission(data);
      }
    });

    // var tabs = [{
    //   title: BabelStr.str(575),   // '共享成员',
    //   tabPanelView: this.participantsView
    // }, {
    //   title: BabelStr.str(576),   //  '分组',
    //   tabPanelView: this.groupListView
    // }];

    // this.tabview = new MDTabView({
    //   fullMode: false,
    //   className: 'ep-share',
    //   enableActivebar: false,
    //   tabBarPosition: 0,
    //   tabs: tabs
    // });
    this.addSubView(this.groupListView, this.$(".tab-root")[0]);
    this.groupListView.show();
    this.$('.close').off();
    this.$('.close').on('click', function (e) {
      _this._closeBtnClicked(e);
    });
  }
});
var _default = exports["default"] = MDAddPermissionView;

},{"1184":1184,"1454":1454,"22":22,"588":588,"596":596}],596:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1439);
require(1421);
var _MDParticipantInfo = _interopRequireDefault(require(276));
var _MDParticipantInfoCollection = _interopRequireDefault(require(277));
var _MDTabPanelView = _interopRequireDefault(require(81));
var _MDMolaUser = _interopRequireDefault(require(272));
/**
 *  enterprice share , Frequent Contacts List
 *  Created jiang
 *  2017/6/17
 */

var MDUserListTabPanel = _MDTabPanelView["default"].extend({
  tmpl: '<div class="search-root">' + '<div class="search-box">          <i class="icon-search"></i>          <input type="text" placeholder="<%=placeholder%>...">        </div>' + '</div>' + '<ul class="share-frequent-contacts-list users-list"></ul>',
  initProps: function initProps() {
    var superP = _MDTabPanelView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      userList: [],
      selectedUser: null,
      allParticipantInfoCollection: new _MDParticipantInfoCollection["default"](),
      data: {
        'placeholder': BabelStr.str(579) // 搜索姓名/邮箱
      }
    });
  },
  events: function events() {
    var superE = _MDTabPanelView["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click .item': this.clickUserItemHandle,
      'keyup .search-box input': this._searchHandle
    });
  },
  initialize: function initialize(opt) {
    _MDTabPanelView["default"].prototype.initialize.call(this, opt);
    this.userList = opt.userList ? opt.userList : [];
    this.setUserList(this.userList);
  },
  setUserList: function setUserList(userList) {
    var self = this;
    this.originList = userList;
    this.userList = userList;
    this.initUserList(userList); //molauserCollection只在显示时用到，组件内部数据交互使用MDParticipantInfoCollection
    _.each(userList, function (user) {
      var participantInfo = _MDParticipantInfo["default"].createParticipantInfo({
        id: user["id"],
        type: _MDParticipantInfo["default"].USER_TYPE,
        name: user["name"],
        email: user["originalEmail"],
        phone: user["phone"],
        guest: user["guest"]
      });
      self.allParticipantInfoCollection.add(participantInfo);
    });
  },
  initUserList: function initUserList(userList) {
    var str = "";
    var temp = "";
    if (userList.length > 0) {
      for (var i = 0; i < userList.length; i++) {
        var userInfo = new _MDMolaUser["default"](userList[i]);
        str += userInfo.getUserItemHtmlStr();
      }
      this.$(".share-frequent-contacts-list").html(str);
      this.$(".list-item img").imageLoader();
    } else {
      this.$(".share-frequent-contacts-list").html('<div class="no-right-fre">' + BabelStr.str(7190) + '</div>');
    }
  },
  clickUserItemHandle: function clickUserItemHandle($e) {
    var index = $($e.target).closest(".item").index();
    var user = this.userList[index];
    this.selectedUser = _MDParticipantInfo["default"].createParticipantInfo({
      id: user["id"],
      type: _MDParticipantInfo["default"].USER_TYPE,
      name: user["name"],
      email: user["originalEmail"],
      phone: user["phone"],
      guest: user['guest']
    });
    this.checkUser([this.selectedUser]);
  },
  _searchHandle: function _searchHandle() {
    var key = this.$('.search-box input').val();
    this.userList = [];
    for (var i = 0; i < this.originList.length; i++) {
      var user = this.originList[i];
      if (user["name"].indexOf(key) != -1 || user["originalEmail"].indexOf(key) != -1) {
        this.userList.push(user);
      }
      ;
    }
    ;
    this.initUserList(this.userList);
  }
});
var _default = exports["default"] = MDUserListTabPanel;

},{"1184":1184,"1421":1421,"1439":1439,"1454":1454,"272":272,"276":276,"277":277,"81":81}],588:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1466);
require(1417);
require(1463);
require(1412);
var _MDTabPanelView = _interopRequireDefault(require(81));
var _MDMolaUser = _interopRequireDefault(require(272));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDAccountSettingWindowView = _interopRequireDefault(require(734));
var _MDGroupCollection = _interopRequireDefault(require(259));
/**
 *  enterprice share , Frequent Contacts List
 *  Created jichao
 *  2016/12/17
 */

var MDGroupListView = _MDTabPanelView["default"].extend({
  tmpl: "<div class=\"group-list\">\n            <div class=\"detail-list\">\n              <div class=\"title\"><%=ent_group%>(<span id=\"js-epgroup-num\"><%=epGroup.length%></span>) <span class=\"f-fr text-button done edit\"><%=edit%></span></div>\n                <%if(epGroup.length>0){%>\n                  <%for(var i = 0 ; i < epGroup.length ; i++){\n                      var groupInfo = epGroup[i];\n                    %>\n                    <div class=\"detail-list-item \" gid =\"<%=groupInfo.groupId()%>\"><%=groupInfo.groupName()%></div>\n                  <%}%>\n                <%}else{%>\n                  <div class=\"m-blank-state\"><%=empty%></div>\n                <%}%>\n              </div>\n            <div class=\"detail-list\">\n              <div class=\"title\"><%=pri_group%>(<span id=\"js-person-group-num\"><%=personalGroup.length%></span>) <span class=\"f-fr text-button done edit\"><%=edit%></span></div>\n              <%if(personalGroup.length>0){%>\n                <%\n                  for(var i = 0 ; i < personalGroup.length ; i++){\n                    var groupInfo = personalGroup[i];\n                  %>\n                  <div class = \"detail-list-item \" gid =\"<%=groupInfo.groupId()%>\"><%=groupInfo.groupName()%></div>\n                <%}%>\n              <%}else{%>\n                <div class=\"m-blank-state\"><%=pri_empty%></div>\n              <%}%>\n          </div>\n        </div>",
  initProps: function initProps() {
    var superP = _MDTabPanelView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      groupList: [],
      groupCollection: new _MDGroupCollection["default"](),
      data: {}
    });
  },
  events: function events() {
    var superE = _MDTabPanelView["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click .detail-list-item ': this.clickGroupItemHandle,
      'click .edit': this.clickEditHandle
    });
  },
  initialize: function initialize(opt) {
    _MDTabPanelView["default"].prototype.initialize.call(this, opt);
    this.groupCollection.reset(opt.groupList, true);
    Dispatcher.on(MDEvents.GroupAdded, this._groupAddedHandler, this);
    Dispatcher.on(MDEvents.GroupDeleted, this._groupDeletedHandler, this);
    Dispatcher.on(MDEvents.GroupEdited, this._groupEditedHandler, this);
  },
  render: function render() {
    var epGroup = [],
      personalGroup = [];
    _.each(this.groupList, function (groupInfo) {
      if (groupInfo.belongToEnterprise()) {
        epGroup.push(groupInfo);
      } else {
        personalGroup.push(groupInfo);
      }
    });
    var data = {
      'ent_group': BabelStr.str(580),
      // 企业分组
      'edit': BabelStr.str(581),
      // 编辑分组
      'pri_group': BabelStr.str(2384),
      // 个人分组
      'empty': BabelStr.str(582),
      // 企业分组为空
      'pri_empty': BabelStr.str(583),
      // 个人分组为空
      'epGroup': epGroup,
      'personalGroup': personalGroup
    };
    _MDTabPanelView["default"].prototype.render.call(this, data);
  },
  _groupAddedHandler: function _groupAddedHandler(payload) {
    var groupInfo = payload.groupInfo;
    this.groupCollection.add(groupInfo);
    var $list = this.$('.detail-list').eq(0);
    var num = 0;
    if (groupInfo.belongToEnterprise()) {
      num = this.$('#js-epgroup-num').text();
      num = parseInt(num);
      this.$('#js-epgroup-num').text(num + 1);
    } else {
      $list = this.$('.detail-list').eq(1);
      num = this.$('#js-person-group-num').text();
      num = parseInt(num);
      this.$('#js-person-group-num').text(num + 1);
    }
    $list.find('.m-blank-state').remove();
    $list.append("<div class = \"detail-list-item \" gid =\"".concat(groupInfo.groupId(), "\">").concat(groupInfo.groupName(), "</div>"));
  },
  _groupDeletedHandler: function _groupDeletedHandler(payload) {
    var groupId = payload.groupId;
    var groupInfo = this.groupCollection.find(function (groupInfo) {
      return groupInfo.groupId() == groupId;
    });
    this.groupCollection.remove(groupInfo);
    var num = 0;
    if (groupInfo.belongToEnterprise()) {
      num = this.$('#js-epgroup-num').text();
      num = parseInt(num) - 1;
      this.$('#js-epgroup-num').text(num);
      if (num == 0) {
        this.$('.detail-list').eq(0).append("<div class=\"m-blank-state\">".concat(BabelStr.str(7185), "</div>"));
      }
    } else {
      num = this.$('#js-person-group-num').text();
      num = parseInt(num) - 1;
      this.$('#js-person-group-num').text(num);
      if (num == 0) {
        this.$('.detail-list').eq(1).append("<div class=\"m-blank-state\">".concat(BabelStr.str(7186), "</div>"));
      }
    }
    this.$(".detail-list-item[gid=".concat(groupInfo.groupId(), "]")).remove();
  },
  _groupEditedHandler: function _groupEditedHandler(payload) {
    var groupId = payload.groupId;
    var groupName = payload.groupName;
    var groupInfo = this.groupCollection.find(function (groupInfo) {
      return groupInfo.groupId() == groupId;
    });
    this.$(".detail-list-item[gid=".concat(groupInfo.groupId(), "]")).text(groupName);
  },
  clickGroupItemHandle: function clickGroupItemHandle($e) {
    var groupId = $($e.target).closest(".detail-list-item").attr('gid');
    for (var i = 0; i < this.groupCollection.length; i++) {
      var group = this.groupCollection.at(i);
      if (group.groupId() == groupId && this.checkGroup) {
        this.checkGroup(group);
      }
      ;
    }
    ;
  },
  clickEditHandle: function clickEditHandle(e) {
    var settingWindow = new _MDAccountSettingWindowView["default"]();
    settingWindow.activeEditGroup();
    settingWindow.show();
  }
});
var _default = exports["default"] = MDGroupListView;

},{"1184":1184,"1412":1412,"1417":1417,"1454":1454,"1463":1463,"1466":1466,"259":259,"272":272,"32":32,"734":734,"81":81}],734:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDAccountSettingNavPageView = _interopRequireDefault(require(733));
var _MDNavigationWindowView = _interopRequireDefault(require(92));
/**
 * 账户设置窗口
 * Created by manjun.han
 * 2017.3.3
 */

var MDAccountSettingWindowView = _MDNavigationWindowView["default"].extend({
  className: function className() {
    var superCls = _MDNavigationWindowView["default"].prototype.className.call(this);
    return superCls + ' account-setting-window';
  },
  initProps: function initProps() {
    var superP = _MDNavigationWindowView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      width: 750,
      title: BabelStr.str(5),
      showFooter: false
    });
  },
  initialize: function initialize(opts) {
    this.rootNavigationPageView = new _MDAccountSettingNavPageView["default"]();
    opts.rootNavigationPageView = this.rootNavigationPageView;
    _MDNavigationWindowView["default"].prototype.initialize.call(this, opts);
    Dispatcher.on(MDEvents.CloseSettingWin, this.close, this);
  },
  activeEditGroup: function activeEditGroup() {
    this.rootNavigationPageView.activeEditGroup();
  },
  viewDidUnRendered: function viewDidUnRendered() {
    _MDNavigationWindowView["default"].prototype.viewDidUnRendered.call(this);
    this.callback && this.callback();
  }
});
var _default = exports["default"] = MDAccountSettingWindowView;

},{"1184":1184,"1454":1454,"733":733,"92":92}],733:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDAllGroupShowView = _interopRequireDefault(require(738));
var _MDInitializePwdNavPageView = _interopRequireDefault(require(749));
var _MDNoticeSetTabPanelView = _interopRequireDefault(require(750));
var _MDSigSettingTabPanel = _interopRequireDefault(require(760));
var _MDChangePwdTabPanelView = _interopRequireDefault(require(741));
var _MDAccountTabPanelView = _interopRequireDefault(require(735));
var _TabBarPosition = _interopRequireDefault(require(84));
var _MDTabView = _interopRequireDefault(require(82));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDDeviceManagePanelView = _interopRequireDefault(require(746));
var _MDEmailSettingPanelView = _interopRequireDefault(require(747));
var _MDFileAddPerSettingPanelView = _interopRequireDefault(require(748));
var _MDOneGroupNavWinView = _interopRequireDefault(require(752));
var _LazyAITokenPanelView = _interopRequireDefault(require(731));
var _MDSealedFileVerifyTabPanelView = _interopRequireDefault(require(758));
var _MDAPISecretTabPanelView = _interopRequireDefault(require(771));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // import MDGroupManageTabPanelView from './MDGroupManageTabPanelView.js';
//
// 账户设置navpage
// Created by manjun.han
// 2017.5.28
//
var MDAccountSettingNavPageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDAccountSettingNavPageView, _MDNavigationPageView);
  function MDAccountSettingNavPageView() {
    (0, _classCallCheck2["default"])(this, MDAccountSettingNavPageView);
    return _callSuper(this, MDAccountSettingNavPageView, arguments);
  }
  (0, _createClass2["default"])(MDAccountSettingNavPageView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<div class=\"tab-container\"></div>\n    <div class='version-info'>\n      <div><%=BabelStr.str(282)%></div>\n      <div><%=window.appVersion%></div>\n    </div>";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAccountSettingNavPageView.prototype), "className", this).call(this);
      return "".concat(superCls, " account-nav-page");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAccountSettingNavPageView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        title: BabelStr.str(5)
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAccountSettingNavPageView.prototype), "initialize", this).call(this, props);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAccountSettingNavPageView.prototype), "viewDidRendered", this).call(this);
      var hasPwd = false;
      var pwdPanel = new _MDChangePwdTabPanelView["default"]();
      if (!hasPwd) {
        pwdPanel = new _MDInitializePwdNavPageView["default"]();
      }
      var accountCap = _MDLocalString["default"].getLocalString(2300); // 账户信息
      var passCap = _MDLocalString["default"].getLocalString(2301); // 密码设置
      var notiCap = _MDLocalString["default"].getLocalString(2302); // 通知设置
      var groupCap = _MDLocalString["default"].getLocalString(3008); // 分组管理
      var eamil = _MDLocalString["default"].getLocalString(2602);
      var tabArr = [{
        title: function title() {
          return '<i class="icon ic-act-setting"></i>' + accountCap;
        },
        tabPanelView: new _MDAccountTabPanelView["default"](),
        active: true
      }, {
        title: function title() {
          return '<i class="icon ic-pwd-setting"></i>' + passCap;
        },
        tabPanelView: new _MDChangePwdTabPanelView["default"]()
      }];
      if (window.supportAI) {
        tabArr.push({
          title: function title() {
            return '<i class="icon icon30 ic-token-setting"></i>' + BabelStr.str(13000);
          },
          tabPanelView: new _LazyAITokenPanelView["default"]()
        });
      }
      // if(app.isEpVersion() && app.ep.getSendMail()) {
      if (app.isEpVersion()) {
        tabArr.push({
          title: function title() {
            return '<i class="icon ic-noti-setting"></i>' + notiCap;
          },
          tabPanelView: new _MDNoticeSetTabPanelView["default"]()
        });
      }
      tabArr.push({
        title: function title() {
          return '<i class="icon bs-icon ic-api-secret icon30"></i>' + BabelStr.str(50000);
        },
        tabPanelView: new _MDAPISecretTabPanelView["default"]()
      });
      if (app.isEpVersion() && !app.currentUser.isEnterpriseGuest()) {
        var tab = {
          title: function title() {
            return '<i class="icon ic-grp-setting"></i>' + groupCap;
          },
          tabPanelView: new _MDAllGroupShowView["default"]()
        };
        tabArr.push(tab);
      }
      var device = {
        title: function title() {
          return '<i class="icon ic-dev-setting"></i>' + BabelStr.str(2562);
        },
        tabPanelView: new _MDDeviceManagePanelView["default"]()
      };
      tabArr.push(device);
      if (app.isEpVersion() && !app.currentUser.isEnterpriseGuest()) {
        var eamilSetting = {
          title: function title() {
            return '<i class="icon email-set"></i>' + eamil;
          },
          tabPanelView: new _MDEmailSettingPanelView["default"]()
        };
        tabArr.push(eamilSetting);
        var fileSetting = {
          title: function title() {
            return '<i class="icon add-per-set"></i>' + BabelStr.str(2621);
          },
          tabPanelView: new _MDFileAddPerSettingPanelView["default"]()
        };
        tabArr.push(fileSetting);
      }

      // ------------------------------------------------------------ 收集签名
      if (app.isEpVersion()) {
        tabArr.push({
          title: function title() {
            return '<i class="icon icon30 ic-sig-setting sig-set"></i>' + BabelStr.str(5000);
          },
          tabPanelView: new _MDSigSettingTabPanel["default"]()
        });
        tabArr.push({
          title: function title() {
            return '<i class="icon icon30 ic-seal-setting sig-set"></i>' + BabelStr.str(11328);
          },
          tabPanelView: new _MDSealedFileVerifyTabPanelView["default"]()
        });
      }
      this.settingTabView = new _MDTabView["default"]({
        className: 'setting-tabs',
        enableActivebar: false,
        tabBarPosition: _TabBarPosition["default"].LEFT,
        tabs: tabArr
      });
      this.addSubView(this.settingTabView, this.$('.tab-containe')[0]);
    }
  }, {
    key: "activeEditGroup",
    value: function activeEditGroup() {
      this.settingTabView.activeTabAt(3);
    }
  }]);
  return MDAccountSettingNavPageView;
}(_MDNavigationPageView2["default"]);

},{"1150":1150,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"56":56,"731":731,"735":735,"738":738,"741":741,"746":746,"747":747,"748":748,"749":749,"750":750,"752":752,"758":758,"760":760,"771":771,"82":82,"84":84}],771:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationView = _interopRequireDefault(require(57));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
var _MDAPISecretPanelView = _interopRequireDefault(require(768));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDAPISecretTabPanelView = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(MDAPISecretTabPanelView, _MDTabPanelView);
  function MDAPISecretTabPanelView() {
    (0, _classCallCheck2["default"])(this, MDAPISecretTabPanelView);
    return _callSuper(this, MDAPISecretTabPanelView, arguments);
  }
  (0, _createClass2["default"])(MDAPISecretTabPanelView, [{
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAPISecretTabPanelView.prototype), "className", this).call(this);
      return "".concat(superCls, " api-secret-tab-panel");
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAPISecretTabPanelView.prototype), "initialize", this).call(this, props);
      // let view = new MDAPISecretPanelRootView({

      // })
      // this.addSubView(view)
      this.navView = new _MDNavigationView["default"]({
        animateNavigate: true,
        showNavigationBar: true,
        cls: "api-secret-nav-root",
        rootNavigationPageView: new _MDAPISecretPanelView["default"]()
      });
      this.addSubView(this.navView);
    }
  }]);
  return MDAPISecretTabPanelView;
}(_MDTabPanelView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"57":57,"768":768,"81":81}],768:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1439);
require(1437);
require(1417);
require(1463);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDAPISecretCreatePageView = _interopRequireDefault(require(767));
var _menusvg = _interopRequireDefault(require(1119));
var _MDCommonListPopupView = _interopRequireDefault(require(62));
var _popupPos = _interopRequireDefault(require(65));
var _MDAPISecretRenameWinView = _interopRequireDefault(require(770));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDAPISecretPopupView = _interopRequireDefault(require(769));
var _MDAPIAgentInfoPageView = _interopRequireDefault(require(766));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDAPISecretPanelView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDAPISecretPanelView, _MDNavigationPageView);
  function MDAPISecretPanelView() {
    (0, _classCallCheck2["default"])(this, MDAPISecretPanelView);
    return _callSuper(this, MDAPISecretPanelView, arguments);
  }
  (0, _createClass2["default"])(MDAPISecretPanelView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<div class=\"header flex-align middle between mgb-15\">\n      <div class=\"title-name boldfont\"><%=BabelStr.str(50000)%></div>\n      <div class=\"flex-align middle gap-10\">\n        <div class=\"about-secret flex-align middle\">\n          ".concat(_menusvg["default"].menu_doc, "\n          <span class=\"name\"><%=BabelStr.str(50001)%></span>\n\n        </div>\n        <span class=\"create-secret flex-align middle\">\n          ").concat(_menusvg["default"].menu_key, "\n          <span class=\"name\"><%=BabelStr.str(50002)%></span>\n        </span>\n      </div>\n    </div>\n    <div class=\"pro-block\">\n      <div class=\"table-header line-item\">\n        <div class=\"line-secret f-hide\"><%=BabelStr.str(50003)%></div>\n        <div class=\"line-name \"><%=BabelStr.str(50004)%></div>\n        <div class=\"line-time f-tc\"><%=BabelStr.str(3048)%></div>\n        <div class=\"opts\"></div>\n      </div>\n      <div class=\"pro-list\"></div>\n    </div>\n    <div class=\"empty\">\n      <div class=\"empty-content\">\n        <div class=\"flex-align center\">\n          <div class=\"new-icon ic-secret-empty\"></div>\n        </div>\n        <div class=\"f-tc boldfont2\"><%=BabelStr.str(50013)%></div>\n        <div class=\"help-block\"><%=BabelStr.str(50014)%></div>\n        <div class=\"flex-align center\">\n          <div class=\"text-button done about-secret\"><%=BabelStr.str(50015)%></div>\n        </div>\n      </div>\n    </div>\n\n    ");
    }
  }, {
    key: "proItem",
    value: function proItem(data) {
      return "<div class=\" line-item\" data-id=\"".concat(data.id, "\">\n    <div class=\"line-secret f-hide\">\n      <div class=\"text-button done secret text-hide\">").concat(data.id, "</div>\n      \n    </div>\n    <div class=\"line-name flex-align with-column\">\n      <span class=\"text-button done app-name text-hide\">").concat(data.name, "</span>\n    </div>\n    <div class=\"line-time f-tc\">").concat(data.time, "</div>\n    <div class=\"opts flex-align middle end\">\n      <div class=\"more\">").concat(_menusvg["default"].menu_more, "</div>\n    </div>\n  </div>");
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAPISecretPanelView.prototype), "className", this).call(this);
      return "".concat(superCls, " api-secret-nav-page");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAPISecretPanelView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .about-secret": this._openAboutDoc,
        "click .create-secret": this._createSecret,
        "click .more": this._showMore,
        "click .secret": this._showSecret,
        "click .app-name": this._showInfo
      });
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAPISecretPanelView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        showNavigationBar: false
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAPISecretPanelView.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "_openAboutDoc",
    value: function _openAboutDoc() {
      window.open("https://www.babel.cc/public/babelwiki/zh/mcp-integration.html", "_blank");
    }
  }, {
    key: "_createSecret",
    value: function _createSecret() {
      var pageView = new _MDAPISecretCreatePageView["default"]();
      this.getNavigationView().push(pageView);
    }
  }, {
    key: "renderPro",
    value: function renderPro(datas) {
      var _this = this;
      _MMEnterpriseController["default"].listMcpApp(function (datas) {
        _.each(datas, function (data) {
          data.time = new Date(data.datetime).format("yyyy-MM-dd");
          data.type = data.fileId == 0 ? 1 : 0;
        });
        _this.originDatas = datas;
        if (datas.length) {
          _this.$(".empty").addClass("f-hide");
        } else {
          _this.$(".empty").removeClass("f-hide");
        }
        _this.$(".pro-list").empty();
        _.each(datas, function (data) {
          var item = _this.proItem(data);
          _this.$(".pro-list").append(item);
        });
      });
      // datas = [{
      //   id: 0,
      //   sercet: "Alza1...DWnrs",
      //   type: 0,
      //   name: "我的测试",
      //   time: new Date().format("yyyy-MM-dd")

      // },{
      //   id: 1,
      //   sercet: "next",
      //   type: 1,
      //   name: "我的测试2",
      //   time: new Date().format("yyyy-MM-dd")

      // }]
    }
  }, {
    key: "_showMore",
    value: function _showMore($e) {
      var _this2 = this;
      var $btn = $($e.target);
      var $item = $btn.closest(".line-item");
      this.menuPop = _MDCommonListPopupView["default"].show({
        triggerView: $btn,
        direction: _popupPos["default"].BOTTOM_RIGHT,
        width: 160,
        elCls: "with-top-after secret-manage-list",
        items: [BabelStr.str(50025), BabelStr.str(50026)],
        mouseleave: function mouseleave($e) {
          // this.menuPop.close()
          // this.menuPop = undefined
        },
        onItemClicked: function onItemClicked(index) {
          if (index == 0) {
            _this2.showRename($item, $e);
            // this.ctl.openUploadWindow();
          } else {
            _this2.delItem($item);
            // this.ctl.openUploadFolderWindow();
          }
        }
      });
    }
  }, {
    key: "_showSecret",
    value: function _showSecret($e) {
      var $btn = $($e.target);
      var $item = $btn.closest(".line-item");
      var id = $item.data("id");
      var data = _.find(this.originDatas, function (data) {
        return data.id == id;
      });
      if (!data) {
        console.error("怎么没找到");
      }
      _MDAPISecretPopupView["default"].show({
        triggerView: $btn,
        direction: _popupPos["default"].TOP_LEFT,
        secretData: data,
        $container: this.getNavigationView().$el
      });
    }
  }, {
    key: "_showInfo",
    value: function _showInfo($e) {
      var $item = $($e.target).closest(".line-item");
      var id = $item.data("id");
      var data = _.find(this.originDatas, function (data) {
        return data.id == id;
      });
      if (!data) {
        console.error("怎么没找到");
      }
      var view = new _MDAPIAgentInfoPageView["default"]({
        secretData: data
      });
      this.getNavigationView().push(view);
    }
  }, {
    key: "showRename",
    value: function showRename($item, $e) {
      var _this3 = this;
      var id = $item.data("id");
      var win = new _MDAPISecretRenameWinView["default"]({
        mcp_id: id,
        success: function success() {
          var data = {};
          data.name = "修改后的名称";
          $item.find(".app-name").html(data.name);
          _this3._showInfo($e);
        }
      });
      win.show();
    }
  }, {
    key: "delItem",
    value: function delItem($item) {
      var _this4 = this;
      var id = $item.data("id");
      console.log("要删除：" + id);
      _MDAlertView["default"].showStandardSelection({
        message: BabelStr.str(50027),
        okFun: function okFun() {
          _MMEnterpriseController["default"].deleteMcpApp(id, function () {
            MDMessageView.success(BabelStr.str(308), _this4.getNavigationView().$el);
            $item.remove();
            if (!_this4.$(".pro-list .line-item").length) {
              _this4.$(".empty").removeClass("f-hide");
            }
          }, function (err) {
            MDMessageView.success(err.msg, _this4.getNavigationView().$el);
          });
        }
      });
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAPISecretPanelView.prototype), "viewDidRendered", this).call(this);
      console.log("viewDidRendered");
      this.renderPro();
      console.log("刷新列表");
    }
  }]);
  return MDAPISecretPanelView;
}(_MDNavigationPageView2["default"]);

},{"1098":1098,"1119":1119,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1417":1417,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"32":32,"56":56,"62":62,"65":65,"766":766,"767":767,"769":769,"770":770}],1119:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var menuSvg = {
  menu_show_more: "<svg width=\"7\" height=\"11\" viewBox=\"0 0 7 11\">\n    <path d=\"M0.11 10v-10l6 5z\" fill=\"currentColor\"/>\n  </svg>",
  // 属性搜索：三列数据/属性圆点 + 竖线层叠结构（数据字段隐喻），与右侧"三条横线"搜索范围完全区分
  menu_attr_search: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18px\" height=\"18px\" viewBox=\"0 0 18 18\" fill=\"currentColor\">\n    <rect x=\"2\" y=\"2\" width=\"14\" height=\"14\" rx=\"3\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.4\"/>\n    <rect x=\"5\" y=\"5.2\" width=\"8\" height=\"1.4\" rx=\"0.7\"/>\n    <rect x=\"5\" y=\"8.3\" width=\"5.6\" height=\"1.4\" rx=\"0.7\"/>\n    <rect x=\"5\" y=\"11.4\" width=\"6.8\" height=\"1.4\" rx=\"0.7\"/>\n  </svg>",
  // 标签删除：细线条描边 ×，14px 尺寸，圆角端点避免换色亚像素抖动
  menu_close_small: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14px\" height=\"14px\" viewBox=\"0 0 14 14\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.2\" stroke-linecap=\"round\">\n    <line x1=\"3.5\" y1=\"3.5\" x2=\"10.5\" y2=\"10.5\"/>\n    <line x1=\"10.5\" y1=\"3.5\" x2=\"3.5\" y2=\"10.5\"/>\n  </svg>",
  menu_open_type: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n  <g transform=\"translate(-115.000000, -96.000000)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n  <g transform=\"translate(115.257850, 96.232597)\">\n  <path d=\"M 8.47 15.083 C 8.444 15.083 8.419 15.083 8.396 15.082 C 7.419 15.051 6.589 14.432 6.283 13.506 L 5.236 10.354 C 5.169 10.154 5.011 9.995 4.81 9.928 L 1.577 8.855 C .657 8.55 .04 7.725 .002 6.758 C-.036 5.789 .518 4.921 1.411 4.546 L 11.8 .185 C 12.674 -.181 13.635 .005 14.308 .669 C 14.983 1.334 15.182 2.293 14.826 3.169 L 10.602 13.642 C 10.247 14.524 9.415 15.083 8.47 15.083 Z M 7.829 12.992 C 7.966 13.405 8.336 13.449 8.446 13.452 C 8.56 13.449 8.928 13.436 9.09 13.032 L 13.316 2.56 C 13.471 2.173 13.24 1.903 13.164 1.829 C 13.091 1.755 12.816 1.526 12.432 1.688 L 2.043 6.049 C 1.644 6.217 1.626 6.585 1.631 6.695 C 1.635 6.805 1.682 7.171 2.091 7.307 L 5.323 8.38 C 6.008 8.608 6.553 9.154 6.783 9.84 L 7.829 12.992 L 7.829 12.992 Z\" fill=\"currentColor\"/>\n  </g>\n  </g>\n  </svg>",
  menu_online_edit: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n\n  <path d=\"M 10.836 .596 C 10.886 .596 10.933 .615 10.969 .651 L 14.085 3.769 C 14.102 3.786 14.116 3.807 14.126 3.829 C 14.135 3.852 14.14 3.876 14.14 3.901 C 14.14 3.925 14.135 3.95 14.126 3.972 C 14.116 3.995 14.102 4.016 14.085 4.033 L 6.137 11.981 C 6.111 12.009 6.075 12.026 6.037 12.034 L 2.884 12.587 C 2.846 12.592 2.809 12.596 2.771 12.596 C 2.604 12.596 2.449 12.531 2.325 12.411 C 2.252 12.339 2.198 12.25 2.168 12.153 C 2.137 12.056 2.131 11.952 2.149 11.852 L 2.702 8.698 C 2.709 8.661 2.726 8.627 2.754 8.599 L 10.703 .651 C 10.738 .615 10.785 .596 10.836 .596 Z M 10.836 2.527 L 4.035 9.326 L 3.743 10.995 L 5.409 10.701 L 12.21 3.902 L 10.836 2.527 Z M 14.439 14.171 L .639 14.171 C .308 14.171 .039 14.47 .039 14.84 L .039 15.592 C .039 15.684 .107 15.759 .189 15.759 L 14.889 15.759 C 14.972 15.759 15.039 15.684 15.039 15.592 L 15.039 14.84 C 15.039 14.47 14.771 14.171 14.439 14.171 Z\" fill=\"currentColor\"/>\n\n  </svg>",
  menu_edit: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n  <g transform=\"translate(0.500243, 1.000000)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n            <path d=\"M 14 11.286 C 14.553 11.286 15 11.743 15 12.306 L 15 12.98 C 15 13.543 14.553 14 14 14 L 8.016 14 C 7.586 14 7.237 13.644 7.237 13.205 C 7.237 12.994 7.319 12.792 7.466 12.643 L 8.502 11.585 C 8.69 11.394 8.944 11.286 9.209 11.286 L 14 11.286 Z M 8.738 1.663 C 8.789 1.663 8.836 1.683 8.872 1.719 L 12.002 4.915 C 12.02 4.933 12.034 4.954 12.043 4.978 C 12.053 5.001 12.057 5.026 12.057 5.051 C 12.057 5.076 12.053 5.101 12.043 5.125 C 12.034 5.147 12.02 5.169 12.002 5.187 L 4.017 13.335 C 3.991 13.363 3.955 13.381 3.917 13.388 L .749 13.955 C .711 13.961 .674 13.965 .636 13.965 C .468 13.965 .312 13.898 .188 13.774 C .115 13.701 .06 13.61 .03 13.51 C-.001 13.41 -.008 13.305 .011 13.202 L .566 9.968 C .574 9.931 .591 9.896 .619 9.866 L 8.604 1.719 C 8.64 1.683 8.687 1.663 8.738 1.663 Z M 8.738 3.643 L 1.906 10.612 L 1.612 12.323 L 3.286 12.021 L 10.119 5.052 L 8.738 3.643 Z M 11.361 .299 L 13.394 2.374 C 13.784 2.772 13.784 3.419 13.394 3.817 L 12.534 4.694 L 9.086 1.177 C 9.373 .884 9.66 .591 9.946 .299 C 10.337 -.1 10.97 -.1 11.361 .299 Z\" fill=\"currentColor\"/>\n        </g>\n\n</svg>",
  menu_preview: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n <g transform=\"translate(0.000000, 2.545412)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n<path d=\"M 8 2.182 C 6.197 2.182 4.728 3.651 4.728 5.454 C 4.728 7.258 6.197 8.728 8 8.728 C 9.803 8.728 11.272 7.258 11.272 5.454 C 11.272 3.651 9.803 2.182 8 2.182 Z M 8 7.418 C 6.917 7.418 6.037 6.538 6.037 5.454 C 6.037 4.371 6.917 3.491 8 3.491 C 9.083 3.491 9.963 4.371 9.963 5.454 C 9.963 6.538 9.083 7.418 8 7.418 Z\" fill=\"currentColor\"/>\n            <path d=\"M 8 0 C 4.363 0 1.258 2.262 0 5.454 C 1.258 8.648 4.363 10.909 8 10.909 C 11.637 10.909 14.742 8.648 16 5.454 C 14.742 2.262 11.637 0 8 0 Z M 8 9.454 C 5.272 9.464 2.778 7.909 1.586 5.454 C 2.786 3.003 5.243 1.454 8 1.454 C 10.757 1.454 13.214 3.003 14.414 5.454 C 13.222 7.909 10.728 9.464 8 9.454 L 8 9.454 Z\" fill=\"currentColor\"/>\n        </g>\n\n</svg>",
  menu_survey_form: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n  <path d=\"M 2 9.5 C 2 9.224 2.224 9 2.5 9 L 4.5 9 C 4.776 9 5 9.224 5 9.5 L 5 13.5 C 5 13.776 4.776 14 4.5 14 L 2.5 14 C 2.224 14 2 13.776 2 13.5 Z M 6 5.5 C 6 5.224 6.224 5 6.5 5 C 6.776 5 7 5.224 7 5.5 L 7 13.5 C 7 13.776 6.776 14 6.5 14 C 6.224 14 6 13.776 6 13.5 Z M 10 2.5 C 10 2.224 10.224 2 10.5 2 C 10.776 2 11 2.224 11 2.5 L 11 13.5 C 11 13.776 10.776 14 10.5 14 C 10.224 14 10 13.776 10 13.5 Z M 14 6.5 C 14 6.224 14.224 6 14.5 6 C 14.776 6 15 6.224 15 6.5 L 15 13.5 C 15 13.776 14.776 14 14.5 14 C 14.224 14 14 13.776 14 13.5 Z\" fill=\"currentColor\"/>\n  </svg>",
  menu_local_read: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n <g transform=\"translate(0.000000, 0.000000) fill=\"currentColor\"\">\n                <path d=\"M 1.392 9.826 L 1.392 12.905 C 1.392 13.846 2.154 14.608 3.095 14.608 L 6.174 14.608 L 6.174 16 L 3.095 16 C 1.386 16 0 14.614 0 12.905 L 0 9.826 L 1.392 9.826 Z M 16 9.826 L 16 12.905 C 16 14.614 14.614 16 12.905 16 L 9.826 16 L 9.826 14.608 L 12.905 14.608 C 13.846 14.608 14.608 13.846 14.608 12.905 L 14.608 9.826 L 16 9.826 Z M 8 4 C 10.667 4 12.944 5.659 13.867 8 C 12.944 10.341 10.667 12 8 12 C 5.333 12 3.056 10.341 2.133 8 C 3.056 5.659 5.333 4 8 4 Z M 8 5.067 C 5.979 5.067 4.176 6.203 3.296 8 C 4.171 9.8 5.999 10.94 8 10.933 C 10.001 10.94 11.829 9.8 12.704 8 C 11.824 6.203 10.021 5.067 8 5.067 Z M 8 5.6 C 9.323 5.6 10.4 6.677 10.4 8 C 10.4 9.323 9.323 10.4 8 10.4 C 6.677 10.4 5.6 9.323 5.6 8 C 5.6 6.677 6.677 5.6 8 5.6 Z M 8 6.56 C 7.205 6.56 6.56 7.205 6.56 8 C 6.56 8.795 7.205 9.44 8 9.44 C 8.795 9.44 9.44 8.795 9.44 8 C 9.44 7.205 8.795 6.56 8 6.56 Z M 6.174 0 L 6.174 1.392 L 3.095 1.392 C 2.154 1.392 1.392 2.154 1.392 3.095 L 1.392 6.174 L 0 6.174 L 0 3.095 C 0 1.386 1.386 0 3.095 0 L 6.174 0 Z M 12.905 0 C 14.614 0 16 1.386 16 3.095 L 16 6.174 L 14.608 6.174 L 14.608 3.095 C 14.608 2.154 13.846 1.392 12.905 1.392 L 9.826 1.392 L 9.826 0 L 12.905 0 Z\" fill=\"currentColor\"/>\n            </g>\n</svg>",
  menu_batch_edit_classify: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16 \" fill=\"currentColor\" >\n <path d=\"M12.8,0 C14.5674667,0 16,1.43253333 16,3.2 L16,12.8 C16,14.5674667 14.5674667,16 12.8,16 L3.2,16 C1.4336,16 3.18263934e-16,14.5674667 3.18263934e-16,12.8 L3.18263934e-16,3.2 C3.18263934e-16,1.43253333 1.4336,0 3.2,0 L12.8,0 Z M12.8,1.6 L3.2,1.6 C2.3168,1.6 1.6,2.3168 1.6,3.2 L1.6,12.8 C1.6,13.6832 2.3168,14.4 3.2,14.4 L12.8,14.4 C13.6842667,14.4 14.4,13.6832 14.4,12.8 L14.4,3.2 C14.4,2.3168 13.6842667,1.6 12.8,1.6 Z M10.4618667,7.9904 C11.0976,7.9904 11.7077333,8.2432 12.1589333,8.69333333 C12.608,9.14346667 12.8618667,9.7536 12.8618667,10.3904 C12.8618667,11.0272 12.608,11.6373333 12.1589333,12.0874667 C11.7077333,12.5376 11.0976,12.7904 10.4618667,12.7904 C9.82506667,12.7904 9.21386667,12.5376 8.7648,12.0874667 C8.45866667,11.7813333 8.24426667,11.4016 8.1376,10.9909333 L3.86133333,10.9909333 C3.46133333,10.9909333 3.26186667,10.7904 3.26186667,10.3904 C3.26186667,9.9904 3.46133333,9.78986667 3.86133333,9.78986667 L8.1376,9.78986667 C8.24426667,9.3792 8.45866667,8.99946667 8.7648,8.69333333 C9.21386667,8.2432 9.82506667,7.9904 10.4618667,7.9904 Z M10.4618667,9.1904 C10.1429333,9.1904 9.83786667,9.31733333 9.6128,9.5424 C9.38773333,9.7664 9.26186667,10.0725333 9.26186667,10.3904 C9.26186667,10.7082667 9.38773333,11.0144 9.6128,11.2394667 C9.83786667,11.4634667 10.1429333,11.5904 10.4618667,11.5904 C10.7797333,11.5904 11.0848,11.4634667 11.3098667,11.2394667 C11.5349333,11.0144 11.6608,10.7082667 11.6608,10.3904 C11.6608,10.0725333 11.5349333,9.7664 11.3098667,9.5424 C11.0848,9.31733333 10.7797333,9.1904 10.4618667,9.1904 Z M5.5392,3.2096 C6.176,3.2096 6.78613333,3.4624 7.23626667,3.91253333 C7.5424,4.21866667 7.7568,4.5984 7.86346667,5.00906667 L12.1397333,5.00906667 C12.5397333,5.00906667 12.7392,5.2096 12.7392,5.6096 C12.7392,6.0096 12.5397333,6.20906667 12.1397333,6.20906667 L7.86346667,6.20906667 C7.7568,6.6208 7.5424,7.00053333 7.23626667,7.30666667 C6.78613333,7.7568 6.176,8.0096 5.5392,8.0096 C4.90346667,8.0096 4.29226667,7.7568 3.84213333,7.30666667 C3.392,6.85653333 3.1392,6.2464 3.1392,5.6096 C3.1392,4.9728 3.392,4.36266667 3.84213333,3.91253333 C4.29226667,3.4624 4.90346667,3.2096 5.5392,3.2096 Z M5.5392,4.4096 C5.22133333,4.4096 4.91626667,4.53546667 4.6912,4.76053333 C4.46613333,4.9856 4.3392,5.29173333 4.3392,5.6096 C4.3392,5.92746667 4.46613333,6.23253333 4.6912,6.4576 C4.91626667,6.68266667 5.22133333,6.8096 5.5392,6.8096 C5.85813333,6.8096 6.1632,6.68266667 6.38826667,6.4576 C6.61333333,6.23253333 6.7392,5.92746667 6.7392,5.6096 C6.7392,5.29173333 6.61333333,4.9856 6.38826667,4.76053333 C6.1632,4.53546667 5.85813333,4.4096 5.5392,4.4096 Z\" />\n</svg>",
  menu_batch_edit_library: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" fill=\"currentColor\">\n <path d=\"M12.8,0 C14.5674667,0 16,1.43253333 16,3.2 L16,12.8 C16,14.5674667 14.5674667,16 12.8,16 L3.2,16 C1.4336,16 3.18263934e-16,14.5674667 3.18263934e-16,12.8 L3.18263934e-16,3.2 C3.18263934e-16,1.43253333 1.4336,0 3.2,0 L12.8,0 Z M12.8,1.6 L3.2,1.6 C2.3168,1.6 1.6,2.3168 1.6,3.2 L1.6,12.8 C1.6,13.6832 2.3168,14.4 3.2,14.4 L12.8,14.4 C13.6842667,14.4 14.4,13.6832 14.4,12.8 L14.4,3.2 C14.4,2.3168 13.6842667,1.6 12.8,1.6 Z M10.4618667,7.9904 C11.0976,7.9904 11.7077333,8.2432 12.1589333,8.69333333 C12.608,9.14346667 12.8618667,9.7536 12.8618667,10.3904 C12.8618667,11.0272 12.608,11.6373333 12.1589333,12.0874667 C11.7077333,12.5376 11.0976,12.7904 10.4618667,12.7904 C9.82506667,12.7904 9.21386667,12.5376 8.7648,12.0874667 C8.45866667,11.7813333 8.24426667,11.4016 8.1376,10.9909333 L3.86133333,10.9909333 C3.46133333,10.9909333 3.26186667,10.7904 3.26186667,10.3904 C3.26186667,9.9904 3.46133333,9.78986667 3.86133333,9.78986667 L8.1376,9.78986667 C8.24426667,9.3792 8.45866667,8.99946667 8.7648,8.69333333 C9.21386667,8.2432 9.82506667,7.9904 10.4618667,7.9904 Z M10.4618667,9.1904 C10.1429333,9.1904 9.83786667,9.31733333 9.6128,9.5424 C9.38773333,9.7664 9.26186667,10.0725333 9.26186667,10.3904 C9.26186667,10.7082667 9.38773333,11.0144 9.6128,11.2394667 C9.83786667,11.4634667 10.1429333,11.5904 10.4618667,11.5904 C10.7797333,11.5904 11.0848,11.4634667 11.3098667,11.2394667 C11.5349333,11.0144 11.6608,10.7082667 11.6608,10.3904 C11.6608,10.0725333 11.5349333,9.7664 11.3098667,9.5424 C11.0848,9.31733333 10.7797333,9.1904 10.4618667,9.1904 Z M5.5392,3.2096 C6.176,3.2096 6.78613333,3.4624 7.23626667,3.91253333 C7.5424,4.21866667 7.7568,4.5984 7.86346667,5.00906667 L12.1397333,5.00906667 C12.5397333,5.00906667 12.7392,5.2096 12.7392,5.6096 C12.7392,6.0096 12.5397333,6.20906667 12.1397333,6.20906667 L7.86346667,6.20906667 C7.7568,6.6208 7.5424,7.00053333 7.23626667,7.30666667 C6.78613333,7.7568 6.176,8.0096 5.5392,8.0096 C4.90346667,8.0096 4.29226667,7.7568 3.84213333,7.30666667 C3.392,6.85653333 3.1392,6.2464 3.1392,5.6096 C3.1392,4.9728 3.392,4.36266667 3.84213333,3.91253333 C4.29226667,3.4624 4.90346667,3.2096 5.5392,3.2096 Z M5.5392,4.4096 C5.22133333,4.4096 4.91626667,4.53546667 4.6912,4.76053333 C4.46613333,4.9856 4.3392,5.29173333 4.3392,5.6096 C4.3392,5.92746667 4.46613333,6.23253333 4.6912,6.4576 C4.91626667,6.68266667 5.22133333,6.8096 5.5392,6.8096 C5.85813333,6.8096 6.1632,6.68266667 6.38826667,6.4576 C6.61333333,6.23253333 6.7392,5.92746667 6.7392,5.6096 C6.7392,5.29173333 6.61333333,4.9856 6.38826667,4.76053333 C6.1632,4.53546667 5.85813333,4.4096 5.5392,4.4096 Z\" />\n</svg>",
  menu_edit_classify: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" fill=\"currentColor\">\n <path d=\"M12.8,0 C14.5674667,0 16,1.43253333 16,3.2 L16,12.8 C16,14.5674667 14.5674667,16 12.8,16 L3.2,16 C1.4336,16 3.18263934e-16,14.5674667 3.18263934e-16,12.8 L3.18263934e-16,3.2 C3.18263934e-16,1.43253333 1.4336,0 3.2,0 L12.8,0 Z M12.8,1.6 L3.2,1.6 C2.3168,1.6 1.6,2.3168 1.6,3.2 L1.6,12.8 C1.6,13.6832 2.3168,14.4 3.2,14.4 L12.8,14.4 C13.6842667,14.4 14.4,13.6832 14.4,12.8 L14.4,3.2 C14.4,2.3168 13.6842667,1.6 12.8,1.6 Z M10.4618667,7.9904 C11.0976,7.9904 11.7077333,8.2432 12.1589333,8.69333333 C12.608,9.14346667 12.8618667,9.7536 12.8618667,10.3904 C12.8618667,11.0272 12.608,11.6373333 12.1589333,12.0874667 C11.7077333,12.5376 11.0976,12.7904 10.4618667,12.7904 C9.82506667,12.7904 9.21386667,12.5376 8.7648,12.0874667 C8.45866667,11.7813333 8.24426667,11.4016 8.1376,10.9909333 L3.86133333,10.9909333 C3.46133333,10.9909333 3.26186667,10.7904 3.26186667,10.3904 C3.26186667,9.9904 3.46133333,9.78986667 3.86133333,9.78986667 L8.1376,9.78986667 C8.24426667,9.3792 8.45866667,8.99946667 8.7648,8.69333333 C9.21386667,8.2432 9.82506667,7.9904 10.4618667,7.9904 Z M10.4618667,9.1904 C10.1429333,9.1904 9.83786667,9.31733333 9.6128,9.5424 C9.38773333,9.7664 9.26186667,10.0725333 9.26186667,10.3904 C9.26186667,10.7082667 9.38773333,11.0144 9.6128,11.2394667 C9.83786667,11.4634667 10.1429333,11.5904 10.4618667,11.5904 C10.7797333,11.5904 11.0848,11.4634667 11.3098667,11.2394667 C11.5349333,11.0144 11.6608,10.7082667 11.6608,10.3904 C11.6608,10.0725333 11.5349333,9.7664 11.3098667,9.5424 C11.0848,9.31733333 10.7797333,9.1904 10.4618667,9.1904 Z M5.5392,3.2096 C6.176,3.2096 6.78613333,3.4624 7.23626667,3.91253333 C7.5424,4.21866667 7.7568,4.5984 7.86346667,5.00906667 L12.1397333,5.00906667 C12.5397333,5.00906667 12.7392,5.2096 12.7392,5.6096 C12.7392,6.0096 12.5397333,6.20906667 12.1397333,6.20906667 L7.86346667,6.20906667 C7.7568,6.6208 7.5424,7.00053333 7.23626667,7.30666667 C6.78613333,7.7568 6.176,8.0096 5.5392,8.0096 C4.90346667,8.0096 4.29226667,7.7568 3.84213333,7.30666667 C3.392,6.85653333 3.1392,6.2464 3.1392,5.6096 C3.1392,4.9728 3.392,4.36266667 3.84213333,3.91253333 C4.29226667,3.4624 4.90346667,3.2096 5.5392,3.2096 Z M5.5392,4.4096 C5.22133333,4.4096 4.91626667,4.53546667 4.6912,4.76053333 C4.46613333,4.9856 4.3392,5.29173333 4.3392,5.6096 C4.3392,5.92746667 4.46613333,6.23253333 4.6912,6.4576 C4.91626667,6.68266667 5.22133333,6.8096 5.5392,6.8096 C5.85813333,6.8096 6.1632,6.68266667 6.38826667,6.4576 C6.61333333,6.23253333 6.7392,5.92746667 6.7392,5.6096 C6.7392,5.29173333 6.61333333,4.9856 6.38826667,4.76053333 C6.1632,4.53546667 5.85813333,4.4096 5.5392,4.4096 Z\" />\n</svg>",
  menu_edit_library: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" fill=\"currentColor\">\n <path d=\"M12.8,0 C14.5674667,0 16,1.43253333 16,3.2 L16,12.8 C16,14.5674667 14.5674667,16 12.8,16 L3.2,16 C1.4336,16 3.18263934e-16,14.5674667 3.18263934e-16,12.8 L3.18263934e-16,3.2 C3.18263934e-16,1.43253333 1.4336,0 3.2,0 L12.8,0 Z M12.8,1.6 L3.2,1.6 C2.3168,1.6 1.6,2.3168 1.6,3.2 L1.6,12.8 C1.6,13.6832 2.3168,14.4 3.2,14.4 L12.8,14.4 C13.6842667,14.4 14.4,13.6832 14.4,12.8 L14.4,3.2 C14.4,2.3168 13.6842667,1.6 12.8,1.6 Z M10.4618667,7.9904 C11.0976,7.9904 11.7077333,8.2432 12.1589333,8.69333333 C12.608,9.14346667 12.8618667,9.7536 12.8618667,10.3904 C12.8618667,11.0272 12.608,11.6373333 12.1589333,12.0874667 C11.7077333,12.5376 11.0976,12.7904 10.4618667,12.7904 C9.82506667,12.7904 9.21386667,12.5376 8.7648,12.0874667 C8.45866667,11.7813333 8.24426667,11.4016 8.1376,10.9909333 L3.86133333,10.9909333 C3.46133333,10.9909333 3.26186667,10.7904 3.26186667,10.3904 C3.26186667,9.9904 3.46133333,9.78986667 3.86133333,9.78986667 L8.1376,9.78986667 C8.24426667,9.3792 8.45866667,8.99946667 8.7648,8.69333333 C9.21386667,8.2432 9.82506667,7.9904 10.4618667,7.9904 Z M10.4618667,9.1904 C10.1429333,9.1904 9.83786667,9.31733333 9.6128,9.5424 C9.38773333,9.7664 9.26186667,10.0725333 9.26186667,10.3904 C9.26186667,10.7082667 9.38773333,11.0144 9.6128,11.2394667 C9.83786667,11.4634667 10.1429333,11.5904 10.4618667,11.5904 C10.7797333,11.5904 11.0848,11.4634667 11.3098667,11.2394667 C11.5349333,11.0144 11.6608,10.7082667 11.6608,10.3904 C11.6608,10.0725333 11.5349333,9.7664 11.3098667,9.5424 C11.0848,9.31733333 10.7797333,9.1904 10.4618667,9.1904 Z M5.5392,3.2096 C6.176,3.2096 6.78613333,3.4624 7.23626667,3.91253333 C7.5424,4.21866667 7.7568,4.5984 7.86346667,5.00906667 L12.1397333,5.00906667 C12.5397333,5.00906667 12.7392,5.2096 12.7392,5.6096 C12.7392,6.0096 12.5397333,6.20906667 12.1397333,6.20906667 L7.86346667,6.20906667 C7.7568,6.6208 7.5424,7.00053333 7.23626667,7.30666667 C6.78613333,7.7568 6.176,8.0096 5.5392,8.0096 C4.90346667,8.0096 4.29226667,7.7568 3.84213333,7.30666667 C3.392,6.85653333 3.1392,6.2464 3.1392,5.6096 C3.1392,4.9728 3.392,4.36266667 3.84213333,3.91253333 C4.29226667,3.4624 4.90346667,3.2096 5.5392,3.2096 Z M5.5392,4.4096 C5.22133333,4.4096 4.91626667,4.53546667 4.6912,4.76053333 C4.46613333,4.9856 4.3392,5.29173333 4.3392,5.6096 C4.3392,5.92746667 4.46613333,6.23253333 4.6912,6.4576 C4.91626667,6.68266667 5.22133333,6.8096 5.5392,6.8096 C5.85813333,6.8096 6.1632,6.68266667 6.38826667,6.4576 C6.61333333,6.23253333 6.7392,5.92746667 6.7392,5.6096 C6.7392,5.29173333 6.61333333,4.9856 6.38826667,4.76053333 C6.1632,4.53546667 5.85813333,4.4096 5.5392,4.4096 Z\" />\n</svg>",
  menu_edit_depart: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" fill=\"currentColor\">\n <path d=\"M12.8,0 C14.5674667,0 16,1.43253333 16,3.2 L16,12.8 C16,14.5674667 14.5674667,16 12.8,16 L3.2,16 C1.4336,16 3.18263934e-16,14.5674667 3.18263934e-16,12.8 L3.18263934e-16,3.2 C3.18263934e-16,1.43253333 1.4336,0 3.2,0 L12.8,0 Z M12.8,1.6 L3.2,1.6 C2.3168,1.6 1.6,2.3168 1.6,3.2 L1.6,12.8 C1.6,13.6832 2.3168,14.4 3.2,14.4 L12.8,14.4 C13.6842667,14.4 14.4,13.6832 14.4,12.8 L14.4,3.2 C14.4,2.3168 13.6842667,1.6 12.8,1.6 Z M10.4618667,7.9904 C11.0976,7.9904 11.7077333,8.2432 12.1589333,8.69333333 C12.608,9.14346667 12.8618667,9.7536 12.8618667,10.3904 C12.8618667,11.0272 12.608,11.6373333 12.1589333,12.0874667 C11.7077333,12.5376 11.0976,12.7904 10.4618667,12.7904 C9.82506667,12.7904 9.21386667,12.5376 8.7648,12.0874667 C8.45866667,11.7813333 8.24426667,11.4016 8.1376,10.9909333 L3.86133333,10.9909333 C3.46133333,10.9909333 3.26186667,10.7904 3.26186667,10.3904 C3.26186667,9.9904 3.46133333,9.78986667 3.86133333,9.78986667 L8.1376,9.78986667 C8.24426667,9.3792 8.45866667,8.99946667 8.7648,8.69333333 C9.21386667,8.2432 9.82506667,7.9904 10.4618667,7.9904 Z M10.4618667,9.1904 C10.1429333,9.1904 9.83786667,9.31733333 9.6128,9.5424 C9.38773333,9.7664 9.26186667,10.0725333 9.26186667,10.3904 C9.26186667,10.7082667 9.38773333,11.0144 9.6128,11.2394667 C9.83786667,11.4634667 10.1429333,11.5904 10.4618667,11.5904 C10.7797333,11.5904 11.0848,11.4634667 11.3098667,11.2394667 C11.5349333,11.0144 11.6608,10.7082667 11.6608,10.3904 C11.6608,10.0725333 11.5349333,9.7664 11.3098667,9.5424 C11.0848,9.31733333 10.7797333,9.1904 10.4618667,9.1904 Z M5.5392,3.2096 C6.176,3.2096 6.78613333,3.4624 7.23626667,3.91253333 C7.5424,4.21866667 7.7568,4.5984 7.86346667,5.00906667 L12.1397333,5.00906667 C12.5397333,5.00906667 12.7392,5.2096 12.7392,5.6096 C12.7392,6.0096 12.5397333,6.20906667 12.1397333,6.20906667 L7.86346667,6.20906667 C7.7568,6.6208 7.5424,7.00053333 7.23626667,7.30666667 C6.78613333,7.7568 6.176,8.0096 5.5392,8.0096 C4.90346667,8.0096 4.29226667,7.7568 3.84213333,7.30666667 C3.392,6.85653333 3.1392,6.2464 3.1392,5.6096 C3.1392,4.9728 3.392,4.36266667 3.84213333,3.91253333 C4.29226667,3.4624 4.90346667,3.2096 5.5392,3.2096 Z M5.5392,4.4096 C5.22133333,4.4096 4.91626667,4.53546667 4.6912,4.76053333 C4.46613333,4.9856 4.3392,5.29173333 4.3392,5.6096 C4.3392,5.92746667 4.46613333,6.23253333 4.6912,6.4576 C4.91626667,6.68266667 5.22133333,6.8096 5.5392,6.8096 C5.85813333,6.8096 6.1632,6.68266667 6.38826667,6.4576 C6.61333333,6.23253333 6.7392,5.92746667 6.7392,5.6096 C6.7392,5.29173333 6.61333333,4.9856 6.38826667,4.76053333 C6.1632,4.53546667 5.85813333,4.4096 5.5392,4.4096 Z\" />\n</svg>",
  menu_edit_project: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" fill=\"currentColor\">\n <path d=\"M12.8,0 C14.5674667,0 16,1.43253333 16,3.2 L16,12.8 C16,14.5674667 14.5674667,16 12.8,16 L3.2,16 C1.4336,16 3.18263934e-16,14.5674667 3.18263934e-16,12.8 L3.18263934e-16,3.2 C3.18263934e-16,1.43253333 1.4336,0 3.2,0 L12.8,0 Z M12.8,1.6 L3.2,1.6 C2.3168,1.6 1.6,2.3168 1.6,3.2 L1.6,12.8 C1.6,13.6832 2.3168,14.4 3.2,14.4 L12.8,14.4 C13.6842667,14.4 14.4,13.6832 14.4,12.8 L14.4,3.2 C14.4,2.3168 13.6842667,1.6 12.8,1.6 Z M10.4618667,7.9904 C11.0976,7.9904 11.7077333,8.2432 12.1589333,8.69333333 C12.608,9.14346667 12.8618667,9.7536 12.8618667,10.3904 C12.8618667,11.0272 12.608,11.6373333 12.1589333,12.0874667 C11.7077333,12.5376 11.0976,12.7904 10.4618667,12.7904 C9.82506667,12.7904 9.21386667,12.5376 8.7648,12.0874667 C8.45866667,11.7813333 8.24426667,11.4016 8.1376,10.9909333 L3.86133333,10.9909333 C3.46133333,10.9909333 3.26186667,10.7904 3.26186667,10.3904 C3.26186667,9.9904 3.46133333,9.78986667 3.86133333,9.78986667 L8.1376,9.78986667 C8.24426667,9.3792 8.45866667,8.99946667 8.7648,8.69333333 C9.21386667,8.2432 9.82506667,7.9904 10.4618667,7.9904 Z M10.4618667,9.1904 C10.1429333,9.1904 9.83786667,9.31733333 9.6128,9.5424 C9.38773333,9.7664 9.26186667,10.0725333 9.26186667,10.3904 C9.26186667,10.7082667 9.38773333,11.0144 9.6128,11.2394667 C9.83786667,11.4634667 10.1429333,11.5904 10.4618667,11.5904 C10.7797333,11.5904 11.0848,11.4634667 11.3098667,11.2394667 C11.5349333,11.0144 11.6608,10.7082667 11.6608,10.3904 C11.6608,10.0725333 11.5349333,9.7664 11.3098667,9.5424 C11.0848,9.31733333 10.7797333,9.1904 10.4618667,9.1904 Z M5.5392,3.2096 C6.176,3.2096 6.78613333,3.4624 7.23626667,3.91253333 C7.5424,4.21866667 7.7568,4.5984 7.86346667,5.00906667 L12.1397333,5.00906667 C12.5397333,5.00906667 12.7392,5.2096 12.7392,5.6096 C12.7392,6.0096 12.5397333,6.20906667 12.1397333,6.20906667 L7.86346667,6.20906667 C7.7568,6.6208 7.5424,7.00053333 7.23626667,7.30666667 C6.78613333,7.7568 6.176,8.0096 5.5392,8.0096 C4.90346667,8.0096 4.29226667,7.7568 3.84213333,7.30666667 C3.392,6.85653333 3.1392,6.2464 3.1392,5.6096 C3.1392,4.9728 3.392,4.36266667 3.84213333,3.91253333 C4.29226667,3.4624 4.90346667,3.2096 5.5392,3.2096 Z M5.5392,4.4096 C5.22133333,4.4096 4.91626667,4.53546667 4.6912,4.76053333 C4.46613333,4.9856 4.3392,5.29173333 4.3392,5.6096 C4.3392,5.92746667 4.46613333,6.23253333 4.6912,6.4576 C4.91626667,6.68266667 5.22133333,6.8096 5.5392,6.8096 C5.85813333,6.8096 6.1632,6.68266667 6.38826667,6.4576 C6.61333333,6.23253333 6.7392,5.92746667 6.7392,5.6096 C6.7392,5.29173333 6.61333333,4.9856 6.38826667,4.76053333 C6.1632,4.53546667 5.85813333,4.4096 5.5392,4.4096 Z\" />\n</svg>",
  menu_edit_team: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" fill=\"currentColor\">\n <path d=\"M12.8,0 C14.5674667,0 16,1.43253333 16,3.2 L16,12.8 C16,14.5674667 14.5674667,16 12.8,16 L3.2,16 C1.4336,16 3.18263934e-16,14.5674667 3.18263934e-16,12.8 L3.18263934e-16,3.2 C3.18263934e-16,1.43253333 1.4336,0 3.2,0 L12.8,0 Z M12.8,1.6 L3.2,1.6 C2.3168,1.6 1.6,2.3168 1.6,3.2 L1.6,12.8 C1.6,13.6832 2.3168,14.4 3.2,14.4 L12.8,14.4 C13.6842667,14.4 14.4,13.6832 14.4,12.8 L14.4,3.2 C14.4,2.3168 13.6842667,1.6 12.8,1.6 Z M10.4618667,7.9904 C11.0976,7.9904 11.7077333,8.2432 12.1589333,8.69333333 C12.608,9.14346667 12.8618667,9.7536 12.8618667,10.3904 C12.8618667,11.0272 12.608,11.6373333 12.1589333,12.0874667 C11.7077333,12.5376 11.0976,12.7904 10.4618667,12.7904 C9.82506667,12.7904 9.21386667,12.5376 8.7648,12.0874667 C8.45866667,11.7813333 8.24426667,11.4016 8.1376,10.9909333 L3.86133333,10.9909333 C3.46133333,10.9909333 3.26186667,10.7904 3.26186667,10.3904 C3.26186667,9.9904 3.46133333,9.78986667 3.86133333,9.78986667 L8.1376,9.78986667 C8.24426667,9.3792 8.45866667,8.99946667 8.7648,8.69333333 C9.21386667,8.2432 9.82506667,7.9904 10.4618667,7.9904 Z M10.4618667,9.1904 C10.1429333,9.1904 9.83786667,9.31733333 9.6128,9.5424 C9.38773333,9.7664 9.26186667,10.0725333 9.26186667,10.3904 C9.26186667,10.7082667 9.38773333,11.0144 9.6128,11.2394667 C9.83786667,11.4634667 10.1429333,11.5904 10.4618667,11.5904 C10.7797333,11.5904 11.0848,11.4634667 11.3098667,11.2394667 C11.5349333,11.0144 11.6608,10.7082667 11.6608,10.3904 C11.6608,10.0725333 11.5349333,9.7664 11.3098667,9.5424 C11.0848,9.31733333 10.7797333,9.1904 10.4618667,9.1904 Z M5.5392,3.2096 C6.176,3.2096 6.78613333,3.4624 7.23626667,3.91253333 C7.5424,4.21866667 7.7568,4.5984 7.86346667,5.00906667 L12.1397333,5.00906667 C12.5397333,5.00906667 12.7392,5.2096 12.7392,5.6096 C12.7392,6.0096 12.5397333,6.20906667 12.1397333,6.20906667 L7.86346667,6.20906667 C7.7568,6.6208 7.5424,7.00053333 7.23626667,7.30666667 C6.78613333,7.7568 6.176,8.0096 5.5392,8.0096 C4.90346667,8.0096 4.29226667,7.7568 3.84213333,7.30666667 C3.392,6.85653333 3.1392,6.2464 3.1392,5.6096 C3.1392,4.9728 3.392,4.36266667 3.84213333,3.91253333 C4.29226667,3.4624 4.90346667,3.2096 5.5392,3.2096 Z M5.5392,4.4096 C5.22133333,4.4096 4.91626667,4.53546667 4.6912,4.76053333 C4.46613333,4.9856 4.3392,5.29173333 4.3392,5.6096 C4.3392,5.92746667 4.46613333,6.23253333 4.6912,6.4576 C4.91626667,6.68266667 5.22133333,6.8096 5.5392,6.8096 C5.85813333,6.8096 6.1632,6.68266667 6.38826667,6.4576 C6.61333333,6.23253333 6.7392,5.92746667 6.7392,5.6096 C6.7392,5.29173333 6.61333333,4.9856 6.38826667,4.76053333 C6.1632,4.53546667 5.85813333,4.4096 5.5392,4.4096 Z\" />\n</svg>",
  menu_apply_classify: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" fill=\"currentColor\">\n<g transform=\"translate(0.000000, 0.241852)\">\n                <path d=\"M 15.902 10.658 C 16.118 11.049 15.964 11.536 15.56 11.744 L 8.432 15.422 C 8.19 15.547 7.9 15.548 7.658 15.424 L .443 11.746 C .038 11.539 -.118 11.054 .096 10.661 C .308 10.269 .809 10.117 1.214 10.324 L 8.041 13.804 L 14.783 10.325 C 15.186 10.117 15.688 10.265 15.902 10.658 Z M 15.878 7.314 C 16.094 7.706 15.944 8.193 15.542 8.403 L 8.384 12.149 C 8.14 12.277 7.846 12.277 7.601 12.149 L .443 8.403 C .041 8.193 -.109 7.706 .107 7.314 C .324 6.924 .826 6.778 1.228 6.988 L 7.993 10.53 L 14.759 6.988 C 15.16 6.778 15.662 6.924 15.878 7.314 Z M 8.403 .094 L 15.366 3.209 C 15.906 3.45 16.148 4.084 15.907 4.624 C 15.809 4.843 15.639 5.023 15.426 5.135 L 8.462 8.785 C 8.149 8.948 7.776 8.948 7.463 8.781 L .578 5.133 C .056 4.856 -.143 4.208 .134 3.684 C .245 3.475 .423 3.308 .638 3.21 L 7.523 .095 C 7.802 -.031 8.122 -.032 8.403 .094 Z M 7.964 1.658 L 2.295 4.224 L 7.968 7.229 L 13.702 4.224 L 7.964 1.658 Z\" fill=\"currentColor\"/>\n            </g>\n</svg>",
  menu_apply_library: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" fill=\"currentColor\">\n<path d=\"M12.8,0 C14.5674667,0 16,1.43253333 16,3.2 L16,12.8 C16,14.5674667 14.5674667,16 12.8,16 L3.2,16 C1.43253333,16 0,14.5674667 0,12.8 L0,3.2 C0,1.43253333 1.43253333,0 3.2,0 L12.8,0 Z M9.824,7.70026667 L5.4336,12.0917333 C4.94826667,12.5770667 4.18026667,12.6101333 3.65653333,12.1888 L3.5488,12.0917333 L1.6,10.1429333 L1.6,12.8 C1.6,13.6832 2.3168,14.4 3.2,14.4 L12.8,14.4 C13.6832,14.4 14.4,13.6832 14.4,12.8 L14.4,12.2762667 L9.824,7.70026667 Z M12.8,1.6 L3.2,1.6 C2.3168,1.6 1.6,2.3168 1.6,3.2 L1.6,7.88053333 L4.49173333,10.7712 L8.88213333,6.3808 C9.40266667,5.86026667 10.2464,5.86026667 10.7669333,6.3808 L14.4,10.0138667 L14.4,3.2 C14.4,2.3168 13.6832,1.6 12.8,1.6 Z\" id=\"Shape\"/></svg>",
  menu_apply_download: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" fill=\"currentColor\">\n\n\n            <g transform=\"translate(0.105209, 0.500000)\">\n                <path d=\"M 15 10.263 C 15.436 10.263 15.79 10.617 15.79 11.053 L 15.79 13.421 C 15.79 14.507 15.296 15 14.211 15 L 1.579 15 C .493 15 0 14.507 0 13.421 L 0 11.053 C 0 10.617 .353 10.263 .789 10.263 C 1.225 10.263 1.579 10.617 1.579 11.053 L 1.579 13.421 L 14.211 13.421 L 14.211 11.053 C 14.211 10.617 14.564 10.263 15 10.263 Z M 7.895 0 C 8.331 0 8.684 .353 8.684 .789 L 8.684 8.356 L 9.442 7.6 C 9.722 7.319 10.161 7.294 10.47 7.523 L 10.558 7.6 C 10.867 7.908 10.867 8.408 10.558 8.716 L 8.453 10.821 C 8.427 10.847 8.399 10.871 8.37 10.894 L 8.453 10.821 C 8.417 10.858 8.378 10.89 8.337 10.917 C 8.32 10.929 8.302 10.94 8.283 10.951 C 8.268 10.959 8.253 10.967 8.237 10.975 C 8.218 10.984 8.199 10.992 8.179 11 C 8.168 11.004 8.157 11.008 8.146 11.012 C 8.123 11.019 8.1 11.026 8.076 11.032 C 8.063 11.035 8.051 11.037 8.038 11.04 C 8.017 11.044 7.995 11.047 7.973 11.049 C 7.957 11.05 7.941 11.051 7.926 11.052 C 7.916 11.052 7.905 11.053 7.895 11.053 L 7.865 11.052 C 7.849 11.051 7.833 11.05 7.816 11.049 L 7.895 11.053 C 7.845 11.053 7.797 11.048 7.75 11.039 C 7.739 11.037 7.727 11.035 7.714 11.032 C 7.69 11.026 7.666 11.019 7.643 11.012 C 7.633 11.008 7.622 11.004 7.611 11 C 7.59 10.992 7.571 10.984 7.552 10.975 C 7.537 10.967 7.521 10.959 7.506 10.951 C 7.488 10.94 7.47 10.929 7.452 10.917 C 7.441 10.91 7.43 10.902 7.42 10.894 C 7.39 10.871 7.362 10.847 7.336 10.821 L 5.231 8.716 C 4.923 8.408 4.923 7.908 5.231 7.6 C 5.54 7.291 6.039 7.291 6.348 7.6 L 7.105 8.357 L 7.105 .789 C 7.105 .353 7.459 0 7.895 0 Z\" fill=\"currentColor\"/>\n            </g>\n\n\n</svg>",
  //部门审批流程设置
  menu_manage_dep_eval: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" fill=\"currentColor\">\n <path d=\"M8,0 C12.416,0 16,3.584 16,8 C16,12.416 12.416,16 8,16 C3.584,16 -3.25665421e-16,12.416 -3.25665421e-16,8 C-3.25665421e-16,3.584 3.584,0 8,0 Z M8,1.6 C4.47146667,1.6 1.6,4.47146667 1.6,8 C1.6,11.5274667 4.47146667,14.4 8,14.4 C11.5274667,14.4 14.4,11.5274667 14.4,8 C14.4,4.47146667 11.5274667,1.6 8,1.6 Z M12.0021333,5.27253333 C12.3306667,5.568 12.3573333,6.0736 12.0608,6.40213333 L7.2608,11.7354667 C6.95466667,12.0757333 6.4256,12.0896 6.10133333,11.7653333 L3.968,9.632 C3.65546667,9.31946667 3.65546667,8.81386667 3.968,8.50133333 C4.28053333,8.1888 4.78613333,8.1888 5.09866667,8.50133333 L6.63573333,10.0373333 L10.8725333,5.3312 C11.168,5.00266667 11.6736,4.976 12.0021333,5.27253333 Z\" id=\"Shape\"/>\n</svg>",
  //转交项目
  menu_transform_project: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" fill=\"currentColor\">\n            <path d=\"M 10.244 .592 C 10.5 .228 11 .141 11.364 .396 L 14.41 2.541 C 15.052 2.994 14.733 4.004 13.947 4.004 L 2.947 4.004 C 2.207 4.004 1.607 4.604 1.607 5.345 L 1.607 6.953 C 1.607 7.397 1.248 7.758 .804 7.758 C .36 7.758 0 7.397 0 6.953 L 0 5.345 C 0 3.716 1.32 2.395 2.947 2.395 L 11.408 2.395 L 10.439 1.712 C 10.109 1.48 10.007 1.044 10.183 .693 L 10.244 .592 Z M 5.757 15.408 C 5.501 15.771 5 15.859 4.637 15.603 L 1.591 13.458 C .949 13.007 1.268 11.996 2.054 11.996 L 13.053 11.996 C 13.794 11.996 14.393 11.396 14.393 10.656 L 14.393 9.047 C 14.393 8.603 14.753 8.243 15.196 8.243 C 15.641 8.243 16 8.603 16 9.047 L 16 10.656 C 16 12.285 14.681 13.605 13.053 13.605 L 4.592 13.605 L 5.562 14.288 C 5.892 14.52 5.994 14.956 5.818 15.306 L 5.757 15.408 Z\" fill=\"currentColor\"/>\n</svg>",
  //文件权限控制
  menu_manage_file_per: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" fill=\"currentColor\">\n                <path d=\"M12.8,2.96059473e-17 C14.5674667,2.96059473e-17 16,1.43253333 16,3.2 L16,12.8 C16,14.5664 14.5674667,16 12.8,16 L3.2,16 C1.43253333,16 -3.25665421e-16,14.5664 -3.25665421e-16,12.8 L-3.25665421e-16,3.2 C-3.25665421e-16,1.43253333 1.43253333,2.96059473e-17 3.2,2.96059473e-17 L12.8,2.96059473e-17 Z M12.8,1.6 L3.2,1.6 C2.3168,1.6 1.6,2.31573333 1.6,3.2 L1.6,12.8 C1.6,13.6832 2.3168,14.4 3.2,14.4 L12.8,14.4 C13.6832,14.4 14.4,13.6832 14.4,12.8 L14.4,3.2 C14.4,2.31573333 13.6832,1.6 12.8,1.6 Z M5.5264,10.6666667 C4.05333333,10.6666667 2.85973333,9.472 2.85973333,8 C2.85973333,6.52693333 4.05333333,5.33333333 5.5264,5.33333333 C6.9984,5.33333333 8.19306667,6.52693333 8.19306667,8 L9.58293333,8 L9.584,6.16426667 L10.6506667,6.16426667 L10.6496,8 L11.7045333,8 L11.7045333,5.70346667 L12.7712,5.70346667 L12.7712,9.06666667 L7.97013333,9.06666667 C7.5584,10.0085333 6.61866667,10.6666667 5.5264,10.6666667 Z M5.5264,6.4 C4.64213333,6.4 3.9264,7.11573333 3.9264,8 C3.9264,8.8832 4.64213333,9.6 5.5264,9.6 C6.4096,9.6 7.1264,8.8832 7.1264,8 C7.1264,7.11573333 6.4096,6.4 5.5264,6.4 Z\" id=\"Shape\"/>\n</svg>",
  // 文控项目（直接显示）
  // 文控发送文件

  menu_send_file: "\n<svg width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"Artboard\" fill=\"currentColor\" fill-rule=\"nonzero\">\n            <g id=\"Group\" transform=\"translate(0.000000, 0.622565)\">\n                <path d=\"M10.9213975,6.01705831 C11.1880456,6.26722278 11.2239219,6.66961912 11.0222389,6.96147767 L10.9543649,7.04486583 L6.8984037,11.3606878 L7.06711927,12.5387879 L7.12723631,12.5126079 C7.35219041,12.4301894 7.61011192,12.4631568 7.80888602,12.6115101 L7.89033491,12.6813235 C8.14922605,12.9402146 8.17249716,13.3435806 7.96111788,13.6286517 L7.89033491,13.7101006 L7.05936223,14.5410733 C6.66084441,14.9395911 5.99470879,14.7495437 5.84732507,14.2307918 L5.82599322,14.1299503 L5.41002206,11.2210611 C5.38384206,11.0387707 5.42844503,10.854541 5.53122578,10.7052181 L5.60006949,10.6198906 L9.89358994,6.0490561 C10.1689648,5.75622792 10.6295389,5.74168347 10.9213975,6.01705831 Z M15.9983787,0.7723311 L15.9848039,0.872202963 L13.4918859,13.3387324 C13.4114066,13.7411287 13.0167673,13.9912932 12.6269761,13.9069354 L12.5300132,13.8788162 L7.95917862,12.2168708 C7.58199266,12.080153 7.38709708,11.6622426 7.52381487,11.2850566 C7.64986674,10.9388988 8.01153863,10.7469121 8.36157496,10.8225433 L8.45659868,10.8496929 L12.2313672,12.2226886 L14.2540148,2.10848087 L2.37120249,8.55845784 L4.76327903,9.62214165 C5.09974055,9.77146463 5.26651686,10.1457417 5.166645,10.4889906 L5.13173833,10.5820751 C4.98241535,10.9185366 4.6091079,11.0853129 4.26488935,10.9854411 L4.17277453,10.951504 L0.431943024,9.28955866 C-0.0848696226,9.05975641 -0.144017036,8.36744078 0.287468194,8.04455408 L0.380552648,7.98540667 L14.9249986,0.0897117698 C15.4369631,-0.187602333 16.0352247,0.216733265 15.9983787,0.7723311 Z\" id=\"Shape\"></path>\n            </g>\n        </g>\n    </g>\n</svg>",
  // 查看文件发送记录
  menu_send_his: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"15px\" viewBox=\"0 0 16 15\">\n            <g transform=\"translate(0.000000, 0.949153)\">\n                <path d=\"M 1.627 0 C 2.526 0 3.254 .723 3.254 1.615 C 3.254 2.508 2.526 3.231 1.627 3.231 C .728 3.231 0 2.508 0 1.615 C 0 .723 .728 0 1.627 0 Z M 1.627 5.385 C 2.526 5.385 3.254 6.108 3.254 7 C 3.254 7.892 2.526 8.615 1.627 8.615 C .728 8.615 0 7.892 0 7 C 0 6.108 .728 5.385 1.627 5.385 Z M 1.627 10.769 C 2.526 10.769 3.254 11.492 3.254 12.385 C 3.254 13.277 2.526 14 1.627 14 C .728 14 0 13.277 0 12.385 C 0 11.492 .728 10.769 1.627 10.769 Z M 15.186 .808 C 15.636 .808 16 1.169 16 1.615 C 16 2.024 15.694 2.362 15.297 2.416 L 15.186 2.423 L 5.424 2.423 C 4.974 2.423 4.61 2.061 4.61 1.615 C 4.61 1.206 4.916 .869 5.313 .815 L 5.424 .808 L 15.186 .808 Z M 15.186 6.192 C 15.636 6.192 16 6.554 16 7 C 16 7.409 15.694 7.747 15.297 7.8 L 15.186 7.808 L 5.424 7.808 C 4.974 7.808 4.61 7.446 4.61 7 C 4.61 6.591 4.916 6.253 5.313 6.2 L 5.424 6.192 L 15.186 6.192 Z M 15.186 11.577 C 15.636 11.577 16 11.939 16 12.385 C 16 12.794 15.694 13.131 15.297 13.185 L 15.186 13.192 L 5.424 13.192 C 4.974 13.192 4.61 12.831 4.61 12.385 C 4.61 11.976 4.916 11.638 5.313 11.584 L 5.424 11.577 L 15.186 11.577 Z\" fill=\"currentColor\"/>\n            </g>\n</svg>",
  // ## 新建部门
  menu_create_dep: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"14px\" viewBox=\"0 0 16 14\">\n        <g transform=\"translate(0.000000, -1.000000)\" fill=\"currentColor>\n            <g id=\"Group\" transform=\"translate(0.000000, 1.600000)\" >\n                <path d=\"M6.4,-3.13474736e-16 L8,1.6 L14.4,1.6 C15.28,1.6 16,2.32 16,3.2 L16,11.2 C16,12.08 15.28,12.8 14.4,12.8 L1.6,12.8 C0.72,12.8 0,12.08 0,11.2 L0.00847058824,1.6 C0.00847058824,0.72 0.72,-3.13474736e-16 1.6,-3.13474736e-16 L6.4,-3.13474736e-16 Z M14.4,3.2 L1.6,3.2 L1.6,11.2 L14.4,11.2 L14.4,3.2 Z M11.7364706,6.12141176 C12.3858824,6.12141176 12.9129412,6.64752941 12.9129412,7.29788235 C12.9129412,7.94729412 12.3858824,8.47435294 11.7364706,8.47435294 C11.0870588,8.47435294 10.56,7.94729412 10.56,7.29788235 C10.56,6.64752941 11.0870588,6.12141176 11.7364706,6.12141176 Z M4.07058824,6.09788235 C4.72,6.09788235 5.24705882,6.624 5.24705882,7.27435294 C5.24705882,7.92376471 4.72,8.45082353 4.07058824,8.45082353 C3.42117647,8.45082353 2.89411765,7.92376471 2.89411765,7.27435294 C2.89411765,6.624 3.42117647,6.09788235 4.07058824,6.09788235 Z M8.08658824,6.06964706 C8.736,6.06964706 9.26305882,6.59670588 9.26305882,7.24611765 C9.26305882,7.89552941 8.736,8.42258824 8.08658824,8.42258824 C7.43717647,8.42258824 6.91011765,7.89552941 6.91011765,7.24611765 C6.91011765,6.59670588 7.43717647,6.06964706 8.08658824,6.06964706 Z\" id=\"Shape\"/>\n            </g>\n        </g>\n</svg>",
  //新建文件夹
  menu_create_folder: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"14px\" viewBox=\"0 0 16 14\">\n\n        <g transform=\"translate(0.000000, -1.000000)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n            <path d=\"M 6.4 1.5 L 8 3.125 L 14.4 3.125 C 15.28 3.125 16 3.856 16 4.75 L 16 12.875 C 16 13.769 15.28 14.5 14.4 14.5 L 1.6 14.5 C .72 14.5 0 13.769 0 12.875 L .008 3.125 C .008 2.231 .72 1.5 1.6 1.5 L 6.4 1.5 Z M 14.4 4.75 L 1.6 4.75 L 1.6 12.875 L 14.4 12.875 L 14.4 4.75 Z M 11.5 6.5 L 11.5 8 L 13 8 L 13 9.5 L 11.5 9.5 L 11.5 11 L 10 11 L 10 9.5 L 8.5 9.5 L 8.5 8 L 10 8 L 10 6.5 L 11.5 6.5 Z\" fill=\"currentColor\"/>\n        </g>\n\n</svg>",
  //markdown文件
  menu_create_md: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" fill=\"currentColor\">\n                <path d=\"M12.8,-2.36847579e-16 C14.5674667,-2.36847579e-16 16,1.43253333 16,3.2 L16,12.8 C16,14.5664 14.5674667,16 12.8,16 L3.2,16 C1.4336,16 9.47390314e-16,14.5664 9.47390314e-16,12.8 L9.47390314e-16,3.2 C9.47390314e-16,1.43253333 1.4336,-2.36847579e-16 3.2,-2.36847579e-16 L12.8,-2.36847579e-16 Z M12.8,1.6 L3.2,1.6 C2.3168,1.6 1.6,2.31573333 1.6,3.2 L1.6,12.8 C1.6,13.6832 2.3168,14.4 3.2,14.4 L12.8,14.4 C13.6842667,14.4 14.4,13.6832 14.4,12.8 L14.4,3.2 C14.4,2.31573333 13.6842667,1.6 12.8,1.6 Z M10.56,3.78666667 L12,4.26666667 L12,11.7333333 L10.4,11.7333333 L10.4,6.6656 L8.64,9.01333333 L7.36,9.01333333 L5.6,6.6656 L5.6,11.7333333 L4,11.7333333 L4,4.26666667 L5.44,3.78666667 L8,7.2 L10.56,3.78666667 Z\"/>\n            </g>\n</svg>",
  //以图搜图
  menu_ai_img_search: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" fill=\"currentColor\">\n<path d=\"M1.392,9.82613333 L1.392,12.9045333 C1.392,13.8453333 2.15466667,14.608 3.09546667,14.608 L6.17386667,14.608 L6.17386667,16 L3.09546667,16 C1.3856,16 -3.25665421e-16,14.6133333 -3.25665421e-16,12.9045333 L-3.25665421e-16,9.82613333 L1.392,9.82613333 Z M16,9.82613333 L16,12.9045333 C16,14.6133333 14.6144,16 12.9045333,16 L9.82613333,16 L9.82613333,14.608 L12.9045333,14.608 C13.8453333,14.608 14.608,13.8453333 14.608,12.9045333 L14.608,9.82613333 L16,9.82613333 Z M10.128,5.06986667 C11.3557333,6.2976 11.504,8.19733333 10.5717333,9.5872 L11.9776,10.9930667 L10.9930667,11.9776 L9.5872,10.5717333 C8.19733333,11.5029333 6.29866667,11.3546667 5.06986667,10.1269333 C3.6736,8.73066667 3.6736,6.46613333 5.06986667,5.06986667 C6.4672,3.67253333 8.73066667,3.67253333 10.128,5.06986667 Z M6.0544,6.05333333 C5.20106667,6.90666667 5.20106667,8.29013333 6.0544,9.14346667 C6.90773333,9.99573333 8.29013333,9.99573333 9.14346667,9.14346667 C9.9968,8.29013333 9.9968,6.90666667 9.14346667,6.05333333 C8.29013333,5.20106667 6.90773333,5.20106667 6.0544,6.05333333 Z M6.17386667,1.48029737e-16 L6.17386667,1.39093333 L3.09546667,1.39093333 C2.15466667,1.39093333 1.392,2.1536 1.392,3.09546667 L1.392,6.17386667 L-3.25665421e-16,6.17386667 L-3.25665421e-16,3.09546667 C-3.25665421e-16,1.3856 1.3856,1.48029737e-16 3.09546667,1.48029737e-16 L6.17386667,1.48029737e-16 Z M12.9045333,1.48029737e-16 C14.6144,1.48029737e-16 16,1.3856 16,3.09546667 L16,6.17386667 L14.608,6.17386667 L14.608,3.09546667 C14.608,2.1536 13.8453333,1.39093333 12.9045333,1.39093333 L9.82613333,1.39093333 L9.82613333,1.48029737e-16 L12.9045333,1.48029737e-16 Z\"/>\n            </g>\n</svg>",
  //添加标签
  menu_add_tag: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n\n  <path d=\"M 8.72 .552 L 8.875 .557 L 13.663 .942 C 14.446 1.005 15.067 1.626 15.13 2.409 L 15.516 7.197 C 15.553 7.665 15.384 8.126 15.052 8.457 L 8.56 14.949 C 7.757 15.752 6.454 15.752 5.65 14.949 L 1.123 10.422 C .32 9.618 .32 8.315 1.123 7.512 L 7.615 1.02 C 7.947 .688 8.407 .519 8.875 .557 Z M 8.765 1.924 C 8.698 1.919 8.632 1.943 8.585 1.99 L 2.093 8.482 C 1.826 8.75 1.826 9.184 2.093 9.452 L 6.62 13.979 C 6.888 14.247 7.322 14.247 7.59 13.979 L 14.082 7.487 C 14.129 7.44 14.153 7.374 14.148 7.307 L 13.763 2.519 C 13.754 2.407 13.665 2.318 13.553 2.309 Z M 11.944 4.129 C 12.747 4.932 12.747 6.235 11.944 7.039 C 11.14 7.842 9.837 7.842 9.033 7.039 C 8.23 6.235 8.23 4.932 9.033 4.129 C 9.837 3.325 11.14 3.325 11.944 4.129 Z M 9.874 4.969 C 9.535 5.309 9.535 5.859 9.874 6.198 C 10.213 6.537 10.764 6.537 11.103 6.198 C 11.442 5.859 11.442 5.309 11.103 4.969 C 10.764 4.63 10.213 4.63 9.874 4.969 Z\" fill=\"currentColor\"/>\n  </svg>",
  //提醒关注
  menu_focus: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" fill=\"currentColor\">\n            <g id=\"Group\" transform=\"translate(0.000000, 0.000000)\">\n                <path d=\"M1.392,9.82613333 L1.392,12.9045333 C1.392,13.8453333 2.15466667,14.608 3.09546667,14.608 L6.17386667,14.608 L6.17386667,16 L3.09546667,16 C1.3856,16 0,14.6144 0,12.9045333 L0,9.82613333 L1.392,9.82613333 Z M16,9.82613333 L16,12.9045333 C16,14.6144 14.6144,16 12.9045333,16 L9.82613333,16 L9.82613333,14.608 L12.9045333,14.608 C13.8453333,14.608 14.608,13.8453333 14.608,12.9045333 L14.608,9.82613333 L16,9.82613333 Z M8.8,4.26666667 L8.8,7.2 L11.7333333,7.2 L11.7333333,8.8 L8.8,8.8 L8.8,11.7333333 L7.2,11.7333333 L7.2,8.8 L4.26666667,8.8 L4.26666667,7.2 L7.2,7.2 L7.2,4.26666667 L8.8,4.26666667 Z M6.17386667,0 L6.17386667,1.392 L3.09546667,1.392 C2.15466667,1.392 1.392,2.15466667 1.392,3.09546667 L1.392,6.17386667 L0,6.17386667 L0,3.09546667 C0,1.3856 1.3856,0 3.09546667,0 L6.17386667,0 Z M12.9045333,0 C14.6144,0 16,1.3856 16,3.09546667 L16,6.17386667 L14.608,6.17386667 L14.608,3.09546667 C14.608,2.15466667 13.8453333,1.392 12.9045333,1.392 L9.82613333,1.392 L9.82613333,0 L12.9045333,0 Z\" id=\"Shape\"/>\n            </g>\n</svg>",
  //上传新版本
  menu_new_ver: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" fill=\"currentColor\">\n            <g transform=\"translate(-0.000000, 0.201759)\">\n                <path d=\"M 13.371 7.953 L 14.968 9.549 C 15.28 9.861 15.28 10.367 14.968 10.678 C 14.656 10.99 14.15 10.99 13.838 10.678 L 13.53 10.37 L 13.498 14.91 C 13.496 15.292 13.184 15.6 12.801 15.596 C 12.419 15.594 12.112 15.282 12.114 14.9 L 12.147 10.305 L 11.774 10.678 C 11.491 10.962 11.047 10.988 10.734 10.756 L 10.644 10.678 C 10.333 10.367 10.333 9.861 10.644 9.549 L 12.241 7.953 C 12.553 7.641 13.059 7.641 13.371 7.953 Z M 1.166 10.196 L 7.851 13.663 C 8.243 13.866 8.395 14.349 8.192 14.74 C 7.988 15.131 7.507 15.285 7.115 15.081 L .431 11.613 C .04 11.409 -.113 10.928 .09 10.536 C .293 10.145 .774 9.992 1.166 10.196 Z M 1.184 6.792 L 7.869 10.479 C 8.254 10.693 8.395 11.178 8.182 11.564 C 7.969 11.95 7.484 12.091 7.097 11.878 L .413 8.19 C .027 7.977 -.113 7.492 .1 7.105 C .312 6.72 .798 6.579 1.184 6.792 Z M 8.413 .094 L 15.367 3.204 C 15.906 3.445 16.147 4.078 15.907 4.617 C 15.808 4.836 15.64 5.016 15.427 5.128 L 8.473 8.772 C 8.16 8.936 7.787 8.935 7.475 8.77 L .6 5.126 C .078 4.849 -.121 4.202 .156 3.679 C .267 3.471 .443 3.303 .659 3.205 L 7.535 .096 C 7.814 -.031 8.133 -.032 8.413 .094 Z M 7.976 1.655 L 2.314 4.218 L 7.979 7.219 L 13.705 4.219 L 7.976 1.655 Z\" fill=\"currentColor\"/>\n            </g>\n</svg>",
  //下载
  menu_download: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" fill=\"currentColor\">\n        <g transform=\"translate(1.000000, 1.000000)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n            <path d=\"M 0 9.626 L 1.75 9.626 L 1.75 12.25 L 12.25 12.25 L 12.25 9.626 L 14 9.626 L 14 12.25 C 14 13.213 13.213 14 12.25 14 L 1.75 14 C .787 14 0 13.213 0 12.25 M 10.141 4.891 L 7.876 7.149 L 7.876 0 L 6.126 0 L 6.126 7.149 L 3.859 4.891 L 2.626 6.126 L 7 10.5 L 11.376 6.126 L 10.141 4.891 Z\" fill=\"currentColor\"/>\n        </g>\n</svg>",
  // 下载为PDF
  menu_down_pdf: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"12px\" viewBox=\"0 0 16 12\" fill=\"currentColor\">\n <g transform=\"translate(0.000000, -2.000000)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n            <g transform=\"translate(0.000000, 2.718400)\">\n                <path d=\"M 15.36 8.869 L .64 8.869 C .286 8.869 0 9.188 0 9.583 L 0 10.385 C 0 10.483 .071 10.563 .16 10.563 L 15.84 10.563 C 15.927 10.563 16 10.483 16 10.385 L 16 9.583 C 16 9.188 15.713 8.869 15.36 8.869 Z M .315 0 L 3.073 0 C 3.674 0 4.124 .169 4.422 .505 C 4.722 .841 4.871 1.319 4.871 1.94 C 4.871 2.579 4.708 3.078 4.382 3.438 C 4.057 3.796 3.558 3.977 2.89 3.977 L 1.981 3.977 L 1.981 6.322 L .315 6.322 L .315 0 Z M 1.981 2.695 L 2.387 2.695 C 2.707 2.695 2.932 2.63 3.061 2.499 C 3.191 2.368 3.255 2.201 3.255 1.997 C 3.255 1.798 3.2 1.63 3.087 1.492 C 2.975 1.355 2.764 1.285 2.453 1.285 L 1.981 1.285 L 1.981 2.695 Z M 5.761 0 L 8.226 0 C 8.713 0 9.105 .078 9.404 .233 C 9.703 .388 9.951 .611 10.146 .901 C 10.341 1.191 10.483 1.53 10.571 1.915 C 10.659 2.3 10.703 2.708 10.703 3.14 C 10.703 3.815 10.638 4.339 10.507 4.711 C 10.377 5.084 10.195 5.396 9.963 5.648 C 9.731 5.9 9.482 6.067 9.216 6.15 C 8.852 6.266 8.522 6.322 8.226 6.322 L 5.761 6.322 L 5.761 0 Z M 7.421 1.431 L 7.421 4.886 L 7.827 4.886 C 8.174 4.886 8.42 4.842 8.567 4.751 C 8.714 4.66 8.829 4.502 8.912 4.276 C 8.994 4.05 9.036 3.684 9.036 3.179 C 9.036 2.509 8.943 2.05 8.757 1.803 C 8.572 1.555 8.265 1.431 7.835 1.431 L 7.421 1.431 Z M 11.582 0 L 15.684 0 L 15.684 1.359 L 13.249 1.359 L 13.249 2.463 L 15.329 2.463 L 15.329 3.74 L 13.249 3.74 L 13.249 6.322 L 11.582 6.322 L 11.582 0 Z\" fill=\"currentColor\"/>\n            </g>\n        </g>\n</svg>",
  // 重命名
  menu_rename: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"14px\" viewBox=\"0 0 16 14\" fill=\"currentColor\">\n\n        <path d=\"M 10.299 0 L 11.612 .88 L 12.927 0 L 14.194 0 L 14.194 1.556 L 13.397 1.556 L 12.387 2.232 L 12.387 11.343 L 13.483 12.444 L 14.194 12.444 L 14.194 14 L 12.841 14 L 11.612 12.766 L 10.385 14 L 9.032 14 L 9.032 12.444 L 9.742 12.444 L 10.839 11.343 L 10.839 2.232 L 9.829 1.556 L 9.032 1.556 L 9.032 0 L 10.299 0 Z M 9.318 3.111 L 9.318 4.667 L 1.548 4.667 L 1.548 9.333 L 9.318 9.333 L 9.318 10.889 L .774 10.889 L 0 10.111 L 0 3.889 L .774 3.111 L 9.318 3.111 Z M 15.226 3.111 L 16 3.889 L 16 10.111 L 15.226 10.889 L 13.814 10.889 L 13.814 9.333 L 14.452 9.333 L 14.452 4.667 L 13.814 4.667 L 13.814 3.111 L 15.226 3.111 Z M 8 6 L 8 8 L 3 8 L 3 6 L 8 6 Z\" fill=\"currentColor\"/>\n\n</svg>",
  // 批量重命名
  menu_batch_rename: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"14px\" viewBox=\"0 0 16 14\" fill=\"currentColor\">\n\n        <path d=\"M 10.299 0 L 11.612 .88 L 12.927 0 L 14.194 0 L 14.194 1.556 L 13.397 1.556 L 12.387 2.232 L 12.387 11.343 L 13.483 12.444 L 14.194 12.444 L 14.194 14 L 12.841 14 L 11.612 12.766 L 10.385 14 L 9.032 14 L 9.032 12.444 L 9.742 12.444 L 10.839 11.343 L 10.839 2.232 L 9.829 1.556 L 9.032 1.556 L 9.032 0 L 10.299 0 Z M 9.318 3.111 L 9.318 4.667 L 1.548 4.667 L 1.548 9.333 L 9.318 9.333 L 9.318 10.889 L .774 10.889 L 0 10.111 L 0 3.889 L .774 3.111 L 9.318 3.111 Z M 15.226 3.111 L 16 3.889 L 16 10.111 L 15.226 10.889 L 13.814 10.889 L 13.814 9.333 L 14.452 9.333 L 14.452 4.667 L 13.814 4.667 L 13.814 3.111 L 15.226 3.111 Z M 8 6 L 8 8 L 3 8 L 3 6 L 8 6 Z\" fill=\"currentColor\"/>\n\n</svg>",
  // 复制
  menu_quick_copy: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n            <g transform=\"translate(0.896508, 0.000000)\">\n                <path d=\"M 1.524 4.482 L 1.524 14.222 C 1.524 14.362 1.638 14.476 1.778 14.476 L 9.726 14.476 L 9.726 16 L 1.778 16 C .796 16 0 15.204 0 14.222 L 0 4.482 L 1.524 4.482 Z M 9.721 0 C 10.009 0 10.284 .122 10.477 .336 L 13.947 4.193 C 14.115 4.378 14.207 4.62 14.207 4.872 L 14.207 12.429 C 14.207 12.991 13.753 13.445 13.191 13.445 L 4.019 13.445 C 3.458 13.445 3.003 12.991 3.003 12.429 L 3.003 1.016 C 3.003 .455 3.458 0 4.019 0 L 9.721 0 Z M 9.277 1.524 L 4.527 1.524 L 4.527 11.921 L 12.683 11.921 L 12.683 5.066 L 12.558 4.929 L 9.277 4.93 L 9.277 1.524 Z\" fill=\"currentColor\"/>\n            </g>\n</svg>",
  // 剪切
  menu_quick_cut: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"14px\" viewBox=\"0 0 16 14\">\n\n  <path d=\"M 11.631 .36 C 11.955 .558 12.076 .962 11.927 1.301 L 11.88 1.391 L 8.542 6.851 L 9.987 9.019 C 10.537 8.394 11.343 8 12.24 8 C 13.897 8 15.24 9.343 15.24 11 C 15.24 12.657 13.897 14 12.24 14 C 10.583 14 9.24 12.657 9.24 11 C 9.24 10.858 9.25 10.719 9.269 10.583 C 9.239 10.56 9.211 10.533 9.184 10.504 L 9.116 10.416 L 7.68 8.263 L 6.38 10.391 C 6.334 10.467 6.277 10.531 6.211 10.584 C 6.23 10.719 6.24 10.858 6.24 11 C 6.24 12.657 4.897 14 3.24 14 C 1.583 14 .24 12.657 .24 11 C .24 9.343 1.583 8 3.24 8 C 4.128 8 4.925 8.385 5.475 8.998 L 6.763 6.888 L 3.116 1.416 C 2.886 1.071 2.979 .606 3.324 .376 C 3.637 .167 4.051 .225 4.296 .496 L 4.364 .584 L 7.626 5.477 L 10.6 .609 C 10.816 .255 11.278 .144 11.631 .36 Z M 3.24 9.5 C 2.412 9.5 1.74 10.172 1.74 11 C 1.74 11.828 2.412 12.5 3.24 12.5 C 4.069 12.5 4.74 11.828 4.74 11 C 4.74 10.172 4.069 9.5 3.24 9.5 Z M 12.24 9.5 C 11.412 9.5 10.74 10.172 10.74 11 C 10.74 11.828 11.412 12.5 12.24 12.5 C 13.069 12.5 13.74 11.828 13.74 11 C 13.74 10.172 13.069 9.5 12.24 9.5 Z\" fill=\"currentColor\"/>\n\n  </svg>",
  // 粘贴
  menu_paste: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14px\" height=\"16px\" viewBox=\"0 0 14 16\">\n\n  <path d=\"M 1.806 13.611 C 1.808 13.741 1.914 13.845 2.044 13.845 L 2.705 13.844 L 2.708 15.273 L 2.047 15.274 L 2.013 15.274 C 1.117 15.257 .392 14.533 .377 13.634 Z M 5.614 13.839 L 5.617 15.268 L 3.483 15.271 L 3.481 13.843 L 5.614 13.839 Z M 8.524 13.834 L 8.526 15.263 L 6.393 15.266 L 6.39 13.838 L 8.524 13.834 Z M 11.171 13.83 L 11.174 15.258 L 9.302 15.262 L 9.299 13.833 L 11.171 13.83 Z M 9.492 .274 C 9.762 .274 10.02 .388 10.2 .589 L 13.454 4.204 C 13.611 4.379 13.698 4.606 13.698 4.841 L 13.698 11.928 C 13.698 12.454 13.272 12.88 12.746 12.88 L 4.146 12.88 C 3.62 12.88 3.193 12.454 3.193 11.928 L 3.193 1.226 C 3.193 .7 3.62 .274 4.146 .274 L 9.492 .274 Z M 1.804 10.713 L 1.806 12.847 L .377 12.847 L .376 10.714 L 1.804 10.713 Z M 9.076 1.702 L 4.622 1.703 L 4.622 11.451 L 12.27 11.451 L 12.27 5.024 L 12.154 4.896 L 9.076 4.896 L 9.076 1.702 Z M 1.803 7.804 L 1.804 9.937 L .375 9.938 L .374 7.805 L 1.803 7.804 Z M 1.802 4.895 L 1.803 7.028 L .374 7.029 L .373 4.896 L 1.802 4.895 Z\" fill=\"currentColor\"/>\n\n  </svg>",
  // ## 共享及协作
  menu_share_type: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"14px\" viewBox=\"0 0 16 14\">\n\n        <g transform=\"translate(0.000000, -1.000000)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n            <path d=\"M 13.934 2.485 C 13.934 2.107 13.627 1.8 13.246 1.8 C 12.865 1.8 12.558 2.107 12.558 2.485 L 12.558 3.853 L 11.18 3.853 C 10.8 3.853 10.492 4.16 10.492 4.537 C 10.492 4.916 10.8 5.222 11.18 5.222 L 12.558 5.222 L 12.558 6.591 C 12.558 6.969 12.865 7.276 13.246 7.276 C 13.627 7.276 13.934 6.969 13.934 6.591 L 13.934 5.222 L 15.312 5.222 C 15.692 5.222 16 4.916 16 4.537 C 16 4.16 15.692 3.853 15.312 3.853 L 13.934 3.853 L 13.934 2.485 Z M 6.526 1.5 C 8.185 1.5 9.53 2.837 9.53 4.487 C 9.53 6.136 8.185 7.473 6.526 7.473 C 4.866 7.473 3.521 6.136 3.521 4.487 C 3.521 2.837 4.866 1.5 6.526 1.5 Z M 6.526 2.993 C 5.696 2.993 5.023 3.661 5.023 4.487 C 5.023 5.311 5.696 5.98 6.526 5.98 C 7.356 5.98 8.028 5.311 8.028 4.487 C 8.028 3.661 7.356 2.993 6.526 2.993 Z M 6.403 8.502 C 9.36 8.502 11.565 9.505 13.019 11.513 L 13.019 14.5 L 0 14.5 L 0 11.513 C 1.313 9.505 3.447 8.502 6.403 8.502 Z M 6.403 9.995 C 4.134 9.995 2.558 10.647 1.526 11.954 L 1.502 11.986 L 1.502 13.006 L 11.517 13.006 L 11.517 12.026 L 11.498 12.003 C 10.4 10.723 8.841 10.057 6.712 9.999 L 6.403 9.995 Z\" fill=\"currentColor\"/>\n        </g>\n\n</svg>",
  // 分享
  menu_share: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n\n  <path d=\"M 12.569 .94 C 14.162 .94 15.453 2.231 15.453 3.824 C 15.453 5.417 14.162 6.709 12.569 6.709 C 11.686 6.709 10.897 6.313 10.368 5.689 L 6.151 7.797 C 6.198 8.004 6.222 8.219 6.222 8.44 C 6.222 8.739 6.177 9.028 6.092 9.299 L 10.229 11.368 C 10.753 10.642 11.605 10.17 12.569 10.17 C 14.162 10.17 15.453 11.462 15.453 13.055 C 15.453 14.648 14.162 15.94 12.569 15.94 C 10.976 15.94 9.684 14.648 9.684 13.055 C 9.684 12.962 9.688 12.869 9.697 12.778 L 5.281 10.572 C 4.768 11.039 4.086 11.324 3.338 11.324 C 1.745 11.324 .453 10.033 .453 8.44 C .453 6.847 1.745 5.555 3.338 5.555 C 4.17 5.555 4.92 5.907 5.446 6.471 L 9.728 4.331 C 9.699 4.166 9.684 3.997 9.684 3.824 C 9.684 2.231 10.976 .94 12.569 .94 Z M 12.569 11.67 C 11.804 11.67 11.184 12.29 11.184 13.055 C 11.184 13.82 11.804 14.44 12.569 14.44 C 13.333 14.44 13.953 13.82 13.953 13.055 C 13.953 12.29 13.333 11.67 12.569 11.67 Z M 3.338 7.055 C 2.573 7.055 1.953 7.675 1.953 8.44 C 1.953 9.204 2.573 9.824 3.338 9.824 C 4.103 9.824 4.722 9.204 4.722 8.44 C 4.722 7.675 4.103 7.055 3.338 7.055 Z M 12.569 2.44 C 11.804 2.44 11.184 3.06 11.184 3.824 C 11.184 4.589 11.804 5.209 12.569 5.209 C 13.333 5.209 13.953 4.589 13.953 3.824 C 13.953 3.06 13.333 2.44 12.569 2.44 Z\" fill=\"currentColor\"/>\n\n  </svg>",
  // 快照分享
  menu_quick_share: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n\n  <path d=\"M 12.569 .94 C 14.162 .94 15.453 2.231 15.453 3.824 C 15.453 5.417 14.162 6.709 12.569 6.709 C 11.686 6.709 10.897 6.313 10.368 5.689 L 6.151 7.797 C 6.198 8.004 6.222 8.219 6.222 8.44 C 6.222 8.739 6.177 9.028 6.092 9.299 L 10.229 11.368 C 10.753 10.642 11.605 10.17 12.569 10.17 C 14.162 10.17 15.453 11.462 15.453 13.055 C 15.453 14.648 14.162 15.94 12.569 15.94 C 10.976 15.94 9.684 14.648 9.684 13.055 C 9.684 12.962 9.688 12.869 9.697 12.778 L 5.281 10.572 C 4.768 11.039 4.086 11.324 3.338 11.324 C 1.745 11.324 .453 10.033 .453 8.44 C .453 6.847 1.745 5.555 3.338 5.555 C 4.17 5.555 4.92 5.907 5.446 6.471 L 9.728 4.331 C 9.699 4.166 9.684 3.997 9.684 3.824 C 9.684 2.231 10.976 .94 12.569 .94 Z M 12.569 11.67 C 11.804 11.67 11.184 12.29 11.184 13.055 C 11.184 13.82 11.804 14.44 12.569 14.44 C 13.333 14.44 13.953 13.82 13.953 13.055 C 13.953 12.29 13.333 11.67 12.569 11.67 Z M 3.338 7.055 C 2.573 7.055 1.953 7.675 1.953 8.44 C 1.953 9.204 2.573 9.824 3.338 9.824 C 4.103 9.824 4.722 9.204 4.722 8.44 C 4.722 7.675 4.103 7.055 3.338 7.055 Z M 12.569 2.44 C 11.804 2.44 11.184 3.06 11.184 3.824 C 11.184 4.589 11.804 5.209 12.569 5.209 C 13.333 5.209 13.953 4.589 13.953 3.824 C 13.953 3.06 13.333 2.44 12.569 2.44 Z\" fill=\"currentColor\"/>\n\n  </svg>",
  // 生成分享链接
  menu_share_link: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n    <title>Artboard</title>\n\n        <g transform=\"translate(1.214250, 1.214250)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n            <path d=\"M 3.781 6.256 C 4.074 6.549 4.074 7.023 3.781 7.316 L 2.013 9.084 C 1.33 9.768 1.33 10.876 2.013 11.559 C 2.697 12.242 3.805 12.242 4.488 11.559 L 6.256 9.791 C 6.549 9.498 7.024 9.498 7.316 9.791 C 7.609 10.084 7.609 10.559 7.316 10.852 L 5.549 12.62 C 4.279 13.889 2.222 13.889 .952 12.62 C-.317 11.35 -.317 9.293 .952 8.023 L 2.72 6.256 C 3.013 5.963 3.488 5.963 3.781 6.256 Z M 10.557 3.015 C 10.85 3.308 10.85 3.783 10.557 4.075 L 4.076 10.557 C 3.783 10.85 3.308 10.85 3.015 10.557 C 2.722 10.264 2.722 9.79 3.015 9.497 L 9.497 3.015 C 9.79 2.722 10.264 2.722 10.557 3.015 Z M 12.62 .952 C 13.889 2.222 13.889 4.279 12.62 5.549 L 10.852 7.316 C 10.559 7.609 10.084 7.609 9.791 7.316 C 9.498 7.023 9.498 6.549 9.791 6.256 L 11.559 4.488 C 12.243 3.805 12.243 2.696 11.559 2.013 C 10.876 1.33 9.768 1.33 9.084 2.013 L 7.316 3.781 C 7.024 4.074 6.549 4.074 6.256 3.781 C 5.963 3.488 5.963 3.013 6.256 2.72 L 8.024 .952 C 9.293 -.317 11.351 -.317 12.62 .952 Z\" fill=\"currentColor\"/>\n        </g>\n\n</svg>",
  // 关闭分享link
  menu_close_link: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n    <title>Artboard</title>\n\n        <g transform=\"translate(1.214250, 1.214250)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n            <path d=\"M 3.781 6.256 C 4.074 6.549 4.074 7.023 3.781 7.316 L 2.013 9.084 C 1.33 9.767 1.33 10.876 2.013 11.559 C 2.696 12.242 3.804 12.242 4.488 11.559 L 6.256 9.791 C 6.549 9.498 7.023 9.498 7.316 9.791 C 7.609 10.084 7.609 10.559 7.316 10.852 L 5.549 12.62 C 4.279 13.889 2.222 13.889 .952 12.62 C-.317 11.35 -.317 9.293 .952 8.023 L 2.72 6.256 C 3.013 5.963 3.488 5.963 3.781 6.256 Z M 4.075 3.015 L 10.557 9.497 C 10.85 9.789 10.85 10.264 10.557 10.557 C 10.264 10.85 9.789 10.85 9.497 10.557 L 3.015 4.075 C 2.722 3.783 2.722 3.308 3.015 3.015 C 3.308 2.722 3.783 2.722 4.075 3.015 Z M 12.62 .952 C 13.889 2.222 13.889 4.279 12.62 5.549 L 10.852 7.316 C 10.559 7.609 10.084 7.609 9.791 7.316 C 9.498 7.023 9.498 6.549 9.791 6.256 L 11.559 4.488 C 12.242 3.804 12.242 2.696 11.559 2.013 C 10.876 1.33 9.768 1.33 9.084 2.013 L 7.316 3.781 C 7.023 4.074 6.549 4.074 6.256 3.781 C 5.963 3.488 5.963 3.013 6.256 2.72 L 8.023 .952 C 9.293 -.317 11.35 -.317 12.62 .952 Z\" fill=\"currentColor\"/>\n        </g>\n\n</svg>",
  // 退出分享
  menu_quit_share: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n    <title>Artboard</title>\n\n        <g transform=\"translate(1.214250, 1.214250)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n            <path d=\"M 3.781 6.256 C 4.074 6.549 4.074 7.023 3.781 7.316 L 2.013 9.084 C 1.33 9.767 1.33 10.876 2.013 11.559 C 2.696 12.242 3.804 12.242 4.488 11.559 L 6.256 9.791 C 6.549 9.498 7.023 9.498 7.316 9.791 C 7.609 10.084 7.609 10.559 7.316 10.852 L 5.549 12.62 C 4.279 13.889 2.222 13.889 .952 12.62 C-.317 11.35 -.317 9.293 .952 8.023 L 2.72 6.256 C 3.013 5.963 3.488 5.963 3.781 6.256 Z M 4.075 3.015 L 10.557 9.497 C 10.85 9.789 10.85 10.264 10.557 10.557 C 10.264 10.85 9.789 10.85 9.497 10.557 L 3.015 4.075 C 2.722 3.783 2.722 3.308 3.015 3.015 C 3.308 2.722 3.783 2.722 4.075 3.015 Z M 12.62 .952 C 13.889 2.222 13.889 4.279 12.62 5.549 L 10.852 7.316 C 10.559 7.609 10.084 7.609 9.791 7.316 C 9.498 7.023 9.498 6.549 9.791 6.256 L 11.559 4.488 C 12.242 3.804 12.242 2.696 11.559 2.013 C 10.876 1.33 9.768 1.33 9.084 2.013 L 7.316 3.781 C 7.023 4.074 6.549 4.074 6.256 3.781 C 5.963 3.488 5.963 3.013 6.256 2.72 L 8.023 .952 C 9.293 -.317 11.35 -.317 12.62 .952 Z\" fill=\"currentColor\"/>\n        </g>\n\n</svg>",
  // 发送
  menu_send: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n\n            <g transform=\"translate(-0.000000, 0.622565)\">\n                <path d=\"M 10.921 6.017 C 11.188 6.267 11.224 6.67 11.022 6.961 L 10.954 7.045 L 6.898 11.361 L 7.067 12.539 L 7.127 12.513 C 7.352 12.43 7.61 12.463 7.809 12.612 L 7.89 12.681 C 8.149 12.94 8.172 13.344 7.961 13.629 L 7.89 13.71 L 7.059 14.541 C 6.661 14.94 5.995 14.75 5.847 14.231 L 5.826 14.13 L 5.41 11.221 C 5.384 11.039 5.428 10.855 5.531 10.705 L 5.6 10.62 L 9.894 6.049 C 10.169 5.756 10.63 5.742 10.921 6.017 Z M 15.998 .772 L 15.985 .872 L 13.492 13.339 C 13.411 13.741 13.017 13.991 12.627 13.907 L 12.53 13.879 L 7.959 12.217 C 7.582 12.08 7.387 11.662 7.524 11.285 C 7.65 10.939 8.012 10.747 8.362 10.823 L 8.457 10.85 L 12.231 12.223 L 14.254 2.108 L 2.371 8.558 L 4.763 9.622 C 5.1 9.771 5.267 10.146 5.167 10.489 L 5.132 10.582 C 4.982 10.919 4.609 11.085 4.265 10.985 L 4.173 10.952 L .432 9.29 C-.085 9.06 -.144 8.367 .287 8.045 L .381 7.985 L 14.925 .09 C 15.437 -.188 16.035 .217 15.998 .772 Z\" fill=\"currentColor\"/>\n            </g>\n\n</svg>",
  // 传送文件
  menu_transform_file: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"14px\" viewBox=\"0 0 16 14\">\n\n        <g transform=\"translate(0.000000, -1.000000)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n            <g transform=\"translate(-0.000000, 1.177642)\">\n                <path d=\"M 11.975 6.993 C 12.376 6.993 12.702 7.319 12.702 7.721 L 12.702 8.982 C 12.702 10.455 11.509 11.648 10.036 11.648 L 3.277 11.648 L 4.32 12.301 C 4.661 12.514 4.764 12.962 4.552 13.303 C 4.339 13.643 3.89 13.747 3.549 13.534 L .343 11.53 C-.277 11.142 -.001 10.184 .731 10.186 L 10.032 10.214 C 10.705 10.214 11.248 9.671 11.248 9.002 L 11.248 7.721 C 11.248 7.319 11.573 6.993 11.975 6.993 Z M 4.087 6.69 C 3.685 6.69 3.359 6.364 3.359 5.963 L 3.359 4.69 C 3.359 3.221 4.548 2.028 6.017 2.023 L 12.48 2.004 L 11.312 1.354 C 10.971 1.154 10.853 .719 11.044 .374 C 11.236 .029 11.668 -.1 12.018 .083 L 15.624 2.087 C 16.28 2.451 16.023 3.448 15.274 3.451 L 6.022 3.479 C 5.354 3.481 4.814 4.022 4.814 4.691 L 4.814 5.964 C 4.814 6.365 4.488 6.691 4.087 6.691 L 4.087 6.69 Z\" fill=\"currentColor\"/>\n            </g>\n        </g>\n\n</svg>",
  // 锁定文件
  menu_lock_file: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n    <title>Artboard</title>\n\n        <g transform=\"translate(1.500000, 0.505000)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n            <path d=\"M 6.5 0 C 9.123 0 11.25 2.127 11.25 4.75 L 11.25 6.006 C 12.237 6.129 13 6.97 13 7.99 L 13 12.99 C 13 14.095 12.104 14.99 11 14.99 L 2 14.99 C .895 14.99 0 14.095 0 12.99 L 0 7.99 C 0 6.97 .763 6.128 1.75 6.005 L 1.75 4.75 C 1.75 2.127 3.877 0 6.5 0 L 6.5 0 Z M 11 7.49 L 2 7.49 C 1.724 7.49 1.5 7.714 1.5 7.99 L 1.5 12.99 C 1.5 13.266 1.724 13.49 2 13.49 L 11 13.49 C 11.276 13.49 11.5 13.266 11.5 12.99 L 11.5 7.99 C 11.5 7.745 11.323 7.54 11.09 7.498 L 11 7.49 Z M 6.5 1.5 C 4.705 1.5 3.25 2.955 3.25 4.75 L 3.25 5.99 L 9.75 5.99 L 9.75 4.75 C 9.75 2.955 8.295 1.5 6.5 1.5 Z\" fill=\"currentColor\"/>\n        </g>\n\n</svg>",
  // 解锁文件
  menu_unlock_file: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n    <title>Artboard</title>\n\n        <g transform=\"translate(1.500000, 0.505000)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n            <path d=\"M 6.5 0 C 9.123 0 11.25 2.127 11.25 4.75 L 11.25 6.006 C 12.237 6.129 13 6.97 13 7.99 L 13 12.99 C 13 14.095 12.104 14.99 11 14.99 L 2 14.99 C .895 14.99 0 14.095 0 12.99 L 0 7.99 C 0 6.97 .763 6.128 1.75 6.005 L 1.75 4.75 C 1.75 2.127 3.877 0 6.5 0 L 6.5 0 Z M 11 7.49 L 2 7.49 C 1.724 7.49 1.5 7.714 1.5 7.99 L 1.5 12.99 C 1.5 13.266 1.724 13.49 2 13.49 L 11 13.49 C 11.276 13.49 11.5 13.266 11.5 12.99 L 11.5 7.99 C 11.5 7.745 11.323 7.54 11.09 7.498 L 11 7.49 Z M 6.5 1.5 C 4.705 1.5 3.25 2.955 3.25 4.75 L 3.25 5.99 L 9.75 5.99 L 9.75 4.75 C 9.75 2.955 8.295 1.5 6.5 1.5 Z\" fill=\"currentColor\"/>\n        </g>\n\n</svg>",
  // ## 整理
  menu_arrange: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"14px\" viewBox=\"0 0 16 14\">\n\n        <g transform=\"translate(0.000000, -1.000000)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n            <g transform=\"translate(0.000000, 1.500000)\">\n                <path d=\"M 6.4 0 L 8 1.625 L 14.4 1.625 C 15.28 1.625 16 2.356 16 3.25 L 16 11.375 C 16 12.269 15.28 13 14.4 13 L 1.6 13 C .72 13 0 12.269 0 11.375 L .008 1.625 C .008 .731 .72 0 1.6 0 L 6.4 0 Z M 14.4 3.25 L 1.6 3.25 L 1.6 11.375 L 14.4 11.375 L 14.4 3.25 Z M 7.901 4.184 L 8.929 6.268 L 11.229 6.602 L 9.565 8.225 L 9.958 10.515 L 7.901 9.434 L 5.843 10.515 L 6.236 8.225 L 4.572 6.602 L 6.872 6.268 L 7.901 4.184 Z\" fill=\"currentColor\"/>\n            </g>\n        </g>\n\n</svg>",
  // ### 置顶
  menu_stick_top: "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M0.963 0.195H14.459C14.874 0.195 15.211 0.532 15.211 0.948C15.211 1.363 14.874 1.7 14.459 1.7H0.963C0.548 1.7 0.211 1.363 0.211 0.948C0.211 0.532 0.548 0.195 0.963 0.195ZM5.943 3.842L0.65 9.135L0.558 9.235C-0.248 10.189 0.421 11.695 1.711 11.695H3.711V13.195C3.711 14.3 4.606 15.195 5.711 15.195H9.711L9.86 15.19C10.895 15.114 11.711 14.25 11.711 13.195V11.695H13.711C15.047 11.695 15.717 10.08 14.772 9.135L9.479 3.842C8.502 2.866 6.92 2.866 5.943 3.842ZM7.004 4.903C7.394 4.512 8.028 4.512 8.418 4.903L13.711 10.195H10.711C10.435 10.195 10.211 10.419 10.211 10.695V13.195C10.211 13.472 9.987 13.695 9.711 13.695H5.711C5.435 13.695 5.211 13.472 5.211 13.195V10.695C5.211 10.419 4.987 10.195 4.711 10.195H1.711L7.004 4.903Z\" fill=\"currentColor\"/>\n  </svg>",
  // 取消置顶
  menu_unstick_top: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n\n  <path d=\"M 1.612 .159 L 15.107 .159 C 15.523 .159 15.859 .496 15.859 .911 C 15.859 1.327 15.523 1.664 15.107 1.664 L 1.612 1.664 C 1.196 1.664 .859 1.327 .859 .911 C .859 .496 1.196 .159 1.612 .159 Z M 3.43 2.645 L 3.516 2.716 L 5.639 4.757 L 6.592 3.806 C 7.525 2.872 9.014 2.831 9.996 3.684 L 10.127 3.806 L 15.42 9.099 C 16.365 10.043 15.696 11.659 14.359 11.659 L 12.818 11.658 L 15.14 13.891 C 15.439 14.178 15.448 14.653 15.161 14.951 C 14.9 15.223 14.484 15.255 14.186 15.043 L 14.1 14.972 L 12.355 13.294 C 12.289 14.286 11.499 15.081 10.509 15.154 L 10.359 15.159 L 6.359 15.159 C 5.255 15.159 4.359 14.264 4.359 13.159 L 4.359 11.658 L 2.359 11.659 C 1.069 11.659 .401 10.153 1.207 9.199 L 1.299 9.099 L 4.578 5.818 L 2.476 3.797 C 2.178 3.51 2.168 3.035 2.455 2.737 C 2.716 2.465 3.133 2.433 3.43 2.645 Z M 5.66 6.858 L 2.359 10.159 L 5.359 10.159 L 5.449 10.167 C 5.682 10.21 5.859 10.414 5.859 10.659 L 5.859 13.159 L 5.867 13.249 C 5.91 13.482 6.114 13.659 6.359 13.659 L 10.359 13.659 L 10.449 13.651 C 10.682 13.609 10.859 13.405 10.859 13.159 L 10.859 11.857 L 5.66 6.858 Z M 8.972 4.783 C 8.58 4.478 8.013 4.506 7.652 4.866 L 6.72 5.797 L 11.267 10.168 L 11.359 10.159 L 14.359 10.159 L 9.066 4.866 Z\" fill=\"currentColor\"/>\n\n  </svg>",
  // 提醒关注
  menu_focus_new: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n\n  <path d=\"M 1.516 9.242 L 1.516 12.128 C 1.516 13.01 2.231 13.725 3.113 13.725 L 5.999 13.725 L 5.999 15.03 L 3.113 15.03 C 1.51 15.03 .211 13.731 .211 12.128 L .211 9.242 L 1.516 9.242 Z M 15.211 9.242 L 15.211 12.128 C 15.211 13.731 13.912 15.03 12.309 15.03 L 9.423 15.03 L 9.423 13.725 L 12.309 13.725 C 13.191 13.725 13.906 13.01 13.906 12.128 L 13.906 9.242 L 15.211 9.242 Z M 8.461 4.03 L 8.461 6.78 L 11.211 6.78 L 11.211 8.28 L 8.461 8.28 L 8.461 11.03 L 6.961 11.03 L 6.961 8.28 L 4.211 8.28 L 4.211 6.78 L 6.961 6.78 L 6.961 4.03 L 8.461 4.03 Z M 5.999 .03 L 5.999 1.335 L 3.113 1.335 C 2.231 1.335 1.516 2.05 1.516 2.932 L 1.516 5.818 L .211 5.818 L .211 2.932 C .211 1.329 1.51 .03 3.113 .03 L 5.999 .03 Z M 12.309 .03 C 13.912 .03 15.211 1.329 15.211 2.932 L 15.211 5.818 L 13.906 5.818 L 13.906 2.932 C 13.906 2.05 13.191 1.335 12.309 1.335 L 9.423 1.335 L 9.423 .03 L 12.309 .03 Z\" fill=\"currentColor\"/>\n\n  </svg>",
  // 移动
  menu_move: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"14px\" viewBox=\"0 0 16 14\">\n\n        <g transform=\"translate(0.000000, -1.000000)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n            <g transform=\"translate(0.000000, 1.500000)\">\n                <path d=\"M 6.4 0 L 8 1.625 L 14.4 1.625 C 15.28 1.625 16 2.356 16 3.25 L 16 11.375 C 16 12.269 15.28 13 14.4 13 L 1.6 13 C .72 13 0 12.269 0 11.375 L .008 1.625 C .008 .731 .72 0 1.6 0 L 6.4 0 Z M 14.4 3.25 L 1.6 3.25 L 1.6 11.375 L 14.4 11.375 L 14.4 3.25 Z M 7.992 3.953 L 11.4 7.362 L 7.992 10.753 L 6.785 9.554 L 8.136 8.203 L 4.6 8.203 L 4.6 6.503 L 8.136 6.503 L 6.793 5.152 L 7.992 3.953 Z\" fill=\"currentColor\"/>\n            </g>\n        </g>\n\n</svg>",
  // 复制到
  menu_copy_to: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n            <g transform=\"translate(0.896508, -0.000000)\">\n                <path d=\"M 1.524 4.482 L 1.524 14.222 C 1.524 14.362 1.638 14.476 1.778 14.476 L 9.726 14.476 L 9.726 16 L 1.778 16 C .796 16 0 15.204 0 14.222 L 0 4.482 L 1.524 4.482 Z M 9.721 0 C 10.009 0 10.284 .122 10.477 .336 L 13.947 4.193 C 14.115 4.378 14.207 4.62 14.207 4.872 L 14.207 12.429 C 14.207 12.991 13.753 13.445 13.191 13.445 L 4.019 13.445 C 3.458 13.445 3.003 12.991 3.003 12.429 L 3.003 1.016 C 3.003 .455 3.458 0 4.019 0 L 9.721 0 Z M 9.277 1.524 L 4.527 1.524 L 4.527 11.921 L 12.683 11.921 L 12.683 5.066 L 12.558 4.929 L 9.277 4.93 L 9.277 1.524 Z\" fill=\"currentColor\"/>\n            </g>\n</svg>",
  // 添加快捷方式
  menu_add_file_link: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n  <title>Artboard</title>\n\n      <g transform=\"translate(2.249857, 2.250125)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n          <path d=\"M 10.75 0 L 10.767 0 C 10.787 .001 10.807 .002 10.827 .004 L 10.75 0 C 10.796 0 10.842 .004 10.887 .013 C 10.898 .015 10.909 .017 10.921 .02 C 10.944 .025 10.967 .032 10.989 .039 C 10.999 .042 11.009 .046 11.019 .05 C 11.039 .057 11.057 .065 11.075 .074 C 11.09 .081 11.104 .089 11.119 .097 C 11.136 .107 11.153 .117 11.17 .129 C 11.18 .136 11.191 .143 11.201 .151 C 11.258 .194 11.308 .244 11.351 .301 L 11.28 .22 C 11.317 .257 11.349 .297 11.377 .339 C 11.39 .359 11.402 .38 11.414 .402 C 11.419 .411 11.423 .419 11.427 .428 C 11.44 .455 11.451 .483 11.461 .513 C 11.463 .52 11.465 .526 11.467 .532 C 11.479 .569 11.487 .608 11.493 .648 L 11.5 .75 L 11.5 5.25 C 11.5 5.664 11.164 6 10.75 6 C 10.37 6 10.056 5.718 10.006 5.352 L 10 5.25 L 10 2.56 L 1.28 11.28 C .987 11.573 .512 11.573 .219 11.28 C-.047 11.014 -.071 10.597 .147 10.304 L .219 10.22 L 8.938 1.5 L 6.25 1.5 C 5.87 1.5 5.556 1.218 5.506 .852 L 5.5 .75 C 5.5 .37 5.782 .057 6.148 .007 L 6.25 0 L 10.75 0 Z\" fill=\"currentColor\"/>\n      </g>\n\n</svg>",
  // 转为项目
  menu_to_project: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n\n  <path d=\"M 12.956 .688 C 14.613 .688 15.956 2.031 15.956 3.688 L 15.956 12.688 C 15.956 14.345 14.613 15.688 12.956 15.688 L 3.956 15.688 C 2.299 15.688 .956 14.345 .956 12.688 L .956 3.688 C .956 2.031 2.299 .688 3.956 .688 L 12.956 .688 Z M 12.956 2.188 L 3.956 2.188 C 3.127 2.188 2.456 2.859 2.456 3.688 L 2.456 12.688 C 2.456 13.516 3.127 14.188 3.956 14.188 L 12.956 14.188 C 13.784 14.188 14.456 13.516 14.456 12.688 L 14.456 3.688 C 14.456 2.859 13.784 2.188 12.956 2.188 Z M 8.456 4.194 C 9.284 4.194 9.956 4.866 9.956 5.694 C 9.956 6.016 9.855 6.314 9.682 6.558 L 11.263 9.194 C 11.326 9.186 11.391 9.182 11.456 9.182 C 12.284 9.182 12.956 9.853 12.956 10.682 C 12.956 11.51 12.284 12.182 11.456 12.182 C 10.841 12.182 10.313 11.812 10.081 11.282 L 6.831 11.282 C 6.599 11.812 6.071 12.182 5.456 12.182 C 4.627 12.182 3.956 11.51 3.956 10.682 C 3.956 9.853 4.627 9.182 5.456 9.182 C 5.521 9.182 5.586 9.186 5.649 9.194 L 7.23 6.558 C 7.057 6.314 6.956 6.016 6.956 5.694 C 6.956 4.866 7.627 4.194 8.456 4.194 Z M 8.256 7.181 L 6.678 9.811 C 6.738 9.895 6.789 9.985 6.831 10.081 L 10.081 10.081 C 10.123 9.985 10.174 9.895 10.234 9.811 L 8.656 7.181 C 8.59 7.19 8.524 7.194 8.456 7.194 C 8.388 7.194 8.321 7.19 8.256 7.181 Z\" fill=\"currentColor\"/>\n\n  </svg>",
  // 归档
  menu_archive: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n\n  <path d=\"M 13.402 .25 C 14.289 .25 15.027 .912 15.137 1.778 L 15.15 1.924 L 15.656 9.477 C 15.702 9.622 15.728 9.777 15.728 9.937 L 15.728 13.937 C 15.728 14.765 15.056 15.437 14.228 15.437 L 2.228 15.437 C 1.399 15.437 .728 14.765 .728 13.937 L .728 9.937 C .728 9.763 .757 9.596 .812 9.44 L 1.542 1.869 C 1.606 1.007 2.289 .329 3.136 .256 L 3.287 .25 L 13.402 .25 Z M 3.727 9.936 L 2.228 9.937 L 2.228 13.937 L 14.228 13.937 L 14.228 9.937 L 12.727 9.936 L 12.728 12.437 L 3.728 12.437 L 3.727 9.936 Z M 13.402 1.75 L 3.287 1.75 C 3.178 1.75 3.084 1.82 3.05 1.919 L 3.037 1.981 L 2.554 8.436 L 5.228 8.437 L 5.228 10.937 L 11.228 10.937 L 11.228 8.437 L 13.933 8.436 L 13.651 1.989 C 13.646 1.878 13.569 1.786 13.466 1.758 L 13.402 1.75 Z M 11.609 6.25 C 12.023 6.25 12.359 6.586 12.359 7 C 12.359 7.414 12.023 7.75 11.609 7.75 L 5.109 7.75 C 4.695 7.75 4.359 7.414 4.359 7 C 4.359 6.586 4.695 6.25 5.109 6.25 L 11.609 6.25 Z M 10.609 3.25 C 11.023 3.25 11.359 3.586 11.359 4 C 11.359 4.414 11.023 4.75 10.609 4.75 L 6.109 4.75 C 5.695 4.75 5.359 4.414 5.359 4 C 5.359 3.586 5.695 3.25 6.109 3.25 L 10.609 3.25 Z\" fill=\"currentColor\"/>\n\n  </svg>",
  // 本地归档
  menu_local_archive: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n\n  <path d=\"M 13.402 .25 C 14.289 .25 15.027 .912 15.137 1.778 L 15.15 1.924 L 15.656 9.477 C 15.702 9.622 15.728 9.777 15.728 9.937 L 15.728 13.937 C 15.728 14.765 15.056 15.437 14.228 15.437 L 2.228 15.437 C 1.399 15.437 .728 14.765 .728 13.937 L .728 9.937 C .728 9.763 .757 9.596 .812 9.44 L 1.542 1.869 C 1.606 1.007 2.289 .329 3.136 .256 L 3.287 .25 L 13.402 .25 Z M 3.727 9.936 L 2.228 9.937 L 2.228 13.937 L 14.228 13.937 L 14.228 9.937 L 12.727 9.936 L 12.728 12.437 L 3.728 12.437 L 3.727 9.936 Z M 13.402 1.75 L 3.287 1.75 C 3.178 1.75 3.084 1.82 3.05 1.919 L 3.037 1.981 L 2.554 8.436 L 5.228 8.437 L 5.228 10.937 L 11.228 10.937 L 11.228 8.437 L 13.933 8.436 L 13.651 1.989 C 13.646 1.878 13.569 1.786 13.466 1.758 L 13.402 1.75 Z M 11.609 6.25 C 12.023 6.25 12.359 6.586 12.359 7 C 12.359 7.414 12.023 7.75 11.609 7.75 L 5.109 7.75 C 4.695 7.75 4.359 7.414 4.359 7 C 4.359 6.586 4.695 6.25 5.109 6.25 L 11.609 6.25 Z M 10.609 3.25 C 11.023 3.25 11.359 3.586 11.359 4 C 11.359 4.414 11.023 4.75 10.609 4.75 L 6.109 4.75 C 5.695 4.75 5.359 4.414 5.359 4 C 5.359 3.586 5.695 3.25 6.109 3.25 L 10.609 3.25 Z\" fill=\"currentColor\"/>\n\n  </svg>",
  // 同步该文件夹
  menu_sync: "<svg width=\"16px\" height=\"13px\" viewBox=\"0 0 16 13\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n  <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n  <path d=\"M2.3931821,3.43093371 L4.32687599,6.4389488 L3.08577213,6.43891561 C3.08576369,7.67554306 3.55751694,8.91217314 4.50103188,9.85568808 C6.20577658,11.5604328 8.86740546,11.7250956 10.7570028,10.3496766 L11.9040566,11.4963774 C9.37680517,13.4934831 5.69812201,13.3253484 3.3647468,10.9919732 C2.10735822,9.73458459 1.47871675,8.08654265 1.47882237,6.43853352 L0.459488213,6.4389488 L2.3931821,3.43093371 Z M12.4707955,1.88592444 C13.7278739,3.14300282 14.3565154,4.79054183 14.3567199,6.43814438 L15.4594882,6.4389488 L13.5257943,9.4469639 L11.5921004,6.4389488 L12.7497702,6.43834203 C12.7496159,5.2019279 12.2778626,3.9655617 11.3345104,3.02220952 C9.54954084,1.23723992 6.71550639,1.14071469 4.81707691,2.73263384 L3.67692724,1.59349694 C6.20614823,-0.62453805 10.0578089,-0.527062217 12.4707955,1.88592444 Z\" fill=\"currentColor\" fill-rule=\"nonzero\"/>\n  </g>\n  </svg>",
  // 取消同步
  menu_cancel_sync: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"14px\" viewBox=\"0 0 16 14\">\n\n  <path d=\"M 2.393 3.931 L 4.327 6.939 L 3.086 6.939 C 3.086 8.176 3.558 9.412 4.501 10.356 C 6.206 12.06 8.867 12.225 10.757 10.85 L 11.904 11.996 C 9.377 13.993 5.698 13.825 3.365 11.492 C 2.107 10.235 1.479 8.587 1.479 6.939 L .459 6.939 L 2.393 3.931 Z M 12.471 2.386 C 13.728 3.643 14.357 5.291 14.357 6.938 L 15.459 6.939 L 13.526 9.947 L 11.592 6.939 L 12.75 6.938 C 12.75 5.702 12.278 4.466 11.335 3.522 C 9.55 1.737 6.716 1.641 4.817 3.233 L 3.677 2.093 C 6.206 -.125 10.058 -.027 12.471 2.386 Z M 8.975 4.907 C 9.256 4.627 9.711 4.627 9.991 4.907 C 10.272 5.188 10.272 5.643 9.991 5.923 L 8.975 6.939 L 9.991 7.955 C 10.272 8.235 10.272 8.69 9.991 8.971 C 9.711 9.251 9.256 9.251 8.975 8.971 L 7.959 7.955 L 6.944 8.971 C 6.663 9.251 6.208 9.251 5.928 8.971 C 5.647 8.69 5.647 8.235 5.928 7.955 L 6.944 6.939 L 5.928 5.923 C 5.647 5.643 5.647 5.188 5.928 4.907 C 6.208 4.627 6.663 4.627 6.944 4.907 L 7.959 5.923 Z\" fill=\"currentColor\"/>\n\n  </svg>",
  // 打开本地文件夹
  menu_open_local_folder: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"14px\" viewBox=\"0 0 16 14\">\n        <g transform=\"translate(0.000000, -1.000000)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n            <path d=\"M 6.4 1.5 L 8 3.125 L 14.4 3.125 C 15.28 3.125 16 3.856 16 4.75 L 16 12.875 C 16 13.769 15.28 14.5 14.4 14.5 L 1.6 14.5 C .72 14.5 0 13.769 0 12.875 L .008 3.125 C .008 2.231 .72 1.5 1.6 1.5 L 6.4 1.5 Z M 14.4 4.75 L 1.6 4.75 L 1.6 12.875 L 14.4 12.875 L 14.4 4.75 Z\" fill=\"currentColor\"/>\n        </g>\n</svg>",
  // 清除缓存
  menu_clear_cache: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n\n  <g transform=\"translate(0.727341, 0.114114)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n  <path d=\"M 14.745 14.421 L 13.736 8.604 L 14.077 8.604 C 14.351 8.604 14.572 8.383 14.572 8.109 L 14.572 4.454 C 14.572 4.18 14.351 3.959 14.077 3.959 L 9.394 3.959 L 9.394 .495 C 9.394 .221 9.173 0 8.899 0 L 5.853 0 C 5.579 0 5.359 .221 5.359 .495 L 5.359 3.959 L .676 3.959 C .402 3.959 .181 4.18 .181 4.454 L .181 8.109 C .181 8.383 .402 8.604 .676 8.604 L 1.016 8.604 L .008 14.421 C .002 14.45 0 14.478 0 14.505 C 0 14.779 .221 15 .495 15 L 14.258 15 C 14.286 15 14.315 14.998 14.341 14.992 C 14.612 14.947 14.793 14.69 14.745 14.421 Z M 1.513 5.292 L 6.691 5.292 L 6.691 1.332 L 8.062 1.332 L 8.062 5.292 L 13.239 5.292 L 13.239 7.272 L 1.513 7.272 L 1.513 5.292 Z M 10.422 13.668 L 10.422 10.698 C 10.422 10.614 10.353 10.546 10.27 10.546 L 9.356 10.546 C 9.272 10.546 9.204 10.614 9.204 10.698 L 9.204 13.668 L 5.549 13.668 L 5.549 10.698 C 5.549 10.614 5.48 10.546 5.397 10.546 L 4.483 10.546 C 4.399 10.546 4.331 10.614 4.331 10.698 L 4.331 13.668 L 1.49 13.668 L 2.349 8.718 L 12.402 8.718 L 13.26 13.668 L 10.422 13.668 Z\" fill=\"currentColor\"/>\n  </g>\n\n  </svg>",
  // 移至回收站
  menu_delete_to_transh: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n    <title>Artboard</title>\n\n        <g transform=\"translate(2.000000, 1.500000)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n            <path d=\"M8.25025961,0.722 L8.25025961,3.33066907e-16 L3.74974039,3.33066907e-16 L3.74974039,0.722 L2.30575914e-16,0.722 L2.30575914e-16,2.167 L0.749740395,2.167 L0.749740395,11.556 C0.749740395,12.35 1.42471443,13 2.25025961,13 L9.74974039,13 C10.5752856,13 11.2502596,12.35 11.2502596,11.556 L11.2502596,2.167 L12,2.167 L12,0.722 L8.25025961,0.722 Z M9.74974039,11.556 L2.25025961,11.556 L2.25025961,2.167 L9.74974039,2.167 L9.74974039,11.556 Z M3.74974039,3.611 L5.25025961,3.611 L5.25025961,10.111 L3.74974039,10.111 L3.74974039,3.611 Z M6.74974039,3.611 L8.25025961,3.611 L8.25025961,10.111 L6.74974039,10.111 L6.74974039,3.611 Z\">\n        </g>\n</svg>",
  // 永久删除
  menu_delete_fover: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n    <title>Artboard</title>\n\n        <g transform=\"translate(2.000000, 1.500000)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n            <path d=\"M8.25025961,0.722 L8.25025961,3.33066907e-16 L3.74974039,3.33066907e-16 L3.74974039,0.722 L2.30575914e-16,0.722 L2.30575914e-16,2.167 L0.749740395,2.167 L0.749740395,11.556 C0.749740395,12.35 1.42471443,13 2.25025961,13 L9.74974039,13 C10.5752856,13 11.2502596,12.35 11.2502596,11.556 L11.2502596,2.167 L12,2.167 L12,0.722 L8.25025961,0.722 Z M9.74974039,11.556 L2.25025961,11.556 L2.25025961,2.167 L9.74974039,2.167 L9.74974039,11.556 Z M3.74974039,3.611 L5.25025961,3.611 L5.25025961,10.111 L3.74974039,10.111 L3.74974039,3.611 Z M6.74974039,3.611 L8.25025961,3.611 L8.25025961,10.111 L6.74974039,10.111 L6.74974039,3.611 Z\">\n        </g>\n</svg>",
  // 恢复
  menu_recover: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"14px\" viewBox=\"0 0 16 14\">\n\n  <g transform=\"translate(0.460363, 0.185124)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n  <path d=\"M .087 4.097 C .117 4.161 .159 4.218 .211 4.266 L 3.282 7.313 C 3.564 7.593 4.02 7.593 4.302 7.313 C 4.439 7.18 4.516 6.997 4.516 6.806 C 4.516 6.615 4.439 6.433 4.302 6.3 L 2.47 4.481 L 9.578 4.481 C 11.775 4.481 13.554 6.246 13.554 8.426 C 13.554 10.606 11.775 12.372 9.578 12.372 L 2.346 12.372 C 2.154 12.371 1.969 12.446 1.832 12.582 C 1.696 12.717 1.619 12.901 1.618 13.093 C 1.618 13.493 1.944 13.815 2.346 13.815 L 9.578 13.815 C 12.571 13.815 15 11.405 15 8.434 C 15 5.463 12.571 3.052 9.578 3.052 L 2.47 3.052 L 4.302 1.226 C 4.438 1.092 4.514 .91 4.514 .719 C 4.514 .529 4.438 .346 4.302 .213 C 4.167 .077 3.984 1.367 e-16 3.792 1.367 e-16 C 3.6 1.367 e-16 3.417 .077 3.282 .213 L .211 3.252 C-.014 3.474 -.065 3.819 .087 4.097 L .087 4.097 Z\" fill=\"currentColor\"/>\n  </g>\n\n  </svg>",
  // 更多
  menu_more: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14px\" height=\"3px\" viewBox=\"0 0 14 3\">\n\n  <path d=\"M 1.498 2.687 C 2.188 2.687 2.748 2.127 2.748 1.437 C 2.748 .746 2.188 .187 1.498 .187 C .807 .187 .248 .746 .248 1.437 C .248 2.127 .807 2.687 1.498 2.687 Z M 6.762 2.687 C 7.453 2.687 8.012 2.127 8.012 1.437 C 8.012 .746 7.453 .187 6.762 .187 C 6.072 .187 5.512 .746 5.512 1.437 C 5.512 2.127 6.072 2.687 6.762 2.687 Z M 12.027 2.687 C 12.717 2.687 13.277 2.127 13.277 1.437 C 13.277 .746 12.717 .187 12.027 .187 C 11.336 .187 10.777 .746 10.777 1.437 C 10.777 2.127 11.336 2.687 12.027 2.687 Z\" fill=\"currentColor\"/>\n\n  </svg>",
  // 审批
  menu_eval: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"15px\" viewBox=\"0 0 16 15\">\n\n  <path d=\"M 8.228 -.008 C 12.368 -.008 15.728 3.352 15.728 7.492 C 15.728 11.632 12.368 14.992 8.228 14.992 C 4.088 14.992 .728 11.632 .728 7.492 C .728 3.352 4.088 -.008 8.228 -.008 Z M 8.228 1.492 C 4.92 1.492 2.228 4.184 2.228 7.492 C 2.228 10.799 4.92 13.492 8.228 13.492 C 11.535 13.492 14.228 10.799 14.228 7.492 C 14.228 4.184 11.535 1.492 8.228 1.492 Z M 11.734 10.323 L 11.734 11.743 L 4.721 11.743 L 4.721 10.323 L 11.734 10.323 Z M 10.836 3.506 L 12.007 4.443 L 7.557 10.005 L 4.589 7.82 L 5.478 6.612 L 7.286 7.943 L 10.836 3.506 Z\" fill=\"currentColor\"/>\n\n  </svg>",
  // 查看版本
  menu_show_ver: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"13px\" viewBox=\"0 0 16 13\">\n\n  <path d=\"M 15.698 8.329 C 15.899 8.696 15.755 9.153 15.377 9.348 L 8.69 12.799 C 8.464 12.916 8.192 12.916 7.964 12.8 L 1.196 9.35 C .817 9.156 .671 8.701 .87 8.332 C 1.07 7.964 1.539 7.822 1.919 8.016 L 8.323 11.281 L 14.647 8.018 C 15.026 7.822 15.496 7.962 15.698 8.329 Z M 8.662 .42 L 15.194 3.342 C 15.701 3.569 15.928 4.163 15.701 4.67 C 15.609 4.876 15.45 5.045 15.25 5.149 L 8.718 8.572 C 8.425 8.726 8.074 8.725 7.781 8.57 L 1.323 5.147 C .833 4.887 .646 4.279 .906 3.788 C 1.01 3.592 1.177 3.435 1.38 3.344 L 7.837 .422 C 8.099 .303 8.4 .302 8.662 .42 Z M 8.252 1.887 L 2.933 4.294 L 8.254 7.113 L 13.634 4.295 L 8.252 1.887 Z\" fill=\"currentColor\"/>\n\n  </svg>",
  // 查看相关文件
  menu_show_link_file: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"15px\" height=\"16px\" viewBox=\"0 0 15 16\">\n\n  <path d=\"M 11.472 10.004 C 11.869 10.004 12.19 10.325 12.19 10.722 L 12.19 12.158 L 13.627 12.158 C 14.024 12.158 14.345 12.48 14.345 12.877 C 14.345 13.273 14.024 13.595 13.627 13.595 L 12.19 13.595 L 12.19 15.032 C 12.19 15.428 11.869 15.75 11.472 15.75 C 11.075 15.75 10.754 15.428 10.754 15.032 L 10.754 13.595 L 9.317 13.595 C 8.92 13.595 8.599 13.273 8.599 12.877 C 8.599 12.48 8.92 12.158 9.317 12.158 L 10.754 12.158 L 10.754 10.722 C 10.754 10.325 11.075 10.004 11.472 10.004 Z M 7.903 .75 C 8.085 .75 8.259 .815 8.394 .932 L 8.471 1.008 L 11.991 5.03 C 12.087 5.14 12.149 5.275 12.17 5.418 L 12.177 5.527 L 12.177 7.538 C 12.177 7.955 11.84 8.292 11.423 8.292 C 11.041 8.292 10.726 8.009 10.676 7.64 L 10.669 7.538 L 10.669 6.001 L 6.857 6.002 L 6.856 2.258 L 1.618 2.258 L 1.678 12.048 L 5.449 12.048 C 5.831 12.048 6.147 12.332 6.197 12.7 L 6.204 12.803 C 6.204 13.185 5.92 13.5 5.552 13.55 L 5.449 13.557 L .924 13.557 C .542 13.557 .227 13.273 .177 12.905 L .17 12.803 L .11 1.504 C .11 1.122 .393 .807 .762 .757 L .864 .75 L 7.903 .75 Z\" fill=\"currentColor\"/>\n\n  </svg>\n  ",
  // 标记为已读
  menu_mark_read: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n\n  <path d=\"M 12.728 .453 C 14.384 .453 15.728 1.796 15.728 3.453 L 15.728 12.453 C 15.728 14.109 14.384 15.453 12.728 15.453 L 3.728 15.453 C 2.071 15.453 .728 14.109 .728 12.453 L .728 3.453 C .728 1.796 2.071 .453 3.728 .453 L 12.728 .453 Z M 12.728 1.953 L 3.728 1.953 C 2.899 1.953 2.228 2.624 2.228 3.453 L 2.228 12.453 C 2.228 13.281 2.899 13.953 3.728 13.953 L 12.728 13.953 C 13.556 13.953 14.228 13.281 14.228 12.453 L 14.228 3.453 C 14.228 2.624 13.556 1.953 12.728 1.953 Z M 8.228 5.953 C 9.332 5.953 10.228 6.848 10.228 7.953 C 10.228 9.057 9.332 9.953 8.228 9.953 C 7.123 9.953 6.228 9.057 6.228 7.953 C 6.228 6.848 7.123 5.953 8.228 5.953 Z\" fill=\"currentColor\"/>\n\n  </svg>",
  // 安全级别
  menu_security: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14px\" height=\"16px\" viewBox=\"0 0 14 16\">\n\n        <g transform=\"translate(-1.000000, 0.000000)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n            <g transform=\"translate(1.000000, 0.000000)\">\n                <path d=\"M 6.726 .053 C 6.894 -.018 7.083 -.018 7.251 .053 L 13.551 2.667 C 13.804 2.771 13.969 3.017 13.971 3.29 L 13.998 9.482 L 14 9.525 C 14 9.532 14 9.54 13.999 9.55 L 13.958 9.798 C 13.231 11.901 11.008 13.92 7.314 15.918 C 7.109 16.028 6.862 16.027 6.659 15.915 C 2.8 13.799 .582 11.773 .03 9.747 L .023 9.725 L .014 9.71 L .006 9.668 L 0 7.24 L .006 3.293 C .007 3.019 .172 2.773 .426 2.667 L 6.726 .053 Z M 6.988 1.416 L 1.37 3.748 L 1.365 8.571 L 1.367 9.367 L 1.365 9.392 C 1.363 9.412 1.358 9.429 1.348 9.392 L 1.352 9.405 L 1.397 9.554 C 1.858 10.923 3.474 12.466 6.263 14.123 L 6.603 14.323 L 6.991 14.542 L 7.388 14.32 C 10.253 12.676 11.984 11.067 12.599 9.538 L 12.633 9.446 L 12.633 8.731 L 12.608 3.748 L 6.988 1.416 Z M 6.991 4.97 C 7.407 4.97 7.744 5.305 7.744 5.72 L 7.744 7.223 L 9.253 7.223 C 9.67 7.223 10.007 7.559 10.007 7.974 C 10.007 8.389 9.67 8.725 9.253 8.725 L 7.744 8.725 L 7.744 10.228 C 7.744 10.643 7.407 10.978 6.991 10.978 C 6.574 10.978 6.237 10.643 6.237 10.228 L 6.237 8.725 L 4.728 8.725 C 4.311 8.725 3.974 8.389 3.974 7.974 C 3.974 7.559 4.311 7.223 4.728 7.223 L 6.237 7.223 L 6.237 5.72 C 6.237 5.305 6.574 4.97 6.991 4.97 Z\" fill=\"currentColor\"/>\n            </g>\n        </g>\n\n</svg>",
  // 传输文件
  // <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="15px" viewBox="0 0 18 15">

  // <path d="M 13.059 7.413 C 13.473 7.413 13.809 7.749 13.809 8.163 L 13.809 9.464 C 13.809 10.983 12.578 12.214 11.059 12.214 L 4.088 12.193 L 5.164 12.866 C 5.483 13.066 5.601 13.466 5.454 13.802 L 5.403 13.9 C 5.183 14.251 4.72 14.358 4.369 14.138 L 1.062 12.071 C .422 11.671 .707 10.683 1.462 10.685 L 11.055 10.714 C 11.749 10.714 12.309 10.155 12.309 9.464 L 12.309 8.163 C 12.309 7.749 12.645 7.413 13.059 7.413 Z M 4.923 7.101 C 4.508 7.101 4.173 6.765 4.173 6.351 L 4.173 5.037 C 4.173 3.522 5.399 2.292 6.914 2.287 L 13.581 2.268 L 12.375 1.597 C 12.043 1.413 11.906 1.014 12.04 .67 L 12.083 .577 C 12.285 .215 12.741 .085 13.103 .286 L 16.824 2.353 C 17.499 2.728 17.235 3.756 16.462 3.758 L 6.919 3.787 C 6.23 3.79 5.673 4.349 5.673 5.037 L 5.673 6.351 C 5.673 6.765 5.337 7.101 4.923 7.101 Z" fill="currentColor"/>

  // </svg>
  //查看详情
  menu_file_info: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n\n  <path d=\"M 7.195 11.696 L 8.695 11.696 L 8.695 7.196 L 7.195 7.196 L 7.195 11.696 Z M 7.945 .446 C 3.805 .446 .445 3.806 .445 7.946 C .445 12.086 3.805 15.446 7.945 15.446 C 12.085 15.446 15.445 12.086 15.445 7.946 C 15.445 3.806 12.085 .446 7.945 .446 Z M 7.945 13.946 C 4.638 13.946 1.945 11.253 1.945 7.946 C 1.945 4.638 4.638 1.946 7.945 1.946 C 11.253 1.946 13.945 4.638 13.945 7.946 C 13.945 11.253 11.253 13.946 7.945 13.946 Z M 7.195 5.696 L 8.695 5.696 L 8.695 4.196 L 7.195 4.196 L 7.195 5.696 Z\" fill=\"currentColor\"/>\n\n  </svg>",
  menu_msbox: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"15px\" viewBox=\"0 0 16 15\">\n\n  <path d=\"M 12.987 0 C 14.643 0 15.987 1.343 15.987 3 L 15.987 12 C 15.987 13.657 14.643 15 12.987 15 L 3.987 15 C 2.33 15 .987 13.657 .987 12 L .987 3 C .987 1.343 2.33 0 3.987 0 L 12.987 0 Z M 12.987 1.5 L 3.987 1.5 C 3.158 1.5 2.487 2.172 2.487 3 L 2.487 12 C 2.487 12.828 3.158 13.5 3.987 13.5 L 12.987 13.5 C 13.815 13.5 14.487 12.828 14.487 12 L 14.487 3 C 14.487 2.172 13.815 1.5 12.987 1.5 Z M 10.794 7.491 C 11.39 7.491 11.963 7.728 12.385 8.15 C 12.807 8.572 13.044 9.144 13.044 9.741 C 13.044 10.338 12.807 10.91 12.385 11.332 C 11.963 11.754 11.39 11.991 10.794 11.991 C 10.197 11.991 9.625 11.754 9.203 11.332 C 8.916 11.045 8.715 10.689 8.615 10.304 L 4.606 10.304 C 4.231 10.304 4.044 10.116 4.044 9.741 C 4.044 9.366 4.231 9.178 4.606 9.178 L 8.615 9.178 C 8.715 8.793 8.916 8.437 9.203 8.15 C 9.625 7.728 10.197 7.491 10.794 7.491 Z M 10.794 8.616 C 10.495 8.616 10.209 8.735 9.998 8.946 C 9.787 9.156 9.669 9.443 9.669 9.741 C 9.669 10.039 9.787 10.326 9.998 10.537 C 10.209 10.747 10.495 10.866 10.794 10.866 C 11.092 10.866 11.378 10.747 11.589 10.537 C 11.8 10.326 11.919 10.039 11.919 9.741 C 11.919 9.443 11.8 9.156 11.589 8.946 C 11.378 8.735 11.092 8.616 10.794 8.616 Z M 6.179 3.009 C 6.776 3.009 7.348 3.246 7.77 3.668 C 8.057 3.955 8.258 4.311 8.358 4.696 L 12.367 4.696 C 12.742 4.696 12.929 4.884 12.929 5.259 C 12.929 5.634 12.742 5.821 12.367 5.821 L 8.358 5.821 C 8.258 6.207 8.057 6.563 7.77 6.85 C 7.348 7.272 6.776 7.509 6.179 7.509 C 5.583 7.509 5.01 7.272 4.588 6.85 C 4.166 6.428 3.929 5.856 3.929 5.259 C 3.929 4.662 4.166 4.09 4.588 3.668 C 5.01 3.246 5.583 3.009 6.179 3.009 Z M 6.179 4.134 C 5.881 4.134 5.595 4.252 5.384 4.463 C 5.173 4.674 5.054 4.961 5.054 5.259 C 5.054 5.557 5.173 5.843 5.384 6.054 C 5.595 6.265 5.881 6.384 6.179 6.384 C 6.478 6.384 6.764 6.265 6.975 6.054 C 7.186 5.843 7.304 5.557 7.304 5.259 C 7.304 4.961 7.186 4.674 6.975 4.463 C 6.764 4.252 6.478 4.134 6.179 4.134 Z\" fill=\"currentColor\"/>\n\n  </svg>",
  menu_create_project: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n\n    <path d=\"M 12.278 .185 C 13.935 .185 15.278 1.528 15.278 3.185 L 15.278 12.185 C 15.278 13.842 13.935 15.185 12.278 15.185 L 3.278 15.185 C 1.622 15.185 .278 13.842 .278 12.185 L .278 3.185 C .278 1.528 1.622 .185 3.278 .185 L 12.278 .185 Z M 12.278 1.685 L 3.278 1.685 C 2.45 1.685 1.778 2.356 1.778 3.185 L 1.778 12.185 C 1.778 13.013 2.45 13.685 3.278 13.685 L 12.278 13.685 C 13.107 13.685 13.778 13.013 13.778 12.185 L 13.778 3.185 C 13.778 2.356 13.107 1.685 12.278 1.685 Z M 7.778 3.691 C 8.607 3.691 9.278 4.363 9.278 5.191 C 9.278 5.513 9.177 5.811 9.005 6.055 L 10.586 8.691 C 10.649 8.683 10.713 8.678 10.778 8.678 C 11.607 8.678 12.278 9.35 12.278 10.178 C 12.278 11.007 11.607 11.678 10.778 11.678 C 10.164 11.678 9.635 11.309 9.404 10.779 L 6.153 10.779 C 5.922 11.309 5.393 11.678 4.778 11.678 C 3.95 11.678 3.278 11.007 3.278 10.178 C 3.278 9.35 3.95 8.678 4.778 8.678 C 4.844 8.678 4.908 8.683 4.971 8.691 L 6.552 6.055 C 6.38 5.811 6.278 5.513 6.278 5.191 C 6.278 4.363 6.95 3.691 7.778 3.691 Z M 7.579 6.678 L 6 9.308 C 6.06 9.392 6.111 9.482 6.153 9.578 L 9.404 9.578 C 9.445 9.482 9.497 9.392 9.556 9.308 L 7.978 6.678 C 7.913 6.687 7.846 6.691 7.778 6.691 C 7.711 6.691 7.644 6.687 7.579 6.678 Z\" fill=\"currentColor\"/>\n\n  </svg>",
  // ##新建子素材库
  menu_new_library: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n\n          <path d=\"M 12.278 .045 C 13.935 .045 15.278 1.388 15.278 3.045 L 15.278 12.045 C 15.278 13.702 13.935 15.045 12.278 15.045 L 3.278 15.045 C 1.622 15.045 .278 13.702 .278 12.045 L .278 3.045 C .278 1.388 1.622 .045 3.278 .045 L 12.278 .045 Z M 9.488 7.264 L 5.373 11.381 C 4.917 11.836 4.197 11.867 3.707 11.472 L 3.605 11.381 L 1.778 9.554 L 1.778 12.045 C 1.778 12.873 2.45 13.545 3.278 13.545 L 12.278 13.545 C 13.107 13.545 13.778 12.873 13.778 12.045 L 13.778 11.554 L 9.488 7.264 Z M 12.278 1.545 L 3.278 1.545 C 2.45 1.545 1.778 2.216 1.778 3.045 L 1.778 7.433 L 4.489 10.143 L 8.605 6.027 C 9.093 5.539 9.885 5.539 10.373 6.027 L 13.778 9.433 L 13.778 3.045 C 13.778 2.216 13.107 1.545 12.278 1.545 Z\" fill=\"currentColor\"/>\n\n  </svg>",
  // ##新建分类
  menu_new_classify: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n\n          <path d=\"M 15.191 10.554 C 15.393 10.922 15.249 11.378 14.87 11.574 L 8.184 15.024 C 7.957 15.141 7.685 15.142 7.458 15.026 L .69 11.575 C .31 11.382 .164 10.926 .364 10.558 C .563 10.189 1.033 10.047 1.413 10.241 L 7.817 13.506 L 14.141 10.243 C 14.519 10.047 14.99 10.187 15.191 10.554 Z M 15.168 7.419 C 15.371 7.785 15.23 8.243 14.853 8.44 L 8.139 11.954 C 7.91 12.074 7.634 12.074 7.404 11.954 L .69 8.44 C .313 8.243 .172 7.785 .375 7.419 C .578 7.052 1.049 6.915 1.426 7.113 L 7.772 10.434 L 14.118 7.113 C 14.495 6.915 14.965 7.052 15.168 7.419 Z M 8.155 .645 L 14.688 3.567 C 15.194 3.794 15.421 4.388 15.195 4.895 C 15.102 5.101 14.944 5.27 14.744 5.375 L 8.212 8.797 C 7.918 8.951 7.568 8.95 7.275 8.795 L .817 5.372 C .327 5.112 .14 4.504 .4 4.014 C .504 3.817 .67 3.661 .873 3.569 L 7.331 .647 C 7.593 .528 7.893 .528 8.155 .645 Z M 7.745 2.113 L 2.427 4.519 L 7.747 7.339 L 13.127 4.52 L 7.745 2.113 Z\" fill=\"currentColor\"/>\n\n  </svg>",
  // #上传文件
  menu_new_upload_file: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n        <g transform=\"translate(1.500000, 1.500000)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n            <path d=\"M 0 8.938 L 1.625 8.938 L 1.625 11.375 L 11.375 11.375 L 11.375 8.938 L 13 8.938 L 13 11.375 C 13 12.269 12.269 13 11.375 13 L 1.625 13 C .731 13 0 12.269 0 11.375\" fill=\"currentColor\"/>\n            <polygon transform=\"translate(6.500000, 4.875000) scale(-1, 1) rotate(-180.000000) translate(-6.500000, -4.875000) \" points=\"9.416875 4.541875 7.3125 6.638125 7.3125 0 5.6875 0 5.6875 6.638125 3.583125 4.541875 2.4375 5.6875 6.5 9.75 10.5625 5.6875\" fill=\"currentColor\"/>\n        </g>\n</svg>",
  // ##解压
  menu_unzip: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"15px\" viewBox=\"0 0 16 15\">\n\n          <path d=\"M 7.778 9.311 C 8.071 9.311 8.363 9.604 8.363 9.896 L 8.363 12.721 L 9.142 11.941 C 9.239 11.844 9.434 11.747 9.532 11.747 C 9.629 11.747 9.824 11.844 9.921 11.941 C 10.116 12.136 10.116 12.526 9.921 12.721 L 8.168 14.474 C 8.071 14.571 7.973 14.669 7.681 14.669 C 7.486 14.669 7.291 14.474 7.291 14.474 L 5.636 12.721 C 5.441 12.526 5.441 12.136 5.636 11.941 C 5.733 11.844 5.928 11.747 6.025 11.747 C 6.123 11.747 6.317 11.844 6.415 11.941 L 7.194 12.721 L 7.194 9.896 C 7.194 9.604 7.486 9.311 7.778 9.311 Z M 3.98 1.617 C 4.369 1.617 4.661 1.909 4.661 2.298 C 4.661 2.688 4.369 3.078 3.882 3.078 L 2.129 3.078 C 1.934 3.078 1.739 3.272 1.739 3.467 L 1.739 12.136 C 1.739 12.331 1.934 12.526 2.129 12.526 L 4.272 12.526 C 4.661 12.526 5.051 12.818 5.051 13.305 C 5.051 13.792 4.661 14.084 4.272 14.084 L 2.129 14.084 C 1.058 14.084 .278 13.208 .278 12.234 L .278 3.467 C .278 2.396 1.155 1.617 2.129 1.617 L 3.98 1.617 Z M 13.428 1.519 C 14.499 1.519 15.278 2.396 15.278 3.37 L 15.278 12.039 C 15.278 13.208 14.402 14.084 13.428 14.084 L 11.674 14.084 C 11.285 14.084 10.895 13.792 10.895 13.305 C 10.895 12.818 11.187 12.526 11.674 12.526 L 13.428 12.526 C 13.623 12.526 13.817 12.331 13.817 12.136 L 13.817 3.467 C 13.817 3.272 13.623 3.078 13.428 3.078 L 11.674 3.078 C 11.285 3.078 10.895 2.785 10.895 2.298 C 10.895 1.811 11.187 1.519 11.674 1.519 L 13.428 1.519 Z M 11.967 7.071 C 12.454 7.071 12.746 7.461 12.746 7.85 C 12.746 8.337 12.356 8.63 11.967 8.63 L 3.687 8.63 C 3.2 8.63 2.908 8.24 2.908 7.85 C 2.908 7.461 3.2 7.071 3.59 7.071 Z M 7.778 .935 C 7.876 .935 8.071 1.032 8.168 1.13 L 9.921 2.883 C 10.116 3.078 10.116 3.467 9.921 3.662 C 9.726 3.857 9.337 3.857 9.142 3.662 L 8.363 2.883 L 8.363 5.708 C 8.363 6 8.071 6.292 7.778 6.292 C 7.486 6.292 7.194 6 7.194 5.708 L 7.194 2.98 L 6.415 3.76 C 6.22 3.954 5.83 3.954 5.636 3.76 C 5.441 3.565 5.441 3.175 5.636 2.98 C 5.636 2.883 7.291 1.13 7.389 1.13 C 7.486 1.032 7.681 .935 7.778 .935 Z\" fill=\"currentColor\"/>\n  </svg>",
  menu_link_file: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n  <path d=\"M 6.343 6.351 C 6.537 6.148 6.825 6.066 7.096 6.136 C 7.368 6.207 7.58 6.419 7.65 6.69 C 7.721 6.962 7.639 7.25 7.436 7.444 C 6.913 8.05 6.972 8.963 7.568 9.497 L 9.986 11.914 C 10.301 12.213 10.712 12.389 11.145 12.411 C 11.49 12.419 11.825 12.288 12.072 12.047 C 12.325 11.78 12.457 11.421 12.436 11.054 C 12.419 10.638 12.241 10.246 11.939 9.961 L 10.979 9 C 10.776 8.807 10.694 8.518 10.764 8.247 C 10.835 7.975 11.047 7.763 11.318 7.693 C 11.59 7.622 11.878 7.705 12.072 7.908 L 13.032 8.868 C 13.611 9.425 13.955 10.184 13.992 10.987 C 14.053 11.802 13.75 12.602 13.165 13.173 C 12.628 13.705 11.901 14.003 11.145 14 C 10.298 13.987 9.489 13.642 8.893 13.04 L 6.476 10.623 C 5.872 10.028 5.527 9.219 5.515 8.371 C 5.504 7.613 5.803 6.883 6.343 6.351 Z M 4.85 2 C 5.698 2.013 6.506 2.358 7.102 2.96 L 9.52 5.377 C 10.123 5.972 10.468 6.781 10.48 7.629 C 10.491 8.387 10.192 9.117 9.652 9.649 C 9.459 9.852 9.17 9.934 8.899 9.864 C 8.627 9.793 8.415 9.581 8.345 9.31 C 8.274 9.038 8.356 8.75 8.559 8.556 C 9.082 7.95 9.023 7.037 8.427 6.503 L 6.009 4.086 C 5.703 3.774 5.287 3.596 4.85 3.589 C 4.505 3.581 4.171 3.712 3.923 3.953 C 3.67 4.22 3.538 4.579 3.559 4.946 C 3.604 5.351 3.792 5.727 4.089 6.006 L 4.42 6.338 L 5.08 6.998 C 5.224 7.148 5.297 7.351 5.284 7.558 C 5.272 7.765 5.175 7.957 5.016 8.09 C 4.713 8.388 4.227 8.388 3.923 8.09 L 3.294 7.43 L 2.963 7.099 C 2.384 6.541 2.04 5.783 2.003 4.979 C 1.968 4.178 2.268 3.399 2.83 2.827 C 3.367 2.295 4.094 1.997 4.85 2 Z\" fill=\"currentColor\"/>\n\n  </svg>",
  menu_link_file2: "<svg stroke=\"currentColor\" fill=\"currentColor\" stroke-width=\"0\" viewBox=\"0 0 16 16\" height=\"1em\" width=\"1em\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6.354 5.5H4a3 3 0 0 0 0 6h3a3 3 0 0 0 2.83-4H9q-.13 0-.25.031A2 2 0 0 1 7 10.5H4a2 2 0 1 1 0-4h1.535c.218-.376.495-.714.82-1z\"></path><path d=\"M9 5.5a3 3 0 0 0-2.83 4h1.098A2 2 0 0 1 9 6.5h3a2 2 0 1 1 0 4h-1.535a4 4 0 0 1-.82 1H12a3 3 0 1 0 0-6z\"></path></svg>",
  menu_survey: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 55 55\" width=\"1em\" height=\"1em\"><defs><linearGradient x1=\"50%\" y1=\"0%\" x2=\"50%\" y2=\"100%\" id=\"menuSurveyGradient\"><stop stop-color=\"#11356A\" offset=\"0%\"></stop><stop stop-color=\"#102F64\" offset=\"100%\"></stop></linearGradient></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g fill=\"url(#menuSurveyGradient)\"><rect x=\"0\" y=\"0\" width=\"55\" height=\"55\" rx=\"14\"></rect></g><path d=\"M33.4363616,12.1321411 L19.1863616,12.1321411 C17.1863811,12.1321411 15.6030608,13.7154614 15.6030608,15.6321411 L15.6030608,38.6321411 C15.6030608,40.5488208 17.1863811,42.1321411 19.1863616,42.1321411 L37.1030413,42.1321411 C39.0197014,42.1321411 40.6863714,40.5488208 40.6863714,38.6321411 L40.6863714,19.215481 L33.4363616,12.1321411 Z M38.6030706,37.965481 C38.6030706,39.2987817 37.5197014,40.3821606 36.1863714,40.3821606 L20.0197405,40.3821606 C18.6864104,40.3821606 17.6030706,39.298811 17.6030706,37.9654517 L17.6030706,16.2988306 C17.6030706,14.9655298 18.6864104,13.8821606 20.0197405,13.8821606 L32.6863909,13.8821606 L32.6863909,18.2988403 C32.6863909,19.0488403 33.3530706,19.7154907 34.1030706,19.7154907 L38.5197503,19.7154907 L38.6030706,37.9655103 L38.6030706,37.965481 Z M27.6863811,28.5488208 L27.6030315,28.4654712 C27.103051,28.048811 26.353051,28.1321313 25.9363616,28.5488208 C25.4363811,29.0488013 25.4363811,29.8821216 25.9363616,30.3821313 L28.4363811,32.8821509 C28.5197014,32.9654712 28.5197014,33.0488208 28.603051,33.1321411 L28.6863714,33.1321411 C29.1863811,33.5488013 30.0197014,33.5488013 30.5197112,33.1321411 C30.6030315,33.0488208 30.6863811,32.9654712 30.6863811,32.8821509 L35.7696819,27.7154712 C36.269721,27.2154614 36.269721,26.3821411 35.7696819,25.8821313 C35.7696819,25.798811 35.6863616,25.798811 35.6030413,25.798811 C35.1030315,25.3821509 34.3530315,25.4654712 33.9363714,25.8821313 L29.519721,30.3821313 L27.6863811,28.5488208 L27.6863811,28.5488208 Z M23.2697014,26.4654614 C23.2697014,25.7154712 23.9363811,25.2154712 24.6863811,25.2154712 L28.019721,25.2154712 C28.769721,25.2154712 29.4363714,25.7987817 29.4363714,26.4654614 L29.4363714,26.8821509 L31.603051,26.8821509 L31.603051,25.048811 C31.603051,24.0488208 30.6863518,23.2154712 29.603051,23.2154712 L23.1030315,23.2154712 C22.019721,23.2154712 21.103051,24.0488208 21.103051,25.048811 L21.103051,30.9654614 C21.103051,31.965481 22.019721,32.7988013 23.1030315,32.7988013 L25.103051,32.7988013 L25.103051,30.7988208 L24.6863811,30.7988208 C23.9363811,30.7988208 23.2697014,30.2154712 23.2697014,29.548811 L23.2697014,26.4654614 Z\" fill=\"#FFFFFF\" fill-rule=\"nonzero\"></path></g></svg>",
  menu_link_file3: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"17px\" height=\"17px\" viewBox=\"0 0 17 17\">\n    <g id=\"Group-129\" transform=\"translate(0.624317, 0.325699)\">\n        <circle id=\"Oval\" fill=\"#775BB5\" cx=\"8\" cy=\"8\" r=\"8\"/>\n        <path d=\"M8.6643112,6.50918183 C8.7939346,6.50918183 8.91150886,6.56047314 8.9980978,6.64375173 L9.12225787,6.74369461 L9.24061532,6.85320388 L9.27973066,6.89228114 C10.1978499,7.81104725 10.1199998,9.26132004 9.20186784,10.1806696 L7.07213758,12.311034 C6.1527373,13.2298001 4.64866192,13.2298001 3.72926165,12.311034 L3.68955021,12.2713353 C2.77014993,11.3525818 2.77014993,9.84785961 3.68955021,8.92782517 L4.66763615,8.01259771 C4.69656678,7.97738885 4.7300634,7.94614986 4.76711133,7.91951492 L4.77714383,7.91012926 L4.84393987,7.87358568 C4.91287503,7.84012374 4.99025193,7.8213461 5.07203072,7.8213461 C5.36098184,7.8213461 5.59521716,8.05558143 5.59521716,8.34453254 C5.59521716,8.51065851 5.51769678,8.6585966 5.39693901,8.75444435 L4.4557615,9.69530478 C3.95649578,10.1933275 3.95649578,11.0055539 4.4557615,11.5047815 L4.49579001,11.5448354 C4.99504303,12.0434543 5.80667325,12.0434543 6.30590091,11.5448354 L8.43626534,9.41510514 C8.93550568,8.9158521 9.08454723,8.05678633 8.58530688,7.55816746 L8.54559544,7.51844334 C8.50390542,7.47675331 8.45932358,7.43987025 8.41390466,7.40241644 C8.3688916,7.37498245 8.32879968,7.34033165 8.29510012,7.30013825 L8.24788591,7.2330285 C8.20639782,7.16188703 8.18261187,7.0791665 8.18261187,6.99088117 C8.18261187,6.7248488 8.39826614,6.50918183 8.6643112,6.50918183 Z M8.92795911,3.68944161 C9.84735939,2.77004134 11.3514348,2.77004134 12.2708224,3.68944161 L12.3105338,3.72915305 C13.2299341,4.64854063 13.2299341,6.15264139 12.3098616,7.07202901 L11.3211977,7.98430126 C11.2877265,8.02642253 11.2479136,8.06326754 11.2030908,8.09327624 L11.188543,8.10670786 C11.1076996,8.15250729 11.0145534,8.18071496 10.9147992,8.18071496 C10.6281818,8.18071496 10.3958363,7.94835677 10.3958363,7.66175207 C10.3958363,7.49074303 10.4785949,7.33907604 10.6062143,7.24452198 L11.5443098,6.30579234 C12.0435502,5.80717347 12.0435502,4.99463007 11.5443098,4.49536435 L11.504573,4.45628709 C11.00532,3.95703405 10.1934107,3.95703405 9.69541335,4.45628709 L7.56442745,6.58603003 C7.06519978,7.0852577 6.87562239,7.81055264 7.37485005,8.3097803 L7.41394001,8.34823609 C7.49177746,8.42608622 7.60431645,8.50826137 7.66443532,8.64324982 L7.68901182,8.70536185 C7.70239788,8.74821546 7.70961327,8.79378799 7.70961327,8.84104599 C7.70961327,9.09217547 7.50602082,9.29579329 7.25486597,9.29579329 C7.17244985,9.29579329 7.09522118,9.2737497 7.0285704,9.23542074 C6.98565009,9.21056146 6.9480314,9.17994395 6.91600605,9.14417703 C6.87176668,9.10643151 6.82842782,9.06707521 6.78667437,9.02533444 L6.7475971,8.98685328 C5.82819683,8.06685689 5.87882859,6.73919363 6.79822886,5.81979335 Z\" fill=\"#FFFFFF\" fill-rule=\"nonzero\"/>\n    </g>\n  </svg>",
  menu_task: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n\n    <path d=\"M 9.969 .012 L 10.748 1.961 C 11.132 2.108 11.498 2.297 11.838 2.526 L 13.828 2.239 L 15.585 5.285 L 14.196 7.049 C 14.215 7.357 14.215 7.666 14.196 7.973 L 15.585 9.738 L 13.827 12.783 L 11.838 12.497 C 11.497 12.726 11.132 12.916 10.748 13.062 L 9.968 15.012 L 6.453 15.012 L 5.673 13.064 C 5.29 12.918 4.924 12.728 4.583 12.499 L 2.594 12.786 L .836 9.74 L 2.226 7.976 C 2.207 7.668 2.207 7.359 2.226 7.051 L .836 5.286 L 2.594 2.241 L 4.583 2.527 C 4.924 2.298 5.29 2.109 5.673 1.962 L 6.453 .012 L 9.969 .012 Z M 8.953 1.512 L 7.469 1.512 L 6.823 3.129 L 6.209 3.363 C 5.931 3.47 5.666 3.607 5.419 3.773 L 4.94 4.093 L 3.385 3.87 L 2.643 5.156 L 3.758 6.573 L 3.723 7.144 C 3.708 7.391 3.708 7.638 3.723 7.884 L 3.758 8.454 L 2.643 9.87 L 3.385 11.156 L 4.94 10.932 L 5.419 11.254 C 5.666 11.419 5.931 11.557 6.209 11.663 L 6.822 11.897 L 7.468 13.512 L 8.953 13.512 L 9.599 11.895 L 10.213 11.661 C 10.491 11.555 10.756 11.417 11.003 11.251 L 11.481 10.931 L 13.036 11.154 L 13.778 9.868 L 12.664 8.452 L 12.699 7.881 C 12.715 7.635 12.715 7.388 12.699 7.141 L 12.664 6.572 L 13.778 5.155 L 13.036 3.869 L 11.481 4.093 L 11.002 3.771 C 10.755 3.606 10.49 3.468 10.212 3.362 L 9.599 3.128 L 8.953 1.512 Z M 6.711 4.512 L 11.211 7.512 L 6.711 10.512 L 6.711 4.512 Z\" fill=\"currentColor\"/>\n\n  </svg>",
  menu_task_clear: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\">\n\n    <path d=\"M 15.92 15.063 L 14.895 9.149 L 15.241 9.149 C 15.52 9.149 15.744 8.924 15.744 8.645 L 15.744 4.929 C 15.744 4.65 15.52 4.426 15.241 4.426 L 10.48 4.426 L 10.48 .903 C 10.48 .625 10.255 .4 9.976 .4 L 6.88 .4 C 6.601 .4 6.376 .625 6.376 .903 L 6.376 4.426 L 1.615 4.426 C 1.336 4.426 1.112 4.65 1.112 4.929 L 1.112 8.645 C 1.112 8.924 1.336 9.149 1.615 9.149 L 1.962 9.149 L .936 15.063 C .93 15.092 .928 15.121 .928 15.149 C .928 15.427 1.153 15.652 1.431 15.652 L 15.425 15.652 C 15.454 15.652 15.483 15.65 15.51 15.644 C 15.785 15.598 15.969 15.336 15.92 15.063 Z M 2.467 5.781 L 7.731 5.781 L 7.731 1.755 L 9.125 1.755 L 9.125 5.781 L 14.389 5.781 L 14.389 7.794 L 2.467 7.794 L 2.467 5.781 Z M 11.525 14.297 L 11.525 11.278 C 11.525 11.192 11.455 11.123 11.37 11.123 L 10.441 11.123 C 10.356 11.123 10.286 11.192 10.286 11.278 L 10.286 14.297 L 6.57 14.297 L 6.57 11.278 C 6.57 11.192 6.5 11.123 6.415 11.123 L 5.486 11.123 C 5.401 11.123 5.331 11.192 5.331 11.278 L 5.331 14.297 L 2.444 14.297 L 3.316 9.265 L 13.538 9.265 L 14.411 14.297 L 11.525 14.297 Z\" fill=\"currentColor\"/>\n\n  </svg>",
  menu_task_rename: "<svg width=\"55px\" height=\"55px\" viewBox=\"0 0 55 55\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <title>\u81EA\u52A8\u91CD\u547D\u540D</title>\n    <g id=\"\u81EA\u52A8\u91CD\u547D\u540D\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <rect id=\"\u77E9\u5F62\u5907\u4EFD\" fill=\"#F5F5F5\" x=\"0\" y=\"0\" width=\"55\" height=\"55\" rx=\"14\"></rect>\n        <g id=\"\u7F16\u7EC4\" transform=\"translate(14.362400, 15.594050)\" fill=\"#000000\">\n            <path d=\"M13.4463336,2.4633 L11.4954,2.4633 L11.4954,0 L13.54815,0 C15.1098822,0 16.5106788,0.3793482 17.5074942,1.3778058 L17.65365,1.5305304 C17.7012738,1.4796222 17.7488976,1.4270718 17.7998058,1.3778058 C18.7966212,0.3793482 20.1974178,0 21.75915,0 L23.8119,0 L23.8119,2.4633 L21.75915,2.4633 C20.560344,2.4633 19.9051062,2.7556116 19.54218,3.12018 C19.1776116,3.4831062 18.8853,4.138344 18.8853,5.33715 L18.8853,18.47475 C18.8853,19.673556 19.1776116,20.3287938 19.54218,20.69172 C19.9051062,21.0562884 20.560344,21.3486 21.75915,21.3486 L23.8119,21.3486 L23.8119,23.8119 L21.75915,23.8119 C20.1974178,23.8119 18.7966212,23.4325518 17.7998058,22.4340942 C17.7497947,22.3844388 17.7010602,22.333514 17.65365,22.2813696 C17.6062398,22.333514 17.5575053,22.3844388 17.5074942,22.4340942 C16.5106788,23.4325518 15.1098822,23.8119 13.54815,23.8119 L11.4954,23.8119 L11.4954,21.3486 L13.54815,21.3486 C14.746956,21.3486 15.4021938,21.0562884 15.76512,20.69172 C16.1296884,20.3287938 16.422,19.6768404 16.422,18.4780344 L16.422,5.33715 C16.422,4.138344 16.1296884,3.4831062 15.76512,3.12018 C15.4021938,2.7556116 14.746956,2.4633 13.54815,2.4633 L13.4446914,2.4633 L13.4463336,2.4633 Z\" id=\"\u8DEF\u5F84\"></path>\n            <path d=\"M21.3486,18.0642 L26.2752,18.0642 L26.2752,5.7477 L21.3486,5.7477 L21.3486,8.211 L23.8119,8.211 L23.8119,15.6009 L21.3486,15.6009 L21.3486,18.0642 Z M13.9587,13.1376 L4.9266,13.1376 L4.9266,10.6743 L13.9587,10.6743 L13.9587,13.1376 Z M13.9587,8.211 L2.4633,8.211 L2.4633,15.6009 L13.9587,15.6009 L13.9587,18.0642 L0,18.0642 L0,5.7477 L13.9587,5.7477 L13.9587,8.211 Z\" id=\"\u5F62\u72B6\"></path>\n        </g>\n    </g>\n  </svg>",
  menu_time: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"17px\" height=\"16px\" viewBox=\"0 0 17 16\">\n\n  <g transform=\"translate(-1746.000000, -1195.000000)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n      <g transform=\"translate(1746.641609, 1195.396301)\">\n          <polygon points=\"7 7 5 7 5 8.5 8.5 8.5 8.5 3.5 7 3.5\" fill=\"currentColor\"/>\n          <path d=\"M 7.75 0 C 2.535 0 0 2.535 0 7.75 C 0 12.965 2.535 15.5 7.75 15.5 C 12.965 15.5 15.5 12.965 15.5 7.75 C 15.5 2.535 12.965 0 7.75 0 Z M 7.75 14 C 3.428 14 1.5 12.073 1.5 7.75 C 1.5 3.428 3.428 1.5 7.75 1.5 C 12.073 1.5 14 3.428 14 7.75 C 14 12.073 12.073 14 7.75 14 Z\" fill=\"currentColor\"/>\n      </g>\n  </g>\n\n  </svg>",
  menu_tool_move: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"17px\" height=\"17px\" viewBox=\"0 0 17 17\">\n\n  <g transform=\"translate(-667.000000, -382.000000)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n      <g transform=\"translate(667.497803, 382.090759)\">\n          <polygon points=\"11.09 3.03 8.06 4.4408921e-16 5.03 3.03 6.09 4.09 7.31 2.87 7.31 7.31 2.87 7.31 4.09 6.09 3.03 5.03 0 8.06 3.03 11.09 4.09 10.03 2.87 8.81 7.31 8.81 7.31 13.249 6.091 12.029 5.031 13.091 8.061 16.121 11.091 13.091 10.031 12.03 8.81 13.25 8.81 8.81 13.25 8.81 12.03 10.03 13.091 11.09 16.121 8.06 13.091 5.03 12.031 6.09 13.25 7.31 8.81 7.31 8.81 2.87 10.03 4.09\" fill=\"currentColor\"/>\n      </g>\n  </g>\n\n</svg>",
  menu_tool_remove: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"17px\" viewBox=\"0 0 16 17\">\n\n  <g transform=\"translate(-629.000000, -381.000000)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n      <g transform=\"translate(629.054688, 381.462402)\">\n          <path d=\"M 15.5 3 L 11.5 3 L 11.5 2.25 C 11.5 1.007 10.493 0 9.25 0 L 6.253 0 C 5.655 0 5.082 .238 4.66 .661 C 4.238 1.084 4.002 1.657 4.003 2.255 L 4.003 3 L 0 3 L 0 4.5 L 1.591 4.5 L 2.836 14.041 C 2.985 15.16 3.938 15.997 5.067 16 L 10.433 16 C 11.562 15.997 12.515 15.16 12.664 14.041 L 13.908 4.5 L 15.5 4.5 L 15.5 3 Z M 5.503 2.25 C 5.503 1.836 5.839 1.5 6.253 1.5 L 9.25 1.5 C 9.664 1.5 10 1.836 10 2.25 L 10 3 L 5.505 3 L 5.503 2.25 Z M 11.177 13.845 C 11.129 14.219 10.811 14.5 10.433 14.5 L 5.067 14.5 C 4.69 14.5 4.371 14.22 4.323 13.846 L 3.104 4.5 L 12.396 4.5 L 11.177 13.845 Z\" fill=\"currentColor\"/>\n      </g>\n  </g>\n\n</svg>",
  menu_tool_info: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"17px\" viewBox=\"0 0 16 17\">\n\n<g transform=\"translate(-578.000000, -321.000000)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n    <g transform=\"translate(578.152832, 321.961182)\">\n        <path d=\"M 7.75 0 C 2.535 0 0 2.535 0 7.75 C 0 12.965 2.535 15.5 7.75 15.5 C 12.965 15.5 15.5 12.965 15.5 7.75 C 15.5 2.535 12.965 0 7.75 0 Z M 7.75 14 C 3.428 14 1.5 12.073 1.5 7.75 C 1.5 3.428 3.428 1.5 7.75 1.5 C 12.073 1.5 14 3.428 14 7.75 C 14 12.073 12.073 14 7.75 14 Z\" fill=\"currentColor\"/>\n        <path d=\"M 7.75 4 C 7.447 4 7.173 4.183 7.057 4.463 C 6.941 4.743 7.005 5.066 7.22 5.28 C 7.434 5.495 7.757 5.559 8.037 5.443 C 8.317 5.327 8.5 5.053 8.5 4.75 C 8.512 4.548 8.437 4.35 8.293 4.207 C 8.15 4.063 7.952 3.988 7.75 4 L 7.75 4 Z M 7 6.405 L 7 11.5 L 8.5 11.5 L 8.5 6.405 C 8.008 6.532 7.492 6.532 7 6.405 L 7 6.405 Z\" fill=\"currentColor\"/>\n    </g>\n</g>\n\n</svg>",
  menu_task_organize: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"14px\" viewBox=\"0 0 16 14\">\n\n<path d=\"M 4.418 2.525 C 5.091 2.524 5.707 2.905 6.008 3.508 L 6.304 4.104 L 13.586 4.104 L 13.586 11.406 C 13.586 12.387 12.791 13.183 11.81 13.183 L 2.731 13.183 C 1.75 13.183 .955 12.387 .955 11.406 L .955 2.525 L 4.418 2.525 Z M 4.418 3.709 L 2.139 3.709 L 2.139 11.406 C 2.139 11.733 2.404 11.998 2.731 11.998 L 11.81 11.998 C 12.137 11.998 12.402 11.733 12.402 11.406 L 12.402 5.288 L 5.573 5.288 L 4.947 4.036 C 4.847 3.836 4.642 3.709 4.418 3.709 Z M 6.786 .156 C 7.459 .156 8.075 .537 8.376 1.139 L 8.674 1.735 L 15.955 1.735 L 15.955 9.038 C 15.955 9.791 15.481 10.462 14.771 10.713 L 14.771 2.919 L 7.941 2.919 L 7.316 1.668 C 7.216 1.468 7.011 1.341 6.787 1.34 L 2.929 1.34 L 2.929 .156 L 6.786 .156 Z\" fill=\"currentColor\"/>\n\n</svg>",
  menu_task_con: "<svg width=\"55px\" height=\"55px\" viewBox=\"0 0 55 55\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n<title>\u81EA\u52A8\u8F6Cpdf</title>\n<g id=\"\u81EA\u52A8\u8F6Cpdf\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n    <g id=\"pdf\">\n        <g id=\"Group-12-Copy-3\" fill=\"#CA0909\">\n            <rect id=\"Rectangle-921-Copy-2\" x=\"0\" y=\"0\" width=\"55\" height=\"55\" rx=\"14\"></rect>\n        </g>\n        <path d=\"M13.1775545,35.9340306 L17.8489926,35.9340306 C18.7724484,35.9340306 19.5168557,36.1943376 20.0822368,36.7149594 C20.647618,37.2355812 20.9303043,37.967032 20.9303043,38.9093339 C20.9303043,39.7197135 20.6782423,40.4252514 20.1741108,41.0259689 C19.6699793,41.6266863 18.8949477,41.9270405 17.8489926,41.9270405 L14.583933,41.9270405 L14.583933,46.3157895 L13.1775545,46.3157895 L13.1775545,35.9340306 Z M18.6617239,37.3616108 C18.3507643,37.215554 17.9243791,37.1425267 17.3825555,37.1425267 L14.583933,37.1425267 L14.583933,40.7397461 L17.3825555,40.7397461 C18.0138978,40.7397461 18.5262667,40.6054701 18.9196777,40.3369141 C19.3130888,40.068358 19.5097913,39.5948584 19.5097913,38.9164011 C19.5097913,38.1531366 19.227105,37.6348784 18.6617239,37.3616108 L18.6617239,37.3616108 Z M27.4067126,45.1143606 C27.882575,45.1143606 28.2736244,45.0648905 28.5798725,44.9659488 C29.1264076,44.7821999 29.5739943,44.428842 29.922646,43.9058645 C30.200625,43.4865402 30.4008612,42.9494362 30.5233604,42.2945364 C30.594033,41.9034811 30.6293688,41.5407003 30.6293688,41.2061832 C30.6293688,39.9199411 30.3737733,38.9211162 29.8625745,38.2096782 C29.3513758,37.4982403 28.5280519,37.1425267 27.3925781,37.1425267 L24.8978464,37.1425267 L24.8978464,45.1143606 L27.4067126,45.1143606 Z M23.4844007,35.9340306 L27.6894017,35.9340306 C29.116989,35.9340306 30.2241771,36.4405103 31.0109992,37.4534848 C31.7130141,38.3675176 32.0640162,39.5383101 32.0640162,40.9658974 C32.0640162,42.0683906 31.8567129,43.0648599 31.4421001,43.9553351 C30.7118162,45.5289792 29.4562178,46.3157895 27.6752673,46.3157895 L23.4844007,46.3157895 L23.4844007,35.9340306 Z M34.7311883,35.9340306 L41.9326943,35.9340306 L41.9326943,37.2061318 L36.1375668,37.2061318 L36.1375668,40.3581157 L41.2330387,40.3581157 L41.2330387,41.5948808 L36.1375668,41.5948808 L36.1375668,46.3157895 L34.7311883,46.3157895 L34.7311883,35.9340306 Z\" id=\"PDF\" fill=\"#FFFFFF\"></path>\n        <path d=\"M27.0015678,8.27315312 C26.27014,8.32525359 26.4135353,11.0169758 26.805557,12.7808618 C27.2408313,11.6657895 27.7329956,8.22105265 27.0015678,8.27315312 Z M17.3970366,30.0277473 C18.5731017,29.8317599 19.7491667,28.6558359 20.9252318,26.3039879 C20.5332101,26.4999752 17.8897098,28.3973686 17.3970366,30.0277473 Z M34.1311314,22.9842108 C34.1311314,23.476316 39.052774,24.4605266 39.1542399,23.5601652 C39.2557058,22.6598039 34.1311314,22.4921055 34.1311314,22.9842108 Z M32.0978497,23.9521399 C28.7656654,24.3441146 24.7800099,24.9526315 23.7956813,25.936842 C22.8113527,26.9210526 19.4577965,31.8421053 17.8897097,31.8421053 C17.4976881,31.8421053 16.9053812,31.8421053 16.4132169,31.35 C15.9210526,30.8578947 15.9210526,30.2656589 15.9210526,29.8736842 C15.9210526,26.9210526 20.5508165,25.3240505 21.3348598,24.9320758 C21.9228923,23.9521391 22.6893293,22.5802285 23.4733727,21.2083172 C24.4534269,19.2484439 25.0414594,17.2885705 25.6294919,15.5246845 C24.8454486,13.1728365 24.2878456,7.23684211 26.748667,7.23684211 C30.1938171,7.23684211 28.3736437,15.1327098 28.3736437,15.1327098 C29.1576871,17.2885705 30.6859813,20.5236844 33.2739147,21.4043045 C33.2739147,21.4043045 40.5263158,21.0833575 40.5263158,23.7561525 C40.5263158,26.4289476 34.0579581,24.9320766 32.0978497,23.9521399 Z M23.303517,24.4605266 C23.303517,24.4605266 28.1853675,22.5999697 31.1781456,22.4921055 C29.1696958,21.1236539 28.0248747,18.3507282 27.2408313,16.5868422 C26.8488096,17.9587536 24.7102968,23.29661 23.303517,24.4605266 Z\" id=\"Shape\" fill=\"#FFFFFF\"></path>\n    </g>\n</g>\n</svg>",
  menu_task_time: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"17px\" height=\"16px\" viewBox=\"0 0 17 16\">\n\n<g transform=\"translate(-1746.000000, -1195.000000)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n    <g transform=\"translate(1746.641609, 1195.396301)\">\n        <polygon points=\"7 7 5 7 5 8.5 8.5 8.5 8.5 3.5 7 3.5\" fill=\"currentColor\"/>\n        <path d=\"M 7.75 0 C 2.535 0 0 2.535 0 7.75 C 0 12.965 2.535 15.5 7.75 15.5 C 12.965 15.5 15.5 12.965 15.5 7.75 C 15.5 2.535 12.965 0 7.75 0 Z M 7.75 14 C 3.428 14 1.5 12.073 1.5 7.75 C 1.5 3.428 3.428 1.5 7.75 1.5 C 12.073 1.5 14 3.428 14 7.75 C 14 12.073 12.073 14 7.75 14 Z\" fill=\"currentColor\"/>\n    </g>\n</g>\n\n</svg>",
  error_cicle: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14px\" height=\"14px\" viewBox=\"0 0 14 14\">\n\n<g transform=\"translate(-27.000000, -274.000000)\" fill=\"#FF0000\" fill-rule=\"nonzero\">\n    <g transform=\"translate(27.250000, 274.787598)\">\n        <path d=\"M 6.5 0 C 2.126 0 0 2.126 0 6.5 C 0 10.874 2.126 13 6.5 13 C 10.874 13 13 10.874 13 6.5 C 13 2.126 10.874 0 6.5 0 Z M 6.5 11.742 C 2.875 11.742 1.258 10.126 1.258 6.5 C 1.258 2.875 2.875 1.258 6.5 1.258 C 10.126 1.258 11.742 2.875 11.742 6.5 C 11.742 10.126 10.126 11.742 6.5 11.742 Z\" fill=\"#FF0000\"/>\n        <path d=\"M 6.5 3.355 C 6.246 3.355 6.016 3.508 5.919 3.743 C 5.821 3.978 5.875 4.249 6.055 4.429 C 6.235 4.609 6.506 4.662 6.741 4.565 C 6.976 4.468 7.129 4.238 7.129 3.984 C 7.139 3.814 7.076 3.648 6.956 3.528 C 6.835 3.408 6.67 3.345 6.5 3.355 L 6.5 3.355 Z M 5.871 5.372 L 5.871 9.645 L 7.129 9.645 L 7.129 5.372 C 6.716 5.478 6.284 5.478 5.871 5.372 L 5.871 5.372 Z\" fill=\"#FF0000\"/>\n    </g>\n</g>\n\n</svg>,",
  banned_file: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16px\" height=\"14px\" viewBox=\"0 0 16 14\">\n\n<path d=\"M 7.999 0 C 8.735 0 9.549 .325 9.972 1.067 L 15.762 11.19 C 16.146 11.859 16.039 12.593 15.631 13.132 C 15.231 13.662 14.556 14 13.791 14 L 2.209 14 C 1.486 14.011 .801 13.689 .368 13.132 C-.07 12.566 -.121 11.806 .237 11.19 L 6.027 1.067 C 6.452 .326 7.263 0 7.999 0 Z M 8 9.528 C 7.31 9.528 6.75 10.083 6.75 10.766 L 6.75 10.791 C 6.75 11.475 7.31 12.029 8 12.029 C 8.691 12.029 9.25 11.475 9.25 10.791 L 9.25 10.766 C 9.25 10.083 8.691 9.528 8 9.528 Z M 8 2 C 7.735 2 7.481 2.105 7.293 2.293 C 7.106 2.48 7 2.735 7 3 L 7 7 C 7 7.552 7.448 8 8 8 C 8.553 8 9 7.552 9 7 L 9 3 C 9 2.735 8.895 2.48 8.707 2.293 C 8.52 2.105 8.265 2 8 2 Z\" fill=\"#D81E06\"/>\n\n</svg>",
  menu_key: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20px\" height=\"11px\" viewBox=\"0 0 20 11\">\n\n<g transform=\"translate(0.163757, 0.568970)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n    <path d=\"M 3.583 6.417 C 3.194 6.028 3 5.556 3 5 C 3 4.444 3.194 3.972 3.583 3.583 C 3.972 3.194 4.444 3 5 3 C 5.556 3 6.028 3.194 6.417 3.583 C 6.806 3.972 7 4.444 7 5 C 7 5.556 6.806 6.028 6.417 6.417 C 6.028 6.806 5.556 7 5 7 C 4.444 7 3.972 6.806 3.583 6.417 Z M 5 10 C 3.611 10 2.431 9.514 1.458 8.542 C .486 7.569 0 6.389 0 5 C 0 3.611 .486 2.431 1.458 1.458 C 2.431 .486 3.611 0 5 0 C 5.903 0 6.736 .226 7.5 .677 C 8.264 1.128 8.875 1.736 9.333 2.5 L 16.5 2.5 L 19 5 L 15.25 8.5 L 13.5 7.25 L 12 8.5 L 10 7 L 9.583 7 C 9.25 7.944 8.656 8.681 7.802 9.208 C 6.948 9.736 6.014 10 5 10 Z M 5 8.5 C 5.875 8.5 6.646 8.219 7.313 7.656 C 7.979 7.094 8.361 6.375 8.458 5.5 L 10.5 5.5 L 11.958 6.583 L 13.438 5.354 L 15.125 6.563 L 16.833 4.979 L 15.875 4 L 8.354 4 C 8.09 3.264 7.656 2.663 7.052 2.198 C 6.448 1.733 5.764 1.5 5 1.5 C 4.028 1.5 3.201 1.84 2.521 2.521 C 1.84 3.201 1.5 4.028 1.5 5 C 1.5 5.972 1.84 6.799 2.521 7.479 C 3.201 8.16 4.028 8.5 5 8.5 Z\" fill=\"currentColor\"/>\n</g>\n\n</svg>",
  menu_doc: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"13px\" height=\"17px\" viewBox=\"0 0 13 17\">\n\n<g transform=\"translate(0.156414, 0.568970)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n    <path d=\"M 3.083 8.417 L 8.917 8.417 L 8.917 7.083 L 3.083 7.083 L 3.083 8.417 Z M 3.083 10.917 L 8.917 10.917 L 8.917 9.583 L 3.083 9.583 L 3.083 10.917 Z M 3.083 13.417 L 6.708 13.417 L 6.708 12.083 L 3.083 12.083 L 3.083 13.417 Z M 1.494 16 C 1.081 16 .729 15.853 .438 15.559 C .146 15.266 0 14.912 0 14.5 L 0 1.5 C 0 1.087 .147 .734 .441 .441 C .734 .147 1.087 0 1.5 0 L 8 0 L 12 4 L 12 14.5 C 12 14.912 11.853 15.266 11.559 15.559 C 11.265 15.853 10.912 16 10.499 16 L 1.494 16 Z M 7 5 L 7 1.5 L 1.5 1.5 L 1.5 14.5 L 10.5 14.5 L 10.5 5 L 7 5 Z M 1.54 1.5 L 1.54 5 L 1.54 1.5 L 1.54 14.5 L 1.54 1.5 Z\" fill=\"currentColor\"/>\n</g>\n\n</svg>",
  menu_download_link: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18px\" height=\"16px\" viewBox=\"0 0 18 16\">\n\n<path d=\"M 10.219 1.471 C 10.219 1.545 10.366 1.692 10.586 2.06 C 10.807 2.427 11.027 2.795 11.321 3.383 C 11.616 3.971 11.983 4.486 12.351 5.148 C 12.719 5.81 13.16 6.471 13.527 7.133 C 13.895 7.795 14.336 8.53 14.704 9.192 C 15.071 9.854 15.439 10.515 15.807 11.03 C 16.101 11.618 16.395 12.06 16.689 12.501 C 16.983 12.942 17.057 13.162 17.204 13.31 C 17.351 13.604 17.498 13.898 17.498 14.192 C 17.571 14.486 17.498 14.707 17.424 15.001 C 17.351 15.295 17.204 15.442 17.057 15.589 C 16.836 15.736 16.616 15.81 16.321 15.81 L 1.469 15.81 C 1.027 15.81 .66 15.736 .439 15.589 C .219 15.442 .071 15.221 -.002 15.001 C-.076 14.78 -.076 14.486 -.002 14.265 C .071 13.971 .145 13.751 .366 13.457 C .439 13.31 .586 13.089 .807 12.648 C 1.027 12.28 1.321 11.765 1.689 11.251 C 2.057 10.662 2.424 10.074 2.792 9.412 C 3.16 8.751 3.601 8.015 4.042 7.354 C 4.483 6.692 4.851 5.957 5.219 5.295 C 5.586 4.633 5.954 4.045 6.248 3.53 C 6.542 3.015 6.836 2.574 7.057 2.207 L 7.424 1.618 C 7.571 1.398 7.792 1.177 8.086 1.03 C 8.38 .883 8.601 .81 8.895 .81 C 9.189 .81 9.41 .883 9.704 .957 C 9.851 1.03 10.071 1.251 10.219 1.471 Z M 9.777 4.854 C 9.777 4.707 9.777 4.56 9.704 4.486 C 9.63 4.339 9.557 4.265 9.483 4.192 C 9.41 4.118 9.263 4.045 9.116 3.971 C 8.969 3.898 8.821 3.824 8.674 3.824 C 8.38 3.824 8.16 3.898 7.939 4.118 C 7.719 4.339 7.571 4.56 7.571 4.854 L 7.571 9.412 C 7.571 9.707 7.719 9.927 7.939 10.148 C 8.16 10.368 8.38 10.442 8.674 10.442 C 8.969 10.442 9.189 10.368 9.41 10.148 C 9.63 9.927 9.777 9.707 9.777 9.412 L 9.777 4.854 Z M 8.674 11.471 C 8.38 11.471 8.086 11.545 7.939 11.765 C 7.792 11.986 7.645 12.207 7.645 12.501 C 7.645 12.795 7.719 13.089 7.939 13.236 C 8.16 13.457 8.38 13.53 8.674 13.53 C 8.969 13.53 9.263 13.457 9.41 13.236 C 9.63 13.015 9.704 12.795 9.704 12.501 C 9.704 12.207 9.63 11.912 9.41 11.765 C 9.263 11.545 8.969 11.471 8.674 11.471 L 8.674 11.471 Z\" fill=\"currentColor\"/>\n\n</svg>",
  menu_del_cicle: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14px\" height=\"14px\" viewBox=\"0 0 14 14\">\n\n<path d=\"M7,0.5 C10.588,0.5 13.5,3.412 13.5,7 C13.5,10.588 10.588,13.5 7,13.5 C3.412,13.5 0.5,10.588 0.5,7 C0.5,3.412 3.412,0.5 7,0.5 Z M10.25,6.35 L3.75,6.35 L3.75,7.65 L10.25,7.65 L10.25,6.35 Z\" id=\"\u5F62\u72B6\u7ED3\u5408\" fill=\"#EA3323\" fill-rule=\"nonzero\"/>\n\n</svg>"
};
var _default = exports["default"] = menuSvg;

},{"1454":1454}],770:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1498);
var _keycode = _interopRequireDefault(require(104));
var _MDWindowView = _interopRequireDefault(require(93));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDMessageView = _interopRequireDefault(require(55));
/**
 *  Window for rename file name
 *  Created by manjun.han
 *  2026.3.4
 */

var MDAPISecretRenameWinView = _MDWindowView["default"].extend({
  contentTmpl: "<div class=\"wrapper clear-appearance\">\n    <form action=\"\">\n      <div class=\"form-item\">\n        <p class=\"mgb-10\"><%=BabelStr.str(7262)%></p>\n        <div class=\"__input_parent\">\n          <input name=\"apisecretname\" testFileName type=\"text\"  id=\"renameInput\" class=\"form-control testFileNameEnd testFileName\" maxlength=\"100\" palceholder=\"<%=BabelStr.str(158)%>\"/>\n        </div>\n      </div>\n      </form>\n    </div>",
  className: function className() {
    var superCls = _MDWindowView["default"].prototype.className.call(this);
    return superCls + ' m-renameWin';
  },
  initProps: function initProps() {
    var props = _MDWindowView["default"].prototype.initProps.call(this);
    return _.extend(props, {
      width: 460
    });
  },
  events: function events() {
    var superE = _MDWindowView["default"].prototype.events.call(this);
    return _.extend({}, superE, {
      'keyup #renameInput': this._submitOnEnter
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    opt = _.extend({}, opt);
    // this.fileInfor = opt.fileInfor;
    opt.title = BabelStr.str(30);
    opt.buttons = [{
      label: BabelStr.str(155),
      type: 'default'
    }, {
      label: BabelStr.str(154),
      type: 'done',
      autoClose: false,
      onClick: function onClick(button, $e) {
        self._submit();
        return false;
      }
    }];
    _MDWindowView["default"].prototype.initialize.call(this, opt);
  },
  _submit: function _submit() {
    var _this = this;
    var self = this;
    var originName = "";
    var newName = $.trim(self.$("#renameInput").val());
    var validator = this.$('form').validate();
    if (validator.form()) {
      if (newName == originName) {
        self.close();
      } else {
        _MMEnterpriseController["default"].updateMcpAppName(this.mcp_id, newName, function () {
          self.close();
          self.success();
        }, function (err) {
          _MDMessageView["default"].error(err.msg, _this.$el);
        });
      }

      // if(this.fileInfor.get("multFile")) {
      //   this.multFileRename(newName)
      // } else {
      //   if (!this.fileInfor.isFolder()) {
      //     originName = MMCommonFun.getFileNameWithoutExtension(originName);
      //   }

      // }
    }
  },
  viewDidRendered: function viewDidRendered() {
    this.$input = this.$("input");
    var self = this;
    if (app.canDispInNormalBrowser()) {
      self.$input.focus();
    }
    this.$('form').submit(false);
    this.$('form').validate({
      rules: {
        'fileName': {
          'required': true,
          'maxlength': 100
        }
      },
      messages: {
        'fileName': {
          'required': BabelStr.str(7198),
          'maxlength': BabelStr.str(7199)
        }
      }
    });
  },
  _submitOnEnter: function _submitOnEnter($e) {
    if (_keycode["default"].isEnterKey($e.keyCode)) {
      this._submit();
    }
  }
});
var _default = exports["default"] = MDAPISecretRenameWinView;

},{"104":104,"1098":1098,"1184":1184,"1454":1454,"1498":1498,"55":55,"93":93}],769:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require(1199));
require(1417);
require(1463);
var _asyncToGenerator2 = _interopRequireDefault(require(1172));
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDPopupView2 = _interopRequireDefault(require(64));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 *  Create by jichao
 *  2026-3-4
 */
var MDAPISecretPopupView = exports["default"] = /*#__PURE__*/function (_MDPopupView) {
  (0, _inherits2["default"])(MDAPISecretPopupView, _MDPopupView);
  function MDAPISecretPopupView() {
    (0, _classCallCheck2["default"])(this, MDAPISecretPopupView);
    return _callSuper(this, MDAPISecretPopupView, arguments);
  }
  (0, _createClass2["default"])(MDAPISecretPopupView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n      <div class=\"header flex-align middle mgb-15 between\">\n        <div class=\"boldfont2\"><%=BabelStr.str(50028)%></div>\n        <div class=\"new-icon ic-close icon30 close\"></div>\n      </div>\n      <div class=\"line-item mgb-15\">\n        <div class=\"title boldfont2\">API Key</div>\n        <div class=\"flex-align between middle\">\n          <span class=\"copy-content\"><%=appkey%></span>\n          <span class=\"copy ic-copy new-icon icon30\"></span>\n        </div>\n      </div>\n      <div class=\"line-item mgb-15\">\n        <div class=\"title boldfont2\">API secret</div>\n        <span class=\"text-button done show-secret\"><%=BabelStr.str(50037)%></span>\n\n        <div class=\"flex-align between middle for-secret f-hide\">\n          <span class=\"copy-content\"><%=secretkey%></span>\n          <span class=\"copy ic-copy new-icon icon30\"></span>\n        </div>\n      </div>\n      <div class=\"line-item mgb-15\">\n        <div class=\"title boldfont2\"><%=BabelStr.str(50005)%></div>\n        <div class=\"flex-align between middle\">\n          <span class=\"copy-content\"><%=name%></span>\n          <span class=\"copy ic-copy new-icon icon30\"></span>\n        </div>\n      </div>\n      <div class=\"line-item mgb-15\">\n        <div class=\"title boldfont2\"><%=BabelStr.str(50029)%></div>\n        <div class=\"flex-align between middle\">\n          <span class=\"copy-content\"><%=callbackUri%></span>\n          <span class=\"copy ic-copy new-icon icon30\"></span>\n        </div>\n      </div>\n      <div class=\"flex-align end\">\n        <span class=\"button small copy-all\"><%=BabelStr.str(50030)%></span>\n      </div>\n    ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAPISecretPopupView.prototype), "className", this).call(this);
      return "".concat(superCls, " api-secret-popup");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAPISecretPopupView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .copy": this._copy,
        "click .copy-all": this._copyAll,
        "click .close": this._close,
        "click .show-secret": this._showSecret
      });
    }
  }, {
    key: "_showSecret",
    value: function _showSecret($e) {
      $($e.target).addClass("f-hide");
      this.$(".for-secret").removeClass("f-hide");
    }
  }, {
    key: "render",
    value: function render(data) {
      data = this.secretData;
      data.callbackUri = data.callbackUri || "--";
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAPISecretPopupView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAPISecretPopupView.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "_copy",
    value: function _copy($e) {
      var target = $($e.target).siblings(".copy-content")[0];
      this.copy(target.textContent);
    }
  }, {
    key: "_copyAll",
    value: function _copyAll() {
      var $item = this.$(".line-item");
      var result = "";
      for (var i = 0; i < $item.length; i++) {
        var element = $item.eq(i);
        var name = element.find(".title").text();
        var content = element.find(".copy-content").text();
        result = result + name + ":" + content + ";";
      }
      this.copy(result);
    }
  }, {
    key: "copy",
    value: function () {
      var _copy2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(result) {
        var textarea;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return navigator.clipboard.writeText(result);
            case 3:
              _MDMessageView["default"].success(BabelStr.str(50031), this.$container);
              _context.next = 15;
              break;
            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);
              console.warn("现代API复制失败，尝试回退方法:", _context.t0);

              // 回退方法
              textarea = document.createElement("textarea");
              textarea.value = result;
              textarea.style.position = "fixed"; // 避免滚动
              document.body.appendChild(textarea);
              textarea.select();
              try {
                document.execCommand("copy");
                _MDMessageView["default"].success(BabelStr.str(50031), this.$container);
              } catch (fallbackErr) {
                _MDMessageView["default"].success(BabelStr.str(50032), this.$container);
              } finally {
                document.body.removeChild(textarea);
              }
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 6]]);
      }));
      function copy(_x) {
        return _copy2.apply(this, arguments);
      }
      return copy;
    }()
  }, {
    key: "_close",
    value: function _close() {
      this.close();
    }
  }]);
  return MDAPISecretPopupView;
}(_MDPopupView2["default"]);
_.extend(MDAPISecretPopupView, {
  instance: null,
  show: function show(opt) {
    if (MDAPISecretPopupView.instance) {
      MDAPISecretPopupView.instance.close();
    }
    var op = new MDAPISecretPopupView(opt);
    MDAPISecretPopupView.instance = op;
    op.show({
      triggerView: opt.triggerView,
      center: true,
      width: opt.width ? opt.width : 400
    });
    return op;
  },
  close: function close() {
    if (MDAPISecretPopupView.instance) {
      MDAPISecretPopupView.instance.close();
      MDAPISecretPopupView.instance = undefined;
    }
  }
});

},{"1172":1172,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1199":1199,"1417":1417,"1454":1454,"1463":1463,"1475":1475,"55":55,"64":64}],767:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1429);
require(1439);
require(1498);
require(1417);
require(1463);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MMFileIconMaker = _interopRequireDefault(require(296));
var _MMFileInfo = _interopRequireDefault(require(297));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDMoveFileWindowView = _interopRequireDefault(require(508));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDAPISecretCreatePageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDAPISecretCreatePageView, _MDNavigationPageView);
  function MDAPISecretCreatePageView() {
    (0, _classCallCheck2["default"])(this, MDAPISecretCreatePageView);
    return _callSuper(this, MDAPISecretCreatePageView, arguments);
  }
  (0, _createClass2["default"])(MDAPISecretCreatePageView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<div class=\"mgb-15\">\n      <div class=\"mgb-10\"><%=BabelStr.str(50017)%></div>\n      <input type=\"\" class=\"form-control mgb-15 pro-name\" placeholder=\"<%=BabelStr.str(50018)%>\"/>\n    </div>\n    <div>\n      <div class=\"mgb-10\"><%=BabelStr.str(50019)%></div>\n      <div class=\"radio-group\">\n\n        <div class=\"setting-item radio-box\" data-type=\"0\"><%=BabelStr.str(50020)%></div>\n        <div class=\"folder-group\">\n          <div class=\"has-selected  flex-align between middle\">\n            <div class=\"file-item flex-align middle\">\n              <div class=\"file-thumb root no-shrink\"></div>\n              <div class=\"file-name text-hide\"></div>\n            </div>\n            <div class=\"text-button done select-folder no-shrink\"><%=BabelStr.str(28019)%></div>\n          </div>\n          <div class=\"no-selected\">\n            <div class=\"text-button done select-folder\"><%=BabelStr.str(28014)%></div>\n          </div>\n        </div>\n        <div class=\"setting-item radio-box checked\" data-type=\"1\"><%=BabelStr.str(50021)%></div>\n      </div>\n    </div>\n    <div class=\"btns flex-align end gap-10 mgt-20\">\n      <div class=\"text-button cancel\"><%=BabelStr.str(3081)%></div>\n      <div class=\"small button done create\"><%=BabelStr.str(50022)%></div>\n    </div>\n    ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAPISecretCreatePageView.prototype), "className", this).call(this);
      return "".concat(superCls, " api-secret-create-page");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAPISecretCreatePageView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .setting-item': this._settingType,
        "click .select-folder": this._selectFolder,
        "click .cancel": this._cancel,
        "click .create": this._create
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      props.title = BabelStr.str(50016);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAPISecretCreatePageView.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "_settingType",
    value: function _settingType($e) {
      var $current = $($e.target).closest('.setting-item');
      this.type = $current.data('type');
      this.checkedByIndex(this.type);
    }
  }, {
    key: "checkedByIndex",
    value: function checkedByIndex(index) {
      this.$('.setting-item').removeClass('checked');
      this.$('.setting-item').eq(index).addClass('checked');
      if (this.type == 0) {
        this.$('.folder-group').show();
      } else {
        this.$('.folder-group').hide();
      }
    }
  }, {
    key: "renderFileInfo",
    value: function renderFileInfo() {
      if (!this.fileInfor) {
        this.$(".folder-group").removeClass("selected");
        return;
      }
      _MMFileIconMaker["default"].setTypeIconForFileInfoNotCalcDevice(this.fileInfor, this.$(".file-thumb.root"), undefined, undefined, 20);
      this.$(".file-name").html(this.fileInfor.getFileName());
      this.$(".folder-group").addClass("selected");
    }
  }, {
    key: "_selectFolder",
    value: function _selectFolder() {
      var _this = this;
      var win = new _MDMoveFileWindowView["default"]({
        forChooseFolder: true,
        forMove: false,
        title: BabelStr.str(28013),
        unselectableHandle: function unselectableHandle(file) {
          if (file.getFileId().slice(0, 5) === "0--00") {
            return false;
          }
          return !(file.canManageFilePermission() || file.isOwner());
        },
        fileIntercept: function fileIntercept(file) {
          // if(file.getFileId().slice(0, 5) === "0--00") {
          //   return false
          // }
          return false;
          // return !file.canDelete();
        },
        intercept: function intercept(targetFolderId) {
          if (targetFolderId.slice(0, 5) === "0--00") {
            return {
              isOK: false,
              msg: BabelStr.str(6851)
            };
          } else {
            return {
              isOK: true
            };
          }
        },
        chooseCallback: function chooseCallback(result) {
          console.log(result);
          var file = new _MMFileInfo["default"]({
            fileId: result.id,
            fileName: result.name,
            teamMark: result.teamMark
          });
          _this.fileInfor = file;
          _this.renderFileInfo();
        }
      });
      win.show();
    }
  }, {
    key: "_create",
    value: function _create() {
      var _this2 = this;
      var name = this.$(".pro-name").val().trim();
      if (!name) {
        _MDMessageView["default"].error(BabelStr.str(50018), this.$el);
        return;
      }
      var $checked = this.$('.setting-item.checked');
      var type = $checked.data("type");
      var fileId;
      if (type == 0) {
        if (!this.fileInfor) {
          _MDMessageView["default"].error(BabelStr.str(6850), this.$el);
          return;
        }
        fileId = this.fileInfor.getFileId();
      }
      _MMEnterpriseController["default"].createMcpApp(fileId, name, function (res) {
        var finish = function finish() {
          _this2.getNavigationView().pop(function () {
            _MDMessageView["default"].success(BabelStr.str(308), _this2.getNavigationView().$el);
          });
        };
        // 服务端新建时权限位为0,前端创建成功后默认勾选全部文件权限(15 = 读写四项);更新失败不阻塞创建流程
        // 注意: 服务端 insert 未回填自增 id, res.mcp_id 恒为 0 不可用,需用返回的 appkey 从列表反查真实 id
        _MMEnterpriseController["default"].listMcpApp(function (apps) {
          var created = _.find(apps, function (d) {
            return d.appkey == res.mcp_app_key;
          });
          if (created) {
            _MMEnterpriseController["default"].updateMcpFilePermission(15, created.id, finish, finish);
          } else {
            finish();
          }
        }, finish);
      }, function (err) {
        _MDMessageView["default"].error(err.msg, _this2.$el);
      });
      console.log("验证通过");
    }
  }, {
    key: "_cancel",
    value: function _cancel() {
      this.getNavigationView().pop();
    }
  }]);
  return MDAPISecretCreatePageView;
}(_MDNavigationPageView2["default"]);

},{"1098":1098,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1417":1417,"1429":1429,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"1498":1498,"296":296,"297":297,"508":508,"55":55,"56":56}],508:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1413);
require(1463);
require(1417);
require(1426);
require(1428);
require(1429);
require(1439);
require(1424);
require(1461);
require(1430);
require(1471);
var _MMFileInfoCollection = _interopRequireDefault(require(298));
var _MDChannelType = _interopRequireDefault(require(717));
var _MDWindowView = _interopRequireDefault(require(93));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDFileOperationManager = _interopRequireDefault(require(326));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDCreateFolderWindowView = _interopRequireDefault(require(486));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDCheckboxView = _interopRequireDefault(require(37));
var _MMFileInfo = _interopRequireDefault(require(297));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDFolderTreeView = _interopRequireDefault(require(598));
// MDMoveFileWindowView.js (重构后，业务逻辑保留)

var MDMoveFileWindowView = _MDWindowView["default"].extend({
  contentTmpl: "\n    <p class=\"title\"><%= BabelStr.str(7200) %></p>\n    <p class=\"help-block\"><%= BabelStr.str(7201) %></p>\n    <div class=\"wrapper folder-tree-placeholder\"></div>\n    <div class=\"mgt-10 last-path\">\n      <div><%= BabelStr.str(20161) %></div>\n      <div class=\"checkbox-div\"></div>\n    </div>\n  ",
  className: function className() {
    return _MDWindowView["default"].prototype.className.call(this) + ' m-moveFileWin';
  },
  initProps: function initProps() {
    return _.extend(_MDWindowView["default"].prototype.initProps.call(this), {
      fileInfors: [],
      onlyEp: false,
      folderId: -1,
      isCopyAction: false,
      isLinkFileAction: false,
      deleteAfterMove: true,
      ancestorIds: [],
      parentId: "0",
      selectedPath: [],
      forMove: true,
      forChooseFolder: false,
      pageSize: 20,
      pathArr: [],
      unselectableHandle: undefined,
      // 业务标志
      forLibrary: false,
      forLibraryFile: false,
      // 树组件实例
      folderTree: null,
      currentSelectedFileInfo: null,
      currentSelectedAncestorFileInfos: []
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    if (!opt.openFolder) {
      this.fileInfors = opt.fileInfors;
      this.hasFolder = _.any(this.fileInfors, function (fileInfo) {
        return fileInfo.isFolder();
      });
    }

    // 计算 forLibrary / forLibraryFile
    opt.forLibrary = _.every(this.fileInfors, function (fileInfo) {
      return fileInfo.isMaterialLibraryFolder() || fileInfo.isMaterialClass();
    });
    opt.forLibraryFile = _.every(this.fileInfors, function (fileInfo) {
      return fileInfo.beloneMaterialLibrary();
    });
    if (!this.fileInfors || !this.fileInfors.length) {
      opt.forLibrary = false;
      opt.forLibraryFile = false;
    }
    this.forLibrary = opt.forLibrary;
    this.forLibraryFile = opt.forLibraryFile;

    // 标题设置
    if (opt.title) {
      // 使用传入的 title
    } else if (opt.openFolder) {
      // 无特殊
    } else if (opt.isLinkFileAction) {
      opt.title = BabelStr.str(2623);
    } else if (!opt.isCopyAction) {
      opt.title = BabelStr.str(7168);
    } else {
      opt.title = BabelStr.str(33);
    }
    opt.buttons = [{
      label: BabelStr.str(155),
      type: 'default'
    }, {
      label: BabelStr.str(154),
      type: 'done',
      className: 'save',
      autoClose: false,
      onClick: function onClick($e) {
        if ($($e.target).hasClass('disabled')) return;
        $($e.target).addClass("disabled");
        var targetFolderId = self._getSelectFolderId();
        if (targetFolderId !== -1) {
          self._executeAction();
        } else {
          self.close();
        }
      }
    }];
    opt.width = 800;
    _MDWindowView["default"].prototype.initialize.call(this, opt);

    // 控制树组件中“新建文件夹”按钮的显示
    var showCreateBtn = true;
    if (this.isCopyAction) {
      // 复制时无限制
    } else if (this.fileInfors.length && !this.fileInfors[0].canDelete()) {
      showCreateBtn = false;
    }
    this._showCreateBtn = showCreateBtn;

    // 处理 lastPath 记忆功能
    self.lastPathInfo = this._readLastPath();
    self.useLastPathInfo = false;
    // onlyEp 模式仅限企业目录，上次路径可能指向其他频道，不显示
    if (self.lastPathInfo && !this.forLibrary && !this.forLibraryFile && !this.onlyEp) {
      this.lastPathCheckbox = new _MDCheckboxView["default"]({
        label: self.lastPathInfo.path,
        onChanged: function onChanged(checked) {
          self.useLastPathInfo = checked;
        }
      });
      this.addSubView(this.lastPathCheckbox, this.$('.checkbox-div'), true);
    } else {
      this.$el.find(".last-path").remove();
    }

    // 获取当前文件所在路径（用于初始展开）
    this._fetchCurrentPath();
  },
  _fetchCurrentPath: function _fetchCurrentPath() {
    var self = this;
    if (!this.parentId || this.parentId === '0') {
      // 外部传入的 pathArr（如指定默认展开的频道）需要保留，不能在此清空
      return;
    }
    _MMNetDiskDataController["default"].getPathById(this.parentId, _MDChannelType["default"].home, null, function (data) {
      if (!data || !data.length) {
        self.pathArr = [];
        return;
      }
      var top = data.models[data.models.length - 1];
      var lastOpendPathId = '';
      if (top.isOwner()) {
        lastOpendPathId = '0--002';
      } else if (top.isDepartmentFolder() || top.isEpPublicFolder() || top.isMaterialLibrary()) {
        lastOpendPathId = '0--001';
      } else if (top.isProject() || top.isHQSMProject()) {
        if (app.currentUser.isEpManager()) {
          lastOpendPathId = '0--006';
        } else {
          lastOpendPathId = '0--003';
        }
      } else if (top.isTeamFolder()) {
        lastOpendPathId = '0--005';
      } else {
        lastOpendPathId = '0--004';
      }
      var pathIds = data.map(function (item) {
        return item.getFileId();
      });
      pathIds.reverse();
      if (lastOpendPathId) {
        pathIds.unshift(lastOpendPathId);
      }
      self.pathArr = pathIds;
      if (self.folderTree) {
        self.folderTree.openPath(self.pathArr);
      }
    }, function () {
      self.pathArr = [];
    });
  },
  viewDidRendered: function viewDidRendered() {
    var self = this;
    // 定义业务相关的过滤函数和根数据提供者
    var nodeFilter = function nodeFilter(fileInfo) {
      // 如果 forLibrary 为 true，只显示素材库或素材分类
      if (self.forLibrary) {
        return fileInfo.isMaterialLibrary() || fileInfo.isMaterialClass();
      }
      // 如果 forLibraryFile 为 true，显示素材库相关及素材库文件夹
      if (self.forLibraryFile) {
        return fileInfo.isMaterialLibrary() || fileInfo.isMaterialClass() || fileInfo.isMaterialLibraryFolder() || fileInfo.beloneMaterialLibrary();
      }
      // 默认显示所有文件夹
      return true;
    };
    var nodeDisabled = function nodeDisabled(fileInfo) {
      if (self.unselectableHandle && self.unselectableHandle(fileInfo)) {
        return true;
      }
      // 素材库节点在非素材库模式下不可选
      if (!self.forLibrary && (fileInfo.isMaterialClass() || fileInfo.isMaterialLibrary())) {
        return true;
      }
      // 其他禁用逻辑可由外部 fileIntercept 提供
      if (self.fileIntercept && self.fileIntercept(fileInfo)) {
        return true;
      }
      return false;
    };

    // 根数据提供者
    var rootDataProvider = function rootDataProvider() {
      var request;
      if (self.forLibrary || self.forLibraryFile) {
        request = _MMNetDiskDataController["default"].getFileTreeRootFoldersLibrary;
      } else if (self.onlyEp) {
        request = _MMNetDiskDataController["default"].getFileTreeRootFoldersOnlyEp;
      } else {
        request = _MMNetDiskDataController["default"].getFileTreeRootFolders;
      }
      return request;
    };
    var treeOptions = {
      openFolder: this.openFolder,
      pageSize: this.pageSize,
      showCreateFolderBtn: this._showCreateBtn,
      initialPath: this.pathArr,
      rootDataProvider: rootDataProvider,
      nodeFilter: nodeFilter,
      nodeDisabled: nodeDisabled,
      onSelect: function onSelect(selected) {
        self._onTreeSelect(selected);
      },
      // onOpenFolder: function(folderId) {
      //   app.pathRouter.navigateToPath('file/' + folderId);
      //   self.close();
      //   if (self.afterOpen) self.afterOpen(folderId);
      // },
      onCreateFolder: function onCreateFolder(parentFolderId) {
        self._createFolder(parentFolderId);
      }
    };
    this.folderTree = new _MDFolderTreeView["default"](treeOptions);
    this.addSubView(this.folderTree, this.$('.folder-tree-placeholder'), true);
    if (this.pathArr && this.pathArr.length) {
      this.folderTree.openPath(this.pathArr);
    }
  },
  _onTreeSelect: function _onTreeSelect(selected) {
    this.lastPathCheckbox && this.lastPathCheckbox.setChecked(false);
    this.folderId = selected.folderId;
    this.path = selected.path;
    this.selectedNode = selected.node;
    this.currentSelectedFileInfo = selected.fileInfo;
    this.currentSelectedAncestorFileInfos = selected.ancestorFileInfos;
    this.ancestorIds = selected.ancestorIds;
    var $doneBtn = this.getActionButtons().eq(1);
    if (this.isCopyAction) {
      $doneBtn.prop('disabled', false);
    } else {
      if (this.folderId == 0) {
        var canMoveToRoot = this.fileInfors.length && this.fileInfors[0].canDelete();
        $doneBtn.prop('disabled', !canMoveToRoot);
      } else {
        $doneBtn.prop('disabled', false);
      }
    }
  },
  _getSelectFolderId: function _getSelectFolderId() {
    if (this.useLastPathInfo) return this.lastPathInfo.folderId;
    return this.folderId;
  },
  _getSelectNodeText: function _getSelectNodeText() {
    var _this$selectedNode;
    if (this.useLastPathInfo) return this.lastPathInfo.originalText;
    return (_this$selectedNode = this.selectedNode) === null || _this$selectedNode === void 0 || (_this$selectedNode = _this$selectedNode.original) === null || _this$selectedNode === void 0 ? void 0 : _this$selectedNode.text;
  },
  _getSelectFolderEntId: function _getSelectFolderEntId() {
    if (this.useLastPathInfo) return this.lastPathInfo.targetEntId;
    if (this.currentSelectedFileInfo) {
      return this.currentSelectedFileInfo.getEnterpriseId();
    }
    var fileInfo = this.folderTree ? this.folderTree.getFileInfoById(this.folderId) : null;
    return fileInfo ? fileInfo.getEnterpriseId() : null;
  },
  _createFolder: function _createFolder(parentFolderId) {
    var self = this;
    var parentFolder = this.folderTree ? this.folderTree.getFileInfoById(parentFolderId) : null;
    if (!parentFolder && parentFolderId !== '#') {
      _MDMessageView["default"].error(BabelStr.str(4780), this.$body);
      return;
    }
    if (parentFolderId === '#') {
      parentFolder = new _MMFileInfo["default"]({
        fileId: '0',
        fileName: BabelStr.str(97)
      });
    }
    if (parentFolderId.slice(0, 5) === '0--00' && parentFolderId !== '0--002') {
      _MDMessageView["default"].error(BabelStr.str(4779), this.$body);
      return;
    }
    var win = new _MDCreateFolderWindowView["default"]({
      parentFolder: parentFolder,
      success: function success(fileInfo) {
        self.folderTree.onFolderCreated(parentFolderId, fileInfo);
      }
    });
    win.show();
  },
  _executeAction: function _executeAction() {
    var _this = this;
    var targetFolderId = this._getSelectFolderId();
    if (targetFolderId == "load_more") {
      _MDMessageView["default"].error(BabelStr.str(4780), this.$body);
      this.$('.save').removeClass('disabled');
      return;
    }
    if (this.forChooseFolder) {
      if (_.isFunction(this.intercept)) {
        var result = this.intercept(targetFolderId);
        if (!result.isOK) {
          _MDMessageView["default"].error(result.msg, this.$body);
          this.$('.save').removeClass('disabled');
          return;
        }
      }
      var out = {
        id: targetFolderId,
        path: this.path
      };
      if (this.useLastPathInfo) {
        var _this$selectedNode2;
        out.name = this.lastPathInfo.originalText;
        out.teamMark = this.useLastPathInfo ? this.lastPathInfo.teamMark : (_this$selectedNode2 = this.selectedNode) === null || _this$selectedNode2 === void 0 || (_this$selectedNode2 = _this$selectedNode2.data) === null || _this$selectedNode2 === void 0 ? void 0 : _this$selectedNode2.teamMark;
        out.path = this.lastPathInfo.path;
      } else {
        var node = this.folderTree.getSelectedNode();
        out.name = node.text;
        out.teamMark = node.data.teamMark;
      }
      this.chooseCallback(out);
      this.close();
      return;
    }
    if (targetFolderId.slice(0, 5) === '0--00' && targetFolderId[5] !== '2') {
      _MDMessageView["default"].error(BabelStr.str(4779), this.$body);
      this.$('.save').removeClass('disabled');
      return;
    }
    if (targetFolderId.slice(0, 5) === '0--00') targetFolderId = 0;
    if (this.openFolder) {
      app.pathRouter.navigateToPath('file/' + targetFolderId);
      this.close();
      if (this.afterOpen) this.afterOpen(targetFolderId);
      return;
    }
    var canUpload = true;
    if (this.currentSelectedFileInfo && !this.currentSelectedFileInfo.canUploadOnlyActions()) {
      canUpload = false;
    }
    if (!canUpload) {
      _MDSnackbarView["default"].show(BabelStr.str(12306));
      this.$('.save').removeClass('disabled');
      return;
    }
    if (this.isLinkFileAction) {
      this._createLinkForFile(targetFolderId);
    } else {
      if (!this._validateMoveAction(targetFolderId)) {
        this.$('.save').removeClass('disabled');
        return;
      }
      this.testManuscriptLimits(targetFolderId).then(function (limits) {
        _this._saveSelectedPath(limits);
        var name = _this._getSelectNodeText();
        var limitsResult = MMCommonFun.validateFileType(name, limits);
        if (!limitsResult) {
          var limitStr = _.pluck(limits, 'stringLimit').join(',');
          var msg = BabelStr.str(3640, {
            str: limitStr,
            name: name
          });
          new _MDAlertView["default"]({
            title: BabelStr.str(170),
            width: 600,
            message: msg,
            buttons: [{
              label: BabelStr.str(154)
            }]
          }).show();
          _this.$('.save').removeClass('disabled');
        } else {
          _MMNetDiskDataController["default"].checkFolderSize(targetFolderId, function () {
            if (_this.isCopyAction) _this._copyFileIntoFolder(targetFolderId);else _this._moveFileIntoFolder(targetFolderId);
          }, function (error, msg) {
            _this.$('.save').removeClass('disabled');
            _MDAlertView["default"].showStandardPrompt({
              message: error == 7 ? BabelStr.str(7524) : msg
            });
          });
        }
      })["catch"](function (e) {
        return console.error(e);
      });
    }
  },
  _saveSelectedPath: function _saveSelectedPath(limits) {
    if (!this.useLastPathInfo) {
      var targetFile = this.currentSelectedFileInfo;
      if (!targetFile && this.folderTree) targetFile = this.folderTree.getFileInfoById(this.folderId);
      if (!targetFile) return;
      var targetEntId = targetFile.getEnterpriseId();
      var pathInfo = {
        folderId: this.folderId,
        path: this.path,
        originalText: this.selectedNode ? this.selectedNode.original.text : '',
        limits: limits,
        targetEntId: targetEntId,
        teamMark: targetFile.get('teamMark')
      };
      var key = 'lastPath_' + app.currentUser.getUserId();
      localStorage[key] = JSON.stringify(pathInfo);
    }
  },
  _readLastPath: function _readLastPath() {
    var key = 'lastPath_' + app.currentUser.getUserId();
    var str = localStorage[key];
    return str ? JSON.parse(str) : null;
  },
  _validateMoveAction: function _validateMoveAction(targetFolderId) {
    var self = this;
    var title = BabelStr.str(33);
    var allInCurFolder = _.every(this.fileInfors, function (fileInfor) {
      return !fileInfor.isDeleted() && fileInfor.get('parentId') === targetFolderId;
    });
    if (allInCurFolder) {
      _MDSnackbarView["default"].show(BabelStr.str(7169));
      return false;
    }
    var moveToSelf = _.some(this.fileInfors, function (fileInfor) {
      return _.some(self.ancestorIds, function (ancestorId) {
        if (fileInfor.getFileId() == ancestorId) {
          return true;
        }
        return false;
      });
    });
    if (moveToSelf) {
      if (!this.isCopyAction) title = BabelStr.str(7168);
      _MDSnackbarView["default"].show(BabelStr.str(7170, {
        title: title
      }));
      return false;
    }
    return true;
  },
  _createLinkForFile: function _createLinkForFile(targetFolderId) {
    var _this2 = this;
    _czc && _czc.push(["_trackEvent", "文件操作", "创建快捷方式", "", "", ""]);
    var fileIds = _.map(this.fileInfors, function (file) {
      return file.getFileId();
    });
    _MMNetDiskDataController["default"].createLinkForFiles(targetFolderId, fileIds, function (files) {
      _MDSnackbarView["default"].show(BabelStr.str(308));
      if (targetFolderId == _this2.parentId) {
        _.each(files, function (file) {
          if (viewManager.viewList.curFileTableView && viewManager.viewList.curFileTableView.dataCollection) {
            viewManager.viewList.curFileTableView.dataCollection.addFileBlowStickonTop(file);
          }
        });
      }
      _this2.close();
    }, function (err) {
      _MDSnackbarView["default"].show(err['message']);
    });
  },
  _copyFileIntoFolder: function _copyFileIntoFolder(targetFolderId) {
    var self = this;
    _MDFileOperationManager["default"].copyFileIntoFolder(this.fileInfors, targetFolderId, function () {
      self.close();
    }, {
      forSendFile: this.forSendFile,
      sendId: this.sendId
    });
  },
  _moveFileIntoFolder: function _moveFileIntoFolder(targetFolderId) {
    var self = this;
    var ids = _.map(this.fileInfors, function (file) {
      return file.getFileId();
    });
    if (ids.length == 0) return;
    var sourceFolderId = this.fileInfors[0].getParentFolderId();
    var targetEntId = this._getSelectFolderEntId();
    var sourceEntId = this.fileInfors[0].getEnterpriseId();
    var mixEnt = targetEntId != sourceEntId;
    _MDFileOperationManager["default"].moveFileIntoFolder(ids, targetFolderId, sourceFolderId, mixEnt);
    self.close();
  },
  testManuscriptLimits: function testManuscriptLimits(targetFolderId) {
    var _this3 = this;
    return new Promise(function (resolve, reject) {
      if (targetFolderId == 0) {
        resolve([]);
        return;
      }
      if (_this3.useLastPathInfo) {
        resolve(_this3.lastPathInfo.limits);
        return;
      }
      var ancestorInfos = _this3.currentSelectedAncestorFileInfos || [];
      var sign = false;
      var currentFile = _this3.currentSelectedFileInfo;
      if (currentFile && currentFile.isManuscriptBox && currentFile.isManuscriptBox() && !currentFile.get('limitsState')) {
        sign = true;
        _MMNetDiskDataController["default"].getMsBoxLimits(targetFolderId, resolve);
      } else if (!currentFile || !currentFile.isManuscriptBox || !currentFile.isManuscriptBox()) {
        for (var i = 0; i < ancestorInfos.length; i++) {
          var file = ancestorInfos[i];
          if (file && file.isManuscriptBox && file.isManuscriptBox() && !file.get('limitsState')) {
            sign = true;
            _MMNetDiskDataController["default"].getMsBoxLimits(file.getFileId(), resolve);
            break;
          }
        }
      }
      if (!sign) resolve([]);
    });
  }
}, {
  openFolderWindow: function openFolderWindow(opt, callback) {
    var wind = new MDMoveFileWindowView({
      openFolder: true,
      // upload: opt.upload,
      afterOpen: callback,
      title: BabelStr.str(7173),
      parentId: '0'
    });
    wind.show();
  }
});
window.MDMoveFileWindowView = MDMoveFileWindowView;
var _default = exports["default"] = MDMoveFileWindowView;

},{"1098":1098,"1104":1104,"1184":1184,"1413":1413,"1417":1417,"1424":1424,"1426":1426,"1428":1428,"1429":1429,"1430":1430,"1439":1439,"1454":1454,"1461":1461,"1463":1463,"1471":1471,"297":297,"298":298,"32":32,"326":326,"37":37,"486":486,"55":55,"598":598,"717":717,"72":72,"93":93}],598:[function(require,module,exports){
"use strict";

require(1437);
require(1503);
require(1500);
require(1502);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1423);
require(1463);
require(1480);
require(1487);
require(1538);
require(1443);
require(1498);
require(1541);
require(1418);
require(1537);
require(1429);
require(1417);
require(1421);
require(1439);
require(1438);
require(1415);
require(1426);
require(1412);
require(1422);
require(1461);
require(1424);
require(1466);
require(1419);
require(1420);
require(1477);
require(1493);
require(1464);
require(1492);
require(1476);
require(1478);
require(1495);
var _slicedToArray2 = _interopRequireDefault(require(1192));
var _defineProperty2 = _interopRequireDefault(require(1180));
var _MMFileInfoCollection = _interopRequireDefault(require(298));
var _MMFileInfo = _interopRequireDefault(require(297));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MMViewBase = _interopRequireDefault(require(22));
var _MDCreateFolderWindowView = _interopRequireDefault(require(486));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDClassificationSelectWinView = _interopRequireDefault(require(540));
var _MDClassificationEditWinView = _interopRequireDefault(require(531));
var _MMFileIconMaker = _interopRequireDefault(require(296));
var _MMViewBase$extend;
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; } // MDFolderTreeView.js（完整版，支持节点操作按钮 + 根节点可选中配置 + 高级多选状态管理）
/**
 * 通用文件夹树组件，基于 jsTree 实现
 * 支持懒加载、分页、自定义根节点、节点过滤/禁用、创建文件夹后刷新、多选模式、右键菜单等
 *
 * 【多选模式高级特性】
 * - 支持四种节点类型，每种类型拥有独立的状态机：
 *   1. 全选节点（full）：两态切换 全选 ↔ 删除
 *   2. 部分选中节点（partial）：三态循环 部分选中 ↔ 全选 ↔ 删除
 *   3. 未选中节点（normal）：两态切换 未选中 ↔ 全选
 *   4. 删除节点（deleted）：三态循环 删除 ↔ 全选 ↔ 未选中
 * - 删除状态具有特殊样式（灰色斜线），与普通未选中视觉区分
 * - 初始状态与最终状态相同时不计入变更集合
 */
var MDFolderTreeView = _MMViewBase["default"].extend((_MMViewBase$extend = {
  className: "folder-tree-container",
  tmpl: "\n    <% if (enableSearch) { %>\n    <div class=\"folder-tree-search-wrapper\">\n      <div class=\"search-input-wrap  search-box flex-align middle\">\n        <i class=\"icon icon-search no-shrink\"></i>\n        <input type=\"text\" class=\"folder-tree-search-input\" placeholder=\"<%= searchPlaceholder %>\" />\n        <i class=\"icon icon30 search-clear no-shrink\" data-tooltip-direction=\"top\" data-tooltip=\"<%=BabelStr.str(40167)%>\" style=\"display:none;\"></i>\n      </div>\n    </div>\n    <% } %>\n    <div id=\"treeView\" class=\"folder-tree\"></div>\n    <%if(showCreateFolderBtn){%>\n        <div class=\"create-folder-btn-wrapper \">\n          <span class=\"text-button create-folder\"><%= createStr %></span>\n        </div>\n    <%}%>\n  ",
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    var baseEvents = {
      "click .create-folder": "_onCreateFolderClick"
    };
    return _.extend(superE, baseEvents);
  },
  initProps: function initProps() {
    var _ref;
    return _ref = {
      openFolder: false,
      pageSize: 20,
      showCreateFolderBtn: true,
      initialPath: [],
      multiSelect: false,
      dataSource: "file",
      useCustomIcon: true,
      showRootNode: false,
      rootNodeText: "根目录",
      rootNodeSelectable: false,
      // 节点操作按钮配置
      showNodeActions: false,
      onCreateFolder: null,
      onEditNodeCallback: null,
      onDeleteNodeCallback: null,
      // 业务钩子函数
      rootDataProvider: null,
      nodeFilter: null,
      nodeDisabled: null,
      customNodeIcon: null,
      // 回调事件
      onSelect: null,
      onSelectionChange: null,
      onOpenFolder: null,
      // 内部状态
      fileInforCollection: new _MMFileInfoCollection["default"](),
      jsTree: null,
      selectedFolderId: -1,
      selectedPath: "",
      selectedNode: null,
      selectedFileInfo: null,
      ancestorIds: [],
      ancestorFileInfos: [],
      selectedNodes: [],
      lastOpendPathId: null,
      _isReady: false,
      _pendingOpenPath: null,
      testUpload: true,
      _lastClickedNodeId: null,
      // 多选状态追踪（核心）
      _originalFileInfos: null,
      // 原始文件路径数据
      _initialFullCheckedSet: null,
      // 初始全选节点集合
      _initialPartialSet: null,
      // 初始部分选中节点集合
      _initialDeletedSet: null,
      // 初始已删除节点集合（未选中且需特殊追踪）
      _nodeTypeMap: null,
      // 存储每个节点的类型: 'full', 'partial', 'normal', 'deleted'

      // 新增
      folderCreateMode: "refresh",
      // 新建文件夹模式：'refresh' | 'append'
      onFolderAppended: null,
      // 追加模式回调

      enableContextMenu: true,
      // 是否启用右键菜单

      enableSearch: false
    }, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_ref, "enableSearch", false), "searchUrl", null), "searchDelay", 500), "searchResultLimit", 500), "onSearchComplete", null), "onSearchCleared", null), "_searchKeyword", ''), "_searchTimer", null), "_searchResults", []), "_lastSearchKeyword", ''), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_ref, "_isSearching", false), "_currentMatchIndex", 0), "$msgContainer", $("body"));
  },
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.fileInforCollection = this.fileInforCollection || new _MMFileInfoCollection["default"]();
    this._initialFullCheckedSet = new Set();
    this._initialPartialSet = new Set();
    this._initialDeletedSet = new Set();
    this._nodeTypeMap = new Map();
    if (this.showNodeActions) {
      this.$el.addClass("with-action-btns");
    }
  },
  render: function render(data) {
    data = {
      showCreateFolderBtn: this.showCreateFolderBtn,
      multiSelect: this.multiSelect,
      createStr: this.dataSource == "classification" ? BabelStr.str(40153) : BabelStr.str(163),
      enableSearch: this.enableSearch,
      searchPlaceholder: this.dataSource == "classification" ? BabelStr.str(40165) : BabelStr.str(40166)
    };
    _MMViewBase["default"].prototype.render.call(this, data);
  },
  viewDidRendered: function viewDidRendered() {
    this._renderTree();
    if (this.enableSearch) {
      this._initSearch();
    }
  },
  _initSearch: function _initSearch() {
    var self = this;
    var $input = this.$('.folder-tree-search-input');
    var $clearBtn = this.$('.search-clear');

    // 输入事件（防抖）
    $input.on('input', function () {
      var keyword = $(this).val().trim();
      self._searchKeyword = keyword;
      if (keyword) {
        $clearBtn.show();
      } else {
        $clearBtn.hide();
      }
      clearTimeout(self._searchTimer);
      self._searchTimer = setTimeout(function () {
        self._performSearch(keyword);
      }, self.searchDelay);
    });

    // 回车搜索（立即执行）
    $input.on('keydown', function (e) {
      if (e.keyCode === 13) {
        e.preventDefault();
        var keyword = $(this).val().trim();
        self._searchKeyword = keyword;
        clearTimeout(self._searchTimer);
        self._performSearch(keyword);
      }
    });

    // 清除按钮
    $clearBtn.on('click', function () {
      $input.val('');
      $clearBtn.hide();
      self.clearSearch();
    });

    // 监听 ESC 键清除搜索
    $input.on('keydown', function (e) {
      if (e.keyCode === 27) {
        $input.val('');
        $clearBtn.hide();
        self.clearSearch();
      }
    });
  },
  _renderTree: function _renderTree() {
    var self = this;
    var $treeContainer = this.$("#treeView");
    var coreConfig = {
      themes: {
        dots: false
      },
      multiple: this.multiSelect,
      worker: false,
      data: function data(node, cb) {
        var fileId = node.id;
        if (self.showRootNode && fileId === "#") {
          var selectable = self.rootNodeSelectable;
          var rootNode = {
            id: "root",
            text: self.rootNodeText,
            children: true,
            icon: "icon tree-folder-node",
            state: {
              selectable: selectable,
              disabled: false,
              opened: true
            },
            li_attr: {}
          };
          if (!selectable) {
            rootNode.li_attr["data-jstree"] = '{"checkbox_disabled":true}';
          }
          if (self.useCustomIcon) rootNode.icon = "jstree-folder";
          cb([rootNode]);
          return;
        }
        self._getSubfolders(fileId, 0, function (collection, pages) {
          var nodes = self._transformCollectionToJSTreeNodes(collection);
          if (self.useCustomIcon) {
            setTimeout(function () {
              nodes.forEach(function (nodeItem) {
                var file = collection.findWhere({
                  fileId: nodeItem.id
                });
                if (file && file.fetchIconUrl) file.fetchIconUrl(nodeItem, self.jsTree);
              });
            }, 0);
          }
          if (pages > 1) {
            nodes.push({
              id: fileId + "_load_more",
              text: BabelStr.str(477),
              children: false,
              data: {
                pages: pages,
                curPage: 0,
                id: fileId,
                loadMore: true
              },
              icon: "load-more icon"
            });
          }
          self.fileInforCollection.add(collection.models);
          cb(nodes);
        }, function () {
          cb([]);
        });
      },
      check_callback: function check_callback(operation) {
        return operation === "create_node";
      }
    };
    var plugins = [];
    var contextmenu = {};
    if (this.multiSelect) {
      plugins.push("checkbox");
      coreConfig.multiple = true;
    } else {
      coreConfig.multiple = false;
    }

    // 根据配置决定是否启用右键菜单
    if (this.enableContextMenu) {
      plugins.push("contextmenu");
      contextmenu = {
        items: function items(node) {
          if (node.state.disabled || node.data && node.data.loadMore) return {};
          return {
            createFolder: {
              label: self.dataSource == "classification" ? BabelStr.str(40153) : BabelStr.str(163),
              action: function action(data) {
                var inst = $.jstree.reference(data.reference);
                var obj = inst.get_node(data.reference);
                if (self.onCreateFolder) {
                  self.onCreateFolder(obj.id);
                } else if (self.onAddSubFolderCallback || self.onFolderAppended) {
                  self._onCreateFolder(obj.id);
                }
              }
            }
          };
        }
      };
    }

    // ===== 关键修改：如果启用搜索，添加 search 插件 =====
    if (this.enableSearch) {
      plugins.push("search");
    }
    $treeContainer.jstree({
      core: coreConfig,
      checkbox: this.multiSelect ? {
        three_state: false,
        cascade: "",
        tie_selection: false
      } : undefined,
      contextmenu: contextmenu,
      // ===== 新增：search 插件配置 =====
      search: this.enableSearch ? {
        show_only_matches: false,
        // 改为 false，不隐藏节点
        show_only_matches_children: false,
        // 不显示匹配节点的子节点
        search_leaves_only: false,
        // 搜索所有节点（不只是叶子节点）
        case_sensitive: false,
        // 不区分大小写
        fuzzy: false // 不使用模糊搜索
      } : undefined,
      plugins: plugins
    });
    this.jsTree = $treeContainer.jstree();
    if (this.multiSelect) {
      // 解除 jsTree 内部 click 事件，自定义锚点点击
      $treeContainer.off("click.jstree");
      $treeContainer.on("click", ".jstree-anchor", function (e) {
        e.stopPropagation();
        e.preventDefault();
        var $node = $(this).closest(".jstree-node");
        var nodeId = $node.attr("id");
        if (!nodeId) return;
        var node = self.jsTree.get_node(nodeId);
        if (!node || node.state.disabled) return;
        if (self.multiSelect) {
          self._handleNodeStateToggle(nodeId);
        } else {
          self.jsTree.deselect_all();
          self.jsTree.select_node(nodeId);
        }
      });
      $treeContainer.on("click", ".jstree-node >.jstree-icon", function (e) {
        e.stopPropagation();
        var $node = $(this).closest(".jstree-node");
        var nodeId = $node.attr("id");
        if (nodeId) {
          self.jsTree.toggle_node(nodeId);
        }
      });
    }
    this._bindTreeEvents();
    if (this.initialPath && this.initialPath.length) this.openPath(this.initialPath);
  },
  _bindTreeEvents: function _bindTreeEvents() {
    var self = this;
    if (this.multiSelect) {
      // 复选框点击（仍需状态机）
      this.$("#treeView").on("click", ".jstree-checkbox", function (e) {
        e.stopPropagation();
        e.preventDefault();
        var $node = $(this).closest(".jstree-node");
        var nodeId = $node.attr("id");
        if (!nodeId) return;
        self._handleNodeStateToggle(nodeId);
      });

      // 不再绑定 .jstree-anchor 的点击（已在 _renderTree 中自定义）
      // 拦截 jsTree 默认的 select/check 事件，防止干扰
      this.$("#treeView").on("select_node.jstree", function (e) {
        e.stopImmediatePropagation();
        return false;
      });
      this.$("#treeView").on("check_node.jstree uncheck_node.jstree", function (e) {
        e.stopImmediatePropagation();
      });
    } else {
      // 单选模式保持不变
      this.$("#treeView").on("changed.jstree", function (e, data) {
        if (data.action === "select_node" && data.node) {
          var node = data.node;
          if (self.showRootNode && node.id === "root" && !self.rootNodeSelectable) return;
          if (node.data && node.data.loadMore) {
            self._loadMoreNodes(node);
            return;
          }
          self._handleSingleSelect(node, data.instance);
        }
      });
    }

    // 以下事件不论单选/多选都需要
    this.$("#treeView").on("select_node.jstree", function (e, data) {
      if (self.multiSelect) return;
      var node = data.node;
      var instance = data.instance;
      if (self.showRootNode && node.id === "root" && !self.rootNodeSelectable) {
        instance.deselect_node(node);
        instance.toggle_node(node.id);
        return;
      }
      if (node.data && node.data.loadMore) {
        self._loadMoreNodes(node);
        return;
      }
      if (node && !(node.data && node.data.loadMore)) self._lastClickedNodeId = node.id;
    });
    this.$("#treeView").on("keydown", function (e) {
      if (e.ctrlKey && e.shiftKey && e.keyCode === 78) {
        e.preventDefault();
        var parentId = self._lastClickedNodeId && self._lastClickedNodeId !== -1 ? self._lastClickedNodeId : "#";
        if (self.onCreateFolder) self.onCreateFolder(parentId);
      }
    });

    // 树结构变化后重新附加按钮并刷新半选/删除样式
    this.$("#treeView").on("refresh_node.jstree open_node.jstree close_node.jstree redraw.jstree", function () {
      setTimeout(function () {
        self._refreshAllPartialAndDeletedClasses();
        if (self.showNodeActions) self._attachNodeActions();
      }, 10);
    }).on("ready.jstree", function () {
      self._isReady = true;
      if (self._pendingOpenPath) {
        self._openPathByIds(self._pendingOpenPath);
        self._pendingOpenPath = null;
      }
      self._refreshAllPartialAndDeletedClasses();
      if (self.showNodeActions) self._attachNodeActions();
    }).on("after_open.jstree", function (e, data) {
      var childrenIds = data.node.children;
      childrenIds.forEach(function (id) {
        var childNode = self.jsTree.get_node(id);
        if (self.useCustomIcon && _MMFileIconMaker["default"].reFreshNodeIcon) {
          _MMFileIconMaker["default"].reFreshNodeIcon(childNode, self.jsTree);
        }
      });
      self._refreshAllPartialAndDeletedClasses();
      if (self.showNodeActions) self._attachNodeActions();
    }).on("open_node.jstree", function (e, data) {
      var curId = data.node.id;
      if (curId && curId.slice && curId.slice(0, 5) === "0--00") {
        var rootNode = self.jsTree.get_node("#");
        if (rootNode && rootNode.children) {
          rootNode.children.forEach(function (id) {
            if (id !== curId) {
              var node = self.jsTree.get_node(id);
              if (node && node.state && node.state.opened) self.jsTree.close_node(node);
            }
          });
        }
      }
    });
    // 【新增】监听搜索事件，搜索完成后重新附加操作按钮
    this.$("#treeView").on("search.jstree", function (e, data) {
      // 搜索完成后，重新附加操作按钮
      if (self.showNodeActions) {
        setTimeout(function () {
          self._attachNodeActions();
        }, 50);
      }
    });
    this.$("#treeView").on("load_node.jstree", function (e, data) {
      if (self._searchKeyword && self._searchMatchedIds && self._searchMatchedIds.length > 0) {
        // 对新加载的节点刷新图标
        if (self.useCustomIcon) {
          var nodeId = data.node.id;
          var file = self.fileInforCollection.findWhere({
            fileId: nodeId
          });
          if (file && file.fetchIconUrl) {
            file.fetchIconUrl(data.node, self.jsTree);
          }
        }
        // 重新应用高亮（可能新节点也需要高亮）
        setTimeout(function () {
          self._applySearchHighlights(self._searchMatchedIds, self._searchKeyword);
        }, 50);
      }
    });
  },
  /**
   * 处理节点状态切换（多选模式下由点击checkbox或节点名称触发）
   * @param {string} nodeId 节点ID
   */

  _handleNodeStateToggle: function _handleNodeStateToggle(nodeId) {
    var node = this.jsTree.get_node(nodeId);
    if (!node || node.state.disabled) return;
    var nodeType = this._nodeTypeMap.get(nodeId) || "normal";
    var currentState = this._getNodeState(node);
    var nextState = this._getNextState(nodeType, currentState);
    if (!nextState) return;

    // 执行状态转换
    this._setNodeState(node, nextState);

    // 强制同步节点对象的 state.checked 与 jsTree 内部选中状态
    var isActuallyChecked = nextState === "checked";
    if (node.state.checked !== isActuallyChecked) {
      node.state.checked = isActuallyChecked;
      if (this.jsTree._model.data[nodeId]) {
        this.jsTree._model.data[nodeId].state.checked = isActuallyChecked;
      }
    }
    // 同步 partial 和 deleted 标志（确保与目标状态一致）
    node.state.partial = nextState === "partial";
    node.state.deleted = nextState === "deleted";
    if (this.jsTree._model.data[nodeId]) {
      this.jsTree._model.data[nodeId].state.partial = nextState === "partial";
      this.jsTree._model.data[nodeId].state.deleted = nextState === "deleted";
    }

    // 更新选中节点列表
    this._updateSelectedNodes();
    if (this.onSelectionChange) {
      console.log("selectedNodes", this.selectedNodes.slice());
      this.onSelectionChange({
        selectedNodes: this.selectedNodes.slice()
      });
    }
    this._lastClickedNodeId = nodeId;
    this._setLastClickedHighlight(nodeId);
  },
  /**
   * 获取节点当前状态（优先通过 DOM 类判断，确保视觉一致性）
   * @param {Object} node jsTree节点对象
   * @returns {string} 'checked' | 'partial' | 'deleted' | 'unchecked'
   */
  _getNodeState: function _getNodeState(node) {
    // 优先通过 DOM 元素类名判断（最可靠，反映实际显示状态）
    var $nodeEl = this.$(node.li_attr.id ? "#" + node.li_attr.id : '[id="' + node.id + '"]');
    if ($nodeEl.length) {
      if ($nodeEl.hasClass("jstree-checked")) return "checked";
      if ($nodeEl.hasClass("jstree-partial-selected")) return "partial";
      if ($nodeEl.hasClass("jstree-deleted")) return "deleted";
    }
    // 后备：节点对象上的状态标志
    if (node.state.checked) return "checked";
    if (node.state.partial) return "partial";
    if (node.state.deleted) return "deleted";
    return "unchecked";
  },
  /**
   * 根据节点类型和当前状态计算下一个状态
   * @param {string} nodeType 'full' | 'partial' | 'normal' | 'deleted'
   * @param {string} currentState 'checked' | 'partial' | 'deleted' | 'unchecked'
   * @returns {string|null} 下一个状态
   */
  _getNextState: function _getNextState(nodeType, currentState) {
    switch (nodeType) {
      case "full":
        // 全选节点：两态 全选 ↔ 删除
        if (currentState === "checked") return "deleted";
        if (currentState === "deleted") return "checked";
        return null;
      case "partial":
        // 部分选中节点：三态 部分 ↔ 全选 ↔ 删除
        if (currentState === "partial") return "checked";
        if (currentState === "checked") return "deleted";
        if (currentState === "deleted") return "partial";
        return null;
      case "normal":
        // 未选中节点：两态 未选中 ↔ 全选
        if (currentState === "unchecked") return "checked";
        if (currentState === "checked") return "unchecked";
        return null;
      case "deleted":
        // 删除节点：三态 删除 ↔ 全选 ↔ 未选中
        if (currentState === "deleted") return "checked";
        if (currentState === "checked") return "unchecked";
        if (currentState === "unchecked") return "deleted";
        return null;
      default:
        return null;
    }
  },
  /**
   * 设置节点的 UI 状态（checked / partial / deleted / unchecked）
   * 同时更新节点对象、DOM 类、jsTree 内部数据模型和选中集合
   * @param {Object} node jsTree节点对象
   * @param {string} state 目标状态
   */
  _setNodeState: function _setNodeState(node, state) {
    var nodeId = node.id;
    var $nodeEl = this.$(node.li_attr.id ? "#" + node.li_attr.id : '[id="' + nodeId + '"]');

    // 1. 清除所有自定义状态标志和 DOM 类
    node.state.checked = false;
    node.state.partial = false;
    node.state.deleted = false;
    $nodeEl.removeClass("jstree-checked jstree-partial-selected jstree-deleted");
    if (this.jsTree._model.data[nodeId]) {
      this.jsTree._model.data[nodeId].state.checked = false;
      this.jsTree._model.data[nodeId].state.partial = false;
      this.jsTree._model.data[nodeId].state.deleted = false;
    }

    // 2. 根据目标状态设置样式和 jsTree 内部选中状态
    if (state === "checked") {
      node.state.checked = true;
      $nodeEl.addClass("jstree-checked");
      if (this.jsTree._model.data[nodeId]) {
        this.jsTree._model.data[nodeId].state.checked = true;
      }
      this.jsTree.check_node(node, {
        silent: true
      });
    } else {
      // 无论是 partial、deleted 还是 unchecked，都应该从 jsTree 选中集合中移除
      this.jsTree.uncheck_node(node, {
        silent: true
      });
      // 再次强制确保 checked 为 false（防止 uncheck_node 内部异常）
      node.state.checked = false;
      if (this.jsTree._model.data[nodeId]) {
        this.jsTree._model.data[nodeId].state.checked = false;
      }
      if (state === "partial") {
        node.state.partial = true;
        $nodeEl.addClass("jstree-partial-selected");
        if (this.jsTree._model.data[nodeId]) {
          this.jsTree._model.data[nodeId].state.partial = true;
        }
      } else if (state === "deleted") {
        node.state.deleted = true;
        $nodeEl.addClass("jstree-deleted");
        if (this.jsTree._model.data[nodeId]) {
          this.jsTree._model.data[nodeId].state.deleted = true;
        }
      }
      // unchecked 不需要额外样式
    }

    // 3. 同步 checkbox 视觉
    var $checkbox = $nodeEl.find(">.jstree-anchor");
    if ($checkbox.length) {
      if (state === "checked") {
        $checkbox.addClass("jstree-checked");
      } else {
        $checkbox.removeClass("jstree-checked");
      }
    }
  },
  /**
   * 刷新所有节点的部分选中和删除样式（基于初始集合重新应用）
   */
  _refreshAllPartialAndDeletedClasses: function _refreshAllPartialAndDeletedClasses() {
    var _this = this;
    if (!this.jsTree) return;
    var self = this;
    // 重新应用部分选中样式（仅对初始部分节点且当前未交互过的）
    this._initialPartialSet.forEach(function (nodeId) {
      var node = _this.jsTree.get_node(nodeId);
      if (node && !node.state.checked && !node.state.deleted) {
        node.state.partial = true;
        var $nodeEl = _this.$(node.li_attr.id ? "#" + node.li_attr.id : '[id="' + nodeId + '"]');
        $nodeEl.addClass("jstree-partial-selected");
      }
    });
    // 重新应用删除样式（仅对初始删除节点且当前未交互过的）
    this._initialDeletedSet.forEach(function (nodeId) {
      var node = _this.jsTree.get_node(nodeId);
      if (node && !node.state.checked && !node.state.partial) {
        node.state.deleted = true;
        var $nodeEl = _this.$(node.li_attr.id ? "#" + node.li_attr.id : '[id="' + nodeId + '"]');
        $nodeEl.addClass("jstree-deleted");
      }
    });
  },
  _attachNodeActions: function _attachNodeActions() {
    if (!this.showNodeActions) return;

    // 先移除所有现有的操作按钮，避免重复
    this.$("#treeView .node-actions").remove();
    var self = this;
    this.$("#treeView .jstree-node").each(function () {
      var $li = $(this);
      var nodeId = $li.attr("id");
      // 只跳过 load_more 节点
      if (!nodeId || nodeId.indexOf("_load_more") > -1) return;
      var node = self.jsTree.get_node(nodeId);
      if (node && (node.state.disabled || node.data && node.data.loadMore)) return;
      if (!$li.find(".node-actions").length) {
        var isRootNode = nodeId === "root";
        var eidtStr = "";
        var delStr = "";
        if (app.currentUser.canManageArchive()) {
          eidtStr = self.onEditNodeCallback ? '<a class="action-edit icon" data-tooltip="' + BabelStr.str(40151) + '"></a>' : "";
          delStr = self.onDeleteNodeCallback ? '<a class="action-del icon" data-tooltip="' + BabelStr.str(40154) + '"></a>' : "";
        }
        var $actions = $('<span class="node-actions">' + '<a class="action-add icon" data-tooltip="' + BabelStr.str(40153) + '"></a>' + eidtStr + delStr + "</span>");
        $li.find(".jstree-anchor").append($actions);
      }
      $li.find(">.jstree-anchor .node-actions a").off("mousedown.nodeaction click.nodeaction").on("mousedown.nodeaction click.nodeaction", function (e) {
        e.stopPropagation();
        e.preventDefault();
        var $btn = $(this);
        if ($btn.hasClass("action-add")) {
          if (self.onCreateFolder) {
            self.onCreateFolder(nodeId);
          } else if (self.onAddSubFolderCallback) {
            self._onCreateFolder(nodeId);
          }
        } else if ($btn.hasClass("action-edit")) {
          if (self._onEditNode) self._onEditNode(nodeId);
        } else if ($btn.hasClass("action-del")) {
          self._onDeleteNode(nodeId);
        }
      });
    });
  },
  getPathByNode: function getPathByNode(node) {
    return this.jsTree.get_path(node, "/");
  },
  _onEditNode: function _onEditNode(nodeId) {
    var _this2 = this;
    var node = this.jsTree.get_node(nodeId);
    var win = new _MDClassificationEditWinView["default"]({
      originPath: this.jsTree.get_path(node, "/"),
      pathArr: node.parents,
      classificationId: nodeId,
      originName: node.original.text,
      originParentId: node.original.parent == "root" ? "0" : node.original.parent,
      editCallback: function editCallback(param) {
        var newParentId = param.newParentId,
          originParentId = param.originParentId;
        // 刷新原父节点（节点被移走，原父节点子列表变化）
        if (originParentId && originParentId !== "0" && originParentId !== "#") {
          _this2.refreshNode(originParentId);
        } else {
          // 原父节点是根节点
          _this2.refreshNode("root");
        }

        // 如果父节点发生了变化，还需要刷新新父节点
        if (newParentId && newParentId !== originParentId) {
          _this2.refreshNode(newParentId);
        } else {
          // 仅重命名，刷新原父节点即可（上面已做）
        }
      }
    });
    win.show();
  },
  _onDeleteNode: function _onDeleteNode(nodeId) {
    if (this.dataSource != "classification") {
      console.error("待实现");
      return;
    }
    if (this.deleting == true) {
      return;
    }
    this.deleting = true;
    var self = this;
    _MDAlertView["default"].showStandardSelection({
      message: BabelStr.str(40155),
      okFun: function okFun() {
        _MMEnterpriseController["default"].deleteClassification({
          classificationId: nodeId
        }, function () {
          self.deleting = false;
          var parentId = self.jsTree.get_node(nodeId).parent;
          // 调用删除接口
          if (parentId === "#") {
            // 根节点特殊处理：父节点是虚拟根，刷新整棵树或可视根节点
            self.refreshNode("root"); // 假设 showRootNode 为 true
          } else {
            self.refreshNode(parentId);
          }
          _.isFunction(self.onDeleteNodeCallback) && self.onDeleteNodeCallback(nodeId, parentId);
          MDMessageView.success(BabelStr.str(308), self.$msgContainer);
        }, function (err) {
          self.deleting = false;
          MDMessageView.error(err.message || BabelStr.str(4780), self.$msgContainer);
        });
      },
      onClose: function onClose() {
        self.deleting = false;
      }
    });
  },
  _onCreateFolder: function _onCreateFolder(parentId) {
    var _this3 = this;
    if (this.dataSource != "classification") {
      console.error("待实现");
      return;
    }
    var parentFolder = this.getFileInfoById(parentId);
    var win = new _MDCreateFolderWindowView["default"]({
      parentFolder: parentFolder,
      onCreateCallback: function onCreateCallback(newName) {
        _this3._createClassification(parentId, newName);
        win.close();
      }
    });
    win.show();
  },
  _createClassification: function _createClassification(parentId, newName) {
    var self = this;
    var realParentId = !parentId || parentId === "#" || parentId === "root" ? 0 : parentId;
    if (this.requesting) {
      return;
    }
    this.requesting = true;
    _MMEnterpriseController["default"].createClassification({
      parentId: realParentId,
      name: newName
    }, function (response) {
      self.requesting = false;
      if (response && response.success && response.classification) {
        var newData = response.classification;
        var newFileInfo = new _MMFileInfo["default"]({
          fileId: String(newData.id),
          fileName: newData.name,
          parentId: newData.parent,
          isFolder: true,
          rawClassification: newData
        });
        var displayParentId = realParentId == 0 ? "#" : String(realParentId);
        self.onFolderCreated(displayParentId, newFileInfo);
        _.isFunction(self.onAddSubFolderCallback) && self.onAddSubFolderCallback(displayParentId, newFileInfo);
        MDMessageView.success(BabelStr.str(308), self.$msgContainer);
      } else {
        MDMessageView.error(response.message || BabelStr.str(4780), self.$msgContainer);
      }
    }, function (error) {
      self.requesting = false;
      MDMessageView.error(BabelStr.str(4780), self.$msgContainer);
    });
  },
  _setLastClickedHighlight: function _setLastClickedHighlight(nodeId) {
    this.$("#treeView").find(".jstree-last-clicked").removeClass("jstree-last-clicked");
    if (nodeId) {
      var node = this.jsTree.get_node(nodeId);
      if (node && !node.state.disabled) {
        this.$(node.li_attr.id ? "#" + node.li_attr.id : '[id="' + nodeId + '"]').addClass("jstree-last-clicked");
      }
    }
  },
  _handleSingleSelect: function _handleSingleSelect(node, instance) {
    if (this.showRootNode && node.id === "root" && !this.rootNodeSelectable) return;
    var fileInfo = this.fileInforCollection.findWhere({
      fileId: node.id
    });
    this.selectedFolderId = node.id;
    this.selectedPath = instance.get_path(node, "/");
    this.selectedNode = node;
    this.selectedFileInfo = fileInfo;
    this.ancestorIds = instance.get_path(node, false, true);
    this.ancestorFileInfos = [];
    this.ancestorIds.forEach(function (id) {
      var info = this.fileInforCollection.findWhere({
        fileId: id
      });
      if (info) this.ancestorFileInfos.push(info);
    }.bind(this));
    this._lastClickedNodeId = node.id;
    if (this.onSelect) {
      this.onSelect({
        folderId: node.id,
        path: this.selectedPath,
        node: node,
        fileInfo: fileInfo,
        ancestorIds: this.ancestorIds,
        ancestorFileInfos: this.ancestorFileInfos
      });
    }
    // if (this.openFolder && this.onOpenFolder) this.onOpenFolder(node.id);
  },
  _updateSelectedNodes: function _updateSelectedNodes() {
    var self = this;
    this.selectedNodes = [];
    // 直接从 DOM 中收集带有 jstree-checked 类的节点 ID（绕过 jsTree 内部状态）
    var checkedIds = [];
    this.$("#treeView .jstree-node").each(function () {
      var $node = $(this);
      if ($node.hasClass("jstree-checked")) {
        var id = $node.attr("id");
        if (id) checkedIds.push(id);
      }
    });
    checkedIds.forEach(function (id) {
      var node = self.jsTree.get_node(id);
      if (!node || node.data && node.data.loadMore) return;
      var fileInfo = self.fileInforCollection.findWhere({
        fileId: id
      });
      var path = self.jsTree.get_path(node, "/");
      var ancestorIds = self.jsTree.get_path(node, false, true);
      var ancestorFileInfos = [];
      ancestorIds.forEach(function (aid) {
        var info = self.fileInforCollection.findWhere({
          fileId: aid
        });
        if (info) ancestorFileInfos.push(info);
      });
      self.selectedNodes.push({
        folderId: id,
        path: path,
        node: node,
        fileInfo: fileInfo,
        ancestorIds: ancestorIds,
        ancestorFileInfos: ancestorFileInfos
      });
    });
  },
  _loadMoreNodes: function _loadMoreNodes(loadMoreNode) {
    var self = this;
    if (!loadMoreNode || !loadMoreNode.data) return;
    var nodeId = loadMoreNode.id;
    if (this._loadingMoreNodes && this._loadingMoreNodes[nodeId]) return;
    if (!this._loadingMoreNodes) this._loadingMoreNodes = {};
    this._loadingMoreNodes[nodeId] = true;
    var $nodeLi = this.$("#" + nodeId);
    $nodeLi.addClass("jstree-loading-more");
    var latestNode = this.jsTree.get_node(nodeId);
    if (!latestNode || !latestNode.data) {
      $nodeLi.removeClass("jstree-loading-more");
      delete this._loadingMoreNodes[nodeId];
      return;
    }
    var page = latestNode.data.curPage + 1;
    var pages = latestNode.data.pages;
    var fileId = latestNode.data.id;
    var parentId = latestNode.parent;
    var parent = this.jsTree.get_node(parentId);
    if (!parent) {
      delete this._loadingMoreNodes[nodeId];
      return;
    }
    this._getSubfolders(fileId, page, function (collection, pages) {
      var newNodes = self._transformCollectionToJSTreeNodes(collection, false, parentId);
      var originChildren = parent.children.map(function (cid) {
        return self.jsTree._model.data[cid];
      }).filter(function (n) {
        return n;
      });
      var moreNode = null;
      var otherChildren = [];
      originChildren.forEach(function (n) {
        if (n.data && n.data.loadMore) {
          moreNode = n;
        } else {
          otherChildren.push(n);
        }
      });
      var hasMore = moreNode && moreNode.data && moreNode.data.curPage + 2 < pages;
      if (hasMore && moreNode.data) {
        moreNode.data.curPage = page;
        moreNode.data.id = fileId;
      }
      var nodes = otherChildren.concat(newNodes);
      if (hasMore) nodes.push(moreNode);
      self.jsTree._append_json_data(parent, nodes, function () {
        if (hasMore) {
          var updatedMoreNode = self.jsTree.get_node(nodeId);
          if (updatedMoreNode && updatedMoreNode.data) {
            updatedMoreNode.data.curPage = page;
            updatedMoreNode.data.id = fileId;
          }
        }
        self.$("#" + nodeId).removeClass("jstree-loading-more");
        delete self._loadingMoreNodes[nodeId];
      });
      self.fileInforCollection.add(collection.models);
    }, function () {
      self.$("#" + nodeId).removeClass("jstree-loading-more");
      delete self._loadingMoreNodes[nodeId];
    });
  },
  _getSubfolders: function _getSubfolders(fileId, page, success, fail) {
    var self = this;
    var actualId = fileId;
    if (this.showRootNode && fileId === "root") actualId = "#";else if (fileId && fileId.slice && fileId.slice(0, 5) === "0--00") actualId = "0";
    var request = this._getRequestById(fileId);
    request(actualId, app.currentUser.get("defaultSortIndex"), true, page, this.pageSize, function (collection, total, pages) {
      var filtered = collection.filter(function (fileInfo) {
        return !(fileInfo.isShortcuts && fileInfo.isShortcuts() && !fileInfo.isFolder());
      });
      var filteredCollection = new _MMFileInfoCollection["default"](filtered);
      success && success(filteredCollection, pages);
    }, function () {
      fail && fail();
    }, {
      type: 2,
      no2ndFileInfo: true
    });
  },
  _getRequestById: function _getRequestById(id) {
    var effectiveId = this.showRootNode && id === "root" ? "#" : id;
    if (this.dataSource === "classification") {
      if (effectiveId === "#") return this.rootDataProvider ? this.rootDataProvider() : this._getClassificationRequest.bind(this);
      return this._getClassificationRequest.bind(this);
    }
    if (effectiveId === "#") return this.rootDataProvider();
    if (effectiveId && effectiveId.slice && effectiveId.slice(0, 5) === "0--00") {
      var type = effectiveId[5];
      switch (type) {
        case "1":
          return _MMEnterpriseController["default"].listEnterpriseFiles;
        case "2":
          return _MMEnterpriseController["default"].listPersonalFiles;
        case "3":
          return _MMEnterpriseController["default"].listProjectFiles;
        case "4":
          return _MMEnterpriseController["default"].listJoinShareFiles;
        case "5":
          return _MMEnterpriseController["default"].getMyTeamFolders;
        case "6":
          return _MMEnterpriseController["default"].getAllProjectFoldersInEnterpriseInPage;
        default:
          return _MMNetDiskDataController["default"].listDir;
      }
    }
    var file = this.fileInforCollection.findWhere({
      fileId: effectiveId
    });
    if (file && file.isOwner && file.isOwner()) return _MMEnterpriseController["default"].listPersonalFiles;
    return _MMEnterpriseController["default"].listEnterpriseFiles;
  },
  _getClassificationRequest: function _getClassificationRequest(fileId, sort, isFolderOnly, page, pageSize, success, fail, options) {
    var parentId = fileId === "#" ? 0 : fileId;
    _MMEnterpriseController["default"].getClassificationByParent({
      parentId: parentId
    }, function (response) {
      if (response && response.success && response.classifications) {
        var list = response.classifications;
        var models = [];
        _.each(list, function (item) {
          var fileInfo = new _MMFileInfo["default"]({
            fileId: String(item.id),
            fileName: item.name,
            parentId: item.parent,
            isFolder: true,
            hasChild: false,
            subChildNum: item.subClsNum || 0,
            rawClassification: item
          });
          models.push(fileInfo);
          if (this && this.fileInforCollection) this.fileInforCollection.add(fileInfo, {
            merge: true
          });
        }.bind(this));
        var collection = new _MMFileInfoCollection["default"](models);
        success(collection, list.length, 1);
      } else {
        fail && fail(response);
      }
    }.bind(this), function (error) {
      fail && fail(error);
    });
  },
  _transformCollectionToJSTreeNodes: function _transformCollectionToJSTreeNodes(collection, isRootTree, parentId) {
    var self = this;
    var folders = collection.filter(function (fileInfo) {
      if (!fileInfo.isFolder()) return false;
      if (self.openFolder && fileInfo.isEncryptedFolder && fileInfo.isEncryptedFolder()) return false;
      if (self.nodeFilter && !self.nodeFilter(fileInfo)) return false;
      return true;
    });
    return folders.map(function (fileInfo) {
      return self._transformToJSTreeNode(fileInfo, isRootTree, parentId);
    });
  },
  _transformToJSTreeNode: function _transformToJSTreeNode(fileInfo, isRootTree, parentId) {
    var nodeInfo = fileInfo.getTreeNodeInfo(parentId, this.testUpload);
    var disabled = false;
    if (this.nodeDisabled && this.nodeDisabled(fileInfo)) {
      nodeInfo.li_attr["class"] += " no_upload__node";
      disabled = true;
    }
    var subChildNum = fileInfo.get("subChildNum");
    nodeInfo.children = !disabled && (subChildNum === undefined || subChildNum > 0);
    nodeInfo.state.disabled = disabled;
    nodeInfo.data = nodeInfo.data || {};
    nodeInfo.data.teamMark = fileInfo.get("teamMark");

    // 新版本新增
    if (this.multiSelect) {
      nodeInfo.state.checked = false;
      nodeInfo.state.partial = false;
      nodeInfo.state.deleted = false;
    }
    if (isRootTree && parentId) nodeInfo.parent = parentId === "-1" ? "#" : parentId;
    return nodeInfo;
  },
  openPath: function openPath(pathIds) {
    if (!pathIds || !pathIds.length) return;
    if (!this._isReady) {
      this._pendingOpenPath = pathIds.slice();
      return;
    }
    this._openPathByIds(pathIds);
  },
  _openPathByIds: function _openPathByIds(pathIds) {
    var self = this;
    var nextId = pathIds.shift();
    if (!nextId) return;
    this.jsTree.open_node(nextId, function () {
      self._openPathByIds(pathIds);
    });
    if (pathIds.length === 0 && !this.multiSelect) this.jsTree.select_node(nextId);
  },
  refreshNode: function refreshNode(nodeId) {
    var self = this;
    var savedStates = this._saveNodeStates(nodeId);
    if (nodeId == "#" || nodeId == "root") {
      this.jsTree.refresh();
      setTimeout(function () {
        self._restoreAllNodeStates(savedStates);
        self._refreshAllPartialAndDeletedClasses();
        if (self.showNodeActions) self._attachNodeActions();
      }, 100);
    } else {
      this.jsTree.refresh_node(nodeId);
      setTimeout(function () {
        self._restoreNodeStates(savedStates);
        self._refreshAllPartialAndDeletedClasses();
        if (self.showNodeActions) self._attachNodeActions();
      }, 100);
    }
  },
  selectNode: function selectNode(nodeId) {
    if (this.multiSelect) console.warn("selectNode not recommended in multiSelect mode");
    this.jsTree.deselect_all();
    this.jsTree.select_node(nodeId);
  },
  setSelectedNodes: function setSelectedNodes(nodeIds) {
    if (!this.multiSelect) {
      console.warn("setSelectedNodes only works in multiSelect mode");
      return;
    }
    this.jsTree.deselect_all();
    this.jsTree.select_node(nodeIds);
  },
  getSelectedNodes: function getSelectedNodes() {
    return this.selectedNodes.slice();
  },
  toggleNode: function toggleNode(nodeId) {
    if (!this.multiSelect) return;
    var node = this.jsTree.get_node(nodeId);
    if (node && !node.state.disabled) this.jsTree.toggle_node(nodeId);
  },
  openNode: function openNode(nodeId) {
    this.jsTree.open_node(nodeId);
  },
  getSelectedFolderId: function getSelectedFolderId() {
    return this.selectedFolderId;
  },
  getSelectedPath: function getSelectedPath() {
    return this.selectedPath;
  },
  getSelectedNode: function getSelectedNode() {
    return this.selectedNode;
  },
  getSelectedFileInfo: function getSelectedFileInfo() {
    return this.selectedFileInfo;
  },
  getAncestorIds: function getAncestorIds() {
    return this.ancestorIds;
  },
  getFileInfoById: function getFileInfoById(fileId) {
    return this.fileInforCollection.findWhere({
      fileId: fileId
    });
  },
  getAllFileInfos: function getAllFileInfos() {
    return this.fileInforCollection;
  },
  _onCreateFolderClick: function _onCreateFolderClick() {
    var parentId;
    if (this.multiSelect) parentId = this._lastClickedNodeId && this._lastClickedNodeId !== -1 ? this._lastClickedNodeId : "#";else parentId = this.selectedFolderId && this.selectedFolderId !== -1 ? this.selectedFolderId : "#";
    if (this.onCreateFolder) {
      this.onCreateFolder(parentId);
    } else if (this.onAddSubFolderCallback || this.onFolderAppended) {
      this._onCreateFolder(parentId);
    }
  },
  // onFolderCreated: function (parentFolderId, newFolder) {
  //   this.fileInforCollection.add(newFolder);
  //   this.refreshNode(parentFolderId);
  //   setTimeout(() => {
  //     this.openNode(parentFolderId);
  //     if (!this.multiSelect) this.selectNode(newFolder.getFileId());
  //   }, 400);
  // },

  onFolderCreated: function onFolderCreated(parentFolderId, newFolder) {
    var self = this;
    if (this.folderCreateMode === "append") {
      this.fileInforCollection.add(newFolder);
      var parentNode = this.jsTree.get_node(parentFolderId);
      if (!parentNode) {
        // 父节点不存在，回退到刷新模式
        this._refreshNodeAndRestoreState(parentFolderId, newFolder);
        return;
      }

      // 正确判断节点是否已加载
      var isLoaded = parentNode.state && parentNode.state.loaded === true;

      // 即使 loaded 为 true，也可能 children 是空数组（确实没有子节点）
      // 但此时应该可以追加
      if (!isLoaded) {
        // 节点未加载，先打开（加载）节点再追加
        this.jsTree.open_node(parentFolderId, function () {
          var loadedParentNode = self.jsTree.get_node(parentFolderId);
          if (!loadedParentNode) {
            self._refreshNodeAndRestoreState(parentFolderId, newFolder);
            return;
          }

          // 检查新节点是否已存在（通过文件名去重）
          var hasExisting = false;
          if (Array.isArray(loadedParentNode.children)) {
            for (var i = 0; i < loadedParentNode.children.length; i++) {
              var childNode = self.jsTree.get_node(loadedParentNode.children[i]);
              if (childNode && childNode.text === newFolder.getFileName()) {
                hasExisting = true;
                break;
              }
            }
          }
          if (hasExisting) {
            self.openNode(parentFolderId);
            return;
          }
          self._appendNewNode(parentFolderId, newFolder, loadedParentNode);
        });
        return;
      }

      // 节点已加载，检查是否已存在同名节点
      var hasExisting = false;
      if (Array.isArray(parentNode.children)) {
        for (var i = 0; i < parentNode.children.length; i++) {
          var childNode = this.jsTree.get_node(parentNode.children[i]);
          if (childNode && childNode.text === newFolder.getFileName()) {
            hasExisting = true;
            break;
          }
        }
      }
      if (hasExisting) {
        this.openNode(parentFolderId);
        return;
      }

      // 检查是否已存在相同 ID 的节点
      var existingById = this.jsTree.get_node(newFolder.getFileId());
      if (existingById) {
        this.openNode(parentFolderId);
        if (!this.multiSelect) {
          setTimeout(function () {
            self.selectNode(newFolder.getFileId());
          }, 100);
        }
        if (this.onFolderAppended) {
          this.onFolderAppended({
            parentId: parentFolderId,
            newFolder: newFolder,
            node: existingById
          });
        }
        return;
      }
      this._appendNewNode(parentFolderId, newFolder, parentNode);
    } else {
      // ===== 刷新模式 =====
      this._refreshNodeAndRestoreState(parentFolderId, newFolder);
    }
  },
  /**
   * 追加新节点到父节点
   * @private
   */
  _appendNewNode: function _appendNewNode(parentFolderId, newFolder, parentNode) {
    var self = this;
    var newNode = this._transformToJSTreeNode(newFolder, false, parentFolderId);
    newNode.state = newNode.state || {};
    newNode.state.disabled = false;
    newNode.state.opened = false;
    newNode.state.selected = false;
    newNode.state.checked = false;
    newNode.state.partial = false;
    newNode.state.deleted = false;
    this.jsTree.create_node(parentNode, newNode, "last", function (newNodeRef) {
      if (self.multiSelect) {
        self._nodeTypeMap.set(newNodeRef.id, "normal");
        var $nodeEl = self.$('[id="' + newNodeRef.id + '"]');
        $nodeEl.removeClass("jstree-checked jstree-partial-selected jstree-deleted");
      }
      self.openNode(parentFolderId);
      if (!self.multiSelect) {
        setTimeout(function () {
          self.selectNode(newFolder.getFileId());
        }, 100);
      }
      if (self.showNodeActions) {
        setTimeout(function () {
          self._attachNodeActions();
        }, 50);
      }
      if (self.onFolderAppended) {
        self.onFolderAppended({
          parentId: parentFolderId,
          newFolder: newFolder,
          node: newNodeRef
        });
      }
    });
  },
  _refreshNodeAndRestoreState: function _refreshNodeAndRestoreState(parentFolderId, newFolder) {
    var self = this;
    var savedStates = this._saveNodeStates(parentFolderId);
    this.fileInforCollection.add(newFolder);
    this.refreshNode(parentFolderId);
    setTimeout(function () {
      self.openNode(parentFolderId);
      self._restoreNodeStates(savedStates);
      if (!self.multiSelect && newFolder) {
        self.selectNode(newFolder.getFileId());
      }
      if (self.showNodeActions) self._attachNodeActions();
      self._refreshAllPartialAndDeletedClasses();
    }, 400);
  },
  // ===== 新增：保存节点状态 =====
  _saveNodeStates: function _saveNodeStates(nodeId) {
    var self = this;
    var states = {
      checked: [],
      partial: [],
      deleted: [],
      nodeId: nodeId
    };
    var targetNode = this.jsTree.get_node(nodeId);
    if (!targetNode) return states;
    var nodeIds = [nodeId];
    if (targetNode.children && targetNode.children.length) {
      targetNode.children.forEach(function (childId) {
        nodeIds.push(childId);
      });
    }
    nodeIds.forEach(function (id) {
      var node = self.jsTree.get_node(id);
      if (!node) return;
      if (node.state.checked) states.checked.push(id);
      if (node.state.partial) states.partial.push(id);
      if (node.state.deleted) states.deleted.push(id);
    });
    return states;
  },
  // ===== 新增：恢复节点状态 =====
  _restoreNodeStates: function _restoreNodeStates(states) {
    var self = this;
    if (!states) return;
    states.checked.forEach(function (id) {
      var node = self.jsTree.get_node(id);
      if (node) self._setNodeState(node, "checked");
    });
    states.partial.forEach(function (id) {
      var node = self.jsTree.get_node(id);
      if (node) self._setNodeState(node, "partial");
    });
    states.deleted.forEach(function (id) {
      var node = self.jsTree.get_node(id);
      if (node) self._setNodeState(node, "deleted");
    });
    this._updateSelectedNodes();
    if (this.onSelectionChange) {
      this.onSelectionChange({
        selectedNodes: this.selectedNodes.slice()
      });
    }
  },
  // ===== 新增：保存所有节点状态 =====
  _saveAllNodeStates: function _saveAllNodeStates() {
    var self = this;
    var states = {
      checked: [],
      partial: [],
      deleted: []
    };
    var allNodes = Object.keys(this.jsTree._model.data);
    allNodes.forEach(function (id) {
      if (id === "#") return;
      var node = self.jsTree.get_node(id);
      if (!node) return;
      if (node.state.checked) states.checked.push(id);
      if (node.state.partial) states.partial.push(id);
      if (node.state.deleted) states.deleted.push(id);
    });
    return states;
  },
  // ===== 新增：恢复所有节点状态 =====
  _restoreAllNodeStates: function _restoreAllNodeStates(states) {
    var self = this;
    if (!states) return;
    states.checked.forEach(function (id) {
      var node = self.jsTree.get_node(id);
      if (node) self._setNodeState(node, "checked");
    });
    states.partial.forEach(function (id) {
      var node = self.jsTree.get_node(id);
      if (node) self._setNodeState(node, "partial");
    });
    states.deleted.forEach(function (id) {
      var node = self.jsTree.get_node(id);
      if (node) self._setNodeState(node, "deleted");
    });
    this._updateSelectedNodes();
    if (this.onSelectionChange) {
      this.onSelectionChange({
        selectedNodes: this.selectedNodes.slice()
      });
    }
  },
  /**
   * 根据文件路径数据自动设置节点的选中状态和部分选中状态（多选模式专用）
   * 支持四种初始状态：全选、部分选中、未选中、已删除
   *
   * @param {Array} fileInfos - 文件路径数据 [{ id, paths }]
   * @param {Array} [deletedNodeIds] - 初始“已删除”的节点ID列表
   */
  applyPartialSelectionByFilePaths: function applyPartialSelectionByFilePaths(fileInfos, deletedNodeIds) {
    var _this4 = this;
    if (!this.multiSelect) {
      console.warn("applyPartialSelectionByFilePaths only works in multiSelect mode");
      return;
    }
    if (!this.jsTree || !this._isReady) {
      setTimeout(function () {
        return _this4.applyPartialSelectionByFilePaths(fileInfos, deletedNodeIds);
      }, 100);
      return;
    }
    var totalFiles = fileInfos.length;
    if (totalFiles === 0 && (!deletedNodeIds || deletedNodeIds.length === 0)) return;

    // 收集所有需要打开的完整路径（节点ID数组，从根到叶子）
    var pathsToOpen = [];
    var parsePathToNodeIds = function parsePathToNodeIds(pathStr) {
      return pathStr.split("/").filter(function (p) {
        return p && p !== "0";
      });
    };
    (fileInfos || []).forEach(function (file) {
      (file.paths || []).forEach(function (path) {
        var nodeIds = parsePathToNodeIds(path);
        if (nodeIds.length) pathsToOpen.push(nodeIds);
      });
    });
    if (pathsToOpen.length === 0) {
      // 没有路径需要打开，直接应用状态
      this._applySelectionStates(fileInfos, deletedNodeIds);
      return;
    }

    // 打开所有路径（去重后），全部完成后再应用状态
    this._openMultiplePaths(pathsToOpen, function () {
      _this4._applySelectionStates(fileInfos, deletedNodeIds);
    });
  },
  /**
   * 打开多条路径，所有路径都打开后执行回调
   * @param {Array<Array<string>>} paths 路径数组，每条路径是节点ID数组（从根到叶子）
   * @param {Function} callback 全部打开后的回调
   */
  _openMultiplePaths: function _openMultiplePaths(paths, callback) {
    var _this5 = this;
    if (!paths.length) {
      callback();
      return;
    }
    // 去重：将每条路径转为字符串，用 Set 去重
    var uniquePaths = [];
    var pathStrSet = new Set();
    paths.forEach(function (path) {
      var key = path.join("/");
      if (!pathStrSet.has(key)) {
        pathStrSet.add(key);
        uniquePaths.push(path);
      }
    });
    var pending = uniquePaths.length;
    var hasError = false;
    var onPathOpened = function onPathOpened() {
      if (hasError) return;
      pending--;
      if (pending === 0) callback();
    };
    uniquePaths.forEach(function (pathIds) {
      _this5._openSinglePath(pathIds, function () {
        return onPathOpened();
      }, function (err) {
        hasError = true;
        console.error("Failed to open path:", pathIds, err);
        onPathOpened(); // 继续尝试其他路径
      });
    });
  },
  /**
   * 打开单条完整路径（递归逐层打开）
   * @param {Array<string>} pathIds 节点ID数组，例如 ['11', '23', '94']
   * @param {Function} callback 成功打开全部节点后的回调
   * @param {Function} failCallback 失败回调（可选）
   */
  _openSinglePath: function _openSinglePath(pathIds, callback, failCallback) {
    var _this6 = this;
    if (!pathIds || pathIds.length === 0) {
      callback();
      return;
    }
    var index = 0;
    var openNext = function openNext() {
      if (index >= pathIds.length) {
        callback();
        return;
      }
      var nodeId = pathIds[index];
      var node = _this6.jsTree.get_node(nodeId);
      if (!node) {
        console.warn("Node not found:", nodeId);
        failCallback && failCallback("Node not found");
        return;
      }
      var isLast = index === pathIds.length - 1;
      if (isLast) {
        // 最后一个节点不需要打开，直接继续
        index++;
        openNext();
        return;
      }

      // 非最后一个节点：需要确保打开
      var isOpened = node.state.opened === true;
      if (isOpened) {
        index++;
        openNext();
      } else {
        var onNodeOpened = function onNodeOpened(e, data) {
          if (data.node.id === nodeId) {
            _this6.$("#treeView").off("open_node.jstree", onNodeOpened);
            index++;
            openNext();
          }
        };
        _this6.$("#treeView").on("open_node.jstree", onNodeOpened);
        _this6.jsTree.open_node(nodeId, null, false);
      }
    };
    openNext();
  },
  _ensureNodesLoaded: function _ensureNodesLoaded(nodeIds, callback) {
    var _this7 = this;
    var loadedSet = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Set();
    if (!nodeIds.length) {
      callback();
      return;
    }
    // 去重并过滤已加载节点
    var needLoad = nodeIds.filter(function (id) {
      var node = _this7.jsTree.get_node(id);
      return !node || node && !node.state.loaded;
    });
    if (needLoad.length === 0) {
      callback();
      return;
    }
    var pending = needLoad.length;
    var hasError = false;
    var onLoaded = function onLoaded(id) {
      if (hasError) return;
      pending--;
      if (pending === 0) callback();
    };
    needLoad.forEach(function (id) {
      var parentId = _this7._getParentIdForNode(id);
      if (!parentId) {
        // 没有父节点（可能是根下的直接子节点），尝试直接打开该节点
        var node = _this7.jsTree.get_node(id);
        if (node && node.state.loaded) {
          onLoaded(id);
        } else {
          var onLoadNode = function onLoadNode(e, data) {
            if (data.node.id === id) {
              _this7.$("#treeView").off("load_node.jstree", onLoadNode);
              onLoaded(id);
            }
          };
          _this7.$("#treeView").on("load_node.jstree", onLoadNode);
          _this7.jsTree.open_node(id, function () {}, false);
        }
        return;
      }
      // 先确保父节点打开
      _this7._ensureNodesLoaded([parentId], function () {
        if (hasError) return;
        var node = _this7.jsTree.get_node(id);
        if (node && node.state.loaded) {
          onLoaded(id);
          return;
        }
        // 监听节点加载完成事件
        var onLoadNode = function onLoadNode(e, data) {
          if (data.node.id === id) {
            _this7.$("#treeView").off("load_node.jstree", onLoadNode);
            onLoaded(id);
          }
        };
        _this7.$("#treeView").on("load_node.jstree", onLoadNode);
        _this7.jsTree.open_node(id, function () {}, false);
      }, loadedSet);
    });
  },
  _getParentIdForNode: function _getParentIdForNode(nodeId) {
    // 优先从 jsTree 节点获取 parent
    var node = this.jsTree.get_node(nodeId);
    if (node && node.parent && node.parent !== "#") return node.parent;
    // 后备：从 fileInforCollection 中查找
    var fileInfo = this.fileInforCollection.findWhere({
      fileId: nodeId
    });
    if (fileInfo && fileInfo.get("parentId")) {
      var parentId = fileInfo.get("parentId");
      // 如果父节点是 '0' 或 null，可能需要映射为根节点 ID
      if (parentId === "0" || parentId === 0) {
        return this.showRootNode ? "root" : "#";
      }
      return String(parentId);
    }
    return null;
  },
  _applySelectionStates: function _applySelectionStates(fileInfos, deletedNodeIds) {
    var _this8 = this;
    var totalFiles = fileInfos.length;

    // 保存原始数据用于差异计算
    this._originalFileInfos = fileInfos;

    // 清空之前的初始状态记录
    this._initialFullCheckedSet.clear();
    this._initialPartialSet.clear();
    this._initialDeletedSet.clear();
    this._nodeTypeMap.clear();

    // 1. 统计每个叶子节点（文件直接所属的分类）被多少个文件覆盖
    var nodeCoverCount = {};
    var parsePathToNodeIds = function parsePathToNodeIds(pathStr) {
      return pathStr.split("/").filter(function (p) {
        return p && p !== "0";
      });
    };
    if (fileInfos && fileInfos.length) {
      fileInfos.forEach(function (file) {
        var paths = file.paths || [];
        paths.forEach(function (path) {
          var nodeIds = parsePathToNodeIds(path);
          if (nodeIds.length === 0) return;
          // 只取路径的最后一个节点（文件直接所属的分类）
          var leafNodeId = nodeIds[nodeIds.length - 1];
          nodeCoverCount[leafNodeId] = (nodeCoverCount[leafNodeId] || 0) + 1;
        });
      });
    }

    // 2. 获取所有节点，分类处理
    var allNodes = this.jsTree.get_json("#", {
      flat: true
    });
    var toCheck = [];
    var toPartial = [];
    var deletedSet = new Set(deletedNodeIds || []);
    allNodes.forEach(function (node) {
      var nodeId = node.id;
      if (nodeId === "#" || _this8.showRootNode && nodeId === "root") return;
      var count = nodeCoverCount[nodeId] || 0;
      if (totalFiles > 0 && count === totalFiles) {
        toCheck.push(nodeId);
        _this8._initialFullCheckedSet.add(nodeId);
        _this8._nodeTypeMap.set(nodeId, "full");
      } else if (totalFiles > 0 && count > 0 && count < totalFiles) {
        toPartial.push(nodeId);
        _this8._initialPartialSet.add(nodeId);
        _this8._nodeTypeMap.set(nodeId, "partial");
      } else if (count === 0 && deletedSet.has(nodeId)) {
        _this8._initialDeletedSet.add(nodeId);
        _this8._nodeTypeMap.set(nodeId, "deleted");
      } else {
        _this8._nodeTypeMap.set(nodeId, "normal");
      }
    });

    // 3. 应用状态到 jsTree（临时关闭回调）
    var oldOnSelectionChange = this.onSelectionChange;
    this.onSelectionChange = null;

    // 清除所有节点的状态（包括选中和自定义样式）
    var allNodeIds = Object.keys(this.jsTree._model.data).filter(function (id) {
      return id !== "#";
    });
    allNodeIds.forEach(function (id) {
      var node = _this8.jsTree.get_node(id);
      if (node) {
        node.state.checked = false;
        node.state.partial = false;
        node.state.deleted = false;
        var $el = _this8.$(node.li_attr.id ? "#" + node.li_attr.id : '[id="' + id + '"]');
        $el.removeClass("jstree-checked jstree-partial-selected jstree-deleted");
        $el.find(".jstree-checkbox").removeClass("jstree-checked");
        if (_this8.jsTree._model.data[id]) {
          _this8.jsTree._model.data[id].state.checked = false;
          _this8.jsTree._model.data[id].state.partial = false;
          _this8.jsTree._model.data[id].state.deleted = false;
        }
      }
    });

    // 设置状态
    toCheck.forEach(function (nodeId) {
      var node = _this8.jsTree.get_node(nodeId);
      if (node) _this8._setNodeState(node, "checked");
    });
    toPartial.forEach(function (nodeId) {
      var node = _this8.jsTree.get_node(nodeId);
      if (node) _this8._setNodeState(node, "partial");
    });
    var _iterator = _createForOfIteratorHelper(this._initialDeletedSet),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var nodeId = _step.value;
        var node = this.jsTree.get_node(nodeId);
        if (node) this._setNodeState(node, "deleted");
      }

      // 恢复回调并刷新选中节点列表
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    this.onSelectionChange = oldOnSelectionChange;
    this._updateSelectedNodes();
    if (this.onSelectionChange) {
      this.onSelectionChange({
        selectedNodes: this.selectedNodes.slice()
      });
    }
  },
  /**
   * 从分类数据中构建文件路径并应用初始选中状态
   * @param {Object} data - 分类数据，包含 classifications 和 classes
   * @param {Array} fileIds - 文件ID数组（可选，若不提供则从 classifications 中提取）
   * @param {Array} [deletedNodeIds] - 初始已删除节点ID列表
   */
  applyPartialSelectionByClassificationData: function applyPartialSelectionByClassificationData(data, fileIds, deletedNodeIds) {
    if (!this.multiSelect) {
      console.warn("applyPartialSelectionByClassificationData only works in multiSelect mode");
      return;
    }
    if (!data || !data.classifications || !data.classes) {
      console.error("Invalid classification data");
      return;
    }

    // 构建分类ID到路径ID数组的映射
    var classIdToPathIds = {};
    data.classes.forEach(function (cls) {
      var pathIds = cls.pathIds;
      if (!pathIds && cls.path) {
        pathIds = cls.path.split("/").filter(function (p) {
          return p && p !== "0";
        }).map(function (p) {
          return parseInt(p, 10);
        });
      }
      classIdToPathIds[cls.id] = pathIds && pathIds.length ? pathIds : [cls.id];
    });

    // 确定需要处理的文件ID列表
    var targetFileIds = fileIds && fileIds.length ? fileIds : _.uniq(data.classifications.map(function (item) {
      return String(item.fileId);
    }));

    // 构建文件到路径集合的映射
    var fileToPaths = new Map();
    targetFileIds.forEach(function (fid) {
      return fileToPaths.set(fid, new Set());
    });
    data.classifications.forEach(function (item) {
      var fileId = String(item.fileId);
      var classId = item.classId;
      var pathIds = classIdToPathIds[classId];
      if (!pathIds) return;
      var pathStr = "/0/" + pathIds.join("/");
      if (fileToPaths.has(fileId)) {
        fileToPaths.get(fileId).add(pathStr);
      }
    });

    // 转换为 fileInfos 格式
    var fileInfos = [];
    var _iterator2 = _createForOfIteratorHelper(fileToPaths.entries()),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _step2$value = (0, _slicedToArray2["default"])(_step2.value, 2),
          fileId = _step2$value[0],
          pathSet = _step2$value[1];
        if (pathSet.size > 0) {
          fileInfos.push({
            id: fileId,
            paths: Array.from(pathSet)
          });
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    if (!fileInfos.length) {
      for (var i = 0; i < fileIds.length; i++) {
        fileInfos.push({
          id: fileIds[i],
          paths: []
        });
      }
    }
    this.applyPartialSelectionByFilePaths(fileInfos, deletedNodeIds);
  },
  /**
   * 从变更数据（inserts/deletes/classes）构建文件路径信息并应用初始选中状态
   * @param {Object} data - 包含 inserts, deletes, classes 等字段的数据对象
   * @param {Array} data.inserts - 新增关联记录 [{ fileId, classId }]
   * @param {Array} data.deletes - 删除关联记录 [{ fileId, classId }]
   * @param {Array} data.classes - 分类信息 [{ id, pathIds }]
   * @param {Array} [data.allClasses] - 可选，所有分类信息（与 classes 结构相同）
   */
  applyPartialSelectionByChangeData: function applyPartialSelectionByChangeData(data) {
    var _this9 = this;
    if (!this.multiSelect) {
      console.warn("applyPartialSelectionByChangeData only works in multiSelect mode");
      return;
    }
    if (!this.jsTree || !this._isReady) {
      setTimeout(function () {
        return _this9.applyPartialSelectionByChangeData(data);
      }, 100);
      return;
    }

    // 构建分类 ID 到路径 ID 数组的映射（优先使用 classes，其次 allClasses）
    var classList = data.classes || data.allClasses || [];
    var classIdToPathIds = {};
    _.each(classList, function (cls) {
      var pathIds = cls.pathIds;
      if (!pathIds && cls.path) {
        // 如果没有 pathIds 但有 path 字符串，则解析
        pathIds = cls.path.split("/").filter(function (p) {
          return p && p !== "0";
        }).map(function (p) {
          return parseInt(p, 10);
        });
      }
      if (pathIds && pathIds.length) {
        classIdToPathIds[cls.id] = pathIds;
      } else {
        // 兜底：自身 ID 作为唯一路径
        classIdToPathIds[cls.id] = [cls.id];
      }
    });

    // 收集每个文件关联的路径集合
    var fileToPaths = new Map(); // key: fileId, value: Set of path strings

    // 处理 inserts（新增关联）
    var inserts = data.inserts || [];
    _.each(inserts, function (insert) {
      var fileId = String(insert.fileId);
      var classId = insert.classId;
      var pathIds = classIdToPathIds[classId];
      if (!pathIds) return;
      var pathStr = "/0/" + pathIds.join("/");
      if (!fileToPaths.has(fileId)) {
        fileToPaths.set(fileId, new Set());
      }
      fileToPaths.get(fileId).add(pathStr);
    });

    // 收集所有被删除的分类节点 ID（用于 deletedNodeIds）
    var deletedNodeIds = [];
    var deletes = data.deletes || [];
    _.each(deletes, function (del) {
      var classId = del.classId;
      if (classId && !deletedNodeIds.includes(String(classId))) {
        deletedNodeIds.push(String(classId));
      }
    });

    // 转换为 applyPartialSelectionByFilePaths 所需的 fileInfos 格式
    var fileInfos = [];
    var _iterator3 = _createForOfIteratorHelper(fileToPaths.entries()),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _step3$value = (0, _slicedToArray2["default"])(_step3.value, 2),
          fileId = _step3$value[0],
          pathSet = _step3$value[1];
        fileInfos.push({
          id: fileId,
          paths: Array.from(pathSet)
        });
      }

      // 调用原有方法
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    this.applyPartialSelectionByFilePaths(fileInfos, deletedNodeIds);
  },
  /**
   * 更底层的方法：直接根据 inserts/deletes/classes 构建 fileInfos 和 deletedNodeIds
   * 供外部灵活调用
   * @param {Array} inserts - [{ fileId, classId }]
   * @param {Array} deletes - [{ classId }] 或 [{ fileId, classId }]
   * @param {Array} classes - [{ id, pathIds }]
   * @returns {Object} { fileInfos, deletedNodeIds }
   */
  _buildFileInfosFromChanges: function _buildFileInfosFromChanges(inserts, deletes, classes) {
    // 构建分类路径映射
    var classIdToPathIds = {};
    _.each(classes, function (cls) {
      var pathIds = cls.pathIds;
      if (!pathIds && cls.path) {
        pathIds = cls.path.split("/").filter(function (p) {
          return p && p !== "0";
        }).map(function (p) {
          return parseInt(p, 10);
        });
      }
      classIdToPathIds[cls.id] = pathIds || [cls.id];
    });

    // 收集文件路径
    var fileToPaths = new Map();
    _.each(inserts, function (insert) {
      var fileId = String(insert.fileId);
      var classId = insert.classId;
      var pathIds = classIdToPathIds[classId];
      if (pathIds) {
        var pathStr = "/0/" + pathIds.join("/");
        if (!fileToPaths.has(fileId)) fileToPaths.set(fileId, new Set());
        fileToPaths.get(fileId).add(pathStr);
      }
    });

    // 收集删除的分类节点 ID
    var deletedNodeIds = [];
    _.each(deletes, function (del) {
      var classId = del.classId;
      if (classId && !deletedNodeIds.includes(String(classId))) {
        deletedNodeIds.push(String(classId));
      }
    });
    var fileInfos = [];
    var _iterator4 = _createForOfIteratorHelper(fileToPaths.entries()),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var _step4$value = (0, _slicedToArray2["default"])(_step4.value, 2),
          fileId = _step4$value[0],
          pathSet = _step4$value[1];
        fileInfos.push({
          id: fileId,
          paths: Array.from(pathSet)
        });
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
    return {
      fileInfos: fileInfos,
      deletedNodeIds: deletedNodeIds
    };
  },
  /**
   * 获取最终选中与初始状态的差异
   * 支持四种初始状态：全选、部分选中、未选中、已删除
   *
   * 差异计算规则：
   * - classificationIds：用户额外选中的节点（相对于初始状态）
   *   * 初始未选中（普通） → 最终选中
   *   * 初始部分选中 → 最终选中（从半选变为全选）
   *   * 初始已删除 → 最终选中（从删除状态变为关联）
   * - delClassificationIds：用户取消选中的节点
   *   * 初始全选 → 最终未选中
   *   * 初始部分选中 → 最终未选中（从半选变为未选）
   * - 初始状态与最终状态相同时不计入任何差异集合
   *   * 初始全选且最终全选 → 无变化
   *   * 初始部分选中且最终仍为部分选中 → 无变化（未点击）
   *   * 初始未选中且最终未选中 → 无变化
   *   * 初始已删除且最终未选中（仍为删除样式）→ 无变化
   *
   * @returns {Object} { fileIds, delFileIds, classificationIds, delClassificationIds }
   */
  getSelectionDiff: function getSelectionDiff() {
    var _this10 = this;
    //无初始数据时返回空
    if (!this._originalFileInfos && this._initialFullCheckedSet.size === 0 && this._initialPartialSet.size === 0 && this._initialDeletedSet.size === 0) {
      return {
        fileIds: "",
        delFileIds: "",
        classificationIds: "",
        delClassificationIds: ""
      };
    }

    // 获取当前选中的节点ID集合（checked 节点）
    var currentChecked = this.jsTree.get_checked();
    var currentSet = new Set(currentChecked);
    var added = new Set(); // 新增的分类ID（用户新勾选的）
    var removed = new Set(); // 删除的分类ID（用户取消勾选的）

    // 辅助函数：获取节点当前的实际状态（考虑 partial 和 deleted）
    var getCurrentEffectiveState = function getCurrentEffectiveState(nodeId) {
      var node = _this10.jsTree.get_node(nodeId);
      if (!node) return "unchecked";
      if (node.state.checked) return "checked";
      if (node.state.partial) return "partial";
      if (node.state.deleted) return "deleted";
      return "unchecked";
    };

    // 1. 处理初始全选节点
    var _iterator5 = _createForOfIteratorHelper(this._initialFullCheckedSet),
      _step5;
    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var id = _step5.value;
        var effectiveState = getCurrentEffectiveState(id);
        if (effectiveState === "checked") {
          // 仍然全选，无变化
        } else if (effectiveState === "deleted") {
          // 初始全选 → 删除：需要删除
          removed.add(id);
        } else {
          // 其他情况（未选中），也需要删除
          removed.add(id);
        }
      }

      // 2. 处理初始部分选中节点
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
    var _iterator6 = _createForOfIteratorHelper(this._initialPartialSet),
      _step6;
    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var _id = _step6.value;
        var _effectiveState = getCurrentEffectiveState(_id);
        if (_effectiveState === "checked") {
          // 初始部分 → 全选：需要新增
          added.add(_id);
        } else if (_effectiveState === "deleted") {
          // 初始部分 → 删除：需要删除
          removed.add(_id);
        } else if (_effectiveState === "partial") {
          // 初始部分 → 仍为部分：无变化
        } else {
          // 初始部分 → 未选中：需要删除
          removed.add(_id);
        }
      }

      // 3. 处理初始已删除节点
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
    var _iterator7 = _createForOfIteratorHelper(this._initialDeletedSet),
      _step7;
    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var _id2 = _step7.value;
        var _effectiveState2 = getCurrentEffectiveState(_id2);
        if (_effectiveState2 === "checked") {
          // 初始删除 → 全选：需要新增
          added.add(_id2);
        } else if (_effectiveState2 === "deleted") {
          // 初始删除 → 仍为删除：无变化
        } else if (_effectiveState2 === "unchecked") {
          // 初始删除 → 普通未选中：无变化（仍为未选中，但样式变了？根据需求，删除节点可变为未选中，此时应视为无关联，但不算删除变更？用户要求三态：删除、全选、未选中，所以从未选中再到删除是另一个循环。此处从未选中变为删除应视为新增？不，未选中不是初始状态，所以用户从未选中点击会变成删除？根据状态机，删除节点从未选中点一下会变成删除。但这里我们需要的是最终状态与初始状态的差异。如果初始是删除，最终是未选中，那么不应该算作删除，因为未选中并不是“删除关联”而是“彻底不关联”，但业务上可能希望将这种视为删除？用户需求未明确。按字面，只关心“删除”这个状态的变化，即初始删除且最终未选中，用户没有勾选，所以不算 added，也不算 removed，因为从未关联过？实际上删除节点表示之前有关联但现在要删除，如果最终变成未选中（普通），表示用户决定不关联也不删除？可能业务上认为这仍然是取消关联。为保险，我们按照用户要求：初始删除且最终未选中不计入任何差异，因为未选中不是删除。但用户可能希望删除节点变为未选中时也算作删除？需求中未明确，根据“不计入相同状态”，只有最终状态等于初始状态才不计入。初始是deleted，最终是unchecked，不同，应该计入？但用户四节点类型中，删除节点的三态包含“未选中”，当从删除变为未选中时，应该算作删除（delClassificationIds）吗？我认为应该算作删除，因为用户取消了关联。同理，从未选中变为删除应该算作新增。但是在状态机中，从删除点一次变成全选（新增），再点变成未选中（删除），再点变成删除（无变化）。所以逻辑上：deleted -> checked 是 added；checked -> unchecked 是 removed；unchecked -> deleted 是 added；deleted -> deleted 无变化。为了简化，我们仅根据当前是否选中（checked）来决定 added，根据初始是否全选或部分来决定 removed。由于我们的 diff 逻辑只关心 checked 集合，对于 deleted 状态，它与 unchecked 在 checked 集合中是一样的（都不在 checked 中）。所以无法区分 deleted 和 unchecked 对 removed 的影响。因此我们只能将初始全选/部分节点的最终未选中（包括 deleted 和 unchecked）都视为 removed；初始删除节点的最终未选中（unchecked）不计入 removed，因为初始删除本身就是未选中。这样符合用户预期：初始删除节点如果用户点击变成未选中（不再是删除样式），业务上可能是彻底不关联，但由于初始未选中，不算新增也不删除。这样更合理。
          // 因此，对于初始删除节点，只有当最终变成 checked 时才 added，其他情况无变化。
        }
      }

      // 4. 处理初始普通未选中节点（不在任何初始集合中）
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }
    var allNodeIds = Object.keys(this.jsTree._model.data).filter(function (id) {
      return id !== "#" && !(_this10.showRootNode && id === "root");
    });
    var _iterator8 = _createForOfIteratorHelper(allNodeIds),
      _step8;
    try {
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        var nodeId = _step8.value;
        if (this._initialFullCheckedSet.has(nodeId) || this._initialPartialSet.has(nodeId) || this._initialDeletedSet.has(nodeId)) {
          continue; // 已处理
        }
        // 普通未选中节点
        var _effectiveState3 = getCurrentEffectiveState(nodeId);
        if (_effectiveState3 === "checked") {
          // 初始未选中 → 全选：需要新增
          added.add(nodeId);
        }
        // 其他状态（未选中、partial、deleted）均不计入，因为初始未选中，partial/deleted 不会出现在普通节点中
      }

      // 生成结果字符串
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }
    var fileIdStr = this._originalFileInfos ? this._originalFileInfos.map(function (f) {
      return f.id;
    }).join(",") : "";
    return {
      fileIds: fileIdStr,
      delFileIds: fileIdStr,
      classificationIds: Array.from(added).join(","),
      delClassificationIds: Array.from(removed).join(",")
    };
  },
  /**
   * 获取当前所有全选（checked）状态的节点信息
   * @returns {Array} 节点信息数组，格式同 selectedNodes 中的每一项
   */
  getCheckedNodes: function getCheckedNodes() {
    var self = this;
    var checkedNodes = [];
    this.$("#treeView .jstree-node.jstree-checked").each(function () {
      var $node = $(this);
      var nodeId = $node.attr("id");
      if (!nodeId) return;
      var node = self.jsTree.get_node(nodeId);
      if (!node || node.data && node.data.loadMore) return;
      var fileInfo = self.fileInforCollection.findWhere({
        fileId: nodeId
      });
      var path = self.jsTree.get_path(node, "/");
      var ancestorIds = self.jsTree.get_path(node, false, true);
      var ancestorFileInfos = [];
      ancestorIds.forEach(function (aid) {
        var info = self.fileInforCollection.findWhere({
          fileId: aid
        });
        if (info) ancestorFileInfos.push(info);
      });
      checkedNodes.push({
        folderId: nodeId,
        path: path,
        node: node,
        fileInfo: fileInfo,
        ancestorIds: ancestorIds,
        ancestorFileInfos: ancestorFileInfos
      });
    });
    return checkedNodes;
  },
  /**
   * 获取当前所有删除（deleted）状态的节点信息
   * @returns {Array} 节点信息数组
   */
  getDeletedNodes: function getDeletedNodes() {
    var self = this;
    var deletedNodes = [];
    this.$("#treeView .jstree-node.jstree-deleted").each(function () {
      var $node = $(this);
      var nodeId = $node.attr("id");
      if (!nodeId) return;
      var node = self.jsTree.get_node(nodeId);
      if (!node || node.data && node.data.loadMore) return;
      var fileInfo = self.fileInforCollection.findWhere({
        fileId: nodeId
      });
      var path = self.jsTree.get_path(node, "/");
      var ancestorIds = self.jsTree.get_path(node, false, true);
      var ancestorFileInfos = [];
      ancestorIds.forEach(function (aid) {
        var info = self.fileInforCollection.findWhere({
          fileId: aid
        });
        if (info) ancestorFileInfos.push(info);
      });
      deletedNodes.push({
        folderId: nodeId,
        path: path,
        node: node,
        fileInfo: fileInfo,
        ancestorIds: ancestorIds,
        ancestorFileInfos: ancestorFileInfos
      });
    });
    return deletedNodes;
  },
  /**
   * 获取当前所有选中和删除的节点（合并）
   * @returns {Object} { checkedNodes, deletedNodes }
   */
  getSelectedAndDeletedNodes: function getSelectedAndDeletedNodes() {
    return {
      checkedNodes: this.getCheckedNodes(),
      deletedNodes: this.getDeletedNodes()
    };
  },
  /**
   * 获取当前所有全选节点的 ID 列表
   * @returns {Array} 节点 ID 数组
   */
  getCheckedNodeIds: function getCheckedNodeIds() {
    var ids = [];
    this.$("#treeView .jstree-node.jstree-checked").each(function () {
      var id = $(this).attr("id");
      if (id) ids.push(id);
    });
    return ids;
  },
  /**
   * 获取当前所有删除节点的 ID 列表
   * @returns {Array} 节点 ID 数组
   */
  getDeletedNodeIds: function getDeletedNodeIds() {
    var ids = [];
    this.$("#treeView .jstree-node.jstree-deleted").each(function () {
      var id = $(this).attr("id");
      if (id) ids.push(id);
    });
    return ids;
  }
}, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_MMViewBase$extend, "_initSearch", function _initSearch() {
  var self = this;
  var $input = this.$('.folder-tree-search-input');
  var $clearBtn = this.$('.search-clear');

  // 输入事件（防抖）
  $input.on('input', function () {
    var keyword = $(this).val().trim();
    self._searchKeyword = keyword;
    if (keyword) {
      $clearBtn.show();
    } else {
      $clearBtn.hide();
    }
    clearTimeout(self._searchTimer);
    self._searchTimer = setTimeout(function () {
      self._performSearch(keyword);
    }, self.searchDelay);
  });

  // 回车搜索（立即执行）
  $input.on('keydown', function (e) {
    if (e.keyCode === 13) {
      self._onSearchKeydown(e); // 直接调用，传递事件对象
    }
  });

  // 清除按钮
  $clearBtn.on('click', function () {
    $input.val('');
    $clearBtn.hide();
    self.clearSearch();
  });

  // 监听 ESC 键清除搜索
  $input.on('keydown', function (e) {
    if (e.keyCode === 27) {
      $input.val('');
      $clearBtn.hide();
      self.clearSearch();
    }
  });
}), "_performSearch", function _performSearch(keyword) {
  // 如果关键词为空，直接清除搜索并恢复
  if (!keyword || keyword.trim() === '') {
    this.clearSearch();
    return;
  }
  // 【新增】如果正在搜索中，忽略新的搜索请求
  if (this._isSearching) {
    return;
  }

  // 【新增】如果关键词与上次搜索相同，不重复搜索
  if (keyword === this._lastSearchKeyword) {
    return;
  }
  // 如果是分类数据源，使用分类搜索接口
  if (this.dataSource === 'classification') {
    this._searchClassification(keyword);
    return;
  }

  // 其他数据源使用前端搜索（jsTree内置）
  this._searchLocal(keyword);
}), "_searchClassification", function _searchClassification(keyword) {
  var self = this;
  // 【新增】设置搜索状态
  this._isSearching = true;
  this._lastSearchKeyword = keyword;
  this.$('#treeView').addClass('searching');
  // 构建请求参数
  var params = {
    keyword: keyword,
    limit: this.searchResultLimit || 50
  };

  // 如果有父级限制（当前选中的节点），可以传递
  if (this.selectedFolderId && this.selectedFolderId !== -1 && this.selectedFolderId !== '#') {
    params.parentId = this.selectedFolderId;
  }

  // 调用后台接口
  _MMEnterpriseController["default"].searchClassification(params, function (response) {
    // 【新增】重置搜索状态
    self._isSearching = false;
    self.$('#treeView').removeClass('searching');
    if (response && response.success) {
      var results = response.data || response.classifications || [];
      self._renderSearchResults(results, keyword);
    } else {
      self._renderSearchResults([], keyword);
    }
  }, function (error) {
    self._isSearching = false;
    self.$('#treeView').removeClass('searching');
    console.error('搜索失败:', error);
    self._renderSearchResults([], keyword);
  });
}), "_searchLocal", function _searchLocal(keyword) {
  var self = this;

  // 如果关键词为空，清除搜索
  if (!keyword || keyword.trim() === '') {
    this.clearSearch();
    return;
  }

  // 清除之前的搜索状态
  this.$('#treeView .jstree-node').removeClass('jstree-search-result jstree-search-match');
  this.$('.jstree-no-result').remove();
  this.$('#treeView').removeClass('has-no-result');

  // 获取所有节点
  var allNodes = this.jsTree.get_json('#', {
    flat: true
  });
  var matchedIds = [];
  var lowerKeyword = keyword.toLowerCase();

  // 遍历所有节点，查找匹配的节点
  allNodes.forEach(function (node) {
    if (node.id === '#') return;
    var nodeText = node.text || '';
    if (nodeText.toLowerCase().indexOf(lowerKeyword) !== -1) {
      matchedIds.push(node.id);
    }
  });
  if (matchedIds.length === 0) {
    // 没有匹配结果，显示空状态
    this._showNoResult(keyword);
    // 使用 jsTree 搜索显示空结果
    this.$('#treeView').jstree('search', keyword);
    return;
  }

  // 使用 jsTree 的搜索功能，配合自定义搜索回调
  this.$('#treeView').jstree('search', keyword);

  // 标记匹配节点（jsTree 搜索后会自动匹配，我们额外添加样式）
  setTimeout(function () {
    matchedIds.forEach(function (id) {
      var $node = self.$('[id="' + id + '"]');
      if ($node.length) {
        $node.addClass('jstree-search-match');
        self._highlightNodeText($node, keyword);
      }
    });

    // 展开匹配节点的父节点
    var nodesToOpen = new Set();
    matchedIds.forEach(function (id) {
      var node = self.jsTree.get_node(id);
      if (node && node.parents) {
        node.parents.forEach(function (parentId) {
          if (parentId !== '#') {
            nodesToOpen.add(parentId);
          }
        });
      }
    });

    // 打开父节点
    nodesToOpen.forEach(function (parentId) {
      self.jsTree.open_node(parentId, function () {}, false);
    });

    // 滚动到第一个匹配节点
    var firstMatched = self.$('.jstree-search-match').first();
    if (firstMatched.length) {
      setTimeout(function () {
        var container = self.$('#treeView');
        var offset = firstMatched.position().top - 50;
        // 滚动到目标，但最小为0（容器顶部）
        container.scrollTop(Math.max(0, offset));
      }, 300);
    }

    // 触发搜索完成事件
    if (self.onSearchComplete) {
      self.onSearchComplete({
        keyword: keyword,
        matchedIds: matchedIds,
        totalMatches: matchedIds.length
      });
    }
  }, 100);
}), "_renderSearchResults", function _renderSearchResults(results, keyword) {
  var self = this;

  // 1. 清除旧搜索状态
  if (this.jsTree) {
    this.jsTree.clear_search();
  }
  this.$('#treeView .jstree-node').removeClass('jstree-search-match jstree-search-highlight jstree-search-dim');
  var self = this;
  this.$('#treeView .jstree-anchor').each(function () {
    var $anchor = $(this);
    var $node = $anchor.closest('.jstree-node');
    if ($node.length) {
      self._highlightNodeText($node, ''); // 彻底清除高亮
    }
  });
  this.$('.jstree-no-result').remove();
  this.$('#treeView').removeClass('has-no-result');

  // 关键词为空时直接清除搜索并返回
  if (!keyword || keyword.trim() === '') {
    this.clearSearch();
    return;
  }

  // 2. 提取匹配节点的 ID 列表（转为字符串）
  var matchedIds = results.map(function (item) {
    return String(item.id || item.classificationId);
  });
  this._searchMatchedIds = matchedIds;

  // 3. 无匹配结果 -> 显示空状态
  if (matchedIds.length === 0) {
    this._showNoResult(keyword);
    // 利用 jsTree 搜索隐藏所有节点
    if (this.jsTree) {
      this.jsTree.search(keyword, {
        search_callback: function search_callback() {
          return false;
        }
      });
    }
    return;
  }

  // 4. 收集所有需要展开的路径（从根到叶子，不含“#”或“0”）
  var allPaths = [];
  results.forEach(function (item) {
    var pathIds = item.pathIds;
    if (!pathIds && item.path) {
      // 如果后端返回的是字符串路径，例如 "/0/12/34"
      pathIds = item.path.split('/').filter(function (p) {
        return p && p !== '0';
      });
    }
    if (pathIds && pathIds.length) {
      // 将所有 ID 转为字符串，确保类型一致
      allPaths.push(pathIds.map(String));
    }
  });

  // 5. 如果没有路径信息（例如只有根节点），直接应用高亮
  if (allPaths.length === 0) {
    this._applySearchHighlights(matchedIds, keyword);
    return;
  }

  // 6. 按层级顺序展开所有路径，完成后应用高亮
  this._expandPaths(allPaths, function () {
    self._applySearchHighlights(matchedIds, keyword);
  });

  // 7. 触发搜索完成回调
  if (this.onSearchComplete) {
    this.onSearchComplete({
      keyword: keyword,
      results: results,
      matchedIds: matchedIds
    });
  }
}), "_applySearchHighlights", function _applySearchHighlights(matchedIds, keyword) {
  var self = this;

  // 清除旧样式
  this.$('#treeView .jstree-node').removeClass('jstree-search-dim jstree-search-match jstree-search');

  // 遍历所有节点，应用样式并刷新图标
  this.$('#treeView .jstree-node').each(function () {
    var $node = $(this);
    var nodeId = $node.attr('id');
    if (!nodeId) return;
    var isMatch = matchedIds.indexOf(nodeId) !== -1;

    // 样式处理
    if (isMatch) {
      $node.addClass('jstree-search-match');
      self._highlightNodeText($node, keyword);
    } else {
      $node.addClass('jstree-search-dim');
    }

    // ★ 关键：刷新所有节点的图标（匹配和非匹配都需要）
    if (self.useCustomIcon) {
      var _node$data;
      var node = self.jsTree.get_node(nodeId);
      if (node && !((_node$data = node.data) !== null && _node$data !== void 0 && _node$data.loadMore)) {
        var file = self.fileInforCollection.findWhere({
          fileId: nodeId
        });
        if (file && file.fetchIconUrl) {
          file.fetchIconUrl(node, self.jsTree);
        }
      }
    }
  });

  // 滚动到第一个匹配节点
  var firstMatched = this.$('.jstree-search-match').first();
  if (firstMatched.length) {
    setTimeout(function () {
      requestAnimationFrame(function () {
        var container = self.$('#treeView');
        var containerOffset = container.offset().top;
        var targetOffset = firstMatched.offset().top;
        var currentScroll = container.scrollTop();
        var targetRelativeTop = targetOffset - containerOffset + currentScroll;
        container.scrollTop(Math.max(0, targetRelativeTop - 50));
      });
    }, 100); // 延迟缩短，配合 requestAnimationFrame
  }
  // 重新附加操作按钮
  if (this.showNodeActions) {
    self._attachNodeActions();
    setTimeout(function () {
      self._attachNodeActions();
    }, 100);
  }
  this._currentMatchIndex = 0;
}), "_expandSinglePath", function _expandSinglePath(pathIds, callback) {
  var _this11 = this;
  if (!pathIds || pathIds.length === 0) {
    callback && callback();
    return;
  }
  // 复制一份，避免修改原数组
  var remaining = pathIds.slice();
  var openNext = function openNext(index) {
    if (index >= remaining.length) {
      callback && callback();
      return;
    }
    var nodeId = remaining[index];
    var node = _this11.jsTree.get_node(nodeId);
    if (!node) {
      // 节点不存在，跳过（可能已被删除）
      openNext(index + 1);
      return;
    }
    // 最后一个节点无需打开（仅需确保其父节点已开）
    if (index === remaining.length - 1) {
      openNext(index + 1);
      return;
    }
    // 如果节点已打开，直接下一层
    if (node.state.opened) {
      openNext(index + 1);
      return;
    }
    // 打开节点，完成后继续下一层
    _this11.jsTree.open_node(nodeId, function () {
      openNext(index + 1);
    }, false);
  };
  openNext(0);
}), "_expandPaths", function _expandPaths(pathMap, callback) {
  var self = this;
  var allPaths = Object.values(pathMap);
  if (allPaths.length === 0) {
    callback && callback();
    return;
  }
  // 去重：将路径转为字符串去重
  var uniquePathStrs = new Set(allPaths.map(function (p) {
    return p.join('/');
  }));
  var uniquePaths = Array.from(uniquePathStrs).map(function (s) {
    return s.split('/').filter(Boolean);
  });
  var pending = uniquePaths.length;
  var hasError = false;
  var onPathDone = function onPathDone() {
    if (hasError) return;
    pending--;
    if (pending === 0) callback && callback();
  };
  uniquePaths.forEach(function (pathIds) {
    self._expandSinglePath(pathIds, function () {
      onPathDone();
    });
  });
}), "_highlightNodeText", function _highlightNodeText($node, keyword) {
  var $anchor = $node.find('>.jstree-anchor');
  if (!$anchor.length) return;

  // 获取当前的纯文本（忽略任何现有的高亮span）
  var plainText = $anchor.text();

  // 提取需要保留的非文本元素：图标和操作按钮
  var $icon = $anchor.find('.jstree-icon').first(); // jsTree图标
  var $actions = $anchor.find('.node-actions'); // 操作按钮

  // 清空锚点
  $anchor.empty();

  // 重新添加图标
  if ($icon.length) {
    $anchor.append($icon.clone());
  }

  // 如果没有关键词，直接添加纯文本，然后添加操作按钮
  if (!keyword || keyword.trim() === '') {
    $anchor.append(document.createTextNode(plainText));
    if ($actions.length) {
      $anchor.append($actions.clone());
    }
    return;
  }

  // 高亮分割文本
  var escapedKeyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  var regex = new RegExp('(' + escapedKeyword + ')', 'gi');
  var parts = plainText.split(regex);
  var fragment = document.createDocumentFragment();
  for (var i = 0; i < parts.length; i++) {
    var part = parts[i];
    if (part) {
      var span = document.createElement('span');
      if (part.toLowerCase() === keyword.toLowerCase()) {
        span.className = 'jstree-search-highlight';
      }
      span.textContent = part;
      fragment.appendChild(span);
    }
  }
  $anchor.append(fragment);

  // 最后添加操作按钮（放在文本后面）
  if ($actions.length) {
    $anchor.append($actions.clone());
  }
}), "_showNoResult", function _showNoResult(keyword) {
  // 移除之前的提示
  this.$('.jstree-no-result').remove();
  var $tree = this.$('#treeView');
  var nameStr = "<span class=\"keyword\">".concat(this._escapeHtml(keyword), "</span>");
  var $noResult = $("<div class=\"jstree-no-result\">\n        <div class=\"empty-state\">\n          <i class=\"icon icon-search-empty\"></i>\n          <p class=\"empty-text\">".concat(BabelStr.str(40169, {
    name: nameStr
  }), "</p>\n          <span class=\"hint-text\">").concat(BabelStr.str(40168), "</span>\n        </div>\n      </div>"));
  $tree.append($noResult);
  $tree.addClass('has-no-result');

  // // 【关键修改】隐藏所有节点（自定义回调返回 false）
  // if (this.jsTree) {
  //   this.jsTree.search(keyword, {
  //     search_callback: function() { return false; }
  //   });
  // }
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_MMViewBase$extend, "_escapeHtml", function _escapeHtml(str) {
  if (!str) return '';
  var div = document.createElement('div');
  div.textContent = str;
  return div.innerHTML;
}), "_scrollToNextMatch", function _scrollToNextMatch() {
  var $matches = this.$('.jstree-search-match');
  if (!$matches.length) return;

  // 循环索引
  if (this._currentMatchIndex === undefined || this._currentMatchIndex < 0) {
    this._currentMatchIndex = 0;
  } else {
    this._currentMatchIndex = (this._currentMatchIndex + 1) % $matches.length;
  }
  var $target = $matches.eq(this._currentMatchIndex);
  if (!$target.length) return;
  var container = this.$('#treeView');
  // 计算目标元素相对容器内容区顶部的偏移
  var containerOffset = container.offset().top;
  var targetOffset = $target.offset().top;
  var currentScroll = container.scrollTop();
  // 目标元素在容器内的相对位置（相对于内容区顶部）
  var targetRelativeTop = targetOffset - containerOffset + currentScroll;

  // 滚动到目标位置，留出 50px 边距
  container.scrollTop(targetRelativeTop - 50);
}), "clearSearch", function clearSearch() {
  this._currentMatchIndex = -1;
  this._searchKeyword = '';
  this._searchResults = [];
  this._searchMatchedIds = [];
  this._lastSearchKeyword = '';
  this._isSearching = false;

  // 清除 jsTree 搜索状态
  if (this.jsTree) {
    try {
      this.jsTree.clear_search();
    } catch (e) {
      console.warn('clear_search error:', e);
    }
  }

  // 清除高亮和样式
  this.$('#treeView .jstree-node').removeClass('jstree-search-result jstree-search-match jstree-search-highlight');
  this.$('#treeView .jstree-search-highlight').removeClass('jstree-search-highlight');
  this.$('#treeView .jstree-search-focus').removeClass('jstree-search-focus');
  this.$('.jstree-no-result').remove();
  this.$('#treeView').removeClass('has-no-result');

  // 替换原有的还原原始文本的循环
  var self = this;
  this.$('#treeView .jstree-anchor').each(function () {
    var $anchor = $(this);
    var $node = $anchor.closest('.jstree-node');
    if ($node.length) {
      self._highlightNodeText($node, ''); // 传入空关键词，仅还原纯文本并保留图标
    }
  });

  // 确保所有节点可见（jsTree clear_search 会恢复，但为了保险）
  this.$('#treeView .jstree-node').show();

  // // 重新附加节点操作按钮
  // if (this.showNodeActions) {
  //   setTimeout(function() {
  //     this._attachNodeActions();
  //   }.bind(this), 100);
  // }

  // 触发清除事件
  if (this.onSearchCleared) {
    this.onSearchCleared();
  }
}), "_onSearchInput", function _onSearchInput(e) {
  var keyword = $(e.target).val().trim();
  this._searchKeyword = keyword;
  var $clearBtn = this.$('.search-clear');
  if (keyword) {
    $clearBtn.show();
  } else {
    $clearBtn.hide();
  }

  // 如果关键词为空，立即清除搜索，不等待防抖
  if (keyword === '') {
    clearTimeout(this._searchTimer);
    this.clearSearch();
    return;
  }
  clearTimeout(this._searchTimer);
  this._searchTimer = setTimeout(function () {
    this._performSearch(keyword);
  }.bind(this), this.searchDelay);
}), "_onSearchKeydown", function _onSearchKeydown(e) {
  if (e.keyCode === 13) {
    e.preventDefault();
    var keyword = $(e.target).val().trim();
    this._searchKeyword = keyword;
    clearTimeout(this._searchTimer);
    if (keyword === '') {
      this.clearSearch();
      return;
    }

    // ★ 如果关键词与上次相同，且存在匹配节点，则滚动到下一个
    if (keyword === this._lastSearchKeyword && this._searchMatchedIds && this._searchMatchedIds.length > 0) {
      this._scrollToNextMatch();
      return;
    }

    // 否则执行新搜索
    this._performSearch(keyword);
  }
}), "_onSearchClear", function _onSearchClear() {
  this.$('.folder-tree-search-input').val('');
  this.$('.search-clear').hide();
  this.clearSearch();
}), "remove", function remove() {
  if (this._searchTimer) {
    clearTimeout(this._searchTimer);
    this._searchTimer = null;
  }

  // 移除搜索相关事件
  this.$('.folder-tree-search-input').off('input keydown');
  this.$('.search-clear').off('click');
  this.$("#treeView").off("load_node.jstree"); // 新增

  if (this.jsTree) this.jsTree.destroy();
  $(document).off("click.mdfoldertree");
  _MMViewBase["default"].prototype.remove.call(this);
})));
var _default = exports["default"] = MDFolderTreeView;

},{"1098":1098,"1104":1104,"1180":1180,"1184":1184,"1192":1192,"1412":1412,"1415":1415,"1417":1417,"1418":1418,"1419":1419,"1420":1420,"1421":1421,"1422":1422,"1423":1423,"1424":1424,"1426":1426,"1429":1429,"1437":1437,"1438":1438,"1439":1439,"1443":1443,"1454":1454,"1461":1461,"1463":1463,"1464":1464,"1466":1466,"1476":1476,"1477":1477,"1478":1478,"1480":1480,"1487":1487,"1492":1492,"1493":1493,"1495":1495,"1498":1498,"1500":1500,"1502":1502,"1503":1503,"1537":1537,"1538":1538,"1541":1541,"22":22,"296":296,"297":297,"298":298,"32":32,"486":486,"531":531,"540":540}],531:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1438);
require(1498);
var _MDMessageView = _interopRequireDefault(require(55));
var _MDWindowView = _interopRequireDefault(require(93));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDClassificationSelectWinView = _interopRequireDefault(require(540));
var MDClassificationEditWinView = _MDWindowView["default"].extend({
  contentTmpl: "\n    <div class=\"form-item flex-align middle\">\n      <div class=\"left-title no-shrink\"><%=BabelStr.str(40156)%></div>\n      <input type=\"\" class=\"form-control name-input\" placeholder=\"<%=BabelStr.str(40158)%>\"/>\n    </div>\n    <div class=\"form-item flex-align middle\">\n      <div class=\"left-title no-shrink\"><%=BabelStr.str(40157)%></div>\n      <div class=\"path fullfill\"></div>\n      <div class=\"edit-path text-button done\"><%=BabelStr.str(3070)%></div>\n    </div>\n  ",
  className: function className() {
    return _MDWindowView["default"].prototype.className.call(this) + ' m-classification-edit-win';
  },
  events: function events() {
    var superE = _MDWindowView["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click .edit-path': this._changePath
    });
  },
  initProps: function initProps() {
    return _.extend(_MDWindowView["default"].prototype.initProps.call(this), {
      title: BabelStr.str(40151)
    });
  },
  initialize: function initialize(opt) {
    var buttons = [{
      label: BabelStr.str(155),
      type: 'default',
      onClick: function () {
        this.close();
      }.bind(this)
    }, {
      label: BabelStr.str(154),
      type: 'done',
      className: 'save',
      autoClose: false,
      onClick: function ($e) {
        if ($($e.target).hasClass('disabled')) return;
        $($e.target).addClass('disabled');
        this.updateClassification(function () {
          $($e.target).removeClass('disabled');
        });
      }.bind(this)
    }];
    _MDWindowView["default"].prototype.initialize.call(this, _.extend({}, opt, {
      buttons: buttons
      // width: 800
    }));
    this.$(".name-input").val(this.originName);
    this.$(".path").html(this.originPath);
  },
  render: function render(data) {
    data = {
      title: this.title || BabelStr.str(7200),
      helpText: this.helpText || BabelStr.str(7201)
    };
    _MDWindowView["default"].prototype.render.call(this, data);
  },
  updateClassification: function updateClassification(cb) {
    var _this = this;
    var newName = this.$(".name-input").val().trim();
    if (newName == this.originName && this.newParentId == this.originParentId) {
      cb();
      this.close();
      return;
    }
    var param = {
      classificationId: this.classificationId,
      name: newName
    };
    // if(newName != this.originName) {

    // }
    if (this.newParentId != this.originParentId) {
      param.parentId = this.newParentId == "root" ? 0 : this.newParentId;
    }
    _MMEnterpriseController["default"].updateClassification(param, function () {
      _this.editCallback({
        newParentId: param.parentId || _this.originParentId,
        originParentId: _this.originParentId
      });
      cb();
      _this.close();
    }, function (err) {
      _MDMessageView["default"].error(err.msg || BabelStr.str(309), _this.$body);
      cb();
    });
  },
  _changePath: function _changePath() {
    var _this2 = this;
    var win = new _MDClassificationSelectWinView["default"]({
      multiSelect: false,
      showCreateFolderBtn: false,
      selectedIds: [this.classificationId],
      initialPath: this.pathArr,
      rootNodeSelectable: true,
      showRootNode: true,
      rootNodeText: BabelStr.str(40142),
      confirmCallback: function confirmCallback() {
        var node = win.getSelectedNode();
        var path = win.getPathByNode(node);
        // path = BabelStr.str(40142) + "/" + path
        console.log(node, path);
        _this2.newParentId = node.id;
        _this2.$(".path").html(path);
      }
    });
    win.show();
  }
});
var _default = exports["default"] = MDClassificationEditWinView;

},{"1098":1098,"1184":1184,"1438":1438,"1454":1454,"1498":1498,"540":540,"55":55,"93":93}],540:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1438);
require(1426);
require(1429);
require(1439);
require(1421);
require(1541);
require(1436);
require(1546);
var _MDFolderTreeView = _interopRequireDefault(require(598));
var _MDMessageView = _interopRequireDefault(require(55));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MMFileInfo = _interopRequireDefault(require(297));
var _MDWindowView = _interopRequireDefault(require(93));
var _MDCreateFolderWindowView = _interopRequireDefault(require(486));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
// MDClassificationSelectWinView.js

var MDClassificationSelectWinView = _MDWindowView["default"].extend({
  contentTmpl: "\n    <div class=\"title\"><%=BabelStr.str(40159)%></div>\n    <div class=\"inv-manager-block mgt-10 f-hide flex-align mgb-20 gap-10\">\n      <div class=\"item-title no-shrink\"><%=BabelStr.str(21215)%></div>\n      <div class=\"inv-manager-list gap-10 flex-align with-wrap\"></div>\n    </div>\n    <div class=\"wrapper folder-tree-placeholder\"></div>\n  ",
  className: function className() {
    return _MDWindowView["default"].prototype.className.call(this) + ' m-classification-select-win';
  },
  initProps: function initProps() {
    return _.extend(_MDWindowView["default"].prototype.initProps.call(this), {
      title: BabelStr.str(40159),
      helpText: BabelStr.str(7201),
      selectedIds: [],
      disabledIds: [],
      onlySelectLeaf: false,
      confirmCallback: null,
      cancelCallback: null,
      folderTree: null,
      currentSelectedNodes: [],
      multiSelect: true,
      showCreateFolderBtn: true,
      rootNodeSelectable: false,
      initialPath: [],
      showRootNode: false,
      rootNodeText: "",
      showNodeActions: false
    });
  },
  initialize: function initialize(opt) {
    _.extend(this, _.pick(opt, 'title', 'helpText', 'selectedIds', 'disabledIds', 'onlySelectLeaf', 'confirmCallback', 'cancelCallback'));
    var okStr = app.currentUser.canManageArchive() ? BabelStr.str(154) : BabelStr.str(12544);
    var buttons = [{
      label: BabelStr.str(155),
      type: 'default',
      onClick: function () {
        if (_.isFunction(this.cancelCallback)) this.cancelCallback();
        this.close();
      }.bind(this)
    }, {
      label: okStr,
      type: 'done',
      className: 'save',
      autoClose: false,
      onClick: function ($e) {
        if ($($e.target).hasClass('disabled')) return;
        console.log(this.currentSelectedNodes);
        if (_.isFunction(this.confirmCallback)) {
          var selectedIds = this.currentSelectedNodes.map(function (node) {
            return node.id;
          });
          if (!selectedIds.length) {
            _MDMessageView["default"].error(BabelStr.str(40163), this.$body);
            return;
          }
          $($e.target).addClass('disabled');
          this.confirmCallback(selectedIds);
        }
        this.close();
      }.bind(this)
    }];
    _MDWindowView["default"].prototype.initialize.call(this, _.extend({}, opt, {
      buttons: buttons,
      width: 800
    }));
    this._fetchArchiveManagers();
  },
  _fetchArchiveManagers: function _fetchArchiveManagers() {
    var self = this;
    _MMEnterpriseController["default"].getEntArchiveManagers(function (managerInfos) {
      self.renderEditManager(managerInfos);
    });
  },
  renderEditManager: function renderEditManager(managerInfos) {
    if (!managerInfos || !managerInfos.length) {
      return;
    }
    managerInfos = managerInfos.slice(0, 5);
    var tmpl = '';
    _.each(managerInfos, function (user) {
      tmpl += '<div class="manager-item flex-align middle">' + '<div class="manager-icon icon no-shrink"></div>' + '<span class="name middle-ellipsis">' + (user.name || user.phone) + '</span>' + '</div>';
    });
    this.$(".inv-manager-list").html(tmpl);
    this.$(".inv-manager-block").removeClass("f-hide");
  },
  render: function render(data) {
    data = {
      title: this.title || BabelStr.str(7200),
      helpText: this.helpText || BabelStr.str(7201)
    };
    _MDWindowView["default"].prototype.render.call(this, data);
  },
  viewDidRendered: function viewDidRendered() {
    this._renderTree();
  },
  _renderTree: function _renderTree() {
    var self = this;
    var nodeFilter = function nodeFilter(fileInfo) {
      return true;
    };
    var nodeDisabled = function nodeDisabled(fileInfo) {
      var id = fileInfo.getFileId();
      if (self.disabledIds && self.disabledIds.indexOf(id) !== -1) return true;
      if (self.onlySelectLeaf && fileInfo.get('hasChild') === true) return true;
      return false;
    };
    var treeOptions = {
      dataSource: 'classification',
      // 关键：使用分类数据源
      multiSelect: this.multiSelect,
      initialPath: this.initialPath,
      showCreateFolderBtn: this.showCreateFolderBtn,
      rootNodeSelectable: this.rootNodeSelectable,
      useCustomIcon: false,
      showRootNode: this.showRootNode,
      rootNodeText: this.rootNodeText,
      showNodeActions: this.showNodeActions,
      nodeFilter: nodeFilter,
      nodeDisabled: nodeDisabled,
      onSelectionChange: function onSelectionChange(data) {
        self._onSelectionChange(data.selectedNodes);
      },
      onCreateFolder: function onCreateFolder(parentId) {
        self.onCreateFolder(parentId);
      },
      openFolder: false,
      testUpload: false,
      pageSize: 100
    };
    this.folderTree = new _MDFolderTreeView["default"](treeOptions);
    this.addSubView(this.folderTree, this.$('.folder-tree-placeholder'), true);
    if (this.selectedIds && this.selectedIds.length) {
      setTimeout(function () {
        if (this.multiSelect) {
          if (self.folderTree && self.folderTree.setSelectedNodes) {
            self.folderTree.setSelectedNodes(self.selectedIds);
          }
        } else {
          if (self.folderTree && self.folderTree.selectNode) {
            self.folderTree.selectNode(self.selectedIds[0]);
          }
        }
      }, 200);
    }
  },
  getPathByNode: function getPathByNode(node) {
    return this.folderTree.getPathByNode(node);
  },
  getSelectedNode: function getSelectedNode() {
    return this.folderTree.getSelectedNode();
  },
  openPath: function openPath(pathArr) {
    this.folderTree.openPath(pathArr);
  },
  _onSelectionChange: function _onSelectionChange(selectedNodes) {
    this.currentSelectedNodes = selectedNodes.map(function (nodeInfo) {
      var fileInfo = nodeInfo.fileInfo;
      return {
        id: nodeInfo.folderId,
        name: fileInfo ? fileInfo.getFileName() : nodeInfo.node.text,
        path: nodeInfo.path,
        fileInfo: fileInfo,
        rawData: fileInfo ? fileInfo.toJSON() : null
      };
    });
    var $doneBtn = this.getActionButtons().eq(1);
    if ($doneBtn.length) {
      $doneBtn.prop('disabled', this.currentSelectedNodes.length === 0);
    }
  },
  onCreateFolder: function onCreateFolder(parentId) {
    var self = this;
    // 修复1：parentFolderId → parentId
    var parentFolder = this.folderTree ? this.folderTree.getFileInfoById(parentId) : null;
    var win = new _MDCreateFolderWindowView["default"]({
      parentFolder: parentFolder,
      onCreateCallback: function onCreateCallback(newName) {
        self._createClassification(parentId, newName);
        win.close();
      }
    });
    win.show();
  },
  // 修复2：参数名 parentFile → parentId，语义一致
  _createClassification: function _createClassification(parentId, newName) {
    var self = this;
    var realParentId = parentId === '#' ? 0 : parentId;
    _MMEnterpriseController["default"].createClassification({
      parentId: realParentId,
      name: newName // 使用新变量
    }, function (response) {
      if (response && response.success && response.classification) {
        var newData = response.classification;
        var newFileInfo = new _MMFileInfo["default"]({
          fileId: String(newData.id),
          fileName: newData.name,
          parentId: newData.parent,
          isFolder: true,
          rawClassification: newData
        });
        if (self.folderTree && self.folderTree.onFolderCreated) {
          if (realParentId == 0) {
            realParentId = "#";
          }
          self.folderTree.onFolderCreated(realParentId, newFileInfo);
        } else {
          self.folderTree && self.folderTree.refreshNode(realParentId);
        }
        _MDMessageView["default"].success(BabelStr.str(308), self.$body);
      } else {
        _MDMessageView["default"].error(response.message || BabelStr.str(4780), self.$body);
      }
    }, function (error) {
      _MDMessageView["default"].error(BabelStr.str(4780), self.$body);
    });
  },
  getSelectedClassifications: function getSelectedClassifications() {
    return this.currentSelectedNodes.slice();
  },
  clearSelection: function clearSelection() {
    if (this.folderTree && this.folderTree.setSelectedNodes) {
      this.folderTree.setSelectedNodes([]);
    }
    this.currentSelectedNodes = [];
  }
});
var _default = exports["default"] = MDClassificationSelectWinView;

},{"1098":1098,"1104":1104,"1184":1184,"1421":1421,"1426":1426,"1429":1429,"1436":1436,"1438":1438,"1439":1439,"1454":1454,"1541":1541,"1546":1546,"297":297,"486":486,"55":55,"598":598,"93":93}],486:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1498);
var _MDWindowView = _interopRequireDefault(require(93));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _keycode = _interopRequireDefault(require(104));
var _MDFileOperationManager = _interopRequireDefault(require(326));
var _MDChannelType = _interopRequireDefault(require(717));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDMessageView = _interopRequireDefault(require(55));
/**
 *  Window for create new folder
 *  javascript/moladisk/views/file/MDCreateFolderWindowView.js
 *  Create by manjun.han
 *  2015.9.8
 */

var MDCreateFolderWindowView = _MDWindowView["default"].extend({
  contentTmpl: "<div class=\"wrapper\">\n    <div class=\"mgb-10\"><%=caption%></div>\n      <form >\n        <div class=\"__input_parent\">\n          <input name=\"folderName\" type=\"text\"  testFileName id=\"nameInput\" class=\"form-control testFileNameEnd testFileName notempty\" maxlength=\"100\"/>\n        </div>\n      </form>\n    </div>",
  className: function className() {
    var superCls = _MDWindowView["default"].prototype.className.call(this);
    return superCls + " m-createFolderWin";
  },
  events: function events() {
    var superE = _MDWindowView["default"].prototype.events.call(this);
    return _.extend(superE, {
      'keydown #nameInput': this._submitOnEnter
    });
  },
  initProps: function initProps() {
    var props = _MDWindowView["default"].prototype.initProps.call(this);
    return _.extend(props, {
      parentFolder: app.pathRouter.getCurrentFolder()
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    opt.title = BabelStr.str(163); // "新建文件夹";
    if (app.pathRouter.curChannel == _MDChannelType["default"].archive) {
      opt.title = BabelStr.str(776); // 新建档案夹
    } else if (opt.createDep) {
      opt.title = BabelStr.str(3043); // 添加子部门
    }
    opt.buttons = [{
      label: BabelStr.str(155),
      // '取消',
      type: 'default'
    }, {
      label: BabelStr.str(154),
      //  '确认',
      type: 'done',
      autoClose: false,
      onClick: function onClick($e) {
        self._submit();
      }
    }];
    var cpStr = BabelStr.str(584); // 请填写名称

    opt.data = _.extend({
      'caption': cpStr
    }, opt.data);
    opt.width = 460;
    _MDWindowView["default"].prototype.initialize.call(this, opt);
    var $buttons = this.getActionButtons();
    this.$doneBtn = $buttons.eq(1);
  },
  _submit: function _submit() {
    var self = this;
    var newName = $.trim(self.$("#nameInput").val());
    var validator = this.$('form').validate();
    if (validator.form()) {
      if (this.onCreateCallback) {
        this.onCreateCallback(newName);
      } else {
        self._postCreateFolder(newName);
      }

      // self.close();
    }
  },
  _postCreateFolder: function _postCreateFolder(text) {
    var self = this;
    if (this.creating) {
      return;
    }
    this.creating = true;
    this.$doneBtn.prop('disabled', true);
    if (app.pathRouter.curChannel == _MDChannelType["default"].archive) {
      // 创建归档文件夹
      _MDFileOperationManager["default"].createArchiveFolder(text, this.parentFolder, function (sign) {
        if (!sign.err) {
          self.close();
        } else {
          self.creating = false;
          self.$doneBtn.prop('disabled', false);
          _MDMessageView["default"].error(sign.msg, self.$body);
        }
      });
    } else if (this.createDep) {
      // 创建子部门

      _MDFileOperationManager["default"].createDeppartment(text, this.parentFolder, function (sign) {
        if (!sign.err) {
          self.close();
        } else {
          self.creating = false;
          self.$doneBtn.prop('disabled', false);
          _MDMessageView["default"].error(sign.msg, self.$body);
        }
      });
    } else {
      // 创建文件夹
      _MDFileOperationManager["default"].createFolder(text, this.parentFolder, function (sign) {
        if (!sign.err) {
          self.close();
          _.isFunction(self.success) && self.success(sign);
        } else {
          self.creating = false;
          self.$doneBtn.prop('disabled', false);
          _MDMessageView["default"].error(sign.msg, self.$body);
        }
      });
    }
  },
  viewDidRendered: function viewDidRendered() {
    _MDWindowView["default"].prototype.viewDidRendered.call(this);
    var emtpyStr = BabelStr.str(584); // 文件夹名不能为空
    if (app.pathRouter.curChannel == _MDChannelType["default"].archive) {
      emtpyStr = BabelStr.str(777); // 档案夹名不能为空
    }
    var self = this;
    setBabelTimeout(function () {
      self.$("#nameInput").focus();
    }, 100);
    this.$('form').validate({
      rules: {
        'folderName': {
          'required': true,
          'maxlength': 100
        }
      },
      messages: {
        'folderName': {
          'required': emtpyStr,
          // '文件夹名不能为空',
          'notempty': emtpyStr,
          //'文件夹名不能为空',
          'maxlength': BabelStr.str(586) // '文件夹名称长度不能超过100个字符'
        }
      }
    });
  },
  _submitOnEnter: function _submitOnEnter($e) {
    var disabled = this.$doneBtn.prop('disabled');
    if (disabled) {
      return;
    }
    if (_keycode["default"].isEnterKey($e.keyCode)) {
      this._submit();
      return false;
    }
  }
});
var _default = exports["default"] = MDCreateFolderWindowView;

},{"104":104,"1098":1098,"1104":1104,"1184":1184,"1454":1454,"1498":1498,"326":326,"55":55,"717":717,"72":72,"93":93}],326:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1418);
require(1463);
require(1537);
require(1451);
require(1426);
require(1417);
require(1437);
require(1416);
require(1432);
var _MDAlertView = _interopRequireDefault(require(32));
var _MDTagDataController = _interopRequireDefault(require(1093));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MMBasicData = _interopRequireDefault(require(811));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDTeamDataController = _interopRequireDefault(require(1094));
var _MDEvents = _interopRequireDefault(require(325));
var _Dispatcher = _interopRequireDefault(require(18));
var _ErrorCode = _interopRequireDefault(require(1087));
var _MDMoveProgressWinView = _interopRequireDefault(require(510));
var _MDSpinnerloaderLayerView = _interopRequireDefault(require(75));
var _MDLoadMaskView = _interopRequireDefault(require(49));
// MDFileOperationManager.js
// javascript/moladisk/common/MDFileOperationManager.js
// jiang
// 2017-1-15

/**
 * @callback netCallback

 * @param {function} success - 成功回调
 * @param {function} fail - 失败回调
 *
 */

_Dispatcher["default"].on(_MDEvents["default"].FileOperationUndo, function () {
  MDFileOperationManager.undo();
});
var MDFileOperationManager = {
  operation: null,
  deleteFiles: function deleteFiles(filesDeleting) {
    var self = this;
    if (filesDeleting.length == 1 && filesDeleting[0].isTeamFolder()) {
      _MDAlertView["default"].showRemoveTeamSelection({
        teamInfo: filesDeleting[0],
        onRemove: function onRemove() {
          self.operation = new MDDelFileOperation(filesDeleting);
          self.operation.excute();
        }
      });
    } else {
      var isAllShare = true;
      var hasTmplStore = false;
      filesDeleting.forEach(function (f) {
        if (!f.isMyJoinedShare()) {
          isAllShare = false;
        }
        if (f.isTemplateStore()) {
          hasTmplStore = true;
        }
      });
      var save = BabelStr.str(32);
      var promot = "<p class=\"title\">".concat(BabelStr.str(328), "?</p>");
      if (filesDeleting.length == 1 && filesDeleting[0].isDepartmentFolder()) {
        var param = {
          department: "<span class=\" bold black\">".concat(filesDeleting[0].getFileName(), "</span>")
        };
        promot = "".concat(BabelStr.str(1050, param));
      } else if (filesDeleting.length == 1 && filesDeleting[0].canLeaveShare() || isAllShare) {
        promot = BabelStr.str(5044);
        save = BabelStr.str(154);
      } else if (filesDeleting.length == 1 && filesDeleting[0].isArchived()) {
        promot = "<p class=\"title\">".concat(BabelStr.str(7440), "</p>");
      } else if (hasTmplStore) {
        promot = "<p class=\"title\">".concat(BabelStr.str(21516), "</p>");
      }
      var alert = new _MDAlertView["default"]();
      alert.show({
        title: BabelStr.str(170),
        message: promot,
        className: "m-delAlertWin",
        buttons: [{
          label: save,
          type: "danger",
          onClick: function onClick() {
            self.operation = new MDDelFileOperation(filesDeleting);
            self.operation.excute();
          }
        }, {
          label: BabelStr.str(155)
        }]
      });
    }
  },
  createFolder: function createFolder(text, parentFileInfo, callback) {
    this.operation = new MDNewFolderOperation(text, parentFileInfo, {
      isArchive: false
    });
    this.operation.excute(callback);
  },
  createArchiveFolder: function createArchiveFolder(text, parentFileInfo, callback) {
    this.operation = new MDNewFolderOperation(text, parentFileInfo, {
      isArchive: true
    });
    this.operation.excute(callback);
  },
  createDeppartment: function createDeppartment(text, parentFileInfo, callback) {
    this.operation = new MDNewFolderOperation(text, parentFileInfo, {
      createDep: true
    });
    this.operation.excute(callback);
  },
  createMsBox: function createMsBox(boxInfo, parentFileInfo, callback) {
    MMEnterpriseController.createMsBox(boxInfo, function (folderInfo) {
      if (parentFileInfo.getFileId() == app.currentFolder.getFileId()) {
        var fileInforCollection = MDFileOperationManager.getDispFileInfoCollection();

        // if (app.pathRouter.isInMsBox_Recieve()) {
        fileInforCollection.addFileBlowStickonTop(folderInfo);
        // }

        _MDSnackbarView["default"].show(BabelStr.str(3586));
        if (callback) {
          callback(true);
        }
      }
      _Dispatcher["default"].trigger(_MDEvents["default"].FolderCreated, folderInfo);
    }, function (code, msg) {
      if (code == 12) {
        _MDSnackbarView["default"].show(BabelStr.str(153));
      } else if (code == 20001) {
        _MDSnackbarView["default"].show(BabelStr.str(7506));
      } else {
        if (msg) {
          _MDSnackbarView["default"].show(msg);
        } else {
          _MDSnackbarView["default"].show(BabelStr.str(3535));
        }
      }
      callback(false);
    });
  },
  moveFileIntoFolder: function moveFileIntoFolder(ids, targetFolderId, sourceFolderId, mixEnterprises, callback) {
    if (!ids.length) {
      if (callback) {
        callback();
      }
      return;
    }
    this.operation = new MDMoveFilesOperation(ids, targetFolderId, sourceFolderId, mixEnterprises);
    this.operation.excute(callback);
  },
  copyFileIntoFolder: function copyFileIntoFolder(fileInfors, targetFolderId, callback, params) {
    this.operation = new MDCopyFilesOperation(fileInfors, targetFolderId, callback, params);
    this.operation.excute(callback);
  },
  rename: function rename(fileInfor, newName) {
    this.operation = new MDRenameFileOperation(fileInfor, newName);
    this.operation.excute();
  },
  undo: function undo() {
    if (this.operation) {
      this.operation.undo();
    }
    this.operation = null;
  },
  clear: function clear() {
    this.operation = null;
  },
  delTagForFile: function delTagForFile(fileInfo, tagModel, netCb) {
    var self = this;
    var tagId = tagModel.getId();
    var tagStr = tagModel.getText();
    var fileName = fileInfo.getFileName();
    self.operation = new MDDelTagOperation(fileInfo, tagId, netCb);
    self.operation.excute();
  },
  getDispFileInfoCollection: function getDispFileInfoCollection() {
    if (window.isSharePage) {
      return viewManager.get("sfileListView").getDataCollection();
    }
    if (window.isMsboxUploadPage) {
      return viewManager.get("msAnonyUploadListView").getDataCollection();
    }
    if (app.canDispInNormalBrowser()) {
      return viewManager.get("curFileTableView").getDataCollection();
    } else {
      return viewManager.get("homeListView").getDataCollection();
    }
  },
  requestFolder: function requestFolder(fileInfo) {
    if (app.canDispInNormalBrowser()) {
      return viewManager.get("curFileTableView") && viewManager.get("curFileTableView").refreshCurFolder && viewManager.get("curFileTableView").refreshCurFolder(fileInfo);
    } else {
      return viewManager.get("homeListView") && viewManager.get("curFileTableView").refreshCurFolder && viewManager.get("curFileTableView").refreshCurFolder(fileInfo);
    }
  }
};

/**
 * @class
 * @param {MMFileInfo} fileInfo
 * @param {string} tagId    标签id
 * @param {} netCb    回调
 */
var MDDelTagOperation = function MDDelTagOperation(fileInfo, tagId, netCb) {
  this.fileInfo = fileInfo;
  this.tagId = tagId;
  this.tagData = fileInfo.getTagModelById(tagId);
  this.netCb = netCb || {};
};
Object.assign(MDDelTagOperation.prototype, {}, function () {
  return {
    constructor: MDDelTagOperation,
    excute: function excute(callback) {
      var fileInfo = this.fileInfo;
      var tagId = this.tagId;
      var fileId = fileInfo.getFileId();
      var self = this;
      _MDSnackbarView["default"].show(BabelStr.str(3587) + "...", {
        autoDismiss: false
      });
      _MDTagDataController["default"].removeTagFromFile(fileId, tagId, function (result) {
        _MDSnackbarView["default"].show(BabelStr.str(246), {
          showRollback: true
        });
        fileInfo.removeTagById(tagId);
        _.isFunction(self.netCb.success) && self.netCb.success();
      }, function (errCode) {
        if (errCode == 9150) {
          _MDSnackbarView["default"].show(BabelStr.str(3588));
        } else if (errCode == 12) {
          _MDSnackbarView["default"].show(BabelStr.str(4245));
        } else {
          _MDSnackbarView["default"].show(BabelStr.str(3589));
        }
        _.isFunction(self.netCb.fail) && self.netCb.fail();
      });
    },
    undo: function undo() {
      var self = this;
      var fileInfo = this.fileInfo;
      var tagId = this.tagId;
      _MDTagDataController["default"].addTagForFiles([fileInfo.getFileId()], tagId, null, function success() {
        self.fileInfo.addTag(self.tagData);
        _MDSnackbarView["default"].show(BabelStr.str(3590));
        _Dispatcher["default"].trigger(_MDEvents["default"].Tag_Add_To_File, {
          tagModel: self.tagData,
          fileInfo: self.fileInfo
        });
      }, function fail(e, errFileList) {
        _MDSnackbarView["default"].show(BabelStr.str(3591));
      });
    }
  };
}());

/**
 * MDCopyFilesOperation
 *
 *
 */
var MDCopyFilesOperation = function MDCopyFilesOperation(fileInfors, targetFolderId, callback, params) {
  var _this = this;
  this.fileInfors = fileInfors;
  this.targetFolderId = targetFolderId;
  this.callback = callback;
  this.newIds = [];
  params = params || {};
  this.forSendFile = params.forSendFile;
  this.sendId = params.sendId;
  this.progressWin = new _MDMoveProgressWinView["default"]({
    onDelItem: function onDelItem(subView) {
      _this.progressWin.removeSubView(subView);
      if (_this.progressWin.getSubViewCount() < 1) {
        _this.progressWin.close();
      }
    },
    onClose: function onClose() {
      // var curDataCollection =
      //   MDFileOperationManager.getDispFileInfoCollection();

      if (!app.currentFolder) {
        return;
      }
      var curFolderId = app.currentFolder.getFileId();
      if (_this.targetFolderId == curFolderId) {
        if (curFolderId == '0' && (!app.pathRouter || !app.pathRouter.isInPersonFileChannel())) {
          return;
        }
        // 当前文件夹是移入的文件夹
        MDFileOperationManager.requestFolder(app.currentFolder);
      }
    }
  });

  // let $btn =  $('#move-progress-btn');
  // if(!$btn.length) {
  //   $btn = $(`<div id="move-progress-btn">${BabelStr.str(6115)}</div>`)
  //   $('body').append($btn)
  // }

  // this.$btn = $btn;
};
Object.assign(MDCopyFilesOperation.prototype, {}, function () {
  return {
    constructor: MDCopyFilesOperation,
    excute: function excute(callback) {
      var targetFolderId = this.targetFolderId;
      var self = this;
      var ids = [];
      var copyVersionInfos = [];
      for (var i = 0; i < this.fileInfors.length; i++) {
        var fileInfo = this.fileInfors[i];
        var deleteVersionId = fileInfo.get("deleteVersionId");
        if (deleteVersionId) {
          copyVersionInfos.push({
            fileId: fileInfo.getFileId(),
            versionId: deleteVersionId
          });
        } else {
          ids.push(fileInfo.getFileId());
        }
      }
      _.map(this.fileInfors, function (fileInfor) {
        return fileInfor.getFileId();
      });
      var failList = [];
      var finished = 0;
      var fileInfors = self.fileInfors;
      var sourceCollection = fileInfors[0].collection;
      // MDSnackbarView.show(BabelStr.str(3592)+'...', {
      //   autoDismiss: false
      // });
      var inTrash = fileInfors[0].isDeleted();
      var request;
      if (this.forSendFile) {
        request = _MMNetDiskDataController["default"].saveSendFilePersonal;
      } else {
        request = _MMNetDiskDataController["default"].copyFile;
      }
      request(ids, targetFolderId, function success(key, fileNum) {
        self.callback && self.callback();

        // MDSnackbarView.show(BabelStr.str(3593), { showRollback: true });
        // Dispatcher.trigger(MDEvents.FolderCopied, {
        //   copiedFileInfors: fileInfors,
        //   idMapArr: result,
        //   targetParentFolderId: targetFolderId
        // });

        // self.newIds = [];
        // result.forEach(function(idMap) {
        //   self.newIds.push(idMap.newFileId);
        // })
        var nameStr = self.fileInfors.length > 1 ? self.fileInfors[0].getFileName() + BabelStr.str(7065) : self.fileInfors[0].getFileName();
        self.progressWin.appendKey({
          fileName: nameStr,
          key: key,
          fileNum: fileNum
        });
        self.progressWin.show();
        // _refreshCurrentFileList.call(self);
      }, function fail(errCode, errMsg) {
        self.progressWin.remove();
        self.callback && self.callback(true);
        errMsg = errMsg || BabelStr.str(3594);
        if (errCode == 30001) {
          _MDSnackbarView["default"].show(BabelStr.str(6903));
        } else if (errCode == 12) {
          _MDSnackbarView["default"].show(BabelStr.str(8578));
        } else if (errCode == _MMNetDiskDataController["default"].code.ERROR_DB_FILESIZE_EXCEEDED || errCode == "7") {
          _MDSnackbarView["default"].show(BabelStr.str(3595));
        } else if (errCode == _MMNetDiskDataController["default"].code.ERROR_PERMISSION_DENIED) {
          _MDSnackbarView["default"].show(errMsg);
        } else {
          _MDSnackbarView["default"].show(errMsg);
        }
      }, {
        inTrash: inTrash,
        copyVersionInfos: copyVersionInfos,
        sendId: this.sendId
      });
    },
    undo: function undo() {
      var self = this;
      _MMNetDiskDataController["default"].deleteFilesByIds({
        fileArray: this.newIds
      }, function success() {
        var fileInforCollection = MDFileOperationManager.getDispFileInfoCollection();
        fileInforCollection.remove(self.newFileInfo);
        _Dispatcher["default"].trigger(_MDEvents["default"].FolderDeleted, self.newIds);
        _MDSnackbarView["default"].show(BabelStr.str(3596));
      }, function fail(e, errFileList) {
        _MDSnackbarView["default"].show(BabelStr.str(3597));
      });
    }
  };
}());

/**
 * MDNewFolderOperation
 *
 *
 */
var MDNewFolderOperation = function MDNewFolderOperation(text, parentFileInfo, param) {
  this.text = text;
  this.parentFileInfo = parentFileInfo;
  this.newFileInfo = null;
  this.isArchive = param.isArchive;
  this.createDep = param.createDep;
};
Object.assign(MDNewFolderOperation.prototype, {}, function () {
  return {
    constructor: MDNewFolderOperation,
    excute: function excute(callback) {
      var self = this;
      var creationFunc = _MMNetDiskDataController["default"].createDir;
      if (this.isArchive) {
        creationFunc = _MMNetDiskDataController["default"].createArchiveFolder;
      } else if (this.createDep) {
        creationFunc = function creationFunc(name, folder, forceRename, success, fail) {
          var parentDepId = folder.get("departmentId");
          var openFolder = false;
          if (!parentDepId && folder.getFileId() == "0") {
            parentDepId = window.ep.rootDepId;
            openFolder = true;
          }
          if (parentDepId) {
            MMEnterpriseController.department.createDepartment(name, parentDepId, {
              needFileInfo: true
            }, function (folderInfo) {
              success(folderInfo);
              if (openFolder) {
                localStorage.setItem("s".concat(window.ep.rootDepFolderId), "latestVersionTime-DESC");
                app.pathRouter.navigateToPath("epfile/" + window.ep.rootDepFolderId);
              }
            }, function (code, msg) {
              fail && fail(code, msg);
            });
          }
        };
      }
      var forceRename = 0; // 如果发现重名，放弃强制重命名，返回错误
      creationFunc(this.text, this.parentFileInfo, forceRename, function success(folderInfo) {
        // if (app.isShareApp) {
        //   Dispatcher.trigger(MDEvents.FolderCreated, folderInfo);
        //   return;
        // }

        self.newFileInfo = folderInfo;
        if (self.parentFileInfo.getFileId() != "0" && self.parentFileInfo.getFileId() == app.currentFolder.getFileId() || app.pathRouter.isInArchiveChannel && app.pathRouter.isInArchiveChannel() || self.parentFileInfo.getFileId() == "0" && app.pathRouter.isInPersonFileChannel && app.pathRouter.isInPersonFileChannel()) {
          var fileInforCollection = MDFileOperationManager.getDispFileInfoCollection();

          // if (app.pathRouter.isInFileChannel &&　app.pathRouter.isInFileChannel() || app.pathRouter.isInArchiveChannel && app.pathRouter.isInArchiveChannel()) {
          fileInforCollection.addFileBlowStickonTop(folderInfo);
          // }

          var showRollback = true;
          if (app.pathRouter.isInArchiveChannel && app.pathRouter.isInArchiveChannel() || self.createDep) {
            showRollback = false;
          }

          // if(window.isSharePage) {
          //   fileInforCollection.add(folderInfo)
          // }

          var msg = BabelStr.str(3598);
          if (self.createDep) {
            msg = BabelStr.str(308);
          }
          _MDSnackbarView["default"].show(msg, {
            showRollback: showRollback
          });
        }
        if (callback) {
          callback(folderInfo);
        }
        _Dispatcher["default"].trigger(_MDEvents["default"].FolderCreated, folderInfo);
      }, function fail(errCode, errMsg) {
        if (errCode == 12) {
          errMsg = errMsg || BabelStr.str(153);
        } else if (errCode == _ErrorCode["default"].SameFileExists) {
          errMsg = errMsg || BabelStr.str(20162);
        } else if (errCode == 20001) {
          errMsg = BabelStr.str(7506);
        } else {
          errMsg = errMsg || BabelStr.str(3599);
        }
        // MDSnackbarView.show(errMsg);
        if (callback) {
          callback({
            err: true,
            msg: errMsg
          });
        }
      }, {
        sameFileReturnFalse: true
      });
    },
    undo: function undo() {
      var self = this;
      _MMNetDiskDataController["default"].deleteFilesByIds({
        fileArray: [this.newFileInfo.getFileId()]
      }, function success() {
        var fileInforCollection = MDFileOperationManager.getDispFileInfoCollection();
        fileInforCollection.remove(self.newFileInfo);
        _Dispatcher["default"].trigger(_MDEvents["default"].FolderDeleted, [self.newFileInfo]);
        _MDSnackbarView["default"].show(BabelStr.str(3600));
      }, function fail(e, errFileList) {
        _MDSnackbarView["default"].show(BabelStr.str(3601));
      });
    }
  };
}());

/**
 * MDDelFileOperation
 *
 *
 */
var MDDelFileOperation = function MDDelFileOperation(filesDeleting) {
  this.filesDeleting = filesDeleting;
  this.fileCanDel = [];
};
Object.assign(MDDelFileOperation.prototype, {}, function () {
  var _removeCommonFiles = function _removeCommonFiles() {
    var self = this;
    var fileIds = [];
    var joinedFileId = [];
    var shareCanLeaved = [];
    var shareFileDel = [];
    var fileCanDel = [];
    var filesDeleting = this.filesDeleting;
    _.each(filesDeleting, function (fileInfor) {
      if (fileInfor.isMyJoinedShare()) {
        joinedFileId.push(fileInfor.getFileId());
        shareCanLeaved.push(fileInfor.getFileId());
        shareFileDel.push(fileInfor);
      } else if (fileInfor.isRoot()) {
        if (fileInfor.isMine()) {
          fileIds.push(fileInfor.getFileId());
          fileCanDel.push(fileInfor);
        } else {
          joinedFileId.push(fileInfor.getFileId());
          if (fileInfor.canLeaveShare()) {
            shareCanLeaved.push(fileInfor.getFileId());
            fileCanDel.push(fileInfor);
          }
        }
      } else {
        if (app.pathRouter.hasTeamFolder && app.pathRouter.hasTeamFolder() || app.pathRouter.hasDepartmentFolder && app.pathRouter.hasDepartmentFolder()) {
          fileIds.push(fileInfor.getFileId());
          fileCanDel.push(fileInfor);
        } else {
          if (fileInfor.canDelete() || fileInfor.isOwner()) {
            fileIds.push(fileInfor.getFileId());
            fileCanDel.push(fileInfor);
          } else {
            joinedFileId.push(fileInfor.getFileId());
            if (fileInfor.canLeaveShare()) {
              shareCanLeaved.push(fileInfor.getFileId());
              fileCanDel.push(fileInfor);
            }
          }
        }
      }
    });
    var fileInforCollection = MDFileOperationManager.getDispFileInfoCollection();
    if (fileIds.length >= 1) {
      // MDSnackbarView.show(BabelStr.str(690)+'...');
      _MDLoadMaskView["default"].show(undefined, {
        bodyMsg: BabelStr.str(690) + "...",
        noClose: true
      });
      _MMNetDiskDataController["default"].deleteFilesByIds({
        fileArray: fileIds
      }, function success() {
        self.fileCanDel = fileCanDel;
        fileInforCollection.remove(fileCanDel);
        _Dispatcher["default"].trigger(_MDEvents["default"].FolderDeleted, fileCanDel);
        var callback = true;
        _.each(fileCanDel, function (file) {
          if (file.isProject() || file.isTemplateStore()) {
            callback = false;
          }
        });
        _MDSnackbarView["default"].show(BabelStr.str(3600), {
          showRollback: callback
        });
        _Dispatcher["default"].trigger(_MDEvents["default"].ClearCheckAll);
        _MDLoadMaskView["default"].remove();

        // 修改指向已删除文件的快捷方式的状态
        fileInforCollection.forEach(function (file) {
          file.markShortcutsTargetDeleted(fileIds);
        });
      }, function fail(e, errFileList) {
        if (e) {
          _MDLoadMaskView["default"].remove();
          //todo: message that some folder to delete had a sharing child
          var alert = new _MDAlertView["default"]();
          var z_startIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
          $(alert.el).css("z-index", z_startIndex);
          var title = BabelStr.str(3602) + "[" + e + "]";
          if (e == _MMNetDiskDataController["default"].code.ERROR_DELETE_IS_EVALUATING) {
            title = BabelStr.str(307);
          } else if (e == _MMNetDiskDataController["default"].code.ERROR_FILE_HAS_SHARING_CHILDREN) {
            title = BabelStr.str(3603);
          } else if (e == 339) {
            title = BabelStr.str(3458);
          } else if (e == 703) {
            title = BabelStr.str(7525);
          } else if (e == 138 || e == 142) {
            title = BabelStr.str(21405);
          }
          alert.show({
            title: BabelStr.str(170),
            message: '<p class="title">' + title + "</p>",
            className: "m-delAlertWin",
            onHide: function onHide() {
              var filePathNavView = viewManager.get("filePathNavView");
              filePathNavView.refreshCurFolder();
            },
            buttons: [{
              label: BabelStr.str(3604)
            }]
          });
          _MDSnackbarView["default"].dismiss();
        }
      });
    }
    function leaveShareOneByOne() {
      var leaveFile = shareFileDel.shift();
      if (leaveFile) {
        var leaveFileId = leaveFile.getFileId();
        _MMNetDiskDataController["default"].leaveSharedFile(leaveFileId, function () {
          leaveShareOneByOne();
          fileInforCollection.remove([leaveFile]);
          _Dispatcher["default"].trigger(_MDEvents["default"].FolderDeleted, [leaveFile]);
        }, function (code, msg) {
          leaveShareOneByOne();
          if (msg) {
            _MDSnackbarView["default"].show(msg, {
              showRollback: false
            });
          } else {
            var msg = BabelStr.str(309) + "(" + code + ")";
            _MDSnackbarView["default"].show(msg, {
              showRollback: false
            });
          }
        });
      }
    }
    leaveShareOneByOne();
    if (shareCanLeaved.length != joinedFileId.length) {
      _MDSnackbarView["default"].showStandardMsg(40);
    }
  };
  var _removeDeparment = function _removeDeparment() {
    if (this.filesDeleting.length != 1) {
      return;
    }
    if (!this.filesDeleting[0].isDepartmentFolder()) {
      return;
    }
    var delFileInfo = this.filesDeleting[0];
    var depId = delFileInfo.get("departmentId");
    var folderId = delFileInfo.get("fileId");
    _MDLoadMaskView["default"].show(undefined, {
      bodyMsg: BabelStr.str(690) + "...",
      noClose: true
    });
    MMEnterpriseController.department.delDepartmentByFolderId(depId, folderId, function () {
      //  删除部门
      _MDLoadMaskView["default"].remove();
      var fileInforCollection = MDFileOperationManager.getDispFileInfoCollection();
      fileInforCollection.remove(delFileInfo);
      _Dispatcher["default"].trigger(_MDEvents["default"].FolderDeleted, [delFileInfo]);
      _MDSnackbarView["default"].show(BabelStr.str(308), {
        showRollback: false
      });
      _Dispatcher["default"].trigger(_MDEvents["default"].ClearCheckAll);
    }, function (code, msg) {
      _MDLoadMaskView["default"].remove();
      if (code == _ErrorCode["default"].Dep_has_subDep) {
        msg = BabelStr.str(784); //  含有归档文件的部门不能删除
        var alert = new _MDAlertView["default"]();
        alert.show({
          title: BabelStr.str(170),
          // '提示',
          message: msg,
          buttons: [{
            label: BabelStr.str(154) // '确定',
          }]
        });
        return;
      }
      if (code == _ErrorCode["default"].Cannot_Access_Archive) {
        msg = BabelStr.str(785); //  含有归档文件的部门不能删除
      }
      _MDSnackbarView["default"].show(msg, {
        showRollback: false
      });
    });
  };
  var _removeTeam = function _removeTeam() {
    if (this.filesDeleting.length != 1) {
      return;
    }
    if (!this.filesDeleting[0].isTeamFolder()) {
      return;
    }
    var delFileInfo = this.filesDeleting[0];
    var delTeamFun = function delTeamFun(teamData) {
      _MDTeamDataController["default"].exitTeam(teamData, function () {
        var fileInforCollection = MDFileOperationManager.getDispFileInfoCollection();
        fileInforCollection.remove(delFileInfo);
        _MDSnackbarView["default"].show(BabelStr.str(308), {
          showRollback: false
        });
        _Dispatcher["default"].trigger(_MDEvents["default"].ClearCheckAll);
      }, function (code, msg) {
        _MDSnackbarView["default"].show(BabelStr.str(5088), {
          curTeamInfor: delFileInfo
        });
      });
    };
    var teamInfo = delFileInfo.getTeamInfo();
    if (!teamInfo || teamInfo.getId() == -1) {
      _MDTeamDataController["default"].getByFolder(delFileInfo.getFileId(), function (teamData) {
        delTeamFun(teamData);
      }, function () {});
    } else {
      delTeamFun(teamInfo);
    }
  };
  return {
    constructor: MDDelFileOperation,
    excute: function excute() {
      if (this.filesDeleting.length == 1 && this.filesDeleting[0].isTeamFolder()) {
        _removeTeam.call(this);
      } else if (this.filesDeleting.length == 1 && this.filesDeleting[0].isDepartmentFolder()) {
        _removeDeparment.call(this);
      } else {
        _removeCommonFiles.call(this);
      }
    },
    undo: function undo() {
      var self = this;
      var fileIds = [];
      this.fileCanDel.forEach(function (fileInfo) {
        fileIds.push(fileInfo.getFileId());
      });
      _MMNetDiskDataController["default"].restore(fileIds, fileIds, function () {
        var curFolderId = app.currentFolder.getFileId();
        var parentId = self.fileCanDel[0].getParentFolderId();
        if (curFolderId == parentId) {
          MDFileOperationManager.requestFolder(app.currentFolder);
        }
        var folderInfo = self.fileCanDel.find(function (fileInfo) {
          return fileInfo.isFolder();
        });
        if (folderInfo) {
          _Dispatcher["default"].trigger(_MDEvents["default"].FolderCreated, folderInfo);
        }
        _MDSnackbarView["default"].show(BabelStr.str(3605) + "!");
      }, function (errCode, errMsg) {
        var code = errMsg[0].code;
        errMsg = BabelStr.str(3607) + code + "，" + BabelStr.str(3606) + "!";
        _MDSnackbarView["default"].show(errMsg);
      });
    }
  };
}());

/**
 * MDRenameFileOperation
 *
 *
 */
var MDRenameFileOperation = function MDRenameFileOperation(fileInfor, newName) {
  this.oldName = fileInfor.getFileName();
  this.fileInfor = fileInfor;
  this.newName = newName;
};
Object.assign(MDRenameFileOperation.prototype, {}, function () {
  return {
    constructor: MDRenameFileOperation,
    excute: function excute() {
      var self = this;
      var successFun = function successFun() {
        if (self.fileInfor) {
          self.oldTime = self.fileInfor.get("mtime");
          self.fileInfor.set({
            fileName: self.newName,
            mtime: new Date().getTime() / 1000
          });
        }
        _Dispatcher["default"].trigger(_MDEvents["default"].FolderRenamed, self.fileInfor.getFileId(), self.newName);
        var canrollback = true;
        if (self.fileInfor.isDepartmentFolder()) {
          canrollback = false;
        }
        _MDSnackbarView["default"].show(BabelStr.str(3608), {
          showRollback: canrollback
        });
      };
      if (this.fileInfor.isDepartmentFolder()) {
        var depId = this.fileInfor.get("departmentId");
        MMEnterpriseController.department.changeDepartmentInfo(depId, {
          name: self.newName
        }, successFun, function fail(errCode, errMsg) {
          if (errCode == 20001) {
            _MDSnackbarView["default"].show(BabelStr.str(7506));
            return;
          }
          errMsg = errMsg || BabelStr.str(309) + "(" + errCode + ")";
          _MDSnackbarView["default"].show(errMsg);
        });
      } else {
        _MMNetDiskDataController["default"].renameFile(this.fileInfor.getFileId(), this.fileInfor.getCurVersion(), this.newName, function success() {
          successFun();
        }, function fail(errCode, errMsg) {
          if (errCode == 20001) {
            _MDSnackbarView["default"].show(BabelStr.str(7506));
            return;
          }
          errMsg = errMsg || BabelStr.str(3609);
          _MDSnackbarView["default"].show(errMsg);
        });
      }
    },
    undo: function undo() {
      var self = this;
      _MMNetDiskDataController["default"].renameFile(this.fileInfor.getFileId(), this.fileInfor.getCurVersion(), this.oldName, function success() {
        self.fileInfor.set({
          fileName: self.oldName,
          mtime: self.oldTime
        });
        _Dispatcher["default"].trigger(_MDEvents["default"].FolderRenamed, self.fileInfor.getFileId(), self.newName);
        _MDSnackbarView["default"].show(BabelStr.str(3610));
      }, function fail(errCode, errMsg) {
        errMsg = errMsg || BabelStr.str(3611);
        if (errCode == _MMNetDiskDataController["default"].code.ERROR_DB_FILE_NAME_EXIST) {
          _MDSnackbarView["default"].show(errMsg);
        } else {
          _MDSnackbarView["default"].show(errMsg);
        }
      });
    }
  };
}());

/**
 * MDMoveFilesOperation
 *
 *
 */
var MDMoveFilesOperation = function MDMoveFilesOperation(ids, targetFolderId, sourceFolderId, mixEnterprises) {
  this.ids = ids;
  this.targetFolderId = targetFolderId;
  this.sourceFolderId = sourceFolderId;
  this.mixEnterprises = mixEnterprises;
};
Object.assign(MDMoveFilesOperation.prototype, {}, function () {
  function _refreshCurrentFileList() {
    var self = this;
    var curDataCollection = MDFileOperationManager.getDispFileInfoCollection();
    var curFolderId = app.currentFolder.getFileId();
    if (this.sourceFolderId == curFolderId) {
      // 当前文件夹是移出文件的文件夹
      var fileToRemove = [];
      curDataCollection.each(function (file) {
        var index = _.findIndex(self.ids, function (id) {
          return id == file.getFileId();
        });
        if (index != -1) {
          fileToRemove.push(file);
        }
      });
      curDataCollection.remove(fileToRemove); // 删除
    } else if (this.targetFolderId == curFolderId) {
      // 当前文件夹是移入的文件夹
      MDFileOperationManager.requestFolder(app.currentFolder);
    } else {
      if (this.ids.length == 1 && this.ids[0] == curFolderId) {
        var homeView = viewManager.get("homePanelView");
        if (homeView) {
          homeView.loadFolder(curFolderId);
        }
      }
    }
  }
  return {
    constructor: MDMoveFilesOperation,
    excute: function excute(callback) {
      var ids = this.ids;
      var targetFolderId = this.targetFolderId;
      var self = this;

      // MDSnackbarView.show(BabelStr.str(3612)+'...', {
      //   autoDismiss: false
      // });

      _MDLoadMaskView["default"].show(undefined, {
        bodyMsg: BabelStr.str(3612) + "...",
        noClose: true
      });
      _MMNetDiskDataController["default"].moveFile(ids, targetFolderId, function success() {
        _refreshCurrentFileList.call(self);
        _MDLoadMaskView["default"].remove();
        _MDSnackbarView["default"].show(BabelStr.str(3613), {
          showRollback: true
        });
        _Dispatcher["default"].trigger(_MDEvents["default"].FolderMoved, self.sourceFolderId, targetFolderId, ids);
        if (callback) {
          callback();
        }
      }, function fail(errors, msg) {
        _MDLoadMaskView["default"].remove();
        var errorStr = msg;
        var hasShared = false;
        var hasDepartment = false;
        var noPer = false;
        var fileNotExists = false;
        for (var i = 0; i < errors.length; i++) {
          var fileId = errors[i].fid;
          var index = _.find(self.ids, function (id) {
            return id == fileId;
          });
          if (index >= 0) {
            self.ids.splice(index, 1);
          }

          // errorStr += '[' + fileId + ']' + ' 错误码:' + errors[i].resultCode + '; ';
          if (errors[i].resultCode == 320) {
            hasShared = true;
          }
          if (errors[i].resultCode == 336) {
            hasDepartment = true;
          }
          if (errors[i].resultCode == 12) {
            noPer = true;
          }
          if (errors[i].resultCode == 101) {
            fileNotExists = true;
          }
        }
        if (fileNotExists) {
          var message = BabelStr.str(20013);
          _MDAlertView["default"].showStandardPrompt({
            message: message,
            okFun: function okFun() {
              window.location.reload();
            }
          });
        } else {
          if (hasShared) {
            errorStr = BabelStr.str(3614);
          }
          if (hasDepartment) {
            errorStr = BabelStr.str(3615);
          }
          if (noPer) {
            errorStr = BabelStr.str(6061);
          }
          var dispString = BabelStr.str(3617);
          if (self.mixEnterprises) {
            dispString = BabelStr.str(7519);
          } else if (errors == 30001) {
            dispString = BabelStr.str(6904);
          } else if (errorStr && errorStr.length > 0) {
            dispString += " : " + errorStr;
          }
          _MDSnackbarView["default"].show(dispString);
          if (callback) {
            callback(true);
          }
        }
      });
    },
    undo: function undo() {
      var ids = this.ids;
      var targetFolderId = this.targetFolderId;
      var sourceCollection = this.sourceCollection;
      _MDSnackbarView["default"].show(BabelStr.str(685) + "...", {
        autoDismiss: false
      });
      _MDLoadMaskView["default"].show(undefined, {
        bodyMsg: BabelStr.str(685) + "...",
        noClose: true
      });
      var self = this;
      _MMNetDiskDataController["default"].moveFile(ids, this.sourceFolderId, function success() {
        _MDLoadMaskView["default"].remove();
        var curFolderId = app.currentFolder.getFileId();
        var parentId = self.sourceFolderId;
        if (curFolderId == parentId || curFolderId == targetFolderId) {
          MDFileOperationManager.requestFolder(app.currentFolder);
        }
        _MDSnackbarView["default"].show(BabelStr.str(3618));
        _Dispatcher["default"].trigger(_MDEvents["default"].FolderMoved, targetFolderId, self.sourceFolderId, ids);
      }, function fail(errCode, errMsg) {
        _MDLoadMaskView["default"].remove();
        errMsg = errMsg || BabelStr.str(3619);
        _MDSnackbarView["default"].show(errMsg);
      });
    }
  };
}());
var _default = exports["default"] = MDFileOperationManager;

},{"1087":1087,"1093":1093,"1094":1094,"1104":1104,"1184":1184,"1416":1416,"1417":1417,"1418":1418,"1426":1426,"1432":1432,"1437":1437,"1451":1451,"1454":1454,"1463":1463,"1537":1537,"18":18,"32":32,"325":325,"49":49,"510":510,"72":72,"75":75,"811":811}],1094:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1439);
require(1503);
require(1500);
require(1466);
require(1422);
var _MDTeamInfo = _interopRequireDefault(require(289));
var _MDTeamInfoCollection = _interopRequireDefault(require(290));
var _MDRoleInfoCollection = _interopRequireDefault(require(282));
var _MDInvitationApplicationInfoCollection = _interopRequireDefault(require(262));
var _MDMemberInfo = _interopRequireDefault(require(268));
var _MDMemberInfoCollection = _interopRequireDefault(require(269));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDOrder = _interopRequireDefault(require(274));
var _MMFileInfoCollection = _interopRequireDefault(require(298));
//
//  网络访问的接口实现
//
//  created by jiang, and modified by tobias, and tobias is responsible for this file.
// 2016-3-2
//

var MDTeamDataController = {
  request: function request(route, msg, callback) {
    MDTeamDataController._connector.request(route, msg, callback);
  },
  /**
   * create team
   *
   * @param teamInfo { MDTeamInfo }
   *
   * testCode for the browser-console: MDTeamDataController.create(new MDTeamInfo({name:"two",description:"two d",memberLimit:6 }),function(a,b,c){console.log(a,b,c)},function(a,b,c){console.log("fail",a,b,c)});
   *
   */
  create: function create(teamInfo, orderOptions, success, fail) {
    var params = {
      "name": teamInfo.getName(),
      "description": teamInfo.getDescription(),
      "memberLimit": teamInfo.getMemLimit()
    };
    if (typeof orderOptions === "function") {
      fail = success;
      success = orderOptions;
    } else {
      params["productId"] = orderOptions.productId;
      params["productNumber"] = orderOptions.productNumber;
      params["invoiceAddress"] = orderOptions.invoiceAddress;
      params["invoiceHeader"] = orderOptions.invoiceHeader;
      params["invoiceUserName"] = orderOptions.invoiceUserName;
      params["invoicePhone"] = orderOptions.invoicePhone;
      params["isNeedInvoice"] = orderOptions.isNeedInvoice;
    }
    MDTeamDataController.request("netDrive.fileHandler.team_create", params, function (res) {
      if (res["resultCode"] === 0) {
        teamInfo.setId(res["teamId"]);
        teamInfo.setFolderId(res['folderId']);
        success(res["teamId"], res["orderId"], res['folderId'], res);
      } else {
        fail(res["resultCode"], res);
      }
    });
  },
  update: function update(teamId, updateParam, success, fail) {
    var params = {
      "teamId": teamId,
      "teamName": updateParam.name,
      "description": updateParam.description
    };
    MDTeamDataController.request("netDrive.fileHandler.team_update", params, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"], res);
      }
    });
  },
  /**
   * get all the teams for current user participated
   *
   * @return { array of MDTeamInfo}
   */
  getTeamInfosForCurrentUser: function getTeamInfosForCurrentUser(success, fail) {
    MDTeamDataController.request("netDrive.fileHandler.team_getMyTeams", function (res) {
      if (res["resultCode"] === 0) {
        var out = new _MDTeamInfoCollection["default"]();
        if (res["list"]) {
          out.add(res["list"]);
        }
        success(out);
      } else {
        fail(res["resultCode"], res);
      }
    });
  },
  /**
   * get all the members for the team
   *
   * @param teamId
   * @return {Array of MDMemberInfo} -- class MDMemberInfo is in the file MDTeamInfo.js
   */
  getMembers: function getMembers(teamId, success, fail) {
    MDTeamDataController.request("netDrive.fileHandler.team_getMembers", {
      "teamId": teamId
    }, function (res) {
      if (res["resultCode"] === 0) {
        var out = new _MDMemberInfoCollection["default"]();
        if (res['list']) {
          out.add(res['list']);
        }
        success(out);
      } else {
        fail(res["resultCode"], res);
      }
    });
  },
  /**
   * add member
   *    if the mail not exist in database, register it and mark it as 'no password', and send mail to invite
   *     else if the mail exist in database, only send invitation mail
   * @param teamId
   * @param mail {string}
   * @param alias {string}
   * @param roleId {int} - permission id in the table babelRole
   */
  addMember: function addMember(teamId, mail, alias, roleId, success, fail) {
    if (typeof alias == 'function') {
      success = alias;
      fail = roleId;
      alias = null;
      roleId = null;
    } else if (typeof roleId == 'function') {
      fail = success;
      success = roleId;
      roleId = null;
    }
    MDTeamDataController.request("netDrive.fileHandler.team_addMember", {
      "teamId": teamId,
      "mail": mail,
      "alias": alias,
      "roleId": roleId
    }, function (res) {
      if (res["resultCode"] === 0) {
        var user = null;
        if (res["user"]) {
          user = new _MDMemberInfo["default"](res["user"]);
        }
        success(res, user, !!res["new"]);
      } else {
        fail(res["resultCode"], mail, res);
      }
    });
  },
  addMemberByPhone: function addMemberByPhone(teamId, phone, alias, roleId, success, fail) {
    if (typeof alias == 'function') {
      success = alias;
      fail = roleId;
      alias = null;
      roleId = null;
    } else if (typeof roleId == 'function') {
      fail = success;
      success = roleId;
      roleId = null;
    }
    MDTeamDataController.request("netDrive.fileHandler.team_addMember", {
      "teamId": teamId,
      "phone": phone,
      "alias": alias,
      "roleId": roleId
    }, function (res) {
      if (res["resultCode"] === 0) {
        var user = null;
        if (res["user"]) {
          user = new _MDMemberInfo["default"](res["user"]);
        }
        success(res, user, !!res["new"]);
      } else {
        fail(res["resultCode"], mail, res);
      }
    });
  },
  /**
   *    remove members
   * @param teamId {int}
   * @param userIds {array of int} - array of userId
   */
  removeMembers: function removeMembers(teamId, userIds, success, fail) {
    MDTeamDataController.request("netDrive.fileHandler.team_removeMembers", {
      "teamId": teamId,
      "userIds": userIds
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res);
      } else {
        fail(res["resultCode"], res);
      }
    });
  },
  /**
   * find the team information by team name
   *
   * @param teamName { String }
   * @return team information { MDTeamInfo }, null if not found
   */
  getTeamInfoByName: function getTeamInfoByName(teamName, success, fail) {
    MDTeamDataController.request("netDrive.fileHandler.team_getTeamInfoByName", {
      "teamName": teamName
    }, function (res) {
      if (res["resultCode"] === 0) {
        var out = new _MDTeamInfoCollection["default"]();
        if (res["list"]) {
          out.add(res["list"]);
        }
        success(out);
      } else {
        fail(res["resultCode"], res);
      }
    });
  },
  findTeamInfos: function findTeamInfos(searchString, success, fail) {
    MDTeamDataController.request("netDrive.fileHandler.team_findTeamInfo", {
      "searchString": searchString
    }, function (res) {
      if (res["resultCode"] === 0) {
        var out = new _MDTeamInfoCollection["default"]();
        if (res["list"]) {
          out.add(res["list"]);
        }
        success(out);
      } else {
        fail(res["resultCode"], res);
      }
    });
  },
  getByFolder: function getByFolder(folderId, success, fail) {
    MDTeamDataController.request("netDrive.fileHandler.team_getByFolder", {
      "folderId": folderId
    }, function (res) {
      if (res["resultCode"] === 0 && res["info"]) {
        success(new _MDTeamInfo["default"](res["info"]));
      } else {
        fail(res["resultCode"], res);
      }
    });
  },
  getRoles: function getRoles(success, fail) {
    MDTeamDataController.request("netDrive.fileHandler.team_getRoles", {}, function (res) {
      if (res["resultCode"] === 0) {
        var out = new _MDRoleInfoCollection["default"]();
        var lan = BabelStr.getCurrentLanguage();
        if (lan == 'en') {
          _.each(res['list'], function (item) {
            item.description = item.descriptionEn;
            item.name = item.nameEn;
          });
          res.defaultRole.description = res.defaultRole.descriptionEn;
          res.defaultRole.name = res.defaultRole.nameEn;
        }
        if (res["list"]) {
          out.add(res["list"]);
        }
        success(out, res['defaultRole']['id']);
      } else {
        fail(res["resultCode"], res);
      }
    });
  },
  getRolesByShareType: function getRolesByShareType(isInTeam, success, fail) {
    MDTeamDataController.getRoles(function (roleCollection) {
      var shareRoles = [];
      roleCollection.each(function (roleInfo) {
        if (isInTeam) {
          if (roleInfo.getForTeamShare()) {
            shareRoles.push(roleInfo);
          }
          ;
        } else {
          if (roleInfo.getForShare()) {
            shareRoles.push(roleInfo);
          }
          ;
        }
      });
      success(shareRoles);
    }, function (e) {
      if (fail) {
        fail(e);
      }
      ;
    });
  },
  setUserRole: function setUserRole(teamId, userId, roleId, success, fail) {
    MDTeamDataController.request("netDrive.fileHandler.team_setMemberRole", {
      "teamId": teamId,
      "userId": userId,
      "roleId": roleId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res);
      } else {
        fail(res["resultCode"], res);
      }
    });
  },
  setUserAlias: function setUserAlias(teamId, userId, alias, success, fail) {
    MDTeamDataController.request("netDrive.fileHandler.team_setMemberAlias", {
      "teamId": teamId,
      "userId": userId,
      "alias": alias
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res);
      } else {
        fail(res["resultCode"], res);
      }
    });
  },
  setTeamAlias: function setTeamAlias(teamId, alias, success, fail) {
    MDTeamDataController.request("netDrive.fileHandler.team_setMemberAlias", {
      "teamId": teamId,
      "alias": alias
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res);
      } else {
        fail(res["resultCode"], res);
      }
    });
  },
  getQuota: function getQuota(teamId, success, fail) {
    MDTeamDataController.request("netDrive.fileHandler.team_getQuota", {
      "teamId": teamId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["usedSpace"], res["totalSpace"], res);
      } else {
        fail(res["resultCode"], res);
      }
    });
  },
  getMemberCount: function getMemberCount(teamId, success, fail) {
    MDTeamDataController.request("netDrive.fileHandler.team_getMemberCount", {
      "teamId": teamId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(parseInt(res["count"]), res);
      } else {
        fail(res["resultCode"], res);
      }
    });
  },
  /**
   * in the first place this method will check if the name already exist.
   *
   */
  checkTeamName: function checkTeamName(name, success, fail) {
    MDTeamDataController.request("netDrive.fileHandler.team_checkName", {
      "name": name
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res);
      } else {
        fail(res["resultCode"], res);
      }
    });
  },
  /**
   * apply to join a team
   * @param teamId { int }
   */
  apllyToJoinTeam: function apllyToJoinTeam(teamId, memberDescription, success, fail) {
    MDTeamDataController.request("netDrive.fileHandler.team_applyToJoin", {
      "teamId": teamId,
      "memberDescription": memberDescription || ""
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res);
      } else {
        fail(res["resultCode"], res);
      }
    });
  },
  memberErrorProcess: function memberErrorProcess(res, teamId, userId) {
    if (res["resultCode"] === 406) {
      var alertView = new _MDAlertView["default"]();
      alertView.show({
        title: BabelStr.str(170),
        message: '<p class="title">' + BabelStr.str(5107) + '</p>',
        buttons: [{
          label: BabelStr.str(154),
          type: 'done'
        }]
      });
    }
  },
  /**
   * the current user accept or deny the invitaion
   *
   * @param teamId { int } -
   * @param accept { bool } - true : accept, false:deny
   */
  acceptOrDenyInvitation: function acceptOrDenyInvitation(teamId, accept, success, fail) {
    MDTeamDataController.request("netDrive.fileHandler.team_acceptOrDenyInvitation", {
      "teamId": teamId,
      "accept": accept
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res);
      } else {
        MDTeamDataController.memberErrorProcess(res, teamId, app.currentUser.getUserId());
        fail(res["resultCode"], res);
      }
    });
  },
  haveFreeTeam: function haveFreeTeam(success, fail) {
    MDTeamDataController.request("netDrive.fileHandler.team_haveFreeTeam", {}, function (res) {
      if (res["resultCode"] === 0) {
        success(!!res["hasFreeTeam"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  /**
   * accept or deny the application
   *
   * @param teamId { int } -
   * @param accept { bool } - true : accept, false:deny
   */
  acceptOrDenyApplication: function acceptOrDenyApplication(teamId, userId, accept, success, fail) {
    MDTeamDataController.request("netDrive.fileHandler.team_acceptOrDenyApplication", {
      "accept": accept,
      "userId": userId,
      "teamId": teamId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res);
      } else {
        MDTeamDataController.memberErrorProcess(res, teamId, userId);
        fail(res["resultCode"], res);
      }
    });
  },
  /**
   * Get invitation send to me and the application send to me
   * All the manager of the team can see the applications to enter the team
   *
   * @return array of MDInvitationApplicationInfo
   */
  getInvitationAndApplications: function getInvitationAndApplications(success, fail) {
    // todo call to server

    MDTeamDataController.request("netDrive.fileHandler.team_getInvitationAndApplications", {}, function (res) {
      if (res["resultCode"] === 0) {
        var collection = new _MDInvitationApplicationInfoCollection["default"]();
        if (res['list']) {
          collection.add(res['list']);
        }
        if (_.isFunction(success)) {
          success(collection);
        }
        ;
        console.log("success", res, collection);
      } else {
        fail(res["resultCode"], res);
        console.log("fail", res);
      }
    });
  },
  /*
   get all pending notifications
  */

  getUnProcessedNotifications: function getUnProcessedNotifications(success, fail) {
    MDTeamDataController.request("netDrive.teamHandler.getUnprocessedNotifications", {}, function (res) {
      if (res["resultCode"] === 0) {
        var collection = new _MDInvitationApplicationInfoCollection["default"]();
        if (res['list']) {
          // 过滤一下， 注意，不支持的通知必须过滤，否则会导致页面对象创建失败，从而导致数据和页面显示对象的数量不一致，
          // 从而导致界面删除通知时下标不一致
          var list = res['list'];
          for (var i = 0; i < list.length; i++) {
            var element = list[i];
            if (element.notificationType == "EXPIRATION" || element.notificationType == "SEND_FILE_PERSONAL_REVIEW" || element.notificationType == "SEND_FILE_PERSONAL_REVIEW_RESULT" || element.notificationType == 'SEND_FILE_PERSONAL' || element.notificationContent && element.notificationContent.message) {
              collection.add(element);
            } else {
              console.error(element);
            }
          }
        }
        if (_.isFunction(success)) {
          success(collection);
        }
        ;
        console.log("success", res, collection);
      } else {
        fail(res["resultCode"], res);
        console.log("fail", res);
      }
    });
  },
  getAllNotifications: function getAllNotifications(startIndex, pageSize, success, fail) {
    MMEnterpriseController.request('netDrive.teamHandler.getAllNotifications', {
      startIndex: startIndex,
      pageSize: pageSize
    }, function (res) {
      if (res['resultCode'] === 0) {
        var collection = new _MDInvitationApplicationInfoCollection["default"]();
        if (res['list']) {
          collection.add(res['list']);
        }
        if (_.isFunction(success)) {
          success(collection);
        }
        ;
        console.log("success", res, collection);
      } else {
        _.isFunction(fail) && fail(res['resultCode'], res["message"]);
      }
    });
  },
  getNotificationsByIds: function getNotificationsByIds(ids, success, fail) {
    MMEnterpriseController.request('netDrive.teamHandler.getAllNotifications', {
      ids: ids
    }, function (res) {
      if (res['resultCode'] === 0) {
        var collection = new _MDInvitationApplicationInfoCollection["default"]();
        if (res['list']) {
          collection.add(res['list']);
        }
        if (_.isFunction(success)) {
          success(collection);
        }
        ;
        console.log("success", res, collection);
      } else {
        _.isFunction(fail) && fail(res['resultCode'], res["message"]);
      }
    });
  },
  /*
    clear both notification
  */

  cleanUserUnprocessedNotifications: function cleanUserUnprocessedNotifications(success, fail) {
    MDTeamDataController.request("netDrive.teamHandler.cleanUserUnprocessedNotifications", function (res) {
      if (res["resultCode"] !== 0) {
        fail(res["resultCode"]);
      } else {
        _.isFunction(success) && success();
      }
    });
  },
  /*
    get length of notifications
   */
  getUnprocessedNotificationsLength: function getUnprocessedNotificationsLength(success, fail) {
    MDTeamDataController.request("netDrive.teamHandler.getUnprocessedNotificationsLength", function (res) {
      if (res["resultCode"] !== 0) {
        fail(res["resultCode"]);
      } else {
        _.isFunction(success) && success(res['notificationsLength']);
      }
    });
  },
  /*
    delete one or seris of notifications
   */
  deleteNotifications: function deleteNotifications(notifications, success, fail) {
    MDTeamDataController.request("netDrive.teamHandler.deleteNotifications", {
      'notifications': notifications
    }, function (res) {
      if (res["resultCode"] !== 0) {
        fail(res["resultCode"]);
      } else {
        _.isFunction(success) && success();
      }
    });
  },
  // /**
  //  * get the orderlist for current user
  //  *
  //  *
  //  */
  // getOrderList: function(success, fail) {
  //   var user = app.currentUser;
  //   //      if (user.isAnonymouse()) {
  //   //          if (success) {
  //   //              success([]);
  //   //          };
  //   //      };

  //   MDTeamDataController.request("netDrive.fileHandler.getOrders", {

  //   }, function(res) {
  //     if (res["resultCode"] === 0) {
  //       var orderCollection = new MDOrderInfoCollection;
  //       if (res['orderList']) {
  //         res['orderList'].forEach(function(orderInfo) {
  //           orderCollection.add(new MDOrderInfo(orderInfo));
  //         });
  //       }

  //       if (success) {
  //         success(orderCollection);
  //       };
  //     } else {
  //       fail(res["resultCode"], res);
  //     }
  //   });
  // },

  /**
   * cancel the order
   *
   * @param orderId{String} -
   */
  cancelOrder: function cancelOrder(orderId, success, fail) {
    MDTeamDataController.request("netDrive.fileHandler.cancelOrder", {
      "orderId": orderId
    }, function (res) {
      if (res["resultCode"] === 0) {
        if (success) {
          success();
        }
        ;
      } else {
        if (fail) {
          fail(res["resultCode"], res);
        }
        ;
      }
    });
    if (success) {
      success([new _MDOrder["default"]()]);
    }
    ;
  },
  /**
   *    send a validation code to the phone
   *
   * @param phoneNumber{int} - phone number
   */
  sendValidationCode: function sendValidationCode(phoneNumber, success, fail) {},
  getSystemTimeFromServer: function getSystemTimeFromServer(success, fail) {
    if (!success) return;
    MDTeamDataController.request("netDrive.fileHandler.getTime", function (res) {
      if (res["resultCode"] === 0) {
        success(res["time"]);
      } else {
        if (fail) fail(res["resultCode"], res);
      }
    });
  },
  /**
   *@return MMFileInfo
   */
  getTeamFolderInfoByTeamOwnerId: function getTeamFolderInfoByTeamOwnerId(ownerId, success, fail) {
    if (!success) return;
    MDTeamDataController.request("netDrive.fileHandler.file_getTeamFolderByTeamId", {
      "teamIds": Array.isArray(ownerId) ? ownerId : [ownerId]
    }, function (res) {
      if (res["resultCode"] === 0) {
        var collection = new _MMFileInfoCollection["default"]();
        collection.add(res["list"]);
        success(collection, res);
      } else {
        if (fail) fail(res["resultCode"], res);
      }
    });
  },
  /**
   * get all the team manager in the team that the file belongs to
   * @param fileId {int} - file's id
   * @return {array of MolaUser} - the managers for team, eampty means no team
   */
  getTeamManagerByFileId: function getTeamManagerByFileId(fileId, success, fail) {},
  /**
   * exit the team: for creator, to delete the team
   * @param teamInfo {MDTeamInfo}
   *
   */
  exitTeam: function exitTeam(teamInfo, success, fail) {
    if (teamInfo.getCreatorId() == app.currentUser.getUserId()) {
      MDTeamDataController.request("netDrive.fileHandler.team_remove", {
        "teamId": teamInfo.getId()
      }, function (res) {
        if (res["resultCode"] === 0) {
          success();
        } else {
          fail(res["resultCode"], res);
        }
      });
    } else {
      MDTeamDataController.request("netDrive.fileHandler.team_leave", {
        "teamId": teamInfo.getId()
      }, function (res) {
        if (res["resultCode"] === 0) {
          success();
        } else {
          fail(res["resultCode"]);
        }
      });
    }
  },
  readSystemInformUser: function readSystemInformUser(informId, success, fail) {
    MDTeamDataController.request('netDrive.fileHandler.readSystemInformUser', {
      'informId': informId
    }, function (res) {
      if (res['resultCode'] === 0) {
        success();
      } else {
        fail(res['resultCode']);
      }
    });
  },
  updateMemberNickname: function updateMemberNickname(teamId, userId, nickname, success, fail) {
    MMNetDiskDataController.request("netDrive.teamHandler.setMemberRemark", {
      "teamId": teamId,
      "userId": userId,
      "remark": nickname
    }, function (res) {
      if (res['resultCode'] === 0) {
        success();
      } else {
        fail(res['resultCode']);
      }
    }, function name(params) {
      console.error(params);
    });
  }
};
var _default = exports["default"] = MDTeamDataController;

},{"1184":1184,"1422":1422,"1439":1439,"1454":1454,"1466":1466,"1500":1500,"1503":1503,"262":262,"268":268,"269":269,"274":274,"282":282,"289":289,"290":290,"298":298,"32":32}],290:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1431);
var _MDTeamInfo = _interopRequireDefault(require(289));
/**
 * 从MDTeamInfo中移出MDTeamInfoCollection单独一个文件
 * moved by manjun.han
 * 2016.11.4
 */

var MDTeamInfoCollection = Backbone.Collection.extend({
  "model": _MDTeamInfo["default"],
  getMyFreeTeam: function getMyFreeTeam() {
    var freeTeams = [];
    this.each(function (teamInfo) {
      if (teamInfo.isFree() && teamInfo.isCreatedByMe()) {
        freeTeams.push(teamInfo);
      }
      ;
    });
    return freeTeams;
  },
  findTeamIdByFoldId: function findTeamIdByFoldId(folderId) {
    var teamId = 0;
    this.each(function (teamInfo) {
      if (teamInfo.getFolderId() == folderId) {
        teamId = teamInfo.getId();
        return false;
      }
      ;
    });
    return teamId;
  },
  comparator: function comparator(teamInfo) {
    return teamInfo.get('createTime');
  },
  sortByCreationTime: function sortByCreationTime() {
    this.models.sort(function (t1, t2) {
      return t2.get('createTime') - t1.get('createTime');
    });
  }
});
var _default = exports["default"] = MDTeamInfoCollection;

},{"1184":1184,"1431":1431,"1454":1454,"289":289}],274:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
var _MMModelBase = _interopRequireDefault(require(21));
/**
 * Modified by jichao
 * 2016.12.5
 */

var MDOrder = _MMModelBase["default"].extend({
  defaults: {
    "address": "",
    "invoice": "",
    //发票抬头
    "commitTime": new Date(),
    "endTime": new Date(),
    "content": "",
    "enterpriserId": "",
    "id": "",
    "isDeleted": "",
    "orderId": "",
    "paidTime": new Date(),
    "phone": "",
    "productNum": 0,
    "recipientsName": "",
    "spaceProductId": "",
    "status": -1,
    "totalPrice": 0,
    "type": -1,
    "userId": "",
    "years": 0
  },
  getOrderId: function getOrderId() {
    return this.get("orderId");
  },
  getContent: function getContent() {
    return this.get("content");
  },
  getCommitTime: function getCommitTime() {
    return new Date(this.get("commitTime") * 1000);
  },
  getEndTime: function getEndTime() {
    return new Date(this.get("endTime") * 1000);
  },
  getOrderValidTime: function getOrderValidTime() {
    return new Date((this.get("commitTime") + 30 * 60) * 1000);
  },
  getYears: function getYears() {
    return this.get("years");
  },
  getTotalPrice: function getTotalPrice() {
    return this.get("totalPrice");
  },
  getStatus: function getStatus() {
    return this.get("status");
  },
  getType: function getType() {
    return this.get("type");
  }
});
var _default = exports["default"] = MDOrder;

},{"1184":1184,"1437":1437,"1454":1454,"21":21}],269:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMCollectionBase = _interopRequireDefault(require(20));
var _MDMemberInfo = _interopRequireDefault(require(268));
var MDMemberInfoCollection = _MMCollectionBase["default"].extend({
  model: _MDMemberInfo["default"]
});
var _default = exports["default"] = MDMemberInfoCollection;

},{"1184":1184,"1454":1454,"20":20,"268":268}],268:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDPerformer = _interopRequireDefault(require(278));
var _utils = _interopRequireDefault(require(108));
var MDMemberInfo = _MDPerformer["default"].extend({
  defaults: function defaults() {
    var superDefaults = _MDPerformer["default"].prototype.defaults.call(this);
    return _.extend(superDefaults, {
      "memId": "",
      "teamId": "",
      "avatarURL": ''
    });
  },
  initialize: function initialize(opt) {
    _MDPerformer["default"].prototype.initialize.call(this, opt);
    var memId = this.get('memId');
    if (!this.get('isRegistered')) {
      this.set('avatarURL', _utils["default"].getAvatarImageURL(-1));
    } else {
      this.set('avatarURL', _utils["default"].getAvatarImageURL(memId, 80));
    }
  },
  getMemId: function getMemId() {
    return this.get('memId');
  },
  setMemId: function setMemId(id) {
    this.set('memId', id);
  },
  getTeamId: function getTeamId() {
    return this.get('teamId');
  },
  setTeamId: function setTeamId(id) {
    this.set('teamId', id);
  }
});
var _default = exports["default"] = MDMemberInfo;

},{"108":108,"1184":1184,"1454":1454,"278":278}],262:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMCollectionBase = _interopRequireDefault(require(20));
var _MDInvitationApplicationInfo = _interopRequireDefault(require(261));
var MDInvitationApplicationInfoCollection = _MMCollectionBase["default"].extend({
  model: _MDInvitationApplicationInfo["default"],
  comparator: function comparator(info) {
    return -info.get('updateTime');
  }
});
var _default = exports["default"] = MDInvitationApplicationInfoCollection;

},{"1184":1184,"1454":1454,"20":20,"261":261}],261:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require(1180));
require(1437);
require(1439);
require(1461);
require(1424);
var _MMModelBase = _interopRequireDefault(require(21));
var _MDMessageType = _interopRequireDefault(require(271));
var _MMModelBase$extend;
var MDInvitationApplicationInfo = _MMModelBase["default"].extend((_MMModelBase$extend = {
  defaults: {
    'notificationType': '',
    'notificationContent': {
      'fileId': '-1',
      'inviterId': '-1',
      'inviterName': '',
      'memberDescription': '',
      'memberShip': 0,
      'roleId': 0,
      'teamId': '-1',
      'teamName': '',
      'updateTime': new Date().getTime(),
      'userAlias': '',
      'userId': '-1',
      'userName': '',
      'acceptedEmails': [],
      'enterpriseId': '-1',
      'fileName': '',
      // 'id': 0,
      'ownerId': '-1',
      'processed': 0,
      /**
       * @typedef {object} UserInfor
       * @property {string} email
       * @property {stirng} phone
       * @property {string} name
       * @property {string} userId
       */
      /**
       * @type {Array<UserInfor>}
       */
      'targetUserInfos': [],
      'toRoleId': 0,
      'type': 0,
      'message': {},
      /**
       * message{
       *   type: 0/1,
       *   title: "",
       *   text: "",
       *   userId: "-1",
       *   operationType: "-1",
       *
       * }
       */
      'id': "-1"
    }
  },
  getNotificationType: function getNotificationType() {
    var notitype = this.get('notificationType');
    if (notitype == "UNKNOWN") {
      var type = this.getType();
      if (type == 21) {
        notitype = "SHARE_OUTOFDATE";
      } else if (type == 101) {
        notitype = "QUICKSEND_FILE_REVIEW";
      }
    }
    return notitype;
  },
  getType: function getType() {
    return this.get('notificationContent')['type'];
  },
  getMembership: function getMembership() {
    return this.get('notificationContent')['membership'];
  },
  getTeamName: function getTeamName() {
    return this.get('notificationContent')['teamName'];
  },
  getUserName: function getUserName() {
    return this.get('notificationContent')['userName'];
  },
  getUserInfoName: function getUserInfoName() {
    return this.get('notificationContent')['userInfo'] && this.get('notificationContent')['userInfo']['name'];
  },
  getFileName: function getFileName() {
    return this.get('notificationContent')['fileName'];
  },
  getTeamId: function getTeamId() {
    return this.get('notificationContent')['teamId'];
  },
  getUserId: function getUserId() {
    return this.get('notificationContent')['userId'];
  },
  getFileId: function getFileId() {
    return this.get('notificationContent')['fileId'];
  },
  getMsgFileId: function getMsgFileId() {
    var msg = this.getMessage();
    return msg['fileId'];
  },
  getMsgId: function getMsgId() {
    var msg = this.getMessage();
    return msg['id'];
  },
  getId: function getId() {
    return this.get('notificationContent')['id'];
  },
  getMessage: function getMessage() {
    return this.get('notificationContent')['message'] || {};
  },
  getTargetEmails: function getTargetEmails() {
    return this.get('notificationContent')['targetEmails'];
  },
  getTargetUserInfos: function getTargetUserInfos() {
    return this.get('notificationContent')['targetUserInfos'];
  },
  getUpdateTime: function getUpdateTime() {
    var time = new Date(this.get('notificationContent')['updateTime'] * 1000);
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    var d = time.getDate();
    time = y + '-' + this.add0(m) + '-' + this.add0(d);
    return time;
  },
  add0: function add0(m) {
    return m < 10 ? '0' + m : m;
  },
  isInvitation: function isInvitation() {
    var type = this.getMembership();
    return type == 1;
  },
  isApplication: function isApplication() {
    var type = this.getMembership();
    return type == 2;
  },
  getXXMessage: function getXXMessage() {
    /**
     *
     */
    var message = this.getMessage();
    return message;
  },
  getNotificationContent: function getNotificationContent() {
    return this.get("notificationContent");
  },
  getMsgObj: function getMsgObj() {
    var notificationContent = this.getNotificationContent();
    return notificationContent["message"] || {};
  },
  getExpirationDate: function getExpirationDate() {
    var notificationContent = this.getNotificationContent();
    var date_val = notificationContent["expirationDate"];
    var time = new Date(date_val * 1000);
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    var d = time.getDate();
    time = y + '-' + this.add0(m) + '-' + this.add0(d);
    return time;
  },
  getMsgType: function getMsgType() {
    var msgObj = this.getMsgObj();
    return msgObj["operationType"];
  },
  getMsgTeamId: function getMsgTeamId() {
    var msgObj = this.getMsgObj();
    return msgObj["teamId"];
  },
  getMsgRequestShareId: function getMsgRequestShareId() {
    var msgObj = this.getMsgObj();
    return msgObj["requestShareId"];
  },
  getMsgText: function getMsgText() {
    var msgObj = this.getMsgObj();
    return msgObj["text"];
  },
  getMsgProjectFolderId: function getMsgProjectFolderId() {
    var msgObj = this.getMsgObj();
    var type = this.get("notificationType");
    if (type == "TRANSMITTAL_PROJECT_ADD_MEMBER") {
      return msgObj["transmittalProjectFolderId"];
    } else if (type == "SEND_TRANSMITTAL") {
      if (msgObj["transmittalProject"]) {
        return msgObj["transmittalProject"]['folderId'];
      } else {
        return null;
      }
    } else {
      return msgObj["projectFolderId"];
    }
  },
  getMsgProjectName: function getMsgProjectName() {
    var msgObj = this.getMsgObj();
    var type = this.get("notificationType");
    if (type == "TRANSMITTAL_PROJECT_ADD_MEMBER") {
      return msgObj["transmittalProjectName"];
    } else if (type == "SEND_TRANSMITTAL") {
      if (msgObj["transmittalProject"]) {
        return msgObj["transmittalProject"]['transmittalTitle'];
      } else {
        return null;
      }
    } else {
      return msgObj["projectName"];
    }
  },
  getTransmittalId: function getTransmittalId() {
    var msgObj = this.getMsgObj();
    if (msgObj["transmittal"]) {
      return msgObj["transmittal"]["id"];
    } else {
      return null;
    }
  },
  getTransmittalNo: function getTransmittalNo() {
    var msgObj = this.getMsgObj();
    if (msgObj["transmittal"]) {
      return msgObj["transmittal"]["transmittalNo"];
    } else {
      return null;
    }
  },
  getMsgMessage: function getMsgMessage() {
    var msgObj = this.getMsgObj();
    return msgObj["message"];
  },
  getMsgUserName: function getMsgUserName() {
    var msgObj = this.getMsgObj();
    return msgObj["userName"];
  },
  getMsgUserId: function getMsgUserId() {
    var msgObj = this.getMsgObj();
    return msgObj["userId"];
  },
  getMsgTitle: function getMsgTitle() {
    var msgObj = this.getMsgObj();
    return msgObj["title"];
  },
  getMsgCommentId: function getMsgCommentId() {
    var msgObj = this.getMsgObj();
    return msgObj["commentId"];
  }
}, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_MMModelBase$extend, "getMsgFileId", function getMsgFileId() {
  var msgObj = this.getMsgObj();
  return msgObj["fileId"];
}), "getMsgFileName", function getMsgFileName() {
  var msgObj = this.getMsgObj();
  return msgObj["fileName"];
}), "getMsgOldFileName", function getMsgOldFileName() {
  var msgObj = this.getMsgObj();
  return msgObj["oldName"];
}), "getMsgEnterpriseName", function getMsgEnterpriseName() {
  var msgObj = this.getMsgObj();
  return msgObj["enterpriseName"];
}), "getMsgStatus", function getMsgStatus() {
  var msgObj = this.getMsgObj();
  return msgObj["status"];
}), "getMsgApplyType", function getMsgApplyType() {
  var msgObj = this.getMsgObj();
  return msgObj["applyType"];
}), "getMsgTargetType", function getMsgTargetType() {
  var msgObj = this.getMsgObj();
  return msgObj["type"];
}), "getMsgProcessed", function getMsgProcessed() {
  var msgObj = this.getMsgObj();
  return msgObj["processed"];
}), "getMsgConfirmed", function getMsgConfirmed() {
  var msgObj = this.getMsgObj();
  return msgObj["confirmed"];
}), "getMsgApprovers", function getMsgApprovers() {
  var msgObj = this.getMsgObj();
  return msgObj["approvers"];
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_MMModelBase$extend, "getMsgReceiverId", function getMsgReceiverId() {
  var msgObj = this.getMsgObj();
  return msgObj["receiverId"];
}), "getMsgApplyId", function getMsgApplyId() {
  var msgObj = this.getMsgObj();
  return msgObj["applyId"];
}), "getMsgInvitationId", function getMsgInvitationId() {
  var msgObj = this.getMsgObj();
  return msgObj["invitationId"];
}), "getMsgOperateTime", function getMsgOperateTime() {
  var msgObj = this.getMsgObj();
  return msgObj["operateTime"];
}), "getContent", function getContent() {
  try {
    var msgObj = this.getMsgObj();
    var content = msgObj["content"] || '{}';
    content = JSON.parse(content);
    if (Object.keys(content) == 0) {
      return msgObj;
    }
  } catch (e) {
    console.error(e);
  }
  return content;
}), "getContentLeaveMessage", function getContentLeaveMessage() {
  var content = this.getContent();
  return content["leaveMessage"];
}), "getDelCount", function getDelCount() {
  var content = this.getContent();
  return content["count"];
}), "getContentFileId", function getContentFileId() {
  var content = this.getContent();
  if (content.msgType == _MDMessageType["default"].MULTI_UPLOAD) {
    if (content.parentId) return content.parentId;
  } else if (content.msgType == _MDMessageType["default"].DELETE) {
    return content.files[0].fileId;
  }
  return content["fileId"];
}), "getContentFileVersion", function getContentFileVersion() {
  var content = this.getContent();
  return content["fileVersion"];
}), "getContentFileName", function getContentFileName() {
  var content = this.getContent();
  if (content.msgType == _MDMessageType["default"].MULTI_UPLOAD) {
    if (content.parentName) return content.parentName;
  } else if (content.msgType == _MDMessageType["default"].DELETE) {
    return content.files[0].fileName;
  }
  return content["fileName"];
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_MMModelBase$extend, "getContentParentName", function getContentParentName() {
  var content = this.getContent();
  return content["parentName"];
}), "getContentParentId", function getContentParentId() {
  var content = this.getContent();
  return content["parentId"];
}), "getContentBody", function getContentBody() {
  var content = this.getContent();
  var commentContent = JSON.parse(content["commentContent"]);
  return commentContent["Body"];
}), "getContentMultFile", function getContentMultFile() {
  var content = this.getContent();
  return content["multFile"];
}), "getContentFlowName", function getContentFlowName() {
  var content = this.getContent();
  return content["flowName"];
}), "getFileReviewContentBody", function getFileReviewContentBody() {
  var content = this.getContent();
  return content["content"]["Body"];
}), "getContentEndTime", function getContentEndTime() {
  var content = this.getContent();
  var updateTime = new Date((content["endTime"] - 0) * 1000) || new Date();
  return updateTime.format("yyyy-MM-dd");
}), "getContentUpdateTime", function getContentUpdateTime() {
  var content = this.getContent();
  var updateTime = new Date((content["updateTime"] - 0) * 1000) || new Date();
  return updateTime.format("yyyy-MM-dd");
}), "getContentComment", function getContentComment() {
  var content = this.getContent();
  return content["comment"];
}), "getContentStep", function getContentStep() {
  var content = this.getContent();
  return content["step"];
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])(_MMModelBase$extend, "isUserInInvitation", function isUserInInvitation(userId) {
  var content = this.getContent();
  if (content.targetIds) {
    for (var i = 0; i < content.targetIds.length; i++) {
      var id = content.targetIds[i];
      if (id == userId) {
        return true;
      }
    }
  }
  return false;
}), "getTargetUserNames", function getTargetUserNames() {
  var content = this.getContent();
  var names = "";
  if (content.targetNames) {
    names = content.targetNames.join(",");
  }
  return names;
})), {
  MEMBERSHIP_TYPE: {
    INVITED: 1,
    APPLIED: 2,
    PARTICIPANT: 3,
    TEAMMEMBER: 255
  }
});
var _default = exports["default"] = MDInvitationApplicationInfo;

},{"1180":1180,"1184":1184,"1424":1424,"1437":1437,"1439":1439,"1454":1454,"1461":1461,"21":21,"271":271}],1093:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1431);
var _MDSnackbarView = _interopRequireDefault(require(72));
/**
 * 标签相关管理请求
 * 2017.2.7
 */

var MDTagDataController = {
  _connector: null,
  _sortTags: function _sortTags(tags) {
    tags.sort(function (a, b) {
      return a['tagStr'].localeCompare(b['tagStr'], 'zh');
    });
  },
  /**
   * execute a pomelo request, with defaultParams
   * @param route {string} the method to call
   * @param msg optional {object} the parameter for the remote method
   * @param callback {function} the response callback
   */
  request: function request(route, msg, callback) {
    MDTagDataController._connector.request(route, msg, callback);
  },
  /**
   * 获取左侧栏中的标签信息
   */
  getMyFavoriteTagInfo: function getMyFavoriteTagInfo(success, fail, needCount) {
    MDTagDataController.request('netDrive.tagHandler.getMyFavoriteTagInfo', {
      needCount: needCount
    }, function (res) {
      if (res['resultCode'] === 0) {
        var tags = res['tags'];
        MDTagDataController._sortTags(tags);
        success(tags);
      } else {
        fail(res['resultCode']);
      }
    });
  },
  /**
   * 获得所有带指定标签的文件列表
   * @param {string[]} tagIds - 标签id的数组
   */
  getAllFilesWithTags: function getAllFilesWithTags(tagIds, scopeInfo, success, fail) {
    MDTagDataController.request('netDrive.tagHandler.getAllFilesWithTags', {
      'tagIds': tagIds,
      'scopeInfo': scopeInfo
    }, function (res) {
      if (res['resultCode'] === 0) {
        var files = res['list'];
        success(files);
      } else {
        fail(res['resultCode']);
      }
    });
  },
  /**
   * 为指定的文件集合设置标签
   * @param {string[]} fileIds
   * @param {string} tagId
   */
  addTagForFiles: function addTagForFiles(fileIds, tagId, customColorId, success, fail) {
    MDTagDataController.request('netDrive.tagHandler.addTagForFiles', {
      'fileIds': fileIds,
      'tagId': tagId,
      'customColorId': customColorId
    }, function (res) {
      if (res['resultCode'] === 0) {
        success();
      } else {
        fail(res['resultCode']);
        _MDSnackbarView["default"].show(res["message"]);
      }
    });
  },
  addTagsForFiles: function addTagsForFiles(fileIds, tagIds, customColorIds, success, fail) {
    MDTagDataController.request('netDrive.tagHandler.addTagsForFiles', {
      'fileIds': fileIds,
      'tagIds': tagIds,
      'customColorIds': customColorIds
    }, function (res) {
      if (res['resultCode'] === 0) {
        success();
      } else {
        fail(res['resultCode']);
        _MDSnackbarView["default"].show(res["message"]);
      }
    });
  },
  /**
   * 创建标签并且添加到指定文件
   * @param {string[]} fileIds
   * @param {string} tagStr
   * @param {string} tagColor
   */
  createTagAndAddToFile: function createTagAndAddToFile(fileIds, tagStr, tagColor, success, fail) {
    MDTagDataController.request('netDrive.tagHandler.createTagAndAddToFile', {
      'fileIds': fileIds,
      'tagStr': tagStr,
      'tagColor': tagColor
    }, function (res) {
      if (res['resultCode'] === 0) {
        success(res['tag']);
      } else {
        fail(res['resultCode']);
        _MDSnackbarView["default"].show(res["message"]);
      }
    });
  },
  createTagsAndAddToFiles: function createTagsAndAddToFiles(fileIds, tagStrs, tagColors, success, fail) {
    MDTagDataController.request('netDrive.tagHandler.createTagsAndAddToFiles', {
      'fileIds': fileIds,
      'tagStrs': tagStrs,
      'tagColors': tagColors
    }, function (res) {
      if (res['resultCode'] === 0) {
        success(res['tags']);
      } else {
        fail(res['resultCode']);
        _MDSnackbarView["default"].show(res["message"]);
      }
    });
  },
  /**
   * 为指定的文件删除指定的标签
   * @param {string} fileId
   * @param {string} tagId
   */
  removeTagFromFile: function removeTagFromFile(fileId, tagId, success, fail) {
    MDTagDataController.request('netDrive.tagHandler.removeTagFromFile', {
      'fileId': fileId,
      'tagId': tagId
    }, function (res) {
      if (res['resultCode'] === 0) {
        success();
      } else {
        fail(res['resultCode']);
      }
    });
  },
  removeTagsFromFiles: function removeTagsFromFiles(fileIds, tagIds, success, fail) {
    MDTagDataController.request('netDrive.tagHandler.removeTagsFromFiles', {
      'fileIds': fileIds,
      'tagIds': tagIds
    }, function (res) {
      if (res['resultCode'] === 0) {
        success();
      } else {
        fail(res['resultCode']);
      }
    });
  },
  /**
   * 为指定的文件删除指定的标签
   * @param {Array} fileIds
   * @param {string} tagId
   */
  removeTagFromFiles: function removeTagFromFiles(fileIds, tagId, success, fail) {
    MDTagDataController.request('netDrive.tagHandler.removeTagFromFiles', {
      'fileIds': fileIds,
      'tagId': tagId
    }, function (res) {
      if (res['resultCode'] === 0) {
        success();
      } else {
        fail(res['resultCode']);
      }
    });
  },
  /**
   * 获得所有可见标签
   */
  getAllTagsICanSee: function getAllTagsICanSee(success, fail) {
    MDTagDataController.request('netDrive.tagHandler.getAllTagsICanSee', {}, function (res) {
      if (res['resultCode'] === 0) {
        var tags = res['tags'];
        MDTagDataController._sortTags(tags);
        success(tags);
      } else {
        fail(res['resultCode']);
      }
    });
  },
  /**
   * 直接添加左侧标签
   * @param {string} tagStr
   * @param {number} tagColor
   */
  createTagForMyFavorite: function createTagForMyFavorite(tagStr, tagColor, success, fail) {
    MDTagDataController.request('netDrive.tagHandler.createTagForMyFavorite', {
      'tagStr': tagStr,
      'tagColor': tagColor
    }, function (res) {
      if (res['resultCode'] === 0) {
        success(res['tag']);
      } else {
        fail(res['resultCode']);
        _MDSnackbarView["default"].show(res["message"]);
      }
    });
  },
  /**
   * 增加我的左侧标签
   * @param {string} tagId
   */
  moveTagToMyFavorite: function moveTagToMyFavorite(tagId, success, fail) {
    MDTagDataController.request('netDrive.tagHandler.moveTagToMyFavorite', {
      'tagId': tagId
    }, function (res) {
      if (res['resultCode'] === 0) {
        success();
      } else {
        fail(res['resultCode']);
      }
    });
  },
  /**
   * 删除左侧标签
   * @param {string} tagId
   */
  moveTagOutOfMyFavorite: function moveTagOutOfMyFavorite(tagId, success, fail) {
    MDTagDataController.request('netDrive.tagHandler.moveTagOutOfMyFavorite', {
      'tagId': tagId
    }, function (res) {
      if (res['resultCode'] === 0) {
        success();
      } else {
        fail(res['resultCode']);
      }
    });
  },
  /**
   * 查找标签
   * @param {string} keyStr - 要查找的关键字
   */
  searchTags: function searchTags(keyStr, success, fail) {
    MDTagDataController.request('netDrive.tagHandler.searchTags', {
      'keyword': keyStr
    }, function (res) {
      if (res['resultCode'] === 0) {
        var tags = res['tags'];
        success(tags);
      } else {
        fail(res['resultCode']);
      }
    });
  },
  /**
   * 创建标签
   * @param {string} tagStr - 标签的内容
   * @param {number} tagColor - 标签的颜色，如 0xff0000 为红色
   */
  createNewTag: function createNewTag(tagStr, tagColor, success, fail) {
    MDTagDataController.request('netDrive.tagHandler.createNewTag', {
      'tagStr': tagStr,
      'tagColor': tagColor
    }, function (res) {
      if (res['resultCode'] === 0) {
        var tag = res['tag'];
        success(tag);
      } else {
        fail(res['resultCode']);
        _MDSnackbarView["default"].show(res["message"]);
      }
    });
  },
  /**
   * 获得我使用过的标签列表
   */
  getAllTagsIUsed: function getAllTagsIUsed(success, fail) {
    MDTagDataController.request('netDrive.tagHandler.getAllTagsIUsed', {}, function (res) {
      if (res['resultCode'] === 0) {
        var tags = res['tags'];
        MDTagDataController._sortTags(tags);
        success(tags);
      } else {
        fail && fail(res['resultCode']);
      }
    });
  },
  /**
   * 将自己标记的所有文件中使用过的指定标签更换为新的标签
   * @param {string} oldTagId - 要被替换的标签
   * @param {string} newText -
   * @param {number} newColor
   */
  changeTagsForMyMarkedFiles: function changeTagsForMyMarkedFiles(oldTagId, customColorId, newText, newColor, success, fail) {
    MDTagDataController.request('netDrive.tagHandler.changeTagsForMyMarkedFiles', {
      'oldTagId': oldTagId,
      'customColorId': customColorId,
      'newText': newText,
      'newColor': newColor
    }, function (res) {
      if (res['resultCode'] === 0) {
        success(res['tag']);
      } else {
        fail(res['resultCode']);
      }
    });
  },
  /**
   * 从我标记过的文件中移除指定标签
   * @param {string} tagId
   */
  removeTagFromAllMyMarked: function removeTagFromAllMyMarked(tagId, success, fail) {
    MDTagDataController.request('netDrive.tagHandler.removeTagFromAllMyMarkedFiles', {
      'tagId': tagId
    }, function (res) {
      if (res['resultCode'] === 0) {
        success();
      } else {
        fail(res['resultCode']);
      }
    });
  },
  /**
   * 将标签从以下地方移除
   * 1.我标记的文件标签
   * 2.我创建的标签
   * 3.我喜欢的标签
   * @param {string} tagId
   */
  removeTagFromAllMyUsed: function removeTagFromAllMyUsed(tagId, success, fail) {
    MDTagDataController.request('netDrive.tagHandler.removeTagFromAllMyUsed', {
      'tagId': tagId
    }, function (res) {
      if (res['resultCode'] === 0) {
        success();
      } else {
        fail(res['resultCode']);
      }
    });
  },
  /**
   * 为企业增加新标签
   */
  createTagForEnt: function createTagForEnt(tagStr, tagColor, success, fail) {
    MDTagDataController.request('netDrive.tagHandler.createTagForEnterprise', {
      'tagStr': tagStr,
      'tagColor': tagColor
    }, function (res) {
      if (res['resultCode'] === 0) {
        success(res['tagId']);
      } else {
        fail(res['resultCode']);
      }
    });
  },
  /**
   * 获取企业所用的所有标签
   */
  getAllTagsEntUsed: function getAllTagsEntUsed(success, fail, needCount) {
    MDTagDataController.request('netDrive.tagHandler.getAllTagsEnterpriseUsed', {
      needCount: needCount
    }, function (res) {
      if (res['resultCode'] === 0) {
        var tags = res['tags'];
        MDTagDataController._sortTags(tags);
        success(tags);
      } else {
        fail(res['resultCode']);
      }
    });
  },
  getEnterpriseTagInfo: function getEnterpriseTagInfo(success, fail) {
    MDTagDataController.request('netDrive.tagHandler.getEnterpriseTagInfo', {}, function (res) {
      if (res['resultCode'] === 0) {
        var tags = res['tags'];
        MDTagDataController._sortTags(tags);
        success(tags);
      } else {
        fail(res['resultCode']);
      }
    });
  },
  /**
   * 为企业所有文件替换标签
   * @param {string} oldTagId - 被替换的标签
   * @param {string} newText - 新的标签
   * @param {number} newColor
   */
  changeTagsForEnt: function changeTagsForEnt(oldTagId, newText, newColor, success, fail) {
    MDTagDataController.request('netDrive.tagHandler.changeTagsForEnterprise', {
      'oldTagId': oldTagId,
      'newText': newText,
      'newColor': newColor
    }, function (res) {
      if (res['resultCode'] === 0) {
        success(res['tag']);
      } else {
        fail(res['resultCode']);
      }
    });
  },
  /**
   * 去除所有企业文件中使用的某个标签
   * @param {string} tagId
   */
  removeTagFromEnt: function removeTagFromEnt(tagId, success, fail) {
    MDTagDataController.request('netDrive.tagHandler.removeTagFromEnterprise', {
      'tagId': tagId
    }, function (res) {
      if (res['resultCode'] === 0) {
        success();
      } else {
        fail(res['resultCode']);
      }
    });
  }
};
window.MDTagDataController = MDTagDataController;
var _default = exports["default"] = MDTagDataController;

},{"1184":1184,"1431":1431,"1454":1454,"72":72}],510:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDMoveProgressItemView = _interopRequireDefault(require(509));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 * 文件复制进度显示模块
 */
var MDMoveProgressWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDMoveProgressWinView, _MDWindowView);
  function MDMoveProgressWinView() {
    (0, _classCallCheck2["default"])(this, MDMoveProgressWinView);
    return _callSuper(this, MDMoveProgressWinView, arguments);
  }
  (0, _createClass2["default"])(MDMoveProgressWinView, [{
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMoveProgressWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        keys: []
      });
    }

    // className() {
    //   var superCls = super.className();
    //   return superCls + ' download-block-fix'
    // }
  }, {
    key: "initialize",
    value: function initialize(props) {
      props.needFooter = false;
      props.modal = false;
      props.title = props.title || BabelStr.str(7261);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMoveProgressWinView.prototype), "initialize", this).call(this, props);

      // Dispatcher.on(MDEvents.ClientDown_Start, this._downloadStart,this);
    }
  }, {
    key: "appendKey",
    value: function appendKey(options) {
      var _this = this;
      options.onDelItem = function (param) {
        _this.onDelItem(param);
      };
      options.onClose = function () {
        _this.close();
      };
      var item = new _MDMoveProgressItemView["default"](options);
      this.addSubView(item);
    }
  }]);
  return MDMoveProgressWinView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"509":509,"93":93}],509:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1541);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMViewBase2 = _interopRequireDefault(require(22));
var _MDAlertView = _interopRequireDefault(require(32));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 * 文件复制进度进度显示 客户端显示
 * create by jichao
 * 2019.11.26
 */
var MDMoveProgressItemView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MDMoveProgressItemView, _MMViewBase);
  function MDMoveProgressItemView() {
    (0, _classCallCheck2["default"])(this, MDMoveProgressItemView);
    return _callSuper(this, MDMoveProgressItemView, arguments);
  }
  (0, _createClass2["default"])(MDMoveProgressItemView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n      <div class=\"progress-block\">\n        <div>\n          <span class=\"title\"><%=title%>--<%=fileName%></span>\n        </div>\n        <div>\n          <div class=\"prog-ratio\"></div>\n        </div>\n        <div class=\"flex-align\">\n          <div class=\"progress-wrap progress\" data-progress-percent=\"0\">\n            <div class=\"progress-bar progress\"></div>\n          </div>\n        </div>\n        <div class=\"flex-align end completed f-hide\">\n          <button class=\"button done completed-btn\"><%=end%></button>\n        </div>\n      </div>\n    ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMoveProgressItemView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        fileName: "",
        fileId: "",
        cancelCallback: _.noop,
        needDel: false
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMoveProgressItemView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .completed-btn': this._close
      });
    }
  }, {
    key: "render",
    value: function render(data) {
      var caption = this.fileName;
      if (this.fileNum) {
        caption += BabelStr.str(20052, {
          fileNum: this.fileNum
        });
      }
      data = {
        fileName: caption,
        title: this.title || BabelStr.str(6113),
        end: this.end || BabelStr.str(6114)
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMoveProgressItemView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "_close",
    value: function _close() {
      this.onClose();
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMoveProgressItemView.prototype), "className", this).call(this);
      return superCls + ' copy-progress-win';
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMoveProgressItemView.prototype), "initialize", this).call(this, props);
      this._progressChanged();
    }
  }, {
    key: "moveProgressBar",
    value: function moveProgressBar() {
      console.log("moveProgressBar");
      var getPercent = this.$('.progress-wrap').data('progress-percent');
      var getProgressWrapWidth = this.$('.progress-wrap').width();
      var progressTotal = getPercent * getProgressWrapWidth;
      var animationLength = 400;
      this.$('.progress-bar').stop().animate({
        left: progressTotal
      }, animationLength);
    }
  }, {
    key: "_progressChanged",
    value: function _progressChanged() {
      var _this = this;
      var key = this.key;
      MMEnterpriseController.getProgressInfo(key, function (completed, total, result) {
        if (result && result.error) {
          _MDAlertView["default"].showStandardPrompt({
            message: BabelStr.str(3594) + ":" + result.error
          });
        } else {
          if (completed >= total) {
            completed = total;
          }
          var progress = completed / total;
          console.log("completed-----" + progress + " ------> key:" + key);
          if (total == 0) {
            progress = 1;
            _this.$('.prog-ratio').text('');
          } else {
            _this.$('.prog-ratio').text(completed + "/" + total);
          }
          _this.$('.progress-wrap').data('progress-percent', progress);
          _this.moveProgressBar();
          if (progress < 1) {
            setTimeout(function () {
              _this._progressChanged();
            }, 400);
          } else {
            _.isFunction(_this.onSuccess) && _this.onSuccess();
            setTimeout(function () {
              _this.$('.completed').removeClass('f-hide');
            }, 400);
          }
        }
      }, function (msg, code) {
        if (code) {
          _MDAlertView["default"].showStandardPrompt({
            message: "复制失败！" + " code:" + code + " msg:" + msg
          });
        } else {
          // 没有错误码，可能是网络或者其他错误，则继续发请求进行，不要中断
          setTimeout(function () {
            _this._progressChanged();
          }, 400);
        }
      });
    }
  }, {
    key: "close",
    value: function close() {
      this.onDelItem(this);
    }
  }]);
  return MDMoveProgressItemView;
}(_MMViewBase2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"1541":1541,"22":22,"32":32}],766:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require(1199));
require(1412);
require(1439);
require(1428);
require(1463);
require(1471);
require(1426);
require(1424);
require(1429);
require(1477);
require(1492);
require(1498);
var _asyncToGenerator2 = _interopRequireDefault(require(1172));
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDChannelType = _interopRequireDefault(require(717));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDAPIAgentInfoPageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDAPIAgentInfoPageView, _MDNavigationPageView);
  function MDAPIAgentInfoPageView() {
    (0, _classCallCheck2["default"])(this, MDAPIAgentInfoPageView);
    return _callSuper(this, MDAPIAgentInfoPageView, arguments);
  }
  (0, _createClass2["default"])(MDAPIAgentInfoPageView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n\n    <div class=\"flex-align between middle\">\n      <span class=\"item-name boldfont2 no-shrink\"> <%=BabelStr.str(50006)%></span>\n      <span class=\"copy-content fullfill\"><%=callbackUri%></span>\n      <span class=\"copy ic-copy new-icon no-shrink icon30\" data-tooltip=\"<%=BabelStr.str(2653)%>\"></span>\n    </div>\n    <div class=\"api-key-head flex-align between middle\">\n      <div>\n        <span class=\"item-name boldfont2 no-shrink\">APIKey</span>\n        <div class=\"help-block\"><%=BabelStr.str(50039)%></div>\n      </div>\n      <div class=\"button reset-key no-shrink\"><%=BabelStr.str(50040)%></div>\n    </div>\n    <div class=\"api-key-box flex-align middle\">\n      <span class=\"api-key-text fullfill\"></span>\n      <div class=\"button small copy-key no-shrink\"><%=BabelStr.str(2653)%></div>\n    </div>\n    <div class=\"flex-align between middle\">\n      <span class=\"item-name boldfont2 no-shrink\"><%=BabelStr.str(50038)%></span>\n      <span class=\"<%=fileId != 0 ? 'text-button done' : ''%> copy-content fullfill scope-path text-hide\"></span>\n    </div>\n    <div class=\"prompt-head flex-align between middle\">\n      <div>\n        <span class=\"item-name boldfont2 no-shrink\"><%=BabelStr.str(50041)%></span>\n        <div class=\"help-block\"><%=BabelStr.str(50042)%></div>\n      </div>\n      <span class=\"copy-prompt ic-copy new-icon no-shrink icon30\" data-tooltip=\"<%=BabelStr.str(2653)%>\"></span>\n    </div>\n    <div class=\"prompt-box\"></div>\n    <div class=\"split\"></div>\n    <div class=\"mgb-10 boldfont2\"><%=BabelStr.str(50043)%></div>\n    <div class=\"flex-align between middle\">\n      <span class=\"item-name boldfont2\">APP Key</span>\n      <span class=\"copy-content fullfill\"><%=appkey%></span>\n      <span class=\"copy ic-copy new-icon icon30\" data-tooltip=\"<%=BabelStr.str(2653)%>\"></span>\n    </div>\n    <div class=\"flex-align between middle\">\n      <span class=\"item-name boldfont2 no-shrink\">APP Secret</span>\n      <span class=\"copy-content fullfill\"><%=secretkey%></span>\n      <span class=\"copy ic-copy new-icon no-shrink icon30\" data-tooltip=\"<%=BabelStr.str(2653)%>\"></span>\n    </div>\n    <div class=\"mgb-10 boldfont2\"> <%=BabelStr.str(50034)%></div>\n    <div class=\"url-list\"></div>\n    <div class=\"url-input-block flex-align between gap-10 mgb-10\">\n      <input type=\"\" class=\"form-control url-input fullfill\"/>\n      <div class=\"button add-url done\"><%=BabelStr.str(5031)%></div>\n    </div>\n    <div class=\"split\"></div>\n    <div class=\"boldfont2\"><%=BabelStr.str(50007)%></div>\n    <div class=\"help-block\"><%=BabelStr.str(50008)%></div>\n    <div class=\"per-item  file-per flex-align middle gap-10\">\n      <span class=\"checkbox\"></span>\n      <div class=\"per-name \">files.metadata.write</div>\n      <div class=\"per-desc\"><%=BabelStr.str(50009)%></div>\n    </div>\n    <div class=\"per-item  file-per flex-align middle gap-10\">\n      <span class=\"checkbox\"></span>\n      <div class=\"per-name \">files.metadata.read</div>\n      <div class=\"per-desc\"><%=BabelStr.str(50010)%></div>\n    </div>\n    <div class=\"per-item file-per flex-align middle gap-10\">\n      <span class=\"checkbox\"></span>\n      <div class=\"per-name \">files.content.write</div>\n      <div class=\"per-desc\"><%=BabelStr.str(50011)%></div>\n    </div>\n    <div class=\"per-item file-per flex-align middle gap-10\">\n      <span class=\"checkbox\"></span>\n      <div class=\"per-name \">files.content.read</div>\n      <div class=\"per-desc\"><%=BabelStr.str(50012)%></div>\n    </div>\n    ";
    }
  }, {
    key: "getUrlItem",
    value: function getUrlItem(data) {
      return "<div class=\"flex-align between middle url-item mgb-10px\" data-id=\"".concat(data.id, "\">\n        <div class=\" fullfill\">").concat(data.url, "</div>\n        <div class=\"remove icon remove-url no-shrink\" data-tooltip=\"").concat(BabelStr.str(32), "\"></div>\n      </div>");
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAPIAgentInfoPageView.prototype), "className", this).call(this);
      return "".concat(superCls, " api-secret-info-page");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAPIAgentInfoPageView.prototype), "events", this).call(this);
      return _.extend(superE, {
        // 'click .account-per': this._setAccountPer,
        'click .file-per': this._setFilePer,
        "click .copy": this._copy,
        "click .copy-prompt": this._copyPrompt,
        "click .reset-key": this._resetKey,
        "click .copy-key": this._copyKey,
        "click .add-url": this._addUrl,
        "click .remove-url": this._removeUrl,
        "click .scope-path": this._openScopeFile
      });
    }
  }, {
    key: "_removeUrl",
    value: function _removeUrl($e) {
      var _this = this;
      var $item = $($e.target).closest(".url-item");
      var id = $item.data("id");
      _MMEnterpriseController["default"].deleteMcpCallbackUri(id, function () {
        // MDMessageView.success(BabelStr.str(308), this.navigationWindowView.$body)
        $item.remove();
      }, function (err) {
        MDMessageView.success(err.msg, _this.navigationWindowView.$body);
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      props.title = props.secretData.name;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAPIAgentInfoPageView.prototype), "initialize", this).call(this, props);
      this.getMcpAppCallback();
      this._getToken();
      this._fillScopePath();
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      // 模板渲染进 DOM 后才能按权限位勾选,initialize 阶段取不到 .file-per
      this.refreshPer();
    }
  }, {
    key: "_fillScopePath",
    value: function _fillScopePath() {
      var _this2 = this;
      var fileId = this.secretData.fileId;
      if (fileId == 0) {
        this.$(".scope-path").text(BabelStr.str(11));
        return;
      }
      _MMNetDiskDataController["default"].getPathById(fileId, _MDChannelType["default"].home, null, function (fileInfos) {
        var models = fileInfos.toArray().reverse(); // 根 → 文件
        // 路径根节点归属：为空或属于当前用户 → 个人文件，否则为企业文件
        var rootName = !models.length || models[0].isOwner() ? BabelStr.str(5010) : BabelStr.str(337);
        var names = models.map(function (file) {
          return file.get("fileName");
        });
        _this2.$(".scope-path").text([rootName].concat(names).join(" / "));
      });
    }
  }, {
    key: "_openScopeFile",
    value: function _openScopeFile() {
      var fileId = this.secretData.fileId;
      if (fileId == 0) return;
      app.pathRouter.openNewTabByFileId(fileId);
    }
  }, {
    key: "render",
    value: function render(data) {
      data = this.secretData;
      if (app.ep.isPrivateCloud()) {
        this.callbackUri = location.origin + "/mcp";
      } else {
        this.callbackUri = "https://www.babel.cc/mcp";
      }
      data.callbackUri = this.callbackUri;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAPIAgentInfoPageView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "getMcpAppCallback",
    value: function getMcpAppCallback() {
      var _this3 = this;
      _MMEnterpriseController["default"].getMcpAppCallback(this.secretData.id, function (mcp_callbackUris) {
        _this3.$(".url-list").empty();
        _.each(mcp_callbackUris, function (data) {
          if (data.callbackUri) {
            var item = _this3.getUrlItem({
              url: data.callbackUri,
              id: data.id
            });
            _this3.$(".url-list").append(item);
          }
        });
      }, function (err) {
        _this3.requesting = false;
        MDMessageView.success(err.msg, _this3.navigationWindowView.$body);
      });
    }
  }, {
    key: "refreshPer",
    value: function refreshPer() {
      var accountPermisson = this.secretData.accountPermisson;
      var filePermisson = this.secretData.filePermisson;
      // const $accountItems = this.$(".account-per")
      // for (let i = 0; i < $accountItems.length; i++) {
      //   if(accountPermisson & Math.pow(2, i)) {
      //     $accountItems.eq(i).addClass("checked")
      //   }
      // }
      var $fileItems = this.$(".file-per");
      for (var i = 0; i < $fileItems.length; i++) {
        if (filePermisson & Math.pow(2, i)) {
          $fileItems.eq(i).addClass("checked");
        }
      }
    }
  }, {
    key: "_setAccountPer",
    value: function _setAccountPer($e) {
      var _this4 = this;
      var $item = $($e.target).closest(".per-item");
      $item.toggleClass("checked");
      var per = 0;
      var $items = this.$(".account-per");
      for (var i = 0; i < $items.length; i++) {
        var $element = $items.eq(i);
        if ($element.hasClass("checked")) {
          per = per | Math.pow(2, i);
        }
      }
      _MMEnterpriseController["default"].updateMcpAccountPermission(per, this.secretData.id, function () {
        MDMessageView.success(BabelStr.str(308), _this4.navigationWindowView.$body);
      }, function (err) {
        _this4.requesting = false;
        MDMessageView.success(err.msg, _this4.navigationWindowView.$body);
      });
    }
  }, {
    key: "_setFilePer",
    value: function _setFilePer($e) {
      var _this5 = this;
      var $item = $($e.target).closest(".per-item");
      $item.toggleClass("checked");
      var per = 0;
      var $items = this.$(".file-per");
      for (var i = 0; i < $items.length; i++) {
        var $element = $items.eq(i);
        if ($element.hasClass("checked")) {
          per = per | Math.pow(2, i);
        }
      }
      _MMEnterpriseController["default"].updateMcpFilePermission(per, this.secretData.id, function () {
        MDMessageView.success(BabelStr.str(308), _this5.navigationWindowView.$body);
      }, function (err) {
        _this5.requesting = false;
        MDMessageView.success(err.msg, _this5.navigationWindowView.$body);
      });
    }
  }, {
    key: "_resetKey",
    value: function _resetKey() {
      this._getToken(true);
    }
  }, {
    key: "_getToken",
    value: function _getToken(reset) {
      var _this6 = this;
      if (this.requestTokening) {
        return;
      }
      this.requestTokening = true;
      _MMEnterpriseController["default"].getAccessToken(this.secretData.appkey, reset, function (appAccessCode) {
        _this6.requestTokening = false;
        _this6.apiKeyValue = appAccessCode;
        _this6._fillApiKey();
      }, function (err) {
        _this6.requestTokening = false;
        MDMessageView.error(err.msg || BabelStr.str(168), _this6.navigationWindowView.$body);
      });
    }
  }, {
    key: "_maskKey",
    value: function _maskKey(key) {
      if (!key || key.length <= 16) {
        return key;
      }
      return key.slice(0, 7) + "..." + key.slice(-9);
    }
  }, {
    key: "_fillApiKey",
    value: function _fillApiKey() {
      this.$(".api-key-text").text(this._maskKey(this.apiKeyValue));
      this._fillPrompt();
    }
  }, {
    key: "_fillPrompt",
    value: function _fillPrompt() {
      var key = this.apiKeyValue || "";
      var prompt = BabelStr.str(50044).replace("{0}", this.callbackUri || "").replace("{1}", key);
      this.promptValue = prompt;
      this.$(".prompt-box").text(BabelStr.str(50044).replace("{0}", this.callbackUri || "").replace("{1}", this._maskKey(key)));
    }
  }, {
    key: "_copyPrompt",
    value: function _copyPrompt($e) {
      var target = this.$(".prompt-box")[0];
      var full = this.promptValue;
      this.copy(target, full);
    }
  }, {
    key: "_copyKey",
    value: function _copyKey() {
      var target = this.$(".api-key-text")[0];
      var full = this.apiKeyValue;
      this.copy(target, full);
    }
  }, {
    key: "_addUrl",
    value: function _addUrl() {
      var _this7 = this;
      var val = this.$(".url-input").val().trim();
      if (!val) {
        return;
      }
      if (this.requesting) {
        return;
      }
      this.requesting = true;
      _MMEnterpriseController["default"].insertMcpAppCallback(val, this.secretData.id, function () {
        _this7.getMcpAppCallback();
        _this7.requesting = false;
        MDMessageView.success(BabelStr.str(308), _this7.navigationWindowView.$body);
        _this7.$(".url-input").val("");
      }, function (err) {
        _this7.requesting = false;
        MDMessageView.success(err.msg, _this7.navigationWindowView.$body);
      });
      this.requesting = false;
    }
  }, {
    key: "_copy",
    value: function _copy($e) {
      var target = $($e.target).siblings(".copy-content")[0];
      this.copy(target);
    }
  }, {
    key: "copy",
    value: function () {
      var _copy2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(target, text) {
        var value, textarea;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              value = text !== undefined ? text : target.textContent;
              _context.prev = 1;
              _context.next = 4;
              return navigator.clipboard.writeText(value);
            case 4:
              MDMessageView.success(BabelStr.str(50031), this.navigationWindowView.$body);
              _context.next = 15;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);
              // console.warn("现代API复制失败，尝试回退方法:", err);
              // 回退方法
              textarea = document.createElement("textarea");
              textarea.value = value;
              textarea.style.position = "fixed"; // 避免滚动
              document.body.appendChild(textarea);
              textarea.select();
              try {
                document.execCommand("copy");
                MDMessageView.success(BabelStr.str(50031), this.navigationWindowView.$body);
              } catch (fallbackErr) {
                MDMessageView.error(BabelStr.str(50032), this.navigationWindowView.$body);
              } finally {
                document.body.removeChild(textarea);
              }
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 7]]);
      }));
      function copy(_x, _x2) {
        return _copy2.apply(this, arguments);
      }
      return copy;
    }()
  }, {
    key: "_cancel",
    value: function _cancel() {
      this.getNavigationView().pop();
    }
  }]);
  return MDAPIAgentInfoPageView;
}(_MDNavigationPageView2["default"]);

},{"1098":1098,"1104":1104,"1172":1172,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1199":1199,"1412":1412,"1424":1424,"1426":1426,"1428":1428,"1429":1429,"1439":1439,"1454":1454,"1463":1463,"1471":1471,"1475":1475,"1477":1477,"1492":1492,"1498":1498,"56":56,"717":717}],760:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1412);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
var _MDSwitchView = _interopRequireDefault(require(79));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MMUserDataController = _interopRequireDefault(require(1108));
var _MDSignatureData = _interopRequireDefault(require(286));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDAlertView = _interopRequireDefault(require(32));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MDSigUploadWinView = _interopRequireDefault(require(761));
var _MDSigInputWinView = _interopRequireDefault(require(759));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDSpinnerloaderLayerView = _interopRequireDefault(require(75));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 * 签名设置
 *
 * jiang
 * 2019-03-
 */
var MDSigSettingTabPanel = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(MDSigSettingTabPanel, _MDTabPanelView);
  function MDSigSettingTabPanel() {
    (0, _classCallCheck2["default"])(this, MDSigSettingTabPanel);
    return _callSuper(this, MDSigSettingTabPanel, arguments);
  }
  (0, _createClass2["default"])(MDSigSettingTabPanel, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n      <div class=\"sig-setting\">\n      <div class=\"help-block\"><%=BabelStr.str(11300)%></div>\n      <div class=\"boldfont1 sig-title\"><%=BabelStr.str(11301)%></div>\n      <div class=\"flex-align btns\">\n        <div class=\"text-button done add-sig\"><%=BabelStr.str(11302)%></div>\n        <div class=\"text-button done upload-sig\"><%=BabelStr.str(11303)%></div>\n      </div>\n      <div class=\"sig-list sig-list-css flex-align with-wrap\"></div>\n\n      <div class=\"boldfont1 sig-title\"><%=BabelStr.str(11304)%></div>\n      <div class=\"flex-align btns\">\n        <div class=\"text-button done upload-seal\"><%=BabelStr.str(11305)%></div>\n      </div>\n      <div class=\"seal-list sig-list-css flex-align with-wrap\"></div>\n      </div>\n    ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSigSettingTabPanel.prototype), "className", this).call(this);
      return "".concat(superCls, " sig-set-tabpanel");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSigSettingTabPanel.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        // canvasWidth: 530,
        canvasWidth: 271,
        scale: 0.51 // 271 / 530
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSigSettingTabPanel.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .add-sig': this._addClicked,
        'click .del-sig': this._delClicked,
        'click .enable-active': this._setAcitveClicked,
        'click .upload-sig': this.uploadSig,
        'click .upload-seal': this.uploadSeal
      });
    }
  }, {
    key: "templData",
    value: function templData() {
      return {
        FILE_UPLOAD: 1,
        FILE_DELETE: 2,
        COMMENT: 4,
        SHARE_FILE: 8,
        SHARE_USER: 16,
        FILE_CHANGE: 32,
        'hasBindEmail': app.currentUser.hasBindEmail(),
        'notiTitle': BabelStr.str(2860),
        // 邮件通知设置
        'receiveCap': BabelStr.str(64),
        // 接受巴别鸟发送邮件到我的邮箱
        'selectCap': BabelStr.str(2354),
        // 请勾选您想选择的消息类型
        'upload': BabelStr.str(2355),
        // 文件上传
        'comment': BabelStr.str(2356),
        // 文件批注
        'shareManage': BabelStr.str(2357),
        // 分享的人员管理
        'tip': BabelStr.str(170),
        // 提示
        'bindCap': BabelStr.str(2358),
        // 您目前尚未绑定邮箱，可能无法收到通知，请尽快绑定您的邮箱。
        'bind': BabelStr.str(2359) // 去绑定
      };
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      props.data = this.templData();
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSigSettingTabPanel.prototype), "initialize", this).call(this, props);

      // var canvas = this.$('.sig-input')[0];
      // this.cxt = canvas.getContext('2d');

      if (BabelStr.getCurrentLanguage() == "en") {
        this.canvasWidth = 460;
      }
      // canvas.width = this.canvasWidth;

      // this.w = canvas.width;
      // this.h = canvas.height;
      // this.signature = new MDSignatureData();
      this.signatures = [];
      this.sigCount = 1;
      this.$('.sig-edit').hide();
      // this.$('.add-sig').hide();
    }
  }, {
    key: "uploadSig",
    value: function uploadSig() {
      var _this = this;
      var win = new _MDSigUploadWinView["default"]({
        sealType: 1,
        onAdd: function onAdd(fileId) {
          _this.onAddSeal(fileId);
        }
      });
      win.show();
    }
  }, {
    key: "uploadSeal",
    value: function uploadSeal() {
      var _this2 = this;
      var win = new _MDSigUploadWinView["default"]({
        sealType: 0,
        onAdd: function onAdd(fileId) {
          _this2.onAddSeal(fileId);
        }
        // onAdd: (signature)=>{
        //   signature.active = true
        //   if (signature.length > 0) {
        //     this.signatures.push(signature);
        //   }
        //   this.$('.sig-sec').removeClass('active');
        //   this.addSealDisp(signature, this.signatures.length);
        //   app.currentUser.signature = null;
        // }
      });
      win.show();
    }
  }, {
    key: "_addClicked",
    value: function _addClicked() {
      var _this3 = this;
      var win = new _MDSigInputWinView["default"]({
        onAdd: function onAdd(fileId) {
          _this3.onAddSeal(fileId);
        }
      });
      win.show();
    }
  }, {
    key: "onAddSeal",
    value: function onAddSeal(fileId) {
      var _this4 = this;
      _MMUserDataController["default"].getSealImage(fileId, function (res) {
        var sealInfo = res.sealInfo;
        _this4.sealInfos.push(sealInfo);
        _this4.addSealDisp(sealInfo);
        var param = {};
        var id = sealInfo.id;
        if (sealInfo.type == 0) {
          param.currentSealId = id;
        } else {
          param.currentSignId = id;
        }
        _this4.setUserCurrentSealSignatrue(param, id);
      }, function (err) {
        _MDMessageView["default"].error(err.msg || BabelStr.str(11322));
      });
    }
  }, {
    key: "onActived",
    value: function onActived() {
      var _this5 = this;
      this.$('.sig-sec').remove();
      // MMUserDataController.getMySignatures((signatures)=>{
      //   this.signatures = [];
      //   for (let i = 0; i < signatures.length; i++) {
      //     const sigData = signatures[i].signData;
      //     var sig = new MDSignatureData(signatures[i].id);
      //     sig.decodeStream(sigData);
      //     sig.setActive(signatures[i].active);

      //     this.signatures.push(sig);
      //     this.addSignatureDisp(sig, i + 1);
      //   }
      // }, ()=>{
      //   MDSnackbarView.show(BabelStr.str(168));
      // })
      _MDSpinnerloaderLayerView["default"].showIn(this.$el);
      _MMUserDataController["default"].getMySealSignature(function (res) {
        var sealInfos = res.sealInfos,
          currentSealInfo = res.currentSealInfo;
        _this5.currentSealInfo = currentSealInfo;
        _MDSpinnerloaderLayerView["default"].clearFrom(_this5.$el);
        _this5.sealInfos = sealInfos;
        for (var i = 0; i < sealInfos.length; i++) {
          var seal = sealInfos[i];
          _this5.addSealDisp(seal);
        }
      }, function () {
        _MDSpinnerloaderLayerView["default"].clearFrom(_this5.$el);
        _MDSnackbarView["default"].show(BabelStr.str(168));
      });
    }
  }, {
    key: "addSignatureDisp",
    value: function addSignatureDisp(sigs, index) {
      if (sigs.size() == 0) {
        return;
      }
      // var workSigs = sigs;
      var workSigs = new _MDSignatureData["default"]();
      workSigs.setId(sigs.getId());
      workSigs.decodeStream(sigs.encodeStream());
      workSigs.setActive(sigs.active);
      var id = sigs.getId();
      var $sigSec = $('<div class="sig-sec border1" data-id="' + id + '">' + '<div class="help-block sig-btn">' + "<span class=\"sig-active\">".concat(BabelStr.str(5025), "</span>") + '<button class="enable-active blue-text-link-btn" data-id="' + id + '">' + BabelStr.str(5026) + '</button>' + '</div>' + '<canvas class="" width="' + this.canvasWidth + 'px" height = "153px"/>' + '<button class="del-sig" data-id="' + id + '">' + BabelStr.str(32) + '</button>' + '</div>');
      this.$('.sig-list').append($sigSec);
      if (workSigs.isActive()) {
        $sigSec.addClass('active');
      } else {
        $sigSec.removeClass('active');
      }
      var $canvas = $sigSec.find('canvas');
      var ctx = $canvas[0].getContext('2d');
      for (var i = 0; i < workSigs.size(); i++) {
        var pts = workSigs.at(i);
        ctx.beginPath();
        for (var k = 0; k < pts.length; k++) {
          var pt = pts[k];
          pt.x = pt.x * this.scale;
          pt.y = pt.y * this.scale;
          if (k == 0) {
            ctx.moveTo(pt.x, pt.y);
          } else {
            ctx.lineTo(pt.x, pt.y);
          }
        }
        ctx.stroke();
      }
    }
  }, {
    key: "addSealDisp",
    value: function addSealDisp(seal, index) {
      var id = seal.id;
      var fid = seal.fileId;
      var type = seal.type;
      var cls = "";
      var $parent = this.$('.sig-list');
      var curActive = BabelStr.str(5025);
      var setActuve = BabelStr.str(5026);
      if (type == 0) {
        cls = " seal-sec";
        $parent = this.$('.seal-list');
        curActive = BabelStr.str(11306);
        setActuve = BabelStr.str(11307);
      }
      if (this.currentSealInfo && (id == this.currentSealInfo.currentSeal || id == this.currentSealInfo.currentSign)) {
        cls += " active";
      }
      var $sealec = $("<div class=\"sig-sec border1 flex-align middle center ".concat(cls, "\" data-fid=\"").concat(fid, "\" data-id=\"").concat(id, "\">") + '<div class="help-block sig-btn">' + "<span class=\"sig-active\">".concat(curActive, "</span>") + '<button class="enable-active blue-text-link-btn" data-id="' + id + '">' + setActuve + '</button>' + '</div>' + "\n                      <img src=\"".concat(seal.sealUrl, "\" alt=\"\"/>\n                      ") + '<button class="del-sig" data-id="' + id + '">' + BabelStr.str(32) + '</button>' + '</div>');
      $parent.append($sealec);
    }
  }, {
    key: "_delClicked",
    value: function _delClicked(e) {
      var target = e.target;
      var fid = $(target).closest(".sig-sec").data('fid');
      console.log('-------------- del cliked! - ' + fid);
      _MDAlertView["default"].showStandardSelection({
        message: BabelStr.str(5023),
        okFun: function okFun() {
          _MMUserDataController["default"].delSealByFileId(fid, function () {
            $(target).parent().remove();
          }, function (err) {
            if (err.code == 338) {
              _MDSnackbarView["default"].show(BabelStr.str(5024));
            } else {
              _MDSnackbarView["default"].show(err.msg || BabelStr.str(309));
            }
          });
        }
      });
    }
  }, {
    key: "_setAcitveClicked",
    value: function _setAcitveClicked(e) {
      var target = e.target;
      var id = $(target).data('id');
      var $item = $(target).closest(".sig-sec");
      var param = {};
      if ($item.hasClass("seal-sec")) {
        param.currentSealId = id;
      } else {
        param.currentSignId = id;
      }
      this.setUserCurrentSealSignatrue(param, id);
    }
  }, {
    key: "setUserCurrentSealSignatrue",
    value: function setUserCurrentSealSignatrue(param, id) {
      var _this6 = this;
      _MMUserDataController["default"].setUserCurrentSealSignatrue(param, function () {
        var $cur = _this6.$(".sig-sec[data-id=\"".concat(id, "\"]"));
        var $secs = $cur.siblings('.sig-sec');
        $secs.removeClass('active');
        $cur.addClass('active');
        app.currentUser.sealAndSig = null;
      }, function (err) {
        _MDSnackbarView["default"].show(err.msg || BabelStr.str(309));
      });
    }
  }]);
  return MDSigSettingTabPanel;
}(_MDTabPanelView2["default"]);

},{"1098":1098,"1108":1108,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1417":1417,"1454":1454,"1463":1463,"1475":1475,"286":286,"32":32,"55":55,"72":72,"75":75,"759":759,"76":76,"761":761,"79":79,"81":81,"812":812}],761:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1421);
require(1439);
require(1423);
require(1463);
require(1487);
require(1538);
require(1545);
require(1543);
require(1541);
require(1461);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDCheckboxView = _interopRequireDefault(require(37));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDSpinnerloaderLayerView = _interopRequireDefault(require(75));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDSignatureData = _interopRequireDefault(require(286));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MMUserDataController = _interopRequireDefault(require(1108));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDSigUploadWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDSigUploadWinView, _MDWindowView);
  function MDSigUploadWinView() {
    (0, _classCallCheck2["default"])(this, MDSigUploadWinView);
    return _callSuper(this, MDSigUploadWinView, arguments);
  }
  (0, _createClass2["default"])(MDSigUploadWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<div class=\"help-block\"><%=BabelStr.str(11308)%></div>\n    <div class=\"dropArea mgt-10 flex-align center middle\">\n      <div class=\"flex-align with-column center middle drop-block help-text\">\n        <p>\n         <%=uploadMsg%>\n        </p>\n        <p>\n          <%=BabelStr.str(11310)%>\n        </p>\n        <button class=\"button done selectFile\"><%=BabelStr.str(11311)%></button>\n        <input type=\"file\" class=\"file-input\" style=\"display: none;\" accept=\"image/png, image/jpg, image/jpeg\">\n      </div>\n    </div>\n    <div class=\"check-box-block mgt-10\"></div>\n    ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var props = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSigUploadWinView.prototype), "initProps", this).call(this);
      return _.extend(props, {
        sealType: 0
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSigUploadWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " upload-sig-win");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSigUploadWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .selectFile': this._selectFile
        // "change .file-input": this.handleFile,
      });
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        uploadMsg: this.sealType == 0 ? BabelStr.str(11315) : BabelStr.str(11309)
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSigUploadWinView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      // props.size = 'small';
      if (props.sealType == 0) {
        props.title = BabelStr.str(11305);
      } else {
        props.title = BabelStr.str(11303);
      }
      var self = this;
      props.buttons = [{
        label: BabelStr.str(3081),
        type: 'default'
      }, {
        label: BabelStr.str(3080),
        type: 'done',
        autoClose: false,
        onClick: function onClick(button, $e) {
          self._submit();
          return false;
        }
      }];
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSigUploadWinView.prototype), "initialize", this).call(this, props);
      this.registerDropEvents();
      this.savedFile = null;
      this.checkBox = new _MDCheckboxView["default"]({
        label: BabelStr.str(11316),
        onChanged: function onChanged(checked) {
          // this._setTransparent(checked);
          _this.useTransparent = checked;
        }
      });
      this.addSubView(this.checkBox, this.$(".check-box-block"));
    }
  }, {
    key: "_selectFile",
    value: function _selectFile($e) {
      this.$('.file-input').click();
    }
  }, {
    key: "registerDropEvents",
    value: function registerDropEvents() {
      var dropArea = this.$('.dropArea');
      var fileInput = this.$('.file-input');
      var selectFile = this.$('.selectFile');
      var self = this;
      // // 点击选择文件按钮
      // selectFile.click(function() {
      //   fileInput.click();
      // });

      // 文件选择变化
      fileInput.change(function () {
        if (this.files.length > 0) {
          self.handleFile(this.files[0]);
        }
      });

      // 拖放相关事件
      dropArea.on('dragover', function (e) {
        e.preventDefault();
        $(this).addClass("active");
      });
      dropArea.on('dragleave', function (e) {
        e.preventDefault();
        $(this).removeClass("active");
      });
      dropArea.on('drop', function (e) {
        e.preventDefault();
        $(this).removeClass("active");
        var files = e.originalEvent.dataTransfer.files;
        if (files.length > 0) {
          self.handleFile(files[0]);
        }
      });
    }

    // 处理文件
  }, {
    key: "handleFile",
    value: function handleFile(file) {
      var dropArea = this.$('.dropArea');
      var self = this;
      // 检查文件类型
      var validTypes = ['image/png', 'image/jpeg', 'image/jpg'];
      if (validTypes.indexOf(file.type) === -1) {
        _MDMessageView["default"].error(BabelStr.str(11313), this.$body);
        return;
      }
      // 检查文件大小（不超过 2MB）
      if (file.size > 2 * 1024 * 1024) {
        _MDMessageView["default"].error(BabelStr.str(11314), this.$body);
        return;
      }
      this.savedFile = file;
      this.originFile = file;
      this.fileName = file.name;
      var reader = new FileReader();
      reader.onload = function (e) {
        // 这里可以将图片显示在页面上，比如创建一个 img 标签
        var $img = self.$(".dropArea img");
        if ($img.length) {
          $img.attr('src', e.target.result);
        } else {
          $img = $('<img class="selectFile">').attr('src', e.target.result).css('max-width', '100%');
          dropArea.append($img);
        }
        // if(self.useTransparent) {
        //   $img.onload = ()=>{
        //     self.setTransparent()
        //   }
        // }
        self.$(".drop-block").addClass("f-hide");
        // dropArea.append('<br>拖入图片到区域中新建签名<br>或<br><button id="selectFile">选择文件...</button>');
        // 重新绑定选择文件按钮事件
        // $('#selectFile').click(function() {
        //   fileInput.click();
        // });
      };
      reader.readAsDataURL(file);
    }
  }, {
    key: "_setTransparent",
    value: function _setTransparent(sign) {
      this.useTransparent = sign;
      if (sign) {
        if (this.$(".dropArea img").length) {
          this.setTransparent();
        }
      } else {
        this.savedFile = this.originFile;
        var reader = new FileReader();
        reader.onload = function (e) {
          // 这里可以将图片显示在页面上，比如创建一个 img 标签
          var $img = self.$(".dropArea img");
          $img.attr('src', e.target.result);
        };
        reader.readAsDataURL(this.savedFile);
      }
    }
  }, {
    key: "setTransparent",
    value: function setTransparent(callback) {
      var self = this;
      var img = self.$(".dropArea img")[0];
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      canvas.width = img.clientWidth;
      canvas.height = img.clientHeight;

      // 绘制图片到Canvas
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      // 处理像素：白色转透明
      var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      var data = imageData.data;
      for (var i = 0; i < data.length; i += 4) {
        var r = data[i];
        var g = data[i + 1];
        var b = data[i + 2];
        if (r > 245 && g > 245 && b > 245) {
          data[i + 3] = 0; // 透明度设为0
        }
      }
      ctx.putImageData(imageData, 0, 0);
      // const base64DataUrl = canvas.toDataURL('image/png');
      // self.$(".dropArea img").attr('src', base64DataUrl)
      // window.imgUrl = base64DataUrl
      // self.savedFile = base64DataUrl
      // console.log(self.savedFile)
      canvas.toBlob(function (blob) {
        var processedUrl = URL.createObjectURL(blob);
        self.$(".dropArea img").attr('src', processedUrl);
        self.savedFile = new File([blob], self.fileName, {
          type: 'image/png'
        });
        callback && callback();
        // 注意：后续可通过 URL.revokeObjectURL(processedUrl) 释放内存
      }, 'image/png');

      // 释放内存
      // URL.revokeObjectURL(url);
    }
  }, {
    key: "calcMd5",
    value: function calcMd5(success, fail) {
      if (this.savedFile.hash) {
        success();
      } else {
        _MMNetDiskDataController["default"].calcMd5(this.savedFile, function (sign) {
          if (!sign) {
            fail();
          } else {
            // this.savedFile.hash = sign
            success();
          }
        });
      }
    }
  }, {
    key: "testTransoarent",
    value: function testTransoarent(callback) {
      if (this.useTransparent) {
        this.setTransparent(callback);
      } else {
        callback();
      }
    }
  }, {
    key: "_submit",
    value: function _submit() {
      var _this2 = this;
      if (!this.savedFile) {
        _MDMessageView["default"].error(BabelStr.str(11344), this.$body);
        return;
      }
      _MDSpinnerloaderLayerView["default"].showIn(this.$body);
      if (this.uploading) {
        return;
      }
      this.uploading = true;
      this.testTransoarent(function () {
        var tryCount = 2;
        var url, uploadToken;
        var error = function error(err) {
          console.log(err);
          if (err.code = 10005 && tryCount > 0) {
            tryCount--;
            setTimeout(function () {
              upload(url, uploadToken);
            }, 3000);
          } else {
            _this2.uploading = false;
            _MDMessageView["default"].error(err.msg || BabelStr.str(11323), _this2.$body);
            _MDSpinnerloaderLayerView["default"].clearFrom(_this2.$body);
          }
        };
        var upload = function upload(url, uploadToken) {
          var formData = new FormData();
          formData.append("file", _this2.savedFile, _this2.fileName);
          formData.append("fileName", MMCommonFun.filterFileName(_this2.fileName));
          formData.append("fileHash", _this2.savedFile.hash);
          formData.append("fileSize", _this2.savedFile.size);
          formData.append("uploadToken", uploadToken);
          var xhr = _MMNetDiskDataController["default"].getXhr();
          xhr.onload = function () {
            if (xhr.status >= 200 && xhr.status < 300) {
              console.log('请求成功（onload）', xhr.responseText);
              var response = JSON.parse(xhr.response);
              if (response["code"] == 0) {
                // this.uploadSuccess(response.fileId)
                _this2.onAdd(response.fileId);
                _this2.close();
              } else {
                error(response);
              }
            } else {
              console.log('请求失败（onload）', xhr.statusText);
              error({});
            }
          };
          xhr.open("POST", url, true);
          xhr.send(formData);
        };
        _this2.calcMd5(function () {
          _MMUserDataController["default"].filePreUpload4Seal({
            fileName: _this2.fileName,
            fileHash: _this2.savedFile.hash,
            sealType: _this2.sealType
          }, function (res) {
            console.log(res);
            url = res.url;
            uploadToken = res.uploadToken;
            upload(url, uploadToken);
          }, error);
        }, error);
      });

      // this.onAdd(this.signature)
      // this.close()
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MDSigUploadWinView';
    }
  }]);
  return MDSigUploadWinView;
}(_MDWindowView2["default"]);

},{"1104":1104,"1108":1108,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1421":1421,"1423":1423,"1439":1439,"1454":1454,"1461":1461,"1463":1463,"1475":1475,"1487":1487,"1538":1538,"1541":1541,"1543":1543,"1545":1545,"286":286,"37":37,"55":55,"75":75,"93":93}],759:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1437);
require(1439);
require(1541);
require(1461);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDSpinnerloaderLayerView = _interopRequireDefault(require(75));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MMUserDataController = _interopRequireDefault(require(1108));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // import MDSignatureData from "../../../model/MDSignatureData";
var MDSigInputWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDSigInputWinView, _MDWindowView);
  function MDSigInputWinView() {
    (0, _classCallCheck2["default"])(this, MDSigInputWinView);
    return _callSuper(this, MDSigInputWinView, arguments);
  }
  (0, _createClass2["default"])(MDSigInputWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<div class=\"sig-edit\">\n    <div class=\"help-block\"><%=BabelStr.str(5022)%></div>\n    <div class=\"border1\">\n      <canvas class=\"sig-input\" width=\"530px\" height = \"300px\"/>\n    </div>\n  </div>\n\n    ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var props = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSigInputWinView.prototype), "initProps", this).call(this);
      return _.extend(props, {
        canvasWidth: 530,
        scale: 0.51 // 271 / 530
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSigInputWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " input-sig-win sig-setting");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSigInputWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'mousedown .sig-input': this._onMouseDown,
        'mousemove .sig-input': this._onMouseMove,
        'mouseup .sig-input': this._onMouseUp,
        'touchstart .sig-input': this._onMouseDown,
        'touchmove .sig-input': this._onMouseMove,
        'touchend .sig-input': this._onMouseUp,
        'touchcancel .sig-input': this._onMouseUp
      });
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        uploadMsg: this.isSig ? BabelStr.str(11309) : BabelStr.str(11315)
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSigInputWinView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      props.width = 590;
      props.title = BabelStr.str(11302);
      props.buttons = [{
        label: BabelStr.str(3081),
        type: 'default'
      }, {
        label: BabelStr.str(3080),
        type: 'done',
        autoClose: false,
        onClick: function onClick(button, $e) {
          this._saveClicked();
        }
      }];
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSigInputWinView.prototype), "initialize", this).call(this, props);
      // this.signature = new MDSignatureData();
      var canvas = this.$('.sig-input')[0];
      this.cxt = canvas.getContext('2d');
      if (BabelStr.getCurrentLanguage() == "en") {
        this.canvasWidth = 460;
      }
      canvas.width = this.canvasWidth;
      this.w = canvas.width;
      this.h = canvas.height;
    }
  }, {
    key: "calcMd5",
    value: function calcMd5(success, fail) {
      if (this.savedFile.hash) {
        success();
      } else {
        _MMNetDiskDataController["default"].calcMd5(this.savedFile, function (sign) {
          if (!sign) {
            fail();
          } else {
            // this.savedFile.hash = sign
            success();
          }
        });
      }
    }
  }, {
    key: "canvasToBlobAndFile",
    value: function canvasToBlobAndFile(success, fail) {
      var canvas = this.$('.sig-input')[0];

      // 使用toBlob方法转换为Blob
      canvas.toBlob(function (blob) {
        if (blob) {
          console.log("\u8F6C\u6362\u4E3ABlob\u6210\u529F - \u7C7B\u578B: ".concat(blob.type, ", \u5927\u5C0F: ").concat(Math.round(blob.size / 1024), "KB"));
          // 从Blob创建File对象
          var fileName = "canvas-".concat(new Date().getTime(), ".png");
          var convertedFile = new File([blob], fileName, {
            type: 'image/png'
          });
          console.log("\u8F6C\u6362\u4E3AFile\u6210\u529F - \u6587\u4EF6\u540D: ".concat(convertedFile.name, ", \u5927\u5C0F: ").concat(Math.round(convertedFile.size / 1024), "KB"));
          success(convertedFile);
        } else {
          console.log('转换为Blob失败');
          fail;
        }
      }, 'image/png'); // 指定MIME类型为PNG

      console.log('开始转换Canvas内容...');
    }
  }, {
    key: "_saveClicked",
    value: function _saveClicked() {
      var _this = this;
      _MDSpinnerloaderLayerView["default"].showIn(this.$body);
      if (this.uploading) {
        return;
      }
      this.uploading = true;
      this.canvasToBlobAndFile(function (file) {
        _this.savedFile = file;
        _this.fileName = file.name;
        _this._submit();
      }, function () {
        _MDMessageView["default"].error(BabelStr.str(11323), _this.$body);
        _this.uploading = false;
      });
    }
  }, {
    key: "_submit",
    value: function _submit() {
      var _this2 = this;
      var tryCount = 2;
      var url, uploadToken;
      var error = function error(err) {
        console.log(err);
        if (err.code = 10005 && tryCount > 0) {
          tryCount--;
          setTimeout(function () {
            upload(url, uploadToken);
          }, 3000);
        } else {
          _this2.uploading = true;
          _MDMessageView["default"].error(err.msg || BabelStr.str(11323), _this2.$body);
          _MDSpinnerloaderLayerView["default"].clearFrom(_this2.$body);
        }
      };
      var upload = function upload(url, uploadToken) {
        var formData = new FormData();
        formData.append("file", _this2.savedFile, _this2.fileName);
        formData.append("fileName", MMCommonFun.filterFileName(_this2.fileName));
        formData.append("fileHash", _this2.savedFile.hash);
        formData.append("fileSize", _this2.savedFile.size);
        formData.append("uploadToken", uploadToken);
        var xhr = _MMNetDiskDataController["default"].getXhr();
        xhr.onload = function () {
          if (xhr.status >= 200 && xhr.status < 300) {
            console.log('请求成功（onload）', xhr.responseText);
            var response = JSON.parse(xhr.response);
            if (response["code"] == 0) {
              // this.uploadSuccess(response.fileId)
              _this2.onAdd(response.fileId);
              _this2.close();
            } else {
              error(response);
            }
          } else {
            console.log('请求失败（onload）', xhr.statusText);
            error({});
          }
        };
        xhr.open("POST", url, true);
        xhr.send(formData);
      };
      this.calcMd5(function () {
        _MMUserDataController["default"].filePreUpload4Seal({
          fileName: _this2.fileName,
          fileHash: _this2.savedFile.hash,
          sealType: 1
        }, function (res) {
          console.log(res);
          url = res.url;
          uploadToken = res.uploadToken;
          upload(url, uploadToken);
        }, error);
      }, error);

      // this.onAdd(this.signature)
      // this.close()
    }
  }, {
    key: "_sigEnded",
    value: function _sigEnded() {
      this._mouseDown = false;
      if (this.pts.length == 0) {
        return;
      }
      // this.signature.push(this.pts);
      this.pts = [];
    }
  }, {
    key: "_getPointPos",
    value: function _getPointPos(e) {
      if (app.isTablet()) {
        if (e.originalEvent.touches.length > 0) {
          var pos = {
            x: e.originalEvent.touches[0].clientX,
            y: e.originalEvent.touches[0].clientY
          };
          pos = MMCommonFun.convertPointBetweenElements($('body')[0], this.$('.sig-input')[0], pos);
          return pos;
        } else {
          return null;
        }
      } else {
        return {
          x: e.offsetX,
          y: e.offsetY
        };
      }
    }
  }, {
    key: "_onMouseDown",
    value: function _onMouseDown(e) {
      e.stopPropagation();
      e.preventDefault();
      var pos = this._getPointPos(e);
      var x = pos.x;
      var y = pos.y;
      console.log('x, y:' + x + ',' + y);
      this._mouseDown = true;
      this.pts = [{
        x: x,
        y: y
      }];
      this.cxt.beginPath();
      this.cxt.moveTo(x, y);
    }
  }, {
    key: "_onMouseMove",
    value: function _onMouseMove(e) {
      e.stopPropagation();
      e.preventDefault();
      var pos = this._getPointPos(e);
      var x = pos.x;
      var y = pos.y;
      if (this._mouseDown) {
        console.log('x, y:' + x + ',' + y);
        this.pts.push({
          x: x,
          y: y
        });
        this.cxt.lineTo(x, y);
        if (x >= this.w || y >= this.h) {
          this._sigEnded();
        }
        this.cxt.stroke();
      }
    }
  }, {
    key: "_onMouseUp",
    value: function _onMouseUp(e) {
      var pos = this._getPointPos(e);
      if (pos) {
        var x = pos.x;
        var y = pos.y;
        if (this._mouseDown) {
          this._mouseDown = false;
          this.pts.push({
            x: x,
            y: y
          });
          this.cxt.lineTo(x, y);
          this.cxt.stroke();
          this._sigEnded();
        }
      } else {
        this._sigEnded();
      }
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MDSigInputWinView';
    }
  }]);
  return MDSigInputWinView;
}(_MDWindowView2["default"]);

},{"1104":1104,"1108":1108,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1437":1437,"1439":1439,"1454":1454,"1461":1461,"1463":1463,"1475":1475,"1541":1541,"55":55,"75":75,"93":93}],758:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1437);
require(1482);
require(1439);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
var _MMUserDataController = _interopRequireDefault(require(1108));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDSealedFileVerifyTabPanelView = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(MDSealedFileVerifyTabPanelView, _MDTabPanelView);
  function MDSealedFileVerifyTabPanelView() {
    (0, _classCallCheck2["default"])(this, MDSealedFileVerifyTabPanelView);
    return _callSuper(this, MDSealedFileVerifyTabPanelView, arguments);
  }
  (0, _createClass2["default"])(MDSealedFileVerifyTabPanelView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n      <div class=\"boldfont1\"><%=BabelStr.str(11328)%></div>\n      <div class=\"help-block\"><%=BabelStr.str(11329)%></div>\n      <div class=\"dropArea mgt-10 flex-align center middle with-column\">\n          <div class=\"new-icon icon30 ic-local-choose\"></div>\n          <div class=\"help-text\"><%=BabelStr.str(11330)%></div>\n      </div>\n      <input type=\"file\" class=\"file-input\" style=\"display: none;\" accept=\".pdf, application/pdf\">\n      <div class=\"seal-file-list flex-align with-column\"></div>\n    ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSealedFileVerifyTabPanelView.prototype), "className", this).call(this);
      return "".concat(superCls, " seal-verify-tabpanel");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSealedFileVerifyTabPanelView.prototype), "initProps", this).call(this);
      return _.extend(superP, {});
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSealedFileVerifyTabPanelView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .dropArea': this._selectFile,
        "click .del": this._del
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSealedFileVerifyTabPanelView.prototype), "initialize", this).call(this, props);
      this.registerDropEvents();
    }
  }, {
    key: "onActived",
    value: function onActived() {
      this.$('.sig-sec').remove();
    }
  }, {
    key: "_selectFile",
    value: function _selectFile($e) {
      this.$('.file-input').click();
    }
  }, {
    key: "registerDropEvents",
    value: function registerDropEvents() {
      var dropArea = this.$('.dropArea');
      var fileInput = this.$('.file-input');
      var self = this;
      fileInput.change(function (e) {
        if (this.files.length > 0) {
          self.handleFile(this.files[0]);
        }
        e.target.value = '';
      });
      // 拖放相关事件
      dropArea.on('dragover', function (e) {
        e.preventDefault();
        $(this).addClass("active");
      });
      dropArea.on('dragleave', function (e) {
        e.preventDefault();
        $(this).removeClass("active");
      });
      dropArea.on('drop', function (e) {
        e.preventDefault();
        $(this).removeClass("active");
        var files = e.originalEvent.dataTransfer.files;
        if (files.length > 0) {
          self.handleFile(files[0]);
        }
      });
    }
  }, {
    key: "_del",
    value: function _del($e) {
      $($e.target).closest(".seal-file-item").remove();
    }
  }, {
    key: "renderSealFileItem",
    value: function renderSealFileItem(sealFile, sealSignData) {
      var sealStr = "";
      for (var i = 0; i < sealSignData.length; i++) {
        var sealSign = sealSignData[i];
        var sealInfoStr = sealSign.creatorName + "  ";
        var sealUrl = sealSign.sealUrl || '';
        if (sealUrl) {
          sealUrl = "\n          <img src=\"".concat(sealUrl, "\" alt=\"\" class=\"seal-img\"/>\n        ");
        }
        sealStr += "<div class=\"flex-align item\">\n      <div class=\"title no-shrink\">".concat(BabelStr.str(11338), ":  </div>\n      <div>\n        <div class=\"help-text flex-align\">\n          <div class=\"text-hide mgr-10\">").concat(sealSign.creatorName, "</div>\n          <div class=\"no-shrink\">(  ").concat(new Date(sealSign.sealTime.time).format("yyyy-MM-dd HH:mm:ss"), "  )</div>\n        </div>\n        ").concat(sealUrl, "\n      </div>\n    </div>");
      }
      var tmpl = "\n      <div class=\"seal-file-item\">\n        <div class=\"flex-align between\">\n          <div class=\"flex-align middle file-info\">\n            <div class=\"file-icon thumb\"></div>\n            <div class=\"name text-hide\">".concat(this.fileName, "</div>\n          </div>\n          <div class=\"text-button done del\">").concat(BabelStr.str(32), "</div>\n        </div>\n\n        <div class=\"flex-align item\">\n          <div class=\"title no-shrink\">").concat(BabelStr.str(11333), ":  </div>\n          <div class=\"help-text text-hide\">").concat(sealFile.operatorName, "</div>\n        </div>\n        <div class=\"flex-align item\">\n          <div class=\"title\">").concat(BabelStr.str(11334), ":  </div>\n          <div class=\"help-text\">").concat(new Date(sealFile.time).format("yyyy-MM-dd HH:mm:ss"), "</div>\n        </div>\n        <div class=\"flex-align item\">\n          <div class=\"title\">").concat(BabelStr.str(11335), ":  </div>\n          <div class=\"help-text\">").concat(BabelStr.str(11337), "</div>\n        </div>\n        ").concat(sealStr, "\n      </div>\n    ");
      this.$(".seal-file-list").append(tmpl);
    }
  }, {
    key: "renderErrorItem",
    value: function renderErrorItem(sealFile) {
      var tmpl = "\n      <div class=\"seal-file-item\">\n        <div class=\"flex-align between\">\n          <div class=\"flex-align middle file-info\">\n            <div class=\"file-icon thumb\"></div>\n            <div class=\"name text-hide\">".concat(this.fileName, "</div>\n          </div>\n          <div class=\"text-button done del\">").concat(BabelStr.str(32), "</div>\n        </div>\n        <div class=\"flex-align item\">\n          <div class=\"title\">").concat(BabelStr.str(11335), ":  </div>\n          <div class=\"help-text red\">").concat(BabelStr.str(11340), "</div>\n        </div>\n      </div\n    ");
      this.$(".seal-file-list").append(tmpl);
    }
    // 处理文件
  }, {
    key: "handleFile",
    value: function handleFile(file) {
      var _this = this;
      var dropArea = this.$('.dropArea');
      var self = this;
      // 检查文件类型
      var isValid = file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
      if (!isValid) {
        MDMessageView.error(BabelStr.str(11331), this.$el);
        return;
      }
      this.savedFile = file;
      this.fileName = file.name;
      this.calcMd5(function () {
        _MMUserDataController["default"].verifySeal(_this.savedFile.hash, _this.fileName, function (sealFile, sealSignData) {
          if (sealFile) {
            _this.renderSealFileItem(sealFile, sealSignData);
          } else {
            _this.renderErrorItem();
          }
        }, function () {
          _this.renderErrorItem();
        });
      });
    }
  }, {
    key: "calcMd5",
    value: function calcMd5(success, fail) {
      if (this.savedFile.hash) {
        success();
      } else {
        MMNetDiskDataController.calcMd5(this.savedFile, function (sign) {
          if (!sign) {
            fail();
          } else {
            // this.savedFile.hash = sign
            success();
          }
        });
      }
    }
  }]);
  return MDSealedFileVerifyTabPanelView;
}(_MDTabPanelView2["default"]);

},{"1108":1108,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"1482":1482,"81":81}],752:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDNavigationWindowView = _interopRequireDefault(require(92));
var _MDGroupInfo = _interopRequireDefault(require(260));
var _MDOneGroupShowView = _interopRequireDefault(require(755));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDOneGroupNavWinView = exports["default"] = /*#__PURE__*/function (_MDNavigationWindowVi) {
  (0, _inherits2["default"])(MDOneGroupNavWinView, _MDNavigationWindowVi);
  function MDOneGroupNavWinView() {
    (0, _classCallCheck2["default"])(this, MDOneGroupNavWinView);
    return _callSuper(this, MDOneGroupNavWinView, arguments);
  }
  (0, _createClass2["default"])(MDOneGroupNavWinView, [{
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneGroupNavWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        type: 2 // 0 : 新增, 1 : 编辑, 2: 转交给部门人员, 3: 转换为子项目， 4：转换为父项目  5 转交给项目人员
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      props.rootNavigationPageView = new _MDOneGroupShowView["default"](props);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneGroupNavWinView.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "pushEditProjectInfoView",
    value: function pushEditProjectInfoView(fileInfo) {
      var pageView = new MDProjectCreateInfoPageView({
        type: 1,
        fileId: fileInfo['fileId'],
        showCreateProjectSuccess: true
      });
      this.hideBackBtn = true;
      this.push(pageView);
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneGroupNavWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " one-group-win");
    }
  }]);
  return MDOneGroupNavWinView;
}(_MDNavigationWindowView["default"]);
window.showMDOneGroupNavWinView = function (groupId, groupName) {
  var _this = this;
  if (window.showMDOneGroupNavWinView.singleton) {
    return;
  }
  window.showMDOneGroupNavWinView.singleton = true;
  MMEnterpriseController.getGroupInfoById(groupId, function (group) {
    group.groupId = group.id;
    var groupInfo = new _MDGroupInfo["default"](group);
    var win = new MDOneGroupNavWinView({
      groupInfo: groupInfo,
      groupArr: [],
      onClose: function onClose() {
        window.showMDOneGroupNavWinView.singleton = false;
      }
    });
    win.show();
  }, function () {
    MDMessageView.success(BabelStr.str(2366), _this.$body);
  });
};

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"260":260,"755":755,"92":92}],750:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
require(1429);
require(1424);
require(1466);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDBindEmailNavPageView = _interopRequireDefault(require(739));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
var _MDSwitchView = _interopRequireDefault(require(79));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MMUserDataController = _interopRequireDefault(require(1108));
var _MDSnackbarView = _interopRequireDefault(require(72));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDNoticeSetTabPanelView = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(MDNoticeSetTabPanelView, _MDTabPanelView);
  function MDNoticeSetTabPanelView() {
    (0, _classCallCheck2["default"])(this, MDNoticeSetTabPanelView);
    return _callSuper(this, MDNoticeSetTabPanelView, arguments);
  }
  (0, _createClass2["default"])(MDNoticeSetTabPanelView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n    <% if(entAccept){%>\n      <% if(hasBindEmail){%>\n          <div class=\"block mail-setting\">\n            <div class=\"block-hd\"><label><%=notiTitle%></label></div>\n            <div class=\"block-bd\">\n              <div class=\"f-clb\">\n                <div class=\"f-fl\"><%=receiveCap%></div>\n                <div class=\"noti-opt f-fr\"></div>\n              </div>\n              <div><%=selectCap%></div>\n              <div class=\"type-check-wrap disabled email-checked\">\n                <div class=\"row\">\n                  <div class=\"col-12\">\n                    <span class=\"checkbox\" data-type=\"<%= FILE_UPLOAD %>\"></span>\n                    <label><%=upload%></label>\n                  </div>\n\n                </div>\n                <div class=\"row\">\n                  <div class=\"col-12\">\n                    <span class=\"checkbox\" data-type=\"<%= COMMENT %>\"></span>\n                    <label><%=comment%></label>\n                  </div>\n\n                </div>\n                <div class=\"row\">\n\n                  <div class=\"col-12\">\n                    <span class=\"checkbox\" data-type=\"<%= SHARE_USER %>\"></span>\n                    <label><%=shareManage%></label>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        <%}else{%>\n          <div class=\"block\">\n            <div class=\"block-hd\"><label><%=tip%></label></div>\n            <div class=\"warning-unbind\">\n              <%=bindCap%> <span id=\"js-bind-mail\" class=\"text-button done\"><%=bind%></span>\n            </div>\n          </div>\n        <%}%>\n      <%}%>\n      <div class=\"block mgb-20\">\n        <div class=\"block-hd\"><label><%=BabelStr.str(20172)%></label></div>\n        <div class=\"block-bd push-noti\">\n          <div class=\"type-check-wrap\">\n            <div class=\"row\">\n              <div class=\"col-4 flex-align middle\">\n                <span class=\"checkbox no-shrink\"></span>\n                <label><%=BabelStr.str(6327)%></label>\n              </div>\n              <div class=\"col-8\">\n                <div><%=BabelStr.str(4782)%></div>\n\n\n              </div>\n            </div>\n          </div>\n\n          <div class=\"help-block\"><%=BabelStr.str(4783)%></div>\n        </div>\n      </div>\n\n\n      <div class=\"block\">\n        <div class=\"block-hd\"><label><%=BabelStr.str(2861)%></label></div>\n        <div class=\"block-bd mgb-10\">\n          <div><%=BabelStr.str(2862)%></div>\n\n          <div class=\"type-check-wrap aboutme-check\">\n\n            <div class=\"row\">\n              <div class=\"col-4 flex-align middle\">\n                <span class=\"checkbox no-shrink\" data-index=\"0\" data-type=\"ABOUTME\"></span>\n                <label><%=BabelStr.str(2863)%></label>\n              </div>\n              <div class=\"col-8\">\n                <div><%=BabelStr.str(2866)%></div>\n                <div><%=BabelStr.str(2867)%></div>\n\n              </div>\n            </div>\n\n            <div class=\"row mid\">\n              <div class=\"col-4 flex-align middle\">\n                <span class=\"checkbox no-shrink\" data-index=\"1\" data-type=\"ABOUTME\"></span>\n                <label><%=BabelStr.str(2864)%></label>\n              </div>\n              <div class=\"col-8\">\n                <div><%=BabelStr.str(2869)%></div>\n                <div><%=BabelStr.str(2870)%></div>\n              </div>\n            </div>\n            <div class=\"row\">\n              <div class=\"col-4 flex-align middle\">\n                <span class=\"checkbox no-shrink\" data-index=\"2\" data-type=\"ABOUTME\"></span>\n                <label><%=BabelStr.str(6327)%></label>\n              </div>\n              <div class=\"col-8\">\n                <div><%=BabelStr.str(2868)%></div>\n\n              </div>\n            </div>\n\n          </div>\n\n\n        </div>\n      </div>\n    ";
      /*
              <div class="col-6">
                  <span class="checkbox" data-type="<%= FILE_DELETE %>"></span>
                  <label>文件删除</label>
                </div>
                <div class="col-6">
                <span class="checkbox" data-type="<%= FILE_CHANGE %>"></span>
                <label>文件移动重命名</label>
              </div>
              <div class="col-6">
                <span class="checkbox" data-type="<%= SHARE_FILE %>"></span>
                <label>分享的属性设置</label>
              </div>
       */
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDNoticeSetTabPanelView.prototype), "className", this).call(this);
      return "".concat(superCls, " notice-set-tabpanel");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDNoticeSetTabPanelView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        EMAIL_RECEIVE_FLAG: {
          FILE_UPLOAD: 1,
          FILE_DELETE: 2,
          COMMENT: 4,
          SHARE_FILE: 8,
          SHARE_USER: 16,
          FILE_CHANGE: 32
        }
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDNoticeSetTabPanelView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .email-checked .checkbox': this._typeCheckHandler,
        'click .aboutme-check .checkbox': this._aboutmeCheckedHandle,
        'click #js-bind-mail': this._gotoBindEmailClickHandler,
        'click .push-noti .checkbox': this.pushNotiCheckHandle
      });
    }
  }, {
    key: "templData",
    value: function templData() {
      return {
        FILE_UPLOAD: 1,
        FILE_DELETE: 2,
        COMMENT: 4,
        SHARE_FILE: 8,
        SHARE_USER: 16,
        FILE_CHANGE: 32,
        'hasBindEmail': app.currentUser.hasBindEmail(),
        'entAccept': app.ep.getSendMail(),
        'notiTitle': BabelStr.str(2860),
        // 邮件通知设置
        'receiveCap': BabelStr.str(64),
        // 接受巴别鸟发送邮件到我的邮箱
        'selectCap': BabelStr.str(2354),
        // 请勾选您想选择的消息类型
        'upload': BabelStr.str(2355),
        // 文件上传
        'comment': BabelStr.str(2356),
        // 文件批注
        'shareManage': BabelStr.str(2357),
        // 分享的人员管理
        'tip': BabelStr.str(170),
        // 提示
        'bindCap': BabelStr.str(2358),
        // 您目前尚未绑定邮箱，可能无法收到通知，请尽快绑定您的邮箱。
        'bind': BabelStr.str(2359) // 去绑定
      };
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      props.data = this.templData();
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDNoticeSetTabPanelView.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "onActived",
    value: function onActived() {
      if (!this.initData) {
        this.initData = true;
        this.refreshCheckState();
        this.listenTo(app.currentUser, 'change', this.emailBindHandler);
        this.refreshMailSetting();
      }
    }
  }, {
    key: "refreshMailSetting",
    value: function refreshMailSetting() {
      if (!app.currentUser.hasEmail()) {
        this.$('.mail-setting').addClass("hide");
      } else {
        this.$('.mail-setting').removeClass("hide");
      }
    }
  }, {
    key: "refreshCheckState",
    value: function refreshCheckState() {
      var _this = this;
      this.$checkWrap = this.$('.email-checked.type-check-wrap');
      this.$checkboxes = this.$('.email-checked .checkbox');
      this.$('.block').hide();
      _MDSpinnerloaderView["default"].showIn(this.$el);
      _MMUserDataController["default"].getReceiveEmailType(function (type) {
        _MDSpinnerloaderView["default"].clearFrom(_this.$el);
        _this.$('.block').show();
        var receiveEmailFlag = type ? true : false;
        app.currentUser.setReceiveEmailFlag(receiveEmailFlag);
        _this.mailNotify = new _MDSwitchView["default"]({
          onChange: function onChange(notify) {
            _this._setMailNotify(notify);
          }
        });
        _this.mailNotify.renderTo(_this.$('.noti-opt'));
        if (receiveEmailFlag) {
          _this.mailNotify.open(true);
          _this._setMailCheck(type);
          _this.$checkWrap.removeClass('disabled');
        }
      }, function () {
        _MDSpinnerloaderView["default"].clearFrom(_this.$el);
      });
      MMEnterpriseController.getMyRefuseType(function (data) {
        var type = data ? data.refuseType - 0 : 0;
        _this._setDashboardChecked(type);
        var refusePush = data ? data.refusePush : 1;
        _this.setPushNotiChecked(refusePush);
        var temp = type.toString(2);
        temp = "000" + temp;
        temp = temp.slice(temp.length - 3, temp.length);
        _this.refuseType = temp;
      });
      this._setDashboardChecked(1);
    }
  }, {
    key: "setPushNotiChecked",
    value: function setPushNotiChecked(type) {
      if (!type) {
        this.$('.push-noti .checkbox').addClass("checked");
      } else {
        this.$('.push-noti .checkbox').removeClass("checked");
      }
    }
  }, {
    key: "_setMailCheck",
    value: function _setMailCheck(type) {
      if (type & this.EMAIL_RECEIVE_FLAG.FILE_UPLOAD) {
        this.$('.checkbox[data-type="' + this.EMAIL_RECEIVE_FLAG.FILE_UPLOAD + '"]').addClass('checked');
      } else {
        this.$('.checkbox[data-type="' + this.EMAIL_RECEIVE_FLAG.FILE_UPLOAD + '"]').removeClass('checked');
      }
      if (type & this.EMAIL_RECEIVE_FLAG.FILE_DELETE) {
        this.$('.checkbox[data-type="' + this.EMAIL_RECEIVE_FLAG.FILE_DELETE + '"]').addClass('checked');
      } else {
        this.$('.checkbox[data-type="' + this.EMAIL_RECEIVE_FLAG.FILE_DELETE + '"]').removeClass('checked');
      }
      if (type & this.EMAIL_RECEIVE_FLAG.COMMENT) {
        this.$('.checkbox[data-type="' + this.EMAIL_RECEIVE_FLAG.COMMENT + '"]').addClass('checked');
      } else {
        this.$('.checkbox[data-type="' + this.EMAIL_RECEIVE_FLAG.COMMENT + '"]').removeClass('checked');
      }
      if (type & this.EMAIL_RECEIVE_FLAG.SHARE_FILE) {
        this.$('.checkbox[data-type="' + this.EMAIL_RECEIVE_FLAG.SHARE_FILE + '"]').addClass('checked');
      } else {
        this.$('.checkbox[data-type="' + this.EMAIL_RECEIVE_FLAG.SHARE_FILE + '"]').removeClass('checked');
      }
      if (type & this.EMAIL_RECEIVE_FLAG.SHARE_USER) {
        this.$('.checkbox[data-type="' + this.EMAIL_RECEIVE_FLAG.SHARE_USER + '"]').addClass('checked');
      } else {
        this.$('.checkbox[data-type="' + this.EMAIL_RECEIVE_FLAG.SHARE_USER + '"]').removeClass('checked');
      }
      if (type & this.EMAIL_RECEIVE_FLAG.FILE_CHANGE) {
        this.$('.checkbox[data-type="' + this.EMAIL_RECEIVE_FLAG.FILE_CHANGE + '"]').addClass('checked');
      } else {
        this.$('.checkbox[data-type="' + this.EMAIL_RECEIVE_FLAG.FILE_CHANGE + '"]').removeClass('checked');
      }
    }
  }, {
    key: "_setDashboardChecked",
    value: function _setDashboardChecked(type) {
      if (!(type & 1)) {
        this.$('.checkbox[data-index="0"]').addClass('checked');
      } else {
        this.$('.checkbox[data-index="0"]').removeClass('checked');
      }
      if (!(type & 2)) {
        this.$('.checkbox[data-index="1"]').addClass('checked');
      } else {
        this.$('.checkbox[data-index="1"]').removeClass('checked');
      }
      if (!(type & 4)) {
        this.$('.checkbox[data-index="2"]').addClass('checked');
      } else {
        this.$('.checkbox[data-index="2"]').removeClass('checked');
      }
    }

    /**
     * [_setEmailType 勾选和直接点击switch开关请求成功和失败后的处理不同]
     * @param {[type]} successHandler [description]
     * @param {[type]} failHandler    [description]
     */
  }, {
    key: "_setEmailType",
    value: function _setEmailType(successHandler, failHandler) {
      var type = 0;
      _.each(this.$checkboxes, function (checkbox, index) {
        if ($(checkbox).hasClass('checked')) {
          type = type | $(checkbox).attr('data-type');
        }
      });
      _MMUserDataController["default"].setReceiveEmailType(type, function () {
        successHandler && successHandler(type);
      }, function (errCode) {
        failHandler && failHandler();
      });
    }
  }, {
    key: "_setMailNotify",
    value: function _setMailNotify(notify) {
      var _this2 = this;
      if (notify) {
        this._checkAll();
        this.$checkboxes.eq(0).removeClass('checked');
      } else {
        this._clearAllCheck();
      }
      this._setEmailType(function (type) {
        _this2.$checkWrap.toggleClass('disabled');
      }, function () {
        if (notify) {
          _this2._clearAllCheck();
          _this2.mailNotify.close(true);
        } else {
          _this2._checkAll();
          _this2.mailNotify.open(true);
        }
      });
    }
  }, {
    key: "_aboutmeCheckedHandle",
    value: function _aboutmeCheckedHandle($e) {
      var _this3 = this;
      var index = $($e.target).data("index");
      var refuseTypeArr = this.refuseType.split("");
      refuseTypeArr[2 - index] = this.refuseType[2 - index] ^ 1;
      this.refuseType = refuseTypeArr.join("");
      var type = parseInt(this.refuseType, 2);
      MMEnterpriseController.setMyRefuseType(type, function () {
        _this3._setDashboardChecked(type);
        _MDSnackbarView["default"].show(BabelStr.str(308));
      }, function (msg) {
        _MDSnackbarView["default"].show(msg);
        console.log(操作失败);
      });
    }
  }, {
    key: "_typeCheckHandler",
    value: function _typeCheckHandler($e) {
      var _this4 = this;
      if (this.$checkWrap.hasClass('disabled')) {
        return;
      }
      var $checkbox = $($e.target);
      $checkbox.toggleClass('checked');
      this._setEmailType(function (type) {
        if (type == 0) {
          _this4.$checkWrap.addClass('disabled');
          _this4.mailNotify.close(true);
        }
      }, function () {
        $checkbox.toggleClass('checked');
      });
    }
  }, {
    key: "pushNotiCheckHandle",
    value: function pushNotiCheckHandle($e) {
      var $checkbox = $($e.target);
      // $checkbox.toggleClass('checked');
      var type = 1;
      if (!$checkbox.hasClass("checked")) {
        type = 0;
      }
      MMEnterpriseController.setMyRefusePush(type, function () {
        $checkbox.toggleClass('checked');
        _MDSnackbarView["default"].show(BabelStr.str(308));
      }, function (msg) {
        _MDSnackbarView["default"].show(msg);
      });
    }
  }, {
    key: "_checkAll",
    value: function _checkAll() {
      this.$checkboxes.addClass('checked');
    }
  }, {
    key: "_clearAllCheck",
    value: function _clearAllCheck() {
      this.$checkboxes.removeClass('checked');
    }
  }, {
    key: "_gotoBindEmailClickHandler",
    value: function _gotoBindEmailClickHandler() {
      var bindMailNavPageView = new _MDBindEmailNavPageView["default"]({
        sendBtnText: BabelStr.str(20034)
      });
      this.navigationWindowView.push(bindMailNavPageView);
    }
  }, {
    key: "emailBindHandler",
    value: function emailBindHandler(user) {
      if (user.hasChanged('isBindEmail')) {
        this.refresh(this.templData());
        this.refreshCheckState();
      }
    }
  }]);
  return MDNoticeSetTabPanelView;
}(_MDTabPanelView2["default"]);

},{"1104":1104,"1108":1108,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1424":1424,"1429":1429,"1437":1437,"1454":1454,"1463":1463,"1466":1466,"1475":1475,"1478":1478,"72":72,"739":739,"76":76,"79":79,"81":81}],749:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1426);
require(1423);
require(1463);
require(1538);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDButtonView = _interopRequireDefault(require(36));
var _SMSType = _interopRequireDefault(require(101));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDVerifyCodeInputView = _interopRequireDefault(require(765));
var _MDInitializePwdNavPageViewTpl = _interopRequireDefault(require(778));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDInitializePwdNavPageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDInitializePwdNavPageView, _MDNavigationPageView);
  function MDInitializePwdNavPageView() {
    (0, _classCallCheck2["default"])(this, MDInitializePwdNavPageView);
    return _callSuper(this, MDInitializePwdNavPageView, arguments);
  }
  (0, _createClass2["default"])(MDInitializePwdNavPageView, [{
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDInitializePwdNavPageView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        title: BabelStr.str(2360) //'初始化登录密码'
      });
    }
  }, {
    key: "tmpl",
    value: function tmpl() {
      return _MDInitializePwdNavPageViewTpl["default"];
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var self = this;
      props.data = {
        'phone': app.currentUser.get("originPhone")
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDInitializePwdNavPageView.prototype), "initialize", this).call(this, props);
      this.vcodeFormItemView = new _MDVerifyCodeInputView["default"]({
        targetInput: this.$('#js-phone-ipt')[0],
        verifyCodeType: _SMSType["default"].INIT_PWD,
        inputName: 'verifyCode',
        fieldName: 'phone'
      });
      this.addSubView(this.vcodeFormItemView, this.$('.vcode-form-item')[0]);
      this.resetButtonView = new _MDButtonView["default"]({
        el: this.$('#js-reset-btn'),
        onClick: function onClick() {
          self.$('form').validate().resetForm();
          return false;
        }
      });
      this.submitButtonView = new _MDButtonView["default"]({
        el: this.$('#js-submit-btn'),
        onClick: function onClick() {
          var validator = self.$('form').validate();
          if (validator.form()) {
            self.initPassword();
          }
          return false;
        }
      });
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDInitializePwdNavPageView.prototype), "viewDidRendered", this).call(this);
      this.$('form').validate({
        rules: {
          'password': {
            'required': true,
            'password': true
          },
          'passwordConfirm': {
            'required': true,
            'password': true,
            'equalTo': "#js-pwd"
          },
          'verifyCode': {
            'required': true
          }
        },
        messages: {
          'password': {
            'required': BabelStr.str(2351),
            //'请输入新密码',
            'password': BabelStr.str(2329) // '密码格式错误，密码为6到20位字母，数字组成'
          },
          'passwordConfirm': {
            'required': BabelStr.str(2352),
            //'请输入确认密码',
            'password': BabelStr.str(2329),
            // ''密码格式错误，密码为6到20位字母，数字组成',
            'equalTo': BabelStr.str(2353) // ''两次输入的密码不一致'
          },
          'verifyCode': {
            'required': BabelStr.str(2361) // '请输入验证码'
          }
        }
      });
    }
  }, {
    key: "controlActionButton",
    value: function controlActionButton(disabled) {
      this.resetButtonView.setDisabled(disabled);
      this.submitButtonView.setDisabled(disabled);
    }
  }, {
    key: "initPassword",
    value: function initPassword() {
      this.controlActionButton(true);
      var formData = this.$('form').serializeArray();
      var data = _.object(_.map(formData, _.values));
      var validator = this.$('form').validate();
      var self = this;
      $.ajax({
        url: "/user/initPassword.do",
        data: formData,
        method: 'post',
        success: function success(data) {
          if (data['success']) {
            app.currentUser.set('needChangePassword', false);
            self.navigationWindowView.pop();
          } else {
            var code = data['code'];
            if (code == 234 || code == 238) {
              validator.showErrors({
                'verifyCode': code['msg']
              });
            }
          }
        },
        complete: function complete() {
          self.controlActionButton(false);
        }
      });
    }
  }]);
  return MDInitializePwdNavPageView;
}(_MDNavigationPageView2["default"]);

},{"101":101,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1423":1423,"1426":1426,"1454":1454,"1463":1463,"1475":1475,"1538":1538,"36":36,"56":56,"765":765,"778":778}],778:[function(require,module,exports){
module.exports = '<div class="block block-center bind-section">\  <div class="block-bd">\    <div class="help-block"><%=BabelStr.str(7326)%></div>\    <form>\      <div class="block-center initialize-pwd-section">\        <div class="form-item">\          <input id="js-pwd" type="password" name="password" class="form-control" placeholder="<%=BabelStr.str(394)%>">\        </div>\        <div class="form-item">\          <input type="password" name="passwordConfirm" class="form-control" placeholder="<%=BabelStr.str(2344)%>">\        </div>\        <div class="form-item vcode-form-item">\        </div>\        <div class="class form-item hide">\          <input id="js-phone-ipt" name="phone" type="text" value="<%=phone%>" class="hidden form-control">\        </div>\        <div class="form-button-groups with-btn-right">\          <button id="js-reset-btn" class="button default"><%=BabelStr.str(3088)%></button>\          <button id="js-submit-btn" class="button done"><%=BabelStr.str(3096)%></button>\        </div>\      </div>\    </form>\  </div>\</div>';
},{}],748:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
var _MDDepFilePermissionWinView = _interopRequireDefault(require(565));
var _MMViewBase = _interopRequireDefault(require(22));
var _FileAddPerItemView = _interopRequireDefault(require(730));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDFileAddPerSettingPanelView = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(MDFileAddPerSettingPanelView, _MDTabPanelView);
  function MDFileAddPerSettingPanelView() {
    (0, _classCallCheck2["default"])(this, MDFileAddPerSettingPanelView);
    return _callSuper(this, MDFileAddPerSettingPanelView, arguments);
  }
  (0, _createClass2["default"])(MDFileAddPerSettingPanelView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n\t\t\t<div class=\"empty flex-align center middle\">\n\t\t\t\t<span><%=BabelStr.str(2617)%></span>\n\t\t\t</div>\t\t\t\n\t\t\t<div class=\"mgb-10 boldfont2 header-line\"><%=BabelStr.str(2614)%></div>\t\t\t\n\t\t\t<div class=\"file-list\">\n\t\t\t\t\n\t\t\t</div>";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileAddPerSettingPanelView.prototype), "className", this).call(this);
      return superCls + ' email-setting-panel';
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFileAddPerSettingPanelView.prototype), "initialize", this).call(this, opt);
      this.$('.empty').hide();
    }
  }, {
    key: "onActived",
    value: function onActived() {
      if (!this.initData) {
        this.initData = true;
        this.getMyAppendedPermissionFiles();
      }
    }
  }, {
    key: "getMyAppendedPermissionFiles",
    value: function getMyAppendedPermissionFiles() {
      var _this = this;
      var self = this;
      _MDSpinnerloaderView["default"].showIn(this.$('.file-list'));
      MMEnterpriseController.getMyAppendedPermissionFiles(function (fileInfoCollection) {
        _MDSpinnerloaderView["default"].clearFrom(_this.$('.file-list'));
        if (fileInfoCollection.length < 1) {
          _this.$('.empty').show();
          _this.$('.file-list').hide();
          _this.$('.header-line').hide();
        } else {
          fileInfoCollection.each(function (file) {
            var view = new _FileAddPerItemView["default"]({
              fileInfor: file
            });
            self.addSubView(view, self.$('.file-list'));
          });
        }
      });
    }
  }]);
  return MDFileAddPerSettingPanelView;
}(_MDTabPanelView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"22":22,"565":565,"730":730,"76":76,"81":81}],747:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1498);
require(1477);
require(1420);
require(1485);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
var _MDSwitchView = _interopRequireDefault(require(79));
var _MDSnackbarView = _interopRequireDefault(require(72));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDEmailSettingPanelView = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(MDEmailSettingPanelView, _MDTabPanelView);
  function MDEmailSettingPanelView() {
    (0, _classCallCheck2["default"])(this, MDEmailSettingPanelView);
    return _callSuper(this, MDEmailSettingPanelView, arguments);
  }
  (0, _createClass2["default"])(MDEmailSettingPanelView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n      <div class=\"email-block\">\n        <div class=\"block\">\n          <div class=\"flex-align between mgb-10\">\n            <label class=\"boldfont1\"><%=BabelStr.str(2602)%></label>\n            <div class=\"flex-align middle\">\n              <div class=\"loading f-none\">\n                (<%=BabelStr.str(2626)%>\n                <span class='load1'>.</span>\n                <span class='load2'>.</span>\n                <span class='load3'>.</span>)\n              </div>              \n              <button class=\"text-button done get-email\"><%=BabelStr.str(2608)%></button>\n            </div>\n          </div>\n          <div class=\"help-block mgb-10\"><%=BabelStr.str(2630)%></div>\n          <div class=\"block-bd\">\n            <div class=\"flex-align between mgb-10\">\n              <span><%=BabelStr.str(2603)%></span>\n              <div class=\"switch-block\"></div>\n            </div>\n            <div class=\"help-block readme\"><%=BabelStr.str(2620)%></div>\n            <div class=\"email-setting-body\">\n              <form action=\"\">\n                <div class=\"form-item row\">\n                  <label for=\"\" class=\"col-2\"><%=BabelStr.str(3084)%></label>\n                  <input type=\"text\" class=\"form-control col-10 email edit-none\" required placeholder=\"<%=BabelStr.str(2612)%>\"/>\n                  <span class=\"email col-10\"></span>\n                </div>\n                <div class=\"form-item row\">\n                  <label for=\"\" class=\"col-2\"><%=BabelStr.str(2604)%></label>\n                  <input type=\"text\" class=\"form-control col-10 host edit-none\" required placeholder=\"<%=BabelStr.str(2605)%>\"/>\n                  <span class=\"host col-10\"></span>\n                </div> \n                <div class=\"form-item row\">\n                  <label for=\"\" class=\"col-2\"><%=BabelStr.str(2606)%></label>\n                  <input type=\"text\" class=\"form-control col-10 port edit-none isNumber\" required isNumber placeholder=\"<%=BabelStr.str(2607)%>\"/>\n                  <span class=\"port col-10\"></span>\n                </div>\n                <div class=\"form-item row pwd-item edit-none\">\n                  <label for=\"\" class=\"col-2\"><%=BabelStr.str(394)%></label>\n                  <input type=\"password\" class=\"form-control col-10 pwd\" required placeholder=\"<%=BabelStr.str(2328)%>\"/>\n                </div>                    \n              </form>\n              <div class=\"btns flex-align mgt-10 end\"> \n                <button class=\"button edit-none cancel mgr-10\"><%=BabelStr.str(74)%></button>\n                <button class=\"button edit-none done save\"><%=BabelStr.str(3080)%></button>\n                <button class=\"text-button edit done\"><%=BabelStr.str(2616)%></button>\n              </div>\n\n            </div>\n          </div>\n        </div>          \n      </div>\n    ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEmailSettingPanelView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        showNavigationBar: false
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEmailSettingPanelView.prototype), "className", this).call(this);
      return superCls + ' email-setting-panel';
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEmailSettingPanelView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .get-email': this.pullUserEmail,
        'click .save': this.saveHandle,
        'blur .email': this.getEmailHost,
        'click .edit': this.edit,
        'click .cancel': this.cancleEdit
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEmailSettingPanelView.prototype), "initialize", this).call(this, props);
      this.$('.email-setting-body').hide();
      this.$('.get-email').hide();
      this.$('.readme').hide();
      this.switchView = new _MDSwitchView["default"]({
        onChange: function onChange(notify) {
          _this.switchViewChangeHandle(notify);
        }
      });
      this.switchView.renderTo(this.$('.switch-block'));
      this.getEmailSetting();
      this.$('.edit-none').hide();
    }
  }, {
    key: "edit",
    value: function edit() {
      this.$('.edit-none').show();
      this.$('.edit').hide();
      this.$('.form-item span').hide();
    }
  }, {
    key: "cancleEdit",
    value: function cancleEdit() {
      this.$('.form-item input.email').val(this.email);
      this.$('.form-item input.port').val(this.port);
      this.$('.form-item input.host').val(this.host);
      this.$('.form-item span.email').html(this.email);
      this.$('.form-item span.port').html(this.port);
      this.$('.form-item span.host').html(this.host);
      this.$('.edit-none').hide();
      this.$('.form-item span').show();
      this.$('.edit').show();
    }
  }, {
    key: "getEmailSetting",
    value: function getEmailSetting() {
      var _this2 = this;
      MMEnterpriseController.mail.getEmailSetting(function (res) {
        if (res.email) {
          _this2.email = res.email;
          _this2.port = res.port;
          _this2.host = res.host;
          _this2.cancleEdit();
          _this2.qqEmailChanged(_this2.email);
        }
        if (res.enable) {
          _this2.$('.readme').hide();
          _this2.switchView.open(true);
          _this2.$('.email-setting-body').show();
          _this2.$('.get-email').show();
        } else {
          _this2.$('.readme').show();
        }
      });
    }
  }, {
    key: "switchViewChangeHandle",
    value: function switchViewChangeHandle(sign) {
      var _this3 = this;
      MMEnterpriseController.mail.enableEmailSetting(function (res) {
        if (sign) {
          _this3.$('.email-setting-body').show();
          _this3.$('.get-email').show();
          _this3.$('.readme').hide();
        } else {
          _this3.$('.readme').show();
          _this3.$('.email-setting-body').hide();
          _this3.$('.get-email').hide();
        }
        _this3.cancleEdit();
        MDMessageView.success(BabelStr.str(308), _this3.el);
      }, function () {
        MDMessageView.error(BabelStr.str(309), _this3.el);
      });
    }
  }, {
    key: "getEmailHost",
    value: function getEmailHost() {
      var _this4 = this;
      var email = this.$('.email').val().trim();
      MMEnterpriseController.mail.getEmailHost(email, function (res) {
        _this4.$('.port').val(res.port || 110);
        _this4.$('.host').val(res.host);
        _this4.qqEmailChanged(email);
      }, function (err) {
        console.log(err);
      });
    }
  }, {
    key: "saveHandle",
    value: function saveHandle() {
      var _this5 = this;
      var email = this.$('.email').val().trim();
      var pwd = this.$('.pwd').val().trim();
      var host = this.$('.host').val().trim();
      var port = this.$('.port').val().trim();
      var reg = /^[0-9]*$/;
      if (!reg.test(port)) {
        MDMessageView.error(BabelStr.str(2640), this.el);
        return;
      }
      this.$('.save').attr('disabled', true);
      MMEnterpriseController.mail.initUserEmailSetting({
        email: email,
        host: host,
        port: port,
        password: pwd
      }, function (res) {
        MDMessageView.success(BabelStr.str(308), _this5.el);
        _this5.email = email;
        _this5.port = port;
        _this5.host = host;
        _this5.cancleEdit();
        _this5.$('.save').attr('disabled', false);
      }, function (err) {
        MDMessageView.error(err.msg, _this5.el);
        _this5.$('.save').attr('disabled', false);
      });
    }
  }, {
    key: "getEmailAddress",
    value: function getEmailAddress() {}
  }, {
    key: "isQQEmail",
    value: function isQQEmail(val) {
      return val.trim().includes('@qq.com');
    }
  }, {
    key: "qqEmailChanged",
    value: function qqEmailChanged(val) {
      if (this.isQQEmail(val)) {
        this.$('.pwd-item label').html(BabelStr.str(2631));
        this.$('.pwd-item input').attr('placeholder', BabelStr.str(2632));
      } else {
        this.$('.pwd-item label').html(BabelStr.str(394));
        this.$('.pwd-item input').attr('placeholder', BabelStr.str(2328));
      }
    }
  }, {
    key: "pullUserEmail",
    value: function pullUserEmail() {
      var _this6 = this;
      // MDMessageView.infor(BabelStr.str(2609), this.el)
      this.$('.loading').show();
      MMEnterpriseController.mail.pullUserEmail(function (res) {
        MDMessageView.success(BabelStr.str(308), _this6.el);
        _this6.$('.loading').hide();
      }, function () {
        MDMessageView.error(BabelStr.str(309), _this6.el);
        _this6.$('.loading').hide();
      });
    }
  }]);
  return MDEmailSettingPanelView;
}(_MDTabPanelView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1420":1420,"1454":1454,"1463":1463,"1475":1475,"1477":1477,"1485":1485,"1498":1498,"72":72,"79":79,"81":81}],746:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1439);
require(1421);
require(1429);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDOneGroupSettingView = _interopRequireDefault(require(754));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
var _MDOneGroupShowView = _interopRequireDefault(require(755));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDDeviceManagePanelView = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(MDDeviceManagePanelView, _MDTabPanelView);
  function MDDeviceManagePanelView() {
    (0, _classCallCheck2["default"])(this, MDDeviceManagePanelView);
    return _callSuper(this, MDDeviceManagePanelView, arguments);
  }
  (0, _createClass2["default"])(MDDeviceManagePanelView, [{
    key: "maintmpl",
    value: function maintmpl() {
      return "\n    <%if(!noLastlogin){%>\n      <div ><%=BabelStr.str(3068)%>: <span><%=time%></span> <%=BabelStr.str(2563)%> <span><%=name%></span></div>\n    <%}%>\n\n      <div class=\"online-block\">\n\n        <div class=\"flex-align between middle mgb-10\">\n          <div class=\" boldfont1\"><%=BabelStr.str(2564)%></div>\n          <div class=\"other-device\"></div>\n        </div>\n        <div class=\"list\">\n          <%for(var i = 0 ; i < deviceArr.length ; i++){%>\n            <div class=\"flex-align between item\" data-sessionid = \"<%=deviceArr[i].sessionId%>\">\n              <div>\n                <span><%=deviceArr[i].name%></span>\n                <%if(deviceArr[i].isCurrentEq){%>\n                  <span class=\"main-color font3\">(<%=BabelStr.str(2565)%>)</span>\n                <%}%>\n              </div>\n              <div class=\"flex-align between right\">\n                <div class=\"text-hide flex-align middle\"><%=deviceArr[i].clientStr%></div>\n                <div class=\"text-button done no-shrink mgl-10 exit\"><%=BabelStr.str(2566)%></div>\n              </div>\n            </div>\n          <%}%>\n        </div>\n      </div>\n    ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDeviceManagePanelView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        showNavigationBar: false,
        hideCurDevice: false,
        getDataFromServer: true
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDeviceManagePanelView.prototype), "className", this).call(this);
      return superCls + ' device-allgroup-panel';
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDeviceManagePanelView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .exit': this._exitClickHandle
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDeviceManagePanelView.prototype), "initialize", this).call(this, props);
      if (this.getDataFromServer) this.getTerminalInfosById();
      // this.otherDevice = new MDSwitchView({
      //   onChange: (notify) => {
      //     this._setotherDevice(notify);
      //   },
      // });
      // this.otherDevice.renderTo(this.$(".other-device"));

      // if (true) {
      //   this.otherDevice.open(true);
      // } else {
      //   this.otherDevice.close(true);
      // }
    }
  }, {
    key: "getTerminalInfosById",
    value: function getTerminalInfosById() {
      var _this = this;
      var userId = app.currentUser.getUserId();
      MMEnterpriseController.onlineEquipment.getTerminalInfosById(userId, function (result) {
        _this.initWithData(result);
      });
    }
  }, {
    key: "initWithData",
    value: function initWithData(result) {
      var _this2 = this;
      var data = {};
      var lastLogin = {};
      // data.time = MMCommonFun.formatTime(result.lastLoginTime);
      // if(result.name) {
      //   data.name = result.name;
      // }else {
      //   data.name = result.addr + "  ip:" + result.ip;
      // }

      data.deviceArr = [];
      var sessionArr = [];
      _.each(result, function (item) {
        if (item.sessionId == window.g_sessionId) {
          item.isCurrentEq = true;
          if (_this2.hideCurDevice) {
            return;
          }
        }
        if (_.isUndefined(lastLogin.time) || lastLogin.time < item.time) {
          if (!item.isCurrentEq) {
            lastLogin = item;
          }
        }
        if (!item.ip) {
          item.ip = {
            ip: BabelStr.str(4770)
          };
        }
        item.clientStr = "";
        if (item.terminalType) {
          item.clientStr += "<span class=\"browser no-shrink ".concat(item.terminalType, "\"></span>");
        }
        if (item.terminalName && item.terminalName != "unknown") {
          var terminalName = item.terminalName;
          terminalName = item.terminalNumber ? BabelStr.str(item.terminalNumber) : terminalName;
          terminalName = _this2.checkTerminalName(terminalName);
          item.clientStr += "<span>".concat(terminalName, "</span>");
        } else {
          return;
        }
        if (!item.name) {
          item.addr = item.addr ? item.addr : "";
          item.name = "ip:" + item.ip.ip + item.addr;
        }
        if (sessionArr.indexOf(item.sessionId) < 0) {
          data.deviceArr.push(item);
          sessionArr.push(item.sessionId);
        }
      });
      if (lastLogin.time) {
        data.time = MMCommonFun.formatTime(lastLogin.time);
        lastLogin.addr = lastLogin.addr ? lastLogin.addr : "";
        if (lastLogin.name) {
          data.name = lastLogin.name;
        } else {
          data.name = lastLogin.addr + "  ip:" + lastLogin.ip.ip;
        }
        data.noLastlogin = false;
      } else {
        data.noLastlogin = true;
      }
      var template = _.template(this.maintmpl())(data);
      this.$el.html(template);
    }
  }, {
    key: "checkTerminalName",
    value: function checkTerminalName(name) {
      if (name.indexOf("babel") == 0) {
        name = name.slice(5, name.length);
      }
      return name;
    }
  }, {
    key: "_exitClickHandle",
    value: function _exitClickHandle($e) {
      var _this3 = this;
      var id = $($e.target).closest(".item").data("sessionid");
      var option = {
        okFun: function okFun() {
          _this3.logoutById(id);
        },
        message: BabelStr.str(2567)
      };
      _MDAlertView["default"].showStandardSelection(option);

      // let alert = new MDAlertView({
      //   title: BabelStr.str(170),
      //   message: BabelStr.str(2567),
      //   buttons: [{
      //     label: BabelStr.str(154),
      //     type: "done",
      //     onClick: ()=>{
      //       this.logoutById(id)
      //     }
      //   }]
      // })
      // alert.show();
    }
  }, {
    key: "logoutById",
    value: function logoutById(id) {
      var _this4 = this;
      MMEnterpriseController.onlineEquipment.kickUserSession(id, function () {
        MDMessageView.success(BabelStr.str(308));
        _this4.$(".item[data-sessionid=".concat(id, "]")).remove();
      }, function () {
        MDMessageView.error(BabelStr.str(168));
      });
    }
  }]);
  return MDDeviceManagePanelView;
}(_MDTabPanelView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1421":1421,"1429":1429,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"32":32,"72":72,"754":754,"755":755,"81":81}],741:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1477);
require(1492);
require(1498);
var _MDBindPhoneNavPageView = _interopRequireDefault(require(740));
var _MDBindEmailNavPageView = _interopRequireDefault(require(739));
var _MDTabPanelView = _interopRequireDefault(require(81));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDAlertView = _interopRequireDefault(require(32));
/**
 * 修改密码
 * Created by manjun.hans
 */

var MDChangePwdTabPanelView = _MDTabPanelView["default"].extend({
  tmpl: "\n        <%if(!hasInitPwd){%>\n          <%if(phone) {%>\n            <div><%=BabelStr.str(6078)%> <span class=\"text-button done initpwd-btn\"><%=BabelStr.str(6079)%></span></div>\n          <%} else {%>\n            <div class=\"block\">\n              <div class=\"block-hd\"><label for=\"\"><%=tip%></label></div>\n              <div class=\"block-bd\">\n                <div><%=unbindCap%></div>\n                <div>\n                  <span id=\"js-bind-email\" class=\"text-button done\"><%=bindMail%></span>\n                  <span id=\"js-bind-phone\" class=\"text-button done\"><%=bindPhone%></span>\n                </div>\n              </div>\n            </div>\n          <%}%>\n        <%}else{%>\n        <div class=\"g-th-chg-pwd container\">\n          <form class=\"form-horizontal\" onsubmit=\"return false\">\n            <div class=\"form-item row\">\n                <input id=\"js-oldPwd\" name=\"oldPwd\" class=\"form-control\" type=\"password\" autocomplete=\"off\" placeholder=\"<%=oldPwd%>\"/>\n                <span class=\"pwd-menu icon icon30 opend\"></span>\n            </div>\n            <div class=\"form-item row\">\n              <input id=\"js-newPwd\" name=\"newPwd\" class=\"form-control\" type=\"password\" maxlength=\"20\" autocomplete=\"off\" placeholder=\"<%=newPwd%>\"/>\n              <span class=\"pwd-menu icon icon30 opend\"></span>\n            </div>\n            <div class=\"form-item row\">\n              <input id=\"js-newPwdConfirm\" name=\"newPwdConfirm\" class=\"form-control\" type=\"password\" maxlength=\"20\" autocomplete=\"off\" placeholder=\"<%=confirmPwd%>\"/>\n              <span class=\"pwd-menu icon icon30 opend\"></span>\n            </div>\n            <div class=\"form-item row text-right\">\n                <span class=\"help-block text-button mgr-20 forget-btn\" title=\"<%=forgetPwd%>\" href=\"/account/forgetPwd.do\" target=\"_blank\"><%=forgetPwd%>?</span>\n                <button id=\"js-resetBtn\" class=\"button default mgr-10\"><%=reset%></button><button id=\"js-submitBtn\" class=\"button done\"><%=commit%></button>\n            </div>\n          </form>\n        </div>\n      <%}%>",
  className: function className() {
    var superCls = _MDTabPanelView["default"].prototype.className.call(this);
    return superCls + 'change-pwd-tabpanel';
  },
  events: function events() {
    var superE = _MDTabPanelView["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click #js-resetBtn': this.resetForm,
      'click #js-bind-email': this._gotoBindEmail,
      'click #js-bind-phone': this._gotoBindPhone,
      'click .initpwd-btn': this.initPwdClickHandler,
      'click .forget-btn': this._forgetBtnClicked,
      'click .pwd-menu': this._togglePwd
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    opt.data = {
      'hasInitPwd': app.currentUser.hasInitPwd(),
      'tip': BabelStr.str(170),
      // 提示
      'unbindCap': BabelStr.str(2341),
      // 您尚未绑定邮箱或手机号，绑定后您可以以邮箱(手机号)加密码的方式登录。
      'bindMail': BabelStr.str(2338),
      // 绑定邮箱
      'bindPhone': BabelStr.str(2323),
      // 绑定手机号
      'oldPwd': BabelStr.str(2342),
      // 旧密码
      'newPwd': BabelStr.str(2343),
      // 新密码
      'confirmPwd': BabelStr.str(2344),
      // 确认密码
      'forgetPwd': BabelStr.str(53),
      // 忘记密码
      'reset': BabelStr.str(6858),
      // 重置
      'commit': BabelStr.str(3119),
      // 提交
      'phone': app.currentUser.getPhone()
    };
    _MDTabPanelView["default"].prototype.initialize.call(this, opt);
    self.$oldPasswordInput = self.$('#js-oldPwd');
    self.$newPasswordInput = self.$('#js-newPwd');
    self.$newPasswordAgainInput = self.$('#js-newPwdConfirm');
    this.$form = this.$('form');
    this.listenTo(app.currentUser, 'change', this.userInforChanged);
  },
  _togglePwd: function _togglePwd($e) {
    if ($($e.target).closest('.pwd-menu').hasClass("opend")) {
      $($e.target).siblings('input').attr("type", 'text');
      $($e.target).closest('.pwd-menu').removeClass("opend").addClass('closed');
    } else {
      $($e.target).siblings('input').attr("type", 'password');
      $($e.target).closest('.pwd-menu').addClass("opend").removeClass('closed');
    }
  },
  resetForm: function resetForm($e) {
    // this.$('form').validate().resetForm();
    // this.$('form').get(0).reset();
    this.$('#js-oldPwd').val("").removeClass("validate-error");
    this.$('#js-newPwd').val("").removeClass("validate-error");
    this.$('#js-newPwdConfirm').val("").removeClass("validate-error");
    this.$('.validate-error').remove();
    return false;
  },
  userInforChanged: function userInforChanged(user, options) {
    if (user.hasChanged('needChangePassword')) {
      this.data.hasInitPwd = app.currentUser.hasInitPwd();
      this.refresh(this.data);
    }
  },
  _forgetBtnClicked: function _forgetBtnClicked() {
    // if (app.isInClient()) {
    //   MDAlertView.showStandardPrompt({
    //     message:"找回密码请登录网页 www.babel.cc"
    //   })
    // } else {
    // window.location.href = "/account/forgetPwd.do";
    // app.pathRouter.openNetTab('/account/forgetPwd.do');
    location.replace("/account/forgetPwd.do");
    // }
  },
  _gotoBindEmail: function _gotoBindEmail() {
    var bindMailNavPageView = new _MDBindEmailNavPageView["default"]();
    this.navigationWindowView.push(bindMailNavPageView);
  },
  _gotoBindPhone: function _gotoBindPhone() {
    var bindPhoneNavPageView = new _MDBindPhoneNavPageView["default"]();
    this.navigationWindowView.push(bindPhoneNavPageView);
  },
  /**
   * 保存修改密码按钮。
   * @param e
   */
  passwordSaveHandler: function passwordSaveHandler(e) {
    var self = this;
    var oldPassword = $.trim(self.$oldPasswordInput.val());
    var newPassword = $.trim(self.$newPasswordInput.val());
    var newPasswordAgain = $.trim(self.$newPasswordAgainInput.val());
    var userModel = app.currentUser;
    var $actionButtons = this.$('.user-operations .button');
    $actionButtons.prop('disabled', true);
    var validator = this.$("form").validate();
    userModel.changePassword(newPassword, oldPassword, {
      onBeforeRequest: function onBeforeRequest($e) {
        $actionButtons.eq(1).text(BabelStr.str(2018) + '...'); //("发送中...");
      },
      onSuccess: function onSuccess(data, textStatus, jqxhr) {
        if (data.success) {
          _MDSnackbarView["default"].show(BabelStr.str(2346)); //'密码修改成功');
          self.$('form')[0].reset();
        } else {
          var error = {
            '206': BabelStr.str(2347),
            // '旧密码错误',
            '207': BabelStr.str(2348) // '您还未登录'
          };
          var errMsg = error[data.code];
          if (errMsg) {
            validator.showErrors({
              "oldPwd": error[data.code]
            });
          } else {
            if (data.msg) {
              errMsg = data.msg;
              validator.showErrors({
                "newPwd": errMsg
              });
            } else {
              _MDSnackbarView["default"].show(data.code + ":" + BabelStr.str(2349)); //'网络错误,请稍后重试');
            }
          }
        }
      },
      onError: function onError() {
        _MDSnackbarView["default"].show(BabelStr.str(2349)); //'网络错误,请稍后重试');
      },
      onComplete: function onComplete() {
        $actionButtons.eq(1).text(BabelStr.str(154)); // "确定");
        $actionButtons.prop('disabled', false);
      }
    });
  },
  viewDidRendered: function viewDidRendered() {
    var _this = this;
    _MDTabPanelView["default"].prototype.viewDidRendered.call(this);
    this.$oldPasswordInput.focus();
    this.$('form').validate({
      rules: {
        'oldPwd': {
          'required': true,
          'password': false,
          'min-password': true
        },
        'newPwd': {
          'required': true,
          'password': true
        },
        'newPwdConfirm': {
          'required': true,
          'password': true,
          'equalTo': "#js-newPwd"
        }
      },
      messages: {
        'oldPwd': {
          'required': BabelStr.str(2350),
          //'请输入旧密码',
          'password': BabelStr.str(2329) // '密码格式错误，密码为6到20位字母，数字组成'
        },
        'newPwd': {
          'required': BabelStr.str(2351),
          // '请输入新密码',
          'password': BabelStr.str(2329) //'密码格式错误，密码为6到20位字母，数字组成'
        },
        'newPwdConfirm': {
          'required': BabelStr.str(2352),
          // '请输入确认密码',
          'password': BabelStr.str(2329),
          //'密码格式错误，密码为6到20位字母，数字组成',
          'equalTo': BabelStr.str(2353) // '两次输入的密码不一致'
        }
      },
      // 校验成功后回调
      submitHandler: function submitHandler(form) {
        _this.passwordSaveHandler();
      }
    });
  },
  initPwdClickHandler: function initPwdClickHandler() {
    location.replace("/account/userLogout.do");
    app.syncSessionState();
  }
});
var _default = exports["default"] = MDChangePwdTabPanelView;

},{"1184":1184,"1454":1454,"1477":1477,"1492":1492,"1498":1498,"32":32,"72":72,"739":739,"740":740,"81":81}],738:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1541);
require(1498);
require(1417);
require(1463);
require(1420);
require(1485);
require(1436);
require(1546);
require(1437);
require(1478);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDOneGroupSettingView = _interopRequireDefault(require(754));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
var _MDOneGroupShowView = _interopRequireDefault(require(755));
var _MDGroupCollection = _interopRequireDefault(require(259));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDAllGroupShowView = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(MDAllGroupShowView, _MDTabPanelView);
  function MDAllGroupShowView() {
    (0, _classCallCheck2["default"])(this, MDAllGroupShowView);
    return _callSuper(this, MDAllGroupShowView, arguments);
  }
  (0, _createClass2["default"])(MDAllGroupShowView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n    <div class=\"flex-align search-wrap with-wrap group-search pdb-10\">\n      <div class=\"search-c fullfill search-box search-box-inline\">\n        <div class=\"icon-search\"></div>\n        <input id=\"search-group-name\" placeholder='<%=BabelStr.str(40077)%>'>\n      </div>\n    </div>\n      <div class=\"public-group-block\">\n        <div class=\"head-block flex-align between\">\n          <div class=\"title\"><%=title%></div>\n          <%if(app.currentUser.canCurUserManageEpGroup()){%>\n            <div class=\"new-group-btn blue-text-link-btn\" belongEnt=1><%=create%></div>\n          <%}%>\n        </div>\n        <div class=\"content-block flex-align with-wrap \">\n          <div class=\"m-empty\">\n            <div class=\"info\"><%=noGroup%></div>\n          </div>\n        </div>\n      </div>\n      <div class=\"private-group-block\">\n        <div class=\"head-block flex-align between\">\n          <div class=\"title\"><%=pGroup%></div>\n          <div class=\"new-group-btn blue-text-link-btn\" belongEnt=0><%=create%></div>\n        </div>\n        <div class=\"content-block flex-align with-wrap \">\n          <div class=\"m-empty\">\n            <div class=\"info\"><%=noGroup%></div>\n          </div>\n        </div>\n      </div>\n    ";
    }
  }, {
    key: "groupItem",
    value: function groupItem() {
      return "\n      <div class=\"group-item flex-align between  button\" data-id = \"<%=groupId%>\">\n        <div class=\"flex-align name-contain middle no-shrink\">\n          <div class=\"name no-shrink text-hide\"><%=groupName%></div>\n          <div class=\"number\">(<%=memberNum%>)</div>\n        </div>\n        <%if(app.currentUser.canCurUserManageEpGroup() && belongToEnterprise || !belongToEnterprise){%>\n        <div class=\"icon del no-shrink\"></div>\n        <%}%>\n      </div>\n    ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAllGroupShowView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        showNavigationBar: false
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAllGroupShowView.prototype), "className", this).call(this);
      return superCls + ' app-allgroup-panel';
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAllGroupShowView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .new-group-btn': this.navigationNewGroupView,
        'click .public-group-block .group-item': this.navigationToPublicOneGroupShowView,
        'click .private-group-block .group-item': this.navigationToPrivateOneGroupShowView,
        'click .del': this._delGroupItem,
        'keyup #search-group-name': this._searchInputHandle
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      if (!props.data) {
        props.data = {};
      }
      ;
      props.data = _.extend(props.data, {
        'title': BabelStr.str(2362),
        // 企业公共分组
        'create': BabelStr.str(2363),
        // 新建分组
        'noGroup': BabelStr.str(2364),
        // 暂无分组
        'pGroup': BabelStr.str(2365) // 个人私有分组
      });
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAllGroupShowView.prototype), "initialize", this).call(this, props);
      this.$pubContent = this.$(".public-group-block .content-block");
      this.$priContent = this.$(".private-group-block .content-block");
      if (!app.isEpVersion()) {
        this.$(".public-group-block").remove();
      }
    }
  }, {
    key: "_searchInputHandle",
    value: function _searchInputHandle() {
      var _this = this;
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      this.searchTimer = setTimeout(function () {
        var name = _this.$("#search-group-name").val().trim();
        _this.searchGroup(name);
      }, 400);
    }
  }, {
    key: "searchGroup",
    value: function searchGroup(val) {
      val = val.toLowerCase();
      var items = this.$(".group-item");
      for (var i = 0; i < items.length; i++) {
        var $item = items.eq(i);
        var name = $item.find(".name").text().toLowerCase();
        if (!val || name.includes(val)) {
          $item.removeClass("f-hide");
        } else {
          $item.addClass("f-hide");
        }
      }
    }
  }, {
    key: "renderGroupItem",
    value: function renderGroupItem(groupInfo) {
      var contentTmpl = _.template(this.groupItem())(groupInfo.toJSON());
      if (groupInfo.belongToEnterprise()) {
        this.$pubContent.find(".m-empty").hide();
        this.$pubContent.append(contentTmpl);
      } else {
        this.$priContent.find(".m-empty").hide();
        this.$priContent.append(contentTmpl);
      }
    }
  }, {
    key: "navigationToOneGroupShowView",
    value: function navigationToOneGroupShowView($e, belongEnt) {
      var id = $($e.target).closest(".group-item").data("id").toString();
      var groupInfo = null;
      for (var i = 0; i < this.groupInfoArr.length; i++) {
        if (this.groupInfoArr[i].groupId() == id) {
          groupInfo = this.groupInfoArr[i];
          break;
        }
      }
      ;
      var oneGroupShowView = new _MDOneGroupShowView["default"]({
        groupInfo: groupInfo,
        belongEnterprise: belongEnt,
        groupArr: this.groupInfoArr,
        ignoreIsShowingStructor: groupInfo.get('belongToEnterprise')
      });
      this.navigationWindowView.push(oneGroupShowView);
    }
  }, {
    key: "navigationToPrivateOneGroupShowView",
    value: function navigationToPrivateOneGroupShowView($e) {
      this.navigationToOneGroupShowView($e);
    }
  }, {
    key: "navigationToPublicOneGroupShowView",
    value: function navigationToPublicOneGroupShowView($e) {
      this.navigationToOneGroupShowView($e, 1);
    }
  }, {
    key: "navigationNewGroupView",
    value: function navigationNewGroupView(e) {
      var _this2 = this;
      var belongEnt = $(e.currentTarget).attr('belongEnt');
      var oneGroupSettingView = new _MDOneGroupSettingView["default"]({
        belongEnterprise: belongEnt,
        groupArr: this.groupInfoArr,
        groupAddCallback: function groupAddCallback(groupInfo) {
          _this2.navigationWindowView.pop();
        },
        onCancel: function onCancel() {
          _this2.navigationWindowView.pop();
        }
      });
      this.navigationWindowView.push(oneGroupSettingView);
    }
  }, {
    key: "getGroupsWithoutMember",
    value: function getGroupsWithoutMember() {
      var _this3 = this;
      MMEnterpriseController.getGroupsWithoutMember(function (groupArr) {
        _this3.$pubContent.children(".group-item").remove();
        _this3.$priContent.children(".group-item").remove();
        _this3.$(".m-empty").show();
        _this3._setGroupArr(groupArr);
        var collection = new _MDGroupCollection["default"](groupArr);
        collection.each(function (group) {
          _this3.renderGroupItem(group);
        });
      }, function () {
        _MDSnackbarView["default"].show(BabelStr.str(2366)); //("获取分组信息失败，请稍后重试");
      });
    }
  }, {
    key: "_addGroup",
    value: function _addGroup(groupInfo) {
      this.groupInfoArr.push(groupInfo);
      this._setGroupArr(this.groupInfoArr);
      this.renderGroupItem(groupInfo);
    }
  }, {
    key: "_setGroupArr",
    value: function _setGroupArr(arr) {
      if (this.groupArr) {
        _.each(this.groupArr, function (groupInfo) {
          groupInfo.off('change:memberNum');
        });
      }
      ;
      this.groupInfoArr = arr;
      console.log("groupInfoArr", arr);
      var self = this;
      _.each(arr, function (groupInfo) {
        groupInfo.on('change:memberNum change:groupName', self._onGroupInfoChanged, self);
      });
    }
  }, {
    key: "_onGroupInfoChanged",
    value: function _onGroupInfoChanged(groupInfo) {
      var $groupItems = this.$('.group-item');
      for (var i = 0; i < $groupItems.length; i++) {
        var $el = $($groupItems[i]);
        if ($el.attr('data-id') == groupInfo.groupId()) {
          $el.find('.number').text('(' + groupInfo.memberNum() + ')');
          $el.find('.name').text(groupInfo.groupName());
        }
        ;
      }
      ;
    }
  }, {
    key: "_delGroupItem",
    value: function _delGroupItem($e) {
      var alertOpt = {
        message: BabelStr.str(2367),
        okFun: function okFun() {
          var $curItem = $($e.target).closest(".group-item");
          var id = $curItem.data("id").toString();
          $e.stopPropagation();
          MMEnterpriseController.delGroupById(id, function () {
            if ($curItem.siblings(".group-item").length < 1) {
              $curItem.siblings(".m-empty").show();
            }
            $curItem.remove();
            Dispatcher.trigger(MDEvents.GroupDeleted, {
              groupId: id
            });
          }, function () {
            _MDSnackbarView["default"].show(BabelStr.str(5057));
          });
        }
      };
      _MDAlertView["default"].showStandardSelection(alertOpt);
      return false;
    }
  }, {
    key: "refreshGroupItem",
    value: function refreshGroupItem(groupItem) {
      id = groupItem["groupId"] || "003";
      var $curItem = this.$(".group-item[data-id='" + id + ")']");
      var contentTmpl = _.template(this.groupItem())(groupItem);
      $curItem.replaceWith(contentTmpl);
    }
  }, {
    key: "onActived",
    value: function onActived() {
      if (!this.initData) {
        this.getGroupsWithoutMember();
      }
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAllGroupShowView.prototype), "viewDidRendered", this).call(this);
    }
  }]);
  return MDAllGroupShowView;
}(_MDTabPanelView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1417":1417,"1420":1420,"1436":1436,"1437":1437,"1454":1454,"1463":1463,"1475":1475,"1478":1478,"1485":1485,"1498":1498,"1541":1541,"1546":1546,"259":259,"32":32,"72":72,"754":754,"755":755,"81":81}],754:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDOneGroupCreatePanelView = _interopRequireDefault(require(751));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDOneGroupSettingView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDOneGroupSettingView, _MDNavigationPageView);
  function MDOneGroupSettingView() {
    (0, _classCallCheck2["default"])(this, MDOneGroupSettingView);
    return _callSuper(this, MDOneGroupSettingView, arguments);
  }
  (0, _createClass2["default"])(MDOneGroupSettingView, [{
    key: "initialize",
    value: function initialize(props) {
      props.title = BabelStr.str(2363);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneGroupSettingView.prototype), "initialize", this).call(this, props);
      this.groupCreateView = new _MDOneGroupCreatePanelView["default"]({
        onCancel: this.onCancel,
        groupAddCallback: this.groupAddCallback,
        belongEnterprise: this.belongEnterprise,
        groupArr: this.groupArr
      });
      this.addSubView(this.groupCreateView);
      console.log("MDOneGroupSettingView belongEnterprise", this.belongEnterprise);
    }
  }]);
  return MDOneGroupSettingView;
}(_MDNavigationPageView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"56":56,"751":751}],751:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1498);
require(1421);
require(1432);
var _defineProperty2 = _interopRequireDefault(require(1180));
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMViewBase2 = _interopRequireDefault(require(22));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDOneGroupShowView = _interopRequireDefault(require(755));
var _MDEnterUserChooseView = _interopRequireDefault(require(459));
var _MDEnterpriseShareTabView = _interopRequireDefault(require(675));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDOneGroupCreatePanelView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MDOneGroupCreatePanelView, _MMViewBase);
  function MDOneGroupCreatePanelView() {
    (0, _classCallCheck2["default"])(this, MDOneGroupCreatePanelView);
    return _callSuper(this, MDOneGroupCreatePanelView, arguments);
  }
  (0, _createClass2["default"])(MDOneGroupCreatePanelView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n    <div class=\"group-setting-page-content new-group-panel\">\n      <form class = \"form container mgb-10\">\n        <div class=\"form-item flex-align middle\">\n          <label class=\"no-shrink mgr-10\"><%=groupName%></label>\n          <div class=\"fullfill\">\n            <input type=\"text\" class=\"form-control group-name textinput notempty\" placeholder=\"<%=placeholder%>\" maxlength = \"30\" required/>\n          </div>\n        </div>\n      </form>\n      <div class=\"user-choose-block mgb-10\"></div>\n      <div class=\"flex-align end btns-block\">\n        <span class=\"button default cancle\"><%=cancel%></span>\n        <span class=\"button done add-group-btn\"><%=ok%></span>\n      </div>\n    </div>\n    ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneGroupCreatePanelView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        isHide: true,
        isCreate: true,
        belongEnterprise: 1,
        groupArr: null
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneGroupCreatePanelView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .add-group-btn': this._addGroupBtnClickHandle,
        'click .cancle': this._onCancel
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      if (!props.data) {
        props.data = {};
      }
      ;
      props.data = _.extend(props.data, {
        'groupName': BabelStr.str(2370),
        // 分组名
        'placeholder': BabelStr.str(2373),
        // 请输入分组名称
        'ok': BabelStr.str(154),
        // 确定
        'cancel': BabelStr.str(155) // 取消
      });
      props.title = BabelStr.str(2363); //"新建分组";
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneGroupCreatePanelView.prototype), "initialize", this).call(this, props);
      console.log("MDOneGroupCreatePanelView belongEnterprise", this.belongEnterprise);
      this.chooserView = new _MDEnterpriseShareTabView["default"]((0, _defineProperty2["default"])((0, _defineProperty2["default"])({
        ignoreIsShowingStructor: this.ignoreIsShowingStructor || this.belongEnterprise,
        canSelDepartment: false,
        inputFullWidth: true,
        notIncludeGuest: true,
        needGroupTreeTab: true,
        needFrequentUserTab: false,
        needRoleTab: false,
        isSelectOnlyInEp: this.belongEnterprise,
        fromStr: BabelStr.str(2404),
        placeholder: BabelStr.str(40079)
      }, "isSelectOnlyInEp", true), "onChange", function onChange(mails) {}));
      this.addSubView(this.chooserView, this.$(".user-choose-block")[0]);
      console.log(this.groupArr);
      // setTimeout(()=>{
      //   this.chooserView.showTab()
      // }, 400)
    }
  }, {
    key: "_addGroupBtnClickHandle",
    value: function _addGroupBtnClickHandle() {
      var _this = this;
      var name = this.$('.group-name').val().trim();
      var nameArr = [];
      _.each(this.groupArr, function (item) {
        nameArr.push(item.get('groupName'));
      });
      name = _.escape(name);
      if (_.indexOf(nameArr, name) > -1) {
        MDMessageView.error(BabelStr.str(2692), this.navigationWindowView.$body);
        return;
      }
      var validator = this.$(".form").validate();
      if (!validator.form()) {
        this.refreshWindow();
        return;
      }
      var users = this.chooserView.getSelectedUsers();
      var userIds = [];
      var subGroupIds = [];
      _.each(users, function (user) {
        if (user.userType == 2) {
          subGroupIds.push(user.id);
        } else {
          userIds.push(user.id);
        }
      });
      var params = {
        groupName: name,
        belongEnterprise: this.belongEnterprise,
        subGroupIds: subGroupIds,
        userIds: userIds
      };
      _MMEnterpriseController["default"].createGroup(params, function (groupInfo) {
        if (_this.groupAddCallback) {
          _this.groupAddCallback(groupInfo);
        }
        ;
        Dispatcher.trigger(MDEvents.GroupAdded, {
          groupInfo: groupInfo
        });
      }, function () {
        _MDSnackbarView["default"].show(BabelStr.str(309)); //('创建分组失败')
      });
    }
  }, {
    key: "navigationToOneGroupShowView",
    value: function navigationToOneGroupShowView(groupInfo) {
      var oneGroupShowView = new _MDOneGroupShowView["default"]({
        groupInfo: groupInfo
      });
      this.navigationWindowView.push(oneGroupShowView);
      var pages = this.navigationWindowView.getPageViewStack();
      pages.splice(1, pages.length - 2);
    }
  }, {
    key: "refreshWindow",
    value: function refreshWindow() {
      if (this.navigationWindowView) {
        this.navigationWindowView.refreshWindow();
      }
    }
  }, {
    key: "_onCancel",
    value: function _onCancel() {
      this.onCancel();
    }
  }]);
  return MDOneGroupCreatePanelView;
}(_MMViewBase2["default"]);

},{"1098":1098,"1175":1175,"1179":1179,"1180":1180,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1421":1421,"1432":1432,"1454":1454,"1463":1463,"1475":1475,"1498":1498,"22":22,"459":459,"675":675,"72":72,"755":755}],755:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1421);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDSpinnerloaderLayerView = _interopRequireDefault(require(75));
var _MDAddGroupMemberView = _interopRequireDefault(require(736));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDPaginationView = _interopRequireDefault(require(61));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDOneGroupSettingView = _interopRequireDefault(require(754));
var _MDEditalbeInputDiv = _interopRequireDefault(require(28));
var _regexp = _interopRequireDefault(require(106));
var _MDOneGroupPopupView = _interopRequireDefault(require(753));
var _popupPos = _interopRequireDefault(require(65));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDOneGroupShowView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDOneGroupShowView, _MDNavigationPageView);
  function MDOneGroupShowView() {
    (0, _classCallCheck2["default"])(this, MDOneGroupShowView);
    return _callSuper(this, MDOneGroupShowView, arguments);
  }
  (0, _createClass2["default"])(MDOneGroupShowView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n      <div class=\"head-block\">\n        <div class=\"title\"><%=groupName%></div>\n        <div class=\"group-name big-input-style\"></div>\n      </div>\n      <div class=\"flex-align between title\">\n        <div><%=member%>(<span class=\"total-num\"></span>)</div>\n        <div class=\"text-button done add-new-member\"><%=addMem%></div>\n      </div>\n      <div class=\"mem-disp mgb-10\">\n        <div class=\"content-block \">\n          <ul class=\"users-list mgtb-10\"></ul>\n          <div class=\"foot-content\"></div>\n        </div>\n        <div class=\"m-empty\">\n          <div class=\"info\"><%=empty%></div>\n        </div>\n      </div>\n    ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneGroupShowView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        title: BabelStr.str(3008),
        //"分组管理",
        pageSize: 10,
        users: [{
          name: "用户1",
          email: "01@12.com",
          isManager: true
        }, {
          name: "用户1",
          email: "01@12.com",
          isManager: true
        }, {
          name: "用户1",
          email: "01@12.com",
          isManager: true
        }],
        belongEnterprise: 1,
        _pageChanged: _.noop
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneGroupShowView.prototype), "className", this).call(this);
      return superCls + ' group-tab-panel one-group-panel';
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneGroupShowView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .add-new-member': this._addNewMemberClickHandle,
        "click .group-icon": this.showGroupPopup,
        "click .group-item .name": this.showGroupPopup
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      if (!props.data) {
        props.data = {};
      }
      ;
      props.data = _.extend(props.data, {
        'groupName': BabelStr.str(2370),
        // 分组名
        'member': BabelStr.str(2371),
        // 分组成员
        'addMem': BabelStr.str(71),
        // 添加成员
        'empty': BabelStr.str(2372) // 分组成员为空
      });
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneGroupShowView.prototype), "initialize", this).call(this, props);
      this.groupId = this.groupInfo.groupId();
      this.$(".m-empty").hide();
      this._renderForPage(0);
      this.renderPageBar();
      var self = this;
      this.groupNameInputView = new _MDEditalbeInputDiv["default"]({
        parentDiv: this.$el.find('.group-name')[0],
        placeholder: BabelStr.str(2368),
        //"分组名称不能为空",
        maxlength: 30,
        allowEmpty: false,
        emptyErrorMsg: BabelStr.str(2368),
        //"分组名称不能为空",
        updatedCallback: function updatedCallback(newtext, callback) {
          self._updateGroupName(newtext, callback);
        }
      });
      this.groupNameInputView.setInputVal(this.groupInfo.groupName());
      if (this.groupInfo.belongToEnterprise() && !app.currentUser.canCurUserManageEpGroup()) {
        this.groupNameInputView.setReadOnly();
        this.$('.add-new-member').remove();
      }
      ;
    }
  }, {
    key: "showGroupPopup",
    value: function showGroupPopup($e) {
      var $btn = $($e.target).parents(".uset-item-comp.group-item").find(".group-icon");
      if ($btn.hasClass("with-popup")) {
        var view = $btn.data("popupView");
        view.close();
        return;
      }
      var $item = $btn.closest(".uset-item-comp");
      var id = $item.data("id");
      _MDOneGroupPopupView["default"].show({
        groupName: $item.find(".name").text(),
        triggerView: $btn,
        direction: _popupPos["default"].TOP_LEFT,
        groupId: id
        // $container: this.getNavigationView().$el
      });
    }
  }, {
    key: "renderUserList",
    value: function renderUserList() {
      var _this = this;
      var $contain = this.$(".users-list");
      $contain.find('.remove').off();
      $contain.empty();
      var canRemove = !this.groupInfo.belongToEnterprise() || this.groupInfo.belongToEnterprise() && app.currentUser.isEpAdminUser();
      var tmpl = '';
      _.each(this.users, function (user) {
        if (user.get("userType") == 1) {
          tmpl = user.getDepItemAsUserHtmlStr({
            canRemove: canRemove
          });
        } else if (user.get("userType") == 2) {
          tmpl = user.getGroupItemAsUserHtmlStr({
            canRemove: canRemove,
            cls: " group-item"
          });
        } else {
          tmpl = user.getUserItemHtmlStr({
            canRemove: canRemove
          });
        }
        $contain.append(tmpl);
      });
      $contain.find(".group-item .group-icon").attr("data-tooltip", BabelStr.str(2578)).addClass("f-pointer");
      $contain.find(".group-item .name").attr("data-tooltip", BabelStr.str(2578)).addClass("f-pointer");
      $contain.find('.remove').on('click', function (e) {
        _this._removeMemberFromGroup(e);
      });
    }
  }, {
    key: "remove",
    value: function remove() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneGroupShowView.prototype), "remove", this).call(this);
      this.groupNameInputView.remove();
      this.$(".users-list").find('.remove').off();
    }
  }, {
    key: "renderPageBar",
    value: function renderPageBar() {
      var _this2 = this;
      this.pageBarView = new _MDPaginationView["default"]({
        enableStepButton: true,
        showJumpToPage: false,
        silentInit: true,
        showSelectSizeList: false,
        align: 'left',
        pageSize: this.pageSize,
        onPageChanged: function onPageChanged(curPageIndex) {
          _this2._renderForPage(curPageIndex);
        }
      });
      this.addSubView(this.pageBarView, this.$(".foot-content")[0]);
    }
  }, {
    key: "_renderForPage",
    value: function _renderForPage(index) {
      var _this3 = this;
      this.startIndex = index * this.pageSize;
      _MDSpinnerloaderLayerView["default"].showIn(this.$(".mem-disp"));
      MMEnterpriseController.getGroupMembers(this.groupId, this.startIndex, this.pageSize, function (users, totalCount) {
        _MDSpinnerloaderLayerView["default"].clearFrom(_this3.$(".mem-disp"));
        if (totalCount < 1) {
          _this3.$(".m-empty").show();
          _this3.$(".content-block").hide();
        } else {
          _this3.$(".m-empty").hide();
          _this3.$(".content-block").show();
        }
        _this3.curPageIndex = index;
        _this3.users = users;
        _this3.totalCount = totalCount;
        _this3.renderUserList();
        _this3.pageBarView.setLength(totalCount, true);
        _this3.groupInfo.setMemberNum(totalCount);
        _this3.$('.total-num').text(totalCount);
        _this3.navigationWindowView.refreshWindow();
      }, function () {});
    }
  }, {
    key: "_addNewMemberClickHandle",
    value: function _addNewMemberClickHandle() {
      var _this4 = this;
      console.log("MDOneGroupShowView belongEnterprise", this.belongEnterprise);
      var oneGroupSettingView = new _MDAddGroupMemberView["default"]({
        groupId: this.groupId,
        groupName: this.groupInfo.groupName(),
        ignoreIsShowingStructor: this.ignoreIsShowingStructor,
        belongEnterprise: this.belongEnterprise,
        addSucFuncCallback: function addSucFuncCallback() {
          _this4._renderForPage(_this4.curPageIndex);
        }
      });
      this.navigationWindowView.push(oneGroupSettingView);
    }
  }, {
    key: "_updateGroupName",
    value: function _updateGroupName(newName, callback) {
      var _this5 = this;
      var nameArr = [];
      _.each(this.groupArr, function (item) {
        nameArr.push(item.get('groupName'));
      });
      if (_.indexOf(nameArr, newName) > -1) {
        MDMessageView.error(BabelStr.str(2692), this.navigationWindowView.$body);
        return;
      }
      MMEnterpriseController.updateGroupName(this.groupId, newName, function () {
        _this5.groupInfo.setGroupName(newName);
        callback();
        Dispatcher.trigger(MDEvents.GroupEdited, {
          groupId: _this5.groupInfo.groupId(),
          groupName: _this5.groupInfo.groupName()
        });
      }, function () {});
    }
  }, {
    key: "_removeMemberFromGroup",
    value: function _removeMemberFromGroup(e) {
      var _this6 = this;
      var $target = $(e.currentTarget);
      var userId = $target.attr('user-id');
      var user = _.find(this.users, function (user) {
        return user.getId() == userId;
      });
      var str = '';
      if (user.get("userType") == 1) {
        str = BabelStr.str(2405);
      } else {
        str = BabelStr.str(2369);
      }
      var alertOpt = {
        message: str,
        // 确定要将此人移出分组？
        width: MMCommonFun.isInMobile() ? 300 : 470,
        okFun: function okFun() {
          console.log('---------- delete ', userId);
          MMEnterpriseController.removeMemFromGroup(_this6.groupId, [userId], function () {
            _this6.totalCount--;
            var pageCount = Math.floor(_this6.totalCount / _this6.pageSize);
            if (pageCount < _this6.curPageIndex) {
              _this6.curPageIndex = pageCount;
            }
            ;
            _this6._renderForPage(_this6.curPageIndex);
          }, function () {
            _MDSnackbarView["default"].show(BabelStr.str(309)); // ('删除失败！')
          });
        }
      };
      _MDAlertView["default"].showStandardSelection(alertOpt);
    }
  }]);
  return MDOneGroupShowView;
}(_MDNavigationPageView2["default"]);

},{"106":106,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1417":1417,"1421":1421,"1454":1454,"1463":1463,"1475":1475,"28":28,"32":32,"56":56,"61":61,"65":65,"72":72,"736":736,"75":75,"753":753,"754":754}],736:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1437);
require(1463);
require(1478);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MEStaffSearchPanelView = _interopRequireDefault(require(197));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDEnterUserChooseView = _interopRequireDefault(require(459));
var _MDEnterpriseShareTabView = _interopRequireDefault(require(675));
var _ErrorCode = _interopRequireDefault(require(1087));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDAddGroupMemberView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDAddGroupMemberView, _MDNavigationPageView);
  function MDAddGroupMemberView() {
    (0, _classCallCheck2["default"])(this, MDAddGroupMemberView);
    return _callSuper(this, MDAddGroupMemberView, arguments);
  }
  (0, _createClass2["default"])(MDAddGroupMemberView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n      <div class=\"add-mem-root mgb-10\">\n        <div class=\"choose-block mgb-20\"></div>\n        <div class=\"form-button-groups with-btn-right\">\n          <span class=\"button cancel\">".concat(BabelStr.str(155), "</span>\n          <span class=\"button done add-btn\">").concat(BabelStr.str(154), "</span>\n        </div>\n      </div>\n    ");
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAddGroupMemberView.prototype), "className", this).call(this);
      return superCls + ' group-tab-panel add-group-member-panel';
    }
  }, {
    key: "userItemTmpl",
    value: function userItemTmpl() {
      return "\n      <div class=\"user-item\">\n        <div class=\"name\"><%=name%></div>\n        <div class=\"email\">(<%=email%>)</div>\n        <%if(ismanager){%>\n          <div>".concat(BabelStr.str(1053), "</div>\n        <%}%>\n      </div>\n    ");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAddGroupMemberView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        isHide: true,
        isCreate: true,
        belongEnterprise: 1
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAddGroupMemberView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .cancel': this._canelClicked,
        'click .add-btn': this._okClicked
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      props.title = props.groupName;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDAddGroupMemberView.prototype), "initialize", this).call(this, props);
      this.chooserView = new _MDEnterpriseShareTabView["default"]({
        ignoreIsShowingStructor: this.ignoreIsShowingStructor,
        canSelDepartment: false,
        inputFullWidth: true,
        notIncludeGuest: true,
        needGroupTreeTab: true,
        needFrequentUserTab: false,
        needRoleTab: false,
        placeholder: BabelStr.str(40079),
        fromStr: BabelStr.str(2404),
        excludeGroupIds: [this.groupId.toString()],
        // isTabsOpened: true,
        isSelectOnlyInEp: this.belongEnterprise,
        onChange: function onChange(mails) {}
      });
      this.addSubView(this.chooserView, this.$(".choose-block")[0]);
      // setTimeout(()=>{
      //   this.chooserView.showTab()
      // }, 400)
    }
  }, {
    key: "_canelClicked",
    value: function _canelClicked() {
      this.navigationWindowView.pop();
    }
  }, {
    key: "_okClicked",
    value: function _okClicked() {
      var _this = this;
      var users = this.chooserView.getSelectedUsers();
      var userIds = [];
      var subGroupIds = [];
      _.each(users, function (user) {
        if (user.userType == 2) {
          subGroupIds.push(user.id);
        } else {
          userIds.push(user.id);
        }
      });
      if (userIds.length == 0 && subGroupIds.length == 0) {
        this.navigationWindowView.pop();
        return;
      }
      ;
      console.log(userIds);
      _MDSpinnerloaderView["default"].showIn(this.$('.add-mem-root')[0]);
      var params = {
        groupId: this.groupId,
        subGroupIds: subGroupIds,
        userIds: userIds
        // depIds: depIds
      };
      MMEnterpriseController.addMemForGroup(params, function () {
        _MDSpinnerloaderView["default"].clearFrom(_this.$('.add-mem-root')[0]);
        _this.addSucFuncCallback();
        _this.navigationWindowView.pop();
      }, function (error, msg) {
        _MDSpinnerloaderView["default"].clearFrom(_this.$('.add-mem-root')[0]);
        if (msg) {
          _MDSnackbarView["default"].show(msg);
        } else if (error == _ErrorCode["default"].Error_Secret_Dep) {
          _MDSnackbarView["default"].show(BabelStr.str(21402));
        } else {
          _MDSnackbarView["default"].show(BabelStr.str(7309));
        }
      });
    }
  }, {
    key: "refreshWindow",
    value: function refreshWindow() {
      this.navigationWindowView.refreshWindow();
    }
  }]);
  return MDAddGroupMemberView;
}(_MDNavigationPageView2["default"]);

},{"1087":1087,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1437":1437,"1454":1454,"1463":1463,"1475":1475,"1478":1478,"197":197,"459":459,"56":56,"675":675,"72":72,"76":76}],459:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1466);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDEnterpriseShareTabView = _interopRequireDefault(require(675));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 * 选择成员 created by jichao
 */
// MDEnterUserChooseView.js
// jichao
// 2017-5-15
var MDEnterUserChooseView = exports["default"] = /*#__PURE__*/function (_MDEnterpriseShareTab) {
  (0, _inherits2["default"])(MDEnterUserChooseView, _MDEnterpriseShareTab);
  function MDEnterUserChooseView() {
    (0, _classCallCheck2["default"])(this, MDEnterUserChooseView);
    return _callSuper(this, MDEnterUserChooseView, arguments);
  }
  (0, _createClass2["default"])(MDEnterUserChooseView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n        <div class = \"choose-contain \">\n           <div class = \"choosed\">\n            <input class = \"email-input\" placeholder=\"<%=BabelStr.str(2339)%>\"></input>\n          </div>\n          <div  class = \"tab app-tab-theme \"> </div>\n        </div>\n\n      ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEnterUserChooseView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        data: [],
        targetMails: [],
        needFrequentUserTab: false,
        needGroupTreeTab: true,
        placeholderStr: BabelStr.str(2339),
        isTabAbsolute: true
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEnterUserChooseView.prototype), "className", this).call(this);
      return superCls + ' enterprise-user-tab';
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      var placeholderStr = props.placeholderStr ? props.placeholderStr : BabelStr.str(2339); // 请输入邮箱

      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEnterUserChooseView.prototype), "initialize", this).call(this, props);
      if (this.inputDisabled) {
        placeholderStr = BabelStr.str(677); // 请输入邮箱
      }
      ;
      this.$(".email-input").attr("placeholder", placeholderStr);
      this.nameSpace = "evaluterList" + parseInt(Math.random() * 1000);
      var random = Math.floor();
      if (this.isTabAbsolute) {
        this.$(".choose-contain").on("click." + this.nameSpace, function () {
          _this.showTab();
        });
        this.$(".app-tab-theme").addClass("pos-absolute f-hide");
        $("body").on("click.evaluterList", function ($e) {
          var $target = $e.target;
          if (!$.contains(_this.el, $e.target)) {
            _this.hideTab();
          }
        });
      }
    }
  }, {
    key: "showTab",
    value: function showTab() {
      this.$(".tab").removeClass("f-hide");
    }
  }, {
    key: "hideTab",
    value: function hideTab() {
      this.$(".tab").addClass("f-hide");
    }
  }, {
    key: "viewDidUnRendered",
    value: function viewDidUnRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDEnterUserChooseView.prototype), "viewDidUnRendered", this).call(this);
      var content = this.$(".choose-contain");
      $("body").not(content).off("click." + this.nameSpace);
    }
  }]);
  return MDEnterUserChooseView;
}(_MDEnterpriseShareTabView["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1466":1466,"1475":1475,"675":675}],735:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1421);
require(1496);
require(1417);
require(1463);
require(1450);
require(1446);
require(1466);
require(1436);
require(1546);
require(1439);
require(1437);
require(1477);
require(1492);
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDTabPanelView = _interopRequireDefault(require(81));
var _MMUserDataController = _interopRequireDefault(require(1108));
var _MDUploadHeadWindowView = _interopRequireDefault(require(526));
var _DateFromat = _interopRequireDefault(require(99));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDSwitchView = _interopRequireDefault(require(79));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDAlertView = _interopRequireDefault(require(32));
var _ValidateHelper = _interopRequireDefault(require(793));
var _MDAccountTabPanelView_UserInfoTpl = _interopRequireDefault(require(774));
var _MDBindPhoneNavPageView = _interopRequireDefault(require(740));
var _MDBindEmailNavPageView = _interopRequireDefault(require(739));
var _MDChangeUsernameNavPageView = _interopRequireDefault(require(742));
var _MDRebindPhoneOrEmailView = _interopRequireDefault(require(756));
var _MDDelAccountWinView = _interopRequireDefault(require(745));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _app = _interopRequireDefault(require(17));
/**
 *  Create account tab view
 *  Created by manjun.han
 *
 */

var MDAccountTabPanelView = _MDTabPanelView["default"].extend({
  className: "person-info-panel center-block",
  tmpl: "<%if(!inFreeEdition && needRenewPromot){%>\n        <div class=\"renew-promot\">\n        <span class=\"warning\"><%=servCap%><%if(!hasExpired){%><%=approachingCap%><%}else{%><%=dueCap%><%}%>\n        </span>\uFF0C<%=payCap%>\n      </div>\n    <%}%>\n    <div class=\"block personinfor-block\">\n      <div class=\"block-hd\"><label for=\"\"><%=idInfoCap%></label><span class=\"f-fr del-account f-none text-button danger-c\"><%=BabelStr.str(3722)%></span></div>\n      <div class=\"block-bd flex-align user-info\"></div>\n    </div>\n    <div class=\"block storageInfor\">\n      <div class=\"block-hd\"><label for=\"\"><%=spaceCap%></label></div>\n      <div class=\"block-bd\">\n        <div class=\"storage-zone\">\n          <div class=\"total\">\n            <div class=\"f-fl title\">\n              <div><%=mySpaceCap%> : <em id=\"totalSpace\"></em></div>\n              <%if(!isEpVersion && !inFreeEdition ){%>\n              <a class=\"button done small button-setting expand inline f-fr\" href=\"/payment/expand.do\"><%=exSpaceCap%></a>\n              <%}%>\n            </div>\n            <div class=\"state content\">\n              <div class=\"progress-bar\">\n                <div class=\"progress total-progress\"></div>\n              </div>\n              <div class=\"use-type\">\n                <span class=\"text-left mgr-10\"><%=usedSpaceCap%>(<em class=\"used\"></em>) </span>\n                <span class=\"text-right\"><%=leftSpaceCap%>(<em class=\"remain\"></em>)</span>\n              </div>\n            </div>\n          </div>\n          <div class=\"personal-store\">\n            <div class=\"f-fl title1 boldfont3\">\n              <div><%=personSpaceCap%> : <em id=\"personSpace\"></em></div>\n            </div>\n            <div class=\"state content\">\n              <div class=\"progress-bar progress-bar1\">\n                <div class=\"progress person-progress\"></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"team-store\">\n            <div class=\"f-fl title1 boldfont3\">\n              <div><%=teamSpaceCap%> : <em id=\"teamSpace\"></em></div>\n            </div>\n            <div class=\"state content\">\n              <div class=\"progress-bar  progress-bar1\">\n                <div class=\"progress team-progress\"></div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class='user-recommend-info block'>\n      <div class=\"flex-align between\">\n        <div class=\"mgr-10 boldfont1\"><%=BabelStr.str(40000)%></div>\n        <div class=\"recommend-switch\"></div>\n      </div>\n      <div class=\"help-block\"><%=BabelStr.str(40001)%></div>\n    </div>\n\n\n    <div class='user-epfile-info block'>\n      <div class=\"flex-align between\">\n        <div class=\"mgr-10 boldfont1\"><%=BabelStr.str(11349)%></div>\n        <div class=\"epfile-switch\"></div>\n      </div>\n      <div class=\"help-block\"><%=BabelStr.str(11350)%></div>\n    </div>\n\n    <div class='user-sortindex-info block'>\n        <div class=\"block-hd\"><label for=\"\"><%=BabelStr.str(5459)%></label></div>\n        <div class=\"help-block\"><%=BabelStr.str(5460)%></div>\n        <div class=\"flex-align between\">\n          <div class='sortindex-select'></div>\n          <div class=\"mix-sort flex-align middle between\">\n            <div class=\"mgr-10\"><%=BabelStr.str(4861)%></div>\n            <div class=\"sort-switch\"></div>\n          </div>\n        </div>\n    </div>\n      <div class=\"block usertype-info\">\n        <div class=\"block-hd\"><label for=\"\"><%=typeCap%></label></div>\n        <div class=\"block-bd \" >\n        <%if(isEpVersion){%>\n          <div class=\"title1\">\n            <div class=\"user-type\"><%=entTypeCap%></div>\n          </div>\n        <%}else{%>\n          <div class=\"title1\">\n            <div class=\"user-type\">\n              <%if(inFreeEdition){%>\n              <%=psTypeCap%>\n              <%}else{%>\n                <%=prTypeCap%>(<%=dueTimeCap%> - <%=expiration%>)\n              <%}%>\n              </div>\n          </div>\n           <div>\n            <%if(inFreeEdition){%>\n              <a class=\"button done  small button-setting\" href=\"/payment/upgrade.do\"><%=up2pCap%></a>\n            <%}else{%>\n              <div class=\"settings\">\n              <a class=\"button done small button-setting f-fl\" href=\"/payment/renew.do\"><%=toPay%></a>\n              <a class=\"button  small button-setting f-fl mgl-10\" href=\"/p/order.do\"><%=payListCap%></a>\n              <%if(true || hasExpired){%>\n                <a class=\"button downgrade small button-setting f-fl mgl-10\" ><%=restoreNoraml%></a>\n              <%}%>\n              </div>\n            <%}%>\n          </div>\n        <%}%>\n      </div>\n      <div id=\"js-role-block\" class=\"edit-role-block\">\n      </div>\n    </div>\n    ",
  userInforTmpl: _MDAccountTabPanelView_UserInfoTpl["default"],
  effectiveDateTmpl: "<div class=\"effective-date\">\n      <div class=\"f-fl title\">\n        <div><%=validDays%> </div>\n        <a class=\"button done small inline\" href=\"/p/renew.do\"><%=toPay%></a>\n      </div>\n      <div class=\"eff-state content\">\n        <div class=\"progress-bar\">\n          <div class=\"progress\"></div>\n        </div>\n        <div class=\"use-type\">\n          <span class=\"text-left mgr-10\"><%=validDays%>(<em class=\"used\"><%=remaindays%></em>)</span>\n          <span class=\"text-right\"><%=expireDate%>(<em class=\"remain\"><%=expiration%></em>)</span>\n        </div>\n      </div>\n    </div>",
  _editNameTmpl: "<div class=\"container\">\n                    <div class=\"form-item row\">\n                      <div class=\"col-6\">\n                        <input id=\"js-nameInput\" type=\"text\" class=\"form-control\" required maxlength=\"20\" value=\"<%=name%>\"/>\n                      </div>\n                      <div class=\"col-6 username-operations\">\n                        <button class=\"button done mgr-10 submit-edit-name\">".concat(BabelStr.str(3096), "</button><button class=\"button cancel-edit-name\">\n                        ").concat(BabelStr.str(155), "</button>\n                      </div>\n                    </div>\n                  </div>"),
  rolelistTmpl: "<div id=\"js-roleList\" class=\"role-list \">\n                  <ul>\n                    <%for(var i = 0 ; i < departs.length ; i ++){%>\n                      <li>\n                        <div><span class=\"label-name\"><%=paredtDepStr%>\uFF1A</span><span class=\"role-content\"><%=departs[i].departmentName%></span></div> <!-- \u6240\u5C5E\u90E8\u95E8 -->\n                        <div><span class=\"label-name\"><%=roleStr%>\uFF1A</span><span class=\"role-content\"><%=departs[i].roleName%></span></div> <!-- \u89D2\u8272 -->\n                      </li>\n                      <%}%>\n                  </ul>\n                </div>",
  initProps: function initProps() {
    var superProps = _MDTabPanelView["default"].prototype.initProps.call(this);
    return _.extend(superProps, {
      molaUser: null,
      $userInforBlock: null,
      $uname: null,
      headerView: null,
      $totalSpace: null,
      $useType: null
    });
  },
  events: function events() {
    return {
      "click #js-bind-phone": this._bindPhoneClickHandler,
      "click #js-bind-mail": this._bindEmailClickHandler,
      "click #js-edit-name": this._editUsernameClickHandler,
      // 'click #js-edit-nickname': this._editUserNicknameClickHandler,
      "click #upgradeSpace": this._upgradeSpace,
      "change #avatarFileInput": this._onFileChangeEventHandler,
      "click .cancel-edit-name": this.cancelEditUserName,
      "click .submit-edit-name": this.submitEditUserName,
      "click #js-edit-phone": this._editPhone,
      "click #js-edit-email": this._editEmail,
      "click .downgrade": this._downgradeClicked,
      "click .del-account": this._delAccount
    };
  },
  initialize: function initialize(opt) {
    var _this = this;
    var currentUser = _app["default"].currentUser;
    if (_app["default"].userBeingViewed) {
      currentUser = _app["default"].userBeingViewed;
      _app["default"].userBeingViewed.set("level", 0);
    }
    var user = currentUser;
    var self = this;
    var hasExpired = user.getRemainDay() <= 0;
    var needRenewPromot = !_app["default"].isEpVersion() && user.inFreeEdition() && user.getRemainDay() <= 30;
    var pay = _MDLocalString["default"].getLocalString(2306); // 续费
    var param = {
      dosomething: '<a class="text-button done renew" href="/payment/renew.do">' + pay + "</a>"
    };
    var payCap = _MDLocalString["default"].getLocalString(2307, param); // 请及时 续费

    opt = _.extend({
      data: {
        isEpVersion: _app["default"].isEpVersion(),
        inFreeEdition: currentUser.inFreeEdition(),
        needRenewPromot: needRenewPromot,
        hasExpired: hasExpired,
        expiration: currentUser.getExpirationDateStr(),
        isGodEye: !!_app["default"].userBeingViewed,
        servCap: _MDLocalString["default"].getLocalString(2303),
        // 专业版基础服务
        approachingCap: _MDLocalString["default"].getLocalString(2304),
        // 即将到期
        dueCap: _MDLocalString["default"].getLocalString(2305),
        // 已经过期
        payCap: payCap,
        idInfoCap: _MDLocalString["default"].getLocalString(51),
        // 个人资料
        spaceCap: _MDLocalString["default"].getLocalString(54),
        // 存储空间
        mySpaceCap: _MDLocalString["default"].getLocalString(55),
        // 我的空间
        exSpaceCap: _MDLocalString["default"].getLocalString(3018),
        // 扩展空间
        usedSpaceCap: _MDLocalString["default"].getLocalString(56),
        // 已用空间
        leftSpaceCap: _MDLocalString["default"].getLocalString(3055),
        // 剩余空间
        personSpaceCap: _MDLocalString["default"].getLocalString(58),
        // 个人文件占用空间
        teamSpaceCap: _MDLocalString["default"].getLocalString(59),
        // 团队占用空间
        typeCap: _MDLocalString["default"].getLocalString(61),
        // 用户类型
        entTypeCap: _MDLocalString["default"].getLocalString(2308),
        // 企业版用户
        psTypeCap: _MDLocalString["default"].getLocalString(2309),
        // 个人版用户
        prTypeCap: _MDLocalString["default"].getLocalString(2310),
        // 专业版用户
        dueTimeCap: _MDLocalString["default"].getLocalString(2311),
        // 到期时间
        up2pCap: _MDLocalString["default"].getLocalString(47),
        // 升级至专业版
        toPay: pay,
        // 续费
        payListCap: _MDLocalString["default"].getLocalString(2312),
        // 订单详情,
        restoreNoraml: _MDLocalString["default"].getLocalString(6052) // 恢复到免费版
      }
    }, opt);
    _MDTabPanelView["default"].prototype.initialize.call(this, opt);
    this.$userInforBlock = this.$(".user-info");
    this.$(".block").hide();
    _MDSpinnerloaderView["default"].showIn(this.$el);
    _MMUserDataController["default"].getMyUserData(function (userInfo) {
      _MDSpinnerloaderView["default"].clearFrom(self.$el);
      self.$(".block").show();
    }, function () {
      _MDSpinnerloaderView["default"].clearFrom(self.$el);
    });
    this.molaUser = currentUser;
    this._initUserInfor();
    this.headerView = viewManager.get("headerView");
    this._requestPersonSpace();
    this.levels = null;
    this._renderRoleList();
    this.bindSelf(this._attrImageUrl);

    // if (app.isEpVersion()) {
    //   this.$('#upgradeSpace').hide();
    //   this.$('.storage-zone').find('.team-store').remove();
    //   this.$(".storage-zone .personal-store").remove();
    //   if(app.currentUser.isEnterpriseGuest()){
    //     this.$('.storage-zone').find('.total').remove();
    //   }
    // }
    if (_app["default"].isEpVersion()) {
      this.$(".del-account").remove();
    } else {
      this.$(".del-account").show();
      this.$(".user-epfile-info").addClass("f-hide");
    }
    this.listenTo(currentUser, "change", this.userInforChangedHandler);
    var defaultSortIndex = _app["default"].currentUser.get("defaultSortIndex");
    var index = _.indexOf(["latestVersionTime", "fileName", "currentVersionSize"], defaultSortIndex);
    var conditionArr = [{
      name: BabelStr.str(788),
      sortIndex: "latestVersionTime"
    }, {
      name: BabelStr.str(49),
      sortIndex: "fileName"
    }, {
      name: BabelStr.str(27),
      sortIndex: "currentVersionSize"
    }];
    this.sortIndexSelectView = new _MDDropdownSelectListView["default"]({
      dataProvider: conditionArr,
      labelField: "name",
      selectedIndex: index,
      onChange: function onChange(obj) {
        var sortIndex = obj.sortIndex;
        _MMEnterpriseController["default"].setDefaultSortIndex(sortIndex, function () {
          _app["default"].currentUser.set("defaultSortIndex", sortIndex);
          _MDSnackbarView["default"].show(BabelStr.str(308));
        }, function (msg) {
          _MDSnackbarView["default"].show(msg);
        });
      }
    });
    this.addSubView(this.sortIndexSelectView, this.$(".sortindex-select")[0]);
    this.optView = new _MDSwitchView["default"]({
      onChange: function onChange(state) {
        state = state ? 1 : 0;
        localStorage.setItem("simple_order", state);
      },
      checked: localStorage.getItem("simple_order") == 1,
      attrs: {
        "aria-label": BabelStr.str(4861)
      }
    });
    this.optView.renderTo(this.$(".sort-switch"));
    this.recommendView = new _MDSwitchView["default"]({
      onChange: function onChange(state) {
        state = state ? 0 : 1;
        _this.setCloseRecmmend(state);
      },
      checked: !_app["default"].currentUser.getHideRecommendView(),
      attrs: {
        "aria-label": BabelStr.str(40000)
      }
    });
    this.recommendView.renderTo(this.$(".recommend-switch"));
    this.epfileView = new _MDSwitchView["default"]({
      onChange: function onChange(state) {
        state = state ? 0 : 1;
        _this.setCloseDirectOpenDep(state);
      },
      checked: !_app["default"].currentUser.getCloseDirectOpenDep(),
      attrs: {
        "aria-label": BabelStr.str(40000)
      }
    });
    this.epfileView.renderTo(this.$(".epfile-switch"));
    if (_app["default"].isEpVersion() && _app["default"].currentUser.isEpManager() || !_app["default"].isEpVersion()) {
      this.renderTokenInfo();
      this.$(".ai-token-info").show();
    } else {
      this.$(".ai-token-info").hide();
    }
  },
  setCloseRecmmend: function setCloseRecmmend(close) {
    var _this2 = this;
    _MMEnterpriseController["default"].setCloseRecmmend(close, function () {
      _app["default"].currentUser.setHideRecommendView(close);
      var path = location.hash;
      if (path.startsWith('#')) {
        path = path.substring(1);
      }
      _app["default"].pathRouter.navigateToPath(path, true);
    }, function (code, msg) {
      if (close) {
        _this2.recommendView.close(true);
      } else {
        _this2.recommendView.open(true);
      }
      _MDSnackbarView["default"].show(msg);
    });
  },
  setCloseDirectOpenDep: function setCloseDirectOpenDep(close) {
    var _this3 = this;
    _MMEnterpriseController["default"].setCloseDirectOpenDep(close, function () {
      _app["default"].currentUser.setCloseDirectOpenDep(close);
      _MDSnackbarView["default"].show(BabelStr.str(308));
    }, function (code, msg) {
      if (close) {
        _this3.epfileView.close(true);
      } else {
        _this3.epfileView.open(true);
      }
      _MDSnackbarView["default"].show(msg);
    });
  },
  renderTokenInfo: function renderTokenInfo() {
    var _this4 = this;
    var request = _MMEnterpriseController["default"].getUserTokenInfo;
    if (_app["default"].isEpVersion()) {
      request = _MMEnterpriseController["default"].getEnterpriseTokenInfo;
    }
    request(function (info) {
      _this4.$(".total-token").html(info.tokens);
      _this4.$(".used-token").html(info.tokenUsed);
    });
  },
  _delAccount: function _delAccount() {
    var win = new _MDDelAccountWinView["default"]();
    win.show();
  },
  _upgradeSpace: function _upgradeSpace() {
    console.log("upgrade clicked");
    var alertOpt = {
      message: BabelStr.str(2320) + "：400-920-4020",
      // 暂不支持在线升级请联系客服：400-920-4020
      width: _app["default"].canDispInNormalBrowser() ? 500 : 300 //
    };
    _MDAlertView["default"].showStandardPrompt(alertOpt);
    return;
  },
  _bindPhoneClickHandler: function _bindPhoneClickHandler() {
    var bindPhonePageView = new _MDBindPhoneNavPageView["default"]({
      sendBtnText: BabelStr.str(2385)
    });
    this.navigationWindowView.push(bindPhonePageView);
  },
  _bindEmailClickHandler: function _bindEmailClickHandler() {
    var bindEmailPageView = new _MDBindEmailNavPageView["default"]({
      sendBtnText: BabelStr.str(20034)
    });
    this.navigationWindowView.push(bindEmailPageView);
  },
  _requestPersonSpace: function _requestPersonSpace() {
    var self = this;
    this.$useType = this.$(".use-type");
    var $totalSpace = this.$("#totalSpace");
    var $perUsedSpace = this.$("#personSpace");
    var $shareUsedSpace = this.$("#shareSpace");
    var $teamUsedSpace = this.$("#teamSpace");
    var $useSpace = this.$(".used");
    var $remain = this.$(".remain");
    var $progress = this.$(".total-progress");
    var $person_progress = this.$(".person-progress");
    var $share_progress = this.$(".share-progress");
    var $team_progress = this.$(".team-progress");
    this.$(".storageInfor").addClass("f-hide");
    _MMNetDiskDataController["default"].getQuota(function () {
      self.$(".storageInfor").removeClass("f-hide");
      var total = _app["default"].currentUser.getTotalSpace();
      var usedSpace = _app["default"].currentUser.getUsedSpace();
      var perUsedSpace = _app["default"].currentUser.getUsedSpaceHome();
      var shareUsedSpace = _app["default"].currentUser.getUsedSpaceJoin();
      var teamUsedSpace = _app["default"].currentUser.getUsedSpaceTeam();
      if (_app["default"].isEpVersion()) {
        if (total != 0) {
          self.$("#upgradeSpace").hide();
          self.$(".storage-zone").find(".team-store").remove();
          self.$(".storage-zone .personal-store").remove();
        } else {
          self.$(".storage-zone").find(".total").remove();
          self.$(".storage-zone").find(".team-store").remove();
        }
        if (_app["default"].currentUser.isEnterpriseGuest()) {
          self.$(".storage-zone").find(".total").remove();
        }
      }
      if (total == 0) {
        if (perUsedSpace > shareUsedSpace) {
          total = perUsedSpace;
        } else {
          total = shareUsedSpace;
        }
      }
      var progress = Number(usedSpace / total).toFixed(4) * 100;
      var person_progress = Number(perUsedSpace / total).toFixed(4) * 100;
      var share_progress = Number(shareUsedSpace / total).toFixed(4) * 100;
      var team_progress = Number(teamUsedSpace / total).toFixed(4) * 100;
      _.delay(function () {
        $progress.css("width", progress + "%");
        $person_progress.css("width", person_progress + "%");
        $share_progress.css("width", share_progress + "%");
        $team_progress.css("width", team_progress + "%");
      }, 1000);
      var remain = _app["default"].getFileSizeDescription(total - usedSpace);
      remain = parseInt(remain) > 0 ? remain : 0;
      $remain.text(remain);
      usedSpace = _app["default"].getFileSizeDescription(usedSpace);
      $useSpace.text(usedSpace);
      total = _app["default"].getFileSizeDescription(total);
      $totalSpace.text(total);
      self._refreshExpiration();
      $perUsedSpace.text(_app["default"].getFileSizeDescription(perUsedSpace));
      $shareUsedSpace.text(_app["default"].getFileSizeDescription(shareUsedSpace));
      $teamUsedSpace.text(_app["default"].getFileSizeDescription(teamUsedSpace));
    }, function (errorCode) {
      _MDSnackbarView["default"].show(BabelStr.str(2321)); // 获取空间信息失败
      self.$(".storageInfor").removeClass("f-hide");
    });
  },
  userInforChangedHandler: function userInforChangedHandler(user, opts) {
    var tmpl;
    var mf = BabelStr.str(3070); // 修改
    if (user.hasChanged("name")) {
      this.$("#js-name").html(user.getUserName());
    } else if (user.hasChanged("nickName")) {
      // this.$('#js-nickname').html(user.get('nickName'))
    } else if (user.hasChanged("isBindEmail")) {
      if (!!_app["default"].userBeingViewed || _app["default"].ep.isUserEditClosed()) {
        tmpl = "<div>\n                    <span>".concat(user.getEmail(), "</span>\n                  </div>");
      } else {
        tmpl = "<div>\n                    <span class=\"mgr-20\">".concat(user.getEmail(), "</span>\n                    <span id=\"js-edit-email\" class=\"text-button done\">") + mf + "</span>\n                  </div>";
      }
      this.$("#js-email-content").html(tmpl);
    } else if (user.hasChanged("phone")) {
      if (!!_app["default"].userBeingViewed || _app["default"].ep.isUserEditClosed()) {
        tmpl = "<div>\n                      <span>".concat(user.getPhone(), "</span>\n                    </div>");
      } else {
        tmpl = "<div>\n                      <span class=\"mgr-20\">".concat(user.getPhone(), "</span>\n                      <span id=\"js-edit-phone\" class=\"text-button done\">") + mf + "</span>\n                    </div>";
      }
      this.$("#js-phone-content").html(tmpl);
    }
  },
  _initUserInfor: function _initUserInfor() {
    var userData = this.molaUser.toJSON();
    var phoneNUmber = this.molaUser.getPhone();
    phoneNUmber = !!phoneNUmber ? phoneNUmber : BabelStr.str(2316);
    userData = _.extend(userData, {
      name: userData["nickName"] || userData["name"],
      nickName: userData["nickName"],
      isEpVersion: _app["default"].isEpVersion(),
      imgUrl: this.molaUser.getAvatarImageURL(100),
      isThirdAuthorizer: this.molaUser.isThirdAuthorizer(),
      phoneNumber: phoneNUmber,
      isGodEye: !!_app["default"].userBeingViewed,
      updateAvt: BabelStr.str(2314),
      // 修改头像
      phone: BabelStr.str(2315),
      // 手机号
      modify: BabelStr.str(3070),
      // 修改
      noBind: BabelStr.str(2316),
      // 未绑定
      bind: BabelStr.str(2317),
      // 绑定
      mail: BabelStr.str(3084),
      // 邮箱
      noMailCap: BabelStr.str(2318),
      // 尚未绑定邮箱，将无法及时收到通知
      username: BabelStr.str(2319),
      // 用户名
      isEp: _app["default"].isEpVersion(),
      canEdit: !_app["default"].ep.isUserEditClosed()
    });
    var htmlString = _.template(this.userInforTmpl)(userData);
    this.$userInforBlock.append(htmlString);
    this.$uname = this.$(".uname");
    this._refreshExpiration();
  },
  _refreshExpiration: function _refreshExpiration() {
    this.$el.find(".effective-date").remove();
    if (this.molaUser.getLevel() > 0) {
      var effectiveInfo = {
        remaindays: 120,
        expiration: "2016-12-12",
        validDays: BabelStr.str(2313),
        // 有效天数
        toPay: BabelStr.str(2306),
        // 续费
        expireDate: BabelStr.str(176) // 截止日期
      };
      var effString = _.template(this.effectiveDateTmpl)(effectiveInfo);
      this.$el.find(".storageInfor .block-bd").append(effString);
    }
  },
  _editUsernameClickHandler: function _editUsernameClickHandler($e) {
    var navPageView = new _MDChangeUsernameNavPageView["default"]({
      attr: "name"
    });
    this.navigationWindowView.push(navPageView);
  },
  _editUserNicknameClickHandler: function _editUserNicknameClickHandler() {
    var navPageView = new _MDChangeUsernameNavPageView["default"]({
      attr: "nickName"
    });
    this.navigationWindowView.push(navPageView);
  },
  _onFileChangeEventHandler: function _onFileChangeEventHandler($e) {
    var file = $e.target.files[0];
    var self = this;
    if (file) {
      var uploadAvt = BabelStr.str(2322); // 上传头像
      var doneCap = BabelStr.str(308); // 操作成功
      var failCap = BabelStr.str(168); // 操作失败
      var uploadHeadView = new _MDUploadHeadWindowView["default"]({
        title: uploadAvt,
        uploadUrl: "user/modifyUserAvatar.do",
        fileInfo: file,
        viewMode: 1,
        onSuccess: function onSuccess(fileBlob) {
          self._attrImageUrl(fileBlob);
          self.headerView.setAvartImageURL(fileBlob);
          _MDSnackbarView["default"].show(doneCap);
        },
        onError: function onError(err) {
          _MDSnackbarView["default"].show(failCap);
        },
        onClose: function onClose() {
          $e.target.blur(); // IE11的input[file]会有光标
          document.body.click();
        }
      });
      uploadHeadView.show();
      this.$("#avatarFileInput").val("");
    }
  },
  _attrImageUrl: function _attrImageUrl(url) {
    this.$("#avatarImage").attr("src", url);
  },
  viewDidRendered: function viewDidRendered() {
    _MDTabPanelView["default"].prototype.viewDidRendered.call(this);
    if (!_app["default"].isEpVersion()) {
      var curdate = new Date();
      var expirationDate = _app["default"].currentUser.getExpirationDate();
      var $expand = this.$(".expand");
      if (expirationDate < curdate) {
        $expand.attr("disabled", true);
        $expand.removeAttr("href");
      }
    }
  },
  _editPhone: function _editPhone($e) {
    var bindPhonePageView = new _MDRebindPhoneOrEmailView["default"]({
      changePhone: true,
      sendBtnText: BabelStr.str(2385)
    });
    this.navigationWindowView.push(bindPhonePageView);
  },
  _editEmail: function _editEmail() {
    var bindPhonePageView = new _MDRebindPhoneOrEmailView["default"]({
      changePhone: false,
      sendBtnText: BabelStr.str(20034)
    });
    this.navigationWindowView.push(bindPhonePageView);
  },
  _downgradeClicked: function _downgradeClicked() {
    var alertOpt = {
      message: BabelStr.str(6053),
      //    '您确信要降级为普通用户吗？这样将导致您的空间和享受服务的降低！',
      width: 600,
      okFun: function okFun() {
        _MMNetDiskDataController["default"].downgradeEdition(function () {
          location.replace("/account/userLogout.do");
          _app["default"].syncSessionState();
        }, function () {
          _MDSnackbarView["default"].show(BabelStr.str(168));
        });
      }
    };
    _MDAlertView["default"].showDangerSelection(alertOpt);
  },
  _renderRoleList: function _renderRoleList() {
    var _this5 = this;
    _MMEnterpriseController["default"].roleAndUsers.getUserInfoById(_app["default"].currentUser.getUserId(), function (info) {
      var departments = info.departments;
      var data = {
        paredtDepStr: BabelStr.str(3085),
        roleStr: BabelStr.str(3086),
        departs: departments
      };
      var roleListHTML = _.template(_this5.rolelistTmpl)(data);
      _this5.$("#js-role-block").empty().html(roleListHTML);
    }, function () {});
  }
});
var _default = exports["default"] = MDAccountTabPanelView;

},{"1098":1098,"1104":1104,"1108":1108,"1150":1150,"1184":1184,"1412":1412,"1417":1417,"1421":1421,"1436":1436,"1437":1437,"1439":1439,"1446":1446,"1450":1450,"1454":1454,"1463":1463,"1466":1466,"1477":1477,"1492":1492,"1496":1496,"1546":1546,"17":17,"32":32,"526":526,"67":67,"72":72,"739":739,"740":740,"742":742,"745":745,"756":756,"76":76,"774":774,"79":79,"793":793,"81":81,"99":99}],774:[function(require,module,exports){
module.exports = '<div class="avatarWrapper">\  <p>\    <img id="avatarImage" src="<%=imgUrl%>">\    <span class="icon editPen changeAvatarBtn" data-tooltip="<%=updateAvt%>" data-tooltipp-dir="bottom">\    <input id="avatarFileInput" type="file" name="file" accept=".jpg,.jpeg,.png"></span>\  </p>\</div>\<div class="col-auto basic-info-section">\  <div class="list-section-item">\    <span class="section-label"><%=phone%>:</span>\    <div id="js-phone-content" class="section-content">\      <%if(phone){%>\        <div>\          <span><%=phoneNumber%></span>\          <%if(!isGodEye && canEdit){%>\          <span id="js-edit-phone" class="text-button done mgl-20"><%=modify%></span>\          <%}%>\        </div>\      <%}else{%>\        <div>\          <span class="help-inline"><%=noBind%></span>\          <%if(!isGodEye  && canEdit){%>\          <span id="js-bind-phone" class="text-button done mgl-20"><%=bind%></span>\          <%}%>\        </div>\<!--         <%if(!isEpVersion && !isThirdAuthorizer){%>\          <div class="help-block">尚未绑定手机号，截止到6月1号，登录将受限</div>\        <%}%>\ -->\      <%}%>\    </div>\  </div>\  <div class="list-section-item">\    <span class="section-label"><%=mail%>:</span>\    <div id="js-email-content" class="section-content">\      <%if(isBindEmail){%>\        <div>\          <span class="mgr-20"><%=email%></span>\          <%if(!isGodEye  && canEdit){%>\          <span id="js-edit-email" class="text-button done "><%=modify%></span>\          <%}%>\        </div>\      <%}else{%>\        <div>\          <span class="help-inline mgr-20"><%=noBind%></span>\          <%if(!isGodEye  && canEdit){%>\          <span id="js-bind-mail" class="text-button done"><%=bind%></span>\          <%}%>\        </div>\        <div class="help-block"><%=noMailCap%></div>\      <%}%>\    </div>\  </div>\  <div class="list-section-item">\    <span class="section-label"><%=username%>:</span>\    <div class="section-content">\      <span id="js-name" class="mgr-20"><%=name%></span>\          <%if(!isGodEye  && canEdit){%>\      <span id="js-edit-name" class="text-button done"><%=modify%></span>\          <%}%>\      <!-- <span class="editUName"><i class="icon editUInfo"></i></span> -->\    </div>\  </div>\</div>';
},{}],756:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1426);
require(1423);
require(1463);
require(1538);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDButtonView = _interopRequireDefault(require(36));
var _EmailVerifyCodeType = _interopRequireDefault(require(100));
var _MDVerifyCodeInputView = _interopRequireDefault(require(765));
var _MDRebindPhoneOrEmailViewTpl = _interopRequireDefault(require(779));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _SMSType = _interopRequireDefault(require(101));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDMessageView = _interopRequireDefault(require(55));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDRebindPhoneOrEmailView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDRebindPhoneOrEmailView, _MDNavigationPageView);
  function MDRebindPhoneOrEmailView() {
    (0, _classCallCheck2["default"])(this, MDRebindPhoneOrEmailView);
    return _callSuper(this, MDRebindPhoneOrEmailView, arguments);
  }
  (0, _createClass2["default"])(MDRebindPhoneOrEmailView, [{
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDRebindPhoneOrEmailView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        changePhone: true
      });
    }
  }, {
    key: "contentTmpl",
    value: function contentTmpl() {
      return _MDRebindPhoneOrEmailViewTpl["default"];
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDRebindPhoneOrEmailView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click #js-cancel-btn': this.cancelClickHandler
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      if (!props.changePhone) {
        props.title = BabelStr.str(2332); //"修改邮箱",
        props.data = {
          'type': BabelStr.str(3084),
          //'邮箱',
          'placeholder': BabelStr.str(2333),
          //'请输入新邮箱',
          'name': 'email'
        };
      } else {
        props.title = BabelStr.str(2334); //"修改手机号",
        props.data = {
          'type': BabelStr.str(2315),
          //'手机号',
          'placeholder': BabelStr.str(2335),
          //'请输入新手机号',
          'name': 'phone'
        };
      }
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDRebindPhoneOrEmailView.prototype), "initialize", this).call(this, props);
      var verifyProps = {
        isPhoneFiled: true,
        placeholder: BabelStr.str(2336),
        //'手机验证码',
        fieldName: 'phone',
        inputName: 'verifyCode',
        targetInput: this.$('#js-input'),
        verifyCodeType: _SMSType["default"].REBIND_PHONE,
        sendBtnText: this.sendBtnText,
        interceptor: function interceptor() {
          if (!app.currentUser.get('supportSMS')) {
            _MDAlertView["default"].showStandardPrompt({
              message: BabelStr.str(8567)
            });
            return true;
          }
          return false;
        }
      };
      if (!this.changePhone) {
        verifyProps = {
          isPhoneFiled: false,
          placeholder: BabelStr.str(2337),
          //'邮箱验证码',
          fieldName: 'email',
          inputName: 'verifyCode',
          targetInput: this.$('#js-input'),
          verifyCodeType: _EmailVerifyCodeType["default"].REBIND_EMAIL,
          sendBtnText: this.sendBtnText
        };
      } else {
        if (!app.ep.isPrivateCloud()) {
          this.$("#js-input").intlTelInput();
        }
      }
      this.vcodeFormItemView = new _MDVerifyCodeInputView["default"](verifyProps);
      this.addSubView(this.vcodeFormItemView, this.$('.vcode-form-item')[0]);
      this.cancelButtonView = new _MDButtonView["default"]({
        el: this.$('#js-cancel-btn'),
        onClick: function onClick() {
          _this.navigationWindowView.pop();
          return false;
        }
      });
      this.submitButtonView = new _MDButtonView["default"]({
        el: this.$('#js-submit-btn'),
        onClick: function onClick() {
          var validator = _this.$('form').validate();
          if (validator.form()) {
            _this.changeEmailOrPhone();
          }
          _this.navigationWindowView && _this.navigationWindowView.refreshWindow();
          return false;
        }
      });
    }
  }, {
    key: "cancelClickHandler",
    value: function cancelClickHandler() {
      this.navigationWindowView.pop();
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDRebindPhoneOrEmailView.prototype), "viewDidRendered", this).call(this);
      var rules = {
        'phone': {
          'required': true,
          'isNumber': true
        },
        'verifyCode': {
          'required': true
        }
      };
      var message = {
        'phone': {
          'required': BabelStr.str(2325),
          'mobile': BabelStr.str(2326)
        },
        'verifyCode': {
          'required': BabelStr.str(2327)
        }
      };
      if (!this.changePhone) {
        rules['email'] = {
          'required': true,
          'email': true
        };
        message['email'] = {
          'required': BabelStr.str(2339),
          'email': BabelStr.str(2340)
        };
      }
      this.$('form').validate({
        rules: rules,
        messages: message
      });
    }
  }, {
    key: "controlActionButton",
    value: function controlActionButton(disabled) {
      this.cancelButtonView.setDisabled(disabled);
      this.submitButtonView.setDisabled(disabled);
    }
  }, {
    key: "changeEmailOrPhone",
    value: function changeEmailOrPhone() {
      if (this.changePhone) {
        this.changePhoneAction();
      } else {
        this.changeEmailAction();
      }
    }
  }, {
    key: "changePhoneAction",
    value: function changePhoneAction() {
      var _this2 = this;
      this.controlActionButton(true);
      var formData = this.$('form').serializeArray();
      var validator = this.$('form').validate();
      var submitData = _.object(_.map(formData, _.values));
      if (!app.ep.isPrivateCloud()) {
        var selectedCountryData = this.$("#js-input").intlTelInput("getSelectedCountryData") || {};
        if (selectedCountryData.dialCode && selectedCountryData.dialCode != '86') {
          submitData.phone = selectedCountryData.dialCode + "-" + submitData.phone;
        }
      }
      $.ajax('/user/rebindPhone.do', {
        method: 'post',
        data: submitData,
        success: function success(data) {
          if (data['success']) {
            app.currentUser.setPhone(submitData['phone']);
            _this2.cancelClickHandler();
            _MDSnackbarView["default"].show(BabelStr.str(7319));
          } else {
            var code = data['code'];
            if (code == 234 || code == 238 || code == 201 || code == 207) {
              validator.showErrors({
                verifyCode: data['msg']
              });
              _this2.navigationWindowView && _this2.navigationWindowView.refreshWindow();
            } else {
              if (code === 12 && app.isEpVersion()) {
                data.msg = BabelStr.str(28247);
              }
              _MDMessageView["default"].error(data.msg, _this2.$el);
            }
          }
        },
        error: function error() {},
        complete: function complete() {
          _this2.controlActionButton(false);
        }
      });
    }
  }, {
    key: "changeEmailAction",
    value: function changeEmailAction() {
      var _this3 = this;
      this.controlActionButton(true);
      var formData = this.$('form').serializeArray();
      var validator = this.$('form').validate();
      var submitData = _.object(_.map(formData, _.values));
      $.ajax('/user/rebindEmail.do', {
        method: 'post',
        data: submitData,
        success: function success(data) {
          if (data['success']) {
            app.currentUser.setEmail(submitData.email);
            _this3.cancelClickHandler();
            _MDSnackbarView["default"].show(BabelStr.str(7320));
          } else {
            var code = data['code'];
            if (code == 234 || code == 201 || code == 207) {
              validator.showErrors({
                verifyCode: data['msg']
              });
              _this3.navigationWindowView && _this3.navigationWindowView.refreshWindow();
            } else {
              if (code === 12 && app.isEpVersion()) {
                data.msg = BabelStr.str(28247);
              }
              _MDMessageView["default"].error(data.msg, _this3.$el);
            }
          }
        },
        error: function error() {},
        complete: function complete() {
          _this3.controlActionButton(false);
        }
      });
    }
  }]);
  return MDRebindPhoneOrEmailView;
}(_MDNavigationPageView2["default"]);

},{"100":100,"101":101,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1423":1423,"1426":1426,"1454":1454,"1463":1463,"1475":1475,"1538":1538,"32":32,"36":36,"55":55,"56":56,"72":72,"765":765,"779":779}],779:[function(require,module,exports){
module.exports = '<div class="block-center bind-section rebind-section">\  <form action="">\    <div class="form-item">\      <input id="js-input" type="text" name="<%=name%>" class="form-control" placeholder="<%=placeholder%>">\    </div>\    <div class="form-item  vcode-form-item">\    </div>\  </form>\  <div class="help-block"><%=BabelStr.str(7327,{type: type})%></div>\  <div class="form-button-groups with-btn-right">\    <span id="js-cancel-btn" class="button default"><%=BabelStr.str(155)%></span>\    <button id="js-submit-btn" class="button done"><%=BabelStr.str(3070)%></button>\  </div>\</div>';
},{}],745:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1498);
require(1477);
require(1492);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _keycode = _interopRequireDefault(require(104));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 *  删除企业
 *  Created by jichao
 *  2020.10.27
 */
var MDDelAccountWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDDelAccountWinView, _MDWindowView);
  function MDDelAccountWinView() {
    (0, _classCallCheck2["default"])(this, MDDelAccountWinView);
    return _callSuper(this, MDDelAccountWinView, arguments);
  }
  (0, _createClass2["default"])(MDDelAccountWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<form class=\"step-1\" >\n      <p class=\"f-tc\"><%=BabelStr.str(6156)%></p>\n      <textarea class=\"msg form-control moreThan6Chart\" moreThan6Chart></textarea>\n    </form>\n    <form class=\"step-2 f-none\">\n      <p class=\"f-tc\"><%=BabelStr.str(3723)%></p>\n      <input class='pwd form-control notempty' placeholder=\"<%=BabelStr.str(2328)%>\"  type=\"password\" notempty required/>\n    </form>";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDelAccountWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " staff-search-win");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDelAccountWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'keydown .pwd': this._submitOnEnter
      });
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDelAccountWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {});
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.title = BabelStr.str(220);
      props.buttons = [{
        label: BabelStr.str(3139),
        autoClose: false,
        type: 'done',
        onClick: function onClick() {
          _this.nextStep();
        }
      }];
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDelAccountWinView.prototype), "initialize", this).call(this, props);
      var $buttons = this.getActionButtons();
      $buttons.eq(1).hide();
      $buttons.eq(1).prop('disabled', true);
      $buttons.eq(2).prop('disabled', true);
      this.$doneBtn = $buttons.eq(1);
    }
  }, {
    key: "nextStep",
    value: function nextStep() {
      var _this2 = this;
      var validate = this.$('.step-1').validate();
      if (validate.form()) {
        console.error('验证通过');
      } else {
        console.error('验证失败');
        return;
      }
      var msg = this.$('.msg').val() || '';
      msg = msg.trim();
      _MMEnterpriseController["default"].insertCustomerFeedback(msg, function (res) {
        _this2.feedbackId = res.feedbackId;
      }, function () {});
      var buttons = [{
        label: BabelStr.str(155)
      }, {
        label: BabelStr.str(32),
        autoClose: false,
        type: 'danger',
        onClick: function onClick() {
          _this2.delAccount();
        }
      }];
      this.setButtons(buttons);
      this.$('.step-1').hide();
      this.$('.step-2').show();
    }
  }, {
    key: "_submitOnEnter",
    value: function _submitOnEnter($e) {
      var disabled = this.$doneBtn.prop('disabled');
      if (disabled) {
        return;
      }
      if (_keycode["default"].isEnterKey($e.keyCode)) {
        this.delAccount();
        return false;
      }
    }
  }, {
    key: "delAccount",
    value: function delAccount() {
      var _this3 = this;
      // let validate = this.$('.step-2').validate()
      // if(validate.form()) {
      //   console.error('验证通过')
      // } else {
      //   console.error('验证失败')
      // }
      console.error('接口');
      var pwd = this.$('.pwd').val() || '';
      pwd = pwd.trim();
      _MMEnterpriseController["default"].updateCustomerResult(this.feedbackId, function () {}, function () {});
      _MMEnterpriseController["default"].deleteAccount(pwd, function () {
        location.replace("/account/userLogout.do");
        app.syncSessionState();
      }, function (res) {
        MDMessageView.error(BabelStr.str(7394), _this3.$body);
      });
    }
  }]);
  return MDDelAccountWinView;
}(_MDWindowView2["default"]);

},{"104":104,"1098":1098,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"1477":1477,"1492":1492,"1498":1498,"93":93}],742:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1498);
require(1439);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDChangeUsernameNavPageViewTpl = _interopRequireDefault(require(777));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDMessageView = _interopRequireDefault(require(55));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDChangeUsernameNavPageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDChangeUsernameNavPageView, _MDNavigationPageView);
  function MDChangeUsernameNavPageView() {
    (0, _classCallCheck2["default"])(this, MDChangeUsernameNavPageView);
    return _callSuper(this, MDChangeUsernameNavPageView, arguments);
  }
  (0, _createClass2["default"])(MDChangeUsernameNavPageView, [{
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDChangeUsernameNavPageView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        title: BabelStr.str(2330) //'修改用户名'
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDChangeUsernameNavPageView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click #js-cancel': this.cancleButtonClickHandler,
        'click #js-done': this.submitEditUserName
      });
    }
  }, {
    key: "contentTmpl",
    value: function contentTmpl() {
      return _MDChangeUsernameNavPageViewTpl["default"];
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      props.data = {
        'name': app.currentUser.getUserName()
      };
      if (props.attr == 'name') {
        props.title = BabelStr.str(2330);
      } else if (props.attr == 'nickName') {
        props.title = BabelStr.str(6122);
      }
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDChangeUsernameNavPageView.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "submitEditUserName",
    value: function submitEditUserName($e) {
      var _this = this;
      var self = this;
      var userOldName = app.currentUser.getUserName();
      var input = this.$('#js-nameInput')[0];
      var userNewName = $.trim(input.value);
      var $actionButtons = self.$('.button');
      if (userOldName === userNewName) {
        this.cancleButtonClickHandler();
        return;
      }
      userNewName = _.escape(userNewName);
      var validator = this.$('form').validate();
      if (!validator.form()) {
        return;
      }
      $actionButtons.prop('disabled', true);
      $actionButtons.eq(1).text(BabelStr.str(2018) + '...'); // --------------'发送中...'
      var error = {};
      if (this.attr == 'name') {
        MMEnterpriseController.changeMyName(userNewName, function () {
          _MDSnackbarView["default"].show(BabelStr.str(308)); // 操作成功
          app.currentUser.set('nickName', _.escape(_.unescape(userNewName)));
          app.currentUser.set('name', _.escape(_.unescape(userNewName)));
          self.cancleButtonClickHandler();
        }, function (msg) {
          _MDMessageView["default"].error(msg, _this.$el);
          // validator.showErrors({
          //   uname: msg
          // });
          self.$('.button').prop('disabled', false);
          $actionButtons.eq(1).text(BabelStr.str(154)); // 确定
        });
      } else if (this.attr == 'nickName') {
        MMEnterpriseController.updateMyEnterpriseRemarkName(userNewName, function () {
          _MDSnackbarView["default"].show(BabelStr.str(308)); // 操作成功
          app.currentUser.set('nickName', _.escape(_.unescape(userNewName)));
          self.cancleButtonClickHandler();
        }, function (msg) {
          _MDMessageView["default"].error(msg, _this.$el);
          // validator.showErrors({
          //   uname: msg
          // });
          self.$('.button').prop('disabled', false);
          $actionButtons.eq(1).text(BabelStr.str(154)); // 确定
        });
      } else {
        app.currentUser.changeName(userNewName, {
          onSuccess: function onSuccess(data, textStatus, jqxhr) {
            if (data.success) {
              _MDSnackbarView["default"].show(BabelStr.str(308)); // 操作成功
              app.currentUser.set('name', _.escape(_.unescape(userNewName)));
              self.cancleButtonClickHandler();
            } else {
              error[input.name] = data['msg'] || BabelStr.str(168); // '修改昵称失败,请稍后重试'
              // validator.showErrors(error);
              _MDMessageView["default"].error(error[input.name], this.$el);
            }
          },
          onComplete: function onComplete() {
            self.$('.button').prop('disabled', false);
            $actionButtons.eq(1).text(BabelStr.str(154)); // 确定
          }
        });
      }
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDChangeUsernameNavPageView.prototype), "viewDidRendered", this).call(this);
      this.$('form').validate({
        rules: {
          'uname': {
            'required': true,
            'accountName': true
          }
        },
        messages: {
          'uname': {
            'required': BabelStr.str(2331) //'请输入用户名'
          }
        }
        // 校验成功后回调
        // submitHandler: (form) => {
        //   this.submitEditUserName();
        // }
      });
    }
  }, {
    key: "cancleButtonClickHandler",
    value: function cancleButtonClickHandler() {
      this.navigationWindowView.pop();
    }
  }]);
  return MDChangeUsernameNavPageView;
}(_MDNavigationPageView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"1498":1498,"55":55,"56":56,"72":72,"777":777}],777:[function(require,module,exports){
module.exports = '<div class="block-center bind-section update-name-section">\  <form>\    <div class="form-item">\      <input id="js-nameInput" type="text" name="uname" value="<%=name%>" class="form-control" placeholder="<%=BabelStr.str(2319)%>">\    </div>\    <div class="form-button-groups with-btn-right">\      <span id="js-cancel" class="button default"><%=BabelStr.str(3081)%></span>\      <span id="js-done" class="button done"><%=BabelStr.str(3096)%></span>\    </div>\  </form>\</div>';
},{}],740:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1426);
require(1423);
require(1463);
require(1538);
require(1477);
require(1492);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _ErrorCode = _interopRequireDefault(require(1087));
var _SMSType = _interopRequireDefault(require(101));
var _MDButtonView = _interopRequireDefault(require(36));
var _MDVerifyCodeInputView = _interopRequireDefault(require(765));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDBindPhoneNavPageViewTpl = _interopRequireDefault(require(776));
var _MDAlertView = _interopRequireDefault(require(32));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDBindPhoneNavPageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDBindPhoneNavPageView, _MDNavigationPageView);
  function MDBindPhoneNavPageView() {
    (0, _classCallCheck2["default"])(this, MDBindPhoneNavPageView);
    return _callSuper(this, MDBindPhoneNavPageView, arguments);
  }
  (0, _createClass2["default"])(MDBindPhoneNavPageView, [{
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBindPhoneNavPageView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        title: BabelStr.str(2323) //'绑定手机号'
      });
    }
  }, {
    key: "contentTmpl",
    value: function contentTmpl() {
      return _MDBindPhoneNavPageViewTpl["default"];
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      var self = this;
      props.data = {
        'hasInitPwd': app.currentUser.hasInitPwd()
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBindPhoneNavPageView.prototype), "initialize", this).call(this, props);
      this.cancelButtonView = new _MDButtonView["default"]({
        el: this.$('#js-cancel-btn'),
        onClick: function onClick() {
          _this.navigationWindowView.pop();
          return false;
        }
      });
      this.submitButtonView = new _MDButtonView["default"]({
        el: this.$('#js-submit-btn'),
        onClick: function onClick() {
          var validator = _this.$('form').validate();
          if (validator.form()) {
            _this.bindPhone();
          }
          _this.navigationWindowView && _this.navigationWindowView.refreshWindow();
          return false;
        }
      });
      this.vcodeFormItemView = new _MDVerifyCodeInputView["default"]({
        isPhoneFiled: true,
        fieldName: 'phone',
        inputName: 'verifyCode',
        targetInput: this.$('#js-phone'),
        verifyCodeType: _SMSType["default"].BIND_PHONE,
        interceptor: function interceptor() {
          if (!app.currentUser.get('supportSMS')) {
            _MDAlertView["default"].showStandardPrompt({
              message: BabelStr.str(8567)
            });
            return true;
          }
          return false;
        }
      });
      this.addSubView(this.vcodeFormItemView, this.$('.vcode-form-item')[0]);
    }
  }, {
    key: "bindPhone",
    value: function bindPhone() {
      var _this2 = this;
      this.controlActionButton(true);
      var validator = this.$('form').validate();
      var formData = this.$('form').serializeArray();
      var submitData = _.object(_.map(formData, _.values));
      $.ajax({
        method: 'post',
        data: submitData,
        url: '/account/bindPhone.do',
        success: function success(data, textStatus, jqXHR) {
          if (data.success) {
            var phone = submitData.phone.replace(/(\d{3})(\d{4})/, function (match, $1, $$2) {
              return $1 + "****";
            });
            app.currentUser.setPhone(phone);
            app.currentUser.set('isBindPhone', true);
            app.currentUser.setHasInitPwd();
            _this2.navigationWindowView.pop();
            _MDSnackbarView["default"].show(BabelStr.str(2324)); // 手机号绑定成功
          } else {
            if (data.code == _ErrorCode["default"].Phone_Exist || data.code == _ErrorCode["default"].WaitToSendCode) {
              validator.showErrors({
                'phone': data['msg']
              });
            } else if (data.code == _ErrorCode["default"].Wrong_SmsCode || data.code == _ErrorCode["default"].SmsCode_Exprie) {
              validator.showErrors({
                'verifyCode': data['msg']
              });
            } else {
              validator.showErrors({
                'phone': data['msg']
              });
            }
          }
        },
        complete: function complete() {
          _this2.controlActionButton(false);
        }
      });
    }
  }, {
    key: "controlActionButton",
    value: function controlActionButton(disabled) {
      this.cancelButtonView.setDisabled(disabled);
      this.submitButtonView.setDisabled(disabled);
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBindPhoneNavPageView.prototype), "viewDidRendered", this).call(this);
      var self = this;
      this.$('form').validate({
        rules: {
          'phone': {
            'required': true,
            'mobile': true
          },
          'verifyCode': {
            'required': true
          }
        },
        messages: {
          'phone': {
            'required': BabelStr.str(2325),
            //'请输入手机号',
            'mobile': BabelStr.str(2326) //'手机号格式错误'
          },
          'verifyCode': {
            'required': BabelStr.str(2327) //'验证码不能为空'
          }
        }
      });
      if (!app.currentUser.hasInitPwd()) {
        this.$('#js-password').rules('add', {
          'password': true,
          'required': true,
          messages: {
            'required': BabelStr.str(2328),
            //"请输入密码",
            'passowrd': BabelStr.str(2329) //"密码格式错误，密码为6到20位字母，数字组成"
          }
        });
      }
    }
  }]);
  return MDBindPhoneNavPageView;
}(_MDNavigationPageView2["default"]);

},{"101":101,"1087":1087,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1423":1423,"1426":1426,"1454":1454,"1463":1463,"1475":1475,"1477":1477,"1492":1492,"1538":1538,"32":32,"36":36,"56":56,"72":72,"765":765,"776":776}],776:[function(require,module,exports){
module.exports = '<div class="block-center bind-section bind-phone-section">\  <form action="">\    <div class="form-item">\      <input id="js-phone" type="text" name="phone" class="form-control" placeholder="<%=BabelStr.str(2325)%>">\    </div>\    <%if(!hasInitPwd){%>\      <div class="form-item">\        <input id="js-password" type="password" name="password" class="form-control" placeholder="<%=BabelStr.str(2328)%>">\      </div>\    <%}%>\    <div class="form-item  vcode-form-item">\    </div>\  </form>\  <div class="help-block"><%=BabelStr.str(7325)%></div>\  <div class="form-button-groups with-btn-right">\    <span id="js-cancel-btn" class="button default"><%=BabelStr.str(3081)%></span>\    <button id="js-submit-btn" class="button done"><%=BabelStr.str(3096)%></button>\  </div>\</div>';
},{}],739:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1426);
require(1423);
require(1463);
require(1538);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDButtonView = _interopRequireDefault(require(36));
var _EmailVerifyCodeType = _interopRequireDefault(require(100));
var _MDVerifyCodeInputView = _interopRequireDefault(require(765));
var _MDBindEmailNavPageViewTpl = _interopRequireDefault(require(775));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _SMSType = _interopRequireDefault(require(101));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDBindEmailNavPageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDBindEmailNavPageView, _MDNavigationPageView);
  function MDBindEmailNavPageView() {
    (0, _classCallCheck2["default"])(this, MDBindEmailNavPageView);
    return _callSuper(this, MDBindEmailNavPageView, arguments);
  }
  (0, _createClass2["default"])(MDBindEmailNavPageView, [{
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBindEmailNavPageView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        title: BabelStr.str(2338) //'绑定邮箱'
      });
    }
  }, {
    key: "contentTmpl",
    value: function contentTmpl() {
      return _MDBindEmailNavPageViewTpl["default"];
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBindEmailNavPageView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click #js-cancel': this.cancelClickHandler
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      props.data = {
        'hasInitPwd': app.currentUser.hasInitPwd()
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBindEmailNavPageView.prototype), "initialize", this).call(this, props);
      var self = this;
      this.vcodeFormItemView = new _MDVerifyCodeInputView["default"]({
        isPhoneFiled: false,
        placeholder: BabelStr.str(2337),
        //'邮箱验证码',
        fieldName: 'email',
        inputName: 'verifyCode',
        targetInput: this.$('#js-email'),
        verifyCodeType: _EmailVerifyCodeType["default"].BindEmail,
        sendBtnText: this.sendBtnText
      });
      this.addSubView(this.vcodeFormItemView, this.$('.vcode-form-item')[0]);
      this.cancelButtonView = new _MDButtonView["default"]({
        el: this.$('#js-cancel'),
        onClick: function onClick() {
          self.navigationWindowView.pop();
          return false;
        }
      });
      this.submitButtonView = new _MDButtonView["default"]({
        el: this.$('#js-submit-btn'),
        onClick: function onClick() {
          var validator = self.$('form').validate();
          if (validator.form()) {
            self.bindEmail();
          }
          this.navigationWindowView && this.navigationWindowView.refreshWindow();
          return false;
        }
      });
    }
  }, {
    key: "cancelClickHandler",
    value: function cancelClickHandler() {
      this.navigationWindowView.pop();
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBindEmailNavPageView.prototype), "viewDidRendered", this).call(this);
      this.$('form').validate({
        rules: {
          'email': {
            'required': true,
            'email': true
          },
          'verifyCode': {
            'required': true
          }
        },
        messages: {
          'email': {
            'required': BabelStr.str(2339),
            //'请输入邮箱',
            'email': BabelStr.str(2340) //'邮箱格式错误'
          },
          'verifyCode': {
            'required': BabelStr.str(2327) //'验证码不能为空'
          }
        }
      });
      if (!app.currentUser.hasInitPwd()) {
        this.$('#js-password').rules('add', {
          'password': true,
          'required': true,
          messages: {
            'required': BabelStr.str(2328),
            //"请输入密码",
            'passowrd': BabelStr.str(2329) //"密码格式错误，密码为6到20位字母，数字组成"
          }
        });
      }
    }
  }, {
    key: "controlActionButton",
    value: function controlActionButton(disabled) {
      this.cancelButtonView.setDisabled(disabled);
      this.submitButtonView.setDisabled(disabled);
    }
  }, {
    key: "bindEmail",
    value: function bindEmail() {
      this.controlActionButton(true);
      var formData = this.$('form').serializeArray();
      var self = this;
      var validator = this.$('form').validate();
      var submitData = _.object(_.map(formData, _.values));
      $.ajax('/user/bindEmail.do', {
        method: 'post',
        data: submitData,
        success: function success(data) {
          if (data['success']) {
            app.currentUser.setEmail(submitData.email);
            app.currentUser.set('isBindEmail', true);
            app.currentUser.setHasInitPwd();
            self.cancelClickHandler();
            _MDSnackbarView["default"].show(BabelStr.str(308)); // 邮箱绑定成功
          } else {
            var code = data['code'];
            if (code == 234 || code == 201 || code == 207) {
              validator.showErrors({
                verifyCode: data['msg']
              });
            }
          }
        },
        error: function error() {},
        complete: function complete() {
          self.controlActionButton(false);
        }
      });
    }
  }]);
  return MDBindEmailNavPageView;
}(_MDNavigationPageView2["default"]);

},{"100":100,"101":101,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1423":1423,"1426":1426,"1454":1454,"1463":1463,"1475":1475,"1538":1538,"36":36,"56":56,"72":72,"765":765,"775":775}],775:[function(require,module,exports){
module.exports = '<div class="block-center bind-section bind-email-section">\  <form>\    <div class="form-item">\      <input id="js-email" type="text" name="email" class="form-control" placeholder="<%=BabelStr.str(3164)%>">\    </div>\    <%if(!hasInitPwd){%>\      <div class="form-item">\        <input id="js-password" type="password" name="password" class="form-control" placeholder="<%=BabelStr.str(2328)%>">\      </div>\    <%}%>\    <div class="form-item vcode-form-item">\    </div>\    <div class="help-block"><%=BabelStr.str(7324)%></div>\    <div class="form-button-groups with-btn-right">\      <span id="js-cancel" class="button default"><%=BabelStr.str(3081)%></span>\      <button id="js-submit-btn" class="button done"><%=BabelStr.str(3096)%></button>\    </div>\  </form>\</div>';
},{}],765:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1435);
require(1437);
require(1498);
require(1477);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMViewBase2 = _interopRequireDefault(require(22));
var _MDVerifyCodeInputViewTpl = _interopRequireDefault(require(780));
var _regexp = _interopRequireDefault(require(106));
var _MDVcodeInputWinView = _interopRequireDefault(require(764));
var _common = _interopRequireDefault(require(1116));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
//
// 验证码表单输入组件
//
var MDVerifyCodeInputView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MDVerifyCodeInputView, _MMViewBase);
  function MDVerifyCodeInputView() {
    (0, _classCallCheck2["default"])(this, MDVerifyCodeInputView);
    return _callSuper(this, MDVerifyCodeInputView, arguments);
  }
  (0, _createClass2["default"])(MDVerifyCodeInputView, [{
    key: "tmpl",
    value: function tmpl() {
      return _MDVerifyCodeInputViewTpl["default"];
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDVerifyCodeInputView.prototype), "events", this).call(this);
      return _.extend(superE, {
        // 'click .send-vcode-btn': this.sendVCodeBtnClickHandler
      });
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDVerifyCodeInputView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        onSendCodeAction: _.noop,
        targetInput: null,
        fieldName: 'phone',
        // 获取验证码发送方式的字段名称，phone或email

        verifyCodeType: -1,
        isPhoneFiled: true,
        placeholder: BabelStr.str(489),
        inputName: 'phone',
        // 验证码字段名称，用于form表单提交
        sendBtnText: BabelStr.str(2385)
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDVerifyCodeInputView.prototype), "initialize", this).call(this, props);
      this.$targetInput = $(this.targetInput);
      this.$senSmsCodeBtn = this.$('.send-vcode-btn');
      this.reg = this.isPhoneFiled ? _regexp["default"].phone : _regexp["default"].email;
    }
  }, {
    key: "ensureDivHasUniqueId",
    value: function ensureDivHasUniqueId(divElement) {
      // 检查是否已经是 Element 对象（避免选择器字符串误传）
      if (!(divElement instanceof HTMLElement)) {
        console.error('请传入一个 DOM 元素对象');
        return;
      }

      // 如果没有 id，则生成一个唯一 id
      if (!divElement.id) {
        // 生成唯一 id（基于时间戳 + 随机数）
        var uniqueId = 'div-' + Date.now() + '-' + Math.floor(Math.random() * 10000);
        divElement.id = uniqueId;
      }
    }
  }, {
    key: "sendSMSCode",
    value: function sendSMSCode(code) {
      var _this = this;
      var data = {};
      data[this.fieldName] = this.value;
      data['verifyCodeType'] = this.verifyCodeType;
      var url = "/account/sendEmailVerifyCode.do";
      if (this.isPhoneFiled) {
        if (!app.ep.isPrivateCloud()) {
          var selectedCountryData = this.$targetInput.intlTelInput("getSelectedCountryData") || {};
          if (selectedCountryData.dialCode && selectedCountryData.dialCode != '86') {
            data[this.fieldName] = selectedCountryData.dialCode + "-" + data[this.fieldName];
          }
        }
        url = "/account/getSMSCode.do";
        data.token = _common["default"].getEncrptToken();
      }
      // data.imageVerifyCode = code
      $.ajax(url, {
        method: 'post',
        data: data,
        success: function success(data) {
          if (!data['success']) {
            // if(data.code == 235) {
            //   this.codeWin.vcodeError()
            // } else {
            //   this.codeWin.close()
            var validator = _this.$targetInput.closest('form').validate();
            var error = {};
            error[_this.$targetInput.attr('name')] = data['msg'];
            validator.showErrors(error);
            // }

            _this.reset();
          } else {
            // this.codeWin.close()
          }
        }
      });
    }
  }, {
    key: "getVcode",
    value: function getVcode(callback) {
      // if(this.isPhoneFiled) {
      this.codeWin = new _MDVcodeInputWinView["default"]({
        success: function success(code) {
          callback(code);
        }
      });
      this.codeWin.show();
      // } else {
      //   callback()
      // }
    }
  }, {
    key: "sendVCodeBtnClickHandler",
    value: function sendVCodeBtnClickHandler($e) {
      if (this.$senSmsCodeBtn.hasClass('disabled')) {
        return;
      }
      var value = $.trim(this.$targetInput.val());
      this.value = value;
      var validate = true;
      if (value.length == 0) {
        validate = false;
      } else if (!this.reg.test(value)) {
        validate = false;
      }
      var validator = $(this.targetInput).closest('form').validate();
      if (!validate) {
        validator.element(this.targetInput);
        return;
      }
      if (!validator.element(this.targetInput)) {
        return;
      }
      if (_.isFunction(this.interceptor) && this.interceptor()) {
        return;
      }
      return true;
      // this.getVcode((code)=>{
      //   this.sendSMSCode(code)
      // })
      // //
      // // 60秒间隔
      // //
      // let count = 60;
      // this.$senSmsCodeBtn.addClass('disabled');
      // let desc = BabelStr.str(7323) + (count);
      // this.$senSmsCodeBtn.text(desc);
      // this.timerId = setInterval(() => {
      //   desc = BabelStr.str(7323) + (--count);
      //   this.$senSmsCodeBtn.text(desc);
      //   if (count == 0) {
      //     this.reset();
      //   }
      // }, 1000);
    }
  }, {
    key: "reset",
    value: function reset() {
      this.$senSmsCodeBtn.removeClass('disabled');
      this.$senSmsCodeBtn.text(BabelStr.str(4737));
      clearInterval(this.timerId);
    }
  }, {
    key: "render",
    value: function render(data) {
      data = _.extend(data, {
        'inputName': this.inputName,
        'placeholder': this.placeholder,
        sendBtnText: this.sendBtnText
      });
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDVerifyCodeInputView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDVerifyCodeInputView.prototype), "viewDidRendered", this).call(this);
      if (!$(".capcha-block").length) {
        $("body").append("<div class=\"capcha-block\"></div>");
      }
      var zIndex = 9999999999;
      var btn = this.$senSmsCodeBtn[0];
      var self = this;
      this.ensureDivHasUniqueId(btn);
      $('.capcha-block').slideVerify({
        baseUrl: location.origin,
        //服务器请求地址, 默认地址为安吉服务器;
        mode: 'pop',
        //展示模式
        containerId: btn.id,
        //pop模式 必填 被点击之后出现行为验证码的元素id
        lan: BabelStr.getCurrentLanguage(),
        imgSize: {
          //图片的大小对象,有默认值{ width: '310px',height: '155px'},可省略
          width: '400px',
          height: '200px'
        },
        barSize: {
          //下方滑块的大小对象,有默认值{ width: '310px',height: '50px'},可省略
          width: '400px',
          height: '40px'
        },
        beforeCheck: function beforeCheck() {
          //检验参数合法性的函数  mode ="pop"有效
          return self.sendVCodeBtnClickHandler();
        },
        ready: function ready() {
          $('.capcha-block')[0].style.zIndex = zIndex;
        },
        //加载完毕的回调
        success: function success(params) {
          //成功的回调
          // params为返回的二次验证参数 需要在接下来的实现逻辑回传服务器
          // 例如: login($.extend({}, params))
          self.sendSMSCode();
        },
        error: function error() {} //失败的回调
      });
    }
  }, {
    key: "viewDidUnRendered",
    value: function viewDidUnRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDVerifyCodeInputView.prototype), "viewDidUnRendered", this).call(this);
      $('.capcha-block').remove();
    }
  }]);
  return MDVerifyCodeInputView;
}(_MMViewBase2["default"]);

},{"106":106,"1116":1116,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1435":1435,"1437":1437,"1454":1454,"1463":1463,"1475":1475,"1477":1477,"1498":1498,"22":22,"764":764,"780":780}],780:[function(require,module,exports){
module.exports = '<div class="vcode-input">\  <div class="input-section">\    <input type="text" name="<%=inputName%>" class="form-control" placeholder="<%=placeholder%>">\  </div>\  <span class="send-vcode-btn">\        <span class="btn-text"><%=sendBtnText%></span>\  </span>\  <div class="input-error red f-hide"></div>\</div>';
},{}],764:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1498);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDWindowView2 = _interopRequireDefault(require(93));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDVcodeInputWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDVcodeInputWinView, _MDWindowView);
  function MDVcodeInputWinView() {
    (0, _classCallCheck2["default"])(this, MDVcodeInputWinView);
    return _callSuper(this, MDVcodeInputWinView, arguments);
  }
  (0, _createClass2["default"])(MDVcodeInputWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<div class=\" sign-image-vcode flex-align center \">\n      <img class=\"j-vcode-2 v-code mgr-20\" src=\"/validate/getValidateCode.do\" alt='<%=BabelStr.str(4736)%>' id=\"j-vcode-img\" data-tooltip=\"<%=BabelStr.str(9900)%>\"\n      data-tooltip-dir=\"bottom\" />\n      <input  type=\"text\" class=\"j-vcode \"\n        name=\"imageVerifyCode\" placeholder=\"<%=BabelStr.str(505)%>\"\n        autocomplete=\"off\">\n  </div>";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDVcodeInputWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " sign-alert-contain ");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDVcodeInputWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .v-code': this.vcodeChanged
      });
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      opt.title = BabelStr.str(504);
      opt.buttons = [{
        label: BabelStr.str(154),
        type: 'done',
        autoClose: false,
        onClick: function onClick(button, $e) {
          var vcode = $.trim(this.$('.j-vcode').val());
          opt.success(vcode);
          this.setActionButtonDisabled(true);
          return false;
        }
      }];
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDVcodeInputWinView.prototype), "initialize", this).call(this, opt);
    }
  }, {
    key: "vcodeError",
    value: function vcodeError() {
      _MDMessageView["default"].error(BabelStr.str(7398), this.$body);
      this.setActionButtonDisabled(false);
      this.vcodeChanged();
    }
  }, {
    key: "vcodeChanged",
    value: function vcodeChanged() {
      this.$('.j-vcode-2').attr('src', "/validate/getValidateCode.do?t=" + Math.round(Math.random() * 1000));
    }
  }, {
    key: "pushEditProjectInfoView",
    value: function pushEditProjectInfoView(fileInfo) {
      var pageView = new MDProjectCreateInfoPageView({
        type: 1,
        fileId: fileInfo['fileId'],
        showCreateProjectSuccess: true
      });
      this.hideBackBtn = true;
      this.push(pageView);
    }
  }]);
  return MDVcodeInputWinView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"1498":1498,"55":55,"93":93}],526:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1423);
require(1463);
require(1487);
require(1538);
require(1545);
require(1543);
require(1439);
var _MDAlertView = _interopRequireDefault(require(32));
var _MDWindowView = _interopRequireDefault(require(93));
var _MDMessageView = _interopRequireDefault(require(55));
/**
 *  Upload Headportrait View
 *  Created by dai
 *  2016.11.9
 */

var MDUploadHeadWindowView = _MDWindowView["default"].extend({
  contentTmpl: '<div class="avatar-upload">\
      <button type="button" class="button done"><%=BabelStr.str(3579)%></button>\
      <input type="file" class="avatar-input" id="avatarInput" name="avatar_file" accept=".jpg,.jpeg,.png">\
    </div>\
    <div class="avatar-row">\
      <div class="avatar-wrapper"></div>\
      <div class="preview-wrapper">\
      <h4><%= previewTitle %></h4>\
        <div class="avatar-preview preview-lg"></div>\
        <div class="avatar-preview preview-lg prevew-circle"></div>\
      </div>\
    </div>',
  className: function className() {
    var superCls = _MDWindowView["default"].prototype.className.call(this);
    return superCls + " avatar-window";
  },
  initProps: function initProps() {
    var superP = _MDWindowView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      url: '',
      // just the img url

      uploadUrl: '',
      // img submit url

      aspectRatio: 1,
      // width and height radio of crop box, defult is free radio

      viewMode: 0,
      // 0: the crop box is just within the container 1: the crop box should be within the canvas

      fileInfo: null,
      onSuccess: _.noop,
      onError: _.noop,
      active: false,
      //has croppered or not

      size: null,
      //limit size, default MB please

      needRadioView: true,
      onlyPng: false
    });
  },
  events: function events() {
    var superE = _MDWindowView["default"].prototype.events.call(this);
    return _.extend(superE, {
      'change #avatarInput': this._onFileChangeEventHandler
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    var previewTitle = opt.previewTitle ? opt.previewTitle : BabelStr.str(3580);
    opt.title ? opt.title : BabelStr.str(2322);
    opt.data = {
      previewTitle: previewTitle
    };
    opt.width = 600;
    opt.onShow = function () {
      self.startCropper();
    };
    opt.buttons = [{
      label: BabelStr.str(3081),
      type: 'default'
    }, {
      label: BabelStr.str(3096),
      type: 'done',
      enabled: false,
      onClick: function onClick() {
        self.submit();
      }
    }];
    _MDWindowView["default"].prototype.initialize.call(this, opt);
    this.$avatarWrapper = this.$('.avatar-wrapper');
    this.$avatarInput = this.$('#avatarInput');
    this.$avatarPreview = this.$('.avatar-preview');
    if (!this.needRadioView) {
      this.$(".prevew-circle").remove();
    }
  },
  /**
   * 裁剪并显示
   */
  startCropper: function startCropper() {
    var self = this;
    if (this.size) {
      var fileSize = this.fileInfo['size'];
      var limitSize = this.size * 1024 * 1024;
      if (fileSize > limitSize) {
        _MDMessageView["default"].error(BabelStr.str(3581, {
          "size": this.size
        }), this.$body);
        return;
      }
    }
    if (this.url) {
      URL.revokeObjectURL(this.url); // Revoke the old one
    }
    var reader = new FileReader();
    reader.onload = function () {
      if (self.checkImg(self.fileInfo["name"])) {
        self.url = reader.result;
        if (self.active) {
          self.$img.cropper('replace', self.url);
        } else {
          self.$img = $('<img src="' + self.url + '">');
          self.$avatarWrapper.empty().html(self.$img);
          self.$img.cropper({
            guides: false,
            aspectRatio: self.aspectRatio,
            viewMode: self.viewMode,
            autoCropArea: 1,
            responsive: false,
            //a bug when resize the window
            preview: '.avatar-preview'
          });
          self.active = true;
        }
        self.setActionButtonDisabledByIndex(false, 1);
      } else {
        self.checkErrorCallback();
      }
    };
    if (this.fileInfo) {
      reader.readAsDataURL(this.fileInfo);
    }
    /*this.url = URL.createObjectURL(this.fileInfo);
    if (this.active) {
      this.$img.cropper('replace', this.url);
    } else {
      this.$img = $('<img src="' + this.url + '">');
      this.$avatarWrapper.empty().html(this.$img);
      this.$img.cropper({
        guides: false,
        aspectRatio: 1, //width and height radio of crop box, defult is free radio
        viewMode: 1,  //the crop box should be within the canvas
        responsive: false, //a bug when resize the window
        preview: '.avatar-preview'
      });
      this.active = true;
    }*/
  },
  _onFileChangeEventHandler: function _onFileChangeEventHandler($e) {
    var file = $e.target.files[0];
    this.fileInfo = file;
    this.startCropper();
  },
  submit: function submit() {
    var self = this;
    this.$img.cropper('getCroppedCanvas', {
      width: 400,
      height: 400
    }).toBlob(function (blob) {
      var formData = new FormData();
      if (self.uploadUrl) {
        formData.append('file', blob);
        formData.append('fileName', self.fileName);
        $.ajax(self.uploadUrl, {
          type: 'post',
          data: formData,
          dataType: 'json',
          processData: false,
          contentType: false,
          success: function success(data) {
            var fileUrl = URL.createObjectURL(blob);
            self.onSuccess(fileUrl, data, blob);
          },
          error: function error(err) {
            self.onError(err);
          }
        });
      } else {
        var fileUrl = URL.createObjectURL(blob);
        self.onSuccess(fileUrl, null, blob);
      }
    });
    return false;
  },
  checkImg: function checkImg(name) {
    if (!this.onlyPng || MMCommonFun.getFileExtension1(name).toLowerCase() == "png") {
      return true;
    } else {
      return false;
    }
  },
  checkErrorCallback: function checkErrorCallback() {
    var _this = this;
    new _MDAlertView["default"]().show({
      title: BabelStr.str(3582),
      message: BabelStr.str(3583),
      buttons: [{
        label: BabelStr.str(154),
        autoClose: true,
        onClick: function onClick() {
          _this.close();
        }
      }]
    });
  }
});
var _default = exports["default"] = MDUploadHeadWindowView;

},{"1184":1184,"1423":1423,"1439":1439,"1454":1454,"1463":1463,"1487":1487,"1538":1538,"1543":1543,"1545":1545,"32":32,"55":55,"93":93}],731:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
var _aiLoader = _interopRequireDefault(require(346));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * AI Token 设置面板的懒加载占位组件。
 * 首次激活时动态加载 AI bundle，并用真实面板替换自身。
 */
var LazyAITokenPanelView = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(LazyAITokenPanelView, _MDTabPanelView);
  function LazyAITokenPanelView() {
    (0, _classCallCheck2["default"])(this, LazyAITokenPanelView);
    return _callSuper(this, LazyAITokenPanelView);
  }
  (0, _createClass2["default"])(LazyAITokenPanelView, [{
    key: "tmpl",
    value: function tmpl() {
      return '<div class="ai-token-loading"><div class="loading-spinner"></div><span class="loading-text">加载中...</span></div>';
    }
  }, {
    key: "onActived",
    value: function onActived() {
      var _this = this;
      if (this.replaced) {
        this.realPanel && this.realPanel.onActived && this.realPanel.onActived();
        return;
      }
      if (this.loading) return;
      this.loading = true;
      (0, _aiLoader["default"])().then(function (MDAI) {
        var realPanel = new MDAI.MDAITokenPanelView({});
        var parent = _this.superView;
        if (parent) {
          // 用真实面板替换懒加载占位面板，避免双层 tab-panel 嵌套
          var wasActive = parent.curActiveTabPanelView === _this;
          parent.replaceSubView(realPanel, _this, parent.$tabPanelWrapper && parent.$tabPanelWrapper[0]);
          // 同步更新 tabs 数组中的引用
          var idx = parent.indexOfSubView(realPanel);
          if (parent.tabs && parent.tabs[idx]) {
            parent.tabs[idx].tabPanelView = realPanel;
          }
          if (wasActive) {
            parent.curActiveTabPanelView = realPanel;
            realPanel.$el.addClass('tab-panel-active');
          }
        }
        _this.realPanel = realPanel;
        _this.replaced = true;
        realPanel.onActived && realPanel.onActived();
      })["catch"](function (error) {
        _this.loading = false;
        _this.$el.html('<div class="loading-error">加载失败，请重试</div>');
        console.error(error);
      });
    }
  }]);
  return LazyAITokenPanelView;
}(_MDTabPanelView2["default"]);

},{"1175":1175,"1179":1179,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"346":346,"81":81}],346:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = loadAIBundle;
require(1421);
require(1477);
require(1489);
require(1463);
require(1471);
var aiBundlePromise;
var aiBundleLoadFailed = false;
var aiBundleUnsupported = false;
var loadAttempts = 0;
var MAX_RETRY_ATTEMPTS = 3;

// 单入口页面（approval/admin/enterprise/panel/msboxup 等）未实际使用 AI 功能，
// 且未随页面加载 AI 所需的公共 bundle 与全局库，强行加载 AI bundle 会因模块
// ID 冲突/全局依赖缺失而报错。此处直接标记为不支持，避免加载。
function isUnsupportedAIPage(scripts) {
  var markers = ['MDMyApprovalApp-bundle', 'MAApplication-bundle', 'MEApplication-bundle', 'MDFilePanelRoot-bundle', 'MDBoxUploaderApp-bundle', 'approval-mini', 'admin-mini', 'ad-mini', 'ep-mini', 'panel-mini', 'msboxup-mini'];
  for (var i = 0; i < scripts.length; i++) {
    var src = scripts[i].src;
    for (var j = 0; j < markers.length; j++) {
      if (src.indexOf(markers[j]) !== -1) return true;
    }
  }
  return false;
}
function getAIBundleUrl() {
  var scripts = document.scripts;
  var version = '';
  // 单入口页面未实际使用 AI，直接拦截不加载 AI bundle
  if (isUnsupportedAIPage(scripts)) return null;
  for (var i = 0; i < scripts.length; i++) {
    var src = scripts[i].src;
    var match = src.match(/[?&]v=([^&]+)/);
    if (match) version = match[1];
    // 开发环境：MDAI-base-bundle.js / MDApplication-bundle.js
    if (src.indexOf('MDApplication-bundle') !== -1 || src.indexOf('MDAI-base-bundle') !== -1) {
      return '/javascript/moladisk/MDAI-bundle.js';
    }
    // 生产环境：MDAI-base-mini.js / app-mini.js
    if (src.indexOf('MDAI-base-mini') !== -1 || src.indexOf('app-mini') !== -1) {
      return '/dist/js/MDAI-mini.js' + (version ? '?v=' + version : '');
    }
    // share 页面：使用 share 专属 factor-bundle 三件套，AI bundle 与主 bundle 共享模块注册表
    if (src.indexOf('MDShareApplicationBase-bundle') !== -1) {
      return '/javascript/moladisk/share-ai-bundle.js';
    }
    if (src.indexOf('share-base-mini') !== -1) {
      return '/dist/js/share-ai-mini.js' + (version ? '?v=' + version : '');
    }
    if (src.indexOf('share-mini') !== -1) {
      return '/dist/js/share-ai-mini.js' + (version ? '?v=' + version : '');
    }
    if (src.indexOf('MDShareApplication-bundle') !== -1) {
      return '/javascript/moladisk/share-ai-bundle.js';
    }
  }
  // 兜底：返回开发环境路径
  return '/javascript/moladisk/MDAI-bundle.js';
}
function showError(message) {
  if (typeof MDSnackbarView !== 'undefined') {
    MDSnackbarView.show(message);
  } else if (typeof console !== 'undefined') {
    console.error('AI Bundle Error:', message);
  }
}
function loadAIBundle() {
  if (window.MDAI && window.MDAI.MDAIPanelView && window.MDAI.MDRightAIPanelView) {
    return Promise.resolve(window.MDAI);
  }
  if (aiBundleUnsupported) {
    return Promise.reject(new Error('当前页面不支持 AI 功能'));
  }
  var bundleUrl = getAIBundleUrl();
  if (!bundleUrl) {
    aiBundleUnsupported = true;
    return Promise.reject(new Error('当前页面不支持 AI 功能'));
  }
  if (aiBundleLoadFailed && loadAttempts >= MAX_RETRY_ATTEMPTS) {
    var err = new Error('AI bundle loading failed after ' + MAX_RETRY_ATTEMPTS + ' attempts');
    showError('AI功能加载失败，请刷新页面重试');
    return Promise.reject(err);
  }
  if (aiBundleLoadFailed) {
    aiBundlePromise = null;
    aiBundleLoadFailed = false;
  }
  if (aiBundlePromise) return aiBundlePromise;
  loadAttempts++;
  aiBundlePromise = new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    script.src = bundleUrl;
    script.async = true;
    script.onload = function () {
      if (window.MDAI && window.MDAI.MDAIPanelView) {
        resolve(window.MDAI);
      } else {
        aiBundleLoadFailed = true;
        aiBundlePromise = null;
        var err = new Error('MDAI-bundle loaded without exports');
        if (loadAttempts < MAX_RETRY_ATTEMPTS) {
          showError('AI功能加载中，请稍候...');
        } else {
          showError('AI功能加载失败，请刷新页面重试');
        }
        reject(err);
      }
    };
    script.onerror = function () {
      aiBundleLoadFailed = true;
      aiBundlePromise = null;
      var err = new Error('Unable to load MDAI-bundle');
      if (loadAttempts < MAX_RETRY_ATTEMPTS) {
        showError('AI功能加载中，请稍候...');
      } else {
        showError('AI功能加载失败，请检查网络连接');
      }
      reject(err);
    };
    document.head.appendChild(script);
  });
  return aiBundlePromise;
}

},{"1421":1421,"1454":1454,"1463":1463,"1471":1471,"1477":1477,"1489":1489}],259:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMCollectionBase = _interopRequireDefault(require(20));
var _MDGroupInfo = _interopRequireDefault(require(260));
var MDGroupCollection = _MMCollectionBase["default"].extend({
  model: _MDGroupInfo["default"],
  // 定义 comparator 函数，根据 name 属性排序
  comparator: function comparator(model) {
    return model.get('groupName').toLowerCase(); // 转换为小写以进行不区分大小写的排序
  }
});
var _default = exports["default"] = MDGroupCollection;

},{"1184":1184,"1454":1454,"20":20,"260":260}],567:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
var _MDPaginationView = _interopRequireDefault(require(61));
var _MDDepFilePermissionItem = _interopRequireDefault(require(563));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MEDepRoleHelpWindow = _interopRequireDefault(require(130));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } //
// 部门文件附加权限-部门成员页
// Created by jichao
// 2018.1.15
var MDDepRolePermissionPageView = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(MDDepRolePermissionPageView, _MDTabPanelView);
  function MDDepRolePermissionPageView() {
    (0, _classCallCheck2["default"])(this, MDDepRolePermissionPageView);
    return _callSuper(this, MDDepRolePermissionPageView, arguments);
  }
  (0, _createClass2["default"])(MDDepRolePermissionPageView, [{
    key: "tmpl",
    value:
    // el: '<div class="dep-file-perm-root"></div>',

    function tmpl() {
      return "\n      <div class = \"perm-disp\">\n        <div class=\"help-block mgb-10\"><%=BabelStr.str(2877)%></div>\n        <div class = \"table-root\">\n          <div class=\"table with-layout-fixed f-tc\">\n            <div class=\"head head-line _4col\">\n              <div><%=defaultRrole%> <span class=\"help\">?</span></div>\n              <div><%=perm%></div>\n              <div><%=endTime%></div>\n              <div><%=BabelStr.str(3428)%></div>\n            </div>\n          </div>\n        </div>\n        <div class=\"loader\"></div>\n        <div class=\"table-content user-list\"></div>\n        <div class=\"page-bar\"></div>\n      </div>";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepRolePermissionPageView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        inWin: false,
        startIndex: 0,
        pageSize: 10,
        data: {
          'user': BabelStr.str(577),
          // 用户
          'perm': BabelStr.str(2510),
          // 权限
          'defaultRrole': BabelStr.str(2509),
          'endTime': BabelStr.str(2511)
        }
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepRolePermissionPageView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .help': this._helpClickHandle
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepRolePermissionPageView.prototype), "className", this).call(this);
      return "".concat(superCls, " dep-role-perm-root");
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      this.$('.loader').hide();
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepRolePermissionPageView.prototype), "initialize", this).call(this, opt);
      this.permissionItems = [];
      this.$('.line').remove();
      var self = this;
      this.loadForFile();
      this.fileHasAppendedPermissionInChildren();
    }
  }, {
    key: "_helpClickHandle",
    value: function _helpClickHandle() {
      _MEDepRoleHelpWindow["default"].show();
    }
  }, {
    key: "onActived",
    value: function onActived() {
      _.isFunction(this.onTabActived) && this.onTabActived();
    }
  }, {
    key: "onAllUserPermissionChanged",
    value: function onAllUserPermissionChanged(id) {
      this.allUserPermissionId = id;
      for (var i = 0; i < this.subViews.length; i++) {
        var subView = this.subViews[i];
        if (subView !== this.pageBarView) {
          subView.allUserPermissionChanged(id);
        }
      }
    }
  }, {
    key: "loadForFile",
    value: function loadForFile() {
      var self = this;
      _MDSpinnerloaderView["default"].clearFrom(this.$('.loader')[0]);
      var $el = this.$el;
      _MDSpinnerloaderView["default"].showIn(this.$('.loader')[0]);
      self.$('.table-content').hide();
      self.$('.table-root').hide();
      this.$('.loader').show();
      MMEnterpriseController.getAppendPermissionDepRoles(this.fileInfo.getFileId(), function (roles) {
        self.$('.table-content').show();
        self.$('.table-root').show();
        self.$('.loader').hide();
        self._refresh(roles);
        _MDSpinnerloaderView["default"].clearFrom(self.$('.loader')[0]);
      }, function (code, errMsg) {
        _MDSpinnerloaderView["default"].clearFrom($el[0]);
        _MDSnackbarView["default"].show(errMsg); // ('获取文件权限失败')
      });
      self.$('.perm-disp').show();
    }
  }, {
    key: "fileHasAppendedPermissionInChildren",
    value: function fileHasAppendedPermissionInChildren() {
      var _this = this;
      MMEnterpriseController.fileHasAppendedPermissionInChildren(this.fileInfo.getFileId(), function (sign) {
        _this.hasAppendedPermission = sign;
        // this.loadForFile()
      });
    }
  }, {
    key: "_refresh",
    value: function _refresh(data) {
      var _this2 = this;
      for (var _i = 0; _i < this.subViews.length; _i++) {
        var subView = this.subViews[_i];
        if (subView !== this.pageBarView) {
          this.removeSubView(subView);
          _i--;
        }
      }
      for (var i = 0; i < data.length; i++) {
        var role = data[i];
        role.type = 1;
        var permissionItem = new _MDDepFilePermissionItem["default"]({
          data: role,
          roleArr: this.roleArr,
          fileInfo: this.fileInfo,
          allAppendedRoleId: this.allUserPermissionId,
          roles: this.roles,
          needBasicRoleLine: false,
          isRole: 1,
          hasAppendedPermission: function hasAppendedPermission() {
            return _this2.hasAppendedPermission;
          },
          changeHasAppendedPermission: function changeHasAppendedPermission(sign) {
            _this2.hasAppendedPermission = sign;
          }
        });
        this.addSubView(permissionItem, this.$('.user-list')[0]);
      }
      ;
    }
  }]);
  return MDDepRolePermissionPageView;
}(_MDTabPanelView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"130":130,"1454":1454,"1463":1463,"1475":1475,"563":563,"61":61,"72":72,"76":76,"81":81}],566:[function(require,module,exports){
"use strict";

require(1475);
require(1429);
require(1437);
require(1478);
require(1439);
require(1419);
require(1477);
require(1503);
require(1500);
require(1502);
require(1422);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1423);
require(1463);
require(1480);
require(1487);
require(1538);
require(1541);
require(1413);
var _slicedToArray2 = _interopRequireDefault(require(1192));
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTabPanelView2 = _interopRequireDefault(require(81));
var _MDPaginationView = _interopRequireDefault(require(61));
var _MDDepFilePermissionItem = _interopRequireDefault(require(563));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MEDepRoleHelpWindow = _interopRequireDefault(require(130));
var _MDFilePermHelpWinView = _interopRequireDefault(require(578));
var _MDLoadMaskView = _interopRequireDefault(require(49));
var _MDCheckboxView = _interopRequireDefault(require(37));
var _MDAlertView = _interopRequireDefault(require(32));
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } //
// 部门文件附加权限-部门成员页
// Created by jichao
// 2018.1.15
// 新版问号图标（help-circle，取自设计稿，stroke 继承 currentColor）
var HELP_ICON = "<svg class=\"help-icon\" viewBox=\"0 0 24 24\" width=\"16\" height=\"16\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.6\" stroke-linecap=\"round\"><circle cx=\"12\" cy=\"12\" r=\"9\"/><path d=\"M9.6 9a2.5 2.5 0 0 1 4.8 1c0 1.7-2.4 2-2.4 3.5M12 16.8h.01\"/></svg>";
var MDDepMemberFilePermissionTabView = exports["default"] = /*#__PURE__*/function (_MDTabPanelView) {
  (0, _inherits2["default"])(MDDepMemberFilePermissionTabView, _MDTabPanelView);
  function MDDepMemberFilePermissionTabView() {
    (0, _classCallCheck2["default"])(this, MDDepMemberFilePermissionTabView);
    return _callSuper(this, MDDepMemberFilePermissionTabView, arguments);
  }
  (0, _createClass2["default"])(MDDepMemberFilePermissionTabView, [{
    key: "tmpl",
    value:
    // el: '<div class="dep-file-perm-root"></div>',

    function tmpl() {
      return "\n      <div class = \"perm-disp\">\n        <div class=\"\">\n          <div class=\"boldfont1 mgtb-10\"><%=(belongProject ? BabelStr.str(6031) : BabelStr.str(2800))%></div>\n          <div class=\"perm-priority-line\"><%=BabelStr.str(51366)%><span class=\"perm-help-btn\" data-help=\"priority\">".concat(HELP_ICON, "</span></div>\n          <div class=\"perm-priority-sub\"><%=BabelStr.str(51367)%></div>\n          <div class=\"loader\"></div>\n        </div>\n        <div class=\"table with-layout-fixed head-line _4col f-tc\">\n          <div><%=user%></div>\n          <div><%=perm%><span class=\"perm-help-btn\" data-help=\"setting\">").concat(HELP_ICON, "</span></div>\n          <div><%=endTime%></div>\n          <div><%=BabelStr.str(3428)%></div>\n        </div>\n        <div class=\"table-content all-user\"></div>\n        <div class=\"flex-align middle\">\n          <div class=\"boldfont1 mgtb-10\"><%=(belongProject ? BabelStr.str(2816) : BabelStr.str(2530))%>\n          </div>\n          <span class=\"perm-help-btn\" data-help=\"everyone\">").concat(HELP_ICON, "</span>\n          <span class=\"perm-sub-note\"><%=BabelStr.str(51368)%></span>\n        </div>\n        <div class=\"search-box mgtb-10\">\n          <i class=\"icon-search\"></i>\n          <input type=\"text\" class=\"search-input\" placeholder=<%=BabelStr.str(579)%>>\n        </div>\n        <div class = \"table-root\">\n          <div class=\"table with-layout-fixed f-tc\">\n            <div class=\"head head-line _5col\">\n              <div class=\"m-chb\">\n                <div class=\"box\"></div>\n                <span class=\"label\"><%=user%></span>\n              </div>\n              <div><%=defaultRrole%> <span class=\"perm-help-btn\">").concat(HELP_ICON, "</span></div>\n              <div><%=perm%><span class=\"perm-help-btn\" data-help=\"setting\">").concat(HELP_ICON, "</span></div>\n              <div><%=endTime%></div>\n              <div><%=BabelStr.str(3428)%></div>\n            </div>\n          </div>\n        </div>\n        <div class=\"table-content user-list\"></div>\n        <div class=\"page-bar\"></div>\n        <div class=\"mgt-10 ope-type-content f-hide\"></div>\n      </div>");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepMemberFilePermissionTabView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        inWin: false,
        startIndex: 0,
        pageSize: 10,
        data: {},
        selectedUsers: new Set()
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepMemberFilePermissionTabView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .perm-help-btn": this._helpClickHandle,
        "click .head-line .m-chb": this._toggleAllChecked,
        "input .search-input": this.conditionChanged
      });
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        belongProject: this.fileInfo.belongProject() || this.fileInfo.belongTransmittalProject(),
        user: BabelStr.str(577),
        // 用户
        perm: BabelStr.str(2510),
        // 权限
        defaultRrole: BabelStr.str(2509),
        endTime: BabelStr.str(2511)
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepMemberFilePermissionTabView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepMemberFilePermissionTabView.prototype), "className", this).call(this);
      return "".concat(superCls, " dep-file-perm-root");
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      this.$(".loader").hide();
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepMemberFilePermissionTabView.prototype), "initialize", this).call(this, opt);
      this.permissionItems = [];
      this.$(".line").remove();
      var self = this;
      this.loadForFile();
      this.renderPageBar();
      this.fileHasAppendedPermissionInChildren();
      if (this.fileInfo.belongProject() || this.fileInfo.belongTransmittalProject()) {
        this.alluserType = 5; // 项目文件夹内的所有人设置
      } else {
        this.alluserType = 3; // 部门文件夹内的所有人设置
      }
    }
  }, {
    key: "onActived",
    value: function onActived() {
      _.isFunction(this.onTabActived) && this.onTabActived();
    }
  }, {
    key: "_toggleAllChecked",
    value: function _toggleAllChecked($e) {
      var _this = this;
      var ids = _.pluck(this.users, "id");
      if ($($e.target).closest(".m-chb").hasClass("checked")) {
        _.each(this.subViews, function (subView) {
          if (subView instanceof _MDDepFilePermissionItem["default"]) {
            subView.removeChecked();
          }
        });
        _.each(ids, function (id) {
          _this.selectedUsers["delete"](id);
        });
      } else {
        _.each(this.subViews, function (subView) {
          if (subView instanceof _MDDepFilePermissionItem["default"]) {
            subView.addChecked();
          }
        });
        _.each(ids, function (id) {
          _this.selectedUsers.add(id);
        });
      }
      this.selectChanged();
    }
  }, {
    key: "_helpClickHandle",
    value: function _helpClickHandle($e) {
      // data-help 标记的新问号弹出说明弹窗；部门角色问号保持原有权限列表入口
      var helpType = $($e.target).closest(".perm-help-btn").data("help");
      var helpMap = {
        priority: [51369, 51370],
        everyone: [51371, 51372],
        setting: [51373, 51374]
      };
      if (helpType && helpMap[helpType]) {
        var _helpMap$helpType = (0, _slicedToArray2["default"])(helpMap[helpType], 2),
          titleId = _helpMap$helpType[0],
          bodyId = _helpMap$helpType[1];
        var win = new _MDFilePermHelpWinView["default"]({
          helpTitle: BabelStr.str(titleId),
          helpHtml: BabelStr.str(bodyId)
        });
        win.show();
        return;
      }
      var sign = this.fileInfo.belongProject() || this.fileInfo.belongTransmittalProject();
      _MEDepRoleHelpWindow["default"].show(sign);
    }
  }, {
    key: "conditionChanged",
    value: function conditionChanged() {
      this.loadForFile();
    }
  }, {
    key: "loadForFile",
    value: function loadForFile() {
      var self = this;
      var searchKey = this.$(".search-input").val();
      _MDSpinnerloaderView["default"].clearFrom(this.$(".loader")[0]);
      var $el = this.$el;
      // MDSpinnerloaderView.showIn(this.$('.loader')[0])
      // self.$('.table-content').hide()
      // self.$('.table-root').hide()
      this.$(".loader").hide();
      var maskTimeout = setTimeout(function () {
        maskTimeout = null;
        _MDLoadMaskView["default"].show();
      }, 500);
      MMEnterpriseController.getAppendPermissionUserList(this.fileInfo.getFileId(), this.startIndex, this.pageSize, searchKey, function (userInfos, total, all, sub_inheritance) {
        self.subCheckbox && self.subCheckbox.setChecked(sub_inheritance, true);
        if (maskTimeout) {
          clearTimeout(maskTimeout);
        } else {
          _MDLoadMaskView["default"].remove();
        }
        self.$(".table-content").show();
        self.$(".table-root").show();
        self.$(".loader").hide();
        var allName = BabelStr.str(2800);
        if (self.fileInfo.belongProject() || self.fileInfo.belongTransmittalProject()) {
          allName = BabelStr.str(6031);
        }
        _.isFunction(self.onAllUserPermissionChanged) && self.onAllUserPermissionChanged(all.appendedRoleId);
        var alluser = {
          email: allName,
          id: "-1",
          name: allName,
          registered: 1,
          roleId: -1,
          roleName: BabelStr.str(6150),
          appendedRoleId: all && all.appendedRoleId,
          appendedRoleName: all && all.appendedRoleName,
          appendedDeadline: all && all.appendedDeadline,
          parentDeadline: all && all.parentDeadline,
          parentRoleId: all && all.parentRoleId,
          parentRoleName: all && all.parentRoleName,
          operatorName: all && all.operatorName,
          operator: all && all.operator,
          type: self.alluserType
        };
        self._refresh(userInfos, alluser);
        self.setLength(total, self.startIndex);
        // MDSpinnerloaderView.clearFrom(self.$('.loader')[0])
        self.selectChanged();
      }, function (codeError) {
        if (maskTimeout) {
          clearTimeout(maskTimeout);
        } else {
          _MDLoadMaskView["default"].remove();
        }
        // MDSpinnerloaderView.clearFrom($el[0])
        _MDSnackbarView["default"].show(BabelStr.str(309)); // ('获取文件权限失败')
      });
      self.$(".perm-disp").show();
    }
  }, {
    key: "fileHasAppendedPermissionInChildren",
    value: function fileHasAppendedPermissionInChildren() {
      var _this2 = this;
      MMEnterpriseController.fileHasAppendedPermissionInChildren(this.fileInfo.getFileId(), function (sign) {
        _this2.hasAppendedPermission = sign;
        // this.loadForFile()
      });
    }
  }, {
    key: "_refresh",
    value: function _refresh(data, alluser) {
      var _this3 = this;
      for (var _i = 0; _i < this.subViews.length; _i++) {
        var subView = this.subViews[_i];
        if (subView !== this.pageBarView && subView != this.subCheckbox) {
          this.removeSubView(subView);
          _i--;
        }
      }
      this.users = data;
      for (var i = 0; i < data.length; i++) {
        var user = data[i];
        var permissionItem = new _MDDepFilePermissionItem["default"]({
          data: user,
          roleArr: this.roleArr,
          allAppendedRoleId: alluser.appendedRoleId,
          fileInfo: this.fileInfo,
          roles: this.roles,
          needChecked: true,
          onSelectChanged: function onSelectChanged() {
            _this3.selectChanged();
          },
          hasAppendedPermission: function hasAppendedPermission() {
            return _this3.hasAppendedPermission;
          },
          getSelectedUsers: function getSelectedUsers() {
            return _this3.selectedUsers;
          },
          changeHasAppendedPermission: function changeHasAppendedPermission(sign) {
            _this3.hasAppendedPermission = sign;
          },
          onChangePermission: function onChangePermission(params) {
            _this3.changePermission(params);
          },
          onRemovePermission: function onRemovePermission(params) {
            _this3.removePermission(params);
          }
        });
        this.addSubView(permissionItem, this.$(".user-list")[0]);
      }
      var permissionItem = new _MDDepFilePermissionItem["default"]({
        data: alluser,
        roleArr: this.roleArr,
        fileInfo: this.fileInfo,
        roles: this.roles,
        isUser: false,
        isAllUser: true,
        needBasicRoleLine: false,
        getSelectedUsers: function getSelectedUsers() {
          return _this3.selectedUsers;
        },
        hasAppendedPermission: function hasAppendedPermission() {
          return _this3.hasAppendedPermission;
        },
        onChangeAllPer: function onChangeAllPer(id) {
          _.isFunction(_this3.onAllUserPermissionChanged) && _this3.onAllUserPermissionChanged(id);
          for (var _i2 = 0; _i2 < _this3.subViews.length; _i2++) {
            var _subView = _this3.subViews[_i2];
            if (_subView !== _this3.pageBarView) {
              _subView.allUserPermissionChanged(id);
            }
          }
        },
        changeHasAppendedPermission: function changeHasAppendedPermission(sign) {
          _this3.hasAppendedPermission = sign;
        }
      });
      this.addSubView(permissionItem, this.$(".all-user")[0]);
    }
  }, {
    key: "changePermission",
    value: function changePermission(params) {
      if (!this.selectedUsers.has(params.uid)) {
        return;
      }
      _.each(this.subViews, function (subView) {
        if (subView instanceof _MDDepFilePermissionItem["default"] && subView.isNeedChanged(params.uid)) {
          subView.changePermission(params);
        }
      });
      var curIds = _.pluck(this.users, "id");
      var curIdSet = new Set(curIds);
      var _iterator = _createForOfIteratorHelper(this.selectedUsers.values()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var id = _step.value;
          if (!curIdSet.has(id)) {
            this._changePermission(params, id);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "_changePermission",
    value: function _changePermission(params, curId) {
      var self = this;
      MMEnterpriseController.changeFilePermission(this.fileInfo.getFileId(), params.sign, curId, params.type, params.linkRoleId, params.time, function () {
        MDMessageView.success(BabelStr.str(308));
        console.log("设置权限成功");
      }, function () {
        // MDSpinnerloaderView.clearFrom(this.$('.role')[0]);
        console.error("设置权限失败");
        // MDSnackbarView.show(BabelStr.str(309));   //('设置权限失败!')
      });
    }
  }, {
    key: "removePermission",
    value: function removePermission(params) {
      if (!this.selectedUsers.has(params.uid)) {
        return;
      }
      _.each(this.subViews, function (subView) {
        if (subView instanceof _MDDepFilePermissionItem["default"] && subView.isNeedChanged(params.uid)) {
          subView.removePermission(params);
        }
      });
      var curIds = _.pluck(this.users, "id");
      var curIdSet = new Set(curIds);
      var _iterator2 = _createForOfIteratorHelper(this.selectedUsers.values()),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var id = _step2.value;
          if (!curIdSet.has(id)) {
            this._removePermission(params, id);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "_removePermission",
    value: function _removePermission(params, curId) {
      var self = this;
      MMEnterpriseController.removeFilePermission(this.fileInfo.getFileId(), [curId], params.type, function () {
        console.log("删除额外权限成功");
      }, function () {
        console.error("删除额外权限失败");
      });
    }
  }, {
    key: "setLength",
    value: function setLength(total, startIndex) {
      this.pageBarView.setLength(total, true);
      if (startIndex == 0) {
        this.pageBarView.setCurrentPage(startIndex, true);
      }
    }
  }, {
    key: "renderPageBar",
    value: function renderPageBar() {
      var _this4 = this;
      this.pageBarView = new _MDPaginationView["default"]({
        enableStepButton: true,
        showHeadAndTail: true,
        // showJumpToPage: false,
        silentInit: true,
        // showSelectSizeList: false,
        align: "left",
        pageSize: this.pageSize,
        onPageSizeChanged: function onPageSizeChanged(size) {
          _this4.startIndex = 0;
          _this4.pageSize = size;
          _this4.loadForFile();
        },
        onPageChanged: function onPageChanged(curPageIndex) {
          _this4.startIndex = curPageIndex * _this4.pageSize;
          _this4.loadForFile();
        }
      });
      this.addSubView(this.pageBarView, this.$(".page-bar")[0]);
    }
  }, {
    key: "selectChanged",
    value: function selectChanged($e) {
      var _this5 = this;
      var ids = _.pluck(this.users, "id");
      this.$(".checked-item").removeClass("first");
      this.$(".checked-item").eq(0).addClass("first");
      var checkAll = _.every(this.users, function (user) {
        if (user.canManageFilePermission) {
          return true;
        } else {
          return _this5.selectedUsers.has(user.id);
        }
      });
      if (this.selectedUsers.size > 1) {
        this.$(".user-list").addClass("mult-select");
      } else {
        this.$(".user-list").removeClass("mult-select");
      }
      if (checkAll) {
        this.$(".head-line .m-chb").addClass("checked");
      } else {
        this.$(".head-line .m-chb").removeClass("checked");
      }
    }
  }]);
  return MDDepMemberFilePermissionTabView;
}(_MDTabPanelView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1192":1192,"130":130,"1412":1412,"1413":1413,"1419":1419,"1422":1422,"1423":1423,"1429":1429,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"1477":1477,"1478":1478,"1480":1480,"1487":1487,"1500":1500,"1502":1502,"1503":1503,"1538":1538,"1541":1541,"32":32,"37":37,"49":49,"563":563,"578":578,"61":61,"72":72,"76":76,"81":81}],578:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDWindowView = _interopRequireDefault(require(93));
//
// 文件权限控制-问号说明弹窗（优先级/部门内所有人/不单独设置）
// Created by jichao
// 2026.11.3
//

var MDFilePermHelpWinView = _MDWindowView["default"].extend({
  contentTmpl: "<div class=\"perm-help-content\"></div>",
  className: function className() {
    var superCls = _MDWindowView["default"].prototype.className.call(this);
    return superCls + ' perm-help-win';
  },
  initProps: function initProps() {
    var props = _MDWindowView["default"].prototype.initProps.call(this);
    return _.extend(props, {
      width: 480
    });
  },
  initialize: function initialize(opt) {
    opt = _.extend({}, opt);
    this.helpHtml = opt.helpHtml || '';
    opt.title = opt.helpTitle || '';
    opt.buttons = [{
      label: BabelStr.str(51375),
      type: 'done'
    }];
    _MDWindowView["default"].prototype.initialize.call(this, opt);
  },
  viewDidRendered: function viewDidRendered() {
    this.$('.perm-help-content').html(this.helpHtml);
  }
});
var _default = exports["default"] = MDFilePermHelpWinView;

},{"1184":1184,"1454":1454,"93":93}],563:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1439);
require(1437);
require(1415);
require(1463);
require(1412);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMViewBase2 = _interopRequireDefault(require(22));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDDropDownSelectRoleView = _interopRequireDefault(require(50));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 * 部门文件附加权限 --单个用户
 * WebContent/javascript/moladisk/views/file/fileinfo/MDDepFilePermissionItem.js
 * Created by jichao
 * 2018.1.15
 */ // import MDDropDownFilePermission from '../../../../base/component/mddropdownselect/MDDropDownFilePermission.js'
var MDDepFilePermissionItem = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MDDepFilePermissionItem, _MMViewBase);
  function MDDepFilePermissionItem() {
    (0, _classCallCheck2["default"])(this, MDDepFilePermissionItem);
    return _callSuper(this, MDDepFilePermissionItem, arguments);
  }
  (0, _createClass2["default"])(MDDepFilePermissionItem, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n\t\t\t<div class=\"name text-hide\" id=\"<%=id%>\">\n\t\t\t<%if(needChecked){%>\n\t\t\t<div class=\"m-chb <%=(checked ? \"checked\" : '')%> \">\n\t\t\t\t<%if(canManageFilePermission) {%>\n\t\t\t\t\t<div class=\"temp\"></div>\n\t\t\t\t<%} else {%>\n\t\t\t\t\t<div class=\"box\"></div>\n\t\t\t  <%}%>\n\t\t\t  <span class=\"label text-hide\" data-tooltip=\"<%=(_.escape(name))%>\" data-tooltip-dir=\"top\"><%=name%></span>\n\t\t\t</div>\n\t\t\t<%} else {%>\n\t\t\t<div class=\"text-hide\" data-tooltip=\"<%=(_.escape(name))%>\" data-tooltip-dir=\"top\">\n    \t\t<span class=\"icon\"></span>\n      \t\t<span class=\"username\"><%=name%></span>\n    \t</div>\n\t\t\t<%}%>\n\t\t\t</div>\n\t\t\t<%if(needBasicRoleLine){%>\n\t      <div class=\" basic-role text-hide\" data-tooltip-dir=\"top\"><%=basicRole%></div>\n      <%}%>\n\t    <div class=\" role\"></div>\n    \t<div class=\" time\">\n\t\t\t\t<input type=\"text\" class=\"date-end date f-tc\" required readonly >\n\t\t\t\t<div class=\"deadline-prompt flex-align middle\"><%=setTime%></div>\n\t\t\t\t<button class=\"del-deadline icon icon30\"></button>\n      </div>\n      <div class=\"f-tc op-name text-overflow\"><%=operatorName%></div>";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepFilePermissionItem.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        needBasicRoleLine: true,
        isSilent: true,
        isUser: true,
        needChecked: false,
        hasAppendedPermission: _.noop,
        changeHasAppendedPermission: _.noop,
        getSelectedUsers: _.noop,
        onChangePermission: _.noop,
        onRemovePermission: _.noop
      });
    }
  }, {
    key: "className",
    value: function className() {
      var cls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepFilePermissionItem.prototype), "className", this).call(this);
      return "".concat(cls, " line ");
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      var self = this;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepFilePermissionItem.prototype), "initialize", this).call(this, opt);
      var data = opt.data;
      this.type = this.isUser ? 0 : 3; /// 1 角色 0 用户 3所有人 2分组 4部门
      this.type = this.isRole ? this.isRole : this.type;
      this.isExtend = _.isUndefined(this.data.appendedRoleId) && !_.isUndefined(this.data.parentRoleId);
      self.time = this.isExtend ? data["parentDeadline"] : this.data.appendedDeadline;
      var name = data["name"];
      this.$(".username").html(name).attr("title", _.escape(name));
      var time = new Date();
      this.$(".date-end").datepicker({
        // minDate: time,
      }).on("change", function () {
        if (this.value) {
          this.value += " 23:59:59";
        }
        self.time = new Date(this.value).getTime();
        self.time /= 1000;
        self._changePerHandle(true);
        console.log(self.time);
      });
      this.$(".del-deadline").on("click", function () {
        self.time = null;
        self._changePerHandle(true);
      });
      if (this.data.appendedDeadline) {
        var date = new Date(this.data.appendedDeadline * 1000);
        this.$(".date-end").datepicker("setDate", date);
      }
      if (!this.needBasicRoleLine) {
        this.$el.addClass("_4col");
      } else {
        this.$el.addClass("_5col");
      }
      if (!this.fileInfo.isFolder()) {
        // --------------- 对于文件，删除“仅上传”的权限
        this.roleArr = _.filter(this.roleArr, function (item) {
          return item.linkRoleId != 14 && item.linkRoleId != 16;
        });
      }
      this.refreshList(this.allAppendedRoleId);
      if (!this.isSilent) {
        this.changeFilePermission(function () {});
      }
      this._refreshTime(this.linkRoleId, this.time);
    }
  }, {
    key: "allUserPermissionChanged",
    value: function allUserPermissionChanged(allAppendedRoleId) {
      this.isExtend = _.isUndefined(this.data.appendedRoleId) && !_.isUndefined(this.data.parentRoleId);
      if (this.isExtend && !this.isAllUser) {
        //显示的继承权限
        // this.refreshList(allAppendedRoleId)

        var name = this.data.parentRoleId ? this.data.parentRoleName : BabelStr.str(731);
        if (!_.isUndefined(this.data.parentRoleId) && (!allAppendedRoleId || allAppendedRoleId == -1)) {
          name = BabelStr.str(2803, {
            name: name
          });
        } else {
          name = BabelStr.str(6150);
        }
        this.roleSltView && this.roleSltView.updateLableByIndex(name, 0);
      }
    }
  }, {
    key: "refreshList",
    value: function refreshList(allAppendedRoleId) {
      var self = this;
      var roleArr;
      var managerId = this.fileInfo.getManager();
      if (this.data.canManageFilePermission || this.data.memberType == 1) {
        if (this.data.memberType == 1) {
          this.$(".role").append('<div class="file-per-mgr gray ">' + BabelStr.str(4738) + "</div>");
        } else if (this.fileInfo.belongTransmittalProject()) {
          this.$(".role").append('<div class="file-per-mgr gray ">' + BabelStr.str(5206) + "</div>");
        } else {
          this.$(".role").append('<div class="file-per-mgr gray ">' + BabelStr.str(5174) + "</div>");
        }
      } else if (app.ep.getUseFileManager() && managerId == this.data.id) {
        this.$(".role").append('<div class="file-per-mgr gray ">' + BabelStr.str(2747) + "</div>");
      } else {
        var index = 0;
        var roleId = this.data.appendedRoleId;
        this.linkRoleId = roleId;
        roleArr = this.roleArr.concat();
        if (!_.isUndefined(this.data.parentRoleId) && !allAppendedRoleId) {
          var temp = _.clone(roleArr[0]);
          var name = this.data.parentRoleId ? this.data.parentRoleName : BabelStr.str(731);
          temp["label"] = BabelStr.str(2803, {
            name: name
          });
          roleArr[0] = temp;
          if (this.isExtend) {
            index = 0;
          }
        }
        if (!this.isExtend) {
          for (var i = 0; i < this.roleArr.length; i++) {
            if (this.roleArr[i].linkRoleId == roleId) {
              index = i;
              break;
            }
          }
        }
        this.oldSelectedIndex = index;
        if (this.roleSltView) {
          this.roleSltView.setList(this.roleArr);
          this.roleSltView.selectByIndex(index, true);
        } else {
          this.roleSltView = new _MDDropDownSelectRoleView["default"]({
            labelField: "label",
            index: index,
            bd: roleArr,
            roles: this.roles,
            // showTooltip: true,
            // disabled: this.data.parentRoleId === 0,
            onChange: function onChange(data) {
              console.log(data);
              self.linkRoleId = data.linkRoleId;
              if (data.linkRoleId != -1) {
                self._changePerHandle();
              } else {
                self.removeFilePermission();
              }
            }
          });
          this.$(".role").append(this.roleSltView.$el);
        }
      }
    }
  }, {
    key: "_refreshTime",
    value: function _refreshTime(linkRoleId, time) {
      this.$(".del-deadline").hide();
      var self = this;
      // let isExtend = !this.data.appendedRoleId && !!this.data.parentRoleId;
      if (linkRoleId != -1 && linkRoleId != undefined && !this.isExtend) {
        self.$(".time").addClass("active");
        self.$(".time").removeClass("readonly");
        if (!time) {
          self.$(".deadline-prompt").text(_MDLocalString["default"].getLocalString(745));
        } else {
          var date = new Date(time * 1000);
          var time = "";
          if (date > new Date()) {
            time = "<span class='mgr-10'> 23:59</span>";
          }
          var timeStr = "<span>".concat(date.format("yyyy-MM-dd")).concat(time, "</span>");
          if (date < new Date()) {
            timeStr += "<span class=\"red mgr-10\"> ".concat(BabelStr.str(6813), "</span>");
          }
          this.$(".deadline-prompt").html(timeStr);
          this.$(".del-deadline").show();
        }
      } else {
        self.$(".time").removeClass("active");
        self.$(".time").addClass("readonly");
        self.$(".deadline-prompt").text("-");
      }
    }
  }, {
    key: "changeFilePermission",
    value: function changeFilePermission(sign) {
      var _this = this;
      var self = this;
      var index = -1;
      for (var i = 0; i < self.roleArr.length; i++) {
        if (self.roleArr[i].linkRoleId == this.linkRoleId) {
          index = i;
          break;
        }
      }
      this.onChangePermission({
        uid: this.data.id,
        sign: sign,
        linkRoleId: this.linkRoleId,
        time: this.time,
        index: index,
        type: this.data.type
      });
      _czc && _czc.push(["_trackEvent", "权限", "追加文件权限", "", "", ""]);
      MMEnterpriseController.changeFilePermission(this.fileInfo.getFileId(), sign, this.data.id, this.data.type, this.linkRoleId, this.time, function () {
        MDMessageView.success(BabelStr.str(308));
        // MDSnackbarView.show(BabelStr.str(309));   //('设置权限失败!')
        self.data.appendedRoleId = self.linkRoleId;
        console.log("设置权限成功");
        if (sign) {
          _this.changeHasAppendedPermission(false);
        }
        self._refreshTime(_this.linkRoleId, _this.time);
        _this._dispOperator(true);
        if (_this.isAllUser) {
          _this.onChangeAllPer && _this.onChangeAllPer(_this.linkRoleId);
        }
      }, function () {
        // MDSpinnerloaderView.clearFrom(this.$('.role')[0]);
        console.error("设置权限失败");
        // MDSnackbarView.show(BabelStr.str(309));   //('设置权限失败!')
      });
    }
  }, {
    key: "changePermission",
    value: function changePermission(params) {
      var self = this;
      MMEnterpriseController.changeFilePermission(this.fileInfo.getFileId(), params.sign, this.data.id, this.data.type, params.linkRoleId, params.time, function () {
        MDMessageView.success(BabelStr.str(308));
        // MDSnackbarView.show(BabelStr.str(309));   //('设置权限失败!')
        self.roleSltView.selectByIndex(params.index, true);
        self.data.appendedRoleId = params.linkRoleId;
        console.log("设置权限成功");
        if (params.sign) {
          self.changeHasAppendedPermission(false);
        }
        self._refreshTime(params.linkRoleId, params.time);
        self._dispOperator(true);
      }, function () {
        // MDSpinnerloaderView.clearFrom(this.$('.role')[0]);
        console.error("设置权限失败");
        // MDSnackbarView.show(BabelStr.str(309));   //('设置权限失败!')
      });
    }
  }, {
    key: "_changePerHandle",
    value: function _changePerHandle(aboutTime) {
      if (this.hasAppendedPermission()) {
        if (aboutTime) {
          this.changeFilePermission(false);
        } else {
          // var alert = new MDAlertView({
          // 		message: BabelStr.str(2804),
          // 		title: BabelStr.str(170),
          // 		buttons: [{
          // 			label: BabelStr.str(2806),
          // 			onClick: () => {
          // 				this.changeFilePermission(false)
          // 			}
          // 		}, {
          // 			label: BabelStr.str(2805),
          // 			type: 'done',
          // 			onClick: () => {
          // 				this.changeFilePermission(true)
          // 			}
          // 		}],
          // 		onClose: ()=>{
          // 			this.roleSltView.selectByIndex(this.oldSelectedIndex, true);
          // 		}
          // })
          // alert.show();

          this.changeFilePermission(false);
        }
      } else {
        this.changeFilePermission(true);
      }
    }
  }, {
    key: "_dispOperator",
    value: function _dispOperator(show) {
      if (show) {
        this.$(".op-name").html(app.currentUser.getUserName());
      } else {
        this.$(".op-name").html("-");
      }
    }
  }, {
    key: "removePermission",
    value: function removePermission(params) {
      var _this2 = this;
      var self = this;
      MMEnterpriseController.removeFilePermission(this.fileInfo.getFileId(), [this.data.id], this.data.type, function () {
        self._refreshTime(params.linkRoleId, params.time);
        _this2._dispOperator();
        self.roleSltView.selectByIndex(params.index, true);
        console.log("删除额外权限成功");
      }, function () {
        console.error("删除额外权限失败");
      });
    }
  }, {
    key: "removeFilePermission",
    value: function removeFilePermission(params) {
      var _this3 = this;
      var self = this;
      _czc && _czc.push(["_trackEvent", "权限", "移除追加权限", "", "", ""]);
      var index = -1;
      for (var i = 0; i < self.roleArr.length; i++) {
        if (self.roleArr[i].linkRoleId == this.linkRoleId) {
          index = i;
          break;
        }
      }
      this.onRemovePermission({
        uid: this.data.id,
        linkRoleId: this.linkRoleId,
        time: this.time,
        index: index,
        type: this.data.type
      });
      MMEnterpriseController.removeFilePermission(this.fileInfo.getFileId(), [this.data.id], this.data.type, function () {
        if (!_this3.isUser) {
          MDMessageView.success(BabelStr.str(308));
          // this.deleteCallback();
          // this.removeFromSuperView();
        }
        if (_this3.isAllUser) {
          _this3.onChangeAllPer && _this3.onChangeAllPer(_this3.linkRoleId);
        }
        self._refreshTime(_this3.linkRoleId, _this3.time);
        _this3._dispOperator();
        console.log("删除额外权限成功");
      }, function () {
        console.error("删除额外权限失败");
      });
    }
  }, {
    key: "_toggleChecked",
    value: function _toggleChecked($e) {
      if (this.data.canManageFilePermission) {
        return;
      }
      var users = this.getSelectedUsers();
      var id = this.data.id;
      var target = $($e.target).closest(".m-chb");
      if (target.hasClass("checked")) {
        target.removeClass("checked");
        this.$el.removeClass("checked-item");
        users["delete"](id);
      } else {
        target.addClass("checked");
        this.$el.addClass("checked-item");
        users.add(id);
      }
      _.isFunction(this.onSelectChanged) && this.onSelectChanged();
    }
  }, {
    key: "addChecked",
    value: function addChecked() {
      if (this.data.canManageFilePermission || this.data.id == "-1") {
        return;
      }
      this.$el.addClass("checked-item");
      this.$(".m-chb").addClass("checked");
    }
  }, {
    key: "removeChecked",
    value: function removeChecked() {
      this.$el.removeClass("checked-item");
      this.$(".m-chb").removeClass("checked");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepFilePermissionItem.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .m-chb": this._toggleChecked
      });
    }
  }, {
    key: "isNeedChanged",
    value: function isNeedChanged(uid) {
      if (uid == this.data.id) {
        return;
      }
      if (this.data.canManageFilePermission) {
        return;
      }
      var users = this.getSelectedUsers();
      var id = this.data.id;
      return users.has(id);
    }
  }, {
    key: "render",
    value: function render(data) {
      var users = this.getSelectedUsers();
      var id = this.data.id;
      if (users && users.has(id)) {
        this.$el.addClass("checked-item");
      }
      data = {
        checked: users && users.has(id),
        id: this.data.id,
        name: this.data.name,
        basicRole: this.data.roleName,
        needBasicRoleLine: this.needBasicRoleLine,
        setTime: _MDLocalString["default"].getLocalString(745),
        needChecked: this.needChecked,
        canManageFilePermission: this.data.canManageFilePermission,
        operatorName: this.data.operator && this.data.operator != "0" ? this.data.operatorName : '<span class="readonly">-</span>'
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepFilePermissionItem.prototype), "render", this).call(this, data);
    }
  }]);
  return MDDepFilePermissionItem;
}(_MMViewBase2["default"]);
var _default = exports["default"] = MDDepFilePermissionItem;

},{"1150":1150,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1415":1415,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"22":22,"32":32,"50":50}],1090:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1432);
require(1417);
require(1463);
require(1421);
require(1428);
require(1471);
require(1416);
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDServerChannelType = _interopRequireDefault(require(519));
// MDFilePathManager.js
// jiang
// 2017-3-29

var MDFilePathManager = {
  _filePaths: [],
  _channelType: -1,
  _rootFolder: _MMNetDiskDataController["default"].getHomeDir(),
  resetRootFolder: function resetRootFolder(rootFolder) {
    this._rootFolder = rootFolder;
    this._filePaths.splice(0, this._filePaths.length);
    this._filePaths.push(rootFolder);
  },
  /**
   *
   * @param {MDChannelType} type
   */
  setChannelType: function setChannelType(type) {
    this._channelType = type;
  },
  getFilePaths: function getFilePaths() {
    var paths = MDFilePathManager._filePaths || [];
    return paths;
  },
  clear: function clear() {
    var filePaths = MDFilePathManager._filePaths;
    filePaths.splice(0, filePaths.length);
  },
  updateToRoot: function updateToRoot(file) {
    this.resetRootFolder(file);
    var filePathNavView = viewManager.get("filePathNavView");
    if (filePathNavView) {
      filePathNavView.renderPaths();
    }
  },
  updateFilePath: function updateFilePath(fileId, callback) {
    var filePaths = MDFilePathManager._filePaths;
    var fileInfor = _.find(filePaths, function (fileInfo) {
      if (fileInfo.getFileId() == fileId) {
        return true;
      }
    });
    if (fileInfor) {
      var index = _.indexOf(filePaths, fileInfor);
      filePaths.splice(index + 1);
      callback(fileInfor);
      return;
    }
    _MMNetDiskDataController["default"].getPathById(fileId, this._channelType, null, function (fileInforCollection) {
      filePaths.splice(0);
      fileInforCollection = fileInforCollection.toArray().reverse();
      if (app.ep.isArchive()) {
        MMEnterpriseController.getRootDepartment(function (dep) {
          app.ep.setrootDepartFolderId(dep.folderId);
          for (var i = 0; i < fileInforCollection.length; i++) {
            if (fileInforCollection[i].getFileId() != dep.folderId) {
              filePaths.push(fileInforCollection[i]);
            }
          }
          filePaths.splice(0, 0, MDFilePathManager._rootFolder);
          var fileInfor = filePaths[filePaths.length - 1];
          if (callback) {
            callback(fileInfor);
          }
        });
      } else {
        for (var i = 0; i < fileInforCollection.length; i++) {
          // if(fileInforCollection[i].isManuscriptBox())  {
          //   filePaths.splice(0, filePaths.length, fileInforCollection[i]);
          //   continue;
          //  }
          filePaths.push(fileInforCollection[i]);
        }
        filePaths.splice(0, 0, MDFilePathManager._rootFolder);
        var fileInfor = filePaths[filePaths.length - 1];
        if (callback) {
          callback(fileInfor);
        }
      }
    }, function (code) {
      if (callback) {
        callback(code);
      }
    });
  },
  setPathToPointToFile: function setPathToPointToFile(fileInfo) {
    var filePaths = MDFilePathManager._filePaths;
    if (fileInfo) {
      var parentId = fileInfo.getParentFolderId();
      var index = _.findIndex(filePaths, function (file) {
        return file.getFileId() == parentId;
      });
      if (index >= 0) {
        filePaths.splice(index + 1);
        filePaths.push(fileInfo);
        if (fileInfo.isManuscriptBox() && !fileInfo.get("limitsState")) {
          fileInfo.set("limitsState", true);
          _MMNetDiskDataController["default"].getMsBoxLimits(fileInfo.getFileId(), function (limits) {
            fileInfo.set("limits", limits);
            console.warn(filePaths);
          });
        }
        var filePathNavView = viewManager.get("filePathNavView");
        if (filePathNavView) {
          filePathNavView.renderPaths();
        }
        return true;
      }
    }
    return false;
  },
  getCurrentFolderId: function getCurrentFolderId() {
    var folderId = 0;
    var filePaths = MDFilePathManager._filePaths;
    if (filePaths.length > 0) {
      folderId = filePaths[filePaths.length - 1].get("fileId");
    }
    return folderId;
  },
  getDirectoryDeepCount: function getDirectoryDeepCount() {
    var curPaths = MDFilePathManager._filePaths;
    return curPaths.length;
  },
  getFileInfoFromPath: function getFileInfoFromPath(fileId) {
    var filePaths = MDFilePathManager._filePaths;
    for (var i = 0; i < filePaths.length; i++) {
      var fileInfo = filePaths[i];
      if (fileInfo.getFileId() == fileId) {
        return fileInfo;
      }
    }
  }
};
var _default = exports["default"] = MDFilePathManager;

},{"1104":1104,"1184":1184,"1416":1416,"1417":1417,"1421":1421,"1428":1428,"1432":1432,"1454":1454,"1463":1463,"1471":1471,"519":519}],519:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var MDServerChannelType = {
  HOME: 0,
  TEAM: 1,
  MY_SHARE: 2,
  JOIN_SHARE: 3,
  MY_STAR: 4,
  TRASH: 5,
  DEPARTMENT: 6,
  MY_FOCUS: 7,
  MY_EVALUATING: 8,
  MSBOX_CONTRIBUTOR: 9,
  MSBOX_REVIEW: 10,
  EVALUATION_NEED: 11,
  // 未审批
  EVALUATION_ALREAD: 12,
  // 已审批
  EVALUATION_EVALUATING: 13,
  // 审批中
  EVALUATION_COMPLETED: 14,
  // 审批结束
  EVLUATION_ICREATE: 15,
  // 我发起的审批
  RECENT_FILE: 16,
  // 最近访问文件
  ARCHIVE: 17,
  myArchiveApply: 18,
  RECEIVEARCHIVE: 19,
  ArchiveApplyToReview: 20,
  archivehistory: 21,
  myarchivehistory: 23,
  epfile: 24,
  personfile: 25,
  project: 26,
  MSBOX: 27,
  allproject: 28,
  archiveLibrary: 29,
  classificationapproval: 30
};
var _default = exports["default"] = MDServerChannelType;

},{"1454":1454}],148:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1439);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MEUploadEntMemberWindow = _interopRequireDefault(require(149));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDPaginationView = _interopRequireDefault(require(61));
var _MEStaffAdminTableView = _interopRequireDefault(require(147));
var _MEAddPersonWindowView = _interopRequireDefault(require(187));
var _MEStaffNavigationPageViewTpl = _interopRequireDefault(require(120));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MEEditDepartmentView = _interopRequireDefault(require(143));
var _MDAlertView = _interopRequireDefault(require(32));
var _MEStaffSearchWindowView = _interopRequireDefault(require(200));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDFilesUploadedByUserPopupWin = _interopRequireDefault(require(711));
var _MEInnerPersonPopupView = _interopRequireDefault(require(195));
var _popupPos = _interopRequireDefault(require(65));
var _MMFileInfo = _interopRequireDefault(require(297));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _ErrorMessage = _interopRequireDefault(require(1088));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } //
// javascript/enterprise/view/departs/MEStaffNavigationPageView.js
//
var MEStaffNavigationPageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MEStaffNavigationPageView, _MDNavigationPageView);
  function MEStaffNavigationPageView() {
    (0, _classCallCheck2["default"])(this, MEStaffNavigationPageView);
    return _callSuper(this, MEStaffNavigationPageView, arguments);
  }
  (0, _createClass2["default"])(MEStaffNavigationPageView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return _MEStaffNavigationPageViewTpl["default"];
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStaffNavigationPageView.prototype), "className", this).call(this);
      return "".concat(superCls, " staff-admin-navpage");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStaffNavigationPageView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        forManager: true,
        startIndex: 0,
        pageSize: 20,
        departId: null,
        departName: "",
        folderId: null,
        keyName: "",
        $newMemberFromInnerBtn: null,
        $newMemberBtn: null,
        $removeMemBtn: null,
        $stopOrRecoverBtn: null,
        $changeDepartBtn: null,
        stopHandlerFlag: true,
        onUserChanged: null,
        serveForSingleDep: false // 仅是为指定部门服务，不允许访问其他部门或涉及企业权限
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStaffNavigationPageView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .new-member": this.newMember,
        "click .new-member-from-inner": this.newMemberFromInner,
        "click .remove-member": this.removeMemberFromDepart,
        "click .del-account": this.delAccount,
        "click .change-depart": this.changeDepart,
        "click .stop-or-recover": this.stopOrRecoverUser,
        "input .search-input": this.conditionChanged,
        "click .upload-member": this.uploadMember,
        "click .list-upload": this.listUploadedFiles
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      // props.title = MDLocalString.getLocalString(3139)+'-(' + props.departName + ')';
      props.title = BabelStr.str(506); // "部门人员管理",

      if (props.departName) {
        props.title = props.departName + " - " + props.title;
      }
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStaffNavigationPageView.prototype), "initialize", this).call(this, props);
      this.$newMemberFromInnerBtn = this.$(".button.new-member-from-inner");
      this.$newMemberBtn = this.$(".button.new-member");
      this.$uploadMemberBtn = this.$(".button.upload-member");
      this.$removeMemBtn = this.$(".button.remove-member");
      this.$stopOrRecoverBtn = this.$(".button.stop-or-recover");
      this.$changeDepartBtn = this.$(".button.change-depart");
      this.tableView = new _MEStaffAdminTableView["default"]({
        serveForSingleDep: this.serveForSingleDep,
        beforeRequest: function beforeRequest() {
          // 清除上次添加的change监听
          _this.stopListening(_this.tableView.getDataCollection());
        },
        refreshTableViewWithIndex: function refreshTableViewWithIndex(index) {
          _this.refreshTableViewWithIndex(index);
        },
        onRowSelectionChanged: function onRowSelectionChanged(selectedRowModels) {
          _this.onRowSelectionChanged(selectedRowModels);
        },
        onLoadSuccess: function onLoadSuccess(members, count) {
          _this.$newMemberFromInnerBtn.prop("disabled", false);
          _this.$uploadMemberBtn.prop("disabled", false);
          _this.$newMemberBtn.prop("disabled", false);
          _this.paginationBarView.setLength(count, true, _this.startIndex);
          if (count === 0) {
            _this.paginationBarView.hide();
          } else {
            _this.paginationBarView.show();
          }
          var userCollection = _this.tableView.getDataCollection();
          _this.listenTo(userCollection, "change", _this._collectionModelPropertyChanged);
        },
        onLoadFailed: function onLoadFailed() {}
      });
      this.addSubView(this.tableView, this.$(".table-wrap")[0]);
      this.paginationBarView = new _MDPaginationView["default"]({
        silentInit: true,
        pageSize: this.pageSize,
        onPageChanged: function onPageChanged(curPageIndex) {
          _this._pageChanged(curPageIndex);
        },
        onPageSizeChanged: function onPageSizeChanged(newPageSize) {
          _this.pageSize = newPageSize;
          _this.startIndex = 0;
          _this.refreshTableView();
        }
      });
      this.addSubView(this.paginationBarView, this.$(".table-wrap")[0]);
      if (this.serveForSingleDep) {
        this.$(".stop-or-recover").remove();
        this.$(".edit-member").remove();
        this.$(".change-depart").remove();
      }
      if (!this.folderId) {
        this.$(".list-upload").remove();
      }
      _czc && _czc.push(["_trackEvent", "部门管理", "人员管理", "", "", ""]);
      this.showMoreMenu();
      if (this.fileInfo && !this.fileInfo.canCreateEnterpriseMember()) {
        this.$(".new-member").remove();
        this.$(".upload-member").remove();
      }
    }
  }, {
    key: "listUploadedFiles",
    value: function listUploadedFiles() {
      var userIds = this._getSelectedUserIds();
      var userId = userIds[0];
      var selects = this.tableView.getSelectedModels();
      var user = selects[0];
      _MDFilesUploadedByUserPopupWin["default"].show({
        userId: userId,
        depId: this.departId,
        userName: user.getUserName()
      });
    }
  }, {
    key: "showMoreMenu",
    value: function showMoreMenu() {
      var _this2 = this;
      _MEInnerPersonPopupView["default"].createPopup({
        triggerView: this.$(".more-munu"),
        width: 180,
        direction: _popupPos["default"].BOTTOM,
        hasArrow: false,
        gapY: 0,
        gapX: -20,
        editDepBtn: false,
        forManager: this.forManager,
        getSelectedModels: function getSelectedModels() {
          return _this2.tableView.getSelectedModels();
        },
        showUploadLog: function showUploadLog() {
          _this2.listUplodLogForUser();
        },
        stopUse: function stopUse() {
          // console.log(this.tableView.getSelectedModels())
          _this2.stopOrRecoverUser();
        },
        changeDepart: function changeDepart() {
          _this2.changeDepart();
        },
        exportExcel: function exportExcel() {
          _this2.exportExcel();
        },
        delAccount: function delAccount() {
          _this2.delAccount();
        },
        removeMemberFromDepart: function removeMemberFromDepart() {
          _this2.removeMemberFromDepart();
        },
        getStopHandlerFlag: function getStopHandlerFlag() {
          return _this2.stopHandlerFlag;
        }
      });
    }
  }, {
    key: "_collectionModelPropertyChanged",
    value: function _collectionModelPropertyChanged(userInfo) {
      var isRevert = false;
      if (userInfo.hasChanged("status")) {
        if (this.tableView.getSelectedModels().length === 1) {
          var status = userInfo.getStatus();
          if (status === 1) {
            isRevert = true;
          }
          this.changeStatusButtonState(isRevert);
        }
      }
      _.isFunction(this.onUserChanged) && this.onUserChanged(true);
    }
  }, {
    key: "exportExcel",
    value: function exportExcel() {
      this.downloadUserListFile();
    }
  }, {
    key: "downloadUserListFile",
    value: function downloadUserListFile() {
      var _this3 = this;
      var opt = {
        keyName: this.keyName,
        forManager: this.forManager,
        departmentId: this.departId,
        departmentName: this.departName ? encodeURI(encodeURI(this.departName)) : undefined,
        norecursion: 1,
        frontPage: "2"
      };
      var fileName = "fileEnterpriseUserExcel_" + this.departName + ".xlsx";
      MDLoadMaskView.show(undefined, {
        width: 250,
        bodyMsg: BabelStr.str(20174) + "..."
      });
      _MMEnterpriseController["default"].downloadEntUserListFile(opt, function (token) {
        if (!_this3.forManager) {
          _MMEnterpriseController["default"].isFileExportedByToken(token, function () {
            MDLoadMaskView.remove();
            var file = new _MMFileInfo["default"]({
              fileId: token,
              toDownloadVer: -1,
              type: 1,
              fileName: fileName,
              downloadByToken: true
            });
            window.downloadPanelView.pushFiles([file]);
          }, function (res, msg) {
            MDLoadMaskView.remove();
            _MDSnackbarView["default"].show(msg);
          });
        } else {
          MDLoadMaskView.remove();
          _MMEnterpriseController["default"].showExportMsg();
        }
      }, function (res) {
        MDLoadMaskView.remove();
        _MDSnackbarView["default"].show(res.msg);
      });
    }
  }, {
    key: "refreshTableViewWithIndex",
    value: function refreshTableViewWithIndex(index) {
      this.startIndex = index;
      this.refreshTableView();
    }
  }, {
    key: "refreshTableView",
    value: function refreshTableView() {
      this.paginationBarView.hide();
      this.$newMemberFromInnerBtn.prop("disabled", true);
      this.$newMemberBtn.prop("disabled", true);
      this.$uploadMemberBtn.prop("disabled", true);
      this.tableView.requestUser({
        keyName: this.keyName,
        departmentId: this.departId,
        pageSize: this.pageSize,
        startIndex: this.startIndex
      });
    }
  }, {
    key: "_pageChanged",
    value: function _pageChanged(curPageIndex) {
      this.startIndex = curPageIndex * this.pageSize;
      this.refreshTableView();
    }
  }, {
    key: "conditionChanged",
    value: function conditionChanged() {
      this.keyName = this.$(".search-input").val();
      this.startIndex = 0;
      this.tableView.isInitTable = false;
      this.refreshTableView();
    }
  }, {
    key: "onRowSelectionChanged",
    value: function onRowSelectionChanged(selectedRowModels) {
      var disabled = false;
      var isRevert = false;
      var length = selectedRowModels.length;
      var freezedCount = 0;
      var currentUserId = app.currentUser.getId();
      var ownerId = app.ep.getOwnerId();
      this.stopHandlerFlag = true;
      if (length === 0) {
        disabled = true;
      } else {
        _.each(selectedRowModels, function (userInfo) {
          var userId = userInfo.getId();
          if (!app.isEpVersion() && (userId === currentUserId || userId === ownerId)) {
            disabled = true;
          }
          if (userInfo.getStatus() === 1) {
            freezedCount++;
          }
        });
        if (freezedCount === length) {
          isRevert = true;
          this.stopHandlerFlag = false;
        }
      }
      if (length === 1) {
        this.$(".list-upload").prop("disabled", false);
      } else {
        this.$(".list-upload").prop("disabled", true);
      }
      this.changeStatusButtonState(isRevert);
      this.$stopOrRecoverBtn.prop("disabled", disabled);
      //this.$changeDepartBtn.prop('disabled', disabled);
      this.$removeMemBtn.prop("disabled", disabled);
      this.$(".del-account").prop("disabled", disabled);
    }

    /**
     * 是否显示的是恢复状态的button
     * @param  {Boolean} isRevert [description]
     * @return {[type]}           [description]
     */
  }, {
    key: "changeStatusButtonState",
    value: function changeStatusButtonState(isRevert) {
      var btnText = !isRevert ? BabelStr.str(3064) : BabelStr.str(3063);
      this.stopHandlerFlag = !isRevert ? true : false;
      this.$stopOrRecoverBtn.text(btnText);
    }
  }, {
    key: "newMember",
    value: function newMember() {
      var _this4 = this;
      var win = new _MEAddPersonWindowView["default"]({
        disabledDepChoose: true,
        serveForSingleDep: this.serveForSingleDep,
        defaultDepartmentId: this.departId,
        onAddSuccess: function onAddSuccess() {
          _this4.refreshTableView();
        }
      });
      win.show();
    }
  }, {
    key: "newMemberFromInner",
    value: function newMemberFromInner() {
      var _this5 = this;
      var name = this.departName;
      name = name ? "-(" + name + ")" : "";
      var title = _MDLocalString["default"].getLocalString(3131) + name;
      var win = new _MEStaffSearchWindowView["default"]({
        title: title,
        needRole: true,
        excludeDepId: this.departId,
        onChoose: function onChoose(users, roleId) {
          _this5._onChoose(users, roleId);
        }
      });
      win.show();
    }
  }, {
    key: "_onChoose",
    value: function _onChoose(users, roleId) {
      var _this6 = this;
      var departId = this.departId;
      var userIds = [];
      _.each(users, function (user) {
        var userId = user.getId();
        userIds.push(userId);
      });
      roleId = roleId ? roleId : undefined;
      _MMEnterpriseController["default"].department.addDepartmentMembers(departId, userIds, {
        roleId: roleId
      }, function () {
        _MDMessageView["default"].success(_MDLocalString["default"].getLocalString(3507));
        _.isFunction(_this6.onUserChanged) && _this6.onUserChanged(true);
        _this6.refreshTableView();
      }, function () {
        _MDMessageView["default"].error(_MDLocalString["default"].getLocalString(3508));
      });
    }
  }, {
    key: "changeDepart",
    value: function changeDepart() {
      var _this7 = this;
      var selects = this.tableView.getSelectedModels();
      var datalist = [];
      if (selects && selects.length) {
        for (var i = 0; i < selects.length; i++) {
          var userInfo = {};
          userInfo["id"] = selects[i].get("id");
          userInfo["name"] = selects[i].get("name");
          datalist.push(userInfo);
        }
        var editDepartmentView = new _MEEditDepartmentView["default"]({
          data: datalist,
          departmentId: this.departId,
          onSuccess: function onSuccess() {
            _this7.refreshTableView();
          }
        });
        editDepartmentView.show();
      }
    }
  }, {
    key: "removeMemberFromDepart",
    value: function removeMemberFromDepart() {
      var _this8 = this;
      var selects = this.tableView.getSelectedModels();
      var departmentId = this.departId;
      var userIds = this._getSelectedUserIds();
      var option = {
        okFun: function okFun() {
          var userCollection = _this8.tableView.getDataCollection();
          _MMEnterpriseController["default"].department.delDepartmentMembers(departmentId, userIds, function () {
            userCollection.remove(selects);
            _.isFunction(_this8.onUserChanged) && _this8.onUserChanged(true);
            _MDMessageView["default"].success(_MDLocalString["default"].getLocalString(3509));
            _this8.refreshTableView();
          }, function () {
            _MDMessageView["default"].success(_MDLocalString["default"].getLocalString(3510));
          });
        },
        message: _MDLocalString["default"].getLocalString(3132)
      };
      _MDAlertView["default"].showDangerSelection(option);

      // let alert = new MDAlertView();
      // alert.show({
      //   title: MDLocalString.getLocalString(170),
      //   message: MDLocalString.getLocalString(3132),
      //   buttons: [{
      //     label: MDLocalString.getLocalString(3096),
      //     type: 'done',
      //     onClick: () => {
      //       var userCollection = this.tableView.getDataCollection();
      //       MMEnterpriseController.department.delDepartmentMembers(departmentId, userIds, () => {
      //         userCollection.remove(selects)
      //         _.isFunction(this.onUserChanged) && this.onUserChanged(true);
      //         MDMessageView.success(MDLocalString.getLocalString(3509));
      //         this.refreshTableView();
      //       }, () => {
      //         MDMessageView.success(MDLocalString.getLocalString(3510));
      //       })
      //     }
      //   }, {
      //     label: MDLocalString.getLocalString(155)
      //   }]
      // });
    }
  }, {
    key: "_getSelectedUserIds",
    value: function _getSelectedUserIds() {
      var selects = this.tableView.getSelectedModels();
      var userIds = [];
      _.each(selects, function (userInfo) {
        var userId = userInfo.getId();
        userIds.push(userId);
      });
      return userIds;
    }
  }, {
    key: "delAccount",
    value: function delAccount() {
      var _this9 = this;
      var selects = this.tableView.getSelectedModels();
      var departmentId = this.departId;
      var userIds = [];
      var alert = new _MDAlertView["default"]();
      var isAdmin = app.currentUser.isEpAdminUser();
      var curUserId = app.currentUser.getUserId();
      var allIsCreatedByMe = true;
      _.each(selects, function (userInfo) {
        var userId = userInfo.getId();
        userIds.push(userId);
        if (userInfo.getCreatorId() != curUserId) {
          allIsCreatedByMe = false;
        }
      });
      if (!isAdmin && !allIsCreatedByMe) {
        alert.show({
          title: _MDLocalString["default"].getLocalString(170),
          message: _MDLocalString["default"].getLocalString(3133),
          buttons: [{
            label: _MDLocalString["default"].getLocalString(3096),
            type: "done"
          }]
        });
      } else {
        var option = {
          okFun: function okFun() {
            var userCollection = _this9.tableView.getDataCollection();
            _MMEnterpriseController["default"].deleteMembersById(userIds, function () {
              userCollection.remove(selects);
              _.isFunction(_this9.onUserChanged) && _this9.onUserChanged(true);
              _MDMessageView["default"].success(_MDLocalString["default"].getLocalString(3134));
              _this9.refreshTableView();
            }, function () {
              _MDMessageView["default"].success(_MDLocalString["default"].getLocalString(3510));
            });
          },
          message: _MDLocalString["default"].getLocalString(3511)
        };
        _MDAlertView["default"].showDangerSelection(option);

        // alert.show({
        //   title: MDLocalString.getLocalString(170),
        //   message:  MDLocalString.getLocalString(3511),
        //   buttons: [{
        //     label: MDLocalString.getLocalString(3096),
        //     type: 'done',
        //     onClick: () => {
        //       var userCollection = this.tableView.getDataCollection();
        //       MMEnterpriseController.deleteMembersById(userIds, () => {
        //         userCollection.remove(selects)
        //         _.isFunction(this.onUserChanged) && this.onUserChanged(true);
        //         MDMessageView.success(MDLocalString.getLocalString(3134));
        //         this.refreshTableView();
        //       }, () => {
        //         MDMessageView.success(MDLocalString.getLocalString(3510));
        //       })
        //     }
        //   }, {
        //     label: MDLocalString.getLocalString(155)
        //   }]
        // });
      }
    }
  }, {
    key: "listUplodLogForUser",
    value: function listUplodLogForUser() {
      var folderId = this.folderId;
      var userIds = this._getSelectedUserIds();
      var selects = this.tableView.getSelectedModels();
      var user = selects[0];
      if (userIds.length == 1) {
        var userId = userIds[0];
        _MDFilesUploadedByUserPopupWin["default"].show({
          userId: userId,
          folderId: folderId,
          depId: this.departId,
          userName: user.getUserName()
        });
      }
    }
  }, {
    key: "stopOrRecoverUser",
    value: function stopOrRecoverUser() {
      var _this10 = this;
      var selects = this.tableView.getSelectedModels();
      var userIds = [];
      var alert = new _MDAlertView["default"]();
      var prompt = this.stopHandlerFlag ? _MDLocalString["default"].getLocalString(3064) : _MDLocalString["default"].getLocalString(3063);
      var message = _MDLocalString["default"].getLocalString(3135, {
        prompt: prompt
      });
      var option = {
        okFun: function okFun() {
          for (var i = 0; i < selects.length; i++) {
            var userId = selects[i].getId();
            userIds.push(userId);
          }
          if (_this10.stopHandlerFlag) {
            _MMEnterpriseController["default"].roleAndUsers.freezeUsers(userIds, function () {
              _MDMessageView["default"].success(_MDLocalString["default"].getLocalString(3512));
              _this10.refreshTableView();
            }, function (code, msg) {
              _MDMessageView["default"].error(msg);
            });
          } else {
            _MMEnterpriseController["default"].roleAndUsers.unfreezeUsers(userIds, function () {
              _MDMessageView["default"].success(_MDLocalString["default"].getLocalString(3514));
              _this10.refreshTableView();
            }, function (code, msg) {
              _MDMessageView["default"].error(msg);
            });
          }
        },
        message: message
      };
      if (this.stopHandlerFlag) {
        _MDAlertView["default"].showDangerSelection(option);
      } else {
        _MDAlertView["default"].showStandardSelection(option);
      }

      // alert.show({
      //   title: MDLocalString.getLocalString(170  ),
      //   message: MDLocalString.getLocalString(3135,{
      //     prompt: prompt
      //   }),
      //   buttons: [{
      //     label: MDLocalString.getLocalString(3096),
      //     type: 'done',
      //     onClick: () => {
      //       for (let i = 0; i < selects.length; i++) {
      //         let userId = selects[i].getId();
      //         userIds.push(userId);
      //       }
      //       if (this.stopHandlerFlag) {
      //         MMEnterpriseController.roleAndUsers.freezeUsers(userIds, () => {
      //           MDMessageView.success(MDLocalString.getLocalString(3512));
      //           this.refreshTableView();
      //         }, () => {
      //           MDMessageView.error(MDLocalString.getLocalString(3513));
      //         });
      //       } else {
      //         MMEnterpriseController.roleAndUsers.unfreezeUsers(userIds, () => {
      //           MDMessageView.success(MDLocalString.getLocalString(3514));
      //           this.refreshTableView();
      //         }, () => {
      //           MDMessageView.error(MDLocalString.getLocalString(3515));
      //         });
      //       }
      //     }
      //   }, {
      //     label: MDLocalString.getLocalString(155)
      //   }]
      // });
    }
  }, {
    key: "uploadMember",
    value: function uploadMember() {
      var _this11 = this;
      var win = new _MEUploadEntMemberWindow["default"]({
        onAddSuccess: function onAddSuccess() {
          _this11.refreshTableView();
        },
        onAddFail: function onAddFail() {},
        indep: true,
        departId: this.departId
      });
      win.show();
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStaffNavigationPageView.prototype), "viewDidRendered", this).call(this);
      this.refreshTableView();
    }
  }]);
  return MEStaffNavigationPageView;
}(_MDNavigationPageView2["default"]);

},{"1088":1088,"1098":1098,"1150":1150,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"120":120,"143":143,"1439":1439,"1454":1454,"1463":1463,"147":147,"1475":1475,"149":149,"187":187,"195":195,"200":200,"297":297,"32":32,"55":55,"56":56,"61":61,"65":65,"711":711,"72":72}],195:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDPopupView = _interopRequireDefault(require(64));
var _MDUserLoginPopupWin = _interopRequireDefault(require(715));
/**
 *  User information popup
 *  Create by author's name
 *  2012.9.20
 */

var MEInnerPersonPopupView = _MDPopupView["default"].extend({
  contentTmpl: "<ul class=\"m-menu create-menu\">\n\n\n      <li class=\"joinshare-log\"><%=BabelStr.str(21611)%></li>\n      <li class=\"joinproject-log\"><%=BabelStr.str(21612)%></li>\n      <li class=\"specialfiles\"><%=BabelStr.str(21609)%></li>\n      <%if(!outSide){%>\n        <li class=\"my-share-btn\"><%=BabelStr.str(22050)%></li>\n        <li class=\"upload-log\"><%=BabelStr.str(3402)%></li>\n        <li class=\"upload-list\"><%=BabelStr.str(6364)%></li>\n        <li class=\"login-list\"><%=BabelStr.str(21601)%></li>\n        <li class=\"export-excel\"><%=BabelStr.str(3465)%></li>\n\n        <li class=\"edit-dep\"><%=BabelStr.str(2389)%></li>\n\n        <li class=\"stop\"><%=BabelStr.str(3064)%></li>\n\n        <%if(delAccount) {%>\n          <li class=\"del-account\"><%=BabelStr.str(3271)%></li>\n        <%}%>\n        <%if(removeMemberFromDepart) {%>\n          <li class=\"remove-member\"><%=BabelStr.str(3272)%></li>\n        <%}%>\n      <%}%>\n\n    </ul>",
  // 去掉中英文切换
  // <li id="lan"><%=BabelStr.str(3383)%></li>

  events: function events() {
    var supE = _MDPopupView["default"].prototype.events.call(this);
    return _.extend({
      "click .export-excel": this._exportExcel,
      "click .edit-dep": this._editDep,
      "click .stop": this._stop,
      "click .del-account": this._delAccount,
      "click .remove-member": this._removeMemberFromDepart,
      "click .upload-list": this._showUploadList,
      "click .upload-log": this._showUploadLog,
      "click .joinshare-log": this._showJoinshareLog,
      "click .joinproject-log": this._showJoinprojectLog,
      "click .specialfiles": this._showspecialfiles,
      "click .login-list": this._showLoginLog,
      "click .share-list": this._showShare,
      "click .my-share-btn": this._showMyshare
    }, supE);
  },
  className: function className() {
    var superCls = _MDPopupView["default"].prototype.className.call(this);
    return superCls + " user-setting-popup";
  },
  initProps: function initProps() {
    var superP = _MDPopupView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      editDepBtn: true
    });
  },
  initialize: function initialize(opt) {
    _MDPopupView["default"].prototype.initialize.call(this, opt);
    if (!this.editDepBtn) {
      this.$(".edit-dep").remove();
    }
    if (!_.isFunction(this.showUploadList)) {
      this.$(".upload-list").remove();
    }
    if (!_.isFunction(this.showUploadLog)) {
      this.$(".upload-log").remove();
    }
    if (!_.isFunction(this.showJoinprojectLog)) {
      this.$(".joinproject-log").remove();
    }
    if (!_.isFunction(this.showJoinshareLog)) {
      this.$(".joinshare-log").remove();
    }
    if (!_.isFunction(this.showspecialfiles)) {
      this.$(".specialfiles").remove();
    }
    if (!_.isFunction(this.showLoginLog)) {
      this.$(".login-list").remove();
    }
    if (!_.isFunction(this.showMyshare)) {
      this.$(".my-share-btn").remove();
    }
    if (!app.currentUser.isEpAdminUser()) {
      this.$(".stop").remove();
      this.$(".del-account").hide();
    }
    ;
    this.$stopOrRecoverBtn = this.$(".stop");
    var flag = this.getStopHandlerFlag && this.getStopHandlerFlag();
    this.changeStatusButtonState(flag);
    var selects = this.getSelectedModels();
    if (!selects.length) {
      this.$stopOrRecoverBtn.hide();
      this.$(".edit-dep").hide();
      this.$(".del-account").hide();
      this.$(".remove-member").hide();
    }
    if (selects.length != 1) {
      this.$(".upload-list").hide();
      this.$(".my-share-btn").hide();
      this.$(".login-list").hide();
      this.$(".share-list").hide();
      this.$(".joinproject-log").hide();
      this.$(".specialfiles").hide();
      this.$(".joinshare-log").hide();
      this.$(".upload-log").addClass("disabled");
    } else {
      this.$(".upload-log").removeClass("disabled");
    }
  },
  render: function render(data) {
    data = {
      delAccount: !_.isUndefined(this.delAccount),
      removeMemberFromDepart: !_.isUndefined(this.removeMemberFromDepart),
      outSide: this.outSide
    };
    _MDPopupView["default"].prototype.render.call(this, data);
  },
  changeStatusButtonState: function changeStatusButtonState(flag) {
    var stop = BabelStr.str(3064); // 停用
    var restore = BabelStr.str(3063); // 恢复
    var btnText = flag ? stop : restore;
    this.$stopOrRecoverBtn.text(btnText);
  },
  _exportExcel: function _exportExcel() {
    this.close();
    this.exportExcel();
  },
  _editDep: function _editDep() {
    this.close();
    this.changeDepart();
  },
  _showUploadList: function _showUploadList() {
    this.close();
    this.showUploadList();
  },
  _showUploadLog: function _showUploadLog($e) {
    if ($($e.target).hasClass("disabled")) {
      return;
    }
    this.close();
    this.showUploadLog();
  },
  _showJoinprojectLog: function _showJoinprojectLog($e) {
    if ($($e.target).hasClass("disabled")) {
      return;
    }
    this.close();
    this.showJoinprojectLog();
  },
  _showspecialfiles: function _showspecialfiles($e) {
    if ($($e.target).hasClass("disabled")) {
      return;
    }
    this.close();
    this.showspecialfiles();
  },
  _showJoinshareLog: function _showJoinshareLog($e) {
    if ($($e.target).hasClass("disabled")) {
      return;
    }
    this.close();
    this.showJoinshareLog();
  },
  _stop: function _stop() {
    this.close();
    this.stopUse();
  },
  _delAccount: function _delAccount() {
    this.close();
    this.delAccount();
  },
  _removeMemberFromDepart: function _removeMemberFromDepart() {
    this.removeMemberFromDepart();
    this.close();
  },
  _showLoginLog: function _showLoginLog() {
    this.showLoginLog();
  },
  _showMyshare: function _showMyshare() {
    this.showMyshare();
  },
  _showShare: function _showShare() {}
});
var _default = exports["default"] = MEInnerPersonPopupView;

},{"1184":1184,"1454":1454,"64":64,"715":715}],187:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1421);
require(1498);
require(1439);
require(1426);
require(1417);
require(1463);
require(1446);
require(1415);
require(1437);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MEAddPersonWindowViewTpl = _interopRequireDefault(require(121));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MEDepRoleSelectView = _interopRequireDefault(require(189));
var _MEDepartChooseView = _interopRequireDefault(require(138));
var _MDSpinnerloaderLayerView = _interopRequireDefault(require(75));
var _utils = _interopRequireDefault(require(108));
var _MDMessageView = _interopRequireDefault(require(55));
var _regexp = _interopRequireDefault(require(106));
var _MEUserSpaceInfoView = _interopRequireDefault(require(201));
var _MEEnterpriseRoleSelectView = _interopRequireDefault(require(193));
var _MDAlertView = _interopRequireDefault(require(32));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 * 新增企业人员
 * Created by manjun.han
 * 2016.12.1
 */
var MEAddPersonWindowView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MEAddPersonWindowView, _MDWindowView);
  function MEAddPersonWindowView() {
    (0, _classCallCheck2["default"])(this, MEAddPersonWindowView);
    return _callSuper(this, MEAddPersonWindowView, arguments);
  }
  (0, _createClass2["default"])(MEAddPersonWindowView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return _MEAddPersonWindowViewTpl["default"].root;
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEAddPersonWindowView.prototype), "className", this).call(this);
      return "".concat(superCls, " m-add-person-win window-with-inner");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEAddPersonWindowView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .add-role-btn': this.addExtraRole,
        'click .rm-extra-role': this.removeExtraRole,
        'click #js-randomPwdBtn': this.getRandomPwd,
        'blur #js-email': this.emailInputBlurHandler,
        'blur #js-phone': this.phoneInputBlurHandler,
        'click #js-clearForm': this._clearFormForExistUser
      });
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEAddPersonWindowView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        $roleList: null,
        roleAndDepartStore: [],
        isAdmin: false,
        onAddSuccess: _.noop,
        onAddFail: _.noop,
        disabledDepChoose: false,
        defaultDepartmentId: undefined,
        defaultRoleId: undefined,
        searchUserView: null,
        allowFormControlDisable: false,
        serveForSingleDep: false,
        // 仅是为指定部门服务，不允许访问其他部门或涉及企业权限
        conditionArr: [
          // {"name": "普通成员"},
          // {"name": "受限人员"},
          // {"name": "文档管理员"},
          // {"name": "企业管理员"}
        ]
      });
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        'basic': BabelStr.str(3013),
        // 基本信息
        'IDStr': BabelStr.str(214),
        // 账户
        'mail': BabelStr.str(485),
        // 邮箱或手机号
        'receiveMail': BabelStr.str(669),
        // 新增成员将在该邮箱收到一封邀请邮件
        'name': BabelStr.str(3073),
        // 姓名
        'pswd': BabelStr.str(394),
        // 密码
        'changePwd': BabelStr.str(670),
        // 登录成功后可以修改密码
        'randPwd': BabelStr.str(3144),
        // 随机密码
        'sex': BabelStr.str(3074),
        // 性别
        'male': BabelStr.str(3075),
        // 男
        'female': BabelStr.str(3076),
        // 女
        'contact': BabelStr.str(3077),
        // 联系方式
        'phone': BabelStr.str(488),
        // 手机号
        'company': BabelStr.str(660),
        // 公司
        'remark': BabelStr.str(3079),
        // 备注
        'joinDate': BabelStr.str(3078),
        // 入职时间
        'roleSet': BabelStr.str(674),
        // 权限设置
        'dep': BabelStr.str(3085),
        // 所属部门
        'role': BabelStr.str(3086),
        // 角色
        'newRole': BabelStr.str(3087),
        // 新增角色
        'multiRole': BabelStr.str(3088),
        // 巴别鸟允许一个人在多个部门使用不同角色
        'entRole': BabelStr.str(3071),
        // 企业角色
        'personSpace': BabelStr.str(754),
        // 个人空间设置
        'disabledDepChoose': this.disabledDepChoose
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEAddPersonWindowView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.title = BabelStr.str(671); // '新增企业人员';
      props.width = 900;
      props.buttons = [{
        label: BabelStr.str(155) //  '取消'
      }, {
        label: BabelStr.str(154),
        // '确认',
        type: 'done',
        focused: true,
        autoClose: false,
        onClick: function onClick() {
          _this.$('form').submit();
        }
      }];
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEAddPersonWindowView.prototype), "initialize", this).call(this, props);
      if (!this.defaultDepartmentId) {
        this.defaultDepartmentId = MEAddPersonWindowView.getDefaultDepId();
      }
      if (!app.ep.isPrivateCloud()) {
        this.$("#js-phone").intlTelInput();
      }

      // let silentInit = this.defaultDepartmentId ? false : true;
      var silentInit = false;
      var map = {
        roleId: null,
        departId: this.defaultDepartmentId
      };
      this.roleAndDepartStore.push(map);
      var departTreeView = new _MEDepartChooseView["default"]({
        disabledDepChoose: this.disabledDepChoose,
        readonly: true,
        needRoot: true,
        needAddDefault: false,
        silentInit: silentInit,
        selectedDepartId: this.defaultDepartmentId,
        placeholder: BabelStr.str(3097),
        // ''选择部门',
        disabled: this.serveForSingleDep,
        onChange: function onChange(node) {
          map.departId = node['id'];
          MEAddPersonWindowView.setDefaultDepId(map.departId);
          // if (node['parent'] == '#') {
          //   map.departId = '#';
          //   selectView.setDisabled(true);
          //   departTreeView.reset();
          //   selectView.reset();
          // } else {
          selectView.setDisabled(false);
          selectView.selectDefaultRole();
          // }
          _this.setAddRoleButtonEnabled();
        },
        onReady: function onReady() {
          if (_.isUndefined(_this.defaultDepartmentId)) {
            departTreeView.selectRoot();
          }
        }
      });
      this.addSubView(departTreeView, this.$('#js-departSlot')[0], true);
      departTreeView.$('input').attr('name', departTreeView.cid).rules('add', {
        required: true,
        notEqualTo: function notEqualTo() {
          return function (value, input) {
            var hasSame = _this.hasSameDepartment(map);
            return !hasSame;
          };
        },
        messages: {
          'required': BabelStr.str(672),
          // "请选择部门",
          'notEqualTo': BabelStr.str(3262) // '部门重复'
        }
      });
      var selectView = new _MEDepRoleSelectView["default"]({
        needNoRole: true,
        silentInit: true,
        disabled: true,
        onReady: function onReady() {
          selectView.setDisabled(false);
          selectView.setDefaultRoleId(MEAddPersonWindowView.getLastRoleId());
        },
        onChange: function onChange(role) {
          map.roleId = role.getId();
          MEAddPersonWindowView.setLastRoleId(map.roleId);
        }
      });
      this.addSubView(selectView, this.$('#js-roleSlot')[0], true);
      this.$roleList = this.$('#js-roleList');

      // this.switchView = new MDSwitchView({
      //   onChange: (opened) => {
      //     this.isAdmin = opened;
      //   }
      // });
      // this.addSubView(this.switchView, this.$('#swicthSlot'), true);

      // this.switchDocView = new MDSwitchView({
      //   onChange: (opened) => {
      //     this.isDocAdmin = opened;
      //   }
      // });
      // this.addSubView(this.switchView, this.$('#swicthDocSlot'), true);

      _regexp["default"].registerLoginEmail();
      this.$('form').validate({
        errorPlacement: function errorPlacement(error, element) {
          if (element.data("inDepartChooser")) {
            var errorContainer = $(element).data('departmentTreeView').getValidateErrorContainer();
            $(error).appendTo(errorContainer);
          } else if (element.attr('name') && element.attr('name').indexOf('phone') > -1 && !app.ep.isPrivateCloud()) {
            error.insertAfter(element.closest(".intl-tel-input"));
          } else {
            error.insertAfter(element);
          }
        },
        rules: {
          'email': {
            'email': true
            // login_email: true,
            // login_email: true,
          },
          'phone': {
            isNumber: true
          },
          'password': {
            'userPassword': true
          }
        },
        messages: {
          'username': {
            'required': BabelStr.str(665) //'请输入姓名',
          },
          'email': {
            'required': BabelStr.str(2339) //'请输入邮箱'
          },
          'password': {
            'required': BabelStr.str(2328) //'请输入密码或生成随机密码'
          }
        },
        // 校验成功后回调
        submitHandler: function submitHandler(form) {
          _this.addPerson();
        }
      });
      this.$('.add-role-btn').addClass('disabled');
      this.$needHidedFormControls = this.$('[data-needhide]');
      this.$usernameInput = this.$('#js-userName');
      this.$pwdInput = this.$('#js-password');
      this.$emailInput = this.$('#js-email');
      this.addBabelUser = false;
      if (this.serveForSingleDep) {
        this.$('.add-role-wrap').remove();
        this.$('.open-admin-block').remove();
      }
      ;
      this.userSpaceInfoView = new _MEUserSpaceInfoView["default"]({
        userSpaceInfos: [],
        userInfo: this.userInfo,
        permissionChangedCb: function permissionChangedCb(index) {
          console.log('----- selected:', index);
        }
      });
      this.addSubView(this.userSpaceInfoView, this.$('.space-info-block'));
    }
  }, {
    key: "phoneInputBlurHandler",
    value: function phoneInputBlurHandler($e) {
      var value = this.$('#js-phone').val();
      value = value.trim();
      if (!value) {
        return;
      } else if (!_regexp["default"].isPhone(value)) {
        return;
      }
      this.userType = "phone";
      this.inputBlurHandler2($e, "phone");
    }
  }, {
    key: "emailInputBlurHandler",
    value: function emailInputBlurHandler($e) {
      var value = this.$('#js-email').val();
      value = value.trim();
      if (!value) {
        return;
      } else if (!_regexp["default"].isEmail(value)) {
        return;
      }
      this.userType = "email";
      this.inputBlurHandler2($e, "email");
    }
  }, {
    key: "inputBlurHandler",
    value: function inputBlurHandler($e) {
      var _this2 = this;
      var value = '';
      var net = _MMEnterpriseController["default"];
      var checkUserInofFunc = null;
      if (this.userType == "phone") {
        if (!app.ep.isPrivateCloud()) {
          this.$("#js-phone").intlTelInput();
        }
        value = this.$('#js-phone').val();
        value = value.trim();
        if (!value) {
          return;
        } else {
          this.$('#js-email').val("");
          this.$('#js-email').removeClass("validate-error");
          this.$("#js-email-error").remove();
        }
        if (!app.ep.isPrivateCloud()) {
          var selectedCountryData = this.$("#js-phone").intlTelInput("getSelectedCountryData") || {};
          if (selectedCountryData.dialCode && selectedCountryData.dialCode != '86') {
            value = selectedCountryData.dialCode + "-" + value;
          }
        }
        this.idIsPhone = true;
        checkUserInofFunc = net.checkPhoneInfo;
      } else {
        this.idIsPhone = false;
        checkUserInofFunc = net.checkEmailInfo;
        value = this.$('#js-email').val();
        value = value.trim();
        if (!value) {
          return;
        } else {
          this.$('#js-phone').val("");
          this.$('#js-phone').removeClass("validate-error");
          this.$("#js-phone-error").remove();
        }
      }
      this.setActionButtonDisabledByIndex(false, 1);
      checkUserInofFunc(value, function (emailInfo) {
        var isBabelUser = emailInfo['userInfo'] && emailInfo['userInfo']['registered'];
        var isEnterpriseMember = emailInfo['isEnterpriseMember'];
        var userInfo = emailInfo['userInfo'] || {
          'name': "asdasd"
        };
        _this2.setActionButtonDisabledByIndex(false, 1);
        var errorObj = {};
        if (emailInfo['otherEnterpriseMember']) {
          var alert = new _MDAlertView["default"]({
            title: BabelStr.str(170),
            message: BabelStr.str(7028, {
              name: emailInfo.enterprise.name
            }),
            buttons: [{
              label: BabelStr.str(154)
            }]
          });
          alert.show();
          var validator = _this2.$('form').validate();
          errorObj = {};
          errorObj[_this2.userType] = BabelStr.str(7028, {
            name: emailInfo.enterprise.name
          }); //  '该邮箱已经在本企业中'
          validator.showErrors(errorObj);
          _this2.setActionButtonDisabledByIndex(true, 1);
        } else if (isEnterpriseMember) {
          var _validator = _this2.$('form').validate();
          errorObj = {};
          errorObj[_this2.userType] = BabelStr.str(673);
          _validator.showErrors(errorObj);
          _this2.setActionButtonDisabledByIndex(true, 1);
        } else if (isBabelUser) {
          var msg = BabelStr.str(7029);
          var okStr = BabelStr.str(7030);
          if (window.isPrivateCloud) {
            msg = BabelStr.str(20102);
            okStr = BabelStr.str(154);
          }
          var alert = new _MDAlertView["default"]({
            title: BabelStr.str(170),
            message: msg,
            buttons: [{
              label: okStr,
              type: 'done',
              onClick: function onClick() {
                _MMEnterpriseController["default"].inviteEnterpriseMember(emailInfo['userInfo']['id'], function () {
                  _MDMessageView["default"].success(BabelStr.str(308)); //('添加成功');
                  _this2.close();
                });
              }
            }, {
              label: BabelStr.str(3081)
            }]
          });
          alert.show();
          // let tip = BabelStr.str(2635);    // 该邮箱已经注册为巴别鸟账号，请输入其他邮箱
          var _validator2 = _this2.$('form').validate();
          errorObj = {};
          errorObj[_this2.userType] = BabelStr.str(2635);
          _validator2.showErrors(errorObj);
          _this2.setActionButtonDisabledByIndex(true, 1);
          // let helpTmpl = `<div class="help-tip text-center">
          //                   <span>${tip}</span>
          //                   <span id="js-clearForm" class="ep-ic ep-ic-sm-close f-fr"></span>
          //                 </div>`;
          // let $tip = $(helpTmpl);
          // this.$body.prepend($tip);
          // $tip.hide();
          // $tip.slideDown();
          // this.$needHidedFormControls.slideUp();
          // this.$emailInput.prop('disabled', true);
          // this.$usernameInput.val(userInfo['name']).prop('disabled', true);
          // this.$pwdInput.rules('remove', 'required');
          // this.addBabelUser = true;
        }
      }, function () {});
    }
  }, {
    key: "inputBlurHandler2",
    value: function inputBlurHandler2($e, type) {
      var _this3 = this;
      var value = '';
      var net = _MMEnterpriseController["default"];
      var checkUserInofFunc = null;
      if (type == "phone") {
        if (!app.ep.isPrivateCloud()) {
          this.$("#js-phone").intlTelInput();
        }
        value = this.$('#js-phone').val();
        value = value.trim();
        if (!value) {
          return;
        }
        if (!app.ep.isPrivateCloud()) {
          var selectedCountryData = this.$("#js-phone").intlTelInput("getSelectedCountryData") || {};
          if (selectedCountryData.dialCode && selectedCountryData.dialCode != '86') {
            value = selectedCountryData.dialCode + "-" + value;
          }
        }
        this.idIsPhone = true;
        checkUserInofFunc = net.checkPhoneInfo;
        this.phoneError = false;
      } else {
        this.idIsPhone = false;
        checkUserInofFunc = net.checkEmailInfo;
        value = this.$('#js-email').val();
        value = value.trim();
        if (!value) {
          return;
        }
        this.emailError = false;
      }
      this._checkActionButton();
      checkUserInofFunc(value, function (emailInfo) {
        var isBabelUser = emailInfo['userInfo'] && emailInfo['userInfo']['registered'];
        var isEnterpriseMember = emailInfo['isEnterpriseMember'];
        var userInfo = emailInfo['userInfo'] || {
          'name': "asdasd"
        };
        _this3._checkActionButton();
        var errorObj = {};
        if (emailInfo['otherEnterpriseMember']) {
          var alert = new _MDAlertView["default"]({
            title: BabelStr.str(170),
            message: BabelStr.str(7028, {
              name: emailInfo.enterprise.name
            }),
            buttons: [{
              label: BabelStr.str(154)
            }]
          });
          alert.show();
          var validator = _this3.$('form').validate();
          errorObj = {};
          errorObj[_this3.userType] = BabelStr.str(7028, {
            name: emailInfo.enterprise.name
          }); //  '该邮箱已经在本企业中'
          validator.showErrors(errorObj);
          if (type == "phone") {
            _this3.phoneError = true;
          } else {
            _this3.emailError = true;
          }
          _this3._checkActionButton();
        } else if (isEnterpriseMember) {
          var _validator3 = _this3.$('form').validate();
          errorObj = {};
          errorObj[_this3.userType] = BabelStr.str(673);
          _validator3.showErrors(errorObj);
          if (type == "phone") {
            _this3.phoneError = true;
          } else {
            _this3.emailError = true;
          }
          _this3._checkActionButton();
        } else if (isBabelUser) {
          _this3.$('.default-role-block .searchDep').addClass('f-hide');
          _this3.$('.default-role-block .select-control').addClass('f-hide');
          var msg = BabelStr.str(7029);
          var okStr = BabelStr.str(7030);
          if (window.isPrivateCloud) {
            msg = BabelStr.str(20102);
            okStr = BabelStr.str(154);
          }
          var alert = new _MDAlertView["default"]({
            title: BabelStr.str(170),
            message: msg,
            buttons: [{
              label: okStr,
              type: 'done',
              onClick: function onClick() {
                _MMEnterpriseController["default"].inviteEnterpriseMember(emailInfo['userInfo']['id'], function () {
                  _MDMessageView["default"].success(BabelStr.str(308)); //('添加成功');
                  _this3.close();
                });
              }
            }, {
              label: BabelStr.str(3081),
              onClick: function onClick() {
                _this3.$('.default-role-block .searchDep').removeClass('f-hide');
                _this3.$('.default-role-block .select-control').removeClass('f-hide');
                // this.close()
              }
            }]
          });
          alert.show();
          // let tip = BabelStr.str(2635);    // 该邮箱已经注册为巴别鸟账号，请输入其他邮箱
          var _validator4 = _this3.$('form').validate();
          errorObj = {};
          errorObj[_this3.userType] = BabelStr.str(2635);
          _validator4.showErrors(errorObj);
          if (type == "phone") {
            _this3.phoneError = true;
          } else {
            _this3.emailError = true;
          }
          _this3._checkActionButton();
          // let helpTmpl = `<div class="help-tip text-center">
          //                   <span>${tip}</span>
          //                   <span id="js-clearForm" class="ep-ic ep-ic-sm-close f-fr"></span>
          //                 </div>`;
          // let $tip = $(helpTmpl);
          // this.$body.prepend($tip);
          // $tip.hide();
          // $tip.slideDown();
          // this.$needHidedFormControls.slideUp();
          // this.$emailInput.prop('disabled', true);
          // this.$usernameInput.val(userInfo['name']).prop('disabled', true);
          // this.$pwdInput.rules('remove', 'required');
          // this.addBabelUser = true;
        }
      }, function () {});
    }
  }, {
    key: "_checkActionButton",
    value: function _checkActionButton() {
      if (!this.emailError && !this.phoneError) {
        this.setActionButtonDisabledByIndex(false, 1);
      } else {
        this.setActionButtonDisabledByIndex(true, 1);
      }
    }
  }, {
    key: "_clearFormForExistUser",
    value: function _clearFormForExistUser() {
      this.$('.help-tip').slideUp(function () {
        $(this).remove();
      });
      this.$needHidedFormControls.slideDown();
      this.$usernameInput.val('').prop('disabled', false);
      this.$pwdInput.val('');
      this.$emailInput.val('').prop('disabled', false);
      this.$pwdInput.rules('add', 'required');
      this.addBabelUser = false;
    }
  }, {
    key: "hasSameDepartment",
    value: function hasSameDepartment(departRole) {
      var hasSame = false;
      _.each(this.roleAndDepartStore, function (departRoleInner) {
        if (departRoleInner !== departRole && departRoleInner.departId == departRole.departId) {
          hasSame = true;
        }
      });
      return hasSame;
    }
  }, {
    key: "setAddRoleButtonEnabled",
    value: function setAddRoleButtonEnabled() {
      var disabled = false;
      _.each(this.roleAndDepartStore, function (departRole) {
        if (departRole.departId === '#' || !departRole.departId) {
          disabled = true;
        }
      });
      if (!disabled) {
        var departIds = _.map(this.roleAndDepartStore, function (item) {
          return item.departId;
        });
        disabled = _.uniq(departIds).length != this.roleAndDepartStore.length ? true : false;
      }
      if (disabled) {
        this.$('.add-role-btn').addClass('disabled');
      } else {
        this.$('.add-role-btn').removeClass('disabled');
      }
    }
  }, {
    key: "addExtraRole",
    value: function addExtraRole() {
      var _this4 = this;
      if (this.$('.add-role-btn').hasClass('disabled')) {
        return;
      }
      var data = {
        'title': BabelStr.str(32),
        // 移除
        'dep': BabelStr.str(3085),
        // 所属部门
        'role': BabelStr.str(3086) // 角色
      };
      var tpl = _MEAddPersonWindowViewTpl["default"].extraRoleItem;
      tpl = _.template(tpl)(data);
      var $roleItem = $(tpl);
      var map = {
        roleId: null,
        departId: undefined
      };
      this.roleAndDepartStore.push(map);
      this.$roleList.append($roleItem);
      var selectView = new _MEDepRoleSelectView["default"]({
        needNoRole: true,
        silentInit: true,
        disabled: true,
        onChange: function onChange(role) {
          map.roleId = role.getId();
        }
      });
      this.addSubView(selectView, $roleItem.find('#js-roleSlot')[0], true);
      var departTreeView = new _MEDepartChooseView["default"]({
        readonly: true,
        needRoot: true,
        needAddDefault: false,
        placeholder: BabelStr.str(3097),
        //'选择部门',
        onChange: function onChange(node) {
          map.departId = node['id'];
          // if (node['parent'] == '#') {
          //   map.departId = '#';
          //   selectView.setDisabled(true);
          //   departTreeView.reset();
          //   selectView.reset();
          // } else {
          selectView.setDisabled(false);
          selectView.selectDefaultRole();
          // }
          _this4.setAddRoleButtonEnabled();
        }
      });
      this.addSubView(departTreeView, $roleItem.find('#js-departSlot')[0], true);
      $roleItem.data('subViews', [selectView, departTreeView]).data('store', map);
      departTreeView.$('input').attr('name', departTreeView.cid).rules('add', {
        required: true,
        notEqualTo: function notEqualTo() {
          return function (value, input) {
            var hasSame = _this4.hasSameDepartment(map);
            return !hasSame;
          };
        },
        messages: {
          'required': BabelStr.str(672),
          // "请选择部门",
          'notEqualTo': BabelStr.str(3262) // '部门重复'
        }
      });
      this.setAddRoleButtonEnabled();
    }
  }, {
    key: "removeExtraRole",
    value: function removeExtraRole($e) {
      var $roleItem = $($e.target).closest('.extra-role-block');
      var subViews = $roleItem.data('subViews');
      this.removeSubView(subViews);
      var map = $roleItem.data('store');
      $roleItem.remove();
      this.roleAndDepartStore = _.without(this.roleAndDepartStore, map);
      this.setAddRoleButtonEnabled();
    }

    // addPerson() {

    //   let value;
    //   if(this.userType == "phone") {
    //     value = this.$('#js-phone').val();
    //     value = value.trim();
    //     let selectedCountryData = this.$("#js-phone").intlTelInput("getSelectedCountryData") || {};
    //     if(selectedCountryData.dialCode && selectedCountryData.dialCode != '86') {
    //       value = selectedCountryData.dialCode + "-" + value
    //     }
    //   } else {
    //     value = this.$('#js-email').val();
    //     value = value.trim();
    //   }

    //   if(!value) {
    //     MDMessageView.error(BabelStr.str(7406), this.$body);
    //     return
    //   }

    //   let name = this.$('#js-userName').val();
    //   name = _.escape(name)
    //   let pwd = this.$('#js-password').val();
    //   let sex = Number(this.$('input[name=sex]:checked').val());
    //   let contacts = this.$('#js-contacts').val();
    //   let backlog = this.$('#js-backlog').val();
    //   let isAdmin = this.isAdmin;
    //   let isDocAdmin = this.isDocAdmin;
    //   let joinEnterpriseTime = this.$('#js-joinTime').datepicker('getDate').getTime() / 1000;

    //   let spaceType = this.userSpaceInfoView.getPersonSpaceType();
    //   let spaceLimit = this.userSpaceInfoView.getSpaceLimit();

    //   // 过滤空的节点
    //   let roleAndDepartStore = _.filter(this.roleAndDepartStore, (departRole) => {
    //     if (departRole.departId === '#' || !departRole.departId) {
    //       return false;
    //     }
    //     return true;
    //   });
    //   let departmentIds = _.map(roleAndDepartStore, function(item) {
    //     return item.departId;
    //   });
    //   let roleIds = _.map(roleAndDepartStore, function(item) {
    //     return item.roleId;
    //   });

    //   let data = {
    //     'departmentIds': departmentIds,
    //     'roleIds': roleIds,
    //     'remarks': backlog,
    //     'enterpriseRoleId': this.conditionSelectView.getSelectedRoleId(),
    //     // 'addAsAdmin': isAdmin,
    //     // 'addAsDocAdmin': isDocAdmin,
    //     'sex': sex,
    //     'contacts': contacts,
    //     'name': name,
    //     'joinEnterpriseTime': joinEnterpriseTime,
    //     'canOwnPersonalFile': spaceType,
    //     'spaceLimit': spaceLimit
    //   }
    //   if (this.addBabelUser) {
    //     delete data['sex'];
    //   }
    //   this._addPerson(value, pwd, data);
    // }

    // _addPerson(email, pwd = undefined, data = {}) {
    //   let net = MMEnterpriseController.roleAndUsers;
    //   this.setDisabled(true);
    //   MDSpinnerloaderLayerView.showIn(this.$body);
    //   var mail = email;
    //   var phone = email;
    //   if (this.idIsPhone) {
    //     mail = null;
    //   } else {
    //     phone = null;
    //   }
    //   net.addEnterpriseMember(mail, phone, pwd, data, () => {
    //     this.setDisabled(false);
    //     this.close();
    //     _.isFunction(this.onAddSuccess) && this.onAddSuccess();
    //     MDSpinnerloaderLayerView.clearFrom(this.$body);
    //     MDMessageView.success(BabelStr.str(308))     //('添加成功');
    //   }, (code, msg) => {
    //     this.setDisabled(false);
    //     MDSpinnerloaderLayerView.clearFrom(this.$body);
    //     _.isFunction(this.onAddFail) && this.onAddFail();
    //     var error = BabelStr.str(309);    // 操作失败
    //     if(msg) {
    //       error = msg;
    //     }
    //     MDMessageView.error(error, this.$body);
    //   });
    // }
  }, {
    key: "addPerson",
    value: function addPerson() {
      var phone;
      phone = this.$('#js-phone').val();
      phone = phone.trim();
      if (phone.length > 0) {
        if (!app.ep.isPrivateCloud()) {
          var selectedCountryData = this.$("#js-phone").intlTelInput("getSelectedCountryData") || {};
          if (selectedCountryData.dialCode && selectedCountryData.dialCode != '86') {
            phone = selectedCountryData.dialCode + "-" + phone;
          }
        }
      }
      var email = this.$('#js-email').val();
      email = email.trim();
      if (!phone && !email) {
        _MDMessageView["default"].error(BabelStr.str(7406), this.$body);
        return;
      }
      var name = this.$('#js-userName').val();
      name = _.escape(name);
      var pwd = this.$('#js-password').val();
      var sex = Number(this.$('input[name=sex]:checked').val());
      var backlog = this.$('#js-backlog').val();
      var isAdmin = this.isAdmin;
      var isDocAdmin = this.isDocAdmin;
      var joinEnterpriseTime = this.$('#js-joinTime').datepicker('getDate').getTime() / 1000;
      var spaceType = this.userSpaceInfoView.getPersonSpaceType();
      var spaceLimit = this.userSpaceInfoView.getSpaceLimit();

      // 过滤空的节点
      var roleAndDepartStore = _.filter(this.roleAndDepartStore, function (departRole) {
        if (departRole.departId === '#' || !departRole.departId) {
          return false;
        }
        return true;
      });
      var departmentIds = _.map(roleAndDepartStore, function (item) {
        return item.departId;
      });
      var roleIds = _.map(roleAndDepartStore, function (item) {
        return item.roleId;
      });
      var data = {
        'departmentIds': departmentIds,
        'roleIds': roleIds,
        'remarks': backlog,
        'enterpriseRoleId': this.conditionSelectView.getSelectedRoleId(),
        // 'addAsAdmin': isAdmin,
        // 'addAsDocAdmin': isDocAdmin,
        'sex': sex,
        'name': name,
        'joinEnterpriseTime': joinEnterpriseTime,
        'canOwnPersonalFile': spaceType,
        'spaceLimit': spaceLimit == 0 ? undefined : spaceLimit
      };
      if (this.addBabelUser) {
        delete data['sex'];
      }
      this._addPerson(email, phone, pwd, data);
    }
  }, {
    key: "_addPerson",
    value: function _addPerson(email, phone) {
      var _this5 = this;
      var pwd = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
      var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var phoneArr = phone.split("-");
      if (phone && phoneArr.length == 1) {
        if (!_regexp["default"].isPhone(phone)) {
          _MDMessageView["default"].error(BabelStr.str(2326), this.$body);
          return;
        }
      }
      var net = _MMEnterpriseController["default"].roleAndUsers;
      this.setDisabled(true);
      _MDSpinnerloaderLayerView["default"].showIn(this.$body);
      var mail = email;
      // console.warn(data)
      // return

      net.addEnterpriseMember(mail, phone, pwd, data, function () {
        _this5.setDisabled(false);
        _this5.close();
        _.isFunction(_this5.onAddSuccess) && _this5.onAddSuccess();
        _MDSpinnerloaderLayerView["default"].clearFrom(_this5.$body);
        _MDMessageView["default"].success(BabelStr.str(308)); //('添加成功');
      }, function (code, msg) {
        _this5.setDisabled(false);
        _MDSpinnerloaderLayerView["default"].clearFrom(_this5.$body);
        _.isFunction(_this5.onAddFail) && _this5.onAddFail();
        var error = BabelStr.str(309); // 操作失败
        if (msg) {
          error = msg;
        }
        _MDMessageView["default"].error(error, _this5.$body);
      });
    }
  }, {
    key: "getRandomPwd",
    value: function getRandomPwd() {
      var pwd = _utils["default"].randomString();
      this.$('#js-password').val(pwd);
      var validator = this.$('#js-password').closest('form').validate();
      validator && validator.element(this.$('#js-password'));
    }
  }, {
    key: "getEnterpriseRoleCanSet",
    value: function getEnterpriseRoleCanSet() {
      // MMEnterpriseController.roleAndUsers.getEnterpriseRoleCanSet((roles)=>{
      //   let index;
      //   for(let i = 0 ; i < roles.length ; i++){
      //     let role = roles[i];
      //     let obj = {
      //       "name": role.getName(),
      //       "enterpriseRoleId": role.getId()
      //     }
      //     this.conditionArr.push(obj)
      //     if(role.get("default")){
      //       index = i
      //     }
      //   }
      //   this.enterpriseRoleId = this.conditionArr[index].enterpriseRoleId;
      //   this.conditionSelectView = new MDDropdownSelectListView({
      //     selectedIndex: index,
      //     dataProvider: this.conditionArr,
      //     labelField: "name",
      //     onChange: (obj) => {
      //       this.enterpriseRoleId = obj.enterpriseRoleId;
      //     }
      //   });
      //   this.addSubView(this.conditionSelectView, this.$(".role-select-block")[0]);
      // },()=>{

      // });

      this.conditionSelectView = new _MEEnterpriseRoleSelectView["default"]();
      this.addSubView(this.conditionSelectView, this.$(".role-select-block")[0]);
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      var _this6 = this;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEAddPersonWindowView.prototype), "viewDidRendered", this).call(this);
      this.$('#js-joinTime').datepicker({
        changeMonth: true,
        changeYear: true,
        onClose: function onClose() {
          var validator = _this6.$('#js-joinTime').closest('form').validate();
          validator && validator.element(_this6.$('#js-joinTime'));
        }
      });
      this.$('#js-joinTime').datepicker('setDate', new Date());
      this.getEnterpriseRoleCanSet();
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MEAddPersonWindowView';
    }
  }, {
    key: "setLastRoleId",
    value: function setLastRoleId(id) {
      MEAddPersonWindowView.roleId = id;
    }
  }, {
    key: "getLastRoleId",
    value: function getLastRoleId() {
      return MEAddPersonWindowView.roleId;
    }
  }, {
    key: "getDefaultDepId",
    value: function getDefaultDepId() {
      return MEAddPersonWindowView.defaultDepId;
    }
  }, {
    key: "setDefaultDepId",
    value: function setDefaultDepId(id) {
      return MEAddPersonWindowView.defaultDepId = id;
    }
  }]);
  return MEAddPersonWindowView;
}(_MDWindowView2["default"]);

},{"106":106,"108":108,"1098":1098,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"121":121,"138":138,"1415":1415,"1417":1417,"1421":1421,"1426":1426,"1437":1437,"1439":1439,"1446":1446,"1454":1454,"1463":1463,"1475":1475,"1498":1498,"189":189,"193":193,"201":201,"32":32,"55":55,"75":75,"93":93}],149:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1439);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDOneStepView4 = _interopRequireDefault(require(404));
var _MDStepByStepView = _interopRequireDefault(require(405));
var _MDLocalFileCollector = _interopRequireDefault(require(330));
var _MDProgressBar = _interopRequireDefault(require(338));
var _utils = _interopRequireDefault(require(108));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 * 批量上传企业人员
 * Created by jiang
 * 2017.6.11
 */
var MEUploadEntMemberWindow = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MEUploadEntMemberWindow, _MDWindowView);
  function MEUploadEntMemberWindow() {
    (0, _classCallCheck2["default"])(this, MEUploadEntMemberWindow);
    return _callSuper(this, MEUploadEntMemberWindow, arguments);
  }
  (0, _createClass2["default"])(MEUploadEntMemberWindow, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return '<div class="upload-mem-root"></div>';
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEUploadEntMemberWindow.prototype), "className", this).call(this);
      return "".concat(superCls, " m-upload-mem-win");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEUploadEntMemberWindow.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        onAddSuccess: null,
        indep: false,
        departId: ""
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      if (props.indep) {
        props.title = _MDLocalString["default"].getLocalString(3380);
      } else {
        props.title = _MDLocalString["default"].getLocalString(3136);
      }
      props.width = 600;
      props.buttonsAlign = 'right';
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEUploadEntMemberWindow.prototype), "initialize", this).call(this, props);
      var self = this;
      this.step0 = new MEUploadStep0({
        fileLoaded: function fileLoaded() {
          self.stepByStepView.enableNextStepButton();
        },
        indep: this.indep
      });
      this.step1 = new MEUploadStep1({
        passwordChanged: function passwordChanged() {
          if (self.step1.getDefaultPassword().length >= 6) {
            self.stepByStepView.enableNextStepButton();
          }
          ;
        },
        indep: this.indep,
        departId: this.departId
      });
      this.step2 = new MEUploadStep2();
      this.stepByStepView = new _MDStepByStepView["default"]({
        stepTitles: [this.title, _MDLocalString["default"].getLocalString(3137), _MDLocalString["default"].getLocalString(3138)],
        nextBtnCaptions: [_MDLocalString["default"].getLocalString(3139), _MDLocalString["default"].getLocalString(3138), ''],
        stepSubPanels: [this.step0, this.step1, this.step2],
        lastStepButtonCaption: _MDLocalString["default"].getLocalString(3140),
        finishedCallback: function finishedCallback() {
          self.close();
        },
        indep: this.indep,
        departId: this.departId,
        checkToGoNextFunc: function checkToGoNextFunc(curIndex, nextIndex, callback) {
          if (curIndex == 1) {
            if (!self.step1.validate()) {
              return;
            }
          }
          if (nextIndex == 2) {
            self.stepByStepView.hideButtonzone();
          }
          ;
          callback(true);
        },
        checkToGoPreFunc: function checkToGoPreFunc(curIndex, preIndex, callback) {
          if (curIndex == 2) {
            self.stepByStepView.showButtonzone();
          }
          ;
          callback(true);
        },
        panelShowing: function panelShowing(panelIndex) {
          if (panelIndex == 1) {
            self.step1.focusInput();
            if (self.step1.getDefaultPassword().length < 6) {
              self.stepByStepView.disableNextStepButton();
            }
            ;
          } else if (panelIndex == 2) {
            // 正在执行导入的界面
            self.uploadFileToServer();
          }
          ;
        }
      });
      this.addSubView(this.stepByStepView, this.$('.upload-mem-root'));
      this.stepByStepView.disableNextStepButton();
    }
  }, {
    key: "uploadFileToServer",
    value: function uploadFileToServer() {
      var self = this;
      var file = this.step0.getFile();
      var uploadURL;
      if (this.indep) {
        uploadURL = '/enterprise/importDepartmentUser.do';
      } else {
        uploadURL = '/enterprise/importEnterpriseData.do';
      }
      var psw = this.step1.getDefaultPassword();
      var param = {
        'password': psw,
        'fileName': file.name
      };
      if (this.indep) {
        param["depId"] = this.departId;
      }
      MMNetDiskDataController.uploadFile(file, uploadURL, param, function () {
        self.step2.setUploadFinished();
        if (self.onAddSuccess) {
          self.onAddSuccess();
        }
        ;
      }, function (code, msg) {
        self.step2.setUploadFailed(code, msg);
      }, function (progress) {
        self.step2.setProgress(progress);
      });
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MEUploadEntMemberWindow';
    }
  }]);
  return MEUploadEntMemberWindow;
}(_MDWindowView2["default"]);
var MEUploadStep0 = /*#__PURE__*/function (_MDOneStepView) {
  (0, _inherits2["default"])(MEUploadStep0, _MDOneStepView);
  function MEUploadStep0() {
    (0, _classCallCheck2["default"])(this, MEUploadStep0);
    return _callSuper(this, MEUploadStep0, arguments);
  }
  (0, _createClass2["default"])(MEUploadStep0, [{
    key: "el",
    value: function el() {
      return '<div class="step-zone step0-zone">' + '<div class="step0-title">' + _MDLocalString["default"].getLocalString(3141) + '</div>' + '<div class="step0-title">' + _MDLocalString["default"].getLocalString(3142) + '<span class="blue-text-btn download-tmp">' + _MDLocalString["default"].getLocalString(3143) + '</span></div>' + '<div class=""><span class="blue-text-btn upload-mem-btn">' + _MDLocalString["default"].getLocalString(9) + '</span><span class="upload-file-name"></span></div>' + '</div>';
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEUploadStep0.prototype), "initProps", this).call(this);
      return _.extend(superP, {});
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEUploadStep0.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .download-tmp": this._downloadTemplateClicked,
        "click .upload-mem-btn": this._uploadMembers
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEUploadStep0.prototype), "className", this).call(this);
      return superCls + '';
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEUploadStep0.prototype), "initialize", this).call(this, props);
      var self = this;
      this.$element = $('<input>');
      var $element = this.$element;
      $('body').append($element);
      $element.attr({
        'type': 'file',
        'name': 'file',
        'accept': '.xlsx'
      });
      //$element.attr('accept', 'image/*,' + SUPPORTED_FILETYPE);  // now we want to accept all files
      $element.css({
        'display': 'none',
        'opacity': 0
      });
      $element.on('change', function () {
        var files = $element[0].files;
        if (files.length) {
          self.file = files[0];
          self.$('.upload-file-name').text('《' + files[0].name + '》');
          if (self.fileLoaded) {
            self.fileLoaded();
          }
          ;
        }
        ;
      });
    }

    /**
    * 进入下一步之前的检验
    * return
    *      true - 可以离开本本步骤进入下一步骤
    *      false - 不可以离开当前步骤
    */
  }, {
    key: "beforeGoToNextStep",
    value: function beforeGoToNextStep(callback) {
      callback(false);
    }

    /**
    * 进入上一步之前的检验
    * return
    *      true - 可以离开本本步骤进入上一步骤
    *      false - 不可以离开当前步骤
    */
  }, {
    key: "beforeGoToPreStep",
    value: function beforeGoToPreStep(callback) {
      callback(false);
    }
  }, {
    key: "_downloadTemplateClicked",
    value: function _downloadTemplateClicked(e) {
      console.log('-------- down load template');
      var url = "";
      if (this.indep) {
        url = '/public/babelbird-importUserTemplate.xlsx';
      } else {
        url = '/public/babelbird-importTemplate.xlsx';
      }
      MMNetDiskDataController.downloadFile(url);
    }
  }, {
    key: "_uploadMembers",
    value: function _uploadMembers(e) {
      this.$element.click();
    }
  }, {
    key: "close",
    value: function close() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEUploadStep0.prototype), "close", this).call(this);
      this.$element.remove();
    }
  }, {
    key: "getFile",
    value: function getFile() {
      return this.file;
    }
  }]);
  return MEUploadStep0;
}(_MDOneStepView4["default"]);
var MEUploadStep1 = /*#__PURE__*/function (_MDOneStepView2) {
  (0, _inherits2["default"])(MEUploadStep1, _MDOneStepView2);
  function MEUploadStep1() {
    (0, _classCallCheck2["default"])(this, MEUploadStep1);
    return _callSuper(this, MEUploadStep1, arguments);
  }
  (0, _createClass2["default"])(MEUploadStep1, [{
    key: "el",
    value: function el() {
      return '<form><div class="step-zone step1-zone">' + '<div class="step1-text">' + _MDLocalString["default"].getLocalString(3137) + ' <span><input class="notempty password" required password type="text"></span><span class="blue-text-btn random-pass">' + _MDLocalString["default"].getLocalString(3144) + '</span></div>' + '<div class="promp-modi gray">' + _MDLocalString["default"].getLocalString(3145) + '</div>' + '</div></form>';
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEUploadStep1.prototype), "initProps", this).call(this);
      return _.extend(superP, {});
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEUploadStep1.prototype), "events", this).call(this);
      return _.extend(superE, {
        'keyup input': this._keyUP,
        'click .random-pass': this._randomPassword
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEUploadStep1.prototype), "className", this).call(this);
      return superCls + ' ';
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEUploadStep1.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "validate",
    value: function validate() {
      var validator = this.$el.validate();
      if (!validator.form()) {
        return false;
      }
      return true;
    }

    /**
    * 进入下一步之前的检验
    * return
    *      true - 可以离开本本步骤进入下一步骤
    *      false - 不可以离开当前步骤
    */
  }, {
    key: "beforeGoToNextStep",
    value: function beforeGoToNextStep(callback) {
      callback(false);
    }

    /**
    * 进入上一步之前的检验
    * return
    *      true - 可以离开本本步骤进入上一步骤
    *      false - 不可以离开当前步骤
    */
  }, {
    key: "beforeGoToPreStep",
    value: function beforeGoToPreStep(callback) {
      callback(false);
    }
  }, {
    key: "focusInput",
    value: function focusInput() {
      this.$('input').focus();
    }
  }, {
    key: "getDefaultPassword",
    value: function getDefaultPassword() {
      return this.$('input').val();
    }
  }, {
    key: "_keyUP",
    value: function _keyUP() {
      if (this.passwordChanged) {
        this.passwordChanged();
      }
      ;
    }
  }, {
    key: "_randomPassword",
    value: function _randomPassword() {
      // var numStr = Math.random() + ' ';
      // var randomWord = numStr.split('.')[1].substr(0, 6);
      var randomWord = _utils["default"].randomString();
      this.$('input').val(randomWord);
      if (this.passwordChanged) {
        this.passwordChanged();
      }
      ;
    }
  }]);
  return MEUploadStep1;
}(_MDOneStepView4["default"]);
var MEUploadStep2 = /*#__PURE__*/function (_MDOneStepView3) {
  (0, _inherits2["default"])(MEUploadStep2, _MDOneStepView3);
  function MEUploadStep2() {
    (0, _classCallCheck2["default"])(this, MEUploadStep2);
    return _callSuper(this, MEUploadStep2, arguments);
  }
  (0, _createClass2["default"])(MEUploadStep2, [{
    key: "el",
    value: function el() {
      return '<div class="step-zone step2-zone">' + '<div class="step2-text "><span class="finish-mark icon"></span><span class="prog-title">' + _MDLocalString["default"].getLocalString(3146) + '</span><span class="percent"></span></div>' + '<div class="progress-bar-root"></div>' + '</div>';
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEUploadStep2.prototype), "initProps", this).call(this);
      return _.extend(superP, {});
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEUploadStep2.prototype), "events", this).call(this);
      return _.extend(superE, {});
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEUploadStep2.prototype), "className", this).call(this);
      return superCls + ' ';
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEUploadStep2.prototype), "initialize", this).call(this, props);
      _MDProgressBar["default"].createProgressbarInDom(this.$('.progress-bar-root'));
      this.setProgress(0.5);
    }
  }, {
    key: "setProgress",
    value: function setProgress(percent) {
      _MDProgressBar["default"].setProgress(this.$('.progress-bar-root'), percent);
      this.$('.step2-text .percent').text(Math.round(percent * 100) + '%');
    }
  }, {
    key: "setUploadFinished",
    value: function setUploadFinished() {
      this.$('.step2-text').addClass('finished');
      this.$('.prog-title').text(_MDLocalString["default"].getLocalString(3147));
    }
  }, {
    key: "setUploadFailed",
    value: function setUploadFailed(errorCode, msg) {
      this.$('.step2-text').addClass('failed');
      var errorStr = _MDLocalString["default"].getLocalString(3148);
      if (msg) {
        errorStr = msg;
      }
      switch (errorCode) {
        case undefined:
          errorStr = _MDLocalString["default"].getLocalString(3149);
          break;
        case 200:
          break;
      }
      this.$('.prog-title').text(_MDLocalString["default"].getLocalString(3150) + " - " + errorStr);
    }

    /**
    * 进入下一步之前的检验
    * return
    *      true - 可以离开本本步骤进入下一步骤
    *      false - 不可以离开当前步骤
    */
  }, {
    key: "beforeGoToNextStep",
    value: function beforeGoToNextStep(callback) {
      callback(false);
    }

    /**
    * 进入上一步之前的检验
    * return
    *      true - 可以离开本本步骤进入上一步骤
    *      false - 不可以离开当前步骤
    */
  }, {
    key: "beforeGoToPreStep",
    value: function beforeGoToPreStep(callback) {
      callback(false);
    }
  }]);
  return MEUploadStep2;
}(_MDOneStepView4["default"]);

},{"108":108,"1150":1150,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"330":330,"338":338,"404":404,"405":405,"55":55,"93":93}],405:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1414);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMViewBase2 = _interopRequireDefault(require(22));
var _MDStepByStepViewTmpl = _interopRequireDefault(require(406));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // MDStepByStepView.js
// jiang
// 2017-6-11
var MDStepByStepView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MDStepByStepView, _MMViewBase);
  function MDStepByStepView() {
    (0, _classCallCheck2["default"])(this, MDStepByStepView);
    return _callSuper(this, MDStepByStepView, arguments);
  }
  (0, _createClass2["default"])(MDStepByStepView, [{
    key: "tmpl",
    value: function tmpl() {
      return _MDStepByStepViewTmpl["default"].main;
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDStepByStepView.prototype), "initProps", this).call(this);
      var next = BabelStr.str(3139); // 下一步
      var stop = BabelStr.str(89); // 完成
      return _.extend(superP, {
        stepTitles: ['step1', 'step2', 'step3'],
        nextBtnCaptions: [next, next, stop],
        stepSubPanels: [],
        finishedCallback: null,
        checkToGoNextFunc: null,
        checkToGoPreFunc: null,
        interval: 5,
        arrowWidth: 20,
        passedColor: '#2b7bea',
        nopassColor: '#f0f0f0',
        data: {
          'pre': BabelStr.str(652),
          // 上一步
          'nextStep': BabelStr.str(3139) // 下一步
        }
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDStepByStepView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .pre-step': this._preStepClickHandle,
        'click .next-step': this._nextStepClickHandle
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDStepByStepView.prototype), "className", this).call(this);
      return superCls + ' ';
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      this.curStep = -1;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDStepByStepView.prototype), "initialize", this).call(this, props);
      if (!props.stepTitles || props.stepTitles.length != props.stepSubPanels.length) {
        return;
      }
      ;
      for (var i = 0; i < props.stepTitles.length; i++) {
        var titleStr = props.stepTitles[i];
        this.$('.step-titles').append('<div class="step-title ' + 'step' + i + '">' + titleStr + '</div>');
      }
      ;
      for (var i = 0; i < this.stepSubPanels.length; i++) {
        var panel = this.stepSubPanels[i];
        this.addSubView(panel, this.$('.sub-panel-container'));
      }
      ;
    }
  }, {
    key: "setCurrentStep",
    value: function setCurrentStep(index) {
      var $titles = this.$('.step-title');
      if (index >= $titles.length) {
        return;
      }
      var w = this.$('.step-titles')[0].offsetWidth;
      var h = this.$('.step-titles')[0].offsetHeight;
      this.curStep = index;
      var canvas = this.$('.stepbystep')[0];
      var cxt = canvas.getContext("2d");
      cxt.fillStyle = "rgba(0,0,0,0)";
      cxt.clearRect(0, 0, w, h);
      for (var i = 0; i <= index; i++) {
        this._drawArrow(cxt, i, 'passed');
      }
      ;
      for (var i = index + 1; i < $titles.length; i++) {
        this._drawArrow(cxt, i, 'nopass');
      }
      ;
      for (var i = 0; i < this.stepSubPanels.length; i++) {
        this.stepSubPanels[i].hide();
      }
      ;
      if (index >= 0 && index < this.stepSubPanels.length) {
        this.stepSubPanels[index].show();
        this.panelShowing(index);
      }
      ;
      if (index == 0) {
        this.$('.pre-step').hide();
      } else {
        this.$('.pre-step').show();
      }
      this.$('.next-step').text(this.nextBtnCaptions[index]);
      $titles.removeClass('step-reached');
      for (var i = 0; i <= index; i++) {
        $($titles[i]).addClass('step-reached');
      }
      ;
    }
  }, {
    key: "_drawArrow",
    value: function _drawArrow(cxt, index, type) {
      var h = this.$('.step-titles')[0].offsetHeight;
      var $titles = this.$('.step-title');
      if (type == 'passed') {
        cxt.fillStyle = this.passedColor;
        cxt.strokeStyle = this.passedColor;
      } else {
        cxt.fillStyle = this.nopassColor;
        cxt.strokeStyle = this.nopassColor;
      }
      var x = index * (this.titleWidth + this.arrowWidth + this.interval);

      // 绘制箭头
      if (index == 0) {
        cxt.beginPath();
        cxt.moveTo(0, 0);
        cxt.lineTo(this.titleWidth, 0);
        cxt.lineTo(this.titleWidth + this.arrowWidth, h / 2);
        cxt.lineTo(this.titleWidth, h);
        cxt.lineTo(0, h);
        cxt.closePath();
        cxt.fill();
      } else if (index == $titles.length - 1) {
        cxt.beginPath();
        cxt.moveTo(x - this.arrowWidth, 0);
        cxt.lineTo(x + this.titleWidth, 0);
        cxt.lineTo(x + this.titleWidth, h);
        cxt.lineTo(x - this.arrowWidth, h);
        cxt.lineTo(x, h / 2);
        cxt.closePath();
        cxt.fill();
      } else {
        cxt.beginPath();
        cxt.moveTo(x - this.arrowWidth, 0);
        cxt.lineTo(x + this.titleWidth, 0);
        cxt.lineTo(x + this.titleWidth + this.arrowWidth, h / 2);
        cxt.lineTo(x + this.titleWidth, h);
        cxt.lineTo(x - this.arrowWidth, h);
        cxt.lineTo(x, h / 2);
        cxt.closePath();
        cxt.fill();
      }

      // 绘制文字 - 控制文字位置即可
      var title = this.$('.step-title')[index];
      $(title).css('top', '0px');
      $(title).css('left', x + 'px');
      $(title).css('width', this.titleWidth + 'px');
      $(title).css('height', h + 'px');
      $(title).css('line-height', h + 'px');
    }
  }, {
    key: "_nextStepClickHandle",
    value: function _nextStepClickHandle(e) {
      var index = this.curStep;
      var self = this;
      if (this.curStep == this.stepTitles.length - 1) {
        this.checkToGoNextFunc(index, index + 1, function (canGo) {
          if (canGo) {
            if (self.finishedCallback) {
              self.finishedCallback();
            }
            ;
            self.close();
          }
          ;
        });
      } else {
        this.checkToGoNextFunc(index, index + 1, function (canGo) {
          if (canGo) {
            self.setCurrentStep(self.curStep + 1);
          }
          ;
        });
      }
    }
  }, {
    key: "_preStepClickHandle",
    value: function _preStepClickHandle(e) {
      var self = this;
      if (this.curStep == 0) {} else {
        var index = this.curStep;
        this.checkToGoPreFunc(this.curStep, this.curStep - 1, function () {
          self.setCurrentStep(self.curStep - 1);
        });
      }
    }
  }, {
    key: "enableNextStepButton",
    value: function enableNextStepButton() {
      this.$('.next-step').attr("disabled", false);
    }
  }, {
    key: "disableNextStepButton",
    value: function disableNextStepButton() {
      this.$('.next-step').attr("disabled", true);
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      var w = this.$('.step-titles')[0].offsetWidth;
      var h = this.$('.step-titles')[0].offsetHeight;
      this.$('.stepbystep').attr('width', w + 'px');
      this.$('.stepbystep').attr('height', h + 'px');
      var steps = this.stepTitles.length;
      w = w - (steps - 1) * (this.interval + this.arrowWidth);
      this.titleWidth = w / steps;
      this.setCurrentStep(0);
    }
  }, {
    key: "hideButtonzone",
    value: function hideButtonzone() {
      this.$('.step-buttons').hide();
    }
  }, {
    key: "showButtonzone",
    value: function showButtonzone() {
      this.$('.step-buttons').show();
    }
  }]);
  return MDStepByStepView;
}(_MMViewBase2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1414":1414,"1454":1454,"1463":1463,"1475":1475,"22":22,"406":406}],406:[function(require,module,exports){
module.exports = {"main":"<div class=\"step-panel\">\r  <div class=\"step-titles\">\r    <canvas class=\"stepbystep\"></canvas>\r  </div>\r  <div class=\"sub-panel-container\"></div>\r  <div class=\"step-buttons btns-block flex-align end\">\r    <button class=\"pre-step button done\"><%=pre%></button>\r    <button class=\"next-step button done\"><%=nextStep%></button>\r  </div>\r</div>"};
},{}],404:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMViewBase2 = _interopRequireDefault(require(22));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // MDStepByStepView.js
// jiang
// 2017-6-11
var MDOneStepView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MDOneStepView, _MMViewBase);
  function MDOneStepView() {
    (0, _classCallCheck2["default"])(this, MDOneStepView);
    return _callSuper(this, MDOneStepView, arguments);
  }
  (0, _createClass2["default"])(MDOneStepView, [{
    key: "el",
    value: function el() {
      return '';
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneStepView.prototype), "className", this).call(this);
      return superCls + ' step-panel';
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneStepView.prototype), "initialize", this).call(this, props);
    }

    /**
    * 进入下一步之前的检验
    * return
    *      true - 可以离开本本步骤进入下一步骤
    *      false - 不可以离开当前步骤
    */
  }, {
    key: "beforeGoToNextStep",
    value: function beforeGoToNextStep(callback) {
      callback(false);
    }

    /**
    * 进入上一步之前的检验
    * return
    *      true - 可以离开本本步骤进入上一步骤
    *      false - 不可以离开当前步骤
    */
  }, {
    key: "beforeGoToPreStep",
    value: function beforeGoToPreStep(callback) {
      callback(false);
    }
  }]);
  return MDOneStepView;
}(_MMViewBase2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"22":22}],338:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
// MDProgressBar.js
// jiang
// 2017-6-12

var MDProgressBar = {
  createProgressbarInDom: function createProgressbarInDom($el) {
    var $progBar = $('<div class = "progress-bar">' + '<div class = "progress "></div>' + '</div>');
    $el.append($progBar);
  },
  setProgress: function setProgress($el, percent) {
    var progress = Math.round(percent * 100);
    progress = progress > 100 ? 100 : progress;
    $el.find('.progress').css('width', progress + "%");
  }
};
var _default = exports["default"] = MDProgressBar;

},{"1417":1417,"1454":1454,"1463":1463}],147:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MMModelBase = _interopRequireDefault(require(21));
var _MDTableView2 = _interopRequireDefault(require(89));
var _MEStaffAdminTableRowView = _interopRequireDefault(require(146));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MEDepRoleHelpWindow = _interopRequireDefault(require(130));
var _SortDirection = _interopRequireDefault(require(91));
var _PropType = _interopRequireDefault(require(90));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 *  员工信息table
 * javascript/enterprise/view/departs/MEStaffAdminTableView.js
 *  Created by dai
 *  2016.12.6
 */
var MEStaffAdminTableView = exports["default"] = /*#__PURE__*/function (_MDTableView) {
  (0, _inherits2["default"])(MEStaffAdminTableView, _MDTableView);
  function MEStaffAdminTableView() {
    (0, _classCallCheck2["default"])(this, MEStaffAdminTableView);
    return _callSuper(this, MEStaffAdminTableView, arguments);
  }
  (0, _createClass2["default"])(MEStaffAdminTableView, [{
    key: "emptyTmpl",
    value: function emptyTmpl() {
      if (this.isInitTable) {
        return "<div class=\"m-empty page-empty\" style=\"display: block;padding: 19px 0;\">\n              <p class=\"title\">" + _MDLocalString["default"].getLocalString(3124) + "</p>\n              <p class=\"info\">" + _MDLocalString["default"].getLocalString(3125) + "</p>\n            </div>";
      } else {
        return "<div class=\"m-empty page-empty\" style=\"display: block;padding: 19px 0;\">\n              <p class=\"title\">" + _MDLocalString["default"].getLocalString(3126) + "</p>\n              <p class=\"info\">" + _MDLocalString["default"].getLocalString(3127) + "</p>\n            </div>";
      }
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStaffAdminTableView.prototype), "className", this).call(this);
      return "".concat(superCls, " table-striped staff-table");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStaffAdminTableView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        keyName: "",
        departmentId: undefined,
        pageSize: 20,
        startIndex: 0,
        onLoadSuccess: _.noop,
        onLoadFailed: _.noop,
        sortBy: "name",
        sortDesc: 0,
        refreshTableViewWithIndex: _.noop
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStaffAdminTableView.prototype), "events", this).call(this);
      return _.extend(superE, {});
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props = _.extend({
        blankRenderer: function blankRenderer() {
          return _this.emptyTmpl();
        },
        bodyCls: "userRows",
        rowCls: "row",
        headerCls: "headerWrapper",
        rowClass: _MEStaffAdminTableRowView["default"],
        columns: [{
          name: _MDLocalString["default"].getLocalString(3128),
          dataIndex: "name",
          flex: 1
        }, {
          name: _MDLocalString["default"].getLocalString(3086),
          dataIndex: "departments",
          width: 180,
          help: app.currentUser.isEpAdminUser(),
          cellCls: "f-tc",
          helpCallback: function helpCallback() {
            console.log("------------ help clicked");
            _MEDepRoleHelpWindow["default"].show();
          }
        }, {
          name: _MDLocalString["default"].getLocalString(3072),
          dataIndex: "usedSpace",
          cellCls: "f-tc",
          width: 110
        }, {
          name: _MDLocalString["default"].getLocalString(3068),
          dataIndex: "recentAccessTime",
          cellCls: "f-tc",
          width: 160
        }, {
          name: _MDLocalString["default"].getLocalString(3129),
          dataIndex: "fileOwn",
          cellCls: "f-tc",
          width: 80
        }, {
          name: _MDLocalString["default"].getLocalString(217),
          dataIndex: "stopUser",
          cellCls: "f-tc",
          width: 60
        }],
        sorters: [{
          dataIndex: "name",
          useComparator: false,
          active: true,
          sortFn: function sortFn(direction, dataIndex) {
            _this._sortHandler(direction, dataIndex);
          }
        }, {
          dataIndex: "recentAccessTime",
          useComparator: false,
          sortFn: function sortFn(direction, dataIndex) {
            _this._sortHandler(direction, dataIndex);
          }
        }]
      }, props);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStaffAdminTableView.prototype), "initialize", this).call(this, props);
    }

    /**
     * 请求用户数据
     * @param  {object} params - 参数对象
     * @param {string} opt.keyName - 搜索关键字
     * @param {number} opt.departId - 部门id
     * @param {number} opt.pageSize - 每页个数
     * @param {number} opt.startIndex - 页的起始数据索引
     * @param  {function} onSuccess - 请求成功处理
     * @param  {function} onFail - 请求失败处理
     */
  }, {
    key: "requestUser",
    value: function requestUser(params, onSuccess, onFail) {
      var _this2 = this;
      this.startLoadingState();
      _.extend(this, params);
      _.isFunction(this.beforeRequest) && this.beforeRequest();
      _MMEnterpriseController["default"].getAllMember({
        userType: 0,
        keyName: this.keyName,
        departmentId: this.departmentId,
        pageSize: this.pageSize,
        startIndex: this.startIndex,
        norecursion: 1,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc
      }, function (members, count) {
        _this2.clearLoadingState();
        members["departmentId"] = _this2.departmentId;
        _this2.setDataCollection(members, false, false);
        _.isFunction(_this2.onLoadSuccess) && _this2.onLoadSuccess(members, count);
        _.isFunction(onSuccess) && onSuccess(members, count);
      }, function () {
        _.isFunction(_this2.onLoadFailed) && _this2.onLoadFailed();
        _.isFunction(onFail) && onFail();
      });
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var length = this.dataCollection.length;
      if (length === 0) {
        this.startIndex -= this.pageSize;
      }
      this.requestUser({
        startIndex: this.startIndex
      });
    }
  }, {
    key: "_sortHandler",
    value: function _sortHandler(direction, dataIndex) {
      var sortDesc = direction == _SortDirection["default"].Desc ? 1 : 0;
      this.clearRow(true);
      this.sortDesc = sortDesc;
      this.sortBy = dataIndex;
      this.refreshTableViewWithIndex(0);
    }
  }], [{
    key: "className",
    value: function className() {
      return "MEStaffAdminTableView";
    }
  }]);
  return MEStaffAdminTableView;
}(_MDTableView2["default"]);

},{"1098":1098,"1150":1150,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"130":130,"1454":1454,"146":146,"1463":1463,"1475":1475,"21":21,"89":89,"90":90,"91":91}],146:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1461);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDTableRowView2 = _interopRequireDefault(require(88));
var _utils = _interopRequireDefault(require(108));
var _MEEditInnerPersonWindowView = _interopRequireDefault(require(190));
var _MEDepRoleSelectView = _interopRequireDefault(require(189));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDMessageView = _interopRequireDefault(require(55));
var _MEStaffRowController = _interopRequireDefault(require(196));
var _MEOperateUserPopupView = _interopRequireDefault(require(144));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MEStaffAdminTableRowView = exports["default"] = /*#__PURE__*/function (_MDTableRowView) {
  (0, _inherits2["default"])(MEStaffAdminTableRowView, _MDTableRowView);
  function MEStaffAdminTableRowView() {
    (0, _classCallCheck2["default"])(this, MEStaffAdminTableRowView);
    return _callSuper(this, MEStaffAdminTableRowView, arguments);
  }
  (0, _createClass2["default"])(MEStaffAdminTableRowView, [{
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStaffAdminTableRowView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        defaultRoleId: -100,
        userInfo: null,
        columnRenders: function columnRenders() {
          return [{
            dataIndex: 'name',
            cellCls: 'name-col online-col text-hide',
            render: function render(name, userInfo, index) {
              var uname = userInfo.get('name');
              var mail = userInfo.getAccount();
              var isAdmin = userInfo.isEpAdminUser();
              var status = userInfo.getExactStatus();
              var renderStr = '';
              switch (status) {
                case 0:
                  renderStr += '<span class="state online" data-tooltip-dir="top" data-tooltip="' + _MDLocalString["default"].getLocalString(3121) + '"></span>';
                  break;
                case 1:
                  renderStr += '<span class="state offline" data-tooltip-dir="top" data-tooltip="' + _MDLocalString["default"].getLocalString(3122) + '"></span>';
                  break;
                default:
                  renderStr += '<span class="state freeze" data-tooltip-dir="top" data-tooltip="' + _MDLocalString["default"].getLocalString(3123) + '"></span>';
                  break;
              }
              renderStr += '<span class="name blue">' + uname + '</span>' + '<span class="email">(' + mail + ')</span>';
              if (isAdmin) {
                renderStr += '<span class="admin">' + _MDLocalString["default"].getLocalString(72) + '</span>';
              }
              return renderStr;
            }
          }, {
            dataIndex: 'departments',
            cellCls: 'role-col f-tc',
            render: function render(name, userInfo, index) {
              return "<div id=\"roleList\"></div>";
            }
          }, {
            dataIndex: 'usedSpace',
            cellCls: 'space-col f-tc',
            render: function render(name, userInfo, index) {
              var usedSpace = userInfo.get('usedSpace');
              // let totalSpace = userInfo.get('totalSpace');
              return _utils["default"].convertSpace(usedSpace);
            }
          }, {
            dataIndex: 'recentAccessTime',
            render: function render(name, userInfo, index) {
              var recentAccessTimeCls = userInfo.getRecentAccessTimeCls();
              return "<div class=\"recent-time f-tc ".concat(recentAccessTimeCls, "\">").concat(userInfo.getRecentAccessTime(), "</div>");
            }
          }, {
            dataIndex: 'fileOwn',
            cellCls: 'file-col f-tc',
            render: function render(name, userInfo, index) {
              if (app.currentUser.isEpAdminUser() && app.currentUser.getUserId() != userInfo.getUserId()) {
                return '<button class="text-button transfer">' + _MDLocalString["default"].getLocalString(3060) + '</button>';
              } else {
                return '--';
              }
            }
          }, {
            dataIndex: 'stopUser',
            cellCls: 'stop-col f-tc',
            render: function render(name, userInfo, index) {
              var status = userInfo.getStatus();
              var userId = userInfo.getId();
              var currentUserId = app.currentUser.getId();
              var ownerId = app.ep.getOwnerId();
              if (currentUserId === userId) {
                return "--";
              }
              if (app.currentUser.isEpAdminUser()) {
                return '<button class="text-button operate ">' + _MDLocalString["default"].getLocalString(217) + '</button>';
                if (userId === ownerId) {
                  return '<button class="text-button" disabled>' + _MDLocalString["default"].getLocalString(3064) + '</button>';
                }
                if (status === 1) {
                  return '<button class="text-button recover-user">' + _MDLocalString["default"].getLocalString(3063) + '</button>';
                } else {
                  return '<button class="text-button operate stop-user">' + _MDLocalString["default"].getLocalString(3064) + '</button>';
                }
              }
              ;
            }
          }];
        }
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStaffAdminTableRowView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .name, .email': this.editInnerPerson,
        'dblclick': this.editInnerPerson,
        'click .transfer': this.fileTransfer,
        'mouseup .stop-user': this.stopUser,
        'mouseup .recover-user': this.recoverUser,
        'mouseup .operate': this._operate,
        'mousedown .operate': this._operateMouseDown
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStaffAdminTableRowView.prototype), "initialize", this).call(this, props);
      this.listenTo(this.rowModel, 'change', this.userInfoChanged);
      this.userInfo = this.rowModel;
      this.setDefaultRoleId();
      this.roleSelectView = new _MEDepRoleSelectView["default"]({
        needNoRole: true,
        monitoredScroller: '.staff-admin-navpage',
        onChange: function onChange(roleInfo) {
          _this._changeRole(roleInfo);
        },
        onReady: function onReady() {
          var selectedRoleId = _this.defaultRoleId;
          _this.roleSelectView.selectedByRoleId(selectedRoleId, true);
        }
      });
      this.addSubView(this.roleSelectView, this.$('#roleList')[0], true);
    }
  }, {
    key: "setDefaultRoleId",
    value: function setDefaultRoleId() {
      var departId = this.rowModel.collection.departmentId;
      var departments = this.rowModel.get('departments');
      if (departments && departments.length) {
        for (var i = 0; i < departments.length; i++) {
          var depart = departments[i];
          if (depart.departmentId === departId) {
            this.defaultRoleId = depart.roleId;
          }
        }
      }
    }
  }, {
    key: "_setDepartmentRoleId",
    value: function _setDepartmentRoleId(roleInfo) {
      var roleId = roleInfo.getId();
      var roleName = roleInfo.getName();
      var departId = this.rowModel.collection.departmentId;
      var departments = this.rowModel.get('departments');
      if (departments && departments.length) {
        for (var i = 0; i < departments.length; i++) {
          var newDeps = JSON.parse(JSON.stringify(departments));
          var depart = newDeps[i];
          if (depart.departmentId === departId) {
            depart.roleId = roleId;
            depart.roleName = roleName;
            this.rowModel.set('departments', newDeps);
          }
        }
      }
    }
  }, {
    key: "_changeRole",
    value: function _changeRole(roleInfo) {
      var _this2 = this;
      var departmentId = this.rowModel.collection.departmentId;
      var roleId = roleInfo.getId();
      var userId = this.rowModel.getId();
      var userIds = [userId];
      _MMEnterpriseController["default"].department.changeUsersRoleInDepartment(userIds, departmentId, roleId, function () {
        _this2._setDepartmentRoleId(roleInfo);
        _MDMessageView["default"].success(_MDLocalString["default"].getLocalString(3505));
      }, function () {
        _MDMessageView["default"].error(_MDLocalString["default"].getLocalString(3506));
      });
    }
  }, {
    key: "editInnerPerson",
    value: function editInnerPerson() {
      var _this3 = this;
      if (!app.currentUser.isEpAdminUser()) {
        return;
      }
      ;
      var userInfo = this.rowModel;
      var editInnerPersonView = new _MEEditInnerPersonWindowView["default"]({
        userInfo: userInfo,
        onDeleteAccountSuccess: function onDeleteAccountSuccess() {
          _this3.getTableView().refresh();
        }
      });
      editInnerPersonView.show();
    }
  }, {
    key: "fileTransfer",
    value: function fileTransfer() {
      var _this4 = this;
      _MEStaffRowController["default"].fileTransfer(this.rowModel, function () {
        _this4.getTableView().refresh();
      });
    }
  }, {
    key: "stopUser",
    value: function stopUser($e) {
      _MEStaffRowController["default"].stopUser(this.rowModel, $e);
    }
  }, {
    key: "recoverUser",
    value: function recoverUser($e) {
      _MEStaffRowController["default"].recoverUser(this.rowModel, $e);
    }
  }, {
    key: "userInfoChanged",
    value: function userInfoChanged(userInfo, option) {
      if (userInfo.hasChanged('status') || userInfo.hasChanged('name') || userInfo.hasChanged('email') || userInfo.hasChanged('isEnterpriseManager')) {
        var userId = userInfo.getId();
        var currentUserId = app.currentUser.getId();
        var ownerId = app.ep.getOwnerId();
        var uname = userInfo.get('name');
        var mail = userInfo.get('email');
        var isAdmin = userInfo.isEpAdminUser();
        var exactStatus = userInfo.getExactStatus();
        var status = userInfo.getStatus();
        var renderStr = '';
        var renderButtonStr = '';
        switch (exactStatus) {
          case 0:
            renderStr += '<span class="state online" data-tooltip-dir="top" data-tooltip="' + _MDLocalString["default"].getLocalString(3121) + '"></span>';
            break;
          case 1:
            renderStr += '<span class="state offline" data-tooltip-dir="top" data-tooltip="' + _MDLocalString["default"].getLocalString(3122) + '"></span>';
            break;
          default:
            renderStr += '<span class="state freeze" data-tooltip-dir="top" data-tooltip="' + _MDLocalString["default"].getLocalString(3123) + '"></span>';
            break;
        }
        renderStr += '<span class="name blue">' + uname + '</span>' + '<span class="email">(' + mail + ')</span>';
        if (isAdmin) {
          renderStr += '<span class="admin">' + _MDLocalString["default"].getLocalString(72) + '</span>';
        }
        this.$('.name-col').empty().append(renderStr);

        // if (currentUserId === userId) {
        //   renderButtonStr = `--`
        // }
        // if (userId === ownerId) {
        //   renderButtonStr = '<button class="text-button" disabled>'+MDLocalString.getLocalString(3064)+'</button>'
        // }
        // if (status === 1) {
        //   renderButtonStr = '<button class="text-button recover-user">'+MDLocalString.getLocalString(3063)+'</button>';
        // } else {
        //   renderButtonStr = '<button class="text-button stop-user">'+MDLocalString.getLocalString(3064)+'</button>';
        // }
        // this.$('.stop-col').empty().append(renderButtonStr);
      } else if (userInfo.hasChanged('usedSpace')) {
        var usedSpace = userInfo.get('usedSpace');
        this.$('.space-col').empty().text(_utils["default"].convertSpace(usedSpace));
      } else if (userInfo.hasChanged('departments')) {
        var departId = this.rowModel.collection.departmentId;
        var departments = this.rowModel.get('departments');
        if (departments && departments.length) {
          for (var i = 0; i < departments.length; i++) {
            var depart = departments[i];
            if (depart.departmentId === departId) {
              this.roleSelectView.selectedByRoleId(depart.roleId, true);
            }
          }
        }
      }
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStaffAdminTableRowView.prototype), "viewDidRendered", this).call(this);
      console.log('MEStaffAdminTableRowView viewDidRendered');
    }
  }, {
    key: "_operate",
    value: function _operate(e) {
      e.stopPropagation();
      e.preventDefault();
      var depId = this.rowModel.collection.departmentId;
      _MEOperateUserPopupView["default"].show({
        currentTarget: e.currentTarget,
        userInfo: this.userInfo,
        depId: depId
      });
    }
  }, {
    key: "_operateMouseDown",
    value: function _operateMouseDown(e) {
      e.stopPropagation();
      e.preventDefault();
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MEStaffAdminTableRowView';
    }
  }, {
    key: "showOperatePopup",
    value: function showOperatePopup() {}
  }]);
  return MEStaffAdminTableRowView;
}(_MDTableRowView2["default"]);

},{"108":108,"1098":1098,"1150":1150,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"144":144,"1454":1454,"1461":1461,"1463":1463,"1475":1475,"189":189,"190":190,"196":196,"55":55,"88":88}],190:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1541);
require(1421);
require(1429);
require(1465);
require(1439);
require(1448);
require(1446);
require(1436);
require(1546);
require(1437);
require(1498);
require(1417);
require(1463);
require(1415);
require(1426);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDCheckboxView = _interopRequireDefault(require(37));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MEEditInnerPersonWindowViewTpl = _interopRequireDefault(require(122));
var _MDSwitchView = _interopRequireDefault(require(79));
var _MEFileTransferWindowView = _interopRequireDefault(require(194));
var _MDAlertView = _interopRequireDefault(require(32));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDSpinnerloaderLayerView = _interopRequireDefault(require(75));
var _MEAddPersonWindowViewTpl = _interopRequireDefault(require(121));
var _MEDepRoleSelectView = _interopRequireDefault(require(189));
var _MEDepartChooseView = _interopRequireDefault(require(138));
var _utils = _interopRequireDefault(require(108));
var _MDMessageView = _interopRequireDefault(require(55));
var _MEChangePwdWindowView = _interopRequireDefault(require(188));
var _MDCombobox = _interopRequireDefault(require(27));
var _MEUserSpaceInfoView = _interopRequireDefault(require(201));
var _MEEnterpriseRoleSelectView = _interopRequireDefault(require(193));
var _ErrorCode = _interopRequireDefault(require(1087));
var _MDMolaUser = _interopRequireDefault(require(272));
var _regexp = _interopRequireDefault(require(106));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDLoadMaskView = _interopRequireDefault(require(49));
var _MDFilesUploadedByUserPopupWin = _interopRequireDefault(require(711));
var _MDOneUserJoinsharePopupWin = _interopRequireDefault(require(608));
var _MDUserLoginPopupWin = _interopRequireDefault(require(715));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 * 新增企业人员
 * Created by manjun.han
 * 2016.12.1
 */
var MEEditInnerPersonWindowView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MEEditInnerPersonWindowView, _MDWindowView);
  function MEEditInnerPersonWindowView() {
    (0, _classCallCheck2["default"])(this, MEEditInnerPersonWindowView);
    return _callSuper(this, MEEditInnerPersonWindowView, arguments);
  }
  (0, _createClass2["default"])(MEEditInnerPersonWindowView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return _MEEditInnerPersonWindowViewTpl["default"].root;
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEEditInnerPersonWindowView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        userInfo: null,
        onDeleteAccountSuccess: _.noop,
        onDeleteAccountFail: _.noop,
        onRoleChanged: _.noop,
        roleAndDepartStore: [],
        departSpaceInfos: [],
        showFooter: false,
        conditionArr: [
          // {"name": "普通成员"},
          // {"name": "受限人员"},
          // {"name": "文档管理员"},
          // {"name": "企业管理员"}
        ]
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEEditInnerPersonWindowView.prototype), "className", this).call(this);
      return "".concat(superCls, " m-edit-ip-win m-edit-inner-person");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEEditInnerPersonWindowView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click #lookPersonFile": this._lookPersonFile,
        "click #js-resetPsw": this._resetPsw,
        "click #js-transformFile": this._transformFile,
        "click #js-clearRole": this._clearRole,
        "click #js-delAccount": this._deleteAccount,
        "click #js-stopAccount": this._stopAccount,
        "click #js-restoreAccount": this._restoreAccount,
        "click #js-editBasicInfo": this._showEditInfoForm,
        "click #js-cancelEditBasicInfo": this._cancelEditForm,
        "click #js-updateUserInfo": this._updateUserInfo,
        "click #js-editDepartRole": this._showEditDepartAndRole,
        "click #js-addNewRole": this._addExtraRoleHandler,
        "click .ep-ic-sm-close": this.removeExtraRole,
        "click #js-cancelEditDepartInfo": this._cancelEditDepartRole,
        "click #js-updateDepartInfo": this._saveDepartRoleChange,
        // 'click .edit-space-btn': this._editSpaceClickHandle,
        "click .save-space-btn": this._saveSpaceClickHandle,
        "click #js-changePwd": this._changePwdHandler,
        "keydown .limeted-input": this._limitedKeydown,
        "keyup .limeted-input": this._limitedKeyup,
        "click .save-download-speed-limit": this._saveDownloadSpeedLimit,
        "blur #js-email": this.emailInputBlurHandler,
        "blur #js-phone": this.phoneInputBlurHandler,
        "click .upload-list": this._showUploadList,
        "click .joinshare-log": this._showJoinshareLog,
        "click .my-share-btn": this._showMyshare,
        "click .joinproject-log": this._showJoinprojectLog,
        "click .specialfiles": this._showspecialfiles,
        "click .login-list": this._showLoginLog,
        "click .export-file-list": this._exportFileList,
        'click .exit': this._exitClickHandle
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      var name = props.userInfo.getUserName();
      props.title = "".concat(name, "(").concat(BabelStr.str(204), ")");
      props.width = 880;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEEditInnerPersonWindowView.prototype), "initialize", this).call(this, props);
      this.listenTo(this.userInfo, "change", this._userInfoChanged);
      this._renderSpaceInfos();
      var net = _MMEnterpriseController["default"].roleAndUsers;
      _MMEnterpriseController["default"].getCurrentEnterpriseInfo(function (enterprise) {
        _this.enterprise = enterprise;
        _this._checkToShowSpaceEdit();
        // net.getUserSpaceInfo(this.userInfo.getUserId(), (userSpaceInfos) => {
        //   this.userSpaceInfos = userSpaceInfos[0]['spaceInfos']
        //   this.setUserSpaceInfos(this.userSpaceInfos);
        //   this.$(".save-space-btn").removeClass('done');

        // }, () => {

        // });
      }, function () {});
      this.adminChanged = false;
      if (props.userInfo.getUserId() === app.currentUser.getUserId() || props.userInfo.getUserId() === app.ep.getOwnerId()) {
        this.$("#js-delAccount").hide();
        this.$(" #js-stopAccount").hide();
        // this.adminRoleSwicthView.setDisabled(true);
      }
      if (props.userInfo.getUserId() === app.currentUser.getUserId()) {
        this.$(" #lookPersonFile").hide();
        this.$(" #js-transformFile").hide();
      }
      this.getTerminalInfosById();
      if (!props.userInfo.hasEmail()) {
        this.$(".reset-pwd-block").remove();
      }
      _MMEnterpriseController["default"].getUsersByIds([this.userInfo.getUserId()], true, function (users) {
        var user = users[0];
        _this.userInfo.set(user);
        _this._renderBasicInfo();
      });
      this.librarySwitch = new _MDSwitchView["default"]({
        onChange: function onChange(notify) {
          console.warn(notify);
          notify = notify ? 1 : 0;
          _this._setLibrary(notify);
        }
      });
      this.librarySwitch.renderTo(this.$(".library-switch"));
      this.aiTokenSwitch = new _MDSwitchView["default"]({
        onChange: function onChange(notify) {
          console.warn(notify);
          notify = notify ? 0 : 1;
          _this._setAIToken(notify);
        }
      });
      this.aiTokenSwitch.renderTo(this.$(".ai-token-switch"));
      this.syncSwitch = new _MDSwitchView["default"]({
        onChange: function onChange(notify) {
          console.warn(notify);
          notify = notify ? 0 : 1;
          _this._setSync(notify);
        }
      });
      this.syncSwitch.renderTo(this.$(".sync-switch"));

      // if(this.userInfo.isUndefinedcanAccessMaterialLibrary()) {
      _MMEnterpriseController["default"].isUserCanAccessMaterialLibrary(this.userInfo.getUserId(), function (canAccessMaterialLibrary) {
        _this.userInfo.setCanAccessMaterialLibrary(canAccessMaterialLibrary);
        _this.updateLibrarySwitch();
      });
      // } else {
      //   this.updateLibrarySwitch()
      // }

      if (!window.ep.enableMaterial || !window.materialLibrary) {
        this.$(".library-block").addClass("f-hide");
      } else {
        this.$(".library-block").removeClass("f-hide");
      }
      _MMEnterpriseController["default"].getUserOptionsAsEntMember(this.userInfo.getUserId(), function (memberOptions) {
        _this.userInfo.set("memberOptions", memberOptions);
        _this.updateAITokenSwitch();
        _this.updateSyncSwitch();
      });
      if (!window.supportAI) {
        this.$(".ai-token-block").addClass("f-hide");
      }
    }
  }, {
    key: "updateSyncSwitch",
    value: function updateSyncSwitch() {
      if (this.userInfo.isCloseSync()) {
        this.syncSwitch.close(true);
      } else {
        this.syncSwitch.open(true);
      }
    }
  }, {
    key: "updateAITokenSwitch",
    value: function updateAITokenSwitch() {
      if (this.userInfo.isCloseAI()) {
        this.aiTokenSwitch.close(true);
      } else {
        this.aiTokenSwitch.open(true);
      }
    }
  }, {
    key: "updateLibrarySwitch",
    value: function updateLibrarySwitch() {
      if (this.userInfo.getCanAccessMaterialLibrary()) {
        this.librarySwitch.open(true);
      } else {
        this.librarySwitch.close(true);
      }
    }
  }, {
    key: "_setAIToken",
    value: function _setAIToken(sign) {
      var _this2 = this;
      _MMEnterpriseController["default"].setUserOptionsAsEntMemberByBit([this.userInfo.getUserId()], 1, sign, function () {
        _MDMessageView["default"].success(BabelStr.str(308), _this2.$body);
        _this2.userInfo.setMemberOptions(1, sign);
      }, function (code, msg) {
        _MDMessageView["default"].error(msg, _this2.$body);
        if (sign) {
          _this2.aiTokenSwitch.close(true);
        } else {
          _this2.aiTokenSwitch.open(true);
        }
      });
    }
  }, {
    key: "_setSync",
    value: function _setSync(sign) {
      var _this3 = this;
      _MMEnterpriseController["default"].setUserOptionsAsEntMemberByBit([this.userInfo.getUserId()], 2, sign, function () {
        _MDMessageView["default"].success(BabelStr.str(308), _this3.$body);
        _this3.userInfo.setMemberOptions(2, sign);
      }, function (code, msg) {
        _MDMessageView["default"].error(msg, _this3.$body);
        if (sign) {
          _this3.syncSwitch.close(true);
        } else {
          _this3.syncSwitch.open(true);
        }
      });
    }
  }, {
    key: "_setLibrary",
    value: function _setLibrary(sign) {
      var _this4 = this;
      _MMEnterpriseController["default"].setUserCanAccessMaterialLibrary(this.userInfo.getUserId(), sign, function () {
        _MDMessageView["default"].success(BabelStr.str(308), _this4.$body);
        _this4.userInfo.setCanAccessMaterialLibrary(sign);
      }, function (code, msg) {
        _MDMessageView["default"].error(msg, _this4.$body);
        if (sign) {
          _this4.librarySwitch.close(true);
        } else {
          _this4.librarySwitch.open(true);
        }
      });
    }
  }, {
    key: "_exitClickHandle",
    value: function _exitClickHandle($e) {
      var _this5 = this;
      var id = $($e.target).closest(".item").data("sessionid");
      var option = {
        okFun: function okFun() {
          _this5.logoutById(id);
        },
        message: BabelStr.str(2567)
      };
      _MDAlertView["default"].showStandardSelection(option);
    }
  }, {
    key: "logoutById",
    value: function logoutById(id) {
      var _this6 = this;
      _MMEnterpriseController["default"].onlineEquipment.kickUserSession(id, function () {
        _MDMessageView["default"].success(BabelStr.str(308), _this6.$body);
        _this6.$(".item[data-sessionid=".concat(id, "]")).remove();
      }, function () {
        _MDMessageView["default"].error(BabelStr.str(168), _this6.$body);
      });
    }
  }, {
    key: "_exportFileList",
    value: function _exportFileList() {
      _MDLoadMaskView["default"].show(undefined, {
        bodyMsg: BabelStr.str(4855),
        width: 220
      });
      _MMEnterpriseController["default"].downloadUserSpecialFileList(this.userInfo.getUserId(), function (token) {
        _MDLoadMaskView["default"].remove();
        // this.getFileStatusByToken(
        //   token,
        //   () => {
        //     let url = `enterprise/downloadByToken.do?token=${token}`;
        //     this.downFile(url);
        //   },
        //   (res) => {
        //     MDSnackbarView.show(res.msg);
        //   }
        // );
      }, function (res) {
        _MDSnackbarView["default"].show(res.msg);
      });
    }
  }, {
    key: "downFile",
    value: function downFile(realUrl) {
      var $fileDownloader = $("#file-downloader-filelist");
      if ($fileDownloader.length == 0) {
        $fileDownloader = $("<a>");
        $fileDownloader.attr("id", "ile-downloader-filelist").appendTo("body");
        $fileDownloader.width(0).height(0).css("visibility", "hidden");
      }
      $fileDownloader.attr("href", realUrl);
      $fileDownloader[0].click();
    }
  }, {
    key: "getFileStatusByToken",
    value: function getFileStatusByToken(token, success, fail) {
      var _this7 = this;
      _MMEnterpriseController["default"].getFileStatusByToken(token, function (res) {
        if (res.fileIsReady) {
          _MDLoadMaskView["default"].remove();
          success();
        } else if (res.code != 0) {
          _MDSnackbarView["default"].show(res.msg);
          _MDLoadMaskView["default"].remove();
        } else {
          setTimeout(function () {
            _this7.getFileStatusByToken(token, success, fail);
          }, 2000);
        }
      }, function (error) {
        fail(error);
      });
    }

    // _showJoinprojectLog($e) {
    //   if ($($e.target).hasClass("disabled")) {
    //     return;
    //   }
    //   this.showJoinprojectLog();
    // }

    // _showspecialfiles($e) {
    //   if ($($e.target).hasClass("disabled")) {
    //     return;
    //   }
    //   this.showspecialfiles();
    // }

    // _showJoinshareLog($e) {
    //   if ($($e.target).hasClass("disabled")) {
    //     return;
    //   }
    //   this.showJoinshareLog();
    // }
  }, {
    key: "checkTerminalName",
    value: function checkTerminalName(name) {
      if (name.indexOf("babel") == 0) {
        name = name.slice(5, name.length);
      }
      return name;
    }
  }, {
    key: "_saveDownloadSpeedLimit",
    value: function _saveDownloadSpeedLimit() {
      var _this8 = this;
      var val = this.$(".download-speed").val();
      val = parseFloat(val);
      if (val !== 0 && (val < 100 || val > 20480) || _.isNaN(val)) {
        _MDMessageView["default"].error(BabelStr.str(6357), this.$body);
        return;
      }
      var id = this.userInfo.getUserId();
      _MMEnterpriseController["default"].setDownloadSpeedForUsers([id], val, function () {
        _MDMessageView["default"].success(BabelStr.str(308), _this8.$body);
        _this8.userInfo.set("maxDownloadSpeed", val);
      }, function (code, msg) {
        _MDMessageView["default"].error(msg, _this8.$body);
      });
    }
  }, {
    key: "getTerminalInfosById",
    value: function getTerminalInfosById() {
      var _this9 = this;
      var userId = this.userInfo.getUserId();
      _MMEnterpriseController["default"].onlineEquipment.getTerminalInfosById(userId, function (result) {
        var data = {};
        var lastLogin = {};
        // data.time = MMCommonFun.formatTime(result.lastLoginTime);
        // if(result.name) {
        //   data.name = result.name;
        // }else {
        //   data.name = result.addr + "  ip:" + result.ip;
        // }
        var sessionArr = [];
        data.deviceArr = [];
        _.each(result, function (item) {
          if (_.isUndefined(lastLogin.time) || lastLogin.time > item.time) {
            lastLogin = item;
          }
          item.clientStr = "";
          if (item.terminalType) {
            item.clientStr += "<span class=\"browser ".concat(item.terminalType, "\"></span>");
          }
          if (item.terminalName && item.terminalName != "unknown") {
            var terminalName = item.terminalName;
            terminalName = item.terminalNumber ? BabelStr.str(item.terminalNumber) : terminalName;
            terminalName = _this9.checkTerminalName(terminalName);
            item.clientStr += "<span class='device-name'>".concat(terminalName, "</span>");
          } else {
            return;
          }
          if (!item.name) {
            item.addr = item.addr ? item.addr : "";
            item.name = "ip:" + item.ip.ip + item.addr;
          }
          if (sessionArr.indexOf(item.sessionId) < 0) {
            data.deviceArr.push(item);
            sessionArr.push(item.sessionId);
          }
        });
        // data.time = MMCommonFun.formatTime(lastLogin.time);

        // if(lastLogin.name) {
        //   data.name = lastLogin.name;
        // }else if(lastLogin.ip){
        //   data.name = lastLogin.addr + "  ip:" + lastLogin.ip.ip;
        // }
        data.recentAccessTime = _this9.userInfo.get("recentAccessTime");
        data.recentAccessTime = !!data.recentAccessTime ? _utils["default"].formatTime(data.recentAccessTime, "yyyy-MM-dd HH:mm") : "--";
        var template = _.template(_MEEditInnerPersonWindowViewTpl["default"].lastlogin)(data);
        _this9.$(".lastlogin-block").html(template);
      });
    }
  }, {
    key: "_hasPrivateFilePerChanged",
    value: function _hasPrivateFilePerChanged(index) {
      var _this10 = this;
      var net = _MMEnterpriseController["default"].roleAndUsers;
      var sign = index - 1;
      var data = {
        ownFile: sign
      };
      var userId = this.userInfo.getUserId();
      net.editUser(userId, data, function () {
        _this10.userInfo.setOwnFile(sign);
        _MDMessageView["default"].success(BabelStr.str(308), _this10.$body);
        _this10._checkToShowSpaceEdit();
      }, function () {
        _MDMessageView["default"].error(BabelStr.str(309), _this10.$body);
      });
    }
  }, {
    key: "_checkToShowSpaceEdit",
    value: function _checkToShowSpaceEdit() {
      var canOwn = this.userInfo.getOwnFile();
      if (canOwn == 1 || canOwn == -1 && this.enterprise.canOwnPersonalFile()) {
        // this.$(".space-edit-block").show();
        this.userSpaceInfoView.showSpaceEdit(true);
      } else {
        // this.$(".space-edit-block").hide();
        this.userSpaceInfoView.showSpaceEdit(false);
      }
    }
  }, {
    key: "_limitedKeydown",
    value: function _limitedKeydown(e) {
      MMCommonFun.allowNumberic(e);
    }
  }, {
    key: "_limitedKeyup",
    value: function _limitedKeyup(e) {
      if (this.$(".limeted-input").val().length == 0) {
        this.$(".save-space-btn").addClass("disabled");
      } else {
        this.$(".save-space-btn").removeClass("disabled");
      }
    }
  }, {
    key: "_saveSpaceClickHandle",
    value: function _saveSpaceClickHandle() {
      var _this11 = this;
      if (!this.$(".save-space-btn").hasClass("disabled")) {
        this.$(".save-space-btn").addClass("disabled");
        var newValue = Number.parseFloat(this.$(".limeted-input").val());
        if (newValue == this.userLimeted) {
          return;
        }
        var net = _MMEnterpriseController["default"].roleAndUsers;
        var data = {
          spaceLimit: (newValue - 0) * 1024
        };
        var userId = this.userInfo.getUserId();
        net.editUser(userId, data, function () {
          _this11.userInfo.setSpaceLimit(newValue);
          _MDMessageView["default"].success(BabelStr.str(3258), _this11.$body);
        }, function () {
          _MDMessageView["default"].error(BabelStr.str(3259), _this11.$body);
        });
      }
    }
  }, {
    key: "_controlAdminRole",
    value: function _controlAdminRole(opened) {
      var _this12 = this;
      var net = _MMEnterpriseController["default"].roleAndUsers;
      var ids = [this.userInfo.getUserId()];
      if (opened) {
        net.addAdministrators({
          userIds: ids
        }, function () {
          _this12.userInfo.set("isEnterpriseManager", true);
        }, function () {
          _MDMessageView["default"].error(BabelStr.str(3260), _this12.$body);
          // this.adminRoleSwicthView.close();
        });
      } else {
        net.removeAdministrators({
          userIds: ids
        }, function () {
          _this12.userInfo.set("isEnterpriseManager", false);
          _this12.adminChanged = true;
        }, function () {
          // this.adminRoleSwicthView.open();
          _MDMessageView["default"].error(BabelStr.str(3260), _this12.$body);
        });
      }
    }
  }, {
    key: "_controlDocAdminRole",
    value: function _controlDocAdminRole(opened) {
      var _this13 = this;
      var net = _MMEnterpriseController["default"].roleAndUsers;
      var ids = [this.userInfo.getUserId()];
      if (opened) {
        net.addDocAdministrators({
          userIds: ids
        }, function () {
          _this13.userInfo.set("isDocManager", true);
        }, function () {
          _MDMessageView["default"].error(BabelStr.str(3260), _this13.$body);
          // this.docAdminRoleSwicthView.close();
        });
      } else {
        net.removeDocAdministrators({
          userIds: ids
        }, function () {
          _this13.userInfo.set("isDocManager", false);
          _this13.docAdminChanged = true;
        }, function () {
          // this.docAdminRoleSwicthView.open();
          _MDMessageView["default"].error(BabelStr.str(3260), _this13.$body);
        });
      }
    }
  }, {
    key: "_userInfoChanged",
    value: function _userInfoChanged(userInfo, opts) {
      if (userInfo.hasChanged("departments")) {
        this._renderRoleList();
      }
    }
  }, {
    key: "_saveDepartRoleChange",
    value: function _saveDepartRoleChange() {
      this.$("#js-editRoleBlock form").submit();
    }
  }, {
    key: "_showEditInfoForm",
    value: function _showEditInfoForm() {
      var _this14 = this;
      var userInfo = this.userInfo.toJSON();
      var data = {
        name: userInfo["name"],
        email: userInfo["email"] == "--" ? "" : userInfo["email"],
        phone: userInfo["phone"],
        remarks: userInfo["remarks"],
        status: userInfo["status"],
        sex: userInfo["sex"],
        basicInfo: BabelStr.str(3013),
        // 基本信息
        nameStr: BabelStr.str(3073),
        // 姓名
        sexStr: BabelStr.str(3074),
        // 性别
        manStr: BabelStr.str(3075),
        // 男
        womanStr: BabelStr.str(3076),
        // 女
        concatStr: BabelStr.str(3077),
        // 联系方式
        joinTimeStr: BabelStr.str(3078),
        // 入职时间
        saveStr: BabelStr.str(3080),
        // 保存
        cancleStr: BabelStr.str(3081),
        // 取消
        remarkStr: BabelStr.str(3079) // 备注
      };
      var html = _.template(_MEEditInnerPersonWindowViewTpl["default"].basicInfoForm)(data);
      this.$("#js-basicInfo").empty().html(html);
      this.$("#js-joinTime").datepicker({
        changeMonth: true,
        changeYear: true,
        onClose: function onClose() {
          var validator = _this14.$("#js-joinTime").closest("form").validate();
          validator && validator.element(_this14.$("#js-joinTime"));
        }
      });
      this.$("#js-joinTime").datepicker("setDate", new Date(userInfo["joinEnterpriseTime"] * 1000));
      this.$("#js-basicInfo form").validate({
        rules: {
          phone: {
            isUniversalPhone: true
          }
        },
        messages: {
          username: {
            required: BabelStr.str(3261)
          }
        },
        submitHandler: function submitHandler() {
          var name = _this14.$("#js-userName").val() || "";
          var sex = _this14.$("input[name=sex]:checked").val() ? _this14.$("input[name=sex]:checked").val() : 0;
          var remarks = _this14.$("#js-backlog").val() || "";
          var phone = _this14.$("#js-phone").val() || "";
          var email = _this14.$("#js-email").val();
          var joinEnterpriseTime = _this14.$("#js-joinTime").datepicker("getDate").getTime() / 1000;
          var net = _MMEnterpriseController["default"].roleAndUsers;
          var data = {
            name: _.escape(name.trim()),
            sex: _.escape(sex),
            phone: phone.trim().length ? _.escape(phone.trim()) : -1,
            email: email.length ? _.escape(email) : -1,
            // email: _.escape(email),
            remarks: _.escape(remarks.trim()),
            joinEnterpriseTime: joinEnterpriseTime
          };
          if (!phone.length && !email.length) {
            _MDMessageView["default"].error(BabelStr.str(6578), _this14.$body);
            return;
          }
          var userId = _this14.userInfo.getUserId();
          net.editUser(userId, data, function () {
            if (data.phone == -1) {
              data.phone = "";
            }
            if (data.email == -1) {
              data.email = "";
            }
            _this14.userInfo.set(data);
            _this14._renderBasicInfo();
          }, function (code, msg) {
            if (msg) {
              _MDMessageView["default"].error(msg, _this14.$body);
            } else {
              if (code == _ErrorCode["default"].DuplicatedKey) {
                if (data.phone == -1) {
                  data.phone = "";
                }
                if (data.email == -1) {
                  data.email = "";
                }
                if (data.phone && _this14.userInfo.getPhone() != data.phone) {
                  _MDMessageView["default"].error(BabelStr.str(8351), _this14.$body);
                } else {
                  _MDMessageView["default"].error(BabelStr.str(6572), _this14.$body);
                }
                // MDMessageView.error(BabelStr.str(8351), this.$body);
              } else {
                _MDMessageView["default"].error(BabelStr.str(3259), _this14.$body);
              }
            }
          });
        }
      });
    }
  }, {
    key: "phoneInputBlurHandler",
    value: function phoneInputBlurHandler($e) {
      var value = this.$("#js-phone").val();
      value = value.trim();
      var curPhone = this.userInfo.get("phone");
      if (!value) {
        return;
      } else if (!_regexp["default"].isPhone(value)) {
        return;
      } else if (curPhone == value) {
        return;
      }
      this.inputBlurHandler2(value, "phone");
    }
  }, {
    key: "emailInputBlurHandler",
    value: function emailInputBlurHandler($e) {
      var value = this.$("#js-email").val();
      value = value.trim();
      var curEmail = this.userInfo.get("email");
      if (!value) {
        return;
      } else if (!_regexp["default"].isEmail(value)) {
        return;
      } else if (curEmail == value) {
        return false;
      }
      this.inputBlurHandler2(value, "email");
    }
  }, {
    key: "inputBlurHandler2",
    value: function inputBlurHandler2(value, type) {
      var _this15 = this;
      var net = _MMEnterpriseController["default"];
      var checkUserInofFunc = null;
      if (type == "phone") {
        checkUserInofFunc = net.checkPhoneInfo;
        this.phoneError = false;
      } else {
        this.idIsPhone = false;
        checkUserInofFunc = net.checkEmailInfo;
        this.emailError = false;
      }
      this._checkActionButton();
      checkUserInofFunc(value, function (emailInfo) {
        var isBabelUser = emailInfo["userInfo"] && emailInfo["userInfo"]["registered"];
        var isEnterpriseMember = emailInfo["isEnterpriseMember"];
        var userInfo = emailInfo["userInfo"] || {
          name: "asdasd"
        };
        _this15._checkActionButton();
        var errorObj = {};
        if (emailInfo["otherEnterpriseMember"] && !app.ep.isPrivateCloud() || isEnterpriseMember || isBabelUser) {
          var validator = _this15.$("form").validate();
          if (type == "phone") {
            errorObj[type] = BabelStr.str(6574);
          } else {
            errorObj[type] = BabelStr.str(6573);
          }
          validator.showErrors(errorObj);
        }
      }, function () {});
    }
  }, {
    key: "_checkActionButton",
    value: function _checkActionButton() {
      if (!this.emailError && !this.phoneError) {
        // this.setActionButtonDisabledByIndex(false, 1);
      } else {
        // this.setActionButtonDisabledByIndex(true, 1);
      }
    }
  }, {
    key: "_updateUserInfo",
    value: function _updateUserInfo() {
      // this.$('#js-basicInfo form').submit();
    }
  }, {
    key: "_cancelEditForm",
    value: function _cancelEditForm() {
      this._renderBasicInfo();
      return false;
    }
  }, {
    key: "_addExtraRoleHandler",
    value: function _addExtraRoleHandler($e) {
      if (this.$("#js-addNewRole").hasClass("disabled")) {
        return;
      } else {
        this._addExtraRole();
      }
    }
  }, {
    key: "_showEditDepartAndRole",
    value: function _showEditDepartAndRole() {
      var _this16 = this;
      this.$("#js-roleList").remove();
      this.$("#js-editDepartRole").hide();
      var departments = this.userInfo.get("departments");
      var data = {
        addRoleStr: _MDLocalString["default"].getLocalString(3087),
        addRoleTipStr: _MDLocalString["default"].getLocalString(3088),
        saveStr: _MDLocalString["default"].getLocalString(3080),
        cancleStr: _MDLocalString["default"].getLocalString(3081)
      };
      var html = _.template(_MEEditInnerPersonWindowViewTpl["default"].editDepartRole)(data);
      this.$("#js-role-block").html(html);
      this.$editRoleList = this.$("#js-editRoleList");
      this.roleAndDepartStore = [];
      this.$("#js-editRoleBlock form").validate({
        rules: {},
        errorPlacement: function errorPlacement(error, element) {
          if (element.data("inDepartChooser")) {
            var errorContainer = $(element).data("departmentTreeView").getValidateErrorContainer();
            $(error).appendTo(errorContainer);
          } else {
            error.insertAfter(element);
          }
        },
        /**
         * 校验成功后保存
         */
        submitHandler: function submitHandler() {
          // 权限并未更改
          if (_this16.isDepartmentRoleChanged()) {
            _this16._renderRoleList();
            return;
          }
          var filteredRoleAndDepartStore = [];
          _MDSpinnerloaderLayerView["default"].showIn(_this16.$("#js-role-block"));
          var net = _MMEnterpriseController["default"].department;
          var departmentIds = [];
          var roleIds = [];
          _.each(_this16.roleAndDepartStore, function (departRoleNode) {
            if (departRoleNode.departmentId == "#" || !departRoleNode.departmentId) {
              return;
            }
            filteredRoleAndDepartStore.push(departRoleNode);
            departmentIds.push(departRoleNode.departmentId);
            roleIds.push(departRoleNode.roleId);
          });
          var userId = _this16.userInfo.getUserId();
          net.setUserDepartmentAndRoles(userId, departmentIds, roleIds, function () {
            _MDSpinnerloaderLayerView["default"].clearFrom(_this16.$("#js-role-block"));
            _this16.userInfo.set("departments", filteredRoleAndDepartStore); // 出发change事件

            // this._refreshUsedSpaceInfo(filteredRoleAndDepartStore);
          }, function () {
            _MDSpinnerloaderLayerView["default"].clearFrom(_this16.$("#js-role-block"));
            _MDMessageView["default"].error(BabelStr.str(3259), _this16.$body);
          });
        }
      });
      this.roleAndDepartStore = [];
      var department = departments[0] || {
        roleId: undefined,
        departmentId: undefined
      };
      var departRoleNode = {
        roleId: department["roleId"],
        departmentId: department["departmentId"],
        roleName: BabelStr.getCurrentLanguage() == "en" ? department["roleNameEn"] || department["roleName"] : department["roleName"],
        departmentName: department["departmentName"]
      };
      this._addExtraRole(departRoleNode.roleId, departRoleNode.roleName, departRoleNode.departmentId, departRoleNode.departmentName);
      var roleId, departId, roleName, departmentName;
      if (departments.length > 1) {
        for (var i = 1; i < departments.length; i++) {
          roleId = departments[i]["roleId"];
          departId = departments[i]["departmentId"];
          roleName = departments[i]["roleName"];
          departmentName = departments[i]["departmentName"];
          this._addExtraRole(roleId, roleName, departId, departmentName);
        }
      }
      this.$(".add-role-btn").addClass("disabled");
    }

    // _refreshUsedSpaceInfo(filteredRoleAndDepartStore) {

    //   let processed = [];
    //   let personal = _.find(this.userSpaceInfos, function(spaceInfo) {
    //     return !_.has(spaceInfo, 'departmentId');
    //   });
    //   processed.push(personal);
    //   _.each(filteredRoleAndDepartStore, (departRole) => {
    //     let departmentId = departRole.departmentId;
    //     let spaceInfo = _.findWhere(this.userSpaceInfos, { 'departmentId': departmentId });
    //     if (!spaceInfo) {
    //       spaceInfo = {
    //         'departmentId': departmentId,
    //         'name': departRole.departmentName,
    //         'usedSpace': 0
    //       }
    //     }
    //     processed.push(spaceInfo);
    //   });
    //   this.userSpaceInfos = processed;
    //   // this._renderSpaceInfos(processed);  //todo

    // }
  }, {
    key: "_addExtraRole",
    value: function _addExtraRole() {
      var _this17 = this;
      var roleId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      var roleName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var departId = arguments.length > 2 ? arguments[2] : undefined;
      var departmentName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
      var data = {
        paredtDepStr: _MDLocalString["default"].getLocalString(3085),
        roleStr: _MDLocalString["default"].getLocalString(3086),
        removeStr: BabelStr.str(6060) // 移除
      };
      var tpl = _.template(_MEEditInnerPersonWindowViewTpl["default"].extraRoleItem)(data);
      var $roleItem = $(tpl);
      var departRoleNode = {
        roleId: roleId,
        departmentId: departId,
        roleName: roleName,
        departmentName: departmentName
      };
      this.roleAndDepartStore.push(departRoleNode);
      this.$editRoleList.append($roleItem);
      var departTreeView = new _MEDepartChooseView["default"]({
        // readonly: true,
        needRoot: true,
        needAddDefault: false,
        placeholder: BabelStr.str(3097),
        selectedDepartId: departId,
        silentInit: true,
        onReady: function onReady() {
          _this17.setAddRoleButtonEnabled();
        },
        onChange: function onChange(node) {
          departRoleNode.departmentId = node["id"];
          departRoleNode.departmentName = node["text"];

          // if (node['parent'] == '#') {
          //   departRoleNode.departmentId = '#';
          //   selectView.setDisabled(true);
          //   departTreeView.reset();
          //   selectView.reset();
          // } else {
          selectView.setDisabled(false);
          selectView.selectDefaultRole();
          // }
          _this17.setAddRoleButtonEnabled();
        }
      });
      this.addSubView(departTreeView, $roleItem.find("#js-departSlot")[0], true);
      departTreeView.$("input").attr("name", departTreeView.cid).rules("add", {
        notEqualTo: function notEqualTo() {
          return function (value, input) {
            var hasSame = _this17.hasSameDepartment(departRoleNode);
            return !hasSame;
          };
        },
        messages: {
          notEqualTo: BabelStr.str(3262)
        }
      });
      var disabled = !roleId ? true : false;
      var selectView = new _MEDepRoleSelectView["default"]({
        needNoRole: true,
        disabled: disabled,
        onReady: function onReady() {
          var selectedRoleId = roleId;
          selectView.selectedByRoleId(selectedRoleId, true);
          _this17.setAddRoleButtonEnabled();
        },
        onChange: function onChange(role) {
          departRoleNode.roleId = role.getId();
          departRoleNode.roleName = role.getName();
        }
      });
      this.addSubView(selectView, $roleItem.find("#js-roleSlot")[0], true);
      $roleItem.data("subViews", [selectView, departTreeView]).data("store", departRoleNode);
      this.setAddRoleButtonEnabled();
    }
  }, {
    key: "hasSameDepartment",
    value: function hasSameDepartment(departRole) {
      var hasSame = false;
      _.each(this.roleAndDepartStore, function (departRoleInner) {
        if (departRoleInner !== departRole && departRoleInner.departmentId == departRole.departmentId) {
          hasSame = true;
        }
      });
      return hasSame;
    }
  }, {
    key: "removeExtraRole",
    value: function removeExtraRole($e) {
      var $roleItem = $($e.target).closest(".extra-role-block");
      var subViews = $roleItem.data("subViews");
      this.removeSubView(subViews);
      var departRoleNode = $roleItem.data("store");
      $roleItem.remove();
      this.roleAndDepartStore = _.without(this.roleAndDepartStore, departRoleNode);
      this.setAddRoleButtonEnabled();
    }
  }, {
    key: "_cancelEditDepartRole",
    value: function _cancelEditDepartRole($e) {
      this.eachSubViews(function (subView) {
        if (subView instanceof _MEDepRoleSelectView["default"] || subView instanceof _MEDepartChooseView["default"]) {
          subView.removeFromSuperView();
        }
      });
      this._renderRoleList();
      // 阻止表单提交
      return false;
    }
  }, {
    key: "isDepartmentRoleChanged",
    value: function isDepartmentRoleChanged() {
      var departmentRoles = _.filter(this.roleAndDepartStore, function (departRole) {
        if (departRole.departmentId === "#" || !departRole.departmentId) {
          return false;
        }
        return true;
      });
      var originalDepartmentRoles = _.map(this.userInfo.get("departments"), function (department) {
        return {
          roleId: department["roleId"],
          departmentId: department["departmentId"],
          roleName: department["roleName"],
          departmentName: department["departmentName"]
        };
      });
      return _.isEqual(departmentRoles, originalDepartmentRoles);
    }
  }, {
    key: "setAddRoleButtonEnabled",
    value: function setAddRoleButtonEnabled() {
      var disabled = false;
      _.each(this.roleAndDepartStore, function (departRole) {
        if (departRole.departmentId === "#" || !departRole.departmentId) {
          disabled = true;
        }
      });
      if (!disabled) {
        var departIds = _.map(this.roleAndDepartStore, function (item) {
          return item.departmentId;
        });
        disabled = _.uniq(departIds).length != this.roleAndDepartStore.length ? true : false;
      }
      if (disabled) {
        this.$(".add-role-btn").addClass("disabled");
      } else {
        this.$(".add-role-btn").removeClass("disabled");
      }
    }
  }, {
    key: "_lookPersonFile",
    value: function _lookPersonFile() {
      var memberId = this.userInfo.getUserId();
      var managerId = app.currentUser.getId();
      var url = "/view/user/" + memberId;
      var win = app.pathRouter.openNetTab(url, "_blank");
      win.focus();
    }
  }, {
    key: "_deleteAccount",
    value: function _deleteAccount() {
      var _this18 = this;
      var name = this.userInfo.getUserName();
      var alert = new _MDAlertView["default"]({
        title: BabelStr.str(170),
        message: "<div>".concat(BabelStr.str(3263, {
          name: name
        }), "</div>\n                <div class=\"red1\">").concat(BabelStr.str(3264), "</div>"),
        buttons: [{
          label: BabelStr.str(3096),
          type: "done",
          onClick: function onClick() {
            _this18._deleteAccountAactually();
          }
        }, {
          label: BabelStr.str(155)
        }]
      });
      alert.show();
    }
  }, {
    key: "_restoreAccount",
    value: function _restoreAccount() {
      var _this19 = this;
      var net = _MMEnterpriseController["default"].roleAndUsers;
      var userId = this.userInfo.getUserId();
      net.unfreezeUsers([userId], function () {
        var tpl = _MEEditInnerPersonWindowViewTpl["default"].accountStatus;
        var data = {
          status: 0,
          stoppedStr: _MDLocalString["default"].getLocalString(3082),
          recoverStr: _MDLocalString["default"].getLocalString(3063),
          stopStr: _MDLocalString["default"].getLocalString(3064),
          basicInfoStr: _MDLocalString["default"].getLocalString(3013),
          editStr: _MDLocalString["default"].getLocalString(3070),
          editPasswordStr: _MDLocalString["default"].getLocalString(3083),
          nameStr: _MDLocalString["default"].getLocalString(3073),
          emailStr: _MDLocalString["default"].getLocalString(214),
          sexStr: _MDLocalString["default"].getLocalString(3074),
          manStr: _MDLocalString["default"].getLocalString(3075),
          womanStr: _MDLocalString["default"].getLocalString(3076),
          concatStr: _MDLocalString["default"].getLocalString(3077),
          joinTimeStr: _MDLocalString["default"].getLocalString(3078),
          remarkStr: _MDLocalString["default"].getLocalString(3079)
        };
        var resHtml = _.template(tpl)(data);
        _this19.userInfo.set("status", 0);
        _this19.$("#js-accountStatus").empty().html(resHtml);
        _this19._refreshAccountStatus(0);
      }, function (code, msg) {
        _MDMessageView["default"].error(msg, _this19.$body);
      });
    }
  }, {
    key: "_deleteAccountAactually",
    value: function _deleteAccountAactually() {
      var _this20 = this;
      var net = _MMEnterpriseController["default"];
      var userIds = [this.userInfo.getUserId()];
      _MDSpinnerloaderLayerView["default"].showIn(this.$body);
      var userCollection = this.userInfo.collection;
      this.setDisabled(true);
      net.deleteMembersById(userIds, function () {
        _MDSpinnerloaderLayerView["default"].clearFrom(_this20.$body);
        _this20.close();
        _this20.onDeleteAccountSuccess();
      }, function () {
        _this20.setDisabled(false);
        _MDSpinnerloaderLayerView["default"].clearFrom(_this20.$body);
        _this20.onDeleteAccountFail();
        _MDMessageView["default"].error(BabelStr.str(309), _this20.$body);
      });
    }
  }, {
    key: "_stopAccount",
    value: function _stopAccount() {
      var _this21 = this;
      var name = this.userInfo.getUserName();
      var alert = new _MDAlertView["default"]({
        title: BabelStr.str(170),
        message: "<div>".concat(BabelStr.str(3265, {
          name: name
        }), "</div>"),
        buttons: [{
          label: BabelStr.str(3096),
          type: "done",
          onClick: function onClick() {
            var net = _MMEnterpriseController["default"].roleAndUsers;
            var userId = _this21.userInfo.getUserId();
            net.freezeUsers([userId], function () {
              var tpl = _MEEditInnerPersonWindowViewTpl["default"].accountStatus;
              var resHtml = _.template(tpl)({
                status: 1,
                stoppedStr: _MDLocalString["default"].getLocalString(3082),
                recoverStr: _MDLocalString["default"].getLocalString(3063),
                stopStr: _MDLocalString["default"].getLocalString(3064),
                basicInfoStr: _MDLocalString["default"].getLocalString(3013),
                editStr: _MDLocalString["default"].getLocalString(3070),
                editPasswordStr: _MDLocalString["default"].getLocalString(3083),
                nameStr: _MDLocalString["default"].getLocalString(3073),
                emailStr: _MDLocalString["default"].getLocalString(214),
                sexStr: _MDLocalString["default"].getLocalString(3074),
                manStr: _MDLocalString["default"].getLocalString(3075),
                womanStr: _MDLocalString["default"].getLocalString(3076),
                concatStr: _MDLocalString["default"].getLocalString(3077),
                joinTimeStr: _MDLocalString["default"].getLocalString(3078),
                remarkStr: _MDLocalString["default"].getLocalString(3079)
              });
              _this21.userInfo.set("status", 1);
              _this21.$("#js-accountStatus").empty().html(resHtml);
              _this21._refreshAccountStatus(1);
            }, function () {
              _MDMessageView["default"].error(BabelStr.str(3259), _this21.$body);
            });
          }
        }, {
          label: BabelStr.str(3081)
        }]
      });
      alert.show();
    }
  }, {
    key: "render",
    value: function render() {
      var data = this.getRenderData();
      _MDWindowView2["default"].prototype.render.call(this, data);
      this._renderBasicInfo();
      this._renderRoleList();
    }
  }, {
    key: "_renderBasicInfo",
    value: function _renderBasicInfo() {
      var data = this.getRenderData();
      var infoHTML = _.template(_MEEditInnerPersonWindowViewTpl["default"].basiInfoBlock)(data);
      this.$("#js-basicInfo").empty().html(infoHTML);
      this.$("#js-avatar").imageLoader();
    }
  }, {
    key: "_transformFile",
    value: function _transformFile() {
      var win = new _MEFileTransferWindowView["default"]({
        userInfo: this.userInfo
      });
      win.show();
    }
  }, {
    key: "_clearRole",
    value: function _clearRole() {
      var _this22 = this;
      var name = this.userInfo.getUserName();
      var alert = new _MDAlertView["default"]({
        title: BabelStr.str(170),
        message: "<div>".concat(BabelStr.str(6818, {
          name: name
        }), "</div>\n                <div class=\"red1\">").concat(BabelStr.str(6819, {
          name: name
        }), "</div>"),
        buttons: [{
          label: BabelStr.str(154),
          type: "done",
          onClick: function onClick() {
            _MMEnterpriseController["default"].clearUserAllOrgnizationPermission(_this22.userInfo.getUserId(), function () {
              _this22.userInfo.set("departments", []);
              _MDMessageView["default"].success(BabelStr.str(308), _this22.$body);
            }, function (code, msg) {
              if (code == 12) {
                msg = BabelStr.str(8516);
              }
              _MDMessageView["default"].error(msg, _this22.$body);
            });
          }
        }, {
          label: BabelStr.str(155)
        }]
      });
      alert.show();
    }
  }, {
    key: "_resetPsw",
    value: function _resetPsw() {
      var _this23 = this;
      this.$("#js-resetPsw").attr("disabled", "disabled");
      var userId = this.userInfo.get("id");
      var email = this.userInfo.get("email");
      $.post("/enterprise/sendRetsetEntMemberPswMail.do", {
        userId: userId,
        email: email
      }, function (data, status) {
        console.log(data);
        _this23.$("#js-resetPsw").removeAttr("disabled");
        if (status == "success") {
          if (data.code == 0) {
            _MDMessageView["default"].success(BabelStr.str(3390), _this23.$body);
          } else if (data.code == 250) {
            _MDMessageView["default"].error(BabelStr.str(7031), _this23.$body);
          } else {
            _MDMessageView["default"].error(data.msg, _this23.$body);
          }
        } else {
          _MDMessageView["default"].error(BabelStr.str(7032), _this23.$body);
        }
      });
    }
  }, {
    key: "setUserSpaceInfos",
    value: function setUserSpaceInfos(userSpaceInfos) {
      this.userSpaceInfoView.setUserSpaceInfos(userSpaceInfos);
    }
  }, {
    key: "_renderSpaceInfos",
    value: function _renderSpaceInfos(userSpaceInfos) {
      var _this24 = this;
      var html = _.template(_MEEditInnerPersonWindowViewTpl["default"].spaceBlock)();
      this.$("#js-spaceInfo").empty().html(html);
      if (this.userSpaceInfoView) {
        this.userSpaceInfoView.remove();
      }
      this.userSpaceInfoView = new _MEUserSpaceInfoView["default"]({
        userSpaceInfos: userSpaceInfos,
        userInfo: this.userInfo,
        permissionChangedCb: function permissionChangedCb(index) {
          _this24._hasPrivateFilePerChanged(index);
        }
      });
      this.addSubView(this.userSpaceInfoView, this.$(".space-info-block"));
    }
  }, {
    key: "_renderRoleList",
    value: function _renderRoleList() {
      var data = this.getRenderData();
      data = _.extend(data, {
        paredtDepStr: _MDLocalString["default"].getLocalString(3085),
        roleStr: _MDLocalString["default"].getLocalString(3086)
      });
      var roleListHTML = _.template(_MEEditInnerPersonWindowViewTpl["default"].roleList)(data);
      this.$("#js-role-block").empty().html(roleListHTML);
      this.$("#js-editDepartRole").show();
      var userInfo = this.userInfo.toJSON();
      this._refreshAccountStatus(userInfo["status"]);
    }
  }, {
    key: "_refreshAccountStatus",
    value: function _refreshAccountStatus(status) {
      if (status) {
        this.$(".account-status").removeClass("hide");
      } else {
        this.$(".account-status").addClass("hide");
      }
    }
  }, {
    key: "getRenderData",
    value: function getRenderData() {
      var userInfo = this.userInfo.toJSON();
      var joinEnterpriseTime = _utils["default"].formatTime(userInfo["joinEnterpriseTime"], "yyyy-MM-dd");
      var recentAccessTime = this.userInfo.get("recentAccessTime");
      recentAccessTime = !!recentAccessTime ? _utils["default"].formatTime(recentAccessTime, "yyyy-MM-dd HH:mm") : "--";
      var data = {
        avatarURL: this.userInfo.getAvatarImageURL(),
        maxDownloadSpeed: this.userInfo.get("maxDownloadSpeed") || 0,
        name: this.userInfo.getUserName(),
        email: this.userInfo.getEmail(),
        //userInfo['email'],
        emailStr: _MDLocalString["default"].getLocalString(3030),
        account: this.userInfo.getAccount(),
        //userInfo['account'],
        accountStr: _MDLocalString["default"].getLocalString(214),
        phone: this.userInfo.getPhone() || "--",
        remarks: !userInfo["remarks"] ? "--" : userInfo["remarks"],
        status: userInfo["status"],
        sex: userInfo["sex"],
        joinEnterpriseTime: joinEnterpriseTime,
        departs: userInfo["departments"],
        recentAccessTime: recentAccessTime,
        canEditPwd: app.ep.canEditPersonPwd(),
        manageAccountStr: _MDLocalString["default"].getLocalString(3058),
        resetPswTitle: _MDLocalString["default"].getLocalString(3387),
        resetPswBtn: _MDLocalString["default"].getLocalString(3388),
        setPswTipStr: _MDLocalString["default"].getLocalString(3389),
        moveFileStr: _MDLocalString["default"].getLocalString(3059),
        moveToStr: _MDLocalString["default"].getLocalString(3060),
        moveToTipStr: _MDLocalString["default"].getLocalString(3061),
        stopAccountStr: _MDLocalString["default"].getLocalString(3062),
        recoverStr: _MDLocalString["default"].getLocalString(3063),
        stopStr: _MDLocalString["default"].getLocalString(3064),
        stopTipStr: _MDLocalString["default"].getLocalString(3065),
        delAccountStr: _MDLocalString["default"].getLocalString(3066),
        delStr: _MDLocalString["default"].getLocalString(32),
        delTipStr: _MDLocalString["default"].getLocalString(3067),
        lastLoginStr: _MDLocalString["default"].getLocalString(3068),
        roleManageStr: _MDLocalString["default"].getLocalString(3069),
        editStr: _MDLocalString["default"].getLocalString(3070),
        epRoleStr: _MDLocalString["default"].getLocalString(3071),
        spaceStr: _MDLocalString["default"].getLocalString(3072),
        basicInfoStr: _MDLocalString["default"].getLocalString(3013),
        nameStr: _MDLocalString["default"].getLocalString(3073),
        sexStr: _MDLocalString["default"].getLocalString(3074),
        manStr: _MDLocalString["default"].getLocalString(3075),
        womanStr: _MDLocalString["default"].getLocalString(3076),
        concatStr: _MDLocalString["default"].getLocalString(3077),
        joinTimeStr: _MDLocalString["default"].getLocalString(3078),
        remarkStr: _MDLocalString["default"].getLocalString(3079),
        saveStr: _MDLocalString["default"].getLocalString(3080),
        cancleStr: _MDLocalString["default"].getLocalString(3081),
        editPasswordStr: _MDLocalString["default"].getLocalString(3083),
        stoppedStr: BabelStr.str(3082) // 已停用
      };
      return data;
    }
  }, {
    key: "_changePwdHandler",
    value: function _changePwdHandler() {
      var win = new _MEChangePwdWindowView["default"]({
        userInfo: this.userInfo
      });
      win.show();
      this.close();
    }
  }, {
    key: "getAllEnterpriseRoles",
    value: function getAllEnterpriseRoles() {
      var _this25 = this;
      // MMEnterpriseController.roleAndUsers.getAllEnterpriseRoles((roles)=>{
      //   _.each(roles, (role)=>{
      //     let obj = {
      //       "name": role.getName(),
      //       "enterpriseRoleId": role.getId()
      //     }
      //     this.conditionArr.push(obj)
      //   })

      //   this.conditionArr.push({
      //     'name': '<div class="blue">了解企业角色...</div>',
      //     "enterpriseRoleId": 0,
      //     cannotSelect: true
      //   })

      //   this.enterpriseRoleId = this.userInfo.get("enterpriseRole");
      //   let index = _.findIndex(this.conditionArr, {enterpriseRoleId: this.enterpriseRoleId});

      //   if(app.currentUser.canManageEpAdmin()){
      //       this.conditionSelectView = new MDDropdownSelectListView({
      //       selectedIndex: index,
      //       dataProvider: this.conditionArr,
      //       labelField: "name",
      //       onChange: (obj) => {
      //         if (obj.enterpriseRoleId != 0) {
      //           this.setEnterpriseMemberRole([this.userInfo.getUserId()], obj.enterpriseRoleId)
      //         } else {
      //         }
      //       }
      //     });
      //     this.addSubView(this.conditionSelectView, this.$(".role-select-block")[0]);
      //   } else {
      //     this.$(".js-admin-set").remove()
      //   }

      // },()=>{

      // });

      this.enterpriseRoleId = this.userInfo.get("enterpriseRole");
      if (app.currentUser.canManageEpAdmin()) {
        this.conditionSelectView = new _MEEnterpriseRoleSelectView["default"]({
          enterpriseRoleId: this.enterpriseRoleId,
          roleChangedCb: function roleChangedCb(obj) {
            _this25.setEnterpriseMemberRole([_this25.userInfo.getUserId()], obj);
          }
        });
        this.addSubView(this.conditionSelectView, this.$(".role-select-block")[0]);
      } else {
        this.$(".js-admin-set").remove();
      }
    }
  }, {
    key: "setEnterpriseMemberRole",
    value: function setEnterpriseMemberRole(userids, roleInfo) {
      var _this26 = this;
      var roleId = roleInfo.enterpriseRoleId;
      _MMEnterpriseController["default"].setEnterpriseMemberRole(userids, roleId, function () {
        _this26.enterpriseRoleId = roleId;
        _this26.userInfo.set("enterpriseRole", roleId);
        _this26.userInfo.set("enterpriseRoleName", roleInfo.name);
        _MDMessageView["default"].success(BabelStr.str(3266), _this26.$body);
      }, function () {
        _MDMessageView["default"].success(BabelStr.str(3267), _this26.$body);
      });
    }
  }, {
    key: "_showUploadList",
    value: function _showUploadList() {
      var user = this.userInfo;
      _MDFilesUploadedByUserPopupWin["default"].show({
        userId: user.getUserId(),
        userName: user.getUserName(),
        inEp: true
      });
    }
  }, {
    key: "_showJoinshareLog",
    value: function _showJoinshareLog() {
      var user = this.userInfo;
      _MDOneUserJoinsharePopupWin["default"].show({
        userId: user.getUserId(),
        userName: user.getUserName(),
        organizeType: 0
      });
    }
  }, {
    key: "_showMyshare",
    value: function _showMyshare() {
      var user = this.userInfo;
      _MDOneUserJoinsharePopupWin["default"].show({
        userId: user.getUserId(),
        userName: user.getUserName(),
        organizeType: 2
      });
    }
  }, {
    key: "_showJoinprojectLog",
    value: function _showJoinprojectLog() {
      var user = this.userInfo;
      _MDOneUserJoinsharePopupWin["default"].show({
        userId: user.getUserId(),
        userName: user.getUserName(),
        organizeType: 1
      });
    }
  }, {
    key: "_showLoginLog",
    value: function _showLoginLog() {
      var user = this.userInfo;
      _MDUserLoginPopupWin["default"].show({
        userId: user.getUserId(),
        userName: user.getUserName(),
        inEp: true
      });
    }
  }, {
    key: "_showspecialfiles",
    value: function _showspecialfiles() {
      var user = this.userInfo;
      _MDOneUserJoinsharePopupWin["default"].show({
        userId: user.getUserId(),
        userName: user.getUserName(),
        organizeType: 10
      });
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEEditInnerPersonWindowView.prototype), "viewDidRendered", this).call(this);
      if (!this.userInfo.isEpAdminUser()) {
        this.getAllEnterpriseRoles();
      } else if (this.userInfo.getUserId() != app.ep.get("ownerId") && this.userInfo.getUserId() != app.currentUser.getUserId()) {
        this.getAllEnterpriseRoles();
      } else {
        this.$(".role-block").remove();
      }
    }
  }], [{
    key: "className",
    value: function className() {
      return "MEEditInnerPersonWindowView";
    }
  }]);
  return MEEditInnerPersonWindowView;
}(_MDWindowView2["default"]);

},{"106":106,"108":108,"1087":1087,"1098":1098,"1150":1150,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"121":121,"122":122,"138":138,"1412":1412,"1415":1415,"1417":1417,"1421":1421,"1426":1426,"1429":1429,"1436":1436,"1437":1437,"1439":1439,"1446":1446,"1448":1448,"1454":1454,"1463":1463,"1465":1465,"1475":1475,"1498":1498,"1541":1541,"1546":1546,"188":188,"189":189,"193":193,"194":194,"201":201,"27":27,"272":272,"32":32,"37":37,"49":49,"55":55,"608":608,"67":67,"711":711,"715":715,"72":72,"75":75,"79":79,"93":93}],1448:[function(require,module,exports){
var $ = require(1270);
var parseFloat = require(1323);

// `Number.parseFloat` method
// https://tc39.es/ecma262/#sec-number.parseFloat
// eslint-disable-next-line es/no-number-parsefloat -- required for testing
$({ target: 'Number', stat: true, forced: Number.parseFloat != parseFloat }, {
  parseFloat: parseFloat
});

},{"1270":1270,"1323":1323}],715:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDPopupHelpWindow = _interopRequireDefault(require(63));
var _MDUserLoginLogTableView = _interopRequireDefault(require(714));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDPaginationView = _interopRequireDefault(require(61));
/**
 * 展示某人在某处的所有上传文件
 *
 * javascript/moladisk/views/file/upload/MDUserLoginPopupWin.js
 * jiang
 * 2018-9-14
 */

var MDUserLoginPopupWin = _MDPopupHelpWindow["default"].extend({
  helpTmpl: "<div class=\"upload-list-panel\">\n      <div class=\"help-title text-hide\">".concat(BabelStr.str(21601), "</div>\n      <div class=\"file-list-panel\"></div>\n  </div>"),
  className: function className() {
    var superCls = _MDPopupHelpWindow["default"].prototype.className.call(this);
    return superCls + ' file-uploaded-win';
  },
  initProps: function initProps(prop) {
    var superP = _MDPopupHelpWindow["default"].prototype.initProps.call(this, prop);
    return _.extend(superP, {
      'pageSize': 20,
      inEp: false
    });
  },
  events: function events() {
    var superE = _MDPopupHelpWindow["default"].prototype.events.call(this);
    return _.extend(superE, {});
  },
  initialize: function initialize(options) {
    var _this = this;
    var self = this;
    _MDPopupHelpWindow["default"].prototype.initialize.call(this, options);
    this.$el.css('z-index', 700000001);
    if (this.userName) {
      this.$('.help-title').html(this.userName + ' - ' + BabelStr.str(21601));
    }
    var self = this;
    this.filesTable = new _MDUserLoginLogTableView["default"]({
      roles: this.roles,
      pageSize: this.pageSize,
      depId: this.depId,
      userType: this.userType,
      inEp: this.inEp,
      onLoadSuccess: function onLoadSuccess(members, totalCount) {
        var count = members.length;
        _this.paginationBarView.setLength(totalCount, true, _this.startIndex);
        if (count === 0) {
          _this.paginationBarView.hide();
        } else {
          _this.paginationBarView.show();
        }
      }
    });
    this.addSubView(this.filesTable, this.$('.upload-list-panel')[0]);
    this.paginationBarView = new _MDPaginationView["default"]({
      silentInit: true,
      pageSize: this.pageSize,
      onPageChanged: function onPageChanged(curPageIndex) {
        _this._pageChanged(curPageIndex);
      },
      onPageSizeChanged: function onPageSizeChanged(newPageSize) {
        _this.pageSize = newPageSize;
        _this.startIndex = 0;
        _this.curPageIndex = 0;
        _this.refreshTableView();
      }
    });
    this.addSubView(this.paginationBarView, this.$('.upload-list-panel')[0]);
    this.refreshTableView();
  },
  getClassName: function getClassName() {
    return "MDUserLoginPopupWin";
  },
  _pageChanged: function _pageChanged(curPageIndex) {
    this.startIndex = curPageIndex * this.pageSize;
    this.curPageIndex = curPageIndex;
    this.refreshTableView();
  },
  refreshTableView: function refreshTableView() {
    this.paginationBarView.hide();
    this.filesTable.setPageSize(this.pageSize);
    this.filesTable.requestLoginData({
      userId: this.userId,
      folderId: this.folderId,
      depId: this.depId,
      pageSize: this.pageSize,
      startIndex: this.startIndex,
      curPageIndex: this.curPageIndex,
      userType: this.userType
    });
  }
}, {
  show: function show(opt) {
    if (!MDUserLoginPopupWin.instance) {
      MDUserLoginPopupWin.instance = new MDUserLoginPopupWin({
        userId: opt.userId,
        folderId: opt.folderId,
        depId: opt.depId,
        userType: opt.userType,
        inEp: opt.inEp,
        userName: opt.userName,
        onClose: function onClose() {
          MDUserLoginPopupWin.instance = null;
        }
      });
      app.application.addSubView(MDUserLoginPopupWin.instance, $('body'));
    }
  }
});
var _default = exports["default"] = MDUserLoginPopupWin;

},{"1150":1150,"1184":1184,"1454":1454,"61":61,"63":63,"714":714}],714:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDTableView2 = _interopRequireDefault(require(89));
var _MDUserLoginLogTableRowView = _interopRequireDefault(require(713));
var _MDNetDriveFileHandler = _interopRequireDefault(require(1091));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 *  员工信息table
 * javascript/enterprise/view/departs/MDFilesUploadedByUserTableView.js
 *  Created by jiang
 *  2018.9.15
 */
var MDUserLoginLogTableView = exports["default"] = /*#__PURE__*/function (_MDTableView) {
  (0, _inherits2["default"])(MDUserLoginLogTableView, _MDTableView);
  function MDUserLoginLogTableView() {
    (0, _classCallCheck2["default"])(this, MDUserLoginLogTableView);
    return _callSuper(this, MDUserLoginLogTableView, arguments);
  }
  (0, _createClass2["default"])(MDUserLoginLogTableView, [{
    key: "emptyTmpl",
    value: function emptyTmpl() {
      if (this.isInDep) {
        return "<div class=\"m-empty page-empty\" style=\"display: block;padding: 19px 0; position: absolute;top: 0px;\">\n              <p class=\"title\">" + _MDLocalString["default"].getLocalString(21607) + "</p>\n              <p class=\"info\">" + _MDLocalString["default"].getLocalString(21608) + "</p>\n            </div>";
      } else {
        return "<div class=\"m-empty page-empty\" style=\"display: block;padding: 19px 0; position: absolute;top: 0px;\">\n              <p class=\"title\">" + _MDLocalString["default"].getLocalString(21607) + "</p>\n              <p class=\"info\">" + _MDLocalString["default"].getLocalString(21608) + "</p>\n            </div>";
      }
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUserLoginLogTableView.prototype), "className", this).call(this);
      return "".concat(superCls, " table-striped upload-file-table");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUserLoginLogTableView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        keyName: '',
        allowSelect: false,
        pageSize: 15,
        startIndex: 0,
        onLoadSuccess: _.noop,
        onLoadFailed: _.noop
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUserLoginLogTableView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .headerWrapper": this._clickOnBody
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props = _.extend({
        blankRenderer: function blankRenderer() {
          return _this.emptyTmpl();
        },
        bodyCls: 'fileRows',
        rowCls: 'row',
        headerCls: 'headerWrapper',
        allowSelect: false,
        rowClass: _MDUserLoginLogTableRowView["default"],
        columns: [{
          name: _MDLocalString["default"].getLocalString(21603),
          // ip
          dataIndex: 'address',
          flex: 1
        }, {
          name: _MDLocalString["default"].getLocalString(3172),
          // 时间
          dataIndex: 'datetime',
          flex: 1
        }, {
          name: _MDLocalString["default"].getLocalString(21604),
          // 设备类型
          dataIndex: 'terminalType',
          flex: 1
        }, {
          name: _MDLocalString["default"].getLocalString(21605),
          // terminalName
          dataIndex: 'terminalName',
          flex: 2
        }]
      }, props);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUserLoginLogTableView.prototype), "initialize", this).call(this, props);
      if (this.depId) {
        this.isInDep = true;
      }
    }

    /**
     * 请求用户数据
     * @param  {object} params - 参数对象
     * @param {string} opt.keyName - 搜索关键字
     * @param {number} opt.depId - 部门id
     * @param {number} opt.pageSize - 每页个数
     * @param {number} opt.startIndex - 页的起始数据索引
     * @param  {function} onSuccess - 请求成功处理
     * @param  {function} onFail - 请求失败处理
     */
  }, {
    key: "requestLoginData",
    value: function requestLoginData(params, onSuccess, onFail) {
      var _this2 = this;
      this.startLoadingState();
      _.extend(this, params);
      _.isFunction(this.beforeRequest) && this.beforeRequest();
      var getLogsFunc = MMEnterpriseController.listUserLoginHistory;
      getLogsFunc({
        'userId': this.userId,
        'pageSize': this.pageSize,
        'curPageIndex': this.curPageIndex
      }, function (logCollect, totalCount) {
        _this2.clearLoadingState();
        _this2.setDataCollection(logCollect, true, false);
        _.isFunction(_this2.onLoadSuccess) && _this2.onLoadSuccess(logCollect, totalCount);
        _.isFunction(onSuccess) && onSuccess(logCollect, totalCount);
      }, function () {
        _this2.clearLoadingState();
        _.isFunction(_this2.onLoadFailed) && _this2.onLoadFailed();
        _.isFunction(onFail) && onFail();
      });
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var length = this.dataCollection.length;
      if (length === 0) {
        this.startIndex -= this.pageSize;
      }
      this.requestLoginData({
        startIndex: this.startIndex
      });
    }
  }, {
    key: "_clickOnBody",
    value: function _clickOnBody() {
      console.log('--------------> click on body!');
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MDFilesUploadedByUserTableView';
    }
  }]);
  return MDUserLoginLogTableView;
}(_MDTableView2["default"]);

},{"1091":1091,"1150":1150,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"713":713,"89":89}],713:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDTableRowView2 = _interopRequireDefault(require(88));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDUserLoginLogTableRowView = exports["default"] = /*#__PURE__*/function (_MDTableRowView) {
  (0, _inherits2["default"])(MDUserLoginLogTableRowView, _MDTableRowView);
  function MDUserLoginLogTableRowView() {
    (0, _classCallCheck2["default"])(this, MDUserLoginLogTableRowView);
    return _callSuper(this, MDUserLoginLogTableRowView, arguments);
  }
  (0, _createClass2["default"])(MDUserLoginLogTableRowView, [{
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUserLoginLogTableRowView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        fileInfo: null,
        columnRenders: function columnRenders() {
          return [{
            dataIndex: 'address',
            cellCls: 'name-col online-col text-hide',
            render: function render(name, f, index) {
              var address = f.escape("address");
              var tmpl = "<div>\n                  <div class=\"contentWrapper\">\n                    <div class=\"content\">\n                      <div class=\"name-wrapp\">\n                        <div class=\"inner\">\n                          <span class=\"name\" title=\"".concat(address, "\">").concat(address, "</span>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                  <div class = \"extra-attr\"></div>\n                </div>");
              return tmpl;
            }
          }, {
            dataIndex: 'datetime',
            cellCls: 'time-col',
            render: function render(name, loginInfo, index) {
              console.error("----------- date:", loginInfo.get('datetime'));
              return "<div>\n                      <div class=\"modify-time\">".concat(MMCommonFun.formatDate(loginInfo.get('datetime')), "</div>\n                    </div>");
            }
          }, {
            dataIndex: 'terminalType',
            cellCls: 'parent-col',
            render: function render(name, loginInfo, index) {
              return "<div>\n                      <div class=\"termi-type\">".concat(loginInfo.get('terminalType'), "</div>\n                    </div>");
            }
          }, {
            dataIndex: 'terminalName',
            cellCls: 'parent-col',
            render: function render(name, loginInfo, index) {
              return "<div>\n                      <div class=\"termi-name\">".concat(loginInfo.get('terminalName'), "</div>\n                    </div>");
            }
          }];
        }
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUserLoginLogTableRowView.prototype), "events", this).call(this);
      return _.extend(superE, {
        // 'click .open-parent-folder': this._openParentFolder
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUserLoginLogTableRowView.prototype), "initialize", this).call(this, props);
      var thumbDiv = this.$(".thumbWrapper");
      this.loginInfo = this.rowModel;
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUserLoginLogTableRowView.prototype), "viewDidRendered", this).call(this);
      console.log('MDUserLoginLogTableRowView viewDidRendered');
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MDUserLoginLogTableRowView';
    }
  }]);
  return MDUserLoginLogTableRowView;
}(_MDTableRowView2["default"]);

},{"1150":1150,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1454":1454,"1463":1463,"1475":1475,"88":88}],608:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1541);
var _MDPopupHelpWindow = _interopRequireDefault(require(63));
var _MDOneUserJoinshareTableView = _interopRequireDefault(require(610));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDPaginationView = _interopRequireDefault(require(61));
var _MDLoadMaskView = _interopRequireDefault(require(49));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
/**
 * 展示某人参与分享的文件
 */

var MDOneUserJoinsharePopupWin = _MDPopupHelpWindow["default"].extend({
  helpTmpl: "<div class=\"upload-list-panel\">\n      <div class=\"help-title flex-align between\">\n        <div class=\"name title-name text-hide\"></div>\n        <div class=\"text-button done export no-shrink\">".concat(BabelStr.str(3461), "</div>\n      </div>\n      <div class=\"file-list-panel for-normal\"></div>\n      <div class=\"for-export\" >\n        <div class=\"export-block pd-20\">\n          <div class=\"flex-align between\">\n            <div class=\"name\"></div>\n            <div class=\"time\"></div>\n          </div>\n        </div>\n\n      </div>\n  </div>"),
  className: function className() {
    var superCls = _MDPopupHelpWindow["default"].prototype.className.call(this);
    return superCls + " file-uploaded-win";
  },
  initProps: function initProps(prop) {
    var superP = _MDPopupHelpWindow["default"].prototype.initProps.call(this, prop);
    return _.extend(superP, {
      pageSize: 20,
      organizeType: 0,
      curPageIndex: 0
    });
  },
  events: function events() {
    var superE = _MDPopupHelpWindow["default"].prototype.events.call(this);
    return _.extend(superE, {
      "click .export": this._export,
      "click .test": this._exportPdf
    });
  },
  initialize: function initialize(options) {
    var _this = this;
    var self = this;
    _MDPopupHelpWindow["default"].prototype.initialize.call(this, options);
    this.$el.css("z-index", 700000001);
    if (this.userName) {
      var key = 0;
      switch (this.organizeType) {
        case 0:
          key = 21613;
          break;
        case 1:
          key = 21616;
          break;
        case 2:
          key = 22050;
          break;
        case 10:
          key = 21609;
        default:
          break;
      }
      this.$(".title-name").html(this.userName + " - " + BabelStr.str(key));
    }
    this.$(".time").html(new Date().format("yyyy-MM-dd HH:mm:ss"));
    var self = this;
    this.filesTable = new _MDOneUserJoinshareTableView["default"]({
      pageSize: this.pageSize,
      depId: this.depId,
      organizeType: this.organizeType,
      onLoadSuccess: function onLoadSuccess(members, totalCount) {
        var count = members.length;
        _this.paginationBarView.setLength(totalCount, true, _this.startIndex);
        if (count === 0) {
          _this.paginationBarView.hide();
        } else {
          _this.paginationBarView.show();
        }
      }
    });
    this.addSubView(this.filesTable, this.$(".upload-list-panel")[0]);
    this.paginationBarView = new _MDPaginationView["default"]({
      silentInit: true,
      pageSize: this.pageSize,
      onPageChanged: function onPageChanged(curPageIndex) {
        _this._pageChanged(curPageIndex);
      },
      onPageSizeChanged: function onPageSizeChanged(newPageSize) {
        _this.pageSize = newPageSize;
        _this.startIndex = 0;
        _this.curPageIndex = 0;
        _this.refreshTableView();
      }
    });
    this.addSubView(this.paginationBarView, this.$(".upload-list-panel")[0]);
    this.refreshTableView();
  },
  _export: function _export() {
    var _this2 = this;
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(function () {
      _this2["export"]();
    }, 400);
  },
  "export": function _export() {
    var _this3 = this;
    if (this.exporting) {
      _MDSnackbarView["default"].show(BabelStr.str(8651));
      return;
    }
    _MDLoadMaskView["default"].show(this.$el, {
      bodyMsg: BabelStr.str(8650)
    });
    this.exporting = true;
    if (!this.exportTable) {
      this.exportTable = new _MDOneUserJoinshareTableView["default"]({
        forExport: true,
        userId: this.userId,
        pageSize: this.pageSize,
        depId: this.depId,
        organizeType: this.organizeType,
        curPageIndex: 0
      });
      this.addSubView(this.exportTable, this.$(".for-export .export-block"));
      this.exportTable.requestUploadedFilesForExport(true, function () {
        console.log("save");
        _this3._exportPdf();
      });
    } else {
      this._exportPdf();
    }
  },
  saveExportLog: function saveExportLog() {
    var type = 0;
    var exportFile;
    switch (this.organizeType) {
      case 0:
        type = 4;
        exportFile = "userJoinShareList";
        break;
      case 1:
        type = 5;
        exportFile = "userProjectList";
        break;
      case 2:
        exportFile = "userShareList";
        type = 6;
        break;
      case 10:
        exportFile = "userAppendFileList";
        type = 7;
    }
    _MMEnterpriseController["default"].saveExportLog({
      frontPage: type,
      exportFile: exportFile,
      requestTime: new Date().getTime(),
      exportTime: new Date().getTime(),
      exportStatus: 0
    });
  },
  _exportPdf: function _exportPdf() {
    var _this4 = this;
    this.saveExportLog();
    var target = this.$(".for-export .export-block")[0];
    target.style.background = "#FFFFFF";
    html2canvas(target, {
      tainttest: true,
      //检测每张图片都已经加载完成
      useCORS: true,
      allowTaint: true
      // ignoreElements: element =>{
      //     // console.warn(element)
      //     if(element == this.$('.export-pdf')[0]) {
      //       return true
      //     }
      // }
    }).then(function (canvas) {
      // console.log('23322333223')
      //  console.log(canvas.toDataURL())
      // document.body.appendChild(canvas);
      var contentWidth = canvas.width;
      var contentHeight = canvas.height;
      //一页pdf显示html页面生成的canvas高度;
      var pageHeight = contentWidth / 592.28 * 841.89;
      //未生成pdf的html页面高度
      var leftHeight = contentHeight;
      //页面偏移
      var position = 0;
      //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
      var imgWidth = 595.28;
      var imgHeight = 592.28 / contentWidth * contentHeight;
      var pageData = canvas.toDataURL("image/jpeg", 1.0);
      var pdf = new jspdf.jsPDF("", "pt", "a4");

      //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
      //当内容未超过pdf一页显示的范围，无需分页
      if (leftHeight < pageHeight) {
        pdf.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
      } else {
        while (leftHeight > 0) {
          pdf.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
          leftHeight -= pageHeight;
          position -= 841.89;
          //避免添加空白页
          if (leftHeight > 0) {
            pdf.addPage();
          }
        }
      }
      _MDLoadMaskView["default"].remove();
      _this4.exporting = false;
      var name = _this4.$(".name").html() + ".pdf";
      pdf.save(name);
    });
  },
  getClassName: function getClassName() {
    return "MDOneUserJoinsharePopupWin";
  },
  _pageChanged: function _pageChanged(curPageIndex) {
    this.startIndex = curPageIndex * this.pageSize;
    this.curPageIndex = curPageIndex;
    this.refreshTableView();
  },
  refreshTableView: function refreshTableView() {
    this.paginationBarView.hide();
    this.filesTable.requestUploadedFiles({
      pageSize: this.pageSize,
      userId: this.userId,
      curPageIndex: this.curPageIndex,
      organizeType: this.organizeType
    });
  }
}, {
  show: function show(opt) {
    if (!MDOneUserJoinsharePopupWin.instance) {
      MDOneUserJoinsharePopupWin.instance = new MDOneUserJoinsharePopupWin({
        userId: opt.userId,
        organizeType: opt.organizeType,
        userName: opt.userName,
        onClose: function onClose() {
          MDOneUserJoinsharePopupWin.instance = null;
        }
      });
      app.application.addSubView(MDOneUserJoinsharePopupWin.instance, $("body"));
    }
  }
});
var _default = exports["default"] = MDOneUserJoinsharePopupWin;

},{"1098":1098,"1150":1150,"1184":1184,"1437":1437,"1454":1454,"1541":1541,"49":49,"61":61,"610":610,"63":63,"72":72}],610:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDTableView2 = _interopRequireDefault(require(89));
var _MDOneUserJoinshareTableRowView = _interopRequireDefault(require(609));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
// import MMFileInfoCollection from '../../../../model/MMFileInfoCollection.js'
var MDOneUserJoinshareTableView = exports["default"] = /*#__PURE__*/function (_MDTableView) {
  (0, _inherits2["default"])(MDOneUserJoinshareTableView, _MDTableView);
  function MDOneUserJoinshareTableView() {
    (0, _classCallCheck2["default"])(this, MDOneUserJoinshareTableView);
    return _callSuper(this, MDOneUserJoinshareTableView, arguments);
  }
  (0, _createClass2["default"])(MDOneUserJoinshareTableView, [{
    key: "emptyTmpl",
    value: function emptyTmpl() {
      if (this.organizeType == 0) {
        return "<div class=\"m-empty page-empty\" style=\"display: block;padding: 19px 0; position: absolute;top: 0px;\">\n              <p class=\"title\">" + _MDLocalString["default"].getLocalString(21614) + "</p>\n            </div>";
      } else if (this.organizeType == 1) {
        return "<div class=\"m-empty page-empty\" style=\"display: block;padding: 19px 0; position: absolute;top: 0px;\">\n              <p class=\"title\">" + _MDLocalString["default"].getLocalString(21615) + "</p>\n            </div>";
      } else if (this.organizeType == 2) {
        return "<div class=\"m-empty page-empty\" style=\"display: block;padding: 19px 0; position: absolute;top: 0px;\">\n              <p class=\"title\">" + _MDLocalString["default"].getLocalString(22052) + "</p>\n            </div>";
      } else if (this.organizeType == 10) {
        return "<div class=\"m-empty page-empty\" style=\"display: block;padding: 19px 0; position: absolute;top: 0px;\">\n          <p class=\"title\">" + _MDLocalString["default"].getLocalString(21610) + "</p>\n        </div>";
      }
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneUserJoinshareTableView.prototype), "className", this).call(this);
      var forExport = '';
      if (this.forExport) {
        forExport = "forExport";
      }
      return "".concat(superCls, " table-striped upload-file-table ").concat(forExport);
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneUserJoinshareTableView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        keyName: '',
        allowSelect: false,
        pageSize: 10,
        startIndex: 0,
        onLoadSuccess: _.noop,
        onLoadFailed: _.noop
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneUserJoinshareTableView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .headerWrapper": this._clickOnBody
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props = _.extend({
        blankRenderer: function blankRenderer() {
          return _this.emptyTmpl();
        },
        bodyCls: 'fileRows',
        rowCls: 'row',
        rowOption: {
          forExport: props.forExport,
          organizeType: props.organizeType
        },
        showToolTip: true,
        headerCls: 'headerWrapper',
        allowSelect: false,
        rowClass: _MDOneUserJoinshareTableRowView["default"],
        columns: this.getColumns(props)
      }, props);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneUserJoinshareTableView.prototype), "initialize", this).call(this, props);
      if (this.depId) {
        this.isInDep = true;
      }
    }
  }, {
    key: "getColumns",
    value: function getColumns(props) {
      var columns = [{
        name: _MDLocalString["default"].getLocalString(49),
        dataIndex: 'fileName',
        width: 220,
        cellCls: props.forExport ? 'f-tc' : ''
      }, {
        name: _MDLocalString["default"].getLocalString(38),
        dataIndex: 'view',
        flex: 1,
        cellCls: 'f-tc middle-ellipsis',
        hidden: props.organizeType == 2
      }, {
        name: _MDLocalString["default"].getLocalString(29),
        dataIndex: 'downLoaded',
        flex: 1,
        cellCls: 'f-tc middle-ellipsis',
        hidden: props.organizeType == 2
      }, {
        name: _MDLocalString["default"].getLocalString(2006),
        dataIndex: 'upload',
        flex: 1,
        cellCls: 'f-tc middle-ellipsis',
        hidden: props.organizeType == 2
      }, {
        name: _MDLocalString["default"].getLocalString(32),
        dataIndex: 'del',
        flex: 1,
        cellCls: 'f-tc middle-ellipsis',
        hidden: props.organizeType == 2
      }, {
        name: _MDLocalString["default"].getLocalString(30),
        dataIndex: 'rename',
        flex: 1,
        cellCls: 'f-tc middle-ellipsis',
        hidden: props.organizeType == 2
      }, {
        name: _MDLocalString["default"].getLocalString(31),
        dataIndex: 'move',
        flex: 1,
        cellCls: 'f-tc middle-ellipsis',
        hidden: props.organizeType == 2
      }, {
        name: _MDLocalString["default"].getLocalString(730),
        dataIndex: 'print',
        flex: 1,
        cellCls: 'f-tc middle-ellipsis',
        hidden: props.organizeType == 2
      }, {
        name: _MDLocalString["default"].getLocalString(8573),
        dataIndex: 'vname',
        flex: 2,
        cellCls: 'f-tc middle-ellipsis',
        hidden: props.organizeType == 2
      }, {
        name: _MDLocalString["default"].getLocalString(265),
        dataIndex: 'parentFolder',
        flex: 3,
        hidden: props.forExport,
        cellCls: props.organizeType == 2 ? "f-tr pdlr-20" : ""
      }];
      return columns;
    }
  }, {
    key: "requestUploadedFiles",
    value: function requestUploadedFiles(params, onSuccess, onFail) {
      var _this2 = this;
      this.startLoadingState();
      _.extend(this, params);
      _.isFunction(this.beforeRequest) && this.beforeRequest();
      var getFilesFunc = MMEnterpriseController.getUsersAllOrganizations;
      if (this.organizeType == 10) {
        getFilesFunc = MMEnterpriseController.listUserAppendPermissions;
      }
      getFilesFunc({
        'userId': this.userId,
        'pageSize': this.pageSize,
        'curPageIndex': this.curPageIndex,
        'organizeType': this.organizeType
      }, function (fileCollect, totalCount) {
        _this2.clearLoadingState();
        _this2.setDataCollection(fileCollect, true, false);
        _.isFunction(_this2.onLoadSuccess) && _this2.onLoadSuccess(fileCollect, totalCount);
        _.isFunction(onSuccess) && onSuccess(fileCollect, totalCount);
      }, function () {
        _this2.clearLoadingState();
        _.isFunction(_this2.onLoadFailed) && _this2.onLoadFailed();
        _.isFunction(onFail) && onFail();
      });
    }
  }, {
    key: "requestUploadedFilesForExport",
    value: function requestUploadedFilesForExport(initialCall, onSuccess, onFail) {
      var _this3 = this;
      var getFilesFunc = MMEnterpriseController.getUsersAllOrganizations;
      if (this.organizeType == 10) {
        getFilesFunc = MMEnterpriseController.listUserAppendPermissions;
      }
      getFilesFunc({
        'userId': this.userId,
        'pageSize': this.pageSize,
        'curPageIndex': this.curPageIndex,
        'organizeType': this.organizeType
      }, function (fileCollect, totalCount) {
        if (initialCall) {
          _this3.setDataCollection(fileCollect, true, false);
        } else {
          _this3.dataCollection.add(fileCollect.models);
        }
        if (_this3.curPageIndex * _this3.pageSize + fileCollect.length < totalCount) {
          _this3.curPageIndex++;
          _this3.requestUploadedFilesForExport(false, onSuccess, onFail);
        } else {
          onSuccess();
        }
      }, function () {
        _.isFunction(_this3.onLoadFailed) && _this3.onLoadFailed();
        _.isFunction(onFail) && onFail();
      });
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var length = this.dataCollection.length;
      if (length === 0) {
        this.startIndex -= this.pageSize;
      }
      this.requestUploadedFiles({
        startIndex: this.startIndex
      });
    }
  }, {
    key: "_clickOnBody",
    value: function _clickOnBody() {
      console.log('--------------> click on body!');
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MDOneUserJoinshareTableView';
    }
  }]);
  return MDOneUserJoinshareTableView;
}(_MDTableView2["default"]);

},{"1150":1150,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1454":1454,"1463":1463,"1475":1475,"609":609,"89":89}],609:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDTableRowView2 = _interopRequireDefault(require(88));
var _FILE_ACTION_BITS = _interopRequireDefault(require(235));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDOneUserJoinshareTableRowView = exports["default"] = /*#__PURE__*/function (_MDTableRowView) {
  (0, _inherits2["default"])(MDOneUserJoinshareTableRowView, _MDTableRowView);
  function MDOneUserJoinshareTableRowView() {
    (0, _classCallCheck2["default"])(this, MDOneUserJoinshareTableRowView);
    return _callSuper(this, MDOneUserJoinshareTableRowView, arguments);
  }
  (0, _createClass2["default"])(MDOneUserJoinshareTableRowView, [{
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneUserJoinshareTableRowView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        fileInfo: null,
        columnRenders: function columnRenders() {
          return [{
            dataIndex: 'fileName',
            cellCls: 'name-col online-col text-hide',
            render: function render(name, f, index) {
              var fileName = f.escape("fileName");
              var thumb;
              var tmpl = "<div>\n                  <div class=\"thumbWrapper file-icon-root\">\n                    <i class=\"icon\"></i>\n                  </div>\n                  <div class=\"contentWrapper\">\n                    <div class=\"content\">\n                      <div class=\"name-wrapp\">\n                        <div class=\"inner\">\n                          <span class=\"append-per f-none bg-Cred\">".concat(BabelStr.str(2615), "</span>\n                          <span class=\"security\"></span>\n                          <span class=\"name\" title=\"").concat(name, "\">").concat(name, "</span>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                  <div class = \"extra-attr\"></div>\n                </div>");
              return tmpl;
            }
          }, {
            dataIndex: 'view',
            cellCls: 'f-tc',
            render: function render(name, fileInfor, index) {
              return "<span class=\"".concat(fileInfor.get('actions') & _FILE_ACTION_BITS["default"].READ && 'checked' || 'nochecked', "\"><span></span></span>");
            }
          }, {
            dataIndex: 'downLoaded',
            cellCls: 'f-tc',
            render: function render(name, fileInfor, index) {
              return "<span class=\"".concat(fileInfor.get('actions') & _FILE_ACTION_BITS["default"].DOWNLOAD && 'checked' || 'nochecked', "\"><span></span></span>");
            }
          }, {
            dataIndex: 'upload',
            cellCls: 'f-tc',
            render: function render(name, fileInfor, index) {
              var actions = fileInfor.get('actions');
              var canUpload = actions & _FILE_ACTION_BITS["default"].UPLOAD || actions & _FILE_ACTION_BITS["default"].UPLOADVERSION;
              return "<span class=\"".concat(canUpload && 'checked' || 'nochecked', "\"><span></span></span>");
            }
          }, {
            dataIndex: 'del',
            cellCls: 'f-tc',
            render: function render(name, fileInfor, index) {
              return "<span class=\"".concat(fileInfor.get('actions') & _FILE_ACTION_BITS["default"].DELETE && 'checked' || 'nochecked', "\"><span></span></span>");
            }
          }, {
            dataIndex: 'rename',
            cellCls: 'f-tc',
            render: function render(name, fileInfor, index) {
              return "<span class=\"".concat(fileInfor.get('actions') & _FILE_ACTION_BITS["default"].RENAME && 'checked' || 'nochecked', "\"><span></span></span>");
            }
          }, {
            dataIndex: 'move',
            cellCls: 'f-tc',
            render: function render(name, fileInfor, index) {
              return "<span class=\"".concat(fileInfor.get('actions') & _FILE_ACTION_BITS["default"].MOVE && 'checked' || 'nochecked', "\"><span></span></span>");
            }
          }, {
            dataIndex: 'print',
            cellCls: 'f-tc',
            render: function render(name, fileInfor, index) {
              return "<span class=\"".concat(fileInfor.get('actions') & _FILE_ACTION_BITS["default"].PRINT && 'checked' || 'nochecked', "\"><span></span></span>");
            }
          }, {
            dataIndex: 'vname',
            cellCls: 'f-tc',
            render: function render(name, fileInfor, index) {
              return "<span class=\"".concat(fileInfor.get('actions') & _FILE_ACTION_BITS["default"].ONLY_READ_NAME && 'checked' || 'nochecked', "\"><span></span></span>");
            }
          }, {
            dataIndex: 'parentFolder',
            cellCls: 'parent-col pdlr-20',
            render: function render(name, fileInfor, index) {
              if (fileInfor.get('isPrivateFile')) {
                return "<span class='help-text'>".concat(BabelStr.str(3620), "</span>");
              } else {
                return '<span class="open-parent-folder text-button">' + _MDLocalString["default"].getLocalString(136) + '</span>';
              }
            }
          }];
        }
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneUserJoinshareTableRowView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .open-parent-folder': this._openParentFolder
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneUserJoinshareTableRowView.prototype), "initialize", this).call(this, props);
      var thumbDiv = this.$(".thumbWrapper");
      this.fileInfo = this.rowModel;
      if (!this.forExport) {
        this.fileInfo.setIconForDiv(thumbDiv);
      } else {
        this.$('.thumbWrapper').remove();
      }
      if (this.organizeType == 2) {
        this.$('.parent-col').addClass("flex-align end");
      }
    }
  }, {
    key: "_openParentFolder",
    value: function _openParentFolder() {
      // window.open('/main.do#file/' + this.fileInfo.getParentFolderId());
      var parentId = this.fileInfo.getParentFolderId();
      app.pathRouter.openNewTabByFileId(parentId);
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneUserJoinshareTableRowView.prototype), "viewDidRendered", this).call(this);
      console.log('MDOneUserJoinshareTableRowView viewDidRendered');
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MDOneUserJoinshareTableRowView';
    }
  }]);
  return MDOneUserJoinshareTableRowView;
}(_MDTableRowView2["default"]);

},{"1150":1150,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1454":1454,"1463":1463,"1475":1475,"235":235,"88":88}],201:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1415);
require(1463);
require(1412);
require(1439);
require(1465);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMViewBase2 = _interopRequireDefault(require(22));
var _utils = _interopRequireDefault(require(108));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MEUserSpaceInfoTpl = _interopRequireDefault(require(125));
var _MDCombobox = _interopRequireDefault(require(27));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 * javascript/enterprise/view/persons/MEUserSpaceInfoView.js
 * jiang
 * 2018-8-13
 */
var MEUserSpaceInfoView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MEUserSpaceInfoView, _MMViewBase);
  function MEUserSpaceInfoView() {
    (0, _classCallCheck2["default"])(this, MEUserSpaceInfoView);
    return _callSuper(this, MEUserSpaceInfoView, arguments);
  }
  (0, _createClass2["default"])(MEUserSpaceInfoView, [{
    key: "tmpl",
    value: function tmpl() {
      return '<div class="use-space-panel"></div>';
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEUserSpaceInfoView.prototype), "className", this).call(this);
      return "".concat(superCls, " app-panel app-person-panel");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEUserSpaceInfoView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'input .limeted-input': this._limitedInputHandle,
        'click .calc': this.calcSpace
      });
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEUserSpaceInfoView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        basicCapacity: 1024 * 1024 * 1024 * 100
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEUserSpaceInfoView.prototype), "initialize", this).call(this, props);
      var userSpaceInfos = props.userSpaceInfos;
      var data = {};
      if (_.isUndefined(userSpaceInfos)) {
        //初始化
        this.initView = true;
      } else {
        this.setUserSpaceInfos(userSpaceInfos);
      }
      data = {
        // 'personal': personal,
        // 'departSpaceInfos': departSpaceInfos,
        'limeted': this.userInfo ? this.userInfo.getSpaceLimit() : 0,
        'personLimtedStr': _MDLocalString["default"].getLocalString(3089),
        'editStr': _MDLocalString["default"].getLocalString(3070),
        'saveStr': _MDLocalString["default"].getLocalString(3080),
        'privateLimit': _MDLocalString["default"].getLocalString(3620),
        'spaceTipStr': _MDLocalString["default"].getLocalString(3639),
        'initView': this.initView
      };
      var html = _.template(_MEUserSpaceInfoTpl["default"].spaceInfoList)(data);
      this.$('.use-space-panel').empty().html(html);

      // this.hasPrivateFileView = new MDCheckBoxView({
      //   label: BabelStr.str(3620),
      //   checked: this.userInfo.getOwnFile(),
      //   onChanged: (checked)=>{
      //     this._hasPrivateFilePerChanged(checked);
      //   }
      // })
      // this.addSubView(this.hasPrivateFileView, this.$(".private-limted")[0]);

      var entDefault = BabelStr.str(3636); // 企业默认
      var no = BabelStr.str(3637); // 不许可
      var yes = BabelStr.str(3638); // 许可

      if (window.ep.canOwnPersonalFile) {
        entDefault += "-" + yes;
      } else {
        entDefault += "-" + no;
      }

      // 显示成 “系统默认（允许）” 或者 “系统默认（不允许）”
      // var can = this.enterprise.canOwnPersonalFile()?yes:no;
      // entDefault += '(' + can + ")";

      this.filter = [entDefault, no, yes];
      this.filterIndex = this.userInfo ? this.userInfo.getOwnFile() + 1 : 0;
      this.combobox = new _MDCombobox["default"]({
        parentDiv: this.$('.filelimitlist'),
        itemStrs: this.filter,
        selectIndex: this.filterIndex,
        width: 200,
        popUpWidth: 200,
        useNormalFont: true,
        selectCb: function selectCb(index) {
          _this.filterIndex = index;
          _this.check2HideSpaceEditable();
          if (_this.permissionChangedCb) {
            _this.permissionChangedCb(index);
          }
          ;
        }
      });
      _MMEnterpriseController["default"].getCurrentEnterpriseInfo(function (enterprise) {
        _this.enterprise = enterprise;
        _this.check2HideSpaceEditable();
      }, function () {});
      if (!this.userInfo) {
        this.$('.save-space-btn').remove();
      }
    }
  }, {
    key: "calcSpace",
    value: function calcSpace() {
      var _this2 = this;
      _MDSpinnerloaderView["default"].showIn(this.$('.loader-block'), {
        autoHeight: true
      });
      _MMEnterpriseController["default"].roleAndUsers.getUserSpaceInfo(this.userInfo.getUserId(), function (userSpaceInfos) {
        _this2.userSpaceInfos = userSpaceInfos[0]['spaceInfos'];
        _this2.setUserSpaceInfos(_this2.userSpaceInfos);
        _MDSpinnerloaderView["default"].clearFrom(_this2.$('.loader-block'));
        // this.$(".save-space-btn").removeClass('done');
      }, function () {});
    }
  }, {
    key: "setUserSpaceInfos",
    value: function setUserSpaceInfos(userSpaceInfos, isInit) {
      if (userSpaceInfos && this.initView) {
        this.$('.usedSpace-calc').addClass('f-hide');
        this.$('.usedSpace-info').removeClass('f-hide');
        this.initView = false;
      }
      var personal = {};
      var departSpaceInfos = [];
      _.each(userSpaceInfos, function (spaceInfo) {
        var usedSpace = _utils["default"].convertSpace(spaceInfo['usedSpace']);
        var clone = {};
        if (_.isUndefined(spaceInfo['departmentId'])) {
          _.extend(personal, spaceInfo);
          personal['usedSpace'] = usedSpace;
        } else {
          _.extend(clone, spaceInfo);
          clone['usedSpace'] = usedSpace;
          departSpaceInfos.push(clone);
        }
      });
      if (personal.usedSpace) {
        var personalStr = "<p class=\"flex-align between middle\">\n        <strong class=\"category-name\">".concat(BabelStr.str(3090), " </strong><span class=\"space-size no-shrink\">").concat(personal.usedSpace, "</span>\n      </p>");
        this.$('.space-used').html(personalStr);
      } else {
        this.$('.space-used').remove();
      }
      if (departSpaceInfos.length) {
        var depStr = '';
        for (var i = 0; i < departSpaceInfos.length; i++) {
          depStr += "<div class=\"row\">\n                    <p class=\"flex-align between middle\">\n                      <strong class=\"category-name\">".concat(departSpaceInfos[i].name, " </strong><span class=\"space-size no-shrink\">").concat(departSpaceInfos[i].usedSpace, "</span>\n                    </p>\n                  </div>");
        }
        this.$('.dep-space-info').html(depStr);
      } else {
        this.$('.dep-space').remove();
      }
    }
  }, {
    key: "check2HideSpaceEditable",
    value: function check2HideSpaceEditable() {
      var canHaveFile = false;
      if (this.filterIndex == 0) {
        canHaveFile = this.enterprise.canOwnPersonalFile();
      } else if (this.filterIndex == 1) {
        canHaveFile = false;
      } else {
        canHaveFile = true;
      }
      this.showSpaceEdit(canHaveFile);
    }
  }, {
    key: "showSpaceEdit",
    value: function showSpaceEdit(show) {
      if (show) {
        this.$(".space-edit-block").show();
      } else {
        this.$(".space-edit-block").hide();
      }
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      var _this3 = this;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEUserSpaceInfoView.prototype), "viewDidRendered", this).call(this);
      _MMEnterpriseController["default"].getCurrentEnterpriseInfo(function (data) {
        _this3.basicCapacity = data.get("basicCapacity");
      });
    }
  }, {
    key: "_limitedInputHandle",
    value: function _limitedInputHandle() {
      var value = this.$('.limeted-input').val();
      value = parseFloat(value);
      var max = this.basicCapacity / (1024 * 1024 * 1024);
      if (value >= 0 && value <= max) {
        return;
      }
      if (_.isNaN(value)) {
        this.$('.limeted-input').val('');
      } else if (value < 0) {
        this.$('.limeted-input').val(0);
      } else if (value > max) {
        this.$('.limeted-input').val(max);
      } else {
        this.$('.limeted-input').val(value);
      }
    }
  }, {
    key: "getSpaceLimit",
    value: function getSpaceLimit() {
      return this.$('.limeted-input').val();
    }
  }, {
    key: "getPersonSpaceType",
    value: function getPersonSpaceType() {
      return this.filterIndex - 1;
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MEUserSpaceInfoView';
    }
  }]);
  return MEUserSpaceInfoView;
}(_MMViewBase2["default"]);

},{"108":108,"1098":1098,"1150":1150,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"125":125,"1412":1412,"1415":1415,"1439":1439,"1454":1454,"1463":1463,"1465":1465,"1475":1475,"22":22,"27":27,"76":76}],193:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1416);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MEEntRoleHelpWindow = _interopRequireDefault(require(192));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 * 企业角色选项
 * Created by jiang
 * 2018.08.13
 */
var MEEnterpriseRoleSelectView = exports["default"] = /*#__PURE__*/function (_MDDropdownSelectList) {
  (0, _inherits2["default"])(MEEnterpriseRoleSelectView, _MDDropdownSelectList);
  function MEEnterpriseRoleSelectView() {
    (0, _classCallCheck2["default"])(this, MEEnterpriseRoleSelectView);
    return _callSuper(this, MEEnterpriseRoleSelectView, arguments);
  }
  (0, _createClass2["default"])(MEEnterpriseRoleSelectView, [{
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEEnterpriseRoleSelectView.prototype), "initProps", this).call(this);
      return _.extend(superP, {});
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEEnterpriseRoleSelectView.prototype), "events", this).call(this);
      return _.extend(superE, {});
    }
  }, {
    key: "initialize",
    value: function initialize(opts) {
      var _this = this;
      this.conditionArr = [];
      if (!opts) {
        opts = {};
      }
      _MMEnterpriseController["default"].roleAndUsers.getEnterpriseRoleCanSet(function (roles) {
        _this.roles = roles;
        _.each(roles, function (role) {
          var obj = {
            "name": role.getName(),
            "enterpriseRoleId": role.getId()
          };
          _this.conditionArr.push(obj);
        });
        _this.conditionArr.push({
          'name': "<div class=\"blue\">".concat(BabelStr.str(5140), "...</div>"),
          "enterpriseRoleId": 0,
          cannotSelect: true
        });
        var index = _.findIndex(_this.conditionArr, {
          enterpriseRoleId: opts.enterpriseRoleId
        });
        if (index == -1) {
          index = 1;
        }
        opts.enterpriseRoleId = _this.enterpriseRoleId = _this.conditionArr[index].enterpriseRoleId;
        opts = _.extend(opts, {
          selectedIndex: index,
          dataProvider: _this.conditionArr,
          labelField: "name",
          onChange: function onChange(obj) {
            if (obj.enterpriseRoleId != 0) {
              _this.enterpriseRoleId = obj.enterpriseRoleId;
              _this.roleChangedCb && _this.roleChangedCb(obj);
            } else {
              _MEEntRoleHelpWindow["default"].show({
                roles: _this.roles
              });
            }
          }
        });
        (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEEnterpriseRoleSelectView.prototype), "initialize", _this).call(_this, opts);
      }, function () {});
    }
  }, {
    key: "getSelectedRoleId",
    value: function getSelectedRoleId() {
      return this.enterpriseRoleId;
    }
  }]);
  return MEEnterpriseRoleSelectView;
}(_MDDropdownSelectListView["default"]);

},{"1098":1098,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1416":1416,"1454":1454,"1463":1463,"1475":1475,"192":192,"67":67}],192:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDPopupHelpWindow = _interopRequireDefault(require(63));
var _MEEntRoleHelpTable = _interopRequireDefault(require(191));
/**
 * 角色帮助信息显示的类
 * javascript/enterprise/view/auth/MEEntRoleHelpWindow.js
 * Created by jiang 
 * 2018.8.12
 */

var MEEntRoleHelpWindow = _MDPopupHelpWindow["default"].extend({
  helpTmpl: "<div class=\"ent-role-help\"></div>",
  className: function className() {
    var superCls = _MDPopupHelpWindow["default"].prototype.className.call(this);
    return superCls + ' ent-help-role-win';
  },
  initProps: function initProps(prop) {
    var superP = _MDPopupHelpWindow["default"].prototype.initProps.call(this, prop);
    return _.extend(superP, {});
  },
  events: function events() {
    var superE = _MDPopupHelpWindow["default"].prototype.events.call(this);
    return _.extend(superE, {});
  },
  initialize: function initialize(options) {
    var self = this;
    _MDPopupHelpWindow["default"].prototype.initialize.call(this, options);
    var self = this;
    this.authPanel = new _MEEntRoleHelpTable["default"]({
      roles: this.roles
    });
    this.addSubView(this.authPanel, this.$('.ent-role-help'));
  },
  getClassName: function getClassName() {
    return "MEEntRoleHelpWindow";
  }
}, {
  show: function show(opt) {
    if (!MEEntRoleHelpWindow.instance) {
      MEEntRoleHelpWindow.instance = new MEEntRoleHelpWindow({
        roles: opt.roles,
        onClose: function onClose() {
          MEEntRoleHelpWindow.instance = null;
        }
      });
      app.application.addSubView(MEEntRoleHelpWindow.instance, $('body'));
    }
  }
});
var _default = exports["default"] = MEEntRoleHelpWindow;

},{"1150":1150,"1184":1184,"1454":1454,"191":191,"63":63}],191:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDLocalString = _interopRequireDefault(require(1150));
var _MMViewBase = _interopRequireDefault(require(22));
/**
 * 角色帮助信息显示的类
 * javascript/enterprise/view/persons/MEEntRoleHelpTable.js
 * Created by jiang 
 * 2018.8.14
 */

var MEEntRoleHelpTable = _MMViewBase["default"].extend({
  el: "<div class=\"ent-role-table m-table table-striped\">\n       \n      </div>",
  tmpl: "<table class=\"table-body\"> \n            <tr class=\"t-row head bg-C10\">\n              <th class=\"col-20\"><%=name%></th>\n              <th><%=comment%></th>\n            </tr>\n        </table>",
  className: function className() {
    var superCls = _MMViewBase["default"].prototype.className.call(this);
    return superCls + ' ent-role-table';
  },
  initProps: function initProps(prop) {
    var superP = _MMViewBase["default"].prototype.initProps.call(this, prop);
    return _.extend(superP, {
      data: {
        name: BabelStr.str(3071),
        comment: BabelStr.str(278)
      }
    });
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {});
  },
  initialize: function initialize(options) {
    var _this = this;
    var self = this;
    _MMViewBase["default"].prototype.initialize.call(this, options);
    var self = this;
    _.each(this.roles, function (role) {
      var tr = '<tr class="t-row"><td>' + role.get('name') + '</td><td class="gray">' + role.get('commentCN') + '</td></tr>';
      _this.$('.table-body').append($(tr));
    });
  },
  getClassName: function getClassName() {
    return "MEEntRoleHelpTable";
  }
}, {
  show: function show() {
    if (!MEEntRoleHelpTable.instance) {
      MEEntRoleHelpTable.instance = new MEEntRoleHelpTable({
        onClose: function onClose() {
          MEEntRoleHelpTable.instance = null;
        }
      });
      app.application.addSubView(MEEntRoleHelpTable.instance);
    }
  }
});
var _default = exports["default"] = MEEntRoleHelpTable;

},{"1150":1150,"1184":1184,"1454":1454,"22":22}],188:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1498);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDMessageView = _interopRequireDefault(require(55));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDWindowView2 = _interopRequireDefault(require(93));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MEChangePwdWindowView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MEChangePwdWindowView, _MDWindowView);
  function MEChangePwdWindowView() {
    (0, _classCallCheck2["default"])(this, MEChangePwdWindowView);
    return _callSuper(this, MEChangePwdWindowView, arguments);
  }
  (0, _createClass2["default"])(MEChangePwdWindowView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n      <form action=\"\" class=\"form-horizontal\" novalidate=\"novalidate\">\n        <div class=\"form-item row\">\n          <label for=\"\" class=\"col-3\"><%=BabelStr.str(5135)%></label>\n          <div class=\"col-9\">\n            <input type=\"password\" name=\"pwd\" class=\"form-control\" id=\"js-pwd\" maxlength=\"20\">\n          </div>\n        </div>\n        <div class=\"form-item row\">\n          <label for=\"\" class=\"col-3\"><%=BabelStr.str(5136)%></label>\n          <div class=\"col-9\">\n            <input type=\"password\" name=\"pwdAgain\" class=\"form-control\" id=\"js-pwd-again\"  maxlength=\"20\">\n          </div>\n        </div>\n         <div class=\"form-item row\">\n          <label for=\"\" class=\"col-3\"></label>\n          <div class=\"col-9\">\n            <div class=\"help-block\"><%=BabelStr.str(5137)%><strong id=\"js-name\"></strong><%=BabelStr.str(5138)%></div>\n          </div>\n        </div>\n      </form>";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEChangePwdWindowView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        title: BabelStr.str(3083)
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.buttons = [{
        label: BabelStr.str(3096),
        type: 'done',
        autoClose: false,
        onClick: function onClick() {
          _this.submit();
        }
      }, {
        type: 'default',
        label: BabelStr.str(155)
      }];
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEChangePwdWindowView.prototype), "initialize", this).call(this, props);
      this.$('form').validate({
        rules: {
          'pwd': {
            'userPassword': true,
            'required': true
          },
          'pwdAgain': {
            'userPassword': true,
            'required': true,
            'equalTo': '#js-pwd'
          }
        },
        messages: {
          'pwd': {
            'required': BabelStr.str(2351)
          },
          'pwdAgain': {
            'required': BabelStr.str(2352),
            'equalTo': BabelStr.str(2353)
          }
        }
      });
      var text = this.userInfo.getUserName() + "( " + this.userInfo.getEmail() + " )";
      this.$('#js-name').text(text);
    }
  }, {
    key: "submit",
    value: function submit() {
      var _this2 = this;
      var validator = this.$('form').validate();
      var password = this.$('#js-pwd').val().trim();
      var userIds = [this.userInfo.getUserId()];
      if (validator.form()) {
        _MMEnterpriseController["default"].resetUserPassword(password, userIds, function () {
          _this2.close();
          _MDMessageView["default"].success(BabelStr.str(22346));
        }, function () {
          _MDMessageView["default"].error(BabelStr.str(5139), _this2.$body);
        });
      }
    }
  }]);
  return MEChangePwdWindowView;
}(_MDWindowView2["default"]);

},{"1098":1098,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"1498":1498,"55":55,"93":93}],144:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDPopupView = _interopRequireDefault(require(64));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
var _MEStaffRowController = _interopRequireDefault(require(196));
var _MDFilesUploadedByUserPopupWin = _interopRequireDefault(require(711));
/**
 *  Menu for zoom choices
 *  javascript/enterprise/view/departs/MEOperateUserPopupView.js
 *  Create by jiang
 *  2018.9.17
 */

var MEOperateUserPopupView = _MDPopupView["default"].extend({
  contentTmpl: '<ul class="m-menu"></ul>',
  events: function events() {
    var superEvents = _MDPopupView["default"].prototype.events.call(this);
    return _.extend({}, superEvents, {
      'click li': this._menuItemClickHandler
    });
  },
  initProps: function initProps() {
    var superP = _MDPopupView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      zoomSelected: -1,
      $zoomList: null,
      scaleList: []
    });
  },
  initialize: function initialize(opt) {
    _MDPopupView["default"].prototype.initialize.call(this, opt);
    this.initUserOperations();
  },
  initUserOperations: function initUserOperations() {
    var status = this.userInfo.getStatus();
    var userId = this.userInfo.getId();
    var currentUserId = app.currentUser.getId();
    var ownerId = app.ep.getOwnerId();
    if (app.currentUser.isEpAdminUser()) {
      if (userId === ownerId) {
        this.$(".m-menu").append('<li class="stop">' + BabelStr.str(3064) + '</div>');
      } else if (status === 1) {
        this.$(".m-menu").append('<li class="withdraw">' + BabelStr.str(3063) + '</div>');
      } else {
        this.$(".m-menu").append('<li class="stop">' + BabelStr.str(3064) + '</div>');
      }
    }
    this.$(".m-menu").append('<li class="upload-history">' + BabelStr.str(2049) + '</div>');
  },
  _menuItemClickHandler: function _menuItemClickHandler($e) {
    var $target = $($e.target);
    if ($target.hasClass('stop')) {
      console.log(' stop!');
      this.stopUser();
    } else if ($target.hasClass('withdraw')) {
      console.log(' withdraw!');
      this.recoverUser();
    } else if ($target.hasClass('upload-history')) {
      console.log(' upload-history!');
      this.listUploadedFiles();
    }
    this.close();
  },
  stopUser: function stopUser() {
    _MEStaffRowController["default"].stopUser(this.userInfo);
  },
  recoverUser: function recoverUser() {
    _MEStaffRowController["default"].recoverUser(this.userInfo);
  },
  listUploadedFiles: function listUploadedFiles() {
    _MDFilesUploadedByUserPopupWin["default"].show({
      userId: this.userInfo.getId(),
      userName: this.userInfo.getUserName(),
      depId: this.depId
    });
  }
}, {
  show: function show(opt) {
    if (MEOperateUserPopupView.instance) {
      MEOperateUserPopupView.instance.close();
    }
    MEOperateUserPopupView.instance = new MEOperateUserPopupView(opt);
    MEOperateUserPopupView.instance.show({
      triggerView: opt.currentTarget,
      center: true,
      width: 250,
      onClose: function onClose() {
        MEOperateUserPopupView.instance = null;
      }
    });
    ;
  }
});
var _default = exports["default"] = MEOperateUserPopupView;

},{"1184":1184,"1454":1454,"196":196,"64":64,"711":711,"807":807}],711:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDPopupHelpWindow = _interopRequireDefault(require(63));
var _MDFilesUploadedByUserTableView = _interopRequireDefault(require(712));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDPaginationView = _interopRequireDefault(require(61));
/**
 * 展示某人在某处的所有上传文件
 *
 * javascript/moladisk/views/file/upload/MDFilesUploadedByUserPopupWin.js
 * jiang
 * 2018-9-14
 */

var MDFilesUploadedByUserPopupWin = _MDPopupHelpWindow["default"].extend({
  helpTmpl: "<div class=\"upload-list-panel\">\n      <div class=\"help-title text-hide\">".concat(BabelStr.str(2048), "</div>\n      <div class=\"file-list-panel\"></div>\n  </div>"),
  className: function className() {
    var superCls = _MDPopupHelpWindow["default"].prototype.className.call(this);
    return superCls + ' file-uploaded-win';
  },
  initProps: function initProps(prop) {
    var superP = _MDPopupHelpWindow["default"].prototype.initProps.call(this, prop);
    return _.extend(superP, {
      'pageSize': 20,
      inEp: false
    });
  },
  events: function events() {
    var superE = _MDPopupHelpWindow["default"].prototype.events.call(this);
    return _.extend(superE, {});
  },
  initialize: function initialize(options) {
    var _this = this;
    var self = this;
    _MDPopupHelpWindow["default"].prototype.initialize.call(this, options);
    this.$el.css('z-index', 700000001);
    if (this.userName) {
      this.$('.help-title').html(this.userName + ' - ' + BabelStr.str(2048));
    }
    var self = this;
    this.filesTable = new _MDFilesUploadedByUserTableView["default"]({
      roles: this.roles,
      pageSize: this.pageSize,
      depId: this.depId,
      userType: this.userType,
      inEp: this.inEp,
      onLoadSuccess: function onLoadSuccess(members, totalCount) {
        var count = members.length;
        _this.paginationBarView.setLength(totalCount, true, _this.startIndex);
        if (count === 0) {
          _this.paginationBarView.hide();
        } else {
          _this.paginationBarView.show();
        }
      }
    });
    this.addSubView(this.filesTable, this.$('.upload-list-panel')[0]);
    this.paginationBarView = new _MDPaginationView["default"]({
      silentInit: true,
      pageSize: this.pageSize,
      onPageChanged: function onPageChanged(curPageIndex) {
        _this._pageChanged(curPageIndex);
      },
      onPageSizeChanged: function onPageSizeChanged(newPageSize) {
        _this.pageSize = newPageSize;
        _this.startIndex = 0;
        _this.curPageIndex = 0;
        _this.refreshTableView();
      }
    });
    this.addSubView(this.paginationBarView, this.$('.upload-list-panel')[0]);
    this.refreshTableView();
  },
  getClassName: function getClassName() {
    return "MDFilesUploadedByUserPopupWin";
  },
  _pageChanged: function _pageChanged(curPageIndex) {
    this.startIndex = curPageIndex * this.pageSize;
    this.curPageIndex = curPageIndex;
    this.refreshTableView();
  },
  refreshTableView: function refreshTableView() {
    this.paginationBarView.hide();
    this.filesTable.requestUploadedFiles({
      userId: this.userId,
      folderId: this.folderId,
      pageSize: this.pageSize,
      depId: this.depId,
      startIndex: this.startIndex,
      curPageIndex: this.curPageIndex,
      userType: this.userType
    });
  }
}, {
  show: function show(opt) {
    if (!MDFilesUploadedByUserPopupWin.instance) {
      MDFilesUploadedByUserPopupWin.instance = new MDFilesUploadedByUserPopupWin({
        userId: opt.userId,
        folderId: opt.folderId,
        depId: opt.depId,
        userType: opt.userType,
        inEp: opt.inEp,
        userName: opt.userName,
        onClose: function onClose() {
          MDFilesUploadedByUserPopupWin.instance = null;
        }
      });
      app.application.addSubView(MDFilesUploadedByUserPopupWin.instance, $('body'));
    }
  }
});
var _default = exports["default"] = MDFilesUploadedByUserPopupWin;

},{"1150":1150,"1184":1184,"1454":1454,"61":61,"63":63,"712":712}],712:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDTableView2 = _interopRequireDefault(require(89));
var _MDFilesUpleadedByUserTableRowView = _interopRequireDefault(require(710));
var _MDNetDriveFileHandler = _interopRequireDefault(require(1091));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 *  员工信息table
 * javascript/enterprise/view/departs/MDFilesUploadedByUserTableView.js
 *  Created by jiang
 *  2018.9.15
 */
var MDFilesUploadedByUserTableView = exports["default"] = /*#__PURE__*/function (_MDTableView) {
  (0, _inherits2["default"])(MDFilesUploadedByUserTableView, _MDTableView);
  function MDFilesUploadedByUserTableView() {
    (0, _classCallCheck2["default"])(this, MDFilesUploadedByUserTableView);
    return _callSuper(this, MDFilesUploadedByUserTableView, arguments);
  }
  (0, _createClass2["default"])(MDFilesUploadedByUserTableView, [{
    key: "emptyTmpl",
    value: function emptyTmpl() {
      if (this.isInDep) {
        return "<div class=\"m-empty page-empty\" style=\"display: block;padding: 19px 0; position: absolute;top: 0px;\">\n              <p class=\"title\">" + _MDLocalString["default"].getLocalString(2045) + "</p>\n              <p class=\"info\">" + _MDLocalString["default"].getLocalString(2046) + "</p>\n            </div>";
      } else {
        return "<div class=\"m-empty page-empty\" style=\"display: block;padding: 19px 0; position: absolute;top: 0px;\">\n              <p class=\"title\">" + _MDLocalString["default"].getLocalString(2045) + "</p>\n              <p class=\"info\">" + _MDLocalString["default"].getLocalString(2047) + "</p>\n            </div>";
      }
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFilesUploadedByUserTableView.prototype), "className", this).call(this);
      return "".concat(superCls, " table-striped upload-file-table");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFilesUploadedByUserTableView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        keyName: '',
        allowSelect: false,
        pageSize: 15,
        startIndex: 0,
        onLoadSuccess: _.noop,
        onLoadFailed: _.noop
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFilesUploadedByUserTableView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .headerWrapper": this._clickOnBody
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props = _.extend({
        blankRenderer: function blankRenderer() {
          return _this.emptyTmpl();
        },
        bodyCls: 'fileRows',
        rowCls: 'row',
        headerCls: 'headerWrapper',
        allowSelect: false,
        rowClass: _MDFilesUpleadedByUserTableRowView["default"],
        columns: [{
          name: _MDLocalString["default"].getLocalString(49),
          dataIndex: 'fileName',
          flex: 2
        }, {
          name: _MDLocalString["default"].getLocalString(3048),
          // 创建日期
          dataIndex: 'ctime',
          flex: 1
        }, {
          name: _MDLocalString["default"].getLocalString(265),
          dataIndex: 'parentFolder',
          flex: 1
        }]
      }, props);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFilesUploadedByUserTableView.prototype), "initialize", this).call(this, props);
      if (this.depId) {
        this.isInDep = true;
      }
    }

    /**
     * 请求用户数据
     * @param  {object} params - 参数对象
     * @param {string} opt.keyName - 搜索关键字
     * @param {number} opt.depId - 部门id
     * @param {number} opt.pageSize - 每页个数
     * @param {number} opt.startIndex - 页的起始数据索引
     * @param  {function} onSuccess - 请求成功处理
     * @param  {function} onFail - 请求失败处理
     */
  }, {
    key: "requestUploadedFiles",
    value: function requestUploadedFiles(params, onSuccess, onFail) {
      var _this2 = this;
      this.startLoadingState();
      _.extend(this, params);
      _.isFunction(this.beforeRequest) && this.beforeRequest();
      var getFilesFunc = _MDNetDriveFileHandler["default"].getFilesUploadedByUser;
      if (this.depId) {
        getFilesFunc = _MDNetDriveFileHandler["default"].getFilesInDepUploadedByUser;
      } else if (this.inEp) {
        getFilesFunc = MMEnterpriseController.countUserUploadFileInEnterprise;
      }
      getFilesFunc({
        'userId': this.userId,
        'folderId': this.folderId,
        'depId': this.depId,
        'pageSize': this.pageSize,
        'startIndex': this.startIndex,
        'curPageIndex': this.curPageIndex,
        'userType': this.userType
      }, function (fileCollect, totalCount) {
        _this2.clearLoadingState();
        _this2.setDataCollection(fileCollect, true, false);
        _.isFunction(_this2.onLoadSuccess) && _this2.onLoadSuccess(fileCollect, totalCount);
        _.isFunction(onSuccess) && onSuccess(fileCollect, totalCount);
      }, function () {
        _this2.clearLoadingState();
        _.isFunction(_this2.onLoadFailed) && _this2.onLoadFailed();
        _.isFunction(onFail) && onFail();
      });
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var length = this.dataCollection.length;
      if (length === 0) {
        this.startIndex -= this.pageSize;
      }
      this.requestUploadedFiles({
        startIndex: this.startIndex
      });
    }
  }, {
    key: "_clickOnBody",
    value: function _clickOnBody() {
      console.log('--------------> click on body!');
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MDFilesUploadedByUserTableView';
    }
  }]);
  return MDFilesUploadedByUserTableView;
}(_MDTableView2["default"]);

},{"1091":1091,"1150":1150,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"710":710,"89":89}],710:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDTableRowView2 = _interopRequireDefault(require(88));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDFilesUpleadedByUserTableRowView = exports["default"] = /*#__PURE__*/function (_MDTableRowView) {
  (0, _inherits2["default"])(MDFilesUpleadedByUserTableRowView, _MDTableRowView);
  function MDFilesUpleadedByUserTableRowView() {
    (0, _classCallCheck2["default"])(this, MDFilesUpleadedByUserTableRowView);
    return _callSuper(this, MDFilesUpleadedByUserTableRowView, arguments);
  }
  (0, _createClass2["default"])(MDFilesUpleadedByUserTableRowView, [{
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFilesUpleadedByUserTableRowView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        fileInfo: null,
        columnRenders: function columnRenders() {
          return [{
            dataIndex: 'fileName',
            cellCls: 'name-col online-col text-hide',
            render: function render(name, f, index) {
              var fileName = f.escape("fileName");
              var tmpl = "<div>\n                  <div class=\"thumbWrapper file-icon-root\">\n                    <i class=\"icon\"></i>\n                  </div>\n                  <div class=\"contentWrapper\">\n                    <div class=\"content\">\n                      <div class=\"name-wrapp\">\n                        <div class=\"inner\">\n                          <span class=\"append-per f-none bg-Cred\">".concat(BabelStr.str(2615), "</span>\n                          <span class=\"security\"></span>\n                          <span class=\"name middle-ellipsis\" title=\"").concat(name, "\">").concat(name, "</span>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                  <div class = \"extra-attr\"></div>\n                </div>");
              return tmpl;
            }
          }, {
            dataIndex: 'ctime',
            cellCls: 'time-col',
            render: function render(name, fileInfor, index) {
              return "<div>\n                      <div class=\"modify-time\">".concat(MMCommonFun.formatSec2Date(fileInfor.get('ctime')), "</div>\n                    </div>");
            }
          }, {
            dataIndex: 'parentFolder',
            cellCls: 'parent-col',
            render: function render(name, fileInfor, index) {
              if (fileInfor.get('isPrivateFile')) {
                return "<span class='help-text'>".concat(BabelStr.str(3620), "</span>");
              } else {
                return '<span class="open-parent-folder text-button">' + _MDLocalString["default"].getLocalString(136) + '</span>';
              }
            }
          }];
        }
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFilesUpleadedByUserTableRowView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .open-parent-folder': this._openParentFolder
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFilesUpleadedByUserTableRowView.prototype), "initialize", this).call(this, props);
      var thumbDiv = this.$(".thumbWrapper");
      this.fileInfo = this.rowModel;
      this.fileInfo.setIconForDiv(thumbDiv);
    }
  }, {
    key: "_openParentFolder",
    value: function _openParentFolder() {
      // window.open('/main.do#file/' + this.fileInfo.getParentFolderId());
      var parentId = this.fileInfo.getParentFolderId();
      app.pathRouter.openNewTabByFileId(parentId);
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFilesUpleadedByUserTableRowView.prototype), "viewDidRendered", this).call(this);
      console.log('MDFilesUpleadedByUserTableRowView viewDidRendered');
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MDFilesUpleadedByUserTableRowView';
    }
  }]);
  return MDFilesUpleadedByUserTableRowView;
}(_MDTableRowView2["default"]);

},{"1150":1150,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1454":1454,"1463":1463,"1475":1475,"88":88}],196:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _MEFileTransferWindowView = _interopRequireDefault(require(194));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDMessageView = _interopRequireDefault(require(55));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var MEStaffRowController = exports["default"] = /*#__PURE__*/function () {
  function MEStaffRowController() {
    (0, _classCallCheck2["default"])(this, MEStaffRowController);
  }
  (0, _createClass2["default"])(MEStaffRowController, null, [{
    key: "fileTransfer",
    value: function fileTransfer(userInfo, success) {
      var fileTransferView = new _MEFileTransferWindowView["default"]({
        userInfo: userInfo,
        onSuccess: function onSuccess() {
          success();
        }
      });
      fileTransferView.show();
    }
  }, {
    key: "stopUser",
    value: function stopUser(userInfo, $e) {
      var userIds = [userInfo.getId()];
      var userName = userInfo.getUserName();
      var option = {
        okFun: function okFun() {
          _MMEnterpriseController["default"].roleAndUsers.freezeUsers(userIds, function () {
            _MDMessageView["default"].success(BabelStr.str(3512));
            userInfo.set('status', 1);
            $e && $($e.target).text(BabelStr.str(3063)).removeClass('stop-user').addClass('recover-user');
          }, function () {
            _MDMessageView["default"].error(BabelStr.str(3513));
          });
        },
        message: BabelStr.str(5020, {
          userName: userName
        })
      };
      _MDAlertView["default"].showDangerSelection(option);
    }
  }, {
    key: "recoverUser",
    value: function recoverUser(userInfo, $e) {
      var userIds = [userInfo.getId()];
      var userName = userInfo.getUserName();
      var alert = new _MDAlertView["default"]();
      alert.show({
        title: BabelStr.str(170),
        message: BabelStr.str(5019, {
          userName: userName
        }),
        buttons: [{
          label: BabelStr.str(3096),
          type: 'done',
          onClick: function onClick() {
            _MMEnterpriseController["default"].roleAndUsers.unfreezeUsers(userIds, function () {
              _MDMessageView["default"].success(BabelStr.str(3514));
              userInfo.set('status', 0);
              $e && $($e.target).text(BabelStr.str(3064)).removeClass('recover-user').addClass('stop-user');
            }, function (code, msg) {
              _MDMessageView["default"].error(msg);
            });
          }
        }, {
          label: BabelStr.str(3081)
        }]
      });
    }
  }]);
  return MEStaffRowController;
}();

},{"1098":1098,"1175":1175,"1179":1179,"1184":1184,"1454":1454,"194":194,"32":32,"55":55}],194:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1429);
require(1439);
require(1421);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMViewBase = _interopRequireDefault(require(22));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MEFileTransferWindowView = _interopRequireDefault(require(123));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _utils = _interopRequireDefault(require(108));
var _MEStaffSearchWindowView = _interopRequireDefault(require(200));
var _MDMessageView = _interopRequireDefault(require(55));
var _MDSpinnerloaderLayerView = _interopRequireDefault(require(75));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDSnackbarView = _interopRequireDefault(require(72));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 *  成员管理-转移至窗口
 *  Created by dai
 *  2016.11.30
 */
var MEFileTransferWindowView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MEFileTransferWindowView, _MDWindowView);
  function MEFileTransferWindowView() {
    (0, _classCallCheck2["default"])(this, MEFileTransferWindowView);
    return _callSuper(this, MEFileTransferWindowView, arguments);
  }
  (0, _createClass2["default"])(MEFileTransferWindowView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return _MEFileTransferWindowView["default"].root;
    }
  }, {
    key: "userItemTmpl",
    value: function userItemTmpl() {
      return _MEFileTransferWindowView["default"].useritem;
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEFileTransferWindowView.prototype), "className", this).call(this);
      return "".concat(superCls, " file-transfer-win");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEFileTransferWindowView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        userInfo: null,
        onSuccess: _.noop,
        fromUserId: '',
        toUserId: '',
        totalUsedSpace: 0
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEFileTransferWindowView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .add-staff, .change-staff, .user-input': this.searchStaff,
        'click .view-file': this._lookPersonFile
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      var userInfo = props.userInfo;
      props.title = BabelStr.str(3059); //  "转移文件归属";
      props.buttons = [{
        label: BabelStr.str(3081) // '取消'
      }, {
        label: BabelStr.str(3119),
        // '提交',
        type: 'done',
        autoClose: false,
        enabled: false,
        onClick: this.submit
      }];

      // props.data = {
      //   name: userInfo.getUserName(),
      //   isEnterpriseManager: userInfo.isEpAdminUser()
      // }
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEFileTransferWindowView.prototype), "initialize", this).call(this, props);
      this.userArr = [];
      if (_.isArray(userInfo)) {
        this.userArr = userInfo.slice();
      } else {
        this.userArr.push(userInfo);
      }

      // this.fromUserId = this.userInfo.getId();

      this.userIds = [];
      _.each(this.userArr, function (user) {
        _this.userIds.push(user.getUserId());
      });
      _MDSpinnerloaderLayerView["default"].showIn(this.$('.content-block'), {
        cls: 'white'
      });
      _MMEnterpriseController["default"].roleAndUsers.getPersonalSpaceInfo(this.userIds, function (spaceInfo) {
        _MDSpinnerloaderLayerView["default"].clearFrom(_this.$('.content-block'));
        for (var j = 0; j < spaceInfo.length; j++) {
          var contentTmpl = _.template(_this.userItemTmpl());
          _this.$(".user-content").append(contentTmpl);
          var spaceInfos = spaceInfo[j]['spaceInfos'];
          _this.$(".name").eq(j).append(_this.userArr[j].getUserName());
          for (var i = 0; i < spaceInfos.length; i++) {
            if (!spaceInfos[i]['departmentId']) {
              var name = spaceInfos[i]['name'];
              var usedSpace = _utils["default"].convertSpace(spaceInfos[i]['usedSpace']);
              _this.$('.departs').eq(j).append("<div>".concat(name, "</div>"));
              _this.$('.space').eq(j).append("<div>".concat(usedSpace, "</div>"));
              _this.totalUsedSpace += usedSpace;
            }
          }
        }
      }, function () {
        _MDSpinnerloaderLayerView["default"].clearFrom(_this.$('.content-block'));
        var msg = BabelStr.str(2386); // 文件信息获取失败
        _MDMessageView["default"].error(msg, _this.$body);
      });
    }
  }, {
    key: "searchStaff",
    value: function searchStaff() {
      var _this2 = this;
      var win = new _MEStaffSearchWindowView["default"]({
        singleSelection: true,
        includeNumberInfo: false,
        onChoose: function onChoose(users) {
          _this2._onChoose(users);
        }
      });
      win.show();
    }
  }, {
    key: "_onChoose",
    value: function _onChoose(users) {
      var disabled = users && users.length > 0 ? false : true;
      if (!disabled) {
        var user = users[0];
        this.toUserId = user.getId();
        this.$('.user-input, .add-wrap').hide();
        this.$('.choose-div, .change-staff').show();
        this.$('.choose-div').css('display', 'inline-block');
        this.$('.choose-div .name').text(user.get('name'));
        this.$('.choose-div .email').text('(' + user.getEmail() + ')');
      }
      this.setActionButtonDisabledByIndex(disabled, 1);
    }
  }, {
    key: "submit",
    value: function submit() {
      var _this3 = this;
      if (this.totalUsedSpace === 0) {
        var msg = BabelStr.str(2387); // 没有需要被转移的文件
        _MDMessageView["default"].error(msg, this.$body);
        return;
      }
      if (_.indexOf(this.userIds, this.toUserId) > -1) {
        _MDMessageView["default"].error(BabelStr.str(7000), this.$body);
        return;
      }
      this.setDisabled(true);
      _MDSpinnerloaderLayerView["default"].showIn(this.$body);
      _MMEnterpriseController["default"].roleAndUsers.shiftAllFilesOfUser(this.userIds, this.toUserId, function () {
        _this3.setDisabled(false);
        _MDSpinnerloaderLayerView["default"].clearFrom(_this3.$body);
        _this3.close();
        _MDSnackbarView["default"].show(BabelStr.str(308)); //('文件转移成功');
        _this3.onSuccess();
      }, function () {
        _this3.setDisabled(false);
        _MDSpinnerloaderLayerView["default"].clearFrom(_this3.$body);
        _MDMessageView["default"].error(BabelStr.str(309), _this3.$body); //' 文件转移失败, 请稍后重试'
      });
    }
  }, {
    key: "_lookPersonFile",
    value: function _lookPersonFile() {
      var memberId = this.userInfo.getId();
      var managerId = app.currentUser.getId();
      var url = '/view/user/' + memberId;
      var win = app.pathRouter.openNetTab(url, '_blank');
      win.focus();
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEFileTransferWindowView.prototype), "viewDidRendered", this).call(this);
    }
  }]);
  return MEFileTransferWindowView;
}(_MDWindowView2["default"]);

},{"108":108,"1098":1098,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"123":123,"1421":1421,"1429":1429,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"200":200,"22":22,"55":55,"72":72,"75":75,"76":76,"93":93}],200:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDEnterpriseShareTabView = _interopRequireDefault(require(675));
var _MEStaffSearchPanelView = _interopRequireDefault(require(197));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 *  成员管理-转移至窗口
 *  Created by dai
 *  2016.11.30
 */
var MEStaffSearchWindowView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MEStaffSearchWindowView, _MDWindowView);
  function MEStaffSearchWindowView() {
    (0, _classCallCheck2["default"])(this, MEStaffSearchWindowView);
    return _callSuper(this, MEStaffSearchWindowView, arguments);
  }
  (0, _createClass2["default"])(MEStaffSearchWindowView, [{
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStaffSearchWindowView.prototype), "className", this).call(this);
      return "".concat(superCls, " staff-search-win");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStaffSearchWindowView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        onChoose: _.noop,
        singleSelection: false,
        includeNumberInfo: true,
        needRole: false,
        canChooseGroup: false
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      var title = BabelStr.str(3131); // 选择员工
      props.title = props.title ? props.title : title;
      props.width = BabelStr.isRu() ? 800 : 666;
      props.buttons = [{
        label: BabelStr.str(155) // '取消'
      }, {
        label: BabelStr.str(154),
        // '确定',
        type: 'done',
        enabled: false,
        autoClose: false,
        onClick: function onClick() {
          _this.onSelect();
        }
      }];
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStaffSearchWindowView.prototype), "initialize", this).call(this, props);
      if (this.canChooseGroup) {
        this.searchPanelView = new _MDEnterpriseShareTabView["default"]({
          isSelectOnlyInEp: true,
          canSelDepartment: false,
          excludeOutsider: true,
          notIncludeGuest: true,
          inputFullWidth: true,
          canSelGroup: true,
          // needFrequentUserTab: false,
          needRoleTab: false,
          placeholder: BabelStr.str(40079),
          // needFrequentUserTab: !this.fileInfor.get('forClient'),
          onChange: function onChange(users) {
            var disabled = users && users.length > 0 ? false : true;
            _this.setActionButtonDisabledByIndex(disabled, 1);
          }
        });
      } else {
        this.searchPanelView = new _MEStaffSearchPanelView["default"]({
          singleSelection: this.singleSelection,
          includeNumberInfo: this.includeNumberInfo,
          needRole: this.needRole,
          excludeDepId: this.excludeDepId,
          chooseChangeCb: function chooseChangeCb(users) {
            var disabled = users && users.length > 0 ? false : true;
            _this.setActionButtonDisabledByIndex(disabled, 1);
          }
        });
      }
      this.addSubView(this.searchPanelView);
    }
  }, {
    key: "getSearchedPersons",
    value: function getSearchedPersons() {
      var users;
      if (this.canChooseGroup) {
        users = this.searchPanelView.getSelectedMolaUsers();
      } else {
        users = this.searchPanelView.getSearchedPersons();
      }
      return users;
    }
  }, {
    key: "onSelect",
    value: function onSelect() {
      if (!this.canChooseGroup && !this.searchPanelView.validate()) {
        return;
      }
      var users = this.getSearchedPersons();
      var roleId = undefined;
      if (!this.canChooseGroup) {
        roleId = this.searchPanelView.getSelectedRoleId();
      }
      console.log(users, roleId);
      this.onChoose(users, roleId);
      this.close();
    }
  }]);
  return MEStaffSearchWindowView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"197":197,"675":675,"93":93}],675:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1436);
require(1546);
require(1417);
require(1463);
require(1439);
require(1498);
require(1426);
require(1429);
require(1541);
require(1418);
require(1537);
require(1412);
var _MDUserListView = _interopRequireDefault(require(344));
var _MDParticipantInfo = _interopRequireDefault(require(276));
var _MDEnterpriseGroupTreeView = _interopRequireDefault(require(674));
var _MMViewBase = _interopRequireDefault(require(22));
var _MDTabView = _interopRequireDefault(require(82));
var _MDEnterpriceDepartmentTreeView = _interopRequireDefault(require(672));
var _MDEnterpriceOutsidersListView = _interopRequireDefault(require(673));
var _MDFrequentContactsListView = _interopRequireDefault(require(677));
var _MDParticipantInfoCollection = _interopRequireDefault(require(277));
var _regexp = _interopRequireDefault(require(106));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDEpRolelistTabView = _interopRequireDefault(require(676));
var _MDMolaUser = _interopRequireDefault(require(272));
var _MDDropDownSelectRoleView = _interopRequireDefault(require(50));
var _popupPos = _interopRequireDefault(require(65));
var _MDOneGroupPopupView = _interopRequireDefault(require(753));
/**
 * 企业版分享页面 -->   添加联系人
 * WebContent/javascript/moladisk/views/file/share/MDEnterpriseShareTabView.js
 *  Created by jichao
 *  2016.12.14
 */

var Keycode = {
  BACKSPACE: 8,
  TAB: 9,
  UP: 38,
  DONW: 40,
  ESC: 27,
  ENTER: 13,
  ARROW_UP: 38,
  ARROW_DOWN: 40,
  SPACE: 32,
  // 空格
  COMMA: 188,
  //  逗号
  SEMICOLON: 186,
  // 分号
  DOT: 190 // .
};
var MDEnterpriseShareTabView = _MMViewBase["default"].extend({
  tmpl: "<div class=\"flex-align\">\n          <div class='choose-contain <%=(inputFullWidth ? \"full-width\" : '')%>' tabindex=\"1\">\n            <div class=\"choosed\" >\n              <input class=\"email-input <%=(needInputUsers ? '11' : 'f-hide')%>\" placeholder=\"<%=placeholder%>\"></input>\n            </div>\n          </div>\n          <div class=\"role-select-content f-none\"></div>\n        </div>\n        <div class=\"contact-list\"></div>\n        <div class=\"add-entrance f-clb\">\n          <span class=\"f-fl add-member\"><%=fromEnt%></span>\n          <span class=\"f-fr cancle-add-member f-hide\"><%=close%></span>\n        </div>\n        <div  class=\"tab app-tab-theme f-hide\" </div>",
  checkedItemTpl: "\n      <%if (type==2) {%>\n        <div class=\"user-item no-user-select f-pointer\" data-client-id=\"<%=cid%>\">\n      <%}else{%>\n        <div class=\"user-item no-user-select\" data-client-id=\"<%=cid%>\">\n      <%}%>\n\n        <%if(type==0){%>\n          <span class=\"icon user-s-icon\"></span>\n          <span class=\"user no-user-select\"><%=name%></span>\n        <%} else if(type==1){%>\n          <span class=\"icon dep-s-icon\"></span>\n          <span class=\"user no-user-select\"><%=name%></span>\n        <%} else if (type==2) {%>\n          <span class=\"icon grp-s-icon\" data-tooltip=\"<%=BabelStr.str(2578)%>\"></span>\n          <span class=\"user no-user-select\" data-tooltip=\"<%=BabelStr.str(2578)%>\"><%=name%></span>\n        <%} else if (type==10) {%>\n          <span class=\"user no-user-select main-color\"><%=name%></span>\n        <%}else{%>\n          <span class=\"icon user-error-icon\"></span>\n          <span class=\"user no-user-select error-input\"><%=name%></span>\n        <%}%>\n        <%if(canDeleteItem){%>\n          <span class=\"ope no-user-select\">\xD7</span>\n        <%}%>\n\n      </div>",
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      canManageShare: true,
      onChange: _.noop,
      needFrequentUserTab: true,
      needGroupTreeTab: true,
      inputName: "",
      inputDisabled: false,
      participantInfoCollection: new _MDParticipantInfoCollection["default"](),
      //选中的所有用户
      defaultParticipantInfoCollection: new _MDParticipantInfoCollection["default"](),
      //初始化时传入的用户
      allParticipantInfoCollection: new _MDParticipantInfoCollection["default"](),
      //所有用户   外部成员+部门成员+常用联系人
      isSelectOnlyInEp: false,
      //只在企业中选择
      disCurrentArr: [],
      canSelDepartment: true,
      //是否允许选择部门
      canSelGroup: true,
      //是否允许选择组
      excludeGroupIds: [],
      placeholder: BabelStr.str(709),
      // '请选择审批人员'
      acceptNotFound: true,
      isTabAbsolute: false,
      needRoleTab: false,
      isNeedCurUser: false,
      tabHeight: undefined,
      //Number
      canSelectDepUser: true,
      //是否允许选择部门内人员
      inputFullWidth: false,
      initDepIds: [],
      fromStr: '',
      needDepTree: true,
      scope: 0,
      // 搜索范围  0: 常用联系人， 1： 部门成员，2：外部人员，3： 分组人员
      emptySearchStr: BabelStr.str(3456),
      isTabsOpened: false,
      forFile: false,
      fid: '',
      needRoleSelectList: false,
      beforeSelect: function beforeSelect() {
        return true;
      },
      allowPhone: true,
      allowEmail: true,
      showErrorInput: true,
      needSearch: true,
      needInputUsers: true,
      canDeleteItem: true,
      canSelectItem: true,
      ignoreIsShowingStructor: false,
      onlyOne: false,
      includeDep: false,
      includeGroup: false
    });
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click .ope': this.removeUser,
      'click .choose-contain .user-item': this.showGroupPopup,
      'click .choose-contain': this.setInputFocus,
      'click .choosed': this.setInputFocus,
      'click .email-input': this.setInputFocus,
      // 'keydown .email-input': this.emailInputKeydownHandler,
      'blur .email-input': this.emailInputBlurHandler,
      'keyup .email-input': this.emailInputKeyupHandler,
      'keydown .email-input': this.emailInputKeyDownHandler,
      'click .add-member': this._clickaddMemberhandle,
      'click .cancle-add-member': this._clickCancleAddMemberhandle
    });
  },
  className: function className() {
    var superCls = _MMViewBase["default"].prototype.className.call(this);
    return superCls + ' ep-share-tab enterprise-user-tab';
  },
  initialize: function initialize(opt) {
    var _this = this;
    opt.data = _.extend({
      'placeholder': opt.placeholder,
      'fromEnt': opt.fromStr || BabelStr.str(2383),
      // 从企业成员列表添加
      'close': BabelStr.str(3219),
      // 收起
      'inputFullWidth': opt.inputFullWidth,
      needInputUsers: _.isUndefined(opt.needInputUsers) ? true : opt.needInputUsers
    }, opt.data);
    this.canSelDepartment = true;
    var self = this;
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.bindSelf(this.checkUser);
    this.$(".email-input").attr("name", this.inputName);
    var tabs = [];
    this.scope = 3;
    if (this.excludeOutsider || this.notIncludeGuest) {
      this.scope = 1;
    }
    if (this.needDepTree && (app.currentUser.canLoginEpManagePage() || app.currentUser.get('isShowingStructor'))) {
      if (this.canSelDepartment) {
        this.includeDep = true;
      }
      this.epDepartmentTreeView = new _MDEnterpriceDepartmentTreeView["default"]({
        initDepIds: this.initDepIds,
        canSelDepartment: this.canSelDepartment,
        initParticipantInfo: self.initParticipantInfo,
        canSelectDepUser: this.canSelectDepUser,
        checkUser: function checkUser(users) {
          self.checkUser(users);
        },
        allParticipantInfoCollection: this.allParticipantInfoCollection
      });
      tabs.push({
        title: BabelStr.str(202),
        // '企业成员',
        tabPanelView: this.epDepartmentTreeView
      });
    }
    if (this.needDepTree) {
      // this.scope = this.scope | 2;
    }
    if (!this.excludeOutsider && !this.notIncludeGuest) {
      // this.scope = this.scope | 4;
      var tab = {
        title: BabelStr.str(382),
        // '外部人员',
        tabPanelView: new _MDEnterpriceOutsidersListView["default"]({
          initParticipantInfo: self.initParticipantInfo,
          checkUser: function checkUser(users) {
            self.checkUser(users);
          }
        })
      };
      tabs.push(tab);
    }
    if (this.needGroupTreeTab) {
      // this.scope = this.scope | 8;
      if (this.canSelGroup) {
        this.includeGroup = true;
      }
      this.epGroupTreeView = new _MDEnterpriseGroupTreeView["default"]({
        canSelGroup: this.canSelGroup,
        isSelectOnlyInEp: this.isSelectOnlyInEp,
        excludeGroupIds: this.excludeGroupIds,
        canSelDepartment: this.canSelDepartment,
        initParticipantInfo: self.initParticipantInfo,
        notIncludeGuest: self.notIncludeGuest,
        checkUser: function checkUser(users) {
          self.checkUser(users);
        },
        allParticipantInfoCollection: this.allParticipantInfoCollection
      });
      var tab = {
        title: BabelStr.str(479),
        // '我的分组',
        tabPanelView: this.epGroupTreeView
      };
      tabs.push(tab);
    }
    if (this.needFrequentUserTab) {
      // this.scope = this.scope | 1;
      this.frequentContactListView = new _MDFrequentContactsListView["default"]({
        notIncludeGuest: self.notIncludeGuest,
        checkUser: function checkUser(users) {
          self.checkUser(users);
        },
        initParticipantInfo: self.initParticipantInfo
        // allParticipantInfoCollection: this.allParticipantInfoCollection
      });
      var tab = {
        title: BabelStr.str(480),
        // '常用联系人',
        tabPanelView: this.frequentContactListView,
        active: true
      };
      tabs.unshift(tab);
    }
    if (this.needRoleTab) {
      var tab = {
        title: BabelStr.str(4613),
        // '角色',
        tabPanelView: new _MDEpRolelistTabView["default"]({
          checkUser: function checkUser(users) {
            self.checkUser(users);
          }
          // allParticipantInfoCollection: this.allParticipantInfoCollection
        })
      };
      tabs.push(tab);
    }
    if (tabs.length) {
      this.tabview = new _MDTabView["default"]({
        fullMode: false,
        className: 'ep-share blue-style-tab1',
        enableActivebar: false,
        tabBarPosition: 0,
        tabs: tabs
      });
      this.addSubView(this.tabview, this.$(".tab")[0]);
    } else {
      this.$(".tab").html("<div class='help-text mgtb-20 pdtb-20 f-tc'>".concat(BabelStr.str(6366), "</div>"));
    }
    if (tabs.length == 1) {
      this.tabview.hideTabHead();
    }
    this.contactListView = new _MDUserListView["default"]({
      checkUser: function checkUser(users) {
        self.checkUser(users);
        self.$input.val("");
      },
      maxHeight: 172,
      emptySearchStr: this.emptySearchStr
    });
    this.addSubView(this.contactListView, this.$(".contact-list")[0]);
    this.contactListView.hide();
    this.listenTo(this.participantInfoCollection, 'add', this.whenItemAddHandler);
    this.listenTo(this.participantInfoCollection, 'remove', this.whenItemRemoveHandler);
    this.listenTo(this.participantInfoCollection, 'update', this.whenparticipantInfoCollectionUpdateHandler);
    this.listenTo(this.participantInfoCollection, 'reset', this.whenparticipantInfoCollectionUpdateHandler);
    this.listenTo(this.allParticipantInfoCollection, "add", this.userListUpdate);
    this.$input = this.$(".email-input");
    if (this.isNeedCurUser) {
      this.disCurrentArr = [];
    } else {
      this.disCurrentArr = [app.currentUser.getUserId()];
    }
    this.$(".email-input").data('list', this.defaultParticipantInfoCollection.toJSON());
    this.$(".email-input").data('disUserArr', this.disCurrentArr);
    this.defaultParticipantInfoCollection.each(function (user1, index) {
      self.addItem(user1, true);
    });
    if (this.inputDisabled) {
      this.$(".email-input").prop("readonly", true).addClass("notclick").prop("placeholder", this.placeholder);
    }
    if (this.isTabAbsolute) {
      this.$(".choose-contain").on("click." + this.nameSpace, function ($e) {
        var $item = $($e.target).closest(".user-item");
        if (!$item.find(".grp-s-icon").length) {
          _this.showTab();
        }
      });
      this.$(".app-tab-theme").addClass("pos-absolute f-hide");
      $("body").on("click.evaluterList", function ($e) {
        if ($e.target.tagName == "INPUT") {
          return;
        }
        var $target = $e.target;
        if (!$.contains(_this.el, $e.target)) {
          _this.hideTab();
        }
      });
    }
    if (this.isTabsOpened) {
      this.$(".add-member").addClass('f-hide');
      this.$(".cancle-add-member").removeClass('f-hide');
      this.$(".tab").removeClass('f-hide');
      this.setInputFocus();
    }
    if (this.needRoleSelectList) {
      this.getRoles(function (roles, defaultRole) {
        var roleArr = [];
        // self.roleIds = [];
        for (var i = 0; i < roles.length; i++) {
          var role = roles[i];
          var str = {
            label: role.get("description"),
            canSelected: true,
            linkRoleId: role.getRoleId(),
            systemdefault: role.get('systemdefault')
          };
          roleArr.push(str);
        }
        var index = -1;
        _.each(roleArr, function (roleInfo, i) {
          if (roleInfo["linkRoleId"] == defaultRole) {
            index = i;
          }
        });
        index = index < 0 ? 0 : index;
        _this.roleId = roleArr[index].linkRoleId;
        _this.shareLinkPermissionDropdown = new _MDDropDownSelectRoleView["default"]({
          index: index,
          roles: roles,
          invite: true,
          bd: roleArr,
          onChange: function onChange(item) {
            _this.roleId = item.linkRoleId;
          },
          minW: '162px'
        });
        _this.addSubView(_this.shareLinkPermissionDropdown, _this.$(".role-select-content")[0]);
      });
      this.$('.role-select-content').removeClass('f-none');
    }
    var placeholder = opt.placeholder;
    if (this.includeDep && this.canSelDepartment && this.canSelGroup) {
      placeholder = opt.data.placeholder || BabelStr.str(40080);
    }
    placeholder = placeholder || BabelStr.str(709);
    this.$(".email-input").prop("placeholder", placeholder);
  },
  setDefaultParticipantInfoCollectio: function setDefaultParticipantInfoCollectio(defaultParticipantInfoCollection) {
    var self = this;
    defaultParticipantInfoCollection.each(function (user1, index) {
      self.addItem(user1, true);
    });
  },
  getRoles: function getRoles(callback) {
    var self = this;
    var _initRoles = function _initRoles(roleCollection, defaultRole) {
      var shareRoles = [];
      roleCollection.each(function (roleInfo) {
        // var permission = roleInfo.getPermission();
        shareRoles.push(roleInfo);
      });
      callback(shareRoles, defaultRole);
    };
    if (!this.forFile) {
      MMNetDiskDataController.getAllRoles(function (roleCollection, defaultRole) {
        _initRoles(roleCollection, defaultRole);
      }, function () {
        MDSnackbarView.show(BabelStr.str(7296));
      });
    } else {
      MMNetDiskDataController.getRoles(this.fid, function (roleCollection, defaultRole) {
        _initRoles(roleCollection, defaultRole);
      }, function () {
        MDSnackbarView.show(BabelStr.str(7296));
      });
    }
  },
  showTab: function showTab() {
    // this.$(".tab").removeClass("f-hide");
    this._clickaddMemberhandle();
  },
  hideTab: function hideTab() {
    if (this.$(".tab").hasClass("f-hide")) {
      return;
    }
    this._clickCancleAddMemberhandle();
  },
  getItemInput: function getItemInput() {
    return this.$('.email-input');
  },
  _clickaddMemberhandle: function _clickaddMemberhandle() {
    this.$(".add-member").addClass('f-hide');
    this.$(".cancle-add-member").removeClass('f-hide');
    this.$(".tab").removeClass('f-hide');
    this.setInputFocus();
    _.isFunction(this.onTabShow) && this.onTabShow();
    this.navigationWindowView && this.navigationWindowView.refreshWindow();
  },
  setInputFocus: function setInputFocus() {
    // if (this.$(".email-input").prop("readonly")) {
    //   this.$('.choose-contain').focus();
    // } else {
    this.$('.email-input').focus();
    // }
  },
  _clickCancleAddMemberhandle: function _clickCancleAddMemberhandle() {
    this.$(".add-member").removeClass('f-hide');
    this.$(".cancle-add-member").addClass('f-hide');
    this.$(".tab").addClass('f-hide');
    this.setInputFocus();
    _.isFunction(this.onTabHide) && this.onTabHide();
    this.navigationWindowView && this.navigationWindowView.refreshWindow();
  },
  /**
   * @param  {MDMolaUser | MDMolaUser[]} users
   */
  checkUser: function checkUser(users) {
    if (!_.isUndefined(this.maxLength) && this.participantInfoCollection.length >= this.maxLength) {
      _.isFunction(this.maxLengthCallback) && this.maxLengthCallback();
      return;
    }
    if (!this.canSelectItem) {
      return;
    }
    var result = [];
    if (this.beforeSelect) {
      for (var i = 0; i < users.length; i++) {
        var user = users[i];
        if (this.beforeSelect(user)) {
          result.push(user);
        }
      }
    } else {
      result = users;
    }
    users = result;
    _.each(users, function (user) {
      user.set("id", user.participantId() + "_" + user.participantType()); //设置id属性，数组中存在相同participateId的用户
    });
    if (this.onlyOne) {
      this.participantInfoCollection.set(users);
    } else {
      this.participantInfoCollection.add(users);
    }
    this.setInputFocus();
  },
  addItem: function addItem(userInfor, nosilent) {
    if (!_.isUndefined(this.maxLength) && this.participantInfoCollection.length >= this.maxLength) {
      _.isFunction(this.maxLengthCallback) && this.maxLengthCallback();
      return;
    }
    userInfor.set("id", userInfor.participantId() + "_" + userInfor.participantType());
    if (this.onlyOne) {
      this.participantInfoCollection.set([userInfor]);
    } else {
      this.participantInfoCollection.add(userInfor, {
        silent: !nosilent
      });
    }
  },
  renderItem: function renderItem(user) {
    var name = user.name();
    if (!name) {
      name = user.originalEmail() ? user.mail() : user.phone();
    }
    // if(this.onlyOne) {
    //   this.$(".email-input").html(name)
    //   return
    // }
    var itemHTML = _.template(this.checkedItemTpl)({
      'name': name,
      "cid": user.cid,
      "type": user.participantType(),
      canDeleteItem: this.canDeleteItem
    });
    this.$(".choosed .email-input").before(itemHTML);
  },
  onEnter: function onEnter() {
    var value = this.$input.val();
    value = value.trim();
    if (value.length == 0) {
      return;
    }
    if (_regexp["default"].isEmail(value) && this.allowEmail) {
      var user = this.contactListView.getSelectedUser();
      // _.findWhere(this.contactListView.getUserList(), (e)=>{
      //   e.get("originalEmail") == value
      // })
      if (user) {
        this.$input.val("");
        if (this.beforeSelect(user)) {
          this.addItem(user, true);
        }
      } else if (this.isSelectOnlyInEp) {
        this.$input.val("");
      } else {
        this.addUserEmailItem(value);
      }
    } else if (_regexp["default"].isPhone(value) && this.allowPhone) {
      var _user = this.contactListView.getSelectedUser();
      // _.findWhere(this.contactListView.getUserList(), (e)=>{
      //   e.get("phone") == value
      // })
      if (_user) {
        this.$input.val("");
        if (this.beforeSelect(_user)) {
          this.addItem(_user, true);
        }
      } else if (this.isSelectOnlyInEp) {
        this.$input.val("");
      } else {
        this.addUserPhoneItem(value);
      }
    } else if (this.contactListView && this.contactListView.getSelectedUser()) {
      this.$input.val("");
      var _user2 = this.contactListView.getSelectedUser();
      if (this.beforeSelect(_user2)) {
        this.addItem(_user2, true);
      }
    } else if (this.acceptNotFound) {
      if (this.isSelectOnlyInEp) {
        this.$input.val("");
      } else if (this.showErrorInput) {
        // 错误无效的输入

        if (_regexp["default"].validateTextinput(value)) {
          this.addErrorItem(value);
        }
        this.$input.val("");
      } else {
        this.$input.val("");
      }
    }
    this.contactListView && this.contactListView.hide();
  },
  addErrorItem: function addErrorItem(value) {
    if (!_.isUndefined(this.maxLength) && this.participantInfoCollection.length >= this.maxLength) {
      _.isFunction(this.maxLengthCallback) && this.maxLengthCallback();
      return;
    }
    var self = this;
    var participant = new _MDParticipantInfo["default"]();
    participant.setName(value);
    participant.setParticipantType(_MDParticipantInfo["default"].ERROR);
    self.participantInfoCollection.add(participant, true);
  },
  addUserEmailItem: function addUserEmailItem(email) {
    if (!_regexp["default"].isEmail(email)) {
      return;
    }
    if (!_.isUndefined(this.maxLength) && this.participantInfoCollection.length >= this.maxLength) {
      _.isFunction(this.maxLengthCallback) && this.maxLengthCallback();
      return;
    }
    var self = this;
    // this.isEmailRegistered(email, function(){
    self.$input.val("");
    var participant = new _MDParticipantInfo["default"]();
    participant.setMail(email);
    participant.set("guest", 1);
    participant.set("id", email);
    participant.setParticipantType(_MDParticipantInfo["default"].USER_TYPE);
    self.participantInfoCollection.add(participant, true);
    // }, function(){
    //   self.$input.val("");

    // });
  },
  addUserPhoneItem: function addUserPhoneItem(phone) {
    if (!_regexp["default"].isPhone(phone)) {
      return;
    }
    if (!_.isUndefined(this.maxLength) && this.participantInfoCollection.length >= this.maxLength) {
      _.isFunction(this.maxLengthCallback) && this.maxLengthCallback();
      return;
    }
    var self = this;
    // this.isPhoneRegistered(phone, function(){
    self.$input.val("");
    var participant = new _MDParticipantInfo["default"]();
    participant.setPhone(phone), participant.setParticipantType(_MDParticipantInfo["default"].USER_TYPE);
    participant.set("id", phone);
    participant.set("guest", 1);
    self.participantInfoCollection.add(participant, true);
    // }, function(){
    //   self.$input.val("");

    // });
  },
  removeUser: function removeUser($e) {
    $e.stopPropagation();
    var cid = $($e.target).closest(".user-item").data('clientId');
    this.participantInfoCollection.remove(cid);
  },
  showGroupPopup: function showGroupPopup($e) {
    var $btn = $($e.currentTarget);
    if (!$btn.find(".grp-s-icon").length) {
      return;
    }
    $e.stopPropagation();
    if ($btn.hasClass("with-popup")) {
      var view = $btn.data("popupView");
      view.close();
      return;
    }
    var cid = $btn.data('clientId');
    var user = this.participantInfoCollection.get(cid);
    var id = user.participantId();
    _MDOneGroupPopupView["default"].show({
      groupName: $btn.find(".user").text(),
      triggerView: $btn,
      direction: _popupPos["default"].TOP,
      groupId: id
      // $container: this.getNavigationView().$el
    });
  },
  validateInput: function validateInput(email) {
    return _regexp["default"].isEmail(email);
  },
  whenItemAddHandler: function whenItemAddHandler(user, participantInfoCollection, opt) {
    var _this2 = this;
    if (this.filterCurrentUser && user.isCurrentUser()) {
      participantInfoCollection.remove(user);
      if (!this.filterCurrentUserAlert) {
        this.filterCurrentUserAlert = true;
        var alert = new _MDAlertView["default"]({
          title: BabelStr.str(170),
          message: "<p class=\"title\">".concat(BabelStr.str(5405), "</p>"),
          className: 'm-delAlertWin',
          onClose: function onClose() {
            _this2.filterCurrentUserAlert = false;
          },
          buttons: [{
            label: BabelStr.str(156),
            onClick: function onClick() {
              _this2.filterCurrentUserAlert = false;
            }
          }]
        });
        alert.show();
      }
      return;
    }
    this.renderItem(user);
    this._participantsChanged();
  },
  emailInputBlurHandler: function emailInputBlurHandler() {
    this.onEnter();
  },
  emailInputKeyupHandler: function emailInputKeyupHandler($e) {
    var code = $e.which;
    var val = this.$input.val();
    switch (code) {
      case Keycode.ENTER:
        if (this.enterKey) {
          this.onEnter();
        }
      case Keycode.TAB:
      // case Keycode.COMMA:         // 逗号
      // case Keycode.SPACE:         //
      case Keycode.SEMICOLON:
        // 分号
        this.onEnter();
        $e.preventDefault();
        return;
      case Keycode.UP:
      case Keycode.DONW:
        $e.preventDefault();
        return;
      // case Keycode.BACKSPACE:
      //   this.keyupBackspaceHandle(val)
    }
    if (val && val.length) {
      this._searchUserFromUserlist(val);
    } else {
      this.contactListView.hide();
    }
    this.setInputFocus();
    this.navigationWindowView && this.navigationWindowView.refreshWindow();
  },
  emailInputKeyDownHandler: function emailInputKeyDownHandler($e) {
    var code = $e.which;
    var val = this.$input.val();
    switch (code) {
      case Keycode.BACKSPACE:
        this.keyupBackspaceHandle(val);
    }
    if (code == Keycode.ENTER) {
      this.enterKey = true;
    } else {
      this.enterKey = false;
    }
    if (val && val.length) {} else {
      this.contactListView.hide();
    }
    this.setInputFocus();
    this.navigationWindowView && this.navigationWindowView.refreshWindow();
  },
  userListUpdate: function userListUpdate() {
    var userList = this.allParticipantInfoCollection.models;
    if (!userList) {
      userList = [];
    }
    ;
    this.contactListView.setUserList(userList);
  },
  keyupBackspaceHandle: function keyupBackspaceHandle(val) {
    if (val.length > 0) {
      return;
    }
    var cid = this.$(".user-item:last").data('clientId');
    this.participantInfoCollection.remove(cid);
  },
  whenparticipantInfoCollectionUpdateHandler: function whenparticipantInfoCollectionUpdateHandler() {
    this.onChange(this.participantInfoCollection);
    this.$(".email-input").data('list', this.participantInfoCollection.toJSON());
    this.$(".email-input").data('disUserArr', this.disCurrentArr);
    this._participantsChanged();
    this.navigationWindowView && this.navigationWindowView.refreshWindow();
  },
  whenItemRemoveHandler: function whenItemRemoveHandler(user, collection) {
    var cid = user.cid;
    this.$('[data-client-id=' + cid + ']').remove();
    this._participantsChanged();
    this.onChange(this.participantInfoCollection);
  },
  _participantsChanged: function _participantsChanged() {
    if (this.participantInfoCollection.size() > 0) {
      this.$('.email-input').addClass('border-top');
    } else {
      this.$('.email-input').removeClass('border-top');
    }
  },
  getTargetEmails: function getTargetEmails() {
    return this.getTargetObj();
  },
  getTargetRegExpEmails: function getTargetRegExpEmails() {
    var obj = {
      emails: [],
      //  emails和userIds  中的用户是一致的
      userIds: [],
      phones: [],
      deps: [],
      groupIds: [],
      invalidNames: []
    };
    this.participantInfoCollection.each(function (user) {
      if (user.isUser()) {
        if (user.originalEmail() && _regexp["default"].isEmail(user.originalEmail())) {
          obj.emails.push(user.originalEmail());
        } else if (user.phone()) {
          obj.phones.push(user.phone());
        }
        if (user.participantId()) {
          obj.userIds.push(user.participantId());
        }
      } else if (user.isDep()) {
        obj.deps.push(user.participantId());
      } else if (user.isGroup()) {
        obj.groupIds.push(user.participantId());
      } else {
        obj.invalidNames.push(user.get('name'));
      }
    });
    return obj;
  },
  getTargetObj: function getTargetObj() {
    var obj = {
      emails: [],
      //  emails和userIds  中的用户是一致的
      userIds: [],
      phones: [],
      deps: [],
      groupIds: [],
      invalidNames: []
    };
    this.participantInfoCollection.each(function (user) {
      if (user.isUser()) {
        if (user.originalEmail()) {
          obj.emails.push(user.originalEmail());
        } else if (user.phone()) {
          obj.phones.push(user.phone());
        }
        if (user.participantId()) {
          obj.userIds.push(user.participantId());
        }
      } else if (user.isDep()) {
        obj.deps.push(user.participantId());
      } else if (user.isGroup()) {
        obj.groupIds.push(user.participantId());
      } else {
        obj.invalidNames.push(user.get('name'));
      }
    });
    return obj;
  },
  getTargetIds: function getTargetIds() {
    var obj = {
      emails: [],
      //  emails和userIds  中的用户是一致的
      userIds: [],
      phones: [],
      deps: [],
      groupIds: [],
      invalidNames: []
    };
    this.participantInfoCollection.each(function (user) {
      if (user.isUser()) {
        if (user.participantId()) {
          obj.userIds.push(user.participantId());
        } else if (user.originalEmail()) {
          obj.emails.push(user.originalEmail());
        } else if (user.phone()) {
          obj.phones.push(user.phone());
        }
      } else if (user.isDep()) {
        obj.deps.push(user.participantId());
      } else if (user.isGroup()) {
        obj.groupIds.push(user.participantId());
      } else {
        obj.invalidNames.push(user.get('name'));
      }
    });
    return obj;
  },
  getSelectedUsers: function getSelectedUsers() {
    var out = [];
    var accountType;
    var self = this;
    this.participantInfoCollection.each(function (user) {
      if (user.isUser) {
        if (user.participantId()) {
          accountType = 0;
        } else if (user.originalEmail()) {
          accountType = 1;
        } else if (user.phone()) {
          accountType = 2;
        }
        user = {
          id: user.participantId(),
          userId: user.participantId(),
          name: user.name() || user.phone() || user.mail(),
          email: user.mail() || user.phone(),
          phone: user.phone(),
          accountType: accountType,
          userType: user.get("participantType"),
          roleId: self.roleId
        };
        out.push(user);
      }
    });
    return out;
  },
  getSelectedMolaUsers: function getSelectedMolaUsers() {
    var users = this.getSelectedUsers();
    var out = _.map(users, function (user) {
      return new _MDMolaUser["default"](user);
    });
    return out;
  },
  setSelectsByDepId: function setSelectsByDepId(deps) {
    this.epDepartmentTreeView.setSelectsByDepId(deps);
  },
  clear: function clear() {
    this.$(".choosed .user-item").remove();
    this.participantInfoCollection.reset([]);
    this.$input.val("");
  },
  resetFrequentList: function resetFrequentList(data) {
    this.frequentContactListView.setFrequentUserList(data);
  },
  viewDidRendered: function viewDidRendered() {
    _MMViewBase["default"].prototype.viewDidRendered.call(this);
    if (!this.canManageShare) {
      this.$(".choose-contain").css({
        "width": "100%"
      });
    }
    if (this.showUserList) {
      this.$(".add-member").addClass('f-hide');
      this.$(".cancle-add-member").addClass('f-hide');
      this.$(".tab").removeClass('f-hide');
    }
    this.setInputFocus();
    if (this.tabHeight) {
      this.$('.tab-panel-wrapper').css({
        "height": this.tabHeight + 'px',
        "max-height": this.tabHeight + 'px'
      });
    }
  },
  getInputVal: function getInputVal() {
    return this.$input.val();
  },
  newDepToMolauser: function newDepToMolauser(deps) {
    //array   or  object
    this.epDepartmentTreeView.newDepToMolauser(deps);
  },
  initParticipantInfo: function initParticipantInfo(params) {
    return _MDParticipantInfo["default"].createParticipantInfo(params);
  },
  isEmailRegistered: function isEmailRegistered(email, success, fail) {
    var _this3 = this;
    MMEnterpriseController.isEmailRegistered(email, function (registered) {
      if (!registered) {
        _this3.showWarningView(email, success, fail);
      } else {
        success && success();
      }
    }, function () {
      fail && fail();
    });
  },
  isPhoneRegistered: function isPhoneRegistered(phone, success, fail) {
    var _this4 = this;
    MMEnterpriseController.isPhoneRegistered(phone, function (registered) {
      if (!registered) {
        _this4.showWarningView(phone, success, fail);
      } else {
        success && success();
      }
    }, function () {
      fail && fail();
    });
  },
  showWarningView: function showWarningView(str, success, fail) {
    var msg = BabelStr.str(3318, {
      "name": str
    });
    if (this.used2sendPubShareLink) {
      msg = BabelStr.str(3392, {
        "name": str
      });
    }
    var alertView = new _MDAlertView["default"]();
    alertView.show({
      title: BabelStr.str(170),
      message: msg,
      className: 'm-delAlertWin',
      width: 350,
      buttons: [{
        label: BabelStr.str(154),
        type: 'done',
        onClick: function onClick() {
          success && success();
        }
      }, {
        label: BabelStr.str(155),
        onClick: function onClick() {
          fail && fail();
        }
      }]
    });
  },
  /**
  * 截断字符串，超过 maxLength 显示 ...
  * @param {string} str - 原始字符串
  * @param {number} maxLength - 最大长度（默认 16）
  * @returns {string} 截断后的字符串
  */
  truncateString: function truncateString(str) {
    var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
    if (str.length > maxLength) {
      return str.slice(0, maxLength - 1) + '...';
    }
    return str;
  },
  _searchUserFromUserlist: function _searchUserFromUserlist(key) {
    var _this5 = this;
    if (!this.needSearch) {
      return;
    }
    var self = this;
    key = key.trim();
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(function () {
      MMEnterpriseController.searchUserFromUserlist({
        key: key,
        scope: _this5.scope,
        includeDep: _this5.includeDep,
        includeGroup: _this5.includeGroup
      }, function () {
        var users = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var groupInfos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var departmentInfos = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        var userArr = _.map(users, function (user) {
          return _this5.initParticipantInfo({
            id: user.userId,
            type: _MDParticipantInfo["default"].USER_TYPE,
            name: user.userName,
            email: user.email,
            guest: user.guest
          });
        });
        var groupInfosArr = _.compact(_.map(groupInfos, function (user) {
          if (_this5.isSelectOnlyInEp && !user.belongToEnterprise) {
            return undefined; // 不满足条件时返回 undefined
          }
          return _this5.initParticipantInfo({
            id: user.id,
            type: _MDParticipantInfo["default"].GROUP_TYPE,
            name: user.groupName,
            belongToEnterprise: user.belongToEnterprise
          });
        }));

        // 1. 统计重复名称（基于原始 name 的截断值）
        var nameCount = {};
        departmentInfos.forEach(function (user) {
          var truncatedName = _this5.truncateString(user.name);
          nameCount[truncatedName] = (nameCount[truncatedName] || 0) + 1;
        });

        // 2. 生成最终数组，处理重复名称
        var depArr = _.map(departmentInfos, function (user) {
          var truncatedName = _this5.truncateString(user.name); // 截断 name
          var truncatedParentName = _this5.truncateString(user.parentName); // 截断 parentName

          var finalName = truncatedName; // 默认名称

          // 如果名称重复，拼接 parentName/name
          if (nameCount[truncatedName] > 1) {
            finalName = "".concat(truncatedParentName, "/").concat(truncatedName);
          }

          // 再次截断最终名称（防止拼接后超长）
          // finalName = this.truncateString(finalName);

          return _this5.initParticipantInfo({
            id: user.id,
            type: _MDParticipantInfo["default"].DEP_TYPE,
            name: finalName
          });
        });
        userArr = userArr.concat(groupInfosArr).concat(depArr);
        _this5.contactListView.show();
        _this5.contactListView.setUserList(userArr);
        _this5.navigationWindowView && _this5.navigationWindowView.refreshWindow();
      });
    }, 400);
  }
});
var _default = exports["default"] = MDEnterpriseShareTabView;

},{"106":106,"1184":1184,"1412":1412,"1417":1417,"1418":1418,"1426":1426,"1429":1429,"1436":1436,"1439":1439,"1454":1454,"1463":1463,"1498":1498,"1537":1537,"1541":1541,"1546":1546,"22":22,"272":272,"276":276,"277":277,"32":32,"344":344,"50":50,"65":65,"672":672,"673":673,"674":674,"676":676,"677":677,"753":753,"82":82}],753:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1438);
require(1417);
require(1463);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDPaginationView = _interopRequireDefault(require(61));
var _MDPopupView2 = _interopRequireDefault(require(64));
var _popupPos = _interopRequireDefault(require(65));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 *  Create by jichao
 *  2026-3-24
 */
var MDOneGroupPopupView = exports["default"] = /*#__PURE__*/function (_MDPopupView) {
  (0, _inherits2["default"])(MDOneGroupPopupView, _MDPopupView);
  function MDOneGroupPopupView() {
    (0, _classCallCheck2["default"])(this, MDOneGroupPopupView);
    return _callSuper(this, MDOneGroupPopupView, arguments);
  }
  (0, _createClass2["default"])(MDOneGroupPopupView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n    <div class=\"header flex-align middle  between\">\n      <div class=\"boldfont2 text-hide\"><%=groupName%></div>\n      <div class=\"new-icon ic-close no-shrink icon30 close\"></div>\n    </div>\n\n    <div class=\"user-list-block users-list\"></div>\n    <div class=\"page-bar-block\"></div>\n    ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneGroupPopupView.prototype), "className", this).call(this);
      return "".concat(superCls, " one-group-popup");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneGroupPopupView.prototype), "events", this).call(this);
      return _.extend(superE, {
        // "click .copy": this._copy,
        // "click .copy-all": this._copyAll,
        "click .close": this._close,
        "click .group-icon": this.showGroupPopup,
        "click .group-item .name": this.showGroupPopup,
        'mousedown .header': this.onMouseDown,
        // 在 header 上按下鼠标，开始拖动
        'mousedown .close': this.preventDefault // 在 header 上按下鼠标，开始拖动
      });
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneGroupPopupView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        pageSize: 5,
        startIndex: 0,
        gapX: -5,
        gapY: -5,
        autoCloseWhenClickOutside: false
      });
    }
  }, {
    key: "render",
    value: function render(data) {
      data.groupName = this.groupName + "--" + BabelStr.str(2531);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneGroupPopupView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneGroupPopupView.prototype), "initialize", this).call(this, props);
      this.renderPageBar();
      this._renderForPage(0);
    }
  }, {
    key: "preventDefault",
    value: function preventDefault($e) {
      $e.stopPropagation();
      $e.preventDefault();
    }
    // 鼠标移动事件（更新弹窗位置）
    // **注意**：由于 mousemove 可能在 document 级别触发，我们需要在 render 或 initialize 后绑定
  }, {
    key: "startListeningToMouseMove",
    value: function startListeningToMouseMove() {
      $(document).on('mousemove', this.onMouseMove.bind(this));
      $(document).on('mouseup', this.onMouseUp.bind(this));
    }

    // 停止监听鼠标事件（防止内存泄漏）
  }, {
    key: "stopListeningToMouseMove",
    value: function stopListeningToMouseMove() {
      $(document).off('mousemove', this.onMouseMove);
      $(document).off('mouseup', this.onMouseUp);
    }
    // 鼠标按下事件（开始拖动）
  }, {
    key: "onMouseDown",
    value: function onMouseDown(e) {
      this.isDragging = true;

      // 计算鼠标相对于弹窗左上角的偏移
      this.offsetX = e.offsetX;
      this.offsetY = e.offsetY;
      // 阻止默认行为（防止文本选中）
      e.preventDefault();
    }
    // 鼠标移动时的处理逻辑
  }, {
    key: "onMouseMove",
    value: function onMouseMove(e) {
      if (!this.isDragging) return;
      var mouseX = e.clientX;
      var mouseY = e.clientY;

      // 计算弹窗的新位置，考虑边界情况
      var popupWidth = this.$el.outerWidth();
      var popupHeight = this.$el.outerHeight();
      var windowWidth = $(window).width();
      var windowHeight = $(window).height();
      var left = mouseX - this.offsetX;
      var top = mouseY - this.offsetY;

      // 限制弹窗在视口内
      left = Math.max(0, Math.min(left, windowWidth - popupWidth));
      top = Math.max(0, Math.min(top, windowHeight - popupHeight));

      // 更新弹窗位置
      this.$el.css({
        left: left + 'px',
        top: top + 'px'
      });
    }
    // 鼠标释放，停止拖动
  }, {
    key: "onMouseUp",
    value: function onMouseUp() {
      this.isDragging = false;
    }
  }, {
    key: "showGroupPopup",
    value: function showGroupPopup($e) {
      var $btn = $($e.target).parents(".uset-item-comp.group-item").find(".group-icon");
      if ($btn.hasClass("with-popup")) {
        var view = $btn.data("popupView");
        view.close();
        return;
      }
      var $item = $btn.closest(".uset-item-comp");
      var id = $item.data("id");
      MDOneGroupPopupView.show({
        groupName: $item.find(".name").text(),
        triggerView: $btn,
        direction: _popupPos["default"].TOP_LEFT,
        groupId: id
        // $container: this.getNavigationView().$el
      });
    }
  }, {
    key: "renderPageBar",
    value: function renderPageBar() {
      var _this = this;
      this.pageBarView = new _MDPaginationView["default"]({
        enableStepButton: true,
        showJumpToPage: false,
        silentInit: true,
        showSelectSizeList: false,
        align: 'left',
        pageSize: this.pageSize,
        onPageChanged: function onPageChanged(curPageIndex) {
          _this._renderForPage(curPageIndex);
        }
      });
      this.addSubView(this.pageBarView, this.$(".page-bar-block")[0]);
    }
  }, {
    key: "_renderForPage",
    value: function _renderForPage(index) {
      var _this2 = this;
      this.startIndex = index * this.pageSize;
      MMEnterpriseController.getGroupMembers(this.groupId, this.startIndex, this.pageSize, function (users, totalCount) {
        console.log(users);
        if (!users || !users.length) {
          _this2.$('.user-list-block').html("<div class=\"empty f-tc pdtb-20\">".concat(BabelStr.str(7184), "</div>"));
          _this2.$(".page-bar-block").hide();
        } else {
          _this2.$('.user-list-block').show();
          if (totalCount > 5) {
            _this2.$(".page-bar-block").show();
          }
          _this2.curPageIndex = index;
          _this2.totalCount = totalCount;
          _this2.renderUserList(users);
          _this2.pageBarView.setLength(totalCount, true, _this2.startIndex);
          _this2.layout();
        }
      }, function () {});
    }
  }, {
    key: "renderUserList",
    value: function renderUserList(users) {
      var $contain = this.$(".users-list");
      $contain.find('.remove').off();
      $contain.empty();
      var canRemove = false;
      var tmpl = '';
      _.each(users, function (user) {
        if (user.get("userType") == 2) {
          tmpl = user.getGroupItemAsUserHtmlStr({
            canRemove: false,
            cls: " group-item"
          });
        } else {
          tmpl = user.getUserItemHtmlStr({
            canRemove: false
          });
        }
        $contain.append(tmpl);
      });
      $contain.find(".group-item .group-icon").attr("data-tooltip", BabelStr.str(2578));
      $contain.find(".group-item .name").attr("data-tooltip", BabelStr.str(2578));
    }
  }, {
    key: "_close",
    value: function _close() {
      this.close();
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneGroupPopupView.prototype), "viewDidRendered", this).call(this);
      this.startListeningToMouseMove();
    }
  }, {
    key: "viewWillUnRendered",
    value: function viewWillUnRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneGroupPopupView.prototype), "viewWillUnRendered", this).call(this);
      this.stopListeningToMouseMove();
    }
  }]);
  return MDOneGroupPopupView;
}(_MDPopupView2["default"]);
_.extend(MDOneGroupPopupView, {
  instance: null,
  show: function show(opt) {
    // if (MDOneGroupPopupView.instance) {
    //   MDOneGroupPopupView.instance.close();
    // }
    var op = new MDOneGroupPopupView(opt);

    // MDOneGroupPopupView.instance = op;
    op.show({
      triggerView: opt.triggerView,
      center: true,
      width: opt.width ? opt.width : 400
    });
    return op;
  }
  // ,
  // close: function () {
  //   if (MDOneGroupPopupView.instance) {
  //     MDOneGroupPopupView.instance.close();
  //     MDOneGroupPopupView.instance = undefined;
  //   }
  // },
});

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1417":1417,"1438":1438,"1454":1454,"1463":1463,"1475":1475,"61":61,"64":64,"65":65}],677:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1436);
require(1546);
require(1439);
var _MDParticipantInfo = _interopRequireDefault(require(276));
var _MDParticipantInfoCollection = _interopRequireDefault(require(277));
var _MDTabPanelView = _interopRequireDefault(require(81));
var _MDMolaUser = _interopRequireDefault(require(272));
/**
 *  enterprice share , Frequent Contacts List
 *  Created jichao
 *  2016/12/17
 */

var MDFrequentContactsListView = _MDTabPanelView["default"].extend({
  tmpl: '<ul class="share-frequent-contacts-list users-list"></ul>',
  initProps: function initProps() {
    var superP = _MDTabPanelView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      contactList: [],
      selectedUser: null,
      notIncludeGuest: false
      // allParticipantInfoCollection: new MDParticipantInfoCollection()
    });
  },
  events: function events() {
    var superE = _MDTabPanelView["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click .item': this.clickUserItemHandle
    });
  },
  initialize: function initialize(opt) {
    _MDTabPanelView["default"].prototype.initialize.call(this, opt);
    var contactList = app.application.contactList ? app.application.contactList.toJSON() : [];
    this.setFrequentUserList(contactList);
  },
  setFrequentUserList: function setFrequentUserList(contactList) {
    var self = this;
    if (this.notIncludeGuest) {
      for (var i = 0; i < contactList.length; i++) {
        var contact = contactList[i];
        if (!contact['guest']) {
          this.contactList.push(contact);
        }
      }
    } else {
      this.contactList = contactList;
    }
    this.initContactList(this.contactList); //molauserCollection只在显示时用到，组件内部数据交互使用MDParticipantInfoCollection
  },
  initContactList: function initContactList(contactList) {
    var str = "";
    var temp = "";
    if (contactList.length > 0) {
      for (var i = 0; i < contactList.length; i++) {
        var userInfo = new _MDMolaUser["default"](contactList[i]);
        str += userInfo.getUserItemHtmlStr();
      }
      this.$(".share-frequent-contacts-list").html(str);
      this.$(".list-item img").imageLoader();
    } else {
      // this.$(".share-frequent-contacts-list").html('<div class="no-right-fre">暂无人员</div>');
    }
  },
  clickUserItemHandle: function clickUserItemHandle($e) {
    var index = $($e.target).closest(".item").index();
    var user = this.contactList[index];
    this.selectedUser = _MDParticipantInfo["default"].createParticipantInfo({
      id: user["userId"],
      type: _MDParticipantInfo["default"].USER_TYPE,
      name: user["name"],
      email: user["originalEmail"],
      phone: user["phone"],
      guest: user["guest"]
    });
    this.checkUser([this.selectedUser]);
  }
});
var _default = exports["default"] = MDFrequentContactsListView;

},{"1184":1184,"1436":1436,"1439":1439,"1454":1454,"1546":1546,"272":272,"276":276,"277":277,"81":81}],676:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1417);
require(1463);
var _MDParticipantInfo = _interopRequireDefault(require(276));
var _MDParticipantInfoCollection = _interopRequireDefault(require(277));
var _MDTabPanelView = _interopRequireDefault(require(81));
var _MDMolaUser = _interopRequireDefault(require(272));
/**
 *  choose role
 *  Created jichao
 *  2019.3.13
*/

var MDEpRolelistTabView = _MDTabPanelView["default"].extend({
  tmpl: '<ul class="role-list"></ul>',
  initProps: function initProps() {
    var superP = _MDTabPanelView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      roles: []
      // allParticipantInfoCollection: new MDParticipantInfoCollection()
    });
  },
  events: function events() {
    var superE = _MDTabPanelView["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click .item': this.clickRoleItemHandle
    });
  },
  initialize: function initialize(opt) {
    _MDTabPanelView["default"].prototype.initialize.call(this, opt);
    this.getRole();
  },
  getRole: function getRole() {
    var _this = this;
    MMEnterpriseController.roleAndUsers.getAllDepartmentRoles(function (roles) {
      _this.renderRoles(roles);
      _this.roles = [];
      _.each(roles, function (role) {
        var participantInfo = _MDParticipantInfo["default"].createParticipantInfo({
          id: role.get("id"),
          type: _MDParticipantInfo["default"].ROLE_TYPE,
          name: role.getName()
        });
        // this.allParticipantInfoCollection.add(participantInfo);
        _this.roles.push(participantInfo);
      });
    });
  },
  renderRoles: function renderRoles(roles) {
    var str = "";
    var temp = "";
    if (roles.length > 0) {
      for (var i = 0; i < roles.length; i++) {
        str += "<li class=\"item\" data-id=\"".concat(roles[i].getId(), "\">").concat(roles[i].getName(), "</li>");
      }
      this.$(".role-list").html(str);
    } else {}
  },
  clickRoleItemHandle: function clickRoleItemHandle($e) {
    var id = $($e.target).closest(".item").data("id");
    var user = _.find(this.roles, function (role) {
      return role.participantId() == id;
    });
    this.checkUser([user]);
  }
});
var _default = exports["default"] = MDEpRolelistTabView;

},{"1184":1184,"1412":1412,"1417":1417,"1454":1454,"1463":1463,"272":272,"276":276,"277":277,"81":81}],674:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require(1199));
var _asyncToGenerator2 = _interopRequireDefault(require(1172));
require(1415);
require(1463);
require(1421);
require(1439);
require(1412);
var _MDParticipantInfoCollection = _interopRequireDefault(require(277));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDParticipantInfo = _interopRequireDefault(require(276));
var _MDTabPanelView = _interopRequireDefault(require(81));
var _regexp = _interopRequireDefault(require(106));
var _MDAlertView = _interopRequireDefault(require(32));
/**
 *  enterprice share panel,group tree
 *  Created by jichao
 *  2016.12.14
 */

var MDEnterpriseGroupTreeView = _MDTabPanelView["default"].extend({
  tmpl: ' <div class="dep-tree ep-group-tree"> </div>',
  initProps: function initProps() {
    var superP = _MDTabPanelView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      onChange: _.noop,
      canSelGroup: true,
      jsTreeDataArray: [],
      //jsTree组件所需要的数据
      participantInfoArr: [],
      //不能使用userCollection 相同的id(originalEmail,外部需求),不同的jsTreeId(jstree显示需求)  即同一个用户再不同的部门下
      checkedMembers: [],
      //每次点击所选择的的用户，只记录本次操作
      childrenArr: [],
      isSelectOnlyInEp: false,
      excludeGroupIds: []
    });
  },
  events: function events() {
    var superE = _MDTabPanelView["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click .check-all': this.checkAllMembers,
      'click .jstree-anchor': this.checkMembers
    });
  },
  initialize: function initialize(opt) {
    _MDTabPanelView["default"].prototype.initialize.call(this, opt);
    this.bindSelf(this.checkMembers);
    this.getGroupsAndMembersICanSee();
  },
  initDepTree: function initDepTree() {
    if (this.jsTreeDataArray.length) {
      var self = this;
      this.$('.ep-group-tree').on("changed.jstree", function (e, data) {
        self.onChange(data);
      }).jstree({
        "plugins": ["search", "conditionalselect", "types"],
        'core': {
          'data': this.jsTreeDataArray,
          "themes": {
            "dblclick_toggle": true,
            "icons": false,
            "dots": false // no connecting dots between dots
          }
        }
      });
    } else {
      this.$('.ep-group-tree').append($('<div class="no-right-ent">' + BabelStr.str(5046) + '</div>'));
    }
  },
  checkAllMembers: function checkAllMembers($e) {
    this.checkedMembers = [];
    $e.stopPropagation();
    var self = this;
    var curId = $($e.target).closest(".jstree-node").attr("id");
    this.childrenArr = this.$(".ep-group-tree").jstree().get_node(curId)["children_d"];
    if (this.childrenArr.length > 30) {
      var alert = new _MDAlertView["default"]();
      alert.show({
        title: BabelStr.str(170),
        message: "<p class=\"title\">".concat(BabelStr.str(5045), "</p>"),
        className: 'm-delAlertWin',
        width: 470,
        hideCloseBtn: true,
        buttons: [{
          label: BabelStr.str(154),
          type: 'done',
          onClick: function onClick() {
            self.checkAllMembersCallback();
          }
        }, {
          label: BabelStr.str(155)
        }]
      });
    } else {
      self.checkAllMembersCallback();
    }
  },
  checkAllMembersCallback: function checkAllMembersCallback() {
    var self = this;
    for (var i = 0; i < this.childrenArr.length; i++) {
      var id = this.childrenArr[i];
      _.each(this.participantInfoArr, function (user) {
        if (id == user.get("jsTreeId") && user.isUser()) {
          self.checkedMembers.push(user);
        }
      });
    }
    this.checkUser(this.checkedMembers);
  },
  checkMembers: function checkMembers($e) {
    var self = this;
    this.checkedMembers = [];
    $e.stopPropagation();
    var id = $($e.target).closest(".jstree-node").attr("id");
    this.checkedMembers = _.filter(this.participantInfoArr, function (user) {
      return id == user.get("jsTreeId");
    });
    if (self.checkedMembers.length > 0) {
      this.checkUser(this.checkedMembers);
    }
  },
  getGroupsAndMembersICanSee: function () {
    var _getGroupsAndMembersICanSee = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var _this = this;
      var out, groupsArr;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            console.log("getGroups 调用了一次");
            _context.prev = 1;
            _context.next = 4;
            return _MMEnterpriseController["default"].dedupGetGroups();
          case 4:
            out = _context.sent;
            groupsArr = out.groupsArr;
            _.each(groupsArr, function (group) {
              if (_this.isSelectOnlyInEp) {
                if (group.groupId === "privateGroup") {
                  return; // 跳过私人分组
                }
              }

              // 添加分组到 jsTree 数据
              var dataItem = {
                id: group["groupId"],
                parent: "#",
                text: '<span class="dep-name text-hide">' + group["groupName"] + '</span>'
              };
              _this.jsTreeDataArray.push(dataItem);

              // 处理分组下的成员
              _.each(group["groupMembers"], function (memberGroup) {
                // 排除指定分组
                if (_this.excludeGroupIds.indexOf(memberGroup["groupId"]) > -1) {
                  console.log("排除" + memberGroup["groupName"]);
                  return;
                }

                // 格式化分组数据
                memberGroup["parent"] = group["groupId"];
                memberGroup["id"] = memberGroup["groupId"];
                memberGroup["text"] = '<span class="dep-name text-hide">' + memberGroup["groupName"] + '</span>' + '<span class="check-all f-fr">' + BabelStr.str(2611) + '</span>';
                _this.jsTreeDataArray.push(memberGroup);

                // 初始化分组参与者信息
                var newGroup = _this.initParticipantInfo({
                  id: memberGroup["id"],
                  type: _MDParticipantInfo["default"].GROUP_TYPE,
                  name: memberGroup["groupName"],
                  belongToEnterprise: memberGroup.belongToEnterprise
                });
                newGroup.set("jsTreeId", memberGroup["groupId"]);
                if (_this.canSelGroup) {
                  _this.participantInfoArr.push(newGroup);
                }

                // 处理组成员
                _.each(memberGroup["groupMembers"], function (member) {
                  if (!member || _this.notIncludeGuest && member['guest']) {
                    return; // 跳过无效成员或访客
                  }

                  // 初始化用户参与者信息
                  var participantInfo = _this.initParticipantInfo({
                    id: member["id"],
                    type: _MDParticipantInfo["default"].USER_TYPE,
                    name: member["name"],
                    email: member["email"],
                    phone: member["phone"],
                    guest: member["guest"]
                  });

                  // 构建用户显示 HTML
                  var str = "\n              <div class=\"member flex-align middle\">\n                <div class=\"no-shrink img\">\n                  <img src=\"".concat(participantInfo.getAvatarImageURL(), "\" alt=\"\"\n                       onerror='this.src=\"img/avatar/anonymous.jpg\"'>\n                </div>\n                <div class=\"text-hide no-shrink name\">").concat(participantInfo.name(), "</div>\n                <div class=\"text-hide fullfill mail\">").concat(participantInfo.getAccount(), "</div>\n              </div>");

                  // 添加用户到 jsTree 数据
                  var jsTreeUserItem = {
                    id: participantInfo.participantId() + "_" + memberGroup["groupId"],
                    parent: memberGroup["groupId"],
                    email: participantInfo.mail(),
                    originalEmail: participantInfo.originalEmail(),
                    text: str
                  };
                  participantInfo.set("jsTreeId", jsTreeUserItem.id);
                  _this.jsTreeDataArray.push(jsTreeUserItem);
                  _this.participantInfoArr.push(participantInfo);
                });

                // 处理部门成员（如果允许选择部门）
                if (!_this.canSelDepartment) {
                  return;
                }
                _.each(memberGroup["departmentMembers"], function (member) {
                  if (!member || _this.notIncludeGuest && member['guest']) {
                    return; // 跳过无效成员或访客
                  }

                  // 初始化部门参与者信息
                  var participantInfo = _this.initParticipantInfo({
                    id: member["id"],
                    type: _MDParticipantInfo["default"].DEP_TYPE,
                    name: member["name"]
                  });

                  // 构建部门显示 HTML
                  var str = "\n              <div class=\"member flex-align middle\">\n                <div class=\"no-shrink img\">\n                  <div class=\"dep-icon\"></div>\n                </div>\n                <div class=\"text-hide no-shrink name\">".concat(participantInfo.name(), "</div>\n              </div>");

                  // 添加部门到 jsTree 数据
                  var jsTreeUserItem = {
                    id: participantInfo.participantId() + "_" + memberGroup["groupId"],
                    parent: memberGroup["groupId"],
                    email: participantInfo.mail(),
                    originalEmail: participantInfo.originalEmail(),
                    text: str
                  };
                  participantInfo.set("jsTreeId", jsTreeUserItem.id);
                  _this.jsTreeDataArray.push(jsTreeUserItem);
                  _this.participantInfoArr.push(participantInfo);
                });
              });
            });

            // 初始化部门树
            this.initDepTree();
            _context.next = 13;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](1);
            console.error("获取分组和成员失败:", _context.t0);
            // 这里可以添加错误处理逻辑，如显示错误提示等
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, this, [[1, 10]]);
    }));
    function getGroupsAndMembersICanSee() {
      return _getGroupsAndMembersICanSee.apply(this, arguments);
    }
    return getGroupsAndMembersICanSee;
  }()
});
var _default = exports["default"] = MDEnterpriseGroupTreeView;

},{"106":106,"1098":1098,"1172":1172,"1184":1184,"1199":1199,"1412":1412,"1415":1415,"1421":1421,"1439":1439,"1454":1454,"1463":1463,"276":276,"277":277,"32":32,"81":81}],673:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require(1199));
var _asyncToGenerator2 = _interopRequireDefault(require(1172));
var _MDParticipantInfo = _interopRequireDefault(require(276));
var _MDParticipantInfoCollection = _interopRequireDefault(require(277));
var _MDTabPanelView = _interopRequireDefault(require(81));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _utils = _interopRequireDefault(require(108));
/**
 *  enterprice share ,outsiders list panel
 *  Created jichao
 *  2016/12/17
 */

var MDEnterpriceOutsidersListView = _MDTabPanelView["default"].extend({
  tmpl: '<ul class="share-guest-members-list users-list"></ul>',
  initProps: function initProps() {
    var superP = _MDTabPanelView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      userCollection: new _MDMolaUserCollection["default"](),
      selectedUser: null
    });
  },
  events: function events() {
    var superE = _MDTabPanelView["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click .item': this.clickItemGuestHandle
    });
  },
  initialize: function initialize(opt) {
    _MDTabPanelView["default"].prototype.initialize.call(this, opt);
    this.bindSelf(this.initdata);
    this.getAllGuestUser();
  },
  initdata: function initdata(userCollection) {
    var user = null;
    if (userCollection.length) {
      var str = "";
      for (var i = 0; i < userCollection.length; i++) {
        user = userCollection.at(i);
        str += user.getUserItemHtmlStr();
      }
      this.$(".share-guest-members-list").html(str);
      this.$('.item-guest>img').imageLoader();
    } else {
      var promptStr = BabelStr.str(7276);
      if (this.guestStatus == 1) {
        promptStr = BabelStr.str(7277);
      } else if (this.guestStatus == 2) {
        promptStr = BabelStr.str(7278);
      }
      this.$('.share-guest-members-list').append($('<div class="no-right-out">' + promptStr + '</div>'));
    }
  },
  clickItemGuestHandle: function clickItemGuestHandle($e) {
    var index = $($e.target).closest(".item").index();
    var user = this.userCollection.at(index);
    var participantInfo = this.initParticipantInfo({
      id: user.get("id"),
      type: _MDParticipantInfo["default"].USER_TYPE,
      name: user.get("name"),
      email: user.get("email"),
      phone: user.get("phone"),
      guest: 1
    });
    this.checkUser([participantInfo]);
  },
  getAllGuestUser: function () {
    var _getAllGuestUser = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var self, _yield$MMEnterpriseCo, members, status;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            self = this;
            _context.prev = 1;
            console.log("getGuestICanSee 调用了一次");
            _context.next = 5;
            return _MMEnterpriseController["default"].dedupGetGuestICanSee();
          case 5:
            _yield$MMEnterpriseCo = _context.sent;
            members = _yield$MMEnterpriseCo.members;
            status = _yield$MMEnterpriseCo.status;
            self.guestStatus = status;
            self.initdata(members);
            self.userCollection = members;
            _context.next = 18;
            break;
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](1);
            console.error('Failed to fetch guest data:', _context.t0);
            self.guestStatus = -1;
            self.userCollection = null;
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, this, [[1, 13]]);
    }));
    function getAllGuestUser() {
      return _getAllGuestUser.apply(this, arguments);
    }
    return getAllGuestUser;
  }()
});
var _default = exports["default"] = MDEnterpriceOutsidersListView;

},{"108":108,"1098":1098,"1172":1172,"1184":1184,"1199":1199,"1454":1454,"273":273,"276":276,"277":277,"81":81}],672:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1415);
require(1463);
require(1421);
require(1426);
require(1418);
require(1537);
require(1439);
require(1412);
var _MDTabPanelView = _interopRequireDefault(require(81));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _regexp = _interopRequireDefault(require(106));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDParticipantInfo = _interopRequireDefault(require(276));
var _MDParticipantInfoCollection = _interopRequireDefault(require(277));
/**
 *  enterprice share panel,department tree
 *  Created by jichao
 *  2016.12.14
 */

var MDEnterpriceDepartmentTreeView = _MDTabPanelView["default"].extend({
  tmpl: ' <div class="dep-tree" id="shareDepTree"> </div>',
  initProps: function initProps() {
    var superP = _MDTabPanelView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      onChange: _.noop,
      jsTreeDataArray: [],
      childrenArr: [],
      participantInfoArr: [],
      checkedMembers: [],
      rootId: -1,
      canSelDepartment: true,
      canSelectDepUser: true,
      initDepIds: [],
      allParticipantInfoCollection: new _MDParticipantInfoCollection["default"]()
    });
  },
  events: function events() {
    var superE = _MDTabPanelView["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click .check-all': this.checkAllMembers,
      'click .jstree-anchor': this.checkMembers,
      'keydown .check-all': this.stopPropagation
    });
  },
  initialize: function initialize(opt) {
    _MDTabPanelView["default"].prototype.initialize.call(this, opt);
    this.bindSelf(this.checkMembers);
    // this.getDepartmentAndMembersICanSee();
    this.initDepTree();
  },
  stopPropagation: function stopPropagation($e) {
    $e.stopPropagation();
  },
  initDepTree: function initDepTree() {
    var self = this;
    this.$('#shareDepTree').on("changed.jstree", function (e, data) {
      self.onChange(data);
    }).on("after_open.jstree", function (e, data) {
      self.navigationWindowView && self.navigationWindowView.refreshWindow();
    }).jstree({
      "plugins": ["search", "conditionalselect", "types"],
      'core': {
        'data': function data(node, cb) {
          var id = node.id;
          if (node.id == '#') {
            id = "0";
          }
          console.log("GetDepartmentMembersAndSubDep 调用了一次");
          _MMEnterpriseController["default"].dedupGetDepartmentMembersAndSubDep(id) // 调用 Promise 版本
          .then(function (depart) {
            var nodes = self._transformJstreeNode(depart, id);
            cb(nodes); // 成功时返回数据
          })["catch"](function (error) {
            console.error("加载部门数据失败:", error);
            cb([]); // 失败时返回空数组（避免 jstree 报错）
          });
        },
        "themes": {
          "dblclick_toggle": true,
          "icons": false,
          "dots": false // no connecting dots between dots
        }
      }
    });
  },
  checkAllMembers: function checkAllMembers($e) {
    this.checkedMembers = [];
    $e.stopPropagation();
    var self = this;
    var curId = $($e.target).closest(".jstree-node").attr("id");
    this.childrenArr = this.$("#shareDepTree").jstree().get_node(curId)["children"];
    if (this.childrenArr.length > 30) {
      var alert = new _MDAlertView["default"]();
      alert.show({
        title: BabelStr.str(170),
        message: "<p class=\"title\">".concat(BabelStr.str(5045), "</p>"),
        className: 'm-delAlertWin',
        width: 470,
        hideCloseBtn: true,
        buttons: [{
          label: BabelStr.str(154),
          type: 'done',
          onClick: function onClick() {
            self.checkAllMembersCallback();
          }
        }, {
          label: BabelStr.str(155)
        }]
      });
    } else {
      self.checkAllMembersCallback();
    }
  },
  checkAllMembersCallback: function checkAllMembersCallback() {
    var self = this;
    for (var i = 0; i < this.childrenArr.length; i++) {
      var id = this.childrenArr[i];
      _.each(this.participantInfoArr, function (participantInfo) {
        if (id == participantInfo.get("jsTreeId") && participantInfo.isUser()) {
          self.checkedMembers.push(participantInfo);
        }
      });
    }
    this.checkUser(this.checkedMembers);
  },
  checkMembers: function checkMembers($e) {
    var self = this;
    this.checkedMembers = [];
    $e.stopPropagation();
    var id = $($e.target).closest(".jstree-node").attr("id");
    this.checkedMembers = _.filter(this.participantInfoArr, function (participantInfo) {
      return id == participantInfo.get("jsTreeId");
    });
    if (self.checkedMembers.length > 0) {
      this.checkUser(this.checkedMembers);
    }
  },
  setSelectsByDepId: function setSelectsByDepId(deps) {
    if (!deps.length) {
      return;
    }
    this.checkedMembers = _.filter(this.participantInfoArr, function (participantInfo) {
      var id = participantInfo.get("jsTreeId");
      return _.indexOf(deps, id) > -1;
    });
    this.checkUser(this.checkedMembers);
    if (!this.checkedMembers.length) {
      this.initDepIds = deps;
    }
  },
  getDepartmentAndMembersICanSee: function getDepartmentAndMembersICanSee() {
    var self = this;

    //由于企业成员一般数据量大，先从缓存中取数据
    if (window.mola_epId == app.ep.getEpID() && window.mola_departments) {
      this._initializeWithDepartments(window.mola_departments);
    } else {
      _MMEnterpriseController["default"].department.getDepartmentAndMembersICanSee(function (departments) {
        // 由于企业成员一般数据量大，并且变化不是很频繁，因此缓存之
        window.mola_epId = app.ep.getEpID();
        window.mola_departments = departments;
        self._initializeWithDepartments(departments);
      }, function () {});
    }
  },
  _initializeWithDepartments: function _initializeWithDepartments(departments) {
    var self = this;
    var str = '';
    self.departments = departments;
    var departmentIds = departments.map(function (department) {
      return department["id"];
    });
    departments.forEach(function (department) {
      department["text"] = '<span class = "dep-name text-hide">' + department["name"] + '</span>';
      if (self.canSelectDepUser) {
        department["text"] += '<span class="check-all f-fr">' + BabelStr.str(2611) + '</span>';
      }
      if (_.indexOf(departmentIds, department["parent"]) === -1) {
        department["parent"] = "#";
        department["state"] = {
          "opened": true
        };
        self.rootId = department["id"];
      }
      var depId = department['id'];
      department.isDep = true;
      self.jsTreeDataArray.push(department);
      var members = department["members"];
      var participantinfoCollection = new _MDParticipantInfoCollection["default"]();
      if (self.canSelectDepUser) {
        var id = department["id"];
        var userId, img, email, userName, originalEmail;
        _.each(members, function (member) {
          var participantInfo = self.initParticipantInfo({
            id: member["userId"],
            type: _MDParticipantInfo["default"].USER_TYPE,
            name: ember["name"],
            email: member["email"],
            phone: member["phone"],
            roleName: member["roleName"]
          });
          str = "<div class = \"member flex-align middle\" >\n                    <div class=\"no-shrink img\" >\n                      <img  src=\"".concat(participantInfo.getAvatarImageURL(), "\" alt=\"\" onerror='this.src=\"img/avatar/anonymous.jpg\"'>\n                    </div>\n                    <div class=\"text-hide no-shrink name\">").concat(participantInfo.name(), "</div>\n                    <div class =\"text-hide fullfill mail \">").concat(participantInfo.getAccount(), "</div>\n                    <div class =\"text-hide fullfill rolename \">").concat(participantInfo.roleName(), "</div>\n                </div>");
          var dataItem = {
            "id": participantInfo.participantId() + '_' + depId,
            // 注意 id 为 userId 与所属部门的 departmentId 组成的 29291293123_9
            "email": participantInfo.mail(),
            'originalEmail': participantInfo.originalEmail(),
            "parent": id,
            "text": str
          };
          participantInfo.set("jsTreeId", participantInfo.participantId() + '_' + depId);
          self.jsTreeDataArray.push(dataItem);
          self.participantInfoArr.push(participantInfo);
          participantinfoCollection.add(participantInfo);
        });
      }
      if (self.canSelDepartment) var dep = self.initParticipantInfo({
        id: department["id"],
        type: _MDParticipantInfo["default"].DEP_TYPE,
        name: department["name"]
      });
      dep.set("jsTreeId", department["id"]);
      self.participantInfoArr.push(dep);
      participantinfoCollection.add(dep);
      self.allParticipantInfoCollection.add(participantinfoCollection.models);
    });
    self.initDepTree();
    self.setSelectsByDepId(this.initDepIds);
  },
  _transformJstreeNode: function _transformJstreeNode(department, parentId) {
    var self = this;
    var str = '';
    var nodeArr = [];
    var childDepartments = department.childDepartments;
    _.each(childDepartments, function (child) {
      child["text"] = '<span class = "dep-name text-hide">' + child["name"] + '</span>';
      if (self.canSelectDepUser) {
        child["text"] += '<span class="check-all f-fr">' + BabelStr.str(2611) + '</span>';
      }
      if (parentId == '0') {
        child["parent"] = "#";
        child["state"] = {
          "opened": true
        };
        self.rootId = child["id"];
      }
      child.children = true;
      child.isDep = true;
      nodeArr.push(child);
      if (self.canSelDepartment) {
        var dep = self.initParticipantInfo({
          id: child["id"],
          type: _MDParticipantInfo["default"].DEP_TYPE,
          name: child["name"]
        });
        dep.set("jsTreeId", child["id"]);
        self.participantInfoArr.push(dep);
      }
    });
    var members = department["members"];
    if (self.canSelectDepUser) {
      // var id = department["id"];
      var userId, img, email, userName, originalEmail;
      _.each(members, function (member) {
        var participantInfo = self.initParticipantInfo({
          id: member["userId"],
          type: _MDParticipantInfo["default"].USER_TYPE,
          name: member["userName"],
          email: member["email"],
          phone: member["phone"],
          roleName: member["roleName"]
        });
        // <div class="no-shrink img" >
        //   <img  src="${participantInfo.getAvatarImageURL()}" alt="" onerror=\'this.src="img/avatar/anonymous.jpg"\'>
        // </div>
        str = "<div class = \"member flex-align middle\" >\n                  <div class=\"text-hide no-shrink name\">".concat(participantInfo.name(), "</div>\n                  <div class =\"text-hide fullfill mail \">").concat(participantInfo.getAccount(), "</div>\n                  <div class =\"text-hide fullfill rolename \">").concat(participantInfo.roleName(), "</div>\n              </div>");
        var dataItem = {
          "id": participantInfo.participantId() + '_' + parentId,
          // 注意 id 为 userId 与所属部门的 departmentId 组成的 29291293123_9
          "email": participantInfo.mail(),
          'originalEmail': participantInfo.originalEmail(),
          "parent": parentId,
          "text": str
        };
        participantInfo.set("jsTreeId", participantInfo.participantId() + '_' + parentId);
        nodeArr.push(dataItem);
        self.participantInfoArr.push(participantInfo);
      });
    }
    return nodeArr;

    // self.initDepTree();
    // self.setSelectsByDepId(this.initDepIds)
  }
});
var _default = exports["default"] = MDEnterpriceDepartmentTreeView;

},{"106":106,"1098":1098,"1184":1184,"1412":1412,"1415":1415,"1418":1418,"1421":1421,"1426":1426,"1439":1439,"1454":1454,"1463":1463,"1537":1537,"276":276,"277":277,"32":32,"81":81}],344:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1436);
require(1546);
var _MDMolaUser = _interopRequireDefault(require(272));
var _MDParticipantInfoCollection = _interopRequireDefault(require(277));
var _MDParticipantInfo = _interopRequireDefault(require(276));
var _MMViewBase = _interopRequireDefault(require(22));
/**
 *  人员列表
 *  Created jiang
 *  2017/10/11
 */

var MDUserListView = _MMViewBase["default"].extend({
  el: '<div class="userlist-panel shadow4 border1"></div>',
  tmpl: '<ul class="share-frequent-contacts-list users-list"></ul>',
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      userList: [],
      selectedUser: null,
      emptySearchStr: BabelStr.str(3456),
      allParticipantInfoCollection: new _MDParticipantInfoCollection["default"]()
    });
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      'mousedown .item': this.clickUserItemHandle
    });
  },
  initialize: function initialize(opt) {
    var _this = this;
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.userList = opt.userList ? opt.userList : [];
    this.setUserList(this.userList);
    var self = this;
    $('body').on('click.userlist' + this.winId, function () {
      self.hide();
    });
    if (this.maxHeight) {
      this.$el.css('max-height', this.maxHeight + 'px');
      this.$el.css('overflow', 'auto');
    }
    ;
    document.addEventListener('keydown', function (event) {
      var $items = _this.$('.users-list .item');
      var $active = _this.$('.users-list .item.checked');
      var currentIndex = $active.index();
      var nextIndex = 0;
      if (event.key === 'ArrowUp') {
        if (currentIndex > 0) {
          nextIndex = currentIndex - 1;
        } else {
          nextIndex = $items.length - 1;
        }
        $items.removeClass("checked");
        $items.eq(nextIndex).addClass("checked");
        console.log("ArrowUp");
      } else if (event.key === 'ArrowDown') {
        if (currentIndex < $items.length - 1) {
          nextIndex = currentIndex + 1;
        } else {
          nextIndex = 0;
        }
        $items.removeClass("checked");
        $items.eq(nextIndex).addClass("checked");
        console.log("ArrowDown");
      }
    });
  },
  getUserList: function getUserList() {
    return this.userList;
  },
  getSelectedUser: function getSelectedUser() {
    var $checked = this.$('.users-list .item.checked');
    var user, id;
    if ($checked.length > 0) {
      id = $checked.data("id");
      user = _.find(this.userList, function (item) {
        return item.get("participantId") == id;
      });
    }
    if (user) {
      return user;
    } else {
      return null;
    }
  },
  setUserList: function setUserList(userList) {
    var self = this;
    this.originList = userList;
    this.userList = userList;
    this.initUserList(userList); //molauserCollection只在显示时用到，组件内部数据交互使用MDParticipantInfoCollection
  },
  initUserList: function initUserList(userList) {
    var str = "";
    var temp = "";
    var tempObj = {};
    var uniqArr = [];
    _.each(userList, function (item) {
      tempObj[item.get('participantId')] = item;
    });
    for (var key in tempObj) {
      uniqArr.push(tempObj[key]);
    }
    userList = uniqArr;
    this.userList = uniqArr;
    if (userList.length > 0) {
      for (var i = 0; i < userList.length; i++) {
        var userInfo = new _MDMolaUser["default"](userList[i].toJSON());
        userInfo.set("email", userInfo.get("mail"));
        userInfo.set("id", userInfo.get("participantId"));
        str += userInfo.getUserItemHtmlStr({
          noImg: true,
          typeIcon: true
        });
      }
      this.$(".share-frequent-contacts-list").html(str);
      // this.$(".list-item img").imageLoader();
    } else {
      this.$(".share-frequent-contacts-list").html("<div class=\"no-right-fre mgl-10\">".concat(this.emptySearchStr, "</div>"));
    }
    console.log("initUserList");
  },
  clickUserItemHandle: function clickUserItemHandle($e) {
    var index = $($e.target).closest(".item").index();
    var user = this.userList[index];
    this.checkUser([user]);
  },
  searchUser: function searchUser(key) {
    this.userList = [];
    for (var i = 0; i < this.originList.length; i++) {
      var user = this.originList[i];
      if (user.includeString(key)) {
        this.userList.push(user);
        user.set('userId', user.get('participantId'));
      }
      ;
    }
    ;
    this.initUserList(this.userList);
  },
  remove: function remove(param) {
    _MMViewBase["default"].prototype.remove.call(this, param);
    $('body').off('click.userlist' + this.winId);
  }
});
var _default = exports["default"] = MDUserListView;

},{"1184":1184,"1417":1417,"1436":1436,"1454":1454,"1463":1463,"1546":1546,"22":22,"272":272,"276":276,"277":277}],277:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDParticipantInfo = _interopRequireDefault(require(276));
var _MMCollectionBase = _interopRequireDefault(require(20));
var MDParticipantInfoCollection = _MMCollectionBase["default"].extend({
  model: _MDParticipantInfo["default"]
}, {
  createFromUserCollection: function createFromUserCollection(userCollection) {
    var participantCollection = new MDParticipantInfoCollection();
    var users = userCollection.models ? userCollection.models : userCollection;
    _.each(users, function (userInfo) {
      var pInfo = _MDParticipantInfo["default"].createFromUser(userInfo);
      participantCollection.push(pInfo);
    });
    return participantCollection;
  },
  createFromRoleCollection: function createFromRoleCollection(roles) {
    var participantCollection = new MDParticipantInfoCollection();
    _.each(roles, function (role) {
      var pInfo = _MDParticipantInfo["default"].createFromRole(role);
      participantCollection.push(pInfo);
    });
    return participantCollection;
  },
  createFromGroupCollection: function createFromGroupCollection(groups) {
    var participantCollection = new MDParticipantInfoCollection();
    _.each(groups, function (group) {
      var pInfo = _MDParticipantInfo["default"].createFromGroup(group);
      participantCollection.push(pInfo);
    });
    return participantCollection;
  },
  createFromDepCollection: function createFromDepCollection(deps) {
    var participantCollection = new MDParticipantInfoCollection();
    _.each(deps, function (dep) {
      var pInfo = _MDParticipantInfo["default"].createFromDep(dep);
      participantCollection.push(pInfo);
    });
    return participantCollection;
  },
  createFromMsgReciver: function createFromMsgReciver(data) {
    var participantCollection = new MDParticipantInfoCollection();
    _.each(data, function (item) {
      var pInfo = _MDParticipantInfo["default"].createFromMsgReciver(item);
      participantCollection.push(pInfo);
    });
    return participantCollection;
  }
});
var _default = exports["default"] = MDParticipantInfoCollection;

},{"1184":1184,"1454":1454,"20":20,"276":276}],276:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1439);
require(1421);
require(1437);
var _regexp = _interopRequireDefault(require(106));
var _MMModelBase = _interopRequireDefault(require(21));
// MDParticipantInfo.js
// jiang
// 2017-7-11
//

var MDParticipantInfo = _MMModelBase["default"].extend({
  defaults: {
    "recordId": 0,
    "participantId": 0,
    // -------------- 参与者 id
    "participantType": null,
    "name": "",
    // -------------- 参与者 name
    "mail": "",
    "originalEmail": "",
    "phone": '',
    "roleName": '',
    "registered": 0,
    'guest': 0
  },
  participantId: function participantId() {
    return this.get('participantId');
  },
  isBelongToEnterprise: function isBelongToEnterprise() {
    return this.get("belongToEnterprise");
  },
  isCurrentUser: function isCurrentUser() {
    return this.get('participantId') == app.currentUser.getUserId();
  },
  participantType: function participantType() {
    return this.get('participantType');
  },
  isGuest: function isGuest() {
    return this.get("guest");
  },
  name: function name() {
    return this.get('name');
  },
  roleName: function roleName() {
    return this.get('roleName');
  },
  mail: function mail() {
    var email = this.get('mail');
    if (!_regexp["default"].isEmail(email)) {
      email = '--';
    }
    return email;
  },
  originalEmail: function originalEmail() {
    return this.get('originalEmail');
  },
  phone: function phone() {
    return this.get('phone');
  },
  isUser: function isUser() {
    return this.participantType() == MDParticipantInfo.USER_TYPE;
  },
  isDep: function isDep() {
    return this.participantType() == MDParticipantInfo.DEP_TYPE;
  },
  isGroup: function isGroup() {
    return this.participantType() == MDParticipantInfo.GROUP_TYPE;
  },
  isRole: function isRole() {
    return this.participantType() == MDParticipantInfo.GROUP_TYPE;
  },
  setParticipantType: function setParticipantType(type) {
    this.set('participantType', type);
  },
  setParticipantId: function setParticipantId(id) {
    this.set('participantId', id);
  },
  setName: function setName(name) {
    this.set('name', name);
  },
  setMail: function setMail(mail) {
    this.set('mail', mail);
    this.set('originalEmail', mail);
  },
  setPhone: function setPhone(phone) {
    this.set('phone', phone);
  },
  setRoleName: function setRoleName(name) {
    this.set('roleName', name);
  },
  setRegistered: function setRegistered(registered) {
    this.set("registered", registered);
  },
  isActivedUser: function isActivedUser() {
    return this.get('registered');
  },
  getAccount: function getAccount() {
    var email = this.originalEmail();
    if (!_regexp["default"].isEmail(email)) {
      email = this.phone();
      if (!email) {
        email = "";
      }
    }
    return email;
  },
  includeString: function includeString(str) {
    var name = this.name();
    var account = this.getAccount();
    return name.indexOf(str) != -1 || account.indexOf(str) != -1;
  },
  getAvatarImageURL: function getAvatarImageURL(size, notForce) {
    if (!this.isUser()) {
      return;
    }
    var userId = this.participantId();
    size = size ? size : 80;
    var t = new Date().getTime();
    if (notForce) {
      t = Math.floor(new Date().getTime() / 36000000); // 1 小时内不刷新
    }
    ;
    if (userId == -1) {
      return 'img/avatar/anonymous.jpg';
    }
    return "/user/getUserAvatar.do?userId=" + userId + "&t=" + t + "&size=" + size;
  }
}, {
  USER_TYPE: 0,
  DEP_TYPE: 1,
  GROUP_TYPE: 2,
  ERROR: -1,
  ROLE_TYPE: 10,
  createFromUser: function createFromUser(userInfo) {
    var info = new MDParticipantInfo({
      'participantId': userInfo.getUserId ? userInfo.getUserId() : userInfo.userId,
      'participantType': 0,
      'name': userInfo.getUserName ? userInfo.getUserName() : userInfo.name,
      'mail': userInfo.getEmail ? userInfo.getEmail() : user.email || '',
      'phone': userInfo.getPhone ? userInfo.getPhone() : user.phone || '',
      'guest': userInfo.isEnterpriseGuest ? userInfo.isEnterpriseGuest() : user.guest || 0
    });
    return info;
  },
  createFromMsgReciver: function createFromMsgReciver(item) {
    var info = new MDParticipantInfo({
      'participantId': item.targetId,
      'participantType': item.targetType,
      'name': item.name || '',
      'mail': item.email || ''
    });
    return info;
  },
  createFromDep: function createFromDep(dep) {
    var info = new MDParticipantInfo({
      'participantId': dep.id,
      'participantType': 1,
      'name': dep.name,
      'mail': ''
    });
    return info;
  },
  createFromRole: function createFromRole(role) {
    var info = new MDParticipantInfo({
      'participantId': role.roleId,
      'participantType': 10,
      'name': role.name,
      'mail': ''
    });
    return info;
  },
  createFromGroup: function createFromGroup(group) {
    var info = new MDParticipantInfo({
      'participantId': group.id || group.groupId,
      'participantType': 2,
      'name': group.groupName || group.name,
      'mail': '',
      belongToEnterprise: group.belongToEnterprise
    });
    return info;
  },
  createParticipantInfo: function createParticipantInfo(params) {
    var id = params.id,
      type = params.type,
      name = params.name,
      email = params.email,
      phone = params.phone,
      roleName = params.roleName,
      registered = params.registered,
      guest = params.guest,
      belongToEnterprise = params.belongToEnterprise;
    var participantInfo = new MDParticipantInfo();
    participantInfo.setParticipantId(id);
    participantInfo.setParticipantType(type);
    if (_regexp["default"].isPhone(phone)) {
      participantInfo.setPhone(phone);
      if (_regexp["default"].isEmail(email)) {
        participantInfo.setMail(email);
      }
      if (name == "未注册用户" || name == BabelStr.str(710)) {
        participantInfo.setName(phone);
      } else {
        participantInfo.setName(name);
      }
    } else {
      participantInfo.setMail(email);
      if (name == "未注册用户" || name == BabelStr.str(710)) {
        participantInfo.setName(email);
      } else {
        participantInfo.setName(name);
      }
    }
    participantInfo.set('belongToEnterprise', belongToEnterprise);
    participantInfo.set('roleName', roleName);
    participantInfo.set('guest', guest);
    participantInfo.setRegistered(registered);
    return participantInfo;
  }
});
var _default = exports["default"] = MDParticipantInfo;

},{"106":106,"1184":1184,"1421":1421,"1437":1437,"1439":1439,"1454":1454,"21":21}],197:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1421);
require(1541);
var _defineProperty2 = _interopRequireDefault(require(1180));
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMViewBase2 = _interopRequireDefault(require(22));
var _MDPaginationView = _interopRequireDefault(require(61));
var _MEStaffSearchTableView = _interopRequireDefault(require(199));
var _MEStaffSearchPanelView = _interopRequireDefault(require(124));
var _MEDepRoleSelectView = _interopRequireDefault(require(189));
var _MEDepartChooseView = _interopRequireDefault(require(138));
var _MDChooserView2 = _interopRequireDefault(require(38));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDMessageView = _interopRequireDefault(require(55));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MEStaffSearchPanelView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MEStaffSearchPanelView, _MMViewBase);
  function MEStaffSearchPanelView() {
    (0, _classCallCheck2["default"])(this, MEStaffSearchPanelView);
    return _callSuper(this, MEStaffSearchPanelView, arguments);
  }
  (0, _createClass2["default"])(MEStaffSearchPanelView, [{
    key: "el",
    value: function el() {
      return "<div class=\"m-search-panel\"></div>";
    }
  }, {
    key: "tmpl",
    value: function tmpl() {
      return _MEStaffSearchPanelView["default"];
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStaffSearchPanelView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "input .search-box input": this._inputChangeHandler
      });
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStaffSearchPanelView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        singleSelection: false,
        includeNumberInfo: true,
        _startIndex: 0,
        _pageSize: 10,
        maxInputNumber: 50,
        pageSizePos: "bottom",
        $input: null,
        _conditions: {
          departmentId: undefined,
          roleId: undefined,
          userType: 0,
          keyName: undefined,
          startIndex: 0,
          pageSize: 10
        },
        onLoadSuccess: _.noop,
        onLoadFail: _.noop,
        chooseChangeCb: _.noop,
        onConditionChanged: _.noop,
        userType: 0,
        needRole: false,
        //是否需要选择角色

        roleId: "",
        //设置默认的部门角色

        needFreeze: true,
        disabledDepChoose: false,
        initLoaded: true,
        disabledChooseEpOwnder: false,
        chooseEpOwnderTip: "",
        disabledChooseCurUser: false,
        chooseCurUserTip: ""
      });
    }
    /**
     *
     * @callback ChooseChangeCallback
     * @param {Array.<MDMolaUser>} persons - 选中的人员数组
     */
    /**
     *
     * @param {object} opt
     * @param {boolean} singleSelection - 是否单选
     * @param {ChooseChangeCallback} chooseChangeCb - 选择回调
     *
     */
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStaffSearchPanelView.prototype), "initialize", this).call(this, props);
      if (!props.needFreeze) {
        this._conditions.status = 0;
      }
      this._conditions.excludeDepId = this.excludeDepId;
      this._conditions.userType = this.userType;
      this.tableView = new _MEStaffSearchTableView["default"]({
        singleSelect: this.singleSelection,
        enableDragSelection: false,
        onRowSelectionChanged: function onRowSelectionChanged(selectedModels) {
          _this._onRowSelectionChanged(selectedModels);
        }
      });
      this.addSubView(this.tableView, this.$(".table-wrap")[0]);
      this.paginationBarView = new _MDPaginationView["default"]({
        silentInit: true,
        pageSize: this._pageSize,
        currentPage: 0,
        stepOffset: 3,
        pageSizePos: this.pageSizePos,
        onPageChanged: function onPageChanged(curPageIndex) {
          _this._onPaginationChanged(curPageIndex);
        },
        onPageSizeChanged: function onPageSizeChanged(newPageSize) {
          _this._pageSize = newPageSize;
          _this._conditions["pageSize"] = newPageSize;
          _this._conditions["startIndex"] = 0;
          _this.searchPersons();
        }
      });
      this.paginationBarView.hide();
      this.addSubView(this.paginationBarView, this.$(".table-wrap")[0]);
      this.roleSelectView = new _MEDepRoleSelectView["default"]({
        silentInit: true,
        needAllRole: true,
        onChange: function onChange(role) {
          var roleId = role.getId();
          _this._conditions["roleId"] = roleId;
          _this.initStartIndex();
          _this.searchPersons();
        }
      });
      this.addSubView(this.roleSelectView, this.$("#js-roleSlot")[0], true);
      if (app.currentUser.canLoginEpManagePage() || app.currentUser.get("isShowingStructor")) {
        this.departView = new _MEDepartChooseView["default"]({
          readonly: true,
          needRoot: true,
          disabledDepChoose: this.disabledDepChoose,
          onChange: function onChange(node) {
            var departId = node["id"];
            _this._conditions["departmentId"] = departId;
            _this.initStartIndex();
            _this.searchPersons();
          }
        });
        this.addSubView(this.departView, this.$("#js-departSlot")[0], true);
      } else {
        // this.$(".role-block").removeClass("col-3").addClass("col-6");
        this.$(".dep-block").hide();
      }
      this.chooserView = new _MDChooserView2["default"]((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({
        textField: "name",
        placeholder: "",
        autoChoose: false,
        blurToChoose: true,
        keepText: false,
        maxInputNumber: this.maxInputNumber,
        enableAutoFilter: true,
        backspaceOnceToRemove: true,
        allowInput: false,
        refuseInvalidInput: true,
        disabled: true
      }, "placeholder", BabelStr.str(3444)), "dataEqual", function dataEqual(userPre, userCur) {
        return userPre.getUserId() === userCur.getUserId();
      }), "onChange", function onChange(newChooseText) {
        var chooseItems = _this.chooserView.getChosen();
        _this._onChooserChanged(chooseItems);
        _this.chooseChangeCb(chooseItems);
        _this.$("#js-add-num").text(chooseItems.length);
      }), "chosenItemRenderer", function chosenItemRenderer(user) {
        return "<a>" + user.getUserName() + "</a>";
      }));
      this.addSubView(this.chooserView, this.$("#js-chooserSlot"), true);
      this.$input = this.$(".search-box input");
      if (this.needRole) {
        this.depRoleSelectView = new _MEDepRoleSelectView["default"]({
          silentInit: true,
          needNoRole: true,
          onChange: function onChange(role) {
            _this.roleId = role.getId();
            if (_this.roleId) {
              _this.$(".error-text").hide();
            }
          },
          onReady: function onReady() {}
        });
        this.addSubView(this.depRoleSelectView, this.$("#js-depRoleSlot")[0], true);
      } else {
        this.$("#js-depRoleSlot").hide();
      }
    }
  }, {
    key: "_onChooserChanged",
    value: function _onChooserChanged(selectedUsers) {
      var tableBodyView = this.tableView.getBodyView();
      tableBodyView.eachSubViews(function (tableRowView) {
        var user = tableRowView.rowModel;
        var selected = _.find(selectedUsers, function (molaUser) {
          if (molaUser.getUserId() === user.getUserId()) {
            return true;
          }
        });
        selected = !!selected;
        tableRowView.setSelected(selected);
      });
    }
  }, {
    key: "_onRowSelectionChanged",
    value: function _onRowSelectionChanged(selectedUsers) {
      var _this2 = this;
      var self = this;
      var tableDataCollection = this.tableView.getDataCollection();
      var chooseItems = [];
      var curSelected = [];
      if (this.singleSelection) {
        this.chooserView.clear(true);
        this.chooserView.addChoose(selectedUsers[0], true);
        chooseItems = this.chooserView.getChosen();
        curSelected = chooseItems;
      } else {
        var choosedUsers = this.chooserView.getChosen();
        tableDataCollection.each(function (user) {
          var preSelectIds = [];
          var preHasChoosed = _.find(choosedUsers, function (molaUser) {
            if (molaUser.getUserId() === user.getUserId()) {
              preSelectIds.push(user.getUserId());
              return true;
            }
          });
          var thisTimeHasChoosed = _.find(selectedUsers, function (molaUser) {
            if (molaUser.getUserId() === user.getUserId()) {
              if (_.indexOf(preSelectIds, user.getUserId()) < 0) {
                curSelected.push(user);
              }
              return true;
            }
          });
          //
          // 之前已选中，本次未选中，删除之前选中
          //
          if (!thisTimeHasChoosed) {
            _this2.chooserView.removeChoose(user, true);
          }
        });
        _.each(selectedUsers, function (user) {
          _this2.chooserView.addChoose(user, true);
        });
        chooseItems = this.chooserView.getChosen();
      }
      this.$("#js-add-num").text(chooseItems.length);
      this.chooseChangeCb(chooseItems);
      setTimeout(function () {
        //确保选择回调执行完
        if (!_this2.disabledChooseEpOwnder && !_this2.disabledChooseCurUser) {
          return;
        }
        _.each(curSelected, function (itemUser) {
          if (_this2.disabledChooseEpOwnder && app.ep.getOwnerId() == itemUser.getUserId()) {
            _MDMessageView["default"].error(_this2.chooseEpOwnderTip, _this2.$el);
            self.removeUserFromSelected(itemUser);
          } else if (_this2.disabledChooseCurUser && itemUser.getUserId() == app.currentUser.getUserId()) {
            var alert = new _MDAlertView["default"]();
            alert.show({
              title: BabelStr.str(170),
              message: '<p class="title">' + _this2.chooseCurUserTip + "</p>",
              hideCloseBtn: true,
              buttons: [{
                label: BabelStr.str(154),
                type: "done"
              }, {
                label: BabelStr.str(155),
                type: "done",
                onClick: function onClick() {
                  self.removeUserFromSelected(itemUser);
                }
              }]
            });
          }
        });
      });
    }
  }, {
    key: "removeUserFromSelected",
    value: function removeUserFromSelected(removeUser) {
      var tableBodyView = this.tableView.getBodyView();
      tableBodyView.eachSubViews(function (tableRowView) {
        var user = tableRowView.rowModel;
        if (user.getUserId() == removeUser.getUserId()) {
          tableRowView.setSelected(false);
        }
      });
    }
  }, {
    key: "_inputChangeHandler",
    value: function _inputChangeHandler() {
      var text = this.$input.val();
      this._conditions["keyName"] = text;
      this.initStartIndex();
      this.searchPersons();
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStaffSearchPanelView.prototype), "viewDidRendered", this).call(this);
      if (this.initLoaded) {
        this.searchPersons();
      } else {
        //渲染blank
        var userCollection = new _MDMolaUserCollection["default"]();
        this.tableView.setDataCollection(userCollection, false, true);
      }
    }
  }, {
    key: "initStartIndex",
    value: function initStartIndex() {
      this._conditions["startIndex"] = 0;
    }
  }, {
    key: "searchPersons",
    value: function searchPersons() {
      var _this3 = this;
      this.paginationBarView.$el.css("visibility", "hidden");
      var net = _MMEnterpriseController["default"];
      this.tableView.startLoadingState();
      net.searchEntperiseUsers(this._conditions, function (members, total) {
        var length = members.length;
        _this3.paginationBarView.setLength(total, true, _this3._conditions["startIndex"]);
        if (length > 0) {
          _this3.paginationBarView.show();
          _this3.paginationBarView.$el.css("visibility", "visible");
        }
        var userCollection = new _MDMolaUserCollection["default"](members);
        _this3.tableView.setDataCollection(userCollection, false, true);
        _this3.tableView.clearLoadingState();
        _this3.onLoadSuccess();
        _this3._checkTableRowSelection();
        _this3.onConditionChanged();
      }, function () {});
    }
  }, {
    key: "getSearchedPersons",
    value: function getSearchedPersons() {
      return this.chooserView.getChosen();
    }
  }, {
    key: "getSelectedRoleId",
    value: function getSelectedRoleId() {
      return this.roleId;
    }
  }, {
    key: "validate",
    value: function validate() {
      if (this.needRole && !this.roleId) {
        this.$(".error-text").show();
        if (document.querySelector(".g-window")) {
          document.querySelector(".g-window").scrollTop = 0;
        }
        return false;
      }
      return true;
    }
  }, {
    key: "_checkTableRowSelection",
    value: function _checkTableRowSelection() {
      var selectedUsers = this.chooserView.getChosen();
      var tableBodyView = this.tableView.getBodyView();
      tableBodyView.eachSubViews(function (tableRowView) {
        var user = tableRowView.rowModel;
        var selected = _.find(selectedUsers, function (molaUser) {
          if (molaUser && molaUser.getUserId() === user.getUserId()) {
            return true;
          }
        });
        selected = !!selected;
        var originSelected = tableRowView.isSelected();
        if (selected != originSelected) {
          tableRowView.setSelected(selected, true);
        }
      });
    }
  }, {
    key: "_onPaginationChanged",
    value: function _onPaginationChanged(curIndex) {
      this._conditions["startIndex"] = curIndex * this._pageSize;
      this.searchPersons();
    }
  }, {
    key: "render",
    value: function render() {
      var tip = "";
      if (!this.singleSelection) {
        var param = {
          max: this.maxInputNumber,
          num: '<span id="js-add-num">0</span>'
        };
        tip = BabelStr.str(649, param); // 一次最多添加
      }
      var data = {
        maxInputNumber: this.maxInputNumber,
        includeNumberInfo: this.includeNumberInfo,
        placeholder: BabelStr.str(579),
        // 搜索姓名/邮箱
        selected: BabelStr.str(3268),
        // 已选择
        caption: tip // 一次最多添加<%=maxInputNumber%>个，已添加<span id="js-add-num">0</span>个
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStaffSearchPanelView.prototype), "render", this).call(this, data);
    }
  }]);
  return MEStaffSearchPanelView;
}(_MMViewBase2["default"]);

},{"1098":1098,"1175":1175,"1179":1179,"1180":1180,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"124":124,"138":138,"1417":1417,"1421":1421,"1454":1454,"1463":1463,"1475":1475,"1541":1541,"189":189,"199":199,"22":22,"273":273,"32":32,"38":38,"55":55,"61":61}],199:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMModelBase = _interopRequireDefault(require(21));
var _MDTableView2 = _interopRequireDefault(require(89));
var _MEStaffSearchTableRowView = _interopRequireDefault(require(198));
var _StaffSearchWindowEmptyTable = _interopRequireDefault(require(126));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 *  员工信息table
 *  Created by dai
 *  2016.12.6
 */
var MEStaffSearchTableView = exports["default"] = /*#__PURE__*/function (_MDTableView) {
  (0, _inherits2["default"])(MEStaffSearchTableView, _MDTableView);
  function MEStaffSearchTableView() {
    (0, _classCallCheck2["default"])(this, MEStaffSearchTableView);
    return _callSuper(this, MEStaffSearchTableView, arguments);
  }
  (0, _createClass2["default"])(MEStaffSearchTableView, [{
    key: "emptyTmpl",
    value: function emptyTmpl() {
      return "<div class=\"m-empty page-empty\" style=\"display: block;padding: 19px 0;\">\n              <p class=\"title\">".concat(BabelStr.str(3126), "</p>\n              <p class=\"info\">").concat(BabelStr.str(3127), "</p>\n            </div>");
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStaffSearchTableView.prototype), "className", this).call(this);
      return "".concat(superCls, " table-striped staff-search-table");
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props = _.extend({
        blankRenderer: function blankRenderer() {
          return _this.emptyTmpl();
        },
        bodyCls: 'userRows',
        rowCls: 'row',
        headerCls: 'headerWrapper',
        rowClass: _MEStaffSearchTableRowView["default"],
        unSelectRowWhenClickOutside: false,
        columns: [{
          name: BabelStr.str(3128),
          dataIndex: 'name',
          flex: 1,
          cellCls: 'name-col'
        }]
      }, props);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStaffSearchTableView.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "setSelectedModels",
    value: function setSelectedModels(selectedUsers) {
      this.selectedUsers = selectedUsers;
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MEStaffSearchTableView';
    }
  }]);
  return MEStaffSearchTableView;
}(_MDTableView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"126":126,"1412":1412,"1454":1454,"1463":1463,"1475":1475,"198":198,"21":21,"89":89}],198:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTableRowView2 = _interopRequireDefault(require(88));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MEStaffSearchTableRowView = exports["default"] = /*#__PURE__*/function (_MDTableRowView) {
  (0, _inherits2["default"])(MEStaffSearchTableRowView, _MDTableRowView);
  function MEStaffSearchTableRowView() {
    (0, _classCallCheck2["default"])(this, MEStaffSearchTableRowView);
    return _callSuper(this, MEStaffSearchTableRowView, arguments);
  }
  (0, _createClass2["default"])(MEStaffSearchTableRowView, [{
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStaffSearchTableRowView.prototype), "initProps", this).call(this);
      var mgr = BabelStr.str(72); // 管理员
      return _.extend(superP, {
        userInfo: null,
        columnRenders: function columnRenders() {
          return [{
            dataIndex: 'name',
            cellCls: 'name-col',
            render: function render(name, userInfo, index) {
              var name = userInfo.get('name');
              var mail = userInfo.getAccount();
              var isAdmin = userInfo.get('isAdmin');
              var isGuest = userInfo.isEnterpriseGuest();
              var renderStr = "";
              renderStr += "<img src=\"".concat(userInfo.getAvatarImageURL(), "\"  class=\"avatar s36\" />\n                             <span class=\"name blue\">").concat(name, "</span>\n                             <span class=\"email\">(").concat(mail, ")</span>");
              if (isAdmin) {
                renderStr += '<span class="admin">' + mgr + '</span>';
              }
              if (isGuest) {
                renderStr += "<span class=\"button done mgl-10 small\">".concat(BabelStr.str(382), "</span>");
              }
              return renderStr;
            }
          }];
        }
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStaffSearchTableRowView.prototype), "events", this).call(this);
      return _.extend(superE, {});
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStaffSearchTableRowView.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEStaffSearchTableRowView.prototype), "viewDidRendered", this).call(this);
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MEStaffSearchTableRowView';
    }
  }]);
  return MEStaffSearchTableRowView;
}(_MDTableRowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1454":1454,"1463":1463,"1475":1475,"88":88}],143:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1426);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MMViewBase = _interopRequireDefault(require(22));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MEDepartChooseView = _interopRequireDefault(require(138));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDSpinnerloaderLayerView = _interopRequireDefault(require(75));
var _MEDepRoleSelectView = _interopRequireDefault(require(189));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 *  window to  edit department  /*enterprise
 *  Created by jichao
 *  2016.12.6
 */
var MEEditDepartmentView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MEEditDepartmentView, _MDWindowView);
  function MEEditDepartmentView() {
    (0, _classCallCheck2["default"])(this, MEEditDepartmentView);
    return _callSuper(this, MEEditDepartmentView, arguments);
  }
  (0, _createClass2["default"])(MEEditDepartmentView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n      <div class=\"contain\">\n        <div class=\"container-fluid\"><div class = num><%=numStr%></div></div>\n        <div class=\"container-fluid names-container\">\n          <div class = \"names\">\n            <% for(var i = 0 ; i < persons.length ; i++){%>\n              <span class=\"name\"><%=persons[i]['name']%></span>\n            <%}%>\n          </div>\n        </div>\n        <div class=\"container-fluid\">\n          <form action=\"\">\n            <div class=\"form-item row\">\n              <div class=\"col-20 txt-r\"><label><%=parentDepStr%>\uFF1A</label></div>\n              <div id = \"select\" class=\"col-80\"></div>\n            </div>\n            <div class=\"form-item row\">\n              <div class=\"col-20 txt-r\"><label><%=roleStr%>\uFF1A</label></div>\n              <div id = \"select\" class=\"col-80\"><div id=\"js-roleSlot\"></div></div>\n            </div>\n          </form>\n        </div>\n      </div>";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEEditDepartmentView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        ids: [],
        newDepartmentId: null,
        departmentId: null,
        onSuccess: _.noop,
        data: [{
          name: "employee1",
          id: "1"
        }]
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEEditDepartmentView.prototype), "className", this).call(this);
      return "".concat(superCls, " editDepartment");
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      var _this = this;
      opt.title = _MDLocalString["default"].getLocalString(3118);
      opt.buttons = [{
        type: 'done',
        label: _MDLocalString["default"].getLocalString(3119),
        autoClose: false,
        onClick: function onClick() {
          self.submit();
        }
      }, {
        type: 'cancel',
        label: _MDLocalString["default"].getLocalString(3081),
        autoClose: true
      }];
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEEditDepartmentView.prototype), "initialize", this).call(this, opt);
      var self = this;
      this.departChooserView = new _MEDepartChooseView["default"]({
        needAddDefault: false,
        placeholder: _MDLocalString["default"].getLocalString(3097),
        readonly: true,
        needRoot: true,
        onReady: function onReady() {
          var departNodes = _this.departChooserView.getAllDepartmentNode();
          var selectDepartID = departNodes[0] && departNodes[0]['id'];
          _this.departChooserView.selectedByDepartId(selectDepartID);
        },
        onChange: function onChange(node) {
          _this.newDepartmentId = node["id"];
        }
      });
      this.addSubView(this.departChooserView, this.$("#select")[0]);
      var selectView = new _MEDepRoleSelectView["default"]({
        needNoRole: false,
        silentInit: false,
        onChange: function onChange(role) {
          _this.roleId = role.getId();
        }
      });
      this.addSubView(selectView, this.$('#js-roleSlot')[0], true);
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        'persons': this.data,
        'parentDepStr': _MDLocalString["default"].getLocalString(3085),
        'roleStr': _MDLocalString["default"].getLocalString(3086),
        'numStr': _MDLocalString["default"].getLocalString(3117, {
          length: this.data.length
        })
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEEditDepartmentView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "submit",
    value: function submit() {
      var _this2 = this;
      this.setDisabled(true);
      _MDSpinnerloaderLayerView["default"].showIn(this.$body);
      var net = _MMEnterpriseController["default"].department;
      var personIds = _.map(this.data, function (person) {
        return person['id'];
      });
      net.moveUsersToDepartment(personIds, this.departmentId, this.newDepartmentId, this.roleId, function () {
        _this2.setDisabled(false);
        _this2.close();
        _this2.onSuccess();
        _MDSpinnerloaderLayerView["default"].clearFrom(_this2.$body);
      }, function () {
        _this2.setDisabled(false);
        _MDSpinnerloaderLayerView["default"].clearFrom(_this2.$body);
      });
    }
  }]);
  return MEEditDepartmentView;
}(_MDWindowView2["default"]);

},{"1098":1098,"1150":1150,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"138":138,"1426":1426,"1454":1454,"1463":1463,"1475":1475,"189":189,"22":22,"75":75,"93":93}],140:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMViewBase2 = _interopRequireDefault(require(22));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MEDepartMemberDownLimitView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MEDepartMemberDownLimitView, _MMViewBase);
  function MEDepartMemberDownLimitView() {
    (0, _classCallCheck2["default"])(this, MEDepartMemberDownLimitView);
    return _callSuper(this, MEDepartMemberDownLimitView, arguments);
  }
  (0, _createClass2["default"])(MEDepartMemberDownLimitView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n      <div class=\"flex-align mgtb-10\">\n        <div class=\"left-item\"><%=BabelStr.str(4845)%></div>\n        <input type=\"text\" class=\"form-control\">\n        <div class=\"right-item\"><%=BabelStr.str(4846)%></div>\n        <div class=\"button done\"><%=BabelStr.str(2345)%></div>\n      </div>\n      <div class=\"flex-align\">\n        <div class=\"left-item\"><%=BabelStr.str(4847)%></div>\n        <input type=\"text\" class=\"form-control\">\n        <div class=\"right-item\"><%=BabelStr.str(4848)%></div>\n        <div class=\"button done\"><%=BabelStr.str(2345)%></div>        \n      </div>\n      <div class=\"help-inline\"><%=BabelStr.str(4849)%></div>\n    ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEDepartMemberDownLimitView.prototype), "className", this).call(this);
      return "".concat(superCls, " dep-member-down-limit mgt-10");
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEDepartMemberDownLimitView.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEDepartMemberDownLimitView.prototype), "viewDidRendered", this).call(this);
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MEDepartMemberDownLimitView';
    }
  }]);
  return MEDepartMemberDownLimitView;
}(_MMViewBase2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"22":22}],591:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MDNavigationPageView2 = _interopRequireDefault(require(56));
var _MDFilelogListView = _interopRequireDefault(require(585));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 * pageView  , the users in myshare
 *  Created by jichao
 *  2017.5.2
 */
var MDOneUserFileLogPageView = exports["default"] = /*#__PURE__*/function (_MDNavigationPageView) {
  (0, _inherits2["default"])(MDOneUserFileLogPageView, _MDNavigationPageView);
  function MDOneUserFileLogPageView() {
    (0, _classCallCheck2["default"])(this, MDOneUserFileLogPageView);
    return _callSuper(this, MDOneUserFileLogPageView, arguments);
  }
  (0, _createClass2["default"])(MDOneUserFileLogPageView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n      <div class = \"header user-contain\">\n\n      </div>\n      <div class=\"share-file-block\">\n        <div class=\"header\">\n          <div><%=BabelStr.str(7187)%>(<span class=\"access-num\">0</span>)</div>\n          <div class = \"file-list-ope\" data-opened = true><%=BabelStr.str(3219)%></div>\n        </div>\n        <div class=\"share-file-list\"></div>\n      </div>\n\n      <div class=\"search-block log-search-block\">\n        <div><%=BabelStr.str(3575)%></div>\n        <div class=\"select-contain\">\n\n        </div>\n      </div>\n\n      <div class=\"file-log-block\">\n\n      </div>\n    ";
    }
  }, {
    key: "accessUserInfoTmpl",
    value: function accessUserInfoTmpl() {
      return "\n      <div class=\"user-info\">\n        <div class = \"image\">\n          <image class=\"_user-profile-picture\" src = \"<%=src%>\" width=\"100%\" height=\"100%\"></image>\n        </div>\n        <div class=\"info\">\n          <div class=\"name text-hide\"><%=name%></div>\n          <div class=\"email text-hide\"><%=email%></div>\n        </div>\n      </div>\n    ";
    }
  }, {
    key: "anoymousUserTmpl",
    value: function anoymousUserTmpl() {
      return "\n      <div class=\"user-item\">\n        <div class=\"info\">\n          <div class=\"name text-hide\">".concat(BabelStr.str(722), "</div>\n          <div class=\"address text-hide\">ip:<%=ip%></div>\n        </div>\n      </div>\n    ");
    }
  }, {
    key: "fileItemTmpl",
    value: function fileItemTmpl() {
      return "\n      <div class=\"file-item\">\n        <span class=\" icon <%=(isFolder ? 'folder-ic' : 'file-ic')%>\"></span>\n        <span class=\"file-name\"><%=name%></span>\n      </div>\n    ";
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneUserFileLogPageView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .file-list-ope": this._toogleFileList,
        "click .cancle": this.cancle
      });
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneUserFileLogPageView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        isOneFile: false,
        user: app.currentUser,
        pageSize: 6,
        departmentId: "-1",
        dataCollection: [],
        conditionArr: [{
          type: 0,
          name: BabelStr.str(3110)
        }, {
          type: 1,
          name: BabelStr.str(3111)
        }, {
          type: 2,
          name: BabelStr.str(3112)
        }],
        isdep: false,
        userName: "",
        type: 0
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneUserFileLogPageView.prototype), "className", this).call(this);
      return "".concat(superCls, " myshare-log-page");
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      var _this = this;
      opt.title = BabelStr.str(7188);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDOneUserFileLogPageView.prototype), "initialize", this).call(this, opt);
      if (this.isAnonymous) {
        this.renderAnoymousUser();
      } else {
        this.renderAccessUser();
      }
      if (this.isOneFile) {
        this.$(".share-file-block").remove();
        this.$(".search-block").remove();
        this.$el.append("<div class = 'cancle'>" + BabelStr.str(74) + "<div>");
      } else {
        if (this.isdep) {
          this.$(".share-file-block").remove();
        } else {
          this.getAllMyShareUserJoin();
        }
        this.conditionSelectView = new _MDDropdownSelectListView["default"]({
          dataProvider: this.conditionArr,
          labelField: "name",
          onChange: function onChange(obj) {
            _this.pickConditionChanged(obj);
          }
        });
        this.addSubView(this.conditionSelectView, this.$(".select-contain")[0]);
      }
      if (this.isAnonymous) {
        this.$(".share-file-block").remove();
        this.$(".log-search-block").remove();
      }
      this.filelogListView = new _MDFilelogListView["default"]({
        isAccessUser: false,
        refreshFileLog: function refreshFileLog(startIndex, pageSize) {
          _this.pageSize = pageSize;
          _this.refreshFileLog(startIndex);
        }
      });
      this.addSubView(this.filelogListView, this.$(".file-log-block")[0]);
      this.refreshFileLog(0);
    }
  }, {
    key: "renderAnoymousUser",
    value: function renderAnoymousUser() {
      var user = {
        ip: this.user["ip"]
      };
      var contactHtml = _.template(this.anoymousUserTmpl())(user);
      this.$(".user-contain").append(contactHtml);
    }
  }, {
    key: "renderAccessUser",
    value: function renderAccessUser() {
      var user = {
        name: this.user.getUserName(),
        email: this.user.getEmail(),
        src: this.user.getAvatarImageURL()
      };
      var contentTmpl = _.template(this.accessUserInfoTmpl())(user);
      this.$(".user-contain").append(contentTmpl);
    }
  }, {
    key: "renderFileList",
    value: function renderFileList(fileCollection) {
      var _this2 = this;
      var contentTmpl;
      this.$(".access-num").html(fileCollection.length);
      fileCollection.each(function (file) {
        var obj = {
          name: file.getFileName(),
          isFolder: file.isFolder()
        };
        contentTmpl = _.template(_this2.fileItemTmpl())(obj);
        _this2.$(".share-file-list").append(contentTmpl);
      });
    }
  }, {
    key: "getAllMyShareUserJoin",
    value: function getAllMyShareUserJoin() {
      var _this3 = this;
      var userId = this.user["id"];
      _MMNetDiskDataController["default"].getAllMyShareUserJoin(userId, function (fileCollection) {
        _this3.renderFileList(fileCollection);
        if (_this3.navigationWindowView) {
          _this3.navigationWindowView.reLayout();
        }
      }, function () {});
    }
  }, {
    key: "_toogleFileList",
    value: function _toogleFileList() {
      var $tar = this.$(".file-list-ope");
      var $list = this.$(".share-file-list");
      if ($tar.data("opened")) {
        $list.hide();
        $tar.data("opened", false);
        $tar.html(BabelStr.str(7189));
      } else {
        $list.show();
        $tar.data("opened", true);
        $tar.html(BabelStr.str(3219));
      }
      if (this.navigationWindowView) {
        this.navigationWindowView.reLayout();
      }
    }
  }, {
    key: "cancle",
    value: function cancle() {
      this.cancle();
    }
  }, {
    key: "getUserFileLogInShare",
    value: function getUserFileLogInShare(startIndex) {
      var _this4 = this;
      var userId = this.user.getUserId();
      var fileId = this.fileInfor.getFileId();
      _MMNetDiskDataController["default"].getUserFileLogInShare(userId, fileId, startIndex, this.pageSize, this.type, function (logCollection, total) {
        _this4.filelogListView.setLogCollection(logCollection);
        _this4.filelogListView.setLength(total, startIndex);
        if (_this4.navigationWindowView) {
          _this4.navigationWindowView.refreshWindow();
        }
      }, function () {});
    }
  }, {
    key: "getUserFileLogInAllMYShare",
    value: function getUserFileLogInAllMYShare(startIndex) {
      var _this5 = this;
      var userId;
      var sessionId;
      sessionId = this.user["sessionId"];
      userId = this.user["id"] || 0;
      _MMNetDiskDataController["default"].getUserFileLogInAllMyShare(userId, sessionId, startIndex, this.pageSize, this.type, function (logCollection, total) {
        _this5.filelogListView.setLogCollection(logCollection);
        _this5.filelogListView.setLength(total, startIndex);
        if (_this5.navigationWindowView) {
          _this5.navigationWindowView.refreshWindow();
        }
      }, function () {});
    }
  }, {
    key: "refreshFileLog",
    value: function refreshFileLog(startIndex) {
      this.filelogListView.startRenderFileList();
      if (this.isOneFile) {
        this.getUserFileLogInShare(startIndex);
      } else if (this.isdep) {
        this.getDepartmentFileLogByUser(startIndex);
      } else {
        this.getUserFileLogInAllMYShare(startIndex);
      }
    }
  }, {
    key: "getDepartmentFileLogByUser",
    value: function getDepartmentFileLogByUser(startIndex) {
      var _this6 = this;
      var depId = this.department.getId();
      var userId = this.user["id"] || 0;
      var sessionId = this.user["sessionId"];
      _MMEnterpriseController["default"].getDepartmentFileLogByUser(depId, userId, sessionId, startIndex, this.pageSize, this.type, function (logCollection, total) {
        _this6.filelogListView.setLogCollection(logCollection);
        _this6.filelogListView.setLength(total, startIndex);
        if (_this6.navigationWindowView) {
          _this6.navigationWindowView.refreshWindow();
        }
      }, function () {});
    }
  }, {
    key: "pickConditionChanged",
    value: function pickConditionChanged(obj) {
      this.type = obj.type;
      this.filelogListView.startRenderFileList();
      if (this.isdep) {
        this.getDepartmentFileLogByUser(0);
      } else {
        this.getUserFileLogInAllMYShare(0);
      }
    }
  }]);
  return MDOneUserFileLogPageView;
}(_MDNavigationPageView2["default"]);

},{"1098":1098,"1104":1104,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"56":56,"585":585,"67":67}],585:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDSpinnerloaderLayerView = _interopRequireDefault(require(75));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDPaginationView = _interopRequireDefault(require(61));
var _MMViewBase2 = _interopRequireDefault(require(22));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 *  window , file log
 *  Created by jichao
 *  2017.4.27
 */
var MDFilelogListView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MDFilelogListView, _MMViewBase);
  function MDFilelogListView() {
    (0, _classCallCheck2["default"])(this, MDFilelogListView);
    return _callSuper(this, MDFilelogListView, arguments);
  }
  (0, _createClass2["default"])(MDFilelogListView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n      <div class=\"file-log-block\"></div>\n      <div class=\"page-bar\"></div>\n    ";
    }
  }, {
    key: "logItemTmpl",
    value: function logItemTmpl() {
      return "\n    <div class=\"log-item-1\">\n      <div class=\"top-block flex-align between\">\n        <div class=\"name text-hide fullfill\"><%=name%></div>\n        <div class=\"time no-shrink\"><%=time.format(\"yyyy-MM-dd HH:mm\")%></div>\n      </div>\n      <div class=\"log-content\"><%=text%></div>\n    </div>";
    }
  }, {
    key: "logItemTmpl2",
    value: function logItemTmpl2() {
      return "\n    <div class=\"log-item-2 flex-align between\">\n      <div class=\"log-content fullfill\"><%=text%></div>\n      <div class=\"time\"><%=time.format(\"yyyy-MM-dd HH:mm\")%></div>\n    </div>";
    }
  }, {
    key: "emptyTmpl",
    value: function emptyTmpl() {
      return "\n      <div class=\"empty\">\n        <span>".concat(BabelStr.str(7182), "</span>\n      </div>\n    ");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFilelogListView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        // public variable
        isAccessUser: false,
        // private variabel
        pageSize: 6,
        pageBarView: null,
        dataCollection: []
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFilelogListView.prototype), "className", this).call(this);
      return "".concat(superCls, " file-log-list");
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDFilelogListView.prototype), "initialize", this).call(this, opt);
      this.$fileLogBlock = this.$(".file-log-block");
      this.renderPageBar();
    }
  }, {
    key: "setLogCollection",
    value: function setLogCollection(logCollection) {
      this.renderLogItem(logCollection);
    }
  }, {
    key: "setLength",
    value: function setLength(total, startIndex) {
      this.pageBarView.setLength(total, true);
      if (startIndex == 0) {
        this.pageBarView.setCurrentPage(startIndex, true);
      }
    }
  }, {
    key: "startRenderFileList",
    value: function startRenderFileList() {
      _MDSpinnerloaderLayerView["default"].showIn(this.$fileLogBlock[0]);
    }
  }, {
    key: "stopRenderFileList",
    value: function stopRenderFileList() {
      _MDSpinnerloaderLayerView["default"].showIn(this.$fileLogBlock[0]);
    }
  }, {
    key: "showErrorMsg",
    value: function showErrorMsg(msg) {
      this.stopRenderFileList();
      this.$fileLogBlock.html("<div class=\"mgtb-20 pdtb-20 f-tc\">".concat(msg, "</div>"));
    }
  }, {
    key: "renderLogItem",
    value: function renderLogItem(dataCollection) {
      var _this = this;
      this.$fileLogBlock.empty();
      if (dataCollection.length < 1) {
        this.renderEmpty();
        return;
      }
      this.$(".page-bar").show();
      this.$(".m-pagination-bar").show();
      var contactHtml;
      var tmpl;
      if (this.isAccessUser) {
        tmpl = this.logItemTmpl();
      } else {
        tmpl = this.logItemTmpl2();
      }
      dataCollection.each(function (log) {
        var obj = {
          name: log.getUserName(),
          time: log.getTime(),
          text: log.getFormatStr()
        };
        contactHtml = _.template(tmpl)(obj);
        _this.$(".file-log-block").append(contactHtml);
      });
      _MDSpinnerloaderLayerView["default"].clearFrom(this.$fileLogBlock[0]);
    }
  }, {
    key: "renderPageBar",
    value: function renderPageBar() {
      var _this2 = this;
      this.pageBarView = new _MDPaginationView["default"]({
        enableStepButton: true,
        showHeadAndTail: true,
        // showJumpToPage: false,
        silentInit: true,
        pageSizePos: "top",
        // showSelectSizeList: false,
        align: "left",
        pageSize: this.pageSize,
        onPageSizeChanged: function onPageSizeChanged(size) {
          _this2.startIndex = 0;
          _this2.pageSize = size;
          _this2.refreshFileLog(_this2.startIndex, _this2.pageSize);
        },
        onPageChanged: function onPageChanged(curPageIndex) {
          _this2._pageChanged(curPageIndex);
        }
      });
      this.addSubView(this.pageBarView, this.$(".page-bar")[0]);
    }
  }, {
    key: "renderEmpty",
    value: function renderEmpty() {
      var contentTmpl = _.template(this.emptyTmpl());
      this.$(".file-log-block").html(contentTmpl);
      this.$(".page-bar").hide();
    }
  }, {
    key: "_pickConditionChanged",
    value: function _pickConditionChanged() {}
  }, {
    key: "_pageChanged",
    value: function _pageChanged(curPageIndex) {
      this.startIndex = curPageIndex * this.pageSize;
      this.refreshFileLog(this.startIndex, this.pageSize);
    }
  }]);
  return MDFilelogListView;
}(_MMViewBase2["default"]);

},{"1104":1104,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"22":22,"61":61,"75":75}],138:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1432);
require(1426);
require(1421);
require(1477);
require(1493);
require(1439);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDDropdownView2 = _interopRequireDefault(require(39));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 *  To choose department
 *  Created by jichao
 *  2016.12.6
 */
var MEDepartChooseView = exports["default"] = /*#__PURE__*/function (_MDDropdownView) {
  (0, _inherits2["default"])(MEDepartChooseView, _MDDropdownView);
  function MEDepartChooseView() {
    (0, _classCallCheck2["default"])(this, MEDepartChooseView);
    return _callSuper(this, MEDepartChooseView, arguments);
  }
  (0, _createClass2["default"])(MEDepartChooseView, [{
    key: "tmpl",
    value: function tmpl() {
      return "<div class = \"departtree-input-container\">\n              <input class = \"form-control text-hide department\" name=\"department\" data-tooltip=\"\" data-tooltip-dir=\"top\" placeholder=\"<%=placeholder%>\">\n              <div  class = \"department-tree-popup\"> </div>\n            </div>\n            <div class=\"validate-error-container\"></div>\n            ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEDepartChooseView.prototype), "className", this).call(this);
      return "".concat(superCls, " searchDep");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEDepartChooseView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        onChange: _.noop,
        selectedDepart: null,
        selectedDepartId: undefined,
        filterId: undefined,
        placeholder: _MDLocalString["default"].getLocalString(3101),
        /* '所有部门',*/

        $searchdep: null,
        needRoot: true,
        needAddDefault: false,
        readonly: false,
        onReady: _.noop,
        silentInit: true,
        // 初始化选中时是否触发onChange

        onInputChange: _.noop,
        required: false,
        dropdownAnchor: '.form-control',
        dropdownContainer: '.department-tree-popup',
        disabledDepChoose: false,
        data: [],
        fixed: false,
        needReturnChildren: false,
        needProject: false,
        rootId: undefined // 根节点的 id， 部门筛选不见得一定从根目录开始，可以指定一个子部门为根
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEDepartChooseView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .jstree-node': this.stopPropagation,
        'input .form-control': this._inputChangeHandler
      });
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEDepartChooseView.prototype), "initialize", this).call(this, opt);
      this.$departmentTree = this.$('.department-tree-popup');
      this.$searchdep = this.$('input');
      if (this.readonly) {
        this.$searchdep.prop('readonly', true);
      }
      if (this.disabledDepChoose) {
        this.$searchdep.prop('disabled', this.disabledDepChoose);
        this.$('.departtree-input-container').addClass('disabled');
      }
      if (this.required) {
        this.$searchdep.prop('required', true);
      }
      this.$searchdep.data('inDepartChooser', true);
      //
      // jquery validate 校验使用
      // 改动请注意全局查找
      this.$('.form-control').data('departmentTreeView', this);
    }
  }, {
    key: "stopPropagation",
    value: function stopPropagation($e) {
      $e.stopPropagation();
    }
  }, {
    key: "_inputChangeHandler",
    value: function _inputChangeHandler($e) {
      var text = this.$searchdep.val();
      this.onInputChange(text);
    }
  }, {
    key: "validateData",
    value: function validateData() {
      var rootId;
      if (!this.needRoot) {
        for (var i = 0; i < this.data.length; i++) {
          if (this.data[i].parent == "#") {
            rootId = this.data[i].id;
            this.data.splice(i, 1);
          }
        }
        for (var i = 0; i < this.data.length; i++) {
          if (this.data[i].parent == rootId) {
            this.data[i].parent = "#";
          }
        }
      }
      if (this.needAddDefault) {
        this.data.unshift({
          "id": "-1",
          "text": this.placeholder,
          "parent": "#"
        });
      }
      return this.data;
    }
  }, {
    key: "selectAllDepartmentNode",
    value: function selectAllDepartmentNode(opt_silent) {
      var id = -1;
      this.selectedByDepartId(id, opt_silent);
    }
  }, {
    key: "_onChange",
    value: function _onChange(node, originNode) {
      var _this = this;
      var childrenNodes = [];
      if (this.needReturnChildren) {
        childrenNodes = _.map(node.children, function (id) {
          return _this.getNodeById(id);
        });
      }
      this.onChange(node, originNode, childrenNodes);
    }
  }, {
    key: "initDepTree",
    value: function initDepTree() {
      var _this2 = this;
      var data = this.data;
      //树形菜单
      this.$departmentTree.on("changed.jstree", function (e, data) {
        var node = _this2.$departmentTree.jstree().get_node(data.selected[0]);
        if (data.selected.length) {
          _this2.$departmentTree.hide();
          _this2.$searchdep.val(_.unescape(node.text));
          _this2.$searchdep.attr("data-tooltip", _.unescape(node.text));
          _this2.selectedDepart = node;
          _this2.selectedDepartId = node.id;
          var originNode = _this2.getNodeById(node.id);
          _this2._onChange(node, originNode);
          var validator = _this2.$searchdep.closest('form').validate();
          validator && validator.element(_this2.$searchdep);
        }
        _this2.closeDropDown();
      }).on('ready.jstree', function (e, data) {
        _this2._departmentRemovededHandler(_this2.filterId);
        if (_this2.selectedDepartId) {
          _this2.selectedByDepartId(_this2.selectedDepartId, _this2.silentInit);
        } else if (data.length) {
          var node = data[0];
          _this2.selectedDepartId = data[0].id;
          _this2.selectedByDepartId(_this2.selectedDepartId, _this2.silentInit);
          var originNode = _this2.getNodeById(_this2.selectedDepartId);
          _this2._onChange(node, originNode);
        }
        var items = _this2.$(".department-tree-popup .jstree-anchor");
        for (var i = 0; i < items.length; i++) {
          var element = items[i];
          $(element).attr("data-tooltip", $(element).text());
          $(element).attr("data-tooltip-dir", "left");
        }
        console.log("----- itmes:", items);
        _this2.onReady();
      }).on('before_open.jstree', function () {
        _this2._departmentRemovededHandler(_this2.filterId);
      }).on('after_open.jstree', function () {
        var items = _this2.$(".department-tree-popup .jstree-anchor");
        for (var i = 0; i < items.length; i++) {
          var element = items[i];
          $(element).attr("data-tooltip", $(element).text());
          $(element).attr("data-tooltip-dir", "left");
        }
      }).on('hover_node.jstree', function (event, data) {
        console.log("-------- event:", event, ", data:", data);
      }).jstree({
        "plugins": ["search", "conditionalselect", "types", "sort"],
        'strings': {
          'Loading ...': BabelStr.str(3251) + '...'
        },
        'core': {
          'data': data,
          "themes": {
            "dblclick_toggle": false,
            "icons": false,
            "dots": false // no connecting dots between dots
          }
        },
        "sort": function sort(pre, next) {
          var preNode = _this2.$departmentTree.jstree().get_node(pre);
          var parentId = preNode.parent;
          var parentNode = _this2.$departmentTree.jstree().get_node(parentId);
          var sortedObjs = _.findWhere(_this2.orders, {
            'departmentId': parentId
          });
          var sortedIds;
          if (!sortedObjs) {
            sortedIds = parentNode.children;
          } else {
            sortedIds = sortedObjs.orderSeq;
          }
          var preIndex = _.indexOf(sortedIds, pre);
          var nextIndex = _.indexOf(sortedIds, next);
          console.log(pre, next, preIndex < nextIndex ? 1 : -1);
          return preIndex < nextIndex ? -1 : 1;
        },
        "check_callback": true
        // "search" : {
        //   "search_callback":this.search_callback
        // }
      });
      var to = false;
      this.$searchdep.keyup(function () {
        if (to) {
          clearTimeout(to);
        }
        to = setBabelTimeout(function () {
          var v = _this2.$searchdep.val();
          if (_this2.$departmentTree.jstree().get_selected().length) {
            _this2.$departmentTree.jstree().deselect_all();
          }
          _this2.$departmentTree.jstree(true).search(v);
        }, 250);
      });
      if (!this.selectedDepartId && data.length) {}
    }
  }, {
    key: "getSelectedDepart",
    value: function getSelectedDepart() {
      return this.selectedDepart;
    }
  }, {
    key: "search_callback",
    value: function search_callback(str, nodes) {
      // console.log(nodes);
      // return false;
    }
  }, {
    key: "_departmentRemovededHandler",
    value: function _departmentRemovededHandler(id) {
      this.$("#".concat(id)).hide();
    }
  }, {
    key: "getAllDepartmentNode",
    value: function getAllDepartmentNode() {
      return this.data;
    }
  }, {
    key: "getEnterpriseAllDepAndProject",
    value: function getEnterpriseAllDepAndProject() {
      var _this3 = this;
      var net = _MMEnterpriseController["default"].department;
      net.getEnterpriseAllDepAndProject(function (data) {
        data = _.map(data, function (item, index) {
          var opened = item['parentId'] == '0' ? true : false;
          if (item['parentId'] == '0') {
            _this3.rootNode = item;
            if (!_this3.needAddDefault) {
              _this3.$(".department").attr("placeholder", _.unescape(item["name"]));
            }
          }
          return {
            'id': item['fileId'],
            'text': item['fileName'],
            'folderId': item['fileId'],
            'parent': item['parentId'] == '0' ? '#' : item['parentId'],
            'state': {
              'opened': opened
            }
          };
        });
        _this3.data = data;
        _this3.validateData();
        _this3.initDepTree();
      }, function () {});
    }
  }, {
    key: "getAllDepartmentStructor",
    value: function getAllDepartmentStructor() {
      var _this4 = this;
      var net = _MMEnterpriseController["default"].department;
      net.getAllDepartmentStructor(function (data) {
        if (_this4.rootId) {
          var parentIds = [_this4.rootId];
          var filteredData = [];
          for (var k = 0; k < data.length; k++) {
            var item = data[k];
            var id = item['id'];
            var parentId = item['parent'];
            for (var i = 0; i < parentIds.length; i++) {
              var keyId = parentIds[i];
              if (id == keyId) {
                filteredData.push(item);
                if (id == _this4.rootId) {
                  item['parent'] = '0'; //设置为根
                }
                break;
              } else if (parentId == keyId) {
                filteredData.push(item);
                parentIds.push(id);
                break;
              }
            }
          }
          data = filteredData;
        }
        data = _.map(data, function (item, index) {
          var opened = item['parent'] == '0' ? true : false;
          if (item['parent'] == '0') {
            _this4.rootNode = item;
            if (!_this4.needAddDefault) {
              _this4.$(".department").attr("placeholder", _.unescape(item["name"]));
            }
          }
          return {
            'id': item['id'],
            'text': item['name'],
            'title': item['name'],
            'folderId': item['folderId'],
            'parent': item['parent'] == '0' ? '#' : item['parent'],
            'state': {
              'opened': opened
            }
          };
        });
        _this4.data = data;
        _this4.validateData();
        _this4.initDepTree();
      }, function () {});
    }
  }, {
    key: "getNodeById",
    value: function getNodeById(departId) {
      var selectedNode = null;
      _.each(this.data, function (item) {
        if (departId == item.id) {
          selectedNode = item;
        }
      });
      return selectedNode;
    }
  }, {
    key: "selectedByDepartId",
    value: function selectedByDepartId(departId, opt_silent) {
      this.selectedDepartId = departId;
      var selectedNode = null;
      _.each(this.data, function (item) {
        if (departId == item.id) {
          selectedNode = item;
        }
      });
      if (selectedNode) {
        this.$departmentTree.jstree().select_node(selectedNode, opt_silent);
        if (opt_silent) {
          this.$departmentTree.hide();
          this.$searchdep.val(_.unescape(selectedNode.text));
          this.$searchdep.attr("data-tooltip", _.unescape(selectedNode.text));
          this.selectedDepart = selectedNode;
          this.selectedDepartId = selectedNode.id;
        }
      }
    }
  }, {
    key: "getRootNode",
    value: function getRootNode() {
      return this.rootNode;
    }
  }, {
    key: "selectRoot",
    value: function selectRoot() {
      var node = this.getRootNode();
      this.selectedByDepartId(node.id);
    }
  }, {
    key: "reset",
    value: function reset() {
      this.selectedDepart = null;
      this.selectedDepartId = undefined;
      this.$searchdep.val('');
      this.$searchdep.attr("data-tooltip", '');
    }
  }, {
    key: "render",
    value: function render() {
      var data = {
        'placeholder': this.placeholder
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEDepartChooseView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEDepartChooseView.prototype), "viewDidRendered", this).call(this);
      if (this.needProject) {
        this.getEnterpriseAllDepAndProject();
      } else {
        this.getEnterpriseDepartmentOrder();
      }
    }
  }, {
    key: "getEnterpriseDepartmentOrder",
    value: function getEnterpriseDepartmentOrder() {
      var _this5 = this;
      _MMEnterpriseController["default"].getEnterpriseDepartmentOrder(function (orders) {
        _this5.orders = _.map(orders, function (order) {
          return {
            departmentId: order.departmentId,
            orderSeq: order.orderSeq.split(',')
          };
        });
        _this5.getAllDepartmentStructor(_this5.depId);
      }, function () {
        _.isFunction(_this5.loadError) && _this5.loadError();
      });
    }
  }, {
    key: "getControlName",
    value: function getControlName() {
      return this.$searchdep.attr('name');
    }

    /**
     * jquery validate 插件使用 ， 请不要随意删除，如果变更需要全局查找替换
     * @return {jQuery}
     */
  }, {
    key: "getValidateErrorContainer",
    value: function getValidateErrorContainer() {
      return this.$('.validate-error-container');
    }
  }]);
  return MEDepartChooseView;
}(_MDDropdownView2["default"]);

},{"1098":1098,"1150":1150,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1421":1421,"1426":1426,"1432":1432,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"1477":1477,"1493":1493,"39":39}],132:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDDepEvaluationTableView = _interopRequireDefault(require(134));
var _MDSnackbarView = _interopRequireDefault(require(72));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDDepEvaluationSettingWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDDepEvaluationSettingWinView, _MDWindowView);
  function MDDepEvaluationSettingWinView() {
    (0, _classCallCheck2["default"])(this, MDDepEvaluationSettingWinView);
    return _callSuper(this, MDDepEvaluationSettingWinView, arguments);
  }
  (0, _createClass2["default"])(MDDepEvaluationSettingWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n\t\t\t<div class=\"help-block\"><%=BabelStr.str(3435)%></div>\n\t\t\t<div class=\"radio-group mgt-20\">\n\t\t\t\t<div class=\"setting-item radio-box checked\" data-type=\"3\"><%=BabelStr.str(4542)%></div>\n\t\t\t\t<p><%=BabelStr.str(6025)%></p>\n\t\t\t\t<div class=\"setting-item radio-box \" data-type=\"0\"><%=BabelStr.str(3436)%></div>\n\t\t\t\t<p><%=BabelStr.str(6026)%></p>\n\t\t\t\t<div class=\"setting-item radio-box \" data-type=\"1\"><%=BabelStr.str(3437)%></div>\n\t\t\t\t<p><%=BabelStr.str(6027)%></p>\n\t\t\t\t<div class=\"table-wrap f-none\"></div> \n\t\t    <%if(!isRoot){%>\n\t\t\t\t\t<div class=\"setting-item radio-box\" data-type=\"2\"><%=BabelStr.str(3438)%></div>\n\t\t\t\t\t<p><%=BabelStr.str(6028)%></p>\n\t\t\t\t<%}%>\t\t    \n\t\t\t</div>\t\t\t\n\t\t\t<div class=\"flex-align end btns-block\">\n\t\t\t\t<button class=\"button cancel\"><%=BabelStr.str(155)%></button>\n\t\t\t\t<button class=\"button done save\"><%=BabelStr.str(3080)%></button>\n\t\t\t</div>\n\t\t";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepEvaluationSettingWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " eval-strategy-win");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepEvaluationSettingWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        pageSize: 10,
        startIndex: 0,
        type: 0,
        selected: [],
        canCreate: true,
        dataInit: false,
        depId: '',
        isRoot: false,
        size: 'large'
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      props.title = BabelStr.str(3434);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepEvaluationSettingWinView.prototype), "initialize", this).call(this, props);
      if (!this.dataInit) {
        this.getDepartmentEvaluationLimited(this.depId);
      } else {
        this.index = this.getIndexByType(this.type);
        this.checkedByIndex(this.index);
        this.renderBroadcast();
      }
    }
  }, {
    key: "getIndexByType",
    value: function getIndexByType(type) {
      for (var i = 0; i < this.$('.setting-item').length; i++) {
        var $e = this.$('.setting-item').eq(i);
        if ($e.data('type') == type) {
          this.index = i;
          break;
        }
      }
      return this.index;
    }
  }, {
    key: "render",
    value: function render(data) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepEvaluationSettingWinView.prototype), "render", this).call(this, {
        isRoot: this.isRoot
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepEvaluationSettingWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .setting-item': this._settingType,
        'click .cancel': this.close,
        'click .save': this.save
      });
    }
  }, {
    key: "_settingType",
    value: function _settingType($e) {
      var $current = $($e.target).closest('.setting-item');
      this.type = $current.data('type');
      this.index = this.getIndexByType(this.type);
      this.checkedByIndex(this.index);
    }
  }, {
    key: "checkedByIndex",
    value: function checkedByIndex(index) {
      this.$('.setting-item').removeClass('checked');
      this.$('.setting-item').eq(index).addClass('checked');
      if (this.type == 1) {
        this.$('.table-wrap').show();
      } else {
        this.$('.table-wrap').hide();
      }
    }
  }, {
    key: "renderBroadcast",
    value: function renderBroadcast() {
      var _this = this;
      if (!this.tableView) {
        this.tableView = new _MDDepEvaluationTableView["default"]({
          ids: this.limits,
          onRowSelectionChanged: function onRowSelectionChanged(selectedRowModels) {
            console.log(selectedRowModels);
            _this.selected = selectedRowModels;
          },
          onLoadSuccess: function onLoadSuccess(evaluations) {},
          onLoadFailed: function onLoadFailed() {},
          close: function close() {
            _this.close();
          },
          canCreate: this.canCreate
        });
        this.addSubView(this.tableView, this.$('.table-wrap')[0]);
        this.tableView.requestUser();
      }
      // this.$('.table-wrap').show()
    }
  }, {
    key: "save",
    value: function save() {
      var ids = [];
      if (this.type == 1) {
        _.each(this.selected, function (item) {
          ids.push(item.get("id"));
        });
      }
      this.setDepartmentEvaluationLimited(ids);
    }
  }, {
    key: "setDepartmentEvaluationLimited",
    value: function setDepartmentEvaluationLimited(tmplIds) {
      var _this2 = this;
      MMEnterpriseController.setDepartmentEvaluationLimited(this.depId, this.type, tmplIds, function () {
        _.isFunction(_this2.onChanged) && _this2.onChanged(_this2.type, tmplIds);
        _this2.close();
        console.log('success');
        _MDSnackbarView["default"].show(BabelStr.str(308));
      }, function (code) {
        _MDSnackbarView["default"].show(BabelStr.str(309), {
          code: code
        });
        console.log('fail');
      });
    }
  }, {
    key: "getDepartmentEvaluationLimited",
    value: function getDepartmentEvaluationLimited(depId) {
      var _this3 = this;
      MMEnterpriseController.getDepartmentEvaluationLimited(depId, function (data) {
        _this3.type = data.evaluationLimited;
        _this3.limits = _.pluck(data.templates, 'id');
        _this3.index = _this3.getIndexByType(_this3.type);
        _this3.renderBroadcast();
        _this3.checkedByIndex(_this3.index);
      }, function (code) {});
    }
  }]);
  return MDDepEvaluationSettingWinView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"134":134,"1454":1454,"1463":1463,"1475":1475,"72":72,"93":93}],134:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1420);
require(1485);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTableView2 = _interopRequireDefault(require(89));
var _MDDepEvaluationTableRowView = _interopRequireDefault(require(133));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 * 审批管理table
 * Created by dai
 * 2017.5.15
 */
var MDDepEvaluationTableView = exports["default"] = /*#__PURE__*/function (_MDTableView) {
  (0, _inherits2["default"])(MDDepEvaluationTableView, _MDTableView);
  function MDDepEvaluationTableView() {
    (0, _classCallCheck2["default"])(this, MDDepEvaluationTableView);
    return _callSuper(this, MDDepEvaluationTableView, arguments);
  }
  (0, _createClass2["default"])(MDDepEvaluationTableView, [{
    key: "emptyTmpl",
    value: function emptyTmpl(props) {
      var str = '';
      if (props.canCreate && !app.inMianPage) {
        str = "<button class=\"text-button done create mgl-10\">".concat(BabelStr.str(3442), "</button>");
      }
      return "<div class=\"m-empty page-empty\" style=\"display: block;padding: 20px 0;\">\n        <span class=\"title\">".concat(BabelStr.str(3441), "</span>\n          ").concat(str, "\n      </div>");
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepEvaluationTableView.prototype), "className", this).call(this);
      return "".concat(superCls, " table-striped ver-mid-align evaluation-table");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepEvaluationTableView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .create': this.createClickHandle
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props = _.extend({
        blankRenderer: function blankRenderer() {
          return _this.emptyTmpl({
            canCreate: true
          });
        },
        bodyCls: 'evalRows',
        rowCls: 'row',
        headerCls: 'headerWrapper',
        rowClass: _MDDepEvaluationTableRowView["default"],
        columns: this.getClumns()
      }, props);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepEvaluationTableView.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "createClickHandle",
    value: function createClickHandle() {
      Dispatcher.trigger(MDEvents.Goto_Evaluation);
      this.close();
    }
  }, {
    key: "getClumns",
    value: function getClumns() {
      var clumns = [{
        name: BabelStr.str(3190),
        dataIndex: 'name',
        width: 200
      }, {
        name: BabelStr.str(3191),
        dataIndex: 'evaluator',
        flex: 1
      }, {
        name: BabelStr.str(3048),
        dataIndex: 'time',
        width: 95
      }];
      return clumns;
    }
  }, {
    key: "requestUser",
    value: function requestUser(onSuccess, onFail) {
      var _this2 = this;
      this.startLoadingState();
      MMEnterpriseController.getAllEvaluationTmpls(function (evaluations) {
        _this2.clearLoadingState();
        evaluations.each(function (model, index) {
          if (_this2.ids.includes(model.get("id"))) {
            model._rowSelected = true;
          }
        });
        _this2.setDataCollection(evaluations, true, false);
        _.isFunction(_this2.onLoadSuccess) && _this2.onLoadSuccess(evaluations);
        _.isFunction(onSuccess) && onSuccess(evaluations);
      }, function () {
        _this2.clearLoadingState();
        _.isFunction(_this2.onLoadFailed) && _this2.onLoadFailed();
        _.isFunction(onFail) && onFail();
        MDMessageView.error(BabelStr.str(3523));
      });
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepEvaluationTableView.prototype), "viewDidRendered", this).call(this);
    }
  }]);
  return MDDepEvaluationTableView;
}(_MDTableView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"133":133,"1412":1412,"1420":1420,"1454":1454,"1463":1463,"1475":1475,"1485":1485,"89":89}],133:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1426);
require(1439);
require(1424);
require(1437);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDTableRowView2 = _interopRequireDefault(require(88));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDDepEvaluationTableRowView = exports["default"] = /*#__PURE__*/function (_MDTableRowView) {
  (0, _inherits2["default"])(MDDepEvaluationTableRowView, _MDTableRowView);
  function MDDepEvaluationTableRowView() {
    (0, _classCallCheck2["default"])(this, MDDepEvaluationTableRowView);
    return _callSuper(this, MDDepEvaluationTableRowView, arguments);
  }
  (0, _createClass2["default"])(MDDepEvaluationTableRowView, [{
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepEvaluationTableRowView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        evalModel: null,
        columnRenders: function columnRenders() {
          var clumns = [{
            dataIndex: 'name',
            cellCls: 'name-col'
          }, {
            dataIndex: 'evaluator',
            cellCls: 'evaluator-col',
            render: function render(name, evalInfo, index) {
              var steps = evalInfo.get("steps");
              var renderStr = '';
              var users = _.map(steps, function (step) {
                return step.users;
              });
              users = _.flatten(users);
              var userNames = _.map(users, function (user) {
                return "<span>".concat(user.name, "</span>");
              });
              var roles = _.map(steps, function (step) {
                return step.roles;
              });
              roles = _.flatten(roles);
              var roleNames = _.map(roles, function (role) {
                return "<span class=\"main-color\">".concat(role.name, "</span>");
              });
              renderStr = userNames.join('，') + roleNames.join('，');
              return renderStr;
            }
          }, {
            dataIndex: 'time',
            cellCls: 't-col',
            render: function render(name, evalInfo, index) {
              var time = new Date((evalInfo.get("time") - 0) * 1000);
              return time.format("yyyy-MM-dd");
            }
          }];
          return clumns;
        }
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepEvaluationTableRowView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .edit-eval-btn': this._editEvaluation,
        'click .delete-eval-btn': this._deleteEvaluation
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDepEvaluationTableRowView.prototype), "initialize", this).call(this, props);
      this.evalModel = this.rowModel;
    }
  }, {
    key: "_editEvaluation",
    value: function _editEvaluation() {
      var win = new MDEvalutionEditWinView({
        isEdit: true,
        evalModel: this.evalModel
      });
      win.show();
    }
  }]);
  return MDDepEvaluationTableRowView;
}(_MDTableRowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1424":1424,"1426":1426,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"88":88}],130:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDPopupHelpWindow = _interopRequireDefault(require(63));
var _MEAuthPanelView = _interopRequireDefault(require(129));
/**
 * 角色帮助信息显示的类
 * javascript/enterprise/view/auth/MEDepRoleHelpWindow.js
 * Created by jiang 
 * 2018.8.12
 */

var MEDepRoleHelpWindow = _MDPopupHelpWindow["default"].extend({
  helpTmpl: "<div class=\"role-help\"></div>",
  className: function className() {
    var superCls = _MDPopupHelpWindow["default"].prototype.className.call(this);
    return superCls + ' help-role-win';
  },
  initProps: function initProps(prop) {
    var superP = _MDPopupHelpWindow["default"].prototype.initProps.call(this, prop);
    return _.extend(superP, {
      forShare: false
    });
  },
  events: function events() {
    var superE = _MDPopupHelpWindow["default"].prototype.events.call(this);
    return _.extend(superE, {});
  },
  initialize: function initialize(options) {
    var self = this;
    _MDPopupHelpWindow["default"].prototype.initialize.call(this, options);
    var self = this;
    this.authPanel = new _MEAuthPanelView["default"]({
      disableEdit: true,
      tabIndex: this.forShare ? 1 : 0
    });
    this.addSubView(this.authPanel, this.$('.role-help'));
  },
  getClassName: function getClassName() {
    return "MEDepRoleHelpWindow";
  }
}, {
  show: function show(forShare) {
    if (!MEDepRoleHelpWindow.instance) {
      MEDepRoleHelpWindow.instance = new MEDepRoleHelpWindow({
        onClose: function onClose() {
          MEDepRoleHelpWindow.instance = null;
        },
        forShare: forShare
      });
      app.application.addSubView(MEDepRoleHelpWindow.instance);
    }
  }
});
var _default = exports["default"] = MEDepRoleHelpWindow;

},{"1150":1150,"1184":1184,"129":129,"1454":1454,"63":63}],126:[function(require,module,exports){
module.exports = '<div class="m-empty page-empty" style="display: block;">\  <img src="../../../../img/mdisk/empty-msg.png">\  <p class="title"><%=BabelStr.str(3126)%></p>\  <p class="info"><%=BabelStr.str(3127)%></p>\</div>';
},{}],125:[function(require,module,exports){
module.exports = {"spaceInfoList":"<div class=\"container space-info-list\">\r                        <div class=\"row marginB-20\">\r                          <p>\r                            <span class=\"private-limted\"><%=privateLimit%> </span>\r                            <span class=\"filelimitlist\"></span>\r                            <!-- 允许用户拥有个人空间 -->\r                          </p>\r                        </div>\r                        <div class=\"row space-edit-block\">\r                          <p class=\"space-edit-content flex-align between middle \">\r                            <span class=\"flex-align middle\">\r                              <strong class=\"mgr-10 no-shrink\"><%=personLimtedStr%> </strong> <!-- 个人空间上限 -->\r                              <input class=\"limeted-input form-control mgr-10\" value=\"<%=limeted%>\">\r                              <span class=\"no-shrink\">GB</span>\r                            </span>\r                            <span class=\"no-shrink text-button disabled save-space-btn\"><%=saveStr%></span> <!-- 修改 -->\r                          </p>\r                          <div class=\"gray\"><%=spaceTipStr%></div>\r                        </div>\r                        <div class=\"usedSpace-calc mgt-10 <%=(initView ? '' : 'f-hide')%>\">\r                          <div class=\"flex-align between \">\r                            <strong><%=BabelStr.str(832)%></strong>\r                            <div class=\"calc text-button\"><%=BabelStr.str(20157)%></div>\r                          </div>\r                          <div class=\"loader-block\"></div>\r                        </div>\r                        <div class=\"usedSpace-info <%=(initView ? 'f-hide' : '')%>\">\r                          <div class=\"row space-used\">\r                          </div>\r                          <div class=\"row dep-space\">\r                            <p>\r                              <strong class=\"category-name\"><%=BabelStr.str(6225)%> </strong>\r                              <div class=\"help-block\"><%=BabelStr.str(6226)%></div>\r                            </p>\r                          </div>\r                          <div class=\"row dep-space-info\"></div>\r                        </div>\r                      </div>"};
},{}],124:[function(require,module,exports){
module.exports = '<div class="search-wrap">\  <div class="container">\    <div class="row form-item">\      <div class="col-3 dep-block">\        <div name="" id="js-departSlot"></div>\      </div>\      <div class="col-3 role-block">\        <select name="" id="js-roleSlot"></select>\      </div>\      <div class="col-6">\        <div class="search-box">\          <i class="icon-search"></i>\          <input type="text" placeholder="<%=placeholder%>...">\        </div>\      </div>\    </div>\  </div>\  <div class="container filter-wrap selected-block mgt-10">\    <div class="form-item">\    <div class="flex-align middle between">\      <label for=""><%=selected%>:</label>\      <% if (includeNumberInfo){%>\      <div class="help-block"><%=caption%></div>\      <% }%>\    </div>\      <div class="flex-align mgb-15">\        <div id="js-chooserSlot"></div>\        <div id="js-depRoleSlot"></div>\      </div>\      <div class="error-text red font2 f-none f-tr"><%=BabelStr.str(3497)%></div>\    </div>\  </div>\</div>\<div class="table-wrap f-clb"></div>';
},{}],123:[function(require,module,exports){
module.exports = {"root":"<div class=\"warn-panel\">\r  <p class=\"warn-title\"><i class=\"ep-ic ep-ic-warn\"></i>\r    <label for=\"\"><%=BabelStr.str(3274)%></label>\r  </p>\r  <p class=\"warn-message\"><%=BabelStr.str(3275)%></p>\r</div>\r<div class=\"file-title f-clb\">\r  <label for=\"\" class=\"f-fl\"><%=BabelStr.str(3282)%></label>\r  <!-- <button class=\"button view-file f-fr\">查看所有者文件</button> -->\r</div>\r<div class=\"help-block\"><%=BabelStr.str(6224)%></div>\r<div class=\"content-block p-re\">\r<table class=\"table table-bordered table-block-hd user-table\">\r  <thead>\r    <tr>\r      <td><%=BabelStr.str(3276)%></td>\r      <td><%=BabelStr.str(3277)%></td>\r      <td><%=BabelStr.str(3278)%></td>\r    </tr>\r  </thead>\r  <tbody class=\"user-content \">\r  </tbody>\r</table>\r<div class=\"transfer-box\">\r  <label><%=BabelStr.str(3060)%></label>\r  <input type=\"text\" class=\"form-control user-input\" placeholder=\"<%=BabelStr.str(3279)%>...\">\r  <div class=\"choose-div\">\r    <span class=\"name\"></span>\r    <span class=\"email\"></span>\r  </div>\r  <label><%=BabelStr.str(3280)%></label>\r  <button class=\"button change-staff\"><%=BabelStr.str(3070)%></button>\r  <div class=\"add-wrap\">\r    <button class=\"button add-staff\"><%=BabelStr.str(3281)%></button>\r  </div>\r</div>  \r</div>","useritem":"<tr class=\"item\">\r      <td class=\"name\">\r      </td>\r      <td class=\"departs\"></td>\r      <td class=\"space\"></td>\r    </tr>"};
},{}],122:[function(require,module,exports){
module.exports = {"root":"<div class=\"horizonal-divider\">\r  </div>\r  <div class=\"hide account-status\"><%=stoppedStr%></div>\r  <div class=\"container\">\r    <div class=\"row\">\r      <div class=\"col-6 left-col\">\r        <div id=\"js-basicInfo\" class=\"basic-setting\">\r        </div>\r        <!--basic-setting-end-->\r        <div class=\"manage-block\">\r          <div class=\"block\">\r            <div class=\"block-hd with-operation\">\r              <div class=\"block-title\"><%=manageAccountStr%></div> <!-- 管理账户 -->\r            </div>\r            <div class=\"block-bd\">\r              <ul>\r                <!--               <li>\r                <div>\r                  <span class=\"operation-title\">查看账户</span>\r                  <button class=\"text-button done f-fr\" id=\"lookPersonFile\">查看</button>\r                </div>\r                <p class=\"help-block\">管理员有权查看员工账户使用情况</p>\r              </li>\r -->\r                <li class=\"reset-pwd-block\">\r                  <div>\r                    <span class=\"operation-title\"><%=resetPswTitle%></span>    <!-- 重置密码 -->\r                    <button id=\"js-resetPsw\" class=\"text-button done f-fr\"><%=resetPswBtn%></button> <!-- 重置密码 -->\r                  </div>\r                  <p class=\"help-block\"><%=setPswTipStr%></p> <!-- 发送重置密码的链接地址到用户的邮箱 -->\r                </li>\r                <li>\r                  <div>\r                    <span class=\"operation-title\"><%=moveFileStr%></span>    <!-- 转移文件归属 -->\r                    <button id=\"js-transformFile\" class=\"text-button done f-fr\"><%=moveToStr%></button> <!-- 转移至 -->\r                  </div>\r                  <p class=\"help-block\"><%=moveToTipStr%></p> <!-- 管理员有权将员工账号文件转移至另一员工 -->\r                </li>\r                <li>\r                  <div>\r                    <span class=\"operation-title\"><%=BabelStr.str(6815)%></span>    <!-- 转移文件归属 -->\r                    <button id=\"js-clearRole\" class=\"text-button danger f-fr\"><%=BabelStr.str(6816)%></button> <!-- 转移至 -->\r                  </div>\r                  <p class=\"help-block\"><%=BabelStr.str(6817)%></p> <!--   管理员有权将员工账号文件转移至另一员工 -->\r                </li>\r                <li>\r                  <div>\r                    <span class=\"operation-title\"><%=stopAccountStr%></span> <!-- 停用账户 -->\r                    <span id=\"js-accountStatus\" class=\"f-fr\">\r                    <%if (status == 1){%>\r                    <span class=\"account-stopped\"></span>\r                    <button id=\"js-restoreAccount\" class=\"text-button done\"><%=recoverStr%></button>  <!-- 恢复 -->\r                    <%}else{%>\r                      <button id=\"js-stopAccount\" class=\"text-button danger\"><%=stopStr%></button>   <!-- 停用 -->\r                      <%}%>\r                        </span>\r                  </div>\r                  <p class=\"help-block\"><%=stopTipStr%></p>  <!-- 停用账户使其不能登录本企业(可恢复) -->\r                </li>\r                <li>\r                  <div>\r                    <span class=\"operation-title\"><%=delAccountStr%></span>   <!-- 删除账户 -->\r                    <span class=\"f-fr\">\r                    <button id=\"js-delAccount\" class=\"text-button danger \"><%=delStr%></button> <!-- 删除 -->\r                </span>\r                  </div>\r                  <p class=\"help-block\"><%=delTipStr%></p> <!-- 员工账户删除后，其账户下的文件也将移除，执行此操作请慎重 -->\r                </li>\r                <li>\r                  <div>\r                    <span class=\"operation-title\"><%=BabelStr.str(6354)%></span>   <!-- 上传限速 -->\r                  </div>\r                  <div class='flex-align between middle'>\r                    <div class=\"no-shrink mgr-10\"><%=BabelStr.str(6355)%></div>\r                    <div class=\"flex-align middle\"><input class='mgr-10 form-control download-speed' type=\"\" value=<%=maxDownloadSpeed%> name=\"\"><span class='no-shrink'>k/s</span></div>\r                    <span class=\"text-button save-download-speed-limit no-shrink mgl-10\"><%=BabelStr.str(3080)%></span>\r                  </div>\r                  <p class=\"help-block\"><%=BabelStr.str(6356)%></p>\r                </li>\r                <li>\r                  <!-- <div class=\"help-block\"><%=lastLoginStr%>: <span><%=recentAccessTime%></span></div> -->\r                  <!-- 上次登录： -->\r                  <div class=\"lastlogin-block\"></div>\r                </li>\r              </ul>\r            </div>\r          </div>\r        </div>\r      </div>\r      <!--left-block-end-->\r      <div class=\"col-6 right-col\">\r        <div class=\"auth-block\">\r          <div class=\"block\">\r            <div class=\"block-hd with-operation \">\r              <div class=\"block-title f-fl\"><%=roleManageStr%></div>  <!-- 权限管理 -->\r              <button id=\"js-editDepartRole\" class=\"text-button done  f-fr\"><%=editStr%></button> <!-- 修改 -->\r            </div>\r            <div>\r              <div id=\"js-role-block\" class=\"edit-role-block\">\r              </div>\r              <!-- 管理员-->\r              <!--             <div class=\"open-admin-block\">\r              <div class=\"flex-row middle\">\r                <div class=\"col-10\">\r                  <span>管理员权限</span>\r                  <p class=\"help-block\">开启管理员权限后，可以查看并管理企业部门的文件以及管理员工以及企业外部人员信息</p>\r                </div>\r                <div class=\"col-2 text-right\">\r                  <div id=\"js-swicthSlot\"></div>\r                </div>\r              </div>\r            </div> -->\r              <!-- 文档管理员 -->\r              <!--             <div class=\"open-admin-block\">\r              <div class=\"flex-row middle\">\r                <div class=\"col-10\">\r                  <span>文档管理员权限</span>\r                  <p class=\"help-block\">开启问管理员权限后，可以查看并管理企业各个部门的文件</p>\r                </div>\r                <div class=\"col-2 text-right\">\r                  <div id=\"js-swicthDocSlot\"></div>\r                </div>\r              </div>\r            </div> -->\r            </div>\r          </div>\r        </div>\r          <div class=\"block pdb-20 role-block js-admin-set\">\r            <div class=\"block-hd \">\r              <div class=\"block-title f-fl\"><%=epRoleStr%></div>  <!-- 企业角色 -->\r            </div>\r            <div class=\"role-select-block\"></div>\r          </div>\r        <!--auth-block-end-->\r        <div class=\"space-block\">\r          <div class=\"block\">\r            <div class=\"block-hd with-operation\">\r              <div class=\"block-title f-fl\"><%=spaceStr%></div> <!-- 空间用量 -->\r            </div>\r            <div id=\"js-spaceInfo\" class=\"block-bd  \">\r            </div>\r          </div>\r        </div>\r        <div class=\"library-block\">\r          <div class=\"block\">\r            <div class=\"flex-align center between\">\r              <div class=\"block-hd with-operation\">\r                <div class=\"block-title f-fl\"><%=BabelStr.str(12504)%></div>\r              </div>\r              <div class=\"library-switch\"></div>\r            </div>\r            <div class=\"help-block\">\r              <%=BabelStr.str(12505)%>\r            </div>\r          </div>\r        </div>\r        <div class=\"ai-token-block\">\r          <div class=\"block\">\r            <div class=\"flex-align center between\">\r              <div class=\"block-hd with-operation\">\r                <div class=\"block-title f-fl\"><%=BabelStr.str(13029)%></div>\r              </div>\r              <div class=\"ai-token-switch\"></div>\r            </div>\r            <div class=\"help-block\">\r              <%=BabelStr.str(13030)%>\r            </div>\r          </div>\r        </div>\r        <div class=\"statistics-block\">\r          <div class=\"block\">\r            <div class=\"block-hd with-operation\">\r              <div class=\"block-title f-fl\"><%=BabelStr.str(4900)%></div> <!-- 使用情况统计 -->\r            </div>\r            <div class=\"file-statistics\" class=\"block-bd  \">\r              <div class=\"mgb-10 my-share-btn text-button\"><%=BabelStr.str(22050)%></div>\r              <div class=\"mgb-10 joinshare-log text-button\"><%=BabelStr.str(21611)%></div>\r              <div class=\"mgb-10 joinproject-log text-button\"><%=BabelStr.str(21612)%></div>\r              <div class=\"mgb-10 specialfiles text-button\"><%=BabelStr.str(21609)%></div>\r              <div class=\"mgb-10 upload-list text-button\"><%=BabelStr.str(6364)%></div>\r              <div class=\"mgb-10 login-list text-button\"><%=BabelStr.str(21601)%></div>\r              <div class=\"mgb-10 export-file-list text-button\"><%=BabelStr.str(4854)%></div>\r            </div>\r          </div>\r        </div>\r      </div>\r      <!--right-block-end-->\r    </div>  </div>","basicInfoForm":"<div class=\"block\">\r      <div class=\"block-hd\">\r        <h2 class=\"block-title\"><%=basicInfo%></h2> <!-- 基本信息 -->\r      </div>\r      <div class=\"block-bd\">\r        <form action=\"\" class=\"form-horizontal\">\r          <div class=\"form-item row\">\r            <label for=\"\" class=\"col-3\"><b class=\"form-required\"></b><%=nameStr%>：</label> <!-- 姓名 -->\r            <div class=\"col-9\">\r              <input type=\"text\" name=\"username\" class=\"form-control textinput\" id=\"js-userName\" value=\"<%=name%>\" required maxlength=\"20\">\r            </div>\r          </div>\r          <div class=\"form-item row\" data-needhide=\"true\">\r            <label for=\"\" class=\"col-3\"><%=sexStr%>：</label>  <!-- 性别 -->\r            <div class=\"col-9\">\r              <label class=\"radio-inline\">\r                <input type=\"radio\" name=\"sex\" value=\"1\" <%if(sex==1){%>checked=\"\"\r                <%}%>><%=manStr%>  <!-- 男 -->\r              </label>\r              <label class=\"radio-inline\">\r                <input type=\"radio\" name=\"sex\" value=\"2\" <%if(sex==2){%>checked=\"\"\r                <%}%>><%=womanStr%>  <!-- 女 -->\r              </label>\r            </div>\r          </div>\r          <div class=\"form-item row\">\r            <label for=\"\" class=\"col-3\"><%=BabelStr.str(488)%>：</label> <!-- 联系方式 -->\r            <div class=\"col-9\">\r              <input type=\"text\" name=\"phone\" class=\"form-control textinput\" id=\"js-phone\" placeholder=\"<%=BabelStr.str(488)%>\" value=\"<%=phone%>\">\r            </div>\r          </div>\r          <div class=\"form-item row\">\r            <label for=\"\" class=\"col-3\"><%=BabelStr.str(3030)%>：</label> <!-- 邮箱 -->\r            <div class=\"col-9\">\r              <input type=\"text\" name=\"email\" class=\"form-control\" id=\"js-email\" placeholder=\"<%=BabelStr.str(3030)%>\" value=\"<%=email%>\">\r            </div>\r          </div>\r          <div class=\"form-item row\">\r            <label for=\"\" class=\"col-3\"><%=joinTimeStr%>：</b> <!-- 入职时间 -->\r            </label>\r            <div class=\"col-9\">\r              <div class=\"form-control datepicker\">\r                <input type=\"text\" id=\"js-joinTime\" name=\"joinDate\" readonly required placeholder=\"<%=joinTimeStr%>\">\r                <i class=\"ep-ic ep-ic-date\"></i>\r              </div>\r            </div>\r          </div>\r          <div class=\"form-item row\">\r            <label for=\"\" class=\"col-3\"><%=remarkStr%>：</label>\r            <div class=\"col-9\">\r              <textarea class=\"form-control textinput\" id=\"js-backlog\" rows=\"3\" maxlength=\"200\" placeholder=\"<%=remarkStr%>\">\r                <%=remarks%>\r              </textarea>\r            </div>\r          </div>\r          <div class=\"form-item row\">\r            <label for=\"\" class=\"col-3\"></label>\r            <div class=\"col-9\">\r              <button id=\"js-updateUserInfo\" class=\"button done\"><%=saveStr%></button>\r              <button id=\"js-cancelEditBasicInfo\" class=\"button default\"><%=cancleStr%></button> <!-- 取消 -->\r            </div>\r          </div>\r      </div>\r      </form>\r    </div>","accountStatus":"<%if (status == 1){%>\r        <span class=\"account-stopped\"><%=stoppedStr%></span> <!-- 已停用 -->\r        <button id=\"js-restoreAccount\" class=\"text-button done\"><%=recoverStr%></button>\r        <%}else{%>\r          <button id=\"js-stopAccount\" class=\"text-button danger done\"><%=stopStr%></button> <!-- 停用 -->\r          <%}%>","basiInfoBlock":"<div class=\"block\">\r                <div class=\"block-hd with-operation\">\r                  <div class=\"block-title f-fl\"><%=basicInfoStr%></div> <!-- 基本信息 -->\r                  <div class=\"f-fr\">\r                    <button id=\"js-editBasicInfo\" class=\"text-button done \"><%=editStr%></button> <!-- 修改 -->\r                    <%if(canEditPwd){%>\r                      <button id=\"js-changePwd\" class=\"text-button done \"><%editPasswordStr%></button> <!-- 修改密码 -->\r                      <%}%>\r                  </div>\r                </div>\r                <div id=\"js-infoBlock\" class=\"block-bd\">\r                  <div class=\"row\">\r                    <div class=\"col-2\">\r                      <img id=\"js-avatar\" alt=\"\" data-src=\"<%=avatarURL%>\" class=\"avatar\">\r                    </div>\r                    <div class=\"col-10\">\r                      <div class=\"detail-list horizonal\">\r                        <div class=\"detail-list-item\">\r                          <div class=\"detail-list-item-aside\">\r                            <div class=\"detail-list-item-label\"><%=nameStr%>：</div> <!-- 姓名 -->\r                          </div>\r                          <div class=\"detail-list-item-main text-hide\" title=\"<%=name%>\">\r                            <%=name%>\r                          </div>\r                        </div>\r                        <div class=\"detail-list-item\r\">\r                          <div class=\"detail-list-item-aside\">\r                            <div class=\"detail-list-item-label\"><%=accountStr%>：</div> <!-- 邮箱 -->\r                          </div>\r                          <div class=\"detail-list-item-main text-hide\" title=\"<%=account%>\">\r                            <%=account%>\r                          </div>\r                        </div>\r                        <div class=\"detail-list-item\">\r                          <div class=\"detail-list-item-aside\">\r                            <div class=\"detail-list-item-label\"><%=sexStr%>：</div>\r                          </div>\r                          <div class=\"detail-list-item-main\">\r                            <%if(sex==0){%>--\r                              <%}else if(sex==1){%><%=manStr%>  <!-- 男 -->\r                                <%}else{%><%=womanStr%>  <!-- 女 -->\r                                  <%}%>\r                          </div>\r                        </div>\r                        <div class=\"detail-list-item\r\">\r                          <div class=\"detail-list-item-aside\">\r                            <div class=\"detail-list-item-label\"><%=emailStr%>：</div> <!-- 邮箱 -->\r                          </div>\r                          <div class=\"detail-list-item-main text-hide\" title=\"<%=email%>\">\r                            <%=email%>\r                          </div>\r                        </div>\r                        <div class=\"detail-list-item\">\r                          <div class=\"detail-list-item-aside\">\r                            <div class=\"detail-list-item-label\"><%=BabelStr.str(488)%>：</div> <!-- 联系方式 -->\r                          </div>\r                          <div class=\"detail-list-item-main\">\r                            <%=phone%>\r                          </div>\r                        </div>\r                        <div class=\"detail-list-item\">\r                          <div class=\"detail-list-item-aside\">\r                            <div class=\"detail-list-item-label\"><%=joinTimeStr%>：</div> <!-- 入职时间 -->\r                          </div>\r                          <div class=\"detail-list-item-main\">\r                            <%=joinEnterpriseTime%>\r                          </div>\r                        </div>\r                        <div class=\"detail-list-item\">\r                          <div class=\"detail-list-item-aside\">\r                            <div class=\"detail-list-item-label\"><%=remarkStr%>：</div> <!-- 备注 -->\r                          </div>\r                          <div class=\"detail-list-item-main\">\r                            <%=remarks%>\r                          </div>\r                        </div>\r                      </div>\r                    </div>\r                  </div>\r                </div>\r              </div>","extraRoleItem":"<div class=\"extra-role-block\">\r                  <span class=\"ep-ic ep-ic-sm-close f-fr\" title=\"<%=removeStr%>\"></span>\r                  <div class=\"form-item row\">\r                    <label for=\"\" class=\"col-30 txt-r\"><%=paredtDepStr%>：</label> <!-- 所属部门 -->\r                    <div class=\"col-60\">\r                      <select name=\"\" id=\"js-departSlot\" class=\"form-control\"></select>\r                    </div>\r                  </div>\r                  <div class=\"form-item row\">\r                    <label for=\"\" class=\"col-30 txt-r\"><%=roleStr%>：</label> <!-- 角色 -->\r                    <div class=\"col-60\">\r                      <select name=\"\" id=\"js-roleSlot\" class=\"form-control\"></select>\r                    </div>\r                  </div>\r                </div>","editDepartRole":"<div id=\"js-editRoleBlock\">\r                    <form action=\"\" class=\"form-horizontal\">\r                      <div id=\"js-editRoleList\" class=\"extra-role-list\">\r                      </div>\r                      <!--新增附加角色-->\r                      <div class=\"add-role-wrap\">\r                        <span id=\"js-addNewRole\" class=\"add-role-btn\"><i class=\"ep-ic ep-plus-blue\"></i><%=addRoleStr%></span> <!-- 新增角色 -->\r                        <p class=\"help-block\"><%=addRoleTipStr%></p> <!-- 巴别鸟允许一个人在多个部门使用不同角色 -->\r                      </div>\r                      <div class=\"mgb-10\">\r                        <a id=\"js-updateDepartInfo\" class=\"button done\"><%=saveStr%></a> <!-- 保存 -->\r                        <a id=\"js-cancelEditDepartInfo\" class=\"button default\"><%=cancleStr%></a> <!-- 取消 -->\r                      </div>\r                    </form>\r                  </div>","roleList":"<div id=\"js-roleList\" class=\"role-list \">\r                      <ul>\r                        <%for(var i = 0 ; i < departs.length ; i ++){%>\r                          <li>\r                            <div><span class=\"label-name\"><%=paredtDepStr%>：</span><span class=\"role-content\"><%=departs[i].departmentName%></span></div> <!-- 所属部门 -->\r                            <div><span class=\"label-name\"><%=roleStr%>：</span><span class=\"role-content\"><%=departs[i].roleName%></span></div> <!-- 角色 -->\r                          </li>\r                          <%}%>\r                      </ul>\r                    </div>","spaceBlock":"<div class=\"space-info-block\"></div>","lastlogin":"<div class=\"help-block last-login\"><%=BabelStr.str(3068)%>: <%=recentAccessTime%></div>\r      <%if(deviceArr.length > 0){%>\r        <div class=\"online-block\">\r          <div class=\"block-hd mgt-15\">\r            <div class=\"mgb-10 block-title\"><%=BabelStr.str(2564)%></div>\r          </div>\r          <div class=\"list\">\r            <%for(var i = 0 ; i < deviceArr.length ; i++){%>\r              <div class=\"flex-align between item help-block mgb-10\" data-sessionid = \"<%=deviceArr[i].sessionId%>\">\r                <div>\r                  <span><%=deviceArr[i].name%></span>\r                </div>\r                <div class=\"flex-align between right\"></div>\r                  <div class=\"text-hide flex-align middle\"><%=deviceArr[i].clientStr%></div>\r                  <div class=\"text-button done no-shrink mgl-10 exit\"><%=BabelStr.str(2566)%></div>\r                </div>\r              </div>\r            <%}%>\r          </div>\r        </div>\r      <%}%>"};
},{}],121:[function(require,module,exports){
module.exports = {"root":"<div class=\"window-inner\">\r    <div class=\"horizonal-divider\"></div>\r    <form action=\"\" autocomplete=\"off\" class=\"form-horizontal\">\r      <div class=\"container\">\r        <div class=\"row\">\r          <div class=\"col-6 basic-setting\">\r            <div class=\"block\">\r              <div class=\"block-hd\">\r                <h2 class=\"block-title\"><%=basic%></h2>\r              </div>\r              <div class=\"block-bd\">\r                <div class=\"form-item row\">\r                  <label for=\"\" class=\"col-3\"><b class=\"form-required\"></b><%=IDStr%>：</label>\r                  <div id=\"js-searchEmailWrap\" class=\"col-9\">\r                    <input type=\"text\" name=\"email\" class=\"form-control\" id=\"js-email\"  placeholder=\"<%=BabelStr.str(3030)%>\">\r                    <div class=\"mgtb-10\"><%=BabelStr.str(6228)%></div>\r                    <input type=\"text\" name=\"phone\" class=\"form-control\" id=\"js-phone\"  placeholder=\"<%=BabelStr.str(3031)%>\">\r                    <p class=\"help-block\"><%=receiveMail%></p>\r                  </div>\r                </div>\r                <div class=\"form-item row\">\r                  <label for=\"\" class=\"col-3\"><b class=\"form-required\"></b><%=name%>：</label>\r                  <div class=\"col-9\">\r                    <input type=\"text\" name=\"username\" class=\"form-control notempty textinput\" id=\"js-userName\" required notempty maxlength=\"20\" placeholder=\"<%=name%>\">\r                  </div>\r                </div>\r                <div class=\"form-item row\" data-needhide=\"true\">\r                  <label for=\"\" class=\"col-3\"><b class=\"form-required\"></b><%=pswd%>：</label>\r                  <div class=\"col-9\">\r                    <div class=\"row\">\r                      <div class=\"col-6\">\r                        <input type=\"text\" name=\"password\" class=\"form-control\" id=\"js-password\" required placeholder=\"<%=pswd%>\">\r                      </div>\r                      <div class=\"col-6\">\r                        <span id=\"js-randomPwdBtn\" class=\"form-control-static f-inline-block text-button\"><%=randPwd%></span>\r                      </div>\r                    </div>\r                    <p class=\"help-block\"><%=changePwd%></p>\r                  </div>\r                </div>\r                <div class=\"form-item row\" data-needhide=\"true\">\r                  <label for=\"\" class=\"col-3\"><%=sex%>：</label>\r                  <div class=\"col-9\">\r                    <label class=\"radio-inline\">\r                      <input type=\"radio\" name=\"sex\" value=\"1\" checked=\"\"><%=male%>\r                    </label>\r                    <label class=\"radio-inline\">\r                      <input type=\"radio\" name=\"sex\" value=\"2\"><%=female%>\r                    </label>\r                  </div>\r                </div>\r                <div class=\"form-item row\">\r                  <label for=\"\" class=\"col-3\"><%=joinDate%>：</b>\r                  </label>\r                  <div class=\"col-9\">\r                    <div class=\"form-control datepicker\">\r                      <input type=\"text\" id=\"js-joinTime\" name=\"joinDate\" readonly required placeholder=\"<%=joinDate%>\">\r                      <i class=\"ep-ic ep-ic-date\"></i>\r                    </div>\r                  </div>\r                </div>\r                <div class=\"form-item row\">\r                  <label for=\"\" class=\"col-3\"><%=remark%>：</label>\r                  <div class=\"col-9\">\r                    <textarea class=\"form-control textinput\" id=\"js-backlog\" rows=\"3\" maxlength=\"200\" placeholder=\"<%=remark%>\"></textarea>\r                  </div>\r                </div>\r              </div>\r            </div>\r          </div>\r          <!--basic-setting -end-->\r          <div class=\"col-6 auth-setting\">\r            <div class=\"block\">\r              <div class=\"block-hd\">\r                <h2 class=\"block-title\"><%=roleSet%></h2>\r              </div>\r              <div class=\"block-bd\">\r                <div class=\"default-role-block\">\r                  <div class=\"form-item row\">\r                    <label for=\"\" class=\"col-30\"><%=dep%>：</label>\r                    <div class=\"col-8\">\r                      <select name=\"\" id=\"js-departSlot\" class=\"form-control\"></select>\r                    </div>\r                  </div>\r                  <div class=\"form-item row\">\r                    <label for=\"\" class=\"col-30\"><%=role%>：</label>\r                    <div class=\"col-8\">\r                      <select name=\"\" id=\"js-roleSlot\" class=\"form-control\"></select>\r                    </div>\r                  </div>\r                </div>\r                <!--动态角色-->\r                <div id=\"js-roleList\" class=\"extra-role-list\">\r                </div>\r                <!--新增附加角色-->\r                <%if(!disabledDepChoose){%>\r                <div class=\"add-role-wrap\">\r                  <span class=\"add-role-btn\"><i class=\"ep-ic ep-plus-blue\"></i><%=newRole%></span>\r                  <p class=\"help-block\"><%=multiRole%></p>\r                </div>\r                <%}%>\r              </div>\r              <!--管理员权限-->\r<!--               <div class=\"open-admin-block\">\r                <div class=\"flex-row middle\">\r                  <div class=\"col-10\">\r                    <span>管理员权限</span>\r                    <p class=\"help-block\">开启管理员权限后，可以查看并管理企业部门文件，以及管理员工以及企业外部人员信息</p>\r                  </div>\r                  <div class=\"col-2 text-right\">\r                    <div id=\"swicthSlot\"></div>\r                  </div>\r                </div>\r              </div> -->\r              <!--文档管理员权限-->\r<!--               <div class=\"open-admin-block\">\r                <div class=\"flex-row middle\">\r                  <div class=\"col-10\">\r                    <span>文档管理员权限</span>\r                    <p class=\"help-block\">开启管理员权限后，可以查看并管理企业部门文件</p>\r                  </div>\r                  <div class=\"col-2 text-right\">\r                    <div id=\"swicthSlot\"></div>\r                  </div>\r                </div>\r              </div> -->\r            </div>\r            <!--  企业角色 -->\r            <div class=\"block pdb-20 role-block\">\r              <div class=\"block-hd \">\r                <div class=\"block-title f-fl\"><%=entRole%></div>\r              </div>\r              <div class=\"role-select-block\"></div>\r            </div>\r            <!--  空间设置 -->\r            <div class=\"block pdb-20 role-block\">\r              <div class=\"block-hd \">\r                <div class=\"block-title f-fl\"><strong><%=personSpace%></strong></div>\r              </div>\r              <div class=\"space-info-block\"></div>\r            </div>\r          </div>\r        </div>\r      </div>\r    </form>\r  </div>","extraRoleItem":"<div class=\"extra-role-block\">\r      <span class=\"ep-ic ep-ic-sm-close f-fr rm-extra-role\" title=\"<%=title%>\"></span>\r      <div class=\"form-item row\">\r        <label for=\"\" class=\"col-4\"><%=dep%>：</label>\r        <div class=\"col-8\">\r          <select name=\"\" id=\"js-departSlot\" class=\"form-control\"></select>\r        </div>\r      </div>\r      <div class=\"form-item row\">\r        <label for=\"\" class=\"col-4\"><%=role%>：</label>\r        <div class=\"col-8\">\r          <select name=\"\" id=\"js-roleSlot\" class=\"form-control\"></select>\r        </div>\r      </div>\r    </div>"};
},{}],120:[function(require,module,exports){
module.exports = '<div class="row header">\  <div class="f-fl">\    <button class="button done new-member" disabled><%=BabelStr.str(3268)%></button>\    <div class="search-box search-box-inline">\      <i class="icon-search"></i>\      <input type="text" class="search-input" placeholder="<%=BabelStr.str(579)%>...">\    </div>\  </div>\  <div class="operate-box f-fr f-tr">\    <div class="button-group">\      <button class="button done upload-member mgl-10"><%=BabelStr.str(3273)%></button>\      <button class="button done new-member-from-inner" disabled><%=BabelStr.str(3270)%></button>\          <!--<button class="button done change-depart" disabled>修改部门</button> -->\      <button class="button done list-upload" disabled><%=BabelStr.str(6365)%></button>\      <span class="menu-more-w icon more-munu mgl-10"></span>\    </div>\  </div>\</div>\<div class="table-wrap"></div>';
},{}],113:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1477);
require(1541);
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDInputFileNamePanel = _interopRequireDefault(require(1125));
var _MDfileUploadList = _interopRequireDefault(require(345));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDLoadMaskView = _interopRequireDefault(require(49));
var _drawio = _interopRequireDefault(require(114));
// import MDTextEditor from './MDTextEditor.js';

var MDDrawioEditorController = {
  editor: null,
  createNewDrawioFile: function createNewDrawioFile() {
    // if (!this.editor) {
    initPanel.call(this);
    _MDLoadMaskView["default"].show();
    this.initDrawio();
    // }
  },
  openFile: function openFile(fileInfo, version, callback) {
    var _this = this;
    initPanel.call(this);
    _czc && _czc.push(["_trackEvent", "预览", "drawio", "", "", ""]);
    var fileId = fileInfo.getFileId();
    this.fileInfo = fileInfo;
    this.fileName = fileInfo.getFileName();
    this.isVsdx = fileInfo.isVsdx();

    // var path = '/readme.md';//MMCommonFun.getDocumentDispPath(fileId, version, callback);
    var self = this;
    // getDownloadRealPath
    // MMCommonFun.getDocumentDispPath
    _MDLoadMaskView["default"].show();
    MMCommonFun.getDownloadRealPath(fileId, -1, function (url) {
      MDDrawioEditorController.url = url;
      _this.initDrawio();
    }, function (errorCode, msg) {
      _MDLoadMaskView["default"].remove();
      if (errorCode == 227) {
        _MDSnackbarView["default"].show(msg);
      } else {
        _MDSnackbarView["default"].show('[' + errorCode + ']' + BabelStr.str(5150) + '！');
      }
    });
  },
  drawioLoaded: function drawioLoaded(event) {
    window.openDrawio(MDDrawioEditorController.url, this.fileName);
    console.log(event);
  },
  drawioClosed: function drawioClosed(event) {
    MDDrawioEditorController.removeFromSuperview();
    window.openDrawio = null;
    console.log(event);
  },
  drawioImageCreated: function drawioImageCreated(evt) {
    console.log(evt);
    var imageType = evt.imageType,
      imageContent = evt.imageContent;
    switch (imageType) {
      case "png":
        console.log("base64 格式的 png 图片信息", imageContent);
        break;
      case "svg":
        MDDrawioEditorController.newSvgData = imageContent;
        saveFile.call(MDDrawioEditorController);
        break;
    }
  },
  initDrawio: function initDrawio() {
    var lan = BabelStr.getCurrentLanguage();
    if (lan == 'cn') {
      lan = "zh";
    }
    var openDrawio = (0, _drawio["default"])(window.drawioServerUrl + '/draw?hold=1&' + "lang=" + lan, {
      container: this.$el.find('.drawio-panel')[0],
      fileName: this.fileName || "",
      type: this.isVsdx ? "vsdx" : undefined
    });
    window.openDrawio = openDrawio;
    openDrawio(MDDrawioEditorController.url);
    _MDLoadMaskView["default"].remove();
    window.addEventListener("drawioLoaded", MDDrawioEditorController.drawioLoaded, false);
    window.addEventListener("drawioClosed", MDDrawioEditorController.drawioClosed, false);
    window.addEventListener("drawioImageCreated", MDDrawioEditorController.drawioImageCreated);
  },
  setFileName: function setFileName(name) {
    if (name) {
      var ext = MMCommonFun.getFileExtension(name);
      var reg = /^\d*$/;
      if (ext.length == 0 || ext[ext.length - 1].length == 0 || reg.test(ext[ext.length - 1])) {
        name += ".drawio";
      }
      this.fileName = name;
      // this.$el.find('.text-file-name').text(name);
    } else {
      this.fileName = null;
    }
  },
  removeFromSuperview: function removeFromSuperview() {
    window.removeEventListener("drawioLoaded", MDDrawioEditorController.drawioLoaded, false);
    window.removeEventListener("drawioClosed", MDDrawioEditorController.drawioClosed, false);
    window.removeEventListener("drawioImageCreated", MDDrawioEditorController.drawioImageCreated);
    this.$el.remove();
    // this.editor.removeFromSuperview();
    this.editor = null;
    this.fileInfo = null;
    this.fileName = null;
    MDDrawioEditorController.url = null;
    unregisterEvent.call(this);
    if (this.newVersionUploaded && this.refreshBrowserFun) {
      this.refreshBrowserFun();
    }
    this.refreshBrowserFun = undefined;
  }
};

// ---------------------  private function

function initPanel() {
  var text = "<div class=\"text-editor-root\">\n  <div class=\"text-panel\">\n  <div class=\"drawio-panel\">\n  </div>\n\n  </div>\n\n</div>";
  // var text = `<div class="drawio-panel flex-align center middle">
  //   正在加载中
  // </div>`
  this.$el = $(text);
  $(".app-root").append(this.$el);
  registerEvent.call(this);
}
function registerEvent() {
  var self = this;
  this.$el.find(".back-home").on("click", function (e) {
    location.href = "main.do";
  });
  this.$el.find(".text-close").on("click", function (e) {
    closeBtnClicked.call(self, e);
  });
  // this.$el.find(".text-save").on("click", function (e) {
  //   saveBtnClicked.call(self, e);
  // });
  // this.$el.find(".text-export").on("click", function (e) {
  //   exportClicked.call(self, e);
  // });
}
function unregisterEvent() {
  this.$el.find(".text-close").off("click");
  this.$el.find(".text-save").off("click");
  $(window).off("beforeunload.km");
}
function closeBtnClicked(e) {
  var _this2 = this;
  if (window.openDrawio) {
    window.openDrawio && window.openDrawio.close();
    window.openDrawio = null;
  }
  return;
  if (_.isEqual(this.originKmFileData, data)) {
    this.removeFromSuperview();
  } else {
    var alert = new _MDAlertView["default"]();
    alert.show({
      title: BabelStr.str(170),
      message: "<p class=\"title\">".concat(BabelStr.str(5108), "</p>"),
      className: "m-delAlertWin",
      // width: 350,
      buttons: [{
        label: BabelStr.str(3080),
        type: "done",
        onClick: function onClick() {
          saveFile.call(_this2, function () {
            _this2.removeFromSuperview();
          });
        }
      }, {
        label: BabelStr.str(5109),
        type: "done",
        onClick: function onClick() {
          _this2.removeFromSuperview();
        }
      }, {
        label: BabelStr.str(155)
      }]
    });
  }
}
function saveBtnClicked(e) {
  saveFile.call(this);
}
function exportClicked(e) {
  var win = new MDExportKityminderWinView({
    minder: this.editor.minder,
    name: this.fileName
  });
  win.show();
}
function saveFile(callback) {
  var _this3 = this;
  if (MDDrawioEditorController.fileName == null) {
    var text = MDDrawioEditorController.newSvgData;
    if (!text || text.length == 0) {
      _MDSnackbarView["default"].show(BabelStr.str(5110));
      return;
    }
    var inputFileNamePanel = new _MDInputFileNamePanel["default"]({
      saveFile: function saveFile(fileName) {
        _czc && _czc.push(["_trackEvent", "创建", "创建 md 文件", "", fileName, ""]);
        MDDrawioEditorController.setFileName(fileName);
        uploadNewFile.call(_this3);
        inputFileNamePanel.close();
        if (callback) {
          callback();
        }
      }
    });
    inputFileNamePanel.show();
  } else {
    uploadNewVersion.call(this, callback);
  }
}
function uploadNewFile() {
  var _this4 = this;
  if (!this.uploading) {
    this.uploading = true;
  }
  setTimeout(function () {
    _this4.uploading = false;
  }, 2000);
  var data = MDDrawioEditorController.newSvgData;

  // var dataInfo = {};
  // dataInfo.fileName = this.fileName;
  // dataInfo.name = this.fileName;
  // dataInfo.type = "text";
  // dataInfo.size = data.length;
  // dataInfo.text = data;

  var blob = new Blob([data], {
    type: 'text/plain'
  });
  var dataInfo = new File([blob], this.fileName);
  dataInfo.needCheckFileName = true;
  _MDfileUploadList["default"].pushFile(dataInfo, function (fileInfo) {
    // this.originKmFileData = this.newSvgData;
    _this4.fileInfo = fileInfo;
    // this.originDrawioData = data
    if (fileInfo) {
      // this.editor && this.editor.markClean();
    } else {
      MDDrawioEditorController.setFileName(null);
    }
    console.error("上传完毕");
    _MDAlertView["default"].showStandardPrompt({
      message: BabelStr.str(3556)
    });
  }, undefined, undefined, {
    len: 1
  });
}
function uploadNewVersion(callback) {
  var self = this;
  if (!this.fileInfo) {
    return;
  }
  var data = MDDrawioEditorController.newSvgData;

  // if(data == this.originDrawioData) {
  //   console.log('数据相同')
  //   return
  // }

  // var dataInfo = {};
  // dataInfo.fileName = this.fileName;
  // dataInfo.name = this.fileName;
  // dataInfo.type = "text";
  // dataInfo.size = data.length;
  // dataInfo.text = data;

  var blob = new Blob([data], {
    type: 'text/plain'
  });
  var dataInfo = new File([blob], this.fileName);
  _MDfileUploadList["default"].pushFile(dataInfo, this.fileInfo, function () {
    // this.originDrawioData = data
    console.error("上传完毕");
    _MDAlertView["default"].showStandardPrompt({
      message: BabelStr.str(3556)
    });
    if (callback) {
      callback();
    }
  });
}
var _default = exports["default"] = MDDrawioEditorController;

},{"1125":1125,"114":114,"1184":1184,"1417":1417,"1454":1454,"1463":1463,"1477":1477,"1541":1541,"32":32,"345":345,"49":49,"72":72}],100:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var EmailVerifyCodeType = {
  BindEmail: 1,
  InitPwd: 5,
  RetrievePwd: 4,
  REBIND_EMAIL: 6
};
var _default = exports["default"] = EmailVerifyCodeType;

},{"1454":1454}],92:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require(1180));
require(1466);
require(1417);
require(1463);
var _MDWindowView = _interopRequireDefault(require(93));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDNavigationView = _interopRequireDefault(require(57));
/**
 * 以导航方式显示面板的window
 * Create by manjun.han
 * 2017.2.23
 */

var MDNavigationWindowView = _MDWindowView["default"].extend((0, _defineProperty2["default"])({
  headerTmpl: function headerTmpl() {
    return '<header class="window-header"> \
                <button class="u-nav-back-btn"></button> \
                <span class="title"></span> \
                <button class="icon closeBtn"></button> \
              </header>';
  },
  className: function className() {
    var superCls = _MDWindowView["default"].prototype.className.call(this);
    return superCls + ' m-nav-window';
  },
  events: function events() {
    var superE = _MDWindowView["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click >header .u-nav-back-btn': this.pop
    });
  },
  initProps: function initProps() {
    var superP = _MDWindowView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      navView: null,
      noRefreshWindow: false,
      _isNavigationWindowView: true,
      hideBackBtn: false
    });
  },
  addSubView: function addSubView(subView, opt_parent, opt_slot, opt_silentRender) {
    // subView.navigationView = this.navView;
    // subView.navigationWindowView = this.navigationWindowView;
    _MDWindowView["default"].prototype.addSubView.call(this, subView, opt_parent, opt_slot, opt_silentRender);
  },
  _setWidowTransitionAni: function _setWidowTransitionAni(enable) {
    if (!enable) {
      this.$el.addClass('disable-tran');
    } else {
      this.$el.removeClass('disable-tran');
    }
  },
  /**
   * @param {object} opt
   * @param {MDNavigationPageView} opt.rootNavigationPageView - 根nav页面
   */
  initialize: function initialize(props) {
    _MDWindowView["default"].prototype.initialize.call(this, props);
    this.navView = new _MDNavigationView["default"]({
      rootNavigationPageView: props.rootNavigationPageView,
      showNavigationBar: false
    });
    _MDWindowView["default"].prototype.addSubView.call(this, this.navView);
    // this.navView.visibleNavigationPageView.navigationWindowView = this;
    this.on('reLayout', this.reLayout, this);
    this._setWidowTransitionAni(false);
    _Dispatcher["default"].on('reLayout', this.reLayout, this);
  },
  initWithRootNavigationPageView: function initWithRootNavigationPageView(rootNavigationPageView) {
    this.navView.initWithRootNavigationPageView(rootNavigationPageView);
  },
  push: function push(navigationPageView, opt_animation, opt_cb) {
    var self = this;
    if (_.isFunction(opt_animation)) {
      opt_cb = opt_animation;
      opt_animation = undefined;
    }
    this.$body.css('overflow', 'hidden');
    this.$body[0].offsetWidth;
    // navigationPageView.navigationWindowView = this;
    this.setTitle(navigationPageView.getTitle());
    this.$body.transitionEndOnce(function () {
      self.$body.css('overflow', 'auto');
    });
    this.hideBackBtn = !navigationPageView.getShowNavigationBar();
    this.navView.push(navigationPageView, opt_animation, function () {
      _.isFunction(opt_cb) && opt_cb();
      self.refreshWindow();
    });
  },
  pop: function pop(opt_cb) {
    var self = this;
    this.$('.u-nav-back-btn').prop('disabled', true);
    this.$body.css('overflow', 'hidden');
    this.$body[0].offsetWidth;
    var pageView = this.navView.getNextPopNavigationPageView();
    this.setTitle(pageView.getTitle());
    this.$body.transitionEndOnce(function () {
      self.$body.css('overflow', 'auto');
    });
    this.navView.pop(function (newView) {
      _.isFunction(opt_cb) && opt_cb(newView);
      self.$body.css('overflow', 'auto');
      self.refreshWindow();
      self.$('.u-nav-back-btn').prop('disabled', false);
    });
  },
  popToRoot: function popToRoot(opt_cb) {
    var self = this;
    var pageView = this.navView.getNextPopNavigationPageView();
    this.setTitle(pageView.getTitle());
    this.navView.popToRoot(function () {
      _.isFunction(opt_cb) && opt_cb();
      self.refreshWindow();
    });
  },
  getPageViewStack: function getPageViewStack() {
    return this.navView.getPageViewStack();
  },
  refreshWindow: function refreshWindow() {
    this.refreshHeader();
    this.reLayout();
  },
  refreshHeader: function refreshHeader() {
    var stacks = this.navView.getPageViewStack();
    if (stacks.length == 1 || this.hideBackBtn) {
      this.$('.u-nav-back-btn').hide();
    } else {
      this.$('.u-nav-back-btn').show();
    }
  },
  viewDidRendered: function viewDidRendered() {
    _MDWindowView["default"].prototype.viewDidRendered.call(this);
    if (!this.noRefreshWindow) {
      this.refreshWindow();
    }
    this.setTitle(this.navView.visibleNavigationPageView.getTitle());
    this._setWidowTransitionAni(true);
  },
  reLayout: function reLayout() {
    var pageView = this.navView.visibleNavigationPageView;
    var height = parseInt(pageView.$el.find('.page-content').css('height'));
    height += parseInt(this.$body.css('padding-top'));
    height += parseInt(this.$body.css('padding-bottom'));
    this.$body.css('height', height);
  }
}, "addSubView", function addSubView() {
  throw new Error('MDNavigationWindowView 只能使用push方法添加子view');
}));
var _default = exports["default"] = MDNavigationWindowView;

},{"1180":1180,"1184":1184,"1417":1417,"1454":1454,"1463":1463,"1466":1466,"18":18,"57":57,"93":93}],89:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1438);
require(1431);
var _MMViewBase = _interopRequireDefault(require(22));
var _MDTableRowView = _interopRequireDefault(require(88));
var _MDTableHeaderView = _interopRequireDefault(require(87));
var _MDTableBodyView = _interopRequireDefault(require(85));
var _SortDirection = _interopRequireDefault(require(91));
var _PropType = _interopRequireDefault(require(90));
var _MDLocalString = _interopRequireDefault(require(1150));
/**
 *  Table view component
 *  Create by manjun.han
 *  date here(2015.6.24)
 */

/**
 * 类结构图(+ 代表包含一个， ++ 代表包含一个或多个,  <-- 表示继承）
 *
 *  MDTableView <----- MDFileTableView <----- MDEpFileTableView
 *      +
 *      |---- MDTableHeaderView
 *      |
 *      |---- MDTableBodyView
 *
 */

var scrollBarWidth = function scrollbarSize() {
  var $wrapper = $("<div>").css({
    width: 50,
    height: 50,
    overflowY: "scroll",
    position: "absolute",
    top: -10000
  });
  var $inner = $("<div>").css({
    width: "100%",
    height: "100%"
  });
  $wrapper.append($inner).appendTo("body");
  var w1 = $wrapper.innerWidth();
  var w2 = $inner.innerWidth();
  $wrapper.remove();
  return w1 - w2;
}();

// function scrollBarWidth() {
//   var d = document;
//   var b = d.body;
//   var div = d.createElement('div');
//   div.style.width = '50px';
//   div.style.height = '50px';
//   div.style.overflowY = 'scroll',
//     div.style.position = 'absolute';
//   div.style.top = '-10000px';

//   var innerDiv = d.createElement('div');
//   div.appendChild(innerDiv);
//   b.appendChild(div);
//   var scrollBarWidth = div.offsetWidth - div.clientWidth;
//   b.removeChild(div);
//   return scrollBarWidth;
// }

var DEFAULTS = {
  enableDragSelection: true
};
var MDTableView = _MMViewBase["default"].extend({
  tmpl: '<section></section>',
  className: function className() {
    var superCls = _MMViewBase["default"].prototype.className.call(this);
    return superCls + ' m-table';
  },
  initProps: function initProps() {
    var superProps = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superProps, {
      /**
       * 是否以绝对布局方式显示，绝对布局下，整个table会占据窗口的某个部分，并
       * 适配窗口的resize事件
       *
       * @type {Boolean}
       */
      fullMode: true,
      headerView: null,
      bodyView: null,
      contextMenuView: null,
      /**
       * For Table Header View
       */
      headerCls: '',
      headerShadowWhenBodyScroll: true,
      pageSize: 50,
      /**
       * For Table Body View
       */

      bodyCls: '',
      blankRenderer: "",
      isInitTable: true,
      loading: false,
      loadingRenderer: '<div class="spinner-loader" style="">' +
      // ---- 由函数 clearLoadingState 清除
      '<div class="spinner spinner-small">' + '<div class="bounce1"></div>' + '<div class="bounce2"></div>' + '<div class="bounce3"></div>' + '</div>' + '</div>',
      $loadingLayer: null,
      hide2removeOpt: true,
      //  隐藏 table 是否就删除 table 中的数据?

      rowCls: '',
      /**
       * @typedef {object} Column
       * @property {string} name -  表头名称
       * @property {string} dataIndex - 表头对象的数据列的名称
       * @property {string} cellCls - 列的className
       * @property {number} width - 列的宽度
       * @property {boolean} flex - 是否是flexbox布局
       */
      /**
       * 列定义
       * @type {Array<Column>}
       */
      columns: [],
      autoLoad: false,
      allowSelect: true,
      singleSelect: false,
      onlySelectByCheckbox: false,
      enableShiftMultiSelect: true,
      enableMetaKeyMultiSelect: true,
      enableContextMenu: true,
      sorters: [],
      rowClass: _MDTableRowView["default"],
      _onRowSelectionChanged: function _onRowSelectionChanged() {},
      dataCollection: null,
      // Backbone.Collection
      enableDispatchScrollEvent: true,
      url: '',
      params: '',
      onBeforeRequest: function onBeforeRequest() {},
      onSuccess: function onSuccess() {},
      onError: function onError() {},
      onComplete: function onComplete() {},
      onTableScroll: _.noop,
      sortByRequestAvailable: true,
      useSortRows: false,
      // 虚拟滚动默认关闭，确保未显式启用的 table 继续使用原完整渲染逻辑。
      virtualScroll: false,
      // 尚未测量到实际高度时使用的行高估算值。
      virtualRowHeight: 50,
      // 可视区域上下额外保留的行数，降低快速滚动时的白屏概率。
      virtualBuffer: 10,
      // 虚拟内容底部额外预留高度，单位 px；默认不改变原表格底部布局。
      virtualBottomSpacing: 0,
      // --- Grid 虚拟滚动 ---
      // 开启后按瀑布流布局只渲染可见行；grid 模式专用。
      virtualGridScroll: false,
      // 网格列数计算函数，需由调用方提供。
      virtualGridColumnCount: null,
      // 网格列间距，单位 px。
      virtualGridGutter: 12,
      // 网格行高预估值，单位 px。
      virtualGridRowHeightEstimate: 200,
      rowOption: null
    });
  },
  /**
   * Proxy function for onRowSelectionChanged
   */
  rowSelectionChangeProxy: function rowSelectionChangeProxy() {
    var datasSeleted = this.getSelectedModels();
    if (_.isFunction(this._onRowSelectionChanged)) {
      this._onRowSelectionChanged(datasSeleted);
    }
    this.trigger('selectionChange', datasSeleted);
  },
  /**
   * @callback onRowSelectionChangedCb
   * @param {Array} selectedModels 选中的数据对象数组
   */

  /**
   * @callback SortFn
   * @param {Backbone.Model} preItem - 前一个数据项
   * @param {Backbone.Model} curItem - 当前数据项目
   * @param {SortDirection}  order - 排序顺序
   */

  /**
   * @typedef {object} Sorter
   * @property {stirng} dataIndex - dataIndex字符串，为model的属性名称
   * @property {SortDirection} direction - 排序方向
   * @property {PropType} propType - 属性类型
   * @property {boolean} active - 是否是当前排序字段
   * @property {SortFn} sortFn - 排序算法函数
   */

  /**
   * @type {object} opt - 选项
   * @type {onRowSelectionChangedCb} [opt.onRowSelectionChanged] - 选中状态变更后的回调
   * @type {MDTableRowView} [opt.rowClass=MDTableRowView] - 行的类型
   * @type {string} [opt.bodyCls] - tableBody的样式
   * @type {Backbone.Collection} [opt.dataCollection = null] - tableView的数据collection
   * @type {boolean} [opt.allowSelect=true] - 是否能够选中行，false后
   * @type {Array<Sorter>} [opt.sorters = []] - 排序选项
   * @type {boolean} [opt.fullMode = true] - 是否是全屏模式
   * @type {Array<Column>} columns - 表格列定义
   * @type {boolean} [opt.enableContextMenu = true] - 是否允许右键菜单
   * @type {boolean} [opt.enableMetaKeyMultiSelect = true] - 是否允许使用meta键盘多选
   * @type {boolean} [opt.enableShiftMultiSelect = true] - 是否允许shift键盘多选
   * @type {boolean} [opt.singleSelect=false] - 是否是单选模式
   * @type {string} [opt.blankRenderer] - 没有行时的空白提示
   * @type {MDMenuView} [opt.contextMenuView=null] - 右键菜单对象
   * @type {string} [opt.rowCls] - 行的className
   * @type {function} [opt.onContextmenu] - 右键菜单的回调函数
   * @type {boolean} [opt.enableDragSelection] - 是否允许拖拽选择
   * @type {boolean} [opt.unSelectRowWhenClickOutside] - 点击在tableBody内时，如果没点在row上是否自动取消选中
   * @type {object} [opt.rowOption] - row的额外配置对象
   *
   */

  initialize: function initialize(opt) {
    this.bindSelf([this.rowSelectionChangeProxy, this._controlShadowToHeader, this._reLayout]);
    var _onRowSelectionChanged = opt.onRowSelectionChanged;
    _.extend(opt, {
      onRowSelectionChanged: this.rowSelectionChangeProxy
    });
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this._onRowSelectionChanged = _onRowSelectionChanged;
    this.opt = opt;
    this._renderContent();
    if (this.dataCollection && !this.dataCollection.length) {
      this.dataCollection.isInit = true;
    }
    this.setDataCollection(this.dataCollection, true);
    this.contextMenuView = null;
    this._contentResizeEventName = this.$nsEventName('resize.table-content');
    this._windowResizeEventName = this.$nsEventName('resize');
    this._bindcontentResizeHander = _.throttle(this._contentResizeHander.bind(this), 100);
    this._throttledRelayout = _.throttle(this._reLayout.bind(this), 300);
  },
  _contentResizeHander: function _contentResizeHander() {
    var $content = this.$('.table-content');
    var $headerWrapper = this.$('.headerWrapper');
    if (!$content.length || !$headerWrapper.length) {
      return;
    }
    var width = $content.outerWidth();
    if (width !== undefined && $headerWrapper.width() !== width) {
      $headerWrapper.width(width);
    }
  },
  _bindResizeHandlers: function _bindResizeHandlers() {
    var $window = $(window);

    // 先解绑，保证重复进入 rendered 生命周期时仍然只有一组监听。
    this._unbindResizeHandlers();
    $window.on(this._contentResizeEventName, this._bindcontentResizeHander);
    if (this.fullMode) {
      $window.on(this._windowResizeEventName, this._throttledRelayout);
    }
    this._bindcontentResizeHander();
  },
  _unbindResizeHandlers: function _unbindResizeHandlers() {
    var $window = $(window);
    if (this._contentResizeEventName) {
      $window.off(this._contentResizeEventName, this._bindcontentResizeHander);
    }
    if (this._windowResizeEventName) {
      $window.off(this._windowResizeEventName, this._throttledRelayout);
    }
    if (this._bindcontentResizeHander && this._bindcontentResizeHander.cancel) {
      this._bindcontentResizeHander.cancel();
    }
    if (this._throttledRelayout && this._throttledRelayout.cancel) {
      this._throttledRelayout.cancel();
    }
  },
  _controlShadowToHeader: function _controlShadowToHeader($e) {
    var scrollTop = $e.currentTarget.scrollTop;
    var $header = $(this.getHeaderEl());
    if (scrollTop > 0) {
      !$header.hasClass("shadow") && $header.addClass('shadow');
    } else {
      $header.removeClass('shadow');
    }
  },
  getDataCollection: function getDataCollection() {
    return this.dataCollection;
  },
  getOnlySelectByCheckbox: function getOnlySelectByCheckbox() {
    return this.onlySelectByCheckbox;
  },
  setEnableDragSelection: function setEnableDragSelection(enabled) {
    this.bodyView.setEnableDragSelection(enabled);
  },
  setDataCollection: function setDataCollection(dataCollection, opt_sort, opt_silent) {
    if (!dataCollection) {
      return;
    }
    var self = this;
    if (this.dataCollection) {
      this.stopListening(this.dataCollection);
    }
    this.dataCollection = dataCollection;
    this.headerView.setDataCollection(dataCollection, opt_silent);
    function renderBody() {
      self.bodyView.setDataCollection(dataCollection, opt_silent);
      self.listenTo(self.dataCollection, 'update', self._dataCollectionUpdated);
      self._reLayout();
    }
    var sorter = this.getActiveSorter();
    opt_sort = _.isUndefined(opt_sort) ? true : opt_sort;
    try {
      if (opt_sort && sorter) {
        // 排序完成后 renderBody() 会重新绑定 body 的 Collection 并完整渲染。
        // 如果传入的是当前正在使用的 Collection，先移除 body 的 sort 监听，
        // 避免 Collection.sort() 先触发一次 _renderSortedRows()，随后又触发
        // bodyView.setDataCollection() 内部的 _renderRows()。
        if (this.bodyView && this.bodyView.dataCollection === dataCollection) {
          this.bodyView.stopListening(dataCollection);
        }
        this.sort(sorter.dataIndex, sorter.direction, true, true);
      }
    } finally {
      // 即使排序失败，也必须恢复 body 的监听关系和视图状态。
      renderBody();
    }
  },
  startFilterMode: function startFilterMode() {
    this.filterMode = true;
    this.originActiveSorter = this.getActiveSorter();
    this.bodyView.startFilterMode();
    this.headerView.startFilterMode();
  },
  isFilterMode: function isFilterMode() {
    return this.filterMode;
  },
  clearFilterMode: function clearFilterMode() {
    this.bodyView.beforeClearFilterMode();
    this.originActiveSorter && this.setActiveSorter(this.originActiveSorter, true, true);
    this.bodyView.clearFilterMode();
    this.headerView.clearFilterMode();
    this.filterMode = false;
  },
  renderFilterResult: function renderFilterResult() {
    this.bodyView.renderFilterResult();
  },
  refreshWithCurDataCollection: function refreshWithCurDataCollection() {
    this.setDataCollection(this.dataCollection);
  },
  getSortersInfors: function getSortersInfors() {
    return this.headerView.getSortersInfors();
  },
  getActiveSorter: function getActiveSorter() {
    return this.headerView.getActiveSorter();
  },
  setActiveSorter: function setActiveSorter(sorter, opt_sort, opt_force) {
    this.headerView.setActiveSorter(sorter, opt_sort, opt_force);
  },
  clearActiveSorter: function clearActiveSorter() {
    this.headerView.clearActiveSorter();
  },
  /**
   * 表格排序
   * @param dataIndex 排序属性名称
   * @param direction 排序方向, 参见 SortDirection
   * @param opt_force 是否强制重新排序
   */
  sort: function sort(dataIndex, direction, opt_force, opt_silent, onAfterSortCb) {
    this.headerView.sort(dataIndex, direction, opt_force, opt_silent, onAfterSortCb);
  },
  resetSort: function resetSort() {
    this.headerView.resetSort();
  },
  toggleSort: function toggleSort(dataIndex, opt_silent) {
    this.headerView.toggleSort(dataIndex, opt_silent);
  },
  getHeaderEl: function getHeaderEl() {
    return this.headerView.el;
  },
  getHeaderView: function getHeaderView() {
    return this.headerView;
  },
  getBodyEl: function getBodyEl() {
    return this.bodyView.el;
  },
  getBodyView: function getBodyView() {
    return this.bodyView;
  },
  getContentSubviews: function getContentSubviews() {
    return this.getBodyView().getSubViews();
  },
  addRowAt: function addRowAt(rowData, index) {
    this.bodyView.addRowAt(rowData, index);
  },
  appendRow: function appendRow(rowData) {
    this.addRowAt(rowData, this.dataCollection.length);
  },
  prependRow: function prependRow(rowData) {
    this.addRowAt(rowData, 0);
  },
  removeRowAt: function removeRowAt(index) {
    this.bodyView.removeRowAt(index);
  },
  clearRow: function clearRow(silent) {
    this.bodyView.clearRow(silent);
  },
  selectRowAt: function selectRowAt(index, selected) {
    this.bodyView.selectRowAt(index, selected);
  },
  setAllRowSelected: function setAllRowSelected(selected) {
    this.headerView.setSelection(selected);
    this.bodyView.setAllRowSelected(selected);
  },
  allSelected: function allSelected() {
    return this.bodyView.allSelected();
  },
  hasSelectedRow: function hasSelectedRow() {
    return this.bodyView.hasSelectedRow();
  },
  layout: function layout() {
    this._reLayout();
  },
  _renderContent: function _renderContent() {
    var _this = this;
    var self = this;
    // header
    var opt = _.extend({
      onBeforeSort: function onBeforeSort() {
        self.startLoadingState();
      },
      onAfterSort: function onAfterSort() {
        self.clearLoadingState();
      },
      onBeforeWebSort: function onBeforeWebSort() {
        self.onBeforeWebSort();
        // self.$loadedDiv = self.$('.loaded-sign')
      },
      onAfterWebSort: function onAfterWebSort() {
        self.onAfterWebSort();
      },
      onTableRowRemoved: function onTableRowRemoved(params) {
        self.onTableRowRemoved(params);
      },
      pageSize: this.pageSize
    }, this.opt);
    opt = _.omit(opt, 'className'); // 去掉className避免对headerView和bodyView创建时className的影响

    if (this.headerView) {
      this.headerView.removeFromSuperView();
    }
    opt.onSorted = this.onSorted;
    opt.sortByRequest = this.sortByRequest;
    opt.blankRenderer = function () {
      if (_.isFunction(_this.blankRenderer)) {
        return _this.blankRenderer();
      }
      return _this.blankRenderer;
    };
    this.headerView = new _MDTableHeaderView["default"](opt);
    this.addSubView(this.headerView, function ($headerViewEl) {
      self.$('>section').before($headerViewEl);
    });

    // body
    if (this.bodyView) {
      this.bodyView.removeFromSuperView();
    }
    this.bodyView = new _MDTableBodyView["default"](opt);
    this.addSubView(this.bodyView, function (bodyViewEl) {
      self.$('>section').prepend(bodyViewEl);
      _.isFunction(self.bodyRendered) && self.bodyRendered();
    });
  },
  setSortByRequestAvailable: function setSortByRequestAvailable(sortByRequestAvailable) {
    this.sortByRequestAvailable = sortByRequestAvailable;
    this.headerView.setSortByRequestAvailable(sortByRequestAvailable);
  },
  onBeforeWebSort: function onBeforeWebSort() {},
  onAfterWebSort: function onAfterWebSort() {},
  /**
   * 当body滚动时设置header的padding
   */
  _reLayout: function _reLayout() {
    if (!this.bodyView) {
      return;
    }
    this._refreshHeaderPadding();
    // resize 会改变短列表的可用高度，需要同步更新虚拟列表底部提示的位置。
    if (this.bodyView.virtualScroll && this.bodyView.dataCollection) {
      this.bodyView._positionVirtualLoadedSign(this.bodyView._getVirtualRange());
    }
  },
  _refreshHeaderPadding: function _refreshHeaderPadding() {
    var paddingRight = this.hasScrollBar(this.bodyView.el) ? scrollBarWidth : 0;
    this.headerView.$el.css({
      paddingRight: paddingRight
    });
  },
  hasScrollBar: function hasScrollBar(el, horizonal) {
    if (!el) {
      return false;
    }
    if (horizonal) {
      return el.offsetHeight > el.clientHeight;
    } else {
      return el.offsetWidth > el.clientWidth;
    }
  },
  isTableBodyScroll: function isTableBodyScroll() {
    return this.hasScrollBar(this.bodyView.el, false);
  },
  _dataCollectionUpdated: function _dataCollectionUpdated() {
    this._reLayout();
  },
  getSelectedRowViews: function getSelectedRowViews() {
    return this.bodyView.getSelectedSubViews();
  },
  getRowViews: function getRowViews() {
    return this.bodyView.getSubViews();
  },
  getSelectedModels: function getSelectedModels() {
    return this.bodyView.getSelectedModels();
  },
  viewDidUnRendered: function viewDidUnRendered() {
    this.clearLoadingState();
    this._unbindResizeHandlers();
    _MMViewBase["default"].prototype.viewDidUnRendered.call(this);
  },
  viewDidShow: function viewDidShow() {
    _MMViewBase["default"].prototype.viewDidShow.call(this);
    this.layout();
  },
  isSelectedAll: function isSelectedAll() {
    // 虚拟模式只有部分 row view，必须基于 collection 中的选择状态判断全选。
    if (this.bodyView.virtualScroll) {
      return this.bodyView.allSelected();
    }
    return this.getRowViews().length == this.getSelectedModels().length;
  },
  getContextMenuView: function getContextMenuView() {
    return this.contextMenuView;
  },
  setContextMenuView: function setContextMenuView(contextMenuView) {
    this.contextMenuView = contextMenuView;
  },
  //!{ added by jiang
  sortByDefault: function sortByDefault(unreadFileCount) {
    var sorter = this.getActiveSorter();
    if (sorter) {
      if (!unreadFileCount || sorter.dataIndex == 'unreadFileCount') {
        this.sort(sorter.dataIndex, sorter.direction, true);
      }
    } else {
      this.sort('unreadFileCount', _SortDirection["default"].Desc, true);
    }
    if (unreadFileCount && sorter == 'unreadFileCount') {} else {}
  },
  //!}
  //!
  viewDidHide: function viewDidHide() {
    _MMViewBase["default"].prototype.viewDidHide.call(this);
    if (this.hide2removeOpt) {
      this.clearRow(true);
    }
  },
  request: function request() {},
  refresh: function refresh() {},
  /**
   * @public
   */
  startLoadingState: function startLoadingState() {
    if (this.loading) {
      return;
    }
    var tmpl = this.loadingRenderer;
    if (_.isFunction(this.loadingRenderer)) {
      tmpl = this.loadingRenderer();
    }
    this.loading = true;
    this.bodyView && this.bodyView.$el.css('visibility', 'hidden');
    this.$loadingLayer = $('<div class="table-loading-indicator"></div>');
    this.$loadingLayer.append(tmpl);
    this.$el.addClass('table-loading');
    this.$loadingLayer.addClass('overlayer');
    this.$loadingLayer.appendTo(this.$('>section'));
    if (_MDLocalString["default"].getCurrentLanguage() != 'cn') {
      this.$loadingLayer.addClass("english");
    }
  },
  onTableRowRemoved: function onTableRowRemoved() {},
  /**
   * 清除等待 loading 的界面
   * @public
   */
  clearLoadingState: function clearLoadingState() {
    this.loading = false;
    this.$el.removeClass('table-loading');
    if (this.$loadingLayer) {
      this.$loadingLayer.remove();
      this.$loadingLayer = null;
      this.bodyView && this.bodyView.$el.css('visibility', 'visible');
    }
  },
  isLoading: function isLoading() {
    return this.loading;
  },
  showColumnByDataIndex: function showColumnByDataIndex(dataIndex) {
    var column = _.findWhere(this.columns, {
      dataIndex: dataIndex
    });
    if (column) {
      column.hidden = false;
    }
    ;
    this.headerView.renderColumn();
    this.bodyView._renderRows();
  },
  onlyShowColumnByDataIndex: function onlyShowColumnByDataIndex(dataIndex) {
    this.onluShowColumnMode = true;
    _.each(this.columns, function (column) {
      column.originHidden = column.hidden;
      if (column.dataIndex == dataIndex) {
        column.hidden = false;
      } else {
        column.hidden = true;
      }
    });
    this.headerView.renderColumn();
    this.bodyView._renderRows();
  },
  clearOnlyShowColumnByDataIndex: function clearOnlyShowColumnByDataIndex() {
    if (!this.onluShowColumnMode) {
      return;
    }
    this.onluShowColumnMode = false;
    _.each(this.columns, function (column) {
      column.hidden = column.originHidden;
      column.originHidden = undefined;
    });
    this.headerView.renderColumn();
    this.bodyView._renderRows();
  },
  hideColumnByDataIndex: function hideColumnByDataIndex(dataIndex) {
    var column = _.findWhere(this.columns, {
      dataIndex: dataIndex
    });
    if (column) {
      column.hidden = true;
    }
    ;
    this.headerView.renderColumn();
    this.bodyView._renderRows();
  },
  renderBlank: function renderBlank(blankRender) {
    this.bodyView && this.bodyView.removeSubViews();
    this.bodyView.renderBlank(blankRender);
  },
  viewDidRendered: function viewDidRendered() {
    _MMViewBase["default"].prototype.viewDidRendered.call(this);
    this.$loadingLayer && this.$loadingLayer.css({
      top: this.headerView.$el.height()
    });
    this._reLayout();
    this._bindResizeHandlers();
    // layout 后 body 高度才稳定，此时重新计算首屏虚拟范围。
    if (this.bodyView.virtualScroll) {
      this.bodyView._renderVirtualRows();
    } else if (this.bodyView.virtualGridScroll) {
      this.bodyView._renderVirtualGridRows();
    }
  },
  sortClicked: function sortClicked() {
    this.startLoadingState();
  },
  sortFinished: function sortFinished() {
    var self = this;
    this.bodyView.refresh(function () {
      self.clearLoadingState();
    });
  },
  setTableRowClass: function setTableRowClass(tableRowCls, columns, slient) {
    this.columns = columns;
    this.bodyView.setRowClass(tableRowCls, columns, slient);
    this.headerView.setColumns(columns, slient);
  },
  //
  // 临时方法，以后删除
  //
  renderNextPage: function renderNextPage(loadEnded) {
    this.bodyView.renderNextPage(loadEnded);
  },
  setPageSize: function setPageSize(pageSize) {
    this.pageSize = pageSize;
  }
}, {
  setDefaults: function setDefaults(defaults) {
    _.extend(DEFAULTS, defaults);
    _MDTableBodyView["default"].setDefaults(defaults);
  }
});
var _default = exports["default"] = MDTableView;

},{"1150":1150,"1184":1184,"1431":1431,"1438":1438,"1454":1454,"22":22,"85":85,"87":87,"88":88,"90":90,"91":91}],87:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1426);
require(1424);
require(1439);
require(1412);
require(1417);
require(1463);
require(1437);
require(1478);
require(1431);
require(1430);
var _MMViewBase = _interopRequireDefault(require(22));
var _SortDirection = _interopRequireDefault(require(91));
var _PropType = _interopRequireDefault(require(90));
/**
 *  Header view for table view
 *  Created by manjun.han
 *  2015.9.18
 */

var MDTableHeaderView = _MMViewBase["default"].extend({
  el: "<header></header>",
  tmpl: '<div class="t-row"></div>',
  events: function events() {
    return {
      "click .sortable": this._sortColumnClickHandler,
      "click .t-row .chb": this._onCheckAllSelectionChangeHandler,
      "click .help": this._helpClickHandler
    };
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      $tr: null,
      _arrows: {
        ASC: "asc",
        DESC: "desc"
      },
      _selected: false,
      /**
       * {
       *  dataIndex:'fileSize',
       *  direction:SortDirection.Asc,
       *  propType:PropType.Number,
       *  sortFn:function(pre , next , order){},
       *  @type {String} if missing , will get corresponding column name
       *  name:sortName
       * }
       */
      sorters: [],
      dataCollection: null,
      headerCls: "",
      /**
       * @callback renderFnCallback
       * @param {string} name dataIndex name
       * @param {object} model data model of the row
       * @param {number} index row index in the table body
       */

      /**
       * @typedef TableColumObject
       *
       * @type {object}
       * @property {string} name - column name.
       * @property {number} width - column width
       * @property {boolean} flex - use flexbox layout
       * @property {function|string} headerCellRender - header cell render
       * @property {string} cellCls - row cell class
       * @property {string} dataIndex model field name
       * @property {boolean} sortable if cell support sort
       * @property {renderFnCallback}   render render function for row
       */
      /**
       * 列渲染器
       * @type {Array.<TableColumObject>}
       */
      columns: [],
      allowSelect: true,
      onBeforeSort: _.noop,
      onAfterSort: _.noop
    });
  },
  initialize: function initialize(opt) {
    opt.sorters = _.map(opt.sorters, function (sorter) {
      sorter.useComparator = _.isUndefined(sorter.useComparator) ? true : sorter.useComparator;
      return sorter;
    });
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.$el.addClass(this.headerCls);
    this.$tr = this.$(".t-row");
    this.renderColumn();
    Dispatcher.on(MDEvents.FolderOpenedChanged, this.filePathChanged, this);
  },
  // 动态添加一些排序项
  filePathChanged: function filePathChanged() {
    // var projCreateDateIndex = -1;
    // for (let i = 0; i < this.sorters.length; i++) {
    //   const sorter = this.sorters[i];
    //   if (sorter.dataIndex == 'projectCreateDate') {
    //     projCreateDateIndex = i;
    //   }
    // }
    // if (true || app.pathRouter.isMaodingProject()) {
    //   if (projCreateDateIndex == -1) {
    //     this.sorters.push({
    //       dataIndex: 'projectCreateDate',
    //       direction: SortDirection.Desc,
    //       propType: PropType.Number,
    //       name: BabelStr.str(6106),
    //       useComparator: true
    //     })
    //   }
    // } else {
    //   if (projCreateDateIndex != -1) {
    //     this.sorters.splice(i, 1);
    //   }
    // }
  },
  setSortByRequestAvailable: function setSortByRequestAvailable(sortByRequestAvailable) {
    this.sortByRequestAvailable = sortByRequestAvailable;
  },
  setSelection: function setSelection(selected) {
    this._selected = selected;
    this.$(".chb input[type=checkbox]").prop("checked", selected);
  },
  isInSelectState: function isInSelectState() {
    return this._selected;
  },
  renderColumn: function renderColumn() {
    var sb = [];
    var $tr = this.$tr;
    $tr.empty();
    var self = this;
    self.helpCallbacks = {};
    if (this.allowSelect) {
      sb.push("<div class='chb-col'>");
      sb.push("<div class='chb'>");
      if (!this.singleSelect) {
        sb.push('<input type="checkbox" id="' + this.cid + '"/><label></label>');
      }
      sb.push("</div>");
      sb.push("</div>");
      $tr.append(sb.join(""));
    }
    _.each(this.columns, function (column) {
      if (column.hidden) {
        return;
      }
      var name = column.name;
      if (column.help) {
        name += '<span class="help" data-data-index="' + column.dataIndex + '">?</span>';
        self.helpCallbacks[column.dataIndex] = column.helpCallback;
      }
      var cls = "";
      if (self.showToolTip) {
        cls = "class=\"text-hide\"";
      }
      var $th = $("<div ".concat(cls, ">"));
      var toolTip = "";
      if (self.showToolTip) {
        toolTip = "data-tooltip-dir=\"top\" data-tooltip=\"".concat(column.name, "\"");
      }
      var nameStr = "<span ".concat(toolTip, ">").concat(name, "</span>");
      $th.append(nameStr);
      var sorter = _.find(self.sorters, {
        dataIndex: column.dataIndex
      });
      if (sorter) {
        $th.addClass("sortable").data("sorter", sorter);
        if (sorter.active) {
          $th.addClass("active");
        }
        if (_.isUndefined(sorter.direction)) {
          sorter.direction = _SortDirection["default"].Asc;
        }
        var direction = sorter.direction;
        if (direction == _SortDirection["default"].Asc || direction == _SortDirection["default"].Desc) {
          $th.append("<i class='dir " + self._arrows[direction] + "'/></i>");
        }
      }
      if (!_.isUndefined(column.width)) {
        $th.css({
          width: column.width
        });
      } else if (column.flex) {
        var flex = column.flex || 1;
        flex = flex.toString();
        $th.css({
          "-webkit-box-flex": flex,
          "-webkit-flex-grow": flex,
          "-moz-flex-grow": flex,
          "-ms-flex-positive": flex,
          "flex-grow": flex,
          "-webkit-flex-basis": 0,
          "-moz-flex-basis": 0,
          "-ms-flex-preferred-size": 0,
          "flex-basis": 0
        });
      }
      if (!_.isUndefined(column.minWidth)) {
        $th.css({
          'min-width': column.minWidth
        });
      }
      column.cellCls && $th.addClass(column.cellCls);
      $tr.append($th);
    });
  },
  startFilterMode: function startFilterMode() {
    this.filterMode = true;
  },
  isFilterMode: function isFilterMode() {
    return this.filterMode;
  },
  clearFilterMode: function clearFilterMode() {
    this.filterMode = false;
  },
  setColumns: function setColumns(columns) {
    this.columns = columns;
    this.$(".t-row").empty();
    this.renderColumn();
  },
  _sortColumnClickHandler: function _sortColumnClickHandler($e) {
    var self = this;
    var $curSortTh = this.$(".t-row .active");
    var $th = $($e.currentTarget);
    var sorter = $th.data("sorter");
    var direction = "";
    var force = false;
    // 选择不同的排序字段
    if ($curSortTh[0] !== $th[0]) {
      force = true; // 切换到其他新的排序字段要强制刷新
      direction = sorter.direction;
    } else {
      direction = sorter.direction == _SortDirection["default"].Asc ? _SortDirection["default"].Desc : _SortDirection["default"].Asc;
    }
    _.isFunction(this.onSorted) && this.onSorted(sorter.dataIndex, direction);
    if (this.sortByRequest && this.sortByRequestAvailable) {
      this.sortByRequest(sorter.dataIndex, direction, function () {
        sorter.direction = direction;
        self._setSortHeaderState(sorter.dataIndex, direction);
      });
    } else {
      this.sort(sorter.dataIndex, direction, force);
    }
  },
  _setSortHeaderState: function _setSortHeaderState(dataIndex, direction) {
    var $ths = this.$(".t-row").children();
    $ths.removeClass("active sortable");
    var self = this;
    $ths.each(function () {
      var $th = $(this);
      var sorter = $th.data("sorter");
      if (sorter) {
        $th.addClass("sortable");
        sorter.active = false;
        if (sorter.dataIndex === dataIndex) {
          $th.addClass("active");
          $th.find("i").attr("class", "").addClass("dir " + self._arrows[direction]);
        }
      }
    });
    _.each(this.sorters, function (sorter) {
      if (sorter.dataIndex == dataIndex) {
        sorter.active = true;
      } else {
        sorter.active = false;
      }
    });
  },
  _helpClickHandler: function _helpClickHandler(e) {
    e.stopPropagation();
    var dataIndex = e.target.dataset.dataIndex;
    var cb = this.helpCallbacks[dataIndex];
    cb && cb();
  },
  _onCheckAllSelectionChangeHandler: function _onCheckAllSelectionChangeHandler($e) {
    this._selected = !this._selected;
    this.setSelection(this._selected);
    var bodyView = this.getBodyView();
    bodyView.setAllRowSelected(this._selected);
  },
  selectAll: function selectAll(select) {
    this.setSelection(select);
    var bodyView = this.getBodyView();
    bodyView.setAllRowSelected(select);
  },
  setDataCollection: function setDataCollection(dataCollection) {
    this.dataCollection = dataCollection;
    // this.listenTo(this.dataCollection, 'add', this._eventHandlerOfDataCollection)
    this.setSelection(false);
  },
  _eventHandlerOfDataCollection: function _eventHandlerOfDataCollection() {
    this.setSelection(false);
  },
  getDataCollection: function getDataCollection() {
    return this.dataCollection;
  },
  getSortersInfors: function getSortersInfors() {
    var self = this;
    var sorters = this.sorters;
    var infors = [];
    var columns = this.columns;
    _.each(sorters, function (sorter) {
      var dir = sorter.direction == "ASC" ? "DESC" : "ASC";
      var infor = _.extend({
        arrow: self._arrows[dir]
      }, sorter);
      if (sorter.sorterName || sorter.name) {
        infor.name = sorter.sorterName || sorter.name;
      } else {
        _.some(columns, function (col) {
          if (col.dataIndex == infor.dataIndex) {
            infor.name = col.sorterName || col.name;
            return true;
          }
        });
      }
      infors.push(infor);
    });
    return infors;
  },
  getActiveSorter: function getActiveSorter() {
    return _.findWhere(this.sorters, {
      active: true
    });
  },
  setActiveSorter: function setActiveSorter(sorter, opt_sort, opt_force) {
    var dataIndex = sorter.dataIndex;
    var curActiveSorter = this.getActiveSorter();
    if (!curActiveSorter) {
      // return;
    } else {
      curActiveSorter.active = false;
    }
    var newActiveSorter = _.findWhere(this.sorters, {
      dataIndex: dataIndex
    }) || {};
    newActiveSorter = _.extend(newActiveSorter, sorter);
    newActiveSorter.active = true;
    if (opt_sort) {
      this.sort(dataIndex, newActiveSorter.direction, opt_force);
    } else {
      this._setSortHeaderState(dataIndex, newActiveSorter.direction);
    }
  },
  clearActiveSorter: function clearActiveSorter() {
    var $ths = this.$(".t-row").children();
    $ths.removeClass("active");
  },
  resetSort: function resetSort() {
    var sorter = this.getActiveSorter();
    if (sorter) {
      // reset data
      sorter.active = false;
      // reset view state
      this.$(".t-row .active").removeClass("active").find("dir").remove();
    }
  },
  setFileExtent: function setFileExtent(dataCollection) {
    var name = "";
    var extend = "";
    dataCollection.each(function (fileInfor) {
      if (fileInfor.getFileName) {
        name = fileInfor.getFileName();
        extend = MMCommonFun.getFileExtension1(name);
        fileInfor.set("extend", extend);
      }
    });
  },
  sort: function sort(dataIndex, direction, opt_force, opt_silent) {
    if (!this.dataCollection) {
      return;
    }
    this.setFileExtent(this.dataCollection);
    var self = this;
    var sorter = _.findWhere(this.sorters, {
      dataIndex: dataIndex
    });
    if (sorter.direction === direction && !opt_force) {
      return;
    } else {
      !opt_silent && this.onBeforeSort();
      // _.delay(function() {
      sorter.direction = direction;
      // 自己排序并trigger sort消息
      if (!sorter.useComparator) {
        var myOwnSorter = self._getSortComparator(dataIndex, direction);
        myOwnSorter(direction, dataIndex);
        // 使用默认的比较器
      } else {
        self.dataCollection.comparator = self._getSortComparator(dataIndex, direction);
        self.dataCollection.sort({
          sort: !!opt_silent
        });
      }
      !opt_silent && self.onAfterSort();
      // }, 0)
      self._setSortHeaderState(dataIndex, direction);
    }
  },
  toggleSort: function toggleSort(dataIndex, opt_silent) {
    var self = this;
    var sorter = _.findWhere(this.sorters, {
      dataIndex: dataIndex
    });
    var direction = sorter.direction == _SortDirection["default"].Asc ? _SortDirection["default"].Desc : _SortDirection["default"].Asc;
    if (this.sortByRequest && this.sortByRequestAvailable) {
      this.sortByRequest(dataIndex, direction, function () {
        sorter.direction = direction;
        self._setSortHeaderState(sorter.dataIndex, direction);
      });
    } else {
      this.sort(dataIndex, direction, false, opt_silent);
      // this.sort(sorter.dataIndex, direction, force);
    }
  },
  _getSortComparator: function _getSortComparator(dataIndex, direction) {
    var sorter = _.findWhere(this.sorters, {
      dataIndex: dataIndex
    });
    var order = 0;
    order = direction === "ASC" ? 1 : -1;
    sorter.direction = direction;
    var comparator = null;
    if (_.isFunction(sorter.sortFn)) {
      // 自定义的比较器
      comparator = function comparator(preModel, nextModel) {
        return sorter.sortFn(preModel, nextModel, order);
      };
    } else {
      // 内置的默认比较器
      comparator = function comparator(pre, next) {
        var preVal = pre.get(dataIndex);
        var nextVal = next.get(dataIndex);
        if (!_.isUndefined(preVal) && !_.isUndefined(nextVal)) {
          switch (sorter.propType) {
            case _PropType["default"].Number:
              return order * (preVal - nextVal) > 0 ? 1 : -1;
            case _PropType["default"].String:
              return order * preVal.localeCompare(nextVal) > 0 ? 1 : -1;
            case _PropType["default"].Date:
              return order * (preVal.getTime() - nextVal.getTime()) > 0 ? 1 : -1;
          }
        }
        return 0;
      };
    }
    return comparator;
  },
  getBodyView: function getBodyView() {
    return this.superView.getBodyView();
  }
});
var _default = exports["default"] = MDTableHeaderView;

},{"1184":1184,"1412":1412,"1417":1417,"1424":1424,"1426":1426,"1430":1430,"1431":1431,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1478":1478,"22":22,"90":90,"91":91}],91:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var SortDirection = {
  Asc: 'ASC',
  Desc: 'DESC'
};
var _default = exports["default"] = SortDirection;

},{"1454":1454}],85:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1477);
require(1541);
require(1421);
require(1430);
require(1463);
require(1412);
require(1436);
require(1546);
require(1429);
require(1415);
require(1413);
require(1426);
require(1446);
require(1418);
require(1537);
require(1471);
require(1466);
var _RenderProxy = _interopRequireDefault(require(25));
var _MDTableRowView = _interopRequireDefault(require(88));
var _MMViewBase = _interopRequireDefault(require(22));
var _keycode = _interopRequireDefault(require(104));
var _MDTableBodyViewGridMixin = _interopRequireDefault(require(86));
/**
 *  Header view for table view
 *  Created by manjun.han
 *  2015.9.18
 */

/**
 * (+ 代表包含一个， ++ 代表包含一个或多个,  <-- 表示继承）
 *
 * 类结构图  MDTableBodyView
 *              +
 *              |----MDTableRowView
 */

var DEFAULTS = {
  enableDragSelection: true
};
var MDTableBodyView = _MMViewBase["default"].extend({
  tmpl: '<div class="table-content"></div><div class="f-hide page-bar flex-align middle"></div>',
  getClassName: function getClassName() {
    return 'MDTableBodyView';
  },
  className: function className() {
    var superCls = _MMViewBase["default"].prototype.className.call(this);
    return superCls + ' table-body';
  },
  events: function events() {
    var superP = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superP, {
      "mouseup": this._tableBodyClickHandler,
      'click .page-item': this._pageChangeHandle
    });
  },
  // 私有属性声明，需要在initialize中初始化，

  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      _curIndex: -1,
      rect: {},
      isActiveElement: false,
      contextMenuView: null,
      rowCls: '',
      bodyCls: '',
      blankRenderer: '',
      // {string|function}

      columns: [],
      autoLoad: true,
      allowSelect: true,
      singleSelect: false,
      enableShiftMultiSelect: true,
      enableMetaKeyMultiSelect: true,
      enableContextMenu: false,
      enableDragSelection: undefined,
      enableKeyboardSelected: true,
      rowClass: _MDTableRowView["default"],
      onRowSelectionChanged: _.noop,
      onContextmenu: _.noop,
      onTableScroll: _.noop,
      enableDispatchScrollEvent: true,
      unSelectRowWhenClickOutside: true,
      dataCollection: null,
      // Backbone.Collection
      pageSize: 50,
      url: '',
      params: '',
      onBeforeRequest: _.noop,
      onSuccess: _.noop,
      onError: _.noop,
      onComplete: _.noop,
      rowOption: {},
      showPageBar: false,
      showPageBarMinPage: 3,
      useSortRows: false,
      // 是否启用虚拟滚动；默认 false，未显式启用时完全沿用原完整渲染路径。
      virtualScroll: false,
      // 未测得真实行高时使用的预估高度，单位 px；测量后会被动态行高缓存替代。
      virtualRowHeight: 50,
      // 可视区域上下额外渲染的行数；数值越大快速滚动越平滑，但常驻 row view 越多。
      virtualBuffer: 10,
      // 虚拟内容底部额外预留高度，单位 px；用于承载“已全部加载”等浮层提示。
      virtualBottomSpacing: 0,
      onNextPageRendered: _.noop
    });
  },
  initialize: function initialize(opt) {
    // 虚拟滚动状态全部归属于当前 body 实例，避免 MMViewBase 原型属性或多个表格之间共享缓存。
    // key 为 model.cid（fileId 仅作回退），value 为最近一次 DOM 实测高度，单位 px。
    this._virtualRowHeights = {};
    // 当前挂载窗口内模型 key 的有序快照，用于判断滚动后是否真的需要重绘。
    this._virtualRenderedKeys = [];
    // 监听已挂载行高度变化；评论展开、异步内容变化时会更新高度缓存。
    this._virtualResizeObserver = null;
    // 完整可见模型、累计偏移和总高度的缓存；数据顺序、可见性或行高变化时失效。
    this._virtualLayoutCache = null;
    // 合并异步高度测量的 animation frame / timeout 句柄。
    this._virtualMeasureFrame = null;
    // 合并滚动和 Collection 事件触发的虚拟重绘句柄。
    this._virtualScrollFrame = null;
    // 不写入业务 model 的行级 UI 状态，例如 commentExpanded。
    this._virtualRowStates = {};
    // 已离开窗口但因评论展开而暂时保留的 Row View，按模型 key 索引。
    this._virtualRetainedRowViews = {};
    this.bindSelf([this._onKeydownHandler, this._onContextMenuHandler, this._rowClickHandler, this._onMouseMoveHandler, this._onMouseDownHandler, this._onMouseUpHandler, this._setMouseDragSelection, this._setFocusWhenClick, this._dispatchScrollEvent, this._onVirtualScroll, this._inforPanelShowed]);

    // document.onselectstart = function()
    // {
    //     window.getSelection().removeAllRanges();
    // };

    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.setDefaults(DEFAULTS);
    if (!this.dataCollection && this.autoLoad && !/\s/.test(this.url)) {
      this.load(this.params);
    }
    if (opt.dataCollection) {
      this.setDataCollection(opt.dataCollection, true);
    }
    if (this.enableShiftMultiSelect) {
      this.setKeyBoardSelection();
    }
    if (this.enableContextMenu) {
      this.$el.on('contextmenu.tableContentMenu', this._onContextMenuHandler);
    }
    if (this.allowSelect) {
      // 必须使用mouseup
      // 否则在一个元素内部拉选会有问题
      this.$el.on('mouseup', '.table-content>div', this._rowClickHandler);
      if (this.enableDragSelection && !this.singleSelect) {
        this.$el.on("mousedown", this._onMouseDownHandler);
      }
    }
    if (this.enableDispatchScrollEvent) {
      // this._dispatchScrollEvent = _.throttle(this._dispatchScrollEvent, 100)
      this.$el.on("scroll", this._dispatchScrollEvent);
    }
    if (this.virtualScroll) {
      // 仅在启用时监听，关闭或销毁时会对称解绑。
      this.$el.on("scroll", this._onVirtualScroll);
    }
    this.$pageBar = this.$('.page-bar');
    this.$el.addClass(this.bodyCls);
    Dispatcher.on(MDEvents.ShowInforPanel, this._inforPanelShowed, this);

    // if(this.showPageBar()) {
    //   this.renderPageBar()
    // }
  },
  setCurIndex: function setCurIndex(curIndex) {
    this._curIndex = curIndex;
  },
  load: function load(requestParams) {},
  setEnableDragSelection: function setEnableDragSelection(enabled) {
    this.enableDragSelection = enabled;
  },
  setVirtualScrollEnabled: function setVirtualScrollEnabled(enabled) {
    // 运行期切换入口：完整释放 observer、帧任务、布局缓存和保留行，再按目标模式重绘。
    // 默认配置为 false，因此未调用此方法或未显式开启的表格不会进入任何虚拟分支。
    enabled = !!enabled;
    if (this.virtualScroll === enabled) {
      return;
    }
    if (this._virtualScrollFrame) {
      var cancelFrame = window.cancelAnimationFrame || window.clearTimeout;
      cancelFrame(this._virtualScrollFrame);
      this._virtualScrollFrame = null;
    }
    this.$el.off("scroll", this._onVirtualScroll);
    this._disconnectVirtualResizeObserver();
    this._cancelVirtualMeasure();
    this._releaseVirtualRetainedRows();
    this._virtualRowHeights = {};
    this._virtualRenderedKeys = [];
    this._virtualLayoutCache = null;
    this._virtualRowStates = {};
    this._virtualRetainedRowViews = {};
    this.virtualScroll = enabled;
    if (!enabled) {
      // 退出虚拟模式后恢复样式表定义的 bottom 定位。
      this.$('.loaded-sign').css({
        top: '',
        bottom: ''
      });
    }
    this.$('.table-content').css({
      paddingTop: 0,
      paddingBottom: 0
    });
    if (enabled) {
      this.$el.on("scroll", this._onVirtualScroll);
    }
    this._renderRows();
  },
  refreshGlobalCoorRect: function refreshGlobalCoorRect() {
    var $doc = $(document);
    var scrollTop = $doc.scrollTop();
    var scrollLeft = $doc.scrollLeft();
    var offset = this.$el.offset();
    // 全局坐标
    this.rect = {
      left: offset.left - scrollLeft,
      top: offset.top - scrollTop,
      height: this.$el.height(),
      width: this.$el.width()
    };
  },
  draggingStarted: function draggingStarted() {
    this.dragging = true;
    this._onMouseUpHandler();
  },
  draggingEnded: function draggingEnded() {
    this.dragging = false;
  },
  _onMouseDownHandler: function _onMouseDownHandler($e) {
    var self = this;
    // 检查点击的元素或其父元素是否具有 'file-comment-wrap' 类
    if ($e.target.closest('.file-comment-wrap')) {
      console.log('点击发生在 file-comment-wrap 中！');
      return;
    }
    $(document).on(self.$nsEventName("mouseup"), self._onMouseUpHandler);
    if (!this.enableDragSelection) {
      return;
    }
    this.dragging = false;
    this.preMouseViewPortPt = {
      x: $e.clientX,
      y: $e.clientY
    };

    //
    // http://stackoverflow.com/questions/10045423/determine-whether-user-clicking-scrollbar-or-content-onclick-for-native-scroll
    // Windows下Firefox和IE在点击scrollbar时会触发mousemove事件，在Mac下不会，这回引起拉选
    // 解决的办法是判断鼠标点击点是否在scrollbar上
    var localPt = this.$el.viewPortToLocal({
      x: $e.clientX,
      y: $e.clientY
    });
    if (localPt.x > this.el.clientWidth) {
      return;
    }
    if (!this.$selectionLayer) {
      var css = {
        'pointer-events': 'none',
        "z-index": '20000',
        'position': 'absolute',
        "border": "1px solid rgb(135, 195, 248)",
        "background-color": "rgba(141, 186, 255, 0.37)"
      };
      this.$selectionLayer = $("<div>").appendTo("body").css(css);
    }

    // 获取点的本地坐标
    this.localStartY = localPt.y;
    this.localStartX = localPt.x;
    this.refreshGlobalCoorRect();
    //
    // 1.windows下chrome 47.0.2526版本会有bug
    // 直接在mousedown中添加mousemove会在mousedown事件中触发mousemove事件，
    // 此处用一个异步事件解决该问题
    // 2. 添加延迟处理后，在mac的触摸板会有mouseup不触发的问题
    //    if(app.browser.chrome){
    //      _.delay(function(){
    //        $(document).on(self.$nsEventName("mousemove") , self._onMouseMoveHandler);
    //        $(document).on(self.$nsEventName("mouseup") , self._onMouseUpHandler);
    //      },0);
    //    }else{

    $(document).on(self.$nsEventName("mousemove"), self._onMouseMoveHandler);
    //    }

    $("body").addClass('disable-text-select');
    // 禁用浏览器默认的拖拽滚动
    // $e.preventDefault();
  },
  _onMouseMoveHandler: function _onMouseMoveHandler($e) {
    // detect the contextmenu event
    if ($e.button == 2 || !this.dataCollection.length) {
      return;
    }
    this.curMouseViewPortPt = {
      x: $e.clientX,
      y: $e.clientY
    };
    var horizonalDelta = Math.abs(this.preMouseViewPortPt.x - this.curMouseViewPortPt.x);
    var verticalDelta = Math.abs(this.preMouseViewPortPt.y - this.curMouseViewPortPt.y);
    var lenFromStart = horizonalDelta + verticalDelta;
    var moveBoundary = 10;
    if (lenFromStart > moveBoundary) {
      this.dragMoving = true;
    }
    ;
    var curLocal = this.$el.viewPortToLocal(this.curMouseViewPortPt);
    var delectScrollDelta = 8;
    if (Math.abs(curLocal.x - this.localStartX) < delectScrollDelta && Math.abs(curLocal.y - this.localStartY) < delectScrollDelta) {
      return true;
    }
    var scrollerGlobalPoint = this.$el.contentToGlobal({
      x: 0,
      y: 0
    });
    var startPoint = this.$el.localToGlobal({
      x: this.localStartX,
      y: this.localStartY
    });
    var curPoint = this.$el.localToGlobal(curLocal);
    var mousePointerBeyondTop = curPoint.y < scrollerGlobalPoint.y;
    var mpusePointerBeyoondBottom = curPoint.y > scrollerGlobalPoint.y + this.rect.height;
    if (this.scrolling && (mpusePointerBeyoondBottom || mousePointerBeyondTop)) {
      return;
    } else {
      this.stopScrolling();
    }
    // 当前鼠标点在scroller的顶部
    if (mousePointerBeyondTop) {
      this.startScrolling(true);
      this.scrollingToTop = true;
      // 当前鼠标点在scroller的底部
    } else if (mpusePointerBeyoondBottom) {
      this.startScrolling(false);
      this.scrollingToTop = false;
    }
    if (!this.dragging) {
      this.drawSelectionLayer(startPoint, curPoint);
    }
    ;

    // 阻止浏览器默认的拖拽滚动
    $e.preventDefault();
  },
  _onMouseUpHandler: function _onMouseUpHandler($e) {
    this.stopScrolling();
    $("body").removeClass('disable-text-select');
    $(document).off(this.$nsEventName("mousemove"), this._onMouseMoveHandler);
    $(document).off(this.$nsEventName("mouseup"), this._onMouseUpHandler);
    if (this.dragMoving && $e) {
      var $rowViewEl = $($e.target).closest(".t-row");
      var rowIndex = $rowViewEl.index();
      if (this.virtualScroll || this.virtualGridScroll) {
        // DOM 下标只代表当前窗口，需要还原为 collection 中的真实下标。
        // 鼠标可能在选择层或空白区域释放，此时 index() 为 -1，不能调用 getSubViewAt。
        var rowView = rowIndex >= 0 && rowIndex < this.getSubViewCount() ? this.getSubViewAt(rowIndex) : null;
        rowIndex = rowView ? rowView.index : this._curIndex;
        if (rowIndex >= 0) {
          this.setCurIndex(rowIndex);
        }
      } else {
        // 非虚拟模式保持原逻辑，包括允许使用 -1 清空当前索引。
        this.setCurIndex(rowIndex);
      }
    }
    this.$selectionLayer && this.$selectionLayer.remove();
    this.$selectionLayer = null;
    this.dragMoving = false;
  },
  /**
   * 全局坐标
   * @param startPoint
   * @param curPoint
   */
  drawSelectionLayer: function drawSelectionLayer(startPoint, curPoint) {
    var self = this;
    var topX = Math.min(startPoint.x, curPoint.x);
    var topY = Math.min(startPoint.y, curPoint.y);
    var width = Math.abs(curPoint.x - startPoint.x);
    var height = Math.abs(curPoint.y - startPoint.y);
    var dragRect = {
      top: topY,
      left: topX,
      width: width,
      height: height
    };
    var rect = $.extend({}, dragRect);
    var contained = this.contains(this.rect, rect);
    //未包含，取交集
    if (!contained) {
      rect = this.intersection(this.rect, rect);
      // 如果不存在交集，此情况由于快速反向拉选造成的
      if (!rect) {
        rect = {};
        // 向上滚动中
        if (this.scrollingToTop) {
          rect.top = this.rect.top;
        } else {
          rect.top = this.rect.top + this.rect.height;
        }
        var rectRightX = this.rect.left + this.rect.width;
        // 左右边界检测
        if (rectRightX < curPoint.x) {
          width = Math.abs(rectRightX - startPoint.x);
          rect.left = startPoint.x;
        } else if (curPoint.x < this.rect.left) {
          width = Math.abs(startPoint.x - this.rect.left);
          rect.left = this.rect.left;
        }
        rect.width = width;
        rect.height = 1;
      }
    }
    this.$selectionLayer.css(rect); // 全局坐标
    self._setMouseDragSelection();
  },
  /**
   * 根据选区的大小，选中每个与之相交的rowView，
   * 将选取的坐标点转换为本地坐标点进行比较
   */
  _setMouseDragSelection: function _setMouseDragSelection() {
    var self = this;
    var curLocalPt = self.$el.viewPortToLocal(this.curMouseViewPortPt);
    var top = Math.min(this.localStartY, curLocalPt.y);
    var left = Math.min(this.localStartX, curLocalPt.x);
    var height = Math.abs(this.localStartY - curLocalPt.y);
    var width = Math.abs(this.localStartX - curLocalPt.x);
    var rect = {
      top: top,
      left: left,
      height: height,
      width: width
    };
    if (this.virtualGridScroll) {
      // Grid 虚拟滚动：遍历全部 _gridMetrics，框选所有与拖选框相交的 item。
      var gmetrics = this._gridMetrics;
      if (!gmetrics || gmetrics.length === 0) return;
      var gcontentEl = this._getGridContentEl ? this._getGridContentEl() : this.el;
      var gdeltaY = gcontentEl.offsetTop;
      var gdeltaX = gcontentEl.offsetLeft;

      // 将 drag rect 从 this.el 坐标系转换为 contentEl 坐标系。
      var grectTop = rect.top - gdeltaY;
      var grectLeft = rect.left - gdeltaX;
      var grectBottom = grectTop + rect.height;
      var grectRight = grectLeft + rect.width;
      if (this.dataCollection) {
        var gmodels = this.dataCollection.models || [];
        for (var gi = 0; gi < gmodels.length && gi < gmetrics.length; gi++) {
          var gm = gmetrics[gi];
          var gmodel = gmodels[gi];
          if (!gm || !gmodel) continue;
          var gv = grectBottom >= gm.top && grectTop <= gm.top + (gm.height || 100);
          var gh = grectRight >= gm.left && grectLeft <= gm.left + gm.width;
          gmodel._rowSelected = gv && gh;
        }
      }
      this._syncVirtualSelectionViews();
      var gheaderView = this.superView && this.superView.getHeaderView();
      gheaderView && _.isFunction(gheaderView.setSelection) && gheaderView.setSelection(this.allSelected());
      this._dispatchSelectionChange();
      return;
    }
    if (this.virtualScroll) {
      // 拖选按完整虚拟布局计算，选择状态写入 model，不依赖行是否已挂载。
      var range = this._getVirtualRange();
      var bounds = this._getVirtualDataBounds();
      var selectionBottom = rect.top + rect.height;
      var selectionRight = rect.left + rect.width;
      var rowWidth = this.el.clientWidth;
      this.dataCollection.each(function (model, index) {
        if (index >= bounds.start && index < bounds.end) {
          model._rowSelected = false;
        }
      });
      _.each(range.visibleModels, function (entry, position) {
        var rowTop = range.getRowTop(position);
        var rowBottom = rowTop + range.getRowHeight(position);
        var verticalSelected = rowBottom >= rect.top && rowTop <= selectionBottom;
        var horizontalSelected = selectionRight >= 0 && rect.left <= rowWidth;
        entry.model._rowSelected = verticalSelected && horizontalSelected;
      });

      // 框选只改变 model 的选择状态，不会改变可视范围或行高。
      // 直接同步当前窗口，避免无滚动时重建 row view 导致缩略图闪烁。
      this._syncVirtualSelectionViews();
      var headerView = this.superView && this.superView.getHeaderView();
      headerView && _.isFunction(headerView.setSelection) && headerView.setSelection(this.allSelected());
      this._dispatchSelectionChange();
      return;
    }
    this.eachSubViews(function (rowView, index) {
      var rowEl = rowView.el;
      var $rowEl = rowView.$el;
      // body 的position必须是relative，
      // 保证rowView的offsetParent为bodyView
      var rowDocOffset = rowEl.offsetTop;
      // 每个rowView在bodyView中的本地坐标点
      var rectA = {
        top: rowEl.offsetTop,
        left: rowEl.offsetLeft,
        height: $rowEl.height(),
        width: $rowEl.width()
      };
      // 如果是包含关系或者是相交关系则需要选中
      var shouldSelected = self._isIntersection(rectA, rect) || self.contains(rectA, rect);
      rowView.setSelected(shouldSelected, true);
    });
    this._dispatchSelectionChange();
  },
  startScrolling: function startScrolling(toTop) {
    var delta = 40;
    var self = this;
    this.scrolling = true;
    if (this.tid) {
      return;
    }
    this.tid = setInterval(function () {
      var deltaY = toTop ? -delta : delta;
      var scrollTop = self.$el.scrollTop() + deltaY;
      self.$el.scrollTop(scrollTop);
      var startPoint = self.$el.localToGlobal({
        x: self.localStartX,
        y: self.localStartY
      });
      var local = self.$el.viewPortToLocal(self.curMouseViewPortPt);
      var curPoint = self.$el.localToGlobal(local);
      self.drawSelectionLayer(startPoint, curPoint);
      self.enableDispatchScrollEvent && self.hasVerticalScroll() && self._dispatchScrollEvent();
      if (toTop) {
        if (scrollTop <= 0) {
          self.stopScrolling();
        }
      } else {
        var height = self.$el.height();
        if (scrollTop + height >= self.$el.prop("scrollHeight")) {
          self.stopScrolling();
        }
      }
    }, 100);
  },
  stopScrolling: function stopScrolling() {
    this.tid = clearInterval(this.tid);
    this.scrolling = false;
  },
  getBodyContent$El: function getBodyContent$El() {
    return this.$('.table-content');
  },
  hasVerticalScroll: function hasVerticalScroll() {
    return this.el.offsetWidth > this.el.clientWidth;
  },
  /**
   * 判断矩形是否是包含关系
   */
  contains: function contains(container, contained) {
    return container.left <= contained.left && container.left + container.width >= contained.left + contained.width && container.top <= contained.top && container.top + container.height >= contained.top + contained.height;
  },
  /**
   * 获取相交矩形的坐标
   */
  intersection: function intersection(a, b) {
    var x0 = Math.max(a.left, b.left);
    var x1 = Math.min(a.left + a.width, b.left + b.width);
    if (x0 <= x1) {
      var y0 = Math.max(a.top, b.top);
      var y1 = Math.min(a.top + a.height, b.top + b.height);
      if (y0 <= y1) {
        return {
          left: x0,
          top: y0,
          width: x1 - x0,
          height: y1 - y0
        };
      }
    }
    return null;
  },
  /**
   * 判断是否相交
   */
  _isIntersection: function _isIntersection(rectA, rectB) {
    var x0 = Math.max(rectA.left, rectB.left);
    var x1 = Math.min(rectA.left + rectA.width, rectB.left + rectB.width);
    if (x0 <= x1) {
      var y0 = Math.max(rectA.top, rectB.top);
      var y1 = Math.min(rectA.top + rectA.height, rectB.top + rectB.height);
      if (y0 <= y1) {
        return true;
      }
    }
    return false;
  },
  setKeyBoardSelection: function setKeyBoardSelection() {
    $(document).on(this.$nsEventName('keydown'), this._onKeydownHandler);
    $(document).on(this.$nsEventName('mousedown'), this._setFocusWhenClick);
  },
  _setFocusWhenClick: function _setFocusWhenClick($e) {
    if (this.$el.eventIsInner($e)) {
      this.isActiveElement = true;
    } else {
      this.isActiveElement = false;
    }
  },
  _onKeydownHandler: function _onKeydownHandler($e) {
    if (!this.isActiveElement) {
      return;
    }
    var ctxMenuView = this.superView.getContextMenuView();
    if (ctxMenuView && ctxMenuView.isVisible()) {
      return;
    }
    if (this.virtualScroll) {
      // 虚拟模式不能使用仅遍历已渲染 subViews 的原键盘逻辑。
      this._onVirtualKeydownHandler($e);
      return;
    }
    // Grid 瀑布流模式下方向键导航不适用，跳过。
    if (this.virtualGridScroll) {
      return;
    }

    // ** do not delete these code lines

    var shiftPressed = $e.shiftKey;
    if (this.getSubViewCount() == 0) {
      return;
    }
    switch ($e.which) {
      // UP
      case _keycode["default"].codes.UP:
        this._onArrowKeyHandler(true, shiftPressed);
        break;
      // DOWN
      case _keycode["default"].codes.DOWN:
        this._onArrowKeyHandler(false, shiftPressed);
        break;

      // SHIFT
      case _keycode["default"].codes.SHIFT:
        if (this.enableShiftMultiSelect) {
          this.$el.addClass('disable-text-select');
          this.setCurIndex(Math.max(this._curIndex, 0));
          var view = this.getSubViewAt(this._curIndex);
          view.setShiftBeginStyle(true);
        }
    }
    //    return false ;
  },
  _onVirtualKeydownHandler: function _onVirtualKeydownHandler($e) {
    // 在当前分页且可见的数据内导航，并主动滚动到目标行。
    if ($e.which !== _keycode["default"].codes.UP && $e.which !== _keycode["default"].codes.DOWN) {
      return;
    }
    var visibleIndexes = [];
    var bounds = this._getVirtualDataBounds();
    this.dataCollection.each(function (model, index) {
      if (index >= bounds.start && index < bounds.end && (!_.isFunction(model.getShow) || model.getShow())) {
        visibleIndexes.push(index);
      }
    });
    if (!visibleIndexes.length) {
      return;
    }
    var currentPosition = _.indexOf(visibleIndexes, this._curIndex);
    if (currentPosition < 0) {
      currentPosition = $e.which === _keycode["default"].codes.UP ? visibleIndexes.length : -1;
    }
    currentPosition += $e.which === _keycode["default"].codes.UP ? -1 : 1;
    currentPosition = Math.max(0, Math.min(currentPosition, visibleIndexes.length - 1));
    var nextIndex = visibleIndexes[currentPosition];
    if ($e.shiftKey && this.enableShiftMultiSelect) {
      this._pointer = this._pointer > -1 ? this._pointer : this._curIndex > -1 ? this._curIndex : nextIndex;
      this.selectRowRange(this._pointer, nextIndex, true);
    } else {
      this.selectRowRange(nextIndex, nextIndex, true);
      this._pointer = nextIndex;
    }
    this.setCurIndex(nextIndex);
    var virtualRange = this._getVirtualRange();
    var rowTop = virtualRange.getRowTop(currentPosition);
    var rowBottom = rowTop + virtualRange.getRowHeight(currentPosition);
    if (rowTop < this.el.scrollTop) {
      this.el.scrollTop = rowTop;
    } else if (rowBottom > this.el.scrollTop + this.el.clientHeight) {
      this.el.scrollTop = rowBottom - this.el.clientHeight;
    }
    this._dispatchSelectionChange();
    $e.preventDefault();
  },
  _onArrowKeyHandler: function _onArrowKeyHandler(upKey, shiftPressed) {
    var curSelectRow = null;
    if (this._curIndex == -1) {
      curSelectRow = this.getSubViewAt(0);
      curSelectRow.setSelected(true, true);
      this.setCurIndex(0);
    } else {
      // shift 多选
      if (shiftPressed) {
        var newIndex;
        if (upKey) {
          newIndex = this._curIndex - 1;
          newIndex = Math.max(newIndex, 0);
        } else {
          newIndex = this._curIndex + 1;
          newIndex = Math.min(newIndex, this.getSubViewCount() - 1);
        }
        this.setCurIndex(newIndex);
        this._pointer = Math.max(this._pointer, 0);
        this.selectRowRange(this._pointer, this._curIndex, true);
      } else {
        var curIndex = this._curIndex + (upKey ? -1 : 1);
        curIndex = Math.max(curIndex, 0);
        curIndex = Math.min(this.getSubViewCount() - 1, curIndex);
        this.selectRowRange(curIndex, curIndex, true);
        this.setCurIndex(curIndex);
        this._pointer = curIndex;
      }
      var curRowView = this.getSubViewAt(this._curIndex);
      var position = curRowView.$el.position();
      var scrollTop = this.$el.scrollTop();
      if (upKey && position.top < 0) {
        this.$el.scrollTop(scrollTop - curRowView.$el.height() * 3);
      } else if (position.top + curRowView.$el.height() > this.$el.height()) {
        this.$el.scrollTop(scrollTop + curRowView.$el.height() * 3);
      }
    }
    this._dispatchSelectionChange();
  },
  _onContextMenuHandler: function _onContextMenuHandler($e) {
    var rowViewEl = $($e.target).closest(".t-row", this.$el);
    var rowIndex = $(rowViewEl).index();
    var curRowView = rowIndex > -1 ? this.getSubViewAt(rowIndex) : null;
    var clickInSelectedView = false;
    var preSelRows = this.getSelectedSubViews();
    if (curRowView && preSelRows.length > 0) {
      clickInSelectedView = _.some(preSelRows, function (view) {
        return view == curRowView;
      });
    }
    if (!clickInSelectedView) {
      _.each(preSelRows, function (rowView) {
        rowView.setSelected(false, true);
      });
      // 右键选中当前行
      curRowView && curRowView.setSelected(true, true);
      this._dispatchSelectionChange();
    }
    this.contextMenuView = this.onContextmenu($e);
    this.superView.setContextMenuView(this.contextMenuView);
    return false;
  },
  _refreshPageBar: function _refreshPageBar() {
    if (this.showPageBar) {
      var needPageBar = this.dataCollection.length >= this.pageSize * this.showPageBarMinPage;
      if (needPageBar && !this.pageBarDisplayed) {
        this.pageBarDisplayed = true;
        this.$pageBar.removeClass('f-hide');
      } else {
        this.pageBarDisplayed = false;
        this.$pageBar.addClass('f-hide');
      }
      if (needPageBar) {
        this.renderPageBar();
      }
    }
  },
  renderPageBar: function renderPageBar() {
    var totalPages = Math.ceil(this.dataCollection.length / this.pageSize);
    var pageSize = 10; // 分页显示的最大页码数
    var startPage = 1;
    var endPage = pageSize;

    // 如果总页数小于或等于pageSize，则直接显示所有页码
    if (totalPages <= pageSize) {
      startPage = 1;
      endPage = totalPages;
    } else {
      // 计算应该从哪一页开始显示
      // 尽可能让当前页位于显示页码的中间
      var middle = Math.floor(pageSize / 2);
      startPage = Math.max(1, this.currentPage - middle);

      // 确保不会超出总页数
      endPage = Math.min(totalPages, startPage + pageSize - 1);

      // 如果起始页太接近第一页，调整起始页和结束页
      if (endPage < totalPages) {
        startPage = Math.max(1, endPage - pageSize + 1);
      }
    }
    if (this.startPage == startPage && this.endPage == endPage) {
      return;
    }
    this.startPage = startPage;
    this.endPage = endPage;
    // 显示页码的逻辑（这里用控制台输出代替）
    var pageStr = '';
    var cls = '';
    for (var i = startPage; i <= endPage; i++) {
      if (i == this.currentPage) {
        cls = "checked";
      }
      pageStr += "<div class=\"page-item ".concat(cls, "\">").concat(i, "</div>");
    }
    this.$pageBar.html(pageStr);
  },
  refreshPageBar: function refreshPageBar() {
    var _this = this;
    if (!this.pageBarRefreshTimer) {
      this.pageBarRefreshTimer = setTimeout(function () {
        _this._refreshPageBar();
        clearTimeout(_this.pageBarRefreshTimer);
        _this.pageBarRefreshTimer = undefined;
      }, 400);
    }
  },
  _pageChangeHandle: function _pageChangeHandle($e) {
    var index = $($e.target).html() - 0;
    if (index == this.currentPage) {
      return;
    }
    this.$('.page-item').removeClass('checked');
    $($e.target).addClass('checked');
    this.currentPage = index;
    this.renderPageBar();
    this.renderRowsByPage();
  },
  renderRowsByPage: function renderRowsByPage() {
    this.startIndex = (this.currentPage - 1) * this.pageSize;
    var end = Math.min(this.startIndex + this.pageSize, this.dataCollection.length);
    this.dataCollection.end = end;
    // 分页边界改变会令偏移数组失效。
    this._invalidateVirtualLayout();
    this._renderRows();
  },
  _dispatchScrollEvent: function _dispatchScrollEvent() {
    if (this.pageBarDisplayed) {
      // console.log('开始分页加载')
      return;
    }
    this.superView.trigger("scroll ");
    this.trigger("scroll");
    var scrollTop = this.$el.scrollTop();
    var scrollBottom = this.el.scrollHeight - this.$el.height() - scrollTop;
    this.onTableScroll(scrollTop, scrollBottom);
  },
  getDataCollection: function getDataCollection() {
    return this.dataCollection;
  },
  setDataCollection: function setDataCollection(dataCollection, opt_silent) {
    if (!dataCollection) {
      return;
    }
    if (this.dataCollection !== dataCollection) {
      // collection 更换后旧模型的高度、展开状态和保留 view 均不可复用。
      this._disconnectVirtualResizeObserver();
      this._releaseVirtualRetainedRows();
      if (this.virtualScroll) {
        this._releaseVirtualCurrentRows();
      }
      this._virtualRowHeights = {};
      this._virtualRenderedKeys = [];
      this._virtualLayoutCache = null;
      this._virtualRowStates = {};
      this._virtualRetainedRowViews = {};
    }
    if (this.dataCollection) {
      this.stopListening(this.dataCollection);
    }
    this.dataCollection = dataCollection;
    this.listenTo(this.dataCollection, 'add', this._addNewDataModel);
    this.listenTo(this.dataCollection, 'remove', this._removeDataModel);
    this.listenTo(this.dataCollection, 'update', this._dataCollectionUpdated);
    this.listenTo(this.dataCollection, 'sort', this._dataCollectionSorted);
    this.listenTo(this.dataCollection, 'reset', this._dataCollectionReseted);
    this.listenTo(this.dataCollection, 'all', this._dataCollectionAllEventHandler);
    if (this.dataCollection.length == 0 && !this.dataCollection.pages) {
      if (window.DBManage && dataCollection.noCatch === false) {
        DBManage.removeData('filelist', {
          name: 'locationHash',
          value: location.hash
        }, function () {});
      }
    }
    if (this.dataCollection.length == 0 && !this.dataCollection.pages && !this.dataCollection.isInit) {
      this._renderBlankState();
    } else {
      if (window.DBManage && dataCollection.noCatch === false && dataCollection.length > 0) {
        var data = dataCollection.toJSON();
        data = data.slice(0, 50);
        var locationHash = location.hash;
        _.each(data, function (item) {
          item.locationHash = locationHash;
        });
        DBManage.removeData('filelist', {
          name: 'locationHash',
          value: location.hash
        }, function () {
          DBManage.putData('filelist', data);
        });
      }
      this._renderRows();
    }
    this._dispatchSelectionChange(opt_silent);
  },
  getSelectedSubViews: function getSelectedSubViews() {
    return this.filterSubViews(function (rowView, index) {
      return rowView.isSelected();
    });
  },
  addRowAt: function addRowAt(model, index) {
    if (!this.dataCollection) {
      throw new Error("TableView dataCollection hasn't been inited");
    }
    index = index < 0 ? 0 : index;
    index = Math.min(index, this.dataCollection.length);
    this.dataCollection.add(model, {
      at: index
    });
  },
  appendRow: function appendRow(model) {
    this.addRowAt(model, this.dataCollection.length);
  },
  prependRow: function prependRow(model) {
    this.addRowAt(model, 0);
  },
  removeRowAt: function removeRowAt(index) {
    if (!this.dataCollection) {
      return;
    }
    var model = this.dataCollection.at(index);
    this.dataCollection.remove(model);
  },
  clearRow: function clearRow(silent) {
    if (!this.dataCollection) {
      return;
    }
    this.dataCollection.reset([], {
      'silent': silent
    });
    if (silent) {
      if (this.virtualScroll) {
        // silent reset 不会触发 reset 回调，因此在这里显式完成同等清理。
        this._disconnectVirtualResizeObserver();
        this._cancelVirtualMeasure();
        this._releaseVirtualRetainedRows();
        _.each(this.subViews, function (subView) {
          if (subView.model && subView.model.view === subView) {
            subView.model.view = null;
          }
        });
        this._virtualRowHeights = {};
        this._virtualRenderedKeys = [];
        this._virtualLayoutCache = null;
        this._virtualRowStates = {};
        this._virtualRetainedRowViews = {};
        this.$('.table-content').css({
          paddingTop: 0,
          paddingBottom: 0
        }).empty();
      }
      this.removeSubViews();
    }
  },
  selectRowAt: function selectRowAt(index, selected, opt_silent) {
    if (this.virtualGridScroll) {
      var gmodel = this.dataCollection && this.dataCollection.at(index);
      if (!gmodel) return;
      gmodel._rowSelected = !!selected;
      this._syncVirtualSelectionViews();
      var gheaderView = this.superView && this.superView.getHeaderView();
      gheaderView && _.isFunction(gheaderView.setSelection) && gheaderView.setSelection(this.allSelected());
      if (!opt_silent) {
        this._dispatchSelectionChange();
      }
      return;
    }
    if (this.virtualScroll) {
      // 未渲染行也必须可选，所以虚拟模式以 model 为选择状态源。
      var model = this.dataCollection && this.dataCollection.at(index);
      if (!model) {
        return;
      }
      var bounds = this._getVirtualDataBounds();
      if (!this._isVirtualModelSelectable(model, index, bounds)) {
        return;
      }
      model._rowSelected = !!selected;
      this._syncVirtualSelectionViews();
      var headerView = this.superView && this.superView.getHeaderView();
      headerView && _.isFunction(headerView.setSelection) && headerView.setSelection(this.allSelected());
      if (!opt_silent) {
        this._dispatchSelectionChange();
      }
      return;
    }
    var tbaleRowView = this.indexOfSubView(index);
    tbaleRowView.setSelected(selected, opt_silent);
    var allSelected = this.allSelected();
    var headerView = this.superView && this.superView.getHeaderView();
    headerView && _.isFunction(headerView.setSelection) && headerView.setSelection(allSelected);
  },
  setAllRowSelected: function setAllRowSelected(selected) {
    this._controlAllRowSelection(selected);
  },
  allSelected: function allSelected() {
    if (this.virtualScroll) {
      // “全选”仅覆盖当前数据边界内 getShow() 为真的行。
      if (!this.dataCollection || this.dataCollection.length == 0) {
        return false;
      }
      var bounds = this._getVirtualDataBounds();
      var selectableModels = this.dataCollection.filter(function (model, index) {
        return index >= bounds.start && index < bounds.end && (!_.isFunction(model.getShow) || model.getShow());
      });
      return selectableModels.length > 0 && _.every(selectableModels, function (model) {
        return !!model._rowSelected;
      });
    }
    // Grid 虚拟滚动：全选判断基于 dataCollection 中所有已加载 model，而非仅可见视图。
    if (this.virtualGridScroll) {
      if (!this.dataCollection || this.dataCollection.length == 0) {
        return false;
      }
      var gmodels = this.dataCollection.filter(function (model) {
        return !_.isFunction(model.getShow) || model.getShow();
      });
      return gmodels.length > 0 && _.every(gmodels, function (model) {
        return !!model._rowSelected;
      });
    }
    if (this.getSubViewCount() == 0) {
      return false;
    }
    var allSelected = true;
    var len = 0;
    var subViews = this.filterSubViews(function (subView) {
      if (!subView.$el.hasClass("f-hide")) {
        len++;
        return subView.isSelected();
      }
      return false;
    });
    return subViews && subViews.length == len;
  },
  _isVirtualModelSelectable: function _isVirtualModelSelectable(model, index, bounds) {
    // 集中定义虚拟模式的可选范围，供单选、区间选和全选复用。
    bounds = bounds || this._getVirtualDataBounds();
    return index >= bounds.start && index < bounds.end && (!_.isFunction(model.getShow) || model.getShow());
  },
  hasSelectedRow: function hasSelectedRow() {
    if (this.virtualScroll) {
      return this.getSelectedModels().length > 0;
    }
    if (this.virtualGridScroll) {
      return this.dataCollection ? this.dataCollection.some(function (model) {
        return !!model._rowSelected;
      }) : false;
    }
    var subViews = this.findSubView(function (subView) {
      return subView.isSelected();
    });
    return !!subViews;
  },
  render: function render(data) {
    _MMViewBase["default"].prototype.render.call(this, data);
    this._renderRows();
  },
  getSelectedModels: function getSelectedModels() {
    if (this.virtualScroll) {
      var bounds = this._getVirtualDataBounds();
      return this.dataCollection ? this.dataCollection.filter(function (model, index) {
        return this._isVirtualModelSelectable(model, index, bounds) && !!model._rowSelected;
      }, this) : [];
    }
    if (this.virtualGridScroll) {
      return this.dataCollection ? this.dataCollection.filter(function (model) {
        return !!model._rowSelected;
      }) : [];
    }
    var self = this;
    var selected = this.filterSubViews(function (rowView, index) {
      return rowView.isSelected();
    });
    var selectedModels = _.map(selected, function (rowView) {
      return rowView.getRowModel();
    });
    return selectedModels;
  },
  getRenderedDataCount: function getRenderedDataCount() {
    if (this.virtualGridScroll) {
      return this.dataCollection ? this.dataCollection.length : 0;
    }
    // 返回"分页逻辑已开放的数据量"，而不是物理 DOM 数量。
    // 非虚拟模式仍返回原 getSubViewCount()，保证现有调用方行为不变。
    if (this.virtualScroll) {
      return Math.min(Number(this.dataCollection && this.dataCollection.end) || 0, this.dataCollection ? this.dataCollection.length : 0);
    }
    return this.getSubViewCount();
  },
  _dataCollectionSorted: function _dataCollectionSorted(colleciton, options) {
    if (!this.dataCollection || this.dataCollection.length == 0) {
      return;
    }
    if (this.virtualGridScroll) {
      this.el.scrollTop = 0;
      _.isFunction(this._scheduleGridRender) && this._scheduleGridRender();
      return;
    }
    if (this.virtualScroll) {
      // 排序改变模型顺序和累计偏移，从顶部按新顺序重建窗口。
      this._invalidateVirtualLayout();
      this.el.scrollTop = 0;
      this._renderVirtualRows();
      return;
    }
    if (this.useSortRows && this.dataCollection.length == this.subViews.length) {
      this._renderSortedRows();
    } else {
      this._renderRows();
    }
    this.el.scrollTop = 0;
  },
  scrollToTop: function scrollToTop() {
    this.scrollTop = 0;
    this.el.scrollTop = 0;
  },
  getScrollTop: function getScrollTop() {
    return this.el.scrollTop;
  },
  setScrollTop: function setScrollTop(top) {
    this.el.scrollTop = top;
    this.scrollTop = top;
  },
  onlysetScrollTop: function onlysetScrollTop(top) {
    this.el.scrollTop = top;
  },
  _dataCollectionReseted: function _dataCollectionReseted(opt) {
    if (this.virtualGridScroll) {
      this._gridMeasuredHeights = {};
      this._gridMetrics = null;
      this._gridVisibleRange = null;
    }
    if (this.virtualScroll) {
      // reset 后 cid 集合和行顺序均可能变化，废弃所有旧布局资源。
      this._disconnectVirtualResizeObserver();
      this._cancelVirtualMeasure();
      this._releaseVirtualRetainedRows();
      if (!(opt && opt.noRefresh)) {
        this._releaseVirtualCurrentRows();
      }
      this._virtualRowHeights = {};
      this._virtualRenderedKeys = [];
      this._virtualRowStates = {};
      this._virtualRetainedRowViews = {};
      this._invalidateVirtualLayout();
    }
    if (opt && opt.noRefresh) {
      return;
    }
    if (this.dataCollection.length == 0) {
      this._renderBlankState();
    } else {
      this._renderRows();
    }
  },
  _dataCollectionUpdated: function _dataCollectionUpdated() {
    if (this.virtualGridScroll) {
      this.$blankView && this.$blankView.remove();
      _.isFunction(this._scheduleGridRender) && this._scheduleGridRender();
      this._controlAllRowSelection();
      return;
    }
    if (this.virtualScroll) {
      // model 可见性或内容变化可能影响行高与过滤结果，延迟合并重绘。
      this._invalidateVirtualLayout();
      if (this.dataCollection.length == 0) {
        this._scheduleVirtualRender();
      } else {
        this.$blankView && this.$blankView.remove();
        this._scheduleVirtualRender();
      }
      this._controlAllRowSelection();
      return;
    }
    if (this.dataCollection.length == 0) {
      this._renderBlankState();
    } else {
      this.$blankView && this.$blankView.remove();
    }
    this._controlAllRowSelection();
  },
  isFullfillContent: function isFullfillContent() {
    return this.$('.table-content')[0].offsetHeight > this.el.offsetHeight;
  },
  _addNewDataModel: function _addNewDataModel(model, dataCollection, opt) {
    if (opt && opt.noOtherEvent) {
      return;
    }
    if (this.virtualGridScroll) {
      _.isFunction(this._scheduleGridRender) && this._scheduleGridRender();
      this.refreshPageBar();
      return;
    }
    if (this.virtualScroll) {
      // end 是已开放数据范围的右边界。向该范围内插入模型时同步扩展边界，
      // 否则头部新增一行会挤掉原范围内的最后一行。
      var currentEnd = Number(dataCollection && dataCollection.end) || 0;
      if (currentEnd > 0) {
        var insertIndex = dataCollection.indexOf(model);
        var previousLength = Math.max(dataCollection.length - 1, 0);
        if (currentEnd >= previousLength || insertIndex >= 0 && insertIndex <= currentEnd) {
          dataCollection.end = Math.min(currentEnd + 1, dataCollection.length);
        }
      }
      // 新增数据只扩展布局，不立即创建视口之外的 row view。
      this._invalidateVirtualLayout();
      this._scheduleVirtualRender();
      this.refreshPageBar();
      return;
    }
    var self = this;
    var index = opt.at;
    var rowOptionsPassed = _.isFunction(self.rowOption) ? self.rowOption() : self.rowOption;
    var rowOption = _.extend({
      singleSelect: this.singleSelect,
      rowCls: this.rowCls,
      index: index,
      rowModel: model,
      columns: this.columns,
      allowSelect: this.allowSelect,
      isSearch: this.isSearch,
      isUsedAdvancedSearch: self.isUsedAdvancedSearch
    }, rowOptionsPassed);
    var rowView = new this.rowClass(rowOption);
    model.view = rowView;
    rowView.model = model;
    if (_.isNumber(index)) {
      index = index < 0 ? 0 : index;
      index = index > this.getSubViewCount() ? this.getSubViewCount() : index;
      this.addSubViewAt(rowView, index, this.$('.table-content')[0]);
    } else {
      this.addSubView(rowView, this.$('.table-content')[0]);
    }
    this.refreshPageBar();
    _.isFunction(this.addNewCallback) && this.addNewCallback();
  },
  _dataCollectionAllEventHandler: function _dataCollectionAllEventHandler(eventName, model, dataCollection, opt) {
    if (opt && opt.noOtherEvent) {
      // console.warn('成功阻断')
      return;
    }
    var e = eventName;
    if (e == 'add' || e == 'remove' || e == 'sort' || e == 'destroy' || e == 'reset') {
      this._controlAllRowSelection();
      this.setCurIndex(-1);
    }
  },
  _removeDataModel: function _removeDataModel(model, collection, opt) {
    if (this.virtualGridScroll) {
      if (this._gridMeasuredHeights && opt && opt.index != null) {
        delete this._gridMeasuredHeights[opt.index];
      }
      _.isFunction(this.onTableRowRemoved) && this.onTableRowRemoved({
        index: opt && opt.index,
        fileId: _.isFunction(model.getFileId) && model.getFileId()
      });
      _.isFunction(this._scheduleGridRender) && this._scheduleGridRender();
      this.refreshPageBar();
      return;
    }
    if (this.virtualScroll) {
      // 删除模型时同步删除按行 key 保存的高度与临时 UI 状态。
      var virtualRowKey = this._getVirtualRowKey(model);
      delete this._virtualRowHeights[virtualRowKey];
      delete this._virtualRowStates[virtualRowKey];
      this._invalidateVirtualLayout();
      _.isFunction(this.onTableRowRemoved) && this.onTableRowRemoved({
        index: opt && opt.index,
        fileId: _.isFunction(model.getFileId) && model.getFileId()
      });
      this._scheduleVirtualRender();
      this.refreshPageBar();
      return;
    }
    var index = opt.index;
    _.isFunction(this.onTableRowRemoved) && this.onTableRowRemoved({
      index: index,
      fileId: _.isFunction(model.getFileId) && model.getFileId()
    });
    this.removeSubViewAt(index);
    this.refreshPageBar();
  },
  _onVirtualScroll: function _onVirtualScroll() {
    // 滚动处理分两级：窗口 key 未变化时只校正 padding 和底部提示；
    // 只有进入/离开缓冲区的模型发生变化时，才安排 Row View 增删和复用。
    if (!this.virtualScroll) {
      return;
    }
    var range = this._getVirtualRange();
    var self = this;
    var keys = range.visibleModels.slice(range.start, range.end).map(function (entry) {
      return self._getVirtualRowKey(entry.model);
    });
    if (_.isEqual(keys, this._virtualRenderedKeys)) {
      this._updateVirtualPadding();
      return;
    }
    this._scheduleVirtualRender();
  },
  _scheduleVirtualRender: function _scheduleVirtualRender() {
    var _this2 = this;
    // 将同一帧内的滚动、测量和 collection 事件合并为一次重绘。
    if (this._virtualScrollFrame) {
      return;
    }
    var requestFrame = window.requestAnimationFrame || function (callback) {
      return window.setTimeout(callback, 16);
    };
    this._virtualScrollFrame = requestFrame(function () {
      _this2._virtualScrollFrame = null;
      _this2._renderVirtualRows();
    });
  },
  _invalidateVirtualLayout: function _invalidateVirtualLayout() {
    // 仅清除派生布局，保留已测行高；下次读取范围时按最新数据惰性重建。
    this._virtualLayoutCache = null;
  },
  _getVirtualRange: function _getVirtualRange() {
    // 构建方式：过滤当前分页内 getShow() 为真的模型，以实测高度或预估高度生成累计偏移。
    // 查询方式：两次二分查找分别定位视口首尾，再扩展 virtualBuffer，复杂度为 O(log n)。
    // 返回的 start/end 是 visibleModels 内的半开区间，不是 Collection 的原始下标。
    var defaultRowHeight = Math.max(Number(this.virtualRowHeight) || 50, 1);
    var buffer = Math.max(Number(this.virtualBuffer) || 0, 0);
    var layout = this._virtualLayoutCache;
    if (!layout) {
      var visibleModels = [];
      var bounds = this._getVirtualDataBounds(true);
      var dataStart = bounds.start;
      var dataEnd = bounds.end;
      var offsets = [0];
      var self = this;
      this.dataCollection.each(function (model, index) {
        if (index >= dataStart && index < dataEnd && (!_.isFunction(model.getShow) || model.getShow())) {
          visibleModels.push({
            model: model,
            index: index
          });
          var cachedHeight = self._virtualRowHeights[self._getVirtualRowKey(model)];
          offsets.push(offsets[offsets.length - 1] + (cachedHeight > 0 ? cachedHeight : defaultRowHeight));
        }
      });
      layout = this._virtualLayoutCache = {
        visibleModels: visibleModels,
        offsets: offsets,
        totalHeight: offsets[offsets.length - 1] || 0
      };
    }
    var visibleModels = layout.visibleModels;
    var offsets = layout.offsets;
    var scrollTop = this.el.scrollTop;
    var viewportBottom = scrollTop + this.el.clientHeight;
    var low = 0;
    var high = visibleModels.length;
    while (low < high) {
      var middle = Math.floor((low + high) / 2);
      if (offsets[middle + 1] <= scrollTop) {
        low = middle + 1;
      } else {
        high = middle;
      }
    }
    var start = low;
    start = Math.max(start - buffer, 0);
    low = 0;
    high = visibleModels.length;
    while (low < high) {
      var endMiddle = Math.floor((low + high) / 2);
      if (offsets[endMiddle] < viewportBottom) {
        low = endMiddle + 1;
      } else {
        high = endMiddle;
      }
    }
    var end = low;
    end = Math.min(end + buffer, visibleModels.length);
    return {
      start: start,
      end: end,
      offsets: offsets,
      totalHeight: layout.totalHeight,
      visibleModels: visibleModels,
      getRowTop: function getRowTop(position) {
        return offsets[position] || 0;
      },
      getRowHeight: function getRowHeight(position) {
        return (offsets[position + 1] || 0) - (offsets[position] || 0);
      }
    };
  },
  _getVirtualRowKey: function _getVirtualRowKey(model) {
    // cid 在 collection 生命周期内稳定；fileId 仅作为兼容回退。
    return model && (model.cid || _.isFunction(model.getFileId) && model.getFileId());
  },
  setVirtualRowState: function setVirtualRowState(model, name, value) {
    // 保存不能放入业务 model 的临时行 UI 状态，例如评论展开状态。
    // 状态生命周期跟随当前 Table Body；Collection 更换、清空或销毁时统一释放。
    if (!this.virtualScroll || !model || !name) {
      return;
    }
    var key = this._getVirtualRowKey(model);
    this._virtualRowStates[key] = this._virtualRowStates[key] || {};
    this._virtualRowStates[key][name] = value;
  },
  getVirtualRowState: function getVirtualRowState(model, name) {
    var key = this._getVirtualRowKey(model);
    return !!(key && this._virtualRowStates[key] && this._virtualRowStates[key][name]);
  },
  clearVirtualRowState: function clearVirtualRowState(model, name) {
    // 展开状态清除后，对应的离屏保留 view 也应立即释放。
    var self = this;
    if (!model) {
      _.each(this._virtualRowStates, function (state, key) {
        if (name) {
          delete state[name];
          if (_.isEmpty(state)) {
            delete self._virtualRowStates[key];
          }
        } else {
          delete self._virtualRowStates[key];
        }
      });
      if (!name || name === 'commentExpanded') {
        this._releaseVirtualRetainedRows();
      }
      return;
    }
    var key = this._getVirtualRowKey(model);
    if (!key || !this._virtualRowStates[key]) {
      return;
    }
    if (name) {
      delete this._virtualRowStates[key][name];
      if (_.isEmpty(this._virtualRowStates[key])) {
        delete this._virtualRowStates[key];
      }
    } else {
      delete this._virtualRowStates[key];
    }
    if (!name || name === 'commentExpanded') {
      this._releaseVirtualRetainedRows(model);
    }
  },
  _releaseVirtualRetainedRows: function _releaseVirtualRetainedRows(model) {
    // 评论展开行离屏后会暂存；状态结束或销毁时在此统一回收。
    var targetKey = model && this._getVirtualRowKey(model);
    var self = this;
    var released = false;
    _.each(this._virtualRetainedRowViews || {}, function (view, key) {
      if (targetKey && key !== targetKey) {
        return;
      }
      if (view.model && view.model.view === view) {
        view.model.view = null;
      }
      try {
        view.remove();
      } catch (e) {
        // A retained row may already have been removed by its owner.
      }
      view.superView = null;
      delete self._virtualRowHeights[key];
      delete self._virtualRetainedRowViews[key];
      released = true;
    });
    if (released) {
      this._invalidateVirtualLayout();
    }
  },
  _releaseVirtualCurrentRows: function _releaseVirtualCurrentRows() {
    // 完整释放当前窗口，并清除业务代码可能读取的 model.view 引用。
    _.each([].concat(this.subViews || []), function (view) {
      if (view.model && view.model.view === view) {
        view.model.view = null;
      }
      try {
        view.remove();
      } catch (e) {
        // A current row may already have been removed during collection reset.
      }
      view.superView = null;
    });
    this.subViews = [];
    this.$('.table-content').empty();
  },
  _disconnectVirtualResizeObserver: function _disconnectVirtualResizeObserver() {
    if (this._virtualResizeObserver) {
      this._virtualResizeObserver.disconnect();
      this._virtualResizeObserver = null;
    }
  },
  _cancelVirtualMeasure: function _cancelVirtualMeasure() {
    if (this._virtualMeasureFrame) {
      var cancelFrame = window.cancelAnimationFrame || window.clearTimeout;
      cancelFrame(this._virtualMeasureFrame);
      this._virtualMeasureFrame = null;
    }
  },
  _observeVirtualRows: function _observeVirtualRows() {
    // ResizeObserver 捕获评论展开等动态高度；每次窗口重绘后重新绑定当前 Row View。
    // 不支持 ResizeObserver 的浏览器仍在渲染后主动测量一次，不影响基本滚动能力。
    this._disconnectVirtualResizeObserver();
    if (!this.virtualScroll || !window.ResizeObserver) {
      this._refreshVirtualRowHeights();
      return;
    }
    var self = this;
    this._virtualResizeObserver = new window.ResizeObserver(function () {
      self._refreshVirtualRowHeights();
    });
    this.eachSubViews(function (view) {
      self._virtualResizeObserver.observe(view.el);
    });
    this._refreshVirtualRowHeights();
  },
  refreshVirtualRowHeights: function refreshVirtualRowHeights() {
    // 对外的高度刷新入口按帧去重，避免连续 DOM 修改导致布局抖动。
    if (!this.virtualScroll) {
      return;
    }
    var self = this;
    var requestFrame = window.requestAnimationFrame || function (callback) {
      return window.setTimeout(callback, 16);
    };
    this._cancelVirtualMeasure();
    this._virtualMeasureFrame = requestFrame(function () {
      self._virtualMeasureFrame = null;
      self._refreshVirtualRowHeights();
    });
  },
  _refreshVirtualRowHeights: function _refreshVirtualRowHeights() {
    // 只读取当前窗口，避免遍历或创建离屏 DOM；测得高度写入缓存后重建累计偏移。
    // 高度缩小时可视窗口可能向后扩展，因此额外检查 key 并按需安排一次重绘。
    if (!this.virtualScroll || !this.subViews.length) {
      return;
    }
    var changed = false;
    var heightDecreased = false;
    var self = this;
    this.eachSubViews(function (view) {
      var key = self._getVirtualRowKey(view.model || view.rowModel);
      var height = view.el.getBoundingClientRect().height;
      if (key && height > 0 && self._virtualRowHeights[key] !== height) {
        heightDecreased = heightDecreased || self._virtualRowHeights[key] > height;
        self._virtualRowHeights[key] = height;
        changed = true;
      }
    });
    if (changed) {
      this._invalidateVirtualLayout();
      this._updateVirtualPadding();
      if (heightDecreased) {
        var range = this._getVirtualRange();
        var rangeSelf = this;
        var expectedKeys = range.visibleModels.slice(range.start, range.end).map(function (entry) {
          return rangeSelf._getVirtualRowKey(entry.model);
        });
        if (!_.isEqual(expectedKeys, this._virtualRenderedKeys)) {
          this._scheduleVirtualRender();
        }
      }
    }
  },
  _syncVirtualSelectionViews: function _syncVirtualSelectionViews() {
    // model 是状态源，已挂载 view 仅同步视觉状态。
    this.eachSubViews(function (view) {
      var model = view.model || view.rowModel;
      view.setSelected(!!(model && model._rowSelected), true);
    });
  },
  _updateVirtualPadding: function _updateVirtualPadding() {
    // 上下 padding 分别模拟窗口前后的未挂载行，使 scrollHeight 等于逻辑总高度。
    // 使用实际首尾 View 的 key 反查位置，兼容 Row View 复用和动态范围变化。
    var range = this._getVirtualRange();
    var firstView = this.subViews[0];
    var lastView = this.subViews[this.subViews.length - 1];
    var firstModel = firstView && (firstView.model || firstView.rowModel);
    var lastModel = lastView && (lastView.model || lastView.rowModel);
    var firstKey = this._getVirtualRowKey(firstModel);
    var lastKey = this._getVirtualRowKey(lastModel);
    var firstPosition = -1;
    var lastPosition = -1;
    var self = this;
    _.each(range.visibleModels, function (entry, position) {
      var key = self._getVirtualRowKey(entry.model);
      if (firstPosition < 0 && key === firstKey) {
        firstPosition = position;
      }
      if (key === lastKey) {
        lastPosition = position;
      }
    });
    firstPosition = firstPosition < 0 ? range.start : firstPosition;
    lastPosition = lastPosition < 0 ? range.end - 1 : lastPosition;
    var bottomSpacing = Math.max(Number(this.virtualBottomSpacing) || 0, 0);
    this.$('.table-content').css({
      paddingTop: range.getRowTop(firstPosition),
      paddingBottom: Math.max(range.totalHeight - range.getRowTop(lastPosition + 1), 0) + bottomSpacing
    });
    this._positionVirtualLoadedSign(range);
  },
  _positionVirtualLoadedSign: function _positionVirtualLoadedSign(range) {
    var $loadedSign = this.$('.table-content').children('.loaded-sign');
    if (!$loadedSign.length) {
      return;
    }

    // bottom: 0 会受虚拟 padding、min-height 和 box-sizing 共同影响，可能覆盖最后一行。
    // 长列表锚定到逻辑总行高之后；短列表至少推到容器底部，resize 后由 Table 重新调用。
    var bottomSpacing = Math.max(Number(this.virtualBottomSpacing) || 0, 0);
    var signHeight = $loadedSign.outerHeight() || 0;
    var gap = Math.max(bottomSpacing - signHeight, 0);
    var contentHeight = this.$('.table-content')[0].clientHeight;
    var viewportBottomTop = Math.max(contentHeight - signHeight, 0);
    $loadedSign.css({
      // 数据较多时位于最后一行之后；数据不足一屏时贴住内容区域底部。
      top: Math.max(range.totalHeight + gap, viewportBottomTop),
      bottom: 'auto'
    });
  },
  _getVirtualDataBounds: function _getVirtualDataBounds(initializeEnd) {
    // 保留原分页 startIndex/end 语义，虚拟化只发生在已开放的数据范围内。
    // initializeEnd 仅在首次构建布局时补齐缺失的 end，后续不会越过 Collection.length。
    var dataStart = Math.max(Number(this.startIndex) || 0, 0);
    var dataEnd = Number(this.dataCollection && this.dataCollection.end);
    if (!dataEnd) {
      dataEnd = Math.min(this.superView && this.superView.pageSize || 50, this.dataCollection ? this.dataCollection.length : 0);
      if (initializeEnd && this.dataCollection) {
        this.dataCollection.end = dataEnd;
      }
    }
    return {
      start: dataStart,
      end: Math.min(Math.max(dataEnd, dataStart), this.dataCollection ? this.dataCollection.length : 0)
    };
  },
  _renderVirtualRows: function _renderVirtualRows(callback) {
    // 渲染流程：计算范围 -> 按模型 key 复用重叠 Row -> 创建边缘新增 Row ->
    // 释放离开范围的普通 Row -> 保留展开评论 Row -> 更新 padding、提示和高度 observer。
    // 始终只挂载视口及缓冲区；展开评论行允许离屏保留，以避免重复请求和重复监听。
    if (this._virtualScrollFrame) {
      var cancelFrame = window.cancelAnimationFrame || window.clearTimeout;
      cancelFrame(this._virtualScrollFrame);
      this._virtualScrollFrame = null;
    }
    if (!this.dataCollection) {
      return;
    }
    this._disconnectVirtualResizeObserver();
    if (this.dataCollection.length == 0) {
      this._cancelVirtualMeasure();
      this._releaseVirtualRetainedRows();
      this._releaseVirtualCurrentRows();
      this._virtualRowHeights = {};
      this._virtualRenderedKeys = [];
      this._virtualLayoutCache = null;
      this._virtualRowStates = {};
      this._virtualRetainedRowViews = {};
      this.$('.table-content').css({
        paddingTop: 0,
        paddingBottom: 0
      }).empty();
      // isInit 表示视图仍在初始化阶段，数据尚未加载，不显示空提示避免闪现。
      if (!this.dataCollection.isInit) {
        this._renderBlankState();
      }
      _.isFunction(callback) && callback();
      return;
    }
    this.$blankView && this.$blankView.remove();
    var self = this;
    var range = this._getVirtualRange();
    var oldSubViews = [].concat(this.subViews);
    var reusableViews = {};
    var discardedViews = [];
    _.each(oldSubViews, function (view) {
      var model = view.model || view.rowModel;
      var key = self._getVirtualRowKey(model);
      if (key) {
        // 当前窗口中的普通行也按模型 key 复用。轻微滚动时只创建边缘新增行，
        // 避免仍在可视范围内的缩略图节点被销毁后重新加载。
        reusableViews[key] = view;
        view.$el.detach();
      } else {
        // 无稳定 key 的异常行不能安全复用，仍按原生命周期释放。
        discardedViews.push(view);
      }
    });
    _.each(this._virtualRetainedRowViews, function (view, key) {
      reusableViews[key] = view;
    });
    this._virtualRetainedRowViews = {};
    var buffer = document.createDocumentFragment();
    var $content = this.$('.table-content');
    // “已全部加载”提示由文件表管理，不属于虚拟 row；重绘窗口时需保留该节点。
    // 否则最后一页刚插入提示，就会被随后执行的 $content.empty() 删除。
    var $loadedSign = $content.children('.loaded-sign').detach();
    var orderedSubViews = [];
    var newSubViews = [];
    this.subViews = [];
    this._virtualRenderedKeys = [];
    $content.empty();
    range.visibleModels.slice(range.start, range.end).forEach(function (entry) {
      var model = entry.model;
      var index = entry.index;
      var key = self._getVirtualRowKey(model);
      var rowView = reusableViews[key];
      self._virtualRenderedKeys.push(key);

      // 跨模式切换（list↔grid）时 rowClass 会变，旧视图类型不匹配，必须丢弃重建。
      if (rowView && rowView.constructor !== self.rowClass) {
        try {
          rowView.remove();
        } catch (e) {}
        rowView.superView = null;
        if (model.view === rowView) model.view = null;
        rowView = null;
        delete reusableViews[key];
      }
      if (rowView) {
        // 复用时更新真实 collection 下标及 model.view 关联。
        delete reusableViews[key];
        rowView.index = index;
        rowView.rowModel = model;
        rowView.model = model;
        rowView.superView = self;
        model.view = rowView;
        orderedSubViews.push(rowView);
        buffer.appendChild(rowView.el);
        return;
      }
      var rowOptionsPassed = _.isFunction(self.rowOption) ? self.rowOption() : self.rowOption;
      var rowOption = _.extend({
        singleSelect: self.singleSelect,
        rowCls: self.rowCls,
        index: index,
        rowModel: model,
        columns: self.columns,
        allowSelect: self.allowSelect,
        dataCollection: self.dataCollection,
        isSearch: self.isSearch,
        isUsedAdvancedSearch: self.isUsedAdvancedSearch
      }, rowOptionsPassed);
      rowView = new self.rowClass(rowOption);
      orderedSubViews.push(rowView);
      newSubViews.push(rowView);
      self.addSubView(rowView, function () {
        _RenderProxy["default"].buildViewDom(rowView);
        buffer.appendChild(rowView.el);
        model.view = rowView;
        rowView.model = model;
      }, false, true);
    });
    this.subViews = orderedSubViews;
    var bottomSpacing = Math.max(Number(this.virtualBottomSpacing) || 0, 0);
    $content.css({
      paddingTop: range.getRowTop(range.start),
      paddingBottom: Math.max(range.totalHeight - range.getRowTop(range.end), 0) + bottomSpacing
    });
    _.each(newSubViews, function (view) {
      _RenderProxy["default"].viewWillRendered(view);
    });
    _.each(discardedViews, function (subView) {
      if (subView.model && subView.model.view === subView) {
        subView.model.view = null;
      }
      try {
        subView.remove();
      } catch (e) {
        // Keep virtual scrolling usable if an old row has already been removed.
      }
      subView.superView = null;
    });
    _.each(reusableViews, function (subView, key) {
      if (subView.model && subView.model.view === subView) {
        subView.model.view = null;
      }
      if (self.getVirtualRowState(subView.model || subView.rowModel, 'commentExpanded')) {
        subView.$el.detach();
        self._virtualRetainedRowViews[key] = subView;
        return;
      }
      try {
        subView.remove();
      } catch (e) {
        // Keep virtual scrolling usable if an old row has already been removed.
      }
      subView.superView = null;
    });
    $content.append(buffer);
    $loadedSign.length && $content.append($loadedSign);
    this._positionVirtualLoadedSign(range);
    if (!range.visibleModels.length) {
      $content.css({
        paddingTop: 0,
        paddingBottom: 0
      }).append('<div class="f-tc mgt-20">' + BabelStr.str(2055) + '</div>');
    }
    _.each(newSubViews, function (view) {
      _RenderProxy["default"].viewDidRendered(view);
    });
    this._observeVirtualRows();
    _.isFunction(callback) && callback();
  },
  _renderRows: function _renderRows(callback) {
    if (this.virtualScroll) {
      // 显式分流，关闭虚拟滚动时原实现不发生任何行为变化。
      this._renderVirtualRows(callback);
      return;
    }
    if (!this.dataCollection) {
      return;
    }

    // console.group("TableRow render phase , row number : " + this.dataCollection.length);
    // console.time('TableRow render')
    var self = this;
    // console.time('TableRow removeSubViews')
    // this.removeSubViews();

    var subViews = [].concat(this.subViews);
    this.subViews = [];
    // console.timeEnd('TableRow removeSubViews')
    this.$('.table-content').empty();
    var rowClass = this.rowClass;
    var buffer = document.createDocumentFragment();

    // console.time('TableRow obj create')
    var end = this.dataCollection.end;
    if (!end) {
      var fileInforCollection = this.dataCollection;
      fileInforCollection.needPage = true;
      fileInforCollection.end = this.superView && this.superView.pageSize || 50;
      end = this.superView && this.superView.pageSize || 50;
    }
    ;
    this.dataCollection.each(function (model, index) {
      if (index >= end) {
        return;
      }
      if (self.startIndex && index < self.startIndex) {
        return;
      }
      if (_.isFunction(model.getShow) && !model.getShow()) {
        return;
      }
      var rowOptionsPassed = _.isFunction(self.rowOption) ? self.rowOption() : self.rowOption;
      var rowOption = _.extend({
        singleSelect: self.singleSelect,
        rowCls: self.rowCls,
        index: index,
        rowModel: model,
        columns: self.columns,
        allowSelect: self.allowSelect,
        dataCollection: self.dataCollection,
        isSearch: self.isSearch,
        isUsedAdvancedSearch: self.isUsedAdvancedSearch
      }, rowOptionsPassed);
      var rowView = new self.rowClass(rowOption);
      self.addSubView(rowView, function () {
        _RenderProxy["default"].buildViewDom(rowView);
        buffer.appendChild(rowView.el);
        model.view = rowView;
        rowView.model = model;
      }, false, true);
    });
    // console.timeEnd('TableRow obj create')
    // console.time('TableRow viewWillRendered')
    this.eachSubViews(function (view) {
      _RenderProxy["default"].viewWillRendered(view);
    });
    // console.timeEnd('TableRow viewWillRendered')

    _.each(subViews, function (subView, index) {
      try {
        subView.remove();
      } catch (e) {}
      subView.superView = null;
    });
    this.$blankView && this.$blankView.remove();

    // console.time('TableRow dom append')
    try {
      self.$('.table-content').empty().append(buffer);
    } catch (error) {
      console.log(error);
    }

    // console.timeEnd('TableRow dom append')
    // console.time('TableRow viewDidRendered')
    this.eachSubViews(function (view) {
      _RenderProxy["default"].viewDidRendered(view);
    });
    if (this.dataCollection.length && !this.subViews.length) {
      self.$('.table-content').empty().append("\n          <div class=\"f-tc mgt-20\">".concat(BabelStr.str(2055), "</div>\n        "));
    }

    // console.timeEnd('TableRow viewDidRendered')
    // console.timeEnd('TableRow render')
  },
  _renderSortedRows: function _renderSortedRows(callback) {
    var dataCollection = this.dataCollection;
    if (!dataCollection) {
      return;
    }
    this.onBeforeWebSort();
    // console.group("TableRow render phase , row number : " + dataCollection.length);
    // console.time('TableRow render')
    var self = this;
    // console.time('TableRow removeSubViews')
    // this.removeSubViews();

    var subViews = [].concat(this.subViews);
    this.subViews = [];
    // console.timeEnd('TableRow removeSubViews')
    // this.$('.table-content').empty();
    // var rowClass = this.rowClass;

    // var buffer = document.createDocumentFragment()

    console.time('TableRow obj sort start');
    var end = dataCollection.length;
    // if (!end) {
    //   var fileInforCollection = dataCollection;
    //   fileInforCollection.needPage = true;
    //   fileInforCollection.end = this.superView && this.superView.pageSize || 50;
    //   end = this.superView && this.superView.pageSize || 50;
    // };
    var subViewids = _.map(subViews, function (view) {
      return view.model.id;
    });
    var $subViewEls = [];
    dataCollection.each(function (model, index) {
      if (index >= end) {
        return;
      }
      if (self.startIndex && index < self.startIndex) {
        return;
      }
      if (_.isFunction(model.getShow) && !model.getShow()) {
        return;
      }
      var id = model.id;
      var originIndex = _.indexOf(subViewids, id);
      var rowView = subViews[originIndex];
      if (!rowView) {
        // var rowOptionsPassed = _.isFunction(self.rowOption) ? self.rowOption() : self.rowOption;
        // var rowOption = _.extend({
        //   singleSelect: self.singleSelect,
        //   rowCls: self.rowCls,
        //   index: index,
        //   rowModel: model,
        //   columns: self.columns,
        //   allowSelect: self.allowSelect,
        //   dataCollection: self.dataCollection,
        //   isSearch: self.isSearch,
        // }, rowOptionsPassed);
        // rowView = new self.rowClass(rowOption);
        console.log('出现了未加载的model');
      }
      self.subViews.push(rowView);
      $subViewEls.push(rowView.$el);

      // self.addSubView(rowView, function() {
      //   RenderProxy.buildViewDom(rowView);
      //   buffer.appendChild(rowView.el);
      //   model.view = rowView;
      //   rowView.model = model;
      // }, false, true);
    });
    console.warn('TableRow obj sorted');
    //   // console.time('TableRow viewWillRendered')
    // this.eachSubViews(function(view) {
    //     RenderProxy.viewWillRendered(view)
    //   })
    //   // console.timeEnd('TableRow viewWillRendered')

    // _.each(subViews, function(subView, index) {
    //   try{
    //     subView.remove();
    //   } catch(e) {

    //   }
    //   subView.superView = null;
    // })
    this.$blankView && this.$blankView.remove();

    // console.time('TableRow dom append')
    try {
      self.$('.table-content')[0].replaceChildren();
      self.$('.table-content').html($subViewEls);
    } catch (error) {
      var div = self.$('.table-content')[0];
      var childNodes = div.childNodes;
      for (var i = childNodes.length - 1; i >= 0; i--) {
        if (childNodes[i].nodeType === Node.ELEMENT_NODE) {
          // 只处理元素节点
          div.removeChild(childNodes[i]);
        }
      }
      self.$('.table-content').html($subViewEls);
    }

    // console.timeEnd('TableRow dom append')
    // console.time('TableRow viewDidRendered')
    // this.eachSubViews(function(view) {
    //     RenderProxy.viewDidRendered(view)
    //   })
    if (dataCollection.length && !this.subViews.length) {
      self.$('.table-content').empty().append("\n          <div class=\"f-tc mgt-20\">".concat(BabelStr.str(2055), "</div>\n        "));
    }
    this.onAfterWebSort();
  },
  renderFilterResult: function renderFilterResult(callback) {
    if (this.virtualScroll) {
      // 过滤会改变 visibleModels，必须废弃累计偏移后重绘窗口。
      this._invalidateVirtualLayout();
      this._scheduleVirtualRender();
      _.isFunction(callback) && callback();
      return;
    }
    var dataCollection = this.dataCollection;
    if (!dataCollection) {
      return;
    }
    var self = this;
    // let allSelected = this.allSelected()
    var allSelected = false;
    var subViews = this.originSubViews;
    this.subViews = [];
    var subViewids = _.map(subViews, function (view) {
      return view.model.id;
    });
    var $subViewEls = [];
    var num = 0;
    dataCollection.each(function (model) {
      var id = model.id;
      var originIndex = _.indexOf(subViewids, id);
      var rowView = subViews[originIndex];
      if (!rowView) {
        console.log('出现了未加载的model');
      } else {
        if (_.isFunction(model.getShow) && !model.getShow()) {
          rowView.$el.addClass("f-hide");
          // if(allSelected) {
          rowView.setSelected(false, true);
          // }
        } else {
          rowView.$el.removeClass("f-hide");
          if (allSelected) {
            rowView.setSelected(true, true);
          }
        }
        self.subViews.push(rowView);
        $subViewEls.push(rowView.$el);
      }
    });
    console.timeEnd('TableRow obj filtered');
    this.$blankView && this.$blankView.remove();

    // console.time('TableRow dom append')
    try {
      self.$('.table-content')[0].replaceChildren();
      self.$('.table-content').html($subViewEls);
    } catch (error) {
      var div = self.$('.table-content')[0];
      var childNodes = div.childNodes;
      for (var i = childNodes.length - 1; i >= 0; i--) {
        if (childNodes[i].nodeType === Node.ELEMENT_NODE) {
          // 只处理元素节点
          div.removeChild(childNodes[i]);
        }
      }
      self.$('.table-content').html($subViewEls);
      console.log(error);
    }

    // console.timeEnd('TableRow dom append')

    if (!this.subViews.length) {
      self.$('.table-content').empty().append("\n          <div class=\"f-tc mgt-20\">".concat(BabelStr.str(2055), "</div>\n        "));
    }
    this._dispatchSelectionChange();
  },
  startFilterMode: function startFilterMode() {
    this.filterMode = true;
    this.originSubViews = this.subViews;
    // this.subViews = []
    var dataCollection = this.superView.getDataCollection();
    this.dataCollection = dataCollection;
  },
  beforeClearFilterMode: function beforeClearFilterMode() {
    // this.dataCollection = this.originDataCollection
    this.dataCollection.each(function (file) {
      file.setShow(true);
    });
    _.each(this.subViews, function (view) {
      view.show();
    });
    this.renderFilterResult();
  },
  clearFilterMode: function clearFilterMode() {
    this.filterMode = false;
  },
  refresh: function refresh(callback) {
    var self = this;
    if (!this.dataCollection) {
      callback();
      return;
    }
    ;
    this._renderRows();
    callback();
  },
  _renderBlankState: function _renderBlankState() {
    var tmpl = "";
    if (_.isFunction(this.blankRenderer)) {
      tmpl = this.blankRenderer();
    } else {
      tmpl = this.blankRenderer;
    }
    this.renderBlank(tmpl);
  },
  renderBlank: function renderBlank(blankRender) {
    if (this.virtualGridScroll) {
      if (this._gridResizeObserver) {
        this._gridResizeObserver.disconnect();
        this._gridResizeObserver = null;
      }
      if (this._gridMeasureRAF) {
        (window.cancelAnimationFrame || window.clearTimeout)(this._gridMeasureRAF);
        this._gridMeasureRAF = null;
      }
      this._gridMeasuredHeights = {};
      this._gridMetrics = null;
      this._gridVisibleRange = null;
      var gce = this._getGridContentEl ? this._getGridContentEl() : this.$('.table-content')[0];
      if (gce) {
        gce.style.height = "";
        gce.style.position = "";
        gce.innerHTML = "";
      }
    }
    if (this.virtualScroll) {
      // 空态前移除虚拟占位和 model.view，避免空态仍保留滚动高度。
      this._disconnectVirtualResizeObserver();
      this._cancelVirtualMeasure();
      this._virtualRenderedKeys = [];
      this._virtualLayoutCache = null;
      _.each(this.subViews, function (subView) {
        if (subView.model && subView.model.view === subView) {
          subView.model.view = null;
        }
      });
      this.$('.table-content').css({
        paddingTop: 0,
        paddingBottom: 0
      }).empty();
    }
    this.removeSubViews();
    this.$blankView = $(blankRender);
    this.$el.append(this.$blankView);
  },
  /**
   * 点击动作发生后是否允许tableRow选中
   * @param  {HTMLElement} target - 事件的触发对象
   * @param  {selector|HTMLElement|Array} filters - 应该组织选中的标记
   *
   * @return {booolean}
   */
  _shouldPreventSelection: function _shouldPreventSelection(target, filters) {
    var self = this;
    if (_.isString(filters)) {
      var is = $(target).is(filters);
      if (!is) {
        is = _.some($(filters).toArray(), function (parent) {
          return $.contains(parent, target);
        });
      }
      return is;
    } else if (_.isElement(filters)) {
      return filters == target;
    } else if (_.isArray(filters)) {
      var prevent = false;
      _.each(filters, function (trigger) {
        prevent |= self._shouldPreventSelection(target, trigger);
      });
      return prevent;
    }
    return false;
  },
  _handleVirtualRowSelection: function _handleVirtualRowSelection($e, curRowView, clickFromChb) {
    // 复刻原点击选择语义，但选择范围基于 model 而非当前 subViews。
    var currentIndex = curRowView.index;
    var currentModel = curRowView.rowModel;
    var selectedModels = this.getSelectedModels();
    var bounds = this._getVirtualDataBounds();
    var self = this;
    if (this.singleSelect) {
      this.dataCollection.each(function (model, index) {
        if (index >= bounds.start && index < bounds.end) {
          model._rowSelected = false;
        }
      });
      currentModel._rowSelected = true;
      curRowView.checkToRemoveUnreadMark && curRowView.checkToRemoveUnreadMark();
    } else if (($e.metaKey || $e.ctrlKey) && this.enableMetaKeyMultiSelect) {
      currentModel._rowSelected = !currentModel._rowSelected;
      this.setCurIndex(currentIndex);
    } else if ($e.shiftKey && this.enableShiftMultiSelect) {
      var from = this._curIndex > -1 ? Math.min(currentIndex, this._curIndex) : currentIndex;
      var to = this._curIndex > -1 ? Math.max(currentIndex, this._curIndex) : currentIndex;
      this.dataCollection.each(function (model, index) {
        if (index >= bounds.start && index < bounds.end) {
          model._rowSelected = self._isVirtualModelSelectable(model, index, bounds) && index >= from && index <= to;
        }
      });
    } else if (clickFromChb) {
      currentModel._rowSelected = !currentModel._rowSelected;
      this.setCurIndex(currentIndex);
    } else {
      curRowView.checkToRemoveUnreadMark && curRowView.checkToRemoveUnreadMark();
      this.dataCollection.each(function (model, index) {
        if (index >= bounds.start && index < bounds.end) {
          model._rowSelected = false;
        }
      });
      currentModel._rowSelected = !(selectedModels.length == 1 && selectedModels[0] === currentModel);
      this.setCurIndex(currentIndex);
    }
    this._syncVirtualSelectionViews();
    this._dispatchSelectionChange();
  },
  _rowClickHandler: function _rowClickHandler($e) {
    // return when mouse dragging or right click
    if (this.dragMoving || $e.button == 2 || this.subViews.length == 0) {
      return;
    }
    if (this.superView.getOnlySelectByCheckbox()) {
      if (!$e.target.classList.contains('chb')) {
        return;
      }
    }
    // onlySelectByCheckbox
    var target = $e.target;
    var rowViewEl = $($e.currentTarget);
    var rowIndex = $(rowViewEl).index();
    var curRowView = this.getSubViewAt(rowIndex);
    var filteredSelectionTrigger = curRowView.getFilteredSelectionTrigger();
    var preSelRows;
    var curRowViewContained = false;
    var chbColumnDOM = curRowView.getChbColumn();
    var clickFromChb = $e.target == chbColumnDOM || $.contains(chbColumnDOM, $e.target);
    var from, to;
    var rowView;
    var clickInSelectedView = false;
    if (this._shouldPreventSelection(target, filteredSelectionTrigger)) {
      return;
    }
    if (this.virtualGridScroll) {
      // Grid 虚拟滚动：选择基于 model 索引（curRowView.index），而非 DOM 下标。
      var gcurIndex = curRowView.index;
      var gcurModel = curRowView.rowModel;
      if (gcurIndex == null || !gcurModel) return;
      if (this.singleSelect) {
        this.dataCollection.each(function (model) {
          model._rowSelected = false;
        });
        gcurModel._rowSelected = true;
        curRowView.checkToRemoveUnreadMark && curRowView.checkToRemoveUnreadMark();
      } else if (($e.metaKey || $e.ctrlKey) && this.enableMetaKeyMultiSelect) {
        gcurModel._rowSelected = !gcurModel._rowSelected;
        this.setCurIndex(gcurIndex);
      } else if ($e.shiftKey && this.enableShiftMultiSelect) {
        var gfrom = this._curIndex > -1 ? Math.min(gcurIndex, this._curIndex) : gcurIndex;
        var gto = this._curIndex > -1 ? Math.max(gcurIndex, this._curIndex) : gcurIndex;
        this.dataCollection.each(function (model, index) {
          model._rowSelected = index >= gfrom && index <= gto;
        });
      } else if (clickFromChb) {
        gcurModel._rowSelected = !gcurModel._rowSelected;
        this.setCurIndex(gcurIndex);
      } else {
        curRowView.checkToRemoveUnreadMark && curRowView.checkToRemoveUnreadMark();
        var gselModels = this.getSelectedModels();
        this.dataCollection.each(function (model) {
          model._rowSelected = false;
        });
        gcurModel._rowSelected = !(gselModels.length === 1 && gselModels[0] === gcurModel);
        this.setCurIndex(gcurIndex);
      }
      this._syncVirtualSelectionViews();
      this._dispatchSelectionChange();
      return;
    }
    if (this.virtualScroll) {
      // 当前行可能只是虚拟窗口中的一项，交由 model 选择逻辑处理。
      this._handleVirtualRowSelection($e, curRowView, clickFromChb);
      return;
    }
    if (this.singleSelect) {
      preSelRows = this.getSelectedSubViews();
      _.each(preSelRows, function (rowView, index) {
        if (rowView != curRowView) {
          rowView.setSelected(false, true);
        }
      });
      curRowView.setSelected(true, true);
      curRowView.checkToRemoveUnreadMark && curRowView.checkToRemoveUnreadMark();
    } else {
      // mac下是command键,windows下是ctrl键，点击连选
      if (($e.metaKey || $e.ctrlKey) && this.enableMetaKeyMultiSelect) {
        curRowView.toggleSelected(true);
        this.setCurIndex(rowIndex);

        // shift区域多选
      } else if ($e.shiftKey && this.enableShiftMultiSelect) {
        if (this._curIndex > 0) {
          this.getSubViewAt(this._curIndex).setSelected(false, true);
        }
        from = this._curIndex > -1 ? Math.min(rowIndex, this._curIndex) : rowIndex;
        to = Math.max(rowIndex, this._curIndex);
        // table 初始化时按住shift点选,会选中第一个
        if (this._curIndex == -1) {
          this.$el.addClass('disable-text-select');
        }
        this.selectRowRange(from, to, true);
        // 普通的选择
      } else {
        curRowView.checkToRemoveUnreadMark && curRowView.checkToRemoveUnreadMark();
        this.$el.removeClass('disable-text-select');
        // checkbox的选中由row 自己控制
        if (clickFromChb) {
          curRowView.toggleSelected(true);
        } else {
          preSelRows = this.getSelectedSubViews();
          //当行的正选反选
          if (preSelRows[0] == curRowView && preSelRows.length == 1) {
            curRowView.toggleSelected(true);
            // 多行选中，去除当前行之外的选中，并选中当前行
          } else {
            _.each(preSelRows, function (rowView, index) {
              if (rowView != curRowView) {
                rowView.setSelected(false, true);
              }
            });
            curRowView.setSelected(true, true);
          }
        }
        this.setCurIndex(rowIndex);
      }
    }
    this._dispatchSelectionChange();
  },
  _dispatchSelectionChange: function _dispatchSelectionChange(opt_silent) {
    if (_.isFunction(this.onRowSelectionChanged) && !opt_silent) {
      this.onRowSelectionChanged.call(this.superView);
    }
    var allSelected = this.allSelected();
    this.superView && this.superView.getHeaderView().setSelection(allSelected);
    this.eachSubViews(function (rowView, index) {
      rowView.setShiftBeginStyle(false);
    });
  },
  _controlAllRowSelection: function _controlAllRowSelection(selected) {
    // this.selectAll = selected;
    var self = this;
    if (this.virtualScroll) {
      // 表头全选作用于当前分页可见模型，而不是当前挂载窗口。
      var shouldUpdateAllModels = !_.isUndefined(selected);
      if (_.isUndefined(selected)) {
        var headerView = this.superView && this.superView.getHeaderView();
        if (headerView && headerView.isInSelectState()) {
          selected = true;
          shouldUpdateAllModels = true;
        }
      }
      if (shouldUpdateAllModels && this.dataCollection) {
        var bounds = this._getVirtualDataBounds();
        this.dataCollection.each(function (model, index) {
          if (index >= bounds.start && index < bounds.end) {
            model._rowSelected = selected ? self._isVirtualModelSelectable(model, index, bounds) : false;
          }
        });
      }
      this._syncVirtualSelectionViews();
      this._dispatchSelectionChange();
      return;
    }

    // Grid 虚拟滚动：全选作用于 dataCollection 中所有已加载 model，不受分页边界限制。
    if (this.virtualGridScroll) {
      if (_.isUndefined(selected)) {
        var gheaderView = this.superView && this.superView.getHeaderView();
        selected = !!(gheaderView && gheaderView.isInSelectState());
      }
      if (this.dataCollection) {
        this.dataCollection.each(function (model) {
          model._rowSelected = !!selected;
        });
      }
      // 同步当前可见视图的选中状态。
      this._syncVirtualSelectionViews();
      this._dispatchSelectionChange();
      return;
    }

    // deleted by jiang, 2017-3-22 , 原因: 一个一个设置 css，在文件多时速度极慢
    // this.eachSubViews(function(rowView, index) {
    //   rowView.setSelected(selected, true);
    // });

    // { 统一一次设置 css 属性
    //

    if (_.isUndefined(selected)) {
      var _headerView = this.superView && this.superView.getHeaderView();
      var selectAll = _headerView && _headerView.isInSelectState();
      if (selectAll) {
        this.eachSubViews(function (rowView, index) {
          rowView._selected = selected;
          rowView.rowModel._rowSelected = selected;
        });
        this.$('.table-content').children().addClass('selected');
      }
    } else {
      if (this.selected) {
        this.$(".t-row:not(.f-hide) .chb>input[type=radio]").prop('checked', selected);
      } else {
        this.$(".t-row:not(.f-hide) .chb>input[type=checkbox]").prop('checked', selected);
      }
      this.eachSubViews(function (rowView, index) {
        if (!rowView.$el.hasClass("f-hide")) {
          rowView._selected = selected;
          rowView.rowModel._rowSelected = selected;
        }
      });
      if (selected) {
        this.$('.table-content').children().addClass('selected');
      } else {
        this.$('.table-content').children().removeClass('selected');
      }
    }

    // }end

    this._dispatchSelectionChange();
  },
  _tableBodyClickHandler: function _tableBodyClickHandler($e) {
    if (!this.unSelectRowWhenClickOutside || !this.hasSelectedRow() || this.dragMoving) {
      return;
    }
    var subView = this.findSubView(function (subView, index) {
      return subView.$el.eventIsInner($e);
    });
    if (!subView) {
      this._controlAllRowSelection(false);
      this._dispatchSelectionChange();
    }
  },
  viewWillUnRendered: function viewWillUnRendered() {
    if (this.virtualScroll) {
      // 子 view 销毁前先断开 model.view，防止留下失效 DOM 引用。
      _.each(this.subViews, function (subView) {
        if (subView.model && subView.model.view === subView) {
          subView.model.view = null;
        }
      });
    }
    _MMViewBase["default"].prototype.viewWillUnRendered.call(this);
  },
  viewDidUnRendered: function viewDidUnRendered() {
    _MMViewBase["default"].prototype.viewDidUnRendered.call(this);
    // 对称释放 observer、动画帧、保留行和滚动监听。
    this._disconnectVirtualResizeObserver();
    this._cancelVirtualMeasure();
    this._releaseVirtualRetainedRows();
    this._virtualRowStates = {};
    this._virtualRetainedRowViews = {};
    if (this._virtualScrollFrame) {
      var cancelFrame = window.cancelAnimationFrame || window.clearTimeout;
      cancelFrame(this._virtualScrollFrame);
      this._virtualScrollFrame = null;
    }
    this.$el.off("scroll", this._onVirtualScroll);
    $(document).off(this.$nsEventName("keydown"), this._onKeydownHandler);
  },
  selectRowRange: function selectRowRange(from, to, opt_silent) {
    if (this.virtualGridScroll) {
      var gstart = Math.min(from, to);
      gstart = Math.max(gstart, 0);
      var gend = Math.max(from, to);
      var glen = this.dataCollection ? this.dataCollection.length : 0;
      gend = Math.min(gend, glen - 1);
      if (this.dataCollection) {
        this.dataCollection.each(function (model, index) {
          model._rowSelected = index >= gstart && index <= gend;
        });
      }
      this._syncVirtualSelectionViews();
      if (!opt_silent) {
        this._dispatchSelectionChange();
      }
      return this;
    }
    if (this.virtualScroll) {
      // 区间选择可跨越未挂载行，但不会越过当前分页边界或隐藏行。
      var bounds = this._getVirtualDataBounds();
      var startIndex = Math.max(Math.min(from, to), bounds.start);
      var endIndex = Math.min(Math.max(from, to), bounds.end - 1);
      var self = this;
      this.dataCollection && this.dataCollection.each(function (model, index) {
        if (index >= bounds.start && index < bounds.end) {
          model._rowSelected = self._isVirtualModelSelectable(model, index, bounds) && index >= startIndex && index <= endIndex;
        }
      });
      this._syncVirtualSelectionViews();
      if (!opt_silent) {
        this._dispatchSelectionChange();
      }
      return this;
    }
    var start = Math.min(from, to);
    start = Math.max(start, 0);
    var end = Math.max(from, to);
    end = Math.min(end, this.getSubViewCount() - 1);
    this.eachSubViews(function (subView, index) {
      if (start <= index && end >= index) {
        subView.setSelected(true, opt_silent);
      } else {
        subView.setSelected(false, opt_silent);
      }
    });
    return this;
  },
  /**
   * 根据内容坐标点获取row view
   * @param  {{
   *    x: number ，
   *    y: number
   * }} point [description]
   * @return {[type]}       [description]
   */
  getTableRowUnderContentPoint: function getTableRowUnderContentPoint(point) {
    return this.findSubView(function (subView) {
      var $el = subView.$el;
      var offsetTop = $el.prop('offsetTop');
      var offsetLeft = $el.prop('offsetLeft');
      var height = parseInt($el.css('height'));
      var width = parseInt($el.css('width'));
      var verticalContain = offsetTop <= point.y && offsetTop + height >= point.y;
      var horizonalContain = offsetLeft <= point.x && offsetLeft + width >= point.x;
      if (verticalContain && horizonalContain) {
        return true;
      }
    });
  },
  setFileOnTop: function setFileOnTop(fileInfo) {
    var i = this.dataCollection.indexOf(fileInfo);
    if (i != -1 && i < this.dataCollection.length) {
      this.removeRowAt(i);
      // // this.dataCollection.each(function(file){
      // //   file.setStickonTop(false);
      // // })
      // fileInfo.setStickonTop(true);
      if (fileInfo.getStickonTop()) {
        this.prependRow(fileInfo);
      } else {
        var topIndex = -1;
        this.dataCollection.each(function (file, index) {
          if (file.getStickonTop()) {
            topIndex = index;
          }
          ;
        });
        this.addRowAt(fileInfo, topIndex + 1);
        this.superView.sortByDefault(false);
      }
    }
  },
  removeSubViews: function removeSubViews() {
    _MMViewBase["default"].prototype.removeSubViews.call(this);
    this.$blankView && this.$blankView.remove();
  },
  setRowClass: function setRowClass(rowClass, columns, slient) {
    this.rowClass = rowClass;
    this.columns = columns;
    if (slient) {
      return;
    }
    if (!this.dataCollection || this.dataCollection.length == 0) {
      this._renderBlankState();
    } else {
      this._renderRows();
    }
  },
  renderNextPage: function renderNextPage(loadEnded) {
    if (this.virtualScroll) {
      // 只扩大可访问边界；新进入范围的行仍按视口按需创建。
      var currentEnd = Number(this.dataCollection.end) || 0;
      var pageSize = this.superView && this.superView.pageSize || 50;
      this.dataCollection.end = loadEnded ? this.dataCollection.length : Math.min(Math.max(currentEnd + pageSize, pageSize), this.dataCollection.length);
      this._invalidateVirtualLayout();
      // 立即同步更新虚拟 padding，使 scrollHeight 立刻反映扩展后的数据范围，
      // 防止在 RAF 重绘前的 1 帧内 scrollBottom 仍基于旧高度而导致滚动加载失效。
      if (this.subViews.length) {
        this._updateVirtualPadding();
      }
      this._scheduleVirtualRender();
      this.refreshPageBar();
      this._controlAllRowSelection();
      this.onNextPageRendered();
      return;
    }
    var self = this;
    var rowClass = this.rowClass;
    var buffer = document.createDocumentFragment();

    // console.time('TableRow obj create')
    var start = this.getSubViewCount();
    try {
      var end = start + this.superView.pageSize;
    } catch (e) {
      // statements
      console.log(e);
      end = start + 50;
    }
    if (loadEnded) {
      end = this.dataCollection.end;
    }
    // var end = start + this.superView.pageSize;
    if (this.dataCollection.length) {
      this.$blankView && this.$blankView.remove();
    }
    this.dataCollection.each(function (model, index) {
      if (index < start || index >= end) {
        return;
      }
      var rowOptionsPassed = _.isFunction(self.rowOption) ? self.rowOption() : self.rowOption;
      var rowOption = _.extend({
        singleSelect: self.singleSelect,
        rowCls: self.rowCls,
        index: index,
        rowModel: model,
        columns: self.columns,
        allowSelect: self.allowSelect,
        dataCollection: self.dataCollection,
        isSearch: self.isSearch,
        isUsedAdvancedSearch: self.isUsedAdvancedSearch
      }, rowOptionsPassed);
      var rowView = new rowClass(rowOption);
      self.addSubView(rowView, function () {
        _RenderProxy["default"].buildViewDom(rowView);
        buffer.appendChild(rowView.el);
        model.view = rowView;
        rowView.model = model;
      });
    });
    // console.timeEnd('TableRow obj create')
    // console.time('TableRow viewWillRendered')
    this.eachSubViews(function (view) {
      _RenderProxy["default"].viewWillRendered(view);
    });
    // console.timeEnd('TableRow viewWillRendered')
    // console.time('TableRow dom append')
    self.$('.table-content').append(buffer);
    // console.timeEnd('TableRow dom append')
    // console.time('TableRow viewDidRendered')
    this.eachSubViews(function (view) {
      _RenderProxy["default"].viewDidRendered(view);
    });
    this._controlAllRowSelection();
    this.onNextPageRendered();
  },
  _inforPanelShowed: function _inforPanelShowed(payload) {
    if (!payload.fileInfor) {
      return;
    }
    // console.log('inforPanelShowed', payload);
    // console.log('fileInfo:', payload.fileInfor.cid);
    var selfInfors = this.getSelectedModels();
    var found = false;
    for (var i = 0; i < selfInfors.length; i++) {
      if (selfInfors[i].cid == payload.fileInfor.cid) {
        found = true;
        break;
      }
    }
    if (this.virtualGridScroll) {
      if (!found) {
        this.dataCollection.each(function (model) {
          model._rowSelected = false;
        });
        payload.fileInfor._rowSelected = true;
        this._syncVirtualSelectionViews();
        this._dispatchSelectionChange();
      }
      return;
    }
    if (this.virtualScroll) {
      if (!found) {
        // 信息面板对应行离屏时，直接更新 model 并同步当前窗口。
        var bounds = this._getVirtualDataBounds();
        this.dataCollection.each(function (model, index) {
          if (index >= bounds.start && index < bounds.end) {
            model._rowSelected = false;
          }
        });
        payload.fileInfor._rowSelected = true;
        this._syncVirtualSelectionViews();
        this._dispatchSelectionChange();
      }
      return;
    }
    if (!payload.fileInfor.view) {
      return;
    }
    if (!found) {
      for (var i = 0; i < selfInfors.length; i++) {
        selfInfors[i].view.setSelected(false, true);
      }
      payload.fileInfor.view.setSelected(true, true);
    }
    // console.log('selfInfors', selfInfors);
  }
}, {
  setDefaults: function setDefaults(defaults) {
    _.extend(DEFAULTS, defaults);
  }
});
_MDTableBodyViewGridMixin["default"].applyTo(MDTableBodyView.prototype);
var _default = exports["default"] = MDTableBodyView;

},{"104":104,"1184":1184,"1412":1412,"1413":1413,"1415":1415,"1418":1418,"1421":1421,"1426":1426,"1429":1429,"1430":1430,"1436":1436,"1446":1446,"1454":1454,"1463":1463,"1466":1466,"1471":1471,"1477":1477,"1537":1537,"1541":1541,"1546":1546,"22":22,"25":25,"86":86,"88":88}],88:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1424);
require(1426);
require(1437);
require(1463);
require(1478);
var _MMViewBase = _interopRequireDefault(require(22));
/**
 *  MDTableRowView
 *  Created by manjun.han
 *  date here(2015.6.24)
 */

var MDTableRowView = _MMViewBase["default"].extend({
  el: '<div class="t-row"></div>',
  tmpl: '<div class="row-cells"></div>',
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click input[type=checkbox]': this._preventDefaultChecked
    });
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      _selected: false,
      rowModel: null,
      /**
       * @type {Function(rowView)}
       */
      onSelectionChange: _.noop,
      rowCls: '',
      index: -1,
      allowSelect: true,
      /**
       * 列渲染器
       * @type {Array.<TableColumObject>}
       */
      columns: [],
      /**
       * @callback renderFnCallback
       * @return {stirng} column html string
       */
      /**
       * @typedef {object} ColumnRender
       * @property {string}  dataIndex - model field name
       * @property {string}  cellCls - cell class
       * @property {string|renderFnCallback} render - property return the column html string
       *
       */
      /**
       * 定义行的渲染器,如果是函数类型，函数需要返回一个数组
       * @type {Array.<ColumnRender>}
       */
      columnRenders: null
    });
  },
  /**
   * var opt = {
   *  rowModel:null,
   *  singleSelect:false
   *  rowCls:'',
   *  index:-1,
   *  allowSelect:true,
   *  onSelectionChange:function(rowView){
   *
   *  },
   *  columns:[
   *    name:'',
   *    dataIndex:'',
   *    sortable:false,
   *    cellCls:'',
   *    width:100，
   *    flex:true
   *  ]
   * }
   *
   * Can be overrided bu sub view , but the subview class must call super.initialize()
   */
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this._renderColumn();
  },
  /**
   * @protected
   */
  _renderColumn: function _renderColumn() {
    var self = this;
    // this.$el.empty();
    var $tr = this.$('.row-cells');
    var model = this.rowModel;
    var rowIndex = this.index;
    $tr.addClass(this.rowCls);
    var sb = [];
    if (this.allowSelect) {
      sb.push("<div class='chb-col'>");
      sb.push('<div class="chb">');
      if (!self.singleSelect) {
        sb.push('<input type="checkbox" id="' + this.cid + '"/><label></label>');
      } else {
        sb.push('<input type="radio"/>');
      }
      sb.push("</div>");
      sb.push("</div>");
      $tr.append(sb.join(""));
    }
    var columnRenders = _.isFunction(this.columnRenders) ? this.columnRenders() : this.columnRenders;
    columnRenders = columnRenders || _.map(this.columns, function (column) {
      return {
        dataIndex: column.dataIndex
      };
    });
    var buff = document.createDocumentFragment();
    _.each(this.columns, function (column, index) {
      var columnRender = _.findWhere(columnRenders, {
        dataIndex: column.dataIndex
      });
      columnRender && _.extend(columnRender, {
        flex: column.flex,
        minWidth: column.minWidth,
        hidden: column.hidden || false
      });
      if (columnRender) {
        columnRender.width = _.isUndefined(column.width) ? columnRender.width : column.width;
        if (columnRender.hidden) {
          return;
        }
        var $td = $("<div>");
        $td.addClass(columnRender.cellCls);
        if (_.isFunction(columnRender.render)) {
          $td.append(columnRender.render.apply(self, [model.get(columnRender.dataIndex), model, rowIndex]));
        } else {
          $td.append(model.get(columnRender.dataIndex));
        }
        if (!_.isUndefined(columnRender.width)) {
          $td.css({
            'width': columnRender.width,
            'flex': 'none'
          });
        } else {
          var flex = columnRender.flex;
          if (flex) {
            flex = flex.toString();
            $td.css({
              '-webkit-box-flex': flex,
              '-moz-box-flex': flex,
              '-webkit-flex-grow': flex,
              '-moz-flex-grow': flex,
              '-ms-flex-positive': flex,
              'flex-grow': flex,
              '-webkit-flex-basis': 0,
              '-moz-flex-basis': 0,
              '-ms-flex-preferred-size': 0,
              'flex-basis': 0
            });
          }
        }
        if (!_.isUndefined(columnRender.minWidth)) {
          $td.css({
            'min-width': columnRender.minWidth
          });
        }
        buff.appendChild($td[0]);
      }
    });
    $tr.append(buff);
    this.setSelected(this.rowModel._rowSelected, true);
  },
  getChbColumn: function getChbColumn() {
    return this.$('.row-cells').children()[0];
  },
  toggleSelected: function toggleSelected(opt_silent) {
    var selected = !this.isSelected();
    this.setSelected(selected, opt_silent);
  },
  _preventDefaultChecked: function _preventDefaultChecked($e) {
    $e.preventDefault();
  },
  isSelected: function isSelected() {
    return this._selected;
  },
  setSelected: function setSelected(selected, opt_silent) {
    if (!this.allowSelect) {
      return;
    }
    if (this.singleSelect) {
      this.$(".chb>input[type=radio]").prop('checked', selected);
    } else {
      this.$(".chb>input[type=checkbox]").prop('checked', selected);
    }
    this._selected = selected;
    if (selected) {
      this.$el.addClass('selected');
    } else {
      this.$el.removeClass('selected');
    }
    if (!opt_silent) {
      this.superView._dispatchSelectionChange(opt_silent);
    }
    this.rowModel._rowSelected = selected;
    this.onSelectedChanged && this.onSelectedChanged();
  },
  getTableView: function getTableView() {
    if (this.superView && this.superView.superView) {
      return this.superView.superView;
    }
    ;
    return null;
  },
  getRowModel: function getRowModel() {
    return this.rowModel;
  },
  setShiftBeginStyle: function setShiftBeginStyle(added) {
    if (added) {
      this.$el.addClass("begin-shift");
    } else {
      this.$el.removeClass("begin-shift");
    }
  },
  refresh: function refresh() {
    this._renderColumn();
  },
  /**
   * @return {selector|Array<selector>|HTMLElement} [description]
   */
  getFilteredSelectionTrigger: function getFilteredSelectionTrigger() {
    return [];
  },
  getRowCellsEl: function getRowCellsEl() {
    return this.$('.row-ceils')[0];
  }
});
var _default = exports["default"] = MDTableRowView;

},{"1184":1184,"1424":1424,"1426":1426,"1437":1437,"1454":1454,"1463":1463,"1478":1478,"22":22}],86:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1465);
require(1414);
require(1446);
var _RenderProxy = _interopRequireDefault(require(25));
/**
 * Grid 虚拟滚动 Mixin —— 为 MDTableBodyView 提供瀑布流虚拟渲染能力。
 * 通过 applyTo(proto) 注入，避免 MDTableBodyView 自身过于庞大。
 *
 * 注入后会：
 *   1. 扩展 initProps 中的 grid 配置项
 *   2. 拦截 _renderRows / renderNextPage 增加 virtualGridScroll 分流
 *   3. 在 viewDidUnRendered 中自动清理 grid 资源
 */

var GridMixin = {
  // ---- 配置项 ----

  _gridInitProps: {
    // 开启后按瀑布流布局只渲染可见范围内的行；grid 模式专用。
    virtualGridScroll: false,
    // 网格列数计算函数，需由调用方提供；返回当前应显示的列数。
    virtualGridColumnCount: null,
    // 网格列间距，单位 px。
    virtualGridGutter: 12,
    // 网格行高预估值，单位 px；实际渲染后会由元素自身高度决定。
    virtualGridRowHeightEstimate: 200
  },
  // ---- Public API ----

  /**
   * 运行期开关 Grid 虚拟滚动；仅当 virtualGridScroll 配置项为 true 时由外部调用。
   */
  setVirtualGridScrollEnabled: function setVirtualGridScrollEnabled(enabled) {
    enabled = !!enabled;
    // 即使状态相同，如果从未完成 setup（如 initProps 中直接设为 true），也要补做一次。
    if (this.virtualGridScroll === enabled) {
      if (enabled && !this._onGridScrollHandler) {
        // 需要补做 setup。
      } else {
        return;
      }
    }
    if (enabled) {
      // 先清理 list 虚拟滚动的 scroll 事件以避免重叠。
      this.$el.off("scroll", this._onVirtualScroll);
      if (this._virtualScrollFrame) {
        (window.cancelAnimationFrame || window.clearTimeout)(this._virtualScrollFrame);
        this._virtualScrollFrame = null;
      }
      // 清理 list 虚拟滚动留下的样式，确保宽度计算准确。
      this.$('.table-content').css({
        paddingTop: 0,
        paddingBottom: 0,
        paddingRight: ''
      });
      // 保存原始 virtualScroll 状态，退出 grid 时恢复。
      if (this._savedVirtualScroll === undefined) {
        this._savedVirtualScroll = this.virtualScroll;
      }
      this.virtualScroll = false;
      this.virtualGridScroll = true;
      this._setupGridVirtualScroll();
    } else {
      // 恢复 list 模式的 virtualScroll 状态，确保后续 _renderRows 走虚拟路径。
      if (this._savedVirtualScroll !== undefined) {
        this.virtualScroll = this._savedVirtualScroll;
        this._savedVirtualScroll = undefined;
      }
      this.virtualGridScroll = false;
      this._teardownGridVirtualScroll();
    }
  },
  // ---- 内部实现 ----

  /** 获取 grid 模式的内容容器（.table-content），与滚动容器 this.el 分离。 */
  _getGridContentEl: function _getGridContentEl() {
    return this.$(".table-content")[0] || this.el;
  },
  _setupGridVirtualScroll: function _setupGridVirtualScroll() {
    var self = this;
    var contentEl = this._getGridContentEl();
    this._gridMetrics = [];
    this._gridColHeights = null;
    this._gridTotalHeight = 0;
    this._gridVisibleRange = {
      start: 0,
      end: 0
    };
    this._gridScrollRAF = null;
    this._gridMeasuredHeights = {}; // index → 实测高度
    this._gridMeasureRAF = null;
    this._gridViewPool = {}; // model.cid → view，保留已加载缩略图 DOM

    contentEl.style.position = "relative";
    contentEl.style.paddingRight = "15px";

    // 先清理 list 模式的旧视图和 DOM，确保宽度计算时没有残留内容导致滚动条干扰。
    _.each([].concat(this.subViews || []), function (view) {
      if (view.model && view.model.view === view) {
        view.model.view = null;
      }
      try {
        view.remove();
      } catch (e) {}
      view.superView = null;
    });
    this.subViews = [];
    var $loadedSign = $(contentEl).children('.loaded-sign').detach();
    contentEl.innerHTML = "";
    if ($loadedSign.length) {
      $(contentEl).append($loadedSign);
    }
    this._buildGridLayout();
    this._renderVirtualGridRows();

    // ResizeObserver：监听每张可见卡片的高度变化（如图片加载完成），自动重排。
    // 不监听 contentEl，因为其 height 是我们手动设的固定值，内容变化不会反映到它。
    if (typeof ResizeObserver !== 'undefined') {
      this._gridResizeObserver = new ResizeObserver(_.debounce(function () {
        self._onGridContentResize();
      }, 200));
    }
    this._onGridScrollHandler = _.throttle(function () {
      self._onGridScroll();
    }, 16);
    this.$el.on("scroll", this._onGridScrollHandler);
  },
  _teardownGridVirtualScroll: function _teardownGridVirtualScroll() {
    if (this._gridResizeObserver) {
      this._gridResizeObserver.disconnect();
      this._gridResizeObserver = null;
    }
    if (this._onGridScrollHandler) {
      this.$el.off("scroll", this._onGridScrollHandler);
      this._onGridScrollHandler = null;
    }
    if (this._gridScrollRAF) {
      (window.cancelAnimationFrame || window.clearTimeout)(this._gridScrollRAF);
      this._gridScrollRAF = null;
    }
    if (this._gridMeasureRAF) {
      (window.cancelAnimationFrame || window.clearTimeout)(this._gridMeasureRAF);
      this._gridMeasureRAF = null;
    }
    if (this._gridMeasureTimeout) {
      clearTimeout(this._gridMeasureTimeout);
      this._gridMeasureTimeout = null;
    }
    this._gridMetrics = null;
    this._gridColHeights = null;
    this._gridVisibleRange = null;
    this._gridMeasuredHeights = null;
    this._gridHeightAdjusting = false;
    // 清理视图缓存池。
    if (this._gridViewPool) {
      _.each(this._gridViewPool, function (view) {
        try {
          view.remove();
        } catch (e) {}
        view.superView = null;
      });
      this._gridViewPool = null;
    }
    var contentEl = this._getGridContentEl();
    if (contentEl) {
      contentEl.style.position = "";
      contentEl.style.height = "";
      contentEl.style.paddingRight = "";
    }
    // 退出 grid 虚拟模式：保留 loaded-sign 并恢复默认样式定位。
    var $loadedSign = this.$('.table-content').children('.loaded-sign').detach();
    $loadedSign.css({
      top: '',
      bottom: ''
    });
    // 释放 grid 模式创建的所有 subView，避免切换到 list 模式时旧视图残留。
    _.each([].concat(this.subViews || []), function (view) {
      if (view.model && view.model.view === view) {
        view.model.view = null;
      }
      try {
        view.remove();
      } catch (e) {}
      view.superView = null;
    });
    this.subViews = [];
    this.$('.table-content').empty();
    if ($loadedSign.length) {
      this.$('.table-content').append($loadedSign);
    }
  },
  /** 瀑布流布局——逐卡片使用已测高度（_gridMeasuredHeights）或预估值。 */
  _buildGridLayout: function _buildGridLayout() {
    var models = this.dataCollection && this.dataCollection.models;
    if (!models || !models.length) {
      this._gridMetrics = [];
      this._gridTotalHeight = 0;
      return;
    }
    var colCountFn = this.virtualGridColumnCount;
    var colCount = _.isFunction(colCountFn) ? colCountFn() : colCountFn || 3;
    var gutter = this.virtualGridGutter || 12;
    var contentEl = this._getGridContentEl();
    var paddingRight = parseFloat(contentEl.style.paddingRight) || 0;
    var containerWidth = contentEl.offsetWidth - paddingRight;
    var itemWidth = (containerWidth - gutter * (colCount - 1)) / colCount;
    var estimate = this.virtualGridRowHeightEstimate || 200;
    var measured = this._gridMeasuredHeights || {};
    this._gridColHeights = new Array(colCount).fill(10);
    this._gridMetrics = [];
    var filterMode = this.dataCollection && this.dataCollection.filterMode;
    for (var i = 0; i < models.length; i++) {
      var model = models[i];
      // 筛选模式下，getShow() 为 false 的 model 不占布局空间。
      if (filterMode && _.isFunction(model.getShow) && !model.getShow()) {
        this._gridMetrics[i] = {
          col: 0,
          top: 0,
          left: 0,
          width: 0,
          height: 0
        };
        continue;
      }
      var col = this._findShortestGridCol();
      var top = this._gridColHeights[col];
      var left = col * (itemWidth + gutter);
      // 优先使用该卡片已有实测高度，否则用预估值。
      var height = measured[i] || estimate;
      this._gridMetrics[i] = {
        col: col,
        top: top,
        left: left,
        width: itemWidth,
        height: height
      };
      this._gridColHeights[col] = top + height + gutter;
    }
    this._gridTotalHeight = Math.max.apply(null, this._gridColHeights) + 40;
  },
  _findShortestGridCol: function _findShortestGridCol() {
    var min = Infinity,
      minCol = 0;
    for (var i = 0; i < this._gridColHeights.length; i++) {
      if (this._gridColHeights[i] < min) {
        min = this._gridColHeights[i];
        minCol = i;
      }
    }
    return minCol;
  },
  /** 根据当前滚动位置计算可见 item 范围（含上下各一个视口缓冲）。 */
  _calcGridVisibleRange: function _calcGridVisibleRange() {
    if (!this._gridMetrics || !this._gridMetrics.length) {
      return {
        start: 0,
        end: -1
      };
    }
    var scrollTop = this.el.scrollTop;
    var viewH = this.el.clientHeight;
    var buf = viewH;
    var visTop = Math.max(0, scrollTop - buf);
    var visBot = scrollTop + viewH + buf;
    var start = 0;
    var end = this._gridMetrics.length - 1;
    for (var i = 0; i < this._gridMetrics.length; i++) {
      if (this._gridMetrics[i].top + this._gridMetrics[i].height > visTop) {
        start = i;
        break;
      }
    }
    for (var j = start; j < this._gridMetrics.length; j++) {
      if (this._gridMetrics[j].top > visBot) {
        end = j - 1;
        break;
      }
    }

    // 边界保护：如果计算出的范围无效（如所有内容都在可视范围之外），
    // 基于 scrollTop 定位最近的内容，确保至少返回一个合理范围。
    if (end < start) {
      // 尝试根据 scrollTop 找到最近的可见内容起点。
      var fallbackStart = 0;
      for (var k = 0; k < this._gridMetrics.length; k++) {
        if (this._gridMetrics[k].top + this._gridMetrics[k].height > scrollTop) {
          fallbackStart = k;
          break;
        }
      }
      var fallbackEnd = Math.min(fallbackStart + 20, this._gridMetrics.length - 1);
      return {
        start: Math.max(0, fallbackStart),
        end: Math.max(0, Math.min(fallbackEnd, this._gridMetrics.length - 1))
      };
    }
    return {
      start: Math.max(0, start),
      end: Math.max(0, end)
    };
  },
  /** 滚动回调，仅在可见范围变化时触发重绘。 */
  _onGridScroll: function _onGridScroll() {
    if (!this.virtualGridScroll) return;
    if (this._gridScrollRAF) return;
    var self = this;
    this._gridScrollRAF = requestAnimationFrame(function () {
      self._gridScrollRAF = null;
      var range = self._calcGridVisibleRange();
      var models = self.dataCollection && self.dataCollection.models;
      // 规范化 range：与 _renderVirtualGridRows 中的保护逻辑一致。
      if (range.start > range.end || range.end < 0) {
        range = {
          start: 0,
          end: models ? Math.min(models.length - 1, 20) : 0
        };
      }
      if (models && models.length) {
        range.start = Math.max(0, Math.min(range.start, models.length - 1));
        range.end = Math.max(range.start, Math.min(range.end, models.length - 1));
      }
      if (!self._gridVisibleRange || range.start !== self._gridVisibleRange.start || range.end !== self._gridVisibleRange.end) {
        self._gridVisibleRange = range;
        self._renderVirtualGridRows();
      }
    });
  },
  /** 定位 grid 模式下的"已全部加载"标记，参考 list 虚拟滚动的 _positionVirtualLoadedSign。 */
  _positionGridLoadedSign: function _positionGridLoadedSign() {
    var $content = this.$('.table-content');
    var $loadedSign = $content.children('.loaded-sign');
    if (!$loadedSign.length) {
      return;
    }
    var signHeight = $loadedSign.outerHeight() || 0;
    var contentHeight = $content[0].clientHeight;
    // contentEl 高度 = _gridTotalHeight（含 40px 底部留白）。
    // loaded-sign 的底部应与 contentEl 底部对齐：top = _gridTotalHeight - signHeight。
    // 数据不足一屏时贴住视口底部。
    var totalTop = Math.max((this._gridTotalHeight || 0) - signHeight, 0);
    var viewportBottomTop = Math.max(contentHeight - signHeight, 0);
    $loadedSign.css({
      top: Math.max(totalTop, viewportBottomTop),
      bottom: 'auto'
    });
  },
  /**
   * 数据变更时调度的网格重绘入口。
   * 先同步更新容器高度（保证 loadNumChanged 能读到正确的 scrollHeight），再异步重绘可见行。
   */
  _scheduleGridRender: function _scheduleGridRender() {
    if (!this.virtualGridScroll) return;
    if (this.dataCollection) {
      this.dataCollection.end = this.dataCollection.length;
    }
    this._buildGridLayout();
    // 同步更新内容容器高度，保证 loadNumChanged 读到正确的 scrollHeight。
    // 注意：不触碰滚动容器 this.el 的高度，否则会导致滚动条消失、内容被裁剪。
    var contentEl = this._getGridContentEl();
    if (this._gridTotalHeight) {
      contentEl.style.height = this._gridTotalHeight + "px";
    }
    this._renderVirtualGridRows();
  },
  /** ResizeObserver 回调：卡片高度变化（如图片加载）后自动重排。 */
  _onGridContentResize: function _onGridContentResize() {
    if (!this.virtualGridScroll) return;
    var self = this;
    this._scheduleMeasureHeights(function (changed) {
      if (!changed) return;
      self._relayoutGridViews();
    });
  },
  /** 布局变化后只更新现有视图的位置 + 增量调整视图池，不清空 DOM 重建。 */
  _relayoutGridViews: function _relayoutGridViews() {
    var oldRange = this._gridVisibleRange;
    this._buildGridLayout();
    var contentEl = this._getGridContentEl();
    contentEl.style.height = this._gridTotalHeight + "px";
    var newRange = this._calcGridVisibleRange();
    this._gridVisibleRange = newRange;

    // 先更新所有现有视图的位置。
    var models = this.dataCollection && this.dataCollection.models;
    for (var k = 0; k < this.subViews.length; k++) {
      var view = this.subViews[k];
      if (!view || view.index == null) continue;
      var m = this._gridMetrics[view.index];
      if (m) {
        view.$el.css({
          top: m.top + "px",
          left: m.left + "px",
          width: m.width + "px"
        });
      }
    }

    // _buildGridLayout 可能更新了 _gridTotalHeight（图片加载导致卡片变高），
    // loaded-sign 需要立即跟随定位，不能等下次滚动。
    this._positionGridLoadedSign();

    // 可见范围无变化，无需增减视图。
    if (oldRange && oldRange.start === newRange.start && oldRange.end === newRange.end) {
      return;
    }

    // 范围变化时才完整重渲染；先备份现有视图的选中状态避免丢失。— 但这里仍然需要重建 DOM。
    // 为了彻底避免 contentEl.innerHTML = "" 导致的状态丢失，
    // 我们只在 views 层面做 delta：释放出界视图 + 创建新入界视图。
    this._diffRenderGridViews(oldRange, newRange, models, contentEl);
    this._positionGridLoadedSign();
  },
  /**
   * 增量更新：释放 oldRange 有而 newRange 无的视图，创建 newRange 有而 oldRange 无的视图。
   */
  _diffRenderGridViews: function _diffRenderGridViews(oldRange, newRange, models, contentEl) {
    var oldStart = oldRange ? oldRange.start : 0;
    var oldEnd = oldRange ? oldRange.end : 0;

    // 收集出界 index 集合。
    var outOfRange = {};
    for (var i = oldStart; i <= oldEnd && i < (models ? models.length : 0); i++) {
      if (i < newRange.start || i > newRange.end) {
        outOfRange[i] = true;
      }
    }

    // 释放出界视图。
    var remaining = [];
    for (var j = 0; j < this.subViews.length; j++) {
      var v = this.subViews[j];
      if (!v || v.index == null) continue;
      if (outOfRange[v.index]) {
        if (v.model && v.model.view === v) v.model.view = null;
        if (this._gridResizeObserver && v.el) this._gridResizeObserver.unobserve(v.el);
        v.$el.detach();
        var poolKey = (v.model || v.rowModel) && (v.model || v.rowModel).cid;
        if (poolKey) {
          if (!this._gridViewPool) this._gridViewPool = {};
          this._gridViewPool[poolKey] = v;
        }
      } else {
        remaining.push(v);
      }
    }
    this.subViews = remaining;

    // 收集已有 index，创建缺失的视图。
    var existingIndices = {};
    for (var p = 0; p < remaining.length; p++) {
      if (remaining[p] && remaining[p].index != null) {
        existingIndices[remaining[p].index] = true;
      }
    }
    var fragment = document.createDocumentFragment();
    var newViews = [];
    for (var idx = newRange.start; idx <= newRange.end && idx < (models ? models.length : 0); idx++) {
      if (existingIndices[idx]) continue;
      var model = models[idx];
      var metrics = this._gridMetrics[idx];
      if (!metrics) continue;

      // 先查视图缓存池。
      var poolKey = model.cid;
      var pooledView = this._gridViewPool && this._gridViewPool[poolKey];
      if (pooledView && pooledView.constructor === this.rowClass) {
        delete this._gridViewPool[poolKey];
        pooledView.index = idx;
        pooledView.rowModel = model;
        pooledView.superView = this;
        model.view = pooledView;
        pooledView.$el.css({
          position: "absolute",
          left: metrics.left + "px",
          top: metrics.top + "px",
          width: metrics.width + "px"
        });
        remaining.push(pooledView);
        pooledView.setSelected(!!model._rowSelected, true);
        fragment.appendChild(pooledView.el);
        if (this._gridResizeObserver && pooledView.el) {
          this._gridResizeObserver.observe(pooledView.el);
        }
      } else {
        this._createGridRowView(idx, model, metrics, fragment, newViews, true);
      }
    }

    // 追加新视图到 DOM。
    if (fragment.childNodes.length) {
      contentEl.appendChild(fragment);
    }

    // 新视图生命周期。
    _.each(newViews, function (vw) {
      _RenderProxy["default"].viewWillRendered(vw);
    });
    _.each(newViews, function (vw) {
      _RenderProxy["default"].viewDidRendered(vw);
    });
  },
  /**
   * 创建单个 grid 行视图并插入到 fragment。
   * 提取为单独方法是为了避免 for 循环中的 var 闭包问题（所有回调共享同一变量）。
   */
  _createGridRowView: function _createGridRowView(index, model, metrics, fragment, newViews, opt_observeResize) {
    var self = this;
    var rowOption = _.extend({
      singleSelect: this.singleSelect,
      rowCls: this.rowCls,
      index: index,
      rowModel: model,
      columns: this.columns,
      allowSelect: this.allowSelect,
      dataCollection: this.dataCollection,
      isSearch: this.isSearch,
      isUsedAdvancedSearch: this.isUsedAdvancedSearch
    }, _.isFunction(this.rowOption) ? this.rowOption() : this.rowOption);
    var rowView = new this.rowClass(rowOption);
    rowView.$el.css({
      position: "absolute",
      left: metrics.left + "px",
      top: metrics.top + "px",
      width: metrics.width + "px"
    });
    this.addSubView(rowView, function () {
      _RenderProxy["default"].buildViewDom(rowView);
      fragment.appendChild(rowView.el);
      model.view = rowView;
      rowView.model = model;
      rowView.setSelected(!!model._rowSelected, true);
      if (opt_observeResize && self._gridResizeObserver && rowView.el) {
        self._gridResizeObserver.observe(rowView.el);
      }
    }, false, true);
    newViews.push(rowView);
    return rowView;
  },
  /** 在下一帧测量所有可见卡片的实际高度，如有变化则触发回调。 */
  _scheduleMeasureHeights: function _scheduleMeasureHeights(onChanged) {
    if (this._gridMeasureRAF) return;
    var self = this;
    this._gridMeasureRAF = requestAnimationFrame(function () {
      self._gridMeasureRAF = null;
      var changed = self._measureVisibleHeights();
      if (_.isFunction(onChanged)) onChanged(changed);
    });
  },
  /**
   * 实测当前所有可见卡片的 offsetHeight，存入 _gridMeasuredHeights。
   * @returns {boolean} 是否有卡片高度发生变化。
   */
  _measureVisibleHeights: function _measureVisibleHeights() {
    if (!this.subViews) return false;
    var changed = false;
    var measured = this._gridMeasuredHeights || {};
    this._gridMeasuredHeights = measured;
    for (var i = 0; i < this.subViews.length; i++) {
      var view = this.subViews[i];
      if (!view || !view.el || view.index == null) continue;
      var h = view.el.offsetHeight;
      if (!h) continue;
      if (Math.abs((measured[view.index] || 0) - h) > 2) {
        measured[view.index] = h;
        changed = true;
      }
    }
    return changed;
  },
  /**
   * 网格虚拟渲染核心——按 cid 复用视图，只创建可见范围内的行。
   * 与 _renderVirtualRows 使用相同的视图池复用策略。
   */
  _renderVirtualGridRows: function _renderVirtualGridRows(callback) {
    var models = this.dataCollection && this.dataCollection.models;
    var contentEl = this._getGridContentEl();
    if (!contentEl || !models) {
      if (_.isFunction(callback)) callback();
      return;
    }

    // 空集合处理。
    if (!models.length) {
      if (this.dataCollection && !this.dataCollection.isInit) {
        this._renderBlankState();
      }
      if (_.isFunction(callback)) callback();
      return;
    }

    // 确保布局数据已构建；数据长度变化后 metrics 可能过期或未初始化。
    if (!this._gridMetrics || this._gridMetrics.length !== models.length) {
      this._buildGridLayout();
    }
    var range = this._calcGridVisibleRange();
    // 边界保护：如果 range 无效（如 start > end），恢复为安全范围避免清空 DOM 后无内容。
    if (range.start > range.end || range.end < 0) {
      range = {
        start: 0,
        end: Math.min(models.length - 1, 20)
      };
    }
    range.start = Math.max(0, Math.min(range.start, models.length - 1));
    range.end = Math.max(range.start, Math.min(range.end, models.length - 1));
    this._gridVisibleRange = range;

    // 内容容器撑开高度，滚动容器（this.el）保持原样以承载滚动条。
    contentEl.style.height = this._gridTotalHeight + "px";

    // “已全部加载”提示由文件表管理，不属于虚拟 row；重绘窗口时需保留该节点。
    var $loadedSign = $(contentEl).children('.loaded-sign').detach();

    // ---- 构建旧视图池（按 model.cid） ----
    var oldViews = {};
    var oldSubViews = [].concat(this.subViews || []);
    _.each(oldSubViews, function (view) {
      var model = view.model || view.rowModel;
      var key = model && model.cid;
      if (key) {
        oldViews[key] = view;
        view.$el.detach();
      }
    });
    this.subViews = [];
    var fragment = document.createDocumentFragment();
    var newViews = [];
    var self = this;
    var filterMode = this.dataCollection && this.dataCollection.filterMode;
    var rowClass = this.rowClass;
    for (var i = range.start; i <= range.end && i < models.length; i++) {
      var model = models[i];
      // 筛选模式下跳过被隐藏的 model（其 metrics 高度为 0，不渲染视图）。
      if (filterMode && _.isFunction(model.getShow) && !model.getShow()) {
        var hiddenOldView = oldViews[model.cid];
        if (hiddenOldView) {
          hiddenOldView.$el.detach();
          delete oldViews[model.cid];
        }
        continue;
      }
      var key = model.cid;
      var rowView = oldViews[key];
      var metrics = this._gridMetrics[i];
      if (!metrics || !metrics.width) {
        continue;
      }

      // 跨模式切换（list↔grid）时 rowClass 会变，旧视图类型不匹配，必须丢弃重建。
      if (rowView && rowView.constructor !== rowClass) {
        try {
          rowView.remove();
        } catch (e) {}
        rowView.superView = null;
        if (model.view === rowView) model.view = null;
        rowView = null;
        delete oldViews[key];
      }
      if (rowView) {
        // 复用已有视图。
        delete oldViews[key];
        rowView.index = i;
        rowView.rowModel = model;
        rowView.model = model;
        rowView.superView = this;
        model.view = rowView;
        rowView.$el.css({
          position: "absolute",
          left: metrics.left + "px",
          top: metrics.top + "px",
          width: metrics.width + "px"
        });
        this.subViews.push(rowView);
        // 同步 model 的选中状态到复用视图。
        rowView.setSelected(!!model._rowSelected, true);
        fragment.appendChild(rowView.el);
      } else {
        // 先查视图缓存池。
        if (!rowView && this._gridViewPool && this._gridViewPool[key]) {
          rowView = this._gridViewPool[key];
          delete this._gridViewPool[key];
          // 跨模式切换（list↔grid）时的类型校验。
          if (rowView.constructor !== rowClass) {
            try {
              rowView.remove();
            } catch (e) {}
            rowView.superView = null;
            rowView = null;
          }
        }
        if (rowView) {
          rowView.index = i;
          rowView.rowModel = model;
          rowView.superView = this;
          model.view = rowView;
          rowView.$el.css({
            position: "absolute",
            left: metrics.left + "px",
            top: metrics.top + "px",
            width: metrics.width + "px"
          });
          this.subViews.push(rowView);
          rowView.setSelected(!!model._rowSelected, true);
          fragment.appendChild(rowView.el);
        } else {
          // 创建新视图。
          this._createGridRowView(i, model, metrics, fragment, newViews, false);
        }
      }
    }

    // 超出可见范围的视图放入缓存池，保留已加载的缩略图 DOM，避免滚动回来时重新下载。
    if (!self._gridViewPool) self._gridViewPool = {};
    _.each(oldViews, function (view) {
      if (self._gridResizeObserver && view.el) {
        self._gridResizeObserver.unobserve(view.el);
      }
      if (view.model && view.model.view === view) {
        view.model.view = null;
      }
      view.$el.detach();
      var poolKey = (view.model || view.rowModel) && (view.model || view.rowModel).cid;
      if (poolKey) {
        self._gridViewPool[poolKey] = view;
      }
    });

    // 替换内容（操作内容容器，不影响滚动容器）。
    contentEl.innerHTML = "";
    contentEl.appendChild(fragment);
    $loadedSign.length && $(contentEl).append($loadedSign);
    this._positionGridLoadedSign();

    // 对所有可见卡片注册 ResizeObserver，监听图片加载后高度变化。
    if (this._gridResizeObserver) {
      for (var k = 0; k < this.subViews.length; k++) {
        if (this.subViews[k] && this.subViews[k].el) {
          this._gridResizeObserver.observe(this.subViews[k].el);
        }
      }
    }

    // 新视图生命周期。
    _.each(newViews, function (view) {
      _RenderProxy["default"].viewWillRendered(view);
    });
    _.each(newViews, function (view) {
      _RenderProxy["default"].viewDidRendered(view);
    });
    if (_.isFunction(callback)) callback();

    // 下一帧测量可见卡片实际高度，差异较大时用增量方式校正布局（不重建 DOM）。
    this._scheduleMeasureHeights(function (changed) {
      if (changed) {
        self._relayoutGridViews();
      }
    });
  }
};

// ---- 注入逻辑 ----

/**
 * 将 Grid 虚拟滚动能力注入到 MDTableBodyView 原型。
 * 调用时机：在 MDTableBodyView 类定义完成后立即调用。
 */
GridMixin.applyTo = function (proto) {
  // 1. 将网格方法混入原型（排除特殊键）。
  var methods = _.omit(GridMixin, '_gridInitProps', 'applyTo');
  _.extend(proto, methods);

  // 2. 扩展 initProps，注入 grid 配置项。
  var _origInitProps = proto.initProps;
  proto.initProps = function () {
    var props = _origInitProps.call(this);
    return _.extend(props, GridMixin._gridInitProps);
  };

  // 3. 拦截 _renderRows：grid 模式下走瀑布流渲染。
  var _origRenderRows = proto._renderRows;
  proto._renderRows = function (callback) {
    if (this.virtualGridScroll) {
      this._renderVirtualGridRows(callback);
      return;
    }
    return _origRenderRows.call(this, callback);
  };

  // 4. 拦截 renderNextPage：grid 模式下扩展数据边界并重绘。
  var _origRenderNextPage = proto.renderNextPage;
  proto.renderNextPage = function (loadEnded) {
    if (this.virtualGridScroll) {
      if (this.dataCollection) {
        var gridCurrentEnd = Number(this.dataCollection.end) || 0;
        var gridPageSize = this.superView && this.superView.pageSize || 50;
        this.dataCollection.end = loadEnded ? this.dataCollection.length : Math.min(Math.max(gridCurrentEnd + gridPageSize, gridPageSize), this.dataCollection.length);
      }
      this._scheduleGridRender();
      this.refreshPageBar();
      this._controlAllRowSelection();
      this.onNextPageRendered();
      return;
    }
    return _origRenderNextPage.call(this, loadEnded);
  };

  // 5. 扩展 viewDidUnRendered：清理 grid 资源。
  var _origViewDidUnRendered = proto.viewDidUnRendered;
  proto.viewDidUnRendered = function () {
    this._teardownGridVirtualScroll();
    return _origViewDidUnRendered.call(this);
  };
};
var _default = exports["default"] = GridMixin;

},{"1184":1184,"1412":1412,"1414":1414,"1446":1446,"1454":1454,"1465":1465,"25":25}],82:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1432);
var _TabBarDividerPosition = _interopRequireDefault(require(83));
var _TabBarPosition = _interopRequireDefault(require(84));
var _BarSliderPosition = _interopRequireDefault(require(80));
var _MDTabPanelView = _interopRequireDefault(require(81));
var _MMViewBase = _interopRequireDefault(require(22));
/**
 *  Tab view component
 * WebContent/javascript/base/component/tab/MDTabView.js
 *  Created by manjun.han
 *  2015.9.2
 */

var MDTabView = _MMViewBase["default"].extend({
  tmpl: '<div class="tab-wrapper">' + '<div class="tab-nav">' + '<div class="tabs"></div>' + '<div class="add icon icon20"></div>' + '<div class="active-bar"></div>' + '</div>' + '</div>' + '<div class="tab-panel-wrapper"></div>',
  className: function className() {
    var superCls = _MMViewBase["default"].prototype.className.call(this);
    return superCls + ' m-tabs';
  },
  events: function events() {
    return {
      'click .tab-title': this._tabTitleClickHandler,
      'click .add': this._addTabClickHandle
    };
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      curActiveTabPanelView: null,
      curIndex: -1,
      activeIndex: 0,
      // for dom refs
      $tabs: null,
      $activeBar: null,
      enableActivebar: true,
      $tabTitles: null,
      $tabPanelWrapper: null,
      panelCls: '',
      fullMode: false,
      showAddBtn: false,
      // for pass from options

      maxTab: 2,
      tabBarDividerPosition: _TabBarDividerPosition["default"].TOP,
      tabBarPosition: _TabBarPosition["default"].TOP,
      /**
       * @type {Array.<TabPanelConfig>}
       */
      tabs: []
    });
  },
  /**
   * tabPanel的配置对象
   * @typedef {object} TabPanelConfig
   * @property {string|function} title - 当前tab的标题，如果是function类型需要返回一个字符串类型
   * @property {string} titleCls - tilte样式
   * @property {MDTabPanleView} tabPanelView - tab对象，需要继承自MDTabPanelView
   * @property {boolean} enabled - 是否允许tab选中
   * @property {boolean} active - 是否选中当前tab
   */

  /**
   * @param {object} opt
   * @param {boolean} [opt.enableActivebar] - 是否显示底部激活的滑条
   * @param {Array.<TabPanelConfig>} opt.tabs - 包含tabPanel的数组
   * @param {boolean} [opt.fullMode] - fullMode下参见tab-full样式
   *
   */
  initialize: function initialize(opt) {
    var self = this;
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.$tabWrapper = this.$(".tab-wrapper");
    this.$activeBar = this.$(".active-bar");
    if (!this.enableActivebar) {
      this.$activeBar.remove();
      this.$activeBar = null;
      ;
    }
    if (!this.showAddBtn) {
      this.$(".add").remove();
    }
    this.$tabs = this.$('.tabs');
    this.$tabPanelWrapper = this.$(".tab-panel-wrapper");
    this._renderTabs(this.tabs);
    this.$tabTitles = this.$('.tab-wrapper .tab-title');
    this._initState();
    this._initClass();
  },
  _initState: function _initState() {
    var self = this;
    _.each(this.tabs, function (tab, index) {
      if (_.isBoolean(tab.enabled) && !tab.enabled) {
        self.setTabEnabledAt(index, false);
      }
      if (_.isBoolean(tab.active) && tab.active) {
        self.curIndex = index;
      }
    });
  },
  _initClass: function _initClass() {
    if (this.fullMode) {
      this.$el.addClass('tab-full');
    }
    var position = this.tabBarPosition;
    switch (position) {
      case _TabBarPosition["default"].TOP:
        break;
      case _TabBarPosition["default"].BOTTOM:
        break;
      case _TabBarPosition["default"].RIGHT:
        this.$el.addClass('tab-bar-vertical tab-bar-right');
        break;
      case _TabBarPosition["default"].LEFT:
        this.$el.addClass('tab-bar-vertical tab-bar-left');
        break;
    }
  },
  changeAddBtnState: function changeAddBtnState() {
    var length = this.tabs.length;
    if (length >= this.maxTab) {
      this.$('.add').addClass('f-hide');
    } else {
      this.$('.add').removeClass('f-hide');
    }
  },
  _renderTabs: function _renderTabs(tabs) {
    var self = this;
    this.changeAddBtnState();
    _.each(tabs, function (tab, index) {
      // render title
      var $title = $("<span></span>");
      $title.addClass('tab-title');
      var title = "";
      var tabPanelView = tab.tabPanelView;
      var isLink = tab.isLink;
      if (!isLink) {
        if (!(tabPanelView instanceof _MDTabPanelView["default"])) {
          throw new Error('tabPanelView must be MDTabPanelView type');
        }
        self.addSubView(tabPanelView, self.$tabPanelWrapper[0]);
      } else {
        $title.addClass('islink');
      }
      if (_.isFunction(tab.title)) {
        title = tab.title();
      } else {
        title = tab.title;
      }
      $title.append(title);
      if (tab.showDelBtn) {
        var $delbtn = $('<span class="del icon icon20 ic-tab-close"></span>');
        $delbtn.on("click", function () {
          self.onDelTabCallback(tabPanelView);
        });
        $title.append($delbtn);
      }
      if (tab.titleCls) {
        $title.addClass(tab.titleCls);
      }
      self.$tabs.append($title);
      // render panel
    });
    if (this.hideTabs) {
      this.$tabWrapper.addClass('hide');
    }
  },
  _tabTitleClickHandler: function _tabTitleClickHandler($e) {
    var $tab = $($e.currentTarget);
    if ($tab.hasClass('disabled')) {
      return;
    }
    var index = $tab.index();
    this._activeTabPanelAt(index);

    // 必须调用下面的函数，用于解决 tab 嵌套的问题
    $e.stopPropagation();
  },
  viewDidRendered: function viewDidRendered() {
    _MMViewBase["default"].prototype.viewDidRendered.call(this);
    this.el.offsetWidth; // force browser layout
    this._setTabBarPosition();
    this.enableActivebar && this._setTabBarDividerPosition();
    this._activeTabPanelAt(this.curIndex, false);
  },
  _setTabBarDividerPosition: function _setTabBarDividerPosition() {
    var position = this.tabBarDividerPosition;
    var tabBarHeight = this.$tabWrapper.height();
    var cls = "";
    switch (position) {
      case _TabBarPosition["default"].TOP:
        cls = "bar-top";
        break;
      case _TabBarPosition["default"].BOTTOM:
        cls = "bar-bottom";
        break;
      case _TabBarPosition["default"].RIGHT:
        cls = "bar-right";
        break;
      case _TabBarPosition["default"].LEFT:
        cls = "bar-left";
        break;
    }
    this.$tabWrapper.addClass(cls);
  },
  _setTabBarPosition: function _setTabBarPosition() {
    var position = this.tabBarPosition;
    var tabBarHeight = this.$tabWrapper.css('height');
    switch (position) {
      case _TabBarPosition["default"].TOP:
        if (this.fullMode) {
          this.$tabPanelWrapper.css('top', this.$tabWrapper.css('height'));
        }
        break;
      case _TabBarPosition["default"].BOTTOM:
        this.$tabPanelWrapper.insertBefore(this.$tabWrapper);
        if (this.fullMode) {
          this.$tabPanelWrapper.css('bottom', this.$tabWrapper.css('height'));
          this.$tabPanelWrapper.css('top', 0);
        }
        break;
      case _TabBarPosition["default"].RIGHT:
        break;
      case _TabBarPosition["default"].LEFT:
        if (this.fullMode) {
          this.$tabPanelWrapper.css('top', 0);
          this.$tabPanelWrapper.css('left', this.$tabWrapper.css('width'));
        }
        break;
    }
  },
  _activeTabPanelAt: function _activeTabPanelAt(index, opt_animated) {
    opt_animated = _.isBoolean(opt_animated) ? opt_animated : true;
    if (this.getSubViewCount() == 0) {
      return;
    }
    index = index < 0 ? 0 : index;
    index = index >= this.tabs.length ? this.tabs.length - 1 : index;
    if (this.$(".tab-title").eq(index).hasClass("islink")) {
      this.tabs[index].onActived && this.tabs[index].onActived();
      return;
    }
    if (this.curActiveTabPanelView) {
      this.curActiveTabPanelView.$el.removeClass('tab-panel-active');
      this.curActiveTabPanelView.onHidden();
    }
    _.isFunction(this.onTabChanged) && this.onTabChanged(index);
    var subView = this.getSubViewAt(index);
    subView.$el.addClass('tab-panel-active');
    subView.onActived();
    var $tabTitle = this.$tabs.children().removeClass('tab-title-active').eq(index);
    $tabTitle.addClass('tab-title-active');
    if (opt_animated && this.enableActivebar) {
      if (this.curIndex > index) {
        this.$activeBar.removeClass("forward").addClass("backward");
      } else {
        this.$activeBar.removeClass("backward").addClass("forward");
      }
    }
    if (this.enableActivebar) {
      this.$activeBar.get(0).offsetWidth;
      var position = $tabTitle.position();
      var right = this.$tabs.width() - position.left - $tabTitle.outerWidth();
      this.$activeBar.css({
        'left': position.left,
        'right': right
      });
    }
    this.curActiveTabPanelView = subView;
    this.curIndex = index;
    this.activeIndex = index;
  },
  getSubViewAt: function getSubViewAt(index) {
    var $tabs = this.$(".tab-title");
    var newIndex = index;
    for (var i = 0; i <= index; i++) {
      if ($tabs.eq(i).hasClass('islink')) {
        newIndex--;
      }
    }
    return _MMViewBase["default"].prototype.getSubViewAt.call(this, newIndex);
  },
  setTabEnabledAt: function setTabEnabledAt(index, enabled) {
    var l = this.$tabTitles.length;
    if (index < 0 || index > l) {
      return;
    }
    var $tabTitle = this.$tabTitles.eq(index);
    if (enabled) {
      $tabTitle.removeClass('disabled');
    } else {
      $tabTitle.addClass('disabled');
    }
  },
  activeTabAt: function activeTabAt(index) {
    this._activeTabPanelAt(index);
  },
  /**
   * 添加tab，并传入添加位置
   * @param {TabPanelConfig} tab - tab参数对象
   * @param {number} index - 插入位置
   */
  addTabAt: function addTabAt(tab, index) {
    var _this = this;
    index = this._getValidateIndex(index);
    var $pre = this.$tabs.children().eq(Math.max(index - 1, 0));
    var tabTitle = $("<a class='tab-title'>" + tab.title + "</a>");
    if (tab.showDelBtn) {
      var $delbtn = $('<span class="del icon icon20 ic-tab-close"></span>');
      $delbtn.on("click", function () {
        _this.onDelTabCallback(tabPanelView);
      });
      tabTitle.append($delbtn);
    }
    if ($pre.length > 0) {
      $pre.after(tabTitle);
    } else {
      this.$tabs.append(tabTitle);
    }
    var tabPanelView = tab.tabPanelView;
    if (!(tabPanelView instanceof _MDTabPanelView["default"])) {
      throw new Error('tabPanelView must be MDTabPanelView type');
    }
    this.tabs.splice(index, 0, tab);
    this.addSubViewAt(tabPanelView, index, this.$tabPanelWrapper[0]);
    this.changeAddBtnState();
  },
  _getValidateIndex: function _getValidateIndex(index) {
    var tabCount = this.getSubViewCount();
    index < 0 ? 0 : index;
    index > tabCount - 1 ? tabCount - 1 : index;
    return index;
  },
  replaceTab: function replaceTab(withIndex, newTabCfg) {
    this.tabs.splice(withIndex, 1, newTabCfg);
    var $title = this.$tabTitles.eq(withIndex);
    var title = "";
    var tabPanelView = newTabCfg.tabPanelView;
    $title.removeClass().addClass('tab-title');
    if (_.isFunction(newTabCfg.title)) {
      title = newTabCfg.title();
    } else {
      title = newTabCfg.title;
    }
    if (newTabCfg.titleCls) {
      $title.addClass(newTabCfg.titleCls);
    }
    if (!(tabPanelView instanceof _MDTabPanelView["default"])) {
      throw new Error('tabPanelView must be MDTabPanelView type');
    }
    this.replaceSubView(tabPanelView, this.getSubViewAt(withIndex), self.$tabPanelWrapper[0]);
  },
  removeTabAt: function removeTabAt(index) {
    var tabCount = this.getSubViewCount();
    if (tabCount == 0) {
      return;
    }
    index >= tabCount ? tabCount - 1 : index;
    index >= 0 ? index : 0;
    var activeIndex = this.curIndex;
    if (this.curIndex == index) {
      if (index == 0) {
        activeIndex = 0;
      } else if (index == tabCount - 1) {
        activeIndex = index - 1;
      } else {
        activeIndex = tabCount + 1;
      }
    }
    // this.$tabTitles.eq(index).remove();  //调用addtab后会出错
    this.$('.tab-wrapper .tab-title').eq(index).remove();
    this.removeSubViewAt(index);
    this.activeTabAt(activeIndex);
    this.tabs.splice(index, 1);
    console.log(this.tabs);
    this.changeAddBtnState();
  },
  toggleTabAt: function toggleTabAt(index, show) {
    var tabCount = this.getSubViewCount();
    if (tabCount == 0) {
      return;
    }
    index >= tabCount ? tabCount - 1 : index;
    index >= 0 ? index : 0;
    var activeIndex = -1;
    if (this.curIndex == index) {
      activeIndex = index - 1;
      if (activeIndex < 0) {
        activeIndex = index + 1;
      }
      if (activeIndex >= tabCount) {
        activeIndex = tabCount - 1;
      }
      this.activeTabAt(activeIndex);
    }
    var css = show ? 'inline-block' : 'none';
    this.$tabTitles.eq(index).css("display", css);
  },
  removeTabview: function removeTabview(subview) {
    console.warn(this.tabs);
    var index = this.indexOfSubView(subview);
    if (index >= this.tabs.length || index < 0) {
      console.error("Can not find subView");
    }
    this.removeTabAt(index);
  },
  _addTabClickHandle: function _addTabClickHandle() {
    var index = this.tabs.length;
    _.isFunction(this.onAddTabHandle) && this.onAddTabHandle();
  },
  getTabTitles: function getTabTitles(index) {
    return this.$tabs;
  },
  getActiveIndex: function getActiveIndex() {
    return this.activeIndex;
  },
  getcurActiveTabPanelView: function getcurActiveTabPanelView() {
    return this.curActiveTabPanelView;
  },
  setTabTitle: function setTabTitle(index, title) {
    $(this.$('.tab-title')[index]).text(title);
  },
  hideTabHead: function hideTabHead() {
    this.$('.tab-wrapper').hide();
  },
  showTabHead: function showTabHead() {
    this.$('.tab-wrapper').show();
  },
  setTabVisible: function setTabVisible(index, visible) {
    if (!visible) {
      $(this.$('.tab-title')[index]).hide();
    } else {
      $(this.$('.tab-title')[index]).css('display', 'inline-block');
    }
  }
});
var _default = exports["default"] = MDTabView;

},{"1184":1184,"1432":1432,"1454":1454,"22":22,"80":80,"81":81,"83":83,"84":84}],84:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * @enum {number}
 */
var TabBarPosition = {
  TOP: 0,
  RIGHT: 1,
  BOTTOM: 2,
  LEFT: 3
};
var _default = exports["default"] = TabBarPosition;

},{"1454":1454}],83:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * @enum {number}
 */
var TabBarDividerPosition = {
  TOP: 0,
  RIGHT: 1,
  BOTTOM: 2,
  LEFT: 3
};
var _default = exports["default"] = TabBarDividerPosition;

},{"1454":1454}],81:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMViewBase = _interopRequireDefault(require(22));
/**
 *  TabPanel view for tab component
 * WebContent/javascript/base/component/tab/MDTabPanelView.js
 *  Created by manjun.han
 *  2015.9.2
 */

var MDTabPanelView = _MMViewBase["default"].extend({
  el: '<div class="tab-panel"></div>',
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      lazyOver: false,
      enableLazyLoad: false
    });
  },
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
  },
  isActived: function isActived() {
    return this.$el.hasClass("active");
  },
  onActived: function onActived() {},
  onHidden: function onHidden() {}
});
var _default = exports["default"] = MDTabPanelView;

},{"1184":1184,"1454":1454,"22":22}],80:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * @enum {number}
 */
var BarSliderPosition = {
  Top: 0,
  Bottom: 1,
  Left: 2,
  Right: 3
};
var _default = exports["default"] = BarSliderPosition;

},{"1454":1454}],74:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMViewBase = _interopRequireDefault(require(22));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
/**
 *  加载更多的指示视图
 *  Created by manjun.han
 *  2016.9.30
 */

var MDLoadmoreIndicatorView = _MMViewBase["default"].extend({
  el: '<div class="m-load-more"></div>',
  tmpl: "\n    <div class=\"load-content\">\n      <div class=\"load-more-txt\"><%=loadMoreText%></div>\n      <div class=\"loading-txt\"></div>\n    </div>\n    <div class=\"empty\"><%=BabelStr.str(2622)%></div>\n    ",
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      onLoadMore: _.noop,
      $loadTxt: null,
      enabled: true,
      loadMoreText: BabelStr.str(477),
      // '加载更多',

      hideText: false
    });
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click .load-content': this.loadMoreClickHandler
    });
  },
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.$loadTxt = this.$('.load-more-txt');
    if (this.hideText) {
      this.$loadTxt.hide();
    }
    this.$('.load-content').hide();
  },
  showContent: function showContent() {
    this.$('.load-content').show();
  },
  loadMoreClickHandler: function loadMoreClickHandler($e) {
    if (!this.enabled) {
      return;
    }
    if (this.$el.hasClass('loading')) {
      return;
    }
    this.setLoadingState(true);
    _.isFunction(this.onLoadMore) && this.onLoadMore();
  },
  setLoadingState: function setLoadingState(loading, opt_text) {
    if (loading) {
      this.$('load-content').show();
      this.$('.empty').hide();
      this.$el.addClass('loading');
      _MDSpinnerloaderView["default"].showIn(this.$('.loading-txt')[0]);
    } else {
      this.$el.removeClass('loading');
      _MDSpinnerloaderView["default"].clearFrom(this.$('.loading-txt')[0]);
      this.$loadTxt.text(opt_text || this.loadMoreText);
    }
  },
  setEnabled: function setEnabled(enabled) {
    this.enabled = enabled;
    enabled ? this.$el.removeClass('disabled') : this.$el.addClass('disabled');
  },
  render: function render(data) {
    data = {
      'loadMoreText': this.loadMoreText
    };
    _MMViewBase["default"].prototype.render.call(this, data);
  },
  triggerLoad: function triggerLoad() {
    this.$('.load-content').trigger('click');
  }
});
var _default = exports["default"] = MDLoadmoreIndicatorView;

},{"1184":1184,"1454":1454,"22":22,"76":76}],69:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1413);
require(1463);
require(1438);
require(1498);
require(1415);
require(1421);
require(1417);
require(1418);
require(1537);
require(1426);
var _MMViewBase = _interopRequireDefault(require(22));
var MultiSelectView = _MMViewBase["default"].extend({
  className: 'multi-select-view',
  // 主模板：头部（标签 + 搜索框） + 下拉（全选 + 列表）
  tmpl: "\n    <div class=\"multi-select-header\" role=\"button\">\n      <span class=\"selected-placeholder\">\n        <% if (selectedItems && selectedItems.length) { %>\n          <% _.each(selectedItems, function(item) { %>\n            <span class=\"tag\" data-value=\"<%= item.value %>\">\n              <%= item.label %>\n              <span class=\"tag-remove\" data-value=\"<%= item.value %>\">\xD7</span>\n            </span>\n          <% }); %>\n        <% } else { %>\n          <span class=\"placeholder\"><%= BabelStr.str(3294) %></span>\n        <% } %>\n      </span>\n      <div class=\"search-box\">\n        <input type=\"text\" class=\"search-input\" placeholder=\"<%= BabelStr.str(3294) %>\" />\n      </div>\n    </div>\n\n    <div class=\"multi-select-dropdown\">\n      <div class=\"select-all\">\n        <label class=\"<%= allChecked ? 'active' : '' %>\">\n          <span class=\"custom-checkbox\">\n            <span class=\"check-mark\"></span>\n          </span>\n          Select All\n        </label>\n      </div>\n      <ul class=\"item-list\">\n        <% if (displayItems.length) { %>\n          <% _.each(displayItems, function(item, index) { %>\n            <li class=\"item <%= item.checked ? 'active' : '' %>\" data-value=\"<%= item.value %>\" data-index=\"<%= index %>\">\n              <label>\n                <span class=\"custom-checkbox\">\n                  <span class=\"check-mark\"></span>\n                </span>\n                <%= item.label %>\n              </label>\n            </li>\n          <% }); %>\n        <% } else { %>\n          <li class=\"no-match\">No items match</li>\n        <% } %>\n      </ul>\n    </div>\n    <div class=\"error-message\"></div>\n  ",
  // 独立列表模板（用于搜索局部更新）
  _listTmpl: "\n    <ul class=\"item-list\">\n      <% if (displayItems.length) { %>\n        <% _.each(displayItems, function(item, index) { %>\n          <li class=\"item <%= item.checked ? 'active' : '' %>\" data-value=\"<%= item.value %>\" data-index=\"<%= index %>\">\n            <label>\n              <span class=\"custom-checkbox\">\n                <span class=\"check-mark\"></span>\n              </span>\n              <%= item.label %>\n            </label>\n          </li>\n        <% }); %>\n      <% } else { %>\n        <li class=\"no-match\">No items match</li>\n      <% } %>\n    </ul>\n  ",
  // 独立标签模板（用于选中变化时局部更新）
  _tagsTmpl: "\n    <span class=\"selected-placeholder\">\n      <% if (selectedItems && selectedItems.length) { %>\n        <% _.each(selectedItems, function(item) { %>\n          <span class=\"tag\" data-value=\"<%= item.value %>\">\n            <%= item.label %>\n            <span class=\"tag-remove\" data-value=\"<%= item.value %>\">\xD7</span>\n          </span>\n        <% }); %>\n      <% } else { %>\n        <span class=\"placeholder\"><%= BabelStr.str(3294) %></span>\n      <% } %>\n    </span>\n  ",
  // 初始化属性
  initProps: function initProps(opt) {
    var defaultItems = [{
      label: 'Bag',
      value: 'bag',
      checked: false
    }, {
      label: 'Bow',
      value: 'bow',
      checked: false
    }, {
      label: 'Card',
      value: 'card',
      checked: false
    }, {
      label: 'Flat Box',
      value: 'flatbox',
      checked: false
    }];
    return {
      items: opt.items || defaultItems,
      searchKeyword: '',
      filteredItems: null,
      required: false,
      _documentClickHandler: null
    };
  },
  // 事件绑定（使用点击事件替代 change）
  events: function events() {
    var superEvents = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superEvents, {
      'click .multi-select-header': 'toggleExpand',
      'click .item': 'onItemClick',
      'click .select-all label': 'onSelectAllClick',
      'input .search-input': 'onSearchInput',
      'click .tag-remove': 'onTagRemove'
    });
  },
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.updateFilteredItems();
    this._listCompiler = _.template(this._listTmpl);
    this._tagsCompiler = _.template(this._tagsTmpl);
    this.$el.removeClass('expanded');
    return this;
  },
  // 渲染（整体）
  render: function render(data) {
    var displayItems = this.getDisplayItems();
    var selectedItems = this.getSelectedItems();
    var allChecked = displayItems.length > 0 && displayItems.every(function (item) {
      return item.checked;
    });
    var renderData = _.extend({}, data || {}, {
      displayItems: displayItems,
      selectedItems: selectedItems,
      allChecked: allChecked
    });
    _MMViewBase["default"].prototype.render.call(this, renderData);
    // 注意：模板中已经根据 allChecked 渲染了 active 类，但后期局部更新时仍需要 JS 同步
    this.updateSelectAllState();
    return this;
  },
  // 外部强制刷新
  refresh: function refresh(data) {
    this.removeSubViews();
    this.$el.empty();
    this.render(data);
  },
  // ---------- 局部更新 ----------
  updateList: function updateList() {
    var displayItems = this.getDisplayItems();
    var listHtml = this._listCompiler({
      displayItems: displayItems
    });
    this.$('.item-list').replaceWith(listHtml);
    this.updateSelectAllState();
  },
  updateSelectedTags: function updateSelectedTags() {
    var selectedItems = this.getSelectedItems();
    var tagsHtml = this._tagsCompiler({
      selectedItems: selectedItems
    });
    this.$('.selected-placeholder').replaceWith(tagsHtml);
  },
  // ---------- 展开/收起 ----------
  toggleExpand: function toggleExpand(e) {
    var $target = $(e.target);
    // 点击标签移除按钮不切换
    if ($target.closest('.tag-remove').length) return;

    // 点击输入框：如果未展开则展开，并聚焦；如果已展开则保持
    if ($target.is('input')) {
      if (!this.$el.hasClass('expanded')) {
        this.$el.addClass('expanded');
        this.$('.search-input').focus();
        this._bindDocumentClick();
      }
      return;
    }

    // 其他区域点击：切换展开/收起
    this.$el.toggleClass('expanded');
    if (this.$el.hasClass('expanded')) {
      this.$('.search-input').focus();
      this._bindDocumentClick();
    } else {
      this._unbindDocumentClick();
      this.validate();
    }
  },
  _bindDocumentClick: function _bindDocumentClick() {
    if (this._documentClickHandler) return;
    this._documentClickHandler = _.bind(this._onDocumentClick, this);
    $(document).on('click', this._documentClickHandler);
  },
  _unbindDocumentClick: function _unbindDocumentClick() {
    if (this._documentClickHandler) {
      $(document).off('click', this._documentClickHandler);
      this._documentClickHandler = null;
    }
  },
  _onDocumentClick: function _onDocumentClick(e) {
    var $target = $(e.target);
    if (!this.$el.has(e.target).length && !$.contains(this.el, e.target)) {
      this.$el.removeClass('expanded');
      this._unbindDocumentClick();
      this.validate();
    }
  },
  // ---------- 数据 ----------
  getDisplayItems: function getDisplayItems() {
    var keyword = this.searchKeyword.trim().toLowerCase();
    if (!keyword) return this.items;
    return this.items.filter(function (item) {
      return item.label.toLowerCase().indexOf(keyword) !== -1;
    });
  },
  updateFilteredItems: function updateFilteredItems() {
    this.filteredItems = this.getDisplayItems();
  },
  // ---------- 事件处理 ----------
  // 点击单个选项
  onItemClick: function onItemClick(e) {
    var $item = $(e.currentTarget);
    var value = $item.data('value');
    var item = this.items.find(function (it) {
      return it.value === value;
    });
    if (!item) return;

    // 切换选中状态
    item.checked = !item.checked;
    // 更新视图类
    $item.toggleClass('active', item.checked);

    // 更新标签区
    this.updateSelectedTags();
    // 更新全选状态
    this.updateSelectAllState();
    // 触发事件
    this.trigger('selectionChange', this.getSelectedValues());
    // 刷新错误状态
    this.validate();
  },
  // 点击全选
  onSelectAllClick: function onSelectAllClick(e) {
    var $label = $(e.currentTarget);
    var displayItems = this.getDisplayItems();
    // 判断当前是否全选（根据显示项）
    var allChecked = displayItems.every(function (item) {
      return item.checked;
    });
    var newChecked = !allChecked;
    displayItems.forEach(function (item) {
      item.checked = newChecked;
    });

    // 刷新列表显示（重新渲染列表）
    this.updateList();
    // 更新标签区
    this.updateSelectedTags();
    // 更新全选状态
    this.updateSelectAllState();
    this.trigger('selectionChange', this.getSelectedValues());
    // 刷新错误状态
    this.validate();
  },
  // 搜索输入
  onSearchInput: function onSearchInput(e) {
    this.searchKeyword = e.target.value;
    this.updateFilteredItems();
    this.updateList();
  },
  // 移除标签（取消选中）
  onTagRemove: function onTagRemove(e) {
    e.stopPropagation();
    e.preventDefault();
    var $tagRemove = $(e.target).closest('.tag-remove');
    var value = $tagRemove.data('value');
    var item = this.items.find(function (it) {
      return it.value === value;
    });
    if (item) {
      item.checked = false;
      this.updateSelectedTags();
      this.updateList();
      this.updateSelectAllState();
      this.trigger('selectionChange', this.getSelectedValues());
      // 刷新错误状态
      this.validate();
    }
  },
  // 更新全选状态（通过类控制）
  updateSelectAllState: function updateSelectAllState() {
    var displayItems = this.getDisplayItems();
    var allChecked = displayItems.length > 0 && displayItems.every(function (item) {
      return item.checked;
    });
    var $selectAllLabel = this.$('.select-all label');
    if ($selectAllLabel.length) {
      $selectAllLabel.toggleClass('active', allChecked);
    }
  },
  // ---------- API ----------
  getSelectedValues: function getSelectedValues() {
    return this.items.filter(function (item) {
      return item.checked;
    }).map(function (item) {
      return item.value;
    });
  },
  getSelectedItems: function getSelectedItems() {
    return this.items.filter(function (item) {
      return item.checked;
    });
  },
  setItems: function setItems(newItems) {
    this.items = newItems;
    this.updateFilteredItems();
    this.refresh();
    this.trigger('itemsChange', this.items);
  },
  clearSelection: function clearSelection() {
    this.items.forEach(function (item) {
      item.checked = false;
    });
    this.refresh();
    this.trigger('selectionChange', []);
  },
  selectAll: function selectAll() {
    this.items.forEach(function (item) {
      item.checked = true;
    });
    this.refresh();
    this.trigger('selectionChange', this.getSelectedValues());
  },
  validate: function validate() {
    var selectedValues = this.getSelectedValues();
    if (this.required && selectedValues.length === 0) {
      this.updateError(BabelStr.str(3430));
      return false;
    }
    this.clearError();
    return true;
  },
  updateError: function updateError(message) {
    this.errorMessage = message || '';
    var $error = this.$('.error-message');
    $error.text(this.errorMessage);
    this.$el.toggleClass('has-error', !!this.errorMessage);
  },
  clearError: function clearError() {
    this.updateError('');
  },
  viewWillUnRendered: function viewWillUnRendered() {
    this._unbindDocumentClick();
  },
  setSelectedValues: function setSelectedValues(values) {
    if (!values || !values.length) {
      this.clearSelection();
      return;
    }
    this.items.forEach(function (item) {
      item.checked = values.indexOf(item.value) !== -1;
    });
    this.refresh();
    this.trigger('selectionChange', this.getSelectedValues());
  }
});
var _default = exports["default"] = MultiSelectView;

},{"1184":1184,"1413":1413,"1415":1415,"1417":1417,"1418":1418,"1421":1421,"1426":1426,"1438":1438,"1454":1454,"1463":1463,"1498":1498,"1537":1537,"22":22}],1413:[function(require,module,exports){
'use strict';
var $ = require(1270);
var $every = require(1220).every;
var arrayMethodIsStrict = require(1223);

var STRICT_METHOD = arrayMethodIsStrict('every');

// `Array.prototype.every` method
// https://tc39.es/ecma262/#sec-array.prototype.every
$({ target: 'Array', proto: true, forced: !STRICT_METHOD }, {
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

},{"1220":1220,"1223":1223,"1270":1270}],68:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1424);
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
/**
 * 下拉选择组件
 */

var MDDropdownSelectSplitListView = _MDDropdownSelectListView["default"].extend({
  className: function className() {
    var superCls = _MDDropdownSelectListView["default"].prototype.className.call(this);
    return superCls + ' split-select-control';
  },
  initProps: function initProps() {
    var superP = _MDDropdownSelectListView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      breakPoints: [],
      blockTitles: []
    });
  },
  events: function events() {
    var superE = _MDDropdownSelectListView["default"].prototype.events.call(this);
    return _.extend(superE, {});
  },
  initialize: function initialize(options) {
    _MDDropdownSelectListView["default"].prototype.initialize.call(this, options);
    if (this.placeholder) {
      this.$(".selected-opt-value").html("\n        <div class=\"placeholder\">".concat(this.placeholder, "</div>\n      "));
    }
  },
  renderDropdownList: function renderDropdownList() {
    var _this = this;
    if (!this.dataProvider) {
      return;
    }
    var array;
    var self = this;
    if (this.dataProvider instanceof Backbone.Collection) {
      array = this.dataProvider.models;
    } else if (_.isArray(this.dataProvider)) {
      array = this.dataProvider;
    }
    var title = this.blockTitles.shift();
    var point = this.breakPoints.shift();
    var buffer = [];
    var nativeSelectBuffer = [];
    buffer.push("<div class=\"block-title\">".concat(title, "</div>"));
    _.each(array, function (dataItem, index) {
      var htmlString = self.itemToLabel(dataItem, index);
      buffer.push("<li data-index=".concat(index, ">"));
      buffer.push(htmlString);
      buffer.push('</li>');
      if (point && index == point) {
        title = _this.blockTitles.shift();
        buffer.push("<div class=\"block-split\"></div>");
        buffer.push("<div class=\"block-title\">".concat(title, "</div>"));
        point = _this.breakPoints.shift();
      }
      var label = self.toLabelUtil(dataItem);
      nativeSelectBuffer.push('<option>');
      nativeSelectBuffer.push(label);
      nativeSelectBuffer.push('</option>');
    });
    this.addMoreItems(buffer, nativeSelectBuffer);
    this.$selectPopupList.empty().append(buffer.join(''));
    this.$nativeSelect.empty().append(nativeSelectBuffer.join(''));
  }
}, {});
var _default = exports["default"] = MDDropdownSelectSplitListView;

},{"1184":1184,"1424":1424,"1454":1454,"67":67}],66:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1430);
require(1463);
require(1417);
require(1429);
var _MMViewBase = _interopRequireDefault(require(22));
var MDRadioBoxView = _MMViewBase["default"].extend({
  className: 'md-radio-box-view',
  // 模板：选项列表
  tmpl: "\n    <div class=\"radio-group\">\n      <% _.each(options, function(option) { %>\n        <div class=\"radio-box <%= option.value === selectedValue ? 'checked' : '' %>\" data-value=\"<%= option.value %>\">\n          <%= option.label %>\n        </div>\n      <% }); %>\n    </div>\n  ",
  // 独立选项模板（用于局部更新）
  _optionsTmpl: "\n    <div class=\"radio-group\">\n      <% _.each(options, function(option) { %>\n        <div class=\"radio-box <%= option.value === selectedValue ? 'checked' : '' %>\" data-value=\"<%= option.value %>\">\n          <%= option.label %>\n        </div>\n      <% }); %>\n    </div>\n  ",
  // 初始化属性
  initProps: function initProps(opt) {
    var options = opt.options || [{
      label: '选项1',
      value: '1'
    }, {
      label: '选项2',
      value: '2'
    }];
    // 如果未指定 selected，默认选中第一个
    var selectedValue = opt.selected;
    if (selectedValue === undefined && options.length > 0) {
      selectedValue = options[0].value;
    }
    return {
      options: options,
      selectedValue: selectedValue,
      onChange: opt.onChange || null // 回调函数：function(selectedValue, selectedOption)
    };
  },
  // 事件绑定
  events: function events() {
    var superEvents = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superEvents, {
      'click .radio-box': 'onRadioClick'
    });
  },
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this._optionsCompiler = _.template(this._optionsTmpl);
    return this;
  },
  render: function render(data) {
    var renderData = _.extend({}, data || {}, {
      options: this.options,
      selectedValue: this.selectedValue
    });
    _MMViewBase["default"].prototype.render.call(this, renderData);
    return this;
  },
  refresh: function refresh(data) {
    this.removeSubViews();
    this.$el.empty();
    this.render(data);
  },
  // ---------- 局部更新 ----------
  updateOptions: function updateOptions() {
    var html = this._optionsCompiler({
      options: this.options,
      selectedValue: this.selectedValue
    });
    this.$('.radio-group').replaceWith(html);
  },
  // ---------- 核心方法 ----------
  // 设置选中值
  setSelected: function setSelected(value) {
    // 查找是否存在该值的选项
    var exists = this.options.some(function (opt) {
      return opt.value === value;
    });
    if (!exists) return false;
    if (this.selectedValue === value) return true; // 相同值不触发回调

    var oldValue = this.selectedValue;
    this.selectedValue = value;
    this.updateOptions();
    // 触发回调
    if (_.isFunction(this.onChange)) {
      var selectedOption = this.options.find(function (opt) {
        return opt.value === value;
      });
      this.onChange(value, selectedOption);
    }
    return true;
  },
  // 获取当前选中值
  getSelected: function getSelected() {
    return this.selectedValue;
  },
  // 获取当前选中选项对象
  getSelectedOption: function getSelectedOption() {
    var _this = this;
    return this.options.find(function (opt) {
      return opt.value === _this.selectedValue;
    });
  },
  // 设置选项列表（重置选中为第一个）
  setOptions: function setOptions(newOptions, opt_selected) {
    var _this2 = this;
    this.options = newOptions.slice();
    var selectedValue = opt_selected;
    if (selectedValue === undefined && this.options.length > 0) {
      selectedValue = this.options[0].value;
    }
    this.selectedValue = selectedValue;
    this.updateOptions();
    if (_.isFunction(this.onChange)) {
      var selectedOption = this.options.find(function (opt) {
        return opt.value === _this2.selectedValue;
      });
      this.onChange(this.selectedValue, selectedOption);
    }
  },
  // 清空选中（可选）
  clearSelected: function clearSelected() {
    if (this.selectedValue === null) return;
    this.selectedValue = null;
    this.updateOptions();
    if (_.isFunction(this.onChange)) {
      this.onChange(null, null);
    }
  },
  // ---------- 事件处理器 ----------
  onRadioClick: function onRadioClick(e) {
    var $target = $(e.currentTarget);
    var value = $target.data('value');
    // 如果点击的是已选中的，不触发变化（但也可以允许取消选中，视需求而定）
    // 通常单选框点击已选中项不取消，所以我们忽略
    if (value === this.selectedValue) return;
    this.setSelected(value);
  }
});
var _default = exports["default"] = MDRadioBoxView;

},{"1184":1184,"1417":1417,"1429":1429,"1430":1430,"1454":1454,"1463":1463,"22":22}],62:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDPopupView = _interopRequireDefault(require(64));
/**
 *  MDCommonListPopupView 用于通用的弹出选项列表
 *  Create by jiang
 *  2019.3.10
 */

var MDCommonListPopupView = _MDPopupView["default"].extend({
  contentTmpl: '<ul class="m-menu select-list flex-align with-column"></ul>',
  events: function events() {
    var superEvents = _MDPopupView["default"].prototype.events.call(this);
    return _.extend({}, superEvents, {
      'click li': this._menuItemClickHandler,
      "mouseleave": this._mouseleave
    });
  },
  initProps: function initProps() {
    var superP = _MDPopupView["default"].prototype.initProps.call(this);
    return _.extend(superP, {});
  },
  initialize: function initialize(opt) {
    _MDPopupView["default"].prototype.initialize.call(this, opt);
    if (opt.class_name) {
      this.$(".m-menu").addClass(opt.class_name);
    }
    if (opt.elCls) {
      this.$el.addClass(opt.elCls);
    }
    this.initList(opt.items);
  },
  initList: function initList(items) {
    var html = "";
    for (var i = 0; i < this.items.length; i++) {
      var item = this.items[i];
      if (this.hideIcon) {
        html += "<li ><span class='middle-ellipsis'>" + item + "</span></li>";
      } else if (i == this.selIndex) {
        html += "<li ><span class='icon slt-li'></span><span class='middle-ellipsis'>" + item + "</span></li>";
      } else {
        html += "<li ><span class='icon '></span><span class='middle-ellipsis'>" + item + "</span></li>";
      }
    }
    ;
    this.$(".m-menu").append(html);
  },
  _mouseleave: function _mouseleave($e) {
    this.mouseleave && this.mouseleave($e);
  },
  _menuItemClickHandler: function _menuItemClickHandler($e) {
    var index = $($e.target).closest('li').index();
    this.onItemClicked(index);
    this.close();
  }
}, {
  instance: null,
  show: function show(opt) {
    if (MDCommonListPopupView.instance) {
      MDCommonListPopupView.instance.close();
    }
    var op = new MDCommonListPopupView(opt);
    MDCommonListPopupView.instance = op;
    op.show({
      triggerView: opt.triggerView,
      center: true,
      width: opt.width ? opt.width : 200
    });
    return op;
  },
  close: function close() {
    if (MDCommonListPopupView.instance) {
      MDCommonListPopupView.instance.close();
      MDCommonListPopupView.instance = undefined;
    }
  }
});
var _default = exports["default"] = MDCommonListPopupView;

},{"1184":1184,"1454":1454,"64":64}],61:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1438);
require(1466);
require(1417);
require(1463);
require(1446);
require(1498);
var _MMViewBase = _interopRequireDefault(require(22));
/**
 * 信息显示时的分页组件
 */

var MDPaginationView = _MMViewBase["default"].extend({
  tmpl: "<div class=\"pagination-btns\">\n        <% if(enableHeaderAndTail) {%>\n          <span data-button=\"first\" class=\"first <%=currentPage == 0 ? \"disabled\": \"\" %>\"><%=firstP%></span>\n        <%}%>\n          <span data-button=\"pre\" class=\"pre <%=currentPage == 0 ? \"disabled\": \"\" %>\"><%=preP%></span>\n            <%if(enableStepButton){%>\n              <%if(showFirstPage){%>\n                <span data-button=\"step\" ><%= 1%></span>\n                ...\n              <%}%>\n              <% for(var i = 0 ; i < pageButtonNum ; i++){%>\n                <%if(startPageIndex + i === currentPage){%>\n                  <span data-button=\"step\" class=\"current\"><%= currentPage + 1%></span>\n                <%}else{%>\n                  <span data-button=\"step\" ><%= startPageIndex + i + 1%></span>\n                <%}%>\n              <%}%>\n              <%if(showLastPagebtn){%>\n                ...\n                <span data-button=\"step\" ><%= pageNum%></span>\n              <%}%>\n            <%}%>\n          <span data-button=\"next\"  class=\"pre <%=currentPage == pageNum -1 ? \"disabled\": \"\" %>\"><%=nextP%></span>\n        <% if(enableHeaderAndTail) {%>\n          <span data-button=\"last\"  class=\"last  <%=currentPage == pageNum -1 ? \"disabled\": \"\" %>\"><%=endP%></span>\n        <%}%>\n      </div>\n      <div class=\"pagination-summary\">\n        <% if(showSelectSizeList) {%>\n          <span class=\"page-size-select\">\n            <span class=\"cur-pagesize\"><i class=\"page-size-num\"><%=pageSize%></i>/<%=page%></span>\n            <ul class=\"select-list\">\n              <% for (var i = 0 ; i < pageSizes.length ; i++){\n                  var selected = pageSizes[i].selected\n               %>\n                  <li data-index=\"<%=i%>\" data-value=\"<%=pageSizes[i].size%>\" <%if (selected){%> class=\"selected\" <%}%> ><%=pageSizes[i].size%></li>\n              <%}%>\n            </ul>\n          </span>\n        <%}%>\n        <%if(showPageInfo){%>\n          <span class=\"page-number\">\n            <%= (currentPage * pageSize) + 1%> -\n            <% var curNum = ((currentPage + 1) * pageSize) ;%>\n            <%=  curNum > length ? length : curNum %>/ <%=length%><%=item%>,\n          </span>\n          <span class=\"page-range\"><%=currentPage + 1%>/<%=pageNum%><%=page%></span>\n        <%}%>\n        <% if(showJumpToPage){%>\n          <span class=\"jump-to-page\">\n             , <%=jumpTo%>\n          </span>\n        <%}%>\n      </div>",
  className: function className() {
    var superCls = _MMViewBase["default"].prototype.className.call(this);
    return superCls + " m-pagination-bar";
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      theme: "normal",
      // 'normal'||'compact'

      pageSize: -1,
      pageNum: -1,
      pageButtonNum: 4,
      length: 0,
      startPage: -1,
      currentPage: 0,
      showHeadAndTail: false,
      stepOffset: 2,
      pageSizePos: "bottom",
      onPageChanged: _.noop,
      enableHeaderAndTail: false,
      enableStepButton: true,
      pageButtonNumShown: -1,
      align: "center",
      silentInit: false,
      showJumpToPage: true,
      /**
       * 是否显示跳转到某一页
       */
      pageSizes: [{
        size: 10
      }, {
        size: 20
      }, {
        size: 50
      }, {
        size: 100
      }],
      showSelectSizeList: true,
      showPageInfo: true,
      onPageSizeChanged: _.noop
    });
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      "click .pagination-btns span": this._pageButtonClickHandler,
      "click .cur-pagesize": this._popupPegesizeList,
      "click .select-list li": this._pageSizeClickHandler,
      "keyup .jump-to-page input": this._onInputKeyupHandler,
      "keydown .jump-to-page input": this._onInputKeydownHandler,
      "paste .jump-to-page input": this._onInputPasteHandler
    });
  },
  initialize: function initialize(opt) {
    var _this = this;
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.$el.addClass(this.theme);
    this.pageButtonNumShown = this.pageButtonNum;
    this._computepageNum();
    this._initStepOffset();
    this.setCurrentPage(this.currentPage, this.silentInit);
    this.$el.addClass(this.align);
    this._docClickHandler = _.bind(this._docClickHandler, this);
    _.each(this.pageSizes, function (elem) {
      if (elem.size !== _this.pageSize) {
        elem.selected = false;
      } else {
        elem.selected = true;
      }
    });
    $(document).on(this.$nsEventName("click"), this._docClickHandler);
  },
  render: function render(data) {
    data = {
      pageNum: this.pageNum,
      enableHeaderAndTail: this.enableHeaderAndTail,
      currentPage: this.currentPage,
      showFirstPage: this.pageNum > 5 && this.pageNum - this.currentPage < this.pageButtonNum - 1 && this.showHeadAndTail,
      showLastPagebtn: this.pageNum > 5 && this.pageNum - this.currentPage >= this.pageButtonNum && this.showHeadAndTail,
      startPageIndex: this.startPageIndex,
      pageButtonNum: this.pageButtonNumShown,
      enableStepButton: this.enableStepButton,
      length: this.length,
      pageSize: this.pageSize,
      pageSizes: this.pageSizes,
      showSelectSizeList: this.showSelectSizeList,
      showPageInfo: this.showPageInfo,
      showJumpToPage: this.showJumpToPage,
      firstP: BabelStr.str(2374),
      // 首页
      preP: BabelStr.str(2375),
      // 上一页
      nextP: BabelStr.str(2376),
      // 下一页
      endP: BabelStr.str(2377),
      // 尾页
      page: BabelStr.str(2378),
      // 页
      item: BabelStr.str(2380),
      // 项
      jumpTo: BabelStr.str(2379, {
        "no.": '<input value="' + (parseInt(this.currentPage) + 1) + '"/>'
      }) // 跳转到 {-no.-} 页
    };
    this.$el.empty();
    _MMViewBase["default"].prototype.render.call(this, data);
    this.$input = this.$(".jump-to-page input");
    // this.$input.focus().val(this.$input.val()); // 光标移动到末尾
  },
  _pageSizeClickHandler: function _pageSizeClickHandler($e) {
    var $li = $($e.currentTarget);
    var size = $li.data("value");
    var selectedIndex = $li.data("index");
    _.each(this.pageSizes, function (elem, index) {
      if (index !== selectedIndex) {
        elem.selected = false;
      } else {
        elem.selected = true;
      }
    });
    this.$(".select-list").hide().children().removeClass("selected").eq(selectedIndex).addClass("selected").find(".page-size-num").text(size);
    if (this.pageSize == size) {
      return;
    }
    this.pageSize = size;
    this.currentPage = 0;
    _.isFunction(this.onPageSizeChanged) && this.onPageSizeChanged(parseInt(size));
  },
  _popupPegesizeList: function _popupPegesizeList($e) {
    this.$(".select-list").toggle();
    this.$(".select-list")[0].offsetWidth;
    var pos = this.getPosition();
    this.$(".select-list").position({
      my: pos.my,
      at: pos.at,
      of: this.$(".cur-pagesize"),
      collision: "flip"
    });
  },
  getPosition: function getPosition() {
    var pos;
    if (this.pageSizePos == "bottom") {
      pos = {
        my: "top",
        at: "bottom"
      };
    } else if (this.pageSizePos == "top") {
      pos = {
        my: "bottom",
        at: "top"
      };
    }
    return pos;
  },
  _docClickHandler: function _docClickHandler($e) {
    if (this.$(".page-size-select").length == 0) {
      return;
    }
    if ($.contains(this.$(".page-size-select")[0], $e.target)) {
      return;
    }
    this.$(".select-list").hide();
  },
  _pageButtonClickHandler: function _pageButtonClickHandler($e) {
    var $btn = $($e.target);
    var button = $btn.data("button");
    var disabled = $btn.hasClass("disabled");
    var index = -1;
    if (disabled) {
      return;
    }
    switch (button) {
      case "first":
        index = 0;
        break;
      case "pre":
        index = this.currentPage - 1;
        break;
      case "next":
        index = this.currentPage + 1;
        break;
      case "last":
        index = this.pageNum - 1;
        break;
      case "step":
        index = Number($($e.target).text()) - 1;
        break;
    }
    this.setCurrentPage(index);
  },
  setCurrentPage: function setCurrentPage(index, opt_silent) {
    this.currentPage = index;
    this.computeStartIndex();
    this.render();
    if (_.isFunction(this.onPageChanged) && !opt_silent) {
      this.onPageChanged(this.currentPage);
    }
  },
  _initStepOffset: function _initStepOffset() {
    this.stepOffset = Math.max(1, this.stepOffset);
    this.stepOffset = Math.min(this.pageButtonNum - 1, this.stepOffset);
  },
  computeStartIndex: function computeStartIndex() {
    if (this.pageNum <= this.pageButtonNum) {
      this.startPageIndex = 0;
    } else {
      if (this.currentPage < this.stepOffset) {
        this.startPageIndex = 0;
      } else if (this.currentPage + (this.pageButtonNum - this.stepOffset) > this.pageNum) {
        this.startPageIndex = this.pageNum - this.pageButtonNum;
      } else {
        this.startPageIndex = this.currentPage - this.stepOffset;
      }
    }
  },
  _computepageNum: function _computepageNum() {
    if (this.length < 0) {
      return;
    }
    this.pageNum = Math.ceil(this.length / this.pageSize);
    if (this.pageNum < this.pageButtonNum) {
      this.pageButtonNumShown = this.pageNum;
    } else {
      this.pageButtonNumShown = this.pageButtonNum;
    }
  },
  getCurrentPage: function getCurrentPage() {
    return this.currentPage;
  },
  getLength: function getLength() {
    return this.length;
  },
  /**
   *  设置要显示数据的总长度
   */
  setLength: function setLength(length, opt_silent, startIndex) {
    this.length = length;
    if (length > 0) {
      this.$el.addClass("flex-align between");
    } else {
      this.$el.hide();
    }
    if (startIndex === 0) {
      this.currentPage = 0;
    }
    this._computepageNum();
    this.setCurrentPage(this.currentPage, opt_silent);
  },
  _onInputKeydownHandler: function _onInputKeydownHandler($e) {
    var BACKSPACE = 8;
    var code = $e.which;
    if (this._isNumber(code) || BACKSPACE == code) {
      return true;
    }
    $e.preventDefault();
  },
  _onInputKeyupHandler: function _onInputKeyupHandler($e) {
    var ENTER = 13;
    var val = this.$input.val().trim();
    val = parseInt(val);
    if ($e.which == ENTER && !isNaN(val)) {
      if (val > 0 && val <= this.pageNum) {
        this.setCurrentPage(val - 1);
      }
    }
  },
  _isNumber: function _isNumber(code) {
    var ZERO = 48;
    var NINE = 57;
    var NUM_ZERO = 96;
    var NUM_NINE = 105;
    if (ZERO <= code && code <= NINE || NUM_ZERO <= code && code <= NUM_NINE) {
      return true;
    }
    return false;
  },
  _onInputPasteHandler: function _onInputPasteHandler($e) {
    return false;
  },
  viewWillUnRendered: function viewWillUnRendered() {
    _MMViewBase["default"].prototype.viewWillUnRendered.call(this);
    $(document).off(this.$nsEventName("click"));
  }
});
var _default = exports["default"] = MDPaginationView;

},{"1184":1184,"1417":1417,"1438":1438,"1446":1446,"1454":1454,"1463":1463,"1466":1466,"1498":1498,"22":22}],57:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1421);
require(1432);
var _MDNavigationbarView = _interopRequireDefault(require(58));
var _MMViewBase = _interopRequireDefault(require(22));
var _MDNavigationPageView = _interopRequireDefault(require(56));
/**
 * 导航面板容器组件
 * Created by manjun.han
 * 2016.12.7
 */

var MDNavigationView = _MMViewBase["default"].extend({
  el: '<div class="m-navigation"></div>',
  tmpl: function tmpl() {
    return '<div class="navpage-container"></div>';
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      babelId: MDNavigationView.getNextId(),
      topNavigationPageView: null,
      visibleNavigationPageView: null,
      $navPageContainer: null,
      navigationPageViewStack: [],
      navigationbarView: null,
      showNavigationBar: true,
      animateNavigate: true,
      _isNavigationView: true,
      onNavigationPageViewWillShow: _.noop,
      onNavigationPageViewDidShow: _.noop,
      onPageViewChanged: _.noop,
      removePreView: true
    });
  },
  /**
   *
   * @param  {MDNavigationPageView} opts.rootNavigationPageView - 根视图对象
   * @param {boolean}  opts.showNavigationBar 是否显示navtoolbar
   * @param {boolean} opts.animateNavigate 是否以动画的方式切换page
   */
  initialize: function initialize(opts) {
    var self = this;
    if (!(opts.rootNavigationPageView instanceof _MDNavigationPageView["default"])) {
      throw new Error('rootNavigationPageView lost');
      return;
    }
    _MMViewBase["default"].prototype.initialize.call(this, opts);
    this.$navPageContainer = this.$('.navpage-container');
    this.initWithRootNavigationPageView(this.rootNavigationPageView);
    if (this.showNavigationBar) {
      this.navigationbarView = new _MDNavigationbarView["default"]();
      this.addSubView(this.navigationbarView, function (barEl) {
        self.$navPageContainer.before(barEl);
      });
    }
    this.$el.addClass("data-id" + this.babelId);
    if (opts && opts.cls) {
      this.$el.addClass(opts.cls);
    }
  },
  initWithRootNavigationPageView: function initWithRootNavigationPageView(rootNavigationPageView) {
    this.visibleNavigationPageView && this.visibleNavigationPageView.removeFromSuperView();
    this.onNavigationPageViewWillShow(rootNavigationPageView);
    this.addSubView(rootNavigationPageView, this.$navPageContainer[0]);
    this.visibleNavigationPageView = rootNavigationPageView;
    this.navigationPageViewStack = [rootNavigationPageView];
    this.showOrHideNavigationBar();
  },
  // setRootNavigationpageView: function() {
  //   this.navigationPageViewStack[0] =
  // },

  addSubView: function addSubView(subView, opt_parent, opt_slot, opt_silentRender) {
    // subView.navigationView = this;
    // subView.navigationWindowView = this.navigationWindowView;
    _MMViewBase["default"].prototype.addSubView.call(this, subView, opt_parent, opt_slot, opt_silentRender);
  },
  showBar: function showBar() {
    this.$el.removeClass('no-navbar');
  },
  /**
    *
    * @param  {MDNavigationPageView} navigationPageView - 要显示的视图对象
    * @param {boolean} animateNavigate 是否以动画的方式切换page
    * @param {function}  opt_cb 显示后的回调
    */

  push: function push(navigationPageView, opt_animation, opt_cb) {
    var self = this;
    var animateNavigate = this.animateNavigate;
    if (_.isBoolean(opt_animation)) {
      animateNavigate = opt_animation;
    } else if (_.isFunction(opt_animation)) {
      opt_cb = opt_animation;
    }
    this.onNavigationPageViewWillShow(navigationPageView);
    if (self.removePreView) {
      this.addSubView(navigationPageView, function () {
        self.visibleNavigationPageView.$el.after(navigationPageView.el);
      });
    } else {
      this.addSubView(navigationPageView, this.$(".navpage-container")[0]);
    }
    navigationPageView.el.offsetWidth;
    this.showOrHideNavigationBar(true);

    // navigationPageView._setNavigationView(this);
    this.navigationPageViewStack.push(navigationPageView);
    if (animateNavigate) {
      this.$el.addClass('transitioning');
      navigationPageView.transitioningPage('page-from-right-to-center');
      this.visibleNavigationPageView.transitioningPage('page-from-center-to-left', function () {
        self._replaceVisiableNavigationView(navigationPageView, opt_cb);
        self.$el.removeClass('transitioning');
      });
    } else {
      this._replaceVisiableNavigationView(navigationPageView, opt_cb);
    }
  },
  _replaceVisiableNavigationView: function _replaceVisiableNavigationView(navigationPageView, opt_cb) {
    if (this.removePreView) {
      this.detachSubView(this.visibleNavigationPageView);
    } else {
      this.visibleNavigationPageView.hide();
    }
    this.visibleNavigationPageView = navigationPageView;
    this.navigationbarView && this.navigationbarView.refresh();
    _.isFunction(opt_cb) && opt_cb();
    this.onNavigationPageViewDidShow(navigationPageView);
    this.onPageViewChanged(navigationPageView);
  },
  /**
   * 删除当前page，返回上一个
   */
  pop: function pop(opt_cb) {
    var lastSecondNavPageView = this.navigationPageViewStack[this.navigationPageViewStack.length - 2];
    if (!lastSecondNavPageView) {
      return;
    }
    this.popToNavigationPageView(lastSecondNavPageView, opt_cb);
  },
  popToNavigationPageView: function popToNavigationPageView(navigationPageView, opt_cb) {
    this._popNavigationPageView(navigationPageView, opt_cb);
  },
  /**
   * 返回root page
   */
  popToRoot: function popToRoot(opt_cb) {
    var self = this;
    var rootNavigationPageView = this.navigationPageViewStack[0];
    this._popNavigationPageView(rootNavigationPageView, opt_cb);
  },
  getNextPopNavigationPageView: function getNextPopNavigationPageView() {
    var lastSecondNavPageView = this.navigationPageViewStack[this.navigationPageViewStack.length - 2];
    return lastSecondNavPageView;
  },
  getRootNavigationPageView: function getRootNavigationPageView() {
    return this.navigationPageViewStack[0];
  },
  /**
   * 弹出当前面板，显示指定的面板
   * @param {MDNavigationPageView} navigationPageView
   * @param {function} opt_cb
   */
  _popNavigationPageView: function _popNavigationPageView(navigationPageView, opt_cb) {
    var self = this;
    if (!navigationPageView) {
      return;
    }
    if (navigationPageView === this.visibleNavigationPageView) {
      return;
    }
    this.navigationbarView && this.navigationbarView.setBackEnabled(false);
    if (this.removePreView) {
      this.assembleView(navigationPageView, function () {
        self.visibleNavigationPageView.$el.before(navigationPageView.$el);
      });
    } else {}
    this.showOrHideNavigationBar(true);
    if (this.animateNavigate) {
      this.$el.addClass('transitioning');
      if (this.removeClass) {
        navigationPageView.transitioningPage('page-from-left-to-center');
      }
      this.visibleNavigationPageView.transitioningPage('page-from-center-to-right', function () {
        self.$el.removeClass('transitioning');
        self._doneWithPopAction(navigationPageView, opt_cb);
      });
    } else {
      this._doneWithPopAction(navigationPageView, opt_cb);
    }
    this.onPageViewChanged(navigationPageView);
  },
  _doneWithPopAction: function _doneWithPopAction(navigationPageView, opt_cb) {
    var index = _.indexOf(this.navigationPageViewStack, navigationPageView);
    var delteCount = this.navigationPageViewStack.length - index - 1;
    this.navigationPageViewStack.splice(index + 1, delteCount);
    this.visibleNavigationPageView.removeFromSuperView();
    this.visibleNavigationPageView = navigationPageView;
    if (this.removePreView) {} else {
      navigationPageView.show();
    }
    if (this.navigationbarView) {
      this.navigationbarView.refresh();
      this.navigationbarView.setBackEnabled(true);
    }
    _.isFunction(opt_cb) && opt_cb(navigationPageView);
    if (this.navigationPageViewStack.length <= 1) {
      this.$el.addClass('no-navbar');
    }
  },
  _preNavigationPageView: function _preNavigationPageView() {
    var index = _.indexOf(this.navigationPageViewStack, this.visibleNavigationPageView);
    index--;
    return index > -1 ? this.navigationPageViewStack[index] : null;
  },
  _nextNavigationPageView: function _nextNavigationPageView() {
    var index = _.indexOf(this.navigationPageViewStack, this.visibleNavigationPageView);
    index++;
    return index < this.navigationPageViewStack.length ? this.navigationPageViewStack[index] : null;
  },
  /**
   * 获取已贮藏page的堆栈
   */
  getPageViewStack: function getPageViewStack() {
    return this.navigationPageViewStack;
  },
  showOrHideNavigationBar: function showOrHideNavigationBar(pushPop) {
    var show = false;
    if (pushPop) {
      show = this.showNavigationBar;
    } else {
      show = this.showNavigationBar && this.visibleNavigationPageView.showNavigationBar;
    }
    if (!show) {
      this.$el.addClass('no-navbar');
    } else {
      this.$el.removeClass('no-navbar');
    }
  },
  viewDidRendered: function viewDidRendered() {
    _MMViewBase["default"].prototype.viewDidRendered.call(this);
    this.onNavigationPageViewDidShow(this.rootNavigationPageView);
  }
}, {
  id: 0,
  getNextId: function getNextId() {
    return MDNavigationView.id++;
  }
});
var _default = exports["default"] = MDNavigationView;

},{"1184":1184,"1421":1421,"1432":1432,"1454":1454,"22":22,"56":56,"58":58}],58:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMViewBase = _interopRequireDefault(require(22));
/**
 * 导航顶部工具条
 * Created by manjun.han
 * 2016.12.7
 */

var MDNavigationbarView = _MMViewBase["default"].extend({
  el: '<div class="m-navigationbar"></div>',
  tmpl: "<%if(topMost){%>\n        <span class=\"title\"><%=title%></span>\n      <%}else{%>\n        <span class=\"nav-back\"></span>\n        <span class=\"title\"><%=title%></span>\n      <%}%>",
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click .nav-back': this._backNavClickHandler
    });
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      backEnabled: true
    });
  },
  setTitle: function setTitle(title) {
    this.$title.text(title);
  },
  _backNavClickHandler: function _backNavClickHandler($e) {
    var self = this;
    this.backEnabled && this.navigationView.pop(function () {
      self.refresh();
    });
  },
  refresh: function refresh() {
    var title = this.navigationView.visibleNavigationPageView.getTitle();
    var topMost = this.inTopMost();
    var data = {
      'title': title,
      'topMost': topMost
    };
    this.render(data);
  },
  viewDidRendered: function viewDidRendered() {
    _MMViewBase["default"].prototype.viewDidRendered();
    this.refresh();
  },
  render: function render(data) {
    data = _.extend({
      'title': '',
      'topMost': true
    }, data);
    this.$el.empty();
    _MMViewBase["default"].prototype.render.call(this, data);
    this.$title = this.$('.title');
  },
  inTopMost: function inTopMost() {
    return this.navigationView.getPageViewStack().length == 1 ? true : false;
  },
  setBackEnabled: function setBackEnabled(enabled) {
    this.backEnabled = enabled;
  }
});
var _default = exports["default"] = MDNavigationbarView;

},{"1184":1184,"1454":1454,"22":22}],56:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMViewBase = _interopRequireDefault(require(22));
/**
 * 导航面板页组件
 * Created by manjun.han
 * 2016.12.7
 */

var MDNavigationPageView = _MMViewBase["default"].extend({
  /**
   * 此方法已标记为私有，子类不能覆盖
   * @private
   * @return {string} 模板字符串
   */
  tmpl: function tmpl() {
    var contentTmpl = _.isString(this.contentTmpl) ? this.contentTmpl : this.contentTmpl();
    return '<div class="page-content">' + contentTmpl + '</div>';
  },
  /**
   * 子类可以继承此方法，定制模板
   * @return {[type]} [description]
   */
  contentTmpl: function contentTmpl() {
    return '';
  },
  className: function className() {
    var superCls = _MMViewBase["default"].prototype.className.call(this);
    return superCls + ' nav-page';
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      title: null,
      showNavigationBar: true
    });
  },
  /**
   *
   * @param  {string} opt.title page的title
   * @param {boolean} opt.showNavigationBar 是否显示工具条
   */
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    if (!this.showNavigationBar) {
      this.$el.addClass('no-navbar');
    }
  },
  getShowNavigationBar: function getShowNavigationBar() {
    return this.showNavigationBar;
  },
  setTitle: function setTitle(title) {
    this.title = title;
  },
  getTitle: function getTitle() {
    return this.title;
  },
  transitioningPage: function transitioningPage(animationName, opt_cb) {
    var self = this;
    function animatinEnd() {
      self.$el.removeClass(animationName).removeClass('page-transitioning');
      _.isFunction(opt_cb) && opt_cb();
    }
    this.$el.animationEndOnce(animatinEnd).addClass(animationName).addClass('page-transitioning');
  },
  getNavigationView: function getNavigationView() {
    return this.navigationView;
  },
  addSubView: function addSubView(subView, opt_parent, opt_slot, opt_silentRender) {
    opt_parent = opt_parent || this.$('.page-content')[0];
    _MMViewBase["default"].prototype.addSubView.call(this, subView, opt_parent, opt_slot, opt_silentRender);
  },
  addSubViewAt: function addSubViewAt(subView, index, opt_parent, opt_slot) {
    opt_parent = opt_parent || this.$('.page-content')[0];
    _MMViewBase["default"].prototype.addSubViewAt.call(this, subView, index, opt_parent, opt_slot);
  },
  getContentElem: function getContentElem() {
    return this.$('.page-content').css('height');
  }
});
var _default = exports["default"] = MDNavigationPageView;

},{"1184":1184,"1454":1454,"22":22}],50:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
var _MMViewBase = _interopRequireDefault(require(22));
var _MDShareFilePermissionInfoView = _interopRequireDefault(require(692));
var _MMCommonFun = _interopRequireDefault(require(812));
/**
 *  a dropdowm select menu for role select
 *  WebContent/javascript/base/component/mddropdownselect/MDDropDownSelectRoleView.js
 *
 *  Created by jichao
 *  2016.9.26
 */

var MDDropDownSelectRoleView = _MMViewBase["default"].extend({
  tmpl: '<div class="m-hd br-2 text-over"><span class="inner middle-ellipsis"></span></div>' + '<div class="dropdowm-select-list  with-shadow">' + '<ul class="flex-align with-column"></ul>' + '</div>',
  className: function className() {
    var superCls = _MMViewBase["default"].prototype.className.call(this);
    return superCls + ' m-dropdown-menu';
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      index: -1,
      /**
       * 选中元素的位置
       */
      noSelectIndex: null,
      /**
       * 不可选中元素的位置
       */
      bd: null,
      /**
       * 显示的内容
       */
      onChange: _.noop,
      /**
       * 是否显示帮助按钮
       */
      showHelp: true

      /**
       * 选中元素改变时的回调
       */
    });
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click .m-hd': this._toggleSelected,
      'click  li': this._itemClickHandler
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.setList(this.bd);
    $('body').on(this.$nsEventName("click"), this.removeList);
    this.index = -1;
    this.selectByIndex(opt.index, true);
    if (this.minW) {
      this.$('.dropdowm-select-list').css({
        'min-width': this.minW
      });
    }
  },
  _itemClickHandler: function _itemClickHandler($e) {
    var $li = $($e.currentTarget);
    if (!$li.hasClass('no-select')) {
      var index = $li.index();
      this.selectByIndex(index);
    }
    if ($li.hasClass('p-help')) {
      this.aboutPermission();
    }
    this.removeList();
  },
  _toggleSelected: function _toggleSelected($e) {
    if (this.$el.find(".dropdowm-select-list").hasClass("isdisplay")) {
      this.$el.find(".dropdowm-select-list").removeClass("isdisplay");
      this.$el.find(".dropdowm-select-list").css({
        "max-height": "auto",
        "overflow": "hide"
      });
    } else {
      $(".dropdowm-select-list").removeClass("isdisplay");
      this.$el.find(".dropdowm-select-list").addClass("isdisplay");
      this.layoutFixedPos();
    }
    $e.stopPropagation();
  },
  removeList: function removeList() {
    $(".dropdowm-select-list").removeClass("isdisplay");
    $(".dropdowm-select-list").css({
      "max-height": "initial",
      "overflow-y": "hide"
    });
  },
  setList: function setList(items) {
    this.$(".dropdowm-select-list ul").empty();
    var self = this;
    var length = items.length;
    var html = "";
    var str;
    var cls;
    for (var i = 0; i < length; i++) {
      cls = '';
      var item = items[i];
      if (i != this.index && !item.systemdefault && !_.isUndefined(item.systemdefault)) {
        cls = 'f-hide';
      }
      var text = item.label;
      if (item.linkRoleId) {
        str = 'role=' + item.linkRoleId;
      } else {
        str = "";
      }
      if (item.canSelected) {
        html += '<li ' + str + ' class="middle-ellipsis ' + cls + '">' + text + '</li> ';
      } else {
        html += '<li class="no-select middle-ellipsis ' + cls + '">' + text + '</li> ';
      }
    }
    if (this.showHelp) {
      html += '<li class="p-help no-select">' + BabelStr.str(81) + '...' + '</li>';
    }
    self.$(".dropdowm-select-list ul").append(html);
  },
  layoutFixedPos: function layoutFixedPos() {
    var $pop = this.$('.dropdowm-select-list');
    var elTop = this.$el.offset().top;
    var elLeft = this.$el.offset().left;
    var pos = _MMCommonFun["default"].convertPointBetweenElements(this.$el[0], window, {
      x: 0,
      y: 0
    });
    var winHeight = $(window).height();
    var popHeight = $pop.outerHeight();
    if (pos.y + popHeight + 36 > winHeight) {
      pos.y = winHeight - popHeight;
      if (pos.y < 0) {
        pos.y = 0;
        $pop.css({
          "max-height": winHeight + "px",
          "overflow-y": "auto"
        });
      }
    } else {
      pos.y = elTop - 36;
    }
    $pop.css({
      top: pos.y,
      left: pos.x
    });
  },
  aboutPermission: function aboutPermission($e) {
    var $lis = this.$('li').not('.f-hide').not('.p-help');
    var ids = [];
    for (var i = $lis.length - 1; i >= 0; i--) {
      ids.push($lis.eq(i).attr('role'));
    }
    _MDShareFilePermissionInfoView["default"].show({
      dispRoleIds: ids
    });
  },
  selectByIndex: function selectByIndex(index, opt_silent) {
    opt_silent = _.isBoolean(opt_silent) ? opt_silent : false;
    var oldIndex = this.index;
    if (index == oldIndex || index == -1) {
      return;
    }
    ;
    this.index = index;
    var item = this.bd[index];
    this.$(".m-hd .inner").text(item.label);
    // this.$(".m-hd .inner").attr('data-tooltip', item.label)

    this._curSelected = item;
    if (opt_silent) {
      return;
    }
    var self = this;
    _.isFunction(this.onChange) && this.onChange(item, function fail() {
      self.selectByIndex(oldIndex, true);
    });
  },
  updateLableByIndex: function updateLableByIndex(text, i) {
    this.$(".dropdowm-select-list ul li").eq(i).html(text);
    if (this.index == i) {
      this.$(".m-hd .inner").text(text);
      // this.$(".m-hd .inner").attr('data-tooltip', text)
    }
  },
  getDataByIndex: function getDataByIndex(index) {
    return this.bd[index];
  },
  viewDidUnRendered: function viewDidUnRendered() {
    this.$el.find(".dropdowm-select-list").css({
      "max-height": "auto",
      "overflow": "hide"
    });
    _MMViewBase["default"].prototype.viewDidUnRendered.call(this);
    $('body').off(this.$nsEventName("click"), this.removeList);
  }
});
var _default = exports["default"] = MDDropDownSelectRoleView;

},{"1184":1184,"1417":1417,"1454":1454,"1463":1463,"22":22,"692":692,"812":812}],692:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMFileInfoCollection = _interopRequireDefault(require(298));
var _MDPermisson = _interopRequireDefault(require(279));
var _MEAuthPanelView = _interopRequireDefault(require(129));
var _MDPopupHelpWindow = _interopRequireDefault(require(63));
/**
 *  window for share permission information
 *  WebContent/javascript/moladisk/views/file/share/MDShareFilePermissionInfoView.js
 *  Created by jichao
 *  2016.10.15
 */

var MDShareFilePermissionInfoView = _MDPopupHelpWindow["default"].extend({
  helpTmpl: "<div class=\"role-help\"></div>",
  events: function events() {
    var superE = _MDPopupHelpWindow["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click #close': this._close
    });
  },
  initProps: function initProps() {
    var superP = _MDPopupHelpWindow["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      invite: false
    });
  },
  className: function className() {
    var superCls = _MDPopupHelpWindow["default"].prototype.className.call(this);
    return superCls + ' help-role-win share-role';
  },
  initialize: function initialize(opt) {
    var self = this;
    opt.width = 925;
    opt.title = BabelStr.str(7292);
    _MDPopupHelpWindow["default"].prototype.initialize.call(this, opt);
    this.authPanel = new _MEAuthPanelView["default"]({
      disableEdit: true,
      tabIndex: 1,
      dispRoleIds: this.params && this.params.dispRoleIds
    });
    this.addSubView(this.authPanel, this.$('.role-help'));
  },
  _close: function _close() {
    this.close();
  }
}, {
  show: function show(params) {
    if (!MDShareFilePermissionInfoView.instance) {
      MDShareFilePermissionInfoView.instance = new MDShareFilePermissionInfoView({
        params: params,
        onClose: function onClose() {
          MDShareFilePermissionInfoView.instance = null;
        }
      });
      app.application.addSubView(MDShareFilePermissionInfoView.instance);
    }
  }
});
var _default = exports["default"] = MDShareFilePermissionInfoView;

},{"1184":1184,"129":129,"1454":1454,"279":279,"298":298,"63":63}],279:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  READ: 1,
  // 浏览
  CREATE: 2,
  // 创建目录，上传版本
  DOWNLOAD: Math.pow(2, 2),
  // 下载
  RENAME: Math.pow(2, 3),
  // 重命名
  DELETE: Math.pow(2, 4),
  // 删除
  COMMENT: Math.pow(2, 5),
  // 批注
  REVIEW: Math.pow(2, 6),
  // 评论
  SHARE: Math.pow(2, 7),
  // share
  ONLY_UPLOAD: Math.pow(2, 8),
  //仅上传
  INVITE: Math.pow(2, 9),
  // 邀请成员
  MANAGE: Math.pow(2, 10) // 管理成员
};

},{"1454":1454}],129:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1438);
require(1412);
require(1477);
require(1489);
require(1498);
require(1429);
require(1492);
require(1417);
require(1463);
require(1426);
require(1437);
require(1478);
require(1466);
require(1541);
require(1421);
require(1432);
require(1415);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MEAddRoleWinView = _interopRequireDefault(require(128));
var _MEReplaceRole = _interopRequireDefault(require(131));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDSwitchView = _interopRequireDefault(require(79));
var _MMViewBase2 = _interopRequireDefault(require(22));
var _MDSpinnerloaderLayerView = _interopRequireDefault(require(75));
var _MEAuthPanel = _interopRequireDefault(require(117));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDRole = _interopRequireDefault(require(280));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDMessageView = _interopRequireDefault(require(55));
var _keycode = _interopRequireDefault(require(104));
var _regexp = _interopRequireDefault(require(106));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**0
 * 权限管理面板
 * Created by jichao
 * 2016.12/7
 */
// 权限项 ？ 说明文案映射：键为服务端 filePermissions 数组下标，值为说明 str id（仅部门权限 tab 使用）
var FILE_PER_HELP_MAP = {
  2: 51380,
  // 查看别人文件的批注
  3: 51381,
  // 在别人文件上创建批注
  4: 51382,
  // 删除别人的批注
  5: 51383,
  // 查看子部门文件
  6: 51384,
  // 打印自己的文件(下载pdf)
  7: 51385,
  // 打印别人的文件(下载pdf)
  18: 51386,
  // 查看自己的文件日志
  19: 51387,
  // 查看别人的文件日志
  26: 51388,
  // 显示不可查看文件
  27: 51389,
  // 在线编辑自己的文件
  28: 51390,
  // 在线编辑别人的文件
  29: 51391,
  // 部门文件管理
  30: 51392 // 子部门管理
};
// 子项说明：键为子项词条 str id
var SEC_PER_HELP_MAP = {
  3414: 51393,
  // 管理文件访问控制
  3416: 51394,
  // 文件密级管理
  3417: 51395,
  // 批示分享请求
  3418: 51396 // 转换文件负责人
};
var MEAuthPanelView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MEAuthPanelView, _MMViewBase);
  function MEAuthPanelView() {
    (0, _classCallCheck2["default"])(this, MEAuthPanelView);
    return _callSuper(this, MEAuthPanelView, arguments);
  }
  (0, _createClass2["default"])(MEAuthPanelView, [{
    key: "tmpl",
    value: function tmpl() {
      return _MEAuthPanel["default"];
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEAuthPanelView.prototype), "className", this).call(this);
      return "".concat(superCls, " roleInfo");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEAuthPanelView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        data: [],
        //页面当前渲染所用的数据
        resultArr: [],
        //页面数据的备份（主要用与搜索后页面渲染数据的恢复）
        managerPermission: 0,
        filePermission: 0,
        filePermissionArr: [],
        managerPermissionArr: [],
        dispRoleIds: [],
        roleId: 0,
        _x: 0,
        _y: 0,
        _topRolebody: 0,
        _leftRoleBody: 0,
        _topContain: 0,
        _leftContain: 0,
        move: false,
        down: false,
        tabIndex: 0,
        needNumLine: true
        // showShareTab: true
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEAuthPanelView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .editor": this._clickToEdit,
        "click .del": this._clickToRemoveDep,
        "click .menu-r": this._menuRemove,
        "blur .menu-r": this._menuRemove,
        "click .addRole": this._addRole,
        "click .cancleAddRole": this._cancleAddRole,
        "click .per-help": this._showPerHelp,
        "keyup .search-c": this._searchByRoleName,
        "click #addRoleComit": this.addDepartmentRole,
        "click #editRole": this.changeRoleInfo,
        "click .toleft": this.scrollToLeft,
        "click .toright": this.scrollToRight,
        "mousedown .contain": this._mouseDown,
        "mouseup .contain": this._mouseUp,
        "mousemove .contain": this._mouseMove,
        "mousedown .role-body": this._mouseDown,
        "mouseup .role-body": this._mouseUp,
        "mousemove .role-body": this._mouseMove,
        // 'keyup .head-r': this._inputChange,
        // 'blur .head-r': this._inputBlur,
        'click input.head-r': this._inputClick,
        "click .js-replace-role": this._replaceRole,
        "click .dep-tab": this.deptabClickHandle,
        "click .share-tab": this.sharetabClickHandle,
        "click ": this._triggerSave
      });
    }
  }, {
    key: "_inputClick",
    value: function _inputClick($e) {
      $e.stopPropagation();
    }
  }, {
    key: "_triggerSave",
    value: function _triggerSave($e) {
      var $clickedElement = $($e.target);
      if (this.mode == 'normal') {
        return;
      }
      // 检查点击的目标是否是 #container 的子元素（如 .child-class）
      if ($clickedElement.hasClass("newtd") || $clickedElement.parents(".newtd").length) {
        console.log("点击发生在 .newtd 元素上或其内部");
        return;
      } else if ($clickedElement.hasClass("actived-edit") || $clickedElement.parents(".actived-edit").length) {
        console.log("点击发生在 .actived-edit 元素上或其内部");
        return;
      } else {
        console.log("点击发生在其他子元素上");
      }
      if (this.mode == 'add') {
        this.addDepartmentRole($e);
      } else if (this.mode == 'edit') {
        this.changeRoleInfo($e);
      }
      this.mode = 'saving';
    }
  }, {
    key: "triggerSave",
    value: function triggerSave($e, slient) {
      if (this.mode == 'normal') {
        return;
      }
      if (this.mode == 'add') {
        this.addDepartmentRole($e, slient);
      } else if (this.mode == 'edit') {
        this.changeRoleInfo($e, slient);
      }
      this.mode = 'saving';
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      var _this = this;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEAuthPanelView.prototype), "initialize", this).call(this, opt);
      this.bindSelf(this.documentKeyUpHandler);
      var event = this.$nsEventName("click");
      $(document).bind(event, function () {
        $(".menu-r").addClass("f-hide");
      });
      $("body").append('<span id="temporaryContain"></span>');
      $(document).on(this.$nsEventName("keyup"), function ($e) {
        _this.documentKeyUpHandler($e);
      });
      if (this.disableEdit) {
        this.$(".js-replace-role").remove();
        this.$(".addRole").remove();
        this.$(".role-head").remove();
      }
      if (this.showShareTab) {
        this.$(".js-replace-role").remove();
        this.$(".addRole").remove();
        this.$(".role-head").remove();
      }
      this.optView = new _MDSwitchView["default"]({
        onChange: function onChange(state) {
          _this._optViewOnchange(state);
        },
        checked: !!app.ep.getUseFileManager(),
        className: "tooltipped tooltipped-bc",
        attrs: {
          "aria-label": BabelStr.str(3425)
        }
      });
      this.optView.renderTo(this.$(".owner-ope"));
      this.useDefaultView = new _MDSwitchView["default"]({
        onChange: function onChange(state) {
          _this._useDefaultOnchange(state);
        },
        checked: !!app.ep.isUseDefaultRoles(),
        className: "tooltipped tooltipped-bc",
        attrs: {
          "aria-label": BabelStr.str(8576)
        }
      });
      this.useDefaultView.renderTo(this.$(".use-default-ope"));
      if (!app.currentUser.canManageEpRolelist()) {
        this.$(".js-per-judge").remove();
        this.optView.setDisabled(true);
      }
      _MMEnterpriseController["default"].isOnlyUseCustomShareRole(function (sign) {
        if (sign) {
          _this.useDefaultView.open(true);
        } else {
          _this.useDefaultView.close(true);
        }
      });
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        helpStr: _MDLocalString["default"].getLocalString(3091),
        addRoleStr: _MDLocalString["default"].getLocalString(3087),
        depMaanageRoleStr: this.getHeadTitle(),
        cancleStr: _MDLocalString["default"].getLocalString(3081),
        saveStr: _MDLocalString["default"].getLocalString(154)
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEAuthPanelView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "_optViewOnchange",
    value: function _optViewOnchange(state) {
      state = state ? 1 : 0;
      _MMEnterpriseController["default"].roleAndUsers.setEnterpriseUseFileManager(state, function () {
        _MDMessageView["default"].success(BabelStr.str(308));
        app.ep.setUseFileManager(state);
      }, function () {
        _MDMessageView["default"].error(BabelStr.str(309));
      });
    }
  }, {
    key: "_useDefaultOnchange",
    value: function _useDefaultOnchange(state) {
      var _this2 = this;
      var flag = state ? 1 : 0;
      _MMEnterpriseController["default"].setEnterpriseAttrByBit(7, flag, function () {
        _MDMessageView["default"].success(BabelStr.str(308));
        _this2.getSharePermission();
      }, function () {
        if (state) {
          _this2.useDefaultView.close(true);
          // MDMessageView.error(BabelStr.str(309));
        } else {
          _this2.useDefaultView.open(true);
          // MDMessageView.error(BabelStr.str(309));
        }
      });
    }
  }, {
    key: "scrollToLeft",
    value: function scrollToLeft() {
      var contain = this.$(".role-body .contain");
      var left = contain.scrollLeft();
      var scorll_delta = 400;
      left -= scorll_delta;
      contain.scrollLeft(left);
      // var temp = 'translateX(-'+left+'px)'
      // this.$(".scroll-table").css({
      //   "transform":temp
      // });
    }
  }, {
    key: "documentKeyUpHandler",
    value: function documentKeyUpHandler($e) {
      if (_keycode["default"].isEscKey($e.which)) {
        this._cancleAddRole($e);
      }
    }
  }, {
    key: "scrollToRight",
    value: function scrollToRight() {
      var contain = this.$(".role-body .contain");
      var left = contain.scrollLeft();
      var scorll_delta = 400;
      left += scorll_delta;
      contain.scrollLeft(left);
      left = contain.scrollLeft();
      // var temp = 'translateX(-'+left+'px)'
      // this.$(".scroll-table").css({
      //   "transform":temp
      // });
    }
  }, {
    key: "getHeadTitle",
    value: function getHeadTitle() {
      var num = 3092;
      if (this.tabIndex == 1) {
        num = 3702;
      }
      return BabelStr.str(num);
    }
  }, {
    key: "initLeftHead",
    value: function initLeftHead(filePermissions, managerPermissions, forFilePermission) {
      if (this.needNumLine) {
        this.$el.removeClass("del-num-line");
      } else {
        this.$el.addClass("del-num-line");
      }
      this.$(".scroll-head").html(this.getHeadTitle());
      var per;
      var str = "<li class=\"head\"><div class=\"rt-head\">".concat(BabelStr.str(158), "</div> <div class='diagonal-line'></div> <div class=\"lb-head\">").concat(BabelStr.str(4743), "</div></li>");
      this.$(".scroll-head").html("<div class=\"rt-head\">".concat(BabelStr.str(158), "</div> <div class='diagonal-line'></div> <div class=\"lb-head\">").concat(BabelStr.str(4743), "</div>"));
      var str2 = '<tr class="head"></tr>';
      var result;
      this.filePermissionArr = [];
      this.managerPermissionArr = [];
      this.$(".left").html("");
      this.$("#roleInfoShow").html("");
      var tooltip;
      var helpLine;
      var cls = "";
      var perName;
      for (var i = 0; i < filePermissions.length; i++) {
        perName = filePermissions[i];
        if (forFilePermission && i == 8) {
          // 词条来自服务端（多语言），仅按位置拆出尾部括注（如"(含在线编辑)"）独立成行
          var suffixMatch = perName.match(/[(（][^)）]+[)）]\s*$/);
          var suffix = suffixMatch ? suffixMatch[0] : "";
          if (suffixMatch) {
            perName = perName.slice(0, suffixMatch.index).trim();
          }
          tooltip = "";
          helpLine = "<div class=\"per-edit\">".concat(BabelStr.str(8568), "</div>") + (suffix ? "<div class=\"per-suffix\">".concat(suffix, "</div>") : "") + "<div class=\"per-tag\">".concat(BabelStr.str(6906), "</div>");
          cls = "special-per";
        } else {
          tooltip = "";
          helpLine = "";
          cls = "middle-ellipsis";
        }
        // 部门权限 tab：按下标挂 ？ 说明（下标与服务端 filePermissions 数组约定一致）
        var helpBtn = "";
        if (!forFilePermission && FILE_PER_HELP_MAP[i]) {
          helpBtn = this.getPerHelpBtn(perName, FILE_PER_HELP_MAP[i]);
        }
        if (filePermissions[i]) {
          // middle-ellipsis 截断器会用 textContent 整体重写 li 内容，？ 按钮必须放在截断 span 外
          var nameHtml = helpBtn ? '<span class="middle-ellipsis">' + perName + "</span>" : perName;
          str += '<li class="' + (helpBtn ? "" : cls) + '">' + tooltip + nameHtml + helpBtn + helpLine + " </li>";
          str2 += '<tr index="' + i + '" class="raw"></tr>';
        } else {
          str += '<li class="f-none">' + i + filePermissions[i] + " </li>";
          str2 += '<tr index="' + '" class="raw f-none"></tr>';
        }

        // if(i < 4) {
        result = this.getSecLeftHead(i);
        str += result.result;
        str2 += result.result2;
        // }

        per = Math.pow(2, i);
        this.filePermissionArr.push(per);
      }
      this.manageHide = [];
      for (i = 0; i < managerPermissions.length; i++) {
        var index = this.filePermissionArr.length + i;
        if (managerPermissions[i]) {
          str += "<li>" + managerPermissions[i] + " </li>";
          str2 += '<tr index="' + index + '" class="raw"></tr>';
        } else {
          str += '<li class="f-none">' + managerPermissions[i] + " </li>";
          str2 += '<tr index="' + index + '" class="raw f-none"></tr>';
          this.manageHide.push(index); // 隐藏的管理项
        }
        per = Math.pow(2, i);
        this.managerPermissionArr.push(per);
      }
      str += '<li class="num">' + BabelStr.str(3252) + "</li>";
      str2 += '<tr class="num"></tr>';
      this.$(".left").append(str);
      this.$("#roleInfoShow").append(str2);

      // manageHide: [27, 29, 30, 31, 32 , 33, 34, 35] // 管理权限[1 ,3,4,5,6,7]每一位加文件权限列表长度（25）

      // manager permission 只允许第 1 个显示， 第 0 个 以及其他的都隐藏
      // this.manageHide = [];
      // var manageLiStartIndex = this.filePermissionArr.length;
      // for (var i = 0; i < this.managerPermissionArr.length; i++) {
      //   if (i != 1 && i != 4 && i != 5 && i != 7) {
      //     this.manageHide.push(manageLiStartIndex + i);
      //   };
      // };
    }
  }, {
    key: "getSecLeftHead",
    value: function getSecLeftHead(per) {
      var _this3 = this;
      var result = "";
      var result2 = "";
      var numArr = this.getSecNum(per);
      _.each(numArr, function (item) {
        var secHelp = SEC_PER_HELP_MAP[item] ? _this3.getPerHelpBtn(BabelStr.str(item), SEC_PER_HELP_MAP[item]) : "";
        result += "<li class=\"sec-li\" data-parentindex=\"".concat(per, "\">").concat(BabelStr.str(item)).concat(secHelp, "</li>");
        result2 += "<tr data-parentindex=\"".concat(per, "\" class=\"raw disabled\"></tr> ");
      });
      return {
        result: result,
        result2: result2
      };
    }

    // 权限项 ？ 说明：键为 filePermissions 数组下标，值为说明文案 str id（仅部门权限 tab）
  }, {
    key: "getPerHelpBtn",
    value: function getPerHelpBtn(name, strId) {
      var safe = String(name).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;");
      return "<span class=\"per-help\" data-str=\"".concat(strId, "\" data-name=\"").concat(safe, "\">") + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M9.6 9a2.5 2.5 0 0 1 4.8 1c0 1.7-2.4 2-2.4 3.5"/><path d="M12 16.8h.01"/></svg>' + "</span>";
    }
  }, {
    key: "_showPerHelp",
    value: function _showPerHelp($e) {
      var _this4 = this;
      var $btn = $($e.currentTarget);
      var $exist = $(".per-help-pop");
      // 再次点击同一按钮 = 关闭
      if ($exist.length && $exist.data("btn") === $btn[0]) {
        this._closePerHelp();
        return;
      }
      this._closePerHelp();
      var $pop = $('<div class="per-help-pop">' + '<span class="per-help-close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="m6 6 12 12M18 6 6 18"/></svg></span>' + "<strong></strong><p></p></div>");
      $pop.find("strong").text($btn.data("name"));
      $pop.find("p").text(BabelStr.str($btn.data("str")));
      $pop.data("btn", $btn[0]);
      $("body").append($pop);
      var rect = $btn[0].getBoundingClientRect();
      var w = $pop.outerWidth();
      var h = $pop.outerHeight();
      var left = Math.max(12, Math.min(rect.left, window.innerWidth - w - 12));
      var below = rect.bottom + 8;
      var top = below + h <= window.innerHeight - 12 ? below : Math.max(12, rect.top - h - 8);
      $pop.css({
        left: left,
        top: top
      });
      $pop.on("click", ".per-help-close", function () {
        return _this4._closePerHelp();
      });
      // 注意用 .on 而非 .one：打开气泡的点击会冒泡到这里触发一次 guard 分支，
      // .one 会把这个监听消耗掉，导致之后点空白处不再关闭
      $(document).on("click.perHelp", function ($ev) {
        // 点到其他 ？ 按钮时交给 _showPerHelp 切换，不在这里误关新气泡
        if (!$pop[0].contains($ev.target) && !$($ev.target).closest(".per-help").length) {
          _this4._closePerHelp();
        }
      });
      $(document).one("keydown.perHelp", function ($ev) {
        if ($ev.key === "Escape") _this4._closePerHelp();
      });
      $(window).one("scroll.perHelp resize.perHelp", function () {
        return _this4._closePerHelp();
      });
    }
  }, {
    key: "_closePerHelp",
    value: function _closePerHelp() {
      $(".per-help-pop").remove();
      $(document).off(".perHelp");
      $(window).off(".perHelp");
    }
  }, {
    key: "getSecNum",
    value: function getSecNum(per) {
      var numArr = [];
      switch (per) {
        case 30:
          numArr = [3410, 3411, 3412];
          break;
        case 29:
          numArr = [3414, 3415, 3416, 3417, 3418, 3419];
          break;
        case 27:
          numArr = [3420, 3421];
          break;
        case 28:
          numArr = [3422, 3423];
          break;
      }
      return numArr;
    }
  }, {
    key: "getcheckboxTmpl",
    value: function getcheckboxTmpl(checked, disabled, per) {
      var str;
      if (checked) {
        if (disabled) {
          str = '<td class="roleItetdm"><div data-per="' + per + '" class="checkbox disabled checked"></div></td>';
        } else {
          str = '<td class="roleItem"><div data-per="' + per + '" class="checkbox checked"></div></td>';
        }
      } else {
        if (disabled) {
          str = '<td class="roleItem"><div data-per="' + per + '" class="checkbox disabled"></div></td>';
        } else {
          str = '<td class="roleItem"><div data-per="' + per + '" class="checkbox"></div></td>';
        }
      }
      return str;
    }
  }, {
    key: "showRolesInfo",
    value: function showRolesInfo(data) {
      var _this5 = this;
      this.resize();
      var tableRow = this.$("#roleInfoShow tr");
      var tableContain = this.$(".scroll-table tr");
      this.$(".addRole").prop("disabled", false);
      var str = "";
      var index;
      var width = 0;
      var curWidth = 0;
      var str1 = "";
      var temp = 0;
      var tableRowIndex;
      var name;
      for (var i = 0; i < tableRow.length; i++) {
        tableRow.eq(i).html("");
      }
      tableContain.eq(0).html("");
      $("#temporaryContain").html("");
      for (var i = 0; i < data.length; i++) {
        curWidth = $("#temporaryContain").width() + 30;
        curWidth = curWidth < 80 ? 80 : curWidth;
        // curWidth = curWidth > 120 ? 120 : curWidth;
        width += curWidth;
        index = i;
        name = this.tabIndex ? data[i].get("description") : data[i].get("name");
        $("#temporaryContain").html(name);
        var roleInfo = data[i];
        var classForFolder = roleInfo.onlyForFolder && roleInfo.onlyForFolder() ? "folder" : "";
        if (data[i].get("enterpriseId") == 0) {
          name = data[i].get("name");
          str1 = "";
          str = '<td class="role" roleId = "' + roleInfo.get("id") + '" > \
                  <div class="manage text-hide ' + classForFolder + '">' + name + "</div>" + str1 + "</td>";
        } else {
          var candelStr = "";
          if (!data[i].get("default")) {
            candelStr = '<li class= "del"  index="' + index + '">' + BabelStr.str(32) + "</li>";
          }
          if (this.disableEdit) {
            str = '<td class="role" roleId = "' + data[i].get("id") + '"><div class="manage ' + classForFolder + '  text-hide">' + name + "</div></td>";
          } else {
            str1 = '<input  class="head-r f-hide" type="text" maxlength="30" disable="disable" value="' + name + '"/> \
                  <ul class = "f-hide  menu-r">\
                    <li class = "editor" index="' + index + '">' + BabelStr.str(2503) + "</li>" + candelStr + "</ul>";
            str = '<td class="role" roleId = "' + data[i].get("id") + '"><div class="manage ' + classForFolder + ' text-hide"><span class = "sign more-sign">' + name + "</span></div>" + str1 + "</td>";
          }
        }
        tableRow.eq(0).append(str);
        tableContain.eq(0).append(str);
        for (var j = 0, tableRowIndex = 0; j < this.filePermissionArr.length; j++) {
          tableRowIndex++;
          var checkboxState = this.filePermissionArr[j] & data[i].get("filePermission");
          str = this.getcheckboxTmpl(checkboxState, data[i].get("enterpriseId") == 0, j);
          tableRow.eq(tableRowIndex).append(str);
          var secArr = this.getSecNum(j);
          for (var h = 1; h <= secArr.length; h++) {
            tableRowIndex++;
            str = this.getcheckboxTmpl(checkboxState, true, j);
            tableRow.eq(tableRowIndex).append(str);
          }
        }
        for (j = 0; j < this.managerPermissionArr.length; j++) {
          tableRowIndex++;
          var _checkboxState = this.managerPermissionArr[j] & data[i].get("managerPermission");
          str = this.getcheckboxTmpl(_checkboxState, data[i].get("enterpriseId") == 0, j);
          // if (this.managerPermissionArr[j] & data[i].get("managerPermission")) {
          //   if (data[i].get("enterpriseId") == 0) {
          //     str = '<td class="roleItem"><div class="checkbox checked-0"></div></td>';
          //   } else {
          //     str = '<td class="roleItem"><div class="checkbox checked"></div></td>';
          //   }

          // } else {
          //   str = '<td class="roleItem"><div class="checkbox"></div></td>';
          // }

          tableRow.eq(tableRowIndex).append(str);
        }
      }
      var objLefts = this.$(".role-body .left li");
      var objTabletrs = this.$("#roleInfoShow tr");
      // for (var i = 0; i < this.manageHide.length; i++) {
      //   objLefts.eq(this.manageHide[i] + 1).hide();
      //   objTabletrs.eq(this.manageHide[i] + 1).hide();
      // }
      this.showRoleNnum(data);
      var minW = this.$(".contain").width() - 10;
      if (width <= minW) {
        var tdsHead = tableContain.eq(0).find("td");
        var tdsInner = tableRow.eq(0).find("td");
        var l = tdsHead.length;
        var perW = 1 / l * 100;
        tdsHead.map(function (index, td) {
          $(td).css({
            width: perW + "%"
            // "width": "calc(" + perW + '%' + "- 2px)"
          });
        });
        tdsInner.map(function (index, td) {
          $(td).css({
            width: perW + "%"
            // "width": "calc(" + perW + '%' + "- 2px)"
          });
        });
      }
      width = width > minW ? width : minW;
      this.$("#roleInfoShow").width(width);
      this.$(".scroll-table ").width(width);
      var w = this.$el.width() - this.$(".role-body-inner .left").width();
      if (width > w) {
        this.$(".role-ope").show();
      } else {
        this.$(".role-ope").hide();
      }
      _MDSpinnerloaderLayerView["default"].clearFrom(this.el);
      this.$(".role-main").css({
        visibility: "visible"
      });
      // this.$(".foot-ope .commit").prop("disabled", false);
      // this.$(".foot-add .commit").prop("disabled", true);
      if (app.currentUser.canManageEpRolelist()) {
        this.$(".manage").on("click", function ($e) {
          _this5._clickRoleHead($e);
        });
      }
      this.resize();
    }
  }, {
    key: "showRoleNnum",
    value: function showRoleNnum(data) {
      // this.$(".role-body .left li:last-child").prev().css({
      //   "border-bottom" : "solid 1px #d4d4d4;"
      // });
      this.mode = 'normal';
      this.$(".num").show();
      this.$(".foot-ope").hide();
      this.$(".foot-add").hide();
      this.$el.css({
        bottom: "0"
      });
      this.$(".role-body").css({
        "margin-bottom": "20px"
      });
      if (this.disableEdit) {
        this.$(".role-body").css({
          "margin-bottom": "20px"
        });
      }
      var tablef = this.$("#roleInfoShow .num");
      this.$(".left .num").html(BabelStr.str(3252));
      this.$("#roleInfoShow .num").html("");
      var str;
      // if(this.needNumLine) {
      for (var i = 0; i < data.length; i++) {
        str = "<td>" + data[i].get("count") + "</td>";
        tablef.append(str);
        // }
      }
    }
  }, {
    key: "checkRole",
    value: function checkRole($e) {
      var index = $($e.target).closest("tr").attr("index") - 0;
      var len1 = this.filePermissionArr.length;
      if ($($e.target).hasClass("checked")) {
        $($e.target).removeClass("checked");
        if (index > len1) {
          index = index - len1;
          this.removeManagePermissionValidate(index);
          this.managerPermission = MEAuthPanelView.changeBitToFalse(index, this.managerPermission);
        } else {
          index = index;
          this.removeFilePermissionValidate(index);
          this.filePermission = MEAuthPanelView.changeBitToFalse(index, this.filePermission);
        }
      } else {
        $($e.target).addClass("checked");
        if (index > len1) {
          index = index - len1;
          this.addManagePermissionValidate(index);
          this.managerPermission = MEAuthPanelView.changeBitToTrue(index, this.managerPermission);
        } else {
          index = index;
          this.addFilePermissionValidate(index);
          // this.filePermissionChangedArr.push(index);
          this.filePermission = MEAuthPanelView.changeBitToTrue(index, this.filePermission);
        }
      }
      console.log("filePermissionA:" + this.filePermission.toString(2) + "    managerPermission:" + this.managerPermission);
    }
    /*
      权限联动规则：
        文件权限{
          1 <-- 2 , 3 , 4 , 5 , 6 , 7 , 8 , 9 , 10 , 11 , 12 , 13 , 14 , 15 , 16 , 17 , 18 , 19 , 20 , 23
          4 <-- 5 , 9 , 10
          5 <-- 10
          9 <-- 10
          11 <-- 12
          13 <-- 14
          15 <-- 16 , 17 , 18
          6 <-- 7
          2 <-- 20 , 23
          20 <-- 23
         }
        管理权限{
          0 <-- 6 , 8 , 10 , 12 , 13 , 14 , 15 , 16 , 17 ,  18
          1 <-- 2 , 3 , 4 , 5 , 6
          3 <-- 4 , 5 , 6
          5 <-- 6
          7 <-- 8
          9 <-- 10
          11 <--12 , 6
        }
         */
  }, {
    key: "addFilePermissionValidate",
    value: function addFilePermissionValidate(index) {
      if (this.tabIndex == 1) {
        this.addSharePermissionValidate(index);
        return;
      }
      var self = this;
      var elevantArr = [];
      switch (index) {
        case 2:
        case 5:
        case 7:
        case 9:
        case 11:
        case 13:
        case 15:
        case 17:
        case 19:
        case 20:
          elevantArr = [0];
          break;
        case 3:
          elevantArr = [0, 2];
          break;
        case 4:
          elevantArr = [2];
          break;
        case 30:
          elevantArr = [5];
          break;
        case 16:
          elevantArr = [4];
          break;
        case 27:
          elevantArr = [1];
          break;
        case 28:
          elevantArr = [0, 1];
          break;
        case 29:
          elevantArr = [0, 2, 3, 4, 6, 8, 9, 10, 11, 12, 14, 16, 18, 19, 27, 28];
          break;
      }
      elevantArr.push(index);
      elevantArr.map(function (i) {
        self.filePermission = MEAuthPanelView.changeBitToTrue(i, self.filePermission);
        self.$(".checkbox.actived-edit[data-per=".concat(i, "]")).addClass("checked");
      });
    }
  }, {
    key: "removeFilePermissionValidate",
    value: function removeFilePermissionValidate(index) {
      if (this.tabIndex == 1) {
        this._removeSharePermissionValidate(index);
        return;
      }
      var self = this;
      var elevantArr = [];
      switch (index) {
        case 0:
          elevantArr = [2, 3, 5, 7, 9, 11, 13, 15, 17, 19, 20, 28, 29];
          break;
        case 1:
          elevantArr = [27, 28];
          break;
        case 2:
          elevantArr = [3, 29, 4];
          break;
        case 5:
          elevantArr = [30];
          break;
        case 4:
          elevantArr = [29];
          break;
        case 18:
        case 19:
          elevantArr = [29];
          break;
        case 8:
          elevantArr = [29];
          break;
        case 9:
          elevantArr = [29];
          break;
        case 27:
          elevantArr = [29];
          break;
        case 3:
        case 6:
        case 10:
        case 11:
        case 12:
        case 14:
        case 16:
          elevantArr = [29];
          break;
      }
      elevantArr.push(index);
      elevantArr.map(function (i) {
        self.filePermission = MEAuthPanelView.changeBitToFalse(i, self.filePermission);
        self.$(".checkbox.actived-edit[data-per=".concat(i, "]")).removeClass("checked");
      });
    }
  }, {
    key: "addSharePermissionValidate",
    value: function addSharePermissionValidate(index) {
      var self = this;
      var elevantArr = [];
      switch (index) {
        case 1: // 上传
        case 2:
        case 3: // 删除
        case 4: // 重命名
        case 5:
        case 6:
        case 7:
        case 9:
        case 11:
          elevantArr = [0];
          break;
        case 10:
          // 移动
          elevantArr = [0, 1];
          break;
      }
      elevantArr.push(index);
      elevantArr.map(function (i) {
        self.filePermission = MEAuthPanelView.changeBitToTrue(i, self.filePermission);
        self.$(".checkbox.actived-edit[data-per=".concat(i, "]")).addClass("checked");
      });
      if (index == 8) {
        var disArr = [1, 3, 4, 10];
        disArr.map(function (i) {
          self.filePermission = MEAuthPanelView.changeBitToFalse(i, self.filePermission);
          self.$(".checkbox.actived-edit[data-per=".concat(i, "]")).removeClass("checked");
        });
      } else if (index == 1 || index == 3 || index == 4 || index == 10) {
        // 上传，删除，重命名， 移动与“仅上传自己的文件”矛盾
        self.filePermission = MEAuthPanelView.changeBitToFalse(8, self.filePermission);
        self.$(".checkbox.actived-edit[data-per=".concat(8, "]")).removeClass("checked");
      }
      if (index == 12) {
        //仅查看文件名与其他权限互斥
        var _disArr = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
        _disArr.map(function (i) {
          self.filePermission = MEAuthPanelView.changeBitToFalse(i, self.filePermission);
          self.$(".checkbox.actived-edit[data-per=".concat(i, "]")).removeClass("checked");
        });
      } else {
        var _disArr2 = [12];
        _disArr2.map(function (i) {
          self.filePermission = MEAuthPanelView.changeBitToFalse(i, self.filePermission);
          self.$(".checkbox.actived-edit[data-per=".concat(i, "]")).removeClass("checked");
        });
      }
    }
  }, {
    key: "_removeSharePermissionValidate",
    value: function _removeSharePermissionValidate(index) {
      var self = this;
      var elevantArr = [];
      switch (index) {
        case 0:
          elevantArr = [1, 2, 3, 4, 5, 6, 7, 9, 10, 11];
          break;
        case 1:
          elevantArr = [10];
          break;
      }
      elevantArr.push(index);
      elevantArr.map(function (i) {
        self.filePermission = MEAuthPanelView.changeBitToFalse(i, self.filePermission);
        self.$(".checkbox.actived-edit[data-per=".concat(i, "]")).removeClass("checked");
      });
    }
  }, {
    key: "addManagePermissionValidate",
    value: function addManagePermissionValidate(index) {
      var self = this;
      var checkboxArr = this.$(".checkbox.actived");
      var len1 = this.filePermissionArr.length;
      var elevantArr = [];
      switch (index) {
        case 9:
          elevantArr = [1];
          break;
          break;
      }
      elevantArr.map(function (i) {
        self.managerPermission = MEAuthPanelView.changeBitToTrue(i, self.managerPermission);
        checkboxArr.eq(i + len1).addClass("checked");
      });
    }
  }, {
    key: "removeManagePermissionValidate",
    value: function removeManagePermissionValidate(index) {
      var self = this;
      var checkboxArr = this.$(".checkbox.actived");
      var len1 = this.filePermissionArr.length;
      var elevantArr = [];
      switch (index) {
        case 1:
          elevantArr = [9];
          break;
      }
      elevantArr.map(function (i) {
        self.managerPermission = MEAuthPanelView.changeBitToFalse(i, self.managerPermission);
        checkboxArr.eq(i + len1).removeClass("checked");
      });
    }
  }, {
    key: "_clickRoleHead",
    value: function _clickRoleHead($e) {
      $e.stopPropagation();
      // this.$el.click()
      this.triggerSave($e, true);
      var parent = $e.currentTarget.parentNode;
      $(parent).siblings().find(".menu-r").addClass("f-hide");
      $($e.currentTarget).siblings(".menu-r").toggleClass("f-hide");
      var contain = this.$("#roleInfoShow");
      // var posX = MMCommonFun.convertPointBetweenElements(parent, contain[0], { x: 0, y: 0 }).x;
      // var left = posX + "px";
      // $($e.currentTarget).siblings(".menu-r").css("left", left);
      this.$(".scroll-contain .scroll-table-contain").css({
        height: "150px"
      });
    }
  }, {
    key: "_clickToEdit",
    value: function _clickToEdit($e) {
      $e.stopPropagation();
      var index = parseInt($e.target.getAttribute("index"));
      this._startEdit(index);
      // var parentNode = $($e.currentTarget).closest('.role');
      var parentNode = this.$(".scroll-table .head .role").eq(index);
      parentNode.find(".manage").addClass("f-hide");
      parentNode.siblings().removeClass("backg");
      parentNode.find(".head-r").removeClass("f-hide");
      parentNode.find(".head-r").focus();
      parentNode.find(".head-r").val(parentNode.find(".head-r").val());
      parentNode.addClass("backg");
      parentNode.siblings().find(".head-r").addClass("f-hide");
      parentNode.siblings().find(".manage").removeClass("f-hide");
      this.$(".scroll-contain .scroll-table-contain").css({
        height: "50px"
      });
    }
  }, {
    key: "_startEdit",
    value: function _startEdit(index) {
      var _this6 = this;
      // 列的标号

      this.filePermission = this.data[index].get("filePermission");
      this.managerPermission = this.data[index].get("managerPermission");
      this.roleId = this.data[index].get("id");
      this.showRolesInfo(this.data);
      this.mode = 'edit';
      var objs = this.$("#roleInfoShow tr");
      var tableContain = this.$(".scroll-table tr");
      var tds;
      var obj;
      this.$(".addRole").prop("disabled", false);
      var objtd = objs.eq(0).find("td").eq(index);
      objtd.find(".head-r").width(objtd.width());
      tableContain.eq(0).find("td").eq(index).find(".head-r").width(objtd.find(".manage").width() + 2);
      tableContain.eq(0).find("td").eq(index).width(120);
      for (var i = 1; i < objs.length; i++) {
        obj = objs.eq(i).find("td").eq(index).find(".checkbox");
        if (objs.eq(i).hasClass("disabled")) {
          obj.addClass("actived-edit");
          continue;
        } else {
          obj.addClass("actived");
          obj.addClass("actived-edit");
        }
        obj.on("click", function ($e) {
          _this6.checkRole($e);
        });
      }
      this.$(".num").hide();
      // this.$(".role-body .left li:last-child").prev().css({
      //   "border-bottom" : "none"
      // });
      this.$(".foot-ope").show();
      this.$el.css({
        bottom: "48px"
      });
      // var footOpe = this.$("#roleInfoShow .num");
      // var lengthR, lengthL, str, strL, strR;
      // lengthL = index - 1;
      // lengthR = this.$("#roleInfoShow .num td").length - index - 1;
      // if (lengthR > 0) {
      //   strR = '<td class="fill" colspan="' + lengthR + '">';
      // }
      // if (lengthL > 0) {
      //   strL = '<td class="fill" colspan="' + lengthL + '">';
      // } else {
      //   strL = "";
      // }
      // if (index > 0) {
      //   str = strL + '<td class = "cancleAddRole">取消</td><td id = "editRole" class = "commit">确定</td>' + strR;
      // } else {

      //   str = '<td id = "editRole" class = "commit">确定</td><td class = "cancleAddRole">取消</td>' + strR;
      // }

      // footOpe.html(str);
      // this.$(".left .num").html("");
      // this.$(".left .num").css("boorder-right", "none");
      var contain = this.$("#roleInfoShow");
      var fcur = $("#roleInfoShow tr").eq(0).find("td").eq(index);
      var posX = _MMCommonFun["default"].convertPointBetweenElements(fcur[0], contain[0], {
        x: 0,
        y: 0
      }).x;
      contain.parent()[0].scrollLeft = posX - 200;
    }
  }, {
    key: "scrollContainHandle",
    value: function scrollContainHandle($e) {}
  }, {
    key: "_finishEdit",
    value: function _finishEdit(index) {
      var objs = this.$("#roleInfoShow tr");
      var tds, obj;
      for (var i = 1; i < objs.length; i++) {
        obj = objs.eq(i).find("td").eq(index).find(".checkbox");
        obj.off("click", this.checkRole);
      }
    }
  }, {
    key: "_menuRemove",
    value: function _menuRemove($e) {
      this.$(".menu-r").addClass("f-hide");
    }
  }, {
    key: "_getDataIndex",
    value: function _getDataIndex(id, data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].get("id") == id) {
          return i;
        }
      }
    }
  }, {
    key: "_clickToRemoveDep",
    value: function _clickToRemoveDep($e) {
      var _this7 = this;
      var id = $($e.target).closest(".role").attr("roleId");
      var alert = new _MDAlertView["default"]();
      var name = $($e.target).closest(".role").find(".manage .sign").text();
      name = _.escape(name);
      var num = 3253;
      if (this.tabIndex == 0) {
        num = 6581;
      }
      alert.show({
        title: BabelStr.str(170),
        message: "".concat(BabelStr.str(num), " - <strong>").concat(name, "</strong> ?"),
        buttons: [{
          label: BabelStr.str(3096),
          type: "done",
          onClick: function onClick() {
            _this7.delDepartmentRole(id);
          }
        }, {
          label: BabelStr.str(155)
        }]
      });
    }
  }, {
    key: "_addRole",
    value: function _addRole() {
      var _this8 = this;
      if (this.data.length) {
        var addRoleWinView = new _MEAddRoleWinView["default"]({
          addRoleCallback: function addRoleCallback(style, roleId) {
            _this8.addRoleCallback(style, roleId);
          },
          data: this.data,
          isDepRole: !this.tabIndex
        });
        addRoleWinView.show();
      } else {
        this.addRoleCallback(0, undefined);
      }

      // this.$(".addRole").hide();
    }
  }, {
    key: "addRoleCallback",
    value: function addRoleCallback(style, roleId) {
      var _this9 = this;
      if (style == 0) {
        this.filePermission = 0;
        this.managerPermission = 0;
      } else {
        var role = _.findWhere(this.data, {
          id: roleId
        });
        this.filePermission = role.get("filePermission");
        this.managerPermission = role.get("managerPermission");
      }
      this.mode = 'add';
      this.showRolesInfo(this.data);
      this.$(".cancleAddRole").removeClass("f-hide");
      this.$(".addRole").prop("disabled", true);
      var tableRow = this.$("#roleInfoShow tr").not(".num");
      var tableContain = this.$(".scroll-table tr");
      // var str = '<td class="role backg newtd" > <input  class=  "head-r" type="text" value="" placeholder="角色名称"/> </td>';
      var _Num = 7515;
      if (this.tabIndex == 1) {
        _Num = 6582;
      }
      var str = '<td class="role backg newtd" > <input maxlength="30"  class="head-r" type="text" placeholder="' + BabelStr.str(_Num) + '"/> </td>';
      tableRow.eq(0).append(str);
      tableContain.eq(0).append(str);
      var checkedStr;
      var $str = $(str);
      var $checkedStr = $(checkedStr);
      var tdIndex = 0;
      for (var i = 0; i < this.filePermissionArr.length; i++) {
        str = '<td class="roleItem newtd"><div data-per="' + i + '" class="checkbox actived-edit actived" </div></td>';
        checkedStr = '<td class="roleItem newtd"><div data-per="' + i + '" class="checkbox actived actived-edit checked" </div></td>';
        var hasChecked = this.filePermissionArr[i] & this.filePermission;
        if (hasChecked) {
          tableRow.not(".head").eq(tdIndex).append(checkedStr);
        } else {
          tableRow.not(".head").eq(tdIndex).append(str);
        }
        var secArr = this.getSecNum(i);
        for (var h = 1; h <= secArr.length; h++) {
          tdIndex++;
          var $disabledTd = void 0;
          if (tableRow.not(".head").eq(tdIndex).hasClass("disabled")) {
            $disabledTd = $("<td class=\"roleItem newtd\"><div data-per=\"".concat(i, "\" class=\"checkbox actived-edit disabled\" </div></td>"));
            if (hasChecked) {
              $disabledTd.find(".checkbox").addClass("checked");
            }
          }
          tableRow.not(".head").eq(tdIndex).append($disabledTd);
        }
        tdIndex++;
      }
      var len = this.filePermissionArr.length;
      for (var x = 0; x < this.managerPermissionArr.length; x++) {
        if (this.managerPermissionArr[x] & this.managerPermission) {
          tableRow.not(".head").eq(tdIndex).append(checkedStr);
        } else {
          tableRow.not(".head").eq(tdIndex).append(str);
        }
        tdIndex++;
      }
      tableRow.find(".newtd .checkbox").not(".disabled").on("click", function ($e) {
        _this9.checkRole($e);
      });
      this.$(".num").hide();
      this.$(".role-body .left li:last-child").prev().css({
        "border-bottom": "none"
      });
      this.$(".foot-add").show();
      this.$el.css({
        bottom: "40px"
      });
      tableContain.eq(0).find(".head-r").focus();
      this.$(".role-body").css({
        "margin-bottom": "48px"
      });
      var contain = this.$("#roleInfoShow");
      contain.parent()[0].scrollLeft = 10000;
    }
  }, {
    key: "_cancleAddRole",
    value: function _cancleAddRole($e) {
      $e.stopPropagation();
      this.showRolesInfo(this.data);
    }
  }, {
    key: "_inputChange",
    value: function _inputChange($e) {
      if ($($e.target).val().length > 0) {
        this.$(".commit").prop("disabled", false);
      } else {
        this.$(".commit").prop("disabled", true);
      }
    }
  }, {
    key: "_inputBlur",
    value: function _inputBlur($e) {
      if ($($e.target).val().length <= 0) {
        _MDAlertView["default"].showStandardPrompt({
          message: "<p>" + BabelStr.str(6227) + "</p>",
          width: 400,
          okFun: function okFun() {
            setTimeout(function () {
              $($e.currentTarget).focus();
            }, 500);
          }
        });
      }
    }
  }, {
    key: "_searchByRoleName",
    value: function _searchByRoleName() {
      this.data = [];
      var str = this.$("#search").val();
      var temp = 0;
      if (str.length == 0) {
        this.showRolesInfo(this.resultArr);
        return;
      } else {
        for (var i = 0; i < this.resultArr.length; i++) {
          if (this.resultArr[i].get("name").indexOf(str) > -1) {
            this.data.unshift(this.resultArr[i]);
            temp++;
          } else {
            this.data.push(this.resultArr[i]);
          }
        }
        if (temp > 0) {
          //temp = 0 时,data中数据索引没有发生改变
          this.showRolesInfo(this.data);
        }
      }
    }
  }, {
    key: "getAllDepartmentRolesAndPermission",
    value: function getAllDepartmentRolesAndPermission(refresh) {
      var _this10 = this;
      _MMEnterpriseController["default"].roleAndUsers.getAllDepartmentRolesAndPermission(function (roles, filePermissions, managerPermissions) {
        _this10.data = roles;
        _this10.resultArr = roles.concat([]);
        _this10.initLeftHead(filePermissions, managerPermissions);
        _this10.showRolesInfo(roles);
      }, function () {
        _MDMessageView["default"].error(BabelStr.str(3537));
      }, refresh);
    }
  }, {
    key: "getAllDepartmentRoles",
    value: function getAllDepartmentRoles() {
      var _this11 = this;
      _MMEnterpriseController["default"].roleAndUsers.getAllDepartmentRoles(function (data) {
        console.log(data);
        _this11.showRolesInfo(data);
      }, function () {});
    }
  }, {
    key: "addDepartmentRole",
    value: function addDepartmentRole($e) {
      var _this12 = this;
      $e && $e.stopPropagation();
      var name = this.$(".scroll-table .newtd input").val().trim();
      // name = _.escape(name);
      // this.$(".commit").prop("disabled", true);
      if (!this.validateRoleName(name)) {
        return;
      }
      if (this.tabIndex == 1) {
        _MMEnterpriseController["default"].roleAndUsers.createEnterpriseShareRole(name, this.filePermission, function () {
          // this.getAllEnterpriseRolesAndPermission();
          _this12.getSharePermission(true);
          // this.$(".commit").prop("disabled", false);
        }, function () {
          _this12.mode = 'add';
          _MDMessageView["default"].error(BabelStr.str(3538));
          // this.$(".commit").prop("disabled", false);
        });
      } else {
        _MMEnterpriseController["default"].roleAndUsers.addDepartmentRole(name, this.filePermission, this.managerPermission, function () {
          // this.getAllEnterpriseRolesAndPermission();
          _this12.getAllDepartmentRolesAndPermission(true);
          // this.$(".commit").prop("disabled", false);
        }, function () {
          _this12.mode = 'add';
          _MDMessageView["default"].error(BabelStr.str(3538));
          // this.$(".commit").prop("disabled", false);
        });
      }
    }
  }, {
    key: "editCallback",
    value: function editCallback(name, slient) {
      // this.$(".commit").prop("disabled", false);

      var dataIndex = this._getDataIndex(this.roleId, this.data);
      var resultIndex = this._getDataIndex(this.roleId, this.resultArr);
      this.data[dataIndex].set("filePermission", this.filePermission);
      this.data[dataIndex].set("managerPermission", this.managerPermission);
      var attr = this.tabIndex ? "description" : "name";
      this.data[dataIndex].set(attr, name);
      this.resultArr[dataIndex].set("filePermission", this.filePermission);
      this.resultArr[dataIndex].set("managerPermission", this.managerPermission);
      this.resultArr[dataIndex].set(attr, name);
      !slient && this.showRolesInfo(this.data);
    }
  }, {
    key: "changeRoleInfo",
    value: function changeRoleInfo($e, slient) {
      var _this13 = this;
      $e && $e.stopPropagation();
      var name = this.$(".scroll-table .head .backg .head-r").val().trim();
      // name = _.escape(name);
      if (!this.validateRoleName(name, this.roleId)) {
        return;
      }
      // this.$(".commit").prop("disabled", true);

      if (this.tabIndex == 1) {
        _MMEnterpriseController["default"].roleAndUsers.updateEnterpriseShareRole(this.roleId, name, this.filePermission, function () {
          _this13.editCallback(name, slient);
        }, function () {
          // this.$(".commit").prop("disabled", false);
          _MDMessageView["default"].error(BabelStr.str(3539));
          _this13.mode = 'edit';
        });
      } else {
        _MMEnterpriseController["default"].roleAndUsers.changeRoleInfo(this.roleId, this.filePermission, this.managerPermission, name, function () {
          _this13.editCallback(name, slient);
        }, function () {
          _this13.mode = 'edit';
          // this.$(".commit").prop("disabled", false);
          _MDMessageView["default"].error(BabelStr.str(3539));
        });
      }
    }
  }, {
    key: "delCallback",
    value: function delCallback(id) {
      var dataIndex = this._getDataIndex(id, this.data);
      var resultIndex = this._getDataIndex(id, this.resultArr);
      this.data.splice(dataIndex, 1);
      this.resultArr.splice(resultIndex, 1);
      this.showRolesInfo(this.data);
    }
  }, {
    key: "delDepartmentRole",
    value: function delDepartmentRole(id) {
      var _this14 = this;
      if (this.tabIndex == 1) {
        _MMEnterpriseController["default"].roleAndUsers.deleteEnterpriseShareRole([id], function () {
          _MDMessageView["default"].success(BabelStr.str(305));
          _this14.delCallback(id);
        }, function () {
          _MDMessageView["default"].error(BabelStr.str(3540));
        });
      } else {
        _MMEnterpriseController["default"].roleAndUsers.delDepartmentRole(id, function () {
          _MDMessageView["default"].success(BabelStr.str(305));
          _this14.delCallback(id);
        }, function () {
          _MDMessageView["default"].error(BabelStr.str(3540));
        });
      }
    }
  }, {
    key: "validateRoleName",
    value: function validateRoleName(name, id) {
      if (!name) {
        _MDMessageView["default"].error(BabelStr.str(6227));
        return false;
      }
      if (!_regexp["default"].validateTextinput(name)) {
        _MDMessageView["default"].error(BabelStr.str(12203));
        return false;
      }
      var names = [];
      if (!id) {
        id = -1;
      }
      _.map(this.data, function (item) {
        if (id != item.get("id")) {
          names.push(item.get("name"));
        }
      });
      if (_.indexOf(names, name) > -1) {
        _MDMessageView["default"].error(BabelStr.str(3541));
        return false;
      } else {
        return true;
      }
    }
  }, {
    key: "_mouseDown",
    value: function _mouseDown($e) {
      this.move = false;
      this.down = true;
      this._x = $e.clientX;
      this._y = $e.clientY;
      this._topRolebody = this.$(".role-body-inner").scrollTop();
      this._leftRoleBody = this.$(".role-body-inner").scrollLeft();
      this._topContain = this.$(".contain").scrollTop();
      this._leftContain = this.$(".contain").scrollLeft();
      this.$(".role-body-inner").addClass("grabbing");
      this.$(".contain").addClass("grabbing");
      if (!this.move) {
        this._mouseMove($e);
      }
      // this.dragWrap.css('cursor','move')
    }
  }, {
    key: "_mouseUp",
    value: function _mouseUp($e) {
      $e && $e.stopPropagation();
      this.move = false;
      this.down = false;
      this.$(".role-body-inner").removeClass("grabbing");
      this.$(".contain").removeClass("grabbing");
    }
  }, {
    key: "_mouseMove",
    value: function _mouseMove($e) {
      $e && $e.stopPropagation();
      if (!this.down) {
        return;
      }
      this.$(".role-body-inner").addClass("grabbing");
      this.$(".contain").addClass("grabbing");
      this.move = true;
      var x = this._x - $e.clientX,
        y = this._y - $e.clientY,
        domcontain = this.$(".contain")[0],
        domRolebody = this.$(".role-body-inner")[0];
      domcontain.scrollLeft = this._leftContain + x;
      domcontain.scrollTop = this._topContain + y;
      domRolebody.scrollLeft = this._leftRoleBody + x;
      domRolebody.scrollTop = this._topRolebody + y;
    }
  }, {
    key: "_replaceRole",
    value: function _replaceRole() {
      var replaceRoleView = new _MEReplaceRole["default"]();
      replaceRoleView.show();
    }
  }, {
    key: "renderCss",
    value: function renderCss() {
      var $head = this.$(".role-head");
      var $body = this.$(".role-body");
      var $containner = this.$(".role-main");
      $body.css({
        top: $head.height() + 24 + "px"
      });
      $containner.height(this.$el.height() + $head.height() - 36);
    }
  }, {
    key: "deptabClickHandle",
    value: function deptabClickHandle($e) {
      if (this.$(".dep-tab").hasClass("active")) {
        return;
      }
      this.$(".use-default-block").addClass("f-hide");
      this.tabIndex = 0;
      this.needNumLine = true;
      this.$(".js-replace-role").show();
      this.$(".dep-tab").addClass("active");
      this.$(".share-tab").removeClass("active");
      this.getAllDepartmentRolesAndPermission(true);
      this.$(".per-title ").text(BabelStr.str(3091));
      this.$(".addRole").text(BabelStr.str(3087));
      this.$("#search").attr("placeholder", BabelStr.str(3621));
      this.$el.removeClass("sharepermission");
    }
  }, {
    key: "sharetabClickHandle",
    value: function sharetabClickHandle($e) {
      if (this.$(".share-tab").hasClass("active")) {
        return;
      }
      this.$(".use-default-block").removeClass("f-hide");
      this.tabIndex = 1;
      this.needNumLine = false;
      this.$(".js-replace-role").hide();
      this.$(".share-tab").addClass("active");
      this.$(".dep-tab").removeClass("active");
      this.getSharePermission(true);
      this.$(".addRole").text(BabelStr.str(4726));

      //  您可以在这里管理本企业自定义文件的分享权限管理，此处定义的权限，在分享文件时会出现在权限列表中
      this.$(".per-title ").text(BabelStr.str(5005));
      this.$("#search").attr("placeholder", BabelStr.str(5006));
      this.$el.addClass("sharepermission");
    }
  }, {
    key: "getSharePermission",
    value: function getSharePermission(refresh) {
      var _this15 = this;
      _MMEnterpriseController["default"].roleAndUsers.getAllRoles(function (roleCollection, defaultRoleId, filePermissions, managerPermissions) {
        _this15.data = _.filter(roleCollection.models, function (item) {
          if (_this15.dispRoleIds && _this15.dispRoleIds.length) {
            return _.indexOf(_this15.dispRoleIds, item.get("id").toString()) > -1;
          } else {
            return item.get("systemdefault");
          }
        });
        _this15.resultArr = _this15.data.concat([]);
        _this15.initLeftHead(filePermissions, managerPermissions, true);
        _this15.showRolesInfo(_this15.resultArr);
      }, function () {
        _MDMessageView["default"].error(BabelStr.str(3537));
      }, refresh);
    }
  }, {
    key: "resize",
    value: function resize() {
      var width = 0;
      var pdw;
      if (this.disableEdit) {
        // pdw = $("body").width()*0.1
        width = this.$el.width() - this.$(".left").width() - 10;
      } else {
        pdw = $(".app-left-panel").width() + 50;
        var nameWidth = this.$(".role-body-inner .left").width();
        if (this.tabIndex == 1) {
          nameWidth = this.$(".role-body-inner .left").width();
        }
        width = $("body").width() - pdw - nameWidth;
      }
      this.$(".contain").width(width);
      this.$(".scroll-table-contain").width(width);
      var w = $("#roleInfoShow").width();
      if (w > width) {
        this.$(".role-ope").show();
      } else {
        this.$(".role-ope").hide();
      }
      this.renderCss();
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      var _this16 = this;
      this.$el.addClass("app-panel");
      this.$el.addClass("f-clb");
      var leftRoleNamePanelWith = this.$(".role-body-inner .left").width();
      var width = this.$el.width() - leftRoleNamePanelWith;
      this.$(".contain").width(width - 20);
      this.$(".scroll-table-contain").width(width - 20);
      var self = this;
      $(window).off("resize.role");
      $(window).on("resize.role", function () {
        if (_this16.resizeTimer) {
          clearTimeout(_this16.resizeTimer);
        }
        _this16.resizeTimer = setTimeout(function () {
          _this16.resize();
          _this16.resizeTimer = null;
        }, 500);
      });
      this.$(".contain").scroll(function ($e) {
        var left = _this16.$(".role-body .contain")[0].scrollLeft;
        var temp = "translateX(-" + left + "px)";
        $(".scroll-table-contain").scrollLeft(0);
        _this16.$(".scroll-table").css({
          transform: temp
        });
      });
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEAuthPanelView.prototype), "viewDidRendered", this).call(this);
      if (this.tabIndex == 1) {
        this.sharetabClickHandle();
      } else {
        this.deptabClickHandle();
      }

      // this.$(".role-main").hide();
      this.$(".role-main").css({
        visibility: "hidden"
      });
      _MDSpinnerloaderLayerView["default"].showIn(this.el);
      this.renderCss();
    }
  }, {
    key: "viewWillUnRendered",
    value: function viewWillUnRendered() {
      this.triggerSave(undefined, true);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEAuthPanelView.prototype), "viewWillUnRendered", this).call(this);
    }
  }, {
    key: "viewDidUnRendered",
    value: function viewDidUnRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEAuthPanelView.prototype), "viewDidUnRendered", this).call(this);
      var event = this.$nsEventName("click");
      $(window).off("resize.role");
      $(document).unbind(event);
      $("#temporaryContain").remove();
      $(document).off(this.$nsEventName("keyup"));
    }
  }]);
  return MEAuthPanelView;
}(_MMViewBase2["default"]);
MEAuthPanelView.fullPermission = 0xffffffff;
MEAuthPanelView.changeBitToTrue = function (index, value) {
  var temp = 1 << index;
  return temp | value;
};
MEAuthPanelView.changeBitToFalse = function (index, value) {
  var temp = 1 << index;
  temp = MEAuthPanelView.fullPermission ^ temp;
  return temp & value;
};

},{"104":104,"106":106,"1098":1098,"1150":1150,"117":117,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"128":128,"131":131,"1412":1412,"1415":1415,"1417":1417,"1421":1421,"1426":1426,"1429":1429,"1432":1432,"1437":1437,"1438":1438,"1454":1454,"1463":1463,"1466":1466,"1475":1475,"1477":1477,"1478":1478,"1489":1489,"1492":1492,"1498":1498,"1541":1541,"22":22,"280":280,"32":32,"55":55,"75":75,"79":79,"812":812}],131:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDSpinnerloaderLayerView = _interopRequireDefault(require(75));
var _MEDepRoleSelectView = _interopRequireDefault(require(189));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDLocalString = _interopRequireDefault(require(1150));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 *  window to  edit department  /*enterprise
 *  Created by jichao
 *  2017.11.10
 */
var MEReplaceRole = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MEReplaceRole, _MDWindowView);
  function MEReplaceRole() {
    (0, _classCallCheck2["default"])(this, MEReplaceRole);
    return _callSuper(this, MEReplaceRole, arguments);
  }
  (0, _createClass2["default"])(MEReplaceRole, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n      <div class=\"contain\" >\n        <div class=\"container-fluid mgb-10\"><%=BabelStr.str(3565)%></div>\n        <div class=\"container-fluid\">\n          <form action=\"\">\n            <div class=\"form-item row\">\n              <div class=\"col-3 lh-30\"><label><%=BabelStr.str(3566)%>\uFF1A</label></div>\n              <div  class=\"col-9 js-old-role-select\"></div>\n            </div>\n            <div class=\"form-item row\">\n              <div class=\"col-3 lh-30\"><label><%=BabelStr.str(3569)%>\uFF1A</label></div>\n              <div class=\"col-9 js-new-role-select\"></div>\n            </div>\n          </form>\n        </div>\n      </div>";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEReplaceRole.prototype), "initProps", this).call(this);
      return _.extend(superP, {});
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEReplaceRole.prototype), "className", this).call(this);
      return "".concat(superCls, " replace-role");
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      var _this = this;
      opt.size = 'normal';
      opt.title = _MDLocalString["default"].getLocalString(3564);
      opt.buttons = [{
        type: 'done',
        label: _MDLocalString["default"].getLocalString(154),
        autoClose: false,
        onClick: function onClick() {
          self.submit();
        }
      }, {
        type: 'cancel',
        label: _MDLocalString["default"].getLocalString(3081),
        autoClose: true
      }];
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEReplaceRole.prototype), "initialize", this).call(this, opt);
      var self = this;
      this.oldRoleSelectView = new _MEDepRoleSelectView["default"]({
        needNoRole: false,
        silentInit: false,
        onChange: function onChange(role) {
          _this.oldRoleId = role.getId();
        }
      });
      this.addSubView(this.oldRoleSelectView, this.$('.js-old-role-select')[0]);
      this.newRoleSelectView = new _MEDepRoleSelectView["default"]({
        needNoRole: false,
        silentInit: false,
        onChange: function onChange(role) {
          _this.newRoleId = role.getId();
        }
      });
      this.addSubView(this.newRoleSelectView, this.$('.js-new-role-select')[0]);
    }
  }, {
    key: "submit",
    value: function submit() {
      var _this2 = this;
      this.setDisabled(true);
      var net = _MMEnterpriseController["default"];
      net.migrateDepartmentRoleTo(this.oldRoleId, this.newRoleId, function () {
        MDMessageView.show(BabelStr.str(3570));
        _this2.close();
      }, function () {
        MDMessageView.show(BabelStr.str(3571), _this2.$body);
        _this2.setDisabled(false);
      });
    }
  }]);
  return MEReplaceRole;
}(_MDWindowView2["default"]);

},{"1098":1098,"1150":1150,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"189":189,"75":75,"93":93}],128:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDSpinnerloaderLayerView = _interopRequireDefault(require(75));
var _MEDepRoleSelectView = _interopRequireDefault(require(189));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDRoleSelectView = _interopRequireDefault(require(515));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 *  window to  edit department  /*enterprise
 *  Created by jichao
 *  2017.11.10
 */
var MEAddRoleWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MEAddRoleWinView, _MDWindowView);
  function MEAddRoleWinView() {
    (0, _classCallCheck2["default"])(this, MEAddRoleWinView);
    return _callSuper(this, MEAddRoleWinView, arguments);
  }
  (0, _createClass2["default"])(MEAddRoleWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n      <div class=\"contain\" >\n        <div class=\"container-fluid\">\n          <form action=\"\">\n            <div class=\"form-item row\">\n              <div class=\"col-6\">\n                <div index=0 class=\"radio-box checked opt1\"><%=BabelStr.str(3573)%></div>\n              </div>\n            </div>\n            <div class=\"form-item row role-select-row\">\n              <div class=\"col-7\">\n                <div index=1 class=\"radio-box opt2\"><%=BabelStr.str(3574)%></div>\n              </div>\n              <div class=\"col-5 js-role-select  f-none\"></div>\n            </div>\n          </form>\n        </div>\n      </div>";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEAddRoleWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        addRoleCallback: _.noop,
        checkedIndex: 0,
        isDepRole: true
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEAddRoleWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .radio-box': this._radioBoxClickHandle
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEAddRoleWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " add-role-ep-win");
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      var _this = this;
      opt.size = 'normal';
      opt.title = _MDLocalString["default"].getLocalString(3572);
      opt.buttons = [{
        type: 'done',
        label: _MDLocalString["default"].getLocalString(154),
        autoClose: false,
        onClick: function onClick() {
          self.submit();
        }
      }, {
        type: 'cancel',
        label: _MDLocalString["default"].getLocalString(3081),
        autoClose: true
      }];
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEAddRoleWinView.prototype), "initialize", this).call(this, opt);
      var self = this;
      if (this.data.length) {
        if (this.isDepRole) {
          this.roleSelectView = new _MEDepRoleSelectView["default"]({
            needNoRole: false,
            silentInit: false,
            onChange: function onChange(role) {
              _this.checkedRoleId = role.getId();
            }
          });
        } else {
          this.$('.opt1').text(BabelStr.str(4727));
          this.$('.opt2').text(BabelStr.str(4728));
          this.roleSelectView = new _MDRoleSelectView["default"]({
            onRoleChanged: function onRoleChanged(role) {
              _this.checkedRoleId = role.getRoleId();
            }
          });
          this.roleSelectView.setRoles(this.data);
          self.roleSelectView.selectRole(this.data[0]);
        }
        this.addSubView(this.roleSelectView, this.$('.js-role-select')[0]);
      } else {
        this.$('.role-select-row').addClass('f-hide');
      }
      if (this.isDepRole) {
        this.$el.addClass('dep-role');
      } else {
        this.$el.addClass('share-role');
      }
    }
  }, {
    key: "_radioBoxClickHandle",
    value: function _radioBoxClickHandle($e) {
      var $target = $($e.target).closest(".radio-box");
      var index = $target.attr("index");
      if (index == 1) {
        this.$('.js-role-select').show();
      } else {
        this.$('.js-role-select').hide();
      }
      if ($target.hasClass("checked")) {
        return;
      } else {
        this.$(".radio-box").removeClass("checked");
        $target.addClass("checked");
        this.checkedIndex = index;
      }
    }
  }, {
    key: "submit",
    value: function submit() {
      this.addRoleCallback(this.checkedIndex, this.checkedRoleId);
      this.close();
    }
  }]);
  return MEAddRoleWinView;
}(_MDWindowView2["default"]);

},{"1098":1098,"1150":1150,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"189":189,"515":515,"75":75,"93":93}],515:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1415);
var _MMViewBase = _interopRequireDefault(require(22));
var _MDRoleListPopupView = _interopRequireDefault(require(757));
var _popupPos = _interopRequireDefault(require(65));
var MDRoleSelectView = _MMViewBase["default"].extend({
  el: '<div class="role-select"></div>',
  tmpl: '<div class="f-arrow role-wrap"><span class="role"></span></div>',
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click .role-wrap': this._showRoleListView
    });
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      onRoleChanged: _.noop,
      roles: [],
      selectedRole: null
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.$roleWrap = this.$('.role-wrap');
  },
  _setRole: function _setRole(role, opt_silent) {
    var $spans = this.$roleWrap.children();
    $spans.eq(0).text(role.getDescription());
    this.roleId = role.getRoleId();
    this.selectedRole = role;
    !!!opt_silent && this.onRoleChanged(role);
  },
  selectRole: function selectRole(role, opt_silent) {
    var _this = this;
    this._setRole(role, opt_silent);
    var exist = _.find(this.currentRoles, function (item) {
      return item.get('id') == role.get('id');
    });
    if (!exist) {
      this.currentRoles = _.filter(this.allRoles, function (role) {
        return role.get('systemdefault') || role.get('id') == _this.roleId;
      });
      this.setRoles(this.currentRoles, true);
    }
  },
  setRoles: function setRoles(roles, existData) {
    var self = this;
    if (!existData) {
      this.allRoles = roles;
      this.currentRoles = _.filter(this.allRoles, function (role) {
        return role.get('systemdefault');
      });
    }
    // this.roles = roles;
    _MDRoleListPopupView["default"].createPopup({
      roles: self.currentRoles,
      selectedRole: function selectedRole() {
        return self.selectedRole;
      },
      triggerView: this.$('.role-wrap')[0],
      center: true,
      hasArrow: false,
      direction: _popupPos["default"].BOTTOM_RIGHT,
      asDropdown: false,
      gapY: 6,
      onRoleChange: function onRoleChange(role) {
        self._setRole(role);
      }
    });
  }
});
var _default = exports["default"] = MDRoleSelectView;

},{"1184":1184,"1415":1415,"1417":1417,"1454":1454,"1463":1463,"22":22,"65":65,"757":757}],757:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1426);
var _MDPopupView = _interopRequireDefault(require(64));
var _MDShareFilePermissionInfoView = _interopRequireDefault(require(692));
/**
 *  Class description here
 *  Created by author's name
 *  date here(2015.6.24)
 */

var MDRoleListPopupView = _MDPopupView["default"].extend({
  contentTmpl: "<ul class=\"m-menu\">\n        <%\n        for (var i = 0 ; i < roles.length ; i++){\n          var role = roles[i];\n        %>\n        <li>\n            <%if(role.selected){%><i class=\"icon check menu-icon left\"></i><%}%>\n            <span class=\"middle-ellipsis\"><%=role.roleDes%></span>\n        </li>\n      <%}%>\n      </ul>\n      <div class=\"check-auth text-button pdlr-20\"><%=BabelStr.str(81)%>...</div>\n    ",
  className: function className() {
    var superCls = _MDPopupView["default"].prototype.className.call(this);
    return superCls + ' role-popup role-select';
  },
  initProps: function initProps() {
    var superP = _MDPopupView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      roles: [],
      onRoleChange: _.noop,
      selectedRole: null
    });
  },
  events: function events() {
    var superE = _MDPopupView["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click .m-menu>li': this._roleItemClickHandler,
      'click .check-auth': this._openRoleWindow
    });
  },
  initialize: function initialize(opt) {
    var selectedRole = _.isFunction(opt.selectedRole) ? opt.selectedRole() : opt.selectedRole;
    var roles = _.map(opt.roles, function (role) {
      var selected = false;
      if (selectedRole && selectedRole.getRoleId() == role['id']) {
        selected = true;
      }
      return {
        'roleDes': role.getDescription(),
        'selected': selected
      };
    });
    opt.data = {
      'roles': roles
    };
    opt.width = 180;
    _MDPopupView["default"].prototype.initialize.call(this, opt);
    this.$el.css('z-index', 200000);
  },
  _roleItemClickHandler: function _roleItemClickHandler($e) {
    var index = $($e.currentTarget).index();
    var role = this.roles[index];
    this.onRoleChange(role);
    this.close();
  },
  _openRoleWindow: function _openRoleWindow($e) {
    _MDShareFilePermissionInfoView["default"].show();
    this.close();
  }
});
var _default = exports["default"] = MDRoleListPopupView;

},{"1184":1184,"1426":1426,"1454":1454,"64":64,"692":692}],189:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1438);
require(1412);
require(1432);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDRole = _interopRequireDefault(require(280));
var _MDMessageView = _interopRequireDefault(require(55));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 * 部门角色选项
 * Created by manjun.han
 * 2016.12.13
 */
var MEDepRoleSelectView = exports["default"] = /*#__PURE__*/function (_MDDropdownSelectList) {
  (0, _inherits2["default"])(MEDepRoleSelectView, _MDDropdownSelectList);
  function MEDepRoleSelectView() {
    (0, _classCallCheck2["default"])(this, MEDepRoleSelectView);
    return _callSuper(this, MEDepRoleSelectView, arguments);
  }
  (0, _createClass2["default"])(MEDepRoleSelectView, [{
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEDepRoleSelectView.prototype), "initProps", this).call(this);
      this.selectOptionRenderer = _.bind(this.selectOptionRenderer, this);
      return _.extend(superP, {
        needAllRole: false,
        onLoadRoleError: _.noop,
        needNoRole: false,
        onReady: null,
        labelField: 'name',
        selectOptionRenderer: this.selectOptionRenderer
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEDepRoleSelectView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .cur-selected-opt': this._togglePopupSelectList,
        'click .select-opt-list li': this._onOptionClickHandler,
        'mousedown .select-opt-list li': this._onOptionMousedownHandler
      });
    }
  }, {
    key: "selectOptionRenderer",
    value: function selectOptionRenderer(dataItem, index) {
      var role = dataItem;
      var roleName = role.getName();
      var roleId = role.getId();
      var itemTeamplate = "<div class=\"middle-ellipsis\" title=\"".concat(roleName, "\" data-role-id=\"").concat(roleId, "\" >").concat(roleName, "</div>");
      return itemTeamplate;
    }
  }, {
    key: "_onOptionMousedownHandler",
    value: function _onOptionMousedownHandler(e) {
      e.stopPropagation();
    }
  }, {
    key: "viewWillRendered",
    value: function viewWillRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEDepRoleSelectView.prototype), "viewWillRendered", this).call(this);
      console.log('MEDepRoleSelectView viewWillRendered');
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEDepRoleSelectView.prototype), "viewDidRendered", this).call(this);
      this.requestRoles();
      console.log('MEDepRoleSelectView viewDidRendered');
    }
  }, {
    key: "viewDidUnRendered",
    value: function viewDidUnRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEDepRoleSelectView.prototype), "viewDidUnRendered", this).call(this);
      console.log('MEDepRoleSelectView viewDidUnRendered');
    }
  }, {
    key: "requestRoles",
    value: function requestRoles() {
      var _this = this;
      var disabled = this.disabled;
      this.setDisabled(true);
      var net = _MMEnterpriseController["default"].roleAndUsers;
      var role;
      net.getAllDepartmentRoles(function (roles) {
        var selRole = BabelStr.str(675); // 选择角色
        var allRole = BabelStr.str(676); // 所有角色
        if (_this.needNoRole) {
          role = new _MDRole["default"]();
          role.set('id', '-1');
          role.set('name', selRole);
          roles.splice(0, 0, role);
        }
        if (_this.needAllRole) {
          role = new _MDRole["default"]();
          role.set('id', '-1');
          role.set('name', allRole);
          roles.splice(0, 0, role);
        }
        _this.dataProvider.add(roles);
        _this.renderDropdownList();
        if (_this.defaultRoleId) {
          console.log('------------>' + _this.defaultRoleId);
          for (var i = 0; i < roles.length; i++) {
            var _role = roles[i];
            if (_role.get('id') == _this.defaultRoleId) {
              _this.selectItemAt(i, _this.silentInit);
              break;
            }
          }
        } else {
          _this.selectItemAt(0, _this.silentInit);
        }
        _this.setDisabled(disabled);
        _.isFunction(_this.onReady) && _this.onReady();
      }, function () {
        _this.onLoadRoleError();
        _this.setDisabled(false);
      });
    }
  }, {
    key: "renderDropdownList",
    value: function renderDropdownList() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEDepRoleSelectView.prototype), "renderDropdownList", this).call(this);
      if (this.needNoRole) {
        this.$selectPopupList.children().eq(0).addClass('disabled selected');
        this.selectItemAt(0, true);
        this.$nativeSelect.children().eq(0).prop({
          disabled: true,
          selected: true
        });
      }
    }
  }, {
    key: "selectedByRoleId",
    value: function selectedByRoleId(roleId, silent) {
      var selectedIndex = -1;
      this.dataProvider.each(function (role, index) {
        if (role.getId() == roleId) {
          selectedIndex = index;
        }
      });
      if (selectedIndex > -1) {
        this.selectItemAt(selectedIndex, silent);
      } else {
        this.selectItemAt(0, silent);
        // this.setDisplayValue(BabelStr.str(7034), "red");
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.needNoRole) {
        this.selectItemAt(0, true);
      }
    }
  }, {
    key: "selectDefaultRole",
    value: function selectDefaultRole(opt_silent) {
      var role = this.dataProvider.findWhere({
        'default': 1
      });
      var roleId = role.getId();
      if (this.defaultRoleId) {
        roleId = this.defaultRoleId;
      }
      var index = this.$('div[data-role-id="' + roleId + '"]').parent().index();
      this.selectItemAt(index, opt_silent);
    }
  }, {
    key: "setDefaultRoleId",
    value: function setDefaultRoleId(defaultRoleId) {
      this.defaultRoleId = defaultRoleId;
      this.selectDefaultRole();
    }
  }]);
  return MEDepRoleSelectView;
}(_MDDropdownSelectListView["default"]);

},{"1098":1098,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1412":1412,"1432":1432,"1438":1438,"1454":1454,"1463":1463,"1475":1475,"280":280,"55":55,"67":67}],117:[function(require,module,exports){
module.exports = '<div class="role-main">\  <div class="role-head">\    <div class="flex-align">\      <div class="boldfont2 pdb-10 mgr-20"><%=BabelStr.str(3425)%></div>\      <div class="owner-ope"></div>\    </div>\    <div class="help-block"><%=BabelStr.str(3426)%></div>\    <div class="boldfont2 mgt-15 flex-align tabs mgb-10">\      <span class="dep-tab mgr-10"><%=BabelStr.str(3700)%></span>\      <span class="share-tab"><%=BabelStr.str(3701)%></span>\    </div>\    <div class="help-block per-title"><%=helpStr%></div> <!-- 您可以在这里管理企业内部所有角色的权限，并且新增特定的角色，选择权限后点击保存即时生效，管理员及默认权限无法修改 -->\    <div class="auth-panel-toolbar f-clb">\      <div class="search-c search-box search-box-inline">\        <div class="icon-search"></div>\        <input id="search" placeholder="<%=BabelStr.str(3621)%>">\      </div>\      <div class="role-ope">\        <span class="button toleft  "><span class="ep-ic ep-ic-left"></span>\        </span><span class="button toright  "><span class="ep-ic ep-ic-right"></span></span>\      </div>\       <button class="addRole js-per-judge button done f-fr"><%=addRoleStr%></button> <!-- 新增角色 -->\       <div class="flex-align mgr-10 middle use-default-block f-hide f-fr">\         <span class="mgr-10"><%=BabelStr.str(8576)%></span>\         <button class="f-fr use-default-ope"></button> <!-- 新增角色 -->\       </div>\      <button class="js-replace-role js-per-judge button done mgr-10 f-fr"><%=BabelStr.str(3564)%></button>\    </div>\  </div>\  <div class="role-body f-clb grab">\    <div class="role-body-inner">\      <ul class="f-fl left flex-align with-column col-auto">\      </ul>\      <div class="contain">\        <table id="roleInfoShow" class="">\        </table>\      </div>\    </div>\    <div class="scroll-contain ">\      <div class="scroll-head"><%=depMaanageRoleStr%></div> <!-- 部门管理权限 -->\      <div class="scroll-table-contain">\        <table class="scroll-table">\          <tr class="head" index="1"></tr>\        </table>\      </div>\    </div>\    <div class="bottom f-h60"></div>\  </div>\</div>\<div class="foot-ope">\  <button class="cancleAddRole button"><%=cancleStr%></button> <!-- 取消 -->\  <button id="editRole" class="button done commit"><%=saveStr%></button> <!-- 确定 -->\</div>\<div class="foot-add">\  <button class="cancleAddRole button"><%=cancleStr%></button> <!-- 取消 -->\  <button id="addRoleComit" class=" button done commit"><%=saveStr%></button> <!-- 确定 -->\</div>';
},{}],79:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1438);
var _MMViewBase = _interopRequireDefault(require(22));
/**
 *  Component for choose
 *  Create by manjun.han
 *  date here(2015.6.24)
 */

var MDSwitchView = _MMViewBase["default"].extend({
  el: '<div class=""></div>',
  tmpl: '<input type="checkbox" class="toggle">' + '<label ></label>',
  className: function className() {
    var superCls = _MMViewBase["default"].prototype.className.call(this);
    return superCls + ' round-switch small';
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      $checkbox: null,
      onChange: _.noop,
      attrs: {},
      checked: false,
      disabled: false
    });
  },
  events: function events() {
    return {
      'change input': this._switchValueChangedHandler
    };
  },
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.$checkbox = this.$("input");
    this.$label = this.$("label");
    this.$checkbox.attr("id", this.cid);
    this.$label.attr('for', this.cid);
    this.$el.attr(this.attrs);
    this.$('input').prop('checked', !!this.checked);
    this._switchValueChangedHandler = _.bind(this._switchValueChangedHandler, this);
  },
  open: function open(silent) {
    this.$checkbox.prop("checked", true);
    if (!silent) {
      this.onChange(true);
    }
  },
  setAttr: function setAttr(attr) {
    this.$el.attr(attr);
  },
  close: function close(silent) {
    this.$checkbox.prop("checked", false);
    if (!silent) {
      this.onChange(false);
    }
  },
  _switchValueChangedHandler: function _switchValueChangedHandler($e) {
    _.isFunction(this.onChange) && this.onChange(this.$checkbox.prop("checked"));
  },
  isChecked: function isChecked() {
    return this.$('input').prop('checked');
  },
  setDisabled: function setDisabled(disabled) {
    this.$checkbox.prop('disabled', disabled);
    if (disabled) {
      this.$el.addClass('disabled');
    } else {
      this.$el.removeClass('disabled');
    }
  }
});
var _default = exports["default"] = MDSwitchView;

},{"1184":1184,"1438":1438,"1454":1454,"22":22}],63:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDLocalString = _interopRequireDefault(require(1150));
var _MMViewBase = _interopRequireDefault(require(22));
/**
 * 帮助信息显示的基类
 * javascript/base/component/popup/MDPopupHelpWindow.js
 * Created by jiang 
 * 2018.8.12
 */

var MDPopupHelpWindow = _MMViewBase["default"].extend({
  el: "<div style=\"z-index:1000000000; position: absolute; width: 100%;  height: 100%; top:0px;\"></div>",
  tmpl: "<div class=\"help-mask mask\">\n        <div class=\"help-container \">\n          <div class=\"help-content\"></div>\n          <button class=\"icon marker-close\"></button>\n        </div>\n      </div>",
  helpTmpl: "",
  className: function className() {
    var superCls = _MMViewBase["default"].prototype.className.call(this);
    return superCls + ' help-win';
  },
  initProps: function initProps(prop) {
    var superP = _MMViewBase["default"].prototype.initProps.call(this, prop);
    return _.extend(superP, {});
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click .marker-close': this.closeWindow
    });
  },
  initialize: function initialize(options) {
    var self = this;
    _MMViewBase["default"].prototype.initialize.call(this, options);
    var self = this;
    var content = _.isFunction(this.helpTmpl) ? this.helpTmpl() : this.helpTmpl;
    this.$('.help-content').append($(content));
  },
  closeWindow: function closeWindow() {
    if (this.onClose) {
      this.onClose();
    }
    this.remove();
  },
  _slideclicked: function _slideclicked(e) {
    e.stopPropagation();
  },
  getClassName: function getClassName() {
    return "MDPopupHelpWindow";
  }
}, {});
var _default = exports["default"] = MDPopupHelpWindow;

},{"1150":1150,"1184":1184,"1454":1454,"22":22}],47:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1426);
require(1466);
require(1498);
require(1430);
require(1463);
require(1421);
require(1432);
require(1429);
require(1412);
require(1418);
require(1537);
require(1415);
var _typeof2 = _interopRequireDefault(require(1197));
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMViewBase2 = _interopRequireDefault(require(22));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDMultInputWithEditView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MDMultInputWithEditView, _MMViewBase);
  function MDMultInputWithEditView() {
    (0, _classCallCheck2["default"])(this, MDMultInputWithEditView);
    return _callSuper(this, MDMultInputWithEditView, arguments);
  }
  (0, _createClass2["default"])(MDMultInputWithEditView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n    <div class=\"multi-input-edit-container\">\n      <div class=\"items-wrapper\">\n        <% if (items && items.length) { %>\n          <% _.each(items, function(item, index) { %>\n            <div class=\"item-row\" data-index=\"<%= index %>\">\n              <span class=\"drag-handle\" data-index=\"<%= index %>\">\u22EE\u22EE</span>\n              <input type=\"text\" class=\"item-input\" value=\"<%= item.value %>\" data-index=\"<%= index %>\" />\n              <span class=\"item-remove\" data-index=\"<%= index %>\">\xD7</span>\n            </div>\n          <% }); %>\n        <% } else { %>\n          <span class=\"placeholder-tip\"><%=BabelStr.str(40217)%></span>\n        <% } %>\n      </div>\n      <div class=\"input-wrapper\">\n        <input type=\"text\" class=\"multi-input\" placeholder=\"<%=BabelStr.str(40216)%>\" />\n        <div class=\"error-message\"><%= errorMessage %></div>\n      </div>\n    </div>\n  ";
    }
  }, {
    key: "_itemsTmpl",
    value: function _itemsTmpl() {
      return "\n    <div class=\"items-wrapper\">\n      <% if (items && items.length) { %>\n        <% _.each(items, function(item, index) { %>\n          <div class=\"item-row\" data-index=\"<%= index %>\">\n            <span class=\"drag-handle\" data-index=\"<%= index %>\">\u22EE\u22EE</span>\n            <input type=\"text\" class=\"item-input\" value=\"<%= item.value %>\" data-index=\"<%= index %>\" />\n            <span class=\"item-remove\" data-index=\"<%= index %>\">\xD7</span>\n          </div>\n        <% }); %>\n      <% } else { %>\n        <span class=\"placeholder-tip\"><%=BabelStr.str(40217)%></span>\n      <% } %>\n    </div>\n  ";
    }
  }, {
    key: "_errorTmpl",
    value: function _errorTmpl() {
      return "\n    <div class=\"error-message\"><%= errorMessage %></div>\n  ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var props = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMultInputWithEditView.prototype), "initProps", this).call(this);
      return _.extend(props, {
        items: [],
        maxItems: Infinity,
        duplicate: false,
        validator: null,
        onChange: null,
        onError: null,
        onItemEdit: null,
        onItemDelete: null,
        errorMessage: "",
        _removedItems: [],
        _originalOrder: [],
        _dragulaInstance: null
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMultInputWithEditView.prototype), "className", this).call(this);
      return "".concat(superCls, " multi-input-edit-view");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMultInputWithEditView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "keydown .multi-input": "onInputKeydown",
        "click .item-remove": "onItemRemove",
        "input .multi-input": "onInputChange",
        "click .placeholder-tip": "_focus",
        "change .item-input": "onItemInputChange",
        "input .item-input": "onItemInputChange",
        "keydown .item-input": "onItemInputKeydown",
        "blur .item-input": "onItemInputBlur"
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      _.extend(this, _.pick(props, ["items", "maxItems", "duplicate", "validator", "onChange", "onError", "onItemEdit", "onItemDelete"]));
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMultInputWithEditView.prototype), "initialize", this).call(this, props);
      this._itemsCompiler = _.template(this._itemsTmpl());
      this._errorCompiler = _.template(this._errorTmpl());
      this._initItems();
    }
  }, {
    key: "_initItems",
    value: function _initItems() {
      this.items = this.items.map(function (item) {
        if (typeof item === "string") {
          return {
            id: null,
            value: item,
            isNew: true,
            _originalValue: item
          };
        }
        return _.extend({
          isNew: false,
          _originalValue: item.value
        }, item);
      });
      this._originalOrder = this.items.map(function (item) {
        return item.id;
      });
    }
  }, {
    key: "render",
    value: function render(data) {
      var renderData = _.extend({}, data || {}, {
        items: this.items,
        errorMessage: this.errorMessage || ""
      });
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMultInputWithEditView.prototype), "render", this).call(this, renderData);
      this.$(".multi-input").focus();
      this.initDragEvents();
      return this;
    }
  }, {
    key: "refresh",
    value: function refresh(data) {
      this.removeSubViews();
      this.$el.empty();
      this.render(data);
    }
  }, {
    key: "updateItems",
    value: function updateItems() {
      var itemsHtml = this._itemsCompiler({
        items: this.items
      });
      this.$(".items-wrapper").replaceWith(itemsHtml);
      this.initDragEvents();
    }
  }, {
    key: "initDragEvents",
    value: function initDragEvents() {
      var _this = this;
      this.clearDragEvents();
      var containers = [this.$(".items-wrapper")[0]];
      if (!containers[0]) return;
      this._dragulaInstance = dragula(containers, {
        handle: ".drag-handle",
        invalid: function invalid(el, handle) {
          return el.classList.contains("placeholder-tip");
        }
      }).on("dragend", function (el) {
        _this.updateItemOrder();
      });
    }
  }, {
    key: "clearDragEvents",
    value: function clearDragEvents() {
      if (this._dragulaInstance) {
        this._dragulaInstance.destroy();
        this._dragulaInstance = null;
      }
    }
  }, {
    key: "updateItemOrder",
    value: function updateItemOrder() {
      var _this2 = this;
      var $items = this.$(".item-row");
      var newOrder = [];
      var newItems = [];
      $items.each(function (index, el) {
        var dataIndex = parseInt($(el).data("index"), 10);
        if (dataIndex >= 0 && dataIndex < _this2.items.length) {
          newItems.push(_this2.items[dataIndex]);
          newOrder.push(_this2.items[dataIndex].id);
        }
      });
      this.items = newItems;
      this._originalOrder = newOrder;
      if (_.isFunction(this.onChange)) {
        this.onChange({
          type: "reorder",
          items: this.getItems()
        });
      }
    }
  }, {
    key: "updateError",
    value: function updateError(message) {
      this.errorMessage = message || "";
      var errorHtml = this._errorCompiler({
        errorMessage: this.errorMessage
      });
      var $currentError = this.$(".error-message");
      if ($currentError.length) {
        $currentError.replaceWith(errorHtml);
      } else {
        this.$(".input-wrapper").append(errorHtml);
      }
      this.$el.toggleClass("has-error", !!this.errorMessage);
    }
  }, {
    key: "clearError",
    value: function clearError() {
      this.updateError("");
    }
  }, {
    key: "validateItem",
    value: function validateItem(value) {
      if (!value || !value.trim()) {
        return {
          valid: false,
          message: BabelStr.str(40218)
        };
      }
      if (_.isFunction(this.validator)) {
        var result = this.validator(value);
        if (result && (0, _typeof2["default"])(result) === "object" && result.valid !== undefined) {
          return result;
        } else if (result === true) {
          return {
            valid: true
          };
        } else if (result === false) {
          return {
            valid: false,
            message: BabelStr.str(40219)
          };
        }
      }
      if (!this.duplicate) {
        var exists = this.items.some(function (item) {
          return item.value === value;
        });
        if (exists) {
          return {
            valid: false,
            message: BabelStr.str(40220)
          };
        }
      }
      if (this.items.length >= this.maxItems) {
        return {
          valid: false,
          message: BabelStr.str(40221)
        };
      }
      return {
        valid: true
      };
    }
  }, {
    key: "validateNonEmpty",
    value: function validateNonEmpty() {
      if (this.items.length === 0) {
        var msg = BabelStr.str(40222);
        this.updateError(msg);
        if (_.isFunction(this.onError)) {
          this.onError("empty", msg);
        }
        return false;
      }
      this.clearError();
      return true;
    }
  }, {
    key: "addItem",
    value: function addItem(itemValue) {
      itemValue = itemValue.trim();
      if (!itemValue) {
        return false;
      }
      var result = this.validateItem(itemValue);
      if (!result.valid) {
        this.updateError(result.message);
        if (_.isFunction(this.onError)) {
          this.onError("validation", result.message);
        }
        return false;
      }
      this.clearError();
      var newItem = {
        id: null,
        value: itemValue,
        isNew: true,
        _originalValue: itemValue
      };
      this.items.push(newItem);
      this.updateItems();
      if (_.isFunction(this.onChange)) {
        this.onChange({
          type: "add",
          value: newItem,
          items: this.getItems()
        });
      }
      return true;
    }
  }, {
    key: "removeItem",
    value: function removeItem(itemOrIndex) {
      var index;
      if (typeof itemOrIndex === "number") {
        index = itemOrIndex;
      } else {
        index = this.items.indexOf(itemOrIndex);
      }
      if (index === -1) return false;
      var removed = this.items[index];
      this.items.splice(index, 1);
      this._removedItems.push(removed);
      this.updateItems();
      if (_.isFunction(this.onItemDelete)) {
        this.onItemDelete({
          item: removed,
          items: this.getItems()
        });
      }
      if (_.isFunction(this.onChange)) {
        this.onChange({
          type: "remove",
          value: removed,
          items: this.getItems()
        });
      }
      this.clearError();
      return true;
    }
  }, {
    key: "editItem",
    value: function editItem(index, newValue) {
      newValue = newValue.trim();
      if (!newValue) {
        return false;
      }
      if (index < 0 || index >= this.items.length) {
        return false;
      }
      var item = this.items[index];
      var oldValue = item.value;
      if (oldValue === newValue) {
        return false;
      }
      if (!this.duplicate) {
        var exists = this.items.some(function (it, i) {
          return i !== index && it.value === newValue;
        });
        if (exists) {
          var msg = BabelStr.str(40220);
          this.updateError(msg);
          if (_.isFunction(this.onError)) {
            this.onError("validation", msg);
          }
          return false;
        }
      }
      this.clearError();
      item.value = newValue;
      var $input = this.$(".item-input[data-index=\"".concat(index, "\"]"));
      if ($input.length) {
        $input.val(newValue);
      }
      if (_.isFunction(this.onItemEdit)) {
        this.onItemEdit({
          item: item,
          oldValue: oldValue,
          newValue: newValue,
          items: this.getItems()
        });
      }
      if (_.isFunction(this.onChange)) {
        this.onChange({
          type: "edit",
          value: item,
          oldValue: oldValue,
          items: this.getItems()
        });
      }
      return true;
    }
  }, {
    key: "clearItems",
    value: function clearItems() {
      var _this3 = this;
      if (this.items.length === 0) return;
      var removedItems = this.items.slice();
      this.items = [];
      this._removedItems = this._removedItems.concat(removedItems);
      this.updateItems();
      removedItems.forEach(function (item) {
        if (_.isFunction(_this3.onItemDelete)) {
          _this3.onItemDelete({
            item: item,
            items: _this3.getItems()
          });
        }
      });
      if (_.isFunction(this.onChange)) {
        this.onChange({
          type: "clear",
          items: this.getItems()
        });
      }
    }
  }, {
    key: "getItems",
    value: function getItems() {
      return this.items.map(function (item) {
        return {
          id: item.id,
          value: item.value,
          isNew: item.isNew
        };
      });
    }
  }, {
    key: "setItems",
    value: function setItems(newItems) {
      this.items = newItems.map(function (item) {
        if (typeof item === "string") {
          return {
            id: null,
            value: item,
            isNew: true,
            _originalValue: item
          };
        }
        return _.extend({
          isNew: false,
          _originalValue: item.value
        }, item);
      });
      this._originalOrder = this.items.map(function (item) {
        return item.id;
      });
      this.updateItems();
      this.clearError();
      if (_.isFunction(this.onChange)) {
        this.onChange({
          type: "set",
          items: this.getItems()
        });
      }
    }
  }, {
    key: "getChangeSummary",
    value: function getChangeSummary() {
      var _this4 = this;
      var added = this.items.filter(function (item) {
        return item.isNew;
      });
      var removed = this._removedItems.map(function (item) {
        return {
          id: item.id,
          value: item._originalValue || item.value
        };
      });
      var modified = this.items.filter(function (item) {
        return !item.isNew && item._originalValue !== item.value;
      });
      var currentOrder = this.items.map(function (item) {
        return item.id;
      });
      var reordered = this.items.filter(function (item) {
        return !item.isNew;
      }).map(function (item) {
        return {
          id: item.id,
          value: item.value,
          oldIndex: _this4._originalOrder.indexOf(item.id),
          newIndex: currentOrder.indexOf(item.id)
        };
      }).filter(function (item) {
        return item.oldIndex !== item.newIndex && item.oldIndex !== -1;
      });
      return {
        added: added.map(function (item) {
          return {
            id: item.id,
            value: item.value
          };
        }),
        removed: removed,
        modified: modified.map(function (item) {
          return {
            id: item.id,
            value: item.value,
            oldValue: item._originalValue
          };
        }),
        reordered: reordered,
        all: this.getItems()
      };
    }
  }, {
    key: "onInputKeydown",
    value: function onInputKeydown(e) {
      if (e.key === "Enter") {
        e.preventDefault();
        var $input = this.$(".multi-input");
        var value = $input.val();
        if (this.addItem(value)) {
          $input.val("");
        }
      }
    }
  }, {
    key: "onItemRemove",
    value: function onItemRemove(e) {
      e.stopPropagation();
      var index = parseInt($(e.target).data("index"), 10);
      this.removeItem(index);
      this.clearError();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange() {
      this.clearError();
    }
  }, {
    key: "onItemInputChange",
    value: function onItemInputChange(e) {
      var $input = $(e.target);
      var index = parseInt($input.data("index"), 10);
      var newValue = $input.val();
      this.editItem(index, newValue);
    }
  }, {
    key: "onItemInputKeydown",
    value: function onItemInputKeydown(e) {
      if (e.key === "Enter") {
        e.preventDefault();
        e.stopPropagation();
        var $input = $(e.target);
        var index = parseInt($input.data("index"), 10);
        var newValue = $input.val();
        this.editItem(index, newValue);
        $input.blur();
      } else if (e.key === "Escape") {
        e.preventDefault();
        var _$input = $(e.target);
        var _index = parseInt(_$input.data("index"), 10);
        if (_index >= 0 && _index < this.items.length) {
          _$input.val(this.items[_index].value);
        }
        _$input.blur();
      }
    }
  }, {
    key: "onItemInputBlur",
    value: function onItemInputBlur(e) {
      var $input = $(e.target);
      var index = parseInt($input.data("index"), 10);
      var newValue = $input.val().trim();
      if (newValue && index >= 0 && index < this.items.length) {
        var item = this.items[index];
        if (item.value !== newValue) {
          this.editItem(index, newValue);
        }
        if (_.isFunction(this.onItemBlur)) {
          this.onItemBlur({
            item: item,
            index: index
          });
        }
      }
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this.$(".multi-input").focus();
    }
  }, {
    key: "viewWillUnRendered",
    value: function viewWillUnRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDMultInputWithEditView.prototype), "viewWillUnRendered", this).call(this);
      this.clearDragEvents();
    }
  }], [{
    key: "className",
    value: function className() {
      return "MDMultInputWithEditView";
    }
  }]);
  return MDMultInputWithEditView;
}(_MMViewBase2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1197":1197,"1412":1412,"1415":1415,"1418":1418,"1421":1421,"1426":1426,"1429":1429,"1430":1430,"1432":1432,"1454":1454,"1463":1463,"1466":1466,"1475":1475,"1498":1498,"1537":1537,"22":22}],46:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1498);
require(1477);
require(1492);
var _typeof2 = _interopRequireDefault(require(1197));
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMViewBase2 = _interopRequireDefault(require(22));
var _xss = _interopRequireDefault(require(109));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /*
 * @Author: jichao
 * @Date: 2026-07-08 15:30:00
 * @FilePath: \WebContent\javascript\base\component\input\MDInputView.js
 */
var MDInputView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MDInputView, _MMViewBase);
  function MDInputView() {
    (0, _classCallCheck2["default"])(this, MDInputView);
    return _callSuper(this, MDInputView, arguments);
  }
  (0, _createClass2["default"])(MDInputView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n      <div class=\"md-input-container\">\n        <input type=\"text\"\n               class=\"md-input form-control\"\n               <% if (placeholder) { %>placeholder=\"<%= placeholder %>\"<% } %>\n               <% if (defaultValue) { %>value=\"<%= defaultValue %>\"<% } %>\n               <% if (disabled) { %>disabled=\"disabled\"<% } %>\n               <% if (maxLength) { %>maxlength=\"<%= maxLength %>\"<% } %>\n               />\n        <div class=\"helper-text\"></div>\n        <div class=\"error-message\"></div>\n      </div>\n    ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDInputView.prototype), "className", this).call(this);
      return "".concat(superCls, " md-input-view");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDInputView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        placeholder: '',
        defaultValue: '',
        disabled: false,
        required: false,
        type: 'string',
        helperText: '',
        maxLength: 50,
        onChange: _.noop,
        onBlur: _.noop,
        onEnter: _.noop,
        onError: _.noop,
        validator: null,
        errorMessage: ''
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDInputView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'input .md-input': this._onInput,
        'blur .md-input': this._onBlur,
        'keydown .md-input': this._onKeydown
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDInputView.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "render",
    value: function render(data) {
      var placeholder = this.placeholder;
      var helperText = this.helperText;
      if (!placeholder) {
        switch (this.type) {
          case 'float':
            placeholder = BabelStr.str(40232);
            break;
          case 'number':
            placeholder = BabelStr.str(40234);
            break;
          case 'string':
          default:
            placeholder = BabelStr.str(3294);
            break;
        }
      }
      if (!helperText) {
        switch (this.type) {
          case 'float':
            helperText = BabelStr.str(40233);
            break;
          case 'number':
            helperText = BabelStr.str(40235);
            break;
          case 'string':
          default:
            helperText = BabelStr.str(40239, {
              num: this.maxLength
            });
            break;
        }
      }
      data = _.extend(data || {}, {
        placeholder: placeholder,
        defaultValue: this.defaultValue,
        disabled: this.disabled,
        maxLength: this.maxLength
      });
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDInputView.prototype), "render", this).call(this, data);
      if (helperText) {
        this.$('.helper-text').text(helperText);
      }
    }
  }, {
    key: "_onInput",
    value: function _onInput(e) {
      var value = $(e.target).val();
      this.clearError();
      if (_.isFunction(this.onChange)) {
        this.onChange({
          value: value,
          isValid: this._validate(value)
        });
      }
    }
  }, {
    key: "_onBlur",
    value: function _onBlur(e) {
      var value = $(e.target).val();
      var isValid = this._validate(value);
      if (_.isFunction(this.onBlur)) {
        this.onBlur({
          value: value,
          isValid: isValid
        });
      }
    }
  }, {
    key: "_onKeydown",
    value: function _onKeydown(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var value = $(e.target).val();
        var isValid = this._validate(value);
        if (_.isFunction(this.onEnter)) {
          this.onEnter({
            value: value,
            isValid: isValid
          });
        }
      }
    }
  }, {
    key: "_validate",
    value: function _validate(value) {
      value = value || '';
      var trimmedValue = value.trim();
      if (this.required && !trimmedValue) {
        this.updateError(BabelStr.str(3430));
        return false;
      }
      if (!trimmedValue) {
        return true;
      }
      if (!_xss["default"].checkXSS(value)) {
        this.updateError(BabelStr.str(40241));
        return false;
      }
      var isValid = true;
      var errorMsg = '';
      switch (this.type) {
        case 'number':
          isValid = /^-?\d+$/.test(trimmedValue);
          errorMsg = BabelStr.str(7505);
          break;
        case 'float':
          isValid = /^-?\d+(\.\d+)?$/.test(trimmedValue);
          errorMsg = BabelStr.str(7505);
          break;
        case 'string':
        default:
          isValid = true;
          if (this.maxLength && trimmedValue.length > this.maxLength) {
            isValid = false;
            errorMsg = BabelStr.str(40239).replace('{-num-}', this.maxLength);
          }
          break;
      }
      if (!isValid) {
        this.updateError(errorMsg);
        return false;
      }
      if (_.isFunction(this.validator)) {
        var result = this.validator(value);
        if (result && (0, _typeof2["default"])(result) === 'object') {
          if (!result.valid) {
            this.updateError(result.message || BabelStr.str(40219));
            return false;
          }
        } else if (result === false) {
          this.updateError(BabelStr.str(40219));
          return false;
        }
      }
      return true;
    }
  }, {
    key: "validate",
    value: function validate() {
      var value = this.getValue();
      return this._validate(value);
    }
  }, {
    key: "validateNonEmpty",
    value: function validateNonEmpty() {
      var value = this.getValue().trim();
      if (!value) {
        var msg = BabelStr.str(40222);
        this.updateError(msg);
        if (_.isFunction(this.onError)) {
          this.onError('empty', msg);
        }
        return false;
      }
      this.clearError();
      return true;
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var $input = this.$('.md-input');
      return $input.val() || '';
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      var $input = this.$('.md-input');
      $input.val(value);
      this.clearError();
      if (_.isFunction(this.onChange)) {
        this.onChange({
          value: value,
          isValid: this._validate(value)
        });
      }
    }
  }, {
    key: "updateError",
    value: function updateError(message) {
      this.errorMessage = message || '';
      var $error = this.$('.error-message');
      $error.text(this.errorMessage);
      this.$el.toggleClass('has-error', !!this.errorMessage);
    }
  }, {
    key: "clearError",
    value: function clearError() {
      this.updateError('');
    }
  }, {
    key: "focus",
    value: function focus() {
      this.$('.md-input').focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.$('.md-input').blur();
    }
  }, {
    key: "disable",
    value: function disable() {
      this.$('.md-input').prop('disabled', true);
      this.disabled = true;
    }
  }, {
    key: "enable",
    value: function enable() {
      this.$('.md-input').prop('disabled', false);
      this.disabled = false;
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MDInputView';
    }
  }]);
  return MDInputView;
}(_MMViewBase2["default"]);

},{"109":109,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1197":1197,"1454":1454,"1463":1463,"1475":1475,"1477":1477,"1492":1492,"1498":1498,"22":22}],109:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1477);
/*
 * @Author: jichao
 * @Date: 2026-07-10 15:30:00
 * @FilePath: \WebContent\javascript\base\tools\xss.js
 */
var _default = exports["default"] = {
  checkXSS: function checkXSS(value) {
    if (!value) return true;
    var xssPatterns = [/<script[\s\S]*?>[\s\S]*?<\/script>/gi, /javascript\s*:/gi, /data\s*:\s*(?:text\/html|image\/svg\+xml)/gi, /on\w+\s*=\s*["']?[^"']*["']?/gi, /<iframe[\s\S]*?>/gi, /<img[\s\S]*?>/gi, /<svg[\s\S]*?>[\s\S]*?<\/svg>/gi, /<embed[\s\S]*?>/gi, /<object[\s\S]*?>[\s\S]*?<\/object>/gi, /<applet[\s\S]*?>[\s\S]*?<\/applet>/gi, /<body[\s\S]*?>/gi, /<style[\s\S]*?>[\s\S]*?<\/style>/gi, /<link[\s\S]*?>/gi, /<meta[\s\S]*?>/gi, /<form[\s\S]*?>[\s\S]*?<\/form>/gi];
    for (var _i = 0, _xssPatterns = xssPatterns; _i < _xssPatterns.length; _i++) {
      var pattern = _xssPatterns[_i];
      if (pattern.test(value)) {
        return false;
      }
    }
    return true;
  }
};

},{"1454":1454,"1477":1477}],45:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMViewBase2 = _interopRequireDefault(require(22));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /*
 * @Author: jichao
 * @Date: 2026-07-08 15:45:00
 * @FilePath: \WebContent\javascript\base\component\input\MDDatePickerView.js
 */
var MDDatePickerView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MDDatePickerView, _MMViewBase);
  function MDDatePickerView() {
    (0, _classCallCheck2["default"])(this, MDDatePickerView);
    return _callSuper(this, MDDatePickerView, arguments);
  }
  (0, _createClass2["default"])(MDDatePickerView, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n      <div class=\"md-datepicker-container datepicker \">\n        <input type=\"text\"\n               class=\"md-datepicker-input form-control\"\n               <% if (placeholder) { %>placeholder=\"<%= placeholder %>\"<% } %>\n               <% if (disabled) { %>disabled=\"disabled\"<% } %>\n               readonly=\"readonly\"\n               />\n        <span class=\"ep-ic-date ep-ic\"></span>\n      </div>\n      <div class=\"helper-text\"></div>\n      <div class=\"error-message\"></div>\n    ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDatePickerView.prototype), "className", this).call(this);
      return "".concat(superCls, " md-datepicker-view");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDatePickerView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        placeholder: '',
        defaultDate: null,
        minDate: null,
        maxDate: null,
        disabled: false,
        required: false,
        dateFormat: 'yy-mm-dd',
        helperText: '',
        onChange: _.noop,
        errorMessage: '',
        _datepickerInitialized: false
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDatePickerView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'focus .md-datepicker-input': '_onFocus',
        'blur .md-datepicker-input': '_onBlur'
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDatePickerView.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "render",
    value: function render(data) {
      var placeholder = this.placeholder || BabelStr.str(3231);
      var helperText = this.helperText || BabelStr.str(40231);
      data = _.extend(data || {}, {
        placeholder: placeholder,
        disabled: this.disabled
      });
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDatePickerView.prototype), "render", this).call(this, data);
      if (helperText) {
        this.$('.helper-text').text(helperText);
      }
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDatePickerView.prototype), "viewDidRendered", this).call(this);
      this._initDatepicker();
    }
  }, {
    key: "_initDatepicker",
    value: function _initDatepicker() {
      var $input = this.$('.md-datepicker-input');
      var self = this;
      var options = {
        dateFormat: this.dateFormat,
        onSelect: function onSelect(dateText) {
          var date = $input.datepicker('getDate');
          if (_.isFunction(self.onChange)) {
            self.onChange({
              date: date,
              dateText: dateText,
              timestamp: date ? date.getTime() : null
            });
          }
          self.validate();
        }
      };
      if (this.minDate !== null && this.minDate !== undefined) {
        options.minDate = this.minDate;
      }
      if (this.maxDate !== null && this.maxDate !== undefined) {
        options.maxDate = this.maxDate;
      }
      $input.datepicker(options);
      this._datepickerInitialized = true;
      if (this.defaultDate) {
        $input.datepicker('setDate', this.defaultDate);
      }
    }
  }, {
    key: "_onFocus",
    value: function _onFocus() {
      if (!this._datepickerInitialized) {
        return;
      }
      this.$('.md-datepicker-input').datepicker('show');
    }
  }, {
    key: "_onBlur",
    value: function _onBlur() {
      this.validate();
    }
  }, {
    key: "getDate",
    value: function getDate() {
      if (!this._datepickerInitialized) {
        return null;
      }
      return this.$('.md-datepicker-input').datepicker('getDate');
    }
  }, {
    key: "setDate",
    value: function setDate(date) {
      if (!this._datepickerInitialized) {
        return;
      }
      this.$('.md-datepicker-input').datepicker('setDate', date);
      if (_.isFunction(this.onChange)) {
        var currentDate = this.getDate();
        this.onChange({
          date: currentDate,
          dateText: currentDate ? this.$('.md-datepicker-input').val() : '',
          timestamp: currentDate ? currentDate.getTime() : null
        });
      }
    }
  }, {
    key: "getTimestamp",
    value: function getTimestamp() {
      var date = this.getDate();
      return date ? date.getTime() : null;
    }
  }, {
    key: "setMinDate",
    value: function setMinDate(minDate) {
      this.minDate = minDate;
      if (this._datepickerInitialized) {
        this.$('.md-datepicker-input').datepicker('option', 'minDate', minDate);
      }
    }
  }, {
    key: "setMaxDate",
    value: function setMaxDate(maxDate) {
      this.maxDate = maxDate;
      if (this._datepickerInitialized) {
        this.$('.md-datepicker-input').datepicker('option', 'maxDate', maxDate);
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      if (this._datepickerInitialized) {
        this.$('.md-datepicker-input').datepicker('setDate', null);
        this.$('.md-datepicker-input').val('');
      }
    }
  }, {
    key: "validate",
    value: function validate() {
      var date = this.getDate();
      if (this.required && !date) {
        this.updateError(BabelStr.str(3430));
        return false;
      }
      this.clearError();
      return true;
    }
  }, {
    key: "updateError",
    value: function updateError(message) {
      this.errorMessage = message || '';
      var $error = this.$('.error-message');
      $error.text(this.errorMessage);
      this.$el.toggleClass('has-error', !!this.errorMessage);
    }
  }, {
    key: "clearError",
    value: function clearError() {
      this.updateError('');
    }
  }, {
    key: "disable",
    value: function disable() {
      this.disabled = true;
      this.$('.md-datepicker-input').prop('disabled', true);
    }
  }, {
    key: "enable",
    value: function enable() {
      this.disabled = false;
      this.$('.md-datepicker-input').prop('disabled', false);
    }
  }, {
    key: "viewWillUnRendered",
    value: function viewWillUnRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDatePickerView.prototype), "viewWillUnRendered", this).call(this);
      if (this._datepickerInitialized) {
        try {
          this.$('.md-datepicker-input').datepicker('destroy');
        } catch (e) {
          // datepicker may already be destroyed
        }
        this._datepickerInitialized = false;
      }
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MDDatePickerView';
    }
  }]);
  return MDDatePickerView;
}(_MMViewBase2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"22":22}],38:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1438);
require(1477);
require(1489);
require(1437);
require(1463);
require(1478);
require(1421);
require(1498);
require(1424);
require(1415);
require(1417);
require(1439);
var _MMViewBase = _interopRequireDefault(require(22));
var _regexp = _interopRequireDefault(require(106));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDMolaUser = _interopRequireDefault(require(272));
/**
 * Choose 组件支持在输入框中一次输入多个数据项目，
 * 支持从下拉列表中进行多选,并且支持键盘选中下拉列表中的项，类似于Combox
 * 参考:  https://www.zellerda.com/projects/tokenize
 * Created by manjun.han
 */

var Keycode = {
  BACKSPACE: 8,
  TAB: 9,
  UP: 38,
  DONW: 40,
  ESC: 27,
  ENTER: 13,
  ARROW_UP: 38,
  ARROW_DOWN: 40,
  SPACE: 32,
  // 空格
  COMMA: 188,
  //  逗号
  SEMICOLON: 186,
  // 分号
  DOT: 188
};
var _default = exports["default"] = _MMViewBase["default"].extend({
  el: '<div class="chooser"></div>',
  tmpl: '<div class="placeholder"></div>\
            <ul class="chosen-list">\
              <li class="input"> \
                <input class="chooser-input">\
              </li>\
            </ul>\
          <ul class="dropdown"></ul>',
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click': this._onChooserClickHandler,
      'click    .chosen-list .close': this._chooseCloseClickHandler,
      'keydown  .chooser-input': this._onInputKeydownHandler,
      'keyup    .chooser-input': this._onInputKeyupHandler,
      'input    .chooser-input': this._onInputHandler
    });
  },
  /**
   * @param  {[type]} opt [description]
   * @return {[type]}     [description]
   */
  initialize: function initialize(opt) {
    var self = this;
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.bindSelf([this.removeChoose, this._dropdownListMouseEnterHandler, this._dropdownListClickHandler, this._dropdownListMouseDownHandler, this._pageMouseupHandler]);
    this.$(".chooser-input").attr("disabled", this.disabled);
    this._initValidateInput();
    this.$chooseList = this.$('.chosen-list');
    this.$dropdown = this.$('.dropdown');
    this.$placeholder = this.$('.placeholder');
    this.$textWrapper = $('<span class="char-width"></span>').appendTo('body');
    this.$input = this.$(".chooser-input");
    this.setEnabled(this.enabled);
    this.$placeholder.text(this.placeholder);
    this.$dropdown.css('max-height', this.dropDownMaxHeight);
    if (this.hasDropdown) {
      this._renderDropdownList(this.datas);
      this.$el.on('mousedown', '.dropdown>li.d-item', this._dropdownListMouseDownHandler);
      this.$el.on('click', '.dropdown>li.d-item', this._dropdownListClickHandler);
      this.$el.on('mouseenter', '.dropdown>li.d-item', this._dropdownListMouseEnterHandler);
    } else {
      this.$dropdown.remove();
    }
    this._pageMouseupHandler = _.bind(this._pageMouseupHandler, this);
    $(document).on(this.$nsEventName('mouseup.choserPlugin'), this._pageMouseupHandler);
    this._setDefaultSelectedDatas(this.defaultSelectedDatas);
    this._initDelegateEvents();
  },
  _initDelegateEvents: function _initDelegateEvents() {
    var delegateEvents = this.delegateEvents;
    var events = _.isFunction(delegateEvents) ? delegateEvents.call(this) : delegateEvents;
    if (!events) return;
    var delegateEventSplitter = /^(\S+)\s*(.*)$/;
    this._undelegatePluginEvents();
    for (var key in events) {
      var method = events[key];
      if (!_.isFunction(method)) {
        method = this[method];
      }
      if (!method) continue;
      var match = key.match(delegateEventSplitter);
      this._delegatePlugin(match[1], match[2], _.bind(method, this));
    }
    return this;
  },
  _delegatePlugin: function _delegatePlugin(eventName, selector, listener) {
    this.$el.on(this.$nsEventName(eventName), selector, listener);
    return this;
  },
  _undelegatePluginEvents: function _undelegatePluginEvents() {
    this.$el.off(this.$nsEventName());
  },
  _initValidateInput: function _initValidateInput() {
    var self = this;
    var validateInput = this.validateInput;
    var allowInputSame = this.allowInputSame;
    var onReachMaxInputNumber = this.onReachMaxInputNumber;
    var onInputSame = this.onInputSame;
    this.validateInput = function (data) {
      var hasSame = false;
      if (!data) {
        return false;
      }
      var isDataString = $.type(data) === 'string';
      if (!allowInputSame) {
        var $list = self.$chooseList.children('.chosen');
        var curSelects = $.grep($list, function (li, index) {
          var curData = $(li).data('data-item');
          return self._equal(data, curData);
        });
        hasSame = curSelects.length > 0;
      }
      var hasReachMaxLength = this.hasReachMaxLength();
      hasReachMaxLength && onReachMaxInputNumber.call(self);
      hasSame && onInputSame.call(self);
      var isValid = false;
      if (isDataString) {
        isValid = validateInput.call(self, data);
      } else if (data instanceof _MDMolaUser["default"]) {
        isValid = validateInput.call(self, data);
      } else {
        isValid = data.phone || data.email;
      }
      return !hasReachMaxLength && !hasSame && isValid;
    };
  },
  hasReachMaxLength: function hasReachMaxLength() {
    if (this.maxInputNumber < 0) {
      return false;
    }
    var $list = this.$chooseList.children('.chosen');
    return $list.length == this.maxInputNumber;
  },
  _equal: function _equal(arg1, arg2) {
    if (this.dataEqual) {
      return this.dataEqual(arg1, arg2);
    }
    var textField = this.textField;
    var isArg1String = $.type(arg1) === 'string';
    var isArg2String = $.type(arg1) === 'string';
    if (isArg1String && !isArg2String) {
      return arg1.toString() == arg2[textField].toString();
    } else if (!isArg1String && isArg2String) {
      return arg1[textField].toString() == arg2.toString();
    } else if (isArg1String && isArg2String) {
      return arg1.toString() == arg2.toString();
    } else if ($.isFunction(arg1.equal)) {
      return arg1.equal(arg2);
    } else {
      return arg1 === arg2;
    }
  },
  _setDefaultSelectedDatas: function _setDefaultSelectedDatas(selectedDatas) {
    var self = this;
    selectedDatas = $.isArray(selectedDatas) ? selectedDatas : [];
    $.each(selectedDatas, function (index, val) {
      self._appendChosen(val);
    });
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      blurToChoose: false,
      // 失去焦点后是否自动添加chooser

      allowInput: true,
      // 是否允许输入，

      delegateEvents: {},
      // 事件代理对象，用来自定义事件处理，如下拉列表

      enableAutoFilter: false,
      // 是否允许自动过滤下拉列表的数据

      showEmptyFilterResult: false,
      // 过滤结果为空的提示

      filterFun: function filterFun(datas, text) {
        // 自定义过滤函数
        var self = this;
        return $.grep(datas, function (item, index) {
          var val = self._getDataText(item);
          if (val.indexOf(text) >= 0) {
            return true;
          }
        });
      },
      autoChoose: true,
      // 点击dropdown列表项目时是否自动选中添加到choose中

      enabled: true,
      datas: [],
      // 数据列表

      defaultSelectedDatas: [],
      // 默认选中的数据

      // less than zero , allow input any number
      maxInputNumber: 30,
      // 可输入的最大值

      allowInputSame: false,
      // 是否允许重复项存在

      validateInput: function validateInput(data) {
        // chooser的校验器，只有校验通过的数据才能添加到chooser中

        return true;
      },
      chosenItemRenderer: function chosenItemRenderer(data) {
        // chooser的渲染器，可以对其进行自定义操作
        var text = this._getDataText(data);
        if (!text || text.length == 0) {
          return false;
        }
        return '<a>' + text + '</a>';
      },
      placeholder: '',
      // 输入提示文字占位符

      dropDownMaxHeight: 300,
      // 下拉选项列表的最大高度值

      textField: 'label',
      // 对象的text字段名称

      backspaceOnceToRemove: false,
      // 按一次backspace键是否自动删除choose项目，默认会保留给出删除提示，再次按backspace删除

      keepText: false,
      // 是否保留文字，否则直接就把chooser的整个删掉

      focusShow: true,
      // input获取焦点时是否自动显示下拉列表

      onDropdownShow: $.noop,
      // 下拉列表显示回调

      onDropdownHide: $.noop,
      // 下拉列表关闭回调

      onInputSame: $.noop,
      // 在输入相同值时的回调，可以用来提示用户

      onReachMaxInputNumber: $.noop,
      // 在超过输入最大值的回调

      onChooseOptionClick: $.noop,
      // 在下拉列表中的choose项目点击时的回调

      onChange: $.noop,
      // 当chooser的个数变化时的回调

      onAdd: $.noop,
      onRemove: $.noop,
      onClear: $.noop,
      dataEqual: undefined,
      hasDropdown: true,
      disabled: false,
      formateChoosedData: function formateChoosedData(data) {
        var textField = this.textField;
        var isString = $.type(data) === 'string';
        if (isString) {
          data = $.trim(data);
          if (data.length == 0) return;
          $.each(this.datas, function () {
            if (this == data || this[textField] == data) {
              data = this;
              return false;
            }
          });
        }
        return data;
      },
      // 下拉列表项渲染器
      dropdownRenderer: function dropdownRenderer(data) {
        var text = $.type(data) === 'string' ? data : data['label'];
        var res = [];
        res.push('<div class="c-content"><span>');
        res.push(text);
        res.push('</span></div>');
        return res.join("");
      },
      emptyRenderer: function emptyRenderer(text) {
        return '<li class="no-match">' + BabelStr.str(7011) + '<span>' + text + '</span>' + BabelStr.str(7012) + '</li>';
      },
      cls: {
        selector: 'selector',
        dropdownItemHover: 's-hover',
        dropdownItemDisabled: 's-disable'
      }
    });
  },
  _renderDropdownList: function _renderDropdownList(datas) {
    var self = this;
    var res = [];
    var text = this.$input.val();
    this.$dropdown.empty();
    if (datas && datas.length > 0) {
      var tree = document.createDocumentFragment();
      $.each(datas, function (index, val) {
        var $li = $('<li class="d-item">');
        var content = self.dropdownRenderer.call(self, val);
        $li.append(content).data('data-item', val);
        tree.appendChild($li[0]);
      });
      this.$dropdown.append(tree);
    } else if (this.showEmptyFilterResult) {
      res = this.emptyRenderer.call(this, text);
      this.$dropdown.append(res);
    } else {
      this.hideDropdown();
    }
  },
  _onInputKeydownHandler: function _onInputKeydownHandler($e) {
    var code = $e.which;
    if (!this.allowInput && code !== Keycode.BACKSPACE) {
      $e.preventDefault();
      return;
    }
    var val = this.$input.val();
    switch (code) {
      case Keycode.BACKSPACE:
        this._onBackspace($e);
        this._onInputCharacter();
        break;
      case Keycode.ARROW_DOWN:
        this._onArrow(false);
        break;
      case Keycode.ARROW_UP:
        this._onArrow(true);
        break;
      case Keycode.ESC:
        this._onEsc($e);
        break;
      case Keycode.ENTER:
      case Keycode.COMMA: // 逗号
      case Keycode.SPACE: // 
      case Keycode.SEMICOLON:
        // 分号      
        $e.preventDefault();
        this.onEnter($e);
        break;
      case Keycode.TAB:
      case Keycode.DOT:
        this._appendChosen(val);
        $e.preventDefault();
        break;
      default:
    }
    if (this.hasReachMaxLength() && Keycode.BACKSPACE !== code) {
      $e.preventDefault();
    }
  },
  _onEsc: function _onEsc($e) {
    this.hideDropdown();
    return false;
  },
  _onInputCharacter: function _onInputCharacter() {
    this.$textWrapper.text(this.$input.val());
    var width = this.$textWrapper.width() + 6;
    this.$input.css("width", width + 'px');
  },
  _onArrow: function _onArrow(isUp) {
    if (!this.isEnabled() || !this._dropdownListShown() || !this._hasDropdownItem()) {
      return;
    }
    var $items = this.$dropdown.children('.d-item');
    var curSelectedIndex = $items.filter(".active").index();
    isUp ? curSelectedIndex-- : curSelectedIndex++;
    if (curSelectedIndex < 0) {
      curSelectedIndex = $items.length - 1;
    }
    if (curSelectedIndex >= $items.length) {
      curSelectedIndex = 0;
    }
    $items.removeClass("active");
    var $curItem = $items.eq(curSelectedIndex);
    $curItem.addClass("active");
    this._scrollToIndex(curSelectedIndex, isUp);
  },
  _scrollToIndex: function _scrollToIndex(curSelectedIndex, up) {
    var $children = this.$dropdown.children('.d-item');
    var $item = $children.eq(curSelectedIndex);
    var length = $children.length;
    var scrollTop = 0;
    if (!this._itemTotalInViewPort($item)) {
      if (up) {
        if (curSelectedIndex < length - 1) {
          scrollTop = $item[0].offsetTop;
        } else {
          scrollTop = this.$dropdown[0].scrollHeight - this.$dropdown.height();
        }
      } else {
        if (curSelectedIndex > 0) {
          scrollTop = $item[0].offsetTop + $item.outerHeight() - this.$dropdown.height();
        } else {
          scrollTop = 0;
        }
      }
      this.$dropdown.scrollTop(scrollTop);
    }
    $children.removeClass('active');
    $item.addClass('active');
  },
  _dropdownListMouseEnterHandler: function _dropdownListMouseEnterHandler($e) {
    this.$dropdown.children('.d-item').removeClass('active');
    $($e.currentTarget).addClass('active');
  },
  _chooseCloseClickHandler: function _chooseCloseClickHandler($e) {
    var data = $($e.currentTarget).closest('li').data('data-item');
    this.removeChoose(data);
    var self = this;
    // refocus input , need a timer
    setBabelTimeout(function () {
      self.$input.focus();
    }, 300);
    if (this.enableAutoFilter) {
      $e.stopPropagation();
    }
  },
  _itemTotalInViewPort: function _itemTotalInViewPort(item) {
    var $item = $(item);
    var itemHeight = $item.outerHeight();
    var $viewPort = this.$dropdown;
    var viewPortHeight = $viewPort.outerHeight();
    var scrollTop = $viewPort.scrollTop();
    var y = $item[0].offsetTop - scrollTop;
    return y >= 0 && y + itemHeight <= viewPortHeight;
  },
  _onBackspace: function _onBackspace($e) {
    var val = this.$input.val();
    var self = this;
    var data = "";
    if (val.length == 0) {
      var $last = this.$chooseList.children('.chosen').last();
      if ($last.length > 0) {
        var remove = false;
        if (!this.backspaceOnceToRemove) {
          if ($last.hasClass('pre-remove')) {
            remove = true;
          } else {
            $last.addClass('pre-remove');
          }
        } else {
          remove = true;
        }
        if (remove) {
          // 保留文字的话，禁用删除当前字符
          if (this.keepText) {
            data = $last.data('data-item');
            $e.preventDefault();
          }
          this.removeChoose($last.data('data-item'));
          self.$input.val(self._getDataText(data));
        }
        val = this.$input.val();
      }
    }
    this._updatePlaceholder();
    this._updateDropdownPos();
  },
  _onInputKeyupHandler: function _onInputKeyupHandler($e) {
    var val = this.$input.val();
    this._updatePlaceholder();
    var code = $e.which;
    if (code == Keycode.ESC) {
      this._onEsc($e);
    }
  },
  _onInputHandler: function _onInputHandler($e) {
    var text = this.$input.val();
    this._updatePlaceholder();
    if (this.hasDropdown) {
      this._updateDropdown(text);
      if (this._canShowDropdown()) {
        this.showDropdown();
      }
    }
    this._onInputCharacter();
    this.$chooseList.children('.chosen').last().removeClass('pre-remove');
  },
  _updateDropdown: function _updateDropdown(text) {
    var datas = this.datas;
    var self = this;
    var res = datas;
    if (this.enableAutoFilter && text.length > 0) {
      res = this.filterFun.call(this, datas, text) || [];
    }
    this._renderDropdownList(res);
    return res;
  },
  _updateDropdownPos: function _updateDropdownPos() {
    var height = this.$el.outerHeight();
    var width = this.$el.outerWidth();
    var hBorderWidth = 2;
    this.$dropdown.css('top', height).width(width - hBorderWidth);
  },
  showDropdown: function showDropdown() {
    if (this.datas.length == 0) {
      return;
    }
    this._updateDropdownPos();
    this.$dropdown.show();
    this.onDropdownShow();
  },
  hideDropdown: function hideDropdown() {
    if (!this.hasDropdown) {
      return;
    }
    this.$dropdown.hide();
    this.$dropdown.children('.d-item').removeClass('active');
    this.onDropdownHide();
  },
  _updatePlaceholder: function _updatePlaceholder() {
    var text = this.$input.val();
    var hasChoose = this.$chooseList.children('.chosen').length > 0;
    if (text.length > 0 || hasChoose) {
      this.$placeholder.hide();
    } else {
      this.$placeholder.show();
    }
  },
  _pageMouseupHandler: function _pageMouseupHandler($e) {
    var target = $e.target;
    var clickInner = $.contains(this.el, target) || this.el == target;
    if (!clickInner) {
      this.$input.blur();
      this.hideDropdown();
      if (this.blurToChoose) {
        this._appendChosen(this.$input.val());
      }
    }
  },
  _dropdownListMouseDownHandler: function _dropdownListMouseDownHandler($e) {
    var $li = $($e.currentTarget);
    var data = $li.data('data-item');
    if (!this.autoChoose) {
      this.onChooseOptionClick(data);
    } else {
      this._appendChosen(data);
    }
  },
  _dropdownListClickHandler: function _dropdownListClickHandler($e) {
    $e.stopPropagation();
  },
  onEnter: function onEnter() {
    var text = this.$input.val();
    var data = text;
    var $curActive;
    if (this.hasDropdown && this._dropdownListShown() && this._hasDropdownItem()) {
      $curActive = this.$dropdown.children('.active');
      data = $curActive.length > 0 ? $curActive.data('data-item') : this.$dropdown.eq(0).find('.d-item').data("data-item");
      data = data || text;
    }
    this._appendChosen(data);
    if (!this._hasDropdownItem()) {
      this._renderDropdownList(this.datas);
    }
  },
  _hasDropdownItem: function _hasDropdownItem() {
    return !(this.$dropdown.children('.d-item').length == 0);
  },
  _appendChosen: function _appendChosen(data, opt_slient) {
    if ($.type(data) === 'string' && !data.length) {
      return;
    }
    data = this.formateChoosedData(data);
    if (!data) {
      return;
    }
    var validInput = this.validateInput.call(this, data);
    this.$chooseList.children('.chosen').last().removeClass('pre-remove');

    // data = this.onEnterbeforeAdd.call(this , data);

    var res = this.chosenItemRenderer.call(this, data);
    if (this.refuseInvalidInput && !validInput) {
      return;
    }
    if (!res) return;
    var classStr = validInput ? "" : "error-input";
    var $choose = $('<li class="chosen ' + classStr + '">' + res + '<i class="close">×</i></li>');
    $choose.data('data-item', data).insertBefore(this.$input.parent());
    if (!this.isEnabled()) {
      $choose.find('.close').remove();
    }
    this.$input.val("").focus();
    this._onInputCharacter();
    var $list = this.$chooseList.children('.chosen');
    if ($list.length == this.maxInputNumber) {
      // this.$input.attr("placeholder", "您已达到数量上限了！");
    } else {
      this.$input.attr("placeholder", "");
      this.$input.val("").focus();
    }
    if (!this.enableAutoFilter) {
      this.hideDropdown();
    }
    this._updatePlaceholder();
    this.hasDropdown && this._updateDropdownPos();
    if (!opt_slient) {
      this.onChange.call(this, data, true);
      this.onAdd.call(this, data);
    }
  },
  _onChooserClickHandler: function _onChooserClickHandler($e) {
    if (!this.isEnabled()) {
      return;
    }
    var text = this.$input.val();
    text = text.trim();
    if (this.hasDropdown && !this._dropdownListShown() && text) {
      this._updateDropdown(text);
    }
    this.$input.focus();
    if (this.hasDropdown && this.focusShow && this._canShowDropdown()) {
      this.showDropdown();
    }
    this._updatePlaceholder();
  },
  _canShowDropdown: function _canShowDropdown() {
    if (!this.hasDropdown) {
      return;
    }
    var showEmptyFilterResult = this.showEmptyFilterResult;
    var hasDropdownItem = this._hasDropdownItem();
    if (showEmptyFilterResult || !showEmptyFilterResult && hasDropdownItem) {
      return true;
    }
    return false;
  },
  _getDataText: function _getDataText(data) {
    return $.type(data) === 'string' ? data : data[this.textField];
  },
  _dropdownListShown: function _dropdownListShown() {
    return this.$dropdown.css('display') !== 'none';
  },
  clear: function clear(opt_slient) {
    opt_slient = opt_slient || false;
    var $chosens = this.$chooseList.children('.chosen');
    var self = this;
    $chosens.each(function () {
      var data = $(this).data('data-item');
      self.removeChoose(data, opt_slient);
    });
    this.onClear.call(this);
    !opt_slient && self.onChange.call(self, [], opt_slient);
    this._updateDropdownPos();
  },
  /**
   * 添加Chooser项目
   *
   * @param {[string|object]} data   要添加chooser的值，如果是对象的话，需要包含textField字段值
   * @param {[type]} opt_slient [description]
   */
  addChoose: function addChoose(data, opt_slient) {
    this._appendChosen(data, opt_slient);
  },
  removeChoose: function removeChoose(data, opt_slient) {
    var self = this;
    var $chosens = this.$chooseList.children('.chosen');
    $chosens.each(function () {
      var curData = $(this).data('data-item');
      if (self._equal(data, curData)) {
        $(this).remove();
        if (!opt_slient) {
          self.onRemove.call(self, data);
          self.onChange.call(self, data, false);
        }
        return false;
      }
    });
    this._updateDropdownPos();
    this._updatePlaceholder();
  },
  reset: function reset(datas) {
    this.$input.val("");
    this.datas = datas;
    this._renderDropdownList(datas);
    this._updateDropdownPos();
    this._updatePlaceholder();
  },
  getChosen: function getChosen() {
    var res = [];
    this.$chooseList.children('.chosen').each(function (index, el) {
      res.push($(el).data('data-item'));
    });
    return res;
  },
  getContact: function getContact() {
    var contact = {
      phones: [],
      emails: [],
      invalidNames: []
    };
    this.$chooseList.children('.chosen').each(function (index, el) {
      var data = $(el).data('data-item');
      if (data.phone) {
        contact.phones.push(data.phone);
      } else if (data.email) {
        contact.emails.push(data.email);
      } else {
        contact.invalidNames.push(data.name);
      }
    });
    return contact;
  },
  setEnabled: function setEnabled(enabled) {
    enabled ? this.$el.removeClass("disabled") : this.$el.addClass('disabled');
    this.enabled = enabled;
  },
  isEnabled: function isEnabled() {
    return this.enabled;
  },
  _request: function _request(url, params) {},
  hasChosen: function hasChosen(data) {
    var chosens = this.getChosen();
    var hasChosen = false;
    var chosen = $.each(chosens, function () {
      if (data == this) {
        hasChosen = true;
        return false;
      }
    });
    return hasChosen;
  },
  /**
   * 如果data包含在dropdown中，则返回索引和DOM对象
   *
   * @param  {[type]} data [description]
   * @return {[type]}      [description]
   */
  dropdownViewHasData: function dropdownViewHasData(data) {
    var self = this;
    var index = -1;
    var dom = null;
    this.$dropdown.children('.d-item').each(function (i, el) {
      var curData = $(el).data('data-item');
      if (self._equal(curData, data)) {
        index = i;
        dom = this;
        return false;
      }
    });
    return {
      dom: dom,
      index: index
    };
  },
  getTextVal: function getTextVal() {
    return this.$input.val();
  },
  chooseCurrent: function chooseCurrent() {
    this.addChoose(this.$input.val());
  },
  viewDidRendered: function viewDidRendered() {
    _MMViewBase["default"].prototype.viewDidRendered.call(this);
    var fontSize = this.$input.css('font-size');
    this.$textWrapper.css('font-size', fontSize);
  },
  viewDidUnRendered: function viewDidUnRendered() {
    this.$textWrapper.remove();
    $(document).off(this.$nsEventName('mouseup.choserPlugin'));
  },
  focus: function focus() {
    this.$input && this.$input.focus();
  }
}, {
  validateInputUserContactStr: function validateInputUserContactStr(data) {
    if (_.isString(data)) {
      if (!_regexp["default"].isEmail(data) && !_regexp["default"].isPhone(data)) return false;
    }
    return true;
  },
  checkAlertInputValid: function checkAlertInputValid(invalidNames) {
    if (invalidNames.length > 0) {
      var message = BabelStr.str(4507);
      for (var i = 0; i < invalidNames.length; i++) {
        var name = invalidNames[i];
        message += "  " + name;
      }
      var opt = {
        message: '<p>' + message + '</p>',
        width: 400,
        okFun: function okFun() {}
      };
      _MDAlertView["default"].showStandardPrompt(opt);
      return false;
    }
    return true;
  },
  Check2filterInvalid: function Check2filterInvalid(invalidNames) {
    if (invalidNames.length > 0) {
      var message = BabelStr.str(4508);
      for (var i = 0; i < invalidNames.length; i++) {
        var name = invalidNames[i];
        message += "  " + name;
      }
      var opt = {
        message: '<p>' + message + '</p>',
        width: 400,
        okFun: function okFun() {}
      };
      _MDAlertView["default"].showStandardPrompt(opt);
      return false;
    }
    return true;
  }
});

},{"106":106,"1184":1184,"1415":1415,"1417":1417,"1421":1421,"1424":1424,"1437":1437,"1438":1438,"1439":1439,"1454":1454,"1463":1463,"1477":1477,"1478":1478,"1489":1489,"1498":1498,"22":22,"272":272,"32":32}],36:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMViewBase2 = _interopRequireDefault(require(22));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
//
// Button view
// Created by manjun.han
// 2017.6.1
//
var MDButtonView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MDButtonView, _MMViewBase);
  function MDButtonView() {
    (0, _classCallCheck2["default"])(this, MDButtonView);
    return _callSuper(this, MDButtonView, arguments);
  }
  (0, _createClass2["default"])(MDButtonView, [{
    key: "el",
    value: function el() {
      if (this.textButton) {
        return "<span class=\"text-button\"></span>";
      } else {
        return "<button class=\"button\"></button>";
      }
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDButtonView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        disabled: false,
        selected: false,
        onClick: _.noop,
        type: '',
        label: ''
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDButtonView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click': this._onButtonClickHandler
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDButtonView.prototype), "initialize", this).call(this, props);
      this.setLabel(this.label);
      this.setButtonType(this.type);
    }
  }, {
    key: "_onButtonClickHandler",
    value: function _onButtonClickHandler($e) {
      if (this.isDisabled()) {
        return;
      }
      return this.onClick();
    }
  }, {
    key: "isDisabled",
    value: function isDisabled() {
      return this.$el.hasClass('disabled') || this.$el.prop('disabled');
    }
  }, {
    key: "setButtonType",
    value: function setButtonType(type) {
      if (!type) {
        return;
      }
      this.$el.addClass(type);
    }
  }, {
    key: "setLabel",
    value: function setLabel(label) {
      if (!label) {
        return;
      }
      this.label = label;
      this.$el.text(label);
    }
  }, {
    key: "setDisabled",
    value: function setDisabled(disabled) {
      this.disabled = disabled;
      if (disabled) {
        this.$el.addClass('disabled').prop('disabled', disabled);
      } else {
        this.$el.removeClass('disabled').prop('disabled', disabled);
      }
    }
  }]);
  return MDButtonView;
}(_MMViewBase2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"22":22}],29:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1461);
require(1417);
require(1463);
require(1494);
require(1477);
require(1495);
var _regexp = _interopRequireDefault(require(106));
var _MDSnackbarView = _interopRequireDefault(require(72));
// MDEditalbeTextDiv.js
// jiang
// 2017-6-7

/**
* @param props {
      parentDiv, classes, updatedCallback，text, disabelEdit
  }
*
*/

var MDEditalbeTextDiv = function MDEditalbeTextDiv(props) {
  var keys = Object.keys(props);
  for (var i = 0; i < keys.length; i++) {
    this[keys[i]] = props[keys[i]];
  }
  ;
  this.initialize(props);
};
var maxlength = 140;
_.extend(MDEditalbeTextDiv.prototype, {
  el: '<div class="disp-div-root">' + '<div class="disp-str ">' + '</div>' + '<div class="edit-str ">' + '<textarea maxlength="' + maxlength + '" class="form-control"></textarea>' + '<div class="tool-area">' + '<div class="tool-panel">' + '<button class="cancel-edit-btn icon"></button>' + '<button class="finish-edit-btn icon"></button>' + '</div>' + '</div>' + '</div>' + '</div>',
  registerEvents: function registerEvents() {
    var _this = this;
    this.$el.find('.disp-str').on('mousedown', function (e) {
      _this.clickinDispArea = true;
      return false;
    });
    this.$el.find('.disp-str').on('mouseup', function (e) {
      if (_this.clickinDispArea) {
        _this.toEdit();
      }
      ;
      _this.clickinDispArea = false;
      return false;
    });
    this.$el.find('.disp-str').on('mousedown', function (e) {
      return false;
    });
    this.$el.find('textarea').on('mousedown', function (e) {
      e.stopPropagation();
    });
    this.$el.find('textarea').on('keydown', function (e) {
      _this._keyDownHandle(e);
      e.stopPropagation();
    });
    this.$el.find('.finish-edit-btn').on('mousedown', function (e) {
      _this._hideEdit(true);
      e.stopPropagation();
    });
    $('body').on('mousedown.edit_div', function (e) {
      _this.clickoutside();
    });
  },
  _keyDownHandle: function _keyDownHandle($e) {
    var code = $e.which;
    if (code != 13) {
      return;
    }
    this._hideEdit(true);
  },
  initialize: function initialize(opt) {
    this.$el = $(this.el);
    $(this.parentDiv).append(this.$el);
    this.status = 'read';
    this.$el.find('.edit-str').hide();
    if (this.maxlength) {
      this.$el.find('textarea').attr('maxlength', this.maxlength);
    }
    ;
    if (this.placeholder) {
      this.$el.find('textarea').attr('placeholder', this.placeholder);
    }
    ;
    if (this.small) {
      this.$el.find('textarea').addClass('small');
    }
    if (opt.classes) {
      var classes = opt.classes.split(/\s+/);
      for (var i = 0; i < classes.length; i++) {
        var classstr = classes[i];
        this.$el.find('.disp-str').addClass(classstr);
        this.$el.find('.edit-str').addClass(classstr);
      }
      ;
    }
    ;
    var text = opt.text || "";
    this.$el.find('textarea').val(_.unescape(text));
    this._setStrDiv(text);
    if (!this.disabelEdit) {
      this.$el.find('.disp-str').addClass('enable');
      this.registerEvents();
    }
  },
  setText: function setText(str) {
    this._setStrDiv(str);
  },
  onClickOk: function onClickOk() {
    if (this.status == 'read') {
      this._showEdit();
    } else {
      this._hideEdit(true);
    }
  },
  _setStrDiv: function _setStrDiv(str) {
    this.text = str;
    str = str || this.placeholder;
    this.$el.find('.disp-str').text(_.unescape(str));
    this.$el.find('.disp-str').append('<span><div class="icon right-btn"/></span>');
  },
  _showEdit: function _showEdit() {
    if (this.disabelEdit) {
      return;
    }
    ;
    var text = this.text;
    if (this.text_tail) {
      text = text.substr(0, text.length - this.text_tail.length);
    }
    this.$el.find('textarea').val(_.unescape(text));
    this.status = 'edit';
    this.$el.find('.disp-str').hide();
    this.$el.find('.edit-str').show();
    this.$el.find('textarea').focus();
  },
  _hideEdit: function _hideEdit(update) {
    if (update) {
      var str = this.$el.find('textarea').val();
      if (str.length > maxlength) {
        str = str.substr(0, maxlength);
      }
      ;
      if (!_regexp["default"].validateTextinput(str)) {
        _MDSnackbarView["default"].show(BabelStr.str(12202));
        return;
      }
      this._setStrDiv(str);
      if (this.updatedCallback) {
        this.updatedCallback(str);
      }
      ;
    }
    ;
    this.$el.find('.disp-str').show();
    this.$el.find('.edit-str').hide();
    this.status = 'read';
  },
  clickoutside: function clickoutside(e) {
    this._hideEdit(false);
  },
  toEdit: function toEdit(e) {
    this._showEdit();
  },
  removeFromSuperView: function removeFromSuperView() {
    this.$el.remove();
    $('body').off('mousedown.edit_div');
    this.updatedCallback = null;
  },
  remove: function remove() {
    this.removeFromSuperView();
  },
  close: function close() {
    this.removeFromSuperView();
  }
});
var _default = exports["default"] = MDEditalbeTextDiv;

},{"106":106,"1184":1184,"1417":1417,"1454":1454,"1461":1461,"1463":1463,"1477":1477,"1494":1494,"1495":1495,"72":72}],1494:[function(require,module,exports){
'use strict';
var $ = require(1270);
var createHTML = require(1241);
var forcedStringHTMLMethod = require(1368);

// `String.prototype.small` method
// https://tc39.es/ecma262/#sec-string.prototype.small
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('small') }, {
  small: function small() {
    return createHTML(this, 'small', '', '');
  }
});

},{"1241":1241,"1270":1270,"1368":1368}],28:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1461);
require(1417);
require(1463);
require(1498);
var _keycode = _interopRequireDefault(require(104));
var _regexp = _interopRequireDefault(require(106));
var _MDSnackbarView = _interopRequireDefault(require(72));
// MDEditalbeInputDiv.js
// jiang
// 2017-6-7

/**
* @param props {
      parentDiv, classes, updatedCallback，text, disabelEdit
  }
*
*/

var MDEditalbeInputDiv = function MDEditalbeInputDiv(props) {
  var keys = Object.keys(props);
  for (var i = 0; i < keys.length; i++) {
    this[keys[i]] = props[keys[i]];
  }
  ;
  this.allowEmpty = _.isUndefined(props.allowEmpty) ? true : props.allowEmpty;
  this.emptyErrorMsg = props.emptyErrorMsg || BabelStr.str(3430);
  this.initialize(props);
};
_.extend(MDEditalbeInputDiv.prototype, {
  el: '<div class="disp-input-root">' + '<input type="text" maxlength="140">' + '<button type="button" class="edit-input-btn icon"></button>' + '</div>',
  registerEvents: function registerEvents() {
    var _this = this;
    this.$el.on('click', function (e) {
      e.stopPropagation();
      return false;
    });
    this.$el.on('mousedown', function (e) {
      e.stopPropagation();
      _this._editLogClickHandler(e);
      return false;
    });
    this.$el.on('mouseover', function (e) {
      _this._overLogEdit(e);
      return false;
    });
    this.$el.on('mouseout', function (e) {
      _this._outLogEdit(e);
      return false;
    });
    this.$el.find('.edit-input-btn').on('mousedown', function (e) {
      e.stopPropagation();
      _this._editBtnClicked(e);
      return false;
    });
    this.$el.find('input').on('mousedown', function (e) {
      e.stopPropagation();
      _this._mousedownInput(e);
    });
    this.$el.find('input').on('keydown', function (e) {
      e.stopPropagation();
      return _this._keydownInput(e);
    });
    this.$el.find('input').on('focus', function (e) {
      _this._onFocusLogEdit(e);
    });
    this.$el.find('input').on('blur', function (e) {
      _this._onBlurLogEdit(e);
      return false;
    });
  },
  initialize: function initialize(opt) {
    this.$el = $(this.el);
    $(this.parentDiv).append(this.$el);
    var maxlength = this.maxlength || 140;
    this.$el.find("input").attr("maxlength", maxlength);
    if (!this.disabelEdit) {
      this.registerEvents();
    } else {}
    if (this.placeholder) {
      this.$el.find('input').attr('placeholder', this.placeholder);
    }
    ;
  },
  removeFromSuperView: function removeFromSuperView() {
    this.$el.remove();
    $('body').off('mousedown.edit_div');
    this.updatedCallback = null;
  },
  remove: function remove() {
    this.removeFromSuperView();
  },
  _editLogClickHandler: function _editLogClickHandler() {
    if (this.cannotEditVerLog) {
      return;
    }
    ;
    this.$el.find('input').focus();
    return false;
  },
  _overLogEdit: function _overLogEdit(e) {
    if (this.cannotEditVerLog) {
      this.$el.removeClass('input-edit');
      return;
    }
    ;
    this.$el.addClass('input-edit');
  },
  _outLogEdit: function _outLogEdit(e) {
    if (this.cannotEditVerLog) {
      return;
    }
    ;
    this.$el.removeClass('input-edit');
  },
  _onFocusLogEdit: function _onFocusLogEdit() {
    if (this.cannotEditVerLog) {
      return;
    }
    ;
    this.editFocused = true;
    this.$el.find('.edit-input-btn').addClass('commit-input');
  },
  _onBlurLogEdit: function _onBlurLogEdit() {
    if (this.cannotEditVerLog) {
      return;
    }
    ;
    var self = this;
    setBabelTimeout(function () {
      self.editFocused = false;
    }, 100);
    this.$el.find('.edit-input-btn').removeClass('commit-input');
    if (this.oldStr) {
      this.$el.find('input').val(_.unescape(this.oldStr));
    } else {
      this.$el.find('input').val('');
    }
  },
  _mousedownInput: function _mousedownInput(e) {
    e.stopPropagation();
  },
  _keydownInput: function _keydownInput($e) {
    if (_keycode["default"].isEnterKey($e.keyCode)) {
      this._submitVerLog();
      return false;
    }
  },
  _editBtnClicked: function _editBtnClicked(e) {
    if (this.cannotEditVerLog) {
      return;
    }
    ;
    console.log('------ focus:', this.editFocused);
    var self = this;
    if (!this.editFocused) {
      setBabelTimeout(function () {
        self.$el.find('input').focus();
      }, 1000);
    } else {
      // commit log
      this._submitVerLog();
    }
    return false;
  },
  _submitVerLog: function _submitVerLog() {
    var self = this;
    var logStr = this.$el.find('input').val().trim();
    if (!logStr && !this.allowEmpty) {
      _MDSnackbarView["default"].show(this.emptyErrorMsg);
      return;
    }
    if (!_regexp["default"].validateTextinput(logStr)) {
      _MDSnackbarView["default"].show(BabelStr.str(12202));
      return;
    }
    if (logStr != this.oldStr && this.updatedCallback) {
      this.updatedCallback(logStr, function () {
        self.setInputVal(logStr);
        self.$el.find('input').blur();
      });
    }
    ;
  },
  setReadOnly: function setReadOnly() {
    this.cannotEditVerLog = true;
    this.$el.find('button').remove();
    this.$el.find('input').attr('readonly', true);
  },
  setInputVal: function setInputVal(logStr) {
    this.oldStr = logStr;
    logStr = _.unescape(logStr);
    this.$el.find('input').val(logStr);
    this.$el.find('input').attr('title', logStr);
  }
});
var _default = exports["default"] = MDEditalbeInputDiv;

},{"104":104,"106":106,"1184":1184,"1417":1417,"1454":1454,"1461":1461,"1463":1463,"1498":1498,"72":72}],12:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
var _MDColladaDisplayer = _interopRequireDefault(require(11));
var _MD3DToolbar = _interopRequireDefault(require(14));
var _MD3DObjectVisibleListPanel = _interopRequireDefault(require(13));
var _MDLoadMaskView = _interopRequireDefault(require(49));
var _MDAlertView = _interopRequireDefault(require(32));
var _MMCommonFun = _interopRequireDefault(require(812));
// MDMSOfficeEditor.js
//
// jiang
// 2016-9-6

function MDMSOfficeEditor(parentDiv, opt) {
  this.parentDiv = parentDiv;
  this.threeDisp = null;
  this.constructEditor();
}
;
MDMSOfficeEditor.prototype = function () {
  //----------------------------------------------------------------------------------------------------
  //       private function
  //----------------------------------------------------------------------------------------------------
  function _clearTouchlayerClass() {
    this.$touchLayer.removeClass('cursor-normal');
    this.$touchLayer.removeClass('cursor-hide');
    this.$touchLayer.removeClass('cursor-ruler');
  }

  //----------------------------------------------------------------------------------------------------
  //       private function
  //----------------------------------------------------------------------------------------------------
  return {
    contstructor: MDMSOfficeEditor,
    constructEditor: function constructEditor() {
      var parentDiv = this.parentDiv;
      this.containerId = "MSOfficeEditor";
      this.$editorLayer = $('<div id="' + this.containerId + '" style="position:absolute;width:100%;height:100%;top:0px;left:0px">' + '<iframe class="frame" sandbox="allow-forms allow-scripts" style="position:absolute;width:100%;height:100%;top:0px;left:0px" ></iframe>' + '</div>');
      $(this.parentDiv).append(this.$editorLayer);
    },
    openFile: function openFile(fileInfo, version, callback) {
      var _this = this;
      this.fileInfo = fileInfo;
      _MMCommonFun["default"].getDownloadRealPath(fileInfo.getFileId(), version, function (url) {
        _this.$editorLayer.find("iframe").attr("src", "https://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(url));
        // location.href = "https://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(url);
      });
    },
    refreshSize: function refreshSize() {},
    closeCommentPanel: function closeCommentPanel() {},
    refreshObjsInEditor: function refreshObjsInEditor() {},
    focusComment: function focusComment(comment) {},
    enableMouseWheel: function enableMouseWheel(enable) {},
    getCurrentFileInfo: function getCurrentFileInfo() {
      return this.fileInfo;
    },
    toolChanged: function toolChanged(toolIndex) {
      _clearTouchlayerClass.call(this);
      switch (toolIndex) {
        case 0:
          break;
        case 1:
          break;
        case 2:
          break;
      }
    },
    restoreHomeView: function restoreHomeView() {},
    removeFromSuperView: function removeFromSuperView() {
      this.removed = true;
      this.$editorLayer.remove();
    },
    object3DHided: function object3DHided(obj3DId, imgdata) {},
    allObjShowed: function allObjShowed() {},
    showCommentLayer: function showCommentLayer() {},
    hideCommentLayer: function hideCommentLayer() {},
    getClassName: function getClassName() {
      return "MDMSOfficeEditor";
    },
    getScale: function getScale() {
      return 1;
    },
    getCenterRatioPosition: function getCenterRatioPosition() {
      return {
        x: 0,
        y: 0
      };
    }
  };
}();
var _default = exports["default"] = MDMSOfficeEditor;

},{"11":11,"1184":1184,"13":13,"14":14,"1417":1417,"1454":1454,"1463":1463,"32":32,"49":49,"812":812}],2:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1497);
require(1418);
require(1463);
require(1537);
require(1432);
var _MDNewCommentsController = _interopRequireDefault(require(96));
var _MDCommentSlidePanelView = _interopRequireDefault(require(319));
var _MD3DCommentDiv = _interopRequireDefault(require(8));
var _MD3DComment = _interopRequireDefault(require(6));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDColladaDisplayer = _interopRequireDefault(require(11));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
// MD3DCommentsController.js
//
// jiang
// 2016-8-26

function MD3DCommentsController($parentDiv, scene, camera, displayer) {
  this.scene = scene;
  this.camera = camera;
  this.editorViewCtl = displayer.editorViewCtl;
  _MDNewCommentsController["default"].call(this, $parentDiv, displayer);
}
;
MD3DCommentsController.id = 0;
MD3DCommentsController.createCommentsFromLocalStorage = function () {
  var count = localStorage["3Dcomment_num"];
  var comments = [];
  for (var i = 0; i < count; i++) {
    var comment = new _MD3DComment["default"]();
    comment.readFromLocalStorage(i);
    comments.push(comment);
  }
  ;
  return comments;
};
MD3DCommentsController.saveCommentsToLocalStorage = function (comments) {
  localStorage["3Dcomment_num"] = comments.length;
  for (var i = 0; i < comments.length; i++) {
    var comment = comments[i];
    comment.saveToLocalStorage(i);
  }
  ;
};
_.extend(MD3DCommentsController.prototype, _MDNewCommentsController["default"].prototype, function () {
  // ------------------------------------------------------------------------  private function
  function _seekObject3D(comment) {
    if (!comment.object3D && this.scene) {
      var self = this;
      this.scene.traverse(function (child) {
        if (child instanceof THREE.Object3D) {
          if (child.id == comment.hostId) {
            comment.object3D = child;
            return true;
          }
          ;
        }
      });
    }
    ;
    return comment.object3D;
  }
  ;
  function _seekFace(comment) {
    if (!comment.face && comment.object3D && comment.object3D.geometry) {
      var faces = comment.object3D.geometry.faces;
      if (comment.faceIndex < faces.length) {
        comment.face = faces[comment.faceIndex];
      }
      ;
    }
    ;
    return comment.face;
  }
  ;
  function _getCommentDvPos(comment, notCheck) {
    var interObj = _seekObject3D.call(this, comment);
    if (!interObj) {
      return;
    }
    ;
    var face = _seekFace.call(this, comment);
    if (!face) {
      return;
    }
    ;
    var vertices = interObj.geometry.vertices;
    var pts = [vertices[face.a].clone(), vertices[face.b].clone(), vertices[face.c].clone()];
    var k1 = comment.k1;
    var k2 = comment.k2;
    var ptIndexes = comment.ptIndexes;
    var rotation = new THREE.Matrix4();
    rotation.makeRotationFromEuler(interObj.rotation);
    rotation = interObj.matrixWorld;
    for (var i = pts.length - 1; i >= 0; i--) {
      pts[i].applyMatrix4(rotation);
    }
    ;
    var V0 = pts[ptIndexes[0]].clone().sub(pts[ptIndexes[1]]);
    var V1 = pts[ptIndexes[2]].clone().sub(pts[ptIndexes[1]]);
    var lgPos = pts[ptIndexes[1]].add(V0.multiplyScalar(k1).add(V1.multiplyScalar(k2)));
    var frustum = this.camera.frustum;
    var dvPos = this.displayer.logicToDevice(lgPos.clone());
    if (!notCheck && frustum) {
      if (!frustum.containsPoint(lgPos)) {
        dvPos = null;
      }
      ;
    } else {}
    return dvPos;
  }
  ;
  function _createDivForComment(comment) {
    if (this.scene) {
      var hostObj = null;
      var self = this;
      this.scene.traverse(function (child) {
        if (child instanceof THREE.Object3D) {
          if (child.id == comment.hostId) {
            hostObj = child;
            return true;
          }
          ;
        }
      });
      if (hostObj == null) {
        console.error('--------> cannot seek obj by id');
        return null;
      }
      ;
    }
    ;
    var div = null;
    if (hostObj) {
      var dvPos = _getCommentDvPos.call(this, comment);
      div = new _MD3DCommentDiv["default"](this, comment, this.$parentDiv, dvPos);
    }
    ;
    return div;
  }
  ;
  function _createComment(commentPosInfo) {
    var tempComment = new _MD3DComment["default"]();
    tempComment.object3D = commentPosInfo.object, tempComment.face = commentPosInfo.face;
    tempComment.hostId = tempComment.object3D.id;
    tempComment.faceIndex = commentPosInfo.faceIndex;
    tempComment.k1 = commentPosInfo.k1;
    tempComment.k2 = commentPosInfo.k2;
    tempComment.ptIndexes = commentPosInfo.ptIndexes;
    tempComment.cameraPos = this.camera.position.clone();
    tempComment.up = this.camera.up.clone();
    tempComment.target = this.scene.trackballCtl.target.clone();
    tempComment.setBoard(this.commentsFile);
    var curUserId = app.currentUser.getUserId_Int();
    tempComment.setCreator(curUserId);
    return tempComment;
  }
  ;
  function _animateByPathrouter(comment, cameraPosArr) {
    if (this.pathCtl) {
      this.scene.remove(this.pathCtl.animationParent);
    }
    ;
    var pathControls = new THREE.PathControls(this.camera);
    this.pathCtl = pathControls;

    // configure the controller
    pathControls.duration = 70;
    //speed, so you will not have the dash effect on a curve
    pathControls.useConstantSpeed = true;
    pathControls.lookSpeed = 0.1;
    pathControls.lookVertical = true;
    pathControls.lookHorizontal = true;
    pathControls.verticalAngleMap = {
      srcRange: [0, 2 * Math.PI],
      dstRange: [1.1, 3.8]
    };
    pathControls.horizontalAngleMap = {
      srcRange: [0, 2 * Math.PI],
      dstRange: [0.3, Math.PI - 0.3]
    };
    pathControls.lon = 300;
    pathControls.lat = 40;
    // add the path
    cameraPosArr.forEach(function (e) {
      pathControls.waypoints.push([e.x, e.y, e.z]);
    });
    // when done configuring init the control
    pathControls.init();
    // add the animationParent to the scene and start the animation
    this.scene.add(pathControls.animationParent);
    _MDColladaDisplayer["default"].getInstance.setCameraPathCtl(pathControls);
    pathControls.animation.play(true, 0);
  }
  ;
  function _animateByTween(comment, cameraPosArr, onComplete) {
    var camera = this.camera;
    var curPos = camera.position.clone();
    var finalCameraPos = comment.cameraPos;
    var target = comment.target;
    var controller = this.scene.trackballCtl;
    var up = comment.up;
    var pos = cameraPosArr[0];
    var duration = 60;
    var duration1 = 600;
    var easingFun = TWEEN.Easing.Circular.InOut;
    var easingFun = TWEEN.Easing.Linear.None;
    if (cameraPosArr.length == 1) {
      if (finalCameraPos.clone().sub(curPos).length() > 1) {} else {
        duration1 = 10;
      }
    }
    ;
    var posTween = new TWEEN.Tween(camera.position).to({
      x: pos.x,
      y: pos.y,
      z: pos.z
    }, duration1).easing(easingFun).start();
    var targetTween = new TWEEN.Tween(controller.target).to({
      x: target.x,
      y: target.y,
      z: target.z
    }, duration1).easing(easingFun).start();
    var upTween = new TWEEN.Tween(camera.up).to({
      x: up.x,
      y: up.y,
      z: up.z
    }, duration1).easing(easingFun).start();
    var finalTween = posTween;
    for (var i = 1; i < cameraPosArr.length; i++) {
      if (i == cameraPosArr.length - 1) {
        duration = duration1;
      }
      ;
      pos = cameraPosArr[i];
      var posTween1 = new TWEEN.Tween(camera.position).to({
        x: pos.x,
        y: pos.y,
        z: pos.z
      }, duration).easing(easingFun);
      var targetTween1 = new TWEEN.Tween(controller.target).to({
        x: target.x,
        y: target.y,
        z: target.z
      }, duration).easing(easingFun);
      var upTween1 = new TWEEN.Tween(camera.up).to({
        x: up.x,
        y: up.y,
        z: up.z
      }, duration).easing(easingFun);
      posTween.chain(posTween1);
      targetTween.chain(targetTween1);
      upTween.chain(upTween1);
      posTween = posTween1;
      targetTween = targetTween1;
      upTween = upTween1;
      if (i == cameraPosArr.length - 1) {
        finalTween = posTween1;
      }
      ;
    }
    ;
    finalTween.onComplete(function () {
      console.log('---------> position!');
      setBabelTimeout(function () {
        if (onComplete) {
          onComplete();
        }
        ;
      });
    });
    return;
  }
  ;

  // 计算点击批注后的镜头移动动画路径
  // 路径中最少只有一个点，即镜头的最后位置
  function _calculatePath(comment) {
    var cameraPostions = [];
    if (this.camera) {
      var camera = this.camera;

      // camera current position
      var beginCamPos = camera.position.clone();
      // camera final position
      var endCamPos = comment.cameraPos.clone();
      var controller = this.scene.trackballCtl;

      // camera current focus
      var beginTarget = controller.target.clone();
      // camera final focus
      var endTarget = comment.target.clone();

      // --- 构建移动到指定目标需要经过的几个点
      // ------------- 1. 需要先推镜头，看到整体，再进行旋转
      var colladaDisplayer = _MDColladaDisplayer["default"].getInstance();
      var camPos = colladaDisplayer.getCameraFitPosition(beginTarget, beginCamPos);
      if (camPos.distanceTo(this.camera.position) > 1 && endCamPos.distanceTo(this.camera.position) > 1) {
        beginCamPos = camPos.clone();
        cameraPostions.push(beginCamPos);
      }
      ;
      var v1 = beginCamPos.clone().sub(endTarget).normalize();
      var v2 = endCamPos.clone().sub(endTarget).normalize();
      var angle = v1.angleTo(v2);
      var steps = 4;
      if (angle < Math.PI / 2) {
        if (angle > Math.PI / 6) {
          steps = 2;
        } else {
          steps = 0;
        }
      }
      ;

      // ------------- 2. 旋转到目标方向
      if (steps > 0) {
        var radius = beginCamPos.clone().sub(endTarget).length();
        var vectors = [v1, v2];
        _ease.call(this, vectors, steps, 1);

        // var vHalf = v1.clone().add(v2).normalize().multiplyScalar(radius);
        // var vQuarter1 = v1.clone().add(vHalf).normalize().multiplyScalar(radius);
        // var vQuarter2 = vHalf.clone().add(v2).normalize().multiplyScalar(radius);
        // var vEnd = v2.normalize().multiplyScalar(radius);

        for (var i = 1; i < vectors.length - 1; i++) {
          var v = vectors[i];
          var pos = endTarget.clone().add(v.multiplyScalar(radius));
          cameraPostions.push(pos);
        }
        ;
      }
      ;

      // ------------- 3. 拉镜头到指定位置
      cameraPostions.push(endCamPos);
    }
    ;
    return cameraPostions;
  }
  ;
  function _ease(vectors, steps, i) {
    if (steps == 0) {
      return i + 1;
    }
    ;
    var v1 = vectors[i - 1];
    var v2 = vectors[i];
    var vHalf = v1.clone().add(v2).normalize();
    vectors.splice(i, 0, vHalf);
    var newIndex = _ease.call(this, vectors, steps - 1, i);
    newIndex = _ease.call(this, vectors, steps - 1, newIndex);
    return newIndex;
  }
  ;

  // ---------------------------------------------------------------------------- public function
  return {
    constructor: MD3DCommentsController,
    createComment: function createComment(commentPosInfo) {
      return _createComment.call(this, commentPosInfo);
    },
    createDivForComment: function createDivForComment(comment) {
      return _createDivForComment.call(this, comment);
    },
    getCommentDvPos: function getCommentDvPos(comment) {
      return _getCommentDvPos.call(this, comment);
    },
    setScene: function setScene(scene, camera) {
      this.scene = scene;
      this.camera = camera;
    },
    saveTempCommentDiv: function saveTempCommentDiv(text, atIds, visibleScope, objs3dHided, callback) {
      console.assert(this.commentsFile);
      var objIdHided = [];
      for (var i = 0; i < objs3dHided.length; i++) {
        var obj = objs3dHided[i];
        objIdHided.push(obj.id);
      }
      ;
      var self = this;
      if (this.tempCommentDiv) {
        this.tempCommentDiv.comment.setHided3DObjs(objIdHided);
        _MDNewCommentsController["default"].prototype.saveTempCommentDiv.call(this, text, atIds, visibleScope, callback);
      }
      ;
    },
    clearMemory: function clearMemory() {
      this.scene = null;
      this.camera = null;
      _MDNewCommentsController["default"].prototype.clearMemory.call(this);
    },
    clicked: function clicked(commentDivClicked) {
      _MDNewCommentsController["default"].prototype.clicked.call(this);
      if (this.tempCommentDiv == commentDivClicked) {
        return;
      }
      ;
      if (this.waitAnimating) {
        return;
      }
      ;
      this.waitAnimating = true;
      var self = this;
      if (this.commentPanel) {
        this.commentPanel.removeFromSuperView();
      }
      ;
      this.displayer.removeAllPanels();
      this.displayer.showAllHided3dObjs();
      var cameraPosArr = _calculatePath.call(this, commentDivClicked.comment);
      _animateByTween.call(this, commentDivClicked.comment, cameraPosArr, function onComplete() {
        commentDivClicked.focus(true);
        self.waitAnimating = false;

        // 隐藏在建立批注点时隐藏的那些对象
        self.displayer.hide3DObjsById(commentDivClicked.comment.getHided3DObjs());
        self.commentPanel = new _MDCommentSlidePanelView["default"]({
          view: self,
          comment: commentDivClicked.comment,
          enableDraggable: true,
          editorViewCtl: self.editorViewCtl,
          onDrag: function onDrag() {},
          onCloseBtnClicked: function onCloseBtnClicked() {
            self.commentPanel.removeFromSuperView();
          },
          onRemove: function onRemove() {
            self.commentPanel = null;
            var mainEditor = _MDPcMobileEditorCommonFun["default"].getMainEditor();
            mainEditor.checkToEnablePrivateMouseWheel();
            commentDivClicked.focus(false);
          },
          onOpen: function onOpen() {}
        });
        app.application.addSubView(self.commentPanel);
        var startOffset = _getCommentDvPos.call(self, commentDivClicked.comment, true);
        if (startOffset) {
          var posInBody = _MMCommonFun["default"].convertPointBetweenElements(self.$parentDiv[0], $('body')[0], startOffset);
          self.commentPanel.zoomShow({
            'x': posInBody.x + 40,
            'y': posInBody.y + 40
          }, function () {
            _MDPcMobileEditorCommonFun["default"].getMainEditor().showCommentLine();
          });
        }
        ;
      });
      // this._animateByPathrouter(commentDivClicked.comment, cameraPosArr);
    },
    hideCommentOnObj3dId: function hideCommentOnObj3dId(obj3dId) {
      for (var i = 0; i < this.commentDivs.length; i++) {
        var div = this.commentDivs[i];
        if (div.comment.hostId == obj3dId) {
          div.hideForface();
          // return;
        }
        ;
      }
      ;
    },
    showCommentOnObj3dId: function showCommentOnObj3dId(obj3dId) {
      for (var i = 0; i < this.commentDivs.length; i++) {
        var div = this.commentDivs[i];
        if (div.comment.hostId == obj3dId) {
          div.showForface();
          // return;
        }
        ;
      }
      ;
    }
  };
}());
var _default = exports["default"] = MD3DCommentsController;

},{"11":11,"1184":1184,"1418":1418,"1432":1432,"1454":1454,"1463":1463,"1497":1497,"1537":1537,"319":319,"6":6,"72":72,"8":8,"807":807,"812":812,"96":96}],8:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1465);
var _MDNewCommentDiv = _interopRequireDefault(require(95));
// MD3DCommentDiv.js
//
// jiang
// 2016-8-26

function MD3DCommentDiv(commentCtl, comment, $parentDiv, dvPos) {
  _MDNewCommentDiv["default"].call(this, commentCtl, comment, $parentDiv, dvPos);
}
;
_.extend(MD3DCommentDiv.prototype, _MDNewCommentDiv["default"].prototype, {
  constructor: MD3DCommentDiv,
  refresh: function refresh(dvPos) {
    if (!this._hideForface && dvPos) {
      this.$mark.show();
      dvPos.x -= this.$mark[0].offsetWidth / 2;
      dvPos.y -= this.$mark[0].offsetHeight / 2;
      var curPos = {
        left: parseFloat(this.$mark.css('left')),
        top: parseFloat(this.$mark.css('top'))
      };
      if (Math.abs(curPos.left - dvPos.x) > 0.001 || Math.abs(curPos.top - dvPos.y) > 0.001) {
        this.$mark.css('left', dvPos.x + 'px');
        this.$mark.css('top', dvPos.y + 'px');
      }
      ;
      this.dvPos = {
        x: dvPos.x,
        y: dvPos.y
      };
      this.updateStatus();
    } else {
      this.$mark.hide();
    }
    _MDNewCommentDiv["default"].prototype.refresh.call(this, dvPos);
  },
  hideForface: function hideForface() {
    this._hideForface = true;
  },
  showForface: function showForface() {
    this._hideForface = false;
  }
});
var _default = exports["default"] = MD3DCommentDiv;

},{"1184":1184,"1454":1454,"1465":1465,"95":95}],95:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
var _MMObjOperationStrategy = _interopRequireDefault(require(872));
var _MMOperationType = _interopRequireDefault(require(882));
// MDNewCommentDiv.js
//
// jiang
// 2017-9-6

function MDNewCommentDiv(commentCtl, comment, $parentDiv, dvPos) {
  this.commentCtl = commentCtl;
  this.comment = comment;
  this.$mark = $('<div class="commentmark-root", style="left:0px; top:0px;">' + '<div class="comment-mark"></div>' + '<div class="unread-mark-root">' + '<div class="unread-mark"></div>' + '</div>' + '</div>');
  this.$parentDiv = $parentDiv;
  $parentDiv.append(this.$mark);
  this.refreshCss();
  this.refresh(dvPos);
  this._hideForface = false;
  var self = this;
  this.$mark.click(function (e) {
    e.stopPropagation();
    self.clicked();
  });
  var board = comment.getBoard();
  if (comment.isEvalComment()) {
    this.$mark.find('.comment-mark').addClass('eval-mark');
  }

  // this.$mark.unbind('click');
}
;
MDNewCommentDiv.prototype = function () {
  // ----------------------------------------------- private

  //------------------------------------------------ public
  var publicFunctions = {
    constructor: MDNewCommentDiv,
    createDiv: function createDiv($parentDiv) {
      this.$parentDiv = $parentDiv;
      $parentDiv.append(this.$mark);
      return this.$mark;
    },
    refreshCss: function refreshCss() {},
    refresh: function refresh(dvPos) {
      var hide = _MMObjOperationStrategy["default"].getOperataionTypeForMolaTask(this.comment, 0) == _MMOperationType["default"].Operation_hidden;
      if (hide) {
        this.$mark.hide();
      }
      this.refreshCss();
      return !hide;
    },
    updateStatus: function updateStatus() {
      var s = this.comment.getReadStatus();
      if (this.$mark.hasClass('focus-comment')) {
        if (this.$mark.hasClass('unread-comment')) {
          this.$mark.removeClass('unread-comment');
        }
        ;
      } else {
        if (s == 1) {
          if (this.$mark.hasClass('unread-comment')) {
            this.$mark.removeClass('unread-comment');
          }
          ;
        } else if (!this.$mark.hasClass('unread-comment')) {
          this.$mark.addClass('unread-comment');
        }
        ;
      }
      var scope = this.comment.getVisibleScope();
      switch (scope) {
        case 0:
          // if (!this.$mark.hasClass('pub-comment')) {
          //   this.$mark.addClass('pub-comment');
          // };
          break;
        case 1:
          if (!this.$mark.hasClass('ent-comment')) {
            this.$mark.addClass('ent-comment');
          }
          ;
          break;
        case 2:
          if (!this.$mark.hasClass('pri-comment')) {
            this.$mark.addClass('pri-comment');
          }
          ;
      }
      ;
      if (this.comment.isFinished()) {
        this.$mark.addClass("comment-complate");
      } else {
        this.$mark.removeClass("comment-complate");
      }
      // if (!this.$mark.hasClass('unread-comment')) {
      //   this.$mark.addClass('unread-comment');
      // };
    },
    clearMemory: function clearMemory() {
      this.$mark.unbind('click');
    },
    clicked: function clicked() {
      if (!app.currentUser.logined()) {
        app.popupInnerLogin();
        return;
      }
      this.commentCtl.clicked(this);
    },
    removeFromSuperView: function removeFromSuperView() {
      this.commentCtl = null;
      this.$mark.off();
      this.$mark.remove();
    },
    getPos: function getPos() {
      if (this.dvPos) {
        return {
          x: this.dvPos.x,
          y: this.dvPos.y
        };
      } else {
        return null;
      }
    },
    setOrder: function setOrder(i) {
      var $commentMark = this.$mark.find('.comment-mark');
      var text = $commentMark.text();
      if (text != i) {
        $commentMark.text(i);
      }
      ;
    },
    focus: function focus(isFocus) {
      var focusedClassName = 'focus-comment';
      if (isFocus) {
        this.$mark.addClass(focusedClassName);
      } else {
        this.$mark.removeClass(focusedClassName);
      }
    },
    clear: function clear() {
      this.commentCtl = null;
      this.comment = null;
      this.$mark.remove();
      this.$parentDiv = null;
    }
  };
  return publicFunctions;
}();
var _default = exports["default"] = MDNewCommentDiv;

},{"1184":1184,"1417":1417,"1454":1454,"1463":1463,"872":872,"882":882}],872:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMOperationType = _interopRequireDefault(require(882));
var _MMParticipantCollection = _interopRequireDefault(require(307));
var _ObjType = _interopRequireDefault(require(1084));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
var _ObjVisibleScope = _interopRequireDefault(require(1085));
function MMObjOperationStrategy() {}
;
MMObjOperationStrategy.getOperataionTypeForMolaTask = function (obj, curPageIndex) {
  var curTask = obj.getBoard();
  console.assert(curTask);
  var opType = _MMOperationType["default"].Operation_hidden;
  var curUser = app.currentUser.getUserId_Int();
  var participantMgr = _MMParticipantCollection["default"].singleton;
  var fileInfo = curTask.getFileInfo();
  if (!fileInfo) {
    return _MMOperationType["default"].Operation_hidden;
  }
  ;
  var creator = obj.getCreator();
  if (fileInfo && obj.isComment()) {
    return MMObjOperationStrategy.getOperationTypeForComment(obj, creator.valueOf(), fileInfo);
  }

  // 自己的签名自己总可以编辑
  if (obj.getClassName() == "MMSignatureFrame") {
    if (obj.getUser().getUserId() != app.currentUser.getUserId()) {
      return _MMOperationType["default"].Operation_onlyDisplay;
    } else {
      return _MMOperationType["default"].Operation_editable;
    }
  }
  var objVisible = true;
  if (participantMgr && creator && creator.toDecString) {
    objVisible = participantMgr.isUserVisible(creator.toDecString());
  }
  if (objVisible) {
    if (curPageIndex == obj.getPageIndex()) {
      var objType = obj.getObjType();
      if (fileInfo.canDelMyComment() || curUser.valueOf() == creator.valueOf()) {
        opType = _MMOperationType["default"].Operation_editable;
        var pgIndex = obj.getPageIndex();
        if (curTask.isClosed()) {
          // tobias moved this condition out, so that the creator can always edit its objects. obj.isCommited() || (mantis bug: 0029066)
          if (obj.isComment() || objType == _ObjType["default"].Obj_PDF || objType == _ObjType["default"].Obj_Image || objType == _ObjType["default"].Obj_niceTag) {
            opType = _MMOperationType["default"].Operation_selectable;
          }
          if (objType == _ObjType["default"].Obj_textComment && fileInfo.canDelMyComment()) {
            opType = _MMOperationType["default"].Operation_deletable;
          } else {
            opType = _MMOperationType["default"].Operation_onlyDisplay;
          }
        } else if (objType == _ObjType["default"].Obj_textComment && fileInfo.canDelMyComment()) {
          opType = _MMOperationType["default"].Operation_deletable;
        }
      } else {
        if (fileInfo.canManageFilePermission()) {
          if (obj.isComment() || objType == _ObjType["default"].Obj_textComment || objType == _ObjType["default"].Obj_niceTag || obj.isPenComment || objType == _ObjType["default"].Obj_weldMark) {
            opType = _MMOperationType["default"].Operation_editable;
          }
        } else if (obj.isComment() || objType == _ObjType["default"].Obj_PDF || objType == _ObjType["default"].Obj_Image) {
          opType = _MMOperationType["default"].Operation_selectable;
        } else if (objType == _ObjType["default"].Obj_textComment) {
          opType = _MMOperationType["default"].Operation_selectable;
        } else {
          opType = _MMOperationType["default"].Operation_onlyDisplay;
        }
        if (obj.isComment() || objType == _ObjType["default"].Obj_textComment || objType == _ObjType["default"].Obj_niceTag) {
          if (fileInfo && !fileInfo.canReadComment()) {
            opType = _MMOperationType["default"].Operation_hidden;
          }
          ;
        }
        ;
      }
    }
  }
  if (opType != _MMOperationType["default"].Operation_hidden && (objType == _ObjType["default"].Obj_textComment || obj.isComment() || objType == _ObjType["default"].Obj_niceTag || objType == _ObjType["default"].Obj_weldMark || objType == _ObjType["default"].GObj_scribble)) {
    if (MMObjOperationStrategy.hidden || !fileInfo.canReadComment()) {
      opType = _MMOperationType["default"].Operation_hidden;
    }
    ;
  }
  ;
  return opType;
};
MMObjOperationStrategy.getOperationTypeForComment = function (comment, commentCreatorId, fileInfo) {
  var opType = _MMOperationType["default"].Operation_hidden;
  var curUserId = app.currentUser.getUserId();
  if (MMObjOperationStrategy.canVisible2User(comment, commentCreatorId, fileInfo)) {
    if (MMObjOperationStrategy.hidden) {
      opType = _MMOperationType["default"].Operation_hidden;
    } else if ((fileInfo.canDelMyComment() || fileInfo.canCreateComment()) && curUserId == commentCreatorId || fileInfo.canManageFilePermission() || fileInfo.canEditProject() || curUserId == fileInfo.getOwnerId()) {
      opType = _MMOperationType["default"].Operation_editable;
      if (!fileInfo.canDelMyComment()) {
        opType = _MMOperationType["default"].Operation_selectable;
      }
      if (comment.isEvalComment && comment.isEvalComment() || comment.evalMark) {
        opType = _MMOperationType["default"].Operation_selectable;
        if ((fileInfo.canDelMyComment() || fileInfo.canCreateComment()) && curUserId == commentCreatorId || app.currentUser.isEpAdminUser()) {
          opType = _MMOperationType["default"].Operation_editable;
          if (!fileInfo.canDelMyComment()) {
            opType = _MMOperationType["default"].Operation_selectable;
          }
        }
      }
    } else {
      if (fileInfo.canReadComment()) {
        opType = _MMOperationType["default"].Operation_selectable;
      }
    }
  }
  return opType;
};
MMObjOperationStrategy.canVisible2User = function (comment, commentCreatorId, fileInfo) {
  var scope = comment.getVisibleScope && comment.getVisibleScope() || comment.visibleScope;
  if (scope && scope != _ObjVisibleScope["default"].evaluation) {
    if (scope == _ObjVisibleScope["default"].protectedObject) {
      var visible = false;
      if (fileInfo.belongsToCurrentUserEnterprise()) {
        visible = true;
      }
      return visible;
    } else if (scope == 2) {
      var curUserId = app.currentUser.getUserId();
      return curUserId == commentCreatorId;
    }
  } else {
    return true;
  }
};
MMObjOperationStrategy.setCommentHidden = function (isHidden) {
  MMObjOperationStrategy.hidden = isHidden;
};
var _default = exports["default"] = MMObjOperationStrategy;

},{"1084":1084,"1085":1085,"1184":1184,"1454":1454,"307":307,"807":807,"882":882}],807:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1466);
var _MMCommonFun = _interopRequireDefault(require(812));
var _MDPCEditorViewController = _interopRequireDefault(require(940));
var _MMNetDiskImageCollectionView = _interopRequireDefault(require(938));
var _OBJ_ID = _interopRequireDefault(require(818));
var _MDSnackbarView = _interopRequireDefault(require(72));
// MDPcMobileEditorCommonFun.js
// jiang
// 2017-4-24

// import MMImageMarkerCtl from '../ui/editor-task/android-scroll/MMImageMarkerCtl.js';

var MDPcMobileEditorCommonFun = {
  getMainEditor: function getMainEditor() {
    if (app.canDispInNormalBrowser()) {
      return _MDPCEditorViewController["default"].getCurrentInstance();
    } else {
      return MDPcMobileEditorCommonFun.mainEditor; //MMNetDiskImageCollectionView.getCurrentInstance();
    }
  }
};

/*
 *attention: don't use it too much, if you really want to use this, discuss with the author: Ma shixiong.
 */
MDPcMobileEditorCommonFun.getCurOperationCenter = function () {
  var editorCtl = MDPcMobileEditorCommonFun.getMainEditor();
  if (MMImageMarkerCtl.isShowing()) {
    var marker = MMImageMarkerCtl.getSingleInstance();
    editorCtl = marker.getEditor();
  }
  if (editorCtl) {
    return editorCtl.getOperationCenter();
  }
  return null;
};
MDPcMobileEditorCommonFun.setMainEditor = function (mainEditor) {
  MDPcMobileEditorCommonFun.mainEditor = mainEditor;
};
MDPcMobileEditorCommonFun.navigateToPreviousPage = function () {
  var editor = MDPcMobileEditorCommonFun.getMainEditor();
  editor.scrollToNextImage(false);
  if (editor.closeCommentPanel) editor.closeCommentPanel();
  //scroll thumbnail:
  var curPageIndex = editor.getCurrentPage();
  var roundThumbnailListView = viewManager.get('roundThumbnailListView');
  var showing = roundThumbnailListView.$el.hasClass("active");
  roundThumbnailListView && roundThumbnailListView.scrollToIndex(curPageIndex, showing);
  var pageBarView = viewManager.get("pageBarView");
  pageBarView.scrollThumbnial();
};
MDPcMobileEditorCommonFun.navigateToNextPage = function () {
  var editor = MDPcMobileEditorCommonFun.getMainEditor();
  editor.scrollToNextImage(true);
  if (editor.closeCommentPanel) editor.closeCommentPanel();
  //scroll thumbnail:
  var curPageIndex = editor.getCurrentPage();
  var roundThumbnailListView = viewManager.get('roundThumbnailListView');
  var showing = roundThumbnailListView.$el.hasClass("active");
  roundThumbnailListView && roundThumbnailListView.scrollToIndex(curPageIndex, showing);
  var pageBarView = viewManager.get("pageBarView");
  pageBarView.scrollThumbnial();
};
MDPcMobileEditorCommonFun.currentFileBelongsToCurUserEnterprise = function () {
  var editor = MDPcMobileEditorCommonFun.getMainEditor();
  if (editor) {
    var fileInfo = editor.getCurrentFileInfo();
    return fileInfo && fileInfo.belongsToCurrentUserEnterprise();
  } else {
    return false;
  }
};

// MDPcMobileEditorCommonFun.UIActions, will contain common Actions, that can get called From UI or from Network-messages
// all of these messages are static functions
MDPcMobileEditorCommonFun.UIActions = {
  openComment: function openComment(fileInfo, commenStrId) {
    if (!(commenStrId instanceof _OBJ_ID["default"])) {
      var commentId = new _OBJ_ID["default"]();
      commentId.fromString(commenStrId);
    }
    ;
    var mainEditor = MDPcMobileEditorCommonFun.getMainEditor();
    if (mainEditor.removeCommentPanel) mainEditor.removeCommentPanel();
    mainEditor.scrollToShowFile(fileInfo, function (board) {
      var comment = board.getObject(commentId);
      if (!comment) {
        _MDSnackbarView["default"].show(BabelStr.str(7357));
        return;
      }
      ;
      var _curCommentPage = comment.getPageIndex();
      var preDispVer = mainEditor.getVersionShowing();
      var fileEditor = mainEditor.getCurFileEditor();
      mainEditor.changeVersion(comment.getFileVersion(), function () {
        if (preDispVer != mainEditor.getVersionShowing()) {
          Dispatcher.trigger(MDEvents.VersionChangedByComment, mainEditor.getVersionShowing());
          if (preDispVer == fileInfo.getCurVersion()) {
            _MDSnackbarView["default"].show(BabelStr.str(7358));
            Dispatcher.trigger(MDEvents.DisplayOldVersion, mainEditor.getVersionShowing());
          }
          if (mainEditor.getVersionShowing() == fileInfo.getCurVersion()) {
            _MDSnackbarView["default"].show(BabelStr.str(7359));
            Dispatcher.trigger(MDEvents.DisplayCurVersion, mainEditor.getVersionShowing());
          }
        }
        if (fileInfo.canDispInOpenGL()) {
          fileEditor.focusComment(comment);
          Dispatcher.trigger(MDEvents.FileChanged);
        } else if (!(fileEditor.getClassName() == 'MMPCImageEditor') && !(fileEditor.getClassName() == 'MDPCSinglePagePdfView') && !(fileEditor.getClassName() == 'MDPCSVGView') && !(fileEditor.getClassName() == 'MDSWFEditor')) {
          mainEditor.getCurFileEditor().scrollToShowObj(comment, function () {
            Dispatcher.trigger(MDEvents.COMMENT_CLICKED, mainEditor, comment);
            Dispatcher.trigger(MDEvents.FileChanged);
          });
        } else {
          setBabelTimeout(function () {
            Dispatcher.trigger(MDEvents.COMMENT_CLICKED, mainEditor, comment);
            Dispatcher.trigger(MDEvents.FileChanged);
          }, 100);
        }
      });
    });
  },
  openURLComment: function openURLComment() {
    var map = _MMCommonFun["default"].mapSearch();
    var commentDisplayIndex = parseInt(map['c']);
    var pageIndex = parseInt(map['p']);
    var editorCtl = MDPcMobileEditorCommonFun.getMainEditor();
    if (commentDisplayIndex && pageIndex) {
      //get CommentObj by commentDisplayIndex
      var comment = MDPcMobileEditorCommonFun.getMainEditor().getCurrentBoard().getCommentsInPage(pageIndex - 1)[commentDisplayIndex - 1];
      //console.log(comment);
      if (comment) MDPcMobileEditorCommonFun.UIActions.openComment(comment);
    } else if (pageIndex) {
      MDPcMobileEditorCommonFun.UIActions.changeToPage(pageIndex - 1);
    }
  },
  changeToPage: function changeToPage(pageIndex) {
    var editorCtl = MDPcMobileEditorCommonFun.getMainEditor();
    if (editorCtl) {
      if (editorCtl.getCurFileEditor().changeToPage) {
        editorCtl.changeToImage(pageIndex);
      } else if (editorCtl.changeToPage) {
        editorCtl.changeToPage(pageIndex);
      }
    }
  },
  /**
   * usage: MDPcMobileEditorCommonFun.UIActions.fakeFullscreen($el);
   * The method just set the top left right bottom to 0px.
   * the method is doing it twice, with a short break, because of orientationchanged in IOS.
   * Because the IOS needs is changing the window dimensions much later then the orientationchanged-event is fired.
   */
  fakeFullscreen: function fakeFullscreen($el) {
    MDPcMobileEditorCommonFun.UIActions._fakeFullscreen($el);
    setBabelTimeout(function () {
      MDPcMobileEditorCommonFun.UIActions._fakeFullscreen($el);
    }, 100);
    setBabelTimeout(function () {
      MDPcMobileEditorCommonFun.UIActions._fakeFullscreen($el);
    }, 200);
    setBabelTimeout(function () {
      MDPcMobileEditorCommonFun.UIActions._fakeFullscreen($el);
    }, 500);
    setBabelTimeout(function () {
      MDPcMobileEditorCommonFun.UIActions._fakeFullscreen($el);
    }, 1000);
    setBabelTimeout(function () {
      MDPcMobileEditorCommonFun.UIActions._fakeFullscreen($el);
    }, 2000);
  },
  _fakeFullscreen: function _fakeFullscreen($el) {
    $el.css({
      "top": "0px",
      "right": "0px",
      "bottom": "0px",
      "left": "0px",
      "width": "initial",
      "height": "initial"
    });
  }
};
window.MDPcMobileEditorCommonFun = MDPcMobileEditorCommonFun;
var _default = exports["default"] = MDPcMobileEditorCommonFun;

},{"1184":1184,"1454":1454,"1466":1466,"72":72,"812":812,"818":818,"938":938,"940":940}],938:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1438);
var _MDEditorOption = _interopRequireDefault(require(905));
var _goog = _interopRequireDefault(require(823));
var _MMNetDiskBoardCell = _interopRequireDefault(require(937));
var _MMAndroidCollectionView = _interopRequireDefault(require(912));
var _MMOperationCenterMobileImage = _interopRequireDefault(require(879));
var _MMPointObjData = _interopRequireDefault(require(1062));
var _MMBasicData = _interopRequireDefault(require(811));
var _MMObjElementsController = _interopRequireDefault(require(893));
var _MMPDFCollectionView = _interopRequireDefault(require(931));
/**
 * image 横向滚屏的 view
 * 2015-9-11
 * jiang
 */

/**
 * @param {HTMLElement} containerDiv  page scroll view's parent div
 * @param {MMDevOrientation} devDirection 横纵向
 */
var g_netDiskImgCollectionView = null;
function MMNetDiskImageCollectionView(params) {
  var boardArr = params.boardArr;
  var containerDiv = params.containerDiv;
  this.editorViewCtl = params.editorViewCtl;
  this.boardArr = boardArr;
  console.assert(boardArr.length > 0);
  if (boardArr.length == 0) {
    return;
  }
  ;
  g_netDiskImgCollectionView = this;
  _MMAndroidCollectionView["default"].call(this, containerDiv, "horizontal", boardArr.length);
  this.className = "MMNetDiskImageCollectionView";
  var z_startIndex = _MMBasicData["default"].getO2OStartLayerZ_index();
  $(this.container).css('z-index', z_startIndex);
  this.initWithWhiteboardArr(boardArr);

  //mashx temporary code here for pinch gesture: in the near furture, we're gonna
  //merge this code with the pdf pinch.
  var that = this;
  if (!app.canDispInNormalBrowser()) {
    this.bodyRecognizer = new Hammer($('.m-editor-root')[0]);
    this.mScale = 1.0;
    this.bodyRecognizer.on('pinchstart', _.bind(function (e) {
      console.log('pinchstart');
      that.pinchStart(e);
      that.mScale = 1.0;
    }, this));
    this.bodyRecognizer.on('pinchmove', _.bind(function (e) {
      console.log('pinchmove,scale:' + e.scale);
      that.pinchMove(e.scale / that.mScale);
      that.mScale = e.scale;
    }, this));
    this.bodyRecognizer.on('pinchend', _.bind(function (e) {
      console.log('pinchend, scale:' + e.scale);
      that.pinchEnd(e.scale / that.mScale);
      that.mScale = 1.0;
    }, this));
    this.bodyRecognizer.on('pinchcancel', _.bind(function (e) {
      console.log('pinch cancelled: scale:' + e.scale);
      that.pinchEnd(1.0);
      that.mScale = 1.0;
    }, this));
    $('.m-editor-root')[0].addEventListener('touchstart', function (e) {
      if (e.touches.length >= 2) {
        that.bodyRecognizer.get('pinch').set({
          'enable': true
        });
      }
    }, false);
    $('.m-editor-root')[0].addEventListener('touchend', function (e) {
      that.bodyRecognizer.get('pinch').set({
        'enable': false
      });
    }, false);
  }
  ;
  Dispatcher.on(MDEvents.DATA_READY, this._dataReadyCallback, this);
}
;
_goog["default"].inherits(MMNetDiskImageCollectionView, _MMAndroidCollectionView["default"]);
MMNetDiskImageCollectionView.getCurrentInstance = function () {
  return g_netDiskImgCollectionView;
};
MMNetDiskImageCollectionView.clearCurrentInstance = function () {
  g_netDiskImgCollectionView = null;
};
MMNetDiskImageCollectionView.setCurrentInstance = function (editor) {
  g_netDiskImgCollectionView = editor;
};
MMNetDiskImageCollectionView.prototype._dataReadyCallback = function (board, rect) {
  var that = this;
  if (rect) {
    that.displayInRect(board, rect);
  } else {
    that.refreshView();
  }
};
MMNetDiskImageCollectionView.prototype.initWithWhiteboardArr = function (boardArr) {
  if (this.boardArr != boardArr) {
    this.boardArr = boardArr;
    this.boardArrPageNumChanged();
    this.reloadData();
    this.scrollToPage(0);
  }
  if (this.operationCenter) {
    this.operationCenter.destroy();
    this.operationCenter = null;
  }
  if (!app.canDispInNormalBrowser()) {
    this.operationCenter = new _MMOperationCenterMobileImage["default"]({
      whiteboardArr: boardArr,
      pageIndex: 0,
      editor: this,
      mode: 'collection',
      displayedObject: null,
      editorViewCtl: this.editorViewCtl
    });
  }
  ;
};
MMNetDiskImageCollectionView.prototype.boardArrPageNumChanged = function () {
  this.pageNumChanged(this.boardArr.length);
};
MMNetDiskImageCollectionView.prototype.createCellForPage = function (pageIndex) {
  return new _MMNetDiskBoardCell["default"]({
    editorViewCtl: this.editorViewCtl
  });
};
MMNetDiskImageCollectionView.prototype.initCell = function (cell, pageIndex) {
  cell.setIndex(pageIndex);
  var board = this._getBoardByIndex(pageIndex);
  cell.setBoard(board);
};
MMNetDiskImageCollectionView.prototype.refreshView = function (callback) {
  // this.boardArrPageNumChanged();

  MMNetDiskImageCollectionView.superClass_.refreshView.call(this);
  for (var i = 0; i < this.dispCells.length; i++) {
    var cell = this.dispCells[i];
    var index = cell.getIndex();
    var board = this._getBoardByIndex(index);
    if (board != cell.getBoard()) {
      cell.setBoard(board, callback);
    } else {
      cell.refreshObjsDisp(callback);
    }
  }
};
MMNetDiskImageCollectionView.prototype.displayInRect = function (board, lgRct, callback) {
  this.boardArrPageNumChanged();
  MMNetDiskImageCollectionView.superClass_.refreshView.call(this);
  for (var i = 0; i < this.dispCells.length; i++) {
    var cell = this.dispCells[i];
    var index = cell.getIndex();
    var board = this._getBoardByIndex(index);
    if (board && board != cell.getBoard()) {
      cell.setBoard(board, callback);
    } else {
      if (board) {
        cell.refreshLgPageInRect(lgRct);
      }
      ;
    }
  }
};
MMNetDiskImageCollectionView.prototype._getBoardByIndex = function (index) {
  var board = null;
  if (index < this.boardArr.length) {
    board = this.boardArr[index];
  }
  ;
  return board;
};
MMNetDiskImageCollectionView.prototype.getAssistantCanvas = function () {
  return this.getOperationLayer();
};
MMNetDiskImageCollectionView.prototype.convertPointFromAssistView2Editor = function (pos) {
  //todo: this implementation is from the EditorView
  var cell = this.getCurrentCell();
  if (!cell || !cell.getEditor()) {
    return pos;
  }
  ;
  var editor = cell.getEditor();
  var newpos = pos.clone();
  var to = editor.getCommentLayer();
  var from = this.getAssistantCanvas();
  var converted = MMCommonFun.convertPointBetweenElements(from, to, pos);
  newpos.x = converted.x;
  newpos.y = converted.y;
  return newpos;
};
MMNetDiskImageCollectionView.prototype.convertPointFromEditor2AssistView = function (pos) {
  var cell = this.getCurrentCell();
  if (!cell || !cell.getEditor()) {
    return pos;
  }
  ;
  var editor = cell.getEditor();
  var newpos = pos.clone();
  var to = this.getAssistantCanvas();
  var from = editor.getCommentLayer();
  var converted = MMCommonFun.convertPointBetweenElements(from, to, pos);
  newpos.x = converted.x;
  newpos.y = converted.y;
  return newpos;
};

// --------------------------  ----------------------------  --------------------  新增转换函数
MMNetDiskImageCollectionView.prototype.logic2AssistViewPoint = function (pos) {
  var trsfm = this.getDivTransformer();
  if (!trsfm) {
    return pos;
  }
  ;
  var devicePoint = trsfm.lg2dvPoint(pos);
  var newPoint = this.convertPointFromEditor2AssistView(devicePoint);
  return newPoint;
};
MMNetDiskImageCollectionView.prototype.assistView2LogicPoint = function (pos) {
  var trsfm = this.getDivTransformer();
  if (!trsfm) {
    return pos;
  }
  ;
  var newpos = this.convertPointFromAssistView2Editor(pos);
  var logicPoint = trsfm.dv2lgPoint(newpos);
  return logicPoint;
};

//---------------------------------------------- gesture ------------------------------------------------
MMNetDiskImageCollectionView.prototype.panStart = function (e) {
  MMNetDiskImageCollectionView.superClass_.panStart.call(this, e);
  var cell = this.getCurrentCell();
  if (cell) {
    cell.panStart(e);
  }
  this.subViewScrolled = false;
  this.selfScrolled = false;

  // console.log('0. set self scroll false');
};
MMNetDiskImageCollectionView.prototype.panMove = function (e) {
  var cell = this.getCurrentCell();
  if (cell && !this.selfScrolled) {
    this.subViewScrolled = cell.panMove(e) || this.subViewScrolled; // try to scroll sub view first
    if (!this.subViewScrolled) {
      this.selfScrolled = MMNetDiskImageCollectionView.superClass_.panMove.call(this, e);
    } else {
      // console.log('*** 不能滚屏 子窗口内部滚动了');
    }
    if (!this.selfScrolled) {
      // console.log('1. collection view not scrolled');
    }
    ;
  } else {
    this.selfScrolled = MMNetDiskImageCollectionView.superClass_.panMove.call(this, e);
    if (!this.selfScrolled) {
      // console.log('2. collection view not scrolled');
    }
    ;
  }
  return this.selfScrolled;
};
MMNetDiskImageCollectionView.prototype.panEnd = function (e) {
  var cell = this.getCurrentCell();
  if (cell && !this.selfScrolled) {
    this.scrollToShowFullPage();
    cell.panEnd(e);
    console.log('');
  } else {
    var adjust = MMNetDiskImageCollectionView.superClass_.panEnd.call(this, e);
    if (!adjust) {
      // console.log('not adjust');
    }
    ;
  }
};
MMNetDiskImageCollectionView.prototype.clicked = function (e) {
  this.scrollToShowFullPage();
};
MMNetDiskImageCollectionView.prototype.pinchStart = function (scale) {
  // this.setScrollable(false);

  var cell = this.getCurrentCell();
  if (cell != undefined && cell != null) {
    return cell.pinchStart(scale);
  }
};
MMNetDiskImageCollectionView.prototype.pinchMove = function (scale) {
  // this.setScrollable(false);
  var cell = this.getCurrentCell();
  if (cell != undefined && cell != null) {
    return cell.pinchMove(scale);
  }
};
MMNetDiskImageCollectionView.prototype.pinchEnd = function (scale) {
  var cell = this.getCurrentCell();
  if (cell != undefined && cell != null) {
    return cell.pinchEnd(scale);
  }
};
MMNetDiskImageCollectionView.prototype.refreshSize = function () {
  var curFileIsPdf = this._currentFileIsPdf();
  var curPdfPos;
  if (curFileIsPdf) {
    var curPdfPos = this.getCurFileEditor().getCenterRatioPosition();
  }
  ;
  var curPage = this.curPage;
  if (MMNetDiskImageCollectionView.superClass_.refreshSize.call(this)) {
    console.log("+++  restore to page:" + curPage);
    this.restoreToPage(curPage);
    if (curFileIsPdf) {
      this.getCurFileEditor().restoreCenterPostion(curPdfPos);
    }
    ;
    return true;
  }
  return false;
};

//------------------------------------------------------------------------------------------------

MMNetDiskImageCollectionView.prototype.getObjsInView = function () {
  var cell = this.getCurrentCell();
  if (cell != undefined && cell != null) {
    return cell.getEditor().getObjsInView();
  }
  return [];
};
MMNetDiskImageCollectionView.prototype.getDivTransformer = function () {
  var cell = this.getCurrentCell();
  if (cell && cell.getEditor()) {
    return cell.getEditor().getDivTransformer();
  }
  ;
  return null;
};
MMNetDiskImageCollectionView.prototype.getCanvasTransformer = function () {
  var cell = this.getCurrentCell();
  if (cell && cell.getEditor()) {
    return cell.getEditor().getCanvasTransformer();
  }
  ;
  return null;
};
MMNetDiskImageCollectionView.prototype.showCommentLine = function () {
  //console.log("显示批注线")
  var cell = this.getCurrentCell();
  if (cell && cell.getEditor()) {
    //return cell.getEditor().showCommentLine();
  }
  ;
};
MMNetDiskImageCollectionView.prototype.getPicObject = function () {
  var cell = this.getCurrentCell();
  if (cell != undefined && cell != null) {
    return cell.getEditor().getPicObject();
  }
  return null;
};
MMNetDiskImageCollectionView.prototype.getObjectNatureSize = function () {
  var cell = this.getCurrentCell();
  if (cell != undefined && cell != null) {
    return cell.getEditor().getObjectNatureSize();
  }
  return null;
};
MMNetDiskImageCollectionView.prototype.getFileCount = function () {
  var boardArr = this.boardArr;
  return boardArr.length;
};
MMNetDiskImageCollectionView.prototype.getCurrentFileIndex = function () {
  var cell = this.getCurrentCell();
  if (cell != undefined && cell != null) {
    return cell.pageIndex;
  }
  return -1;
};
MMNetDiskImageCollectionView.prototype.getCurrentFileVersion = function () {
  var fileIndex = this.getCurrentFileIndex();
  if (fileIndex >= 0) {
    return this.boardArr[fileIndex].getCurVersion();
  }
};
MMNetDiskImageCollectionView.prototype.getCurrentFilePageCount = function () {
  return this._getCurPdfPagesCount();
};
MMNetDiskImageCollectionView.prototype.getCurrentFilePageIndex = function () {
  return this._getCurPdfPage();
};
MMNetDiskImageCollectionView.prototype._getCurPdfPagesCount = function () {
  var cell = this.getCurrentCell();
  if (cell != undefined && cell != null) {
    var editor = cell.getEditor();
    if (editor) {
      return editor.getCurrentFilePageCount();
    }
  }
  return 0;
};
MMNetDiskImageCollectionView.prototype.getCurFileEditor = function () {
  var cell = this.getCurrentCell();
  if (cell != undefined && cell != null) {
    var editor = cell.getEditor();
    return editor;
  }
  return null;
};
MMNetDiskImageCollectionView.prototype._getCurPdfPage = function () {
  var cell = this.getCurrentCell();
  if (cell != undefined && cell != null) {
    var editor = cell.getEditor();
    if (editor) {
      return editor.getCurrentFilePageIndex();
    }
  }
  return 0;
};
MMNetDiskImageCollectionView.prototype._currentFileIsPdf = function () {
  var cell = this.getCurrentCell();
  if (cell != undefined && cell != null) {
    var editor = cell.getEditor();
    if (editor instanceof _MMPDFCollectionView["default"]) {
      return true;
    }
  }
  return false;
};
MMNetDiskImageCollectionView.prototype.changeDirection = function () {};
MMNetDiskImageCollectionView.prototype.getCurrentFileInfo = function () {
  var board = this.getCurrentBoard();
  if (board) {
    return board.getFileInfo();
  }
  ;
  return null;
};
MMNetDiskImageCollectionView.prototype.getCurrentBoard = function () {
  var cell = this.getCurrentCell();
  if (cell != undefined && cell != null) {
    return cell.getBoard();
  }
  return null;
};
MMNetDiskImageCollectionView.prototype.getScale = function () {
  var cell = this.getCurrentCell();
  if (cell != undefined && cell != null) {
    return cell.getScale();
  }
  return -1;
};
MMNetDiskImageCollectionView.prototype.getCommentLayer = function () {
  var cell = this.getCurrentCell();
  if (cell != undefined && cell != null) {
    var editor = cell.getEditor();
    if (editor) {
      return editor.getCommentLayer();
    }
  }
  return $();
};
MMNetDiskImageCollectionView.prototype.getOperationCenter = function () {
  return this.operationCenter;
};
MMNetDiskImageCollectionView.prototype.removeFromSuperView = function () {
  if (!this.dispCells) {
    return;
  }
  ;
  if (this.bodyRecognizer) {
    this.bodyRecognizer.off("pinchcancel pinch pinchstart pinchend scale");
  }
  ;
  Dispatcher.off(null, null, this);
  for (var i = 0; i < this.dispCells.length; i++) {
    var cell = this.dispCells[i];
    var editor = cell.getEditor();
    if (editor) {
      editor.removeFromSuperView();
    }
  }
  for (var i = 0; i < this.bufferCells.length; i++) {
    var cell = this.bufferCells[i];
    var editor = cell.getEditor();
    if (editor) {
      editor.removeFromSuperView();
    }
  }
  if (this.operationCenter) {
    this.operationCenter.destroy();
  }
  MMNetDiskImageCollectionView.superClass_.removeFromSuperView.call(this);
};
MMNetDiskImageCollectionView.prototype.changeVersion = function (ver_, callback) {
  var cell = this.getCurrentCell();
  if (cell != undefined && cell != null) {
    cell.changeVersion(ver_, callback);
  }
};
MMNetDiskImageCollectionView.prototype.getVersionShowing = function () {
  var cell = this.getCurrentCell();
  if (cell != undefined && cell != null) {
    return cell.getVersionShowing();
  }
};
MMNetDiskImageCollectionView.prototype.setCurOperation = function (oper_, objs_, comm_) {
  if (!app.canDispInNormalBrowser()) {
    if (this.operationCenter) {
      this.operationCenter.setCurOperation(oper_, objs_, comm_);
    }
  } else {
    var cell = this.getCurrentCell();
    if (cell) {
      cell.getEditor().setCurOperation(oper_, objs_, comm_);
    }
    ;
  }
};
MMNetDiskImageCollectionView.prototype.getCurOperation = function () {
  if (!app.canDispInNormalBrowser()) {
    if (this.operationCenter) {
      return this.operationCenter.m_curOperation;
    }
  } else {
    var cell = this.getCurrentCell();
    if (cell) {
      return cell.getEditor().getCurOperation();
    }
    ;
  }
  return null;
};
MMNetDiskImageCollectionView.prototype.closeCommentPanel = function () {
  for (var i = 0; i < this.dispCells.length; i++) {
    var cell = this.dispCells[i];
    var editor = cell.getEditor();
    if (editor) {
      editor.closeCommentPanel();
    }
  }
};
MMNetDiskImageCollectionView.prototype.changeScale = function (scale, callback) {
  var cell = this.getCurrentCell();
  if (cell) {
    cell.getEditor().changeScale(scale, callback);
  }
  ;
};
MMNetDiskImageCollectionView.prototype.zoomToFit = function (callback) {
  var cell = this.getCurrentCell();
  if (cell) {
    cell.getEditor().zoomToFit();
  }
  ;
};
MMNetDiskImageCollectionView.prototype.getScale = function () {
  var cell = this.getCurrentCell();
  if (cell) {
    return cell.getEditor().getScale();
  }
  ;
  return 1.0;
};
MMNetDiskImageCollectionView.prototype.scrollToBoard = function (board, finishCall) {
  var curboard = this.getCurrentBoard();
  if (curboard == board) {
    if (finishCall) {
      finishCall();
    }
    ;
  } else {
    var index = -1;
    for (var i = 0; i < this.boardArr.length; i++) {
      if (board == this.boardArr[i]) {
        index = i;
        break;
      }
    }
    ;
    if (index != -1) {
      this.scrollToPage(index, true, finishCall);
    }
    ;
  }
};
MMNetDiskImageCollectionView.prototype.scrollToPage = function (index, animated, succ) {
  if (this.boardArr.length <= 0) {
    return;
  }
  ;
  if (index < 0) {
    index = 0;
  }
  ;

  // MDEditorOption.restorehDefault();

  if (index >= this.boardArr.length) {
    index = this.boardArr.length - 1;
  }
  ;
  var leftTop = this.layout.getItemPositionByIndex(index);
  this.scrollToPosition(leftTop, animated, function finished() {
    if (succ) {
      succ();
    }
    ;
  });
};
MMNetDiskImageCollectionView.prototype.getFileThumbnailsInfo = function (size) {
  if (this.boardArr.length <= 0) {
    return [];
  }
  ;
  var thumbs = [];
  for (var i = 0; i < this.boardArr.length; i++) {
    var board = this.boardArr[i];
    thumbs.push(board.getFileThumbnailInfo(size));
  }
  ;
  return thumbs;
};
MMNetDiskImageCollectionView.prototype.refreshCommentsInEditor = function () {
  for (var i = 0; i < this.bufferCells.length; i++) {
    var cell = this.bufferCells[i];
    var editor = cell.getEditor();
    if (editor) {
      var objCtl = _MMObjElementsController["default"].getSingleInstance();
      objCtl.removeAllDivsForEditor(editor);
      editor.refreshCommentsInEditor();
    }
  }
  for (var i = 0; i < this.dispCells.length; i++) {
    var cell = this.dispCells[i];
    var editor = cell.getEditor();
    if (editor) {
      var objCtl = _MMObjElementsController["default"].getSingleInstance();
      objCtl.removeAllDivsForEditor(editor);
      editor.refreshCommentsInEditor();
    }
  }
};
MMNetDiskImageCollectionView.prototype.enableMouseWheel = function (enable) {};
var _default = exports["default"] = MMNetDiskImageCollectionView;

},{"1062":1062,"1184":1184,"1438":1438,"1454":1454,"811":811,"823":823,"879":879,"893":893,"905":905,"912":912,"931":931,"937":937}],879:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMOperationCenterMobile = _interopRequireDefault(require(878));
var _MDTouchMenu = _interopRequireDefault(require(339));
var _MMOperationCenter = _interopRequireDefault(require(874));
var _MDCommentSlidePanelView = _interopRequireDefault(require(319));
var _MMMovingOperation = _interopRequireDefault(require(870));
var _ObjType = _interopRequireDefault(require(1084));
var _MMObjElementsController = _interopRequireDefault(require(893));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
function MMOperationCenterMobileImage(options) {
  _MMOperationCenterMobile["default"].call(this, options);
}
MMOperationCenterMobileImage.prototype = _.extend({}, _MMOperationCenterMobile["default"].prototype);
MMOperationCenterMobileImage.prototype.superclass = _MMOperationCenterMobile["default"];
MMOperationCenterMobileImage.prototype.onThrowRight = function () {
  if (this.mode !== 'taskboard') return;
  if (this.m_curOperation) return;
  if (this.longPressHappend) return;
  this.throwHappened = true;
};
MMOperationCenterMobileImage.prototype.onThrowLeft = function () {
  if (this.mode !== 'taskboard') return;
  if (this.m_curOperation) return;
  if (this.longPressHappend) return;
  this.throwHappened = true;
};
MMOperationCenterMobileImage.prototype.onPanStart = function (f, e) {
  if (!this.m_curOperation) {
    this.userStartPan(f, e);
  }
};
MMOperationCenterMobileImage.prototype.onPan = function (f, e) {
  if (!this.m_curOperation) {
    this.userPanning(f, e);
  }
};
MMOperationCenterMobileImage.prototype.onPanEnd = function (f, e) {
  if (!this.m_curOperation) {
    this.userEndPan(f, e);
  }
};
MMOperationCenterMobileImage.prototype.onTouchStart = function (f, e) {
  this.throwHappened = false;
  this.longPressHappend = false;
  _MDTouchMenu["default"].hide();
  var lastEvent;
  e.preventDefault();
  if (this.createCommentView && !this.m_curOperation) {
    var createCommentView = this.createCommentView;
    this.createCommentView.hide(function () {
      createCommentView.remove();
    });
    if (this.createCommentView._$circleParent) this.createCommentView._$circleParent.remove();
    this.createCommentView = null;
  }
  e.touches[0].currentTarget = e.currentTarget;
  e.touches[0].timeStamp = e.timeStamp;

  //__onMouseDown(f.beginFinger);
  var devicePoint = _MMOperationCenter["default"].getPosition(f.beginFinger, this.offsetLeft || 0, this.offsetTop || 0);
  var logicPoint = this.m_editor.assistView2LogicPoint(devicePoint);
  var clickedObjects = this.getObjectsSelectable(logicPoint); //mashx modified at this point
  if (!!this.m_curOperation) {
    this.m_curOperation.onMouseDown(logicPoint, clickedObjects[0], f.beginFinger);
  }
  lastEvent = e;
};
MMOperationCenterMobileImage.prototype.onTouchMove = function (f, e) {
  e.preventDefault();
  e.stopPropagation();
  var devicePoint = _MMOperationCenter["default"].getPosition(f.lastFinger, this.offsetLeft || 0, this.offsetTop || 0);
  var logicPoint = this.m_editor.assistView2LogicPoint(devicePoint);
  var clickedObjects = this.getObjectsSelectable(logicPoint); //mashx modified at this point
  if (!!this.m_curOperation) {
    this.m_curOperation.onMouseMove(logicPoint, f.lastFinger);
  }
};
MMOperationCenterMobileImage.prototype.onTouchEnd = function (f, e) {
  var devicePoint = _MMOperationCenter["default"].getPosition(f.lastFinger, this.offsetLeft || 0, this.offsetTop || 0);
  var logicPoint = this.m_editor.assistView2LogicPoint(devicePoint);
  var clickedObjects = this.getObjectsSelectable(logicPoint); //mashx modified at this point
  if (!!this.m_curOperation) {
    this.m_curOperation.onMouseUp(logicPoint, f.lastFinger);
  }
};

// MMOperationCenterMobileImage.prototype.onTap = function(f, e) {

//   var devicePoint = MMOperationCenter.getPosition(f.beginFinger, this.offsetLeft || 0, this.offsetTop || 0);
//   var logicPoint = this.m_editor.assistView2LogicPoint(devicePoint);
//   logicPoint.devicePoint = devicePoint;
//   e.LGPoint = logicPoint;

//   var clickedObjects = this.getObjectsSelectable(logicPoint);
//   if (clickedObjects.length > 0) {
//     var _firstObject = clickedObjects[0];
//     if (_firstObject.m_objType == ObjType.Obj_comment) {
//       var elementsCtl = MMObjElementsController.getSingleInstance();
//       var div = elementsCtl.getDivByObj(null, _firstObject);

//       var center = MMCommonFun.getDivCenter($(div));
//       var posInBody = MMCommonFun.convertPointBetweenElements(div, $("body")[0], center);

//       var commentPanel = new MDCommentSlidePanelView({
//         comment: _firstObject,
//         view: this.m_editor,
//         onCloseBtnClicked: function() {
//           MMObjElementsController.commentPointUpdater.updateCommentView(_firstObject, "readed");
//           commentPanel.removeFromSuperView();
//         }
//       });
//       application.addSubView(commentPanel);
//       commentPanel.centerZoomShowForMobile(posInBody);
//     }
//   }
// }

MMOperationCenterMobileImage.prototype.onDoubleTap = function () {
  console.log('double tap');
};
MMOperationCenterMobileImage.prototype.onLongPress = function (f, e) {
  e.preventDefault();
  e.stopPropagation();
  var curWhiteboard = this.editorViewCtl.getCurrentBoard();
  if (!curWhiteboard) {
    return;
  }
  ;
  var fileInfo = curWhiteboard.getFileInfo();
  if (fileInfo && !fileInfo.canCreateComment()) {
    return;
  }
  ;
  var list = [];
  for (var i in f.beginFinger.currentTarget) {
    list.push(i);
  }
  var devicePoint = _MMOperationCenter["default"].getPosition(f.beginFinger, this.offsetLeft || 0, this.offsetTop || 0);
  var logicPoint = this.m_editor.assistView2LogicPoint(devicePoint);
  e.LGPoint = logicPoint;
  //no longpress outside of the current page
  if (!window.isLPOnPage(logicPoint, 0)) return;
  // no longpress when participant is on empty page. because the owner/sponsor puts the first content on a page.
  if (!app.currentUser.isFileOwner(curWhiteboard.getCreatorId().toDecString()) && curWhiteboard.getObjsInPage(this.m_editor.getCurrentFilePageIndex()) == 0) return;

  // no comment or tag creation on closed whiteboards
  if (curWhiteboard.isClosed()) return;
  var clickedObjects = this.getObjectsSelectable(logicPoint); //mashx modified at this point
  console.log("longpress");
  if (window.navigator.vibrate) window.navigator.vibrate(200);
  this.longPressHappend = true;
  if (!this.m_curOperation) {
    if (clickedObjects.length && (clickedObjects[0].m_objType === _ObjType["default"].Obj_comment || clickedObjects[0].m_objType === _ObjType["default"].Obj_niceTag) && app.currentUser.isObjectCreator(clickedObjects[0])
    //   && Math.abs(clickedObjects[0].getCreationTime() - (new Date().getTime())) < 1000 * 60 * 15 /* 10 minutes time */
    ) {
      if (!curWhiteboard.isClosed()) {
        // move the comment      -- 手机上不移动批注了
        // this.m_curOperation = new MMMovingOperation(this, clickedObjects[0]);
        // this.m_curOperation.onMouseDown(logicPoint, this.$canvas, clickedObjects[0], e);
      }
    } else {
      var bodyPoint = MMCommonFun.convertPointBetweenElements($('.m-editor-root')[0], $('body')[0], devicePoint);
      var ver = this.editorViewCtl.getVersionShowing();
      var currentImage = curWhiteboard.getImgPdfObjectsForVersion(ver)[0];
      if (currentImage && currentImage.isPtOn(logicPoint)) {
        this.openTouchMenue(logicPoint, bodyPoint);
      }
    }
  }
};

// ***** EVENTS END, HELPER METHODS START *****

MMOperationCenterMobileImage.prototype.userStartPan = function (finger, e) {
  var editor = null;
  editor = this.m_editor;
  editor.panStart(e);
};
MMOperationCenterMobileImage.prototype.userPanning = function (finger, e) {
  var editor = null;
  this._isPageChanging = true;
  editor = this.m_editor;
  editor.panMove(e);
};
MMOperationCenterMobileImage.prototype.userEndPan = function (finger, e) {
  var editor = null;
  editor = this.m_editor;
  editor.panEnd(e);
};
var _default = exports["default"] = MMOperationCenterMobileImage;

},{"1084":1084,"1184":1184,"1454":1454,"319":319,"339":339,"807":807,"870":870,"874":874,"878":878,"893":893}],319:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
require(1417);
require(1439);
require(1466);
var _MMViewBase = _interopRequireDefault(require(22));
var _MDPanelMessageListView = _interopRequireDefault(require(337));
var _MDCheckboxView = _interopRequireDefault(require(37));
var _MDEvents = _interopRequireDefault(require(325));
var _MDPanelChatInputView = _interopRequireDefault(require(336));
var _MDAudioPlayer = _interopRequireDefault(require(313));
var _MMBasicData = _interopRequireDefault(require(811));
var _MMObjElementsController = _interopRequireDefault(require(893));
var _MMObjOperationStrategy = _interopRequireDefault(require(872));
var _MMOperationType = _interopRequireDefault(require(882));
var _ObjType = _interopRequireDefault(require(1084));
var _MDAlertView = _interopRequireDefault(require(32));
var _MMCommentObj = _interopRequireDefault(require(1005));
var _MDTransformFileUpload = _interopRequireDefault(require(340));
var _MDTransferFileItemView = _interopRequireDefault(require(727));
var _MMSketchCommentController = _interopRequireDefault(require(885));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MDEvaluationOpinionBar = _interopRequireDefault(require(324));
/**
 *  任务版页面
 *  WebContent/javascript/moladisk/common/MDCommentSlidePanelView.js
 *
 *  Create by manjun.han
 *  2014.12.30
 */

var MDCommentSlidePanelView = _MMViewBase["default"].extend({
  tmpl: "<header>\n          <div id=\"pointerRect\"></div>\n          <div>\n            <div class=\"finishChbSlot\"></div>\n            <% if(!readonly){%><div class=\"del-comment-btn\"><%=delComment%></div><%}%>\n          </div>\n          <div class=\"btn-bar f-fr\">\n            <button class=\"icon ic-expand maximi-btn\"></button>\n            <button class=\"icon ic-close\"></button>\n          </div>\n        </header>\n      <section>\n        <div class=\"touch-scrollable\" id=\"js-comment-panel\" style=\"height: 100%\"></div>\n      </section>\n      <footer></footer>",
  className: function className() {
    var cls = _MMViewBase["default"].prototype.className.call(this);
    cls += ' m-comment-panel';
    if (app.isMobile()) {
      cls += ' animated fadeInUp';
    }
    return cls;
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      $chatPanel: null,
      messageListView: null,
      $pointerRect: null,
      comment: null,
      enableDraggable: false,
      maximi: false,
      position: {},
      onCloseBtnClicked: _.noop,
      $maxToggleBtn: null,
      onOpen: _.noop,
      onDrag: _.noop,
      onRemove: _.noop,
      disableMax: false
    });
  },
  events: function events() {
    var superEvents = _MMViewBase["default"].prototype.events.call(this);
    var myEvents = {
      'click .ic-close': this._closeBtnClickHandler,
      'click .del-comment-btn': this._deleteButtonHandler,
      'click': this._clickHandler,
      "mouseenter": this._mouseEnter
    };
    if (app.canDispInNormalBrowser()) {
      _.extend(myEvents, {
        'click .maximi-btn': this._togglePanelMaximi
      });
    }
    return _.extend(superEvents, myEvents);
  },
  initialize: function initialize(options) {
    var _this = this;
    var self = this;
    this.whiteboard = options.editorViewCtl.getCurrentBoard();
    _MMViewBase["default"].prototype.initialize.call(this, options);
    this.hide();
    var zIndex = _MMBasicData["default"].getEditorMaxZ_index();
    this.$el.css('z-index', zIndex);
    this.$messageListWrap = this.$('#js-comment-panel');
    this.$commentDeleteButton = this.$('#del-comment-btn');
    this.$footer = this.$('>footer');
    this.$pointerRect = this.$('#pointerRect');
    this.$bd = this.$('>section');
    if (!options.comment.isComment() && options.comment.m_className !== 'MMTextComment' && options.comment.m_className !== 'MDHtmlComment' && options.comment.m_className !== 'MDArrowHtmlComment' && options.comment.m_className !== 'MDRectHtmlComment' && options.comment.m_className !== 'MD3DComment') {
      throw new Error('the commentSlidePannel needs a comment');
    }
    this.messageListView = new _MDPanelMessageListView["default"]({
      comment: self.comment,
      editorViewCtl: self.editorViewCtl,
      parent: self
    });
    this.addSubView(this.messageListView, this.$messageListWrap[0]);
    var inputDisabled = !this.whiteboard.fileInfo.canReadComment() || app.currentUser.isAnonymous() || this.whiteboard.fileInfo.isInTrash();
    if (this.imgMarkerCtl) {
      this.imgMarkerCtl.editorViewCtl = this.editorViewCtl;
    }
    this.chatInputView = new _MDPanelChatInputView["default"]({
      comment: this.comment,
      view: this.view,
      inputDisabled: inputDisabled,
      imgMarkerCtl: this.imgMarkerCtl,
      editorViewCtl: this.editorViewCtl,
      onFileUploadAction: function onFileUploadAction() {
        if (app.canDispInNormalBrowser()) {
          _MDTransformFileUpload["default"].browserFiles();
        }
      },
      onFocus: function onFocus() {
        self._chatInputViewFocusHandler();
      }
    });
    if (!this.whiteboard.fileInfo.isInTrash()) {
      this.addSubView(this.chatInputView, this.$footer[0]);
    }
    this.normalType = true;
    this._getEvalInfo(function (evalFlow) {
      if (evalFlow) {
        var curUserIsCreator = evalFlow.isCurUserCreator();
        var isEvalOpinion = _this.comment.isEvalComment();
        _this.normalType = !isEvalOpinion;
      }
      if (_this.normalType) {
        _this.finishedCheckboxView = new _MDCheckboxView["default"]({
          label: BabelStr.str(464),
          // '设为已完成',
          isBlockLevel: false,
          editable: _this._canFinishComment(),
          onBeforeChange: function onBeforeChange() {
            if (!app.currentUser.logined()) {
              app.popupInnerLogin();
              return false;
            }
          },
          onChanged: function onChanged(checked) {
            var val = 0;
            if (checked) {
              val = 1;
            }
            self.whiteboard.commentCompleted(self.comment, val);
            setBabelTimeout(function () {
              Dispatcher.trigger(_MDEvents["default"].Comment_changed);
            });
          }
        });
        _this.addSubView(_this.finishedCheckboxView, _this.$('.finishChbSlot'), true);
        _this.finishedCheckboxView.setChecked(_this.comment.isFinished(), true);
      } else {
        _this.evalOpnStatusBar = new _MDEvaluationOpinionBar["default"]({
          fileInfo: _this.whiteboard.fileInfo,
          comment: _this.comment,
          evalFlow: evalFlow
        });
        _this.addSubView(_this.evalOpnStatusBar, _this.$('.finishChbSlot'), true);
      }
      self.update();
      self.whiteboard.commentReaded(self.comment);
      _this.$maxToggleBtn = _this.$('.maximi-btn');
      if (!app.canDispInNormalBrowser() || _this.disableMax) {
        self.$('#del-comment-btn').remove();
        self.$('.maximi-btn').remove();
      }
      var commentCreatorId = _this.comment.getCreator().toString();
      var fileInfo = _this.whiteboard.fileInfo;
      var strategy = _MMObjOperationStrategy["default"].getOperationTypeForComment(_this.comment, commentCreatorId, fileInfo);
      if (strategy != _MMOperationType["default"].Operation_editable) {
        _this.$('.del-comment-btn').remove();
      }
      var commentSlidePanel = viewManager.get('commentSlidePanel');
      if (commentSlidePanel) {
        commentSlidePanel.remove();
      }
      viewManager.add('commentSlidePanel', _this);
      if (app.isEpVersion() && !app.currentUser.isEnterpriseGuest() && _this.whiteboard.fileInfo.belongsToCurrentUserEnterprise()) {
        var scopeName = options.comment.getScopeDispStr();
        var scope = options.comment.getVisibleScope();
        var className = 'commentScope0';
        if (scope == 1) {
          className = 'commentScope1';
        } else if (scope == 2) {
          className = 'commentScope2';
        } else if (scope == 8) {
          className = 'commentEval';
        }
        _this.$el.find('header').after('<div class="commentScope ' + className + '">' + scopeName + '</div>');
        _this.$el.find('section').css('top', '60px');
      }
      if (app.canDispInNormalBrowser()) {
        _this.initFileUpload();
      }
      _MMCommonFun["default"].setTextInputInEditor('replyComment');
    });
  },
  _getEvalInfo: function _getEvalInfo(callback) {
    if (this.whiteboard.fileInfo.isInEvaluation()) {
      var version = this.editorViewCtl.getVersionShowing();
      this.whiteboard.fileInfo.getEvalFlowInfo(version, function (evalFlow) {
        callback(evalFlow);
      });
    } else {
      callback(null);
    }
  },
  initFileUpload: function initFileUpload() {
    var self = this;
    _MDTransformFileUpload["default"].initialize({
      fieldName: 'transferFile',
      uploadURL: '/netdrive/uploadTransferFile.do',
      onFileAdd: function onFileAdd(e, data) {
        var uploadFileItemView = new _MDTransferFileItemView["default"]({
          fileName: data.files[0].name,
          fileSize: data.files[0].size,
          uploadingMode: true
          // fileId: self.whiteboard.fileInfo.getFileId()
        });
        uploadFileItemView.setUploader(data);
        _MDTransformFileUpload["default"].setOtherParams({
          uploadFileItemView: uploadFileItemView
        });
        self.messageListView.appendTransformFileItem(uploadFileItemView);
      },
      onProgress: function onProgress(e, data) {
        var uploadFileItemView = data.view;
        var progress = parseInt(data.loaded / data.total * 100, 10);
        uploadFileItemView.setProgress(progress);
      },
      onGetParam: function onGetParam(file) {
        return {
          'fileId': self.whiteboard.fileInfo.getFileId(),
          'fileName': file.name
        };
      },
      onFail: function onFail(e, data, otherParams) {
        console.error(e);
        console.error(data);
        var result = data.result;
        if (result.code == '10006') {
          result['msg'] = BabelStr.str(5558);
        }
        _MDSnackbarView["default"].show(result['msg']);
        otherParams.uploadFileItemView.superView.remove();
      },
      onUploadFail: function onUploadFail(e, data) {
        var uploadFileItemView = data.view;
      },
      onUploadSuccess: function onUploadSuccess(result, data) {
        var uploadFileItemView = data.view;
        var fileRefId = result['fileRefId'];
        var fileName = data.files[0].name;
        var fileSize = data.files[0].size;
        var fileId = self.whiteboard.fileInfo.getFileId();
        var visibleScope = self.chatInputView.getVisibleScope();
        var comment = self.comment;
        uploadFileItemView.setUploadComplete(fileRefId, function () {
          var msgContent = {
            'fileName': fileName,
            'fileSize': fileSize,
            'fileRefId': fileRefId,
            'fileId': fileId
          };
          _MMSketchCommentController["default"].sendFile(msgContent, visibleScope, comment, _.noop, function () {
            $.ajax({
              url: '/netdrive/deleteTransferFile.do',
              method: 'post',
              data: {
                'fileRefId': fileRefId
              }
            });
            _MDSnackbarView["default"].show(BabelStr.str(465)); //('文件发送失败');
          });
        });
      }
    });
  },
  _clickHandler: function _clickHandler($e) {
    if (app.canDispInNormalBrowser()) {
      if (this.$bd.eventIsInner($e)) {
        this.$bd.css('bottom', 40);
        this.$footer.height(40);
      }
    }
  },
  _canFinishComment: function _canFinishComment() {
    if (this.whiteboard.fileInfo.isInTrash()) {
      return false;
    }
    return this.comment.getCreator() == app.currentUser.getUserId() || this.whiteboard.fileInfo.canFinishComment();
  },
  _chatInputViewFocusHandler: function _chatInputViewFocusHandler() {
    if (app.canDispInNormalBrowser()) {
      this.$bd.css('bottom', 140);
      this.$footer.height(140);
    }
  },
  _togglePanelMaximi: function _togglePanelMaximi($e) {
    var self = this;
    this.$el.addClass('transition').transitionEndOnce(function () {
      self.$el.removeClass('transition');
    });
    this.el.offsetWidth;
    if (!this.maximi) {
      this.$maxToggleBtn.addClass('ic-compress');
      this.$maxToggleBtn.removeClass('ic-expand');
      var position = this.$el.position();
      var height = parseInt(this.$el.css('height'));
      var width = parseInt(this.$el.css('width'));
      this.position = {
        top: position.top,
        left: position.left,
        height: height,
        width: width
      };
      var top = 60;
      this.$el.css({
        top: top,
        height: $(window).height() - top
      });
    } else {
      this.$maxToggleBtn.removeClass('ic-compress');
      this.$maxToggleBtn.addClass('ic-expand');
      this.$el.css({
        top: this.position.top,
        height: this.position.height
      });
    }
    this.maximi = !this.maximi;
  },
  _mouseEnter: function _mouseEnter() {
    this.editorViewCtl.enableMouseWheel(false);
  },
  _mouseLeave: function _mouseLeave() {
    this.editorViewCtl.checkToEnablePrivateMouseWheel();
  },
  update: function update() {
    var self = this;
    if (!this.comment) {
      this.editorViewCtl.closeCommentPanel();
      return;
    }
    var objDispCtl = _MMObjElementsController["default"].getSingleInstance();
    var cDiv = objDispCtl.getDivByObj(this.view, this.comment);
    this.updateDeleteButton();
    this.whiteboard.commentReaded(this.comment);
    Dispatcher.trigger(_MDEvents["default"].Comment_State_Sync, this.whiteboard.fileInfo.getFileId(), this);
    setBabelTimeout(function () {
      Dispatcher.trigger(_MDEvents["default"].Comment_changed);
    });

    //!{ added by jiang, 2016-2-26
    if (this.comment.getObjType() == _ObjType["default"].Obj_textComment) {
      Dispatcher.trigger(_MDEvents["default"].TextComment_status, this.comment);
    }
    ;
    //!}

    var commentListView = viewManager.get("commentList");
    if (commentListView) {
      commentListView.update();
    }
    var newCommentInputView = viewManager.get('newCommentInput');
    if (newCommentInputView) {
      newCommentInputView.removeFromSuperView();
    }
  },
  updateDeleteButton: function updateDeleteButton() {
    this.$commentDeleteButton.removeClass('del-comment-btn');
    if (app.canDispInNormalBrowser()) {
      var pageIndex = 0;
      if (this.view.getCurrentFilePageIndex) {
        pageIndex = this.view.getCurrentFilePageIndex();
      }
      ;
      var opType = _MMObjOperationStrategy["default"].getOperataionTypeForMolaTask(this.comment, pageIndex);
      var _objType = this.comment.getObjType();
      if (opType == _MMOperationType["default"].Operation_editable || opType == _MMOperationType["default"].Operation_deletable) {
        this.$commentDeleteButton.css({
          cursor: 'pointer',
          display: 'inline-block'
        });
      } else {
        this.$commentDeleteButton.css({
          cursor: 'default',
          display: 'none'
        });
      }
    } else {
      //test if the comment is already deleted
      if (this.comment.getCreator() === -1) return;
      if (app.currentUser.isObjectCreator(this.comment) && !this.whiteboard.isClosed()) {
        this.$commentDeleteButton.css({
          cursor: 'pointer',
          display: 'inline-block'
        });
      } else {
        this.$commentDeleteButton.css({
          cursor: 'default',
          display: 'none'
        });
      }
    }
  },
  setDraggable: function setDraggable(enabled) {
    var self = this;
    if (enabled) {
      this.$el.draggable({
        'containment': 'body',
        'handle': "header",
        'drag': function drag() {
          if (_.isFunction(self.onDrag)) {
            self.onDrag();
          }
        },
        'start': function start(e) {
          // var mainEditor = this.editorViewCtl;
          // mainEditor.enableMouseWheel(false);
        },
        'stop': function stop(e) {
          // var mainEditor = this.editorViewCtl;
          // mainEditor.checkToEnablePrivateMouseWheel();
        }
      });
    } else {
      if (this.$el.draggable("instance")) {
        this.$el.draggable('destroy');
      }
    }
    this.enableDraggable = enabled;
  },
  _closeBtnClickHandler: function _closeBtnClickHandler() {
    if (_.isFunction(this.onCloseBtnClicked)) {
      this.onCloseBtnClicked();
    }
  },
  _deleteButtonHandler: function _deleteButtonHandler() {
    var self = this;
    var promptStr = BabelStr.str(312); // 确定删除该批注点？
    if (this.comment.isEvalComment()) {
      promptStr = BabelStr.str(810); // 确定删除该评审意见？
    }
    var alertOpt = {
      message: promptStr,
      okFun: function okFun() {
        self.deleteComment();
      }
    };
    _MDAlertView["default"].showStandardSelection(alertOpt);
  },
  deleteComment: function deleteComment() {
    var self = this;
    var comment = this.comment;
    //tobias bug 55: first close the commentPanel, then delete the comment from the board
    // add by han
    if (_.isFunction(this.onCloseBtnClicked)) {
      this.onCloseBtnClicked();
    }

    //if (app.currentUser.isObjectCreator(comment)) {
    var type = comment.getObjType();
    var board = comment.getBoard();
    var pgIndex = comment.getPageIndex();
    self.whiteboard.deleteComment(comment, function () {
      if (comment.isComment() || type == _ObjType["default"].Obj_niceTag || type == _ObjType["default"].Obj_textComment) {
        Dispatcher.trigger(_MDEvents["default"].Comment_changed);
        Dispatcher.trigger(_MDEvents["default"].COMMENT_REMOVE, board, pgIndex);
      }
    });
    // }
  },
  saveEditorScaleAndPosition: function saveEditorScaleAndPosition() {
    var editor = this.editorViewCtl.getCurEditor();
    this.oldScale = editor.getScale();
    this.oldPos = editor.getCenterRatioPosition();
  },
  needZoom2Show: function needZoom2Show() {
    return this.oldPos;
  },
  zoomShow: function zoomShow(triggerPt, finishCb) {
    this.show();
    this._showPanel(triggerPt, finishCb);
  },
  updatePosition: function updatePosition(callback) {
    this.show();
    var editor = this.editorViewCtl.getCurEditor();
    var pos = editor.getCommentPanelLeftTop(this.comment);
    // this.$el.css({
    //   top: pos.y ,
    //   left: pos.x
    // });
    this._showPanel(pos, callback);
  },
  _showPanel: function _showPanel(triggerPt, finishCb) {
    var _this2 = this;
    if (this.isShowing) {
      return;
    }
    this.isShowing = true;
    setBabelTimeout(function () {
      _this2.isShowing = false;
    }, 200);
    var self = this;
    var $win = $(window);
    var winHeight = $win.height();
    var winWidth = $win.width();
    var width = parseInt(this.$el.css('width'));
    var height = parseInt(this.$el.css('height'));
    var top = triggerPt.y;
    var left = triggerPt.x;
    var delta_y = 0;
    var percentageY;
    var origin;
    if (triggerPt.x + width > winWidth) {
      left -= width;
    }
    if (triggerPt.y + height > winHeight) {
      top = winHeight - height;
    }
    delta_y = triggerPt.y - top;
    this.$el.css({
      top: top,
      left: left
    });
    percentageY = Math.floor(delta_y / height * 100);
    if (left >= triggerPt.x) {
      origin = '0 ' + percentageY + '%';
    } else {
      origin = '100% ' + percentageY + '%';
    }
    this.$el.css({
      'scale': 0
    });
    this.el.offsetWidth;
    this.$el.css({
      'transformOrigin': origin
    });
    this.el.offsetWidth;
    this.$el.transition({
      'scale': 1
    }, function () {
      _.isFunction(finishCb) && finishCb();
      self.$el.removeClass('transition').css('transformOrigin', '0 0');
    });
  },
  centerZoomShowForMobile: function centerZoomShowForMobile(triggerPt, finishCb) {
    this.show();
    var self = this;
    this.$el.addClass('full-size');
    var width = parseInt(this.$el.css('width'));
    var height = parseInt(this.$el.css('height'));
    var px = Math.floor(triggerPt.x / width * 100);
    var py = Math.floor(triggerPt.y / height * 100);
    var origin = px + "% " + py + "%";
    this.$el.css({
      'transformOrigin': origin
    }).addClass('transition');
    this.el.offsetWidth;
    this.$el.transition({
      'scale': 1
    }, function () {
      _.isFunction(finishCb) && finishCb();
      self.$el.removeClass('transition').css('transformOrigin', '0 0');
    });
  },
  getPointerRectView: function getPointerRectView() {
    return this.$pointerRect.get(0);
  },
  render: function render(data) {
    data = _.extend({
      'readonly': this.whiteboard.fileInfo.isInTrash(),
      'delComment': BabelStr.str(120) // 删除批注
    }, data);
    _MMViewBase["default"].prototype.render.call(this, data);
  },
  viewDidUnRendered: function viewDidUnRendered() {
    var _this3 = this;
    _MMViewBase["default"].prototype.viewDidUnRendered.call(this);
    _MDAudioPlayer["default"].stop();
    viewManager.remove('commentSlidePanel');
    if (_.isFunction(this.onRemove)) {
      this.onRemove();
    }
    _MMCommonFun["default"].removeTextInputInEditor('replyComment');
    if (this.oldPos) {
      var editor = this.editorViewCtl.getCurEditor();
      editor.changeScale(this.oldScale, function () {
        editor.restoreCenterPostion(_this3.oldPos);
        editor.refreshObjsInEditor();
      });
    }
  },
  viewDidRendered: function viewDidRendered() {
    _MMViewBase["default"].prototype.viewDidRendered.call(this);
    this.setDraggable(this.enableDraggable);
    if (_.isFunction(this.onOpen)) {
      this.onOpen();
    }
  },
  getComment: function getComment() {
    return this.comment;
  },
  removeFromSuperView: function removeFromSuperView() {
    var self = this;
    if (app.isMobile()) {
      this.$el.animationEndOnce(function () {
        _MMViewBase["default"].prototype.removeFromSuperView.call(self);
      }).addClass('fadeOutDown');
    } else {
      _MMViewBase["default"].prototype.removeFromSuperView.call(this);
    }
  }
});
var _default = exports["default"] = MDCommentSlidePanelView;

},{"1005":1005,"1084":1084,"1184":1184,"1417":1417,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1466":1466,"1478":1478,"22":22,"313":313,"32":32,"324":324,"325":325,"336":336,"337":337,"340":340,"37":37,"72":72,"727":727,"807":807,"811":811,"812":812,"872":872,"882":882,"885":885,"893":893}],340:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1466);
var $input = $('<input type="file" id="fileupload" style="opacity: 0" name="" class="upload-trigger-ipt " multiple="true">');
var MDTransformFileUpload = {
  initialize: function initialize(props) {
    props = _.extend({
      onFileAdd: _.noop,
      onProgress: _.noop,
      uploadURL: "",
      fieldName: "file",
      otherParams: {}
    }, props);
    this.onFail = props.onFail || _.noop;
    this.onFileAdd = props.onFileAdd || _.noop;
    this.onProgress = props.onProgress || _.noop;
    this.uploadURL = props.uploadURL || _.noop;
    this.onFileSubmit = props.onFileSubmit || _.noop;
    this.fieldName = props.fieldName || _.noop;
    this.otherParams = props.otherParams;
    /**
     * @callback onGetParam
     * @param {File} file - 原生File 对象
     * @return {object} - 参数对象
     */
    /**
     * @type {onGetParam}
     */
    this.onGetParam = props.onGetParam;
    /**
     * @callback onUploadSuccess
     * @param {object} result - upload result obj
     * @param {object} data -  The uploader object
     */

    /** @type {onUploadSuccess} */
    this.onUploadSuccess = props.onUploadSuccess;
    this.init();
  },
  setOtherParams: function setOtherParams(otherParams) {
    this.otherParams = otherParams;
  },
  destroy: function destroy() {
    $input.fileupload();
  },
  browserFiles: function browserFiles() {
    if (document.body.contains($input[0])) {
      $input.click();
    }
  },
  pasteFiles: function pasteFiles(file) {
    $input.fileupload("add", {
      files: file
    });
  },
  init: function init() {
    var _this = this;
    if (!document.body.contains($input[0])) {
      $input.appendTo("body");
      $input.attr("name", this.fieldName);
      $input.fileupload({
        sequentialUploads: true,
        replaceFileInput: false,
        autoUpload: false,
        dropZone: $("#js-dropzone"),
        dataType: "json",
        url: this.uploadURL,
        add: function add(e, data) {
          _this.onFileAdd(e, data, _this.otherParams);
        },
        progress: function progress(e, data) {
          var progress = parseInt(data.loaded / data.total * 100, 10);
          _this.onProgress(e, data, _this.otherParams);
        },
        fail: function fail(e, data) {
          _this.onFail(e, data, _this.otherParams);
        },
        send: function send(e, data) {
          if (data.files.length > 10) {
            return false;
          }
        },
        submit: function submit(e, data) {
          _this.onFileSubmit(e, data);
          var params = _this.onGetParam(data.files[0]) || {};
          // var params = this.onGetParam(file) || {};
          params.fileName = MMCommonFun.filterFileName(params.fileName);
          data.formData = params;
        },
        done: function done(e, data) {
          var result = data.result || {};
          if (result.code == 0) {
            _this.onUploadSuccess(result, data, _this.otherParams);
          } else {
            _this.onFail(e, data, _this.otherParams);
          }
        },
        stop: function stop() {
          $input.val("");
        }
      });
    }
  }
};
var _default = exports["default"] = MDTransformFileUpload;

},{"1454":1454,"1466":1466}],337:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
require(1417);
require(1461);
require(1466);
var _MMViewBase = _interopRequireDefault(require(22));
var _MMCommentDataController = _interopRequireDefault(require(1097));
var _link = _interopRequireDefault(require(347));
var _MDAudioPlayer = _interopRequireDefault(require(313));
var _int = _interopRequireDefault(require(820));
var _MMSketchCommentController = _interopRequireDefault(require(885));
var _MDMessage = _interopRequireDefault(require(270));
var _MDTransferFileItemView = _interopRequireDefault(require(727));
var _MMChatMessage = _interopRequireDefault(require(950));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
var _MDMessageType = _interopRequireDefault(require(271));
var _MDMenuView = _interopRequireDefault(require(53));
var _MDMenuItemView = _interopRequireDefault(require(51));
var _MDCommentActionManager = _interopRequireDefault(require(5));
var _MMObject = _interopRequireDefault(require(1081));
/**
 *  任务版页面
 *  Create by manjun.han
 *  2014.12.30
 */

var MDCommentMessageItemView = _MMViewBase["default"].extend({
  tmpl: "\n      <div class=\"avatar-box\">\n        <img class=\"avatar-img _user-profile-picture\" src=\"<%=avatarURL%>\">\n      </div>\n      <div class=\"message-wrap\">\n        <div class=\"msg-hd\">\n          <div class=\"panelmessageUsername\"><%=username%></div>\n          <div class=\"panelmessageTime\"><%=time%></div>\n        </div>\n        <div class=\"panelmessageText\"></div>\n      </div>\n      ",
  initialize: function initialize(opts) {
    var _this = this;
    _MMViewBase["default"].prototype.initialize.call(this, opts);
    var self = this;
    var tempId = this.tempId;
    if (this.type == "chat") {
      this._constructChatMsgElement();
      if (this.tempId) {
        this.$(".panelmessageText").append('<span class="sendEcho">' + BabelStr.str(711) + "</span>" + '<span class="errorEcho">' + BabelStr.str(2019) + "</span>");
        var _timeout = setBabelTimeout(function () {
          self.$(".panelmessageText").addClass("sending");
        }, 1000);
        Dispatcher.on(MDEvents.ChatMessageSendSuccess, function (type, cbTempId, messageId) {
          if (type == _MDMessageType["default"].COMMENT_CHAT && cbTempId == tempId) {
            this.messageId = messageId && messageId.toString() || "";
            clearTimeout(_timeout);
            self.$(".panelmessageText").removeClass("sending");
            Dispatcher.off(null, null, self);
          }
        }, self);
        Dispatcher.on(MDEvents.ChatMessageSendFailed, function (type, cbTempId) {
          if (type == _MDMessageType["default"].COMMENT_CHAT && cbTempId == tempId) {
            clearTimeout(_timeout);
            self.$(".panelmessageText").removeClass("sending");
            self.$(".panelmessageText").addClass("fail");
            Dispatcher.off(null, null, self);
          }
        }, self);
      }
    } else if (this.type == "transfer-file") {
      Dispatcher.on(MDEvents.ChatMessageSendSuccess, function (type, cbTempId, messageId) {
        if (type == _MDMessageType["default"].COMMENT_CHAT && cbTempId == tempId) {
          this.messageId = messageId && messageId.toString() || "";
          this.userId = app.currentUser.getUserId();
          Dispatcher.off(null, null, self);
        }
      }, self);
    }
    _.delay(function () {
      $(document.body).on(self.$nsEventName("MDCommentMessageItemViewContextMenue"), self._docMouseDownHandler, true);
      $("body")[0].addEventListener("click", self._docMouseDownHandler);
    }, 0);
    Dispatcher.on(MDEvents.undo_chat, function (data) {
      var content = data.get("content");
      var fileId = content.fileId;
      if (fileId == _this.comment.getBoard().getFileInfo().getFileId()) {
        if (content.commentId == _this.comment.m_id.toString()) {
          if (content.messageId == _this.messageId) {
            _this.canceld = true;
            _this.$el.html("<div class=\"f-tc C6\">".concat(BabelStr.str(5154), "</div>"));
          }
        }
      }
    });
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      click: this._elClickHandle,
      contextmenu: this._elClickHandle
    });
  },
  className: function className() {
    var superCls = _MMViewBase["default"].prototype.className.call(this);
    return superCls + " panelmessage left-mode";
  },
  render: function render() {
    var data = {
      avatarURL: this.avatarURL,
      time: this.time,
      username: this.username
    };
    _MMViewBase["default"].prototype.render.call(this, data);
  },
  _docMouseDownHandler: function _docMouseDownHandler(e) {
    $("#MDCommentMessageItemViewContextMenue").remove();
  },
  setAnimationShow: function setAnimationShow() {
    var self = this;
    this.$el.addClass("animated fadeIn");
    this.$el.animationEndOnce(function () {
      self.$el.removeClass("animated fadeIn");
    });
  },
  _elClickHandle: function _elClickHandle(e) {
    var _this2 = this;
    this.$el.find("#MDCommentMessageItemViewContextMenue").remove();
    e.preventDefault();
    if (app.currentUser.getUserId() != this.userId || this.canceld) {
      return;
    }
    var sec = new Date().getTime() - this.originTime.getTime();
    if (sec > 5 * 60 * 1000) {
      return;
    }
    if (this.first) {
      return;
    }
    if (e.button == 2 && app.isPC()) {
      var template = "<div id=\"MDCommentMessageItemViewContextMenue\" class=\"f-noselect\">".concat(BabelStr.str(474), "</div>");
      this.contextMenu = $(template);
      this.$el.append(this.contextMenu);
      this.contextMenu.on("mousedown", function (e) {
        if (e.button) {
          return;
        }
        var commentId = _this2.comment.m_id.toString();
        var fileId = _this2.comment.getBoard().getFileInfo().getFileId();
        MMEnterpriseController.recallCommentMessage({
          fileId: fileId,
          messageId: _this2.messageId,
          commentId: commentId
        }, function () {
          _this2.canceld = true;
          _this2.$el.html("<div class=\"f-tc C6\">".concat(BabelStr.str(5154), "</div>"));
        }, function (code) {
          if (code == 2) {
            _MDSnackbarView["default"].show(BabelStr.str(2857));
          } else {
            _MDSnackbarView["default"].show(BabelStr.str(2858));
          }
        });
      });
      console.log("右键了");
    }
  },
  _constructChatMsgElement: function _constructChatMsgElement() {
    var message = this.message;
    var userId = this.userId;
    var visibleScope = message["visibleScope"];
    var messageBody = message["Body"];
    var avatarURL = app.getAvatarImageURL(userId);
    var msgItemTmpl = "";
    var $msgItem;
    var msgType = message["Type"];
    var tempId = message["tempId"];
    var time = this.time;
    var messageDisplay = null;
    if (msgType === "Audio") {
      var audioFile = message["Url"];
      var strId = this.comment ? this.comment.getBoard().getStringId() : "";
      // does not work for discusspanel now

      messageDisplay = _MDAudioPlayer["default"].getAudioPlayer(audioFile, message["Body"], strId);
      this.$(".panelmessageText").append(messageDisplay);
    } else {
      if (msgType === "Text") {
        messageDisplay = message["Body"];
        messageDisplay = _link["default"]["do"](messageDisplay);
        messageDisplay = $('<span class="chatmessage-span">' + messageDisplay + "</span>");
        this.$(".panelmessageText").append(messageDisplay);
      } else if (msgType === "Mark") {
        messageDisplay = _MMSketchCommentController["default"].getSketchHTML(message);
        this.$(".panelmessageText").append(messageDisplay);
      } else if (msgType == "File") {
        messageBody = JSON.parse(messageBody);
        var transferItemView = new _MDTransferFileItemView["default"]({
          fileName: messageBody["fileName"],
          fileSize: messageBody["fileSize"],
          fileRefId: messageBody["fileRefId"],
          uploadingMode: false
        });
        this.addSubView(transferItemView, function (subViewEl) {
          this.$(".panelmessageText").append(subViewEl);
        });
      }
    }
    if (visibleScope) {
      this.$(".panelmessageText").addClass("msgProtected");
    }
    if (this.first) {
      this.$el.addClass("firstComment");
    }
    if (app.currentUser.getUserId() == this.userId && !this.first) {
      this.$el.addClass("right-mode").removeClass("left-mode");
    }
  },
  constructFileMsgElement: function constructFileMsgElement(transferItemView) {
    this.$el.addClass("right-mode").removeClass("left-mode");
    var userId = app.currentUser.getUserId();
    var userName = app.currentUser.getUserName();
    var msg_ = JSON.stringify({
      Type: "File",
      Body: {},
      visibleScope: 0,
      atIds: []
    });
    var messageModel = new _MMChatMessage["default"](0, userId, 0, new Date().getTime(), userName, msg_, this.comment.getId());
    var self = this;
    transferItemView.setOnAbort(function () {
      self.removeFromSuperView();
      self.transferItemView = null;
    });
    transferItemView.setOnFail(function () {
      _MDSnackbarView["default"].show(BabelStr.str(5155));
      self.transferItemView = null;
    });
    this.addSubView(transferItemView, function (subViewEl) {
      self.$(".panelmessageText").append(subViewEl);
    });
  },
  viewDidUnRendered: function viewDidUnRendered() {
    _MMViewBase["default"].prototype.viewDidUnRendered.call(this);
    // prevent memoory leak
    $(document.body)[0].removeEventListener("mosedown", this._docMouseDownHandler);
    $(document.body).off(this.$nsEventName("MDCommentMessageItemViewContextMenue"));
  }
});

/////////////////////////////////////////////////////////////////////////////////////////////////
/**
 * used for starting from bottom
 */

var MDPanelMessageListView = _MMViewBase["default"].extend({
  el: '<div class="m-msgList"></div>',
  tmpl: '<div class="m-msgList-content"><div class="msg-list"></div></div>',
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      comment: null,
      emptyPlaceholder: "",
      _curUserId: null
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.$msgListContent = this.$(".m-msgList-content");
    this.$msgList = this.$(".msg-list");
    this.whiteboard = this.editorViewCtl.getCurrentBoard();
    this._curUserId = app.currentUser.getUserId();
    this._curUserId = typeof this._curUserId === "string" ? new _int["default"](this._curUserId) : this._curUserId;

    /** @type  {Array.<MMChatMessag>} messagesObjs */
    this.comment.fetchChatlog(function (messagesObjs) {
      if (self.parent.needZoom2Show()) {
        self._parseScaleAndPos(messagesObjs);
      }
      self.renderMessageItems(messagesObjs);
    });
    Dispatcher.on(MDEvents.NEW_MESSAGE, this._newMessageHandler, this);
  },
  showMenu: function showMenu() {
    this.menu = new _MDMenuView["default"]({});
    this.addSubView(this.menu);
  },
  _parseScaleAndPos: function _parseScaleAndPos(messageObjs) {
    var _this3 = this;
    if (messageObjs && messageObjs.length) {
      var msg = messageObjs[0];
      var messageBody = JSON.parse(msg.m_message);
      var scale = messageBody.curScale;
      var editor = this.editorViewCtl.getCurEditor();
      editor.changeScale(scale, function () {
        var lgRect = _this3.comment.getExpandRect();
        editor.scrollToShowLgRct(lgRect, function () {
          _this3.parent.updatePosition();
        });
      });
    }
  },
  _newMessageHandler: function _newMessageHandler(payload) {
    var commentId = payload.comment.getId().toString();
    var curCommentId = this.comment.getId().toString();
    var self = this;
    var message = payload.message;
    var messageBody = null;
    var senderId = message.m_userid.toDecString();
    if (commentId != curCommentId) {
      return;
    }
    try {
      messageBody = JSON.parse(message.m_message);
      var msgType = messageBody["Type"];
      if (msgType == "File" && senderId == app.currentUser.getUserId()) {
        return;
      }
    } catch (e) {
      return null;
    }
    self._createMessageItem(message, false, true);
    this.scrollToBottom();
  },
  scrollToBottom: function scrollToBottom() {
    this.$msgListContent.stop().animate({
      scrollTop: this.$msgList.height()
    });
  },
  /**
   * clears the current messages and filles the screen with messages.
   * will be used, when the list for a new comment is displayed.
   */
  renderMessageItems: function renderMessageItems(messagesObjs) {
    var self = this;
    _MDAudioPlayer["default"].off();
    if (!messagesObjs || !messagesObjs.length) {
      this.$el.append(this.emptyPlaceholder);
    } else {
      _.each(messagesObjs, function (messageObj, index) {
        var first = index == 0;
        self._createMessageItem(messageObj, first, false);
      });
    }
  },
  _createMessageItem: function _createMessageItem(messageObj, first, animateShow) {
    var messageDisplay = null;
    var username = messageObj.m_username;
    var userId = messageObj.m_userid.toDecString();
    var message;
    try {
      message = JSON.parse(messageObj.m_message);
    } catch (e) {
      return null;
    }
    var visibleScope = message["visibleScope"];

    // 那些不应该看到的（非企业版，或者非企业内人员不嫩看到），不显示在界面上
    if (visibleScope && visibleScope != _MMObject["default"].SCOPE.IN_EVAL && (!app.isEpVersion() || app.currentUser.isEnterpriseGuest() || !_MDPcMobileEditorCommonFun["default"].currentFileBelongsToCurUserEnterprise())) {
      return;
    }
    var messageBody = message["Body"];
    var originTime = new Date(parseInt(messageObj.m_time.toString(), 10));
    var time = originTime.toRelativeTimeDOMObj();
    var avatarURL = app.getAvatarImageURL(userId);
    var tempId = messageObj["tempId"];
    time = time.html();
    var messageId = messageObj.getId() && messageObj.getId().toDecString();
    var itemView = new MDCommentMessageItemView({
      type: "chat",
      comment: this.comment,
      userId: userId,
      first: first,
      username: username,
      time: time,
      originTime: originTime,
      avatarURL: avatarURL,
      tempId: tempId,
      message: message,
      messageId: messageId
    });

    // if (msgType === 'Audio') {
    //   var audioFile = message['Url'];
    //   var strId = this.comment ? this.comment.getBoard().getStringId() : "";
    //   // does not work for discusspanel now

    //   messageDisplay = MDAudioPlayer.getAudioPlayer(audioFile, message['Body'], strId);

    //   itemView.$('.panelmessageText').append(messageDisplay);

    // } else {
    //   if (msgType === 'Text') {

    //     messageDisplay = _.escape(message['Body']).replace(/\n/g, "<br>");
    //     messageDisplay = linkjs.do(messageDisplay);
    //     messageDisplay = $('<span class="chatmessage-span">' + messageDisplay + '</span>');
    //     itemView.$('.panelmessageText').append(messageDisplay);
    //     if (tempId) {
    //       itemView.$('.panelmessageText').append('<span class="sendEcho">发送中...<span>'+
    //                     '<span class="errorEcho">发送失败<span>');
    //       var _timeout = setBabelTimeout(function(){
    //         itemView.$('.panelmessageText').addClass('sending');
    //       }, 1000);

    //     };

    //   } else if (msgType === 'Mark') {

    //     messageDisplay = MMSketchCommentController.getSketchHTML(message);
    //     itemView.$('.panelmessageText').append(messageDisplay);
    //   } else if (msgType == 'File') {
    //     messageBody = JSON.parse(messageBody);
    //     var transferItemView = new MDTransferFileItemView({
    //       fileName: messageBody['fileName'],
    //       fileSize: messageBody['fileSize'],
    //       fileRefId: messageBody['fileRefId'],
    //       uploadingMode: false
    //     });

    //     itemView.addSubView(transferItemView, function(subViewEl) {
    //       itemView.$('.panelmessageText').append(subViewEl)
    //     });

    //   }
    // }

    // if (visibleScope) {
    //   itemView.$('.panelmessageText').addClass('msgProtected');
    // };

    // if (first) {
    //   itemView.$el.addClass('firstComment');
    // }

    // if (app.currentUser.getUserId() == messageObj.m_userid.toString() && !first) {
    //   itemView.$el.addClass('right-mode').removeClass('left-mode');
    // }

    this.addSubView(itemView, this.$msgList[0]);
    if (animateShow) {
      itemView.setAnimationShow();
    }
  },
  /**
   * @public
   * @param {MDTransferFileItemView} transferItemView - 上传文件视图
   */
  appendTransformFileItem: function appendTransformFileItem(transferItemView) {
    var self = this;
    var originTime = new Date();
    var itemView = new MDCommentMessageItemView({
      type: "transfer-file",
      username: app.currentUser.getUserName(),
      time: BabelStr.str(315),
      avatarURL: app.currentUser.getAvatarImageURL(80),
      transferItemView: transferItemView,
      comment: this.comment,
      originTime: originTime
    });
    itemView.$el.addClass("right-mode").removeClass("left-mode");
    this.addSubView(itemView, this.$msgList[0]);
    itemView.constructFileMsgElement(transferItemView);

    // var userId = app.currentUser.getUserId();
    // var userName = app.currentUser.getUserName();
    // var msg_ = JSON.stringify({
    //   'Type': 'File',
    //   'Body': {},
    //   'visibleScope': 0,
    //   'atIds': []
    // });
    // var messageModel = new MMChatMessage(0, userId, 0, new Date().getTime(), userName, msg_, this.comment.getId());

    // transferItemView.setOnAbort(function() {
    //   itemView.removeFromSuperView();
    // });

    // transferItemView.setOnFail(function() {
    //   MDSnackbarView.show('文件上传失败');
    // });

    // itemView.addSubView(transferItemView, function(subViewEl) {
    //   itemView.$('.panelmessageText').append(subViewEl)
    // });

    this.scrollToBottom();
  },
  viewDidRendered: function viewDidRendered() {
    _MMViewBase["default"].prototype.viewDidRendered.call(this);
    this.$msgListContent.prop({
      scrollTop: this.$msgList.height()
    });
  }
});
var _default = exports["default"] = MDPanelMessageListView;

},{"1081":1081,"1097":1097,"1184":1184,"1417":1417,"1437":1437,"1454":1454,"1461":1461,"1463":1463,"1466":1466,"1478":1478,"22":22,"270":270,"271":271,"313":313,"347":347,"5":5,"51":51,"53":53,"72":72,"727":727,"807":807,"820":820,"885":885,"950":950}],727:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1498);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _utils = _interopRequireDefault(require(108));
var _MDLocalFileCollector = _interopRequireDefault(require(330));
var _MMViewBase2 = _interopRequireDefault(require(22));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MMFileIconMaker = _interopRequireDefault(require(296));
var _MDImageShower = _interopRequireDefault(require(719));
var _MDAlertView = _interopRequireDefault(require(32));
var _MMFileInfo = _interopRequireDefault(require(297));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 *  transfer file view
 *  Created by jichao
 *  2017/4/13
 */
var MDTransferFileItemView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MDTransferFileItemView, _MMViewBase);
  function MDTransferFileItemView() {
    (0, _classCallCheck2["default"])(this, MDTransferFileItemView);
    return _callSuper(this, MDTransferFileItemView, arguments);
  }
  (0, _createClass2["default"])(MDTransferFileItemView, [{
    key: "tagName",
    value: function tagName() {
      return "div";
    }
  }, {
    key: "tmpl",
    value: function tmpl() {
      return "<div class = \"file-upload-contain\">\n              <div class = \"file-content flex-align middle\">\n                <div class = \"file-icon\"></div>\n                <div class = \"content\">\n                  <div class = \"name\"><%=fileName%></div>\n                  <div class = \"size\"><%=fileSize%></div>\n                </div>\n              </div>\n              <%if(uploadingMode){%>\n              <div class=\"flex-align around middle\">\n                <div class = \"progress-bar\">\n                  <div class = \"progress progress-bar-striped \"></div>\n                </div>\n                <div class=\"speed\"><span class=\"percent\">0%</span></div>\n              </div>\n              <%}%>\n              <div class = \"ope\">\n                <%if(uploadingMode){%>\n                <div class = \"icon close ic-close-small \" data-tooltip=\"<%=BabelStr.str(155)%>\" data-tooltip-dir=\"top\"></div>\n                <%}%>\n                <div class = \"icon download\"  data-tooltip=\"<%=BabelStr.str(29)%>\" data-tooltip-dir=\"top\"></div>\n              </div>\n            </div>";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDTransferFileItemView.prototype), "className", this).call(this);
      return "".concat(superCls, " file-upload");
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDTransferFileItemView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        uploadingMode: false,
        fileId: null,
        onAbort: _.noop,
        onUploadFail: _.noop,
        fileName: "",
        fileSize: ""
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDTransferFileItemView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .close": this._abortUploadingFile,
        "click .download": this._downloadClickHandle,
        "click .file-content": this.showImage,
        "dblclick .file-upload-contain": this.stopPropagation
      });
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDTransferFileItemView.prototype), "initialize", this).call(this, opt);
      this.$progress = this.$(".progress");
      if (!this.uploadingMode) {
        this.$(".download").show();
      }
      _MMFileIconMaker["default"].setTypeIconForFileName(this.fileName, this.$(".file-icon"));
      var options = _.extend({
        type: 1
      }, opt);
      var file = new _MMFileInfo["default"](options);
      // file.setIconForDiv(this.$('.file-icon'))

      if (this.isImageName(this.fileName)) {
        this.$(".file-content").css("cursor", "pointer");
      }
    }
  }, {
    key: "render",
    value: function render() {
      var data = {
        fileName: _.escape(this.fileName),
        fileSize: _utils["default"].convertSpace(this.fileSize),
        username: app.currentUser.getUserName(),
        avatar: app.currentUser.getAvatarImageURL(80),
        uploadingMode: this.uploadingMode
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDTransferFileItemView.prototype), "render", this).call(this, data);
    }
  }, {
    key: "setUploadComplete",
    value: function setUploadComplete(fileRefId, callback) {
      this.fileRefId = fileRefId;
      this.$(".progress-bar").remove();
      this.$(".ope .close").remove();
      this.$(".speed").remove();
      this.$(".download").show();
      _.isFunction(callback) && callback();
    }
  }, {
    key: "stopPropagation",
    value: function stopPropagation($e) {
      $e.stopPropagation();
      return;
    }
  }, {
    key: "_abortUploadingFile",
    value: function _abortUploadingFile() {
      if (this.uploader) {
        this.uploader.abort();
        this.onAbort();
      }
    }
  }, {
    key: "_downloadClickHandle",
    value: function _downloadClickHandle() {
      var _this = this;
      this._checkAnonymouse(function () {
        getTransferDownloadUrl(_this.inDepConversation, _this.fileRefId, function (downloadUrl, code, msg) {
          if (!downloadUrl) {
            var _msg = BabelStr.str(3299);
            if (code == "10006") {
              _msg = BabelStr.str(5542);
            }
            var alert = new _MDAlertView["default"]();
            alert.show({
              title: BabelStr.str(170),
              message: _msg,
              autoClose: true,
              hideCloseBtn: true,
              buttons: [{
                label: BabelStr.str(3096),
                onClick: function onClick() {}
              }]
            });
          } else {
            var $iframe = $("#file-downloader");
            $iframe = $("<iframe>");
            $iframe.attr("id", "file-downloader").appendTo("body");
            $iframe.width(0).height(0).css("display", "none");
            $iframe.attr("src", downloadUrl);
            _.delay(function () {
              $iframe.remove();
            }, 1000);
          }
        });
      });
    }

    /**
     * [setUploader description]
     * @param {[type]} uploader [description]
     */
  }, {
    key: "setUploader",
    value: function setUploader(uploader) {
      var _this2 = this;
      this.uploader = uploader;
      uploader.view = this;
      var jqXhr = uploader.submit();
      jqXhr.fail(function () {
        _.isFunction(_this2.onUploadFail) && _this2.onUploadFail();
      });
    }
  }, {
    key: "setOnAbort",
    value: function setOnAbort(onAbort) {
      this.onAbort = onAbort;
    }
  }, {
    key: "setOnFail",
    value: function setOnFail(onFail) {
      this.onUploadFail = onFail;
    }
  }, {
    key: "setProgress",
    value: function setProgress(progress) {
      this.$(".percent").html(progress + "%");
      this.$progress.width(progress + "%");
    }
  }, {
    key: "showImage",
    value: function showImage() {
      var _this3 = this;
      this._checkAnonymouse(function () {
        var isImg = _this3.isImageName(_this3.fileName);
        if (isImg) {
          var imgShower = new _MDImageShower["default"]();
          getTransferDownloadUrl(_this3.inDepConversation, _this3.fileRefId, function (downloadUrl, code, msg) {
            if (code != 0) {
              msg = BabelStr.str(3299);
              if (code == "10006") {
                msg = BabelStr.str(5542);
              }
              var alert = new _MDAlertView["default"]();
              alert.show({
                title: BabelStr.str(170),
                message: msg,
                autoClose: true,
                hideCloseBtn: true,
                buttons: [{
                  label: BabelStr.str(3096),
                  onClick: function onClick() {}
                }]
              });
              imgShower.removeFromSuperView();
            } else {
              imgShower.displayImg(downloadUrl, code);
            }
          });
        }
      });
    }
  }, {
    key: "_checkAnonymouse",
    value: function _checkAnonymouse(cb) {
      if (app.currentUser.isAnonymous()) {
        var alert = new _MDAlertView["default"]();
        var text = BabelStr.str(5052);
        alert.show({
          width: 300,
          title: BabelStr.str(170),
          message: text,
          buttons: [{
            label: BabelStr.str(3096),
            type: "done",
            onClick: function onClick() {}
          }]
        });
      } else {
        cb();
      }
    }
  }, {
    key: "isImageName",
    value: function isImageName(name) {
      name = name.trim();
      var ext = name.split(".").pop();
      var imgExt = ["jpg", "jpeg", "png", "bmp", "ico", "gif"];
      return MMCommonFun.isSpecialExt(ext, imgExt);
    }
  }]);
  return MDTransferFileItemView;
}(_MMViewBase2["default"]);
function getTransferDownloadUrl(inDepConversation, fileId, callback) {
  $.ajax({
    url: "/netdrive/downloadTransferFile.do",
    method: "post",
    data: {
      fileRefId: fileId,
      inDepConversation: inDepConversation ? 1 : 0
    },
    success: function success(data) {
      var downloadUrl = data["url"];
      callback(downloadUrl, data["code"], data["msg"]);
    }
  });
}

},{"108":108,"1104":1104,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"1498":1498,"22":22,"296":296,"297":297,"32":32,"330":330,"719":719}],719:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1423);
require(1411);
require(1530);
require(1505);
require(1506);
require(1507);
require(1508);
require(1510);
require(1509);
require(1512);
require(1513);
require(1514);
require(1516);
require(1517);
require(1518);
require(1519);
require(1521);
require(1520);
require(1522);
require(1523);
require(1524);
require(1525);
require(1526);
require(1527);
require(1528);
require(1529);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MMBasicData = _interopRequireDefault(require(811));
var _MDAlertView = _interopRequireDefault(require(32));
// MDImageShower.js
// jiang
// 2017-4-20
var MDImageShower = exports["default"] = /*#__PURE__*/function () {
  function MDImageShower() {
    (0, _classCallCheck2["default"])(this, MDImageShower);
    this.constructPanel();
  }
  (0, _createClass2["default"])(MDImageShower, [{
    key: "constructPanel",
    value: function constructPanel() {
      var _this = this;
      this.$el = $('<div class="img-shower-mask">' + '<div class="img-panel">' + '<div class="flex-align around middle progress-contain">' + '<div class = "progress-bar">' + '<div class = "progress progress-noanimate progress-bar-striped "></div>' + '</div>' + '<div class="speed"><span class="percent">0%</span></div>' + '</div>' + '</div>' + '<div class="icon marker-close shower-close"></div>' + '<div class = "size-contain"></div>' + '</div>');

      // $('.app-root').append(this.$el);
      $('body').append(this.$el);
      this.$el.find('.shower-close').on('click', function () {
        _this.removeFromSuperView();
      });
      var zIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
      this.$el.css('z-index', zIndex);
    }
  }, {
    key: "removeFromSuperView",
    value: function removeFromSuperView() {
      this.$el.find('.shower-close').off('click');
      $(window).off("resize.transImg");
      this.$el.remove();
    }
  }, {
    key: "displayImg",
    value: function displayImg(imgUrl) {
      var _this2 = this;
      this.getImage(imgUrl, function (dataUrl) {
        var img = new Image();
        img.src = dataUrl;
        img.onload = function (e) {
          var w = img.width;
          var h = img.height;
          _this2.renderSize(img);
          _this2.renderImg(img);
          _this2.bindResize(img, w, h);
        };
      });
    }
  }, {
    key: "displayImgData",
    value: function displayImgData(dataUrl) {
      var _this3 = this;
      // this.getImage(imgUrl, (dataUrl) => {
      var img = new Image();
      img.src = dataUrl;
      img.onload = function (e) {
        var w = img.width;
        var h = img.height;
        _this3.renderSize(img);
        _this3.renderImg(img);
        _this3.bindResize(img, w, h);
      };
      // });
    }
  }, {
    key: "getImage",
    value: function getImage(imgUrl, callback) {
      var _this4 = this;
      var self = this;
      _MMNetDiskDataController["default"].downLoadFileData(imgUrl, function (data) {
        var arr = new Uint8Array(data);

        // Convert the int array to a binary  string
        // We have to use apply() as we are converting an *array*
        // and String.fromCharCode() takes one or more single values, not
        // an array.

        var raw = '';
        var i,
          j,
          subArray,
          chunk = 5000;
        for (i = 0, j = arr.length; i < j; i += chunk) {
          subArray = arr.subarray(i, i + chunk);
          raw += String.fromCharCode.apply(null, subArray);
        }
        // This works!!!
        var b64 = btoa(raw);
        var dataURL = "data:image/jpeg;base64," + b64;
        callback(dataURL);
      }, function () {
        console.error('downLoadFileData failed');
        self.removeFromSuperView();
        var alert = new _MDAlertView["default"]({
          width: 400
        });
        alert.show({
          title: BabelStr.str(170),
          message: BabelStr.str(3299),
          autoClose: true,
          hideCloseBtn: true,
          buttons: [{
            label: BabelStr.str(154),
            onClick: function onClick() {}
          }]
        });
      }, function (percent) {
        _this4.setProgress(Math.round(percent * 100));
      });
    }
  }, {
    key: "renderSize",
    value: function renderSize(img) {
      var str = img.width + ' x ' + img.height + '';
      $(".size-contain").html(str);
    }
  }, {
    key: "renderImg",
    value: function renderImg(img) {
      var $window = $(window);
      var $con = $(".img-panel");
      var imgW = img.width;
      var imgH = img.height;
      var conW = $window.width() - 80;
      var conH = $window.height() - 80;
      var scale = 1.0;
      var imgA = imgW * imgH;
      var conA = conW * conH;
      var maxConA = 1.5 * 1.5 * conA;
      if (imgA > maxConA) {
        scale = Math.sqrt(imgA / maxConA);
        imgW = imgW / scale;
        imgH = imgH / scale;
      }
      img.width = imgW;
      img.height = imgH;
      if (conW > imgW) {
        conW = imgW;
      }
      if (conH > imgH) {
        conH = imgH;
      }
      $con.width(conW + 8);
      $con.height(conH + 8);
      var x = $con.offset().left;
      var y = $con.offset().top;
      $(".shower-close").css({
        "right": x - 37,
        "top": y - 26
      });
      $(".size-contain").css({
        "right": x + 12,
        "top": y + conH - 23
      });
      $(".img-panel").css({
        "display": "block"
      }).html(img);
    }
  }, {
    key: "setProgress",
    value: function setProgress(progress) {
      progress = progress > 100 ? 100 : progress;
      this.$el.find('.progress-noanimate').css('width', progress + "%");
      this.$el.find(".percent").html(progress + "%");
    }
  }, {
    key: "bindResize",
    value: function bindResize(img, w, h) {
      var _this5 = this;
      $(window).on("resize.transImg", function () {
        img.width = w;
        img.height = h;
        _this5.renderImg(img);
      });
    }
  }]);
  return MDImageShower;
}();

},{"1104":1104,"1175":1175,"1179":1179,"1184":1184,"1411":1411,"1417":1417,"1423":1423,"1454":1454,"1463":1463,"1505":1505,"1506":1506,"1507":1507,"1508":1508,"1509":1509,"1510":1510,"1512":1512,"1513":1513,"1514":1514,"1516":1516,"1517":1517,"1518":1518,"1519":1519,"1520":1520,"1521":1521,"1522":1522,"1523":1523,"1524":1524,"1525":1525,"1526":1526,"1527":1527,"1528":1528,"1529":1529,"1530":1530,"32":32,"811":811}],330:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1429);
require(1424);
require(1426);
require(1439);
require(1421);
require(1541);
var _MDEvents = _interopRequireDefault(require(325));
var _MDfileUploadList = _interopRequireDefault(require(345));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MDAlertView = _interopRequireDefault(require(32));
/*jslint nomen: true, vars: true, plusplus:true, browser:true */
/*global console, app, goog, $, _, Backbone,  MDLocalFileCollector,MDEvents,app,SUPPORTED_FILETYPE,MouseEvent,MDFileUploader */

/**
 * the MDLocalFileCollector is responsible to catch files from the user, wether they are droped or by the FileFinder
 * it provides a method. openFileFinderWindow to open the fileFinder
 */
var MDLocalFileCollector = {
  $finderInput: null,
  _init: function _init() {
    "use strict";

    var that = MDLocalFileCollector;
    var $finderInput = MDLocalFileCollector.createInput();
    MDLocalFileCollector.$finderInput = $finderInput;
    $finderInput.change(function (e) {
      var _this = this;
      console.log(e);
      var files = this.files;
      var length = files.length;
      if (files) {
        if (app.isInClient() && app.getTransferController()) {
          MMEnterpriseController.isIpAllowUpload(app.currentFolder.getFileId(), function () {
            if (_this.hasAttribute("directory")) {
              var file = files[0];
              var relativePath = file.webkitRelativePath;
              var relativePathArr = relativePath.split("/");
              var path = file.path;
              var pathArr = path.split("\\");
              var delimiter = "\\";
              if (pathArr.length < 2) {
                pathArr = path.split("/");
                delimiter = "/";
              }
              var rootPathArr = pathArr.slice(0, pathArr.length - (relativePathArr.length - 1));
              var rootPath = rootPathArr.join(delimiter);
              _MDfileUploadList["default"].appendUploadTasks([rootPath], {});
            } else {
              _MDfileUploadList["default"].forClientUpload(files, app.currentFolder.getFileId());
            }
          }, function (err) {
            _MDAlertView["default"].showStandardPrompt({
              message: err.msg
            });
          });
          return;
        } else {
          if (this.hasAttribute("directory")) {
            _MDfileUploadList["default"].pushDir(files);
          } else {
            var needCheck = false;
            if (files.length < 10) {
              needCheck = true;
            }
            var uploadId = _MDfileUploadList["default"].getUploadSingletonId();
            $.each(files, function (index, file) {
              // MDfileUploadList.isFolder(file, function (isFile) {
              //   if (isFile) {
              file.needCheckFileName = needCheck;
              // }
              _MDfileUploadList["default"].pushFile(file, undefined, undefined, undefined, {
                uploadId: uploadId
              });
              // });
            });
          }
        }
      }
    });
  },
  createInput: function createInput(uploadFolder) {
    var $element = $('<input style="position:absolute; touch-action: none;" id="_upload-file-dialog">');
    $('body').append($element);
    $element.attr({
      'type': 'file',
      'name': 'file',
      'multiple': 'true'
    });
    //$element.attr('accept', 'image/*,' + SUPPORTED_FILETYPE);  // now we want to accept all files
    $element.css({
      'display': 'none',
      'opacity': 0
    });
    if (uploadFolder) {
      $.each(['webkitdirectory', 'mozdirectory', 'directory'], function () {
        $element.attr(this, "");
      });
    }
    return $element;
  },
  _removeTmpInput: function _removeTmpInput() {
    if (MDLocalFileCollector._$curInput) {
      MDLocalFileCollector._$curInput.remove();
      MDLocalFileCollector._$curInput = null;
    }
  },
  _$curInput: null,
  /**
   * open a fileFinder, by default the file will be pushed to the uploadList
   * is a callback provided, this will receive the files
   */
  openFileFinderWindow: function openFileFinderWindow(callback, uploadFolder) {
    MDLocalFileCollector._removeTmpInput();
    var maxFileSize = MDLocalFileCollector._maxFileSize;
    if (callback) {
      var $input = MDLocalFileCollector.createInput();
      $input.on('change', function () {
        var files = this.files;
        var fileArr = [];
        $.each(files, function (index, file) {
          fileArr.push(file);
        });
        if ($.isFunction(callback)) {
          callback(fileArr);
        }
        $input.remove();
      });
      MDLocalFileCollector._$curInput = $input;
      $input.click();
    } else {
      $.each(['webkitdirectory', 'mozdirectory', 'directory'], function () {
        if (uploadFolder) {
          MDLocalFileCollector.$finderInput.attr(this, "");
        } else {
          MDLocalFileCollector.$finderInput.removeAttr(this);
        }
      });
      $("body").click();
      MDLocalFileCollector.$finderInput.val('');

      // setTimeout(()=>{
      MDLocalFileCollector.$finderInput.click();
      // })
    }
  },
  openFileFinderWithCondition: function openFileFinderWithCondition(params) {
    MDLocalFileCollector._removeTmpInput();
    var $input = MDLocalFileCollector.createInput();
    $input.removeAttr('multiple');
    var exts = params.exts;
    var result = _.map(exts, function (ext) {
      return ".".concat(ext);
    }).join(",");
    $input.attr("accept", result);
    $input.change(function () {
      var name = this.files[0].name || "";
      var curExt = _MMCommonFun["default"].getFileExtension1(name).toLowerCase();
      if (_.indexOf(exts, curExt) > -1 && this.files[0].size < params.size) {
        // this.files[0].needCheckFileName = true
        _MDfileUploadList["default"].pushFile(this.files[0], null, undefined, undefined, {
          len: 1
        });
        $input.remove();
      } else {
        new _MDAlertView["default"]().show({
          title: BabelStr.str(3582),
          message: params.errMsg,
          buttons: [{
            label: BabelStr.str(154),
            autoClose: true
          }]
        });
      }
    });
    MDLocalFileCollector._$curInput = $input;
    // $input.click();
    setTimeout(function () {
      // $("#_upload-file-dialog").trigger('click');
      $input.click();
    }, 300);
  },
  openExcelFileFinder: function openExcelFileFinder(fileInfo) {
    MDLocalFileCollector._removeTmpInput();
    var $input = MDLocalFileCollector.createInput();
    $input.removeAttr('multiple');
    $input.attr("accept", ".xls,.xlsx,.csv");
    $input.change(function () {
      var name = this.files[0].name || "";
      var curExt = _MMCommonFun["default"].getFileExtension1(name).toLowerCase();
      if ((curExt == 'xls' || curExt == 'xlsx' || curExt == 'csv') && this.files[0].size < 10 * 1024 * 1024) {
        // this.files[0].needCheckFileName = true
        _MDfileUploadList["default"].pushFile(this.files[0], null, undefined, undefined, {
          len: 1
        });
        $input.remove();
      } else {
        new _MDAlertView["default"]().show({
          title: BabelStr.str(3582),
          message: BabelStr.str(26040),
          buttons: [{
            label: BabelStr.str(154),
            autoClose: true
          }]
        });
      }
    });
    MDLocalFileCollector._$curInput = $input;
    // $input.click();
    setTimeout(function () {
      // $("#_upload-file-dialog").trigger('click');
      $input.click();
    }, 300);
  },
  openNewVersionFileFinder: function openNewVersionFileFinder(fileInfo) {
    MDLocalFileCollector._removeTmpInput();
    var $input = MDLocalFileCollector.createInput();
    $input.removeAttr('multiple');
    $input.attr("accept", "." + fileInfo.getFileExtension());
    $input.change(function () {
      var name = this.files[0].name || "";
      if (_MMCommonFun["default"].getFileExtension1(name).toLowerCase() == fileInfo.getFileExtension().toLowerCase()) {
        this.files[0].needCheckFileName = true;
        _MDfileUploadList["default"].pushFile(this.files[0], fileInfo, undefined, undefined, {
          len: 1
        });
        $input.remove();
      } else {
        new _MDAlertView["default"]().show({
          title: BabelStr.str(3582),
          message: BabelStr.str(5036),
          buttons: [{
            label: BabelStr.str(154),
            autoClose: true
          }]
        });
      }
    });
    MDLocalFileCollector._$curInput = $input;
    // $input.click();
    setTimeout(function () {
      // $("#_upload-file-dialog").trigger('click');
      $input.click();
    }, 300);
  }
};
$(function () {
  "use strict";

  MDLocalFileCollector._init();
});
var _default = exports["default"] = MDLocalFileCollector;

},{"1184":1184,"1421":1421,"1424":1424,"1426":1426,"1429":1429,"1439":1439,"1454":1454,"1541":1541,"32":32,"325":325,"345":345,"812":812}],345:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1421);
require(1439);
require(1463);
require(1471);
require(1424);
require(1417);
require(1418);
require(1537);
require(1423);
require(1480);
require(1487);
require(1538);
require(1419);
require(1437);
require(1412);
var _MDAlertView = _interopRequireDefault(require(32));
var _MMModelBase = _interopRequireDefault(require(21));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDLocalFileCollector = _interopRequireDefault(require(330));
var _MDUploadFile = _interopRequireDefault(require(341));
var _MDUpdatePromptWindowView = _interopRequireDefault(require(525));
var _MDEvents = _interopRequireDefault(require(325));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _ErrorCode = _interopRequireDefault(require(1087));
var _MDLoadMaskView = _interopRequireDefault(require(49));
var _MDUploadSameNameWinView = _interopRequireDefault(require(343));
var _MDUploadSameNameForFolderWinView = _interopRequireDefault(require(342));
/*jslint nomen: true, vars: true, plusplus:true, browser:true */
/*global console, app, goog, $, _, MDfileUploadList, MDfileUploadQueue,MMNetDiskDataController,MDLocalFileCollector, MDUploadFile, MDEvents, MDFileUploader, FILETYPE_INDEX, SUPPORTED_FILETYPE, MMModelBase,MMFileInfo,Backbone,MMCommonFun */

/**
 * @creator Tobias Nickel
 * @created 27.08.2015
 */

var MDfileUploadList = {
  list: new Backbone.Collection(),
  isQueueActive: true,
  nextUploadFile: null,
  currentUploadCount: 0,
  MAX_CONCURRENT_UPLOADS: 3,
  MAX_UPLOADS_FOR_FOLDER: 500,
  alert: null,
  /**
   * a user want to upload, a new version
   * @param nativeFile {native File-Object}
   * @param {FileInfo} [fileInfo]  the file, self we upload a new version to
   */
  pushFile: function pushFile(nativeFile, /* optional */fileInfo, parentFolder, callback, params) {
    var _this = this;
    if (!params) {
      params = {};
    }

    // let len = params.len;
    // let inDir = params.inDir;
    var uploadId = params.uploadId;
    var self = this;
    // if(nativeFile.name[0] == '.' ) {
    //   // MDAlertView.showAlert(BabelStr.str(6126))
    //   return
    // }
    if (nativeFile.name.indexOf("~$") === 0 || nativeFile.name == ".www.babel.cc") {
      // MDAlertView.showAlert(BabelStr.str(6126))
      _MDLoadMaskView["default"].remove();
      return;
    }
    var arr = nativeFile.name.split(".");
    // if(arr[1] == 'tmp' || arr[1] == 'swp' || arr[1] == 'lock') {
    //   return
    // }

    if (_.isFunction(fileInfo)) {
      callback = fileInfo;
      fileInfo = null;
    } else if (_.isFunction(parentFolder)) {
      callback = parentFolder;
      parentFolder = null;
    }
    var param = {
      forbidAutoRename: 1,
      sameNameAsNewVersion: 0
    };
    if (!fileInfo && app.currentFolder && app.currentFolder.canUpload()) {
      // 判断是否相同目录下有相同的文件名
      // var timeoutShow = setTimeout(() => {
      //   timeoutShow = null;
      _MDLoadMaskView["default"].show(undefined, {
        // bodyMsg: BabelStr.str(20160)+'...',
        noClose: true
      });
      // }, 3000);
      var checkCallback = function checkCallback(sameNameFileInfo) {
        _MDLoadMaskView["default"].remove();
        // if (timeoutShow) {
        //   clearTimeout(timeoutShow);
        //   timeoutShow = null;
        // }
        // setTimeout(() => {
        //   MDLoadMaskView.remove();
        // });

        var currentUploadType = MDfileUploadList.uploadSingletonObj[uploadId];
        if (sameNameFileInfo) {
          if (viewManager && viewManager.get("curFileTableView") && (!parentFolder || parentFolder.getFileId() == app.currentFolder.getFileId())) {
            var fileCollection = viewManager.get("curFileTableView").getDataCollection();
            fileCollection.each(function (fileInfo) {
              if (fileInfo.getFileId() == sameNameFileInfo.getFileId()) {
                sameNameFileInfo = fileInfo;
                // return false;
              }
              // return true;
            });
          }
          if (!_this.uploadPromise) {
            _this.uploadPromise = new Promise(function (resolve) {
              resolve();
            });
          }
          _this.uploadPromise = _this.uploadPromise.then(function () {
            return new Promise(function (resolve, reject) {
              if (MDfileUploadList.uploadSingletonObj[uploadId]) {
                var _currentUploadType = MDfileUploadList.uploadSingletonObj[uploadId];
                if (_currentUploadType == 2) {
                  param.forbidAutoRename = 0;
                  MDfileUploadList._pushFile(nativeFile, fileInfo, parentFolder, param, callback);
                } else if (_currentUploadType == 3) {
                  // fileInfo = sameNameFileInfo;
                  param.sameNameAsNewVersion = 1;
                  parentFolder = null;
                  MDfileUploadList._pushFile(nativeFile, fileInfo, parentFolder, param, callback);
                }
                resolve();
              } else {
                var win = new _MDUploadSameNameWinView["default"]({
                  canUploadVersion: sameNameFileInfo.canUploadVersion(),
                  msgStr: BabelStr.str(450, {
                    // 当前文件夹已存在名称为 {-fileName-} 的文件，你是要上传一个新版本么?
                    fileName: nativeFile.name
                  }),
                  buttonCallback: function buttonCallback(type, nextSame) {
                    if (type == 2) {
                      param.forbidAutoRename = 0;
                      MDfileUploadList._pushFile(nativeFile, fileInfo, parentFolder, param, callback);
                    } else if (type == 3) {
                      fileInfo = sameNameFileInfo;
                      parentFolder = null;
                      param.sameNameAsNewVersion = 1;
                      MDfileUploadList._pushFile(nativeFile, fileInfo, parentFolder, param, callback);
                    } else {}
                    if (nextSame) {
                      MDfileUploadList.uploadSingletonObj[uploadId] = type;
                    }
                    MDfileUploadList.hasSameNameInFolderCallServer();
                  },
                  onClose: function onClose() {
                    resolve();
                  }
                });
                win.show();
              }
            });
          });
        } else if (currentUploadType == 3) {
          param.sameNameAsNewVersion = 1;
          parentFolder = null;
          MDfileUploadList._pushFile(nativeFile, fileInfo, parentFolder, param, callback);
          MDfileUploadList.hasSameNameInFolderCallServer();
        } else {
          param.forbidAutoRename = 0;
          MDfileUploadList._pushFile(nativeFile, fileInfo, parentFolder, param, callback);
          MDfileUploadList.hasSameNameInFolderCallServer();
        }
      };
      if (nativeFile.needCheckFileName) {
        MDfileUploadList.hasSameNameInFolder({
          folderId: app.currentFolder.getFileId(),
          fileName: nativeFile.name,
          uploadId: uploadId
        }, checkCallback, function (err) {
          // if (timeoutShow) {
          //   clearTimeout(timeoutShow);
          //   timeoutShow = null;
          // }
          _MDLoadMaskView["default"].remove();
          if (!self.errAlert) {
            self.errAlert = new _MDAlertView["default"]();
            self.errAlert.show({
              title: BabelStr.str(170),
              //提示
              message: "<span>" + err.msg + "</span>",
              onClose: function onClose() {
                self.errAlert = undefined;
              }
            });
          }
          MDfileUploadList.hasSameNameInFolderCallServer();
        });
      } else {
        checkCallback();
      }
    } else {
      MDfileUploadList._pushFile(nativeFile, fileInfo, parentFolder, param, callback);
    }
  },
  _pushFile: function _pushFile(nativeFile, fileInfo, parentFolder, param, callback) {
    if (_.isFunction(param)) {
      callback = param;
      param = null;
    }
    var limitsObj;
    try {
      limitsObj = app.pathRouter.getLimitsInPath();
    } catch (e) {
      limitsObj = null;
    }
    var filter = MMCommonFun.testFileName(nativeFile.name);
    var limits = limitsObj && limitsObj.limits;
    var name = limitsObj && limitsObj.name;
    var file = limitsObj && limitsObj.file;
    if (_.isArray(limits) && limits[0]) {
      _.each(limits, function (item) {
        item.stringLimit = item.stringLimit.toLocaleLowerCase();
      });
    }
    var limitsResult = MMCommonFun.validateFileType(nativeFile.name, limits);
    var message = "";
    if (!limitsResult) {
      var type = limits[0]["type"];
      var str = _.pluck(limits, "stringLimit").join(",");
      if (type == 1) {
        message = BabelStr.str(2873, {
          str: str,
          fileName: nativeFile.name,
          name: file.getFileName()
        });
      } else if (type == 2) {
        message = BabelStr.str(2874, {
          str: str,
          fileName: nativeFile.name,
          name: file.getFileName()
        });
      }
    } else if (filter.length > 0) {
      message = BabelStr.str(2872, {
        str: filter.join("，"),
        name: nativeFile.name
      });
      message = _.escape(message);
    }
    if (filter.length > 0 || !limitsResult) {
      this.showAlert(message);
      callback && callback();
      return;
    }
    if (_.isFunction(fileInfo)) {
      callback = fileInfo;
      fileInfo = null;
    } else if (_.isFunction(parentFolder)) {
      callback = parentFolder;
      parentFolder = null;
    }
    var self = MDfileUploadList;
    var allPassed = true;
    MDfileUploadList.validateUpload(nativeFile, fileInfo, function (passed) {
      if (!passed) {
        allPassed = false;
        var msg = BabelStr.str(454, {
          // ('提示：暂不支持单个超过'+MDfileUploadList._maxFileSizeStr+'的文件上传');
          size: MDfileUploadList._maxFileSizeStr
        });
        if (!allPassed) {
          _MDSnackbarView["default"].show(msg);
        }
        return;
      }
      var parentId = null;
      var newVersion = false;
      if (parentFolder) {
        parentId = parentFolder.get("fileId");
        newVersion = false;
      } else if (fileInfo) {
        if (fileInfo.isFolder()) {
          // newFile
          parentId = fileInfo.get("fileId");
          newVersion = false;
        } else {
          // new Version
          parentId = fileInfo.get("parentId");
          newVersion = true;
        }
      } else {
        //newFile
        var uploadFolder = app.currentFolder;
        parentId = uploadFolder.get("fileId");
      }
      var newUploadFile = new _MDUploadFile["default"](nativeFile, parentId, fileInfo, parentFolder, param, callback); // use currentDir

      if (newVersion) {
        newUploadFile.set("newVersion", true);
        //new Version
        // newUploadFile.versionCollection = viewManager.get("versionListView").fileVerCollection;
      } else {
        var shareTableView = viewManager.get("sfileListView");
        var curFileTableView = viewManager.get("curFileTableView");
        var msAnonyUploadListView = viewManager.get("msAnonyUploadListView");
        if (shareTableView) {
          newUploadFile.fileInforCollection = shareTableView.getDataCollection();
        } else if (msAnonyUploadListView) {
          newUploadFile.fileInforCollection = msAnonyUploadListView.getDataCollection();
        } else if (curFileTableView) {
          newUploadFile.fileInforCollection = curFileTableView.getDataCollection();
        }
      }
      nativeFile._ID = newUploadFile.get("id");
      self.list.push(newUploadFile);
      self.startUpload();
    });
  },
  startQueue: function startQueue() {
    MDfileUploadList.isQueueActive = true;
    MDfileUploadList.startUpload();
  },
  stopQueue: function stopQueue() {
    MDfileUploadList.isQueueActive = false;
  },
  startUpload: function startUpload() {
    if (!MDfileUploadList.isQueueActive) {
      return;
    }
    MDfileUploadList.uploadNext();
  },
  checkFinished: function checkFinished() {
    var allFinished = false;
    allFinished = MDfileUploadList.list.all(function (file) {
      return !file.notFinish();
    });
    if (allFinished) {
      MDfileUploadList.sendUploadEmails();
      MDfileUploadList.trigger(_MDEvents["default"].UPLOAD_FINISHED);
    }
  },
  uploadNext: function uploadNext() {
    var self = this;
    if (!MDfileUploadList.isQueueActive) {
      return;
    }

    // 如果有超过 10 个文件在等待上传，则需要降速处理，减少服务器负担
    var maxFilesUploading = MDfileUploadList.MAX_CONCURRENT_UPLOADS;
    if (MDfileUploadList.getFileCountNeedUpload() > 10) {
      maxFilesUploading = 1; // ------------------------ 只允许最多一个文件上传
    }
    if (MDfileUploadList.currentUploadCount >= maxFilesUploading) {
      console.log("currentUploadCount --->" + MDfileUploadList.currentUploadCount + ",    currentUploadCount 超过同时上传的文件上限，需等待");
      return;
    }
    console.log(" ****** -------------------> currentUploadCount --->" + MDfileUploadList.currentUploadCount);
    var self = MDfileUploadList;
    var fileUploading = this.getNextFileToUpload();
    if (fileUploading) {
      fileUploading.startUpload(function stop(type) {
        if (type == "versionLimit") {
          self._stopOtherUploadVersion(fileUploading);
        } else if (type == "spaceLimit") {
          self._stopOthers(fileUploading);
        }
        self.uploadNext();
      }, function loadFinished() {
        self.checkFinished();
        if (MDfileUploadList.currentUploadCount < 1) {
          return;
        }
        console.log("***  uploadfinied ", fileUploading);
        MDfileUploadList.currentUploadCount--;
        self.uploadNext();
      }, function onCancel() {
        if (MDfileUploadList.currentUploadCount > 0) {
          MDfileUploadList.currentUploadCount--;
          console.log("###---------> canceled! currentUploadCount -> " + MDfileUploadList.currentUploadCount);
          self.uploadNext();
        }
        self.checkFinished();
      });
      MDfileUploadList.currentUploadCount++;
      fileUploading.on("change:state", function (uploadFile, stateValue, option) {
        if (stateValue == _MDUploadFile["default"].states.abort || stateValue == _MDUploadFile["default"].states.error) {
          MDfileUploadList.currentUploadCount--;
          console.log("###---------> error! currentUploadCount -> " + MDfileUploadList.currentUploadCount);
          self.uploadNext();
        }
      });
      fileUploading.on(_MDEvents["default"].UPLOAD_FINISHED, function () {
        MDfileUploadList.currentUploadCount--;
        console.log("###---------> UPLOAD_FINISHED! currentUploadCount -> " + MDfileUploadList.currentUploadCount);
        self.uploadNext();
      });
    }
  },
  getNextFileToUpload: function getNextFileToUpload() {
    var waitingCount = 0;
    // MDfileUploadList.list.forEach(function(file) {
    //   if (file.uploading()) {
    //     waitingCount++;
    //   };
    // });
    // 不能一次上传太多的文件
    // if (waitingCount < MDfileUploadList.MAX_CONCURRENT_UPLOADS) {
    return MDfileUploadList.list.find({
      state: _MDUploadFile["default"].states.notStarted
    });
    // }
    // return null;
  },
  getFileCountNeedUpload: function getFileCountNeedUpload() {
    var count = 0;
    MDfileUploadList.list.forEach(function (file) {
      if (file.isNotStarted()) {
        count++;
      }
    });
    return;
  },
  _stopOthers: function _stopOthers(fileUploading) {
    MDfileUploadList.list.forEach(function (file) {
      if (file != fileUploading) {
        file.cancelUpload();
      }
    });
  },
  _stopOtherUploadVersion: function _stopOtherUploadVersion(fileUploading) {
    MDfileUploadList.list.forEach(function (file) {
      if (file != fileUploading && !file.get("fileInfo")) {
        // 没有 fileInfo 的，就是上传新版本
        file.cancelUpload();
      }
    });
  },
  getUploadFileById: function getUploadFileById(id) {
    return MDfileUploadList.list.findWhere({
      fileId: id
    });
  },
  removeFromList: function removeFromList(uploadFile) {
    MDfileUploadList.list.remove(uploadFile);
  },
  clearQueue: function clearQueue() {
    MDfileUploadList.currentUploadCount = 0;
    var uploadingFile = MDfileUploadList.list.findWhere({
      state: _MDUploadFile["default"].states.uploading
    });
    MDfileUploadList.list.forEach(function (file) {
      if (file.get("state") == _MDUploadFile["default"].states.uploading) {
        file.abort(true);
      }
    });
    MDfileUploadList.list.reset();
    MDfileUploadList.cancelUpload();
  },
  /**
   * change this method. to check for memory limits, filetypes,...
   */
  validateUpload: function validateUpload(file, fileInfo, callback) {
    var maxFileSize = MDfileUploadList._maxFileSize;
    if (file.size > maxFileSize) {
      var notExtend = BabelStr.str(455) + " "; // 文件大小不得超过
      _MDSnackbarView["default"].show(notExtend + MDfileUploadList._maxFileSizeStr);
      return;
    }
    if (app.currentFolder && app.currentFolder.canUpload() || fileInfo && fileInfo.canUpload() || fileInfo && fileInfo.canUploadVersion()) {
      var passed = true;
      setBabelTimeout(function () {
        callback(passed);
      }, 1);
    }
  },
  sendUploadEmails: function sendUploadEmails() {
    var fileIds = [];
    MDfileUploadList.list.forEach(function (file) {
      if (!file.get("mailSend") && file.uploadSuccessed()) {
        file.set("mailSend", true);
        fileIds.push(file.get("fileId"));
      }
    });
    //todo: send Mail

    if (fileIds.length > 0) {
      _MMNetDiskDataController["default"].sendUploadEmails(fileIds);
    }
  }
};
_.extend(MDfileUploadList, Backbone.Events);
$(window).on("beforeunload", function () {
  if (MDfileUploadList.currentUploadCount > 0) {
    _MDAlertView["default"].showStandardPrompt({
      message: BabelStr.str(456)
    });
    event.preventDefault();
    event.returnValue = ''; // 触发浏览器默认提示
    // return BabelStr.str(456); // '正在向巴别鸟云端网盘上传文件。如果您离开此页面，某些文件可能会无法上传。';
  }
});
MDfileUploadList._maxFileSize = app.currentUser.getMaxUploadFileSize();
MDfileUploadList._maxFileSizeStr = app.currentUser.getMaxUploadFileSizeStr();
MDfileUploadList.isFolder = function (file, callback) {
  var fileReader = new FileReader();
  fileReader.addEventListener("load", function (e) {
    if (fileReader.result) {
      callback(true);
    } else {
      callback(false);
    }
  });
  fileReader.addEventListener("error", function (e) {
    callback(false);
  });
  fileReader.readAsArrayBuffer(file);
};
MDfileUploadList.forClientUpload = function (files, folderId) {
  var len = files.length;
  var paths = new Set();
  var pathMap = {};
  $.each(files, function (index, file) {
    paths.add(file.path);
  });
  // if (len > 10) {
  //   MDfileUploadList.appendUploadTasks(Array.from(paths));
  //   return;
  // }
  this.uploadPromise = new Promise(function (resolve) {
    resolve();
  });
  var currentUploadType;
  var currentUploadFolderType;
  function testFileName(files, index, success) {
    var file = files.item(index);
    index++;
    if (!file) {
      success();
      return;
    }
    MDfileUploadList.isFolder(file, function (isFile) {
      if (isFile) {
        if (currentUploadType == 2) {
          pathMap[file.path] = {
            forceFolderRename: 1
          };
          testFileName(files, index, success);
          return;
        }
      }
      MMEnterpriseController.hasSameNameInFolder({
        folderId: folderId,
        fileName: file.name,
        len: len
      }, function (sameNameFileInfo) {
        if (!sameNameFileInfo) {
          testFileName(files, index, success);
          return;
        }
        if (!isFile) {
          if (sameNameFileInfo) {
            console.warn("\u53D1\u73B0\u91CD\u540D\u6587\u4EF6\u5939:  ".concat(file.name));
            if (currentUploadFolderType) {
              paths["delete"](file.path);
              testFileName(files, index, success);
            } else {
              var win = new _MDUploadSameNameForFolderWinView["default"]({
                msgStr: BabelStr.str(21508, {
                  //当前文件夹已存在名称为{-name-}的文件夹，该文件夹上传失败，请修改文件名后再次上传
                  name: file.name
                }),
                buttonCallback: function buttonCallback(nextSame) {
                  if (nextSame) {
                    currentUploadFolderType = nextSame;
                  }
                  paths["delete"](file.path);
                  testFileName(files, index, success);
                }
              });
              win.show();
            }
          } else {
            pathMap[file.path] = {
              forceFolderRename: 0
            };
            testFileName(files, index, success);
          }
          return;
        }
        if (currentUploadType == 3) {
          // 上传新版本
          pathMap[file.path] = {
            fileId: sameNameFileInfo.getFileId() + ""
          };
          testFileName(files, index, success);
        } else if (currentUploadType == 2) {
          // 自动重命名
          pathMap[file.path] = {
            forceFolderRename: 1
          };
          testFileName(files, index, success);
        } else if (currentUploadType == 1) {
          paths["delete"](file.path);
          testFileName(files, index, success);
        } else {
          var _win = new _MDUploadSameNameWinView["default"]({
            canUploadVersion: sameNameFileInfo.canUploadVersion(),
            msgStr: BabelStr.str(450, {
              // 当前文件夹已存在名称为 {-fileName-} 的文件！
              fileName: file.name
            }),
            buttonCallback: function buttonCallback(type, nextSame) {
              if (type == 3) {
                pathMap[file.path] = {
                  fileId: sameNameFileInfo.getFileId() + ""
                };
              } else if (type == 1) {
                paths["delete"](file.path);
              } else if (type == 2) {
                pathMap[file.path] = {
                  forceFolderRename: 1
                };
              }
              if (nextSame) {
                currentUploadType = type;
              }
              testFileName(files, index, success);
            }
          });
          _win.show();
        }
      }, function (res) {
        _MDSnackbarView["default"].show(res.msg);
      });
    });
  }
  testFileName(files, 0, function () {
    if (!paths.size) {
      console.log("全被过滤掉了");
      return;
    }
    console.log(Array.from(paths), pathMap);
    MDfileUploadList.appendUploadTasks(Array.from(paths), pathMap);
  });
};
MDfileUploadList.hasSameNameInFolder = function (params, successCB, failCb) {
  var data = {
    params: params,
    successCB: successCB,
    failCb: failCb
  };
  // 排队，一条条执行，禁止直接发往服务器
  if (!MMEnterpriseController.sameNameQueue) {
    MMEnterpriseController.sameNameQueue = [data];
    MDfileUploadList.hasSameNameInFolderCallServer();
  } else {
    MMEnterpriseController.sameNameQueue.push(data);
  }
}, MDfileUploadList.hasSameNameInFolderCallServer = function () {
  if (!MMEnterpriseController.sameNameQueue || MMEnterpriseController.sameNameQueue.length == 0) {
    MMEnterpriseController.sameNameQueue = null;
    return;
  }
  var data = MMEnterpriseController.sameNameQueue.shift();
  var currentUploadType = MDfileUploadList.uploadSingletonObj[data.params.uploadId];
  if (data.params.uploadId && currentUploadType) {
    data.successCB();
    // callServer()
  } else {
    MMEnterpriseController.hasSameNameInFolderRequest(data.params, data.successCB, data.failCb);
  }
}, MDfileUploadList.appendUploadTasks = function (paths, pathMap) {
  var appendUploadTasks = window["ElectronRequire"]("electron").remote.require("./utils/Transfer/TransferController").TransferController.appendUploadTasks;
  appendUploadTasks(paths, app.currentFolder.getFileId(), pathMap);
};
MDfileUploadList.onDrop = function (dataTransfer, parentFolder) {
  parentFolder = parentFolder || app.currentFolder;
  // let a = window['ElectronRequire']('electron').remote.require('./javascript/base/app.js')
  var dt = dataTransfer;
  var files = dt.files;
  if (app.isInClient() && app.getTransferController() && !app.currentFolder.get("aiUploadFile") && !app.currentFolder.get("fotExcelAi")) {
    MMEnterpriseController.isIpAllowUpload(app.currentFolder.getFileId(), function () {
      MDfileUploadList.forClientUpload(files, app.currentFolder.getFileId());
    }, function (err) {
      _MDAlertView["default"].showStandardPrompt({
        message: err.msg
      });
    });
    //
    return;
  }
  _MDLoadMaskView["default"].show(undefined, {
    bodyMsg: BabelStr.str(1542)
  });
  if (dt.items) {
    // chrome 上传模式 - 可上传文件夹
    var items = dt.items || [];
    var hasFolder = false;
    // if(app.currentUser.inFreeEdition()){
    //   _.each(items , function(item){
    //     var fileEntry = items[0].webkitGetAsEntry();
    //     hasFolder = fileEntry.isDirectory;
    //   });
    //   if(hasFolder){
    //     MDSnackbarView.show(BabelStr.str(457));    //('个人版暂不支持文件夹上传，请升级'  );
    //     return;
    //   }
    // }
    // MDfileUploadList.uploadFiles_deepFirst(items, parentFolder);

    // MDfileUploadList.countFiles(items, (count) => {
    //   console.log("=========> fileCount:" + count.file_count);
    //   console.log("=========> folderCount:" + count.folder_count);
    //   if (count.file_count + count.folder_count > 100) {
    //     MDAlertView.showStandardPrompt({
    //       message: BabelStr.str(7500),    //网页上传一次不能超过 100 个文件（夹），请使用客户端的同步文件夹功能进行同步！
    //     })
    //   } else {
    console.log("=========> parentFolder:", parentFolder);
    MDfileUploadList.uploadFiles_layerFirst2(items, parentFolder);
    //   }
    // });A
  } else if (dt.files) {
    var needCheck = false;
    if (dt.files.len < 10) {
      needCheck = true;
    }
    _.each(dt.files, function (file) {
      MDfileUploadList.isFolder(file, function (isFile) {
        if (isFile) {
          file.needCheckFileName = needCheck;
          MDfileUploadList.pushFile(file, null, parentFolder, _.noop);
        } else {}
      });
    });
  }
};

// MDfileUploadList.uploadFiles_deepFirst = function(files, parentFolder) {

//   function traverseFileTree(item, path, parentFileInfo) {
//     path = path || "";
//     if (item.isFile) {
//       // Get file
//       item.file(function(file) {
//         console.log("File:", path + file.name)
//         if (file.name != '.DS_Store') {
//           MDfileUploadList.pushFile(file, null, parentFileInfo);
//         };

//       });
//     } else if (item.isDirectory) {

//       console.log("directory:", path + item.name);

//       MMNetDiskDataController.createDir(item.name, parentFileInfo, function(folderFileInfo) {
//         if (parentFileInfo.getFileId() == app.currentFolder.getFileId()) {

//           var curFileTableView = viewManager.get('curFileTableView');
//           // 只有在homeTableView下才将file加入到Collection中
//           if(curFileTableView){
//             var fileInforCollection = curFileTableView.getDataCollection();
//             if (!app.pathRouter.isInSearch() && app.currentFolder.getFileId() == parentFileInfo.getFileId()) {
//               fileInforCollection.addFileBlowStickonTop(folderFileInfo);
//             }
//           }
//         };

//         Dispatcher.trigger(MDEvents.FolderCreated, folderFileInfo);

//         // Get folder contents
//         var dirReader = item.createReader();
//         dirReader.readEntries(function(entries) {
//           for (var i = 0; i < entries.length; i++) {
//             traverseFileTree(entries[i], path + item.name + "/", folderFileInfo);
//           }
//         });

//       }, function(errroCode) {
//         let msg = BabelStr.str(155) + " code:" + errroCode;
//         MDSnackbarView.show(msg);
//       })
//     }
//   }
// }

MDfileUploadList.countFiles = function (originfiles, next) {
  var files = originfiles;
  var self = this;
  function layerFirstTraverseFileTree(items, callback) {
    var file_count = 0;
    var folder_count = 0;
    var item = items.shift();
    console.log("-----> originfiles length:" + originfiles.length);
    var folderReaded = 0;
    var folderInLayer = 0;
    var fileReaded = 0;
    var fileInLayer = 0;
    while (item) {
      if (item.isFile) {
        fileInLayer++;
        // Get file
        item.file(function (file) {
          fileReaded++;
          if (file.name != ".DS_Store") {
            file_count++;
            console.log("-------> file_count:" + file_count);
          }
          if (items.length == 0 && fileReaded == fileInLayer && folderReaded == folderInLayer) {
            callback({
              file_count: file_count,
              folder_count: folder_count
            });
          }
        });
      } else if (item.isDirectory) {
        folder_count++;
        folderInLayer++;
        console.log("-------> folder_count:" + folder_count);
        // Get folder contents
        var dirReader = item.createReader();
        var fnReadEntries = function fnReadEntries(entries) {
          layerFirstTraverseFileTree(entries, function (count) {
            folderReaded++;
            file_count += count.file_count;
            folder_count += count.folder_count;
            if (items.length == 0 && fileReaded == fileInLayer && folderReaded == folderInLayer) {
              callback({
                file_count: file_count,
                folder_count: folder_count
              });
            }
          });
        };
        dirReader.readEntries(fnReadEntries);
      }
      item = items.shift();
      console.log("-----> originfiles length:" + originfiles.length);
    }
    if (items.length == 0 && fileReaded == fileInLayer && folderReaded == folderInLayer) {
      callback({
        file_count: file_count,
        folder_count: folder_count
      });
    }
  }
  var items = [];
  for (var i = 0; i < files.length; i++) {
    // webkitGetAsEntry is where the magic happens
    var file = files[i].webkitGetAsEntry();
    if (file) {
      items.push(file);
    }
  }
  layerFirstTraverseFileTree(items, function (count) {
    next(count);
  });
};
MDfileUploadList.cancelUpload = function () {
  this.canceled = true;
};
MDfileUploadList.showAlert = function (message) {
  var _this2 = this;
  if (this.alert) {
    this.alert.appendMsg(message);
  } else {
    this.alert = new _MDAlertView["default"]({
      title: BabelStr.str(170),
      width: 600,
      message: message,
      onHide: function onHide() {
        _this2.alert = null;
      },
      buttons: [{
        label: BabelStr.str(154) // ----- '跳过',
      }]
    });
    this.alert.show();
  }
};
MDfileUploadList.pushDir = function (files) {
  var _MDfileUploadList$bui = MDfileUploadList.buildFolderStructure(files),
    folderStructure = _MDfileUploadList$bui.folderStructure,
    length = _MDfileUploadList$bui.length;
  console.log(length);
  if (length > MDfileUploadList.MAX_UPLOADS_FOR_FOLDER) {
    _MDLoadMaskView["default"].remove();
    _MDSnackbarView["default"].show(BabelStr.str(12307, {
      max: MDfileUploadList.MAX_UPLOADS_FOR_FOLDER
    }));
    _MDAlertView["default"].showStandardPrompt({
      message: BabelStr.str(12307, {
        max: MDfileUploadList.MAX_UPLOADS_FOR_FOLDER
      })
    });
    return;
  }
  MDfileUploadList.uploadFolderStructur_layerFirst(folderStructure, app.currentFolder);
};
MDfileUploadList.buildFolderStructure = function (files) {
  var folderStructure = {};
  var length = files.length;
  for (var i = 0; i < files.length; i++) {
    var file = files[i];
    var relativePath = file.webkitRelativePath; // 获取文件的相对路径
    var fileName = file.name;

    // 根据相对路径分割文件夹和文件名
    var pathParts = relativePath.split('/');
    var currentLevel = folderStructure;
    for (var j = 0; j < pathParts.length - 1; j++) {
      var dirName = pathParts[j];
      if (!currentLevel[dirName]) {
        currentLevel[dirName] = {};
        length++;
      }
      currentLevel = currentLevel[dirName];
    }

    // 文件名作为最后一级
    currentLevel[fileName] = file; // 这里可以存储文件的其他信息，如Blob等
  }
  if (length > 1) {
    length--;
  }
  return {
    folderStructure: folderStructure,
    length: length
  };
};
MDfileUploadList.uploadFolderStructur_layerFirst = function (files, parentFolder) {
  var len = files.length;
  var uploadId = MDfileUploadList.getUploadSingletonId();
  this.canceled = false;
  var self = this;
  // let fileArr = Object.entries(files);
  var batchUploadMark = new Date().getTime();
  // function layerFirstTraverseFileTree(obj, isFirstLayer, curPath) {
  // 辅助函数，用于递归遍历对象的属性
  function traverse(items, isFirstLayer, curPath, parentFileInfo) {
    var promises = [];
    var _loop = function _loop() {
        // 检查属性是否存在并且不是原型链上的属性
        if (items.hasOwnProperty(key)) {
          var item = items[key];
          var fileName = key;
          if (item instanceof File && parentFileInfo) {
            file = item;
            file.batchUploadMark = batchUploadMark;
            file.batchTargetRoot = parentFolder;
            console.log("File:", curPath + file.name);
            MDfileUploadList.pushFile(file, null, parentFileInfo, _.noop, {
              len: len,
              inDir: true,
              uploadId: uploadId
            });
            // delete items[fileName]
            // layerFirstTraverseFileTree(items, false, inDir);
          } else {
            var createDir = function createDir(forceRename, callback) {
              var filter = MMCommonFun.testFileName(fileName);
              var message = "";
              if (filter.length > 0) {
                message = BabelStr.str(2872, {
                  str: filter.join("，"),
                  name: fileName
                });
                message = _.escape(message);
              }
              if (filter.length > 0) {
                self.showAlert(message);
                callback();
                return;
              }
              // 创建文件夹但不发送通知和动态，否则会导致后台系统过于忙碌
              _MMNetDiskDataController["default"].createDir(fileName, parentFileInfo, forceRename, true, function (folderFileInfo) {
                _MDLoadMaskView["default"].remove();
                callback(folderFileInfo);
                if (self.canceled) {
                  return;
                }
                if (parentFileInfo.getFileId() == app.currentFolder.getFileId()) {
                  var curFileTableView = viewManager.get("curFileTableView");
                  if (curFileTableView) {
                    var fileInforCollection = curFileTableView.getDataCollection();
                    if (!app.pathRouter.isInSearch() && app.currentFolder.getFileId() == parentFileInfo.getFileId()) {
                      fileInforCollection.addFileBlowStickonTop(folderFileInfo);
                    }
                  }
                }
                Dispatcher.trigger(_MDEvents["default"].FolderCreated, folderFileInfo);

                // layerFirstTraverseFileTree(items[fileName], false, true, curPath + "/" + fileName);
              }, function (errroCode) {
                callback();
                _MDLoadMaskView["default"].remove();
                var folderPath = curPath + "/" + fileName;
                var msg = BabelStr.str(20041, {
                  folder: folderPath
                }) + " code:" + errroCode;
                if (errroCode == 12) {
                  msg = BabelStr.str(20053);
                }
                _MDSnackbarView["default"].show(msg);
                _MDAlertView["default"].showStandardPrompt({
                  message: msg
                });
              }, {
                isBatchCreate: true
              });
            }; // let newBatchUploadMark = new Date().getTime(); // 在第一层文件夹上增加批量上传标记
            var check4batchCreateFiles = function check4batchCreateFiles() {
              return new Promise(function (resolve) {
                if (isFirstLayer) {
                  _MMNetDiskDataController["default"].check4batchCreateFiles(folderId, function (key, code, msg) {
                    if (key) {
                      window[batchUploadMark] = {
                        key: key,
                        batchTargetRoot: parentFolder
                      };
                      createDir(1, resolve); // ------------------------> 第一层，需要强制重命名
                    } else {
                      console.error("----> key invalid");
                    }
                  }, function (code, msg) {
                    _MDLoadMaskView["default"].remove();
                    self.showAlert(msg);
                    console.error("----> 无权访问");
                    resolve();
                  });
                } else {
                  createDir(0, resolve);
                }
              });
            };
            folderId = parentFolder.getFileId();
            checkPromise = check4batchCreateFiles();
            checkPromise.then(function (mola_parentFileInfo) {
              promises.push(traverse(item, false, curPath + "/" + fileName, mola_parentFileInfo));
            });
          }
        }
      },
      file,
      folderId,
      checkPromise;
    for (var key in items) {
      _loop();
    }

    // 等待所有异步操作完成
    return Promise.all(promises);
  }

  // 开始遍历对象
  return traverse(files, true, "", parentFolder);
  // }

  // parentFolder = parentFolder || app.currentFolder;

  // var items = [];
  // for (var i = 0; i < files.length; i++) {
  //   // webkitGetAsEntry is where the magic happens
  //   var file = files[i].webkitGetAsEntry();
  //   if (file) {
  //     file.mola_path = "";
  //     file.mola_parentFileInfo = parentFolder;
  //     items.push(file);
  //   }
  // }
  layerFirstTraverseFileTree(files, true);
};
MDfileUploadList.uploadFiles_layerFirst = function (files, parentFolder) {
  var len = files.length;
  var uploadId = MDfileUploadList.getUploadSingletonId();
  this.canceled = false;
  var self = this;
  function layerFirstTraverseFileTree(items, isFirstLayer, inDir) {
    if (self.canceled) {
      return;
    }
    var item = items.shift();
    if (item) {
      var path = item.mola_path;
      var parentFileInfo = item.mola_parentFileInfo;
      if (item.isFile) {
        // Get file
        item.file(function (file) {
          file.batchUploadMark = item.batchUploadMark;
          file.batchTargetRoot = parentFolder;
          console.log("File:", path + file.name);
          if (file.name != ".DS_Store") {
            MDfileUploadList.pushFile(file, null, parentFileInfo, _.noop, {
              len: len,
              inDir: inDir,
              uploadId: uploadId
            });
          }
        });
        layerFirstTraverseFileTree(items, false, inDir);
      } else if (item.isDirectory) {
        var createDir = function createDir(forceRename) {
          var filter = MMCommonFun.testFileName(item.name);
          // let limits = parentFolder.get("limits");
          // let limitsResult = MMCommonFun.validateFileType(item.name, limits)
          var message = "";
          // if(!limitsResult) {
          // let type = limits[0]['type'];
          // let str = _.pluck(limits, 'stringLimit').join(',');
          // if(type == 1) {
          //   message = BabelStr.str(2873, {str: str, fileName: item.name, name: parentFolder.getFileName()})
          // } else if(type == 2) {
          //   message = BabelStr.str(2874, {str: str, fileName: item.name, name: parentFolder.getFileName()})
          // }
          // } else
          if (filter.length > 0) {
            message = BabelStr.str(2872, {
              str: filter.join("，"),
              name: item.name
            });
            message = _.escape(message);
          }
          if (filter.length > 0) {
            self.showAlert(message);
            return;
          }
          // 创建文件夹但不发送通知和动态，否则会导致后台系统过于忙碌
          _MMNetDiskDataController["default"].createDir(item.name, parentFileInfo, forceRename, true, function (folderFileInfo) {
            _MDLoadMaskView["default"].remove();
            if (self.canceled) {
              return;
            }
            if (parentFileInfo.getFileId() == app.currentFolder.getFileId()) {
              var curFileTableView = viewManager.get("curFileTableView");
              if (curFileTableView) {
                var fileInforCollection = curFileTableView.getDataCollection();
                if (!app.pathRouter.isInSearch() && app.currentFolder.getFileId() == parentFileInfo.getFileId()) {
                  fileInforCollection.addFileBlowStickonTop(folderFileInfo);
                }
              }
            }
            Dispatcher.trigger(_MDEvents["default"].FolderCreated, folderFileInfo);

            // Get folder contents
            var dirReader = item.createReader();
            var fnReadEntries = function fnReadEntries(entries) {
              var nextLayer;
              for (var i = 0; i < entries.length; i++) {
                entries[i].mola_path = path + item.name + "/";
                entries[i].mola_parentFileInfo = folderFileInfo;
                entries[i].batchUploadMark = item.batchUploadMark; //  对文件夹的子文件传播批量上传标记
                items.push(entries[i]);
              }
              if (entries.length > 0) {
                dirReader.readEntries(fnReadEntries);
              } else {
                layerFirstTraverseFileTree(items, false, true);
              }
            };
            dirReader.readEntries(fnReadEntries);
          }, function (errroCode) {
            _MDLoadMaskView["default"].remove();
            var folderPath = item.mola_path + item.name;
            var msg = BabelStr.str(20041, {
              folder: folderPath
            }) + " code:" + errroCode;
            if (errroCode == 12) {
              msg = BabelStr.str(20053);
            }
            _MDSnackbarView["default"].show(msg);
            _MDAlertView["default"].showStandardPrompt({
              message: msg
            });
          }, {
            isBatchCreate: true
          });
        };
        console.log("directory:", path + item.name);
        if (isFirstLayer) {
          item.batchUploadMark = new Date().getTime(); // 在第一层文件夹上增加批量上传标记

          var folderId = parentFolder.getFileId();
          _MMNetDiskDataController["default"].check4batchCreateFiles(folderId, function (key, code, msg) {
            if (key) {
              window[item.batchUploadMark] = {
                key: key,
                batchTargetRoot: parentFolder
              };
              createDir(1); // ------------------------> 第一层，需要强制重命名
            } else {
              console.error("----> key invalid");
            }
          }, function (code, msg) {
            _MDLoadMaskView["default"].remove();
            self.showAlert(msg);
            console.error("----> 无权访问");
          });
        } else {
          setBabelTimeout(function () {
            createDir(0); // ------------------------> 非第一层的下面的各层，不需要需要强制重命名
          }, 200);
        }
      }
    }
  }
  parentFolder = parentFolder || app.currentFolder;
  var items = [];
  for (var i = 0; i < files.length; i++) {
    // webkitGetAsEntry is where the magic happens
    var file = files[i].webkitGetAsEntry();
    if (file) {
      file.mola_path = "";
      file.mola_parentFileInfo = parentFolder;
      items.push(file);
    }
  }
  layerFirstTraverseFileTree(items, true);
};
MDfileUploadList.collect_files = function (files, parentFolder, successCallback, errorCallback) {
  var allFileEntries = [];
  function layerFirstTraverseFileTree2(fileSysEntries) {
    if (allFileEntries.length > MDfileUploadList.MAX_UPLOADS_FOR_FOLDER) {
      errorCallback();
      return;
    }
    var fileSysEntry = fileSysEntries.shift();
    while (fileSysEntry && fileSysEntry.isFile) {
      fileSysEntry = fileSysEntries.shift();
    }
    if (fileSysEntry) {
      // Get folder contents
      var path = fileSysEntry.mola_path;
      var dirReader = fileSysEntry.createReader();
      var fnReadEntries = function fnReadEntries(entries) {
        var folderSysEntries = [];
        var simpleFileEntries = [];
        for (var i = 0; i < entries.length; i++) {
          var subEntry = entries[i];
          subEntry.mola_path = path + fileSysEntry.name + "/";
          subEntry.parentFileEntry = fileSysEntry; //  --------- 子文件没有 mola_parentFileInfo，只有 parentFileEntry
          if (subEntry.isDirectory) {
            folderSysEntries.push(subEntry);
          } else {
            simpleFileEntries.push(subEntry);
          }
        }
        fileSysEntries = fileSysEntries.concat(folderSysEntries, simpleFileEntries);
        allFileEntries = allFileEntries.concat(folderSysEntries, simpleFileEntries);
        if (allFileEntries.length > MDfileUploadList.MAX_UPLOADS_FOR_FOLDER) {
          errorCallback();
          return;
        }
        if (entries.length > 0) {
          dirReader.readEntries(fnReadEntries);
        } else {
          layerFirstTraverseFileTree2(fileSysEntries);
        }
      };
      dirReader.readEntries(fnReadEntries);
    } else {
      successCallback(allFileEntries);
    }
  }
  parentFolder = parentFolder || app.currentFolder;
  var fileSysEntries = [];
  var folderSysEntries = [];
  var simpleFileEntries = [];
  for (var i = 0; i < files.length; i++) {
    // webkitGetAsEntry is where the magic happens
    var fileSystemEntry = files[i].webkitGetAsEntry();
    if (fileSystemEntry) {
      fileSystemEntry.needCheckFileName = true;
      fileSystemEntry.mola_path = "";
      fileSystemEntry.mola_parentFileInfo = parentFolder; // ----------- 只有首层有这个父文件夹的标记， 子文件只有 parentFileEntry
      if (fileSystemEntry.isDirectory) {
        folderSysEntries.push(fileSystemEntry);
      } else {
        simpleFileEntries.push(fileSystemEntry);
      }
      allFileEntries.push(fileSystemEntry);
    }
  }
  fileSysEntries = fileSysEntries.concat(folderSysEntries, simpleFileEntries);
  layerFirstTraverseFileTree2(fileSysEntries);
};
MDfileUploadList.uploadFiles_layerFirst2 = function (files, parentFolder) {
  var len = files.length;
  var uploadId = MDfileUploadList.getUploadSingletonId();
  this.canceled = false;
  var self = this;
  var localStorageKey = "MDfileUploadList.uploadFiles_layerFirst2-";
  MDfileUploadList.collect_files(files, parentFolder, function (allFileEntries) {
    localStorage.setItem(localStorageKey, allFileEntries.length);
    var message = "";
    for (var i = 0; i < allFileEntries.length; i++) {
      var fileEntry = allFileEntries[i];
      fileEntry.uploadId = uploadId;
      var parentFolder1 = fileEntry.mola_parentFileInfo;
      var path = fileEntry.mola_path;
      var fileName = fileEntry.name;
      var fileSize = fileEntry.size;
      var pathInfo = path + "" + fileName;
      localStorage.setItem(localStorageKey + i, pathInfo);
      var logValue = "isFile:" + fileEntry.isFile + ", path:" + path + ", fileName:" + fileName + ", parentFolder1" + (parentFolder1 && parentFolder1.get("fileId"));
      console.log(logValue);
      message += pathInfo + "<br>";
    }

    // MDAlertView.showStandardPrompt({
    //   message: message,
    // });

    MDfileUploadList.uploadByFileSysEntries(allFileEntries, parentFolder, function () {
      _MDLoadMaskView["default"].remove();
    }, function (code, msg) {
      _MDLoadMaskView["default"].remove();
      self.showAlert(code + ":" + msg);
      console.error("----> 无权访问");
    });
  }, function () {
    _MDLoadMaskView["default"].remove();
    _MDSnackbarView["default"].show(BabelStr.str(12307, {
      max: MDfileUploadList.MAX_UPLOADS_FOR_FOLDER
    }));
    _MDAlertView["default"].showStandardPrompt({
      message: BabelStr.str(12307, {
        max: MDfileUploadList.MAX_UPLOADS_FOR_FOLDER
      })
    });
  });
};
MDfileUploadList.uploadByFileSysEntries = function (fileSysEntries, parentFolder, successCallback, errorCallback) {
  if (fileSysEntries.length == 0) {
    successCallback();
    return;
  }
  ;
  var batchUploadMark = new Date().getTime();
  var folderId = parentFolder.getFileId();
  _MMNetDiskDataController["default"].check4batchCreateFiles(folderId, function (key, code, msg) {
    if (key) {
      window[batchUploadMark] = {
        key: key,
        batchTargetRoot: parentFolder
      };
      MDfileUploadList.batchUploadByFileSysEntries(fileSysEntries, batchUploadMark, successCallback, errorCallback);
    } else {
      console.error("----> key invalid");
    }
  }, function (code, msg) {
    errorCallback(code, msg);
  });
};
MDfileUploadList.batchUploadByFileSysEntries = function (fileSysEntries, batchUploadMark, successCallback, errorCallback) {
  var fileSysEntry = fileSysEntries.shift();
  var forceRename = 0;
  if (fileSysEntry) {
    var parentFolder = fileSysEntry.mola_parentFileInfo;
    if (!parentFolder) {
      var parentFileEntry = fileSysEntry.parentFileEntry;
      if (!parentFileEntry) {
        errorCallback("1", "parentFileEntry is null");
        return;
      }
      parentFolder = parentFileEntry.folderFileInfo;
      if (!parentFolder) {
        errorCallback("1", "parentFolder is null");
        return;
      }
    } else {
      forceRename = 1; // -------------- 首层必须强制重命名
    }
    if (fileSysEntry.isFile) {
      var uploadId = fileSysEntry.uploadId;
      fileSysEntry.file(function (file) {
        file.batchUploadMark = batchUploadMark;
        file.batchTargetRoot = parentFolder;
        file.needCheckFileName = fileSysEntry.needCheckFileName;
        console.log("----------> uploadId:", uploadId);
        console.log("File:", fileSysEntry.path + file.name);
        if (file.name != ".DS_Store") {
          MDfileUploadList.pushFile(file, null, parentFolder, _.noop, {
            len: fileSysEntries.length,
            uploadId: uploadId
          });
          _MDLoadMaskView["default"].remove();
        }
      });
      setBabelTimeout(function () {
        MDfileUploadList.batchUploadByFileSysEntries(fileSysEntries, batchUploadMark, successCallback, errorCallback);
      }, 200);
    } else {
      fileSysEntry.batchUploadMark = batchUploadMark;
      MDfileUploadList.createDirForFileSysEntry(forceRename, parentFolder, fileSysEntry, function (folderFileInfo) {
        fileSysEntry.folderFileInfo = folderFileInfo;
        setBabelTimeout(function () {
          MDfileUploadList.batchUploadByFileSysEntries(fileSysEntries, batchUploadMark, successCallback, errorCallback);
        }, 200);
      }, function (errCode, msg) {
        errorCallback(errCode, msg);
      });
    }
  } else {
    successCallback();
  }
};
MDfileUploadList.createDirForFileSysEntry = function (forceRename, parentFolder, fileSysEntry, successCallback, errorCallback) {
  var self = this;
  var filter = MMCommonFun.testFileName(fileSysEntry.name);
  var message = "";
  if (filter.length > 0) {
    message = BabelStr.str(2872, {
      str: filter.join("，"),
      name: fileSysEntry.name
    });
    message = _.escape(message);
  }
  if (filter.length > 0) {
    self.showAlert(message);
    return;
  }
  // 创建文件夹但不发送通知和动态，否则会导致后台系统过于忙碌
  _MMNetDiskDataController["default"].createDir(fileSysEntry.name, parentFolder, forceRename, true, function (folderFileInfo) {
    if (self.canceled) {
      return;
    }
    if (parentFolder.getFileId() == app.currentFolder.getFileId()) {
      var curFileTableView = viewManager.get("curFileTableView");
      if (curFileTableView) {
        var fileInforCollection = curFileTableView.getDataCollection();
        if (!app.pathRouter.isInSearch() && app.currentFolder.getFileId() == parentFolder.getFileId()) {
          fileInforCollection.addFileBlowStickonTop(folderFileInfo);
        }
      }
    }
    fileSysEntry.folderFileInfo = folderFileInfo; // ------------- 记录文件夹信息，以供子文件夹使用

    Dispatcher.trigger(_MDEvents["default"].FolderCreated, folderFileInfo);
    successCallback(folderFileInfo);
  }, function (errroCode) {
    errorCallback(errroCode, "create dir error");
  }, {
    isBatchCreate: true
  });
};
MDfileUploadList.uploadSingletonId = 1;
MDfileUploadList.getUploadSingletonId = function () {
  return MDfileUploadList.uploadSingletonId++;
};
MDfileUploadList.uploadSingletonObj = {};
var _default = exports["default"] = MDfileUploadList;

},{"1087":1087,"1104":1104,"1184":1184,"1412":1412,"1417":1417,"1418":1418,"1419":1419,"1421":1421,"1423":1423,"1424":1424,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1471":1471,"1480":1480,"1487":1487,"1537":1537,"1538":1538,"21":21,"32":32,"325":325,"330":330,"341":341,"342":342,"343":343,"49":49,"525":525,"72":72}],343:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDCheckboxView = _interopRequireDefault(require(37));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /*2021-8-23*/
var MDUploadSameNameWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDUploadSameNameWinView, _MDWindowView);
  function MDUploadSameNameWinView() {
    (0, _classCallCheck2["default"])(this, MDUploadSameNameWinView);
    return _callSuper(this, MDUploadSameNameWinView, arguments);
  }
  (0, _createClass2["default"])(MDUploadSameNameWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<span><%=msgStr%></span>\n      <div class=\"ope-type-content mgt-10\"></div>\n   ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUploadSameNameWinView.prototype), "className", this).call(this);
      return superCls + ' upload-sameName-win';
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUploadSameNameWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        animated: false
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.title = BabelStr.str(449);
      props.hiddenClose = true;
      var buttons = [{
        label: BabelStr.str(451),
        // ----- '跳过',
        onClick: function onClick(button, $e) {
          this.buttonCallback(1, this.nextSame);
        }
      }, {
        label: BabelStr.str(452),
        // ----- '自动重命名继续上传',
        onClick: function onClick(button, $e) {
          this.buttonCallback(2, this.nextSame);
        }
      }];
      if (props.canUploadVersion) {
        buttons.push({
          type: 'done',
          label: BabelStr.str(453),
          // ----- "作为该文件的新版本上传",
          onClick: function onClick(button, $e) {
            this.buttonCallback(3, this.nextSame);
          }
        });
        this.$('.window-footer').addClass('flex-align between');
      } else {
        this.$('.window-footer').addClass('flex-align end');
        buttons[1]['type'] = 'done';
      }
      props.buttons = buttons;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUploadSameNameWinView.prototype), "initialize", this).call(this, props);
      this.checkbox = new _MDCheckboxView["default"]({
        label: BabelStr.str(5412),
        onChanged: function onChanged(checked) {
          _this.nextSame = true;
        }
      });
      this.addSubView(this.checkbox, this.$('.ope-type-content')[0]);
      if (props.canUploadVersion) {
        this.$('.window-footer').addClass('flex-align between');
      } else {
        this.$('.window-footer').addClass('flex-align end');
      }
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        msgStr: this.msgStr
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUploadSameNameWinView.prototype), "render", this).call(this, data);
    }
  }]);
  return MDUploadSameNameWinView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"37":37,"93":93}],342:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDCheckboxView = _interopRequireDefault(require(37));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /*2021-8-23*/
var MDUploadSameNameForFolderWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDUploadSameNameForFolderWinView, _MDWindowView);
  function MDUploadSameNameForFolderWinView() {
    (0, _classCallCheck2["default"])(this, MDUploadSameNameForFolderWinView);
    return _callSuper(this, MDUploadSameNameForFolderWinView, arguments);
  }
  (0, _createClass2["default"])(MDUploadSameNameForFolderWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<span><%=msgStr%></span>\n      <div class=\"ope-type-content mgt-10\"></div>\n   ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUploadSameNameForFolderWinView.prototype), "className", this).call(this);
      return superCls + " upload-sameName-win";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUploadSameNameForFolderWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        animated: false
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.title = BabelStr.str(21510);
      props.hiddenClose = true;
      var buttons = [{
        label: BabelStr.str(154),
        // ----- '确定',
        type: "done",
        onClick: function onClick(button, $e) {
          this.buttonCallback(this.nextSame);
        }
      }];
      props.buttons = buttons;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUploadSameNameForFolderWinView.prototype), "initialize", this).call(this, props);
      this.checkbox = new _MDCheckboxView["default"]({
        label: BabelStr.str(21509),
        onChanged: function onChanged(checked) {
          _this.nextSame = true;
        }
      });
      this.addSubView(this.checkbox, this.$(".ope-type-content")[0]);
      this.$(".window-footer").addClass("flex-align end");
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        msgStr: this.msgStr
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDUploadSameNameForFolderWinView.prototype), "render", this).call(this, data);
    }
  }]);
  return MDUploadSameNameForFolderWinView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"37":37,"93":93}],347:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1477);
require(1492);
/**
 *
 * https://github.com/ilovecode1/linkjs
 */

var linkjs = {
  Version: 1.0,
  Author: "Cosmic Web Services",
  "do": function _do(inputText) {
    var replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
    var replacedText = inputText.replace(replacePattern1, '<a class="link-text" href="$1" target="_blank">$1</a>');
    var replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
    var replacedText = replacedText.replace(replacePattern2, '$1<a class="link-text" href="http://$2" target="_blank">$2</a>');
    var replacePattern3 = /(\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,6})/gim;
    var replacedText = replacedText.replace(replacePattern3, '<a class="link-text" href="mailto:$1">$1</a>');
    return replacedText;
  }
};
var _default = exports["default"] = linkjs;

},{"1454":1454,"1477":1477,"1492":1492}],51:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1432);
require(1417);
require(1463);
var _MMViewBase = _interopRequireDefault(require(22));
var _MDMenuView = _interopRequireDefault(require(53));
/**
 *  Menu view
 *
 *  Created by manjun.han
 *  2016.1.21
 */

var MDMenuItemView = _MMViewBase["default"].extend({
  el: '<div class="menu-item"></div>',
  tmpl: "\n    <div class=\"menu-item-line\">\n      <%if(iconCls){%><span class=\"<%=iconCls%>\"></span><%}%>\n      <%if(iconSvg){%><%=iconSvg%><%}%>\n      <div class=\"menu-item-content\"></div>\n      <%if(iconSvg && hasSub){%>\n        <svg width=\"7px\" height=\"11px\" class=\"show-sub\" viewBox=\"0 0 7 11\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n        <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g transform=\"translate(-328.000000, -547.000000)\" fill=\"currentColor\">\n        <polygon points=\"328.111435 557.100711 328.111435 547.100711 334.111435 552.100711\"/>\n        </g>\n        </g>\n        </svg>\n      <%}%>\n    </div>\n\n    ",
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      // 'mouseenter': this._onMouseEnterHandler,
      // 'mouseleave': this._onMouseLeaveHandler,
      // 'click': this._onClickHandler
    });
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      menuId: MDMenuItemView.getNextId(),
      clickable: true,
      enabled: true,
      topMenu: null,
      onAction: _.noop,
      caption: '',
      itemCls: '',
      newTool: false,
      subMenuItems: []
    });
  },
  /**
   *
   * opt = {
   *    itemCls:'', // extro className
   *    iconCls:'',
   *    caption:'The item's caption'
   * };
   *
   */
  initialize: function initialize(opt) {
    opt.data = {
      'iconCls': opt.iconCls,
      'iconSvg': opt.iconSvg,
      'hasSub': opt.subMenuItems && opt.subMenuItems.length
    };
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.setTopMenu(opt.topMenu);
    this.$menuContent = this.$('.menu-item-content');
    this.$el.addClass(opt.itemCls);
    if (this.newTool) {
      this.$menuContent.addClass('new-tool');
    }
    if (this.subMenuItems.length > 0) {
      if (!this.iconSvg) {
        this.$el.addClass("has-child");
      }
      this.initSubMenu();
      Dispatcher.on(MDEvents.EnterOtherMenuItem, this._menuItemChanged, this);
    }
    this.setCaption(this.caption);
    this.initEvents();
  },
  initEvents: function initEvents() {
    var _this = this;
    this.$el.off('mousedown');
    this.$el.off('mouseenter');
    this.$el.off('mouseleave');
    this.$el.on('mousedown', function (e) {
      _this._onClickHandler(e);
    });
    this.$el.on('mouseenter', function (e) {
      _this._onMouseEnterHandler(e);
    });
    this.$el.on('mouseleave', function (e) {
      _this._onMouseLeaveHandler(e);
    });
  },
  addSubMenuItem: function addSubMenuItem(item) {
    this.subMenuItems.push(item);
  },
  removeSubMenuItem: function removeSubMenuItem(item) {
    for (var i = 0; i < this.subMenuItems.length; i++) {
      var element = this.subMenuItems[i];
      if (element == item) {
        this.subMenu && this.subMenu.removeItem(item);
        this.subMenuItems.splice(i, 1);
        return;
      }
    }
  },
  initSubMenu: function initSubMenu() {
    if (!this.subMenu) {
      this.subMenu = new _MDMenuView["default"]({
        useSvg: !!this.iconSvg,
        width: this.iconSvg && 266
      });
    }
    this.subMenu.removeSubViews();
    for (var i = 0; i < this.subMenuItems.length; i++) {
      var element = this.subMenuItems[i];
      this.subMenu.addItem(element);
    }
  },
  setCaption: function setCaption(caption) {
    this.caption = caption;
    this.$menuContent.text(caption);
  },
  getCaption: function getCaption() {
    return this.caption;
  },
  getTopMenu: function getTopMenu() {
    return this.topMenu;
  },
  setTopMenu: function setTopMenu(topMenu) {
    this.topMenu = topMenu;
  },
  _onMouseEnterHandler: function _onMouseEnterHandler($e) {
    if (this.canHighlight()) {
      this.setHighlighted(true);
    }
    if (this.subMenu) {
      this.subMenu.renderTo(document.body);
      this.subMenu.$el.css("z-index", 10000);
      this.subMenu.showMenu();
      this.subMenu.positionWidthTarget(this.$el, 'right top');
      for (var i = 0; i < this.subMenuItems.length; i++) {
        var element = this.subMenuItems[i];
        element.initEvents();
      }
    }
    Dispatcher.trigger(MDEvents.EnterOtherMenuItem, this);
  },
  _onMouseLeaveHandler: function _onMouseLeaveHandler($e) {
    if (this.canHighlight()) {
      this.setHighlighted(false);
    }
  },
  hideMenu: function hideMenu() {
    if (this.subMenu) {
      for (var i = 0; i < this.subMenuItems.length; i++) {
        var element = this.subMenuItems[i];
        element.hideMenu();
      }
      this.subMenu.hideMenu();
    }
  },
  _menuItemChanged: function _menuItemChanged(item) {
    if (this.subMenuItems.length > 0) {
      if (item != this && item.$el.parent()[0] == this.$el.parent()[0]) {
        this.subMenu.hideMenu();
      }
    }
  },
  setHighlighted: function setHighlighted(highlighted) {
    this.highlighted = highlighted;
    highlighted ? this.$el.addClass("highlight") : this.$el.removeClass("highlight");
  },
  isHighlighted: function isHighlighted() {
    return this.highlighted;
  },
  canHighlight: function canHighlight() {
    return this.isEnabled();
  },
  setEnabled: function setEnabled(enabled) {
    this.enabled = enabled;
    if (enabled) {
      this.$el.removeClass("disabled");
      this.$el.find('.menu-icon').removeClass("disabled");
    } else {
      this.$el.addClass("disabled");
      this.$el.find('.menu-icon').addClass("disabled");
    }
  },
  isEnabled: function isEnabled() {
    return this.enabled;
  },
  viewDidRendered: function viewDidRendered() {
    _MMViewBase["default"].prototype.viewDidRendered.call(this);
  },
  isClickable: function isClickable() {
    return this.clickable;
  },
  _onClickHandler: function _onClickHandler($e) {
    if (this.isEnabled() && this.isClickable()) {
      var menu = this.getTopMenu();
      this.onAction.call(this);
      menu.onMenuItemViewClicked(this);
    } else {
      return false;
    }
  }
}, {
  className: "MDMenuItemView",
  globalId: 0,
  getNextId: function getNextId() {
    return MDMenuItemView.globalId++;
  }
});
var _default = exports["default"] = MDMenuItemView;

},{"1184":1184,"1417":1417,"1432":1432,"1454":1454,"1463":1463,"22":22,"53":53}],53:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1466);
var _MMViewBase = _interopRequireDefault(require(22));
var _MDMenuItemView = _interopRequireDefault(require(51));
var _MDMenuSeperatorView = _interopRequireDefault(require(52));
var _MDSubMenuView = _interopRequireDefault(require(54));
/**
 *  Menu view
 *
 *  Created by manjun.han
 *  2016.1.21
 */

var MDMenuView = _MMViewBase["default"].extend({
  el: '<div class="menu"></div>',
  minTop: 20,
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      'mouseenter': this._onMouseEnterHandler
    });
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      onMenuAction: _.noop,
      width: 240,
      root: true,
      autoRemove: true,
      onDismiss: _.noop,
      onShow: _.noop,
      onHide: _.noop,
      useSvg: false
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    this.bindSelf(this._docMouseDownHandler, this._lazyLayout);
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.$el.css("width", this.width);
    // for click event delay
    _.delay(function () {
      $(document.body).on(self.$nsEventName("contextmenu"), self._docMouseDownHandler, true);
      $("body")[0].addEventListener('mousedown', self._docMouseDownHandler, true);
    }, 0);
    if (this.useSvg) {
      this.$el.addClass("use-svg");
    }
  },
  _docMouseDownHandler: function _docMouseDownHandler($e) {
    if (!this.$el.isInner($e.target)) {
      this.autoRemove ? this.dismiss() : this.hideMenu();
    }
  },
  addItem: function addItem(menuItemView) {
    this.addSubView(menuItemView);
    menuItemView.setTopMenu && menuItemView.setTopMenu(this);
  },
  addSplit: function addSplit() {
    this.$el.append("\n      <div class=\"split\"></div>\n    ");
  },
  removeItem: function removeItem(menuItemView) {
    this.removeSubView(menuItemView);
  },
  removeItemAt: function removeItemAt(index) {
    this.removeSubViewAt(index);
  },
  getItemAt: function getItemAt(index) {
    return this.getSubViewAt(index);
  },
  getItemCount: function getItemCount() {
    return this.getSubViewCount();
  },
  dismiss: function dismiss(onDismiss) {
    this.remove();
    if (_.isFunction(onDismiss)) {
      this.onDismiss = onDismiss;
    }
    this.onDismiss.call(this);
  },
  isRoot: function isRoot() {
    return this.root;
  },
  getHightlightedMenuItem: function getHightlightedMenuItem() {
    var menuItem = null;
    this.eachSubViews(function (subView) {
      if (subView.isHighlighted()) {
        menuItem = subView;
        return false;
      }
    });
  },
  isVisible: function isVisible() {
    return this.el.parentNode && !(this.$el.css("display") == "none");
  },
  positionWithEvent: function positionWithEvent(event) {
    var self = this;
    $(window).on(this.$nsEventName('resize'), self._lazyLayout);
    this.$el.position({
      'my': "left+3 top+3",
      'of': event,
      'collision': "flipfit",
      'using': function using(pos, layout) {
        var winHeight = $(window).height();
        var winWidth = $(window).width();
        // 必须用css('height')
        //
        var srcHeight = Math.ceil(parseInt($(this).css('height')));
        var srcWidth = parseInt($(this).css('width'));
        var minTop = self.minTop;
        if (srcHeight + minTop > winHeight) {
          srcHeight = winHeight - minTop;
          $(this).css('max-height', srcHeight);
          pos.top = minTop;
        }
        var x1 = pos.left;
        var x2 = pos.left + srcWidth;
        var y1 = pos.top;
        var y2 = pos.top + srcHeight;
        // detect bound
        var bpos = {
          left: 0,
          top: minTop
        };
        var bx1 = bpos.left;
        var bx2 = bpos.left + winWidth;
        var by1 = bpos.top;
        var by2 = bpos.top + winHeight;
        // Check if it is inside and if not, reposition
        if (x1 < bx1) {
          pos.left += bx1 - x1;
        }
        if (x2 > bx2) {
          pos.left -= x2 - bx2;
        }
        if (y1 < by1) {
          pos.top += by1 - y1;
        }
        if (y2 > by2) {
          pos.top -= y2 - by2;
        }
        // final position
        var pt = {
          top: pos.top,
          left: pos.left
        };
        $(this).css(pt);
        $(this).data('initpt', pt).data('initHeight', srcHeight);
      }
    });
  },
  _lazyLayout: function _lazyLayout(Re) {
    var minTop = this.minTop;
    var curWinHeight = $(window).height();
    var curTop = this.$el.position().top;
    var height = parseInt(this.$el.css('max-height'));
    var contextWindow = window;
    var pt = this.$el.data('initpt');
    var top = curWinHeight - height;
    if (top <= minTop) {
      top = minTop;
    } else if (top > minTop && top < pt.top) {} else {
      top = pt.top;
    }
    var div = this.$el[0];
    var hasScroll = div.scrollHeight > div.clientHeight;
    top = parseInt(top);
    if (hasScroll) top = minTop;
    this.$el.css('top', top);
    var initHeight = this.$el.data('initHeight');
    if (top == minTop) {
      this.$el.css('max-height', parseInt(curWinHeight - minTop));
    } else {
      this.$el.css('max-height', initHeight);
    }
    this.$el[0].offsetWidth;
  },
  positionWidthTarget: function positionWidthTarget(target, at, within) {
    at = at || "top center";
    within = within || window;
    this.$el.position({
      'my': "left top",
      'at': at,
      'of': target,
      'within': within
    });
  },
  showMenu: function showMenu(onShow) {
    this.$el.show();
    if (_.isFunction(onShow)) {
      this.onShow = onShow;
    }
    this.onShow.call(this);
  },
  hideMenu: function hideMenu(onHide) {
    this.eachSubViews(function (subView) {
      subView.setHighlighted && subView.setHighlighted(false);
      if (subView.getClass() == _MDSubMenuView["default"]) {
        var menu = subView.getMenu();
        menu.hideMenu();
      } else if (subView.getClassName() == "MDMenuItemView") {
        subView.hideMenu();
      }
    });
    this.$el.hide();
    if (_.isFunction(onHide)) {
      this.onHide = onHide;
    }
    this.onHide.call(this);
  },
  toggleMenu: function toggleMenu() {
    this.isVisible() ? this.hideMenu() : this.showMenu();
  },
  _onMouseEnterHandler: function _onMouseEnterHandler($e) {
    var index = $($e.target).closest('.menu-item').index();
    this.eachSubViews(function (subView, i) {
      if (subView.isEnabled() && subView.getClass() == _MDSubMenuView["default"] && index !== i) {
        subView.setHighlighted(false);
      }
    });
  },
  onMenuItemViewClicked: function onMenuItemViewClicked(itemView) {
    this.dismiss();
    this.eachSubViews(function (subView, index) {
      console.log(" --" + index);
      if (subView.getClass() == _MDSubMenuView["default"]) {
        subView.dismissSubMenu();
      }
    });
    this.onMenuAction.call(itemView);
  },
  viewDidUnRendered: function viewDidUnRendered() {
    _MMViewBase["default"].prototype.viewDidUnRendered.call(this);
    // prevent memoory leak
    $(document.body)[0].removeEventListener("mosedown", this._docMouseDownHandler);
    $(document.body).off(this.$nsEventName("contextmenu"));
    $(window).off(this.$nsEventName('resize'));
  }
}, {
  className: "MDMenuView"
});
var _default = exports["default"] = MDMenuView;

},{"1184":1184,"1454":1454,"1466":1466,"22":22,"51":51,"52":52,"54":54}],54:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMViewBase = _interopRequireDefault(require(22));
var _MDMenuItemView = _interopRequireDefault(require(51));
/**
 *  Submenu view
 *
 *  Created by manjun.han
 *  2016.1.21
 */

var MDSubMenuView = _MDMenuItemView["default"].extend({
  initProps: function initProps() {
    var superP = _MDMenuItemView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      _subMenu: null,
      _showTimerId: -1,
      _dismissTimerId: -1,
      clickable: false,
      _timerId: -1
    });
  },
  initialize: function initialize(opt) {
    this.bindSelf(this.dismissSubMenu, this.showSubMenu);
    _MDMenuItemView["default"].prototype.initialize.call(this, opt);
  },
  addItem: function addItem(itemView) {
    this.getMenu().addItem(itemView);
    itemView.setTopMenu(this.topMenu);
  },
  setTopMenu: function setTopMenu(topMenu) {
    _MDMenuItemView["default"].prototype.setTopMenu.call(this, topMenu);
    this.getMenu().eachSubViews(function (subView) {
      subView.setTopMenu(topMenu);
    });
  },
  removeItem: function removeItem(itemView) {
    this.getMenu().removeItem(itemView);
  },
  getItemAt: function getItemAt(index) {
    return this.getMenu().getSubViewAt(index);
  },
  getMenu: function getMenu() {
    if (!this._subMenu) {
      this.setMenu(new MDMenuView());
    }
    return this._subMenu;
  },
  setMenu: function setMenu(menu) {
    if (this._subMenu) {
      this._subMenu.dismissSubMenu();
    }
    this._subMenu = menu;
  },
  setHighlighted: function setHighlighted(highlight) {
    _MDMenuItemView["default"].prototype.setHighlighted.call(this, highlight);
    if (!highlight) {
      this.dismissSubMenu();
    }
  },
  showSubMenu: function showSubMenu() {
    var menu = this.getMenu();
    this.dismissSiblingMenu();
    if (!menu.isViewRendered()) {
      menu.render();
      menu.renderTo("body");
    }
    menu.$el.show().position({
      my: 'left top',
      at: 'right top',
      of: this.el,
      collision: "flip"
    });
  },
  dismissSubMenu: function dismissSubMenu() {
    var menu = this.getMenu();
    menu.hideMenu();
  },
  clearTimers: function clearTimers() {
    clearTimeout(this._showTimerId);
    clearTimeout(this._dismissTimerId);
  },
  _onMouseEnterHandler: function _onMouseEnterHandler($e) {
    console.log(this);
    if (this.isEnabled()) {
      this.clearTimers();
      this._showTimerId = _.delay(this.showSubMenu, MDSubMenuView.MENU_DELAY);
    }
    _MDMenuItemView["default"].prototype._onMouseEnterHandler.call(this);
  },
  _onMouseLeaveHandler: function _onMouseLeaveHandler($e) {
    var inner = this._isMouseEventWithinElement($e.relatedTarget);
    if (!this.isEnabled()) {
      return;
    }
    if (!inner) {
      this.clearTimers();
      this._dismissTimerId = _.delay(this.dismissSubMenu, MDSubMenuView.MENU_DELAY);
      _MDMenuItemView["default"].prototype._onMouseLeaveHandler.call(this);
    } else {
      this.setHighlighted(true);
    }
  },
  dismissSiblingMenu: function dismissSiblingMenu() {
    var superView = this.getSuperView();
    //    if(!superView) debugger;
    //    console.log(superView)
    superView.eachSubViews(function (menuItem) {
      if (menuItem.getClass() == MDSubMenuView) {
        menuItem.dismissSubMenu();
      }
    });
  },
  _isMouseEventWithinElement: function _isMouseEventWithinElement(target) {
    var menu = this.getMenu();
    if (this._isInner(this.el, target) || this._isInner(menu.el, target)) {
      return true;
    }
    return false;
  },
  _isInner: function _isInner(container, contained) {
    return container == contained || $.contains(container, contained);
  },
  remove: function remove() {
    var menu = this.getMenu();
    menu.remove();
    _MDMenuItemView["default"].prototype.remove.call(this);
  }
}, {
  MENU_DELAY: 100
});
var _default = exports["default"] = MDSubMenuView;

},{"1184":1184,"1454":1454,"22":22,"51":51}],52:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMViewBase = _interopRequireDefault(require(22));
/**
 *  Menu view
 *
 *  Created by manjun.han
 *  2016.1.21
 */

var MDMenuSeperatorView = _MMViewBase["default"].extend({
  el: '<div class="menu-seperator"></div>',
  /**
   *
   * opt = {
   *    caption:'The item's caption'
   * };
   *
   */
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
  },
  isEnabled: function isEnabled() {
    return true;
  }
}, {
  className: 'MDMenuSeperatorView'
});
var _default = exports["default"] = MDMenuSeperatorView;

},{"1184":1184,"1454":1454,"22":22}],336:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1498);
require(1417);
require(1463);
var _MMViewBase = _interopRequireDefault(require(22));
var _MDMessageInputAreaView = _interopRequireDefault(require(331));
var _MDMReplyPageView = _interopRequireDefault(require(358));
var _app = _interopRequireDefault(require(17));
var _MDReplyVisibleScopeListView = _interopRequireDefault(require(428));
var _MMBasicData = _interopRequireDefault(require(811));
var _MMSketchCommentController = _interopRequireDefault(require(885));
var _popupPos = _interopRequireDefault(require(65));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDMPopupManager = _interopRequireDefault(require(357));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
/**
 *  Create by Tobias
 *  2015.02.03
 *
 *  Modified by manjun.han 16.7.20
 */

var MDPanelChatInputView = _MMViewBase["default"].extend({
  tmpl: "<div id=\"msgIputSlot\"></div>\n          <div class=\"scribble-placeholder\">\n            <div class=\"flex-align between center\">\n              <div><span class=\"icon scribble\"></span><%=attached%></div>\n              <span class=\"icon close\"></span>\n            </div>\n          </div>\n          <div id=\"footerBar\" class=\"toolbar\">\n            <div class=\"toolbar-inner flex-align between middle\">\n              <div>\n                <button class=\"visibleScopeBtn\">\n                  <span><%=all%></span>\n                  <i class=\"button-icon selectBoxSmall\"></i>\n                </button>\n                <span id=\"js-upload-file\" class=\"icon ic-attach\" data-tooltip=\"<%=fileTrans%>\" data-tooltip-dir=\"top\"></span>\n                <span id=\"js-scribble-btn\" class=\"icon scribble addScribbleBtn\" data-tooltip=\"<%=scribble%>\" data-tooltip-dir=\"top\"></span>\n              </div>\n              <button class=\"button main small send-btn\"><%=send%></button>\n            </div>\n        </div>",
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      shouldChatControllHeight: 0,
      comment: null,
      view: null,
      onSendText: _.noop,
      onFocus: _.noop,
      onFileUploadAction: _.noop
    });
  },
  className: function className() {
    var superCls = _MMViewBase["default"].prototype.className.call(this);
    return superCls + ' m-chat-input';
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    var selfE = _.extend(superE, {
      'click #js-scribble-btn': this._openScribbleView,
      'click #js-upload-file': this._uploadFileClickHandler,
      'mousedown .visibleScopeBtn': this._displayVisibleScope,
      'click .scribble-placeholder .close': this._removeScribble,
      'click .scribble-placeholder': this._displayScribble,
      'click .send-btn': this._sendBtnClickHandler
    });
    return selfE;
  },
  initialize: function initialize(options) {
    options.data = _.extend({
      'attached': BabelStr.str(463),
      // 你附加了图文批注
      'all': BabelStr.str(572),
      // 此回复所有人可见
      'fileTrans': BabelStr.str(325),
      // 文件传输
      'scribble': BabelStr.str(130),
      // 手绘批注
      'send': BabelStr.str(406) // 发送
    }, options.data);
    var self = this;
    _MMViewBase["default"].prototype.initialize.call(this, options);
    self.$('.send-btn').prop('disabled', true);
    this.messageAreaInputView = new _MDMessageInputAreaView["default"]({
      comment: this.comment,
      editorViewCtl: this.editorViewCtl,
      parent: this,
      maxLineCount: 5,
      fontSize: 13,
      enterSubmit: true,
      disabled: this.inputDisabled,
      imgMarkerCtl: this.imgMarkerCtl,
      onInputChange: function onInputChange(text) {
        if (text.length == 0) {
          self.$('.send-btn').prop('disabled', true);
        } else {
          self.$('.send-btn').prop('disabled', false);
        }
      },
      onEnterSend: function onEnterSend(text, atIds) {
        self.sendText(text, atIds);
      },
      onFocus: function onFocus() {
        if (_.isFunction(self.onFocus)) {
          self.onFocus();
        }
        var logined = _app["default"].currentUser.logined();
        if (!logined) {
          _app["default"].popupInnerLogin();
          return;
        }
      }
    });
    this.addSubView(this.messageAreaInputView, this.$('#msgIputSlot'), true);
    if (!_app["default"].canDispInNormalBrowser()) {
      this.$('.scribbleDisplayView').remove();
      this.messageAreaInputView.$el.on('click', function () {
        var logined = _app["default"].currentUser.logined();
        if (!logined) {
          _app["default"].popupInnerLogin();
          return;
        }
        self.messageAreaInputView.blur();
        var chatInputView = new _MDMReplyPageView["default"]({
          title: BabelStr.str(573),
          // "回复批注",
          onConfirm: function onConfirm() {
            var text = chatInputView.getVal();
            text = $.trim(text);
            if (text.length > 0) {
              self.sendText(text, []);
            }
            _MDMPopupManager["default"].dismissView(chatInputView);
          }
        });
        _MDMPopupManager["default"].presentView(chatInputView);
      });
    }
    var isCad = this.comment.getBoard().fileInfo.isCADFile();
    var commentClass = this.comment.m_className;
    if (isCad || commentClass == 'MD3DComment' || commentClass == 'MDHtmlComment' || commentClass == 'MDRectHtmlComment' || commentClass == 'MDArrowHtmlComment') {
      this.$el.find('#js-scribble-btn').hide();
    }
    ;
    this.visibleScope = 0;
    if (this.comment.isEvalComment()) {
      this.visibleScope = this.comment.getVisibleScope();
    }
    if (!_app["default"].isEpVersion() || _app["default"].currentUser.isEnterpriseGuest() || this.comment.getVisibleScope() || !_MDPcMobileEditorCommonFun["default"].currentFileBelongsToCurUserEnterprise()) {
      this.$el.find('.visibleScopeBtn').css('display', 'none');
    }
    ;
  },
  _displayScribble: function _displayScribble() {
    var self = this;
    var marker = this.imgMarkerCtl.getSingleInstance();
    var obj = this.view ? this.view.getPicObject() : _MDPcMobileEditorCommonFun["default"].getMainEditor().getPicObject();
    var swfEditor = false;
    if (this.view && this.view.getClassName() == "MDSWFEditor") {
      swfEditor = true;
    }
    var opt = {
      swfEditor: swfEditor,
      isOpenOldScribble: true,
      editorViewCtl: this.editorViewCtl
    };
    marker.displayToEdit(obj, opt, function () {
      // self.update();
    });
  },
  _sendBtnClickHandler: function _sendBtnClickHandler() {
    var text = this.messageAreaInputView.getText();
    var atIds = this.messageAreaInputView.getAtIds();
    this.sendText(text, atIds);
  },
  _uploadFileClickHandler: function _uploadFileClickHandler() {
    if (_app["default"].currentUser.logined()) {
      this.onFileUploadAction();
    } else {
      _app["default"].popupInnerLogin();
    }
  },
  _openScribbleView: function _openScribbleView() {
    var self = this;
    if (_app["default"].currentUser.logined()) {
      var marker = this.imgMarkerCtl.getSingleInstance();
      var swfEditor = false;
      if (this.view && this.view.getClassName() == "MDSWFEditor") {
        swfEditor = true;
      }
      var opt = {
        comment: this.comment,
        swfEditor: swfEditor,
        editorViewCtl: this.editorViewCtl
      };
      var obj = this.view ? this.view.getPicObject() : _MDPcMobileEditorCommonFun["default"].getMainEditor().getPicObject();
      marker.displayToEdit(obj, opt, function () {
        if (self.hasSketch()) {
          self.$el.addClass('has-scribble');
          self.$('.send-btn').prop('disabled', false);
        }
      });
    } else {
      _app["default"].popupInnerLogin();
    }
    return false;
  },
  _removeScribble: function _removeScribble($e) {
    var _allObjects = _MMSketchCommentController["default"].getAllObjects();
    var _actionManager = this.editorViewCtl.getCurrentBoard().m_actionManager;
    if (_actionManager) {
      _actionManager.deleteObjects(_allObjects, {
        toUndo: false,
        realtime: false,
        isMark_: true
      });
    }
    ;
    this.$el.removeClass('has-scribble');
    this.$('.send-btn').prop('disabled', true);
    return false;
  },
  hasSketch: function hasSketch() {
    return _MMSketchCommentController["default"].getAllObjects().length >= 1;
  },
  sendText: function sendText(text, atIds) {
    var self = this;
    if (!text && !this.hasSketch()) {
      return;
    }
    function onSuccess() {
      self.messageAreaInputView.setText('');
      self.messageAreaInputView.setAtObjEmpty();
      self._removeScribble();
    }
    function onFail() {
      _MDSnackbarView["default"].showStandardMsg(3);
    }
    var editor = this.editorViewCtl.getCurEditor();
    this.comment.curScale = editor.getScale();
    this.comment.centerPos = editor.getCenterRatioPosition();
    _czc && _czc.push(["_trackEvent", "讨论", "回复批注信息", "回复批注", "", "#submitButton"]);
    _MMSketchCommentController["default"].sendText(text, atIds, this.visibleScope, this.comment, onSuccess, onFail); // 统计标记个数
  },
  _displayVisibleScope: function _displayVisibleScope(e) {
    if (this.scopeList) {
      this.scopeList.remove();
      this.scopeList = null;
      return;
    }
    this.scopeList = new _MDReplyVisibleScopeListView["default"]();
    var z_startIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
    this.scopeList.$el.css("z-index", z_startIndex);
    var self = this;
    this.scopeList.show({
      triggerView: e.currentTarget,
      center: true,
      direction: _popupPos["default"].TOP_LEFT,
      width: 300,
      onClose: function onClose() {
        if (self.scopeList) {
          var select = self.scopeList.scopeSelected;
          self.visibleScope = select;
          self.$el.find('.visibleScopeBtn span').text(self.scopeList.getDispString());
        }
        ;
        self.scopeList = null;
      }
    });
  },
  viewWillUnRendered: function viewWillUnRendered() {
    _MMViewBase["default"].prototype.viewWillUnRendered.call(this);
    this._removeScribble();
  },
  getVisibleScope: function getVisibleScope() {
    return this.visibleScope;
  }
});
var _default = exports["default"] = MDPanelChatInputView;

},{"1184":1184,"1417":1417,"1454":1454,"1463":1463,"1498":1498,"17":17,"22":22,"331":331,"357":357,"358":358,"428":428,"65":65,"72":72,"807":807,"811":811,"885":885}],428:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDPopupView = _interopRequireDefault(require(64));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
/**
 *  Menu for comment reply visible scopes choices
 *  Create by jiang
 *  2016.12.10
 */

var MDReplyVisibleScopeListView = _MDPopupView["default"].extend({
  contentTmpl: '<ul class="m-menu"></ul>',
  events: function events() {
    var superEvents = _MDPopupView["default"].prototype.events.call(this);
    return _.extend({}, superEvents, {
      'click li': this._menuItemClickHandler
    });
  },
  initProps: function initProps() {
    var superP = _MDPopupView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      scopeSelected: -1,
      $scopeList: null,
      scopeNameList: [],
      parentDiv: $('.app-root')[0]
    });
  },
  initialize: function initialize(opt) {
    _MDPopupView["default"].prototype.initialize.call(this, opt);
    this.initScopeList();
  },
  initScopeList: function initScopeList() {
    var fileEditor = _MDPcMobileEditorCommonFun["default"].getMainEditor().getCurFileEditor();
    this.scopeNameList = MDReplyVisibleScopeListView.visibleScopes;
    if (this.$scopeList) {
      this.$scopeList.remove();
    }
    var html = "";
    for (var i = 0; i < this.scopeNameList.length; i++) {
      var scopeName = this.scopeNameList[i];
      html += "<li >" + scopeName + "</li>";
    }
    ;
    this.$(".m-menu").append(html);
    this.$scopeList = $(html);
    this.title = this.scopeNameList[0];
  },
  _menuItemClickHandler: function _menuItemClickHandler($e) {
    var index = $($e.target).index();
    this.scopeSelected = -1;
    if (index < this.scopeNameList.length) {
      this.scopeSelected = index;
      this.title = this.scopeNameList[index];
    }
    ;
    this.close();
  },
  getDispString: function getDispString() {
    return this.title;
  }
}, {
  // visibleScopes: ['此回复所有人可见', '此回复仅企业内人员可见']
  visibleScopes: [BabelStr.str(572), BabelStr.str(574)]
});
var _default = exports["default"] = MDReplyVisibleScopeListView;

},{"1184":1184,"1454":1454,"64":64,"807":807}],358:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1498);
var _MDMPageView = _interopRequireDefault(require(356));
var _MMBasicData = _interopRequireDefault(require(811));
var _MDMBarButtonItemView = _interopRequireDefault(require(351));
var _MDMPopupManager = _interopRequireDefault(require(357));
/**
 *  Create by manjun.han
 *  date here(2015.6.24)
 */

var MDMReplyPageView = _MDMPageView["default"].extend({
  className: function className() {
    var superCls = _MDMPageView["default"].prototype.className.call(this);
    return superCls + ' pop-page';
  },
  pageContentTmpl: '<textarea class="text-area clear-appearance" placeholder="' + BabelStr.str(7113) + '..."></textarea>' + '<div class="section">' + '<span class="f-fr"></span><span class="remain"><%=totalLength%></div>',
  initProps: function initProps() {
    var superP = _MDMPageView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      title: BabelStr.str(573),
      onConfirm: _.noop,
      isPopup: true
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    opt = _.extend({
      title: BabelStr.str(7111),
      data: {
        'totalLength': this.totalLength
      }
    }, opt);
    _MDMPageView["default"].prototype.initialize.call(this, opt);
    var zIndex = _MMBasicData["default"].getEditorMaxZ_index();
    this.$el.css('z-index', zIndex);
    var cancelBarButtonItem = new _MDMBarButtonItemView["default"]({
      barButtonRenderer: '<button class="">' + BabelStr.str(155) + '</button>',
      barButtonItemAction: function barButtonItemAction() {
        _MDMPopupManager["default"].dismissView(self);
      }
    });
    this.addLeftBarButtonItem(cancelBarButtonItem);
    var confirmBarButtonItem = new _MDMBarButtonItemView["default"]({
      barButtonRenderer: '<button class="">' + BabelStr.str(154) + '</button>',
      barButtonItemAction: function barButtonItemAction() {
        if (_.isFunction(self.onConfirm)) {
          self.onConfirm();
        }
      }
    });
    this.addRightBarButtonItem(confirmBarButtonItem);
  },
  getVal: function getVal() {
    return this.$("textarea").val().trim();
  }
});
var _default = exports["default"] = MDMReplyPageView;

},{"1184":1184,"1454":1454,"1498":1498,"351":351,"356":356,"357":357,"811":811}],324:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
var _MMViewBase = _interopRequireDefault(require(22));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDCommentActionManager = _interopRequireDefault(require(5));
/**
 *  在批注面板展示评审意见的处理状态
 *  WebContent/javascript/moladisk/common/MDEvaluationOpinionBar.js
 *  Created by jiang
 *  2019.3.5
 */

var MDEvaluationOpinionBar = _MMViewBase["default"].extend({
  el: '<div class="inline"></div>',
  tmpl: "<div class=\"inline\">\n          <div class=\"sec radio-group pd-10\">\n            <div class=\"setting-item mgb-10 radio-box\" data-type=\"2\"><%=BabelStr.str(806)%></div>\n            <div class=\"setting-item mgb-10 radio-box \" data-type=\"3\"><%=BabelStr.str(811)%></div>\n          </div>\n          <div class=\"eval-mark\">\n            <div class=\"sec eval-opnion inline\"></div>\n          </div>\n        </div>",
  className: function className() {
    var superCls = _MMViewBase["default"].prototype.className.call(this);
    return superCls + ' m-eval-bar';
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      comment: null,
      // ------------------- MMCommentObj
      evalFlow: null // ------------------- 流程
    });
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click .radio-box': this._clickRadioHandler
    });
  },
  initialize: function initialize(opt) {
    var _this = this;
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.$('.sec').hide();
    this.$('.setting-item').removeClass('checked');
    var curUserEval = this.evalFlow.getCurrentUserEvaluation();
    var curUserIsCreator = this.evalFlow.isCurUserCreator();
    var curUserGroupIndex = this.evalFlow.getCurrentUserGroupIndex();
    var curStep = this.evalFlow.getCurStep();
    var fileId = this.fileInfo.getFileId();
    var id = this.comment.getId().toString();
    _MDCommentActionManager["default"].getEvalStatus(id, function (status) {
      if (curUserIsCreator) {
        _this.$(".radio-group").show();
        _this.$(".eval-mark").remove();
        if (status == 2) {
          $(_this.$('.setting-item')[0]).addClass('checked');
        } else if (status == 3) {
          $(_this.$('.setting-item')[1]).addClass('checked');
        }
      } else {
        _this.$(".radio-group").remove();
        _this.$(".eval-opnion").css("display", "inline-block");
        var str = BabelStr.str(812);
        if (status == 2) {
          str = BabelStr.str(807);
          _this.$(".eval-opnion").addClass("eval-acc");
        } else if (status == 3) {
          str = BabelStr.str(808);
          _this.$(".eval-opnion").addClass("eval-rej");
        }
        _this.$(".eval-opnion").text(str);
      }
    }, function () {
      _MDSnackbarView["default"].show(BabelStr.str(168));
    });
  },
  _clickRadioHandler: function _clickRadioHandler(e) {
    var _this2 = this;
    this.$(".radio-box").removeClass("checked");
    $(e.target).addClass("checked");
    var val = $(e.target).data("type");
    var oldVal = this.option;
    if (oldVal != val) {
      this.option = val;
      var id = this.comment.getId().toString();
      var fileId = this.fileInfo.getFileId();
      _MDCommentActionManager["default"].setEvalStatus(fileId, id, val, function () {
        _MDSnackbarView["default"].show(BabelStr.str(308));
      }, function () {
        _this2.option = oldVal;
        _MDSnackbarView["default"].show(BabelStr.str(168));
        $(e.target).removeClass("checked");
      });
    }
    console.log("--------> " + $(e.target).data("type"));
  }
});
var _default = exports["default"] = MDEvaluationOpinionBar;

},{"1184":1184,"1437":1437,"1454":1454,"1463":1463,"1478":1478,"22":22,"5":5,"72":72}],5:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require(1197));
require(1437);
require(1463);
require(1478);
require(1461);
require(1466);
var _MDHtmlComment = _interopRequireDefault(require(219));
var _MDArrowHtmlComment = _interopRequireDefault(require(216));
var _MDRectHtmlComment = _interopRequireDefault(require(223));
var _MD3DComment = _interopRequireDefault(require(6));
var _MMWhiteboardController = _interopRequireDefault(require(1109));
var _int = _interopRequireDefault(require(820));
var _MMChatMessage = _interopRequireDefault(require(950));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDEvents = _interopRequireDefault(require(325));
var _OBJ_ID = _interopRequireDefault(require(818));
var _MDConnector = _interopRequireDefault(require(1089));
var _MMCommentDataController = _interopRequireDefault(require(1097));
var _CommentStatus = _interopRequireDefault(require(1036));
// MDCommentActionManager.js
// jiang created, mshx implemented
// 2016-9-2

function MDCommentActionManager(options) {
  this.fileId = options.fileId;
  console.assert(this.fileId, 'missing fileId');
}
;
MDCommentActionManager.prototype = {
  constructor: MDCommentActionManager,
  request: function request(route, params, callback) {
    console.assert(this.fileId, 'missing fileId'); //is this manager already destroyed?
    params['fileId'] = this.fileId;
    _MDConnector["default"].request(route, params, callback);
  },
  //handleIncommingMessage: function (message) {
  //  if (message.fileId != this.fileId) return;
  //  if (this.actionHandler) this.actionHandler.call(null, message);
  //},

  updateComment: function updateComment(md3DComment, success, fail) {
    console.assert(md3DComment.id instanceof _OBJ_ID["default"]);
    this.request('collaborate.glCollaborateHandler.setComment', {
      'commentId': md3DComment.id.toString(),
      'comment': JSON.parse(JSON.stringify(md3DComment.encode())) // have a classFreeObject
    }, function (response) {
      if (MDCommentActionManager.isSuccessfullResponse(response)) {
        if (success) success();
      } else {
        if (fail) fail();
      }
    });
  },
  addComment: function addComment(md3DComment, success, fail) {
    this.updateComment(md3DComment, success, fail);
  },
  removeComment: function removeComment(md3DCommentId, success, fail) {
    this.request('collaborate.glCollaborateHandler.removeComment', {
      'commentId': md3DCommentId
    }, function (response) {
      if (MDCommentActionManager.isSuccessfullResponse(response)) {
        if (success) success();
      } else {
        if (fail) fail();
      }
    });
  },
  replyComment: function replyComment(versionShowing, visibleScope, md3DCommentId, commentContent, success, fail) {
    if (typeof commentContent == 'string') {
      //the commentcontent should be a JSON-String
      JSON.parse(commentContent);
    } else if ((0, _typeof2["default"])(commentContent) == 'object') {
      commentContent = JSON.stringify(commentContent);
    } else {
      console.error(commentContent);
      throw new Error('invalid commentContent');
    }
    this.request('collaborate.glCollaborateHandler.replyComment', {
      'version': versionShowing,
      'visibleScope': visibleScope,
      'commentId': md3DCommentId,
      'commentContent': commentContent
    }, function (response) {
      if (MDCommentActionManager.isSuccessfullResponse(response)) {
        if (success) success(response['messageId']);
      } else {
        if (fail) fail();
      }
    });
  },
  commentReaded: function commentReaded(commentId, success, fail) {
    commentId = _.isString(commentId) ? commentId : commentId.getId().toString();
    this.request('collaborate.glCollaborateHandler.readComment', {
      'commentId': commentId
    }, function (response) {
      if (MDCommentActionManager.isSuccessfullResponse(response)) {
        if (success) success();
      } else {
        if (fail) fail();
      }
    });
  },
  setCompleted: function setCompleted(md3DCommentId, completed, success, fail) {
    this.request('collaborate.glCollaborateHandler.setCommentCompleted', {
      'commentId': md3DCommentId,
      'completed': !!completed
    }, function (response) {
      if (MDCommentActionManager.isSuccessfullResponse(response)) {
        if (success) success();
      } else {
        if (fail) fail();
      }
    });
  },
  getAllComments: function getAllComments(success, fail) {
    this.request('collaborate.glCollaborateHandler.getAllComments', {}, function (response) {
      if (MDCommentActionManager.isSuccessfullResponse(response)) {
        if (success) success(response['comments']);
      } else {
        if (fail) fail();
      }
    });
  },
  // 与旧代码兼容，用于删除手绘批注， 3D 目前没有手绘批注
  deleteObjects: function deleteObjects() {},
  destroy: function destroy() {
    this.fileId = null;
    _MDConnector["default"].off('3DCollabMessage', this.handleIncommingMessage);
  }
};
MDCommentActionManager.isSuccessfullResponse = function (response) {
  return response['resultCode'] === 0;
};
MDCommentActionManager.handleIncommingMessage = function (message) {
  //{
  //  type: 'setComment',
  //    fileId: fileId,
  //  senderId: userId,
  //  commentId: commentId,
  //  comment: comment,
  //  newComment: newComment
  //}
  console.log(message);
  var curBoard = _MMWhiteboardController["default"].findBoardInBuffer(message['fileId']);
  var comment, commentId;
  if (curBoard) {
    if (message['type'] == 'setComment') {
      if (message['newComment'] == true) {
        var className = message['comment']['className'];
        if (className == "MDRectHtmlComment") {
          comment = new _MDRectHtmlComment["default"]();
        } else if (className == "MDArrowHtmlComment") {
          comment = new _MDArrowHtmlComment["default"]();
        } else if (className == "MDHtmlComment") {
          comment = new _MDHtmlComment["default"]();
        } else {
          comment = new _MD3DComment["default"]();
        }
        comment.setBoard(curBoard);
        comment.decode(message['comment']);
        curBoard.addComment_Local(comment);
        _Dispatcher["default"].trigger(_MDEvents["default"].Comment_changed, null);
      }
    } else if (message['type'] == 'removeComment') {
      commentId = new _OBJ_ID["default"]();
      commentId.fromString(message['commentId']);
      curBoard.deleteComment_Local(commentId);
      _Dispatcher["default"].trigger(_MDEvents["default"].Comment_changed, null);
    } else if (message['type'] == 'replyComment') {
      commentId = new _OBJ_ID["default"]();
      commentId.fromString(message['commentId']);
      comment = curBoard.getObject(commentId);
      _MMCommentDataController["default"].getCommentReadSatus(commentId.toString(), function (unreadCount) {
        var messageId = message.messageId || 0;
        comment.setReadStatus(unreadCount ? _CommentStatus["default"].Comment_newReply : _CommentStatus["default"].Comment_read);
        var senderId = new _int["default"](parseInt(message['senderId']));
        var payload = {
          comment: comment,
          sender: senderId,
          message: new _MMChatMessage["default"](new _int["default"](messageId), senderId, 0, new Date().getTime(), message['senderName'], message['commentContent'], commentId)
        };
        if (message['senderId'] != app.currentUser.getUserId()) {
          _Dispatcher["default"].trigger(_MDEvents["default"].NEW_MESSAGE, payload);
        }
        ;
      }, function () {});
    }
  }
};
MDCommentActionManager.setEvalStatus = function (fileId, commentId, status, success, fail) {
  var route = "collaborate.collaborateHandler.answerEvaluationComment";
  var params = {
    fileId: fileId,
    commentId: commentId,
    completed: status
  };
  _MDConnector["default"].request(route, params, function (response) {
    if (MDCommentActionManager.isSuccessfullResponse(response)) {
      if (success) success();
    } else {
      if (fail) fail();
    }
  });
};
MDCommentActionManager.getEvalStatus = function (commentId, success, fail) {
  var route = "collaborate.collaborateHandler.getCommentInfo";
  var params = {
    commentId: commentId
  };
  _MDConnector["default"].request(route, params, function (response) {
    if (MDCommentActionManager.isSuccessfullResponse(response)) {
      if (success) success(response["comment"]["completed"]);
    } else {
      if (fail) fail();
    }
  });
};
_MDConnector["default"].on('3DCollabMessage', MDCommentActionManager.handleIncommingMessage);
var _default = exports["default"] = MDCommentActionManager;

},{"1036":1036,"1089":1089,"1097":1097,"1109":1109,"1184":1184,"1197":1197,"1437":1437,"1454":1454,"1461":1461,"1463":1463,"1466":1466,"1478":1478,"18":18,"216":216,"219":219,"223":223,"325":325,"6":6,"818":818,"820":820,"950":950}],1109:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1432);
require(1463);
require(1471);
require(1424);
var _MDCommentsFile = _interopRequireDefault(require(7));
var _MMNetDiskDiscussionBoard = _interopRequireDefault(require(1086));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MMCollaborationManager = _interopRequireDefault(require(1096));
var _MDVirtualBoard = _interopRequireDefault(require(97));
var _MMImage = _interopRequireDefault(require(1016));
var _MMPDFDocument = _interopRequireDefault(require(1021));
//
//  管理打开的白板数组
//
//  created  by jiang
//  2015-8-28
//

//
//  类结构图 - 白板数据控制
//
//  类结构如下（+ 代表包含一个， ++ 代表包含一个或多个）：
//
//  MMWhiteboardController
//           |
//           ++——  MMNetDiskDiscussionBoard
//           |
//           ++--  MDCommentsFile
//           |          |
//           |          +--- MMFileInfo
//           |          |
//           |          ++-- MD3DComment
//           |          |
//           -          -

var MMWhiteboardController = {
  boardBuffer: [],
  openWhiteboardsByFiles: function openWhiteboardsByFiles(arrFileInfo, success, fail, progress) {
    var count = arrFileInfo.length;
    var finished = 0;
    var boardsOpened = [];
    MMWhiteboardController.openBoardOneByOne(arrFileInfo, 0, boardsOpened, success, fail, progress);
  },
  openBoardOneByOne: function openBoardOneByOne(arrFileInfo, index, boardsOpened, success, fail, progress) {
    var that = MMWhiteboardController;
    var count = arrFileInfo.length;
    if (index < count) {
      var i = index;
      MMWhiteboardController.openWhiteboardByFileInfo(arrFileInfo[i], -1, function boardLoaded(board) {
        boardsOpened.push(board);
        if (progress) {
          progress((index + 1) / count);
        }
        that.openBoardOneByOne(arrFileInfo, index + 1, boardsOpened, success, fail, progress);
      }, function loadFailed() {
        if (progress) {
          progress((index + 1) / count);
        }
        that.openBoardOneByOne(arrFileInfo, index + 1, boardsOpened, success, fail, progress);
        if (fail) {
          fail();
        }
      });
    } else {
      if (success) {
        success(boardsOpened);
      }
    }
    if (progress) {
      progress(index / count);
    }
  },
  closeAll: function closeAll() {
    for (var i = 0; i < MMWhiteboardController.boardBuffer.length; i++) {
      var board = MMWhiteboardController.boardBuffer[i];
      _MMCollaborationManager["default"].leave(board);
      var fileInfo = board.getFileInfo();
      fileInfo.setBoard(null);
      board.setFileInfo(null);
    }
    var length = MMWhiteboardController.boardBuffer.length;
    MMWhiteboardController.boardBuffer.splice(0, length);
  },
  openWhiteboardByFileId: function openWhiteboardByFileId(fileId, success, fail) {
    var board = MMWhiteboardController.findBoardInBuffer(fileId);
    if (!board) {
      _MMNetDiskDataController["default"].getFileInfoByFileId(fileId, function (fileInfo) {
        MMWhiteboardController.openWhiteboardByFileInfo(fileInfo, -1, success, fail);
      });
    } else if (success) {
      setBabelTimeout(function () {
        success(board);
      }, 0);
    }
  },
  openWhiteboardByFileInfo: function openWhiteboardByFileInfo(fileInfo, ver, cb, fail) {
    var success = function success(board) {
      if (board && board.getScribblesFromSever) {
        ver = ver - 0;
        board.getScribblesFromSever(ver, board, function suc() {
          // board.registerFindController();
          cb(board);
        }, function () {
          fail();
        });
      } else {
        cb(board);
      }
    };
    var createVirtualBoard = function createVirtualBoard() {
      var newboard = new _MDVirtualBoard["default"](fileInfo.getFileId());
      newboard.setFileInfo(fileInfo);
      fileInfo.setBoard(newboard);
      newboard.setDisplayName(fileInfo.getFileName());
      MMWhiteboardController.boardBuffer.push(newboard);
      fileInfo.markVirtualBoard();
      if (success) {
        success(newboard);
      }
    };
    var board = MMWhiteboardController.findBoardInBuffer(fileInfo.getFileId());
    if (!board) {
      if (fileInfo) {
        var watermarkPromise = new Promise(function (pass, rejected) {
          if (fileInfo.isVideo() || fileInfo.isAudio()) {
            pass();
          } else if (fileInfo.preWatermark) {
            pass();
          } else {
            fileInfo.preWatermark = true;
            var fid = app.isShareApp ? app.pathRouter.rootFileId : fileInfo.getFileId();
            MMEnterpriseController.isFileNeedWatermarkPreview(fid, function (data) {
              fileInfo.set("watermarkInfo", data);
              pass();
            });
          }
        });
        watermarkPromise.then(function () {
          if (fileInfo.canDispInWebBrowser() || fileInfo.canDispInOpenGL()) {
            var board = new _MDCommentsFile["default"](fileInfo.getFileId());
            board.setFileInfo(fileInfo);
            fileInfo.setBoard(board);
            board.setDisplayName(fileInfo.getFileName());
            MMWhiteboardController.boardBuffer.push(board);
            if (success) {
              _MMCollaborationManager["default"].join3D(board, function finished() {
                board.m_actionManager.getAllComments(function (response) {
                  board.initData(response);
                  success(board);
                });
              }, function loadFailed(e) {
                console.error("链接 3D 消息发送机制失败");
                if (fail) {
                  fail(e);
                }
              });
            }
          } else if (!fileInfo.dispNeedWhiteBoard()) {
            createVirtualBoard();
          } else {
            // if (success) {
            // success(board, true);
            // board.getScribblesFromSever(-1, function suc(){
            //   // board.registerFindController();
            // let imgObj = new MMImage(null)
            // imgObj.setFileVersion(fileInfo.getCurVersion())
            // imgObj.initWithWihteBoard(board)
            // board.addInitObject(imgObj)
            // success(board);
            // }, function(){
            //   fail();
            // })
            // };
            var loadFailed = function loadFailed(errorCode) {
              if (fileInfo.isImage() || fileInfo.getLinkFileUrl()) {
                fileInfo.setOnlyDisp(true);
                var imgObj = new _MMImage["default"](null);
                imgObj.setFileVersion(fileInfo.getCurVersion());
                imgObj.initWithWihteBoard(board);
                board.addInitObject(imgObj);
                success(board);
                return;
              }
              if (fileInfo.isPdf()) {
                fileInfo.setOnlyDisp(true);
                var pdfObj = new _MMPDFDocument["default"](board);
                success(board);
                return;
              }
              if (fileInfo.isOfficeFile()) {
                fileInfo.setOnlyDisp(true);
                success(board);
                return;
              }
              if (fileInfo.isSVGFile()) {
                createVirtualBoard();
              } else {
                if (fail) {
                  fail(errorCode);
                }
              }
            };
            var board = new _MMNetDiskDiscussionBoard["default"](fileInfo.getFileId(), fileInfo.get("ownerId"));

            // initialize file information to board
            board.setDisplayName(fileInfo.getFileName());
            board.setCurVersion(fileInfo.getCurVersion());
            board.setLatestVersion(fileInfo.get("latestVer"));
            // board.setVersionShowing(fileInfo.getCurVersion());
            board.setFileInfo(fileInfo);
            fileInfo.setBoard(board);
            MMWhiteboardController.boardBuffer.push(board);
            if (fileInfo.getLinkFileUrl()) {
              loadFailed();
              return;
            }
            _MMCollaborationManager["default"].join(board, function finished() {
              if (success) {
                success(board);
                // board.getScribblesFromSever(
                //   ver,
                //   function suc() {
                //     // board.registerFindController();
                //     success(board);
                //   },
                //   function () {
                //     fail();
                //   }
                // );
              }
            }, loadFailed);
          }
        });
      }
    } else if (success) {
      setBabelTimeout(function () {
        success(board);
      }, 0);
    }
  },
  rejoinBoard: function rejoinBoard(board, success, fail) {
    if (board instanceof _MDCommentsFile["default"]) {
      _MMCollaborationManager["default"].join3D(board, function finished() {
        success && success();
      }, function loadFailed(e) {
        if (fail) {
          fail(e);
        }
      });
    } else if (board instanceof _MMNetDiskDiscussionBoard["default"]) {
      _MMCollaborationManager["default"].join(board, function finished() {
        if (success) {
          success();
        }
      }, function loadFailed(ecode) {
        if (fail) {
          fail(ecode);
        }
      });
    }
  },
  findBoardInBuffer: function findBoardInBuffer(fileId) {
    for (var i = 0; i < MMWhiteboardController.boardBuffer.length; i++) {
      var board = MMWhiteboardController.boardBuffer[i];
      if (board.getStringId() == fileId) {
        return board;
      }
    }
    return null;
  },
  clearBoardBufferByFileId: function clearBoardBufferByFileId(fileId) {
    for (var i = 0; i < MMWhiteboardController.boardBuffer.length; i++) {
      var board = MMWhiteboardController.boardBuffer[i];
      if (board.getStringId() == fileId) {
        MMWhiteboardController.boardBuffer.splice(i, 1);
        break;
      }
    }
  },
  closeWhiteboard: function closeWhiteboard(fileId) {
    for (var i = 0; i < MMWhiteboardController.boardBuffer.length; i++) {
      var board = MMWhiteboardController.boardBuffer[i];
      if (board.getStringId() == fileId) {
        _MMCollaborationManager["default"].leave(board);
        MMWhiteboardController.boardBuffer.splice(i, 1);
        break;
      }
    }
  },
  getOpenedBoards: function getOpenedBoards() {
    return MMWhiteboardController.boardBuffer;
  }
};
window.MMWhiteboardController = MMWhiteboardController;
var _default = exports["default"] = MMWhiteboardController;

},{"1016":1016,"1021":1021,"1086":1086,"1096":1096,"1104":1104,"1184":1184,"1424":1424,"1432":1432,"1454":1454,"1463":1463,"1471":1471,"7":7,"97":97}],1096:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
require(1439);
require(1410);
require(1411);
require(1423);
require(1530);
require(1505);
require(1506);
require(1507);
require(1508);
require(1510);
require(1509);
require(1512);
require(1513);
require(1514);
require(1516);
require(1517);
require(1518);
require(1519);
require(1521);
require(1520);
require(1522);
require(1523);
require(1524);
require(1525);
require(1526);
require(1527);
require(1528);
require(1529);
require(1421);
require(1424);
var _Dispatcher = _interopRequireDefault(require(18));
var _MDConnector = _interopRequireDefault(require(1089));
var _MMSendActionMessage = _interopRequireDefault(require(853));
var _MMSendActionRespMessage = _interopRequireDefault(require(855));
var _MMJoinCollabMessage = _interopRequireDefault(require(845));
var _MMWhiteboardController = _interopRequireDefault(require(1109));
var _int = _interopRequireDefault(require(820));
var _Encoder = _interopRequireDefault(require(800));
var _MMWhiteboard = _interopRequireDefault(require(960));
var _Decoder = _interopRequireDefault(require(799));
var _MMMessage = _interopRequireDefault(require(1079));
var _MMAction = _interopRequireDefault(require(963));
var _MMTaskBoard = _interopRequireDefault(require(959));
/*
 */

var MMCollaborationManager = {
  m_curSession: null,
  m_allSessions: null,
  m_msgIndex: 100,
  initiate: function initiate() {
    MMCollaborationManager.m_whiteboards = {};
    MMCollaborationManager.m_whiteboardArray = [];
    var that = this;
    pomelo.on('onJoin', function (response) {
      try {
        console.log("pomelo:user id" + response['uid'] + "join collaboration " + response['cid'].toString());
      } catch (e) {
        console.log(e.name + ":" + e.message);
      }
    });
    pomelo.on('onLeave', function (response) {
      try {
        console.log("pomelo:user id" + response['uid'] + "leave collaboration " + response['cid'].toString());
      } catch (e) {
        console.log(e.name + ":" + e.message);
      }
    });
    pomelo.on('onAction', function (res) {
      try {
        setBabelTimeout(function () {
          console.log("pomelo:user id" + res['uid'] + "receive new action of  collaboration " + res['cid'].toString());
          if (!res['payload']) return;
          var result = new ArrayBuffer(res['payload'].length);
          new Uint8Array(result).set(res['payload']);
          var curBoard = _MMWhiteboardController["default"].findBoardInBuffer(res.cid);
          if (curBoard) {
            MMCollaborationManager.processMessage(result, curBoard, {
              messageId: res['messageId'] - 0
            });
          }
        }, 1);
      } catch (e) {
        console.log(e.name + ":" + e.message);
      }
    });
  },
  startMainCollaboration: function startMainCollaboration(boardInfo_, collabInfo_) {
    var _whiteBoard;
    var created = false;
    if (MMCollaborationManager.m_whiteboards[boardInfo_.getId().toDecString()]) {
      _whiteBoard = MMCollaborationManager.m_whiteboards[boardInfo_.getId().toDecString()];
    } else {
      _whiteBoard = new _MMTaskBoard["default"](boardInfo_, collabInfo_);
      created = true;
    }
    MMCollaborationManager._initCollaboration(_whiteBoard);
    if (boardInfo_.isNewBoard()) {
      // added by jjj, 2015-5-18
      _whiteBoard.m_actionManager.changeServerBackgroundToWebDefault(0);
    }
    return _whiteBoard;
  },
  _initCollaboration: function _initCollaboration(whiteBoard_) {
    whiteBoard_.openDocument();
    if (MMCollaborationManager.m_whiteboardArray.indexOf(whiteBoard_) === -1) {
      MMCollaborationManager.m_whiteboardArray.push(whiteBoard_);
      MMCollaborationManager.m_whiteboards[whiteBoard_.getStringId()] = whiteBoard_;
    }
    MMCollaborationManager.bindWhiteboard(whiteBoard_);
  },
  bindWhiteboard: function bindWhiteboard(board) {
    var that = this;
    var curTask = MMCollaborationManager.currentWhiteboard;
    if (curTask !== board) {
      if (curTask !== null) {
        MMCollaborationManager.leave(curTask);
      }
      if (board) {
        MMCollaborationManager.join(board);
      }
    }
  },
  join3D: function join3D(board_, cb_, fail) {
    // this.join(board_, cb_, fail, 'collaborate.glCollaborateHandler.joinCollab')

    console.assert(board_);
    var cid = board_.getId();
    var route = 'collaborate.glCollaborateHandler.joinCollab';
    return _MDConnector["default"].request(route, {
      'cid': cid
    }, function (res) {
      if (typeof res["resultCode"] == 'undefined') {
        //res instanceof Error
        if (fail) {
          fail("result code: " + res['resultCode']);
        }
      } else {
        setBabelTimeout(function () {
          if (res['resultCode'] === 0) {
            if (cb_) {
              cb_();
            }
          } else {
            console.error("join fail -- result code: " + res['resultCode']);
            if (res['resultCode'] == 252) {}
            if (fail) {
              fail("result code: " + res['resultCode']);
            }
            ;
          }
        }, 0);
      }
    });
  },
  join: function join(board_, cb_, fail, url) {
    console.assert(board_);
    var cid = board_.getId();
    var route = 'collaborate.collaborateHandler.joinCollab';
    if (url) {
      route = url;
    }
    ;
    var localSeq = board_.getSeq();

    //mashx temporary.
    if (localSeq == -1) {
      localSeq = -65535;
    }
    var msg = new _MMJoinCollabMessage["default"](cid, board_.getCreatorId(), "", localSeq, 3);
    var _msgId = new _int["default"](this.m_msgIndex);
    msg.setId(_msgId);
    var that = this;
    var _enc = new _Encoder["default"]();
    //var _enc = new Coder.Encoder();
    _enc.encodeObject(msg);
    var payload = _enc.getStream();
    var bid = board_.getMotherBoardStringId();
    // fail();
    // return
    return _MDConnector["default"].request(route, {
      'bid': bid,
      'cid': cid.toDecString(),
      'payload': Array.apply(null, new Uint8Array(payload))
    }, function (res) {
      if (typeof res["resultCode"] == 'undefined') {
        //res instanceof Error
        if (fail) {
          console.error('---- joinCollab failed:' + res['resultCode']);
          fail(res['resultCode']);
        }
      } else {
        setBabelTimeout(function () {
          if (res['resultCode'] === 0) {
            board_.clearUserOnline();
            if (res['members']) {
              var members = res['members'];
              for (var i = 0; i < members.length; i++) {
                var member = members[i];
                var userId = member.split(":");
                board_.setUserOnline(userId[0]);
              }
            }
            if (res['payload']) {
              if (res['documentType'] == '3d') {
                board_.initData(res['payload']);
              } else {
                var result = new ArrayBuffer(res['payload'].length);
                new Uint8Array(result).set(res['payload']);
                that.processMessage(result, board_);
              }
            }
            _Dispatcher["default"].trigger(MDEvents.DATA_INDEX_READY);
            board_.m_actionManager.__startActionQueueInterval();
            if (cb_) {
              cb_();
            }
          } else {
            console.error("join fail -- result code: " + res['resultCode']);
            if (res['resultCode'] == 252) {}
            if (fail) {
              fail(res['resultCode']);
            }
            ;
          }
        }, 0);
      }
    });
  },
  getDataBlock: function getDataBlock(bid, blockId, callback) {
    var route = 'collaborate.collaborateHandler.getDataBlock';
    var that = this;
    return _MDConnector["default"].request(route, {
      'uid': _MDConnector["default"].sid,
      'bid': bid.toDecString(),
      'blockId': blockId.toDecString()
    }, function (res) {
      try {
        if (!res) {
          console.error('get no response');
          return;
        }
        console.log("result code " + res['resultCode']);
        if (res['resultCode'] !== 0 && !res['payload']) {
          console.error('error, got no payload');
          return;
        }
        var result = new ArrayBuffer(res['payload'].length);
        new Uint8Array(result).set(res['payload']);
        callback(result);
      } catch (e) {
        console.error(e.name + ":" + e.message);
      }
    });
  },
  leave: function leave(board, cb) {
    var route = 'collaborate.collaborateHandler.leaveCollab';
    var uid = app.currentUser.getUserId();
    var cid = board.getStringId();
    return _MDConnector["default"].request(route, {
      'uid': uid,
      'cid': cid
    }, function (res) {
      if (cb) {
        cb();
      }
      console.log("result code " + res['resultCode']);
    });
  },
  processMessage: function processMessage(data_, curBoard_, opt) {
    console.assert(curBoard_ instanceof _MMWhiteboard["default"]);
    var _dec = new _Decoder["default"](curBoard_);
    _dec.setStream(data_);
    var _message = _dec.decodeFromObject(___MM_DOC_VERSION__);
    console.assert(_message instanceof _MMMessage["default"]);
    //actually MMSendActionPushMessage
    //console.log("decording message success");
    if (opt && opt.messageId) {
      _message.m_action.m_chatMessage.setId(new _int["default"](opt.messageId));
    }
    if (_message.respond) {
      _message.respond(curBoard_, this);
      _Dispatcher["default"].trigger(MDEvents.Comment_changed);
    }
  },
  sendMessage: function sendMessage(message, whiteboard, cb) {
    var that = this;
    var msg = null;
    console.assert(whiteboard instanceof _MMWhiteboard["default"]);
    var bid = whiteboard.getId();
    var cid = whiteboard.getId();
    // make sure the message is a MMSendActionMessage
    if (!(message instanceof _MMMessage["default"])) {
      if (message instanceof _MMAction["default"]) {
        msg = new _MMSendActionMessage["default"](cid, message);
      } else {
        console.error(message instanceof _MMMessage["default"], 'connection send message error');
      }
    }
    // encoding and sending the message
    var msgId = new _int["default"](this.m_msgIndex);
    msg.setId(msgId);
    var enc = new _Encoder["default"]();
    enc.encodeObject(msg);

    /*
     * attention: we have to merge the following part...
     */
    return _MDConnector["default"].request("collaborate.collaborateHandler.sendAction", {
      'cid': bid.toDecString(),
      'bid': cid.toDecString(),
      'name': app.currentUser.getUserName(),
      'payload': Array.apply(null, new Uint8Array(enc.getStream()))
    }, function (res) {
      setBabelTimeout(function () {
        var rMessage = null;
        if (res['resultCode'] === 0) {
          if (res['payload']) {
            var result = new ArrayBuffer(res['payload'].length);
            new Uint8Array(result).set(res['payload']);
            var dec = new _Decoder["default"](whiteboard);
            dec.setStream(result);
            rMessage = dec.decodeFromObject(___MM_DOC_VERSION__);
            console.assert(rMessage instanceof _MMSendActionRespMessage["default"]);
          }
        } else {
          console.error("send action -- result code: " + res['resultCode']);
          if (res['resultCode'] == 252) {
            //alert("这个程序员真他妈牛逼");
            that.join(whiteboard, function () {}, function () {});
          }
        }
        if (cb) cb(res['resultCode'], rMessage, res["messageId"]);
      }, 0);
    });
    this.m_msgIndex++;
  }
};
/**
 * an alias for the same sendMessage
 */
MMCollaborationManager.sendAction = MMCollaborationManager.sendMessage;
window.MMCollaborationManager = MMCollaborationManager; // 解决循环引用
var _default = exports["default"] = MMCollaborationManager;

},{"1079":1079,"1089":1089,"1109":1109,"1184":1184,"1410":1410,"1411":1411,"1421":1421,"1423":1423,"1424":1424,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1478":1478,"1505":1505,"1506":1506,"1507":1507,"1508":1508,"1509":1509,"1510":1510,"1512":1512,"1513":1513,"1514":1514,"1516":1516,"1517":1517,"1518":1518,"1519":1519,"1520":1520,"1521":1521,"1522":1522,"1523":1523,"1524":1524,"1525":1525,"1526":1526,"1527":1527,"1528":1528,"1529":1529,"1530":1530,"18":18,"799":799,"800":800,"820":820,"845":845,"853":853,"855":855,"959":959,"960":960,"963":963}],855:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMMessage = _interopRequireDefault(require(1079));
function MMSendActionRespMessage() {
  _MMMessage["default"].call(this);
  this.m_className = 'MMSendActionRespMessage';
  this.m_flag;
  this.m_cliSeq;
  this.m_serSeq;
  this.m_image;
}
;
MMSendActionRespMessage.prototype = new _MMMessage["default"]();
MMSendActionRespMessage.superclass = _MMMessage["default"].prototype;
MMSendActionRespMessage.prototype.encode = function (enc_) {
  //  MMSendActionRespMessage.superclass.encode.call(this, enc_) ;
  //  enc_.encode4Bytes(this.m_flag)
  //  enc_.encode8Bytes(this.m_cliSeq) ;
  //  enc_.encode8Bytes(this.m_ser);
};
MMSendActionRespMessage.prototype.decode = function (dec_, ver_) {
  MMSendActionRespMessage.superclass.decode.call(this, dec_, ver_);
  this.m_flag = dec_.decodeFrom4Bytes(ver_);
  this.m_cliSeq = dec_.decodeFrom8Bytes(ver_);
  this.m_serSeq = dec_.decodeFrom8Bytes(ver_);
  this.m_image = dec_.decodeFromBuffer(ver_);
};
var _default = exports["default"] = MMSendActionRespMessage;

},{"1079":1079,"1184":1184,"1454":1454}],853:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMMessage = _interopRequireDefault(require(1079));
function MMSendActionMessage(cid_, actionInfo_) {
  _MMMessage["default"].call(this);
  this.m_className = 'MMSendActionMessage';
  this.m_cId = cid_;
  this.m_action = actionInfo_;
}
;
MMSendActionMessage.prototype = new _MMMessage["default"]();
MMSendActionMessage.superclass = _MMMessage["default"].prototype;
MMSendActionMessage.prototype.encode = function (enc_) {
  MMSendActionMessage.superclass.encode.call(this, enc_);
  enc_.encode8Bytes(this.m_cId);
  enc_.encodeObject(this.m_action);
};
MMSendActionMessage.prototype.decode = function (dec_, ver_) {
  MMSendActionMessage.superclass.decode.call(this, dec_, ver_);
  this.m_cId = dec_.decodeFrom8Bytes(ver_);
  this.m_action = dec_.decodeFromObject(ver_);
};
var _default = exports["default"] = MMSendActionMessage;

},{"1079":1079,"1184":1184,"1454":1454}],845:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _map = _interopRequireDefault(require(821));
var _MMMessage = _interopRequireDefault(require(1079));
function MMJoinCollabMessage(collabId_, owner_, collabPwd_, seq_, type_) {
  _MMMessage["default"].call(this);
  this.m_className = 'MMJoinCollabMessage';
  this.m_collabId = collabId_;
  this.m_collabPwd = collabPwd_ ? collabPwd_ : "";
  this.m_sequence = seq_ ? seq_ : -65000;
  this.m_whiteBoardType = type_;
  this.m_owner = owner_;
}
;
MMJoinCollabMessage.prototype = new _MMMessage["default"]();
MMJoinCollabMessage.prototype.encode = function (enc_) {
  _MMMessage["default"].prototype.encode.call(this, enc_);
  enc_.encode8Bytes(this.m_collabId);
  //enc_.encode8Bytes(this.m_userid) ;
  enc_.encodeString(this.m_collabPwd);
  enc_.encode8Bytes(this.m_sequence);
  enc_.encode4Bytes(this.m_whiteBoardType);
  enc_.encode8Bytes(this.m_owner);
};
var JOIN_COOP_FAILED = 0;
var JOIN_COOP_SUCCESS = 1;
var JOIN_COOP_NOT_EXIST = 2;
var JOIN_COOP_PWD_NOTMATCH = 3;
window.JOIN_COOP_FAILED = JOIN_COOP_FAILED;
window.JOIN_COOP_SUCCESS = JOIN_COOP_SUCCESS;
window.JOIN_COOP_NOT_EXIST = JOIN_COOP_NOT_EXIST;
window.JOIN_COOP_PWD_NOTMATCH = JOIN_COOP_PWD_NOTMATCH;
var _default = exports["default"] = MMJoinCollabMessage;

},{"1079":1079,"1184":1184,"1454":1454,"821":821}],1016:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMShadowType = _interopRequireDefault(require(797));
var _MMBlockObj = _interopRequireDefault(require(1000));
var _MMImgViewCtl = _interopRequireDefault(require(891));
var _MMImageData = _interopRequireDefault(require(1055));
var _MMPoint = _interopRequireDefault(require(830));
var _ObjType = _interopRequireDefault(require(1084));
var _MMObjElementsController = _interopRequireDefault(require(893));
var _MMCommonFun = _interopRequireDefault(require(812));
/**
 *
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMImage}
 */
function MMImage(board) {
  _MMBlockObj["default"].call(this, board); //
  //this.m_className = 'MMImage' ;
  this.m_objType = _ObjType["default"].Obj_Image;
  this.img_src = "";
  this.bufferImg = null;
  this.originSize = new _MMPoint["default"](0, 0);
  this.capacity = 0;
  this.showingOriginFile = false; // 是否显示的原始对象
  this.m_isUploading = false;
}
MMImage.prototype = new _MMBlockObj["default"](); //
MMImage.prototype.m_className = "MMImage";
MMImage.superclass = _MMBlockObj["default"].prototype;
MMImage.prototype.encode = function (enc_) {
  MMImage.superclass.encode.call(this, enc_);
  var _objVer = 1;
  enc_.encode4Bytes(_objVer);
  enc_.encodeMMPoint(this.originSize);
  enc_.encodeFloat(this.capacity);
};
MMImage.prototype.decode = function (dec_, ver_) {
  MMImage.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
  this.originSize = dec_.decodeFromMMPoint(ver_);
  this.capacity = dec_.decodeFromFloat(ver_);
  //  console.log("img rect:(" + this.m_rect.left + "," + this.m_rect.right + "," + this.m_rect.top + "," + this.m_rect.bottom + ")");
};
MMImage.prototype.getHotZoneCtl = function () {
  var _imgData = this.getObjData();
  return _imgData.getHotZoneCtl();
};
MMImage.prototype.draw = function (ctx, trsfm, pgindex, callback) {
  return this.bufferImgForCanvas(ctx, trsfm, pgindex, callback);
  //  this.drawInDiv(editor, trsfm, pgindex);
};

//****************************** 使用 <img> 标签绘制图片的功能代码 ******************************-

MMImage.prototype.drawInDiv = function (editor, trsfm, pgindex) {
  var _imgData = this.getObjData();
  var imgSrc = _imgData.getFilePath(trsfm);

  //  console.log("--------------> pdf file:" + imgSrc);

  if (imgSrc.length === 0 && this.getImage() === null) {
    return; //imgSrc = 'img/test.pdf';
  }

  //  if(this.dispCtl == null){
  //    this.dispCtl = new MMImgViewCtl(this);
  //  }
  //  this.dispCtl.displayInDiv($div, trsfm, pgindex);

  var elementsCtl = _MMObjElementsController["default"].getSingleInstance();
  elementsCtl.displayInDiv(editor, this, trsfm, pgindex);
};
MMImage.prototype.getFilePath = function (trsfm) {
  this.getObjData().getFilePath(trsfm);
};

//****************************** 使用 canvas 绘制图片的功能代码 ******************************-

MMImage.prototype.bufferImgForCanvas = function (ctx, trsfm, pgindex, callback) {
  var _imgData = this.getObjData();
  if (_imgData.getFilePath().length == 0) return 0;
  var delayed = 0;
  if (_imgData && this.bufferImg == null) {
    delayed = 1;
    this.bufferImg = new Image();
    this.bufferImg.crossOrigin = "*";
    this.bufferImg.src = _imgData.getFilePath(); //'img/test/r1.jpg';
    this.bufferImg.ctxs = [];
    this.bufferImg.trsfms = [];
    this.bufferImg.pages = [];
    this.bufferImg.loaded = false;

    //    console.log("draw image: path ->" + _imgData.getFilePath());
    var _that = this;
    this.bufferImg.onload = function (e) {
      _that.bufferImg.loaded = true;
      //$('body').append($('<img src="' + _that.bufferImg.src + '" class="bufferedImage" style="position:absolute;z-index:1000000000000;top:0px;left:0px;">'))
      if (_that.bufferImg.ctxs.length > 2) {
        //        console.log("img draw --------- " + _that.bufferImg.ctxs.length);
      }
      for (var i = 0; i < _that.bufferImg.ctxs.length; i++) {
        _that.drawInCanvas(_that.bufferImg.ctxs[i], _that.bufferImg.trsfms[i], _that.bufferImg.pages[i]);
      }
      _that.bufferImg.ctxs = null;
      _that.bufferImg.trsfms = null;
      if (callback) {
        callback();
      }
    };
    this.bufferImg.onerror = function () {
      if (callback) {
        callback();
      }
    };
  }
  if (this.bufferImg.height > 0) this.bufferImg.loaded = true;
  if (this.bufferImg.loaded) {
    this.drawInCanvas(ctx, trsfm, pgindex, callback);
    //    console.log("---------- image draw directly!");
  } else {
    var i = _MMCommonFun["default"].findObjInArray(this.bufferImg.ctxs, ctx);
    if (i == -1) {
      this.bufferImg.ctxs.push(ctx);
      this.bufferImg.trsfms.push(trsfm);
      this.bufferImg.pages.push(pgindex);
    }
  }
  return delayed;
};

/**
 * draw obj in canvas context
 * @param ctx
 * @param trsfm
 * @param pgindex
 * @param {MMRect} rect
 */
MMImage.prototype.drawObjInRct = function (ctx, trsfm, pgindex, rect) {
  if (this.bufferImg.loaded) {
    var left = rect.left;
    var top = rect.top;
    var data = this.getObjData();
    var alpha = data.m_fillType.m_fillColor.m_alpha;
    ctx.globalAlpha = alpha;
    data.m_shadowType.setContext(ctx, trsfm);
    ctx.drawImage(this.bufferImg, left, top, rect.getWidth(), rect.getHeight());
    if (data.m_strokeType.m_lineWidth > 0) {
      data.m_strokeType.setContext(ctx, trsfm);
      var dvRct = rect;
      var shadow = new _MMShadowType["default"]();
      shadow.m_hasShadow = false;
      shadow.setContext(ctx, trsfm);
      ctx.strokeRect(dvRct.left, dvRct.top, dvRct.getWidth(), dvRct.getHeight());
    }
    ctx.globalAlpha = 1.0;
  }
};
MMImage.prototype.setFilePath = function (path_) {
  this.getObjData().setFilePath(path_);
  this.m_filePath = path_;
};
MMImage.prototype.getOriginFilePath = function () {
  return this.getObjData().getOriginFilePath();
};
MMImage.prototype.getLowPixelFilePath = function () {
  return this.getObjData().getLowPixelFilePath();
};
MMImage.prototype.getLowPixelFilePathForO2O = function () {
  this.setShowingOriginFile(false);
  var pixelRatio = window.devicePixelRatio ? window.devicePixelRatio : 1;
  var lowSize = Math.max($("body").width(), $("body").height()) * pixelRatio;
  var originSize = this.getOriginSize();
  if (originSize) {
    if (lowSize > originSize.width && lowSize > originSize.height) {
      lowSize = Math.max(originSize.width, originSize.height);
      this.setShowingOriginFile(true);
    }
  }
  return this.getObjData().getLowPixelFilePath(lowSize);
};
MMImage.prototype.setImage = function (image) {
  this.getObjData().setImage(image);
  if (image) {
    this.originSize.x = image.width;
    this.originSize.y = image.height;
  }
};
MMImage.prototype.getImage = function () {
  return this.getObjData().getImage();
};
MMImage.prototype.isLoaded = function () {
  return this.getObjData().isLoaded();
};
MMImage.prototype.isPng = function () {
  return this.getObjData().isPng();
};
MMImage.prototype.isPtOn = function (pt, error) {
  if (pt.x >= this.m_expandRect.left && pt.x <= this.m_expandRect.right && pt.y >= this.m_expandRect.top && pt.y <= this.m_expandRect.bottom) {
    return true;
  }
  return false;
};
MMImage.prototype.setCapacity = function (capacity) {
  this.capacity = capacity;
};
MMImage.prototype.getCapacity = function () {
  return this.capacity;
};
MMImage.prototype.setShowingOriginFile = function (showOrigin) {
  this.showingOriginFile = showOrigin;
};
MMImage.prototype.isShowingOriginFile = function () {
  return this.showingOriginFile;
};
MMImage.prototype.isUploading = function () {
  return this.m_isUploading;
};
MMImage.prototype.setUploading = function (flag_) {
  this.m_isUploading = flag_;
};

/**
 * @param {MMPoint}
 */
MMImage.prototype.setOriginSize = function (newOriginSize) {
  console.assert(newOriginSize instanceof _MMPoint["default"], "newOriginSize need to be MMPoint");
  this.originSize = newOriginSize;
};
MMImage.prototype.getDispFilePath = function (w, h) {
  if (this.inTesting) {
    return this.m_filePath;
  }
  var ver_ = this.getFileVersion();
  var _ret = "";
  if (this.m_filePath != undefined && this.m_filePath.length > 0) {}
  var fileInfo = this.m_board.getFileInfo();
  if (fileInfo.isOnlyDisp() && !fileInfo.getLinkFileUrl()) {
    return _MMCommonFun["default"].getImageOnlyDispPath(this.m_board.getStringId(), ver_);
  }
  return _MMCommonFun["default"].getImageDispPath(this.m_board.getStringId(), ver_, w, h);
  // if (_ret.length == 0){
  //  var param = "fileId="+this.m_board.getStringId()+"&version="+ver_;  //+"&style="+73;
  //  if (window.location.host) {
  //    var _ret = "/netdrive/downloadDisplayImage.do?"+param;
  //    return _ret ;
  //  }

  //  var _ret = "http://192.168.2.17:9090/newDownloadFile.do?"+param;
  //  return _ret ;
  // }
};
var _default = exports["default"] = MMImage;

},{"1000":1000,"1055":1055,"1084":1084,"1184":1184,"1454":1454,"797":797,"812":812,"830":830,"891":891,"893":893}],893:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1541);
require(1432);
require(1421);
require(1417);
require(1463);
require(1466);
var _MMBasicData = _interopRequireDefault(require(811));
var _MMCommentPointUpdater = _interopRequireDefault(require(888));
var _MDCommentView = _interopRequireDefault(require(320));
var _MDEvents = _interopRequireDefault(require(325));
var _MDNiceTagView = _interopRequireDefault(require(335));
var _ObjType = _interopRequireDefault(require(1084));
var _MMOperationType = _interopRequireDefault(require(882));
var _MMObjOperationStrategy = _interopRequireDefault(require(872));
var _MMPointObj = _interopRequireDefault(require(1023));
var _MMCenterRect = _interopRequireDefault(require(829));
var _MMParticipantCollection = _interopRequireDefault(require(307));
var _MMDevOrientation = _interopRequireDefault(require(814));
var _MDColorDisk = _interopRequireDefault(require(856));
/**
 * 用于控制对象在屏幕上使用 HTMLElement 进行显示的机制
 */

var g_objElementsCtl = null;
//var gIdentityColors = [ "rgba(255, 92, 30,    1)", "rgba(255, 187, 0,    1)",
//    "rgba(183, 188, 63,   1)", "rgba(0, 163, 240,    1)",
//    "rgba(164, 75, 185,   1)", "rgba(160, 160, 160,  1)",
//    "rgba(159, 89, 183,   1)", "rgba(58, 205, 118,   1)",
//    "rgba(42, 188, 160,   1)", "rgba(255, 48, 100,   1)",
//    "rgba(180, 78, 126,   1)", "rgba(227, 141, 23,   1)",
//    "rgba(33, 131, 247,   1)", "rgba(216, 79, 138,   1)",
//    "rgba(11, 123, 117,   1)", "rgba(236, 188, 86,   1)",
//    "rgba(16, 145, 174,   1)", "rgba(224, 108, 114,  1)",
//    "rgba(138, 29, 73,    1)", "rgba(56, 118, 178,   1)",
//    "rgba(149, 202, 213,  1)" ];
// var gIdentityColors = [
//                    "rgba(0, 163, 240,    1)",
//                    "rgba(183, 188, 63,   1)",
//                         "rgba(255, 187, 0,    1)",
//                         "rgba(255, 92, 30,    1)",
//                    "rgba(160, 160, 160,  1)",
//                    "rgba(164, 75, 185,   1)",
//                    "rgba(159, 89, 183,   1)",
//                    "rgba(58, 205, 118,   1)",
//                    "rgba(42, 188, 160,   1)",
//                    "rgba(255, 48, 100,   1)",
//                    "rgba(180, 78, 126,   1)",
//                    "rgba(227, 141, 23,   1)",
//                    "rgba(33, 131, 247,   1)",
//                    "rgba(216, 79, 138,   1)",
//                    "rgba(11, 123, 117,   1)",
//                    "rgba(236, 188, 86,   1)",
//                    "rgba(16, 145, 174,   1)",
//                    "rgba(224, 108, 114,  1)",
//                    "rgba(138, 29, 73,    1)",
//                    "rgba(56, 118, 178,   1)",
//                    "rgba(149, 202, 213,  1)"
//                    ];

// mashx reconstruct this module.
var gIdentityColors = function () {
  var _colors = [g_keyColor];
  var gIdentityColors = {
    getColor: function getColor(index_) {
      var _index = index_;
      if (!_index || _index < 0) {
        _index = 0;
      } else if (_index >= _colors.length) {
        _index = _index % _colors.length;
      }
      return _colors[_index];
    }
  };
  return gIdentityColors;
}();

/* 构造函数
 *
 * @param {HTMLElement}
 *            parentDiv 父元素
 */
function MMObjElementsController() {
  this.editor2ObjDivs = new Array();
  this.imgPdfParentDiv = null; // 显示的元素所在的父 div
  this.operationParentDiv = null; // 显示的元素所在的父 div

  this.curEditor = null;
  this.mmobjs = null; // 所掌控的对象
  this.divs = null; // 对象的显示元素 与 this.mmobjs 一一对应

  this.canvasQu = new Array(); // 为 pdf 刷新服务

  this.divSelected = null; // the object user selected by mouse
  this.trsfm = null;
  this.pageIndex = 0;
  return this;
}
;
MMObjElementsController.getSingleInstance = function () {
  if (g_objElementsCtl == null) {
    g_objElementsCtl = new MMObjElementsController();
    Dispatcher.on(_MDEvents["default"].commentsPerChanged, g_objElementsCtl.refreshAllComments, g_objElementsCtl);
    /*
     * !!!!!mashx 临时代码每隔两份钟刷新一次批注，这是无奈之举，因为批注动画经常会同心圆，我们将会在下一版彻底解决这个问题，
     */
    g_objElementsCtl.refreshActionInterval = setInterval(function () {
      g_objElementsCtl.refreshAllComments();
    }, 120000);
  }
  return g_objElementsCtl;
};
MMObjElementsController.prototype.isObjNeedOperated = function (objType) {
  if (objType == _ObjType["default"].Obj_comment || objType == _ObjType["default"].Obj_niceTag || objType == _ObjType["default"].GObj_text || objType == _ObjType["default"].Obj_graphComment) {
    return true;
  }
  return false;
};
MMObjElementsController.prototype.saveCurEditorInfo = function (editor) {
  if (this.curEditor != editor) {
    this.curEditor = editor;
    var index = -1;
    for (var i = 0; i < this.editor2ObjDivs.length; i++) {
      if (this.editor2ObjDivs[i].editor == editor) {
        this.mmobjs = this.editor2ObjDivs[i].mmobjs;
        this.divs = this.editor2ObjDivs[i].divs;
        index = i;
        break;
      }
    }
    if (index == -1) {
      this.mmobjs = new Array();
      this.divs = new Array();
      this.editor2ObjDivs.push({
        editor: editor,
        mmobjs: this.mmobjs,
        divs: this.divs
      });
    }
  }
};
MMObjElementsController.prototype.iterateAllObjElement = function (editor, callback) {
  for (var i = 0; i < this.editor2ObjDivs.length; i++) {
    var mmobjs = [];
    var divs = [];
    var targetEditor = this.editor2ObjDivs[i].editor;
    if (editor != null) {
      if (editor == this.editor2ObjDivs[i].editor) {
        mmobjs = this.editor2ObjDivs[i].mmobjs;
        divs = this.editor2ObjDivs[i].divs;
      }
    } else {
      mmobjs = this.editor2ObjDivs[i].mmobjs;
      divs = this.editor2ObjDivs[i].divs;
    }
    var breakIter = false;
    for (var k = 0; k < mmobjs.length; k++) {
      var obj = mmobjs[k];
      var div = divs[k];
      if (callback != null) {
        breakIter = callback(obj, div, targetEditor);
        if (breakIter) break;
      }
    }
    if (breakIter) break;
  }
};
MMObjElementsController.prototype.setDispCallback = function (obj, dispFinished) {
  if (!this.dispCallbacks) {
    this.dispCallbacks = [];
  }
  ;
  this.dispCallbacks.push({
    obj: obj,
    callback: dispFinished
  });
};
MMObjElementsController.prototype.removeDispCallback = function (obj) {
  if (!this.dispCallbacks) {
    return;
  }
  ;
  for (var i = 0; i < this.dispCallbacks.length; i++) {
    var call = this.dispCallbacks[i];
    if (call.obj == obj) {
      this.dispCallbacks.splice(i, 1);
      continue;
    }
    ;
    i++;
  }
  ;
};
MMObjElementsController.prototype.callbackDisp = function (obj) {
  if (!this.dispCallbacks) {
    return;
  }
  ;
  for (var i = 0; i < this.dispCallbacks.length; i++) {
    var call = this.dispCallbacks[i];
    if (call.obj == obj) {
      call.callback();
    }
    ;
  }
  ;
};
MMObjElementsController.prototype.displayInDiv = function (editor, obj, trsfm, pgindex) {
  this.saveCurEditorInfo(editor);
  this.trsfm = trsfm;
  this.pageIndex = pgindex;
  var parentDiv = null;
  if (this.isObjNeedOperated(obj.m_objType)) {
    parentDiv = editor.getCommentLayer();
  } else {
    parentDiv = editor.getImgPdfLayer();
  }
  var createDivSuc = true;
  if (obj) {
    var i = 0;
    for (i = 0; i < this.mmobjs.length; i++) {
      if (this.mmobjs[i] == obj) {
        break;
      }
    }
    if (i < this.mmobjs.length) {
      this.$div = $(this.divs[i]);
    } else {
      this.$div = this.createDiv(obj);
      if (this.$div != undefined && this.$div != null) {
        this.mmobjs.push(obj);
        this.divs.push(this.$div[0]);
        if (this.$div.hasClass("niceTag")) {
          this.$div.css({
            "visibility": "hidden"
          });
        }
        $(parentDiv).append(this.$div);
      } else {
        createDivSuc = false;
      }
    }
  }
  if (createDivSuc) {
    this.placeElement(obj, this.$div, trsfm, pgindex);
    var data = obj.getObjData();
    if (data && obj.m_objType != _ObjType["default"].Obj_comment && obj.m_objType != _ObjType["default"].Obj_niceTag) {
      var alpha = data.m_fillType.m_fillColor.m_alpha;
      this.$div.css("opacity", alpha);
      // console.log("obj" + this.mmobj.m_className + " opacity
      // -----------> " + alpha);
      data.m_strokeType.setDivAppearance(this.$div[0], trsfm);
      data.m_shadowType.setDivAppearance(this.$div[0], trsfm);
    }
    this.renderDivContent(obj, this.$div, editor);
  }

  // this.drawObjInCanvas(editor, obj, trsfm, pgindex);
  this.callbackDisp(obj);
};
MMObjElementsController.prototype.drawObjInCanvas = function (editor, obj, trsfm, pgindex) {
  if (obj && obj.m_objType == _ObjType["default"].Obj_graphComment) {
    var canvas = editor.getScribbleCanvas();
    var graphCommentAppearance = new MMGraphCommentAppearance(editor, obj, transform, pgIndex);
    graphCommentAppearance.drawInCanvas();
  }
  ;
};
MMObjElementsController.prototype.renderDivContent = function (obj, $div, editor) {
  switch (obj.m_objType) {
    case _ObjType["default"].GObj_text:
      break;
    case _ObjType["default"].Obj_Image:
      var _imgData = obj.getObjData();
      var trsfm = this.curEditor.getDivTransformer();
      var imgSrc = _imgData.getFilePath(trsfm);
      // console.log("--------------> pdf file:" + imgSrc);

      if (imgSrc.length == 0) {
        var image = _imgData.getImage();
        if (image) {
          imgSrc = image.src;
        } else {
          return; // imgSrc = 'img/test.pdf';
        }
      }
      var $img = this.$div;
      $img.attr("src", imgSrc);
      if (!$img[0].isLoaded) $img.addClass('board-image-loading');
      $img.on("load", function () {
        $img.removeClass('board-image-loading');
        $img.isLoaded = true;
      });
      break;
    case _ObjType["default"].Obj_niceTag:
      var trsfm = this.curEditor.getDivTransformer();
      $div[0].tagView.update(trsfm, editor);
      break;
    case _ObjType["default"].Obj_PDF:
      break;
    case _ObjType["default"].Obj_Document:
      break;
    default:
      break;
  }
};
MMObjElementsController.prototype.createDiv = function (obj) {
  var $div = null;
  switch (obj.m_objType) {
    case _ObjType["default"].Obj_Image:
      // 控制 z-index 来保证 pdf 的显示在手写 canvas 层的下面
      var index = obj.getLayerIndex() + this.curEditor.getPdfStartlayerZ_index();
      $div = $("<img style='position:absolute;z-index:" + index + ";'>");
      $div.on('load', function () {
        $div.removeClass('board-image-loading');
        $div[0].isLoaded = true;
      });
      //todo: handle the errorcase if an image can not be displayed
      //$div.on('error', function(){});
      break;
    case _ObjType["default"].Obj_PDF:
      var index = obj.getLayerIndex() + this.curEditor.getPdfStartlayerZ_index();
      $div = $("<canvas class='board-image-loading' style='position:absolute;z-index:" + index + ";'></canvas>");
      break;
    case _ObjType["default"].Obj_graphComment:
    case _ObjType["default"].Obj_comment:
      var index = obj.getLayerIndex() + this.curEditor.getCommentStartlayerZ_index();
      $div = $("<div class='comment f-noclickevents' style='position:absolute;z-index:" + index + ";'></div>");
      var status = MMObjElementsController.commentPointUpdater.statusMap[obj.getReadStatus(app.currentUser.getUserId_Int())];
      $div[0].commentView = new _MDCommentView["default"]($div, "#00a5ff", status, obj);
      var visibleScope = obj.getVisibleScope();
      if (visibleScope == 1) {
        $div.addClass('ent-comment');
      } else if (visibleScope == 2) {
        $div.addClass('pri-comment');
      } else if (visibleScope >= 8) {
        $div.addClass('eval-comment');
      }
      //    MMObjElementsController.commentPointUpdater.commentViews
      //        .push($div[0].commentView);
      break;
    case _ObjType["default"].Obj_niceTag:
      //var trsfm = this.editor
      var tagView = new _MDNiceTagView["default"](obj, this.trsfm);
      $div = $(tagView.el);
      $div[0].tagView = tagView;
      break;
    case _ObjType["default"].GObj_text:
      var index = obj.getLayerIndex() + this.curEditor.getTextStartlayerZ_index();
      $div = $("<textarea style='position:absolute; overflow:hidden; z-index:" + index + ";'>" + obj.getText() + "</textarea>");
      break;
    default:
      break;
  }
  return $div;
};
MMObjElementsController.prototype.refreshLayerIndex = function (obj, index_) {
  var startIndex = _MMBasicData["default"].getPdfStartlayerZ_index();
  this.iterateAllObjElement(null, function (mmobj, div) {
    if (mmobj == obj) {
      var $div = $(div);
      $div.css("z-index", startIndex + index_);
    }
    return false;
  });
};
MMObjElementsController.prototype.removeObj = function (obj) {
  for (var k = 0; k < this.editor2ObjDivs.length; k++) {
    var mmobjs = this.editor2ObjDivs[k].mmobjs;
    var divs = this.editor2ObjDivs[k].divs;
    for (var i = 0; i < mmobjs.length; i++) {
      if (mmobjs[i] == obj) {
        if (obj.m_objType != _ObjType["default"].Obj_niceTag && divs[i].tagView && obj.views.indexOf(divs[i].tagView) !== -1) {
          divs[i].tagView.remove();
        } // niceTag.views.push(this);

        $(divs[i]).remove();
        mmobjs[i] = null;
        mmobjs.splice(i, 1);
        divs.splice(i, 1);
        break;
      }
    }
  }
};
MMObjElementsController.prototype.placeElement = function (obj, $element, trsfm, pgIndex) {
  // point 2.
  if (_MMObjOperationStrategy["default"].getOperataionTypeForMolaTask(obj, pgIndex) == _MMOperationType["default"].Operation_hidden) {
    $element.css("display", "none");
    return;
  }

  // $element.css("display", "block");  重定向之前隐藏标注

  var dvrct = null;
  if (!(obj instanceof _MMPointObj["default"])) {
    //(obj.m_objType != ObjType.Obj_comment) {
    var lgrct = new _MMCenterRect["default"]();
    var direction = _MMDevOrientation["default"].createObjByStr(this.curEditor.direction);
    lgrct.setRect(obj.getDrawRect(direction));
    lgrct.setAngle(obj.getDrawAngle(direction));
    dvrct = trsfm.lg2dvCenterRect(lgrct, pgIndex);
  } else {
    // -------------------------------------------------------标注的显示
    var pos = obj.getPos();
    if (pos != undefined) {
      pos = trsfm.lg2dvPoint(pos, pgIndex);
      dvrct = new _MMCenterRect["default"]();
      dvrct.center = pos;
      dvrct.width = dvrct.height = 0; //
    }
  }
  if (dvrct != null) {
    $element.css("left", Math.round(dvrct.getLeftTop().x) + 'px');
    $element.css("top", Math.round(dvrct.getLeftTop().y) + 'px');
    $element.css("box-sizing", "border-box");
    if ($element[0].tagName == 'CANVAS') {
      $element.attr("width", Math.round(dvrct.width));
      $element.attr("height", Math.round(dvrct.height));
    } else {
      $element.css("width", Math.round(dvrct.width) + 'px');
      $element.css("height", Math.round(dvrct.height) + 'px');
      if ($element[0].tagName == 'TEXTAREA') {
        $element.css("width", Math.round(dvrct.width) + 6 + 'px');
        $element.css("height", Math.round(dvrct.height) + 200 + 'px');
      }
    }
    if (dvrct.angle) {
      $element.css('transform', 'rotate(' + dvrct.angle + 'deg)');
    } else {
      $element.css('transform', '');
    }
    this.setEditable($element, false);
    if (obj.isComment()) {
      this.adjustCommentApperance(obj, $element, dvrct);
      this.setEditable($element, true);
    } else if (obj.m_objType == _ObjType["default"].GObj_text) {
      this.adjustTextApperance(obj, $element, trsfm);
    }
  }
};
MMObjElementsController.prototype.adjustCommentApperance = function (obj, $element, dvCenterRct) {
  // 1. 边框圆角
  $element.css("border-radius", dvCenterRct.width / 2 + "px");
  $element.css("-moz-border-radius", dvCenterRct.width / 2 + "px");
  $element.css("border-width", "0px");
  $element.css("border-color", "white");

  // 2. 颜色
  var usrId = obj.getCreator();
  var index = 0;
  if (_MMParticipantCollection["default"] && _MMParticipantCollection["default"].singleton) {
    index = window.location.host ? _MMParticipantCollection["default"].singleton.getParticipantIndexInCurrentBoard(usrId) : 0;
  }
  var color = gIdentityColors.getColor(index);
  var visibleScope = obj.getVisibleScope();
  if (visibleScope == 1) {
    color = _MDColorDisk["default"].commentColor["private"]; //'blue';
  } else if (visibleScope == 2) {
    color = _MDColorDisk["default"].commentColor.ent; // '#696B6F';
  } else if (visibleScope >= 8) {
    color = _MDColorDisk["default"].commentColor.evaluation; //'rgb(238, 10, 200)';
  }
  $element[0].userIdColor = color;
  if ($element[0].commentView) {
    var s = obj.getReadStatus(app.currentUser.getUserId_Int());
    var status = MMObjElementsController.commentPointUpdater.statusMap[s];
    if ($element[0].commentView.status !== "onair") $element[0].commentView.status = status;
    //if the comment is onair, just keep it.
    $element[0].commentView.setColor(color);
  }
};
MMObjElementsController.prototype.adjustTextApperance = function (obj, $element, trsfm) {
  var dvfont = Math.round(trsfm.lg2dvLen(obj.getFontSize()));
  $element.css('font-size', dvfont + 'px');
  $element.css('background-color', 'rgba(255,255,255, 0)');
  $element.css('background', 'rgba(255,255,255, 0)');
  $element.css('color', obj.getTextColor().getRGBA());
  var alignment = obj.getAlignment();
  var strAlign = _MMBasicData["default"].toStringAlignment(alignment);
  $element.css('text-align', strAlign);
  $element.val(obj.getText());
};
MMObjElementsController.prototype.hideAllDivsForEditor = function (editor) {
  var editorIndex = -1;
  for (var k = 0; k < this.editor2ObjDivs.length; k++) {
    if (this.editor2ObjDivs[k].editor == editor) {
      editorIndex = k;
      var mmobjs = this.editor2ObjDivs[k].mmobjs;
      var divs = this.editor2ObjDivs[k].divs;
      for (var i = 0; i < divs.length; i++) {
        $(divs[i]).css("display", "none");
      }
    }
    ;
  }
  ;
};
MMObjElementsController.prototype.removeAllDivsForEditor = function (editor) {
  var editorIndex = -1;
  for (var k = 0; k < this.editor2ObjDivs.length; k++) {
    if (this.editor2ObjDivs[k].editor == editor) {
      editorIndex = k;
      var mmobjs = this.editor2ObjDivs[k].mmobjs;
      var divs = this.editor2ObjDivs[k].divs;
      for (var i = 0; i < divs.length; i++) {
        $(divs[i]).remove();
        divs[i] = null;
        mmobjs[i] = null;
      }
      mmobjs.splice(0, mmobjs.length);
      divs.splice(0, divs.length);
      this.editor2ObjDivs.splice(k, 1);
      this.mmobjs = null;
      this.divs = null;
      this.curEditor = null;
      break;
    }
    ;
  }
  ;
  if (editorIndex != -1) {
    if (this.editor2ObjDivs.length > 0) {
      this.mmobjs = this.editor2ObjDivs[this.editor2ObjDivs.length - 1].mmobjs;
      this.divs = this.editor2ObjDivs[this.editor2ObjDivs.length - 1].divs;
      this.curEditor = this.editor2ObjDivs[this.editor2ObjDivs.length - 1].editor;
    }
  }
  this.canvasQu.splice(0, this.canvasQu.length);
  this.commentViews = [];
};
MMObjElementsController.prototype.removeAuxiliaryDivsForEditor = function (editor) {
  var editorIndex = -1;
  for (var k = 0; k < this.editor2ObjDivs.length; k++) {
    if (this.editor2ObjDivs[k].editor == editor) {
      editorIndex = k;
      var mmobjs = this.editor2ObjDivs[k].mmobjs;
      var divs = this.editor2ObjDivs[k].divs;
      var newObjs = [];
      var newDivs = [];
      for (var i = 0; i < divs.length; i++) {
        var obj = mmobjs[i];
        if (obj.isAuxiliary()) {
          $(divs[i]).remove();
        } else {
          newObjs.push(obj);
          newDivs.push(divs[i]);
        }
      }
      mmobjs.splice(0, mmobjs.length);
      divs.splice(0, divs.length);
      for (var i = 0; i < newObjs.length; i++) {
        mmobjs.push(newObjs[i]);
        divs.push(newDivs[i]);
      }
      ;
      break;
    }
    ;
  }
  ;
};
MMObjElementsController.prototype.empty = function () {
  return this.divs.legnth == 0;
};
MMObjElementsController.prototype.changeEditable = function (obj, editable) {
  var parentDiv = this.imgPdfParentDiv;
  var $div;
  if (obj.isComment()) {
    parentDiv = this.operationParentDiv;
  }
  if (parentDiv != undefined && parentDiv != null) {
    var i = 0;
    for (i = 0; i < this.mmobjs.length; i++) {
      if (this.mmobjs[i] == obj) {
        break;
      }
    }
    if (i < this.mmobjs.length) {
      $div = $(this.divs[i]);
      this.setEditable($div, editable);
    }
  }
};
MMObjElementsController.prototype.setEditable = function ($div, editable) {
  $div.css("pointer-events", "none");
  return;
  // while($div.length > 0){
  if (editable) {
    $div.css("pointer-events", "auto");
  } else {
    $div.css("pointer-events", "none");
  }
  // $div = $div.children();
  // }
};
MMObjElementsController.prototype.getObjInfoByDiv = function (div) {
  var objInfo = {
    obj: null,
    editor: null
  };
  this.iterateAllObjElement(null, function (mmobj, element, editor) {
    if (element == div) {
      objInfo.obj = mmobj;
      objInfo.editor = editor;
      return true; // 已经找到，退出遍历
    }
    return false;
  });
  return objInfo;
};
MMObjElementsController.prototype.getDivByObj = function (editor, obj) {
  var div = null;
  this.iterateAllObjElement(editor, function (mmobj, element) {
    if (mmobj == obj) {
      div = element;
      return true; // 已经找到，退出遍历
    }
    return false;
  });
  return div;
};
MMObjElementsController.prototype.getDivsByObj = function (obj) {
  var divs = [];
  this.iterateAllObjElement(null, function (mmobj, element) {
    if (mmobj == obj) {
      divs.push(element);
    }
    return false;
  });
  return divs;
};
MMObjElementsController.prototype.getCommentsDivs = function (editor) {
  var comments = [];
  this.iterateAllObjElement(editor, function (mmobj, element) {
    if (mmobj.isComment()) {
      comments.push(element);
    }
    return false;
  });
  return comments;
};
/**
 * refresh all comment appearance
 *
 */
MMObjElementsController.prototype.refreshAllComments = function () {
  for (var i = 0; i < this.editor2ObjDivs.length; i++) {
    var editor = this.editor2ObjDivs[i].editor;
    var trsfm = editor.getDivTransformer();
    var pgIndex = editor.getCurrentFilePageIndex();
    var mmobjs = this.editor2ObjDivs[i].mmobjs;
    var divs = this.editor2ObjDivs[i].divs;
    for (var j = 0; j < mmobjs.length; j++) {
      var obj = mmobjs[j];
      var $element = $(divs[j]);
      if (obj.m_objType === _ObjType["default"].Obj_comment || obj.m_objType === _ObjType["default"].Obj_graphComment) {
        this.placeElement(obj, $element, trsfm, pgIndex);
        // this.drawObjInCanvas(editor, obj, trsfm, pgIndex);
      }
    }
  }
};

/*******************************************************************************
 *
 * mouse events
 *
 ******************************************************************************/

MMObjElementsController.prototype.showCommentPanel = function (div) {
  var objInfo = this.getObjInfoByDiv(div);
  objInfo.editor.showCommentPanel(objInfo.obj, div);
};
MMObjElementsController.prototype.clearSelectedDiv = function () {
  this.divSelected = null;
};
$(function () {
  MMObjElementsController.$scaleStyle = $('<style id="MMObjElementsControllerScaleStyle">');
  $(document.body).append(MMObjElementsController.$scaleStyle);
});
MMObjElementsController.prototype.zoomScaleChanged = function (scale, editor) {
  var newCommentInput = viewManager.get('newCommentInput');
  if (newCommentInput) {
    newCommentInput.remove();
  }
  scale = 1;
  var reverseScale = 1 / scale;
  var reverseScale = 1 / scale;
  if (editor.$root) {
    editor.$root.find(".niceTag, .m-db-newCommentCreationView, .comment").css({
      'transform': 'scale(' + reverseScale + ')',
      '-webkit-transform': 'scale(' + reverseScale + ')'
    });
  } else if (editor.$contentDiv) {
    editor.$contentDiv.find(".niceTag, .m-db-newCommentCreationView, .comment").css({
      'transform': 'scale(' + reverseScale + ')',
      '-webkit-transform': 'scale(' + reverseScale + ')'
    });
  }
};
/*******************************************************************************
 *
 * PDF
 *
 ******************************************************************************/

MMObjElementsController.prototype.refreshPdf = function (obj) {
  if (obj.m_objType != _ObjType["default"].Obj_PDF) {
    return;
  }
  if (!this.mmobjs) return;
  var index = -1;
  for (var i = 0; i < this.mmobjs.length; i++) {
    if (this.mmobjs[i] == obj) {
      index = i;
      break;
    }
  }
  if (index == -1) {
    // for(i=0; i< this.divs.length; i++){
    // var canvas = this.divs[i];
    // this.applyForRender(canvas);
    // }
  } else {
    for (i = 0; i < this.divs.length; i++) {
      if (index == i) {
        var canvas = this.divs[i];
        this.applyForRender(canvas);
        $(canvas).removeClass('board-image-loading');
      }
    }
  }
};
MMObjElementsController.prototype.applyForRender = function (canvas) {
  this.canvasQu.push(canvas);
  if (this.canvasQu.length == 1) {
    this.refreshPdfInCanvas(canvas);
  }
  ;
};
MMObjElementsController.prototype.refreshPdfInCanvas = function (canvas) {
  var context = canvas.getContext('2d');
  context.fillRect(0, 0, 30, 30);
  var obj = null;
  for (var i = 0; i < this.divs.length; i++) {
    if (canvas == this.divs[i]) {
      obj = this.mmobjs[i];
      break;
    }
  }
  if (obj != null) {
    var viewport = obj.page.getViewport(1.0);
    var scale = parseInt($(canvas).attr("width")) / viewport.width;

    // console.log("pdf scale: " + scale + " canvas width:" +
    // $(canvas).attr("width") + " origin pdf width:" +
    // viewport.width);

    var viewport = obj.page.getViewport(scale);

    // viewport.width = canvas.width;
    // viewport.height = canvas.height;
    // canvas.width = viewport.width;
    // canvas.height = viewport.height;

    var renderContext = {
      'canvasContext': context,
      'viewport': viewport
    };
    var rendTask = obj.page.render(renderContext);
    var _that = this;
    rendTask.then(function () {
      _that.canvasQu.shift();
      if (_that.canvasQu.length > 0) {
        _that.refreshPdfInCanvas(_that.canvasQu[0]);
      }
    });
  }
};
MMObjElementsController.commentPointUpdater = new _MMCommentPointUpdater["default"]();
var _default = exports["default"] = MMObjElementsController;

},{"1023":1023,"1084":1084,"1184":1184,"1417":1417,"1421":1421,"1432":1432,"1454":1454,"1463":1463,"1466":1466,"1541":1541,"307":307,"320":320,"325":325,"335":335,"811":811,"814":814,"829":829,"856":856,"872":872,"882":882,"888":888}],320:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDCommentAnimator = _interopRequireDefault(require(317));
var _MDEvents = _interopRequireDefault(require(325));
var _MMCommentPointUpdater = _interopRequireDefault(require(888));
var MMCommentView = function MMCommentView(parent, color, status, obj) {
  var commentSlidePanel = viewManager.get("commentSlidePanel");
  if (commentSlidePanel && commentSlidePanel.comment === obj) {
    status = "onair";
  }
  this.$parent = $(parent);
  this.color = color;
  this.comment = obj;
  this.status = status;
  _MDCommentAnimator["default"].createColoredClasses(color);
  var that = this;
  _.extend(this, Backbone.Events);
  this.$parent.on('click', function (e) {
    that.trigger('click', e);
  });
  this.init(this.status);
};
MMCommentView.prototype.setColor = function (newColor) {
  this.color = newColor;
  _MDCommentAnimator["default"].createColoredClasses(newColor);
  this.init();
};
MMCommentView.prototype.getStatus = function () {
  return this.status;
};
MMCommentView.prototype.changeStatus = MMCommentView.prototype.init = function (status) {
  if (status != this.status) {
    if (status) {
      this.status = status;
    }
    switch (this.status.toLowerCase()) {
      case 'newmessage':
        _MDCommentAnimator["default"].init(this.$parent, 'CommentNewMessage-' + _MDCommentAnimator["default"].fixeColorName(this.color));
        break;
      case 'onair':
        _MDCommentAnimator["default"].init(this.$parent, 'CommentOnAir-' + _MDCommentAnimator["default"].fixeColorName(this.color));
        break;
      case _MDEvents["default"].CLOSED:
        _MDCommentAnimator["default"].init(this.$parent, 'CommentClosed-' + _MDCommentAnimator["default"].fixeColorName(this.color));
        break;
      case 'moving':
        _MDCommentAnimator["default"].init(this.$parent, 'CommentMoving-' + _MDCommentAnimator["default"].fixeColorName(this.color));
        break;
      case 'unreaded':
        _MDCommentAnimator["default"].init(this.$parent, 'CommentUnReaded-' + _MDCommentAnimator["default"].fixeColorName(this.color));
        break;
      case 'readed':
        _MDCommentAnimator["default"].init(this.$parent, 'CommentReaded-' + _MDCommentAnimator["default"].fixeColorName(this.color));
        break;
      default:
        _MDCommentAnimator["default"].init(this.$parent, 'CommentReaded-' + _MDCommentAnimator["default"].fixeColorName("#0000ff"));
    }
  }
  if (this.comment.isFinished()) {
    this.$parent.css('opacity', 0.5);
  } else {
    this.$parent.css('opacity', 1);
  }
  _MMCommentPointUpdater["default"]._updateIndex(this.$parent[0], this.comment);
};
var _default = exports["default"] = MMCommentView;

},{"1184":1184,"1454":1454,"317":317,"325":325,"888":888}],888:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1438);
require(1466);
require(1418);
require(1463);
require(1537);
var _Dispatcher = _interopRequireDefault(require(18));
var _MDEvents = _interopRequireDefault(require(325));
var _MMObjElementsController = _interopRequireDefault(require(893));
var _MMAndroidCollectionView = _interopRequireDefault(require(912));
var _MDPCEditorViewController = _interopRequireDefault(require(940));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _ObjType = _interopRequireDefault(require(1084));
function MMCommentPointUpdater() {
  this.registeredDispatcherEvents = [];
  this.registerEvents();
  return this;
}
MMCommentPointUpdater.prototype.registerEvents = function () {
  var clearAllCommentViews = function () {
    this.destroy();
  }.bind(this);
  _Dispatcher["default"].on(_MDEvents["default"].WHITEBOARD_CLOSED, clearAllCommentViews);
  _Dispatcher["default"].on(_MDEvents["default"].SET_PAGE_INDEX, clearAllCommentViews);
  this.registeredDispatcherEvents.push(clearAllCommentViews);
  var openCommentHandler = function (editor, commentObj) {
    this.commentOpened(editor, commentObj);
  }.bind(this);
  _Dispatcher["default"].on(_MDEvents["default"].COMMENT_CLICKED, openCommentHandler);
  this.registeredDispatcherEvents.push(openCommentHandler);
  var commentMoveHandler = function (editor, commentObj, offset) {
    this.commentMoveTMP(editor, commentObj, offset);
  }.bind(this);
  _Dispatcher["default"].on(_MDEvents["default"].COMMENT_MOVE_TO_OFFSET, commentMoveHandler);
  this.registeredDispatcherEvents.push(commentMoveHandler);

  // WhiteboardEvents
  _Dispatcher["default"].on(_MDEvents["default"].NEW_MESSAGE, function (payload) {
    payload = payload || {};
    var comment = payload.comment;
    var sender = payload.sender;
    if (comment) {
      if (sender && !(_.isString(sender) && sender == app.currentUser.getUserId()) && !(!_.isString(sender) && sender.isEqualTo(app.currentUser.getUserId_Int()))) {
        var currentCommentPanel = viewManager.get("commentSlidePanel");
        var mainEditor = _MDPcMobileEditorCommonFun["default"].getMainEditor();
        if (mainEditor) {
          var currentBoard = mainEditor.getCurrentBoard();
          if (currentCommentPanel && currentCommentPanel.comment === comment) {
            _.delay(function () {
              currentBoard.m_actionManager.commentReaded(comment);
            });
          } else {
            var status = comment.getReadStatus(app.currentUser.getUserId_Int());
            _MMObjElementsController["default"].commentPointUpdater.updateCommentView(comment, status);
          }
        }
      }
    }
  });
};
MMCommentPointUpdater.prototype.commentMoveTMP = function (editor, commentObj, offset) {
  if (editor instanceof _MMAndroidCollectionView["default"] || editor instanceof _MDPCEditorViewController["default"]) {
    editor = editor.getCurEditor();
  }
  var elementsCtl = _MMObjElementsController["default"].getSingleInstance();
  var element = elementsCtl.getDivByObj(editor, commentObj);
  if (!element) {
    console.error('---------> not found comment object');
    return;
  }
  ;
  var view = element.commentView;
  if (view == null || view == undefined) {
    console.error("comentView not found!");
  }
  var orgPos = offset.clone();
  orgPos.x = parseInt(view.$parent.css("left"));
  orgPos.y = parseInt(view.$parent.css("top"));
  if (view.offset) {
    orgPos.x -= view.offset.x;
    orgPos.y -= view.offset.y;
  }
  if (offset.x !== 0 || offset.y !== 0) {
    view.$parent.css("left", orgPos.x + offset.x + "px");
    view.$parent.css("top", orgPos.y + offset.y + "px");
  }
  if (!MMCommonFun.isPC()) {
    if (offset.x === 0 && offset.y === 0) {
      if (this._orgStatus) {
        view.changeStatus(this._orgStatus);
        this._orgStatus = null;
        view.$parent.removeClass('moving');
      }
    } else {
      if (view.status !== "moving") {
        this._orgStatus = view.status;
        view.changeStatus('moving');
        view.$parent.addClass('moving');
      }
    }
  }
  view.offset = offset;
};
MMCommentPointUpdater.prototype.updateCommentView = function (commentObj, status) {
  if (typeof status == 'number') {
    status = this.statusMap[status];
  }
  var elementsCtl = _MMObjElementsController["default"].getSingleInstance();
  var elements = elementsCtl.getDivsByObj(commentObj);
  elements.forEach(function (element) {
    if (element) {
      var view = element.commentView;
      if (view == null || view == undefined) {
        console.error("comentView not found!");
      }
      view.changeStatus(status);
    }
  }.bind(this));
};
MMCommentPointUpdater.prototype.destroy = function () {
  this.lastOpen = null;
};
MMCommentPointUpdater.prototype.statusMap = ['unreaded', 'readed', 'newmessage'];
MMCommentPointUpdater.prototype.lastOpen = null;

/**
 * @param optionl commentObj{an MMComment} so set this comment onAir
 *  pass null to clear the last open commentObj
 */
MMCommentPointUpdater.prototype.commentOpened = function (editor, commentObj) {
  while (editor instanceof _MMAndroidCollectionView["default"] || editor instanceof _MDPCEditorViewController["default"]) {
    editor = editor.getCurEditor();
  }
  if (editor.getClassName() == "MDHtmlRender") {
    editor.openCommentPanel(commentObj);
  } else {
    this._commonCommentOpened(editor, commentObj);
  }
};
MMCommentPointUpdater.prototype._commonCommentOpened = function (editor, commentObj) {
  var element;
  if (commentObj === null) {
    this.lastOpen = null;
  }
  var elementsCtl = _MMObjElementsController["default"].getSingleInstance();
  if (!commentObj) {
    commentObj = this.lastOpen;
  }
  if (commentObj) {
    element = editor.getDivByObj(commentObj);
    if (!element && commentObj.m_objType != _ObjType["default"].Obj_textComment) {
      _MDSnackbarView["default"].show(BabelStr.str(7369));
    }
  }
  this.lastOpen = commentObj;
  var commentDivs = editor.getCommentsDivs();
  commentDivs.forEach(function (commentDiv) {
    if (element === commentDiv) {
      // open the panel:
      elementsCtl.showCommentPanel(element.commentView.$parent[0]);
      if (MMCommonFun.isPC()) {
        element.commentView.changeStatus('onair');
      }
    } else {
      var cDiv = commentDiv;
      var objInfo = elementsCtl.getObjInfoByDiv(cDiv);
      if (objInfo.obj) {
        var status = objInfo.obj.getReadStatus(app.currentUser.getUserId_Int());
        cDiv.commentView.changeStatus(this.statusMap[status]);
      }
    }
    MMCommentPointUpdater._updateIndex(commentDiv);
  }.bind(this));
};
MMCommentPointUpdater._updateIndex = function (element, commentObj) {
  var index = 1;

  // 使用创建者头像
  // var id = commentObj.getCreator().toDecString();
  // var t = new Date().getTime();
  // var avatarUrl = "" + "/user/getUserAvatar.do?userId=" + id + "&t=" + t + "&size=" + 30 + "";

  function updateIndex() {
    if (element.commentView) {
      if (element.commentView.status == "newmessage") index = 2;
      $(element.children[element.children.length - index]).text(element.commentView.comment.getIndex());
      // $(element.children[element.children.length - index]).html('<img src="' + avatarUrl + '" class="comment-avatar" />');
    }
  }
  updateIndex();
  _.delay(updateIndex, 10);
};
var _default = exports["default"] = MMCommentPointUpdater;

},{"1084":1084,"1184":1184,"1418":1418,"1438":1438,"1454":1454,"1463":1463,"1466":1466,"1537":1537,"18":18,"325":325,"72":72,"807":807,"893":893,"912":912,"940":940}],940:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1451);
require(1466);
require(1541);
require(1432);
var _MDEditorOption = _interopRequireDefault(require(905));
var _MDHtmlRender = _interopRequireDefault(require(222));
var _MDAVFileBrowser = _interopRequireDefault(require(16));
var _MMNetDiskBoardCell = _interopRequireDefault(require(937));
var _MD3DEditor = _interopRequireDefault(require(9));
var _MDSWFEditor = _interopRequireDefault(require(1122));
var _MDPCSinglePagePdfView = _interopRequireDefault(require(943));
var _MDPCSVGView = _interopRequireDefault(require(942));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MMFileInfo = _interopRequireDefault(require(297));
var _MMWhiteboardController = _interopRequireDefault(require(1109));
var _MMPCImageEditor = _interopRequireDefault(require(916));
var _MMObjElementsController = _interopRequireDefault(require(893));
var _MMRect = _interopRequireDefault(require(831));
var _OBJ_ID = _interopRequireDefault(require(818));
var _MMImageMarkerCtl = _interopRequireDefault(require(915));
var _MMPDFCollectionView = _interopRequireDefault(require(931));
var _MDCheckStatusFromServer = _interopRequireDefault(require(33));
var _MDTextFileBrowser = _interopRequireDefault(require(231));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
var _MDMessageView = _interopRequireDefault(require(55));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MD_SALON_MSG_TYPE = _interopRequireDefault(require(212));
var _MDSalonMsg = _interopRequireDefault(require(205));
var _MDAlertView = _interopRequireDefault(require(32));
var _MMPoint = _interopRequireDefault(require(830));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDMailDisplayView = _interopRequireDefault(require(230));
var _MDOfficeDisplayView = _interopRequireDefault(require(1111));
var _MDPenZoneMarkController = _interopRequireDefault(require(887));
var _MDKityMinderFileEditor = _interopRequireDefault(require(229));
var _MDCadFileEditor = _interopRequireDefault(require(111));
var _MDDrawioEditor = _interopRequireDefault(require(112));
var _MDTipTapEditor = _interopRequireDefault(require(1132));
var _MDPdfOriginFileDisplayView = _interopRequireDefault(require(929));
/**
 * 直接切换文件 view 2015-9-11 jiang
 * javascript/molasync-source/ui/netdisk/pc/editor/MDPCEditorViewController.js
 */

/**
 *
 * @param {HTMLElement}
 *            containerDiv page scroll view's parent div
 * @param {MMDevOrientation}
 *            devDirection 横纵向
 */

var g_pcEditorCtl = null;
window.g_pcEditorCtl = g_pcEditorCtl;
function MDPCEditorViewController(containerDiv) {
  console.assert(containerDiv, "undefined containerDiv");
  this.containerDiv = containerDiv;
  // this.boardArr = boardArr;

  // mashx temporary code here for pinch gesture: in the near furture, we're
  // gonna merge this code with the pdf pinch.
  var that = this;
  window.g_pcEditorCtl = g_pcEditorCtl = this;
  Dispatcher.on(MDEvents.COMMENT_CREATE, this.commentCreated, this);
  Dispatcher.on(MDEvents.DATA_READY, this.commentCreated, this);
  Dispatcher.on(MDEvents.COMMENT_REMOVE, this.commentDeleted, this);
  Dispatcher.on(MDEvents.SALON_MESSAGE, this.salonMsgManage, this);
  Dispatcher.on(MDEvents.MOUSE_CLICK_LOG_POS, this._chekToSendMouseClickPos, this);
  Dispatcher.on(MDEvents.WindowScrolled, this._checkToSendWindowPos, this);
  Dispatcher.on(MDEvents.SALON_PEN_ADD, this._checkToSendPen, this);
  Dispatcher.on(MDEvents.SALON_EARASER, this._checkToSendEaraser, this);
  Dispatcher.on(MDEvents.POMELO_RECONNECT, this._rejoinBoard, this);
  Dispatcher.on(MDEvents.FileSignatureChanged, this._fileSignatureChanged, this);
  this.penZoneCtl = new _MDPenZoneMarkController["default"]();
  this.penZoneCtl.setEditorViewCtl(this);
  this.registerEvents();
}
MDPCEditorViewController.instances = [];
MDPCEditorViewController.getCurrentInstance = function () {
  return g_pcEditorCtl;
};
MDPCEditorViewController.clearCurrentInstance = function () {
  if (g_pcEditorCtl) {
    g_pcEditorCtl.clearEvents();
  }
  g_pcEditorCtl = null;
};
MDPCEditorViewController.setCurrentInstance = function (editor) {
  if (g_pcEditorCtl != editor) {
    g_pcEditorCtl && g_pcEditorCtl.clearEvents();
    g_pcEditorCtl = editor;
  }
};
MDPCEditorViewController.isEditorShowing = function () {
  return g_pcEditorCtl != null;
};
Object.assign(MDPCEditorViewController.prototype, {}, function () {
  function _recordReadMark() {
    var fileId = this.m_board.getStringId();
    var usrId = app.currentUser.id;
    _MMNetDiskDataController["default"].addFileAccessUser(fileId, usrId, function () {}, function () {});
    // !!{ clear unread mark
    var fileInfo = this.getCurrentFileInfo();
    var fver = this.curVer;
    _MMNetDiskDataController["default"].clearUnreadMarkWithVerNum(fileInfo, fver);
    // !!} added by jiang, 2016-2-17
  }
  function _initEditorWithCurrentFile(callback, opt_silent, commentId, searchText) {
    // MDEditorOption.restorehDefault();

    if (this.editor) {
      this.editor.removeFromSuperView();
    }
    this.editor = null;
    var curFileInfo = this.fileInfoArr[this.fileIndex];
    var self = this;
    _MMFileInfo["default"].prepareLinkedFileInfo(curFileInfo, function (params) {
      if (curFileInfo.isShortcuts()) {
        curFileInfo = curFileInfo.getShortCutsTargetFile();
      }
      if (curFileInfo.isArchived() && !app.ep.isArchive()) {
        if (!app.ep.canShowArchiveModel()) {
          var opt = {
            message: BabelStr.str(6119)
          };
          _MDAlertView["default"].showStandardPrompt(opt);
          return;
        }
        var opt = {
          width: 490,
          message: BabelStr.str(762),
          //  	你要查看的是归档文件，需要到档案库去查看，点击确定转到档案库
          okFun: function okFun() {
            app.pathRouter.openNetTab("/archive.do#archive/" + curFileInfo.getParentFolderId());
          }
        };
        _MDAlertView["default"].showStandardSelection(opt);
        return;
      }
      var ver = self.curVer;
      // if (self.curVer == -1) {
      //   ver = curFileInfo.getCurVersion();
      // };

      _MDCheckStatusFromServer["default"].checkFromServer(curFileInfo, ver, function success(suc) {
        if (!suc) {
          self.m_board = null;
          return;
        }
        self.m_board = self.boardArr[self.fileIndex];
        curFileInfo.setVersionReady(ver);
        if (self.m_board == undefined) {
          NProgress.start();
          var temp = self.fileIndex;
          _openWhiteboardByInfo.call(self, curFileInfo, ver, function (board) {
            if (self.fileIndex == temp) {
              NProgress.done();
              if (board == undefined) {
                board = null;
              }
              self.m_board = board;
              _refreshWithCurrentBoard.call(self, function () {
                self.penZoneCtl && self.penZoneCtl.refreshData && self.penZoneCtl.refreshData();
                if (_.isFunction(callback)) {
                  callback(self.m_board);
                }
              }, commentId, searchText);
            }
          }, function fail(errorCode) {
            NProgress.done();
            if (curFileInfo.isArchived() && !app.ep.isArchive()) {
              if (app.ep.canShowArchiveModel()) {
                var opt = {
                  width: 490,
                  message: BabelStr.str(762),
                  //    你要查看的是归档文件，需要到档案库去查看，点击确定转到档案库
                  okFun: function okFun() {
                    app.pathRouter.openNetTab("/archive.do#archive/" + curFileInfo.getParentFolderId());
                  }
                };
                _MDAlertView["default"].showStandardSelection(opt);
              } else {
                var opt = {
                  message: BabelStr.str(6119)
                };
                _MDAlertView["default"].showStandardPrompt(opt);
              }
            }
            if (_.isFunction(callback)) {
              callback(self.m_board, errorCode);
            }
          });
        } else {
          if (curFileInfo.isImage()) {
            createImageLayer(curFileInfo, self.m_board, self);
          }
          if (curFileInfo.isOnlyDisp()) {
            // MDMessageView.show(BabelStr.str(833), 'infor', self.containerDiv, 8000);
          }
          _refreshWithCurrentBoard.call(self, function () {
            self.penZoneCtl && self.penZoneCtl.refreshData();
            if (_.isFunction(callback)) {
              callback(self.m_board);
            }
          }, commentId, searchText);
        }
        if (!opt_silent) {
          Dispatcher.trigger(MDEvents.EditorPageIndexChanged);
        }
      }, function fail() {
        callback(null);
      });
    });
  }
  function _checkVersionReady(fileInfo, version, success, fail) {
    if (fileInfo.isVersionReady(version) || !fileInfo.dispNeedWhiteBoard() || fileInfo.canDispInOpenGL()) {
      success();
      return;
    }
    var self = this;
    _MDCheckStatusFromServer["default"].checkFromServer(fileInfo, version, function (suc) {
      if (!suc) {
        // self.m_board = null;
        return;
      }

      // MMWhiteboardController.closeWhiteboard(fileInfo.getFileId());

      fileInfo.setVersionReady(version);
      NProgress.start();
      var temp = self.fileIndex;
      _openWhiteboardByInfo.call(self, fileInfo, version, function (board) {
        if (self.fileIndex == temp) {
          NProgress.done();
          if (board == undefined) {
            board = null;
          }
          self.m_board = board;
          success();
        } else {
          fail();
        }
      }, function (errorCode) {
        NProgress.done();
        fail(null, errorCode);
      });
    }, function () {
      fail();
    });
  }
  function _openWhiteboardByInfo(fileInfoInput, ver, success, fail) {
    var self = this;
    var versionList = null;
    var isValidateVersion = true;
    var fileInfo = fileInfoInput;
    _MMFileInfo["default"].prepareLinkedFileInfo(fileInfo, function () {
      if (fileInfo.isShortcuts()) {
        fileInfo = fileInfo.getShortCutsTargetFile();
      }
      _MMWhiteboardController["default"].openWhiteboardByFileInfo(fileInfo, ver, function (board, isInit) {
        if (board == undefined) {
          board = null;
        }
        if (isInit && fileInfo.isImage()) {
          createImageLayer(fileInfo, board, self);
        }
        if (fileInfo.isOnlyDisp()) {
          // MDMessageView.show(BabelStr.str(833), 'infor', self.containerDiv, 8000);
        }
        // board.registerFindController(self.curVer)
        var index = -1;
        for (var i = 0; i < self.fileInfoArr.length; i++) {
          if (self.fileInfoArr[i] == fileInfo) {
            self.boardArr[i] = board;
            index = i;
          }
        }
        if (fileInfo.isDeleteVersion()) {
          self.curVer = fileInfo.getDeleteVersion();
          fileInfo.setCurVersionWithVerNum(self.curVer, {
            silent: true
          });
          // board.setVersionShowing(self.curVer);
          if (success) {
            success(board, index);
          }
        } else {
          // versionList = fileInfo.getFileVersionList();
          versionList = null;
          if (self.curVer != -1) {
            // -1时强制获取新的versionList
            versionList = fileInfo.getFileVersionList();
          }
          if (!versionList) {
            _MMNetDiskDataController["default"].getFileVersionsByFileInfo(fileInfo, function () {
              versionList = fileInfo.getFileVersionList();
              isValidateVersion = versionList.isValidateVersion(self.curVer);
              if (self.curVer == -1 && versionList.length) {
                self.curVer = versionList.at(0).getCurVersion();
                _.isFunction(board.setCurVersion) && board.setCurVersion(self.curVer);
                // fileInfo.setCurVersion(self.curVer, versionList.at(0))
              } else if (!isValidateVersion) {
                self.curVer = board.getCurVersion();
              }
              // board.setVersionShowing(self.curVer);
              if (success) {
                success(board, index);
              }
            }, function () {
              if (fail) {
                fail();
              }
            });
          } else {
            isValidateVersion = versionList.isValidateVersion(self.curVer);
            if (!isValidateVersion) {
              self.curVer = board.getCurVersion();
            }
            // board.setVersionShowing(self.curVer);
            if (success) {
              success(board, index);
            }
          }
        }
      }, function (ecode) {
        if (fail) {
          fail(ecode);
          if (ecode == 350) {
            _MDSnackbarView["default"].show(BabelStr.str(742));
          }
        }
      });
    });
  }
  function createImageLayer(file, board, self) {
    return;
    var path = MMCommonFun.getImageDispPath(file.getFileId(), board.getCurVersion());
    var img = new Image();
    img.crossOrigin = "Anonymous";
    img.src = path;
    img.onload = function () {
      var scale = MMCommonFun.getFitZoomScale(10, self.containerDiv, img.width, img.height);
      var $img = $(img);
      var imgDispWidth = parseInt(img.width * scale);
      var imgDispHeight = parseInt(img.height * scale);
      var winW = self.containerDiv.offsetWidth;
      var winH = self.containerDiv.offsetHeight;
      var marginLeft = (winW - imgDispWidth) / 2;
      var marginTop = (winH - imgDispHeight) / 2;
      $img.css("position", "absolute");
      $img.css("width", imgDispWidth + "px");
      $img.css("height", imgDispHeight + "px");
      $img.css("left", marginLeft + "px");
      $img.css("top", marginTop + "px");
      $(self.containerDiv).append($img);
      self.$imgLayer = $img;
    };
  }
  function _refreshWithCurrentBoard(callback, commentStrId, searchText) {
    if (this.editor) {
      this.editor.removeFromSuperView();
    }
    var commentId = commentStrId;
    var comment = null;
    var self = this;
    var curFileInfo = this.fileInfoArr[this.fileIndex];
    if (this.m_board) {
      if (this.curVer == -1) {
        this.curVer = this.m_board.getCurVersion();
      }
      if (commentStrId) {
        if (!(commentStrId instanceof _OBJ_ID["default"])) {
          commentId = new _OBJ_ID["default"]();
          commentId.fromString(commentStrId);
        }
        comment = this.m_board.getObject(commentId);
        this.curVer = this.m_board.getCurVersion();
        if (comment) {
          var dispVer = comment.getFileVersion();
          if (this.curVer != dispVer) {
            this.curVer = dispVer;
            var verList = curFileInfo.getFileVersionList();
            var isValidateVersion = verList.isValidateVersion(dispVer);
            if (!isValidateVersion) {
              _MDSnackbarView["default"].show(BabelStr.str(5092));
              return;
            }
            _MDMessageView["default"].success(BabelStr.str(5093));
          }
        } else {
          _MDSnackbarView["default"].show(BabelStr.str(5094));
        }

        // this.m_board.setVersionShowing(this.curVer);
      } else if (this.curVer == -1) {
        // this.curVer = this.m_board.getCurVersion();
        // this.m_board.setVersionShowing(this.curVer);
      } else {
        // this.curVer = this.m_board.getVersionShowing();
        // this.m_board.setVersionShowing(this.curVer);
      }
      if (curFileInfo.isDeleteVersion()) {
        this.curVer = curFileInfo.getDeleteVersion();
        // this.m_board.setVersionShowing(this.curVer);
      }
      _recordReadMark.call(this);
      if (curFileInfo.canDispInWebBrowser()) {
        _createHtmlBrowser.call(this, comment, callback);
      } else if (!curFileInfo.dispNeedWhiteBoard() || curFileInfo.canDispInWebBrowser()) {
        // 根目录分享的 html ，参与者只能看源码

        _createEditorNoBoard.call(this, curFileInfo, callback);
      } else if (curFileInfo.isOnlyDisp() && curFileInfo.isPdf()) {
        _createMultiPageDocEditor.call(this, comment, callback, searchText, true);
      } else if (this.m_board.isOperateOnPDFFile()) {
        if (this.m_board.getPageCountByVersion(this.curVer) > 1) {
          _createMultiPageDocEditor.call(this, comment, callback, searchText);
        } else if (this.m_board.getPageCountByVersion(this.curVer) == 1) {
          _createSinglePageEditor.call(this, comment, callback, searchText);
        } else {
          _MDSnackbarView["default"].show(BabelStr.str(7475));
          var url = "/netdrive/resetFileConvertStatus.do";
          var param = {
            fileId: this.m_board.getStringId(),
            version: this.curVer
          };
          $.ajax(url, {
            data: param,
            method: "post",
            success: function success(data1, xhr) {
              if (data1.success) {}
            }
          });
        }

        // };
      } else if (curFileInfo.canDispInOpenGL()) {
        _create3DEditor.call(this, comment, callback);
      } else {
        _createSinglePageEditor.call(this, comment, callback, searchText);
      }
      if (curFileInfo.isInTrash() && this.editor) {
        this.editor.setReadOnly();
      }
      this.salonMsgQueue = [];
    }
  }
  function _createEditorNoBoard(fileInfo, callback) {
    // if (fileInfo.getFileExtension().toLowerCase() == 'md') {
    // MDKityMinderFileEditor
    if (fileInfo.canDispWithGSCAD()) {
      this.editor = new _MDCadFileEditor["default"](this.containerDiv);
    } else if (fileInfo.canDispWithKityMinder()) {
      this.editor = new _MDKityMinderFileEditor["default"](this.containerDiv);
    } else if (fileInfo.isBabelOffice()) {
      this.editor = new _MDTipTapEditor["default"](this.containerDiv);
      // this.editor.openFile(fileInfo, fileInfo.getCurVersion());
    } else if (fileInfo.isDrawio()) {
      this.editor = new _MDDrawioEditor["default"](this.containerDiv);
    } else if (fileInfo.canDispWithTextBrowser() || fileInfo.canDispInWebBrowser()) {
      this.editor = new _MDTextFileBrowser["default"](this.containerDiv);
    } else if (fileInfo.isVideo() || fileInfo.isAudio()) {
      this.editor = new _MDAVFileBrowser["default"](this.containerDiv);
    } else if (fileInfo.isMail()) {
      this.editor = new _MDMailDisplayView["default"](this.containerDiv);
    } else if (fileInfo.isPdf()) {
      this.editor = new _MDPdfOriginFileDisplayView["default"](this.containerDiv);
    } else if (fileInfo.isOfficeFile()) {
      this.editor = new _MDOfficeDisplayView["default"](this.containerDiv);
    } else if (fileInfo.isImage()) {
      this.editor = new _MMPCImageEditor["default"](this.containerDiv, {
        editorViewCtl: this
      });
    }
    this.editor && this.editor.openFile(fileInfo, this.curVer, callback);
    // };
    if (fileInfo.getLinkFileUrl()) {
      _createSinglePageEditor.call(this, undefined, callback);
    }
    Dispatcher.trigger(MDEvents.HIDE_ZOOM_BAR);
  }
  function _createSinglePageEditor(comment, callback, searchText) {
    var _this = this;
    var self = this;
    var imgs = this.m_board.getImgPdfObjectsForVersion(this.curVer);
    var curFileInfo = this.fileInfoArr[this.fileIndex];
    var fileId = curFileInfo.getFileId();
    var ver = self.curVer;
    if (imgs.length < 1 && !self.m_board.canDispWithSVG() && !curFileInfo.isPdf()) {
      if (curFileInfo.isImage() && curFileInfo.canDownload() || curFileInfo.getLinkFileUrl()) {
        curFileInfo.setOnlyDisp(true);
      } else {
        return;
      }
    } else {
      curFileInfo.setOnlyDisp(false);
    }
    function checkCreateEditor(next) {
      if (self.m_board.canDispWithSVG()) {
        self.editor = new _MDPCSVGView["default"](self.containerDiv, {
          editorViewCtl: self
        });
        next();
      } else if (self.m_board.isOperateOnPDFFile() && self.m_board.getPageCountByVersion(self.curVer) == 1) {
        if (self.m_board.isCADFile() && (!app.isInClient() || app.isInClient() && app.isClientFlashReady())) {
          MMCommonFun.getCadDocumentDispPath(fileId, ver, function (url, type) {
            var files = url.split("?");
            if (files.length < 1) {
              return;
            }
            var str = files[0];
            var ext = str.substr(-3).toLocaleLowerCase();
            if (type == "swf") {
              self.editor = new _MDSWFEditor["default"](self.containerDiv, {
                editorViewCtl: self
              });
            } else {
              self.editor = new _MDPCSinglePagePdfView["default"](self.containerDiv, {
                editorViewCtl: self
              });
            }
            next(url, type);
          }, function fail() {
            return;
          });
          return;
        } else {
          MMCommonFun.canUseSWF2DispPdf({
            fileId: fileId,
            version: ver
          }, function () {
            self.editor = new _MDSWFEditor["default"](self.containerDiv, {
              editorViewCtl: self,
              useGetDispUrl: true
            });
            next();
          }, function () {
            self.editor = new _MDPCSinglePagePdfView["default"](self.containerDiv, {
              editorViewCtl: self
            });
            next();
          });
        }
      } else {
        self.editor = new _MMPCImageEditor["default"](self.containerDiv, {
          editorViewCtl: self
        });
        next();
      }
    }
    checkCreateEditor(function (url, type) {
      _this.editor.setDispForVersion(true); // 只显示指定的版本的批注
      _this.editor.setImgMarkerCtl(_MMImageMarkerCtl["default"]);
      if (imgs.length > 0 && _this.editor) {
        var opt = {
          url: url,
          type: type
        };
        var self = _this;
        _this.editor.displayObject(imgs[0], opt, function () {
          if (comment) {
            if (comment.getFileVersion() == imgs[0].getFileVersion()) {
              var mainEditor = _MDPcMobileEditorCommonFun["default"].getMainEditor();
              Dispatcher.trigger(MDEvents.COMMENT_CLICKED, mainEditor, comment);
            } else {
              _MDSnackbarView["default"].show(BabelStr.str(5094));
            }
          }
          if (searchText) {
            Dispatcher.trigger(MDEvents.Search_pdf_text_cliked, {
              editorViewCtl: self.editor.editorViewCtl,
              searchText: searchText
            });
          }
          if (callback) {
            self.$imgLayer && self.$imgLayer.remove();
            setTimeout(function () {
              self.$imgLayer && self.$imgLayer.remove();
            }, 400);
            callback();
          }
          self.checkToEnablePrivateMouseWheel();
          Dispatcher.trigger(MDEvents.ZOOM_CHANGED, {
            editorViewCtl: self
          });
        });
      } else {
        console.error("----- 获取 image 对象错误，或者创建 editor 错误！");
      }
    });
  }
  function _createMultiPageDocEditor(comment, callback, searchText, onlyDisplay) {
    var self = this;
    var pageSpace = 0;
    var parmas = {
      whiteboard: this.m_board,
      containerDiv: this.containerDiv,
      pageSpacing: pageSpace,
      dispVer: this.curVer,
      editorViewCtl: this,
      onlyDisplay: onlyDisplay
    };
    this.editor = new _MMPDFCollectionView["default"](parmas, function () {
      self.checkToEnablePrivateMouseWheel();
      if (comment) {
        self.editor.scrollToShowObj(comment, function () {
          var mainEditor = _MDPcMobileEditorCommonFun["default"].getMainEditor();
          Dispatcher.trigger(MDEvents.COMMENT_CLICKED, mainEditor, comment);
        });
      }
      if (searchText) {
        Dispatcher.trigger(MDEvents.Search_pdf_text_cliked, {
          editorViewCtl: self.editor.editorViewCtl,
          searchText: searchText
        });
      }
      if (callback) {
        callback();
      }
    });
    this.editor.setImgMarkerCtl(_MMImageMarkerCtl["default"]);
  }
  function _create3DEditor(comment, callback) {
    var curFileInfo = this.fileInfoArr[this.fileIndex];
    this.editor = new _MD3DEditor["default"](this.containerDiv, {
      editorViewCtl: this
    });
    var self = this;
    this.checkToEnablePrivateMouseWheel();
    var commentFile = this.m_board;
    var imgs = this.m_board.getDispFilePath(curFileInfo, this.curVer, function (path) {
      self.editor.initWith3DFile(curFileInfo, commentFile, path, function () {
        if (comment) {
          self.editor.focusComment(comment);
        }
        if (callback) {
          callback();
        }
      });
    });
  }
  function _createHtmlBrowser(comment, callback) {
    var curFileInfo = this.fileInfoArr[this.fileIndex];
    if (window.dispHtmlInIframe) {
      this.editor = new _MDHtmlRender["default"](this.containerDiv, {
        editorViewCtl: this
      });
      var self = this;
      this.checkToEnablePrivateMouseWheel();
      var commentFile = this.m_board;
      var imgs = this.m_board.getDispFilePath(curFileInfo, this.curVer, function (path) {
        self.editor.initWithHtmlFile(curFileInfo, commentFile, path, function () {
          if (comment) {
            self.editor.focusComment(comment);
          }
          if (callback) {
            callback();
          }
        });
      });
    } else {
      this.editor = new _MDTextFileBrowser["default"](this.containerDiv);
      this.editor.openFile(curFileInfo, this.curVer, callback);
      Dispatcher.trigger(MDEvents.HIDE_ZOOM_BAR);
    }
  }
  function _getBoardByIndex(index) {
    var board = null;
    if (index < this.boardArr.length) {
      board = this.boardArr[index];
    }
    return board;
  }
  function _getCurPdfPagesCount() {
    var editor = this.editor;
    var fileInfo = this.getCurrentFileInfo();
    if (!fileInfo.dispNeedWhiteBoard()) {
      return 1;
    } else if (fileInfo.canDispInOpenGL()) {
      return 1;
    }
    var ver = this.getVersionShowing();
    return this.m_board.getPageCountByVersion(ver);
  }
  function _getCurPdfPage() {
    var editor = this.editor;
    var fileInfo = this.getCurrentFileInfo();
    if (!fileInfo.dispNeedWhiteBoard()) {
      return 0;
    } else if (editor && !fileInfo.canDispInOpenGL()) {
      return editor.getCurrentFilePageIndex();
    }
    return 0;
  }
  function _currentFileIsPdf() {
    if (!this.m_board) {
      return null;
    }
    return this.m_board.isOperateOnPDFFile();
  }

  //----------------------------------------------------------------------------------------------------------

  return {
    constructor: MDPCEditorViewController,
    registerEvents: function registerEvents() {
      var self = this;
      this.enableMouseWheel(true);
    },
    clearEvents: function clearEvents() {
      this.enableMouseWheel(false);
    },
    enableMouseWheel: function enableMouseWheel(enable) {
      var self = this;
      var curFileInfo = this.getCurrentFileInfo();
      if (!curFileInfo) {
        return;
      }
      if (enable) {
        if (curFileInfo && !curFileInfo.dispNeedWhiteBoard()) {} else if (curFileInfo && curFileInfo.canDispInOpenGL() && this.editor) {
          this.editor.enableMouseWheel(enable);
        } else {
          $(this.containerDiv).on("mousewheel", function (e) {
            self.onMouseWheel(e);
          });
          $(".scroll-content").on("mousewheel", function (e) {
            e.preventDefault();
          });
        }
      } else {
        if (!curFileInfo.dispNeedWhiteBoard()) {} else if (curFileInfo && curFileInfo.canDispInOpenGL() && this.editor) {
          this.editor.enableMouseWheel(enable);
        } else {
          $(this.containerDiv).off("mousewheel");
          $(".scroll-content").off("mousewheel");
        }
      }
    },
    onMouseWheel: function onMouseWheel(e) {
      if (!this.editor || !this.editor.pinchStart) {
        return;
      }
      var deltaRatio = 1.05;
      var time = 1000;
      var event = e.originalEvent;
      var delta = 0;
      var self = this;
      e.stopPropagation();

      // if (event.wheelDelta) { /* IE/Opera. */
      //         delta = event.wheelDelta/120;
      // } else if (event.detail) { /** Mozilla case. */
      //         * In Mozilla, sign of delta is different than in IE.
      //          * Also, delta is multiple of 3.

      //         delta = -event.detail/3;
      // }
      // console.log('--*-- mouse wheel delta', event.wheelDelta);

      // if (delta == 0) {
      //   return;
      // };

      if (event.deltaY > 0) {
        deltaRatio = 1 / deltaRatio;
      }
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.editor.pinchMove(deltaRatio);
      } else if (this.editor.pinchStart) {
        // wheel start
        this.editor.pinchStart();
      }
      this.timeout = setBabelTimeout(function () {
        // wheel end
        self.timeout = null;
        self.editor.pinchEnd(deltaRatio);
      }, time);
    },
    // displayFiles : function(fileArr, version, curFileIndex, callback, opt_silent) {
    //   var fileInfo = null;
    //   if (fileArr.length == 0) {
    //     return;
    //   }
    //   this.fileIndex = curFileIndex;
    //   g_pcEditorCtl = this;
    //   this.fileInfoArr = fileArr;
    //   this.boardArr = new Array(fileArr.length);

    //   if (!(_.isNumber(version) && !_.isNaN(version) && version >= 0)) {
    //     fileInfo = this.fileInfoArr[this.fileIndex];
    //     version = fileInfo.getCurVersion();
    //   }
    //   this.curVer = version;
    //   _initEditorWithCurrentFile.call(this, callback, opt_silent);

    // },

    displayFiles: function displayFiles(parameters) {
      var fileArr = parameters.fileInfos;
      var version = parseInt(parameters.version);
      var curFileIndex = parameters.curFileIndex;
      var callback = parameters.callback;
      var opt_silent = parameters.opt_silent;
      var commentId = parameters.commentId;
      var searchText = parameters.searchText;
      this.initParameters = parameters;
      console.assert(fileArr, "displayFiles called error!");
      var fileInfo = null;
      if (fileArr.length == 0) {
        return;
      }
      this.fileIndex = curFileIndex;
      g_pcEditorCtl = this;
      this.fileInfoArr = fileArr;
      this.boardArr = new Array(fileArr.length);
      var self = this;
      if (!(_.isNumber(version) && !_.isNaN(version) && version >= -1)) {
        fileInfo = this.fileInfoArr[this.fileIndex];
        _MMFileInfo["default"].prepareLinkedFileInfo(fileInfo, function () {
          if (fileInfo.isShortcuts()) {
            fileInfo = fileInfo.getShortCutsTargetFile();
          }
          version = fileInfo.getCurVersion();
          self.curVer = version;
          _initEditorWithCurrentFile.call(self, callback, opt_silent, commentId, searchText);
        });
      } else {
        this.curVer = version;
        _initEditorWithCurrentFile.call(this, callback, opt_silent, commentId, searchText);
      }
    },
    boardArrPageNumChanged: function boardArrPageNumChanged() {},
    checkToEnablePrivateMouseWheel: function checkToEnablePrivateMouseWheel() {
      if (!this.m_board) {
        return;
      }
      Dispatcher.trigger(MDEvents.HIDE_ZOOM_BAR);
      var curFileInfo = this.fileInfoArr[this.fileIndex];
      if (!curFileInfo.dispNeedWhiteBoard()) {} else if (this.m_board.isOperateOnPDFFile() && this.m_board.getPageCount() > 1) {
        this.enableMouseWheel(false);
      } else if (curFileInfo.canDispInOpenGL() || this.m_board.isCADFile()) {
        this.enableMouseWheel(false);
      } else {
        this.enableMouseWheel(false);
        Dispatcher.trigger(MDEvents.DISPLAY_ZOOM_BAR);
      }
    },
    setAllBoards: function setAllBoards(boardArr, fileIndex) {
      this.boardArr = boardArr;
      this.fileIndex = fileIndex;
    },
    changeToNextFile: function changeToNextFile(next, animated, callback) {
      var step = 0;
      if (next && this.fileIndex < this.boardArr.length - 1) {
        step = 1;
      }
      if (!next && this.fileIndex > 0) {
        step = -1;
      }
      if (step != 0) {
        Dispatcher.trigger(MDEvents.beforeChangeToNextFile);
        this.closeBoard(this.fileIndex);
        this.fileIndex += step;
        this.curVer = -1;
        _initEditorWithCurrentFile.call(this, function (board) {
          Dispatcher.trigger(MDEvents.afterChangeToNextFile);
          if (callback) {
            callback(board);
          }
        });
      }
    },
    closeBoard: function closeBoard(index) {
      var board = this.boardArr[index];
      var fileInfo = this.getCurrentFileInfo();
      if (board) {
        if (!fileInfo.dispNeedWhiteBoard()) {} else if (fileInfo.canDispInOpenGL() || fileInfo.canDispInWebBrowser()) {} else {
          board.clearPdfPage();
          getMMPdfLoader().clear();
        }
      }
    },
    changeToFile: function changeToFile(index, callback) {
      var pgNum = this.boardArr.length;
      if (index >= 0 && index < pgNum && this.fileIndex != index) {
        Dispatcher.trigger(MDEvents.beforeChangeToNextFile);
        this.closeBoard(this.fileIndex);
        this.fileIndex = index;
        this.curVer = -1;
        _initEditorWithCurrentFile.call(this, function (board) {
          Dispatcher.trigger(MDEvents.afterChangeToNextFile);
          if (callback) {
            callback(board);
          }
        });
      }
      return this.fileIndex;
    },
    hasNextFile: function hasNextFile(next) {
      var fileIndex = this.fileIndex;
      var pgNum = this.boardArr.length;
      if (next && fileIndex < pgNum - 1) {
        return true;
      }
      if (!next && fileIndex > 0) {
        return true;
      }
      return false;
    },
    createCellForFile: function createCellForFile(pageIndex) {
      return new _MMNetDiskBoardCell["default"]();
    },
    initCell: function initCell(cell, pageIndex) {
      cell.setIndex(pageIndex);
      var board = _getBoardByIndex.call(this, pageIndex);
      cell.setBoard(board);
    },
    refreshView: function refreshView(board, callback) {
      // this.boardArrPageNumChanged();

      if (this.m_board == board) {
        this.displayInRect(board);
      }
    },
    displayInRect: function displayInRect(board, lgRct, callback) {
      if (this.m_board == board && this.editor) {
        this.editor.refreshLgPageInRect(lgRct);
      }
      callback && callback();
    },
    getAssistantCanvas: function getAssistantCanvas() {
      return this.getOperationLayer();
    },
    convertPointFromAssistView2Editor: function convertPointFromAssistView2Editor(pos) {
      // todo: this implementation is from the EditorView
      var cell = this.getCurrentCell();
      if (!cell || !cell.getEditor()) {
        return pos;
      }
      var editor = cell.getEditor();
      var newpos = pos.clone();
      var to = editor.getCommentLayer();
      var from = this.getAssistantCanvas();
      var converted = MMCommonFun.convertPointBetweenElements(from, to, pos);
      newpos.x = converted.x;
      newpos.y = converted.y;
      return newpos;
    },
    convertPointFromEditor2AssistView: function convertPointFromEditor2AssistView(pos) {
      var cell = this.getCurrentCell();
      if (!cell || !cell.getEditor()) {
        return pos;
      }
      var editor = cell.getEditor();
      var newpos = pos.clone();
      var to = this.getAssistantCanvas();
      var from = editor.getCommentLayer();
      var converted = MMCommonFun.convertPointBetweenElements(from, to, pos);
      newpos.x = converted.x;
      newpos.y = converted.y;
      return newpos;
    },
    logic2AssistViewPoint: function logic2AssistViewPoint(pos) {
      var trsfm = this.getDivTransformer();
      if (!trsfm) {
        return pos;
      }
      var devicePoint = trsfm.lg2dvPoint(pos);
      var newPoint = this.convertPointFromEditor2AssistView(devicePoint);
      return newPoint;
    },
    assistView2LogicPoint: function assistView2LogicPoint(pos) {
      var trsfm = this.getDivTransformer();
      if (!trsfm) {
        return pos;
      }
      var newpos = this.convertPointFromAssistView2Editor(pos);
      var logicPoint = trsfm.dv2lgPoint(newpos);
      return logicPoint;
    },
    clicked: function clicked(e) {
      this.scrollToShowFullPage();
    },
    refreshSize: function refreshSize(ignoreScale) {
      if (!this.editor) {
        return;
      }
      var curFileIsPdf = _currentFileIsPdf.call(this);
      var curPdfPos;
      if (curFileIsPdf) {
        var curPdfPos = this.getCurFileEditor().getCenterRatioPosition();
      }
      if (!this.editor) {
        return;
      }

      // if (!curFileIsPdf) {
      this.editor.refreshSize(ignoreScale);
      // };

      if (curFileIsPdf) {
        this.getCurFileEditor().restoreCenterPostion(curPdfPos);
      }
    },
    getObjsInView: function getObjsInView() {
      var cell = this.getCurrentCell();
      if (cell != undefined && cell != null) {
        return cell.getEditor().getObjsInView();
      }
      return [];
    },
    getDivTransformer: function getDivTransformer() {
      var cell = this.getCurrentCell();
      if (cell && cell.getEditor()) {
        return cell.getEditor().getDivTransformer();
      }
      return null;
    },
    getCanvasTransformer: function getCanvasTransformer() {
      var cell = this.getCurrentCell();
      if (cell && cell.getEditor()) {
        return cell.getEditor().getCanvasTransformer();
      }
      return null;
    },
    showCommentLine: function showCommentLine() {
      // console.log("显示批注线")
    },
    getPicObject: function getPicObject() {
      if (this.editor && this.editor.getPicObject) {
        return this.editor.getPicObject();
      }
      return null;
    },
    getObjectNatureSize: function getObjectNatureSize() {
      var cell = this.getCurrentCell();
      if (cell != undefined && cell != null) {
        return cell.getEditor().getObjectNatureSize();
      }
      return null;
    },
    getFileCount: function getFileCount() {
      var boardArr = this.boardArr;
      return boardArr.length;
    },
    getCurrentFileIndex: function getCurrentFileIndex() {
      return this.fileIndex;
    },
    getCurrentFilePageCount: function getCurrentFilePageCount() {
      return _getCurPdfPagesCount.call(this);
    },
    getCurrentFilePageIndex: function getCurrentFilePageIndex() {
      return _getCurPdfPage.call(this);
    },
    getCurFileEditor: function getCurFileEditor() {
      return this.editor;
    },
    getFileThumbnailsInfo: function getFileThumbnailsInfo(size, callback) {
      if (this.boardArr.length <= 0) {
        return [];
      }
      var thumbs = [];
      // for (var i = 0; i < this.boardArr.length; i++) {
      //   var board = this.boardArr[i];
      //   if (board) {
      //     thumbs.push(board.getFileThumbnailInfo(size));
      //   } else {
      //     thumbs.push(undefined);
      //     _openWhiteboardByInfo.call(this, this.fileInfoArr[i], function(board,
      //       index) {
      //       var thumbInfo = board.getFileThumbnailInfo(size);
      //       if (callback) {
      //         setBabelTimeout(function() {

      //           callback(thumbInfo, index);

      //         }, 100)
      //       };
      //     }, function() {

      //     });
      //   }

      // }

      for (var i = 0; i < this.fileInfoArr.length; i++) {
        var fileInfo = this.fileInfoArr[i];
        var url = fileInfo.getThumbnailUrl(size);
        var thumbInfo = {};
        thumbInfo.url = url;
        thumbInfo.imgSize = {
          x: 400,
          y: 400
        };
        thumbInfo.fileName = fileInfo.getFileName();
        thumbs.push(thumbInfo);
      }
      return thumbs;
    },
    refreshCommentsInEditor: function refreshCommentsInEditor() {
      var editor = this.editor;
      if (editor) {
        var objCtl = _MMObjElementsController["default"].getSingleInstance();
        objCtl.removeAllDivsForEditor(editor);
        editor.refreshCommentsInEditor();
      }
    },
    refreshObjsInEditor: function refreshObjsInEditor() {
      var editor = this.editor;
      if (editor) {
        var objCtl = _MMObjElementsController["default"].getSingleInstance();
        objCtl.removeAllDivsForEditor(editor);
        editor.refreshObjsInEditor();
      }
    },
    changeDirection: function changeDirection() {},
    getCurrentBoard: function getCurrentBoard() {
      return this.m_board;
    },
    getAllBoards: function getAllBoards() {
      return this.boardArr;
    },
    getAllFileInfo: function getAllFileInfo() {
      return this.fileInfoArr;
    },
    getCurrentFileInfo: function getCurrentFileInfo() {
      if (!this.fileInfoArr) {
        return null;
      }
      var fileInfo = this.fileInfoArr[this.fileIndex];
      if (fileInfo && fileInfo.isShortcuts()) {
        fileInfo = fileInfo.getShortCutsTargetFile();
      }
      return fileInfo;
    },
    getScale: function getScale() {
      var editor = this.editor;
      if (editor) {
        return editor.getScale();
      }
      return -1;
    },
    getCommentLayer: function getCommentLayer() {
      var editor = this.editor;
      if (editor) {
        return editor.getCommentLayer();
      }
      return $();
    },
    getOperationCenter: function getOperationCenter() {
      return null;
    },
    removeFromSuperView: function removeFromSuperView() {
      this.clearEvents();
      Dispatcher.off(null, null, this);
      if (!this.editor) {
        return;
      }
      this.editor.removeFromSuperView();
      window.g_pcEditorCtl = g_pcEditorCtl = null;
      Dispatcher.trigger(MDEvents.UpdateChannleUnreadNum);
      this.penZoneCtl && this.penZoneCtl.clearAll();
      this.penZoneCtl = null;
    },
    changeVersion2currentVersion: function changeVersion2currentVersion(callback, fail) {
      var curFileInfo = this.fileInfoArr[this.fileIndex];
      var curVer = curFileInfo.getCurVersion();
      if (this.curVer != curVer) {
        this.changeVersion(curVer, callback, fail);
      }
    },
    changeVersion: function changeVersion(ver_, callback, fail) {
      var _this2 = this;
      var self = this;
      if (this.curVer != ver_) {
        var board = this.getCurrentBoard();
        board.sendWeldMark2Server(this.curVer);
        board.sendScribbles2Server(this.curVer, function () {
          var lastVer = _this2.curVer;
          var curFileInfo = _this2.fileInfoArr[_this2.fileIndex];
          _checkVersionReady.call(_this2, curFileInfo, ver_, function () {
            _this2.curVer = ver_;
            // this.m_board.setVersionShowing(this.curVer);
            _recordReadMark.call(_this2);

            // 分享参与者不能预览分享者放置在根目录的 html 文件, 即 parentFolderId == 0 但 owner 不是自己的文件
            // 这样的 html 文件只能预览其源代码了
            if (curFileInfo.canDispInWebBrowser()) {
              _this2.editor.removeFromSuperView();
              _createHtmlBrowser.call(_this2, null, callback);
            } else if (curFileInfo.canDispWithGSCAD()) {
              _this2.editor.openFile(curFileInfo, _this2.curVer, callback);
            } else if (curFileInfo.isOnlyDisp() && curFileInfo.isPdf()) {
              _createMultiPageDocEditor.call(_this2, comment, callback, searchText, true);
            } else if (!curFileInfo.dispNeedWhiteBoard() || curFileInfo.canDispInWebBrowser()) {
              // 根目录分享的 html ，参与者只能看源码
              if (curFileInfo.canDispWithTextBrowser() || curFileInfo.canDispInWebBrowser()) {
                _this2.editor.openFile(curFileInfo, _this2.curVer, callback);
              } else if (curFileInfo.isOfficeFile()) {
                _this2.editor.openFile(curFileInfo, _this2.curVer, callback);
              } else if (curFileInfo.canDispWithKityMinder()) {
                _this2.editor.openFile(curFileInfo, _this2.curVer, callback);
              } else if (curFileInfo.isDrawio()) {
                _this2.editor.openFile(curFileInfo, _this2.curVer, callback);
              } else if (curFileInfo.isVideo() || curFileInfo.isAudio()) {
                _this2.editor.removeFromSuperView();
                _this2.editor = new _MDAVFileBrowser["default"](_this2.containerDiv);
                _this2.editor.openFile(curFileInfo, _this2.curVer, callback);
              }
            } else if (_this2.m_board.isOperateOnPDFFile() && _this2.m_board.getPageCountByVersion(ver_) > 1) {
              if (_this2.m_board.getPageCountByVersion(lastVer) < 2) {
                _this2.editor.removeFromSuperView();
                _createMultiPageDocEditor.call(_this2, undefined, callback);
              } else {
                _this2.editor.setBoard(_this2.m_board);
                _this2.editor.changeVersion(ver_);
                if (_.isFunction(callback)) {
                  callback();
                }
              }
            } else if (curFileInfo.canDispInOpenGL()) {
              _this2.editor.removeFromSuperView();
              _create3DEditor.call(_this2, null, callback);
            } else {
              if (_this2.m_board.getPageCountByVersion(lastVer) > 1) {
                _this2.editor.removeFromSuperView();
                _createSinglePageEditor.call(_this2, undefined, callback);
              } else {
                var imgs = _this2.m_board.getImgPdfObjectsForVersion(ver_);
                if (imgs.length > 0) {
                  _this2.editor.displayObject(imgs[0], function () {
                    if (_.isFunction(callback)) {
                      callback();
                    }
                    Dispatcher.trigger(MDEvents.ZOOM_CHANGED, {
                      editorViewCtl: self
                    });
                  });
                }
              }
            }
            if (!_this2.verChangedByMsg) {
              _this2._chekToSendVersionMsg(ver_);
            }
            if (curFileInfo.isInTrash() && _this2.editor) {
              _this2.editor.setReadOnly();
            }
          }, function () {
            console.error("---- open version failed!");
            if (fail) {
              fail();
            }
          });
        }, function () {
          _MDMessageView["default"].error(BabelStr.str(5095));
          fail();
        });
      } else {
        callback && callback();
      }
    },
    setCurOperation: function setCurOperation(oper_, objs_, comm_) {
      var editor = this.editor;
      var fileInfo = this.getCurrentFileInfo();
      if (editor) {
        if (!fileInfo.dispNeedWhiteBoard()) {} else if (fileInfo.canDispInOpenGL()) {} else {
          editor.setCurOperation(oper_, objs_, comm_);
        }
      }
    },
    getCurOperation: function getCurOperation() {
      var editor = this.editor;
      if (editor) {
        return editor.getCurOperation();
      }
      return null;
    },
    getCurEditor: function getCurEditor() {
      return this.editor;
    },
    closeCommentPanel: function closeCommentPanel() {
      var editor = this.editor;
      if (editor) {
        editor.closeCommentPanel();
      }
    },
    changeScale: function changeScale(scale, callback) {
      var self = this;
      var editor = this.editor;
      if (editor) {
        editor.changeScale(scale, function () {
          console.log("------------> scaled changed to:", scale);
          if (callback) {
            callback();
          }
          self._checkToSendWindowPos();
        });
      }
    },
    _checkToSendWindowPos: function _checkToSendWindowPos() {
      var fileInfo = this.getCurrentFileInfo();
      var salonInfo = fileInfo.getSalonInfo();
      var versionDisp = this.getVersionShowing();
      if (salonInfo && salonInfo.isCurrentUserSpeaker()) {
        var centerPos = this.editor.getCenterRatioPosition();
        var lgCenterpos = this.editor.getCenterLogicPosition();
        var scale = this.editor.getScale();
        var msg = {
          type: _MD_SALON_MSG_TYPE["default"].WindowPos,
          fileDim: "2D",
          fileId: fileInfo.getFileId(),
          versionDisp: versionDisp,
          center: centerPos,
          winW2DocW: scale,
          lgCenter: lgCenterpos
        };
        _MMEnterpriseController["default"].broadCastSalonMsg(fileInfo.getFileId(), msg, function () {}, function () {});
      }
    },
    _chekToSendMouseClickPos: function _chekToSendMouseClickPos(logicPoint) {
      var self = this;
      var fileInfo = this.getCurrentFileInfo();
      var salonInfo = fileInfo.getSalonInfo();
      var versionDisp = this.getVersionShowing();
      if (salonInfo && salonInfo.isCurrentUserSpeaker()) {
        var msg = {
          type: _MD_SALON_MSG_TYPE["default"].MouseClickPos,
          fileDim: "2D",
          fileId: fileInfo.getFileId(),
          versionDisp: versionDisp,
          clickPos: logicPoint
        };
        _MMEnterpriseController["default"].broadCastSalonMsg(fileInfo.getFileId(), msg, function () {
          console.log(msg);
        }, function () {});

        // 本地显示鼠标点击
        var msgModel = new _MDSalonMsg["default"](msg);
        self._processSalonMouseClickMsg(msgModel);
      }
    },
    _chekToSendVersionMsg: function _chekToSendVersionMsg(ver_) {
      var self = this;
      var fileInfo = this.getCurrentFileInfo();
      if (!fileInfo.getSalonInfo) {
        return;
      }
      var salonInfo = fileInfo.getSalonInfo();
      var versionDisp = ver_;
      if (salonInfo && salonInfo.isCurrentUserSpeaker()) {
        var msg = {
          type: _MD_SALON_MSG_TYPE["default"].ChangeVersion,
          fileId: fileInfo.getFileId(),
          versionDisp: versionDisp
        };
        _MMEnterpriseController["default"].broadCastSalonMsg(fileInfo.getFileId(), msg, function () {
          console.log(msg);
        }, function () {});
      }
    },
    zoomToFit: function zoomToFit(callback) {
      var editor = this.editor;
      if (editor) {
        editor.zoomToFit();
      }
    },
    rotatePage: function rotatePage(callback) {
      var editor = this.editor;
      if (editor) {
        editor.rotate90();
      }
    },
    scrollToShowFile: function scrollToShowFile(fileInfo, finishCall) {
      var self = this;
      var curFileInfo = this.getCurrentFileInfo();
      if (curFileInfo == fileInfo) {
        if (finishCall) {
          finishCall(self.getCurrentBoard());
        }
      } else {
        var index = -1;
        for (var i = 0; i < this.fileInfoArr.length; i++) {
          if (fileInfo == this.fileInfoArr[i]) {
            index = i;
            break;
          }
        }
        if (index != -1) {
          this.changeToFile(index, function () {
            if (finishCall) {
              finishCall(self.getCurrentBoard());
            }
          });
        }
      }
    },
    scrollToFile: function scrollToFile(index, animated, succ) {
      if (this.boardArr.length <= 0) {
        return;
      }
      if (index < 0) {
        index = 0;
      }
      if (index >= this.boardArr.length) {
        index = this.boardArr.length - 1;
      }
      this.changeToFile(index);
      if (typeof succ === "function") {
        succ();
      }
    },
    commentCreated: function commentCreated(board, pgIndex) {
      if (board != this.m_board) {
        return;
      }
      var pgSize = this.m_board.getPageSize();
      var rect = new _MMRect["default"]();
      if (pgIndex instanceof _MMRect["default"]) {
        rect = pgIndex;
      } else {
        rect.setRct(0, pgIndex * pgSize.height, pgSize.width, pgSize.height);
      }
      this.penZoneCtl && this.penZoneCtl.refreshData();
      this.displayInRect(board, rect);
    },
    _fileSignatureChanged: function _fileSignatureChanged(fileData, msgContent) {
      var _this3 = this;
      var fileId = fileData.fileId;
      var version = fileData.version;
      var fileInfo = this.getCurrentFileInfo();
      var curFileId = fileInfo.getFileId();
      if (curFileId == fileId && this.m_board) {
        this.m_board.updateSignatures(fileId, version, function () {
          _this3.getCurEditor().refreshObjsInCanvas();
        });
      }
    },
    commentDeleted: function commentDeleted(board, pgIndex) {
      if (board != this.m_board) {
        return;
      }
      var curFileInfo = this.getCurrentFileInfo();
      if (!curFileInfo.dispNeedWhiteBoard()) {} else if (curFileInfo.canDispInOpenGL()) {} else {
        var pgSize = this.m_board.getPageSize();
        var rect = new _MMRect["default"]();
        if (pgIndex instanceof _MMRect["default"]) {
          rect = pgIndex;
        } else {
          rect.setRct(0, pgIndex * pgSize.height, pgSize.width, pgSize.height);
        }
        this.displayInRect(board, rect);
      }
    },
    followTeacher: function followTeacher(dispPosition, callback) {
      var curFileInfo = this.getCurrentFileInfo();
      if (curFileInfo.getFileId() != dispPosition.fileId || this.editor) {
        // return;
      }
      this.editor.followTeacher(dispPosition, callback);
    },
    salonMsgManage: function salonMsgManage(salonMsg) {
      var fileId = salonMsg.getFileId();
      var curFileInfo = this.getCurrentFileInfo();
      if (curFileInfo.getFileId() != fileId) {
        return;
      }

      // --------------------------- 使用队列对消息进行缓冲
      if (!this.salonMsgQueue) {
        this.salonMsgQueue = [];
      } else {
        // -------------------------------- 清除队列中不是当前文档的消息
        var i = 0;
        while (i < this.salonMsgQueue.length) {
          var oldMsg = this.salonMsgQueue[i];
          if (oldMsg.getFileId() != fileId) {
            this.salonMsgQueue.splice(i, 1);
          } else {
            i++;
          }
        }
        var type = salonMsg.getType();
        switch (type) {
          case _MD_SALON_MSG_TYPE["default"].WindowPos:
          case _MD_SALON_MSG_TYPE["default"].MouseClickPos:
          case _MD_SALON_MSG_TYPE["default"].ChangeVersion:
            // ---------------------- 去除旧的相同类型的消息
            var i = 0;
            while (i < this.salonMsgQueue.length) {
              var oldMsg = this.salonMsgQueue[i];
              if (oldMsg.getType() == type) {
                this.salonMsgQueue.splice(i, 1);
              } else {
                i++;
              }
            }
            break;
        }
      }

      // -------------------------------------------最新消息入队列
      this.salonMsgQueue.push(salonMsg);
      if (!this.salonMsgProcessing) {
        this._processNextMsgInQueue();
      }
    },
    _processNextMsgInQueue: function _processNextMsgInQueue() {
      var self = this;
      var salonMsg = this.salonMsgQueue.shift();
      this.salonMsgProcessing = salonMsg;
      if (salonMsg) {
        var fileId = salonMsg.getFileId();
        var curFileInfo = this.getCurrentFileInfo();
        if (curFileInfo.getFileId() != fileId) {
          this._processNextMsgInQueue();
          return;
        }
        this._checkToChangeDispVersion(salonMsg, function () {
          var type = salonMsg.getType();
          switch (type) {
            case _MD_SALON_MSG_TYPE["default"].WindowPos:
              var dispPos = salonMsg.get2DPosInfo();
              if (dispPos) {
                self.followTeacher(dispPos, function () {
                  self._processNextMsgInQueue();
                });
              } else {
                self._processNextMsgInQueue();
              }
              break;
            case _MD_SALON_MSG_TYPE["default"].MouseClickPos:
              self._processSalonMouseClickMsg(salonMsg);
              setBabelTimeout(function () {
                self._processNextMsgInQueue();
              }, 1);
              break;
            case _MD_SALON_MSG_TYPE["default"].SalonPenAdd:
              self.salonPenAddEvents(salonMsg);
              setBabelTimeout(function () {
                self._processNextMsgInQueue();
              }, 1);
              break;
            case _MD_SALON_MSG_TYPE["default"].SalonEaraser:
              self.salonEaraserEvents(salonMsg);
              setBabelTimeout(function () {
                self._processNextMsgInQueue();
              }, 1);
              break;
            default:
              setBabelTimeout(function () {
                self._processNextMsgInQueue();
              }, 1);
          }
        }, function fail() {
          self._processNextMsgInQueue();
        });
      }
    },
    _checkToChangeDispVersion: function _checkToChangeDispVersion(salonMsg, callback, fail) {
      var type = salonMsg.getType();
      if (type != _MD_SALON_MSG_TYPE["default"].WindowPos && type != _MD_SALON_MSG_TYPE["default"].MouseClickPos && type != _MD_SALON_MSG_TYPE["default"].ChangeVersion) {
        callback();
        return;
      }
      var self = this;
      var salonVer = salonMsg.getVersionDisp();
      if (salonVer != this.getVersionShowing()) {
        this.verChangedByMsg = true;
        this.changeVersion(salonVer, function () {
          self.verChangedByMsg = false;
          callback();
        }, function () {
          fail && fail();
        });
      } else {
        callback();
      }
    },
    _processSalonMouseClickMsg: function _processSalonMouseClickMsg(salonMsg) {
      if (salonMsg.is2D()) {
        var logicPt = salonMsg.getMouseClickPos();
        logicPt = new _MMPoint["default"](logicPt.x, logicPt.y);
        var fileInfo = this.getCurrentFileInfo();
        var salonInfo = fileInfo.getSalonInfo();
        if (salonInfo && salonInfo.hasMe()) {
          this.editor.dispSalonSpeakerMouseClick(logicPt);
        }
      } else {}
    },
    getZoomList: function getZoomList() {
      if (this.editor) {
        return this.editor.getZoomList();
      }
    },
    canChangeFile: function canChangeFile(success, fail) {
      var curFileInfo = this.getCurrentFileInfo();
      if (!curFileInfo) {
        success();
        return;
      }
      var board = this.getCurrentBoard();
      if (!board) {
        success();
        return;
      }
      var ver = this.getVersionShowing();
      board.sendWeldMark2Server(ver);
      board.sendScribbles2Server(ver, function () {
        var salonInfo = curFileInfo.getSalonInfo();
        if (salonInfo && salonInfo.hasMe()) {
          var alert = new _MDAlertView["default"]();
          alert.show({
            title: BabelStr.str(170),
            message: "<p class=\"title\">".concat(BabelStr.str(5096), "</p>"),
            className: "m-delAlertWin",
            hideCloseBtn: true,
            buttons: [{
              label: BabelStr.str(154),
              type: "done",
              onClick: function onClick() {
                if (salonInfo.isCurrentUserSpeaker()) {
                  _MMEnterpriseController["default"].closeSalon(salonInfo.getSalonId(), curFileInfo.getFileId(), function () {
                    Dispatcher.trigger(MDEvents.salonStatusChanged);
                    success();
                  }, function () {
                    _MDMessageView["default"].error(BabelStr.str(5097));
                    fail();
                  });
                } else {
                  _MMEnterpriseController["default"].leaveSalon(salonInfo.getSalonId(), function () {
                    success();
                  }, function () {
                    _MDMessageView["default"].error(BabelStr.str(5098));
                    fail();
                  });
                }
              }
            }, {
              label: BabelStr.str(155)
            }]
          });
        } else {
          success();
        }
      }, function () {
        _MDMessageView["default"].error(BabelStr.str(5095));
        fail();
      });
    },
    showCommentLayer: function showCommentLayer() {
      this.editor.showCommentLayer();
    },
    hideCommentLayer: function hideCommentLayer() {
      this.editor.hideCommentLayer();
    },
    _checkToSendPen: function _checkToSendPen(scribble) {
      var self = this;
      var fileInfo = this.getCurrentFileInfo();
      var salonInfo = fileInfo.getSalonInfo();
      var index = this.editor.getCurrentFilePageIndex();
      if (salonInfo && salonInfo.isCurrentUserSpeaker()) {
        var msg = {
          type: _MD_SALON_MSG_TYPE["default"].SalonPenAdd,
          fileDim: "2D",
          fileId: fileInfo.getFileId(),
          scribble: scribble,
          index: index
        };
        _MMEnterpriseController["default"].broadCastSalonMsg(fileInfo.getFileId(), msg, function () {
          console.log(msg);
        }, function () {});
      }
    },
    salonPenAddEvents: function salonPenAddEvents(salonMsg) {
      if (salonMsg.is2D()) {
        var scribble = salonMsg.getPenScribble();
        var fileInfo = this.getCurrentFileInfo();
        var salonInfo = fileInfo.getSalonInfo();
        var index = salonMsg.getCurrentPageIndex();
        if (salonInfo && salonInfo.hasMe()) {
          var pots = scribble.lgPts;
          var newPots = [];
          var newPot;
          for (var i = 0; i < pots.length; i++) {
            newPot = new _MMPoint["default"](pots[i].x, pots[i].y);
            newPots.push(newPot);
          }
          scribble.lgPts = newPots;
          this.editor.getCurrentBoard().addSalonScribble(scribble);
          this.editor.refreshSalonScribbleInCanvas(index);
        }
      } else {}
    },
    _checkToSendEaraser: function _checkToSendEaraser(ids) {
      var self = this;
      var fileInfo = this.getCurrentFileInfo();
      var salonInfo = fileInfo.getSalonInfo();
      var index = this.editor.getCurrentFilePageIndex();
      if (salonInfo && salonInfo.isCurrentUserSpeaker()) {
        var msg = {
          type: _MD_SALON_MSG_TYPE["default"].SalonEaraser,
          fileDim: "2D",
          fileId: fileInfo.getFileId(),
          ids: ids,
          index: index
        };
        _MMEnterpriseController["default"].broadCastSalonMsg(fileInfo.getFileId(), msg, function () {
          console.log(msg);
        }, function () {});
      }
    },
    salonEaraserEvents: function salonEaraserEvents(salonMsg) {
      if (salonMsg.is2D()) {
        var ids = salonMsg.getEaraserIds();
        var fileInfo = this.getCurrentFileInfo();
        var salonInfo = fileInfo.getSalonInfo();
        var index = salonMsg.getCurrentPageIndex();
        if (salonInfo && salonInfo.hasMe()) {
          this.editor.getCurrentBoard().removeSolonScribble(ids);
          this.editor.refreshSalonScribbleInCanvas(index);
        }
      } else {}
    },
    toggleZoomRect: function toggleZoomRect() {
      if (this._isNeedZoomRect()) {
        return this.editor.toggleZoomRect();
      }
    },
    canShowZoomRectTool: function canShowZoomRectTool() {
      if (this._isNeedZoomRect()) {
        return true;
      }
      return false;
    },
    disableZoomRectLayer: function disableZoomRectLayer() {
      if (this._isNeedZoomRect()) {
        this.editor.disableZoomRectLayer();
      }
    },
    isShowingZoomRect: function isShowingZoomRect() {
      if (this._isNeedZoomRect()) {
        return this.editor.isShowingZoomRect();
      }
    },
    _isNeedZoomRect: function _isNeedZoomRect() {
      return this.m_board.isCADFile();
    },
    getVersionShowing: function getVersionShowing() {
      return this.curVer;
    },
    refreshCurrentMainEditor: function refreshCurrentMainEditor() {
      MDPCEditorViewController.setCurrentInstance(this);
    },
    getEditorRootDiv: function getEditorRootDiv() {
      return $(this.containerDiv).parents(".p-editor-root")[0];
    },
    getEditorZoneDiv: function getEditorZoneDiv() {
      return this.containerDiv;
    },
    getEditorContentPanelDiv: function getEditorContentPanelDiv() {
      return $(this.containerDiv).parents(".editor-content-panel")[0];
    },
    isSwfEditor: function isSwfEditor() {
      return this.editor.getClassName() == "MDSWFEditor";
    },
    setPenZoneCtl: function setPenZoneCtl(ctl) {
      this.penZoneCtl = ctl;
    },
    getPenZoneCtl: function getPenZoneCtl() {
      return this.penZoneCtl;
    },
    setGraphicToolType: function setGraphicToolType(type) {
      this.graphicToolType = type;
    },
    getGraphicToolType: function getGraphicToolType(type) {
      return this.graphicToolType;
    },
    setGraphicToolCreateState: function setGraphicToolCreateState(state) {
      this.graphicToolCreateState = state;
    },
    getGraphicToolCreateState: function getGraphicToolCreateState() {
      return this.graphicToolCreateState;
    },
    _rejoinBoard: function _rejoinBoard() {
      var board = this.getCurrentBoard();
      _MMWhiteboardController["default"].rejoinBoard(board, function () {}, function (code) {
        if (code == 350) {
          _MDSnackbarView["default"].show(BabelStr.str(742));
        }
      });
    },
    canSignInEval: function canSignInEval(callback) {
      var _this4 = this;
      var fileInfo = this.getCurrentFileInfo();
      var ver = this.getVersionShowing();
      if (fileInfo) {
        fileInfo.getEvalFlowInfo(ver, function (evalFlow) {
          if (evalFlow && (evalFlow.isCurUserPassed() || evalFlow.isCurUserCreator() && fileInfo.isPassed())) {
            app.currentUser.getSignature(function (sigdata) {
              var board = _this4.getCurrentBoard();
              if (sigdata && !board.userHasSignatureForVersion(app.currentUser.getUserId(), ver)) {
                callback(sigdata);
              } else {
                callback(false);
              }
            });
          } else {
            callback(false);
          }
        });
      } else {
        callback(false);
      }
    },
    removeCommentPanel: function removeCommentPanel() {
      var editor = this.getCurEditor();
      if (editor.removeCommentPanel) editor.removeCommentPanel();
    }
  };
}());
window.MDPCEditorViewController = MDPCEditorViewController;
var _default = exports["default"] = MDPCEditorViewController;

},{"1098":1098,"1104":1104,"1109":1109,"111":111,"1111":1111,"112":112,"1122":1122,"1132":1132,"1184":1184,"1432":1432,"1451":1451,"1454":1454,"1466":1466,"1541":1541,"16":16,"205":205,"212":212,"222":222,"229":229,"230":230,"231":231,"297":297,"32":32,"33":33,"55":55,"72":72,"807":807,"818":818,"830":830,"831":831,"887":887,"893":893,"9":9,"905":905,"915":915,"916":916,"929":929,"931":931,"937":937,"942":942,"943":943}],1132:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1451);
// import MDTiptapEditorController from "./MDTiptapEditorController.js";

// import MDShareFileWindowView from "../moladisk/views/file/share/MDShareFileWindowView";

// import MDFileActionController from "../moladisk/views/file/MDFileActionController";

var MDTiptapEditor = function MDTiptapEditor(parentDiv, fileInfo) {
  this.$content = $('<div classarkdown-body" style="position:fixed;width:100%;height:100%;top:0;overflow:auto"></div>');
  $(parentDiv).append(this.$content);
};
Object.assign(MDTiptapEditor.prototype, Object.prototype, {
  contstructor: MDTiptapEditor,
  openFile: function openFile(curFileInfo, version, callback) {
    _czc && _czc.push(["_trackEvent", "预览", "Mail", "", "", ""]);
    this.fileInfo = curFileInfo;
    var fileId = curFileInfo.getFileId();
    this.tiptapServerUrl = "/netdrive/viewBabelOffice.do?fileId=".concat(fileId);
    if (curFileInfo.dispForVersion) {
      this.tiptapServerUrl += "&version=".concat(version);
    }
    curFileInfo.dispForVersion = false;
    this.initTiptap(curFileInfo);
    callback && callback();
  },
  initTiptap: function initTiptap(fileInfo) {
    Dispatcher.on(MDEvents.tiptopUploadFile, _newUpload, this);
    this.iframe = document.createElement('iframe');
    this.iframe.style.width = '100%';
    this.iframe.style.height = '100%';
    this.iframe.style.border = 'none';
    this.iframe.src = this.tiptapServerUrl;
    var originFolder = app.currentFolder;

    // 监听来自 iframe 的消息
    // window.addEventListener('message', this.handleIframeMessage.bind(this));
    var self = this;
    this.$content.append(this.iframe);
    MDLoadMaskView.remove();
    window.addEventListener('message', handleIframeMessage);
    function handleIframeMessage(event) {
      // 验证消息来源
      // if (event.origin !== this.tiptapServerUrl) return;

      switch (event.data.type) {
        case 'UPLOAD_FILE':
          handleFileUpload(event.data.file);
          break;
        case 'ONLINE_EDIT':
          handleFileEdit();
          break;
        case 'CLOSE_PANEL':
          handleFileClose();
          break;
        case 'SHARE_FILE':
          handleShare();
          break;
        case 'EDITOR_CONTENT_CHANGE':
          console.log(event.data.content);
          // this.model.set('content', event.data.content);
          break;
      }
    }
    this.handleIframeMessage = handleIframeMessage;
    function handleFileEdit() {
      var ctl = new MDFileActionController();
      ctl.setFileInfors([fileInfo]);
      ctl.onlineEditFile();
      Dispatcher.trigger(MDEvents.CloseEdit);
    }
    function handleFileClose() {
      Dispatcher.trigger(MDEvents.CloseEdit);
    }
    function handleShare() {
      // var wind = new MDShareFileWindowView({
      //   fileInfor: fileInfo,
      // });
      // wind.show();

      Dispatcher.trigger(MDEvents.ClientShare_LocalFile, {
        fileId: fileInfo.getFileId(),
        fileName: fileInfo.getFileName()
      });
    }
    function handleFileUpload(file) {
      app.currentFolder = MMNetDiskDataController.getHomeDir();
      if (!app.currentFolder.canUpload()) {
        MDMessageView.error(BabelStr.str(13120));
        return;
      }
      app.currentFolder.set("fotTiptap", true);
      MDfileUploadList.pushFile(file, undefined, undefined, undefined);
      return;
    }
    function _newUpload(fileInfo) {
      var disUrl = location.origin + MMCommonFun.getImageDispPath(fileInfo.getFileId(), -1) + "&needJump2Url=2";
      this.iframe.contentWindow.postMessage({
        type: 'UPLOAD_SUCCESS',
        fileUrl: disUrl // 假设返回中包含文件 URL
      }, this.tiptapServerUrl);
    }
  },
  getScale: function getScale() {
    return 1;
  },
  setScale: function setScale() {},
  refreshSize: function refreshSize() {},
  getClassName: function getClassName() {
    return "MDTiptapEditor";
  },
  closeCommentPanel: function closeCommentPanel() {},
  removeFromSuperView: function removeFromSuperView() {
    window.removeEventListener('message', this.handleIframeMessage);
    this.$content.remove();
  },
  // 以下是为了配合手机界面的接口
  getCurrentBoard: function getCurrentBoard() {
    return null;
  },
  getCurrentFileInfo: function getCurrentFileInfo() {
    return this.fileInfo;
  },
  getCurrentFilePageCount: function getCurrentFilePageCount() {
    return 1;
  },
  getCurrentFilePageIndex: function getCurrentFilePageIndex() {
    return 0;
  },
  getCurrentFileIndex: function getCurrentFileIndex() {
    return 0;
  }
});
var _default = exports["default"] = MDTiptapEditor;

},{"1451":1451,"1454":1454}],1111:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1451);
require(1417);
require(1463);
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MDLoadMaskView = _interopRequireDefault(require(49));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MMFileInfo = _interopRequireDefault(require(297));
var MDOfficeDisplayView = function MDOfficeDisplayView(parentDiv, fileInfo) {
  this.$content = $('<div class="office-page" style="position:absolute;width:100%;height:100%;top:0;overflow:auto"></div>');
  $(parentDiv).append(this.$content);
};
Object.assign(MDOfficeDisplayView.prototype, Object.prototype, {
  contstructor: MDOfficeDisplayView,
  openFile: function openFile(curFileInfo, version, callback) {
    var _this = this;
    _czc && _czc.push(["_trackEvent", "预览", "Mail", "", "", ""]);
    this.fileInfo = curFileInfo;
    var fileId = curFileInfo.getFileId();
    this.loadIframe(fileId, version);
    callback();
    var refreshIframe = function refreshIframe(file) {
      var fid;
      if (file instanceof _MMFileInfo["default"]) {
        fid = file.getFileId();
      } else {
        fid = file.fileId;
      }
      if (fid == fileId) {
        var ver = "-1";
        _this.loadIframe(fid, ver);
      }
    };
    Dispatcher.on(MDEvents.RefreshOnlineOfficeEditor, refreshIframe, this);
  },
  loadIframe: function loadIframe(fid, ver) {
    this.$content.empty();
    var url = location.origin + "/netdrive/openFileByBabelOffice.do?fileId=" + fid + "&readOnly=1&version=" + ver;
    var mail = "<iframe src=\"".concat(url, "\" class=\"office-page-iframe\" style=\"position:absolute;width:100%;height:100%;top:0;border:none;background-color: #fff;\"></iframe>");
    this.$content.append(mail);
    this.$content.find(".office-page").find("iframe").load(function () {
      this.$content.find(".office-page").find("iframe").contents().find("body").on("mousemove", function (e) {
        // console.log('----------------- mouse moving!');
        Dispatcher.trigger(MDEvents.mailMouseMove);
      });
    });
  },
  getScale: function getScale() {
    return 1;
  },
  setScale: function setScale() {},
  refreshSize: function refreshSize() {},
  getClassName: function getClassName() {
    return "MDOfficeDisplayView";
  },
  closeCommentPanel: function closeCommentPanel() {},
  removeFromSuperView: function removeFromSuperView() {
    this.$content.remove();
  },
  // 以下是为了配合手机界面的接口
  getCurrentBoard: function getCurrentBoard() {
    return null;
  },
  getCurrentFileInfo: function getCurrentFileInfo() {
    return this.fileInfo;
  },
  getCurrentFilePageCount: function getCurrentFilePageCount() {
    return 1;
  },
  getCurrentFilePageIndex: function getCurrentFilePageIndex() {
    return 0;
  },
  getCurrentFileIndex: function getCurrentFileIndex() {
    return 0;
  }
});
var _default = exports["default"] = MDOfficeDisplayView;

},{"1104":1104,"1184":1184,"1417":1417,"1451":1451,"1454":1454,"1463":1463,"297":297,"49":49,"72":72,"812":812}],937:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1466);
var _goog = _interopRequireDefault(require(823));
var _MMAndroidScrollView = _interopRequireDefault(require(913));
var _MMPDFCollectionView = _interopRequireDefault(require(931));
var _MMCell = _interopRequireDefault(require(927));
var _MMMobilePageView = _interopRequireDefault(require(930));
var _MMPCImageEditor = _interopRequireDefault(require(916));
//-------------------------------------------------------------------------------------------\\
//                  Scroll page Cell
//-------------------------------------------------------------------------------------------//
function MMNetDiskBoardCell(params) {
  this.editorViewCtl = params.editorViewCtl;
  _MMCell["default"].call(this);
  this.scrollView = new _MMAndroidScrollView["default"](this.$rootDiv[0]);
  this.curVer = -1;
}
;
_goog["default"].inherits(MMNetDiskBoardCell, _MMCell["default"]);
MMNetDiskBoardCell.prototype.setBoard = function (board, callback) {
  if (!board) {
    return;
  }
  ;
  var fileCurversion = board.getCurVersion();
  if (this.m_board != board || fileCurversion != this.curVer) {
    this.m_board = board;
    this.init(callback);
  } else if (this.m_board && app.canDispInNormalBrowser()) {
    this.scrollView.zoomToFit();
  }
};
MMNetDiskBoardCell.prototype.getBoard = function () {
  return this.m_board;
};
MMNetDiskBoardCell.prototype.init = function (callback) {
  var that = this;
  this.curVer = this.m_board.getCurVersion();
  if (this.m_board.isOperateOnPDFFile()) {
    if (this.editor) {
      this.editor.removeFromSuperView();
    }
    ;
    var pageSpace = 0;
    var params = {
      whiteboard: this.m_board,
      containerDiv: this.scrollView.getScrollContentDiv(),
      pageSpacing: pageSpace,
      dispVer: this.curVer,
      editorViewCtl: this.editorViewCtl
    };
    this.editor = new _MMPDFCollectionView["default"](params);
  } else {
    if (!this.editor || !(this.editor instanceof _MMMobilePageView["default"])) {
      if (this.editor) {
        this.editor.removeFromSuperView();
      }
      ;
      var params = {
        editorViewCtl: this.editorViewCtl
      };
      if (!app.canDispInNormalBrowser()) {
        this.editor = new _MMMobilePageView["default"](this.scrollView.getScrollContentDiv(), params);
      } else {
        this.editor = new _MMPCImageEditor["default"](this.scrollView.getScrollContentDiv(), params);
      }
      this.editor.setDispForVersion(true); // 只显示指定的版本的批注
    }
    ;
    var imgs = this.m_board.getImgPdfObjectsForVersion(this.curVer);
    if (imgs.length > 0 && this.editor) {
      this.editor.displayObject(imgs[0], function () {
        //that.zoomToFit();
        if (callback) callback();
        Dispatcher.trigger(MDEvents.ZOOM_CHANGED, {
          editorViewCtl: this.editorViewCtl
        });
      });
    }
    ;
  }
};
MMNetDiskBoardCell.prototype.getEditor = function () {
  return this.editor;
};
MMNetDiskBoardCell.prototype.pan = function () {
  return this.editor;
};
MMNetDiskBoardCell.prototype.setSize = function (size) {
  MMNetDiskBoardCell.superClass_.setSize.call(this, size);
  this.scrollView.refreshSize();
  this.scrollView.recordOriginScrollSize();
  this.scrollView.setContentSize(size);
  if (this.editor == undefined || this.editor == null) {} else {
    this.editor.refreshSize();
  }
};
MMNetDiskBoardCell.prototype.zoomToFit = function () {
  this.editor.zoomToFit();
};
MMNetDiskBoardCell.prototype.checkToFitScreen = function () {
  if (this.scrollView.checkToFitParentDiv()) {
    this.editor.refreshSize();
  }
};
MMNetDiskBoardCell.prototype.removeFromSuperView = function () {
  MMNetDiskBoardCell.superClass_.removeFromSuperView.call(this);
  if (this.editor) {
    this.editor.removeFromSuperView();
  }
  ;
};
MMNetDiskBoardCell.prototype.changeZoomScaleTo = function (scale) {
  var curScale = this.editor.getZoomScale();
  if (curScale != scale) {
    var centerRatio = this.editor.getCenterRatioPosition();
    var scale = this.editor.changeZoomScale(scale);
    this.editor.restoreCenterPostion(centerRatio);
  }
  return scale;
};
MMNetDiskBoardCell.prototype.getScrollableInfo = function () {
  return this.editor.getScrollableInfo();
};
MMNetDiskBoardCell.prototype.scrollOffset = function (offset) {
  this.editor.scrollOffset(offset);
};
MMNetDiskBoardCell.prototype.refreshObjsDisp = function () {
  this.editor.refreshObjsInEditor();
};
MMNetDiskBoardCell.prototype.refreshLgPageInRect = function (lgRct) {
  this.editor.refreshLgPageInRect(lgRct);
};
MMNetDiskBoardCell.prototype.getScale = function () {
  return this.scrollView.getScale();
};

//---------------------------------------------- gesture ------------------------------------------------
MMNetDiskBoardCell.prototype.panStart = function (e) {
  return this.scrollView.panStart(e);
};
MMNetDiskBoardCell.prototype.panMove = function (e) {
  return this.scrollView.panMove(e);
};
MMNetDiskBoardCell.prototype.panEnd = function (e) {
  return this.scrollView.panEnd(e);
};
MMNetDiskBoardCell.prototype.pinchStart = function (scale) {
  // return;
  this.scrollView.pinchStart(scale);
};
MMNetDiskBoardCell.prototype.pinchMove = function (scale) {
  // return;
  this.scrollView.pinchMove(scale);
};
MMNetDiskBoardCell.prototype.pinchEnd = function (scale) {
  // return;
  var that = this;
  this.scrollView.pinchEnd(scale, function scaleFinished() {
    that.editor.refreshSize();
  });
};
MMNetDiskBoardCell.prototype.changeVersion = function (ver_, callback) {
  if (typeof ver_ == "string") {
    ver_ = parseInt(ver_);
  }
  ;
  var self = this;
  if (this.curVer != ver_) {
    this.curVer = ver_;
    this.m_board.setVersionShowing(this.curVer);
    if (this.m_board.isOperateOnPDFFile()) {
      this.editor.changeVersion(ver_);
      if (callback) callback();
    } else {
      var imgs = this.m_board.getImgPdfObjectsForVersion(ver_);
      if (imgs.length > 0) {
        this.editor.displayObject(imgs[0], function () {
          //that.zoomToFit();
          if (callback) callback();
          Dispatcher.trigger(MDEvents.ZOOM_CHANGED, {
            editorViewCtl: self.editorViewCtl
          });
        });
      }
      ;
    }
  }
  ;
};
MMNetDiskBoardCell.prototype.getVersionShowing = function () {
  return this.curVer;
};
var _default = exports["default"] = MMNetDiskBoardCell;

},{"1184":1184,"1454":1454,"1466":1466,"823":823,"913":913,"916":916,"927":927,"930":930,"931":931}],931:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MMPDFCollectionView;
require(1466);
require(1450);
require(1412);
var _MMPoint = _interopRequireDefault(require(830));
var _goog = _interopRequireDefault(require(823));
var _MMVerticalCollectionView = _interopRequireDefault(require(935));
var _MMBasicData = _interopRequireDefault(require(811));
var _rect = _interopRequireDefault(require(836));
var _MMPdfPageCell = _interopRequireDefault(require(934));
var _MDEvents = _interopRequireDefault(require(325));
var _MMObjElementsController = _interopRequireDefault(require(893));
var _size = _interopRequireDefault(require(837));
var _MDLoadMaskView = _interopRequireDefault(require(49));
var _MMNetDiskImageCollectionView = _interopRequireDefault(require(938));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MMCommonFun = _interopRequireDefault(require(812));
/**
 * 本类支持垂直滑动，在一屏中显示多页 pdf 的显示
 * javascript/molasync-source/ui/editor-task/pdf-scroll/MMPDFCollectionView.js
 * jiang
 * 2015-8-3
 */

/**
 * @param {HTMLElement} containerDiv  page scroll view's parent div
 * @param {?Number} pgnum 共有多少页
 */
function MMPDFCollectionView(params, callback) {
  var _this = this;
  var whiteboard = params.whiteboard;
  var containerDiv = params.containerDiv;
  var pageSpacing = params.pageSpacing;
  var dispVer = params.dispVer;
  _czc && _czc.push(["_trackEvent", "预览", "多页 pdf", "", "", ""]);
  this.onlyDisplay = params.onlyDisplay;
  this.editorViewCtl = params.editorViewCtl;
  console.assert(whiteboard);
  // console.assert(whiteboard.isDocument());
  this.pageMargin = 10;
  _MMVerticalCollectionView["default"].call(this, containerDiv, pageSpacing, this.pageMargin);
  if (!app.canDispInNormalBrowser()) {
    _MMNetDiskImageCollectionView["default"].setCurrentInstance(this); // 在移动端，此为单独的 editor

    $(this.container).css("overflow", "auto");
    var usrId = app.currentUser.id;
    _MMNetDiskDataController["default"].addFileAccessUser(whiteboard.getStringId(), usrId, function () {}, function () {});
  } else {
    $(this.container).css("overflow", "auto");
  }
  if (pageSpacing == undefined || pageSpacing == null) {
    this.pageSpacing = 20;
  } else {
    this.pageSpacing = pageSpacing;
  }
  this.board = whiteboard;
  if (dispVer != null && dispVer != undefined) {
    this.curVer = dispVer;
  } else {
    this.curVer = this.board.getCurVersion();
  }
  this.newPageSizes = [];
  var passwordCallback = function passwordCallback(pwd) {
    var password = whiteboard.fileInfo.getPassowrdByVersion(_this.editorViewCtl.getVersionShowing(), true);
    pwd(password);
  };
  this.refreshView(callback, passwordCallback, function (url) {
    _this.board.pdfUrl = url;
  });
  this.$contentDiv.css('margin-bottom', '65px');
  this.className = "MMPDFCollectionView";
  var self = this;
  this.keyDownFun = function (e) {
    if (!_MMCommonFun["default"].hasTextInputInEditor()) {
      e.stopPropagation();
      e.preventDefault();
      console.log('-------------- key down!');
      var keyCode = e.keyCode;
      if (keyCode == 38) {
        //上箭头
        self.scrollPageUp();
      } else if (keyCode == 40 || keyCode == 32) {
        // 下箭头，空格
        self.scrollPageDown();
      }
    }
  };

  // document.addEventListener('keydown', this.keyDownFun, true);
  document.addEventListener('keydown', this.keyDownFun);
}
;
_goog["default"].inherits(MMPDFCollectionView, _MMVerticalCollectionView["default"]);
MMPDFCollectionView.prototype.setBoard = function (board) {
  this.board = board;
};
MMPDFCollectionView.prototype.refreshView = function (callback, passwordCallback, setBoardPdfUrl) {
  var that = this;
  var pdfObjs = this.board.getImgPdfObjectsForVersion(this.curVer);
  this.pdfObjs = pdfObjs;
  this.newPageSizes = [];
  this.newPageSizes = [];
  _MDLoadMaskView["default"].show();
  _MDLoadMaskView["default"]._singleton.$el[0].offsetWidth;

  // setBabelTimeout(function(){
  console.log('---------> 需要显示');
  for (var i = 0; i < pdfObjs.length; i++) {
    var pgSize = pdfObjs[i].getOriginSize();
    if (!pgSize) {
      _MDLoadMaskView["default"].remove();
      return;
    }
    ;
    var size = new _size["default"](pgSize.x, pgSize.y);
    that.newPageSizes.push(size);
  }
  ;
  if (this.onlyDisplay) {
    getMMPdfLoader().loadPdfPageForNoboard(this.board, pdfObjs, this.editorViewCtl, setBoardPdfUrl, function (error) {
      if (error) {
        _MDLoadMaskView["default"].remove();
        return;
      }
      if (that.removed) {
        console.log('*******>>> removed');
        that = null;
        return;
      }
      ;
      that.scale = that.initWithPageSizes(that.newPageSizes, that.pageMargin, function renderProgress(step) {
        // console.log('render progress:' + step);
        if (step == 1) {}
        ;
      });
      Dispatcher.trigger(_MDEvents["default"].ZOOM_CHANGED, {
        editorViewCtl: that.editorViewCtl
      });
      if (callback) {
        callback();
      }
      ;
    }, function progress(p) {
      _MDLoadMaskView["default"].displayPercent(p);
    });
  } else {
    getMMPdfLoader().loadPdfPageForWhiteboard(pdfObjs, passwordCallback, setBoardPdfUrl, function (error) {
      _MDLoadMaskView["default"].remove();
      if (error) {
        _MDLoadMaskView["default"].remove();
        return;
      }
      if (that.removed) {
        console.log('*******>>> removed');
        that = null;
        return;
      }
      ;
      that.scale = that.initWithPageSizes(that.newPageSizes, that.pageMargin, function renderProgress(step) {
        // console.log('render progress:' + step);
        if (step == 1) {}
        ;
      });
      Dispatcher.trigger(_MDEvents["default"].ZOOM_CHANGED, {
        editorViewCtl: that.editorViewCtl
      });
      if (callback) {
        callback();
      }
      ;
    }, function progress(p) {
      _MDLoadMaskView["default"].displayPercent(p);
    });
  }

  // }, 0)
};
MMPDFCollectionView.prototype.getCurrentFileIndex = function () {
  return 0;
};

// MMPDFCollectionView.prototype._getPdfPageOneByOne = function(callback) {
//   var that = this;
//   var pdfObj = this.pdfObjs[this.waitingIndex];
//   pdfObj.getPdfPage(function(page) {
//     if (page.pageIndex == that.waitingIndex) {
//       var viewport = page.getViewport(1.0);
//       var size = new Size(viewport.width, viewport.height);
//       that.newPageSizes.push(size);
//       console.log('*** get page:' + page.pageIndex);
//       that.waitingIndex++;

//       if (that.waitingIndex < that.pdfObjs.length) {
//         that._getPdfPageOneByOne(callback);
//       } else { // 全部下载完毕

//         that.initWithPageSizes(that.newPageSizes, function renderProgress(step) {
//           console.log('render progress:' + step);
//           if (!that.downloadProgressView) {
//             return;
//           };
//         });
//         if (callback) {
//           callback();
//         };
//       }
//     };
//   });
// };

MMPDFCollectionView.prototype.displayInRect = function (lgRct, callback) {
  var that = this;
  this.refreshView(function () {
    that.displayObjs(lgRct, callback);
  });
};
MMPDFCollectionView.prototype.displayObjs = function (lgRct, callback) {
  var that = this;
  for (var i = 0; i < that.dispCells.length; i++) {
    var cell = that.dispCells[i];
    var index = cell.getIndex();
    var pdfObj = that._getObjByIndex(index);
    if (pdfObj && pdfObj != cell.getImage()) {
      cell.setImage(pdfObj, callback);
    } else {
      if (pdfObj && pdfObj.getExpandRect().intersects(lgRct)) {
        cell.refreshLgPageInRect(lgRct);
      }
      ;
    }
  }
};
MMPDFCollectionView.prototype.refreshLgPageInRect = function (lgRct, callback) {
  this.displayObjs(lgRct, callback);
};
MMPDFCollectionView.prototype._getObjByIndex = function (index) {
  var pdfObj = null;
  if (index < this.pdfObjs.length) {
    pdfObj = this.pdfObjs[index];
  }
  ;
  return pdfObj;
};
MMPDFCollectionView.prototype.createCellForPage = function (pageIndex) {
  var cell = new _MMPdfPageCell["default"](null, this.pageMargin, {
    editorViewCtl: this.editorViewCtl
  });
  cell.setIndex(pageIndex);
  cell.setImgMarkerCtl(this.imgMarkerCtl);
  var pdfObj = this._getObjByIndex(pageIndex);
  if (!app.canDispInNormalBrowser()) {
    cell.dispThumbnailAsBackground(pdfObj);
  }
  ;
  return cell;
};
MMPDFCollectionView.prototype.initCell = function (cell, pageIndex, finishedDraw) {
  cell.setIndex(pageIndex);
  var pdfObj = this._getObjByIndex(pageIndex);
  cell.setImage(pdfObj, finishedDraw);
};
MMPDFCollectionView.prototype.getPicObject = function () {
  var cell = this.getFirstDispCell();
  if (cell) {
    var editor = cell.getEditor();
    if (editor) {
      return editor.getPicObject();
    }
    ;
  }
  ;
  return null;
};
MMPDFCollectionView.prototype.changeVersion = function (ver_, callback) {
  if (this.curVer != ver_) {
    this.curVer = ver_;
    this.newPageSizes = [];
    this.refreshView(callback);
  }
  ;
};
MMPDFCollectionView.prototype.setCurOperation = function (oper_, objs_, comm_) {
  var that = this;
  for (var i = 0; i < that.dispCells.length; i++) {
    var cell = that.dispCells[i];
    if (cell) {
      cell.getEditor().setCurOperation(oper_, objs_, comm_);
    }
    ;
  }
};
MMPDFCollectionView.prototype.getCurrentFilePageCount = function () {
  return this.board.getPageCountByVersion(this.curVer);
};
MMPDFCollectionView.prototype.getCurrentFilePageIndex = function () {
  var curLeft = this.container.scrollLeft;
  var curTop = this.container.scrollTop;
  var visiblePageIndexes = this.layout.getSufficientVisiblePageIndex(curLeft, curTop, this.viewSize, 0);
  if (visiblePageIndexes.length < 1) {
    return 0;
  } else {
    return visiblePageIndexes[0];
  }

  // var cell = this.getFirstDispCell();
  // if(cell != undefined && cell != null){
  //  return cell.pageIndex;
  // }
  // return 0;
};
MMPDFCollectionView.prototype.clearContent = function () {};
MMPDFCollectionView.prototype.closeCommentPanel = function () {
  for (var i = 0; i < this.dispCells.length; i++) {
    var cell = this.dispCells[i];
    var editor = cell.getEditor();
    if (editor) {
      editor.closeCommentPanel();
    }
  }
};
MMPDFCollectionView.prototype.getScale = function () {
  return this.scale;
  if (!app.canDispInNormalBrowser()) {
    var pdfObjs = this.board.getDisplayingPdf();
    if (pdfObjs.length == 0 || !this.pageSizes || this.pageSizes.length == 0) {
      return 1.0;
    }
    ;
    var objW = this.pageSizes[0].width;
    var rect = this.layout.getItemRectByIndex(0);
    var pageW = rect.getWidth();
    return pageW / objW;
  } else {
    var cell = this.getFirstDispCell();
    if (cell) {
      var editor = cell.getEditor();
      if (editor) {
        return editor.getScale();
      }
    }
    ;
  }
};
MMPDFCollectionView.prototype.calculateContentWidthByScale = function (scale) {
  var containerW = $(this.container).width();
  if (!this.pageSizes || this.pageSizes.length == 0 || scale < 0) {
    return containerW;
  }
  ;
  var contentW = this.pageSizes[0].width * scale + 2 * this.pageMargin;
  if (contentW < containerW) {
    contentW = containerW;
  }
  ;
  return contentW;
};
MMPDFCollectionView.prototype.getFitScale = function () {
  var containerW = $(this.container).width();
  if (!this.pageSizes || this.pageSizes.length == 0) {
    return 1.0;
  }
  ;
  var objW = this.pageSizes[0].width;
  return containerW / objW;
};
MMPDFCollectionView.prototype.getZoomList = function () {
  if (!this.pageSizes || this.pageSizes.length == 0) {
    return 1.0;
  }
  ;
  var start = this.getStartScale();
  start = parseInt((start * 100).toFixed(0));
  var zoomList = [start];

  // find the start int can be divide by 25
  while (start % 25 != 0) {
    start++;
  }
  for (var i = 0; i < 5; i++) {
    zoomList.push(start);
    start += 25;
  }
  ;
  while (start % 50 != 0) {
    start++;
  }
  var multi = 50;
  for (var i = 0; i < 3; i++) {
    start += multi;
    zoomList.push(start);
    multi *= 2;
  }
  ;
  for (var i = 0; i < zoomList.length; i++) {
    var zoom = (zoomList[i] / 100).toFixed(2);
    zoomList[i] = zoom;
  }
  ;
  zoomList = _.uniq(zoomList); // 做一次查重，去掉重复的

  return zoomList;
};
MMPDFCollectionView.prototype.getStartScale = function (scale, callback) {
  var containerW = $(this.container).width();
  var containerH = $(this.container).height();
  if (!this.pageSizes || this.pageSizes.length == 0) {
    return 1.0;
  }
  ;
  var pgW = this.pageSizes[0].width;
  var pgH = this.pageSizes[0].height;
  for (var i = 1; i < this.pageSizes.length; i++) {
    if (this.pageSizes[i].width > pgW) {
      pgW = this.pageSizes[i].width;
    }
    if (this.pageSizes[i].height > pgH) {
      pgH = this.pageSizes[i].height;
    }
    ;
  }
  ;
  var start = 1.0;
  if (pgW < containerW && pgH < containerH) {} else {
    start = Math.min(containerW / pgW, containerH / pgH);
  }
  return start;
};

// only for PC, for mobile please use pinch events
MMPDFCollectionView.prototype.changeScale = function (scale, callback) {
  if (this.pageSizes.length == 0) {
    if (callback) {
      callback();
    }
    ;
    return;
  }
  ;
  var ratioPos = this.getCenterRatioPosition();
  var contentW = this.calculateContentWidthByScale(scale);
  var containerH = $(this.container).height();
  if (scale < 0) {
    this.scale = this.layout.getFitScale(contentW, this.pageSizes);
  } else {
    this.scale = scale;
  }
  this.layout.setScale(this.scale);
  var spacing = this.pageSpacing * this.scale;
  // var containerW = $(this.container).width();

  this.scale = this.layout.setItemSizes(contentW, containerH, this.pageSizes, this.pageSpacing, this.pageMargin);
  if (scale == -1) {
    // fit scalse
    //this.scale = this.minScale;
    Dispatcher.trigger(_MDEvents["default"].ZOOM_CHANGED, {
      editorViewCtl: this.editorViewCtl
    });
  } else {
    this.scale = scale;
    this.layout.setScale(this.scale);
    this.layout.refreshWithChangedScale(contentW, spacing);
  }
  for (var i = 0; i < this.dispCells.length; i++) {
    var cell = this.dispCells[i];
    cell.getEditor().setScale(this.scale);
  }
  ;
  this.setContentSize(this.layout.getContentSize());
  this.refreshDispCellsPosition();
  // this.displayCellsInCurViewPort();

  // this.refreshSize();

  for (var i = 0; i < this.dispCells.length; i++) {
    var cell = this.dispCells[i];
    cell.getEditor().refreshTimeout(this.scale);
  }
  ;
  this.onScroll();
  this.restoreCenterPostion(ratioPos);
  if (callback) {
    setBabelTimeout(function () {
      callback();
    }, 100);
  }
  ;
};
MMPDFCollectionView.prototype.followTeacher = function (dispPosition, callback) {
  var _this2 = this;
  if (dispPosition.fileDim != '2D') {
    if (callback) {
      callback();
    }
    ;
    return;
  }
  ;
  var that = this;
  this.changeScale(dispPosition.scale, function () {
    setBabelTimeout(function () {
      if (dispPosition.centerPos) {
        that.restoreCenterPostion(dispPosition.centerPos);
      } else {
        that.restoreCenterLogicPosition(dispPosition.lgCenter);
      }
      if (callback) {
        callback();
      }
      ;
    }, 10);
    Dispatcher.trigger(_MDEvents["default"].RefreshZoomDisp, _this2.scale);
  });
};
MMPDFCollectionView.prototype.zoomToFit = function (callback) {
  if (!app.canDispInNormalBrowser()) {
    this.changeScale(1.0);
  } else {
    this.changeScale(-1.0);
  }
};
MMPDFCollectionView.prototype.getCommentsDivs = function () {
  var commentDivs = [];
  for (var i = 0; i < this.dispCells.length; i++) {
    var cell = this.dispCells[i];
    if (cell) {
      var editor = cell.getEditor();
      if (editor) {
        var divs = editor.getCommentsDivs();
        commentDivs = commentDivs.concat(divs);
      }
      ;
    }
    ;
  }
  ;
  return commentDivs;
};
MMPDFCollectionView.prototype.getDivByObj = function (commentObj) {
  var commentDivs = [];
  for (var i = 0; i < this.dispCells.length; i++) {
    var cell = this.dispCells[i];
    if (cell) {
      var editor = cell.getEditor();
      if (editor) {
        var div = editor.getDivByObj(commentObj);
        if (div) return div;
      }
      ;
    }
    ;
  }
  ;
  return null;
};

// MMPDFCollectionView.prototype.scrollPageIntoView =
MMPDFCollectionView.prototype.scrollToShowPdfLink = function (obj, showObjCallback) {
  var pgIndex = obj.pageNumber - 1;
  var that = this;
  var destArray = obj.destArray;
  this.processScrollToShowObj = true;
  obj.x *= 1.27;
  obj.y *= 1.27;
  this.objToShowing = obj;
  this.showObjCallback = showObjCallback;

  // 判断该页是否已经渲染完毕了
  var pageEditorRendered = null;
  for (var i = 0; i < this.dispCells.length; i++) {
    var cell = this.dispCells[i];
    if (cell.getIndex() == pgIndex && cell.getEditor()) {
      pageEditorRendered = cell.getEditor();
      break;
    }
    ;
  }
  ;
  var curPg = this.getCurPdfPage();
  if (curPg != pgIndex) {
    this.scrollToPage(pgIndex, false, function () {
      if (!pageEditorRendered) {
        var curView = that.getCurPdfPageView();
        if (curView.getCurrentFilePageIndex() != pgIndex) {
          console.error('错误的页号 ----------- ' + curView.getCurrentFilePageIndex() + ' - ' + pgIndex);
        } else {
          pageEditorRendered = curView;
        }
      }
      ;
      if (pageEditorRendered) {
        that.scrollToShowPdflinkAfterRender(pageEditorRendered, pgIndex, {
          x: destArray[2],
          y: destArray[3]
        });
      }
      ;
    });
  } else {
    if (pageEditorRendered) {
      that.scrollToShowPdflinkAfterRender(pageEditorRendered, pgIndex, {
        x: destArray[2],
        y: destArray[3]
      });
    } else {
      console.error('!错误的页号 ----------- ' + pgIndex);
    }
  }
};
MMPDFCollectionView.prototype.scrollToShowPdflinkAfterRender = function (editor, pgIndex, obj) {
  var targetEditor = editor;
  if (targetEditor) {
    var scale = targetEditor.getScale();
    obj.y = targetEditor.$contentDiv.height() - obj.y * scale;
    var assistDiv = targetEditor.getAssistantCanvas();
    var ptInContent = _MMCommonFun["default"].convertPointBetweenElements(assistDiv, this.getScrollView(), obj);
    this.getScrollView().scrollTop = ptInContent.y - 20;
    // this.scrollToShow(ptInContent);
    var commentSlidePanel = viewManager.get("commentSlidePanel");
    if (commentSlidePanel) {
      commentSlidePanel.removeFromSuperView();
    }
    if (this.showObjCallback) {
      this.showObjCallback();
    }
    ;
    // editor.restoreCenterPostion(editor.getCenterRatioPosition())
  }
  ;
};
MMPDFCollectionView.prototype.scrollToShowObj = function (obj, showObjCallback) {
  var pgIndex = obj.getPageIndex();
  var that = this;

  // if (this.processScrollToShowObj) {
  //  return;
  // };

  this.processScrollToShowObj = true;
  this.objToShowing = obj;
  this.showObjCallback = showObjCallback;

  // 判断该页是否已经渲染完毕了
  var pageEditorRendered = null;
  for (var i = 0; i < this.dispCells.length; i++) {
    var cell = this.dispCells[i];
    if (cell.getIndex() == pgIndex && cell.getEditor()) {
      pageEditorRendered = cell.getEditor();
      break;
    }
    ;
  }
  ;
  var curPg = this.getCurPdfPage();
  if (curPg != pgIndex) {
    this.scrollToPage(pgIndex, false, function () {
      // if (pageEditorRendered) {
      //  that.scrollToShowObjAfterRender(pageEditorRendered, pgIndex);
      // } else {
      //  Dispatcher.on(MDEvents.RENDER_OBJ_FINISH, that.scrollToShowObjAfterRender, that);
      // }

      if (!pageEditorRendered) {
        var curView = that.getCurPdfPageView();
        if (curView) {
          if (curView.getCurrentFilePageIndex() != pgIndex) {
            console.error('错误的页号 ----------- ' + curView.getCurrentFilePageIndex() + ' - ' + pgIndex);
          } else {
            pageEditorRendered = curView;
          }
        }
      }
      ;
      if (pageEditorRendered) {
        that.scrollToShowObjAfterRender(pageEditorRendered, pgIndex);
      }
      ;
    });
  } else {
    if (pageEditorRendered) {
      that.scrollToShowObjAfterRender(pageEditorRendered, pgIndex);
    } else {
      console.error('!错误的页号 ----------- ' + pgIndex);
    }
  }
};
MMPDFCollectionView.prototype.getCurPdfPageView = function () {
  var pgIndex = this.getCurPdfPage();
  for (var i = 0; i < this.dispCells.length; i++) {
    var cell = this.dispCells[i];
    if (cell.getIndex() == pgIndex && cell.getEditor()) {
      return cell.getEditor();
      break;
    }
    ;
  }
  ;
  return null;
};
MMPDFCollectionView.prototype.scrollToShowObjAfterRender = function (editor, pgIndex) {
  var objPage = this.objToShowing.getPageIndex();
  if (objPage == pgIndex) {
    this.processScrollToShowObj = false;
    Dispatcher.off(_MDEvents["default"].RENDER_OBJ_FINISH, this.scrollToShowObjAfterRender);
    var pgIndex = this.objToShowing.getPageIndex();
    var targetEditor = editor;
    // for (var i = 0; i < this.dispCells.length; i++) {
    //  var cell = this.dispCells[i];
    //  if (cell.getIndex() == pgIndex) {
    //    var editor = cell.getEditor();
    //    console.assert(editor);
    //    if (editor) {
    //      targetEditor = editor;
    //      break;

    //    };

    //  };
    // };
    if (targetEditor) {
      var divPt = targetEditor.logic2AssistViewPoint(this.objToShowing.getDispCenter());
      var assistDiv = targetEditor.getAssistantCanvas();
      var ptInContent = _MMCommonFun["default"].convertPointBetweenElements(assistDiv, this.getScrollView(), divPt);
      this.scrollToShow(ptInContent);
      var commentSlidePanel = viewManager.get("commentSlidePanel");
      if (commentSlidePanel) {
        commentSlidePanel.removeFromSuperView();
      }
    }
    ;
    if (this.showObjCallback) {
      this.showObjCallback();
    }
    ;
  }
  ;
};
MMPDFCollectionView.prototype.scrollToShowPos = function (pos, pgIndex, showObjCallback, isdivPos) {
  var that = this;

  // 判断该页是否已经渲染完毕了
  var pageEditorRendered = null;
  for (var i = 0; i < this.dispCells.length; i++) {
    var cell = this.dispCells[i];
    if (cell.getIndex() == pgIndex && cell.getEditor()) {
      pageEditorRendered = cell.getEditor();
      break;
    }
    ;
  }
  ;
  var curPg = this.getCurPdfPage();
  if (curPg != pgIndex) {
    this.scrollToPage(pgIndex, false, function () {
      var curView = that.getCurPdfPageView();
      if (curView) {
        that.scrollToShowPosAfterRender(curView, pos, showObjCallback, isdivPos);
      }
      ;
    });
  } else {
    if (pageEditorRendered) {
      that.scrollToShowPosAfterRender(pageEditorRendered, pos, showObjCallback, isdivPos);
    } else {
      console.error('!错误的页号 ----------- ' + pgIndex);
    }
  }
};
MMPDFCollectionView.prototype.scrollToShowPosAfterRender = function (editor, pos, showObjCallback, isdivPos) {
  var targetEditor = editor;
  if (targetEditor) {
    var divPt = isdivPos ? pos : targetEditor.logic2AssistViewPoint(pos);
    var assistDiv = targetEditor.getAssistantCanvas();
    var ptInContent = _MMCommonFun["default"].convertPointBetweenElements(assistDiv, this.getScrollView(), divPt);
    this.scrollToShow(ptInContent);
    var commentSlidePanel = viewManager.get("commentSlidePanel");
    if (commentSlidePanel) {
      commentSlidePanel.removeFromSuperView();
    }
  }
  ;
  showObjCallback && showObjCallback();
};
MMPDFCollectionView.prototype.getCurrentBoard = function () {
  return this.board;
};
MMPDFCollectionView.prototype.getCurrentFileInfo = function () {
  return this.board.getFileInfo();
};
MMPDFCollectionView.prototype.getCurPdfPagesCount = function () {
  if (this.board) {
    return this.board.getPageCountByVersion();
  }
  ;
  return 0;
};
MMPDFCollectionView.prototype.getCurPdfPage = function () {
  return this.getCurrentFilePageIndex();
};
MMPDFCollectionView.prototype.refreshCommentsInEditor = function () {
  for (var i = 0; i < this.bufferCells.length; i++) {
    var cell = this.bufferCells[i];
    var editor = cell.getEditor();
    if (editor) {
      var objCtl = _MMObjElementsController["default"].getSingleInstance();
      objCtl.removeAllDivsForEditor(editor);
      editor.refreshCommentsInEditor();
    }
  }
  for (var i = 0; i < this.dispCells.length; i++) {
    var cell = this.dispCells[i];
    var editor = cell.getEditor();
    if (editor) {
      var objCtl = _MMObjElementsController["default"].getSingleInstance();
      objCtl.removeAllDivsForEditor(editor);
      editor.refreshCommentsInEditor();
    }
  }
};
MMPDFCollectionView.prototype.refreshObjsInEditor = function () {
  for (var i = 0; i < this.bufferCells.length; i++) {
    var cell = this.bufferCells[i];
    var editor = cell.getEditor();
    if (editor) {
      var objCtl = _MMObjElementsController["default"].getSingleInstance();
      objCtl.removeAllDivsForEditor(editor);
      editor.refreshObjsInEditor();
    }
  }
  for (var i = 0; i < this.dispCells.length; i++) {
    var cell = this.dispCells[i];
    var editor = cell.getEditor();
    if (editor) {
      var objCtl = _MMObjElementsController["default"].getSingleInstance();
      objCtl.removeAllDivsForEditor(editor);
      editor.refreshObjsInEditor();
    }
  }
};
MMPDFCollectionView.prototype.refreshSalonScribbleInCanvas = function (pgIndex) {
  var that = this;
  for (var i = 0; i < that.dispCells.length; i++) {
    var cell = that.dispCells[i];
    var index = cell.getIndex();
    if (index == pgIndex) {
      var editor = cell.getEditor();
      if (editor) {
        editor.refreshSalonScribbleInCanvas();
      }
    }
    ;
  }
};
MMPDFCollectionView.prototype.showCommentLayer = function () {
  for (var i = 0; i < this.bufferCells.length; i++) {
    var cell = this.bufferCells[i];
    var editor = cell.getEditor();
    if (editor) {
      editor.showCommentLayer();
    }
  }
  for (var i = 0; i < this.dispCells.length; i++) {
    var cell = this.dispCells[i];
    var editor = cell.getEditor();
    if (editor) {
      editor.showCommentLayer();
    }
  }
};
MMPDFCollectionView.prototype.hideCommentLayer = function () {
  for (var i = 0; i < this.bufferCells.length; i++) {
    var cell = this.bufferCells[i];
    var editor = cell.getEditor();
    if (editor) {
      editor.hideCommentLayer();
    }
  }
  for (var i = 0; i < this.dispCells.length; i++) {
    var cell = this.dispCells[i];
    var editor = cell.getEditor();
    if (editor) {
      editor.hideCommentLayer();
    }
  }
};
MMPDFCollectionView.prototype.dispSalonSpeakerMouseClick = function (logPt) {
  for (var i = 0; i < this.dispCells.length; i++) {
    var cell = this.dispCells[i];
    var editor = cell.getEditor();
    if (editor) {
      editor.dispSalonSpeakerMouseClick(logPt);
    }
  }
};
MMPDFCollectionView.prototype.removeFromSuperView = function () {
  MMPDFCollectionView.superClass_.removeFromSuperView.call(this);
  document.removeEventListener('keydown', this.keyDownFun);
};
MMPDFCollectionView.prototype.enableMouseWheel = function () {};
MMPDFCollectionView.prototype.setImgMarkerCtl = function (imgMarkerCtl) {
  this.imgMarkerCtl = imgMarkerCtl;
};
MMPDFCollectionView.prototype.getCenterLogicPosition = function () {
  var that = this;
  var ratioCenter = this.getCenterRatioPosition();
  var ptDiv = {
    x: ratioCenter.x * this.container.scrollWidth,
    y: ratioCenter.y * this.container.scrollHeight
  };
  var curView = that.getCurPdfPageView();
  if (curView) {
    var to = curView.getAssistantCanvas();
    var ptInCanvas = _MMCommonFun["default"].convertPointBetweenElements(this.$contentDiv[0], to, ptDiv);
    ptInCanvas = new _MMPoint["default"](ptInCanvas.x, ptInCanvas.y);
    var lgPos = curView.assistView2LogicPoint(ptInCanvas);
    return lgPos;
  }
  ;
  return null;
};
MMPDFCollectionView.prototype.restoreCenterLogicPosition = function (lgCenter) {
  var that = this;
  var curView = that.getCurPdfPageView();
  if (curView) {
    lgCenter = new _MMPoint["default"](lgCenter.x, lgCenter.y);
    var ptInCanvas = curView.logic2AssistViewPoint(lgCenter);
    var from = curView.getAssistantCanvas();
    var ptInContent = _MMCommonFun["default"].convertPointBetweenElements(from, this.$contentDiv[0], ptInCanvas);
    var ptCenter = {
      x: ptInContent.x / this.container.scrollWidth,
      y: ptInContent.y / this.container.scrollHeight
    };
    this.restoreCenterPostion(ptCenter);
  }
  ;
};
MMPDFCollectionView.prototype.refreshObjsInCanvas = function (rect) {
  var that = this;
  for (var i = 0; i < that.dispCells.length; i++) {
    var cell = that.dispCells[i];
    var index = cell.getIndex();
    var editor = cell.getEditor();
    if (editor) {
      editor.refreshObjsInCanvas();
    }
  }
};
MMPDFCollectionView.prototype.rotate90 = function () {
  var that = this;
  var curView = that.getCurPdfPageView();
  if (curView) {
    curView.rotate90();
  }
  ;
};

},{"1104":1104,"1184":1184,"1412":1412,"1450":1450,"1454":1454,"1466":1466,"325":325,"49":49,"811":811,"812":812,"823":823,"830":830,"836":836,"837":837,"893":893,"934":934,"935":935,"938":938}],935:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MMVerticalCollectionView;
require(1438);
require(1432);
var _goog = _interopRequireDefault(require(823));
var _MMBasicData = _interopRequireDefault(require(811));
var _rect = _interopRequireDefault(require(836));
var _MMCell = _interopRequireDefault(require(927));
var _MDEvents = _interopRequireDefault(require(325));
var _MMVerticalLayout = _interopRequireDefault(require(936));
var _MMAndroidScrollView = _interopRequireDefault(require(913));
var _MDTouchMenu = _interopRequireDefault(require(339));
/**
 * 本类支持多页上下滑动
 * jiang
 * 2015-4-7
 */

/**
 * @param {HTMLElement} containerDiv  page scroll view's parent div
 * @param {String} scrollDirection 横向还是竖向滚动 "horizontal, vertical"
 * @param {?Number} pgnum 共有多少页
 */
function MMVerticalCollectionView(containerDiv, pageSpacing, pageMargin) {
  if (pageSpacing == undefined || pageSpacing == null) {
    this.pageSpacing = 10;
  } else {
    this.pageSpacing = pageSpacing;
  }
  this.pageMargin = pageMargin ? pageMargin : 0;
  var preloadItem = 4;
  if (MMCommonFun.isIOSDevice()) {
    preloadItem = 2; //must be even.
  }
  ;
  if (!app.canDispInNormalBrowser()) {
    preloadItem = 0;
  }
  ;
  this.layout = new _MMVerticalLayout["default"]($(containerDiv).width(), this.pageSpacing, preloadItem);
  this.dispCells = new Array();
  this.bufferCells = new Array();
  this.clickTimer = null;
  this.animateScroll = false;
  this.animateStep = null;
  _MMAndroidScrollView["default"].call(this, containerDiv);
  $(this.container).addClass('touch-scrollable');

  // 允许自己滚动
  if (this.$touchEventLayer) {
    this.$touchEventLayer.remove();
  }
  ;
  $(this.container).css("pointer-events", "auto");
  $(this.container).css('left', '0');
  $(this.container).css('top', '0');
  $(this.container).css('position', 'absolute');
  this.mScale = 1.0;
  if (!app.canDispInNormalBrowser()) {
    // pinch gesture
    this.bodyRecognizer = new Hammer($('.m-editor-root')[0], {
      'touchAction': 'auto'
    });
    //    this.bodyRecognizer = new Hammer($('body')[0]);
    //    this.bodyRecognizer.get('pinch').set({ enable: true});
    var that = this;
    //    this.bodyRecognizer.on('pinchin', _.bind(function(e){
    //        console.log('pinchin');
    //        //that.pinchStart(e);
    //    }, this));
    //    this.bodyRecognizer.on('pinchout', _.bind(function(d,e){
    //        console.log('pinchout');
    //      //that.pinchMove(d);
    //  }, this));

    this.bodyRecognizer.on('pinchstart', _.bind(function (e) {
      if (!$(e.target).hasClass('scroll-content') && !($(e.target).closest('.scroll-content').length > 0)) {
        return;
      }
      console.log('pinchstart');
      that.pinchStart(e);
      that.mScale = 1.0;
      //        e.preventDefault();
    }, this));
    this.bodyRecognizer.on('pinchmove', _.bind(function (e) {
      if (!$(e.target).hasClass('scroll-content') && !($(e.target).closest('.scroll-content').length > 0)) {
        return;
      }
      console.log('pinchmove,scale:' + e.scale);
      that.pinchMove(e.scale / that.mScale);
      that.mScale = e.scale;
      //        e.preventDefault();
    }, this));
    this.bodyRecognizer.on('pinchend', _.bind(function (e) {
      if (!$(e.target).hasClass('scroll-content') && !($(e.target).closest('.scroll-content').length > 0)) {
        return;
      }
      console.log('pinchend, scale:' + e.scale);
      that.pinchEnd(e.scale / that.mScale);
      that.mScale = 1.0;
      //        e.preventDefault();
    }, this));
    this.bodyRecognizer.on('pinchcancel', _.bind(function (e) {
      console.log('pinch cancelled: scale:' + e.scale);
      that.pinchEnd(1.0);
      that.mScale = 1.0;
    }, this));
    $('.m-editor-root')[0].addEventListener('touchstart', function (e) {
      if (e.touches.length >= 2) {
        that.bodyRecognizer.get('pinch').set({
          'enable': true
        });
        that.bodyRecognizer.set({
          'touchAction': 'none'
        });
      }
    }, false);
    $('.m-editor-root')[0].addEventListener('touchend', function (e) {
      that.bodyRecognizer.get('pinch').set({
        'enable': false
      });
      that.bodyRecognizer.set({
        'touchAction': 'auto'
      });
    }, false);
  }
  ;
}
;
_goog["default"].inherits(MMVerticalCollectionView, _MMAndroidScrollView["default"]);
MMVerticalCollectionView.prototype.refreshView = function (callback) {};

// 首次必须调用此函数，以便正确初始化内容的大小
// @param pagesSizes {Array of size} - 各页的尺寸
MMVerticalCollectionView.prototype.initWithPageSizes = function (pageSizes, pageMargin, renderProgress) {
  if (!pageSizes) {
    return;
  }
  ;
  if (this.pageSizes != pageSizes || this.pageSizes.length != pageSizes.length) {
    this.pageSizes = pageSizes;
    this.pageMargin = pageMargin;
    var containerH = $(this.container).height();
    this.scale = this.layout.setItemSizes($(this.parentDiv).width(), containerH, pageSizes, this.pageSpacing, pageMargin);
    this.minScale = this.scale;
    this.setContentSize(this.layout.getContentSize());
    this.reloadData(renderProgress);
  }
  ;
  return this.scale;
};
MMVerticalCollectionView.prototype.reloadData = function (renderProgress) {
  for (var i = 0; i < this.dispCells.length; i++) {
    var cell = this.dispCells[i];
    cell.removeFromSuperView();
  }
  for (var i = 0; i < this.bufferCells.length; i++) {
    var cell = this.bufferCells[i];
    cell.removeFromSuperView();
  }
  this.dispCells.splice(0, this.dispCells.length);
  this.bufferCells.splice(0, this.bufferCells.length);
  this.displayCellsInCurViewPort(renderProgress);
};

// 手机转屏时需要调用此函数
MMVerticalCollectionView.prototype.refreshSize = function (ignoreScale) {
  // if(ignoreScale) {
  //   var containerH = $(this.container).height();
  //   this.layout.setScale(-1.0)
  //   this.scale = this.layout.setItemSizes($(this.parentDiv).width(), containerH, this.pageSizes, this.pageSpacing, this.pageMargin);
  // }
  if (app.canDispInNormalBrowser()) {} else {
    //!{ added by jiang, 2015-12-10, for mobile rotation
    _MDTouchMenu["default"].hide();
    //!}
  }
  var that = this;

  // 记录就的位置
  var pos = this.container.scrollTop / this.container.scrollHeight;
  if (MMVerticalCollectionView.superClass_.refreshSize.call(this) && this.pageSizes) {
    var containerH = $(this.container).height();
    //this.layout.setItemSizes($(this.parentDiv).width(), containerH, this.pageSizes, this.pageSpacing);
    var dispW = this.calculateContentWidthByScale(this.scale);
    this.layout.refreshWithContainerSize(dispW);
    this.setContentSize(this.layout.getContentSize());
    this.refreshDispCellsPosition();
    this.displayCellsInCurViewPort();

    // 这些代码本质上没有意义，但可以保障更新 container 的 scrollWidth 和 scrollHeight
    that.$contentDiv[0].style.display = 'none';
    that.$contentDiv[0].offsetHeight;
    that.$contentDiv[0].style.display = '';
    that.container.style.display = 'none';
    that.container.offsetHeight;
    that.container.style.display = '';

    // 恢复位置
    var top = pos * this.container.scrollHeight;
    if (top + this.container.offsetHeight > this.container.scrollHeight) {
      top = this.container.scrollHeight - this.container.offsetHeight;
    }
    ;
    this.container.scrollTop = top;
    return true;
  }
  return false;
};

// 用户手指放大后，调用此函数
MMVerticalCollectionView.prototype.refreshForScaled = function () {
  var spacing = this.pageSpacing * this.$contentDiv.width() / $(this.container).width();
  var containerH = $(this.container).height();
  this.layout.setItemSizes(this.$contentDiv.width(), containerH, this.pageSizes, spacing);
  this.setContentSize(this.layout.getContentSize());
  this.refreshDispCellsPosition();
  this.displayCellsInCurViewPort();
};
MMVerticalCollectionView.prototype.refreshDispCellsPosition = function () {
  for (var i = 0; i < this.dispCells.length; i++) {
    var cell = this.dispCells[i];
    var pageIndex = cell.pageIndex;
    var rect = this.layout.getItemRectByIndex(pageIndex);
    cell.setPos(rect.left, rect.top);
    cell.setSize(rect.getSize());
  }
  ;
};
MMVerticalCollectionView.prototype.displayCellsInCurViewPort = function (renderProgress) {
  this.createCellsInCurViewPort();
  this.renderCells(renderProgress);
};
MMVerticalCollectionView.prototype.createCellsInCurViewPort = function () {
  var curLeft = this.container.scrollLeft;
  var curTop = this.container.scrollTop;
  var visiblePageIndexes = this.layout.getVisibleItemIndex(curLeft, curTop, this.viewSize);

  // var visiblePageIndexes =[];
  // for (var i = 0; i < this.pgNum; i++) {
  //  visiblePageIndexes.push(i);
  // };

  //  this.debugCellsInfo(visiblePageIndexes);

  var indexesNotFound = new Array();
  for (var i = 0; i < this.dispCells.length; i++) {
    var cell = this.dispCells[i];
    cell.needRemain = false;
  }
  for (var i = 0; i < visiblePageIndexes.length; i++) {
    var pgIndex = visiblePageIndexes[i];
    var notfound = true;
    for (var k = 0; k < this.dispCells.length; k++) {
      var cell = this.dispCells[k];
      if (pgIndex == cell.pageIndex) {
        cell.needRemain = true;
        notfound = false;
        break;
      }
    }
    if (notfound) {
      indexesNotFound.push(pgIndex);
    }
  }

  // 删除不需要显示的 cell
  for (var i = 0; i < this.dispCells.length;) {
    var cell = this.dispCells[i];
    if (!cell.needRemain) {
      cell.removeFromSuperView();
      this.dispCells.splice(i, 1);
      //      console.log("--- remove cell:" + cell.pageIndex);
    } else {
      i++;
    }
  }
  for (var i = 0; i < indexesNotFound.length; i++) {
    var pgIndex = indexesNotFound[i];
    var cell = this.getCellForPage(pgIndex);
    this.dispCells.push(cell);
    //    console.log("--- create cell:" + pgIndex);
  }
};
MMVerticalCollectionView.prototype.renderCells = function (renderProgress) {
  var self = this;
  var cellNum = this.dispCells.length;
  if (cellNum == 0) {
    if (renderProgress) {
      renderProgress(1.0);
    }
    ;
    return;
  }
  ;
  var totalNum = cellNum;
  for (var i = 0; i < this.dispCells.length; i++) {
    var cell = this.dispCells[i];
    this.initCell(cell, cell.pageIndex, function cellFinishedRender(curCell) {
      cellNum--;
      if (renderProgress) {
        renderProgress((totalNum - cellNum) / totalNum);
      }
      ;
      if (self.scrollToPageCallback && curCell.pageIndex == self.scrollToPageCallback.pageIndex && self.scrollToPageCallback.callback) {
        self.scrollToPageCallback.callback();
        self.scrollToPageCallback = null;
      }
      ;
    });
  }
};
MMVerticalCollectionView.prototype.addCellToBuffer = function (cell) {
  var found = false;
  for (var i = 0; i < this.bufferCells.length; i++) {
    if (this.bufferCells[i] == cell) {
      found = true;
      break;
    }
  }
  if (!found) {
    this.bufferCells.push(cell);
  }
};
MMVerticalCollectionView.prototype.onScroll = function (event) {
  MMVerticalCollectionView.superClass_.onScroll.call(this);
  this.createCellsInCurViewPort();
  var curPage = this.judgeCurPage();
  this.displayCurPageIndex(curPage);
  Dispatcher.trigger(_MDEvents["default"].DISPLAY_PDF_BAR);
};

//
// 由于当前屏幕中有多页在显示，因此需要给出一个页面提示，提示用户当前的页，后面还有多少页
//
MMVerticalCollectionView.prototype.judgeCurPage = function () {
  if (!this.pageSizes) {
    return 1;
  }
  ;
  var curLeft = this.container.scrollLeft;
  var curTop = this.container.scrollTop;
  var visiblePageIndexes = this.layout.getSufficientVisiblePageIndex(curLeft, curTop, this.viewSize, 0);
  if (visiblePageIndexes.length < 1) {
    return 1;
  }
  ;
  var total = this.pageSizes.length;
  var start = visiblePageIndexes[0];
  var end = visiblePageIndexes[visiblePageIndexes.length - 1];
  var curPage = start;
  if (end > total / 2) {
    curPage = end;
  }
  ;
  Dispatcher.trigger(_MDEvents["default"].SET_PAGE_INDEX, curPage);
  return curPage;
};
MMVerticalCollectionView.prototype.getFirstDispCell = function () {
  if (!this.pageSizes) {
    return null;
  }
  ;
  var curLeft = this.container.scrollLeft;
  var curTop = this.container.scrollTop;
  var visiblePageIndexes = this.layout.getVisibleItemIndex(curLeft, curTop, this.viewSize, 0);
  if (visiblePageIndexes.length < 1) {
    return null;
  }
  ;
  var total = this.pageSizes.length;
  var start = visiblePageIndexes[0];
  for (var i = 0; i < this.dispCells.length; i++) {
    var cell = this.dispCells[i];
    if (cell.pageIndex == start) {
      return cell;
    }
    ;
  }
  ;
  return null;
};
MMVerticalCollectionView.prototype.displayCurPageIndex = function (curPage) {
  return;
  if (this.pageSizes.length < 1) {
    return;
  }
  ;
  if (!this.$pageIndexLabel) {
    this.$pageIndexLabel = $("<div class='pdf-curpage'></div>");
    $(this.parentDiv).append(this.$pageIndexLabel);
  }
  ;
  var text = curPage + 1 + "/" + this.pageSizes.length;
  var width = 10 * text.length + 10;
  this.$pageIndexLabel.css("display", "block");
  this.$pageIndexLabel.css("width", width + "px");
  this.$pageIndexLabel.text(text);
  if (this.dispPageLabelTimer) {
    clearTimeout(this.dispPageLabelTimer);
  }
  ;
  this.dispPageLabelTimer = setBabelTimeout(function () {
    this.dispPageLabelTimer = null;
    this.$pageIndexLabel.css("display", "none");
  }.bind(this), 1000);
};
MMVerticalCollectionView.prototype.scrollStopped = function () {
  MMVerticalCollectionView.superClass_.scrollStopped.call(this);
  this.renderCells();
};
MMVerticalCollectionView.prototype.debugCellsInfo = function (visiblePageIndexes) {
  if (!MMCommonFun.isArraysEqual(this.debug_visiblePages, visiblePageIndexes)) {
    this.debug_visiblePages = new Array();
    console.log("-------- ========   visible page indexs:------------------------");
    var str = "";
    for (var i = 0; i < visiblePageIndexes.length; i++) {
      this.debug_visiblePages.push(visiblePageIndexes[i]);
      str += visiblePageIndexes[i] + ", ";
    }
    console.log("***    >>>> " + str);
    str = "";
    for (var i = 0; i < this.dispCells.length; i++) {
      var cell = this.dispCells[i];
      str += cell.pageIndex + ", ";
    }
    console.log(" ^^^ displayed cells: [ " + str + "]");
    str = "";
    for (var i = 0; i < this.bufferCells.length; i++) {
      var cell = this.bufferCells[i];
      str += cell.pageIndex + ", ";
    }
    console.log(" ~~~~ buffered cells: [ " + str + "]");
  }
};
MMVerticalCollectionView.prototype.getCellForPage = function (pageIndex) {
  var cell = null;
  if (this.bufferCells.length > 0) {
    cell = this.bufferCells.shift();
  }
  if (cell == null) {
    cell = this.createCellForPage(pageIndex);
    cell.asSubViewTo(this.$contentDiv[0]);
  }
  cell.pageIndex = pageIndex;
  var rect = this.layout.getItemRectByIndex(pageIndex);
  cell.setScale(this.scale);
  cell.setPos(rect.left, rect.top);
  cell.setSize(rect.getSize());
  return cell;
};
MMVerticalCollectionView.prototype.createCellForPage = function (pageIndex) {
  return new _MMCell["default"]();
};
MMVerticalCollectionView.prototype.initCell = function (cell, pageIndex) {};
MMVerticalCollectionView.prototype.getVisibleCells = function () {
  var left = this.container.scrollLeft;
  var top = this.container.scrollTop;
  var indexes = this.layout.getVisibleItemIndex(left, top, this.viewSize);
  var visibleCells = new Array();
  for (var k = 0; k < indexes.length; k++) {
    var index = indexes[k];
    for (var i = 0; i < this.dispCells.length; i++) {
      var cell = this.dispCells[i];
      if (cell.pageIndex == index) {
        visibleCells.push(cell);
      }
    }
  }
  return visibleCells;
};
MMVerticalCollectionView.prototype.scrollPageUp = function (animated, succ) {
  this.scrollToNextPage(false, animated, succ);
};
MMVerticalCollectionView.prototype.scrollPageDown = function (animated, succ) {
  this.scrollToNextPage(true, animated, succ);
};
MMVerticalCollectionView.prototype.scrollToNextPage = function (next, animated, succ) {
  var curPg = this.judgeCurPage();
  if (next) {
    if (curPg < this.pageSizes.length) {
      this.scrollToPage(++curPg, animated, succ);
    }
    ;
  } else {
    if (curPg >= 0) {
      this.scrollToPage(--curPg, animated, succ);
    }
    ;
  }
};
MMVerticalCollectionView.prototype.scrollToPage = function (index, animated, succ) {
  if (this.pageSizes.length <= 0) {
    return;
  }
  ;
  if (index < 0) {
    index = 0;
  }
  ;
  if (index >= this.pageSizes.length) {
    index = this.pageSizes.length - 1;
  }
  ;
  this.scrollToPageCallback = {
    pageIndex: index,
    callback: succ
  };
  var rect = this.layout.getItemRectByIndex(index);
  var left = rect.left;
  var top = rect.top;
  if (left == 0 && this.container.scrollWidth > this.container.offsetWidth) {
    left = (this.container.scrollWidth - this.container.offsetWidth) / 2;
  }
  var canScroll = false;
  if (top > this.container.scrollTop) {
    // 需要向下滚动
    if (this.container.scrollHeight - this.container.scrollTop - this.container.offsetHeight > 1) {
      canScroll = true;
    }
    ;
  } else if (top < this.container.scrollTop) {
    canScroll = true;
  }
  ;
  if (canScroll) {
    this.scrollToPosition({
      x: left,
      y: top
    }, animated, function finished() {
      // setBabelTimeout(()=>{
      //   succ && succ();
      // }, 1000)
    });
  } else {
    // 已经到了底部，不需要移动
    if (succ) {
      succ();
    }
    ;
  }
};
MMVerticalCollectionView.prototype.changeToPage = function (index, succ) {
  this.scrollToPage(index, true, succ);
};

//=========================================================== pinch gesture ====================================================================================

MMVerticalCollectionView.prototype.pinchStart = function (e) {
  MMVerticalCollectionView.superClass_.pinchStart.call(this, 1);
  this.recordOriginScrollSize();
};
MMVerticalCollectionView.prototype.pinchMove = function (scale) {
  MMVerticalCollectionView.superClass_.pinchMove.call(this, scale);
};
MMVerticalCollectionView.prototype.pinchEnd = function (scale, callback) {
  var that = this;
  MMVerticalCollectionView.superClass_.pinchEnd.call(this, scale, function scaledFinished() {
    that.refreshForScaled();
  });
};
MMVerticalCollectionView.prototype.removeFromSuperView = function () {
  MMVerticalCollectionView.superClass_.removeFromSuperView.call(this);
  for (var i = 0; i < this.bufferCells.length; i++) {
    var cell = this.bufferCells[i];
    var editor = cell.getEditor();
    if (editor) {
      editor.removeFromSuperView();
    }
  }
  for (var i = 0; i < this.dispCells.length; i++) {
    var cell = this.dispCells[i];
    var editor = cell.getEditor();
    if (editor) {
      editor.removeFromSuperView();
    }
  }
  Dispatcher.off(null, null, this);
  if (this.bodyRecognizer) {
    this.bodyRecognizer.off("touchstart touchmove touchend touchcancel pinchstart pinchmove pinchend pinchcancel");
  }
  ;
};

},{"1184":1184,"1432":1432,"1438":1438,"1454":1454,"325":325,"339":339,"811":811,"823":823,"836":836,"913":913,"927":927,"936":936}],936:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MMVerticalLayout;
var _size = _interopRequireDefault(require(837));
var _MMPoint = _interopRequireDefault(require(830));
var _MMRect = _interopRequireDefault(require(831));
/**
 *
 */

var g_pageError = 0.01;
var MMVerticalLayoutType = {
  equalWidth: 0,
  keepProportion: 1
};
function MMVerticalLayout(pageDispWidth, itemSpacing, preloadNum) {
  this.layoutType = MMVerticalLayoutType.equalWidth;
  if (preloadNum == undefined || preloadNum == null) {
    this.preloadNum = 2;
  } else {
    this.preloadNum = preloadNum;
  }
  this.pageDispWidth = pageDispWidth;
  this.viewHeight = 0;
  this.itemSpacing = itemSpacing;
  this.pageMargin = 0;
  this.scale = -1.0;
}
;
MMVerticalLayout.prototype.setItemSizes = function (pageDispWidth, viewHeight, itemSizes, itemSpacing, pageMargin) {
  if (this.scale < 0) {
    this.scale = this.getFitScale(pageDispWidth, itemSizes);
  }
  ;
  this.pageDispWidth = pageDispWidth;
  this.viewHeight = viewHeight;
  this.itemSizes = itemSizes;
  if (itemSpacing) {
    this.itemSpacing = itemSpacing;
  }
  ;
  this.pageMargin = pageMargin ? pageMargin : 0;
  var pageCount = itemSizes.length;
  var containerW = pageDispWidth;

  // if(pageCount >= 1 && app.canDispInNormalBrowser()){ // pc 上显示文档时, 文档宽度不要小于 70%
  // 	var fitScale = containerW * 0.7 / itemSizes[0].width;
  // 	// this.scale = fitScale;
  // }

  this._calculateItemPostions();
  return this.scale;
};
MMVerticalLayout.prototype.getFitScale = function (pageDispWidth, itemSizes) {
  if (itemSizes.length < 1) {
    return 1.0;
  }
  ;
  var t = itemSizes[0];
  if (itemSizes[1]) {
    t = itemSizes[1] > itemSizes[0] ? itemSizes[1] : itemSizes[0];
    if (itemSizes[2]) {
      t = itemSizes[2] > itemSizes[1] ? itemSizes[2] : itemSizes[1];
    }
  }
  var fitScale = pageDispWidth * 0.7 / t.width;
  return fitScale;
};
MMVerticalLayout.prototype.refreshWithChangedScale = function (pageDispWidth, itemSpacing) {
  this.pageDispWidth = pageDispWidth;
  if (itemSpacing != undefined) {
    this.itemSpacing = itemSpacing;
  }
  ;
  this._calculateItemPostions();
};
MMVerticalLayout.prototype.refreshWithContainerSize = function (pageDispWidth) {
  this.pageDispWidth = pageDispWidth;
  this._calculateItemPostions();
};
MMVerticalLayout.prototype.setScale = function (scale) {
  this.scale = scale;
};
MMVerticalLayout.prototype._calculateItemPostions = function () {
  this.itemRects = [];
  if (this.layoutType == MMVerticalLayoutType.equalWidth) {
    var curPageTop = 0;
    for (var i = 0; i < this.itemSizes.length; i++) {
      var size = this.itemSizes[i];
      var rect = new _MMRect["default"]();
      var height = this.calculateHeightByWidth(this.pageDispWidth, size.height, size.width);
      rect.setRct(0, curPageTop, this.pageDispWidth, height);
      this.itemRects.push(rect);
      curPageTop += rect.getHeight() + this.itemSpacing;
    }
    ;
    console.assert(!isNaN(curPageTop));
  }
  ;
};
MMVerticalLayout.prototype.getContentSize = function () {
  var contentSize = new _size["default"](this.pageDispWidth, 0);
  if (!this.itemSizes || this.itemSizes.length == 0) return contentSize;
  if (this.layoutType == MMVerticalLayoutType.equalWidth) {
    for (var i = 0; i < this.itemSizes.length; i++) {
      var size = this.itemSizes[i];
      contentSize.height += this.calculateHeightByWidth(this.pageDispWidth, size.height, size.width);
    }
    ;
    for (var i = 0; i < this.itemSizes.length - 1; i++) {
      contentSize.height += this.itemSpacing;
    }
    ;
  }
  ;
  console.assert(!isNaN(contentSize.height));
  return contentSize;
};
MMVerticalLayout.prototype.calculateHeightByWidth = function (width, itemH, itemW) {
  var cellHeight = 0;
  if (!app.canDispInNormalBrowser()) {
    cellHeight = (width - 2 * this.pageMargin) * itemH / itemW + 2 * this.pageMargin;
  } else {
    cellHeight = itemH * this.scale + 2 * this.pageMargin;
  }
  if (this.itemSizes.length <= 1 && cellHeight < this.viewHeight) {
    cellHeight = this.viewHeight;
  }
  ;
  console.assert(!isNaN(cellHeight));
  return cellHeight;
};
MMVerticalLayout.prototype.getVisibleItemIndex = function (left, top, viewSize, preloadNum) {
  if (!this.itemSizes) {
    return [];
  }
  ;
  var itemIndexes = new Array();
  var start = -1;
  var end = -1;
  var curPageTop = 0;
  var curPageBottom = 0;
  var winTop = top;
  var winBottom = winTop + viewSize.height;
  for (var i = 0; i < this.itemRects.length; i++) {
    var rect = this.itemRects[i];
    curPageTop = rect.top;
    curPageBottom = rect.top + rect.getHeight();
    if (winTop > curPageBottom) {
      start = i + 1;
    }
    if (winBottom > curPageTop) {
      end = i;
    }
    if (curPageTop > winBottom) {
      break;
    }
    ;
  }
  ;
  if (start < 0) start = 0;
  if (start > this.itemSizes.length) start = this.itemSizes.length - 1;
  if (end < 0) end = this.itemSizes.length - 1;

  // preload cell index
  if (preloadNum == undefined || preloadNum == null || preloadNum < 0) {
    preloadNum = this.preloadNum;
  }
  ;
  if (preloadNum > 0) {
    start -= preloadNum / 2;
    if (start < 0) {
      end += preloadNum / 2 - start;
      if (end >= this.itemSizes.length) {
        end = this.itemSizes.length - 1;
      }
      ;
      start = 0;
    } else {
      end += preloadNum / 2;
      if (end >= this.itemSizes.length) {
        start -= end - this.itemSizes.length;
        end = this.itemSizes.length - 1;
        if (start < 0) {
          start = 0;
        }
        ;
      }
      ;
    }
  }
  ;
  for (var i = start; i <= end; i++) {
    itemIndexes.push(i);
  }
  return itemIndexes;
};
MMVerticalLayout.prototype.getSufficientVisiblePageIndex = function (left, top, viewSize, preloadNum) {
  if (!this.itemSizes) {
    return [];
  }
  ;
  var viewRect = new _MMRect["default"]();
  viewRect.setRct(left, top, viewSize.width, viewSize.height);
  var quarterViewArea = viewRect.area() / 4;
  var itemIndexes = [];
  for (var i = 0; i < this.itemRects.length; i++) {
    var rect = this.itemRects[i];
    var inter = viewRect.intersectsRect(rect);
    if (inter) {
      var interArea = inter.area();
      var quarterPgArea = rect.area() / 4;
      if (interArea > quarterPgArea || interArea > quarterViewArea) {
        itemIndexes.push(i);
      }
      ;
    }
    ;
  }
  ;
  return itemIndexes;
};
MMVerticalLayout.prototype.getItemRectByIndex = function (index) {
  console.assert(index < this.itemSizes.length);
  var rect = null;
  if (index >= 0 && index < this.itemRects.length) {
    rect = this.itemRects[index].clone();
  }
  ;
  return rect;
};

},{"1184":1184,"1454":1454,"830":830,"831":831,"837":837}],934:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MMPdfPageCell;
var _MMMobilePageView = _interopRequireDefault(require(930));
var _MDPCPdfPageView = _interopRequireDefault(require(941));
var _MMCell = _interopRequireDefault(require(927));
var _goog = _interopRequireDefault(require(823));
//-------------------------------------------------------------------------------------------\\
//                  Scroll page Cell
//-------------------------------------------------------------------------------------------//
function MMPdfPageCell(imgObj, pageMargin, opt) {
  this.editorViewCtl = opt.editorViewCtl;
  _MMCell["default"].call(this);
  this.pageMargin = pageMargin ? pageMargin : 0;
  if (!app.canDispInNormalBrowser()) {
    this.editor = new _MMMobilePageView["default"](this.$rootDiv[0], opt);
  } else {
    this.editor = new _MDPCPdfPageView["default"](this.$rootDiv[0], pageMargin, opt);
  }
  this.editor.setPageMargin(this.pageMargin);
  this.editor.setDispForVersion(true); // 只显示指定的版本的批注

  this.imgObj = imgObj;
}
;
_goog["default"].inherits(MMPdfPageCell, _MMCell["default"]);
MMPdfPageCell.prototype.setImage = function (imgObj, callback) {
  if (!imgObj) {
    return;
  }
  ;

  //    this.imgSrc = this.imgDiv.src;
  var imgSrc = imgObj.getDispFilePath();
  if (this.imgObj != imgObj && imgSrc.length > 0) {
    if (!app.canDispInNormalBrowser()) {
      // 显示缩略图
      this.dispThumbnailAsBackground(imgObj);
    }
    ;
    this.imgObj = imgObj;
    this.init(callback);
  } else if (this.imgObj) {
    if (callback) {
      callback(this);
    }
    ;
  }
};
MMPdfPageCell.prototype.getImage = function () {
  return this.imgObj;
};
MMPdfPageCell.prototype.init = function (callback) {
  var that = this;
  this.editor.displayObject(this.imgObj, function () {
    setBabelTimeout(function () {
      that.clearCellBackground();
    }, 100);
    if (callback) callback(that);
  });
  // console.log("================> init cell with index:" + this.imgObj.getPageIndex());
};
MMPdfPageCell.prototype.getEditor = function () {
  return this.editor;
};
MMPdfPageCell.prototype.setSize = function (size) {
  MMPdfPageCell.superClass_.setSize.call(this, size);
  this.editor.refreshSize(size);
  if (this.editor == undefined || this.editor == null) {} else {}
};
MMPdfPageCell.prototype.setScale = function (scale) {
  this.scale = scale;
  this.editor.setScale(scale);
};
MMPdfPageCell.prototype.removeFromSuperView = function () {
  if (this.editor) {
    this.editor.removeFromSuperView();
  }
  ;
  MMPdfPageCell.superClass_.removeFromSuperView.call(this);
};
MMPdfPageCell.prototype.changeZoomScaleTo = function (scale) {
  var curScale = this.editor.getZoomScale();
  if (curScale != scale) {
    var centerRatio = this.editor.getCenterRatioPosition();
    var scale = this.editor.changeZoomScale(scale);
    this.editor.restoreCenterPostion(centerRatio);
  }
  return scale;
};
MMPdfPageCell.prototype.getScrollableInfo = function () {
  return this.editor.getScrollableInfo();
};
MMPdfPageCell.prototype.scrollOffset = function (offset) {
  this.editor.scrollOffset(offset);
};
MMPdfPageCell.prototype.refreshObjsDisp = function () {
  this.editor.refreshObjsInEditor();
};
MMPdfPageCell.prototype.refreshLgPageInRect = function (lgRct) {
  this.editor.refreshLgPageInRect(lgRct);
};
MMPdfPageCell.prototype.setImgMarkerCtl = function (imgMarkerCtl) {
  this.imgMarkerCtl = imgMarkerCtl;
  this.editor.setImgMarkerCtl(imgMarkerCtl);
};

},{"1184":1184,"1454":1454,"823":823,"927":927,"930":930,"941":941}],941:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1437);
require(1466);
require(1438);
require(1541);
require(1412);
var _MMRect = _interopRequireDefault(require(831));
var _MDEditorOption = _interopRequireDefault(require(905));
var _MDMarkerObjDrawerController = _interopRequireDefault(require(909));
var _MDColorDisk = _interopRequireDefault(require(856));
var _MMBasicData = _interopRequireDefault(require(811));
var _Dispatcher = _interopRequireDefault(require(18));
var _MMWhiteboard = _interopRequireDefault(require(960));
var _MDEvents = _interopRequireDefault(require(325));
var _MMEditorScroller = _interopRequireDefault(require(907));
var _MMAndroidScrollView = _interopRequireDefault(require(913));
var _MMPDFPageDrawer = _interopRequireDefault(require(933));
var _MMOperationCenterDesktopImage = _interopRequireDefault(require(876));
var _MMOperationCenterDesktopMarker = _interopRequireDefault(require(877));
var _MMOperationCenterMobileMarker = _interopRequireDefault(require(880));
var _MDPdfTextLayerController = _interopRequireDefault(require(910));
var _MDPdfTileView = _interopRequireDefault(require(454));
var _ObjType = _interopRequireDefault(require(1084));
var _MMObjElementsController = _interopRequireDefault(require(893));
var _size = _interopRequireDefault(require(837));
var _MMPoint = _interopRequireDefault(require(830));
var _EditorMode = _interopRequireDefault(require(904));
var _MMOperationCenter = _interopRequireDefault(require(874));
var _MMObjectFilter = _interopRequireDefault(require(955));
var _FilterType = _interopRequireDefault(require(949));
var _ImageTransformer = _interopRequireDefault(require(826));
var _MMPDFDrawerController = _interopRequireDefault(require(932));
var _MDCommentSlidePanelView = _interopRequireDefault(require(319));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
var _MMCommentLineDrawer = _interopRequireDefault(require(906));
var _MMOperationCenterMobileImage = _interopRequireDefault(require(879));
var _MDNavigatorMap = _interopRequireDefault(require(939));
var _MDEditorCommonFun = _interopRequireDefault(require(908));
var _MDPenToolbar = _interopRequireDefault(require(427));
var _MMCommonEditorView = _interopRequireDefault(require(914));
/*jslint nomen: true, vars: true, plusplus:true, browser:true */
/*global console, app, goog, $, _ */
/**
 * pc 上的 pdf 一页的显示
 * javascript/molasync-source/ui/netdisk/pc/editor/MDPCPdfPageView.js
 * 2016-1-28
 */

var g_pdfPageViewId = 0;
function MDPCPdfPageView(containerDiv, pageMargin, opt) {
  this.editorViewCtl = opt.editorViewCtl;
  this.id = g_pdfPageViewId++;
  this.pageMargin = pageMargin ? pageMargin : 10;
  this.mmPdfObj = null;
  this.pdfUrl = null;
  this.$contentDiv = $(containerDiv);
  this.parentDiv = containerDiv;
  this.commentDiv = null;
  this._margin = 10;
  this.operationCenter = null;
  this.scale = 1.0;
  this.__hideScaleDisplayTimeout = null;
  this.__imageMapSrc = null;
  this.divObjsFilter = new _MMObjectFilter["default"]();
  this.divObjsFilter.type = _FilterType["default"].Include;
  this.divObjsFilter.objTypes.push(_ObjType["default"].Obj_comment);
  this.divObjsFilter.objTypes.push(_ObjType["default"].Obj_niceTag);
  this.divObjsFilter.objTypes.push(_ObjType["default"].Obj_graphComment);
  this.canvasObjsFilter = new _MMObjectFilter["default"]();
  this.canvasObjsFilter.type = _FilterType["default"].Include;
  this.canvasObjsFilter.objTypes = _ObjType["default"].getCanvasObjType();
  this.bufferCanvas = [];
  // this.pdfDrawer = new MMPDFPageDrawer();

  if (typeof window.devicePixelRatio == 'undefined') {
    window.devicePixelRatio = 1.0;
  }
  ;
  var that = this;
  this.displayForVersion = false;
  _Dispatcher["default"].on(_MDEvents["default"].Mouse_up, this._onMouseUp, this);
  _Dispatcher["default"].on(_MDEvents["default"].TextComment_status, this.textCommentStatusChanged, this);
  _Dispatcher["default"].on(_MDEvents["default"].NEW_MESSAGE, this.receiveNewMessage, this);
  _Dispatcher["default"].on(_MDEvents["default"].salonStatusChanged, this._salonStatusChanged, this);
}
;
MDPCPdfPageView.prototype.getPicObject = function () {
  return this.mmPdfObj;
};
MDPCPdfPageView.prototype.getClassName = function () {
  return "MDPCPdfPageView";
};
MDPCPdfPageView.prototype.setDispForVersion = function (forVersion) {
  this.displayForVersion = forVersion;
};
MDPCPdfPageView.prototype.displayObject = function (pdfObj, opt, loadFinished) {
  if (!loadFinished) {
    if (opt && _.isFunction(opt)) {
      loadFinished = opt;
      opt = {};
    } else {}
  }
  var filePath = pdfObj.getDispFilePath();
  if (this.mmPdfObj != pdfObj && filePath.length > 0) {
    this.board = pdfObj.getBoard();
    this.mmPdfObj = pdfObj;
    this.loadFinished = loadFinished;
    _MMObjElementsController["default"].getSingleInstance().removeAllDivsForEditor(this);
    this.constructView(loadFinished);
  } else if (filePath.length > 0) {
    this.refreshEditor();
    if (loadFinished) {
      loadFinished(false);
    }
    ;
  }
  ;
};
MDPCPdfPageView.prototype.setPageMargin = function (pageMargin) {
  this.pageMargin = pageMargin;
};
MDPCPdfPageView.prototype.exitFullscreen = function () {
  var element = document;
  if (element.exitFullScreen) element.exitFullScreen();
  if (element.webkitExitFullScreen) element.webkitExitFullScreen();
  if (element.mozExitFullScreen) element.mozExitFullScreen();
  if (element.msExitFullScreen) element.msExitFullScreen();
  this.__imageMapSrc = null;
  this._closeFullscreenEventhandler.unbind();
  delete this._closeFullscreenEventhandler;
  if (this.bodyOverflow != undefined) {
    $(this.parentDiv).css('overflow', this.bodyOverflow);
    $(this.parentDiv).css('overflow-x', this.bodyOverflowX);
    $(this.parentDiv).css('overflow-y', this.bodyOverflowY);
  }
};
MDPCPdfPageView.prototype.isDispPdf = function () {
  return this.mmPdfObj.getObjType() == _ObjType["default"].Obj_PDF;
};
MDPCPdfPageView.prototype.constructView = function (loadFinished) {
  var z_startIndex = _MMBasicData["default"].getO2OStartLayerZ_index();
  var z_maxIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
  this.$root = $(this.container);
  if (!this.mmPdfObj) {
    return;
  }
  ;
  if (this._$allLayers) {
    _MMObjElementsController["default"].getSingleInstance().removeAllDivsForEditor(this);
    this._$allLayers.remove();
  }
  ;
  this.$contentDiv.empty();
  if (this.isDispPdf()) {
    if (this.needTileView()) {
      this._$allLayers = $("<div class='pdf-thumb-layer editor-zone' style='position:absolute; left:0px; top:0px;background-size:100% 100%;background-repeat:none'></div>" + "<div class='tile-container editor-zone' style='position:absolute; left:0px; top:0px;background-size:100% 100%;background-repeat:none;background-color:black;overflow:hidden'></div>" + "<canvas class='scribble-layer editor-canvas-zone' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 0, 0, 0.0);pointer-events:none;'></canvas>" + "<canvas class='comment-line-layer assist_layer' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 0, 0, 0.0);pointer-events:none;'></canvas>" + "<div class='comment-layer editor-zone' style='position:absolute; box-shadow:0 0 10px rgba(0,0,0,0.25);overflow: hidden; left:0px; top:0px;pointer-events:none;z-index: 390000000;'></div>" + "<canvas class='operate-layer assist_layer f-selectable' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 0, 0, 0.0); z-index: 400000000;'></canvas>" + "<div class='text-layer editor-zone textLayer' style='position:absolute; left:0px; top:0px;color:rgba(0,0,0,0);'></div>" + "");
    } else {
      this._$allLayers = $("<div class='pdf-thumb-layer editor-zone' style='position:absolute; left:0px; top:0px;background-size:100% 100%;background-repeat:none'></div>" + "<div class='editor-zone' style='position:absolute;'>" + "<canvas class='pdf-layer editor-canvas-zone' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 255, 255, 1.0)'></canvas>" + "</div>" + "<canvas class='scribble-layer editor-canvas-zone' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 0, 0, 0.0);pointer-events:none;'></canvas>" + "<canvas class='comment-line-layer assist_layer' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 0, 0, 0.0);pointer-events:none;'></canvas>" + "<div class='comment-layer editor-zone' style='position:absolute; box-shadow:0 0 10px rgba(0,0,0,0.25);overflow: hidden; left:0px; top:0px;pointer-events:none;z-index: 390000000;'></div>" + "<canvas class='operate-layer assist_layer f-selectable' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 0, 0, 0.0); z-index: 400000000;'></canvas>" + "<div class='editor-zone' style='position:absolute;' >" + "<div class='editor-zone text-container' style='position:absolute;'>" + "<div class='text-layer  textLayer' style='position:absolute; left:0px; top:0px;color:rgba(0,0,0,0);'></div>" + "</div>" + "</div>" + "");
    }
  } else {
    console.log('not a pdf document');
  }
  this.$contentDiv.append(this._$allLayers);
  this._$pdfLayer = this.$contentDiv.find('.pdf-layer');
  this._$pdfThumbLayer = this.$contentDiv.find('.pdf-thumb-layer');
  this._$pdfTileContainer = this.$contentDiv.find('.tile-container');
  this._$textLayer = this.$contentDiv.find('.text-layer');
  this._$editorLayer = this.$contentDiv.find('.comment-layer');
  this._$operateLayer = this.$contentDiv.find('.operate-layer');
  this._$scribbleLayer = this.$contentDiv.find('.scribble-layer');
  this._$content = this.$contentDiv;
  this._$editorZone = this.$contentDiv.find('.editor-zone'); // image 层和 comment 层
  this._$editorCanvasZone = this.$contentDiv.find('.editor-canvas-zone'); // image 层和 comment 层
  this._$editorContent = this.$contentDiv.find('.assist_layer');
  this._$salonPenCanvas = this.$contentDiv.find('.comment-line-layer');
  this._$textContainer = this.$contentDiv.find('.text-container');
  this._$editorCanvasZone.hide(); // 暂时隐藏，page 加载后再显示，避免显示错误的 page 大小

  var that = this;
  this._scrollNotificationHandler = function (offset) {
    that.$rootScroll[0].scrollLeft = offset.x;
    that.$rootScroll[0].scrollTop = offset.y;
  };
  var mouseDown = false;
  var lastScreenPos = null;
  this.$contentDiv.on('touchstart mousedown', function (e) {
    if (!that.operationCenter) return;
    if (!that.operationCenter.getCurOperation()) that._onMouseDown(e);
  });
  this.$contentDiv.on('touchend mouseup', function (e) {
    if (!that.operationCenter) return;
    if (!that.operationCenter.getCurOperation()) that._onMouseUp(e);
  });
  this.$contentDiv.on('touchmove mousemove', function (e) {
    if (!that.operationCenter) return;
    if (!that.operationCenter.getCurOperation() && that.operationCenter.isMouseCaptured()) that._onMouseMove(e);
  });
  this.initView(loadFinished);
  this.$root.css('left', '0%');
  this.createOperationCenter();
  this.refreshTextLayerIndex();
  this.registerTextLayerEvents();

  // if (loadFinished) {
  //   loadFinished();
  // };

  if (this.canNavigate()) {
    if (this.navigatorMap) {
      this.navigatorMap.removeFromSuperView();
      this.navigatorMap = null;
    }
    ;
    var that = this;
    this.navigatorMap = new _MDNavigatorMap["default"]($('.p-editor-zone')[0], $('.android-container')[0], this._$content, function (offset) {
      that._scrollNotificationHandler(offset);
    });
  }
  ;
  if (this.board && this.board.isCADFile) {
    if (this.board.isCADFile()) {
      var backcolor = localStorage['CADBackgroundColor'];
      if (backcolor) {
        this.changeBackgroundColor(backcolor);
      } else {
        this.changeBackgroundColor('black');
      }
    } else {
      this.changeBackgroundColor('white');
    }
  }
  ;
  if (!_MDEditorOption["default"].showCommentOn) {
    this.hideCommentLayer();
  }
  ;
};
MDPCPdfPageView.prototype.showCommentLayer = function () {
  this._$operateLayer.show();
  this.textLayerCtl.setEnable(true);
};
MDPCPdfPageView.prototype.hideCommentLayer = function () {
  this._$operateLayer.hide();
  this.textLayerCtl.setEnable(false);
};
MDPCPdfPageView.prototype.changeBackgroundColor = function (color) {
  if (this.needTileView()) {
    this._$pdfTileContainer.css('background-color', color);
  } else {
    this._$pdfLayer.css('background-color', color);
  }
};
MDPCPdfPageView.prototype.createOperationCenter = function () {
  if (!app.canDispInNormalBrowser() && this.editorMode != _EditorMode["default"].mark) {
    return;
  }
  ;
  if (this.operationCenter) {
    this.operationCenter.destroy();
  }
  ;
  if (app.canDispInNormalBrowser()) {
    if (this.editorMode === _EditorMode["default"].mark) {
      this.operationCenterType = _MMOperationCenterDesktopMarker["default"];
    } else {
      this.operationCenterType = _MMOperationCenterDesktopImage["default"];
    }
  } else {
    if (this.editorMode === _EditorMode["default"].mark) {
      this.operationCenterType = _MMOperationCenterMobileMarker["default"];
    } else {
      if (this.mmPdfObj.m_objType == _ObjType["default"].Obj_Image) {
        this.operationCenterType = _MMOperationCenterMobileImage["default"];
      } else {}
    }
  }
  this.operationCenter = new this.operationCenterType({
    whiteboard: this.board,
    pageIndex: this.getCurrentFilePageIndex(),
    editor: this,
    mode: 'FULLSCREEN',
    displayedObject: this.mmPdfObj,
    editorViewCtl: this.editorViewCtl
  });
  this.operationCenter.setImgMarkerCtl(this.imgMarkerCtl);
};
MDPCPdfPageView.prototype.initNavigator = function () {
  var lowFilePath = this.mmPdfObj.getThumbnailUrl(false);
  if (this.navigatorMap) {
    this.navigatorMap.initNavigator(this.winW, this.winH, this.imgRatio, lowFilePath);
  }
  ;
};
MDPCPdfPageView.prototype.initView = function (loadFinished) {
  // this.centerElement(this.__scaleDisplay);

  this.drawFininshed = false;

  // image src path
  if (!this.mmPdfObj) return;
  var filePath = "";
  filePath = this.mmPdfObj.getDispFilePath();
  this.mmPdfObj.setShowingOriginFile(true);
  if (filePath.length == 0) {
    return;
  }
  ;
  var originSize = this.mmPdfObj.getOriginSize();
  if (originSize) {
    this.originW = originSize.x;
    this.originH = originSize.y;
    this.setScaleToFit();
  }
  ;
  this.drawPdfPage(loadFinished);
};
MDPCPdfPageView.prototype.drawPdfPage = function (loadFinished) {
  var that = this;
  _MMPDFDrawerController["default"].getGlobalInstance().clear(this);
  console.log('--------- begin pdf page index  ' + that.mmPdfObj.getPdfPageIndex() + '  time: ' + new Date().getTime());
  that._$pdfThumbLayer.css("background-image", "url(" + that.mmPdfObj.getThumbnailUrl(false) + ")");
  this.mmPdfObj.getPdfPage(function (page) {
    that.page = page;
    if (!that.mmPdfObj || page['pageIndex'] != that.mmPdfObj.getPdfPageIndex() - 1 || page.mmobjId != that.mmPdfObj.getId()) {
      return;
    }
    ;
    that._$editorCanvasZone.show();
    var viewport = that.mmPdfObj.page.getViewport(1.0);
    that.originW = viewport.width;
    that.originH = viewport.height;
    that.imgRatio = that.originH / that.originW;
    that.mmPdfObj.setOriginSize(new _MMPoint["default"](viewport.width, viewport.height));
    that.initRotateAngle();
    that.initNavigator();
    that.refreshEditor(loadFinished, true);
    if (that.needTileView()) {
      that.drawPageInTileView(page, loadFinished);
    } else {
      that.drawPageInCanvas(loadFinished);
    }
  });
};
MDPCPdfPageView.prototype.drawPageInTileView = function (loadFinished) {
  if (!this.tileView) {
    this.tileView = new _MDPdfTileView["default"]();
  }
  ;
  this.tileView.renderTo(this.page, this._$pdfTileContainer[0], $('.android-container')[0]);
};
MDPCPdfPageView.prototype.drawPageInCanvas = function (loadFinished) {
  var that = this;
  var page = this.page;
  page['mytestindex'] = this.mmPdfObj.getPageIndex();
  console.log('--------- draw page In canvas, index ' + this.mmPdfObj.getPageIndex() + ' time:' + new Date().getTime());
  // that.pdfDrawer.clear();
  // that.pdfDrawer.setPDFPage(page);

  $(that.container).css('overflow', 'hidden');
  var $pdflayer = that._$pdfLayer;
  if (app.canDispInNormalBrowser()) {
    that._$textLayer.css('display', 'block');
  }
  ;
  $(that.container).css('overflow', 'auto');
  console.log('--------- draw pdf in editor   ' + new Date().getTime());
  var time = 10;
  var drawFinishCall = loadFinished;
  time = 0;
  // setBabelTimeout(function(){
  // that._$pdfLayer.css("display", "none");
  // that.pdfDrawer.drawInCanvas($pdflayer[0], function(){
  _MMPDFDrawerController["default"].getGlobalInstance().drawInCanvas(that, $pdflayer[0], page, function () {
    //          that.__loadingPlaceholder.css('display', 'none');
    that._$pdfLayer.css("display", "block");
    that.drawFininshed = true;
    // that.refreshEditor();
    that._$pdfThumbLayer.remove();
    if (drawFinishCall) {
      drawFinishCall(true); //pdf draw finhished.
    }
    ;
  });
  // }, time);
};
MDPCPdfPageView.prototype.adjustScale = function () {
  var imgDispWidth = this.originRotateW;
  var imgDispHeight = this.originRotateH;
  imgDispWidth = parseInt(imgDispWidth * this.scale);
  imgDispHeight = parseInt(imgDispHeight * this.scale);
  var winW = this.parentDivSize.width - this._margin;
  var winH = this.parentDivSize.height - this._margin;

  // if (imgDispWidth > winW || imgDispHeight > winH) {
  var xScale = winW / this.originRotateW;
  var yScale = winH / this.originRotateH;
  this.scale = xScale < yScale ? xScale : yScale;
  // }

  return this.scale;
};
MDPCPdfPageView.prototype.refreshDivsSize = function (clearCanvas) {
  if (!this.$root) {
    return;
  }
  ;
  var editorZoneSize = new _size["default"](0, 0);

  // window size
  this.winW = this.parentDivSize.width;
  this.winH = this.parentDivSize.height;
  this.adjustScale();
  var contentW = this.winW;
  var contentH = this.winH;
  var that = this;
  var imgDispWidth = this.originRotateW;
  var imgDispHeight = this.originRotateH;
  imgDispWidth = parseInt(imgDispWidth * this.scale);
  imgDispHeight = parseInt(imgDispHeight * this.scale);
  if (contentW >= imgDispWidth && contentH >= imgDispHeight) {
    this.$root.css("overflow", "hidden");
  } else {
    this.$root.css("overflow", "auto");
  }
  var marginLeft = (this.winW - imgDispWidth) / 2;
  if (marginLeft < 0) {
    marginLeft = 0;
    contentW = imgDispWidth;
  }
  var marginTop = (this.winH - imgDispHeight) / 2;
  if (marginTop < 0) {
    marginTop = 0;
    contentH = imgDispHeight;
  }
  var $editorContent = this._$editorContent;
  $editorContent.css('width', contentW + 'px');
  $editorContent.css('height', contentH + 'px');
  $editorContent.css('margin-left', 'auto');
  $editorContent.css('margin-right', 'auto');
  $editorContent.css('margin-top', 'auto');
  $editorContent.css('margin-bottom', 'auto');
  this._$editorContent.attr('width', contentW + 'px');
  this._$editorContent.attr('height', contentH + 'px');
  var $editorZone = this._$editorZone; // image 层和 comment 层
  var $editorCanvasZone = this._$editorCanvasZone;
  editorZoneSize.width = imgDispWidth;
  editorZoneSize.height = imgDispHeight;
  $editorZone.css('width', imgDispWidth + 'px');
  $editorZone.css('height', imgDispHeight + 'px');
  $editorZone.css('left', marginLeft + 'px');
  $editorZone.css('top', marginTop + 'px');
  $editorCanvasZone.css('width', imgDispWidth + 'px');
  $editorCanvasZone.css('height', imgDispHeight + 'px');
  $editorCanvasZone.css('left', marginLeft + 'px');
  $editorCanvasZone.css('top', marginTop + 'px');
  var imgScaleW = that.originW * this.scale;
  var imgScaleH = that.originH * this.scale;
  var imgLeft = (imgDispWidth - imgScaleW) / 2;
  var imgTop = (imgDispHeight - imgScaleH) / 2;
  if (clearCanvas) {
    MMCommonFun.initCanvasSize($editorCanvasZone, imgDispWidth, imgDispHeight);
    if (that._$pdfLayer) {
      MMCommonFun.initCanvasSize(that._$pdfLayer, imgScaleW, imgScaleH);
    }
  }
  ;
  if (typeof window.devicePixelRatio == 'undefined') {
    window.devicePixelRatio = 1.0;
  }
  ;
  this._$textLayer.css('width', imgScaleW * window.devicePixelRatio + 'px');
  this._$textLayer.css('height', imgScaleH * window.devicePixelRatio + 'px');
  this._$textLayer.css('transform-origin', '0px 0px');
  this._$textLayer.css('transform', 'scale(' + 1 / window.devicePixelRatio + ')');
  var $pdflayer = this._$pdfLayer;
  $pdflayer.css('left', marginLeft + 'px');
  $pdflayer.css('top', marginTop + 'px');
  if (that._$pdfLayer) {
    that._$pdfLayer.css("width", imgScaleW + "px");
    that._$pdfLayer.css("height", imgScaleH + "px");
    that._$pdfLayer.css('left', imgLeft + 'px');
    that._$pdfLayer.css('top', imgTop + 'px');
    that._$pdfLayer.css('transform', 'rotate(' + this.angle + 'deg)');
    this._$textContainer.css('left', '0px');
    this._$textContainer.css('top', '0px');
    this._$textContainer.css('transform', 'rotate(' + this.angle + 'deg)');
    if (this._$textLayer) {
      that._$textLayer.css('left', imgLeft + 'px');
      that._$textLayer.css('top', imgTop + 'px');
    }
    ;
  }
  return editorZoneSize;
};
MDPCPdfPageView.prototype.refreshEditor = function (loadFinished, clearCanvas) {
  if (!this.$root) {
    return;
  }
  ;
  var editorZoneSize = this.refreshDivsSize(clearCanvas);
  this.refreshObjsInEditor();
  if (loadFinished) {
    loadFinished(true);
  }
  ;
  if (this.mmPdfObj && this.divTrsfm) {
    _Dispatcher["default"].trigger(_MDEvents["default"].RENDER_OBJ_FINISH, this, this.mmPdfObj.getPageIndex());
  }
  ;
  return editorZoneSize;
};
MDPCPdfPageView.prototype.getScale = function () {
  return this.scale;
};
MDPCPdfPageView.prototype.changeEditZoneSize = function (width, height) {};
MDPCPdfPageView.prototype.centerElement = function (el, direction) {
  var $el = $(el);
  var winW = $(this.parentDiv).width() || window.innerWidth;
  var winH = $(this.parentDiv).height() || window.innerHeight;
  if (!direction) {
    $el.css('left', winW / 2 - parseInt($el.width()) / 2);
    $el.css('top', winH / 2 - parseInt($el.height()) / 2);
  } else {
    if (direction === 'top') {
      $el.css('top', winW / 2 - parseInt($el.height()) / 2);
    } else if (direction === 'left') {
      $el.css('left', winH / 2 - parseInt($el.width()) / 2);
    }
  }
};
MDPCPdfPageView.prototype.endFullscreen = function () {
  this.$root.css('left', '100%');
  if (app.canDispInNormalBrowser()) {
    this.exitFullscreen();
    this.removeFromSuperView();
  } else {
    setBabelTimeout(function () {
      this.exitFullscreen();
      this.removeFromSuperView();
    }.bind(this), 300);
  }
};
MDPCPdfPageView.prototype.constructHotZoneCtl = function () {
  //this.hotZoneCtl = new MMHotZoneDispCtl(this.$root[0]);
};

/**
 * 获得标注 div 所在的层
 * @returns $div
 */
MDPCPdfPageView.prototype.getCommentLayer = function () {
  return this._$editorLayer[0];
};

/**
 * 获得标注对象 div 所在的 z index
 * @returns z index {Number}
 */
MDPCPdfPageView.prototype.getCommentStartlayerZ_index = function () {
  return _MMBasicData["default"].getO2OCommentStartlayerZ_index();
};
MDPCPdfPageView.prototype.getAssistantCanvas = function () {
  return this._$operateLayer[0];
};
MDPCPdfPageView.prototype.getSalonPenCanvas = function () {
  return this._$salonPenCanvas[0];
};
MDPCPdfPageView.prototype.getScribbleCanvas = function () {
  return this._$scribbleLayer[0];
};
MDPCPdfPageView.prototype.getPageAssistantCanvas = function () {
  return this.getAssistantCanvas();
};
MDPCPdfPageView.prototype.getCommentLineLayer = function () {
  return null;
};
MDPCPdfPageView.prototype.getDivTransformer = function () {
  return this.divTrsfm;
};
MDPCPdfPageView.prototype.getCanvasTransformer = function () {
  return this.canvasTrsfm;
};
MDPCPdfPageView.prototype.getDivTransformerForAssist = function () {
  return this.divAssistTrsfm;
};
MDPCPdfPageView.prototype.getCanvasTransformerForAssist = function () {
  return this.canvasAssistTrsfm;
};
MDPCPdfPageView.prototype.zoom = function (change) {
  this.changeScale(this.scale + change);
};

// variable to avoid dublicated resizing on scale
// var globalo2oScallNumber = null;
MDPCPdfPageView.prototype.refreshTimeout = function (scale, callback) {
  var that = this;

  // execute the scale
  this.setScaleToFit();
  this.globalo2oScallNumber = Math.random();
  var localo2oScallNumber = this.globalo2oScallNumber;
  requestAnimationFrame(function () {
    if (localo2oScallNumber == this.globalo2oScallNumber) this.refreshEditor(function () {
      that.refreshCanvas();
      if (callback) {
        callback();
      }
      ;
    });
  }.bind(this));
};
MDPCPdfPageView.prototype.changeScale = function (scale, callback) {
  console.error('changeScale');
};
MDPCPdfPageView.prototype.zoomDiv = function (scale) {
  console.error('zoomDiv');
  this.refreshCanvas();
};
MDPCPdfPageView.prototype.zoomToFit = function () {
  console.error('zoomToFit');
  var scale = this.getFitZoomScale();
  this.changeScale(scale);
};
MDPCPdfPageView.prototype.getFitZoomScale = function () {
  var margin = this.pageMargin;
  var containerW = this.parentDiv.offsetWidth - margin;
  var containerH = this.parentDiv.offsetHeight - margin;
  if (containerW > 0 && containerH > 0 && this.originW > 0 && this.originH > 0) {
    var scaleX = containerW / this.originW;
    var scaleY = containerH / this.originH;
    var scale = scaleX < scaleY ? scaleX : scaleY;
    if (scale > 1.0) {
      scale = 1.0;
    }
    ;
    return scale;
  }
  ;
  return 1.0;
};
MDPCPdfPageView.prototype.setScale = function (scale) {
  this.scale = scale;
  this.clearSalonSpeakerMouseClick();
};
MDPCPdfPageView.prototype.setScaleToFit = function () {
  if (this.mmPdfObj) {
    var board = this.mmPdfObj.getBoard();
    if (!board || board.getPageCount() == 1) {
      return;
    }
    ;
  } else {
    return;
  }
  var margin = this.pageMargin;
  var containerW = this.parentDivSize.width - 2 * margin;
  var containerH = this.parentDivSize.height - 2 * margin;
  if (containerW > 0 && containerH > 0 && this.originW > 0 && this.originH > 0) {
    var scaleX = containerW / this.originW;
    var scaleY = containerH / this.originH;
    var needScaleToFitWinWidth = false;
    needScaleToFitWinWidth = this.isDispPdf() && !app.canDispInNormalBrowser() || this.editorMode == _EditorMode["default"].mark;
    if (needScaleToFitWinWidth) {
      //  ----------------------------- pdf 等宽显示,即只要宽度适合
      scaleY = scaleX + 0.1;
    }
    ;
    var pageCount = this.mmPdfObj.getBoard().getPageCount();
    var scale = scaleX < scaleY ? scaleX : scaleY;
    this.scale = scale;
  } else {
    this.scale = 1.0;
  }
};
MDPCPdfPageView.prototype.needTileView = function () {
  return false;
  return this.mmPdfObj.getBoard().getPageCount() == 1;
};
MDPCPdfPageView.prototype.canNavigate = function () {
  return this.mmPdfObj.getBoard().getPageCount() == 1;
};
MDPCPdfPageView.prototype.zoomToFitWidth = function (callback) {
  var margin = this.pageMargin;
  var containerW = this.parentDiv.offsetWidth - margin;
  if (containerW > 0 && this.originW > 0) {
    var scaleX = containerW / this.originW;
    var scale = scaleX < 1 ? scaleX : 1;
    this.changeScale(scale, callback);
  }
  ;
};
MDPCPdfPageView.prototype.refreshSize = function (size) {
  var that = this;
  this.parentDivSize = size;
  this.setScaleToFit();
  this.refreshEditor(function () {
    that.refreshCanvas();
  });
  this.removeCommentPanel();

  // var curPdfPos = this.editorViewCtl.getCurEditor().getCenterRatioPosition();
  // this.editorViewCtl.getCurEditor().restoreCenterPostion(curPdfPos);
};
MDPCPdfPageView.prototype.refreshCanvas = function () {
  var targetW = this._$editorZone.width();
  var targetH = this._$editorZone.height();

  // this.refreshPdfCanvas(targetW, targetH);
  var imgScaleW = this.originW * this.scale;
  var imgScaleH = this.originH * this.scale;
  this.refreshPdfCanvas(imgScaleW, imgScaleH);
  MMCommonFun.initCanvasSize(this._$scribbleLayer, targetW, targetH);
  this.refreshObjsInCanvas();
};
MDPCPdfPageView.prototype.refreshPdfCanvas = function (targetW, targetH) {
  if (this.needTileView()) {
    this.drawPageInTileView();
  } else {
    if (!this.isDispPdf() || !this.drawFininshed) {
      return;
    }
    if (this._$drawingPdf) {
      this._$drawingPdf.remove();
    }
    ;
    this._$drawingPdf = this._$pdfLayer.clone();
    this._$pdfLayer.before(this._$drawingPdf);
    MMCommonFun.initCanvasSize(this._$drawingPdf, targetW, targetH);
    _MMPDFDrawerController["default"].getGlobalInstance().clear(this);
    var that = this;
    var drawingPdf = this._$drawingPdf;
    _MMPDFDrawerController["default"].getGlobalInstance().drawInCanvas(this, this._$drawingPdf[0], this.page, function () {
      that._$pdfLayer.remove();
      that._$pdfLayer = drawingPdf;
      that._$drawingPdf = null;
      that._$editorCanvasZone = that.$contentDiv.find('.editor-canvas-zone'); // image 层和 comment 层
    });
  }
};
MDPCPdfPageView.prototype.calculateZoomList = function () {
  if (app.canDispInNormalBrowser()) {
    var imgOrgWidth = this.originW;
    var imgOrgHeight = this.originH;
    var contentW = this.winW;
    var contentH = this.winH;
    var scaleX = contentW / imgOrgWidth;
    var scaleY = contentH / imgOrgHeight;
    var fitScale = Math.min(scaleX, scaleY);
    var fitW = Math.max(scaleX, scaleY);
    var minScale = 0;
    var maxScale = 0;
    if (fitScale > 0) {
      var c1 = Math.floor(10 * fitScale);
      if (fitScale > 0.2) {
        minScale = 0.2;
      } else {
        minScale = Math.floor(fitScale * 100) / 100;
      }
      var c2 = Math.floor((2.0 - fitScale) * 10);
      if (c2 < 0) {
        c2 = 0;
      }
      ;
      maxScale = fitScale + c2 * 0.1;
      if (2.0 - maxScale < 0.2) {
        maxScale = 2.0;
      }
      ;
      maxScale = Math.floor(maxScale + 0.5);
      if (maxScale < 2) {
        maxScale = 1.5;
      }
      ;
      if (fitScale < 0.5) {
        maxScale = 1.0;
      } else {
        if (fitScale > 2.0) {
          maxScale = Math.ceil(fitScale * 100) / 100;
        } else {
          maxScale = 2.0;
        }
      }
      var scales = [];
      if (minScale < 0.2) {
        scales.push(minScale);
      }
      ;
      scales.push(0.2);
      scales.push(0.35);
      scales.push(0.5);
      scales.push(0.75);
      scales.push(1.0);
      if (maxScale > 1.0 || this.mmPdfObj && this.mmPdfObj.getObjType() == _ObjType["default"].Obj_PDF) {
        scales.push(1.5);
        scales.push(2.0);
      }
      ;
      if (maxScale > 2.0) {
        scales.push(maxScale);
      }
      ;
      if (this == _MDPcMobileEditorCommonFun["default"].getMainEditor()) {
        _Dispatcher["default"].trigger(_MDEvents["default"].SCALE_ARRAY, scales);
      }
      ;
      return scales;
    }
    ;
  }
  ;
};
MDPCPdfPageView.prototype.refreshObjsInEditor = function () {
  var arcAngle = this.mmPdfObj.getDrawAngle() * Math.PI / 180;
  var lgImgRect = this.mmPdfObj.getDrawRect();
  var dvImgSize = new _size["default"](this.originW, this.originH);
  if (!this.originW || !this.originH || isNaN(this.originW) || isNaN(this.originH)) {
    this.divTrsfm = null;
    this.divAssistTrsfm = null;
    return;
  }
  ;
  dvImgSize.width *= this.scale;
  dvImgSize.height *= this.scale;
  var viewAngle = this.angle * Math.PI / 180;
  this.divTrsfm = new _ImageTransformer["default"](dvImgSize, lgImgRect, arcAngle, viewAngle);
  this.divAssistTrsfm = new _ImageTransformer["default"](dvImgSize, lgImgRect, arcAngle, viewAngle);
  this.divAssistTrsfm.setLayers(this._$editorLayer[0], this._$operateLayer[0]);
  var canvas = this._$scribbleLayer[0];
  var canvasSize = dvImgSize; //   new Size(parseInt(canvas.style.width), parseInt(canvas.style.height));
  this.canvasTrsfm = new _ImageTransformer["default"](canvasSize, lgImgRect, arcAngle, viewAngle);
  this.canvasAssistTrsfm = new _ImageTransformer["default"](canvasSize, lgImgRect, arcAngle, viewAngle);
  this.canvasAssistTrsfm.setLayers(canvas, this._$operateLayer[0]);
  var lgRct = this.mmPdfObj.getExpandRect();
  _MMObjElementsController["default"].getSingleInstance().removeAllDivsForEditor(this);
  if (this.displayForVersion) {
    this.divObjsFilter.objVer = this.mmPdfObj.getFileVersion();
    this.canvasObjsFilter.objVer = this.mmPdfObj.getFileVersion();
  } else {
    this.divObjsFilter.objVer = this.canvasObjsFilter.objVer = -1;
  }
  this.refreshCommentsInEditor(lgRct);
  this.refreshObjsInCanvas(lgRct);
};
MDPCPdfPageView.prototype.getOperationCenter = function () {
  return this.operationCenter;
};
MDPCPdfPageView.prototype.setCurOperation = function (oper_, objs_, comm_) {
  if (this.operationCenter) {
    // oper_ = "arrowComment";   // ------------- test
    this.operationCenter.setCurOperation(oper_, objs_, comm_);
    this.refreshTextLayerIndex();
  }
};
MDPCPdfPageView.prototype.getCurOperation = function () {
  return this.operationCenter.m_curOperation;
};
MDPCPdfPageView.prototype.refreshLgPageInRect = function (lgRct) {
  this.refreshObjsInCanvas(lgRct);
  this.refreshCommentsInEditor(lgRct);
};
MDPCPdfPageView.prototype.clearContent = function () {
  if (!this.$root) {
    return;
  }
  ;

  // 1. clear canvas
  var geo_canvas = this._$scribbleLayer[0];
  if (geo_canvas) {
    var w = this._$scribbleLayer.width();
    var h = this._$scribbleLayer.height();
    var ctx = geo_canvas.getContext('2d');
    ctx.clearRect(0, 0, w, h);
  }
  ;

  // 2. clear div
  _MMObjElementsController["default"].getSingleInstance().removeAllDivsForEditor(this);
};
MDPCPdfPageView.prototype.clearPdfLayer = function () {
  var pdf_canvas = this._$pdfLayer[0];
  if (pdf_canvas) {
    var w = this._$pdfLayer.width();
    var h = this._$pdfLayer.height();
    var ctx = pdf_canvas.getContext('2d');
    ctx.clearRect(0, 0, w, h);
  }
  ;
};
MDPCPdfPageView.prototype.refreshObjsInCanvas = function (lgRct) {
  if (!this.mmPdfObj || !this.canvasTrsfm) {
    return;
  }
  ;
  if (!lgRct) {
    lgRct = this.mmPdfObj.getExpandRect();
  }
  ;
  var geo_canvas = this._$scribbleLayer[0];
  MMCommonFun.setContextScale(geo_canvas);
  var i = this.mmPdfObj.getPageIndex();

  // 刷新旧的绘制内容
  var dvRct = this.canvasTrsfm.lg2dvRect(lgRct, i).intRect();
  var curTask = this.board;
  var geo_ctx = geo_canvas.getContext("2d");

  // //test
  // geo_ctx.fillStyle = 'rgba(255,0,0,0.5)';
  // geo_ctx.fillRect(0,0,320,320);

  if (curTask && geo_ctx) {
    geo_ctx.save();
    MMCommonFun.clipContext(geo_ctx, dvRct);
    curTask.drawObjsInCanvas(geo_ctx, this.canvasTrsfm, i, this.canvasObjsFilter, lgRct);
    geo_ctx.restore();
  }
  ;
  this.refreshSalonScribbleInCanvas();
};
MDPCPdfPageView.prototype.refreshSalonScribbleInCanvas = function (dvRct) {
  if (this.editorMode == _EditorMode["default"].mark) {
    return;
  }
  ;
  var geo_canvas = this.getSalonPenCanvas();
  // var geo_canvas = this.getAssistantCanvas();
  var geo_ctx = geo_canvas.getContext("2d");
  if (!dvRct) {
    dvRct = new _MMRect["default"]();
    dvRct.setRct(0, 0, geo_canvas.offsetWidth, geo_canvas.offsetHeight);
  }
  var leftTop = dvRct.getOrigin();
  var size = dvRct.getSize();
  geo_ctx.clearRect(leftTop.x, leftTop.y, size.width, size.height);
  var curTask = this.board;
  var trsfm = this.getCanvasTransformerForAssist();
  if (curTask && geo_ctx) {
    var lgRct = trsfm.dv2lgRect(dvRct);
    geo_ctx.save();
    MMCommonFun.clipContext(geo_ctx, dvRct);
    curTask.drawSalonScribbles(geo_ctx, this.getCanvasTransformerForAssist(), lgRct);
    geo_ctx.restore();
  }
  ;
};
MDPCPdfPageView.prototype.drawMarkerObjsInCanvas = function (objects) {
  _MDMarkerObjDrawerController["default"].drawMarkerObjs(this, objects);
};
MDPCPdfPageView.prototype.scale2drawMarkerObjsInCanvas = function (objects, callback) {
  _MDMarkerObjDrawerController["default"].scale2drawMarkerObjs(this, objects, this.markEditable, callback);
};
MDPCPdfPageView.prototype.clearOpLayer = function () {
  var ctx = this._$operateLayer[0].getContext('2d');
  ctx.clearRect(0, 0, this._$operateLayer.width(), this._$operateLayer.height());
};
MDPCPdfPageView.prototype.drawPathInOpLayer = function (pathLGPoints) {
  if (!pathLGPoints) {
    return;
  }
  ;
  var ctx = this._$operateLayer[0].getContext('2d');
  this.clearOpLayer();

  // ctx.fillStyle = 'rgba(255,0,0,0.5)';
  // ctx.fillRect(0, 0, 100, 100);

  if (pathLGPoints[0]) {
    ctx.beginPath();
    var op = this.getCurOperation();
    if (op.toolName && op.toolName == "penComment") {
      ctx.strokeStyle = _MDPenToolbar["default"].getColor();
      ctx.lineWidth = _MDPenToolbar["default"].getLineWidth();
    } else {
      ctx.strokeStyle = _MDColorDisk["default"].getCurColor();
      ctx.lineWidth = MDLineWidthAndFont.getCurLineWidth();
    }
    var devicePoint = this.getDivTransformer().lg2dvPoint(pathLGPoints[0], this.mmPdfObj.getPageIndex());
    devicePoint = this.convertPointFromEditor2AssistView(devicePoint);
    ctx.moveTo(devicePoint.x, devicePoint.y);
    for (var i = 0; i < pathLGPoints.length; i++) {
      devicePoint = this.getDivTransformer().lg2dvPoint(pathLGPoints[i], this.mmPdfObj.getPageIndex());
      devicePoint = this.convertPointFromEditor2AssistView(devicePoint);
      ctx.lineTo(devicePoint.x, devicePoint.y);
    }
    ctx.stroke();
  }
};
MDPCPdfPageView.prototype.refreshCommentsInEditor = function (lgRct) {
  if (!this.mmPdfObj || !this.divTrsfm) {
    return;
  }
  ;
  if (!lgRct) {
    lgRct = this.mmPdfObj.getExpandRect();
  }
  ;
  if (this.editorMode == _EditorMode["default"].mark) {
    _MMObjElementsController["default"].getSingleInstance().removeAllDivsForEditor(this);
  } else {
    var curTask = this.mmPdfObj.getBoard();
    curTask.drawObjsInDiv(this, this.divTrsfm, this.mmPdfObj.getPageIndex(), this.divObjsFilter, lgRct);
  }
};
MDPCPdfPageView.prototype.getCurrentFilePageIndex = function () {
  var index = -1;
  if (this.mmPdfObj) {
    index = this.mmPdfObj.getPageIndex();
  }
  return index;
};
MDPCPdfPageView.prototype._onMouseDown = function (e) {
  if (this.animateScrolling) {
    clearInterval(this.animateScrolling);
    this.animateScrolling = null;
  }
  this.startMousePos = MMCommonFun.touchPosition(e);
  this.$rootScroll = this.$contentDiv.parent().parent();
  if (!this.mouseDown && this.hotZonePanelCtl && (this.hotZonePanelCtl.isHotZoneInCreation() || this.hotZonePanelCtl.isTargetInCreation())) {
    console.log("mouse down:(" + this.startMousePos.x + "," + this.startMousePos.y + ")");
  } else {
    this.moveLen = 1;
    if (this.navigatorMap) {
      this.navigatorMap.preventMouseEvents(true);
    }
    ;
    this.lastScreenPos = MMCommonFun.touchPosition(e);
  }
  this.mouseDown = true;
  this.startTime = new Date();
};
MDPCPdfPageView.prototype._onMouseMove = function (e) {
  if (this.mouseDown && this.hotZonePanelCtl && (this.hotZonePanelCtl.isHotZoneInCreation() || this.hotZonePanelCtl.isTargetInCreation())) {
    this.endMousePos = MMCommonFun.touchPosition(e);
    var delta = this.startMousePos.offsetTo(this.endMousePos);
    var canvas = this._$operateLayer[0];
    var ctx = canvas.getContext('2d');
    var w = canvas.offsetWidth;
    var h = canvas.offsetHeight;
    ctx.clearRect(0, 0, w, h);
    if (this.hotZonePanelCtl.isHotZoneInCreation()) {
      ctx.fillStyle = "rgba(0, 255, 0, 0.5)";
    }
    ;
    if (this.hotZonePanelCtl.isTargetInCreation()) {
      ctx.fillStyle = "rgba(255, 0, 0, 0.5)";
    }
    ;
    ctx.fillRect(this.startMousePos.x, this.startMousePos.y, delta.x, delta.y);
  } else {
    var newScreePos = MMCommonFun.touchPosition(e);
    if (this.moveLen) {
      this.moveLen += Math.abs(newScreePos.x - this.lastScreenPos.x) + Math.abs(newScreePos.y - this.lastScreenPos.y);
    }
    ;
    if ((e.type == 'mousemove' || e.type == 'touchmove') && this.lastScreenPos && this.mouseDown && !this.operationCenter.m_selectedObjs.length) {
      this._scrollNotificationHandler(new _MMPoint["default"](this.$rootScroll[0].scrollLeft - (newScreePos.x - this.lastScreenPos.x), this.$rootScroll[0].scrollTop - (newScreePos.y - this.lastScreenPos.y)));
    }
    this.lastScreenPos = newScreePos;
  }
};
MDPCPdfPageView.prototype._onMouseUp = function (e) {
  var self = this;
  if (this.mouseDown) {
    this.mouseDown = false;
    if (this.hotZonePanelCtl && (this.hotZonePanelCtl.isHotZoneInCreation() || this.hotZonePanelCtl.isTargetInCreation())) {
      this._createHotZone();
    } else {
      if (this.navigatorMap) {
        this.navigatorMap.preventMouseEvents(false);
      }
      ;
      this.moveLen = 0;
    }
    var curTime = new Date();
    var dist = this.lastScreenPos.distanceTo(this.startMousePos);
    var timespan = curTime - this.startTime;
    console.log('----------------------- time span:' + timespan);
    console.log('----------------------- dist:' + dist);
    var v = dist / timespan;
    if (dist > 100 && v > 1) {
      var animatespan = 42;
      var curV = this.lastScreenPos.subtract(this.startMousePos);
      this.animateScrolling = setInterval(function () {
        curV.multiple(0.9);
        if (curV.magnitude() < 10) {
          clearInterval(self.animateScrolling);
          self.animateScrolling = null;
        } else {
          self._scrollNotificationHandler(new _MMPoint["default"](self.$rootScroll[0].scrollLeft - curV.x, self.$rootScroll[0].scrollTop - curV.y));
        }
      }, animatespan);
    }
  }
};
MDPCPdfPageView.prototype._onScroll = function () {
  var that = this;
  clearTimeout(this.__naviShowTimeout);
  this.__naviShowTimeout = setBabelTimeout(function (e) {
    if (that._overNaviRoot !== true) that.$navi_root.css('display', 'none');
  }, 1000);
  var objType = this.mmPdfObj.getObjType();
  if (this.container.scrollWidth > this.container.offsetWidth || this.container.scrollHeight > this.container.offsetHeight) {
    this.$navi_root.css('display', 'inline');
  }
  this.focusInNavi();
  this.showCommentLine();
};
MDPCPdfPageView.prototype.focusInNavi = function () {
  if (!this.needDisplayNavi()) {
    return;
  }
  ;
  var dimensions = this._calcMicroNaviDimensions();
  var context = this._$focusFrame[0].getContext('2d');
  context.clearRect(0, 0, this.naviW, this.naviH);
  context.fillStyle = 'rgba(0,0,0,0.6)';
  context.fillRect(0, 0, this.naviW + 1, this.naviH + 1);
  context.clearRect(dimensions.left, dimensions.top, dimensions.viewW, dimensions.viewH);
  context.strokeStyle = 'red';
  context.lineWidth = 1;
  context.strokeRect(dimensions.left, dimensions.top, dimensions.viewW, dimensions.viewH);
};
MDPCPdfPageView.prototype.getPanelVariable = function () {
  var panelInDisp = {
      panel: null
    },
    panelInScrible = {
      panel: null
    };
  return function getPanelVariable() {
    if (this.editorMode == _EditorMode["default"].normal) {
      return panelInDisp;
    } else {
      return panelInScrible;
    }
  };
}();
MDPCPdfPageView.prototype._calcMicroNaviDimensions = function () {
  var scroll = this.container;
  var width = scroll.scrollWidth;
  var height = scroll.scrollHeight;
  var viewWidth = scroll.offsetWidth;
  var handle = this.getPanelVariable();
  if (handle.panel) {
    var w = handle.panel.$el[0].offsetWidth; // + 15;
    width -= w;
    viewWidth -= w;
  }
  return {
    top: scroll.scrollTop / height * this.naviH,
    left: scroll.scrollLeft / width * this.naviW,
    viewW: viewWidth / width * this.naviW,
    viewH: scroll.offsetHeight / height * this.naviH
  };
};
MDPCPdfPageView.prototype.removeFromSuperView = function () {
  _MMPDFDrawerController["default"].getGlobalInstance().clear(this);
  if (this.$root) {
    this.$root.remove();
  }
  this.removeEvents();
  if (this.operationCenter) {
    this.operationCenter.destroy();
    this.operationCenter = null;
  }
  // Dispatcher.trigger(MDEvents.IMG_FULLSCREEN_END,this.mmPdfObj );
  //Dispatcher.off("SCROLL_OPERATION",this._scrollNotificationHandler);
  this.$root = null;
  this.mmPdfObj = null;
  this.board = null;
  if (this.__scaleDisplay) {
    this.__scaleDisplay.remove();
  }
  if (this.$navi_root) {
    this.$navi_root.remove();
  }
  ;
  var elementsCtl = _MMObjElementsController["default"].getSingleInstance();
  elementsCtl.removeAllDivsForEditor(this);
  this.removeCommentPanel();
  this.__lastWinW = 0;
  this.winW = 0;
};
MDPCPdfPageView.prototype.getObjsInView = function () {
  if (this.board) {
    var divObjs = this.board.getObjsInPageByFilter(this.mmPdfObj.getPageIndex(), this.divObjsFilter, this.mmPdfObj.getExpandRect());
    var canvasObjs = this.board.getObjsInPageByFilter(this.mmPdfObj.getPageIndex(), this.canvasObjsFilter, this.mmPdfObj.getExpandRect());
    return divObjs.concat(canvasObjs);
  } else {
    return [];
  }
};
MDPCPdfPageView.prototype.showCommentPanel = function (mmobj, div) {
  if (!app.canDispInNormalBrowser()) {
    this.showCommentPanelForMobile(mmobj, div);
  } else {
    this.showCommentPanelForPC(mmobj, div);
  }
};
MDPCPdfPageView.prototype.showCommentPanelForMobile = function (mmobj, div) {
  var center = MMCommonFun.getDivCenter($(div));
  var posInBody = MMCommonFun.convertPointBetweenElements(div, $("body")[0], center);
  var that = this;
  var handle = this.getPanelVariable();
  if (!handle.panel) {
    var commentPanel = new _MDCommentSlidePanelView["default"]({
      comment: mmobj,
      view: this,
      editorViewCtl: this.editorViewCtl,
      onCloseBtnClicked: function onCloseBtnClicked() {
        _MMObjElementsController["default"].commentPointUpdater.updateCommentView(mmobj, "readed");
        commentPanel.removeFromSuperView();
        handle.panel = null;
      }
    });
    application.addSubView(commentPanel);
    commentPanel.centerZoomShowForMobile(posInBody);
    handle.panel = commentPanel;
  }
};
MDPCPdfPageView.prototype.showCommentPanelForPC = function (mmobj, div) {
  var self = this;
  this.commentDiv = div;
  this.commentObj = mmobj;
  var handle = this.getPanelVariable();

  //MMCommentLineDrawer.clear(this.getCommentLineLayer());
  if (mmobj && handle.panel && handle.panel._comment === mmobj) {
    return;
  }
  if (mmobj) {
    this.scrollToShowComment(div);
    setBabelTimeout(function () {
      console.assert(mmobj.m_objType === _ObjType["default"].Obj_comment);
      if (handle.panel) {
        handle.panel.removeFromSuperView();
        handle.panel = null;
      }
      var enableDraggable = false;
      if (app.canDispInNormalBrowser()) {
        enableDraggable = true;
      }
      if (handle.panel == null) {
        handle.panel = new _MDCommentSlidePanelView["default"]({
          view: self,
          comment: mmobj,
          enableDraggable: enableDraggable,
          imgMarkerCtl: self.imgMarkerCtl,
          editorViewCtl: self.editorViewCtl,
          onRemove: function onRemove() {
            handle.panel = null;
          },
          onDrag: function onDrag() {
            _MDPcMobileEditorCommonFun["default"].getMainEditor().showCommentLine();
          },
          onCloseBtnClicked: function onCloseBtnClicked() {
            self.removeCommentPanel();
            self.removeCommentLine();
          }
        });
        self.scroller = new _MMEditorScroller["default"](self);
      } else {
        handle.panel.update({
          comment: mmobj
        });
      }
      app.application.addSubView(handle.panel);
      var startOffset = $(self.commentDiv).offset();
      handle.panel.zoomShow({
        'y': startOffset.top,
        'x': startOffset.left
      }, function () {
        _MDPcMobileEditorCommonFun["default"].getMainEditor().showCommentLine();
      });

      // Dispatcher.trigger(MDEvents.Comment_State_Sync, self.getCurrentBoard().fileInfo.getFileId(), mmobj);
    }, 200);
  }
};
MDPCPdfPageView.prototype.closeCommentPanel = MDPCPdfPageView.prototype.removeCommentPanel = function () {
  var handle = this.getPanelVariable();
  if (handle.panel) {
    if (handle.panel.superView) {
      handle.panel.removeFromSuperView();
    }
    handle.panel = null;
    _MMObjElementsController["default"].commentPointUpdater.updateCommentView(this.commentObj, "readed");
    this.scroller = null;
    this.commentObj = null;
    this.commentDiv = null;
    this.clearCommentCanvas();
  }
};
MDPCPdfPageView.prototype.removeCommentLine = function () {
  this.commentDiv = null;
};
MDPCPdfPageView.prototype.showCommentLine = function () {
  return;
  if (!app.canDispInNormalBrowser()) return;
  var handle = this.getPanelVariable();
  if (handle.panel) {
    this.clearCommentCanvas();
    var elementsCtl = _MMObjElementsController["default"].getSingleInstance();
    var div = elementsCtl.getDivByObj(this, this.commentObj);
    if (div) {
      _MMCommentLineDrawer["default"].drawLineBetweenDivs(this.getCommentLineLayer(), div, handle.panel.getPointerRectView(), this.scale);
    }
    ;
  }
};
MDPCPdfPageView.prototype.setCommentDiv = function (div) {
  this.commentDiv = div;
};

/**
 * a method should return a converted point, that can be transfered to a LG point using the
 * this.trsfm.dv2lsPoint() (ImageTransformer)
 * @param
 * @returns {MMPoint} devicepoint for the Image - Transformation
 */
MDPCPdfPageView.prototype.convertPointFromAssistView2Editor = function (pos) {
  //todo: this implementation is from the EditorView
  var newpos = pos.clone();
  var to = this.getCommentLayer();
  var from = this.getAssistantCanvas();
  var converted = MMCommonFun.convertPointBetweenElements(from, to, pos);
  newpos.x = converted.x;
  newpos.y = converted.y;
  return newpos;
};
MDPCPdfPageView.prototype.convertPointFromEditor2AssistView = function (pos) {
  var newpos = pos.clone();
  var to = this.getAssistantCanvas();
  var from = this.getCommentLayer();
  var converted = MMCommonFun.convertPointBetweenElements(from, to, pos);
  newpos.x = converted.x;
  newpos.y = converted.y;
  return newpos;
};

// --------------------------  ----------------------------  --------------------  新增转换函数
MDPCPdfPageView.prototype.logic2AssistViewPoint = function (pos) {
  var devicePoint = this.divTrsfm.lg2dvPoint(pos);
  var newPoint = this.convertPointFromEditor2AssistView(devicePoint);
  return newPoint;
};
MDPCPdfPageView.prototype.assistView2LogicPoint = function (pos) {
  if (!this.divTrsfm) {
    return pos;
  }
  ;
  var newpos = this.convertPointFromAssistView2Editor(pos);
  var logicPoint = this.divTrsfm.dv2lgPoint(newpos);
  return logicPoint;
};
MDPCPdfPageView.prototype.clearCommentCanvas = function () {
  var canvas = this.getCommentLineLayer();
  if (!canvas) {
    return;
  }
  ;
  var ctx = canvas.getContext('2d');
  var w = parseInt($(canvas).attr('width'));
  var h = parseInt($(canvas).attr('height'));
  ctx.clearRect(0, 0, w, h);
};
MDPCPdfPageView.prototype.scrollToShowComment = function (comment) {
  // this.scroller.scrollToShowObjDiv(this.commentDiv);
};
MDPCPdfPageView.prototype.getScrollContent = function () {
  return this._$content[0];
};
MDPCPdfPageView.prototype.getImageDispSize = function () {
  var size = new _size["default"](this._$editorZone[0].clientWidth, this._$editorZone[0].clientHeight);
  return size;
};
MDPCPdfPageView.prototype.getCommentPanelDiv = function () {
  var handle = this.getPanelVariable();
  return handle.panel.$el[0];
};
MDPCPdfPageView.prototype.getImageURL = function (imageData) {
  return imageData.getFilePath_Original();
};

//
// change the editor mode
// @param mode {string}
//
MDPCPdfPageView.prototype.setMode = function (mode) {
  if (this.editorMode != mode) {
    this.editorMode = mode;
    this.refreshViewByCurrentMode();
  }
};
MDPCPdfPageView.prototype.refreshViewByCurrentMode = function () {
  if (this.editorMode == _EditorMode["default"].mark) {
    this.canvasObjsFilter.moveObjType(_ObjType["default"].Obj_textComment);
  }
};
MDPCPdfPageView.prototype.getZoomScale = function () {
  return this.scale;
};
MDPCPdfPageView.prototype.getObjectNatureSize = function () {
  return {
    width: this.originW,
    height: this.originH
  };
};
MDPCPdfPageView.prototype.scrollToShowLgRct = function (lgRct) {
  var lgPts = lgRct.getLogicPts();
  var dvPts = [];
  for (var i = 0; i < lgPts.length; i++) {
    var lgPt = lgPts[i];
    var dvPt = this.divTrsfm.lg2dvPoint(lgPt);
    dvPts.push(dvPt);
  }
  ;
  var ptsInView = [];
  for (var i = 0; i < dvPts.length; i++) {
    var dvPt = dvPts[i];
    var pt = MMCommonFun.convertPointBetweenElements(this._$editorLayer[0], this.$root[0], dvPt);
    ptsInView.push(pt);
  }
  ;
  var rect = MMCommonFun.getRect(ptsInView);
  var targetCenter = rect.getCenter();
  var pos = {
    x: targetCenter.x - this.$root[0].offsetWidth / 2,
    y: targetCenter.y - this.$root[0].offsetHeight / 2
  };
  this.scrollToPosition(pos, true);
};
MDPCPdfPageView.prototype.getCurrentBoard = function () {
  if (this.mmPdfObj) {
    return this.mmPdfObj.getBoard();
  }
  ;
};
MDPCPdfPageView.prototype.getCommentsDivs = function () {
  var elementsCtl = _MMObjElementsController["default"].getSingleInstance();
  var commentDivs = elementsCtl.getCommentsDivs(this);
  return commentDivs;
};
MDPCPdfPageView.prototype.getDivByObj = function (commentObj) {
  var elementsCtl = _MMObjElementsController["default"].getSingleInstance();
  var element = null;
  if (commentObj) {
    element = elementsCtl.getDivByObj(this, commentObj);
  }
  return element;
};
MDPCPdfPageView.prototype.useTransformToScale = function () {
  return false;
};

//--------------------------------------------------------------------------------------------------  text layer

MDPCPdfPageView.prototype.getPdfTextLayer = function () {
  return this._$textLayer;
};
MDPCPdfPageView.prototype.getPdfTextMarkLayer = function () {
  return this._$scribbleLayer;
};
MDPCPdfPageView.prototype.registerTextLayerEvents = function () {
  if (this.editorMode == _EditorMode["default"].mark || !this.isDispPdf()) {
    this.textLayerCtl = null;
    return;
  }
  ;
  this.textLayerCtl = new _MDPdfTextLayerController["default"]();
  this.textLayerCtl.listenToPdfPageEditor(this, this.mmPdfObj.getBoard(), this.mmPdfObj.getPageIndex());
};
MDPCPdfPageView.prototype.textLayerEmptied = function () {
  if (this.textLayerCtl) {
    this.textLayerCtl.textLayerEmptied();
  }
  ;
};
MDPCPdfPageView.prototype.refreshTextLayerIndex = function () {
  if (this.editorMode == _EditorMode["default"].mark || !this.isDispPdf()) {
    return;
  }
  ;
  if (_MMOperationCenter["default"].getOperation() == 'text-mark') {
    $('.text-container').css('z-index', 400000001);
  } else {
    $('.text-container').css('z-index', 'auto');
  }
};
MDPCPdfPageView.prototype.removeEvents = function () {
  _Dispatcher["default"].off(null, null, this);
};
MDPCPdfPageView.prototype.receiveNewMessage = function (payload) {
  payload = payload || {};
  var comment = payload.comment;
  MMCommonFun.refreshTextCommentStatus(comment, this);
};
MDPCPdfPageView.prototype.textCommentStatusChanged = function (textComment, sender) {
  MMCommonFun.refreshTextCommentStatus(textComment, this);
};
MDPCPdfPageView.prototype.setImgMarkerCtl = function (imgMarkerCtl) {
  this.imgMarkerCtl = imgMarkerCtl;
  if (this.operationCenter) {
    this.operationCenter.setImgMarkerCtl(imgMarkerCtl);
  }
  ;
};
MDPCPdfPageView.prototype.dispSalonSpeakerMouseClick = function (logicPoint) {
  _MDEditorCommonFun["default"].dispSalonSpeakerMouseClick(this, logicPoint);
};
MDPCPdfPageView.prototype.clearSalonSpeakerMouseClick = function () {
  _MDEditorCommonFun["default"].clearSalonSpeakerMouseClick(this);
};
MDPCPdfPageView.prototype._salonStatusChanged = function (salonInfo) {
  if (!salonInfo) {
    // 演播结束
    this.getCurrentBoard().clearSalonScribbles();
    this.clearSalonPenCanvas();
  }
  ;
};
MDPCPdfPageView.prototype.clearAssistCanvas = function () {
  var canvas = this._$operateLayer[0];
  var ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, canvas.offsetWidth, canvas.offsetHeight);
};
MDPCPdfPageView.prototype.clearSalonPenCanvas = function () {
  var canvas = this._$salonPenCanvas[0];
  var ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, canvas.offsetWidth, canvas.offsetHeight);
};
MDPCPdfPageView.prototype.showFocusRect = function (lgRect) {
  _MMCommonEditorView["default"].showFocusRect(this, lgRect);
};
MDPCPdfPageView.prototype.rotate90 = function () {
  var _this = this;
  if (this.needTileView()) {
    return;
  }
  if (this.isRotating) {
    return;
  }
  this.isRotating = true;
  this.angle = (this.angle - 90) % 360;
  this.angle = this.angle < 0 ? this.angle + 360 : this.angle;
  this.setDispAngle(this.angle);
  this.refreshEditor(function () {
    _this.isRotating = false;
  });
};
MDPCPdfPageView.prototype.setDispAngle = function (angle) {
  this.angle = angle;
  this.mmPdfObj.setRotateAngle90(this.angle);
  var i = this.mmPdfObj.getPageIndex();
  var curTask = this.mmPdfObj.getBoard();
  var fileInfo = curTask && curTask.getFileInfo();
  var fileId = fileInfo.getFileId();
  MMCommonFun.setDefaultRotate(fileId, i, this.angle);
  if (angle == 90 || angle == 270) {
    this.originRotateW = this.originH;
    this.originRotateH = this.originW;
  } else {
    this.originRotateW = this.originW;
    this.originRotateH = this.originH;
  }
  this.imgRatio = this.originRotateH / this.originRotateW;
  this.initNavigator();
};
MDPCPdfPageView.prototype.initRotateAngle = function () {
  var i = this.mmPdfObj.getPageIndex();
  var curTask = this.mmPdfObj.getBoard();
  var fileInfo = curTask && curTask.getFileInfo();
  var fileId = fileInfo.getFileId();
  this.angle = MMCommonFun.getDefaultRotate(fileId, i);
  this.setDispAngle(this.angle);
};
MDPCPdfPageView.prototype.getDispRectInContentForObj = function (lgObj) {
  var lgRect = lgObj.getRect();
  var dvRect = this.lg2ContentDvRect(lgRect);
  return dvRect;
};
MDPCPdfPageView.prototype.lg2ContentDvRect = function (rect) {
  var rctPts = rect.getCtrlPts(true);
  var tgPts = this.lg2ContentDvPoints(rctPts);
  var dvRect = new _MMRect["default"]();
  dvRect.initWithPtsBounadingBox(tgPts);
  return dvRect;
};
MDPCPdfPageView.prototype.lg2ContentDvPoints = function (pts) {
  var pageIndex = this.getCurrentFilePageIndex();
  var trsfm = this.getDivTransformer();
  var dvPts = trsfm.lg2dvPoints(pts, pageIndex);
  ;
  var parentDiv = this.getScrollContent();
  var editorPage = this.getCommentLayer();
  var tgPts = [];
  for (var i = 0; i < dvPts.length; i++) {
    var pt = dvPts[i];
    var convert = MMCommonFun.convertPointBetweenElements(editorPage, parentDiv, pt);
    tgPts.push(new _MMPoint["default"](convert.x, convert.y));
  }
  ;
  return tgPts;
};
MDPCPdfPageView.prototype.contentDv2LgPoints = function (pts) {
  var pageIndex = this.getCurrentFilePageIndex();
  var trsfm = this.getCanvasTransformer();
  var ptInPage = this.convertPtsFromContent2Page(pts);
  var lgPts = trsfm.dv2lgPoints(ptInPage, pageIndex);
  return lgPts;
};
MDPCPdfPageView.prototype.convertPtsFromContent2Page = function (pts) {
  var parentDiv = this.getScrollContent();
  var editorPage = this.getCommentLayer();
  var ptInPage = [];
  for (var i = 0; i < pts.length; i++) {
    var pt = pts[i];
    var convert = MMCommonFun.convertPointBetweenElements(parentDiv, editorPage, pt);
    ptInPage.push(new _MMPoint["default"](convert.x, convert.y));
  }
  ;
  return ptInPage;
};
MDPCPdfPageView.prototype.getContentLgRect = function () {
  var lgImgRect = this.mmPdfObj.getDrawRect();
  return lgImgRect;
};
MDPCPdfPageView.prototype.dv2ContentLgRect = function (rect) {
  var rctPts = rect.getCtrlPts(true);
  var tgPts = this.contentDv2LgPoints(rctPts);
  var dvRect = new _MMRect["default"]();
  dvRect.initWithPtsBounadingBox(tgPts);
  return dvRect;
};
var _default = exports["default"] = MDPCPdfPageView;

},{"1084":1084,"1184":1184,"1412":1412,"1417":1417,"1437":1437,"1438":1438,"1454":1454,"1463":1463,"1466":1466,"1541":1541,"18":18,"319":319,"325":325,"427":427,"454":454,"807":807,"811":811,"826":826,"830":830,"831":831,"837":837,"856":856,"874":874,"876":876,"877":877,"879":879,"880":880,"893":893,"904":904,"905":905,"906":906,"907":907,"908":908,"909":909,"910":910,"913":913,"914":914,"932":932,"933":933,"939":939,"949":949,"955":955,"960":960}],933:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1432);
require(1438);
//  绘制 pdf page 到指定的 canvas
//
//

function MMPDFPageDrawer() {
  this.bufferCanvas = [];
}
;
MMPDFPageDrawer.prototype.setPDFPage = function (page) {
  if (this.page != page) {
    this.page = page;
    this.clear();
  }
  ;
};
MMPDFPageDrawer.prototype.clear = function () {
  if (this.rTask) {
    this.rTask.cancel();
    console.log('1. cancel');
    if (this.bufferCanvas.length > 1) {
      this.bufferCanvas.splice(1, this.bufferCanvas.length - 1);
    }
    ;
  } else {
    this.bufferCanvas.splice(0, this.bufferCanvas.length);
  }
  this.rTask = null;
};
var g_debugIndex = 0;
MMPDFPageDrawer.prototype.drawInCanvas = function (canvas, callback) {
  g_debugIndex++;
  if (g_debugIndex % 2 == 0) {
    console.log('---------- index:', g_debugIndex);
  }
  ;
  var index = -1;
  for (var i = 0; i < this.bufferCanvas.length; i++) {
    if (this.bufferCanvas[i] == canvas) {
      index = i;
      break;
    }
  }
  ;
  var that = this;
  if (index == -1) {
    canvas.pdfCallbacks = [callback];
    this.bufferCanvas.push(canvas);
  } else {
    canvas.pdfCallbacks = [callback];
    this.bufferCanvas.push(canvas);
    if (index == 0) {
      if (this.rTask) {
        this.rTask.cancel();
        console.log('2. cancel');
      }
      ;
    }
    ;
    return;
  }
  if (this.bufferCanvas.length == 1) {
    // setBabelTimeout(function(){
    that._drawInCanvas();
    // }, 100);
  }
  ;
};
MMPDFPageDrawer.prototype._drawInCanvas = function (canvas) {
  if (this.bufferCanvas.length == 0) {
    return;
  }
  ;
  if (this.rTask) {
    this.rTask.cancel();
    console.log("3. cancel");
    return;
  }
  ;
  var that = this;
  var canvas = this.bufferCanvas[0];
  var callbacks = canvas.pdfCallbacks;
  canvas.pdfCallback = null;
  var viewport = this.page.getViewport(1.0);
  var canvasWidth = canvas.width;
  var canvasHeight = canvas.height;
  var scale = canvasWidth / viewport.width;
  viewport = this.page.getViewport(scale);
  var context = canvas.getContext('2d');
  context.scale(1, 1);
  this.isRejected = false;
  var renderContext = {
    'canvasContext': context,
    'viewport': viewport,
    'continueCallback': function pdfViewcContinueCallback(cont) {
      // if (that.isRejected) {
      // that.rTask = null;
      // that.bufferCanvas.shift();
      // setBabelTimeout(function(){
      //  that._drawInCanvas();
      // }, 100);

      // } else {
      //  cont();
      // }
      cont();
      that.isRejected = false;
    }
  };
  context.clearRect(0, 0, canvasWidth, canvasHeight);

  // if (true || !app.isPC()) {
  this.rTask = this.page.render(renderContext);
  this.rTask.promise.then(function () {
    that.rTask = null;
    for (var i = 0; i < callbacks.length; i++) {
      var callback = callbacks[i];
      if (callback) callback();
    }
    ;
    that.bufferCanvas.shift();
    // setBabelTimeout(function(){
    that._drawInCanvas();
    // }, 100);
  }.bind(that), function () {
    that.isRejected = true;
    that.rTask = null;
    //    for (var i = 0; i < callbacks.length; i++) {
    //  var callback = callbacks[i];
    //  if(callback) callback();
    // };
    that.bufferCanvas.shift();
    that._drawInCanvas();
  }.bind(that), function () {
    console.log("************ third function");
  });

  // } else {
  //  this.page.getTextContent().then(function(textContent){
  //    var textLayer = new TextLayerBuilder({
  //      'textLayerDiv': that._$textLayer[0],
  //      'viewport':viewport,
  //      'pageIndex':0
  //    });
  //    textLayer.setTextContent(textContent);
  //    this.rTask = that.page.render(renderContext);
  //      this.rTask.then(function(){
  //        that.rTask = null;
  //      for (var i = 0; i < callbacks.length; i++) {
  //        var callback = callbacks[i];
  //        if(callback) callback();
  //      };
  //      that.bufferCanvas.shift();
  //      that._drawInCanvas();

  //      }.bind(that));

  //  })
  // }
};
var _default = exports["default"] = MMPDFPageDrawer;

},{"1432":1432,"1438":1438,"1454":1454}],908:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1432);
var MDEditorCommonFun = {
  dispSalonSpeakerMouseClick: function dispSalonSpeakerMouseClick(editor, logicPoint) {
    var assistLayer = editor.getCommentLayer();
    var w = assistLayer.offsetWidth;
    var h = assistLayer.offsetHeight;
    var divPos = editor.canvasTrsfm.lg2dvPoint(logicPoint);
    if (divPos.x > 0 && divPos.y > 0 && divPos.x < w && divPos.y < h) {
      var $mouseClickDispDiv = $('<div class="mouse-click-disp"><div class="out-circle"></div> </div>');
      $(assistLayer).append($mouseClickDispDiv);
      $mouseClickDispDiv.css('left', divPos.x - 3 + 'px');
      $mouseClickDispDiv.css('top', divPos.y - 3 + 'px');
      if (!editor.mouseDivs) {
        editor.mouseDivs = [];
      }
      ;
      editor.mouseDivs.push($mouseClickDispDiv);
      var self = editor;
      setBabelTimeout(function () {
        $mouseClickDispDiv.remove();
        for (var i = 0; i < self.mouseDivs.length; i++) {
          if (self.mouseDivs[i] == $mouseClickDispDiv) {
            self.mouseDivs.splice(i, 1);
          }
        }
        ;
      }, 5000);
    }
    ;
  },
  clearSalonSpeakerMouseClick: function clearSalonSpeakerMouseClick(editor) {
    if (editor.mouseDivs) {
      for (var i = 0; i < editor.mouseDivs.length; i++) {
        editor.mouseDivs[i].remove();
      }
      ;
      editor.mouseDivs.splice(0, editor.mouseDivs.length);
    }
    ;
  }
};
window.MDEditorCommonFun = MDEditorCommonFun;
var _default = exports["default"] = MDEditorCommonFun;

},{"1432":1432,"1454":1454}],930:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1438);
require(1466);
require(1412);
var _MMBasicData = _interopRequireDefault(require(811));
var _MMObjElementsController = _interopRequireDefault(require(893));
var _MMWhiteboard = _interopRequireDefault(require(960));
var _MDEvents = _interopRequireDefault(require(325));
var _MMOperationCenterMobilePDF = _interopRequireDefault(require(881));
var _MMPDFDrawerController = _interopRequireDefault(require(932));
var _ImageTransformer = _interopRequireDefault(require(826));
var _MMObjectFilter = _interopRequireDefault(require(955));
var _FilterType = _interopRequireDefault(require(949));
var _ObjType = _interopRequireDefault(require(1084));
var _size = _interopRequireDefault(require(837));
var _MMOperationCenterMobileImage = _interopRequireDefault(require(879));
var _EditorMode = _interopRequireDefault(require(904));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
var _MMOperationCenterDesktopImage = _interopRequireDefault(require(876));
var _MDSpinnerloaderLayerView = _interopRequireDefault(require(75));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
/**
 * 显示 pdf 的一页或者一张图片
 *
 * jiang
 * 2015-8-3
 */

function MMMobilePageView(containerDiv, opt) {
  this.editorViewCtl = opt.editorViewCtl;
  this.pageMargin = 0;
  this.parentDiv = containerDiv;
  this.mmPicObj = null;
  this.pdfUrl = null;
  this.commentDiv = null;
  this.commentPanel = null;
  this.operationCenter = null;
  this.scale = 1.0;
  this.pdfDrawerCtl = _MMPDFDrawerController["default"].getGlobalInstance();
  this.divObjsFilter = new _MMObjectFilter["default"]();
  this.divObjsFilter.type = _FilterType["default"].Include;
  this.divObjsFilter.objTypes.push(_ObjType["default"].Obj_comment);
  this.divObjsFilter.objTypes.push(_ObjType["default"].Obj_niceTag);
  this.canvasObjsFilter = new _MMObjectFilter["default"]();
  this.canvasObjsFilter.type = _FilterType["default"].Include;
  this.canvasObjsFilter.objTypes = _ObjType["default"].getCanvasObjType();
  this.renderTaskMain = {
    task: null
  };
  this.renderTaskNav = {
    task: null
  };
  if (typeof window.devicePixelRatio == 'undefined') {
    window.devicePixelRatio = 1.0;
  }
  ;
  var that = this;
  this.editorMode = _EditorMode["default"].normal;
  this.displayForVersion = false; //是否仅指定的版本的批注？

  Dispatcher.on(_MDEvents["default"].COMMENT_CREATE, this._commentCreated, this);
  Dispatcher.on(_MDEvents["default"].DATA_READY, this._commentCreated, this);
  Dispatcher.on(_MDEvents["default"].TextComment_status, this.textCommentStatusChanged, this);
  Dispatcher.on(_MDEvents["default"].NEW_MESSAGE, this.receiveNewMessage, this);
}
;
MMMobilePageView.prototype.setDispForVersion = function (forVersion) {
  this.displayForVersion = forVersion;
};
MMMobilePageView.prototype.getPicObject = function () {
  return this.mmPicObj;
};
MMMobilePageView.prototype.setPageMargin = function (pageMargin) {
  this.pageMargin = pageMargin;
};
MMMobilePageView.prototype.displayObject = function (obj, opt, loadFinished) {
  if (!loadFinished) {
    if (opt && _.isFunction(opt)) {
      loadFinished = opt;
      opt = {};
    } else {}
  }
  console.assert(obj && (obj.getObjType() == _ObjType["default"].Obj_PDF || obj.getObjType() == _ObjType["default"].Obj_Image));
  var filePath = obj.getDispFilePath();
  if (this.mmPicObj != obj && filePath.length > 0) {
    this.mmPicObj = obj;
    this.loadFinished = loadFinished;
    this.board = obj.getBoard();
    this.constructView(loadFinished);
  } else if (filePath.length > 0) {
    this.initView();
    if (loadFinished) {
      loadFinished(false);
    }
    ;
  }
  ;
};
MMMobilePageView.prototype.changeBackgroundForPng = function () {
  $(this.container).css("background-image", "url(img/rect.jpg)");
  $(this.container).css("background-repeat", "repeat");
};
MMMobilePageView.prototype.changeBackgroundForJpg = function () {
  $(this.container).css("background-image", "none");
  $(this.container).css("background-color", "#f1f2f2");
};
MMMobilePageView.prototype.isDispPdf = function () {
  return this.mmPicObj.getObjType() == _ObjType["default"].Obj_PDF;
};
MMMobilePageView.prototype.isDispSVG = function () {
  var board = this.mmPicObj.getBoard();
  return board.canDispWithSVG();
};
MMMobilePageView.prototype.constructView = function (loadFinished) {
  var z_startIndex = _MMBasicData["default"].getO2OStartLayerZ_index();
  var z_maxIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
  this.$root = $(this.parentDiv);
  if (!this.mmPicObj) {
    return;
  }
  ;
  if (this._$allLayers) {
    _MMObjElementsController["default"].getSingleInstance().removeAllDivsForEditor(this);
    this._$allLayers.remove();
  }
  ;
  if (this.isDispSVG()) {
    this._$allLayers = $("<div class='svg-layer editor-zone' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 255, 255, 1.0)'></div>" + "<canvas class='scribble-layer editor-canvas-zone' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 0, 0, 0.0);pointer-events:none;'></canvas>" + "<div class='comment-layer editor-zone' style='position:absolute; overflow: hidden; left:0px; top:0px;pointer-events:none;z-index: 390000000;'></div>");
  } else if (this.isDispPdf()) {
    this._$allLayers = $("<canvas class='pdf-layer editor-canvas-zone' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 255, 255, 1.0)'></canvas>" + "<canvas class='scribble-layer editor-canvas-zone' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 0, 0, 0.0);pointer-events:none;'></canvas>" + "<div class='comment-layer editor-zone' style='position:absolute; overflow: hidden; left:0px; top:0px;pointer-events:none;z-index: 390000000;'></div>");
  } else {
    this._$allLayers = $("<div class='image-background editor-zone' style='position:absolute; left:0px; top:0px;background-image:url(img/rect.jpg);background-repeat:repeat'></div>" +
    // "<div class='image-background editor-zone' style='position:absolute; left:0px; top:0px;background-color:white'></div>" +
    "<img class='image-layer editor-zone' style='position:absolute; left:0px; top:0px;background-size:100% 100%;background-repeat:none'></img>" + "<div class='comment-layer editor-zone' style='position:absolute; overflow: hidden; left:0px; top:0px;pointer-events:none;z-index: 390000000;'></div>");
  }
  this.$root.append(this._$allLayers);
  this._$drawing = $("<div class='drawing' style='position:absolute; left:0px; top:0px;width:100%;height:100%;text-align:center;line-height:100%;color:gray;'>正在渲染...</div>");
  this._$drawing.css('line-height', this.parentDiv.offsetHeight + 'px');
  if (!this.isDispPdf()) {
    this._$drawing.text('下载中...');
  }
  ;

  //------------------------------------- 不需要显示
  this._$drawing.css('display', 'none');
  this.$root.append(this._$drawing);
  this._$svgLayer = this.$root.find('.svg-layer');
  this._$pdfLayer = this.$root.find('.pdf-layer');
  this._$imgBackground = this.$root.find('.image-background');
  this._$imageLayer = this.$root.find('.image-layer');
  this._$editorLayer = this.$root.find('.comment-layer');
  this._$content = this.$root;
  this._$editorZone = this.$root.find('.editor-zone'); // image 层和 comment 层
  this._$editorCanvasZone = this.$root.find('.editor-canvas-zone'); // image 层和 comment 层
  this._$scribbleLayer = this.$root.find('.scribble-layer'); // image 层和 comment 层

  var that = this;
  this._scrollNotificationHandler = function (offset) {
    that.$root[0].scrollLeft = offset.x;
    that.$root[0].scrollTop = offset.y;
  };
  var mouseDown = false;
  var lastScreenPos = null;
  //this.$scroll_editor.css("cursor","-webkit-grab");

  this.initView(loadFinished);

  // !! changed by jiang
  // if (this.operationCenter) {
  //  this.operationCenter.destroy();
  // };

  //    this.operationCenter = new MMOperationCenterMobilePDF({
  //        whiteboard: this.board,
  //        pageIndex: this.getCurrentFilePageIndex(),
  //        editor: this,
  //        mode: 'PDFDocument',
  //        displayedObject: this.mmPicObj
  //    });
  // !! with
  this.createOperationCenter();
  // !! end
};
MMMobilePageView.prototype.showCommentLayer = function () {};
MMMobilePageView.prototype.hideCommentLayer = function () {};
MMMobilePageView.prototype.createOperationCenter = function () {
  if (this.operationCenter) {
    this.operationCenter.destroy();
  }
  ;
  var mode = 'PDFDocument';
  if (app.canDispInNormalBrowser()) {
    this.operationCenterType = _MMOperationCenterDesktopImage["default"];
  } else {
    if (this.mmPicObj.m_objType == _ObjType["default"].Obj_Image) {
      this.operationCenterType = _MMOperationCenterMobileImage["default"];
    } else {
      this.operationCenterType = _MMOperationCenterMobilePDF["default"];
    }
  }
  this.operationCenter = new this.operationCenterType({
    whiteboard: this.board,
    pageIndex: this.getCurrentFilePageIndex(),
    editor: this,
    mode: mode,
    displayedObject: this.mmPicObj,
    imgMarkerCtl: this.imgMarkerCtl,
    editorViewCtl: this.editorViewCtl
  });
};
MMMobilePageView.prototype.initView = function (loadFinished) {
  // image src path
  if (!this.mmPicObj) return;
  var filePath = "";
  filePath = this.mmPicObj.getDispFilePath();
  if (filePath.length == 0) {
    return;
  }
  ;
  this.drawFininshed = false;
  this.setUseDefualtScale(true);
  var _initSync = function (loadFinished) {
    this.pdfRatio = this.originH / this.originW;
    var size = this.refreshEditor(loadFinished, true);
    if (this.mmPicObj.getObjType() == _ObjType["default"].Obj_Image && this.mmPicObj.isPng()) {
      this.$root.find(".image-background").css("display", "block");
    }
    ;
    return size;
  }.bind(this);

  // image sizeCommentSli
  var that = this;
  var objType = this.mmPicObj.getObjType();
  if (this.isDispSVG()) {
    this.mmPicObj.getDispSVGFilePath(function (path) {
      MMNetDiskDataController.downLoadFileData(path, function (data) {
        var decodedString = MMCommonFun.decodeFromUTF8Array(data);
        var $svg = $(decodedString);
        that._$svgLayer.empty();
        that._$svgLayer.append($svg);
        that.$svg = that._$svgLayer.find('svg');
        that.originW = that.$svg.attr('width');
        that.originH = that.$svg.attr('height');
        that.imgRatio = that.originH / that.originW;
        // that.mmPicObj.setOriginSize(new MMPoint(that.originW, that.originH));

        that.setScaleToFit();
        _initSync();
        $(that.container).css('overflow', 'auto');

        //that.drawPageInCanvas();
        loadFinished && loadFinished();
        console.log('---- file opend:' + decodedString);
      }, function fail() {}, function pregress(p) {
        console.log('--------> download :' + p);
      });
    });
  } else if (objType == _ObjType["default"].Obj_PDF) {
    this.mmPicObj.getPdfPage(function pageLoaded(page) {
      if (!that.mmPicObj || that.mmPicObj.getObjType() != _ObjType["default"].Obj_PDF || page["pageIndex"] != that.mmPicObj.getPdfPageIndex() - 1) {
        return;
      }
      ;
      that.page = page;
      $(that.container).css('overflow', 'hidden');
      var $pdflayer = that._$pdfLayer;
      var viewport = that.mmPicObj.page.getViewport(1.0);
      that.originW = viewport.width;
      that.originH = viewport.height;

      // MDDebugLog.log('*****>> after load, originW' + that.originW);

      that.setScaleToFit();
      var dispSize = _initSync();
      $(that.container).css('overflow', 'auto');

      //MMCommonFun.initCanvasSize(that._$pdfLayer, dispSize.width, dispSize.height);

      that.pdfDrawerCtl.drawInCanvas(that, $pdflayer[0], page, function () {
        that.drawFininshed = true;
        that._$drawing.remove();
        that.refreshEditor(loadFinished);
      });
    });
  } else {
    //!{ 暂时当缩略图层显示
    this._$imgBackground.css("background-image", "url(" + that.mmPicObj.getThumbnailUrl(false) + ")");
    this._$imgBackground.css("background-size", "100% 100%");
    this._$imgBackground.css("background-repeat", "none");
    //!}  added by jiang, 2015-12-16

    _MDSpinnerloaderView["default"].showIn(this.$root);
    var tempImg = that._$imageLayer[0];
    tempImg.onload = function (e) {
      _MDSpinnerloaderView["default"].clearFrom(that.$root);
      if (!that.mmPicObj || e.target.mmPicObj.getPageIndex() != that.mmPicObj.getPageIndex()) {
        e.target.mmPicObj = null;
        return;
      }
      ;
      that.drawFininshed = true;
      e.target.mmPicObj = null;

      // that._$imageLayer.css("background-image", "url(" + tempImg.src + ")");

      //!{ 真图加载后将背景恢复为国际象棋盘
      that._$imgBackground.css("background-image", "url(/img/rect.jpg)");
      that._$imgBackground.css("background-size", "auto");
      that._$imgBackground.css("background-repeat", "repeat");
      //!} added by jiang, 2015-12-16

      // console.log('-----> url:'+ tempImg.src);

      // that.originW = tempImg.width ;
      // that.originH = tempImg.height;
      // var originSize = that.mmPicObj.getOriginSize();
      // if (originSize && originSize.width > that.originW && originSize.height > that.originH) {
      //  that.originW = originSize.width;
      //  that.originH = originSize.height;
      // };

      that.setScaleToFit();
      var dispSize = _initSync(loadFinished);
      that._$drawing.remove();
    };
    tempImg.mmPicObj = this.mmPicObj;
    tempImg.src = filePath;
  }

  // 根据预存的大小初始化版面
  var originSize = that.mmPicObj.getOriginSize();
  if (originSize) {
    this.originW = originSize.x;
    this.originH = originSize.y;

    // MDDebugLog.log('***** before load, originW' + this.originW);

    this.refreshEditor();
  }
  ;
};
MMMobilePageView.prototype.refreshEditor = function (loadFinished, clearCanvas) {
  if (!this.$root) {
    return;
  }
  ;
  if (this.useDefualtScale()) {
    this.setScaleToFit();
  }
  ;

  // window size
  this.winW = this.parentDiv.offsetWidth;
  this.winH = this.parentDiv.offsetHeight;

  // set root view size
  if (this.__lastWinW !== this.winW) {
    this.$root.css('width', this.winW + 'px');
  }
  if (this.__lastWinH !== this.winH) {
    this.$root.css('height', this.winH + 'px');
  }
  this.__lastWinW = this.winW;
  this.__lastWinH = this.winH;
  var contentW = this.winW;
  var contentH = this.winH;
  if (this.commentPanel) {
    //    var w = this.commentPanel.$el[0].offsetWidth;// + 15;
    //    contentW -= w;
  }
  var editorZoneSize = new _size["default"](0, 0);
  var that = this;
  var dispWidth = this.originW;
  var dispHeight = this.originH;

  // console.log("origin :(" + dispWidth + "," + dispHeight + ")");

  dispWidth = parseInt(dispWidth * this.scale);
  dispHeight = parseInt(dispHeight * this.scale);

  // console.log("after scale :(" + dispWidth + "," + dispHeight + ")");

  if (contentW >= dispWidth && contentH >= dispHeight) {
    this.$root.css("overflow", "hidden");
  } else {
    this.$root.css("overflow", "auto");
  }
  var marginLeft = (this.winW - dispWidth) / 2;
  if (marginLeft < 0) {
    marginLeft = 0;
    contentW = dispWidth;
  }
  var marginTop = (this.winH - dispHeight) / 2;
  if (marginTop < 0) {
    marginTop = 0;
    contentH = dispHeight;
  }
  var $content = this._$content;
  $content.css('width', contentW + 'px');
  $content.css('height', contentH + 'px');

  //  $editorContent.css('margin-left', 'auto');
  //  $editorContent.css('margin-right', 'auto');
  //  $editorContent.css('margin-top', 'auto');
  //  $editorContent.css('margin-bottom', 'auto');

  var $editorZone = this._$editorZone; // image 层和 comment 层
  var $editorCanvasZone = this._$editorCanvasZone;
  $editorZone.css('width', dispWidth + 'px');
  $editorZone.css('height', dispHeight + 'px');
  $editorZone.css('left', marginLeft + 'px');
  $editorZone.css('top', marginTop + 'px');
  $editorCanvasZone.css('width', dispWidth + 'px');
  $editorCanvasZone.css('height', dispHeight + 'px');
  $editorCanvasZone.css('left', marginLeft + 'px');
  $editorCanvasZone.css('top', marginTop + 'px');
  if (clearCanvas && this.isDispPdf()) {
    MMCommonFun.initCanvasSize($editorCanvasZone, dispWidth, dispHeight);
  }
  ;
  var $pdflayer = this.$root.find('.pdf-layer');
  $pdflayer.css('left', marginLeft + 'px');
  $pdflayer.css('top', marginTop + 'px');
  editorZoneSize.width = dispWidth;
  editorZoneSize.height = dispHeight;
  if (this.isDispSVG() && this.$svg) {
    this.$svg.attr('width', dispWidth);
    this.$svg.attr('height', dispHeight);
  }
  this.refreshObjsInEditor();
  if (!app.canDispInNormalBrowser()) {
    if (loadFinished && this.mmPicObj.getObjType() == _ObjType["default"].Obj_PDF && this.drawFininshed) {
      loadFinished(true);
    }
    ;
  } else {
    if (loadFinished) {
      loadFinished(true);
    }
    ;
  }
  return editorZoneSize;
};
MMMobilePageView.prototype.refreshCanvas = function () {
  if (!this.drawFininshed) {
    return;
  }
  var targetW = this._$editorZone.width();
  var targetH = this._$editorZone.height();
  this.refreshPdfCanvas(targetW, targetH);
};
MMMobilePageView.prototype.refreshPdfCanvas = function (targetW, targetH) {
  if (!this.isDispPdf() || !this.drawFininshed || !this.$root || !this._$pdfLayer) {
    console.log("~~~~~~ can't disp pdf ", this.isDispPdf(), " draw finish:" + this.drawFininshed + "root:" + this.$root + " pdfLayer:" + this._$pdfLayer);
    return;
  }
  if (!this._$drawingPdf) {
    this._$drawingPdf = this._$pdfLayer.clone();
    this._$pdfLayer.before(this._$drawingPdf);
  }
  ;
  MMCommonFun.initCanvasSize(this._$drawingPdf, targetW, targetH);
  var that = this;

  // return;
  var $originPdf = this._$pdfLayer;
  var $newPdf = this._$drawingPdf;
  if (!$originPdf) {
    console.error('---- pdf layer is null');
  }
  ;
  this.pdfDrawerCtl.drawInCanvas(this, $newPdf[0], this.page, function drawFininshed() {
    if (!that.$root) {
      return;
    }
    ;
    $originPdf.remove();
    that._$pdfLayer = $newPdf;
    // that._$drawingPdf = null;
    that._$editorCanvasZone = that.$root.find('.editor-canvas-zone'); // image 层和 comment 层
    that._$drawingPdf = null;
    that.operationCenter.updateAssistantCanvas();
  });
};
MMMobilePageView.prototype.refreshObjsInEditor = function () {
  var arcAngle = this.mmPicObj.getDrawAngle() * Math.PI / 180;
  var lgImgRect = this.mmPicObj.getDrawRect();
  var dvImgSize = new _size["default"](this.originW, this.originH);

  // MDDebugLog.log("devicesize:("+dvImgSize.width+","+dvImgSize.height + ")" );

  dvImgSize.width *= this.scale;
  dvImgSize.height *= this.scale;

  // MDDebugLog.log("devicesize:("+dvImgSize.width+","+dvImgSize.height + ")" );
  // MDDebugLog.log("logic rect:" + lgImgRect.toString());

  this.trsfm = new _ImageTransformer["default"](dvImgSize, lgImgRect, arcAngle);
  this.assistTrsfm = new _ImageTransformer["default"](dvImgSize, lgImgRect, arcAngle);
  this.assistTrsfm.setLayers(this._$editorLayer[0], this._$editorLayer[0]);
  var lgRct = this.mmPicObj.getExpandRect();
  _MMObjElementsController["default"].getSingleInstance().removeAllDivsForEditor(this);
  if (this.displayForVersion) {
    this.divObjsFilter.objVer = this.mmPicObj.getFileVersion();
  } else {
    this.divObjsFilter.objVer = -1;
  }
  this.refreshCommentsInEditor(lgRct);
  this.refreshObjsInCanvas(lgRct);
};
MMMobilePageView.prototype.refreshCommentsInEditor = function (lgRct) {
  if (!this.mmPicObj || !this.trsfm) {
    return;
  }
  ;
  if (this.editorMode == _EditorMode["default"].mark) {
    _MMObjElementsController["default"].getSingleInstance().removeAllDivsForEditor(this);
  } else {
    var curTask = this.board;
    curTask.drawObjsInDiv(this, this.trsfm, this.mmPicObj.getPageIndex(), this.divObjsFilter, lgRct);
  }
};
MMMobilePageView.prototype.refreshObjsInCanvas = function (lgRct) {
  if (!this.mmPicObj || !this.trsfm) {
    return;
  }
  ;
  if (!lgRct) {
    lgRct = this.mmPicObj.getExpandRect();
  }
  ;
  var geo_canvas = this._$scribbleLayer[0];
  if (!geo_canvas) {
    return;
  }
  ;
  MMCommonFun.setContextScale(geo_canvas);
  var i = this.mmPicObj.getPageIndex();

  // 刷新旧的绘制内容
  var dvRct = this.trsfm.lg2dvRect(lgRct, i).intRect();
  var curTask = this.board;
  var geo_ctx = geo_canvas.getContext("2d");

  // //test
  // geo_ctx.fillStyle = 'rgba(255,0,0,0.5)';
  // geo_ctx.fillRect(0,0,320,320);

  if (curTask && geo_ctx) {
    geo_ctx.save();
    MMCommonFun.clipContext(geo_ctx, dvRct);
    curTask.drawObjsInCanvas(geo_ctx, this.trsfm, i, this.canvasObjsFilter, lgRct);
    geo_ctx.restore();
  }
  ;
};

/**
 * 获得标注 div 所在的层
 * @returns $div
 */
MMMobilePageView.prototype.getCommentLayer = function () {
  return this._$editorLayer[0];
};

/**
 * 获得标注对象 div 所在的 z index
 * @returns z index {Number}
 */
MMMobilePageView.prototype.getCommentStartlayerZ_index = function () {
  return _MMBasicData["default"].getO2OCommentStartlayerZ_index();
};
MMMobilePageView.prototype.getAssistantCanvas = function () {
  // return this._$editorLayer[0];
  return this._$pdfLayer[0];
};
MMMobilePageView.prototype.getPageAssistantCanvas = function () {
  return this.getAssistantCanvas();
};
MMMobilePageView.prototype.getCanvasTransformer = MMMobilePageView.prototype.getTransformer = function () {
  return this.trsfm;
};
MMMobilePageView.prototype.getDivTransformer = function () {
  return this.trsfm;
};
MMMobilePageView.prototype.getTransformerForAssist = function () {
  return this.assistTrsfm;
};
MMMobilePageView.prototype.refreshSize = function () {
  var that = this;
  this.refreshEditor();
  this.refreshCanvas();
};
MMMobilePageView.prototype.getOperationCenter = function () {
  return this.operationCenter;
};
MMMobilePageView.prototype.setCurOperation = function (oper_, objs_, comm_) {
  if (this.operationCenter) {
    this.operationCenter.setCurOperation(oper_, objs_, comm_);
  }
};
MMMobilePageView.prototype.getCurOperation = function () {
  return this.operationCenter.m_curOperation;
};
MMMobilePageView.prototype.refreshLgPageInRect = function (lgRct) {
  this.refreshObjsInCanvas(lgRct);
  this.refreshCommentsInEditor(lgRct);
};
MMMobilePageView.prototype.clearContent = function () {
  // 1. clear canvas

  // 2. clear div
  _MMObjElementsController["default"].getSingleInstance().removeAllDivsForEditor(this);
};
MMMobilePageView.prototype.clearPdfLayer = function () {
  var pdf_canvas = this._$pdfLayer[0];
  if (pdf_canvas) {
    var w = this._$pdfLayer.width();
    var h = this._$pdfLayer.height();
    var ctx = pdf_canvas.getContext('2d');
    ctx.clearRect(0, 0, w, h);
  }
  ;
};
MMMobilePageView.prototype.getCurrentFilePageIndex = function () {
  var index = -1;
  if (this.mmPicObj) {
    index = this.mmPicObj.getPageIndex();
  }
  return index;
};
MMMobilePageView.prototype.removeFromSuperView = function () {
  this.pdfDrawerCtl.clear(this);
  $(this.$root).remove();
  if (this.operationCenter) {
    this.operationCenter.destroy();
    this.operationCenter = null;
  }
  // Dispatcher.trigger(MDEvents.IMG_FULLSCREEN_END,this.mmPicObj );
  //Dispatcher.off("SCROLL_OPERATION",this._scrollNotificationHandler);
  this.$root = null;
  this.mmPicObj = null;
  this.board = null;
  var elementsCtl = _MMObjElementsController["default"].getSingleInstance();
  elementsCtl.removeAllDivsForEditor(this);
  this.__lastWinW = 0;
  this.winW = 0;
};
MMMobilePageView.prototype.getObjsInView = function () {
  if (this.board) {
    var divObjs = this.board.getObjsInPageByFilter(this.mmPicObj.getPageIndex(), this.divObjsFilter, this.mmPicObj.getExpandRect());
    var canvasObjs = this.board.getObjsInPageByFilter(this.mmPicObj.getPageIndex(), this.canvasObjsFilter, this.mmPicObj.getExpandRect());
    return divObjs.concat(canvasObjs);
  } else {
    return [];
  }
};
MMMobilePageView.prototype.logic2AssistViewPoint = function (pos) {
  var devicePoint = this.trsfm.lg2dvPoint(pos);
  var newPoint = this.convertPointFromEditor2AssistView(devicePoint);
  return newPoint;
};
MMMobilePageView.prototype.assistView2LogicPoint = function (pos) {
  if (!this.trsfm) {
    return pos;
  }
  ;
  var newpos = this.convertPointFromAssistView2Editor(pos);
  var logicPoint = this.trsfm.dv2lgPoint(newpos);
  return logicPoint;
};

/**
 * a method should return a converted point, that can be transfered to a LG point using the
 * this.trsfm.dv2lsPoint() (ImageTransformer)
 * @param
 * @returns {MMPoint} devicepoint for the Image - Transformation
 */
MMMobilePageView.prototype.convertPointFromAssistView2Editor = function (pos) {
  //todo: this implementation is from the EditorView
  var newpos = pos.clone();
  var to = this.getCommentLayer();
  var from = this.getAssistantCanvas();
  var converted = MMCommonFun.convertPointBetweenElements(from, to, pos);
  newpos.x = converted.x;
  newpos.y = converted.y;
  return newpos;
};
MMMobilePageView.prototype.convertPointFromEditor2AssistView = function (pos) {
  var newpos = pos.clone();
  var to = this.getAssistantCanvas();
  var from = this.getCommentLayer();
  var converted = MMCommonFun.convertPointBetweenElements(from, to, pos);
  newpos.x = converted.x;
  newpos.y = converted.y;
  return newpos;
};
MMMobilePageView.prototype.getScrollView = function () {
  return this.container;
};
MMMobilePageView.prototype.getScrollContent = function () {
  return this._$content[0];
};
MMMobilePageView.prototype.getScrollViewSize = function () {
  var size = new _size["default"](this.container.clientWidth, this.container.clientHeight);
  return size;
};
MMMobilePageView.prototype.getImageDispSize = function () {
  var size = new _size["default"](this._$editorZone[0].clientWidth, this._$editorZone[0].clientHeight);
  return size;
};
MMMobilePageView.prototype.getObjectNatureSize = function () {
  return {
    width: this.originW,
    height: this.originH
  };
};

//mashx
MMMobilePageView.prototype.getContainer = function () {
  return this.$root;
};
//====================================================================================================================================================

MMMobilePageView.prototype.useDefualtScale = function () {
  return this.useFitScale;
};
MMMobilePageView.prototype.setUseDefualtScale = function (useFitScale) {
  this.useFitScale = useFitScale;
};
MMMobilePageView.prototype.setScale = function (scale) {
  this.scale = scale;
};
MMMobilePageView.prototype.setScaleToFit = function () {
  var margin = 0;
  var containerW = this.parentDiv.offsetWidth - margin;
  var containerH = this.parentDiv.offsetHeight - margin;
  if (containerW > 0 && containerH > 0 && this.originW > 0 && this.originH > 0) {
    var scaleX = containerW / this.originW;
    var scaleY = containerH / this.originH;
    if (this.isDispPdf()) {
      //  ----------------------------- pdf 等宽显示,即只要宽度适合
      scaleY = scaleX + 0.1;
    }
    ;
    var scale = scaleX < scaleY ? scaleX : scaleY;
    if (scale > 1.0 && !this.isDispPdf()) {
      scale = 1.0;
    }
    ;
    this.scale = scale;
  } else {
    this.scale = 1.0;
  }
};
MMMobilePageView.prototype.getCurrentBoard = function () {
  // body...
  return this.mmPicObj.getBoard();
};
MMMobilePageView.prototype.getScale = function () {
  return 1.0;
};
MMMobilePageView.prototype.useTransformToScale = function () {
  return false;
};
MMMobilePageView.prototype._getPageCount = function () {
  var curTask = _MDPcMobileEditorCommonFun["default"].getMainEditor().getCurrentBoard();
  if (curTask) {
    var pgCount = curTask.getPageCountByVersion();
    return pgCount;
  }
  return 0;
};
MMMobilePageView.prototype.getCurrentFilePageCount = function () {
  return this._getPageCount();
};
MMMobilePageView.prototype._commentCreated = function () {
  this.refreshCommentsInEditor();
};
MMMobilePageView.prototype.removeEvents = function () {
  Dispatcher.off(null, null, this);
};
MMMobilePageView.prototype.textCommentStatusChanged = function (textComment, sender) {
  MMCommonFun.refreshTextCommentStatus(textComment, this);
};
MMMobilePageView.prototype.receiveNewMessage = function (payload) {
  payload = payload || {};
  var comment = payload.comment;
  MMCommonFun.refreshTextCommentStatus(comment, this);
};
MMMobilePageView.prototype.setImgMarkerCtl = function (imgMarkerCtl) {
  this.imgMarkerCtl = imgMarkerCtl;
  if (this.operationCenter) {
    this.operationCenter.setImgMarkerCtl(imgMarkerCtl);
  }
  ;
};
var _default = exports["default"] = MMMobilePageView;

},{"1084":1084,"1184":1184,"1412":1412,"1417":1417,"1438":1438,"1454":1454,"1463":1463,"1466":1466,"325":325,"75":75,"76":76,"807":807,"811":811,"826":826,"837":837,"876":876,"879":879,"881":881,"893":893,"904":904,"932":932,"949":949,"955":955,"960":960}],881:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMOperationCenterMobile = _interopRequireDefault(require(878));
var _ObjType = _interopRequireDefault(require(1084));
var _MMObjElementsController = _interopRequireDefault(require(893));
var _MMOperationCenter = _interopRequireDefault(require(874));
var _MDCommentSlidePanelView = _interopRequireDefault(require(319));
var _MDTouchMenu = _interopRequireDefault(require(339));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
function MMOperationCenterMobilePDF(options) {
  _MMOperationCenterMobile["default"].call(this, options);
}
MMOperationCenterMobilePDF.prototype = _.extend({}, _MMOperationCenterMobile["default"].prototype);
MMOperationCenterMobilePDF.prototype.superclass = _MMOperationCenterMobile["default"];

// ****************** EVENTS START ****************

MMOperationCenterMobilePDF.prototype.onTouchStart = function (f, e) {
  this.throwHappened = false;
  this.longPressHappend = false;
  _MDTouchMenu["default"].hide();

  //Dispatcher.trigger(MDEvents.CLOSE_PANELS);
  if (this.createCommentView && !this.m_curOperation) {
    var createCommentView = this.createCommentView;
    this.createCommentView.hide(function () {
      createCommentView.remove();
    });
    if (this.createCommentView._$circleParent) this.createCommentView._$circleParent.remove();
    this.createCommentView = null;
  }
  e.touches[0].currentTarget = e.currentTarget;
  e.touches[0].timeStamp = e.timeStamp;
  this.lastEvent = e;
};
MMOperationCenterMobilePDF.prototype.onTouchMove = function (f, e) {
  var devicePoint = _MMOperationCenter["default"].getPosition(f.curFinger, this.offsetLeft || 0, this.offsetTop || 0);
  var logicPoint = this.m_editor.assistView2LogicPoint(devicePoint);
  if (this.m_curOperation) {
    e.preventDefault();
    e.stopPropagation();
    this.m_curOperation.onMouseMove(logicPoint, f.curFinger, e);
  }
  this.lastEvent = e;
};
MMOperationCenterMobilePDF.prototype.onTouchEnd = function (f, e) {
  this.lastEvent.touches[0].timeStamp = this.lastEvent.timeStamp;
  var devicePoint = _MMOperationCenter["default"].getPosition(f.curFinger, this.offsetLeft || 0, this.offsetTop || 0);
  var logicPoint = this.m_editor.assistView2LogicPoint(devicePoint);
  if (this.m_curOperation) {
    this.m_curOperation.onMouseUp(logicPoint, f.curFinger, e);
  }
};

// MMOperationCenterMobilePDF.prototype.onTap = function(f, e) {

//   var devicePoint = MMOperationCenter.getPosition(f.beginFinger, this.offsetLeft || 0, this.offsetTop || 0);
//   var logicPoint = this.m_editor.assistView2LogicPoint(devicePoint);
//   logicPoint.devicePoint = devicePoint;
//   e.LGPoint = logicPoint;

//   var clickedObjects = this.getObjectsSelectable(logicPoint);
//   if (clickedObjects.length > 0) {
//     var _firstObject = clickedObjects[0];
//     if (_firstObject.m_objType === ObjType.Obj_comment) {
//       var elementsCtl = MMObjElementsController.getSingleInstance();
//       var div = elementsCtl.getDivByObj(null, _firstObject);

//       var center = MMCommonFun.getDivCenter($(div));
//       var posInBody = MMCommonFun.convertPointBetweenElements(div, $("body")[0], center);

//       var commentPanel = new MDCommentSlidePanelView({
//         comment: _firstObject,
//         view: this.m_editor,
//         onCloseBtnClicked: function() {
//           MMObjElementsController.commentPointUpdater.updateCommentView(_firstObject, "readed");
//           commentPanel.removeFromSuperView();
//         }
//       });
//       application.addSubView(commentPanel);
//       commentPanel.centerZoomShowForMobile(posInBody);

//     } else if (_firstObject.m_objType === ObjType.Obj_textComment) {
//       var commentPanel = new MDCommentSlidePanelView({
//         comment: _firstObject,
//         view: this.m_editor,
//         onCloseBtnClicked: function() {
//           MMObjElementsController.commentPointUpdater.updateCommentView(_firstObject, "readed");
//           commentPanel.removeFromSuperView();
//         }
//       });
//       application.addSubView(commentPanel);
//       commentPanel.centerZoomShowForMobile({ x: 0, y: 0 });
//     }
//   }
// }

MMOperationCenterMobilePDF.prototype.onLongPress = function (f, e) {
  e.preventDefault();
  e.stopPropagation();
  var curWhiteboard = this.editorViewCtl.getCurrentBoard();
  if (!curWhiteboard) {
    return;
  }
  ;
  var fileInfo = curWhiteboard.getFileInfo();
  if (fileInfo && !fileInfo.canCreateComment()) {
    return;
  }
  ;
  var devicePoint = _MMOperationCenter["default"].getPosition(f.beginFinger, this.offsetLeft || 0, this.offsetTop || 0);
  var bodyPoint = MMCommonFun.convertPointBetweenElements(this.m_canvas, $('body')[0], devicePoint);
  var logicPoint = this.m_editor.assistView2LogicPoint(devicePoint);
  logicPoint.devicePoint = devicePoint;
  logicPoint.bodyPoint = bodyPoint;
  e.LGPoint = logicPoint;
  var clickedObjects = this.getObjectsSelectable(logicPoint);
  console.log("longpress");
  if (window.navigator.vibrate) window.navigator.vibrate(200);
  if (clickedObjects.length > 0) {
    var _firstObject = clickedObjects[0];
    if ((_firstObject.m_objType == _ObjType["default"].Obj_comment || _firstObject.m_objType == _ObjType["default"].Obj_niceTag) && app.currentUser.isObjectCreator(clickedObjects[0])) {
      //&& Math.abs(clickedObjects[0].getCreationTime() - (new Date().getTime())) < 1000 * 60 * 15 // no 10 minutes time requirement.
      /* 10 minutes time */

      // begin move ...
      // console.log("SELECT CURRENT OPEREATION")
      // this.setCurOperation('move', _firstObject);
      // this.m_curOperation.onMouseDown(logicPoint, this.$canvas, e);
      //this.commentMoving = _firstObject;
    }
  } else {
    this.openTouchMenue(logicPoint, bodyPoint);
  }
};
MMOperationCenterMobilePDF.prototype.getTransformer = function () {
  return this.m_editor.getTransformer();
};
var _default = exports["default"] = MMOperationCenterMobilePDF;

},{"1084":1084,"1184":1184,"1454":1454,"319":319,"339":339,"807":807,"874":874,"878":878,"893":893}],75:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
var _MMViewBase = _interopRequireDefault(require(22));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
/**
 * Simple inline loading indicator view.
 * Created by manjun.han
 * 2016.03.18
 */

var MDSpinnerloaderLayerView = _MMViewBase["default"].extend({
  el: '<div class="spinner-loader-layer"></div>',
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend({}, superP, {
      spinnerView: null,
      expandParentHeight: false
    });
  },
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    if (opt.cls == "white") {
      this.$el.addClass('white');
    }
    if (opt.expandParentHeight) {
      this.$el.addClass('expand-parent-height');
    }
    this.spinnerView = new _MDSpinnerloaderView["default"]();
    this.addSubView(this.spinnerView);
    this.$el.data('load-layer-View', this);
  },
  setSizeType: function setSizeType(sizeType) {
    this.spinnerView.setSizeType(sizeType);
  }
}, {
  showIn: function showIn(parent, opt) {
    var parentEl = null;
    if (parent instanceof _MMViewBase["default"]) {
      parentEl = parent.el;
    } else {
      parentEl = parent;
    }
    var children = $(parentEl).find('.spinner-loader-layer').eq(0);
    var loadLayerView = children.data('load-layer-View');
    if (!loadLayerView) {
      loadLayerView = new MDSpinnerloaderLayerView(opt);
      loadLayerView.renderTo(parent);
      parentEl.offsetWidth;
    }
  },
  clearFrom: function clearFrom(parent) {
    var parentEl = null;
    if (parent instanceof _MMViewBase["default"]) {
      parentEl = parent.el;
    } else {
      parentEl = parent;
    }
    $(parentEl).find('.spinner-loader-layer').each(function () {
      var loadView = $(this).data('load-layer-View');
      if (loadView) {
        loadView.remove();
      }
      ;
    });
  }
});
var _default = exports["default"] = MDSpinnerloaderLayerView;

},{"1184":1184,"1417":1417,"1454":1454,"1463":1463,"22":22,"76":76}],929:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1451);
require(1412);
require(1417);
require(1463);
var MDPdfOriginFileDisplayView = function MDPdfOriginFileDisplayView(parentDiv, fileInfo) {
  this.$content = $('<div class="office-page" style="position:absolute;width:100%;height:100%;top:0;overflow:auto"></div>');
  $(parentDiv).append(this.$content);
};
Object.assign(MDPdfOriginFileDisplayView.prototype, Object.prototype, {
  contstructor: MDPdfOriginFileDisplayView,
  openFile: function openFile(curFileInfo, version, callback) {
    _czc && _czc.push(["_trackEvent", "预览", "Mail", "", "", ""]);
    this.fileInfo = curFileInfo;
    var fileId = curFileInfo.getFileId();

    // let url =
    //   location.origin +
    //   "/netdrive/openFileByBabelOffice.do?fileId=" +
    //   fileId +
    //   "&readOnly=1&version=" +
    //   c;
    var url = "/pdf/pdfjs-3.9.179-legacy-dist/web/viewer.html?fileId=".concat(fileId, "&v=").concat(version);
    var mail = "<iframe src=\"".concat(url, "\" class=\"office-page-iframe\" style=\"position:absolute;width:100%;height:100%;top:0;border:none;background-color: #fff;\"></iframe>");
    this.$content.append(mail);
    callback();
    this.$content.find(".office-page").find("iframe").load(function () {
      this.$content.find(".office-page").find("iframe").contents().find("body").on("mousemove", function (e) {
        // console.log('----------------- mouse moving!');
        Dispatcher.trigger(MDEvents.mailMouseMove);
      });
    });
  },
  getScale: function getScale() {
    return 1;
  },
  setScale: function setScale() {},
  refreshSize: function refreshSize() {},
  getClassName: function getClassName() {
    return "MDPdfOriginFileDisplayView";
  },
  closeCommentPanel: function closeCommentPanel() {},
  removeFromSuperView: function removeFromSuperView() {
    this.$content.remove();
  },
  // 以下是为了配合手机界面的接口
  getCurrentBoard: function getCurrentBoard() {
    return null;
  },
  getCurrentFileInfo: function getCurrentFileInfo() {
    return this.fileInfo;
  },
  getCurrentFilePageCount: function getCurrentFilePageCount() {
    return 1;
  },
  getCurrentFilePageIndex: function getCurrentFilePageIndex() {
    return 0;
  },
  getCurrentFileIndex: function getCurrentFileIndex() {
    return 0;
  }
});
var _default = exports["default"] = MDPdfOriginFileDisplayView;

},{"1412":1412,"1417":1417,"1451":1451,"1454":1454,"1463":1463}],915:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1416);
require(1439);
require(1412);
require(1466);
require(1437);
require(1478);
var _MDMarkerObjDrawerController = _interopRequireDefault(require(909));
var _MDSelectFrame = _interopRequireDefault(require(919));
var _MDCombobox = _interopRequireDefault(require(27));
var _MDLineWidthAndFont = _interopRequireDefault(require(861));
var _MDColorDiskPopupView = _interopRequireDefault(require(857));
var _MDZoomPopupView = _interopRequireDefault(require(439));
var _MMSketchCommentController = _interopRequireDefault(require(885));
var _MMThumbnailMaker = _interopRequireDefault(require(903));
var _MMBasicData = _interopRequireDefault(require(811));
var _ObjType = _interopRequireDefault(require(1084));
var _MMRect = _interopRequireDefault(require(831));
var _size = _interopRequireDefault(require(837));
var _MMPCImageEditor = _interopRequireDefault(require(916));
var _EditorMode = _interopRequireDefault(require(904));
var _ImageTransformer = _interopRequireDefault(require(826));
var _MDPCSinglePagePdfView = _interopRequireDefault(require(943));
var _MDPCSVGView = _interopRequireDefault(require(942));
var _MDColorDisk = _interopRequireDefault(require(856));
var _MDSWFEditor = _interopRequireDefault(require(1122));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MDDropdownSelectListView = _interopRequireDefault(require(67));
/**
 * 为图片增加标记的显示界面控制
 * javascript/molasync-source/ui/editor-task/android-scroll/MMImageMarkerCtl.js
 * 2015-6-24
 */

function MMImageMarkerCtl(containerDiv) {
  var that = this;
  this.animationSteps = 5;
  this.animationSpan = 1000 / 24;
  this.parentDiv = containerDiv;
  this.imageEditor = null;
  this.constructView();
  this.adjustView(false);
  this.$root.css("display", "block");
  this.comment = null;
  this.displaying = false;
  Dispatcher.on(MDEvents.MARK_READY, function (board, rect) {
    setBabelTimeout(function () {
      that.displayInRect(rect);
    });
  });
  Dispatcher.on(MDEvents.Null_Selected, function () {
    that.nullSelected();
  });
  Dispatcher.on(MDEvents.Obj_Selected, function () {
    that.objSelected();
  });
}

// var g_singleImageMarkerCtl = null;
window.g_singleImageMarkerCtl = null;
var MarkerEditMode = {
  editable: "w",
  readonly: "r"
};
MMImageMarkerCtl.getSingleInstance = function () {
  if (g_singleImageMarkerCtl == null) {
    g_singleImageMarkerCtl = new MMImageMarkerCtl($(".app-root")[0]);
  }
  return g_singleImageMarkerCtl;
};
_MMSketchCommentController["default"].imgMarkerCtl = MMImageMarkerCtl;
MMImageMarkerCtl.prototype.displayToEdit = function (imgobj, param, callback_) {
  var _this = this;
  this.swfEditor = param.swfEditor;
  this.editorViewCtl = param.editorViewCtl;
  this.displaying = true;
  this._initEditorByObjectType(imgobj);
  param = param ? param : {};
  var comment = param.comment;
  this.comment = comment;
  this.isOpenOldScribble = param.isOpenOldScribble;
  this.curBtnId = "pen-marker";
  this.$root.css("display", "block");
  if (this.mode != MarkerEditMode.editable && this.editor) {
    this.mmImg = null;
    this.editor.mmImg = null;
  }
  this.editor.markEditable = true;
  this.mode = MarkerEditMode.editable;
  this._completeCallback = callback_;
  _MMSketchCommentController["default"].enterSketch();
  var sizeZoom = 1.0;
  var that = this;
  // if (this.mmImg != imgobj  || param.swfEditor) {
  this.mmImg = imgobj;
  var editor = this.editorViewCtl.getCurEditor();
  this.scale = editor.getScale();
  this.initWithObject(function () {
    that.editor.changeScale(editor.getScale(), function () {
      that.editor.restoreCenterPostion(editor.getCenterRatioPosition());
      that.editor.setCurOperation("draw");
      // that.$mobileMsgInput.find('.mobile-input').blur();
      //        that.focusInput();
      var _markObjs = _MMSketchCommentController["default"].getAllObjects();
      that.sketchObjects(_markObjs);
      if (that.comment != comment) {
        that.delClicked();
      }
    });
  });
  this.editor.clearContent();
  var fileInfo = this.editorViewCtl.getCurrentFileInfo();
  var ext = fileInfo.getFileExtension().toLowerCase();
  this.$root.find(".encode-block").addClass("f-hide");
  if (ext == "svg") {
    this.$toolbar.find(".encode-block-foredit").removeClass("f-hide");
    var conditionArr = [{
      type: "utf-8",
      name: "utf-8"
    }, {
      type: "utf-16",
      name: "utf-16"
    }];
    var type = localStorage.getItem("encodtype" + fileInfo.getFileId());
    var selectedIndex = 0;
    if (type) {
      selectedIndex = _.findIndex(conditionArr, function (item) {
        return item.name == type;
      });
    }
    if (!this.encodingSelectForEdit) {
      this.encodingSelectForEdit = new _MDDropdownSelectListView["default"]({
        dataProvider: conditionArr,
        labelField: "name",
        // isFixed: true,
        gapY: 1,
        selectedIndex: selectedIndex,
        onChange: function onChange(obj) {
          localStorage.setItem("encodtype" + fileInfo.getFileId(), obj.type);
          var curEditor = _this.editor;
          var data = curEditor.getOriginData();
          curEditor.encodeToType(data, obj.type);
        }
      });
      this.$toolbar.find(".encode-block-foredit").append(this.encodingSelectForEdit.$el);
    } else {
      this.encodingSelectForEdit.selectItemAt(selectedIndex, true);
    }
  }
  // } else {
  //   that.editor.setCurOperation('draw');
  //   this.editor.clearContent();
  //   this.adjustView(false, function() {
  //     var _markObjs = MMSketchCommentController.getAllObjects();
  //     that.sketchObjects(_markObjs);
  //     //        that.focusInput();
  //     if (that.comment != comment) {
  //       that.delClicked();
  //     }
  //   });
  // }

  _MMCommonFun["default"].setTextInputInEditor("handGraphPanel");
};
MMImageMarkerCtl.prototype.displayToReadOnly = function (imgobj, markObjs, param, callback, msg) {
  var _this2 = this;
  this.isOpenOldScribble = true;
  this.swfEditor = param.swfEditor;
  this.editorViewCtl = param.editorViewCtl;
  this.displaying = true;
  this.comment = undefined;
  this.$root.css("display", "block");
  if (this.mode != MarkerEditMode.readonly) {
    this.mmImg = null;
    this.editor.mmImg = null;
  }
  this._initEditorByObjectType(imgobj);
  this.mode = MarkerEditMode.readonly;
  this.editor.markEditable = false;
  if (!msg) {
    this.msg = "";
  } else {
    this.msg = msg;
  }
  var scroll2Show = function scroll2Show() {
    that.editor.setCurOperation();
    that.scrollToShowSketchObjects(markObjs);
    that.showMsg();
  };
  var that = this;
  // if (this.mmImg != imgobj || param.swfEditor) {
  this.mmImg = imgobj;
  this.initWithObject(function renderFinish(pdfDrawFinish) {
    if (!pdfDrawFinish) {
      that.flashObjects(markObjs, function () {
        that.scale2SketchObjects(markObjs, function () {
          scroll2Show();
        });
        if (callback) {
          callback();
        }
      });
    } else {
      that.scale2SketchObjects(markObjs, function () {
        if (callback) {
          callback();
        }
        scroll2Show();
      });
    }
  });
  // } else {
  //   this.editor.setCurOperation(undefined);
  //   this.editor.clearContent();
  //   this.adjustView(false, function renderFinish(pdfDrawFinish) {
  //     if (!pdfDrawFinish) {
  //       that.flashObjects(markObjs, function() {
  //         that.sketchObjects(markObjs);
  //         if (callback) {
  //           callback();
  //         };
  //       });
  //     } else {
  //       that.sketchObjects(markObjs);
  //       if (callback) {
  //         callback();
  //       };
  //     }
  //     that.scrollToShowSketchObjects(markObjs);
  //     that.showMsg();
  //   })
  // }

  this.changeToolToHand();
  var fileInfo = this.editorViewCtl.getCurrentFileInfo();
  var ext = fileInfo.getFileExtension().toLowerCase();
  this.$root.find(".encode-block").addClass("f-hide");
  if (ext == "svg") {
    var conditionArr = [{
      type: "utf-8",
      name: "utf-8"
    }, {
      type: "utf-16",
      name: "utf-16"
    }];
    var type = localStorage.getItem("encodtype" + fileInfo.getFileId());
    var selectedIndex = 0;
    if (type) {
      selectedIndex = _.findIndex(conditionArr, function (item) {
        return item.name == type;
      });
    }
    if (!this.encodingSelectForeRead) {
      this.$root.find(".marker-editor-zone").append('<div class="encode-block encode-block-forread"></div>');
      this.encodingSelectForeRead = new _MDDropdownSelectListView["default"]({
        dataProvider: conditionArr,
        labelField: "name",
        // isFixed: true,
        selectedIndex: selectedIndex,
        gapY: 1,
        onChange: function onChange(obj) {
          localStorage.setItem("encodtype" + fileInfo.getFileId(), obj.type);
          var curEditor = _this2.editor;
          var data = curEditor.getOriginData();
          curEditor.encodeToType(data, obj.type);
          that.flashObjects(markObjs, function () {
            that.scale2SketchObjects(markObjs, function () {
              scroll2Show();
            });
            if (callback) {
              callback();
            }
          });
        }
      });
      this.$root.find(".encode-block-forread").append(this.encodingSelectForeRead.$el);
    } else {
      this.encodingSelectForeRead.selectItemAt(selectedIndex, true);
    }
    this.$root.find(".encode-block-forread").removeClass("f-hide");
  }
  _MMCommonFun["default"].setTextInputInEditor("handGraphPanel");
};
MMImageMarkerCtl.refreshSize = function () {
  if (MMImageMarkerCtl.isShowing()) {
    g_singleImageMarkerCtl.adjustView();
    if (g_singleImageMarkerCtl.sketchedObjects && g_singleImageMarkerCtl.sketchedObjects.length > 0) {
      g_singleImageMarkerCtl.sketchObjects(g_singleImageMarkerCtl.sketchedObjects);
    }
  }
};
MMImageMarkerCtl.prototype.constructView = function () {
  var z_maxIndex = _MMBasicData["default"].getO2OMaxLayerZ_index() + 1;
  this.$root = $("<div class='marker-root  f-noselect' style='z-index:" + z_maxIndex + ";'></div>");
  this.$mask = $("<div class='marker-mask m-mobile-mask' ></div>");
  this.$panel = $("<div class='marker-panel' ></div>");
  if (!app.canDispInNormalBrowser()) {
    this.$toolbar = this.createToolBarForMobile();
    this.$panel.addClass("mobile-marker-panel");
  } else {
    this.$toolbar = this.createToolBarForPC();
  }
  this.$editorZone = $("<div class='marker-editor-zone'>" + "<div class='marker-editor-container'></div>" + "</div>");
  this.$closeBtn = $("<div class='icon marker-close' style='z-index:" + z_maxIndex + ";'></div>");
  $(this.parentDiv).append(this.$root);
  this.$root.append(this.$mask);
  this.$root.append(this.$panel);
  this.$panel.append(this.$toolbar);
  this.$panel.append(this.$editorZone);
  this.$editorZone.append(this.$closeBtn);
  if (!app.canDispInNormalBrowser()) {
    this.createFooterForMobile();
    this.$closeBtn.addClass("mobile-marker-close");
  }
  this.mode = MarkerEditMode.editable;
  this.natureSize = {
    width: 1000,
    height: 1700
  };
  this.editor = new _MMPCImageEditor["default"](this.$editorZone.find(".marker-editor-container")[0]);
  this.editor.setMode(_EditorMode["default"].mark);
  $(this.editor.container).css("background-color", "black");
  this.registerEvents();
  this.updateCurColor();
};
MMImageMarkerCtl.prototype.updateCurColor = function () {
  var color = _MDColorDisk["default"].getCurColor();
  this.$root.find(".color-marker").css("background-color", color);
};
MMImageMarkerCtl.prototype._initEditorByObjectType = function (picObj) {
  if (!picObj) {
    return;
  }
  this.editor && this.editor.removeFromSuperView();
  if (this.swfEditor) {
    this.editor = new _MDSWFEditor["default"](this.$editorZone.find(".marker-editor-container")[0], {
      editorViewCtl: this.editorViewCtl
    });
    this.editor.toolChanged("graphic");
  } else if (picObj.m_objType == _ObjType["default"].Obj_Image) {
    this.editor = new _MMPCImageEditor["default"](this.$editorZone.find(".marker-editor-container")[0], {
      editorViewCtl: this.editorViewCtl
    });
  } else if (picObj.getBoard().canDispWithSVG()) {
    this.editor = new _MDPCSVGView["default"](this.$editorZone.find(".marker-editor-container")[0], {
      editorViewCtl: this.editorViewCtl
    });
  } else {
    this.editor = new _MDPCSinglePagePdfView["default"](this.$editorZone.find(".marker-editor-container")[0], {
      editorViewCtl: this.editorViewCtl
    });
  }
  this.editor.setMode(_EditorMode["default"].mark);
  $(this.editor.container).css("background-color", "black");
};
MMImageMarkerCtl.prototype.createToolBarForPC = function () {
  var scribble = BabelStr.str(466); // 手绘线条
  var rect = BabelStr.str(467); // 矩形框
  var line = BabelStr.str(468); // 直线
  var arrow = BabelStr.str(469); // 箭头
  var text = BabelStr.str(470); // 文本
  var color = BabelStr.str(471); // 颜色
  var lineWidth = BabelStr.str(472); // 线宽
  var fontSize = BabelStr.str(473); // 字号
  var undo = BabelStr.str(474); // 撤销
  var redo = BabelStr.str(475); // 重做
  var del = BabelStr.str(32); // 删除
  var cancel = BabelStr.str(155); // 取消
  var save = BabelStr.str(3080); // 保存
  var tmpl = "<div class='marker-toolbar' >\n        <div class=\"marker-toolbar-inner flex-align middle between\">\n          <ul id='left-bar' class='marker-left-bar'>\n            <li id='pen-marker' class='marker-tool ' title=\"".concat(scribble, "\">\n              <div class='marker-icon-btn pen-marker'></div>\n            </li>\n            <li id='rect-marker' class='marker-tool' title=\"").concat(rect, "\">\n              <div class='marker-icon-btn rect-marker'></div>\n            </li>\n            <li id='line-marker' class='marker-tool' title=\"").concat(line, "\">\n              <div class='marker-icon-btn line-marker'></div>\n            </li>\n            <li id='arrow-marker' class='marker-tool' title=\"").concat(arrow, "\">\n              <div class='marker-icon-btn arrow-marker'></div>\n            </li>\n            <li id='text-marker' class='marker-tool' title=\"").concat(text, "\">\n              <div class='marker-icon-btn text-marker'></div>\n            </li>\n            <li class='marker-divider'></li>\n            <li id='color-marker' class='marker-tool' title=\"").concat(color, "\">\n              <div class='marker-icon-btn color-marker'></div>\n            </li>\n            <li id='width-marker' class='marker-op width-op' title=\"").concat(lineWidth, "\">\n              <span class='thin'><div></div></span>\n              <span class='middle'><div></div></span>\n              <span class='wide'><div></div></span>\n            </li>\n            <li id='width-marker' class='marker-op font-op' title=\"").concat(fontSize, "\">\n              <span class='prompt'>").concat(fontSize, "</span>\n              <span class='font-list'></span>\n            </li>\n            <li class='marker-divider'></li>\n            <li id='undo-marker' class='marker-tool' title=\"").concat(undo, "\">\n              <div class='marker-icon-btn undo-marker'></div>\n            </li>\n            <li id='redo-marker' class='marker-tool' title=\"").concat(redo, "\">\n              <div class='marker-icon-btn redo-marker'></div>\n            </li>\n            <li id='del-marker' class='marker-tool' title=\"").concat(del, "\">\n              <button class='del-marker disabled' disabled='disabled'>").concat(del, "</button>\n            </li>\n\n\n          </ul>\n          <ul id='right-bar' class='marker-right-bar' >\n            <li class=\"tool-li encode-block encode-block-foredit f-hide\" ></li>\n            <li id='cancel-marker' class='button default'>").concat(cancel, "</li>\n            <li id='finish-marker' class='button done mgl-10'>").concat(save, "</li>\n          </ul>\n        </div>\n    </div>");

  // ------------------ 不再显示撤销和删除
  // <li id='hand-marker' class='marker-tool with-select' >
  //   <div class='marker-icon-btn hand-marker'></div>
  // </li>
  // <li class='marker-divider'></li>
  // <li id='undo-marker' class='marker-tool' title="撤销">
  //   <div class='marker-icon-btn undo-marker'></div>
  // </li>
  // <li id='redo-marker' class='marker-tool' title="重做">
  //   <div class='marker-icon-btn redo-marker'></div>
  // </li>
  //  <li id='del-marker' class='marker-tool' title="清屏">
  //   <div class='marker-icon-btn clear-marker'></div>
  // </li>

  this.$toolbar = $(tmpl);
  return this.$toolbar;
};
MMImageMarkerCtl.prototype.objSelected = function () {
  $("#del-marker button").removeAttr("disabled");
  $("#del-marker button").removeClass("disabled");
};
MMImageMarkerCtl.prototype.nullSelected = function () {
  $("#del-marker button").attr("disabled", "disabled");
  $("#del-marker button").addClass("disabled");
};
MMImageMarkerCtl.prototype.createToolBarForMobile = function () {
  var tmpl = "<div class='marker-toolbar'>\n    <div class=\"marker-toolbar-inner flex-align middle between\">\n        <ul id='left-bar' class='marker-left-bar'>\n          <li id='pen-marker' class='marker-tool'>\n            <div class='marker-icon-btn pen-marker'></div>\n          </li>\n          <li id='hand-marker' class='marker-tool'>\n            <div class='marker-icon-btn hand-marker'></div>\n          </li>\n        </ul>\n        <ul id='right-bar' class='marker-right-bar'>\n          <li id='undo-marker' class='marker-tool'>\n            <div class='marker-icon-btn undo-marker'></div>\n          </li>\n          <li class='marker-divider'>|</li>\n          <li id='cancel-marker' class='float-left'>\u5173\u95ED</li>\n        </ul>\n      </div>\n    </div>";
  this.$toolbar = $(tmpl);
  return this.$toolbar;
};
MMImageMarkerCtl.prototype.createFooterForMobile = function () {
  var z_maxIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
  var send = BabelStr.str(406); // 发送
  this.$mobileMsgInput = $("<div class='mobile-input-panel'style='z-index:" + z_maxIndex + ";'>" + "<input class='mobile-input'/>" + "<div class='mobile-send background-key-color'> " + send + "</div>" + "</div>");
  this.$mobileMsgDisp = $("<div class='mobile-msg-panel' style='z-index:" + z_maxIndex + ";'>" + "<div class='mobile-msg-shadow'></div>" + "<div class='mobile-msg-zone'>" + "<span class='mobile-msg'/>" + "</div>" + "</div>");
};
MMImageMarkerCtl.prototype.focusInput = function () {
  var that = this;
  if (!app.canDispInNormalBrowser()) {
    // setBabelTimeout(function(){
    that.$mobileMsgInput.find(".mobile-input").focus();
    // }, 100)
  }
};

// MMImageMarkerCtl.prototype.sendMsgClicked = function() {
//   var msg = this.$mobileMsgInput.find('.mobile-input').val().trim();
//   if (msg.length > 0 || MMSketchCommentController.getAllObjects().length > 0) {

//     var that = this;
//     var user = app.currentUser;
//     // var action = StaAction.replyComment;
//     if (MMSketchCommentController.getAllObjects().length > 0) {
//       // action = StaAction.replyWithMarker;
//     };

//     if (user && user.isAnonymous() && !user.hasAnonymouseName()) {
//       var anonymousePanel = MMAnonymousPanel.getSingleInstance();
//       anonymousePanel.show(this.$root[0], function(done) {
//         if (done) {
//           console.log("--------- user done!");
//           that.closePanel();
//           that.$mobileMsgInput.find('.mobile-input').val('');
//           MMSketchCommentController.sendSketchComment(that, msg, that.comment);

//         } else {
//           console.log("--------- user cancel");
//         }
//       });
//     } else {
//       that.closePanel();
//       that.$mobileMsgInput.find('.mobile-input').val('');
//       MMSketchCommentController.sendSketchComment(that, msg, that.comment);
//     }

//   };
// };

MMImageMarkerCtl.prototype.showMsg = function () {
  this.msgStatus = "animating";
  if (!app.canDispInNormalBrowser() && this.mode == MarkerEditMode.readonly) {
    this.$mobileMsgInput.remove();
    this.$mobileMsgDisp.remove();
    if (this.msg.length > 0) {
      this.$mobileMsgDisp.find(".mobile-msg").html(this.msg);
      $(this.parentDiv).append(this.$mobileMsgDisp);
      var height = this.$mobileMsgDisp.height();
      this.$mobileMsgDisp.css("bottom", -height + "px");
      var that = this;
      that.animateForMsg(0, height / this.animationSteps, 1, function () {
        that.msgStatus = "show";
      });
    }
  }
};
MMImageMarkerCtl.prototype.animateForMsg = function (targetBottom, delta, step, completeCallback) {
  var bottom = parseInt(this.$mobileMsgDisp.css("bottom"));
  if (step < this.animationSteps) {
    bottom += delta;
    this.$mobileMsgDisp.css("bottom", bottom + "px");
    var that = this;
    setBabelTimeout(function () {
      that.animateForMsg(targetBottom, delta, step + 1, completeCallback);
    }, that.animationSpan);
  } else {
    this.$mobileMsgDisp.css("bottom", targetBottom + "px");
    if (completeCallback) {
      completeCallback();
    }
  }
};
MMImageMarkerCtl.prototype.hideMsg = function () {
  this.msgStatus = "animating";
  if (!app.canDispInNormalBrowser() && this.mode == MarkerEditMode.readonly) {
    var height = this.$mobileMsgDisp.height();
    var that = this;
    this.animateForMsg(-height, -height / this.animationSteps, 1, function () {
      that.$mobileMsgDisp.remove();
      that.msgStatus = "hide";
    });
  }
};
MMImageMarkerCtl.prototype.toggleShowMsg = function () {
  if (this.msgStatus == "hide") {
    this.showMsg();
  } else if (this.msgStatus == "show") {
    this.hideMsg();
  }
};
MMImageMarkerCtl.prototype.enableTextEdit = function (show) {
  if (show) {
    this.$toolbar.find(".font-op").show();
    this.$toolbar.find(".width-op").hide();
    $(".op-obj").css("pointer-events", "auto");
  } else {
    this.$toolbar.find(".font-op").hide();
    this.$toolbar.find(".width-op").show();
    $(".op-obj").css("pointer-events", "none");
  }
};
MMImageMarkerCtl.prototype.registerEvents = function () {
  var that = this;
  this.$toolbar.find("#pen-marker").on("click", function (e) {
    _MDMarkerObjDrawerController["default"].clearFocus();
    that.changeToolToPen();
  });
  this.$toolbar.find("#hand-marker").on("click", function (e) {
    _MDMarkerObjDrawerController["default"].clearFocus();
    that.changeToolToHand();
  });
  this.$toolbar.find("#rect-marker").on("click", function (e) {
    _MDMarkerObjDrawerController["default"].clearFocus();
    that.changeToolToRect();
  });
  this.$toolbar.find("#line-marker").on("click", function (e) {
    _MDMarkerObjDrawerController["default"].clearFocus();
    that.changeToolToLine();
  });
  this.$toolbar.find("#text-marker").on("click", function (e) {
    _MDMarkerObjDrawerController["default"].clearFocus();
    that.changeToolToText();
  });
  this.$toolbar.find("#arrow-marker").on("click", function (e) {
    _MDMarkerObjDrawerController["default"].clearFocus();
    that.changeToolToArrow();
  });
  this.$toolbar.find("#color-marker").on("click", function (e) {
    // MDMarkerObjDrawerController.clearFocus();
    that.showColorDisk(e);
  });
  this.$toolbar.find("#del-marker").on("click", function (e) {
    // MDMarkerObjDrawerController.clearFocus();
    _MDMarkerObjDrawerController["default"].delObjFocused(this);
    var _markObjs = _MMSketchCommentController["default"].getAllObjects();
    that.sketchObjects(_markObjs);
  });

  //----------------------
  // this.$toolbar.find("#zoomIn-bar").on('click',function(e){
  //  that.zoomInClicked();
  // });
  // this.$toolbar.find("#zoomOut-bar").on('click',function(e){
  //  that.zoomOutClicked();
  // });
  this.$toolbar.find("#undo-marker").on("click", function (e) {
    _MDMarkerObjDrawerController["default"].clearFocus();
    that.undoClicked();
  });
  this.$toolbar.find("#redo-marker").on("click", function (e) {
    _MDMarkerObjDrawerController["default"].clearFocus();
    that.redoClicked();
  });
  // this.$toolbar.find("#del-marker").on('click', function(e) {
  //   MDMarkerObjDrawerController.clearFocus();
  //   that.delClicked();
  // });

  this.$toolbar.find("#finish-marker").on("click", function (e) {
    _MDMarkerObjDrawerController["default"].clearFocus();
    that.finishMark();
  });
  this.$toolbar.find("#cancel-marker").on("click", function (e) {
    _MDMarkerObjDrawerController["default"].clearFocus();
    that.cancelMark();
  });
  this.$toolbar.find(".width-op span").on("click", function (e) {
    // MDMarkerObjDrawerController.clearFocus();
    that.changeWidth(e);
  });
  this.$closeBtn.on("click", function () {
    _MDMarkerObjDrawerController["default"].clearFocus();
    that.closePanel();
    _MMSketchCommentController["default"].clearAllObjects();
    _MDMarkerObjDrawerController["default"].clearAllObjs();
    that.interupted = true;
  });
  this.updateToolWithCurLineWidthAndFont();
  var self = this;
  this.combobox = new _MDCombobox["default"]({
    parentDiv: this.$toolbar.find(".font-list"),
    itemStrs: _MDLineWidthAndFont["default"].fontSizes,
    selectIndex: _MDLineWidthAndFont["default"].curFontIndex,
    popUpWidth: 70,
    selectCb: function selectCb(index) {
      _MDLineWidthAndFont["default"].curFontIndex = index;
      _MDSelectFrame["default"].setFontSize(_MDLineWidthAndFont["default"].getCurFontSize());
    }
  });
  this.$toolbar.find(".font-op").hide();
};
MMImageMarkerCtl.prototype.updateToolWithCurLineWidthAndFont = function () {
  var wIndex = _MDLineWidthAndFont["default"].curWidthIndex;
  var $widthOp = this.$toolbar.find(".width-op span");
  for (var i = 0; i < $widthOp.length; i++) {
    var w = _MDLineWidthAndFont["default"].lineWidths[i];
    $($widthOp[i]).find("span").css("width", w + "px");
    $($widthOp[i]).find("span").css("height", w + "px");
  }
  $widthOp.removeClass("selected");
  $($widthOp[wIndex]).addClass("selected");
};
MMImageMarkerCtl.prototype.initWithObject = function (callback) {
  if (this.editor) {
    this.editor.clearContent();
  }
  // if (false && MDPcMobileEditorCommonFun.getMainEditor().getPicObject() == this.mmImg) {
  //   this.natureSize = MDPcMobileEditorCommonFun.getMainEditor().getObjectNatureSize();
  //   this.adjustView(true, callback);
  // } else {
  var that = this;
  var objType = this.mmImg.getObjType();
  if (this.swfEditor) {
    that.adjustView(true, callback);
  } else if (objType == _ObjType["default"].Obj_Image) {
    this.image = new Image();
    this.image.onload = function () {
      that.natureSize = {
        width: that.image.width,
        height: that.image.height
      };
      that.adjustView(true, callback);
    };
    this.image.src = this.mmImg.getDispFilePath();
  } else if (objType == _ObjType["default"].Obj_PDF) {
    this.mmImg.getPdfPage(function (page) {
      // if(sizeZoom){
      //  var viewport = page.getViewport(sizeZoom);
      // }else{
      var viewport = page.getViewport(2.0);
      // }
      that.imgW = viewport.width;
      that.imgH = viewport.height;
      that.natureSize = {
        width: viewport.width,
        height: viewport.height
      };
      that.adjustView(true, callback);
    });
  }
  // }
};
MMImageMarkerCtl.prototype.adjustView = function (imgChanged, callback) {
  if (!app.canDispInNormalBrowser()) {
    this.adjustViewForMobile(imgChanged, callback);
  } else {
    this.adjustViewForPC(imgChanged, callback);
  }
  var that = this;
  if (this.mmImg && imgChanged) {
    this.editor.displayObject(this.mmImg, function (e) {
      if (!app.canDispInNormalBrowser()) {
        var assistLayer = $(that.editor.getAssistantCanvas()).on("click", function () {
          that.toggleShowMsg();
        });
      }

      // 不需要 fit 了，因为内部已经 fit 了
      // that.editor.zoomToFitWidth(callback);
      if (callback) {
        callback(e);
      }
    });
  } else {
    this.editor.refreshSize();
    if (callback) {
      callback();
    }
  }
  if (this.mode == MarkerEditMode.editable) {
    this.changeToolById(this.curBtnId);
  }
  this.enableUndo(false);
  this.enableRedo(false);
  var currentBoard = MDPcMobileEditorCommonFun.getMainEditor().getCurrentBoard();
  currentBoard.on(MDEvents.UNDO_REDO, function (type_) {
    if (type_ == 0) {
      that.enableUndo(false);
    } else if (type_ == 1) {
      that.enableUndo(true);
    } else if (type_ == 2) {
      that.enableRedo(false);
    } else {
      that.enableRedo(true);
    }
  });
};
MMImageMarkerCtl.prototype.adjustViewForMobile = function (imgChanged, callback) {
  var that = this;
  var winW = $("body").width();
  var winH = $("body").height();
  var panelSize = {
    width: winW < 780 ? 780 : winW,
    height: winH
  };
  this.$panel.css("width", panelSize.width + "px");
  this.$panel.css("height", panelSize.height + "px");
  // this.$panel.css('left', (winW - editorSize.width) / 2 + margin);
  this.$panel.css("margin-top", 0 + "px");
  var $editorContainer = this.$editorZone.find(".marker-editor-container");
  $editorContainer.css("width", "100%");
  $editorContainer.css("height", "100%");
  $editorContainer.css("left", 0 + "px");
  $editorContainer.css("top", 0 + "px");
  this.$mobileMsgInput.remove();
  this.$closeBtn.css("display", "none"); // only used in pc

  if (this.mode == MarkerEditMode.readonly) {
    this.$editorZone.css("height", panelSize.height + "px");
    this.$toolbar.css("display", "none");
    this.$toolbar.find(".marker-icon-btn").css("display", "none");
    this.$toolbar.find(".marker-divider").css("display", "none");
    this.$toolbar.find(".marker-right-bar").addClass("mobile-right-bar");
    this.$closeBtn.css("display", "block"); // only used in pc
  } else {
    this.$toolbar.css("display", "block");
    this.$toolbar.find(".marker-right-bar").addClass("mobile-right-bar");
    this.$toolbar.find(".marker-icon-btn").css("display", "block");
    this.$toolbar.find(".marker-divider").css("display", "block");
    $(this.parentDiv).append(this.$mobileMsgInput);

    //mashx comment the following code and made a new one.--begin
    //    this.$editorZone.css('height', (panelSize.height - this.$toolbar.height()-this.$mobileMsgInput.height()) + "px");
    //    this.$editorZone.css('top', this.$mobileMsgInput.height() + "px");

    this.$editorZone.css("height", panelSize.height - this.$toolbar.height() + "px");
    //mashx --end.

    this.$mobileMsgInput.css("top", "0px");
    this.$mobileMsgInput.css("display", "none");
    setBabelTimeout(function () {
      that.showMsgInput();
    }, 300);
    this.$toolbar.css("bottom", "0px");
    var placeholder = BabelStr.str(476); // 在此输入批注，也可以手绘下面的图片
    this.$mobileMsgInput.find(".mobile-input").attr("placeholder", placeholder);
    this.$mobileMsgInput.find(".mobile-send").on("click", function () {
      that.sendMsgClicked();
    });
  }
};

//mashx --begin
MMImageMarkerCtl.prototype.showMsgInput = function () {
  this.$mobileMsgInput.css("display", "block");
  this.$mobileMsgInput.removeClass("msg-input-animation-hide");
  this.$mobileMsgInput.addClass("msg-input-animation-show");
};
MMImageMarkerCtl.prototype.hideMsgInput = function () {
  this.$mobileMsgInput.removeClass("msg-input-animation-show");
  this.$mobileMsgInput.addClass("msg-input-animation-hide");
  this.$mobileMsgInput.css("display", "none");
};
//mashx --end
MMImageMarkerCtl.prototype.adjustViewForPC = function (imgChanged, callback) {
  var that = this;
  var winW = $("body").width();
  var winH = $("body").height();
  var margin = 40;
  var winSize = new _size["default"](winW - margin * 2, winH - this.$toolbar.height() - margin * 2);
  var editorSize = {
    width: this.natureSize.width <= winSize.width ? this.natureSize.width : winSize.width,
    height: this.natureSize.height <= winSize.height ? this.natureSize.height : winSize.height
  };

  // if (this.mode == MarkerEditMode.readonly) {

  // } else {
  var innerWinW = winW - 8;
  if (innerWinW < 760) {
    innerWinW = 760;
  }
  var minEditorWidth = 900 < innerWinW ? 900 : innerWinW;
  if (editorSize.width < minEditorWidth) {
    editorSize.height = editorSize.height * minEditorWidth / editorSize.width;
    editorSize.width = minEditorWidth;
    if (editorSize.height > winSize.height) {
      editorSize.height = winSize.height;
    }
  }
  // }

  var borderWidth = 1;
  var panelSize = {
    width: editorSize.width + borderWidth * 2,
    height: editorSize.height + borderWidth * 2 + this.$toolbar.height()
  };
  this.$panel.css("width", panelSize.width + "px");
  this.$panel.css("height", panelSize.height + "px");
  // this.$panel.css('left', (winW - editorSize.width) / 2 + margin);
  this.$panel.css("margin-top", (winH - panelSize.height) / 2 + "px");
  this.$editorZone.css("height", editorSize.height + borderWidth * 2 + "px");
  var $editorContainer = this.$editorZone.find(".marker-editor-container");
  $editorContainer.css("width", editorSize.width + "px");
  $editorContainer.css("height", editorSize.height + "px");
  if (this.mode == MarkerEditMode.readonly) {
    // this.$editorZone.css('top', this.$toolbar.height() / 2 + "px");
    this.$toolbar.css("display", "none");
    this.$closeBtn.css("display", "block");
  } else {
    this.$toolbar.css("display", "block");
    this.$closeBtn.css("display", "none");
    if (app.canDispInNormalBrowser()) {
      this.$toolbar.find("#hand-marker").css("display", "none");
    }
  }
};
MMImageMarkerCtl.prototype.closePanel = function (flag_) {
  this.$root.css("display", "none");
  this.displaying = false;
  if (!app.canDispInNormalBrowser()) {
    this.$mobileMsgDisp.remove();
    this.$mobileMsgInput.remove();
  }
  if (this.colorPanel) {
    this.colorPanel.close();
  }
  _MMCommonFun["default"].removeTextInputInEditor("handGraphPanel");
};
MMImageMarkerCtl.isShowing = function () {
  if (g_singleImageMarkerCtl) {
    return g_singleImageMarkerCtl.displaying;
  }
  return false;
};
MMImageMarkerCtl.prototype.finishMark = function () {
  console.log("finish mark!");
  var that = this;
  if (this._completeCallback) {
    this._completeCallback();
    this._completeCallback = null;
  }
  this.closePanel();
};
MMImageMarkerCtl.prototype.scrollToShowSketchObjects = function (objects_) {
  if (!objects_) {
    return;
  }
  var _objects = objects_;
  if (_objects.length == 0) {
    return;
  }
  var _lgRect = new _MMRect["default"](0, 0, 0, 0); //MMLgRect
  for (var i = 0; i < _objects.length; i++) {
    var _object = _objects[i];
    var _rect = _object.getExpandRect();
    if (i == 0) {
      _lgRect = _rect;
    } else {
      _lgRect.expandToInclude(_rect);
    }
    break;
  }
  this.editor.scrollToShowLgRct(_lgRect);
};
MMImageMarkerCtl.prototype.clearObjects = function () {
  this.sketchedObjects = undefined;
};
MMImageMarkerCtl.prototype.sketchObjects = function (objects_) {
  if (!objects_) {
    return;
  }
  this.sketchedObjects = objects_;
  this.editor.drawMarkerObjsInCanvas(objects_);
};
MMImageMarkerCtl.prototype.scale2SketchObjects = function (objects_, callback) {
  if (!objects_) {
    callback && callback();
    return;
  }
  this.sketchedObjects = objects_;
  this.editor.scale2drawMarkerObjsInCanvas(objects_, callback);
};
MMImageMarkerCtl.prototype.flashObjects = function (objects_, callback_) {
  _MDMarkerObjDrawerController["default"].flashObjects(this, objects_, callback_);
};
MMImageMarkerCtl.prototype.displayInRect = function (rect) {
  this.editor.refreshLgPageInRect(rect);
  var _objects = _MMSketchCommentController["default"].getAllObjects();
  this.sketchObjects(_objects);
};
MMImageMarkerCtl.prototype.cancelMark = function () {
  this.closePanel();
  if (!this.isOpenOldScribble) {
    _MMSketchCommentController["default"].clearAllObjects();
    _MDMarkerObjDrawerController["default"].clearAllObjs();
  }
};
MMImageMarkerCtl.prototype.setBtnActive = function (id) {
  this.$toolbar.find("li").removeClass("active-marker");
  $("#" + id).addClass("active-marker");
  this.curBtnId = id;
};
MMImageMarkerCtl.prototype.changeToolById = function (id) {
  if (id == "pen-marker") {
    //this.editor.setScrollable(true)

    this.changeToolToPen();
  } else if (id == "hand-marker") {
    //this.editor.setScrollable(false)
    this.changeToolToHand();
  }
};
MMImageMarkerCtl.prototype.changeOpType = function (type) {
  if (this.operationType == type) {
    this.changeToolToHand();
    return false;
  } else {
    return true;
  }
};
MMImageMarkerCtl.prototype.changeToolToHand = function () {
  console.log("change to hand");
  this.editor.setScrollable(false);
  this.$editorZone.removeClass("cursor-draw");
  this.$editorZone.addClass("cursor-pan");
  this.setBtnActive("hand-marker");
  this.editor.setCurOperation(undefined);
  this.operationType = "hand";
};
MMImageMarkerCtl.prototype.changeToolToPen = function () {
  if (this.changeOpType("draw")) {
    console.log("change to pen");
    this.editor.setScrollable(true);
    this.$editorZone.removeClass("cursor-pan");
    this.$editorZone.addClass("cursor-draw");
    this.setBtnActive("pen-marker");
    this.editor.setCurOperation("draw");
    this.enableTextEdit(false);
    this.operationType = "draw";
  }
};
MMImageMarkerCtl.prototype.changeToolToRect = function () {
  if (this.changeOpType("rect")) {
    console.log("change to pen");
    this.$editorZone.removeClass("cursor-pan");
    this.$editorZone.addClass("cursor-draw");
    this.setBtnActive("rect-marker");
    this.editor.setCurOperation("rect");
    this.enableTextEdit(false);
    this.operationType = "rect";
  }
};
MMImageMarkerCtl.prototype.changeToolToLine = function () {
  if (this.changeOpType("line")) {
    this.$editorZone.removeClass("cursor-pan");
    this.$editorZone.addClass("cursor-draw");
    this.setBtnActive("line-marker");
    this.editor.setCurOperation("line");
    this.enableTextEdit(false);
    this.operationType = "line";
  }
};
MMImageMarkerCtl.prototype.changeToolToArrow = function () {
  if (this.changeOpType("arrow")) {
    this.$editorZone.removeClass("cursor-pan");
    this.$editorZone.addClass("cursor-draw");
    this.setBtnActive("arrow-marker");
    this.editor.setCurOperation("arrow");
    this.enableTextEdit(false);
    this.operationType = "arrow";
  }
};
MMImageMarkerCtl.prototype.changeToolToText = function () {
  if (this.changeOpType("text")) {
    this.$editorZone.removeClass("cursor-pan");
    this.$editorZone.addClass("cursor-draw");
    this.setBtnActive("text-marker");
    this.editor.setCurOperation("text");
    this.enableTextEdit(true);
    this.operationType = "text";
  }
};

// MMImageMarkerCtl.prototype.zoomInClicked = function() {
//  var that=this;
//   var scale= parseFloat(this.$toolbar.find("#zoomInfo-text").html());
//   sizeZoom=3.0;

//    // this.initWithObject(function() {
//    //    that.editor.setCurOperation('draw');
//    //    if (that.comment != comment) {
//    //      that.delClicked();
//    //    }

//   scale+=0.2;
//   // this._$imageLayer = this.$root.find('.image-layer');

//   // this._$imageLayer.width(this.mmImg.getOriginSize().x* scale + "px");
//   // this._$imageLayer.height(this.mmImg.getOriginSize().y* scale + "px");
//   this.$root.find(".scroll-content").children().each(function(index,obj){

//    if(obj.width){
//      obj.width=obj.width*scale;
//      obj.height=obj.height*scale;
//    }
//    if($(obj).width()){
//      $(obj).width(parseInt($(obj).width())*scale+"px");
//      $(obj).height(parseInt($(obj).height())*scale+"px");
//    }

//   });

//   this._$scroll_content=this.$root.find(".scroll-content");
//    this._$scroll_content.width(this._$scroll_content.width()*scale+"px");
//   this._$scroll_content.height(this._$scroll_content.height()*scale+"px");
//   // if (!$undo.hasClass('dis-able-marker')) {
//   //   console.log("undo clicked");
//   //   var currentBoard = MDPcMobileEditorCommonFun.getMainEditor().getCurrentBoard();
//   //   currentBoard.m_actionManager.undo();

//   // };
//   that.editor.setCurOperation('draw');
//   this.$toolbar.find("#zoomInfo-text").html(scale);
// };
MMImageMarkerCtl.prototype.zoomOutClicked = function () {};
MMImageMarkerCtl.prototype.undoClicked = function () {
  var $undo = this.$toolbar.find("#undo-marker");
  if (!$undo.hasClass("disable-marker")) {
    console.log("undo clicked");
    var currentBoard = MDPcMobileEditorCommonFun.getMainEditor().getCurrentBoard();
    currentBoard.m_actionManager.undo();
  }
};
MMImageMarkerCtl.prototype.redoClicked = function () {
  var $redo = this.$toolbar.find("#redo-marker");
  if (!$redo.hasClass("disable-marker")) {
    console.log("redo clicked");
    var currentBoard = MDPcMobileEditorCommonFun.getMainEditor().getCurrentBoard();
    currentBoard.m_actionManager.redo();
  }
};
MMImageMarkerCtl.prototype.delClicked = function () {
  console.log("del clicked");
  var _objects = _MMSketchCommentController["default"].getAllObjects();
  var _objIds = [];
  for (var i = 0; i < _objects.length; i++) {
    _objIds.push(_objects[i]);
  }
  var currentBoard = MDPcMobileEditorCommonFun.getMainEditor().getCurrentBoard();
  currentBoard.m_actionManager.deleteElements(_objIds, {
    toUndo: true,
    realtime: false,
    isMark_: true
  });
  if (_objIds.length > 0) {}
};
MMImageMarkerCtl.prototype.enableUndo = function (enabled) {
  var $undo = this.$toolbar.find("#undo-marker");
  if (enabled) {
    $undo.removeClass("disable-marker");
  } else {
    $undo.addClass("disable-marker");
  }
};
MMImageMarkerCtl.prototype.enableRedo = function (enabled) {
  var $redo = this.$toolbar.find("#redo-marker");
  if (enabled) {
    $redo.removeClass("disable-marker");
  } else {
    $redo.addClass("disable-marker");
  }
};
MMImageMarkerCtl.prototype.createScribbleThumbnail = function (callback, thumbWidth, thumbHeight) {
  console.log("================in createScribbleThumbnail================");
  var targetW = thumbWidth ? thumbWidth : 500;
  var targetH = thumbHeight ? thumbHeight : 100;
  var _strObjIds = [];
  var _objects = _MMSketchCommentController["default"].getAllObjects();
  if (_objects.length == 0) {
    console.log("================_objects.length==0================");
    if (callback) {
      callback(null);
    }
  }
  var _lgRect = new _MMRect["default"](0, 0, 0, 0); //MMLgRect
  for (var i = 0; i < _objects.length; i++) {
    var _object = _objects[i];
    var _objId = _object.getId();
    var _strObjId = _objId.toString();
    _strObjIds.push(_strObjId);
    var _rect = _object.getExpandRect();
    if (i == 0) {
      _lgRect = _rect;
    } else {
      _lgRect.expandToInclude(_rect);
    }
  }
  var mainEditor = MDPcMobileEditorCommonFun.getMainEditor();
  if (!mainEditor) return;
  var _currentWhiteboard = mainEditor.getCurrentBoard();
  if (!_currentWhiteboard) return;
  var dispRect = this.editor.getDivTransformer().lg2dvRect(_lgRect);
  dispRect.expand(10, 40, 10, 40);
  if (dispRect.left < 0) {
    dispRect.left = 0;
  }
  if (dispRect.top < 0) {
    dispRect.top = 0;
  }
  var dispW = dispRect.getWidth();
  if (dispW < targetW) {
    dispW = targetW;
  }
  if (dispW > this.natureSize.width) {
    dispW = this.natureSize.width;
  }
  var dispH = dispW * targetH / targetW;
  var newRect = new _MMRect["default"]();
  newRect.setRct(dispRect.getOrigin().x, dispRect.getOrigin().y, dispW, dispH);

  // get the logic rect to make thumbnail
  var editorTrsfm = this.editor.getDivTransformer();
  var lgThumbRct = editorTrsfm.dv2lgRect(newRect);
  var center = lgThumbRct.getCenter();
  lgThumbRct = lgThumbRct.rotateAroundPt(center, -editorTrsfm.angle * 180 / Math.PI);
  var thumbSize = new _size["default"](targetW, targetH);
  var thumbTrsfm = new _ImageTransformer["default"](thumbSize, lgThumbRct, editorTrsfm.angle);
  var curImgRect = new _MMRect["default"]();
  // if (false && !app.canDispInNormalBrowser()) {
  //   curImgRect.setRct(0, 0, this.natureSize.width, this.natureSize.height);
  // } else {
  var imgSize = this.editor.getDivTransformer().getDevicePageSize();
  curImgRect.setRct(0, 0, imgSize.width, imgSize.height);
  // }

  var imgTrsfm = new _ImageTransformer["default"](thumbSize, newRect, 0);
  var imgDvRect = imgTrsfm.lg2dvRect(curImgRect);
  console.log("================before MMThumbnailMaker.createMarkerThumbnail================");
  _MMThumbnailMaker["default"].createMarkerThumbnail(imgDvRect, thumbSize, thumbTrsfm, this.mmImg, _objects, function (image) {
    console.log("================after MMThumbnailMaker.createMarkerThumbnail================");
    if (callback) {
      callback(image);
    }
  });
};
MMImageMarkerCtl.prototype.getEditor = function () {
  return this.editor;
};
MMImageMarkerCtl.prototype.showColorDisk = function (e) {
  var self = this;
  if (this.colorPanel) {
    this.colorPanel.remove();
    this.colorPanel = null;
  } else {
    this.colorPanel = new _MDColorDiskPopupView["default"]();
    var z_startIndex = _MMBasicData["default"].getO2OMaxLayerZ_index() + 2;
    this.colorPanel.$el.css("z-index", z_startIndex);
    var self = this;
    this.colorPanel.show({
      triggerView: e.currentTarget,
      center: true,
      width: 146,
      hasArrow: true,
      arrowClass: "black",
      hasShadow: true,
      onClose: function onClose() {
        self.updateCurColor();
        self.colorPanel = null;
      }
    });
  }
};
MMImageMarkerCtl.prototype.changeWidth = function (e) {
  var index = $(e.currentTarget).index();
  if (index != _MDLineWidthAndFont["default"].curWidthIndex) {
    _MDLineWidthAndFont["default"].curWidthIndex = index;
    this.updateToolWithCurLineWidthAndFont();
    _MDSelectFrame["default"].setLineWidth(_MDLineWidthAndFont["default"].getCurLineWidth());
  }
};
window.MMImageMarkerCtl = MMImageMarkerCtl;
var _default = exports["default"] = MMImageMarkerCtl;

},{"1084":1084,"1122":1122,"1184":1184,"1412":1412,"1416":1416,"1417":1417,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1466":1466,"1478":1478,"27":27,"439":439,"67":67,"811":811,"812":812,"826":826,"831":831,"837":837,"856":856,"857":857,"861":861,"885":885,"903":903,"904":904,"909":909,"916":916,"919":919,"942":942,"943":943}],1122:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require(1180));
require(1451);
require(1466);
var _MDSWFPlayer = _interopRequireDefault(require(1123));
var _MDSWFToolbar = _interopRequireDefault(require(1124));
var _MDLoadMaskView = _interopRequireDefault(require(49));
var _MMCommonEditorView = _interopRequireDefault(require(914));
var _MMOperationCenterDesktopImage = _interopRequireDefault(require(876));
var _MMOperationCenterDesktopMarker = _interopRequireDefault(require(877));
var _MMOperationCenterMobileMarker = _interopRequireDefault(require(880));
var _MMOperationCenterMobileImage = _interopRequireDefault(require(879));
var _EditorMode = _interopRequireDefault(require(904));
var _MMObjectFilter = _interopRequireDefault(require(955));
var _FilterType = _interopRequireDefault(require(949));
var _ObjType = _interopRequireDefault(require(1084));
var _MMBasicData = _interopRequireDefault(require(811));
var _MMObjElementsController = _interopRequireDefault(require(893));
var _MDFileEditorInterface = _interopRequireDefault(require(1121));
var _MMRect = _interopRequireDefault(require(831));
var _Object$assign; // MDSWFEditor.js
// javascript/swf-player/editor/MDSWFEditor.js
// jiang
// 2018-8-5
//
//  类结构图 - swf 的显示控制
//
//  类结构如下（+ 代表包含一个， ++ 代表包含一个或多个）：
//
//  MDSWFEditor
//           |
//           |
//           +---  MDSWFPlayer  // 显示 swf 文件 模型内容
//           |          |
//           |          -
//           |
//           +---   MDSWFToolbar  // 控制显示 swf 的工具栏
//           |
//           |
//           -
//

function MDSWFEditor(parentDiv, opt) {
  // MMCommonEditorView.call(this, parentDiv);

  _MDFileEditorInterface["default"].call(this, parentDiv, opt);
  this.useGetDispUrl = opt.useGetDispUrl;
  this.swfDisp = null;
  this.canvasTrsfm = this;
  this.constructEditor();
  _czc && _czc.push(["_trackEvent", "预览", "SWF", "", "", ""]);
}
;
function _clearTouchlayerClass() {
  this.$touchLayer.removeClass('cursor-normal');
  this.$touchLayer.removeClass('cursor-hide');
  this.$touchLayer.removeClass('cursor-ruler');
}
Object.assign(MDSWFEditor.prototype, _MDFileEditorInterface["default"].prototype, (_Object$assign = {
  contstructor: MDSWFEditor,
  constructEditor: function constructEditor() {
    var parentDiv = this.parentDiv;
    this.containerId = "swf-container";
    this.touchId = "swf-touchlayer";
    this.$swfRoot = $('<div class="swf-root" style="position:absolute;width:100%;height:100%;top:0px;left:0px"></div>');
    $(this.parentDiv).append(this.$swfRoot);
    this.$editorLayer = $('<div id="' + this.containerId + '" class=""  style="position:absolute;width:100%;height:100%;top:0px;left:0px"></div>');
    this.$commentLayer = $('<div  class="comment-layer" style="position:absolute;width:100%;height:100%;top:0px;left:0px pointer-events:none"></div>');
    this.$scribbleLayer = $('<canvas id="" class="scribble" style="position:absolute;width:100%;height:100%;background-color:rgba(0,0,0,0) pointer-events:none"></canvas>');
    this.$touchLayer = $('<canvas id="' + this.touchId + '" class="" style="position:absolute;width:100%;height:100%;background-color:rgba(0,0,0,0)"></canvas>');
    this.$scribbleLayer.hide();
    this.$commentLayer.hide();
    this.$touchLayer.hide();
    this._$scribbleLayer = this.$scribbleLayer;
    this.$swfRoot.append(this.$editorLayer);
    this.$swfRoot.append(this.$commentLayer);
    this.$swfRoot.append(this.$scribbleLayer);
    this.$swfRoot.append(this.$touchLayer);
    this.swfDisp = new _MDSWFPlayer["default"](this.containerId, this.touchId, this);
    this.swfToolbar = new _MDSWFToolbar["default"]({
      editor: this,
      editorViewCtl: this.editorViewCtl
    });
    this.$swfRoot.append(this.swfToolbar.$el);
    _MDSWFPlayer["default"].setInstance(this.swfDisp);
  },
  _onMouseMove: function _onMouseMove(e) {
    Dispatcher.trigger(MDEvents.DISPLAY_ZOOM_BAR);
  },
  isShowingZoomRect: function isShowingZoomRect() {},
  restoreCenterPostion: function restoreCenterPostion() {},
  displayObject: function displayObject(picObj, opt, onLoaded) {
    this.clearContent();
    if (!onLoaded) {
      if (opt && _.isFunction(opt)) {
        onLoaded = opt;
        opt = {};
      } else {}
    }
    var self = this;
    this.mmPicObj = picObj;
    this.board = picObj.getBoard();
    var fileInfo = this.mmPicObj.getBoard().getFileInfo();
    var fileId = fileInfo.getFileId();
    var ver = this.mmPicObj.getFileVersion();
    var getUrl = function getUrl(next) {
      var url = opt.url;
      if (url) {
        next(url);
      } else if (self.useGetDispUrl) {
        MMCommonFun.getCadDocumentDispPath(fileId, ver, function (url) {
          next(url);
        });
      } else {
        MMCommonFun.getDocumentDispPath(fileId, ver, function (url) {
          next(url);
        });
      }
    };
    getUrl(function (url) {
      self.swfDisp.loadBabelFile(url, fileInfo, ver, function () {
        self.refreshSize();
        self.createOperationCenter();
        onLoaded();
        self.refreshObjsInEditor();
      });

      // ---- 
    }, function fail() {
      onLoaded();
    });
  },
  createOperationCenter: function createOperationCenter() {
    if (MMCommonFun.isPC()) {
      if (this.editorMode === _EditorMode["default"].mark) {
        this.operationCenterType = _MMOperationCenterDesktopMarker["default"];
      } else {
        this.operationCenterType = _MMOperationCenterDesktopImage["default"];
      }
    } else {
      if (this.editorMode === _EditorMode["default"].mark) {
        this.operationCenterType = _MMOperationCenterMobileMarker["default"];
      } else {
        if (this.mmPicObj.m_objType == _ObjType["default"].Obj_Image) {
          this.operationCenterType = _MMOperationCenterMobileImage["default"];
        } else {}
      }
    }
    this.operationCenter = new this.operationCenterType({
      whiteboard: this.board,
      editor: this,
      mode: 'FULLSCREEN',
      displayedObject: this.mmPicObj,
      imgMarkerCtl: this.imgMarkerCtl,
      editorViewCtl: this.editorViewCtl
    });
  },
  refreshSize: function refreshSize() {
    var winW = this.parentDiv.offsetWidth;
    var winH = this.parentDiv.offsetHeight;
    this.$touchLayer[0].width = winW;
    this.$touchLayer[0].height = winH;
    this.$scribbleLayer[0].width = winW;
    this.$scribbleLayer[0].height = winH;
    this.swfDisp.refreshSize();
    this.refreshObjsInEditor();
  },
  closeCommentPanel: function closeCommentPanel() {
    console.error('TO DO');
  },
  refreshObjsInEditor: function refreshObjsInEditor() {
    this.refreshLgPageInRect();
  },
  refreshCommentsInEditor: function refreshCommentsInEditor() {
    this.refreshLgPageInRect();
  },
  refreshObjsInCanvas: function refreshObjsInCanvas(rect) {
    this.refreshLgPageInRect(rect);
  },
  focusComment: function focusComment(comment) {
    this.swfDisp.focusComment(comment);
  },
  enableMouseWheel: function enableMouseWheel(enable) {
    this.swfDisp.enableMouseWheel(enable);
    if (enable) {
      console.log('--- enabled');
    }
    ;
  },
  toolChanged: function toolChanged(toolName) {
    var curOPe = this.operationCenter && this.getCurOperation();
    if (curOPe && _.isFunction(curOPe.saveActiveObj)) {
      curOPe.saveActiveObj(); //保存编辑状态下的焊接图标
    }
    this.operationCenter && this.operationCenter.setCurOperation(null);
    _clearTouchlayerClass.call(this);
    this.disableOperationCenter = false;
    switch (toolName) {
      case 'move':
        this.disableOperationCenter = true;
        this.swfDisp.setOperationType(OPERATION_SWF_TYPE.move);
        // this.$touchLayer.addClass('cursor-normal');
        break;
      case 'comment':
        this.swfDisp.setOperationType(OPERATION_SWF_TYPE.disassemble);
        this.operationCenter && this.operationCenter.setCurOperation('comment');
        // this.$touchLayer.addClass('cursor-hide');
        break;
      case 'penComment':
        this.disableOperationCenter = true;
        this.swfDisp.setOperationType(OPERATION_SWF_TYPE.penComment);
        this.operationCenter && this.operationCenter.setCurOperation('penComment');
        break;
      case 'zoomrect':
        this.disableOperationCenter = true;
        this.swfDisp.setOperationType(OPERATION_SWF_TYPE.zoomrect);
        // this.$touchLayer.addClass('cursor-ruler');
        break;
      case 'zoomout':
        this.disableOperationCenter = true;
        this.swfDisp.zoomOut();
        this.refreshObjsInEditor();
        break;
      case 'zoomfit':
        this.disableOperationCenter = true;
        this.swfDisp.zoomFit();
        this.refreshObjsInEditor();
        break;
      case 'zoomin':
        this.disableOperationCenter = true;
        this.swfDisp.zoomIn();
        this.refreshObjsInEditor();
        break;
      case 'graphic':
        this.disableOperationCenter = true;
        this.operationCenter && this.operationCenter.setCurOperation('graphic');
        this.swfDisp.setOperationType(OPERATION_SWF_TYPE.graphic);
        break;
    }
  },
  restoreHomeView: function restoreHomeView() {
    this.swfDisp.fitTheScreen();
  },
  removeFromSuperView: function removeFromSuperView() {
    if (this.loader) {
      this.loader.abort();
    }
    ;
    this.$swfRoot.remove();
    this.removed = true;
    this.swfDisp.release();
    _MDSWFPlayer["default"].setInstance(null);
    this.swfToolbar && this.swfToolbar.remove();
    this.swfToolbar = null;
    Dispatcher.off(null, null, this);
    var elementsCtl = _MMObjElementsController["default"].getSingleInstance();
    elementsCtl.removeAllDivsForEditor(this);
    if (this.editorMode != _EditorMode["default"].mark) {
      this.removeCommentPanel();
    }
  },
  getScale: function getScale() {
    return this.swfDisp.getScale();
  },
  setDispForVersion: function setDispForVersion(v) {
    console.error('TO DO');
  },
  showCommentLayer: function showCommentLayer() {
    console.error('TO DO');
  },
  hideCommentLayer: function hideCommentLayer() {
    console.error('TO DO');
  },
  getClassName: function getClassName() {
    return "MDSWFEditor";
  },
  getAssistantCanvas: function getAssistantCanvas() {
    return this.$touchLayer[0];
  },
  assistView2LogicPoint: function assistView2LogicPoint(dvPt) {
    return this.swfDisp.dev2log(dvPt.x, dvPt.y);
  },
  canShowZoomRectTool: function canShowZoomRectTool() {
    return false;
  },
  getObjsInView: function getObjsInView() {
    if (this.board) {
      var divObjs = this.board.getObjsInPageByFilter(0, this.divObjsFilter, this.mmPicObj.getExpandRect());
      var canvasObjs = this.board.getObjsInPageByFilter(0, this.canvasObjsFilter, this.mmPicObj.getExpandRect());
      for (var i = 0; i < canvasObjs.length; i++) {
        var obj = canvasObjs[i];
        var found = false;
        for (var k = 0; k < divObjs.length; k++) {
          var dvObj = divObjs[k];
          if (obj == dvObj) {
            found = true;
          }
          ;
        }
        ;
        if (!found) {
          divObjs.push(obj);
        }
        ;
      }
      ;
      return divObjs;
    } else {
      return [];
    }
  },
  getDivTransformer: function getDivTransformer() {
    return this;
  },
  getDivTransformerForAssist: function getDivTransformerForAssist() {
    return this;
  },
  getCanvasTransformer: function getCanvasTransformer() {
    return this;
  },
  getCanvasTransformerForAssist: function getCanvasTransformerForAssist() {
    return this;
  },
  _getScribbleContext: function _getScribbleContext() {
    var canvas = this.$scribbleLayer[0];
    var ctx = canvas.getContext('2d');
    return ctx;
  },
  getScriblleLayer: function getScriblleLayer() {
    return this.$scribbleLayer;
  },
  logic2AssistViewPoint: function logic2AssistViewPoint(pt) {
    return this.lg2dvPoint(pt);
  }
}, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_Object$assign, "assistView2LogicPoint", function assistView2LogicPoint(pt) {
  return this.dv2lgPoint(pt);
}), "lg2dvPoint", function lg2dvPoint(pt) {
  return this.swfDisp.log2dev(pt.x, pt.y);
}), "dv2lgPoint", function dv2lgPoint(pt) {
  return this.swfDisp.dev2log(pt.x, pt.y);
}), "lg2ContentDvPoints", function lg2ContentDvPoints(pts) {
  return this.lg2dvPoints(pts);
}), "convertPtsFromContent2Page", function convertPtsFromContent2Page(pts) {
  return pts;
}), "getCommentLayer", function getCommentLayer() {
  return this.$commentLayer[0];
}), "refreshLgPageInRect", function refreshLgPageInRect(lgRct) {
  // --- 重新刷新显示批注位置信息
  if (this.editorMode == _EditorMode["default"].mark) {
    _MMObjElementsController["default"].getSingleInstance().removeAllDivsForEditor(this);
  } else {
    var curTask = this.mmPicObj.getBoard();
    var trsfm = this.getDivTransformer();
    curTask.drawObjsInDiv(this, trsfm, 0, this.divObjsFilter, lgRct);
    var canvasTrsfm = this.getCanvasTransformer();
    var dvRect = null;
    if (!lgRct) {
      var canvas = this.$scribbleLayer[0];
      dvRect = new _MMRect["default"](0, canvas.width, canvas.height, 0);
    } else {
      dvRect = canvasTrsfm.lg2dvRect(lgRct, 0);
    }
    var ctx = this._getScribbleContext();
    ctx.clearRect(dvRect.left, dvRect.top, dvRect.getWidth(), dvRect.getHeight());
    curTask.drawObjsInCanvas(ctx, canvasTrsfm, 0, this.canvasObjsFilter, lgRct);

    // var geo_canvas = this._$scribbleLayer[0];
    // var geo_ctx = geo_canvas.getContext("2d");
    // curTask.drawCommentsInCanvas(geo_ctx, this.canvasTrsfm, i, this.canvasObjsFilter, lgRct);

    var penZoneCtl = this.editorViewCtl.getPenZoneCtl();
    penZoneCtl && penZoneCtl.refreshDisp();
  }
}), "restoreCenterPostion", function restoreCenterPostion() {
  console.error('TO DO');
}), "scrollToShowComment", function scrollToShowComment(div) {
  // console.error('TO DO')
  var scrollView = this.$editorLayer[0];
  var left = scrollView.scrollLeft;
  var top = scrollView.scrollTop;
  var divPos = MMCommonFun.getDivCenter(this.$editorLayer);
  var divX = parseInt($(div).css('left'));
  var divY = parseInt($(div).css('top'));
  if (divX > scrollView.offsetWidth || divX < 0 || divY > scrollView.offsetHeight || divY < 0) {
    var _x$y = {
        x: divPos.x - div.offsetLeft,
        y: divPos.y - div.offsetTop
      },
      x = _x$y.x,
      y = _x$y.y;
    this.swfDisp.moveFile(x, y);
    this.swfDisp.restorScribbleLayerPos();
    this.refreshObjsInEditor();
  }
}), "scrollToShowLgRct", function scrollToShowLgRct(lgRct, callback) {
  var lgCenter = lgRct.getCenter();
  var dvCenter = this.lg2dvPoint(lgCenter);
  var scrollView = this.$editorLayer[0];
  var divPos = MMCommonFun.getDivCenter(this.$editorLayer);
  var divX = dvCenter.x;
  var divY = dvCenter.y;
  var error = 100;
  if (divX > scrollView.offsetWidth - error || divX < error || divY > scrollView.offsetHeight - error || divY < error) {
    var _x$y2 = {
        x: divPos.x - divX,
        y: divPos.y - divY
      },
      x = _x$y2.x,
      y = _x$y2.y;
    this.swfDisp.moveFile(x, y);
    this.swfDisp.restorScribbleLayerPos();
  }
  this.refreshObjsInEditor();
  setBabelTimeout(function () {
    callback && callback();
  }, 100);
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_Object$assign, "refreshViewByCurrentMode", function refreshViewByCurrentMode() {
  _MDFileEditorInterface["default"].prototype.refreshViewByCurrentMode.call(this);
  if (this.editorMode == _EditorMode["default"].mark) {
    this.swfToolbar && this.swfToolbar.remove();
  }
}), "changeBackgroundColor", function changeBackgroundColor(colorname) {
  this.swfDisp.changeBackgroundColor(colorname);
}), "changeScale", function changeScale(scale, callback) {
  this.swfDisp.changeScale(scale);
  setBabelTimeout(function () {
    callback && callback();
  }, 100);
}), "getCenterRatioPosition", function getCenterRatioPosition() {
  return this.swfDisp.getCenterRatioPosition();
}), "restoreCenterPostion", function restoreCenterPostion(pos) {
  this.swfDisp.restoreCenterPostion(pos);
}), "getZoomScale", function getZoomScale() {
  return this.swfDisp.getZoomScale();
}), "showFocusRect", function showFocusRect(lgRect) {
  _MMCommonEditorView["default"].showFocusRect(this, lgRect);
}), "getContentLgRect", function getContentLgRect() {
  var picObj = this.getPicObject();
  return picObj.getLogicRect();
}), "getLgPageRect", function getLgPageRect() {
  return this.getContentLgRect();
}), "dv2ContentLgRect", function dv2ContentLgRect(rect) {
  var rctPts = rect.getCtrlPts(true);
  var tgPts = this.dv2lgPoints(rctPts);
  var lgRect = new _MMRect["default"]();
  lgRect.initWithPtsBounadingBox(tgPts);
  return lgRect;
})));
var _default = exports["default"] = MDSWFEditor;

},{"1084":1084,"1121":1121,"1123":1123,"1124":1124,"1180":1180,"1184":1184,"1451":1451,"1454":1454,"1466":1466,"49":49,"811":811,"831":831,"876":876,"877":877,"879":879,"880":880,"893":893,"904":904,"914":914,"949":949,"955":955}],1124:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDBasicToolbar = _interopRequireDefault(require(804));
var _MMBasicData = _interopRequireDefault(require(811));
// MDSWFToolbar.js
// jiang
// 2016-10-23

// import MDGraphicToolTabView from '../../moladisk/views/editor/graphictool/MDGraphicToolTabView.js'

var MDSWFToolbar = _MDBasicToolbar["default"].extend({
  el: '<div id="Toolbar3D" class="left-tool-panel Toolbar3D-container tool-bar"></div>',
  toolTmp: function toolTmp() {
    return '<li class="b-swf-move" data-tooltip="<%=BabelStr.str(31)%>" data-tooltip-dir="right">' + '<button class="icon ic-move p-move  button-li  f-pointer"></button>' + '</li>' + '<li class="b-swf-common" data-tooltip="<%=BabelStr.str(42)%>" data-tooltip-dir="right">' + '<button class="button-icon p-comment  button-li  f-pointer"></button>' + '</li>' + '<li class="b-pen-comment">' + '<button class="button-icon p-pen-comment  button-li  f-pointer"  data-tooltip="<%= BabelStr.getLocalString(787)%>"></button>' + '</li>' + '<li class="b-graphic-tool">' + '<button class="button-icon button-li p-graphic-tool f-pointer" tool-name="graphic" data-tooltip="<%=BabelStr.str(2741)%>"></button>' + '</li>' + '<li class="b-swf-zoomrect" data-tooltip="<%=BabelStr.str(2633)%>" data-tooltip-dir="right">' + '<button class="ic-zoomrect icon"></button>' + '</li>' + '<li class="b-swf-zoomout" data-tooltip="<%=BabelStr.str(2628)%>" data-tooltip-dir="right">' + '<button class="ic-zoomout icon"></button>' + '</li>' + '<li class="b-swf-zoomfit" data-tooltip="<%=BabelStr.str(2629)%>" data-tooltip-dir="right">' + '<button class="ic-zoomfit icon"></button>' + '</li>' + '<li class="b-swf-zoomin" data-tooltip="<%=BabelStr.str(2627)%>" data-tooltip-dir="right">' + '<button class="ic-zoomin icon"></button>' + '</li>';
  },
  // .toolbar-zoom .btn-zoomout
  initProps: function initProps() {
    var superP = _MDBasicToolbar["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      editor: null
    });
  },
  events: function events() {
    var superE = _MDBasicToolbar["default"].prototype.events.call(this);
    return _.extend(superE, {
      "click .b-swf-common": this._commonToolClicked,
      "click .b-swf-zoomout": this._zoomoutToolClicked,
      "click .b-swf-zoomfit": this._zoomfitToolClicked,
      "click .b-swf-zoomin": this._zoominClicked,
      "click .b-swf-zoomrect": this._zoomrectClicked,
      "click .b-swf-move": this._moveHandle,
      "click .p-pen-comment": this._penCommentClicked,
      "click .b-graphic-tool": this._graohicToolClicked
    });
  },
  initialize: function initialize(opt) {
    _MDBasicToolbar["default"].prototype.initialize.call(this, opt);
    this.maitainShow = false;
    // this.initWithDefaultTool();
    Dispatcher.on(MDEvents.Move_toolbar_clicked, this.initWithDefaultTool, this);
  },
  initWithDefaultTool: function initWithDefaultTool() {
    this._moveHandle();
  },
  _moveHandle: function _moveHandle() {
    this.setToolSelected(0);
    this.editor.toolChanged("move");
    Dispatcher.trigger(MDEvents.toolbarChanged, "move", this.editorViewCtl);
  },
  _commonToolClicked: function _commonToolClicked(e) {
    this.setToolSelected(1);
    this.editor.toolChanged('comment');
    Dispatcher.trigger(MDEvents.toolbarChanged, "comment", this.editorViewCtl);
  },
  _zoomrectClicked: function _zoomrectClicked(e) {
    this.setToolSelected(4);
    this.editor.toolChanged('zoomrect');
    Dispatcher.trigger(MDEvents.toolbarChanged, "zoomrect", this.editorViewCtl);
  },
  _graohicToolClicked: function _graohicToolClicked() {
    this.setToolSelected(3);
    this.editor.toolChanged('graphic');
    Dispatcher.trigger(MDEvents.toolbarChanged, "graphic", this.editorViewCtl);
  },
  removeChecked: function removeChecked() {
    this.editor.toolChanged(null);
  },
  _zoomoutToolClicked: function _zoomoutToolClicked(e) {
    this.clearSelect();
    this.editor.toolChanged('zoomout');
  },
  _zoomfitToolClicked: function _zoomfitToolClicked(e) {
    this.clearSelect();
    this.editor.toolChanged('zoomfit');
  },
  _zoominClicked: function _zoominClicked() {
    this.clearSelect();
    this.editor.toolChanged('zoomin');
  },
  removeFromSuperView: function removeFromSuperView() {
    _MDBasicToolbar["default"].prototype.removeFromSuperView.call(this);
    this.$el.remove();
    this.editor = null;
  },
  _toolClicked: function _toolClicked(e) {
    var selected = _MDBasicToolbar["default"].prototype._toolClicked.call(this, e);
    if ($(e.currentTarget).hasClass('p-pen-comment')) {
      if (selected) {
        var curTarget = e.currentTarget;
        var toolName = 'penComment';
        this.editor.toolChanged("penComment");
        Dispatcher.trigger(MDEvents.toolbarChanged, toolName, this.editorViewCtl);
      } else {
        this.editor.setCurOperation();
        Dispatcher.trigger(MDEvents.toolbarChanged, "", this.editorViewCtl);
        this.setToolSelected(0);
        this.editor.toolChanged("move");
      }
    }
    return selected;
  }
}, {
  className: 'MDSWFToolbar'
});
var _default = exports["default"] = MDSWFToolbar;

},{"1184":1184,"1454":1454,"804":804,"811":811}],1123:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1412);
require(1451);
require(1438);
require(1429);
require(1437);
require(1478);
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDGraphDrawer = _interopRequireDefault(require(806));
var _MMPoint = _interopRequireDefault(require(830));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
// MDSWFPlayer.js
// 2016-06-25

// import MD3DTool from '../controller/MD3DTool.js'
// import MD3DComment from '../data/MD3DComment.js'
// import MD3DCommentPosCalculator from '../controller/MD3DCommentPosCalculator.js'
// import MDNew3DCommentInputView from '../panel/MDNew3DCommentInputView.js'

// import MD3DCommentsController from '../controller/MD3DCommentsController'
// import swfobject from './swfobject.js'

/**
 *  控制显示 swf 文件
 *   1. 构建鼠标控制器
 *   4. 批注控制器
 *   5. 隐藏和显示对象
 */

var OPERATION_SWF_TYPE = {
  comment: "comment",
  disassemble: "disassemble",
  measure: "measure",
  zoomrect: "zoomrect",
  move: 'move',
  penComment: 'penComment',
  graphic: 'graphic'
};
var g_minMoveDistance = 5;
var g_swfid = Math.ceil(Math.random() * 1000);
var g_swfFlashLoadCallback = {};
function g_swfFlashLoadComplete(id) {
  var cb = g_swfFlashLoadCallback[id];
  if (cb) {
    delete g_swfFlashLoadCallback[id];
    cb();
  }
}
var g_swfFileLoadCallbacks = {};
function g_swfFileLoadComplete(id, result) {
  var cb = g_swfFileLoadCallbacks[id];
  if (cb) {
    delete g_swfFileLoadCallbacks[id];
    cb(result);
  }
}
window.g_swfFileLoadComplete = g_swfFileLoadComplete;
window.g_swfFlashLoadComplete = g_swfFlashLoadComplete;
window.OPERATION_SWF_TYPE = OPERATION_SWF_TYPE;
function MDSWFPlayer(divId, touchId, parentEditor) {
  this.editorViewCtl = parentEditor.editorViewCtl;
  this.refreshObjsInEditor = function () {
    parentEditor.refreshObjsInEditor();
  };
  // this.renderer = null;
  // this.camera = null;
  // this.scene = null;

  this.parentEditor = parentEditor;
  this.$container = $(parentEditor.parentDiv).find('#' + divId);
  this.$touchLayer = $(parentEditor.parentDiv).find('#' + touchId);
  this.$commentLayer = $(parentEditor.parentDiv).find('.comment-layer');
  this.$scribbleLayer = $(parentEditor.parentDiv).find('.scribble');
  this.objs3dHided = [];
  this.elementId = 'CADFileDisplayer_' + g_swfid;
  this.swfId = g_swfid;
  this.isFlashReady = false;
  g_swfid = (g_swfid + 1) % 1000000;
  var pageHost = document.location.protocol == "https:" ? "https://" : "http://";
  this.$flashDomPlaceHolder = "\n          <script type=\"text/javascript\">            \n            var swfVersionStr = \"11.1.0\";            \n            var xiSwfUrlStr = \"/cadFileDisplayer/playerProductInstall.swf\";\n            var flashvars = {\n                bridgeName: 'b_CADFileDisplayer',\n                id: '".concat(this.swfId, "'\n            };\n            var params = {};\n            params.quality = \"high\";\n            params.bgcolor = \"#ffffff\";\n            params.allowscriptaccess = \"sameDomain\";\n            params.allowfullscreen = \"true\";\n            params.wmode=\"opaque\";\n            var attributes = {};\n            attributes.id = \"").concat(this.elementId, "\";\n            attributes.name = \"CADFileDisplayer\";\n            attributes.align = \"middle\";\n            swfobject.embedSWF(\n                \"/cadFileDisplayer/CADFileDisplayer.swf\", \"flashContent\", \n                \"100%\", \"100%\", \n                swfVersionStr, xiSwfUrlStr, \n                flashvars, params, attributes);          \n            swfobject.createCSS(\"#flashContent\", \"display:block;text-align:center;\");\n            var pageHost = ((document.location.protocol == \"https:\") ? \"https://\" : \"http://\"); \n          \n          </script>\n          \n          <div id=\"flashContent\">\n            <a href='http://www.adobe.com/go/getflashplayer'><img src='").concat(pageHost, "www.adobe.com/images/shared/download_buttons/get_flash_player.gif' alt='Get Adobe Flash player' /></a>\n          </div>\n          <noscript>\n            <object classid=\"clsid:D27CDB6E-AE6D-11cf-96B8-444553540000\" width=\"100%\" height=\"100%\" id=\"").concat(this.elementId, "\">\n                <param name=\"movie\" value=\"/cadFileDisplayer/CADFileDisplayer.swf\" />\n                <param name=\"quality\" value=\"high\" />\n                <param name=\"bgcolor\" value=\"#ffffff\" />\n                <param name=\"allowScriptAccess\" value=\"sameDomain\" />\n                <param name=\"allowFullScreen\" value=\"true\" />\n                <!--[if !IE]>-->\n                <object type=\"application/x-shockwave-flash\" data=\"/cadFileDisplayer/CADFileDisplayer.swf\" width=\"100%\" height=\"100%\">\n                    <param name=\"quality\" value=\"high\" />\n                    <param name=\"bgcolor\" value=\"#ffffff\" />\n                    <param name=\"allowScriptAccess\" value=\"sameDomain\" />\n                    <param name=\"allowFullScreen\" value=\"true\" />\n                <!--<![endif]-->\n                <!--[if gte IE 6]>-->\n                    <p> \n                        Either scripts and active content are not permitted to run or Adobe Flash Player version\n                        11.1.0 or greater is not installed.\n                    </p>\n                <!--<![endif]-->\n                    <a href=\"http://www.adobe.com/go/getflashplayer\">\n                        <img src=\"http://www.adobe.com/images/shared/download_buttons/get_flash_player.gif\" alt=\"Get Adobe Flash Player\" />\n                    </a>\n                <!--[if !IE]>-->\n                </object>\n                <!--<![endif]-->\n            </object>\n          </noscript>\n   ");
  this.init();
}
MDSWFPlayer.getInstance = function () {
  return MDSWFPlayer.instance;
};
MDSWFPlayer.setInstance = function (instance) {
  MDSWFPlayer.instance = instance;
};
Object.assign(MDSWFPlayer.prototype, Object, function () {
  //  private function
  // *********************************************************************************************

  function _initEvents() {
    var self = this;

    //------------------------------------------------------ mouse wheel

    this.$touchLayer.bind("mousewheel", function (event) {
      self.refreshDiv();
    });

    //------------------------------------------------------ mouse click

    this.$touchLayer.bind("click", function (event) {});

    //------------------------------------------------------ mouse drag
    this.$touchLayer.bind("mousedown", function (event) {
      // console.log('mouse down!');
      if (event.target == self.$touchLayer[0]) {
        self.down = true;
        self.mouseDownCaptured = true;
        var x = event.clientX;
        var y = event.clientY;
        var p = MMCommonFun.convertPointBetweenElements($('body')[0], self.$touchLayer[0], {
          x: x,
          y: y
        });
        self.translate = {
          x: p.x,
          y: p.y
        };
        self.startPt = p;
        switch (self.operationType) {
          case OPERATION_SWF_TYPE.zoomrect:
            self.graphDrawer = new _MDGraphDrawer["default"](self.$touchLayer[0], 'rectComment');
            self.graphDrawer.mouseDown(p.x, p.y);
            self.lengthFromStart = 0;
            break;
          case OPERATION_SWF_TYPE.move:
            self.canvasLeft = self.$scribbleLayer[0].offsetLeft;
            self.canvasTop = self.$scribbleLayer[0].offsetTop;
            break;
        }
        // self.hasPanelShow = self.removeAllPanels();
      }
      ;
    });
    this.$touchLayer.bind("mousemove", function (event) {
      if (event.target == self.$touchLayer[0]) {
        self.checkToEnableMouseWheel();
        var curMouse = {
          x: event.offsetX,
          y: event.offsetY
        };

        // console.log(curMouse)
        if (self.down) {
          console.log('draging');

          // self.translate.x += curMouse.x - self.preMouse.x;
          // self.translate.y += curMouse.y - self.preMouse.y;

          var x = event.clientX;
          var y = event.clientY;
          var p = MMCommonFun.convertPointBetweenElements($('body')[0], self.$touchLayer[0], {
            x: x,
            y: y
          });
          var focusPoint = p;
          x = p.x - self.translate.x;
          y = p.y - self.translate.y;
          self.translate = {
            x: p.x,
            y: p.y
          };
          switch (self.operationType) {
            case OPERATION_SWF_TYPE.zoomrect:
              if (self.graphDrawer) {
                focusPoint = self.graphDrawer.mouseMove(p.x, p.y);
                self.curRct = null;
              }
              ;
              break;
            case OPERATION_SWF_TYPE.move:
              self.parentEditor.removeAllDivsForEditor(self.parentEditor);
              self.moveFile(x, y);
          }

          // self.refreshDiv();
        }
        ;

        // self.currentTool.mouseMove(curMouse);
      }
      ;
    });
    this.$touchLayer.bind("mouseup", function (event) {
      var zoomRected = false;
      if (event.target == self.$touchLayer[0]) {
        switch (self.operationType) {
          case OPERATION_SWF_TYPE.zoomrect:
            var x = event.clientX;
            var y = event.clientY;
            var p = MMCommonFun.convertPointBetweenElements($('body')[0], self.$touchLayer[0], {
              x: x,
              y: y
            });
            self.lengthFromStart = Math.sqrt((self.startPt.x - p.x) * (self.startPt.x - p.x) + (self.startPt.y - p.y) * (self.startPt.y - p.y));
            if (self.lengthFromStart < g_minMoveDistance) {
              self.mouseDownCaptured = false;
              self.graphDrawer = null;
              // self.clearPanel();
              return;
            }
            ;
            if (self.mouseDownCaptured) {
              var obj = {
                x: self.startPt.x,
                y: self.startPt.y,
                width: p.x - self.startPt.x,
                height: p.y - self.startPt.y
              };
              // { x, y, width, height } 
              self.zoomRect(obj);
              // self._createComment(p.x, p.y);

              zoomRected = true;
            }
            ;
            self.mouseDownCaptured = false;
            var c = self.$touchLayer[0];
            var ctx = c.getContext("2d");
            ctx.clearRect(0, 0, c.offsetWidth, c.offsetHeight);
            self.curRct = null;
            self.graphDrawer = null;
            Dispatcher.trigger(MDEvents.Move_toolbar_clicked);
            break;
        }
        if (self.operationType == OPERATION_SWF_TYPE.openComment) {} else if (self.operationType == OPERATION_SWF_TYPE.move) {
          self.restorScribbleLayerPos();
          self.refreshObjsInEditor();
        } else if (zoomRected) {
          self.refreshObjsInEditor();
        }

        // console.log('mouse up!');
        // if (Math.abs(self.translate.x) + Math.abs(self.translate.y) < 5) {
        //   var delta = 0;
        //   var dvPos = {
        //     x: event.offsetX,
        //     y: event.offsetY
        //   }
        //   if (!self.hasPanelShow) {

        //     setBabelTimeout(function() {

        //       // self.currentTool.mouseClick(dvPos);

        //       // switch(self.operationType){

        //       //   case OPERATION_SWF_TYPE.comment:

        //       //     _create3DCommentAtScreen.call(self, dvPos);
        //       //     self.refreshDiv();
        //       //     break;

        //       //   case OPERATION_SWF_TYPE.disassemble:

        //       //     _disassembleToolClicked.call(self, dvPos);
        //       //    break;

        //       //   case OPERATION_SWF_TYPE.measure:

        //           self.currentTool.mouseClick(dvPos);
        //       // }

        //     }, 1);
        //   };

        // };
        self.hasPanelShow = false;
        self.down = false;
      }
      ;
    });
    $('body').bind("mouseup", function (event) {
      // console.log('mouse up!');
      self.down = false;
    });
    Dispatcher.on(MDEvents.Enable3DWheel, function () {
      self.checkToEnableMouseWheel();
    });
    Dispatcher.on(MDEvents.Disable3DWheel, function () {
      self.enableMouseWheel(false);
    });
  }
  ;

  //  public function
  // ****************************************************************************************************

  return {
    // 注意：此函数内不能再添加创建任何 THREE JS 对象！！！，否则会影响旧文档读出的 THREE JS 对象的序号
    // 如果需要添加辅助对象或者灯光等等，请在函数 createOtherAssistObjs 中添加
    //
    init: function init() {
      var _this = this;
      var width = this.$container.width();
      var height = this.$container.height();
      _initEvents.call(this);
      g_swfFlashLoadCallback[this.swfId] = function () {
        console.log(3333);
        _this.isFlashReady = true;
        if (_this.onReady) {
          _this.onReady();
          _this.onReady = undefined;
        }
      };
      this.$container.html(this.$flashDomPlaceHolder);
      if (MMCommonFun.isSupportFlash()) {
        // this.$commentLayer.show();
        // this.$touchLayer.show();
        // this.$scribbleLayer.show();
        // MDSpinnerloaderView.showIn(this.$container.parent());  
      } else {
        // this.$touchLayer.hide();
      }
      this.paused = false;

      // this.posCalculator = new MD3DCommentPosCalculator(this.$container.width(), this.$container.height(), this.camera);

      // this.commentsCtl = new MD3DCommentsController(this.$touchLayer, this.scene, this.camera, this);

      // setTimeout(()=>{
      //   this.loadswf_url('http://localhost:8080/cadFileDisplayer/jiami1.swf', '8648c6a0');
      // }, 4000)

      this.setOperationType(OPERATION_SWF_TYPE.comment);
      this.swfobject = document.getElementById(this.elementId);
    },
    // init
    setDispForVersion: function setDispForVersion(version) {},
    restorScribbleLayerPos: function restorScribbleLayerPos() {
      this.$scribbleLayer.css('left', '0px');
      this.$scribbleLayer.css('top', '0px');
    },
    fitTheScreen: function fitTheScreen() {
      if (!this.boundingSphere) {
        return;
      }
      ;
      this.camera.up.set(0, 0, 1);
      var radius = this.boundingSphere.radius;
      var center = this.boundingSphere.center.clone();
      this.scene.trackballCtl.target = center;
    },
    // fitTheScreen

    refreshDiv: function refreshDiv() {
      if (this.commentsCtl) {
        this.commentsCtl.refreshDivs();
      }
      ;

      // if (this.currentTool) {
      // this.currentTool.refreshDisp();
      // };
    },
    // refreshDiv

    logicToDevice: function logicToDevice(pos) {
      var renderer = this.renderer;
      var widthHalf = 0.5 * renderer.context.canvas.width;
      var heightHalf = 0.5 * renderer.context.canvas.height;
      var camera = this.camera;
      var vector = pos.clone();
      vector.project(camera);
      vector.x = vector.x * widthHalf + widthHalf;
      vector.y = -(vector.y * heightHalf) + heightHalf;
      return {
        x: vector.x,
        y: vector.y
      };
    },
    // logicToDevice

    deviceToLogic: function deviceToLogic(dvPos) {
      var vector = new THREE.Vector3();
      vector.set(dvPos.x / this.$touchLayer.width() * 2 - 1, -(dvPos.y / this.$touchLayer.height()) * 2 + 1, 0.5);
      vector.unproject(this.camera);
      // var dir = vector.sub(this.camera.position).normalize();
      // var distance = - this.camera.position.z / dir.z;
      // var position = this.camera.position.clone().add(dir.multiplyScalar(distance));
      // console.log("x: " + position.x + " y: " + position.y);
      var position = vector;
      return new THREE.Vector3(position.x, position.y, position.z);
    },
    // deviceToLogic = function(dvPos)

    removeAllPanels: function removeAllPanels() {
      var hasPanelShow = false;

      // if (this.currentTool) {

      // this.currentTool.clearPanel();

      // };

      // return this.commentsCtl.removeCommentPanel() || hasPanelShow;
    },
    // removeAllPanels = function()

    release: function release() {
      this.$touchLayer.off();
      this.paused = true;
      this.parentEditor = null;

      // this.trackballController.removeEventListener('change');

      // this.trackballController.dispose();

      // this.commentsCtl.clearMemory();

      // if (this.currentTool) {
      // this.currentTool.clear();
      // };

      Dispatcher.off(MDEvents.Enable3DWheel);
      Dispatcher.off(MDEvents.Disable3DWheel);
    },
    // release = function()

    refreshSize: function refreshSize() {
      var winW = this.$container.width();
      var winH = this.$container.height();
      this.$touchLayer[0].width = winW;
      this.$touchLayer[0].height = winH;
      this.swfobject && this.swfobject.js_refreshSize && this.swfobject.js_refreshSize();
    },
    // refreshSize = function()

    enableMouseWheel: function enableMouseWheel(enable) {
      // if (!this.trackballController) {
      //   return;
      // };
      // this.trackballController.enabled = enable;
    },
    checkToEnableMouseWheel: function checkToEnableMouseWheel() {

      // if (!this.trackballController.enabled) {

      //   this.enableMouseWheel(true);

      // };
    },
    setCommentsFile: function setCommentsFile(commentsFile) {
      this.commentsFile = commentsFile;
      if (this.commentsCtl) {
        this.commentsCtl.setCommentsFile(commentsFile);
      }
      ;
    },
    focusComment: function focusComment(comment) {

      // this.commentsCtl.focusComment(comment);
    },
    readCommentsFromFile: function readCommentsFromFile(callback) {
      if (this.commentsCtl) {
        this.commentsCtl.readCommentsFromFile(callback);
      } else {
        if (callback) {
          callback();
        }
        ;
      }
    },
    setOperationType: function setOperationType(type) {
      this.operationType = type;

      // if (this.currentTool) {

      // this.currentTool.clear();
      // this.currentTool = null;

      // };

      if (this.scene) {
        this.scene.remove(this.interGeo);
      } else {
        return;
      }
      switch (type) {
        case OPERATION_SWF_TYPE.comment:
          this.enableMouseWheel(true);
          // this.currentTool = new MD3DTool.MD3DCommentController(this.$touchLayer, this.scene, this.camera, this);

          break;
        case OPERATION_SWF_TYPE.disassemble:
          this.enableMouseWheel(true);
          // this.currentTool = new MD3DTool.MD3DDisassembleController(this.$touchLayer, this.scene, this.camera, this);
          // this.showAllHided3dObjs();
          break;
        case OPERATION_SWF_TYPE.measure:
          this.enableMouseWheel(true);
          this.currentTool = new MD3DTool.MD3DMeasureController(this.$touchLayer, this.scene, this.camera, this);
          break;
      }
      // this.currentTool.editorViewCtl = this.editorViewCtl;
    },
    loadBabelFile: function loadBabelFile(url, fileInfo, ver, onLoadCallback) {
      var _this2 = this;
      var onReady = function onReady() {
        var password = fileInfo.getPassowrdByVersion(ver) || '';
        password = password.slice(0, 8);

        // 获取原下载url
        if (g_swfFileLoadCallbacks[_this2.swfId]) {
          console.error('alread has a callback');
        }
        g_swfFileLoadCallbacks[_this2.swfId] = function () {
          _MDSpinnerloaderView["default"].clearFrom(_this2.$container.parent());
          onLoadCallback();
        };
        var watermarkInfo = fileInfo.get('watermarkInfo');
        /*
        if (watermarkInfo.watermarkType == 2) {
          MMNetDiskDataController.downLoadFileData(watermarkInfo.url, (data) => {
            data = new Uint8Array(data);
            const str = this.uint8ToString(data);
            watermarkInfo.imageData = str;
            this.setWatermarkConfig(watermarkInfo);
          });
        } else {
          this.setWatermarkConfig(watermarkInfo);
        }
        */
        if (watermarkInfo.watermarkType === 2 || watermarkInfo.watermarkType === 3) {
          watermarkInfo.watermarkWord = app.currentUser.get('name');
        }
        _this2.setWatermarkConfig(watermarkInfo);
        _this2.swfobject.js_loadswf_url(url, password);
        _this2.$commentLayer.show();
        _this2.$touchLayer.show();
        _this2.$scribbleLayer.show();
        _MDSpinnerloaderView["default"].showIn(_this2.$container.parent());
      };
      if (this.isFlashReady) {
        onReady();
      } else {
        this.onReady = onReady;
      }
    },
    loadswf_url: function loadswf_url(url, password) {
      this.swfobject.js_loadswf_url(url, password);
    },
    dev2log: function dev2log(x, y) {
      var pt = this.swfobject.js_dev2log({
        x: x,
        y: y
      });
      return new _MMPoint["default"](pt.x, pt.y);
    },
    getScale: function getScale() {
      if (this.swfobject.js_getScale) {
        return this.swfobject.js_getScale();
      }
      return 1;
    },
    log2dev: function log2dev(x, y) {
      if (!this.swfobject) {
        return;
      }
      var pt = this.swfobject.js_log2dev({
        x: x,
        y: y
      });
      return new _MMPoint["default"](pt.x, pt.y);
    },
    moveFile: function moveFile(x, y) {
      console.log(x, y);
      var moved = this.swfobject.js_moveFile(x, y);
      var canvas = this.$scribbleLayer[0];
      var left = canvas.offsetLeft + moved.x;
      var top = canvas.offsetTop + moved.y;
      this.$scribbleLayer.css('left', left + 'px');
      this.$scribbleLayer.css('top', top + 'px');
      return moved;
    },
    getFitScale: function getFitScale() {
      return this.swfobject.js_getFitScale();
    },
    zoomIn: function zoomIn() {
      console.log('zoomin');
      return this.swfobject.js_zoomIn();
    },
    zoomOut: function zoomOut() {
      console.log('zoomout');
      return this.swfobject.js_zoomOut();
    },
    zoomFit: function zoomFit() {
      return this.swfobject.js_zoomFit();
    },
    changeBackgroundColor: function changeBackgroundColor(colorName) {
      this.swfobject.js_changeBackgroundColor(colorName);
    },
    /**
     * @param {object} rect - { x, y, width, height } 
     */
    zoomRect: function zoomRect(rect) {
      console.warn(rect);
      return this.swfobject.js_zoomRect(rect);
    },
    setWatermarkConfig: function setWatermarkConfig(config) {
      return this.swfobject.js_setWatermarkConfig(config);
    },
    uint8ToString: function uint8ToString(arr) {
      var r = '';
      for (var i = 0; i < arr.length; i++) {
        var v = arr[i];
        var b = v.toString(16);
        if (b.length === 1) {
          r += '0' + b;
        } else {
          r += b;
        }
      }
      return r;
    },
    changeScale: function changeScale(scale, callback) {
      this.swfobject && _.isFunction(this.swfobject.js_changeScale) && this.swfobject.js_changeScale(scale);
    },
    getZoomScale: function getZoomScale() {
      return this.swfobject.js_getZoomScale();
    },
    getCenterRatioPosition: function getCenterRatioPosition() {
      return this.swfobject.js_getCenterRatioPosition();
    },
    restoreCenterPostion: function restoreCenterPostion(pos) {
      this.swfobject.js_restoreCenterPostion(pos);
    }
  };
}());
var _default = exports["default"] = MDSWFPlayer;

},{"1104":1104,"1184":1184,"1412":1412,"1417":1417,"1429":1429,"1437":1437,"1438":1438,"1451":1451,"1454":1454,"1463":1463,"1478":1478,"76":76,"806":806,"830":830}],1121:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1451);
var _EditorMode = _interopRequireDefault(require(904));
var _MMObjectFilter = _interopRequireDefault(require(955));
var _FilterType = _interopRequireDefault(require(949));
var _ObjType = _interopRequireDefault(require(1084));
var _MMBasicData = _interopRequireDefault(require(811));
var _MMObjElementsController = _interopRequireDefault(require(893));
var _MDCommentSlidePanelView = _interopRequireDefault(require(319));
var _MMEditorScroller = _interopRequireDefault(require(907));
var _MDColorDisk = _interopRequireDefault(require(856));
var _MDLineWidthAndFont = _interopRequireDefault(require(861));
var _MDMarkerObjDrawerController = _interopRequireDefault(require(909));
var _MMRect = _interopRequireDefault(require(831));
var _MMPoint = _interopRequireDefault(require(830));
var _MDPenToolbar = _interopRequireDefault(require(427));
var _size = _interopRequireDefault(require(837));
/**
 * javascript/swf-player/editor/MDFileEditorInterface.js
 * jiang
 * 2018-8-8
 */

var MDFileEditorInterface = function MDFileEditorInterface(parentDiv, opt) {
  this.parentDiv = parentDiv;
  this.$parentDiv = $(this.parentDiv);
  this.editorViewCtl = opt.editorViewCtl;
  this.divObjsFilter = new _MMObjectFilter["default"]();
  this.divObjsFilter.type = _FilterType["default"].Include;
  this.divObjsFilter.objTypes.push(_ObjType["default"].Obj_comment);
  this.divObjsFilter.objTypes.push(_ObjType["default"].Obj_niceTag);
  this.divObjsFilter.objTypes.push(_ObjType["default"].Obj_graphComment);
  this.canvasObjsFilter = new _MMObjectFilter["default"]();
  this.canvasObjsFilter.type = _FilterType["default"].Include;
  this.canvasObjsFilter.objTypes = _ObjType["default"].getCanvasObjType();
  this.scale = 1.0; // 
};
Object.assign(MDFileEditorInterface.prototype, {
  contstructor: MDFileEditorInterface,
  setImgMarkerCtl: function setImgMarkerCtl(imgMarkerCtl) {
    this.imgMarkerCtl = imgMarkerCtl;
  },
  setMode: function setMode(mode) {
    if (this.editorMode != mode) {
      this.editorMode = mode;
      this.refreshViewByCurrentMode();
    }
  },
  refreshViewByCurrentMode: function refreshViewByCurrentMode() {
    if (this.editorMode == _EditorMode["default"].mark) {
      this.canvasObjsFilter.moveObjType(_ObjType["default"].Obj_textComment);
      this.canvasObjsFilter.moveObjType(_ObjType["default"].GObj_text);
      this.canvasObjsFilter.moveObjType(_ObjType["default"].Obj_graphComment);
    }
  },
  getCommentStartlayerZ_index: function getCommentStartlayerZ_index() {
    return _MMBasicData["default"].getO2OCommentStartlayerZ_index();
  },
  getDivByObj: function getDivByObj(commentObj) {
    var elementsCtl = _MMObjElementsController["default"].getSingleInstance();
    var element = null;
    if (commentObj) {
      element = elementsCtl.getDivByObj(this, commentObj);
    }
    return element;
  },
  getCommentsDivs: function getCommentsDivs() {
    var elementsCtl = _MMObjElementsController["default"].getSingleInstance();
    var commentDivs = elementsCtl.getCommentsDivs(this);
    return commentDivs;
  },
  getCurrentBoard: function getCurrentBoard() {
    return this.mmPicObj.getBoard();
  },
  getCurrentFilePageIndex: function getCurrentFilePageIndex() {
    return 0;
  },
  getPicObject: function getPicObject() {
    return this.mmPicObj;
  },
  convertPointFromEditor2AssistView: function convertPointFromEditor2AssistView(dvPt) {
    return dvPt;
  },
  getCenterRatioPosition: function getCenterRatioPosition() {
    return {
      x: 0.5,
      y: 0.5
    };
  },
  showCommentPanel: function showCommentPanel(mmobj, div) {
    if (!app.canDispInNormalBrowser()) {
      this.showCommentPanelForMobile(mmobj, div);
    } else {
      this.showCommentPanelForPC(mmobj, div);
    }
  },
  showCommentPanelForMobile: function showCommentPanelForMobile(mmobj, div) {
    var center = MMCommonFun.getDivCenter($(div));
    var posInBody = MMCommonFun.convertPointBetweenElements(div, $("body")[0], center);
    var self = this;
    var handle = MDFileEditorInterface.getPanelVariable();
    if (!handle.panel) {
      handle.panel = new _MDCommentSlidePanelView["default"]({
        comment: mmobj,
        view: this.m_editor,
        editorViewCtl: this.editorViewCtl,
        imgMarkerCtl: self.imgMarkerCtl,
        onCloseBtnClicked: function onCloseBtnClicked() {
          _MMObjElementsController["default"].commentPointUpdater.updateCommentView(mmobj, "readed");
          handle.panel.removeFromSuperView();
          handle.panel = null;
        },
        onRemove: function onRemove() {
          handle.panel = null;
        }
      });
      application.addSubView(handle.panel);
      handle.panel.centerZoomShowForMobile(posInBody);
    }
  },
  showCommentPanelForPC: function showCommentPanelForPC(mmobj, div) {
    var self = this;
    self.commentDiv = div;
    self.commentObj = mmobj;
    var handle = MDFileEditorInterface.getPanelVariable();
    if (mmobj && handle.panel && handle.panel._comment === mmobj) {
      return;
    }
    console.assert(mmobj.m_objType === _ObjType["default"].Obj_comment);
    if (!this.scroller) {
      this.scroller = new _MMEditorScroller["default"](this);
    }
    ;
    this.scrollToShowComment(div);
    setBabelTimeout(function () {
      if (handle.panel) {
        handle.panel.removeFromSuperView();
        handle.panel = null;
      }
      if (!handle.panel) {
        handle.panel = new _MDCommentSlidePanelView["default"]({
          view: self,
          editorViewCtl: self.editorViewCtl,
          comment: mmobj,
          enableDraggable: true,
          imgMarkerCtl: self.imgMarkerCtl,
          onDrag: function onDrag() {
            self.editorViewCtl.showCommentLine();
          },
          onCloseBtnClicked: function onCloseBtnClicked() {
            self.removeCommentPanel();
            self.removeCommentLine();
          },
          onRemove: function onRemove() {
            handle.panel = null;
            var mainEditor = self.editorViewCtl;
            mainEditor && mainEditor.checkToEnablePrivateMouseWheel();
          },
          onOpen: function onOpen() {
            self.showCommentLine();
          }
        });
      } else {
        handle.panel.update({
          comment: mmobj
        });
      }
      app.application.addSubView(handle.panel);
      var startOffset = $(self.commentDiv).offset();
      handle.panel.saveEditorScaleAndPosition();

      // handle.panel.zoomShow({
      //   'y': startOffset.top,
      //   'x': startOffset.left
      // }, function() {
      //   self.editorViewCtl && self.editorViewCtl.showCommentLine();
      // });

      // Dispatcher.trigger(MDEvents.Comment_State_Sync, self.getCurrentBoard().fileInfo.getFileId(), mmobj);
    }, 200);
  },
  getCommentPanelLeftTop: function getCommentPanelLeftTop(comment) {
    var lgPos = comment.getPos();
    var trsfm = this.getDivTransformer();
    var dvPos = trsfm.lg2dvPoint(lgPos, 0);
    var commentLayer = this.getCommentLayer();
    var pos = MMCommonFun.convertPointBetweenElements(commentLayer, $('body')[0], dvPos);
    return pos;
  },
  removeAllDivsForEditor: function removeAllDivsForEditor(editor) {
    var elementsCtl = _MMObjElementsController["default"].getSingleInstance();
    elementsCtl.removeAllDivsForEditor(editor);
  },
  removeCommentPanel: function removeCommentPanel() {
    var handle = MDFileEditorInterface.getPanelVariable();
    if (handle.panel) {
      if (handle.panel.superView) {
        handle.panel.removeFromSuperView();
      }
      handle.panel = null;
      _MMObjElementsController["default"].commentPointUpdater.updateCommentView(this.commentObj, "readed");
      this.scroller = null;
      this.commentObj = null;
      this.commentDiv = null;
      this.clearCommentCanvas();
    }
  },
  showCommentLine: function showCommentLine() {},
  clearCommentCanvas: function clearCommentCanvas() {},
  removeCommentLine: function removeCommentLine() {},
  clearContent: function clearContent() {
    if (!this.$root) {
      return;
    }
    ;

    // 1. clear canvas
    var geo_canvas = this.$scribbleLayer[0];
    if (geo_canvas) {
      var w = this.$scribbleLayer.width();
      var h = this.$scribbleLayer.height();
      var ctx = geo_canvas.getContext('2d');
      ctx.clearRect(0, 0, w, h);
    }
    ;

    // 2. clear div
    _MMObjElementsController["default"].getSingleInstance().removeAllDivsForEditor(this);
  },
  setScrollable: function setScrollable(canScroll) {
    this.canScroll = canScroll;
  },
  setCurOperation: function setCurOperation(oper_, objs_, comm_) {
    if (this.operationCenter) {
      // oper_ = "arrowComment";   // ------------- test
      this.operationCenter.setCurOperation(oper_, objs_, comm_);
    }
    this.curOp = oper_;
  },
  getCurOperation: function getCurOperation() {
    return this.operationCenter.getCurOperation();
  },
  drawPathInOpLayer: function drawPathInOpLayer(pathLGPoints) {
    if (!pathLGPoints) {
      return;
    }
    ;
    var ctx = this.$touchLayer[0].getContext('2d');
    this.clearOpLayer();

    // ctx.fillStyle = 'rgba(255,0,0,0.5)';
    // ctx.fillRect(0, 0, 100, 100);

    if (pathLGPoints[0]) {
      ctx.beginPath();
      var op = this.getCurOperation();
      if (op.toolName && op.toolName == "penComment") {
        ctx.strokeStyle = _MDPenToolbar["default"].getColor();
        ctx.lineWidth = _MDPenToolbar["default"].getLineWidth();
      } else {
        ctx.strokeStyle = _MDColorDisk["default"].getCurColor();
        ctx.lineWidth = _MDLineWidthAndFont["default"].getCurLineWidth();
      }
      var devicePoint = this.getDivTransformer().lg2dvPoint(pathLGPoints[0], this.mmPicObj.getPageIndex());
      devicePoint = this.convertPointFromEditor2AssistView(devicePoint);
      ctx.moveTo(devicePoint.x, devicePoint.y);
      for (var i = 0; i < pathLGPoints.length; i++) {
        devicePoint = this.getDivTransformer().lg2dvPoint(pathLGPoints[i], this.mmPicObj.getPageIndex());
        devicePoint = this.convertPointFromEditor2AssistView(devicePoint);
        ctx.lineTo(devicePoint.x, devicePoint.y);
      }
      ctx.stroke();
    }
  },
  clearOpLayer: function clearOpLayer() {
    var ctx = this.$touchLayer[0].getContext('2d');
    ctx.clearRect(0, 0, this.$touchLayer.width(), this.$touchLayer.height());
  },
  drawMarkerObjsInCanvas: function drawMarkerObjsInCanvas(objects) {
    _MDMarkerObjDrawerController["default"].drawMarkerObjs(this, objects, this.markEditable);
  },
  scale2drawMarkerObjsInCanvas: function scale2drawMarkerObjsInCanvas(objects, callback) {
    _MDMarkerObjDrawerController["default"].scale2drawMarkerObjs(this, objects, this.markEditable, callback);
  },
  getScrollContent: function getScrollContent() {
    return this.$editorLayer[0];
  },
  // ---------------------------------------------------------------------------------   坐标转换
  getDispRectInContentForObj: function getDispRectInContentForObj(lgObj) {
    var lgRect = lgObj.getRect();
    var dvRect = this.lg2ContentDvRect(lgRect);
    return dvRect;
  },
  lg2ContentDvRect: function lg2ContentDvRect(rect) {
    var rctPts = rect.getCtrlPts(true);
    var tgPts = this.lg2ContentDvPoints(rctPts);
    var dvRect = new _MMRect["default"]();
    dvRect.initWithPtsBounadingBox(tgPts);
    return dvRect;
  },
  dv2lgPoints: function dv2lgPoints(dvPts) {
    var lgPts = [];
    for (var i = 0; i < dvPts.length; i++) {
      var pt = dvPts[i];
      lgPts.push(this.dv2lgPoint(pt));
    }
    return lgPts;
  },
  lg2dvPoints: function lg2dvPoints(pts) {
    var dvPts = [];
    for (var i = 0; i < pts.length; i++) {
      var pt = pts[i];
      dvPts.push(this.lg2dvPoint(pt));
    }
    return dvPts;
  },
  lg2dvRect: function lg2dvRect(src_rect) {
    var tg_rect = new _MMRect["default"]();
    var src_lefttop = new _MMPoint["default"](src_rect.left, src_rect.top);
    var src_rightbottom = new _MMPoint["default"](src_rect.right, src_rect.bottom);
    var tg_lefttop = this.lg2dvPoint(src_lefttop);
    var tg_rightbottom = this.lg2dvPoint(src_rightbottom);
    tg_rect.left = Math.min(tg_lefttop.x, tg_rightbottom.x);
    tg_rect.top = Math.min(tg_lefttop.y, tg_rightbottom.y);
    ;
    tg_rect.right = Math.max(tg_rightbottom.x, tg_lefttop.x);
    tg_rect.bottom = Math.max(tg_rightbottom.y, tg_lefttop.y);
    return tg_rect;
  },
  dv2lgRect: function dv2lgRect(rect) {
    var dvPt0 = new _MMPoint["default"](rect.left, rect.top);
    var dvPt1 = new _MMPoint["default"](rect.right, rect.bottom);
    var lgP0 = this.dv2lgPoint(dvPt0);
    var lgP1 = this.dv2lgPoint(dvPt1);
    var lgRct = new _MMRect["default"]();
    lgRct.initWith2Pts(lgP0, lgP1);
    return lgRct;
  },
  dv2lgLen: function dv2lgLen(dvLen) {
    var p0 = {
      x: 0,
      y: 0
    };
    var p1 = {
      x: 0,
      y: dvLen
    };
    var lgP0 = this.dv2lgPoint(p0);
    var lgP1 = this.dv2lgPoint(p1);
    var len = Math.sqrt((lgP0.x - lgP1.x) * (lgP0.x - lgP1.x) + (lgP0.y - lgP1.y) * (lgP0.y - lgP1.y));
    if (dvLen < 0) {
      len = -len;
    }
    return len;
  },
  lg2dvLen: function lg2dvLen(lgLen) {
    var p0 = {
      x: 0,
      y: 0
    };
    var p1 = {
      x: 0,
      y: lgLen
    };
    var dvP0 = this.lg2dvPoint(p0);
    var dvP1 = this.lg2dvPoint(p1);
    var len = Math.sqrt((dvP0.x - dvP1.x) * (dvP0.x - dvP1.x) + (dvP0.y - dvP1.y) * (dvP0.y - dvP1.y));
    if (lgLen < 0) {
      len = -len;
    }
    return len;
  },
  lg2dvVec: function lg2dvVec(vec) {
    return new _MMPoint["default"](this.lg2dvLen(vec.x), this.lg2dvLen(vec.y));
  },
  contentDv2LgPoints: function contentDv2LgPoints(pts) {
    var lgPts = this.dv2lgPoints(pts);
    return lgPts;
  },
  getDispStartEndPtsInContentForObj: function getDispStartEndPtsInContentForObj(lgObj) {
    var lgPts = lgObj.getLogicPts();
    var dvPts = this.lg2ContentDvPoints(lgPts);
    var startEndPts = [dvPts[0], dvPts[dvPts.length - 1]];
    return startEndPts;
  },
  getZoomScale: function getZoomScale() {
    return 1;
  },
  getScrollViewSize: function getScrollViewSize() {
    var size = new _size["default"](this.parentDiv.clientWidth, this.parentDiv.clientHeight);
    return size;
  }
});
MDFileEditorInterface.getPanelVariable = function (oper_, objs_, comm_) {
  var panelInDisp = {
      panel: null
    },
    panelInScrible = {
      panel: null
    };
  return function getPanelVariable() {
    if (this.editorMode == _EditorMode["default"].normal) {
      return panelInDisp;
    } else {
      return panelInScrible;
    }
  };
}();
var _default = exports["default"] = MDFileEditorInterface;

},{"1084":1084,"1184":1184,"1451":1451,"1454":1454,"319":319,"427":427,"811":811,"830":830,"831":831,"837":837,"856":856,"861":861,"893":893,"904":904,"907":907,"909":909,"949":949,"955":955}],943:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1437);
require(1438);
var _goog = _interopRequireDefault(require(823));
var _MMCommonEditorView = _interopRequireDefault(require(914));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDEvents = _interopRequireDefault(require(325));
var _MDPdfTextLayerController = _interopRequireDefault(require(910));
var _MDPdfTileView = _interopRequireDefault(require(454));
var _MMPoint = _interopRequireDefault(require(830));
var _EditorMode = _interopRequireDefault(require(904));
var _MMOperationCenter = _interopRequireDefault(require(874));
var _MMPDFDrawerController = _interopRequireDefault(require(932));
var _MDBabelTileView = _interopRequireDefault(require(453));
/**
 * pc 上的仅有一页的 pdf 文档的显示
 *
 * 需要支持无极缩放，即快速缩放不重绘 pdf 内容，而是在缩放停止后再刷新
 * 2016-9-22
 */

var g_pdfPageViewId = 0;
function MDPCSinglePagePdfView(containerDiv, opt) {
  _MMCommonEditorView["default"].call(this, containerDiv);
  this.id = g_pdfPageViewId++;
  this.editorViewCtl = opt.editorViewCtl;
  var pageMargin = opt.pageMargin;
  this.pageMargin = pageMargin ? pageMargin : 10;
  this.mmPicObj = null;
  this.pdfUrl = null;
  $(this.container).css("pointer-events", "auto");
  this.bufferCanvas = [];
  _Dispatcher["default"].on(_MDEvents["default"].TextComment_status, this.textCommentStatusChanged, this);
  _Dispatcher["default"].on(_MDEvents["default"].NEW_MESSAGE, this.receiveNewMessage, this);
  _Dispatcher["default"].on(_MDEvents["default"].TileRenderProgress, this.tileDrawingProgress, this);
  this.className = 'MDPCSinglePagePdfView';
  _czc && _czc.push(["_trackEvent", "预览", "单页pdf", "", "", ""]);
}
;
_goog["default"].inherits(MDPCSinglePagePdfView, _MMCommonEditorView["default"]);
MDPCSinglePagePdfView.prototype.constructView = function (loadFinished) {
  _MMCommonEditorView["default"].prototype.constructView.call(this, loadFinished);
  var $pdfLayer = null;
  if (this.needTileView()) {
    $pdfLayer = this._$pdfTileContainer;
  } else {
    $pdfLayer = this._$pdfLayer;
  }
  if (this.board && this.board.isCADFile()) {
    if (this.board.isCADFile()) {
      var backcolor = localStorage['CADBackgroundColor'];
      if (backcolor) {
        $pdfLayer.css('background-color', backcolor);
      } else {
        $pdfLayer.css('background-color', 'black');
      }
    } else {
      $pdfLayer.css('background-color', 'white');
    }
  } else {
    this.refreshTextLayerIndex();
    this.registerTextLayerEvents();
  }
};
MDPCSinglePagePdfView.prototype._createLayers = function (callback) {
  var $layers = null;
  if (this.needTileView()) {
    $layers = $("<div class='pdf-thumb-layer editor-zone' style='position:absolute; left:0px; top:0px;background-size:100% 100%;background-repeat:none'></div>" + "<div class='tile-container editor-zone' style='position:absolute; left:0px; top:0px;background-size:100% 100%;background-repeat:none;background-color:rgba(255, 0, 0, 0.0);overflow:hidden'></div>" + "<canvas class='scribble-layer editor-canvas-zone' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 0, 0, 0.0);pointer-events:none;'></canvas>" + "<canvas class='comment-line-layer assist_layer' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 0, 0, 0.0);pointer-events:none;'></canvas>" + "<div class='comment-layer editor-zone' style='position:absolute; box-shadow:0 0 10px rgba(0,0,0,0.25);overflow: hidden; left:0px; top:0px;pointer-events:none;z-index: 390000000;'></div>" + "<canvas class='operate-layer assist_layer f-selectable' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 0, 0, 0.0); z-index: 400000000;'></canvas>" + "<div class='text-layer editor-zone textLayer' style='position:absolute; left:0px; top:0px;color:rgba(0,0,0,0);'></div>" + "<canvas class='zoomrect-layer ' style='position:absolute; left:0px; top:0px;color:rgba(0,0,255,0.5);z-index: 400000000;'></canvas>" + "");
  } else {
    $layers = $("<div class='pdf-thumb-layer editor-zone' style='position:absolute; left:0px; top:0px;background-size:100% 100%;background-repeat:none'></div>" + "<div class='editor-zone' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 255, 255, 1.0)'>" + "<canvas class='pdf-layer' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 255, 255, 1.0)'></canvas>" + "</div>" + "<canvas class='scribble-layer editor-canvas-zone' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 0, 0, 0.0);pointer-events:none;'></canvas>" + "<canvas class='comment-line-layer assist_layer' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 0, 0, 0.0);pointer-events:none;'></canvas>" + "<div class='comment-layer editor-zone' style='position:absolute; box-shadow:0 0 10px rgba(0,0,0,0.25);overflow: hidden; left:0px; top:0px;pointer-events:none;z-index: 390000000;'></div>" + "<canvas class='operate-layer assist_layer f-selectable' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 0, 0, 0.0); z-index: 400000000;'></canvas>" + "<div class='editor-zone' style='position:absolute;' >" + "<div class='editor-zone text-container' style='position:absolute;'>" + "<div class='text-layer textLayer' style='position:absolute; left:0px; top:0px;color:rgba(0,0,0,0);'></div>" + "</div>" + "</div>" + "<canvas class='zoomrect-layer ' style='position:absolute; left:0px; top:0px;color:rgba(0,0,255,0.5);z-index: 400000000;'></canvas>" + "");
  }
  callback($layers);
};
MDPCSinglePagePdfView.prototype._initLayerVars = function () {
  _MMCommonEditorView["default"].prototype._initLayerVars.call(this);
  this._$pdfLayer = this.$contentDiv.find('.pdf-layer');
  this._$pdfThumbLayer = this.$contentDiv.find('.pdf-thumb-layer');
  this._$pdfTileContainer = this.$contentDiv.find('.tile-container');
  this._$textLayer = this.$contentDiv.find('.text-layer');
  this._$textContainer = this.$contentDiv.find('.text-container');
};
MDPCSinglePagePdfView.prototype.changeBackgroundColor = function (color) {
  if (this.needTileView()) {
    this._$pdfTileContainer.css('background-color', color);
  } else {
    this._$pdfLayer.css('background-color', color);
  }
};
MDPCSinglePagePdfView.prototype._positionOtherLayer = function (marginLeft, marginTop) {
  var $pdflayer = this._$pdfLayer;
  $pdflayer.css('left', marginLeft + 'px');
  $pdflayer.css('top', marginTop + 'px');
};
MDPCSinglePagePdfView.prototype.drawFile = function (loadFinished) {
  var that = this;
  _MMPDFDrawerController["default"].getGlobalInstance().clear(this);
  console.log('--------- begin pdf page   ' + new Date().getTime());
  that._$pdfThumbLayer.css("background-image", "url(" + that.mmPicObj.getThumbnailUrl() + ")");
  this.mmPicObj.getPdfPage(function (page) {
    that.page = page;
    if (!that.mmPicObj || page['pageIndex'] != that.mmPicObj.getPdfPageIndex() - 1 || page.mmobjId != that.mmPicObj.getId()) {
      return;
    }
    ;
    var viewport = that.mmPicObj.page.getViewport(1.0);
    that.originW = viewport.width;
    that.originH = viewport.height;
    that.imgRatio = that.originH / that.originW;
    that.mmPicObj.setOriginSize(new _MMPoint["default"](viewport.width, viewport.height));
    loadFinished();
    if (that.needTileView()) {
      that.drawPageInTileView(page);
    } else {
      that.drawPageInCanvas();
    }
  });
};
MDPCSinglePagePdfView.prototype.tileDrawingProgress = function (opt) {
  var self = this;
  var progress = opt.progress;
  var editorViewCtl = opt.editorViewCtl;
  if (editorViewCtl != this.editorViewCtl) {
    return;
  }
  if (progress && (progress >= 1.0 || Math.abs(progress, 1.0) < 0.01)) {
    self._$pdfThumbLayer.remove();
    if (this.board.isCADFile()) {} else {
      this.changeBackgroundColor('white');
    }
  }
}, MDPCSinglePagePdfView.prototype.drawPageInTileView = function (page, loadFinished) {
  if (!this.tileView) {
    var $scrollView = $(this.container);
    this.tileView = new _MDBabelTileView["default"](this.mmPicObj, this._$pdfTileContainer[0], $scrollView[0], {
      editorViewCtl: this.editorViewCtl
    });
  }
  ;
  this.tileView.refresh(this.scale);
  loadFinished && loadFinished();
};
MDPCSinglePagePdfView.prototype.refreshDivsSize = function (clearCanvas) {
  var dispSize = _MMCommonEditorView["default"].prototype.refreshDivsSize.call(this, clearCanvas);
  var self = this;
  if (this.needTileView()) {
    if (self.tileView) {
      self.tileView.refresh(self.scale);
    }
    ;
  }
  this.updateZoomRectLayer();
  return dispSize;
};
MDPCSinglePagePdfView.prototype.drawPageInCanvas = function (loadFinished) {
  var that = this;
  var page = this.page;
  console.log('--------- set pdf page   ' + new Date().getTime());
  // that.pdfDrawer.clear();
  // that.pdfDrawer.setPDFPage(page);

  $(that.container).css('overflow', 'hidden');
  var $pdflayer = that._$pdfLayer;
  if (app.canDispInNormalBrowser()) {
    that._$textLayer.css('display', 'block');
  }
  ;
  $(that.container).css('overflow', 'auto');
  console.log('--------- draw pdf in editor   ' + new Date().getTime());
  var time = 10;
  var drawFinishCall = loadFinished;
  time = 0;
  // setBabelTimeout(function(){
  that._$pdfLayer.css("display", "none");
  // that.pdfDrawer.drawInCanvas($pdflayer[0], function(){
  _MMPDFDrawerController["default"].getGlobalInstance().drawInCanvas(that, $pdflayer[0], page, function (canvas) {
    //          that.__loadingPlaceholder.css('display', 'none');
    that._$pdfLayer.css("display", "block");
    that.drawFininshed = true;
    that.initNavigator(canvas);

    // that.refreshEditor();
    that._$pdfThumbLayer.remove();
    if (drawFinishCall) {
      drawFinishCall(true); //pdf draw finhished.
    }
    ;
  });
  // }, time);
};
MDPCSinglePagePdfView.prototype.initNavigator = function (canvas) {
  var angle = this.angle;
  if (this.navigatorMap) {
    this.navigatorMap.initNavigator(this.winW, this.winH, this.imgRatio, canvas, angle);
  }
  ;
};
MDPCSinglePagePdfView.prototype.getScale = function () {
  return this.scale;
};
MDPCSinglePagePdfView.prototype.refreshSize = function () {
  var that = this;
  _MMCommonEditorView["default"].prototype.refreshSize.call(this, function () {});
};
MDPCSinglePagePdfView.prototype.refreshCanvas = function () {
  _MMCommonEditorView["default"].prototype.refreshCanvas.call(this);

  // var targetW = this._$editorZone.width();
  // var targetH = this._$editorZone.height();
  // this.refreshPdfCanvas(targetW, targetH);

  var imgScaleW = this.originW * this.scale;
  var imgScaleH = this.originH * this.scale;
  this.refreshPdfCanvas(imgScaleW, imgScaleH);
  this.updateZoomRectLayer();
};
// variable to avoid dublicated resizing on scale
// var globalo2oScallNumber = null;
MDPCSinglePagePdfView.prototype.refreshTimeout = function (scale, callback) {
  var that = this;

  // execute the scale
  this.setScaleToFit();
  this.globalo2oScallNumber = Math.random();
  var localo2oScallNumber = this.globalo2oScallNumber;
  requestAnimationFrame(function () {
    if (localo2oScallNumber == this.globalo2oScallNumber) this.refreshEditor(function () {
      that.refreshCanvas();
      if (callback) {
        callback();
      }
      ;
    });
  }.bind(this));
};
MDPCSinglePagePdfView.prototype.changeScale = function (scale, callback) {
  var self = this;
  console.log('----------------- change scale:', scale);
  _MMCommonEditorView["default"].prototype.changeScale.call(this, scale, function () {
    if (!self.pinching) {
      self.refreshCanvas();
    }
    ;
    if (callback) {
      callback();
    }
    ;
  });
};
MDPCSinglePagePdfView.prototype.setScale = function (scale) {
  this.scale = scale;
};
MDPCSinglePagePdfView.prototype.zoomDiv = function (scale) {
  _MMCommonEditorView["default"].prototype.zoomDiv.call(this, scale);
};

// 模拟滚轮结束时的刷新操作
MDPCSinglePagePdfView.prototype.pinchEnd = function (scale) {
  _MMCommonEditorView["default"].prototype.pinchEnd.call(this, scale);
  this.refreshCanvas();
};
MDPCSinglePagePdfView.prototype.followTeacher = function (dispPosition, callback) {
  _MMCommonEditorView["default"].prototype.followTeacher.call(this, dispPosition, callback);
  var that = this;
  setBabelTimeout(function () {
    that.refreshCanvas();
  }, 100);
};
MDPCSinglePagePdfView.prototype.needTileView = function () {
  return this.board.isCADFile();
  return this.mmPicObj.getBoard().getPageCount() == 1;
};
MDPCSinglePagePdfView.prototype.canNavigate = function () {
  return this.mmPicObj.getBoard().getPageCount() == 1;
};
MDPCSinglePagePdfView.prototype.refreshPdfCanvas = function (targetW, targetH) {
  if (this.needTileView()) {
    this.drawPageInTileView();
  } else {
    if (!this.isDispPdf() || !this.drawFininshed) {
      return;
    }
    if (this._$drawingPdf) {
      this._$drawingPdf.remove();
    }
    ;
    this._$drawingPdf = this._$pdfLayer.clone();
    this._$pdfLayer.before(this._$drawingPdf);
    this._$editorCanvasZone = this.$contentDiv.find('.editor-canvas-zone'); // image 层和 comment 层

    MMCommonFun.initCanvasSize(this._$drawingPdf, targetW, targetH);
    _MMPDFDrawerController["default"].getGlobalInstance().clear(this);
    var that = this;
    var drawingPdf = this._$drawingPdf;
    _MMPDFDrawerController["default"].getGlobalInstance().drawInCanvas(this, this._$drawingPdf[0], this.page, function () {
      that._$pdfLayer.remove();
      that._$pdfLayer = drawingPdf;
      that._$drawingPdf = null;
      that._$editorCanvasZone = that.$contentDiv.find('.editor-canvas-zone'); // image 层和 comment 层
    });
  }
};
MDPCSinglePagePdfView.prototype.clearPdfLayer = function () {
  var pdf_canvas = this._$pdfLayer[0];
  if (pdf_canvas) {
    var w = this._$pdfLayer.width();
    var h = this._$pdfLayer.height();
    var ctx = pdf_canvas.getContext('2d');
    ctx.clearRect(0, 0, w, h);
  }
  ;
};
MDPCSinglePagePdfView.prototype.getCurrentFilePageIndex = function () {
  var index = -1;
  if (this.mmPicObj) {
    index = this.mmPicObj.getPageIndex();
  }
  return index;
};
MDPCSinglePagePdfView.prototype.removeFromSuperView = function () {
  _MMCommonEditorView["default"].prototype.removeFromSuperView.call(this);
  if (this.tileView) {
    this.tileView.removeFromSuperView();
  }
  ;
};
MDPCSinglePagePdfView.prototype.setCurOperation = function (oper_, objs_, comm_) {
  _MMCommonEditorView["default"].prototype.setCurOperation.call(this, oper_, objs_, comm_);
  this.refreshTextLayerIndex();
};
MDPCSinglePagePdfView.prototype.useTransformToScale = function () {
  return false;
};

//--------------------------------------------------------------------------------------------------  text layer

MDPCSinglePagePdfView.prototype.getPdfTextLayer = function () {
  return this._$textLayer;
};
MDPCSinglePagePdfView.prototype.getPdfTextMarkLayer = function () {
  return this._$scribbleLayer;
};
MDPCSinglePagePdfView.prototype.registerTextLayerEvents = function () {
  if (this.editorMode == _EditorMode["default"].mark || !this.isDispPdf()) {
    this.textLayerCtl = null;
    return;
  }
  ;
  this.textLayerCtl = new _MDPdfTextLayerController["default"]();
  this.textLayerCtl.listenToPdfPageEditor(this, this.mmPicObj.getBoard(), this.mmPicObj.getPageIndex());
};
MDPCSinglePagePdfView.prototype.textLayerEmptied = function () {
  if (this.textLayerCtl) {
    this.textLayerCtl.textLayerEmptied();
  }
  ;
};
MDPCSinglePagePdfView.prototype.hasText = function (has) {
  if (has != undefined) {
    this._hasText = has;
  }
  ;
  return this._hasText;
};
MDPCSinglePagePdfView.prototype.refreshTextLayerIndex = function () {
  if (this.editorMode == _EditorMode["default"].mark || !this.isDispPdf()) {
    return;
  }
  ;
  if (_MMOperationCenter["default"].getOperation() == 'text-mark') {
    $('.text-container').css('z-index', 400000001);
  } else {
    $('.text-container').css('z-index', 'auto');
  }
};
MDPCSinglePagePdfView.prototype.removeEvents = function () {
  _Dispatcher["default"].off(null, null, this);
};
MDPCSinglePagePdfView.prototype.receiveNewMessage = function (payload) {
  payload = payload || {};
  var comment = payload.comment;
  MMCommonFun.refreshTextCommentStatus(comment, this);
};
MDPCSinglePagePdfView.prototype.textCommentStatusChanged = function (textComment) {
  MMCommonFun.refreshTextCommentStatus(textComment, this);
};
MDPCSinglePagePdfView.prototype.getZoomList = function () {
  var zoomlist = this.calculateZoomList();
  return zoomlist;
};
MDPCSinglePagePdfView.prototype.calcFinalScale = function (deltaScale) {
  //1. 不允许 deltaScale <= 0
  if (deltaScale <= 0) {
    return 1.0;
  }
  ;
  var maxArea = 45000 * 45000; // 最大值
  var minArea = 100 * 100;
  var originConentSize = {
    w: this.originW,
    //this.$contentDiv.width(),
    h: this.originH //this.$contentDiv.height()
  };
  var curDispSize = {
    w: originConentSize.w * this.scale,
    h: originConentSize.h * this.scale
  };
  var curArea = curDispSize.w * curDispSize.h;
  var finalScale = this.scale * deltaScale;
  var scaledSize = {
    w: originConentSize.w * finalScale,
    h: originConentSize.h * finalScale
  };
  var scaledArea = scaledSize.w * scaledSize.h;
  var targetDeltaScale = deltaScale;

  // 不能超过最大最小值
  if (deltaScale < 1) {
    if (curArea > minArea) {
      if (scaledArea < minArea) {
        targetDeltaScale = Math.sqrt(minArea / curArea);
      }
      ;
    } else {
      targetDeltaScale = 1.0;
    }
  } else {
    if (curArea < maxArea) {
      if (scaledArea > maxArea) {
        targetDeltaScale = Math.sqrt(maxArea / curArea);
      }
      ;
    } else {
      targetDeltaScale = 1.0;
    }
  }

  // 关键比例的捕捉
  var keyScales = [0.5, 1.0]; //-------- 关键比例
  var error = 0.09; //------------ 吸附距离

  var curScale = this.scale;
  if (this.hiddenScale) {
    curScale = this.hiddenScale;
  }
  ;
  finalScale = curScale * targetDeltaScale;
  var absorbed = false;
  for (var i = 0; i < keyScales.length; i++) {
    // 吸附发生
    if (Math.abs(keyScales[i] - finalScale) < error) {
      this.hiddenScale = finalScale;
      absorbed = true;
      targetDeltaScale = keyScales[i] / this.scale;
      break;
    }
  }
  ;
  if (!absorbed) {
    if (this.hiddenScale) {
      this.hiddenScale = 0;
      targetDeltaScale = finalScale / this.scale;
    }
  }
  ;
  console.log('hiddenScale :', this.hiddenScale);
  return targetDeltaScale;
};
MDPCSinglePagePdfView.prototype.toggleZoomRect = function () {
  if (this.showZoomRectLayer) {
    this.showZoomRectLayer = false;
  } else {
    this.showZoomRectLayer = true;
  }
  this.updateZoomRectLayer();
  return this.showZoomRectLayer;
};
MDPCSinglePagePdfView.prototype._onScroll = function () {
  _MMCommonEditorView["default"].prototype._onScroll.call(this);
  this.updateZoomRectLayer();
};
MDPCSinglePagePdfView.prototype.isShowingZoomRect = function () {
  return this.showZoomRectLayer;
};
MDPCSinglePagePdfView.prototype.updateZoomRectLayer = function () {
  _MMCommonEditorView["default"].prototype._onScroll.call(this);
  if (!this.$zoomRectLayer) {
    this.$zoomRectLayer = this.$contentDiv.find('.zoomrect-layer');
  }
  if (!this.showZoomRectLayer) {
    this.$zoomRectLayer.hide();
    return;
  }
  this.$zoomRectLayer.show();
  var x = this.container.scrollLeft;
  var y = this.container.scrollTop;
  var w = document.documentElement.clientWidth;
  var h = document.documentElement.clientHeight;
  this.$zoomRectLayer.css('left', x + 'px');
  this.$zoomRectLayer.css('top', y + 'px');
  this.$zoomRectLayer.attr('width', w + 'px');
  this.$zoomRectLayer.attr('height', h + 'px');
};
MDPCSinglePagePdfView.prototype.zoomRectMouseDown = function (e) {
  this.zoomRectX = e.offsetX;
  this.zoomRectY = e.offsetY;
  var context = this.$zoomRectLayer[0].getContext('2d');
  context.strokeStyle = "rgb(250, 20, 83)";
  this.zoomRectCaptured = true;
};
MDPCSinglePagePdfView.prototype.zoomRectMouseUp = function (e) {
  this.zoomRectCaptured = false;
  if (Math.abs(this.zoomRectW) < 2) {
    this.zoomRectW = 1;
  }
  if (Math.abs(this.zoomRectH) < 2) {
    this.zoomRectH = 1;
  }
  var zoomDiff = 1.0;
  if (this.zoomRectW == 1 && this.zoomRectH == 1) {
    zoomDiff = 1.1;
  } else {
    var r1 = document.documentElement.clientWidth / document.documentElement.clientHeight;
    var r2 = this.zoomRectW / this.zoomRectH;
    if (r2 >= r1) {
      // 以宽为准
      zoomDiff = document.documentElement.clientWidth / this.zoomRectW;
    } else {
      zoomDiff = document.documentElement.clientHeight / this.zoomRectH;
    }
  }
  var context = this.$zoomRectLayer[0].getContext('2d');
  context.clearRect(0, 0, this.$zoomRectLayer[0].width, this.$zoomRectLayer[0].height);
  var cX = (this.container.scrollLeft + this.zoomRectX + this.zoomRectW / 2) / this.container.scrollWidth;
  var cY = (this.container.scrollTop + this.zoomRectY + this.zoomRectH / 2) / this.container.scrollHeight;
  this.zoomCenterX = cX / this.$contentDiv.width();
  this.zoomCenterY = cY / this.$contentDiv.height();
  var deltaScale = this.calcFinalScale(zoomDiff);
  var self = this;
  var scale = this.scale * deltaScale;
  this.changeScale(scale, function () {
    setBabelTimeout(function () {
      var nCx = cX * self.originW * scale;
      var nCy = cY * self.originH * scale;
      self.container.scrollLeft = nCx - document.documentElement.clientWidth / 2;
      self.container.scrollTop = nCy - document.documentElement.clientHeight / 2;
    }, 100);
  });
  this.disableZoomRectLayer();
  _Dispatcher["default"].trigger(_MDEvents["default"].HideZoomRectLayer);
};
MDPCSinglePagePdfView.prototype.zoomRectMouseMove = function (e) {
  if (this.zoomRectCaptured) {
    var w = e.offsetX - this.zoomRectX;
    var h = e.offsetY - this.zoomRectY;
    var context = this.$zoomRectLayer[0].getContext('2d');
    context.clearRect(0, 0, this.$zoomRectLayer[0].width, this.$zoomRectLayer[0].height);
    context.strokeRect(this.zoomRectX, this.zoomRectY, w, h);
    this.zoomRectW = w;
    this.zoomRectH = h;
  }
  _Dispatcher["default"].trigger(_MDEvents["default"].DISPLAY_ZOOM_BAR);
};
MDPCSinglePagePdfView.prototype.disableZoomRectLayer = function () {
  this.showZoomRectLayer = false;
  this.updateZoomRectLayer();
};
MDPCSinglePagePdfView.prototype.getCurrentFileIndex = function () {
  return 0;
};
MDPCSinglePagePdfView.prototype.scrollToPage = function () {};
var _default = exports["default"] = MDPCSinglePagePdfView;

},{"1184":1184,"1417":1417,"1437":1437,"1438":1438,"1454":1454,"1463":1463,"18":18,"325":325,"453":453,"454":454,"823":823,"830":830,"874":874,"904":904,"910":910,"914":914,"932":932}],910:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1437);
require(1478);
var _MDTextCommentPanelCtl = _interopRequireDefault(require(434));
var _MMRect = _interopRequireDefault(require(831));
//
// MDPdfTextLayerController.js
//
// jiang
// 2016-1-14
//

var MDPdfTextLayerController = function MDPdfTextLayerController() {};
MDPdfTextLayerController.prototype.listenToPdfPageEditor = function (pdfPageEditor, board, pgIndex) {
  this.pdfPageEditor = pdfPageEditor;
  this.$textLayer = pdfPageEditor.getPdfTextLayer();
  this.$textMarkLayer = pdfPageEditor.getPdfTextMarkLayer();
  this.enabled = true;
  this.editorViewCtl = pdfPageEditor.editorViewCtl;
  var $textLayer = this.$textLayer;
  var $textMarkLayer = this.$textMarkLayer;
  var that = this;
  that.subLayerEventRegistered = false;
  $textLayer.off('mousedown');
  $textLayer.change(function () {
    console.log('------> text layer changed');
  });

  // $textLayer.off('mousemove');

  // $textLayer.on('mousemove', function mousedown(argument) {
  //    argument.stopPropagation();
  // });

  $textLayer.on('mousedown', function mousedown(argument) {
    if (!that.enabled) {
      return;
    }
    ;
    argument.stopPropagation();
    var trsfm = pdfPageEditor.getCanvasTransformer();
    if (!that.subLayerEventRegistered && $textLayer.find('div').length > 0) {
      that.subLayerEventRegistered = true;
      $textLayer.find('div').off('mouseup');
      $textLayer.find('div').on('mouseup', function mouseup(argument) {
        argument.stopPropagation();
        var sel = window.getSelection();
        if (sel.baseNode) {
          var startNode = sel.baseNode.parentNode;
          var startPos = sel.baseOffset;
        } else if (sel.anchorNode) {
          var startNode = sel.anchorNode.parentNode;
          var startPos = sel.anchorOffset;
        } else {
          return;
        }
        var endNode = sel.focusNode.parentNode;
        var endPos = sel.focusOffset;
        if (startNode == endNode && startPos > endPos) {
          var temp = startPos;
          startPos = endPos;
          endPos = temp;
        }
        ;
        if ($(startNode).index() > $(endNode).index()) {
          var temp = startNode;
          startNode = endNode;
          endNode = temp;
          temp = endPos;
          endPos = startPos;
          startPos = temp;
        }
        ;

        // var txtSel = sel.toString().replace(/\n/g, "");;
        var txtSel = sel.toString();
        sel.removeAllRanges();
        var canvas = $textMarkLayer[0];
        var ctx = canvas.getContext("2d");
        ctx.fillStyle = 'rgba(255, 255,0,0.5)';
        //ctx.fillStyle='rgba(254, 237, 111,0.5)';

        var $childs = $textLayer.find('.textLayer').children();
        var needDraw = false;
        var logicRcts = [];
        var targetPos = null;
        for (var i = 0; i < $childs.length; i++) {
          var div = $childs[i];
          var rct = that.calcuSelectRect(canvas, div, startNode, endNode, startPos, endPos);
          if (div == startNode && rct.w > 1) {
            needDraw = true;
            targetPos = {
              x: rct.x + rct.w,
              y: rct.y
            };
          }
          ;
          if (needDraw && rct.w > 1 && rct.h > 1) {
            //ctx.clearRect(rct.x, rct.y, rct.w, rct.h);

            // 绘制黄色区域
            ctx.fillRect(rct.x, rct.y, rct.w, rct.h);
            var mrct = new _MMRect["default"]();
            mrct.setRct(rct.x, rct.y, rct.w, rct.h);
            var lgRct = trsfm.dv2lgRect(mrct);
            logicRcts.push(lgRct);
          }
          ;
          if (div == endNode) {
            break;
          }
          ;
        }
        ;
        if (needDraw) {
          _MDTextCommentPanelCtl["default"].setViewCtl(that.editorViewCtl);
          _MDTextCommentPanelCtl["default"].showCreationPanel(targetPos, canvas, txtSel, logicRcts, board, pgIndex, function success() {
            var refreshRct = logicRcts[0].clone();
            for (var i = 0; i < logicRcts.length; i++) {
              refreshRct.expandToInclude(logicRcts[i]);
            }
            ;
            pdfPageEditor.refreshObjsInCanvas(refreshRct);
          }, function fail() {});
        }
        ;
      });
    }
    ;
  });
};
MDPdfTextLayerController.prototype.textLayerEmptied = function () {
  this.subLayerEventRegistered = false;
};
MDPdfTextLayerController.prototype.calcuDivPosition = function (div, canvas) {
  var left = div.offsetleft;
  var top = div.offsetTop;
  var w = div.offsetWidth;
  var h = div.offsetHeight;
  var pos0 = MMCommonFun.convertPointBetweenElements(div, canvas, {
    x: 0,
    y: 0
  });
  var pos1 = MMCommonFun.convertPointBetweenElements(div, canvas, {
    x: w,
    y: h
  });
  return {
    x: pos0.x,
    y: pos0.y,
    w: pos1.x - pos0.x,
    h: pos1.y - pos0.y
  };
};
MDPdfTextLayerController.prototype.setEnable = function (able) {
  this.enabled = able;
};
MDPdfTextLayerController.prototype.calcuDivPartition = function (canvas, textDiv, offset) {
  var text = $(textDiv).text();
  var fontSize = $(textDiv).css('font-size');
  var fontFam = $(textDiv).css('font-family');
  var ctx = canvas.getContext("2d");
  ctx.font = fontSize + " " + fontFam;
  var totalW = ctx.measureText(text).width;
  var subtxt = text.substr(0, offset);
  var subW = ctx.measureText(subtxt).width;
  return subW / totalW;
};
MDPdfTextLayerController.prototype.calcuSelectRect = function (canvas, textDiv, startNode, endNode, startPos, endPos) {
  var rect = this.calcuDivPosition(textDiv, canvas);
  if (textDiv != startNode && textDiv != endNode) {
    return rect;
  } else {
    var startX = rect.x;
    var endX = startX + rect.w;
    if (textDiv == startNode) {
      var startR = this.calcuDivPartition(canvas, startNode, startPos);
      startX = rect.x + startR * rect.w;
    }
    if (textDiv == endNode) {
      var endR = this.calcuDivPartition(canvas, endNode, endPos);
      endX = rect.x + endR * rect.w;
    }
    ;
    rect.x = startX;
    rect.w = endX - startX;
  }
  return rect;
};
var _default = exports["default"] = MDPdfTextLayerController;

},{"1184":1184,"1417":1417,"1437":1437,"1454":1454,"1463":1463,"1478":1478,"434":434,"831":831}],454:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MDPdfTileView = exports.MDPdfTile = void 0;
var _MDTileView = require(455);
var _goog = _interopRequireDefault(require(823));
/*jslint nomen: true, vars: true, plusplus:true, browser:true */
/*global console, app, goog, $, _ */
/**
 * pc 上的 pdf 一页的显示
 * 2016-1-28
 */

var MDPdfTile = exports.MDPdfTile = function MDPdfTile(pdfPage, tileSize, xi, yi, $containerDiv) {
  this.pdfPage = pdfPage;
  _MDTileView.MDTile.call(this, tileSize, xi, yi, $containerDiv);
};
_goog["default"].inherits(MDPdfTile, _MDTileView.MDTile);
MDPdfTile.prototype.removeFromSuperview = function () {
  this.$tile.remove();
};
MDPdfTile.prototype.createDispView = function () {
  this.$canvas = $('<canvas class="tile-canvas" style="position:absolute;left:0px;top:0px;width:100%;height:100%"></canvas>');
  return this.$canvas;
};
MDPdfTile.prototype.refreshView = function (callback) {
  _MDTileView.MDTile.prototype.refreshView.call(this);
  var canvas = this.$canvas[0];
  ;
  canvas.width = this.tileSize.w;
  canvas.height = this.tileSize.h;
  var context = canvas.getContext('2d');
  context.fillStyle = '#000';
  context.fillRect(0, 0, canvas.width, canvas.height);

  //context.translate(-this.xi*this.tileSize.w, -this.yi*this.tileSize.h);

  // console.log('draw pdf tile -------- x:', this.xi, 'y:', this.yi);

  var page = this.pdfPage;
  var viewport = page.getViewport(1.0);
  var canvasWidth = this.$containerDiv.width();
  var canvasHeight = this.$containerDiv.height();
  var scale = canvasWidth / viewport.width;
  viewport = page.getViewport(scale);
  var dx = -this.xi * this.tileSize.w;
  var dy = -this.yi * this.tileSize.h;
  context.clearRect(0, 0, canvas.width, canvas.height);
  var a = viewport.rotation * Math.PI / 180;
  var t0 = Math.cos(a) * scale;
  var t1 = Math.sin(a) * scale;
  var t2 = t1;
  var t3 = -t0;
  var t4 = viewport.transform[4];
  var t5 = viewport.transform[5];
  viewport.transform = [t0, t1, t2, t3, t4 + dx, t5 + dy];

  // viewport['transform'] = [scale, 0,0, -scale, dx, viewport.height + dy];

  // console.log('-------------> start:' + (new Date()).getTime());
  this.task = page.render({
    'canvasContext': context,
    'viewport': viewport
  });
  this.task.then(function () {
    // console.log('-------------> end :' + (new Date()).getTime());
  });
  var page_num = 1;
  this.task.promise.then(function () {
    // console.log('-------------> draw finish :' + (new Date()).getTime());
    if (callback) {
      callback();
    }
    ;

    //     context.resetTransform();
    // context.fillStyle="#FF0000";
    // context.fillRect(0,0,150,75);
  }, function () {
    // console.log('-------------> draw canceled :' + (new Date()).getTime());
    if (callback) {
      callback();
    }
    ;
  });
};
MDPdfTile.prototype.canelDrawing = function () {
  if (this.task) {
    this.task.cancel();
  }
  ;
};

//-------------------------------------------------------------------------------------------

var MDPdfTileView = exports.MDPdfTileView = function MDPdfTileView() {
  _MDTileView.MDTileView.call(this);
};
_goog["default"].inherits(MDPdfTileView, _MDTileView.MDTileView);
MDPdfTileView.prototype.renderTo = function (pdfPage, containerDiv, scrollView, tileSize) {
  this.pdfPage = pdfPage;
  _MDTileView.MDTileView.prototype.renderTo.call(this, containerDiv, scrollView, tileSize);
};
_MDTileView.MDTileView.prototype.createTile = function (tileSize, xi, yi, $containerDiv) {
  return new MDPdfTile(this.pdfPage, tileSize, xi, yi, $containerDiv);
};

},{"1184":1184,"1454":1454,"455":455,"823":823}],455:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MDTileView = exports.MDTile = void 0;
require(1432);
require(1421);
var _MMCommonFun = _interopRequireDefault(require(812));
var _MDLoadMaskView = _interopRequireDefault(require(49));
/*jslint nomen: true, vars: true, plusplus:true, browser:true */
/*global console, app, goog, $, _ */
/**
 * 分块显示
 * 2016-1-28
 */

var MDTile = exports.MDTile = function MDTile(tileSize, xi, yi, $containerDiv) {
  this.tileSize = tileSize;
  this.xi = xi;
  this.yi = yi;
  this.$containerDiv = $containerDiv;
  this.$tile = $('<div class="tile" style="position:absolute;border:0px solid;"></div>');
  this.$tile.css('left', xi * tileSize.w + 'px');
  this.$tile.css('top', yi * tileSize.h + 'px');
  this.$tile.css('width', tileSize.w + 'px');
  this.$tile.css('height', tileSize.h + 'px');
  $containerDiv.append(this.$tile);
  this.$dispView = this.createDispView();
  if (this.$dispView) {
    this.$tile.append(this.$dispView);
  }
  ;
};
MDTile.prototype.removeFromSuperview = function () {
  this.$tile.remove();
};
MDTile.prototype.createDispView = function () {
  return undefined;
};
MDTile.prototype.refreshView = function () {};
MDTile.prototype.canelDrawing = function () {};

//-------------------------------------------------------------------------------------------

var MDTileView = exports.MDTileView = function MDTileView() {
  this.expand = 2;
};
MDTileView.prototype.renderTo = function (containerDiv, scrollView, callback) {
  this.removeFromSuperview();
  console.assert(containerDiv && scrollView, 'containerDiv 和 scrollView 不能为空');
  this.tileSize = {
    w: 512,
    h: 512
  };
  this.$containerDiv = $(containerDiv);
  this.constructView();
  this.scrollView = scrollView;
  var self = this;
  this.scrollFun = function (event) {
    self.onScroll(event);
  };
  $(scrollView).on('scroll', this.scrollFun);
  this.refresh(callback);
  this.checkToShowMask();
};
MDTileView.prototype.constructView = function () {
  this.$tileContainer = $('<div class="tile-container" style="position:relative;width:100%;height:100%;overflow:hidden"></div>');
  this.$containerDiv.append(this.$tileContainer);
};
MDTileView.prototype.removeFromSuperview = function () {
  if (this.scrollFun) {
    $(this.scrollView).off('scroll', this.scrollFun);
  }
  ;
  if (this.tiles) {
    for (var i = 0; i < this.tiles.length; i++) {
      this.tiles[i].removeFromSuperview();
    }
    ;
  }
  ;
  if (this.$tileContainer) {
    this.$tileContainer.remove();
  }
  ;
  this.tiles = [];
  this.tilesWaitDraw = [];
  if (this.tileDrawing) {
    this.tileDrawing.canelDrawing();
    this.tileDrawing = null;
  }
  ;
};
MDTileView.prototype.onScroll = function (event) {
  this.refresh();
  if (this.showMaskTimeout) {
    clearTimeout(this.showMaskTimeout);
  }
  ;
  var that = this;
  this.showMaskTimeout = setBabelTimeout(function () {
    that.checkToShowMask();
  }, 2000);
};
MDTileView.prototype.currentTileInWaiting = function () {
  var inWaiting = false;
  var indexBox = this.tilesSeeInViewBox;
  for (var xi = indexBox.startXi; xi < indexBox.endXi; xi++) {
    for (var yi = indexBox.startYi; yi < indexBox.endYi; yi++) {
      for (var i = 0; i < this.tilesWaitDraw.length; i++) {
        if (this.tilesWaitDraw[i].xi == xi && this.tilesWaitDraw[i].yi == yi) {
          inWaiting = true;
          break;
        }
      }
      ;
    }
    ;
  }
  ;
  return inWaiting;
};
MDTileView.prototype.checkToShowMask = function () {
  if (!this.showMask && this.currentTileInWaiting()) {
    this.showMask = true;
    _MDLoadMaskView["default"].show();
  }
  ;
};
MDTileView.prototype.checkToRemoveMask = function () {
  if (this.showMask && !this.currentTileInWaiting()) {
    this.showMask = false;
    _MDLoadMaskView["default"].remove();
  }
  ;
};
MDTileView.prototype.refresh = function (callback) {
  var origin = {
    x: 0,
    y: 0
  };
  var posInScroll = _MMCommonFun["default"].convertPointBetweenElements(this.$tileContainer[0], this.scrollView, origin);
  posInScroll.x = this.scrollView.scrollLeft - posInScroll.x;
  posInScroll.y = this.scrollView.scrollTop - posInScroll.y;
  var startXi = 0;
  if (posInScroll.x > 0) {
    startXi = Math.floor(posInScroll.x / this.tileSize.w);
  }
  ;
  var endXi = Math.floor((posInScroll.x + this.scrollView.offsetWidth) / this.tileSize.w) + 1;
  var maxXi = Math.floor(this.scrollView.scrollWidth / this.tileSize.w) + 1;
  var startYi = 0;
  if (posInScroll.y > 0) {
    startYi = Math.floor(posInScroll.y / this.tileSize.h);
  }
  ;
  var endYi = Math.floor((posInScroll.y + this.scrollView.offsetHeight) / this.tileSize.h) + 1;
  var maxYi = Math.floor(this.scrollView.scrollHeight / this.tileSize.h) + 1;
  this.tilesSeeInViewBox = {
    startXi: startXi,
    endXi: endXi,
    startYi: startYi,
    endYi: endYi
  };

  // console.log('=========> {', startXi, ',', endXi + '} - {', startYi, ',', endYi, '}');

  this.displayTiles(startXi, endXi, startYi, endYi, maxXi, maxYi, callback);
};
MDTileView.prototype.displayTiles = function (startXi, endXi, startYi, endYi, maxXi, maxYi, callback) {
  var i = 0;
  var expStartXi = startXi - this.expand;
  if (expStartXi < 0) {
    expStartXi = 0;
  }
  ;
  var expEndXi = endXi + this.expand;
  if (expEndXi > maxXi) {
    expEndXi = maxXi;
  }
  ;
  var expStartYi = startYi - this.expand;
  if (expStartYi < 0) {
    expStartYi = 0;
  }
  ;
  var expEndYi = endYi + this.expand;
  if (expEndYi > maxYi) {
    expEndYi = maxYi;
  }
  ;
  this.tilesExpBox = {
    expStartXi: expStartXi,
    expEndXi: expEndXi,
    expStartYi: expStartYi,
    expEndYi: expEndYi
  };
  while (i < this.tiles.length) {
    var tile = this.tiles[i];
    if (tile.xi < expStartXi || tile.xi >= expEndXi || tile.yi < expStartYi || tile.yi >= expEndYi) {
      tile.removeFromSuperview();
      this.removeFromDrawQueue(tile);
      this.tiles.splice(i, 1);
    } else {
      i++;
    }
  }
  ;
  var tilesCreated = [];
  for (var xi = expStartXi; xi < expEndXi; xi++) {
    for (var yi = expStartYi; yi < expEndYi; yi++) {
      var found = false;
      for (var i = 0; i < this.tiles.length; i++) {
        var tile = this.tiles[i];
        if (tile.xi == xi && tile.yi == yi) {
          found = true;
          break;
        }
        ;
      }
      ;
      if (!found) {
        var tile = this.createTile(this.tileSize, xi, yi, this.$tileContainer);
        tilesCreated.push(tile);
        this.tiles.push(tile);
      }
      ;
    }
    ;
  }
  this.drawTiles(tilesCreated);
  this.callback = callback;
};
MDTileView.prototype.createTile = function (tileSize, xi, yi, $containerDiv) {
  return new MDTile(tileSize, xi, yi, $containerDiv);
};
MDTileView.prototype.drawTiles = function (tiles) {
  if (!tiles) {
    tiles = this.tiles;
  }
  ;
  if (!this.tilesWaitDraw) {
    this.tilesWaitDraw = [];
  }
  ;

  // console.log('********-->>>>>>>> ---- before enter waiting');
  // var str = '';
  // for (var i = 0; i < this.tilesWaitDraw.length; i++) {
  //  str += ' - (' + this.tilesWaitDraw[i].xi +','+ this.tilesWaitDraw[i].yi+')';
  // };
  // console.log('-----' , str);

  for (var i = tiles.length - 1; i >= 0; i--) {
    var index = this.tilesWaitDraw.indexOf(tiles[i]);
    if (index == -1) {
      this.tilesWaitDraw.push(tiles[i]);
    }
  }
  ;
  // sort
  var tempArr = [];
  var indexBox = this.tilesSeeInViewBox;
  for (var xi = indexBox.startXi; xi < indexBox.endXi; xi++) {
    for (var yi = indexBox.startYi; yi < indexBox.endYi; yi++) {
      for (var i = 0; i < this.tilesWaitDraw.length; i++) {
        if (this.tilesWaitDraw[i] && this.tilesWaitDraw[i].xi == xi && this.tilesWaitDraw[i].yi == yi) {
          tempArr.push(this.tilesWaitDraw[i]);
          this.tilesWaitDraw[i] = null;
        }
      }
      ;
    }
    ;
  }
  ;
  var expBox = this.tilesExpBox;
  for (var xi = expBox.expStartXi; xi < expBox.expEndXi; xi++) {
    for (var yi = expBox.expStartYi; yi < expBox.expEndYi; yi++) {
      for (var i = 0; i < this.tilesWaitDraw.length; i++) {
        if (this.tilesWaitDraw[i] && this.tilesWaitDraw[i].xi == xi && this.tilesWaitDraw[i].yi == yi) {
          tempArr.push(this.tilesWaitDraw[i]);
          this.tilesWaitDraw[i] = null;
        }
      }
      ;
    }
    ;
  }
  ;
  this.tilesWaitDraw = tempArr;
  if (!this.tileDrawing && this.tilesWaitDraw.length > 0) {
    this.drawTileOneByOne();
  }
  ;
};
MDTileView.prototype.removeFromDrawQueue = function (tile) {
  if (!this.tilesWaitDraw) {
    return;
  }
  ;
  var index = this.tilesWaitDraw.indexOf(tile);
  if (index != -1) {
    this.tilesWaitDraw.splice(index, 1);
  } else if (this.tileDrawing == tile) {
    tile.canelDrawing();
  }
  ;
};
MDTileView.prototype.drawTileOneByOne = function () {
  this.checkToRemoveMask();
  var self = this;
  if (this.tilesWaitDraw.length == 0) {
    this.tileDrawing = null;
    if (this.callback) {
      setBabelTimeout(function () {
        self.callback();
        self.callback = null;
      }, 0);
    }
    ;
    return;
  }
  ;
  this.tileDrawing = this.tilesWaitDraw.shift();
  var self = this;
  this.tileDrawing.refreshView(function () {
    self.drawTileOneByOne();
  });
};

},{"1184":1184,"1421":1421,"1432":1432,"1454":1454,"49":49,"812":812}],942:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1439);
require(1421);
require(1477);
require(1412);
require(1411);
require(1434);
require(1438);
var _goog = _interopRequireDefault(require(823));
var _MMCommonEditorView = _interopRequireDefault(require(914));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDEvents = _interopRequireDefault(require(325));
var _MMPoint = _interopRequireDefault(require(830));
var _EditorMode = _interopRequireDefault(require(904));
var _MMOperationCenter = _interopRequireDefault(require(874));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDSVGLayerPanel = _interopRequireDefault(require(944));
var _MDSnackbarView = _interopRequireDefault(require(72));
/**
 * pc SVG 文件的显示
 * location : /javascript/molasync-source/ui/netdisk/pc/editor/MDPCSVGView.js
 *
 * 2018-7-28
 */

function sanitizeSVGElements($svg) {
  $svg.find('script, foreignObject, iframe, embed, object').remove();
  $svg.each(function () {
    sanitizeElementAttributes(this);
    var descendants = this.querySelectorAll('*');
    for (var i = 0; i < descendants.length; i++) {
      sanitizeElementAttributes(descendants[i]);
    }
  });
  return $svg;
}
function sanitizeElementAttributes(el) {
  if (!el.attributes) return;
  var toRemove = [];
  for (var i = 0; i < el.attributes.length; i++) {
    var name = el.attributes[i].name.toLowerCase();
    var value = el.attributes[i].value;
    if (name.indexOf('on') === 0) {
      toRemove.push(el.attributes[i].name);
    } else if ((name === 'href' || name === 'xlink:href') && /^\s*javascript:/i.test(value)) {
      toRemove.push(el.attributes[i].name);
    }
  }
  for (var j = 0; j < toRemove.length; j++) {
    el.removeAttribute(toRemove[j]);
  }
}
function MDPCSVGView(containerDiv, opt) {
  _MMCommonEditorView["default"].call(this, containerDiv);
  this.editorViewCtl = opt.editorViewCtl;
  var pageMargin = opt.pageMargin;
  this.pageMargin = pageMargin ? pageMargin : 10;
  this.mmPicObj = null;
  this.pdfUrl = null;
  $(this.container).css("pointer-events", "auto");
  this.bufferCanvas = [];
  _Dispatcher["default"].on(_MDEvents["default"].NEW_MESSAGE, this.receiveNewMessage, this);
  this.className = "MDPCSVGView";
}
_goog["default"].inherits(MDPCSVGView, _MMCommonEditorView["default"]);
MDPCSVGView.prototype.constructView = function (loadFinished) {
  _MMCommonEditorView["default"].prototype.constructView.call(this, loadFinished);
  var $pdfLayer = this._$svgLayer;
  if (this.board && this.board.canDispWithSVG()) {
    var backcolor = localStorage["SVGBackgroundColor"];
    if (backcolor) {
      $pdfLayer.css("background-color", backcolor);
    } else {
      $pdfLayer.css("background-color", "white");
    }
  }
};
MDPCSVGView.prototype._createLayers = function (callback) {
  var $layers = null;
  if (this.board.isVirtualBoard()) {
    $layers = $("<div class='svg-layer editor-zone' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 255, 255, 1.0)'></div>" + "<canvas class='image-layer-marker editor-canvas-zone' style='position:absolute'></canvas>" + "");
  } else {
    $layers = $("<div class='svg-layer editor-zone' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 255, 255, 1.0)'></div>" + "<canvas class='image-layer-marker editor-canvas-zone' style='position:absolute'></canvas>" + "<canvas class='scribble-layer editor-canvas-zone' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 0, 0, 0.0);pointer-events:none;'></canvas>" + "<div class='comment-layer editor-zone' style='position:absolute; box-shadow:0 0 10px rgba(0,0,0,0.25);overflow: hidden; left:0px; top:0px;pointer-events:none;z-index: 390000000;'></div>" + "<canvas class='operate-layer assist_layer f-selectable' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 0, 0, 0.0); z-index: 400000000;'></canvas>" + "");
  }
  callback($layers);
};
MDPCSVGView.prototype._initLayerVars = function () {
  _MMCommonEditorView["default"].prototype._initLayerVars.call(this);
  this._$svgLayer = this.$contentDiv.find(".svg-layer");
  this._$imageLayerMarker = this.$contentDiv.find(".image-layer-marker");
};
MDPCSVGView.prototype.changeBackgroundColor = function (color) {
  this._$svgLayer.css("background-color", color);
};
MDPCSVGView.prototype._positionOtherLayer = function (marginLeft, marginTop) {
  var $svgLayer = this._$svgLayer;
  $svgLayer.css("left", marginLeft + "px");
  $svgLayer.css("top", marginTop + "px");
  this._$imageLayerMarker.css("left", marginLeft + "px");
  this._$imageLayerMarker.css("top", marginTop + "px");
};
MDPCSVGView.prototype.drawFile = function (loadFinished) {
  var that = this;
  this.mmPicObj.getDispSVGFilePath(function (path) {
    // path = '/img/test/CAD-Model.svg';  // ------------------------------ for test
    _MMNetDiskDataController["default"].downLoadFileData(path, function (data) {
      that.originData = data;
      var file = that.board.getFileInfo();
      var type = localStorage.getItem("encodtype" + file.getFileId());
      if (type) {
        that.encodeToType(data, type);
        loadFinished && loadFinished();
        return;
      }
      var decodedString = MMCommonFun.decodeFromUTF8Array(data);
      var $svg;
      try {
        $svg = $(decodedString);
        var svgArr = [];
        $svg.each(function (index, item) {
          if (item.nodeName == "svg") {
            svgArr.push(item);
          }
        });
        $svg = $(svgArr);
        sanitizeSVGElements($svg);
        that._$svgLayer.empty();
        that._$svgLayer.append($svg);
        that.$svg = that._$svgLayer.find("svg");
        var viewBox = that.$svg.prop("viewBox").baseVal;
        if (!viewBox) {
          that.$svg[0].setAttribute("viewBox", "0 0 ".concat(that.$svg.width(), " ").concat(that.$svg.height()));
          viewBox = that.$svg.prop("viewBox").baseVal;
        }
        if (!viewBox.width) {
          viewBox.width = that.$svg.width();
        }
        if (!viewBox.height) {
          viewBox.height = that.$svg.height();
        }
        that.originW = viewBox.width;
        that.originH = viewBox.height;
        that.originRotateW = that.originW;
        that.originRotateH = that.originH;
        that.imgRatio = that.originH / that.originW;
        that.mmPicObj.setOriginSize(new _MMPoint["default"](that.originW, that.originH));
        that._initSync();
        that.createLayerPanel();
        that.initByOriginSize();
      } catch (e) {
        console.log(e);
        _MDSnackbarView["default"].show(BabelStr.str(6759));
      }

      //that.drawPageInCanvas();
      loadFinished && loadFinished();
      console.log("---- file opend:" + decodedString);
    }, function fail() {}, function pregress(p) {
      console.log("--------> download :" + p);
    });
  });

  // this.mmPicObj.getPdfPage(function(page) {
  //   that.page = page;
  //   if (!that.mmPicObj || page['pageIndex'] != that.mmPicObj.getPdfPageIndex() - 1 || page.mmobjId != that.mmPicObj.getId()) {
  //     return;
  //   };

  //   var viewport = that.mmPicObj.page.getViewport(1.0);
  //   that.originW = viewport.width;
  //   that.originH = viewport.height;

  //   that.imgRatio = that.originH / that.originW;

  //   that.mmPicObj.setOriginSize(new MMPoint(viewport.width, viewport.height));

  //   that.initNavigator();

  //   if (that.needTileView()) {
  //     that.drawPageInTileView(page, loadFinished);
  //   } else {
  //     that.drawPageInCanvas(loadFinished);
  //   }

  // });
};
MDPCSVGView.prototype.getOriginData = function () {
  return this.originData;
};
MDPCSVGView.prototype.encodeToType = function (data, type) {
  var dataView = new DataView(data);
  // The TextDecoder interface is documented at http://encoding.spec.whatwg.org/#interface-textdecoder
  var decoder = new TextDecoder(type);
  var decodedString = decoder.decode(dataView);
  var $svg;
  try {
    $svg = $(decodedString);
    var svgArr = [];
    $svg.each(function (index, item) {
      if (item.nodeName == "svg") {
        svgArr.push(item);
      }
    });
    $svg = $(svgArr);
    sanitizeSVGElements($svg);
    this._$svgLayer.empty();
    this._$svgLayer.append($svg);
    this.$svg = this._$svgLayer.find("svg");
    var viewBox = this.$svg.prop("viewBox").baseVal;
    if (!viewBox) {
      this.$svg[0].setAttribute("viewBox", "0 0 ".concat(this.$svg.width(), " ").concat(this.$svg.height()));
      viewBox = this.$svg.prop("viewBox").baseVal;
    }
    if (!viewBox.width) {
      viewBox.width = this.$svg.width();
    }
    if (!viewBox.height) {
      viewBox.height = this.$svg.height();
    }
    this.originW = viewBox.width;
    this.originH = viewBox.height;
    this.originRotateW = this.originW;
    this.originRotateH = this.originH;
    this.imgRatio = this.originH / this.originW;
    this.mmPicObj.setOriginSize(new _MMPoint["default"](this.originW, this.originH));
    this._initSync();
    this.createLayerPanel();
    this.initByOriginSize();
  } catch (e) {
    _MDSnackbarView["default"].show(BabelStr.str(6759));
    console.log(e);
  }
  console.log("---- file opend:" + decodedString);
};
MDPCSVGView.prototype.drawWatermarke = function (angle) {
  var theCanvas = this._$imageLayerMarker[0];
  if (theCanvas) {
    var w = theCanvas.width;
    var h = theCanvas.height;
    theCanvas.getContext("2d").clearRect(0, 0, w, h);
    var ctx = theCanvas.getContext("2d");
    ctx.translate(w / 2, h / 2);
    ctx.rotate(angle * Math.PI / 180);
    // ctx.translate(0, 0);
    ctx.translate(-w / 2, -h / 2);
    MMCommonFun.drawWaterMark(ctx, theCanvas, this);
  }
};
MDPCSVGView.prototype.createLayerPanel = function () {
  if (this.editorMode == _EditorMode["default"].mark) {
    return;
  }
  var that = this;
  var $layersDiv = this.$svg.children("g");
  var layers = [];
  for (var i = 0; i < $layersDiv.length; i++) {
    var g = $layersDiv[i];
    if (g.id) {
      layers.push({
        id: g.id,
        name: g.id
      });
    }
  }
  if (layers.length > 0) {
    if (this.layerPanel) {
      this.layerPanel.remove();
    }
    this.layerPanel = new _MDSVGLayerPanel["default"]({
      layers: layers,
      onClickedCb: function onClickedCb(layer) {
        if (layer.disable) {
          that.$svg.find("#" + layer.id).hide();
        } else {
          that.$svg.find("#" + layer.id).show();
        }
      }
    });
    app.application.addSubView(this.layerPanel, this.parentDiv);
  }
};
MDPCSVGView.prototype.refreshDivsSize = function (clearCanvas) {
  var dispSize = _MMCommonEditorView["default"].prototype.refreshDivsSize.call(this, clearCanvas);
  if (this.$svg) {
    this.$svg.attr("width", dispSize.width);
    this.$svg.attr("height", dispSize.height);
  }
  return dispSize;
};
MDPCSVGView.prototype.getScale = function () {
  return this.scale;
};
MDPCSVGView.prototype.refreshSize = function () {
  var that = this;
  _MMCommonEditorView["default"].prototype.refreshSize.call(this, function () {});
};
MDPCSVGView.prototype.refreshCanvas = function () {
  _MMCommonEditorView["default"].prototype.refreshCanvas.call(this);
  var targetW = this._$editorZone.width();
  var targetH = this._$editorZone.height();
  this.refreshPdfCanvas(targetW, targetH);
  this.updateZoomRectLayer();
};
// variable to avoid dublicated resizing on scale
// var globalo2oScallNumber = null;
MDPCSVGView.prototype.refreshTimeout = function (scale, callback) {
  var that = this;

  // execute the scale
  this.setScaleToFit();
  this.globalo2oScallNumber = Math.random();
  var localo2oScallNumber = this.globalo2oScallNumber;
  requestAnimationFrame(function () {
    if (localo2oScallNumber == this.globalo2oScallNumber) this.refreshEditor(function () {
      that.refreshCanvas();
      if (callback) {
        callback();
      }
    });
  }.bind(this));
};
MDPCSVGView.prototype.changeScale = function (scale, callback) {
  var self = this;
  console.log("----------------- change scale:", scale);
  _MMCommonEditorView["default"].prototype.changeScale.call(this, scale, function () {
    if (!self.pinching) {
      self.refreshCanvas();
    }
    if (callback) {
      callback();
    }
  });
};
MDPCSVGView.prototype.setScale = function (scale) {
  this.scale = scale;
};
MDPCSVGView.prototype.zoomDiv = function (scale) {
  _MMCommonEditorView["default"].prototype.zoomDiv.call(this, scale);
};

// 模拟滚轮结束时的刷新操作
MDPCSVGView.prototype.pinchEnd = function (scale) {
  _MMCommonEditorView["default"].prototype.pinchEnd.call(this, scale);
  this.refreshCanvas();
};
MDPCSVGView.prototype.followTeacher = function (dispPosition, callback) {
  _MMCommonEditorView["default"].prototype.followTeacher.call(this, dispPosition, callback);
  var that = this;
  setBabelTimeout(function () {
    that.refreshCanvas();
  }, 100);
};
MDPCSVGView.prototype.needTileView = function () {
  return this.board.isCADFile();
  return this.mmPicObj.getBoard().getPageCount() == 1;
};
MDPCSVGView.prototype.canNavigate = function () {
  return this.mmPicObj.getBoard().getPageCount() == 1;
};
MDPCSVGView.prototype.refreshPdfCanvas = function (targetW, targetH) {
  if (this.needTileView()) {
    this.drawPageInTileView();
  } else {
    if (!this.isDispPdf() || !this.drawFininshed) {
      return;
    }
    if (this._$drawingPdf) {
      this._$drawingPdf.remove();
    }
    this._$drawingPdf = this._$pdfLayer.clone();
    this._$pdfLayer.before(this._$drawingPdf);
    this._$editorCanvasZone = this.$contentDiv.find(".editor-canvas-zone"); // image 层和 comment 层

    MMCommonFun.initCanvasSize(this._$drawingPdf, targetW, targetH);
    MMPDFDrawerController.getGlobalInstance().clear(this);
    var that = this;
    var drawingPdf = this._$drawingPdf;
    MMPDFDrawerController.getGlobalInstance().drawInCanvas(this, this._$drawingPdf[0], this.page, function () {
      that._$pdfLayer.remove();
      that._$pdfLayer = drawingPdf;
      that._$drawingPdf = null;
      that._$editorCanvasZone = that.$contentDiv.find(".editor-canvas-zone"); // image 层和 comment 层
    });
  }
};
MDPCSVGView.prototype.clearPdfLayer = function () {
  var pdf_canvas = this._$pdfLayer[0];
  if (pdf_canvas) {
    var w = this._$pdfLayer.width();
    var h = this._$pdfLayer.height();
    var ctx = pdf_canvas.getContext("2d");
    ctx.clearRect(0, 0, w, h);
  }
};
MDPCSVGView.prototype.getCurrentFilePageIndex = function () {
  var index = -1;
  if (this.mmPicObj) {
    index = this.mmPicObj.getPageIndex();
  }
  return index;
};
MDPCSVGView.prototype.removeFromSuperView = function () {
  _MMCommonEditorView["default"].prototype.removeFromSuperView.call(this);
  if (this.layerPanel) {
    this.layerPanel.remove();
  }
};
MDPCSVGView.prototype.setCurOperation = function (oper_, objs_, comm_) {
  _MMCommonEditorView["default"].prototype.setCurOperation.call(this, oper_, objs_, comm_);
  this.refreshTextLayerIndex();
};
MDPCSVGView.prototype.useTransformToScale = function () {
  return false;
};

//--------------------------------------------------------------------------------------------------  text layer

MDPCSVGView.prototype.getPdfTextLayer = function () {
  return this._$textLayer;
};
MDPCSVGView.prototype.getPdfTextMarkLayer = function () {
  return this._$scribbleLayer;
};
MDPCSVGView.prototype.registerTextLayerEvents = function () {
  if (this.editorMode == _EditorMode["default"].mark || !this.isDispPdf()) {
    this.textLayerCtl = null;
    return;
  }
  this.textLayerCtl = new MDPdfTextLayerController();
  this.textLayerCtl.listenToPdfPageEditor(this, this.mmPicObj.getBoard(), this.mmPicObj.getPageIndex());
};
MDPCSVGView.prototype.textLayerEmptied = function () {
  if (this.textLayerCtl) {
    this.textLayerCtl.textLayerEmptied();
  }
};
MDPCSVGView.prototype.hasText = function (has) {
  if (has != undefined) {
    this._hasText = has;
  }
  return this._hasText;
};
MDPCSVGView.prototype.refreshTextLayerIndex = function () {
  if (this.editorMode == _EditorMode["default"].mark || !this.isDispPdf()) {
    return;
  }
  if (_MMOperationCenter["default"].getOperation() == "text-mark") {
    $(".text-layer").css("z-index", 400000001);
  } else {
    $(".text-layer").css("z-index", "auto");
  }
};
MDPCSVGView.prototype.removeEvents = function () {
  _Dispatcher["default"].off(null, null, this);
};
MDPCSVGView.prototype.receiveNewMessage = function (payload) {
  payload = payload || {};
  var comment = payload.comment;
  MMCommonFun.refreshTextCommentStatus(comment, this);
};
MDPCSVGView.prototype.textCommentStatusChanged = function (textComment) {
  MMCommonFun.refreshTextCommentStatus(textComment, this);
};
MDPCSVGView.prototype.getZoomList = function () {
  if (this.board.isVirtualBoard()) {
    return null;
  } else {
    var zoomlist = this.calculateZoomList();
    return zoomlist;
  }
};
MDPCSVGView.prototype.getMaxScale = function () {
  return 4;
};
MDPCSVGView.prototype.isLimitMaxScale = function () {
  return false;
};
MDPCSVGView.prototype.calcFinalScale = function (deltaScale) {
  //1. 不允许 deltaScale <= 0
  if (deltaScale <= 0) {
    return 1.0;
  }
  var maxArea = 45000 * 45000; // 最大值
  var minArea = 100 * 100;
  var originConentSize = {
    w: this.originW,
    //this.$contentDiv.width(),
    h: this.originH //this.$contentDiv.height()
  };
  var curDispSize = {
    w: originConentSize.w * this.scale,
    h: originConentSize.h * this.scale
  };
  var curArea = curDispSize.w * curDispSize.h;
  var finalScale = this.scale * deltaScale;
  var scaledSize = {
    w: originConentSize.w * finalScale,
    h: originConentSize.h * finalScale
  };
  var scaledArea = scaledSize.w * scaledSize.h;
  var targetDeltaScale = deltaScale;

  // 不能超过最大最小值
  if (deltaScale < 1) {
    if (curArea > minArea) {
      if (scaledArea < minArea) {
        targetDeltaScale = Math.sqrt(minArea / curArea);
      }
    } else {
      targetDeltaScale = 1.0;
    }
  } else {
    if (curArea < maxArea) {
      if (scaledArea > maxArea) {
        targetDeltaScale = Math.sqrt(maxArea / curArea);
      }
    } else {
      targetDeltaScale = 1.0;
    }
  }

  // 关键比例的捕捉
  var keyScales = [0.5, 1.0]; //-------- 关键比例
  var error = 0.09; //------------ 吸附距离

  var curScale = this.scale;
  if (this.hiddenScale) {
    curScale = this.hiddenScale;
  }
  finalScale = curScale * targetDeltaScale;
  var absorbed = false;
  for (var i = 0; i < keyScales.length; i++) {
    // 吸附发生
    if (Math.abs(keyScales[i] - finalScale) < error) {
      this.hiddenScale = finalScale;
      absorbed = true;
      targetDeltaScale = keyScales[i] / this.scale;
      break;
    }
  }
  if (!absorbed) {
    if (this.hiddenScale) {
      this.hiddenScale = 0;
      targetDeltaScale = finalScale / this.scale;
    }
  }
  console.log("hiddenScale :", this.hiddenScale);
  return targetDeltaScale;
};
MDPCSVGView.prototype.toggleZoomRect = function () {
  if (this.showZoomRectLayer) {
    this.showZoomRectLayer = false;
  } else {
    this.showZoomRectLayer = true;
  }
  this.updateZoomRectLayer();
  return this.showZoomRectLayer;
};
MDPCSVGView.prototype._onScroll = function () {
  _MMCommonEditorView["default"].prototype._onScroll.call(this);
  this.updateZoomRectLayer();
};
MDPCSVGView.prototype.isShowingZoomRect = function () {
  return this.showZoomRectLayer;
};
MDPCSVGView.prototype.updateZoomRectLayer = function () {
  _MMCommonEditorView["default"].prototype._onScroll.call(this);
  if (!this.$zoomRectLayer) {
    this.$zoomRectLayer = this.$contentDiv.find(".zoomrect-layer");
  }
  if (!this.showZoomRectLayer) {
    this.$zoomRectLayer.hide();
    return;
  }
  this.$zoomRectLayer.show();
  var x = this.container.scrollLeft;
  var y = this.container.scrollTop;
  var w = document.documentElement.clientWidth;
  var h = document.documentElement.clientHeight;
  this.$zoomRectLayer.css("left", x + "px");
  this.$zoomRectLayer.css("top", y + "px");
  this.$zoomRectLayer.attr("width", w + "px");
  this.$zoomRectLayer.attr("height", h + "px");
};
MDPCSVGView.prototype.zoomRectMouseDown = function (e) {
  this.zoomRectX = e.offsetX;
  this.zoomRectY = e.offsetY;
  var context = this.$zoomRectLayer[0].getContext("2d");
  context.strokeStyle = "rgb(250, 20, 83)";
  this.zoomRectCaptured = true;
};
MDPCSVGView.prototype.zoomRectMouseUp = function (e) {
  this.zoomRectCaptured = false;
  if (Math.abs(this.zoomRectW) < 2) {
    this.zoomRectW = 1;
  }
  if (Math.abs(this.zoomRectH) < 2) {
    this.zoomRectH = 1;
  }
  var zoomDiff = 1.0;
  if (this.zoomRectW == 1 && this.zoomRectH == 1) {
    zoomDiff = 1.1;
  } else {
    var r1 = document.documentElement.clientWidth / document.documentElement.clientHeight;
    var r2 = this.zoomRectW / this.zoomRectH;
    if (r2 >= r1) {
      // 以宽为准
      zoomDiff = document.documentElement.clientWidth / this.zoomRectW;
    } else {
      zoomDiff = document.documentElement.clientHeight / this.zoomRectH;
    }
  }
  var context = this.$zoomRectLayer[0].getContext("2d");
  context.clearRect(0, 0, this.$zoomRectLayer[0].width, this.$zoomRectLayer[0].height);
  var cX = (this.container.scrollLeft + this.zoomRectX + this.zoomRectW / 2) / this.container.scrollWidth;
  var cY = (this.container.scrollTop + this.zoomRectY + this.zoomRectH / 2) / this.container.scrollHeight;
  this.zoomCenterX = cX / this.$contentDiv.width();
  this.zoomCenterY = cY / this.$contentDiv.height();
  var deltaScale = this.calcFinalScale(zoomDiff);
  var self = this;
  var scale = this.scale * deltaScale;
  this.changeScale(scale, function () {
    setBabelTimeout(function () {
      var nCx = cX * self.originW * scale;
      var nCy = cY * self.originH * scale;
      self.container.scrollLeft = nCx - document.documentElement.clientWidth / 2;
      self.container.scrollTop = nCy - document.documentElement.clientHeight / 2;
    }, 100);
  });
  this.disableZoomRectLayer();
  _Dispatcher["default"].trigger(_MDEvents["default"].HideZoomRectLayer);
};
MDPCSVGView.prototype.zoomRectMouseMove = function (e) {
  if (this.zoomRectCaptured) {
    var w = e.offsetX - this.zoomRectX;
    var h = e.offsetY - this.zoomRectY;
    var context = this.$zoomRectLayer[0].getContext("2d");
    context.clearRect(0, 0, this.$zoomRectLayer[0].width, this.$zoomRectLayer[0].height);
    context.strokeRect(this.zoomRectX, this.zoomRectY, w, h);
    this.zoomRectW = w;
    this.zoomRectH = h;
  }
  _Dispatcher["default"].trigger(_MDEvents["default"].DISPLAY_ZOOM_BAR);
};
MDPCSVGView.prototype.disableZoomRectLayer = function () {
  this.showZoomRectLayer = false;
  this.updateZoomRectLayer();
};
var _default = exports["default"] = MDPCSVGView;

},{"1104":1104,"1184":1184,"1411":1411,"1412":1412,"1417":1417,"1421":1421,"1434":1434,"1438":1438,"1439":1439,"1454":1454,"1463":1463,"1477":1477,"18":18,"325":325,"72":72,"823":823,"830":830,"874":874,"904":904,"914":914,"944":944}],944:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1439);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDBasicToolPanel2 = _interopRequireDefault(require(456));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } //  svg layer panel
// path: /javascript/molasync-source/ui/netdisk/pc/editor/MDSVGLayerPanel.js
// jiang
// 2018-7-29
var MDSVGLayerPanel = exports["default"] = /*#__PURE__*/function (_MDBasicToolPanel) {
  (0, _inherits2["default"])(MDSVGLayerPanel, _MDBasicToolPanel);
  function MDSVGLayerPanel() {
    (0, _classCallCheck2["default"])(this, MDSVGLayerPanel);
    return _callSuper(this, MDSVGLayerPanel, arguments);
  }
  (0, _createClass2["default"])(MDSVGLayerPanel, [{
    key: "initialize",
    value: function initialize(props) {
      props.inEditor = true;
      props.normalEditorPanel = true;
      props.hideCloseBtn = true;
      props.width = 150;
      props.backgroundColor = "";
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSVGLayerPanel.prototype), "initialize", this).call(this, props);
      var self = this;
      this.setTitle(BabelStr.str(751)); // ('图层列表');
      this.showSubTitle();
      this.initLayers(props.layers);
      this.showPanel({
        left: '80px',
        top: '10px'
      });
    }
  }, {
    key: "className",
    value: function className() {
      return 'svg-layer-panel';
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDSVGLayerPanel.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click li>button ': this._toggleLayer
      });
    }
  }, {
    key: "initLayers",
    value: function initLayers(layers) {
      this.$('.tool-p-content').empty();
      var $ul = $('<ul class="layer-list"></ul>');
      for (var i = 0; i < layers.length; i++) {
        var layer = layers[i];
        var $li = '<li id="' + layer.id + '">' + '<button class=""><span class="icon icon20"></span></button>' + '<span class="layer-name">' + layer.name + '</span>' + '</li>';
        $ul.append($li);
      }
      this.$('.tool-p-content').append($ul);
    }
  }, {
    key: "setEditorViewCtl",
    value: function setEditorViewCtl(editorViewCtl) {
      this.editorViewCtl = editorViewCtl;
    }
  }, {
    key: "_toggleLayer",
    value: function _toggleLayer(e) {
      var $li = $(e.currentTarget).parent();
      var i = $li.index();
      if (this.layers[i].disable) {
        this.layers[i].disable = false;
        $(e.currentTarget).removeClass('disable');
      } else {
        this.layers[i].disable = true;
        $(e.currentTarget).addClass('disable');
      }
      this.onClickedCb(this.layers[i]);
    }
  }]);
  return MDSVGLayerPanel;
}(_MDBasicToolPanel2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"456":456}],456:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1466);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMViewBase2 = _interopRequireDefault(require(22));
var _MMBasicData = _interopRequireDefault(require(811));
var _Dispatcher = _interopRequireDefault(require(18));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // MDBasicToolPanel.js
// jiang
// 2017-5-11
var MDBasicToolPanel = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MDBasicToolPanel, _MMViewBase);
  function MDBasicToolPanel() {
    (0, _classCallCheck2["default"])(this, MDBasicToolPanel);
    return _callSuper(this, MDBasicToolPanel, arguments);
  }
  (0, _createClass2["default"])(MDBasicToolPanel, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n      <div class=\"tool-panel tool-panel-pallet\">\n        <div class=\"tool-p-header\">\n          <div class=\"tool-handle\"></div>\n          <button class=\"tool-p-close icon\"></button>\n        </div>\n        <div class=\"tool-p-title\"></div>\n        <div class=\"tool-p-subtitle\"></div>\n        <div class=\"tool-p-content\"></div>\n        <div class=\"display-btn f-none\">        \n        </div>\n      </div>\n      \n      ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBasicToolPanel.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        closeIsHide: false,
        closeIsShowBtn: false
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBasicToolPanel.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .tool-p-close ': this._closeHandler,
        'mousewheel .tool-panel ': this._wheelHandler,
        'click .display-btn': this.hideDisBtn
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      this.strClassName = 'MDBasicToolPanel';
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBasicToolPanel.prototype), "initialize", this).call(this, props);
      if (this.hideCloseBtn) {
        this.$('.tool-p-close').remove();
      }
      if (this.width) {
        this.$('.tool-panel').width(this.width);
      }
      if (this.elClassName) {
        this.$('.tool-panel').addClass(this.elClassName);
      }
      ;
      if (props.inEditor) {
        this.initInEditor();
      } else {
        this.initOutEditor();
      }
      if (props.normalEditorPanel) {
        this.$('.tool-panel').addClass('normal-editor-panel');
      }
      var self = this;
      this._winResizeFun = function (e) {
        self._winResized(e);
      };
      $(window).resize(this._winResizeFun);
    }
  }, {
    key: "_winResized",
    value: function _winResized(e) {
      console.log('--------> resized!');
      if (!this.inEditor) {
        return;
      }
      ;
      var xCssName = 'left';
      var yCssName = 'top';
      if (this.anchorPoint == 'rightBottom') {
        xCssName = 'right';
        yCssName = 'bottom';
      } else if (this.anchorPoint == 'leftTop') {} else {
        return;
      }
      var yPos = parseInt(this.$('.tool-panel').css(yCssName));
      var xPos = parseInt(this.$('.tool-panel').css(xCssName));
      if (this.anchorPoint == 'rightBottom') {
        // adjust y position
        var maxYPos = window.innerHeight - this.$('.tool-panel')[0].offsetHeight;
        if (this.originY + this.$('.tool-panel')[0].offsetHeight < window.innerHeight) {
          yPos = this.originY;
        } else if (yPos != maxYPos) {
          yPos = maxYPos;
        }
        this.$('.tool-panel').css(yCssName, yPos + 'px');
      } else if (this.anchorPoint == 'leftTop') {} else {
        return;
      }
    }
  }, {
    key: "initInEditor",
    value: function initInEditor() {
      var _this = this;
      this.$('.tool-panel').addClass('in-editor');
      var z_startIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
      this.$('.tool-panel').css('z-index', z_startIndex);
      this.hideSubTitle();
      this.$('.tool-p-header').on('mousedown', function (e) {
        _this._onmouseDown(e);
      });
    }
  }, {
    key: "setDisButtonText",
    value: function setDisButtonText(text) {
      this.$('.display-btn').text(text);
    }
  }, {
    key: "showSubTitle",
    value: function showSubTitle() {
      this.$('.tool-p-subtitle').show();
    }
  }, {
    key: "setSubTitle",
    value: function setSubTitle(str) {
      this.$('.tool-p-subtitle').html(str);
      this.showSubTitle();
    }
  }, {
    key: "hideSubTitle",
    value: function hideSubTitle() {
      this.$('.tool-p-subtitle').hide();
    }
  }, {
    key: "setTitle",
    value: function setTitle(title) {
      this.$('.tool-p-title').text(title);
    }
    // setSubTitle(title) {
    //   this.$('.tool-p-subtitle').text(title);
    // }
  }, {
    key: "initOutEditor",
    value: function initOutEditor() {
      // this.$('.tool-panel').css('z-index', 10);
      var z_startIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
      this.$el.css('z-index', z_startIndex);
      this.$('.tool-panel').addClass('out-editor');
    }
  }, {
    key: "remove",
    value: function remove(opt_removeRef) {
      this.$('.tool-panel').off();
      $(window).off("resize", this._winResizeFun);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDBasicToolPanel.prototype), "remove", this).call(this, opt_removeRef);
    }
  }, {
    key: "_wheelHandler",
    value: function _wheelHandler(e) {
      e.stopPropagation();
    }
  }, {
    key: "_onmouseDown",
    value: function _onmouseDown(e) {
      var _this2 = this;
      this.preX = e.screenX;
      this.preY = e.screenY;
      this.$rootlayer = $('body');
      this.$rootlayer.on('mousemove.evaluation', function (e) {
        _this2._onmouseMove(e);
      });
      this.$rootlayer.on('mouseup.evaluation', function () {
        _this2._onmouseUp();
      });
    }
  }, {
    key: "_onmouseMove",
    value: function _onmouseMove(e) {
      var curX = e.screenX;
      var curY = e.screenY;
      var offX = curX - this.preX;
      var offY = curY - this.preY;
      var xCssName = 'left';
      var yCssName = 'top';
      if (this.anchorPoint == 'rightBottom') {
        xCssName = 'right';
        yCssName = 'bottom';
      } else if (this.anchorPoint == 'leftTop') {} else if (this.anchorPoint == 'topRight') {
        xCssName = 'right';
      } else {
        yCssName = 'bottom';
      }
      var yPos = parseInt(this.$('.tool-panel').css(yCssName));
      var xPos = parseInt(this.$('.tool-panel').css(xCssName));
      if (this.anchorPoint == 'rightBottom') {
        yPos -= offY;
        xPos -= offX;
      } else if (this.anchorPoint == 'leftTop') {
        yPos += offY;
        xPos += offX;
      } else if (this.anchorPoint == 'topRight') {
        xPos -= offX;
        yPos += offY;
      } else {
        yPos -= offY;
        xPos += offX;
      }
      this.$('.tool-panel').css(yCssName, yPos + 'px');
      this.$('.tool-panel').css(xCssName, xPos + 'px');
      this.preX = curX;
      this.preY = curY;
      this.originX = xPos;
      this.originY = yPos;
      console.log('------ mouse move!');
    }
  }, {
    key: "_onmouseUp",
    value: function _onmouseUp() {
      this.$rootlayer.off('mousemove.evaluation');
      this.$rootlayer.off('mouseup.evaluation');
    }
  }, {
    key: "_closeHandler",
    value: function _closeHandler() {
      if (this.closeIsHide) {
        this.hidePanel();
      } else if (this.closeIsShowBtn) {
        this.showDisBtn();
      } else {
        this.remove();
      }
    }
  }, {
    key: "showPanel",
    value: function showPanel(anchorPoint) {
      anchorPoint = anchorPoint || {
        "right": "10px",
        "bottom": "50px"
      };
      var left = parseInt(anchorPoint.left);
      var top = parseInt(anchorPoint.top);
      var right = parseInt(anchorPoint.right);
      var bottom = parseInt(anchorPoint.bottom);
      this.anchorPoint = null;
      var xPos = 0;
      var yPos = 0;
      var xCssName = 'left';
      var yCssName = 'top';
      if (!isNaN(left) && !isNaN(top)) {
        this.anchorPoint = 'leftTop';
        xPos = left;
        yPos = top;
      } else if (!isNaN(right) && !isNaN(bottom)) {
        this.anchorPoint = 'rightBottom';
        xPos = right;
        xCssName = 'right';
        yPos = bottom;
        yCssName = 'bottom';
      } else if (!isNaN(right) && !isNaN(top)) {
        this.anchorPoint = 'topRight';
        xPos = right;
        xCssName = 'right';
        yPos = top;
        yCssName = 'top';
      } else {
        this.anchorPoint = 'leftBottom';
        xPos = left;
        xCssName = 'left';
        yPos = bottom;
        yCssName = 'bottom';
      }
      if (!this.anchorPoint) {
        console.error('错误的位置参数');
        return;
      }
      ;
      this.$el.show();
      this.$('.tool-panel').css(xCssName, xPos + 'px');
      this.$('.tool-panel').css(yCssName, yPos + 'px');
      this.onShow();
      this.originX = xPos;
      this.originY = yPos;
    }
  }, {
    key: "onHide",
    value: function onHide() {}
  }, {
    key: "onShow",
    value: function onShow() {}
  }, {
    key: "hidePanel",
    value: function hidePanel() {
      this.$el.hide();
      this.onHide();
    }
  }, {
    key: "showDisBtn",
    value: function showDisBtn() {
      this.$('.tool-panel').addClass('show-dis-btn');
    }
  }, {
    key: "hideDisBtn",
    value: function hideDisBtn() {
      this.$('.tool-panel').removeClass('show-dis-btn');
    }
  }, {
    key: "isShowing",
    value: function isShowing() {
      return this.$el.css('display') == 'block';
    }
  }, {
    key: "setShow",
    value: function setShow(show) {
      if (!show) {
        this.hidePanel();
      } else {
        this.$el.show();
      }
    }
  }]);
  return MDBasicToolPanel;
}(_MMViewBase2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1466":1466,"1475":1475,"18":18,"22":22,"811":811}],916:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1421);
require(1423);
require(1463);
require(1487);
require(1538);
require(1545);
require(1543);
require(1417);
var _goog = _interopRequireDefault(require(823));
var _MMCommonEditorView = _interopRequireDefault(require(914));
var _MDBabelTileView = _interopRequireDefault(require(453));
var _ObjType = _interopRequireDefault(require(1084));
var _EditorMode = _interopRequireDefault(require(904));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDMessageView = _interopRequireDefault(require(55));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MEWaterMarkRenderer = _interopRequireDefault(require(808));
var _utils = _interopRequireDefault(require(108));
/**
 * 一比一显示原图
 */

var MMPCImageEditor = function MMPCImageEditor(containerDiv, opt) {
  this.editorViewCtl = opt && opt.editorViewCtl;
  _MMCommonEditorView["default"].call(this, containerDiv);
  this.imageSrc = null;
  this._useOnlyDispClientWatermark = false;
  this.changeBackgroundForPng();
  this.changeBackgroundForJpg();
  $(this.container).css("pointer-events", "auto");
  this.disableSysTouchEvents();
  this.curIndex = -1;
  Dispatcher.on(MDEvents.COMMENT_CREATE, this._commentCreatedInPage, this);
  Dispatcher.on(MDEvents.DATA_READY, this._commentCreated, this);
  this.className = "MMPCImageEditor";
  _czc && _czc.push(["_trackEvent", "预览", "图片", "", "", ""]);
};
_goog["default"].inherits(MMPCImageEditor, _MMCommonEditorView["default"]);
var g_pcImgEditor = null;
MMPCImageEditor.getSingleInstance = function (parentDiv) {
  if (g_pcImgEditor == null) {
    g_pcImgEditor = new MMPCImageEditor(parentDiv);
  }
  return g_pcImgEditor;
};
MMPCImageEditor.removeSingleInstance = function () {
  if (g_pcImgEditor) {
    g_pcImgEditor.removeFromSuperView();
  }
  g_pcImgEditor = null;
};
MMPCImageEditor.prototype.displayObject = function (img, opt, loadFinished) {
  if (img) {
    if (this.mmImg != img) {
      this.needTile = null;
      var that = this;
      MMPCImageEditor.superClass_.displayObject.call(this, img, opt, loadFinished);
    }
  }
};
MMPCImageEditor.prototype.constructView = function (loadFinished) {
  _MMCommonEditorView["default"].prototype.constructView.call(this, loadFinished);
};
MMPCImageEditor.prototype._needTileImage = function (callback) {
  // 非企业版不支持切图
  if (!app.isEpVersion()) {
    callback(false);
    return;
  }
  if (this.editorMode == _EditorMode["default"].mark) {
    callback(false);
    return;
  }

  // 查看缓存
  if (this.needTile != null) {
    callback(this.needTile);
    return;
  }

  // 询问服务器
  var originSize = this.mmPicObj.getOriginSize();
  var self = this;

  // if (!originSize) {
  //   if (!this.showErrorImage) {
  //     MDAlertView.showStandardPrompt({
  //       title: BabelStr.str(170),
  //       message: BabelStr.str(5091),
  //       okFun: function(){
  //         self.showErrorImage = false;
  //       }
  //     })
  //   }
  //   this.showErrorImage = true;
  //   callback(false);

  //   return;
  // };

  var self = this;
  var whiteboard = this.mmPicObj.getBoard();
  var fileInfo = whiteboard.getFileInfo();
  if (fileInfo && originSize && originSize.x * originSize.y >= 2048 * 2048) {
    $.ajax({
      async: false,
      type: "POST",
      url: "/netdrive/isSliceImageExist.do",
      dataType: "json",
      data: {
        fileId: fileInfo.getFileId(),
        version: this.mmPicObj.getFileVersion(),
        scale: 1
      },
      success: function success(resp) {
        if (resp["success"]) {
          self.needTile = true;
          callback(true);
        } else {
          self.needTile = false;
          callback(false);
        }
      },
      error: function error(e) {
        callback(false);
      }
    });
  } else {
    this.needTile = false;
    callback(false);
  }
};
MMPCImageEditor.prototype._createLayers = function (callback) {
  this._needTileImage(function (need) {
    var $layers = null;
    if (need) {
      $layers = $("<div class='image-background editor-zone' style='position:absolute; left:0px; top:0px;background-image:url(/img/rect.jpg);background-repeat:repeat'></div>" + "<div class='editor-zone' style='position:absolute; left:0px; top:0px;background-size:100% 100%;background-repeat:none'>" + "<div class='image-tile-layer image-layer' style='position:absolute; left:0px; top:0px; '></div>" + "<canvas class='image-layer-marker' style='position:absolute; pointer-events:none'></canvas>" + "</div>" + "<canvas class='scribble-layer editor-canvas-zone' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 0, 0, 0.0);pointer-events:none;'></canvas>" + "<canvas class='comment-line-layer assist_layer' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 0, 0, 0.0);pointer-events:none;'></canvas>" + "<div class='comment-layer editor-zone' style='position:absolute; box-shadow:0 0 10px rgba(0,0,0,0.25);overflow: hidden; left:0px; top:0px;pointer-events:none;z-index: 390000000;'></div>" + "<canvas class='operate-layer assist_layer f-selectable' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 0, 0, 0.0); z-index: 400000000;'></canvas>");
    } else {
      $layers = $("<div class='image-background editor-zone' style='position:absolute; left:0px; top:0px;background-image:url(/img/rect.jpg);background-repeat:repeat'></div>" + "<div class='editor-zone' style='position:absolute; left:0px; top:0px;background-size:100% 100%;background-repeat:none'>" + "<canvas class='image-layer image-canvas-layer' crossOrigin='anonymous' style='position:absolute'></canvas>" + "<img class='image-layer image-img-layer' crossOrigin='anonymous' style='position:absolute;width:100%;height:100%;object-fit:contain;pointer-events:none'></img>" + "</div>" + "<canvas class='scribble-layer editor-canvas-zone' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 0, 0, 0.0);pointer-events:none;'></canvas>" + "<canvas class='comment-line-layer assist_layer' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 0, 0, 0.0);pointer-events:none;'></canvas>" + "<div class='comment-layer editor-zone' style='position:absolute; box-shadow:0 0 10px rgba(0,0,0,0.25);overflow: hidden; left:0px; top:0px;pointer-events:none;z-index: 390000000;'></div>" + "<canvas class='operate-layer assist_layer f-selectable' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 0, 0, 0.0); z-index: 400000000;'></canvas>");
    }
    callback($layers);
  });

  // if (!this._needTileImage()) {
  //   return $("<div class='image-background editor-zone' style='position:absolute; left:0px; top:0px;background-image:url(/img/rect.jpg);background-repeat:repeat'></div>" +
  //     "<img class='image-layer editor-zone' style='position:absolute; left:0px; top:0px;background-size:100% 100%;background-repeat:none'></img>" +
  //     "<canvas class='scribble-layer editor-canvas-zone' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 0, 0, 0.0);pointer-events:none;'></canvas>" +
  //     "<canvas class='comment-line-layer assist_layer' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 0, 0, 0.0);pointer-events:none;'></canvas>" +
  //     "<div class='comment-layer editor-zone' style='position:absolute; box-shadow:0 0 10px rgba(0,0,0,0.25);overflow: hidden; left:0px; top:0px;pointer-events:none;z-index: 390000000;'></div>" +
  //     "<canvas class='operate-layer assist_layer f-selectable' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 0, 0, 0.0); z-index: 400000000;'></canvas>"
  //   )

  // } else {
  //   return $("<div class='image-background editor-zone' style='position:absolute; left:0px; top:0px;background-image:url(/img/rect.jpg);background-repeat:repeat'></div>" +
  //     "<div class='image-tile-layer editor-zone' style='position:absolute; left:0px; top:0px;background-size:100% 100%;background-repeat:none'></div>" +
  //     "<canvas class='scribble-layer editor-canvas-zone' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 0, 0, 0.0);pointer-events:none;'></canvas>" +
  //     "<canvas class='comment-line-layer assist_layer' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 0, 0, 0.0);pointer-events:none;'></canvas>" +
  //     "<div class='comment-layer editor-zone' style='position:absolute; box-shadow:0 0 10px rgba(0,0,0,0.25);overflow: hidden; left:0px; top:0px;pointer-events:none;z-index: 390000000;'></div>" +
  //     "<canvas class='operate-layer assist_layer f-selectable' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 0, 0, 0.0); z-index: 400000000;'></canvas>"
  //   )
  // }
};
MMPCImageEditor.prototype.drawFile = function (filePath, loadFinished) {
  var that = this;
  this._useOnlyDispClientWatermark = false;
  function loaded(param) {
    loadFinished(param);
  }
  this._needTileImage(function (need) {
    if (!need) {
      that._updateImageLayerMode();
      var isDotmtxCli = that._isDotmtxCliImage();
      if (isDotmtxCli) {
        var url = filePath;
        url += (url.indexOf('?') >= 0 ? '&' : '?') + 'dotmtxcli=1';
        if (url.indexOf('needJump2Url=') < 0) {
          url += '&needJump2Url=0';
        }
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.responseType = "json";
        xhr.onload = function () {
          if (xhr.status !== 200) {
            if (loaded) loaded(false);
            return;
          }
          var resp = xhr.response;
          if (!resp) {
            if (loaded) loaded(false);
            return;
          }
          if (resp.code == "10010") {
            resp["msg"] = BabelStr.str(108);
            _MDAlertView["default"].showStandardPrompt({
              message: resp.code + "-" + resp["msg"]
            });
            if (loaded) loaded(false);
            return;
          }
          if (resp.code === 0 && resp.success && resp.url) {
            var xhr2 = new XMLHttpRequest();
            xhr2.open("GET", resp.url, true);
            xhr2.responseType = "arraybuffer";
            xhr2.onload = function () {
              if (xhr2.status !== 200) {
                if (loaded) loaded(false);
                return;
              }
              var whiteboard = that.mmPicObj.getBoard();
              var fileInfo = whiteboard && whiteboard.getFileInfo();
              var waterkey = fileInfo && fileInfo.get("waterkey");
              function loadImageWithWaterkey(key) {
                var blobData;
                if (key) {
                  var decryptedBuffer = _utils["default"].decryptFirstChunk(xhr2.response, key);
                  blobData = new Blob([decryptedBuffer]);
                } else {
                  blobData = new Blob([xhr2.response]);
                }
                var blobUrl = URL.createObjectURL(blobData);
                var img = new Image();
                img.crossOrigin = "anonymous";
                img.onload = function () {
                  URL.revokeObjectURL(blobUrl);
                  that.originW = img.naturalWidth;
                  that.originH = img.naturalHeight;
                  that._loadedImg = img;
                  that.initRotateAngle();
                  that.setScaleToFit();
                  that.refreshDivsSize();
                  that._initSync(loaded);
                  that.restoreBackgroundColor();
                  if (loaded) loaded(true);
                };
                img.onerror = function () {
                  if (loaded) loaded(false);
                };
                img.src = blobUrl;
                that.imageSrc = filePath;
              }
              if (!waterkey && fileInfo) {
                $.ajax({
                  type: "POST",
                  url: "/netdrive/isFileConvertFinished.do",
                  dataType: "json",
                  data: {
                    fileId: fileInfo.getFileId(),
                    version: that.mmPicObj.getFileVersion(),
                    dotmtxcli: app.ep.getdotmtxcli()
                  },
                  success: function success(resp) {
                    if (resp && resp.waterkey) {
                      fileInfo.set("waterkey", resp.waterkey);
                      loadImageWithWaterkey(resp.waterkey);
                    } else if (resp && resp.code == "10010") {
                      resp["msg"] = BabelStr.str(108);
                      _MDAlertView["default"].showStandardPrompt({
                        message: resp.code + "-" + resp["msg"]
                      });
                      if (loaded) loaded(false);
                    } else {
                      loadImageWithWaterkey(null);
                    }
                  },
                  error: function error() {
                    loadImageWithWaterkey(null);
                  }
                });
              } else {
                loadImageWithWaterkey(waterkey);
              }
            };
            xhr2.onerror = function () {
              if (loaded) loaded(false);
            };
            xhr2.send();
          } else {
            if (loaded) loaded(false);
          }
        };
        xhr.onerror = function () {
          if (loaded) loaded(false);
        };
        xhr.send();
      } else {
        var handleImageLoadError = function handleImageLoadError(img) {
          if (!hasRetriedOnlyDisp) {
            hasRetriedOnlyDisp = true;
            if (fileInfo) fileInfo.setOnlyDisp(true);
            that._useOnlyDispClientWatermark = true;
            that._updateImageLayerMode();
            that.imageSrc = onlyDispFilePath;
            img.src = onlyDispFilePath;
            return;
          }
          if (loaded) loaded(false);
        };
        var board = that.mmPicObj.getBoard();
        var fileInfo = board && board.getFileInfo();
        var onlyDispFilePath = _MMCommonFun["default"].getImageOnlyDispPath(board.getStringId(), that.mmPicObj.getFileVersion());
        var hasRetriedOnlyDisp = filePath === onlyDispFilePath;
        var $img = that._$imageLayer;
        if ($img && $img[0] && $img[0].tagName === 'IMG') {
          var imgElement = $img[0];
          imgElement.crossOrigin = "anonymous";
          imgElement.onload = function () {
            // Scaled previews reuse this element; only the initial file load
            // should initialize dimensions and reset the zoom.
            imgElement.onload = null;
            imgElement.onerror = null;
            that.originW = imgElement.naturalWidth;
            that.originH = imgElement.naturalHeight;
            that._loadedImg = imgElement;
            that.initRotateAngle();
            that.setScaleToFit();
            that.refreshDivsSize();
            that._initSync(loaded);
            that.restoreBackgroundColor();
            if (loaded) loaded(true);
          };
          imgElement.onerror = function () {
            handleImageLoadError(imgElement);
          };
          imgElement.src = filePath;
        } else {
          var img = new Image();
          img.crossOrigin = "anonymous";
          img.onload = function () {
            that.originW = img.naturalWidth;
            that.originH = img.naturalHeight;
            that._loadedImg = img;
            that.initRotateAngle();
            that.setScaleToFit();
            that.refreshDivsSize();
            that._initSync(loaded);
            that.restoreBackgroundColor();
            if (loaded) loaded(true);
          };
          img.onerror = function () {
            handleImageLoadError(img);
          };
          img.src = filePath;
        }
        that.imageSrc = filePath;
      }
    } else {
      var $tileContainer = that.$contentDiv.find(".image-tile-layer");
      var $scrollView = $(".p-editor-zone>.android-container");
      if ($scrollView.length == 0) {
        console.error("div 层次发生了变化，需要修改此处的代码");
        return;
      }
      that.__naturalSize.css("display", "block");
      that._initSync(loaded);
      that.tileView = new _MDBabelTileView["default"](that.mmPicObj, $tileContainer[0], $scrollView[0], {
        editorViewCtl: that.editorViewCtl
      });
      that.tileView.refresh(that.scale);
      if (loaded) {
        loaded(false);
      }
    }
    that.restoreBackgroundColor();
  });
};
MMPCImageEditor.prototype.initNavigator = function () {
  var width = this.originRotateW;
  var height = this.originRotateH;
  var sizeImg = width > height ? width : height;
  var baseSize = 200;
  if (sizeImg > 1000) {
    baseSize = baseSize * 2;
  } else if (sizeImg > 6000) {
    baseSize = baseSize * 3;
  } else {
    baseSize = 200;
  }
  var angle = this.angle;
  var isTile = !!this.tileView;
  var lowFilePath;
  if (this._shouldUseClientWatermark()) {
    var $canvas = isTile ? this._$imageLayerMarker : this._$imageLayer;
    lowFilePath = $canvas[0];
  } else {
    lowFilePath = this.mmPicObj.getThumbnailUrl(false, baseSize);
  }
  // var lowFilePath = this.mmPicObj.getThumbnailUrl(false, baseSize);

  if (this.navigatorMap) {
    this.navigatorMap.initNavigator(this.winW, this.winH, this.imgRatio, lowFilePath, angle);
  }
};
MMPCImageEditor.prototype.drawWatermarke = function (angle) {
  if (!this._shouldUseClientWatermark()) {
    return;
  }
  var isTile = !!this.tileView;
  var $canvas = isTile ? this._$imageLayerMarker : this._$imageLayer;
  var canvas = $canvas && $canvas[0];
  if (!canvas) return;
  var $zone = this._$editorZone;
  var cssWidth = $zone.width();
  var cssHeight = $zone.height();
  if (cssWidth <= 0 || cssHeight <= 0) return;
  var dpr = window.devicePixelRatio || 1;
  var pixelWidth = Math.round(cssWidth * dpr);
  var pixelHeight = Math.round(cssHeight * dpr);
  canvas.style.setProperty("width", cssWidth + "px", "important");
  canvas.style.setProperty("height", cssHeight + "px", "important");
  canvas.style.setProperty("display", "block", "important");
  canvas.style.setProperty("position", "absolute", "important");
  canvas.style.setProperty("left", "0px", "important");
  canvas.style.setProperty("top", "0px", "important");
  canvas.style.setProperty("pointer-events", "none", "important");
  canvas.style.setProperty("z-index", "1", "important");
  if (canvas.width !== pixelWidth || canvas.height !== pixelHeight) {
    canvas.width = pixelWidth;
    canvas.height = pixelHeight;
  }
  var ctx = canvas.getContext("2d");
  ctx.setTransform(1, 0, 0, 1, 0, 0);
  ctx.clearRect(0, 0, pixelWidth, pixelHeight);
  if (!isTile) {
    var img = this._loadedImg;
    if (img && img.complete && img.naturalWidth) {
      try {
        ctx.save();
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.drawImage(img, 0, 0, cssWidth, cssHeight);
        ctx.restore();
      } catch (e) {}
    } else {
      return;
    }
  }
  var whiteboard = this.mmPicObj.getBoard();
  var fileInfo = whiteboard.getFileInfo();
  var watermarkInfo = fileInfo.get("watermarkInfo");
  if (watermarkInfo) {
    _MEWaterMarkRenderer["default"]._drawWaterMark(ctx, canvas, watermarkInfo);
  }
};
MMPCImageEditor.prototype._isDotmtxCliImage = function () {
  if (!app.ep.getdotmtxcli()) return false;
  var whiteboard = this.mmPicObj && this.mmPicObj.getBoard();
  var fileInfo = whiteboard && whiteboard.getFileInfo();
  var watermarkInfo = fileInfo && fileInfo.get("watermarkInfo");
  return watermarkInfo && watermarkInfo.watermarkType === 7;
};
MMPCImageEditor.prototype._shouldUseClientWatermark = function () {
  return this._isDotmtxCliImage() || this._useOnlyDispClientWatermark;
};
MMPCImageEditor.prototype._updateImageLayerMode = function () {
  var $imageCanvasLayer = this.$contentDiv.find(".image-canvas-layer");
  var $imageImgLayer = this.$contentDiv.find(".image-img-layer");
  if (this._shouldUseClientWatermark()) {
    $imageCanvasLayer.show();
    $imageImgLayer.hide();
    this._$imageLayer = $imageCanvasLayer;
  } else {
    $imageCanvasLayer.hide();
    $imageImgLayer.show();
    this._$imageLayer = $imageImgLayer;
  }
};
MMPCImageEditor.prototype._initLayerVars = function () {
  _MMCommonEditorView["default"].prototype._initLayerVars.call(this);
  this._updateImageLayerMode();
  this._$imgBackground = this.$contentDiv.find(".image-background");
  this._$imageLayerMarker = this.$contentDiv.find(".image-layer-marker");
};
MMPCImageEditor.prototype._positionOtherLayer = function (marginLeft, marginTop) {};
MMPCImageEditor.prototype.changeToImage = function (pgindex, callback) {
  Dispatcher.trigger(MDEvents.SELECT_NULL_OPERATION);
  if (_MDPcMobileEditorCommonFun["default"].getMainEditor().commentPanel) _MDPcMobileEditorCommonFun["default"].getMainEditor().commentPanel.closePanelWithOppositeDir();
  this.initImageByIndex(pgindex, callback);
};
MMPCImageEditor.prototype.initImageByIndex = function (index, callback) {
  var curTask = _MDPcMobileEditorCommonFun["default"].getMainEditor().getCurrentBoard();
  if (curTask) {
    var imgObjs = curTask.getImgPdfObjects();
    if (index >= imgObjs.length || index < 0) {
      return;
    }
    if (index < imgObjs.length) {
      var img = imgObjs[index];
      var that = this;
      this.displayObject(img, function (e) {
        if (img.getObjType() == _ObjType["default"].Obj_Image) {
          that.zoomToFit();
        }
        if (callback) {
          setBabelTimeout(function () {
            callback();
          }, 0);
        }
      });
      this.curIndex = index;
      Dispatcher.trigger(MDEvents.SET_PAGE_INDEX, index);
    }
  }
};
MMPCImageEditor.prototype.initByImage = function (img) {
  var that = this;
  this.displayObject(img, function (e) {
    that.zoomToFit();
  });
};

// MMPCImageEditor.prototype.scrollToNextImage = function(next) {
//  var curTask = MDPcMobileEditorCommonFun.getMainEditor().getCurrentBoard();
//  if (curTask && this.curIndex >= 0) {
//    var imgObjs = curTask.getImgPdfObjects();
//    var nextPage = this.curIndex;
//    if (next) {
//      if (this.curIndex < imgObjs.length - 1) {
//        nextPage++;
//      };
//    } else {
//      if (this.curIndex > 0) {
//        nextPage--;
//      };
//    }
//    this.changeToImage(nextPage);
//    return nextPage;
//  };
//  return 0;
// };
MMPCImageEditor.prototype.setInitialPageIndex = function (pgindex) {
  this.initailIndex = pgindex;
};
MMPCImageEditor.prototype.refreshView = function (callback) {
  //mashx change the logic
  var pageIndex = this.curIndex >= 0 ? this.curIndex : this.initailIndex;
  this.changeToImage(pageIndex, callback);
};
MMPCImageEditor.prototype.displayInRect = function (rect, callback) {
  var obj = this.getCurrentImage();
  if (obj && obj.getExpandRect().intersects(rect)) {
    this.refreshLgPageInRect(rect);
  } else if (obj == null) {
    this.refreshView(callback);
  }
};
MMPCImageEditor.prototype.getCurrentImage = function () {
  return this.getPicObject();
};
MMPCImageEditor.prototype._getPageCount = function () {
  var mainEditor = _MDPcMobileEditorCommonFun["default"].getMainEditor();
  if (mainEditor) {
    var curTask = mainEditor.getCurrentBoard();
    if (curTask) {
      var pgCount = curTask.getPageCountByVersion();
      return pgCount;
    }
  }
  return 0;
};
MMPCImageEditor.prototype.getCurrentFilePageCount = function () {
  return this._getPageCount();
};
MMPCImageEditor.prototype.getCurrentImageIndex = function () {
  return this.curIndex;
};
MMPCImageEditor.prototype._commentCreated = function (board, lgRect) {
  this.refreshLgPageInRect(lgRect);
};
MMPCImageEditor.prototype._commentCreatedInPage = function (board, pgindex) {
  var lgRect = board.getPageRect();
  this.refreshLgPageInRect(lgRect);
};
MMPCImageEditor.prototype.refreshSize = function () {
  var that = this;
  _MMCommonEditorView["default"].prototype.refreshSize.call(this, function () {
    that.zoomDiv(that.scale);
  });
};
MMPCImageEditor.prototype.enableMouseWheel = function () {};
MMPCImageEditor.prototype.getZoomList = function () {
  var zoomlist = this.calculateZoomList();
  return zoomlist;
};
MMPCImageEditor.prototype.refreshDivsSize = function (clearCanvas) {
  var dispSize = _MMCommonEditorView["default"].prototype.refreshDivsSize.call(this, clearCanvas);
  var self = this;
  this._needTileImage(function (need) {
    if (need && self.tileView) {
      self.tileView.refresh(self.scale);
    }
  });
  return dispSize;
};
MMPCImageEditor.prototype.removeFromSuperView = function () {
  _MMCommonEditorView["default"].prototype.removeFromSuperView.call(this);
  if (this.tileView) {
    this.tileView.removeFromSuperView();
  }
};
MMPCImageEditor.prototype.changeBackgroundColor = function (color) {
  if (color) {
    this._$imgBackground.css("background-color", color);
    this._$imgBackground.css("background-image", "none");
    if (color == "none") {
      this._$imgBackground.css("background-image", "url(/img/rect.jpg)");
      this._$imgBackground.css("background-size", "auto");
      this._$imgBackground.css("background-repeat", "repeat");
    }
    this.saveDefaultBackgroundColor(color);
  }
};
MMPCImageEditor.prototype.saveDefaultBackgroundColor = function (color) {
  var whiteboard = this.mmPicObj.getBoard();
  var fileInfo = whiteboard.getFileInfo();
  var ext = fileInfo.getFileExtension();
  localStorage["BackgroundColor-" + ext] = color;
};
MMPCImageEditor.prototype.restoreBackgroundColor = function () {
  var whiteboard = this.mmPicObj.getBoard();
  var fileInfo = whiteboard.getFileInfo();
  var ext = fileInfo.getFileExtension();
  var color = localStorage["BackgroundColor-" + ext];
  if (color) {
    this.changeBackgroundColor(color);
  } else {
    this.changeBackgroundColor("none");
  }
};
MMPCImageEditor.prototype._copyToClipBoard = function () {
  if (location.protocol == "http:" && location.host != "localhost:8080") {
    _MDMessageView["default"].error(BabelStr.str(6369), this.$root);
    return;
  }
  var imageLayer = this._$imageLayer && this._$imageLayer[0];
  if (!imageLayer) {
    _MDMessageView["default"].error(BabelStr.str(5418), this.$root);
    return;
  }
  var canvas = imageLayer.tagName === "CANVAS" ? imageLayer : _MMCommonFun["default"].imgtocanvas(imageLayer);
  var self = this;
  _MMCommonFun["default"].clipboardCopyCanvas(canvas, function () {
    _MDMessageView["default"].success(BabelStr.str(6368), self.$root);
  }, function () {
    _MDMessageView["default"].error(BabelStr.str(5418), self.$root);
  });
};
var _default = exports["default"] = MMPCImageEditor;

},{"108":108,"1084":1084,"1184":1184,"1417":1417,"1421":1421,"1423":1423,"1454":1454,"1463":1463,"1487":1487,"1538":1538,"1543":1543,"1545":1545,"32":32,"453":453,"55":55,"807":807,"808":808,"812":812,"823":823,"904":904,"914":914}],914:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1421);
require(1466);
require(1471);
require(1423);
require(1487);
require(1538);
require(1545);
require(1543);
require(1438);
var _MMRect = _interopRequireDefault(require(831));
var _MDMarkerObjDrawerController = _interopRequireDefault(require(909));
var _MDLineWidthAndFont = _interopRequireDefault(require(861));
var _MDColorDisk = _interopRequireDefault(require(856));
var _goog = _interopRequireDefault(require(823));
var _MMBasicData = _interopRequireDefault(require(811));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MDEvents = _interopRequireDefault(require(325));
var _MDCommentSlidePanelView = _interopRequireDefault(require(319));
var _MMEditorScroller = _interopRequireDefault(require(907));
var _MMAndroidScrollView = _interopRequireDefault(require(913));
var _MDNavigatorMap = _interopRequireDefault(require(939));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MMObjectFilter = _interopRequireDefault(require(955));
var _EditorMode = _interopRequireDefault(require(904));
var _FilterType = _interopRequireDefault(require(949));
var _ObjType = _interopRequireDefault(require(1084));
var _MMObjElementsController = _interopRequireDefault(require(893));
var _size = _interopRequireDefault(require(837));
var _ImageTransformer = _interopRequireDefault(require(826));
var _MMOperationCenterDesktopImage = _interopRequireDefault(require(876));
var _MMOperationCenterDesktopMarker = _interopRequireDefault(require(877));
var _MMOperationCenterMobileMarker = _interopRequireDefault(require(880));
var _MMOperationCenterMobileImage = _interopRequireDefault(require(879));
var _MMPoint = _interopRequireDefault(require(830));
var _MMCommentLineDrawer = _interopRequireDefault(require(906));
var _MDPenToolbar = _interopRequireDefault(require(427));
/*jslint nomen: true, vars: true, plusplus:true, browser:true */
/*global console, app, goog, $, _ */
/**
 * pc 和 mark 调用的显示
 * javascript/molasync-source/ui/editor-task/android-scroll/MMCommonEditorView.js
 * 2015-6-18
 */

function MMCommonEditorView(containerDiv) {
  _MMAndroidScrollView["default"].call(this, containerDiv);
  this.pageMargin = 10;
  this.mmPicObj = null;
  var __mmPicObj = null;
  this.commentDiv = null;
  this.operationCenter = null;
  this.scale = 1.0;
  this.__hideScaleDisplayTimeout = null;
  this.__imageMapSrc = null;
  this.divObjsFilter = new _MMObjectFilter["default"]();
  this.divObjsFilter.type = _FilterType["default"].Include;
  this.divObjsFilter.objTypes.push(_ObjType["default"].Obj_comment);
  this.divObjsFilter.objTypes.push(_ObjType["default"].Obj_niceTag);
  this.divObjsFilter.objTypes.push(_ObjType["default"].Obj_graphComment);
  // this.divObjsFilter.objTypes.push(ObjType.Obj_weldMark);

  this.canvasObjsFilter = new _MMObjectFilter["default"]();
  this.canvasObjsFilter.type = _FilterType["default"].Include;
  this.canvasObjsFilter.objTypes = _ObjType["default"].getCanvasObjType();
  if (typeof window.devicePixelRatio == "undefined") {
    window.devicePixelRatio = 1.0;
  }
  this.editorMode = _EditorMode["default"].normal;
  this.displayForVersion = false;
  _Dispatcher["default"].on(_MDEvents["default"].Mouse_up, this._onMouseUp, this);
  _Dispatcher["default"].on(_MDEvents["default"].salonStatusChanged, this._salonStatusChanged, this);
}
_goog["default"].inherits(MMCommonEditorView, _MMAndroidScrollView["default"]);
var g_androidO2oEditorCtl = null;
MMCommonEditorView.getSingleInstance = function () {
  if (g_androidO2oEditorCtl == null) {
    g_androidO2oEditorCtl = new MMCommonEditorView();
  }
  return g_androidO2oEditorCtl;
};
MMCommonEditorView.prototype.getPicObject = function () {
  return this.mmPicObj;
};
MMCommonEditorView.prototype.setDispForVersion = function (forVersion) {
  this.displayForVersion = forVersion;
};
MMCommonEditorView.prototype.displayObject = function (imgObj, opt, loadFinished) {
  if (!loadFinished) {
    if (opt && _.isFunction(opt)) {
      loadFinished = opt;
      opt = {};
    } else {}
  }
  var filePath = imgObj.getDispFilePath();
  if (this.mmPicObj != imgObj && filePath.length > 0) {
    this.board = imgObj.getBoard();
    this.mmPicObj = imgObj;
    this.loadFinished = loadFinished;
    _MMObjElementsController["default"].getSingleInstance().removeAllDivsForEditor(this);
    this.constructView(loadFinished);
  } else if (filePath.length > 0) {
    this.refreshEditor();
    if (loadFinished) {
      loadFinished(false);
    }
  }
};
MMCommonEditorView.prototype.initRotateAngle = function () {
  var i = this.mmPicObj.getPageIndex();
  var curTask = this.mmPicObj.getBoard();
  var fileInfo = curTask && curTask.getFileInfo();
  var fileId = fileInfo.getFileId();
  this.angle = MMCommonFun.getDefaultRotate(fileId, i);
  this.setDispAngle(this.angle);
};
MMCommonEditorView.prototype.setPageMargin = function (pageMargin) {
  this.pageMargin = pageMargin;
};
MMCommonEditorView.prototype.changeBackgroundForPng = function () {
  $(this.container).css("background-image", "url(img/rect.jpg)");
  $(this.container).css("background-repeat", "repeat");
};
MMCommonEditorView.prototype.changeBackgroundForJpg = function () {
  $(this.container).css("background-image", "none");
};
MMCommonEditorView.prototype.changeBackgroundForPDF = function () {
  $(this.container).css("background-image", "none");
};
MMCommonEditorView.prototype.exitFullscreen = function () {
  var element = document;
  if (element.exitFullScreen) element.exitFullScreen();
  if (element.webkitExitFullScreen) element.webkitExitFullScreen();
  if (element.mozExitFullScreen) element.mozExitFullScreen();
  if (element.msExitFullScreen) element.msExitFullScreen();
  this.__imageMapSrc = null;
  this._closeFullscreenEventhandler.unbind();
  delete this._closeFullscreenEventhandler;
  if (this.bodyOverflow != undefined) {
    $(this.parentDiv).css("overflow", this.bodyOverflow);
    $(this.parentDiv).css("overflow-x", this.bodyOverflowX);
    $(this.parentDiv).css("overflow-y", this.bodyOverflowY);
  }
};
MMCommonEditorView.prototype.isDispPdf = function () {
  return this.mmPicObj && this.mmPicObj.getObjType() == _ObjType["default"].Obj_PDF;
};
MMCommonEditorView.prototype.needDisplayNavi = function () {
  if (app.canDispInNormalBrowser() || app.isTablet()) {
    return true;
  }
  return false;
};
MMCommonEditorView.prototype.constructView = function (loadFinished) {
  var z_startIndex = _MMBasicData["default"].getO2OStartLayerZ_index();
  var z_maxIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
  this.$root = $(this.container);
  if (!this.mmPicObj) {
    return;
  }
  if (this._$allLayers) {
    _MMObjElementsController["default"].getSingleInstance().removeAllDivsForEditor(this);
    this._$allLayers.remove();
  }
  this.$contentDiv.empty();
  var self = this;
  this._createLayers(function (layers) {
    self._$allLayers = layers;
    self.$contentDiv.append(self._$allLayers);
    if (!self.__scaleDisplay) {
      self.__scaleDisplay = $("<div class='scaleDisplay f-noclickevents f-selectable' style='position:absolute;color:white;padding:0px 6px 0px 6px;font-size: 14px;font-weight:bold;background-color:rgba(0,0,0,0.7);  border-radius: 4px;' >100%</div>");
      self.__naturalSize = $("<div class='naturalSize f-noclickevents f-selectable' ></div>");
      var rightTop = $(self.parentDiv).find(".editor-right-top-btn-block");
      if (rightTop.length) {
        rightTop.prepend(self.__naturalSize);
      } else {
        $(self.parentDiv).append(self.__naturalSize);
      }
      $(self.parentDiv).append(self.__scaleDisplay);
    }
    self.checkToRemoveLayerNotNeeded();
    self._initLayerVars();
    var that = self;
    self._scrollNotificationHandler = function (offset) {
      that.$root[0].scrollLeft = offset.x;
      that.$root[0].scrollTop = offset.y;
    };
    var mouseDown = false;
    var lastScreenPos = null;
    //self.$scroll_editor.css("cursor","-webkit-grab");

    self.$contentDiv.on("touchstart mousedown", function (e) {
      if (!that.operationCenter) return;
      if (!that.operationCenter.getCurOperation()) that._onMouseDown(e);
    });
    self.$contentDiv.on("touchend mouseup", function (e) {
      if (!that.operationCenter) return;
      if (!that.operationCenter.getCurOperation()) that._onMouseUp(e);
    });
    self.$contentDiv.on("touchmove mousemove", function (e) {
      if (!that.operationCenter) return;
      if (!that.operationCenter.getCurOperation() && that.operationCenter.isMouseCaptured()) that._onMouseMove(e);
    });
    self.$contentDiv.find(".zoomrect-layer").on("mousedown", function (e) {
      that.zoomRectMouseDown(e);
    });
    self.$contentDiv.find(".zoomrect-layer").on("mouseup", function (e) {
      that.zoomRectMouseUp(e);
    });
    self.$contentDiv.find(".zoomrect-layer").on("mousemove", function (e) {
      that.zoomRectMouseMove(e);
    });
    self.$root.scroll(function (e) {
      that._onScroll();
    });
    if (self.needDisplayNavi()) {
      self.constructNavi();
    } else {
      self.$navi_root = $("");
    }
    self.__scaleDisplay.css("display", "none");
    self.initView(loadFinished);
    self.$root.css("left", "0");
    self.$root.css("top", "0");
    self.$root.css("position", "absolute");
    self.createOperationCenter();
  });

  // this.createOverLapOpLayer();  //---------------- 创建跨页的操作层
};
MMCommonEditorView.prototype._createLayers = function (callback) {
  callback($(""));
};
MMCommonEditorView.prototype._initLayerVars = function () {
  this._$editorLayer = this.$contentDiv.find(".comment-layer");
  this._$operateLayer = this.$contentDiv.find(".operate-layer");
  this._$scribbleLayer = this.$contentDiv.find(".scribble-layer");
  this._$commentLineLayer = this.$contentDiv.find(".comment-line-layer");
  this._$content = this.$contentDiv;
  this._$editorZone = this.$contentDiv.find(".editor-zone"); // image 层和 comment 层
  this._$editorCanvasZone = this.$contentDiv.find(".editor-canvas-zone"); // image 层和 comment 层
  this._$editorContent = this.$contentDiv.find(".assist_layer");
  this._$salonPenCanvas = this.$contentDiv.find(".comment-line-layer");
};
MMCommonEditorView.prototype.createOperationCenter = function () {
  if (!app.canDispInNormalBrowser() && this.editorMode != _EditorMode["default"].mark) {
    return;
  }
  var curFileInfo = this.editorViewCtl && this.editorViewCtl.getCurrentFileInfo();
  // if(curFileInfo.isOnlyDisp()) {
  //   return
  // }

  if (this.operationCenter) {
    this.operationCenter.destroy();
  }
  if (app.canDispInNormalBrowser()) {
    if (this.editorMode === _EditorMode["default"].mark) {
      this.operationCenterType = _MMOperationCenterDesktopMarker["default"];
    } else {
      this.operationCenterType = _MMOperationCenterDesktopImage["default"];
    }
  } else {
    if (this.editorMode === _EditorMode["default"].mark) {
      this.operationCenterType = _MMOperationCenterMobileMarker["default"];
    } else {
      if (this.mmPicObj.m_objType == _ObjType["default"].Obj_Image) {
        this.operationCenterType = _MMOperationCenterMobileImage["default"];
      } else {}
    }
  }
  this.operationCenter = new this.operationCenterType({
    whiteboard: this.board,
    pageIndex: this.getCurrentFilePageIndex(),
    editor: this,
    mode: "FULLSCREEN",
    displayedObject: this.mmPicObj,
    imgMarkerCtl: this.imgMarkerCtl,
    editorViewCtl: this.editorViewCtl
  });
};
MMCommonEditorView.prototype.checkToRemoveLayerNotNeeded = function () {
  if (this.editorMode == _EditorMode["default"].mark || !app.canDispInNormalBrowser()) {
    this._$allLayers.find(".comment-line-layer").remove();
  } else if (app.canDispInNormalBrowser()) {}
  if (!app.canDispInNormalBrowser()) {
    this.__scaleDisplay.css("display", "none");
    this.__naturalSize.css("display", "none");
  }
  if (!app.canDispInNormalBrowser() && this.editorMode != _EditorMode["default"].mark) {
    this._$allLayers.find(".operate-layer").remove();
  }
  if (app.canDispInNormalBrowser() && this.editorMode != _EditorMode["default"].mark) {
    this._$allLayers.find(".scribble-layer").remove();
  }
};
MMCommonEditorView.prototype._initSync = function (loadFinished) {
  this.imgRatio = this.originRotateH / this.originRotateW;
  var dispSize = this.refreshEditor(loadFinished, true);
  this.initNavigator();
  if (this.mmPicObj.getObjType() == _ObjType["default"].Obj_Image && this.mmPicObj.isPng()) {
    this.$contentDiv.find(".image-background").css("display", "block");
  }
  return dispSize;
};
MMCommonEditorView.prototype.initByOriginSize = function () {
  var originSize = this.mmPicObj.getOriginSize();
  if (originSize) {
    this.originW = originSize.x;
    this.originH = originSize.y;
    this.initRotateAngle();
    this.refreshEditor(undefined, true);
  }
};
MMCommonEditorView.prototype.initView = function (loadFinished) {
  this.restoreDefaultTransform();
  this.centerElement(this.__scaleDisplay);
  this.drawFininshed = false;

  // image src path
  if (!this.mmPicObj) return;
  var filePath = "";
  filePath = this.mmPicObj.getDispFilePath();
  this.mmPicObj.setShowingOriginFile(true);
  if (filePath.length == 0) {
    return;
  }
  var originSize = this.mmPicObj.getOriginSize();
  if (originSize) {
    this.originW = originSize.x;
    this.originH = originSize.y;
    this.initRotateAngle();
    this.setScaleToFit();
    this.refreshEditor(undefined, true);
  }

  // image sizeCommentSli
  var that = this;
  var objType = this.mmPicObj.getObjType();
  if (objType === _ObjType["default"].Obj_Image) {
    this.drawFile(filePath, loadFinished);
  } else if (objType == _ObjType["default"].Obj_PDF) {
    this.drawFile(loadFinished);
  } else {
    this.drawFile(loadFinished);
  }
};
MMCommonEditorView.prototype.drawFile = function (filePath, loadFinished) {
  var that = this;
  var imgLayer = this._$imageLayer[0];
  if (this.imageSrc != null && this.imageSrc.indexOf(filePath) >= 0 && this._$imageLayer.attr("src")) {
    that._initSync(loadFinished);
  } else {
    this._$imageLayer.on("progress", function () {
      console.log("in progress");
    });

    //!{ 暂时当缩略图层显示

    this._$imgBackground.css("background-image", "url(" + that.mmPicObj.getThumbnailUrl(false) + ")");
    this._$imgBackground.css("background-size", "100% 100%");
    this._$imgBackground.css("background-repeat", "none");
    //!}  added by jiang, 2015-12-16

    this.imageSrc = filePath;
    var tempImg = that._$imageLayer[0];
    var fileInfo = that.getCurrentBoard() && that.getCurrentBoard().getFileInfo && that.getCurrentBoard().getFileInfo();
    if (fileInfo && fileInfo.isOnlyDisp()) {
      _MDSpinnerloaderView["default"].showIn(that.parentDiv);
    }
    tempImg.onload = function (e) {
      _MDSpinnerloaderView["default"].clearFrom(that.parentDiv);
      if (that.removed) {
        console.log("******* removed");
        that = null;
        return;
      }

      // let point = new MMPoint(tempImg.width, tempImg.height)
      if (!that.originW && !that.originH) {
        that.mmPicObj.setImage(tempImg);
        var originSize = that.mmPicObj.getOriginSize();
        if (originSize) {
          that.originW = originSize.x;
          that.originH = originSize.y;
        }
        that.initRotateAngle();
        that.setScaleToFit();
      }
      if (!that.mmPicObj || !e.target.mmPicObj || e.target.mmPicObj.getId() != that.mmPicObj.getId()) {
        e.target.mmPicObj = null;
        return;
      }
      e.target.mmPicObj = null;

      //!{ 真图加载后将背景恢复为国际象棋盘
      that.restoreBackgroundColor();
      //!} added by jiang, 2015-12-16

      if (app.canDispInNormalBrowser()) {
        if (that._$textLayer) {
          that._$textLayer.css("display", "none");
        }
        that.__naturalSize.css("display", "block");
      }
      var scale = that.getFitZoomScale();
      if (that.useTransformToScale()) {
        scale = 1.0;
      }
      that.scale = scale;
      that.scale = scale;
      if (that.editorMode == _EditorMode["default"].mark) {
        that.setScaleToFit();
      }
      var fileInfo = that.getCurrentBoard() && that.getCurrentBoard().getFileInfo && that.getCurrentBoard().getFileInfo();
      that._$imageLayer.attr("width", that.originW * scale + "px");
      that._$imageLayer.attr("height", that.originH * scale + "px");
      that._$imageLayer.css("display", "block");
      if (fileInfo && fileInfo.isOnlyDisp()) {
        that._$imageLayerMarker.css("display", "block");
      } else {
        that._$imageLayerMarker.css("display", "none");
      }
      var dispSize = that._initSync();
      // MMCommonFun.initCanvasSize(
      //   that._$imageLayerMarker,
      //   dispSize.width,
      //   dispSize.height
      // );
      MMCommonFun.initCanvasSize(that._$editorCanvasZone, dispSize.width, dispSize.height);
      // if (that.editorMode == EditorMode.mark) {
      that.refreshEditor();
      // };

      if (loadFinished) {
        setBabelTimeout(function () {
          loadFinished(false);
        }, 0);
      }
      //                that.__loadingPlaceholder.css('display','none');
      $(that.container).css("overflow", "auto");
    };
    tempImg.onerror = function (e) {
      // var fileInfo = that.getCurrentBoard().getFileInfo();
      if (fileInfo) {
        var size = fileInfo.getCurrentVersionSize();
        if (size > 20000000) {
          _MDSnackbarView["default"].showStandardMsg(41);
        } else {
          _MDSnackbarView["default"].showStandardMsg(20);
        }
      } else {
        _MDSnackbarView["default"].showStandardMsg(20);
      }
      if (loadFinished) {
        loadFinished();
      }
    };
    tempImg.mmPicObj = this.mmPicObj;
    $(this.container).css("overflow", "hidden");

    //            this.__loadingPlaceholder.css('display','block');

    that._$imageLayer.attr("src", filePath);
  }
};

// MMCommonEditorView.prototype.drawPdfPage = function(loadFinished) {
//   var that = this;
//   that.changeBackgroundForPDF();

//   MMPDFDrawerController.getGlobalInstance().clear(this);

//   this.mmPicObj.getPdfPage(function(page) {
//     if (that.removed) {
//       console.log('******* removed');
//       that = null;
//       return;
//     };

//     if (!that.mmPicObj || page['pageIndex'] != that.mmPicObj.getPdfPageIndex() - 1 || page.mmobjId != that.mmPicObj.getId()) {
//       return;
//     };
//     that.page = page;

//     $(that.container).css('overflow', 'hidden');
//     var $pdflayer = that._$pdfLayer;
//     if (app.canDispInNormalBrowser() && that._$textLayer) {
//       that._$textLayer.css('display', 'block');
//     };

//     that.__naturalSize.css('display', 'none');
//     var viewport = that.mmPicObj.page.getViewport(1.0);
//     that.originW = viewport.width;
//     that.originH = viewport.height;

//     that.mmPicObj.setOriginSize(new MMPoint(viewport.width, viewport.height));

//     that.setScaleToFit();

//     var dispSize = that._initSync();

//     $(that.container).css('overflow', 'auto');

//     var time = 10;
//     var drawFinishCall = loadFinished;
//     if (that.editorMode == EditorMode.mark) {
//       that.refreshEditor();
//       if (loadFinished) {
//         setBabelTimeout(function() {
//           loadFinished(false);
//         }, 0);
//       };
//     }

//     time = 0;

//     MMPDFDrawerController.getGlobalInstance().drawInCanvas(that, $pdflayer[0], page, function() {

//       that.drawFininshed = true;

//       that._$pdfThumbLayer.remove();
//       if (drawFinishCall) {
//         drawFinishCall(true); //pdf draw finhished.
//       };
//     });

//   });
// };

MMCommonEditorView.prototype.refreshDivsSize = function (clearCanvas) {
  console.log("MMCommonEditorView.prototype.refreshDivsSize");
  if (!this.$root) {
    return;
  }
  var editorZoneSize = new _size["default"](0, 0);
  var $editorContent;
  // window size
  this.winW = this.parentDiv.offsetWidth;
  this.winH = this.parentDiv.offsetHeight;

  // set root view size
  if (this.__lastWinW !== this.winW) {
    this.$root.css("width", this.winW + "px");
  }
  if (this.__lastWinH !== this.winH) {
    this.$root.css("height", this.winH + "px");
  }
  this.__lastWinW = this.winW;
  this.__lastWinH = this.winH;
  var contentW = this.winW;
  var contentH = this.winH;
  var that = this;
  var imgDispWidth = this.originRotateW;
  var imgDispHeight = this.originRotateH;
  that.__naturalSize.html(that.originRotateW + " x " + that.originRotateH);
  if (!this.useTransformToScale()) {
    imgDispWidth = parseInt(imgDispWidth * this.scale);
    imgDispHeight = parseInt(imgDispHeight * this.scale);
    if (contentW >= imgDispWidth && contentH >= imgDispHeight) {
      this.$root.css("overflow", "hidden");
    } else {
      this.$root.css("overflow", "auto");
    }
    if (this.imageSrc != null && this.mmPicObj.getObjType() == _ObjType["default"].Obj_Image) {
      var path = this.mmPicObj.getDispFilePath(imgDispWidth, imgDispHeight);
      if (this.imageSrc != path) {
        this.imageSrc = path;
        fetch(path, {
          mode: 'cors'
        }).then(function (res) {
          return res.blob();
        }).then(function (blob) {
          var url = URL.createObjectURL(blob);
          that._$imageLayer.attr("src", url);
        });

        // var image = new Image();
        // image.src = path;
        // image.onload = function () {

        //   var canvas = document.createElement('canvas');
        //   canvas.width = image.width;
        //   canvas.height = image.height;
        //   canvas.getContext('2d').drawImage(image, 0, 0);
        //   that._$imageLayer.attr("src", canvas.toDataURL('image/png'));

        //   // that._$imageLayer.attr("src", path);
        // };
      }
    }
  }
  var marginLeft = (this.winW - imgDispWidth) / 2;
  if (marginLeft < 0) {
    marginLeft = 0;
    contentW = imgDispWidth;
  }
  var marginTop = (this.winH - imgDispHeight) / 2;
  if (marginTop < 0) {
    marginTop = 0;
    contentH = imgDispHeight;
  }
  var $content = this._$content;
  $content.css("width", contentW + "px");
  $content.css("height", contentH + "px");
  $editorContent = this._$editorContent;
  $editorContent.css("width", contentW + "px");
  $editorContent.css("height", contentH + "px");
  $editorContent.css("margin-left", "auto");
  $editorContent.css("margin-right", "auto");
  $editorContent.css("margin-top", "auto");
  $editorContent.css("margin-bottom", "auto");
  this._$operateLayer.attr("width", contentW + "px");
  this._$operateLayer.attr("height", contentH + "px");
  this._$commentLineLayer.attr("width", contentW + "px");
  this._$commentLineLayer.attr("height", contentH + "px");
  if (contentH > 10000 || contentW > 1000) {
    this._$commentLineLayer.hide(); // ------------------- 太大的 canvas 导致屏幕变成白屏
  } else {
    this._$commentLineLayer.show();
  }
  var $editorZone = this._$editorZone; // image 层和 comment 层
  var $editorCanvasZone = this._$editorCanvasZone;
  editorZoneSize.width = imgDispWidth;
  editorZoneSize.height = imgDispHeight;
  $editorZone.css("width", imgDispWidth + "px");
  $editorZone.css("height", imgDispHeight + "px");
  $editorZone.css("left", marginLeft + "px");
  $editorZone.css("top", marginTop + "px");

  // $editorCanvasZone.css('width', imgDispWidth + 'px');
  // $editorCanvasZone.css('height', imgDispHeight + 'px');
  $editorCanvasZone.css("left", marginLeft + "px");
  $editorCanvasZone.css("top", marginTop + "px");
  // $editorCanvasZone.attr('width', imgDispWidth + 'px');
  // $editorCanvasZone.attr('height', imgDispHeight + 'px');

  var fileInfo = this.editorViewCtl && this.editorViewCtl.getCurrentFileInfo();
  // if (!fileInfo || !fileInfo.isOnlyDisp) {
  _.each($editorCanvasZone, function (canvas) {
    if (!canvas.width) {
      return;
    }
    var nc = document.createElement("canvas");
    nc.width = canvas.width;
    nc.height = canvas.height;
    nc.getContext("2d").drawImage(canvas, 0, 0);
    canvas.width = imgDispWidth;
    canvas.height = imgDispHeight;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(nc, 0, 0, nc.width, nc.height, 0, 0, imgDispWidth, imgDispHeight);
  });
  // }

  $editorCanvasZone.css("width", imgDispWidth + "px");
  $editorCanvasZone.css("height", imgDispHeight + "px");
  if (typeof window.devicePixelRatio == "undefined") {
    window.devicePixelRatio = 1.0;
  }

  // --------------------------------------------- pdf size

  var imgScaleW = that.originW * this.scale;
  var imgScaleH = that.originH * this.scale;
  var imgLeft = (imgDispWidth - imgScaleW) / 2;
  var imgTop = (imgDispHeight - imgScaleH) / 2;
  if (this._$textLayer) {
    this._$textLayer.css("width", imgScaleW * window.devicePixelRatio + "px");
    this._$textLayer.css("height", imgScaleH * window.devicePixelRatio + "px");
    this._$textLayer.css("transform-origin", "0px 0px");
    this._$textLayer.css("transform", "scale(" + 1 / window.devicePixelRatio + ")");
  }
  if (clearCanvas) {
    MMCommonFun.initCanvasSize($editorCanvasZone, imgDispWidth, imgDispHeight);
    if (that._$pdfLayer) {
      MMCommonFun.initCanvasSize(that._$pdfLayer, imgScaleW, imgScaleH);
    }
  }
  for (var i = 0; i < this._$scribbleLayer.length; i++) {
    MMCommonFun.setContextScale(this._$scribbleLayer[i]);
  }
  this._positionOtherLayer(marginLeft, marginTop);
  if (that._$pdfLayer) {
    that._$pdfLayer.css("width", imgScaleW + "px");
    that._$pdfLayer.css("height", imgScaleH + "px");
    that._$pdfLayer.css("left", imgLeft + "px");
    that._$pdfLayer.css("top", imgTop + "px");
    that._$pdfLayer.css("transform", "rotate(" + this.angle + "deg)");
    this._$textContainer.css("left", "0px");
    this._$textContainer.css("top", "0px");
    this._$textContainer.css("transform", "rotate(" + this.angle + "deg)");
    if (this._$textLayer) {
      that._$textLayer.css("left", imgLeft + "px");
      that._$textLayer.css("top", imgTop + "px");
    }
  } else if (that._$imageLayer) {
    // --------------------------------------------- image size

    var imgScaleW = that.originW * this.scale;
    var imgScaleH = that.originH * this.scale;
    var imgLeft = (imgDispWidth - imgScaleW) / 2;
    var imgTop = (imgDispHeight - imgScaleH) / 2;
    that._$imageLayer.css("width", imgScaleW + "px");
    that._$imageLayer.css("height", imgScaleH + "px");
    that._$imageLayer.css("left", imgLeft + "px");
    that._$imageLayer.css("top", imgTop + "px");
    that._$imageLayer.css("transform", "rotate(" + this.angle + "deg)");
  }
  if (that._$imageLayerMarker) {
    that.drawWatermarke(this.angle);
  }
  return editorZoneSize;
};
MMCommonEditorView.prototype._positionOtherLayer = function (marginLeft, marginTop) {};
MMCommonEditorView.prototype.refreshEditor = function (loadFinished, clearCanvas) {
  if (!this.$root) {
    return;
  }
  var editorZoneSize = this.refreshDivsSize(clearCanvas);
  var fileInfo = this.editorViewCtl && this.editorViewCtl.getCurrentFileInfo();
  if (!fileInfo || !fileInfo.isOnlyDisp()) {
    this.refreshObjsInEditor();
  }
  this.recordOriginScrollSize();
  var self = this;
  if (this.scale) {
    setBabelTimeout(function () {
      _Dispatcher["default"].trigger(_MDEvents["default"].ZOOM_CHANGED, {
        editorViewCtl: self.editorViewCtl
      });
    }, 10);
  }
  this.calculateZoomList();
  if (loadFinished) {
    loadFinished(true);
  }
  this.showCommentLine();
  if (this.mmPicObj && this.divTrsfm) {
    _Dispatcher["default"].trigger(_MDEvents["default"].RENDER_OBJ_FINISH, this, this.mmPicObj.getPageIndex());
  }
  return editorZoneSize;
};
MMCommonEditorView.prototype.constructNavi = function () {
  if (this.navigatorMap) {
    this.navigatorMap.removeFromSuperView();
    this.navigatorMap = null;
  }
  if (!this.needDisplayNavi()) {
    return;
  }
  var that = this;
  this.navigatorMap = new _MDNavigatorMap["default"](this.parentDiv, this.container, this._$content, function (offset) {
    that._scrollNotificationHandler(offset);
  });
};
MMCommonEditorView.prototype.changeEditZoneSize = function (width, height) {};
MMCommonEditorView.prototype.centerElement = function (el, direction) {
  var $el = $(el);
  var winW = $(this.parentDiv).width() || window.innerWidth;
  var winH = $(this.parentDiv).height() || window.innerHeight;
  if (!direction) {
    $el.css("left", winW / 2 - parseInt($el.width()) / 2);
    $el.css("top", winH / 2 - parseInt($el.height()) / 2);
  } else {
    if (direction === "top") {
      $el.css("top", winW / 2 - parseInt($el.height()) / 2);
    } else if (direction === "left") {
      $el.css("left", winH / 2 - parseInt($el.width()) / 2);
    }
  }
};
MMCommonEditorView.prototype.endFullscreen = function () {
  this.$root.css("left", "100%");
  if (app.canDispInNormalBrowser()) {
    this.exitFullscreen();
    this.removeFromSuperView();
  } else {
    setBabelTimeout(function () {
      this.exitFullscreen();
      this.removeFromSuperView();
    }.bind(this), 300);
  }
};
MMCommonEditorView.prototype.constructHotZoneCtl = function () {
  //this.hotZoneCtl = new MMHotZoneDispCtl(this.$root[0]);
};

/**
 * 获得标注 div 所在的层
 * @returns $div
 */
MMCommonEditorView.prototype.getCommentLayer = function () {
  return this._$editorLayer[0];
};

/**
 * 获得标注对象 div 所在的 z index
 * @returns z index {Number}
 */
MMCommonEditorView.prototype.getCommentStartlayerZ_index = function () {
  return _MMBasicData["default"].getO2OCommentStartlayerZ_index();
};
MMCommonEditorView.prototype.getAssistantCanvas = function () {
  return this._$operateLayer[0];
};
MMCommonEditorView.prototype.getSalonPenCanvas = function () {
  return this._$salonPenCanvas[0];
};
MMCommonEditorView.prototype.clearSalonPenCanvas = function () {
  var canvas = this._$salonPenCanvas[0];
  var ctx = canvas.getContext("2d");
  ctx.clearRect(0, 0, canvas.offsetWidth, canvas.offsetHeight);
};
MMCommonEditorView.prototype.clearAssistCanvas = function () {
  var canvas = this._$operateLayer[0];
  var ctx = canvas.getContext("2d");
  ctx.clearRect(0, 0, canvas.offsetWidth, canvas.offsetHeight);
};
MMCommonEditorView.prototype.getScribbleCanvas = function () {
  return this._$scribbleLayer[0];
};
MMCommonEditorView.prototype.getPageAssistantCanvas = function () {
  return this.getAssistantCanvas();
};
MMCommonEditorView.prototype.getCommentLineLayer = function () {
  return this._$commentLineLayer[0];
};
MMCommonEditorView.prototype.getDivTransformer = function () {
  return this.divTrsfm;
};
MMCommonEditorView.prototype.getCanvasTransformer = function () {
  return this.canvasTrsfm;
};
MMCommonEditorView.prototype.getDivTransformerForAssist = function () {
  return this.divAssistTrsfm;
};
MMCommonEditorView.prototype.getCanvasTransformerForAssist = function () {
  return this.canvasAssistTrsfm;
};
MMCommonEditorView.prototype.zoom = function (change) {
  this.changeScale(this.scale + change);
};

// variable to avoid dublicated resizing on scale
// var globalo2oScallNumber = null;
MMCommonEditorView.prototype.changeScale = function (scale, callback) {
  if (this.scale == scale) {
    this.refreshEditor(callback);
    return;
  }
  var oldScroll = {
    left: this.container.scrollLeft,
    top: this.container.scrollTop
  };
  var scaleChange = scale / this.scale;

  // cals windowDifferences
  var windowWidth = window.innerWidth;
  var windowHeight = window.innerHeight;
  var newwidth = windowWidth * scaleChange;
  var newheight = windowHeight * scaleChange;
  var widthDifference = windowWidth - newwidth;
  var heightDifference = windowHeight - newheight;
  var that = this;

  // execute the scale
  this.scale = scale;
  this.globalo2oScallNumber = Math.random();
  var localo2oScallNumber = this.globalo2oScallNumber;
  requestAnimationFrame(function () {
    if (localo2oScallNumber == this.globalo2oScallNumber) this.refreshEditor(function () {
      // update the scollPosition
      that._scrollNotificationHandler(new _MMPoint["default"](parseInt(oldScroll.left * scaleChange - widthDifference / 2), parseInt(oldScroll.top * scaleChange - heightDifference / 2)));
      if (callback) {
        callback();
      }
    });
  }.bind(this));

  // // update the scollPosition
  // this._scrollNotificationHandler(new MMPoint(
  //   parseInt((oldScroll.left * scaleChange) - (widthDifference / 2)),
  //   parseInt((oldScroll.top * scaleChange) - (heightDifference / 2))
  // ));

  // show the __scaleDisplay for a moment
  if (app.canDispInNormalBrowser() && !this.board.isCADFile()) {
    this.__scaleDisplay.css("display", "block");
    this.__scaleDisplay.html(Math.round(this.scale * 100) + "%");
    this.centerElement(this.__scaleDisplay);
    clearTimeout(this.__hideScaleDisplayTimeout);
    this.__hideScaleDisplayTimeout = setBabelTimeout(function () {
      this.__scaleDisplay.css("display", "none");
    }.bind(this), 2000);
  }
  this.clearSalonSpeakerMouseClick();
};
MMCommonEditorView.prototype.zoomDiv = function (scale) {
  if (this.useTransformToScale()) {
    MMCommonEditorView.superClass_.zoomDiv.call(this, scale);
  } else {
    this.changeScale(scale);
  }
  _MMObjElementsController["default"].getSingleInstance().zoomScaleChanged(scale, this);
  if (this.__scaleDisplay && app.canDispInNormalBrowser() && !this.board.isCADFile()) {
    this.__scaleDisplay.css("display", "block");
    this.__scaleDisplay.html(Math.round(this.scale * 100) + "%");
    this.centerElement(this.__scaleDisplay);
    clearTimeout(this.__hideScaleDisplayTimeout);
    this.__hideScaleDisplayTimeout = setBabelTimeout(function () {
      this.__scaleDisplay.css("display", "none");
    }.bind(this), 2000);
  }
};
MMCommonEditorView.prototype.zoomToFit = function () {
  if (this.useTransformToScale()) {
    MMCommonEditorView.superClass_.zoomToFit.call(this);
  } else {
    var scale = this.getFitZoomScale();
    this.changeScale(scale);
  }
};
MMCommonEditorView.prototype.getFitZoomScale = function () {
  var margin = this.pageMargin;
  var containerW = this.parentDiv.offsetWidth - margin;
  var containerH = this.parentDiv.offsetHeight - margin;
  if (containerW > 0 && containerH > 0 && this.originRotateW > 0 && this.originRotateH > 0) {
    var scaleX = containerW / this.originRotateW;
    var scaleY = containerH / this.originRotateH;
    var scale = scaleX < scaleY ? scaleX : scaleY;
    if (scale > 1.0) {
      scale = 1.0;
    }
    return scale;
  }
  return 1.0;
};
MMCommonEditorView.prototype.setScaleToFit = function () {
  var margin = this.pageMargin;
  var containerW = this.parentDiv.offsetWidth - 2 * margin;
  var containerH = this.parentDiv.offsetHeight - 2 * margin;
  if (containerW > 0 && containerH > 0 && this.originRotateW > 0 && this.originRotateH > 0) {
    var scaleX = containerW / this.originRotateW;
    var scaleY = containerH / this.originRotateH;
    var needScaleToFitWinWidth = false;
    needScaleToFitWinWidth = this.isDispPdf() && !app.canDispInNormalBrowser() || this.editorMode == _EditorMode["default"].mark;
    if (needScaleToFitWinWidth) {
      //  ----------------------------- pdf 等宽显示,即只要宽度适合
      scaleY = scaleX + 0.1;
    }
    var pageCount = this.mmPicObj.getBoard().getPageCount();
    var scale = scaleX < scaleY ? scaleX : scaleY;
    if (scale > 1.0 && (!this.isDispPdf() || this.isDispPdf() && pageCount == 1) && this.editorMode !== _EditorMode["default"].mark) {
      scale = 1.0;
    }
    this.scale = scale;
  } else {
    this.scale = 1.0;
  }
};
MMCommonEditorView.prototype.zoomToFitWidth = function (callback) {
  if (this.useTransformToScale()) {
    MMCommonEditorView.superClass_.zoomToFitWidth.call(this);
  } else {
    var margin = this.pageMargin;
    var containerW = this.parentDiv.offsetWidth - margin;
    if (containerW > 0 && this.originRotateW > 0) {
      var scaleX = containerW / this.originRotateW;
      var scale = scaleX < 1 ? scaleX : 1;
      this.changeScale(scale, callback);
    }
  }
};
MMCommonEditorView.prototype.refreshSize = function (callback) {
  var that = this;
  if (this.needRefreshSize()) {
    this.refreshEditor(function () {
      MMCommonEditorView.superClass_.refreshSize.call(that);
      that.refreshCanvas();
      if (callback) {
        callback();
      }
    });
  }
  this.removeCommentPanel();
};
MMCommonEditorView.prototype.refreshCanvas = function () {
  var targetW = this._$editorZone.width();
  var targetH = this._$editorZone.height();
  if (targetW > 10000 || targetH > 10000) {
    this._$scribbleLayer.hide();
    return;
  } else {
    this._$scribbleLayer.show();
  }
  MMCommonFun.initCanvasSize(this._$scribbleLayer, targetW, targetH);
  this.refreshObjsInCanvas();
};

// MMCommonEditorView.prototype.refreshPdfCanvas = function(targetW, targetH) {

//   if (!this.isDispPdf() || !this.drawFininshed) {
//     return;
//   }

//   if (this._$drawingPdf) {
//     this._$drawingPdf.remove();
//   };

//   this._$drawingPdf = this._$pdfLayer.clone();
//   this._$pdfLayer.before(this._$drawingPdf);
//   MMCommonFun.initCanvasSize(this._$drawingPdf, targetW, targetH);

//   // this.pdfDrawer.clear();
//   MMPDFDrawerController.getGlobalInstance().clear(this);

//   var that = this;

//   MMPDFDrawerController.getGlobalInstance().drawInCanvas(this, this._$drawingPdf[0], this.page, function() {
//     that._$pdfLayer.remove();
//     that._$pdfLayer = that._$drawingPdf;
//     that._$drawingPdf = null;
//     that._$editorCanvasZone = that.$contentDiv.find('.editor-canvas-zone'); // image 层和 comment 层

//   })
// }

MMCommonEditorView.prototype.initNavigator = function () {
  var width = this.originRotateW;
  var height = this.originRotateH;
  var sizeImg = width > height ? width : height;
  var baseSize = 200;
  if (sizeImg > 1000) {
    baseSize = baseSize * 2;
  } else if (sizeImg > 6000) {
    baseSize = baseSize * 3;
  } else {
    baseSize = 200;
  }
  var angle = this.angle;
  var lowFilePath = this.mmPicObj.getThumbnailUrl(false, baseSize);
  if (this.navigatorMap) {
    this.navigatorMap.initNavigator(this.winW, this.winH, this.imgRatio, lowFilePath, angle);
  }
};
MMCommonEditorView.prototype.getMaxScale = function () {
  return 2.0;
};
MMCommonEditorView.prototype.isLimitMaxScale = function () {
  return true;
};
MMCommonEditorView.prototype.calculateZoomList = function () {
  if (app.canDispInNormalBrowser()) {
    var imgOrgWidth = this.originRotateW;
    var imgOrgHeight = this.originRotateH;
    var contentW = this.winW;
    var contentH = this.winH;
    var _maxlimit = this.getMaxScale(); //Math.round(Math.sqrt((4096*3072) / (imgOrgWidth * imgOrgHeight)));
    if (_maxlimit < 2.0 && this.mmPicObj && this.mmPicObj.getObjType() == _ObjType["default"].Obj_PDF) {
      _maxlimit = 2.0;
    }
    if (_maxlimit < 1.5 && this.mmPicObj && this.mmPicObj.getObjType() != _ObjType["default"].Obj_PDF) {
      _maxlimit = 1.5;
    }
    var scaleX = contentW / imgOrgWidth;
    var scaleY = contentH / imgOrgHeight;
    var fitScale = Math.min(scaleX, scaleY);
    var fitW = Math.max(scaleX, scaleY);
    if (this.isLimitMaxScale()) {
      if (fitScale > 1.0) {
        _maxlimit = Math.floor(fitScale * 2 * 100) / 100;
      }
      if (_maxlimit > 5) {
        _maxlimit = 5;
      }
    }
    var minScale = 0;
    var maxScale = 0;
    if (fitScale > 0) {
      var minScale = 0.25;
      while (minScale < fitScale) {
        minScale += 0.25;
      }
      if (minScale > 0.5) {
        minScale = 0.5;
      }
      var secondScale = minScale;
      minScale -= 0.25;
      if (minScale == 0) {
        minScale = Math.floor(fitScale * 100) / 100;
      }
      var scales = [];
      if (Math.abs(minScale - secondScale) < 0.01) {
        scales.push(secondScale);
      } else {
        scales.push(minScale);
        scales.push(secondScale);
      }
      var scale = secondScale + (secondScale >= 1 ? 0.5 : 0.25);
      while (scale <= _maxlimit) {
        scales.push(scale);
        if (scale >= 1.0) {
          scale += 0.5;
        } else {
          scale += 0.25;
        }
      }

      // if (this == MDPcMobileEditorCommonFun.getMainEditor()) {
      //   Dispatcher.trigger(MDEvents.SCALE_ARRAY, scales);
      // };

      return scales;
    }
  }
};
MMCommonEditorView.prototype.refreshObjsInEditor = function () {
  if (!this.mmPicObj || this.board.isVirtualBoard()) {
    return;
  }
  var arcAngle = this.mmPicObj.getDrawAngle() * Math.PI / 180;
  var lgImgRect = this.mmPicObj.getDrawRect();
  var dvImgSize = new _size["default"](this.originW, this.originH);
  if (!this.originRotateW || !this.originRotateH || isNaN(this.originRotateW) || isNaN(this.originRotateH)) {
    this.divTrsfm = null;
    this.divAssistTrsfm = null;
    return;
  }
  if (!this.useTransformToScale()) {
    dvImgSize.width *= this.scale;
    dvImgSize.height *= this.scale;
  }
  var viewAngle = this.angle * Math.PI / 180;
  this.divTrsfm = new _ImageTransformer["default"](dvImgSize, lgImgRect, arcAngle, viewAngle);
  this.divAssistTrsfm = new _ImageTransformer["default"](dvImgSize, lgImgRect, arcAngle, viewAngle);
  this.divAssistTrsfm.setLayers(this._$editorLayer[0], this._$operateLayer[0]);
  var canvas = this._$scribbleLayer[0];
  var canvasSize = dvImgSize; //new Size(parseInt(canvas.style.width), parseInt(canvas.style.height));
  this.canvasTrsfm = new _ImageTransformer["default"](canvasSize, lgImgRect, arcAngle, viewAngle);
  this.canvasAssistTrsfm = new _ImageTransformer["default"](canvasSize, lgImgRect, arcAngle, viewAngle);
  this.canvasAssistTrsfm.setLayers(canvas, this._$operateLayer[0]);
  var lgPt = lgImgRect.getOrigin();
  var dvPt = this.divTrsfm.lg2dvPoint(lgPt);
  console.log("----- left top:" + dvPt.x + "," + dvPt.y);
  var lgRct = this.mmPicObj.getExpandRect();
  _MMObjElementsController["default"].getSingleInstance().removeAllDivsForEditor(this);
  if (this.displayForVersion) {
    this.divObjsFilter.objVer = this.mmPicObj.getFileVersion();
    this.canvasObjsFilter.objVer = this.mmPicObj.getFileVersion();
  } else {
    this.divObjsFilter.objVer = this.canvasObjsFilter.objVer = -1;
  }
  this.refreshCommentsInEditor(lgRct);
  this.refreshObjsInCanvas(lgRct);
};
MMCommonEditorView.prototype.getOperationCenter = function () {
  return this.operationCenter;
};
MMCommonEditorView.prototype.setCurOperation = function (oper_, objs_, comm_) {
  if (this.operationCenter) {
    // oper_ = "arrowComment";   // ------------- test
    this.operationCenter.setCurOperation(oper_, objs_, comm_);
  }
};
MMCommonEditorView.prototype.getCurOperation = function () {
  return this.operationCenter.m_curOperation;
};
MMCommonEditorView.prototype.refreshLgPageInRect = function (lgRct) {
  this.refreshObjsInCanvas(lgRct);
  this.refreshCommentsInEditor(lgRct);
};
MMCommonEditorView.prototype.clearContent = function () {
  if (!this.$root) {
    return;
  }

  // 1. clear canvas
  var geo_canvas = this._$scribbleLayer[0];
  if (geo_canvas) {
    var w = this._$scribbleLayer.width();
    var h = this._$scribbleLayer.height();
    var ctx = geo_canvas.getContext("2d");
    ctx.clearRect(0, 0, w, h);
  }

  // 2. clear div
  _MMObjElementsController["default"].getSingleInstance().removeAllDivsForEditor(this);
  if (this.mmPicObj.m_objType == _ObjType["default"].Obj_Image) {
    if (!this._$imageLayer.attr("src")) {
      this._$imageLayer.attr("src", this.imageSrc);
    }
  } else {}
};
MMCommonEditorView.prototype.clearPdfLayer = function () {
  // var pdf_canvas = this._$pdfLayer[0];
  // if (pdf_canvas) {
  //   var w = this._$pdfLayer.width();
  //   var h = this._$pdfLayer.height();
  //   var ctx = pdf_canvas.getContext('2d');
  //   ctx.clearRect(0, 0, w, h);
  // };
};
MMCommonEditorView.prototype.drawMarkerObjsInCanvas = function (objects) {
  _MDMarkerObjDrawerController["default"].drawMarkerObjs(this, objects, this.markEditable);
};
MMCommonEditorView.prototype.scale2drawMarkerObjsInCanvas = function (objects, callback) {
  _MDMarkerObjDrawerController["default"].scale2drawMarkerObjs(this, objects, this.markEditable, callback);
};
MMCommonEditorView.prototype.clearOpLayer = function () {
  var ctx = this._$operateLayer[0].getContext("2d");
  ctx.clearRect(0, 0, this._$operateLayer.width(), this._$operateLayer.height());
};
MMCommonEditorView.prototype.drawPathInOpLayer = function (pathLGPoints) {
  if (!pathLGPoints) {
    return;
  }
  var ctx = this._$operateLayer[0].getContext("2d");
  this.clearOpLayer();

  // ctx.fillStyle = 'rgba(255,0,0,0.5)';
  // ctx.fillRect(0, 0, 100, 100);

  if (pathLGPoints[0]) {
    ctx.beginPath();
    var op = this.getCurOperation();
    if (op.toolName && op.toolName == "penComment") {
      ctx.strokeStyle = _MDPenToolbar["default"].getColor();
      ctx.lineWidth = _MDPenToolbar["default"].getLineWidth();
    } else {
      ctx.strokeStyle = _MDColorDisk["default"].getCurColor();
      ctx.lineWidth = _MDLineWidthAndFont["default"].getCurLineWidth();
    }
    var devicePoint = this.getDivTransformer().lg2dvPoint(pathLGPoints[0], this.mmPicObj.getPageIndex());
    devicePoint = this.convertPointFromEditor2AssistView(devicePoint);
    ctx.moveTo(devicePoint.x, devicePoint.y);
    for (var i = 0; i < pathLGPoints.length; i++) {
      devicePoint = this.getDivTransformer().lg2dvPoint(pathLGPoints[i], this.mmPicObj.getPageIndex());
      devicePoint = this.convertPointFromEditor2AssistView(devicePoint);
      ctx.lineTo(devicePoint.x, devicePoint.y);
    }
    ctx.stroke();
  }
};
MMCommonEditorView.prototype.refreshObjsInCanvas = function (lgRct) {
  if (!this.mmPicObj || !this.canvasTrsfm) {
    return;
  }
  if (!lgRct) {
    lgRct = this.mmPicObj.getExpandRect();
  }
  var geo_canvas = this._$scribbleLayer[0];
  MMCommonFun.setContextScale(geo_canvas);
  var i = this.mmPicObj.getPageIndex();

  // 刷新旧的绘制内容
  var dvRct = this.canvasTrsfm.lg2dvRect(lgRct, i).intRect();
  var curTask = this.board;
  var geo_ctx = geo_canvas.getContext("2d");
  if (curTask && geo_ctx && this.editorMode == _EditorMode["default"].normal) {
    geo_ctx.save();
    MMCommonFun.clipContext(geo_ctx, dvRct);
    curTask.drawObjsInCanvas(geo_ctx, this.canvasTrsfm, i, this.canvasObjsFilter, lgRct);
    geo_ctx.restore();
  }
  this.refreshSalonScribbleInCanvas();
};
MMCommonEditorView.prototype.refreshSalonScribbleInCanvas = function (dvRct) {
  if (this.editorMode == _EditorMode["default"].mark) {
    return;
  }
  var geo_canvas = this.getSalonPenCanvas();
  if (!geo_canvas) {
    return;
  }
  var geo_ctx = geo_canvas.getContext("2d");
  if (!dvRct) {
    dvRct = new _MMRect["default"]();
    dvRct.setRct(0, 0, geo_canvas.offsetWidth, geo_canvas.offsetHeight);
  }
  var leftTop = dvRct.getOrigin();
  var size = dvRct.getSize();
  geo_ctx.clearRect(leftTop.x, leftTop.y, size.width, size.height);
  var curTask = this.board;
  var trsfm = this.getCanvasTransformerForAssist();
  if (curTask && geo_ctx) {
    var lgRct = trsfm.dv2lgRect(dvRct);
    geo_ctx.save();
    MMCommonFun.clipContext(geo_ctx, dvRct);
    curTask.drawSalonScribbles(geo_ctx, this.getCanvasTransformerForAssist(), lgRct);
    geo_ctx.restore();
  }
};
MMCommonEditorView.prototype.refreshCommentsInEditor = function (lgRct) {
  if (!this.mmPicObj || !this.divTrsfm) {
    return;
  }
  if (!lgRct) {
    lgRct = this.mmPicObj.getExpandRect();
  }
  if (this.editorMode == _EditorMode["default"].mark) {
    _MMObjElementsController["default"].getSingleInstance().removeAllDivsForEditor(this);
  } else {
    var i = this.mmPicObj.getPageIndex();
    var curTask = this.mmPicObj.getBoard();
    curTask.drawObjsInDiv(this, this.divTrsfm, i, this.divObjsFilter, lgRct);

    // var geo_canvas = this._$scribbleLayer[0];
    // var geo_ctx = geo_canvas.getContext("2d");
    // curTask.drawCommentsInCanvas(geo_ctx, this.canvasTrsfm, i, this.canvasObjsFilter, lgRct);
  }
  if (this.editorViewCtl) {
    var penZoneCtl = this.editorViewCtl.getPenZoneCtl();
    penZoneCtl && penZoneCtl.refreshDisp();
  }
};
MMCommonEditorView.prototype.getCurrentFilePageIndex = function () {
  var index = -1;
  if (this.mmPicObj) {
    index = this.mmPicObj.getPageIndex();
  }
  return index;
};
MMCommonEditorView.prototype._onMouseDown = function (e) {
  if (!this.mouseDown && this.hotZonePanelCtl && (this.hotZonePanelCtl.isHotZoneInCreation() || this.hotZonePanelCtl.isTargetInCreation())) {
    this.startMousePos = MMCommonFun.touchPosition(e);
    console.log("mouse down:(" + this.startMousePos.x + "," + this.startMousePos.y + ")");
  } else {
    this.moveLen = 1;
    if (this.navigatorMap) {
      this.navigatorMap.preventMouseEvents(true);
    }
    //that.$scroll_editor.css("cursor","move");
    this.lastScreenPos = MMCommonFun.touchPosition(e);
  }
  this.mouseDown = true;
};
MMCommonEditorView.prototype._onMouseMove = function (e) {
  if (this.mouseDown && this.hotZonePanelCtl && (this.hotZonePanelCtl.isHotZoneInCreation() || this.hotZonePanelCtl.isTargetInCreation())) {
    this.endMousePos = MMCommonFun.touchPosition(e);
    var delta = this.startMousePos.offsetTo(this.endMousePos);
    var canvas = this._$operateLayer[0];
    var ctx = canvas.getContext("2d");
    var w = canvas.offsetWidth;
    var h = canvas.offsetHeight;
    ctx.clearRect(0, 0, w, h);
    if (this.hotZonePanelCtl.isHotZoneInCreation()) {
      ctx.fillStyle = "rgba(0, 255, 0, 0.5)";
    }
    if (this.hotZonePanelCtl.isTargetInCreation()) {
      ctx.fillStyle = "rgba(255, 0, 0, 0.5)";
    }
    ctx.fillRect(this.startMousePos.x, this.startMousePos.y, delta.x, delta.y);
  } else {
    var newScreePos = MMCommonFun.touchPosition(e);
    if (this.moveLen) {
      this.moveLen += Math.abs(newScreePos.x - this.lastScreenPos.x) + Math.abs(newScreePos.y - this.lastScreenPos.y);
    }
    if ((e.type == "mousemove" || e.type == "touchmove") && this.lastScreenPos && this.mouseDown && !this.operationCenter.m_selectedObjs.length) {
      this._scrollNotificationHandler(new _MMPoint["default"](this.$root[0].scrollLeft - (newScreePos.x - this.lastScreenPos.x), this.$root[0].scrollTop - (newScreePos.y - this.lastScreenPos.y)));
    }
    this.lastScreenPos = newScreePos;
  }
};
MMCommonEditorView.prototype._onMouseUp = function (e) {
  if (this.mouseDown) {
    this.mouseDown = false;
    if (this.hotZonePanelCtl && (this.hotZonePanelCtl.isHotZoneInCreation() || this.hotZonePanelCtl.isTargetInCreation())) {
      this._createHotZone();
    } else {
      // this.$navi_root.css('pointer-events', 'all');
      if (this.navigatorMap) {
        this.navigatorMap.preventMouseEvents(false);
      }
      this.moveLen = 0;
    }
  }
};
MMCommonEditorView.prototype._onScroll = function () {
  var that = this;
  this.showCommentLine();
};
MMCommonEditorView.prototype.focusInNavi = function () {
  if (!this.needDisplayNavi()) {
    return;
  }
  this.navigatorMap.focus();
};
MMCommonEditorView.prototype._calcMicroNaviDimensions = function () {
  var scroll = this.container;
  var width = scroll.scrollWidth;
  var height = scroll.scrollHeight;
  var viewWidth = scroll.offsetWidth;
  var handle = this.getPanelVariable();
  if (handle.panel) {
    var w = handle.panel.$el[0].offsetWidth; // + 15;
    width -= w;
    viewWidth -= w;
  }
  return {
    top: scroll.scrollTop / height * this.naviH,
    left: scroll.scrollLeft / width * this.naviW,
    viewW: viewWidth / width * this.naviW,
    viewH: scroll.offsetHeight / height * this.naviH
  };
};
MMCommonEditorView.prototype.removeFromSuperView = function () {
  if (this.$root) {
    this.$root.remove();
  }
  if (this.scroller) {
    this.scroller.editor = null;
    this.scroller = null;
  }
  if (this.operationCenter) {
    this.operationCenter.destroy();
    this.operationCenter = null;
  }
  _Dispatcher["default"].off(null, null, this);
  this.$root = null;
  this.mmPicObj = null;
  this.board = null;
  if (this.__scaleDisplay) {
    this.__scaleDisplay.remove();
    this.__naturalSize.remove();
  }
  if (this.$navi_root) {
    this.$navi_root.remove();
  }
  if (this.navigatorMap) {
    this.navigatorMap.removeFromSuperView();
  }
  var elementsCtl = _MMObjElementsController["default"].getSingleInstance();
  elementsCtl.removeAllDivsForEditor(this);
  this.removeCommentPanel();
  this.__lastWinW = 0;
  this.winW = 0;
};
MMCommonEditorView.prototype.getObjsInView = function () {
  if (this.board) {
    var divObjs = this.board.getObjsInPageByFilter(this.mmPicObj.getPageIndex(), this.divObjsFilter, this.mmPicObj.getExpandRect());
    var canvasObjs = this.board.getObjsInPageByFilter(this.mmPicObj.getPageIndex(), this.canvasObjsFilter, this.mmPicObj.getExpandRect());
    for (var i = 0; i < canvasObjs.length; i++) {
      var obj = canvasObjs[i];
      var found = false;
      for (var k = 0; k < divObjs.length; k++) {
        var dvObj = divObjs[k];
        if (obj == dvObj) {
          found = true;
        }
      }
      if (!found) {
        divObjs.push(obj);
      }
    }
    return divObjs;
  } else {
    return [];
  }
};
MMCommonEditorView.prototype.showCommentPanel = function (mmobj, div) {
  if (!app.canDispInNormalBrowser()) {
    this.showCommentPanelForMobile(mmobj, div);
  } else {
    this.showCommentPanelForPC(mmobj, div);
  }
};
MMCommonEditorView.prototype.showCommentPanelForMobile = function (mmobj, div) {
  var center = MMCommonFun.getDivCenter($(div));
  var posInBody = MMCommonFun.convertPointBetweenElements(div, $("body")[0], center);
  var self = this;
  var handle = this.getPanelVariable();
  if (!handle.panel) {
    handle.panel = new _MDCommentSlidePanelView["default"]({
      comment: mmobj,
      view: this.m_editor,
      editorViewCtl: this.editorViewCtl,
      imgMarkerCtl: self.imgMarkerCtl,
      onCloseBtnClicked: function onCloseBtnClicked() {
        _MMObjElementsController["default"].commentPointUpdater.updateCommentView(mmobj, "readed");
        handle.panel.removeFromSuperView();
        handle.panel = null;
      },
      onRemove: function onRemove() {
        handle.panel = null;
      }
    });
    application.addSubView(handle.panel);
    handle.panel.centerZoomShowForMobile(posInBody);
  }
};
MMCommonEditorView.prototype.getPanelVariable = function () {
  var panelInDisp = {
      panel: null
    },
    panelInScrible = {
      panel: null
    };
  return function getPanelVariable() {
    if (this.editorMode == _EditorMode["default"].normal) {
      return panelInDisp;
    } else {
      return panelInScrible;
    }
  };
}();
MMCommonEditorView.prototype.showCommentPanelForPC = function (mmobj, div) {
  var self = this;
  self.commentDiv = div;
  self.commentObj = mmobj;
  var handle = this.getPanelVariable();
  if (mmobj && handle.panel && handle.panel._comment === mmobj) {
    return;
  }
  console.assert(mmobj.m_objType === _ObjType["default"].Obj_comment);
  if (!this.scroller) {
    this.scroller = new _MMEditorScroller["default"](this);
  }
  this.scrollToShowComment(div);
  if (this.commentPanelTimeout) {
    return;
  }
  if (handle.panel) {
    handle.panel.removeFromSuperView();
    handle.panel = null;
  }
  if (!handle.panel) {
    handle.panel = new _MDCommentSlidePanelView["default"]({
      view: self,
      editorViewCtl: self.editorViewCtl,
      comment: mmobj,
      enableDraggable: true,
      imgMarkerCtl: self.imgMarkerCtl,
      onDrag: function onDrag() {
        self.editorViewCtl.showCommentLine();
      },
      onCloseBtnClicked: function onCloseBtnClicked() {
        self.removeCommentPanel();
        self.removeCommentLine();
      },
      onRemove: function onRemove() {
        handle.panel = null;
        var mainEditor = self.editorViewCtl;
        mainEditor && mainEditor.checkToEnablePrivateMouseWheel();
      },
      onOpen: function onOpen() {
        self.showCommentLine();
      }
    });
  } else {
    handle.panel.update({
      comment: mmobj
    });
  }
  app.application.addSubView(handle.panel);
  var startOffset = $(self.commentDiv).offset();
  var left = startOffset.left;
  var top = startOffset.top;
  var pos = MMCommonFun.convertPointBetweenElements(self.commentDiv, $("body")[0], {
    x: 0,
    y: 0
  });
  console.log("========= " + startOffset.top + "," + startOffset.left);
  console.log("--------- " + pos.y + "," + pos.x);
  if (pos.x == 0) {
    if (!self.commentDiv.hello) {
      self.commentDiv.hello = "haha";
    } else {
      self.commentDiv.hello += "0";
    }
  }
  console.log("self.commentDiv" + " ---> " + self.commentDiv.hello);
  handle.panel.zoomShow({
    y: top,
    x: left
  }, function () {
    self.editorViewCtl && self.editorViewCtl.showCommentLine();
  });
  // handle.panel.saveEditorScaleAndPosition();

  this.commentPanelTimeout = setBabelTimeout(function () {
    self.commentPanelTimeout = null;
  }, 1000);
};
MMCommonEditorView.prototype.getCommentPanelLeftTop = function (comment) {
  var lgPos = comment.getPos();
  var trsfm = this.getDivTransformer();
  var pgIndex = this.getCurrentFilePageIndex();
  var dvPos = trsfm.lg2dvPoint(lgPos, pgIndex);
  var commentLayer = this.getCommentLayer();
  var pos = MMCommonFun.convertPointBetweenElements(commentLayer, $("body")[0], dvPos);
  return pos;
};
MMCommonEditorView.prototype.removeCommentPanel = function () {
  var handle = this.getPanelVariable();
  if (handle.panel) {
    if (handle.panel.superView) {
      handle.panel.removeFromSuperView();
    }
    handle.panel = null;
    _MMObjElementsController["default"].commentPointUpdater.updateCommentView(this.commentObj, "readed");
    this.scroller = null;
    this.commentObj = null;
    this.commentDiv = null;
    this.clearCommentCanvas();
  }
};
MMCommonEditorView.prototype.removeCommentLine = function () {
  this.commentDiv = null;
};
MMCommonEditorView.prototype.showCommentLine = function () {
  return;
  var handle = this.getPanelVariable();
  if (!app.canDispInNormalBrowser()) return;
  if (handle.panel) {
    this.clearCommentCanvas();
    var elementsCtl = _MMObjElementsController["default"].getSingleInstance();
    var div = elementsCtl.getDivByObj(this, this.commentObj);
    if (div) {
      _MMCommentLineDrawer["default"].drawLineBetweenDivs(this.getCommentLineLayer(), div, handle.panel.getPointerRectView(), this.scale);
    }
  }
};
MMCommonEditorView.prototype.setCommentDiv = function (div) {
  this.commentDiv = div;
};

/**
 * a method should return a converted point, that can be transfered to a LG point using the
 * this.trsfm.dv2lsPoint() (ImageTransformer)
 * @param
 * @returns {MMPoint} devicepoint for the Image - Transformation
 */
MMCommonEditorView.prototype.convertPointFromAssistView2Editor = function (pos) {
  //todo: this implementation is from the EditorView
  var newpos = pos.clone();
  var to = this.getCommentLayer();
  var from = this.getAssistantCanvas();
  var converted = MMCommonFun.convertPointBetweenElements(from, to, pos);
  newpos.x = converted.x;
  newpos.y = converted.y;
  return newpos;
};
MMCommonEditorView.prototype.convertPointFromEditor2AssistView = function (pos) {
  var newpos = pos.clone();
  var to = this.getAssistantCanvas();
  var from = this.getCommentLayer();
  var converted = MMCommonFun.convertPointBetweenElements(from, to, pos);
  newpos.x = converted.x;
  newpos.y = converted.y;
  return newpos;
};

// --------------------------  ----------------------------  --------------------  新增转换函数
//
MMCommonEditorView.prototype.logic2AssistViewPoint = function (pos) {
  var devicePoint = this.divTrsfm.lg2dvPoint(pos);
  var newPoint = this.convertPointFromEditor2AssistView(devicePoint);
  return newPoint;
};
MMCommonEditorView.prototype.assistView2LogicPoint = function (pos) {
  if (!this.divTrsfm) {
    return pos;
  }
  var newpos = this.convertPointFromAssistView2Editor(pos);
  var logicPoint = this.divTrsfm.dv2lgPoint(newpos);
  return logicPoint;
};
MMCommonEditorView.prototype.clearCommentCanvas = function () {
  var canvas = this.getCommentLineLayer();
  if (!canvas) {
    return;
  }
  var ctx = canvas.getContext("2d");
  var w = parseInt($(canvas).attr("width"));
  var h = parseInt($(canvas).attr("height"));
  ctx.clearRect(0, 0, w, h);
};
MMCommonEditorView.prototype.scrollToShowComment = function (comment) {
  this.scroller.scrollToShowObjDiv(this.commentDiv);
};
MMCommonEditorView.prototype.getScrollContent = function () {
  return this._$content[0];
};
MMCommonEditorView.prototype.getImageDispSize = function () {
  var size = new _size["default"](this._$editorZone[0].clientWidth, this._$editorZone[0].clientHeight);
  return size;
};
MMCommonEditorView.prototype.getCommentPanelDiv = function () {
  var handle = this.getPanelVariable();
  return handle.panel.$el[0];
};
MMCommonEditorView.prototype.getImageURL = function (imageData) {
  return imageData.getFilePath_Original();
};

//
// change the editor mode
// @param mode {string}
//
MMCommonEditorView.prototype.setMode = function (mode) {
  if (this.editorMode != mode) {
    this.editorMode = mode;
    this.refreshViewByCurrentMode();
  }
};
MMCommonEditorView.prototype.refreshViewByCurrentMode = function () {
  if (this.editorMode == _EditorMode["default"].mark) {
    this.canvasObjsFilter.moveObjType(_ObjType["default"].Obj_textComment);
    this.canvasObjsFilter.moveObjType(_ObjType["default"].GObj_text);
    this.canvasObjsFilter.moveObjType(_ObjType["default"].Obj_graphComment);
  }
};
MMCommonEditorView.prototype.getZoomScale = function () {
  return this.scale;
};
MMCommonEditorView.prototype.getObjectNatureSize = function () {
  return {
    width: this.originRotateW,
    height: this.originRotateH
  };
};
MMCommonEditorView.prototype.scrollToShowLgRct = function (lgRct, callback) {
  var lgPts = lgRct.getLogicPts();
  var dvPts = [];
  for (var i = 0; i < lgPts.length; i++) {
    var lgPt = lgPts[i];
    var dvPt = this.divTrsfm.lg2dvPoint(lgPt);
    dvPts.push(dvPt);
  }
  var ptsInView = [];
  for (var i = 0; i < dvPts.length; i++) {
    var dvPt = dvPts[i];
    var pt = MMCommonFun.convertPointBetweenElements(this._$editorLayer[0], this.$root[0], dvPt);
    ptsInView.push(pt);
  }
  var rect = MMCommonFun.getRect(ptsInView);
  var targetCenter = rect.getCenter();
  var pos = {
    x: targetCenter.x - this.$root[0].offsetWidth / 2,
    y: targetCenter.y - this.$root[0].offsetHeight / 2
  };
  this.scrollToPosition(pos, true, callback);
};
MMCommonEditorView.prototype.getCurrentBoard = function () {
  return this.mmPicObj.getBoard();
};
MMCommonEditorView.prototype.getCommentsDivs = function () {
  var elementsCtl = _MMObjElementsController["default"].getSingleInstance();
  var commentDivs = elementsCtl.getCommentsDivs(this);
  return commentDivs;
};
MMCommonEditorView.prototype.getDivByObj = function (commentObj) {
  var elementsCtl = _MMObjElementsController["default"].getSingleInstance();
  var element = null;
  if (commentObj) {
    element = elementsCtl.getDivByObj(this, commentObj);
  }
  return element;
};
MMCommonEditorView.prototype.closeCommentPanel = function () {
  this.removeCommentPanel();
  var handle = this.getPanelVariable();
  if (handle.panel) {
    handle.panel.remove();
    handle.panel = null;
  }
};
MMCommonEditorView.prototype.pinchMove = function (scale) {
  this.pinching = true;
  scale = this.calcFinalScale(scale);
  _MMAndroidScrollView["default"].prototype.pinchMove.call(this, scale);
};

// 模拟滚轮结束时的刷新操作
MMCommonEditorView.prototype.pinchEnd = function (scale) {
  this.pinching = false;
  scale = this.calcFinalScale(scale);
  _MMAndroidScrollView["default"].prototype.pinchEnd.call(this, scale);
};

//
// 控制面积不能太大也不能太小
// 2016.9.22
// jiang
//
MMCommonEditorView.prototype.calcFinalScale = function (deltaScale) {
  //1. 不允许 deltaScale <= 0
  if (deltaScale <= 0) {
    return 1.0;
  }
  var maxArea = 4500 * 4500;
  var minArea = 100 * 100;
  var doubleArea = this.originRotateW * this.originRotateH * 2 * 2;
  if (this.board.isCADFile()) {
    maxArea = 3072 * 3072;
  } else if (maxArea < doubleArea) {
    maxArea = doubleArea;
  }
  var originConentSize = {
    w: this.originRotateW,
    //this.$contentDiv.width(),
    h: this.originRotateH //this.$contentDiv.height()
  };
  var curDispSize = {
    w: originConentSize.w * this.scale,
    h: originConentSize.h * this.scale
  };
  var curArea = curDispSize.w * curDispSize.h;
  var finalScale = this.scale * deltaScale;
  var scaledSize = {
    w: originConentSize.w * finalScale,
    h: originConentSize.h * finalScale
  };
  var scaledArea = scaledSize.w * scaledSize.h;
  var targetDeltaScale = deltaScale;

  // 不能超过最大最小值
  if (deltaScale < 1) {
    if (curArea > minArea) {
      if (scaledArea < minArea) {
        targetDeltaScale = Math.sqrt(minArea / curArea);
      }
    } else {
      targetDeltaScale = 1.0;
    }
  } else {
    if (curArea < maxArea) {
      if (scaledArea > maxArea) {
        targetDeltaScale = Math.sqrt(maxArea / curArea);
      }
    } else {
      targetDeltaScale = 1.0;
    }
  }

  // 关键比例的捕捉
  var keyScales = [0.5, 1.0]; //-------- 关键比例
  var error = 0.09; //------------ 吸附距离

  var curScale = this.scale;
  if (this.hiddenScale) {
    curScale = this.hiddenScale;
  }
  finalScale = curScale * targetDeltaScale;
  var absorbed = false;
  for (var i = 0; i < keyScales.length; i++) {
    // 吸附发生
    if (Math.abs(keyScales[i] - finalScale) < error) {
      this.hiddenScale = finalScale;
      absorbed = true;
      targetDeltaScale = keyScales[i] / this.scale;
      break;
    }
  }
  if (!absorbed) {
    if (this.hiddenScale) {
      this.hiddenScale = 0;
      targetDeltaScale = finalScale / this.scale;
    }
  }
  console.log("hiddenScale :", this.hiddenScale);
  return targetDeltaScale;
};
MMCommonEditorView.prototype.setImgMarkerCtl = function (imgMarkerCtl) {
  this.imgMarkerCtl = imgMarkerCtl;
  if (this.operationCenter) {
    this.operationCenter.setImgMarkerCtl(imgMarkerCtl);
  }
};
MMCommonEditorView.prototype.dispSalonSpeakerMouseClick = function (logicPoint) {
  MDEditorCommonFun.dispSalonSpeakerMouseClick(this, logicPoint);
};
MMCommonEditorView.prototype.getCenterLogicPosition = function () {
  var ratioCenter = this.getCenterRatioPosition();
  var ptDiv = new _MMPoint["default"](ratioCenter.x * this.container.scrollWidth, ratioCenter.y * this.container.scrollHeight);
  var to = this.getAssistantCanvas();
  var ptInCanvas = MMCommonFun.convertPointBetweenElements(this.$contentDiv[0], to, ptDiv);
  ptInCanvas = new _MMPoint["default"](ptInCanvas.x, ptInCanvas.y);
  var lgPos = this.assistView2LogicPoint(ptInCanvas);
  return lgPos;
};
MMCommonEditorView.prototype.restoreCenterLogicPosition = function (lgCenter) {
  lgCenter = new _MMPoint["default"](lgCenter.x, lgCenter.y);
  var ptInCanvas = this.logic2AssistViewPoint(lgCenter);
  var from = this.getAssistantCanvas();
  var ptInContent = MMCommonFun.convertPointBetweenElements(from, this.$contentDiv[0], ptInCanvas);
  var ptCenter = {
    x: ptInContent.x / this.container.scrollWidth,
    y: ptInContent.y / this.container.scrollHeight
  };
  this.restoreCenterPostion(ptCenter);
};
MMCommonEditorView.prototype.clearSalonSpeakerMouseClick = function () {
  MDEditorCommonFun.clearSalonSpeakerMouseClick(this);
};
MMCommonEditorView.prototype.lg2ContentDvRect = function (rect) {
  var rctPts = rect.getCtrlPts(true);
  var tgPts = this.lg2ContentDvPoints(rctPts);
  var dvRect = new _MMRect["default"]();
  dvRect.initWithPtsBounadingBox(tgPts);
  return dvRect;
};
MMCommonEditorView.prototype.dv2ContentLgRect = function (rect) {
  var rctPts = rect.getCtrlPts(true);
  var tgPts = this.contentDv2LgPoints(rctPts);
  var dvRect = new _MMRect["default"]();
  dvRect.initWithPtsBounadingBox(tgPts);
  return dvRect;
};
MMCommonEditorView.prototype.lg2ContentDvPoints = function (pts) {
  var pageIndex = this.getCurrentFilePageIndex();
  var $parentDiv = $(this.getScrollContent());
  var trsfm = this.getDivTransformer();
  var dvPts = trsfm.lg2dvPoints(pts, pageIndex);
  var parentDiv = this.getScrollContent();
  var editorPage = this.getCommentLayer();
  var tgPts = [];
  for (var i = 0; i < dvPts.length; i++) {
    var pt = dvPts[i];
    var convert = MMCommonFun.convertPointBetweenElements(editorPage, parentDiv, pt);
    tgPts.push(new _MMPoint["default"](convert.x, convert.y));
  }
  return tgPts;
};
MMCommonEditorView.prototype.contentDv2LgPoints = function (pts) {
  var pageIndex = this.getCurrentFilePageIndex();
  var trsfm = this.getCanvasTransformer();
  var ptInPage = this.convertPtsFromContent2Page(pts);
  var lgPts = trsfm.dv2lgPoints(ptInPage, pageIndex);
  return lgPts;
};
MMCommonEditorView.prototype.convertPtsFromContent2Page = function (pts) {
  var parentDiv = this.getScrollContent();
  var editorPage = this.getCommentLayer();
  var ptInPage = [];
  for (var i = 0; i < pts.length; i++) {
    var pt = pts[i];
    var convert = MMCommonFun.convertPointBetweenElements(parentDiv, editorPage, pt);
    ptInPage.push(new _MMPoint["default"](convert.x, convert.y));
  }
  return ptInPage;
};
MMCommonEditorView.prototype.getDispRectInContentForObj = function (lgObj) {
  var lgRect = lgObj.getRect();
  var dvRect = this.lg2ContentDvRect(lgRect);
  return dvRect;
};
MMCommonEditorView.prototype.getDispStartEndPtsInContentForObj = function (lgObj) {
  var lgPts = lgObj.getLogicPts();
  var dvPts = this.lg2ContentDvPoints(lgPts);
  var startEndPts = [dvPts[0], dvPts[dvPts.length - 1]];
  return startEndPts;
};
MMCommonEditorView.prototype.showCommentLayer = function () {
  this._$operateLayer.show();
  this.textLayerCtl && this.textLayerCtl.setEnable(true);
};
MMCommonEditorView.prototype.hideCommentLayer = function () {
  this._$operateLayer.hide();
  this.textLayerCtl && this.textLayerCtl.setEnable(false);
};
MMCommonEditorView.prototype._salonStatusChanged = function (salonInfo) {
  if (!salonInfo) {
    // 演播结束
    this.getCurrentBoard().clearSalonScribbles();
    this.clearSalonPenCanvas();
  }
};
MMCommonEditorView.prototype.restoreBackgroundColor = function () {};
MMCommonEditorView.prototype.showFocusRect = function (lgRect) {
  MMCommonEditorView.showFocusRect(this, lgRect);
};
MMCommonEditorView.prototype.rotate90 = function () {
  var _this = this;
  if (this.isRotating) {
    return;
  }
  this.isRotating = true;
  this.angle = (this.angle - 90) % 360;
  this.angle = this.angle < 0 ? this.angle + 360 : this.angle;
  this.setDispAngle(this.angle);
  this.refreshEditor(function () {
    _this.isRotating = false;
  });
};
MMCommonEditorView.prototype.setDispAngle = function (angle) {
  this.angle = angle;
  this.mmPicObj.setRotateAngle90(this.angle);
  var i = this.mmPicObj.getPageIndex();
  var curTask = this.mmPicObj.getBoard();
  var fileInfo = curTask && curTask.getFileInfo();
  var fileId = fileInfo.getFileId();
  MMCommonFun.setDefaultRotate(fileId, i, this.angle);
  if (angle == 90 || angle == 270) {
    this.originRotateW = this.originH;
    this.originRotateH = this.originW;
  } else {
    this.originRotateW = this.originW;
    this.originRotateH = this.originH;
  }
  this.imgRatio = this.originRotateH / this.originRotateW;
  this.initNavigator();
};
MMCommonEditorView.prototype.getContentLgRect = function () {
  var lgImgRect = this.mmPicObj.getDrawRect();
  return lgImgRect;
};
MMCommonEditorView.showFocusRect = function (editor, lgRect) {
  var trsfm = editor.getCanvasTransformerForAssist();
  var dvRect = trsfm.lg2dvRect(lgRect);
  var canvas = editor.getAssistantCanvas();
  var ctx = canvas.getContext("2d");
  ctx.fillStyle = "rgba(255,255,0, 0.5)";
  ctx.fillRect(dvRect.left, dvRect.top, dvRect.getWidth(), dvRect.getHeight());
  setBabelTimeout(function () {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  }, 500);
};
var _default = exports["default"] = MMCommonEditorView;

},{"1084":1084,"1184":1184,"1417":1417,"1421":1421,"1423":1423,"1438":1438,"1454":1454,"1463":1463,"1466":1466,"1471":1471,"1487":1487,"1538":1538,"1543":1543,"1545":1545,"18":18,"319":319,"325":325,"427":427,"72":72,"76":76,"811":811,"823":823,"826":826,"830":830,"831":831,"837":837,"856":856,"861":861,"876":876,"877":877,"879":879,"880":880,"893":893,"904":904,"906":906,"907":907,"909":909,"913":913,"939":939,"949":949,"955":955}],939:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1465);
var _MMBasicData = _interopRequireDefault(require(811));
var _MMPoint = _interopRequireDefault(require(830));
function MDNavigatorMap(parentDiv, scroll, $content, callback) {
  var that = this;
  this.parentDiv = parentDiv;
  this.scroll = scroll;
  this.$content = $content;
  var z_maxIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
  var tmpl = '<div id="navi-root" class="navi-root">' + '<div>' + '<img class="image-map"/>' + '<canvas class="pdf-map"></canvas>' + '</div>' + '<canvas class="focus-frame"></canvas> ' + '</div>';
  this.$navi_root = $(tmpl);
  this.$navi_root.css('z-index', z_maxIndex);
  this._$pdfMap = this.$navi_root.find('.pdf-map');
  this._$imageMap = this.$navi_root.find('.image-map');
  this._$focusFrame = this.$navi_root.find('.focus-frame');
  $(parentDiv).append(this.$navi_root);
  var mouseNaviRootDown = false;
  this.$navi_root.on('mousedown', function (e) {
    mouseNaviRootDown = true;
    naviScroll(e);
  });
  this.$navi_root.on('mouseup', function (e) {
    naviScroll(e);
    mouseNaviRootDown = false;
  });
  this.$navi_root.on('mousemove', function (e) {
    naviScroll(e);
  });
  this._overNaviRoot = false;
  this.$navi_root.on('mouseleave', function (e) {
    naviScroll(e);
    mouseNaviRootDown = false;
    that._overNaviRoot = false;
    that.onScroll();
  });
  this.$navi_root.on('mouseenter', function (e) {
    that._overNaviRoot = true;
  });
  function naviScroll(e) {
    var factor = parseFloat(that.$content.width()) / parseFloat(that.$navi_root.width()); // * that.getScale();
    var factorY = parseFloat(that.$content.height()) / parseFloat(that.$navi_root.height()); // * that.getScale();
    var dimensions = that._calcMicroNaviDimensions();
    if (mouseNaviRootDown && callback) {
      var x = ((e.offsetX || e.pageX) - dimensions.viewW / 2) * factor;
      var y = ((e.offsetY || e.pageY) - dimensions.viewH / 2) * factorY;
      var pt = new _MMPoint["default"](x, y);
      callback(pt);
    }
  }
  this.onScroll = function (e) {
    clearTimeout(that.__naviShowTimeout);
    that.__naviShowTimeout = setBabelTimeout(function (e) {
      if (that._overNaviRoot !== true) that.$navi_root.css('display', 'none');
    }, 1000);
    if (that.scroll.scrollWidth > that.scroll.offsetWidth || that.scroll.scrollHeight > that.scroll.offsetHeight) {
      that.$navi_root.css('display', 'inline');
    }
    that.focus();
  };
  $(scroll).on('scroll.navi', this.onScroll);
}
;
MDNavigatorMap.prototype.removeFromSuperView = function () {
  if (this.$navi_root) {
    this.$navi_root.remove();
  }
  $(this.scroll).off('scroll.navi', this.onScroll);
};
MDNavigatorMap.prototype.initNavigator = function (winW, winH, imgRatio, imgFilePath, angle) {
  var that = this;
  this.naviShowTimeout = null;
  this.winW = winW;
  this.winH = winH;
  this.imgRatio = imgRatio;

  // set navigation view size and image
  var winArea = this.winW * this.winH;
  var naviArea = winArea / 15;
  if (naviArea > 40000) {
    naviArea = 40000;
  }
  this.naviW = Math.sqrt(naviArea / this.imgRatio); // S(navi) < 200 * 200
  this.naviH = this.naviW * this.imgRatio;
  if (this.naviH > $(this.parentDiv).height() - 20) {
    this.naviH = $(this.parentDiv).height() - 20;
    this.naviW = this.naviH / this.imgRatio;
  }
  this.$navi_root.css('width', this.naviW + 'px');
  this.$navi_root.css('height', this.naviH + 'px');
  this.$navi_root.css('left', '10px');
  this.$navi_root.css('top', '10px');
  this._$pdfMap.css('display', 'none');
  this._$imageMap.css('display', 'block');
  this._$imageMap.css('position', 'absolute');
  var imgW = this.naviW;
  var imgH = this.naviH;
  if (angle == 90 || angle == 270) {
    imgW = this.naviH;
    imgH = this.naviW;
  }
  var curMap;
  if (imgFilePath && imgFilePath.tagName == 'CANVAS') {
    curMap = this._$pdfMap;
  } else {
    curMap = this._$imageMap;
  }
  curMap.css('width', imgW + 'px');
  curMap.css('height', imgH + 'px');
  curMap.css('left', (this.naviW - imgW) / 2 + 'px');
  curMap.css('top', (this.naviH - imgH) / 2 + 'px');
  curMap.css('transform', 'rotate(' + angle + 'deg)');
  var lowFilePath = imgFilePath;
  if (this.__imageMapSrc !== lowFilePath) {
    this._$imageMap.css('display', 'none');
    if (lowFilePath.tagName == 'CANVAS') {
      var ctx = curMap[0].getContext("2d");
      ctx.drawImage(lowFilePath, 0, 0, lowFilePath.width, lowFilePath.height, 0, 0, curMap[0].width, curMap[0].height);
      that._$pdfMap.css('display', 'block');
    } else {
      var tmpImg = new Image();
      tmpImg.onload = function (e) {
        that._$imageMap.css('display', 'block');
      };
      tmpImg.src = lowFilePath;
      this.__imageMapSrc = lowFilePath;
      this._$imageMap[0].src = lowFilePath;
    }
  }
  this._$focusFrame.attr('width', this.naviW + 1 + 'px');
  this._$focusFrame.attr('height', this.naviH + 1 + 'px');
};
MDNavigatorMap.prototype._calcMicroNaviDimensions = function () {
  var scroll = this.scroll;
  var width = scroll.scrollWidth;
  var height = scroll.scrollHeight;
  var viewWidth = scroll.offsetWidth;
  if (this.commentPanel) {
    var w = this.commentPanel.$el[0].offsetWidth; // + 15;
    width -= w;
    viewWidth -= w;
  }
  return {
    top: scroll.scrollTop / height * this.naviH,
    left: scroll.scrollLeft / width * this.naviW,
    viewW: viewWidth / width * this.naviW,
    viewH: scroll.offsetHeight / height * this.naviH
  };
};
MDNavigatorMap.prototype.focus = function () {
  var dimensions = this._calcMicroNaviDimensions();
  var context = this._$focusFrame[0].getContext('2d');
  context.clearRect(0, 0, this.naviW, this.naviH);
  context.fillStyle = 'rgba(0,0,0,0.6)';
  context.fillRect(0, 0, this.naviW + 1, this.naviH + 1);
  context.clearRect(dimensions.left, dimensions.top, dimensions.viewW, dimensions.viewH);
  context.strokeStyle = 'red';
  context.lineWidth = 1;
  context.strokeRect(dimensions.left, dimensions.top, dimensions.viewW, dimensions.viewH);
};
MDNavigatorMap.prototype.preventMouseEvents = function (prevent) {
  if (prevent) {
    this.$navi_root.css('pointer-events', 'none');
  } else {
    this.$navi_root.css('pointer-events', 'all');
  }
};
var _default = exports["default"] = MDNavigatorMap;

},{"1184":1184,"1417":1417,"1454":1454,"1463":1463,"1465":1465,"811":811,"830":830}],907:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1421);
var _size = _interopRequireDefault(require(837));
var _MMPoint = _interopRequireDefault(require(830));
var MMEditorScroller = function MMEditorScroller(editor) {
  this.editor = editor;
  this.oldScrollWidth = 0;
};
MMEditorScroller.prototype.changeScrollWidthByPanel = function () {
  //	var scrollView = this.editor.getScrollView();
  this.panelDiv = this.editor.getCommentPanelDiv();
  var scrollContent = this.editor.getScrollContent();
  this.oldScrollWidth = scrollContent.offsetWidth;
  var newW = scrollContent.offsetWidth + this.panelDiv.offsetWidth;
  $(scrollContent).css("width", newW + "px");
};
MMEditorScroller.prototype.restoreScrollWidth = function () {
  var scrollContent = this.editor.getScrollContent();
  $(scrollContent).css("width", this.oldScrollWidth + "px");
};
MMEditorScroller.prototype.scrollToShowObjDiv = function (objDiv) {
  var isChrome = false;
  if (navigator.userAgent.indexOf("Chrome") > -1) isChrome = true;
  var scrollView = this.editor.getScrollView();
  var needScrollWin = false;
  if (scrollView.tagName.toLowerCase() == "body" || scrollView == window) {
    needScrollWin = true;
  }
  if (isChrome || !needScrollWin) {
    this.scrollDivToShowObjDiv(objDiv);
  } else {
    this.scrollWindowToShowObjDiv(objDiv);
  }
};
MMEditorScroller.prototype.scrollDivToShowObjDiv = function (objDiv) {
  var viewSize = this.editor.getScrollViewSize();
  var scrollView = this.editor.getScrollView();
  var contentSize = new _size["default"](scrollView.scrollWidth, scrollView.scrollHeight);
  var left = scrollView.scrollLeft;
  var top = scrollView.scrollTop;
  var divPos = MMCommonFun.getDivCenter($(objDiv));
  var divPosInScroll = MMCommonFun.convertPointBetweenElements(objDiv, scrollView, divPos);
  var w = 0;
  if (this.panelDiv) {
    w = this.panelDiv.offsetWidth;
  }
  var expand = 80;
  if (divPosInScroll.x + expand > left + viewSize.width - w) {
    console.log("scroll left:" + window.pageXOffset);
    var distX = divPosInScroll.x + expand - (left + viewSize.width - w); //left + viewSize.width
    left += distX;
    console.log("scroll left:" + window.pageXOffset);
  } else if (divPosInScroll.x - expand < left) {
    left = divPosInScroll.x - expand;
  }
  if (divPosInScroll.y + expand > top + viewSize.height) {
    var distY = divPosInScroll.y + expand - (top + viewSize.height);
    top += distY;
  } else if (divPosInScroll.y - expand < top) {
    top = divPosInScroll.y - expand;
  }
  scrollView.scrollLeft = left;
  scrollView.scrollTop = top;
};
MMEditorScroller.prototype.scrollWindowToShowObjDiv = function (objDiv) {
  if (objDiv == null || objDiv == undefined) return;
  var scrollView = this.editor.getScrollView();
  var viewSize = this.editor.getScrollViewSize();
  var contentSize = new _size["default"](scrollView.scrollWidth, scrollView.scrollHeight);
  var left = window.pageXOffset;
  var top = window.pageYOffset;
  var divPos = MMCommonFun.getDivCenter($(objDiv));
  var divPosInWin = MMCommonFun.convertPointBetweenElements(objDiv, window, divPos);
  var panelDiv = this.editor.getCommentPanelDiv();
  var origin = new _MMPoint["default"](0, 0);
  var panelTopLeft = MMCommonFun.convertPointBetweenElements(panelDiv, window, origin);
  var expand = 80;
  if (divPosInWin.x + expand > panelTopLeft.x) {
    console.log("scroll left:" + window.pageXOffset);
    var distX = divPosInWin.x + expand - panelTopLeft.x;
    left += distX;
    console.log("scroll left:" + window.pageXOffset);
  } else if (divPosInWin.x - expand < left) {
    left = divPosInWin.x - expand;
  }
  if (divPosInWin.y + expand > top + window.innerHeight) {
    var distY = divPosInWin.y + expand - window.innerHeight - top;
    top += distY;
  } else if (divPosInWin.y - expand < top) {
    top = divPosInWin.y - expand;
  }
  window.scrollTo(left, top);
};
var _default = exports["default"] = MMEditorScroller;

},{"1184":1184,"1421":1421,"1454":1454,"830":830,"837":837}],906:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 *
 */

function dashLineFun() {
  var CP = window.CanvasRenderingContext2D && CanvasRenderingContext2D.prototype;
  if (CP && CP.lineTo) {
    CP.dashedLine = function (x, y, x2, y2, dashArray) {
      if (!dashArray) dashArray = [10, 5];
      if (dashLength == 0) dashLength = 0.001; // Hack for Safari
      var dashCount = dashArray.length;
      this.moveTo(x, y);
      var dx = x2 - x,
        dy = y2 - y;
      var slope = dx ? dy / dx : 1e15;
      var distRemaining = Math.sqrt(dx * dx + dy * dy);
      var dashIndex = 0,
        draw = true;
      while (distRemaining >= 0.1) {
        var dashLength = dashArray[dashIndex++ % dashCount];
        if (dashLength > distRemaining) dashLength = distRemaining;
        var xStep = Math.sqrt(dashLength * dashLength / (1 + slope * slope));
        if (dx < 0) xStep = -xStep;
        x += xStep;
        y += slope * xStep;
        this[draw ? 'lineTo' : 'moveTo'](x, y);
        distRemaining -= dashLength;
        draw = !draw;
      }
    };
  }
}
;
dashLineFun();
var MMCommentLineDrawer = {
  drawLineBetweenDivs: function drawLineBetweenDivs(canvas, commentDiv, panelPosDiv, scale) {
    var from = commentDiv;
    var pos = MMCommonFun.getDivCenter($(commentDiv));
    var to = canvas;
    var newCommentPos = MMCommonFun.convertPointBetweenElements(from, to, pos);
    from = panelPosDiv;
    pos = MMCommonFun.getDivCenter($(panelPosDiv));
    var newPanelPos = MMCommonFun.convertPointBetweenElements(from, to, pos);
    if (!commentDiv) return;
    MMCommentLineDrawer.lineColor = commentDiv.userIdColor;
    MMCommentLineDrawer.drawLineWithPos(canvas, newCommentPos, newPanelPos, scale);

    // test
    // var ctx = canvas.getContext('2d');
    // ctx.fillStyle='red';
    // ctx.fillRect(0, 0, 100, 100);
  },
  drawLineWithPos: function drawLineWithPos(canvas, fromPos, toPos, scale) {
    var cxt = canvas.getContext("2d");
    if (!scale) {
      scale = 1.0;
    }
    ;
    if (scale < 0.01) {
      scale = 0.01;
    }
    ;
    //cxt.clearRect(0, 0, canvas.offsetWidth, canvas.offsetHeight);
    cxt.strokeStyle = MMCommentLineDrawer.lineColor;
    cxt.lineWidth = 3.0; // / scale;
    cxt.beginPath();
    //			cxt.moveTo(fromPos.x, fromPos.y);
    //			cxt.lineTo(toPos.x, toPos.y);
    cxt.dashedLine(fromPos.x, fromPos.y, toPos.x, toPos.y, [10, 5]); //[10/scale, 5/scale]
    cxt.stroke();
  },
  clear: function clear(canvas) {
    var cxt = canvas.getContext("2d");
    cxt.clearRect(0, 0, canvas.offsetWidth, canvas.offsetHeight);
  }
};
var _default = exports["default"] = MMCommentLineDrawer;

},{"1454":1454}],880:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMOperationCenterMobile = _interopRequireDefault(require(878));
var _MMOperationCenter = _interopRequireDefault(require(874));
function MMOperationCenterMobileMarker(options) {
  options.isMarker = true;
  _MMOperationCenterMobile["default"].call(this, options);
}
MMOperationCenterMobileMarker.prototype = _.extend({}, _MMOperationCenterMobile["default"].prototype); //window['*OperationCenterPrototype'];
MMOperationCenterMobileMarker.prototype.superclass = _MMOperationCenterMobile["default"]; //window['*OperationCenterPrototype'];

// ****************** EVENTS START ****************

MMOperationCenterMobileMarker.prototype.onThrowRight = function () {
  if (this.mode !== 'taskboard') return;
  if (this.m_curOperation) return;
  if (this.longPressHappend) return;
  this.throwHappened = true;
};
MMOperationCenterMobileMarker.prototype.onThrowLeft = function () {
  if (this.mode !== 'taskboard') return;
  if (this.m_curOperation) return;
  if (this.longPressHappend) return;
  this.throwHappened = true;
};
MMOperationCenterMobileMarker.prototype.onPanStart = function (f, e) {
  if (!this.m_curOperation) {
    // e.preventDefault()
    this.userStartPan(f, e);
  }
};
MMOperationCenterMobileMarker.prototype.onPan = function (f, e) {
  if (!this.m_curOperation) {
    //e.preventDefault()
    this.userPanning(f, e);
  }
};
MMOperationCenterMobileMarker.prototype.onPanEnd = function (f, e) {
  if (!this.m_curOperation) {
    //e.preventDefault()
    this.userEndPan(f, e);
  }
};
MMOperationCenterMobileMarker.prototype.onPinchStart = function (e) {
  return;
  e.preventDefault();
  // this.userStartPinch();
};
MMOperationCenterMobileMarker.prototype.onPinch = function (d, e) {
  return;
  e.preventDefault();
  this.userPinching(d);
};
MMOperationCenterMobileMarker.prototype.onPinchEnd = function (change, e) {
  return;
  e.preventDefault();
  this.userEndPinching(change);
};
MMOperationCenterMobileMarker.prototype.onTouchStart = function (f, e) {
  e.touches[0].currentTarget = e.currentTarget;
  e.touches[0].timeStamp = e.timeStamp;

  //__onMouseDown(f.beginFinger);
  var devicePoint = _MMOperationCenter["default"].getPosition(f.beginFinger, this.offsetLeft || 0, this.offsetTop || 0);
  var logicPoint = this.m_editor.assistView2LogicPoint(devicePoint);
  var clickedObjects = this.getObjectsSelectable(logicPoint); //mashx modified at this point
  if (!!this.m_curOperation) {
    this.m_curOperation.onMouseDown(logicPoint, clickedObjects[0], f.beginFinger, e);
  }
};
MMOperationCenterMobileMarker.prototype.onTouchMove = function (f, e) {
  var devicePoint = _MMOperationCenter["default"].getPosition(f.lastFinger, this.offsetLeft || 0, this.offsetTop || 0);
  var logicPoint = this.m_editor.assistView2LogicPoint(devicePoint);
  var clickedObjects = this.getObjectsSelectable(logicPoint); //mashx modified at this point
  if (!!this.m_curOperation) {
    this.m_curOperation.onMouseMove(logicPoint, f.lastFinger, e);
  }
};
MMOperationCenterMobileMarker.prototype.onTouchEnd = function (f, e) {
  var devicePoint = _MMOperationCenter["default"].getPosition(f.lastFinger, this.offsetLeft || 0, this.offsetTop || 0);
  var logicPoint = this.m_editor.assistView2LogicPoint(devicePoint);
  var clickedObjects = this.getObjectsSelectable(logicPoint); //mashx modified at this point
  if (!!this.m_curOperation) {
    this.m_curOperation.onMouseUp(logicPoint, f.lastFinger, e);
  }
};
var _default = exports["default"] = MMOperationCenterMobileMarker;

},{"1184":1184,"1454":1454,"874":874,"878":878}],878:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1438);
require(1498);
require(1437);
var _MMNiceTag = _interopRequireDefault(require(1018));
var _MMOperationCenter = _interopRequireDefault(require(874));
var _MDMPopupManager = _interopRequireDefault(require(357));
var _MDGestureRecognizer = _interopRequireDefault(require(327));
var _MDMAddTagPageView = _interopRequireDefault(require(349));
var _MDMNewCommentPageView = _interopRequireDefault(require(353));
var _MMSketchCommentController = _interopRequireDefault(require(885));
var _app = _interopRequireDefault(require(17));
var _MMColor = _interopRequireDefault(require(794));
var _MMCommentObj = _interopRequireDefault(require(1005));
var _MMFillType = _interopRequireDefault(require(795));
var _MDTouchMenu = _interopRequireDefault(require(339));
var _ObjType = _interopRequireDefault(require(1084));
var _MDCommentSlidePanelView = _interopRequireDefault(require(319));
var _MMObjElementsController = _interopRequireDefault(require(893));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDEvents = _interopRequireDefault(require(325));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
function MMOperationCenterMobile(options) {
  _MMOperationCenter["default"].call(this, options);
}
MMOperationCenterMobile.prototype = _.extend({}, _MMOperationCenter["default"].prototype);
MMOperationCenterMobile.prototype.superclass = _MMOperationCenter["default"];
MMOperationCenterMobile.prototype.registerMouseEvents = function () {
  var that = this;
  this.$canvas = $(this.m_canvas);
  this.removeEvents();
  var $canvas = this.$canvas;
  var lastEvent = null;
  this.throwHappened = false;
  this.longPressHappend = false;
  this._recognizer = new _MDGestureRecognizer["default"]($canvas[0], {
    longTolerance: 10,
    minFirstPanDistance: 10,
    longPressTime: 500
  });
  this._recognizer.on(_MDEvents["default"].THROW_RIGHT, _.bind(this.onThrowRight, this));
  this._recognizer.on(_MDEvents["default"].THROW_LEFT, _.bind(this.onThrowLeft, this));
  this._recognizer.on(_MDEvents["default"].PAN_START, _.bind(this.onPanStart, this));
  this._recognizer.on(_MDEvents["default"].PAN, _.bind(this.onPan, this));
  this._recognizer.on(_MDEvents["default"].PAN_END, _.bind(this.onPanEnd, this));
  this._recognizer.on(_MDEvents["default"].PINCH_START, _.bind(this.onPinchStart, this));
  this._recognizer.on(_MDEvents["default"].PINCH, _.bind(this.onPinch, this));
  this._recognizer.on(_MDEvents["default"].PINCH_END, _.bind(this.onPinchEnd, this));
  this._recognizer.on(_MDEvents["default"].touchstart, _.bind(this.onTouchStart, this));
  this._recognizer.on(_MDEvents["default"].touchmove, _.bind(this.onTouchMove, this));
  this._recognizer.on(_MDEvents["default"].touchend, _.bind(this.onTouchEnd, this));
  this._recognizer.on(_MDEvents["default"].TAP, _.bind(this.onTap, this));
  this._recognizer.on(_MDEvents["default"].LONG_PRESS, _.bind(this.onLongPress, this));
  this._recognizer.on(_MDEvents["default"].DOUBLE_TAP, _.bind(this.onDoubleTap, this));
};
MMOperationCenterMobile.prototype.removeEvents = function (e) {
  _MMOperationCenter["default"].prototype.removeEvents.call(this, e);
  if (this._recognizer) {
    this._recognizer.destroy();
    this._recognizer = null;
  }
};
// ****************** EVENTS START ****************

MMOperationCenterMobile.prototype.onThrowRight = function () {/* overwrite me */};
MMOperationCenterMobile.prototype.onThrowLeft = function () {/* overwrite me */};
MMOperationCenterMobile.prototype.onPanStart = function (f, e) {/* overwrite me */};
MMOperationCenterMobile.prototype.onPan = function (f, e) {/* overwrite me */};
MMOperationCenterMobile.prototype.onPanEnd = function (f, e) {/* overwrite me */};
MMOperationCenterMobile.prototype.onPinchStart = function (e) {/* overwrite me */};
MMOperationCenterMobile.prototype.onPinch = function (d, e) {/* overwrite me */};
MMOperationCenterMobile.prototype.onPinchEnd = function (change, e) {/* overwrite me */};
MMOperationCenterMobile.prototype.onTouchStart = function (f, e) {/* overwrite me */};
MMOperationCenterMobile.prototype.onTouchMove = function (f, e) {/* overwrite me */};
MMOperationCenterMobile.prototype.onTouchEnd = function (f, e) {/* overwrite me */};
MMOperationCenterMobile.prototype.onTap = function (f, e) {/* overwrite me */};
MMOperationCenterMobile.prototype.onLongPress = function (f, e) {/* overwrite me */};
MMOperationCenterMobile.prototype.onDoubleTap = function (f, e) {/* overwrite me */};

// ***** EVENTS END, HELPER METHODS START *****

MMOperationCenterMobile.prototype.userStartPan = function (finger, e) {
  var editor = null;
  editor = this.m_editor;
  editor.panStart(e);
};
MMOperationCenterMobile.prototype.userPanning = function (finger, e) {
  var editor = null;
  this._isPageChanging = true;
  editor = this.m_editor;
  editor.panMove(e);
};
MMOperationCenterMobile.prototype.userEndPan = function (finger, e) {
  var editor = null;
  editor = this.m_editor;
  editor.panEnd(e);
};
MMOperationCenterMobile.prototype.userStartPinch = function (change) {
  this.m_editor.pinchStart();
};
MMOperationCenterMobile.prototype.userPinching = function (change) {
  this.m_editor.pinchMove(change);
};
MMOperationCenterMobile.prototype.userEndPinching = function (change) {
  this.m_editor.pinchEnd(change);
};
/*******************************************************************************/
MMOperationCenterMobile.prototype.openTagCreationView = function (logicPoint, devicePoint) {
  var that = this;
  var curWhiteboard = this.editorViewCtl.getCurrentBoard();
  if (curWhiteboard.isClosed()) {
    return false;
  }
  ;
  var newTagCreationView = new _MDMAddTagPageView["default"]({
    title: BabelStr.str(7111),
    onConfirm: function onConfirm() {
      var text = newTagCreationView.getVal().trim();
      if (text) {
        var ver = that.editorViewCtl.getVersionShowing();
        var newTag = new _MMNiceTag["default"](curWhiteboard, ver);
        newTag.setLabel(text);
        newTag.setPos(logicPoint);
        newTag.setPageIndex(that.m_editor.getCurrentFilePageIndex());
        newTag.creationTime = new Date().getTime();
        var option = {
          toUndo: true,
          realtime: true,
          isMark_: false
        };
        curWhiteboard.m_actionManager.addObject(newTag, option);
      }
      _MDMPopupManager["default"].dismissView(newTagCreationView);
    }
  });
  _MDMPopupManager["default"].presentView(newTagCreationView);
};
MMOperationCenterMobile.prototype.openTouchMenue = function (logicPoint, bodyPoint) {
  var curWhiteboard = this.editorViewCtl.getCurrentBoard();
  if (curWhiteboard.isClosed()) {
    return false;
  }
  ;
  var that = this;
  var devicePoint = this.m_editor.logic2AssistViewPoint(logicPoint);
  var userLogined = _app["default"].currentUser.logined();
  _MDTouchMenu["default"].pop($('body'), bodyPoint, [
  //buttons
  {
    text: BabelStr.str(459),
    click: function () {
      /* click */
      if (_app["default"].isMobile() && !userLogined) {
        _app["default"].popupInnerLogin();
      } else {
        that.openCommentPanel(logicPoint);
      }
    }.bind(this)
  }, {
    text: BabelStr.str(7111),
    click: function click() {
      if (_app["default"].isMobile() && !userLogined) {
        _app["default"].popupInnerLogin();
      } else {
        that.openTagCreationView(logicPoint, devicePoint);
      }
    }
  }], function () {/* finally */}.bind(this));
};
MMOperationCenterMobile.prototype.openCommentPanel = function (logicPoint) {
  var that = this;
  var commentModalView = new _MDMNewCommentPageView["default"]({
    editorViewCtl: this.editorViewCtl,
    onConfirm: function onConfirm() {
      var text = commentModalView.getVal();
      if (text.length > 0) {
        // if (MMSketchCommentController.getAllObjects().length == 0) {
        //   MDSnackbarView.show('请输入批注内容');
        //   return;
        // }
        var curWhiteboard = that.editorViewCtl.getCurrentBoard();
        var curDispVer = that.editorViewCtl.getVersionShowing();
        var comment = new _MMCommentObj["default"](curWhiteboard, curDispVer);
        var editorCtl = that.editor;
        comment.setPageIndex(that.m_editor.getCurrentFilePageIndex());
        comment.setPos(logicPoint); // 先设置属性，再进入 undo

        var filltype = new _MMFillType["default"]();
        ;
        filltype.setFill(true);
        var color = new _MMColor["default"]();
        color.m_r = 1;
        color.m_g = 0;
        color.m_b = 0;
        color.m_alpha = 1;
        filltype.setFillColor(color);
        comment.setFillType(filltype);
        var creatorId = _app["default"].currentUser.getUserId_Int();
        comment.setRead(creatorId);
        comment.setCreator(creatorId);
        var option = {
          toUndo: true,
          realtime: true,
          isMark_: false
        };
        curWhiteboard.m_actionManager.addObject(comment, option);
        curWhiteboard.m_actionManager.sendMessage(JSON.stringify({
          'Type': 'Text',
          'Body': text
        }), comment.getId());
      }
      _MDMPopupManager["default"].dismissView(commentModalView);
    }
  });
  _MDMPopupManager["default"].presentView(commentModalView);
};
MMOperationCenterMobile.prototype.onTap = function (f, e) {
  var devicePoint = _MMOperationCenter["default"].getPosition(f.beginFinger, this.offsetLeft || 0, this.offsetTop || 0);
  var logicPoint = this.m_editor.assistView2LogicPoint(devicePoint);
  logicPoint.devicePoint = devicePoint;
  e.LGPoint = logicPoint;
  var clickedObjects = this.getObjectsSelectable(logicPoint);
  if (clickedObjects.length > 0) {
    var _firstObject = clickedObjects[0];
    if (_firstObject.m_objType === _ObjType["default"].Obj_comment) {
      var elementsCtl = _MMObjElementsController["default"].getSingleInstance();
      var div = elementsCtl.getDivByObj(null, _firstObject);
      var center = MMCommonFun.getDivCenter($(div));
      var posInBody = MMCommonFun.convertPointBetweenElements(div, $("body")[0], center);
      var commentPanel = new _MDCommentSlidePanelView["default"]({
        comment: _firstObject,
        view: this.m_editor,
        editorViewCtl: this.editorViewCtl,
        onCloseBtnClicked: function onCloseBtnClicked() {
          _MMObjElementsController["default"].commentPointUpdater.updateCommentView(_firstObject, "readed");
          commentPanel.removeFromSuperView();
        }
      });
      application.addSubView(commentPanel);
      commentPanel.centerZoomShowForMobile(posInBody);
    } else if (_firstObject.m_objType === _ObjType["default"].Obj_textComment) {
      var commentPanel = new _MDCommentSlidePanelView["default"]({
        comment: _firstObject,
        view: this.m_editor,
        editorViewCtl: this.editorViewCtl,
        onCloseBtnClicked: function onCloseBtnClicked() {
          _MMObjElementsController["default"].commentPointUpdater.updateCommentView(_firstObject, "readed");
          commentPanel.removeFromSuperView();
        }
      });
      application.addSubView(commentPanel);
      commentPanel.centerZoomShowForMobile({
        x: 0,
        y: 0
      });
    }
  } else {
    _Dispatcher["default"].trigger(_MDEvents["default"].TapOnWhiteSpaceInDoc);
  }
};
var _default = exports["default"] = MMOperationCenterMobile;

},{"1005":1005,"1018":1018,"1084":1084,"1184":1184,"1437":1437,"1438":1438,"1454":1454,"1498":1498,"17":17,"18":18,"319":319,"325":325,"327":327,"339":339,"349":349,"353":353,"357":357,"794":794,"795":795,"807":807,"874":874,"885":885,"893":893}],353:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1498);
var _MDMPageView = _interopRequireDefault(require(356));
var _MMBasicData = _interopRequireDefault(require(811));
var _MDMBarButtonItemView = _interopRequireDefault(require(351));
var _MDMPopupManager = _interopRequireDefault(require(357));
var _MMCommonFun = _interopRequireDefault(require(812));
/**
 *  Class description here
 *  Create by author's name
 *  date here(2015.6.24)
 */

var MDMNewCommentPageView = _MDMPageView["default"].extend({
  className: function className() {
    var superCls = _MDMPageView["default"].prototype.className.call(this);
    return superCls + ' pop-page animated fadeInUp';
  },
  pageContentTmpl: "<textarea class=\"text-area clear-appearance\" name=\"someText\" placeholder=\"".concat(BabelStr.str(118), "\"></textarea>"),
  initProps: function initProps() {
    var superP = _MDMPageView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      title: BabelStr.str(459),
      //'建立批注',
      onConfirm: _.noop,
      isPopup: true
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    _MDMPageView["default"].prototype.initialize.call(this, opt);
    var zIndex = _MMBasicData["default"].getEditorMaxZ_index();
    this.$el.css('z-index', zIndex);
    var okStr = BabelStr.str(154); // 确定
    var cancelStr = BabelStr.str(155); // 取消
    var cancelBarButtonItem = new _MDMBarButtonItemView["default"]({
      barButtonRenderer: '<button class="">' + cancelStr + '</button>',
      barButtonItemAction: function barButtonItemAction() {
        _MMCommonFun["default"].removeTextInputInEditor('newComment');
        _MDMPopupManager["default"].dismissView(self);
      }
    });
    this.addLeftBarButtonItem(cancelBarButtonItem);
    var confirmBarButtonItem = new _MDMBarButtonItemView["default"]({
      barButtonRenderer: '<button class="">' + okStr + '</button>',
      barButtonItemAction: function barButtonItemAction() {
        _MMCommonFun["default"].removeTextInputInEditor('newComment');
        if (_.isFunction(self.onConfirm)) {
          self.onConfirm();
        }
      }
    });
    this.addRightBarButtonItem(confirmBarButtonItem);
    _MMCommonFun["default"].setTextInputInEditor('newComment');
  },
  getVal: function getVal() {
    return this.$("textarea").val().trim();
  }
});
var _default = exports["default"] = MDMNewCommentPageView;

},{"1184":1184,"1454":1454,"1498":1498,"351":351,"356":356,"357":357,"811":811,"812":812}],349:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1498);
var _MDMPageView = _interopRequireDefault(require(356));
var _MMBasicData = _interopRequireDefault(require(811));
var _MDMBarButtonItemView = _interopRequireDefault(require(351));
var _MDMPopupManager = _interopRequireDefault(require(357));
var MDMAddTagPageView = _MDMPageView["default"].extend({
  className: function className() {
    var superCls = _MDMPageView["default"].prototype.className.call(this);
    return superCls + ' pop-page';
  },
  pageContentTmpl: '<textarea class="text-area clear-appearance" placeholder="' + BabelStr.str(7113) + '..."></textarea>' + '<div class="section">' + '<span class="f-fr"><span class="remain"><%=totalLength%></span>字</span>' + '</div>',
  initProps: function initProps() {
    var superP = _MDMPageView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      totalLength: 15,
      isPopup: true,
      title: BabelStr.str(7111),
      onConfirm: _.noop
    });
  },
  events: function events() {
    var superEvents = _MDMPageView["default"].prototype.events.call(this);
    return _.extend(superEvents, {
      "input textarea": this._textAreaInputEvent
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    opt = _.extend({
      data: {
        'totalLength': 15
      }
    }, opt);
    _MDMPageView["default"].prototype.initialize.call(this, opt);
    var zIndex = _MMBasicData["default"].getEditorMaxZ_index();
    this.$el.css('z-index', zIndex);
    var cancelBarButtonItem = new _MDMBarButtonItemView["default"]({
      barButtonRenderer: '<button class="">' + BabelStr.str(155) + '</button>',
      barButtonItemAction: function barButtonItemAction() {
        _MDMPopupManager["default"].dismissView(self);
      }
    });
    this.addLeftBarButtonItem(cancelBarButtonItem);
    var confirmBarButtonItem = new _MDMBarButtonItemView["default"]({
      barButtonRenderer: '<button class="">' + BabelStr.str(3096) + '</button>',
      barButtonItemAction: function barButtonItemAction() {
        if (_.isFunction(self.onConfirm)) {
          self.onConfirm();
        }
      }
    });
    this.addRightBarButtonItem(confirmBarButtonItem);
  },
  _textAreaInputEvent: function _textAreaInputEvent() {
    var $textarea = this.$("textarea");
    var val = $textarea.val();
    var remain = this.totalLength - val.length;
    if (remain <= 0) {
      $textarea.val(val.substring(0, this.totalLength));
      remain = 0;
    }
    this.$(".remain").text(remain);
  },
  getVal: function getVal() {
    return this.$("textarea").val().trim();
  }
});
var _default = exports["default"] = MDMAddTagPageView;

},{"1184":1184,"1454":1454,"1498":1498,"351":351,"356":356,"357":357,"811":811}],357:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
/**
 * 弹出层管理对象
 * Created by manjun.han
 */

var MDMPopupManager = {
  _views: [],
  presentView: function presentView(view) {
    application.addSubView(view);
    MDMPopupManager._views.push(view);
  },
  dismissView: function dismissView(view) {
    var views = MDMPopupManager._views;
    var subView = _.find(views, function (subView) {
      if (view === subView) {
        return subView;
      }
    });
    if (subView) {
      subView.removeFromSuperView();
      MDMPopupManager.views = _.without(views, subView);
    }
  },
  dismissAll: function dismissAll() {
    var views = MDMPopupManager._views;
    _.each(views, function (subView) {
      if (subView.superView) {
        subView.removeFromSuperView();
      }
    });
    MDMPopupManager._views = [];
  }
};
var _default = exports["default"] = MDMPopupManager;

},{"1417":1417,"1454":1454,"1463":1463}],356:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMViewBase = _interopRequireDefault(require(22));
var _MDMPageHeaderView = _interopRequireDefault(require(355));
var _MDMBarButtonItemView = _interopRequireDefault(require(351));
/**
 *  Page view for mobile applicatio
 *  Created by manjun.han
 *  2016.8.18
 */

var MDMPageView = _MMViewBase["default"].extend({
  el: '<div class="g-page"></div>',
  tmpl: function tmpl() {
    var pageContentTmpl = this.pageContentTmpl;
    if (_.isFunction(this.pageContentTmpl)) {
      pageContentTmpl = this.pageContentTmpl();
    }
    var tmpl = '<div id="js-pageHeaderSlot"></div>' + '<div class="page-bd">' + pageContentTmpl + '</div>';
    return tmpl;
  },
  pageContentTmpl: function pageContentTmpl() {
    return "";
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      title: '',
      showBackBarButtonItem: false,
      backBarButtonItem: null,
      backBarButtonItemAction: _.noop,
      leftBarButtonItems: [],
      rightBarButtonItems: [],
      isPopup: false
    });
  },
  /**
   * @param {object} opt
   * @param {boolean} [opt.isPopup] - 是否是弹出层
   * @param {string} [opt.title] - 页面标题
   * @param {boolean} [opt.showBackBarButtonItem] - 是否显示返回按钮
   * @param {MDMBarButtonItemView} [opt.backBarButtonItem] - 返回按钮对象
   */
  initialize: function initialize(opt) {
    var self = this;
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    if (this.isPopup) {
      this.$el.addClass('animated fadeInUp');
    }
    this.headerView = new _MDMPageHeaderView["default"]({
      title: this.title,
      leftBarButtonItems: this.leftBarButtonItems,
      rightBarButtonItems: this.rightBarButtonItems
    });
    this.addSubView(this.headerView, this.$('#js-pageHeaderSlot'), true);
    if (this.showBackBarButtonItem) {
      if (!this.backBarButtonItem) {
        var backBarButtonItem = new _MDMBarButtonItemView["default"]({
          barButtonRenderer: '<button class="icon backArrow"></button>',
          barButtonItemAction: function barButtonItemAction() {
            if (_.isFunction(self.backBarButtonItemAction)) {
              self.backBarButtonItemAction();
            }
          }
        });
        this.backBarButtonItem = backBarButtonItem;
        this.headerView.setBackBarButtonItem(backBarButtonItem);
      }
    }
  },
  addSubViewAt: function addSubViewAt(subView, index, opt_parent, opt_slot) {
    if (this.headerView != subView) {
      if (!opt_parent) {
        opt_parent = this.$('.page-bd')[0];
      }
    }
    _MMViewBase["default"].prototype.addSubViewAt.apply(this, arguments);
  },
  addLeftBarButtonItem: function addLeftBarButtonItem(barButtonItem) {
    this.headerView.addLeftBarButtonItem(barButtonItem);
  },
  addRightBarButtonItem: function addRightBarButtonItem(barButtonItem) {
    this.headerView.addRightBarButtonItem(barButtonItem);
  },
  setLeftBarButtonItems: function setLeftBarButtonItems(leftBarButtonItems) {
    this.headerView.setLeftBarButtonItems(leftBarButtonItems);
  },
  setRightBarButtonItems: function setRightBarButtonItems(rightBarButtonItems) {
    this.headerView.setRightBarButtonItems(rightBarButtonItems);
  },
  setTitle: function setTitle(title) {
    this.headerView.setTitle(title);
  },
  removeFromSuperView: function removeFromSuperView() {
    var self = this;
    if (this.isPopup) {
      this.$el.animationEndOnce(function () {
        _MMViewBase["default"].prototype.removeFromSuperView.call(self);
      }).addClass('fadeOutDown');
    } else {
      _MMViewBase["default"].prototype.removeFromSuperView.call(self);
    }
  }
});
var _default = exports["default"] = MDMPageView;

},{"1184":1184,"1454":1454,"22":22,"351":351,"355":355}],355:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMViewBase = _interopRequireDefault(require(22));
var _MDMBarButtonItemView = _interopRequireDefault(require(351));
/**
 *  Class description here
 *  Created by manjun.han
 *  2015.10.10
 */

var MDMPageHeaderView = _MMViewBase["default"].extend({
  el: '<div class="f-clb page-hd "></div>',
  tmpl: '<div class="left-btn-bar"></div>' + '<div class="content">' + '<span class="page-hd-title"><%=title%></span>' + '</div>' + '<div class="right-btn-bar"></div>',
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      $leftBarButtonItems: null,
      $rightBarButtonItems: null,
      leftBarButtonItems: [],
      rightBarButtonItems: [],
      data: {
        title: ''
      }
    });
  },
  initialize: function initialize(opt) {
    opt.data = _.extend({}, opt.data);
    opt.data['title'] = opt.title;
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.$title = this.$('.page-hd-title');
    this.$leftBarButtonItems = this.$('.left-btn-bar');
    this.$rightBarButtonItems = this.$('.right-btn-bar');
    this.$titleView = this.$('.content');
    this.$titleView.css('z-index', -1);
  },
  setTitle: function setTitle(title) {
    this.$title.text(title);
  },
  setBackBarButtonItem: function setBackBarButtonItem(backBarButtonItem) {
    var self = this;
    if (this.backBarButtonItemView) {
      this.backBarButtonItemView.removeFromSuperView();
    }
    this.addSubView(backBarButtonItem, function (subViewEl) {
      self.$leftBarButtonItems.prepend(subViewEl);
    });
    this.backBarButtonItemView = backBarButtonItem;
  },
  addLeftBarButtonItem: function addLeftBarButtonItem(barButtonItem) {
    this.addSubView(barButtonItem, this.$leftBarButtonItems[0]);
    this.layoutChange(true, false);
  },
  addRightBarButtonItem: function addRightBarButtonItem(barButtonItem) {
    this.addSubView(barButtonItem, this.$rightBarButtonItems[0]);
    this.layoutChange(false, true);
  },
  setLeftBarButtonItems: function setLeftBarButtonItems(leftBarButtonItems) {
    var self = this;
    _.each(this.leftBarButtonItems, function (barButtonItem) {
      barButtonItem.removeFromSuperView();
    });
    this.leftBarButtonItems = leftBarButtonItems;
    _.each(this.leftBarButtonItems, function (barButtonItem) {
      self.addLeftBarButtonItem(barButtonItem);
    });
  },
  setRightBarButtonItems: function setRightBarButtonItems(rightBarButtonItems) {
    var self = this;
    _.each(this.rightBarButtonItems, function (barButtonItem) {
      barButtonItem.removeFromSuperView();
    });
    this.rightBarButtonItems = rightBarButtonItems;
    _.each(this.rightBarButtonItems, function (barButtonItem) {
      self.addRightBarButtonItem(barButtonItem);
    });
  },
  render: function render(data) {
    _MMViewBase["default"].prototype.render.call(this, data);
    var self = this;
    self.removeSubViews();
    if (_.isArray(this.leftBarButtonItems)) {
      _.each(this.leftBarButtonItems, function (barButtonItem) {
        self.addSubView(barButtonItem, self.$leftBarButtonItems[0]);
      });
    }
    if (_.isArray(this.rightBarButtonItems)) {
      _.each(this.rightBarButtonItems, function (barButtonItem) {
        self.addSubView(barButtonItem, self.$rightBarButtonItems[0]);
      });
    }
    this.layoutChange();
  },
  layoutChange: function layoutChange(leftChange, rightChange) {
    if (this.isViewRendered()) {
      if (leftChange) {
        var paddingLeft = this.$leftBarButtonItems.width();
        // this.$titleView.css('left', paddingLeft);
        this.$titleView.css('left', 0);
      }
      if (rightChange) {
        var paddingRight = this.$rightBarButtonItems.width();
        // this.$titleView.css('right', paddingRight);
        this.$titleView.css('right', 0);
      }
    }
  },
  viewDidRendered: function viewDidRendered() {
    _MMViewBase["default"].prototype.viewDidRendered.call(this);
    this.layoutChange(true, true);
  },
  viewDidShow: function viewDidShow() {
    _MMViewBase["default"].prototype.viewDidShow.call(this);
    this.layoutChange(true, true);
  }
});
var _default = exports["default"] = MDMPageHeaderView;

},{"1184":1184,"1454":1454,"22":22,"351":351}],351:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMViewBase = _interopRequireDefault(require(22));
/**
 * 	Class description here
 *  Created by author's name
 *  date here(2015.6.24)
 */

var MDMBarButtonItemView = _MMViewBase["default"].extend({
  el: '<div class="bar-btn-item"></div>',
  className: function className() {
    var superCls = _MMViewBase["default"].prototype.className.call(this);
    return superCls + ' cls';
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      disabled: false,
      disabledCls: '',
      barButtonItemAction: _.noop,
      barButtonRenderer: _.noop
    });
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click': this._clickHandler
    });
  },
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
  },
  setEnabled: function setEnabled(enabled) {
    this.disabled = !enabled;
  },
  _clickHandler: function _clickHandler($e) {
    if (this.disabled) {
      return;
    }
    this.barButtonItemAction();
  },
  setAction: function setAction(action) {
    if (_.isFunction(action)) {
      throw new Error('MDMBarButtonItemView setAction error , the action must be function');
    }
    this.barButtonItemAction = action;
  },
  render: function render() {
    _MMViewBase["default"].prototype.render.call(this);
    var barButtonContent = '';
    var barButtonRenderer = "";
    if (_.isFunction(this.barButtonRenderer)) {
      barButtonRenderer = this.barButtonRenderer();
    } else if (_.isString(this.barButtonRenderer)) {
      barButtonRenderer = this.barButtonRenderer;
    }
    this.$el.append(barButtonRenderer);
  }
});
var _default = exports["default"] = MDMBarButtonItemView;

},{"1184":1184,"1454":1454,"22":22}],877:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDMarkerObjDrawerController = _interopRequireDefault(require(909));
var _MMSketchCommentController = _interopRequireDefault(require(885));
var _MDTextOperation = _interopRequireDefault(require(862));
var _MMOperationCenterDesktop = _interopRequireDefault(require(875));
var _MMDesktopContextMenue = _interopRequireDefault(require(865));
var _MMOperationCenter = _interopRequireDefault(require(874));
var _MDSelectFrame = _interopRequireDefault(require(919));
function MMOperationCenterDesktopMarker(options) {
  options.isMarker = true;
  _MMOperationCenterDesktop["default"].call(this, options);
}
MMOperationCenterDesktopMarker.prototype = _.extend({}, _MMOperationCenterDesktop["default"].prototype);

/**
 * Method to register on the assistlayer mouseDown event
 * @param e {event}
 */
MMOperationCenterDesktopMarker.prototype.onMouseDown = function (e) {
  _MMOperationCenterDesktop["default"].prototype.onMouseDown.call(this, e);
  var canvasOffset = $(this.m_canvas).offset();
  this.clearSelection();
  var devicePoint = _MMOperationCenter["default"].getPosition(e, this.offsetLeft || 0, this.offsetTop || 0);
  this.startDvPos = devicePoint;
  this.lastDvPos = devicePoint;
  this.moveEnough = false;
  if (this.m_editor && this.m_editor.beforeScroll) {
    this.m_editor.beforeScroll();
  }
  var logicPoint = this.m_editor.assistView2LogicPoint(devicePoint);
  logicPoint.devicePoint = devicePoint;
  e.LGPoint = logicPoint;
  this.clickedObjects = this.getObjectsSelectable(logicPoint); //mashx modified at this point
  var clickedObjects = this.clickedObjects;
  if (!!this.m_curOperation) {
    if (this.m_curOperation instanceof _MDTextOperation["default"]) {
      this.m_curOperation.mouseDown(e);
    } else {
      _MDMarkerObjDrawerController["default"].clearFocus();
      this.m_curOperation.onMouseDown(logicPoint, clickedObjects[0], e);
    }
  } else {
    _MDMarkerObjDrawerController["default"].clearFocus();
    _MDSelectFrame["default"].clear();
  }
  this.lastMouseDownEvent = e;
};

/**
 * Method to register on the assistlayer mouseMove event
 * @param e {event}
 */
MMOperationCenterDesktopMarker.prototype.onMouseMove = function (e) {
  if (!this.captured) {
    return;
  }
  ;
  _MMOperationCenterDesktop["default"].prototype.onMouseMove.call(this, e);
  var devicePoint = _MMOperationCenter["default"].getPosition(e, this.offsetLeft || 0, this.offsetTop || 0);
  this.lastDvPos = devicePoint;
  if (!this.moveEnough) {
    if (Math.abs(devicePoint.x - this.startDvPos.x) + Math.abs(devicePoint.y - this.startDvPos.y) > 7) {
      this.moveEnough = true;
      console.log('------------- move enough!');
    }
    ;
  }
  ;
  var logicPoint = this.m_editor.assistView2LogicPoint(devicePoint);
  logicPoint.devicePoint = devicePoint;
  e.LGPoint = logicPoint;
  if (this.m_curOperation) {
    this.m_curOperation.moveEnough = this.moveEnough;
    if (this.m_curOperation instanceof _MDTextOperation["default"]) {
      this.m_curOperation.mouseMove(e);
    } else {
      this.m_curOperation.onMouseMove(logicPoint, e);
    }
  }
};

/**
 * Method to register on the assistlayer mouseup event
 * @param e {event}
 */
MMOperationCenterDesktopMarker.prototype.onMouseUp = function (e) {
  if (!this.captured) {
    return;
  }
  ;
  var devicePoint = _MMOperationCenter["default"].getPosition(e, this.offsetLeft || 0, this.offsetTop || 0);
  if (e.type == 'touchend') {
    devicePoint = this.lastDvPos;
  }
  var logicPoint = this.m_editor.assistView2LogicPoint(devicePoint);
  logicPoint.devicePoint = devicePoint;
  e.LGPoint = logicPoint;
  if (this.moveEnough) {
    if (this.m_curOperation && e.button === 0 || e.type == "touchend") {
      if (this.m_curOperation instanceof _MDTextOperation["default"]) {
        this.m_curOperation.mouseUp(e);
      } else {
        this.m_curOperation && this.m_curOperation.onMouseUp(logicPoint, e);
      }
    }
  } else {
    if (this.clickedObjects.length > 0) {
      var selectObj = this.clickedObjects[0];
      _MDMarkerObjDrawerController["default"].focus(this.editor, selectObj);
    }
    ;
  }
  this.lastMouseUpEvent = e;
  this._isPageChanging = false;

  // 处理手指的 click 事件
  if (e.type == "touchend") {
    var curPos = this.lastDvPos;
    if (Math.abs(curPos.x - this.startDvPos.x) + Math.abs(curPos.y - this.startDvPos.y) < 4) {
      this.clicked(e);
    }
  }
};
MMOperationCenterDesktopMarker.prototype.clicked = function (e) {
  if (this.m_curOperation && this.m_curOperation instanceof _MDTextOperation["default"]) {
    this.m_curOperation.mouseUp(e);
  }
};
MMOperationCenterDesktopMarker.prototype.getObjectsSelectable = function (lgPt) {
  var objs = _MMSketchCommentController["default"].getAllObjects();
  var out = [];
  for (var i = 0; i < objs.length; i++) {
    var obj = objs[i];
    if (obj.isPtOn(lgPt)) {
      console.log('---------- on obj!');
      out.push(obj);
    }
    ;
  }
  ;
  return out;
};
var _default = exports["default"] = MMOperationCenterDesktopMarker;

},{"1184":1184,"1454":1454,"862":862,"865":865,"874":874,"875":875,"885":885,"909":909,"919":919}],876:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDGraphCommentOperation = _interopRequireDefault(require(859));
var _MMOperationCenterDesktop = _interopRequireDefault(require(875));
var _MMDesktopContextMenue = _interopRequireDefault(require(865));
var _MDTextCommentPanelCtl = _interopRequireDefault(require(434));
var _MMObjOperationStrategy = _interopRequireDefault(require(872));
var _MMOperationCenter = _interopRequireDefault(require(874));
var _MMPoint = _interopRequireDefault(require(830));
var _ObjType = _interopRequireDefault(require(1084));
var _MMOperationType = _interopRequireDefault(require(882));
var _MMCommentObj = _interopRequireDefault(require(1005));
var _MMCommentOperation = _interopRequireDefault(require(864));
var _MMTextComment = _interopRequireDefault(require(1032));
var _MMWeldMark = _interopRequireDefault(require(1034));
var _MMDrawScribbleOperation = _interopRequireDefault(require(868));
var _MDMarkerObjDrawerController = _interopRequireDefault(require(909));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MMSealFrame = _interopRequireDefault(require(886));
/**
 *
 * WebContent/javascript/molasync-source/operation-controller/MMOperationCenterDesktopImage.js
 *
 */

// import MMImageMarkerCtl from '../ui/editor-task/android-scroll/MMImageMarkerCtl.js';

function MMOperationCenterDesktopImage(options) {
  _MMOperationCenterDesktop["default"].call(this, options);
  Dispatcher.on(MDEvents.COMMENT_CLICKED, this.openTextCommentHandler, this);
}
MMOperationCenterDesktopImage.prototype = _.extend({}, _MMOperationCenterDesktop["default"].prototype);

/**
 * Method to register on the assistlayer mouseDown event
 * @param e {event}
 */
MMOperationCenterDesktopImage.prototype.onMouseDown = function (e) {
  //e.stopPropagation();
  e.preventDefault();
  _MMOperationCenterDesktop["default"].prototype.onMouseDown.call(this, e);
  _MDTextCommentPanelCtl["default"].setBoardVersionShowing(this.editorViewCtl.getVersionShowing());
  _MDTextCommentPanelCtl["default"].setViewCtl(this.editorViewCtl);
  this.mouseStartPos = _MMCommonFun["default"].touchPosition(e);
  var that = this;
  var canvasOffset = $(that.m_canvas).offset();
  that.clearSelection();
  var devicePoint = _MMOperationCenter["default"].getPosition(e, this.offsetLeft || 0, this.offsetTop || 0);
  this.startDvPos = devicePoint;
  this.lastDvPos = devicePoint;
  this.moveEnough = false; //

  that.prePosition = new _MMPoint["default"](devicePoint.x, devicePoint.y);
  if (that.m_editor && that.m_editor.beforeScroll) {
    that.m_editor.beforeScroll();
  }
  var logicPoint = that.m_editor.assistView2LogicPoint(devicePoint);
  logicPoint.devicePoint = devicePoint;
  e.LGPoint = logicPoint;
  var clickedObjects;
  var file = this.getCurrentBoard().getFileInfo();
  if (file.isOnlyDisp()) {
    clickedObjects = [];
  } else {
    clickedObjects = that.getObjectsSelectable(logicPoint); //mashx modified at this point
  }
  that.hoverObjs = clickedObjects;

  // if (that.m_editor && that.m_editor.removeCommentPanel)
  //     that.m_editor.removeCommentPanel();

  if (e.button && e.button !== 0 && !MMImageMarkerCtl.isShowing()) {
    _MMDesktopContextMenue["default"].show({
      e: e,
      operationCenter: that,
      clickedElements: clickedObjects,
      logicPoint: logicPoint,
      devicePoint: devicePoint,
      pageView: this.editor
    });
  } else {
    if (!!that.m_curOperation) {
      that.m_curOperation.onMouseDown(logicPoint, clickedObjects[0], e);
    } else {
      if (clickedObjects[0]) {
        that.m_selectedObjs = [clickedObjects[0]];
        if (_MMObjOperationStrategy["default"].getOperataionTypeForMolaTask(clickedObjects[0], that.m_editor.getCurrentFilePageIndex()) == _MMOperationType["default"].Operation_editable) {
          if (!that.editor.disableOperationCenter && clickedObjects[0].getObjType() != _ObjType["default"].Obj_graphComment) {
            that.setCurOperation('move', that.m_selectedObjs[0]);
            that.m_curOperation.onMouseDown(logicPoint, that.$canvas, e);
          }
          ;
        }
      } else {
        that.m_selectedObjs = [];
        that.setCurOperation();
      }
    }
  }
  that.lastMouseDownEvent = e;
};

/**
 * Method to register on the assistlayer mouseMove event
 * @param e {event}
 */
MMOperationCenterDesktopImage.prototype.onMouseMove = function (e) {
  // e.stopPropagation();
  e.preventDefault();
  if (this.editor.getClassName() != 'MDSWFEditor') {
    Dispatcher.trigger(MDEvents.DISPLAY_PDF_BAR);
    Dispatcher.trigger(MDEvents.DISPLAY_ZOOM_BAR);
  }
  var file = this.getCurrentBoard().getFileInfo();
  if (file.isOnlyDisp()) {
    return;
  }
  _MMOperationCenterDesktop["default"].prototype.onMouseMove.call(this, e);
  if (!this.captured) {
    return;
  }
  ;
  var that = this;
  var devicePoint = _MMOperationCenter["default"].getPosition(e, this.offsetLeft || 0, this.offsetTop || 0);
  this.lastDvPos = devicePoint;
  var logicPoint = that.m_editor.assistView2LogicPoint(devicePoint);
  logicPoint.devicePoint = devicePoint;
  e.LGPoint = logicPoint;
  that.hoverObjs = that.getObjectsSelectable(logicPoint);
  if (that.m_curOperation && !app.pathRouter.inTrash()) {
    // && !that.m_curOperation.divOperation) {
    that.clearSelection();
    if (!this.moveEnough) {
      if (Math.abs(devicePoint.x - this.startDvPos.x) + Math.abs(devicePoint.y - this.startDvPos.y) > 7) {
        this.moveEnough = true;
        console.log('------------- move enough!');
      }
      ;
    }
    ;
    this.m_curOperation.moveEnough = this.moveEnough;

    // mashx move the following code from above to here.
    that.m_curOperation.onMouseMove(logicPoint, e, that.$canvas);
  }
  that.lastMouseMoveEvent = e;
};

/**
 *
 * Method to register on the assistlayer mouseup event
 * @param e {event}
 */
MMOperationCenterDesktopImage.prototype.onMouseUp = function (e) {
  if (!this.captured) {
    return;
  }
  ;
  if (e.originalEvent.mouseUpOperationCenterDone === true) {
    return;
  }
  e.originalEvent.mouseUpOperationCenterDone = true;
  _MMOperationCenterDesktop["default"].prototype.onMouseUp.call(this, e);
  var file = this.getCurrentBoard().getFileInfo();
  if (file.isOnlyDisp()) {
    return;
  }
  var that = this;
  that.clearSelection();
  var devicePoint = _MMOperationCenter["default"].getPosition(e, this.offsetLeft || 0, this.offsetTop || 0);
  if (devicePoint == null) {
    // 对于平板电脑 touchend 事件没有接触点，就使用上一个 move 事件的点
    if (that.lastDvPos) {
      devicePoint = that.lastDvPos;
    } else {
      return;
    }
  }
  var logicPoint = that.m_editor.assistView2LogicPoint(devicePoint);
  logicPoint.devicePoint = devicePoint;
  e.LGPoint = logicPoint;
  if (that.m_curOperation && (e.button === 0 || e.type == "touchend")) {
    that.m_curOperation.onMouseUp(logicPoint, e);
  }
  that.hoverObjs = that.getObjectsSelectable(logicPoint); //mashx

  //    if (!that.throwHappened && that.m_editor instanceof MMBoardCollectionView) {
  //        that.m_editor.scrollToShowFullPage();
  //    }
  var currentOperation = that.getCurOperation();
  if (that.hoverObjs[0] && that.hoverObjs[0] instanceof _MMCommentObj["default"] && (!currentOperation || currentOperation instanceof _MMCommentOperation["default"]) && (e.button === undefined || e.button === 0 || e.type == "touchend")) {
    // if (distanceBetweenMouseEvents(e, that.lastMouseDownEvent) < 2)
    //     Dispatcher.trigger(MDEvents.COMMENT_CLICKED, that.m_editor, that.hoverObjs[0]);

    if (that.createCommentView) {
      that.createCommentView.remove();
      that.createCommentView = null;
    }
  } else if (that.hoverObjs[0] && that.hoverObjs[0] instanceof _MMTextComment["default"] && !currentOperation && (e.button === undefined || e.button === 0)) {
    if (distanceBetweenMouseEvents(e, that.lastMouseDownEvent) < 2) _MDTextCommentPanelCtl["default"].setImgMarkerCtl(that.imgMarkerCtl);
    _MDTextCommentPanelCtl["default"].showReplyPanel(that.m_editor, that.hoverObjs[0]);
  }
  that.lastMouseUpEvent = e;
  that._isPageChanging = false;
  e.preventDefault();
  this.captured = false;

  // 处理手指的 click 事件
  if (e.type == "touchend") {
    var curPos = this.lastDvPos;
    if (Math.abs(curPos.x - this.startDvPos.x) + Math.abs(curPos.y - this.startDvPos.y) < 4) {
      this.clicked(e);
    }
  }
};
MMOperationCenterDesktopImage.prototype.clicked = function (e) {
  var that = this;
  e.preventDefault();
  _MMOperationCenterDesktop["default"].prototype.clicked.call(this, e);
  var devicePoint = _MMOperationCenter["default"].getPosition(e, this.offsetLeft || 0, this.offsetTop || 0);
  if (e.type == "touchend") {
    devicePoint = this.startDvPos;
  }
  var logicPoint = that.m_editor.assistView2LogicPoint(devicePoint);
  logicPoint.devicePoint = devicePoint;
  e.LGPoint = logicPoint;
  that.hoverObjs = that.getObjectsSelectable(logicPoint);
  that.penZoneMarks = [];
  var penZoneCtl = this.editorViewCtl.getPenZoneCtl();
  if (penZoneCtl) {
    that.penZoneMarks = penZoneCtl.getHoveredMarks(logicPoint);
  }
  var currentOperation = that.getCurOperation();
  if (that.commentSlidePanelClosing) {
    return;
  }
  // if (that.m_editor && that.m_editor.removeCommentPanel){
  if (viewManager.get("commentSlidePanel") && that.hoverObjs[0] && viewManager.get("commentSlidePanel").comment.m_id.m_localIndex == that.hoverObjs[0].m_id.m_localIndex) {
    that.commentSlidePanelClosing = setBabelTimeout(function () {
      that.commentSlidePanelClosing = null;
    }, 1000);
    that.m_editor.removeCommentPanel();
  } else if (viewManager.get("commentSlidePanel") && !that.hoverObjs[0]) {
    that.m_editor.removeCommentPanel();
  } else if (that.penZoneMarks.length > 0) {
    var markInfo = that.penZoneMarks[0];
    var userId = markInfo.userId;
    var index = markInfo.index;
    penZoneCtl.focusUserSection(userId, index);
  } else if (that.hoverObjs[0] && that.hoverObjs[0] instanceof _MMCommentObj["default"] && (!currentOperation || currentOperation instanceof _MMCommentOperation["default"] || currentOperation instanceof _MDGraphCommentOperation["default"] || currentOperation instanceof _MMDrawScribbleOperation["default"]) && (e.button === undefined || e.button === 0)) {
    if (distanceBetweenMouseEvents(e, that.lastMouseDownEvent) < 2 || e.type == "touchend") {
      Dispatcher.trigger(MDEvents.COMMENT_CLICKED, that.m_editor, that.hoverObjs[0]);
    }
  } else if (that.hoverObjs[0] && that.hoverObjs[0] instanceof _MMWeldMark["default"] && this.mouseStartPos && currentOperation) {
    currentOperation.clicked(logicPoint, this.editor, this.hoverObjs[0]);
  } else if (that.hoverObjs[0] && that.hoverObjs[0] instanceof _MMSealFrame["default"] && this.mouseStartPos) {
    var selectObj = that.hoverObjs[0];
    if (selectObj.getUser().getUserId() == app.currentUser.getUserId()) {
      _MDMarkerObjDrawerController["default"].focus(this.editor, selectObj);
    }
  } else {
    _MDMarkerObjDrawerController["default"].clearFocus();
  }
  var mouseEndPos = {
    x: e.clientX,
    y: e.clientY
  };
  if (this.mouseStartPos && !currentOperation) {
    if (Math.abs(this.mouseStartPos.x - mouseEndPos.x) + Math.abs(this.mouseStartPos.y - mouseEndPos.y) < 10) {
      Dispatcher.trigger(MDEvents.MOUSE_CLICK_LOG_POS, logicPoint);
    }
    ;
  } else if (this.mouseStartPos && currentOperation) {
    if (that.hoverObjs[0] && !(that.hoverObjs[0] instanceof _MMWeldMark["default"])) {
      return;
    }
    _.isFunction(currentOperation.clicked) && currentOperation.clicked(logicPoint, this.editor, that.hoverObjs[0]);
  }
};
MMOperationCenterDesktopImage.prototype.ondblClick = function (e) {
  var _this = this;
  Dispatcher.trigger(MDEvents.SHOW_COMMENTS);
  var that = this;
  var curTask = this.getCurrentBoard();
  var fileInfo = curTask.getFileInfo();
  if (fileInfo && !fileInfo.canCreateComment()) {
    return;
  }
  ;
  if (fileInfo.isOnlyDisp()) {
    return;
  }
  if (app.pathRouter.inTrash()) {
    return;
  }
  ;
  var version = this.editorViewCtl.getVersionShowing();
  fileInfo.canCreateCommentForVersion(version, function (can) {
    if (can) {
      if (app.currentUser.id != curTask.getCreatorId().toDecString() && curTask.getObjsInPage(that.m_editor.getCurrentFilePageIndex()).length == 0) return;
      var canvasOffset = $(that.m_canvas).offset();
      var devicePoint = _MMOperationCenter["default"].getPosition(e, _this.offsetLeft || 0, _this.offsetTop || 0);
      var logicPoint = that.m_editor.assistView2LogicPoint(devicePoint);
      e.LGPoint = logicPoint;
      var clickedObjects = that.getObjectsSelectable(logicPoint);
      var creatComment = false;
      if (!clickedObjects[0] || clickedObjects[0].m_objType !== _ObjType["default"].Obj_comment || clickedObjects[0] && clickedObjects[0] instanceof _MMCommentObj["default"] && _MMObjOperationStrategy["default"].getOperataionTypeForMolaTask(clickedObjects[0], that.m_editor.getCurrentFilePageIndex()) == _MMOperationType["default"].Operation_selectable) {
        if (!app.currentUser.logined()) {
          app.popupInnerLogin();
          return;
        }
        that.openCommentCreation(logicPoint, clickedObjects[0]);
      }
    }
  });
};
MMOperationCenterDesktopImage.prototype.openTextCommentHandler = function (editorCtl, textComment) {
  if (this.m_editor && textComment.getObjType() == _ObjType["default"].Obj_textComment) {
    var picObj = this.m_editor.getPicObject();
    if (picObj && picObj.getPageIndex() == textComment.getPageIndex()) {
      console.log('click on text comment');
      var that = this;
      _MDTextCommentPanelCtl["default"].setViewCtl(this.editorViewCtl);
      setBabelTimeout(function () {
        _MDTextCommentPanelCtl["default"].showReplyPanel(that.m_editor, textComment);
        $('.p-textcomment-root').css('background-color', 'rgba(255,255,255,0.3)');
      }, 0);
    }
    ;
  }
  ;
};
var _default = exports["default"] = MMOperationCenterDesktopImage;

},{"1005":1005,"1032":1032,"1034":1034,"1084":1084,"1184":1184,"1454":1454,"434":434,"812":812,"830":830,"859":859,"864":864,"865":865,"868":868,"872":872,"874":874,"875":875,"882":882,"886":886,"909":909}],875:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1438);
var _MDNiceTagView = _interopRequireDefault(require(335));
var _MMNiceTag = _interopRequireDefault(require(1018));
var _MMOperationCenter = _interopRequireDefault(require(874));
var _MMCommentOperation = _interopRequireDefault(require(864));
var _MMNewTagOperation = _interopRequireDefault(require(871));
var _MMWeldMark = _interopRequireDefault(require(1034));
var _MDGraphicToolOperation = _interopRequireDefault(require(860));
function MMOperationCenterDesktop(options) {
  _MMOperationCenter["default"].call(this, options);
}
MMOperationCenterDesktop.prototype = _.extend({}, _MMOperationCenter["default"].prototype);
MMOperationCenterDesktop.prototype.registerMouseEvents = function () {
  var that = this;
  this.removeEvents();
  this.listenToOnlineEvent();
  if (!this.$canvas) {
    this.$canvas = $(this.m_canvas);
  }
  this.mouseEventHandler = {
    down: _.bind(this.onMouseDown, this),
    move: _.bind(this.onMouseMove, this),
    up: _.bind(this.onMouseUp, this),
    dblclick: _.bind(this.ondblClick, this),
    clicked: _.bind(this.clicked, this)
  };
  this.$canvas.on('click', this.mouseEventHandler.clicked);
  this.$canvas.on('touchstart mousedown', this.mouseEventHandler.down);
  this.$canvas.on('touchmove mousemove', this.mouseEventHandler.move);
  this.$canvas.on('touchend mouseup', this.mouseEventHandler.up);
  this.$canvas.on('dblclick', this.mouseEventHandler.dblclick);
  $('body').on('mouseup.marker' + this.pageIndex, function (e) {
    that.mouseEventHandler.up(e);
  });
};
MMOperationCenterDesktop.prototype._onlineEventHandler = function (isOnline) {
  this.isOnline = isOnline;
  if (isOnline) {
    this.registerMouseEvents();
  } else {
    this.removeEvents();
  }
};
MMOperationCenterDesktop.prototype.removeEvents = function (e) {
  _MMOperationCenter["default"].prototype.removeEvents.call(this, e);
  if (!this.mouseEventHandler || !this.$canvas) {
    return;
  }
  $('body').off('mouseup.marker' + this.pageIndex);
  this.$canvas.off('clicked', this.mouseEventHandler.clicked);
  this.$canvas.off('touchstart mousedown', this.mouseEventHandler.down);
  this.$canvas.off('touchmove mousemove', this.mouseEventHandler.move);
  this.$canvas.off('touchend mouseup', this.mouseEventHandler.up);
  this.$canvas.off('dblclick', this.mouseEventHandler.dblclick);
  this.mouseEventHandler = null;
};

/**
 * Method to register on the assistlayer mouseDown event
 * @param e {event}
 */
MMOperationCenterDesktop.prototype.onMouseDown = function (e) {
  /* overwrite me */

  this.captured = true;
  var that = this;
  document.onmousemove = function (event) {
    if (that.captured) {
      event = event || window.event;
    }
    ;
  };
  document.onmouseup = function (e) {
    if (that.captured) {
      document.onmousemove = null;
      document.onmouseup = null;
    }
    that.captured = false;
    Dispatcher.trigger(MDEvents.Mouse_up, e);
  };
};
MMOperationCenterDesktop.prototype.isMouseCaptured = function () {
  return this.captured;
};

/**
 * Method to register on the assistlayer mouseMove event
 * @param e {event}
 */
MMOperationCenterDesktop.prototype.onMouseMove = function (e) {
  /* overwrite me */
  e.preventDefault();
  this.refreshCursor(e);
};
MMOperationCenterDesktop.prototype.refreshCursor = function (e) {
  var that = this;
  if (!this.$canvas) return;
  var devicePoint = _MMOperationCenter["default"].getPosition(e, this.offsetLeft || 0, this.offsetTop || 0);
  var logicPoint = that.m_editor.assistView2LogicPoint(devicePoint);
  that.penZoneMarks = [];
  var penZoneCtl = this.editorViewCtl && this.editorViewCtl.getPenZoneCtl();
  if (penZoneCtl) {
    that.penZoneMarks = penZoneCtl.getHoveredMarks(logicPoint);
  }
  that.hoverObjs = that.getObjectsSelectable(logicPoint);
  if (that.penZoneMarks.length > 0 || this.hoverObjs.length > 0) {
    if (this.hoverObjs[0] instanceof _MMWeldMark["default"] && this.getCurOperation() instanceof _MDGraphicToolOperation["default"]) {
      this.$canvas.css('cursor', 'pointer');
    } else if (!(this.hoverObjs[0] instanceof _MMWeldMark["default"])) {
      this.$canvas.css('cursor', 'pointer');
    } else {
      // this.$canvas.css('cursor', 'auto');
    }
  } else {
    if (this.m_editor.getPicObject().isPtOn(logicPoint)) {
      this.$canvas.css('cursor', 'auto');
      if (this.m_curOperation) {
        if (this.m_curOperation instanceof _MMCommentOperation["default"] || this.m_curOperation instanceof _MMNewTagOperation["default"]) {
          this.$canvas.css('cursor', 'crosshair');
        } else if (this.m_curOperation.getClassName() == "MMDrawScribbleOperation") {
          this.$canvas.css('cursor', _.escape('url(/img/mdisk/cursors/pen1.png), auto'));
        }
      }
      ;
    } else {
      this.$canvas.css('cursor', 'auto');
    }
  }
};

/**
 * Method to register on the assistlayer mouseup event
 * @abstract
 * @param e {event}
 */
MMOperationCenterDesktop.prototype.onMouseUp = function (e) {};

/**
 * Method to register on the assistlayer click event
 * @abstract
 * @param e {event}
 */
MMOperationCenterDesktop.prototype.clicked = function (e) {};
/**
 * @abstract
 * @param  {MouseEvent} e [description]
 * @return {void}
 */
MMOperationCenterDesktop.prototype.ondblClick = function (e) {};
MMOperationCenterDesktop.prototype.openTagCreationView = function (logicPoint, devicePoint) {
  if (this.m_editor.getCurrentBoard().isClosed()) return false;
  var $commentLayerParent = $(this.m_editor.getCommentLayer()).parent();
  var text = '';
  if (this._niceTagView) text = this._niceTagView.getValue();
  var ver = this.editorViewCtl.getVersionShowing();
  var nt = new _MMNiceTag["default"](this.m_editor.getCurrentBoard(), ver);
  nt.setPos(logicPoint.clone());
  nt.setLabel(text);
  nt.setPageIndex(this.m_editor.getCurrentFilePageIndex());
  nt._devicePoint = devicePoint;
  var ntv = new _MDNiceTagView["default"](nt, this.getTransformer(), true);
  $commentLayerParent.append(ntv.el);
  ntv.input.focus();
  this._niceTagView = ntv;
};
MMOperationCenterDesktop.prototype.openCommentCreation = function (logicPoint, obj) {
  if (this.m_editor.getCurrentBoard().isClosed()) return false;
  var that = this;
  if (this.m_editor.getPicObject().isPtOn(logicPoint)) {
    this.setCurOperation('comment', undefined, true);
    Dispatcher.trigger(MDEvents.CommentToolChangedNotByClick, 'comment');
    this.m_curOperation.onMouseDown(logicPoint.clone(), obj);
    this.m_curOperation.onMouseUp(logicPoint.clone(), true);
    return true;
  }
  return false;
};
var _default = exports["default"] = MMOperationCenterDesktop;

},{"1018":1018,"1034":1034,"1184":1184,"1438":1438,"1454":1454,"335":335,"860":860,"864":864,"871":871,"874":874}],1018:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMPointObj = _interopRequireDefault(require(1023));
var _ObjType = _interopRequireDefault(require(1084));
var _MMObjElementsController = _interopRequireDefault(require(893));
//
//  Created by jiang on 15/5/21.
//  Copyright (c) 2015年 Molamola. All rights reserved.
//

/**
 *                 /----------------------------
 *         -     /                             |
 *       ( @ ) *            tag                |
 *         -     \                             |
 *                 \----------------------------
 *
 *    like the tag in App Nice ,
 *    attention: the nice tag must also store in the server database， so must save the record id the object
 *       database table structure (pseudo):
 *         NiceTags (tagId, tagType, tagLabel)
 *         TaskTags (taskId, pageIndex, tagId)
 *
 *     created by jiang
 *     2015-5-21
 */

function MMNiceTag(board, ver) {
  _MMPointObj["default"].call(this, board, ver); //
  this.m_className = 'MMNiceTag';
  this.m_objType = _ObjType["default"].Obj_niceTag;
}
;
MMNiceTag.prototype = new _MMPointObj["default"](); //
MMNiceTag.superclass = _MMPointObj["default"].prototype;
MMNiceTag.prototype.encode = function (enc_) {
  MMNiceTag.superclass.encode.call(this, enc_);
};
MMNiceTag.prototype.decode = function (dec_, ver_) {
  MMNiceTag.superclass.decode.call(this, dec_, ver_);
};
MMNiceTag.prototype.setLabel = function (label) {
  var data = this.getObjData();
  if (data) {
    data.label = label;
  }
};
MMNiceTag.prototype.getLabel = function () {
  var data = this.getObjData();
  if (data) {
    return data.label;
  }
  return "";
};

//
// set side info
// @para right {bool}  true - on the right side
//
MMNiceTag.prototype.setSide = function (right) {
  var data = this.getObjData();
  if (data) {
    data.rightSide = !!right;
  }
};
MMNiceTag.prototype.isRightSide = function () {
  var data = this.getObjData();
  if (data) {
    return data.rightSide;
  }
  return true;
};
MMNiceTag.prototype.isInNiceTagDeleteArea = function (trsfm, lgPoint, ctx) {
  var point = trsfm.lg2dvPoint(lgPoint);
  if (!this.closePoint) {
    return;
  }
  if (point.x > this.closePoint.x && point.x < this.closePoint.x + 25) {
    if (point.y > this.closePoint.y && point.y < this.closePoint.y + 25) {
      return true;
    }
  }
  return false;
};
MMNiceTag.prototype.drawInDiv = function (editor, trsfm, pgindex) {
  var elementsCtl = _MMObjElementsController["default"].getSingleInstance();
  elementsCtl.displayInDiv(editor, this, trsfm, pgindex);
};
MMNiceTag.prototype.getCreationTime = function () {
  return this.creationTime || 0;
};
var _default = exports["default"] = MMNiceTag;

},{"1023":1023,"1084":1084,"1184":1184,"1454":1454,"893":893}],335:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1438);
require(1421);
require(1465);
require(1432);
require(1466);
require(1498);
require(1437);
var _MMObjElementsController = _interopRequireDefault(require(893));
var _MDGestureRecognizer = _interopRequireDefault(require(327));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
var _MMCommonFun = _interopRequireDefault(require(812));
/**
 *  @creator: Tobias
 *  @creationTime: 25.05.2015
 */

var MDNiceTagView = function MDNiceTagView(niceTag, trsfm, creationMode) {
  this.el = document.createElement('div');
  this.LGpos = niceTag.getPos();
  this.niceTag = niceTag;
  if (!niceTag.views) {
    niceTag.views = [];
  }
  niceTag.views.push(this);
  this.trsfm = trsfm;
  this.editorCtl = _MDPcMobileEditorCommonFun["default"].getMainEditor();
  this._pos = niceTag._devicePoint || trsfm.lg2dvPoint(this.LGpos.clone(), this.editorCtl.getCurrentFilePageIndex());
  this.el.style.top = this._pos.y + "px";
  this.el.style.left = this._pos.x + "px";
  this.el.style.cursor = "move";
  var scale = 1 / this.editorCtl.getScale();
  this.el.setAttribute('class', 'niceTag');
  this.needle = document.createElement('div');
  this.needle.setAttribute('class', 'needle');
  if (creationMode) {
    _MMCommonFun["default"].setTextInputInEditor('newComment');
    MDNiceTagView.instance = this;
    this.recognizer = new _MDGestureRecognizer["default"](this.el);
    this.recognizer.on(MDEvents.PAN, function (finger, e) {
      this.pan(finger);
    }.bind(this));
    this.input = document.createElement('input');
    this.input.maxLength = 15;
    this.input.value = niceTag.getLabel();
    this.needle.appendChild(this.input);
    this.input.style.backgroundColor = "rgba(0,0,0,0)";
    this.input.style.borderWidth = "0px";
    this.input.style.outline = "0px";
    this.input.style.width = "130px";
    this.input.style.cursor = "move";
    this.input.addEventListener('change', function () {
      this.updateDirection();
    }.bind(this));

    //sendCombi [ctrl] + [enter]
    this.input.addEventListener('keyup', function (e) {
      if (e.ctrlKey && e.keyCode == 13) {
        this.create();
      }
    }.bind(this));
    var ok = BabelStr.str(89); // 完成
    this.sendButton = document.createElement('button');
    this.sendButton.appendChild(document.createTextNode(ok));
    this.sendButton.style.backgroundColor = "rgb(0, 160, 240)";
    this.sendButton.style.position = "absolute";
    this.sendButton.style.color = "white";
    this.sendButton.style.width = "44px";
    this.sendButton.style.borderRadius = "2px";
    this.sendButton.style.padding = "2px 5px";
    this.sendButton.style.top = "-2px";
    this.sendButton.style.left = "180px";
    if (_MMCommonFun["default"].isPC()) {
      this.sendButton.style.backgroundColor = "#00a0f0";
    } else {
      this.sendButton.style.backgroundColor = "#eb7f87";
    }
    this.sendButton.addEventListener('click', function () {
      this.create();
    }.bind(this));
    this._closeHandler = function (e) {
      if ([].indexOf.apply($('.niceTag *'), [e.target]) === -1) {
        this.remove();
      }
    }.bind(this);
    setBabelTimeout(function () {
      document.body.addEventListener('click', this._closeHandler);
      _MMObjElementsController["default"].getSingleInstance().zoomScaleChanged(this.editorCtl.getScale(), this.editorCtl);
    }.bind(this), 100);
    this._pageChangeHandler = function () {
      this.remove();
    }.bind(this);
    Dispatcher.on(MDEvents.SET_PAGE_INDEX, this._pageChangeHandler);
  } else {
    //this.needle.innerText = niceTag.getLabel();
    this.needle.appendChild(document.createTextNode(niceTag.getLabel()));
    // this.needleText = document.createElement('div')
    // this.needleText.appendChild(document.createTextNode(niceTag.getLabel()));
    // this.needle.appendChild(this.needleText)
    // var curUser = app.currentUser.getUserId_Int();
    // var creator = niceTag.getCreator()
    // var fileInfo = niceTag.getBoard().getFileInfo()
    // if(fileInfo.canDelMyComment() || curUser.valueOf() == creator.valueOf()) {
    //   this.close = document.createElement('div');
    //   this.close.setAttribute('class', 'icon delete icon-close-cicle ');
    //   this.needle.appendChild(this.close);
    // }
  }
  this.dot = document.createElement('div');
  this.dot.setAttribute('class', 'dot icon niceTagDot');
  this.el.appendChild(this.dot);
  this.arrow = document.createElement('div');
  this.arrow.setAttribute('class', 'niceTagArrow');
  this.el.appendChild(this.arrow);
  this.el.appendChild(this.needle);
  if (this.sendButton) this.el.appendChild(this.sendButton);
  // this.updateDirection();
  setBabelTimeout(function () {
    this.updateDirection();
  }.bind(this), 1);
};
MDNiceTagView.prototype.pan = function (finger) {
  var imageRect = this.editorCtl.getPicObject().getRect();
  var border = 0.001;
  var maxOffset;
  var lgOffset = {
    x: this.trsfm.dv2lgLen(finger.offset.x),
    y: this.trsfm.dv2lgLen(finger.offset.y)
  };
  if (lgOffset.x > 0) {
    maxOffset = imageRect.right - this.LGpos.x - border;
    if (lgOffset.x > maxOffset) lgOffset.x = maxOffset;
  } else {
    maxOffset = imageRect.left - this.LGpos.x + border;
    if (lgOffset.x < maxOffset) lgOffset.x = maxOffset;
  }
  if (lgOffset.y > 0) {
    maxOffset = imageRect.bottom - this.LGpos.y - border;
    if (lgOffset.y > maxOffset) lgOffset.y = maxOffset;
  } else {
    maxOffset = imageRect.top - this.LGpos.y + border;
    if (lgOffset.y < maxOffset) lgOffset.y = maxOffset;
  }
  this.LGpos.x += lgOffset.x;
  this.LGpos.y += lgOffset.y;
  this.el.style.left = parseFloat(this.el.style.left) + this.trsfm.lg2dvLen(lgOffset.x) + "px";
  this.el.style.top = parseFloat(this.el.style.top) + this.trsfm.lg2dvLen(lgOffset.y) + "px";
  this.updateDirection();
};
MDNiceTagView.prototype.remove = function () {
  if (this.removed) return;
  var index = this.niceTag.views.indexOf(this);
  this.niceTag.views.splice(index, 1);
  this.el.parentNode.removeChild(this.el);
  if (this.recognizer) this.recognizer.destroy();
  Dispatcher.off(MDEvents.SET_PAGE_INDEX, this._pageChangeHandler);
  document.body.removeEventListener('click', this._closeHandler);
  clearInterval(this._animateInterval);
  this.removed = true;
  if (MDNiceTagView.instance == this) {
    _MMCommonFun["default"].removeTextInputInEditor('newComment');
  }
};
MDNiceTagView.prototype.updateDirection = function () {
  this.parent = this.el.parentElement || this.parent;
  ;
  var sendButtonWidth = this.sendButton ? $(this.sendButton).width() : 0;
  var neededWidth = this._pos.x + $(this.needle).outerWidth() + sendButtonWidth + 19;
  var editorCtl = _MDPcMobileEditorCommonFun["default"].getMainEditor();
  console.assert(editorCtl);
  var lgPoint = this.trsfm.dv2lgPoint({
    y: parseInt(this.el.style.top),
    x: parseInt(this.el.style.left)
  }, editorCtl.getCurrentFilePageIndex());

  //defaults
  var classes = 'niceTag';
  var maxNeedleWidth = 'initial';
  var buttonLeft = '180px';
  var leftSpace = "";
  var bordeInPx = 30;
  if (this.trsfm.orientation !== 'portrait') {
    lgPoint.y = lgPoint.y - this.editorCtl.getCurrentFilePageIndex() * 15; // old: % 20;

    leftSpace = this.trsfm.lg2dvLen(lgPoint.y);
    if (leftSpace > neededWidth) {
      // all right
    } else {
      if (lgPoint.y > 10) {
        classes = 'niceTag left';
        maxNeedleWidth = parseInt(this.trsfm.lg2dvLen(lgPoint.y) - bordeInPx) + "px";
        buttonLeft = '-210px';
      } else {
        maxNeedleWidth = parseInt(this.trsfm.lg2dvLen(15 - lgPoint.y) - bordeInPx) + "px";
      }
    }
  } else {
    // landscape
    //lgPoint.x = lgPoint.x % 15;
    leftSpace = this.trsfm.lg2dvLen(lgPoint.x);
    if (leftSpace > neededWidth) {
      // all right
    } else {
      if (lgPoint.x > 7.5) {
        classes = 'niceTag left';
        maxNeedleWidth = parseInt(this.trsfm.lg2dvLen(lgPoint.x) - bordeInPx) + 'px';
        buttonLeft = '-210px';
      } else {
        maxNeedleWidth = parseInt(this.trsfm.lg2dvLen(20 - lgPoint.x) - bordeInPx) + 'px';
      }
    }
  }
  this.el.setAttribute('class', classes);
  this.needle.style.maxWidth = maxNeedleWidth;
  if (this.sendButton) this.sendButton.style.left = buttonLeft;
  $(this.el).css({
    "visibility": "visible"
  });

  // if(this.close) {
  //   let closePoint = {
  //     x: this._pos.x + this.close.offsetLeft,
  //     y: this._pos.y + this.close.offsetTop
  //   }
  //   this.niceTag.closePoint = closePoint
  // }
};
MDNiceTagView.prototype.update = function (trsfm, editor) {
  $(this.needle).text(this.niceTag.getLabel());
  // let target
  // if(this.needleText) {
  //   target = this.needleText
  // } else {
  //   target = this.needle
  // }

  // $(target).text(this.niceTag.getLabel());
  var pos = this.niceTag.getPos();
  this._pos = trsfm.lg2dvPoint(pos, editor.getCurrentFilePageIndex());
  this.el.style.top = this._pos.y - 8 + 'px';
  this.el.style.left = this._pos.x - 5 + 'px';
};
MDNiceTagView.prototype.getValue = function () {
  if (this.removed) return "";
  return this.input.value.trim();
};
MDNiceTagView.prototype.create = function () {
  var that = this;
  var text = this.getValue();
  this.niceTag.setLabel(text);
  if (text.length > 0) {
    that.createTag();
    that.remove();
    Dispatcher.trigger(MDEvents.Comment_changed);
  }
};
MDNiceTagView.prototype.createTag = function () {
  _czc && _czc.push(["_trackEvent", "讨论", "创建批注", "标签批注", "", ""]);
  var curWhiteboard = _MDPcMobileEditorCommonFun["default"].getMainEditor().getCurrentBoard();
  var realtime = true; // MMCommonFun.isPC() ? false : true;
  //realtime = false; //tmp
  this.niceTag.creationTime = new Date().getTime();

  // only for test, jiang
  // curWhiteboard.addObject(this.niceTag);
  // return;
  // end

  var option = {
    toUndo: true,
    realtime: realtime,
    isMark_: false
  };
  curWhiteboard.m_actionManager.addObject(this.niceTag, option);

  //mashx for temporary
  console.error('请马世雄修正');
  Dispatcher.trigger("mashx_temporary");
  Dispatcher.trigger(MDEvents.SELECT_NULL_OPERATION);
  //END

  this.editorCtl.refreshCommentsInEditor();
};
var _default = exports["default"] = MDNiceTagView;

},{"1184":1184,"1421":1421,"1432":1432,"1437":1437,"1438":1438,"1454":1454,"1465":1465,"1466":1466,"1498":1498,"327":327,"807":807,"812":812,"893":893}],874:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1461);
require(1421);
require(1432);
require(1466);
var _MDSalonPenOperation = _interopRequireDefault(require(210));
var _MDSalonEraserOperation = _interopRequireDefault(require(203));
var _MDGraphCommentOperation = _interopRequireDefault(require(859));
var _MDTextOperation = _interopRequireDefault(require(862));
var _MMPDFDocument = _interopRequireDefault(require(1021));
var _MMImage = _interopRequireDefault(require(1016));
var _MMMovingOperation = _interopRequireDefault(require(870));
var _MMScalingOperation = _interopRequireDefault(require(884));
var _MMRotatingOperation = _interopRequireDefault(require(883));
var _MMErasingOperation = _interopRequireDefault(require(869));
var _MMCommentOperation = _interopRequireDefault(require(864));
var _MMNewTagOperation = _interopRequireDefault(require(871));
var _MMBoxSelectingOperation = _interopRequireDefault(require(863));
var _MMDrawScribbleOperation = _interopRequireDefault(require(868));
var _MMDrawLineOperation = _interopRequireDefault(require(866));
var _MMDrawRectOperation = _interopRequireDefault(require(867));
var _Dispatcher = _interopRequireDefault(require(18));
var _MMObjOperationStrategy = _interopRequireDefault(require(872));
var _MDEvents = _interopRequireDefault(require(325));
var _MDOnlineEventHandler = _interopRequireDefault(require(59));
var _OnlineEvent = _interopRequireDefault(require(60));
var _MMPoint = _interopRequireDefault(require(830));
var _ObjType = _interopRequireDefault(require(1084));
var _MMRect = _interopRequireDefault(require(831));
var _MMOperationType = _interopRequireDefault(require(882));
var _MMCommentObj = _interopRequireDefault(require(1005));
var _MDGraphicToolOperation = _interopRequireDefault(require(860));
/**
 * @constructor
 * @param options {object}
 *    options.whiteboard the whiteboard to use
 *    options.pageIndex the page that should be selected
 */
function MMOperationCenter(options) {
  if (!options.editor) throw 'options.editor need to be set';
  var keys = Object.keys(options);
  for (var i = 0; i < keys.length; i++) {
    this[keys[i]] = options[keys[i]];
  }
  ;
  var that = this;
  this.m_curOperation = null;
  this.m_whiteboard = options.editor.getCurrentBoard();
  this.m_selectedObjs = [];
  this.hoverObjs = [];
  this.m_canvas = null;
  //this.m_displayedObject = options.displayedObject || null;

  this.createCommentView = null;
  this.mouseEventHandler = {}; // list of jwerty handle
  this.DispatcherHandlers = [];
  this.objectTypes = null;
  this.objFilter = options.objFilter !== undefined ? options.objFilter : null;
  this.mode = options.mode ? options.mode : 'taskboard';
  this.m_editor = options.editor;
  this._windowClickCallback = null;
  this._isPageChanging = false;
  this.isOnline = true;
  this.imgMarkerCtl = options.imgMarkerCtl;
  this.editorViewCtl = options.editorViewCtl;

  //helper
  this.boundingboxExpansion = options.boundingboxExpansion !== undefined ? options.boundingboxExpansion : 7.5;
  this.controllCircleRadius = options.controllCircleRadius !== undefined ? options.controllCircleRadius : 17.5; // radius in dvPixel
  this.controllSquareRadius = options.controllSquareRadius !== undefined ? options.controllSquareRadius : 5; // radius in dvPixel
  this.borderColor = options.borderColor !== undefined ? options.borderColor : '#457cfd';
  this.borderWidth = options.borderWidth !== undefined ? options.borderWidth : 1;
  this.updateAssistantCanvas();
  this.listenToOnlineEvent();

  //mashx for temporary BEGIN
  _Dispatcher["default"].on("mashx_temporary", function () {
    that.m_curOperation = null;
  });
  //mashx for temporary END

  this.isMarker = options.isMarker;
  if (this.isMarker) {
    this.setCurOperation(MMOperationCenter.getMarkerOperation());
  } else {
    this.setCurOperation(MMOperationCenter.getOperation());
  }
}
; // end Constructor

MMOperationCenter.registerMouseEvents = function () {
  throw Error("this is now defined in ocDesktop and ocMobile");
};
MMOperationCenter.setOperation = function (oper_) {
  MMOperationCenter.globalOperation = oper_;
};
MMOperationCenter.getOperation = function () {
  return MMOperationCenter.globalOperation;
};
MMOperationCenter.setMarkerOperation = function (oper_) {
  MMOperationCenter.markerOperation = oper_;
};
MMOperationCenter.getMarkerOperation = function () {
  return MMOperationCenter.markerOperation;
};
MMOperationCenter.clearOperation = function () {
  MMOperationCenter.globalOperation = null;
  MMOperationCenter.markerOperation = null;
};
MMOperationCenter.prototype.updateAssistantCanvas = function () {
  if (this.m_editor) {
    this.m_canvas = this.m_editor.getAssistantCanvas();
    if (this.m_canvas && this.m_canvas.getContext) {
      this.ctx = this.m_canvas.getContext('2d');
      this.m_canvas.setAttribute('oncontextmenu', 'return false;');
      this.registerMouseEvents(this);
    }
    ;
  }
};
MMOperationCenter.prototype.getAssistantCanvas = function () {
  return this.m_editor.getAssistantCanvas();
};
MMOperationCenter.getPosition = function () {
  function getClickPosition(e, offsetLeft, offsetTop) {
    var point = null;
    var $root = '';
    if (!app.canDispInNormalBrowser()) {
      $root = $('.m-editor-zone')[0];
    } else {
      $root = window;
    }
    var touchPos = MMCommonFun.touchPosition(e);
    if (touchPos) {
      var newpos = MMCommonFun.convertPointBetweenElements($root, e.target, touchPos);
      var xPosition = newpos.x;
      var yPosition = newpos.y;
      point = new _MMPoint["default"](xPosition, yPosition);
    }
    return point;
  }
  function getPosition(element) {
    var xPosition = 0;
    var yPosition = 0;
    if (this.mode == 'FULLSCREEN') {
      xPosition += element.parentElement.scrollLeft;
      yPosition += element.parentElement.scrollTop;
    }
    while (element) {
      var scrollLeft = element.scrollLeft;
      var scrollTop = element.scrollTop;
      if (!element.offsetParent) {
        scrollLeft = document.documentElement.scrollLeft || window.pageXOffset || document.body.scrollLeft;
        scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
      }
      xPosition += element.offsetLeft - scrollLeft + element.clientLeft;
      yPosition += element.offsetTop - scrollTop + element.clientTop;
      element = element.offsetParent;
    }
    return {
      x: xPosition,
      y: yPosition
    };
  }
  return function (e, offsetLeft, offsetTop) {
    return getClickPosition(e, offsetLeft, offsetTop);
  };
}();

/**
 * Add Backbone.Events to MMOperationCenter
 * @author  manjun.han
 * @date 2016.9.6
 */
_.extend(MMOperationCenter.prototype, Backbone.Events);

/**
 * removes the mouseEvents from the canvas, it will be called when the OC get destroyed
 */

MMOperationCenter.prototype.openFullscreen = function (obj) {
  if (obj instanceof _MMImage["default"] || obj instanceof _MMPDFDocument["default"]) {
    this.removeEvents();
    _Dispatcher["default"].trigger(_MDEvents["default"].DISPLAY_IMG_FULLSCREEN, this.m_editor, obj);
  }
};
MMOperationCenter.prototype.getTransformer = function () {
  return this.m_editor.getDivTransformer();
};
MMOperationCenter.prototype.getAssistTrsfm = function () {
  return this.m_editor.getDivTransformerForAssist();
};

// MMOperationCenter.prototype.getLPFromEvent = function(e) {
//   var devicePoint = new MMPoint(e.pageX - (this.offsetLeft || 0) - canvasOffset.left, e.pageY - (this.offsetTop || 0) - canvasOffset.top);
//   var logicPoint = this.m_editor.assistView2LogicPoint(devicePoint);
//   e.LGPoint = logicPoint;
//   return logicPoint;
// };

MMOperationCenter.prototype.getCurOperation = function () {
  return this.m_curOperation;
};
MMOperationCenter.prototype.setCurOperation = function (oper_, obj_, tmp) {
  if (app.canDispInNormalBrowser() && this.editorViewCtl) {
    MDPCEditorViewController.setCurrentInstance(this.editorViewCtl);
  }
  if (this.isMarker) {
    MMOperationCenter.setMarkerOperation(oper_);
  } else {
    MMOperationCenter.setOperation(oper_);
  }
  if (!this.$canvas) {
    return;
  }
  ;

  // ------------------- 删除旧的 cursor class

  // var cursorClasses = ['cursor-move', 'cursor-scale', 'cursor-comment', 'cursor-default'];
  // var i = cursorClasses.length;
  // while (i--) {
  //   this.$canvas.removeClass(cursorClasses[i]);
  // }
  var classStrs = this.$canvas.attr('class').split(' ');
  var cursorClassNames = [];
  for (var i = 0; i < classStrs.length; i++) {
    if (classStrs[i].indexOf('cursor-') != -1) {
      cursorClassNames.push(classStrs[i]);
    }
  }
  ;
  for (var i = 0; i < cursorClassNames.length; i++) {
    this.$canvas.removeClass(cursorClassNames[i]);
  }
  ;
  var toolView = null;
  //mashx modified the concrete logic as following
  if (!oper_) {
    if (this.m_curOperation) {
      this.m_curOperation.preDestroy();
      this.m_curOperation = null;
      _Dispatcher["default"].trigger(_MDEvents["default"].NULL_OPERATION, {
        isMarker: this.isMarker,
        editorViewCtl: this.editorViewCtl
      });
    }
    return;
  }

  // if (this.m_curOperation) {
  //   this.setCurOperation();
  // }

  if (oper_ == 'move') {
    this.m_curOperation = new _MMMovingOperation["default"](this, obj_);
    this.$canvas.addClass('cursor-move');
  } else if (oper_ == 'scale') {
    this.m_curOperation = new _MMScalingOperation["default"](this);
    this.$canvas.addClass('cursor-scale');
  } else if (oper_ == 'rotate') {
    this.m_curOperation = new _MMRotatingOperation["default"](this);
    this.$canvas.addClass('cursor-default');
  } else if (oper_ == 'erase') {
    this.m_curOperation = new _MMErasingOperation["default"](this);
    this.$canvas.addClass('cursor-default');
  } else if (oper_ == 'box') {
    this.m_curOperation = new _MMBoxSelectingOperation["default"](this);
    this.$canvas.addClass('cursor-default');
  } else if (oper_ == 'tag') {
    this.m_curOperation = new _MMNewTagOperation["default"](this);
    this.$canvas.addClass('cursor-default');
    _Dispatcher["default"].trigger(_MDEvents["default"].SELECT_TAG_OPERATION);
  } else if (oper_ == 'draw') {
    this.m_curOperation = new _MMDrawScribbleOperation["default"](this, {
      isMarker: true,
      canUndo: true,
      toolName: 'draw'
    });
    this.$canvas.addClass('cursor-draw');
  } else if (oper_ == 'graphic') {
    this.m_curOperation = new _MDGraphicToolOperation["default"](this);
    this.$canvas.addClass('cursor-rect');
  } else if (oper_ == 'rect') {
    this.m_curOperation = new _MMDrawRectOperation["default"](this);
    this.$canvas.addClass('cursor-rect');
  } else if (oper_ == 'line') {
    this.m_curOperation = new _MMDrawLineOperation["default"](this);
    this.$canvas.addClass('cursor-line');
  } else if (oper_ == 'arrow') {
    this.m_curOperation = new _MMDrawLineOperation["default"](this, 1);
    this.$canvas.addClass('cursor-line');
  } else if (oper_ == 'comment') {
    this.m_curOperation = new _MMCommentOperation["default"](this, tmp);
    this.$canvas.addClass('cursor-comment');
    _Dispatcher["default"].trigger(_MDEvents["default"].SELECT_COMMENT_OPERATION);
  } else if (oper_ == 'text-mark') {// ----  选中文字进行批注
    // 此处不需要做任何事情
  } else if (oper_ == 'text') {
    this.m_curOperation = new _MDTextOperation["default"](this);
    this.$canvas.addClass('cursor-comment');
    _Dispatcher["default"].trigger(_MDEvents["default"].SELECT_TEXT_MARK_OPERATION);
  } else if (oper_ == 'arrowComment' || oper_ == 'rectComment' || oper_ == 'ellipseComment') {
    this.m_curOperation = new _MDGraphCommentOperation["default"](this, oper_);
    this.$canvas.addClass('cursor-comment');
    _Dispatcher["default"].trigger(_MDEvents["default"].SELECT_GRAPH_OPERATION);
  } else if (oper_ == 'salon-pen') {
    this.m_curOperation = new _MDSalonPenOperation["default"](this, oper_);
    this.$canvas.addClass('cursor-comment');
    _Dispatcher["default"].trigger(_MDEvents["default"].SELECT_SALON_PEN);
  } else if (oper_ == 'salon-eraser') {
    this.m_curOperation = new _MDSalonEraserOperation["default"](this, {
      toolName: 'salon-eraser'
    });
    this.$canvas.addClass('cursor-eraser');
    _Dispatcher["default"].trigger(_MDEvents["default"].SELECT_SALON_ERASER);
  } else if (oper_ == 'penComment') {
    this.m_curOperation = new _MMDrawScribbleOperation["default"](this, {
      isMarker: false,
      canUndo: false,
      toolName: 'penComment'
    });
    this.$canvas.addClass('cursor-draw');
  } else if (oper_ == 'penEraser') {
    this.m_curOperation = new _MDSalonEraserOperation["default"](this, {
      toolName: 'penEraser'
    });
    this.$canvas.addClass('cursor-eraser');
  } else {
    console.error("error!,please set the correct the status, One of: 'move', 'scale', 'erase', 'box', 'rotate'");
  }
  if (this.m_curOperation) {
    this.m_curOperation.setEditorViewCtl && this.m_curOperation.setEditorViewCtl(this.editorViewCtl);
  }
  if (this.createCommentView) {
    var createCommentView = this.createCommentView;
    this.createCommentView.hide(function () {
      createCommentView.remove();
    });
  }
  if (this.m_curOperation) {
    this.m_curOperation.setImgMarkerCtl(this.imgMarkerCtl);
  }
  ;
  _Dispatcher["default"].trigger(_MDEvents["default"].OPERATION_CHANGED, oper_);
};
MMOperationCenter.explodePointsFromPT = function explodePointsFromPT(points, center, width) {
  var out = [];
  var i = points.length;
  while (i--) {
    var distance = center.distanceTo(points[i]);
    var offsetX = (center.x - points[i].x) / distance * width;
    var offsetY = (center.y - points[i].y) / distance * width;
    out.unshift(new _MMPoint["default"](points[i].x - offsetX, points[i].y - offsetY));
  }
  return out;
};
MMOperationCenter.prototype.deleteSelectedObjects = function () {
  if (this.m_selectedObjs.length === 0) return;
  if (_MMObjOperationStrategy["default"].getOperataionTypeForMolaTask(this.m_selectedObjs[0], this.m_editor.getCurrentFilePageIndex()) !== _MMOperationType["default"].Operation_editable) {
    return;
  }
  if (this.m_selectedObjs[0].m_objType === _ObjType["default"].Obj_comment && this.m_editor.removeCommentPanel) {
    this.m_editor.removeCommentPanel();
  }
  this.m_editor.getCurrentBoard().m_actionManager.deleteObject(this.m_selectedObjs, {
    toUndo: true,
    realtime: true
  });
  this.m_selectedObjs = [];
};

/**
 * returns list of object at the position of the given logic-point
 *
 * @param lgPoint {MMPoint} the logicpoint
 * @return {array of MMObject}
 */
MMOperationCenter.prototype.getObjectsAtLGPoint = MMOperationCenter.prototype.getObjectsAtPoint = function (lgPoint, objectBlacklist) {
  if (!(lgPoint instanceof _MMPoint["default"])) return null;
  if (!objectBlacklist) objectBlacklist = [];
  var objects = this.m_editor.getObjsInView();
  var out = [];
  var i = objects.length;
  var trsfm = this.m_editor.getDivTransformer();
  if (!trsfm) {
    return lgPoint;
  }
  ;
  var scale;
  if (this.m_editor.useTransformToScale) {
    scale = this.m_editor.useTransformToScale() ? this.m_editor.getScale() : 1;
  } else {
    scale = 1; //   this.m_editor.getScale();
  }
  var commentRadiusLG = trsfm.dv2lgLen(this.controllCircleRadius / scale);
  while (i--) {
    var obj = objects[i];
    if (this.objFilter && this.objFilter.isObjRemovedByFilter(obj)) continue;
    if (objectBlacklist.indexOf(obj) === -1) {
      // if obj is not inblacklist test the point.
      if (obj.isComment()) {
        if (!!obj.getPos() && obj.getPos().distanceTo(lgPoint) < commentRadiusLG) out.push(obj);
      } else if (obj.m_objType == _ObjType["default"].Obj_niceTag) {
        if (!!obj.getPos() && obj.getPos().distanceTo(lgPoint) < commentRadiusLG * 2) {
          // || obj.isInNiceTagDeleteArea(trsfm, lgPoint, this.ctx)){
          out.push(obj);
        }
      } else if (obj.m_objType == _ObjType["default"].Obj_weldMark) {
        obj.isInWakeUpArea(trsfm, lgPoint, this.ctx) && out.push(obj);
      } else {
        if (obj.isPtOn(lgPoint)) out.push(obj);
      }
    }
  }
  return out;
};
MMOperationCenter.prototype.getObjectsSelectable = function (lgPoint) {
  var ret = [];
  var i;
  var objectsAtPoint = this.getObjectsAtPoint(lgPoint);
  if (!objectsAtPoint) return ret;
  for (i = 0; i < objectsAtPoint.length; i++) {
    var object = objectsAtPoint[i];
    var opType = _MMObjOperationStrategy["default"].getOperataionTypeForMolaTask(object, object.getPageIndex());
    if (opType == _MMOperationType["default"].Operation_selectable || opType == _MMOperationType["default"].Operation_deletable || opType == _MMOperationType["default"].Operation_editable) ret.push(object);
  }
  for (i = 0; i < ret.length; i++) {
    if (ret[i].isComment()) {
      var commentObj = ret.splice(i, 1);
      console.assert(commentObj[0]);
      ret.splice(0, 0, commentObj[0]);
      break;
    }
  }
  return ret;
};
MMOperationCenter.prototype.getObjectsAtDVPoint = function (dv, objectBlacklist) {
  var lgPt = this.m_editor.assistView2LogicPoint(dv);
  return this.getObjectsAtLGPoint(lgPt, objectBlacklist);
};
MMOperationCenter.prototype.clearSelection = function clearSelection() {
  var ids = [];
  var i = this.m_selectedObjs.length;
  while (i--) {
    ids.push(this.m_selectedObjs[i].getId());
  }
  this.m_selectedObjs = this.m_editor.getCurrentBoard().getObjsById(ids);
  return this;
};
MMOperationCenter.prototype.calcFullscreenButtonPosition = function (expandPoints, obj) {
  var point = expandPoints[this.getCtrPointIndexFor('fullscreen', obj)].clone();
  var top = this.m_editor.getCurrentFilePageIndex() * 20 + 0.5;
  var trsfm = this.m_editor.getDivTransformer();
  point.y = point.y < top ? top : point.y;
  if (trsfm.orientation == 'portrait') {
    point.x = point.x < 0.5 ? 0.5 : point.x;
  } else {
    point.x = point.x > 14.5 ? 14.5 : point.x;
  }
  return point;
};

/**
 * @param points {array of MMPoint} should be used with lgPoints
 */
MMOperationCenter.pointsToMaxRect = function (points) {
  var rect = new _MMRect["default"](9999999999999, -99999999999999, -99999999999999, 99999999999999);
  var i = points.length;
  while (i--) {
    rect.top = points[i].y < rect.top ? points[i].y : rect.top;
    rect.bottom = points[i].y > rect.bottom ? points[i].y : rect.bottom;
    rect.left = points[i].x < rect.left ? points[i].x : rect.left;
    rect.right = points[i].x > rect.right ? points[i].x : rect.right;
  }
  return rect;
};
MMOperationCenter.prototype.setPageIndex = function (pageIndex_) {
  pageIndex_ = parseInt(pageIndex_);
  if (this.m_editor.getCurrentFilePageIndex() === pageIndex_) return;
  this.m_selectedObjs = [];
  this.hoverObjs = [];
  this.closeContextMenu();
  if (this.createCommentView) {
    var createCommentView = this.createCommentView;
    this.createCommentView.hide(function () {
      createCommentView.remove();
    });
    if (this.createCommentView._$circleParent) this.createCommentView._$circleParent.remove();
    this.createCommentView = null;
  }
  //mashx
  this.setCurOperation();
};
MMOperationCenter.prototype.getCurrentFilePageIndex = function () {
  return this.m_editor.getCurrentFilePageIndex();
};
MMOperationCenter.prototype.getCtrPointIndexFor = function (action, obj) {
  var out = 0;
  var trsfm = this.m_editor.getDivTransformer();
  if (trsfm.orientation == 'portrait') {
    switch (action) {
      case 'scale':
        out = 4;
        break;
      case 'fullscreen':
        out = 0;
        break;
    }
  } else {
    switch (action) {
      case 'scale':
        out = 6;
        break;
      case 'fullscreen':
        out = 2;
        break;
    }
  }
  // this formular is tested for 90deg rotations
  var angle = obj.getObjData().m_angle;
  var steps = Math.floor(angle % 360 / 45);
  return (out - steps + 8000) % 8;
};
MMOperationCenter.prototype.destroy = function (action) {
  this.removeEvents();
  if (this._recognizer) {
    this._recognizer.destroy();
    this._recognizer = null;
  }
  this.m_curOperation = null;
  this.m_selectedObjs = null;
  this.hoverObjs = null;
  this.m_canvas = null;
  this.createCommentView = null;
  this.keyEvents = null;
  this.mouseEventHandler = null;
  this.DispatcherHandlers = null;
  this.objectTypes = null;
  this.objFilter = null;
  this.m_editor = null;
  this._windowClickCallback = null;
};
MMOperationCenter.prototype.zoomSteps = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 3, 4];
MMOperationCenter.prototype.zoom = function (change) {
  if (change) {
    if (this.mode == 'taskboard') {
      var editor = this.m_editor;
      var newScale = editor.getZoomScale();
      var curIndex = this.zoomSteps.indexOf(editor.getZoomScale());
      if (curIndex !== -1) {
        if (typeof change == "string") {
          if (change === 'in') {
            if (curIndex < this.zoomSteps.length - 1) newScale = this.zoomSteps[this.zoomSteps.indexOf(editor.getZoomScale()) + 1];
          } else {
            if (curIndex > 0) newScale = this.zoomSteps[this.zoomSteps.indexOf(editor.getZoomScale()) - 1];
          }
        } else {
          if (change > 0) {
            if (curIndex < this.zoomSteps.length - 1) newScale = this.zoomSteps[this.zoomSteps.indexOf(editor.getZoomScale()) + 1];
          } else {
            if (curIndex > 0) newScale = this.zoomSteps[this.zoomSteps.indexOf(editor.getZoomScale()) - 1];
          }
        }
      }
      editor.changeZoomScale(newScale);
      _Dispatcher["default"].trigger(_MDEvents["default"].SET_SCALE, newScale, editor);
      return newScale;
    } else {
      //fullscreenScrolling
      if (typeof change == "string") {
        if (change === 'in') {
          var newScale = MMCommonFun.getO2OEditor().scale + 0.05 > 4 ? 4 : MMCommonFun.getO2OEditor().scale + 0.05;
          MMCommonFun.getO2OEditor().changeScale(newScale);
          //MMCommonFun.getO2OEditor().changeScale(1);
        } else {
          var newScale = MMCommonFun.getO2OEditor().scale - 0.05 < 0.1 ? 0.1 : MMCommonFun.getO2OEditor().scale - 0.05;
          MMCommonFun.getO2OEditor().changeScale(newScale);
          //MMCommonFun.getO2OEditor().changeScale(0.5);
        }
      } else {
        var newScale = MMCommonFun.getO2OEditor().scale + MMCommonFun.getO2OEditor().scale * change;
        newScale = newScale < 0.25 ? 0.25 : newScale;
        newScale = newScale > 4 ? 4 : newScale;
        MMCommonFun.getO2OEditor().changeScale(newScale);
        //MMCommonFun.getO2OEditor().changeScale(0.5);
      }
    }
  } else {
    return this.m_editor.getZoomScale();
  }
};
MMOperationCenter.prototype.setSelection = function (objs) {
  this.m_selectedObjs = objs instanceof Array ? objs : [objs];
};
MMOperationCenter.prototype.getCurrentBoard = function () {
  return this.m_editor.getCurrentBoard();
};
MMOperationCenter.prototype.removeEvents = function () {
  _Dispatcher["default"].on(null, null, this);
};

/**
 * Listen to network connection
 * @return {void}
 */
MMOperationCenter.prototype.listenToOnlineEvent = function () {
  var onlineEventHandler = new _MDOnlineEventHandler["default"]();
  this.isOnline = onlineEventHandler.isOnline();
  this.listenTo(onlineEventHandler, _OnlineEvent["default"].OnlineStateChange, this._onlineEventHandler);
};
MMOperationCenter.prototype._onlineEventHandler = function (isOnline) {
  this.isOnline = isOnline;
};
MMOperationCenter.prototype.setImgMarkerCtl = function (imgMarkerCtl) {
  this.imgMarkerCtl = imgMarkerCtl;
  if (this.m_curOperation) {
    this.m_curOperation.setImgMarkerCtl(imgMarkerCtl);
  }
  ;
};
var distanceBetweenMouseEvents = function distanceBetweenMouseEvents(e1, e2) {
  var dx = e1.screenX - e2.screenX;
  var dy = e1.screenY - e2.screenY;
  return Math.sqrt(dx * dx + dy * dy);
};
window.distanceBetweenMouseEvents = distanceBetweenMouseEvents;
var _default = exports["default"] = MMOperationCenter;

},{"1005":1005,"1016":1016,"1021":1021,"1084":1084,"1184":1184,"1421":1421,"1432":1432,"1454":1454,"1461":1461,"1466":1466,"18":18,"203":203,"210":210,"325":325,"59":59,"60":60,"830":830,"831":831,"859":859,"860":860,"862":862,"863":863,"864":864,"866":866,"867":867,"868":868,"869":869,"870":870,"871":871,"872":872,"882":882,"883":883,"884":884}],1021:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1438);
require(1466);
require(1432);
var _MMPdfLoader = _interopRequireDefault(require(897));
var _MMBlockObj = _interopRequireDefault(require(1000));
var _ObjType = _interopRequireDefault(require(1084));
var _MMObjElementsController = _interopRequireDefault(require(893));
var _MMPoint = _interopRequireDefault(require(830));
/**
 * @author lishusheng ,2014-06-06
 * @param  init {bool}
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMPDFDocument}
 */
function MMPDFDocument(board, init) {
  _MMBlockObj["default"].call(this, board, init); //
  this.m_className = "MMPDFDocument";
  this.m_objType = _ObjType["default"].Obj_PDF;
  this.m_image = null; //ios5
  this.m_imageNext = null; //ios5

  this.m_fileSize; //string
  this.m_filePath; //string
  this.m_fileName; //string

  this.dispCtl = null;
  this.page = null; // pdf's page to display

  this.waittingQueue = [];
  this.capacity = 0;
  this.originSize = new _MMPoint["default"](0, 0);
}
MMPDFDocument.prototype = new _MMBlockObj["default"](); //
MMPDFDocument.superclass = _MMBlockObj["default"].prototype;
MMPDFDocument.prototype.encode = function (enc_) {
  MMPDFDocument.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
  enc_.encodeFloat(this.capacity);
  enc_.encodeMMPoint(this.originSize);
};
MMPDFDocument.prototype.decode = function (dec_, ver_) {
  MMPDFDocument.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
  this.capacity = dec_.decodeFromFloat(ver_);
  this.originSize = dec_.decodeFromMMPoint(ver_);
};
MMPDFDocument.prototype.setPdfPageIndex = function (index) {
  var _pdfDocData = this.getObjData();
  _pdfDocData.setPdfPageIndex(index);
};
MMPDFDocument.prototype.getPdfPageIndex = function () {
  var _pdfDocData = this.getObjData();
  var pdfIndex = _pdfDocData.getPdfPageIndex();
  return pdfIndex;
};
MMPDFDocument.prototype.draw = function (ctx, trsfm, pgindex, callback) {
  //if (this.page != null) {
  return this.drawInCanvas(ctx, trsfm, pgindex, callback);
  //}
};
MMPDFDocument.prototype.drawInDiv = function (editor, trsfm, pgindex) {
  var _pdfDocData = this.getObjData();
  var pdffilePath = _pdfDocData.getFilePath();

  //    console.log("--------------> pdf file:" + pdffilePath);

  if (pdffilePath.length == 0) {
    return; //pdffilePath = 'img/test.pdf';
  }
  var elementsCtl = _MMObjElementsController["default"].getSingleInstance();
  elementsCtl.displayInDiv(editor, this, trsfm, pgindex);
  if (this.page == null) {
    var pdfLoader = getMMPdfLoader();
    pdfLoader.getPdfByUrl(this, pdffilePath);
  } else {
    elementsCtl.refreshPdf(this);
  }
};
MMPDFDocument.prototype.getFilePath = function () {
  var _pdfDocData = this.getObjData();
  var pdffilePath = _pdfDocData.getFilePath();
  return pdffilePath;
};
MMPDFDocument.prototype.setFilePath = function (path) {
  var _pdfDocData = this.getObjData();
  var pdffilePath = _pdfDocData.setFilePath(path);
  this.m_filePath = path;
};
MMPDFDocument.prototype.getPdfPage = function (callback) {
  var _this = this;
  var _pdfDocData = this.getObjData();
  var pdffilePath = this.getDispFilePath();
  var passwordCallback = function passwordCallback(pwd) {
    var password = _this.m_board.fileInfo.getPassowrdByVersion(_this.getFileVersion(), true);
    pwd(password);
  };
  if (pdffilePath.length == 0) {
    return;
  }
  if (this.page == null) {
    if (this.waittingQueue.length == 0) {
      this.waittingQueue.push(callback);
      var pdfLoader = getMMPdfLoader();
      pdfLoader.getPdfByUrl(this, pdffilePath, passwordCallback);
    } else {
      this.waittingQueue.push(callback);
    }
    return 1;
  } else {
    this.page.pageIndex = this.getPdfPageIndex() - 1;
    this.page.mmobjId = this.getId();
    _.delay(function () {
      callback(this.page);
    }.bind(this), 0);
  }
};
MMPDFDocument.prototype.setPdfPage = function (page) {
  this.page = page;
};
MMPDFDocument.prototype.pdfLoaded = function (pdf) {
  this.m_pdf = pdf;
  var pgLoader = getPdfPageLoader();
  var pdfIndex = this.getPdfPageIndex();
  pgLoader.getPdfPage(this, pdf, pdfIndex);
};
MMPDFDocument.prototype.getPdfDoc = function () {
  return this.m_pdf;
};
MMPDFDocument.prototype.setPdfDoc = function (pdf) {
  this.m_pdf = pdf;
};
MMPDFDocument.prototype.pageLoaded = function (page) {
  if (this.page != page) {
    this.page = page;
    this.page.pageIndex = this.getPdfPageIndex() - 1;
    this.page.mmobjId = this.getId();

    //notify the objElementsController
    _MMObjElementsController["default"].getSingleInstance().refreshPdf(this);

    //notify the mmo2oEditorView
    // if (MMCommonFun.getO2OEditor()) {
    //     MMCommonFun.getO2OEditor().pageLoaded(this);
    // } else {
    //     //should be android-O2O-Editor
    //     // MDPcMobileEditorCommonFun.getMainEditor().pageLoaded(this);
    // }

    for (var i = 0; i < this.waittingQueue.length; i++) {
      var callback = this.waittingQueue[i];
      callback(page);
    }
  }
};

/**
 * draw obj in canvas context
 * @param {CanvasRenderingContext2D} ctx
 * @param {Transformer} trsfm
 * @param pgindex
 * @param {MMRect} rect
 */
MMPDFDocument.prototype.drawObjInRct = function (ctx, trsfm, pgindex, rect, callback) {
  this.getPdfPage(function (page) {
    // you can now use *page* here

    var viewport = page.getViewport(1.0);
    var scale = parseInt($(ctx.canvas).attr("width")) / viewport.width;
    var tmpCanvas = $(ctx.canvas).clone()[0];
    $(tmpCanvas).attr("height", scale * viewport.height + "px");
    viewport = page.getViewport(scale);
    //viewport.offsetX = rect.left;
    var renderContext = {
      canvasContext: tmpCanvas.getContext("2d"),
      viewport: viewport
    };
    page.render(renderContext).then(function () {
      var elementsCtl = _MMObjElementsController["default"].getSingleInstance();
      var canvas = tmpCanvas;
      var img = new Image();
      img.onload = function () {
        //$('body').append($('<img src="' + img.src + '" class="renderPDFDocument:" style="position:absolute;z-index:1000000000000;top:0px;left:0px;">'))

        ctx.drawImage(img, rect.left, rect.top, rect.getWidth(), rect.getHeight());
        if (callback) callback();
      }.bind(this);
      img.onerror = function () {
        if (callback) callback();
      };
      try {
        img.src = canvas.toDataURL();
        return 1;
      } catch (e) {
        if (callback) callback();
      }
    });
  }.bind(this));
  return 1;
  if (this.page != null) {
    var elementsCtl = _MMObjElementsController["default"].getSingleInstance();
    var canvas = elementsCtl.getDivByObj(this);
    var img = new Image();
    img.onload = function () {
      ctx.drawImage(img, rect.left, rect.top, rect.getWidth(), rect.getHeight());
      if (callback) callback();
    };
    img.onerror = function () {
      if (callback) callback();
    };
    try {
      img.src = canvas.toDataURL();
    } catch (e) {
      if (callback) callback();
    }
    return 1;
  }
  return 0;
};
MMPDFDocument.prototype.isPtOn = function (pt, error) {
  if (pt.x >= this.m_rect.left && pt.x <= this.m_rect.right && pt.y >= this.m_rect.top && pt.y <= this.m_rect.bottom) {
    return true;
  }
  return false;
};
MMPDFDocument.prototype.getLowPixelFilePathForO2O = function () {
  var _pdfDocData = this.getObjData();
  return _pdfDocData.getFilePath_Original();
};
MMPDFDocument.prototype.setShowingOriginFile = function (showOrigin) {};
MMPDFDocument.prototype.isShowingOriginFile = function () {
  return true;
};
MMPDFDocument.prototype.getThumbnailUrl = function (useCurrentVersion, size) {
  size = size ? size : 200;
  size = parseInt(size);
  var version = this.getFileVersion();
  var fileId = this.m_board.getStringId();
  var index = this.getPageIndex();
  var param = "fileId=" + fileId + "&size=" + size + "&version=" + version + "&index=" + index;
  var thumbUrl = "/netdrive/downloadThumbnail.do?" + param;
  return thumbUrl;
};

/**
 * @param {MMPoint}
 */
MMPDFDocument.prototype.setOriginSize = function (newOriginSize) {
  console.assert(newOriginSize instanceof _MMPoint["default"], "newOriginSize need to be MMPoint");
  this.originSize = newOriginSize;
};
MMPDFDocument.prototype.getDispFilePath = function () {
  // test
  //    return '/img/test.numbers';
  //    return 'http://test.babel.cc/29409/document/b_7193670126124560/0/7193670126124560_convert.pdf?Expires=1453444549&OSSAccessKeyId=N1lYconeXg3A7acj&Signature=wqeOPQ%2BKJI3wAtyUQTebYdpfRDE%3D';
  // end

  if (this.inTesting) {
    return this.m_filePath;
  }
  var ver_ = this.getFileVersion();
  if (ver_ < 0) {
    ver_ = 0;
  }
  var _ret = "";
  if (this.m_filePath != undefined && this.m_filePath.length > 0) {}
  var name = this.m_board.displayName;
  var ext = name.split(".").pop();
  ext = ext.toLowerCase();
  if (ext == "heic" || ext == "webp" || ext == "avif") {
    return MMCommonFun.getImageDispPath(this.m_board.getStringId(), ver_);
  } else {
    return MMCommonFun.getDocumentDispPath(this.m_board.getStringId(), ver_);
  }

  // if (_ret.length == 0){
  //     var param = "fileId="+this.m_board.getStringId()+"&version="+ver_;
  //     if (window.location.host) {
  //         var _ret = "/netdrive/getDisplayDocumentUrl.do?"+param;
  //         return _ret ;
  //     }

  //     var _ret = "http://192.168.2.17:9090/getDisplayDocumentUrl.do?"+param;
  //     return _ret ;
  // }
};
MMPDFDocument.prototype.isPng = function () {
  return false;
};
MMPDFDocument.prototype.getDispSVGFilePath = function (callback) {
  var ver_ = this.getFileVersion();
  if (ver_ < 0) {
    ver_ = 0;
  }
  var _ret = "";
  if (this.m_filePath != undefined && this.m_filePath.length > 0) {}
  MMCommonFun.getDownloadRealPath(this.m_board.getStringId(), ver_, function (path) {
    callback(path);
  });
};
MMPDFDocument.prototype.clearPdfPage = function () {
  this.page = null;
  this.waittingQueue.splice(0, this.waittingQueue.length);
};
var _default = exports["default"] = MMPDFDocument;

},{"1000":1000,"1084":1084,"1184":1184,"1432":1432,"1438":1438,"1454":1454,"1466":1466,"830":830,"893":893,"897":897}],897:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1432);
require(1421);
require(1541);
require(1412);
require(1417);
require(1463);
require(1437);
var _MMCommonFun = _interopRequireDefault(require(812));
var _map = _interopRequireDefault(require(821));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDLoadMaskView = _interopRequireDefault(require(49));
var _MMPrintServiveView = _interopRequireDefault(require(899));
/*
 * mashx 延迟加载，需要将这段代码作为一个公共函数
 */

function loadScript(url, callback) {
  var script = document.createElement("script");
  script.type = "text/javascript";
  if (typeof callback != "undefined") {
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (script.readyState == "loaded" || script.readyState == "complete") {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {
      script.onload = function () {
        callback();
      };
    }
  }
  script.src = url;
  document.body.appendChild(script);
}
jQuery.cachedScript = function (url, options) {
  // allow user to set any option except for dataType, cache, and url
  options = $.extend(options || {}, {
    dataType: "script",
    cache: true,
    url: url
  });

  // Use $.ajax() since it is more flexible than $.getScript
  // Return the jqXHR object so we can chain callbacks
  return jQuery.ajax(options);
};
if (!Array.prototype.at) {
  Array.prototype.at = function (index) {
    if (index < 0) {
      return this[this.length + index];
    } else {
      return this[index];
    }
  };
}

// if (!String.prototype.replaceAll) {
//   String.prototype.replaceAll = function (old, now) {
//     return this.split(old).join(now);
//   };
// }
//  // Usage 用法
//  $.cachedScript("ajax/test.js").done(function(script, textStatus) {
//     console.log( textStatus );
//  });

var g_pdfLoader = null;
var g_pdf_loaded = false;
window.g_pdfLoader = g_pdfLoader;
window.g_pdf_loaded = g_pdf_loaded;
function getMMPdfLoader() {
  if (g_pdfLoader == null) {
    g_pdfLoader = new MMPdfLoader();
  }
  return g_pdfLoader;
}
window.getMMPdfLoader = getMMPdfLoader;
var MMUrl2PdfObjs = function MMUrl2PdfObjs() {
  this.url = null; // String
  this.objs = new Array(); // MMPdfDocument
};
window.MMUrl2PdfObjs = MMUrl2PdfObjs;
var MMPdfLoader = function MMPdfLoader() {
  this.waitPdfBuffer = new Array(); // MMUrl2PdfObjs

  this.pdfUrls = new Array(); // String
  this.pdfs = new Array(); // pdf
};
MMPdfLoader.prototype.clear = function () {
  this.waitPdfBuffer.splice(0, this.waitPdfBuffer.length);
  this.pdfUrls.splice(0, this.pdfUrls.length);
  this.pdfs.splice(0, this.pdfs.length);
  if (g_pageLoader) g_pageLoader.clear();
};
MMPdfLoader.prototype.getPdfByUrl = function (obj, url, password) {
  var index = this.pdfUrls.indexOf(url);
  if (index == -1) {
    var waitIndex = -1;
    for (var i = 0; i < this.waitPdfBuffer.length; i++) {
      var url2pdfObjs = this.waitPdfBuffer[i];
      if (url2pdfObjs.url == url) {
        waitIndex = i;
        var objIndex = url2pdfObjs.objs.indexOf(obj);
        if (objIndex == -1) {
          url2pdfObjs.objs.push(obj);
        }
        break;
      }
    }
    if (waitIndex == -1) {
      var url2Objs = new MMUrl2PdfObjs();
      url2Objs.url = url;
      url2Objs.objs.push(obj);
      url2Objs.password = password;
      this.waitPdfBuffer.push(url2Objs);
      if (this.waitPdfBuffer.length == 1) {
        this.loadPdfForFirst();
      }
    }
  } else {
    var pdf = this.pdfs[index];
    obj.pdfLoaded(pdf);
  }
};
MMPdfLoader.prototype.loadPdfForFirst = function () {
  var that = this;
  var timeoutHandler = null;
  var loadDoc = function loadDoc() {
    if (that.waitPdfBuffer.length > 0) {
      var url2Objs = that.waitPdfBuffer[0];
      var password = url2Objs.password;
      _MDLoadMaskView["default"].show();
      _MMCommonFun["default"].getRealRequestURL(url2Objs.url, function (realURL) {
        console.log("---------> load pdf:" + realURL);

        // PDFJS.disableWorker = true;

        if (that.task) {
          var x = 0;
        }
        that.task = pdfjsLib.getDocument({
          url: realURL,
          cMapUrl: pdfjsLib.cMapUrl,
          cMapPacked: pdfjsLib.cMapPacked,
          disableRange: true
        });
        that.task.onPassword = password;
        that.task.onProgress = function (param) {
          Dispatcher.trigger(MDEvents.DOWNLOAD_PROGRESS, param.loaded / param.total);
          if (param.loaded == param.total) {
            timeoutHandler = setTimeout(function () {
              // MDSnackbarView.showStandardMsg(43);
              _MDLoadMaskView["default"].remove();
              that.pdfLoaded();
            }, 1000 * 50);
          }
        };
        that.task.promise.then(function (pdf) {
          timeoutHandler && clearTimeout(timeoutHandler);
          _MDLoadMaskView["default"].remove();
          that.pdfLoaded(pdf);
        }, function () {
          timeoutHandler && clearTimeout(timeoutHandler);
          _MDLoadMaskView["default"].remove();
          that.pdfLoaded();
        })["catch"](function (err) {
          timeoutHandler && clearTimeout(timeoutHandler);
          _MDLoadMaskView["default"].remove();
          that.pdfLoaded();
        });
      }, function (error) {
        if (error.code == 207) {
          app.redirectToLogin();
        } else {
          if (error.code == 227 || error.code == 4) {
            _MDSnackbarView["default"].show(error.msg);
          } else if (error.code == 141) {
            _MDSnackbarView["default"].showStandardMsg(42);
          } else {
            _MDSnackbarView["default"].show(error.code + ":" + BabelStr.str(7370));
          }
          _MDLoadMaskView["default"].remove();
          if (that.waitPdfBuffer.length > 0) {
            var url2Objs = that.waitPdfBuffer.shift();
            if (that.waitPdfBuffer.length > 0) {
              that.loadPdfForFirst();
            }
          }
        }
      });
    }
  };
  MMPdfLoader.ensurePDFJS(loadDoc);
};

//***************************************************************************************************
//                                                  *
//  get pdf
//
//**

MMPdfLoader.prototype.loadPdfPageForWhiteboard = function (pdfPageObjs, password, setBoardPdfUrl, callback, progress) {
  var that = this;
  if (pdfPageObjs.length == 0) {
    if (callback) {
      callback();
    }
    return;
  }
  var pdfUrl = pdfPageObjs[0].getDispFilePath();
  var loadDoc = function loadDoc() {
    if (pdfPageObjs.length > 1) {
      progress(0);
    }
    setBabelTimeout(function () {
      _MMCommonFun["default"].getRealRequestURL(pdfUrl, function (realURL) {
        _.isFunction(setBoardPdfUrl) && setBoardPdfUrl(realURL);
        console.log("---------> load pdf:" + realURL);
        if (that.task) {
          var x = 0;
        }
        // PDFJS.disableWorker = true;
        //
        //
        that.task = pdfjsLib.getDocument({
          url: realURL,
          cMapUrl: pdfjsLib.cMapUrl,
          cMapPacked: pdfjsLib.cMapPacked,
          disableRange: true
        });
        that.task.onPassword = password;
        that.task.onProgress = function (param) {
          var percent = param.loaded / param.total * 0.9;
          if (progress && !isNaN(percent)) {
            progress(percent);
          }
        };
        that.task.promise.then(function (pdf) {
          // webViewerLoad(pdf)
          var pgCount = pdfPageObjs.length;
          var pdfNumPages = pdf.numPages;
          if (pgCount != pdfNumPages) {
            console.error("document error!");
            progress(1);
            if (callback) {
              callback();
            }
          } else {
            for (var i = 0; i < pdfPageObjs.length; i++) {
              var obj = pdfPageObjs[i];
              obj.setPdfDoc(pdf);
            }
            that.loadPageOneByOne(pdf, pdfPageObjs, 0, function () {
              if (callback) {
                callback();
              }
            }, progress);
          }
        })["catch"](function (error) {
          if (callback) {
            callback();
          }
        });
      }, function () {
        if (callback) {
          callback(true);
        }
      });
    }, 0);
  };
  MMPdfLoader.ensurePDFJS(loadDoc);
};

//   that.task = PDFJS.getDocument(realURL, undefined, password , ).then(function(pdf) {

//     // webViewerLoad(pdf)
//     var pgCount = pdfPageObjs.length;
//     var pdfNumPages = pdf.numPages;
//     if (pgCount != pdfNumPages) {
//       console.error('document error!');
//       progress(1);
//       if (callback) {
//         callback();
//       };
//     } else {
//       for (var i = 0; i < pdfPageObjs.length; i++) {
//         var obj = pdfPageObjs[i];
//         obj.setPdfDoc(pdf);
//       };
//       that.loadPageOneByOne(pdf, pdfPageObjs, 0, function() {
//         if (callback) {
//           callback();
//         };
//       }, progress)

//     }

//   }, function() {
//     if (callback) {
//       callback();
//     };
//   }).catch(function(error){
//     if (callback) {
//       callback();
//     };
//   });
// }, function() {
//   if (callback) {
//     callback();
//   };
// });

MMPdfLoader.prototype.loadPdfPageForNoboard = function (board, pdfObjs, editorViewCtl, setBoardPdfUrl, callback, progress) {
  var that = this;
  this.editorViewCtl = editorViewCtl;
  var file = board.getFileInfo();
  var fileId = file.getFileId();
  var version = board.getCurVersion();
  var pdfUrl = "/netdrive/getDisplayDocumentUrl.do?fileId=".concat(fileId, "&version=").concat(version);
  var loadDoc = function loadDoc() {
    setBabelTimeout(function () {
      _MMCommonFun["default"].getRealRequestURL(pdfUrl, function (realURL) {
        _.isFunction(setBoardPdfUrl) && setBoardPdfUrl(realURL);
        console.log("---------> load pdf:" + realURL);
        if (that.task) {
          var x = 0;
        }
        that.task = pdfjsLib.getDocument({
          url: realURL,
          cMapUrl: pdfjsLib.cMapUrl,
          cMapPacked: pdfjsLib.cMapPacked,
          password: file.getPassowrdByVersion(version),
          disableRange: true
        });
        that.task.onProgress = function (param) {
          var percent = param.loaded / param.total * 0.9;
          if (progress && !isNaN(percent)) {
            progress(percent);
          }
        };
        that.task.promise.then(function (pdf) {
          that.pdfLoaded(pdf);
          var pdfNumPages = pdf.numPages;
          that.loadPageOneByOneForNoBoard(pdf, pdfObjs, pdfNumPages, 0, function () {
            if (callback) {
              callback();
            }
          }, progress);
        })["catch"](function (error) {
          if (callback) {
            callback();
          }
        });
      }, function () {
        if (callback) {
          callback(true);
        }
      });
    }, 0);
  };
  MMPdfLoader.ensurePDFJS(loadDoc);
};
MMPdfLoader.prototype.loadPageOneByOneForNoBoard = function (pdf, pdfObjs, pdfNumPages, pgIndex, callback, progress) {
  var that = this;
  pdf.getPage(pgIndex + 1).then(function (page) {
    if (pdfObjs[pgIndex]) {
      pdfObjs[pgIndex].setPdfPage(page);
      pdfObjs[pgIndex].setPdfDoc(pdf);
    }
    var scale = 1;
    var viewport = page.getViewport(scale);
    // Support HiDPI-screens.
    var outputScale = window.devicePixelRatio || 1;
    var parent = $(that.editorViewCtl.containerDiv);
    // var canvas = parent.find('.scroll-content canvas')
    // if(!canvas.length) {
    var canvas = $("<canvas class='pdf-layer' style='background-color:rgba(255, 255, 255, 1.0)'></canvas>");
    parent.find(".scroll-content").append(canvas);
    // }
    canvas = canvas[0];
    // var canvas = document.getElementById('the-canvas');
    var context = canvas.getContext("2d");
    var pw = parent.width();
    var left = 0;
    if (pw > viewport.width) {
      left = (pw - viewport.width) / 2;
    }
    canvas.width = Math.floor(viewport.width * outputScale);
    canvas.height = Math.floor(viewport.height * outputScale);
    canvas.style.width = Math.floor(viewport.width) + "px";
    canvas.style.height = Math.floor(viewport.height) + "px";
    canvas.style["margin-left"] = Math.floor(left) + "px";
    var transform = outputScale !== 1 ? [outputScale, 0, 0, outputScale, 0, 0] : null;
    var renderContext = {
      canvasContext: context,
      transform: transform,
      viewport: viewport
    };
    page.render(renderContext).promise.then(function () {
      if (pgIndex < pdfNumPages - 1) {
        that.loadPageOneByOneForNoBoard(pdf, pdfObjs, pdfNumPages, pgIndex + 1, callback, progress);
      } else {
        callback();
      }
      if (progress) {
        if (pdfNumPages > 1) {
          progress(0.9 + pgIndex / (pdfNumPages - 1) / 10);
        }
      }
    })["catch"](function (e) {
      console.log(e);
    });
  }, function error(res) {
    _MDSnackbarView["default"].show(BabelStr.str(5157));
    console.log(res);
    if (callback) {
      callback();
    }
  }, function () {
    console.error("111111111");
  });
};
MMPdfLoader.prototype.loadPageOneByOne = function (pdf, pdfPageObjs, pgIndex, callback, progress) {
  var that = this;
  var pgCount = pdfPageObjs.length;
  pdf.getPage(pgIndex + 1).then(function (page) {
    pdfPageObjs[pgIndex].setPdfPage(page);
    if (pgIndex < pgCount - 1) {
      that.loadPageOneByOne(pdf, pdfPageObjs, pgIndex + 1, callback, progress);
    } else {
      callback();
    }
    if (progress) {
      if (pgCount > 1) {
        progress(0.9 + pgIndex / (pgCount - 1) / 10);
      }
    }
  }, function error() {
    _MDSnackbarView["default"].show(BabelStr.str(5157));
    if (callback) {
      callback();
    }
  }, function () {
    console.error("111111111");
  });
};

//**
//
//  get pdf end
//                                                  *
//***************************************************************************************************

/**
 * this method makes sure that pdfJS is loaded and can be used globaly
 */
MMPdfLoader.ensurePDFJS = function (callback) {
  if (!g_pdf_loaded) {
    // Usage 用法
    if (!app.isDebug()) {
      // if(true){
      console.log("start load pdf-mini.js  ");
      // $.ajax({
      //   url: window.staticSrc + "/dist/js/pdf-mini.js",
      //   dataType: "script",
      //   success: function(data, textStatus) {
      //     console.log('pdf-mini.js loaded');
      //     console.log( data ); // Data returned
      //     console.log( textStatus ); // Success
      //     PDFJS.workerSrc = window.staticSrc + '/dist/js/pdfwork-mini.js';
      //     PDFJS.cMapUrl = window.staticSrc + '/javascript/vendor/pdf_js/web/cmaps/';
      //     PDFJS.cMapPacked = true;
      //     g_pdf_loaded = true;
      //     callback();
      //     console.log('pdf-mini.js loaded-----------');
      //   },
      //   error:function(request,msg,e){
      //     console.log( "request:",request ); // Data returned
      //     console.log( "msg:",msg ); //
      //     console.log( "e:",e ); //

      //   }
      // });

      loadScript(window.staticSrc + "/dist/js/pdf-mini.js", function (script, textStatus) {
        console.log("pdf-mini.js loaded");
        pdfjsLib.GlobalWorkerOptions.workerSrc = window.staticSrc + "/dist/js/pdfwork-mini.js";
        pdfjsLib.cMapUrl = window.staticSrc + "/dist/cmaps/";
        pdfjsLib.cMapPacked = true;
        g_pdf_loaded = true;
        callback();
      });
    } else {
      loadScript(window.staticSrc + "/javascript/vendor/pdf_js/build/pdf.js", function (script, textStatus) {
        // PDFJS.workerSrc = window.staticSrc + '/javascript/vendor/pdf_js/build/pdf.worker.js';
        pdfjsLib.GlobalWorkerOptions.workerSrc = window.staticSrc + "/javascript/vendor/pdf_js/build/pdf.worker.js";
        pdfjsLib.cMapUrl = window.staticSrc + "/dist/cmaps/";
        pdfjsLib.cMapPacked = true;
        g_pdf_loaded = true;
        callback();
      });
      // .done(function() {
      //   var {TextLayerBuilder} = require(window.staticSrc + '/javascript/vendor/pdf_js/build/text_layer_builder.js')
      //   window.TextLayerBuilder = TextLayerBuilder
      // });
    }
  } else {
    //timeout, to execute the callback allways async.
    setBabelTimeout(callback, 0);
  }
};
MMPdfLoader.pdfLoaded = function (pdf) {
  getMMPdfLoader().pdfLoaded(pdf);
};
MMPdfLoader.prototype.pdfLoaded = function (pdf) {
  var that = this;
  if (pdf) {
    getPdfPageLoader().getAllPagesForPdf(pdf, function () {
      if (that.waitPdfBuffer.length > 0) {
        var url2Objs = that.waitPdfBuffer.shift();
        that.pdfUrls.push(url2Objs.url);
        that.pdfs.push(pdf);
        for (var i = 0; i < url2Objs.objs.length; i++) {
          var obj = url2Objs.objs[i];
          obj.pdfLoaded(pdf);
        }
        if (that.waitPdfBuffer.length > 0) {
          that.loadPdfForFirst();
        }
      }
    });
  } else {
    // pdf 为空，则尝试下一个
    if (that.waitPdfBuffer.length > 0) {
      that.waitPdfBuffer.shift();
      if (that.waitPdfBuffer.length > 0) {
        that.loadPdfForFirst();
      }
    }
  }
};

/**************************************************************************************************************************************/

var g_pageLoader = null;
window.g_pageLoader = g_pageLoader;
function getPdfPageLoader() {
  if (g_pageLoader == null) {
    g_pageLoader = new MMPdfPageLoader();
  }
  return g_pageLoader;
}
window.getPdfPageLoader = getPdfPageLoader;
/**
 * �???? pdf ?????��?��????? page ??????�?
 */
var Map_PdfPages = function Map_PdfPages() {
  this.pdfs = new Array();
  this.mapPdfIndex2Page = new _map["default"](); // map pdf & index to pdf's page
};
Map_PdfPages.prototype.clear = function () {
  this.pdfs.splice(0, this.pdfs.length);
  var values = this.mapPdfIndex2Page.getValues();
  for (var i = 0; i < values.length; i++) {
    values[i].clear();
  }
  this.mapPdfIndex2Page.clear();
};
Map_PdfPages.prototype.findPdf = function (pdf) {
  var index = -1;
  for (var i = 0; i < this.pdfs.length; i++) {
    if (pdf == this.pdfs[i]) {
      index = i;
      break;
    }
  }
  return index;
};
Map_PdfPages.prototype.getPdfPage = function (pdf, pgIndex) {
  var index = this.findPdf(pdf);
  var page = undefined;
  if (index != -1) {
    var index2page = this.mapPdfIndex2Page.get(index);
    if (index2page != undefined) {
      var p = index2page.get(pgIndex);
      if (p != undefined) {
        page = p;
      }
    }
  }
  return page;
};
Map_PdfPages.prototype.addPdfPage = function (pdf, pgIndex, page) {
  var index = this.findPdf(pdf);
  if (index == -1) {
    this.pdfs.push(pdf);
    index = this.pdfs.length - 1;
  }
  var index2page = this.mapPdfIndex2Page.get(index);
  if (index2page == undefined) {
    index2page = new _map["default"]();
    index2page.set(pgIndex, page);
    this.mapPdfIndex2Page.set(index, index2page);
  } else {
    index2page.set(pgIndex, page);
  }
};

/**
 * 记�?? pdf page ?????��?��??
 */
var MMPageWaitInfo = function MMPageWaitInfo() {
  this.pdf = null; // pdf
  this.pageIndex = null; // pdf's page index
  this.objs = new Array(); // page index ?????��?��??
};

//-------------------------------------------------------- MMPdfPageLoader  ------------------------

var MMPdfPageLoader = function MMPdfPageLoader() {
  this.waitPageBuffer = new Array(); // MMPageWaitInfo

  this.pdf_pages = new Map_PdfPages(); // 已�??�?载�???????? pdf 页信???�?Struct_PdfPages;
};
MMPdfPageLoader.prototype.clear = function () {
  this.waitPageBuffer.splice(0, this.waitPageBuffer.length);
  this.pdf_pages.clear();
};
MMPdfPageLoader.prototype.getPageOneByOne = function (pdf, pgIndex, pgCount, callback) {
  var that = this;
  pdf.getPage(pgIndex).then(function (page) {
    that.pdf_pages.addPdfPage(pdf, pgIndex, page);
    if (pgIndex < pgCount) {
      that.getPageOneByOne(pdf, pgIndex + 1, pgCount, callback);
    } else {
      callback();
    }
  });
};
MMPdfPageLoader.prototype.getAllPagesForPdf = function (pdf, callback) {
  var pgCount = pdf.numPages;
  var i = 1;
  _MDLoadMaskView["default"].show();
  this.getPageOneByOne(pdf, 1, pgCount, function () {
    _MDLoadMaskView["default"].remove();
    if (callback) {
      callback();
    }
  });
};
MMPdfPageLoader.prototype.getPdfPage = function (obj, pdf, pgIndex) {
  var page = this.pdf_pages.getPdfPage(pdf, pgIndex);
  if (page != undefined) {
    obj.pageLoaded(page);
  } else {
    var index = -1;
    for (var i = 0; i < this.waitPageBuffer.length; i++) {
      var info = this.waitPageBuffer[i]; // MMPageWaitInfo
      if (info.pdf == pdf && info.pageIndex == pgIndex) {
        // 已�???????��?��?�页???请�????��??�?�?
        index = i;
        var objIndex = _MMCommonFun["default"].findObjInArray(info.objs, obj);
        if (objIndex == -1) {
          info.objs.push(obj); // 注�??为�??�??????��??
        }
        break;
      }
    }
    if (index == -1) {
      // 没�??人�?��??该页�???????�?�?�????请�???????��??�???????
      var wait_info = new MMPageWaitInfo();
      wait_info.pdf = pdf;
      wait_info.pageIndex = pgIndex;
      wait_info.objs.push(obj);
      this.waitPageBuffer.push(wait_info);
      if (this.waitPageBuffer.length == 1) {
        this.loadPageForFirstWaiting();
      }
    }
  }
};
MMPdfPageLoader.prototype.loadPageForFirstWaiting = function () {
  if (this.waitPageBuffer.length > 0) {
    var wait_info = this.waitPageBuffer[0];
    var pdf = wait_info.pdf;
    var i = wait_info.pageIndex;
    console.log("-----> request pdf page:" + i + "--" + new Date().getTime());
    pdf.getPage(i).then(function (page) {
      console.log("<----- return pdf page:" + page["pageIndex"] + " --" + new Date().getTime());
      var pgLoader = getPdfPageLoader();
      pgLoader.pageLoaded(page);
    });
  }
};

//MMPdfPageLoader.pageLoaded = function(page){
//  var pgLoader = getPdfPageLoader();
//  pgLoader.pageLoaded(page);
//};

MMPdfPageLoader.prototype.pageLoaded = function (page) {
  var wait_info = this.waitPageBuffer.shift();
  this.pdf_pages.addPdfPage(wait_info.pdf, wait_info.pageIndex, page);
  this.loadPageForFirstWaiting();
  for (var i = 0; i < wait_info.objs.length; i++) {
    wait_info.objs[i].pageLoaded(page);
  }
};
var _default = exports["default"] = MMPdfLoader;

},{"1184":1184,"1412":1412,"1417":1417,"1421":1421,"1432":1432,"1437":1437,"1454":1454,"1463":1463,"1541":1541,"49":49,"72":72,"812":812,"821":821,"899":899}],899:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1438);
require(1463);
require(1471);
require(1423);
require(1487);
require(1538);
require(1545);
require(1543);
require(1417);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMViewBase2 = _interopRequireDefault(require(22));
var _MMPrintProgressView = _interopRequireDefault(require(898));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MMPrintServiveView = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(MMPrintServiveView, _MMViewBase);
  function MMPrintServiveView() {
    (0, _classCallCheck2["default"])(this, MMPrintServiveView);
    return _callSuper(this, MMPrintServiveView, arguments);
  }
  (0, _createClass2["default"])(MMPrintServiveView, [{
    key: "tmpl",
    value: function tmpl() {}
  }, {
    key: "className",
    value: function className() {}
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MMPrintServiveView.prototype), "events", this).call(this);
      return _.extend(superE, {});
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MMPrintServiveView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        l10n: "zh-cn",
        editor: null
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      // super.initialize(props);
      Dispatcher.off('beforePrint');
      Dispatcher.off('afterPrint');
      Dispatcher.on('beforePrint', this.beforePrint, this);
      Dispatcher.on('afterPrint', this.afterPrint, this);
      this.PDFPrintServiceFactory = {
        instance: {
          supportsPrinting: false,
          createPrintService: function createPrintService() {
            throw new Error('Not implemented: createPrintService');
          }
        }
      };
      window.activeService = null;
      var overlayManager = null;
      var print = window.print;
      var overlayPromise;
      window.print = this.print;
      var self = this;
      this.PDFPrintServiceFactory.instance = {
        supportsPrinting: true,
        createPrintService: function createPrintService(pdfDocument, pagesOverview, printContainer, l10n, progressView) {
          if (window.activeService) {
            throw new Error('The print service is created and active.');
          }
          window.activeService = new self.PDFPrintService(pdfDocument, pagesOverview, printContainer, l10n, progressView);
          return window.activeService;
        }
      };
      this.PDFPrintService.prototype = {
        layout: function layout() {
          this.throwIfInactive();
          var body = document.querySelector('body');
          body.setAttribute('data-pdfjsprinting', true);

          // let hasEqualPageSizes = this.pagesOverview.every(function(size) {
          //   return size.width === this.pagesOverview[0].width &&
          //          size.height === this.pagesOverview[0].height;
          // }, this);
          // if (!hasEqualPageSizes) {
          //   console.warn('Not all pages have the same size. The printed ' +
          //                'result may be incorrect!');
          // }

          this.pageStyleSheet = document.createElement('style');
          var pageSize = this.pagesOverview[0];
          this.pageStyleSheet.textContent =
          // "size:<width> <height>" is what we need. But also add "A4" because
          // Firefox incorrectly reports support for the other value.
          '@supports ((size:A4) and (size:1pt 1pt)) {' + '@page { size: ' + pageSize.width + 'pt ' + pageSize.height + 'pt;}' + '}';
          body.appendChild(this.pageStyleSheet);
        },
        destroy: function destroy() {
          if (window.activeService !== this) {
            // |window.activeService| cannot be replaced without calling destroy() first,
            // so if it differs then an external consumer has a stale reference to
            // us.
            return;
          }
          this.printContainer.textContent = '';
          if (this.pageStyleSheet && this.pageStyleSheet.parentNode) {
            this.pageStyleSheet.parentNode.removeChild(this.pageStyleSheet);
            this.pageStyleSheet = null;
          }
          this.scratchCanvas.width = this.scratchCanvas.height = 0;
          this.scratchCanvas = null;
          window.activeService = null;
          // ensureOverlay().then(function() {
          //   if (overlayManager.active !== 'printServiceOverlay') {
          //     return; // overlay was already closed
          //   }
          //   overlayManager.close('printServiceOverlay');
          // });
        },
        renderPages: function renderPages(editor) {
          var _this = this;
          var self = this;
          // let pageCount = this.pagesOverview.length;
          var pageCount = this.pdfDocument.numPages;
          var renderNextPage = function renderNextPage(resolve, reject) {
            _this.throwIfInactive();
            if (++_this.currentPage >= pageCount) {
              _this.progressView.remove();
              _this.progressView = null;
              resolve();
              return;
            }
            var index = _this.currentPage;
            _this.progressView.progressChanged(index / pageCount);
            self.renderPage(_this, _this.pdfDocument, index + 1, _this.pagesOverview[index], editor).then(self.useRenderedPage.bind(_this)).then(function () {
              renderNextPage(resolve, reject);
            }, reject);
          };
          return new Promise(renderNextPage);
        },
        renderPage: function renderPage(activeServiceOnEntry, pdfDocument, pageNumber, size, editor) {
          var scratchCanvas = window.activeService.scratchCanvas;
          // size = {
          //   width: 500,
          //   height: 600,
          //   rotation: 0
          // };
          var CSS_UNITS = 1.333;
          var PRINT_RESOLUTION = 150;
          var PRINT_UNITS = PRINT_RESOLUTION / 72.0;
          scratchCanvas.width = Math.floor(size.width * PRINT_UNITS);
          scratchCanvas.height = Math.floor(size.height * PRINT_UNITS);

          // The physical size of the img as specified by the PDF document.
          var width = Math.floor(size.width * CSS_UNITS) + 'px';
          var height = Math.floor(size.height * CSS_UNITS) + 'px';
          var ctx = scratchCanvas.getContext('2d');
          ctx.save();
          ctx.fillStyle = 'rgb(255, 255, 255)';
          ctx.fillRect(0, 0, scratchCanvas.width, scratchCanvas.height);
          ctx.restore();
          return pdfDocument.getPage(pageNumber).then(function (pdfPage) {
            var renderContext = {
              canvasContext: ctx,
              transform: [PRINT_UNITS, 0, 0, PRINT_UNITS, 0, 0],
              viewport: pdfPage.getViewport({
                scale: 1,
                rotation: size.rotation
              }),
              intent: 'print'
            };
            return pdfPage.render(renderContext).promise;
          }).then(function () {
            MMCommonFun.drawWaterMark(ctx, scratchCanvas, editor);
            return {
              width: width,
              height: height
            };
          });
        },
        useRenderedPage: function useRenderedPage(printItem) {
          this.throwIfInactive();
          var img = document.createElement('img');
          img.style.width = printItem.width;
          img.style.height = printItem.height;
          var scratchCanvas = this.scratchCanvas;
          if ('toBlob' in scratchCanvas) {
            scratchCanvas.toBlob(function (blob) {
              img.src = URL.createObjectURL(blob);
            });
          } else {
            img.src = scratchCanvas.toDataURL();
          }
          var wrapper = document.createElement('div');
          wrapper.appendChild(img);
          $("iframe.printContainer").contents().find('body').append(wrapper);
          return new Promise(function (resolve, reject) {
            img.onload = resolve;
            img.onerror = reject;
          });
        },
        performPrint: function performPrint() {
          var _this2 = this;
          this.throwIfInactive();
          return new Promise(function (resolve) {
            // Push window.print in the macrotask queue to avoid being affected by
            // the deprecation of running print() code in a microtask, see
            // https://github.com/mozilla/pdf.js/issues/7547.
            setBabelTimeout(function () {
              if (!_this2.active) {
                resolve();
                return;
              }
              $("iframe.printContainer")[0].contentWindow.print();
              // print.call(window);
              // Delay promise resolution in case print() was not synchronous.
              setBabelTimeout(resolve, 20); // Tidy-up.
            }, 0);
          });
        },
        get active() {
          return this === window.activeService;
        },
        throwIfInactive: function throwIfInactive() {
          // if (!this.active) {
          //   throw new Error('This print request was cancelled or completed.');
          // }
        }
      };
    }
  }, {
    key: "printPdf",
    value: function printPdf(pdfDocument, pdfInfo, progressView, editor) {
      this.either = editor;
      $("body .printContainer").remove();
      $("body").append("<iframe class = \"printContainer f-hide\"></iframe>");
      this.pagesOverview = pdfInfo;
      this.pdfDocument = pdfDocument;
      this.progressView = progressView;
      // new MMPrintProgressView({
      //   fileName: fileInfo.getFileName()
      // });
      this.webViewerPrint(editor);
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MMPrintServiveView.prototype), "viewDidRendered", this).call(this);
      this.getEnterpriseWaterMark();
    }
  }, {
    key: "webViewerPrint",
    value: function webViewerPrint(editor) {
      window.print(editor);
    }
  }, {
    key: "beforePrint",
    value: function beforePrint() {
      if (this.printService) {
        return;
      }
      // if (!this.supportsPrinting) {
      //   this.l10n.get('printing_not_supported', null,
      //                 'Warning: Printing is not fully supported by ' +
      //                 'this browser.').then((printMessage) => {
      //     this.error(printMessage);
      //   });
      //   return;
      // }
      var printContainer = $("iframe.printContainer");
      var printService = this.PDFPrintServiceFactory.instance.createPrintService(this.pdfDocument, this.pagesOverview, printContainer, this.l10n, this.progressView);
      this.printService = printService;
      // this.forceRendering();

      printService.layout();

      // if (typeof PDFJSDev !== 'undefined' &&
      //     PDFJSDev.test('FIREFOX || MOZCENTRAL')) {
      //   this.externalServices.reportTelemetry({
      //     type: 'print',
      //   });
      // }
    }
  }, {
    key: "afterPrint",
    value: function afterPrint() {
      if (this.printService) {
        this.printService.destroy();
        this.printService = null;
      }
      $("iframe.printContainer").remove();
      // this.forceRendering();
    }
  }, {
    key: "PDFPrintService",
    value: function PDFPrintService(pdfDocument, pagesOverview, printContainer, l10n, progressView) {
      this.pdfDocument = pdfDocument;
      this.pagesOverview = pagesOverview;
      this.printContainer = printContainer;
      this.l10n = l10n || null;
      this.currentPage = -1;
      this.progressView = progressView;
      // The temporary canvas where renderPage paints one page at a time.
      this.scratchCanvas = document.createElement('canvas');
    }
  }, {
    key: "print",
    value: function print(editor) {
      var self = this;
      if (window.activeService) {
        console.warn('Ignored window.print() because of a pending print job.');
        return;
      }
      // ensureOverlay().then(function() {
      //   if (window.activeService) {
      //     overlayManager.open('printServiceOverlay');
      //   }
      // });

      try {
        Dispatcher.trigger('beforePrint');
      } finally {
        // if (!window.activeService) {
        //   console.error('Expected print service to be initialized.');
        // ensureOverlay().then(function() {
        //   if (overlayManager.active === 'printServiceOverlay') {
        //     overlayManager.close('printServiceOverlay');
        //   }
        // });
        //   return; // eslint-disable-line no-unsafe-finally
        // }
        var activeServiceOnEntry = window.activeService;
        window.activeService.renderPages(editor).then(function () {
          return activeServiceOnEntry.performPrint();
        })["catch"](function (e) {
          console.error(e);
          if (activeServiceOnEntry.active) {
            if (window.activeService) {
              window.activeService.destroy();
              Dispatcher.trigger('afterPrint');
            }
          }
        }).then(function () {
          // aborts acts on the "active" print request, so we need to check
          // whether the print request (activeServiceOnEntry) is still active.
          // Without the check, an unrelated print request (created after aborting
          // this print request while the pages were being generated) would be
          // aborted.
          if (activeServiceOnEntry.active) {
            if (window.activeService) {
              window.activeService.destroy();
              Dispatcher.trigger('afterPrint');
            }
          }
        });
      }
    }

    // renderProgress(index, total, l10n) {
    //   let progressContainer = document.getElementById('printServiceOverlay');
    //   let progress = Math.round(100 * index / total);
    //   let progressBar = progressContainer.querySelector('progress');
    //   let progressPerc = progressContainer.querySelector('.relative-progress');
    //   progressBar.value = progress;
    //   l10n.get('print_progress_percent', { progress, }, progress + '%').
    //       then((msg) => {
    //     progressPerc.textContent = msg;
    //   });
    // }
  }, {
    key: "ensureOverlay",
    value: function ensureOverlay() {
      if (!overlayPromise) {
        overlayManager = PDFViewerApplication.overlayManager;
        if (!overlayManager) {
          throw new Error('The overlay manager has not yet been initialized.');
        }
        overlayPromise = overlayManager.register('printServiceOverlay', document.getElementById('printServiceOverlay'), abort, true);
        document.getElementById('printCancel').onclick = abort;
      }
      return overlayPromise;
    }
  }]);
  return MMPrintServiveView;
}(_MMViewBase2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1417":1417,"1423":1423,"1438":1438,"1454":1454,"1463":1463,"1471":1471,"1475":1475,"1487":1487,"1538":1538,"1543":1543,"1545":1545,"22":22,"898":898}],898:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MMViewBase2 = _interopRequireDefault(require(22));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var _default = exports["default"] = /*#__PURE__*/function (_MMViewBase) {
  (0, _inherits2["default"])(_default, _MMViewBase);
  function _default() {
    (0, _classCallCheck2["default"])(this, _default);
    return _callSuper(this, _default, arguments);
  }
  (0, _createClass2["default"])(_default, [{
    key: "tmpl",
    value: function tmpl() {
      return "\n    <div class=\"print-progress-block\">\n      <div class=\"progress-block\">\n        <div>\n          <span class=\"title\"><%=file%></span>\n        </div>\n        <div class=\"flex-align middle\">\n          <div class=\"progress-wrap progress\" data-progress-percent=\"0\">\n            <div class=\"progress-bar progress\"></div>\n          </div>\n          <div class=\"no-shrink mgl-20  right-block\">\n            <div class=\"cancel \"><%=BabelStr.str(155)%></div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"print-overlayer\"></div>\n    ";
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(_default.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        fileName: "223233",
        fileId: "33",
        cancelCallback: _.noop,
        needDel: false
      });
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(_default.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .cancel': this._cancelClickHandle,
        'click .js-hide': this.close,
        'click .open-progress': this._showProgress
      });
    }
  }, {
    key: "render",
    value: function render(data) {
      data = {
        fileName: this.fileName,
        file: BabelStr.str(7371, {
          fileName: this.fileName
        })
      };
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(_default.prototype), "render", this).call(this, data);
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(_default.prototype), "className", this).call(this);
      return superCls + ' print-block-fix flex-align middle center';
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      // props.modal = false;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(_default.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "moveProgressBar",
    value: function moveProgressBar() {
      console.log("moveProgressBar");
      var getPercent = this.$('.progress-wrap').data('progress-percent');
      if (getPercent == 1) {
        this.$(".progress-bar").hide();
      } else {
        this.$(".progress-bar").show();
      }
      var getProgressWrapWidth = this.$('.progress-wrap').width();
      var progressTotal = getPercent * getProgressWrapWidth;
      var animationLength = 400;
      this.$('.progress-bar').stop().animate({
        left: progressTotal
      }, animationLength);
    }
  }, {
    key: "progressChanged",
    value: function progressChanged(progress) {
      this.$('.progress-wrap').data('progress-percent', progress);
      this.moveProgressBar();
    }

    // _cancelClickHandle() {
    //   let alert = new MDAlertView();
    //   alert.show({
    //     title: BabelStr.str(170),
    //     message: BabelStr.str(3292, {"name": this.fileName}),
    //     buttons: [{
    //       label: BabelStr.str(3096),
    //       type: 'done',
    //       onClick: () => {
    //         this._cancelEditFileInClient(this.fileId);
    //         this.cancelCallback(this.fileId)
    //         // console.error("已取消文件"+this.fileName+"的下载")
    //       }
    //     }, {
    //       label: BabelStr.str(155)
    //     }]
    //   });
    // }
  }, {
    key: "show",
    value: function show() {
      $("body").append(this.$el);
    }
  }, {
    key: "remove",
    value: function remove() {
      $("body").find(".print-block-fix").remove();
    }
  }, {
    key: "_cancelClickHandle",
    value: function _cancelClickHandle(fileId) {
      Dispatcher.trigger('afterPrint');
      this.remove();
      console.error("提前结束打印");
    }
  }]);
  return _default;
}(_MMViewBase2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1417":1417,"1454":1454,"1463":1463,"1475":1475,"22":22}],884:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMOperation = _interopRequireDefault(require(873));
var _MMPoint = _interopRequireDefault(require(830));
function MMScalingOperation(opareationManager) {
  _MMOperation["default"].call(this);
  this.m_operationManager = opareationManager;
  this.oc = opareationManager;
  this.corner = this.oc.getCtrPointIndexFor('scale', this.oc.m_selectedObjs[0]);
  this.oposideCorner = (this.corner + 4) % 8;
  this.m_startPoint = new _MMPoint["default"](-1, -1);
  this.m_lastPoint = new _MMPoint["default"](-1, -1);
}
MMScalingOperation.prototype = new _MMOperation["default"]();
MMScalingOperation.superclass = _MMOperation["default"].prototype;

/**
 * @param point {MMPoint} an LGPoint
 */
MMScalingOperation.prototype.onMouseDown = function (point) {
  this.m_startPoint = point;
};

/**
 * @param point {MMPoint} an LGPoint
 */
MMScalingOperation.prototype.onMouseMove = function (point) {
  var obj = this.oc.m_selectedObjs[0];
  var data = obj.getObjData();
  var ctrPoints = data.get8ArrCtrlPoints();
  var center = ctrPoints[this.oposideCorner].clone();
  var scale = this.calcScale(point, center);
  //example for transformation
  //object_.transform(this.m_option[index_], this.m_basePt, scale, this.m_angleInfect, 0, offset);
  this.oc.ctx.globalAlpha = 0.5;
  obj.transform(undefined, center.clone(), scale.clone(), false, 0, new _MMPoint["default"](0, 0));
  var renderPoints = obj.getObjData().get8ExpandArrCtrlPoints(this.oc.getTransformer().dv2lgLen(this.oc.boundingboxExpansion));
  this.oc.drawPointsClosed(renderPoints, null, this.oc.borderColor, 2);
  var inverseScale = new _MMPoint["default"](1 / scale.x, 1 / scale.y);
  obj.transform(undefined, center.clone(), inverseScale, false, 0, new _MMPoint["default"](0, 0));
  this.oc.ctx.globalAlpha = 1;
};
MMScalingOperation.prototype.calcScale = function (currentPoint, obj) {
  var obj = this.oc.m_selectedObjs[0];
  var data = obj.getObjData();
  var ctrPoints = data.get8ArrCtrlPoints();
  var center = ctrPoints[this.oposideCorner].clone();
  if (center.distanceTo(currentPoint) < this.oc.getTransformer().dv2lgLen(this.oc.boundingboxExpansion) + 0.7) {
    currentPoint = this.m_lastPoint;
  }
  this.m_lastPoint = currentPoint;
  var startDistanceX = Math.abs(center.x - this.m_startPoint.x);
  var startDistanceY = Math.abs(center.y - this.m_startPoint.y);
  var endDistanceX = Math.abs(center.x - currentPoint.x);
  var endDistanceY = Math.abs(center.y - currentPoint.y);
  endDistanceX = endDistanceX = endDistanceX < 0.3 ? 0.4 : endDistanceX;
  endDistanceY = endDistanceY = endDistanceY < 0.3 ? 0.4 : endDistanceY;
  var scaleX = endDistanceX / startDistanceX;
  var scaleY = endDistanceY / startDistanceY;
  var scale = new _MMPoint["default"](scaleX, scaleY);

  // set a minimum scale
  scale.x = scale.x < 0.1 ? 0.1 : scale.x;
  scale.y = scale.y < 0.1 ? 0.1 : scale.y;

  // to keep the aspect ratio
  var type = obj.m_className;
  if (type == 'MMImage' || type == 'MMPDFDocument') {
    scale.x = scale.x > scale.y ? scale.x : scale.y;
    scale.y = scale.x > scale.y ? scale.x : scale.y;
  }
  return scale;
};

/**
 * @param point {MMPoint} an LGPoint
 */
MMScalingOperation.prototype.onMouseUp = function (point, center) {
  var obj = this.oc.m_selectedObjs[0];
  var data = obj.getObjData();
  var ctrPoints = data.get8ArrCtrlPoints();
  var center = ctrPoints[this.oposideCorner].clone();
  var scale = this.calcScale(point, obj);
  this.oc.getCurrentBoard().m_actionManager.scale(obj, center, scale, true);
  this.m_startPoint = null;
  this.oc.setCurOperation();
};
var _default = exports["default"] = MMScalingOperation;

},{"1184":1184,"1454":1454,"830":830,"873":873}],883:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMOperation = _interopRequireDefault(require(873));
var _MMPoint = _interopRequireDefault(require(830));
function MMRotatingOperation(object_) {
  _MMOperation["default"].call(this);
  this.m_object = object_;
  this.m_startPoint = new _MMPoint["default"](-1, -1);
}
;
MMRotatingOperation.prototype = new _MMOperation["default"]();
MMRotatingOperation.superclass = _MMOperation["default"].prototype;
MMRotatingOperation.prototype.onMouseDown = function (e) {
  MMRotatingOperation.superclass.onMouseDown(e);
  //set m_startPoint here ;
};
MMRotatingOperation.prototype.onMouseMove = function (e) {
  MMRotatingOperation.superclass.onMouseMove(e);
  //draw something on the assist-layer.
};
MMRotatingOperation.prototype.onMouseUp = function (e) {
  MMRotatingOperation.superclass.onMouseUp(e);
};
var _default = exports["default"] = MMRotatingOperation;

},{"1184":1184,"1454":1454,"830":830,"873":873}],871:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMOperation = _interopRequireDefault(require(873));
var _MMPoint = _interopRequireDefault(require(830));
var _MMCommentObj = _interopRequireDefault(require(1005));
var _MMFillType = _interopRequireDefault(require(795));
var _MMColor = _interopRequireDefault(require(794));
/**
 *@param tmp {boolean} if true, the operator is temporare and set to null, when it get hidden
 */
function MMNewTagOperation(oc, tmp) {
  _MMOperation["default"].call(this);
  if (oc == undefined) {
    throw "initialise the eraseOperation with your OC";
  }
  this.m_oc = oc;
  this.temporary = !!tmp;
  this.m_flag = false;
  this.m_movingOperation = null;
  this.m_oc.m_selectedObjs = [];
  this.displayed = false;
}
MMNewTagOperation.prototype = new _MMOperation["default"]();
MMNewTagOperation.superclass = _MMOperation["default"].prototype;
MMNewTagOperation.prototype.onMouseDown = function (lgPoint, obj) {};
MMNewTagOperation.prototype.onMouseMove = function (lgPoint) {};
MMNewTagOperation.prototype.onMouseUp = function (lgPoint, flag_) {
  if (this.isLPOnCurrentPage(lgPoint)) {
    var devicePoint = this.m_oc.getTransformer().lg2dvPoint(lgPoint, this.m_oc.getCurrentFilePageIndex());
    devicePoint = this.m_oc.m_editor.convertPointFromEditor2AssistView(devicePoint, this.m_oc.getCurrentFilePageIndex());
    Dispatcher.trigger(MDEvents.SHOW_COMMENTS);
    this.m_oc.openTagCreationView(lgPoint, devicePoint);
  }
};

/**
 *@param lp {MMPoint} the point to test
 */
MMNewTagOperation.prototype.isLPOnCurrentPage = function (lp) {
  return isLPOnPage(lp, this.m_oc.getCurrentFilePageIndex());
};
MMNewTagOperation.prototype.preDestroy = function () {};
var _default = exports["default"] = MMNewTagOperation;

},{"1005":1005,"1184":1184,"1454":1454,"794":794,"795":795,"830":830,"873":873}],869:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1421);
var _MMOperation = _interopRequireDefault(require(873));
var _MMPoint = _interopRequireDefault(require(830));
function MMErasingOperation(oc) {
  _MMOperation["default"].call(this);
  if (oc === undefined) {
    throw "initialise the eraseOperation with your OC";
  }
  this.m_operationCenter = oc;
  this.m_objectsToErase = [];
  this.pathLGPoints = [];
  this.started = false;
  this.canvas = this.m_operationCenter.m_canvas;
  this.ctx = this.canvas.getContext("2d");
  this.ctx.lineJoin = "round";
}
;
MMErasingOperation.prototype = new _MMOperation["default"]();
MMErasingOperation.superclass = _MMOperation["default"].prototype;
MMErasingOperation.prototype.onMouseDown = function (lgPoint) {
  this.pathLGPoints = [];
  this.pathLGPoints.push(lgPoint);
  this.m_objectsToErase = this.m_operationCenter.getObjectsAtLGPoint(lgPoint);
  this.started = true;
};
MMErasingOperation.prototype.onMouseMove = function (lgPoint) {
  var that = this;
  if (this.started) {
    this.pathLGPoints.push(lgPoint);
    this.addObjectUnique(this.m_operationCenter.getObjectsAtLGPoint(lgPoint, this.m_objectsToErase));
    this.drawRemovePathTo();
  }
};
MMErasingOperation.prototype.onMouseUp = function (lgPoint) {
  this.pathLGPoints = [];
  this.m_operationCenter.setCurOperation();
  this.m_operationCenter.getCurrentBoard().m_actionManager.deleteObject(this.m_objectsToErase);
  this.m_objectsToErase = [];
};
MMErasingOperation.prototype.drawRemovePathTo = function () {
  var i = this.m_objectsToErase.length;
  this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
  this.ctx.globalAlpha = 0.5;
  while (i--) {
    var points;
    switch (this.m_objectsToErase[i].getClassName()) {
      case "MMText":
        points = this.m_objectsToErase[i].getObjData().m_arrCtrlPts;
        this.m_operationCenter.drawPointsClosed(points, "#555555", null);
        break;
      case "MMScribble":
        this.m_objectsToErase[i].draw(this.ctx, this.m_operationCenter.getTransformer(), this.m_operationCenter.getCurrentFilePageIndex());
        break;
      default:
        points = this.m_objectsToErase[i].getObjData().m_arrCtrlPts;
        this.m_operationCenter.drawPointsClosed(points, "#ffffff", null);
    }
  }
  this.ctx.globalAlpha = 1;
  if (this.pathLGPoints[0]) {
    this.ctx.beginPath();
    this.ctx.strokeStyle = "#aaaaaa";
    this.ctx.lineWidth = 5;
    var devicePoint = this.m_operationCenter.getTransformer().lg2dvPoint(this.pathLGPoints[0], this.m_operationCenter.getCurrentFilePageIndex());
    devicePoint = this.m_operationCenter.m_editor.convertPointFromEditor2AssistView(devicePoint);
    this.ctx.moveTo(devicePoint.x, devicePoint.y);
    for (i = 0; i < this.pathLGPoints.length; i++) {
      devicePoint = this.m_operationCenter.getTransformer().lg2dvPoint(this.pathLGPoints[i], this.m_operationCenter.getCurrentFilePageIndex());
      devicePoint = this.m_operationCenter.m_editor.convertPointFromEditor2AssistView(devicePoint);
      this.ctx.lineTo(devicePoint.x, devicePoint.y);
    }
    this.ctx.stroke();
  }
};
MMErasingOperation.prototype.addObjectUnique = function (objs) {
  for (var i = 0; i < objs.length; i++) {
    if (this.m_objectsToErase.indexOf(objs[i]) === -1) {
      this.m_objectsToErase.push(objs[i]);
    }
  }
};
var _default = exports["default"] = MMErasingOperation;

},{"1184":1184,"1421":1421,"1454":1454,"830":830,"873":873}],867:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDLineWidthAndFont = _interopRequireDefault(require(861));
var _MDColorDisk = _interopRequireDefault(require(856));
var _MMOperation = _interopRequireDefault(require(873));
var _MMPoint = _interopRequireDefault(require(830));
var _MDEvents = _interopRequireDefault(require(325));
var _MMColor = _interopRequireDefault(require(794));
var _MMRectangle = _interopRequireDefault(require(1026));
var _MMStrokeType = _interopRequireDefault(require(798));
var _BoardOrientation = _interopRequireDefault(require(802));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
function MMDrawRectOperation(oc) {
  _MMOperation["default"].call(this);
  if (oc === undefined) {
    throw "initialise the eraseOperation with your OC";
  }
  this.m_operationCenter = oc;
  this.started = false;
  this.startPoint = undefined;
  this.endPoint = undefined;
  this.canvas = this.m_operationCenter.m_canvas;
  this.ctx = this.canvas.getContext("2d");
}
;
MMDrawRectOperation.prototype = new _MMOperation["default"]();
MMDrawRectOperation.superclass = _MMOperation["default"].prototype;
MMDrawRectOperation.prototype.onMouseDown = function (lgPoint) {
  this.started = true;
  this.startPoint = lgPoint;
};
MMDrawRectOperation.prototype.onMouseMove = function (lgPoint) {
  if (this.started && this.moveEnough) {
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.ctx.strokeStyle = _MDColorDisk["default"].getCurColor();
    this.ctx.lineWidth = _MDLineWidthAndFont["default"].getCurLineWidth();
    var _width = Math.abs(lgPoint.devicePoint.x - this.startPoint.devicePoint.x);
    var _height = Math.abs(lgPoint.devicePoint.y - this.startPoint.devicePoint.y);
    var _startX = Math.min(lgPoint.devicePoint.x, this.startPoint.devicePoint.x);
    var _startY = Math.min(lgPoint.devicePoint.y, this.startPoint.devicePoint.y);
    this.ctx.strokeRect(_startX, _startY, _width, _height);
  }
};
MMDrawRectOperation.prototype.onMouseUp = function (lgPoint) {
  if (!this.started) {
    return;
  }
  ;
  this.started = false;
  var mainEditor = _MDPcMobileEditorCommonFun["default"].getMainEditor();
  if (!mainEditor) return;
  var curTask = mainEditor.getCurrentBoard();
  if (!curTask || !this.moveEnough) return;
  this.endPoint = lgPoint;
  var trsfm = this.m_operationCenter.getTransformer();
  var pageIndex = this.m_operationCenter.getCurrentFilePageIndex();
  var _startX = Math.min(lgPoint.x, this.startPoint.x);
  var _startY = Math.min(lgPoint.y, this.startPoint.y);
  var _endX = Math.max(lgPoint.x, this.startPoint.x);
  var _endY = Math.max(lgPoint.y, this.startPoint.y);
  var _startPoint = new _MMPoint["default"](_startX, _startY);
  var _endPoint = new _MMPoint["default"](_endX, _endY);
  var pathDVPoints = [];
  var _startDV = trsfm.lg2dvPoint(_startPoint, pageIndex);
  var _endDV = trsfm.lg2dvPoint(_endPoint, pageIndex);
  pathDVPoints.push(_startDV);
  pathDVPoints.push(_endDV);
  var rect = new _MMRectangle["default"](curTask);
  rect.setDevOrientation(_BoardOrientation["default"].Portrait);
  rect.setDevPts(trsfm, pathDVPoints, pageIndex);
  var _strokeType = new _MMStrokeType["default"]();
  var dvLineW = _MDLineWidthAndFont["default"].getCurLineWidth();
  var lgLineW = trsfm.dv2lgLen(dvLineW);
  _strokeType.setLineWidth(lgLineW);
  var _color = new _MMColor["default"]();
  _color.fromString(_MDColorDisk["default"].getCurColor());
  _strokeType.setLineColor(_color);
  rect.setStrokeType(_strokeType);
  this.m_operationCenter.m_editor.clearOpLayer();
  var option = {
    toUndo: true,
    realtime: false,
    isMark_: true
  };
  curTask.m_actionManager.addObject(rect, option);
};
var _default = exports["default"] = MMDrawRectOperation;

},{"1026":1026,"1184":1184,"1454":1454,"325":325,"794":794,"798":798,"802":802,"807":807,"830":830,"856":856,"861":861,"873":873}],866:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDGraphDrawer = _interopRequireDefault(require(806));
var _MDLineWidthAndFont = _interopRequireDefault(require(861));
var _MDColorDisk = _interopRequireDefault(require(856));
var _MMOperation = _interopRequireDefault(require(873));
var _MMPoint = _interopRequireDefault(require(830));
var _MDEvents = _interopRequireDefault(require(325));
var _BoardOrientation = _interopRequireDefault(require(802));
var _MMColor = _interopRequireDefault(require(794));
var _MMSegment = _interopRequireDefault(require(1029));
var _MMStrokeType = _interopRequireDefault(require(798));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
function MMDrawLineOperation(oc, arrowType) {
  _MMOperation["default"].call(this);
  if (oc === undefined) {
    throw "initialise the eraseOperation with your OC";
  }
  this.m_operationCenter = oc;
  this.started = false;
  this.startPoint = undefined;
  this.endPoint = undefined;
  this.canvas = this.m_operationCenter.m_canvas;
  this.ctx = this.canvas.getContext("2d");
  this.ctx.lineCap = "round";
  this.arrowType = arrowType;
}
;
MMDrawLineOperation.prototype = new _MMOperation["default"]();
MMDrawLineOperation.superclass = _MMOperation["default"].prototype;
MMDrawLineOperation.prototype.onMouseDown = function (lgPoint) {
  this.started = true;
  this.startPoint = lgPoint;
  var mainEditor = _MDPcMobileEditorCommonFun["default"].getMainEditor();
  if (!mainEditor) return;
  var curTask = mainEditor.getCurrentBoard();
  if (!curTask) return;
  this.line = new _MMSegment["default"](curTask);
  this.line.setDevOrientation(_BoardOrientation["default"].Portrait);
  var trsfm = this.m_operationCenter.getAssistTrsfm();
  var pageIndex = this.m_operationCenter.getCurrentFilePageIndex();
  this.pageIndex = pageIndex;
  this.trsfm = trsfm;
  var _strokeType = new _MMStrokeType["default"]();
  var dvLineW = _MDLineWidthAndFont["default"].getCurLineWidth();
  var lgLineW = trsfm.dv2lgLen(dvLineW);
  _strokeType.setLineWidth(lgLineW);
  if (this.arrowType) {
    _strokeType.setArrowType(this.arrowType);
  }
  ;
  var _color = new _MMColor["default"]();
  _color.fromString(_MDColorDisk["default"].getCurColor());
  _strokeType.setLineColor(_color);
  this.line.setStrokeType(_strokeType);
  var _startDV = trsfm.lg2dvPoint(this.startPoint, pageIndex);
  var _endDV = _startDV.clone();
  var pathDVPoints = [_startDV, _endDV];
  this.line.setDevPts(trsfm, pathDVPoints, pageIndex);
  this._startDV = _startDV;
};
MMDrawLineOperation.prototype.onMouseMove = function (lgPoint) {
  if (this.started && this.moveEnough) {
    // this.ctx.beginPath();
    // this.ctx.strokeStyle = MDColorDisk.getCurColor();
    // this.ctx.lineWidth = MDLineWidthAndFont.getCurLineWidth();

    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

    // this.ctx.moveTo(this.startPoint.devicePoint.x, this.startPoint.devicePoint.y);
    // this.ctx.lineTo(lgPoint.devicePoint.x, lgPoint.devicePoint.y);

    // this.ctx.stroke();

    var _endDV = this.trsfm.lg2dvPoint(lgPoint, this.pageIndex);
    var pathDVPoints = [this._startDV, _endDV];
    this.line.setDevPts(this.trsfm, pathDVPoints, this.pageIndex);
    if (this.arrowType == 1) {
      _MDGraphDrawer["default"].drawArrow(this.ctx, _MDColorDisk["default"].getCurColor(), _MDColorDisk["default"].getCurColor(), this._startDV, _endDV);
    } else {
      this.line.drawInCanvas(this.ctx, this.trsfm, this.pageIndex);
    }
  }
};
MMDrawLineOperation.prototype.onMouseUp = function (lgPoint) {
  if (!this.started || !this.moveEnough) {
    return;
  }
  ;
  this.started = false;
  this.endPoint = lgPoint;
  var mainEditor = _MDPcMobileEditorCommonFun["default"].getMainEditor();
  if (!mainEditor) return;
  var curTask = mainEditor.getCurrentBoard();
  if (!curTask) return;

  // var trsfm = this.m_operationCenter.getTransformer();
  // var pageIndex = this.m_operationCenter.getCurrentFilePageIndex();

  // var pathDVPoints = [];

  // var _startDV = trsfm.lg2dvPoint(this.startPoint, pageIndex);
  // var _endDV = trsfm.lg2dvPoint(this.endPoint, pageIndex);
  // pathDVPoints.push(_startDV);
  // pathDVPoints.push(_endDV);

  // var line = new MMSegment(curTask);
  // line.setDevPts(trsfm, pathDVPoints, pageIndex);

  // var _strokeType = new MMStrokeType();
  // var dvLineW = MDLineWidthAndFont.getCurLineWidth();
  // var lgLineW = trsfm.dv2lgLen(dvLineW);
  // _strokeType.setLineWidth(lgLineW);

  // var _color = new MMColor();
  // _color.fromString(MDColorDisk.getCurColor());
  // _strokeType.setLineColor(_color);
  // line.setStrokeType(_strokeType);

  this.m_operationCenter.m_editor.clearOpLayer();
  var option = {
    toUndo: true,
    realtime: false,
    isMark_: true
  };
  curTask.m_actionManager.addObject(this.line, option);
};
var _default = exports["default"] = MMDrawLineOperation;

},{"1029":1029,"1184":1184,"1454":1454,"325":325,"794":794,"798":798,"802":802,"806":806,"807":807,"830":830,"856":856,"861":861,"873":873}],1029:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
var _MDGraphDrawer = _interopRequireDefault(require(806));
var _MMPathDrawer = _interopRequireDefault(require(896));
var _MMGraphics = _interopRequireDefault(require(1013));
var _MMYellowObj = _interopRequireDefault(require(1035));
var _vec = _interopRequireDefault(require(839));
var _ObjType = _interopRequireDefault(require(1084));
var _MMFillType = _interopRequireDefault(require(795));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MMPoint = _interopRequireDefault(require(830));
var _MMStrokeType = _interopRequireDefault(require(798));
/**
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMSegment}
 */
function MMSegment(board) {
  _MMYellowObj["default"].call(this, board); //
  this.m_className = 'MMSegment';
  this.m_objType = _ObjType["default"].GObj_line;
  this.m_isClose = false;
}
;
MMSegment.prototype = new _MMYellowObj["default"](); //
MMSegment.superclass = _MMYellowObj["default"].prototype;
MMSegment.prototype.encode = function (enc_) {
  MMSegment.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMSegment.prototype.decode = function (dec_, ver_) {
  MMSegment.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
MMSegment.prototype.draw = function (ctx, trsfm, pgindex) {
  _MMGraphics["default"].prototype.draw.call(this, ctx, trsfm, pgindex);
};
MMSegment.prototype.drawInCanvas = function (ctx, trsfm, pgindex) {
  var data = this.getObjData();
  if (data == null || data == undefined || data.m_arrPoints == undefined || data.m_arrPoints == null || data.m_arrPoints.length == 0) return;
  if (data.m_strokeType.m_arrowType == 1) {
    var color = data.m_strokeType.m_lineColor;
    var dvP1 = trsfm.lg2dvPoint(data.m_arrPoints[0], pgindex);
    var dvP2 = trsfm.lg2dvPoint(data.m_arrPoints[1], pgindex);
    _MDGraphDrawer["default"].drawArrow(ctx, color.toString(), color.toString(), dvP1, dvP2);
  } else {
    _MMGraphics["default"].prototype.drawInCanvas.call(this, ctx, trsfm, pgindex);
    try {
      var fillType = new _MMFillType["default"]();
      fillType.m_board = data.m_fillType.m_board;
      fillType.m_gradient = data.m_fillType.m_gradient;
      fillType.m_notGradient = data.m_fillType.m_notGradient;
      fillType.m_fillColor = data.m_strokeType.m_lineColor;
      fillType.m_hasFill = true;
      var strokeType = new _MMStrokeType["default"]();
      strokeType.m_lineWidth = data.m_strokeType.m_lineWidth;
      strokeType.setLineColor(data.m_strokeType.m_lineColor);
      var drawer = new _MMPathDrawer["default"](ctx, strokeType, fillType, data.m_shadowType, trsfm, pgindex);
      var pts = data.m_arrPoints;
      var length = pts.length;
      if (length > 1) {
        if (Math.abs(data.m_strokeType.m_arrowType - 1) < 0.00001) {
          var arrowPts = this.getArrowPoints(pts[length - 2], pts[length - 1]);
          drawer.drawPolyline(arrowPts, 0, arrowPts.length, true);
        } else if (Math.abs(data.m_strokeType.m_arrowType - 2) < 0.00001) {
          //画第一个端点
          var arrowEndPts = this.getArrowPoints(pts[length - 2], pts[length - 1]);
          drawer.drawPolyline(arrowEndPts, 0, arrowEndPts.length, true);
          //画第二个端点
          var arrowBeginPts = this.getArrowPoints(pts[length - 1], pts[length - 2]);
          drawer.drawPolyline(arrowBeginPts, 0, arrowBeginPts.length, true);
        }
      }
    } catch (e) {}
  }
};
MMSegment.prototype.getArrowPoints = function (beginPt_, endPt_) {
  var data = this.getObjData();
  var _ratio = data.m_strokeType.m_lineWidth / 0.078125 * 4;
  var vector0 = new _vec["default"](1, 0);
  var vector1 = new _vec["default"](endPt_.x - beginPt_.x, endPt_.y - beginPt_.y);
  var arc = vector0.angleBetweenVector(vector1);
  var _arrowPts = new Array();
  _arrowPts.push(new _MMPoint["default"](endPt_.x, endPt_.y));
  _MMCommonFun["default"].rotateAroundPts(_arrowPts, beginPt_, -arc);

  //重置箭头的大小
  var _arroWidth = 0.1605;
  var _arrowHeight = 0.1003;
  var _arrowShapePts = new Array();
  var _arrowPt = _arrowPts.pop();
  _arrowShapePts.push(new _MMPoint["default"](_arrowPt.x - _arroWidth * _ratio, _arrowPt.y - _arrowHeight * _ratio));
  _arrowShapePts.push(_arrowPt);
  _arrowShapePts.push(new _MMPoint["default"](_arrowPt.x - _arroWidth * _ratio, _arrowPt.y + _arrowHeight * _ratio));
  _MMCommonFun["default"].rotateAroundPts(_arrowShapePts, beginPt_, arc);
  //    MMCommonFun::debugOutput(m_arrPoints, "segment arrow after");
  return _arrowShapePts;
};
MMSegment.prototype.clone = function () {
  var newObj = new MMSegment(this.board);
  newObj.initBy(this);
  return newObj;
};
var _default = exports["default"] = MMSegment;

},{"1013":1013,"1035":1035,"1084":1084,"1184":1184,"1437":1437,"1454":1454,"1463":1463,"1478":1478,"795":795,"798":798,"806":806,"812":812,"830":830,"839":839,"896":896}],863:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMOperation = _interopRequireDefault(require(873));
var _MDEvents = _interopRequireDefault(require(325));
var _MMPoint = _interopRequireDefault(require(830));
function MMBoxSelectingOperation(oc) {
  _MMOperation["default"].call(this);
  if (oc == undefined) {
    throw "initialise the eraseOperation with your OC";
  }
  this.m_operationCenter = oc;
  this.m_startPoint = new _MMPoint["default"](-1, -1);
}
;
MMBoxSelectingOperation.prototype = new _MMOperation["default"]();
MMBoxSelectingOperation.superclass = _MMOperation["default"].prototype;
MMBoxSelectingOperation.prototype.onMouseDown = function (e) {
  //MMBoxSelectingOperation.superclass.onMouseDown(e);
  //set m_startPoint here ;
};
MMBoxSelectingOperation.prototype.onMouseMove = function (e) {
  //MMBoxSelectingOperation.superclass.onMouseMove(e);
  //draw something on the assist-layer.
};
MMBoxSelectingOperation.prototype.onMouseUp = function (e) {
  //MMBoxSelectingOperation.superclass.onMouseUp(e);
  //to-do:handle the operation here.

  //reset current operation
  this.m_operationCenter.setCurOperation();
};
var _default = exports["default"] = MMBoxSelectingOperation;

},{"1184":1184,"1454":1454,"325":325,"830":830,"873":873}],862:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDHandMarkerElController = _interopRequireDefault(require(923));
var _MDOpElType = _interopRequireDefault(require(924));
var _MDOpRectController = _interopRequireDefault(require(918));
// MDTextOperation.js
//
// jiang
// 2017-7-28

function MDTextOperation(operationCenter) {
  var $parentDiv = $(operationCenter.m_editor.getScrollContent());
  var elCtl = _MDHandMarkerElController["default"];
  var editor = operationCenter.m_editor;
  _MDOpRectController["default"].call(this, editor, elCtl, $parentDiv, _MDOpElType["default"].OpText);
  this.className = "MDTextOperation";
}
;
_.extend(MDTextOperation.prototype, _MDOpRectController["default"].prototype, function () {
  //----------------------------------------------------------------------------------------------------
  //       private function
  //----------------------------------------------------------------------------------------------------

  //----------------------------------------------------------------------------------------------------
  //       public function
  //----------------------------------------------------------------------------------------------------

  return {
    contstructor: MDTextOperation,
    construct: function construct() {},
    mouseDown: function mouseDown(e) {
      _MDOpRectController["default"].prototype.mouseDown.call(this, e);
    },
    mouseMove: function mouseMove(e) {
      _MDOpRectController["default"].prototype.mouseMove.call(this, e);
    },
    mouseUp: function mouseUp(e) {
      _MDOpRectController["default"].prototype.mouseUp.call(this, e);
    },
    setImgMarkerCtl: function setImgMarkerCtl(imgMarker) {
      this.imgMarker = imgMarker;
    },
    preDestroy: function preDestroy() {}
  };
}());
var _default = exports["default"] = MDTextOperation;

},{"1184":1184,"1454":1454,"918":918,"923":923,"924":924}],860:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
var _MMOperation = _interopRequireDefault(require(873));
var _MMPoint = _interopRequireDefault(require(830));
var _MMCommentObj = _interopRequireDefault(require(1005));
var _MMFillType = _interopRequireDefault(require(795));
var _MMColor = _interopRequireDefault(require(794));
var _MDNew2DCommentInputView = _interopRequireDefault(require(333));
var _MMMovingOperation = _interopRequireDefault(require(870));
var _MMWeldMark = _interopRequireDefault(require(1034));
var _BoardOrientation = _interopRequireDefault(require(802));
var _MDNetDriveFileHandler = _interopRequireDefault(require(1091));
var _MDSnackbarView = _interopRequireDefault(require(72));
function MDGraphicToolOperation(oc, option) {
  _MMOperation["default"].call(this, option);
  if (oc === undefined) {
    throw "initialise the eraseOperation with your OC";
  }
  this.m_operationCenter = oc;
  this.pathLGPoints = [];
  this.started = false;
  this.canvas = this.m_operationCenter.m_canvas;
  this.ctx = this.canvas.getContext("2d");
  this.ctx.lineJoin = "round";
  this.ctx.lineCap = "round";
  this.editor = this.m_operationCenter.editor;
  this.className = "MDGraphicToolOperation";
  this.activeObj = null; //处于编辑状态的焊接标记数据 动态变量 设备坐标 编辑时改变属性  编辑结束后置空
  this.hoverObj = null; // 处于编辑状态的焊接标记原始数据 静态变量 逻辑坐标 引用 编辑结束后改变属性 置空
  this.isMouseUp = false;
  Dispatcher.on(MDEvents.toolbarChanged, this.saveActiveObj, this);
}
MDGraphicToolOperation.prototype = new _MMOperation["default"]();
MDGraphicToolOperation.superclass = _MMOperation["default"].prototype;
MDGraphicToolOperation.prototype.isInOriginRect = function (point) {
  if (!this.activeObj) {
    return false;
  }
  var oPoint = this.activeObj.oPoint;
  if (point.x < oPoint.x - 10 || point.x > oPoint.x + 10) {
    return false;
  }
  if (point.y < oPoint.y - 10 || point.y > oPoint.y + 10) {
    return false;
  }
  return true;
};
MDGraphicToolOperation.prototype.isInTranslateRect = function (point) {
  if (!this.activeObj) {
    return false;
  }
  var oPoint = this.activeObj.oPoint;
  var tPoint = this.activeObj.tPoint;
  var dirObj = this.activeObj.dirObj;
  oPoint = {
    x: oPoint.x + tPoint.w * dirObj.signX,
    y: oPoint.y + tPoint.h * dirObj.signY
  };
  if (point.x < oPoint.x - 10 || point.x > oPoint.x + 10) {
    return false;
  }
  if (point.y < oPoint.y - 10 || point.y > oPoint.y + 10) {
    return false;
  }
  return true;
};
MDGraphicToolOperation.prototype.clicked = function (logicPoint, editor, hoverObj) {
  if (this.isMouseUp) {
    return;
  }
  var point = this.editor.logic2AssistViewPoint(logicPoint);
  var canvas = this.editor.getAssistantCanvas();
  var ctx = canvas.getContext('2d');
  var tras = this.editor.getDivTransformer();
  var pageIndex = this.m_operationCenter.getCurrentFilePageIndex();
  if (this.activeObj && this.activeObj.active && !_MMWeldMark["default"].isInWeldMarkRect(this.activeObj, point, ctx)) {
    // 编辑状态，在图标所在区域外点击
    this.saveActiveObj();
    // 保存新插入内容
    // let currentBoard = MDPcMobileEditorCommonFun.getMainEditor().getCurrentBoard();   
    // let curDispVer = this.editorViewCtl.getVersionShowing();
    // let fileInfo = this.editorViewCtl.getCurrentFileInfo();
    // let weldMark = this.hoverObj;  
    // let obj = _.clone(this.activeObj);
    // obj.oPoint = this.editor.assistView2LogicPoint(this.activeObj.oPoint) //
    // weldMark.setWeldMarkData(obj)

    // weldMark.setExpandRect(tras, ctx);
    // weldMark.setPageIndex(pageIndex);

    // let data = weldMark.createWeldMarkData();
    // let fileId = fileInfo.getFileId();    
    // MDNetDriveFileHandler.sendBoardDatas(fileId, curDispVer, [data], ()=>{
    //   if(this.hoverObj) {
    //     this.hoverObj.objData.active = false;  
    //   }      
    //   this.m_operationCenter.m_editor.refreshObjsInCanvas(weldMark.getExpandRect());
    //   this.m_operationCenter.m_editor.clearOpLayer();
    //   this.activeObj = null;
    //   this.hoverObj = null;
    //   MDSnackbarView.show(BabelStr.str(2744))
    // }, ()=>{
    //   MDSnackbarView.show(BabelStr.str(3559))
    // })
  } else if (this.activeObj && this.activeObj.active && _MMWeldMark["default"].isInWeldMarkRect(this.activeObj, point, ctx)) {
    this.activeObj.active = true;
    return;
  } else if (!this.hoverObj && this.editor.editorViewCtl.getGraphicToolCreateState()) {
    var fid = this.editorViewCtl.getCurrentFileInfo().getFileId();
    var ver = this.editorViewCtl.getVersionShowing();
    this.editor.editorViewCtl.setGraphicToolCreateState(false);
    Dispatcher.trigger(MDEvents.weldMarkInserted, {
      fid: fid,
      ver: ver
    });
    //新增
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    var dir = _MMWeldMark["default"].getDir(this.canvas, point, {
      x: point.x + 100,
      y: point.y + 100
    });
    var imgId = this.editor.editorViewCtl.getGraphicToolType();
    // this.activeObj = {
    //   oPoint: point, //原点屏幕
    //   tPoint: { w: 100, h: 100 }, // 第二个控制点相对原点的偏移值
    //   dirObj: dir, // 第二个控制点的坐标系所在象限
    //   state: 'done', //'done'： 正常状态, 'translate': 变形状态, 'move': 移动状态      
    //   active: true,
    //   solidSide: {
    //     signId: imgId,
    //     SE: '左侧信息展示(实线侧)',
    //     FCAR: '上方信息展示(实线侧)',
    //     LP: '右侧信息展示(实线侧)',
    //   },
    //   dottedSide: {
    //     signId: imgId,
    //     SE: '左侧信息展示',
    //     FCAR: '下方信息展示',
    //     LP: '右侧信息展示'
    //   },
    //   isFleldWeld : true, // 是否现场焊接
    //   isAllAround: true,  // 是否环绕弓箭周围焊缝
    //   specificAction: '闪光冷焊' // "" , 焊接方法  
    // }
    var currentBoard = MDPcMobileEditorCommonFun.getMainEditor().getCurrentBoard();
    var curDispVer = this.editorViewCtl.getVersionShowing();
    var fileInfo = this.editorViewCtl.getCurrentFileInfo();
    var weldMark = new _MMWeldMark["default"](currentBoard, curDispVer);
    var activeObj = weldMark.getWeldMarkData();
    activeObj.oPoint = this.editor.assistView2LogicPoint(point);
    activeObj.dirObj = dir;
    activeObj.solidSide.signId = imgId;
    activeObj.active = true;
    weldMark.setExpandRect(tras, ctx);
    weldMark.setPageIndex(pageIndex);
    var creatorId = new Int64(app.currentUser.id);
    weldMark.setCreator(creatorId);
    var option = {
      toUndo: false,
      realtime: false,
      isMark_: false
    };
    var self = this;
    self.setActiveObj(weldMark);
    currentBoard.m_actionManager.addObject(weldMark, option);
  } else if (hoverObj) {
    var _activeObj = _.clone(hoverObj.getWeldMarkData());
    _activeObj.oPoint = this.editor.logic2AssistViewPoint(_activeObj.oPoint);
    if (_MMWeldMark["default"].isInWeldMarkRect(_activeObj, point, this.ctx)) {
      this.setActiveObj(hoverObj);
    }
  }
};
MDGraphicToolOperation.prototype.saveActiveObj = function () {
  var _this = this;
  if (!this.activeObj || !this.activeObj.active) {
    return;
  }
  var canvas = this.editor.getAssistantCanvas();
  var ctx = canvas.getContext('2d');
  var tras = this.editor.getDivTransformer();
  var pageIndex = this.m_operationCenter.getCurrentFilePageIndex();
  // 保存新插入内容
  var currentBoard = MDPcMobileEditorCommonFun.getMainEditor().getCurrentBoard();
  var curDispVer = this.editorViewCtl.getVersionShowing();
  var fileInfo = this.editorViewCtl.getCurrentFileInfo();
  var weldMark = this.hoverObj;
  var obj = _.clone(this.activeObj);
  obj.oPoint = this.editor.assistView2LogicPoint(this.activeObj.oPoint); //
  weldMark.setWeldMarkData(obj);
  weldMark.setExpandRect(tras, ctx);
  weldMark.setPageIndex(pageIndex);
  var data = weldMark.createWeldMarkData();
  var fileId = fileInfo.getFileId();
  _MDNetDriveFileHandler["default"].sendBoardDatas(fileId, curDispVer, [data], function () {
    if (_this.hoverObj) {
      _this.hoverObj.objData.active = false;
    }
    _this.m_operationCenter.m_editor.refreshObjsInCanvas(weldMark.getExpandRect());
    _this.m_operationCenter.m_editor.clearOpLayer();
    _this.activeObj = null;
    _this.hoverObj = null;
    _MDSnackbarView["default"].show(BabelStr.str(2744));
  }, function () {
    _MDSnackbarView["default"].show(BabelStr.str(3559));
  });
};
MDGraphicToolOperation.prototype.setActiveObj = function (hoverObj) {
  var activeObj = _.clone(hoverObj.getWeldMarkData());
  activeObj.oPoint = this.editor.logic2AssistViewPoint(activeObj.oPoint);
  this.activeObj = activeObj;
  this.hoverObj = hoverObj;
  this.hoverObj.setActive(true);
  // 清除去以前的
  var rect = this.hoverObj.getExpandRect();
  this.m_operationCenter.m_editor.refreshObjsInCanvas(rect);
  this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
  _MMWeldMark["default"].drawWithDevOpoint(this.ctx, this.activeObj, this.canvas, true, true);
};
MDGraphicToolOperation.prototype.removeObj = function (hoverObj) {
  var _this2 = this;
  var fileInfo = this.editorViewCtl.getCurrentFileInfo();
  var fileId = fileInfo.getFileId();
  var strIds = [hoverObj.getId().toString()];
  _MDNetDriveFileHandler["default"].deleteBoardDataById(fileId, strIds, function () {
    _this2.m_operationCenter.m_editor.clearOpLayer();
    _this2.activeObj = null;
    _this2.hoverObj = null;
  });
};
MDGraphicToolOperation.prototype.onMouseDown = function (logicPoint, obj, e) {
  var point = this.editor.logic2AssistViewPoint(logicPoint);
  this.isMouseUp = false;
  if (this.isInTranslateRect(point)) {
    this.activeObj.state = 'translate';
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    _MMWeldMark["default"].drawWithDevOpoint(this.ctx, this.activeObj, this.canvas, true, true);
    // var img = new Image();
    // img.src = `img/gb/${this.activeObj.solidSide.signId} copy 3.svg`
    // img.onload = () => {
    // let moveObj = _.clone(this.activeObj);
    // moveObj.oPoint = {
    //   x: 0,
    //   y: 0
    // }
    // let moveCanvas = MMWeldMark.createMoveCanvas(moveObj)
    // this.editor.$contentDiv.append(moveCanvas)
    // let $moveCanvas = $(moveCanvas);
    // let lg = MMWeldMark.getTPointXy(this.activeObj)
    // let x = lg.x;
    // if (lg.x < this.activeObj.oPoint.x) {
    //   x -= 102
    // }
    // $moveCanvas.css({
    //   top: lg.y - 40,
    //   left: x
    // })
    // };
  } else if (this.isInOriginRect(point)) {
    this.activeObj.state = 'move';
    _MMWeldMark["default"].drawWithDevOpoint(this.ctx, this.activeObj, this.canvas, true, true);
  }
};
MDGraphicToolOperation.prototype.onMouseMove = function (logicPoint, e, canvas) {
  var point = this.editor.logic2AssistViewPoint(logicPoint);
  if (this.activeObj && this.activeObj.state == 'translate') {
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    var x = point.x;
    if (point.x < this.activeObj.oPoint.x) {
      x -= 102;
    }
    var lg = {
      x: x,
      y: point.y - 40
    };
    var dirObj = _MMWeldMark["default"].getMoveDir(this.activeObj.oPoint, point);
    this.activeObj.dirObj = dirObj;
    this.activeObj.tPoint = {
      w: Math.abs(this.activeObj.oPoint.x - point.x),
      h: Math.abs(this.activeObj.oPoint.y - point.y)
    };
    _MMWeldMark["default"].drawWithDevOpoint(this.ctx, this.activeObj, this.canvas, true, false);
    // var $moveCanvas = $('.move-canvas')
    // $moveCanvas.css({
    //   top: lg.y,
    //   left: lg.x
    // })
  } else if (this.activeObj && this.activeObj.state == 'move') {
    this.activeObj.oPoint = point;
    _MMWeldMark["default"].drawWithDevOpoint(this.ctx, this.activeObj, this.canvas, true, false);
  }
};
MDGraphicToolOperation.prototype.onMouseUp = function (logicPoint, e) {
  if (this.activeObj && this.activeObj.state == 'translate') {
    this.activeObj.state = 'done';
    var point = this.editor.logic2AssistViewPoint(logicPoint);
    this.activeObj.tPoint = {
      w: Math.abs(this.activeObj.oPoint.x - point.x),
      h: Math.abs(this.activeObj.oPoint.y - point.y)
    };
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    _MMWeldMark["default"].drawWithDevOpoint(this.ctx, this.activeObj, this.canvas, true, true);
    // $('.move-canvas').remove()
    this.isMouseUp = true;
  } else if (this.activeObj && this.activeObj.state == 'move') {
    // this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

    // var img = new Image();
    // img.src = `img/gb/${this.activeObj.imgId} copy 3.svg`
    // img.onload = ()=>{
    //   this.drawWithDevOpoint(this.ctx, this.activeObj.oPoint, this, true.activeObj.tPoint.w, this.activeObj.tPoint.h, this.activeObj.dirObj, img)
    // };
    _MMWeldMark["default"].drawWithDevOpoint(this.ctx, this.activeObj, this.canvas, true, true);
    this.isMouseUp = true;
    this.activeObj.state = 'done';
  }
  if (this.hoverObj) {
    var obj = _.clone(this.activeObj);
    obj.oPoint = this.editor.assistView2LogicPoint(this.activeObj.oPoint); //
    this.hoverObj.setWeldMarkData(obj);
  }
};
MDGraphicToolOperation.prototype.divOperation = true;
var _default = exports["default"] = MDGraphicToolOperation;

},{"1005":1005,"1034":1034,"1091":1091,"1184":1184,"1437":1437,"1454":1454,"1463":1463,"1478":1478,"333":333,"72":72,"794":794,"795":795,"802":802,"830":830,"870":870,"873":873}],210:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1438);
var _MMRect = _interopRequireDefault(require(831));
var _MDEvents = _interopRequireDefault(require(325));
var _MDSalonScribble = _interopRequireDefault(require(211));
var _MDGraphDrawer = _interopRequireDefault(require(806));
var _MMCommonFun = _interopRequireDefault(require(812));
// MDSalonPenOperation.js
//
// jiang
// 2017-10-14

function MDSalonPenOperation(operationCenter) {
  this.m_oc = operationCenter;
  this.editor = operationCenter.m_editor;
  this.transformer = this.editor.getCanvasTransformerForAssist(); // 坐标转换器
  this.canvas = this.editor.getAssistantCanvas(); // 绘制图形的 canvas
  this.ctx = this.canvas.getContext('2d');
}
;
var g_minMoveDistance = 5;
_.extend(MDSalonPenOperation.prototype, Object.prototype, function () {
  //----------------------------------------------------------------------------------------------------
  //       private function
  //----------------------------------------------------------------------------------------------------

  //----------------------------------------------------------------------------------------------------
  //       public function
  //----------------------------------------------------------------------------------------------------

  return {
    contstructor: MDSalonPenOperation,
    construct: function construct() {},
    onMouseDown: function onMouseDown(logicPt, overObj, e) {
      console.log('----- graph comment ----- mouse down');
      this.mouseDownCaptured = true;
      var x = e.clientX;
      var y = e.clientY;
      this.pts = [];
      var p = _MMCommonFun["default"].convertPointBetweenElements($('body')[0], this.m_oc.getAssistantCanvas(), {
        x: x,
        y: y
      });
      this.pts.push(p);
      this.startPt = p;

      // this.graphDrawer = new MDGraphDrawer(this.m_oc.getAssistantCanvas(), this.curToolName);
      // this.graphDrawer.mouseDown(p.x, p.y);

      // this.lengthFromStart = 0;

      var pageIndex = this.editor.getCurrentFilePageIndex();
      this.scribble = new _MDSalonScribble["default"](pageIndex);
      this.scribble.addLgPt(logicPt);
      _MDSalonScribble["default"].initCtx(this.ctx);
    },
    onMouseMove: function onMouseMove(logicPt, e, $canvas) {
      var x = e.clientX;
      var y = e.clientY;
      var p = _MMCommonFun["default"].convertPointBetweenElements($('body')[0], this.m_oc.getAssistantCanvas(), {
        x: x,
        y: y
      });

      // 过滤一下，抛弃那些移动距离太近的点，减少点的数量
      var prePt = this.pts[this.pts.length - 1];
      if (Math.abs(prePt.x - p.x) + Math.abs(prePt.y - p.y) < 4) {
        return;
      }
      ;
      this.pts.push(p);
      var focusPoint = p;

      // if (this.graphDrawer) {
      //   focusPoint = this.graphDrawer.mouseMove(p.x, p.y);
      //   this.curRct = null;
      // };

      this.scribble.addLgPt(logicPt);
      var ptNumDrawn = 3;
      var pts = [];
      var k = 0;
      for (var i = this.pts.length - 1; i >= 0 && k < ptNumDrawn; i--) {
        pts.push(this.pts[i]);
        k++;
      }
      ;
      var boundingBox = new _MMRect["default"]();
      boundingBox.initWithPtsBounadingBox(pts);
      boundingBox.shrink(-10);
      this.ctx.save();
      _MMCommonFun["default"].clipContext(this.ctx, boundingBox);
      _MDSalonScribble["default"].initCtx(this.ctx);
      this.ctx.beginPath();
      this.ctx.moveTo(this.startPt.x, this.startPt.y);
      for (var i = 0; i < this.pts.length; i++) {
        var p = this.pts[i];
        this.ctx.lineTo(p.x, p.y);
      }
      ;
      this.ctx.stroke();
      this.ctx.restore();
    },
    onMouseUp: function onMouseUp(logicPt, e) {
      var x = e.clientX;
      var y = e.clientY;
      var p = _MMCommonFun["default"].convertPointBetweenElements($('body')[0], this.m_oc.getAssistantCanvas(), {
        x: x,
        y: y
      });

      // this.lengthFromStart = Math.sqrt((this.startPt.x - p.x)*(this.startPt.x - p.x) + (this.startPt.y - p.y)* (this.startPt.y - p.y))

      // if (this.lengthFromStart < g_minMoveDistance) {
      //   this.mouseDownCaptured = false;
      //   this.graphDrawer = null;
      //   this.clearPanel();
      //   return;
      // };

      this.editor.getCurrentBoard().addSalonScribble(this.scribble);
      if (this.mouseDownCaptured) {
        Dispatcher.trigger(_MDEvents["default"].SALON_PEN_ADD, this.scribble);
      }
      ;
      this.mouseDownCaptured = false;
      var c = this.m_oc.getAssistantCanvas();
      var ctx = c.getContext("2d");
      this.curRct = null;
      this.graphDrawer = null;
      var boundingBox = new _MMRect["default"]();
      boundingBox.initWithPtsBounadingBox(this.pts);
      boundingBox.shrink(-10);
      ctx.clearRect(0, 0, c.offsetWidth, c.offsetHeight);
      this.editor.refreshSalonScribbleInCanvas(boundingBox);
    },
    setImgMarkerCtl: function setImgMarkerCtl(imgMarker) {
      this.imgMarker = imgMarker;
    },
    preDestroy: function preDestroy() {
      this.clearPanel();
    },
    clearPanel: function clearPanel() {
      if (this.m_oc.createCommentView) {
        var createCommentView = this.m_oc.createCommentView;
        createCommentView.hide(function () {
          createCommentView.$el.remove();
          this.clearAssistantCanvas();
          if (createCommentView._$circleParent) createCommentView._$circleParent.remove();
          this.m_oc.createCommentView = null;
        }.bind(this));
      }
    },
    clearAssistantCanvas: function clearAssistantCanvas() {
      var c = this.m_oc.getAssistantCanvas();
      var ctx = c.getContext("2d");
      ctx.clearRect(0, 0, c.offsetWidth, c.offsetHeight);
    },
    _createComment: function _createComment(x, y) {}
  };
}());
var _default = exports["default"] = MDSalonPenOperation;

},{"1184":1184,"1438":1438,"1454":1454,"211":211,"325":325,"806":806,"812":812,"831":831}],203:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
require(1438);
require(1417);
var _MDEvents = _interopRequireDefault(require(325));
var _MDGraphDrawer = _interopRequireDefault(require(806));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MMOperation = _interopRequireDefault(require(873));
var _MDNetDriveFileHandler = _interopRequireDefault(require(1091));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDLocalString = _interopRequireDefault(require(1150));
// MDSalonEraserOperation.js
// javascript/enterprise/view/salon/MDSalonEraserOperation.js
// jiang
// 2017-10-14

function MDSalonEraserOperation(operationCenter, option) {
  _MMOperation["default"].call(this, option);
  this.m_oc = operationCenter;
  this.editor = operationCenter.m_editor;
  this.$contentDiv = this.editor.$contentDiv;
  this.transformer = this.editor.getCanvasTransformerForAssist(); // 坐标转换器
  this.canvas = this.m_oc.getAssistantCanvas(); // 绘制图形的 canvas
  this.ctx = this.canvas.getContext('2d');
  Dispatcher.on(_MDEvents["default"].Mouse_up, this.clearEaraser, this);
}
;
var g_minMoveDistance = 5;
_.extend(MDSalonEraserOperation.prototype, _MMOperation["default"].prototype, function () {
  //----------------------------------------------------------------------------------------------------
  //       private function
  //----------------------------------------------------------------------------------------------------

  //-----------------------------------------        -----------------------------------------------------------
  //       public function
  //----------------------------------------------------------------------------------------------------

  return {
    contstructor: MDSalonEraserOperation,
    construct: function construct() {},
    onMouseDown: function onMouseDown(logicPt, overObj, e) {
      this.startLgPt = logicPt;
      console.log('----- graph comment ----- mouse down');
      this.mouseDownCaptured = true;
      var x = e.clientX;
      var y = e.clientY;
      // this.eraserCanvas = this._createEraserLayer()[0];
      // this.eraserCtx = this.eraserCanvas.getContext("2d");
      var p = _MMCommonFun["default"].convertPointBetweenElements($('body')[0], this.m_oc.getAssistantCanvas(), {
        x: x,
        y: y
      });
      this.startPt = p;
      // this.eraserCtx.moveTo(p.x, p.y);
      console.log("start:x" + p.x + "y" + p.y);
      // this.graphDrawer = new MDGraphDrawer(this.m_oc.getAssistantCanvas(), this.curToolName);
      // this.graphDrawer.mouseDown(p.x, p.y);

      // this.lengthFromStart = 0;
      MDSalonEraserOperation.initCtx(this.ctx);
    },
    onMouseMove: function onMouseMove(logicPt, e, $canvas) {
      var x = e.clientX;
      var y = e.clientY;
      var p = _MMCommonFun["default"].convertPointBetweenElements($('body')[0], this.m_oc.getAssistantCanvas(), {
        x: x,
        y: y
      });
      var focusPoint = p;
      // this.eraserCtx.clearRect(0, 0, this.eraserCanvas.width, this.eraserCanvas.height);
      // this.eraserCtx.lineTo(p.x, p.y);
      // this.eraserCtx.stroke();
      // if (this.graphDrawer) {
      //   focusPoint = this.graphDrawer.mouseMove(p.x, p.y);
      //   this.curRct = null;
      // };
      var c = this.m_oc.getAssistantCanvas();
      var ctx = c.getContext("2d");
      ctx.clearRect(0, 0, c.offsetWidth, c.offsetHeight);
      ctx.beginPath();
      ctx.moveTo(this.startPt.x, this.startPt.y);
      ctx.lineTo(p.x, p.y);
      ctx.stroke();
    },
    onMouseUp: function onMouseUp(logicPt, e) {
      var _this = this;
      var x = e.clientX;
      var y = e.clientY;
      var p = _MMCommonFun["default"].convertPointBetweenElements($('body')[0], this.m_oc.getAssistantCanvas(), {
        x: x,
        y: y
      });
      // this.eraserCtx.clearRect(0, 0, this.eraserCanvas.width, this.eraserCanvas.height);
      // this.lengthFromStart = Math.sqrt((this.startPt.x - p.x)*(this.startPt.x - p.x) + (this.startPt.y - p.y)* (this.startPt.y - p.y))

      // if (this.lengthFromStart < g_minMoveDistance) {
      //   this.mouseDownCaptured = false;
      //   this.graphDrawer = null;
      //   this.clearPanel();
      //   return;
      // };

      var board = this.editor.getCurrentBoard();
      var scribbles = null;
      var hasOthers = false;
      if (this.toolName == "penEraser") {
        var result = board.getMyScribbleIntersectWithSeg(this.startLgPt, logicPt);
        scribbles = result.scribbles;
        hasOthers = result.hasOthers;
      } else {
        scribbles = board.getSalonScribbleIntersectWithSeg(this.startLgPt, logicPt);
      }

      // this.eraserCtx.clearRect(0, 0, this.eraserCanvas.width, this.eraserCanvas.height);
      // $(this.eraserCanvas).hide();

      if (scribbles.length) {
        if (this.toolName == "penEraser") {
          var ids = [];
          var strIds = [];
          var lgRect;
          for (var i = 0; i < scribbles.length; i++) {
            if (!lgRect) {
              lgRect = scribbles[i].getExpandRect();
            } else {
              lgRect.expandToInclude(scribbles[i].getExpandRect());
            }
            var element = scribbles[i];
            ids.push(element.getId());
            strIds.push(element.getId().toString());
          }
          var fileId = board.getFileInfo().getFileId();
          _MDNetDriveFileHandler["default"].deleteBoardDataById(fileId, strIds, function () {
            board.removeObjects(ids);
            _this.editorViewCtl.getPenZoneCtl().refreshData();
            _this.editor.refreshObjsInCanvas(lgRect);
            if (hasOthers) {
              _MDSnackbarView["default"].show(BabelStr.str(5143));
            }
          }, function () {
            _MDSnackbarView["default"].show(BabelStr.str(168));
          });
        } else {
          var ids = _.pluck(scribbles, "id");
          this.editor.getCurrentBoard().removeSolonScribble(ids);
        }
        Dispatcher.trigger(_MDEvents["default"].SALON_EARASER, ids);
        var c = this.m_oc.getAssistantCanvas();
        var ctx = c.getContext("2d");
        ctx.clearRect(0, 0, c.offsetWidth, c.offsetHeight);
        if (this.toolName == 'penEraser') {
          this.editor.refreshObjsInCanvas();
        } else {
          this.editor.refreshSalonScribbleInCanvas();
        }
        console.log('----------> 获得擦除对象:', scribbles.length);
      } else {
        if (hasOthers) {
          _MDSnackbarView["default"].show(BabelStr.str(5143));
        }
      }
      this.mouseDownCaptured = false;
      this.curRct = null;
      this.graphDrawer = null;
      var c = this.m_oc.getAssistantCanvas();
      var ctx = c.getContext("2d");
      ctx.clearRect(0, 0, c.offsetWidth, c.offsetHeight);
    },
    _removeSalonScriblle: function _removeSalonScriblle() {},
    setImgMarkerCtl: function setImgMarkerCtl(imgMarker) {
      this.imgMarker = imgMarker;
    },
    preDestroy: function preDestroy() {
      this.clearPanel();
    },
    clearPanel: function clearPanel() {
      if (this.m_oc.createCommentView) {
        var createCommentView = this.m_oc.createCommentView;
        createCommentView.hide(function () {
          createCommentView.$el.remove();
          this.clearAssistantCanvas();
          if (createCommentView._$circleParent) createCommentView._$circleParent.remove();
          this.m_oc.createCommentView = null;
        }.bind(this));
      }
    },
    clearAssistantCanvas: function clearAssistantCanvas() {
      var c = this.m_oc.getAssistantCanvas();
      var ctx = c.getContext("2d");
      ctx.clearRect(0, 0, c.offsetWidth, c.offsetHeight);
    },
    _createComment: function _createComment(x, y) {},
    _createEraserLayer: function _createEraserLayer() {
      var _this2 = this;
      return null;
      var $layer = this.$contentDiv.find(".eraser-layer");
      if ($layer.length > 0) {
        $layer.show();
      } else {
        var w = this.$contentDiv.width();
        var h = this.$contentDiv.height();
        $layer = $("<canvas class='eraser-layer assist_layer f-selectable' width='" + w + "' height='" + h + "' style='position:absolute;left:0px; top:0px;background-color:rgba(255, 0, 0, 0.0);z-index: 400000001;'></canvas>");
        this.$contentDiv.append($layer);
      }
      $layer.off("mousemove").on("mousemove", function (e) {
        _this2.mouseMove(e);
      });
      $layer.off("mouseup").on("mouseup", function (e) {
        _this2.eraserCtx.clearRect(0, 0, _this2.eraserCanvas.width, _this2.eraserCanvas.height);
        $(_this2.eraserCanvas).hide();
      });
      var eraserCtx = $layer[0].getContext("2d");
      MDSalonEraserOperation.initCtx(eraserCtx);
      return $layer;
    },
    mouseMove: function mouseMove(e) {
      var x = e.clientX;
      var y = e.clientY;
      var p = _MMCommonFun["default"].convertPointBetweenElements($('body')[0], this.m_oc.getAssistantCanvas(), {
        x: x,
        y: y
      });
      var focusPoint = p;
      this.eraserCtx.clearRect(0, 0, this.eraserCanvas.width, this.eraserCanvas.height);
      this.eraserCtx.save();
      this.eraserCtx.beginPath();
      this.eraserCtx.moveTo(this.startPt.x, this.startPt.y);
      console.log(p.x, p.y);
      this.eraserCtx.lineTo(p.x, p.y);
      this.eraserCtx.stroke();
      this.eraserCtx.closePath();
      // if (this.graphDrawer) {
      //   focusPoint = this.graphDrawer.mouseMove(p.x, p.y);
      //   this.curRct = null;
      // };
    },
    clearEaraser: function clearEaraser() {
      this.eraserCtx && this.eraserCtx.clearRect(0, 0, this.eraserCanvas.width, this.eraserCanvas.height);
      $(this.eraserCanvas).hide();
    }
  };
}());
MDSalonEraserOperation.initCtx = function (ctx) {
  ctx.strokeStyle = 'white';
  ctx.shadowBlur = 20;
  ctx.shadowColor = "black";
  ctx.lineWidth = 5;
  ctx.lineCap = "round";
};
var _default = exports["default"] = MDSalonEraserOperation;

},{"1091":1091,"1150":1150,"1184":1184,"1417":1417,"1437":1437,"1438":1438,"1454":1454,"1463":1463,"1478":1478,"325":325,"72":72,"806":806,"812":812,"873":873}],868:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDLineWidthAndFont = _interopRequireDefault(require(861));
var _MDColorDisk = _interopRequireDefault(require(856));
var _MMOperation = _interopRequireDefault(require(873));
var _MMPoint = _interopRequireDefault(require(830));
var _MDEvents = _interopRequireDefault(require(325));
var _BoardOrientation = _interopRequireDefault(require(802));
var _MMColor = _interopRequireDefault(require(794));
var _MMScribble = _interopRequireDefault(require(1028));
var _MMStrokeType = _interopRequireDefault(require(798));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
var _MDPenToolbar = _interopRequireDefault(require(427));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDNetDriveFileHandler = _interopRequireDefault(require(1091));
var _Encoder = _interopRequireDefault(require(800));
/**
 * javascript/molasync-source/operation-controller/MMDrawScribbleOperation.js
 * jiang
 * 2081-10-1
 */

function MMDrawScribbleOperation(oc, option) {
  _MMOperation["default"].call(this, option);
  if (oc === undefined) {
    throw "initialise the eraseOperation with your OC";
  }
  this.m_operationCenter = oc;
  this.pathLGPoints = [];
  this.started = false;
  this.canvas = this.m_operationCenter.m_canvas;
  this.ctx = this.canvas.getContext("2d");
  this.ctx.lineJoin = "round";
  this.ctx.lineCap = "round";
  this.className = "MMDrawScribbleOperation";
}
;
MMDrawScribbleOperation.prototype = new _MMOperation["default"]();
MMDrawScribbleOperation.superclass = _MMOperation["default"].prototype;
MMDrawScribbleOperation.prototype.onMouseDown = function (lgPoint) {
  _MMOperation["default"].prototype.onMouseDown.call(this, null, lgPoint);
  this.ctx.strokeStyle = _MDColorDisk["default"].getCurColor();
  this.pathLGPoints = [];
  this.pathLGPoints.push(lgPoint);
  this.started = true;
};
MMDrawScribbleOperation.prototype.onMouseMove = function (lgPoint, e) {
  var that = this;
  e.preventDefault();
  //e.stopPropagation();
  if (this.started && this.moveEnough) {
    this.pathLGPoints.push(lgPoint);
    this.drawPath();
  }
};
MMDrawScribbleOperation.prototype.onMouseUp = function (lgPoint) {
  if (!this.started) {
    return;
  }
  ;
  this.started = false;
  var trsfm = this.m_operationCenter.getTransformer();
  var pageIndex = this.m_operationCenter.getCurrentFilePageIndex();
  /*
   * mashx: I strongly recommend that we need to initiate the objects by logic points directly...
   */
  var rLen = this.pathLGPoints.length - this.pathLGPoints.length % 3;
  var pathDVPoints = [];
  for (var i = 0; i < rLen; i++) {
    var dvPoint = trsfm.lg2dvPoint(this.pathLGPoints[i], pageIndex);
    pathDVPoints.push(dvPoint);
  }
  var goodPts = _MMScribble["default"].removeInterferenceDvPoints(pathDVPoints);
  var goodOrginMouseLgPts = [];
  for (var i = 0; i < goodPts.length; i++) {
    var lgPoint = trsfm.dv2lgPoint(goodPts[i], pageIndex);
    goodOrginMouseLgPts.push(lgPoint);
  }
  var curDispVer;
  var goodLgPts = _MMScribble["default"].calShapePts(goodOrginMouseLgPts);
  if (goodLgPts.length && this.moveEnough) {
    var currentBoard = this.editorViewCtl.getCurrentBoard();
    var curDispVer = this.editorViewCtl.getVersionShowing();
    var fileInfo = this.editorViewCtl.getCurrentFileInfo();
    var scribble = new _MMScribble["default"](currentBoard, curDispVer);
    scribble.setLogicPts(goodLgPts);
    scribble.setPageIndex(pageIndex);
    scribble.setOriginMouseLgPts(goodOrginMouseLgPts);
    var _strokeType = new _MMStrokeType["default"]();
    var lineWidth = _MDLineWidthAndFont["default"].getCurLineWidth();
    if (this.toolName == "penComment") {
      lineWidth = _MDPenToolbar["default"].getLineWidth();
      scribble.isPenComment = true;
    }
    var lgW = this.m_operationCenter.getTransformer().dv2lgLen(lineWidth);
    _strokeType.setLineWidth(lgW);
    scribble.setOriginLineWidth(lgW); // -------------------  记录原始宽度，用于简介式的新的数据存储
    scribble.setOriginLineDvWidth(lineWidth); // -------------------  记录原始屏幕显示宽度

    var _color = new _MMColor["default"]();
    _color.fromString(_MDColorDisk["default"].getCurColor());
    if (this.toolName == "penComment") {
      _color.fromString(_MDPenToolbar["default"].getColor());
    }
    _strokeType.setLineColor(_color);
    scribble.setOriginLineColor(_MDPenToolbar["default"].getColor()); // -------------------  记录原始颜色，用于简介式的新的数据存储

    scribble.setStrokeType(_strokeType);
    scribble.setDevOrientation(_BoardOrientation["default"].Portrait);
    var option = {
      toUndo: this.canUndo,
      realtime: false,
      isMark_: this.isMarker
    };
    var creatorId = new Int64(app.currentUser.id);
    scribble.setCreator(creatorId);
    _czc && _czc.push(["_trackEvent", "讨论", "创建批注", "自由手绘", "", ""]);
    currentBoard.m_actionManager.addObject(scribble, option);
    if (this.toolName == "penComment") {
      _Dispatcher["default"].trigger(_MDEvents["default"].PenCommentCreated, this.m_operationCenter);

      // 测试存储使用，尽量避免写一笔就保存一次通知一次
      // currentBoard.sendScribbles2Server(curDispVer, function(){
      //   console.log('-------------- save scribbles successfully!');
      // }, function(){
      //   console.error('-------- save scribbles error!');
      // })
    }
  }
  var that = this;
  setBabelTimeout(function () {
    that.m_operationCenter.m_editor.clearOpLayer();
  });
};
MMDrawScribbleOperation.prototype.drawPath = function () {
  this.m_operationCenter.m_editor.drawPathInOpLayer(this.pathLGPoints);
};
var _default = exports["default"] = MMDrawScribbleOperation;

},{"1028":1028,"1091":1091,"1184":1184,"1454":1454,"18":18,"325":325,"427":427,"794":794,"798":798,"800":800,"802":802,"807":807,"830":830,"856":856,"861":861,"873":873}],865:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1438);
require(1412);
require(1461);
require(1437);
var _MMObjOperationStrategy = _interopRequireDefault(require(872));
var _MMBasicData = _interopRequireDefault(require(811));
var _MDAlertView = _interopRequireDefault(require(32));
var _MMOperationType = _interopRequireDefault(require(882));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
var _ObjType = _interopRequireDefault(require(1084));
var _MDWelMarkSettingWindow = _interopRequireDefault(require(438));
var _MMStrokeType = _interopRequireDefault(require(798));
var _MMColor = _interopRequireDefault(require(794));
var _MMPoint = _interopRequireDefault(require(830));
var _MMSignatureFrame = _interopRequireDefault(require(1030));
var _BoardOrientation = _interopRequireDefault(require(802));
var _MDLineWidthAndFont = _interopRequireDefault(require(861));
var _MDColorDisk = _interopRequireDefault(require(856));
var _MDMarkerObjDrawerController = _interopRequireDefault(require(909));
var _MDNetDriveFileHandler = _interopRequireDefault(require(1091));
var _MMSealFrame = _interopRequireDefault(require(886));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDEvents = _interopRequireDefault(require(325));
var _Dispatcher = _interopRequireDefault(require(18));
var MMDesktopContextMenue = {
  /**
   * the domElement that is displayed
   */
  contextManue: null,
  /**
   * the original Method was: MMOperationCenter.prototype.showContextMenue
   * @params {object} e,operationCenter,clickedElements,logicPoint,devicePoint
   * usage: MMDesktopContextMenue.show
   */
  show: function show(params) {
    //return; // disabled in the first online version of net_drive
    var e = params.e;
    var operationCenter = params.operationCenter;
    var clickedElements = params.clickedElements;
    this.logicPoint = params.logicPoint;
    this.devicePoint = params.devicePoint;
    this.operationCenter = operationCenter;
    this.pageView = params.pageView;
    var curTask = _MDPcMobileEditorCommonFun["default"].getMainEditor().getCurrentBoard();
    var pageIndex = operationCenter.getCurrentFilePageIndex();
    requestAnimationFrame(function () {
      var _this = this;
      this.close();
      this._addwindowHandler();
      if (clickedElements[0]) {
        operationCenter.m_selectedObjs = [clickedElements[0]];
      } else {
        operationCenter.m_selectedObjs = [];
      }
      var selectionCanBeDeleted = false;
      if (operationCenter.m_selectedObjs[0]) selectionCanBeDeleted = _MMObjOperationStrategy["default"].getOperataionTypeForMolaTask(operationCenter.m_selectedObjs[0], pageIndex) === _MMOperationType["default"].Operation_editable;
      var template = '<div id="MMOperationCenterContextMenue" class="f-noselect"' + 'style="top:' + e.pageY + 'px;left:' + (e.pageX + 3) + 'px;"></div>';
      this.contextMenu = $(template);
      // document.body.appendChild(this.contextMenu[0]);
      $('.app-root').append(this.contextMenu);

      //this.contextMenu.hide();
      //this.contextMenu.show(200);
      var that = this;
      var closeFullscreenItem = null;
      if (operationCenter.mode !== 'FULLSCREEN') {
        if (!operationCenter.m_selectedObjs.length || operationCenter.m_selectedObjs[0] && _MMObjOperationStrategy["default"].getOperataionTypeForMolaTask(operationCenter.m_selectedObjs[0], pageIndex) !== _MMOperationType["default"].Operation_editable) {
          this.contextMenu.append(this._createContextMenueEntry(BabelStr.str(32), true));
        } else {
          var $contextMenueDeleteEntry = this._createContextMenueEntry(BabelStr.str(32));
          $contextMenueDeleteEntry.on('click', function () {
            that.close();
            operationCenter.deleteSelectedObjects();
          });
          this.contextMenu.append($contextMenueDeleteEntry);
        }
      }
      var _obj = operationCenter.hoverObjs[0];
      if (_obj && !app.pathRouter.inTrash()) {
        var _opType = _MMObjOperationStrategy["default"].getOperataionTypeForMolaTask(_obj, pageIndex);
        var _objType = _obj.getObjType();
        if (_objType == _ObjType["default"].Obj_weldMark) {
          var weldMark = operationCenter.hoverObjs[0];
          if (!weldMark.objData.active) {
            return;
          }
        }

        // 签名可以移动，但不能删除
        // if (_objType != ObjType.Obj_signatureFrame && (_opType === MMOperationType.Operation_editable || _opType === MMOperationType.Operation_deletable)) {
        if (_objType != _ObjType["default"].Obj_signatureFrame && _objType != _ObjType["default"].Obj_seal && (_opType === _MMOperationType["default"].Operation_editable || _opType === _MMOperationType["default"].Operation_deletable)) {
          //show delete entry
          var deleteEntry = this._createContextMenueEntry(BabelStr.str(32)); //next
          deleteEntry.on('click', function () {
            operationCenter.getCurrentBoard().m_actionManager.deleteObject(operationCenter.hoverObjs[0], {
              toUndo: false,
              realtime: true
            });
            _Dispatcher["default"].trigger(_MDEvents["default"].Comment_changed);
            _Dispatcher["default"].trigger(_MDEvents["default"].Comment_State_Sync, curTask.fileInfo.getFileId(), pageIndex);
            _Dispatcher["default"].trigger(_MDEvents["default"].COMMENT_REMOVE, curTask, pageIndex);
            if (_objType == _ObjType["default"].Obj_weldMark) {
              operationCenter.m_curOperation.removeObj(operationCenter.hoverObjs[0]);
            }
          });
          this.contextMenu.append(deleteEntry);
        }
        if (_objType == _ObjType["default"].Obj_seal || _objType == _ObjType["default"].Obj_signatureFrame && curTask.fileInfo.isNormalSig()) {
          var canEdit = _opType === _MMOperationType["default"].Operation_editable || _opType === _MMOperationType["default"].Operation_deletable;

          //show delete entry
          var deleteEntry = this._createSigDeleteMenu(canEdit, _obj.user, _obj); //next
          deleteEntry.on('click', function ($e) {
            if (!$($e.target).hasClass("del")) {
              return;
            }
            _this._delSig(curTask.fileInfo.getFileId(), _obj.fileVersion, _obj.getSealedId(), function () {
              operationCenter.getCurrentBoard().m_actionManager.deleteObject(_obj, {
                toUndo: false,
                realtime: true
              });
              _Dispatcher["default"].trigger(_MDEvents["default"].Comment_changed);
              _Dispatcher["default"].trigger(_MDEvents["default"].Comment_State_Sync, curTask.fileInfo.getFileId(), pageIndex);
              _Dispatcher["default"].trigger(_MDEvents["default"].COMMENT_REMOVE, curTask, pageIndex);
              _Dispatcher["default"].trigger(_MDEvents["default"].fileSealChanged, {
                fileId: curTask.fileInfo.getFileId(),
                version: _obj.fileVersion
              });
            });
            _MDMarkerObjDrawerController["default"].clearFocus();
          });
          this.contextMenu.append(deleteEntry);
          _MDMarkerObjDrawerController["default"].focus(this.pageView, _obj);
        }
        if (_objType == _ObjType["default"].Obj_weldMark) {
          var editEntry = this._createContextMenueEntry(BabelStr.str(2503)); //next
          editEntry.on('click', function () {
            _MDWelMarkSettingWindow["default"].show(operationCenter.hoverObjs[0], function () {
              var weldMark = operationCenter.hoverObjs[0];
              weldMark.objData.active = true;
              operationCenter.editor.refreshObjsInCanvas(weldMark.getExpandRect());
              operationCenter.m_curOperation.setActiveObj(weldMark);
            });
          });
          this.contextMenu.append(editEntry);
        }
      } else {
        var board = operationCenter.getCurrentBoard();
        if (board && (board.isCADFile() || board.canChangeBackground())) {
          if (board && board.isCADFile()) {
            if (_objType == _ObjType["default"].Obj_weldMark) {
              var editEntry = this._createContextMenueEntry(BabelStr.str(2503)); //next
              editEntry.on('click', function () {
                _MDWelMarkSettingWindow["default"].show(operationCenter.hoverObjs[0], function () {
                  var weldMark = operationCenter.hoverObjs[0];
                  weldMark.objData.active = true;
                  operationCenter.editor.refreshObjsInCanvas(weldMark.getExpandRect());
                  operationCenter.m_curOperation.setActiveObj(weldMark);
                });
              });
              this.contextMenu.append(editEntry);
            }
            if (_opType === _MMOperationType["default"].Operation_editable || _opType === _MMOperationType["default"].Operation_deletable) {
              //show delete entry
              var deleteEntry = this._createContextMenueEntry(BabelStr.str(32)); //next
              deleteEntry.on('click', function () {
                operationCenter.getCurrentBoard().m_actionManager.deleteObject(operationCenter.hoverObjs[0], {
                  toUndo: false,
                  realtime: true
                });
                _Dispatcher["default"].trigger(_MDEvents["default"].Comment_changed);
                _Dispatcher["default"].trigger(_MDEvents["default"].Comment_State_Sync, curTask.fileInfo.getFileId(), pageIndex);
                _Dispatcher["default"].trigger(_MDEvents["default"].COMMENT_REMOVE, curTask, pageIndex);
                if (_objType == _ObjType["default"].Obj_weldMark) {
                  operationCenter.m_curOperation.removeObj(operationCenter.hoverObjs[0]);
                }
              });
              this.contextMenu.append(deleteEntry);
            }
          }
          var $black = this._createContextMenueEntry(BabelStr.str(5012));
          var $white = this._createContextMenueEntry(BabelStr.str(5013));
          this.contextMenu.append($black);
          this.contextMenu.append($white);
          var $default = null;
          var fileInfo = board.getFileInfo();
          if (fileInfo.isImage()) {
            $default = this._createContextMenueEntry(BabelStr.str(5014));
            $default.on('click', function () {
              that._changeBackgroundColor('none');
            });
            this.contextMenu.append($default);
          }
          $black.on('click', function () {
            that._changeBackgroundColor('black');
          });
          $white.on('click', function () {
            that._changeBackgroundColor('white');
          });
        }
        ;
      }
      var fileInfo = board && board.getFileInfo();
      if (fileInfo && !board.canDispWithSVG() && !board.isCADFile() && (fileInfo.isImage() || board.isOperateOnPDFFile())) {
        var rotate = this._createContextMenueEntry(BabelStr.str(5015));
        rotate.on('click', function () {
          that._rotate90();
        });
        this.contextMenu.append(rotate);
      }
      if (fileInfo && fileInfo.canDownload() && fileInfo.canCopyToClipBoard()) {
        var rotate = this._createContextMenueEntry(BabelStr.str(6367));
        rotate.on('click', function () {
          that._copyToClipBoard();
        });
        this.contextMenu.append(rotate);
      }
      if (!fileInfo.isArchived() && fileInfo && window.isOpenOneFileAI && !app.currentUser.isCloseAI() && !app.currentUser.isAnonymous() && window.supportAI && fileInfo.canUseOCR()) {
        var rotate = this._createContextMenueEntry(BabelStr.str(12609));
        rotate.on('click', function () {
          that._OcrWords();
        });
        this.contextMenu.append(rotate);
      }
      // if (operationCenter && operationCenter.editorViewCtl && operationCenter.editorViewCtl.canSignInEval && app.ep.canShowEvalModel()) {
      //   operationCenter.editorViewCtl.canSignInEval((sigData)=>{
      //     if (sigData) {
      //       var addSig = this._createContextMenueEntry(BabelStr.str(5016));
      //       var hwRatio = sigData.getRatio();
      //       addSig.on('click', function(){
      //         console.log('--------------- 签名!');
      //         that._insertSignature(hwRatio);
      //       });
      //       this.contextMenu.append(addSig);
      //     }

      //   })
      // }

      if (fileInfo && fileInfo.canAddSig()) {
        app.currentUser.getMySealSignature(function (sealAndSig) {
          if (sealAndSig.sig) {
            var addSig = _this._createContextMenueEntry(BabelStr.str(5016));
            // var hwRatio = sealAndSig.getRatio();
            addSig.on('click', function () {
              console.log('--------------- 签名!');
              // that._insertSig(hwRatio);
              that._insertSeal(sealAndSig.sig);
            });
            _this.contextMenu.append(addSig);
          }
          if (sealAndSig.seal) {
            var addSeal = _this._createContextMenueEntry(BabelStr.str(11317));
            // var hwRatio = .getRatio();
            addSeal.on('click', function () {
              console.log('--------------- 签章!');
              that._insertSeal(sealAndSig.seal);
            });
            _this.contextMenu.append(addSeal);
          }
        });
      }
      if (this.contextMenu.height() > window.innerHeight - e.pageY) {
        this.contextMenu.css('top', '-=' + this.contextMenu.height());
      }
      if (this.contextMenu.width() > window.innerWidth - e.pageX) {
        this.contextMenu.css('left', '-=' + this.contextMenu.width());
      }
    }.bind(this));
  },
  //hide the current contextManue
  close: function close() {
    if (this.contextMenu) {
      this._removeWindowHandler();
      this.contextMenu.remove();
      this.contextMenu = null;
    }
  },
  _createContextMenueSeparator: function _createContextMenueSeparator() {
    return $('<div class="contextMenueSeparator" ></div>');
  },
  _createContextMenueEntry: function _createContextMenueEntry(text, disabled) {
    return $('<div class="contextMenueEntry' + (disabled ? " disabled" : '') + '">' + text + '</div>');
  },
  _createSigDeleteMenu: function _createSigDeleteMenu(canEdit, user, sealFrame) {
    return $("<div class=\"contextMenueEntry sig-editor-menu flex-align between middle \">\n      <div class=\"info text-hide\">\n        <div class=\"name text-hide\">".concat(user.getUserName(user), "</div>\n        <div class=\"help-text\">").concat(MMCommonFun.formatDate(sealFrame.getDatetime() * 1000), "</div>\n      </div>\n      <div class=\"opt text-button done no-shrink del ").concat(!canEdit && "f-hide", "\">").concat(BabelStr.str(32), "</div>\n    </div>"));
  },
  _delSig: function _delSig(fileId, ver, id, callback) {
    ver = ver - 0;
    _MDNetDriveFileHandler["default"].deleteFileSeal(fileId, ver, id, callback, function (code, msg) {
      _MDSnackbarView["default"].show(msg || BabelStr.str(309));
    });
  },
  _addwindowHandler: function _addwindowHandler() {
    if (!this._windowClickCallback) {
      var handler = function handler(e) {
        if (e.button === 0) {
          MMDesktopContextMenue.close();
        }
      };
      document.body.addEventListener("click", handler);
      this._windowClickCallback = handler;
    }
  },
  _removeWindowHandler: function _removeWindowHandler() {
    if (this._windowClickCallback) {
      document.body.removeEventListener('click', this._windowClickCallback);
      this._windowClickCallback = null;
    }
  },
  _changeBackgroundColor: function _changeBackgroundColor(color) {
    var mainView = this.operationCenter.m_editor;
    if (mainView && mainView.changeBackgroundColor) {
      mainView.changeBackgroundColor(color);
      localStorage['CADBackgroundColor'] = color;
    }
    ;
    if (!localStorage['stopBackgroundPrompt']) {
      var z_maxIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
      var alert = new _MDAlertView["default"]();
      alert.$el.css('z-index', z_maxIndex);
      var msg = "<p class=\"title\">".concat(BabelStr.str(5017), "</p>");
      alert.show({
        title: BabelStr.str(170),
        message: msg,
        className: 'm-delAlertWin',
        buttons: [{
          label: BabelStr.str(3604),
          type: 'done',
          onClick: function onClick() {}
        }, {
          label: BabelStr.str(5018),
          onClick: function onClick() {
            localStorage['stopBackgroundPrompt'] = 1;
          }
        }]
      });
    }
    ;
  },
  _rotate90: function _rotate90() {
    var mainView = this.operationCenter.m_editor;
    if (mainView) {
      mainView.rotate90();
    }
    ;
  },
  _copyToClipBoard: function _copyToClipBoard() {
    var mainView = this.operationCenter.m_editor;
    if (mainView) {
      mainView._copyToClipBoard();
    }
    ;
  },
  _insertSig: function _insertSig(hwRatio) {
    var mainEditor = _MDPcMobileEditorCommonFun["default"].getMainEditor();
    if (!mainEditor) return;
    var curTask = mainEditor.getCurrentBoard();
    var trsfm = this.operationCenter.getTransformer();
    var pageIndex = this.operationCenter.getCurrentFilePageIndex();
    var _startX = this.logicPoint.x;
    var _startY = this.logicPoint.y;
    var w = 300;
    var h = w * hwRatio;
    var lgWidth = trsfm.dv2lgLen(w);
    var lgHeight = trsfm.dv2lgLen(h);
    var _endX = _startX + lgWidth;
    var _endY = _startY + lgHeight;
    var _startPoint = new _MMPoint["default"](_startX, _startY);
    var _endPoint = new _MMPoint["default"](_endX, _endY);
    var pathDVPoints = [];
    var _startDV = trsfm.lg2dvPoint(_startPoint, pageIndex);
    var _endDV = trsfm.lg2dvPoint(_endPoint, pageIndex);
    pathDVPoints.push(_startDV);
    pathDVPoints.push(_endDV);
    var ver = this.operationCenter.editorViewCtl.getVersionShowing();
    var sigFrame = new _MMSignatureFrame["default"](curTask, ver);
    sigFrame.setDevOrientation(_BoardOrientation["default"].Portrait);
    sigFrame.setDevPts(trsfm, pathDVPoints, pageIndex);
    sigFrame.setUser(app.currentUser);
    sigFrame.setPageRect(this.pageView.getContentLgRect());
    var _strokeType = new _MMStrokeType["default"]();
    var dvLineW = _MDLineWidthAndFont["default"].getCurLineWidth();
    var lgLineW = trsfm.dv2lgLen(dvLineW);
    _strokeType.setLineWidth(lgLineW);
    var _color = new _MMColor["default"]();
    _color.fromString("#000000");
    _strokeType.setLineColor(_color);
    sigFrame.setStrokeType(_strokeType);
    sigFrame.setSigData(app.currentUser.getSigData());
    var fileInfo = curTask && curTask.getFileInfo();
    var fileId = fileInfo.getFileId();
    // MDNetDriveFileHandler.saveFileSignatures(fileId, ver, sigFrame, ()=>{
    this.operationCenter.m_editor.clearOpLayer();
    var option = {
      toUndo: false,
      realtime: false,
      isMark_: false
    };
    curTask.m_actionManager.addObject(sigFrame, option);
    _MDMarkerObjDrawerController["default"].focus(this.pageView, sigFrame);

    // }, ()=>{

    // })
  },
  _OcrWords: function _OcrWords() {
    _Dispatcher["default"].trigger(_MDEvents["default"].OcrFile);
  },
  _insertSeal: function _insertSeal(sealData) {
    var _this2 = this;
    var mainEditor = _MDPcMobileEditorCommonFun["default"].getMainEditor();
    if (!mainEditor) return;
    var curTask = mainEditor.getCurrentBoard();
    var trsfm = this.operationCenter.getTransformer();
    var pageIndex = this.operationCenter.getCurrentFilePageIndex();
    var _startX = this.logicPoint.x;
    var _startY = this.logicPoint.y;
    sealData.loadImg(function () {
      var w = sealData.getWidth();
      // var h = w * hwRatio;
      var h = sealData.getHeight();
      var lgWidth = trsfm.dv2lgLen(w);
      var lgHeight = trsfm.dv2lgLen(h);
      var sealsize = localStorage.getItem("sealsize");
      if (sealsize) {
        sealsize = JSON.parse(sealsize);
        if (sealData.getId() == sealsize.id) {
          var lgsize = _this2.pageView.getContentLgRect().getSize();
          lgWidth = sealsize.w * lgsize.width;
          lgHeight = sealsize.h * lgsize.height;
          console.log("使用了上次的尺寸");
        }
      }
      var _endX = _startX + lgWidth;
      var _endY = _startY + lgHeight;
      var _startPoint = new _MMPoint["default"](_startX, _startY);
      var _endPoint = new _MMPoint["default"](_endX, _endY);
      var pathDVPoints = [];
      var _startDV = trsfm.lg2dvPoint(_startPoint, pageIndex);
      var _endDV = trsfm.lg2dvPoint(_endPoint, pageIndex);
      pathDVPoints.push(_startDV);
      pathDVPoints.push(_endDV);
      var ver = _this2.operationCenter.editorViewCtl.getVersionShowing();
      var sigFrame = new _MMSealFrame["default"](curTask, ver);
      sigFrame.setDevOrientation(_BoardOrientation["default"].Portrait);
      sigFrame.setDevPts(trsfm, pathDVPoints, pageIndex);
      sigFrame.setUser(app.currentUser);
      sigFrame.setPageRect(_this2.pageView.getContentLgRect());
      var _strokeType = new _MMStrokeType["default"]();
      var dvLineW = _MDLineWidthAndFont["default"].getCurLineWidth();
      var lgLineW = trsfm.dv2lgLen(dvLineW);
      _strokeType.setLineWidth(lgLineW);
      var _color = new _MMColor["default"]();
      _color.fromString("#000000");
      _strokeType.setLineColor(_color);
      sigFrame.setStrokeType(_strokeType);
      sigFrame.setSigData(sealData);
      var fileInfo = curTask && curTask.getFileInfo();
      var fileId = fileInfo.getFileId();
      _MDNetDriveFileHandler["default"].addSealToFile(fileId, ver, sigFrame, function (res) {
        sigFrame.setSealedId(res.id);
        sigFrame.setDatetime(new Date().getTime() / 1000);
        _this2.operationCenter.m_editor.clearOpLayer();
        var option = {
          toUndo: false,
          realtime: false,
          isMark_: false
        };
        curTask.m_actionManager.addObject(sigFrame, option);
        _MDMarkerObjDrawerController["default"].focus(_this2.pageView, sigFrame);
        _Dispatcher["default"].trigger(_MDEvents["default"].fileSealChanged, {
          fileId: fileId,
          version: ver
        });
      }, function () {});
    });
  },
  _insertSignature: function _insertSignature(hwRatio) {
    var _this3 = this;
    var mainEditor = _MDPcMobileEditorCommonFun["default"].getMainEditor();
    if (!mainEditor) return;
    var curTask = mainEditor.getCurrentBoard();
    var trsfm = this.operationCenter.getTransformer();
    var pageIndex = this.operationCenter.getCurrentFilePageIndex();
    var _startX = this.logicPoint.x;
    var _startY = this.logicPoint.y;
    var w = 300;
    var h = w * hwRatio;
    var lgWidth = trsfm.dv2lgLen(w);
    var lgHeight = trsfm.dv2lgLen(h);
    var _endX = _startX + lgWidth;
    var _endY = _startY + lgHeight;
    var _startPoint = new _MMPoint["default"](_startX, _startY);
    var _endPoint = new _MMPoint["default"](_endX, _endY);
    var pathDVPoints = [];
    var _startDV = trsfm.lg2dvPoint(_startPoint, pageIndex);
    var _endDV = trsfm.lg2dvPoint(_endPoint, pageIndex);
    pathDVPoints.push(_startDV);
    pathDVPoints.push(_endDV);
    var ver = this.operationCenter.editorViewCtl.getVersionShowing();
    var sigFrame = new _MMSignatureFrame["default"](curTask, ver);
    sigFrame.setDevOrientation(_BoardOrientation["default"].Portrait);
    sigFrame.setDevPts(trsfm, pathDVPoints, pageIndex);
    sigFrame.setUser(app.currentUser);
    sigFrame.setPageRect(this.pageView.getContentLgRect());
    var _strokeType = new _MMStrokeType["default"]();
    var dvLineW = _MDLineWidthAndFont["default"].getCurLineWidth();
    var lgLineW = trsfm.dv2lgLen(dvLineW);
    _strokeType.setLineWidth(lgLineW);
    var _color = new _MMColor["default"]();
    _color.fromString("#000000");
    _strokeType.setLineColor(_color);
    sigFrame.setStrokeType(_strokeType);
    sigFrame.setSigData(app.currentUser.getSigData());
    var fileInfo = curTask && curTask.getFileInfo();
    var fileId = fileInfo.getFileId();
    _MDNetDriveFileHandler["default"].saveFileSignatures(fileId, ver, sigFrame, function () {
      _this3.operationCenter.m_editor.clearOpLayer();
      var option = {
        toUndo: false,
        realtime: false,
        isMark_: false
      };
      curTask.m_actionManager.addObject(sigFrame, option);
      _MDMarkerObjDrawerController["default"].focus(_this3.pageView, sigFrame);
    }, function () {});
  }
};
var _default = exports["default"] = MMDesktopContextMenue;

},{"1030":1030,"1084":1084,"1091":1091,"1184":1184,"1412":1412,"1437":1437,"1438":1438,"1454":1454,"1461":1461,"18":18,"32":32,"325":325,"438":438,"72":72,"794":794,"798":798,"802":802,"807":807,"811":811,"830":830,"856":856,"861":861,"872":872,"882":882,"886":886,"909":909}],438:[function(require,module,exports){
"use strict";

require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1439);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MMRect = _interopRequireDefault(require(831));
var _MMCommonFun = _interopRequireDefault(require(812));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /**
 *  编辑设置焊接标注的窗口
 *  javascript/moladisk/views/editor/MDWelMarkSettingWindow.js
 *  Created by jiang
 *  2018.10.22
 */
var MDWelMarkSettingWindow = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDWelMarkSettingWindow, _MDWindowView);
  function MDWelMarkSettingWindow() {
    (0, _classCallCheck2["default"])(this, MDWelMarkSettingWindow);
    return _callSuper(this, MDWelMarkSettingWindow, arguments);
  }
  (0, _createClass2["default"])(MDWelMarkSettingWindow, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n      <div class=\"contain\" style=\"position:relative\">\n        <canvas width=\"700px\" height=\"400px\"></canvas>\n      </div>";
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDWelMarkSettingWindow.prototype), "events", this).call(this);
      return _.extend(superE, {
        "mousemove canvas": this.onMouseMove,
        "click canvas": this.onMouseClick
      });
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDWelMarkSettingWindow.prototype), "initProps", this).call(this);
      return _.extend(superP, {});
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDWelMarkSettingWindow.prototype), "className", this).call(this);
      return "".concat(superCls, " welmark-setting");
    }
  }, {
    key: "initialize",
    value: function initialize(opt) {
      var _this = this;
      var self = this;
      opt.buttons = [{
        type: 'done',
        label: BabelStr.str(154),
        autoClose: false,
        onClick: function onClick() {
          if (_this.welmark) {
            _this.updateStrByInput();
            _this.welmark.objData.solidSide.signId = _this.topMarkIndex;
            _this.welmark.objData.dottedSide.signId = _this.bottomMarkIndex;
            _this.welmark.objData.solidSide.SE = _this.strs[0];
            _this.welmark.objData.solidSide.LP = _this.strs[1];
            _this.welmark.objData.dottedSide.SE = _this.strs[2];
            _this.welmark.objData.dottedSide.LP = _this.strs[3];
            _this.welmark.objData.specificAction = _this.strs[4];
            _this.welmark.objData.solidSide.FCAR = _this.strs[5];
            _this.welmark.objData.dottedSide.FCAR = _this.strs[6];
            _this.welmark.objData.isFleldWeld = _this.live;
            _this.welmark.objData.isAllAround = _this.round;
          }
          _this.onFinished && _this.onFinished();
          MDWelMarkSettingWindow.instance.close();
          MDWelMarkSettingWindow.instance = null;
        }
      }, {
        type: 'cancel',
        label: BabelStr.str(155),
        autoClose: true,
        onClick: function onClick() {
          MDWelMarkSettingWindow.instance.close();
          MDWelMarkSettingWindow.instance = null;
          self.onCancel && self.onCancel();
        }
      }];
      opt.width = 720;
      opt.title = BabelStr.str(2744);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDWelMarkSettingWindow.prototype), "initialize", this).call(this, opt);
      this.canvasW = 700;
      this.canvasH = 400;
      this.space = 10; // 横向对象之间的间隔

      this.originDist = 20;
      this.distBetweenLine = this.originDist; // 实线与虚线之间的距离

      this.fontSize = 14; // 绘制文字的字号

      this.topMarkIndex = 3; // 上面的标准符号， <= 0 表示没有符号
      this.bottomMarkIndex = 3; // 下面的标准符号， <= 0 表示没有符号

      this.live = true;
      this.round = true;
      this.leftTopStr = "abcdedf";
      this.rightTopStr = "";
      this.leftBottomStr = "p12*h39";
      this.rightBottomStr = "l30 x 4";
      this.tailStr = "H2 * R39";
      this.topStr = "top str,  a:19";
      this.bottomStr = "";
      if (this.welmark) {
        this.topMarkIndex = this.welmark.objData.solidSide.signId;
        this.bottomMarkIndex = this.welmark.objData.dottedSide.signId;
        this.leftTopStr = this.welmark.objData.solidSide.SE;
        this.rightTopStr = this.welmark.objData.solidSide.LP;
        this.leftBottomStr = this.welmark.objData.dottedSide.SE;
        this.rightBottomStr = this.welmark.objData.dottedSide.LP;
        this.tailStr = this.welmark.objData.specificAction;
        this.topStr = this.welmark.objData.solidSide.FCAR;
        this.bottomStr = this.welmark.objData.dottedSide.FCAR;
        this.live = this.welmark.objData.isFleldWeld;
        this.round = this.welmark.objData.isAllAround;
      }

      // 所有字符串构成数组，次序不可随便调换！
      this.strs = [this.leftTopStr, this.rightTopStr, this.leftBottomStr, this.rightBottomStr, this.tailStr, this.topStr, this.bottomStr];
      this.calcParameters();
      this.drawMarkObj();
      _MMCommonFun["default"].setTextInputInEditor('MarkSettingPanel');
    }
  }, {
    key: "viewDidUnRendered",
    value: function viewDidUnRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDWelMarkSettingWindow.prototype), "viewDidUnRendered", this).call(this);
      _MMCommonFun["default"].removeTextInputInEditor('MarkSettingPanel');
    }
  }, {
    key: "calcParameters",
    value: function calcParameters() {
      if (this.topMarkIndex == this.bottomMarkIndex) {
        this.distBetweenLine = 0;
      } else {
        this.distBetweenLine = this.originDist;
      }
      this.widths = {
        strWidths: [50, 50, 50, 50, 50, 50, 50],
        markWidth: 40
      };
      var canvas = this.$('canvas')[0];
      this.ctx = canvas.getContext('2d');
      this.ctx.font = "Arial " + this.fontSize + "px";
      for (var i = 0; i < this.strs.length; i++) {
        var str = this.strs[i];
        var w = this.ctx.measureText(str);
        if (w.width > this.widths.strWidths[i]) {
          this.widths.strWidths[i] = w.width;
        }
      }
      this.markX = this.space * 3 + Math.max(this.widths.strWidths[0], this.widths.strWidths[2]) + this.space;
      this.horizontal = this.markX + this.widths.markWidth + this.space + Math.max(this.widths.strWidths[1], this.widths.strWidths[3]) + this.space;
      this.tail = this.widths.markWidth + this.widths.strWidths[4];
      this.head = this.widths.markWidth;
      this.startX = (this.canvasW - (this.head + this.horizontal + this.tail)) / 2;
      this.startY = this.canvasH / 2;

      // 收集热区
      this.hotRects = [];
      this.strPos = [];

      // 字符串热区
      var textRects = [];
      var x = this.startX + this.head + this.markX - this.space - this.widths.strWidths[0];
      var y = this.startY - this.fontSize;
      var d = this.fontSize / 3;
      textRects.push(new _MMRect["default"](y - this.fontSize, x + this.widths.strWidths[0], y + d, x));
      this.strPos.push({
        x: x,
        y: y
      });
      x = this.startX + this.head + this.markX + this.widths.markWidth + this.space;
      textRects.push(new _MMRect["default"](y - this.fontSize, x + this.widths.strWidths[1], y + d, x));
      this.strPos.push({
        x: x,
        y: y
      });
      x = this.startX + this.head + this.markX - this.space - this.widths.strWidths[2];
      y = this.startY + this.distBetweenLine + this.fontSize / 2 + this.space;
      textRects.push(new _MMRect["default"](y - this.fontSize, x + this.widths.strWidths[2], y + d, x));
      this.strPos.push({
        x: x,
        y: y
      });
      x = this.startX + this.head + this.markX + this.widths.markWidth + this.space;
      textRects.push(new _MMRect["default"](y - this.fontSize, x + this.widths.strWidths[3], y + d, x));
      this.strPos.push({
        x: x,
        y: y
      });

      // tail text
      x = this.startX + this.head + this.horizontal + this.space;
      y = this.startY + this.fontSize / 2;
      textRects.push(new _MMRect["default"](y - this.fontSize, x + this.widths.strWidths[4], y + d, x));
      this.strPos.push({
        x: x,
        y: y
      });
      this.hotRects.push(textRects);

      // top string
      x = this.startX + this.head + this.markX + this.widths.markWidth / 2 - this.widths.strWidths[5] / 2;
      y = this.startY - this.widths.markWidth - this.fontSize;
      textRects.push(new _MMRect["default"](y - this.fontSize, x + this.widths.strWidths[5], y + d, x));
      this.strPos.push({
        x: x,
        y: y
      });

      // 下字符串
      x = this.startX + this.head + this.markX + this.widths.markWidth / 2 - this.widths.strWidths[6] / 2;
      y = this.startY + this.distBetweenLine + this.widths.markWidth + this.fontSize;
      textRects.push(new _MMRect["default"](y - this.fontSize, x + this.widths.strWidths[6], y + d, x));
      this.strPos.push({
        x: x,
        y: y
      });

      // 基础符号热区
      var basickRects = [];
      x = this.startX + this.head + this.markX;
      y = this.startY - this.widths.markWidth;
      basickRects.push(new _MMRect["default"](y, x + this.widths.markWidth, y + this.widths.markWidth, x));
      y = this.startY + this.distBetweenLine;
      basickRects.push(new _MMRect["default"](y, x + this.widths.markWidth, y + this.widths.markWidth, x));
      this.hotRects.push(basickRects);

      // 小旗的热区
      x = this.startX + this.head;
      y = this.startY;
      var size = 30 / 2;
      this.hotRects.push([new _MMRect["default"](y - size, x + size, y + size, x - size)]);
    }
  }, {
    key: "drawMarkObj",
    value: function drawMarkObj() {
      this.drawHorizontal();
      this.drawBasicMarks();
      this.drawFlags();
      this.drawComments();
      this.drawHotRects();
    }
  }, {
    key: "drawHorizontal",
    value: function drawHorizontal() {
      this.ctx.strokeStyle = "#ff0000";
      this.ctx.lineWidth = 2;

      // 实线
      this.ctx.beginPath();
      var startX = this.startX + this.head;
      var endX = startX + this.horizontal;
      this.ctx.moveTo(startX, this.startY);
      this.ctx.lineTo(endX, this.startY);
      this.ctx.stroke();

      // 虚线
      var dist = this.distBetweenLine;
      var y = this.startY + dist;
      var x = startX;
      var step = 4;
      while (x < endX) {
        this.ctx.beginPath();
        this.ctx.moveTo(x, y);
        this.ctx.lineTo(x + step, y);
        this.ctx.stroke();
        x += step * 2;
      }

      // 尾线
      var d = 20;
      this.ctx.beginPath();
      this.ctx.moveTo(endX, this.startY);
      this.ctx.lineTo(endX + d, this.startY - d);
      this.ctx.moveTo(endX, this.startY);
      this.ctx.lineTo(endX + d, this.startY + d);
      this.ctx.stroke();

      // 头部
      x = this.startX;
      y = this.startY + this.head;
      var arrow = 10;
      this.ctx.beginPath();
      this.ctx.moveTo(x, y);
      this.ctx.lineTo(x, y - arrow);
      this.ctx.moveTo(x, y);
      this.ctx.lineTo(x + arrow, y);
      this.ctx.moveTo(x, y);
      this.ctx.lineTo(this.startX + this.head, this.startY);
      this.ctx.stroke();
    }
  }, {
    key: "drawBasicMarks",
    value: function drawBasicMarks() {
      var _this2 = this;
      var self = this;
      if (this.topMarkIndex > 0) {
        var drawTop = function drawTop() {
          var x = _this2.startX + _this2.head + _this2.markX + _this2.widths.markWidth / 2 - _this2.topmark.width / 2;
          var y = _this2.startY - _this2.topmark.height;
          _this2.ctx.drawImage(_this2.topmark, x, y);
        };
        if (!this.topmark) {
          var url = MDWelMarkSettingWindow.getMarkUrl(this.topMarkIndex);
          var img = new Image();
          img.src = url;
          img.onload = function () {
            drawTop();
          };
          this.topmark = img;
        } else {
          drawTop();
        }
      }
      if (this.bottomMarkIndex > 0) {
        var drawBottom = function drawBottom() {
          var cx = _this2.startX + _this2.head + _this2.markX + _this2.widths.markWidth / 2;
          var cy = _this2.startY + _this2.distBetweenLine + _this2.bottommark.height / 2;
          _this2.ctx.save();
          _this2.ctx.setTransform(1, 0, 0, -1, cx, cy);
          _this2.ctx.drawImage(_this2.bottommark, -_this2.bottommark.width / 2, -_this2.bottommark.height / 2);
          _this2.ctx.restore();
        };
        if (!this.bottommark) {
          var _url = MDWelMarkSettingWindow.getMarkUrl(this.bottomMarkIndex);
          var _img = new Image();
          _img.src = _url;
          _img.onload = function () {
            drawBottom();
          };
          this.bottommark = _img;
        } else {
          drawBottom();
        }
      }
    }
  }, {
    key: "drawComments",
    value: function drawComments() {
      for (var i = 0; i < this.strPos.length; i++) {
        var pos = this.strPos[i];
        var x = this.strPos[i].x;
        var y = this.strPos[i].y;
        this.ctx.fillText(this.strs[i], x, y);
      }
    }
  }, {
    key: "drawFlags",
    value: function drawFlags() {
      var _this3 = this;
      if (this.live) {
        var drawFlag = function drawFlag() {
          var x = _this3.startX + _this3.head - _this3.flagMark.width / 2 + 10;
          var y = _this3.startY - _this3.flagMark.height + 2;
          _this3.ctx.drawImage(_this3.flagMark, x, y);
        };
        if (!this.flagMark) {
          this.flagMark = new Image();
          this.flagMark.src = MDWelMarkSettingWindow.getMarkUrl(34);
          this.flagMark.onload = function () {
            drawFlag();
          };
        } else {
          drawFlag();
        }
      }
      if (this.round) {
        var drawCircle = function drawCircle() {
          var x = _this3.startX + _this3.head - _this3.roundMark.width / 2;
          var y = _this3.startY - _this3.roundMark.height / 2;
          _this3.ctx.drawImage(_this3.roundMark, x, y);
        };
        if (!this.roundMark) {
          this.roundMark = new Image();
          this.roundMark.src = MDWelMarkSettingWindow.getMarkUrl(33);
          this.roundMark.onload = function () {
            drawCircle();
          };
        } else {
          drawCircle();
        }
      }
    }
  }, {
    key: "drawHotRects",
    value: function drawHotRects() {
      if (!this.curHot) {
        return;
      }
      this.ctx.strokeStyle = "rgba(254, 200, 111,1.0)";
      var rect = this.curHot.rect;
      this.ctx.strokeRect(rect.left, rect.top, rect.getWidth(), rect.getHeight());
    }
  }, {
    key: "onMouseMove",
    value: function onMouseMove(e) {
      console.log(' x:' + e.offsetX + "  y:" + e.offsetY);
      var x = e.offsetX;
      var y = e.offsetY;
      var inHot = false;
      this.overHot = this._getHotInfo(e);
      if (this.overHot) {
        this.$('canvas').css('cursor', "pointer");
      } else {
        this.$('canvas').css('cursor', "auto");
      }
      this.refreshHotArea();
    }
  }, {
    key: "_getHotInfo",
    value: function _getHotInfo(e) {
      var x = e.offsetX;
      var y = e.offsetY;
      var overHot = null;
      for (var i = 0; i < this.hotRects.length; i++) {
        var rects = this.hotRects[i];
        for (var k = 0; k < rects.length; k++) {
          var rect = rects[k];
          if (rect.include({
            x: x,
            y: y
          })) {
            overHot = {
              index0: i,
              index1: k,
              rect: rect
            };
            break;
          }
        }
      }
      return overHot;
    }
  }, {
    key: "onMouseClick",
    value: function onMouseClick(e) {
      if (this.overHot) {
        if (this.overHot.index0 == 0) {
          // 基础标记
          this.showStringInput(this.overHot.index1, this.overHot.rect);
        } else if (this.overHot.index0 == 1) {
          this.showBasicMarkSelect();
        } else if (this.overHot.index0 == 2) {
          this.showFlagSetting();
        }
      }
    }
  }, {
    key: "refreshHotArea",
    value: function refreshHotArea() {
      if (!this.curHot && !this.overHot) {
        return;
      }
      if (!this.curHot && this.overHot || !this.overHot && this.curHot || this.curHot.index0 != this.overHot.index0 || this.curHot.index1 != this.overHot.index1) {
        this.curHot = this.overHot;
        this.refresh();
      }
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var canvas = this.$('canvas')[0];
      this.ctx.clearRect(0, 0, canvas.offsetWidth, canvas.offsetHeight);
      this.drawMarkObj();
    }
  }, {
    key: "showBasicMarkSelect",
    value: function showBasicMarkSelect() {
      var _this4 = this;
      var $cover = $('<div style="position:absolute;top:0px;left:0px; width:100%; height:100%;">' + '<ul class="element-panel" style="position:absolute;top:0px;left:0px; width:50%; height:50%; background-color: rgba(0, 0, 0, 0.8);"></ul>' + '</div>');
      for (var i = 0; i < 17; i++) {
        var k = i + 1;
        var $div = '<img class="gb-img" src="img/gb/' + k + ' copy 2.svg" alt="" data-id="' + k + '">';
        $cover.find('ul').append($div);
      }
      this.$('.contain').append($cover);
      $cover.on('click', function (e) {
        $cover.off();
        $cover.find('img').off();
        $cover.remove();
      });
      $cover.find('img').on('click', function (e) {
        var $img = $(e.currentTarget);
        var index = $img.index() + 1;
        console.log('img index :' + index);
        _this4.setCurBasicMark(index);
      });
    }
  }, {
    key: "updateStrByInput",
    value: function updateStrByInput() {
      if (this.textInput) {
        var $cover = this.textInput.$cover;
        var strIndex = this.textInput.strIndex;
        $cover.off();
        $cover.find('input').off();
        $cover.remove();
        var str = $cover.find('input').val();
        if (str != this.strs[strIndex]) {
          this.strs[strIndex] = str;
          this.calcParameters();
          this.refresh();
        }
        this.textInput = null;
      }
    }
  }, {
    key: "showStringInput",
    value: function showStringInput(strIndex, rect) {
      var _this5 = this;
      var $cover = $('<div style="position:absolute;top:0px;left:0px; width:100%; height:100%;background-color: rgba(0, 0, 0, 0.5);">' + '<input class="str-val" style="position:absolute;top:0px;left:0px; width:100px; height:40px;"></input>' + '</div>');
      $cover.find('input').css('top', rect.top + 'px');
      $cover.find('input').css('left', rect.left + 'px');
      $cover.find('input').val(this.strs[strIndex]);
      $cover.find('input').attr('maxlength', 15);
      if (strIndex > 4) {
        $cover.find('input').attr('maxlength', 30);
      }
      if (rect.getWidth() > 100) {
        $cover.find('input').css('width', rect.getWidth() + 'px');
      }
      this.$('.contain').append($cover);
      $cover.on('click', function (e) {
        _this5.updateStrByInput();
      });
      $cover.find('input').on('click', function (e) {
        e.stopPropagation();
      });
      $cover.find('input').on('keydown', function (e) {
        if (e.keyCode == 13) {
          _this5.updateStrByInput();
        }
      });
      $cover.find('input').focus();
      this.textInput = {
        $cover: $cover,
        strIndex: strIndex
      };
    }
  }, {
    key: "showFlagSetting",
    value: function showFlagSetting() {
      var _this6 = this;
      console.log('--------> show flag setting');
      var $cover = $('<div style="position:absolute;top:0px;left:0px; width:100%; height:100%;background-color: rgba(0, 0, 0, 0.5);">' + '<div class="check-panel" style="padding: 10px; margin: 20px; background-color: white;">' + '<input type="checkbox" class="live" name="additional" value="live">' + BabelStr.str(7151) + '<br>' + '<input type="checkbox" class="round" name="additional" value="round"> ' + BabelStr.str(7152) + '</div>' + '</div>');
      this.$('.contain').append($cover);
      var inputFinished = function inputFinished(e) {
        $cover.off();
        $cover.find('input').off();
        $cover.find('.check-panel').off();
        $cover.remove();
      };
      $cover.on('click', function (e) {
        inputFinished();
      });
      $cover.find('.check-panel').on('click', function (e) {
        e.stopPropagation();
      });
      $cover.find('input').on('change', function (e) {
        console.log('input changed!');
        var checked = {
          name: $(e.target).val(),
          selected: $(e.target).isChecked()
        };
        _this6[checked.name] = checked.selected;
        _this6.calcParameters();
        _this6.refresh();
      });
      $cover.find('.live').prop("checked", this.live);
      $cover.find('.round').prop("checked", this.round);
    }
  }, {
    key: "setCurBasicMark",
    value: function setCurBasicMark(index) {
      if (this.overHot) {
        if (this.overHot.index0 == 1) {
          // 基础标记
          if (this.overHot.index1 == 0) {
            if (this.topMarkIndex != index) {
              this.topMarkIndex = index;
              this.topmark = null;
            }
          } else {
            if (this.bottomMarkIndex != index) {
              this.bottomMarkIndex = index;
              this.bottommark = null;
            }
          }
          this.calcParameters();
          this.refresh();
        }
      }
    }
  }]);
  return MDWelMarkSettingWindow;
}(_MDWindowView2["default"]);
MDWelMarkSettingWindow.show = function (welmarkObj, onFinished, onCancel) {
  if (MDWelMarkSettingWindow.instance) {
    MDWelMarkSettingWindow.instance.close();
  }
  MDWelMarkSettingWindow.instance = new MDWelMarkSettingWindow({
    welmark: welmarkObj,
    onFinished: onFinished,
    onCancel: onCancel
  });
  MDWelMarkSettingWindow.instance.show();
};
MDWelMarkSettingWindow.getMarkUrl = function (index) {
  var url = "/img/gb/" + index + " copy 3.svg";
  return url;
};

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1417":1417,"1439":1439,"1454":1454,"1463":1463,"1475":1475,"812":812,"831":831,"93":93}],864:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1438);
var _MMOperation = _interopRequireDefault(require(873));
var _MMPoint = _interopRequireDefault(require(830));
var _MMCommentObj = _interopRequireDefault(require(1005));
var _MMFillType = _interopRequireDefault(require(795));
var _MMColor = _interopRequireDefault(require(794));
var _MDNew2DCommentInputView = _interopRequireDefault(require(333));
var _MMMovingOperation = _interopRequireDefault(require(870));
var g_textCached = undefined;
window.g_textCached = g_textCached;
/**
 *@param tmp {boolean} if true, the operator is temporare and set to null, when it get hidden
 *
 */
function MMCommentOperation(oc, tmp) {
  _MMOperation["default"].call(this);
  if (oc == undefined) {
    throw "initialise the eraseOperation with your OC";
  }
  this.m_oc = oc;
  this.temporary = !!tmp;
  this.m_flag = false;
  this.m_movingOperation = null;
  this.m_oc.m_selectedObjs = [];
  this.displayed = false;
}
MMCommentOperation.prototype = new _MMOperation["default"]();
MMCommentOperation.superclass = _MMOperation["default"].prototype;
MMCommentOperation.prototype.onMouseDown = function (lgPoint, obj, e) {
  if (obj && obj.m_className == "MMCommentObj" && app.currentUser.isObjectCreator(obj)) {
    this.m_movingOperation = new _MMMovingOperation["default"](this.m_oc, obj, true);
    var $opLayer = $(this.m_oc.m_editor.getAssistantCanvas());
    this.m_movingOperation.onMouseDown(lgPoint, $opLayer, e);
  } else {
    if (this.m_oc.createCommentView) {
      g_textCached = this.m_oc.createCommentView.getContent();
      this.preDestroy();
      this.m_flag = true;
      //to determine whether it is a temporary operation or not (eg. double click)
      if (this.temporary == true || !MMCommonFun.isPC()) {
        this.m_oc.setCurOperation();
      }
    } else {
      this.m_flag = false;
    }
  }
};
MMCommentOperation.prototype.onMouseMove = function (lgPoint, e, layer) {
  if (this.m_movingOperation) {
    this.m_movingOperation.onMouseMove(lgPoint, e, layer);
  } else {}
};
MMCommentOperation.prototype.onMouseUp = function (lgPoint, e) {
  var that = this;
  if (this.m_movingOperation) {
    this.m_movingOperation.onMouseUp(lgPoint, e); // in this case, flag is an event
    this.m_movingOperation = null;
  } else {
    var currentBoard = this.m_oc.getCurrentBoard();
    var ver = this.m_oc.editorViewCtl.getVersionShowing();
    var objRect = currentBoard.getPicObjDisplaying(this.m_oc.getCurrentFilePageIndex(), ver).m_rect;
    if (!this.isLPOnCurrentPage(lgPoint)) {
      // while changing the page, the LG point is not correct, use this code until it is fixed
      return;
    }
    if (this.m_oc.createCommentView) return;
    if (this.m_flag) return;
    if (currentBoard.isClosed()) return;
    Dispatcher.trigger(MDEvents.SHOW_COMMENTS);
    if (objRect) {
      lgPoint = MMCommonFun.movePointIntoRect(lgPoint, objRect);
    }
    ;
    var $commentLayerParent = $(this.m_oc.m_editor.getCommentLayer()).parent();
    var devicePoint = this.m_oc.getTransformer().lg2dvPoint(lgPoint, this.m_oc.getCurrentFilePageIndex());
    devicePoint = this.m_oc.m_editor.convertPointFromEditor2AssistView(devicePoint, this.m_oc.getCurrentFilePageIndex());
    var assistView = this.m_oc.m_editor.getAssistantCanvas();
    devicePoint = MMCommonFun.convertPointBetweenElements(assistView, $commentLayerParent[0], devicePoint);
    var position = {
      x: devicePoint.x - 1,
      y: devicePoint.y
    };
    this.m_oc.createCommentView = new _MDNew2DCommentInputView["default"]({
      showVisibleScope: true,
      v_pos: position,
      position: lgPoint,
      page: this.m_oc.getCurrentFilePageIndex(),
      parentLayer: $commentLayerParent,
      editor: this.m_oc.m_editor,
      imgMarkerCtl: this.imgMarkerCtl,
      editorViewCtl: this.m_oc.editorViewCtl
    });
    if (g_textCached) {
      this.m_oc.createCommentView.setContent(g_textCached);
    }
    application.addSubView(this.m_oc.createCommentView, $commentLayerParent[0]);
    this.m_oc.createCommentView.inputView.setFocus(true);

    // this.temporary = e;
  }
  this.m_oc.m_selectedObjs = [];
};

/**
 *@param lp {MMPoint} the point to test
 */
MMCommentOperation.prototype.isLPOnCurrentPage = function (lp) {
  return isLPOnPage(lp, this.m_oc.getCurrentFilePageIndex());
};

/**
 * checks if a point is on a given page
 * todo: you can move this method to a more global jsfile
 */
var isLPOnPage = function isLPOnPage(lp, page) {
  var pageToHeight = (page + 1) * MMLogicPageHeight; // 20
  var pageFromHeight = pageToHeight - MMLogicPageHeight; // 20
  return lp.y <= pageToHeight && lp.y >= pageFromHeight && lp.x >= 0 && lp.x <= MMLogicPageWidth;
};
window.isLPOnPage = isLPOnPage;
MMCommentOperation.prototype.preDestroy = function () {
  if (this.m_oc.createCommentView) {
    var createCommentView = this.m_oc.createCommentView;
    createCommentView.hide(function () {
      createCommentView.$el.remove();
      if (createCommentView._$circleParent) createCommentView._$circleParent.remove();
      this.m_oc.createCommentView = null;
    }.bind(this));
  }
};
MMCommentOperation.prototype.closeCommentInputView = function () {
  this.m_oc.createCommentView.hide(function () {
    if (this.temporary == true) {
      this.m_oc.setCurOperation();
    } else {
      this.preDestroy();
    }
  }.bind(this));
};
MMCommentOperation.prototype.divOperation = true;
var _default = exports["default"] = MMCommentOperation;

},{"1005":1005,"1184":1184,"1438":1438,"1454":1454,"333":333,"794":794,"795":795,"830":830,"870":870,"873":873}],870:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1438);
var _MMOperation = _interopRequireDefault(require(873));
var _ObjType = _interopRequireDefault(require(1084));
var _MMPointObj = _interopRequireDefault(require(1023));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
function MMMovingOperation(oc, selectedObj, isChild) {
  _MMOperation["default"].call(this);
  console.assert(selectedObj);
  this.m_operationCenter = oc;
  this.oc = oc;
  this.startPoint = null;
  this.selectedObj = selectedObj;
  if (isChild == true) {
    /*
     * be careful to make sure to remove the loop-reference when the moveoperation is done.
     */
    this.m_isChild = true;
  }
  this.$deleteArea = $('<div class="movingOperationDeleteArea">');
  this.$deleteArea.append($('<div class="icon delete">'));
  if (this.selectedObj.views) {
    for (var i = 0; i < this.selectedObj.views.length; i++) this.selectedObj.views[i].el.style.transition = "initial";
  }
}
;
document.write('<style>.movingOperationDeleteArea{' + 'transition: margin-top 0.3s linear, background-color 0.3s linear,width 0.3s linear,padding-top 0.3s linear, height 0.3s linear;' + 'position:fixed;' + 'z-index:1000000;' + 'top:50%;' + 'border:3px solid #fff;' + 'height:50px;' + 'width:60px;' + 'margin-top: -28px;', 'text-align:right; ' + 'background-color:#000;' + 'border-left-width: 0px;' + 'border-radius: 0px 5px 5px 0px;' + 'left:-32px;' + 'padding-top:8px' + '} .movingOperationDeleteArea .icon{margin-right: 12px;}</style>');
MMMovingOperation.prototype = new _MMOperation["default"]();
MMMovingOperation.superclass = _MMOperation["default"].prototype;
MMMovingOperation.prototype.onMouseDown = function (point, $opLayer, e) {
  this.mouseStartPos = {
    x: e.clientX,
    y: e.clientY
  };
  this.preMousePos = this.mouseStartPos;
  this.startPoint = point;
  this.$opLayer = $opLayer;
  if ($opLayer) {
    this.opOldCursor = $opLayer.css('cursor');
    $opLayer.css('cursor', 'move');
  }
  ;
  this.maxOffset = this.calcMaxOffset(this.selectedObj);
  if (!MMCommonFun.isPC()) {
    //
    if (this.oc.mode == "FULLSCREEN") {
      $(this.oc.m_editor.getCommentLayer()).append(this.$deleteArea);
    } else {
      $(document.body).append(this.$deleteArea);
    }
    this.$deleteArea.animate({
      left: "0px"
    }, 400);
  }
  var selectedObj = this.selectedObj;
  var userOffset = this.startPoint.offsetTo(point);
  var possibleOffset = this.limitOffset(userOffset);
  if (selectedObj.m_objType == _ObjType["default"].Obj_comment) {
    var dvOffset = this.oc.getTransformer().lg2dvVec(possibleOffset);
    var parentOffset = {
      // (MMCommonFun.isPC() ?
      left: 0,
      top: 0
    }; // : $(this.oc.m_editor.getCommentLayer()).offset());
    dvOffset.x = Math.round(dvOffset.x + parentOffset.left);
    dvOffset.y = Math.round(dvOffset.y + parentOffset.top);
    Dispatcher.trigger(MDEvents.COMMENT_MOVE_TO_OFFSET, this.oc.m_editor, selectedObj, dvOffset);
  }
};
MMMovingOperation.prototype.calcMaxOffset = function (obj) {
  var objData = obj.getObjData();
  //console.log(objData);var maxoffset;
  var maxoffset;
  if (obj instanceof _MMPointObj["default"]) {
    //pointobj
    var pos = objData.m_pos;
    maxoffset = {
      minY: -(pos.y - obj.getPageIndex() * MMLogicPageHeight),
      //up
      maxY: MMLogicPageHeight - (pos.y - obj.getPageIndex() * MMLogicPageHeight),
      //down
      minX: -pos.x,
      //left
      maxX: MMLogicPageWidth - pos.x //right
    };
    if (this.m_operationCenter.mode === 'FULLSCREEN' || this.m_operationCenter.mode === 'collection' || this.m_operationCenter.mode === 'PDFDocument') {
      var imageFrame = this.oc.m_editor.getPicObject().getRect();
      var imageMaxOffset = {
        minY: -Math.abs(pos.y - imageFrame.top),
        maxY: Math.abs(pos.y - imageFrame.bottom),
        minX: -Math.abs(pos.x - imageFrame.left),
        maxX: Math.abs(pos.x - imageFrame.right)
      };
      maxoffset.minX = maxoffset.minX < imageMaxOffset.minX ? imageMaxOffset.minX : maxoffset.minX;
      maxoffset.maxX = maxoffset.maxX > imageMaxOffset.maxX ? imageMaxOffset.maxX : maxoffset.maxX;
      maxoffset.minY = maxoffset.minY < imageMaxOffset.minY ? imageMaxOffset.minY : maxoffset.minY;
      maxoffset.maxY = maxoffset.maxY > imageMaxOffset.maxY ? imageMaxOffset.maxY : maxoffset.maxY;
    }
  } else {
    //blockobj
    var expandRect = objData.m_expandRect;
    var left = expandRect.left;
    var right = expandRect.right;
    var top = expandRect.top % MMLogicPageHeight;
    var bottom = expandRect.bottom % MMLogicPageHeight;
    var topPage = Math.floor(expandRect.top / MMLogicPageHeight);
    var bottomPage = Math.floor(expandRect.bottom / MMLogicPageHeight);
    // var curPage = this.oc.getPageIndex();
    var curPage = obj.getPageIndex();
    var curPageTop = curPage * MMLogicPageHeight;
    var curPageBottom = curPage * MMLogicPageHeight + MMLogicPageHeight;
    maxoffset = {
      minY: -(expandRect.bottom - curPageTop - 0.5),
      //up
      maxY: curPageBottom - expandRect.top - 0.5,
      //down
      minX: -(right - 0.5),
      //left
      maxX: MMLogicPageWidth - left - 0.5 //right
    };
  }
  return maxoffset;
};
MMMovingOperation.prototype.limitOffset = function (offset) {
  var out = offset.clone();
  out.x = out.x < this.maxOffset.minX ? this.maxOffset.minX : out.x > this.maxOffset.maxX ? this.maxOffset.maxX : out.x;
  out.y = out.y < this.maxOffset.minY ? this.maxOffset.minY : out.y > this.maxOffset.maxY ? this.maxOffset.maxY : out.y;
  return out;
};
MMMovingOperation.prototype.onMouseMove = function (point, e, $opLayer) {
  var curPos = {
    x: e.clientX,
    y: e.clientY
  };
  var possibleOffset;
  var selectedObj = this.selectedObj;
  var userOffset = this.startPoint.offsetTo(point);
  possibleOffset = this.limitOffset(userOffset);
  if (this.$opLayer) {
    this.$opLayer.css('cursor', 'move');
  }
  ;
  if (selectedObj.m_objType === _ObjType["default"].Obj_comment) {
    var dvOffset = this.oc.getTransformer().lg2dvVec(possibleOffset);
    var parentOffset = {
      // (MMCommonFun.isPC() ?
      left: 0,
      top: 0
    };
    if (Math.abs(curPos.x - this.preMousePos.x) + Math.abs(curPos.y - this.preMousePos.y) >= 2) {
      dvOffset.x = Math.round(dvOffset.x + parentOffset.left);
      dvOffset.y = Math.round(dvOffset.y + parentOffset.top);
      Dispatcher.trigger(MDEvents.COMMENT_MOVE_TO_OFFSET, this.oc.m_editor, selectedObj, dvOffset);
    }
  } else if (selectedObj.m_objType === _ObjType["default"].Obj_niceTag) {
    var dvOffset = this.oc.getTransformer().lg2dvVec(possibleOffset);
    if (selectedObj.views) {
      for (var i = 0; i < this.selectedObj.views.length; i++) {
        selectedObj.views[i].el.style.left = selectedObj.views[i]._pos.x + dvOffset.x - 5 + "px";
        selectedObj.views[i].el.style.top = selectedObj.views[i]._pos.y + dvOffset.y - 8 + "px";
        selectedObj.views[i].updateDirection();
      }
    }
  }
  if (!MMCommonFun.isPC()) {
    this.updateDeleteArea(point, e);
  }
  this.preMousePos = curPos;
};
MMMovingOperation.prototype.updateDeleteArea = function (lp, e) {
  if (this.isMouseInDeleteArea(e)) {
    this.$deleteArea.css({
      "background-color": '#eb7f87',
      width: '80px',
      height: '70px',
      left: '0px',
      'margin-top': '-38px',
      'padding-top': '18px'
    });
  } else {
    this.$deleteArea.css({
      "background-color": '#000000',
      width: '60px',
      height: '50px',
      left: '0px',
      'margin-top': '-28px',
      'padding-top': '8px'
    });
  }
};
MMMovingOperation.prototype.isMouseInDeleteArea = function (e) {
  return e.clientX < 90 && Math.abs(window.innerHeight / 2 - e.clientY) < 50;
};
MMMovingOperation.prototype.onMouseUp = function (point, e) {
  var curPos = {
    x: e.clientX,
    y: e.clientY
  };
  if (this.$opLayer) {
    this.$opLayer.css('cursor', this.opOldCursor);
    this.$opLayer = null;
    console.log('restore cursor');
  }
  ;
  var longEnough = false;
  if (Math.abs(curPos.x - this.mouseStartPos.x) + Math.abs(curPos.y - this.mouseStartPos.y) >= 2) {
    longEnough = true;
  }
  var selectedObj = this.selectedObj;
  var userOffset = this.startPoint.offsetTo(point);
  var offset = this.limitOffset(userOffset);
  if (selectedObj.m_objType == _ObjType["default"].Obj_comment) {
    var dvOffset = offset.clone();
    dvOffset.x = 0;
    dvOffset.y = 0;
    longEnough && Dispatcher.trigger(MDEvents.COMMENT_MOVE_TO_OFFSET, this.oc.m_editor, selectedObj, dvOffset);
  }
  if (this.startPoint != null && longEnough && !app.pathRouter.inTrash()) {
    if (this.isMouseInDeleteArea(e) && !MMCommonFun.isPC()) {
      this.oc.getCurrentBoard().m_actionManager.deleteObject(this.selectedObj, {
        toUndo: false,
        realtime: true
      });
    } else {
      //var offset = this.startPoint.offsetTo(point);// new MMPoint(point.x-this.startPoint.x,point.y-this.startPoint.y);
      var objs = [selectedObj];
      if (selectedObj.m_objType == _ObjType["default"].Obj_comment || selectedObj.m_objType == _ObjType["default"].Obj_niceTag) {
        this.oc.getCurrentBoard().m_actionManager.move(objs, offset, true, true);
      }
    }
  }
  if (this.selectedObj.views) {
    _.delay(function () {
      for (var i = 0; i < this.selectedObj.views.length; i++) {
        this.selectedObj.views[i].el.style.transition = "";
        this.selectedObj.views[i].updateDirection();
      }
    }.bind(this), 2);
  }
  if (!this.m_isChild) {
    this.oc.setCurOperation();
  }
  if (!MMCommonFun.isPC()) {
    this.$deleteArea.animate({
      'left': '-50px'
    }, 400);
    setBabelTimeout(function () {
      this.$deleteArea.remove();
    }.bind(this), 400);
  }
  _MDPcMobileEditorCommonFun["default"].getMainEditor().refreshCommentsInEditor();
};
var _default = exports["default"] = MMMovingOperation;

},{"1023":1023,"1084":1084,"1184":1184,"1438":1438,"1454":1454,"807":807,"873":873}],873:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1461);
function MMOperation(option) {
  if (option) {
    var keys = Object.keys(option);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      this[key] = option[key];
    }
  }
}
;
MMOperation.prototype.onMouseDown = function (editor, point) {
  this.editorViewCtl.refreshCurrentMainEditor();
};
MMOperation.prototype.onMouseMove = function (editor, point) {};
MMOperation.prototype.onMouseUp = function (editor, point) {};
MMOperation.prototype.preDestroy = function () {};
MMOperation.prototype.getClassName = function () {
  return this.className;
};
MMOperation.prototype.setImgMarkerCtl = function (imgMarkerCtl) {
  this.imgMarkerCtl = imgMarkerCtl;
};
MMOperation.prototype.setEditorViewCtl = function (editorViewCtl) {
  this.editorViewCtl = editorViewCtl;
};
var _default = exports["default"] = MMOperation;

},{"1454":1454,"1461":1461}],859:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1438);
var _MDNew2DCommentInputView = _interopRequireDefault(require(333));
var _MMGraphCommentAppearance = _interopRequireDefault(require(890));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MDGraphDrawer = _interopRequireDefault(require(806));
// MDGraphCommentOperation.js
//
// jiang
// 2017-10-4

function MDGraphCommentOperation(operationCenter, curToolName) {
  // var $parentDiv = $(operationCenter.m_editor.getScrollContent());
  // var elCtl = MDHandMarkerElController;
  // var editor = operationCenter.m_editor;
  this.m_oc = operationCenter;
  this.curToolName = curToolName;
}
;
var g_minMoveDistance = 5;
_.extend(MDGraphCommentOperation.prototype, Object.prototype, function () {
  //----------------------------------------------------------------------------------------------------
  //       private function
  //----------------------------------------------------------------------------------------------------

  //----------------------------------------------------------------------------------------------------
  //       public function
  //----------------------------------------------------------------------------------------------------

  return {
    contstructor: MDGraphCommentOperation,
    construct: function construct() {},
    getClassName: function getClassName() {
      return "MDGraphCommentOperation";
    },
    onMouseDown: function onMouseDown(logicPt, overObj, e) {
      console.log('----- graph comment ----- mouse down');
      this.mouseDownCaptured = true;
      var pos = _MMCommonFun["default"].touchPosition(e);
      var p = _MMCommonFun["default"].convertPointBetweenElements($('body')[0], this.m_oc.getAssistantCanvas(), pos);
      this.startPt = p;
      this.graphDrawer = new _MDGraphDrawer["default"](this.m_oc.getAssistantCanvas(), this.curToolName);
      this.graphDrawer.mouseDown(p.x, p.y);
      this.lengthFromStart = 0;
    },
    onMouseMove: function onMouseMove(logicPt, e, $canvas) {
      var pos = _MMCommonFun["default"].touchPosition(e);
      this.prePos = pos;
      var p = _MMCommonFun["default"].convertPointBetweenElements($('body')[0], this.m_oc.getAssistantCanvas(), pos);
      var focusPoint = p;
      if (this.graphDrawer) {
        focusPoint = this.graphDrawer.mouseMove(p.x, p.y);
        this.curRct = null;
      }
      ;
    },
    onMouseUp: function onMouseUp(logicPt, e) {
      var pos = _MMCommonFun["default"].touchPosition(e);
      if (pos == null) {
        if (this.prePos) {
          pos = this.prePos;
        } else {
          return;
        }
      }
      var p = _MMCommonFun["default"].convertPointBetweenElements($('body')[0], this.m_oc.getAssistantCanvas(), pos);
      this.lengthFromStart = Math.sqrt((this.startPt.x - p.x) * (this.startPt.x - p.x) + (this.startPt.y - p.y) * (this.startPt.y - p.y));
      if (this.lengthFromStart < g_minMoveDistance) {
        this.mouseDownCaptured = false;
        this.graphDrawer = null;
        this.clearPanel();
        return;
      }
      ;
      if (this.mouseDownCaptured) {
        this._createComment(p.x, p.y);
      }
      ;
      this.mouseDownCaptured = false;
      var c = this.m_oc.getAssistantCanvas();
      var ctx = c.getContext("2d");
      // ctx.clearRect(0, 0, c.offsetWidth, c.offsetHeight);
      this.curRct = null;
      this.graphDrawer = null;
    },
    setImgMarkerCtl: function setImgMarkerCtl(imgMarker) {
      this.imgMarker = imgMarker;
    },
    preDestroy: function preDestroy() {
      this.clearPanel();
    },
    clearPanel: function clearPanel() {
      if (this.m_oc.createCommentView) {
        var createCommentView = this.m_oc.createCommentView;
        createCommentView.hide(function () {
          createCommentView.$el.remove();
          this.clearAssistantCanvas();
          if (createCommentView._$circleParent) createCommentView._$circleParent.remove();
          this.m_oc.createCommentView = null;
        }.bind(this));
      }
    },
    clearAssistantCanvas: function clearAssistantCanvas() {
      var c = this.m_oc.getAssistantCanvas();
      var ctx = c.getContext("2d");
      ctx.clearRect(0, 0, c.offsetWidth, c.offsetHeight);
    },
    _createComment: function _createComment(x, y) {
      var pts = [this.startPt, {
        x: x,
        y: y
      }];
      var commentPos = _MMGraphCommentAppearance["default"].calcuCommentPos(pts, this.curToolName);
      var $commentLayerParent = $(this.m_oc.m_editor.getCommentLayer()).parent();
      var assistView = this.m_oc.m_editor.getAssistantCanvas();
      var devicePoint = _MMCommonFun["default"].convertPointBetweenElements(assistView, $commentLayerParent[0], commentPos);
      var trsfm = this.m_oc.m_editor.getCanvasTransformerForAssist();
      var pgIndex = this.m_oc.getCurrentFilePageIndex();
      var lgPts = [];
      for (var i = 0; i < pts.length; i++) {
        var lgPt = trsfm.dv2lgPoint(pts[i], pgIndex);
        lgPts.push(lgPt);
      }
      ;
      var self = this;
      var position = {
        x: devicePoint.x - 1,
        y: devicePoint.y
      };
      this.m_oc.createCommentView = new _MDNew2DCommentInputView["default"]({
        showVisibleScope: true,
        v_pos: position,
        position: lgPts[0],
        page: this.m_oc.getCurrentFilePageIndex(),
        parentLayer: $commentLayerParent,
        editor: this.m_oc.m_editor,
        imgMarkerCtl: this.imgMarker,
        commentType: this.curToolName,
        lgPoints: lgPts,
        editorViewCtl: this.m_oc.editorViewCtl,
        onHide: function onHide() {
          self.clearAssistantCanvas();
        }
      });
      if (g_textCached) {
        this.m_oc.createCommentView.setContent(g_textCached);
      }
      application.addSubView(this.m_oc.createCommentView, $commentLayerParent[0]);
      this.m_oc.createCommentView.inputView.setFocus(true);
    }
  };
}());
var _default = exports["default"] = MDGraphCommentOperation;

},{"1184":1184,"1438":1438,"1454":1454,"333":333,"806":806,"812":812,"890":890}],890:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMGraphComment = _interopRequireDefault(require(1012));
// MMGraphCommentAppearance.js
//
// jiang
// 2017-10-2

function MMGraphCommentAppearance(editor, comment, trsfm, pgIndex) {
  this.editor = editor;
  this.comment = comment;
  this.trsfm = trsfm;
  this.pgIndex = pgIndex;
  var canvas = editor.getScribbleCanvas();
  this.ctx = canvas.getContext('2d');
}
;
_.extend(MMGraphCommentAppearance.prototype, Object.prototype, {
  constructor: MMGraphCommentAppearance,
  // html comment refresh
  drawInCanvas: function drawInCanvas() {
    var pts = this.comment.getPts();
    if (!pts) {
      return;
    }
    ;
    var dvPts = [];
    for (var i = 0; i < pts.length; i++) {
      var pt = this.trsgm.lg2dvPoint(pts[i], this.pgIndex);
      dvPts.push(pt);
    }
    ;
    var borderColor = MDColorDisk.getGraphCommentBorderColor();
    var contentColor = MDColorDisk.getGraphCommentContentColor();
    if (this.comment.commentType == 'arrowComment') {
      this._drawArrow(dvPts[0], dvPts[1]);
    } else if (this.comment.commentType == 'rectComment') {
      MDGraphDrawer.drawMultiBorderRect(this.ctx, borderColor, contentColor, this.comment.lineWidth, dvPts[0], dvPts[1]);
    } else {
      MDGraphDrawer.drawMultiBorderEllipse(this.ctx, borderColor, contentColor, this.comment.lineWidth, dvPts[0], dvPts[1]);
    }
  },
  _drawArrow: function _drawArrow(pos1, pos2) {
    var ctx = this.ctx;
    var borderColor = MDColorDisk.getGraphCommentBorderColor();
    var contentColor = MDColorDisk.getGraphCommentContentColor();
    MDGraphDrawer.drawArrow(ctx, borderColor, contentColor, pos1, pos2);
  },
  clear: function clear() {
    this.editor = null;
    this.comment = null;
    this.trsfm = null;
  }
});
MMGraphCommentAppearance.calcuCommentPos = function (pts, commentType) {
  return _MMGraphComment["default"].calcuCommentPos(pts, commentType);
};
var _default = exports["default"] = MMGraphCommentAppearance;

},{"1012":1012,"1184":1184,"1454":1454}],333:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1438);
require(1465);
var _MDColorDisk = _interopRequireDefault(require(856));
var _MDLineWidthAndFont = _interopRequireDefault(require(861));
var _MMCommentObj = _interopRequireDefault(require(1005));
var _MMGraphComment = _interopRequireDefault(require(1012));
var _MDNewCommentInputView = _interopRequireDefault(require(334));
var _MDCommentAnimator = _interopRequireDefault(require(317));
var _MDEvents = _interopRequireDefault(require(325));
var _MDPCEditorViewController = _interopRequireDefault(require(940));
var _MMColor = _interopRequireDefault(require(794));
var _int = _interopRequireDefault(require(820));
var _MMSketchCommentController = _interopRequireDefault(require(885));
var _MMObjElementsController = _interopRequireDefault(require(893));
var _MDGestureRecognizer = _interopRequireDefault(require(327));
var _MMFillType = _interopRequireDefault(require(795));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MMCommonFun = _interopRequireDefault(require(812));
/**
 *  任务版页面
 *
 *  Create by manjun.han
 *  2014.12.30
 */

var MDNew2DCommentInputView = _MDNewCommentInputView["default"].extend({
  initialize: function initialize(options) {
    _MDNewCommentInputView["default"].prototype.initialize.call(this, options);
    _MMCommonFun["default"].setTextInputInEditor('newComment');
  },
  send: function send(text, atIds) {
    if (this.$button.hasClass('disabled')) {
      return;
    }
    var text = this.getContent();
    if (text == '' && !this.hasSketch()) {
      _MDSnackbarView["default"].showStandardMsg(0);
      return;
    }
    if (this.sending) {
      return;
    }
    ;
    this.sending = true;
    var curWhiteboard = this.getBoard();
    var curDispVer = this.editorViewCtl.getVersionShowing();
    var comment = null;
    var commentLabel = BabelStr.str(7109);
    if (this.commentType == "arrowComment" || this.commentType == "ellipseComment" || this.commentType == "rectComment") {
      commentLabel = BabelStr.str(7110);
      comment = new _MMGraphComment["default"](curWhiteboard, this.commentType, curDispVer);
      comment.setPts(this.lgPoints);
      comment.graphColor = _MDColorDisk["default"].getCurColor();
      comment.lineWidth = _MDLineWidthAndFont["default"].getGraphCommentLineWidth();
    } else {
      comment = new _MMCommentObj["default"](curWhiteboard, curDispVer);
      comment.setPos(this.position); // 先设置属性，再进入 undo
    }
    var editorCtl = this.editor;
    comment.setPageIndex(this.page);
    comment.setVisibleScope(this.visibleScope);
    var filltype = new _MMFillType["default"]();
    ;
    filltype.setFill(true);
    var color = new _MMColor["default"]();
    color.m_r = 1;
    color.m_g = 0;
    color.m_b = 0;
    color.m_alpha = 1;
    filltype.setFillColor(color);
    comment.setFillType(filltype);
    var creatorId = new _int["default"](app.currentUser.id);
    comment.setRead(creatorId);
    comment.setCreator(creatorId);
    var editor = this.editorViewCtl.getCurEditor();
    comment.curScale = editor.getScale();
    comment.centerPos = editor.getCenterRatioPosition();
    this.showWaiting();
    var self = this;
    var option = {
      toUndo: true,
      realtime: true,
      isMark_: false
    };
    curWhiteboard.m_actionManager.addObject(comment, option, function (error) {
      if (!error) {
        if (self.hasSketch()) {
          var message = JSON.stringify({
            'Type': 'Text',
            'visibleScope': comment.getVisibleScope(),
            'Body': text,
            'atIds': atIds
          });
          _czc && _czc.push(["_trackEvent", "讨论", "创建批注", commentLabel + "（含手绘）", "", "#submitButton"]);
          _MMSketchCommentController["default"].sendSketch(message, atIds, comment.getVisibleScope(), comment, function success() {
            if (!comment.isEvalComment()) {
              _MDSnackbarView["default"].showStandardMsg('commentCreated');
            } else {
              _MDSnackbarView["default"].showStandardMsg('evalOpiCreated');
            }
            self._serverCallback();
          }, function fail(code) {
            if (code == undefined) {
              _MDSnackbarView["default"].showStandardMsg('networkerror');
            } else {
              if (!comment.isEvalComment()) {
                _MDSnackbarView["default"].showStandardMsg('commentFailed');
              } else {
                _MDSnackbarView["default"].showStandardMsg('opFailed');
              }
            }
            self._serverCallback();
          });
        } else {
          _czc && _czc.push(["_trackEvent", "讨论", "创建批注", commentLabel, "", "#submitButton"]);
          curWhiteboard.m_actionManager.sendMessage(JSON.stringify({
            'Type': 'Text',
            'Body': text,
            'atIds': atIds,
            'curScale': comment.curScale
          }), comment.getId(), function (error2) {
            if (!error2) {
              if (!comment.isEvalComment()) {
                _MDSnackbarView["default"].showStandardMsg('commentCreated');
              } else {
                _MDSnackbarView["default"].showStandardMsg('evalOpiCreated');
              }
              Dispatcher.trigger(_MDEvents["default"].Comment_changed);
            } else {
              if (!comment.isEvalComment()) {
                _MDSnackbarView["default"].showStandardMsg('commentFailed');
              } else {
                _MDSnackbarView["default"].showStandardMsg('opFailed');
              }
            }
            self._serverCallback();
          });
        }
      } else {
        _MDSnackbarView["default"].showStandardMsg('opFailed');
        self._serverCallback();
      }
    });
  },
  _serverCallback: function _serverCallback() {
    this.removeWaitingShow();
    this.sending = false;
    var self = this;
    var editorCtl = this.editor;
    var curOperation = editorCtl.getCurOperation();
    if (curOperation && curOperation.closeCommentInputView) {
      curOperation.closeCommentInputView();
    } else {
      /*
       * mashx to handle some bad situation...
       */
      self.removeFromSuperView();
    }
    g_textCached = undefined;
    // editorCtl.setCurOperation();
    this.setContent("");
    if (this.onHide) {
      this.onHide();
    }
    ;
  },
  sendText: function sendText(text, atIds) {
    var self = this;
    self.send(text, atIds);
    setBabelTimeout(function () {
      Dispatcher.trigger(_MDEvents["default"].Comment_State_Sync, self.getBoard().fileInfo.getFileId(), self);
    }, 300); //有待改进8/28 2016
  },
  hide: function hide(cb) {
    if (app.canDispInNormalBrowser()) {
      var editorCtl = _MDPCEditorViewController["default"].getCurrentInstance();
      if (editorCtl) {
        editorCtl.checkToEnablePrivateMouseWheel();
      }
      ;
    }
    ;
    _MDNewCommentInputView["default"].prototype.hide.call(this, cb);
    viewManager.remove('newCommentInput');
  },
  // getContent: function() {
  //   return this.inputView.getText().trim();
  // },

  // setContent: function(text) {
  //   this.inputView.setText(text);
  //   this.update();
  // },

  viewWillUnRendered: function viewWillUnRendered() {
    _MDNewCommentInputView["default"].prototype.viewWillUnRendered.call(this);
    viewManager.remove('newCommentInput');
  },
  viewDidRendered: function viewDidRendered() {
    _MDNewCommentInputView["default"].prototype.viewDidRendered.call(this);

    // var $window = $(window);
    // var parentWidth = parseInt($window.width());
    // var parentHeight = parseInt($window.height());
    // var myWidth = parseInt(this.$container.width());
    // var myHeight = parseInt(this.$container.height());
    // var myLeft = this.v_pos.x;
    // var myTop = this.v_pos.y;

    var color = g_keyColor;
    if (this.visibleScope >= 8) {
      color = _MDColorDisk["default"].commentColor.evaluation;
    }
    if (app.canDispInNormalBrowser()) {
      // var pointPos = {
      //   upward: 'top',
      //   sideward: 'left'
      // };

      // // keeping the view in frame,
      // if ((myLeft + myWidth) > parentWidth) {
      //   myLeft -= myWidth;
      //   pointPos.sideward = 'right';
      // }
      // if ((myTop + myHeight) > parentHeight) {
      //   myTop -= myHeight;
      //   pointPos.upward = 'bottom';
      // }
      //  //prepare the commentCircle
      // this._$circleParent = $('<div class="comment-pt cursor-move">');
      // this._$circleParent.css(pointPos.upward , 0);
      // this._$circleParent.css(pointPos.sideward , 0);

      this.recognizer = new _MDGestureRecognizer["default"](this._$circleParent[0]);
      this.recognizer.on(_MDEvents["default"].PAN, function (finger, e) {
        var maxOffset;
        // for Portrait, enought for the current edition (17.07.2015)
        var editorCtl = this.editor;
        var imageRect = editorCtl.getPicObject().getRect();
        //example: {top: 1725.78125, right: 15, bottom: 1734.21875, left: 0}
        // {x:5,y:1727}
        var trsfm = editorCtl.getCanvasTransformer();
        var lgOffset = {
          x: trsfm.dv2lgLen(finger.offset.x),
          y: trsfm.dv2lgLen(finger.offset.y)
        };
        if (lgOffset.x > 0) {
          maxOffset = imageRect.right - this.position.x;
          if (lgOffset.x > maxOffset) lgOffset.x = maxOffset;
        } else {
          maxOffset = imageRect.left - this.position.x;
          if (lgOffset.x < maxOffset) lgOffset.x = maxOffset;
        }
        if (lgOffset.y > 0) {
          maxOffset = imageRect.bottom - this.position.y;
          if (lgOffset.y > maxOffset) lgOffset.y = maxOffset;
        } else {
          maxOffset = imageRect.top - this.position.y;
          if (lgOffset.y < maxOffset) lgOffset.y = maxOffset;
        }
        this.position.x += lgOffset.x;
        this.$el[0].style.left = parseFloat(this.$el[0].style.left) + trsfm.lg2dvLen(lgOffset.x) + "px";
        this.position.y += lgOffset.y;
        this.$el[0].style.top = parseFloat(this.$el[0].style.top) + trsfm.lg2dvLen(lgOffset.y) + "px";
      }.bind(this));
      var _mainEditor = this.editor;
      _MMObjElementsController["default"].getSingleInstance().zoomScaleChanged(_mainEditor.getScale(), _mainEditor);
      _MDCommentAnimator["default"].createColoredClasses(color);

      //prepareing the touch recognizer
      _MDCommentAnimator["default"].init(this._$circleParent, 'CommentReaded-' + _MDCommentAnimator["default"].fixeColorName(color));
      // adding the new index to the comment circle
      var currentBoard = this.getBoard();
      var curDispVer = this.editorViewCtl.getVersionShowing();
      var comments = currentBoard.getCommentsForVersion(curDispVer);
      var pubCommentCount = 0;
      for (var i = comments.length - 1; i >= 0; i--) {
        var comment = comments[i];
        if (comment.getVisibleScope() == this.visibleScope) {
          pubCommentCount++;
        }
        ;
      }
      ;
      var commentDisplayIndex = pubCommentCount + 1;
      this._$circleParent.children().append(commentDisplayIndex);
      this.$container.append(this._$circleParent);
    }
    viewManager.add('newCommentInput', this);

    // this.$el.css({
    //   'left': myLeft,
    //   'top': myTop
    // });
    this.show();
    this.update();
  }
});
var _default = exports["default"] = MDNew2DCommentInputView;

},{"1005":1005,"1012":1012,"1184":1184,"1438":1438,"1454":1454,"1465":1465,"317":317,"325":325,"327":327,"334":334,"72":72,"76":76,"794":794,"795":795,"812":812,"820":820,"856":856,"861":861,"885":885,"893":893,"940":940}],1012:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMCommentObj = _interopRequireDefault(require(1005));
var _MMRect = _interopRequireDefault(require(831));
var _MMPoint = _interopRequireDefault(require(830));
var _MDGraphDrawer = _interopRequireDefault(require(806));
var _MDLineWidthAndFont = _interopRequireDefault(require(861));
var _MDColorDisk = _interopRequireDefault(require(856));
var _ObjType = _interopRequireDefault(require(1084));
//
//
//

function MMGraphComment(board, commentType, ver) {
  _MMCommentObj["default"].call(this, board, ver); //
  this.m_className = 'MMGraphComment';
  this.m_objType = _ObjType["default"].Obj_graphComment;
  this.statusRadius = 10;
  this.setRead(app.currentUser.getUserId_Int());
  this.pts = [];
  this.commentType = commentType; // 可能的值: "arrowComment", "ellipseComment", "rectComment"

  this.graphColor = 'red';
  this.lineWidth = 4;
}
;
MMGraphComment.prototype = new _MMCommentObj["default"](); //
MMGraphComment.superclass = _MMCommentObj["default"].prototype;
MMGraphComment.prototype.encode = function (enc_) {
  MMGraphComment.superclass.encode.call(this, enc_);

  // var ptNum = this.pts.length;
  // enc_.encode4Bytes(this.ptNum);

  // for (var i = 0; i < this.pts.length; i++) {
  //     enc_.encodeMMPoint(this.pts[i]);
  // };
  enc_.encodeArray(this.pts, 'MMPoint');
  enc_.encodeString(this.commentType);
  enc_.encodeString(this.graphColor);
  enc_.encode4Bytes(this.lineWidth);
};
MMGraphComment.prototype.decode = function (dec_, ver_) {
  MMGraphComment.superclass.decode.call(this, dec_, ver_);

  // var ptNum = dec_.decodeFrom4Bytes(ver_);

  this.pts = dec_.decodeFromArray(ver_, 'MMPoint');

  // for (var i = 0; i < ptNum; i++) {
  //   var pt = new MMPoint();
  //   pt = dec_.decodeFromMMPoint(ver_);
  //   this.pts.push(pt);
  // }

  this.commentType = dec_.decodeFromString(ver_);
  this.graphColor = dec_.decodeFromString(ver_);
  this.lineWidth = dec_.decodeFrom4Bytes(ver_);
  var commentPos = MMGraphComment.calcuCommentPos(this.pts, this.commentType);
  this.setPos(commentPos);
};
MMGraphComment.prototype.getRects = function () {
  return MMGraphComment.superclass.getRects.call(this);
};
MMGraphComment.prototype.setRects = function (rects) {
  MMGraphComment.superclass.setRects.setRects.call(this, rects);
};
MMGraphComment.prototype.getDispCenter = function () {
  return MMGraphComment.superclass.getDispCenter.call(this);
};
MMGraphComment.prototype.draw = function (ctx, trsfm, pgindex) {
  ctx.save();
  this.drawInCanvas(ctx, trsfm, pgindex);
  ctx.restore();
};
MMGraphComment.prototype.drawInCanvas = function (ctx, trsfm, pgindex) {
  var dvPts = [];
  for (var i = 0; i < this.pts.length; i++) {
    var lgPt = this.pts[i];
    var dvPt = trsfm.lg2dvPoint(lgPt, pgindex);
    dvPts.push(dvPt);
  }
  ;
  var borderColor = _MDColorDisk["default"].getGraphCommentBorderColor();
  var fillColor = _MDColorDisk["default"].getGraphCommentContentColor();
  var lineWidth = _MDLineWidthAndFont["default"].getGraphCommentLineWidth();
  if (this.commentType == "arrowComment") {
    _MDGraphDrawer["default"].drawArrow(ctx, borderColor, fillColor, dvPts[0], dvPts[1]);
  } else if (this.commentType == "rectComment") {
    _MDGraphDrawer["default"].drawMultiBorderRect(ctx, borderColor, fillColor, lineWidth, dvPts[0], dvPts[1]);
  } else if (this.commentType == "ellipseComment") {
    _MDGraphDrawer["default"].drawMultiBorderEllipse(ctx, borderColor, fillColor, lineWidth, dvPts[0], dvPts[1]);
  }
  ;
};
MMGraphComment.prototype.setPts = function (pts) {
  this.pts = pts;
  var commentPos = MMGraphComment.calcuCommentPos(pts, this.commentType);
  this.setPos(commentPos);
};
MMGraphComment.prototype.getPts = function (pts) {
  return this.pts;
};
MMGraphComment.calcuCommentPos = function (pts, commentType) {
  var commentPos = new _MMPoint["default"]();
  if (commentType == "arrowComment") {
    commentPos.x = (pts[0].x + pts[0].x) / 2;
    commentPos.y = (pts[0].y + pts[0].y) / 2;
  } else if (commentType == "rectComment") {
    commentPos.x = Math.min(pts[0].x, pts[1].x);
    commentPos.y = Math.min(pts[0].y, pts[1].y);
  } else if (commentType == "rectComment" || commentType == "ellipseComment") {
    // commentPos.x = (pts[0].x + pts[1].x) / 2;
    // commentPos.y = Math.min(pts[0].y, pts[1].y);
    commentPos.x = Math.min(pts[0].x, pts[1].x);
    commentPos.y = (pts[0].y + pts[1].y) / 2;
  }
  ;
  return commentPos;
};
MMGraphComment.prototype.getExpandRect = function () {
  var commentRect = this.m_expandRect.clone();
  var graphRect = new _MMRect["default"]();
  graphRect.initWithPtsBounadingBox(this.pts);
  graphRect.expand({
    top: 1,
    left: 1,
    right: 1,
    bottom: 1
  });
  commentRect.expandToInclude(graphRect);
  return commentRect;
};
var _default = exports["default"] = MMGraphComment;

},{"1005":1005,"1084":1084,"1184":1184,"1454":1454,"806":806,"830":830,"831":831,"856":856,"861":861}],327:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1421);
var _MDEvents = _interopRequireDefault(require(325));
/**
 * @constructor
 * @param el {htmlElement} the element where the events are going to me detected, you can add this to the body to capture all.
 * @param config {object} used to set some settings, read he first 10 lines of the method, and you see the options
 *
 * the events are:
 "  MDEvents.TAP
 *  MDEvents.DOUBLE_TAP
 *  MDEvents.PINCH_START
 *  MDEvents.PINCH
 *  MDEvents.PINCH_END
 *  MDEvents.THROW
 *  MDEvents.THROW_LEFT
 *  MDEvents.THROW_RIGHT
 *  MDEvents.LONG_PRESS
 *  MDEvents.touchstart
 *  MDEvents.touchmove
 *  MDEvents.PAN_START
 *  MDEvents.PAN
 *  MDEvents.PAN_END
 */
var MDGestureRecognizer = function MDGestureRecognizer(el, config) {
  "use strict";

  _.extend(this, Backbone.Events);
  config = config !== undefined ? config : {};
  this.swipeSpeed = config.swipeSpeed || 400;
  this.swipePrecision = config.swipePrecision || 6;
  this.minPinchDistance = config.minPinchDistance || 1;
  this.minSwipeDistance = config.minSwipeDistance || 20;
  this.longPressTime = config.longPressTime || 800;
  this.longTolerance = config.longTolerance || 5;
  this.tapTolerance = config.tapTolerance || 5;
  this.panDistance = config.panDistance || 5;
  this.doubleTapSpeed = 400;
  this.doubleTapDistance = 15;
  this.minThrowSpeed = config.minThrowSpeed || 200;
  this.minFirstPanDistance = config.minFirstPanDistance || 5;
  var touchMode = false;
  var touchStartHandler = function touchStartHandler(e) {
    touchMode = true;
    updateFinger(e.touches, e.timeStamp, e);
    console.log('--------------- touch start!');
    if (e.touches.length == 1) {
      document.body.addEventListener('touchmove', touchMoveHandler);
      document.body.addEventListener('touchend', touchEndHandler);
    }
  };
  var touchMoveHandler = function touchMoveHandler(e) {
    updateFinger(e.touches, e.timeStamp, e);
  };
  var touchEndHandler = function touchEndHandler(e) {
    if (!e.touches) e.touches = [];
    console.log('--------------- touch end!');
    updateFinger(e, e.timeStamp, e);
    if (!e.touches.length) {
      document.body.removeEventListener('touchmove', touchMoveHandler);
      document.body.removeEventListener('touchend', touchEndHandler);
    }
  };
  el.addEventListener('touchstart', touchStartHandler);
  var mouseStartHandler = function mouseStartHandler(e) {
    if (touchMode) return;
    mouseEventToTouch(e);
    if (!e.touches) e.touches = [];
    updateFinger(e.touches, e.timeStamp, e);
    if (e.touches.length == 1) {
      document.body.addEventListener('mousemove', mouseMoveHandler);
      document.body.addEventListener('mouseup', mouseEndHandler);
    }
  };
  var mouseMoveHandler = function mouseMoveHandler(e) {
    if (touchMode) return;
    mouseEventToTouch(e);
    if (!e.touches) e.touches = [];
    updateFinger(e.touches, e.timeStamp, e);
  };
  var mouseEndHandler = function mouseEndHandler(e) {
    if (touchMode) return;
    if (!e.touches) e.touches = [];
    updateFinger(e, e.timeStamp, e);
    if (!e.touches.length) {
      document.body.removeEventListener('mousemove', mouseMoveHandler);
      document.body.removeEventListener('mouseup', mouseEndHandler);
    }
  };
  el.addEventListener('mousedown', mouseStartHandler);
  function mouseEventToTouch(e) {
    if (e instanceof MouseEvent) {
      e.touches = [e];
    }
  }
  this.finger = {};
  var fingerCount = 0;
  var that = this;
  function updateFinger(finger, time, e) {
    if (!that) return;
    var orgPrevent = e.preventDefault;
    e.preventDefault = function () {
      orgPrevent.apply(e);
    };
    var i; // used for loops
    var identifier = []; // list of the touch identifirer on the given event
    for (i = 0; i < finger.length; i++) {
      // copy the touch Object to create compatibility between android and iOS
      // because iOS is not creating a new touch Object on touchmove.
      var curFinger = touchToFinger(finger[i], e);
      identifier.push(curFinger.identifier);
      if (!that.finger[curFinger.identifier]) {
        // for each new finger set the beginFinger
        that.finger[curFinger.identifier] = {
          beginFinger: curFinger
        };
        that.trigger(_MDEvents["default"].touchstart, that.finger[curFinger.identifier], e);
        fingerCount++;
        clearLongPress();
        if (identifier.length === 1 && that != null) detectLongpress(that.finger[curFinger.identifier], e);
      }
      if (!that) return;
      that.finger[curFinger.identifier].lastFinger = that.finger[curFinger.identifier].curFinger || curFinger;
      that.finger[curFinger.identifier].curFinger = curFinger;
      that.finger[curFinger.identifier].lastFinger.preventDefault = curFinger.preventDefault;
      that.finger[curFinger.identifier].lastFinger.stopPropagation = curFinger.stopPropagation;
    }
    for (i in that.finger) {
      if (identifier.indexOf(i) === -1 && identifier.length == 0) {
        var f = that.finger[i];
        delete that.finger[i];
        fingerCount--;
        detectSwipe(f, e);
        if (identifier.length == 0) detectThrow(f, e);
        detectTap(f, e);
        that.trigger(_MDEvents["default"].touchend, f, e);
        if (f.panning) {
          that.trigger(_MDEvents["default"].PAN_END, f, e);
        }
        clearLongPress();
        if (identifier.length < 2 && curPinch) {
          that.trigger(_MDEvents["default"].PINCH_END, curPinch, e);
          curPinch = null;
        }
      } else {
        detectMove(that.finger[i], e);
      }
    }
    detectPinch(e);
  }
  /**
   * helps to clone a touch object and adds a timeStamp
   */
  function touchToFinger(touch, e) {
    return {
      clientX: touch.clientX,
      clientY: touch.clientY,
      force: touch.force,
      identifier: touch.identifier,
      pageX: touch.pageX,
      pageY: touch.pageY,
      radiusX: touch.radiusX,
      radiusY: touch.radiusY,
      screenX: touch.screenX,
      screenY: touch.screenY,
      target: touch.target,
      timeStamp: e.timeStamp,
      currentTarget: e.currentTarget,
      preventDefault: function preventDefault() {
        e.preventDefault();
      },
      stopPropagation: function stopPropagation() {
        e.stopPropagation();
      }
    };
  }
  function detectMove(f, e) {
    if (fingerCount !== 1 || !f) return;
    f.offset = {
      x: f.curFinger.screenX - f.lastFinger.screenX,
      y: f.curFinger.screenY - f.lastFinger.screenY
    };
    that.trigger(_MDEvents["default"].touchmove, f, e);
    f.offset = {
      x: f.curFinger.screenX - f.lastFinger.screenX,
      y: f.curFinger.screenY - f.lastFinger.screenY
    };
    if (!f.longPressed) {
      if (f.panning) {
        that.trigger(_MDEvents["default"].PAN, f, e);
        // console.log("** panning");
      } else if (distanceOfFingers(f.beginFinger, f.curFinger) > that.minFirstPanDistance) {
        f.offset = {
          x: f.curFinger.screenX - f.beginFinger.screenX,
          y: f.curFinger.screenY - f.beginFinger.screenY
        };
        f.panning = true;
        that.trigger(_MDEvents["default"].PAN_START, f, e);
        that.trigger(_MDEvents["default"].PAN, f, e);
        // console.log("**--- start panning");
      }
    }
  }
  var lastTap = null;
  function detectTap(f, e) {
    if (fingerCount > 0) return;
    if (distanceOfFingers(f.beginFinger, f.lastFinger) > that.tapTolerance) return;

    //detect doubleTap
    if (lastTap && f.lastFinger !== lastTap.lastFinger && distanceOfFingers(f.lastFinger, lastTap.lastFinger) < that.doubleTapDistance && f.curFinger.timeStamp - lastTap.curFinger.timeStamp < that.doubleTapSpeed) {
      that.trigger(_MDEvents["default"].DOUBLE_TAP, f, e);
    } else if (!f.longPressed) {
      that.trigger(_MDEvents["default"].TAP, f, e);
      lastTap = f;
    }
  }
  var longPress = null;
  // used to detect a longpress, when only one finger is holded on the screen for 2 seconds
  function detectLongpress(f, e) {
    if (longPress) return;
    longPress = {
      finger: f,
      timeout: setBabelTimeout(function () {
        if (!longPress) return;
        if (longPress.finger.panning) return;
        if (distanceOfFingers(longPress.finger.beginFinger, longPress.finger.lastFinger) > that.longTolerance) return;
        longPress.finger.longPressed = true;
        that.trigger(_MDEvents["default"].LONG_PRESS, longPress.finger, e);
        longPress = null;
        updateFinger(e, e.timeStamp, e);
      }, that.longPressTime)
    };
  }
  function clearLongPress() {
    if (!longPress) return;
    clearTimeout(longPress.timeout);
    longPress = null;
  }
  var lastFingers = [1, 2];
  var lastDistance = null;
  var curPinch = null;
  var originDistance = null;
  function detectPinch(e) {
    var i;
    var finger = [];
    var curDistance;
    for (i in that.finger) {
      finger.push(that.finger[i]);
    }
    if (finger.length !== 2) return;
    if (lastFingers[0] === finger[0] && lastFingers[1] === finger[1]) {
      var dx = finger[0].curFinger.screenX - finger[1].curFinger.screenX;
      var dy = finger[0].curFinger.screenY - finger[1].curFinger.screenY;
      curDistance = Math.sqrt(dx * dx + dy * dy);
      if (lastDistance) {
        var distanceChange = curDistance - lastDistance;
        if (Math.abs(distanceChange) > that.minPinchDistance) {
          if (curPinch === null) {
            curPinch = 0;
            that.trigger(_MDEvents["default"].PINCH_START, originDistance, e);
            originDistance = curDistance;
          }
          curPinch = curDistance / originDistance;
          that.trigger(_MDEvents["default"].PINCH, curDistance / lastDistance, e);
        }
      }
    } else {
      lastDistance == null;
    }
    lastDistance = curDistance;
    lastFingers = finger;
  }
  function detectSwipe(finger, e) {
    if (finger.lastFinger.timeStamp - finger.beginFinger.timeStamp < that.swipeSpeed) {
      if (distanceOfFingers(finger.beginFinger, finger.lastFinger) < that.minSwipeDistance) return;
      if (Math.abs(finger.beginFinger.screenX - finger.lastFinger.screenX) / that.swipePrecision > Math.abs(finger.beginFinger.screenY - finger.lastFinger.screenY)) {
        that.trigger(_MDEvents["default"].SWIPE, e, finger.beginFinger.screenX - finger.lastFinger.screenX);
        // up-down swipe
        if (finger.beginFinger.screenX - finger.lastFinger.screenX < 0) {
          that.trigger(_MDEvents["default"].SWIPE_LEFT, e, Math.abs(finger.beginFinger.screenX - finger.lastFinger.screenX));
        } else {
          that.trigger(_MDEvents["default"].SWIPE_RIGHT, e, Math.abs(finger.beginFinger.screenX - finger.lastFinger.screenX));
        }
      } else if (Math.abs(finger.beginFinger.screenX - finger.lastFinger.screenX) < Math.abs(finger.beginFinger.screenY - finger.lastFinger.screenY) / that.swipePrecision) {
        that.trigger(_MDEvents["default"].SWIPE, finger.beginFinger.screenX - finger.lastFinger.screenX);
        if (finger.beginFinger.screenY - finger.lastFinger.screenY < 0) {
          that.trigger(_MDEvents["default"].SWIPE_UP, e, Math.abs(finger.beginFinger.screenY - finger.lastFinger.screenY));
        } else {
          that.trigger(_MDEvents["default"].SWIPE_DOWN, e, Math.abs(finger.beginFinger.screenY - finger.lastFinger.screenY));
        }
      }
    }
  }

  //detects left and right throw
  function detectThrow(f) {
    var deltaTime = f.curFinger.timeStamp - f.lastFinger.timeStamp;
    var deltaX = f.curFinger.screenX - f.lastFinger.screenX;
    var deltaY = f.curFinger.screenY - f.lastFinger.screenY;
    var delta = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
    var speedX = 1000 / deltaTime * deltaX;
    var speed = 1000 / deltaTime * delta;
    if (speed > that.minThrowSpeed) {
      that.trigger(_MDEvents["default"].THROW, speed);
      if (deltaX < 0) {
        that.trigger(_MDEvents["default"].THROW_RIGHT, speed);
      } else {
        that.trigger(_MDEvents["default"].THROW_LEFT, speed);
      }
      if (deltaY < 0) {
        that.trigger(_MDEvents["default"].THROW_UP, speed);
      } else {
        that.trigger(_MDEvents["default"].THROW_DOWN, speed);
      }
    }
  }
  function distanceOfFingers(one, two) {
    var dx = Math.abs(one.screenX - two.screenX);
    var dy = Math.abs(one.screenY - two.screenY);
    return Math.sqrt(dx * dx + dy * dy);
  }
  this.destroy = function () {
    if (!el) return;
    el.removeEventListener(_MDEvents["default"].touchstart, touchStartHandler);
    el.removeEventListener(_MDEvents["default"].touchmove, touchMoveHandler);
    el.removeEventListener(_MDEvents["default"].touchend, touchEndHandler);
    this.off();
    this.finger = null;
    lastFingers = null;
    clearLongPress();
    that = null;
    el = null;
  };
};
var _default = exports["default"] = MDGestureRecognizer;

},{"1184":1184,"1421":1421,"1454":1454,"325":325}],434:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1414);
require(1466);
var _MDTextCommentCreationPanel = _interopRequireDefault(require(432));
var _MDTextCommentEditPanel = _interopRequireDefault(require(433));
var _MMBasicData = _interopRequireDefault(require(811));
var MDTextCommentPanelCtl = {
  $el: $('<div class="p-textcomment-root" style="position:absolute;left:0px;top:0px;width:100%;height:100%;overflow: hidden">' + '<canvas class="p-comment-canvas" style="position:absolute;left:0px;top:0px;"></canvas>' + '<div class="p-textcomment mousevent" style="position:absolute;left:0px;top:0px;"></div>' + '</div>' + ''),
  setBoardVersionShowing: function setBoardVersionShowing(ver) {
    this.versionShowing = ver;
  },
  setViewCtl: function setViewCtl(ctl) {
    this.editorViewCtl = ctl;
    this.versionShowing = ctl.getVersionShowing();
  },
  showCreationPanel: function showCreationPanel(pos, posFromDiv, text, lgRcts, board, pgIndex, success, fail) {
    var self = MDTextCommentPanelCtl;
    self.showReply = false;
    self.replyShowed = false;
    MDTextCommentPanelCtl.lgRcts = lgRcts;
    MDTextCommentPanelCtl.board = board;
    MDTextCommentPanelCtl.pgIndex = pgIndex;
    MDTextCommentPanelCtl.text = text;
    MDTextCommentPanelCtl.successCall = success;
    MDTextCommentPanelCtl.failCall = fail;
    if (lgRcts.length == 0 || !board) {
      console.error('call MDTextCommentPanelCtl with wrong parameters!');
      return;
    }
    ;
    self._clearDiv();
    MDTextCommentPanelCtl.initialize('create');
    self.targetPos = MMCommonFun.convertPointBetweenElements(posFromDiv, self.$canvas[0], pos);
    self._displayArrowPanel(self.targetPos);
  },
  showReplyPanel: function showReplyPanel(pdfPageEditor, textCommentObj) {
    var self = MDTextCommentPanelCtl;
    if (pdfPageEditor.getCurrentFilePageIndex() == textCommentObj.getPageIndex() && !self.replyShowed) {
      self.showReply = true;
      var trsfm = pdfPageEditor.getCanvasTransformer();
      var lgRcts = textCommentObj.getRects();
      var firstRct = lgRcts[0].clone();
      var dvRct = trsfm.lg2dvRect(firstRct);
      var topRight = {
        x: dvRct.right,
        y: dvRct.top
      };
      var layer = pdfPageEditor.getPdfTextMarkLayer()[0];
      self._clearDiv();
      var replyOpt = {
        textCommentObj: textCommentObj,
        pdfPageEditor: pdfPageEditor
      };
      self.initialize('reply', replyOpt);
      self.targetPos = MMCommonFun.convertPointBetweenElements(layer, self.$canvas[0], topRight);
      self._displayArrowPanel(self.targetPos);
      self.replyShowed = true;
    }
    ;
  },
  _clearDiv: function _clearDiv() {
    var self = MDTextCommentPanelCtl;
    self.$el.find('.p-textcomment').empty();
    self.$el.remove();
    self.replyShowed = false;
  },
  _displayArrowPanel: function _displayArrowPanel(targetPos) {
    var bodyW = $('body').width();
    var bodyH = $('body').height();
    var self = MDTextCommentPanelCtl;
    var top = targetPos.y - 200;
    if (top + self.panelH > bodyH) {
      top = bodyH - self.panelH;
    }
    ;
    if (top - 50 < 0) {
      top = 50;
    }
    ;
    var left = targetPos.x + 200;
    if (left + self.panelW > bodyW) {
      left = bodyW - self.panelW;
    }
    ;
    if (left < targetPos.x) {
      left = targetPos.x - self.panelW - 100;
    }
    ;
    var anchor = {
      x: left,
      y: top
    };
    var panelRct = self.drawArrow(targetPos, anchor);
    self.setTxtPos(panelRct);
  },
  setTxtPos: function setTxtPos(panelRct) {
    var self = MDTextCommentPanelCtl;
    self.$panel.css('left', panelRct.x + 'px');
    self.$panel.css('top', panelRct.y + 'px');
    self.$panel.css('width', panelRct.w + 'px');
    self.$panel.css('height', panelRct.h + 'px');
    if (self.showReply) {
      self.$panel.css('width', '380px');
      self.$panel.css('height', '380px');
    }
    ;
  },
  drawArrow: function drawArrow(targetPos, anchor) {
    var self = MDTextCommentPanelCtl;
    var arrowH = 40;
    var anchorBottom = {
      x: anchor.x,
      y: anchor.y + arrowH
    };
    var anchorMid = {
      x: anchor.x,
      y: anchor.y + arrowH / 2
    };
    var w = $('body')[0].offsetWidth;
    var h = $('body')[0].offsetHeight;
    self.cxt.clearRect(0, 0, w, h);

    // if (self.type=='create') {
    //  self.cxt.fillStyle='rgba(254, 237, 111,0.8)';
    // } else {
    self.cxt.fillStyle = 'rgba(254, 237, 111,0.3)';
    // }

    self.cxt.strokeStyle = 'rgba(254, 237, 111,0.8)';
    self.cxt.lineWidth = 1;

    // self.cxt.shadowBlur = 10;
    // self.cxt.shadowColor='gray';
    // self.cxt.shadowOffsetX=0;
    // self.cxt.shadowOffsetY=0;

    var lineW = self.lineW;
    var lineH = self.lineH;
    var radius = self.radius;

    //arrow
    self.cxt.beginPath();
    self.cxt.moveTo(targetPos.x, targetPos.y);

    // self.cxt.bezierCurveTo(anchorMid.x, anchorMid.y, anchorMid.x, anchorMid.y, anchor.x, anchor.y);
    self.cxt.quadraticCurveTo(anchorMid.x, anchorMid.y, anchor.x, anchor.y);
    self.cxt.lineTo(anchorBottom.x, anchorBottom.y);

    // self.cxt.bezierCurveTo(anchorMid.x, anchorMid.y, anchorMid.x, anchorMid.y, targetPos.x, targetPos.y);
    self.cxt.quadraticCurveTo(anchorMid.x, anchorMid.y, targetPos.x, targetPos.y);
    var leftop = {
      x: anchor.x,
      y: anchor.y - radius
    };
    if (self.showReply) {
      self.cxt.fill();
      self.cxt.stroke();
    } else {
      if (anchor.x < targetPos.x) {
        self.cxt.fill();
      }
      ;
      self.cxt.fill();
      self.cxt.stroke();
      self.cxt.fillStyle = 'rgba(254, 237, 111,0.8)';
      self.cxt.strokeStyle = 'rgba(254, 237, 111,1)';
      self.cxt.beginPath();
      self.leftop = leftop;
      self.cxt.moveTo(anchor.x, anchor.y);
      //left top
      self.cxt.lineTo(leftop.x, leftop.y + radius);
      self.cxt.arcTo(leftop.x, leftop.y, leftop.x + radius, leftop.y, radius);
      self.cxt.lineTo(leftop.x + radius + lineW, leftop.y);

      // right top
      self.cxt.arcTo(leftop.x + 2 * radius + lineW, leftop.y, leftop.x + 2 * radius + lineW, leftop.y + radius, radius);
      self.cxt.lineTo(leftop.x + 2 * radius + lineW, leftop.y + radius + lineH);

      // right bottom
      self.cxt.arcTo(leftop.x + 2 * radius + lineW, leftop.y + 2 * radius + lineH, leftop.x + 1 * radius + lineW, leftop.y + 2 * radius + lineH, radius);
      self.cxt.lineTo(leftop.x + 1 * radius, leftop.y + 2 * radius + lineH);

      // left bottom
      self.cxt.arcTo(leftop.x, leftop.y + 2 * radius + lineH, leftop.x, leftop.y + 1 * radius + lineH, radius);
      self.cxt.lineTo(anchor.x, anchor.y);
      self.cxt.fill();
      self.cxt.stroke();
    }
    return {
      x: leftop.x,
      y: leftop.y,
      w: self.panelW,
      h: self.panelH
    };
  },
  initialize: function initialize(type, replyOpt) {
    var z_maxIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
    MDTextCommentPanelCtl.$el.css('z-index', z_maxIndex);
    $('.app-root').append(MDTextCommentPanelCtl.$el);
    var self = MDTextCommentPanelCtl;
    self.lineW = 300;
    self.lineH = 300;
    self.radius = 5;
    self.panelW = self.lineW + 2 * self.radius;
    self.panelH = self.lineH + 2 * self.radius;
    self.type = type;
    self.$canvas = self.$el.find('.p-comment-canvas');
    self.$panel = self.$el.find('.p-textcomment');
    var w = $('body')[0].offsetWidth;
    var h = $('body')[0].offsetHeight;
    self.$canvas.attr('width', w + 'px');
    self.$canvas.attr('height', h + 'px');
    self.cxt = self.$canvas[0].getContext('2d');
    self.panel = null;
    var $panelRoot = self.$el.find('.p-textcomment');
    if (type == 'create') {
      self.radius = 8;
      _MDTextCommentCreationPanel["default"].versionShowing = this.versionShowing;
      _MDTextCommentCreationPanel["default"].editorViewCtl = this.editorViewCtl;
      _MDTextCommentCreationPanel["default"].renderTo($panelRoot, self.text, self.lgRcts, self.board, self.pgIndex, function () {
        Dispatcher.trigger(MDEvents.NULL_OPERATION, {
          editorViewCtl: self.editorViewCtl
        });
        self.remove();
      }, function fail() {});
    } else if (type == 'reply') {
      self.panelW = 380;
      self.panelH = 380;
      _MDTextCommentEditPanel["default"].versionShowing = this.versionShowing;
      _MDTextCommentEditPanel["default"].editorViewCtl = this.editorViewCtl;
      _MDTextCommentEditPanel["default"].renderTo($panelRoot, replyOpt.pdfPageEditor, replyOpt.textCommentObj, function (type1) {
        if (type1 == 'close') {
          self.remove();
          Dispatcher.trigger(MDEvents.NULL_OPERATION, {
            editorViewCtl: self.editorViewCtl
          });
        } else {}
      }, function fail() {});
    }
    Dispatcher.on(MDEvents.COMMENT_REMOVE, this.remove, this);
    self.registerEvents();
  },
  registerEvents: function registerEvents() {
    var self = MDTextCommentPanelCtl;
    self.$el.find('.mousevent').on('mousedown', function (e) {
      self.mousedown(e);
    });
    self.$el.find('.mousevent').on('mousemove', function (e) {
      self.mousemove(e);
    });
    self.$el.find('.mousevent').on('mouseup', function (e) {
      self.mouseup(e);
    });
    self.$el.on('mouseup', function (e) {
      e.stopPropagation();
      self.rootClick(e);
    });
    self.$el.on('mousemove', function (e) {
      e.stopPropagation();
      if (self.prePos) {
        self.mousemove(e);
      }
    });
  },
  okClicked: function okClicked() {
    var self = MDTextCommentPanelCtl;
    var textInput = self.$el.find();
    self.remove();
    self._createTextComment();
  },
  remove: function remove() {
    $('.p-textcomment-root').css('background-color', 'rgba(0,0,0,0.0)');
    var self = MDTextCommentPanelCtl;
    MDTextCommentPanelCtl.$el.remove();
    if (MDTextCommentPanelCtl.successCall) {
      MDTextCommentPanelCtl.successCall();
    }
    ;
    self.replyShowed = false;
    _MDTextCommentEditPanel["default"].remove();
  },
  rootClick: function rootClick(e) {
    var self = MDTextCommentPanelCtl;
    self.remove();
  },
  mousedown: function mousedown(e) {
    var self = MDTextCommentPanelCtl;
    self.prePos = {
      x: e.clientX,
      y: e.clientY
    };
    self.movelen = 0;
    e.stopPropagation();
  },
  mousemove: function mousemove(e) {
    e.stopPropagation();
    var self = MDTextCommentPanelCtl;
    var pos = {
      x: e.clientX,
      y: e.clientY
    };
    var $win = $(window);
    var winHeight = $win.height();
    var winWidth = $win.width();
    var width = parseInt($(".m-comment-panel").css("width"));
    var height = parseInt($(".m-comment-panel").css('height'));
    var leftPanelWidth = $(".p-commentsNavi-zone").width();
    if (self.prePos) {
      var dx = pos.x - self.prePos.x;
      var dy = pos.y - self.prePos.y;
      var left = parseInt(self.$panel.css('left'));
      var top = parseInt(self.$panel.css('top'));
      left = left + dx >= 0 ? left + dx : 0;
      top = top + dy >= 0 ? top + dy : 0;
      left = left + width > winWidth ? winWidth - width : left;
      left = left < leftPanelWidth ? leftPanelWidth : left;
      top = top + height > winHeight ? winHeight - height : top;
      self.$panel.css('left', left + 'px');
      self.$panel.css('top', top + 'px');
      self.movelen += Math.sqrt(dx * dx + dy * dy);
      console.log('-------' + self.movelen);
      self.prePos = pos;
      var leftTop = {
        x: left,
        y: top + self.radius
      };
      self.drawArrow(self.targetPos, leftTop);
    }
    ;
  },
  mouseup: function mouseup(e) {
    e.stopPropagation();
    var self = MDTextCommentPanelCtl;
    self.prePos = null;
    if (self.movelen < 5) {}
    ;
    self.movelen = 0;
  },
  setImgMarkerCtl: function setImgMarkerCtl(imgMarkerCtl) {
    this.imgMarkerCtl = imgMarkerCtl;
    _MDTextCommentEditPanel["default"].setImgMarkerCtl(imgMarkerCtl);
  }
};
var _default = exports["default"] = MDTextCommentPanelCtl;

},{"1184":1184,"1414":1414,"1417":1417,"1454":1454,"1463":1463,"1466":1466,"432":432,"433":433,"811":811}],433:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
var _int = _interopRequireDefault(require(820));
var _MDCommentSlidePanelView = _interopRequireDefault(require(319));
var _MMTextComment = _interopRequireDefault(require(1032));
var MDTextCommentEditPanel = {
  renderTo: function renderTo($parenDiv, pdfPageEditor, textCommentObj, success, fail) {
    var self = MDTextCommentEditPanel;
    self.$el = $('<div>');
    self.$parenDiv = $parenDiv;
    $parenDiv.append(self.$el);
    var panel = new _MDCommentSlidePanelView["default"]({
      view: pdfPageEditor,
      comment: textCommentObj,
      disableMax: true,
      imgMarkerCtl: this.imgMarkerCtl,
      editorViewCtl: this.editorViewCtl,
      onCloseBtnClicked: function onCloseBtnClicked() {
        success('close');
      },
      onRemove: function onRemove() {
        self.commentPanel = null;
      }
    });
    application.addSubView(panel, self.$el[0]);
    self.registerEvents();
    panel.show();
    MDTextCommentEditPanel.commentPanel = panel;
  },
  show: function show(text, lgRcts, board, pgIndex, success, fail) {
    MDTextCommentEditPanel.lgRcts = lgRcts;
    MDTextCommentEditPanel.board = board;
    MDTextCommentEditPanel.pgIndex = pgIndex;
    MDTextCommentEditPanel.text = text;
    MDTextCommentEditPanel.successCall = success;
    MDTextCommentEditPanel.failCall = fail;
    MDTextCommentEditPanel.$parenDiv.find('.p-comment-text').text(text);
  },
  initialize: function initialize() {},
  registerEvents: function registerEvents() {
    var self = MDTextCommentEditPanel;
    self.$parenDiv.find('.p-comment-text').on('mousedown', function (e) {
      self.textmousedown(e);
    });
    self.$parenDiv.find('.p-comment-text').on('mousemove', function (e) {
      if (self.prePos) {
        self.mousemove(e);
      } else {
        self.textmousemove(e);
      }
    });
    self.$parenDiv.find('.p-comment-text').on('mouseup', function (e) {
      self.textmouseup(e);
    });
    self.$parenDiv.find('.closeBt').on('click', function (e) {
      self.successCall();
    });
    self.$parenDiv.find('.OK').on('click', function (e) {
      self.okClicked();
    });
  },
  okClicked: function okClicked() {
    var self = MDTextCommentEditPanel;
    self._createTextComment();
    self.successCall();
  },
  textmousedown: function textmousedown(e) {
    var self = MDTextCommentEditPanel;
    self.catchDown = true;
    e.stopPropagation();
  },
  textmousemove: function textmousemove(e) {
    if (MDTextCommentEditPanel.catchDown) {
      e.stopPropagation();
    }
    ;
  },
  textmouseup: function textmouseup(e) {
    self.catchDown = false;
    e.stopPropagation();
  },
  _createTextComment: function _createTextComment() {
    var self = MDTextCommentEditPanel;
    var curWhiteboard = MDTextCommentEditPanel.board;
    var textComment = new _MMTextComment["default"](curWhiteboard, versionShowing);
    textComment.setPageIndex(MDTextCommentEditPanel.pgIndex);
    var creatorId = new _int["default"](app.currentUser.id);
    textComment.setRead(creatorId);
    textComment.setCreator(creatorId);
    textComment.setRects(MDTextCommentEditPanel.lgRcts);
    var option = {
      toUndo: true,
      realtime: true,
      isMark_: false
    };
    curWhiteboard.m_actionManager.addObject(textComment, option);
    var text = self.$parenDiv.find('.p-comment-text').text;
    // curWhiteboard.m_actionManager.sendMessage(JSON.stringify({
    //     'Type': 'Text',
    //     'Body': text
    // }), textComment.getId());
  },
  remove: function remove() {
    if (MDTextCommentEditPanel.commentPanel) {
      var panel = MDTextCommentEditPanel.commentPanel;
      MDTextCommentEditPanel.commentPanel = null;
      panel.removeFromSuperView();
    }
    ;
  },
  setImgMarkerCtl: function setImgMarkerCtl(imgMarkerCtl) {
    this.imgMarkerCtl = imgMarkerCtl;
  }
};
var _default = exports["default"] = MDTextCommentEditPanel;

},{"1032":1032,"1184":1184,"1417":1417,"1454":1454,"1463":1463,"319":319,"820":820}],432:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1498);
var _int = _interopRequireDefault(require(820));
var _MMTextComment = _interopRequireDefault(require(1032));
var MDTextCommentCreationPanel = {
  $el: $('<button class="closeBt">' + BabelStr.str(156) + '</button>' + '<textarea class="p-comment-text" style="" placeholder="' + BabelStr.str(5158) + '"></textarea>' + '<button class="copy">' + BabelStr.str(2653) + '</button>' + '<button class="OK">' + BabelStr.str(154) + '</button>' + ''),
  renderTo: function renderTo($parenDiv, text, lgRcts, board, pgIndex, success, fail) {
    var self = MDTextCommentCreationPanel;
    self.$parenDiv = $parenDiv;
    $parenDiv.append(self.$el);
    self.show(text, lgRcts, board, pgIndex, success, fail);
    self.registerEvents();
  },
  show: function show(text, lgRcts, board, pgIndex, success, fail) {
    MDTextCommentCreationPanel.lgRcts = lgRcts;
    MDTextCommentCreationPanel.board = board;
    MDTextCommentCreationPanel.pgIndex = pgIndex;
    MDTextCommentCreationPanel.text = text;
    MDTextCommentCreationPanel.successCall = success;
    MDTextCommentCreationPanel.failCall = fail;
    MDTextCommentCreationPanel.$parenDiv.find('.p-comment-text').val(text);
    MDTextCommentCreationPanel.$parenDiv.find('.p-comment-text').focus();
    MDTextCommentCreationPanel.$parenDiv.find('.p-comment-text').select();

    // 隐藏提示功能
    $('.textCommentPrompt').remove();
  },
  initialize: function initialize() {},
  registerEvents: function registerEvents() {
    var self = MDTextCommentCreationPanel;
    self.$parenDiv.find('.p-comment-text').on('mousedown', function (e) {
      self.textmousedown(e);
    });
    self.$parenDiv.find('.p-comment-text').on('mousemove', function (e) {
      if (self.prePos) {
        self.mousemove(e);
      } else {
        self.textmousemove(e);
      }
    });
    self.$parenDiv.find('.p-comment-text').on('mouseup', function (e) {
      self.textmouseup(e);
    });
    self.$parenDiv.find('.closeBt').on('click', function (e) {
      self.successCall();
    });
    self.$parenDiv.find('.OK').on('click', function (e) {
      self.okClicked();
    });
    self.$parenDiv.find('.copy').on('click', function (e) {
      self.copyClicked();
    });
  },
  okClicked: function okClicked() {
    var self = MDTextCommentCreationPanel;
    var text = self.$parenDiv.find('.p-comment-text').val();
    if (text.trim().length == 0) {
      self.successCall();
    } else {
      self._createTextComment();
      self.successCall();
    }
  },
  copyClicked: function copyClicked() {
    var self = this;
    var $btn = MDTextCommentCreationPanel.$parenDiv.find('.copy');
    var clipboard = new Clipboard($btn.get(0), {
      text: function text() {
        return MDTextCommentCreationPanel.$parenDiv.find('.p-comment-text').val();
      }
    });
    clipboard.on('success', function (e) {
      e.clearSelection();
      self.successCall();
    });
    clipboard.on('error', function (e) {
      var tip = "";
      if (app.os.mac) {
        tip = BabelStr.str(7149);
      } else {
        tip = BabelStr.str(7150);
      }
      MDTextCommentCreationPanel.$parenDiv.find('.p-comment-text').select();
      // self.showTooltip($btn, tip);
    });
    this.clipboard = clipboard;
  },
  textmousedown: function textmousedown(e) {
    var self = MDTextCommentCreationPanel;
    self.catchDown = true;
    e.stopPropagation();
  },
  textmousemove: function textmousemove(e) {
    if (MDTextCommentCreationPanel.catchDown) {
      e.stopPropagation();
    }
    ;
  },
  textmouseup: function textmouseup(e) {
    var self = MDTextCommentCreationPanel;
    self.catchDown = false;
    e.stopPropagation();
  },
  _createTextComment: function _createTextComment() {
    var self = MDTextCommentCreationPanel;
    var curWhiteboard = MDTextCommentCreationPanel.board;
    var textComment = new _MMTextComment["default"](curWhiteboard, this.versionShowing);
    textComment.setPageIndex(MDTextCommentCreationPanel.pgIndex);
    var creatorId = new _int["default"](app.currentUser.id);
    textComment.setRead(creatorId);
    textComment.setCreator(creatorId);
    textComment.setRects(MDTextCommentCreationPanel.lgRcts);
    var option = {
      toUndo: true,
      realtime: true,
      isMark_: false
    };
    curWhiteboard.m_actionManager.addObject(textComment, option);
    _czc && _czc.push(["_trackEvent", "讨论", "发送批注信息", "创建文本批注", "", "#submitButton"]);
    var text = self.$parenDiv.find('.p-comment-text').val();
    curWhiteboard.m_actionManager.sendMessage(JSON.stringify({
      'Type': 'Text',
      'Body': text
    }), textComment.getId());
    Dispatcher.trigger(MDEvents.Comment_changed);
  }
};
var _default = exports["default"] = MDTextCommentCreationPanel;

},{"1032":1032,"1184":1184,"1417":1417,"1454":1454,"1463":1463,"1498":1498,"820":820}],1032:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1414);
require(1466);
require(1437);
require(1463);
require(1478);
require(1421);
var _MMObject = _interopRequireDefault(require(1081));
var _ObjType = _interopRequireDefault(require(1084));
var _MMBasicData = _interopRequireDefault(require(811));
var _MMCommonFun = _interopRequireDefault(require(812));
var _CommentStatus = _interopRequireDefault(require(1036));
var _MMRect = _interopRequireDefault(require(831));
var _MMPointObj = _interopRequireDefault(require(1023));
var _box = _interopRequireDefault(require(833));
var _MMPoint = _interopRequireDefault(require(830));
var _MMPathDrawer = _interopRequireDefault(require(896));
function MMTextComment(board, ver) {
  _MMObject["default"].call(this, board, ver); //
  this.m_className = 'MMTextComment';
  this.m_objType = _ObjType["default"].Obj_textComment;
  this.statusRadius = 10;
  this.setRead(app.currentUser.getUserId_Int());
}
;
MMTextComment.prototype = new _MMObject["default"](); //
MMTextComment.superclass = _MMObject["default"].prototype;
MMTextComment.prototype.encode = function (enc_) {
  _MMPointObj["default"].superclass.encode.call(this, enc_);
};
MMTextComment.prototype.decode = function (dec_, ver_) {
  _MMPointObj["default"].superclass.decode.call(this, dec_, ver_);
};
MMTextComment.prototype.getRects = function () {
  var data = this.getObjData();
  if (data) {
    return data.m_rects;
  } else {
    return new Array();
  }
};
MMTextComment.prototype.setRects = function (rects) {
  var data = this.getObjData();
  if (data) {
    data.setRects(rects);
  }
  this.m_expandRect = new _MMRect["default"](0, 0, 0, 0);
  if (rects.length > 0) {
    this.m_expandRect = rects[0].clone();
    for (var i = 1; i < rects.length; i++) {
      this.m_expandRect.expandToInclude(rects[i]);
    }
    ;
  }
  ;
  this.m_rect = this.m_expandRect.clone();
};
MMTextComment.prototype.getDispCenter = function () {
  var rects = this.getRects();
  if (rects && rects.length > 0) {
    return rects[0].getCenter();
  }
  ;
  return new _MMRect["default"]();
};
MMTextComment.prototype.draw = function (ctx, trsfm, pgindex) {
  ctx.save();
  this.drawInCanvas(ctx, trsfm, pgindex);
  ctx.restore();
};
MMTextComment.prototype.drawInCanvas = function (ctx, trsfm, pgindex) {
  var data = this.getObjData();
  if (data) {
    var objRct = this.m_expandRect;
    if (objRct == undefined) return;
    var pgRct = new _MMRect["default"]();
    var lgpgsize = _MMBasicData["default"].pageSize;
    pgRct.setRct(0, pgindex * lgpgsize.height, lgpgsize.width, lgpgsize.height);
    try {
      if (_box["default"].intersects(pgRct, objRct)) {
        var rects = this.getRects();
        for (var i = 0; i < rects.length; i++) {
          var pts = [];
          pts.push(new _MMPoint["default"](rects[i].left, rects[i].top));
          pts.push(new _MMPoint["default"](rects[i].right, rects[i].top));
          pts.push(new _MMPoint["default"](rects[i].right, rects[i].bottom));
          pts.push(new _MMPoint["default"](rects[i].left, rects[i].bottom));
          var drawer = new _MMPathDrawer["default"](ctx, data.m_strokeType, data.m_fillType, data.m_shadowType, trsfm, pgindex);
          drawer.drawPolyline(pts, 0, pts.length, true);
        }
        if (rects.length > 0) {
          var curUser = app.currentUser;
          var status = this.getReadStatus(curUser.getUserId_Int());
          if (status != _CommentStatus["default"].Comment_read) {
            var lgTopRight = new _MMPoint["default"](rects[0].right, rects[0].top);
            var dvTopRgith = trsfm.lg2dvPoint(lgTopRight, pgindex);
            ctx.fillStyle = "rgba(255, 0, 0, 1.0)";
            ctx.strokeStyle = "rgba(255, 255, 255, 1.0)";
            ctx.lineWidth = 1;
            ctx.beginPath();
            ctx.arc(dvTopRgith.x, dvTopRgith.y, this.statusRadius, 0, 2 * Math.PI);
            ctx.fill();
            ctx.stroke();
          }
          ;
        }
        ;
      }
    } catch (e) {
      console.log("circle draw in canvas error !!!! ->" + e.message);
    }
  }
};
MMTextComment.prototype.setRead = function (usrId) {
  var data = this.getObjData();
  if (data) {
    data.setRead(usrId);
  }
};
MMTextComment.prototype.getReadStatus = function (usrId) {
  var data = this.getObjData();
  if (data) {
    return data.getReadStatus(usrId);
  } else {
    return false;
  }
};
MMTextComment.prototype.setStatusForUserId = function (userId, status) {
  var data = this.getObjData();
  if (data) {
    data.setStatusForUserId(userId, status);
  }
};
MMTextComment.prototype.setHasNewReplyFromUser = function (userId) {
  var data = this.getObjData();
  if (data) {
    data.setHasNewReplyFromUser(userId);
  }
};
MMTextComment.prototype.setFinished = function (finished) {
  var data = this.getObjData();
  if (data) {
    data.setFinished(finished);
  }
};
MMTextComment.prototype.isFinished = function () {
  var data = this.getObjData();
  if (data) {
    return data.isFinished();
  } else {
    return false;
  }
};
MMTextComment.prototype.praise = function (userId_) {
  var data = this.getObjData();
  if (data) {
    data.praise(userId_);
  }
};
MMTextComment.prototype.isPraised = function (userId_) {
  var data = this.getObjData();
  if (data) {
    return this.getObjData().isPraised(userId_);
  } else {
    return false;
  }
};
MMTextComment.prototype._creationTime = null;
MMTextComment.prototype.getCreationTime = function (pt, error) {
  if (this._creationTime) return this._creationTime;
  var data = this.getObjData();
  var currentWhiteboard = this.getBoard();
  if (!currentWhiteboard) return null;
  var firstPost = currentWhiteboard.getChatLog(this.getId())[0];
  var time = parseInt(firstPost.m_time.toString());
  return time || null;
};
MMTextComment.prototype.getIndex = function () {
  var curDispVer = this.getFileVersion();
  return this.getBoard().getCommentsForVersion(curDispVer).indexOf(this) + 1;
};
MMTextComment.prototype.getStatusPosition = function () {
  var rects = this.getRects();
  if (rects.length > 0) {
    return new _MMPoint["default"](rects[0].right, rects[0].top);
  }
  ;
};
MMTextComment.prototype.getStatusRadius = function () {
  return this.statusRadius;
};
MMTextComment.prototype.fetchChatlog = function (callback) {
  this.getObjData().commentBasicData.fetchChatlog(this.getId(), callback);
};
MMTextComment.prototype.isEvalComment = function () {
  return false;
};
var _default = exports["default"] = MMTextComment;

},{"1023":1023,"1036":1036,"1081":1081,"1084":1084,"1184":1184,"1414":1414,"1421":1421,"1437":1437,"1454":1454,"1463":1463,"1466":1466,"1478":1478,"811":811,"812":812,"830":830,"831":831,"833":833,"896":896}],427:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1466);
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDEditorVerticalToolbar = _interopRequireDefault(require(417));
var _MDBasicToolbar = _interopRequireDefault(require(804));
// MDPenToolbar.js
// javascript/moladisk/views/editor/MDPenToolbar.js
// jiang
// 2017-10-5

var MDPenToolbar = _MDEditorVerticalToolbar["default"].extend({
  toolTmp: function toolTmp() {
    return '<li class="b-pen-li" data-group="pen">' + '<button class="button-icon p-pen-comment  button-li  f-pointer" tool-name="penComment" data-tooltip="<%=pen%>"></button>' + '</li>' + '<li class="b-pen-li" data-group="pen">' + '<button class="button-icon b-erase-comment  button-li  f-pointer" tool-name="penEraser" data-tooltip="<%=eraser%>"></button>' + '</li>' + '<li class="tool-splider">' + '</li>' + '<%=colors%>' + '<li class="tool-splider">' + '</li>' + '<%=lines%>' + '';
  },
  render: function render(data) {
    var colors = '';
    for (var i = 0; i < MDPenToolbar.colors.length; i++) {
      var color = MDPenToolbar.colors[i];
      var $divStr = '<li class="b-color-li" data-group="color">' + '<button class="b-color b-color-' + i + '  button-li  f-pointer" tool-name="color" data-tooltip="' + color + '" style="background-color: ' + color + '"></button>' + '</li>';
      colors += $divStr;
    }
    var lines = '';
    for (var _i = 0; _i < MDPenToolbar.lines.length; _i++) {
      var line = MDPenToolbar.lines[_i] + 'px';
      var $divStr = '<li class="b-line-li" data-group="line">' + '<div class="b-line b-line-' + _i + '  button-li  f-pointer" tool-name="lineWidth" data-tooltip="' + line + '"><div/></div>' + '</li>';
      lines += $divStr;
    }
    var data = {
      'eraser': _MDLocalString["default"].getLocalString(2041),
      // 板擦
      'pen': _MDLocalString["default"].getLocalString(787),
      // 手绘笔
      'colors': colors,
      'lines': lines
    };

    // render
    _MDEditorVerticalToolbar["default"].prototype.render.call(this, data);
    this.initDefaultSelected();
  },
  initProps: function initProps() {
    var superP = _MDEditorVerticalToolbar["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      editorViewCtl: null,
      disableToggle: true
    });
  },
  events: function events() {
    var superE = _MDEditorVerticalToolbar["default"].prototype.events.call(this);
    return _.extend(superE, {});
  },
  initialize: function initialize(opt) {
    _MDEditorVerticalToolbar["default"].prototype.initialize.call(this, opt);
    Dispatcher.on(MDEvents.CommentToolChangedNotByClick, this._changedByOthers, this);
    Dispatcher.on(MDEvents.NULL_OPERATION, this._clearTool, this);
    this.$el.css('left', '50px');
  },
  initDefaultSelected: function initDefaultSelected() {
    // set deault color selected
    var colorIndex = -1;
    for (var i = 0; i < MDPenToolbar.colors.length; i++) {
      var color = MDPenToolbar.colors[i];
      if (color == MDPenToolbar.color) {
        colorIndex = i;
        break;
      }
    }
    colorIndex = this.$('.b-color-' + colorIndex).parent().index();
    this.setToolSelected(colorIndex);

    // 默认选中的线宽
    var widthIndex = -1;
    for (var _i2 = 0; _i2 < MDPenToolbar.lines.length; _i2++) {
      var line = MDPenToolbar.lines[_i2];
      if (line == MDPenToolbar.line) {
        widthIndex = _i2;
        break;
      }
    }
    widthIndex = this.$('.b-line-' + widthIndex).parent().index();
    this.setToolSelected(widthIndex);

    // 默认选中的工具
    this.setToolSelected(0);
  },
  setEditorViewCtl: function setEditorViewCtl(editorViewCtl) {
    _MDEditorVerticalToolbar["default"].prototype.setEditorViewCtl.call(this, editorViewCtl);
  },
  _changedByOthers: function _changedByOthers(toolName) {
    if (toolName == 'comment') {
      // this.setToolSelected(0);
      // this.editorViewCtl.setCurOperation('comment');
      this.clearSelect();
    }
    ;
  },
  _clearTool: function _clearTool(params) {
    var isMarkerEvent = params.isMark;
    var editorViewCtl = params.editorViewCtl;
    if (!isMarkerEvent && this.editorViewCtl == editorViewCtl) {
      this.clearSelect();
    }
    ;
  },
  _beforeFileChanged: function _beforeFileChanged(e) {
    _MDEditorVerticalToolbar["default"].prototype._beforeFileChanged.call(this, e);
    this.$('.b-text-comment').hide();
    this.clearSelect();
  },
  _afterFileChanged: function _afterFileChanged(e) {
    _MDEditorVerticalToolbar["default"].prototype._afterFileChanged.call(this, e);
    var fileInfo = this.editorViewCtl.getCurrentFileInfo();
    if (fileInfo.canDispInOpenGL() || !fileInfo.canCreateComment() || fileInfo.isCADFile()) {
      this.$el.hide();
    } else {}
  },
  // comment tool selected
  _toolSelected: function _toolSelected(e) {
    this.editorViewCtl.disableZoomRectLayer();
    Dispatcher.trigger(MDEvents.HideZoomRectLayer);
    var selected = _MDEditorVerticalToolbar["default"].prototype._toolSelected.call(this, e);
    if (selected) {
      Dispatcher.trigger(MDEvents.SHOW_COMMENTS);
    }
  },
  _toolClicked: function _toolClicked(e) {
    var selected = _MDBasicToolbar["default"].prototype._toolClicked.call(this, e);
    if (selected) {
      var curTarget = e.currentTarget;
      var toolName = $(curTarget).attr('tool-name');
      if (toolName == "penComment" || toolName == "penEraser") {
        this.editorViewCtl.setCurOperation(toolName);
        Dispatcher.trigger(MDEvents.toolbarChanged, toolName, this.editorViewCtl);
      } else {
        if (toolName == "color") {
          console.log($(curTarget).data().tooltip);
          MDPenToolbar.color = $(curTarget).data().tooltip;
        } else if (toolName == "lineWidth") {
          console.log($(curTarget).data().tooltip);
          MDPenToolbar.line = parseInt($(curTarget).data().tooltip);
        }
      }
    } else {
      this.editorViewCtl.setCurOperation();
    }
    return selected;
  }
}, {
  className: 'MDPenToolbar',
  colors: ['#FFFFFF', '#49FFFF', '#56B8F4', '#F5CF51', '#DD0000', '#000000'],
  lines: [1, 2, 3, 4, 5],
  color: "#DD0000",
  line: 3,
  getColor: function getColor() {
    return MDPenToolbar.color;
  },
  getLineWidth: function getLineWidth() {
    return MDPenToolbar.line;
  }
});
var _default = exports["default"] = MDPenToolbar;

},{"1150":1150,"1184":1184,"1454":1454,"1466":1466,"417":417,"804":804}],417:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDBasicToolbar = _interopRequireDefault(require(804));
// MDEditorVerticalToolbar.js
// jiang
// 2017-10-14

var MDEditorVerticalToolbar = _MDBasicToolbar["default"].extend({
  toolTmp: function toolTmp() {
    return '<li class="b-样例">' + '<button class="button-icon 样例  button-li  f-pointer" tool-name="样例" data-tooltip="样例"></button>' + '</li>' + '';
  },
  initProps: function initProps() {
    var superP = _MDBasicToolbar["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      editorViewCtl: null
    });
  },
  events: function events() {
    var superE = _MDBasicToolbar["default"].prototype.events.call(this);
    return _.extend(superE, {});
  },
  initialize: function initialize(opt) {
    _MDBasicToolbar["default"].prototype.initialize.call(this, opt);

    // 与其他 toolbar 进行通信，了解其他 toolbar 的状态
    Dispatcher.on(MDEvents.toolbarChanged, this._onToolChanged, this);
  },
  setEditorViewCtl: function setEditorViewCtl(editorViewCtl) {
    this.editorViewCtl = editorViewCtl;
  },
  _beforeFileChanged: function _beforeFileChanged(e) {
    this.$el.hide();
  },
  _afterFileChanged: function _afterFileChanged(e) {},
  _onToolChanged: function _onToolChanged(toolName) {
    var $toolItems = this.$('.button-li');
    var found = false;
    for (var i = 0; i < $toolItems.length; i++) {
      var $tool = $($toolItems[i]);
      if ($tool.attr('tool-name') == toolName) {
        found = true;
        break;
      }
      ;
    }
    ;
    if (!found) {
      // 其他 toolbar 设置了，清理自己的 toolbar 的选中状态
      this.clearSelect();
    }
    ;
  },
  // comment tool selected
  _toolClicked: function _toolClicked(e) {
    var selected = _MDBasicToolbar["default"].prototype._toolClicked.call(this, e);
    if (selected) {
      var curTarget = e.currentTarget;
      var toolName = $(curTarget).attr('tool-name');
      this.editorViewCtl.setCurOperation(toolName);
      Dispatcher.trigger(MDEvents.toolbarChanged, toolName, this.editorViewCtl);
    } else {
      this.editorViewCtl.setCurOperation();
      Dispatcher.trigger(MDEvents.toolbarChanged, "", this.editorViewCtl);
    }
    return selected;
  }
}, {
  className: 'MDEditorVerticalToolbar'
});
var _default = exports["default"] = MDEditorVerticalToolbar;

},{"1184":1184,"1454":1454,"804":804}],453:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1432);
require(1454);
require(1451);
require(1466);
require(1437);
require(1461);
var _ObjType = _interopRequireDefault(require(1084));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDEvents = _interopRequireDefault(require(325));
var _MMRect = _interopRequireDefault(require(831));
// MDBabelTileView
//
// jiang
// 2018-06-28
//

var MDBabelTileView = function MDBabelTileView(imgObj, containerDiv, scrollView, opt) {
  var self = this;
  var g_imgTileSize = 256;
  var g_tileWaitingQueue = [];
  var g_tileDrawingQueue = [];
  var g_maxCountDrawing = 4; // 最大同时绘制的 tile 数

  var g_viewCtl = opt.editorViewCtl;
  var g_enabelCachePdf = true;
  var g_pdfCachedBuffer = {};
  function addToWaitingQueue(tile) {
    g_tileWaitingQueue.push(tile);
  }
  function getNextWaitingTile() {
    var visibleTileBox = self.currentTileLayer.tilesSeeInViewBox;
    var visibleTile = null;
    for (var i = 0; i < g_tileWaitingQueue.length; i++) {
      var tile = g_tileWaitingQueue[i];
      if (tile.standScale == self.currentTileLayer.standScale) {
        if (tile.row >= visibleTileBox.startYi && tile.row <= visibleTileBox.endYi && tile.col >= visibleTileBox.startXi && tile.col <= visibleTileBox.endXi) {
          visibleTile = tile;
          g_tileWaitingQueue.splice(i, 1); // 从队列中删除
          break;
        }
      }
    }
    if (!visibleTile) {
      visibleTile = g_tileWaitingQueue.shift();
    }
    return visibleTile;
  }
  function getCachedPdfImage(tile) {
    if (!g_enabelCachePdf) {
      return null;
    }
    var stScale = tile.standScale;
    var imageMatrix = g_pdfCachedBuffer[stScale];
    if (!imageMatrix) {
      g_pdfCachedBuffer[stScale] = {};
      return null;
    }
    var row = imageMatrix[tile.row];
    if (!row) {
      imageMatrix[tile.row] = {};
      return null;
    }
    return row[tile.col];
  }
  function cachePdfImage(tile, cxt) {
    if (!g_enabelCachePdf) {
      return;
    }
    var imgData = cxt.getImageData(0, 0, g_imgTileSize, g_imgTileSize);
    g_pdfCachedBuffer[tile.standScale][tile.row][tile.col] = imgData;
    // cxt.clearRect(0, 0, 100, 100);
    // cxt.putImageData(imgData, 0, 0);
  }
  this.imgObj = imgObj;
  this.containerDiv = containerDiv;
  this.scrollView = scrollView;
  (function calcuMinStandScale() {
    var originSize = this.imgObj.getOriginSize();
    var area = originSize.x * originSize.y;
    var scale = 1.0;
    while (area / 4 > 256 * 256) {
      area /= 4;
      scale /= 2;
    }
    this.minStandScale = scale;
  }).call(this);
  var _scale = 0;
  var self = this;
  Object.defineProperty(this, 'scale', {
    get: function get() {
      return _scale;
    },
    set: function set(newScale) {
      if (_scale != newScale) {
        _scaleChanged.call(self, newScale);
      }
      ;
      _scale = newScale;
    },
    enumerable: true,
    configurable: true
  });

  // MDBaseTile
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  var MDBaseTile = function BaseTileClass() {
    var MDBaseTile = function MDBaseTile(tileInfo, layerDiv, imgObj, standScale, row, col, renderedCb) {
      if (!tileInfo) {
        return;
      }
      this.imgObj = imgObj;
      this.standScale = standScale;
      this.row = row;
      this.col = col;
      this.renderedCb = renderedCb;
      this.drawFinished = false;

      // this.$div = $('<img style="position:absolute;border:0px solid blue;">');
      this.$div = this.createDiv(tileInfo);
      this.updateWithSize(tileInfo);
      $(layerDiv).append(this.$div);
      addToWaitingQueue(this);
      _drawImg.call(this);
      function _drawImg() {
        var self = this;

        // 获得允许绘制的 tile 数： 最大数减去当前绘制数量
        var numCanDraw = g_maxCountDrawing - g_tileDrawingQueue.length;
        if (numCanDraw < 0) {
          return;
        }
        for (var i = 0; i < numCanDraw; i++) {
          var tile = getNextWaitingTile();
          if (!tile) {
            renderedCb();
            return;
          }
          ;
          g_tileDrawingQueue.push(tile);
          tile.draw(function success() {
            // 绘制
            g_tileDrawingQueue.remove(tile);
            _drawImg();
          }, function () {
            g_tileDrawingQueue.remove(tile);
            _drawImg();
          });
        }
      }
    };
    Object.assign(MDBaseTile.prototype, {}, function () {
      return {
        constructor: MDBaseTile,
        createDiv: function createDiv() {},
        draw: function draw(success, fail) {},
        stopDrawing: function stopDrawing() {},
        removeFromSuperView: function removeFromSuperView() {
          this.removed = true;
          this.$div.remove();
          this.imgObj;
          for (var i = 0; i < g_tileWaitingQueue.length; i++) {
            var tile = g_tileWaitingQueue[i];
            if (tile == this) {
              g_tileWaitingQueue.splice(i, 1);
              this.renderedCb(tile);
              break;
            }
            ;
          }
          ;
          for (var i = 0; i < g_tileDrawingQueue.length; i++) {
            var tile = g_tileDrawingQueue[i];
            if (tile == this) {
              g_tileDrawingQueue.splice(i, 1);
              this.renderedCb(tile);
              break;
            }
            ;
          }
          ;
        },
        updateWithSize: function updateWithSize(tileInfo) {
          this.$div.css('left', Math.round(this.col * tileInfo.tileSize) + 'px');
          this.$div.css('top', Math.round(this.row * tileInfo.tileSize) + 'px');
          if (this.row == tileInfo.maxRow) {
            if (tileInfo.modH > 1) {
              this.$div.css('height', tileInfo.modH + 'px');
            } else {
              return;
            }
          } else {
            this.$div.css('height', tileInfo.tileSize + 'px');
          }
          if (this.col == tileInfo.maxCol) {
            if (tileInfo.modW > 1) {
              this.$div.css('width', tileInfo.modW + 'px');
            } else {
              return;
            }
          } else {
            this.$div.css('width', tileInfo.tileSize + 'px');
          }
        }
      };
    }());
    return MDBaseTile;
  }();

  // class MDImgTile
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  var MDImgTile = function ImgTileClass() {
    var MDImgTile = function MDImgTile(tileInfo, layerDiv, imgObj, standScale, row, col, callback) {
      MDBaseTile.call(this, tileInfo, layerDiv, imgObj, standScale, row, col, callback);
    };
    MDImgTile.prototype = new MDBaseTile();
    Object.assign(MDImgTile.prototype, function () {
      return {
        constructor: MDImgTile,
        draw: function draw(success, fail) {
          var standard = this.standard;
          var whiteboard = this.imgObj.getBoard();
          if (!whiteboard) {
            return;
          }
          ;
          var fileInfo = whiteboard.getFileInfo();
          if (!fileInfo) {
            return;
          }
          ;
          var fileSrc = '/netdrive/getSliceImage.do?' + 'fileId=' + fileInfo.getFileId() + '&version=' + g_viewCtl.getVersionShowing() + '&scale=' + Math.round(1 / this.standScale) + '&row=' + this.row + '&col=' + this.col;
          var img = new Image(); //this.$div[0];

          img.src = fileSrc;
          var self = this;
          img.onload = function (e) {
            self.drawFinished = true;
            if (!self.removed) {
              self.$div.css('background-image', 'url(' + fileSrc + ')');
              self.renderedCb(self);
              success && success();
            }
            ;
          };
          img.onerror = function (e) {
            self.renderedCb(self);
            fail && fail();
          };
        },
        createDiv: function createDiv(tileInfo) {
          return $('<div style="position:absolute;border:none;background-size: 100% 100%;background-repeat: no-repeat;background-position: center center;"></div>');
        }
      };
    }());
    return MDImgTile;
  }();

  // pdf tile
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  var MDPdfTile = function ImgTileClass() {
    var MDPdfTile = function MDPdfTile(tileInfo, layerDiv, imgObj, standScale, row, col, callback) {
      MDBaseTile.call(this, tileInfo, layerDiv, imgObj, standScale, row, col, callback);
    };
    MDPdfTile.prototype = new MDBaseTile();
    Object.assign(MDPdfTile.prototype, function () {
      return {
        constructor: MDPdfTile,
        createDiv: function createDiv(tileInfo) {
          return $('<canvas style="position:absolute;border:none;" width="256px" height="256px"></canvas>');
        },
        updateWithSize: function updateWithSize(tileInfo) {
          MDBaseTile.prototype.updateWithSize.call(this, tileInfo);
          if (this.attrSizeSetted) {
            return;
          }
          this.attrSizeSetted = true;
          var canvasH = parseInt(this.$div.attr('height'));
          var canvasW = parseInt(this.$div.attr('width'));
          if (this.row == tileInfo.maxRow) {
            if (tileInfo.modH > 1) {
              var h = Math.round(g_imgTileSize * tileInfo.modH / tileInfo.tileSize);
              if (canvasH != h) {
                this.$div.attr('height', h + 'px');
              }
            } else {
              return;
            }
          } else {
            if (canvasH != g_imgTileSize) {
              this.$div.attr('height', g_imgTileSize + 'px');
            }
          }
          if (this.col == tileInfo.maxCol) {
            if (tileInfo.modW > 1) {
              var w = Math.round(g_imgTileSize * tileInfo.modW / tileInfo.tileSize);
              if (canvasW != w) {
                this.$div.attr('width', w + 'px');
              }
            } else {
              return;
            }
          } else {
            if (canvasW != g_imgTileSize) {
              this.$div.attr('width', '256px');
            }
          }
        },
        // -----------------------------------------------------------------  draw pdf tile
        draw: function draw(success, fail) {
          var standard = this.standard;
          var whiteboard = this.imgObj.getBoard();
          if (!whiteboard) {
            return;
          }
          ;
          var canvas = this.$div[0];
          var self = this;
          var context = canvas.getContext('2d');
          var standScale = this.standScale;
          var imgCached = getCachedPdfImage(this);
          if (imgCached) {
            context.putImageData(imgCached, 0, 0);
            setBabelTimeout(function () {
              self.renderedCb(self);
              success();
            }, 100);
          } else {
            this.imgObj.getPdfPage(function (page) {
              var viewport = page.getViewport(standScale);
              var dx = -self.col * g_imgTileSize;
              var dy = -self.row * g_imgTileSize;
              context.clearRect(0, 0, canvas.width, canvas.height);
              var a = viewport.rotation * Math.PI / 180;
              var t0 = Math.cos(a) * standScale;
              var t1 = Math.sin(a) * standScale;
              var t2 = t1;
              var t3 = -t0;
              var t4 = viewport.transform[4];
              var t5 = viewport.transform[5];
              viewport.transform = [t0, t1, t2, t3, t4 + dx, t5 + dy];

              // setBabelTimeout(function(){
              self.task = page.render({
                'canvasContext': context,
                'viewport': viewport
              });
              self.task.then(function () {
                self.drawFinished = true;
                self.renderedCb(self);
                console.log('(' + self.row + ', ' + self.col + ')-------------> end :' + new Date().getTime());
                self.task = null;
                if (g_enabelCachePdf) {
                  cachePdfImage(self, context);
                }
                success(); // ---------------------------------------- 返回，绘制下一个 tile
              }, function () {
                self.renderedCb(self);
                fail();
              });
              // }, 100);
            });
          }
        },
        stopDrawing: function stopDrawing() {
          this.task && this.task.cancel();
          this.renderedCb(this);
        },
        removeFromSuperView: function removeFromSuperView() {
          MDBaseTile.prototype.removeFromSuperView.call(this);
          if (this.task) {
            this.task.cancel();
          }
          g_tileWaitingQueue.remove(this);
          g_tileDrawingQueue.remove(this);
          this.renderedCb(this);
        }
      };
    }());
    return MDPdfTile;
  }();

  // class MDImgPdfTileLayer
  ////////////////////////////////////////////////////////////////////////////////////////////////////////

  var MDImgPdfTileLayer = function ImgTileLayerClass() {
    var layerId = 0;
    var MDImgPdfTileLayer = function MDImgPdfTileLayer(imgObj, standScale, parentDiv, scrollView) {
      this.id = layerId++;
      console.log('create layer :', this.id);
      var $tileContainer = $('<div class="tile-container" style="position:relative;width:0px;height:0px"></div>');
      $(parentDiv).prepend($tileContainer);
      this.imgObj = imgObj;
      var originSize = this.imgObj.getOriginSize();
      this.standScale = standScale;
      var maxCol = Math.floor(originSize.x * standScale / g_imgTileSize);
      var maxRow = Math.floor(originSize.y * standScale / g_imgTileSize);
      var modW = Math.round(originSize.x * standScale - maxCol * g_imgTileSize);
      var modH = Math.round(originSize.y * standScale - maxRow * g_imgTileSize);
      this.tilesLoading = [];
      this.tileInfo = {
        standScale: standScale,
        maxCol: maxCol,
        maxRow: maxRow,
        modW: modW,
        modH: modH
      };
      this.$tileContainer = $tileContainer;
      this.scrollView = scrollView;
      this.expand = 0; // 在窗口外面多绘制几行 tile
      if (imgObj.getObjType() == _ObjType["default"].Obj_Image) {
        this.expand = 2;
      }
      this.tileMatrix = [];
      for (var i = 0; i <= maxRow; i++) {
        var tileInRow = [];
        for (var j = 0; j <= maxCol; j++) {
          tileInRow.push(null);
        }
        ;
        this.tileMatrix.push(tileInRow);
      }
      ;
    };
    MDImgPdfTileLayer.prototype = {
      removeFromSuperView: function removeFromSuperView() {
        console.log('remove layer:', this.id);
        this.$tileContainer.remove();
        for (var i = 0; i < this.tileMatrix.length; i++) {
          var tileInRow = this.tileMatrix[i];
          for (var j = 0; j < tileInRow.length; j++) {
            var tile = tileInRow[j];
            if (tile) {
              tile.removeFromSuperView();
            }
            ;
          }
          ;
        }
        ;
      },
      recordCurrentLayer: function recordCurrentLayer(curLayer) {
        this.curLayer = curLayer;
      },
      delayRefresh: function delayRefresh(callback) {
        var self = this;
        setBabelTimeout(function () {
          self.refresh(function (tile) {
            console.log('----> delayRefresh callback');
            callback(tile);
          });
          // console.log('refresh with standard scale:' + self.standScale);
        }, 20);
      },
      refresh: function refresh(callback) {
        var origin = {
          x: this.scrollView.scrollLeft,
          y: this.scrollView.scrollTop
        };
        var topLeft = MMCommonFun.convertPointBetweenElements(this.scrollView, this.$tileContainer[0], origin);
        var rightBottom = MMCommonFun.convertPointBetweenElements(this.scrollView, this.$tileContainer[0], {
          x: origin.x + this.scrollView.offsetWidth,
          y: origin.y + this.scrollView.offsetHeight
        });
        var viewBox = new _MMRect["default"]();
        viewBox.initWith2Pts(topLeft, rightBottom);
        var posInScroll = viewBox.getOrigin();
        var viewWidth = viewBox.getWidth();
        var viewHeight = viewBox.getHeight();

        // var tileDispW = g_imgTileSize * this.divScale;
        var tileDispW = this.tileInfo.tileSize;

        //
        //   坐标体系
        //
        //   (0,0)  |          startXi                 endXi          X
        //  --------+------------|-----------------------|------------->
        //          |
        //          |
        // startYi  -            +=======================+
        //          |            ‖                       ‖
        //          |            ‖      屏幕可视区域        ‖
        // endYi    -            +=======================+
        //          |
        //        Y ∨
        //

        var startXi = 0;
        if (posInScroll.x > 0) {
          startXi = Math.floor(posInScroll.x / tileDispW);
        }
        ;
        var dispContainerW = this.$tileContainer.parent().width();
        var dispContainerH = this.$tileContainer.parent().height();
        var dispW = dispContainerW < viewWidth ? dispContainerW : viewWidth;
        var numInrow = Math.floor(dispW / tileDispW) + 1;
        var endXi = startXi + numInrow;
        var startYi = 0;
        if (posInScroll.y > 0) {
          startYi = Math.floor(posInScroll.y / tileDispW);
        }
        ;
        var dispH = dispContainerH < viewHeight ? dispContainerH : viewHeight;
        var numInCol = Math.floor(dispH / tileDispW) + 1;
        var endYi = startYi + numInCol;
        this.tilesSeeInViewBox = {
          startXi: startXi,
          endXi: endXi,
          startYi: startYi,
          endYi: endYi
        };
        this.displayTiles(startXi, endXi, startYi, endYi, this.tileInfo.maxCol, this.tileInfo.maxRow, function (tile) {
          console.log('---------------> refresh callback');
          callback(tile);
        });
      },
      displayTiles: function displayTiles(startXi, endXi, startYi, endYi, maxXi, maxYi, callback) {
        var self = this;
        if (!callback) {
          console.error("	displayTiles --------------->   callback is null!");
        }
        var i = 0;
        var expStartXi = startXi - this.expand;
        if (expStartXi < 0) {
          expStartXi = 0;
        }
        ;
        var expEndXi = endXi + this.expand;
        if (expEndXi > maxXi) {
          expEndXi = maxXi;
        }
        ;
        var expStartYi = startYi - this.expand;
        if (expStartYi < 0) {
          expStartYi = 0;
        }
        ;
        var expEndYi = endYi + this.expand;
        if (expEndYi > maxYi) {
          expEndYi = maxYi;
        }
        ;
        this.tilesExpBox = {
          expStartXi: expStartXi,
          expEndXi: expEndXi,
          expStartYi: expStartYi,
          expEndYi: expEndYi
        };

        // -------------------------------------------------------------- 删除不需要显示的 tile
        for (var row = 0; row <= this.tileInfo.maxRow; row++) {
          var tileInRow = this.tileMatrix[row];
          if (tileInRow) {
            if (row < expStartYi || row > expEndYi) {
              for (var col = 0; col <= this.tileInfo.maxCol; col++) {
                var tile = tileInRow[col];
                if (tile) {
                  tile.removeFromSuperView();
                  self.tilesLoading.remove(tile);
                  g_tileWaitingQueue.remove(tile);
                  g_tileDrawingQueue.remove(tile);
                }
                ;
                tileInRow[col] = null;
              }
              ;
            } else {
              for (var col = 0; col < expStartXi; col++) {
                var tile = tileInRow[col];
                if (tile) {
                  tile.removeFromSuperView();
                  self.tilesLoading.remove(tile);
                  g_tileWaitingQueue.remove(tile);
                  g_tileDrawingQueue.remove(tile);
                }
                ;
                tileInRow[col] = null;
              }
              ;
              for (var col = expEndXi + 1; col <= this.tileInfo.maxCol; col++) {
                var tile = tileInRow[col];
                if (tile) {
                  tile.removeFromSuperView();
                  self.tilesLoading.remove(tile);
                  g_tileWaitingQueue.remove(tile);
                  g_tileDrawingQueue.remove(tile);
                }
                ;
                tileInRow[col] = null;
              }
              ;
            }
          }
          ;
        }
        ;
        if (this._cancelRefresh) {
          return;
        }
        ;

        // -------------------------------------------------- 刷新 tile size，并创建需要显示但还没有的 tile
        for (var row = expStartYi; row <= expEndYi; row++) {
          for (var col = expStartXi; col <= expEndXi; col++) {
            var tile = this.tileMatrix[row][col];
            if (!tile) {
              if (this.curLayer == this) {
                //  只有当前缩放比例对应的 layer 才需要创建新的 tile 
                var newtile = this.createTile(this.tileInfo, this.$tileContainer[0], this.imgObj, this.standScale, row, col, function drawFinishCallback(tileLoaded) {
                  if (!tileLoaded) {
                    return;
                  }
                  self.tilesLoading.remove(tileLoaded);
                  console.log('----> tileLoading :', self.tilesLoading.length);
                  if (callback) callback(tileLoaded);else {
                    console.error("callback is null!");
                  }
                });
                this.tileMatrix[row][col] = newtile;
                this.tilesLoading.push(newtile);

                // 记录当前的等待绘制的初始总数
                this.originTileWaitingCount = this.tilesLoading.length;
              }
            } else {
              tile.updateWithSize(this.tileInfo);
            }
          }
          ;
        }
      },
      getDrawingProgress: function getDrawingProgress() {
        if (!this.originTileWaitingCount) {
          return 1.0;
        } else {
          return (this.originTileWaitingCount - this.tilesLoading.length) / this.originTileWaitingCount;
        }
      },
      isVisibleTileFinishDrawing: function isVisibleTileFinishDrawing() {
        var finished = true;
        var self = this;
        var visibleTileBox = this.tilesSeeInViewBox;
        for (var i = 0; i < this.tilesLoading.length; i++) {
          var tile = this.tilesLoading[i];
          if (tile.row >= visibleTileBox.startYi && tile.row <= visibleTileBox.endYi && tile.col >= visibleTileBox.startXi && tile.col <= visibleTileBox.endXi) {
            finished = false;
            break;
          }
        }
        return finished;
      },
      removeVisibleTilesInViewBox: function removeVisibleTilesInViewBox() {
        var visibleTileBox = this.tilesSeeInViewBox;
        for (var row = visibleTileBox.startYi; row <= visibleTileBox.endYi; row++) {
          for (var col = visibleTileBox.startXi; col <= visibleTileBox.endXi; col++) {
            var tile = this.tileMatrix[row][col];
            if (!tile) {} else {
              tile.removeFromSuperView();
              this.tileMatrix[row][col] = null;
              this.tilesLoading.remove(tile);
            }
          }
          ;
        }
      },
      createTile: function createTile(tileInfo, layerDiv, imgObj, standScale, row, col, callback) {
        var objType = this.imgObj.getObjType();
        if (objType == _ObjType["default"].Obj_Image) {
          return new MDImgTile(tileInfo, layerDiv, imgObj, standScale, row, col, callback);
        } else {
          return new MDPdfTile(tileInfo, layerDiv, imgObj, standScale, row, col, callback);
        }
      },
      updateDispScale: function updateDispScale(dispScale) {
        var scale = dispScale / this.standScale;
        this.tileInfo.tileSize = Math.round(g_imgTileSize * scale);
        var originSize = this.imgObj.getOriginSize();
        this.tileInfo.modW = Math.round(originSize.x * dispScale - this.tileInfo.maxCol * this.tileInfo.tileSize);
        this.tileInfo.modH = Math.round(originSize.y * dispScale - this.tileInfo.maxRow * this.tileInfo.tileSize);

        // this.$tileContainer.css('transform-origin', 'left top');
        // this.$tileContainer.css('transform', 'scale(' + scale + ')');

        for (var i = 0; i < this.tileMatrix.length; i++) {
          var tileInRow = this.tileMatrix[i];
          for (var j = 0; j < tileInRow.length; j++) {
            var tile = tileInRow[j];
            if (tile) {
              tile.updateWithSize(this.tileInfo);
            }
            ;
          }
          ;
        }
        ;

        // this.divScale = scale;
      },
      cancelRefresh: function cancelRefresh() {
        this._cancelRefresh = true;
        console.log('cancel layer:', this.id);
      },
      enableRefresh: function enableRefresh() {
        this._cancelRefresh = false;
        console.log('enable layer:', this.id);
      },
      stopDrawing: function stopDrawing() {
        if (this.curLayer == this) {
          return;
        }

        // 移除正在绘制的块
        for (var i = 0; i < this.tilesLoading.length; i++) {
          var tile = this.tilesLoading[i];
          tile.stopDrawing();
          tile.removeFromSuperView();
          this.tileMatrix[tile.row][tile.col] = null;
          g_tileWaitingQueue.remove(tile);
          g_tileDrawingQueue.remove(tile);
        }
        ;
        this.tilesLoading = [];
      }
    };
    return MDImgPdfTileLayer;
  }();

  // ---------------------------------------------------------------------------------------------------  MDBabelTileView 的函数

  function _getCurrentLayer() {
    var s1 = _getStandardScale.call(this, this.curScale);
    var index = s1;
    if (!this.bufferTileLayer) {
      this.bufferTileLayer = {}; // 以放大倍率为 key 的 map ，存储该 scale 对应的层
    }
    ;
    if (!this.bufferTileLayer[s1]) {
      this.bufferTileLayer[s1] = new MDImgPdfTileLayer(this.imgObj, s1, this.containerDiv, this.scrollView);
    }
    ;
    return this.bufferTileLayer[s1];
  }
  function _refreshAllLayer(newScale) {
    if (!this.bufferTileLayer) {
      return;
    }
    ;
    var self = this;
    var keys = Object.keys(this.bufferTileLayer);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var layer = this.bufferTileLayer[key];
      layer.updateDispScale(newScale);
      console.log('-------> cal delay refresh!');
      layer.delayRefresh(function tileloaded(tile) {
        _tileLoaded.call(self, tile);
      });
    }
  }
  function _tileLoaded(tile) {
    var tileStandardScale = tile.standScale;
    var curStandardScale = this.currentTileLayer.standScale;
    console.log('tileloaded :' + tileStandardScale + ' - curScale:' + curStandardScale);
    if (tileStandardScale == curStandardScale) {
      console.log('======= this.currentTileLayer.tilesLoading.length:', this.currentTileLayer.tilesLoading.length);
      if (this.currentTileLayer.tilesLoading.length == 0) {
        this._removeOtherLayer();
      } else if (this.currentTileLayer.isVisibleTileFinishDrawing()) {
        this._removeOtherLayerTilesInViewBox();
      }
      _Dispatcher["default"].trigger(_MDEvents["default"].TileRenderProgress, {
        progress: this.currentTileLayer.getDrawingProgress(),
        editorViewCtl: g_viewCtl
      });
    }
  }

  // -------------------------------------------------  在各层上记录谁是当前层
  function _markCurrentLayer(curLayer) {
    var keys = Object.keys(this.bufferTileLayer);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var layer = this.bufferTileLayer[key];
      layer.recordCurrentLayer(curLayer);
      if (layer != curLayer) {
        layer.stopDrawing(); // 停止非当前层的绘制，避免占用 cpu
      }
    }
  }

  /** 
   * 放大比例改变时调用
   *
   */
  function _scaleChanged(newScale) {
    var self = this;
    this.curScale = newScale;
    self.currentTileLayer = _getCurrentLayer.call(self);
    _markCurrentLayer.call(self, self.currentTileLayer); // ------------------------ 记录当前层
    _refreshAllLayer.call(self, newScale);
  }

  //
  // 获得 scale 所对应的标准放大比例，这个比例属于 {1， 1/2, 1/4, 1/8, ...,}中的一个
  //
  function _getStandardScale(scale) {
    var objType = this.imgObj.getObjType();
    var standScale = 1.0;
    if (scale <= 1 || objType == _ObjType["default"].Obj_Image) {
      while (scale < standScale) {
        // 找到 scale 所在标准区间的下限
        standScale /= 2;
      }
      if (scale != standScale) {
        standScale *= 2; // 取上限
      }
      ;
      if (standScale > 1) {
        standScale = 1;
      }
      ;
      if (standScale < this.minStandScale) {
        standScale = this.minStandScale;
      }
      ;
    } else {
      while (scale > standScale) {
        standScale *= 2;
      }
    }
    return standScale;
  }
  ;
  function _registerEvents() {
    var self = this;
    $(this.scrollView).on('scroll.tileView', function (e) {
      _onScroll.call(self, e);
    });
  }
  function _onScroll(e) {
    var self = this;
    if (this.refreshTimeout) {
      clearTimeout(this.refreshTimeout);
    }
    this.refreshTimeout = setBabelTimeout(function () {
      if (self.currentTileLayer) {
        self.currentTileLayer.refresh(function (tile) {
          _tileLoaded.call(self, tile);
        });
      }
      ;
    }, 1000);
  }
  _registerEvents.call(this);
};
Object.assign(MDBabelTileView.prototype, {}, function () {
  return {
    constructor: MDBabelTileView,
    _removeOtherLayer: function _removeOtherLayer() {
      var keys = Object.keys(this.bufferTileLayer);
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        var layer = this.bufferTileLayer[key];
        if (layer != this.currentTileLayer) {
          layer.removeFromSuperView();
          delete this.bufferTileLayer[key];
        }
      }
    },
    _removeOtherLayerTilesInViewBox: function _removeOtherLayerTilesInViewBox() {
      var keys = Object.keys(this.bufferTileLayer);
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        var layer = this.bufferTileLayer[key];
        if (layer != this.currentTileLayer) {
          layer.removeVisibleTilesInViewBox();
        }
      }
    },
    refresh: function refresh(scale) {
      this.scale = scale;
    },
    removeFromSuperView: function removeFromSuperView() {
      $(this.scrollView).off('scroll.tileView');
    }
  };
}());
var _default = exports["default"] = MDBabelTileView;

},{"1084":1084,"1184":1184,"1432":1432,"1437":1437,"1451":1451,"1454":1454,"1461":1461,"1466":1466,"18":18,"325":325,"831":831}],909:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1541);
var _MDCanvasSltHtmlElement = _interopRequireDefault(require(920));
var _MDSelectFrame = _interopRequireDefault(require(919));
var _ObjType = _interopRequireDefault(require(1084));
var _MDHandMarkerElController = _interopRequireDefault(require(923));
var MDMarkerObjDrawerController = {
  drawMarkerObjs: function drawMarkerObjs(editor, objects, forEdit) {
    if (!editor.mmPicObj || !editor.canvasTrsfm || !objects) {
      return;
    }
    ;
    var selectedObj = _MDSelectFrame["default"].getSelectedLgObj();
    this.clearAllObjs();
    var trsfm = editor.getCanvasTransformer();
    var canvas = editor._$scribbleLayer[0];
    if (canvas) {
      var ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, editor._$scribbleLayer.width(), editor._$scribbleLayer.height());
      for (var i = 0; i < objects.length; i++) {
        if (objects[i].getObjType() != _ObjType["default"].GObj_text) {
          var pageIndex = objects[i].getPageIndex();
          objects[i].draw(ctx, trsfm, pageIndex);
        }
        ;
      }
    }
    _MDHandMarkerElController["default"].dispLgObjects(editor, objects, forEdit);
    if (selectedObj) {
      MDMarkerObjDrawerController.focus(editor, selectedObj);
    }
    ;
  },
  scale2drawMarkerObjs: function scale2drawMarkerObjs(editor, objects, forEdit, callback) {
    if (!editor.mmPicObj || !editor.canvasTrsfm || !objects) {
      return;
    }
    ;
    var selectedObj = _MDSelectFrame["default"].getSelectedLgObj();
    this.clearAllObjs();
    var trsfm = editor.getCanvasTransformer();
    var curPageIndex = editor.getCurrentFilePageIndex();
    var objsRect;
    for (var i = 0; i < objects.length; i++) {
      var pageIndex = objects[i].getPageIndex();
      if (curPageIndex == pageIndex) {
        var rect = objects[i].getRect();
        if (!objsRect) {
          objsRect = rect;
        } else {
          objsRect.expandToInclude(rect);
        }
      }
    }
    var drawScribbles = function drawScribbles() {
      var newTrsfm = editor.getCanvasTransformer();
      var canvas = editor._$scribbleLayer[0];
      if (canvas) {
        var ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, editor._$scribbleLayer.width(), editor._$scribbleLayer.height());
        for (var i = 0; i < objects.length; i++) {
          if (objects[i].getObjType() != _ObjType["default"].GObj_text) {
            var pageIndex = objects[i].getPageIndex();
            objects[i].draw(ctx, newTrsfm, pageIndex);
          }
          ;
        }
      }
      _MDHandMarkerElController["default"].dispLgObjects(editor, objects, forEdit);
      if (selectedObj) {
        MDMarkerObjDrawerController.focus(editor, selectedObj);
      }
      ;
      callback && callback();
    };
    var dispRect = trsfm.lg2dvRect(objsRect, curPageIndex);
    var size = editor.getScrollViewSize();
    var minW = size.width / 4;
    var minH = size.height / 4;
    var dispW = dispRect.getWidth();
    var dispH = dispRect.getHeight();
    if (dispW < minW && dispH < minH) {
      var scale = Math.min(minW / dispW, minH / dispH);
      var curScale = editor.getScale();
      editor.changeScale(curScale * scale, function () {
        editor.scrollToShowLgRct(objsRect, function () {
          drawScribbles();
        });
      });
    } else {
      drawScribbles();
    }
  },
  flashObjects: function flashObjects(markerCtl, objects_, callback_) {
    // callback_ && callback_();
    // return;			// 放弃煽动绘制

    var that = markerCtl;
    that.interupted = false;
    var pageIndex = markerCtl.editor.getCurrentFilePageIndex();
    var trsfm = markerCtl.editor.getDivTransformerForAssist();
    var canvas = markerCtl.editor.getAssistantCanvas();
    if (canvas) {
      var ctx = canvas.getContext('2d');
      if (!(objects_ instanceof Array)) {
        objects_ = [objects_];
      }
      ctx.globalAlpha = 1.0;
      var trend = 0;
      var count = 0;
      var handle = setInterval(function () {
        if (that.interupted == true) {
          clearInterval(handle);
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          return;
        }
        if (trend == 0) {
          var newAlpha = ctx.globalAlpha - 0.4;
          if (newAlpha <= 0.0) {
            trend = 1;
          } else {
            ctx.globalAlpha = newAlpha;
          }
        } else {
          var newAlpha = ctx.globalAlpha + 0.4;
          if (newAlpha >= 1.0) {
            count++;
            if (count >= 2) {
              clearInterval(handle);
              ctx.clearRect(0, 0, canvas.width, canvas.height);
              if (callback_) callback_();
              return;
            }
            trend = 0;
          } else {
            ctx.globalAlpha = newAlpha;
          }
        }
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        for (var i = 0; i < objects_.length; i++) {
          if (objects_[i].getObjType() != _ObjType["default"].GObj_text) objects_[i].draw(ctx, trsfm, pageIndex);
        }
      }, 50);
    }
    _MDHandMarkerElController["default"].clear();
    _MDHandMarkerElController["default"].dispLgObjects(markerCtl.editor, objects_);
  },
  clearAllObjs: function clearAllObjs() {
    _MDHandMarkerElController["default"].clear();
  },
  focus: function focus(commonEditor, obj) {
    var el = _MDHandMarkerElController["default"].getElByLgObj(obj);
    if (el) {
      _MDSelectFrame["default"].focus(el);
    } else {
      var canvasSltEl = new _MDCanvasSltHtmlElement["default"](commonEditor, obj);
      _MDSelectFrame["default"].focus(canvasSltEl);
    }
  },
  clearFocus: function clearFocus() {
    _MDSelectFrame["default"].clear();
  },
  delObjFocused: function delObjFocused(commonEditor) {
    var dom = _MDSelectFrame["default"].focus();
    if (dom) {
      _MDSelectFrame["default"].clear();
      _MDHandMarkerElController["default"].removeObjByMdEl(dom);
    }
    ;
  }
};
var _default = exports["default"] = MDMarkerObjDrawerController;

},{"1084":1084,"1184":1184,"1454":1454,"1541":1541,"919":919,"920":920,"923":923}],923:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1416);
require(1432);
require(1437);
require(1463);
require(1478);
var _MMSketchCommentController = _interopRequireDefault(require(885));
var _MDSelectFrame = _interopRequireDefault(require(919));
var _MDTextHtmlElement = _interopRequireDefault(require(926));
var _MMRect = _interopRequireDefault(require(831));
var _MMFont = _interopRequireDefault(require(815));
var _ObjType = _interopRequireDefault(require(1084));
var _BoardOrientation = _interopRequireDefault(require(802));
var _MMColor = _interopRequireDefault(require(794));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MMPoint = _interopRequireDefault(require(830));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
var _MDOpElType = _interopRequireDefault(require(924));
// 手绘批注的使用 dom 对象进行显示的控制，此处管理所有 dom 对象
//
//  jiang
// 2017-7-29

var MDHandMarkerElController = {
  mdElArr: [],
  addMdEl: function addMdEl(el, commonEditor) {
    if (this.findIndex(el) == -1) {
      this.mdElArr.push(el);
      this._createLgData(el, commonEditor);
    } else {
      this._updateLgData(el, commonEditor);
    }
  },
  removeObjByMdEl: function removeObjByMdEl(el) {
    for (var i = 0; i < this.mdElArr.length; i++) {
      if (this.mdElArr[i] == el) {
        el.remove();
        this.mdElArr.splice(i, 1);
        if (el.getLgObj()) {
          var currentBoard = _MDPcMobileEditorCommonFun["default"].getMainEditor().getCurrentBoard();
          currentBoard.m_actionManager.deleteObject(el.getLgObj(), {
            toUndo: true,
            isMark_: true
          });
        }
        ;
        break;
      }
    }
    ;
    if (el.lgObj) {
      var currentBoard = _MDPcMobileEditorCommonFun["default"].getMainEditor().getCurrentBoard();
      currentBoard.m_actionManager.deleteObject(el.lgObj, {
        toUndo: true,
        isMark_: true
      });
      _MMSketchCommentController["default"].removeObject(el.lgObj.getId());
    }
    ;
  },
  clear: function clear() {
    for (var i = 0; i < this.mdElArr.length; i++) {
      this.mdElArr[i].remove();
    }
    ;
    $('.op-rect').remove();
    this.mdElArr.splice(0, this.mdElArr.length);
    _MDSelectFrame["default"].clear();
  },
  findIndex: function findIndex(mdEl) {
    var index = -1;
    for (var i = 0; i < this.mdElArr.length; i++) {
      if (this.mdElArr[i] == mdEl) {
        index = i;
        break;
      }
    }
    ;
    return index;
  },
  _createLgData: function _createLgData(el, commonEditor) {
    if (!el.getLgObj()) {
      if (el.opElType == _MDOpElType["default"].OpText) {
        // --------- 分情况进行对象创建
        var currentBoard = _MDPcMobileEditorCommonFun["default"].getMainEditor().getCurrentBoard();
        var text = new MMText(currentBoard);
        el.setLgObj(text);
        this._updateLgData(el, commonEditor);
        var option = {
          toUndo: true,
          realtime: false,
          isMark_: true,
          createNotRefresh: true
        };
        currentBoard.m_actionManager.addObject(text, option);
      }
      ;
    }
    ;
  },
  _updateLgData: function _updateLgData(el, commonEditor) {
    if (el.getLgObj()) {
      var text = el.getLgObj();
      var pageIndex = commonEditor.getCurrentFilePageIndex();
      var pathDVPoints = el.getCtrlPts(true);
      var ptInPage = commonEditor.convertPtsFromContent2Page(pathDVPoints);
      var trsfm = commonEditor.getDivTransformer();
      text.setDevPts(trsfm, ptInPage, pageIndex);
      var _color = new _MMColor["default"]();
      _color.fromString(el.getColor());
      text.setTextColor(_color);
      var str = el.getText();
      text.setText(str);
      var dvFontSize = el.getFontSize();
      var lgFontSize = trsfm.dv2lgLen(dvFontSize);
      var font = new _MMFont["default"]();
      font.m_fontSize = lgFontSize;
      text.setLgFont(font);
      text.setDevOrientation(_BoardOrientation["default"].Portrait);
    }
    ;
  },
  dispLgObjects: function dispLgObjects(editor, objects, forEdit) {
    for (var i = 0; i < objects.length; i++) {
      var obj = objects[i];
      if (obj.getObjType() == _ObjType["default"].GObj_text) {
        this.dispLgObjectInEditor(editor, obj, forEdit);
      }
      ;
    }
    ;
  },
  dispLgObjectInEditor: function dispLgObjectInEditor(commonEditor, obj, forEdit) {
    var el = this.getElByLgObj(obj);
    var elCtl = this;
    var rect = obj.getRect();
    var dvRect = commonEditor.lg2ContentDvRect(rect);
    var parentDiv = commonEditor.getScrollContent();
    if (!el) {
      if (obj.getObjType() == _ObjType["default"].GObj_text) {
        el = new _MDTextHtmlElement["default"](elCtl, $(parentDiv), dvRect);
        el.hideBorder();
        if (!forEdit) {
          el.setReadOnly();
        }
        ;
        el.setLgObj(obj);
        el.editor = commonEditor;
        this.mdElArr.push(el);
      } else {
        console.error('------------ wrong object type!');
      }
    }
    el.setRect(dvRect);
    var str = obj.getText();
    el.setText(str);
    var trsfm = commonEditor.getCanvasTransformer();
    var fontSize = obj.getFontSize();
    var dvFontSize = trsfm.lg2dvLen(fontSize);
    el.setFontSize(dvFontSize);
    var color = obj.getTextColor().toString();
    el.setColor(color);
  },
  getElByLgObj: function getElByLgObj(obj) {
    var el = null;
    for (var i = 0; i < this.mdElArr.length; i++) {
      if (this.mdElArr[i].getLgObj() == obj || this.mdElArr[i].getLgObj().getId().toString() == obj.getId().toString()) {
        el = this.mdElArr[i];
        break;
      }
      ;
    }
    ;
    return el;
  }
};
var _default = exports["default"] = MDHandMarkerElController;

},{"1084":1084,"1184":1184,"1416":1416,"1432":1432,"1437":1437,"1454":1454,"1463":1463,"1478":1478,"794":794,"802":802,"807":807,"812":812,"815":815,"830":830,"831":831,"885":885,"919":919,"924":924,"926":926}],920:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
var _ObjType = _interopRequireDefault(require(1084));
var _MMColor = _interopRequireDefault(require(794));
var _MDEvents = _interopRequireDefault(require(325));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDRatioTransformer = _interopRequireDefault(require(827));
var _transformer = _interopRequireDefault(require(838));
var _size = _interopRequireDefault(require(837));
var _MMPoint = _interopRequireDefault(require(830));
var _MDOpElType = _interopRequireDefault(require(924));
var _MDColorDisk = _interopRequireDefault(require(856));
var _MDDispHtmlElement = _interopRequireDefault(require(922));
var _MDSelectFrame = _interopRequireDefault(require(919));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MMRect = _interopRequireDefault(require(831));
var _MDNetDriveFileHandler = _interopRequireDefault(require(1091));
//
// 显示当 canvas 对象被选中时的效果
// MDCanvasSltHtmlElement.js
//
// jiang
// 2017-7-24

function MDCanvasSltHtmlElement(commonEditor, lgObj) {
  this.lgObj = lgObj;
  this.commonEditor = commonEditor;
  this.pageRect = commonEditor.getContentLgRect();
  var elCtl = null;
  var parentDiv = commonEditor.getScrollContent();
  if (lgObj.getObjType() == _ObjType["default"].GObj_line) {
    var endPts = commonEditor.getDispStartEndPtsInContentForObj(lgObj);
    this.startDvPos = endPts[0];
    this.endDvPos = endPts[1];
    this.devRect = new _MMRect["default"]();
    this.devRect.initWith2Pts(endPts[0], endPts[1]);
    this.isSegmentObj = true;
  } else {
    this.devRect = commonEditor.getDispRectInContentForObj(lgObj);
  }
  var dvRct = this.devRect.clone();
  _MDDispHtmlElement["default"].call(this, elCtl, $(parentDiv), this.devRect);
  this.prepareCanvasTransformer();
  this.rectChanged(dvRct);
  this.isCanvas = true;
}
;
_.extend(MDCanvasSltHtmlElement.prototype, _MDDispHtmlElement["default"].prototype, function () {
  return {
    contstructor: MDCanvasSltHtmlElement,
    construct: function construct() {
      this.$el.addClass('op-canvas');
      this.$el.append('<canvas style="position: absolute;left: -3px;top: -3px;"></canvas>');
      this.opElType = _MDOpElType["default"].OpCanvas;

      // this.$el.css('border', '1px solid ' + MDColorDisk.getCurColor());

      _MDDispHtmlElement["default"].prototype.construct.call(this);
    },
    _registerEvents: function _registerEvents() {
      _MDDispHtmlElement["default"].prototype.registerEvents.call(this);
    },
    refresh: function refresh() {
      this.$el.find('canvas').attr('width', this.rect.getWidth() + 'px');
      this.$el.find('canvas').attr('height', this.rect.getHeight() + 'px');
      this.draw();
    },
    draw: function draw() {
      var canvas = this.$el.find('canvas')[0];
      var ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, this.rect.getWidth(), this.rect.getHeight());
      if (this.lgObj.getObjType() == _ObjType["default"].Obj_seal) {} else if (this.isSegmentObj) {
        var topLeft = true;
        if (Math.abs(this.startDvPos.x - this.endDvPos.x) > 0.001) {
          if ((this.startDvPos.x - this.endDvPos.x) * (this.startDvPos.y - this.endDvPos.y) < 0) {
            topLeft = false;
          }
        }
        ctx.lineWidth = 1;
        ctx.strokeStyle = '#00ffff';
        var start = {
          x: 0,
          y: 0
        };
        var end = {
          x: this.rect.getWidth(),
          y: this.rect.getHeight()
        };
        if (!topLeft) {
          start = {
            x: 0,
            y: this.rect.getHeight()
          };
          end = {
            x: this.rect.getWidth(),
            y: 0
          };
        }
        ;
        ctx.beginPath();
        ctx.moveTo(start.x, start.y);
        ctx.lineTo(end.x, end.y);
        ctx.stroke();
      } else {
        if (!this.lgRelativePts) {
          return;
        }
        ;
        this.dispObj.draw(ctx, this.transformer, 0);
      }
    },
    needClickEventThrough: function needClickEventThrough() {
      return true;
    },
    finishCreate: function finishCreate() {},
    didSelected: function didSelected() {
      _MDDispHtmlElement["default"].prototype.didSelected.call(this);
      this.refresh();
    },
    unSelected: function unSelected() {
      _MDDispHtmlElement["default"].prototype.unSelected.call(this);
      this.$el.remove();
    },
    endPtsChanged: function endPtsChanged(startPos, endPos) {
      this.startDvPos = startPos;
      this.endDvPos = endPos;
      this.refresh();
    },
    rectChanged: function rectChanged(devRect) {
      if (!this.isSegmentObj) {
        var w = devRect.getWidth();
        var h = devRect.getHeight();
        if (w == this.dvSize.width && h == this.dvSize.height) {
          this.action = 'moving';
        } else {
          this.action = 'scale';
        }
        var lgRect = this.commonEditor.dv2ContentLgRect(devRect);
        this.lgBase = lgRect.getOrigin();
        if (this.action == 'scale') {
          if (w <= 0) {
            w = 1;
            devRect.setWidth(w);
          }
          ;
          if (h <= 0) {
            h = 1;
            devRect.setHeight(h);
          }
          ;
          var wRatio = w / this.dvSize.width;
          var hRatio = h / this.dvSize.height;
          this.dvSize.width = w;
          this.dvSize.height = h;
          lgRect = this.commonEditor.dv2ContentLgRect(devRect);
          this.lgSize.width = lgRect.getWidth();
          this.lgSize.height = lgRect.getHeight();
          this.refresh();
        }
      }
    },
    prepareCanvasTransformer: function prepareCanvasTransformer() {
      if (this.isSegmentObj) {} else {
        var objLgRect = this.lgObj.getRect().clone();
        var lgPts = this.lgObj.getLogicPts();
        this.targetLgRect = objLgRect;
        this.lgRelativePts = [];
        this.lgBase = new _MMPoint["default"](objLgRect.left, objLgRect.top);
        this.lgSize = new _size["default"](objLgRect.getWidth(), objLgRect.getHeight());
        var offsetPts = [];
        for (var i = 0; i < lgPts.length; i++) {
          var lgPt = this.lgBase.offsetTo(lgPts[i]);
          lgPt.x = lgPt.x / this.lgSize.width;
          lgPt.y = lgPt.y / this.lgSize.height;
          this.lgRelativePts.push(lgPt);
        }
        ;

        // this.lgRelativePts = [new MMPoint(0, 1), new MMPoint(0.5, 0.5), new MMPoint(1, 0)];
        this.dvSize = new _size["default"](this.devRect.getWidth(), this.devRect.getHeight());
        this.transformer = new _MDRatioTransformer["default"](this.lgSize, this.dvSize);
        this.dispObj = this.lgObj.clone();
        this.dispObj.isSkeleton(true);
        var dvPts = this.transformer.lg2dvPoints(this.lgRelativePts);
        this.dispObj.setDevPts(this.transformer, dvPts);
      }
    },
    // 需要更新原始数据
    userActionFinished: function userActionFinished() {
      if (this.isSegmentObj) {
        var lgPts = this.commonEditor.contentDv2LgPoints([this.startDvPos, this.endDvPos]);
        this.lgObj.setLogicPts(lgPts);
      } else {
        var targetLgPts = [];
        for (var i = 0; i < this.lgRelativePts.length; i++) {
          var rPt = this.lgRelativePts[i].clone();
          rPt.x = rPt.x * this.lgSize.width + this.lgBase.x;
          rPt.y = rPt.y * this.lgSize.height + this.lgBase.y;
          targetLgPts.push(rPt);
        }
        ;
        this.lgObj.setLogicPts(targetLgPts);
      }
      if (this.lgObj.getClassName() == "MMSignatureFrame") {
        this.commonEditor.refreshObjsInEditor();
        var fileId = this.lgObj.getBoard().getStringId();
        var version = this.lgObj.getFileVersion();
        _MDNetDriveFileHandler["default"].updateFileSealPosition(fileId, version, this.lgObj);
        _Dispatcher["default"].trigger(_MDEvents["default"].fileSealChanged, {
          fileId: fileId,
          version: version
        });
        var rect = this.lgObj.getRect2Save();
        localStorage.setItem("sealsize", JSON.stringify({
          w: rect.getWidth(),
          h: rect.getHeight(),
          id: this.lgObj.getSigData().getId()
        }));
      } else {
        _Dispatcher["default"].trigger(_MDEvents["default"].MARK_READY);
      }
    },
    setColor: function setColor(color) {
      var _strokeType = this.lgObj.getStrokeType();
      var _color = new _MMColor["default"]();
      _color.fromString(color);
      _strokeType.setLineColor(_color);
      this.lgObj.setStrokeType(_strokeType);
      _Dispatcher["default"].trigger(_MDEvents["default"].MARK_READY);
    },
    setLineWidth: function setLineWidth(w) {
      var lgW = this.commonEditor.getDivTransformer().dv2lgLen(w);
      var _strokeType = this.lgObj.getStrokeType();
      _strokeType.setLineWidth(lgW);
      this.lgObj.setStrokeType(_strokeType);
      _Dispatcher["default"].trigger(_MDEvents["default"].MARK_READY);
    },
    // 调整移动的距离，避免移出画面
    adjustMoveOffset: function adjustMoveOffset(devX, devY) {
      var pgDvRect = this.commonEditor.lg2ContentDvRect(this.pageRect);
      var objFrame = this.devRect.clone();
      var angle = this.lgObj.getAngle();
      var center = objFrame.getCenter();
      objFrame = objFrame.rotateAroundPt(center, angle, true);
      if (objFrame.left + devX < pgDvRect.left) {
        devX = pgDvRect.left - objFrame.left;
      } else if (objFrame.right + devX > pgDvRect.right) {
        devX = pgDvRect.right - objFrame.right;
      }
      if (objFrame.top + devY < pgDvRect.top) {
        devY = pgDvRect.top - objFrame.top;
      } else if (objFrame.bottom + devY > pgDvRect.bottom) {
        devY = pgDvRect.bottom - objFrame.bottom;
      }
      return {
        x: devX,
        y: devY
      };
    },
    adJustScale: function adJustScale(ctlType, rect) {
      if (this.lgObj.getClassName() == "MMSignatureFrame") {
        var sigData = this.lgObj.getSigData();
        var hwRatio = sigData.gethwRatio();
        var lgRect = new _MMRect["default"](0, 1, hwRatio, 0);
        var dvRect = this.commonEditor.lg2ContentDvRect(lgRect);
        var dvHwRatio = dvRect.getHeight() / dvRect.getWidth();
        var w = rect.getWidth();
        var h = rect.getHeight();
        switch (ctlType) {
          case 'corner0':
            var targetH = w * dvHwRatio;
            rect.top -= targetH - h;
            break;
          case 'corner1':
            var targetW = h / dvHwRatio;
            var deltaY = targetW - w;
            rect.left -= deltaY / 2;
            rect.right += deltaY / 2;
            break;
          case 'corner2':
            var targetH = w * dvHwRatio;
            rect.top -= targetH - h;
            break;
          case 'corner3':
            var targetH = w * dvHwRatio;
            var deltaY = targetH - h;
            rect.bottom += deltaY;
            break;
          case 'corner4':
            var targetH = w * dvHwRatio;
            rect.bottom += targetH - h;
            break;
          case 'corner5':
            var targetW = h / dvHwRatio;
            var deltaY = targetW - w;
            rect.left -= deltaY / 2;
            rect.right += deltaY / 2;
            break;
          case 'corner6':
            var targetH = w * dvHwRatio;
            rect.bottom += targetH - h;
            break;
          case 'corner7':
            var targetH = w * dvHwRatio;
            rect.bottom += targetH - h;
            break;
        }
      }
    }
  };
}());
var _default = exports["default"] = MDCanvasSltHtmlElement;

},{"1084":1084,"1091":1091,"1184":1184,"1417":1417,"1454":1454,"1463":1463,"18":18,"325":325,"794":794,"812":812,"827":827,"830":830,"831":831,"837":837,"838":838,"856":856,"919":919,"922":922,"924":924}],827:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _transformer = _interopRequireDefault(require(838));
/**
 * 逻辑坐标和设备坐标转换器, 其中逻辑坐标是 【0..1]之间的小数
 *
 * jiang
 * 2017-7-30
 */

/**
 * @param lg_pagesize   {Size}
 * @param dv_pagesize   {Size}
 * @param ort     {BoardOrientation}
 */
function MDRatioTransformer(lg_pagesize, dv_pagesize) {
  _transformer["default"].call(this, lg_pagesize, dv_pagesize);
  return this;
}
;
_.extend(MDRatioTransformer.prototype, _transformer["default"].prototype, {
  contstructor: MDRatioTransformer,
  lg2dvPoint: function lg2dvPoint(lgpoint) {
    var lgPt = lgpoint.clone();
    lgPt.x *= this.lgpgsize.width;
    lgPt.y *= this.lgpgsize.height;
    return _transformer["default"].prototype.lg2dvPoint.call(this, lgPt);
  },
  dv2lgPoint: function dv2lgPoint(dvpoint) {
    var lgPt = _transformer["default"].prototype.dv2lgPoint.call(this, dvpoint);
    lgPt.x /= this.lgpgsize.width;
    lgPt.y /= this.lgpgsize.height;
    return lgPt;
  }
});
var _default = exports["default"] = MDRatioTransformer;

},{"1184":1184,"1454":1454,"838":838}],904:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var EditorMode = {
  normal: 'normal',
  // 普通模式, 不能显示标记模式下的内容
  mark: 'mark' // 标记模式，此时不能显示批注，只能显示标记模式下的内容
};
var _default = exports["default"] = EditorMode;

},{"1454":1454}],903:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1466);
var _MMPDFDrawerController = _interopRequireDefault(require(932));
var _transformer = _interopRequireDefault(require(838));
var _MMPageThumbnailMaker = _interopRequireDefault(require(895));
var _ObjType = _interopRequireDefault(require(1084));
var _size = _interopRequireDefault(require(837));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
var MMThumbnailMaker = {
  /**
   * lgRect {MMRect} the rect to take
   * orientation {string BoardOrientation}
   * size {int} the max with for the thumbnail
   */
  createBoardThumb: function createBoardThumb(lgRect, orientation, maxWidth, callback) {
    var mainEditor = _MDPcMobileEditorCommonFun["default"].getMainEditor();
    if (!mainEditor) return;
    var board = mainEditor.getCurrentBoard();
    if (!board) return;
    var page = parseInt(lgRect.top / 20);
    lgRect.top -= page * 20;
    lgRect.bottom -= page * 20;
    //if(lgRect.top%20==0)lgRect.top-=0.00000000001;
    var thumbDVPageWidth = (lgRect.right - lgRect.left) / 15 * maxWidth;
    var thumbDVPageHeight = thumbDVPageWidth * 20 / 15;
    var pageThumbnailMaker = new _MMPageThumbnailMaker["default"](board, thumbDVPageWidth);

    //lgRect.top = lgRect.top % 20;
    //lgRect.bottom = lgRect.bottom % 20;
    //pageThumbnailMaker.trsfm.lgPgOrigin.y = page * thumbDVPageHeight;
    pageThumbnailMaker.createThumbnailForPage(page, function (image) {
      /*success*/

      var pageImageTansformer = new _transformer["default"](new _size["default"](15, 20), new _size["default"](thumbDVPageWidth, thumbDVPageHeight), orientation);
      var dvRect = pageImageTansformer.lg2dvRect(lgRect, 0);
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      if (orientation == "portrait") {
        canvas.setAttribute('width', maxWidth + 'px');
        canvas.setAttribute('height', maxWidth / lgRect.getWidth() * lgRect.getHeight() + 'px');
      } else {
        canvas.setAttribute('width', maxWidth / lgRect.getWidth() * lgRect.getHeight() + 'px');
        canvas.setAttribute('height', maxWidth + 'px');
        ctx.rotate(-90 * Math.PI / 180);
        ctx.translate(-maxWidth, 0);
      }

      //$('body').append($('<img src="' + image.src + '" class="renderPDFDocument:" style="position:absolute;z-index:1000000000000;top:0px;left:0px;">'))
      ctx.drawImage(image, dvRect.left, dvRect.top, dvRect.right - dvRect.left, dvRect.bottom - dvRect.top, 0, 0, maxWidth, maxWidth / lgRect.getWidth() * lgRect.getHeight());
      var data = canvas.toDataURL('image/jpeg');
      data = canvas.toDataURL('image/jpeg');
      data = canvas.toDataURL('image/jpeg');
      data = canvas.toDataURL('image/jpeg');
      callback(data);
    }, function (msg) {/*fail*/
    });
  },
  createObjsThumb: function createObjsThumb(objs, lgRect, orientation, maxWidth, callback) {
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    var pageIndex = parseInt(lgRect.top / 20);
    var thumbDVPageWidth = 15 / (lgRect.right - lgRect.left) * maxWidth;
    var rectTansformer = new _transformer["default"](new _size["default"](15, 20), new _size["default"](thumbDVPageWidth, thumbDVPageWidth * 20 / 15), orientation);
    var dvRect = rectTansformer.lg2dvRect(lgRect);
    rectTansformer.lgPgOrigin.x = dvRect.left;
    rectTansformer.lgPgOrigin.y = dvRect.top;
    callback(canvas.toDataURL('image/jpeg', 0.9));
  },
  //
  // jiang
  // 2015-7-1
  //
  createMarkerThumbnail: function createMarkerThumbnail(imgDvRect, thumbSize, trsfm, mmimg, objs, callback) {
    if (!mmimg) {
      if (callback) {
        callback(null);
      }
      ;
      return;
    }
    ;

    //        console.log('================in MMThumbnailMaker.createMarkerThumbnail================');

    var $canvas = $("<canvas class='.thumbnail-maker' style='position:fixed;display:none' >" + "</canvas>");
    $("body").append($canvas);
    var canvas = $canvas[0];
    var ctx = canvas.getContext('2d');
    canvas.setAttribute('width', thumbSize.width + 'px');
    canvas.setAttribute('height', thumbSize.height + 'px');

    // 1. draw the backgroudn image

    if (mmimg.getObjType() == _ObjType["default"].Obj_Image) {
      var image = new Image();
      var path = mmimg.getLowPixelFilePath();
      image.onload = function () {
        ctx.drawImage(image, imgDvRect.getOrigin().x, imgDvRect.getOrigin().y, imgDvRect.getWidth(), imgDvRect.getHeight());

        // 2. draw the scribble's
        for (var i = 0; i < objs.length; i++) {
          var obj = objs[i];
          obj.draw(ctx, trsfm, obj.getPageIndex());
        }
        ;
        var thumbnail = new Image();
        thumbnail.src = canvas.toDataURL('image/jpg');
        $canvas.remove();
        if (callback) {
          callback(thumbnail);
        }
        ;
      };
      image.onerror = function () {
        //                console.log('================image.onerror================');
        if (callback) {
          callback(null);
        }
        ;
      };
      image.crossOrigin = '';
      image.src = path;
    } else if (mmimg.getObjType() == _ObjType["default"].Obj_PDF) {
      //            console.log('================mmimg.getObjType() == ObjType.Obj_PDF================');
      mmimg.getPdfPage(function (page) {
        //                console.log('================after getPdfPage================');
        var $pdfcanvas = $("<canvas class='.thumbnail-pdf-maker' style='position:fixed;display:none' " + "</canvas>");
        $("body").append($pdfcanvas);
        $pdfcanvas.attr('width', imgDvRect.getWidth() + 'px');
        $pdfcanvas.attr('height', imgDvRect.getHeight() + 'px');

        //                console.log('================before page.render================');
        var pdfcanvas = $pdfcanvas[0];
        var context = pdfcanvas.getContext('2d');
        context.fillStyle = "white";
        context.fillRect(0, 0, imgDvRect.getWidth(), imgDvRect.getHeight());
        var viewport = page.getViewport(1.0);
        var scale = parseInt($(pdfcanvas).attr("width")) / viewport.width;
        var viewport = page.getViewport(scale);
        var renderContext = {
          'canvasContext': context,
          'viewport': viewport
        };
        var rendTask = page.render(renderContext);
        rendTask.then(function () {
          //                    console.log('================in rendTask.then================');
          var pdfImg = new Image();
          //下面这段代码绝对不能有，否则在firefox上很有可能会出错。
          //                    pdfImg.crossOrigin = '';
          pdfImg.src = pdfcanvas.toDataURL('image/jpg');
          pdfImg.onload = function () {
            ctx.fillStyle = "white";
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            //                        console.log('================pdfImg loaded================');
            ctx.drawImage(pdfImg, imgDvRect.getOrigin().x, imgDvRect.getOrigin().y, imgDvRect.getWidth(), imgDvRect.getHeight());

            // 2. draw the scribble's
            for (var i = 0; i < objs.length; i++) {
              var obj = objs[i];
              obj.draw(ctx, trsfm, obj.getPageIndex());
            }
            ;
            var thumbnail = new Image();
            thumbnail.src = canvas.toDataURL('image/jpeg', 0.9);
            $canvas.remove();
            $pdfcanvas.remove();
            if (callback) {
              callback(thumbnail);
            }
            ;
          };
          pdfImg.onerror = function () {
            //                        console.log('================pdfImg.onerror================');
            if (callback) {
              callback(null);
            }
            ;
          };
        });
      });
    }
  },
  calculateThumbnailSize: function calculateThumbnailSize(wantedSize, imgSize) {
    var targetSize = {
      width: wantedSize.width,
      height: wantedSize.height
    };
    if (targetSize.width > imgSize.width) {
      targetSize.width = imgSize.width;
    }
    ;
    targetSize.height = targetSize.width * imgSize.height / imgSize.width;
    return targetSize;
  },
  createImgPdfThumbnail: function createImgPdfThumbnail(mmimg, callback, imageData) {
    var $canvas = $("<canvas class='.pdfimg-thumbnail-maker' style='position:fixed;display:none' >" + "</canvas>");
    $("body").append($canvas);
    var canvas = $canvas[0];
    var ctx = canvas.getContext('2d');
    var wantedSize = {
      width: 256,
      height: 256
    };
    var that = MMThumbnailMaker;
    if (mmimg.getObjType() == _ObjType["default"].Obj_Image) {
      var image = new Image();

      //temporary code, ATTENTION:
      //the original code is 'var path = mmimg.getLowPixelFilePath()' ,
      //I hacked to the following, because this url has been used somewhere else, which failed, and the
      //IE browser is not gonna try again.
      //this is only for temporary, because we're gonna change the thumbnail system in the following days.
      var path = imageData ? imageData : mmimg.getLowPixelFilePath() + '&transfer=1';
      var loaded = false;
      image.onload = function () {
        if (!image.width && imageData) {
          setBabelTimeout(function () {
            image.onload();
          }, 50);
          return;
        }
        if (loaded) return;
        loaded = true;
        var imgSize = {
          width: image.width,
          height: image.height
        };
        var thumbSize = that.calculateThumbnailSize(wantedSize, imgSize);
        canvas.setAttribute('width', thumbSize.width + 'px');
        canvas.setAttribute('height', thumbSize.height + 'px');
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, thumbSize.width, thumbSize.height);
        ctx.drawImage(image, 0, 0, thumbSize.width, thumbSize.height);

        // var thumbnail = new Image();
        // thumbnail.src=canvas.toDataURL('image/jpeg',0.9);

        var data = canvas.toDataURL('image/jpeg');
        $canvas.remove();
        document.body.removeChild(image);
        if (callback) {
          callback(data);
        }
        ;
      };
      image.crossOrigin = '';
      image.src = path;
      document.body.appendChild(image);
      if (imageData) {
        //for firefox
        setBabelTimeout(function () {
          image.onload();
        }, 50);
      }
    } else if (mmimg.getObjType() == _ObjType["default"].Obj_PDF) {
      mmimg.getPdfPage(function (page) {
        var viewport = page.getViewport(1.0);
        var pdfSize = {
          width: viewport.width,
          height: viewport.height
        };
        var thumbSize = that.calculateThumbnailSize(wantedSize, pdfSize);
        canvas.setAttribute('width', thumbSize.width + 'px');
        canvas.setAttribute('height', thumbSize.height + 'px');
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, thumbSize.width, thumbSize.height);
        _MMPDFDrawerController["default"].getGlobalInstance().drawInCanvas("thumbnail_" + mmimg.getPageIndex(), canvas, page, function () {
          var data = canvas.toDataURL('image/jpeg');
          $canvas.remove();
          if (callback) {
            callback(data);
          }
        });
      });
    }
  }
};
var _default = exports["default"] = MMThumbnailMaker;

},{"1084":1084,"1184":1184,"1454":1454,"1466":1466,"807":807,"837":837,"838":838,"895":895,"932":932}],932:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MMPDFDrawerController;
require(1432);
require(1437);
require(1438);
var _MDWaterMarkDrawer = _interopRequireDefault(require(911));
var _text_layer_builder = require(1145);
var _text_highlighter = require(1144);
var _text_accessibility = require(1143);
//	将绘制的请求排队，一页页进行绘制
//  jiang
//  2015-8-7
//

// import {AutomationEventBus, EventBus} from '../../../../vendor/pdf_js/build/event_utils.js'

var g_pdfDrawerCtl = null;
function MMPDFDrawerController() {
  this.bufferEditorCanvasPage = [];
}
;
MMPDFDrawerController.getGlobalInstance = function () {
  if (!g_pdfDrawerCtl) {
    g_pdfDrawerCtl = new MMPDFDrawerController();
  }
  ;
  return g_pdfDrawerCtl;
};
MMPDFDrawerController.prototype.clear = function (editor) {
  for (var i = 0; i < this.bufferEditorCanvasPage.length;) {
    if (this.bufferEditorCanvasPage[i].editor == editor) {
      if (i == 0 && this.rTask) {
        this.rTask.cancel();
        //console.log("--- clear - canel task!");
      } else {
        //console.log("--- clear - delelte editor");
        this.bufferEditorCanvasPage.splice(i, 1);
        continue;
      }
    }
    i++;
  }
  ;
};
MMPDFDrawerController.prototype.drawInCanvas = function (editor, canvas, page, callback) {
  if (!editor || !canvas || !page) {
    return;
  }
  ;
  // console.log('1 --------- drawInCanvas 	'+(new Date()).getTime() );

  var index = -1;
  for (var i = 0; i < this.bufferEditorCanvasPage.length; i++) {
    if (this.bufferEditorCanvasPage[i].canvas == canvas) {
      index = i;
      break;
    }
  }
  ;
  var that = this;
  var data = {
    editor: editor,
    canvas: canvas,
    page: page
  };
  canvas.pdfCallbacks = [callback];
  this.bufferEditorCanvasPage.push(data);

  //console.log('** request draw:', this.bufferEditorCanvasPage.length);

  if (index == -1) {} else {
    if (index == 0) {
      if (this.rTask) {
        this.rTask.cancel();
      } else {
        if (this.rTask == null) {
          // setBabelTimeout(function(){
          that._drawInCanvas();
          // }, 100);
        }
        ;
      }
    } else {
      this.bufferEditorCanvasPage.splice(index, 1);
      if (this.rTask == null) {
        // setBabelTimeout(function(){
        that._drawInCanvas();
        // }, 100);
      }
      ;
    }
    return;
  }
  if (this.rTask == null) {
    // setBabelTimeout(function(){
    that._drawInCanvas();
    // }, 100);
  }
  ;
};
MMPDFDrawerController.prototype._drawInCanvas = function () {
  // console.log('2 --------- _drawInCanvas 	'+(new Date()).getTime() );
  if (this.bufferEditorCanvasPage.length == 0) {
    //console.log("-----> all page rendered!");
    return;
  }
  ;
  if (this.rTask) {
    this.rTask.cancel();
    return;
  }
  ;

  //console.log('*** draw pdf page:', this.bufferEditorCanvasPage.length);
  var that = this;
  var canvas = this.bufferEditorCanvasPage[0].canvas;
  var page = this.bufferEditorCanvasPage[0].page;
  var editor = this.bufferEditorCanvasPage[0].editor;
  if (editor.removed) {
    console.log('******---->>> removed!, need not draw');
    that.rTask = null;
    that.bufferEditorCanvasPage.shift();
    that._drawInCanvas();
    return;
  }
  var $textLayer = null;
  if (app.canDispInNormalBrowser() && editor.getPdfTextLayer) {
    var $textLayer = editor.getPdfTextLayer();
  }
  var callbacks = canvas.pdfCallbacks;
  var viewport = page.getViewport(1.0);
  var canvasWidth = canvas.width;
  var canvasHeight = canvas.height;
  var scale = canvasWidth / viewport.width;
  var CSS_UNITS = 96.0 / 72.0;
  viewport = page.getViewport(scale);
  var context = canvas.getContext('2d');
  context.scale(1, 1);
  this.isRejected = false;
  var renderContext = {
    'canvasContext': context,
    'viewport': viewport,
    'continueCallback': function pdfViewcContinueCallback(cont) {
      // if (that.isRejected) {
      // that.rTask = null;
      // that.bufferEditorCanvasPage.shift();
      // setBabelTimeout(function(){
      // 	that._drawInCanvas();
      // }, 100);

      // } else {
      // 	cont();
      // }
      cont();
      that.isRejected = false;
    }
  };
  context.clearRect(0, 0, canvasWidth, canvasHeight);

  // that.drawWaterMark(context, canvas, editor);

  var $tmplCanvas = $(canvas).clone();
  $tmplCanvas.addClass("drawwater");
  $tmplCanvas.insertAfter($(canvas));
  var tmplContext = $tmplCanvas[0].getContext('2d');
  that.drawWaterMark(tmplContext, $tmplCanvas[0], editor);
  this.rTask = page.render(renderContext);
  console.log('++++++++++++++++++> draw pdf page, index: ' + page['mytestindex'] + '  time:' + new Date().getTime());
  if (app.canDispInNormalBrowser() && $textLayer && $textLayer.length > 0) {
    var self = this;
    page.getTextContent().then(function (textContent) {
      $textLayer.empty();
      editor.textLayerEmptied();

      // const eventBus = new EventBus();

      var textHighlighter = new _text_highlighter.TextHighlighter({
        pageIndex: page.pageIndex,
        eventBus: editor.editorViewCtl.getCurrentBoard().eventBus,
        findController: editor.editorViewCtl.getCurrentBoard().findController
      });
      var accessibilityManager = new _text_accessibility.TextAccessibilityManager();
      var textLayer = new _text_layer_builder.TextLayerBuilder({
        highlighter: textHighlighter,
        accessibilityManager: accessibilityManager,
        isOffscreenCanvasSupported: true,
        enablePermissions: false
        // 'textLayerDiv': $textLayer[0],
        // 'viewport':viewport,
        // 'pageIndex':page.pageIndex,
        // 'findController': editor.editorViewCtl.getCurrentBoard().findController,
        // 'editor': editor.editorViewCtl.editor
      });
      $textLayer[0].style.setProperty("--scale-factor", viewport.scale);
      $textLayer.append(textLayer.div);
      editor.hasText && editor.hasText(true);
      var readableStream = page.streamTextContent({
        includeMarkedContent: true,
        disableNormalization: true
      });
      textLayer.setTextContentSource(readableStream);
      // textLayer.render(viewport)
      // textLayer.setTextContent(textContent);
      // textLayer.render();
      self.textLayer = textLayer;
      Dispatcher.trigger(MDEvents.fileHasText, editor);
    });
  }
  this.rTask.promise.then(function () {
    console.log('===================> finish pdf page ' + new Date().getTime());
    that.drawWaterMark(context, canvas, editor);
    $tmplCanvas.remove();
    //console.log('*** draw pdf page finished:', that.bufferEditorCanvasPage.length);

    that.rTask = null;
    that.bufferEditorCanvasPage.shift();
    if (!editor.removed) {
      for (var i = 0; i < callbacks.length; i++) {
        var callback = callbacks[i];
        setBabelTimeout(function () {
          if (callback) callback(canvas);
        }, 1);
      }
      ;
    }
    ;

    // var waterMarkDrawer = new MDWaterMarkDrawer();
    // waterMarkDrawer.drawTextWaterMark(context, '画擎科技', canvasWidth, canvasHeight);
    if (that.textLayer) {
      that.textLayer.cancel();
      try {
        that.textLayer.render(viewport).then(function () {
          that._drawInCanvas();
        });
      } catch (error) {
        that._drawInCanvas();
      }
    } else {
      that._drawInCanvas();
    }

    // setBabelTimeout(function(){

    // }, 100);
  }.bind(that), function failed() {
    $tmplCanvas.remove();
    //console.log('*** draw pdf page canceled');
    that.isRejected = true;
    that.rTask = null;
    that.bufferEditorCanvasPage.shift();
    //   	for (var i = 0; i < callbacks.length; i++) {
    // 	var callback = callbacks[i];
    // 	setBabelTimeout(function(){
    // 		if(callback) callback();
    // 	}, 1);
    // };
    that._drawInCanvas();
  }.bind(that), function () {
    console.log("************ third function");
  });
};
MMPDFDrawerController.prototype.drawWaterMark = function (ctx, canvas, editor) {
  if (!(editor && editor.board && editor.board.fileInfo)) {
    return;
  }
  var fileInfo = editor.board.fileInfo;
  var watermarkInfo = fileInfo.get("watermarkInfo");
  if (watermarkInfo.watermarkType == 7 && !app.ep.getdotmtxcli()) {
    return;
  }
  MMCommonFun.drawWaterMark(ctx, canvas, editor);
};

// var text = "文字水印测试文字水印测试";
// var deg = 30/180;
// var fontSize = 36
// ;
// var transparent = 0.2;
// // ctx.fillStyle
// ctx.font = "48px serif"
// ctx.globalAlpha = transparent;
// var textLen = ctx.measureText(text).width;
// var wHeight = Math.sin(deg) * textLen; //watermark size
// var wWidth = Math.cos(deg) * textLen;
// var x,y;
// for(x = 20 ; x < canvas.width ; x = x + wWidth +50 ){
// 	for(y = wHeight+50 ; y < canvas.height ; y = y + wHeight + 50){
// 		ctx.save();
// 		ctx.translate(x, y);
// 		ctx.rotate(-deg);
// 		ctx.fillText(text, 0 , 0)
// 		ctx.restore();
// 	}
// }

MMPDFDrawerController.prototype.drawWordWaterMark = function (ctx, canvas, watermarkInfo) {
  MMCommonFun.drawWordWaterMark(ctx, canvas, watermarkInfo);
};
MMPDFDrawerController.prototype.drawimgWaterMark = function (ctx, canvas, watermarkInfo) {
  MMCommonFun.drawimgWaterMark(ctx, canvas, watermarkInfo);
};

},{"1143":1143,"1144":1144,"1145":1145,"1184":1184,"1432":1432,"1437":1437,"1438":1438,"1454":1454,"911":911}],1145:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextLayerBuilder = void 0;
var _regenerator = _interopRequireDefault(require(1199));
require(1423);
require(1463);
require(1487);
require(1532);
require(1538);
require(1535);
require(1534);
require(1477);
require(1450);
require(1437);
require(1478);
var _asyncToGenerator2 = _interopRequireDefault(require(1172));
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _defineProperty2 = _interopRequireDefault(require(1180));
var _classPrivateFieldGet2 = _interopRequireDefault(require(1177));
var _classPrivateFieldSet2 = _interopRequireDefault(require(1178));
var _ui_utils = require(1146);
function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; } /* Copyright 2012 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // eslint-disable-next-line max-len
/** @typedef {import("../src/display/display_utils").PageViewport} PageViewport */ /** @typedef {import("../src/display/api").TextContent} TextContent */ /** @typedef {import("./text_highlighter").TextHighlighter} TextHighlighter */ // eslint-disable-next-line max-len
/** @typedef {import("./text_accessibility.js").TextAccessibilityManager} TextAccessibilityManager */ // const { normalizeUnicode, renderTextLayer, updateTextLayer }  =  window.pdfjsLib;
/**
 * @typedef {Object} TextLayerBuilderOptions
 * @property {TextHighlighter} highlighter - Optional object that will handle
 *   highlighting text from the find controller.
 * @property {TextAccessibilityManager} [accessibilityManager]
 * @property {boolean} [isOffscreenCanvasSupported] - Allows to use an
 *   OffscreenCanvas if needed.
 */
/**
 * The text layer builder provides text selection functionality for the PDF.
 * It does this by creating overlay divs over the PDF's text. These divs
 * contain text that matches the PDF text they are overlaying.
 */
var _enablePermissions = /*#__PURE__*/new WeakMap();
var _rotation = /*#__PURE__*/new WeakMap();
var _scale = /*#__PURE__*/new WeakMap();
var _textContentSource = /*#__PURE__*/new WeakMap();
var _finishRendering = /*#__PURE__*/new WeakSet();
var _bindMouse = /*#__PURE__*/new WeakSet();
var TextLayerBuilder = exports.TextLayerBuilder = /*#__PURE__*/function () {
  function TextLayerBuilder(_ref) {
    var _ref$highlighter = _ref.highlighter,
      highlighter = _ref$highlighter === void 0 ? null : _ref$highlighter,
      _ref$accessibilityMan = _ref.accessibilityManager,
      accessibilityManager = _ref$accessibilityMan === void 0 ? null : _ref$accessibilityMan,
      _ref$isOffscreenCanva = _ref.isOffscreenCanvasSupported,
      isOffscreenCanvasSupported = _ref$isOffscreenCanva === void 0 ? true : _ref$isOffscreenCanva,
      _ref$enablePermission = _ref.enablePermissions,
      enablePermissions = _ref$enablePermission === void 0 ? false : _ref$enablePermission;
    (0, _classCallCheck2["default"])(this, TextLayerBuilder);
    /**
     * Improves text selection by adding an additional div where the mouse was
     * clicked. This reduces flickering of the content if the mouse is slowly
     * dragged up or down.
     */
    _classPrivateMethodInitSpec(this, _bindMouse);
    _classPrivateMethodInitSpec(this, _finishRendering);
    _classPrivateFieldInitSpec(this, _enablePermissions, {
      writable: true,
      value: false
    });
    (0, _defineProperty2["default"])(this, "normalizeUnicode", window.pdfjsLib.normalizeUnicode);
    (0, _defineProperty2["default"])(this, "renderTextLayer", window.pdfjsLib.renderTextLayer);
    (0, _defineProperty2["default"])(this, "updateTextLayer", window.pdfjsLib.updateTextLayer);
    _classPrivateFieldInitSpec(this, _rotation, {
      writable: true,
      value: 0
    });
    _classPrivateFieldInitSpec(this, _scale, {
      writable: true,
      value: 0
    });
    _classPrivateFieldInitSpec(this, _textContentSource, {
      writable: true,
      value: null
    });
    this.textContentItemsStr = [];
    this.renderingDone = false;
    this.textDivs = [];
    this.textDivProperties = new WeakMap();
    this.textLayerRenderTask = null;
    this.highlighter = highlighter;
    this.accessibilityManager = accessibilityManager;
    this.isOffscreenCanvasSupported = isOffscreenCanvasSupported;
    (0, _classPrivateFieldSet2["default"])(this, _enablePermissions, enablePermissions === true);
    this.div = document.createElement("div");
    this.div.className = "textLayer";
    this.hide();
  }
  (0, _createClass2["default"])(TextLayerBuilder, [{
    key: "numTextDivs",
    get: function get() {
      return this.textDivs.length;
    }

    /**
     * Renders the text layer.
     * @param {PageViewport} viewport
     */
  }, {
    key: "render",
    value: (function () {
      var _render = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(viewport) {
        var _this$highlighter, _this$accessibilityMa, _this$accessibilityMa2;
        var scale, rotation, mustRotate, mustRescale;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if ((0, _classPrivateFieldGet2["default"])(this, _textContentSource)) {
                _context.next = 2;
                break;
              }
              throw new Error('No "textContentSource" parameter specified.');
            case 2:
              scale = viewport.scale * (globalThis.devicePixelRatio || 1);
              rotation = viewport.rotation;
              if (!this.renderingDone) {
                _context.next = 10;
                break;
              }
              mustRotate = rotation !== (0, _classPrivateFieldGet2["default"])(this, _rotation);
              mustRescale = scale !== (0, _classPrivateFieldGet2["default"])(this, _scale);
              if (mustRotate || mustRescale) {
                this.hide();
                this.updateTextLayer({
                  container: this.div,
                  viewport: viewport,
                  textDivs: this.textDivs,
                  textDivProperties: this.textDivProperties,
                  isOffscreenCanvasSupported: this.isOffscreenCanvasSupported,
                  mustRescale: mustRescale,
                  mustRotate: mustRotate
                });
                (0, _classPrivateFieldSet2["default"])(this, _scale, scale);
                (0, _classPrivateFieldSet2["default"])(this, _rotation, rotation);
              }
              this.show();
              return _context.abrupt("return");
            case 10:
              this.cancel();
              (_this$highlighter = this.highlighter) === null || _this$highlighter === void 0 || _this$highlighter.setTextMapping(this.textDivs, this.textContentItemsStr);
              (_this$accessibilityMa = this.accessibilityManager) === null || _this$accessibilityMa === void 0 || _this$accessibilityMa.setTextMapping(this.textDivs);
              this.textLayerRenderTask = this.renderTextLayer({
                textContentSource: (0, _classPrivateFieldGet2["default"])(this, _textContentSource),
                container: this.div,
                viewport: viewport,
                textDivs: this.textDivs,
                textDivProperties: this.textDivProperties,
                textContentItemsStr: this.textContentItemsStr,
                isOffscreenCanvasSupported: this.isOffscreenCanvasSupported
              });
              _context.next = 16;
              return this.textLayerRenderTask.promise;
            case 16:
              _classPrivateMethodGet(this, _finishRendering, _finishRendering2).call(this);
              (0, _classPrivateFieldSet2["default"])(this, _scale, scale);
              (0, _classPrivateFieldSet2["default"])(this, _rotation, rotation);
              this.show();
              (_this$accessibilityMa2 = this.accessibilityManager) === null || _this$accessibilityMa2 === void 0 || _this$accessibilityMa2.enable();
            case 21:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function render(_x) {
        return _render.apply(this, arguments);
      }
      return render;
    }())
  }, {
    key: "hide",
    value: function hide() {
      if (!this.div.hidden) {
        var _this$highlighter2;
        // We turn off the highlighter in order to avoid to scroll into view an
        // element of the text layer which could be hidden.
        (_this$highlighter2 = this.highlighter) === null || _this$highlighter2 === void 0 || _this$highlighter2.disable();
        this.div.hidden = true;
      }
    }
  }, {
    key: "show",
    value: function show() {
      if (this.div.hidden && this.renderingDone) {
        var _this$highlighter3;
        this.div.hidden = false;
        (_this$highlighter3 = this.highlighter) === null || _this$highlighter3 === void 0 || _this$highlighter3.enable();
      }
    }

    /**
     * Cancel rendering of the text layer.
     */
  }, {
    key: "cancel",
    value: function cancel() {
      var _this$highlighter4, _this$accessibilityMa3;
      if (this.textLayerRenderTask) {
        this.textLayerRenderTask.cancel();
        this.textLayerRenderTask = null;
      }
      (_this$highlighter4 = this.highlighter) === null || _this$highlighter4 === void 0 || _this$highlighter4.disable();
      (_this$accessibilityMa3 = this.accessibilityManager) === null || _this$accessibilityMa3 === void 0 || _this$accessibilityMa3.disable();
      this.textContentItemsStr.length = 0;
      this.textDivs.length = 0;
      this.textDivProperties = new WeakMap();
    }

    /**
     * @param {ReadableStream | TextContent} source
     */
  }, {
    key: "setTextContentSource",
    value: function setTextContentSource(source) {
      this.cancel();
      (0, _classPrivateFieldSet2["default"])(this, _textContentSource, source);
    }
  }]);
  return TextLayerBuilder;
}();
function _finishRendering2() {
  this.renderingDone = true;
  var endOfContent = document.createElement("div");
  endOfContent.className = "endOfContent";
  this.div.append(endOfContent);
  _classPrivateMethodGet(this, _bindMouse, _bindMouse2).call(this);
}
function _bindMouse2() {
  var _this = this;
  var div = this.div;
  div.addEventListener("mousedown", function (evt) {
    var end = div.querySelector(".endOfContent");
    if (!end) {
      return;
    }
    if (typeof PDFJSDev === "undefined" || !PDFJSDev.test("MOZCENTRAL")) {
      // On non-Firefox browsers, the selection will feel better if the height
      // of the `endOfContent` div is adjusted to start at mouse click
      // location. This avoids flickering when the selection moves up.
      // However it does not work when selection is started on empty space.
      var adjustTop = evt.target !== div;
      if (typeof PDFJSDev === "undefined" || PDFJSDev.test("GENERIC")) {
        adjustTop && (adjustTop = getComputedStyle(end).getPropertyValue("-moz-user-select") !== "none");
      }
      if (adjustTop) {
        var divBounds = div.getBoundingClientRect();
        var r = Math.max(0, (evt.pageY - divBounds.top) / divBounds.height);
        end.style.top = (r * 100).toFixed(2) + "%";
      }
    }
    end.classList.add("active");
  });
  div.addEventListener("mouseup", function () {
    var end = div.querySelector(".endOfContent");
    if (!end) {
      return;
    }
    if (typeof PDFJSDev === "undefined" || !PDFJSDev.test("MOZCENTRAL")) {
      end.style.top = "";
    }
    end.classList.remove("active");
  });
  div.addEventListener("copy", function (event) {
    if (!(0, _classPrivateFieldGet2["default"])(_this, _enablePermissions)) {
      var selection = document.getSelection();
      event.clipboardData.setData("text/plain", (0, _ui_utils.removeNullCharacters)(_this.normalizeUnicode(selection.toString())));
    }
    event.preventDefault();
    event.stopPropagation();
  });
}

},{"1146":1146,"1172":1172,"1175":1175,"1177":1177,"1178":1178,"1179":1179,"1180":1180,"1184":1184,"1199":1199,"1423":1423,"1437":1437,"1450":1450,"1454":1454,"1463":1463,"1477":1477,"1478":1478,"1487":1487,"1532":1532,"1534":1534,"1535":1535,"1538":1538}],1144:[function(require,module,exports){
"use strict";

require(1429);
require(1437);
require(1463);
require(1478);
require(1439);
require(1419);
require(1487);
require(1477);
require(1503);
require(1500);
require(1502);
require(1423);
require(1538);
require(1422);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextHighlighter = void 0;
require(1420);
require(1485);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/* Copyright 2021 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** @typedef {import("./event_utils").EventBus} EventBus */
// eslint-disable-next-line max-len
/** @typedef {import("./pdf_find_controller").PDFFindController} PDFFindController */
/**
 * @typedef {Object} TextHighlighterOptions
 * @property {PDFFindController} findController
 * @property {EventBus} eventBus - The application event bus.
 * @property {number} pageIndex - The page index.
 */
/**
 * TextHighlighter handles highlighting matches from the FindController in
 * either the text layer or XFA layer depending on the type of document.
 */
var TextHighlighter = exports.TextHighlighter = /*#__PURE__*/function () {
  /**
   * @param {TextHighlighterOptions} options
   */
  function TextHighlighter(_ref) {
    var findController = _ref.findController,
      eventBus = _ref.eventBus,
      pageIndex = _ref.pageIndex;
    (0, _classCallCheck2["default"])(this, TextHighlighter);
    this.findController = findController;
    this.matches = [];
    this.eventBus = eventBus;
    this.pageIdx = pageIndex;
    this._onUpdateTextLayerMatches = null;
    this.textDivs = null;
    this.textContentItemsStr = null;
    this.enabled = false;
  }

  /**
   * Store two arrays that will map DOM nodes to text they should contain.
   * The arrays should be of equal length and the array element at each index
   * should correspond to the other. e.g.
   * `items[0] = "<span>Item 0</span>" and texts[0] = "Item 0";
   *
   * @param {Array<Node>} divs
   * @param {Array<string>} texts
   */
  (0, _createClass2["default"])(TextHighlighter, [{
    key: "setTextMapping",
    value: function setTextMapping(divs, texts) {
      this.textDivs = divs;
      this.textContentItemsStr = texts;
    }

    /**
     * Start listening for events to update the highlighter and check if there are
     * any current matches that need be highlighted.
     */
  }, {
    key: "enable",
    value: function enable() {
      var _this = this;
      if (!this.textDivs || !this.textContentItemsStr) {
        throw new Error("Text divs and strings have not been set.");
      }
      if (this.enabled) {
        throw new Error("TextHighlighter is already enabled.");
      }
      this.enabled = true;
      if (!this._onUpdateTextLayerMatches) {
        this._onUpdateTextLayerMatches = function (evt) {
          if (evt.pageIndex === _this.pageIdx || evt.pageIndex === -1) {
            _this._updateMatches();
          }
        };
        this.eventBus._on("updatetextlayermatches", this._onUpdateTextLayerMatches);
      }
      this._updateMatches();
    }
  }, {
    key: "disable",
    value: function disable() {
      if (!this.enabled) {
        return;
      }
      this.enabled = false;
      if (this._onUpdateTextLayerMatches) {
        this.eventBus._off("updatetextlayermatches", this._onUpdateTextLayerMatches);
        Dispatcher.off("updatetextlayermatches", this._onUpdateTextLayerMatches);
        this._onUpdateTextLayerMatches = null;
      }
      this._updateMatches( /* reset = */true);
    }
  }, {
    key: "_convertMatches",
    value: function _convertMatches(matches, matchesLength) {
      // Early exit if there is nothing to convert.
      if (!matches) {
        return [];
      }
      var textContentItemsStr = this.textContentItemsStr;
      var i = 0,
        iIndex = 0;
      var end = textContentItemsStr.length - 1;
      var result = [];
      for (var m = 0, mm = matches.length; m < mm; m++) {
        // Calculate the start position.
        var matchIdx = matches[m];

        // Loop over the divIdxs.
        while (i !== end && matchIdx >= iIndex + textContentItemsStr[i].length) {
          iIndex += textContentItemsStr[i].length;
          i++;
        }
        if (i === textContentItemsStr.length) {
          console.error("Could not find a matching mapping");
        }
        var match = {
          begin: {
            divIdx: i,
            offset: matchIdx - iIndex
          }
        };

        // Calculate the end position.
        matchIdx += matchesLength[m];

        // Somewhat the same array as above, but use > instead of >= to get
        // the end position right.
        while (i !== end && matchIdx > iIndex + textContentItemsStr[i].length) {
          iIndex += textContentItemsStr[i].length;
          i++;
        }
        match.end = {
          divIdx: i,
          offset: matchIdx - iIndex
        };
        result.push(match);
      }
      return result;
    }
  }, {
    key: "_renderMatches",
    value: function _renderMatches(matches) {
      // Early exit if there is nothing to render.
      if (matches.length === 0) {
        return;
      }
      var findController = this.findController,
        pageIdx = this.pageIdx;
      var textContentItemsStr = this.textContentItemsStr,
        textDivs = this.textDivs;
      var isSelectedPage = pageIdx === findController.selected.pageIdx;
      var selectedMatchIdx = findController.selected.matchIdx;
      var highlightAll = findController.state.highlightAll;
      var prevEnd = null;
      var infinity = {
        divIdx: -1,
        offset: undefined
      };
      function beginText(begin, className) {
        var divIdx = begin.divIdx;
        textDivs[divIdx].textContent = "";
        return appendTextToDiv(divIdx, 0, begin.offset, className);
      }
      function appendTextToDiv(divIdx, fromOffset, toOffset, className) {
        var div = textDivs[divIdx];
        if (div.nodeType === Node.TEXT_NODE) {
          var span = document.createElement("span");
          div.before(span);
          span.append(div);
          textDivs[divIdx] = span;
          div = span;
        }
        var content = textContentItemsStr[divIdx].substring(fromOffset, toOffset);
        var node = document.createTextNode(content);
        if (className) {
          var _span = document.createElement("span");
          _span.className = "".concat(className, " appended");
          _span.append(node);
          div.append(_span);
          return className.includes("selected") ? _span.offsetLeft : 0;
        }
        div.append(node);
        return 0;
      }
      var i0 = selectedMatchIdx,
        i1 = i0 + 1;
      if (highlightAll) {
        i0 = 0;
        i1 = matches.length;
      } else if (!isSelectedPage) {
        // Not highlighting all and this isn't the selected page, so do nothing.
        return;
      }
      var lastDivIdx = -1;
      var lastOffset = -1;
      for (var i = i0; i < i1; i++) {
        var match = matches[i];
        var begin = match.begin;
        if (begin.divIdx === lastDivIdx && begin.offset === lastOffset) {
          // It's possible to be in this situation if we searched for a 'f' and we
          // have a ligature 'ff' in the text. The 'ff' has to be highlighted two
          // times.
          continue;
        }
        lastDivIdx = begin.divIdx;
        lastOffset = begin.offset;
        var end = match.end;
        var isSelected = isSelectedPage && i === selectedMatchIdx;
        var highlightSuffix = isSelected ? " selected" : "";
        var selectedLeft = 0;

        // Match inside new div.
        if (!prevEnd || begin.divIdx !== prevEnd.divIdx) {
          // If there was a previous div, then add the text at the end.
          if (prevEnd !== null) {
            appendTextToDiv(prevEnd.divIdx, prevEnd.offset, infinity.offset);
          }
          // Clear the divs and set the content until the starting point.
          beginText(begin);
        } else {
          appendTextToDiv(prevEnd.divIdx, prevEnd.offset, begin.offset);
        }
        if (begin.divIdx === end.divIdx) {
          selectedLeft = appendTextToDiv(begin.divIdx, begin.offset, end.offset, "highlight" + highlightSuffix);
        } else {
          selectedLeft = appendTextToDiv(begin.divIdx, begin.offset, infinity.offset, "highlight begin" + highlightSuffix);
          for (var n0 = begin.divIdx + 1, n1 = end.divIdx; n0 < n1; n0++) {
            textDivs[n0].className = "highlight middle" + highlightSuffix;
          }
          beginText(end, "highlight end" + highlightSuffix);
        }
        prevEnd = end;
        if (isSelected) {
          // Attempt to scroll the selected match into view.
          findController.scrollMatchIntoView({
            element: textDivs[begin.divIdx],
            selectedLeft: selectedLeft,
            pageIndex: pageIdx,
            matchIndex: selectedMatchIdx
          });
        }
      }
      if (prevEnd) {
        appendTextToDiv(prevEnd.divIdx, prevEnd.offset, infinity.offset);
      }
    }
  }, {
    key: "_updateMatches",
    value: function _updateMatches() {
      var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!this.enabled && !reset) {
        return;
      }
      var findController = this.findController,
        matches = this.matches,
        pageIdx = this.pageIdx;
      var textContentItemsStr = this.textContentItemsStr,
        textDivs = this.textDivs;
      var clearedUntilDivIdx = -1;

      // Clear all current matches.
      var _iterator = _createForOfIteratorHelper(matches),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var match = _step.value;
          var begin = Math.max(clearedUntilDivIdx, match.begin.divIdx);
          for (var n = begin, end = match.end.divIdx; n <= end; n++) {
            var div = textDivs[n];
            div.textContent = textContentItemsStr[n];
            div.className = "";
          }
          clearedUntilDivIdx = match.end.divIdx + 1;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (!(findController !== null && findController !== void 0 && findController.highlightMatches) || reset) {
        return;
      }
      // Convert the matches on the `findController` into the match format
      // used for the textLayer.
      var pageMatches = findController.pageMatches[pageIdx] || null;
      var pageMatchesLength = findController.pageMatchesLength[pageIdx] || null;
      this.matches = this._convertMatches(pageMatches, pageMatchesLength);
      this._renderMatches(this.matches);
    }
  }]);
  return TextHighlighter;
}();

},{"1175":1175,"1179":1179,"1184":1184,"1419":1419,"1420":1420,"1422":1422,"1423":1423,"1429":1429,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1477":1477,"1478":1478,"1485":1485,"1487":1487,"1500":1500,"1502":1502,"1503":1503,"1538":1538}],1143:[function(require,module,exports){
"use strict";

require(1437);
require(1478);
require(1439);
require(1477);
require(1503);
require(1500);
require(1502);
require(1422);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextAccessibilityManager = void 0;
require(1423);
require(1443);
require(1463);
require(1487);
require(1538);
require(1429);
require(1431);
require(1420);
require(1485);
require(1424);
require(1415);
require(1419);
require(1532);
require(1534);
require(1412);
var _slicedToArray2 = _interopRequireDefault(require(1192));
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _classPrivateFieldGet2 = _interopRequireDefault(require(1177));
var _classPrivateFieldSet2 = _interopRequireDefault(require(1178));
var _ui_utils = require(1146);
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
function _classStaticPrivateMethodGet(receiver, classConstructor, method) { _classCheckPrivateStaticAccess(receiver, classConstructor); return method; }
function _classCheckPrivateStaticAccess(receiver, classConstructor) { if (receiver !== classConstructor) { throw new TypeError("Private static access of wrong provenance"); } } /* Copyright 2022 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This class aims to provide some methods:
 *  - to reorder elements in the DOM with respect to the visual order;
 *  - to create a link, using aria-owns, between spans in the textLayer and
 *    annotations in the annotationLayer. The goal is to help to know
 *    where the annotations are in the text flow.
 */
var _enabled = /*#__PURE__*/new WeakMap();
var _textChildren = /*#__PURE__*/new WeakMap();
var _textNodes = /*#__PURE__*/new WeakMap();
var _waitingElements = /*#__PURE__*/new WeakMap();
var _addIdToAriaOwns = /*#__PURE__*/new WeakSet();
var TextAccessibilityManager = exports.TextAccessibilityManager = /*#__PURE__*/function () {
  function TextAccessibilityManager() {
    (0, _classCallCheck2["default"])(this, TextAccessibilityManager);
    _classPrivateMethodInitSpec(this, _addIdToAriaOwns);
    _classPrivateFieldInitSpec(this, _enabled, {
      writable: true,
      value: false
    });
    _classPrivateFieldInitSpec(this, _textChildren, {
      writable: true,
      value: null
    });
    _classPrivateFieldInitSpec(this, _textNodes, {
      writable: true,
      value: new Map()
    });
    _classPrivateFieldInitSpec(this, _waitingElements, {
      writable: true,
      value: new Map()
    });
  }
  (0, _createClass2["default"])(TextAccessibilityManager, [{
    key: "setTextMapping",
    value: function setTextMapping(textDivs) {
      (0, _classPrivateFieldSet2["default"])(this, _textChildren, textDivs);
    }

    /**
     * Compare the positions of two elements, it must correspond to
     * the visual ordering.
     *
     * @param {HTMLElement} e1
     * @param {HTMLElement} e2
     * @returns {number}
     */
  }, {
    key: "enable",
    value:
    /**
     * Function called when the text layer has finished rendering.
     */
    function enable() {
      if ((0, _classPrivateFieldGet2["default"])(this, _enabled)) {
        throw new Error("TextAccessibilityManager is already enabled.");
      }
      if (!(0, _classPrivateFieldGet2["default"])(this, _textChildren)) {
        throw new Error("Text divs and strings have not been set.");
      }
      (0, _classPrivateFieldSet2["default"])(this, _enabled, true);
      (0, _classPrivateFieldSet2["default"])(this, _textChildren, (0, _classPrivateFieldGet2["default"])(this, _textChildren).slice());
      (0, _classPrivateFieldGet2["default"])(this, _textChildren).sort(_classStaticPrivateMethodGet(TextAccessibilityManager, TextAccessibilityManager, _compareElementPositions));
      if ((0, _classPrivateFieldGet2["default"])(this, _textNodes).size > 0) {
        // Some links have been made before this manager has been disabled, hence
        // we restore them.
        var textChildren = (0, _classPrivateFieldGet2["default"])(this, _textChildren);
        var _iterator = _createForOfIteratorHelper((0, _classPrivateFieldGet2["default"])(this, _textNodes)),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = (0, _slicedToArray2["default"])(_step.value, 2),
              id = _step$value[0],
              nodeIndex = _step$value[1];
            var element = document.getElementById(id);
            if (!element) {
              // If the page was *fully* reset the element no longer exists, and it
              // will be re-inserted later (i.e. when the annotationLayer renders).
              (0, _classPrivateFieldGet2["default"])(this, _textNodes)["delete"](id);
              continue;
            }
            _classPrivateMethodGet(this, _addIdToAriaOwns, _addIdToAriaOwns2).call(this, id, textChildren[nodeIndex]);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      var _iterator2 = _createForOfIteratorHelper((0, _classPrivateFieldGet2["default"])(this, _waitingElements)),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = (0, _slicedToArray2["default"])(_step2.value, 2),
            _element = _step2$value[0],
            isRemovable = _step2$value[1];
          this.addPointerInTextLayer(_element, isRemovable);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      (0, _classPrivateFieldGet2["default"])(this, _waitingElements).clear();
    }
  }, {
    key: "disable",
    value: function disable() {
      if (!(0, _classPrivateFieldGet2["default"])(this, _enabled)) {
        return;
      }

      // Don't clear this.#textNodes which is used to rebuild the aria-owns
      // in case it's re-enabled at some point.

      (0, _classPrivateFieldGet2["default"])(this, _waitingElements).clear();
      (0, _classPrivateFieldSet2["default"])(this, _textChildren, null);
      (0, _classPrivateFieldSet2["default"])(this, _enabled, false);
    }

    /**
     * Remove an aria-owns id from a node in the text layer.
     * @param {HTMLElement} element
     */
  }, {
    key: "removePointerInTextLayer",
    value: function removePointerInTextLayer(element) {
      var _owns;
      if (!(0, _classPrivateFieldGet2["default"])(this, _enabled)) {
        (0, _classPrivateFieldGet2["default"])(this, _waitingElements)["delete"](element);
        return;
      }
      var children = (0, _classPrivateFieldGet2["default"])(this, _textChildren);
      if (!children || children.length === 0) {
        return;
      }
      var id = element.id;
      var nodeIndex = (0, _classPrivateFieldGet2["default"])(this, _textNodes).get(id);
      if (nodeIndex === undefined) {
        return;
      }
      var node = children[nodeIndex];
      (0, _classPrivateFieldGet2["default"])(this, _textNodes)["delete"](id);
      var owns = node.getAttribute("aria-owns");
      if ((_owns = owns) !== null && _owns !== void 0 && _owns.includes(id)) {
        owns = owns.split(" ").filter(function (x) {
          return x !== id;
        }).join(" ");
        if (owns) {
          node.setAttribute("aria-owns", owns);
        } else {
          node.removeAttribute("aria-owns");
          node.setAttribute("role", "presentation");
        }
      }
    }
  }, {
    key: "addPointerInTextLayer",
    value:
    /**
     * Find the text node which is the nearest and add an aria-owns attribute
     * in order to correctly position this editor in the text flow.
     * @param {HTMLElement} element
     * @param {boolean} isRemovable
     */
    function addPointerInTextLayer(element, isRemovable) {
      var id = element.id;
      if (!id) {
        return;
      }
      if (!(0, _classPrivateFieldGet2["default"])(this, _enabled)) {
        // The text layer needs to be there, so we postpone the association.
        (0, _classPrivateFieldGet2["default"])(this, _waitingElements).set(element, isRemovable);
        return;
      }
      if (isRemovable) {
        this.removePointerInTextLayer(element);
      }
      var children = (0, _classPrivateFieldGet2["default"])(this, _textChildren);
      if (!children || children.length === 0) {
        return;
      }
      var index = (0, _ui_utils.binarySearchFirstItem)(children, function (node) {
        return _classStaticPrivateMethodGet(TextAccessibilityManager, TextAccessibilityManager, _compareElementPositions).call(TextAccessibilityManager, element, node) < 0;
      });
      var nodeIndex = Math.max(0, index - 1);
      _classPrivateMethodGet(this, _addIdToAriaOwns, _addIdToAriaOwns2).call(this, id, children[nodeIndex]);
      (0, _classPrivateFieldGet2["default"])(this, _textNodes).set(id, nodeIndex);
    }

    /**
     * Move a div in the DOM in order to respect the visual order.
     * @param {HTMLDivElement} element
     */
  }, {
    key: "moveElementInDOM",
    value: function moveElementInDOM(container, element, contentElement, isRemovable) {
      this.addPointerInTextLayer(contentElement, isRemovable);
      if (!container.hasChildNodes()) {
        container.append(element);
        return;
      }
      var children = Array.from(container.childNodes).filter(function (node) {
        return node !== element;
      });
      if (children.length === 0) {
        return;
      }
      var elementToCompare = contentElement || element;
      var index = (0, _ui_utils.binarySearchFirstItem)(children, function (node) {
        return _classStaticPrivateMethodGet(TextAccessibilityManager, TextAccessibilityManager, _compareElementPositions).call(TextAccessibilityManager, elementToCompare, node) < 0;
      });
      if (index === 0) {
        children[0].before(element);
      } else {
        children[index - 1].after(element);
      }
    }
  }]);
  return TextAccessibilityManager;
}();
function _compareElementPositions(e1, e2) {
  var rect1 = e1.getBoundingClientRect();
  var rect2 = e2.getBoundingClientRect();
  if (rect1.width === 0 && rect1.height === 0) {
    return +1;
  }
  if (rect2.width === 0 && rect2.height === 0) {
    return -1;
  }
  var top1 = rect1.y;
  var bot1 = rect1.y + rect1.height;
  var mid1 = rect1.y + rect1.height / 2;
  var top2 = rect2.y;
  var bot2 = rect2.y + rect2.height;
  var mid2 = rect2.y + rect2.height / 2;
  if (mid1 <= top2 && mid2 >= bot1) {
    return -1;
  }
  if (mid2 <= top1 && mid1 >= bot2) {
    return +1;
  }
  var centerX1 = rect1.x + rect1.width / 2;
  var centerX2 = rect2.x + rect2.width / 2;
  return centerX1 - centerX2;
}
function _addIdToAriaOwns2(id, node) {
  var owns = node.getAttribute("aria-owns");
  if (!(owns !== null && owns !== void 0 && owns.includes(id))) {
    node.setAttribute("aria-owns", owns ? "".concat(owns, " ").concat(id) : id);
  }
  node.removeAttribute("role");
}

},{"1146":1146,"1175":1175,"1177":1177,"1178":1178,"1179":1179,"1184":1184,"1192":1192,"1412":1412,"1415":1415,"1419":1419,"1420":1420,"1422":1422,"1423":1423,"1424":1424,"1429":1429,"1431":1431,"1437":1437,"1439":1439,"1443":1443,"1454":1454,"1463":1463,"1477":1477,"1478":1478,"1485":1485,"1487":1487,"1500":1500,"1502":1502,"1503":1503,"1532":1532,"1534":1534,"1538":1538}],911:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// MDWaterMarkDrawer.js
// jiang
// 2017.9.3

var MDWaterMarkDrawer = function MDWaterMarkDrawer() {};
_.extend(MDWaterMarkDrawer.prototype, {
  drawTextWaterMark: function drawTextWaterMark(ctx, text, viewWidth, viewHeight) {
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.rotate(-45 * Math.PI / 180);
    ctx.translate(-Math.sqrt(2) * viewHeight, 0);
    ctx.fillStyle = "rgba(0,0,0,0.1)";
    ctx.font = "60px Georgia";
    var wordSize = ctx.measureText(text);
    wordSize.height = 100;
    var gap = 50;
    var width = Math.sqrt(2) * viewWidth + Math.sqrt(2) * viewHeight;
    var i = 0;
    for (var y = 0; y < width; y += wordSize.height) {
      var x = 0;
      if (i % 2 == 1) {
        x = -(wordSize.width + gap) / 2;
      }
      ;
      for (; x < width; x += wordSize.width) {
        x += 50;
        ctx.fillText(text, x, y);
      }
      ;
      i++;
    }
    ;
    ctx.setTransform(1, 0, 0, 1, 0, 0);
  }
});
var _default = exports["default"] = MDWaterMarkDrawer;

},{"1454":1454}],895:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _transformer = _interopRequireDefault(require(838));
var _size = _interopRequireDefault(require(837));
/**
 *
 */

function MMPageThumbnailMaker(board, thumbWidth) {
  this.board = board;
  var ThumbWidth = 384;
  this.thumbW = thumbWidth || ThumbWidth;
  this.$canvas = $("<canvas class='thumbnail-maker' style='position:fixed;display:none' " + "width='" + this.thumbW + "px' >" + "</canvas>");
  $("body").append(this.$canvas);
  var pageSize = this.board.getPageSize();
  this.thumbH = this.thumbW * pageSize.height / pageSize.width;
  this.$canvas.attr("height", this.thumbH + "px");
  var dvSize = new _size["default"](this.thumbW, this.thumbH);
  this.trsfm = new _transformer["default"](pageSize, dvSize);
}
;
var g_pageThumbMakerSingleton = null;
MMPageThumbnailMaker.getSingleInstance = function (board) {
  if (g_pageThumbMakerSingleton == null) {
    g_pageThumbMakerSingleton = new MMPageThumbnailMaker(board);
  }
  g_pageThumbMakerSingleton.board = board;
  return g_pageThumbMakerSingleton;
};

/**
 * create thumbnail for the page
 * @param {Number} index - page index
 * @param {function(img)} callback -
 */
MMPageThumbnailMaker.prototype.createThumbnailForPage = function (index, sucCB_, failCB_) {
  var ctx = this.$canvas[0].getContext("2d");
  ctx.clearRect(0, 0, this.thumbW, this.thumbH);
  var that = this;
  this.board.drawPageThumbnailInCanvas(ctx, this.trsfm, index, function () {
    // success
    var img = new Image();
    try {
      var xiaoCanvas = that.$canvas[0];
      img.onload = function () {
        if (sucCB_) sucCB_(img);
      };
      img.src = xiaoCanvas.toDataURL("image/jpeg");
    } catch (e) {
      console.error(e.message);
      if (failCB_) failCB_();
      return;
    }
  }, function () {
    // failed
    //console.log("make thumbnail failed!");
    failCB_();
  });
};
var _default = exports["default"] = MMPageThumbnailMaker;

},{"1184":1184,"1454":1454,"837":837,"838":838}],857:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDSelectFrame = _interopRequireDefault(require(919));
var _MDColorDisk = _interopRequireDefault(require(856));
var _MDPopupView = _interopRequireDefault(require(64));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
/**
 *  Menu for zoom choices
 *  Create by jiang
 *  2015.9.15
 */

var MDColorDiskPopupView = _MDPopupView["default"].extend({
  contentTmpl: '<ul class="m-menu color-list"></ul>',
  events: function events() {
    var superEvents = _MDPopupView["default"].prototype.events.call(this);
    return _.extend({}, superEvents, {
      'click li': this._menuItemClickHandler
    });
  },
  initProps: function initProps() {
    var superP = _MDPopupView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      zoomSelected: -1,
      $zoomList: null,
      scaleList: []
    });
  },
  initialize: function initialize(opt) {
    _MDPopupView["default"].prototype.initialize.call(this, opt);
    this.initColorList();
  },
  initColorList: function initColorList() {
    var colorList = _MDColorDisk["default"].colors;
    var html = "";
    for (var i = 0; i < colorList.length; i++) {
      if (i == _MDColorDisk["default"].curIndex) {
        html += '<li class="selected" style="background-color:' + colorList[i] + '">' + '</li>';
      } else {
        html += '<li style="background-color:' + colorList[i] + '">' + '</li>';
      }
    }
    ;
    this.$(".m-menu").append(html);
    this.$zoomList = $(html);
  },
  _menuItemClickHandler: function _menuItemClickHandler($e) {
    var index = $($e.target).index();
    _MDColorDisk["default"].curIndex = index;
    _MDSelectFrame["default"].setColor(_MDColorDisk["default"].getCurColor());
    this.close();
  }
});
var _default = exports["default"] = MDColorDiskPopupView;

},{"1184":1184,"1454":1454,"64":64,"807":807,"856":856,"919":919}],826:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _BoardOrientation = _interopRequireDefault(require(802));
var _transformer = _interopRequireDefault(require(838));
var _MMPoint = _interopRequireDefault(require(830));
function ImageTransformer(dv_imageSize, lg_imageRect, angle, viewAngle) {
  _transformer["default"].call(this, lg_imageRect.getSize(), dv_imageSize, _BoardOrientation["default"].Portrait, viewAngle); //
  this.lgPgOrigin = lg_imageRect.getOrigin();
  this.angle = angle;
  this.center = lg_imageRect.getCenter();
}
;
ImageTransformer.prototype = new _transformer["default"]();
ImageTransformer.superclass = _transformer["default"].prototype;

/**
 *
 * @param lgpoint { MMPoint }
 * @param pgindex { int } PageIndex
 * @returns { MMPoint }
 */
ImageTransformer.prototype.lg2dvPoint = function (lgpoint, pgindex) {
  lgpoint = lgpoint.clone();
  MMCommonFun.rotateAroundPt(lgpoint, this.center, -this.angle);
  var dvPoint = ImageTransformer.superclass.lg2dvPoint.call(this, lgpoint, 0);
  if (this.fromDiv && this.targetDiv) {
    dvPoint = MMCommonFun.convertPointBetweenElements(this.fromDiv, this.targetDiv, dvPoint);
  }
  ;
  return new _MMPoint["default"](dvPoint.x, dvPoint.y);
};
ImageTransformer.prototype.dv2lgPoint = function (dvpoint, pgindex) {
  var tempPt = new _MMPoint["default"](dvpoint.x, dvpoint.y);
  if (this.fromDiv && this.targetDiv) {
    tempPt = MMCommonFun.convertPointBetweenElements(this.targetDiv, this.fromDiv, tempPt);
  }
  ;
  var lgpoint = ImageTransformer.superclass.dv2lgPoint.call(this, tempPt, 0);
  MMCommonFun.rotateAroundPt(lgpoint, this.center, this.angle);
  return new _MMPoint["default"](lgpoint.x, lgpoint.y);
};
ImageTransformer.prototype.setLayers = function (fromDiv, targetDiv) {
  this.fromDiv = fromDiv;
  this.targetDiv = targetDiv;
};

// mola.math.AssistantTransformer = function(lgSize_, dvSize_, ort_, offset_) {
//   Transformer.call(this, lgSize_, dvSize_, ort_);
//   this.offset = offset_;
// };
// mola.math.AssistantTransformer.prototype = new Transformer();
// mola.math.AssistantTransformer.superclass = Transformer.prototype;

// mola.math.AssistantTransformer.prototype.lg2dvPoint = function(lgpoint, pgindex) {
//   lgpoint = lgpoint.clone();
//   var dvPoint = ImageTransformer.superclass.lg2dvPoint.call(this, lgpoint, pgindex);
//   dvPoint.x = dvPoint.x + this.offset.x;
//   dvPoint.y = dvPoint.y + this.offset.y;
//   return dvPoint;
// };

// mola.math.AssistantTransformer.prototype.dv2lgPoint = function(dvpoint, pgindex) {
//   dvpoint.x = dvpoint.x - this.offset.x;
//   dvpoint.y = dvpoint.y - this.offset.y;
//   var lgpoint = ImageTransformer.superclass.dv2lgPoint.call(this, dvpoint, pgindex);
//   return lgpoint;
// };
var _default = exports["default"] = ImageTransformer;

},{"1184":1184,"1454":1454,"802":802,"830":830,"838":838}],838:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _size = _interopRequireDefault(require(837));
var _MMRect = _interopRequireDefault(require(831));
var _MMPoint = _interopRequireDefault(require(830));
var _BoardOrientation = _interopRequireDefault(require(802));
var _MMCenterRect = _interopRequireDefault(require(829));
var _MMCommonFun = _interopRequireDefault(require(812));
/**
 * 逻辑坐标和设备坐标转换器
 *
 * jiang
 * 2014-5-21
 */

/**
 * @param lg_pagesize   {Size}
 * @param dv_pagesize   {Size}
 * @param ort     {BoardOrientation}
 */
function Transformer(lg_pagesize, dv_pagesize, ort, viewAngle) {
  this.lgPgOrigin = new _MMPoint["default"](0, 0);
  this.lgpgsize = lg_pagesize;
  this.dvpgsize = dv_pagesize;
  this.viewAngle = !viewAngle ? 0 : viewAngle;
  if (dv_pagesize) {
    this.viewCenter = {
      x: dv_pagesize.width / 2,
      y: dv_pagesize.height / 2
    };
    var dvPts = [{
      x: 0,
      y: 0
    }, {
      x: dv_pagesize.width,
      y: dv_pagesize.height
    }];
    _MMCommonFun["default"].rotateAroundPts(dvPts, this.viewCenter, this.viewAngle);
    var dvRect = new _MMRect["default"]();
    dvRect.initWithPtsBounadingBox(dvPts);
    this.dvOrigin = dvRect.getOrigin();
  }
  if (ort == undefined) {
    this.orientation = _BoardOrientation["default"].Portrait;
  } else {
    this.orientation = ort;
  }
  this.$viewcontent = null; // 显示 div 时需要挂靠的 parentDiv
  this.view_editable = true; // 所对应的 view 中的对象是否可以和用户交互

  this.m_pagePageIndex = 0; // 基础页号，用于协同页的时候

  this.m_startPg = 0;
  return this;
}
;
Transformer.prototype.setPageBaseIndex = function (i) {
  this.m_pagePageIndex = i;
};
Transformer.prototype.setDevicePageSize = function (size) {
  this.dvpgsize = size;
};
Transformer.prototype.getDevicePageSize = function () {
  var size = this.dvpgsize.clone();
  return size;
};
Transformer.prototype.setStartPageIndex = function (i) {
  this.m_startPg = i;
};
Transformer.prototype.getStartPageIndex = function (size) {
  return this.m_startPg;
};
Transformer.prototype.setOrientation = function (ort) {
  this.orientation = ort;
};

/**
 *
 * @param lgpoint { MMPoint }
 * @param pgindex { int } PageIndex
 * @returns { MMPoint }
 */
Transformer.prototype.lg2dvPoint = function (lgpoint, pgindex) {
  if (pgindex == undefined || pgindex == null) {
    pgindex = 0;
  }
  pgindex += this.m_pagePageIndex;
  var dvpoint = new _MMPoint["default"]();
  if (this.orientation == _BoardOrientation["default"].Portrait) {
    dvpoint.x = (lgpoint.x - this.lgPgOrigin.x) / this.lgpgsize.width * this.dvpgsize.width;
    dvpoint.y = (lgpoint.y - this.lgPgOrigin.y) / this.lgpgsize.height * this.dvpgsize.height;
    dvpoint.y -= this.dvpgsize.height * pgindex;
  } else {
    dvpoint.y = (this.lgpgsize.width - (lgpoint.x - this.lgPgOrigin.x)) / this.lgpgsize.width * this.dvpgsize.height;
    dvpoint.x = (lgpoint.y - this.lgPgOrigin.y) / this.lgpgsize.height * this.dvpgsize.width;
    dvpoint.x -= this.dvpgsize.width * pgindex;
  }
  _MMCommonFun["default"].rotateAroundPt(dvpoint, this.viewCenter, this.viewAngle);
  dvpoint.x -= this.dvOrigin.x;
  dvpoint.y -= this.dvOrigin.y;
  return dvpoint;
};
/**
 * this method is usefull for offsets
 * please test this function before use
 */
Transformer.prototype.lg2dvVec = function (lgpoint) {
  if (this.orientation == _BoardOrientation["default"].Portrait) {
    return new _MMPoint["default"](this.lg2dvLen(lgpoint.x), this.lg2dvLen(lgpoint.y));
  } else {
    return new _MMPoint["default"](this.lg2dvLen(lgpoint.y), this.lg2dvLen(-lgpoint.x));
  }
};

//----------------------------------- deleted by jiang -------------------
///**
// * this method is usefull for offsets
// */
//Transformer.prototype.dv2lgVec = function(lgpoint){
//  console.assert(false,"please test this method before use.");
//  if(this.orientation == BoardOrientation.Portrait){
//    return new MMPoint(
//        this.dv2lgLen(lgpoint.x),
//        this.dv2lgLen(lgpoint.y)
//    );
//  }else{
//    return new MMPoint(
//        this.dv2lgLen(lgpoint.y),
//        this.dv2lgLen(-lgpoint.x)
//    );
//  }
//}
///**
// * this method is usefull for offsets
// * please test this function before use
// */
//Transformer.prototype.lg2dvVec = function(lgpoint){
//  if(this.orientation == BoardOrientation.Portrait){
//    return new MMPoint(
//        this.lg2dvLen(lgpoint.x),
//        this.lg2dvLen(lgpoint.y)
//    );
//  }else{
//    return new MMPoint(
//        this.lg2dvLen(lgpoint.y),
//        this.lg2dvLen(-lgpoint.x)
//    );
//  }
//}

//-------------------------------- added by jiang ----------------------------
/**
 * this method is usefull for offsets
 */
Transformer.prototype.dv2lgVec = function (dvpoint) {
  var start = new _MMPoint["default"](0, 0);
  var lgSt = this.dv2lgPoint(dvpoint, 0);
  var lgEnd = this.dv2lgPoint(start, 0);
  var tg = lgEnd.offsetTo(lgSt);
  return tg;
};
Transformer.prototype.lg2dvVec = function (lgpoint) {
  var start = new _MMPoint["default"](0, 0);
  var dvSt = this.lg2dvPoint(lgpoint, 0);
  var dvEnd = this.lg2dvPoint(start, 0);
  var tg = dvEnd.offsetTo(dvSt);
  return tg;
};
Transformer.prototype.lg2dvPoints = function (lgpoints, pgindex) {
  var res = [];
  for (var i = 0; i < lgpoints.length; i++) {
    var point = this.lg2dvPoint(lgpoints[i], pgindex);
    res.push(point);
  }
  return res;
};
Transformer.prototype.lg2dvRect = function (lgrect, pgindex) {
  return this.trRect(lgrect, pgindex, this.lg2dvPoint);
};
Transformer.prototype.trRect = function (src_rect, pgindex, func) {
  var tg_rect = new _MMRect["default"]();
  var src_lefttop = new _MMPoint["default"](src_rect.left, src_rect.top);
  var src_rightbottom = new _MMPoint["default"](src_rect.right, src_rect.bottom);
  var tg_lefttop = func.call(this, src_lefttop, pgindex);
  var tg_rightbottom = func.call(this, src_rightbottom, pgindex);
  tg_rect.left = Math.min(tg_lefttop.x, tg_rightbottom.x);
  tg_rect.top = Math.min(tg_lefttop.y, tg_rightbottom.y);
  ;
  tg_rect.right = Math.max(tg_rightbottom.x, tg_lefttop.x);
  tg_rect.bottom = Math.max(tg_rightbottom.y, tg_lefttop.y);
  return tg_rect;
};

/**
 *
 * @param dvpoint {MMPoint}
 * @param pgindex {int}
 * @returns {MMPoint}
 */
Transformer.prototype.dv2lgPoint = function (dvpoint, pgindex) {
  var lgpoint = new _MMPoint["default"]();
  if (pgindex == undefined || pgindex == null) {
    pgindex = 0;
  }
  pgindex += this.m_pagePageIndex;
  dvpoint.x += this.dvOrigin.x;
  dvpoint.y += this.dvOrigin.y;
  _MMCommonFun["default"].rotateAroundPt(dvpoint, this.viewCenter, -this.viewAngle);
  if (this.orientation == _BoardOrientation["default"].Portrait) {
    lgpoint.x = dvpoint.x / this.dvpgsize.width * this.lgpgsize.width + this.lgPgOrigin.x;
    lgpoint.y = dvpoint.y / this.dvpgsize.height * this.lgpgsize.height + this.lgPgOrigin.y;
    lgpoint.y += this.lgpgsize.height * pgindex;
  } else {
    lgpoint.y = dvpoint.x / this.dvpgsize.width * this.lgpgsize.height + this.lgPgOrigin.y;
    lgpoint.x = (this.dvpgsize.height - dvpoint.y) / this.dvpgsize.height * this.lgpgsize.width + this.lgPgOrigin.x;
    lgpoint.y += this.lgpgsize.height * pgindex;
  }
  return lgpoint;
};
/**
 *
 * @param lgpoints {Array of MMPoint}
 * @param pgindex
 * @returns {Array}
 */
Transformer.prototype.dv2lgPoints = function (lgpoints, pgindex) {
  var res = [];
  for (var i = 0; i < lgpoints.length; i++) {
    var point = this.dv2lgPoint(lgpoints[i], pgindex);
    res.push(point);
  }
  return res;
};
Transformer.prototype.dv2lgRect = function (dvRect, pgindex) {
  return this.trRect(dvRect, pgindex, this.dv2lgPoint);
};
Transformer.prototype.lg2dvCenterRect = function (lgRct, pgindex) {
  var dvRct = new _MMCenterRect["default"]();
  dvRct.center = this.lg2dvPoint(lgRct.center, pgindex);
  if (this.orientation == _BoardOrientation["default"].Portrait) {
    dvRct.width = lgRct.width / this.lgpgsize.width * this.dvpgsize.width;
    dvRct.height = lgRct.height / this.lgpgsize.height * this.dvpgsize.height;
    dvRct.angle = lgRct.angle;
  } else {
    dvRct.width = lgRct.width / this.lgpgsize.width * this.dvpgsize.height;
    dvRct.height = lgRct.height / this.lgpgsize.height * this.dvpgsize.width;
    dvRct.angle = lgRct.angle - 90;
  }
  return dvRct;
};
Transformer.prototype.dv2lgCenterRect = function (dvRct, pgindex) {
  var lgRct = new _MMCenterRect["default"]();
  lgRct.center = this.lg2dvPoint(dvRct.center, pgindex);
  if (this.orientation == _BoardOrientation["default"].Portrait) {
    lgRct.width = dvRct.width / this.dvpgsize.width * this.lgpgsize.width;
    lgRct.height = dvRct.height / this.dvpgsize.height * this.lgpgsize.height;
    lgRct.angle = dvRct.angle;
  } else {
    lgRct.width = dvRct.width / this.dvpgsize.width * this.lgpgsize.height;
    lgRct.height = dvRct.height / this.dvpgsize.height * this.lgpgsize.width;
    lgRct.angle = dvRct.angle + 90;
  }
  return lgRct;
};
Transformer.prototype.lg2dvLen = function (len) {
  var dvLen = 0;
  if (this.orientation == _BoardOrientation["default"].Portrait) {
    dvLen = len / this.lgpgsize.width * this.dvpgsize.width;
  } else {
    dvLen = len / this.lgpgsize.width * this.dvpgsize.height;
  }
  return dvLen;
};
Transformer.prototype.dv2lgLen = function (len) {
  var lgLen = 0;
  if (this.orientation == _BoardOrientation["default"].Portrait) {
    lgLen = len / this.dvpgsize.width * this.lgpgsize.width;
  } else {
    lgLen = len / this.dvpgsize.width * this.lgpgsize.height;
  }
  return lgLen;
};
Transformer.prototype.getLgPageIndex = function (y) {
  var index = Math.floor(y / this.lgpgsize.height);
  return index;
};
Transformer.prototype.getLgPageRect = function () {
  var pageRect = new _MMRect["default"](this.lgPgOrigin.y, this.lgPgOrigin.x + this.lgpgsize.width, this.lgPgOrigin.y + this.lgpgsize.height, this.lgPgOrigin.x);
  return pageRect;
};
var _default = exports["default"] = Transformer;

},{"1184":1184,"1454":1454,"802":802,"812":812,"829":829,"830":830,"831":831,"837":837}],439:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDPopupView = _interopRequireDefault(require(64));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
/**
 *  Menu for zoom choices
 *  Create by jiang
 *  2015.9.15
 */

var MDZoomPopupView = _MDPopupView["default"].extend({
  contentTmpl: '<ul class="m-menu"></ul>',
  events: function events() {
    var superEvents = _MDPopupView["default"].prototype.events.call(this);
    return _.extend({}, superEvents, {
      'click li': this._menuItemClickHandler
    });
  },
  initProps: function initProps() {
    var superP = _MDPopupView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      zoomSelected: -1,
      $zoomList: null,
      scaleList: []
    });
  },
  initialize: function initialize(opt) {
    _MDPopupView["default"].prototype.initialize.call(this, opt);
    this.initZoomList();
  },
  initZoomList: function initZoomList() {
    var fileEditor = this.editor.getCurFileEditor();
    this.scaleList = [0.25, 0.50, 0.75, 1.0, 1.50, 2.0];
    if (fileEditor && fileEditor.getZoomList) {
      var list = fileEditor.getZoomList();
      if (list) {
        this.scaleList = list;
      }
    }
    if (this.$zoomList) {
      this.$zoomList.remove();
    }
    var html = "";
    for (var i = 0; i < this.scaleList.length; i++) {
      var scale = this.scaleList[i];
      var percent = Math.round(scale * 100) + "%";
      html += "<li >" + percent + "</li>";
    }
    ;
    var board = this.editor.getCurrentBoard();
    html += "<li>" + BabelStr.str(5161) + "</div>";
    this.$(".m-menu").append(html);
    this.$zoomList = $(html);
  },
  _menuItemClickHandler: function _menuItemClickHandler($e) {
    var index = $($e.target).index();
    this.zoomSelected = -1;
    if (index < this.scaleList.length) {
      this.zoomSelected = this.scaleList[index];
    }
    ;
    if (this.zoomSelected > 0) {
      this.editor.changeScale(this.zoomSelected);
    } else {
      this.editor.zoomToFit();
    }
    this.close();
  }
});
var _default = exports["default"] = MDZoomPopupView;

},{"1184":1184,"1454":1454,"64":64,"807":807}],67:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1424);
require(1417);
require(1463);
require(1412);
require(1466);
var _MDDropdownView = _interopRequireDefault(require(39));
var _MMCommonFun = _interopRequireDefault(require(812));
var _toolsvg = _interopRequireDefault(require(1120));
/**
 * 下拉选择组件
 * WebContent/javascript/base/component/select/MDDropdownSelectListView.js
 * Created by manjun.han
 * 2017.1.11
 */

var MDDropdownSelectListView = _MDDropdownView["default"].extend({
  tmpl: function tmpl() {
    return "<div class=\"form-control cur-selected-opt\">\n      <div class=\"selected-opt-value\"></div>\n        <div class=\"arrow-svg-container\">\n          <span class=\"svg-item down\"><%=arrow_down%></span>\n          <span class=\"svg-item up\"><%=arrow_up%></span>\n        </div>\n    </div>\n    <select></select>\n    <ul class=\"select-opt-list\"></ul>";
  },
  className: function className() {
    var superCls = _MDDropdownView["default"].prototype.className.call(this);
    return superCls + ' select-control';
  },
  initProps: function initProps(opts) {
    var superP = _MDDropdownView["default"].prototype.initProps.call(this, opts);
    return _.extend(superP, {
      /**
       * @callback ChangeCallback
       * @param {string|object|Backbone.Model} dataItem 新的选中数据
       */
      /**
       * 下拉选项改变后的回调
       * @type {ChangeCallback}
       */
      onChange: _.noop,
      /**
       * 初始化选中是否触发onChange
       * @type {boolean}
       */
      silentInit: true,
      /**
       * 针对于异步请求数据的加载成功后的回调处理
       * @type {function}
       */
      onReady: _.noop,
      /**
       * 是否是必填字段，主要用于表单校验
       * @type {boolean}
       */
      required: false,
      /**
       * 默认占位符文本，当 selectedIndex 为 -1 时显示
       * @type {string}
       */
      placeholder: BabelStr.str(40229),
      $selectPopupList: null,
      /**
       * 当前下拉列表的数据源
       * @type {Array.<string>|Array.<object>|Backbone.Collection}
       */
      dataProvider: new Backbone.Collection(),
      /**
       * 下拉列表项的展示字段名称
       * @type {string}
       */
      labelField: 'label',
      isFixed: false,
      /**
       * @callback selectOptionRenderer
       * @param {string|object|Backbone.Model} dataItem - 当前选项的渲染器
       * @param {number} index - 当前行的索引
       * @return {string} 当前行的html模板
       */
      /**
       * 下拉选项的渲染器，默认显示labelField指向的字段值
       * @type {selectOptionRenderer}
       */
      selectOptionRenderer: undefined,
      /**
       * 选中行后的值渲染器
       * @type {selectOptionRenderer}
       */
      selectedOptionRenderer: undefined,
      dropdownAnchor: '.cur-selected-opt',
      dropdownContainer: '.select-opt-list',
      $nativeSelect: null,
      selectedIndex: 0,
      repeatChange: false,
      gapY: 0,
      interceptor: function interceptor() {
        return true;
      }
    });
  },
  events: function events() {
    var superE = _MDDropdownView["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click .select-opt-list li': this._onOptionClickHandler
      // "mousedown input.selected-opt-value": this._inputClickHandler
    });
  },
  initialize: function initialize(options) {
    var eventName = 'mousedown.dropdown';
    this.$("input.selected-opt-value").off(eventName).on(eventName, this._inputClickHandler);
    _MDDropdownView["default"].prototype.initialize.call(this, options);
    this.initWithData(options);
  },
  _inputClickHandler: function _inputClickHandler($e) {
    $e.preventDefault();
    $e.stopPropagation();
  },
  render: function render(data) {
    data = {
      arrow_down: _toolsvg["default"].arrow_down,
      arrow_up: _toolsvg["default"].arrow_up
    };
    _MDDropdownView["default"].prototype.render.call(this, data);
  },
  initWithData: function initWithData(options) {
    this.initProps(options);
    this.$selectPopupList = this.$('.select-opt-list');
    this.$selectedOptValue = this.$('.selected-opt-value');
    this.$nativeSelect = this.$('select');
    this.$nativeSelect.prop('name', this.prefixedName('select'));
    this.$nativeSelect.prop('required', this.required);
    this.setDataProvider(this.dataProvider);
    this.selectItemAt(this.selectedIndex, this.silentInit, true);
    this.bindSelf(this.openDropDown);
  },
  setDisplayValue: function setDisplayValue(text, warning) {
    this.$('.selected-opt-value').text(text);
    if (warning) {
      this.$('.selected-opt-value').addClass("red");
    }
  },
  setDataProvider: function setDataProvider(dataProvider) {
    this.dataProvider = dataProvider;
    this.renderDropdownList();
    this.el.offsetWidth;
  },
  openDropDown: function openDropDown() {
    _MDDropdownView["default"].prototype.openDropDown.call(this);
    if (this.isFixed) {
      this.layoutFixedPos();
      // let pos = this.$el.offset();
      // this.$dropdownContainer.css({
      //   position: "fixed",
      //   left: pos.left,
      //   top: pos.top+32,
      //   width: this.$el.width()
      // })
    }
  },
  layoutFixedPos: function layoutFixedPos() {
    var $pop = this.$('.select-opt-list');
    var elTop = this.$el.offset().top;
    var elLeft = this.$el.offset().left;
    var elHeight = this.$el.height();
    var pos = _MMCommonFun["default"].convertPointBetweenElements(this.$el[0], window, {
      x: 0,
      y: 0
    });
    var winHeight = $(window).height();
    var popHeight = $pop.outerHeight();
    if (pos.y + popHeight + elHeight + this.gapY > winHeight) {
      pos.y = winHeight - popHeight;
      if (pos.y < 0) {
        pos.y = 0;
        $pop.css({
          "max-height": winHeight + "px",
          "overflow-y": "auto"
        });
      }
    } else {
      pos.y = elTop + elHeight + this.gapY;
    }
    if (this.toRight) {
      pos.x = Math.max(0, pos.x - $pop.outerWidth() + this.$el.width());
    }
    $pop.css({
      position: "fixed",
      top: pos.y,
      left: pos.x,
      width: this.$el.width(),
      'z-index': 999
    });
  },
  renderDropdownList: function renderDropdownList() {
    if (!this.dataProvider) {
      return;
    }
    var array;
    var self = this;
    if (this.dataProvider instanceof Backbone.Collection) {
      array = this.dataProvider.models;
    } else if (_.isArray(this.dataProvider)) {
      array = this.dataProvider;
    }
    var buffer = [];
    var nativeSelectBuffer = [];
    _.each(array, function (dataItem, index) {
      var htmlString = self.itemToLabel(dataItem, index);
      buffer.push("<li data-index=".concat(index, ">"));
      buffer.push(htmlString);
      buffer.push('</li>');
      var label = self.toLabelUtil(dataItem);
      nativeSelectBuffer.push('<option>');
      nativeSelectBuffer.push(label);
      nativeSelectBuffer.push('</option>');
    });
    this.addMoreItems(buffer, nativeSelectBuffer);
    this.$selectPopupList.empty().append(buffer.join(''));
    this.$nativeSelect.empty().append(nativeSelectBuffer.join(''));
  },
  addMoreItems: function addMoreItems(buffer, nativeSelectBuffer) {},
  itemToLabel: function itemToLabel(dataItem, index) {
    if (_.isFunction(this.selectOptionRenderer)) {
      return this.selectOptionRenderer(dataItem, index);
    }
    return this.toLabelUtil(dataItem, index);
  },
  toLabelUtil: function toLabelUtil(dataItem) {
    var result;
    if (dataItem instanceof Backbone.Model) {
      result = dataItem.get(this.labelField);
    } else if (_.isString(dataItem)) {
      result = dataItem;
    } else if (_.isObject(dataItem)) {
      result = dataItem[this.labelField];
    }
    return "<span class=\"middle-ellipsis\">".concat(result, "</span>");
  },
  selectItemToLabel: function selectItemToLabel(dataItem, index) {
    if (_.isFunction(this.selectedOptionRenderer)) {
      return this.selectedOptionRenderer(dataItem, index);
    }
    return this.toLabelUtil(dataItem, index);
  },
  selectItemAt: function selectItemAt(index, silent, ingnoreInterceptor) {
    var _this = this;
    if (index === -1) {
      this.selectedDataItem = null;
      this.selectedIndex = -1;
      this.$('.selected-opt-value').removeClass("red");
      this.$selectPopupList.find('>li').removeClass('selected');
      var div = "<div class=\"selected-opt-value placeholder\"></div>";
      this.$selectedOptValue.off("blur");
      this.$selectedOptValue.replaceWith(div);
      this.$selectedOptValue = this.$('.selected-opt-value');
      this.$selectedOptValue.text(this.placeholder);
      return;
    }
    var selectedDataItem = this.getDataItemAt(index);
    if (!selectedDataItem) {
      return;
    }
    if (!ingnoreInterceptor && !this.interceptor(selectedDataItem)) {
      return;
    }
    this.$('.selected-opt-value').removeClass("red");
    if (selectedDataItem.cannotSelect) {
      _.isFunction(this.onChange) && !silent && this.onChange(selectedDataItem);
    } else {
      this.selectedDataItem = selectedDataItem;
      this.$selectPopupList.find('>li').removeClass('selected').eq(index).addClass('selected');
      if (selectedDataItem.contenteditable) {
        this.$selectedOptValue.attr('contenteditable', true);
        var input = "<input class=\"selected-opt-value\" value=\"".concat(selectedDataItem.value, "\" placeholder=\"").concat(selectedDataItem.placeholder || selectedDataItem.value, "\">");
        this.$selectedOptValue.replaceWith(input);
        this.$selectedOptValue = this.$('.selected-opt-value');
        this.$selectedOptValue[0].focus();
        this.$selectedOptValue.off("blur");
        this.$selectedOptValue.on("blur", function () {
          selectedDataItem.value = _this.$selectedOptValue.val();
          _.isFunction(selectedDataItem.onChecked) && selectedDataItem.onChecked(selectedDataItem, function (data) {
            selectedDataItem.value = data.value;
            _this.$selectedOptValue.val(_.unescape(selectedDataItem.value));
          });
          _.isFunction(_this.onChange) && !silent && _this.onChange(selectedDataItem);
        });
      } else {
        var _div = "<div class=\"selected-opt-value\"></div>";
        this.$selectedOptValue.off("blur");
        this.$selectedOptValue.replaceWith(_div);
        this.$selectedOptValue = this.$('.selected-opt-value');
        this.$selectedOptValue.html(this.selectItemToLabel(this.selectedDataItem, index));
      }
      this.$nativeSelect.prop('selectedIndex', index);
      this.selectedIndex = index;
      _.isFunction(this.onChange) && !silent && this.onChange(this.selectedDataItem);
    }
  },
  getSelectedItem: function getSelectedItem() {
    return this.selectedDataItem;
  },
  getDataItemAt: function getDataItemAt(index) {
    var array = _.isArray(this.dataProvider) ? this.dataProvider : this.dataProvider.models;
    return array[index];
  },
  _onOptionClickHandler: function _onOptionClickHandler($e) {
    var $li = $($e.currentTarget);
    if (!$li.hasClass('disabled') && !$li.is('[disabled]')) {
      var index = parseInt($li.data("index"));
      if (this.selectedIndex != index || this.repeatChange) {
        var selectedDataItem = this.getDataItemAt(index);
        this.selectItemAt(index);
      }
    }
    this.$el.removeClass('opened');
  },
  validate: function validate() {
    if (this.required && !this.selectedDataItem) {
      this.updateError(BabelStr.str(3430));
      return false;
    }
    this.clearError();
    return true;
  },
  updateError: function updateError(message) {
    this.$el.toggleClass('has-error', !!message);
  },
  clearError: function clearError() {
    this.updateError('');
  },
  setSelectedValue: function setSelectedValue(value) {
    if (value === null || value === undefined || value === '') {
      this.selectItemAt(-1, true);
      return;
    }
    var array = _.isArray(this.dataProvider) ? this.dataProvider : this.dataProvider.models;
    for (var i = 0; i < array.length; i++) {
      var item = array[i];
      var itemValue = item instanceof Backbone.Model ? item.get('value') : item.value;
      if (itemValue === value) {
        this.selectItemAt(i, true);
        return;
      }
    }
  }
});
var _default = exports["default"] = MDDropdownSelectListView;

},{"1120":1120,"1184":1184,"1412":1412,"1417":1417,"1424":1424,"1454":1454,"1463":1463,"1466":1466,"39":39,"812":812}],1120:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var toolSvg = {
  arrow_up: "<svg\n    xmlns=\"http://www.w3.org/2000/svg\"\n    width=\"1em\"\n    height=\"1em\"\n    fill=\"none\"\n    viewBox=\"0 0 24 24\"\n  >\n    <path\n      fill=\"currentColor\"\n      d=\"M21.707 17.293a1 1 0 0 1-1.414 0L12 9l-8.293 8.293a1 1 0 0 1-1.414-1.414l8.293-8.293a2 2 0 0 1 2.828 0l8.293 8.293a1 1 0 0 1 0 1.414\"\n    ></path>\n  </svg>",
  arrow_down: "<svg\n    xmlns=\"http://www.w3.org/2000/svg\"\n    width=\"1em\"\n    height=\"1em\"\n    fill=\"none\"\n    viewBox=\"0 0 24 24\"\n  >\n    <path\n      fill=\"currentColor\"\n      d=\"M21.707 6.707a1 1 0 0 0-1.414 0L12 15l-8.293-8.293a1 1 0 0 0-1.414 1.414l8.293 8.293a2 2 0 0 0 2.828 0l8.293-8.293a1 1 0 0 0 0-1.414\"\n    ></path>\n  </svg>",
  arrow_right: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"1em\" height=\"1em\" fill=\"none\" viewBox=\"0 0 24 24\">\n  <path fill=\"currentColor\" d=\"M17.293 12.707a1 1 0 0 0 0-1.414L8.707 2.293a1 1 0 0 0-1.414 1.414L15.586 12l-8.293 8.293a1 1 0 0 0 1.414 1.414l8.586-8.586a1 1 0 0 0 0-1.414\"></path>\n</svg>"
};
var _default = exports["default"] = toolSvg;

},{"1454":1454}],39:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1483);
var _MMViewBase = _interopRequireDefault(require(22));
/**
 * 通用Dropdown组件
 * Created by manjun.han
 * 2017.1.11
 */
var _default = exports["default"] = _MMViewBase["default"].extend({
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      $dropdownAnchor: null,
      /**
       * @public
       * @type {selector|HTMLElement} dropdown的锚点DOM对象
       */
      dropdownAnchor: '',
      disabled: false,
      /**
       * 下拉的列表对象
       * @type {selector|HTMLElement}
       */
      dropdownContainer: '',
      monitoredScroller: undefined,
      hideWhenWindowReize: false,
      fixed: false,
      onOpen: _.noop
    });
  },
  initialize: function initialize(options) {
    _MMViewBase["default"].prototype.initialize.call(this, options);
    this.bindSelf(this.clickOutsideHandler, this.toggleDropdown, this.closeDropDown, this._windowResizeHandler);
    this.bindDropdownToggle();
  },
  bindDropdownToggle: function bindDropdownToggle() {
    this.$dropdownAnchor = this.$(this.dropdownAnchor);
    this.$dropdownContainer = this.$(this.dropdownContainer);
    if (this.$dropdownAnchor.length == 0) {
      return;
    }
    this.$dropdownAnchor.css('position', 'relative');
    if (this.fixed) {
      this.$dropdownContainer.css('position', 'fixed');
      this.$dropdownContainer.css('width', '120px');
    } else {
      this.$dropdownContainer.css('position', 'absolute');
    }
    this.$dropdownContainer.hide();
    var eventName = 'mousedown.dropdown';
    this.$dropdownAnchor.off(eventName).on(eventName, this.toggleDropdown);
    this.setDisabled(this.disabled);
    $(document).off(this.$nsEventName('mousedown'));
    $(document).on(this.$nsEventName('mousedown'), this.clickOutsideHandler);
    if (this.hideWhenWindowReize) {
      $(window).off(this.$nsEventName('resize'));
      $(window).on(this.$nsEventName('resize'), _.debounce(this._windowResizeHandler, 200));
    }
  },
  _windowResizeHandler: function _windowResizeHandler($e) {
    if (!this.isDropdownOpen()) {
      return;
    }
    this.closeDropDown();
  },
  clickOutsideHandler: function clickOutsideHandler($e) {
    var $target = $e.target;
    if (!$.contains(this.el, $e.target)) {
      this.closeDropDown();
    }
  },
  setDisabled: function setDisabled(disabled) {
    this.disabled = disabled;
    disabled ? this.$el.addClass('disabled') : this.$el.removeClass('disabled');
  },
  isDisabled: function isDisabled() {
    return this.disabled;
  },
  toggleDropdown: function toggleDropdown($e) {
    // $e.stopPropagation();
    if (this.isDisabled()) {
      return;
    }
    this.isDropdownOpen() ? this.closeDropDown() : this.openDropDown();
  },
  closeDropDown: function closeDropDown() {
    if (this.isDropdownOpen()) {
      this.$el.removeClass('opened');
      this.$dropdownContainer.hide();
    }
    _.isFunction(this.onClose) && this.onClose();
  },
  isDropdownOpen: function isDropdownOpen() {
    return this.$el.hasClass('opened');
  },
  openDropDown: function openDropDown() {
    this.$el.addClass('opened');
    // this.$dropdownContainer.appendTo('body')
    this.$dropdownContainer.show();
    this.$dropdownContainer.position({
      my: 'left top',
      at: 'left bottom ',
      of: this.$dropdownAnchor,
      collision: 'fit'
    });
    _.isFunction(this.onOpen) && this.onOpen();
    this.el.offsetWidth;
    this.$dropdownContainer.css({
      //for ie11
      "opacity": 0.9999
    });
  },
  viewDidRendered: function viewDidRendered() {
    _MMViewBase["default"].prototype.viewDidRendered.call(this);
    this.bindDropdownToggle();
    var self = this;
    if (this.monitoredScroller) {
      if (this.isViewRendered()) {
        var $viewPort = this.$el.closest(this.monitoredScroller);
        $viewPort.on(this.$nsEventName('scroll'), _.debounce(this.closeDropDown, 100));
      }
    }
  },
  viewWillUnRendered: function viewWillUnRendered() {
    _MMViewBase["default"].prototype.viewWillUnRendered.call(this);
    $(document).off(this.$nsEventName('mousedown'));
    var $viewPort = this.$el.closest(this.monitoredScroller);
    $viewPort.off(this.$nsEventName('scroll'));
  }
});

},{"1184":1184,"1454":1454,"1483":1483,"22":22}],1483:[function(require,module,exports){
'use strict';
var $ = require(1270);
var createHTML = require(1241);
var forcedStringHTMLMethod = require(1368);

// `String.prototype.fixed` method
// https://tc39.es/ecma262/#sec-string.prototype.fixed
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('fixed') }, {
  fixed: function fixed() {
    return createHTML(this, 'tt', '', '');
  }
});

},{"1241":1241,"1270":1270,"1368":1368}],27:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1461);
require(1417);
require(1463);
var _MDSelectableListView = _interopRequireDefault(require(31));
var _keycode = _interopRequireDefault(require(104));
// MDDropDownComBox.js
// jiang
// 2017-6-7

/**
* @param props {
      parentDiv, classes, updatedCallback，text, disableEdit
  }
*
*/

var MDCombobox = function MDCombobox(props) {
  this.defaultOption();
  var keys = Object.keys(props);
  for (var i = 0; i < keys.length; i++) {
    this[keys[i]] = props[keys[i]];
  }
  this.initialize(props);
};
_.extend(MDCombobox.prototype, {
  el: '<div class="combo-box-root">' + '<span class="combo-caption middle-ellipsis"></span>' + '<span class="combo-arrow"></span>' + "</div>",
  defaultOption: function defaultOption() {
    this.disableEdit = false;
  },
  registerEvents: function registerEvents() {
    var _this = this;
    this.$el.on("mousedown", function (e) {
      _this.comboboxClicked(e);
      return false;
    });
  },
  initialize: function initialize(opt) {
    this.$el = $(this.el);
    $(this.parentDiv).append(this.$el);
    var maxlength = this.maxlength || 140;
    if (!this.disableEdit) {
      this.registerEvents();
    } else {}
    if (this.width) {
      this.$el.css("width", this.width + "px");
    }
    this._updateCaption();
  },
  _updateCaption: function _updateCaption() {
    var dispCur = this.itemStrs[this.selectIndex];
    this.$el.find(".combo-caption").text(dispCur);
  },
  setCaption: function setCaption(dispCur) {
    this.$el.find(".combo-caption").text(dispCur);
  },
  removeFromSuperView: function removeFromSuperView() {
    this.$el.off();
    this.$el.remove();
    this.updatedCallback = null;
  },
  remove: function remove() {
    this.removeFromSuperView();
  },
  close: function close() {
    this.remove();
  },
  setSelectIndex: function setSelectIndex(selectIndex) {
    this.selectIndex = selectIndex;
    if (this.selectList) {
      this.selectList.setSelectIndex(selectIndex);
    } else {
      this._updateCaption();
    }
  },
  comboboxClicked: function comboboxClicked(e) {
    if (this.comboboxClickCb) {
      this.comboboxClickCb();
    }
    var width = this.popUpWidth ? this.popUpWidth : 110;
    var self = this;
    if (this.disableEdit) {
      return;
    }
    if (this.selectList) {
      this.selectList.close();
      this.selectList = null;
    } else {
      this.selectList = new _MDSelectableListView["default"]({
        selectIndex: this.selectIndex,
        itemStrs: this.itemStrs,
        triggerView: this.$el[0],
        center: true,
        width: width,
        loadSlot: this.loadSlot,
        useNormalFont: this.useNormalFont,
        outsideArea: this.outsideArea,
        onClose: function onClose() {
          if (self.selectList) {
            var selectIndex = self.selectList.selectIndex;
            if (selectIndex != self.selectIndex) {
              self.selectIndex = selectIndex;
              self._updateCaption();
              self.selectCb(selectIndex);
            }
          }
          self.selectList = null;
        }
      });
      this.selectList.show();
    }
  },
  setItemStrs: function setItemStrs(itemStrs) {
    this.itemStrs = itemStrs;
    if (this.selectList) {
      this.selectList.setItemStrs(itemStrs);
    }
  },
  setReadOnly: function setReadOnly() {
    this.disableEdit = true;
  }
});
var _default = exports["default"] = MDCombobox;

},{"104":104,"1184":1184,"1417":1417,"1454":1454,"1461":1461,"1463":1463,"31":31}],31:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMBasicData = _interopRequireDefault(require(811));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDEvents = _interopRequireDefault(require(325));
var _MDPopupView = _interopRequireDefault(require(64));
/**
 *  Menu for zoom choices
 *  Create by jiang
 *  2017.7.12
 */

var MDSelectableListView = _MDPopupView["default"].extend({
  contentTmpl: '<ul class="m-menu select-list small-font">' + '</ul>',
  events: function events() {
    var superEvents = _MDPopupView["default"].prototype.events.call(this);
    return _.extend({}, superEvents, {
      'click li': this._menuItemClickHandler
    });
  },
  initProps: function initProps() {
    var superP = _MDPopupView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      gapY: 0
    });
  },
  initialize: function initialize(opt) {
    _MDPopupView["default"].prototype.initialize.call(this, opt);
    this.setItemStrs(this.itemStrs);
    _.isFunction(this.loadSlot) && this.renderSlot(this.loadSlot);
    this._dispSelectMark();
    var z_startIndex = _MMBasicData["default"].getO2OMaxLayerZ_index() + 2;
    this.$el.css('z-index', z_startIndex);
    if (this.useNormalFont) {
      this.$('.select-list').removeClass('small-font');
    }
  },
  setItemStrs: function setItemStrs(itemStrs) {
    this.itemStrs = itemStrs;
    this.$('.select-list').empty();
    var str = '';
    for (var i = 0; i < this.itemStrs.length; i++) {
      var itemStr = this.itemStrs[i];
      str += '<li><span class="icon slt-li"></span>' + itemStr + '</li>';
    }
    ;
    this.$('.select-list').html(str);
  },
  renderSlot: function renderSlot(success) {
    var $slot = $("<div class='slot-block'></div>");
    this.$('.select-list').append($slot);
    success($slot);
  },
  setSelectIndex: function setSelectIndex(selectIndex) {
    this.selectIndex = selectIndex;
  },
  _menuItemClickHandler: function _menuItemClickHandler($e) {
    var index = $($e.target).index();
    this.selectIndex = index;
    this._dispSelectMark();
    if (this.selectCb) {
      this.selectCb(index);
    }
    ;
    this.close();
  },
  _dispSelectMark: function _dispSelectMark() {
    var i = this.selectIndex;
    this.$('li span').removeClass('slt-li');
    $(this.$('li span')[i]).addClass('slt-li');
  }
}, {
  IconSizeOption: 0
});
var _default = exports["default"] = MDSelectableListView;

},{"1184":1184,"1454":1454,"18":18,"325":325,"64":64,"811":811}],905:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var MDEditorOption = {
  showCommentOn: true,
  setShowCommentOn: function setShowCommentOn(on) {
    this.showCommentOn = on;
  },
  restorehDefault: function restorehDefault() {
    this.showCommentOn = true;
  }
};
var _default = exports["default"] = MDEditorOption;

},{"1454":1454}],887:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1437);
require(1463);
require(1478);
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDNetDriveFileHandler = _interopRequireDefault(require(1091));
var _MMNetDiskDiscussionBoard = _interopRequireDefault(require(1086));
var _OBJ_ID = _interopRequireDefault(require(818));
var _MMRect = _interopRequireDefault(require(831));
/**
* javascript/molasync-source/ui/controller/MDPenZoneMarkController.js
* jiang
* 2018-10-5
*/

var MDPenZoneMarkController = function MDPenZoneMarkController() {
  this.userMarkLgRects = [];
  this.$marks = [];
  this.markW = 26;
  this.markH = 34;
  this.init();
};
MDPenZoneMarkController.prototype = _.extend(MDPenZoneMarkController.prototype, {
  init: function init() {
    Dispatcher.on('editPenScribblesFromServer', this.onScribbleChangedByOthers, this);
  },
  setEditorViewCtl: function setEditorViewCtl(ctl) {
    this.editorViewCtl = ctl;
    this.clearOldData();
  },
  refreshData: function refreshData() {
    var editViewCtl = this.editorViewCtl;
    // var editor = editViewCtl.getCurEditor();
    var board = editViewCtl.getCurrentBoard();
    var curDispVer = editViewCtl.getVersionShowing();
    var userScribbleGroups = board.getScribbleGroupByCreator(curDispVer);
    this.userMarkLgRects = [];
    for (var i = 0; i < userScribbleGroups.length; i++) {
      var element = userScribbleGroups[i];
      var userId = element.userId;
      var sections = element.sections;
      var rects = [];
      for (var k = 0; k < sections.length; k++) {
        var scribbles = sections[k];
        var rect = null;
        for (var l = 0; l < scribbles.length; l++) {
          var scribble = scribbles[l];
          var objRect = scribble.getRect();
          var pgIndex = scribble.getPageIndex();
          if (!rect) {
            rect = objRect;
          } else {
            rect.expandToInclude(objRect);
          }
          if (!rect.pageIndex) {
            rect.pageIndex = pgIndex;
          }
        }
        rects.push(rect);
      }
      this.userMarkLgRects.push({
        userId: userId,
        rects: rects,
        sections: sections
      });
    }
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setBabelTimeout(function () {
      board.sendScribbles2Server(curDispVer, function () {
        // MDSnackbarView.show('保存成功')
      }, function () {
        _MDSnackbarView["default"].show(BabelStr.str(7367));
      });
    }, 60000); // 一分钟

    this.refreshDisp();
    var fileInfo = editViewCtl.getCurrentFileInfo();
    Dispatcher.trigger(MDEvents.refreshPenList, {
      fileId: fileInfo.getFileId(),
      version: curDispVer,
      pens: this.userMarkLgRects
    });
  },
  showHideScribbles: function showHideScribbles(userId, index, showHide) {
    var self = this;
    var showHideFun = function showHideFun(userSec, secIndex) {
      var scribbles = userSec.sections[secIndex];
      var lgRect;
      for (var k = 0; k < scribbles.length; k++) {
        var scribble = scribbles[k];
        if (showHide == "hide") {
          scribble.hide = true;
        } else {
          scribble.hide = false;
        }
        if (!lgRect) {
          lgRect = scribble.getExpandRect();
        } else {
          lgRect.expandToInclude(scribble.getExpandRect());
        }
      }
      return lgRect;
    };
    for (var i = 0; i < this.userMarkLgRects.length; i++) {
      var userSec = this.userMarkLgRects[i];
      if (userSec.userId == userId) {
        var refreshRect;
        if (index != -1) {
          refreshRect = showHideFun(userSec, index);
        } else {
          for (var k = 0; k < userSec.sections.length; k++) {
            if (k == 0) {
              refreshRect = showHideFun(userSec, k);
            } else {
              refreshRect.expandToInclude(showHideFun(userSec, k));
            }
          }
        }
        var editViewCtl = this.editorViewCtl;
        var editor = editViewCtl.getCurEditor();
        editor.refreshObjsInEditor(refreshRect);
        break;
      }
    }
  },
  removeSections: function removeSections(userId, index, success, fail) {
    var self = this;
    var editViewCtl = this.editorViewCtl;
    var fileInfo = editViewCtl.getCurrentFileInfo();
    var collectSribbles = function collectSribbles(theIndex) {
      var scribbles = [];
      for (var i = 0; i < self.userMarkLgRects.length; i++) {
        var userSec = self.userMarkLgRects[i];
        if (userSec.userId == userId) {
          if (theIndex != -1) {
            scribbles = scribbles.concat(userSec.sections[theIndex]);
          } else {
            for (var k = 0; k < userSec.sections.length; k++) {
              var secSribbles = userSec.sections[k];
              scribbles = scribbles.concat(secSribbles);
            }
          }
          break;
        }
      }
      return scribbles;
    };
    if (fileInfo.canDelMyComment()) {
      var scribbles = collectSribbles(index);
      if (scribbles.length > 0) {
        var ids = [];
        var strIds = [];
        var lgRect;
        for (var i = 0; i < scribbles.length; i++) {
          var s = scribbles[i];
          ids.push(s.getId());
          strIds.push(s.getId().toString());
          if (!lgRect) {
            lgRect = s.getExpandRect();
          } else {
            lgRect.expandToInclude(s.getExpandRect());
          }
        }
        _MDNetDriveFileHandler["default"].deleteBoardDataById(fileInfo.getFileId(), strIds, function () {
          var editViewCtl = self.editorViewCtl;
          var editor = editViewCtl.getCurEditor();
          var board = editViewCtl.getCurrentBoard();
          board.removeObjects(ids);
          editor.refreshObjsInEditor(lgRect);
          self.refreshData();
          success && success();
        }, function (e, msg) {
          if (msg) {
            _MDSnackbarView["default"].show(msg);
          } else {
            _MDSnackbarView["default"].show(BabelStr.str(168));
          }
        });
      }
    } else {
      _MDSnackbarView["default"].show(BabelStr.str(7368));
    }
  },
  refreshDisp: function refreshDisp() {
    var editViewCtl = this.editorViewCtl;
    var editor = editViewCtl.getCurEditor();
    if (!editor || !editor.getCommentLayer) {
      return;
    }
    var layer = editor.getCommentLayer();
    var trsfm = editor.getDivTransformer();
    var w = this.markW;
    var h = this.markH;
    for (var i = 0; i < this.$marks.length; i++) {
      var $mark = this.$marks[i];
      $mark.remove();
    }
    this.$marks = [];
    for (var _i = 0; _i < this.userMarkLgRects.length; _i++) {
      var element = this.userMarkLgRects[_i];
      var iconIndex = _i % 6 + 1;
      var rects = element.rects;
      var userId = element.userId;
      for (var k = 0; k < rects.length; k++) {
        var rect = rects[k];
        var c = rect.getCenter();
        var pos = trsfm.lg2dvPoint(c, rect.pageIndex);
        var dvRect = trsfm.lg2dvRect(rect, rect.pageIndex);
        var _$mark = $('<div style="position:absolute;" class="pen-location"> </div>');
        $(layer).append(_$mark);
        this.$marks.push(_$mark);
        var markDvRect = new _MMRect["default"]();
        markDvRect.setRct(pos.x - w / 2, pos.y - h, w, h);
        var markLgRect = trsfm.dv2lgRect(markDvRect, rect.pageIndex);
        _$mark.css("width", w + 'px');
        _$mark.css("height", h + 'px');
        _$mark.css("left", markDvRect.left + 'px');
        _$mark.css("top", markDvRect.top + 'px');
        _$mark.css("background-image", "url(img/mdisk/location" + iconIndex + ".svg)");
        _$mark.css("background-size", w + "px " + h + "px");
        _$mark.penZoneMarkInfo = {
          userId: userId,
          index: k,
          markLgRect: markLgRect
        };
        var scribble = element.sections[k][0];
        var dvOriginW = scribble.getOriginLineDvWidth();
        var lgW = scribble.getOriginLineWidth();
        var dvW = trsfm.lg2dvLen(lgW);
        if (dvW / dvOriginW < 0.2) {
          // 过于小的时候显示定位标记
          _$mark.css('display', 'block');
          _$mark.penZoneMarkInfo.visible = true;
        } else {
          _$mark.css('display', 'none');
          _$mark.penZoneMarkInfo.visible = false;
        }
      }
    }
  },
  getHoveredMarks: function getHoveredMarks(lgPoint) {
    var marksInfo = [];
    for (var i = 0; i < this.$marks.length; i++) {
      var penZoneMarkInfo = this.$marks[i].penZoneMarkInfo;
      if (penZoneMarkInfo.visible && penZoneMarkInfo.markLgRect.include(lgPoint)) {
        marksInfo.push(penZoneMarkInfo);
      }
    }
    return marksInfo;
  },
  onScribbleChangedByOthers: function onScribbleChangedByOthers(msg) {
    var self = this;
    var editViewCtl = this.editorViewCtl;
    var editor = editViewCtl.getCurEditor();
    var board = editViewCtl.getCurrentBoard();
    var fileInfo = editViewCtl.getCurrentFileInfo();
    var fileId = msg.fileId;
    if (fileId == fileInfo.getFileId()) {
      var lgRect;
      if (msg.msgType == 57) {
        var datas = msg.datas;
        for (var i = 0; i < datas.length; i++) {
          var data = datas[i];
          var scribble = _MMNetDiskDiscussionBoard["default"].createObjectFromData(board, data);
          var option = {
            toUndo: false,
            realtime: false,
            isMark_: false
          };
          board.m_actionManager.addObject(scribble, option);
          if (!lgRect) {
            lgRect = scribble.getExpandRect();
          } else {
            lgRect.expandToInclude(scribble.getExpandRect());
          }
        }
      } else if (msg.msgType == 58) {
        var dataIds = msg.dataIds;
        var ids = [];
        for (var _i2 = 0; _i2 < dataIds.length; _i2++) {
          var strId = dataIds[_i2];
          var id = new _OBJ_ID["default"]();
          id.fromString(strId);
          ids.push(id);
        }
        if (ids.length) {
          var objs = board.removeObjects(ids);
          for (var _i3 = 0; _i3 < objs.length; _i3++) {
            var obj = objs[_i3];
            if (!obj) {
              continue;
            }
            if (!lgRect) {
              lgRect = obj.getExpandRect();
            } else {
              lgRect.expandToInclude(obj.getExpandRect());
            }
          }
        }
      }
      if (lgRect) {
        editor.refreshObjsInEditor(lgRect);
        this.refreshData();
      }
    }
  },
  focusUserSection: function focusUserSection(userId, index) {
    var rects;
    var userSec;
    for (var i = 0; i < this.userMarkLgRects.length; i++) {
      userSec = this.userMarkLgRects[i];
      if (userId == userSec.userId) {
        rects = userSec.rects;
        break;
      }
    }
    if (rects && index >= 0 && index < rects.length) {
      var rect = rects[index];
      var scribble = userSec.sections[index][0];
      var editViewCtl = this.editorViewCtl;
      var editor = editViewCtl.getCurEditor();
      var check2zoomFun = function check2zoomFun(view, callback) {
        var trsfm = view.getDivTransformer(); // 此处必须使用 view，不能使用 editor
        var lgW = scribble.getOriginLineWidth();
        var trgetW = scribble.getOriginLineDvWidth();
        var dvW = trsfm.lg2dvLen(lgW);
        var deltaZoom = trgetW / dvW;
        var scale = view.getZoomScale();
        scale *= deltaZoom;
        editor.changeScale(scale, function () {
          // 此处必须使用 editor ，不能使用 view
          callback();
          Dispatcher.trigger(MDEvents.ZOOM_CHANGED);
        });
      };
      var zoomCollectionViewSale2ShowScribble = function zoomCollectionViewSale2ShowScribble(view) {
        check2zoomFun(view, function () {
          editor.scrollToShowPosAfterRender(view, rect.getCenter(), function () {
            view.showFocusRect(rect);
          });
        });
      };
      if (editor.getClassName() == "MMPDFCollectionView") {
        var pgIndex = scribble.getPageIndex();
        var curPg = editor.getCurPdfPage();
        if (pgIndex != curPg) {
          editor.scrollToPage(pgIndex, false, function () {
            var curView = editor.getCurPdfPageView();
            zoomCollectionViewSale2ShowScribble(curView);
          });
        } else {
          var curView = editor.getCurPdfPageView();
          zoomCollectionViewSale2ShowScribble(curView);
        }
      } else {
        check2zoomFun(editor, function () {
          editor.scrollToShowLgRct(rect, function () {
            editor.showFocusRect(rect);
          });
        });
      }
    }
  },
  clearOldData: function clearOldData() {
    this.userMarkLgRects = [];
    for (var i = 0; i < this.$marks.length; i++) {
      var $mark = this.$marks[i];
      $mark.remove();
    }
    this.marks = [];
  },
  clearAll: function clearAll() {
    this.clearOldData();
    Dispatcher.off(null, null, this);
  }
});
var _default = exports["default"] = MDPenZoneMarkController;

},{"1086":1086,"1091":1091,"1184":1184,"1412":1412,"1437":1437,"1454":1454,"1463":1463,"1478":1478,"72":72,"807":807,"818":818,"831":831}],1086:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1466);
require(1418);
require(1463);
require(1537);
require(1541);
require(1437);
require(1478);
require(1426);
var _MMTaskBoard = _interopRequireDefault(require(959));
var _MMRoundArray = _interopRequireDefault(require(958));
var _int = _interopRequireDefault(require(820));
var _ObjType = _interopRequireDefault(require(1084));
var _CommentStatus = _interopRequireDefault(require(1036));
var _BoardType = _interopRequireDefault(require(947));
var _MDNetDriveFileHandler = _interopRequireDefault(require(1091));
var _MMScribble = _interopRequireDefault(require(1028));
var _Decoder = _interopRequireDefault(require(799));
var _Encoder = _interopRequireDefault(require(800));
var _MMWeldMark = _interopRequireDefault(require(1034));
var _pdf_link_service = require(1141);
var _pdf_find_controller = require(1139);
var _app_options = require(1136);
var _event_utils = require(1138);
var _MMSignatureFrame = _interopRequireDefault(require(1030));
var _MDSignatureData = _interopRequireDefault(require(286));
var _BoardOrientation = _interopRequireDefault(require(802));
var _MMSealFrame = _interopRequireDefault(require(886));
var _MDSealData = _interopRequireDefault(require(283));
var _MDMolaUser = _interopRequireDefault(require(272));
var _MMUserDataController = _interopRequireDefault(require(1108));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDEvents = _interopRequireDefault(require(325));
/**
 *
 * molasync-source/whiteboard/netdisk/MMNetDiskDiscussionBoard.js
 */

function MMNetDiskDiscussionBoard(fileId, ownerId) {
  var boardInfo = {};
  boardInfo.m_id = new _int["default"](parseInt(fileId));
  boardInfo.m_creator = new _int["default"](parseInt(ownerId));
  _MMTaskBoard["default"].call(this, boardInfo);
  this.latestVer = -1;
  this.curVersion = -1;
  this.versionShowing = -1;
  this.displayName = "";
  this.m_type = _BoardType["default"].enumNetDiskBoard;
}
MMNetDiskDiscussionBoard.prototype = new _MMTaskBoard["default"]();
MMNetDiskDiscussionBoard.superclass = _MMTaskBoard["default"].prototype;
MMNetDiskDiscussionBoard.prototype.decode = function (dc_, ver_) {
  MMNetDiskDiscussionBoard.superclass.decode.call(this, dc_, ver_);
  var latestVer = dc_.decodeFrom4Bytes(ver_);
  var curVersion = dc_.decodeFrom4Bytes(ver_);
};

/******************************************************************
                          version
*******************************************************************/

//
//  get the img  or pdfPage objects
// @param ver_ {integer} - file version  default:0
//
MMNetDiskDiscussionBoard.prototype.getImgPdfObjectsForVersion = function (ver_) {
  if (ver_ === undefined || ver_ === null) {
    ver_ = this.versionShowing;
  }
  if (typeof ver_ != "number") {
    ver_ = parseInt(ver_);
  }
  var objs = [];
  var allObjs = this.getAllObjs();
  allObjs.forEach(function (obj) {
    if ((obj.getObjType() == _ObjType["default"].Obj_Image || obj.getObjType() == _ObjType["default"].Obj_PDF) && obj.getFileVersion() == ver_) objs.push(obj);
  });
  return objs;
};
MMNetDiskDiscussionBoard.prototype.getDisplayingPdf = function (ver_) {
  var ver = ver_ || this.versionShowing;
  if (ver < 0) {
    ver = 0;
  }
  var objs = [];
  var allObjs = this.getAllObjs();
  allObjs.forEach(function (obj) {
    if (obj.getObjType() == _ObjType["default"].Obj_PDF && obj.getFileVersion() == ver) objs.push(obj);
  });
  return objs;
};
MMNetDiskDiscussionBoard.prototype._loadPages = function (imgPdfObjs, callback) {
  var pagesCount = imgPdfObjs.length;
  var pagesInfo = [];
  var i = 0;
  var pdf = null;
  function loadPages(index) {
    if (index >= imgPdfObjs.length) {
      // 已经获得所有 page info
      callback(pdf, pagesInfo);
      return;
    }
    var pdfObj = imgPdfObjs[index];
    pdfObj.getPdfPage(function (page) {
      var viewport = page.getViewport(1.0);
      var pageSizeInfo = {
        width: viewport.width,
        height: viewport.height,
        rotation: viewport.rotation
      };
      pagesInfo.push(pageSizeInfo);
      if (pdf == null) {
        pdf = pdfObj.getPdfDoc();
      }
      loadPages(++index);
    });
  }
  loadPages(0);
}, MMNetDiskDiscussionBoard.prototype.registerFindController = function (ver_, editor) {
  var _this = this;
  var self = this;
  // if (!this.isDispPdf()) {
  //   this.pdfLinkService = null;
  //   this.findController = null;
  //   return;
  // };

  if (this.fileInfo && this.fileInfo.isCADFile()) {
    return;
  }

  // this.pdfLinkService = new PDFLinkService({
  //   openPdfLink: (obj)=>{
  //     this.scrollToShowPdfLink(obj)
  //   }
  // });
  var eventBus = new _event_utils.EventBus();
  this.eventBus = eventBus;
  var pdfLinkService = new _pdf_link_service.PDFLinkService({
    eventBus: eventBus,
    externalLinkTarget: _app_options.AppOptions.get("externalLinkTarget"),
    externalLinkRel: _app_options.AppOptions.get("externalLinkRel"),
    ignoreDestinationZoom: _app_options.AppOptions.get("ignoreDestinationZoom"),
    openPdfLink: function openPdfLink(obj) {
      editor.scrollToShowPdfLink(obj);
    }
  });
  this.pdfLinkService = pdfLinkService;
  var findController = new _pdf_find_controller.PDFFindController({
    linkService: pdfLinkService,
    eventBus: eventBus,
    updateMatchesCountOnProgress: true
  });
  this.findController = findController;

  // this.findController = new PDFFindController({
  //   linkService: this.pdfLinkService,
  // });

  setTimeout(function () {
    var imgPdfObjs = _this.getDisplayingPdf(ver_);
    _this._loadPages(imgPdfObjs, function (pdf, pagesInfo) {
      self.pdfLinkService.setDocument(pdf);
      self.findController.setDocument(pdf);
    });
  }, 800);
};
MMNetDiskDiscussionBoard.prototype.clearPdfPage = function () {
  var objs = [];
  var allObjs = this.getAllObjs();
  allObjs.forEach(function (obj) {
    if (obj.getObjType() == _ObjType["default"].Obj_PDF) obj.clearPdfPage();
  });
};
MMNetDiskDiscussionBoard.prototype.setLatestVersion = function (ver_) {
  this.latestVer = ver_;
};
MMNetDiskDiscussionBoard.prototype.getLatestVersion = function () {
  return this.latestVer;
};
MMNetDiskDiscussionBoard.prototype.setCurVersion = function (ver_) {
  this.curVersion = ver_;
};
MMNetDiskDiscussionBoard.prototype.getCurVersion = function () {
  return this.curVersion;
};

// MMNetDiskDiscussionBoard.prototype.setVersionShowing = function(ver_) {
//   this.versionShowing = ver_;
// };

// MMNetDiskDiscussionBoard.prototype.getVersionShowing = function() {
//   if (this.versionShowing == undefined) {
//     return this.curVersion;
//   };
//   return this.versionShowing;
// };

//
// delete all objects for the version
//
MMNetDiskDiscussionBoard.prototype.delObjedsForVersion = function (ver_) {
  this.m_objManager.delObjedsForVersion(ver_);
};
MMNetDiskDiscussionBoard.prototype.getCommentsForVersion = function (ver_) {
  if (ver_ == undefined || ver_ == null) {
    ver_ = this.getVersionShowing();
  }
  var comments = [];
  var allObjs = this.getAllObjs();
  allObjs.forEach(function (obj) {
    if (obj.isComment() && obj.getFileVersion() == ver_) comments.push(obj);
  });
  return comments;
};
MMNetDiskDiscussionBoard.prototype.getVisibleCommentsForVersion = function (ver_) {
  if (ver_ == undefined || ver_ == null) {
    ver_ = this.getVersionShowing();
  }
  var comments = [];
  var allObjs = this.getAllObjs();
  allObjs.forEach(function (obj) {
    if (obj.isComment() && obj.getFileVersion() == ver_) {
      var commentCreatorId = obj.getCreator().toString();
      if (obj.getVisibleScope() != 2 || obj.getVisibleScope() == 2 && app.currentUser.getUserId() == commentCreatorId) {
        comments.push(obj);
      }
    }
  });
  return comments;
};
MMNetDiskDiscussionBoard.prototype.getPublicCommentsForVersion = function (ver_) {
  if (ver_ == undefined || ver_ == null) {
    ver_ = this.getVersionShowing();
  }
  var comments = [];
  var allObjs = this.getAllObjs();
  allObjs.forEach(function (obj) {
    if (obj.isComment() && obj.getFileVersion() == ver_ && !obj.getVisibleScope()) comments.push(obj);
  });
  return comments;
};
MMNetDiskDiscussionBoard.prototype.getAllCommentsForVersion = function (ver_) {
  if (ver_ == undefined || ver_ == null) {
    ver_ = this.getVersionShowing();
  }
  var comments = [];
  var allObjs = this.getAllObjs();
  allObjs.forEach(function (obj) {
    if ((obj.isComment() || obj.getObjType() == _ObjType["default"].Obj_textComment || obj.getObjType() == _ObjType["default"].Obj_niceTag) && obj.getFileVersion() == ver_) comments.push(obj);
  });
  return comments;
};
MMNetDiskDiscussionBoard.prototype.setDisplayName = function (name) {
  this.displayName = name;
};
MMNetDiskDiscussionBoard.prototype.getDisplayName = function (name) {
  return this.displayName;
};
MMNetDiskDiscussionBoard.prototype.setFileInfo = function (fileInfo) {
  this.fileInfo = fileInfo;
};
MMNetDiskDiscussionBoard.prototype.getFileInfo = function () {
  return this.fileInfo;
};
MMNetDiskDiscussionBoard.prototype.getPageCountByVersion = function (ver) {
  if (ver == undefined) {
    ver = this.versionShowing;
  }
  if (ver >= 0) {
    var objs = this.getImgPdfObjectsForVersion(ver);
    var pgCount = 0;
    for (var i = 0; i < objs.length; i++) {
      var pgIndex = objs[i].getPageIndex() + 1;
      if (pgIndex > pgCount) {
        pgCount = pgIndex;
      }
    }
    return pgCount;
  } else {
    return this.getPageCount();
  }
};
MMNetDiskDiscussionBoard.prototype.getCommentsInPageForVersion = function (pgIndex, ver) {
  var comments = new Array();
  var objsInPage = this.getObjsInPage(pgIndex);
  for (var i = 0; i < objsInPage.length; i++) {
    if (objsInPage[i].m_objType == _ObjType["default"].Obj_comment) {
      if (ver != undefined && objsInPage[i].getFileVersion() == ver || ver == undefined) {
        comments.push(objsInPage[i]);
      }
    }
  }
  return comments;
};
MMNetDiskDiscussionBoard.prototype.getCurrentUserUnreadComments = function () {
  var comments = new Array();
  var usrId = app.currentUser.getUserId_Int();
  for (var i = 0; i < this.m_orderedObjIds.length; i++) {
    var object = this.m_objManager.getObject(this.m_orderedObjIds[i]);
    if (object.isComment() && object.getFileVersion() == this.versionShowing) {
      var status = object.getReadStatus(usrId);
      if (status != _CommentStatus["default"].Comment_read) {
        comments.push(object);
      }
    }
  }
  return comments;
};
MMNetDiskDiscussionBoard.prototype.getCurrentUserAllUnreadComments = function () {
  var comments = new Array();
  var usrId = app.currentUser.getUserId_Int();
  for (var i = 0; i < this.m_orderedObjIds.length; i++) {
    var object = this.m_objManager.getObject(this.m_orderedObjIds[i]);
    if ((object.isComment() || object.m_objType == _ObjType["default"].Obj_textComment) && object.getFileVersion() == this.versionShowing) {
      var status = object.getReadStatus(usrId);
      if (status != _CommentStatus["default"].Comment_read) {
        comments.push(object);
      }
    }
  }
  return comments;
};
MMNetDiskDiscussionBoard.prototype.getFileThumbnailInfo = function (size) {
  var imgObj = null;
  var versionShowing = this.curVersion;
  if (this.fileInfo.isDeleteVersion()) {
    versionShowing = this.fileInfo.getDeleteVersion();
  }
  if (versionShowing == undefined) {
    versionShowing = this.curVersion;
  }
  for (var i = 0; i < this.m_orderedObjIds.length; i++) {
    var object = this.m_objManager.getObject(this.m_orderedObjIds[i]);
    if (object.getPageIndex() == 0 && object.getFileVersion() == versionShowing && (object.m_objType == _ObjType["default"].Obj_Image || object.m_objType == _ObjType["default"].Obj_PDF)) {
      imgObj = object;
      break;
    }
  }
  var urlInfo;
  if (this.fileInfo && this.fileInfo.getFileName) {
    if (imgObj) {
      urlInfo = {};
      urlInfo.url = imgObj.getThumbnailUrl(true, size);
      urlInfo.imgSize = imgObj.getOriginSize();
      urlInfo.fileName = this.fileInfo.getFileName();
    } else {
      urlInfo = {};
      urlInfo.url = "*";
      urlInfo.fileName = this.fileInfo.getFileName();
    }
  }
  return urlInfo;
};
MMNetDiskDiscussionBoard.prototype.getPicObjDisplaying = function (pgIndex, ver) {
  var comments = new Array();
  var objsInPage = this.getObjsInPage(pgIndex);
  for (var i = 0; i < objsInPage.length; i++) {
    if (objsInPage[i].m_objType == _ObjType["default"].Obj_Image || objsInPage[i].m_objType == _ObjType["default"].Obj_PDF) {
      if (ver != undefined && objsInPage[i].getFileVersion() == ver) {
        return objsInPage[i];
      }
    }
  }
  return null;
};
MMNetDiskDiscussionBoard.prototype.isCADFile = function () {
  if (this.isOperateOnPDFFile()) {
    var name = this.getDisplayName();
    var ext = name.split(".").pop();
    ext = ext.toLowerCase();
    if (ext == "dxf" || ext == "dwg" || ext == "dwt") {
      return true;
    }
  }
  return false;
};
MMNetDiskDiscussionBoard.prototype.canDispWithSVG = function () {
  var name = this.getDisplayName();
  var ext = name.split(".").pop();
  ext = ext.toLowerCase();
  if (ext == "svg" && this.getFileInfo().canDownload()) {
    return true;
  }
  return false;
};
MMNetDiskDiscussionBoard.prototype.canChangeBackground = function () {
  var name = this.getDisplayName();
  var ext = name.split(".").pop();
  ext = ext.toLowerCase();
  if (ext == "png" || ext == "svg") {
    return true;
  }
  return false;
};
MMNetDiskDiscussionBoard.prototype.commentCompleted = function (comment, completed) {
  this.m_actionManager.commentCompleted(comment, completed);
};
MMNetDiskDiscussionBoard.prototype.commentReaded = function (comment) {
  this.m_actionManager.commentReaded(comment);
};
MMNetDiskDiscussionBoard.prototype.deleteComment = function (comment, success, fail) {
  this.m_actionManager.deleteObject(comment, {
    toUndo: true,
    realtime: true,
    onSuccess: success,
    onFail: fail
  });
};
MMNetDiskDiscussionBoard.prototype.deleteCommentById = function (commentId, success, fail) {
  this.m_actionManager.deleteObject(commentId, {
    toUndo: false,
    realtime: true,
    onSuccess: success,
    onFail: fail
  });
};
MMNetDiskDiscussionBoard.prototype.clearActionStacks = function () {
  this.m_actionManager.clearActionStacks();
};
MMNetDiskDiscussionBoard.prototype.sendMessage = function (jsonMsg, commentId, param, cb) {
  return this.m_actionManager.sendMessage(jsonMsg, commentId, param, cb);
};
MMNetDiskDiscussionBoard.prototype.addObject = function (newObj, toUndo, realtime, isMark_, callback_) {
  return this.m_actionManager.sendMessage(newObj, toUndo, realtime, isMark_, callback_);
};
MMNetDiskDiscussionBoard.prototype.notify = function (action_) {
  this.m_actionManager.notify(action_);
};
MMNetDiskDiscussionBoard.prototype.sendScribbles2Server = function (version, success, fail) {
  var data = [];
  var needSave = [];
  if (version == undefined || version == null || version == -1) {
    version = this.getCurVersion();
  }
  var scribbles = this.getAllObjs(_ObjType["default"].GObj_scribble);
  for (var i = 0; i < scribbles.length; i++) {
    if (!scribbles[i].isSaved && scribbles[i].getCreator() == app.currentUser.getId()) {
      data.push(scribbles[i].createScribbleData());
      needSave.push(scribbles[i]);
    }
  }
  if (data.length > 0) {
    var fileId = this.getFileInfo().getFileId();
    _MDNetDriveFileHandler["default"].sendBoardDatas(fileId, version, data, function () {
      for (var _i = 0; _i < needSave.length; _i++) {
        var s = needSave[_i];
        s.isSaved = true;
      }
      success && success();
    }, function () {
      fail && fail();
    });
  } else {
    success && success();
  }
};
MMNetDiskDiscussionBoard.prototype.getScribblesFromSever = function (ver_, board, success, fail) {
  var allObjs = board.getAllObjs();
  var delIds = [];
  _.each(allObjs, function (obj) {
    if (obj.m_className == "MMSignatureFrame") {
      delIds.push(obj.getId());
    }
  });
  board.removeObjects(delIds);
  var fileId = this.getFileInfo().getFileId();
  var version = this.getCurVersion();
  if (ver_ != undefined && ver_ != null && ver_ != -1) {
    version = ver_;
  }
  var self = this;
  _MDNetDriveFileHandler["default"].getScribblesInFile(fileId, version, function (data) {
    var objs = data;
    self.removeScribblesForVersion(version);
    try {
      for (var i = 0; i < objs.length; i++) {
        var obj = objs[i];
        var scribble = MMNetDiskDiscussionBoard.createObjectFromData(self, obj);
        var option = {
          toUndo: false,
          realtime: false,
          isMark_: false
        };
        self.m_actionManager.addObject(scribble, option);
      }
    } catch (e) {
      console.error("------------>" + e);
    }
    _MDNetDriveFileHandler["default"].getFileSeals(fileId, version, function (sigInfos) {
      for (var _i2 = 0; _i2 < sigInfos.length; _i2++) {
        var sigInfo = sigInfos[_i2];
        var pgIndex = sigInfo.pageIndex;
        MMNetDiskDiscussionBoard.createSigFrameFromData(self, sigInfo, fileId, function (sigFrame) {
          var option = {
            toUndo: false,
            realtime: false,
            isMark_: false
          };
          self.m_actionManager.addObject(sigFrame, option);
        });
      }
      _Dispatcher["default"].trigger(_MDEvents["default"].fileSealChanged, {
        fileId: fileId,
        version: version
      });
    }, function () {
      fail();
    });
    success();
  }, function () {
    console.error("------------------- sucess read failed");
    fail();
  });
};
MMNetDiskDiscussionBoard.prototype.updateSignatures = function (fileId, version, callback) {
  var _this2 = this;
  _MDNetDriveFileHandler["default"].getFileSeals(fileId, version, function (sigInfos) {
    var oldSigFrames = _this2.getAllSigFramesForVersion(version);
    for (var i = 0; i < sigInfos.length; i++) {
      var sigInfo = sigInfos[i];
      // MMNetDiskDiscussionBoard.createSigFrameFromData(
      //   this,
      //   sigInfo,
      //   fileId,
      //   sigFrame=>{
      var sigNeedUpdate = null;
      for (var k = 0; k < oldSigFrames.length; k++) {
        var oldFrame = oldSigFrames[k];
        if (oldFrame.getSealedId() == sigInfo.id) {
          sigNeedUpdate = oldFrame;
          break;
        }
      }
      if (sigNeedUpdate) {
        sigNeedUpdate.setDefaultRect2Save(sigInfo.rect);
        sigNeedUpdate.setAngle(sigInfo.angle);
      } else {
        MMNetDiskDiscussionBoard.createSigFrameFromData(_this2, sigInfo, fileId, function (sigFrame) {
          var option = {
            toUndo: false,
            realtime: false,
            isMark_: false
          };
          _this2.m_actionManager.addObject(sigFrame, option);
        });
      }
    }
    var oldSealedIds = _.map(oldSigFrames, function (oldFrame) {
      return oldFrame.getSealedId();
    });
    var newSealedIds = _.map(sigInfos, function (sigInfo) {
      return sigInfo.id;
    });
    var delIds = _.difference(oldSealedIds, newSealedIds);
    if (delIds.length) {
      var delFrames = _.map(delIds, function (id) {
        for (var _k = 0; _k < oldSigFrames.length; _k++) {
          var _oldFrame = oldSigFrames[_k];
          if (_oldFrame.getSealedId() == id) {
            return _oldFrame;
          }
        }
      });
      _this2.m_actionManager.deleteObjects(delFrames);
    }
    callback();
  }, function () {});
};
MMNetDiskDiscussionBoard.createObjectFromData = function (board, data) {
  if (data.type == "scribble") {
    var scribble = new _MMScribble["default"](board, data.version);
    scribble.isPenComment = true;
    var encode = new _Encoder["default"]();
    encode.setBuffer(data.data);
    var decoder = new _Decoder["default"](board);
    decoder.setStream(encode.getStream());
    scribble.decodeOrigin(decoder);
    scribble.isSaved = true;
    return scribble;
  } else if (data.type == "weldMark") {
    var weldMark = new _MMWeldMark["default"](board, data.version);
    var encode = new _Encoder["default"]();
    encode.setBuffer(data.data);
    var decoder = new _Decoder["default"](board);
    decoder.setStream(encode.getStream());
    weldMark.decodeOrigin(decoder);
    return weldMark;
  }
};
MMNetDiskDiscussionBoard.createSigFrameFromData = function (board, sigInfo, fileId, callback) {
  var version = sigInfo.version;
  var sigFrame = new _MMSealFrame["default"](board, version);
  sigFrame.setDefaultRect2Save(sigInfo.rect);
  sigFrame.setUser(sigInfo.user);
  sigFrame.setSealedId(sigInfo.id);
  sigFrame.setPageIndex(sigInfo.pageIndex);
  sigFrame.setDevOrientation(_BoardOrientation["default"].Portrait);
  sigFrame.setAngle(-sigInfo.angle);
  sigFrame.setDatetime(sigInfo.datetime);
  _MMUserDataController["default"].getSealByIdAndFileId(fileId, sigInfo.sealId, function (sealInfo) {
    var sealData = new _MDSealData["default"](sealInfo);
    sealData.loadImg(function () {
      sigFrame.setSigData(sealData);
      var picObjs = board.getImgPdfObjectsForVersion(version);
      for (var k = 0; k < picObjs.length; k++) {
        var picObj = picObjs[k];
        if (picObj.getPageIndex() == sigInfo.pageIndex) {
          var picrect = picObj.getDrawRect();
          var lgPts = picrect.getLogicPts();
          sigFrame.setLogPts(lgPts); // 初始化外界矩形为整个文档的大小，随后在绘制时会根据 setRect2Save 而自动调整
        }
      }
      callback(sigFrame);
    });
  });

  // return ;
};
MMNetDiskDiscussionBoard.prototype.sendWeldMark2Server = function (version, success, fail) {
  var data = [];
  var needSave = [];
  if (version == undefined || version == null || version == -1) {
    version = this.getCurVersion();
  }
  var weldMarks = this.getAllObjs(_ObjType["default"].Obj_weldMark);
  for (var i = 0; i < weldMarks.length; i++) {
    if (weldMarks[i].objData.active && weldMarks[i].getCreator() == app.currentUser.getId()) {
      data.push(weldMarks[i].createWeldMarkData());
      needSave.push(weldMarks[i]);
    }
  }
  if (data.length > 0) {
    var fileId = this.getFileInfo().getFileId();
    _MDNetDriveFileHandler["default"].sendBoardDatas(fileId, version, data, function () {
      for (var _i3 = 0; _i3 < needSave.length; _i3++) {
        var s = needSave[_i3];
        s.objData.active = false;
      }
      success && success();
    }, function () {
      fail && fail();
    });
  } else {
    success && success();
  }
};
MMNetDiskDiscussionBoard.prototype.userHasSignatureForVersion = function (userId, version, success, fail) {
  var frames = this.getAllSigFramesForVersion(version);
  var found = false;
  frames.forEach(function (obj) {
    if (obj.getClassName() == "MMSignatureFrame" && obj.getUser().getUserId() == userId) found = true;
  });
  return found;
};
MMNetDiskDiscussionBoard.prototype.getAllSigFramesForVersion = function (ver_) {
  if (ver_ == undefined || ver_ == null) {
    ver_ = this.getVersionShowing();
  }
  var sigFrames = [];
  var allObjs = this.getAllObjs();
  allObjs.forEach(function (obj) {
    if (obj.getClassName() == "MMSignatureFrame" && obj.getFileVersion() == ver_) sigFrames.push(obj);
  });
  return sigFrames;
};
MMNetDiskDiscussionBoard.prototype.getAllSigFrames = function () {
  var sigFrames = [];
  var allObjs = this.getAllObjs();
  allObjs.forEach(function (obj) {
    if (obj.getClassName() == "MMSignatureFrame") sigFrames.push(obj);
  });
  return sigFrames;
};
var _default = exports["default"] = MMNetDiskDiscussionBoard;

},{"1028":1028,"1030":1030,"1034":1034,"1036":1036,"1084":1084,"1091":1091,"1108":1108,"1136":1136,"1138":1138,"1139":1139,"1141":1141,"1184":1184,"1418":1418,"1426":1426,"1437":1437,"1454":1454,"1463":1463,"1466":1466,"1478":1478,"1537":1537,"1541":1541,"18":18,"272":272,"283":283,"286":286,"325":325,"799":799,"800":800,"802":802,"820":820,"886":886,"947":947,"958":958,"959":959}],1141:[function(require,module,exports){
"use strict";

require(1429);
require(1419);
require(1503);
require(1500);
require(1502);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleLinkService = exports.PDFLinkService = exports.LinkTarget = void 0;
var _regenerator = _interopRequireDefault(require(1199));
require(1423);
require(1443);
require(1463);
require(1487);
require(1538);
require(1422);
require(1447);
require(1446);
require(1420);
require(1485);
require(1477);
require(1492);
require(1536);
require(1489);
require(1465);
require(1461);
require(1437);
require(1478);
require(1471);
require(1412);
require(1532);
require(1534);
require(1439);
var _typeof2 = _interopRequireDefault(require(1197));
var _asyncToGenerator2 = _interopRequireDefault(require(1172));
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _classPrivateFieldGet2 = _interopRequireDefault(require(1177));
var _ui_utils = require(1146);
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classStaticPrivateMethodGet(receiver, classConstructor, method) { _classCheckPrivateStaticAccess(receiver, classConstructor); return method; }
function _classCheckPrivateStaticAccess(receiver, classConstructor) { if (receiver !== classConstructor) { throw new TypeError("Private static access of wrong provenance"); } }
function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; } /* Copyright 2015 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** @typedef {import("./event_utils").EventBus} EventBus */ /** @typedef {import("./interfaces").IPDFLinkService} IPDFLinkService */
var DEFAULT_LINK_REL = "noopener noreferrer nofollow";
var LinkTarget = exports.LinkTarget = {
  NONE: 0,
  // Default value.
  SELF: 1,
  BLANK: 2,
  PARENT: 3,
  TOP: 4
};

/**
 * @typedef {Object} ExternalLinkParameters
 * @property {string} url - An absolute URL.
 * @property {LinkTarget} [target] - The link target. The default value is
 *   `LinkTarget.NONE`.
 * @property {string} [rel] - The link relationship. The default value is
 *   `DEFAULT_LINK_REL`.
 * @property {boolean} [enabled] - Whether the link should be enabled. The
 *   default value is true.
 */

/**
 * Adds various attributes (href, title, target, rel) to hyperlinks.
 * @param {HTMLAnchorElement} link - The link element.
 * @param {ExternalLinkParameters} params
 */
function _addLinkAttributes(link) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    url = _ref.url,
    target = _ref.target,
    rel = _ref.rel,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? true : _ref$enabled;
  if (!url || typeof url !== "string") {
    throw new Error('A valid "url" parameter must provided.');
  }
  var urlNullRemoved = (0, _ui_utils.removeNullCharacters)(url);
  if (enabled) {
    link.href = link.title = urlNullRemoved;
  } else {
    link.href = "";
    link.title = "Disabled: ".concat(urlNullRemoved);
    link.onclick = function () {
      return false;
    };
  }
  var targetStr = ""; // LinkTarget.NONE
  switch (target) {
    case LinkTarget.NONE:
      break;
    case LinkTarget.SELF:
      targetStr = "_self";
      break;
    case LinkTarget.BLANK:
      targetStr = "_blank";
      break;
    case LinkTarget.PARENT:
      targetStr = "_parent";
      break;
    case LinkTarget.TOP:
      targetStr = "_top";
      break;
  }
  link.target = targetStr;
  link.rel = typeof rel === "string" ? rel : DEFAULT_LINK_REL;
}

/**
 * @typedef {Object} PDFLinkServiceOptions
 * @property {EventBus} eventBus - The application event bus.
 * @property {number} [externalLinkTarget] - Specifies the `target` attribute
 *   for external links. Must use one of the values from {LinkTarget}.
 *   Defaults to using no target.
 * @property {string} [externalLinkRel] - Specifies the `rel` attribute for
 *   external links. Defaults to stripping the referrer.
 * @property {boolean} [ignoreDestinationZoom] - Ignores the zoom argument,
 *   thus preserving the current zoom level in the viewer, when navigating
 *   to internal destinations. The default value is `false`.
 */

/**
 * Performs navigation functions inside PDF, such as opening specified page,
 * or destination.
 * @implements {IPDFLinkService}
 */
var _pagesRefCache = /*#__PURE__*/new WeakMap();
var _goToDestinationHelper = /*#__PURE__*/new WeakSet();
var PDFLinkService = exports.PDFLinkService = /*#__PURE__*/function () {
  /**
   * @param {PDFLinkServiceOptions} options
   */
  function PDFLinkService() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      eventBus = _ref2.eventBus,
      openPdfLink = _ref2.openPdfLink,
      _ref2$externalLinkTar = _ref2.externalLinkTarget,
      externalLinkTarget = _ref2$externalLinkTar === void 0 ? null : _ref2$externalLinkTar,
      _ref2$externalLinkRel = _ref2.externalLinkRel,
      externalLinkRel = _ref2$externalLinkRel === void 0 ? null : _ref2$externalLinkRel,
      _ref2$ignoreDestinati = _ref2.ignoreDestinationZoom,
      ignoreDestinationZoom = _ref2$ignoreDestinati === void 0 ? false : _ref2$ignoreDestinati;
    (0, _classCallCheck2["default"])(this, PDFLinkService);
    _classPrivateMethodInitSpec(this, _goToDestinationHelper);
    _classPrivateFieldInitSpec(this, _pagesRefCache, {
      writable: true,
      value: new Map()
    });
    this.openPdfLink = openPdfLink;
    this.eventBus = eventBus;
    this.externalLinkTarget = externalLinkTarget;
    this.externalLinkRel = externalLinkRel;
    this.externalLinkEnabled = true;
    this._ignoreDestinationZoom = ignoreDestinationZoom;
    this.baseUrl = null;
    this.pdfDocument = null;
    this.pdfViewer = null;
    this.pdfHistory = null;
  }
  (0, _createClass2["default"])(PDFLinkService, [{
    key: "setDocument",
    value: function setDocument(pdfDocument) {
      var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      this.baseUrl = baseUrl;
      this.pdfDocument = pdfDocument;
      (0, _classPrivateFieldGet2["default"])(this, _pagesRefCache).clear();
    }
  }, {
    key: "setEditor",
    value: function setEditor(editor) {
      this.editor = editor;
    }
  }, {
    key: "setViewer",
    value: function setViewer(pdfViewer) {
      this.pdfViewer = pdfViewer;
    }
  }, {
    key: "setHistory",
    value: function setHistory(pdfHistory) {
      this.pdfHistory = pdfHistory;
    }

    /**
     * @type {number}
     */
  }, {
    key: "pagesCount",
    get: function get() {
      return this.pdfDocument ? this.pdfDocument.numPages : 0;
    }

    /**
     * @type {number}
     */
  }, {
    key: "page",
    get: function get() {
      return this.editor.getCurrentFileIndex() + 1;
    }

    /**
     * @param {number} value
     */,
    set: function set(value) {
      if (this.page == value) {
        return;
      }
      this.editor.scrollToPage(value, false);
      // this.pdfViewer.currentPageNumber = value;
      console.warn("set current pageIndex");
    }

    /**
     * @type {number}
     */
  }, {
    key: "rotation",
    get: function get() {
      return this.pdfViewer.pagesRotation;
    }

    /**
     * @param {number} value
     */,
    set: function set(value) {
      this.pdfViewer.pagesRotation = value;
    }

    /**
     * @type {boolean}
     */
  }, {
    key: "isInPresentationMode",
    get: function get() {
      return this.pdfViewer.isInPresentationMode;
    }
  }, {
    key: "goToDestination",
    value: (
    /**
     * This method will, when available, also update the browser history.
     *
     * @param {string|Array} dest - The named, or explicit, PDF destination.
     */
    function () {
      var _goToDestination = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(dest) {
        var namedDest, explicitDest;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.pdfDocument) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              if (!(typeof dest === "string")) {
                _context.next = 9;
                break;
              }
              namedDest = dest;
              _context.next = 6;
              return this.pdfDocument.getDestination(dest);
            case 6:
              explicitDest = _context.sent;
              _context.next = 13;
              break;
            case 9:
              namedDest = null;
              _context.next = 12;
              return dest;
            case 12:
              explicitDest = _context.sent;
            case 13:
              if (Array.isArray(explicitDest)) {
                _context.next = 16;
                break;
              }
              console.error("PDFLinkService.goToDestination: \"".concat(explicitDest, "\" is not ") + "a valid destination array, for dest=\"".concat(dest, "\"."));
              return _context.abrupt("return");
            case 16:
              _classPrivateMethodGet(this, _goToDestinationHelper, _goToDestinationHelper2).call(this, dest, namedDest, explicitDest);
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function goToDestination(_x) {
        return _goToDestination.apply(this, arguments);
      }
      return goToDestination;
    }()
    /**
     * This method will, when available, also update the browser history.
     *
     * @param {number|string} val - The page number, or page label.
     */
    )
  }, {
    key: "goToPage",
    value: function goToPage(val) {
      if (!this.pdfDocument) {
        return;
      }
      var pageNumber = typeof val === "string" && this.pdfViewer.pageLabelToPageNumber(val) || val | 0;
      if (!(Number.isInteger(pageNumber) && pageNumber > 0 && pageNumber <= this.pagesCount)) {
        console.error("PDFLinkService.goToPage: \"".concat(val, "\" is not a valid page."));
        return;
      }
      if (this.pdfHistory) {
        // Update the browser history before scrolling the new page into view,
        // to be able to accurately capture the current document position.
        this.pdfHistory.pushCurrentPosition();
        this.pdfHistory.pushPage(pageNumber);
      }
      this.pdfViewer.scrollPageIntoView({
        pageNumber: pageNumber
      });
    }

    /**
     * Wrapper around the `addLinkAttributes` helper function.
     * @param {HTMLAnchorElement} link
     * @param {string} url
     * @param {boolean} [newWindow]
     */
  }, {
    key: "addLinkAttributes",
    value: function addLinkAttributes(link, url) {
      var newWindow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      _addLinkAttributes(link, {
        url: url,
        target: newWindow ? LinkTarget.BLANK : this.externalLinkTarget,
        rel: this.externalLinkRel,
        enabled: this.externalLinkEnabled
      });
    }

    /**
     * @param {string|Array} dest - The PDF destination object.
     * @returns {string} The hyperlink to the PDF object.
     */
  }, {
    key: "getDestinationHash",
    value: function getDestinationHash(dest) {
      if (typeof dest === "string") {
        if (dest.length > 0) {
          return this.getAnchorUrl("#" + escape(dest));
        }
      } else if (Array.isArray(dest)) {
        var str = JSON.stringify(dest);
        if (str.length > 0) {
          return this.getAnchorUrl("#" + escape(str));
        }
      }
      return this.getAnchorUrl("");
    }

    /**
     * Prefix the full url on anchor links to make sure that links are resolved
     * relative to the current URL instead of the one defined in <base href>.
     * @param {string} anchor - The anchor hash, including the #.
     * @returns {string} The hyperlink to the PDF object.
     */
  }, {
    key: "getAnchorUrl",
    value: function getAnchorUrl(anchor) {
      return this.baseUrl ? this.baseUrl + anchor : anchor;
    }

    /**
     * @param {string} hash
     */
  }, {
    key: "setHash",
    value: function setHash(hash) {
      if (!this.pdfDocument) {
        return;
      }
      var pageNumber, dest;
      if (hash.includes("=")) {
        var params = (0, _ui_utils.parseQueryString)(hash);
        if (params.has("search")) {
          var query = params.get("search").replaceAll('"', ""),
            phrase = params.get("phrase") === "true";
          this.eventBus.dispatch("findfromurlhash", {
            source: this,
            query: phrase ? query : query.match(/\S+/g)
          });
        }
        // borrowing syntax from "Parameters for Opening PDF Files"
        if (params.has("page")) {
          pageNumber = params.get("page") | 0 || 1;
        }
        if (params.has("zoom")) {
          // Build the destination array.
          var zoomArgs = params.get("zoom").split(","); // scale,left,top
          var zoomArg = zoomArgs[0];
          var zoomArgNumber = parseFloat(zoomArg);
          if (!zoomArg.includes("Fit")) {
            // If the zoomArg is a number, it has to get divided by 100. If it's
            // a string, it should stay as it is.
            dest = [null, {
              name: "XYZ"
            }, zoomArgs.length > 1 ? zoomArgs[1] | 0 : null, zoomArgs.length > 2 ? zoomArgs[2] | 0 : null, zoomArgNumber ? zoomArgNumber / 100 : zoomArg];
          } else {
            if (zoomArg === "Fit" || zoomArg === "FitB") {
              dest = [null, {
                name: zoomArg
              }];
            } else if (zoomArg === "FitH" || zoomArg === "FitBH" || zoomArg === "FitV" || zoomArg === "FitBV") {
              dest = [null, {
                name: zoomArg
              }, zoomArgs.length > 1 ? zoomArgs[1] | 0 : null];
            } else if (zoomArg === "FitR") {
              if (zoomArgs.length !== 5) {
                console.error('PDFLinkService.setHash: Not enough parameters for "FitR".');
              } else {
                dest = [null, {
                  name: zoomArg
                }, zoomArgs[1] | 0, zoomArgs[2] | 0, zoomArgs[3] | 0, zoomArgs[4] | 0];
              }
            } else {
              console.error("PDFLinkService.setHash: \"".concat(zoomArg, "\" is not a valid zoom value."));
            }
          }
        }
        if (dest) {
          this.pdfViewer.scrollPageIntoView({
            pageNumber: pageNumber || this.page,
            destArray: dest,
            allowNegativeOffset: true
          });
        } else if (pageNumber) {
          this.page = pageNumber; // simple page
        }
        if (params.has("pagemode")) {
          this.eventBus.dispatch("pagemode", {
            source: this,
            mode: params.get("pagemode")
          });
        }
        // Ensure that this parameter is *always* handled last, in order to
        // guarantee that it won't be overridden (e.g. by the "page" parameter).
        if (params.has("nameddest")) {
          this.goToDestination(params.get("nameddest"));
        }
      } else {
        // Named (or explicit) destination.
        dest = unescape(hash);
        try {
          dest = JSON.parse(dest);
          if (!Array.isArray(dest)) {
            // Avoid incorrectly rejecting a valid named destination, such as
            // e.g. "4.3" or "true", because `JSON.parse` converted its type.
            dest = dest.toString();
          }
        } catch (_unused) {}
        if (typeof dest === "string" || _classStaticPrivateMethodGet(PDFLinkService, PDFLinkService, _isValidExplicitDestination).call(PDFLinkService, dest)) {
          this.goToDestination(dest);
          return;
        }
        console.error("PDFLinkService.setHash: \"".concat(unescape(hash), "\" is not a valid destination."));
      }
    }

    /**
     * @param {string} action
     */
  }, {
    key: "executeNamedAction",
    value: function executeNamedAction(action) {
      var _this$pdfHistory, _this$pdfHistory2;
      // See PDF reference, table 8.45 - Named action
      switch (action) {
        case "GoBack":
          (_this$pdfHistory = this.pdfHistory) === null || _this$pdfHistory === void 0 || _this$pdfHistory.back();
          break;
        case "GoForward":
          (_this$pdfHistory2 = this.pdfHistory) === null || _this$pdfHistory2 === void 0 || _this$pdfHistory2.forward();
          break;
        case "NextPage":
          this.pdfViewer.nextPage();
          break;
        case "PrevPage":
          this.pdfViewer.previousPage();
          break;
        case "LastPage":
          this.page = this.pagesCount;
          break;
        case "FirstPage":
          this.page = 1;
          break;
        default:
          break;
        // No action according to spec
      }
      this.eventBus.dispatch("namedaction", {
        source: this,
        action: action
      });
    }

    /**
     * @param {Object} action
     */
  }, {
    key: "executeSetOCGState",
    value: (function () {
      var _executeSetOCGState = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(action) {
        var pdfDocument, optionalContentConfig, operator, _iterator, _step, elem, group;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              pdfDocument = this.pdfDocument;
              _context2.next = 3;
              return this.pdfViewer.optionalContentConfigPromise;
            case 3:
              optionalContentConfig = _context2.sent;
              if (!(pdfDocument !== this.pdfDocument)) {
                _context2.next = 6;
                break;
              }
              return _context2.abrupt("return");
            case 6:
              _iterator = _createForOfIteratorHelper(action.state);
              _context2.prev = 7;
              _iterator.s();
            case 9:
              if ((_step = _iterator.n()).done) {
                _context2.next = 28;
                break;
              }
              elem = _step.value;
              _context2.t0 = elem;
              _context2.next = _context2.t0 === "ON" ? 14 : _context2.t0 === "OFF" ? 14 : _context2.t0 === "Toggle" ? 14 : 16;
              break;
            case 14:
              operator = elem;
              return _context2.abrupt("continue", 26);
            case 16:
              _context2.t1 = operator;
              _context2.next = _context2.t1 === "ON" ? 19 : _context2.t1 === "OFF" ? 21 : _context2.t1 === "Toggle" ? 23 : 26;
              break;
            case 19:
              optionalContentConfig.setVisibility(elem, true);
              return _context2.abrupt("break", 26);
            case 21:
              optionalContentConfig.setVisibility(elem, false);
              return _context2.abrupt("break", 26);
            case 23:
              group = optionalContentConfig.getGroup(elem);
              if (group) {
                optionalContentConfig.setVisibility(elem, !group.visible);
              }
              return _context2.abrupt("break", 26);
            case 26:
              _context2.next = 9;
              break;
            case 28:
              _context2.next = 33;
              break;
            case 30:
              _context2.prev = 30;
              _context2.t2 = _context2["catch"](7);
              _iterator.e(_context2.t2);
            case 33:
              _context2.prev = 33;
              _iterator.f();
              return _context2.finish(33);
            case 36:
              this.pdfViewer.optionalContentConfigPromise = Promise.resolve(optionalContentConfig);
            case 37:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[7, 30, 33, 36]]);
      }));
      function executeSetOCGState(_x2) {
        return _executeSetOCGState.apply(this, arguments);
      }
      return executeSetOCGState;
    }()
    /**
     * @param {number} pageNum - page number.
     * @param {Object} pageRef - reference to the page.
     */
    )
  }, {
    key: "cachePageRef",
    value: function cachePageRef(pageNum, pageRef) {
      if (!pageRef) {
        return;
      }
      var refStr = pageRef.gen === 0 ? "".concat(pageRef.num, "R") : "".concat(pageRef.num, "R").concat(pageRef.gen);
      (0, _classPrivateFieldGet2["default"])(this, _pagesRefCache).set(refStr, pageNum);
    }

    /**
     * @ignore
     */
  }, {
    key: "_cachedPageNumber",
    value: function _cachedPageNumber(pageRef) {
      if (!pageRef) {
        return null;
      }
      var refStr = pageRef.gen === 0 ? "".concat(pageRef.num, "R") : "".concat(pageRef.num, "R").concat(pageRef.gen);
      return (0, _classPrivateFieldGet2["default"])(this, _pagesRefCache).get(refStr) || null;
    }
  }]);
  return PDFLinkService;
}();
/**
 * @implements {IPDFLinkService}
 */
function _goToDestinationHelper2(rawDest) {
  var _this = this;
  var namedDest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var explicitDest = arguments.length > 2 ? arguments[2] : undefined;
  // Dest array looks like that: <page-ref> </XYZ|/FitXXX> <args..>
  var destRef = explicitDest[0];
  var pageNumber;
  if ((0, _typeof2["default"])(destRef) === "object" && destRef !== null) {
    pageNumber = this._cachedPageNumber(destRef);
    if (!pageNumber) {
      // Fetch the page reference if it's not yet available. This could
      // only occur during loading, before all pages have been resolved.
      this.pdfDocument.getPageIndex(destRef).then(function (pageIndex) {
        _this.cachePageRef(pageIndex + 1, destRef);
        _classPrivateMethodGet(_this, _goToDestinationHelper, _goToDestinationHelper2).call(_this, rawDest, namedDest, explicitDest);
      })["catch"](function () {
        console.error("PDFLinkService.#goToDestinationHelper: \"".concat(destRef, "\" is not ") + "a valid page reference, for dest=\"".concat(rawDest, "\"."));
      });
      return;
    }
  } else if (Number.isInteger(destRef)) {
    pageNumber = destRef + 1;
  } else {
    console.error("PDFLinkService.#goToDestinationHelper: \"".concat(destRef, "\" is not ") + "a valid destination reference, for dest=\"".concat(rawDest, "\"."));
    return;
  }
  if (!pageNumber || pageNumber < 1 || pageNumber > this.pagesCount) {
    console.error("PDFLinkService.#goToDestinationHelper: \"".concat(pageNumber, "\" is not ") + "a valid page number, for dest=\"".concat(rawDest, "\"."));
    return;
  }
  if (this.pdfHistory) {
    // Update the browser history before scrolling the new destination into
    // view, to be able to accurately capture the current document position.
    this.pdfHistory.pushCurrentPosition();
    this.pdfHistory.push({
      namedDest: namedDest,
      explicitDest: explicitDest,
      pageNumber: pageNumber
    });
  }

  // this.pdfViewer.scrollPageIntoView({
  //   pageNumber,
  //   destArray: explicitDest,
  //   ignoreDestinationZoom: this._ignoreDestinationZoom,
  // });
  this.openPdfLink({
    pageNumber: pageNumber,
    destArray: explicitDest
  });
}
function _isValidExplicitDestination(dest) {
  if (!Array.isArray(dest)) {
    return false;
  }
  var destLength = dest.length;
  if (destLength < 2) {
    return false;
  }
  var page = dest[0];
  if (!((0, _typeof2["default"])(page) === "object" && Number.isInteger(page.num) && Number.isInteger(page.gen)) && !(Number.isInteger(page) && page >= 0)) {
    return false;
  }
  var zoom = dest[1];
  if (!((0, _typeof2["default"])(zoom) === "object" && typeof zoom.name === "string")) {
    return false;
  }
  var allowNull = true;
  switch (zoom.name) {
    case "XYZ":
      if (destLength !== 5) {
        return false;
      }
      break;
    case "Fit":
    case "FitB":
      return destLength === 2;
    case "FitH":
    case "FitBH":
    case "FitV":
    case "FitBV":
      if (destLength !== 3) {
        return false;
      }
      break;
    case "FitR":
      if (destLength !== 6) {
        return false;
      }
      allowNull = false;
      break;
    default:
      return false;
  }
  for (var i = 2; i < destLength; i++) {
    var param = dest[i];
    if (!(typeof param === "number" || allowNull && param === null)) {
      return false;
    }
  }
  return true;
}
var SimpleLinkService = exports.SimpleLinkService = /*#__PURE__*/function () {
  function SimpleLinkService() {
    (0, _classCallCheck2["default"])(this, SimpleLinkService);
    this.externalLinkEnabled = true;
  }

  /**
   * @type {number}
   */
  (0, _createClass2["default"])(SimpleLinkService, [{
    key: "pagesCount",
    get: function get() {
      return 0;
    }

    /**
     * @type {number}
     */
  }, {
    key: "page",
    get: function get() {
      return 0;
    }

    /**
     * @param {number} value
     */,
    set: function set(value) {}

    /**
     * @type {number}
     */
  }, {
    key: "rotation",
    get: function get() {
      return 0;
    }

    /**
     * @param {number} value
     */,
    set: function set(value) {}

    /**
     * @type {boolean}
     */
  }, {
    key: "isInPresentationMode",
    get: function get() {
      return false;
    }

    /**
     * @param {string|Array} dest - The named, or explicit, PDF destination.
     */
  }, {
    key: "goToDestination",
    value: (function () {
      var _goToDestination2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(dest) {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function goToDestination(_x3) {
        return _goToDestination2.apply(this, arguments);
      }
      return goToDestination;
    }()
    /**
     * @param {number|string} val - The page number, or page label.
     */
    )
  }, {
    key: "goToPage",
    value: function goToPage(val) {}

    /**
     * @param {HTMLAnchorElement} link
     * @param {string} url
     * @param {boolean} [newWindow]
     */
  }, {
    key: "addLinkAttributes",
    value: function addLinkAttributes(link, url) {
      var newWindow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      _addLinkAttributes(link, {
        url: url,
        enabled: this.externalLinkEnabled
      });
    }

    /**
     * @param dest - The PDF destination object.
     * @returns {string} The hyperlink to the PDF object.
     */
  }, {
    key: "getDestinationHash",
    value: function getDestinationHash(dest) {
      return "#";
    }

    /**
     * @param hash - The PDF parameters/hash.
     * @returns {string} The hyperlink to the PDF object.
     */
  }, {
    key: "getAnchorUrl",
    value: function getAnchorUrl(hash) {
      return "#";
    }

    /**
     * @param {string} hash
     */
  }, {
    key: "setHash",
    value: function setHash(hash) {}

    /**
     * @param {string} action
     */
  }, {
    key: "executeNamedAction",
    value: function executeNamedAction(action) {}

    /**
     * @param {Object} action
     */
  }, {
    key: "executeSetOCGState",
    value: function executeSetOCGState(action) {}

    /**
     * @param {number} pageNum - page number.
     * @param {Object} pageRef - reference to the page.
     */
  }, {
    key: "cachePageRef",
    value: function cachePageRef(pageNum, pageRef) {}
  }]);
  return SimpleLinkService;
}();

},{"1146":1146,"1172":1172,"1175":1175,"1177":1177,"1179":1179,"1184":1184,"1197":1197,"1199":1199,"1412":1412,"1419":1419,"1420":1420,"1422":1422,"1423":1423,"1429":1429,"1437":1437,"1439":1439,"1443":1443,"1446":1446,"1447":1447,"1454":1454,"1461":1461,"1463":1463,"1465":1465,"1471":1471,"1477":1477,"1478":1478,"1485":1485,"1487":1487,"1489":1489,"1492":1492,"1500":1500,"1502":1502,"1503":1503,"1532":1532,"1534":1534,"1536":1536,"1538":1538}],1139:[function(require,module,exports){
"use strict";

require(1437);
require(1439);
require(1419);
require(1503);
require(1500);
require(1502);
require(1422);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFFindController = exports.FindState = void 0;
var _toConsumableArray2 = _interopRequireDefault(require(1194));
var _typeof2 = _interopRequireDefault(require(1197));
var _slicedToArray2 = _interopRequireDefault(require(1192));
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _classPrivateFieldGet7 = _interopRequireDefault(require(1177));
var _classPrivateFieldSet2 = _interopRequireDefault(require(1178));
require(1423);
require(1463);
require(1480);
require(1487);
require(1538);
require(1443);
require(1477);
require(1424);
require(1461);
require(1412);
require(1476);
require(1478);
require(1492);
require(1482);
require(1429);
require(1438);
require(1532);
require(1534);
require(1489);
require(1541);
require(1426);
require(1415);
require(1536);
require(1428);
require(1431);
require(1471);
var _ui_utils = require(1146);
var _pdf_find_utils = require(1140);
function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; } /* Copyright 2012 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** @typedef {import("../src/display/api").PDFDocumentProxy} PDFDocumentProxy */ /** @typedef {import("./event_utils").EventBus} EventBus */ /** @typedef {import("./interfaces").IPDFLinkService} IPDFLinkService */
// import { PromiseCapability } from "pdfjs-lib";

var FindState = exports.FindState = {
  FOUND: 0,
  NOT_FOUND: 1,
  WRAPPED: 2,
  PENDING: 3
};
var FIND_TIMEOUT = 250; // ms
var MATCH_SCROLL_OFFSET_TOP = -50; // px
var MATCH_SCROLL_OFFSET_LEFT = -400; // px

var CHARACTERS_TO_NORMALIZE = {
  "\u2010": "-",
  // Hyphen
  "\u2018": "'",
  // Left single quotation mark
  "\u2019": "'",
  // Right single quotation mark
  "\u201A": "'",
  // Single low-9 quotation mark
  "\u201B": "'",
  // Single high-reversed-9 quotation mark
  "\u201C": '"',
  // Left double quotation mark
  "\u201D": '"',
  // Right double quotation mark
  "\u201E": '"',
  // Double low-9 quotation mark
  "\u201F": '"',
  // Double high-reversed-9 quotation mark
  "\xBC": "1/4",
  // Vulgar fraction one quarter
  "\xBD": "1/2",
  // Vulgar fraction one half
  "\xBE": "3/4" // Vulgar fraction three quarters
};

// These diacritics aren't considered as combining diacritics
// when searching in a document:
//   https://searchfox.org/mozilla-central/source/intl/unicharutil/util/is_combining_diacritic.py.
// The combining class definitions can be found:
//   https://www.unicode.org/reports/tr44/#Canonical_Combining_Class_Values
// Category 0 corresponds to [^\p{Mn}].
var DIACRITICS_EXCEPTION = new Set([
// UNICODE_COMBINING_CLASS_KANA_VOICING
// https://www.compart.com/fr/unicode/combining/8
0x3099, 0x309a,
// UNICODE_COMBINING_CLASS_VIRAMA (under 0xFFFF)
// https://www.compart.com/fr/unicode/combining/9
0x094d, 0x09cd, 0x0a4d, 0x0acd, 0x0b4d, 0x0bcd, 0x0c4d, 0x0ccd, 0x0d3b, 0x0d3c, 0x0d4d, 0x0dca, 0x0e3a, 0x0eba, 0x0f84, 0x1039, 0x103a, 0x1714, 0x1734, 0x17d2, 0x1a60, 0x1b44, 0x1baa, 0x1bab, 0x1bf2, 0x1bf3, 0x2d7f, 0xa806, 0xa82c, 0xa8c4, 0xa953, 0xa9c0, 0xaaf6, 0xabed,
// 91
// https://www.compart.com/fr/unicode/combining/91
0x0c56,
// 129
// https://www.compart.com/fr/unicode/combining/129
0x0f71,
// 130
// https://www.compart.com/fr/unicode/combining/130
0x0f72, 0x0f7a, 0x0f7b, 0x0f7c, 0x0f7d, 0x0f80,
// 132
// https://www.compart.com/fr/unicode/combining/132
0x0f74]);
var DIACRITICS_EXCEPTION_STR; // Lazily initialized, see below.

var DIACRITICS_REG_EXP = /(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C04\u0C3C\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CF3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D81-\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u180F\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ACE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA82C\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDEFD-\uDEFF\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC00-\uDC02\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC82\uDCB0-\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD34\uDD45\uDD46\uDD73\uDD80-\uDD82\uDDB3-\uDDC0\uDDC9-\uDDCC\uDDCE\uDDCF\uDE2C-\uDE37\uDE3E\uDE41\uDEDF-\uDEEA\uDF00-\uDF03\uDF3B\uDF3C\uDF3E-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC35-\uDC46\uDC5E\uDCB0-\uDCC3\uDDAF-\uDDB5\uDDB8-\uDDC0\uDDDC\uDDDD\uDE30-\uDE40\uDEAB-\uDEB7\uDF1D-\uDF2B]|\uD806[\uDC2C-\uDC3A\uDD30-\uDD35\uDD37\uDD38\uDD3B-\uDD3E\uDD40\uDD42\uDD43\uDDD1-\uDDD7\uDDDA-\uDDE0\uDDE4\uDE01-\uDE0A\uDE33-\uDE39\uDE3B-\uDE3E\uDE47\uDE51-\uDE5B\uDE8A-\uDE99]|\uD807[\uDC2F-\uDC36\uDC38-\uDC3F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD8A-\uDD8E\uDD90\uDD91\uDD93-\uDD97\uDEF3-\uDEF6\uDF00\uDF01\uDF03\uDF34-\uDF3A\uDF3E-\uDF42]|\uD80D[\uDC40\uDC47-\uDC55]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF51-\uDF87\uDF8F-\uDF92\uDFE4\uDFF0\uDFF1]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDC8F\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD839[\uDCEC-\uDCEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF])+/g;
var SPECIAL_CHARS_REG_EXP = /([\$\(-\+\.\?\[-\^\{-\}])|((?:[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]))|([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+)|((?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C04\u0C3C\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CF3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D81-\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u180F\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ACE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA82C\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDEFD-\uDEFF\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC00-\uDC02\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC82\uDCB0-\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD34\uDD45\uDD46\uDD73\uDD80-\uDD82\uDDB3-\uDDC0\uDDC9-\uDDCC\uDDCE\uDDCF\uDE2C-\uDE37\uDE3E\uDE41\uDEDF-\uDEEA\uDF00-\uDF03\uDF3B\uDF3C\uDF3E-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC35-\uDC46\uDC5E\uDCB0-\uDCC3\uDDAF-\uDDB5\uDDB8-\uDDC0\uDDDC\uDDDD\uDE30-\uDE40\uDEAB-\uDEB7\uDF1D-\uDF2B]|\uD806[\uDC2C-\uDC3A\uDD30-\uDD35\uDD37\uDD38\uDD3B-\uDD3E\uDD40\uDD42\uDD43\uDDD1-\uDDD7\uDDDA-\uDDE0\uDDE4\uDE01-\uDE0A\uDE33-\uDE39\uDE3B-\uDE3E\uDE47\uDE51-\uDE5B\uDE8A-\uDE99]|\uD807[\uDC2F-\uDC36\uDC38-\uDC3F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD8A-\uDD8E\uDD90\uDD91\uDD93-\uDD97\uDEF3-\uDEF6\uDF00\uDF01\uDF03\uDF34-\uDF3A\uDF3E-\uDF42]|\uD80D[\uDC40\uDC47-\uDC55]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF51-\uDF87\uDF8F-\uDF92\uDFE4\uDFF0\uDFF1]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDC8F\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD839[\uDCEC-\uDCEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF]))|((?:[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF]))/g;
var NOT_DIACRITIC_FROM_END_REG_EXP = /((?:[\0-\u02FF\u0370-\u0482\u048A-\u0590\u05BE\u05C0\u05C3\u05C6\u05C8-\u060F\u061B-\u064A\u0660-\u066F\u0671-\u06D5\u06DD\u06DE\u06E5\u06E6\u06E9\u06EE-\u0710\u0712-\u072F\u074B-\u07A5\u07B1-\u07EA\u07F4-\u07FC\u07FE-\u0815\u081A\u0824\u0828\u082E-\u0858\u085C-\u0897\u08A0-\u08C9\u08E2\u0904-\u0939\u093D\u0950\u0958-\u0961\u0964-\u0980\u0984-\u09BB\u09BD\u09C5\u09C6\u09C9\u09CA\u09CE-\u09D6\u09D8-\u09E1\u09E4-\u09FD\u09FF\u0A00\u0A04-\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A6F\u0A72-\u0A74\u0A76-\u0A80\u0A84-\u0ABB\u0ABD\u0AC6\u0ACA\u0ACE-\u0AE1\u0AE4-\u0AF9\u0B00\u0B04-\u0B3B\u0B3D\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B54\u0B58-\u0B61\u0B64-\u0B81\u0B83-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE-\u0BD6\u0BD8-\u0BFF\u0C05-\u0C3B\u0C3D\u0C45\u0C49\u0C4E-\u0C54\u0C57-\u0C61\u0C64-\u0C80\u0C84-\u0CBB\u0CBD\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CE1\u0CE4-\u0CF2\u0CF4-\u0CFF\u0D04-\u0D3A\u0D3D\u0D45\u0D49\u0D4E-\u0D56\u0D58-\u0D61\u0D64-\u0D80\u0D84-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DF1\u0DF4-\u0E30\u0E32\u0E33\u0E3B-\u0E46\u0E4F-\u0EB0\u0EB2\u0EB3\u0EBD-\u0EC7\u0ECF-\u0F17\u0F1A-\u0F34\u0F36\u0F38\u0F3A-\u0F3D\u0F40-\u0F70\u0F85\u0F88-\u0F8C\u0F98\u0FBD-\u0FC5\u0FC7-\u102A\u103F-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u1090-\u1099\u109E-\u135C\u1360-\u1711\u1716-\u1731\u1735-\u1751\u1754-\u1771\u1774-\u17B3\u17D4-\u17DC\u17DE-\u180A\u180E\u1810-\u1884\u1887-\u18A8\u18AA-\u191F\u192C-\u192F\u193C-\u1A16\u1A1C-\u1A54\u1A5F\u1A7D\u1A7E\u1A80-\u1AAF\u1ACF-\u1AFF\u1B05-\u1B33\u1B45-\u1B6A\u1B74-\u1B7F\u1B83-\u1BA0\u1BAE-\u1BE5\u1BF4-\u1C23\u1C38-\u1CCF\u1CD3\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA-\u1DBF\u1E00-\u20CF\u20F1-\u2CEE\u2CF2-\u2D7E\u2D80-\u2DDF\u2E00-\u3029\u3030-\u3098\u309B-\uA66E\uA673\uA67E-\uA69D\uA6A0-\uA6EF\uA6F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA828-\uA82B\uA82D-\uA87F\uA882-\uA8B3\uA8C6-\uA8DF\uA8F2-\uA8FE\uA900-\uA925\uA92E-\uA946\uA954-\uA97F\uA984-\uA9B2\uA9C1-\uA9E4\uA9E6-\uAA28\uAA37-\uAA42\uAA44-\uAA4B\uAA4E-\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2-\uAAEA\uAAF0-\uAAF4\uAAF7-\uABE2\uABEB\uABEE-\uD7FF\uE000-\uFB1D\uFB1F-\uFDFF\uFE10-\uFE1F\uFE30-\uFFFF]|\uD800[\uDC00-\uDDFC\uDDFE-\uDEDF\uDEE1-\uDF75\uDF7B-\uDFFF]|[\uD801\uD808-\uD80C\uD80E-\uD819\uD81C-\uD82E\uD830-\uD832\uD835\uD837\uD83B-\uDB3F\uDB41-\uDBFF][\uDC00-\uDFFF]|\uD802[\uDC00-\uDE00\uDE04\uDE07-\uDE0B\uDE10-\uDE37\uDE3B-\uDE3E\uDE40-\uDEE4\uDEE7-\uDFFF]|\uD803[\uDC00-\uDD23\uDD28-\uDEAA\uDEAD-\uDEFC\uDF00-\uDF45\uDF51-\uDF81\uDF86-\uDFFF]|\uD804[\uDC03-\uDC37\uDC47-\uDC6F\uDC71\uDC72\uDC75-\uDC7E\uDC83-\uDCAF\uDCBB-\uDCC1\uDCC3-\uDCFF\uDD03-\uDD26\uDD35-\uDD44\uDD47-\uDD72\uDD74-\uDD7F\uDD83-\uDDB2\uDDC1-\uDDC8\uDDCD\uDDD0-\uDE2B\uDE38-\uDE3D\uDE3F\uDE40\uDE42-\uDEDE\uDEEB-\uDEFF\uDF04-\uDF3A\uDF3D\uDF45\uDF46\uDF49\uDF4A\uDF4E-\uDF56\uDF58-\uDF61\uDF64\uDF65\uDF6D-\uDF6F\uDF75-\uDFFF]|\uD805[\uDC00-\uDC34\uDC47-\uDC5D\uDC5F-\uDCAF\uDCC4-\uDDAE\uDDB6\uDDB7\uDDC1-\uDDDB\uDDDE-\uDE2F\uDE41-\uDEAA\uDEB8-\uDF1C\uDF2C-\uDFFF]|\uD806[\uDC00-\uDC2B\uDC3B-\uDD2F\uDD36\uDD39\uDD3A\uDD3F\uDD41\uDD44-\uDDD0\uDDD8\uDDD9\uDDE1-\uDDE3\uDDE5-\uDE00\uDE0B-\uDE32\uDE3A\uDE3F-\uDE46\uDE48-\uDE50\uDE5C-\uDE89\uDE9A-\uDFFF]|\uD807[\uDC00-\uDC2E\uDC37\uDC40-\uDC91\uDCA8\uDCB7-\uDD30\uDD37-\uDD39\uDD3B\uDD3E\uDD46\uDD48-\uDD89\uDD8F\uDD92\uDD98-\uDEF2\uDEF7-\uDEFF\uDF02\uDF04-\uDF33\uDF3B-\uDF3D\uDF43-\uDFFF]|\uD80D[\uDC00-\uDC3F\uDC41-\uDC46\uDC56-\uDFFF]|\uD81A[\uDC00-\uDEEF\uDEF5-\uDF2F\uDF37-\uDFFF]|\uD81B[\uDC00-\uDF4E\uDF50\uDF88-\uDF8E\uDF93-\uDFE3\uDFE5-\uDFEF\uDFF2-\uDFFF]|\uD82F[\uDC00-\uDC9C\uDC9F-\uDFFF]|\uD833[\uDC00-\uDEFF\uDF2E\uDF2F\uDF47-\uDFFF]|\uD834[\uDC00-\uDD64\uDD6A-\uDD6C\uDD73-\uDD7A\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDE41\uDE45-\uDFFF]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85-\uDE9A\uDEA0\uDEB0-\uDFFF]|\uD838[\uDC07\uDC19\uDC1A\uDC22\uDC25\uDC2B-\uDC8E\uDC90-\uDD2F\uDD37-\uDEAD\uDEAF-\uDEEB\uDEF0-\uDFFF]|\uD839[\uDC00-\uDCEB\uDCF0-\uDFFF]|\uD83A[\uDC00-\uDCCF\uDCD7-\uDD43\uDD4B-\uDFFF]|\uDB40[\uDC00-\uDCFF\uDDF0-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C04\u0C3C\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CF3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D81-\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u180F\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ACE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA82C\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDEFD-\uDEFF\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC00-\uDC02\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC82\uDCB0-\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD34\uDD45\uDD46\uDD73\uDD80-\uDD82\uDDB3-\uDDC0\uDDC9-\uDDCC\uDDCE\uDDCF\uDE2C-\uDE37\uDE3E\uDE41\uDEDF-\uDEEA\uDF00-\uDF03\uDF3B\uDF3C\uDF3E-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC35-\uDC46\uDC5E\uDCB0-\uDCC3\uDDAF-\uDDB5\uDDB8-\uDDC0\uDDDC\uDDDD\uDE30-\uDE40\uDEAB-\uDEB7\uDF1D-\uDF2B]|\uD806[\uDC2C-\uDC3A\uDD30-\uDD35\uDD37\uDD38\uDD3B-\uDD3E\uDD40\uDD42\uDD43\uDDD1-\uDDD7\uDDDA-\uDDE0\uDDE4\uDE01-\uDE0A\uDE33-\uDE39\uDE3B-\uDE3E\uDE47\uDE51-\uDE5B\uDE8A-\uDE99]|\uD807[\uDC2F-\uDC36\uDC38-\uDC3F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD8A-\uDD8E\uDD90\uDD91\uDD93-\uDD97\uDEF3-\uDEF6\uDF00\uDF01\uDF03\uDF34-\uDF3A\uDF3E-\uDF42]|\uD80D[\uDC40\uDC47-\uDC55]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF51-\uDF87\uDF8F-\uDF92\uDFE4\uDFF0\uDFF1]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDC8F\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD839[\uDCEC-\uDCEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF])*$/;
var NOT_DIACRITIC_FROM_START_REG_EXP = /^(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C04\u0C3C\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CF3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D81-\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u180F\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ACE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA82C\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDEFD-\uDEFF\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC00-\uDC02\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC82\uDCB0-\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD34\uDD45\uDD46\uDD73\uDD80-\uDD82\uDDB3-\uDDC0\uDDC9-\uDDCC\uDDCE\uDDCF\uDE2C-\uDE37\uDE3E\uDE41\uDEDF-\uDEEA\uDF00-\uDF03\uDF3B\uDF3C\uDF3E-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC35-\uDC46\uDC5E\uDCB0-\uDCC3\uDDAF-\uDDB5\uDDB8-\uDDC0\uDDDC\uDDDD\uDE30-\uDE40\uDEAB-\uDEB7\uDF1D-\uDF2B]|\uD806[\uDC2C-\uDC3A\uDD30-\uDD35\uDD37\uDD38\uDD3B-\uDD3E\uDD40\uDD42\uDD43\uDDD1-\uDDD7\uDDDA-\uDDE0\uDDE4\uDE01-\uDE0A\uDE33-\uDE39\uDE3B-\uDE3E\uDE47\uDE51-\uDE5B\uDE8A-\uDE99]|\uD807[\uDC2F-\uDC36\uDC38-\uDC3F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD8A-\uDD8E\uDD90\uDD91\uDD93-\uDD97\uDEF3-\uDEF6\uDF00\uDF01\uDF03\uDF34-\uDF3A\uDF3E-\uDF42]|\uD80D[\uDC40\uDC47-\uDC55]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF51-\uDF87\uDF8F-\uDF92\uDFE4\uDFF0\uDFF1]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDC8F\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD839[\uDCEC-\uDCEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF])*((?:[\0-\u02FF\u0370-\u0482\u048A-\u0590\u05BE\u05C0\u05C3\u05C6\u05C8-\u060F\u061B-\u064A\u0660-\u066F\u0671-\u06D5\u06DD\u06DE\u06E5\u06E6\u06E9\u06EE-\u0710\u0712-\u072F\u074B-\u07A5\u07B1-\u07EA\u07F4-\u07FC\u07FE-\u0815\u081A\u0824\u0828\u082E-\u0858\u085C-\u0897\u08A0-\u08C9\u08E2\u0904-\u0939\u093D\u0950\u0958-\u0961\u0964-\u0980\u0984-\u09BB\u09BD\u09C5\u09C6\u09C9\u09CA\u09CE-\u09D6\u09D8-\u09E1\u09E4-\u09FD\u09FF\u0A00\u0A04-\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A6F\u0A72-\u0A74\u0A76-\u0A80\u0A84-\u0ABB\u0ABD\u0AC6\u0ACA\u0ACE-\u0AE1\u0AE4-\u0AF9\u0B00\u0B04-\u0B3B\u0B3D\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B54\u0B58-\u0B61\u0B64-\u0B81\u0B83-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE-\u0BD6\u0BD8-\u0BFF\u0C05-\u0C3B\u0C3D\u0C45\u0C49\u0C4E-\u0C54\u0C57-\u0C61\u0C64-\u0C80\u0C84-\u0CBB\u0CBD\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CE1\u0CE4-\u0CF2\u0CF4-\u0CFF\u0D04-\u0D3A\u0D3D\u0D45\u0D49\u0D4E-\u0D56\u0D58-\u0D61\u0D64-\u0D80\u0D84-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DF1\u0DF4-\u0E30\u0E32\u0E33\u0E3B-\u0E46\u0E4F-\u0EB0\u0EB2\u0EB3\u0EBD-\u0EC7\u0ECF-\u0F17\u0F1A-\u0F34\u0F36\u0F38\u0F3A-\u0F3D\u0F40-\u0F70\u0F85\u0F88-\u0F8C\u0F98\u0FBD-\u0FC5\u0FC7-\u102A\u103F-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u1090-\u1099\u109E-\u135C\u1360-\u1711\u1716-\u1731\u1735-\u1751\u1754-\u1771\u1774-\u17B3\u17D4-\u17DC\u17DE-\u180A\u180E\u1810-\u1884\u1887-\u18A8\u18AA-\u191F\u192C-\u192F\u193C-\u1A16\u1A1C-\u1A54\u1A5F\u1A7D\u1A7E\u1A80-\u1AAF\u1ACF-\u1AFF\u1B05-\u1B33\u1B45-\u1B6A\u1B74-\u1B7F\u1B83-\u1BA0\u1BAE-\u1BE5\u1BF4-\u1C23\u1C38-\u1CCF\u1CD3\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA-\u1DBF\u1E00-\u20CF\u20F1-\u2CEE\u2CF2-\u2D7E\u2D80-\u2DDF\u2E00-\u3029\u3030-\u3098\u309B-\uA66E\uA673\uA67E-\uA69D\uA6A0-\uA6EF\uA6F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA828-\uA82B\uA82D-\uA87F\uA882-\uA8B3\uA8C6-\uA8DF\uA8F2-\uA8FE\uA900-\uA925\uA92E-\uA946\uA954-\uA97F\uA984-\uA9B2\uA9C1-\uA9E4\uA9E6-\uAA28\uAA37-\uAA42\uAA44-\uAA4B\uAA4E-\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2-\uAAEA\uAAF0-\uAAF4\uAAF7-\uABE2\uABEB\uABEE-\uD7FF\uE000-\uFB1D\uFB1F-\uFDFF\uFE10-\uFE1F\uFE30-\uFFFF]|\uD800[\uDC00-\uDDFC\uDDFE-\uDEDF\uDEE1-\uDF75\uDF7B-\uDFFF]|[\uD801\uD808-\uD80C\uD80E-\uD819\uD81C-\uD82E\uD830-\uD832\uD835\uD837\uD83B-\uDB3F\uDB41-\uDBFF][\uDC00-\uDFFF]|\uD802[\uDC00-\uDE00\uDE04\uDE07-\uDE0B\uDE10-\uDE37\uDE3B-\uDE3E\uDE40-\uDEE4\uDEE7-\uDFFF]|\uD803[\uDC00-\uDD23\uDD28-\uDEAA\uDEAD-\uDEFC\uDF00-\uDF45\uDF51-\uDF81\uDF86-\uDFFF]|\uD804[\uDC03-\uDC37\uDC47-\uDC6F\uDC71\uDC72\uDC75-\uDC7E\uDC83-\uDCAF\uDCBB-\uDCC1\uDCC3-\uDCFF\uDD03-\uDD26\uDD35-\uDD44\uDD47-\uDD72\uDD74-\uDD7F\uDD83-\uDDB2\uDDC1-\uDDC8\uDDCD\uDDD0-\uDE2B\uDE38-\uDE3D\uDE3F\uDE40\uDE42-\uDEDE\uDEEB-\uDEFF\uDF04-\uDF3A\uDF3D\uDF45\uDF46\uDF49\uDF4A\uDF4E-\uDF56\uDF58-\uDF61\uDF64\uDF65\uDF6D-\uDF6F\uDF75-\uDFFF]|\uD805[\uDC00-\uDC34\uDC47-\uDC5D\uDC5F-\uDCAF\uDCC4-\uDDAE\uDDB6\uDDB7\uDDC1-\uDDDB\uDDDE-\uDE2F\uDE41-\uDEAA\uDEB8-\uDF1C\uDF2C-\uDFFF]|\uD806[\uDC00-\uDC2B\uDC3B-\uDD2F\uDD36\uDD39\uDD3A\uDD3F\uDD41\uDD44-\uDDD0\uDDD8\uDDD9\uDDE1-\uDDE3\uDDE5-\uDE00\uDE0B-\uDE32\uDE3A\uDE3F-\uDE46\uDE48-\uDE50\uDE5C-\uDE89\uDE9A-\uDFFF]|\uD807[\uDC00-\uDC2E\uDC37\uDC40-\uDC91\uDCA8\uDCB7-\uDD30\uDD37-\uDD39\uDD3B\uDD3E\uDD46\uDD48-\uDD89\uDD8F\uDD92\uDD98-\uDEF2\uDEF7-\uDEFF\uDF02\uDF04-\uDF33\uDF3B-\uDF3D\uDF43-\uDFFF]|\uD80D[\uDC00-\uDC3F\uDC41-\uDC46\uDC56-\uDFFF]|\uD81A[\uDC00-\uDEEF\uDEF5-\uDF2F\uDF37-\uDFFF]|\uD81B[\uDC00-\uDF4E\uDF50\uDF88-\uDF8E\uDF93-\uDFE3\uDFE5-\uDFEF\uDFF2-\uDFFF]|\uD82F[\uDC00-\uDC9C\uDC9F-\uDFFF]|\uD833[\uDC00-\uDEFF\uDF2E\uDF2F\uDF47-\uDFFF]|\uD834[\uDC00-\uDD64\uDD6A-\uDD6C\uDD73-\uDD7A\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDE41\uDE45-\uDFFF]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85-\uDE9A\uDEA0\uDEB0-\uDFFF]|\uD838[\uDC07\uDC19\uDC1A\uDC22\uDC25\uDC2B-\uDC8E\uDC90-\uDD2F\uDD37-\uDEAD\uDEAF-\uDEEB\uDEF0-\uDFFF]|\uD839[\uDC00-\uDCEB\uDCF0-\uDFFF]|\uD83A[\uDC00-\uDCCF\uDCD7-\uDD43\uDD4B-\uDFFF]|\uDB40[\uDC00-\uDCFF\uDDF0-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))/;

// The range [AC00-D7AF] corresponds to the Hangul syllables.
// The few other chars are some CJK Compatibility Ideographs.
var SYLLABLES_REG_EXP = /[\uAC00-\uD7AF\uFA6C\uFACF-\uFAD1\uFAD5-\uFAD7]+/g;
var SYLLABLES_LENGTHS = new Map();
// When decomposed (in using NFD) the above syllables will start
// with one of the chars in this regexp.
var FIRST_CHAR_SYLLABLES_REG_EXP = "[\\u1100-\\u1112\\ud7a4-\\ud7af\\ud84a\\ud84c\\ud850\\ud854\\ud857\\ud85f]";
var NFKC_CHARS_TO_NORMALIZE = new Map();
var noSyllablesRegExp = null;
var withSyllablesRegExp = null;
function normalize(text) {
  // The diacritics in the text or in the query can be composed or not.
  // So we use a decomposed text using NFD (and the same for the query)
  // in order to be sure that diacritics are in the same order.

  // Collect syllables length and positions.
  var syllablePositions = [];
  var m;
  while ((m = SYLLABLES_REG_EXP.exec(text)) !== null) {
    var _m = m,
      index = _m.index;
    var _iterator = _createForOfIteratorHelper(m[0]),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _char = _step.value;
        var len = SYLLABLES_LENGTHS.get(_char);
        if (!len) {
          len = _char.normalize("NFD").length;
          SYLLABLES_LENGTHS.set(_char, len);
        }
        syllablePositions.push([len, index++]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  var normalizationRegex;
  if (syllablePositions.length === 0 && noSyllablesRegExp) {
    normalizationRegex = noSyllablesRegExp;
  } else if (syllablePositions.length > 0 && withSyllablesRegExp) {
    normalizationRegex = withSyllablesRegExp;
  } else {
    // Compile the regular expression for text normalization once.
    var replace = Object.keys(CHARACTERS_TO_NORMALIZE).join("");
    var toNormalizeWithNFKC = (0, _pdf_find_utils.getNormalizeWithNFKC)();

    // 3040-309F: Hiragana
    // 30A0-30FF: Katakana
    var CJK = "(?:\\p{Ideographic}|[\u3040-\u30FF])";
    var HKDiacritics = "(?:\u3099|\u309A)";
    var regexp = "([".concat(replace, "])|([").concat(toNormalizeWithNFKC, "])|(").concat(HKDiacritics, "\\n)|(\\p{M}+(?:-\\n)?)|(\\S-\\n)|(").concat(CJK, "\\n)|(\\n)");
    if (syllablePositions.length === 0) {
      // Most of the syllables belong to Hangul so there are no need
      // to search for them in a non-Hangul document.
      // We use the \0 in order to have the same number of groups.
      normalizationRegex = noSyllablesRegExp = new RegExp(regexp + "|(\\u0000)", "gum");
    } else {
      normalizationRegex = withSyllablesRegExp = new RegExp(regexp + "|(".concat(FIRST_CHAR_SYLLABLES_REG_EXP, ")"), "gum");
    }
  }

  // The goal of this function is to normalize the string and
  // be able to get from an index in the new string the
  // corresponding index in the old string.
  // For example if we have: abCd12ef456gh where C is replaced by ccc
  // and numbers replaced by nothing (it's the case for diacritics), then
  // we'll obtain the normalized string: abcccdefgh.
  // So here the reverse map is: [0,1,2,2,2,3,6,7,11,12].

  // The goal is to obtain the array: [[0, 0], [3, -1], [4, -2],
  // [6, 0], [8, 3]].
  // which can be used like this:
  //  - let say that i is the index in new string and j the index
  //    the old string.
  //  - if i is in [0; 3[ then j = i + 0
  //  - if i is in [3; 4[ then j = i - 1
  //  - if i is in [4; 6[ then j = i - 2
  //  ...
  // Thanks to a binary search it's easy to know where is i and what's the
  // shift.
  // Let say that the last entry in the array is [x, s] and we have a
  // substitution at index y (old string) which will replace o chars by n chars.
  // Firstly, if o === n, then no need to add a new entry: the shift is
  // the same.
  // Secondly, if o < n, then we push the n - o elements:
  // [y - (s - 1), s - 1], [y - (s - 2), s - 2], ...
  // Thirdly, if o > n, then we push the element: [y - (s - n), o + s - n]

  // Collect diacritics length and positions.
  var rawDiacriticsPositions = [];
  while ((m = DIACRITICS_REG_EXP.exec(text)) !== null) {
    rawDiacriticsPositions.push([m[0].length, m.index]);
  }
  var normalized = text.normalize("NFD");
  var positions = [[0, 0]];
  var rawDiacriticsIndex = 0;
  var syllableIndex = 0;
  var shift = 0;
  var shiftOrigin = 0;
  var eol = 0;
  var hasDiacritics = false;
  normalized = normalized.replace(normalizationRegex, function (match, p1, p2, p3, p4, p5, p6, p7, p8, i) {
    var _syllablePositions$sy;
    i -= shiftOrigin;
    if (p1) {
      // Maybe fractions or quotations mark...
      var replacement = CHARACTERS_TO_NORMALIZE[p1];
      var jj = replacement.length;
      for (var j = 1; j < jj; j++) {
        positions.push([i - shift + j, shift - j]);
      }
      shift -= jj - 1;
      return replacement;
    }
    if (p2) {
      // Use the NFKC representation to normalize the char.
      var _replacement = NFKC_CHARS_TO_NORMALIZE.get(p2);
      if (!_replacement) {
        _replacement = p2.normalize("NFKC");
        NFKC_CHARS_TO_NORMALIZE.set(p2, _replacement);
      }
      var _jj = _replacement.length;
      for (var _j = 1; _j < _jj; _j++) {
        positions.push([i - shift + _j, shift - _j]);
      }
      shift -= _jj - 1;
      return _replacement;
    }
    if (p3) {
      var _rawDiacriticsPositio;
      // We've a Katakana-Hiragana diacritic followed by a \n so don't replace
      // the \n by a whitespace.
      hasDiacritics = true;

      // Diacritic.
      if (i + eol === ((_rawDiacriticsPositio = rawDiacriticsPositions[rawDiacriticsIndex]) === null || _rawDiacriticsPositio === void 0 ? void 0 : _rawDiacriticsPositio[1])) {
        ++rawDiacriticsIndex;
      } else {
        // i is the position of the first diacritic
        // so (i - 1) is the position for the letter before.
        positions.push([i - 1 - shift + 1, shift - 1]);
        shift -= 1;
        shiftOrigin += 1;
      }

      // End-of-line.
      positions.push([i - shift + 1, shift]);
      shiftOrigin += 1;
      eol += 1;
      return p3.charAt(0);
    }
    if (p4) {
      var _rawDiacriticsPositio2;
      var hasTrailingDashEOL = p4.endsWith("\n");
      var _len = hasTrailingDashEOL ? p4.length - 2 : p4.length;

      // Diacritics.
      hasDiacritics = true;
      var _jj2 = _len;
      if (i + eol === ((_rawDiacriticsPositio2 = rawDiacriticsPositions[rawDiacriticsIndex]) === null || _rawDiacriticsPositio2 === void 0 ? void 0 : _rawDiacriticsPositio2[1])) {
        _jj2 -= rawDiacriticsPositions[rawDiacriticsIndex][0];
        ++rawDiacriticsIndex;
      }
      for (var _j2 = 1; _j2 <= _jj2; _j2++) {
        // i is the position of the first diacritic
        // so (i - 1) is the position for the letter before.
        positions.push([i - 1 - shift + _j2, shift - _j2]);
      }
      shift -= _jj2;
      shiftOrigin += _jj2;
      if (hasTrailingDashEOL) {
        // Diacritics are followed by a -\n.
        // See comments in `if (p5)` block.
        i += _len - 1;
        positions.push([i - shift + 1, 1 + shift]);
        shift += 1;
        shiftOrigin += 1;
        eol += 1;
        return p4.slice(0, _len);
      }
      return p4;
    }
    if (p5) {
      // "X-\n" is removed because an hyphen at the end of a line
      // with not a space before is likely here to mark a break
      // in a word.
      // If X is encoded with UTF-32 then it can have a length greater than 1.
      // The \n isn't in the original text so here y = i, n = X.len - 2 and
      // o = X.len - 1.
      var _len2 = p5.length - 2;
      positions.push([i - shift + _len2, 1 + shift]);
      shift += 1;
      shiftOrigin += 1;
      eol += 1;
      return p5.slice(0, -2);
    }
    if (p6) {
      // An ideographic at the end of a line doesn't imply adding an extra
      // white space.
      // A CJK can be encoded in UTF-32, hence their length isn't always 1.
      var _len3 = p6.length - 1;
      positions.push([i - shift + _len3, shift]);
      shiftOrigin += 1;
      eol += 1;
      return p6.slice(0, -1);
    }
    if (p7) {
      // eol is replaced by space: "foo\nbar" is likely equivalent to
      // "foo bar".
      positions.push([i - shift + 1, shift - 1]);
      shift -= 1;
      shiftOrigin += 1;
      eol += 1;
      return " ";
    }

    // p8
    if (i + eol === ((_syllablePositions$sy = syllablePositions[syllableIndex]) === null || _syllablePositions$sy === void 0 ? void 0 : _syllablePositions$sy[1])) {
      // A syllable (1 char) is replaced with several chars (n) so
      // newCharsLen = n - 1.
      var newCharLen = syllablePositions[syllableIndex][0] - 1;
      ++syllableIndex;
      for (var _j3 = 1; _j3 <= newCharLen; _j3++) {
        positions.push([i - (shift - _j3), shift - _j3]);
      }
      shift -= newCharLen;
      shiftOrigin += newCharLen;
    }
    return p8;
  });
  positions.push([normalized.length, shift]);
  return [normalized, positions, hasDiacritics];
}

// Determine the original, non-normalized, match index such that highlighting of
// search results is correct in the `textLayer` for strings containing e.g. "½"
// characters; essentially "inverting" the result of the `normalize` function.
function getOriginalIndex(diffs, pos, len) {
  if (!diffs) {
    return [pos, len];
  }

  // First char in the new string.
  var start = pos;
  // Last char in the new string.
  var end = pos + len - 1;
  var i = (0, _ui_utils.binarySearchFirstItem)(diffs, function (x) {
    return x[0] >= start;
  });
  if (diffs[i][0] > start) {
    --i;
  }
  var j = (0, _ui_utils.binarySearchFirstItem)(diffs, function (x) {
    return x[0] >= end;
  }, i);
  if (diffs[j][0] > end) {
    --j;
  }

  // First char in the old string.
  var oldStart = start + diffs[i][1];

  // Last char in the old string.
  var oldEnd = end + diffs[j][1];
  var oldLen = oldEnd + 1 - oldStart;
  return [oldStart, oldLen];
}

/**
 * @typedef {Object} PDFFindControllerOptions
 * @property {IPDFLinkService} linkService - The navigation/linking service.
 * @property {EventBus} eventBus - The application event bus.
 * @property {boolean} [updateMatchesCountOnProgress] - True if the matches
 *   count must be updated on progress or only when the last page is reached.
 *   The default value is `true`.
 */

/**
 * Provides search functionality to find a given string in a PDF document.
 */
var _state = /*#__PURE__*/new WeakMap();
var _updateMatchesCountOnProgress = /*#__PURE__*/new WeakMap();
var _visitedPagesCount = /*#__PURE__*/new WeakMap();
var _onFind = /*#__PURE__*/new WeakSet();
var _reset = /*#__PURE__*/new WeakSet();
var _query = /*#__PURE__*/new WeakMap();
var _shouldDirtyMatch = /*#__PURE__*/new WeakSet();
var _isEntireWord = /*#__PURE__*/new WeakSet();
var _calculateRegExpMatch = /*#__PURE__*/new WeakSet();
var _convertToRegExpString = /*#__PURE__*/new WeakSet();
var _calculateMatch = /*#__PURE__*/new WeakSet();
var _extractText = /*#__PURE__*/new WeakSet();
var _updatePage = /*#__PURE__*/new WeakSet();
var _updateAllPages = /*#__PURE__*/new WeakSet();
var _nextMatch = /*#__PURE__*/new WeakSet();
var _matchesReady = /*#__PURE__*/new WeakSet();
var _nextPageMatch = /*#__PURE__*/new WeakSet();
var _advanceOffsetPage = /*#__PURE__*/new WeakSet();
var _updateMatch = /*#__PURE__*/new WeakSet();
var _onFindBarClose = /*#__PURE__*/new WeakSet();
var _requestMatchesCount = /*#__PURE__*/new WeakSet();
var _updateUIResultsCount = /*#__PURE__*/new WeakSet();
var _updateUIState = /*#__PURE__*/new WeakSet();
var PDFFindController = exports.PDFFindController = /*#__PURE__*/function () {
  /**
   * @param {PDFFindControllerOptions} options
   */
  function PDFFindController(_ref) {
    var _linkService = _ref.linkService,
      eventBus = _ref.eventBus,
      _ref$updateMatchesCou = _ref.updateMatchesCountOnProgress,
      updateMatchesCountOnProgress = _ref$updateMatchesCou === void 0 ? true : _ref$updateMatchesCou;
    (0, _classCallCheck2["default"])(this, PDFFindController);
    _classPrivateMethodInitSpec(this, _updateUIState);
    _classPrivateMethodInitSpec(this, _updateUIResultsCount);
    _classPrivateMethodInitSpec(this, _requestMatchesCount);
    _classPrivateMethodInitSpec(this, _onFindBarClose);
    _classPrivateMethodInitSpec(this, _updateMatch);
    _classPrivateMethodInitSpec(this, _advanceOffsetPage);
    _classPrivateMethodInitSpec(this, _nextPageMatch);
    _classPrivateMethodInitSpec(this, _matchesReady);
    _classPrivateMethodInitSpec(this, _nextMatch);
    _classPrivateMethodInitSpec(this, _updateAllPages);
    _classPrivateMethodInitSpec(this, _updatePage);
    _classPrivateMethodInitSpec(this, _extractText);
    _classPrivateMethodInitSpec(this, _calculateMatch);
    _classPrivateMethodInitSpec(this, _convertToRegExpString);
    _classPrivateMethodInitSpec(this, _calculateRegExpMatch);
    /**
     * Determine if the search query constitutes a "whole word", by comparing the
     * first/last character type with the preceding/following character type.
     */
    _classPrivateMethodInitSpec(this, _isEntireWord);
    _classPrivateMethodInitSpec(this, _shouldDirtyMatch);
    /**
     * @type {string|Array} The (current) normalized search query.
     */
    _classPrivateFieldInitSpec(this, _query, {
      get: _get_query,
      set: void 0
    });
    _classPrivateMethodInitSpec(this, _reset);
    _classPrivateMethodInitSpec(this, _onFind);
    _classPrivateFieldInitSpec(this, _state, {
      writable: true,
      value: null
    });
    _classPrivateFieldInitSpec(this, _updateMatchesCountOnProgress, {
      writable: true,
      value: true
    });
    _classPrivateFieldInitSpec(this, _visitedPagesCount, {
      writable: true,
      value: 0
    });
    this._linkService = _linkService;
    this._eventBus = eventBus;
    (0, _classPrivateFieldSet2["default"])(this, _updateMatchesCountOnProgress, updateMatchesCountOnProgress);

    /**
     * Callback used to check if a `pageNumber` is currently visible.
     * @type {function}
     */
    this.onIsPageVisible = null;
    _classPrivateMethodGet(this, _reset, _reset2).call(this);
    eventBus._on("find", _classPrivateMethodGet(this, _onFind, _onFind2).bind(this));
    eventBus._on("findbarclose", _classPrivateMethodGet(this, _onFindBarClose, _onFindBarClose2).bind(this));
  }
  (0, _createClass2["default"])(PDFFindController, [{
    key: "highlightMatches",
    get: function get() {
      return this._highlightMatches;
    }
  }, {
    key: "pageMatches",
    get: function get() {
      return this._pageMatches;
    }
  }, {
    key: "pageMatchesLength",
    get: function get() {
      return this._pageMatchesLength;
    }
  }, {
    key: "selected",
    get: function get() {
      return this._selected;
    }
  }, {
    key: "state",
    get: function get() {
      return (0, _classPrivateFieldGet7["default"])(this, _state);
    }

    /**
     * Set a reference to the PDF document in order to search it.
     * Note that searching is not possible if this method is not called.
     *
     * @param {PDFDocumentProxy} pdfDocument - The PDF document to search.
     */
  }, {
    key: "setDocument",
    value: function setDocument(pdfDocument) {
      if (this._pdfDocument) {
        _classPrivateMethodGet(this, _reset, _reset2).call(this);
      }
      if (!pdfDocument) {
        return;
      }
      this._pdfDocument = pdfDocument;
      this._firstPageCapability.resolve();
    }
  }, {
    key: "scrollMatchIntoView",
    value:
    /**
     * @typedef {Object} PDFFindControllerScrollMatchIntoViewParams
     * @property {HTMLElement} element
     * @property {number} selectedLeft
     * @property {number} pageIndex
     * @property {number} matchIndex
     */

    /**
     * Scroll the current match into view.
     * @param {PDFFindControllerScrollMatchIntoViewParams}
     */
    function scrollMatchIntoView(_ref2) {
      var _ref2$element = _ref2.element,
        element = _ref2$element === void 0 ? null : _ref2$element,
        _ref2$selectedLeft = _ref2.selectedLeft,
        selectedLeft = _ref2$selectedLeft === void 0 ? 0 : _ref2$selectedLeft,
        _ref2$pageIndex = _ref2.pageIndex,
        pageIndex = _ref2$pageIndex === void 0 ? -1 : _ref2$pageIndex,
        _ref2$matchIndex = _ref2.matchIndex,
        matchIndex = _ref2$matchIndex === void 0 ? -1 : _ref2$matchIndex;
      if (!this._scrollMatches || !element) {
        return;
      } else if (matchIndex === -1 || matchIndex !== this._selected.matchIdx) {
        return;
      } else if (pageIndex === -1 || pageIndex !== this._selected.pageIdx) {
        return;
      }
      this._scrollMatches = false; // Ensure that scrolling only happens once.

      var spot = {
        top: MATCH_SCROLL_OFFSET_TOP,
        left: selectedLeft + MATCH_SCROLL_OFFSET_LEFT
      };
      (0, _ui_utils.scrollIntoView)(element, spot, /* scrollMatches = */true);
    }
  }]);
  return PDFFindController;
}();
function _onFind2(state) {
  var _this = this;
  if (!state) {
    return;
  }
  if ((typeof PDFJSDev === "undefined" || PDFJSDev.test("GENERIC")) && state.phraseSearch === false) {
    console.error("The `phraseSearch`-parameter was removed, please provide " + "an Array of strings in the `query`-parameter instead.");
    if (typeof state.query === "string") {
      state.query = state.query.match(/\S+/g);
    }
  }
  var pdfDocument = this._pdfDocument;
  var type = state.type;
  if ((0, _classPrivateFieldGet7["default"])(this, _state) === null || _classPrivateMethodGet(this, _shouldDirtyMatch, _shouldDirtyMatch2).call(this, state)) {
    this._dirtyMatch = true;
  }
  (0, _classPrivateFieldSet2["default"])(this, _state, state);
  if (type !== "highlightallchange") {
    _classPrivateMethodGet(this, _updateUIState, _updateUIState2).call(this, FindState.PENDING);
  }
  this._firstPageCapability.promise.then(function () {
    // If the document was closed before searching began, or if the search
    // operation was relevant for a previously opened document, do nothing.
    if (!_this._pdfDocument || pdfDocument && _this._pdfDocument !== pdfDocument) {
      return;
    }
    _classPrivateMethodGet(_this, _extractText, _extractText2).call(_this);
    var findbarClosed = !_this._highlightMatches;
    var pendingTimeout = !!_this._findTimeout;
    if (_this._findTimeout) {
      clearTimeout(_this._findTimeout);
      _this._findTimeout = null;
    }
    if (!type) {
      // Trigger the find action with a small delay to avoid starting the
      // search when the user is still typing (saving resources).
      _this._findTimeout = setTimeout(function () {
        _classPrivateMethodGet(_this, _nextMatch, _nextMatch2).call(_this);
        _this._findTimeout = null;
      }, FIND_TIMEOUT);
    } else if (_this._dirtyMatch) {
      // Immediately trigger searching for non-'find' operations, when the
      // current state needs to be reset and matches re-calculated.
      _classPrivateMethodGet(_this, _nextMatch, _nextMatch2).call(_this);
    } else if (type === "again") {
      _classPrivateMethodGet(_this, _nextMatch, _nextMatch2).call(_this);

      // When the findbar was previously closed, and `highlightAll` is set,
      // ensure that the matches on all active pages are highlighted again.
      if (findbarClosed && (0, _classPrivateFieldGet7["default"])(_this, _state).highlightAll) {
        _classPrivateMethodGet(_this, _updateAllPages, _updateAllPages2).call(_this);
      }
    } else if (type === "highlightallchange") {
      // If there was a pending search operation, synchronously trigger a new
      // search *first* to ensure that the correct matches are highlighted.
      if (pendingTimeout) {
        _classPrivateMethodGet(_this, _nextMatch, _nextMatch2).call(_this);
      } else {
        _this._highlightMatches = true;
      }
      _classPrivateMethodGet(_this, _updateAllPages, _updateAllPages2).call(_this); // Update the highlighting on all active pages.
    } else {
      _classPrivateMethodGet(_this, _nextMatch, _nextMatch2).call(_this);
    }
  });
}
function _reset2() {
  this._highlightMatches = false;
  this._scrollMatches = false;
  this._pdfDocument = null;
  this._pageMatches = [];
  this._pageMatchesLength = [];
  (0, _classPrivateFieldSet2["default"])(this, _visitedPagesCount, 0);
  (0, _classPrivateFieldSet2["default"])(this, _state, null);
  // Currently selected match.
  this._selected = {
    pageIdx: -1,
    matchIdx: -1
  };
  // Where the find algorithm currently is in the document.
  this._offset = {
    pageIdx: null,
    matchIdx: null,
    wrapped: false
  };
  this._extractTextPromises = [];
  this._pageContents = []; // Stores the normalized text for each page.
  this._pageDiffs = [];
  this._hasDiacritics = [];
  this._matchesCountTotal = 0;
  this._pagesToSearch = null;
  this._pendingFindMatches = new Set();
  this._resumePageIdx = null;
  this._dirtyMatch = false;
  clearTimeout(this._findTimeout);
  this._findTimeout = null;
  this._firstPageCapability = new window.pdfjsLib.PromiseCapability();
}
function _get_query() {
  var _classPrivateFieldGet2 = (0, _classPrivateFieldGet7["default"])(this, _state),
    query = _classPrivateFieldGet2.query;
  if (typeof query === "string") {
    if (query !== this._rawQuery) {
      this._rawQuery = query;
      var _normalize = normalize(query);
      var _normalize2 = (0, _slicedToArray2["default"])(_normalize, 1);
      this._normalizedQuery = _normalize2[0];
    }
    return this._normalizedQuery;
  }
  // We don't bother caching the normalized search query in the Array-case,
  // since this code-path is *essentially* unused in the default viewer.
  return (query || []).filter(function (q) {
    return !!q;
  }).map(function (q) {
    return normalize(q)[0];
  });
}
function _shouldDirtyMatch2(state) {
  var _this$onIsPageVisible, _this$onIsPageVisible2;
  // When the search query changes, regardless of the actual search command
  // used, always re-calculate matches to avoid errors (fixes bug 1030622).
  var newQuery = state.query,
    prevQuery = (0, _classPrivateFieldGet7["default"])(this, _state).query;
  var newType = (0, _typeof2["default"])(newQuery),
    prevType = (0, _typeof2["default"])(prevQuery);
  if (newType !== prevType) {
    return true;
  }
  if (newType === "string") {
    if (newQuery !== prevQuery) {
      return true;
    }
  } else {
    // Array
    if (JSON.stringify(newQuery) !== JSON.stringify(prevQuery)) {
      return true;
    }
  }
  switch (state.type) {
    case "again":
      var pageNumber = this._selected.pageIdx + 1;
      var linkService = this._linkService;
      // Only treat a 'findagain' event as a new search operation when it's
      // *absolutely* certain that the currently selected match is no longer
      // visible, e.g. as a result of the user scrolling in the document.
      //
      // NOTE: If only a simple `this._linkService.page` check was used here,
      // there's a risk that consecutive 'findagain' operations could "skip"
      // over matches at the top/bottom of pages thus making them completely
      // inaccessible when there's multiple pages visible in the viewer.
      return pageNumber >= 1 && pageNumber <= linkService.pagesCount && pageNumber !== linkService.page && !((_this$onIsPageVisible = (_this$onIsPageVisible2 = this.onIsPageVisible) === null || _this$onIsPageVisible2 === void 0 ? void 0 : _this$onIsPageVisible2.call(this, pageNumber)) !== null && _this$onIsPageVisible !== void 0 ? _this$onIsPageVisible : true);
    case "highlightallchange":
      return false;
  }
  return true;
}
function _isEntireWord2(content, startIdx, length) {
  var match = content.slice(0, startIdx).match(NOT_DIACRITIC_FROM_END_REG_EXP);
  if (match) {
    var first = content.charCodeAt(startIdx);
    var limit = match[1].charCodeAt(0);
    if ((0, _pdf_find_utils.getCharacterType)(first) === (0, _pdf_find_utils.getCharacterType)(limit)) {
      return false;
    }
  }
  match = content.slice(startIdx + length).match(NOT_DIACRITIC_FROM_START_REG_EXP);
  if (match) {
    var last = content.charCodeAt(startIdx + length - 1);
    var _limit = match[1].charCodeAt(0);
    if ((0, _pdf_find_utils.getCharacterType)(last) === (0, _pdf_find_utils.getCharacterType)(_limit)) {
      return false;
    }
  }
  return true;
}
function _calculateRegExpMatch2(query, entireWord, pageIndex, pageContent) {
  var matches = this._pageMatches[pageIndex] = [];
  var matchesLength = this._pageMatchesLength[pageIndex] = [];
  if (!query) {
    // The query can be empty because some chars like diacritics could have
    // been stripped out.
    return;
  }
  var diffs = this._pageDiffs[pageIndex];
  var match;
  while ((match = query.exec(pageContent)) !== null) {
    if (entireWord && !_classPrivateMethodGet(this, _isEntireWord, _isEntireWord2).call(this, pageContent, match.index, match[0].length)) {
      continue;
    }
    var _getOriginalIndex = getOriginalIndex(diffs, match.index, match[0].length),
      _getOriginalIndex2 = (0, _slicedToArray2["default"])(_getOriginalIndex, 2),
      matchPos = _getOriginalIndex2[0],
      matchLen = _getOriginalIndex2[1];
    if (matchLen) {
      matches.push(matchPos);
      matchesLength.push(matchLen);
    }
  }
}
function _convertToRegExpString2(query, hasDiacritics) {
  var _classPrivateFieldGet3 = (0, _classPrivateFieldGet7["default"])(this, _state),
    matchDiacritics = _classPrivateFieldGet3.matchDiacritics;
  var isUnicode = false;
  query = query.replaceAll(SPECIAL_CHARS_REG_EXP, function (match, p1 /* to escape */, p2 /* punctuation */, p3 /* whitespaces */, p4 /* diacritics */, p5 /* letters */) {
    // We don't need to use a \s for whitespaces since all the different
    // kind of whitespaces are replaced by a single " ".

    if (p1) {
      // Escape characters like *+?... to not interfer with regexp syntax.
      return "[ ]*\\".concat(p1, "[ ]*");
    }
    if (p2) {
      // Allow whitespaces around punctuation signs.
      return "[ ]*".concat(p2, "[ ]*");
    }
    if (p3) {
      // Replace spaces by \s+ to be sure to match any spaces.
      return "[ ]+";
    }
    if (matchDiacritics) {
      return p4 || p5;
    }
    if (p4) {
      // Diacritics are removed with few exceptions.
      return DIACRITICS_EXCEPTION.has(p4.charCodeAt(0)) ? p4 : "";
    }

    // A letter has been matched and it can be followed by any diacritics
    // in normalized text.
    if (hasDiacritics) {
      isUnicode = true;
      return "".concat(p5, "\\p{M}*");
    }
    return p5;
  });
  var trailingSpaces = "[ ]*";
  if (query.endsWith(trailingSpaces)) {
    // The [ ]* has been added in order to help to match "foo . bar" but
    // it doesn't make sense to match some whitespaces after the dot
    // when it's the last character.
    query = query.slice(0, query.length - trailingSpaces.length);
  }
  if (matchDiacritics) {
    // aX must not match aXY.
    if (hasDiacritics) {
      DIACRITICS_EXCEPTION_STR || (DIACRITICS_EXCEPTION_STR = String.fromCharCode.apply(String, (0, _toConsumableArray2["default"])(DIACRITICS_EXCEPTION)));
      isUnicode = true;
      query = "".concat(query, "(?=[").concat(DIACRITICS_EXCEPTION_STR, "]|[^\\p{M}]|$)");
    }
  }
  return [isUnicode, query];
}
function _calculateMatch2(pageIndex) {
  var _this2 = this;
  var _this$visitedPagesCou;
  var query = (0, _classPrivateFieldGet7["default"])(this, _query);
  if (query.length === 0) {
    return; // Do nothing: the matches should be wiped out already.
  }
  var _classPrivateFieldGet4 = (0, _classPrivateFieldGet7["default"])(this, _state),
    caseSensitive = _classPrivateFieldGet4.caseSensitive,
    entireWord = _classPrivateFieldGet4.entireWord;
  var pageContent = this._pageContents[pageIndex];
  var hasDiacritics = this._hasDiacritics[pageIndex];
  var isUnicode = false;
  if (typeof query === "string") {
    var _classPrivateMethodGe = _classPrivateMethodGet(this, _convertToRegExpString, _convertToRegExpString2).call(this, query, hasDiacritics);
    var _classPrivateMethodGe2 = (0, _slicedToArray2["default"])(_classPrivateMethodGe, 2);
    isUnicode = _classPrivateMethodGe2[0];
    query = _classPrivateMethodGe2[1];
  } else {
    // Words are sorted in reverse order to be sure that "foobar" is matched
    // before "foo" in case the query is "foobar foo".
    query = query.sort().reverse().map(function (q) {
      var _classPrivateMethodGe3 = _classPrivateMethodGet(_this2, _convertToRegExpString, _convertToRegExpString2).call(_this2, q, hasDiacritics),
        _classPrivateMethodGe4 = (0, _slicedToArray2["default"])(_classPrivateMethodGe3, 2),
        isUnicodePart = _classPrivateMethodGe4[0],
        queryPart = _classPrivateMethodGe4[1];
      isUnicode || (isUnicode = isUnicodePart);
      return "(".concat(queryPart, ")");
    }).join("|");
  }
  var flags = "g".concat(isUnicode ? "u" : "").concat(caseSensitive ? "" : "i");
  query = query ? new RegExp(query, flags) : null;
  _classPrivateMethodGet(this, _calculateRegExpMatch, _calculateRegExpMatch2).call(this, query, entireWord, pageIndex, pageContent);

  // When `highlightAll` is set, ensure that the matches on previously
  // rendered (and still active) pages are correctly highlighted.
  if ((0, _classPrivateFieldGet7["default"])(this, _state).highlightAll) {
    _classPrivateMethodGet(this, _updatePage, _updatePage2).call(this, pageIndex);
  }
  if (this._resumePageIdx === pageIndex) {
    this._resumePageIdx = null;
    _classPrivateMethodGet(this, _nextPageMatch, _nextPageMatch2).call(this);
  }

  // Update the match count.
  var pageMatchesCount = this._pageMatches[pageIndex].length;
  this._matchesCountTotal += pageMatchesCount;
  if ((0, _classPrivateFieldGet7["default"])(this, _updateMatchesCountOnProgress)) {
    if (pageMatchesCount > 0) {
      _classPrivateMethodGet(this, _updateUIResultsCount, _updateUIResultsCount2).call(this);
    }
  } else if ((0, _classPrivateFieldSet2["default"])(this, _visitedPagesCount, (_this$visitedPagesCou = (0, _classPrivateFieldGet7["default"])(this, _visitedPagesCount), ++_this$visitedPagesCou)) === this._linkService.pagesCount) {
    // For example, in GeckoView we want to have only the final update because
    // the Java side provides only one object to update the counts.
    _classPrivateMethodGet(this, _updateUIResultsCount, _updateUIResultsCount2).call(this);
  }
}
function _extractText2() {
  var _this3 = this;
  // Perform text extraction once if this method is called multiple times.
  if (this._extractTextPromises.length > 0) {
    return;
  }
  var promise = Promise.resolve();
  var textOptions = {
    disableNormalization: true
  };
  var _loop = function _loop(i) {
    var extractTextCapability = new window.pdfjsLib.PromiseCapability();
    _this3._extractTextPromises[i] = extractTextCapability.promise;
    promise = promise.then(function () {
      return _this3._pdfDocument.getPage(i + 1).then(function (pdfPage) {
        return pdfPage.getTextContent(textOptions);
      }).then(function (textContent) {
        var strBuf = [];
        var _iterator2 = _createForOfIteratorHelper(textContent.items),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var textItem = _step2.value;
            strBuf.push(textItem.str);
            if (textItem.hasEOL) {
              strBuf.push("\n");
            }
          }

          // Store the normalized page content (text items) as one string.
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        var _normalize3 = normalize(strBuf.join(""));
        var _normalize4 = (0, _slicedToArray2["default"])(_normalize3, 3);
        _this3._pageContents[i] = _normalize4[0];
        _this3._pageDiffs[i] = _normalize4[1];
        _this3._hasDiacritics[i] = _normalize4[2];
        extractTextCapability.resolve();
      }, function (reason) {
        console.error("Unable to get text content for page ".concat(i + 1), reason);
        // Page error -- assuming no text content.
        _this3._pageContents[i] = "";
        _this3._pageDiffs[i] = null;
        _this3._hasDiacritics[i] = false;
        extractTextCapability.resolve();
      });
    });
  };
  for (var i = 0, ii = this._linkService.pagesCount; i < ii; i++) {
    _loop(i);
  }
}
function _updatePage2(index) {
  if (this._scrollMatches && this._selected.pageIdx === index) {
    // If the page is selected, scroll the page into view, which triggers
    // rendering the page, which adds the text layer. Once the text layer
    // is built, it will attempt to scroll the selected match into view.
    this._linkService.page = index + 1;
  }
  this._eventBus.dispatch("updatetextlayermatches", {
    source: this,
    pageIndex: index
  });
}
function _updateAllPages2() {
  this._eventBus.dispatch("updatetextlayermatches", {
    source: this,
    pageIndex: -1
  });
}
function _nextMatch2() {
  var _this4 = this;
  var previous = (0, _classPrivateFieldGet7["default"])(this, _state).findPrevious;
  var currentPageIndex = this._linkService.page - 1;
  var numPages = this._linkService.pagesCount;
  this._highlightMatches = true;
  if (this._dirtyMatch) {
    // Need to recalculate the matches, reset everything.
    this._dirtyMatch = false;
    this._selected.pageIdx = this._selected.matchIdx = -1;
    this._offset.pageIdx = currentPageIndex;
    this._offset.matchIdx = null;
    this._offset.wrapped = false;
    this._resumePageIdx = null;
    this._pageMatches.length = 0;
    this._pageMatchesLength.length = 0;
    (0, _classPrivateFieldSet2["default"])(this, _visitedPagesCount, 0);
    this._matchesCountTotal = 0;
    _classPrivateMethodGet(this, _updateAllPages, _updateAllPages2).call(this); // Wipe out any previously highlighted matches.
    var _loop2 = function _loop2(i) {
      // Start finding the matches as soon as the text is extracted.
      if (_this4._pendingFindMatches.has(i)) {
        return 1; // continue
      }
      _this4._pendingFindMatches.add(i);
      _this4._extractTextPromises[i].then(function () {
        _this4._pendingFindMatches["delete"](i);
        _classPrivateMethodGet(_this4, _calculateMatch, _calculateMatch2).call(_this4, i);
      });
    };
    for (var i = 0; i < numPages; i++) {
      if (_loop2(i)) continue;
    }
  }

  // If there's no query there's no point in searching.
  var query = (0, _classPrivateFieldGet7["default"])(this, _query);
  if (query.length === 0) {
    _classPrivateMethodGet(this, _updateUIState, _updateUIState2).call(this, FindState.FOUND);
    return;
  }
  // If we're waiting on a page, we return since we can't do anything else.
  if (this._resumePageIdx) {
    return;
  }
  var offset = this._offset;
  // Keep track of how many pages we should maximally iterate through.
  this._pagesToSearch = numPages;
  // If there's already a `matchIdx` that means we are iterating through a
  // page's matches.
  if (offset.matchIdx !== null) {
    var numPageMatches = this._pageMatches[offset.pageIdx].length;
    if (!previous && offset.matchIdx + 1 < numPageMatches || previous && offset.matchIdx > 0) {
      // The simple case; we just have advance the matchIdx to select
      // the next match on the page.
      offset.matchIdx = previous ? offset.matchIdx - 1 : offset.matchIdx + 1;
      _classPrivateMethodGet(this, _updateMatch, _updateMatch2).call(this, /* found = */true);
      return;
    }
    // We went beyond the current page's matches, so we advance to
    // the next page.
    _classPrivateMethodGet(this, _advanceOffsetPage, _advanceOffsetPage2).call(this, previous);
  }
  // Start searching through the page.
  _classPrivateMethodGet(this, _nextPageMatch, _nextPageMatch2).call(this);
}
function _matchesReady2(matches) {
  var offset = this._offset;
  var numMatches = matches.length;
  var previous = (0, _classPrivateFieldGet7["default"])(this, _state).findPrevious;
  if (numMatches) {
    // There were matches for the page, so initialize `matchIdx`.
    offset.matchIdx = previous ? numMatches - 1 : 0;
    _classPrivateMethodGet(this, _updateMatch, _updateMatch2).call(this, /* found = */true);
    return true;
  }
  // No matches, so attempt to search the next page.
  _classPrivateMethodGet(this, _advanceOffsetPage, _advanceOffsetPage2).call(this, previous);
  if (offset.wrapped) {
    offset.matchIdx = null;
    if (this._pagesToSearch < 0) {
      // No point in wrapping again, there were no matches.
      _classPrivateMethodGet(this, _updateMatch, _updateMatch2).call(this, /* found = */false);
      // While matches were not found, searching for a page
      // with matches should nevertheless halt.
      return true;
    }
  }
  // Matches were not found (and searching is not done).
  return false;
}
function _nextPageMatch2() {
  if (this._resumePageIdx !== null) {
    console.error("There can only be one pending page.");
  }
  var matches = null;
  do {
    var pageIdx = this._offset.pageIdx;
    matches = this._pageMatches[pageIdx];
    if (!matches) {
      // The matches don't exist yet for processing by `_matchesReady`,
      // so set a resume point for when they do exist.
      this._resumePageIdx = pageIdx;
      break;
    }
  } while (!_classPrivateMethodGet(this, _matchesReady, _matchesReady2).call(this, matches));
}
function _advanceOffsetPage2(previous) {
  var offset = this._offset;
  var numPages = this._linkService.pagesCount;
  offset.pageIdx = previous ? offset.pageIdx - 1 : offset.pageIdx + 1;
  offset.matchIdx = null;
  this._pagesToSearch--;
  if (offset.pageIdx >= numPages || offset.pageIdx < 0) {
    offset.pageIdx = previous ? numPages - 1 : 0;
    offset.wrapped = true;
  }
}
function _updateMatch2() {
  var found = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var state = FindState.NOT_FOUND;
  var wrapped = this._offset.wrapped;
  this._offset.wrapped = false;
  if (found) {
    var previousPage = this._selected.pageIdx;
    this._selected.pageIdx = this._offset.pageIdx;
    this._selected.matchIdx = this._offset.matchIdx;
    state = wrapped ? FindState.WRAPPED : FindState.FOUND;

    // Update the currently selected page to wipe out any selected matches.
    if (previousPage !== -1 && previousPage !== this._selected.pageIdx) {
      _classPrivateMethodGet(this, _updatePage, _updatePage2).call(this, previousPage);
    }
  }
  _classPrivateMethodGet(this, _updateUIState, _updateUIState2).call(this, state, (0, _classPrivateFieldGet7["default"])(this, _state).findPrevious);
  if (this._selected.pageIdx !== -1) {
    // Ensure that the match will be scrolled into view.
    this._scrollMatches = true;
    _classPrivateMethodGet(this, _updatePage, _updatePage2).call(this, this._selected.pageIdx);
  }
}
function _onFindBarClose2(evt) {
  var _this5 = this;
  var pdfDocument = this._pdfDocument;
  // Since searching is asynchronous, ensure that the removal of highlighted
  // matches (from the UI) is async too such that the 'updatetextlayermatches'
  // events will always be dispatched in the expected order.
  this._firstPageCapability.promise.then(function () {
    // Only update the UI if the document is open, and is the current one.
    if (!_this5._pdfDocument || pdfDocument && _this5._pdfDocument !== pdfDocument) {
      return;
    }
    // Ensure that a pending, not yet started, search operation is aborted.
    if (_this5._findTimeout) {
      clearTimeout(_this5._findTimeout);
      _this5._findTimeout = null;
    }
    // Abort any long running searches, to avoid a match being scrolled into
    // view *after* the findbar has been closed. In this case `this._offset`
    // will most likely differ from `this._selected`, hence we also ensure
    // that any new search operation will always start with a clean slate.
    if (_this5._resumePageIdx) {
      _this5._resumePageIdx = null;
      _this5._dirtyMatch = true;
    }
    // Avoid the UI being in a pending state when the findbar is re-opened.
    _classPrivateMethodGet(_this5, _updateUIState, _updateUIState2).call(_this5, FindState.FOUND);
    _this5._highlightMatches = false;
    _classPrivateMethodGet(_this5, _updateAllPages, _updateAllPages2).call(_this5); // Wipe out any previously highlighted matches.
  });
}
function _requestMatchesCount2() {
  var _this$_selected = this._selected,
    pageIdx = _this$_selected.pageIdx,
    matchIdx = _this$_selected.matchIdx;
  var current = 0,
    total = this._matchesCountTotal;
  if (matchIdx !== -1) {
    for (var i = 0; i < pageIdx; i++) {
      var _this$_pageMatches$i;
      current += ((_this$_pageMatches$i = this._pageMatches[i]) === null || _this$_pageMatches$i === void 0 ? void 0 : _this$_pageMatches$i.length) || 0;
    }
    current += matchIdx + 1;
  }
  // When searching starts, this method may be called before the `pageMatches`
  // have been counted (in `_calculateMatch`). Ensure that the UI won't show
  // temporarily broken state when the active find result doesn't make sense.
  if (current < 1 || current > total) {
    current = total = 0;
  }
  return {
    current: current,
    total: total
  };
}
function _updateUIResultsCount2() {
  this._eventBus.dispatch("updatefindmatchescount", {
    source: this,
    matchesCount: _classPrivateMethodGet(this, _requestMatchesCount, _requestMatchesCount2).call(this)
  });
}
function _updateUIState2(state) {
  var _classPrivateFieldGet5, _classPrivateFieldGet6;
  var previous = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!(0, _classPrivateFieldGet7["default"])(this, _updateMatchesCountOnProgress) && ((0, _classPrivateFieldGet7["default"])(this, _visitedPagesCount) !== this._linkService.pagesCount || state === FindState.PENDING)) {
    // When this.#updateMatchesCountOnProgress is false we only send an update
    // when everything is ready.
    return;
  }
  this._eventBus.dispatch("updatefindcontrolstate", {
    source: this,
    state: state,
    previous: previous,
    matchesCount: _classPrivateMethodGet(this, _requestMatchesCount, _requestMatchesCount2).call(this),
    rawQuery: (_classPrivateFieldGet5 = (_classPrivateFieldGet6 = (0, _classPrivateFieldGet7["default"])(this, _state)) === null || _classPrivateFieldGet6 === void 0 ? void 0 : _classPrivateFieldGet6.query) !== null && _classPrivateFieldGet5 !== void 0 ? _classPrivateFieldGet5 : null
  });
}

},{"1140":1140,"1146":1146,"1175":1175,"1177":1177,"1178":1178,"1179":1179,"1184":1184,"1192":1192,"1194":1194,"1197":1197,"1412":1412,"1415":1415,"1419":1419,"1422":1422,"1423":1423,"1424":1424,"1426":1426,"1428":1428,"1429":1429,"1431":1431,"1437":1437,"1438":1438,"1439":1439,"1443":1443,"1454":1454,"1461":1461,"1463":1463,"1471":1471,"1476":1476,"1477":1477,"1478":1478,"1480":1480,"1482":1482,"1487":1487,"1489":1489,"1492":1492,"1500":1500,"1502":1502,"1503":1503,"1532":1532,"1534":1534,"1536":1536,"1538":1538,"1541":1541}],1534:[function(require,module,exports){
// TODO: Remove this module from `core-js@4` since it's replaced to module below
require(1533);

},{"1533":1533}],1533:[function(require,module,exports){
'use strict';
var collection = require(1237);
var collectionWeak = require(1236);

// `WeakSet` constructor
// https://tc39.es/ecma262/#sec-weakset-constructor
collection('WeakSet', function (init) {
  return function WeakSet() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionWeak);

},{"1236":1236,"1237":1237}],1194:[function(require,module,exports){
var arrayWithoutHoles = require(1170);
var iterableToArray = require(1185);
var unsupportedIterableToArray = require(1198);
var nonIterableSpread = require(1188);
function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"1170":1170,"1185":1185,"1188":1188,"1198":1198}],1188:[function(require,module,exports){
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],1185:[function(require,module,exports){
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],1170:[function(require,module,exports){
var arrayLikeToArray = require(1168);
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"1168":1168}],1146:[function(require,module,exports){
"use strict";

require(1429);
require(1437);
require(1478);
require(1439);
require(1419);
require(1503);
require(1500);
require(1502);
require(1422);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animationStarted = exports.VERTICAL_PADDING = exports.UNKNOWN_SCALE = exports.TextLayerMode = exports.SpreadMode = exports.SidebarView = exports.ScrollMode = exports.SCROLLBAR_PADDING = exports.RenderingStates = exports.ProgressBar = exports.PresentationModeState = exports.OutputScale = exports.MIN_SCALE = exports.MAX_SCALE = exports.MAX_AUTO_SCALE = exports.DEFAULT_SCALE_VALUE = exports.DEFAULT_SCALE_DELTA = exports.DEFAULT_SCALE = exports.CursorTool = exports.AutoPrintRegExp = void 0;
exports.apiPageLayoutToViewerModes = apiPageLayoutToViewerModes;
exports.apiPageModeToSidebarView = apiPageModeToSidebarView;
exports.approximateFraction = approximateFraction;
exports.backtrackBeforeAllVisibleElements = backtrackBeforeAllVisibleElements;
exports.binarySearchFirstItem = binarySearchFirstItem;
exports.docStyle = void 0;
exports.getActiveOrFocusedElement = getActiveOrFocusedElement;
exports.getPageSizeInches = getPageSizeInches;
exports.getVisibleElements = getVisibleElements;
exports.isPortraitOrientation = isPortraitOrientation;
exports.isValidRotation = isValidRotation;
exports.isValidScrollMode = isValidScrollMode;
exports.isValidSpreadMode = isValidSpreadMode;
exports.noContextMenuHandler = noContextMenuHandler;
exports.normalizeWheelEventDelta = normalizeWheelEventDelta;
exports.normalizeWheelEventDirection = normalizeWheelEventDirection;
exports.parseQueryString = parseQueryString;
exports.removeNullCharacters = removeNullCharacters;
exports.roundToDivide = roundToDivide;
exports.scrollIntoView = scrollIntoView;
exports.toggleCheckedBtn = toggleCheckedBtn;
exports.toggleExpandedBtn = toggleExpandedBtn;
exports.watchScroll = watchScroll;
require(1423);
require(1443);
require(1463);
require(1487);
require(1538);
require(1543);
require(1477);
require(1492);
require(1536);
require(1480);
require(1431);
require(1444);
require(1447);
require(1446);
require(1420);
require(1485);
require(1464);
require(1471);
require(1541);
require(1532);
var _classPrivateFieldGet2 = _interopRequireDefault(require(1177));
var _classPrivateFieldSet2 = _interopRequireDefault(require(1178));
var _slicedToArray2 = _interopRequireDefault(require(1192));
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/* Copyright 2012 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var DEFAULT_SCALE_VALUE = exports.DEFAULT_SCALE_VALUE = "auto";
var DEFAULT_SCALE = exports.DEFAULT_SCALE = 1.0;
var DEFAULT_SCALE_DELTA = exports.DEFAULT_SCALE_DELTA = 1.1;
var MIN_SCALE = exports.MIN_SCALE = 0.1;
var MAX_SCALE = exports.MAX_SCALE = 10.0;
var UNKNOWN_SCALE = exports.UNKNOWN_SCALE = 0;
var MAX_AUTO_SCALE = exports.MAX_AUTO_SCALE = 1.25;
var SCROLLBAR_PADDING = exports.SCROLLBAR_PADDING = 40;
var VERTICAL_PADDING = exports.VERTICAL_PADDING = 5;
var RenderingStates = exports.RenderingStates = {
  INITIAL: 0,
  RUNNING: 1,
  PAUSED: 2,
  FINISHED: 3
};
var PresentationModeState = exports.PresentationModeState = {
  UNKNOWN: 0,
  NORMAL: 1,
  CHANGING: 2,
  FULLSCREEN: 3
};
var SidebarView = exports.SidebarView = {
  UNKNOWN: -1,
  NONE: 0,
  THUMBS: 1,
  // Default value.
  OUTLINE: 2,
  ATTACHMENTS: 3,
  LAYERS: 4
};
var TextLayerMode = exports.TextLayerMode = {
  DISABLE: 0,
  ENABLE: 1,
  ENABLE_PERMISSIONS: 2
};
var ScrollMode = exports.ScrollMode = {
  UNKNOWN: -1,
  VERTICAL: 0,
  // Default value.
  HORIZONTAL: 1,
  WRAPPED: 2,
  PAGE: 3
};
var SpreadMode = exports.SpreadMode = {
  UNKNOWN: -1,
  NONE: 0,
  // Default value.
  ODD: 1,
  EVEN: 2
};
var CursorTool = exports.CursorTool = {
  SELECT: 0,
  // The default value.
  HAND: 1,
  ZOOM: 2
};

// Used by `PDFViewerApplication`, and by the API unit-tests.
var AutoPrintRegExp = exports.AutoPrintRegExp = /\bprint\s*\(/;

/**
 * Scale factors for the canvas, necessary with HiDPI displays.
 */
var OutputScale = exports.OutputScale = /*#__PURE__*/function () {
  function OutputScale() {
    (0, _classCallCheck2["default"])(this, OutputScale);
    var pixelRatio = window.devicePixelRatio || 1;

    /**
     * @type {number} Horizontal scale.
     */
    this.sx = pixelRatio;

    /**
     * @type {number} Vertical scale.
     */
    this.sy = pixelRatio;
  }

  /**
   * @type {boolean} Returns `true` when scaling is required, `false` otherwise.
   */
  (0, _createClass2["default"])(OutputScale, [{
    key: "scaled",
    get: function get() {
      return this.sx !== 1 || this.sy !== 1;
    }
  }]);
  return OutputScale;
}();
/**
 * Scrolls specified element into view of its parent.
 * @param {HTMLElement} element - The element to be visible.
 * @param {Object} [spot] - An object with optional top and left properties,
 *   specifying the offset from the top left edge.
 * @param {number} [spot.left]
 * @param {number} [spot.top]
 * @param {boolean} [scrollMatches] - When scrolling search results into view,
 *   ignore elements that either: Contains marked content identifiers,
 *   or have the CSS-rule `overflow: hidden;` set. The default value is `false`.
 */
function scrollIntoView(element, spot) {
  var scrollMatches = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  // Assuming offsetParent is available (it's not available when viewer is in
  // hidden iframe or object). We have to scroll: if the offsetParent is not set
  // producing the error. See also animationStarted.
  var parent = element.offsetParent;
  if (!parent) {
    console.error("offsetParent is not set -- cannot scroll");
    return;
  }
  var offsetY = element.offsetTop + element.clientTop;
  var offsetX = element.offsetLeft + element.clientLeft;
  while (parent.clientHeight === parent.scrollHeight && parent.clientWidth === parent.scrollWidth || scrollMatches && (parent.classList.contains("markedContent") || getComputedStyle(parent).overflow === "hidden")) {
    offsetY += parent.offsetTop;
    offsetX += parent.offsetLeft;
    parent = parent.offsetParent;
    if (!parent) {
      return; // no need to scroll
    }
  }
  if (spot) {
    if (spot.top !== undefined) {
      offsetY += spot.top;
    }
    if (spot.left !== undefined) {
      offsetX += spot.left;
      parent.scrollLeft = offsetX;
    }
  }
  parent.scrollTop = offsetY;
}

/**
 * Helper function to start monitoring the scroll event and converting them into
 * PDF.js friendly one: with scroll debounce and scroll direction.
 */
function watchScroll(viewAreaElement, callback) {
  var debounceScroll = function debounceScroll(evt) {
    if (rAF) {
      return;
    }
    // schedule an invocation of scroll for next animation frame.
    rAF = window.requestAnimationFrame(function viewAreaElementScrolled() {
      rAF = null;
      var currentX = viewAreaElement.scrollLeft;
      var lastX = state.lastX;
      if (currentX !== lastX) {
        state.right = currentX > lastX;
      }
      state.lastX = currentX;
      var currentY = viewAreaElement.scrollTop;
      var lastY = state.lastY;
      if (currentY !== lastY) {
        state.down = currentY > lastY;
      }
      state.lastY = currentY;
      callback(state);
    });
  };
  var state = {
    right: true,
    down: true,
    lastX: viewAreaElement.scrollLeft,
    lastY: viewAreaElement.scrollTop,
    _eventHandler: debounceScroll
  };
  var rAF = null;
  viewAreaElement.addEventListener("scroll", debounceScroll, true);
  return state;
}

/**
 * Helper function to parse query string (e.g. ?param1=value&param2=...).
 * @param {string}
 * @returns {Map}
 */
function parseQueryString(query) {
  var params = new Map();
  var _iterator = _createForOfIteratorHelper(new URLSearchParams(query)),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = (0, _slicedToArray2["default"])(_step.value, 2),
        key = _step$value[0],
        value = _step$value[1];
      params.set(key.toLowerCase(), value);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return params;
}
var InvisibleCharactersRegExp = /[\x01-\x1F]/g;

/**
 * @param {string} str
 * @param {boolean} [replaceInvisible]
 */
function removeNullCharacters(str) {
  var replaceInvisible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (typeof str !== "string") {
    console.error("The argument must be a string.");
    return str;
  }
  if (replaceInvisible) {
    str = str.replaceAll(InvisibleCharactersRegExp, " ");
  }
  return str.replaceAll("\x00", "");
}

/**
 * Use binary search to find the index of the first item in a given array which
 * passes a given condition. The items are expected to be sorted in the sense
 * that if the condition is true for one item in the array, then it is also true
 * for all following items.
 *
 * @returns {number} Index of the first array element to pass the test,
 *                   or |items.length| if no such element exists.
 */
function binarySearchFirstItem(items, condition) {
  var start = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var minIndex = start;
  var maxIndex = items.length - 1;
  if (maxIndex < 0 || !condition(items[maxIndex])) {
    return items.length;
  }
  if (condition(items[minIndex])) {
    return minIndex;
  }
  while (minIndex < maxIndex) {
    var currentIndex = minIndex + maxIndex >> 1;
    var currentItem = items[currentIndex];
    if (condition(currentItem)) {
      maxIndex = currentIndex;
    } else {
      minIndex = currentIndex + 1;
    }
  }
  return minIndex; /* === maxIndex */
}

/**
 *  Approximates float number as a fraction using Farey sequence (max order
 *  of 8).
 *  @param {number} x - Positive float number.
 *  @returns {Array} Estimated fraction: the first array item is a numerator,
 *                   the second one is a denominator.
 */
function approximateFraction(x) {
  // Fast paths for int numbers or their inversions.
  if (Math.floor(x) === x) {
    return [x, 1];
  }
  var xinv = 1 / x;
  var limit = 8;
  if (xinv > limit) {
    return [1, limit];
  } else if (Math.floor(xinv) === xinv) {
    return [1, xinv];
  }
  var x_ = x > 1 ? xinv : x;
  // a/b and c/d are neighbours in Farey sequence.
  var a = 0,
    b = 1,
    c = 1,
    d = 1;
  // Limiting search to order 8.
  while (true) {
    // Generating next term in sequence (order of q).
    var p = a + c,
      q = b + d;
    if (q > limit) {
      break;
    }
    if (x_ <= p / q) {
      c = p;
      d = q;
    } else {
      a = p;
      b = q;
    }
  }
  var result;
  // Select closest of the neighbours to x.
  if (x_ - a / b < c / d - x_) {
    result = x_ === x ? [a, b] : [b, a];
  } else {
    result = x_ === x ? [c, d] : [d, c];
  }
  return result;
}
function roundToDivide(x, div) {
  var r = x % div;
  return r === 0 ? x : Math.round(x - r + div);
}

/**
 * @typedef {Object} GetPageSizeInchesParameters
 * @property {number[]} view
 * @property {number} userUnit
 * @property {number} rotate
 */

/**
 * @typedef {Object} PageSize
 * @property {number} width - In inches.
 * @property {number} height - In inches.
 */

/**
 * Gets the size of the specified page, converted from PDF units to inches.
 * @param {GetPageSizeInchesParameters} params
 * @returns {PageSize}
 */
function getPageSizeInches(_ref) {
  var view = _ref.view,
    userUnit = _ref.userUnit,
    rotate = _ref.rotate;
  var _view = (0, _slicedToArray2["default"])(view, 4),
    x1 = _view[0],
    y1 = _view[1],
    x2 = _view[2],
    y2 = _view[3];
  // We need to take the page rotation into account as well.
  var changeOrientation = rotate % 180 !== 0;
  var width = (x2 - x1) / 72 * userUnit;
  var height = (y2 - y1) / 72 * userUnit;
  return {
    width: changeOrientation ? height : width,
    height: changeOrientation ? width : height
  };
}

/**
 * Helper function for getVisibleElements.
 *
 * @param {number} index - initial guess at the first visible element
 * @param {Array} views - array of pages, into which `index` is an index
 * @param {number} top - the top of the scroll pane
 * @returns {number} less than or equal to `index` that is definitely at or
 *   before the first visible element in `views`, but not by too much. (Usually,
 *   this will be the first element in the first partially visible row in
 *   `views`, although sometimes it goes back one row further.)
 */
function backtrackBeforeAllVisibleElements(index, views, top) {
  // binarySearchFirstItem's assumption is that the input is ordered, with only
  // one index where the conditions flips from false to true: [false ...,
  // true...]. With vertical scrolling and spreads, it is possible to have
  // [false ..., true, false, true ...]. With wrapped scrolling we can have a
  // similar sequence, with many more mixed true and false in the middle.
  //
  // So there is no guarantee that the binary search yields the index of the
  // first visible element. It could have been any of the other visible elements
  // that were preceded by a hidden element.

  // Of course, if either this element or the previous (hidden) element is also
  // the first element, there's nothing to worry about.
  if (index < 2) {
    return index;
  }

  // That aside, the possible cases are represented below.
  //
  //     ****  = fully hidden
  //     A*B*  = mix of partially visible and/or hidden pages
  //     CDEF  = fully visible
  //
  // (1) Binary search could have returned A, in which case we can stop.
  // (2) Binary search could also have returned B, in which case we need to
  // check the whole row.
  // (3) Binary search could also have returned C, in which case we need to
  // check the whole previous row.
  //
  // There's one other possibility:
  //
  //     ****  = fully hidden
  //     ABCD  = mix of fully and/or partially visible pages
  //
  // (4) Binary search could only have returned A.

  // Initially assume that we need to find the beginning of the current row
  // (case 1, 2, or 4), which means finding a page that is above the current
  // page's top. If the found page is partially visible, we're definitely not in
  // case 3, and this assumption is correct.
  var elt = views[index].div;
  var pageTop = elt.offsetTop + elt.clientTop;
  if (pageTop >= top) {
    // The found page is fully visible, so we're actually either in case 3 or 4,
    // and unfortunately we can't tell the difference between them without
    // scanning the entire previous row, so we just conservatively assume that
    // we do need to backtrack to that row. In both cases, the previous page is
    // in the previous row, so use its top instead.
    elt = views[index - 1].div;
    pageTop = elt.offsetTop + elt.clientTop;
  }

  // Now we backtrack to the first page that still has its bottom below
  // `pageTop`, which is the top of a page in the first visible row (unless
  // we're in case 4, in which case it's the row before that).
  // `index` is found by binary search, so the page at `index - 1` is
  // invisible and we can start looking for potentially visible pages from
  // `index - 2`. (However, if this loop terminates on its first iteration,
  // which is the case when pages are stacked vertically, `index` should remain
  // unchanged, so we use a distinct loop variable.)
  for (var i = index - 2; i >= 0; --i) {
    elt = views[i].div;
    if (elt.offsetTop + elt.clientTop + elt.clientHeight <= pageTop) {
      // We have reached the previous row, so stop now.
      // This loop is expected to terminate relatively quickly because the
      // number of pages per row is expected to be small.
      break;
    }
    index = i;
  }
  return index;
}

/**
 * @typedef {Object} GetVisibleElementsParameters
 * @property {HTMLElement} scrollEl - A container that can possibly scroll.
 * @property {Array} views - Objects with a `div` property that contains an
 *   HTMLElement, which should all be descendants of `scrollEl` satisfying the
 *   relevant layout assumptions.
 * @property {boolean} sortByVisibility - If `true`, the returned elements are
 *   sorted in descending order of the percent of their padding box that is
 *   visible. The default value is `false`.
 * @property {boolean} horizontal - If `true`, the elements are assumed to be
 *   laid out horizontally instead of vertically. The default value is `false`.
 * @property {boolean} rtl - If `true`, the `scrollEl` container is assumed to
 *   be in right-to-left mode. The default value is `false`.
 */

/**
 * Generic helper to find out what elements are visible within a scroll pane.
 *
 * Well, pretty generic. There are some assumptions placed on the elements
 * referenced by `views`:
 *   - If `horizontal`, no left of any earlier element is to the right of the
 *     left of any later element.
 *   - Otherwise, `views` can be split into contiguous rows where, within a row,
 *     no top of any element is below the bottom of any other element, and
 *     between rows, no bottom of any element in an earlier row is below the
 *     top of any element in a later row.
 *
 * (Here, top, left, etc. all refer to the padding edge of the element in
 * question. For pages, that ends up being equivalent to the bounding box of the
 * rendering canvas. Earlier and later refer to index in `views`, not page
 * layout.)
 *
 * @param {GetVisibleElementsParameters}
 * @returns {Object} `{ first, last, views: [{ id, x, y, view, percent }] }`
 */
function getVisibleElements(_ref2) {
  var scrollEl = _ref2.scrollEl,
    views = _ref2.views,
    _ref2$sortByVisibilit = _ref2.sortByVisibility,
    sortByVisibility = _ref2$sortByVisibilit === void 0 ? false : _ref2$sortByVisibilit,
    _ref2$horizontal = _ref2.horizontal,
    horizontal = _ref2$horizontal === void 0 ? false : _ref2$horizontal,
    _ref2$rtl = _ref2.rtl,
    rtl = _ref2$rtl === void 0 ? false : _ref2$rtl;
  var top = scrollEl.scrollTop,
    bottom = top + scrollEl.clientHeight;
  var left = scrollEl.scrollLeft,
    right = left + scrollEl.clientWidth;

  // Throughout this "generic" function, comments will assume we're working with
  // PDF document pages, which is the most important and complex case. In this
  // case, the visible elements we're actually interested is the page canvas,
  // which is contained in a wrapper which adds no padding/border/margin, which
  // is itself contained in `view.div` which adds no padding (but does add a
  // border). So, as specified in this function's doc comment, this function
  // does all of its work on the padding edge of the provided views, starting at
  // offsetLeft/Top (which includes margin) and adding clientLeft/Top (which is
  // the border). Adding clientWidth/Height gets us the bottom-right corner of
  // the padding edge.
  function isElementBottomAfterViewTop(view) {
    var element = view.div;
    var elementBottom = element.offsetTop + element.clientTop + element.clientHeight;
    return elementBottom > top;
  }
  function isElementNextAfterViewHorizontally(view) {
    var element = view.div;
    var elementLeft = element.offsetLeft + element.clientLeft;
    var elementRight = elementLeft + element.clientWidth;
    return rtl ? elementLeft < right : elementRight > left;
  }
  var visible = [],
    ids = new Set(),
    numViews = views.length;
  var firstVisibleElementInd = binarySearchFirstItem(views, horizontal ? isElementNextAfterViewHorizontally : isElementBottomAfterViewTop);

  // Please note the return value of the `binarySearchFirstItem` function when
  // no valid element is found (hence the `firstVisibleElementInd` check below).
  if (firstVisibleElementInd > 0 && firstVisibleElementInd < numViews && !horizontal) {
    // In wrapped scrolling (or vertical scrolling with spreads), with some page
    // sizes, isElementBottomAfterViewTop doesn't satisfy the binary search
    // condition: there can be pages with bottoms above the view top between
    // pages with bottoms below. This function detects and corrects that error;
    // see it for more comments.
    firstVisibleElementInd = backtrackBeforeAllVisibleElements(firstVisibleElementInd, views, top);
  }

  // lastEdge acts as a cutoff for us to stop looping, because we know all
  // subsequent pages will be hidden.
  //
  // When using wrapped scrolling or vertical scrolling with spreads, we can't
  // simply stop the first time we reach a page below the bottom of the view;
  // the tops of subsequent pages on the same row could still be visible. In
  // horizontal scrolling, we don't have that issue, so we can stop as soon as
  // we pass `right`, without needing the code below that handles the -1 case.
  var lastEdge = horizontal ? right : -1;
  for (var i = firstVisibleElementInd; i < numViews; i++) {
    var view = views[i],
      element = view.div;
    var currentWidth = element.offsetLeft + element.clientLeft;
    var currentHeight = element.offsetTop + element.clientTop;
    var viewWidth = element.clientWidth,
      viewHeight = element.clientHeight;
    var viewRight = currentWidth + viewWidth;
    var viewBottom = currentHeight + viewHeight;
    if (lastEdge === -1) {
      // As commented above, this is only needed in non-horizontal cases.
      // Setting lastEdge to the bottom of the first page that is partially
      // visible ensures that the next page fully below lastEdge is on the
      // next row, which has to be fully hidden along with all subsequent rows.
      if (viewBottom >= bottom) {
        lastEdge = viewBottom;
      }
    } else if ((horizontal ? currentWidth : currentHeight) > lastEdge) {
      break;
    }
    if (viewBottom <= top || currentHeight >= bottom || viewRight <= left || currentWidth >= right) {
      continue;
    }
    var hiddenHeight = Math.max(0, top - currentHeight) + Math.max(0, viewBottom - bottom);
    var hiddenWidth = Math.max(0, left - currentWidth) + Math.max(0, viewRight - right);
    var fractionHeight = (viewHeight - hiddenHeight) / viewHeight,
      fractionWidth = (viewWidth - hiddenWidth) / viewWidth;
    var percent = fractionHeight * fractionWidth * 100 | 0;
    visible.push({
      id: view.id,
      x: currentWidth,
      y: currentHeight,
      view: view,
      percent: percent,
      widthPercent: fractionWidth * 100 | 0
    });
    ids.add(view.id);
  }
  var first = visible[0],
    last = visible.at(-1);
  if (sortByVisibility) {
    visible.sort(function (a, b) {
      var pc = a.percent - b.percent;
      if (Math.abs(pc) > 0.001) {
        return -pc;
      }
      return a.id - b.id; // ensure stability
    });
  }
  return {
    first: first,
    last: last,
    views: visible,
    ids: ids
  };
}

/**
 * Event handler to suppress context menu.
 */
function noContextMenuHandler(evt) {
  evt.preventDefault();
}
function normalizeWheelEventDirection(evt) {
  var delta = Math.hypot(evt.deltaX, evt.deltaY);
  var angle = Math.atan2(evt.deltaY, evt.deltaX);
  if (-0.25 * Math.PI < angle && angle < 0.75 * Math.PI) {
    // All that is left-up oriented has to change the sign.
    delta = -delta;
  }
  return delta;
}
function normalizeWheelEventDelta(evt) {
  var deltaMode = evt.deltaMode; // Avoid being affected by bug 1392460.
  var delta = normalizeWheelEventDirection(evt);
  var MOUSE_PIXELS_PER_LINE = 30;
  var MOUSE_LINES_PER_PAGE = 30;

  // Converts delta to per-page units
  if (deltaMode === WheelEvent.DOM_DELTA_PIXEL) {
    delta /= MOUSE_PIXELS_PER_LINE * MOUSE_LINES_PER_PAGE;
  } else if (deltaMode === WheelEvent.DOM_DELTA_LINE) {
    delta /= MOUSE_LINES_PER_PAGE;
  }
  return delta;
}
function isValidRotation(angle) {
  return Number.isInteger(angle) && angle % 90 === 0;
}
function isValidScrollMode(mode) {
  return Number.isInteger(mode) && Object.values(ScrollMode).includes(mode) && mode !== ScrollMode.UNKNOWN;
}
function isValidSpreadMode(mode) {
  return Number.isInteger(mode) && Object.values(SpreadMode).includes(mode) && mode !== SpreadMode.UNKNOWN;
}
function isPortraitOrientation(size) {
  return size.width <= size.height;
}

/**
 * Promise that is resolved when DOM window becomes visible.
 */
var animationStarted = exports.animationStarted = new Promise(function (resolve) {
  if (typeof PDFJSDev !== "undefined" && PDFJSDev.test("LIB") && typeof window === "undefined") {
    // Prevent "ReferenceError: window is not defined" errors when running the
    // unit-tests in Node.js environments.
    setTimeout(resolve, 20);
    return;
  }
  window.requestAnimationFrame(resolve);
});
var docStyle = exports.docStyle = typeof PDFJSDev !== "undefined" && PDFJSDev.test("LIB") && typeof document === "undefined" ? null : document.documentElement.style;
function clamp(v, min, max) {
  return Math.min(Math.max(v, min), max);
}
var _classList = /*#__PURE__*/new WeakMap();
var _disableAutoFetchTimeout = /*#__PURE__*/new WeakMap();
var _percent = /*#__PURE__*/new WeakMap();
var _style = /*#__PURE__*/new WeakMap();
var _visible = /*#__PURE__*/new WeakMap();
var ProgressBar = exports.ProgressBar = /*#__PURE__*/function () {
  function ProgressBar(bar) {
    (0, _classCallCheck2["default"])(this, ProgressBar);
    _classPrivateFieldInitSpec(this, _classList, {
      writable: true,
      value: null
    });
    _classPrivateFieldInitSpec(this, _disableAutoFetchTimeout, {
      writable: true,
      value: null
    });
    _classPrivateFieldInitSpec(this, _percent, {
      writable: true,
      value: 0
    });
    _classPrivateFieldInitSpec(this, _style, {
      writable: true,
      value: null
    });
    _classPrivateFieldInitSpec(this, _visible, {
      writable: true,
      value: true
    });
    (0, _classPrivateFieldSet2["default"])(this, _classList, bar.classList);
    (0, _classPrivateFieldSet2["default"])(this, _style, bar.style);
  }
  (0, _createClass2["default"])(ProgressBar, [{
    key: "percent",
    get: function get() {
      return (0, _classPrivateFieldGet2["default"])(this, _percent);
    },
    set: function set(val) {
      (0, _classPrivateFieldSet2["default"])(this, _percent, clamp(val, 0, 100));
      if (isNaN(val)) {
        (0, _classPrivateFieldGet2["default"])(this, _classList).add("indeterminate");
        return;
      }
      (0, _classPrivateFieldGet2["default"])(this, _classList).remove("indeterminate");
      (0, _classPrivateFieldGet2["default"])(this, _style).setProperty("--progressBar-percent", "".concat((0, _classPrivateFieldGet2["default"])(this, _percent), "%"));
    }
  }, {
    key: "setWidth",
    value: function setWidth(viewer) {
      if (!viewer) {
        return;
      }
      var container = viewer.parentNode;
      var scrollbarWidth = container.offsetWidth - viewer.offsetWidth;
      if (scrollbarWidth > 0) {
        (0, _classPrivateFieldGet2["default"])(this, _style).setProperty("--progressBar-end-offset", "".concat(scrollbarWidth, "px"));
      }
    }
  }, {
    key: "setDisableAutoFetch",
    value: function setDisableAutoFetch() {
      var _this = this;
      var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : /* ms = */5000;
      if (isNaN((0, _classPrivateFieldGet2["default"])(this, _percent))) {
        return;
      }
      if ((0, _classPrivateFieldGet2["default"])(this, _disableAutoFetchTimeout)) {
        clearTimeout((0, _classPrivateFieldGet2["default"])(this, _disableAutoFetchTimeout));
      }
      this.show();
      (0, _classPrivateFieldSet2["default"])(this, _disableAutoFetchTimeout, setTimeout(function () {
        (0, _classPrivateFieldSet2["default"])(_this, _disableAutoFetchTimeout, null);
        _this.hide();
      }, delay));
    }
  }, {
    key: "hide",
    value: function hide() {
      if (!(0, _classPrivateFieldGet2["default"])(this, _visible)) {
        return;
      }
      (0, _classPrivateFieldSet2["default"])(this, _visible, false);
      (0, _classPrivateFieldGet2["default"])(this, _classList).add("hidden");
    }
  }, {
    key: "show",
    value: function show() {
      if ((0, _classPrivateFieldGet2["default"])(this, _visible)) {
        return;
      }
      (0, _classPrivateFieldSet2["default"])(this, _visible, true);
      (0, _classPrivateFieldGet2["default"])(this, _classList).remove("hidden");
    }
  }]);
  return ProgressBar;
}();
/**
 * Get the active or focused element in current DOM.
 *
 * Recursively search for the truly active or focused element in case there are
 * shadow DOMs.
 *
 * @returns {Element} the truly active or focused element.
 */
function getActiveOrFocusedElement() {
  var curRoot = document;
  var curActiveOrFocused = curRoot.activeElement || curRoot.querySelector(":focus");
  while ((_curActiveOrFocused = curActiveOrFocused) !== null && _curActiveOrFocused !== void 0 && _curActiveOrFocused.shadowRoot) {
    var _curActiveOrFocused;
    curRoot = curActiveOrFocused.shadowRoot;
    curActiveOrFocused = curRoot.activeElement || curRoot.querySelector(":focus");
  }
  return curActiveOrFocused;
}

/**
 * Converts API PageLayout values to the format used by `BaseViewer`.
 * @param {string} mode - The API PageLayout value.
 * @returns {Object}
 */
function apiPageLayoutToViewerModes(layout) {
  var scrollMode = ScrollMode.VERTICAL,
    spreadMode = SpreadMode.NONE;
  switch (layout) {
    case "SinglePage":
      scrollMode = ScrollMode.PAGE;
      break;
    case "OneColumn":
      break;
    case "TwoPageLeft":
      scrollMode = ScrollMode.PAGE;
    /* falls through */
    case "TwoColumnLeft":
      spreadMode = SpreadMode.ODD;
      break;
    case "TwoPageRight":
      scrollMode = ScrollMode.PAGE;
    /* falls through */
    case "TwoColumnRight":
      spreadMode = SpreadMode.EVEN;
      break;
  }
  return {
    scrollMode: scrollMode,
    spreadMode: spreadMode
  };
}

/**
 * Converts API PageMode values to the format used by `PDFSidebar`.
 * NOTE: There's also a "FullScreen" parameter which is not possible to support,
 *       since the Fullscreen API used in browsers requires that entering
 *       fullscreen mode only occurs as a result of a user-initiated event.
 * @param {string} mode - The API PageMode value.
 * @returns {number} A value from {SidebarView}.
 */
function apiPageModeToSidebarView(mode) {
  switch (mode) {
    case "UseNone":
      return SidebarView.NONE;
    case "UseThumbs":
      return SidebarView.THUMBS;
    case "UseOutlines":
      return SidebarView.OUTLINE;
    case "UseAttachments":
      return SidebarView.ATTACHMENTS;
    case "UseOC":
      return SidebarView.LAYERS;
  }
  return SidebarView.NONE; // Default value.
}
function toggleCheckedBtn(button, toggle) {
  var view = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  button.classList.toggle("toggled", toggle);
  button.setAttribute("aria-checked", toggle);
  view === null || view === void 0 || view.classList.toggle("hidden", !toggle);
}
function toggleExpandedBtn(button, toggle) {
  var view = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  button.classList.toggle("toggled", toggle);
  button.setAttribute("aria-expanded", toggle);
  view === null || view === void 0 || view.classList.toggle("hidden", !toggle);
}

},{"1175":1175,"1177":1177,"1178":1178,"1179":1179,"1184":1184,"1192":1192,"1419":1419,"1420":1420,"1422":1422,"1423":1423,"1429":1429,"1431":1431,"1437":1437,"1439":1439,"1443":1443,"1444":1444,"1446":1446,"1447":1447,"1454":1454,"1463":1463,"1464":1464,"1471":1471,"1477":1477,"1478":1478,"1480":1480,"1485":1485,"1487":1487,"1492":1492,"1500":1500,"1502":1502,"1503":1503,"1532":1532,"1536":1536,"1538":1538,"1541":1541,"1543":1543}],1536:[function(require,module,exports){
// TODO: Remove from `core-js@4`
require(1491);

},{"1491":1491}],1491:[function(require,module,exports){
'use strict';
var $ = require(1270);
var call = require(1278);
var uncurryThis = require(1281);
var requireObjectCoercible = require(1359);
var isCallable = require(1302);
var isNullOrUndefined = require(1306);
var isRegExp = require(1309);
var toString = require(1393);
var getMethod = require(1285);
var getRegExpFlags = require(1355);
var getSubstitution = require(1286);
var wellKnownSymbol = require(1408);
var IS_PURE = require(1308);

var REPLACE = wellKnownSymbol('replace');
var $TypeError = TypeError;
var indexOf = uncurryThis(''.indexOf);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);
var max = Math.max;

var stringIndexOf = function (string, searchValue, fromIndex) {
  if (fromIndex > string.length) return -1;
  if (searchValue === '') return fromIndex;
  return indexOf(string, searchValue, fromIndex);
};

// `String.prototype.replaceAll` method
// https://tc39.es/ecma262/#sec-string.prototype.replaceall
$({ target: 'String', proto: true }, {
  replaceAll: function replaceAll(searchValue, replaceValue) {
    var O = requireObjectCoercible(this);
    var IS_REG_EXP, flags, replacer, string, searchString, functionalReplace, searchLength, advanceBy, replacement;
    var position = 0;
    var endOfLastMatch = 0;
    var result = '';
    if (!isNullOrUndefined(searchValue)) {
      IS_REG_EXP = isRegExp(searchValue);
      if (IS_REG_EXP) {
        flags = toString(requireObjectCoercible(getRegExpFlags(searchValue)));
        if (!~indexOf(flags, 'g')) throw $TypeError('`.replaceAll` does not allow non-global regexes');
      }
      replacer = getMethod(searchValue, REPLACE);
      if (replacer) {
        return call(replacer, searchValue, O, replaceValue);
      } else if (IS_PURE && IS_REG_EXP) {
        return replace(toString(O), searchValue, replaceValue);
      }
    }
    string = toString(O);
    searchString = toString(searchValue);
    functionalReplace = isCallable(replaceValue);
    if (!functionalReplace) replaceValue = toString(replaceValue);
    searchLength = searchString.length;
    advanceBy = max(1, searchLength);
    position = stringIndexOf(string, searchString, 0);
    while (position !== -1) {
      replacement = functionalReplace
        ? toString(replaceValue(searchString, position, string))
        : getSubstitution(searchString, string, position, [], undefined, replaceValue);
      result += stringSlice(string, endOfLastMatch, position) + replacement;
      endOfLastMatch = position + searchLength;
      position = stringIndexOf(string, searchString, position + advanceBy);
    }
    if (endOfLastMatch < string.length) {
      result += stringSlice(string, endOfLastMatch);
    }
    return result;
  }
});

},{"1270":1270,"1278":1278,"1281":1281,"1285":1285,"1286":1286,"1302":1302,"1306":1306,"1308":1308,"1309":1309,"1355":1355,"1359":1359,"1393":1393,"1408":1408}],1485:[function(require,module,exports){
'use strict';
var $ = require(1270);
var uncurryThis = require(1281);
var notARegExp = require(1322);
var requireObjectCoercible = require(1359);
var toString = require(1393);
var correctIsRegExpLogic = require(1239);

var stringIndexOf = uncurryThis(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString(requireObjectCoercible(this)),
      toString(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

},{"1239":1239,"1270":1270,"1281":1281,"1322":1322,"1359":1359,"1393":1393}],1464:[function(require,module,exports){
var $ = require(1270);
var $values = require(1340).values;

// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
$({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});

},{"1270":1270,"1340":1340}],1178:[function(require,module,exports){
var classApplyDescriptorSet = require(1174);
var classExtractFieldDescriptor = require(1176);
function _classPrivateFieldSet(receiver, privateMap, value) {
  var descriptor = classExtractFieldDescriptor(receiver, privateMap, "set");
  classApplyDescriptorSet(receiver, descriptor, value);
  return value;
}
module.exports = _classPrivateFieldSet, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"1174":1174,"1176":1176}],1174:[function(require,module,exports){
function _classApplyDescriptorSet(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
module.exports = _classApplyDescriptorSet, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],1140:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CharacterType = void 0;
exports.getCharacterType = getCharacterType;
exports.getNormalizeWithNFKC = getNormalizeWithNFKC;
require(1477);
require(1412);
require(1424);
/* Copyright 2018 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var CharacterType = exports.CharacterType = {
  SPACE: 0,
  ALPHA_LETTER: 1,
  PUNCT: 2,
  HAN_LETTER: 3,
  KATAKANA_LETTER: 4,
  HIRAGANA_LETTER: 5,
  HALFWIDTH_KATAKANA_LETTER: 6,
  THAI_LETTER: 7
};
function isAlphabeticalScript(charCode) {
  return charCode < 0x2e80;
}
function isAscii(charCode) {
  return (charCode & 0xff80) === 0;
}
function isAsciiAlpha(charCode) {
  return charCode >= /* a = */0x61 && charCode <= /* z = */0x7a || charCode >= /* A = */0x41 && charCode <= /* Z = */0x5a;
}
function isAsciiDigit(charCode) {
  return charCode >= /* 0 = */0x30 && charCode <= /* 9 = */0x39;
}
function isAsciiSpace(charCode) {
  return charCode === /* SPACE = */0x20 || charCode === /* TAB = */0x09 || charCode === /* CR = */0x0d || charCode === /* LF = */0x0a;
}
function isHan(charCode) {
  return charCode >= 0x3400 && charCode <= 0x9fff || charCode >= 0xf900 && charCode <= 0xfaff;
}
function isKatakana(charCode) {
  return charCode >= 0x30a0 && charCode <= 0x30ff;
}
function isHiragana(charCode) {
  return charCode >= 0x3040 && charCode <= 0x309f;
}
function isHalfwidthKatakana(charCode) {
  return charCode >= 0xff60 && charCode <= 0xff9f;
}
function isThai(charCode) {
  return (charCode & 0xff80) === 0x0e00;
}

/**
 * This function is based on the word-break detection implemented in:
 * https://hg.mozilla.org/mozilla-central/file/tip/intl/lwbrk/WordBreaker.cpp
 */
function getCharacterType(charCode) {
  if (isAlphabeticalScript(charCode)) {
    if (isAscii(charCode)) {
      if (isAsciiSpace(charCode)) {
        return CharacterType.SPACE;
      } else if (isAsciiAlpha(charCode) || isAsciiDigit(charCode) || charCode === /* UNDERSCORE = */0x5f) {
        return CharacterType.ALPHA_LETTER;
      }
      return CharacterType.PUNCT;
    } else if (isThai(charCode)) {
      return CharacterType.THAI_LETTER;
    } else if (charCode === /* NBSP = */0xa0) {
      return CharacterType.SPACE;
    }
    return CharacterType.ALPHA_LETTER;
  }
  if (isHan(charCode)) {
    return CharacterType.HAN_LETTER;
  } else if (isKatakana(charCode)) {
    return CharacterType.KATAKANA_LETTER;
  } else if (isHiragana(charCode)) {
    return CharacterType.HIRAGANA_LETTER;
  } else if (isHalfwidthKatakana(charCode)) {
    return CharacterType.HALFWIDTH_KATAKANA_LETTER;
  }
  return CharacterType.ALPHA_LETTER;
}
var NormalizeWithNFKC;
function getNormalizeWithNFKC() {
  /* eslint-disable no-irregular-whitespace */
  NormalizeWithNFKC || (NormalizeWithNFKC = "\xA0\xA8\xAA\xAF\xB2-\xB5\xB8-\xBA\xBC-\xBE\u0132-\u0133\u013F-\u0140\u0149\u017F\u01C4-\u01CC\u01F1-\u01F3\u02B0-\u02B8\u02D8-\u02DD\u02E0-\u02E4\u0374\u037A\u037E\u0384-\u0385\u0387\u03D0-\u03D6\u03F0-\u03F2\u03F4-\u03F5\u03F9\u0587\u0675-\u0678\u0958-\u095F\u09DC-\u09DD\u09DF\u0A33\u0A36\u0A59-\u0A5B\u0A5E\u0B5C-\u0B5D\u0E33\u0EB3\u0EDC-\u0EDD\u0F0C\u0F43\u0F4D\u0F52\u0F57\u0F5C\u0F69\u10FC\u1D2C-\u1D2E\u1D30-\u1D3A\u1D3C-\u1D4D\u1D4F-\u1D6A\u1D78\u1D9B-\u1DBF\u1E9A-\u1E9B\u1F71\u1F73\u1F75\u1F77\u1F79\u1F7B\u1F7D\u1FBB\u1FBD-\u1FC1\u1FC9\u1FCB\u1FCD-\u1FCF\u1FD3\u1FDB\u1FDD-\u1FDF\u1FE3\u1FEB\u1FED-\u1FEF\u1FF9\u1FFB\u1FFD-\u1FFE\u2000-\u200A\u2011\u2017\u2024-\u2026\u202F\u2033-\u2034\u2036-\u2037\u203C\u203E\u2047-\u2049\u2057\u205F\u2070-\u2071\u2074-\u208E\u2090-\u209C\u20A8\u2100-\u2103\u2105-\u2107\u2109-\u2113\u2115-\u2116\u2119-\u211D\u2120-\u2122\u2124\u2126\u2128\u212A-\u212D\u212F-\u2131\u2133-\u2139\u213B-\u2140\u2145-\u2149\u2150-\u217F\u2189\u222C-\u222D\u222F-\u2230\u2329-\u232A\u2460-\u24EA\u2A0C\u2A74-\u2A76\u2ADC\u2C7C-\u2C7D\u2D6F\u2E9F\u2EF3\u2F00-\u2FD5\u3000\u3036\u3038-\u303A\u309B-\u309C\u309F\u30FF\u3131-\u318E\u3192-\u319F\u3200-\u321E\u3220-\u3247\u3250-\u327E\u3280-\u33FF\uA69C-\uA69D\uA770\uA7F2-\uA7F4\uA7F8-\uA7F9\uAB5C-\uAB5F\uAB69\uF900-\uFA0D\uFA10\uFA12\uFA15-\uFA1E\uFA20\uFA22\uFA25-\uFA26\uFA2A-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB36\uFB38-\uFB3C\uFB3E\uFB40-\uFB41\uFB43-\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFC\uFE10-\uFE19\uFE30-\uFE44\uFE47-\uFE52\uFE54-\uFE66\uFE68-\uFE6B\uFE70-\uFE72\uFE74\uFE76-\uFEFC\uFF01-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC\uFFE0-\uFFE6");
  if (typeof PDFJSDev === "undefined" || PDFJSDev.test("TESTING")) {
    var ranges = [];
    var range = [];
    var diacriticsRegex = /^(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C04\u0C3C\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CF3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D81-\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u180F\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ACE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA82C\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDEFD-\uDEFF\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC00-\uDC02\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC82\uDCB0-\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD34\uDD45\uDD46\uDD73\uDD80-\uDD82\uDDB3-\uDDC0\uDDC9-\uDDCC\uDDCE\uDDCF\uDE2C-\uDE37\uDE3E\uDE41\uDEDF-\uDEEA\uDF00-\uDF03\uDF3B\uDF3C\uDF3E-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC35-\uDC46\uDC5E\uDCB0-\uDCC3\uDDAF-\uDDB5\uDDB8-\uDDC0\uDDDC\uDDDD\uDE30-\uDE40\uDEAB-\uDEB7\uDF1D-\uDF2B]|\uD806[\uDC2C-\uDC3A\uDD30-\uDD35\uDD37\uDD38\uDD3B-\uDD3E\uDD40\uDD42\uDD43\uDDD1-\uDDD7\uDDDA-\uDDE0\uDDE4\uDE01-\uDE0A\uDE33-\uDE39\uDE3B-\uDE3E\uDE47\uDE51-\uDE5B\uDE8A-\uDE99]|\uD807[\uDC2F-\uDC36\uDC38-\uDC3F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD8A-\uDD8E\uDD90\uDD91\uDD93-\uDD97\uDEF3-\uDEF6\uDF00\uDF01\uDF03\uDF34-\uDF3A\uDF3E-\uDF42]|\uD80D[\uDC40\uDC47-\uDC55]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF51-\uDF87\uDF8F-\uDF92\uDFE4\uDFF0\uDFF1]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDC8F\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD839[\uDCEC-\uDCEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF])$/;
    // Some chars must be replaced by their NFKC counterpart during a search.
    for (var i = 0; i < 65536; i++) {
      var c = String.fromCharCode(i);
      if (c.normalize("NFKC") !== c && !diacriticsRegex.test(c)) {
        if (range.length !== 2) {
          range[0] = range[1] = i;
          continue;
        }
        if (range[1] + 1 !== i) {
          if (range[0] === range[1]) {
            ranges.push(String.fromCharCode(range[0]));
          } else {
            ranges.push("".concat(String.fromCharCode(range[0]), "-").concat(String.fromCharCode(range[1])));
          }
          range[0] = range[1] = i;
        } else {
          range[1] = i;
        }
      }
    }
    if (ranges.join("") !== NormalizeWithNFKC) {
      throw new Error("getNormalizeWithNFKC - update the `NormalizeWithNFKC` string.");
    }
  }
  return NormalizeWithNFKC;
}

},{"1412":1412,"1424":1424,"1454":1454,"1477":1477}],1138:[function(require,module,exports){
"use strict";

require(1437);
require(1478);
require(1419);
require(1503);
require(1500);
require(1502);
require(1422);
require(1475);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WaitOnType = exports.EventBus = exports.AutomationEventBus = void 0;
exports.waitOnEventOrTimeout = waitOnEventOrTimeout;
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _classPrivateFieldGet3 = _interopRequireDefault(require(1177));
var _typeof2 = _interopRequireDefault(require(1197));
require(1439);
require(1463);
require(1471);
require(1447);
require(1446);
require(1438);
require(1541);
require(1452);
require(1429);
require(1432);
require(1477);
require(1423);
require(1487);
require(1532);
require(1538);
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
/* Copyright 2012 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var WaitOnType = exports.WaitOnType = {
  EVENT: "event",
  TIMEOUT: "timeout"
};

/**
 * @typedef {Object} WaitOnEventOrTimeoutParameters
 * @property {Object} target - The event target, can for example be:
 *   `window`, `document`, a DOM element, or an {EventBus} instance.
 * @property {string} name - The name of the event.
 * @property {number} delay - The delay, in milliseconds, after which the
 *   timeout occurs (if the event wasn't already dispatched).
 */

/**
 * Allows waiting for an event or a timeout, whichever occurs first.
 * Can be used to ensure that an action always occurs, even when an event
 * arrives late or not at all.
 *
 * @param {WaitOnEventOrTimeoutParameters}
 * @returns {Promise} A promise that is resolved with a {WaitOnType} value.
 */
function waitOnEventOrTimeout(_ref) {
  var target = _ref.target,
    name = _ref.name,
    _ref$delay = _ref.delay,
    delay = _ref$delay === void 0 ? 0 : _ref$delay;
  return new Promise(function (resolve, reject) {
    if ((0, _typeof2["default"])(target) !== "object" || !(name && typeof name === "string") || !(Number.isInteger(delay) && delay >= 0)) {
      throw new Error("waitOnEventOrTimeout - invalid parameters.");
    }
    function handler(type) {
      if (target instanceof EventBus) {
        target._off(name, eventHandler);
      } else {
        target.removeEventListener(name, eventHandler);
      }
      if (timeout) {
        clearTimeout(timeout);
      }
      resolve(type);
    }
    var eventHandler = handler.bind(null, WaitOnType.EVENT);
    if (target instanceof EventBus) {
      target._on(name, eventHandler);
    } else {
      target.addEventListener(name, eventHandler);
    }
    var timeoutHandler = handler.bind(null, WaitOnType.TIMEOUT);
    var timeout = setTimeout(timeoutHandler, delay);
  });
}

/**
 * Simple event bus for an application. Listeners are attached using the `on`
 * and `off` methods. To raise an event, the `dispatch` method shall be used.
 */
var _listeners = /*#__PURE__*/new WeakMap();
var EventBus = exports.EventBus = /*#__PURE__*/function () {
  function EventBus() {
    (0, _classCallCheck2["default"])(this, EventBus);
    _classPrivateFieldInitSpec(this, _listeners, {
      writable: true,
      value: Object.create(null)
    });
  }
  (0, _createClass2["default"])(EventBus, [{
    key: "on",
    value:
    /**
     * @param {string} eventName
     * @param {function} listener
     * @param {Object} [options]
     */
    function on(eventName, listener) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      this._on(eventName, listener, {
        external: true,
        once: options === null || options === void 0 ? void 0 : options.once
      });
    }

    /**
     * @param {string} eventName
     * @param {function} listener
     * @param {Object} [options]
     */
  }, {
    key: "off",
    value: function off(eventName, listener) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      this._off(eventName, listener, {
        external: true,
        once: options === null || options === void 0 ? void 0 : options.once
      });
    }

    /**
     * @param {string} eventName
     * @param {Object} data
     */
  }, {
    key: "dispatch",
    value: function dispatch(eventName, data) {
      var eventListeners = (0, _classPrivateFieldGet3["default"])(this, _listeners)[eventName];
      if (!eventListeners || eventListeners.length === 0) {
        return;
      }
      var externalListeners;
      // Making copy of the listeners array in case if it will be modified
      // during dispatch.
      var _iterator = _createForOfIteratorHelper(eventListeners.slice(0)),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _step.value,
            _listener = _step$value.listener,
            external = _step$value.external,
            once = _step$value.once;
          if (once) {
            this._off(eventName, _listener);
          }
          if (external) {
            (externalListeners || (externalListeners = [])).push(_listener);
            continue;
          }
          _listener(data);
        }
        // Dispatch any "external" listeners *after* the internal ones, to give the
        // viewer components time to handle events and update their state first.
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (externalListeners) {
        var _iterator2 = _createForOfIteratorHelper(externalListeners),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var listener = _step2.value;
            listener(data);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        externalListeners = null;
      }
    }

    /**
     * @ignore
     */
  }, {
    key: "_on",
    value: function _on(eventName, listener) {
      var _classPrivateFieldGet2;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var eventListeners = (_classPrivateFieldGet2 = (0, _classPrivateFieldGet3["default"])(this, _listeners))[eventName] || (_classPrivateFieldGet2[eventName] = []);
      eventListeners.push({
        listener: listener,
        external: (options === null || options === void 0 ? void 0 : options.external) === true,
        once: (options === null || options === void 0 ? void 0 : options.once) === true
      });
    }

    /**
     * @ignore
     */
  }, {
    key: "_off",
    value: function _off(eventName, listener) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var eventListeners = (0, _classPrivateFieldGet3["default"])(this, _listeners)[eventName];
      if (!eventListeners) {
        return;
      }
      for (var i = 0, ii = eventListeners.length; i < ii; i++) {
        if (eventListeners[i].listener === listener) {
          eventListeners.splice(i, 1);
          return;
        }
      }
    }
  }]);
  return EventBus;
}();
/**
 * NOTE: Only used to support various PDF viewer tests in `mozilla-central`.
 */
var AutomationEventBus = exports.AutomationEventBus = /*#__PURE__*/function (_EventBus2) {
  (0, _inherits2["default"])(AutomationEventBus, _EventBus2);
  function AutomationEventBus() {
    (0, _classCallCheck2["default"])(this, AutomationEventBus);
    return _callSuper(this, AutomationEventBus, arguments);
  }
  (0, _createClass2["default"])(AutomationEventBus, [{
    key: "dispatch",
    value: function dispatch(eventName, data) {
      if (typeof PDFJSDev !== "undefined" && !PDFJSDev.test("MOZCENTRAL")) {
        throw new Error("Not implemented: AutomationEventBus.dispatch");
      }
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(AutomationEventBus.prototype), "dispatch", this).call(this, eventName, data);
      var detail = Object.create(null);
      if (data) {
        for (var key in data) {
          var value = data[key];
          if (key === "source") {
            if (value === window || value === document) {
              return; // No need to re-dispatch (already) global events.
            }
            continue; // Ignore the `source` property.
          }
          detail[key] = value;
        }
      }
      var event = new CustomEvent(eventName, {
        bubbles: true,
        cancelable: true,
        detail: detail
      });
      document.dispatchEvent(event);
    }
  }]);
  return AutomationEventBus;
}(EventBus);

},{"1175":1175,"1177":1177,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1197":1197,"1419":1419,"1422":1422,"1423":1423,"1429":1429,"1432":1432,"1437":1437,"1438":1438,"1439":1439,"1446":1446,"1447":1447,"1452":1452,"1454":1454,"1463":1463,"1471":1471,"1475":1475,"1477":1477,"1478":1478,"1487":1487,"1500":1500,"1502":1502,"1503":1503,"1532":1532,"1538":1538,"1541":1541}],1532:[function(require,module,exports){
// TODO: Remove this module from `core-js@4` since it's replaced to module below
require(1531);

},{"1531":1531}],1531:[function(require,module,exports){
'use strict';
var global = require(1287);
var uncurryThis = require(1281);
var defineBuiltIns = require(1248);
var InternalMetadataModule = require(1297);
var collection = require(1237);
var collectionWeak = require(1236);
var isObject = require(1307);
var isExtensible = require(1334);
var enforceInternalState = require(1298).enforce;
var NATIVE_WEAK_MAP = require(1405);

var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var InternalWeakMap;

var wrapper = function (init) {
  return function WeakMap() {
    return init(this, arguments.length ? arguments[0] : undefined);
  };
};

// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $WeakMap = collection('WeakMap', wrapper, collectionWeak);

// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
  InternalMetadataModule.enable();
  var WeakMapPrototype = $WeakMap.prototype;
  var nativeDelete = uncurryThis(WeakMapPrototype['delete']);
  var nativeHas = uncurryThis(WeakMapPrototype.has);
  var nativeGet = uncurryThis(WeakMapPrototype.get);
  var nativeSet = uncurryThis(WeakMapPrototype.set);
  defineBuiltIns(WeakMapPrototype, {
    'delete': function (key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeDelete(this, key) || state.frozen['delete'](key);
      } return nativeDelete(this, key);
    },
    has: function has(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas(this, key) || state.frozen.has(key);
      } return nativeHas(this, key);
    },
    get: function get(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas(this, key) ? nativeGet(this, key) : state.frozen.get(key);
      } return nativeGet(this, key);
    },
    set: function set(key, value) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        nativeHas(this, key) ? nativeSet(this, key, value) : state.frozen.set(key, value);
      } else nativeSet(this, key, value);
      return this;
    }
  });
}

},{"1236":1236,"1237":1237,"1248":1248,"1281":1281,"1287":1287,"1297":1297,"1298":1298,"1307":1307,"1334":1334,"1405":1405}],1236:[function(require,module,exports){
'use strict';
var uncurryThis = require(1281);
var defineBuiltIns = require(1248);
var getWeakData = require(1297).getWeakData;
var anInstance = require(1208);
var anObject = require(1209);
var isNullOrUndefined = require(1306);
var isObject = require(1307);
var iterate = require(1311);
var ArrayIterationModule = require(1220);
var hasOwn = require(1288);
var InternalStateModule = require(1298);

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;
var find = ArrayIterationModule.find;
var findIndex = ArrayIterationModule.findIndex;
var splice = uncurryThis([].splice);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (store) {
  return store.frozen || (store.frozen = new UncaughtFrozenStore());
};

var UncaughtFrozenStore = function () {
  this.entries = [];
};

var findUncaughtFrozen = function (store, key) {
  return find(store.entries, function (it) {
    return it[0] === key;
  });
};

UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.entries.push([key, value]);
  },
  'delete': function (key) {
    var index = findIndex(this.entries, function (it) {
      return it[0] === key;
    });
    if (~index) splice(this.entries, index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor = wrapper(function (that, iterable) {
      anInstance(that, Prototype);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        id: id++,
        frozen: undefined
      });
      if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var Prototype = Constructor.prototype;

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var data = getWeakData(anObject(key), true);
      if (data === true) uncaughtFrozenStore(state).set(key, value);
      else data[state.id] = value;
      return that;
    };

    defineBuiltIns(Prototype, {
      // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
      // https://tc39.es/ecma262/#sec-weakset.prototype.delete
      'delete': function (key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state)['delete'](key);
        return data && hasOwn(data, state.id) && delete data[state.id];
      },
      // `{ WeakMap, WeakSet }.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.has
      // https://tc39.es/ecma262/#sec-weakset.prototype.has
      has: function has(key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state).has(key);
        return data && hasOwn(data, state.id);
      }
    });

    defineBuiltIns(Prototype, IS_MAP ? {
      // `WeakMap.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.get
      get: function get(key) {
        var state = getInternalState(this);
        if (isObject(key)) {
          var data = getWeakData(key);
          if (data === true) return uncaughtFrozenStore(state).get(key);
          return data ? data[state.id] : undefined;
        }
      },
      // `WeakMap.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.set
      set: function set(key, value) {
        return define(this, key, value);
      }
    } : {
      // `WeakSet.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-weakset.prototype.add
      add: function add(value) {
        return define(this, value, true);
      }
    });

    return Constructor;
  }
};

},{"1208":1208,"1209":1209,"1220":1220,"1248":1248,"1281":1281,"1288":1288,"1297":1297,"1298":1298,"1306":1306,"1307":1307,"1311":1311}],1177:[function(require,module,exports){
var classApplyDescriptorGet = require(1173);
var classExtractFieldDescriptor = require(1176);
function _classPrivateFieldGet(receiver, privateMap) {
  var descriptor = classExtractFieldDescriptor(receiver, privateMap, "get");
  return classApplyDescriptorGet(receiver, descriptor);
}
module.exports = _classPrivateFieldGet, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"1173":1173,"1176":1176}],1176:[function(require,module,exports){
function _classExtractFieldDescriptor(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
module.exports = _classExtractFieldDescriptor, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],1173:[function(require,module,exports){
function _classApplyDescriptorGet(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
module.exports = _classApplyDescriptorGet, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],1136:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compatibilityParams = exports.OptionKind = exports.AppOptions = void 0;
var _typeof2 = _interopRequireDefault(require(1197));
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
require(1452);
require(1477);
require(1535);
require(1447);
require(1446);
require(1461);
/* Copyright 2018 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var compatibilityParams = exports.compatibilityParams = Object.create(null);
if (typeof PDFJSDev === "undefined" || PDFJSDev.test("GENERIC")) {
  if (typeof PDFJSDev !== "undefined" && PDFJSDev.test("LIB") && typeof navigator === "undefined") {
    globalThis.navigator = Object.create(null);
  }
  var userAgent = navigator.userAgent || "";
  var platform = navigator.platform || "";
  var maxTouchPoints = navigator.maxTouchPoints || 1;
  var isAndroid = /Android/.test(userAgent);
  var isIOS = /\b(iPad|iPhone|iPod)(?=;)/.test(userAgent) || platform === "MacIntel" && maxTouchPoints > 1;

  // Limit canvas size to 5 mega-pixels on mobile.
  // Support: Android, iOS
  (function checkCanvasSizeLimitation() {
    if (isIOS || isAndroid) {
      compatibilityParams.maxCanvasPixels = 5242880;
    }
  })();
}
var OptionKind = exports.OptionKind = {
  VIEWER: 0x02,
  API: 0x04,
  WORKER: 0x08,
  PREFERENCE: 0x80
};

/**
 * NOTE: These options are used to generate the `default_preferences.json` file,
 *       see `OptionKind.PREFERENCE`, hence the values below must use only
 *       primitive types and cannot rely on any imported types.
 */
var defaultOptions = {
  annotationEditorMode: {
    /** @type {number} */
    value: 0,
    kind: OptionKind.VIEWER + OptionKind.PREFERENCE
  },
  annotationMode: {
    /** @type {number} */
    value: 2,
    kind: OptionKind.VIEWER + OptionKind.PREFERENCE
  },
  cursorToolOnLoad: {
    /** @type {number} */
    value: 0,
    kind: OptionKind.VIEWER + OptionKind.PREFERENCE
  },
  defaultZoomDelay: {
    /** @type {number} */
    value: 400,
    kind: OptionKind.VIEWER + OptionKind.PREFERENCE
  },
  defaultZoomValue: {
    /** @type {string} */
    value: "",
    kind: OptionKind.VIEWER + OptionKind.PREFERENCE
  },
  disableHistory: {
    /** @type {boolean} */
    value: false,
    kind: OptionKind.VIEWER
  },
  disablePageLabels: {
    /** @type {boolean} */
    value: false,
    kind: OptionKind.VIEWER + OptionKind.PREFERENCE
  },
  enablePermissions: {
    /** @type {boolean} */
    value: false,
    kind: OptionKind.VIEWER + OptionKind.PREFERENCE
  },
  enablePrintAutoRotate: {
    /** @type {boolean} */
    value: true,
    kind: OptionKind.VIEWER + OptionKind.PREFERENCE
  },
  enableScripting: {
    /** @type {boolean} */
    value: typeof PDFJSDev === "undefined" || !PDFJSDev.test("CHROME"),
    kind: OptionKind.VIEWER + OptionKind.PREFERENCE
  },
  externalLinkRel: {
    /** @type {string} */
    value: "noopener noreferrer nofollow",
    kind: OptionKind.VIEWER
  },
  externalLinkTarget: {
    /** @type {number} */
    value: 0,
    kind: OptionKind.VIEWER + OptionKind.PREFERENCE
  },
  historyUpdateUrl: {
    /** @type {boolean} */
    value: false,
    kind: OptionKind.VIEWER + OptionKind.PREFERENCE
  },
  ignoreDestinationZoom: {
    /** @type {boolean} */
    value: false,
    kind: OptionKind.VIEWER + OptionKind.PREFERENCE
  },
  imageResourcesPath: {
    /** @type {string} */
    value: typeof PDFJSDev !== "undefined" && PDFJSDev.test("MOZCENTRAL") ? "resource://pdf.js/web/images/" : "./images/",
    kind: OptionKind.VIEWER
  },
  maxCanvasPixels: {
    /** @type {number} */
    value: 16777216,
    kind: OptionKind.VIEWER
  },
  forcePageColors: {
    /** @type {boolean} */
    value: false,
    kind: OptionKind.VIEWER + OptionKind.PREFERENCE
  },
  pageColorsBackground: {
    /** @type {string} */
    value: "Canvas",
    kind: OptionKind.VIEWER + OptionKind.PREFERENCE
  },
  pageColorsForeground: {
    /** @type {string} */
    value: "CanvasText",
    kind: OptionKind.VIEWER + OptionKind.PREFERENCE
  },
  pdfBugEnabled: {
    /** @type {boolean} */
    value: typeof PDFJSDev === "undefined",
    kind: OptionKind.VIEWER + OptionKind.PREFERENCE
  },
  printResolution: {
    /** @type {number} */
    value: 150,
    kind: OptionKind.VIEWER
  },
  sidebarViewOnLoad: {
    /** @type {number} */
    value: -1,
    kind: OptionKind.VIEWER + OptionKind.PREFERENCE
  },
  scrollModeOnLoad: {
    /** @type {number} */
    value: -1,
    kind: OptionKind.VIEWER + OptionKind.PREFERENCE
  },
  spreadModeOnLoad: {
    /** @type {number} */
    value: -1,
    kind: OptionKind.VIEWER + OptionKind.PREFERENCE
  },
  textLayerMode: {
    /** @type {number} */
    value: 1,
    kind: OptionKind.VIEWER + OptionKind.PREFERENCE
  },
  useOnlyCssZoom: {
    /** @type {boolean} */
    value: false,
    kind: OptionKind.VIEWER + OptionKind.PREFERENCE
  },
  viewerCssTheme: {
    /** @type {number} */
    value: typeof PDFJSDev !== "undefined" && PDFJSDev.test("CHROME") ? 2 : 0,
    kind: OptionKind.VIEWER + OptionKind.PREFERENCE
  },
  viewOnLoad: {
    /** @type {boolean} */
    value: 0,
    kind: OptionKind.VIEWER + OptionKind.PREFERENCE
  },
  cMapPacked: {
    /** @type {boolean} */
    value: true,
    kind: OptionKind.API
  },
  cMapUrl: {
    /** @type {string} */
    value:
    // eslint-disable-next-line no-nested-ternary
    typeof PDFJSDev === "undefined" ? "../external/bcmaps/" : PDFJSDev.test("MOZCENTRAL") ? "resource://pdf.js/web/cmaps/" : "../web/cmaps/",
    kind: OptionKind.API
  },
  disableAutoFetch: {
    /** @type {boolean} */
    value: false,
    kind: OptionKind.API + OptionKind.PREFERENCE
  },
  disableFontFace: {
    /** @type {boolean} */
    value: false,
    kind: OptionKind.API + OptionKind.PREFERENCE
  },
  disableRange: {
    /** @type {boolean} */
    value: false,
    kind: OptionKind.API + OptionKind.PREFERENCE
  },
  disableStream: {
    /** @type {boolean} */
    value: false,
    kind: OptionKind.API + OptionKind.PREFERENCE
  },
  docBaseUrl: {
    /** @type {string} */
    value: "",
    kind: OptionKind.API
  },
  enableXfa: {
    /** @type {boolean} */
    value: true,
    kind: OptionKind.API + OptionKind.PREFERENCE
  },
  fontExtraProperties: {
    /** @type {boolean} */
    value: false,
    kind: OptionKind.API
  },
  isEvalSupported: {
    /** @type {boolean} */
    value: true,
    kind: OptionKind.API
  },
  isOffscreenCanvasSupported: {
    /** @type {boolean} */
    value: true,
    kind: OptionKind.API
  },
  maxImageSize: {
    /** @type {number} */
    value: -1,
    kind: OptionKind.API
  },
  pdfBug: {
    /** @type {boolean} */
    value: false,
    kind: OptionKind.API
  },
  standardFontDataUrl: {
    /** @type {string} */
    value:
    // eslint-disable-next-line no-nested-ternary
    typeof PDFJSDev === "undefined" ? "../external/standard_fonts/" : PDFJSDev.test("MOZCENTRAL") ? "resource://pdf.js/web/standard_fonts/" : "../web/standard_fonts/",
    kind: OptionKind.API
  },
  verbosity: {
    /** @type {number} */
    value: 1,
    kind: OptionKind.API
  },
  workerPort: {
    /** @type {Object} */
    value: null,
    kind: OptionKind.WORKER
  },
  workerSrc: {
    /** @type {string} */
    value:
    // eslint-disable-next-line no-nested-ternary
    typeof PDFJSDev === "undefined" ? "../src/pdf.worker.js" : PDFJSDev.test("MOZCENTRAL") ? "resource://pdf.js/build/pdf.worker.js" : "../build/pdf.worker.js",
    kind: OptionKind.WORKER
  }
};
if (typeof PDFJSDev === "undefined" || PDFJSDev.test("GENERIC")) {
  defaultOptions.defaultUrl = {
    /** @type {string} */
    value: "compressed.tracemonkey-pldi-09.pdf",
    kind: OptionKind.VIEWER
  };
  defaultOptions.disablePreferences = {
    /** @type {boolean} */
    value: typeof PDFJSDev !== "undefined" && PDFJSDev.test("TESTING"),
    kind: OptionKind.VIEWER
  };
  defaultOptions.locale = {
    /** @type {string} */
    value: navigator.language || "en-US",
    kind: OptionKind.VIEWER
  };
  defaultOptions.sandboxBundleSrc = {
    /** @type {string} */
    value: typeof PDFJSDev === "undefined" ? "../build/dev-sandbox/pdf.sandbox.js" : "../build/pdf.sandbox.js",
    kind: OptionKind.VIEWER
  };
} else if (PDFJSDev.test("CHROME")) {
  defaultOptions.defaultUrl = {
    /** @type {string} */
    value: "",
    kind: OptionKind.VIEWER
  };
  defaultOptions.disableTelemetry = {
    /** @type {boolean} */
    value: false,
    kind: OptionKind.VIEWER + OptionKind.PREFERENCE
  };
  defaultOptions.sandboxBundleSrc = {
    /** @type {string} */
    value: "../build/pdf.sandbox.js",
    kind: OptionKind.VIEWER
  };
}
var userOptions = Object.create(null);
var AppOptions = exports.AppOptions = /*#__PURE__*/function () {
  function AppOptions() {
    (0, _classCallCheck2["default"])(this, AppOptions);
    throw new Error("Cannot initialize AppOptions.");
  }
  (0, _createClass2["default"])(AppOptions, null, [{
    key: "get",
    value: function get(name) {
      var userOption = userOptions[name];
      if (userOption !== undefined) {
        return userOption;
      }
      var defaultOption = defaultOptions[name];
      if (defaultOption !== undefined) {
        var _compatibilityParams$;
        return (_compatibilityParams$ = compatibilityParams[name]) !== null && _compatibilityParams$ !== void 0 ? _compatibilityParams$ : defaultOption.value;
      }
      return undefined;
    }
  }, {
    key: "getAll",
    value: function getAll() {
      var kind = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var options = Object.create(null);
      for (var name in defaultOptions) {
        var _compatibilityParams$2;
        var defaultOption = defaultOptions[name];
        if (kind) {
          if ((kind & defaultOption.kind) === 0) {
            continue;
          }
          if (kind === OptionKind.PREFERENCE) {
            var value = defaultOption.value,
              valueType = (0, _typeof2["default"])(value);
            if (valueType === "boolean" || valueType === "string" || valueType === "number" && Number.isInteger(value)) {
              options[name] = value;
              continue;
            }
            throw new Error("Invalid type for preference: ".concat(name));
          }
        }
        var userOption = userOptions[name];
        options[name] = userOption !== undefined ? userOption : (_compatibilityParams$2 = compatibilityParams[name]) !== null && _compatibilityParams$2 !== void 0 ? _compatibilityParams$2 : defaultOption.value;
      }
      return options;
    }
  }, {
    key: "set",
    value: function set(name, value) {
      userOptions[name] = value;
    }
  }, {
    key: "setAll",
    value: function setAll(options) {
      for (var name in options) {
        userOptions[name] = options[name];
      }
    }
  }, {
    key: "remove",
    value: function remove(name) {
      delete userOptions[name];
    }
  }]);
  return AppOptions;
}();
if (typeof PDFJSDev === "undefined" || PDFJSDev.test("GENERIC")) {
  AppOptions._hasUserOptions = function () {
    return Object.keys(userOptions).length > 0;
  };
}

},{"1175":1175,"1179":1179,"1184":1184,"1197":1197,"1446":1446,"1447":1447,"1452":1452,"1454":1454,"1461":1461,"1477":1477,"1535":1535}],1535:[function(require,module,exports){
// TODO: Remove from `core-js@4`
require(1440);

},{"1440":1440}],1440:[function(require,module,exports){
var $ = require(1270);
var global = require(1287);

// `globalThis` object
// https://tc39.es/ecma262/#sec-globalthis
$({ global: true, forced: global.globalThis !== global }, {
  globalThis: global
});

},{"1270":1270,"1287":1287}],1447:[function(require,module,exports){
var $ = require(1270);
var isIntegralNumber = require(1305);

// `Number.isInteger` method
// https://tc39.es/ecma262/#sec-number.isinteger
$({ target: 'Number', stat: true }, {
  isInteger: isIntegralNumber
});

},{"1270":1270,"1305":1305}],1034:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
var _MMObject = _interopRequireDefault(require(1081));
var _ObjType = _interopRequireDefault(require(1084));
var _MMRect = _interopRequireDefault(require(831));
var _Encoder = _interopRequireDefault(require(800));
var _Decoder = _interopRequireDefault(require(799));
/*
oPoint(x,y)  w
|-------->  signX = 1 ( 1 or -1)
| 
h| 
V                   tPoint(oPoint.x-h)
signY = 1 ( 1 or -1)
*/
function MMWeldMark(board, ver) {
  _MMObject["default"].call(this, board, ver);
  this.m_className = 'MMWeldMark';
  this.m_objType = _ObjType["default"].Obj_weldMark;
  this.m_expandRect = null;
  /*
  \											F
   \									-----           // c
  	\										A				
  	 \									R	
  	  \				S(E)		sign 		L-P	  	 
  	T  》————————————————————————————————————
  			 - - - - - - - - - - - - - - - - - - \
  	  / 																			\
  	 /																				 \
  	/  	 																				\-->	
   /  
  /
  
  */

  this.objData = {
    oPoint: {
      x: 0,
      y: 0
    },
    //原点逻辑坐标
    tPoint: {
      w: 100,
      h: 100
    },
    // 第二个控制点相对原点的偏移值
    dirObj: {
      signX: 1,
      signY: 1
    },
    // 第二个控制点的坐标系所在象限
    state: 'done',
    //'done'： 正常状态, 'translate': 变形状态, 'move': 移动状态
    // imgId: '0',
    active: false,
    solidSide: {
      SE: '',
      // S: 坡口深度， E: 坡口焊接尺寸 
      signId: '0',
      // 基本焊接符号id    	 
      // finishSymbol: '', // 焊缝加工完成符号   F
      // contourSymbolId: '', // 焊缝表面轮廓加工符号  C     焊接符号id
      // grooveAngle: '', // 坡口角度  A
      // rootOpening: '', // 间隙   R
      FCAR: '',
      // 上述四个的集合
      LP: '' //  L: 焊缝长度 P: 间距
    },
    dottedSide: {
      SE: '',
      // S: 坡口深度， E: 坡口焊接尺寸 
      signId: '0',
      // 基本焊接符号id    	 
      // finishSymbol: '', // 焊缝加工完成符号   F
      // contourSymbolId: '', // 焊缝表面轮廓加工符号  C     焊接符号id
      // grooveAngle: '', // 坡口角度  A
      // rootOpening: '', // 间隙   R
      FCAR: '',
      // 上述四个的集合
      LP: '' //  L: 焊缝长度 P: 间距
    },
    isFleldWeld: false,
    // 是否现场焊接
    isAllAround: false,
    // 是否环绕弓箭周围焊缝
    specificAction: '',
    // "" , 焊接方法   T
    strokeStyle: '#ff0000'
  };
}
MMWeldMark.prototype = new _MMObject["default"]();
MMWeldMark.superclass = _MMObject["default"].prototype;
MMWeldMark.prototype.encode = function (enc_) {
  MMWeldMark.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMWeldMark.prototype.decode = function (dec_, ver_) {
  MMWeldMark.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
MMWeldMark.prototype.setWeldMarkData = function (objData) {
  this.objData = objData;
};
MMWeldMark.prototype.setActive = function (active) {
  this.objData.active = active;
};
MMWeldMark.prototype.getWeldMarkData = function () {
  return this.objData;
};
MMWeldMark.prototype.setExpandRect = function (tras, ctx) {
  var tPoint = this.objData.tPoint;
  tPoint = {
    w: tras.dv2lgLen(tPoint.w),
    h: tras.dv2lgLen(tPoint.h)
  };
  var markW = MMWeldMark.getLineWidth(this.objData, ctx) + 20 + MMWeldMark.getSpecificActionWidth(this.objData, ctx);
  var markH = 0;
  if (this.objData.dirObj.signY > 0) {
    markH = MMWeldMark.getSolidSideHeight(this.objData, ctx);
  } else {
    markH = MMWeldMark.getDottedSideHeight(this.objData, ctx);
  }
  markW = tras.dv2lgLen(markW);
  markH = tras.dv2lgLen(markH);
  var append = tras.dv2lgLen(20);
  var targetPoint = {
    x: this.objData.oPoint.x + this.objData.dirObj.signX * (tPoint.w + markW),
    y: this.objData.oPoint.y + this.objData.dirObj.signY * (tPoint.h + markH)
  };
  var _oPoint = {
    x: this.objData.oPoint.x - this.objData.dirObj.signX * append,
    y: this.objData.oPoint.y - this.objData.dirObj.signY * append
  };
  var rect = new _MMRect["default"]();
  rect.initWith2Pts(_oPoint, targetPoint);
  MMWeldMark.superclass.setExpandRect.call(this, rect);
};
MMWeldMark.prototype.draw = function (ctx, trsfm, pgIndex) {
  if (this.objData.active) {
    return;
  }
  var devObjcet = _.clone(this.objData);
  devObjcet.oPoint = trsfm.lg2dvPoint(devObjcet.oPoint, pgIndex);
  return MMWeldMark.drawWithDevOpoint(ctx, devObjcet, null, false, true);
};
MMWeldMark.prototype.isInWakeUpArea = function (tras, lgPoint, ctx) {
  var obj = _.clone(this.objData);
  obj.oPoint = tras.lg2dvPoint(obj.oPoint);
  var point = tras.lg2dvPoint(lgPoint);
  return MMWeldMark.isInWeldMarkRect(obj, point, ctx);
};
MMWeldMark.prototype.createWeldMarkData = function () {
  var coder = new _Encoder["default"]();
  this.encodeOrigin(coder);
  var data = coder.getBuffer();
  var dataId = this.getId().toString();
  return {
    data: data,
    dataId: dataId,
    type: 'weldMark'
  };
};
MMWeldMark.prototype.initWithData = function (data) {
  var encode = new _Encoder["default"]();
  encode.setBuffer(data.data);
  var decoder = new _Decoder["default"](this.getBoard());
  decoder.setStream(encode.getStream());
  this.decodeOrigin(decoder);
};
MMWeldMark.prototype.encodeOrigin = function (ec_) {
  var _objVer = 0;
  ec_.encode4Bytes(_objVer);
  ec_.encodeObjID(this.m_id);
  ec_.encode4Bytes(this.m_objType);
  ec_.encode4Bytes(this.fileVersion);
  ec_.encode4Bytes(this.visibleScope);
  ec_.encode8Bytes(this.getCreator());
  ec_.encode4Bytes(this.getPageIndex());
  ec_.encodeMMRect(this.m_expandRect);
  ec_.encodeMMPoint(this.objData.oPoint);
  ec_.encodeFloat(this.objData.tPoint.w);
  ec_.encodeFloat(this.objData.tPoint.h);
  ec_.encodeString(this.objData.dirObj.signX);
  ec_.encodeString(this.objData.dirObj.signY);
  ec_.encodeString(this.objData.solidSide.SE);
  ec_.encodeString(this.objData.solidSide.signId);
  ec_.encodeString(this.objData.solidSide.FCAR);
  ec_.encodeString(this.objData.solidSide.LP);
  ec_.encodeString(this.objData.dottedSide.SE);
  ec_.encodeString(this.objData.dottedSide.signId);
  ec_.encodeString(this.objData.dottedSide.FCAR);
  ec_.encodeString(this.objData.dottedSide.LP);
  ec_.encodeBool(this.objData.isFleldWeld);
  ec_.encodeBool(this.objData.isAllAround);
  ec_.encodeString(this.objData.specificAction);
  ec_.encodeString(this.objData.strokeStyle);
};
MMWeldMark.prototype.decodeOrigin = function (dc_, ver_) {
  var _objVer = 0;
  _objVer = dc_.decodeFrom4Bytes(ver_);
  this.m_id = dc_.decodeFromObjID(ver_);
  this.m_objType = dc_.decodeFrom4Bytes(ver_);
  this.fileVersion = dc_.decodeFrom4Bytes(ver_);
  this.visibleScope = dc_.decodeFrom4Bytes(ver_);
  var creatorId = dc_.decodeFrom8Bytes(ver_);
  var pgIndex = dc_.decodeFrom4Bytes(ver_);
  this.setCreator(creatorId);
  this.setPageIndex(pgIndex);
  this.m_expandRect = dc_.decodeFromMMRect(ver_);
  this.objData.oPoint = dc_.decodeFromMMPoint(ver_);
  this.objData.tPoint.w = dc_.decodeFromFloat(ver_);
  this.objData.tPoint.h = dc_.decodeFromFloat(ver_);
  this.objData.dirObj.signX = dc_.decodeFromString(ver_);
  this.objData.dirObj.signY = dc_.decodeFromString(ver_);
  this.objData.solidSide.SE = dc_.decodeFromString(ver_);
  this.objData.solidSide.signId = dc_.decodeFromString(ver_);
  this.objData.solidSide.FCAR = dc_.decodeFromString(ver_);
  this.objData.solidSide.LP = dc_.decodeFromString(ver_);
  this.objData.dottedSide.SE = dc_.decodeFromString(ver_);
  this.objData.dottedSide.signId = dc_.decodeFromString(ver_);
  this.objData.dottedSide.FCAR = dc_.decodeFromString(ver_);
  this.objData.dottedSide.LP = dc_.decodeFromString(ver_);
  this.objData.isFleldWeld = dc_.decodeFromBool(ver_);
  this.objData.isAllAround = dc_.decodeFromBool(ver_);
  this.objData.specificAction = dc_.decodeFromString(ver_);
  this.objData.strokeStyle = dc_.decodeFromString(ver_);
};
MMWeldMark.getLineWidth = function (objData, ctx) {
  var SELength = MMWeldMark.getSEWidth(objData, ctx);
  var LPLength = MMWeldMark.getLPWidth(objData, ctx);
  var lineLength = SELength + LPLength + 40;
  return lineLength;
};
MMWeldMark.getSEWidth = function (objData, ctx) {
  var solidSELength = ctx.measureText(objData.solidSide.SE).width + 20;
  var dottedSELength = ctx.measureText(objData.dottedSide.SE).width + 20;
  var SELength = Math.max(solidSELength, dottedSELength);
  SELength = SELength > 120 ? 120 : SELength;
  SELength = SELength < 60 ? 60 : SELength;
  return SELength;
};
MMWeldMark.getLPWidth = function (objData, ctx) {
  var solidLPLength = ctx.measureText(objData.solidSide.LP).width + 20;
  var dottedLPLength = ctx.measureText(objData.solidSide.LP).width + 20;
  var LPLength = Math.max(solidLPLength, dottedLPLength);
  LPLength = LPLength > 120 ? 120 : LPLength;
  LPLength = LPLength < 60 ? 60 : LPLength;
  return LPLength;
};
MMWeldMark.getSolidSideHeight = function (objData, ctx) {
  if (objData.solidSide.FCAR) {
    return 60;
  } else {
    return 40;
  }
};
MMWeldMark.getDottedSideHeight = function (objData, ctx) {
  if (objData.dottedSide.FCAR) {
    return 66;
  } else {
    return 46;
  }
};
MMWeldMark.getSpecificActionWidth = function (objData, ctx) {
  var width = 0;
  if (objData.specificAction) {
    width = ctx.measureText(objData.specificAction).width + 10;
    width = width > 100 ? 100 : width;
  }
  return width;
};
MMWeldMark.getInitObjData = function () {
  return {
    oPoint: {
      x: 0,
      y: 0
    },
    //原点逻辑坐标
    tPoint: {
      w: 100,
      h: 100
    },
    // 第二个控制点相对原点的偏移值
    dirObj: {
      signX: 1,
      signY: 1
    },
    // 第二个控制点的坐标系所在象限
    state: 'done',
    //'done'： 正常状态, 'translate': 变形状态, 'move': 移动状态
    active: false,
    solidSide: {
      SE: '',
      // S: 坡口深度， E: 坡口焊接尺寸 
      signId: '',
      // 基本焊接符号id    	 
      // finishSymbol: '', // 焊缝加工完成符号   F
      // contourSymbolId: '', // 焊缝表面轮廓加工符号  C     焊接符号id
      // grooveAngle: '', // 坡口角度  A
      // rootOpening: '', // 间隙   R
      FCAR: '',
      // 上述四个的集合
      LP: '' //  L: 焊缝长度 P: 间距
    },
    dottedSide: {
      SE: '',
      // S: 坡口深度， E: 坡口焊接尺寸 
      signId: '',
      // 基本焊接符号id    	 
      // finishSymbol: '', // 焊缝加工完成符号   F
      // contourSymbolId: '', // 焊缝表面轮廓加工符号  C     焊接符号id
      // grooveAngle: '', // 坡口角度  A
      // rootOpening: '', // 间隙   R
      FCAR: '',
      // 上述四个的集合
      LP: '' //  L: 焊缝长度 P: 间距
    },
    isFleldWeld: false,
    // 是否现场焊接
    isAllAround: false,
    // 是否环绕弓箭周围焊缝
    specificAction: '',
    // "" , 焊接方法   T
    strokeStyle: '#ff0000'
  };
};
MMWeldMark.getAsideHeight = function (objData, ctx) {
  return MMWeldMark.getDottedSideHeight(objData, ctx) + MMWeldMark.getSolidSideHeight(objData, ctx);
};
MMWeldMark.drawWithDevOpoint = function (ctx, objData, canvas, needClear, needImg) {
  var point = objData.oPoint;
  var w = objData.tPoint.w;
  var h = objData.tPoint.h;
  var dirObj = objData.dirObj;
  needClear && ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.strokeStyle = '#ff0000';
  ctx.lineWidth = 2;
  ctx.fillStyle = objData.strokeStyle;
  this.drawArrow(ctx, objData);
  var signX = dirObj.signX;
  // console.log(signX)
  var signY = dirObj.signY;
  w = w * signX;
  h = h * signY;

  // 绘制基准线

  ctx.save();
  ctx.translate(point.x, point.y);
  ctx.beginPath();
  var SELength = MMWeldMark.getSEWidth(objData, ctx);
  var lineLength = MMWeldMark.getLineWidth(objData, ctx);
  ctx.moveTo(w, h);
  ctx.lineTo(w + lineLength * signX, h);
  MMWeldMark.drawDottedLine(ctx, {
    x: w,
    y: h + 6
  }, lineLength, signX);
  ctx.stroke();
  ctx.restore();
  var isFleldWeld = objData.isFleldWeld;
  if (isFleldWeld && needImg) {
    var img = new Image();
    img.src = "img/gb/34 copy 3.svg";
    img.onload = function () {
      ctx.drawImage(img, point.x + w - 10, point.y + h - 37);
      // ctx.drawImage(img, 0, 0)
    };
  }
  var isAllAround = objData.isAllAround;
  if (isAllAround && needImg) {
    var _img = new Image();
    _img.src = "img/gb/33 copy 3.svg";
    _img.onload = function () {
      ctx.drawImage(_img, point.x + w - 20, point.y + h - 20);
      // ctx.drawImage(img, 0, 0)
    };
  }
  var specificAction = objData.specificAction;
  if (specificAction) {
    var specificActionLength = ctx.measureText(objData.solidSide.SE).width + 10;
    ctx.save();
    ctx.translate(point.x + w + signX * lineLength, point.y + h);
    signX < 0 && (ctx.textAlign = 'right');
    ctx.textBaseline = 'middle';
    ctx.fillText(specificAction, signX * 10, 0, 90);
    ctx.beginPath();
    ctx.strokeStyle = '#ff0000';
    ctx.fillStyle = objData.strokeStyle;
    ctx.moveTo(0, 0);
    ctx.lineTo(signX * 30, signY * 30);
    ctx.moveTo(0, 0);
    ctx.lineTo(signX * 30, -signY * 30);
    ctx.stroke();
    // ctx.closePath();			 
    ctx.restore();
  }

  //计算基准线左侧点坐标
  var leftX = point.x + w;
  if (signX < 0) {
    leftX -= lineLength;
  }
  var asideStartPoint = {
    x: leftX,
    y: point.y + h
  };

  //绘制实线侧
  MMWeldMark.drawAside(ctx, objData, asideStartPoint, lineLength, 'solid', SELength, needImg);
  //绘制虚线侧		
  MMWeldMark.drawAside(ctx, objData, asideStartPoint, lineLength, 'dotted', SELength, needImg);
};
MMWeldMark.drawAside = function (ctx, objData, startPoint, length, type, leftLength, needImg) {
  var sideData, dir;
  if (type == 'solid') {
    //实线侧在上方
    sideData = objData.solidSide;
    dir = 0;
  } else if (type == 'dotted') {
    sideData = objData.dottedSide;
    dir = 1;
  } else {
    console.error('类型错误');
    return;
  }
  var signId = sideData.signId;
  if (signId && needImg) {
    var img = new Image();
    img.src = "img/gb/".concat(signId, " copy 3.svg");
    img.onload = function () {
      ctx.save();
      ctx.translate(startPoint.x, startPoint.y);
      // console.log(type + "x: " + startPoint.x + "   y: " + startPoint.y);
      // ctx.lineTo(100,50)

      type == 'dotted' && ctx.transform(1, 0, 0, -1, 0, 0);
      // ctx.drawImage(img, 0, 0)
      ctx.drawImage(img, leftLength, -40);
      ctx.restore();
    };
  }
  var SE = sideData.SE;
  if (SE) {
    ctx.save();
    ctx.translate(startPoint.x, startPoint.y);
    ctx.textBaseline = 'bottom';
    ctx.textAlign = 'right';
    ctx.strokeStyle = '#ff0000';
    ctx.fillStyle = objData.strokeStyle;
    ctx.fillText(SE, leftLength - 10, -6 + 26 * dir, 90);
    ctx.restore();
  }
  var LP = sideData.LP;
  if (LP) {
    ctx.save();
    ctx.translate(startPoint.x, startPoint.y);
    ctx.textBaseline = 'bottom';
    ctx.textAlign = 'left';
    ctx.strokeStyle = '#ff0000';
    ctx.fillStyle = objData.strokeStyle;
    ctx.fillText(LP, leftLength + 50, -6 + 26 * dir, 90);
    ctx.restore();
  }
  var FCAR = sideData.FCAR;
  if (FCAR) {
    ctx.save();
    ctx.translate(startPoint.x, startPoint.y);
    ctx.textAlign = 'center';
    ctx.strokeStyle = '#ff0000';
    ctx.fillStyle = objData.strokeStyle;
    ctx.fillText(FCAR, length / 2, -40 + 86 * dir, length - 20);
    ctx.restore();
  }
};
MMWeldMark.drawDottedSide = function (ctx, objData, startPoint, length, angle) {
  ctx.translate(startPoint.x, ctx.translate.y);
  var sideData = objData.solidSide;
  var signId = solidSide.signId;
  var img = new Image();
  img.src = "img/gb/".concat(signId, " copy 3.svg");
  img.onload = function () {
    ctx.save();
    ctx.rotate(angle);
    ctx.drawImage(img, (length - 40) / 2, -40);
    ctx.restore();
  };
};
MMWeldMark.drawDottedLine = function (ctx, startPoint, length, dir) {
  //length % 4=2   水平的直线	
  ctx.moveTo(startPoint.x, startPoint.y);
  // let l = Math.floor(length / 6);
  ctx.lineWidth = 1;
  for (var x = 0; x < length - 6; x += 6) {
    ctx.lineTo(startPoint.x + (x + 2) * dir, startPoint.y);
    ctx.moveTo(startPoint.x + (x + 6) * dir, startPoint.y);
  }
  ctx.lineWidth = 2;
};
MMWeldMark.drawArrow = function (ctx, objData) {
  var point = objData.oPoint;
  var w = objData.tPoint.w;
  var h = objData.tPoint.h;
  var dirObj = objData.dirObj;
  var isActive = objData.active;
  var signX = dirObj.signX;
  var signY = dirObj.signY;
  w = w * signX;
  h = h * signY;
  var temp = 45 * Math.PI / 180;
  var roud = Math.atan(h / w);
  roud -= temp;
  signX < 0 && (roud += Math.PI);
  ctx.save();
  ctx.translate(point.x, point.y);
  if (isActive) {
    ctx.strokeStyle = '#e3e3e3';
    ctx.beginPath();
    ctx.arc(0, 0, 10, 0, Math.PI * 2);
    ctx.stroke();
    ctx.strokeStyle = "rgba(254, 200, 111,1.0)";
    ctx.beginPath();
    ctx.arc(0, 0, 8, 0, Math.PI * 2);
    ctx.stroke();
    ctx.strokeStyle = '#e3e3e3';
    ctx.beginPath();
    ctx.arc(w, h, 10, 0, Math.PI * 2);
    ctx.stroke();
    ctx.beginPath();
    ctx.strokeStyle = "rgba(254, 200, 111,1.0)";
    ctx.arc(w, h, 8, 0, Math.PI * 2);
    ctx.stroke();
  }
  ctx.beginPath();
  ctx.strokeStyle = '#ff0000';
  ctx.lineWidth = 2;
  ctx.save();
  ctx.rotate(roud);
  ctx.moveTo(0, 0);
  ctx.lineTo(0, 10);
  ctx.moveTo(0, 0);
  ctx.lineTo(10, 0);
  ctx.moveTo(0, 0);
  ctx.restore();
  ctx.lineTo(w, h);
  // ctx.closePath();
  ctx.stroke();
  ctx.restore();
};
MMWeldMark.createMoveCanvas = function (objData) {
  var canvas = document.createElement('canvas');
  canvas.setAttribute("class", 'move-canvas');
  var ctx = canvas.getContext("2d");
  var width = MMWeldMark.getLineWidth(objData, ctx) + 20 + MMWeldMark.getSpecificActionWidth(objData, ctx);
  var height = MMWeldMark.getAsideHeight(objData, ctx);
  var solidHeight = MMWeldMark.getSolidSideHeight(objData, ctx);
  canvas.width = width;
  canvas.height = height;
  // ctx.beginPath();
  // ctx.strokeStyle = '#ff0000';
  // ctx.lineWidth = 1;
  // ctx.moveTo(0,40);
  // ctx.lineTo(102,40);
  // ctx.moveTo(0,46);
  // for(var i = 0; i < 26; i++) {
  //   ctx.lineTo(i*4 + 2, 46);  
  //   ctx.moveTo(i*4 + 4, 46);
  // } 
  // ctx.drawImage(img, 31, 0)
  // ctx.stroke()
  // let middleY = canvas.height/2-4;
  // ctx.beginPath();
  // ctx.strokeStyle = '#ff0000';
  // ctx.moveTo(0, middleY);
  // ctx.lineTo(102, middleY);
  // MMWeldMark.drawDottedLine(ctx, {x: 0, y: middleY+6}, 102, 1)
  // ctx.closePath();
  // ctx.stroke();
  // ctx.restore();
  // MMWeldMark.drawAside(ctx, objData, {x:0, y: middleY}, 102, 'solid');
  // 	//绘制虚线侧		
  // MMWeldMark.drawAside(ctx, objData, {x:0, y: middleY}, 102, 'dotted')
  var data = _.clone(objData);
  // data.dirObj = {
  // 	signX: 1,
  // 	signY: 1
  // }
  data.oPoint = {
    x: -(data.oPoint.x + data.tPoint.w * data.dirObj.signX),
    y: -(data.oPoint.y + data.tPoint.h * data.dirObj.signY - solidHeight - 20)
  };
  MMWeldMark.drawWithDevOpoint(ctx, data, null, false, true);
  return canvas;
};
MMWeldMark.getDir = function (canvas, point, target) {
  var w = Math.abs(target.x - point.x);
  var h = Math.abs(target.y - point.y);
  var dirObj = {
    signX: 1,
    signY: 1
  };
  var centerX = canvas.width / 2;
  var centerY = canvas.height / 2;
  dirObj.signX = (point.x - centerX) / Math.abs(point.x - centerX) || 1;
  dirObj.signY = (point.y - centerY) / Math.abs(point.y - centerY) || 1;
  if (dirObj.signX > 0 && target.x + 102 > canvas.width) {
    dirObj.signX = -dirObj.signX;
  } else if (dirObj.signX < 0 && target.x - 102 < 0) {
    dirObj.signX = -dirObj.signX;
  }
  return dirObj;
};
MMWeldMark.getMoveDir = function (point, target) {
  var dirObj = {
    signX: 1,
    signY: 1
  };
  dirObj.signX = target.x > point.x ? 1 : -1;
  dirObj.signY = target.y > point.y ? 1 : -1;
  return dirObj;
};
MMWeldMark.getTPointXy = function (Obj_weldMark) {
  return {
    x: Obj_weldMark.oPoint.x + Obj_weldMark.tPoint.w * Obj_weldMark.dirObj.signX,
    y: Obj_weldMark.oPoint.y + Obj_weldMark.tPoint.h * Obj_weldMark.dirObj.signY
  };
};
MMWeldMark.isInWeldMarkRect = function (objData, point, ctx) {
  // 屏幕坐标
  var oPoint = objData.oPoint;
  var tPoint = MMWeldMark.getTPointXy(objData);
  var a = Math.atan(objData.tPoint.h / objData.tPoint.w);
  if (objData.dirObj.signX * objData.dirObj.signY < 0) {
    a = Math.PI / 2 - a;
  }

  // a = Math.PI*a/180;
  var cosA = Math.abs(Math.cos(a));
  var sinA = Math.abs(Math.sin(a));
  var _oPoint = {
    x: oPoint.x * cosA + oPoint.y * sinA - objData.dirObj.signX * 10,
    y: oPoint.y * cosA - oPoint.x * sinA - objData.dirObj.signY * 10
  };
  var _tPoint = {
    x: tPoint.x * cosA + tPoint.y * sinA + objData.dirObj.signX * 10,
    y: tPoint.y * cosA - tPoint.x * sinA + objData.dirObj.signY * 10
  };
  var _point = {
    x: point.x * cosA + point.y * sinA,
    y: point.y * cosA - point.x * sinA
  };
  var rect = new _MMRect["default"]();
  rect.initWith2Pts(_oPoint, _tPoint);
  if (rect.include(_point)) {
    return true;
  }
  var ltPoint = null;
  var markW = MMWeldMark.getLineWidth(objData, ctx) + 20 + MMWeldMark.getSpecificActionWidth(objData, ctx);
  var solidSideH = MMWeldMark.getSolidSideHeight(objData, ctx);
  var asideSideH = MMWeldMark.getAsideHeight(objData, ctx);
  if (objData.dirObj.signX > 0) {
    ltPoint = {
      x: tPoint.x,
      y: tPoint.y - solidSideH
    };
  } else {
    ltPoint = {
      x: tPoint.x - markW,
      y: tPoint.y - solidSideH
    };
  }
  var rect2 = new _MMRect["default"]();
  rect2.setRct(ltPoint.x, ltPoint.y, markW, asideSideH);
  return rect2.include(point);
};
var _default = exports["default"] = MMWeldMark;

},{"1081":1081,"1084":1084,"1184":1184,"1437":1437,"1454":1454,"1463":1463,"1478":1478,"799":799,"800":800,"831":831}],1030:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMRectangle = _interopRequireDefault(require(1026));
var _ObjType = _interopRequireDefault(require(1084));
var _MDGraphDrawer = _interopRequireDefault(require(806));
var _MMFillType = _interopRequireDefault(require(795));
var _MMStrokeType = _interopRequireDefault(require(798));
var _MMPathDrawer = _interopRequireDefault(require(896));
var _MMPoint = _interopRequireDefault(require(830));
var _MMRect = _interopRequireDefault(require(831));
var _MMColor = _interopRequireDefault(require(794));
/**
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMSignatureFrame}
 */
function MMSignatureFrame(board, ver) {
  _MMRectangle["default"].call(this, board, ver); //
  this.m_className = 'MMSignatureFrame';
  this.m_objType = _ObjType["default"].Obj_signatureFrame;
  this.m_isClose = false;
  this.user = null;
  this.pgRect = null;
  this.angle = 0;
}
;
MMSignatureFrame.prototype = new _MMRectangle["default"](); //
MMSignatureFrame.superclass = _MMRectangle["default"].prototype;
MMSignatureFrame.prototype.encode = function (enc_) {
  MMSignatureFrame.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMSignatureFrame.prototype.decode = function (dec_, ver_) {
  MMSignatureFrame.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
MMSignatureFrame.prototype.draw = function (ctx, trsfm, pgindex) {
  MMSignatureFrame.superclass.draw.call(this, ctx, trsfm, pgindex);
};
MMSignatureFrame.prototype.drawInCanvas = function (ctx, trsfm, pgindex) {
  var data = this.getObjData();
  if (data == null || data == undefined || data.m_arrPoints == undefined || data.m_arrPoints == null || data.m_arrPoints.length == 0) return;
  if (!this.pgRect) {
    this.pgRect = trsfm.getLgPageRect();
    this.initByDefaultRect2Save();
  }
  // MMSignatureFrame.superclass.drawInCanvas.call(this, ctx, trsfm, pgindex);

  ctx.save();
  var angle = this.angle;
  if (this.sigData) {
    var standardData = this.sigData.getData();
    var standW = this.sigData.getWidth();
    var standH = this.sigData.getHeight();
    var rect = this.getDrawRect();
    var origin = rect.getOrigin();
    var w = rect.getWidth();
    var h = rect.getHeight();
    var center = rect.getCenter();
    var dvCent = trsfm.lg2dvPoint(center);
    ctx.translate(dvCent.x, dvCent.y);
    ctx.rotate(angle);
    ctx.translate(-dvCent.x, -dvCent.y);
    var targetWidth, targetHeight;
    if (standW / standH > w / h) {
      targetWidth = w;
      targetHeight = targetWidth * standH / standW;
    } else {
      targetHeight = h;
      targetWidth = targetHeight * standW / standH;
    }
    var leftTop = {
      x: origin.x + (w - targetWidth) / 2,
      y: origin.y + (h - targetHeight) / 2
    };
    var lineW = trsfm.dv2lgLen(1); // ------------------- 线宽为 1px;

    var fillType = new _MMFillType["default"]();
    fillType.m_board = data.m_fillType.m_board;
    fillType.m_gradient = data.m_fillType.m_gradient;
    fillType.m_notGradient = data.m_fillType.m_notGradient;
    fillType.m_fillColor = data.m_strokeType.m_lineColor;
    fillType.m_hasFill = false;
    var colorStr = "#ff0000";
    var strokeType = this.getStrokeType();
    if (!strokeType) {
      strokeType = new _MMStrokeType["default"]();
      strokeType.m_lineWidth = lineW;
      var color = data.m_strokeType.m_lineColor;
      var color = new _MMColor["default"]();
      color.fromString(colorStr);
      strokeType.setLineColor(color);
    }
    var drawer = new _MMPathDrawer["default"](ctx, strokeType, fillType, data.m_shadowType, trsfm, pgindex);
    ctx.lineWidth = 1;
    for (var i = 0; i < standardData.length; i++) {
      var stroke = standardData[i];
      var strokePts = [];
      for (var k = 0; k < stroke.length; k++) {
        var pt = stroke[k];
        var lgPt = new _MMPoint["default"]();
        lgPt.x = leftTop.x + pt.x * targetWidth;
        lgPt.y = leftTop.y + pt.y * targetHeight;
        strokePts.push(lgPt);
      }
      drawer.drawPolyline(strokePts, 0, strokePts.length, false);
    }
    if (this.user) {
      var dvLefttop = trsfm.lg2dvPoint(origin);
      var name = this.user.getUserName() + '-' + BabelStr.str(7523);
      ctx.font = "10px Arial";
      ctx.fillStyle = colorStr;
      var w = 10;
      ctx.fillText(name, dvLefttop.x + w + w / 2, dvLefttop.y);
      ctx.fillRect(dvLefttop.x, dvLefttop.y - w * 4 / 5, w, w);
    }
  }
  ctx.restore();
};
MMSignatureFrame.prototype.clone = function () {
  var newObj = new MMSignatureFrame(this.board);
  newObj.initBy(this);
  newObj.sigData = this.sigData;
  newObj.user = this.user;
  newObj.pgRect = this.pgRect;
  return newObj;
};
MMSignatureFrame.prototype.setSigData = function (sigData) {
  this.sigData = sigData;
};
MMSignatureFrame.prototype.getSigData = function () {
  return this.sigData;
};
MMSignatureFrame.prototype.getSigDataId = function () {
  return this.sigData.getId();
};
MMSignatureFrame.prototype.setUser = function (user) {
  this.user = user;
};
MMSignatureFrame.prototype.getUser = function () {
  return this.user;
};
MMSignatureFrame.prototype.setPageRect = function (pgRect) {
  this.pgRect = pgRect;
};
MMSignatureFrame.prototype.getRect2Save = function () {
  if (this.pgRect) {
    var drawRect = this.getDrawRect();
    var pgW = this.pgRect.getWidth();
    var pgH = this.pgRect.getHeight();
    var origin = drawRect.getOrigin();
    var pageOrigin = this.pgRect.getOrigin();
    origin.subtract(pageOrigin);
    var w = drawRect.getWidth();
    var h = drawRect.getHeight();
    origin.x = origin.x / pgW;
    origin.y = origin.y / pgH;
    w = w / pgW;
    h = h / pgH;
    var rect2save = new _MMRect["default"]();
    rect2save.setRct(origin.x, origin.y, w, h);
    return rect2save;
  }
};
MMSignatureFrame.prototype.initByRect2Save = function (rect) {
  if (this.pgRect) {
    var pageOrigin = this.pgRect.getOrigin();
    var pgW = this.pgRect.getWidth();
    var pgH = this.pgRect.getHeight();
    var drawRect = rect;
    var origin = drawRect.getOrigin();
    var w = drawRect.getWidth();
    var h = drawRect.getHeight();
    origin.x = pageOrigin.x + origin.x * pgW;
    origin.y = pageOrigin.y + origin.y * pgH;
    w = w * pgW;
    h = h * pgH;
    var rectInit = new _MMRect["default"]();
    rectInit.setRct(origin.x, origin.y, w, h);
    this.initByRect(rectInit);
  }
};

// 设置保存数据在区间 【0 1】 内的签字框数据
MMSignatureFrame.prototype.setDefaultRect2Save = function (standRect) {
  this.standRect = standRect;
  this.pgRect = null;
};
MMSignatureFrame.prototype.getDefaultRect2Save = function () {
  return this.standRect;
};
MMSignatureFrame.prototype.initByDefaultRect2Save = function () {
  if (this.standRect) {
    this.initByRect2Save(this.standRect);
  }
};
MMSignatureFrame.prototype.rotate90 = function () {
  this.angle -= Math.PI / 2;
};
var _default = exports["default"] = MMSignatureFrame;

},{"1026":1026,"1084":1084,"1184":1184,"1454":1454,"794":794,"795":795,"798":798,"806":806,"830":830,"831":831,"896":896}],1026:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMGraphics = _interopRequireDefault(require(1013));
var _ObjType = _interopRequireDefault(require(1084));
function MMRectangle(board, ver) {
  _MMGraphics["default"].call(this, board, ver);
  this.m_objType = _ObjType["default"].GObj_rect;
  this.m_className = 'MMRectangle';
}
;
MMRectangle.prototype = new _MMGraphics["default"]();
MMRectangle.superclass = _MMGraphics["default"].prototype;
MMRectangle.prototype.encode = function (enc_) {
  MMRectangle.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMRectangle.prototype.decode = function (dec_, ver_) {
  MMRectangle.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
MMRectangle.prototype.clone = function () {
  var newObj = new MMRectangle(this.board);
  newObj.initBy(this);
  return newObj;
};
MMRectangle.prototype.initByRect = function (rect) {
  var pts = rect.getLogicPts();
  this.setLogPts(pts);
};

//MMRectangle.prototype.draw = function(ctx, trsfm,  pgindex){
//  // test
//  var dvrct = trsfm.lg2dvRect(this.m_rect, pgindex);
//  ctx.fillStyle="rgba(255,0,0,0.5)";
//  //ctx.fillRect(333.33333, 333.25, 333.33333, 666.5);
//  ctx.fillRect(dvrct.left, dvrct.top, dvrct.getWidth(), dvrct.getHeight());
//
//};
var _default = exports["default"] = MMRectangle;

},{"1013":1013,"1084":1084,"1184":1184,"1454":1454}],1013:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMYellowObj = _interopRequireDefault(require(1035));
var _MMBasicData = _interopRequireDefault(require(811));
var _box = _interopRequireDefault(require(833));
var _MMPathDrawer = _interopRequireDefault(require(896));
var _MMRect = _interopRequireDefault(require(831));
/**
 * MMGraphics 是所有绘制多边形的基础类
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMGraphics}
 */
function MMGraphics(board, ver) {
  _MMYellowObj["default"].call(this, board, ver);
  this.angle = 0;
}
;
MMGraphics.prototype = new _MMYellowObj["default"]();
MMGraphics.superclass = _MMYellowObj["default"].prototype;
MMGraphics.prototype.encode = function (enc_) {
  MMGraphics.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMGraphics.prototype.decode = function (dec_, ver_) {
  MMGraphics.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
MMGraphics.prototype.draw = function (ctx, trsfm, pgindex) {
  ctx.save();
  this.drawInCanvas(ctx, trsfm, pgindex);
  ctx.restore();
};
MMGraphics.prototype.drawInCanvas = function (ctx, trsfm, pgindex) {
  var objRct = this.calcuExpandRect();
  var pgRct = new _MMRect["default"]();
  var lgpgsize = _MMBasicData["default"].pageSize;
  pgRct.setRct(0, pgindex * lgpgsize.height, lgpgsize.width, lgpgsize.height);
  try {
    if (_box["default"].intersects(pgRct, objRct) && this.getArrPoints().length > 1) {
      var data = this.getObjData();
      var drawer = new _MMPathDrawer["default"](ctx, data.m_strokeType, data.m_fillType, data.m_shadowType, trsfm, pgindex);
      drawer.isSkeleton(this.isSkeleton());
      drawer.drawPolyline(data.m_arrPoints, 0, data.m_arrPoints.length, data.m_isClose);
    }
  } catch (e) {
    console.log("graphics draw 异常 :" + e.message);
  }
};
var _default = exports["default"] = MMGraphics;

},{"1035":1035,"1184":1184,"1454":1454,"811":811,"831":831,"833":833,"896":896}],1035:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMBezierObj = _interopRequireDefault(require(999));
function MMYellowObj(board, ver) {
  _MMBezierObj["default"].call(this, board, ver);
  this.m_className = 'MMYellowObj';
}
;
MMYellowObj.prototype = new _MMBezierObj["default"](); //
MMYellowObj.superclass = _MMBezierObj["default"].prototype;
MMYellowObj.prototype.encode = function (enc_) {
  _MMBezierObj["default"].prototype.encode.call(this, enc_);
  //  var _objVer = 0 ;
  //  enc_.encode4Bytes(_objVer) ;
};
MMYellowObj.prototype.decode = function (dec_, ver_) {
  _MMBezierObj["default"].prototype.decode.call(this, dec_, ver_);

  //  var _objVer = dec_.decodeFrom4Bytes(ver_) ;
  //  this.m_ver = _objVer ;
};
var _default = exports["default"] = MMYellowObj;

},{"1184":1184,"1454":1454,"999":999}],1028:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1414);
require(1437);
require(1463);
require(1478);
var _MMBezierObj = _interopRequireDefault(require(999));
var _ObjType = _interopRequireDefault(require(1084));
var _MMPoint = _interopRequireDefault(require(830));
var _MMStrokeType = _interopRequireDefault(require(798));
var _MMColor = _interopRequireDefault(require(794));
var _BoardOrientation = _interopRequireDefault(require(802));
var _Encoder = _interopRequireDefault(require(800));
/**
 * javascript/molasync-source/whiteboard/elements/graphics/MMScribble.js
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMScribble}
 */
function MMScribble(board, ver_) {
  _MMBezierObj["default"].call(this, board, ver_); //
  this.m_objType = _ObjType["default"].GObj_scribble;
  this.m_className = 'MMScribble';
  this.hide = false;
  this.isPenComment = false; // 是否是自由手绘批注
}
;
MMScribble.prototype = new _MMBezierObj["default"](); //
MMScribble.superclass = _MMBezierObj["default"].prototype; //

MMScribble.prototype.encode = function (enc_) {
  MMScribble.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMScribble.prototype.decode = function (dec_, ver_) {
  MMScribble.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
MMScribble.prototype.draw = function (ctx, trsfm, pgindex) {
  var rct = this.m_rect;
  var data = this.getObjData();
  if (rct != null && data != null && data != undefined && !this.hide) {
    rct = trsfm.lg2dvRect(rct);
    if (this.getArrPoints().length == 2 && rct.getWidth() < 10 && rct.getHeight() < 10) {
      var c = this.m_rect.getCenter();
      c = trsfm.lg2dvPoint(c, pgindex);
      var r = data.m_strokeType.m_lineWidth / 2;
      r = trsfm.lg2dvLen(r);
      var style = data.m_strokeType.m_lineColor.getRGBA();
      ctx.fillStyle = style;
      ctx.beginPath();
      ctx.arc(c.x, c.y, r + 0.5, 0, 2 * Math.PI);
      ctx.fill();
    } else {
      this.drawInCanvas(ctx, trsfm, pgindex);
    }
  }
  return 0;
};
MMScribble.prototype.clone = function () {
  var newObj = new MMScribble(this.board);
  newObj.initBy(this);
  return newObj;
};
MMScribble.prototype.setOriginMouseLgPts = function (lgPts) {
  this.originMouseLgPts = lgPts;
};
MMScribble.prototype.getOriginMouseLgPts = function (lgPts) {
  return this.originMouseLgPts;
};
MMScribble.prototype.setOriginLineWidth = function (lineWidth) {
  this.orginLineWidth = lineWidth;
};
MMScribble.prototype.setOriginLineDvWidth = function (lineWidth) {
  this.orginLineDvWidth = lineWidth;
};
MMScribble.prototype.getOriginLineWidth = function () {
  return this.orginLineWidth;
};
MMScribble.prototype.getOriginLineDvWidth = function () {
  return this.orginLineDvWidth;
};
MMScribble.prototype.setOriginLineColor = function (color) {
  this.originColor = color;
};
MMScribble.prototype.encodeOrigin = function (ec_) {
  var _objVer = 0;
  ec_.encode4Bytes(_objVer);
  ec_.encodeObjID(this.m_id);
  ec_.encode4Bytes(this.m_objType);
  ec_.encode4Bytes(this.fileVersion);
  ec_.encode4Bytes(this.visibleScope);
  ec_.encode8Bytes(this.getCreator());
  ec_.encode4Bytes(this.getPageIndex());
  ec_.encodeFloat(this.orginLineWidth);
  ec_.encodeString(this.originColor);
  ec_.encodeArray(this.originMouseLgPts, 'MMPoint');
  ec_.encode4Bytes(this.orginLineDvWidth);
};
MMScribble.prototype.decodeOrigin = function (dc_, ver_) {
  var _objVer = 0;
  _objVer = dc_.decodeFrom4Bytes(ver_);
  this.m_id = dc_.decodeFromObjID(ver_);
  this.m_objType = dc_.decodeFrom4Bytes(ver_);
  this.fileVersion = dc_.decodeFrom4Bytes(ver_);
  this.visibleScope = dc_.decodeFrom4Bytes(ver_);
  var creatorId = dc_.decodeFrom8Bytes(ver_);
  var pgIndex = dc_.decodeFrom4Bytes(ver_);
  this.setCreator(creatorId);
  this.setPageIndex(pgIndex);
  this.orginLineWidth = dc_.decodeFromFloat(ver_);
  this.originColor = dc_.decodeFromString(ver_);
  this.originMouseLgPts = dc_.decodeFromArray(ver_, 'MMPoint');
  this.orginLineDvWidth = dc_.decodeFrom4Bytes(ver_);

  // --------------- 根据原生数据，生成 Bezier 点，线性和颜色
  var goodLgPts = MMScribble.calShapePts(this.originMouseLgPts);
  this.setLogicPts(goodLgPts);
  var _strokeType = new _MMStrokeType["default"]();
  _strokeType.setLineWidth(this.orginLineWidth);
  var _color = new _MMColor["default"]();
  _color.fromString(this.originColor);
  _strokeType.setLineColor(_color);
  this.setStrokeType(_strokeType);
  this.setDevOrientation(_BoardOrientation["default"].Portrait);
};
MMScribble.prototype.createScribbleData = function () {
  var coder = new _Encoder["default"]();
  this.encodeOrigin(coder);
  var data = coder.getBuffer();
  var dataId = this.getId().toString();
  return {
    data: data,
    dataId: dataId,
    type: 'scribble'
  };
};
MMScribble.prototype.initWithData = function (data) {
  var encode = new _Encoder["default"]();
  encode.setBuffer(data.data);
  var decoder = new Decoder(this.getBoard());
  decoder.setStream(encode.getStream());
  this.decodeOrigin(decoder);
};
MMScribble.prototype.getExpandRect = function () {
  var rect = MMScribble.superclass.getExpandRect.call(this);
  if (this.orginLineWidth) {
    rect.shrink(-this.orginLineWidth);
  }
  return rect;
};
MMScribble.calShapePts = function (points) {
  var originPoints = [];
  if (points.length < 2) return points;else if (points.length == 2) originPoints = [points[0], points[0], points[0], points[1], points[1], points[1]];else {
    if (points[points.length - 1].x != points[0].x || points[points.length - 1].y != points[0].y) {
      originPoints.push(points[0]);
      originPoints.push(points[0]);
      originPoints.push(points[0]);
      for (var i = 1; i < points.length - 1; i++) {
        var controlPts = MMScribble.getControlPoints(points[i - 1], points[i + 1], points[i]);
        originPoints.push(controlPts[0]);
        originPoints.push(points[i]);
        originPoints.push(controlPts[1]);
      }
      originPoints.push(points[points.length - 1]);
      originPoints.push(points[points.length - 1]);
      originPoints.push(points[points.length - 1]);
    } else {
      var controlPts1 = MMScribble.getControlPoints(points[points.length - 2], points[1], points[0]);
      originPoints.push(controlPts1[0]);
      originPoints.push(points[0]);
      originPoints.push(controlPts1[1]);
      for (var i = 1; i < points.length - 1; i++) {
        var controlPts = MMScribble.getControlPoints(points[i - 1], points[i + 1], points[i]);
        originPoints.push(controlPts[0]);
        originPoints.push(points[i]);
        originPoints.push(controlPts[1]);
      }
      var controlPts2 = MMScribble.getControlPoints(points[points.length - 2], points[1], points[points.length - 1]);
      originPoints.push(controlPts2[0]);
      originPoints.push(points[points.length - 1]);
      originPoints.push(controlPts2[1]);
    }
  }
  return originPoints;
};
MMScribble.removeInterferenceDvPoints = function (points) {
  if (points.length < 2) {
    return points;
  }
  ;
  var inteferValue = 2;
  var resultPts = [];
  resultPts.push(points[0]);
  var index = 0;
  var last = points[0];
  for (var i = 1; i < points.length; i++) {
    var pt = points[i];
    if (Math.abs(pt.x - last.x) > inteferValue && Math.abs(pt.y - last.y)) {
      resultPts.push(pt);
      index++;
      last = pt;
    } else if (i == points.length - 1) {
      resultPts.push(pt);
    }
    ;
  }
  ;
  return resultPts;
};
MMScribble.getControlPoints = function (point1, point2, point3) {
  var d1 = Math.sqrt(Math.pow(point1.x - point3.x, 2) + Math.pow(point1.y - point3.y, 2));
  var d2 = Math.sqrt(Math.pow(point2.x - point3.x, 2) + Math.pow(point2.y - point3.y, 2));
  var controlPts = [{}, {}];
  if (d1 + d2 != 0) {
    var fa = 0.5 * d1 / (d1 + d2);
    var fb = 0.5 * d2 / (d1 + d2);
    controlPts[0] = new _MMPoint["default"](point3.x - fa * (point2.x - point1.x), point3.y - fa * (point2.y - point1.y));
    controlPts[1] = new _MMPoint["default"](point3.x + fb * (point2.x - point1.x), point3.y + fb * (point2.y - point1.y));
  } else {
    controlPts[0] = point1;
    controlPts[1] = point1;
  }
  return controlPts;
};
var _default = exports["default"] = MMScribble;

},{"1084":1084,"1184":1184,"1414":1414,"1437":1437,"1454":1454,"1463":1463,"1478":1478,"794":794,"798":798,"800":800,"802":802,"830":830,"999":999}],999:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
var _MMBlockObj = _interopRequireDefault(require(1000));
var _MMRect = _interopRequireDefault(require(831));
var _MMPathDrawer = _interopRequireDefault(require(896));
var _MMBasicData = _interopRequireDefault(require(811));
var _box = _interopRequireDefault(require(833));
var _MDSeg = _interopRequireDefault(require(828));
/**
 * javascript/molasync-source/whiteboard/elements/graphics/MMBezierObj.js
 * 
 * jiang
 * 2018-10-3
 */

function MMBezierObj(board, ver_) {
  _MMBlockObj["default"].call(this, board, ver_); //
}
;
MMBezierObj.prototype = new _MMBlockObj["default"](); //
MMBezierObj.superclass = _MMBlockObj["default"].prototype;
MMBezierObj.prototype.m_className = 'MMBezierObj';
MMBezierObj.prototype.encode = function (enc_) {
  MMBezierObj.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMBezierObj.prototype.decode = function (dec_, ver_) {
  MMBezierObj.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
MMBezierObj.prototype.drawInCanvas = function (ctx, trsfm, pgindex) {
  var objRct = this.calcuExpandRect();
  if (objRct == undefined) return;
  var pgRct = new _MMRect["default"]();
  var lgpgsize = _MMBasicData["default"].pageSize;
  pgRct.setRct(0, pgindex * lgpgsize.height, lgpgsize.width, lgpgsize.height);
  try {
    if (_box["default"].intersects(pgRct, objRct) && this.getArrPoints().length > 1) {
      var data = this.getObjData();
      data.m_strokeType.m_hasBoard = true;
      var drawer = new _MMPathDrawer["default"](ctx, data.m_strokeType, data.m_fillType, data.m_shadowType, trsfm, pgindex);
      drawer.isSkeleton(this.isSkeleton());
      drawer.drawBezier(data.m_arrPoints, 0, data.m_arrPoints.length, data.m_isClose);

      //      var pts = this.getArrPoints();
      //      data.m_strokeType.setContext(ctx, trsfm);
      //      data.m_shadowType.setContext(ctx, trsfm);
      //      data.m_fillType.setContext(ctx, trsfm);
      //
      //      ctx.beginPath();
      //      var startPt = trsfm.lg2dvPoint(pts[1], pgindex);
      //      ctx.moveTo(startPt.x, startPt.y);
      //      for(var i=2; i < pts.length - 3; i+=3){   // 绘制三次 bezier 曲线
      //
      //        var outPt = trsfm.lg2dvPoint(pts[i], pgindex);
      //        var inPt = trsfm.lg2dvPoint(pts[i + 1], pgindex);
      //        var pt = trsfm.lg2dvPoint(pts[i+2], pgindex);
      //
      //        ctx.bezierCurveTo(outPt.x, outPt.y, inPt.x, inPt.y, pt.x, pt.y);
      //
      //      }
      //
      //      if(data.m_isClose){
      //        outPt = trsfm.lg2dvPoint(pts[pts.length - 1], pgindex);
      //        inPt = trsfm.lg2dvPoint(pts[0], pgindex);
      //        pt = trsfm.lg2dvPoint(pts[1], pgindex);
      //        ctx.bezierCurveTo(outPt.x, outPt.y, inPt.x, inPt.y, pt.x, pt.y);
      //      }
      //      ctx.fill();
      //      ctx.stroke();
    }
  } catch (e) {
    console.log("circle draw in canvas error !!!! ->" + e.message);
  }
};
MMBezierObj.prototype.getLogicPts = function () {
  var data = this.getObjData();
  if (data) {
    return data.getLogicPts();
  }
  return [];
};
MMBezierObj.prototype.getSegLogicPts = function () {
  if (this.segPts) {
    return this.segPts;
  }
  this.segPts = [];
  var lgPts = this.getLogicPts();
  for (var i = 1; i < lgPts.length - 3; i += 3) {
    var p0 = lgPts[i];
    var p1 = lgPts[i + 1];
    var p2 = lgPts[i + 2];
    var p3 = lgPts[i + 3];
    if (!p0 || !p1 || !p2 || !p3) {
      console.log('undefined!');
    }
    var oneBezierSegPts = this.getSegPts4Bezier(p0, p1, p2, p3);
    this.segPts = this.segPts.concat(oneBezierSegPts);
  }
  return this.segPts;
};
MMBezierObj.prototype.getSegPts4Bezier = function (p0, p1, p2, p3) {
  var steps = Math.sqrt((p0.x - p3.x) * (p0.x - p3.x) + (p0.y - p3.y) * (p0.y - p3.y));
  var bPt1 = {
    p: p0,
    outp: p1
  };
  var bPt2 = {
    p: p3,
    inp: p2
  };
  var steps = 100;
  var segPts = [];
  for (var i = 0; i < steps; i++) {
    var pt = _MMPathDrawer["default"].getBezierPt(bPt1, bPt2, i / steps);
    segPts.push(pt);
  }
  return segPts;
};
MMBezierObj.prototype.intersectWith = function (pt0, pt1) {
  var objRct = this.calcuExpandRect();
  if (objRct == undefined) return false;
  var segPts = this.getSegLogicPts();
  var tempRect = new _MMRect["default"]();
  tempRect.initWithPtsBounadingBox([pt0, pt1]);
  if (objRct.intersects(tempRect)) {
    for (var i = 0; i < segPts.length - 1; i++) {
      var pt_0 = segPts[i];
      var pt_1 = segPts[i + 1];
      var tempRect2 = new _MMRect["default"]();
      tempRect2.initWithPtsBounadingBox([pt_0, pt_1]);
      if (tempRect2.intersects(tempRect)) {
        if (_MDSeg["default"].intersects(pt0, pt1, pt_0, pt_1)) {
          return true;
        }
        ;
      }
      ;
    }
    ;
  }
  ;
  return false;
};
var _default = exports["default"] = MMBezierObj;

},{"1000":1000,"1184":1184,"1412":1412,"1454":1454,"811":811,"828":828,"831":831,"833":833,"896":896}],896:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
require(1414);
var _MDGraphDrawer = _interopRequireDefault(require(806));
var _MMPoint = _interopRequireDefault(require(830));
/**
 * 负责绘制图形的边框和填充
 */

/**
 * @param ctx {HTML5 canvas context}
 * @param strokeType {MMStrokeType}
 * @param fillType {MMFillType}
 * @param shadowType {MMShadowType}
 * @param pgindex {Number} 页的下标
 */
function MMPathDrawer(ctx, strokeType, fillType, shadowType, trsfm, pgindex) {
  this.pgindex = pgindex;
  this.ctx = ctx;
  this.trsfm = trsfm;
  this.arrCubicBezierPts = new Array();
  this.dashArray = new Array();
  var width = trsfm.lg2dvLen(strokeType.m_lineWidth);
  this.dashArray.push(strokeType.m_length[0] * width);
  this.dashArray.push(strokeType.m_length[0] * width);
  this.fillColor = fillType.getFillColor().toString();
  strokeType.setContext(ctx, trsfm);
  fillType.setContext(ctx, trsfm, pgindex);
  shadowType.setContext(ctx, trsfm);
}
;

/**
 * 绘制 bezier 曲线或者填充 bezier 曲线
 * @param pts {Array} 点的集合
 * @param startIndex {Number} 起始点
 * @param length {Number} 点的个数
 * @param isClose {Boolean} 是否闭合
 */
MMPathDrawer.prototype.drawBezier = function (pts, startIndex, length, isClose) {
  if (this.isSkeleton()) {
    this.initForSkeleton();
  }
  ;
  try {
    if (startIndex + 1 < pts.length && pts.length > 2) {
      this.getCubicBezierPt(pts, startIndex, length, true, isClose);
      this.ctx.beginPath();
      var startPt = this.trsfm.lg2dvPoint(pts[startIndex + 1], this.pgindex);
      this.ctx.moveTo(startPt.x, startPt.y);
      for (var i = startIndex + 2; i < length - 3; i += 3) {
        // 绘制三次 bezier 曲线

        var outPt = this.trsfm.lg2dvPoint(pts[i], this.pgindex);
        var inPt = this.trsfm.lg2dvPoint(pts[i + 1], this.pgindex);
        var pt = this.trsfm.lg2dvPoint(pts[i + 2], this.pgindex);
        this.ctx.bezierCurveTo(outPt.x, outPt.y, inPt.x, inPt.y, pt.x, pt.y);
      }
      if (isClose) {
        outPt = this.trsfm.lg2dvPoint(pts[length - 1], this.pgindex);
        inPt = this.trsfm.lg2dvPoint(pts[startIndex], this.pgindex);
        pt = this.trsfm.lg2dvPoint(pts[startIndex + 1], this.pgindex);
        this.ctx.bezierCurveTo(outPt.x, outPt.y, inPt.x, inPt.y, pt.x, pt.y);
      }
      this.ctx.fill();
      if (this.dashArray[0] > 0 && this.dashArray[1] > 0) {
        this.ctx.beginPath();
        this.drawDashStroke(this.ctx, this.dashArray);
        this.ctx.stroke();
      } else {
        this.ctx.stroke();
      }
    }
  } catch (e) {
    //console.log("path drawer error !!! ---> " + e.message);
  }
};
MMPathDrawer.prototype.drawArrow = function (p1, p2) {
  if (this.isSkeleton()) {
    this.initForSkeleton();
  }
  ;
  var dvP1 = this.trsfm.lg2dvPoint(p1, this.pgindex);
  var dvP2 = this.trsfm.lg2dvPoint(p2, this.pgindex);
  _MDGraphDrawer["default"].drawArrow(this.ctx, '#ffffff', this.fillColor, dvP1, dvP2);
};
MMPathDrawer.prototype.initForSkeleton = function () {
  this.ctx.lineWidth = 1;
  this.ctx.strokeStyle = '#00ffff';
},
/**
 * 绘制多边形
 * @param pts {Array} 点的集合
 * @param startIndex {Number} 起始点
 * @param length {Number} 点的个数
 * @param isClose {Boolean} 是否闭合
 */
MMPathDrawer.prototype.drawPolyline = function (pts, startIndex, length, isClose) {
  if (this.isSkeleton()) {
    this.initForSkeleton();
  }
  ;
  try {
    if (startIndex < pts.length && pts.length > 1) {
      this.getCubicBezierPt(pts, startIndex, length, false, isClose);
      this.ctx.beginPath();
      var startPt = this.trsfm.lg2dvPoint(pts[startIndex], this.pgindex);
      this.ctx.moveTo(startPt.x, startPt.y);
      for (var i = startIndex + 1; i < startIndex + length; i++) {
        // 绘制三多段线

        var pt = this.trsfm.lg2dvPoint(pts[i], this.pgindex);
        this.ctx.lineTo(pt.x, pt.y);
      }
      if (isClose) {
        this.ctx.lineTo(startPt.x, startPt.y);
      }
      this.ctx.fill();
      if (this.dashArray[0] > 0 && this.dashArray[1] > 0) {
        this.ctx.beginPath();
        this.drawDashStroke(this.ctx, this.dashArray);
        this.ctx.stroke();
      } else {
        this.ctx.stroke();
      }
    }
  } catch (e) {
    console.log("path drawer error !!! ---> " + e.message);
    throw e;
  }
};
MMPathDrawer.prototype.getCubicBezierPt = function (pts, startIndex, length, isBezier, isClose) {
  this.arrCubicBezierPts = new Array();
  if (isBezier) {
    for (var i = 0; i < length; i = i + 3) {
      var inpt = this.trsfm.lg2dvPoint(pts[startIndex + i], this.pgindex);
      var pt = this.trsfm.lg2dvPoint(pts[startIndex + i + 1], this.pgindex);
      var outpt = this.trsfm.lg2dvPoint(pts[startIndex + i + 2], this.pgindex);
      this.arrCubicBezierPts.push({
        inp: inpt,
        p: pt,
        outp: outpt
      });
    }
    if (isClose) {
      var inpt = this.trsfm.lg2dvPoint(pts[startIndex], this.pgindex);
      var pt = this.trsfm.lg2dvPoint(pts[startIndex + 1], this.pgindex);
      var outpt = this.trsfm.lg2dvPoint(pts[startIndex + 2], this.pgindex);
      this.arrCubicBezierPts.push({
        inp: inpt,
        p: pt,
        outp: outpt
      });
    }
  } else {
    for (var i = 0; i < length; i++) {
      var pt = this.trsfm.lg2dvPoint(pts[startIndex + i], this.pgindex);
      this.arrCubicBezierPts.push({
        inp: pt,
        p: pt,
        outp: pt
      });
    }
    if (isClose) {
      var pt = this.trsfm.lg2dvPoint(pts[startIndex], this.pgindex);
      this.arrCubicBezierPts.push({
        inp: pt,
        p: pt,
        outp: pt
      });
    }
  }
};
MMPathDrawer.prototype.drawDashStroke = function (ctx, dashArray) {
  if (this.isSkeleton()) {
    this.initForSkeleton();
  }
  ;
  for (var i = 0; i < this.arrCubicBezierPts.length - 1; i++) {
    var subPath = this.calculateDashedBezier(this.arrCubicBezierPts[i], this.arrCubicBezierPts[i + 1], dashArray);
    if (subPath.length < 1) return;
    var part = subPath[0];
    ctx.moveTo(part.x, part.y);
    for (var j = 1; j < subPath.length; j++) {
      part = subPath[j];
      if (j % 2 != 0) {
        ctx.lineTo(part.x, part.y);
      } else {
        ctx.moveTo(part.x, part.y);
      }
    }
  }
};
MMPathDrawer.prototype.calculateDashedBezier = function (point1, point2, dashArray) {
  var step = 0.0005;
  var arclength = function arclength(pt1, pt2) {
    return Math.sqrt(Math.pow(pt1.x - pt2.x, 2) + Math.pow(pt1.y - pt2.y, 2));
  };
  var subPath = new Array();
  var loc = this.getBezierPt(point1, point2, 0);
  var lastLoc = loc;
  var dashIndex = 0;
  var length = 0;
  subPath.push(loc);
  for (var t = step; t <= 1; t += step) {
    loc = this.getBezierPt(point1, point2, t);
    length += arclength(lastLoc, loc);
    lastLoc = loc;
    if (length >= dashArray[dashIndex]) {
      subPath.push(loc);
      dashIndex = (dashIndex + 1) % dashArray.length;
      length = 0;
    }
  }
  subPath.push(loc);
  return subPath;
};
MMPathDrawer.prototype.getBezierPt = function (point1, point2, t) {
  return MMPathDrawer.getBezierPt(point1, point2, t);
};
MMPathDrawer.prototype.isSkeleton = function (skeleton) {
  if (skeleton != undefined) {
    this._isSkeleton = skeleton;
  }
  ;
  return this._isSkeleton;
};
MMPathDrawer.getBezierPt = function (point1, point2, t) {
  var pt = new _MMPoint["default"]();
  pt.x = point1.p.x * Math.pow(1 - t, 3) + 3 * t * (1 - t) * (1 - t) * point1.outp.x + 3 * t * t * (1 - t) * point2.inp.x + t * t * t * point2.p.x;
  pt.y = point1.p.y * Math.pow(1 - t, 3) + 3 * t * (1 - t) * (1 - t) * point1.outp.y + 3 * t * t * (1 - t) * point2.inp.y + t * t * t * point2.p.y;
  return pt;
};
var _default = exports["default"] = MMPathDrawer;

},{"1184":1184,"1414":1414,"1437":1437,"1454":1454,"1463":1463,"1478":1478,"806":806,"830":830}],959:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1431);
require(1418);
require(1463);
require(1537);
var _map = _interopRequireDefault(require(821));
var _MMMainWhiteboard = _interopRequireDefault(require(952));
var _BoardOrientation = _interopRequireDefault(require(802));
var _MMRoundArray = _interopRequireDefault(require(958));
var _ObjType = _interopRequireDefault(require(1084));
var _MMObjOperationStrategy = _interopRequireDefault(require(872));
var _MMOperationType = _interopRequireDefault(require(882));
var _Dispatcher = _interopRequireDefault(require(18));
function MMTaskboard(boardInfo_, collabInfo_) {
  if (boardInfo_) {
    this.m_closed = false;
    this.m_chatLog = [];
    _MMMainWhiteboard["default"].call(this, boardInfo_);
    this.__createPageArray();
  }
  /*
   * the users who are online
   */
  this.m_usersOnline = new _map["default"]();
}
;
MMTaskboard.prototype = new _MMMainWhiteboard["default"]();
MMTaskboard.superclass = _MMMainWhiteboard["default"].prototype;
MMTaskboard.prototype.decode = function (dc_, ver_) {
  MMTaskboard.superclass.decode.call(this, dc_, ver_);
  var _ver = dc_.decodeFrom4Bytes();
  this.m_chatLog = dc_.decodeFromArray(ver_, 'Meta');
  this.m_closed = dc_.decodeFromBool(ver_);
};
MMTaskboard.prototype.__createPageArray = function () {
  var rounds = new _MMRoundArray["default"](this, this.m_pageWidth, this.m_pageHeight);
  var localTime = new Date();
  localTime = localTime.getTime() / 1000;
  rounds.addPage(false, 1, localTime);
  this.m_pagesInfo = rounds;
};
MMTaskboard.prototype.getChatLog = function (objId_) {
  var resChatLog = [];
  for (var i = 0; i < this.m_chatLog.length; i++) {
    var msg = this.m_chatLog[i];
    var iObjId = msg.getObjId();
    if (!objId_) {
      if (iObjId.isBlank()) {
        resChatLog.push(msg);
      }
    } else {
      if (iObjId.isEqualTo(objId_)) {
        resChatLog.push(msg);
      }
    }
  }
  return resChatLog;
};
MMTaskboard.prototype.sortMessages = function () {
  this.m_chatLog.sort(function (a, b) {
    return a.m_time - b.m_time;
  });
};
MMTaskboard.prototype.addMessage = function (msg_) {
  this.m_chatLog.push(msg_);
  //  this.sortMessages();
};
MMTaskboard.prototype.getCommentsInPage = function (pgIndex) {
  var comments = new Array();
  var objsInPage = this.getObjsInPage(pgIndex);
  for (var i = 0; i < objsInPage.length; i++) {
    if (objsInPage[i].m_objType == _ObjType["default"].Obj_comment) {
      comments.push(objsInPage[i]);
    }
  }
  return comments;
};
MMTaskboard.prototype.getVisibleComentsInPage = function (view, pgIndex) {
  var ret = [];
  var objs = view.getObjsInView();
  //todo:  view.getObjsInView() returns null;
  if (objs) {
    for (var i = 0; i < objs.length; i++) {
      var obj = objs[i];
      if (obj.m_objType == _ObjType["default"].Obj_comment && _MMObjOperationStrategy["default"].getOperataionTypeForMolaTask(obj, pgIndex) != _MMOperationType["default"].Operation_hidden) {
        ret.push(obj);
      }
    }
  }
  return ret;
};
MMTaskboard.prototype.setCommentActive = function (commentObj) {
  var pgIndex = commentObj.getPageIndex();
  var commentsInPage = this.getCommentsInPage(pgIndex);
  for (var i = 0; i < commentsInPage.length; i++) {
    if (commentsInPage[i] == commentObj) {
      commentsInPage[i].setActive(true);
    } else {
      commentsInPage[i].setActive(false);
    }
  }
};
MMTaskboard.prototype.clearCommentsActiveInPage = function (pgIndex) {
  var commentsInPage = this.getCommentsInPage(pgIndex);
  for (var i = 0; i < commentsInPage.length; i++) {
    commentsInPage[i].setActive(false);
  }
};
MMTaskboard.prototype.isUserCommittedRound = function (userId, roundIndex_) {
  var committed = false;
  committed = this.m_pagesInfo.isUserCommittedRound(userId, roundIndex_);
  return committed;
};
MMTaskboard.prototype.isCurrentUserCommittedRound = function (roundIndex_) {
  var userId = app.currentUser.getUserId_Int();
  return this.isUserCommittedRound(userId, roundIndex_);
};
MMTaskboard.prototype.isCreatorCommittedRound = function (roundIndex_) {
  return this.isUserCommittedRound(this.getCreatorId(), roundIndex_);
};
MMTaskboard.prototype.currentUserHasNeedCommittedRound = function () {
  var pageCount = this.getPageCount();
  for (var i = 0; i < pageCount; i++) {
    if (this.currentUserNeedCommitRound(i)) {
      return true;
    }
  }
  return false;
};
MMTaskboard.prototype.getCurrentUserVisibleRoundCount = function () {
  var userId = app.currentUser.getUserId_Int();
  var creatorId = this.getCreatorId();
  var pgCount = this.getPageCount();
  if (!userId.isEqualTo(creatorId)) {
    if (!this.isCreatorCommittedRound(pgCount - 1)) {
      pgCount--;
    }
  }
  if (pgCount < 0) pgCount = 0;
  return pgCount;
};
MMTaskboard.prototype.currentUserNeedCommitRound = function (roundIndex_) {
  var userId = app.currentUser.getUserId_Int();
  if (!this.isUserCommittedRound(userId, roundIndex_)) {
    var ids = this.getUserObjectsInPage(roundIndex_, userId);
    if (ids.length > 0) {
      return true;
    }
  }
  return false;
};
MMTaskboard.prototype.commitRound = function (pageIndex_, commitUser_) {
  this.m_pagesInfo.commitRound(pageIndex_, commitUser_);
};
MMTaskboard.prototype.isClosed = function () {
  return this.m_closed;
};
MMTaskboard.prototype.setClosed = function (flag_) {
  this.m_closed = flag_;
};
MMTaskboard.prototype.clearUserOnline = function () {
  this.m_usersOnline.forEach(function (value_, key_) {
    _Dispatcher["default"].trigger(MDEvents.PARTICIPANT_LEFT, key_);
  });
  this.m_usersOnline.clear();
}, MMTaskboard.prototype.setUserOnline = function (userId) {
  var temp = this.m_usersOnline.get(userId);
  if (temp) {
    this.m_usersOnline.set(userId, temp + 1);
  } else {
    this.m_usersOnline.set(userId, 1);
  }
  _Dispatcher["default"].trigger(MDEvents.PARTICIPANT_ENTER, userId);
}, MMTaskboard.prototype.setUserOffline = function (userId) {
  var temp = this.m_usersOnline.get(userId);
  if (temp) {
    if (temp >= 2) {
      this.m_usersOnline.set(userId, temp - 1);
      return;
    }
  }
  this.m_usersOnline.remove(userId);
  _Dispatcher["default"].trigger(MDEvents.PARTICIPANT_LEFT, userId);
}, MMTaskboard.prototype.isUserOnline = function (userId) {
  if (userId == app.currentUser.getUserId()) return true;
  var temp = this.m_usersOnline.get(userId);
  if (temp) {
    if (temp >= 1) {
      return true;
    } else {
      console.assert(false);
    }
  }
  return false;
};
MMTaskboard.prototype.getUserUncommitedObjectsInPage = function (pgIndex_, userId_) {
  var arrUsrObjs = [];
  var arrObjs = this.getObjsInPage(pgIndex_);
  for (var i = 0; i < arrObjs.length; i++) {
    var object = arrObjs[i];
    if (object.getCreator().valueOf() == userId_.valueOf() && !object.isCommited()) {
      arrUsrObjs.push(object);
    }
  }
  return arrUsrObjs;
};
MMTaskboard.prototype.hasUncommitedContent = function (pageIndex_) {
  var _userId = app.currentUser.getUserId_Int();
  var objects = this.getUserUncommitedObjectsInPage(pageIndex_, _userId);
  return objects.length > 0;
};
MMTaskboard.prototype.isCurrentUserCommitable = function (roundIndex_) {
  var userId = app.currentUser.getUserId_Int();
  if (!this.isCreatorCommittedRound(roundIndex_) && this.getCreatorId().valueOf() != userId.valueOf()) return false;
  return this.m_pagesInfo.isCommitable(userId, roundIndex_);
};
MMTaskboard.prototype.setCommitable = function (userId, roundIndex_) {
  this.m_pagesInfo.setCommitable(userId, roundIndex_);
};
MMTaskboard.prototype.setUncommitable = function (userId, roundIndex_) {
  this.m_pagesInfo.setUncommitable(userId, roundIndex_);
};
MMTaskboard.prototype.getImgPdfObjectInPage = function (pageIndex_) {
  var _objects = this.getImgPdfObjects();
  for (var i = 0; i < _objects.length; i++) {
    if (_objects[i].getPageIndex() == pageIndex_) {
      return _objects[i];
    }
  }
  ;
  return null;
};
MMTaskboard.prototype.getImageRatioInPage = function (pageIndex_) {
  var _object = this.getImgPdfObjectInPage(pageIndex_);
  if (_object.getOriginSize) {
    var _originSize = _object.getOriginSize();
    return _originSize.width / _originSize.height;
  } else {
    return 0.6667;
  }
};
MMTaskboard.prototype.getThumbnailURLForPage = function (pageIndex_) {
  var _object = this.getImgPdfObjectInPage(pageIndex_);
  if (_object.getLowPixelFilePath) {
    return _object.getLowPixelFilePath();
  }
  console.assert(false);
};

//MMTaskboard.prototype.initWithPDFDocument = function(url_) {
//    PDFJS.getDocument(url_,undefined,undefined,function(param){
//        console.log('loaded:'+param.loaded+" total:"+param.total,param);
//      }).then(function(){
//        var _pageCount = pdf.numPages();
//        var trsfm = this.m_operationCenter.getTransformer();
//        for (var i = 0 ; i < _pageCount ; i ++) {
//            this.m_actionManager.createNewRound(function(){
//                var _pageObj = new MMPDFDocument(this);
//                _pageObj.setDevPts(trsfm, pathDVPoints, i);
//                _pageObj.setDevOrientation(BoardOrientation.Portrait);
//                this.m_actionManager.addObject(_pageObj);
//            }, function(){
//                console.assert(false);
//            });
//        }
//    });
//}
var _default = exports["default"] = MMTaskboard;

},{"1084":1084,"1184":1184,"1418":1418,"1431":1431,"1437":1437,"1454":1454,"1463":1463,"1537":1537,"18":18,"802":802,"821":821,"872":872,"882":882,"952":952,"958":958}],952:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMWhiteboard = _interopRequireDefault(require(960));
var _Decoder = _interopRequireDefault(require(799));
function MMMainWhiteboard(boardInfo_, collabInfo_) {
  if (boardInfo_) {
    var _id = boardInfo_.m_id;
    _MMWhiteboard["default"].call(this, _id);
    this.m_boardInfo = boardInfo_;
  }
}
;
MMMainWhiteboard.prototype = new _MMWhiteboard["default"]();
MMMainWhiteboard.superclass = _MMWhiteboard["default"].prototype;
MMMainWhiteboard.prototype.decode = function (dc_, ver_) {
  _MMWhiteboard["default"].prototype.decode.call(this, dc_, ver_);
  var _objVer = dc_.decodeFrom4Bytes(ver_);
  this.m_seq = dc_.decodeFrom8Bytes(ver_);
  var _temp = dc_.decodeFrom4Bytes(ver_);
  console.assert(_temp == 0);
};
MMMainWhiteboard.prototype.encode = function (ec_) {
  _MMWhiteboard["default"].prototype.encode.call(this, ec_);
};
/**
 *
 * @param chatMessage_ {MMChatMessage}
 * @returns
 */
MMMainWhiteboard.prototype.addMessage = function (chatMessage_) {
  var _coopid = chatMessage_.getSessionid();
  var _coop = this.m_coops.get(_coopid, null); //MMCooperation,该类还为实现
  if (_coop != null) {
    _coop.addMessage(chatMessage_);
  }
};
MMMainWhiteboard.prototype.initFromNetwork_help = function (data_) {
  if (data_) {
    var _dec = new _Decoder["default"](this);
    _dec.setStream(data_);
    this.decode(_dec, ___MM_DOC_VERSION__);
  } else {
    this.m_pagesInfo.addPage(false, 2);
  }
};
MMMainWhiteboard.prototype.getMotherBoardId = function () {
  return this.m_id;
};
MMMainWhiteboard.prototype.getMotherBoardStringId = function () {
  console.assert(this.m_id);
  return this.m_id.toDecString();
};
MMMainWhiteboard.prototype.getCreatorId = function () {
  return this.m_boardInfo.m_creator;
};
MMMainWhiteboard.prototype.getParticipants = function () {
  if (this.m_participants) {
    return this.m_participants;
  }
  ;
  return [];
};

//todo: provide a method for production
MMMainWhiteboard.prototype.getRemoteDURL = function (fileName_) {
  return MMCommonFun.getRemoteDURL(this.m_boardInfo.m_creator.toDecString(), this.m_boardInfo.m_id.toDecString(), fileName_);
};

//
// MMMainWhiteboard.prototype.getThumbnailForPage = function(pageIndex_) {
//   return MMCommonFun.getThumbnailOfDoc(this.m_boardInfo.m_creator.toDecString(), this.m_boardInfo.m_id.toDecString(), pageIndex_);
// };
//

MMMainWhiteboard.prototype.isMainBoard = function () {
  return true;
};
var _default = exports["default"] = MMMainWhiteboard;

},{"1184":1184,"1454":1454,"799":799,"960":960}],960:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MMWhiteboard;
require(1437);
require(1432);
require(1463);
require(1478);
require(1412);
require(1476);
require(1477);
require(1418);
require(1537);
require(1461);
var _MDSalonScribble = _interopRequireDefault(require(211));
var _BackgroundPaperAttr = _interopRequireDefault(require(946));
var _MMLayerAction = _interopRequireDefault(require(977));
var _Layer_Move_Type = _interopRequireDefault(require(962));
var _BoardType = _interopRequireDefault(require(947));
var _MMRect = _interopRequireDefault(require(831));
var _ObjType = _interopRequireDefault(require(1084));
var _basicMath = _interopRequireDefault(require(832));
var _OBJ_ID = _interopRequireDefault(require(818));
var _MMOperationType = _interopRequireDefault(require(882));
var _MMObject = _interopRequireDefault(require(1081));
var _MMPagesInfo = _interopRequireDefault(require(956));
var _MMObjManager = _interopRequireDefault(require(954));
var _MMObjDataManager = _interopRequireDefault(require(953));
var _MMObjElementsController = _interopRequireDefault(require(893));
var _MMObjOperationStrategy = _interopRequireDefault(require(872));
var _map = _interopRequireDefault(require(821));
var _MMIdManager = _interopRequireDefault(require(951));
var _MMActionManager = _interopRequireDefault(require(964));
var _MMSketchCommentController = _interopRequireDefault(require(885));
var _MMObjectFilter = _interopRequireDefault(require(955));
var _FilterType = _interopRequireDefault(require(949));
var MMLogicPageWidth = 15; // cm
var MMLogicPageHeight = 20; // cm
window.MMLogicPageWidth = MMLogicPageWidth;
window.MMLogicPageHeight = MMLogicPageHeight;

//
// 白板基类
//
function MMWhiteboard(id_) {
  this.m_ver = 0;
  this.m_defaultRecNum = 1;
  this.m_id = id_;
  this.m_type = _BoardType["default"].enumWhiteBoardMain;
  this.m_pageWidth = MMLogicPageWidth;
  this.m_pageHeight = MMLogicPageHeight;
  this.m_createdTime = new Date().getTime() / 1000;
  this.m_pagesInfo = new _MMPagesInfo["default"](this, this.m_pageWidth, this.m_pageHeight);
  this.m_objManager = new _MMObjManager["default"](this);
  this.m_objDataManager = new _MMObjDataManager["default"](this);
  this.m_actionManager = new _MMActionManager["default"](this);
  this.m_orderedObjIds = new Array(); // 按照加入对象的顺序存储

  this.m_selectedObjects = [];
  this.delayedDrawWaitingCount = 0;

  /*
   * 64位整数
   */
  this.m_seq = -1;
  this.m_changed = false;
}
;
_.extend(MMWhiteboard.prototype, Backbone.Events);
MMWhiteboard.prototype.isVirtualBoard = function () {
  return false;
};
MMWhiteboard.prototype.getType = function () {
  return this.m_type;
};
MMWhiteboard.prototype.getPagesController = function () {
  return this.m_pagesInfo;
};
MMWhiteboard.prototype.getType = function () {
  return this.m_type;
};
MMWhiteboard.prototype.isMainBoard = function () {
  return false;
};
MMWhiteboard.prototype.getSeq = function () {
  return this.m_seq;
};
MMWhiteboard.prototype.setSeq = function (seq_) {
  this.m_seq = seq_;
};
MMWhiteboard.prototype.stepSeq = function () {
  this.m_seq++;
};
MMWhiteboard.prototype.destruct = function () {
  this.m_objManager.destruct();
  this.m_objDataManager.destruct();
  this.actionManager.destruct();
};
MMWhiteboard.prototype.getId = function () {
  return this.m_id;
};
MMWhiteboard.prototype.getStringId = function () {
  return this.m_id.toDecString();
};
MMWhiteboard.prototype.getObject = function (id_) {
  return this.m_objManager.getObject(id_);
};
/**
 *
 * @param arrId {Array<OBJ_ID>}
 * @param mutex_ {bool}
 * @returns Array<MMObject>
 */
MMWhiteboard.prototype.getObjsById = function (arrId, mutex_) {
  var arrObjs = new Array();
  if (!(arrId instanceof Array)) {
    arrId = [arrId];
  }
  if (mutex_) {}
  for (var i = 0; i < arrId.length; i++) {
    var obj = this.getObject(arrId[i]);
    if (obj) {
      arrObjs.push(obj);
    }
  }
  if (mutex_) {}
  return arrObjs;
};
MMWhiteboard.prototype.connected = function (conn_) {
  this.m_actionManager.connected(conn_);
  this.m_objDataManager.connected(conn_);
};
MMWhiteboard.prototype.__addObject = function (object_, isMark_) {
  var layerIndex = this.m_orderedObjIds.length;
  object_.setLayerIndex(layerIndex);
  console.assert(object_ instanceof _MMObject["default"]);
  var _id = this.m_objManager.saveObject(object_);

  /*
   */
  object_.saveToDataManager();

  // mark 对象不存储在 m_orderedObjIds，仅保存在 objectManager 中
  if (!isMark_) {
    this.m_orderedObjIds.push(_id);
  } else {
    object_.m_isMark = true;
  }
  //    this.testObjs.push(object_); // used to test

  return _id;
};
MMWhiteboard.prototype.addObject = function (object_) {
  return this.__addObject(object_, false);
};
MMWhiteboard.prototype.addInitObject = function (object_) {
  return this.__addObject(object_, false);
};
MMWhiteboard.prototype.addMarkObjects = function (objects_) {
  for (var i = 0; i < objects_.length; i++) {
    this.m_objManager.saveObject(objects_[i]);
  }
};
/**
 *
 * @param objectMap_ Map<int32,MMObject>
 */
MMWhiteboard.prototype.addObjectFromMap = function (objectMap_) {
  var _ret = new _map["default"](); //map<__int32_t, OBJ_ID>
  var addedObjs = new Array(); //vector<MMObject*>
  var keys = objectMap_.getKeys();

  //处理每个对象
  for (var i = 0; i < keys.length; i++) {
    var _layer = keys[i];
    var _object = objectMap_.get(keys[i]); //MMObject
    //    assert(_object != null);
    if (_object != null) {
      /*
       * 将对象重新加入对象管理器、白板
       */
      var _id = this.m_objManager.saveObject(_object); //OBJ_ID
      addedObjs.push(_object);
      _ret.set(_layer, _id);
      _object.saveToDataManager();
      if (_object.getObjType() == _ObjType["default"].Obj_Recorder || _object.getObjType() == _ObjType["default"].Obj_Image || _object.getObjType() == _ObjType["default"].Obj_PDF || _object.getObjType() == _ObjType["default"].Obj_Document) {
        //m_resourcemgr->addPath(_object->getFilePath());//待实现
      }
      if (_layer >= 0) {
        if (this.m_orderedObjIds.length <= _layer) {
          this.m_orderedObjIds.push(_id);
        } else {
          this.m_orderedObjIds.splice(_layer, 0, _id); //参考，http://www.w3school.com.cn/jsref/jsref_splice.asp
        }
      } else {
        _object.m_isMark = true;
      }
    }
  }

  //更新对象层次
  this._updateObjsLayerIntersectWithObjs(addedObjs);
  return _ret;
};
/**
 *
 * @param ids_  {Array<OBJ_ID>}
 */
MMWhiteboard.prototype.getObjectLayer = function (ids_) {
  var _ret = new _map["default"](); //map<__int32_t, MMObject*>
  if (ids_.length > 0) {
    for (var i = 0; i < ids_.length; i++) {
      /*
       *map:层次-对象
       */
      var iTmp = ids_[i];
      var _obj = iTmp instanceof _OBJ_ID["default"] ? this.getObject(iTmp) : iTmp; //MMObject
      if (_obj != null) {
        var key = this.getLayer(_obj);
        _ret.set(key, _obj);
      } else {}
    }
  }
  return _ret;
};

/**
 *
 * @param id_  {OBJ_ID}
 */
MMWhiteboard.prototype.getLayer = function (id_) {
  var iTmp = id_ instanceof _OBJ_ID["default"] ? id_ : id_.getId();
  for (var i = 0; i < this.m_orderedObjIds.length; i++) {
    if (this.m_orderedObjIds[i].toString() == iTmp.toString()) {
      return i;
    }
  }
  if (_MMSketchCommentController["default"]) {
    return _MMSketchCommentController["default"].getLayer(iTmp);
  }
  return 0;
};
/**
 * 改变指定对象的层次
 * @param objs_  Array<OBJ_ID>
 * @param type {int}
 */
MMWhiteboard.prototype.changeLayerForObjs = function (objs_, type) {
  var _layerInfo = new _MMLayerAction["default"]();
  if (objs_ == null || objs_.length == 0) {
    return _layerInfo;
  }
  _layerInfo.setObjsID(objs_);

  // 获得旧位置
  var oldIndex = new Array();
  for (var i = 0; i < objs_.length; i++) {
    var index = this.m_orderedObjIds.length;
    for (var j = 0; j < this.m_orderedObjIds.length; j++) {
      if (this.m_orderedObjIds[j].toString() == objs_[i].toString()) {
        index = j;
      }
    }
    console.assert(index < this.m_orderedObjIds.length);
    oldIndex.push(index);
  }
  // 计算新位置
  var newStart = 0;
  if (type == _Layer_Move_Type["default"].enumLayerMoveToFront) {
    newStart = this.m_orderedObjIds.length - objs_.length;
  }
  // 记录位置信息
  _layerInfo.setPositionInfo(oldIndex, newStart);
  // 改变层次
  this.changeLayerByLayerInfo(_layerInfo, false); // 本级已经保证互斥访问，所以改变层次时不需要再互斥，否则会死锁
};
/**
 *
 * @param layerInfo_
 * @param mutex_ {bool}
 */
MMWhiteboard.prototype.changeLayerByLayerInfo = function (layerInfo_, mutex_) {
  if (mutex_) {}
  if (layerInfo_.m_do == Undo_Redo_Type.MM_DO) {
    // 从旧位置删除
    for (var i = 0; i < layerInfo_.m_ids.length; i++) {
      for (var j = 0; j < this.m_orderedObjIds.length; j++) {
        if (this.m_orderedObjIds[j].toString() == layerInfo_.m_ids[i].toString()) {
          this.m_orderedObjIds.splice(j, 1);
          break;
        }
      }
    }
    // 插入到指定位置
    var index = layerInfo_.m_newStart;
    if (index > this.m_orderedObjIds.length) {
      index = this.m_orderedObjIds.length;
    }
    for (var i = 0; i < layerInfo_.m_ids.length; i++) {
      this.m_orderedObjIds.splice(index++, 0, layerInfo_.m_ids[i]);
    }
  } else {
    // 从新位置删除
    this.m_orderedObjIds.splice(layerInfo_.m_newStart, layerInfo_.m_ids.length);

    // 恢复到旧位置
    for (var i = 0; i < layerInfo_.m_ids.length; i++) {
      this.m_orderedObjIds.splice(layerInfo_.m_oldIndex[i], 0, layerInfo_.m_ids[i]);
    }
  }
  var changedObjs = layerInfo_.getObject(this, false);
  this._updateObjsLayerIntersectWithObjs(changedObjs);
};

/**
 * 更新对象层次
 *@param  changedObjs  {Array<MMObject>}
 */
MMWhiteboard.prototype._updateObjsLayerIntersectWithObjs = function (changedObjs) {
  for (var i = 0; i < this.m_orderedObjIds.length; i++) {
    var _object = this.m_objManager.getObject(this.m_orderedObjIds[i]);
    //    assert(_object != null);
    if (_object != null) {
      var lgRect = _object.getRect();
      var intersect = false;
      for (var k = 0; k < changedObjs.length; k++) {
        var changeObj = changedObjs[k];
        //判断两个矩形是否相交
        if (_basicMath["default"].intersects(lgRect, changeObj.getRect())) {
          intersect = true;
          break;
        } else {}
        ;
      }
      if (intersect) {
        _object.setLayerIndex(i);
      } else {}
      ;
    } else {}
    ;
  }
};
/**
 *
 * @param index_ {int32}
 * @param bkGrdAttr {BackgroundPaperAttr}
 * @returns {bool}
 */
MMWhiteboard.prototype.getPageBackGroundByIndex = function (index_, bkGrdAttr) {
  if (this.m_pagesInfo.getBackgroundPaperAttr(index_, bkGrdAttr)) {
    return true;
  } else {
    return false;
  }
};
/**
 *
 * @param index_ {int32}
 * @param bkGrdAttr {BackgroundPaperAttr}
 */
MMWhiteboard.prototype.setPageBackGroundByIndex = function (index_, bkGrdAttr) {
  this.m_pagesInfo.setBackgroundPaperAttr(index_, bkGrdAttr);
};

/**
 *
 * @param defaultBackGround {!BackgroundPaperAttr}
 * @param specialBackGround {!map<unsigned, BackgroundPaperAttr>}
 */
MMWhiteboard.prototype.getPageBackGround = function (defaultBackGround, specialBackGround) {
  this.m_pagesInfo.getPageBackGround(defaultBackGround, specialBackGround);
};
/**
 *
 * @param defaultBackGround {!BackgroundPaperAttr}
 * @param specialBackGround {!map<unsigned, BackgroundPaperAttr>}
 */
MMWhiteboard.prototype.setPageBackGround = function (defaultBackGround, specialBackGround) {
  this.m_pagesInfo.setPageBackGround(defaultBackGround, specialBackGround);
  //做刷新操作，待实现...
};

/**
 *
 * @param defaultBackGround {!BackgroundPaperAttr}
 */
MMWhiteboard.prototype.setDefaultPageBackGround = function (defaultBackGround) {
  this.m_pagesInfo.setDefaultPageBackGround(defaultBackGround);
};
MMWhiteboard.prototype.removePageBackGround = function (index_) {
  this.m_pagesInfo.removePageBackGround(index_);
  //刷新操作，待实现...
};
MMWhiteboard.prototype.__notifyAction = function (actionInfo_) {
  this.m_actionManager.notify(actionInfo_);
};
MMWhiteboard.prototype.__delObject = function (id_) {
  for (var i = 0; i < this.m_orderedObjIds.length; i++) {
    //lishusheng,2014-06-17
    if (this.m_orderedObjIds[i].toString() == id_.toString()) {
      this.m_orderedObjIds.splice(i, 1);
      break;
    }
  }
  var _object = this.m_objManager.getObject(id_);
  if (_object) {
    _object.releaseElement();
    _MMObjElementsController["default"].getSingleInstance().removeObj(_object);
    _object.removeFromDataManager();
    this.m_objManager.deleteObject(id_);
  }
  ;
  return _object;
};
MMWhiteboard.prototype.openDocument = function () {};
MMWhiteboard.prototype.performAction = function (actionInfo_) {
  this.m_actionManager.performAction(actionInfo_);
};
MMWhiteboard.prototype.addPage = function (refreshView_, pageNum) {
  this.m_pagesInfo.addPage(refreshView_, pageNum, 0, false);
};
MMWhiteboard.prototype.changeBground = function (index_, bgPaper_) {};
MMWhiteboard.prototype.redrawWithinRect = function (logicRect_) {};
MMWhiteboard.prototype.setChangedMark = function (flag_) {
  this.m_changed = true;
};
MMWhiteboard.prototype.getChangedMark = function () {
  return this.m_changed;
};

/*
 * @param {!Set<OBJ_ID>}
 * @return{!Set<ID>}
 */
MMWhiteboard.prototype.getCollabIds = function (ids_) {};
/**
 *
 * @param pageIndex_ {int}
 * @return {Int64}
 */
MMWhiteboard.prototype.getCoopIdByPage = function (pageIndex_) {};

/*
 */
MMWhiteboard.prototype.shuffle = function (newObjs_, baseObj_) {
  if (_MMIdManager["default"].isBlank(baseObj_)) {
    return;
  }
  for (var i = newObjs_.length - 1; i >= 0; i--) {
    this.m_orderedObjIds.pop();
  }
  var _baseIndex = this.m_orderedObjIds.length;
  for (var i = 0; i < this.m_orderedObjIds.length; i++) {
    if (this.m_orderedObjIds[i] === baseObj_) {
      _baseIndex = i;
      break;
    }
  }
  if (_baseIndex >= this.m_orderedObjIds.length - 1) {
    this.m_orderedObjIds.concat(newObjs_);
  } else {
    Array.prototype.splice.apply(this.m_orderedObjIds, [_baseIndex + 1, 0].concat(newObjs_));
  }
};
MMWhiteboard.prototype.isReadOnly = function () {
  return true;
};
MMWhiteboard.prototype.clearDispDiv = function (parentDiv) {
  for (var i = 0; i < this.m_orderedObjIds.length; i++) {
    var _object = this.m_objManager.getObject(this.m_orderedObjIds[i]);
    _object.clearDispDiv(parentDiv);
  }
};

/**
 * draw object in canvas
 * @param {canvas context} ctx
 * @param trsfm
 * @param pgindex
 * @param lgRct
 * @param objFilter
 */
MMWhiteboard.prototype.drawPageThumbnailInCanvas = function (ctx, trsfm, pgindex, successCallback, failedCallback) {
  var objFilter = new _MMObjectFilter["default"]();
  objFilter.type = _FilterType["default"].NotInlcude;
  //  objFilter.objTypes.push(ObjType.Obj_Image);

  if (this.delayedDrawWaitingCount == 0) {
    // no waiting, so
    // 背景
    var bkGrd = this.getBkgrdInfo(pgindex);
    if (bkGrd != null && bkGrd != undefined) {
      //bkGrd.drawInCanvas(ctx, trsfm);
    }
    this.thumbnailQueue = this.getObjsInPageByFilter(pgindex, objFilter);
    this.drawObjOneByOne(ctx, trsfm, pgindex, successCallback);
  } else {
    // previous draw not finished,so ignore current draw
    if (failedCallback != undefined && failedCallback != null) {
      failedCallback();
    }
  }
};
MMWhiteboard.prototype.drawObjOneByOne = function (ctx, trsfm, pgIndex, successCallback) {
  var that = this;
  var delay = 0;
  while (this.thumbnailQueue.length > 0) {
    var obj = this.thumbnailQueue[0];
    delay = this.thumbnailQueue[0].draw(ctx, trsfm, pgIndex, function () {
      that.thumbnailQueue.splice(0, 1);
      that.drawObjOneByOne(ctx, trsfm, pgIndex, successCallback);
    });
    if (delay == undefined || delay == 0) {
      this.thumbnailQueue.splice(0, 1);
    } else {
      break;
    }
  }
  if (this.thumbnailQueue.length == 0 && (delay == undefined || delay == 0)) {
    successCallback();
  }
};

/**
 * draw object in canvas
 * @param {canvas context} ctx
 * @param trsfm
 * @param pgindex
 * @param lgRct
 * @param objFilter
 */
MMWhiteboard.prototype.drawObjsInCanvas = function (ctx, trsfm, pgindex, objFilter, lgRct) {
  //----todo  计算焊接标记的外接矩形
  var objs = this.getObjsInPageByFilter(pgindex, objFilter, lgRct);
  for (var i = 0; i < objs.length; i++) {
    //point 1.
    if (_MMObjOperationStrategy["default"].getOperataionTypeForMolaTask(objs[i], pgindex) == _MMOperationType["default"].Operation_hidden) {
      continue;
    }
    objs[i].draw(ctx, trsfm, pgindex);
  }
};
MMWhiteboard.prototype.drawCommentsInCanvas = function (ctx, trsfm, pgindex, objFilter, lgRct) {
  var objs = this.getObjsInPageByFilter(pgindex, objFilter, lgRct);
  for (var i = 0; i < objs.length; i++) {
    //point 1.
    if (_MMObjOperationStrategy["default"].getOperataionTypeForMolaTask(objs[i], pgindex) == _MMOperationType["default"].Operation_hidden || objs[i].getClassName() != 'MMGraphComment') {
      continue;
    }
    objs[i].draw(ctx, trsfm, pgindex);
  }
};

/**
 * draw objects with div
 * @param editor
 * @param trsfm
 * @param pgindex
 * @param lgRct
 * @param {FilterType} objFilter - objects filter
 */
MMWhiteboard.prototype.drawObjsInDiv = function (editor, trsfm, pgindex, objFilter, lgRct) {
  var lgSize = this.getPageSize();
  var pgRct = new _MMRect["default"](pgindex * lgSize.height, lgSize.width, (pgindex + 1) * lgSize.height, 0);
  for (var i = 0; i < this.m_orderedObjIds.length; i++) {
    var _object = this.m_objManager.getObject(this.m_orderedObjIds[i]);
    if (_object.canDrawInDiv()) {
      if (objFilter != undefined && objFilter != null && objFilter.isObjRemovedByFilter(_object)) continue;
      var objRct = _object.m_expandRect;

      //objRct.debugOutput("object rect:");

      if (!_basicMath["default"].intersects(objRct, pgRct)) continue;
      if (_object.getPageIndex() != pgindex) continue;

      //    console.log(_object.m_className);

      if (_object == undefined || _object == null) continue;
      if (_MMObjOperationStrategy["default"].getOperataionTypeForMolaTask(_object, pgindex) == _MMOperationType["default"].Operation_hidden) continue;
      if (lgRct != undefined && lgRct != null) {
        // 如果有刷新范围，则此处进行相交判断
        if (_basicMath["default"].intersects(objRct, lgRct)) {
          _object.drawInDiv(editor, trsfm, pgindex);
        }
      } else {
        _object.drawInDiv(editor, trsfm, pgindex);
      }
    }
  }
};
MMWhiteboard.prototype.drawImagesInDiv = function (editor, trsfm, pgindex, objFilter, lgRct) {
  var lgSize = this.getPageSize();
  var pgRct = new _MMRect["default"](pgindex * lgSize.height, lgSize.width, (pgindex + 1) * lgSize.height, 0);
  for (var i = 0; i < this.m_orderedObjIds.length; i++) {
    var _object = this.m_objManager.getObject(this.m_orderedObjIds[i]);
    if (_object.canDrawInDiv() && _object.m_objType == _ObjType["default"].Obj_Image) {
      if (objFilter != undefined && objFilter != null && objFilter.isObjRemovedByFilter(_object)) continue;
      var objRct = _object.m_expandRect;

      //objRct.debugOutput("object rect:");

      if (!_basicMath["default"].intersects(objRct, pgRct)) continue;
      if (_object.getPageIndex() != pgindex) continue;

      //      console.log(_object.m_className);

      if (_object == undefined || _object == null) continue;
      if (_MMObjOperationStrategy["default"].getOperataionTypeForMolaTask(_object, pgindex) == _MMOperationType["default"].Operation_hidden) continue;
      if (lgRct != undefined && lgRct != null) {
        // 如果有刷新范围，则此处进行相交判断
        if (_basicMath["default"].intersects(objRct, lgRct)) {
          _object.drawInDiv(editor, trsfm, pgindex);
        }
      } else {
        _object.drawInDiv(editor, trsfm, pgindex);
      }
    }
  }
};
MMWhiteboard.prototype.drawAuxiliaryInDiv = function (editor, trsfm, pgindex, objFilter, lgRct) {
  var lgSize = this.getPageSize();
  var pgRct = new _MMRect["default"](pgindex * lgSize.height, lgSize.width, (pgindex + 1) * lgSize.height, 0);
  for (var i = 0; i < this.m_orderedObjIds.length; i++) {
    var _object = this.m_objManager.getObject(this.m_orderedObjIds[i]);
    if (_object.canDrawInDiv() && _object.m_objType != _ObjType["default"].Obj_Image) {
      if (objFilter != undefined && objFilter != null && objFilter.isObjRemovedByFilter(_object)) continue;
      var objRct = _object.m_expandRect;

      //objRct.debugOutput("object rect:");

      if (!_basicMath["default"].intersects(objRct, pgRct)) continue;
      if (_object.getPageIndex() != pgindex) continue;

      //      console.log(_object.m_className);

      if (_object == undefined || _object == null) continue;
      if (_MMObjOperationStrategy["default"].getOperataionTypeForMolaTask(_object, pgindex) == _MMOperationType["default"].Operation_hidden) continue;
      if (lgRct != undefined && lgRct != null) {
        // 如果有刷新范围，则此处进行相交判断
        if (_basicMath["default"].intersects(objRct, lgRct)) {
          _object.drawInDiv(editor, trsfm, pgindex);
        }
      } else {
        _object.drawInDiv(editor, trsfm, pgindex);
      }
    }
  }
};
MMWhiteboard.prototype.draw = function (imgpdftype, ctx, trsfm, pgindex, lgRct) {
  //  for(var i=0; i < this.testObjs.length; i++){
  //    var obj = this.testObjs[i];
  //    obj.draw(ctx, trsfm, pgindex);
  //  }
  var lgSize = trsfm.lgpgsize;
  var pgRct = new _MMRect["default"](pgindex * lgSize.height, lgSize.width, (pgindex + 1) * lgSize.height, 0);
  for (var i = 0; i < this.m_orderedObjIds.length; i++) {
    var _object = this.m_objManager.getObject(this.m_orderedObjIds[i]);
    if (imgpdftype == "geo" && (_object.m_objType == _ObjType["default"].Obj_Image || _object.m_objType == _ObjType["default"].Obj_PDF) || imgpdftype == "img" && _object.m_objType != _ObjType["default"].Obj_Image && _object.m_objType != _ObjType["default"].Obj_PDF) {
      continue;
    }
    var objRct = _object.m_expandRect;
    if (!_basicMath["default"].intersects(objRct, pgRct)) continue;

    //    console.log(_object.m_className);

    if (_object == undefined || _object == null) continue;
    if (lgRct != undefined && lgRct != null) {
      // 如果有刷新范围，则此处进行相交判断
      if (_basicMath["default"].intersects(objRct, lgRct)) {
        _object.draw(ctx, trsfm, pgindex);
      }
    } else {
      _object.draw(ctx, trsfm, pgindex);
    }
  }
};
MMWhiteboard.prototype.changeEditable = function (trsfm) {
  for (var i = 0; i < this.testObjs.length; i++) {
    var obj = this.testObjs[i];
    obj.changeEditable(trsfm);
  }
};
//测试用的
MMWhiteboard.prototype.testIterator = function () {
  for (var i = 0; i < this.m_orderedObjIds.length; i++) {
    var _object = this.m_objManager.getObject(this.m_orderedObjIds[i]);
    //    _object.setDataMgr( this.m_objManager) ;
    var _objData = _object.getObjData();
    //    alert("MMWhiteboard.prototype.testIterator()----> "+_objData);
  }
};
MMWhiteboard.prototype.getPageCount = function () {
  return this.m_pagesInfo.m_pagesInfo.length;
};
MMWhiteboard.prototype.encode = function (enc_) {};
MMWhiteboard.prototype.decode = function (dec_) {
  var _hasData = 1; // 标志有白板数据
  _hasData = dec_.decodeFrom1Byte(___MM_DOC_VERSION__);
  var _docVer = -1;
  if (_hasData) {
    _docVer = dec_.decodeFrom4Bytes(___MM_DOC_VERSION__);
    if (_docVer <= ___MM_DOC_VERSION__) {
      //解析文档的高度、宽度
      this.m_id = dec_.decodeFrom8Bytes(_docVer);
      this.m_pageWidth = dec_.decodeFromFloat(_docVer);
      this.m_pageHeight = dec_.decodeFromFloat(_docVer);
      this.m_createdTime = dec_.decodeFrom8Bytes(_docVer);
      this.m_type = dec_.decodeFrom4Bytes(_docVer);
      this.m_default_rec_num = dec_.decodeFrom4Bytes(_docVer);
      this.m_zoomScale = dec_.decodeFromFloat(_docVer);
      this.m_curPageLgPoint = dec_.decodeFromMMPoint(_docVer);

      //解析board上obj的数量
      this.m_orderedObjIds = dec_.decodeFromArray(_docVer, 'ObjID');

      //this.m_transfer.decode(dec_, _docVer) ;
      //最新的服务器版本是10，已经没有MMMacTransformer
      //           dec_.shift(36) ;

      //保存m_pages
      this.m_pagesInfo.decode(dec_, _docVer);
      //保存objmgr
      this.m_objManager.decode(dec_, _docVer);
      this.m_objDataManager.decode(dec_, _docVer);
      //
      //           this.m_resourcemgr.decode(dec_, _docVer);
      /*
       * mashx some temporary code here
       */
      var _temp0 = dec_.decodeFrom4Bytes(_docVer);
      var _temp1 = dec_.decodeFrom4Bytes(_docVer);
      var _temp2 = dec_.decodeFrom4Bytes(_docVer);
      for (var i = 0; i < _temp2; i++) {
        var _temp3 = dec_.decodeFromString(_docVer);
        var _temp4 = dec_.decodeFrom4Bytes(_docVer);
      }
    } else {
      console.assert(false);
    }
    var name = this.displayName;
    var ext = name.split('.').pop();
    ext = ext.toLowerCase();
    if (ext == 'heic' || ext == 'webp' || ext == 'avif') {
      var objs = this.getAllObjs();
      for (var _i = 0; _i < objs.length; _i++) {
        var element = objs[_i];
        if (element.m_objType == _ObjType["default"].Obj_PDF) {
          element.m_objType = _ObjType["default"].Obj_Image;
        }
      }
    }
  }
  return _docVer;
};
MMWhiteboard.prototype.resetClientSeqs = function () {
  this.m_actionManager.resetClientSeqs();
};
MMWhiteboard.prototype.getObjDataManager = function () {
  return this.m_objDataManager;
};
MMWhiteboard.prototype.getPgInfo = function (pgIndex) {
  //  this.setTestInfo();  // test 测试代码

  return this.m_pagesInfo.getPgInfo(pgIndex);
};
MMWhiteboard.prototype.getBkgrdInfo = function (pgIndex) {
  return this.m_pagesInfo.getBkgrdInfo(pgIndex);
};
MMWhiteboard.prototype.setTestInfo = function () {
  if (this.m_pagesInfo == null || this.m_pagesInfo.m_pagesInfo == null || this.m_pagesInfo.m_pagesInfo.length == 0) {
    this.m_pagesInfo = new _MMPagesInfo["default"]();
    for (var i = 0; i < 5; i++) {
      var info = new _BackgroundPaperAttr["default"]();
      if (i == 1) {
        info.m_type = 1;
        info.m_name = "img/test/r1.jpg";
      } else {
        info.m_type = 0;
        info.m_color.w = 0.3 * i;
        info.m_color.x = 1;
        info.m_color.y = 1;
        info.m_color.z = 1;
      }
      this.m_pagesInfo.m_pagesInfo.push(info);
    }
  }
};
MMWhiteboard.prototype.initFromActionArray = function (conn_, array_) {
  for (var i = 0; i < array_.length; i++) {
    this.performAction(array_[i]);
  }
};
MMWhiteboard.prototype.initFromNetwork = function (conn_, data_) {
  //      console.log("获取了全部数据") ;
  this.initFromNetwork_help(data_);

  /*
   * we have to clear the clientsequence queue
   */
  this.resetClientSeqs();
  this.connected(conn_);
  this.isReady = true;
  //    console.error("这里可能需要刷新操作");
  //    Dispatcher.trigger(MDEvents.DATA_READY,this);
};
MMWhiteboard.prototype.getCollabInfo = function () {
  return this.m_collabInfo;
};
MMWhiteboard.prototype.searchObjIncludeStr = function (str) {
  var objs = new Array();
  if (str.length > 0) {
    var _reg = new RegExp(str, "i");
    for (var i = 0; i < this.m_orderedObjIds.length; i++) {
      var _object = this.m_objManager.getObject(this.m_orderedObjIds[i]);
      var find = _object.includeStr(_reg);
      if (find.length > 0) {
        var obj = new Object();
        obj.text = find;
        obj.obj = _object;
        objs.push(obj);
      }
    }
  }
  return objs;
};
MMWhiteboard.prototype.hasCollabZone = function () {
  if (this.m_collabInfo) {
    return true;
  } else {
    if (this.m_sponsoredCollabInfos.getCount() > 0) {
      return true;
    }
  }
  return false;
};
MMWhiteboard.prototype.feedback4Notify = function (serverSeq_, clientSeq_) {
  this.m_actionManager.feedback4Notify(serverSeq_, clientSeq_);
};
MMWhiteboard.prototype.getPageSize = function () {
  var pagesController = this.getPagesController();
  if (pagesController != null && pagesController != undefined) {
    return pagesController.getPageSize();
  }
  return null;
};
MMWhiteboard.prototype.getPageRect = function (index) {
  var pgSize = this.getPageSize();
  if (pgSize) {
    var top = pgSize.height * index;
    var bottom = top + pgSize.height;
    var left = 0;
    var right = pgSize.width;
    var pgRct = new _MMRect["default"](top, right, bottom, left);
    return pgRct;
  }
  ;
};

/**
 * get objects in page
 * @param pgIndex
 * @returns {Array of MMObjects}
 */
MMWhiteboard.prototype.getObjsInPage = function (pgIndex) {
  var pgSize = this.getPageSize();
  var top = pgSize.height * pgIndex;
  var bottom = top + pgSize.height;
  var left = 0;
  var right = pgSize.width;
  var pgRct = new _MMRect["default"](top, right, bottom, left);
  var objsInPage = new Array();
  for (var i = 0; i < this.m_orderedObjIds.length; i++) {
    var object = this.m_objManager.getObject(this.m_orderedObjIds[i]);
    if (object.getPageIndex() == pgIndex) {
      objsInPage.push(object);
    }
  }
  return objsInPage;
};
MMWhiteboard.prototype.hasObjsInPage = function (pgIndex) {
  return this.getObjsInPage(pgIndex).length > 0;
};

/**
 * get objects in page by filter
 * @param {Number} pgIndex
 * @param {MMObjectFilter} filter
 * @returns {Array of MMObjects}
 * @author jiang
 */
MMWhiteboard.prototype.getObjsInPageByFilter = function (pgIndex, filter, lgRct) {
  var finalObjs = new Array();
  var objsInPage = this.getObjsInPage(pgIndex);
  if (filter == undefined) {
    console.log("filter undefined");
  }
  for (var i = 0; i < objsInPage.length; i++) {
    var obj = objsInPage[i];
    if (!filter.isObjRemovedByFilter(obj)) {
      if (lgRct != undefined && lgRct != null) {
        if (_basicMath["default"].intersects(lgRct, obj.getExpandRect()) && obj.getPageIndex() == pgIndex) {
          finalObjs.push(obj);
        }
        ;
      } else if (obj.getPageIndex() == pgIndex) {
        finalObjs.push(obj);
      }
    }
  }
  return finalObjs;
};
MMWhiteboard.prototype.getUserObjectsInPage = function (pgIndex_, userId_) {
  var arrUsrObjs = [];
  var arrObjs = this.getObjsInPage(pgIndex_);
  for (var i = 0; i < arrObjs.length; i++) {
    var object = arrObjs[i];
    if (object.getCreator().valueOf() == userId_.valueOf()) {
      arrUsrObjs.push(object);
    }
  }
  return arrUsrObjs;
};

/**
 * mark page changed by position of objects
 * @author jiang
 * @param {Array} objIds_
 */
MMWhiteboard.prototype.markPageDirtyByObjects = function (objIds_) {
  if (objIds_ != null && objIds_ != undefined) {
    for (var i = 0; i < objIds_.length; i++) {
      var object = this.m_objManager.getObject(objIds_[i]);
      if (object) {
        var pgIndex = object.getPageIndex();
        this.m_pagesInfo.setPageDirtyMark(pgIndex, true);
      }
    }
  }
};
MMWhiteboard.prototype.getPageDirtyMark = function (pgIndex) {
  return this.m_pagesInfo.getPageDirtyMark(pgIndex);
};
MMWhiteboard.prototype.setPageDirtyMark = function (pgIndex, dirty) {
  this.m_pagesInfo.setPageDirtyMark(pgIndex, dirty);
};

/**
 *
 * @param type optional{int} from the  ObjType enumeration
 */
MMWhiteboard.prototype.getAllObjs = function (type) {
  var out = [];
  var that = this;
  this.m_orderedObjIds.forEach(function (objId) {
    var obj = that.getObject(objId);
    if (!obj) {
      return;
    }
    ;
    if (type) {
      if (obj.getObjType() == type) out.push(obj);
    } else {
      out.push(obj);
    }
  });
  // if(type){
  //  this.m_objManager.m_objects.forEach(function(obj){
  //    if(obj.getObjType()==type)
  //      out.push(obj)
  //  });
  // }else{
  //  this.m_objManager.m_objects.forEach(function(obj){
  //    out.push(obj)
  //  });
  // }
  return out;
};
//
// 判断是否处理的是pdf文件
// by manjun.han 15.7.3
//
MMWhiteboard.prototype.isOperateOnPDFFile = function () {
  var ids = this.m_orderedObjIds;
  if (ids.length == 0) {
    return false;
  }
  ;
  var obj = this.getObject(ids[0]);
  return obj.m_objType == _ObjType["default"].Obj_PDF;
};
MMWhiteboard.prototype.canUploadPDFFile = function () {
  return !this.isDocument();
};

//
//  白板对象既可以当做一个工程（内含多张图片，多个文档），也可以仅当做一个文档（对应 word，ppt）
//  这个函数就是判断白板是否仅是一个文档
//
MMWhiteboard.prototype.isDocument = function () {
  if (this.isOperateOnPDFFile()) {
    var ids = this.m_orderedObjIds;
    if (ids.length == 1) {
      return false;
    }
    ;
    var obj1 = this.getObject(ids[0]);
    var obj2 = this.getObject(ids[1]);
    var filePath = obj1.getFilePath();
    var isDoc = obj1.getFilePath() == obj2.getFilePath();

    // for (var i = 1; i < objs.length; i++) {
    //     if(filePath != objs[i].getFilePath()){  // 所有pdf页对象指向的是同一个pdf文档时，才是一个单独的文档
    //         isDoc = false;
    //         break;
    //     }
    // };
    return isDoc;
  }
  ;
  return false;
};
MMWhiteboard.prototype.getImgPdfObjects = function () {
  var objs = [];
  this.m_objManager.m_objects.forEach(function (obj) {
    if (obj.getObjType() == _ObjType["default"].Obj_Image || obj.getObjType() == _ObjType["default"].Obj_PDF) objs.push(obj);
  });
  for (var i = 0; i < objs.length - 1; i++) {
    if (objs[i].getPageIndex() == -1) {
      return objs;
    }
    ;
  }
  if (this.sortedObjs && this.sortedObjs.length == objs.length) {
    return this.sortedObjs;
  } else {
    var allLoaded = true;
    // 按照页号排序
    for (var i = 0; i < objs.length - 1; i++) {
      if (objs[i].getPageIndex() == -1) {
        allLoaded = false;
      }
      ;
      for (var j = i + 1; j < objs.length; j++) {
        var obj0 = objs[i];
        var obj1 = objs[j];
        if (obj0.getPageIndex() > obj1.getPageIndex()) {
          objs[j] = obj0;
          objs[i] = obj1;
        }
      }
    }
    if (allLoaded) {
      this.sortedObjs = objs;
    }
  }
  return objs;
};
MMWhiteboard.prototype.addSalonScribble = function (scribble) {
  if (!this.salonScribbles) {
    this.salonScribbles = [];
  }
  ;
  var newScribble;
  if (!scribble.draw) {
    //不是MDSalonMsg的对象
    var newScribble = new _MDSalonScribble["default"](scribble.pageIndex);
    newScribble.initData(scribble);
  } else {
    newScribble = scribble;
  }
  this.salonScribbles.push(newScribble);
};
MMWhiteboard.prototype.clearSalonScribbles = function () {
  this.salonScribbles = [];
};

// 获得与线段相交的粉笔线条
// @param pt0{MMPoint} - 线段的起始点
// @param pt1{MMPoint} - 线段的终止点
MMWhiteboard.prototype.getSalonScribbleIntersectWithSeg = function (pt0, pt1) {
  var intersects = [];
  for (var i = 0; i < this.salonScribbles.length; i++) {
    if (this.salonScribbles[i].intersectWith(pt0, pt1)) {
      intersects.push(this.salonScribbles[i]);
    }
  }
  ;
  return intersects;
};
MMWhiteboard.prototype.removeSolonScribble = function (scribbleIds) {
  for (var i = 0; i < scribbleIds.length; i++) {
    var sId = scribbleIds[i];
    for (var k = 0; k < this.salonScribbles.length;) {
      if (this.salonScribbles[k].getId() == sId) {
        this.salonScribbles.splice(k, 1);
      } else {
        k++;
      }
    }
    ;
  }
  ;
  return null;
};
MMWhiteboard.prototype.getScribbleIntersectWithSeg = function (pt0, pt1) {
  var intersects = [];
  var scribbles = this.getAllObjs(_ObjType["default"].GObj_scribble);
  for (var i = 0; i < scribbles.length; i++) {
    if (scribbles[i].intersectWith(pt0, pt1)) {
      intersects.push(scribbles[i]);
    }
  }
  ;
  return intersects;
};
MMWhiteboard.prototype.getMyScribbleIntersectWithSeg = function (pt0, pt1) {
  var intersects = [];
  var hasOthers = false;
  var scribbles = this.getScribbleIntersectWithSeg(pt0, pt1);
  for (var i = 0; i < scribbles.length; i++) {
    var s = scribbles[i];
    if (s.getCreator() == app.currentUser.getId()) {
      intersects.push(s);
    } else {
      hasOthers = true;
    }
  }
  return {
    scribbles: intersects,
    hasOthers: hasOthers
  };
};
MMWhiteboard.prototype.removeScribblesForVersion = function (version) {
  var scribbles = this.getAllObjs(_ObjType["default"].GObj_scribble);
  var sIds = [];
  for (var i = 0; i < scribbles.length; i++) {
    if (scribbles[i].getFileVersion() == version || version == -1) {
      sIds = scribbles[i].getId();
    }
  }
  ;
  this.removeObjects(sIds);
};
MMWhiteboard.prototype.getScribbleGroupByCreator = function (ver) {
  var intersects = [];
  var scribbles = this.getAllObjs(_ObjType["default"].GObj_scribble);
  var mapUsr2Scribbles = {};
  var canCombine = function canCombine(s1, s2) {
    var r1 = s1.getRect();
    var r2 = s2.getRect();
    return r1.intersects(r2);
  };
  for (var i = 0; i < scribbles.length; i++) {
    if (scribbles[i].getFileVersion() == ver) {
      var creator = scribbles[i].getCreator();
      if (!mapUsr2Scribbles[creator]) {
        mapUsr2Scribbles[creator] = [scribbles[i]];
      } else {
        mapUsr2Scribbles[creator].push(scribbles[i]);
      }
    }
  }
  ;
  var userScribbleGroups = [];
  for (var _i2 = 0; _i2 < Object.keys(mapUsr2Scribbles).length; _i2++) {
    var userId = Object.keys(mapUsr2Scribbles)[_i2];
    var userScribbles = mapUsr2Scribbles[userId];
    for (var k = 0; k < userScribbles.length; k++) {
      var scribble = userScribbles[k];
      scribble.mark = k;
    }
    for (var _k = 0; _k < userScribbles.length - 1; _k++) {
      var s1 = userScribbles[_k];
      for (var j = _k + 1; j < userScribbles.length; j++) {
        var s2 = userScribbles[j];
        if (s1.mark != s2.mark) {
          if (canCombine(s1, s2)) {
            var oldMark = s2.mark;
            for (var l = 0; l < userScribbles.length; l++) {
              var s3 = userScribbles[l];
              if (s3.mark == oldMark) {
                s3.mark = s1.mark; // 标记为同类
              }
            }
          }
        }
      }
    }
    var group = {
      userId: userId,
      sections: []
    };
    var mark2Group = {};
    for (var _l = 0; _l < userScribbles.length; _l++) {
      var element = userScribbles[_l];
      if (!mark2Group[element.mark]) {
        mark2Group[element.mark] = [element];
      } else {
        mark2Group[element.mark].push(element);
      }
    }
    for (var _k2 = 0; _k2 < Object.keys(mark2Group).length; _k2++) {
      var key = Object.keys(mark2Group)[_k2];
      group.sections.push(mark2Group[key]);
    }
    userScribbleGroups.push(group);
  }
  return userScribbleGroups;
};
MMWhiteboard.prototype.removeObjects = function (scribbleIds) {
  var objects = [];
  for (var i = 0; i < scribbleIds.length; i++) {
    var sId = scribbleIds[i];
    var obj = this.__delObject(sId);
    objects.push(obj);
  }
  ;
  return objects;
};

// 绘制所有粉笔线条
MMWhiteboard.prototype.drawSalonScribbles = function (ctx, trsfm, lgRct) {
  if (!this.salonScribbles) {
    return;
  }
  ;
  for (var i = 0; i < this.salonScribbles.length; i++) {
    this.salonScribbles[i].draw(ctx, trsfm, lgRct);
  }
  ;
};
MMWhiteboard.getStandardPageRectForPage = function (pgIndex) {
  return new _MMRect["default"](0, pgIndex * MMLogicPageHeight, MMLogicPageWidth, (pgIndex + 1) * MMLogicPageHeight);
};

},{"1081":1081,"1084":1084,"1184":1184,"1412":1412,"1418":1418,"1432":1432,"1437":1437,"1454":1454,"1461":1461,"1463":1463,"1476":1476,"1477":1477,"1478":1478,"1537":1537,"211":211,"818":818,"821":821,"831":831,"832":832,"872":872,"882":882,"885":885,"893":893,"946":946,"947":947,"949":949,"951":951,"953":953,"954":954,"955":955,"956":956,"962":962,"964":964,"977":977}],977:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Layer_Move_Type = _interopRequireDefault(require(962));
var _MMAction = _interopRequireDefault(require(963));
var _Encoder = _interopRequireDefault(require(800));
var _MMUndoInfo = _interopRequireDefault(require(992));
/**
 * @author lishusheng,2014-06-18
 * @param oldIndex_
 * @returns {MMLayerAction}
 */
function MMLayerAction(oldIndex_, newStart_, id_, do_) {
  _MMAction["default"].call(this);
  this.m_type = _Layer_Move_Type["default"].enumLayerMovetoBack; //  Layer_Move_Type  0, 1

  //保存info的属性
  this.m_oldIndex = oldIndex_; //std::vector<__uint32_t>
  this.m_newStart = newStart_; //__uint32_t
  this.m_id = id_; //  vector<OBJ_ID>
  this.m_do = do_; // 1 do, 2 undo  Undo_Redo_Type

  this.m_ids = this.m_id;
}
;
MMLayerAction.prototype = new _MMAction["default"]();
MMLayerAction.superclass = _MMAction["default"].prototype;
MMLayerAction.prototype.createReverse = function () {
  return new MMLayerAction(this.m_newStart, this.m_oldIndex, this.m_ids, this.m_do == 1 ? 2 : 1);
};
MMLayerAction.prototype.getClassName = function () {
  return 'MMLayerAction';
};
/**
 *
 * @param whiteboard_
 * @param active_  {bool}
 */

MMLayerAction.prototype.execute = function (whiteboard_, active_) {
  console.log("MMLayerAction.execute()");
  this.calcObjsRectFromWhiteBoard(whiteboard_);
  //  whiteboard_.changeLayerForObjs(this.m_ids,this.m_type);

  whiteboard_.changeLayerByLayerInfo(this, false);

  //  var arrayObjects = this.m_objects.getValues();//MMObject
  //  for (var i = 0 ; i < arrayObjects.length ; i ++) {
  //    var _id = whiteboard_.__addObject(arrayObjects[i]);
  //    this.m_ids.push(_id);
  //  }
  //
  //
  //  /*
  //   */
  this.m_collabId = whiteboard_.getCollabIds(this.m_ids);
};
MMLayerAction.prototype.postExecuteA = function (whiteboard_) {
  MMLayerAction.superclass.postExecuteA.call(this, whiteboard_);
};
MMLayerAction.prototype.postExecuteP = function (whiteboard_) {
  //  whiteboard_.shuffle(this.m_ids, this.m_baseObj) ;
  return this.getRefreshRect();
};
MMLayerAction.prototype.__CreateDataImg = function () {
  var _enc = new _Encoder["default"]();
  _enc.encode4Bytes(___MM_DOC_VERSION__);
  var _count = this.m_objects.length;
  _enc.encode4Bytes(_count);
  for (var i = 0; i < _count; i++) {
    var _object = this.m_objects[i];
    _enc.encodeObject(_object);
    /*
     *
     */
    if (!_object.getIncludeData()) {
      var _objData = _object.getObjData();
      _objData.encode(_enc);
    }
  }
  this.m_image = _enc.getStream();
};
MMLayerAction.prototype.encode = function (enc_) {
  var _layerInfo = new MMLayerInfo(this);
  _layerInfo.encode(enc_);
};

//MMLayerAction.prototype.decode = function (dec_, ver_) {
//
//} ;
/**
 *
 * @returns {MMUndoInfo}
 */
MMLayerAction.prototype.getRefreshRect = function () {
  var info = new _MMUndoInfo["default"]();
  info.m_refreshRcts = this.m_objsRect;
  return info;
};
/**
 * @param board {MMWhiteBoard}
 * @param mutex_ {bool}
 * @returns Array<MMObject>
 */
MMLayerAction.prototype.getObject = function (board, mutex_) {
  return board.getObjsById(this.m_ids, false);
};
/**
 *
 * @param ids_ {Array<OBJ_ID>}
 */
MMLayerAction.prototype.setObjsID = function (ids_) {
  this.m_id = ids_;
  this.m_ids = ids_;
};
/**
 *
 * @param oldIndex {int32}
 * @param newStart {int32}
 */
MMLayerAction.prototype.setPositionInfo = function (oldIndex, newStart) {
  this.m_oldIndex = oldIndex;
  this.m_newStart = newStart;
};
var _default = exports["default"] = MMLayerAction;

},{"1184":1184,"1454":1454,"800":800,"962":962,"963":963,"992":992}],964:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1541);
require(1429);
var _MMPagesInfo = _interopRequireDefault(require(956));
var _Page_Oper = _interopRequireDefault(require(998));
var _MDEvents = _interopRequireDefault(require(325));
var _MMCreateAction = _interopRequireDefault(require(970));
var _MMActionStack = _interopRequireDefault(require(965));
var _Dispatcher = _interopRequireDefault(require(18));
var _MMUpdateActions = require(994);
var _MMAction = _interopRequireDefault(require(963));
var _MMIdManager = _interopRequireDefault(require(951));
var _MMReadAction = _interopRequireDefault(require(988));
var _MMRoundAction = _interopRequireDefault(require(990));
var _MMInsertAction = _interopRequireDefault(require(975));
var _MMPageAddAction = _interopRequireDefault(require(980));
var _MMChatMessageAction = _interopRequireDefault(require(966));
var _MMChatMessage = _interopRequireDefault(require(950));
var _MMDeleteAction = _interopRequireDefault(require(972));
var _BackgroundPaperAttr = _interopRequireDefault(require(946));
var _MMPageBkGrdAction = _interopRequireDefault(require(982));
var _map = _interopRequireDefault(require(821));
var _MMPoint = _interopRequireDefault(require(830));
var _MMRProcessMessage = _interopRequireDefault(require(851));
var _OBJ_ID = _interopRequireDefault(require(818));
var _CommentStatus = _interopRequireDefault(require(1036));
// import MMCollaborationManager from '../../../net/MMCollaborationManager.js' // 循环引用

function MMActionManager(whiteboard_) {
  this.m_whiteboard = whiteboard_;
  /*
   *@private {!Whiteboard.MMActionStack}
   */
  this.m_undoStack = new _MMActionStack["default"]();
  this.m_redoStack = new _MMActionStack["default"]();
  this.m_actionQueue = [];
  this.intervallActionInterval = null;
  this.intervallActionIntervalWaiting = false;
  this.m_clientSequence = [];
  var _myTime = new Date();
  this.m_sequence = _myTime.getTime();
  this.m_sequence = this.m_sequence / 1000;
  this.m_sequence = this.m_sequence << 32;
}
;

/**
 * lets send all messages on the queue. One by one, not all at once.
 * if is stopping automatically when the queue is empty.
 * you call this method, every time when you add some
 */
MMActionManager.prototype.__startActionQueueInterval = function () {
  var that = this;
  if (this.intervallActionInterval === null) {
    this.intervallActionInterval = setInterval(function () {
      if (!that.intervallActionIntervalWaiting) {
        if (MMCollaborationManager !== null) {
          var action = that.m_actionQueue.shift();
          if (!action) {
            clearInterval(that.intervallActionInterval);
            that.intervallActionInterval = null;
            return;
          }
          MMCollaborationManager.sendAction(action, that.m_whiteboard, function (resultCode_, rMsg_, messageId) {
            that.intervallActionIntervalWaiting = false;
            if (resultCode_ === 0) {
              if (rMsg_) {
                //rMsg_.m_flag,rMsg_.m_cliSeq,rMsg_.m_serSeq,rMsg_.m_image
                if (rMsg_.m_flag == 1) {
                  that.m_whiteboard.stepSeq();
                  if (action.onSuccess) action.onSuccess(messageId);
                } else {
                  console.log('SYNCHRONIZATION ERROR: rMsg.m_flag: ' + rMsg_.m_flag);
                  that.m_actionQueue.unshift(action);
                  if (action.onFail) action.onFail(resultCode_);
                }
              } else {
                console.assert(false, 'rMsg_ is null or undefined');
                that.m_actionQueue.unshift(action);
              }
            } else {
              console.log('SYNCHRONIZATION ERROR: resultCode_ != 0:', resultCode_);
              that.m_actionQueue.unshift(action);
              clearInterval(that.intervallActionInterval);
              that.intervallActionInterval = null;
              if (action.onFail) action.onFail(resultCode_);
            }
          });
          that.intervallActionIntervalWaiting = true;
        }
      }
    }, 40);
  }
};
MMActionManager.prototype.notify = function (action_) {
  var _lastClientSeq = this.m_sequence++;
  this.m_clientSequence.push(_lastClientSeq);
  if (this.m_clientSequence.length > BLOCK_SIZE) {
    this.m_clientSequence.shift();
  }
  action_.setIndSeq(_lastClientSeq);
  this.m_actionQueue.push(action_);
  this.__startActionQueueInterval();
};
MMActionManager.prototype.undo = function () {
  if (!this.m_undoStack.empty()) {
    var lastAction = this.m_undoStack.pop();
    var lastActionReverse = lastAction.createReverse(this.m_whiteboard);
    lastActionReverse.setContext(false, lastAction.isRealtime(), lastAction.isMark());
    this.performInternalAction(lastActionReverse, false);
    this.m_redoStack.push(lastActionReverse);
  }
  if (this.m_undoStack.empty()) {
    this.m_whiteboard.trigger(_MDEvents["default"].UNDO_REDO, 0);
  }
  this.m_whiteboard.trigger(_MDEvents["default"].UNDO_REDO, 3);
};
MMActionManager.prototype.canUndo = function () {
  return !this.m_undoStack.empty();
};
MMActionManager.prototype.redo = function () {
  if (!this.m_redoStack.empty()) {
    var lastRedoAction = this.m_redoStack.pop();
    var lastRedoActionReverse = lastRedoAction.createReverse(this.m_whiteboard);
    lastRedoActionReverse.setContext(false, lastRedoAction.isRealtime(), lastRedoAction.isMark());
    this.performInternalAction(lastRedoActionReverse, false);
    this.m_undoStack.push(lastRedoActionReverse);
  }
  if (this.m_redoStack.empty()) {
    this.m_whiteboard.trigger(_MDEvents["default"].UNDO_REDO, 2);
  }
  this.m_whiteboard.trigger(_MDEvents["default"].UNDO_REDO, 1);
};
MMActionManager.prototype.canRedo = function () {
  return !this.m_redoStack.empty();
};
MMActionManager.prototype.clearActionStacks = function () {
  this.m_undoStack.clear();
  this.m_redoStack.clear();
};
MMActionManager.prototype.performInternalAction = function (action_) {
  var actionInfo = action_.execActionA(this.m_whiteboard);
  if (action_.isUndoable()) {
    this.m_undoStack.push(action_);
  }
  if (action_.isRealtime()) {
    this.notify(action_);
  }
};
MMActionManager.prototype.destruct = function () {
  this.m_whiteboard = null;
  this.m_connection = null;
};
MMActionManager.prototype.connected = function (conn_) {
  this.m_connection = conn_;
  this.outgo();
};
MMActionManager.prototype.outgo = function () {
  console.assert(this.m_connection);
  for (var i = 0; i < this.m_actionQueue.length; i++) {
    this.m_connection.processMessage(this.m_actionQueue[i]);
  }
};
MMActionManager.prototype.sendAction = function (actionInfo_) {
  var _message = new _MMRProcessMessage["default"]();
  this.m_connection.sendMessage(_message);
};
MMActionManager.prototype.feedback4Notify = function (serverSeq_, clientSeq_) {
  var _firstActionInfo = this.m_actionQueue.shift();
  console.assert(_firstActionInfo.getIndSeq() === clientSeq_);
  this.m_whiteboard.setSeq(serverSeq_);
};
MMActionManager.prototype.resetClientSeqs = function () {
  this.m_clientSequence = [];
};

/**
 * performs actions from the outside
 */
MMActionManager.prototype.performExternalAction = MMActionManager.prototype.performAction = function (action_) {
  if (!action_) {
    return;
  }
  ;
  console.assert(action_ instanceof _MMAction["default"]);
  if (action_.notSent()) {
    /*
     */
  } else {
    /*
     */
    var _localSeq = this.m_whiteboard.getSeq();
    var _infoSeq = action_.getSeq();
    if (_localSeq > _infoSeq - 1) {
      console.log('客户端收到重复信息，放弃执行...');
      return false;
    } else {
      if (this.m_whiteboard.isMainBoard()) {
        console.assert(_localSeq == _infoSeq - 1);
        if (_localSeq != _infoSeq - 1) {}
      }
      if (action_.getIdentifier() == _MMIdManager["default"].locator) {
        console.log('客户端收到自身发送的消息... ');
        var _sThat = action_.getIndSeq();
      }
    }
    this.m_whiteboard.setSeq(action_.getSeq());
  }
  this.m_whiteboard.setChangedMark(true);

  ////    var _refreshInfo = new MMUndoInfo ;
  //  switch (action_.getType())
  //  {
  //  case ACTION_TYPE.CREATE:
  //      action_.execAction(this.m_whiteboard, false) ;
  ////        _refreshInfo = action_.getRefreshRect() ;
  ////        this.m_whiteboard.shuffle(action_.getObjIds(), action_.getBaseObj()) ;
  //      break ;
  //  default:
  //  }
  var _refreshInfo = action_.execActionP(this.m_whiteboard);
  if (this.m_whiteboard.isReadOnly() || this.m_connection) {
    //做刷新操作，_refreshInfo
    if (_refreshInfo) {
      var _refreshRect = _refreshInfo.getTotalRect();
      _refreshRect.expand(0.5, 0.5, 0.5, 0.5);
      _Dispatcher["default"].trigger(_MDEvents["default"].DATA_READY, this.m_whiteboard, _refreshRect);
    }
  }
};

/**
 * THE FOLLOWING METHODS ARE SUPPORTER METHODS TO PROVIDE A SIMPLE API FOR THE UI
 *
 */

/**
 * @param obj {MMBlockObj} the object or list of objects to rotate
 * @param center {MMPoint} Point to rotate around
 * @param angle {float} rotation angle in degree
 */
MMActionManager.prototype.rotate = function (newObj, center, angle, angleInfect, toUndo) {
  if (!(newObj instanceof Array)) {
    newObj = [newObj];
  } else {
    newObj = newObj.slice();
  }
  this.m_whiteboard.setChangedMark(true);
  var action = new _MMUpdateActions.MMRotateAction(center, angle, angleInfect, newObj);
  this.performInternalAction(action, toUndo);
};

/**
 * @param obj {MMBlockObj} the object or list of objects to rotate
 * @param offset {MMPoint} the offset to the current position
 */
MMActionManager.prototype.move = function (newObj, offset, toUndo, realtime) {
  if (!(newObj instanceof Array)) {
    newObj = [newObj];
  } else {
    newObj = newObj.slice();
  }
  this.m_whiteboard.setChangedMark(true);
  var action = new _MMUpdateActions.MMMoveAction(offset, newObj);
  action.setContext(toUndo, realtime);
  this.performInternalAction(action);
};

/**
 * @param obj {MMBlockObj} the object or list of objects to rotate
 * @param basepoint {MMPoint}
 * @param scale {MMPoint}
 */
MMActionManager.prototype.scale = function (newObj, basepoint, scale, toUndo) {
  var i;
  if (!(newObj instanceof Array)) {
    newObj = [newObj];
  } else {
    newObj = newObj.slice();
  }
  if (!(newObj[0] instanceof _OBJ_ID["default"])) {
    for (i = 0; i < newObj.length; i++) {
      newObj[i] = newObj[i].getId();
    }
  }
  var scaleMap = new _map["default"]();
  for (i = 0; i < newObj.length; i++) {
    scaleMap.set(newObj, new _MMPoint["default"](scale.x, scale.y));
  }
  this.m_whiteboard.setChangedMark(true);
  var action = new _MMUpdateActions.MMScaleAction([], [], false, basepoint, false, scaleMap, newObj);
  this.performInternalAction(action, toUndo);
  return action;
};

/**
 * adds an object to the whiteboard
 * @param newObj {}
 */
MMActionManager.prototype.addElement = MMActionManager.prototype.addElements = MMActionManager.prototype.addObject = MMActionManager.prototype.addObjects = function (newObj, option, callback_) {
  var toUndo = option && option.toUndo;
  var realtime = option && option.realtime;
  var isMark_ = option && option.isMark_;
  var createNotRefresh = option && option.createNotRefresh;
  if (!(newObj instanceof Array)) {
    newObj = [newObj];
  } else {
    newObj = newObj.slice();
  }

  //如果是molasync，则需要将其打开。
  //    var _lgRect = newObj[0].getLogicRect();
  //    if (this.m_whiteboard.m_pages && this.m_whiteboard.m_pages.onTheLastPage(_lgRect)) {
  //      this.m_whiteboard.addPage(YES);
  //    }

  //
  this.m_whiteboard.setChangedMark(true);
  var _createAction = new _MMCreateAction["default"](newObj, isMark_);
  _createAction.onSuccess = function () {
    if (callback_) {
      callback_(0);
    }
  };
  _createAction.onFail = function (code) {
    if (callback_) {
      callback_(code);
    }
  };
  _createAction.setContext(toUndo, realtime, isMark_);
  _createAction.notRefresh = createNotRefresh;
  this.performInternalAction(_createAction);
  _createAction.notRefresh = false;
  if (toUndo) {
    this.m_whiteboard.trigger(_MDEvents["default"].UNDO_REDO, 1);
  }
  return _createAction;
};

/**
 * 将服务器端的页面的改为 Web 端的背景（服务器端的页面默认是 ios 端的背景）
 * @param pgIndex { int }  页号
 *
 */
MMActionManager.prototype.changeServerBackgroundToWebDefault = function (pgIndex) {
  var oper_ = _Page_Oper["default"].SET_BACKGROUND;
  var oldDefaultBackGround = new _BackgroundPaperAttr["default"]();
  var oldMapSpecialBackGrounds = this.m_whiteboard.m_pagesInfo.m_specialBackGround;
  var oldSpecialBackGround = this.m_whiteboard.getBkgrdInfo(pgIndex);
  var newSpecialBackGround = new _BackgroundPaperAttr["default"]();
  var paper = new _BackgroundPaperAttr["default"]();
  var setBkGrdAction = new _MMPageBkGrdAction["default"](oper_, oldDefaultBackGround, oldMapSpecialBackGrounds, oldSpecialBackGround, newSpecialBackGround, pgIndex);
  setBkGrdAction.setContext(false, true, false);
  this.performInternalAction(setBkGrdAction);
};
/**
 * removes given objects from the whiteboard.
 * @param objs_ {Objects or there IDs} the objects to Delete
 */
MMActionManager.prototype.deleteObject = MMActionManager.prototype.deleteObjects = MMActionManager.prototype.deleteElement = MMActionManager.prototype.deleteElements = function (objs_, param) {
  if (!param) {
    param = {};
  }
  ;
  var toUndo = param.toUndo;
  var realtime = param.realtime;
  var isMark_ = param.isMark_;
  var onSuccess = param.onSuccess;
  var onFail = param.onFail;
  if (!(objs_ instanceof Array)) {
    objs_ = [objs_];
  } else {
    objs_ = objs_.slice();
  }
  this.m_whiteboard.setChangedMark(true);
  var _deleteAction = new _MMDeleteAction["default"](objs_, this.m_whiteboard, isMark_);
  _deleteAction.onSuccess = onSuccess;
  _deleteAction.onFail = onFail;
  _deleteAction.setContext(toUndo, realtime, isMark_);
  this.performInternalAction(_deleteAction);
  if (toUndo) {
    this.m_whiteboard.trigger(_MDEvents["default"].UNDO_REDO, 1);
  }
};

/**
 *
 * @param msg_ {JSON string} {Type:"Text"|"Audio",Body:"text",URL:"audioFileName"}
 */
MMActionManager.prototype.sendMessage = function (msg_, objId_, param, callback_) {
  if (param && _.isFunction(param)) {
    callback_ = param;
  }
  ;
  if (app.currentUser) {
    var userId = app.currentUser.getUserId_Int();
    var userName = app.currentUser.getUserName();
    var chatMessage = new _MMChatMessage["default"](0, userId, 0, new Date().getTime(), userName, msg_, objId_);
    if (param && param.clientUsers) {
      chatMessage.set_auxiliaryInfo(param.visibleScope, param.clientUsers);
    }
    ;
    var action = new _MMChatMessageAction["default"](chatMessage);
    action.onSuccess = function (messageId) {
      if (callback_) {
        callback_(0, messageId);
      }
    };
    action.onFail = function (code) {
      if (callback_) {
        callback_(code);
      }
    };
    action.setContext(false, true, false);
    this.performInternalAction(action);
    return chatMessage;
  }
};
MMActionManager.prototype.createNewRounds = function (pageNum_, sucCB_, failCB_) {
  this.m_whiteboard.setChangedMark(true);
  var pageCreateInfo = new _MMPagesInfo["default"].PageCreationInfo();
  var localDate = new Date();
  pageCreateInfo.m_creationTime = Math.floor(localDate.getTime() / 1000);
  pageCreateInfo.m_newPageNum = pageNum_;
  var _action = new _MMPageAddAction["default"](_Page_Oper["default"].ADD, pageCreateInfo, this.m_whiteboard.getPageCount());
  var that = this;
  _action.onSuccess = function () {
    _action.execute(that.m_whiteboard);
    that.m_whiteboard.setChangedMark(true);
    if (sucCB_) sucCB_();
  };
  _action.onFail = function () {
    if (failCB_) failCB_();
  };
  this.notify(_action, true);
};
MMActionManager.prototype.commitRound = function (pageIndex_, commitUser_, sucCB_, failCB_) {
  var that = this;
  var objects = this.m_whiteboard.getUserUncommitedObjectsInPage(pageIndex_, commitUser_);
  for (var i = 0; i < objects.length; i++) {
    objects[i].setCommited(true);
  }
  var commitable = false;
  if (objects.length > 0) {
    commitable = true;
    var layerObjects = this.m_whiteboard.getObjectLayer(objects);
    var iInfo = new _MMInsertAction["default"](layerObjects, this);
    iInfo.onSuccess = function () {
      var rInfo = new _MMRoundAction["default"](pageIndex_, commitUser_);
      rInfo.onSuccess = function () {
        rInfo.execute(that.m_whiteboard);
        that.m_whiteboard.setChangedMark(true);
        that.clearActionStacks();
        if (sucCB_) sucCB_();
      };
      rInfo.onFail = function (code) {
        for (var i = 0; i < objects.length; i++) {
          objects[i].setCommited(false);
        }
        if (failCB_) failCB_(commitable, 1); //1 means:
      };
      that.notify(rInfo);
    };
    iInfo.onFail = function (code) {
      for (var i = 0; i < objects.length; i++) {
        objects[i].setCommited(false);
      }
      if (failCB_) failCB_(commitable, 2); //2 means:
    };
    this.notify(iInfo);
  } else {
    var that = this;
    var rInfo = new _MMRoundAction["default"](pageIndex_, commitUser_);
    rInfo.onSuccess = function () {
      rInfo.execute(that.m_whiteboard);
      that.m_whiteboard.setChangedMark(true);
      that.clearActionStacks();
      if (sucCB_) sucCB_();
    };
    rInfo.onFail = function () {};
    that.notify(rInfo);
  }
};

/*
 *this code is for temporary
 */
MMActionManager.prototype.commitContent = function (objects_, commitUser_, sucCB_, failCB_) {
  var layerObjects = objects_;
  var iInfo = new _MMInsertAction["default"](layerObjects);
  var _maxPage = this.m_whiteboard.getPageCount() - 1;
  //    var _enc = new Encoder();
  //    _enc.encodeObject(iInfo);
  //    var _dec = new Decoder(MDPcMobileEditorCommonFun.getMainEditor().getCurrentBoard());
  //    _dec.setStream(_enc.getStream());
  //    var _temp = _dec.decodeFromObject(___MM_DOC_VERSION__);
  //
  var that = this;
  iInfo.onSuccess = function () {
    var rInfo = new _MMRoundAction["default"](_maxPage, commitUser_);
    rInfo.onSuccess = function () {
      rInfo.execute(that.m_whiteboard);
      that.m_whiteboard.setChangedMark(true);
      that.clearActionStacks();
      if (sucCB_) sucCB_();
    };
    rInfo.onFail = function () {
      console.assert('commit error --- commit phrase');
    };
    that.notify(rInfo);
  };
  iInfo.onFail = function () {
    console.assert('commit error --- insert phrase');
  };
  this.notify(iInfo);
};
MMActionManager.prototype._commitRound = function (pageIndex_, commitUser_, sucCB_, failCB_) {};
MMActionManager.prototype.commentReaded = function (comment_) {
  if (app.currentUser && comment_) {
    var comId = comment_.getId();
    var userId = app.currentUser.getUserId_Int();
    if (comment_.getReadStatus(userId) == _CommentStatus["default"].Comment_read) {
      return;
    }
    var action = new _MMReadAction["default"](userId, comId);
    action.setContext(false, true, false);
    this.performInternalAction(action);
  }
};
MMActionManager.prototype.commentCompleted = function (comment_, completed_) {
  var complete = false;
  if (completed_) {
    complete = true;
  }
  if (app.currentUser && comment_) {
    var comId = comment_.getId();
    var pageIndex = comment_.getPageIndex();
    var action = new _MMUpdateActions.MMCommentCompleteAction(complete, pageIndex, comId);
    action.setContext(false, true, false);
    this.performInternalAction(action);
  }
};
MMActionManager.prototype.commentPraised = function (comment_) {
  if (app.currentUser && comment_) {
    var comId = comment_.getId();
    var userId = app.currentUser.getUserId_Int();
    var pageIndex = comment_.getPageIndex();
    var action = new _MMUpdateActions.MMCommentPraiseAction(userId, pageIndex, comId);
    action.setContext(false, true, false);
    this.performInternalAction(action);
  }
};
var _default = exports["default"] = MMActionManager;

},{"1036":1036,"1184":1184,"1429":1429,"1437":1437,"1454":1454,"1541":1541,"18":18,"325":325,"818":818,"821":821,"830":830,"851":851,"946":946,"950":950,"951":951,"956":956,"963":963,"965":965,"966":966,"970":970,"972":972,"975":975,"980":980,"982":982,"988":988,"990":990,"994":994,"998":998}],994:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MMColorAction = MMColorAction;
exports.MMCommentCompleteAction = MMCommentCompleteAction;
exports.MMCommentPraiseAction = MMCommentPraiseAction;
exports.MMFillAction = MMFillAction;
exports.MMFontAction = MMFontAction;
exports.MMImageAction = MMImageAction;
exports.MMMoveAction = MMMoveAction;
exports.MMObjLockAction = MMObjLockAction;
exports.MMRotateAction = MMRotateAction;
exports.MMScaleAction = MMScaleAction;
exports.MMShadowAction = MMShadowAction;
exports.MMStrokeAction = MMStrokeAction;
exports.MMStyleAction = MMStyleAction;
exports.MMTextAction = MMTextAction;
exports.MMTextColorAction = MMTextColorAction;
exports.MMYellowPtMoveAction = MMYellowPtMoveAction;
var _MMRange = _interopRequireDefault(require(816));
var _MMUpdateAction = _interopRequireDefault(require(993));
var _MMPoint = _interopRequireDefault(require(830));
var _ObjType = _interopRequireDefault(require(1084));
var _MMUpdateInfos = require(996);
var _map = _interopRequireDefault(require(821));
/**
 *
 * @param center_
 * @param angle_
 * @param angleInfect_
 * @param ids_
 * @returns {MMRotateAction}
 */
function MMRotateAction(center_, angle_, angleInfect_, ids_) {
  _MMUpdateAction["default"].call(this, ids_);
  this.m_center = center_;
  this.m_angle = angle_;
  this.m_angleInfect = angleInfect_;
}
;
MMRotateAction.prototype = new _MMUpdateAction["default"]();
MMRotateAction.superclass = _MMUpdateAction["default"].prototype;
MMRotateAction.prototype.__doAction = function (object_, index_) {
  var scalePoint = new _MMPoint["default"](1.0, 1.0);
  var offsetPoint = new _MMPoint["default"](0, 0);
  object_.transform(this.m_option[index_], this.m_center, scalePoint, this.m_angleInfect, this.m_angle, offsetPoint);
};
MMRotateAction.prototype.encode = function (enc_) {
  var _rotateUI = new _MMUpdateInfos.MMRotateUpdateInfo(this);
  _rotateUI.encode(enc_);
};
MMRotateAction.prototype.createReverse = function () {
  return new MMRotateAction(this.m_center, -this.m_angle, -this.m_angleInfect, this.m_ids);
};
MMRotateAction.prototype.m_className = "MMRotateAction";

/**
 *
 * @param offset_ { Vec2 }
 * @param ids_ {list of Int64}
 * @returns {MMMoveAction}
 */
function MMMoveAction(offset_, ids_) {
  _MMUpdateAction["default"].call(this, ids_);
  this.m_offset = offset_;
}
;
MMMoveAction.prototype = new _MMUpdateAction["default"]();
MMMoveAction.superclass = _MMUpdateAction["default"].prototype;
MMMoveAction.prototype.__doAction = function (object_, index_) {
  object_.move(this.m_offset);
};
MMMoveAction.prototype.encode = function (enc_) {
  var _moveUI = new _MMUpdateInfos.MMMoveUpdateInfo(this);
  _moveUI.encode(enc_);
};
MMMoveAction.prototype.m_className = "MMMoveAction";
MMMoveAction.prototype.createReverse = function () {
  var reverseOffset = new _MMPoint["default"](-this.m_offset.x, -this.m_offset.y);
  return new MMMoveAction(reverseOffset, this.m_ids);
};
/**
 *
 * @param scaleChanged_
 * @param activeIds_
 * @param newValue_
 * @param basePt_
 * @param angleInfect_
 * @param idScalMap_
 * @param ids_
 * @returns {MMScaleAction}
 */
function MMScaleAction(scaleChanged_, activeIds_, newValue_, basePt_, angleInfect_, idScalMap_, ids_) {
  _MMUpdateAction["default"].call(this, ids_);
  this.m_scaleChanged = scaleChanged_; //vector<OBJ_ID>
  this.m_activeIds = activeIds_; //vector<OBJ_ID>
  this.m_newValue = newValue_; //bool
  this.m_basePt = basePt_; //MMLgPoint
  this.m_angleInfect = angleInfect_; //bool
  this.m_idScaleMap = idScalMap_; //map<OBJ_ID, MMLgPoint>  Map of MMPoint
}
;
MMScaleAction.prototype = new _MMUpdateAction["default"]();
MMScaleAction.superclass = _MMUpdateAction["default"].prototype;
MMScaleAction.prototype.__doAction = function (object_, index_) {
  var scale = this.getScaleFromID(this.m_ids[index_]);
  var offset = new _MMPoint["default"](0, 0);
  object_.transform(this.m_option[index_], this.m_basePt, scale, this.m_angleInfect, 0, offset);
};
MMScaleAction.prototype.encode = function (enc_) {
  var _scaleUI = new _MMUpdateInfos.MMScaleUpdateInfo(this);
  _scaleUI.encode(enc_);
};
MMScaleAction.prototype.getScaleFromID = function (ID) {
  return this.m_idScaleMap.get(ID);
};
MMScaleAction.prototype.m_className = "MMScaleAction";
MMScaleAction.prototype.createReverse = function () {
  var newMap = new _map["default"]();
  var oldMap = this.m_idScaleMap;
  var oldMapKeys = oldMap.getKeys();
  var i = null;
  for (var i = 0; i < oldMapKeys.length; i++) {
    var key = oldMapKeys[i];
    var oldValue = oldMap.get(key);
    var newValue = new _MMPoint["default"](1 / oldValue.x, 1 / oldValue.y);
    newMap.set(key, newValue);
  }
  return new MMScaleAction(this.m_scaleChanged, this.m_activeIds, this.m_newValue, this.m_basePt, this.m_angleInfect, newMap, this.m_ids);
};
function MMYellowPtMoveAction(oldYellowPts_, newYellowPts_, oldClose_, newClose_, ids_) {
  _MMUpdateAction["default"].call(this, ids_);
  this.m_oldYellowPts = oldYellowPts_; //vector<OBJ_ID>
  this.m_newYellowPts = newYellowPts_; //vector<OBJ_ID>
  this.m_oldClose = oldClose_; //bool
  this.m_newClose = newClose_; //MMLgPoint
}
;
MMYellowPtMoveAction.prototype = new _MMUpdateAction["default"]();
MMYellowPtMoveAction.superclass = _MMUpdateAction["default"].prototype;
MMYellowPtMoveAction.prototype.__doAction = function (object_, inddex_) {
  object_.setYellowPtsAndIsClose(this.m_newYellowPts, this.m_newClose);
};
MMYellowPtMoveAction.prototype.encode = function (enc_) {
  var _yellowPtMoveUI = new _MMUpdateInfos.MMYellowPtMoveUpdateInfo(this);
  _yellowPtMoveUI.encode(enc_);
};
MMYellowPtMoveAction.prototype.m_className = "MMYellowPtMoveAction";
MMYellowPtMoveAction.prototype.createReverse = function () {
  return new MMYellowPtMoveAction(this.m_newYellowPts, this.m_oldYellowPts, this.m_newClose, this.m_oldClose, this.m_ids);
};

/**
 *
 * @param oldType_
 * @param newType_
 * @param ids_
 * @returns {MMStrokeAction}
 */
function MMStrokeAction(oldType_, newType_, ids_) {
  _MMUpdateAction["default"].call(this, ids_);
  this.m_oldType = oldType_; // vector<MMStrokeType>
  this.m_newType = newType_; //vector<MMStrokeType>
}
;
MMStrokeAction.prototype = new _MMUpdateAction["default"]();
MMStrokeAction.superclass = _MMUpdateAction["default"].prototype;
MMStrokeAction.prototype.__doAction = function (object_, index_) {
  object_.setStrokeType(this.m_newType[index_]);
};
MMStrokeAction.prototype.encode = function (enc_) {
  var _strokeUI = new _MMUpdateInfos.MMStrokeUpdateInfo(this);
  _strokeUI.encode(enc_);
};
MMStrokeAction.prototype.m_className = "MMStrokeAction";
MMStrokeAction.prototype.createReverse = function () {
  return new MMStrokeAction(this.m_newType, this.m_oldType, this.m_ids);
};
/**
 *
 * @param oldType_
 * @param newType_
 * @param ids_
 * @returns {MMFillAction}
 */
function MMFillAction(oldType_, newType_, ids_) {
  _MMUpdateAction["default"].call(this, ids_);
  this.m_oldType = oldType_; // vector<MMFillType>
  this.m_newType = newType_; //vector<MMFillType>
}
;
MMFillAction.prototype = new _MMUpdateAction["default"]();
MMFillAction.superclass = _MMUpdateAction["default"].prototype;
MMFillAction.prototype.__doAction = function (object_, index_) {
  object_.setFillType(this.m_newType[index_]);
};
MMFillAction.prototype.encode = function (enc_) {
  var _fillUI = new _MMUpdateInfos.MMFillUpdateInfo(this);
  _fillUI.encode(enc_);
};
MMFillAction.prototype.m_className = "MMFillAction";
MMFillAction.prototype.createReverse = function () {
  return new MMFillAction(this.m_newType, this.m_oldType, this.m_ids);
};
/**
 *
 * @param oldType_
 * @param newType_
 * @param ids_
 * @returns {MMShadowAction}
 */
function MMShadowAction(oldType_, newType_, ids_) {
  _MMUpdateAction["default"].call(this, ids_);
  this.m_oldType = oldType_; // vector<MMShadowType>
  this.m_newType = newType_; //vector<MMShadowType>
}
;
MMShadowAction.prototype = new _MMUpdateAction["default"]();
MMShadowAction.superclass = _MMUpdateAction["default"].prototype;
MMShadowAction.prototype.__doAction = function (object_, index_) {
  object_.setShadowType(this.m_newType[index_]);
};
MMShadowAction.prototype.encode = function (enc_) {
  var _shadowUI = new _MMUpdateInfos.MMShadowUpdateInfo(this);
  _shadowUI.encode(enc_);
};
MMShadowAction.prototype.m_className = "MMShadowAction";
MMShadowAction.prototype.createReverse = function () {
  return new MMShadowAction(this.m_newType, this.m_oldType, this.m_ids);
};
/**
 *
 * @param oldStrokeType_
 * @param newStrokeType_
 * @param oldFillType_
 * @param newFillType_
 * @param oldShadowType_
 * @param newShadowType_
 * @param ids_
 * @returns {MMStyleAction}
 */
function MMStyleAction(oldStrokeType_, newStrokeType_, oldFillType_, newFillType_, oldShadowType_, newShadowType_, ids_) {
  _MMUpdateAction["default"].call(this, ids_);
  this.m_oldStrokeType = oldStrokeType_; //vector<MMStrokeType>
  this.m_newStrokeType = newStrokeType_; //vector<MMStrokeType>

  this.m_oldFillType = oldFillType_; //vector<MMFillType>
  this.m_newFillType = newFillType_; //vector<MMFillType>

  this.m_oldShadowType = oldShadowType_; //vector<MMShadowType>
  this.m_newShadowType = newShadowType_; //vector<MMShadowType>
}
;
MMStyleAction.prototype = new _MMUpdateAction["default"]();
MMStyleAction.superclass = _MMUpdateAction["default"].prototype;
MMStyleAction.prototype.__doAction = function (object_, index_) {
  object_.setShadowType(this.m_newShadowType[index_]);
  object_.setFillType(this.m_newFillType[index_]);
  object_.setStrokeType(this.m_newStrokeType[index_]);

  //  object_.scale(this.m_offset) ;
};
MMStyleAction.prototype.encode = function (enc_) {
  var _styleUI = new _MMUpdateInfos.MMStyleUpdateInfo(this);
  _styleUI.encode(enc_);
};
MMStyleAction.prototype.m_className = "MMStyleAction";
MMStyleAction.prototype.createReverse = function () {
  return new MMStyleAction(this.m_newStrokeType, this.m_oldStrokeType, this.m_oldShadowType, this.m_oldFillType, this.m_newShadowType, this.m_oldShadowType, this.m_ids);
};
/**
 *
 * @param oldColor_
 * @param newColor_
 * @param ids_
 * @returns {MMColorAction}
 */
function MMColorAction(oldColor_, newColor_, ids_) {
  _MMUpdateAction["default"].call(this, ids_);
  this.m_oldColor = oldColor_; // vector<MMColor>
  this.m_newColor = newColor_; //vector<MMColor>
}
;
MMColorAction.prototype = new _MMUpdateAction["default"]();
MMColorAction.superclass = _MMUpdateAction["default"].prototype;
MMColorAction.prototype.__doAction = function (object_, index_) {
  object_.changeColor(this.m_newColor[index_]);
};
MMColorAction.prototype.encode = function (enc_) {
  var _colorUI = new _MMUpdateInfos.MMColorUpdateInfo(this);
  _colorUI.encode(enc_);
};
MMColorAction.prototype.m_className = "MMColorAction";
MMColorAction.prototype.createReverse = function () {
  return new MMColorAction(this.m_newColor, this.m_oldColor, this.m_ids);
};
/**
 *
 * @param oldFont_
 * @param newFont_
 * @param oldAlign_
 * @param newAlign_
 * @param ids_
 * @returns {MMFontAction}
 */
function MMFontAction(oldFont_, newFont_, oldAlign_, newAlign_, ids_) {
  _MMUpdateAction["default"].call(this, ids_);
  this.m_oldFont = oldFont_; // {MMFont}
  this.m_newFont = newFont_; // {MMFont}
  this.m_oldAlign = oldAlign_; // {MolaTextAlignment}
  this.m_newAlign = newAlign_; // {MolaTextAlignment}
}
;
MMFontAction.prototype = new _MMUpdateAction["default"]();
MMFontAction.superclass = _MMUpdateAction["default"].prototype;
MMFontAction.prototype.__doAction = function (object_, index_) {
  var text = null;
  if (object_.getObjType() == _ObjType["default"].GObj_note || object_.getObjType() == _ObjType["default"].GObj_rectMark) {
    text = object_.getTextObj();
  } else {
    text = object_;
  }
  text.setLgFont(this.m_newFont);
  text.setAlignment(this.m_newAlign.textAlignment);
};
MMFontAction.prototype.encode = function (enc_) {
  var _fontUI = new _MMUpdateInfos.MMFontUpdateInfo(this);
  _fontUI.encode(enc_);
};
MMFontAction.prototype.m_className = "MMFontAction";
MMFontAction.prototype.createReverse = function () {
  return new MMFontAction(this.m_newFont, this.m_oldFont, this.m_newAlign, this.m_oldAlign, this.m_ids);
};
function MMTextAction(start_, oldStr_, newStr_, oldRect_, newRect_, oldFontSize_, newFontSize_, ids_) {
  _MMUpdateAction["default"].call(this, ids_);
  this.m_start = start_; // 修改字符串的开始位置 unsigned
  this.m_oldStr = oldStr_; // 旧字符串 string
  this.m_newStr = newStr_; // 新字符串 string
  this.m_oldRect = oldRect_; // 旧框的矩形 MMLgRect
  this.m_newRect = newRect_; // 新框的矩形 MMLgRect
  this.m_oldFontSize = oldFontSize_; // 旧字体的大小 float
  this.m_newFontSize = newFontSize_; // 新字体的大小 float
}
;
MMTextAction.prototype = new _MMUpdateAction["default"]();
MMTextAction.superclass = _MMUpdateAction["default"].prototype;
MMTextAction.prototype.__doAction = function (object_, index_) {
  var text = null;
  if (object_.getObjType() == _ObjType["default"].GObj_note || object_.getObjType() == _ObjType["default"].GObj_rectMark) {
    text = object_.getTextObj();
  } else {
    text = object_;
  }
  var range = new _MMRange["default"]();
  range.m_start = this.m_start;
  range.m_len = this.m_oldStr.length;
  text.replaceText(range, this.m_newStr, this.m_newRect, this.m_newFontSize);
};
MMTextAction.prototype.encode = function (enc_) {
  var _textUI = new _MMUpdateInfos.MMTextUpdateInfo(this);
  _textUI.encode(enc_);
};
MMTextAction.prototype.m_className = "MMTextAction";
MMTextAction.prototype.createReverse = function () {
  return new MMTextAction(this.m_start, this.m_newStr, this.m_oldStr, this.m_newRect, this.m_oldRect, this.m_newFontSize, this.m_oldFontSize, this.m_ids);
};
/**
 *
 * @param oldColor_
 * @param newColor_
 * @param ids_
 * @returns {MMTextColorAction}
 */
function MMTextColorAction(oldColor_, newColor_, ids_) {
  _MMUpdateAction["default"].call(this, ids_);
  this.m_oldColor = oldColor_; // MMColor
  this.m_newColor = newColor_; //MMColor
}
;
MMTextColorAction.prototype = new _MMUpdateAction["default"]();
MMTextColorAction.superclass = _MMUpdateAction["default"].prototype;
MMTextColorAction.prototype.__doAction = function (object_, index_) {
  var text = null;
  if (object_.getObjType() == _ObjType["default"].GObj_note || object_.getObjType() == _ObjType["default"].GObj_rectMark) {
    text = object_.getTextObj();
  } else {
    text = object_;
  }
  text.setTextColor(this.m_newColor);
};
MMTextColorAction.prototype.encode = function (enc_) {
  var _textColorUI = new _MMUpdateInfos.MMTextColorUpdateInfo(this);
  _textColorUI.encode(enc_);
};
MMTextColorAction.prototype.m_className = "MMTextColorAction";
MMTextColorAction.prototype.createReverse = function () {
  return new MMTextColorAction(this.m_newColor, this.m_oldColor, this.m_ids);
};
/**
 *
 * @param data_   {ArrayBuffer}
 * @param ids_
 * @returns {MMImageAction}
 */
function MMImageAction(data_, ids_) {
  _MMUpdateAction["default"].call(this, ids_);
  this.m_image = data_; // ArrayBuffer
}
;
MMImageAction.prototype = new _MMUpdateAction["default"]();
MMImageAction.superclass = _MMUpdateAction["default"].prototype;
MMImageAction.prototype.__doAction = function (object_, index_) {};
MMImageAction.prototype.encode = function (enc_) {
  var _imageUI = new _MMUpdateInfos.MMImageUpdateInfo(this);
  _imageUI.encode(enc_);
};
MMImageAction.prototype.m_className = "MMImageAction";
function MMObjLockAction(oldLock_, newLock_, ids_) {
  _MMUpdateAction["default"].call(this, ids_);
  this.m_oldLock = oldLock_; // bool
  this.m_newLock = newLock_; //bool
}
;
MMObjLockAction.prototype = new _MMUpdateAction["default"]();
MMObjLockAction.superclass = _MMUpdateAction["default"].prototype;
MMObjLockAction.prototype.__doAction = function (object_, index_) {
  object_.setLock(this.m_newLock);
};
MMObjLockAction.prototype.encode = function (enc_) {
  var _objLockUI = new _MMUpdateInfos.MMObjLockUpdateInfo(this);
  _objLockUI.encode(enc_);
};
MMObjLockAction.prototype.m_className = "MMObjLockAction";
MMObjLockAction.prototype.createReverse = function () {
  return new MMObjLockAction(this.m_newLock, this.m_oldLock, this.m_ids);
};
function MMCommentCompleteAction(completed_, pageIndex_, ids_) {
  _MMUpdateAction["default"].call(this, ids_);
  this.m_completed = completed_;
  this.m_pageIndex = pageIndex_;
  this.m_needSendNotification = false;
}
MMCommentCompleteAction.prototype = new _MMUpdateAction["default"]();
MMCommentCompleteAction.superclass = _MMUpdateAction["default"].prototype;
MMCommentCompleteAction.prototype.m_className = "MMCommentCompleteAction";
MMCommentCompleteAction.prototype.__doAction = function (object_, index_) {
  object_.setFinished(this.m_completed);
};
MMCommentCompleteAction.prototype.encode = function (enc_) {
  var ccUI = new _MMUpdateInfos.MMCommentCompleteInfo(this);
  ccUI.encode(enc_);
};
function MMCommentPraiseAction(userId_, pageIndex_, ids_) {
  _MMUpdateAction["default"].call(this, ids_);
  this.m_userId = userId_;
  this.m_pageIndex = pageIndex_;
  this.m_needSendNotification;
}
MMCommentPraiseAction.prototype = new _MMUpdateAction["default"]();
MMCommentPraiseAction.superclass = _MMUpdateAction["default"].prototype;
MMCommentPraiseAction.prototype.m_className = "MMCommentPraiseAction";
MMCommentPraiseAction.prototype.encode = function (enc_) {
  var cpUI = new _MMUpdateInfos.MMCommentPraiseInfo(this);
  cpUI.encode(enc_);
};
MMCommentPraiseAction.prototype.__doAction = function (object_, index_) {
  object_.praise(this.m_userId);
};

},{"1084":1084,"1184":1184,"1454":1454,"816":816,"821":821,"830":830,"993":993,"996":996}],996:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MMColorUpdateInfo = MMColorUpdateInfo;
exports.MMCommentCompleteInfo = MMCommentCompleteInfo;
exports.MMCommentPraiseInfo = MMCommentPraiseInfo;
exports.MMFillUpdateInfo = MMFillUpdateInfo;
exports.MMFontUpdateInfo = MMFontUpdateInfo;
exports.MMImageUpdateInfo = MMImageUpdateInfo;
exports.MMMoveUpdateInfo = MMMoveUpdateInfo;
exports.MMObjLockUpdateInfo = MMObjLockUpdateInfo;
exports.MMRotateUpdateInfo = MMRotateUpdateInfo;
exports.MMScaleUpdateInfo = MMScaleUpdateInfo;
exports.MMShadowUpdateInfo = MMShadowUpdateInfo;
exports.MMStrokeUpdateInfo = MMStrokeUpdateInfo;
exports.MMStyleUpdateInfo = MMStyleUpdateInfo;
exports.MMTextColorUpdateInfo = MMTextColorUpdateInfo;
exports.MMTextUpdateInfo = MMTextUpdateInfo;
exports.MMYellowPtMoveUpdateInfo = MMYellowPtMoveUpdateInfo;
var _MMUpdateInfo = _interopRequireDefault(require(995));
var _MMActionInfo = _interopRequireDefault(require(1077));
var _MMUpdateActions = require(994);
var _OPERATOR = _interopRequireDefault(require(997));
var _MMUpdateAction = _interopRequireDefault(require(993));
// //////////////////////////////////////////////////////////////////////////////////////////////////////////
//
// rotate_ui
//
//
/**
 * @author lishusheng ,2014-06-11
 * @param ids_
 * @returns {MMRotateUpdateInfo}
 */
function MMRotateUpdateInfo(RotateUpdateAction_) {
  _MMUpdateInfo["default"].call(this, RotateUpdateAction_);
  this.m_className = 'MMRotateUpdateInfo';
  this.m_operator = _OPERATOR["default"].ROTATE;
  this.m_center; // MMLgPoint
  this.m_angle; // float
  this.m_angleInfect; // bool
  if (RotateUpdateAction_ instanceof _MMUpdateAction["default"]) {
    this.m_center = RotateUpdateAction_.m_center;
    this.m_angle = RotateUpdateAction_.m_angle;
    this.m_angleInfect = RotateUpdateAction_.m_angleInfect;
  }
}
;
MMRotateUpdateInfo.prototype = new _MMActionInfo["default"]();
MMRotateUpdateInfo.superclass = _MMUpdateInfo["default"].prototype;
MMRotateUpdateInfo.prototype.getClassName = function () {
  return this.m_className;
};
MMRotateUpdateInfo.prototype.getReverseInfo = function () {};
MMRotateUpdateInfo.prototype.encode = function (enc_) {
  MMRotateUpdateInfo.superclass.encode.call(this, enc_);
  enc_.encodeMMPoint(this.m_center);
  enc_.encodeFloat(this.m_angle);
  enc_.encodeBool(this.m_angleInfect);
};
MMRotateUpdateInfo.prototype.decode = function (dec_, ver_) {
  MMRotateUpdateInfo.superclass.decode.call(this, dec_, ver_);
  this.m_center = dec_.decodeFromMMPoint(ver_);
  this.m_angle = dec_.decodeFromFloat(ver_);
  this.m_angleInfect = dec_.decodeFromBool(ver_);
};
MMRotateUpdateInfo.prototype.getCompatible = function (whiteboard_) {
  return new _MMUpdateActions.MMRotateAction(this.m_center, this.m_angle, this.m_angleInfect, this.m_id);
};

// //////////////////////////////////////////////////////////////////////////////////////////////////////////
//
// move_ui
//
//
/**
 * @author lishusheng ,2014-06-11
 * @param ids_
 * @returns {MMMoveUpdateInfo}
 */
function MMMoveUpdateInfo(moveUpdateAction_) {
  _MMUpdateInfo["default"].call(this, moveUpdateAction_);
  this.m_className = 'MMMoveUpdateInfo';
  this.m_operator = _OPERATOR["default"].MOVE;
  this.m_offset; // MMLgPoint
  if (moveUpdateAction_ instanceof _MMUpdateAction["default"]) {
    this.m_offset = moveUpdateAction_.m_offset;
  }
}
;
MMMoveUpdateInfo.prototype = new _MMActionInfo["default"]();
MMMoveUpdateInfo.superclass = _MMUpdateInfo["default"].prototype;
MMMoveUpdateInfo.prototype.getClassName = function () {
  return this.m_className;
};
MMMoveUpdateInfo.prototype.getReverseInfo = function () {};
MMMoveUpdateInfo.prototype.encode = function (enc_) {
  MMMoveUpdateInfo.superclass.encode.call(this, enc_);
  enc_.encodeMMPoint(this.m_offset);
};
MMMoveUpdateInfo.prototype.decode = function (dec_, ver_) {
  MMMoveUpdateInfo.superclass.decode.call(this, dec_, ver_);
  this.m_offset = dec_.decodeFromMMPoint(ver_);
};
MMMoveUpdateInfo.prototype.getCompatible = function (whiteboard_) {
  return new _MMUpdateActions.MMMoveAction(this.m_offset, this.m_id);
};
// //////////////////////////////////////////////////////////////////////////////////////////////////////////
//
// scale_ui
//
//

function MMScaleUpdateInfo(scaleUpdateAction_) {
  _MMUpdateInfo["default"].call(this, scaleUpdateAction_);
  this.m_className = 'MMScaleUpdateInfo';
  this.m_operator = _OPERATOR["default"].SCALE;
  this.m_scaleChanged; // vector<OBJ_ID>
  this.m_activeIds; // vector<OBJ_ID>
  this.m_newValue; // bool
  this.m_basePt; // MMLgPoint
  this.m_angleInfect; // bool
  this.m_idScaleMap; // map<OBJ_ID, MMLgPoint>

  if (scaleUpdateAction_ instanceof _MMUpdateAction["default"]) {
    this.m_scaleChanged = scaleUpdateAction_.m_scaleChanged;
    this.m_activeIds = scaleUpdateAction_.m_activeIds;
    this.m_newValue = scaleUpdateAction_.m_newValue;
    this.m_basePt = scaleUpdateAction_.m_basePt;
    this.m_angleInfect = scaleUpdateAction_.m_angleInfect;
    this.m_idScaleMap = scaleUpdateAction_.m_idScaleMap;
  }
}
;
MMScaleUpdateInfo.prototype = new _MMActionInfo["default"]();
MMScaleUpdateInfo.superclass = _MMUpdateInfo["default"].prototype;
MMScaleUpdateInfo.prototype.getClassName = function () {
  return this.m_className;
};
MMScaleUpdateInfo.prototype.getReverseInfo = function () {};
MMScaleUpdateInfo.prototype.encode = function (enc_) {
  MMScaleUpdateInfo.superclass.encode.call(this, enc_);
  enc_.encodeMMPoint(this.m_basePt);
  enc_.encodeBool(this.m_angleInfect);
  enc_.encodeMap(this.m_idScaleMap, "ObjID", "MMPoint");
  enc_.encodeArray(this.m_scaleChanged, "ObjID");
  enc_.encodeBool(this.m_newValue);
};
MMScaleUpdateInfo.prototype.decode = function (dec_, ver_) {
  MMScaleUpdateInfo.superclass.decode.call(this, dec_, ver_);
  this.m_basePt = dec_.decodeFromMMPoint(ver_);
  this.m_angleInfect = dec_.decodeFromBool(ver_);
  this.m_idScaleMap = dec_.decodeFromMap(ver_, "ObjID", "MMPoint");
  this.m_scaleChanged = dec_.decodeFromArray(ver_, "ObjID");
  this.m_newValue = dec_.decodeFromBool(ver_);
};
MMScaleUpdateInfo.prototype.getCompatible = function (whiteboard_) {
  return new _MMUpdateActions.MMScaleAction(this.m_scaleChanged, this.m_activeIds, this.m_newValue, this.m_basePt, this.m_angleInfect, this.m_idScaleMap, this.m_id);
};
// //////////////////////////////////////////////////////////////////////////////////////////////////////////
//
// yellowPtMove_ui
//
//

function MMYellowPtMoveUpdateInfo(yellowPtMoveUpdateAction_) {
  _MMUpdateInfo["default"].call(this, yellowPtMoveUpdateAction_);
  this.m_className = 'MMYellowPtMoveUpdateInfo';
  this.m_operator = _OPERATOR["default"].YELLOW_MOVE;
  this.m_oldYellowPts; // vector<MMLgPoint>
  this.m_newYellowPts; // vector<MMLgPoint>
  this.m_oldClose; // bool
  this.m_newClose; // bool

  if (yellowPtMoveUpdateAction_ instanceof _MMUpdateAction["default"]) {
    this.m_oldYellowPts = yellowPtMoveUpdateAction_.m_oldYellowPts;
    this.m_newYellowPts = yellowPtMoveUpdateAction_.m_newYellowPts;
    this.m_oldClose = yellowPtMoveUpdateAction_.m_oldClose;
    this.m_newClose = yellowPtMoveUpdateAction_.m_newClose;
  }
}
;
MMYellowPtMoveUpdateInfo.prototype = new _MMActionInfo["default"]();
MMYellowPtMoveUpdateInfo.superclass = _MMUpdateInfo["default"].prototype;
MMYellowPtMoveUpdateInfo.prototype.getClassName = function () {
  return this.m_className;
};
MMYellowPtMoveUpdateInfo.prototype.getReverseInfo = function () {};
MMYellowPtMoveUpdateInfo.prototype.encode = function (enc_) {
  MMYellowPtMoveUpdateInfo.superclass.encode.call(this, enc_);
  enc_.encodeArray(this.m_oldYellowPts, "MMPoint");
  enc_.encodeArray(this.m_newYellowPts, "MMPoint");
  enc_.encodeBool(this.m_oldClose);
  enc_.encodeBool(this.m_newClose);
};
MMYellowPtMoveUpdateInfo.prototype.decode = function (dec_, ver_) {
  MMYellowPtMoveUpdateInfo.superclass.decode.call(this, dec_, ver_);
  this.m_oldYellowPts = dec_.decodeFromArray(ver_, "MMPoint");
  this.m_newYellowPts = dec_.decodeFromArray(ver_, "MMPoint");
  this.m_oldClose = dec_.decodeFromBool(ver_);
  this.m_newClose = dec_.decodeFromBool(ver_);
};
MMYellowPtMoveUpdateInfo.prototype.getCompatible = function (whiteboard_) {
  return new _MMUpdateActions.MMYellowPtMoveAction(this.m_oldYellowPts, this.m_newYellowPts, this.m_oldClose, this.m_newClose, this.m_id);
};

// //////////////////////////////////////////////////////////////////////////////////////////////////////////
//
// stroke_ui
//
//

function MMStrokeUpdateInfo(strokeUpdateAction_) {
  _MMUpdateInfo["default"].call(this, strokeUpdateAction_);
  this.m_className = 'MMStrokeUpdateInfo';
  this.m_operator = _OPERATOR["default"].STROKE;
  this.m_oldType; // vector<MMStrokeType>
  this.m_newType; // vector<MMStrokeType>

  if (strokeUpdateAction_ instanceof _MMUpdateAction["default"]) {
    this.m_oldType = strokeUpdateAction_.m_oldType;
    this.m_newType = strokeUpdateAction_.m_newType;
  }
}
;
MMStrokeUpdateInfo.prototype = new _MMActionInfo["default"]();
MMStrokeUpdateInfo.superclass = _MMUpdateInfo["default"].prototype;
MMStrokeUpdateInfo.prototype.getClassName = function () {
  return this.m_className;
};
MMStrokeUpdateInfo.prototype.getReverseInfo = function () {};
MMStrokeUpdateInfo.prototype.encode = function (enc_) {
  MMStrokeUpdateInfo.superclass.encode.call(this, enc_);
  enc_.encodeArray(this.m_oldType, "Meta");
  enc_.encodeArray(this.m_newType, "Meta");
};
MMStrokeUpdateInfo.prototype.decode = function (dec_, ver_) {
  MMStrokeUpdateInfo.superclass.decode.call(this, dec_, ver_);
  this.m_oldType = dec_.decodeFromArray(ver_, "Meta");
  this.m_newType = dec_.decodeFromArray(ver_, "Meta");
};
MMStrokeUpdateInfo.prototype.getCompatible = function (whiteboard_) {
  return new _MMUpdateActions.MMStrokeAction(this.m_oldType, this.m_newType, this.m_id);
};
// //////////////////////////////////////////////////////////////////////////////////////////////////////////
//
// fill_ui
//
//
function MMFillUpdateInfo(fillUpdateAction_) {
  _MMUpdateInfo["default"].call(this, fillUpdateAction_);
  this.m_className = 'MMFillUpdateInfo';
  this.m_operator = _OPERATOR["default"].FILL;
  this.m_oldType; // vector<MMFillType>
  this.m_newType; // vector<MMFillType>

  if (fillUpdateAction_ instanceof _MMUpdateAction["default"]) {
    this.m_oldType = fillUpdateAction_.m_oldType;
    this.m_newType = fillUpdateAction_.m_newType;
  }
}
;
MMFillUpdateInfo.prototype = new _MMActionInfo["default"]();
MMFillUpdateInfo.superclass = _MMUpdateInfo["default"].prototype;
MMFillUpdateInfo.prototype.getClassName = function () {
  return this.m_className;
};
MMFillUpdateInfo.prototype.getReverseInfo = function () {};
MMFillUpdateInfo.prototype.encode = function (enc_) {
  MMFillUpdateInfo.superclass.encode.call(this, enc_);
  enc_.encodeArray(this.m_oldType, "Meta");
  enc_.encodeArray(this.m_newType, "Meta");
};
MMFillUpdateInfo.prototype.decode = function (dec_, ver_) {
  MMFillUpdateInfo.superclass.decode.call(this, dec_, ver_);
  this.m_oldType = dec_.decodeFromArray(ver_, "Meta");
  this.m_newType = dec_.decodeFromArray(ver_, "Meta");
};
MMFillUpdateInfo.prototype.getCompatible = function (whiteboard_) {
  return new _MMUpdateActions.MMFillAction(this.m_oldType, this.m_newType, this.m_id);
};

// //////////////////////////////////////////////////////////////////////////////////////////////////////////
//
// shadow_ui
//
//
function MMShadowUpdateInfo(shadowUpdateAction_) {
  _MMUpdateInfo["default"].call(this, shadowUpdateAction_);
  this.m_className = 'MMShadowUpdateInfo';
  this.m_operator = _OPERATOR["default"].SHADOW;
  this.m_oldType; // vector<MMShadowType>
  this.m_newType; // vector<MMShadowType>

  if (shadowUpdateAction_ instanceof _MMUpdateAction["default"]) {
    this.m_oldType = shadowUpdateAction_.m_oldType;
    this.m_newType = shadowUpdateAction_.m_newType;
  }
}
;
MMShadowUpdateInfo.prototype = new _MMActionInfo["default"]();
MMShadowUpdateInfo.superclass = _MMUpdateInfo["default"].prototype;
MMShadowUpdateInfo.prototype.getClassName = function () {
  return this.m_className;
};
MMShadowUpdateInfo.prototype.getReverseInfo = function () {};
MMShadowUpdateInfo.prototype.encode = function (enc_) {
  MMShadowUpdateInfo.superclass.encode.call(this, enc_);
  enc_.encodeArray(this.m_oldType, "Meta");
  enc_.encodeArray(this.m_newType, "Meta");
};
MMShadowUpdateInfo.prototype.decode = function (dec_, ver_) {
  MMShadowUpdateInfo.superclass.decode.call(this, dec_, ver_);
  this.m_oldType = dec_.decodeFromArray(ver_, "Meta");
  this.m_newType = dec_.decodeFromArray(ver_, "Meta");
};
MMShadowUpdateInfo.prototype.getCompatible = function (whiteboard_) {
  return new _MMUpdateActions.MMShadowAction(this.m_oldType, this.m_newType, this.m_id);
};
// //////////////////////////////////////////////////////////////////////////////////////////////////////////
//
// style_ui
//
//
function MMStyleUpdateInfo(styleUpdateAction_) {
  _MMUpdateInfo["default"].call(this, styleUpdateAction_);
  this.m_className = 'MMStyleUpdateInfo';
  this.m_operator = _OPERATOR["default"].STYLE;
  this.m_oldStrokeType; // vector<MMStrokeType>
  this.m_newStrokeType; // vector<MMStrokeType>

  this.m_oldFillType; // vector<MMFillType>
  this.m_newFillType; // vector<MMFillType>

  this.m_oldShadowType; // vector<MMShadowType>
  this.m_newShadowType; // vector<MMShadowType>

  if (styleUpdateAction_ instanceof _MMUpdateAction["default"]) {
    this.m_oldStrokeType = styleUpdateAction_.m_oldStrokeType;
    this.m_newStrokeType = styleUpdateAction_.m_newStrokeType;
    this.m_oldFillType = styleUpdateAction_.m_oldFillType;
    this.m_newFillType = styleUpdateAction_.m_newStrokeType;
    this.m_oldShadowType = styleUpdateAction_.m_oldShadowType;
    this.m_newShadowType = styleUpdateAction_.m_newShadowType;
  }
}
;
MMStyleUpdateInfo.prototype = new _MMActionInfo["default"]();
MMStyleUpdateInfo.superclass = _MMUpdateInfo["default"].prototype;
MMStyleUpdateInfo.prototype.getClassName = function () {
  return this.m_className;
};
MMStyleUpdateInfo.prototype.getReverseInfo = function () {};
MMStyleUpdateInfo.prototype.encode = function (enc_) {
  MMStyleUpdateInfo.superclass.encode.call(this, enc_);
  enc_.encodeArray(this.m_oldStrokeType, "Meta");
  enc_.encodeArray(this.m_newStrokeType, "Meta");
  enc_.encodeArray(this.m_oldFillType, "Meta");
  enc_.encodeArray(this.m_newFillType, "Meta");
  enc_.encodeArray(this.m_oldShadowType, "Meta");
  enc_.encodeArray(this.m_newShadowType, "Meta");
};
MMStyleUpdateInfo.prototype.decode = function (dec_, ver_) {
  MMStyleUpdateInfo.superclass.decode.call(this, dec_, ver_);
  this.m_oldStrokeType = dec_.decodeFromArray(ver_, "Meta");
  this.m_newStrokeType = dec_.decodeFromArray(ver_, "Meta");
  this.m_oldFillType = dec_.decodeFromArray(ver_, "Meta");
  this.m_newFillType = dec_.decodeFromArray(ver_, "Meta");
  this.m_oldShadowType = dec_.decodeFromArray(ver_, "Meta");
  this.m_newShadowType = dec_.decodeFromArray(ver_, "Meta");
};
MMStyleUpdateInfo.prototype.getCompatible = function (whiteboard_) {
  return new _MMUpdateActions.MMStyleAction(this.m_oldStrokeType, this.m_newStrokeType, this.m_oldFillType, this.m_newFillType, this.m_oldShadowType, this.m_newShadowType, this.m_id);
};

// //////////////////////////////////////////////////////////////////////////////////////////////////////////
//
// color_ui
//
//
function MMColorUpdateInfo(colorUpdateAction_) {
  _MMUpdateInfo["default"].call(this, colorUpdateAction_);
  this.m_className = 'MMColorUpdateInfo';
  this.m_operator = _OPERATOR["default"].COLOR;
  this.m_oldColor; // vector<MMColor>
  this.m_newColor; // vector<MMColor>

  if (colorUpdateAction_ instanceof _MMUpdateAction["default"]) {
    this.m_oldColor = colorUpdateAction_.m_oldColor;
    this.m_newColor = colorUpdateAction_.m_newColor;
  }
}
;
MMColorUpdateInfo.prototype = new _MMActionInfo["default"]();
MMColorUpdateInfo.superclass = _MMUpdateInfo["default"].prototype;
MMColorUpdateInfo.prototype.getClassName = function () {
  return this.m_className;
};
MMColorUpdateInfo.prototype.getReverseInfo = function () {};
MMColorUpdateInfo.prototype.encode = function (enc_) {
  MMColorUpdateInfo.superclass.encode.call(this, enc_);
  enc_.encodeArray(this.m_oldColor, "Meta");
  enc_.encodeArray(this.m_newColor, "Meta");
};
MMColorUpdateInfo.prototype.decode = function (dec_, ver_) {
  MMColorUpdateInfo.superclass.decode.call(this, dec_, ver_);
  this.m_oldColor = dec_.decodeFromArray(ver_, "Meta");
  this.m_newColor = dec_.decodeFromArray(ver_, "Meta");
};
MMColorUpdateInfo.prototype.getCompatible = function (whiteboard_) {
  return new _MMUpdateActions.MMColorAction(this.m_oldColor, this.m_newColor, this.m_id);
};

// //////////////////////////////////////////////////////////////////////////////////////////////////////////
//
// font_ui
//
//
function MMFontUpdateInfo(fontUpdateAction_) {
  _MMUpdateInfo["default"].call(this, fontUpdateAction_);
  this.m_className = 'MMFontUpdateInfo';
  this.m_operator = _OPERATOR["default"].TEXT_FONT;
  this.m_oldFont; // {MMFont}
  this.m_newFont; // {MMFont}
  this.m_oldAlign; // {MolaTextAlignment}
  this.m_newAlign; // {MolaTextAlignment}
  if (fontUpdateAction_ instanceof _MMUpdateAction["default"]) {
    this.m_oldFont = fontUpdateAction_.m_oldFont;
    this.m_newFont = fontUpdateAction_.m_newFont;
    this.m_oldAlign = fontUpdateAction_.m_oldAlign;
    this.m_newAlign = fontUpdateAction_.m_newAlign;
  }
}
;
MMFontUpdateInfo.prototype = new _MMActionInfo["default"]();
MMFontUpdateInfo.superclass = _MMUpdateInfo["default"].prototype;
MMFontUpdateInfo.prototype.getClassName = function () {
  return this.m_className;
};
MMFontUpdateInfo.prototype.getReverseInfo = function () {};
MMFontUpdateInfo.prototype.encode = function (enc_) {
  MMFontUpdateInfo.superclass.encode.call(this, enc_);
  enc_.encodeMMFont(this.m_oldFont);
  enc_.encodeMolaTextAlignment(this.m_oldAlign);
  enc_.encodeMMFont(this.m_newFont);
  enc_.encodeMolaTextAlignment(this.m_newAlign);
};
MMFontUpdateInfo.prototype.decode = function (dec_, ver_) {
  MMFontUpdateInfo.superclass.decode.call(this, dec_, ver_);
  this.m_oldFont = dec_.decodeFromMMFont(ver_);
  this.m_oldAlign = dec_.decodeFromMolaTextAlignment(ver_);
  this.m_newFont = dec_.decodeFromMMFont(ver_);
  this.m_newAlign = dec_.decodeFromMolaTextAlignment(ver_);
};
MMFontUpdateInfo.prototype.getCompatible = function (whiteboard_) {
  return new _MMUpdateActions.MMFontAction(this.m_oldFont, this.m_newFont, this.m_oldAlign, this.m_newAlign, this.m_id);
};
// //////////////////////////////////////////////////////////////////////////////////////////////////////////
//
// text_ui
//
//
function MMTextUpdateInfo(textUpdateAction_) {
  _MMUpdateInfo["default"].call(this, textUpdateAction_);
  this.m_className = 'MMTextUpdateInfo';
  this.m_operator = _OPERATOR["default"].TEXT_CONTENT;
  this.m_start; // 修改字符串的开始位置 unsigned
  this.m_oldStr; // 旧字符串 string
  this.m_newStr; // 新字符串 string
  this.m_oldRect; // 旧框的矩形 MMLgRect
  this.m_newRect; // 新框的矩形 MMLgRect
  this.m_oldFontSize; // 旧字体的大小 float
  this.m_newFontSize; // 新字体的大小 float

  if (textUpdateAction_ instanceof _MMUpdateAction["default"]) {
    this.m_start = textUpdateAction_.m_start;
    this.m_oldStr = textUpdateAction_.m_oldStr;
    this.m_newStr = textUpdateAction_.m_newStr;
    this.m_oldRect = textUpdateAction_.m_oldRect;
    this.m_newRect = textUpdateAction_.m_newRect;
    this.m_oldFontSize = textUpdateAction_.m_oldFontSize;
    this.m_newFontSize = textUpdateAction_.m_newFontSize;
  }
}
;
MMTextUpdateInfo.prototype = new _MMActionInfo["default"]();
MMTextUpdateInfo.superclass = _MMUpdateInfo["default"].prototype;
MMTextUpdateInfo.prototype.getClassName = function () {
  return this.m_className;
};
MMTextUpdateInfo.prototype.getReverseInfo = function () {};
MMTextUpdateInfo.prototype.encode = function (enc_) {
  MMTextUpdateInfo.superclass.encode.call(this, enc_);
  enc_.encode4Bytes(this.m_start);
  enc_.encodeString(this.m_oldStr);
  enc_.encodeString(this.m_newStr);
  enc_.encodeMMRect(this.m_oldRect);
  enc_.encodeMMRect(this.m_newRect);
  enc_.encodeFloat(this.m_oldFontSize);
  enc_.encodeFloat(this.m_newFontSize);
};
MMTextUpdateInfo.prototype.decode = function (dec_, ver_) {
  MMTextUpdateInfo.superclass.decode.call(this, dec_, ver_);
  this.m_start = dec_.decodeFrom4Bytes(ver_);
  this.m_oldStr = dec_.decodeFromString(ver_);
  this.m_newStr = dec_.decodeFromString(ver_);
  this.m_oldRect = dec_.decodeFromMMRect(ver_);
  this.m_newRect = dec_.decodeFromMMRect(ver_);
  this.m_oldFontSize = dec_.decodeFromFloat(ver_);
  this.m_newFontSize = dec_.decodeFromFloat(ver_);
};
MMTextUpdateInfo.prototype.getCompatible = function (whiteboard_) {
  return new _MMUpdateActions.MMTextAction(this.m_start, this.m_oldStr, this.m_newStr, this.m_oldRect, this.m_newRect, this.m_oldFontSize, this.m_newFontSize, this.m_id);
};
// //////////////////////////////////////////////////////////////////////////////////////////////////////////
//
// textColor_ui
//
//
function MMTextColorUpdateInfo(textColorUpdateAction_) {
  _MMUpdateInfo["default"].call(this, textColorUpdateAction_);
  this.m_className = 'MMTextColorUpdateInfo';
  this.m_operator = _OPERATOR["default"].TEXT_COLOR;
  this.m_oldColor; // MMColor
  this.m_newColor; // MMColor

  if (textColorUpdateAction_ instanceof _MMUpdateAction["default"]) {
    this.m_oldColor = textColorUpdateAction_.m_oldColor;
    this.m_newColor = textColorUpdateAction_.m_newColor;
  }
}
;
MMTextColorUpdateInfo.prototype = new _MMActionInfo["default"]();
MMTextColorUpdateInfo.superclass = _MMUpdateInfo["default"].prototype;
MMTextColorUpdateInfo.prototype.getClassName = function () {
  return this.m_className;
};
MMTextColorUpdateInfo.prototype.getReverseInfo = function () {};
MMTextColorUpdateInfo.prototype.encode = function (enc_) {
  MMTextColorUpdateInfo.superclass.encode.call(this, enc_);
  enc_.encodeObject(this.m_oldColor);
  enc_.encodeObject(this.m_newColor);
};
MMTextColorUpdateInfo.prototype.decode = function (dec_, ver_) {
  MMTextColorUpdateInfo.superclass.decode.call(this, dec_, ver_);
  this.m_oldColor = dec_.decodeFromObject(ver_);
  this.m_newColor = dec_.decodeFromObject(ver_);
};
MMTextColorUpdateInfo.prototype.getCompatible = function (whiteboard_) {
  return new _MMUpdateActions.MMTextColorAction(this.m_oldColor, this.m_newColor, this.m_id);
};
// //////////////////////////////////////////////////////////////////////////////////////////////////////////
//
// image_ui
//
//
function MMImageUpdateInfo(imageUpdateAction_) {
  _MMUpdateInfo["default"].call(this, imageUpdateAction_);
  this.m_className = 'MMImageUpdateInfo';
  // this.m_operator = OPERATOR.TEXT_COLOR ;

  this.m_image; // ArrayBuffer

  if (imageUpdateAction_ instanceof _MMUpdateAction["default"]) {
    this.m_image = imageUpdateAction_.m_image;
  }
}
;
MMImageUpdateInfo.prototype = new _MMActionInfo["default"]();
MMImageUpdateInfo.superclass = _MMUpdateInfo["default"].prototype;
MMImageUpdateInfo.prototype.getClassName = function () {
  return this.m_className;
};
MMImageUpdateInfo.prototype.getReverseInfo = function () {};
MMImageUpdateInfo.prototype.encode = function (enc_) {
  // MMImageUpdateInfo.superclass.encode.call(this,
  // enc_);
  // enc_.encodeBuffer(this.m_image);
};
MMImageUpdateInfo.prototype.decode = function (dec_, ver_) {
  // MMImageUpdateInfo.superclass.decode.call(this,dec_,ver_);
  // this.m_image = dec_.decodeFromBuffer(ver_);
};
MMImageUpdateInfo.prototype.getCompatible = function (whiteboard_) {
  return new _MMUpdateActions.MMImageAction(this.m_image, this.m_id);
};
// //////////////////////////////////////////////////////////////////////////////////////////////////////////
//
// obj_lock_ui
//
//

function MMObjLockUpdateInfo(objLockUpdateAction_) {
  _MMUpdateInfo["default"].call(this, objLockUpdateAction_);
  this.m_className = 'MMObjLockUpdateInfo';
  this.m_operator = _OPERATOR["default"].LOCKOBJ;
  this.m_oldLock; // bool
  this.m_newLock; // bool

  if (objLockUpdateAction_ instanceof _MMUpdateAction["default"]) {
    this.m_oldLock = objLockUpdateAction_.m_oldLock;
    this.m_newLock = objLockUpdateAction_.m_newLock;
  }
}
;
MMObjLockUpdateInfo.prototype = new _MMActionInfo["default"]();
MMObjLockUpdateInfo.superclass = _MMUpdateInfo["default"].prototype;
MMObjLockUpdateInfo.prototype.getClassName = function () {
  return this.m_className;
};
MMObjLockUpdateInfo.prototype.getReverseInfo = function () {};
MMObjLockUpdateInfo.prototype.encode = function (enc_) {
  MMObjLockUpdateInfo.superclass.encode.call(this, enc_);
  enc_.encodeBool(this.m_oldLock);
  enc_.encodeBool(this.m_newLock);
};
MMObjLockUpdateInfo.prototype.decode = function (dec_, ver_) {
  MMObjLockUpdateInfo.superclass.decode.call(this, dec_, ver_);
  this.m_oldLock = dec_.decodeFromBool(ver_);
  this.m_newLock = dec_.decodeFromBool(ver_);
};
MMObjLockUpdateInfo.prototype.getCompatible = function (whiteboard_) {
  return new _MMUpdateActions.MMObjLockAction(this.m_oldLock, this.m_newLock, this.m_id);
};
function MMCommentCompleteInfo(ccAction_) {
  _MMUpdateInfo["default"].call(this, ccAction_);
  if (ccAction_ instanceof _MMUpdateActions.MMCommentCompleteAction) {
    this.m_completed = ccAction_.m_completed;
    this.m_pageIndex = ccAction_.m_pageIndex;
    this.m_needSendNotification = ccAction_.m_needSendNotification;
  }
  this.m_ver = 1;
  this.m_operator = _OPERATOR["default"].COMMENT_COMPLETED;
}
MMCommentCompleteInfo.prototype = new _MMUpdateInfo["default"]();
MMCommentCompleteInfo.superclass = _MMUpdateInfo["default"].prototype;
MMCommentCompleteInfo.prototype.m_className = "MMCommentCompleteInfo";
MMCommentCompleteInfo.prototype.encode = function (enc_) {
  MMCommentCompleteInfo.superclass.encode.call(this, enc_);
  enc_.encodeBool(this.m_completed);
  enc_.encode4Bytes(this.m_pageIndex);
};
MMCommentCompleteInfo.prototype.decode = function (dec_, ver_) {
  MMCommentCompleteInfo.superclass.decode.call(this, dec_, ver_);
  this.m_completed = dec_.decodeFromBool(ver_);
  this.m_pageIndex = dec_.decodeFrom4Bytes(ver_);
};
MMCommentCompleteInfo.prototype.getCompatible = function (whiteboard_) {
  return new _MMUpdateActions.MMCommentCompleteAction(this.m_completed, this.m_pageIndex, this.m_id);
};
function MMCommentPraiseInfo(cpAction) {
  _MMUpdateInfo["default"].call(this, cpAction);
  if (cpAction instanceof _MMUpdateActions.MMCommentPraiseAction) {
    this.m_userId = cpAction.m_userId;
    this.m_pageIndex = cpAction.m_pageIndex;
    this.m_needSendNotification = cpAction.m_needSendNotification;
  }
  this.m_ver = 1;
  this.m_operator = _OPERATOR["default"].COMMENT_PRAISE;
}
MMCommentPraiseInfo.prototype = new _MMUpdateInfo["default"]();
MMCommentPraiseInfo.superclass = _MMUpdateInfo["default"].prototype;
MMCommentPraiseInfo.prototype.m_className = "MMCommentPraiseInfo";
MMCommentPraiseInfo.prototype.encode = function (enc_) {
  MMCommentPraiseInfo.superclass.encode.call(this, enc_);
  enc_.encode8Bytes(this.m_userId);
  enc_.encode4Bytes(this.m_pageIndex);
};
MMCommentPraiseInfo.prototype.decode = function (dec_, ver_) {
  MMCommentPraiseInfo.superclass.decode.call(this, dec_, ver_);
  this.m_userId = dec_.decodeFrom8Bytes(ver_);
  this.m_pageIndex = dec_.decodeFrom4Bytes(ver_);
};
MMCommentPraiseInfo.prototype.getCompatible = function (whiteboard_) {
  return new _MMUpdateActions.MMCommentPraiseAction(this.m_userId, this.m_pageIndex, this.m_id);
};

},{"1077":1077,"1184":1184,"1454":1454,"993":993,"994":994,"995":995,"997":997}],997:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var OPERATOR = {
  ROTATE: 1,
  MOVE: 2,
  SCALE: 3,
  FILL: 4,
  STROKE: 5,
  SHADOW: 6,
  STYLE: 7,
  TEXT_FONT: 8,
  TEXT_COLOR: 9,
  TEXT_CONTENT: 10,
  TABLE: 11,
  YELLOW_MOVE: 12,
  COLOR: 13,
  IMAGE: 14,
  LOCKOBJ: 15,
  COMMENT_PRAISE: 16,
  COMMENT_COMPLETED: 17
};
var _default = exports["default"] = OPERATOR;

},{"1454":1454}],995:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMUpdateAction = _interopRequireDefault(require(993));
var _MMActionInfo = _interopRequireDefault(require(1077));
var _ACTION_TYPE = _interopRequireDefault(require(1076));
var _ACTION_SOURCE = _interopRequireDefault(require(1075));
var _Decoder = _interopRequireDefault(require(799));
/**
 * @author lishusheng ,2014-06-11
 * @param ids_
 * @returns {MMUpdateInfo}
 */
function MMUpdateInfo(updateAction_) {
  _MMActionInfo["default"].call(this, updateAction_);
  this.m_className = 'MMUpdateInfo';
  this.m_type = _ACTION_TYPE["default"].UPDATE;
  this.m_source = _ACTION_SOURCE["default"].LOCAL;
  this.m_id = new Array(); // vector<OBJ_ID>
  this.m_operator; // OPERATOR int32
  this.m_option = new Array(); // vector<update_option>
  if (updateAction_ instanceof _MMUpdateAction["default"]) {
    this.m_id = updateAction_.m_ids;
    this.m_operator = updateAction_.m_operator;
    this.m_option = updateAction_.m_option;
  }
}
;
MMUpdateInfo.prototype = new _MMActionInfo["default"]();
MMUpdateInfo.superclass = _MMActionInfo["default"].prototype;
MMUpdateInfo.prototype.__getObjIds = function () {
  return this.m_id;
};
MMUpdateInfo.prototype.__getObjects = function (whiteboard_) {
  var _ret = new Array();
  if (this.m_dataImage == null) {
    return null;
  }
  var _dec = new _Decoder["default"](whiteboard_);
  _dec.setStream(this.m_dataImage);
  var _ver = _dec.decodeFrom4Bytes(___MM_DOC_VERSION__);
  var _size = _dec.decodeFrom4Bytes(_ver);
  for (var i = 0; i < _size; i++) {
    var _object = _dec.decodeFromObject(_ver);
    if (!_object.getIncludeData()) {
      _object.setIncludeData(true);
      var _objData = _object.getObjData();
      _objData.decode(_dec, _ver);
    }
    _ret.push(_object);
  }
  return _ret;
};
MMUpdateInfo.prototype.encode = function (enc_) {
  MMUpdateInfo.superclass.encode.call(this, enc_);
  enc_.encodeArray(this.m_id, "ObjID");
  enc_.encode4Bytes(this.m_operator);
  var _size = this.m_option.length;
  enc_.encode4Bytes(_size);
  for (var i = 0; i < _size; i++) {
    this.m_operator[i].encode(enc_);
  }
};
MMUpdateInfo.prototype.decode = function (dec_, ver_) {
  MMUpdateInfo.superclass.decode.call(this, dec_, ver_);
  this.m_id = dec_.decodeFromArray(ver_, "ObjID");
  this.m_operator = dec_.decodeFrom4Bytes(ver_);
  var _size = 0;
  _size = dec_.decodeFrom4Bytes(ver_);
  for (var i = 0; i < _size; i++) {
    var op = new UpdateOption();
    op.decode(dec_, ver_);
    this.m_option.push(op);
  }
};
MMUpdateInfo.prototype.getClassName = function () {
  return this.m_className;
};
MMUpdateInfo.prototype.getCompatible = function (whiteboard_) {
  var _ObjIds = this.__getObjIds();
  return new _MMUpdateAction["default"](_ObjIds);
};
function UpdateOption() {
  this.m_updateAll = true; // bool
  this.m_oldFont = 0.0; // float
  this.m_newFont = 0.0; // float
}
;
/**
 * @return UpdateOption
 */
UpdateOption.prototype.getReverseOption = function () {};
UpdateOption.prototype.encode = function (enc_) {
  var _ver = 0;
  enc_.encode4Bytes(_ver);
  enc_.encodeBool(this.m_updateAll);
  enc_.encodeFloat(this.m_oldFont);
  enc_.encodeFloat(this.m_newFont);
};
UpdateOption.prototype.decode = function (dec_, ver_) {
  var _ver = 0;
  _ver = dec_.decodeFrom4Bytes(ver_);
  this.m_updateAll = dec_.decodeFromBool(ver_);
  this.m_oldFont = dec_.decodeFromFloat(ver_);
  this.m_newFont = dec_.decodeFromFloat(ver_);
};
var _default = exports["default"] = MMUpdateInfo;

},{"1075":1075,"1076":1076,"1077":1077,"1184":1184,"1454":1454,"799":799,"993":993}],993:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMAction = _interopRequireDefault(require(963));
var _MMObject = _interopRequireDefault(require(1081));
var _MMUndoInfo = _interopRequireDefault(require(992));
function MMUpdateAction(ids) {
  _MMAction["default"].call(this);
  if (ids) {
    if (!(ids instanceof Array)) {
      ids = [ids];
    }
    if (ids[0] instanceof _MMObject["default"]) {
      for (var i = 0; i < ids.length; i++) {
        ids[i] = ids[i].getId();
      }
    }
  }
  this.m_ids = ids;
  this.m_option = [];
  this.m_operator;
}
;
MMUpdateAction.prototype = new _MMAction["default"]();
MMUpdateAction.superclass = _MMAction["default"].prototype;
MMUpdateAction.prototype.execute = function (whiteboard_) {
  //console.log(this.getClassName()+",MMUpdateAction::execute") ;
  this.calcObjsRectFromWhiteBoard(whiteboard_);
  var _syncPre, _syncPost; //{Set<ID>}
  _syncPre = whiteboard_.getCollabIds(); //同步前的协同Id
  for (var i = 0; i < this.m_ids.length; i++) {
    var _object = whiteboard_.getObject(this.m_ids[i]);
    if (_object) {
      _object.setIdentity(this.m_ids[i].m_macAddr); //设置对象的Identity
      this.__doAction(_object, i);
      this.m_objsRect.push(_object.getExpandRect());
    }
  }
  _syncPost = whiteboard_.getCollabIds(); //同步后的协同Id
};
MMUpdateAction.prototype.preExecuteP = function (whiteboard_) {
  //待实现
};
MMUpdateAction.prototype.postExecuteP = function (whiteboard_) {
  //待实现
  return this.getRefreshRect();
};
MMUpdateAction.prototype.compDetail_deprecated = function (actionInfo_) {
  MMUpdateAction.superclass.compDetail_deprecated(actionInfo_);
  this.m_option = actionInfo_.m_option;
};
/**
 *
 * @returns {MMUndoInfo}
 */
MMUpdateAction.prototype.getRefreshRect = function () {
  var info = new _MMUndoInfo["default"]();
  info.m_refreshRcts = this.m_objsRect;
  return info;
};
MMUpdateAction.prototype.getClassName = function () {
  return this.m_className;
};
MMUpdateAction.prototype.m_className = "MMUpdateAction";
var _default = exports["default"] = MMUpdateAction;

},{"1081":1081,"1184":1184,"1454":1454,"963":963,"992":992}],816:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function MMRange(start_, len_) {
  this.m_start = start_ ? start_ : 0; //unsigned
  this.m_len = len_ ? len_ : 0; //unsigned
}
;
var _default = exports["default"] = MMRange;

},{"1454":1454}],990:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMPageAction = _interopRequireDefault(require(979));
var _ACTION_TYPE = _interopRequireDefault(require(1076));
var _MMRoundInfo = _interopRequireDefault(require(991));
function MMRoundAction(pageIndex_, commitUser_) {
  _MMPageAction["default"].call(this);
  this.m_type = _ACTION_TYPE["default"].COMMIT_ROUND;
  this.m_pageIndex = pageIndex_;
  this.m_commitUser = commitUser_;
}
;
MMRoundAction.prototype = new _MMPageAction["default"]();
MMRoundAction.superclass = _MMPageAction["default"].prototype;
MMRoundAction.prototype.encode = function (enc_) {
  var _roundInfo = new _MMRoundInfo["default"](this);
  _roundInfo.encode(enc_);
};
MMRoundAction.prototype.getClassName = function () {
  return 'MMRoundAction';
};
MMRoundAction.prototype.execute = function (task_, active_) {
  /*
   * 提交者本身不走这个函数，是否应该统一一下？？？
   */
  task_.commitRound(this.m_pageIndex, this.m_commitUser, false);
  task_.trigger('commitRound', this.m_pageIndex);
};
MMRoundAction.prototype.getPageIndex = function () {
  return this.m_pageIndex;
};
MMRoundAction.prototype.getNotifyType = function () {
  return 206;
};
var _default = exports["default"] = MMRoundAction;

},{"1076":1076,"1184":1184,"1454":1454,"979":979,"991":991}],991:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMPageInfo = _interopRequireDefault(require(984));
var _ACTION_TYPE = _interopRequireDefault(require(1076));
var _MMRoundAction = _interopRequireDefault(require(990));
function MMRoundInfo(roundAction_) {
  _MMPageInfo["default"].call(this, roundAction_);
  this.m_type = _ACTION_TYPE["default"].COMMIT_ROUND;
  if (roundAction_ instanceof _MMRoundAction["default"]) {
    this.m_pageIndex = roundAction_.m_pageIndex;
    this.m_commitUser = roundAction_.m_commitUser;
  }
}
MMRoundInfo.prototype.getClassName = function () {
  return 'MMRoundInfo';
};
MMRoundInfo.prototype = new _MMPageInfo["default"]();
MMRoundInfo.superclass = _MMPageInfo["default"].prototype;
MMRoundInfo.prototype.decode = function (dec_, ver_) {
  MMRoundInfo.superclass.decode.call(this, dec_, ver_);
  this.m_pageIndex = dec_.decodeFrom4Bytes(ver_);
  this.m_commitUser = dec_.decodeFrom8Bytes(ver_);
};
MMRoundInfo.prototype.encode = function (enc_) {
  MMRoundInfo.superclass.encode.call(this, enc_);
  enc_.encode4Bytes(this.m_pageIndex);
  enc_.encode8Bytes(this.m_commitUser);
};
MMRoundInfo.prototype.getPageIndex = function () {
  return this.m_pageIndex;
};
MMRoundInfo.prototype.getCompatible = function (whiteboard_) {
  return new _MMRoundAction["default"](this.m_pageIndex, this.m_commitUser);
};
var _default = exports["default"] = MMRoundInfo;

},{"1076":1076,"1184":1184,"1454":1454,"984":984,"990":990}],988:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ACTION_TYPE = _interopRequireDefault(require(1076));
var _MMActionInfo = _interopRequireDefault(require(1077));
var _MMAction = _interopRequireDefault(require(963));
var _MMReadInfo = _interopRequireDefault(require(989));
function MMReadAction(userId_, objId_) {
  _MMActionInfo["default"].call(this);
  this.m_type = _ACTION_TYPE["default"].READ_STATUS;
  this.m_userId = userId_;
  this.m_objId = objId_;
  this.m_ver = 1;
}
MMReadAction.prototype = new _MMAction["default"]();
MMReadAction.superclass = _MMAction["default"].prototype;
MMReadAction.prototype.getClassName = function () {
  return 'MMReadAction';
};
MMReadAction.prototype.encode = function (enc_) {
  var _readInfo = new _MMReadInfo["default"](this);
  _readInfo.encode(enc_);
};
MMReadAction.prototype.execute = function (taskBoard_, active_) {
  var comment = taskBoard_.getObject(this.m_objId);
  if (comment) {
    comment.setRead(this.m_userId);
  }
};
MMReadAction.prototype.postExecuteA = function (whiteboard_) {};
var _default = exports["default"] = MMReadAction;

},{"1076":1076,"1077":1077,"1184":1184,"1454":1454,"963":963,"989":989}],989:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMActionInfo = _interopRequireDefault(require(1077));
var _MMReadAction = _interopRequireDefault(require(988));
var _ACTION_TYPE = _interopRequireDefault(require(1076));
function MMReadInfo(readAction_) {
  _MMActionInfo["default"].call(this, readAction_);
  this.m_ver = 1;
  this.m_type = _ACTION_TYPE["default"].READ_STATUS;
  if (readAction_ instanceof _MMReadAction["default"]) {
    this.m_userId = readAction_.m_userId;
    this.m_objId = readAction_.m_objId;
  }
}
MMReadInfo.prototype = new _MMActionInfo["default"]();
MMReadInfo.superclass = _MMActionInfo["default"].prototype;
MMReadInfo.prototype.getClassName = function () {
  return "MMReadInfo";
};
MMReadInfo.prototype.encode = function (enc_) {
  MMReadInfo.superclass.encode.call(this, enc_);
  enc_.encode8Bytes(this.m_userId);
  enc_.encodeObjID(this.m_objId);
  enc_.encode4Bytes(this.m_pageIndex);
};
MMReadInfo.prototype.decode = function (dec_, ver_) {
  MMReadInfo.superclass.decode.call(this, dec_, ver_);
  this.m_userId = dec_.decodeFrom8Bytes(ver_);
  this.m_objId = dec_.decodeFromObjID(ver_);
  this.m_pageIndex = dec_.decodeFrom4Bytes(ver_);
};
MMReadInfo.prototype.getCompatible = function (whiteboard_) {
  return new _MMReadAction["default"](this.m_userId, this.m_objId);
};
var _default = exports["default"] = MMReadInfo;

},{"1076":1076,"1077":1077,"1184":1184,"1454":1454,"988":988}],982:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _BoardType = _interopRequireDefault(require(947));
var _Page_Oper = _interopRequireDefault(require(998));
var _MMPageAction = _interopRequireDefault(require(979));
var _MMCommonFun = _interopRequireDefault(require(812));
function MMPageBkGrdAction(oper_, oldDefaultBackGround_, oldMapSpecialBackGrounds_, oldSpecialBackGround_, paper_, pageindex_) {
  _MMPageAction["default"].call(this, oper_);

  //保存相应info的属性
  this.m_oldDefaultBackGround = oldDefaultBackGround_; //BackgroundPaperAttr
  this.m_oldMapSpecialBackGrounds = oldMapSpecialBackGrounds_; //map<unsigned, BackgroundPaperAttr>
  this.m_oldSpecialBackGround = oldSpecialBackGround_; // BackgroundPaperAttr
  this.m_paper = paper_; //BackgroundPaperAttr
  this.m_pageindex = pageindex_; //INDEX
}
;
MMPageBkGrdAction.prototype = new _MMPageAction["default"]();
MMPageBkGrdAction.superclass = _MMPageAction["default"].prototype;
MMPageBkGrdAction.prototype.getClassName = function () {
  return 'MMPageBkGrdAction';
};

/**
 * @param whiteboard_
 * @param active_  {bool}
 */
MMPageBkGrdAction.prototype.execute = function (whiteboard_, active_) {
  MMPageBkGrdAction.superclass.execute.call(this, whiteboard_, active_);

  //待实现。。
  this.m_boardPageNum = whiteboard_.getPageCount();
  if (this.m_oper == _Page_Oper["default"].SET_BACKGROUND) {
    if (this.m_pageindex == INDEX.ALL) {
      whiteboard_.getPageBackGround(this.m_oldDefaultBackGround, this.m_oldMapSpecialBackGrounds);
      whiteboard_.setDefaultPageBackGround(this.m_paper);
      for (var i = 0; i < this.m_boardPageNum; i++) {
        //MDPcMobileEditorCommonFun.getMainEditor().refreshDvPageBackground();
      }
    } else {
      whiteboard_.getPageBackGroundByIndex(this.m_pageindex, this.m_oldSpecialBackGround);
      whiteboard_.setPageBackGroundByIndex(this.m_pageindex, this.m_paper);
      var editor = MDPcMobileEditorCommonFun.getMainEditor();
    }
  } else if (this.m_oper == _Page_Oper["default"].RECOVER_BACKGROUND) {
    if (this.m_pageindex == INDEX.ALL) {
      whiteboard_.setPageBackGround(this.m_oldDefaultBackGround, this.m_oldMapSpecialBackGrounds);
      for (var i = 0; i < this.m_boardPageNum; i++) {
        //MDPcMobileEditorCommonFun.getMainEditor().refreshDvPageBackground();
      }
    } else {
      whiteboard_.removePageBackGround(this.m_pageindex);
      //MDPcMobileEditorCommonFun.getMainEditor().refreshDvPageBackground();
    }
  } else {
    console.assert(false);
  }
};
MMPageBkGrdAction.prototype.postExecuteA = function (whiteboard_) {
  MMPageBkGrdAction.superclass.postExecuteA.call(this, whiteboard_);
};
MMPageBkGrdAction.prototype.postExecuteP = function (whiteboard_) {
  //  whiteboard_.shuffle(this.m_ids, this.m_baseObj) ;
  return this.getRefreshRect();
};
MMPageBkGrdAction.prototype.encode = function (enc_) {
  var _PageBkGrdInfo = new MMPageBkGrdInfo(this);
  _PageBkGrdInfo.encode(enc_);
};
MMPageBkGrdAction.prototype.recordCoopId = function (whitebrd_) {
  if (whitebrd_.getType() == _BoardType["default"].enumWhiteBoardMain) {
    this.m_collabIds.clear();
    if (this.m_pageindex == INDEX.ALL) {
      this.m_collabIds = whitebrd_.getCollabIds(this.m_ids);
    } else {
      var _collabId = whitebrd_.getCoopIdByPage(this.m_pageindex);
      this.m_collabIds.add(_collabId);
    }
  } else {
    this.m_collabIds.clear();
    this.m_collabIds.add(whitebrd_.getId());
  }
};

/**
 * @returns {MMUndoInfo}
 */
MMPageBkGrdAction.prototype.getRefreshRect = function () {
  var info = MMPageBkGrdAction.superclass.getRefreshRect.call(this);
  if (this.m_pageindex == INDEX.ALL) {
    for (var i = 0; i < this.m_boardPageNum; i++) {
      info.m_pagesIndex.push(i);
    }
  } else {
    info.m_pagesIndex.push(this.m_pageindex);
  }
  return info;
};
var _default = exports["default"] = MMPageBkGrdAction;

},{"1184":1184,"1454":1454,"812":812,"947":947,"979":979,"998":998}],980:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMPageAction = _interopRequireDefault(require(979));
var _MDEvents = _interopRequireDefault(require(325));
var _MMPageAddInfo = _interopRequireDefault(require(981));
var _Page_Oper = _interopRequireDefault(require(998));
var _Dispatcher = _interopRequireDefault(require(18));
function MMPageAddAction(oper_, creationInfo_, pageIndex_) {
  _MMPageAction["default"].call(this, oper_);
  //保存相应info的属性
  this.m_creationInfo = creationInfo_;
  this.m_pageIndex = pageIndex_;
}
;
MMPageAddAction.prototype = new _MMPageAction["default"]();
MMPageAddAction.superclass = _MMPageAction["default"].prototype;
MMPageAddAction.prototype.getClassName = function () {
  return 'MMPageAddAction';
};
MMPageAddAction.prototype.getPageIndex = function () {
  return this.m_pageIndex;
};
MMPageAddAction.prototype.getNotifyType = function () {
  return 204;
};
/**
 * @param whiteboard_
 * @param active_  {bool}
 */
MMPageAddAction.prototype.execute = function (whiteboard_, active_) {
  MMPageAddAction.superclass.execute.call(this, whiteboard_, active_);
  var pageNum = this.m_creationInfo.m_newPageNum;
  var _pages = whiteboard_.getPagesController();
  if (this.m_oper == _Page_Oper["default"].ADD) {
    var isAddAction = true;
    this.m_creationInfo = _pages.addPage(false, pageNum, this.m_creationInfo.m_creationTime, isAddAction); //最后一个参数，待测试
    _Dispatcher["default"].trigger(_MDEvents["default"].NEW_ROUND, pageNum);
    console.log("----> add page");
  } else if (this.m_oper == _Page_Oper["default"].REMOVE) {
    _pages.removePage(true, pageNum);
  } else {
    console.assert(false);
    return;
  }
};
MMPageAddAction.prototype.postExecuteA = function (whiteboard_) {
  MMPageAddAction.superclass.postExecuteA.call(this, whiteboard_);
};
MMPageAddAction.prototype.postExecuteP = function (whiteboard_) {
  return this.getRefreshRect();
};
MMPageAddAction.prototype.encode = function (enc_) {
  var _pageAddInfo = new _MMPageAddInfo["default"](this);
  _pageAddInfo.encode(enc_);
};
var _default = exports["default"] = MMPageAddAction;

},{"1184":1184,"1454":1454,"18":18,"325":325,"979":979,"981":981,"998":998}],981:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMPagesInfo = _interopRequireDefault(require(956));
var _MMPageInfo = _interopRequireDefault(require(984));
var _MMPageAddAction = _interopRequireDefault(require(980));
/**
 * @author lishusheng,2014-06-18
 */
function MMPageAddInfo(pageAddAction_) {
  _MMPageInfo["default"].call(this, pageAddAction_);
  this.m_className = 'MMPageAddInfo';
  this.m_creationInfo = new _MMPagesInfo["default"].PageCreationInfo();
  if (pageAddAction_ instanceof _MMPageAddAction["default"]) {
    this.m_creationInfo = pageAddAction_.m_creationInfo;
  }
}
;
MMPageAddInfo.prototype = new _MMPageInfo["default"]();
MMPageAddInfo.superclass = _MMPageInfo["default"].prototype;
MMPageAddInfo.prototype.getClassName = function () {
  return this.m_className;
};
MMPageAddInfo.prototype.getOper = function () {
  return this.m_oper;
};
MMPageAddInfo.prototype.encode = function (enc_) {
  MMPageAddInfo.superclass.encode.call(this, enc_);
  enc_.encodeFloat(this.m_creationInfo.m_creationTime);
  enc_.encode4Bytes(this.m_creationInfo.m_newPageNum);
};
MMPageAddInfo.prototype.decode = function (dec_, ver_) {
  MMPageAddInfo.superclass.decode.call(this, dec_, ver_);
  this.m_creationInfo = new _MMPagesInfo["default"].PageCreationInfo();
  this.m_creationInfo.m_creationTime = dec_.decodeFromFloat(ver_);
  this.m_creationInfo.m_newPageNum = dec_.decodeFrom4Bytes(ver_);
};
MMPageAddInfo.prototype.getCompatible = function (whiteboard_) {
  return new _MMPageAddAction["default"](this.m_oper, this.m_creationInfo);
};
var _default = exports["default"] = MMPageAddInfo;

},{"1184":1184,"1454":1454,"956":956,"980":980,"984":984}],979:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDEvents = _interopRequireDefault(require(325));
var _MMAction = _interopRequireDefault(require(963));
var _ACTION_TYPE = _interopRequireDefault(require(1076));
var _MMPageInfo = _interopRequireDefault(require(984));
var _MMUndoInfo = _interopRequireDefault(require(992));
/**
 * @param oper_ { Page_OPER }  MMPageInfo 中的 Page_OPER 类型 【ADD : 0, REMOVE : 1, SET_BACKGROUND : 2, RECOVER_BACKGROUND : 3】
 *
 */
function MMPageAction(oper_) {
  _MMAction["default"].call(this);
  this.m_type = _ACTION_TYPE["default"].PAGE_OP;
  this.m_image = null;
  this.m_oper = oper_;
}
;
MMPageAction.prototype = new _MMAction["default"]();
MMPageAction.superclass = _MMAction["default"].prototype;
MMPageAction.prototype.getClassName = function () {
  return 'MMPageAction';
};
MMPageAction.prototype.recordCoopId = function (whiteboard_) {};
/**
 * according to the Page_OPER Object, this method creates a Reverse by using the opposide value:
 *  {ADD: 0, REMOVE: 1, SET_BACKGROUND: 2, RECOVER_BACKGROUND: 3}
 */
MMPageAction.prototype.createReverse = function () {
  var oper = null;
  switch (this.m_oper) {
    case 0:
      oper = 1;
      break;
    case 1:
      oper = 0;
      break;
    case 2:
      oper = 3;
      break;
    case 3:
      oper = 2;
      break;
  }
  return MMPageAction(oper);
};

/**
 * @param whiteboard_
 * @param active_  {bool}
 */
MMPageAction.prototype.execute = function (whiteboard_, active_) {
  this.recordCoopId(whiteboard_);
};
MMPageAction.prototype.postExecuteA = function (whiteboard_) {
  MMPageAction.superclass.postExecuteA.call(this, whiteboard_);
};
MMPageAction.prototype.postExecuteP = function (whiteboard_) {
  return this.getRefreshRect();
};
MMPageAction.prototype.encode = function (enc_) {
  var _pageInfo = new _MMPageInfo["default"](this);
  _pageInfo.encode(enc_);
};
/**
 * @returns {MMUndoInfo}
 */
MMPageAction.prototype.getRefreshRect = function () {
  var info = new _MMUndoInfo["default"]();
  info.m_refreshRcts = this.m_objsRect;
  info.m_refreshFullScreen = true;
  return info;
};
var _default = exports["default"] = MMPageAction;

},{"1076":1076,"1184":1184,"1454":1454,"325":325,"963":963,"984":984,"992":992}],984:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMPageAction = _interopRequireDefault(require(979));
var _MMActionInfo = _interopRequireDefault(require(1077));
var _ACTION_TYPE = _interopRequireDefault(require(1076));
var _ACTION_SOURCE = _interopRequireDefault(require(1075));
var _Page_Oper = _interopRequireDefault(require(998));
/*
 * @param {Array.<MMObject>}
 */
function MMPageInfo(pageAction_) {
  _MMActionInfo["default"].call(this, pageAction_);
  this.m_className = 'MMPageInfo';
  this.m_type = _ACTION_TYPE["default"].PAGE_OP;
  this.m_source = _ACTION_SOURCE["default"].LOCAL;
  this.m_oper = _Page_Oper["default"].ADD; //int32  {OPER}

  if (pageAction_ instanceof _MMPageAction["default"]) {
    this.m_oper = pageAction_.m_oper;
  }
}
;
MMPageInfo.prototype = new _MMActionInfo["default"]();
MMPageInfo.superclass = _MMActionInfo["default"].prototype;
MMPageInfo.prototype.getClassName = function () {
  return this.m_className;
};
MMPageInfo.prototype.getOper = function () {
  return this.m_oper;
};
MMPageInfo.prototype.encode = function (enc_) {
  MMPageInfo.superclass.encode.call(this, enc_);
  enc_.encode4Bytes(this.m_oper);
};
MMPageInfo.prototype.decode = function (dec_, ver_) {
  MMPageInfo.superclass.decode.call(this, dec_, ver_);
  this.m_oper = dec_.decodeFrom4Bytes(ver_);
};
MMPageInfo.prototype.getCompatible = function (whiteboard_) {
  return new _MMPageAction["default"](this.m_oper);
};
var _default = exports["default"] = MMPageInfo;

},{"1075":1075,"1076":1076,"1077":1077,"1184":1184,"1454":1454,"979":979,"998":998}],998:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var Page_Oper = {
  ADD: 0,
  REMOVE: 1,
  SET_BACKGROUND: 2,
  RECOVER_BACKGROUND: 3
};
var _default = exports["default"] = Page_Oper;

},{"1454":1454}],970:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMAction = _interopRequireDefault(require(963));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDEvents = _interopRequireDefault(require(325));
var _MMUndoInfo = _interopRequireDefault(require(992));
var _MMIdManager = _interopRequireDefault(require(951));
var _MMSketchCommentController = _interopRequireDefault(require(885));
var _MMCreateInfo = _interopRequireDefault(require(971));
var _MMCommentObj = _interopRequireDefault(require(1005));
var _Encoder = _interopRequireDefault(require(800));
var _MMDeleteAction = _interopRequireDefault(require(972));
/**
 * @constructor
 * @param newObjs_ {Element or list of Elements}, the elements to add
 */
function MMCreateAction(newObjs_, isMark_) {
  _MMAction["default"].call(this);
  if (!(newObjs_ instanceof Array)) {
    newObjs_ = [newObjs_];
  }
  this.m_objects = newObjs_;
  this.m_objsRect = new Array();
  if (this.m_objects != null) {
    for (var i = 0; i < this.m_objects.length; i++) {
      this.m_objsRect.push(this.m_objects[i].getExpandRect());
    }
  }
  this.m_image = null;
  this.m_baseObj = _MMIdManager["default"].m_blankId;
  this.m_isMark = isMark_;
}
;
MMCreateAction.prototype = new _MMAction["default"]();
MMCreateAction.superclass = _MMAction["default"].prototype;
MMCreateAction.prototype.getClassName = function () {
  return 'MMCreateAction';
};
MMCreateAction.prototype.execute = function (whiteboard_) {
  console.log("execute MMCreateAction");
  for (var i = 0; i < this.m_objects.length; i++) {
    var _object = this.m_objects[i];
    var _id = whiteboard_.__addObject(_object, this.m_isMark);
    this.m_ids.push(_id);
    if (_object instanceof _MMCommentObj["default"]) {
      var _pageIndex = _object.getPageIndex();
      setBabelTimeout(function () {
        _Dispatcher["default"].trigger(_MDEvents["default"].COMMENT_CREATE, _object.getBoard(), _pageIndex);
      });
    }
    if (this.m_isMark) {
      if (_MMSketchCommentController["default"]) {
        _MMSketchCommentController["default"].addObject(_object);
      }
    }
  }

  /*
   */
  this.m_collabId = whiteboard_.getCollabIds(this.m_ids); //协作，同步
};
MMCreateAction.prototype.postExecuteA = function (whiteboard_) {
  MMCreateAction.superclass.postExecuteA.call(this, whiteboard_);
  this.__createDataImg();
};
MMCreateAction.prototype.postExecuteP = function (whiteboard_) {
  if (this.m_baseObj) {
    whiteboard_.shuffle(this.m_ids, this.m_baseObj); //重新排列对象
  }
  return this.getRefreshRect();
};
MMCreateAction.prototype.__createDataImg = function () {
  var _enc = new _Encoder["default"]();
  _enc.encode4Bytes(___MM_DOC_VERSION__);
  var _count = this.m_objects.length;
  _enc.encode4Bytes(_count);
  for (var i = 0; i < _count; i++) {
    var _object = this.m_objects[i];
    _enc.encodeObject(_object);
    if (!_object.getIncludeData()) {
      var _objData = _object.getObjData();
      _objData.encode(_enc);
    }
  }
  this.m_image = _enc.getStream();
};
MMCreateAction.prototype.encode = function (enc_) {
  var _createInfo = new _MMCreateInfo["default"](this);
  _createInfo.encode(enc_);
};
MMCreateAction.prototype.decode = function (dec_, ver_) {};
MMCreateAction.prototype.getRefreshRect = function () {
  var info = new _MMUndoInfo["default"]();
  info.m_refreshRcts = this.m_objsRect;
  return info;
};
MMCreateAction.prototype.createReverse = function (whiteboard) {
  return new _MMDeleteAction["default"](this.m_objects, whiteboard, this.m_isMark);
};
var _default = exports["default"] = MMCreateAction;

},{"1005":1005,"1184":1184,"1454":1454,"18":18,"325":325,"800":800,"885":885,"951":951,"963":963,"971":971,"972":972,"992":992}],971:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMCreateAction = _interopRequireDefault(require(970));
var _MMActionInfo = _interopRequireDefault(require(1077));
var _ACTION_TYPE = _interopRequireDefault(require(1076));
var _Decoder = _interopRequireDefault(require(799));
var _ACTION_SOURCE = _interopRequireDefault(require(1075));
/*
 * @param {Array.<MMObject>}
 */
function MMCreateInfo(createAction_) {
  _MMActionInfo["default"].call(this, createAction_);
  this.m_className = 'MMCreateInfo';
  this.m_type = _ACTION_TYPE["default"].CREATE;
  this.m_source = _ACTION_SOURCE["default"].LOCAL;
  this.m_baseObj = {
    m_localIndex: 0,
    m_macAddr: 0
  };
  if (createAction_ instanceof _MMCreateAction["default"]) {
    this.m_dataImage = createAction_.m_image;
    this.m_collabs = createAction_.m_collabIds;
    this.m_macaddr = createAction_.m_identifier;
    this.m_indseq = createAction_.m_indSeq;
  }
}
;
MMCreateInfo.prototype = new _MMActionInfo["default"]();
MMCreateInfo.superclass = _MMActionInfo["default"].prototype;
MMCreateInfo.prototype.__getObjects = function (whiteboard_) {
  var _ret = new Array();
  if (this.m_dataImage == null) {
    return null;
  }
  var _dec = new _Decoder["default"](whiteboard_);
  _dec.setStream(this.m_dataImage);
  var _ver = _dec.decodeFrom4Bytes(___MM_DOC_VERSION__);
  var _size = _dec.decodeFrom4Bytes(_ver);
  for (var i = 0; i < _size; i++) {
    var _object = _dec.decodeFromObject(_ver);
    if (!_object.getIncludeData()) {
      _object.setIncludeData(true);
      var _objData = _object.getObjData();
      _objData.decode(_dec, _ver);
    }
    _ret.push(_object);
  }
  return _ret;
};
MMCreateInfo.prototype.encode = function (enc_) {
  MMCreateInfo.superclass.encode.call(this, enc_);
  enc_.encodeBuffer(this.m_dataImage);
  enc_.encodeObjID(this.m_baseObj);
};
MMCreateInfo.prototype.decode = function (dec_, ver_) {
  MMCreateInfo.superclass.decode.call(this, dec_, ver_);
  this.m_dataImage = dec_.decodeFromBuffer(ver_);
  this.m_baseObj = dec_.decodeFromObjID(ver_);
};

//MMCreateInfo.prototype.createDataImg = function (objs_, enc_) {
//  enc_.encode4Bytes(___MM_DOC_VERSION__) ;
//
//  var _count = objs_.length ;
//  enc_.encode4Bytes(objs_.length) ;
//  for (var i = 0 ; i < _count ; i ++) {
//    var _object = objs_[i] ;
//    enc_.encodeObject(_object) ;
//    /*
//     *
//     */
//    if (!_object.getIncludeData()) {
//      var _objData = _object.getObjData() ;
//      _objData.encode(enc_) ;
//    }
//  }
//} ;

MMCreateInfo.prototype.getCompatible = function (whiteboard_) {
  var _newObjs = this.__getObjects(whiteboard_);
  return new _MMCreateAction["default"](_newObjs);
};
var _default = exports["default"] = MMCreateInfo;

},{"1075":1075,"1076":1076,"1077":1077,"1184":1184,"1454":1454,"799":799,"970":970}],966:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1461);
var _MMAction = _interopRequireDefault(require(963));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDEvents = _interopRequireDefault(require(325));
var _MMChatMessageInfo = _interopRequireDefault(require(967));
var _MMUndoInfo = _interopRequireDefault(require(992));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
/**
 * @author lishusheng,2014-06-20
 * @param message_  {MMChatMessage}
 * @returns {MMChatMessageAction}
 */
function MMChatMessageAction(chatMessage_) {
  _MMAction["default"].call(this);
  //保存info的属性
  this.m_chatMessage = chatMessage_; //
}
;
MMChatMessageAction.prototype = new _MMAction["default"]();
MMChatMessageAction.superclass = _MMAction["default"].prototype;
MMChatMessageAction.prototype.getClassName = function () {
  return 'MMChatMessageAction';
};

/**
 * @param whiteboard_
 * @param active_  {bool}
 */

MMChatMessageAction.prototype.execute = function (whiteboard_, active_) {
  whiteboard_.addMessage(this.m_chatMessage);
  this.m_collabIds.clear();
  this.m_collabIds.add(this.m_chatMessage.getSessionid());

  //  /*
  //   */
  //  this.m_collabId = whiteboard_.getCollabIds(this.m_ids) ;
};
MMChatMessageAction.prototype.postExecuteA = function (whiteboard_) {};
MMChatMessageAction.prototype.postExecuteP = function (whiteboard_) {
  /*
   */
  var editor = _MDPcMobileEditorCommonFun["default"].getMainEditor();
  var objId = this.m_chatMessage.getObjId();
  var msg = JSON.parse(this.m_chatMessage.getMessage());
  if (!objId.isBlank()) {
    // 过滤
    if (msg.visibleScope && (app.currentUser.isEnterpriseGuest() || !whiteboard_.fileInfo.belongsToCurrentUserEnterprise())) {
      return;
    }
    ;
    var comment = whiteboard_.getObject(objId);
    if (comment) {
      comment.setHasNewReplyFromUser(this.m_chatMessage.getUserId());
      var payload = {
        comment: comment,
        sender: this.m_chatMessage.getUserId(),
        message: this.m_chatMessage
      };
      _Dispatcher["default"].trigger(_MDEvents["default"].NEW_MESSAGE, payload);
      _Dispatcher["default"].trigger(_MDEvents["default"].NewNotificationRecived);
    }
  } else {
    var payload = {
      comment: undefined,
      sender: this.m_chatMessage.getUserId(),
      message: this.m_chatMessage
    };
    _Dispatcher["default"].trigger(_MDEvents["default"].NEW_MESSAGE, payload);
  }
  return this.getRefreshRect();
};
MMChatMessageAction.prototype.encode = function (enc_) {
  var _ChatMessageInfo = new _MMChatMessageInfo["default"](this);
  _ChatMessageInfo.encode(enc_);
};

/**
 *
 * @returns {MMUndoInfo}
 */
MMChatMessageAction.prototype.getRefreshRect = function () {
  var info = new _MMUndoInfo["default"]();
  info.m_refreshRcts = this.m_objsRect;
  return info;
};
var _default = exports["default"] = MMChatMessageAction;

},{"1184":1184,"1454":1454,"1461":1461,"18":18,"325":325,"807":807,"963":963,"967":967,"992":992}],967:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMChatMessageAction = _interopRequireDefault(require(966));
var _MMActionInfo = _interopRequireDefault(require(1077));
var _ACTION_TYPE = _interopRequireDefault(require(1076));
var _ACTION_SOURCE = _interopRequireDefault(require(1075));
/**
 * @author lishusheng,2014-06-20
 */
function MMChatMessageInfo(chatMessageAction_) {
  _MMActionInfo["default"].call(this, chatMessageAction_);
  this.m_className = 'MMChatMessageInfo';
  this.m_type = _ACTION_TYPE["default"].MESSAGE;
  this.m_source = _ACTION_SOURCE["default"].LOCAL;
  this.m_chatMessage; //{MMChatMessage}

  if (chatMessageAction_ instanceof _MMChatMessageAction["default"]) {
    this.m_chatMessage = chatMessageAction_.m_chatMessage;
  }
}
;
MMChatMessageInfo.prototype = new _MMActionInfo["default"]();
MMChatMessageInfo.superclass = _MMActionInfo["default"].prototype;
MMChatMessageInfo.prototype.getClassName = function () {
  return this.m_className;
};
MMChatMessageInfo.prototype.encode = function (enc_) {
  MMChatMessageInfo.superclass.encode.call(this, enc_);
  enc_.encodeObject(this.m_chatMessage);
};
MMChatMessageInfo.prototype.decode = function (dec_, ver_) {
  MMChatMessageInfo.superclass.decode.call(this, dec_, ver_);
  this.m_chatMessage = dec_.decodeFromObject(ver_);
};
MMChatMessageInfo.prototype.getCompatible = function (whiteboard_) {
  return new _MMChatMessageAction["default"](this.m_chatMessage);
};
var _default = exports["default"] = MMChatMessageInfo;

},{"1075":1075,"1076":1076,"1077":1077,"1184":1184,"1454":1454,"966":966}],965:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function MMActionStack() {
  this.m_actions = [];
}
;
MMActionStack.prototype.maxStacksize = 1000;
MMActionStack.prototype.getSize = function () {
  this.m_actions.length;
};
MMActionStack.prototype.push = function (_action) {
  if (this.m_actions.length >= this.maxStacksize) {
    this.m_actions.shift();
  }
  this.m_actions.push(_action);
};
MMActionStack.prototype.pop = function () {
  return this.m_actions.pop();
};
MMActionStack.prototype.empty = function () {
  return this.m_actions.length === 0;
};
MMActionStack.prototype.clear = function () {
  return this.m_actions = [];
};
MMActionStack.prototype.invalidLayerAction = function (_action) {
  //todo:
};
var _default = exports["default"] = MMActionStack;

},{"1454":1454}],851:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMMessage = _interopRequireDefault(require(1079));
var _MMWhiteboard = _interopRequireDefault(require(960));
function MMRProcessMessage() {
  _MMMessage["default"].call(this);
  this.m_className = 'MMRProcessMessage';
  this.m_flag;
  this.m_userId;
  this.m_coopBoard;
  this.m_mainBoard;
  this.m_clientSeq;
  this.m_serverSeq;
  this.m_dataBuffer;
}
;
MMRProcessMessage.prototype = new _MMMessage["default"]();
MMRProcessMessage.superclass = _MMMessage["default"].prototype;
MMRProcessMessage.prototype.encode = function (enc_) {
  MMRProcessMessage.superclass.encode.call(this, enc_);
  enc_.encode8Bytes(this.m_userId);
  enc_.encode8Bytes(this.m_coopBoard);
  enc_.encode8Bytes(this.m_mainBoard);
  enc_.encode8Bytes(this.m_clientSeq);
  enc_.encode8Bytes(this.m_serverSeq);
  enc_.encode4Bytes(this.m_flag);
  enc_.encodeBuffer(this.m_dataBuffer);
};
MMRProcessMessage.prototype.decode = function (dec_, ver_) {
  MMRProcessMessage.superclass.decode.call(this, dec_, ver_);
  this.m_userId = dec_.decodeFrom8Bytes(ver_);
  this.m_coopBoard = dec_.decodeFrom8Bytes(ver_);
  this.m_mainBoard = dec_.decodeFrom8Bytes(ver_);
  this.m_clientSeq = dec_.decodeFrom8Bytes(ver_);
  this.m_serverSeq = dec_.decodeFrom8Bytes(ver_);
  this.m_flag = dec_.decodeFrom4Bytes(ver_);
  this.m_dataBuffer = dec_.decodeFromBuffer(ver_);
};
MMRProcessMessage.prototype.respond = function (whiteboard_) {
  console.assert(whiteboard_ instanceof _MMWhiteboard["default"]);
  var _actionManager = whiteboard_.getActionManager();
  _actionManager.feedback4Notify(this.m_serverSeq, this.m_clientSeq);
};
var _default = exports["default"] = MMRProcessMessage;

},{"1079":1079,"1184":1184,"1454":1454,"960":960}],962:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  enumLayerMoveToFront: 0,
  enumLayerMovetoBack: 1
};

},{"1454":1454}],955:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1421);
require(1432);
var _FilterType = _interopRequireDefault(require(949));
var _ObjVisibleScope = _interopRequireDefault(require(1085));
var _ObjType = _interopRequireDefault(require(1084));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
//
// 对象过滤器
//
function MMObjectFilter() {
  this.type = _FilterType["default"].Include;
  this.objTypes = new Array(); // object type array
  this.objVer = -1; // -1 表示不用检测对象的版本.否则需要对象的版本与本值一致才可选中
}
;

/**
 * 判断对象是否被过滤器过滤掉了
 * @param obj
 */
MMObjectFilter.prototype.isObjRemovedByFilter = function (obj) {
  var removed = false;
  if (this.type == _FilterType["default"].Include) {
    removed = true;
    //this method is changed by Tobias
    //    for(var i=0; i<this.objTypes.length; i++){
    //      if(obj.getObjType() == this.objTypes[i]){
    //        removed = false;
    //        break;
    //      }
    //    }

    removed = this.objTypes.indexOf(obj.getObjType()) === -1;
  } else if (this.type == _FilterType["default"].NotInlcude) {
    removed = false;
    //    for(var i=0; i<this.objTypes.length; i++){
    //      if(obj.getObjType() == this.objTypes[i]){
    //        removed = true;
    //        break;
    //      }
    //    }
    removed = this.objTypes.indexOf(obj.getObjType()) !== -1;
  }
  if (this.objVer >= 0) {
    if (this.objVer != obj.getFileVersion()) {
      removed = true;
    }
    ;
  }
  ;

  // 根据批注点的可视范围来设定是否显示批注点
  // if (!removed && obj.isComment() && obj.getVisibleScope()) {

  //   if (app.isEpVersion() && !app.currentUser.isEnterpriseGuest() && MDPcMobileEditorCommonFun.currentFileBelongsToCurUserEnterprise()) {

  //     if (obj.getVisibleScope() == ObjVisibleScope.privateObject) {
  //       var uid = app.currentUser.getUserId_Int();
  //       var cid = obj.getCreator();
  //       if (!uid.isEqualTo(cid)) {
  //         removed = true;
  //       }
  //     };

  //   } else {
  //     removed = true;
  //   }

  // };

  return removed;
};
MMObjectFilter.prototype.moveObjType = function (objType) {
  for (var i = 0; i < this.objTypes.length; i++) {
    if (this.objTypes[i] == objType) {
      this.objTypes.splice(i, 1);
      break;
    }
  }
  ;
};
var _default = exports["default"] = MMObjectFilter;

},{"1084":1084,"1085":1085,"1184":1184,"1421":1421,"1432":1432,"1454":1454,"807":807,"949":949}],954:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1418);
require(1463);
require(1537);
var _MMObject = _interopRequireDefault(require(1081));
var _MMIdManager = _interopRequireDefault(require(951));
var _map = _interopRequireDefault(require(821));
var _ObjType = _interopRequireDefault(require(1084));
function MMObjManager(whiteboard_) {
  this.m_whiteboard = whiteboard_;
  this.m_objects = new _map["default"]();
}
;
MMObjManager.prototype.destruct = function () {
  this.m_whiteboard = null;
};
MMObjManager.prototype.saveObject = function (object_) {
  console.assert(object_ instanceof _MMObject["default"]);
  var _id;
  if (object_.isRegistered()) {
    _id = object_.getId();
  } else {
    _id = _MMIdManager["default"].getNewId();
    object_.setCreator(app.currentUser.getUserId_Int());
  }
  this.m_objects.set(_id, object_);
  object_.setId(_id);
  return _id;
};
MMObjManager.prototype.getObject = function (id_) {
  return this.m_objects.get(id_);
};
MMObjManager.prototype.deleteObject = function (id_) {
  this.m_objects.remove(id_);
};
MMObjManager.prototype.encode = function (enc_) {
  //  enc_.encodeMap(this.m_objects, 'ObjID', 'Meta') ;
};
MMObjManager.prototype.decode = function (dec_, ver_) {
  //  this.m_objects = dec_.decodeFromMap(ver_, 'ObjID', 'Meta') ;
  var _length = dec_.decodeFrom4Bytes(ver_);
  for (var i = 0; i < _length; i++) {
    var _object = dec_.decodeFromObject(ver_);
    //    console.log("object "+i+" "+_object.getClassName()) ;
    var _objId = _object.getId();
    var _oldObject = this.m_objects.get(_objId);
    if (_oldObject) {
      _oldObject.duplicateFrom(_object);
    } else {
      this.m_objects.set(_objId, _object);
    }
  }
};
MMObjManager.prototype.delObjedsForVersion = function (ver_) {
  if (ver_ === undefined || ver_ === null) {
    return;
  }
  ;
  var objs = [];
  this.m_objects.forEach(function (obj) {
    if ((obj.getObjType() == _ObjType["default"].Obj_Image || obj.getObjType() == _ObjType["default"].Obj_PDF) && obj.getFileVersion() === ver_) objs.push(obj);
  });
  for (var i = 0; i < objs.length; i++) {
    this.deleteObject(objs[i].getId());
  }
  ;
};
var _default = exports["default"] = MMObjManager;

},{"1081":1081,"1084":1084,"1184":1184,"1418":1418,"1454":1454,"1463":1463,"1537":1537,"821":821,"951":951}],953:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
require(1423);
require(1411);
require(1530);
require(1505);
require(1506);
require(1507);
require(1508);
require(1510);
require(1509);
require(1512);
require(1513);
require(1514);
require(1516);
require(1517);
require(1518);
require(1519);
require(1521);
require(1520);
require(1522);
require(1523);
require(1524);
require(1525);
require(1526);
require(1527);
require(1528);
require(1529);
require(1410);
require(1434);
var _map = _interopRequireDefault(require(821));
var _set = _interopRequireDefault(require(822));
var _MMDatablockMessage = _interopRequireDefault(require(844));
var _BoardType = _interopRequireDefault(require(947));
var _int = _interopRequireDefault(require(820));
var _Decoder = _interopRequireDefault(require(799));
var _MMRect = _interopRequireDefault(require(831));
var BLOCK_SIZE = 128;
window.BLOCK_SIZE = BLOCK_SIZE;
function MMObjDataManager(whiteboard_) {
  this.m_whiteboard = whiteboard_;
  this.m_connection = null;
  //  this.m_buffer = ;
  //
  this.m_objDatas = new _map["default"]();
  this.m_buffer = new _map["default"](); //map<OBJ_ID, MMObjData*>

  this.m_blockIds = new _set["default"](); //map<blokID,Bool>
}
;
MMObjDataManager.prototype.destruct = function () {
  this.m_whiteboard = null;
  this.m_connection = null;
};
MMObjDataManager.prototype.connected = function (conn_) {
  //console.assert(conn_ instanceof MMCollaborationManager.MMConnection) ;
  this.m_connection = conn_;
};

/**
 * 网络连接出错处理函数
 * @param conn_
 */
MMObjDataManager.prototype.disconnected = function (conn_) {
  this.m_blockIds.clear(); //清除块请求状态
};
MMObjDataManager.prototype.decode = function (dec_, ver_) {
  if (this.m_whiteboard.getType() == _BoardType["default"].enumNetDiskBoard) {
    this.m_buffer = dec_.decodeFromMap(ver_, 'ObjID', 'Meta');
    return;
  }
  this.m_objDatas = new _map["default"]();
  var _lenMap = dec_.decodeFrom4Bytes(ver_);
  for (var j = 0; j < _lenMap; j++) {
    var _key = dec_.decodeFrom8Bytes(ver_);
    var _value = new Array();
    var _lenArray = dec_.decodeFrom4Bytes(ver_);
    for (var i = 0; i < _lenArray; i++) {
      var _objIndex = dec_.decodeFrom8Bytes(ver_);
      _value.push(_objIndex);
    }
    this.m_objDatas.set(_key, _value);
  }
};
MMObjDataManager.prototype.__getDataBlockId = function (id_) {
  var _macAddr = id_.m_macAddr;
  if (this.m_objDatas.containsKey(_macAddr)) {
    var _arrayObjs = this.m_objDatas.get(_macAddr);
    var _offset = -1;
    for (var i = 0; i < _arrayObjs.length; i++) {
      if (_arrayObjs[i].toString() == id_.m_localIndex.toString()) {
        _offset = i;
        break;
      }
    }
    if (_offset != -1) {
      var _tempBlockId = _offset / BLOCK_SIZE;
      //      var _shiftMac = _macAddr << 16 ;
      //      _blockId = _shiftMac | _blockId ;

      var _newView = new Uint8Array(_macAddr.buffer);
      var _blockId = new _int["default"](_newView);
      _blockId.leftShift16();
      var m_dataBuffer = new ArrayBuffer(2);
      var _dataView = new DataView(m_dataBuffer);
      _dataView.setInt16(0, _tempBlockId, false); // true 表示先低位后高位，false表示先高位后低位
      var _oldView = new Uint8Array(m_dataBuffer);
      _blockId.buffer[7] = _oldView[1];
      _blockId.buffer[6] = _oldView[0];

      //      var _newView = new Uint8Array(_macAddr.buffer);
      //      var _blockId = new Int64(_newView);

      return _blockId;
    }
  }
  return 0;
};
MMObjDataManager.prototype.getObjData = function (id_) {
  if (this.m_buffer.containsKey(id_)) {
    return this.m_buffer.get(id_);
  } else {
    console.assert(false);
    var _blockId = this.__getDataBlockId(id_);
    if (_blockId != 0) {
      var _blockIdString = _blockId.buffer.toString();
      //如果不在请求当中，则发送Message请求，lishusheng
      if (!this.m_blockIds.contains(_blockIdString)) {
        var _that = this;
        this.m_blockIds.add(_blockIdString);
        //var _message = new MMDatablockMessage(this.m_whiteboard.getId(), _blockId);

        if (this.m_connection) {
          var _callback = function _callback(data) {
            var _dec = new _Decoder["default"](_that.m_whiteboard);
            var _newBuffer = data;
            // 解析成map<OBJ_ID, MMObjData*>
            _dec.setStream(_newBuffer);
            var _version = _dec.decodeFrom4Bytes(0);
            var _objMap = _dec.decodeFromMap(_version, "ObjID", "Meta");
            _that.m_buffer.addAll(_objMap);
            _that.m_blockIds.remove(_blockIdString); //请求成功，设置不在请求当中

            //redraw() ;//这里做重新绘制操作
            var objs = _objMap.getValues();
            var rect = new _MMRect["default"]();
            if (objs.length > 0) {
              rect = objs[0].getExpandRect().clone();
            }
            for (var i = 1; i < objs.length; i++) {
              var r = objs[i].getExpandRect().clone();
              rect.expandToInclude(r);
            }
            //in the near future, only DATA_DATA_READY is needed. waiting for reconstruction...
            _that.m_whiteboard.trigger(MDEvents.DATA_READY, rect);
            _that.m_whiteboard.trigger(MDEvents.DATA_DATA_READY, rect);
          };
          this.m_connection.getDataBlock(this.m_whiteboard.getId(), _blockId, _callback);
        }
      }
      ;
    }
    return null;
  }
};
MMObjDataManager.prototype.addObjData = function (id_, objData_) {
  console.assert(objData_);
  this.m_whiteboard.setChangedMark(true);
  if (this.m_whiteboard.isMainBoard()) {
    var _arrayObjs = this.m_objDatas.get(id_.m_macAddr);
    if (_arrayObjs) {
      var _i = 0;
      for (_i = 0; _i < _arrayObjs.length; _i++) {
        if (_arrayObjs[_i] == id_.m_localIndex) {
          break;
        }
      }
      if (_i == _arrayObjs.length) {
        _arrayObjs.push(id_.m_localIndex);
      }
    } else {
      _arrayObjs = new Array();
      _arrayObjs.push(id_.m_localIndex);
      this.m_objDatas.set(id_.m_macAddr, _arrayObjs);
    }
  }
  if (!this.m_buffer.containsKey(id_)) {
    this.m_buffer.set(id_, objData_);
  }
  objData_.setId(id_);
};
MMObjDataManager.prototype.delObjData = function (id_) {
  this.m_whiteboard.setChangedMark(true);
  if (this.m_buffer.containsKey(id_)) {
    return this.m_buffer.remove(id_);
  }
};
MMObjDataManager.prototype.markDataModified = function (id_) {};
var _default = exports["default"] = MMObjDataManager;

},{"1184":1184,"1410":1410,"1411":1411,"1423":1423,"1434":1434,"1437":1437,"1454":1454,"1463":1463,"1478":1478,"1505":1505,"1506":1506,"1507":1507,"1508":1508,"1509":1509,"1510":1510,"1512":1512,"1513":1513,"1514":1514,"1516":1516,"1517":1517,"1518":1518,"1519":1519,"1520":1520,"1521":1521,"1522":1522,"1523":1523,"1524":1524,"1525":1525,"1526":1526,"1527":1527,"1528":1528,"1529":1529,"1530":1530,"799":799,"820":820,"821":821,"822":822,"831":831,"844":844,"947":947}],844:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMMessage = _interopRequireDefault(require(1079));
/**
 * @author lishusheng 2014-05-29
 * @param mainboard_ {int_64}
 * @param id_        {int_64}
 * @returns {MMDatablockMessage}
 */
function MMDatablockMessage(mainboard_, blockId_) {
  _MMMessage["default"].call(this);
  this.m_className = 'MMDatablockMessage';
  this.m_blockId = blockId_; //int_64
  this.m_mainboard = mainboard_; //int_64
  this.m_datamgr = null; //MMObjDataManager
}
;
MMDatablockMessage.prototype = new _MMMessage["default"]();
MMDatablockMessage.prototype.encode = function (enc_) {
  _MMMessage["default"].prototype.encode.call(this, enc_);
  enc_.encode8Bytes(this.m_mainboard);
  enc_.encode8Bytes(this.m_blockId);
};
MMDatablockMessage.prototype.decode = function (dec_, ver_) {
  _MMMessage["default"].prototype.decode.call(this, dec_, ver_);
  this.m_mainboard = dec_.decodeFrom8Bytes(ver_);
  this.m_blockId = dec_.decodeFrom8Bytes(ver_);
};
var _default = exports["default"] = MMDatablockMessage;

},{"1079":1079,"1184":1184,"1454":1454}],1079:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMMeta = _interopRequireDefault(require(1080));
function MMMessage() {
  _MMMeta["default"].call(this);
  this.m_id = -1;
}
;
MMMessage.prototype = new _MMMeta["default"]();
MMMessage.superclass = _MMMeta["default"].prototype;
MMMessage.prototype.encode = function (enc_) {
  MMMessage.superclass.encode.call(this, enc_);
  enc_.encode8Bytes(this.m_id);
  this.m_userid = app.currentUser.getUserId_Int(); //app.currentUser.getUserId() ;
  enc_.encode8Bytes(this.m_userid);
};
MMMessage.prototype.decode = function (dec_, ver_) {
  MMMessage.superclass.decode.call(this, dec_, ver_);
  this.m_id = dec_.decodeFrom8Bytes(ver_);
  this.m_userid = dec_.decodeFrom8Bytes(ver_);
};
MMMessage.prototype.setId = function (id_) {
  this.m_id = id_;
};
MMMessage.prototype.getId = function () {
  return this.m_id;
};
var _default = exports["default"] = MMMessage;

},{"1080":1080,"1184":1184,"1454":1454}],949:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * @enum {string}
 */
var FilterType = {
  Include: 'include',
  NotInlcude: 'not include'
};
var _default = exports["default"] = FilterType;

},{"1454":1454}],211:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1466);
var _MMRect = _interopRequireDefault(require(831));
var _MDSeg = _interopRequireDefault(require(828));
// 此类用于保存演播时的粉笔的笔画点
// MDSalonScribble.js
// jiang
// 2017-10-14

var MDSalonScribble = function MDSalonScribble(pageIndex) {
  this.pageIndex = pageIndex;
  this.id = MDSalonScribble.getId();
  this.lgPts = [];
  this.color = 'rgba(255, 0,0,1)';
  this.lineWidth = 2;
  this.boundingBox = null;
};
MDSalonScribble.gId = 0;
MDSalonScribble.getId = function () {
  var localId = localStorage.getItem("MDSalonScribble_id");
  if (localId) {
    localId = parseInt(localId);
    if (localId > MDSalonScribble.gId) {
      MDSalonScribble.gId = localId;
    }
    ;
  }
  ;
  MDSalonScribble.gId++;
  localStorage.setItem("MDSalonScribble_id", MDSalonScribble.gId);
  return app.currentUser.getUserId() + '_' + MDSalonScribble.gId;
};
_.extend(MDSalonScribble.prototype, Object.prototype, {
  initData: function initData(scribble) {
    this.id = scribble.id;
    this.setLgPts(scribble.lgPts);
    this.color = scribble.color;
    this._calcuBoundingBox();
  },
  getId: function getId() {
    return this.id;
  },
  addLgPt: function addLgPt(pt) {
    this.lgPts.push(pt);
    this._calcuBoundingBox();
  },
  setLgPts: function setLgPts(pts) {
    this.lgPts = pts;
    this._calcuBoundingBox();
  },
  _calcuBoundingBox: function _calcuBoundingBox() {
    if (!this.boundingBox) {
      this.boundingBox = new _MMRect["default"]();
    }
    ;
    this.boundingBox.initWithPtsBounadingBox(this.lgPts);
  },
  draw: function draw(ctx, trsfm, lgRct) {
    if (this.lgPts.length < 2 || lgRct && !lgRct.intersects(this.boundingBox)) {
      return;
    }
    ;
    MDSalonScribble.initCtx(ctx);
    ctx.beginPath();
    var dvPts = trsfm.lg2dvPoints(this.lgPts, this.pageIndex);
    ctx.moveTo(dvPts[0].x, dvPts[0].y);
    for (var i = 1; i < dvPts.length; i++) {
      ctx.lineTo(dvPts[i].x, dvPts[i].y);
    }
    ;
    ctx.stroke();
  },
  intersectWith: function intersectWith(pt0, pt1) {
    var tempRect = new _MMRect["default"]();
    tempRect.initWithPtsBounadingBox([pt0, pt1]);
    if (this.boundingBox.intersects(tempRect)) {
      for (var i = 0; i < this.lgPts.length - 1; i++) {
        var pt_0 = this.lgPts[i];
        var pt_1 = this.lgPts[i + 1];
        var tempRect2 = new _MMRect["default"]();
        tempRect2.initWithPtsBounadingBox([pt_0, pt_1]);
        if (tempRect2.intersects(tempRect)) {
          if (_MDSeg["default"].intersects(pt0, pt1, pt_0, pt_1)) {
            return true;
          }
          ;
        }
        ;
      }
      ;
    }
    ;
    return false;
  }
});
MDSalonScribble.initCtx = function (ctx) {
  ctx.lineWidth = 4;
  ctx.strokeStyle = 'red';
  ctx.shadowBlur = 8;
  ctx.shadowColor = "white";
  ctx.lineWidth = 5;
  ctx.lineCap = "round";
  ctx.lineJoin = "round";
};
var _default = exports["default"] = MDSalonScribble;

},{"1184":1184,"1454":1454,"1466":1466,"828":828,"831":831}],828:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _goog = _interopRequireDefault(require(823));
var _vec = _interopRequireDefault(require(839));
/**
 * 线段 class
 *
 * jiang
 * 2014-5-21
 */

function MDSeg(pt0, pt1) {
  this.pt0 = pt0;
  this.pt1 = pt1;
  return this;
}
;
MDSeg.prototype.equals = function (seg) {
  if (this.pt0.equals(seg.pt0) && this.pt1.equals(seg.pt1)) {
    return true;
  }
  ;
};
MDSeg.prototype.isPtOn = function (pt) {
  var v0 = _vec["default"].difference(this.pt0, pt);
  var v1 = _vec["default"].difference(this.pt1, pt);
  var cross = _vec["default"].cross(v0, v1);
  var dot = _vec["default"].dot(v0, v1);
  if (MDSeg.isZero(cross) && dot <= 0) {
    return true;
  }
  ;
  return false;
};
MDSeg.error = 0.00000001;
MDSeg.isZero = function (x) {
  return Math.abs(x) < MDSeg.error;
};
MDSeg.intersects = function (pt00, pt01, pt10, pt11) {
  var seg1 = new MDSeg(pt00, pt01);
  var seg2 = new MDSeg(pt10, pt11);
  if (seg1.isPtOn(pt10) || seg1.isPtOn(pt11) || seg2.isPtOn(pt00) || seg2.isPtOn(pt01)) {
    return true;
  }
  ;
  var v0 = _vec["default"].difference(pt01, pt00);
  var v00 = _vec["default"].difference(pt10, pt00);
  var v01 = _vec["default"].difference(pt11, pt00);
  var d1 = _vec["default"].cross(v0, v00);
  var d2 = _vec["default"].cross(v0, v01);
  var v1 = _vec["default"].difference(pt11, pt10);
  var v10 = _vec["default"].difference(pt00, pt10);
  var v11 = _vec["default"].difference(pt01, pt10);
  var d3 = _vec["default"].cross(v1, v10);
  var d4 = _vec["default"].cross(v1, v11);
  if (d1 * d2 < 0 && d3 * d4 < 0) {
    return true;
  }
  ;
  return false;
};
var _default = exports["default"] = MDSeg;

},{"1184":1184,"1454":1454,"823":823,"839":839}],882:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * @enum {number}
 */
var MMOperationType = {
  Operation_onlyDisplay: 1,
  Operation_selectable: 2,
  Operation_deletable: 3,
  Operation_editable: 4,
  Operation_hidden: 5
};
var _default = exports["default"] = MMOperationType;

},{"1454":1454}],958:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMPagesInfo = _interopRequireDefault(require(956));
var _MMRound = _interopRequireDefault(require(957));
function MMRoundArray(whiteboard_, width_, height_) {
  _MMPagesInfo["default"].call(this, whiteboard_, width_, height_);
}
;
MMRoundArray.prototype = new _MMPagesInfo["default"](); //
MMRoundArray.superclass = _MMPagesInfo["default"].prototype;
MMRoundArray.prototype.__createPage = function () {
  return new _MMRound["default"]();
};
MMRoundArray.prototype.isUserCommittedRound = function (userId_, roundIndex_) {
  var committed = false;
  if (roundIndex_ < 0) {
    console.log("round index error!");
  }
  ;
  if (roundIndex_ < this.m_pagesInfo.length && roundIndex_ >= 0) {
    var round = this.m_pagesInfo[roundIndex_];
    committed = round.isUserCommitted(userId_);
  }
  return committed;
};
MMRoundArray.prototype.isCommitable = function (userId_, roundIndex_) {
  var commitable = true;
  if (roundIndex_ < this.m_pagesInfo.length && roundIndex_ >= 0) {
    var round = this.m_pagesInfo[roundIndex_];
    commitable = round.isCommitable(userId_);
  }
  return commitable;
};
MMRoundArray.prototype.setCommitable = function (userId_, roundIndex_) {
  if (roundIndex_ < this.m_pagesInfo.length && roundIndex_ >= 0) {
    var round = this.m_pagesInfo[roundIndex_];
    round.setCommitable(userId_);
  }
};
MMRoundArray.prototype.setUncommitable = function (userId_, roundIndex_) {
  if (roundIndex_ < this.m_pagesInfo.length && roundIndex_ >= 0) {
    var round = this.m_pagesInfo[roundIndex_];
    round.setUncommitable(userId_);
  }
};
MMRoundArray.prototype.commitRound = function (pageIndex_, commitUser_) {
  if (pageIndex_ < this.m_pagesInfo.length && pageIndex_ >= 0) {
    var round = this.m_pagesInfo[pageIndex_];
    round.commit(commitUser_);
  } else {
    console.assert(false);
  }
};
var _default = exports["default"] = MMRoundArray;

},{"1184":1184,"1454":1454,"956":956,"957":957}],957:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
var _PageInfo = _interopRequireDefault(require(961));
var _CommitInfo = _interopRequireDefault(require(948));
function MMRound(whiteboard_) {
  _PageInfo["default"].call(this, whiteboard_);
  this.m_userCommited = [];
}
;
MMRound.prototype = new _PageInfo["default"](); //
MMRound.superclass = _PageInfo["default"].prototype;
MMRound.prototype.encode = function (enc_) {
  MMRound.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMRound.prototype.decode = function (dec_, ver_) {
  MMRound.superclass.decode.call(this, dec_, ver_);
  var version = dec_.decodeFrom4Bytes(ver_);
  var count = dec_.decodeFrom4Bytes(ver_);
  for (var i = 0; i < count; i++) {
    var commitInfo = new _CommitInfo["default"]();
    commitInfo.decode(dec_, ver_);
    this.m_userCommited.push(commitInfo);
  }
};
MMRound.prototype.isUserCommitted = function (userId_) {
  for (var i = 0; i < this.m_userCommited.length; i++) {
    if (this.m_userCommited[i].m_userId.valueOf() == userId_.valueOf()) {
      return true;
    }
  }
  return false;
};
MMRound.prototype.isCommitable = function (userId_) {
  for (var i = 0; i < this.m_userCommited.length; i++) {
    if (this.m_userCommited[i].m_userId.valueOf() == userId_.valueOf()) {
      return !this.m_userCommited[i].m_commitStatus;
    }
  }
  return true;
};
MMRound.prototype.setCommitable = function (userId_) {
  for (var i = 0; i < this.m_userCommited.length; i++) {
    if (this.m_userCommited[i].m_userId.valueOf() == userId_.valueOf()) {
      this.m_userCommited[i].m_commitStatus = false;
    }
  }
};
MMRound.prototype.setUncommitable = function (userId_) {
  for (var i = 0; i < this.m_userCommited.length; i++) {
    if (this.m_userCommited[i].m_userId.valueOf() == userId_.valueOf()) {
      this.m_userCommited[i].m_commitStatus = true;
    }
  }
};
MMRound.prototype.commit = function (commitUser_) {
  var found = false;
  var len = this.m_userCommited.length;
  for (var i = 0; i < len; i++) {
    if (this.m_userCommited[i].m_userId == commitUser_) {
      found = true;
    }
  }
  if (!found) {
    var info = new _CommitInfo["default"]();
    info.m_userId = commitUser_;
    var localTime = new Date();
    localTime = localTime.getTime() / 1000;
    info.m_time = localTime;
    this.m_userCommited.push(info);
  }
};
var _default = exports["default"] = MMRound;

},{"1184":1184,"1437":1437,"1454":1454,"948":948,"961":961}],948:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function CommitInfo() {
  this.m_userId = -1;
  this.m_time = -1;
}
;
CommitInfo.prototype.encode = function (enc_) {
  console.assert(false);
};
CommitInfo.prototype.decode = function (dec_, ver_) {
  var version = dec_.decodeFrom4Bytes(ver_);
  this.m_userId = dec_.decodeFrom8Bytes(ver_);
  this.m_time = dec_.decodeFrom8Bytes(ver_);
  if (version > 0) {
    this.m_commitStatus = dec_.decodeFromBool(ver_);
    this.m_commitNum = dec_.decodeFrom4Bytes(ver_);
  }
};
var _default = exports["default"] = CommitInfo;

},{"1454":1454}],956:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
var _PageInfo = _interopRequireDefault(require(961));
var _map = _interopRequireDefault(require(821));
var _vec = _interopRequireDefault(require(841));
var _MMMeta = _interopRequireDefault(require(1080));
var _BackgroundPaperAttr = _interopRequireDefault(require(946));
var _size = _interopRequireDefault(require(837));
function MMPagesInfo(whiteboard_, width_, height_) {
  _MMMeta["default"].call(this);
  this.m_whiteboard = whiteboard_;
  this.m_pageWidth = width_;
  this.m_pageHeight = height_;
  this.m_defaultBackGround = new _BackgroundPaperAttr["default"]();
  this.m_specialBackGround = new _map["default"]();
  this.m_pagesInfo = new Array();
  this.m_dirtyPageMark = [];
}
;
MMPagesInfo.prototype = new _MMMeta["default"]();
MMPagesInfo.prototype.encode = function () {
  console.assert(false);
};
MMPagesInfo.prototype.decode = function (dec_, ver_) {
  _MMMeta["default"].prototype.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_pageWidth = dec_.decodeFromFloat(ver_);
  this.m_pageHeight = dec_.decodeFromFloat(ver_);
  var temp = new _BackgroundPaperAttr["default"]();
  temp.__deprecatedDecode(dec_, ver_, true); //该函数需要注意，仅仅在此处使用。

  var _specialLen = dec_.decodeFrom4Bytes(ver_);
  for (var i = 0; i < _specialLen; i++) {
    var _key = dec_.decodeFrom4Bytes(ver_);
    var _bjpa = new _BackgroundPaperAttr["default"]();
    _bjpa.__deprecatedDecode(dec_, ver_, true);
    this.m_specialBackGround.set(_key, _bjpa);
  }
  this.m_pagesInfo = [];
  var _pageCount = dec_.decodeFrom4Bytes(ver_);
  for (var i = 0; i < _pageCount; i++) {
    var _pageInfo = this.__createPage();
    _pageInfo.decode(dec_, ver_);
    this.m_pagesInfo.push(_pageInfo);
  }
};
MMPagesInfo.prototype.__createPage = function () {
  if (this.m_pagesInfo.length > 0) {
    var lastPageInfo = this.m_pagesInfo[this.m_pagesInfo.length - 1];
  }
  ;
  return new _PageInfo["default"]();
};

/**
 * 创建背景信息, 新建背景默认和上一页一致
 * @param newPgIndex {Number}
 * @returns {BackgroundPaperAttr}
 */
MMPagesInfo.prototype.createBackgroundForNewPage = function (newPgIndex) {
  var bkgrdInfo = null;
  if (this.m_pagesInfo.length > 0 && newPgIndex > 0) {
    var pgIndex = this.m_pagesInfo.length - 1;
    if (this.m_specialBackGround) {
      bkgrdInfo = this.m_specialBackGround.get(pgIndex); //BackgroundPaperAttr
    }
    if (bkgrdInfo != undefined && bkgrdInfo != null) {
      this.setBackgroundPaperAttr(newPgIndex, bkgrdInfo);
    }
  }
};

/**
 * 获得背景信息
 * @param pgIndex {Number}
 * @returns {BackgroundPaperAttr}
 */
MMPagesInfo.prototype.getBkgrdInfo = function (pgIndex) {
  var bkgrdInfo = null;
  if (this.m_specialBackGround) {
    bkgrdInfo = this.m_specialBackGround.get(pgIndex); //BackgroundPaperAttr
  }
  if (bkgrdInfo == undefined || bkgrdInfo == null) {
    bkgrdInfo = this.m_defaultBackGround;
  }
  return bkgrdInfo;
};

/**
 * 创建背景信息, 新建背景默认和上一页一致
 * @param newPgIndex {Number}
 * @returns {BackgroundPaperAttr}
 */
MMPagesInfo.prototype.createBackgroundForNewPage = function (newPgIndex) {
  var bkgrdInfo = null;
  if (this.m_pagesInfo.length > 0 && newPgIndex > 0) {
    var pgIndex = this.m_pagesInfo.length - 1;
    if (this.m_specialBackGround) {
      bkgrdInfo = this.m_specialBackGround.get(pgIndex); //BackgroundPaperAttr
    }
    if (bkgrdInfo != undefined && bkgrdInfo != null) {
      this.setBackgroundPaperAttr(newPgIndex, bkgrdInfo);
    }
  }
};

/**
 * 获得页信息
 * @param pgIndex
 * @returns {PageInfo}
 */
MMPagesInfo.prototype.getPgInfo = function (pgIndex) {
  var pgInfo = null; //BackgroundPaperAttr
  if (pgIndex < this.m_pagesInfo.length) {
    pgInfo = this.m_pagesInfo[pgIndex];
  }
  return pgInfo;
};
/**
 *
 * @param index_ {int32}
 * @param bkGrdAttr {BackgroundPaperAttr}
 * @returns {bool}
 */
MMPagesInfo.prototype.getBackgroundPaperAttr = function (index_, bkGrdAttr) {
  var _bkGrdAttr = this.m_specialBackGround.get(index_, null);
  if (_bkGrdAttr != null) {
    bkGrdAttr = _bkGrdAttr;
    return true; //xcode 中都返回true，不理解
  } else {
    bkGrdAttr = this.m_defaultBackGround;
    return true; //xcode 中都返回true，不理解
  }
};
MMPagesInfo.prototype.setBackgroundPaperAttr = function (index_, bkGrdAttr) {
  var baAttr = new _BackgroundPaperAttr["default"]();
  baAttr.m_type = bkGrdAttr.m_type;
  baAttr.m_name = bkGrdAttr.m_name;
  baAttr.m_color = bkGrdAttr.m_color;
  baAttr.img = bkGrdAttr.img; //

  //待实现...if（）{}

  this.m_specialBackGround.set(index_, baAttr);
};
MMPagesInfo.prototype.setDefaultPageBackGround = function (bkGrdAttr) {
  this.m_defaultBackGround = bkGrdAttr;
  this.m_specialBackGround.clear();

  //待实现...if（）{}
};

/**
 *
 * @param defaultBackGround {!BackgroundPaperAttr} 不能为空
 * @param specialBackGround {!map<unsigned, BackgroundPaperAttr>} 不能为空
 */
MMPagesInfo.prototype.getPageBackGround = function (defaultBackGround, specialBackGround) {
  specialBackGround = this.m_specialBackGround;
  defaultBackGround = this.m_defaultBackGround;
};

/**
 *
 * @param defaultBackGround {!BackgroundPaperAttr} 不能为空
 * @param specialBackGround {!map<unsigned, BackgroundPaperAttr>} 不能为空
 */
MMPagesInfo.prototype.setPageBackGround = function (defaultBackGround, specialBackGround) {
  this.m_specialBackGround = specialBackGround;
  this.m_defaultBackGround = defaultBackGround;
  this.m_defaultBackGround.initImage();
  var backgroundPaperAttr = this.m_specialBackGround.getValues(); //Array<BackgroundPaperAttr>
  for (var i = 0; i < backgroundPaperAttr.length; i++) {
    backgroundPaperAttr[i].initImage();
  }
};
/**
 *
 * @param defaultBackGround {!BackgroundPaperAttr} 不能为空
 */
MMPagesInfo.prototype.setPageBackGround = function (defaultBackGround) {
  this.m_defaultBackGround = defaultBackGround;
  this.m_specialBackGround.clear();
  //待实现...
};
/**
 * 从特殊背景中去除，恢复为默认背景
 * @param index_
 */
MMPagesInfo.prototype.removePageBackGround = function (index_) {
  this.m_specialBackGround.remove(index_);
};
/**
 *
 * @param refreshView {bool}
 * @param newPageNum {unsigned}
 * @param creationTime {long}
 * @param isAddAction {bool}  是否是界面新建
 * @returns {MMPagesInfo.PageCreationInfo}
 */
MMPagesInfo.prototype.addPage = function (refreshView, newPageNum, creationTime, isAddAction) {
  //待实现...

  var creationInfo = new MMPagesInfo.PageCreationInfo();
  if (creationTime == null) {
    var today = new Date();
    var h = today.getHours();
    var m = today.getMinutes();
    var s = today.getSeconds();
    creationInfo.m_creationTime = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate(), today.getHours(), today.getMinutes(), today.getSeconds(), 0) / 1000; //time(NULL)????
  } else {
    creationInfo.m_creationTime = creationTime;
  }
  creationInfo.newPageNum = newPageNum;
  for (var i = 0; i < newPageNum; i++) {
    var pageInfo = this.__createPage();

    // added by jiang, 2015-5-29
    if (isAddAction) {
      var newPgIndex = this.m_pagesInfo.length;
      this.createBackgroundForNewPage(newPgIndex);
    }
    ;
    // end

    pageInfo.m_createTime = creationInfo.m_creationTime;
    pageInfo.date = new Date();
    pageInfo.date.setTime(pageInfo.m_createTime * 1000);
    pageInfo.m_pageChangedFirst = true;
    //    NSDate *date = [NSDate dateWithTimeIntervalSince1970: pageInfo->creationTime];
    //        pageInfo->timeStr = [m_dateFormatter stringFromDate:date];
    //        pageInfo->setIconValid(false) ;
    this.m_pagesInfo.push(pageInfo);
  }
  this.setPageDirtyMark(this.m_pagesInfo.length - 1, true); // set page dirty, jiang, 2015-2-10

  return creationInfo;
};

/**
 *
 * @param refreshView {bool}
 * @param newPageNum {unsigned}
 * @returns
 */
MMPagesInfo.prototype.removePage = function (refreshView, removePageNum) {
  //待实现...
  for (var i = 0; i < removePageNum; i++) {
    if (this.m_pagesInfo.length != 0) {
      this.m_pagesInfo.pop();
    }
  }
};
MMPagesInfo.prototype.getPageSize = function () {
  var pgSize = new _size["default"](this.m_pageWidth, this.m_pageHeight);
  return pgSize;
};
MMPagesInfo.PageCreationInfo = function () {
  this.m_creationTime = 0; //time_t  {long}
  this.m_newPageNum = 1; //unsigned
};

/**
 * set paget dirty mark
 * @param {number} pgIndex
 * @param {bool} dirty
 * @author jiang
 * 2015-2-10
 */
MMPagesInfo.prototype.setPageDirtyMark = function (pgIndex, dirty) {
  if (pgIndex >= this.m_dirtyPageMark.length) {
    for (var i = this.m_dirtyPageMark.length; i < pgIndex + 1; i++) {
      this.m_dirtyPageMark.push(false);
    }
  }
  this.m_dirtyPageMark[pgIndex] = dirty;
};

/**
 * get page dirty mark
 * @param pgIndex
 * @returns {bool}
 */
MMPagesInfo.prototype.getPageDirtyMark = function (pgIndex) {
  if (pgIndex < this.m_dirtyPageMark.length) {
    return this.m_dirtyPageMark[pgIndex];
  }
  return false;
};

/*
//********************************************************* BackgroundPaperAttr--是否应该删除
MMPagesInfo.BackgroundType = {
    enumPaperTypeBigImageFill:0,
    enumPaperTypeSmallImageTile:1,
    enumPaperTypeColorFill:2
};

MMPagesInfo.BackgroundPaperAttr = function(){
    this.type = MMPagesInfo.BackgroundType.enumPaperTypeBigImageFill; //BackgroundType
    this.fileName = "";//string
    this.color = new Vec4();//vec4<double>
    this.img;    // 此属性不需要保存到文件 CGImageRef
    this.horizontalImg;//CGImageRef

};


MMPagesInfo.BackgroundPaperAttr.prototype.encode = function(enc_){
  var _objver = 0;
  enc_.encode4Bytes(_objver);
  enc_.encode4Bytes(this.type);
  enc_.encodeString(this.fileName);
  enc_.encodeFloat(this.color.x);
  enc_.encodeFloat(this.color.y);
  enc_.encodeFloat(this.color.z);
  enc_.encodeFloat(this.color.w);
};

MMPagesInfo.BackgroundPaperAttr.prototype.decode = function (dec_, ver_){
  var _objver = 0;
  _objver = dec_.decodeFrom4Bytes(ver_);
  this.type = dec_.decodeFrom4Bytes(ver_);
  this.fileName = dec_.decodeFromString(ver_);
  this.color.x = dec_.decodeFromFloat(ver_);
  this.color.y = dec_.decodeFromFloat(ver_);
  this.color.z = dec_.decodeFromFloat(ver_);
  this.color.w = dec_.decodeFromFloat(ver_);

//  this.fileName = "img/" + this.fileName;

};


MMPagesInfo.BackgroundPaperAttr.prototype.initImage = function(){
  //待实现
};

MMPagesInfo.BackgroundPaperAttr.prototype.drawInDiv = function(div){
  //待实现
//  if(this.type == 0){
    if(this.img == null){
      this.img = new Image();
      this.img.loaded = false;
      this.img.type = this.type;
      this.img.divs = new Array();
      this.img.name = "/img/background/" + this.fileName;

      this.img.src = "/img/background/" + this.fileName;
      this.img.onload = function(e){
        var img = e.target;
        img.loaded = true;

        for(var i=0;i<img.divs.length;i++){
          MMPagesInfo.BackgroundPaperAttr.setBackground(img.divs[i], img, img.type);
        };
      };
    }

    if(this.img.loaded){
      MMPagesInfo.BackgroundPaperAttr.setBackground(div, this.img, this.type);
    } else {
      this.img.divs.push(div);
    }

//  } else {
//    var color = new MMColor();
//    color.setColorByVec4(this.color);
//    var rgba = color.getRGBA();
//
//    $(div).css("background-color", rgba);
//  }

};

MMPagesInfo.BackgroundPaperAttr.setBackground = function (div, img, type) {
  var standardW = 768;
  var standardH = 1024;

  var xRatio = Math.round(100 * img.width / standardW);
  if(xRatio > 100) xRatio = 100;

  var yRatio = Math.round(100 * img.height / standardH);
  if(yRatio > 100) yRatio = 100;

  $(div).css("background-image", "url(" + img.name + ")");
  $(div).css("background-size", xRatio + "% " + yRatio + "%");
};
*/
var _default = exports["default"] = MMPagesInfo;

},{"1080":1080,"1184":1184,"1437":1437,"1454":1454,"821":821,"837":837,"841":841,"946":946,"961":961}],961:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
var _TextAlignment = _interopRequireDefault(require(819));
var _MMBasicData = _interopRequireDefault(require(811));
var _MMTextDrawer = _interopRequireDefault(require(902));
var _rect = _interopRequireDefault(require(836));
var _BoardOrientation = _interopRequireDefault(require(802));
var _MMRect = _interopRequireDefault(require(831));
function PageInfo() {
  this.$canvas = null;
}
;
PageInfo.prototype.decode = function (dec_, ver_) {
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_createTime = dec_.decodeFrom8Bytes(ver_);
  this.m_pageChangedFirst = dec_.decodeFromBool(ver_);
  var realTime = 0;
  //    for(var i=0; i<this.m_createTime.buffer.length; i++){
  //      realTime = realTime << 8;
  //      realTime += this.m_createTime.buffer[i];
  //    }
  //
  //  realTime = realTime << 8;
  //  realTime += this.m_createTime.buffer[4];
  //  realTime = realTime << 8;
  //  realTime += this.m_createTime.buffer[5];
  //  realTime = realTime << 8;
  //  realTime += this.m_createTime.buffer[6];
  //  realTime = realTime << 8;
  //  realTime += this.m_createTime.buffer[7];

  realTime = this.m_createTime.toNumber();
  realTime = realTime * 1000;
  this.date = new Date();
  this.date.setTime(realTime);
};

/**
 * 创建绘制页信息的画布，根据父元素进行创建，不同的父元素对应于不同的画布
 * @param parentDiv {HTML Element}
 * @returns 对应于父元素的画布
 */
PageInfo.prototype.createCanvas = function (parentDiv) {
  if (this.parentDivs == undefined) {
    this.parentDivs = new Array();
    this.canvases = new Array();
  }
  var i = -1;
  for (var k = 0; k < this.parentDivs.length; k++) {
    if (this.parentDivs[k] == parentDiv) {
      i = k;
      break;
    }
  }
  if (i == -1) {
    this.parentDivs.push(parentDiv);
    var $canvas = $("<canvas style='position:absolute' class='page-info'> </canvas>");
    this.canvases.push($canvas);
    i = this.canvases.length - 1;
    $(parentDiv).append($canvas);
  }
  return this.canvases[i];
};
PageInfo.prototype.drawInDiv = function (parentDiv, trsfm) {
  var $canvas = this.createCanvas(parentDiv);
  var edge = trsfm.lg2dvLen(0.1);
  var w_ratio = 1 / 2.5;
  var h_ratio = 1 / 5;
  var dvpgsize = trsfm.dvpgsize.clone();
  if (trsfm.orientation == _BoardOrientation["default"].Landscape) {
    var w = dvpgsize.width;
    dvpgsize.width = dvpgsize.height;
    dvpgsize.height = w;
  }
  var pginfoRct = new _rect["default"](0, 0, 0, 0);
  pginfoRct.width = dvpgsize.width * w_ratio;
  pginfoRct.height = dvpgsize.height * h_ratio;
  pginfoRct.left = dvpgsize.width - pginfoRct.width - edge;
  pginfoRct.top = dvpgsize.height - pginfoRct.height - edge;
  $canvas.css("left", pginfoRct.left + "px");
  $canvas.css("top", pginfoRct.top + "px");
  $canvas.attr("width", pginfoRct.width);
  $canvas.attr("height", pginfoRct.height);
  var canvas = $canvas[0];
  var ctx = canvas.getContext("2d");
  ctx.fillRect(0, 0, pginfoRct.width, pginfoRct.height);
};
PageInfo.prototype.drawInCanvas = function (ctx, trsfm, dvPgindex, dvPgCount) {
  var edge = 0; //trsfm.lg2dvLen(0.1);
  var w_ratio = 1 / 3;
  var h_ratio = 1 / 5;
  ctx.save();
  var dvpgsize = trsfm.dvpgsize.clone();
  //   if(trsfm.orientation == BoardOrientation.Landscape){
  //     var w = dvpgsize.width;
  //     dvpgsize.width = dvpgsize.height;
  //     dvpgsize.height = w;
  //   }

  var pginfoRct = new _rect["default"](0, 0, 0, 0);
  pginfoRct.width = dvpgsize.width * w_ratio;
  pginfoRct.height = dvpgsize.height * h_ratio;
  pginfoRct.left = dvpgsize.width - pginfoRct.width - edge;
  pginfoRct.top = dvpgsize.height - pginfoRct.height - edge;

  //   ctx.fillStyle="#FF0000";
  //   ctx.fillRect(pginfoRct.left, pginfoRct.top, pginfoRct.width, pginfoRct.height);

  var pgNo = dvPgindex + 1 + "/" + dvPgCount;
  this.drawTimeInCanvas(ctx, trsfm, pginfoRct, pgNo);
  ctx.restore();
};

/**
 * 绘制脚线和日期
 * @param ctx {HTML5 canvas context}
 * @param trsfm {Transformer}
 * @param inRect {Rect}
 * @param pgNo {String} 页码信息
 */
PageInfo.prototype.drawTimeInCanvas = function (ctx, trsfm, inRect, pgNo) {
  var edge = trsfm.lg2dvLen(trsfm.lgpgsize.width / 100);
  ctx.clearRect(inRect.left, inRect.top, inRect.width, inRect.height);
  var color = "#aaaaaa";
  ctx.strokeStyle = color;
  ctx.fillStyle = color;
  ctx.lineWidth = 1;

  // 绘制脚线
  ctx.beginPath();
  var x = Math.round(inRect.left);
  var y = Math.round(inRect.top + inRect.height - edge);
  ctx.moveTo(x, y);
  var x1 = Math.round(inRect.left + inRect.width);
  ctx.lineTo(x1, y); // 横线

  ctx.moveTo(inRect.left + inRect.width - edge, inRect.top);
  ctx.lineTo(inRect.left + inRect.width - edge, inRect.top + inRect.height); // 竖线
  ctx.stroke();

  // 绘制页日期
  var fontSize = trsfm.lg2dvLen(0.25);
  var fontName = "Arial";
  var text = this.date.Format("yyyy-MM-dd hh:mm:ss") + "  " + pgNo; //"2014-06-22 17:30";
  //  var text = this.date.toLocaleString() + "  " + pgNo; //"2014-06-22 17:30";
  var top = inRect.top + inRect.height - edge - fontSize * 1.2;
  var right = inRect.left + inRect.width - 2 * edge;
  var bottom = inRect.top + inRect.height;
  ctx.font = fontSize + "px Arial";
  var textW = ctx.measureText(text).width;
  var left = right - textW - 2 * fontSize;
  var textRct = new _MMRect["default"](top, right, bottom, left);

  //  ctx.fillStyle = 'rgba(0,0,0,0.5)';    // 黑底
  //  ctx.fillRect(inRect.left, textRct.top, inRect.width, textRct.getHeight());
  //  ctx.fillStyle = 'white';      // 白字

  _MMTextDrawer["default"].drawTextInRect(ctx, fontSize, fontName, text, textRct, _TextAlignment["default"].Right, 0);
};
PageInfo.prototype.testDrawLine = function (ctx, x0, y0, x1, y1) {
  ctx.beginPath();
  ctx.moveTo(x0, y0);
  ctx.lineTo(x1, y1);
  ctx.stroke();
};
var _default = exports["default"] = PageInfo;

},{"1184":1184,"1437":1437,"1454":1454,"802":802,"811":811,"819":819,"831":831,"836":836,"902":902}],902:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1477);
require(1495);
require(1412);
var _TextAlignment = _interopRequireDefault(require(819));
var _MMPoint = _interopRequireDefault(require(830));
/**
 *
 */

function MMTextDrawer(e) {}
;

/**
 * 绘制文字到指定的文本框内
 * @param ctx       {HTML5 canvas context}
 * @param fontSize    {Number} - 文字大小
 * @param fontName    {Numver} - 文字字体
 * @param text      {String} - 文本
 * @param rect      {MMRect} - 矩形框
 * @param alignment   {MolaTextAlignment} 文本对齐方式
 */
MMTextDrawer.drawTextInRect = function (ctx, fontSize, fontName, text, rect, alignment, arc) {
  if (alignment == undefined) alignment = _TextAlignment["default"].Left;

  // 使用 12px 的字号排版文字进行行的分割 这样可以免去受显示文字的大小变化对排版的影响
  ctx.font = "12px " + fontName;
  var lines = String(text).split(/\r\n|\r|\n/g);
  var lines_disp = new Array();
  for (var i = 0; i < lines.length; i++) {
    var line = lines[i];
    var sublines = splitByWidth(ctx, line, rect.getWidth() * 12 / fontSize);
    lines_disp = lines_disp.concat(sublines);
  }

  // 绘制文字
  ctx.font = fontSize + "px " + fontName;
  var center = new _MMPoint["default"]((rect.left + rect.right) / 2, (rect.top + rect.bottom) / 2);
  ctx.translate(center.x, center.y);
  ctx.rotate(arc);
  ctx.translate(-center.x, -center.y);
  var ratio = 1.0;
  if (fontSize < 12) {
    ratio = fontSize / 12;
    fontSize = 12;
  }
  ctx.scale(ratio, ratio);

  //  console.log("draw text:" + text);

  var left = rect.left / ratio;
  var top = rect.top / ratio;
  var rectW = rect.getWidth() / ratio;
  //
  //  ctx.fillRect(left, top, rect.getWidth() / ratio, rect.getHeight() / ratio);
  //
  //  console.log("font size:" + fontSize + "  text:" + text);

  var y = top + fontSize;
  for (i = 0; i < lines_disp.length; i++) {
    var start = left;
    if (alignment == _TextAlignment["default"].Center) {
      start = left + (rectW - ctx.measureText(lines_disp[i]).width) / 2;
    } else if (alignment == _TextAlignment["default"].Right) {
      start = left + rectW - ctx.measureText(lines_disp[i]).width;
    } else {}
    ctx.fillText(lines_disp[i], start, y);
    y += fontSize;

    //    console.log("print ----> (" + lines_disp[i] + ")");

    if (lines_disp[i].length < 3) {
      var s = lines_disp[i];
      var c = s.charCodeAt(0);

      //      console.log("=====>" + c);
    }
  }
};
function splitByWidth(ctx, line, maxwidth) {
  var lines = new Array();
  if (line.length >= 1) {
    var len = 2;
    var subline = line.substr(0, len++);
    do {
      while (ctx.measureText(subline).width < maxwidth && len <= line.length) {
        subline = line.substr(0, len++);
      }
      var splitIndex = len - 1;
      if (len <= line.length) {
        splitIndex = getLineSplitIndex(line.substr(0, len - 1));
      }
      var subLine = line.substr(0, splitIndex);
      if (subLine.length > 0) {
        lines.push(subLine);
      }
      line = line.substr(splitIndex);
    } while (ctx.measureText(line).width > maxwidth && line.length > 2);
    if (line.length > 0) lines.push(line);
  } else {
    lines[0] = line;
  }
  return lines;
}
function getLineSplitIndex(str) {
  if (str.length < 2) return str.length;
  var c = str[str.length - 1];
  var pre = str[str.length - 2];
  if (isPunctuation(c)) {
    return str.length; // 标点符号放在行尾
  } else if (isBlank(c)) {
    return str.length - 1;
  } else if (isLetters(c) && isLetters(pre)) {
    for (var i = str.length - 1; i > 0; i--) {
      c = str[i];
      if (isPunctuation(c) || isBlank(c)) {
        return i + 1;
      } else if (!isLetters(c)) {
        return i + 1;
      }
    }
  }
  return str.length - 1;
}
function isPunctuation(c) {
  var punctuations = [',', '.', '!', '?', ';', ':',
  // 半角
  '，', '。', '！', '？', '；', '：']; // 全角
  for (var i = 0; i < punctuations.length; i++) {
    if (c == punctuations[i]) {
      break;
    }
  }
  if (i < punctuations.length) return true;
  return false;
}
function isBlank(c) {
  if (c == ' ' || c == '　' /* 全角*/) {
    return true;
  }
  return false;
}
function isLetters(c) {
  var code = c.charCodeAt(0);
  if (code >= 65 && code <= 90 || code >= 97 && code <= 122) {
    return true;
  }
  return false;
}
var _default = exports["default"] = MMTextDrawer;

},{"1184":1184,"1412":1412,"1454":1454,"1477":1477,"1495":1495,"819":819,"830":830}],1495:[function(require,module,exports){
'use strict';
var apply = require(1274);
var call = require(1278);
var uncurryThis = require(1281);
var fixRegExpWellKnownSymbolLogic = require(1272);
var anObject = require(1209);
var isNullOrUndefined = require(1306);
var isRegExp = require(1309);
var requireObjectCoercible = require(1359);
var speciesConstructor = require(1367);
var advanceStringIndex = require(1207);
var toLength = require(1386);
var toString = require(1393);
var getMethod = require(1285);
var arraySlice = require(1226);
var callRegExpExec = require(1352);
var regexpExec = require(1353);
var stickyHelpers = require(1356);
var fails = require(1271);

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min = Math.min;
var $push = [].push;
var exec = uncurryThis(/./.exec);
var push = uncurryThis($push);
var stringSlice = uncurryThis(''.slice);

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

// @@split logic
fixRegExpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = toString(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return call(nativeSplit, string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = call(regexpExec, separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          push(output, stringSlice(string, lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) apply($push, output, arraySlice(match, 1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !exec(separatorCopy, '')) push(output, '');
      } else push(output, stringSlice(string, lastLastIndex));
      return output.length > lim ? arraySlice(output, 0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : call(nativeSplit, this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = isNullOrUndefined(separator) ? undefined : getMethod(separator, SPLIT);
      return splitter
        ? call(splitter, separator, O, limit)
        : call(internalSplit, toString(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);

      if (res.done) return res.value;

      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = callRegExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          push(A, stringSlice(S, p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            push(A, z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      push(A, stringSlice(S, p));
      return A;
    }
  ];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);

},{"1207":1207,"1209":1209,"1226":1226,"1271":1271,"1272":1272,"1274":1274,"1278":1278,"1281":1281,"1285":1285,"1306":1306,"1309":1309,"1352":1352,"1353":1353,"1356":1356,"1359":1359,"1367":1367,"1386":1386,"1393":1393}],946:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1425);
require(1439);
var _vec = _interopRequireDefault(require(841));
var _MMColor = _interopRequireDefault(require(794));
function BackgroundPaperAttr() {
  this.m_type = 1;
  this.m_name = '2.png';
  this.m_color = new _vec["default"]();
  this.img = null;
}
;
BackgroundPaperAttr.prototype.getFullPath = function () {
  var i = this.m_name.lastIndexOf(".");
  var finalname;
  if (MMCommonFun.isRetina()) {
    finalname = this.m_name.substring(0, i) + "_ipad@2x" + this.m_name.substring(i);
  } else {
    finalname = this.m_name.substring(0, i) + "_ipad" + this.m_name.substring(i);
  }
  return "/img/background/" + finalname;
};

/**
 *__deprecatedDecode, MMPageArray中的解析函数没有写好，用这个临时函数。注意：以后的代码中不要使用这个函数
 *
 **/
BackgroundPaperAttr.prototype.__deprecatedDecode = BackgroundPaperAttr.prototype.decode = function (dec_, ver_, deprecated_) {
  var _objver = 0;
  if (!deprecated_) _objver = dec_.decodeFrom4Bytes(ver_);
  this.m_type = dec_.decodeFrom4Bytes(ver_);
  this.m_name = dec_.decodeFromString(ver_);
  this.m_color = dec_.decodeFromVec4(ver_, 'Float');
};
BackgroundPaperAttr.prototype.encode = function (enc_) {
  var _objver = 0;
  enc_.encode4Bytes(_objver);
  enc_.encode4Bytes(this.m_type);
  enc_.encodeString(this.m_name);
  enc_.encodeVec4(this.m_color, 'Float');
};

/**
 * 绘制背景
 * @param div {HTMLElement} 放置背景的 html 元素
 */
BackgroundPaperAttr.prototype.drawInDiv = function (div) {
  if (this.m_type < 2) {
    if (this.img == null || this.img.src != this.getFullPath()) {
      if (this.img) {
        this.img.divs = [];
      }
      ;
      this.img = new Image();
      this.img.loaded = false;
      this.img.type = this.m_type;
      this.img.divs = new Array();
      this.img.name = this.getFullPath();
      this.img.src = this.getFullPath();
      var that = this;
      this.img.onload = function (e) {
        var img = e.target;
        img.loaded = true;
        for (var i = 0; i < img.divs.length; i++) {
          var aDiv = img.divs[i];
          if (aDiv.backgroundSrc == that.getFullPath()) {
            // 文件名称对应才能绘制，避免下载慢的图片覆盖下载快的图片
            BackgroundPaperAttr.setBackground(aDiv, img, img.type);
            //                        console.log("------------- draw background:", img.src);
          }
        }
        ;
      };
    }
    if (this.img.loaded) {
      BackgroundPaperAttr.setBackground(div, this.img, this.type);
    } else {
      this.img.divs.push(div);
    }
  } else {
    var color = new _MMColor["default"]();
    color.setColorByVec4(this.m_color);
    var rgba = color.getRGBA();
    $(div).css("background-color", rgba);
    $(div).css("background-image", "none");
  }
};
BackgroundPaperAttr.setBackground = function (div, img, type) {
  var standardW = 768;
  var standardH = 1024;
  var xRatio = Math.round(100 * img.width / standardW);
  if (xRatio > 100) xRatio = 100;
  var yRatio = Math.round(100 * img.height / standardH);
  if (yRatio > 100) yRatio = 100;
  $(div).css("background-image", "url(" + img.name + ")");
  if (xRatio >= 100) {
    $(div).css("background-size", xRatio + "% " + yRatio + "%");
  } else {
    $(div).css("background-size", "auto");
  }
};

/**
 * 绘制背景
 * @param div {HTMLElement} 放置背景的 html 元素
 */
BackgroundPaperAttr.prototype.drawInCanvas = function (ctx, trsfm) {
  if (this.m_type < 2) {
    if (this.img == null) {
      this.img = new Image();
      this.img.loaded = false;
      this.img.type = this.m_type;
      this.img.divs = new Array();
      this.img.name = this.getFullPath();
      this.img.src = this.getFullPath();
      var that = this;
      this.img.onload = function (e) {
        var img = e.target;
        img.loaded = true;
        that.drawLoadedImageIncanvas(ctx, trsfm);
      };
    }
    if (this.img.loaded) {
      this.drawLoadedImageIncanvas(ctx, trsfm);
    }
  } else {
    this.drawColorInCanvas(ctx, trsfm);
  }
};
BackgroundPaperAttr.prototype.drawLoadedImageIncanvas = function (ctx, trsfm) {
  var standardW = 768;
  var standardH = 1024;
  var wRatio = 1 * this.img.width / standardW;
  if (wRatio > 1) wRatio = 1;
  var hRatio = 1 * this.img.height / standardH;
  if (hRatio > 1) hRatio = 1;
  var dvSize = trsfm.getDevicePageSize();
  var drawW = dvSize.width * wRatio;
  var drawH = dvSize.height * hRatio;

  // 目前没有考虑横屏 ------ not concern landscape so far
  for (var x = 0; x < dvSize.width; x += drawW) {
    for (var y = 0; y < dvSize.height; y += drawH) {
      ctx.drawImage(this.img, x, y, drawW, drawH);
    }
  }
};
BackgroundPaperAttr.prototype.drawColorInCanvas = function (ctx, trsfm) {
  var color = new _MMColor["default"]();
  color.setColorByVec4(this.m_color);
  var rgba = color.getRGBA();
  ctx.fillStyle = rgba;
  var dvSize = trsfm.getDevicePageSize();
  ctx.fillRect(0, 0, dvSize.width, dvSize.height);
};
var _default = exports["default"] = BackgroundPaperAttr;

},{"1184":1184,"1425":1425,"1439":1439,"1454":1454,"794":794,"841":841}],947:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * @enum {number}
 */
var BoardType = {
  enumWhiteBoardMain: 0,
  //

  enumWhiteBoardSynch: 1,
  //

  enumTask: 2,
  enumNetDiskBoard: 3
};
var _default = exports["default"] = BoardType;

},{"1454":1454}],886:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ObjType = _interopRequireDefault(require(1084));
var _MMRect = _interopRequireDefault(require(831));
var _MMBlockObj = _interopRequireDefault(require(1000));
/**
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMSealFrame}
 */
function MMSealFrame(board, ver) {
  _MMBlockObj["default"].call(this, board, ver); //
  this.m_className = 'MMSignatureFrame';
  this.m_objType = _ObjType["default"].Obj_seal;
  this.m_isClose = false;
  this.user = null;
  this.pgRect = null;
  this.angle = 0;
}
;
MMSealFrame.prototype = new _MMBlockObj["default"](); //
MMSealFrame.superclass = _MMBlockObj["default"].prototype;
MMSealFrame.prototype.encode = function (enc_) {
  MMSealFrame.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMSealFrame.prototype.decode = function (dec_, ver_) {
  MMSealFrame.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};

// MMSealFrame.prototype.draw = function(ctx, trsfm, pgindex) {
//   MMSealFrame.superclass.draw.call(this, ctx, trsfm, pgindex);
// };

MMSealFrame.prototype.draw = function (ctx, trsfm, pgindex) {
  var data = this.getObjData();
  if (data == null || data == undefined) return;
  if (!this.pgRect) {
    this.pgRect = trsfm.getLgPageRect();
    this.initByDefaultRect2Save();
  }
  // MMSignatureFrame.superclass.drawInCanvas.call(this, ctx, trsfm, pgindex);

  var angle = this.angle;
  if (this.sealData) {
    // const avatarUrl = this.sealData.sealUrl;
    // const avatarImg = new Image();
    // avatarImg.crossOrigin = 'Anonymous';

    // avatarImg.onload = () => {
    var avatarImg = this.sealData.getAvatarImg();
    ctx.save();
    var rect = this.getDrawRect();
    var origin = rect.getOrigin();
    var w = rect.getWidth();
    var h = rect.getHeight();
    var center = rect.getCenter();
    var dvCent = trsfm.lg2dvPoint(center);
    ctx.translate(dvCent.x, dvCent.y);
    ctx.rotate(trsfm.viewAngle);
    // ctx.translate(-dvCent.x, -dvCent.y);

    // 图片原始尺寸 (300x300)
    var imgWidth = this.sealData.getWidth();
    var imgHeight = this.sealData.getHeight();

    // canvas尺寸
    var canvasWidth = trsfm.lg2dvLen(w);
    var canvasHeight = trsfm.lg2dvLen(h);
    // 计算缩放比例 - 取宽度和高度缩放比例的最小值，确保图片完全显示在canvas中
    var scaleX = canvasWidth / imgWidth;
    var scaleY = canvasHeight / imgHeight;
    var scale = Math.min(scaleX, scaleY);

    // 计算缩放后的图片尺寸
    var scaledWidth = imgWidth * scale;
    var scaledHeight = imgHeight * scale;

    // 因为已经将原点平移到了dvCent，所以这里直接使用相对坐标
    var x = -scaledWidth / 2; // 相对于旋转中心的X偏移
    var y = -scaledHeight / 2; // 相对于旋转中心的Y偏移
    // 绘制图片
    ctx.drawImage(avatarImg, x, y, scaledWidth, scaledHeight);
    // 恢复到左上角
    // 计算用户信息位置（在图像上方，即顶部）
    // if (this.user) {
    //   var colorStr = "#ff0000";
    //   var name = this.user.getUserName() + '-' + BabelStr.str(11318);

    //   // 设置文本样式
    //   ctx.font = "10px Arial";
    //   ctx.fillStyle = colorStr;

    //   // 计算文本宽度
    //   const textWidth = ctx.measureText(name).width;
    //   const rectSize = 10; // 小矩形尺寸

    //   // 顶部位置计算（基于旋转中心和图像尺寸）
    //   // 向上偏移图像高度的一半 + 额外间距，确保显示在图像顶部
    //   const topOffset = -scaledHeight / 2 - rectSize * 2;

    //   // 相对旋转中心的坐标（水平居中，垂直居上）
    //   const rectX = -scaledWidth / 2; // 矩形水平居中
    //   const rectY = topOffset;

    //   const textX = rectX + rectSize + 5; // 文本在矩形右侧
    //   const textY = topOffset + rectSize * 0.6; // 文本垂直居中对齐矩形

    //   // 先绘制矩形标记
    //   ctx.fillRect(rectX, rectY, rectSize, rectSize);
    //   // 再绘制文本
    //   ctx.fillText(name, textX, textY);
    // }
    ctx.restore();
    //   };

    //   avatarImg.onerror = function() {
    //     console.error('Failed to load avatar image');
    //   };

    //   // 设置图片源，开始加载
    //   avatarImg.src = avatarUrl;
  }

  // ctx.restore();
};
MMSealFrame.prototype.clone = function () {
  var newObj = new MMSealFrame(this.board);
  newObj.initBy(this);
  newObj.sealData = this.sealData;
  newObj.user = this.user;
  newObj.pgRect = this.pgRect;
  return newObj;
};
MMSealFrame.prototype.getLogicPts = function (sealData) {
  return this.getObjData().getRect().getLogicPts();
};
MMSealFrame.prototype.isPtOn = function (pt, error) {
  if (pt.x >= this.m_expandRect.left && pt.x <= this.m_expandRect.right && pt.y >= this.m_expandRect.top && pt.y <= this.m_expandRect.bottom) {
    return true;
  }
  return false;
};
MMSealFrame.prototype.setSigData = function (sealData) {
  this.sealData = sealData;
};
MMSealFrame.prototype.getSigData = function () {
  return this.sealData;
};
MMSealFrame.prototype.getDatetime = function () {
  return this.datetime;
};
MMSealFrame.prototype.setDatetime = function (datetime) {
  return this.datetime = datetime;
};
MMSealFrame.prototype.getSealedId = function () {
  return this.sealedId;
};
MMSealFrame.prototype.setSealedId = function (sealedId) {
  return this.sealedId = sealedId;
};
MMSealFrame.prototype.getSigDataId = function () {
  return this.sealData.getId();
};
MMSealFrame.prototype.setUser = function (user) {
  this.user = user;
};
MMSealFrame.prototype.getUser = function () {
  return this.user;
};
MMSealFrame.prototype.setPageRect = function (pgRect) {
  this.pgRect = pgRect;
};
MMSealFrame.prototype.getRect2Save = function () {
  if (this.pgRect) {
    var drawRect = this.getDrawRect();
    var pgW = this.pgRect.getWidth();
    var pgH = this.pgRect.getHeight();
    var origin = drawRect.getOrigin();
    var pageOrigin = this.pgRect.getOrigin();
    origin.subtract(pageOrigin);
    var w = drawRect.getWidth();
    var h = drawRect.getHeight();
    origin.x = origin.x / pgW;
    origin.y = origin.y / pgH;
    w = w / pgW;
    h = h / pgH;
    var rect2save = new _MMRect["default"]();
    rect2save.setRct(origin.x, origin.y, w, h);
    return rect2save;
  }
};
MMSealFrame.prototype.getSealSizeData = function () {
  var rect = this.getRect2Save();
  return {
    x: rect.getOrigin().x,
    y: rect.getOrigin().y,
    height: rect.getHeight(),
    width: rect.getWidth()
  };
};
MMSealFrame.prototype.initByRect2Save = function (rect) {
  if (this.pgRect) {
    var pageOrigin = this.pgRect.getOrigin();
    var pgW = this.pgRect.getWidth();
    var pgH = this.pgRect.getHeight();
    var drawRect = rect;
    var origin = drawRect.getOrigin();
    var w = drawRect.getWidth();
    var h = drawRect.getHeight();
    origin.x = pageOrigin.x + origin.x * pgW;
    origin.y = pageOrigin.y + origin.y * pgH;
    w = w * pgW;
    h = h * pgH;
    var rectInit = new _MMRect["default"]();
    rectInit.setRct(origin.x, origin.y, w, h);
    this.initObjectWithLogicRect(rectInit);
  }
};
MMSealFrame.prototype.initByRect = function (rect) {
  var pts = rect.getLogicPts();
  this.setLogPts(pts);
};

// 设置保存数据在区间 【0 1】 内的签字框数据
MMSealFrame.prototype.setDefaultRect2Save = function (standRect) {
  this.standRect = standRect;
  this.pgRect = null;
};
MMSealFrame.prototype.getDefaultRect2Save = function () {
  return this.standRect;
};
MMSealFrame.prototype.initByDefaultRect2Save = function () {
  if (this.standRect) {
    this.initByRect2Save(this.standRect);
  }
};
MMSealFrame.prototype.rotate90 = function () {
  this.angle -= Math.PI / 2;
};
var _default = exports["default"] = MMSealFrame;

},{"1000":1000,"1084":1084,"1184":1184,"1454":1454,"831":831}],1000:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1466);
var _MMObject = _interopRequireDefault(require(1081));
var _MMCenterRect = _interopRequireDefault(require(829));
var _MMRect = _interopRequireDefault(require(831));
function MMBlockObj(board, ver_) {
  _MMObject["default"].call(this, board, ver_);
}
MMBlockObj.prototype = new _MMObject["default"](); //
MMBlockObj.prototype.m_className = "MMBlockObj";
MMBlockObj.superclass = _MMObject["default"].prototype;
MMBlockObj.prototype.encode = function (enc_) {
  MMBlockObj.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMBlockObj.prototype.decode = function (dec_, ver_) {
  MMBlockObj.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
MMBlockObj.prototype.setDevPts = function (trsfm_, devPts_, pageIndex_) {
  var data = this.getObjData();
  if (data) {
    data.setDevPts(trsfm_, devPts_, pageIndex_);
    this.m_rect = data.getRect();
    this.m_expandRect = data.getExpandRect();
  }
};
MMBlockObj.prototype.setLogPts = function (lgPts, pageIndex_) {
  var data = this.getObjData();
  if (data) {
    data.setLogPts(lgPts, pageIndex_);
    this.m_rect = data.getRect();
    this.m_expandRect = data.getExpandRect();
  }
};
MMBlockObj.prototype.getRect = function () {
  return this.getObjData().getRect();
};
MMBlockObj.prototype.getLogicRect = function () {
  return this.getObjData().getLogicRect();
};
MMBlockObj.prototype.getDevOrientation = function () {
  return this.getObjData().getDevOrientation();
};
MMBlockObj.prototype.setDevOrientation = function (devOri_) {
  this.getObjData().setDevOrientation(devOri_);
};
MMBlockObj.prototype.transform = function (option, basePt_,
// 参考点 MMLgPoint
scale_,
// 拉伸比例 MMLgPoint
angleInfect_,
// 缩放时是否受原有角度影响？在多个对象同时被选中拉伸时，此参数置为 false
alpha_,
// 相对旋转角度(0, 360) float
offset_ // 相对位移 MMLgPoint
) {
  var data = this.getObjData();
  var scale = data.transform(option, basePt_, scale_, angleInfect_, alpha_, offset_);
  this.m_rect = data.getRect();
  this.m_expandRect = data.getExpandRect();
  return scale;
};
MMBlockObj.prototype.move = function (offset_, moveAll_) {
  var data = this.getObjData();
  data.move(offset_, moveAll_);
  this.m_rect = data.getRect();
  this.m_expandRect = data.getExpandRect();
};
MMBlockObj.prototype.rotate = function (alpha_, rotateAll_) {
  this.getObjData().rotate(alpha_, rotateAll_);
};
MMBlockObj.prototype.drawInCanvas = function (ctx, trsfm, pgindex, callback) {
  var delayed = 0;
  var data = this.getObjData();
  if (data != null && data != undefined && this.m_rect != undefined) {
    var lgrct = new _MMCenterRect["default"]();
    var lgRct = this.getDrawRect();
    var angle = this.getDrawAngle();
    lgrct.setRect(lgRct);
    lgrct.setAngle(angle);

    //    console.log("--------------------");
    //      console.log("draw class name:" + data.m_className);
    //      lgRct.debugOutput("draw lg rect:");
    //    console.log("draw object angle ------->" + angle + " obj angle: " + data.m_angle);
    //      console.log("draw device orient:" + data.m_orientation.devOrientation);

    var dvrct = trsfm.lg2dvCenterRect(lgrct, pgindex);
    var cx = dvrct.center.x;
    var cy = dvrct.center.y;
    ctx.translate(cx, cy);
    ctx.rotate(dvrct.angle * Math.PI / 180);
    ctx.translate(-cx, -cy);
    ctx.fillStyle = "#cccccc";
    var left = dvrct.getLeftTop().x;
    var top = dvrct.getLeftTop().y;
    var rctDraw = new _MMRect["default"]();
    rctDraw.setRct(left, top, dvrct.width, dvrct.height);
    delayed = this.drawObjInRct(ctx, trsfm, pgindex, rctDraw, callback);
    ctx.setTransform(1, 0, 0, 1, 0, 0);
  }
  return delayed;
};
MMBlockObj.prototype.getDrawRect = function (devOri_) {
  return this.getObjData().getDrawRect(devOri_);
};
MMBlockObj.prototype.getDrawAngle = function (devOri_) {
  return this.getObjData().getDrawAngle(devOri_);
};
MMBlockObj.prototype.getArcAngle = function () {
  return this.getObjData().getArcAngle();
};
MMBlockObj.prototype.initObjectWithLogicRect = function (rect) {
  var objData = this.getObjData();
  this.m_expandRect = this.m_rect = rect;
  if (objData) {
    objData.initObjectWithLogicRect(rect);
    this.m_rect = objData.getRect();
  }
};
MMBlockObj.prototype.getOriginSize = function () {
  if (this.originSize && this.originSize.x > 0 && this.originSize.y > 0) {
    return {
      x: this.originSize.x,
      y: this.originSize.y
    };
  }
  return null;
};
MMBlockObj.prototype.getThumbnailUrl = function (useCurrentVersion, size) {
  size = size ? size : 128;
  size = parseInt(size);
  var fileId = this.m_board.getStringId();
  var version = this.getFileVersion();
  // if (useCurrentVersion) {
  //   version = this.m_board.getCurVersion();
  // } else {
  //   version = this.m_board.getVersionShowing();
  // }

  var param = "fileId=" + fileId + "&size=" + size + "&version=" + version;
  var thumbUrl = "/netdrive/downloadThumbnail.do?" + param;
  return thumbUrl;
};
var _default = exports["default"] = MMBlockObj;

},{"1081":1081,"1184":1184,"1454":1454,"1466":1466,"829":829,"831":831}],231:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require(1180));
require(1451);
require(1423);
require(1411);
require(1463);
require(1530);
require(1505);
require(1506);
require(1507);
require(1508);
require(1510);
require(1509);
require(1512);
require(1513);
require(1514);
require(1516);
require(1517);
require(1518);
require(1519);
require(1521);
require(1520);
require(1522);
require(1523);
require(1524);
require(1525);
require(1526);
require(1527);
require(1528);
require(1529);
require(1434);
require(1541);
require(1417);
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MEWatermarkOverlay = _interopRequireDefault(require(809));
var _MDLoadMaskView = _interopRequireDefault(require(49));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _utils = _interopRequireDefault(require(108));
var MDTextFileBrowser = function MDTextFileBrowser(parentDiv) {
  this.$content = $('<div class="md-browser markdown-body" style=""></div>');
  $(parentDiv).append(this.$content);
  this.$imageLayerMarker = $("<canvas class='image-layer-marker editor-canvas-zone' style='position:absolute; width:100%;height: 100%; pointer-events:none'></canvas>");
  $(parentDiv).append(this.$imageLayerMarker);
  if (!app.canDispInNormalBrowser()) {
    this.$content.on("click", function () {
      Dispatcher.trigger(MDEvents.TapOnWhiteSpaceInDoc);
    });
  }
};
Object.assign(MDTextFileBrowser.prototype, Object.prototype, {
  contstructor: MDTextFileBrowser,
  openFile: function openFile(curFileInfo, version, callback) {
    _czc && _czc.push(["_trackEvent", "预览", "MD", "", "", ""]);
    var fileId = curFileInfo.getFileId();
    this.curFileInfo = curFileInfo;
    if (!this.curFileInfo.canDownload()) {
      this.$content.addClass('no-user-select');
    }
    var self = this;
    // var path = '/readme.md';//MMCommonFun.getDocumentDispPath(fileId, version, callback);

    _MDLoadMaskView["default"].show();
    var request;
    // if (curFileInfo.isMDFile()) {
    request = _MMCommonFun["default"].getDocumentDispPath;
    // } else {
    //   request = MMCommonFun.getDownloadRealPath;
    // }
    var otherParam = undefined;
    if (curFileInfo.isOnlyTxt()) {
      otherParam = {
        dispIsReady: true
      };
    }
    var maxTryCount = 3;
    var requestFun = function requestFun() {
      request(fileId, version, function (url, type, pwd) {
        _MMNetDiskDataController["default"].downLoadFileData(url, function (data) {
          // data = utils.decryptDesECBArryBuffer(data, pwd)
          self.originData = data;
          var decodedString = data;
          // try {
          decodedString = _MMCommonFun["default"].decodeFromUTF8Array(data);
          // } catch (error) {
          //   decodedString = MMCommonFun.utf8byteToString(data)
          // }
          // var decodedString = MMCommonFun.decodeFromUTF8Array(data);
          // console.log(decodedString);

          var file = self.getCurrentBoard().getFileInfo();
          var type = localStorage.getItem("encodtype" + file.getFileId());
          if (type) {
            if (data instanceof Uint8Array) {
              data = data.buffer;
            }
            var dataView = new DataView(data);
            // The TextDecoder interface is documented at http://encoding.spec.whatwg.org/#interface-textdecoder
            var decoder = new TextDecoder(type);
            decodedString = decoder.decode(dataView);
          }
          var ext = curFileInfo.getFileExtension().toLowerCase();
          // decodedString = _.escape(decodedString);
          if (ext == "md") {
            self._dispMarkdownFile(decodedString, function () {
              _MDLoadMaskView["default"].remove();
              if (callback) {
                callback();
              }
            });
          } else {
            self._dispOtherTextFile(decodedString, function () {
              _MDLoadMaskView["default"].remove();
              if (callback) {
                callback();
              }
            });
          }
        }, function () {
          _MDLoadMaskView["default"].remove();
        }, undefined, pwd);
      }, function (code, msg) {
        if (code == 10010) {
          if (maxTryCount > 0) {
            setTimeout(function () {
              maxTryCount--;
              requestFun();
            }, 2000);
            return;
          }
        } else {
          _MDLoadMaskView["default"].remove();
          _MDSnackbarView["default"].show(BabelStr.str(108));
        }
      }, otherParam);
    };
    requestFun();

    // MMCommonFun.getDownloadRealPath(fileId, version, function(path){

    // }, function(){
    //         MDLoadMaskView.remove();
    //      	if (callback) {
    //      		callback();
    //      	};
    // })
  },
  _dispMarkdownFile: function _dispMarkdownFile(data, callback) {
    var self = this;
    marked(data, function (e, htmlStr) {
      self.$content[0].innerHTML = htmlStr;
      self.drawWaterMark();
      if (callback) {
        callback();
      }
      self.$content.off("scroll");
      self.$content.on("scroll", function (e) {
        if (self.scrollEvtTimeout) {
          clearTimeout(self.scrollEvtTimeout);
        }
        self.scrollEvtTimeout = setBabelTimeout(function () {
          Dispatcher.trigger(MDEvents.WindowScrolled);
        }, 500);
      });
    });
  },
  drawWaterMark: function drawWaterMark() {
    var self = this;
    this._watermarkOverlay = _MEWatermarkOverlay["default"].createWatermarkOverlay({
      container: this.$imageLayerMarker.parent()[0],
      existingCanvas: this.$imageLayerMarker[0],
      canvasClass: "image-layer-marker editor-canvas-zone",
      extraStyles: {
        width: "100%",
        height: "100%"
      },
      getSize: function getSize() {
        return {
          cssWidth: self.$imageLayerMarker.width(),
          cssHeight: self.$imageLayerMarker.height()
        };
      },
      getWatermarkInfo: function getWatermarkInfo() {
        return self.curFileInfo.get("watermarkInfo");
      },
      onCanvasRecreated: function onCanvasRecreated(newCanvas) {
        self.$imageLayerMarker = $(newCanvas);
      }
    });
  },
  setReadOnly: function setReadOnly() {},
  _dispOtherTextFile: function _dispOtherTextFile(data, callback) {
    var mode = this.curFileInfo.getCodeMirrorModeStr();
    this.$content.empty();
    this.mirrorEditor = CodeMirror(this.$content[0], (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({
      lineNumbers: true,
      lineWrapping: true,
      //是否强制换行
      mode: mode,
      autoCloseBrackets: true,
      matchBrackets: true
    }, "lineNumbers", true), "smartIndent", true), "showCursorWhenSelecting", true), "autofocus", true));
    if (callback) {
      callback();
    }
    this.doc = this.mirrorEditor.getDoc();
    this.doc.setValue(data);
    this.mirrorEditor.setOption("readOnly", true);
    var self = this;
    self.drawWaterMark();
    this.$content.find(".CodeMirror-scroll").off("scroll");
    this.$content.find(".CodeMirror-scroll").on("scroll", function (e) {
      if (self.scrollEvtTimeout) {
        clearTimeout(self.scrollEvtTimeout);
      }
      self.scrollEvtTimeout = setBabelTimeout(function () {
        Dispatcher.trigger(MDEvents.WindowScrolled);
        console.log("----------> codemirror elements count:", self.$content.find("*").length);
      }, 500);
    });
    console.log("----------> codemirror elements count:", this.$content.find("*").length);
  },
  encodeToType: function encodeToType(data, type) {
    if (data instanceof Uint8Array) {
      data = data.buffer;
    }
    var dataView = new DataView(data);
    // The TextDecoder interface is documented at http://encoding.spec.whatwg.org/#interface-textdecoder
    var decoder = new TextDecoder(type);
    var decodedString = decoder.decode(dataView);
    this.doc.setValue(decodedString);
    this.doc.markClean();
  },
  getCenterRatioPosition: function getCenterRatioPosition() {
    var center = {
      x: 0,
      y: 0
    };
    var container = this.$content[0];
    if (this.$content.find(".CodeMirror-scroll").length) {
      container = this.$content.find(".CodeMirror-scroll")[0];
    } else {}
    center.x = (container.scrollLeft + container.offsetWidth / 2) / container.scrollWidth;
    center.y = (container.scrollTop + container.offsetHeight / 2) / container.scrollHeight;
    console.log("----------- codemirror center:", center);
    return center;
  },
  getOriginData: function getOriginData() {
    return this.originData;
  },
  restoreCenterPostion: function restoreCenterPostion(ratioCenter) {
    var pos = {
      x: 0,
      y: 0
    };
    var container = this.$content[0];
    if (this.$content.find(".CodeMirror-scroll").length) {
      container = this.$content.find(".CodeMirror-scroll")[0];
    }
    pos.x = ratioCenter.x * container.scrollWidth - container.offsetWidth / 2;
    pos.y = ratioCenter.y * container.scrollHeight - container.offsetHeight / 2;
    container.scrollTop = pos.y;
    container.scrollLeft = pos.x;
  },
  getScale: function getScale() {
    return 1;
  },
  setScale: function setScale() {},
  changeScale: function changeScale(scale, callback) {
    if (callback) {
      callback();
    }
  },
  refreshSize: function refreshSize() {
    console.log("md refreshSize");
    // this.drawWaterMark()
  },
  closeCommentPanel: function closeCommentPanel() {},
  getCurrentFileInfo: function getCurrentFileInfo() {
    return this.curFileInfo;
  },
  removeFromSuperView: function removeFromSuperView() {
    if (this._watermarkOverlay) {
      this._watermarkOverlay.cleanup();
      this._watermarkOverlay = null;
    }
    if (!app.canDispInNormalBrowser()) {
      this.$content.off("click");
    }
    this.$content.find(".CodeMirror-scroll").off();
    this.$content.remove();
    this.$imageLayerMarker.remove();
  },
  // 以下是为了配合手机界面的接口
  getCurrentBoard: function getCurrentBoard() {
    return this.curFileInfo.getBoard();
  },
  getCurrentFilePageCount: function getCurrentFilePageCount() {
    return 1;
  },
  getCurrentFilePageIndex: function getCurrentFilePageIndex() {
    return 0;
  },
  getCurrentFileIndex: function getCurrentFileIndex() {
    return 0;
  },
  getClassName: function getClassName() {
    return "MDTextFileBrowser";
  },
  setCurOperation: function setCurOperation() {}
});
var _default = exports["default"] = MDTextFileBrowser;

},{"108":108,"1104":1104,"1180":1180,"1184":1184,"1411":1411,"1417":1417,"1423":1423,"1434":1434,"1451":1451,"1454":1454,"1463":1463,"1505":1505,"1506":1506,"1507":1507,"1508":1508,"1509":1509,"1510":1510,"1512":1512,"1513":1513,"1514":1514,"1516":1516,"1517":1517,"1518":1518,"1519":1519,"1520":1520,"1521":1521,"1522":1522,"1523":1523,"1524":1524,"1525":1525,"1526":1526,"1527":1527,"1528":1528,"1529":1529,"1530":1530,"1541":1541,"49":49,"72":72,"809":809,"812":812}],230:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1451);
require(1417);
require(1463);
var _MDVideoPlayerView = _interopRequireDefault(require(436));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MDLoadMaskView = _interopRequireDefault(require(49));
var _MDSnackbarView = _interopRequireDefault(require(72));
var MDMailDisplayView = function MDMailDisplayView(parentDiv, fileInfo) {
  this.$content = $('<div class="mail-page" style="position:absolute;width:100%;height:100%;top:0;overflow:auto"></div>');
  $(parentDiv).append(this.$content);
};
Object.assign(MDMailDisplayView.prototype, Object.prototype, {
  contstructor: MDMailDisplayView,
  openFile: function openFile(curFileInfo, version, callback) {
    _czc && _czc.push(["_trackEvent", "预览", "Mail", "", "", ""]);
    this.fileInfo = curFileInfo;
    var fileId = curFileInfo.getFileId();
    // let origin = document.location.origin;
    var isArchive = 0;
    if (app.ep && app.ep.isArchive()) {
      isArchive = 1;
    }
    var isShareApp = app.isShareApp ? 1 : 0;
    var url = "/email/previewEmail.do?fileId=" + fileId + "&isArchive=" + isArchive + "&isShareApp=" + isShareApp;
    if (isShareApp && fileId != app.pathRouter.getRootFileId()) {
      url += "&shareId=" + app.pathRouter.getRootFileId();
    }
    var mail = "<iframe src=\"".concat(url, "\" class=\"mail-page-iframe\" style=\"position:absolute;width:100%;height:100%;top:0;border:none;background-color: #fff;\"></iframe>");
    this.$content.append(mail);
    callback();
    // var self = this;
    // this.avPlayer = new MDVideoPlayerView({
    //   fileInfo: curFileInfo
    // });

    // this.curFileInfo = curFileInfo;
    // self.avPlayer.renderTo(self.$content)
    // MMCommonFun.getDocumentDispPath(fileId, version, function(realUrl) {
    //   self.avPlayer.openWithUrl(curFileInfo, realUrl, curFileInfo.getFileName());
    //   callback();
    // }, function(errorCode, errorMsg) {
    //   if (errorCode == 141) {
    //     MDSnackbarView.showStandardMsg(42);
    //   } else {
    //     MDSnackbarView.show(errorMsg);
    //   }

    // });
    $(".mail-page").find("iframe").load(function () {
      $(".mail-page").find("iframe").contents().find("body").on("mousemove", function (e) {
        // console.log('----------------- mouse moving!');
        Dispatcher.trigger(MDEvents.mailMouseMove);
      });
    });
  },
  getScale: function getScale() {
    return 1;
  },
  setScale: function setScale() {},
  refreshSize: function refreshSize() {},
  getClassName: function getClassName() {
    return "MDMailDisplayView";
  },
  closeCommentPanel: function closeCommentPanel() {},
  removeFromSuperView: function removeFromSuperView() {
    this.$content.remove();
  },
  // 以下是为了配合手机界面的接口
  getCurrentBoard: function getCurrentBoard() {
    return null;
  },
  getCurrentFileInfo: function getCurrentFileInfo() {
    return this.fileInfo;
  },
  getCurrentFilePageCount: function getCurrentFilePageCount() {
    return 1;
  },
  getCurrentFilePageIndex: function getCurrentFilePageIndex() {
    return 0;
  },
  getCurrentFileIndex: function getCurrentFileIndex() {
    return 0;
  }
});
var _default = exports["default"] = MDMailDisplayView;

},{"1104":1104,"1184":1184,"1417":1417,"1451":1451,"1454":1454,"1463":1463,"436":436,"49":49,"72":72,"812":812}],229:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1451);
require(1417);
require(1463);
require(1461);
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MEWatermarkOverlay = _interopRequireDefault(require(809));
var _MDLoadMaskView = _interopRequireDefault(require(49));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDInputFileNamePanel = _interopRequireDefault(require(1125));
var _xmindToJson = _interopRequireDefault(require(1149));
var MDKityMinderFileEditor = function MDKityMinderFileEditor(parentDiv) {
  this.$content = $("<div class=\"md-browser kityminder-body\" style=\"\">\n    <div class=\"kityminder-shower-app\"   ng-controller=\"MainShowController\">\n      <kityminder-editor on-init=\"initEditor(editor, minder)\"></kityminder-editor>\n    </div>\n  </div>");
  // ng-app="kityminderShower"

  $(parentDiv).append(this.$content);
  this.$imageLayerMarker = $("<canvas class='image-layer-marker editor-canvas-zone' style='position:absolute; width:100%;height: 100%; pointer-events:none; z-index:2'></canvas>");
  this.$content.append(this.$imageLayerMarker);
  if (!app.canDispInNormalBrowser()) {
    this.$content.on('click', function () {
      Dispatcher.trigger(MDEvents.TapOnWhiteSpaceInDoc);
    });
  }
  ;
};
Object.assign(MDKityMinderFileEditor.prototype, Object.prototype, {
  contstructor: MDKityMinderFileEditor,
  openFile: function openFile(curFileInfo, version, callback) {
    _czc && _czc.push(["_trackEvent", "预览", "MD", "", "", ""]);
    var fileId = curFileInfo.getFileId();
    this.curFileInfo = curFileInfo;
    this.fileName = curFileInfo.getFileName();
    var self = this;
    if (!self.editor) {
      var kityminderEditorIndex = self.getKityminderEditorIndex();
      self.appName = "kityminderShower" + kityminderEditorIndex;
      this.$content.find('.kityminder-shower-app').attr("ng-app", self.appName);
      angular.module(self.appName, ['kityminderEditor']).config(["configProvider", function (e) {
        // e.setLanguage('en'); // 假设支持设置语言
      }]).controller('MainShowController', ["$scope", function ($scope) {
        $scope.initEditor = function (editor, minder) {
          self.editor = editor;
          self.minder = minder;
          console.error('我是第一个');
        };
      }]);
      angular.bootstrap(this.$content.find('.kityminder-shower-app'), [self.appName]);
    }
    console.error('我是第二个');
    _MDLoadMaskView["default"].show();
    _MMCommonFun["default"].getDocumentDispPath(fileId, version, function (url, type, key) {
      _MMNetDiskDataController["default"].downLoadFileData(url, function (data) {
        // var decodedString = MMCommonFun.decodeFromUTF8Array(data);

        if (curFileInfo.getLowerCaseExt() == 'xmind') {
          var blob = new Blob([data]);
          var parse = new _xmindToJson["default"]();
          parse.xmindToJSON(blob).then(function (json) {
            console.error('xmind2json');
            console.log(json);
            self._dispkityMinderFile(json, callback);
          });

          // window.blob = blob
          // window.kityminder.data.getRegisterProtocol('xmind').decode(blob).then(function(c) {
          // self._dispkityMinderFile(c, callback)
          // }, function(e) {
          //   console.log(e)
          // })
        } else {
          var decodedString;
          // if(key) {
          decodedString = _MMCommonFun["default"].decodeFromUTF8Array(data);
          // } else {
          //   decodedString = MMCommonFun.decodeFromUTF8Array(data)
          // }
          self._dispkityMinderFile(decodedString, callback);
        }

        // console.log(decodedString);

        // self._dispkityMinderFile(decodedString, function(){
        //   MDLoadMaskView.remove();
        //   if (callback) {
        //     callback();
        //   };
        // })
      }, function () {
        _MDLoadMaskView["default"].remove();
      }, undefined, key);
    }, function (errorCode, msg) {
      _MDLoadMaskView["default"].remove();
      if (errorCode == 227) {
        _MDSnackbarView["default"].show(msg);
      } else {
        _MDSnackbarView["default"].show('[' + errorCode + ']' + BabelStr.str(5150) + '！');
      }
    });

    // MMCommonFun.getDownloadRealPath(fileId, version, function(path){

    // }, function(){
    //         MDLoadMaskView.remove();
    //       if (callback) {
    //         callback();
    //       };
    // })
  },
  _dispkityMinderFile: function _dispkityMinderFile(data, callback) {
    var self = this;
    this.$content.find('.kityminder-shower-app .tab-content .tab-pane').removeClass('active');
    this.$content.find('.kityminder-shower-app .tab-content .tab-pane').eq(2).addClass('active');
    if (_.isString(data)) {
      data = JSON.parse(data);
    }
    this.editor.minder.importJson(data);
    this.curFileInfo.set('kmFileData', data);
    if (callback) {
      callback();
    }
    ;
    this.drawWaterMark();
    _MDLoadMaskView["default"].remove();
    // self.$content.off('scroll');
    // self.$content.on('scroll', function(e){
    //   if (self.scrollEvtTimeout) {
    //     clearTimeout(self.scrollEvtTimeout);
    //   };
    //   self.scrollEvtTimeout = setBabelTimeout(function(){
    //     Dispatcher.trigger(MDEvents.WindowScrolled);
    //   }, 500)
    // })
  },
  drawWaterMark: function drawWaterMark() {
    var self = this;
    this._watermarkOverlay = _MEWatermarkOverlay["default"].createWatermarkOverlay({
      container: this.$content[0],
      existingCanvas: this.$imageLayerMarker[0],
      canvasClass: "image-layer-marker editor-canvas-zone",
      extraStyles: {
        width: "100%",
        height: "100%",
        zIndex: "2"
      },
      getSize: function getSize() {
        return {
          cssWidth: self.$imageLayerMarker.width(),
          cssHeight: self.$imageLayerMarker.height()
        };
      },
      getWatermarkInfo: function getWatermarkInfo() {
        return self.curFileInfo.get("watermarkInfo");
      },
      onCanvasRecreated: function onCanvasRecreated(newCanvas) {
        self.$imageLayerMarker = $(newCanvas);
      }
    });
  },
  getCenterRatioPosition: function getCenterRatioPosition() {
    var center = {
      x: 0,
      y: 0
    };
    var container = this.$content[0];
    if (this.$content.find('.CodeMirror-scroll').length) {
      container = this.$content.find('.CodeMirror-scroll')[0];
    } else {}
    center.x = (container.scrollLeft + container.offsetWidth / 2) / container.scrollWidth;
    center.y = (container.scrollTop + container.offsetHeight / 2) / container.scrollHeight;
    console.log('----------- codemirror center:', center);
    return center;
  },
  restoreCenterPostion: function restoreCenterPostion(ratioCenter) {
    var pos = {
      x: 0,
      y: 0
    };
    var container = this.$content[0];
    if (this.$content.find('.CodeMirror-scroll').length) {
      container = this.$content.find('.CodeMirror-scroll')[0];
    }
    pos.x = ratioCenter.x * container.scrollWidth - container.offsetWidth / 2;
    pos.y = ratioCenter.y * container.scrollHeight - container.offsetHeight / 2;
    container.scrollTop = pos.y;
    container.scrollLeft = pos.x;
  },
  getScale: function getScale() {
    return 1;
  },
  setScale: function setScale() {},
  changeScale: function changeScale(scale, callback) {
    if (callback) {
      callback();
    }
    ;
  },
  refreshSize: function refreshSize() {},
  closeCommentPanel: function closeCommentPanel() {},
  getCurrentFileInfo: function getCurrentFileInfo() {
    return this.curFileInfo;
  },
  removeFromSuperView: function removeFromSuperView() {
    if (this._watermarkOverlay) {
      this._watermarkOverlay.cleanup();
      this._watermarkOverlay = null;
    }
    if (!app.canDispInNormalBrowser()) {
      this.$content.off('click');
    }
    ;
    this.$content.find('.CodeMirror-scroll').off();
    this.$content.remove();
    this.$imageLayerMarker.remove();
  },
  // 以下是为了配合手机界面的接口
  getCurrentBoard: function getCurrentBoard() {
    return this.curFileInfo.getBoard();
  },
  getCurrentFilePageCount: function getCurrentFilePageCount() {
    return 1;
  },
  getKityminderEditorIndex: function getKityminderEditorIndex() {
    return window.kityminderEditorIndex++;
  },
  getCurrentFilePageIndex: function getCurrentFilePageIndex() {
    return 0;
  },
  getCurrentFileIndex: function getCurrentFileIndex() {
    return 0;
  },
  getClassName: function getClassName() {
    return 'MDKityMinderFileEditor';
  },
  setCurOperation: function setCurOperation() {}
});
window.kityminderEditorIndex = 0;
var _default = exports["default"] = MDKityMinderFileEditor;

},{"1104":1104,"1125":1125,"1149":1149,"1184":1184,"1417":1417,"1451":1451,"1454":1454,"1461":1461,"1463":1463,"49":49,"72":72,"809":809,"812":812}],222:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
var _MMPoint = _interopRequireDefault(require(830));
var _MDGraphDrawer = _interopRequireDefault(require(806));
var _MDLineWidthAndFont = _interopRequireDefault(require(861));
var _MDColorDisk = _interopRequireDefault(require(856));
var _MDHtmlCommentsController = _interopRequireDefault(require(221));
var _MDNew3DCommentInputView = _interopRequireDefault(require(15));
var _MDLoadMaskView = _interopRequireDefault(require(49));
// MDHtmlRender.js
//
// jiang
// 2017-8-31

//

var g_minMoveDistance = 10;
function MDHtmlRender(parentDiv, opt) {
  this.editorViewCtl = opt.editorViewCtl;
  this.parentDiv = parentDiv;
  this.curToolName = 'arrowComment'; // 可能的值: comment, arrowComment, rectComment, ellipseComment

  this.constructEditor();
  _czc && _czc.push(["_trackEvent", "预览", "HTML", "", "", ""]);
}
;
MDHtmlRender.prototype = function () {
  //----------------------------------------------------------------------------------------------------
  //       private function
  //----------------------------------------------------------------------------------------------------
  function _clearTouchlayerClass() {
    this.$touchLayer.removeClass('cursor-normal');
    this.$touchLayer.removeClass('cursor-hide');
    this.$touchLayer.removeClass('cursor-ruler');
  }

  //----------------------------------------------------------------------------------------------------
  //       public function
  //----------------------------------------------------------------------------------------------------
  return {
    contstructor: MDHtmlRender,
    constructEditor: function constructEditor() {
      var self = this;
      var parentDiv = this.parentDiv;
      this.containerId = "html-render";
      this.touchId = "3DTouchLayer";
      this.$editorLayer = $('<iframe sandbox="" id="' + this.containerId + '" style="position:absolute;width:100%;height:100%;top:0px;left:0px;background-color:white"><base href="http://enterprise.babel.cc:8080/htmlF" /></iframe>');
      this.$touchLayer = $('<div id="' + this.touchId + '" style="position:absolute;left:0px;top:0px;width:100%;height:100%;background-color:rgba(255,0,0,0.0);z-index:100">' + '<canvas style="position:absolute" class="obj-canvas"></canvas>' + '<canvas style="position:absolute" class="op-canvas"></canvas>' + '</div>');
      this.$css = $('<link rel="stylesheet" type="text/css" href="/css/html-comment.css">');
      $(this.parentDiv).append(this.$editorLayer);
      // $(this.parentDiv).append(this.$touchLayer);

      this.commentsCtl = new _MDHtmlCommentsController["default"](this.$touchLayer, this);
      if (app.currentUser.isAnonymous()) {
        this.$editorLayer.attr('sandbox', '');
      } else {
        this.$editorLayer.attr('sandbox', 'allow-same-origin allow-scripts');
      }
    },
    registerEvents: function registerEvents() {
      var self = this;
      this.$touchLayer.off();
      this.$touchLayer.on('mousedown', function (e) {
        self._mousedown(e);
      });
      this.$touchLayer.on('mousemove', function (e) {
        self._mousemove(e);
      });
      this.$touchLayer.on('mouseup', function (e) {
        self._mouseup(e);
      });
      this.$touchLayer.on('click', function (e) {
        self.clickOnTouchLayer(e);
      });
    },
    initWithHtmlFile: function initWithHtmlFile(curFileInfo, commentsFile, modelUrl, callback) {
      this.commentsFile = commentsFile;
      this.commentsCtl.setCommentsFile(commentsFile);
      this.curFileInfo = curFileInfo;
      this.$contentDoms = [];
      var self = this;
      this.htmlTop = 0;

      // MDLoadMaskView.show();
      //     MDLoadMaskView.remove();

      // modelUrl = 'https://help.aliyun.com/document_detail/44957.html'

      // modelUrl = '/test/out/index.html'

      this.$editorLayer.attr('src', modelUrl);
      this.$editorLayer.off('load');
      this.$editorLayer.load(function (e) {
        console.log('-------------> frame loaded');

        // 获得所有 dom 元素
        self.$contentDoms = $('*', self.$editorLayer.contents());

        // register click events
        self.$contentDoms.on('click', function (e) {
          console.log('>>>----------> clicked!');
        });

        // // register scroll event
        var f = self.$editorLayer[0].contentWindow;
        f.onscroll = function (e) {
          self.editorScrolled(e);
        };
        self.editorScrolled();

        // // get all the div
        // var childs = $('*', self.$editorLayer.contents());
        // console.log('div count:', childs.length);

        // add touch layer
        self.$touchLayer.remove();
        $('body', self.$editorLayer.contents()).append(self.$touchLayer);
        $('head', self.$editorLayer.contents()).append($(self.$css));
        var $html = $('html', self.$editorLayer.contents());
        console.log('---------------- html top:', $html[0].offsetTop);
        self.htmlTop = $html[0].offsetTop;
        self.registerEvents();
        self._createDispCommentsInFile();
      });
      if (callback) {
        callback();
      }
      ;
    },
    editorScrolled: function editorScrolled(e) {
      if (this.refreshTimeout) {
        clearTimeout(this.refreshTimeout);
      }
      ;
      var self = this;
      this.refreshTimeout = setBabelTimeout(function () {
        self.refreshObjsInEditor();
      }, 100);
    },
    getDomByIndex: function getDomByIndex(index) {
      return this.$contentDoms[index];
    },
    _getClientXY: function _getClientXY(e) {
      var x = e.clientX;
      var y = e.clientY - this.htmlTop;
      return new _MMPoint["default"](x, y);
    },
    // touch click events
    clickOnTouchLayer: function clickOnTouchLayer(e) {
      this.editorViewCtl.refreshCurrentMainEditor();
      if (this.lengthFromStart >= g_minMoveDistance) {
        return;
      }
      ;
      var self = this;
      if (this.commentCreationPanel) {
        this.commentsCtl.popTempCommentDiv();
        this.commentCreationPanel.removeFromSuperView();
        this.commentCreationPanel = null;
        return;
      }
      ;
      if (this.commentsCtl.clearCommentPanel()) {
        return;
      }
      ;
      this.collectDomRect();
      var $cover = this.$touchLayer;
      var p = this._getClientXY(e);
      var clickedCommentDiv = this.getClickCommentDiv(p.x, p.y);
      if (clickedCommentDiv) {
        console.log('------- click on comment!');
        clickedCommentDiv.clicked();
        return;
      }
      ;
      if (this.curToolName != "comment") {
        if (!app.canDispInNormalBrowser()) {
          Dispatcher.trigger(MDEvents.TapOnWhiteSpaceInDoc);
        }
        ;
        return;
      }
      ;

      // var p = MMCommonFun.convertPointBetweenElements($('body', this.$editorLayer.contents())[0], this.$touchLayer[0], {x:x, y:y});
      var domClicked = this.getDomInfoMouseOn(p.x, p.y);
      if (domClicked) {
        var rct = this.rects[domClicked.index];
        var dom = this.$contentDoms[domClicked.domIndex];
        domClicked.commentType = "comment";
        this.commentsCtl.createTempCommentDiv(this.$touchLayer, domClicked);

        // var $div = '<div style="position:absolute; left:' + rct.x + 'px; top:' + rct.y + 'px; width:' + rct.w + 'px; height:' + rct.h + 'px; border:1px solid yellow"></div>' ;
        // $cover.append($div);

        this._showCommentCreationPanel(p);
      }
      ;

      // this.drawMousePos(p);
    },
    // html show comment creation panel
    _showCommentCreationPanel: function _showCommentCreationPanel(pos) {
      var self = this;
      var p_root = MMCommonFun.convertPointBetweenElements($('.editor-content-panel')[0], $('.app-root')[0], {
        x: pos.x + 10,
        y: pos.y + 10
      });
      if (this.commentCreationPanel) {
        this.commentCreationPanel.removeFromSuperView();
      }
      ;
      this.commentCreationPanel = new _MDNew3DCommentInputView["default"]({
        editorViewCtl: this.editorViewCtl,
        v_pos: p_root,
        showVisibleScope: true,
        cancelFun: function cancelFun() {
          console.log('-------> cancel');
          self.commentsCtl.popTempCommentDiv();
          self.commentCreationPanel = null;
          self.refreshCanvas();
          self.commentsCtl.refreshDivs();
        },
        okFun: function okFun(text, atIds, visibleScope) {
          self.commentCreationPanel.showWaiting();
          self.commentsCtl.saveTempCommentDiv(text, atIds, visibleScope, function () {
            self.commentCreationPanel.removeWaitingShow();
            if (self.commentCreationPanel) {
              self.commentCreationPanel.removeFromSuperView();
            }
            ;
            self.commentCreationPanel = null;
            self.commentsCtl.refreshDivs();
          });
        }
      });
    },
    _mousedown: function _mousedown(e) {
      this.mouseDownCaptured = true;
      var p = this._getClientXY(e);
      this.startPt = {
        x: p.x,
        y: p.y
      };
      this.graphDrawer = new _MDGraphDrawer["default"](this.$touchLayer.find('.op-canvas')[0], this.curToolName);
      this.graphDrawer.mouseDown(p.x, p.y);
      this.lengthFromStart = 0;
    },
    // html touchlayer mousemove
    _mousemove: function _mousemove(e) {
      if (!this.mouseDownCaptured && !this.curToolName) {
        return;
      }
      ;
      var p = this._getClientXY(e);
      var c = this.$touchLayer.find('.op-canvas')[0];
      var ctx = c.getContext("2d");
      var cleared = false;
      var focusPoint = {
        x: p.x,
        y: p.y
      };
      if (this.graphDrawer) {
        focusPoint = this.graphDrawer.mouseMove(p.x, p.y);
        cleared = true;
        this.curRct = null;
      }
      ;
      var rctOn = this.getRectMouseOn(focusPoint.x, focusPoint.y);
      if (rctOn && this.curRct != rctOn) {
        !cleared && ctx.clearRect(0, 0, c.offsetWidth, c.offsetHeight);
        this.curRct = rctOn;
        ctx.strokeStyle = '#00ffff';
        var r = rctOn;
        ctx.strokeRect(r.x, r.y, r.w, r.h);
      }
      ;
    },
    // html touchlayer mouseup
    _mouseup: function _mouseup(e) {
      if (!this.mouseDownCaptured) {
        return;
      }
      ;
      var p = this._getClientXY(e);
      this.lengthFromStart = Math.sqrt((this.startPt.x - p.x) * (this.startPt.x - p.x) + (this.startPt.y - p.y) * (this.startPt.y - p.y));
      if (this.lengthFromStart < g_minMoveDistance) {
        this.mouseDownCaptured = false;
        this.graphDrawer = null;
        return;
      }
      ;
      if (this.mouseDownCaptured) {
        this._createComment(p.x, p.y);
      }
      ;
      this.mouseDownCaptured = false;
      var c = this.$touchLayer.find('.op-canvas')[0];
      var ctx = c.getContext("2d");
      ctx.clearRect(0, 0, c.offsetWidth, c.offsetHeight);
      this.curRct = null;
      this.graphDrawer = null;
    },
    _createComment: function _createComment(x, y) {
      if (this.curToolName == "arrowComment") {
        var posInfo1 = this.getDomInfoMouseOn(this.startPt.x, this.startPt.y);
        var posInfo2 = this.getDomInfoMouseOn(x, y);
        if (!posInfo1 || !posInfo2) {
          this.refreshTouchLayer();
          return;
        }
        ;
        var commentPosInfo = {
          commentType: "arrowComment",
          posInfo1: posInfo1,
          posInfo2: posInfo2
        };
        this.commentsCtl.createTempCommentDiv(this.$touchLayer, commentPosInfo);
        var mid = {
          x: (x + this.startPt.x) / 2,
          y: (y + this.startPt.y) / 2
        };
        this._showCommentCreationPanel(mid);
      } else if (this.curToolName == "rectComment" || this.curToolName == "ellipseComment") {
        var center = {
          x: (this.startPt.x + x) / 2,
          y: (this.startPt.y + y) / 2
        };
        var posInfo = this.getDomInfoMouseOn(center.x, center.y);
        if (!posInfo) {
          this.refreshTouchLayer();
          return;
        }
        ;
        var domRect = this.rects[posInfo.index];
        var graphType = 'rect';
        if (this.curToolName == "ellipseComment") {
          graphType = 'ellipse';
        }
        ;
        var commentPosInfo = {
          commentType: "rectComment",
          posInfo: posInfo,
          rectWidth: Math.abs(x - this.startPt.x) / domRect.w,
          rectHeight: Math.abs(y - this.startPt.y) / domRect.h,
          lineWidth: _MDLineWidthAndFont["default"].getGraphCommentLineWidth(),
          graphType: graphType
        };
        this.commentsCtl.createTempCommentDiv(this.$touchLayer, commentPosInfo);
        var topMid = {
          x: (x + this.startPt.x) / 2,
          y: this.startPt.y
        };
        this._showCommentCreationPanel(topMid);
      }
      ;
    },
    drawMousePos: function drawMousePos(pos) {
      var c = this.$touchLayer.find('.op-canvas')[0];
      var ctx = c.getContext("2d");
      ctx.strokeStyle = '#00ffff';
      ctx.clearRect(0, 0, c.offsetWidth, c.offsetHeight);
      this.refreshCanvas();
      ctx.beginPath();
      ctx.arc(pos.x, pos.y, 2, 0, 2 * Math.PI);
      ctx.stroke();
    },
    collectDomRect: function collectDomRect() {
      if (this.rects) {
        return;
      }
      ;
      this.rects = [];
      var $domInFrame = this.$contentDoms;
      var bodyInFrameIndex = 0;
      var touchDom = this.$touchLayer[0];
      for (var i = 0; i < $domInFrame.length; i++) {
        var dom = $domInFrame[i];
        if (dom.tagName == 'BODY') {
          bodyInFrameIndex = i;
          break;
        }
        ;
        console.log('---', dom.tagName);
      }
      for (var i = bodyInFrameIndex + 1; i < $domInFrame.length; i++) {
        var dom = $domInFrame[i];
        var p0 = {
          x: 0,
          y: 0
        };
        var p1 = {
          x: dom.offsetWidth,
          y: dom.offsetHeight
        };
        var p00 = MMCommonFun.convertPointBetweenElements(dom, touchDom, p0);
        var p11 = MMCommonFun.convertPointBetweenElements(dom, touchDom, p1);
        var rect = {
          x: p00.x,
          y: p00.y,
          w: p11.x - p00.x,
          h: p11.y - p00.y
        };
        this.rects.push(rect);
      }
      ;
      this.bodyInFrameIndex = bodyInFrameIndex;
    },
    // 搜索 frame dom 元素在 touchlayer 上的位置
    refreshCanvas: function refreshCanvas() {
      this.collectDomRect();
      var c = this.$touchLayer.find('.op-canvas')[0];
      var ctx = c.getContext("2d");
      ctx.strokeStyle = '#00ffff';
      ctx.clearRect(0, 0, c.offsetWidth, c.offsetHeight);
      var c = this.$touchLayer.find('.obj-canvas')[0];
      var ctx = c.getContext("2d");
      ctx.strokeStyle = '#00ffff';
      ctx.clearRect(0, 0, c.offsetWidth, c.offsetHeight);
      ctx.lineWidth = 2;
      var rects = this.rects;
      if (!rects) {
        return;
      }
      ;
      // for (var i = 0; i < rects.length; i++) {
      //   var r = rects[i];
      //   if (r.w > 0 && r.h > 0) {
      //     ctx.strokeRect(r.x,r.y,r.w,r.h);
      //   };
      // };

      // -------- test
      // MMCommonFun.drawArrow(ctx, 'blue', {x:0,y:0}, {x:500, y:500})
    },
    refreshTouchLayer: function refreshTouchLayer() {
      this.collectDomRect();
      var c = this.$touchLayer.find('.op-canvas')[0];
      var ctx = c.getContext("2d");
      ctx.strokeStyle = '#00ffff';
      ctx.clearRect(0, 0, c.offsetWidth, c.offsetHeight);
    },
    refreshSize: function refreshSize(e) {
      this.editorScrolled(e);
    },
    getDomInfoMouseOn: function getDomInfoMouseOn(x, y) {
      if (!this.rects) {
        return null;
      }
      ;
      var rects = this.rects;
      for (var i = rects.length - 1; i >= 0; i--) {
        if (x >= rects[i].x && y >= rects[i].y && x < rects[i].x + rects[i].w && y < rects[i].y + rects[i].h) {
          return {
            index: i,
            x: (x - rects[i].x) / rects[i].w,
            y: (y - rects[i].y) / rects[i].h,
            domIndex: i + this.bodyInFrameIndex + 1
          };
        }
      }
      ;
    },
    getRectMouseOn: function getRectMouseOn(x, y) {
      if (!this.rects) {
        return null;
      }
      ;
      var rects = this.rects;
      for (var i = rects.length - 1; i >= 0; i--) {
        if (x >= rects[i].x && y >= rects[i].y && x < rects[i].x + rects[i].w && y < rects[i].y + rects[i].h) {
          // console.log('---------------> rect index:', i, ', x:', x, ',y:', y, ',  rect.x:', rects[i].x, ', rect.y:', rects[i].y);
          return rects[i];
        }
      }
      ;
    },
    getClickCommentDiv: function getClickCommentDiv(x, y) {
      var touchDom = this.$touchLayer[0];
      var comment = null;
      var commentDivs = this.commentsCtl.commentDivs;
      for (var i = commentDivs.length - 1; i >= 0; i--) {
        if (commentDivs[i].isPtOn(touchDom, x, y)) {
          comment = commentDivs[i];
          break;
        }
      }
      ;
      return comment;
    },
    closeCommentPanel: function closeCommentPanel() {
      if (this.commentCreationPanel) {
        this.commentCreationPanel.removeFromSuperView();
      }
      ;
    },
    refreshObjsInEditor: function refreshObjsInEditor() {
      var self = this;
      var currentTarget = self.$editorLayer[0].contentWindow;
      var top = 0 - this.htmlTop;
      self.$touchLayer.css('top', currentTarget.pageYOffset + 'px');
      self.rects = null;
      self.$touchLayer.find('canvas').attr('left', '0px');
      self.$touchLayer.find('canvas').attr('top', top + 'px');
      self.$touchLayer.find('canvas').attr('width', self.$touchLayer[0].offsetWidth + 'px');
      self.$touchLayer.find('canvas').attr('height', self.$touchLayer[0].offsetHeight + 'px');
      self.refreshCanvas();
      self.commentsCtl.refreshDivs();
    },
    focusComment: function focusComment(comment) {
      // this.threeDisp.focusComment(comment);
    },
    enableMouseWheel: function enableMouseWheel(enable) {
      // this.threeDisp.enableMouseWheel(enable);
      // if (enable) {
      //   console.log('--- enabled');
      // };
    },
    toolChanged: function toolChanged(toolIndex) {
      _clearTouchlayerClass.call(this);
      switch (toolIndex) {
        case 0:
          this.threeDisp.setOperationType(OPERATION_3D_TYPE.comment);
          this.$touchLayer.addClass('cursor-normal');
          break;
        case 1:
          this.threeDisp.setOperationType(OPERATION_3D_TYPE.disassemble);
          this.$touchLayer.addClass('cursor-hide');
          break;
        case 2:
          this.threeDisp.setOperationType(OPERATION_3D_TYPE.measure);
          this.$touchLayer.addClass('cursor-ruler');
          break;
      }
    },
    restoreHomeView: function restoreHomeView() {
      // this.threeDisp.fitTheScreen();
    },
    removeFromSuperView: function removeFromSuperView() {
      if (this.loader) {
        this.loader.abort();
      }
      ;
      $(window).off('resize.html');
      this.removed = true;
      this.$editorLayer.remove();
      this.$touchLayer.remove();
      this.commentsCtl.clearMemory();
      var self = this;
      if (self.commentCreationPanel) {
        self.commentCreationPanel.removeFromSuperView();
        self.commentCreationPanel = null;
      }
      ;
    },
    allObjShowed: function allObjShowed() {},
    setCurOperation: function setCurOperation(toolName) {
      this.curToolName = toolName;
      // this.curToolName = "arrowComment"
      this.refreshTouchLayer();
    },
    getCurrentFilePageIndex: function getCurrentFilePageIndex() {
      return 0;
    },
    _createDispCommentsInFile: function _createDispCommentsInFile() {
      var self = this;
      if (this.commentsCtl) {
        this.commentsCtl.readCommentsFromFile(function () {
          self.commentsCtl.refreshDivs();
        });
      }
      ;
    },
    removeAllPanels: function removeAllPanels() {},
    getTouchLayerDiv: function getTouchLayerDiv() {
      return this.$touchLayer[0];
    },
    getClassName: function getClassName() {
      return 'MDHtmlRender';
    },
    scrollToShowObj: function scrollToShowObj(comment, callback) {
      var $bodyInFrame = $('body', this.$editorLayer.contents());
      var htmlPos = this.commentsCtl.getCommentDispPosInLayer(comment, $bodyInFrame[0]);
      var frameWin = this.$editorLayer[0].contentWindow;
      var left = htmlPos.leftTop.x - frameWin.innerWidth / 2;
      var top = htmlPos.leftTop.y - frameWin.innerHeight / 2;
      frameWin.scrollTo(left, top);
      if (callback) {
        setBabelTimeout(function () {
          callback();
        }, 250);
      }
      ;
    },
    getDivByObj: function getDivByObj(comment) {
      return this.commentsCtl.getCommentDiv(comment);
    },
    getCommentsDivs: function getCommentsDivs() {
      return this.commentsCtl.commentDivs;
    },
    openCommentPanel: function openCommentPanel(comment) {
      var commentDiv = this.getDivByObj(comment);
      if (commentDiv) {
        this.commentsCtl.clicked(commentDiv);
      }
      ;
    },
    getObjCanvas2DContext: function getObjCanvas2DContext() {
      var c = this.$touchLayer.find('.obj-canvas')[0];
      var ctx = c.getContext("2d");
      return ctx;
    },
    showCommentLayer: function showCommentLayer() {
      this.$touchLayer.show();
    },
    hideCommentLayer: function hideCommentLayer() {
      this.$touchLayer.hide();
    },
    getCurrentBoard: function getCurrentBoard() {
      return this.commentsFile;
    },
    getCurrentFilePageCount: function getCurrentFilePageCount() {
      return 1;
    },
    getCurrentFileInfo: function getCurrentFileInfo() {
      return this.curFileInfo;
    },
    getScale: function getScale() {
      return 1;
    },
    getCenterRatioPosition: function getCenterRatioPosition() {
      return {
        x: 0,
        y: 0
      };
    }
  };
}();
var _default = exports["default"] = MDHtmlRender;

},{"1184":1184,"1417":1417,"1454":1454,"1463":1463,"15":15,"221":221,"49":49,"806":806,"830":830,"856":856,"861":861}],221:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDRectHtmlCommentAppearance = _interopRequireDefault(require(224));
var _MDRectHtmlComment = _interopRequireDefault(require(223));
var _MDColorDisk = _interopRequireDefault(require(856));
var _MDArrowHtmlComment = _interopRequireDefault(require(216));
var _MDArrowHtmlCommentAppearance = _interopRequireDefault(require(217));
var _MDHtmlCommentDiv = _interopRequireDefault(require(220));
var _MDHtmlComment = _interopRequireDefault(require(219));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MDNewCommentsController = _interopRequireDefault(require(96));
var _MDCommentSlidePanelView = _interopRequireDefault(require(319));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
// MDHtmlCommentsController.js
//
// jiang
// 2016-8-26

function MDHtmlCommentsController($parentDiv, displayer) {
  _MDNewCommentsController["default"].call(this, $parentDiv, displayer);
}
;
MDHtmlCommentsController.id = 0;
MDHtmlCommentsController.createCommentsFromLocalStorage = function () {
  var count = localStorage["HtmlComment_num"];
  var comments = [];
  for (var i = 0; i < count; i++) {
    var comment = new MD3DComment();
    comment.readFromLocalStorage(i);
    comments.push(comment);
  }
  ;
  return comments;
};
MDHtmlCommentsController.saveCommentsToLocalStorage = function (comments) {
  localStorage["HtmlComment_num"] = comments.length;
  for (var i = 0; i < comments.length; i++) {
    var comment = comments[i];
    comment.saveToLocalStorage(i);
  }
  ;
};
_.extend(MDHtmlCommentsController.prototype, _MDNewCommentsController["default"].prototype, function () {
  // ------------------------------------------------------------------------  private function

  function _getCommentDvPos(comment, notCheck) {
    var dvPos = {
      x: comment.x * comment.hostDom.offsetWidth,
      y: comment.y * comment.hostDom.offsetHeight
    };
    dvPos = _MMCommonFun["default"].convertPointBetweenElements(comment.hostDom, this.$parentDiv[0], dvPos);
    return dvPos;
  }
  ;

  // function _createDivForComment(comment) {
  //   if (this.displayer) {
  //     var hostDom = this.displayer.getDomByIndex(comment.domIndex);
  //     comment.hostDom = hostDom;
  //     if (hostDom == null) {
  //       console.error('--------> cannot seek obj by id');
  //       return null;
  //     };
  //   };

  //   var domPos = $(hostDom).css('position');
  //   if (domPos != 'absolute' || domPos != 'relative') {
  //     $(hostDom).css('position', 'relative');
  //   };

  //   var div = null;
  //   if (hostDom) {
  //     var dvPos = _getCommentDvPos.call(this, comment);
  //     this.$parentDiv = $(hostDom);
  //     div = new MDHtmlCommentDiv(this, comment, this.$parentDiv, dvPos);

  //   };

  //   return div;
  // };
  function _createDivForComment(comment) {
    if (this.displayer) {
      var hostDom = this.displayer.getDomByIndex(comment.domIndex);
      comment.hostDom = hostDom;
      if (hostDom == null) {
        console.error('--------> cannot seek obj by id');
        return null;
      }
      ;
    }
    ;
    var div = null;
    if (hostDom) {
      if (comment.getClassName() == 'MDHtmlComment') {
        var dvPos = _getCommentDvPos.call(this, comment);
        div = new _MDHtmlCommentDiv["default"](this, comment, this.$parentDiv, dvPos);
      } else if (comment.getClassName() == 'MDArrowHtmlComment') {
        div = new _MDArrowHtmlCommentAppearance["default"](this, comment, this.$parentDiv, this.displayer);
      } else if (comment.getClassName() == 'MDRectHtmlComment') {
        div = new _MDRectHtmlCommentAppearance["default"](this, comment, this.$parentDiv, this.displayer);
      }
    }
    ;
    return div;
  }
  ;
  function _createComment(commentPosInfo) {
    var tempComment = null;
    if (commentPosInfo.commentType == "comment") {
      tempComment = new _MDHtmlComment["default"]();
      tempComment.domIndex = commentPosInfo.domIndex;
      tempComment.x = commentPosInfo.x;
      tempComment.y = commentPosInfo.y;
    } else if (commentPosInfo.commentType == "rectComment") {
      tempComment = new _MDRectHtmlComment["default"]();
      tempComment.initWithPosInfo(commentPosInfo);
    } else if (commentPosInfo.commentType == "arrowComment") {
      tempComment = new _MDArrowHtmlComment["default"]();
      tempComment.initWithPosInfo(commentPosInfo);
    }
    tempComment.setGraphColor(_MDColorDisk["default"].getCurColor());
    tempComment.setBoard(this.commentsFile);
    var curUserId = app.currentUser.getUserId_Int();
    tempComment.setCreator(curUserId);
    return tempComment;
  }
  ;

  // ---------------------------------------------------------------------------- public function
  return {
    constructor: MDHtmlCommentsController,
    createComment: function createComment(commentPosInfo) {
      return _createComment.call(this, commentPosInfo);
    },
    createDivForComment: function createDivForComment(comment) {
      return _createDivForComment.call(this, comment);
    },
    getCommentDvPos: function getCommentDvPos(comment) {
      return _getCommentDvPos.call(this, comment);
    },
    // html save html comment
    saveTempCommentDiv: function saveTempCommentDiv(text, atIds, visibleScope, callback) {
      console.assert(this.commentsFile);
      var self = this;
      if (this.tempCommentDiv) {
        _MDNewCommentsController["default"].prototype.saveTempCommentDiv.call(this, text, atIds, visibleScope, callback);
      }
      ;
    },
    clearMemory: function clearMemory() {
      this.scene = null;
      this.camera = null;
      _MDNewCommentsController["default"].prototype.clearMemory.call(this);
    },
    // show comment pannel
    clicked: function clicked(commentDivClicked) {
      _MDNewCommentsController["default"].prototype.clicked.call(this);
      if (this.tempCommentDiv == commentDivClicked) {
        return;
      }
      ;
      var self = this;
      if (this.commentPanel) {
        this.commentPanel.removeFromSuperView();
      }
      ;
      this.displayer.removeAllPanels();
      self.commentPanel = new _MDCommentSlidePanelView["default"]({
        editorViewCtl: this.editorViewCtl,
        view: self,
        comment: commentDivClicked.comment,
        enableDraggable: true,
        onDrag: function onDrag() {},
        onCloseBtnClicked: function onCloseBtnClicked() {
          self.commentPanel.removeFromSuperView();
        },
        onRemove: function onRemove() {
          self.commentPanel = null;
          commentDivClicked.focus(false);
        },
        onOpen: function onOpen() {}
      });

      // $('.p-editor-zone').append(self.commentPanel.$el);

      if (app.canDispInNormalBrowser()) {
        app.application.addSubView(self.commentPanel, this.editorViewCtl.getEditorZoneDiv());
        var posInBody = commentDivClicked.getDispPosInLayer(this.displayer.getTouchLayerDiv());
        var p_root = _MMCommonFun["default"].convertPointBetweenElements(this.editorViewCtl.getEditorContentPanelDiv(), this.editorViewCtl.getEditorRootDiv(), posInBody.leftTop);
        self.commentPanel.zoomShow({
          'x': p_root.x + 20,
          'y': p_root.y - 20
        }, function () {
          // MDPcMobileEditorCommonFun.getMainEditor().showCommentLine();
        });
      } else {
        app.application.addSubView(self.commentPanel);
        self.commentPanel.centerZoomShowForMobile({
          x: 500,
          y: 700
        });
      }

      // this._animateByPathrouter(commentDivClicked.comment, cameraPosArr);
    },
    clearCommentPanel: function clearCommentPanel() {
      if (this.commentPanel) {
        this.commentPanel.removeFromSuperView();
        // app.application.removeSubView(self.commentPanel);
        return true;
      }
      ;
      return false;
    },
    getCommentDispPosInLayer: function getCommentDispPosInLayer(comment, layer) {
      for (var i = this.commentDivs.length - 1; i >= 0; i--) {
        if (this.commentDivs[i].comment == comment) {
          return this.commentDivs[i].getDispPosInLayer(layer);
        }
      }
      ;
    },
    refreshDivs: function refreshDivs() {
      _MDNewCommentsController["default"].prototype.refreshDivs.call(this);
      for (var i = 0; i < this.commentDivs.length; i++) {
        this.commentDivs[i].refresh();
      }
      ;
    }
  };
}());
var _default = exports["default"] = MDHtmlCommentsController;

},{"1184":1184,"1454":1454,"216":216,"217":217,"219":219,"220":220,"223":223,"224":224,"319":319,"72":72,"807":807,"812":812,"856":856,"96":96}],224:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDColorDisk = _interopRequireDefault(require(856));
var _MDGraphDrawer = _interopRequireDefault(require(806));
var _MDHtmlCommentDiv = _interopRequireDefault(require(220));
// MDRectHtmlCommentAppearance.js
//
// jiang
// 2017-10-3

function MDRectHtmlCommentAppearance(commentCtl, comment, $parentDiv, displayer) {
  this.displayer = displayer;
  _MDHtmlCommentDiv["default"].call(this, commentCtl, comment, $parentDiv);
  this.refreshCss();
}
;
_.extend(MDRectHtmlCommentAppearance.prototype, _MDHtmlCommentDiv["default"].prototype, {
  constructor: MDRectHtmlCommentAppearance,
  refreshCss: function refreshCss() {
    _MDHtmlCommentDiv["default"].prototype.refreshCss.call(this);
  },
  getDispPosInLayer: function getDispPosInLayer(layer) {
    return _MDHtmlCommentDiv["default"].prototype.getDispPosInLayer.call(this, layer);
  },
  isPtOn: function isPtOn(layer, x, y) {
    return _MDHtmlCommentDiv["default"].prototype.isPtOn.call(this, layer, x, y);
  },
  // html comment refresh
  refresh: function refresh() {
    var rectDispInfo = this.getRectDispPoints();
    if (!rectDispInfo) {
      return;
    }
    ;
    var p1 = {
      x: rectDispInfo.center.x - rectDispInfo.size.w / 2,
      y: rectDispInfo.center.y - rectDispInfo.size.h / 2
    };
    var p2 = {
      x: rectDispInfo.center.x + rectDispInfo.size.w / 2,
      y: rectDispInfo.center.y + rectDispInfo.size.h / 2
    };
    if (_MDHtmlCommentDiv["default"].prototype.refresh.call(this)) {
      this._drawRect(p1, p2);
      return true;
    }
    return false;
  },
  getRectDispPoints: function getRectDispPoints() {
    if (!this.comment) {
      return;
    }
    ;
    var hostDom = this.displayer.getDomByIndex(this.comment.domIndex);
    var dvPos = {
      x: this.comment.x * hostDom.offsetWidth,
      y: this.comment.y * hostDom.offsetHeight
    };
    var size = {
      w: this.comment.rectWidth * hostDom.offsetWidth,
      h: this.comment.rectHeight * hostDom.offsetHeight
    };
    dvPos = MMCommonFun.convertPointBetweenElements(hostDom, this.$parentDiv[0], dvPos);
    var rectDispInfo = {
      center: dvPos,
      size: size
    };
    return rectDispInfo;
  },
  getCommentDispPos: function getCommentDispPos() {
    var rectDispInfo = this.getRectDispPoints();
    if (!rectDispInfo) {
      return;
    }
    ;
    var commentPos = {
      x: rectDispInfo.center.x - rectDispInfo.size.w / 2,
      y: rectDispInfo.center.y - rectDispInfo.size.h / 2
    };
    if (this.comment.graphType == "ellipse") {
      commentPos = {
        x: rectDispInfo.center.x - rectDispInfo.size.w / 2,
        y: rectDispInfo.center.y
      };
    }
    ;
    return commentPos;
  },
  _drawRect: function _drawRect(pos1, pos2) {
    var ctx = this.displayer.getObjCanvas2DContext();
    var borderColor = _MDColorDisk["default"].getGraphCommentBorderColor();
    var contentColor = _MDColorDisk["default"].getGraphCommentContentColor();
    if (this.comment.graphType == 'ellipse') {
      _MDGraphDrawer["default"].drawMultiBorderEllipse(ctx, borderColor, contentColor, this.comment.lineWidth, pos1, pos2);
    } else {
      _MDGraphDrawer["default"].drawMultiBorderRect(ctx, borderColor, contentColor, this.comment.lineWidth, pos1, pos2);
    }
  },
  clear: function clear() {
    _MDHtmlCommentDiv["default"].prototype.clear.call(this);
    this.displayer = null;
  }
});
var _default = exports["default"] = MDRectHtmlCommentAppearance;

},{"1184":1184,"1454":1454,"220":220,"806":806,"856":856}],217:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDColorDisk = _interopRequireDefault(require(856));
var _MDGraphDrawer = _interopRequireDefault(require(806));
var _MDHtmlCommentDiv = _interopRequireDefault(require(220));
// MDArrowHtmlCommentAppearance.js
//
// jiang
// 2017-10-2

function MDArrowHtmlCommentAppearance(commentCtl, comment, $parentDiv, displayer) {
  this.displayer = displayer;
  _MDHtmlCommentDiv["default"].call(this, commentCtl, comment, $parentDiv);
  this.refreshCss();
}
;
_.extend(MDArrowHtmlCommentAppearance.prototype, _MDHtmlCommentDiv["default"].prototype, {
  constructor: MDArrowHtmlCommentAppearance,
  refreshCss: function refreshCss() {
    _MDHtmlCommentDiv["default"].prototype.refreshCss.call(this);
  },
  getDispPosInLayer: function getDispPosInLayer(layer) {
    return _MDHtmlCommentDiv["default"].prototype.getDispPosInLayer.call(this, layer);
  },
  isPtOn: function isPtOn(layer, x, y) {
    return _MDHtmlCommentDiv["default"].prototype.isPtOn.call(this, layer, x, y);
  },
  // html comment refresh
  refresh: function refresh() {
    var pts = this.getArrowDispPoints();
    if (!pts || pts.length < 2) {
      return;
    }
    ;
    if (_MDHtmlCommentDiv["default"].prototype.refresh.call(this)) {
      this._drawArrow(pts[0], pts[1]);
      return true;
    }
    return false;
  },
  getArrowDispPoints: function getArrowDispPoints() {
    if (!this.comment) {
      return;
    }
    ;
    var hostDom = this.displayer.getDomByIndex(this.comment.domIndex);
    var hostDom2 = this.displayer.getDomByIndex(this.comment.domIndex2);
    if (!hostDom || !hostDom2) {
      return [];
    }
    ;
    var dvPos = {
      x: this.comment.x * hostDom.offsetWidth,
      y: this.comment.y * hostDom.offsetHeight
    };
    var dvPos2 = {
      x: this.comment.x2 * hostDom2.offsetWidth,
      y: this.comment.y2 * hostDom2.offsetHeight
    };
    dvPos = MMCommonFun.convertPointBetweenElements(hostDom, this.$parentDiv[0], dvPos);
    dvPos2 = MMCommonFun.convertPointBetweenElements(hostDom2, this.$parentDiv[0], dvPos2);
    return [dvPos, dvPos2];
  },
  getCommentDispPos: function getCommentDispPos() {
    var pts = this.getArrowDispPoints();
    if (!pts || pts.length < 2) {
      return;
    }
    ;

    // var commentPos = {
    //   x: (pts[0].x + pts[1].x) / 2,
    //   y: (pts[0].y + pts[1].y) / 2
    // }
    var commentPos = {
      x: pts[0].x,
      y: pts[0].y
    };
    return commentPos;
  },
  _drawArrow: function _drawArrow(pos1, pos2) {
    var ctx = this.displayer.getObjCanvas2DContext();
    var borderColor = _MDColorDisk["default"].getGraphCommentBorderColor();
    var contentColor = _MDColorDisk["default"].getGraphCommentContentColor();
    _MDGraphDrawer["default"].drawArrow(ctx, borderColor, contentColor, pos1, pos2);
  },
  clear: function clear() {
    _MDHtmlCommentDiv["default"].prototype.clear.call(this);
    this.displayer = null;
  }
});
var _default = exports["default"] = MDArrowHtmlCommentAppearance;

},{"1184":1184,"1454":1454,"220":220,"806":806,"856":856}],806:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1414);
var _MDLineWidthAndFont = _interopRequireDefault(require(861));
var _MDColorDisk = _interopRequireDefault(require(856));
var _vec = _interopRequireDefault(require(839));
// graph drawer
//
// jiang
// 2017-10-4

var MDGraphDrawer = function MDGraphDrawer(canvas, graphName) {
  this.canvas = canvas;
  this.curToolName = graphName;
};
MDGraphDrawer.prototype = {
  mouseDown: function mouseDown(x, y) {
    this.startPt = {
      x: x,
      y: y
    };
  },
  mouseMove: function mouseMove(x, y) {
    var c = this.canvas;
    var ctx = c.getContext("2d");
    var focusPoint = {
      x: x,
      y: y
    };
    var borderColor = _MDColorDisk["default"].getGraphCommentBorderColor();
    var contentColor = _MDColorDisk["default"].getGraphCommentContentColor();
    if (this.curToolName == "arrowComment") {
      ctx.clearRect(0, 0, c.offsetWidth, c.offsetHeight);
      MDGraphDrawer.drawArrow(ctx, borderColor, contentColor, this.startPt, {
        x: x,
        y: y
      });
    } else if (this.curToolName == "rectComment" || this.curToolName == "ellipseComment") {
      // 取中心点
      focusPoint.x = (this.startPt.x + x) / 2;
      focusPoint.y = (this.startPt.y + y) / 2;
      ctx.clearRect(0, 0, c.offsetWidth, c.offsetHeight);
      if (this.curToolName == "ellipseComment") {
        MDGraphDrawer.drawMultiBorderEllipse(ctx, borderColor, contentColor, _MDLineWidthAndFont["default"].getGraphCommentLineWidth(), this.startPt, {
          x: x,
          y: y
        });
      } else {
        MDGraphDrawer.drawMultiBorderRect(ctx, borderColor, contentColor, _MDLineWidthAndFont["default"].getGraphCommentLineWidth(), this.startPt, {
          x: x,
          y: y
        });
      }
      MDGraphDrawer.drawCross(ctx, borderColor, focusPoint);
    }
    ;
    return focusPoint;
  }
};
MDGraphDrawer.drawArrow = function (ctx, color, fillColor, p1, p2) {
  var v = new _vec["default"](p2.x - p1.x, p2.y - p1.y);
  var xAxis = new _vec["default"](1, 0);
  var angleV = v.angleBetweenVector(xAxis);
  var vXAxis = v.rotate(angleV);
  var arrowL = vXAxis.x;
  var arrowHeadW = Math.sqrt(arrowL / 2);
  var maxHeadW = 60;
  if (arrowHeadW > maxHeadW) {
    arrowHeadW = maxHeadW;
  }
  ;

  //
  //             (2*)
  //           _ (1*)  \
  //  (0*)  -      | -w-(*3)
  //          -  (5*)  /
  //             (4*)
  //

  var pts = [];
  pts[0] = new _vec["default"](0, 0);
  pts[1] = new _vec["default"](arrowL - arrowHeadW, arrowHeadW / 2);
  pts[2] = new _vec["default"](arrowL - arrowHeadW, arrowHeadW);
  pts[3] = new _vec["default"](arrowL, 0);
  pts[4] = new _vec["default"](arrowL - arrowHeadW, -arrowHeadW);
  pts[5] = new _vec["default"](arrowL - arrowHeadW, -arrowHeadW / 2);
  for (var i = 0; i < pts.length; i++) {
    pts[i].rotate(-angleV);
    pts[i].add(p1);
  }
  ;
  ctx.lineJoin = "round";
  ctx.lineCap = "round";
  ctx.beginPath();
  ctx.moveTo(pts[0].x, pts[0].y);
  for (var i = 1; i < pts.length; i++) {
    ctx.lineTo(pts[i].x, pts[i].y);
  }
  ;
  ctx.closePath();
  ctx.fillStyle = fillColor;
  ctx.fill();
  if (color == fillColor) {
    ctx.strokeStyle = 'white';
    ctx.lineWidth = 1;
    ctx.stroke();
  } else {
    ctx.strokeStyle = 'white';
    ctx.lineWidth = 4;
    ctx.stroke();
    ctx.strokeStyle = color;
    ctx.lineWidth = 2;
    ctx.stroke();
  }
};
MDGraphDrawer.drawMultiBorderRect = function (ctx, color, fillColor, lineWidth, p1, p2) {
  ctx.strokeStyle = 'white';
  ctx.lineWidth = lineWidth + 2;
  ctx.strokeRect(p1.x, p1.y, p2.x - p1.x, p2.y - p1.y);
  ctx.strokeStyle = color;
  ctx.lineWidth = lineWidth;
  ctx.strokeRect(p1.x, p1.y, p2.x - p1.x, p2.y - p1.y);
  ctx.fillStyle = fillColor;
  ctx.fillRect(p1.x, p1.y, p2.x - p1.x, p2.y - p1.y);
};
MDGraphDrawer.drawCross = function (ctx, color, center) {
  MDGraphDrawer.drawSingleCross(ctx, 3, 'white', center);
  MDGraphDrawer.drawSingleCross(ctx, 1, color, center);
};
MDGraphDrawer.drawSingleCross = function (ctx, lineWidth, color, center) {
  var c = center;
  ctx.strokeStyle = color;
  ctx.lineWidth = lineWidth;
  var r = 5;
  ctx.beginPath();
  ctx.moveTo(c.x - 5, c.y);
  ctx.lineTo(c.x + 5, c.y);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(c.x, c.y - 5);
  ctx.lineTo(c.x, c.y + 5);
  ctx.stroke();
};
MDGraphDrawer.drawMultiBorderEllipse = function (ctx, color, fillColor, lineWidth, p1, p2) {
  var x = Math.min(p1.x, p2.x),
    y = Math.min(p1.y, p2.y),
    w = Math.abs(p1.x - p2.x),
    h = Math.abs(p1.y - p2.y);
  MDGraphDrawer.drawEllipse(ctx, 'white', null, lineWidth + 2, x, y, w, h);
  MDGraphDrawer.drawEllipse(ctx, color, fillColor, lineWidth, x, y, w, h);
};
MDGraphDrawer.drawEllipse = function (ctx, color, fillColor, lineWidth, x, y, w, h) {
  ctx.strokeStyle = color;
  ctx.lineWidth = lineWidth;
  var kappa = .5522848,
    ox = w / 2 * kappa,
    // control point offset horizontal
    oy = h / 2 * kappa,
    // control point offset vertical
    xe = x + w,
    // x-end
    ye = y + h,
    // y-end
    xm = x + w / 2,
    // x-middle
    ym = y + h / 2; // y-middle

  ctx.beginPath();
  ctx.moveTo(x, ym);
  ctx.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
  ctx.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
  ctx.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
  ctx.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
  ctx.stroke();
  if (fillColor) {
    ctx.fillStyle = fillColor;
    ctx.fill();
  }
  ;
};
var _default = exports["default"] = MDGraphDrawer;

},{"1184":1184,"1414":1414,"1454":1454,"839":839,"856":856,"861":861}],220:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1465);
var _MDNewCommentDiv = _interopRequireDefault(require(95));
// MDHtmlCommentDiv.js
//
// jiang
// 2017-9-7

function MDHtmlCommentDiv(commentCtl, comment, $parentDiv, dvPos) {
  _MDNewCommentDiv["default"].call(this, commentCtl, comment, $parentDiv, dvPos);
  this.refreshCss();
}
;
_.extend(MDHtmlCommentDiv.prototype, _MDNewCommentDiv["default"].prototype, {
  constructor: MDHtmlCommentDiv,
  refreshCss: function refreshCss() {
    // this.$mark.css({
    // 	'width': '24px',
    // 	'height': '24px',
    // 	'position': 'absolute',
    //     'border': 'none'
    // });

    // this.$mark.find('.comment-mark').css({
    //   'background-color': 'rgb(250, 20, 83)',
    //   'border-width': '2px',
    //   'width': '100%',
    //   'height': '100%',
    //   'position': 'absolute',
    //   'border-radius': '50%',
    //   'border-color': 'white',
    //   'border-style': 'solid',
    //   'text-align': 'center',
    //   'vertical-align': 'middle',
    //   'color': 'white',
    //   'font-size': '12px',
    //   'line-height': '20px',
    //   'cursor': 'pointer',
    // })
    // this.$mark.find('.unread-mark-root').css({
    // 'visibility': 'hidden',
    //   'position': 'absolute',
    //   'cursor': 'pointer',
    //   'width': '100%',
    //   'height': '100%',
    // })
    // this.$mark.find('.unread-mark').css({
    //     'position':' absolute',
    //     'width':' 6px',
    //     'height':' 6px',
    //     'border-radius':' 50%',
    //     'background-color': '#63FB05',
    //     'left':' 9px',
    //     'top': '-2px',
    // })

    // if (this.$mark.hasClass('ent-comment')) {
    // 	this.$mark.find('.comment-mark').css('background-color', 'blue');
    // };
    // if (this.$mark.hasClass('pri-comment')) {
    // 	this.$mark.find('.comment-mark').css('background-color', '#696B6F');
    // };
  },
  getDispPosInLayer: function getDispPosInLayer(layer) {
    var dispDiv = this.$mark.find('.comment-mark')[0];
    if (dispDiv) {
      var dispPos = {
        leftTop: null,
        width: dispDiv.offsetWidth,
        height: dispDiv.offsetHeight
      };
      dispPos.leftTop = MMCommonFun.convertPointBetweenElements(dispDiv, layer, {
        x: 0,
        y: 0
      });
      return dispPos;
    }
    ;
  },
  isPtOn: function isPtOn(layer, x, y) {
    var dispPos = this.getDispPosInLayer(layer);
    if (dispPos) {
      if (x >= dispPos.leftTop.x && x <= dispPos.leftTop.x + dispPos.width) {
        if (y >= dispPos.leftTop.y && y <= dispPos.leftTop.y + dispPos.height) {
          return true;
        }
        ;
      }
      ;
    }
    ;
    return false;
  },
  getCommentDispPos: function getCommentDispPos() {
    if (!this.comment.hostDom) {
      return;
    }
    ;
    var dvPos = {
      x: this.comment.x * this.comment.hostDom.offsetWidth,
      y: this.comment.y * this.comment.hostDom.offsetHeight
    };
    dvPos = MMCommonFun.convertPointBetweenElements(this.comment.hostDom, this.$parentDiv[0], dvPos);
    return dvPos;
  },
  // html comment refresh
  refresh: function refresh() {
    var dvPos = this.getCommentDispPos();
    this.$mark.show();
    dvPos.x = Math.floor(dvPos.x - (this.$mark[0].offsetWidth + 4) / 2);
    dvPos.y = Math.floor(dvPos.y - (this.$mark[0].offsetHeight + 4) / 2);
    var curPos = {
      left: parseFloat(this.$mark.css('left')),
      top: parseFloat(this.$mark.css('top'))
    };
    if (Math.abs(curPos.left - dvPos.x) > 0.001 || Math.abs(curPos.top - dvPos.y) > 0.001) {
      this.$mark.css('left', dvPos.x + 'px');
      this.$mark.css('top', dvPos.y + 'px');
    }
    ;
    this.dvPos = {
      x: dvPos.x,
      y: dvPos.y
    };
    this.updateStatus();
    return _MDNewCommentDiv["default"].prototype.refresh.call(this, dvPos);
  },
  clear: function clear() {
    _MDNewCommentDiv["default"].prototype.clear.call(this);
  }
});
var _default = exports["default"] = MDHtmlCommentDiv;

},{"1184":1184,"1417":1417,"1454":1454,"1463":1463,"1465":1465,"95":95}],96:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1432);
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MMObject = _interopRequireDefault(require(1081));
// MDNewCommentsController.js
//
// jiang
// 2017-9-6

function MDNewCommentsController($parentDiv, displayer) {
  this.editorViewCtl = displayer.editorViewCtl;
  this.displayer = displayer;
  this.$parentDiv = $parentDiv;
  this.commentDivs = [];
  this.commentsFile = null;
  var self = this;
  Dispatcher.on(MDEvents.NEW_MESSAGE, function (payload) {
    self.onCommentStatusChanged(payload.comment);
  });
}
;
MDNewCommentsController.id = 0;
MDNewCommentsController.prototype = function () {
  // ---------------------------------------------------------------------------- public function
  return {
    constructor: MDNewCommentsController,
    createComment: function createComment(commentPosInfo) {
      return null;
    },
    createDivForComment: function createDivForComment(comment) {
      return null;
    },
    getCommentDvPos: function getCommentDvPos(comment) {
      return null;
    },
    createTempCommentDiv: function createTempCommentDiv($parentDiv, commentPosInfo) {
      var _this = this;
      this.$parentDiv = $parentDiv;
      this.popTempCommentDiv();
      var fileInfo = this.editorViewCtl.getCurrentFileInfo();
      var version = this.editorViewCtl.getVersionShowing();
      fileInfo.getEvalFlowInfo(version, function (evalFlow) {
        var tempComment = _this.createComment(commentPosInfo);
        _this.evalFlow = evalFlow;
        if (evalFlow) {
          _this.isInEval = true;
          if (!evalFlow.isCurUserCreator()) {
            tempComment.setVisibleScope(_MMObject["default"].SCOPE.IN_EVAL);
          }
        }
        _this.tempCommentDiv = _this.createDivForComment(tempComment);
        _this.commentDivs.push(_this.tempCommentDiv);
      });
    },
    setCommentsFile: function setCommentsFile(commentsFile) {
      if (this.commentsFile != commentsFile) {
        this.clearAllDispComments();
        if (this.commentsFile) {
          this.commentsFile.clearMemory();
        }
        ;
        this.commentsFile = commentsFile;
        this.commentsFile.set3DCommentsCtl(this);
      }
      ;
    },
    readCommentsFromFile: function readCommentsFromFile(callback) {
      this.clearAllDispComments();
      var self = this;
      if (this.commentsFile) {
        this.commentsFile.getDisplayComments(function (comments) {
          for (var i = 0; i < comments.length; i++) {
            var comment = comments[i];
            var div = self.createDivForComment(comment);
            if (div) {
              self.commentDivs.push(div);
            }
            ;
          }
          ;
          if (callback) {
            callback();
          }
          ;
        });
      }
      ;
    },
    clearAllDispComments: function clearAllDispComments() {
      if (!this.commentDivs) {
        return;
      }
      ;
      this.tempCommentDiv = null;
      for (var i = 0; i < this.commentDivs.length; i++) {
        var div = this.commentDivs[i];
        div.removeFromSuperView();
      }
      ;
      this.commentDivs = [];
    },
    refreshDivs: function refreshDivs() {
      if (!this.commentDivs) {
        return;
      }
      ;
      var orders = {
        0: 0,
        1: 0,
        2: 0,
        8: 0
      };
      for (var i = 0; i < this.commentDivs.length; i++) {
        var commentDiv = this.commentDivs[i];
        var visibleScope = commentDiv.comment.getVisibleScope();
        orders[visibleScope]++;
        commentDiv.setOrder(orders[visibleScope]);
        var dvPos = this.getCommentDvPos(commentDiv.comment);
        commentDiv.refresh(dvPos);
      }
      ;
    },
    popTempCommentDiv: function popTempCommentDiv() {
      if (this.tempCommentDiv) {
        this.tempCommentDiv.removeFromSuperView();
        this.commentDivs.pop();
        this.tempCommentDiv = null;
      }
      ;
    },
    saveTempCommentDiv: function saveTempCommentDiv(text, atIds, visibleScope, callback) {
      console.assert(this.commentsFile);
      var self = this;
      if (this.tempCommentDiv) {
        this.tempCommentDiv.comment.setVisibleScope(visibleScope);
        var commentDiv = this.tempCommentDiv;
        var ver = this.editorViewCtl.getVersionShowing();
        this.commentsFile.addComment(this.tempCommentDiv.comment, text, atIds, ver, function success() {
          if (visibleScope < 8) {
            _MDSnackbarView["default"].showStandardMsg('commentCreated');
          } else {
            _MDSnackbarView["default"].showStandardMsg('evalOpiCreated');
          }
          if (callback) {
            callback();
          }
          ;
        }, function fail(phase) {
          if (callback) {
            callback();
          }
          ;
          if (phase == 1) {
            self.onCommentDeleted(commentDiv.comment);
          }
          ;
          if (visibleScope < 8) {
            _MDSnackbarView["default"].showStandardMsg('commentFailed');
          } else {
            _MDSnackbarView["default"].showStandardMsg('opFailed');
          }
        });
        this.tempCommentDiv = null;
      }
      ;
    },
    clearMemory: function clearMemory() {
      Dispatcher.off(MDEvents.NEW_MESSAGE);
      this.clearAllDispComments();
      if (this.commentsFile) {
        this.commentsFile.clearMemory();
      }
      ;
      this.removeCommentPanel();
    },
    clicked: function clicked(commentDivClicked) {
      // this._animateByPathrouter(commentDivClicked.comment, cameraPosArr);
      this.editorViewCtl.refreshCurrentMainEditor();
    },
    removeCommentPanel: function removeCommentPanel() {
      var hasPanel = false;
      if (this.commentPanel) {
        hasPanel = true;
        this.commentPanel.removeFromSuperView();
      }
      ;
      this.commentPanel = null;
      return hasPanel;
    },
    onCommentCreated: function onCommentCreated(comment) {
      var found = false;
      for (var i = 0; i < this.commentDivs.length; i++) {
        var div = this.commentDivs[i];
        if (div.comment == comment) {
          found = true;
          break;
        }
        ;
      }
      ;
      if (!found) {
        var div = this.createDivForComment(comment);
        if (div) {
          this.commentDivs.push(div);
          this.refreshDivs();
        }
        ;
      }
      ;
    },
    onCommentDeleted: function onCommentDeleted(comment) {
      for (var i = 0; i < this.commentDivs.length; i++) {
        var div = this.commentDivs[i];
        if (div.comment == comment || div.comment.getId() == comment) {
          div.removeFromSuperView();
          div.comment.clearMemory();
          this.commentDivs.splice(i, 1);
          break;
        }
        ;
      }
      ;
    },
    onCommentStatusChanged: function onCommentStatusChanged(comment) {
      for (var i = 0; i < this.commentDivs.length; i++) {
        var div = this.commentDivs[i];
        if (div.comment == comment) {
          // todo
          this.commentDivs[i].updateStatus();
          break;
        }
        ;
      }
      ;
    },
    focusComment: function focusComment(comment) {
      for (var i = 0; i < this.commentDivs.length; i++) {
        var div = this.commentDivs[i];
        if (div.comment == comment) {
          this.clicked(div);
          return;
        }
        ;
      }
      ;
    },
    getCommentDiv: function getCommentDiv(comment) {
      for (var i = 0; i < this.commentDivs.length; i++) {
        if (this.commentDivs[i].comment == comment) {
          return this.commentDivs[i];
        }
      }
      ;
    }
  };
}();
var _default = exports["default"] = MDNewCommentsController;

},{"1081":1081,"1184":1184,"1432":1432,"1454":1454,"72":72}],112:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1451);
require(1423);
require(1463);
require(1487);
require(1538);
require(1545);
require(1543);
require(1417);
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MEWatermarkOverlay = _interopRequireDefault(require(809));
var _MDLoadMaskView = _interopRequireDefault(require(49));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDInputFileNamePanel = _interopRequireDefault(require(1125));
var _xmindToJson = _interopRequireDefault(require(1149));
var _drawio = _interopRequireDefault(require(114));
var MDDrawioEditor = function MDDrawioEditor(parentDiv) {
  this.$content = $("<div class=\"drawio-panel flex-align middle center\" style=\"overflow:auto\">\n  </div>");
  // ng-app="kityminderShower"
  $(parentDiv).append(this.$content);
  this.$imageLayerMarker = $("<canvas class='image-layer-marker editor-canvas-zone' style='position:absolute; width:100%;height: 100%; pointer-events:none; z-index:2'></canvas>");
  this.$content.append(this.$imageLayerMarker);
  this.$content.on("mousemove", function (e) {
    Dispatcher.trigger(MDEvents.DISPLAY_ZOOM_BAR);
  });
};
Object.assign(MDDrawioEditor.prototype, Object.prototype, {
  contstructor: MDDrawioEditor,
  openFile: function openFile(curFileInfo, version, callback) {
    // initPanel.call(this);
    _czc && _czc.push(["_trackEvent", "预览", "drawio", "", "", ""]);
    var fileId = curFileInfo.getFileId();
    this.curFileInfo = curFileInfo;
    this.fileName = curFileInfo.getFileName();

    // var path = '/readme.md';//MMCommonFun.getDocumentDispPath(fileId, version, callback);
    var self = this;
    _MDLoadMaskView["default"].show();
    this.isVsdx = curFileInfo.isVsdx();
    this.isDrawio = curFileInfo.isDrawio();
    if (this.isDrawio && this.url) {
      this.initDrawio();
      return;
    }
    _MMCommonFun["default"].getDownloadRealPath(fileId, version, function (url) {
      self.url = url;
      MDDrawioEditor.url = url;
      // self.initDrawio()
      _MDLoadMaskView["default"].remove();
      if (self.isDrawio && self.url) {
        self.initDrawio();
        if (callback) {
          callback();
        }
        ;
        return;
      }
      var xhr = new XMLHttpRequest();
      xhr.open("GET", self.url, true);
      xhr.responseType = "blob";
      xhr.onload = function () {
        // 创建一个Blob URL
        var blob = new Blob([xhr.response], {
          type: 'image/svg+xml'
        });
        var url = URL.createObjectURL(blob);

        // 创建一个<object>元素来显示SVG
        var svgObject = document.createElement('object');
        svgObject.type = 'image/svg+xml';
        svgObject.data = url; // 设置data属性为Blob URL

        // 将<object>元素添加到页面中
        self.$content.find('object').remove();
        self.$content.append(svgObject);
        if (callback) {
          callback();
        }
        ;
        self.drawWaterMark();

        // 注意：当你不再需要这个URL时，应该释放它
        // URL.revokeObjectURL(svgUrl); // 在适当的时候调用以释放内存
      };
      xhr.send();
    }, function (errorCode, msg) {
      _MDLoadMaskView["default"].remove();
      if (errorCode == 227) {
        _MDSnackbarView["default"].show(msg);
      } else {
        _MDSnackbarView["default"].show('[' + errorCode + ']' + BabelStr.str(5150) + '！');
      }
    });
  },
  // drawioClosed: function(event) {
  //   MDDrawioEditorController.removeFromSuperview();
  //   window.openDrawio = null
  //   console.log(event)
  // },
  // drawioImageCreated: function(evt) {
  //   console.log(evt)
  //   const { imageType, imageContent } = evt;
  //   switch (imageType) {
  //     case "png":
  //       console.log("base64 格式的 png 图片信息", imageContent);
  //       break;
  //     case "svg":
  //       MDDrawioEditorController.newSvgData = imageContent
  //       saveFile.call(MDDrawioEditorController);
  //       break;
  //   }
  // },

  initDrawio: function initDrawio() {
    var t = window.appVersion;
    var lan = BabelStr.getCurrentLanguage();
    if (lan == 'cn') {
      lan = "zh";
    }
    var openDrawio = (0, _drawio["default"])(window.drawioServerUrl + '/draw?hold=1&t=' + t + "lang=" + lan, {
      container: this.$content[0],
      fileName: this.fileName || "",
      type: this.isVsdx ? "vsdx" : undefined,
      readOnly: true
    });
    window.openDrawio = openDrawio;
    if (this.url && window.openDrawio) {
      _MDLoadMaskView["default"].remove();
      openDrawio(this.url);
    }
    window.addEventListener("drawioLoaded", MDDrawioEditor.drawioLoaded, false);
    // window.addEventListener("drawioClosed", MDDrawioEditorController.drawioClosed, false);

    // window.addEventListener("drawioImageCreated", MDDrawioEditorController.drawioImageCreated);
  },
  drawWaterMark: function drawWaterMark() {
    var self = this;
    this._watermarkOverlay = _MEWatermarkOverlay["default"].createWatermarkOverlay({
      container: this.$content[0],
      existingCanvas: this.$imageLayerMarker[0],
      canvasClass: "image-layer-marker editor-canvas-zone",
      extraStyles: {
        width: "100%",
        height: "100%",
        zIndex: "2"
      },
      getSize: function getSize() {
        return {
          cssWidth: self.$imageLayerMarker.width(),
          cssHeight: self.$imageLayerMarker.height()
        };
      },
      getWatermarkInfo: function getWatermarkInfo() {
        return self.curFileInfo.get("watermarkInfo");
      },
      onCanvasRecreated: function onCanvasRecreated(newCanvas) {
        self.$imageLayerMarker = $(newCanvas);
      }
    });
  },
  getCenterRatioPosition: function getCenterRatioPosition() {
    var center = {
      x: 0,
      y: 0
    };
    var container = this.$content[0];
    if (this.$content.find('.CodeMirror-scroll').length) {
      container = this.$content.find('.CodeMirror-scroll')[0];
    } else {}
    center.x = (container.scrollLeft + container.offsetWidth / 2) / container.scrollWidth;
    center.y = (container.scrollTop + container.offsetHeight / 2) / container.scrollHeight;
    console.log('----------- codemirror center:', center);
    return center;
  },
  restoreCenterPostion: function restoreCenterPostion(ratioCenter) {
    var pos = {
      x: 0,
      y: 0
    };
    var container = this.$content[0];
    if (this.$content.find('.CodeMirror-scroll').length) {
      container = this.$content.find('.CodeMirror-scroll')[0];
    }
    pos.x = ratioCenter.x * container.scrollWidth - container.offsetWidth / 2;
    pos.y = ratioCenter.y * container.scrollHeight - container.offsetHeight / 2;
    container.scrollTop = pos.y;
    container.scrollLeft = pos.x;
  },
  getScale: function getScale() {
    return this.originScale || 1;
  },
  setScale: function setScale(scale) {
    this.originScale = scale;
  },
  changeScale: function changeScale(scale, callback) {
    if (!this.originSize) {
      this.originSize = {
        width: this.$content.find('object').width(),
        height: this.$content.find('object').height()
      };
    }
    this.originScale = scale;
    var width = this.originSize.width * scale;
    var height = this.originSize.height * scale;
    var element = this.$content.find('object')[0];
    element.width = width;
    element.height = height;
    var contentWidth = this.$content.width();
    var contentHeight = this.$content.height();
    if (contentWidth > width) {
      this.$content.addClass('center');
    } else {
      this.$content.removeClass('center');
    }
    if (contentHeight > height) {
      this.$content.addClass('middle');
    } else {
      this.$content.removeClass('middle');
    }
    if (callback) {
      callback();
    }
    ;
  },
  zoomToFit: function zoomToFit() {
    this.changeScale(1);
  },
  refreshSize: function refreshSize() {},
  closeCommentPanel: function closeCommentPanel() {},
  getCurrentFileInfo: function getCurrentFileInfo() {
    return this.curFileInfo;
  },
  removeFromSuperView: function removeFromSuperView() {
    if (this._watermarkOverlay) {
      this._watermarkOverlay.cleanup();
      this._watermarkOverlay = null;
    }
    if (!app.canDispInNormalBrowser()) {
      this.$content.off('click');
    }
    ;
    this.$content.find('.CodeMirror-scroll').off();
    this.$content.remove();
    this.$imageLayerMarker.remove();
    window.removeEventListener("drawioLoaded", MDDrawioEditor.drawioLoaded, false);
    MDDrawioEditor.url = null;
  },
  // 以下是为了配合手机界面的接口
  getCurrentBoard: function getCurrentBoard() {
    return this.curFileInfo.getBoard();
  },
  getCurrentFilePageCount: function getCurrentFilePageCount() {
    return 1;
  },
  getKityminderEditorIndex: function getKityminderEditorIndex() {
    return window.kityminderEditorIndex++;
  },
  getCurrentFilePageIndex: function getCurrentFilePageIndex() {
    return 0;
  },
  getCurrentFileIndex: function getCurrentFileIndex() {
    return 0;
  },
  getClassName: function getClassName() {
    return 'MDDrawioEditor';
  },
  setCurOperation: function setCurOperation() {}
});
MDDrawioEditor.drawioLoaded = function () {
  window.openDrawio(MDDrawioEditor.url, this.fileName);
  console.log(event);
};
window.kityminderEditorIndex = 0;
var _default = exports["default"] = MDDrawioEditor;

},{"1104":1104,"1125":1125,"114":114,"1149":1149,"1184":1184,"1417":1417,"1423":1423,"1451":1451,"1454":1454,"1463":1463,"1487":1487,"1538":1538,"1543":1543,"1545":1545,"49":49,"72":72,"809":809,"812":812}],1149:[function(require,module,exports){
"use strict";

require(1475);
var _interopRequireDefault = require(1184);
var _regenerator = _interopRequireDefault(require(1199));
var _typeof2 = _interopRequireDefault(require(1197));
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
require(1463);
require(1471);
require(1477);
require(1492);
require(1422);
require(1426);
require(1418);
require(1537);
require(1421);
require(1446);
require(1416);
require(1439);
require(1415);
require(1461);
require(1423);
require(1487);
require(1538);
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
var utils = require(1148);
var convert = require(1573); // const format = require('xml-formatter')

var JSZip = require("jszip");
var path = require(1551);
var format = xmlFormatter;
var parser = /*#__PURE__*/function (_utils) {
  (0, _inherits2["default"])(parser, _utils);
  function parser() {
    (0, _classCallCheck2["default"])(this, parser);
    return _callSuper(this, parser, arguments);
  }
  (0, _createClass2["default"])(parser, [{
    key: "getImageInfo",
    value:
    //读取图片文件信息
    function getImageInfo(res, v) {
      return _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var file, base64, img;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return res.file(v).async('base64');
            case 2:
              file = _context.sent;
              base64 = "data:image/".concat((path.extname(v) || 'png').replace(/\./g, ''), ";base64,") + file;
              if ((typeof window === "undefined" ? "undefined" : (0, _typeof2["default"])(window)) === 'object') {
                img = new Image();
                img.src = base64; // 加载完成执行

                img.onload = function () {
                  var width = img.width,
                    height = img.height;
                  var maxWith = 200;
                  if (width > maxWith) {
                    var scale = maxWith / width;
                    width = width * scale;
                    height = height * scale;
                  }
                  return Promise.resolve({
                    width: width,
                    height: height,
                    base64: base64,
                    name: v
                  });
                };
                img.onerror = function () {
                  return Promise.resolve({
                    base64: base64,
                    name: v
                  });
                };
              }
              return _context.abrupt("return", {
                base64: base64,
                name: v
              });
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    } // 素组递归格式化
  }, {
    key: "toKityJSON",
    value: function toKityJSON() {
      var _this2 = this;
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var imgFiles = arguments.length > 1 ? arguments[1] : undefined;
      var list = data.attached || (Array.isArray(data) ? data : data.title ? [data] : []);
      return list.map(function (v) {
        var _ref = v || {},
          topic = _ref.topic;
        return _this2.rootFormData(topic || v, imgFiles);
      });
    } //xmind 转 json需要的数据格式
  }, {
    key: "rootFormData",
    value: function rootFormData(data, imgFiles) {
      var _this3 = this;
      var _ref2 = data || {},
        _ref2$title = _ref2.title,
        title = _ref2$title === void 0 ? '' : _ref2$title,
        _ref2$notes = _ref2.notes,
        notes = _ref2$notes === void 0 ? {
          plain: {
            content: ''
          }
        } : _ref2$notes,
        _ref2$image = _ref2.image,
        image = _ref2$image === void 0 ? {
          src: ''
        } : _ref2$image,
        xmlInfo = _ref2['xhtml:img'],
        _ref2$markers = _ref2.markers,
        markers = _ref2$markers === void 0 ? [] : _ref2$markers,
        _ref2$markerRefs = _ref2['marker-refs'],
        markerRefs = _ref2$markerRefs === void 0 ? {} : _ref2$markerRefs;
      var _ref3 = data || {},
        children = _ref3.children; // 百度脑图xml转json的children属性

      var _ref4 = children || {},
        _ref4$topics = _ref4.topics,
        topics = _ref4$topics === void 0 ? {} : _ref4$topics;
      var _ref5 = topics || {},
        topic = _ref5.topic;
      if (Array.isArray(topics)) {
        children = topics;
      } else if (Array.isArray(topic)) {
        children = topic;
      } else if (Array.isArray(data)) {
        children = data;
      }
      var text = title[(0, _get2["default"])((0, _getPrototypeOf2["default"])(parser.prototype), "objMatchingkey", this).call(this, title, 'text')] || title; //图片

      var imageAttr = (xmlInfo || {})['_attributes'] || {};
      var src = imageAttr['xhtml:src'];
      var imageSize = {
        width: imageAttr['svg:width'],
        height: imageAttr['svg:height']
      };
      var imageData = imgFiles[path.basename(src || image.src)] || {};
      var imageBase = imageData.base64;
      if (imageBase && (!imageSize.width || !imageSize.height)) {
        imageSize = {
          width: imageData.width,
          height: imageData.height
        };
      } //标记属性

      var priority, progress;
      var markerList = markerRefs['marker-ref'] || markers;
      if (markerList._attributes) {
        markerList = [markerList];
      }
      markerList.forEach(function (v) {
        var attr = v['_attributes'] || v;
        var markerId = attr['markerId'] || attr['marker-id'];
        if (markerId.indexOf('priority') >= 0) {
          var num = Number(markerId.replace(/[^0-9]/ig, ''));
          if (!isNaN(num)) priority = num;
        } else if (markerId.indexOf('task') >= 0) {
          var index = _this3.task.findIndex(function (r) {
            return markerId.split('-').pop() === r;
          });
          progress = index + 1;
        }
      });
      var params = {
        children: this.toKityJSON(topic || children, imgFiles),
        data: {
          text: text,
          priority: priority,
          progress: progress,
          note: notes.plain.content,
          image: imageBase,
          imageSize: imageSize
        }
      };
      return params;
    }
  }, {
    key: "xmindToJSON",
    value: function xmindToJSON(data) {
      var _this4 = this;
      var _superprop_getObjMatchingkey = function _superprop_getObjMatchingkey() {
          return (0, _get2["default"])((0, _getPrototypeOf2["default"])(parser.prototype), "objMatchingkey", _this4);
        },
        _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var zip, res, files, keys, isJsonFile, kityminderFile, file, fileVal, imglist, imgListBase, imgFiles, xmindData, content, json;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              // if (typeof data === 'string') {
              //     const readFile = require('./readFile');
              //     data = await new readFile().getFileBody(data)
              // }
              zip = new JSZip(); //xmind解压
              _context2.next = 4;
              return zip.loadAsync(data, {
                optimizedBinaryString: true
              });
            case 4:
              res = _context2.sent;
              files = res.files; //查找xmind content json或xml文件
              keys = _superprop_getObjMatchingkey().call(_this, files, "".concat(_this.fileName, ".json")) || _superprop_getObjMatchingkey().call(_this, files, _this.fileName);
              isJsonFile = path.extname(keys).indexOf('json') >= 0; //查找是否存在kityminder.json文件
              kityminderFile = files[_this.kityminder];
              file = kityminderFile || files[keys];
              if (file) {
                _context2.next = 12;
                break;
              }
              return _context2.abrupt("return", Promise.reject(new Error('文件解析失败')));
            case 12:
              _context2.next = 14;
              return res.file(file.name).async('string');
            case 14:
              fileVal = _context2.sent;
              if (!kityminderFile) {
                _context2.next = 19;
                break;
              }
              return _context2.abrupt("return", Promise.resolve(fileVal));
            case 19:
              //获取解压包的图片列表
              imglist = Object.keys(files).filter(function (v) {
                return _this.imgRegex.test(path.basename(v));
              });
              _context2.next = 22;
              return Promise.all(imglist.map(function (v) {
                return _this.getImageInfo(res, v);
              }));
            case 22:
              imgListBase = _context2.sent;
              imgFiles = {};
              imgListBase.forEach(function (v) {
                imgFiles[path.basename(v.name)] = v;
              }); //读取content.json 或者 content.xml 转换成脑图数据
              xmindData = {
                template: 'default',
                theme: 'fresh-blue',
                root: {
                  data: {
                    text: ''
                  },
                  children: []
                }
              };
              if (!isJsonFile) {
                //xml转json
                json = JSON.parse(convert.xml2json(format(fileVal, {
                  collapseContent: true
                }), {
                  compact: true,
                  spaces: 4
                }));
                content = json['xmap-content'].sheet.topic;
              } else {
                content = (JSON.parse(fileVal).shift() || {
                  rootTopic: {}
                }).rootTopic;
              }
              xmindData.root = _.extend({}, xmindData.root, _this.rootFormData(content, imgFiles)); // {
              //     ...xmindData.root
              //     //格式化为kityminder文件格式
              //     ...this.rootFormData(content, imgFiles)
              // }
              return _context2.abrupt("return", Promise.resolve(xmindData));
            case 29:
              _context2.next = 34;
              break;
            case 31:
              _context2.prev = 31;
              _context2.t0 = _context2["catch"](0);
              return _context2.abrupt("return", Promise.reject(_context2.t0));
            case 34:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 31]]);
      }))();
    }
  }]);
  return parser;
}(utils);
module.exports = parser;

},{"1148":1148,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1197":1197,"1199":1199,"1415":1415,"1416":1416,"1418":1418,"1421":1421,"1422":1422,"1423":1423,"1426":1426,"1439":1439,"1446":1446,"1461":1461,"1463":1463,"1471":1471,"1475":1475,"1477":1477,"1487":1487,"1492":1492,"1537":1537,"1538":1538,"1551":1551,"1573":1573,"jszip":"jszip"}],"jszip":[function(require,module,exports){
"use strict";

module.exports = window.JSZip;
if (window.JSZip) module.exports["default"] = window.JSZip;

},{}],1573:[function(require,module,exports){
/*jslint node:true */

var xml2js = require(1577);
var xml2json = require(1578);
var js2xml = require(1574);
var json2xml = require(1575);

module.exports = {
  xml2js: xml2js,
  xml2json: xml2json,
  js2xml: js2xml,
  json2xml: json2xml
};

},{"1574":1574,"1575":1575,"1577":1577,"1578":1578}],1578:[function(require,module,exports){
var helper = require(1576);
var xml2js = require(1577);

function validateOptions (userOptions) {
  var options = helper.copyOptions(userOptions);
  helper.ensureSpacesExists(options);
  return options;
}

module.exports = function(xml, userOptions) {
  var options, js, json, parentKey;
  options = validateOptions(userOptions);
  js = xml2js(xml, options);
  parentKey = 'compact' in options && options.compact ? '_parent' : 'parent';
  // parentKey = ptions.compact ? '_parent' : 'parent'; // consider this
  if ('addParent' in options && options.addParent) {
    json = JSON.stringify(js, function (k, v) { return k === parentKey? '_' : v; }, options.spaces);
  } else {
    json = JSON.stringify(js, null, options.spaces);
  }
  return json.replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
};

},{"1576":1576,"1577":1577}],1577:[function(require,module,exports){
var sax = require(1568);
var expat /*= require('node-expat');*/ = { on: function () { }, parse: function () { } };
var helper = require(1576);
var isArray = require(1572).isArray;

var options;
var pureJsParser = true;
var currentElement;

function validateOptions(userOptions) {
  options = helper.copyOptions(userOptions);
  helper.ensureFlagExists('ignoreDeclaration', options);
  helper.ensureFlagExists('ignoreInstruction', options);
  helper.ensureFlagExists('ignoreAttributes', options);
  helper.ensureFlagExists('ignoreText', options);
  helper.ensureFlagExists('ignoreComment', options);
  helper.ensureFlagExists('ignoreCdata', options);
  helper.ensureFlagExists('ignoreDoctype', options);
  helper.ensureFlagExists('compact', options);
  helper.ensureFlagExists('alwaysChildren', options);
  helper.ensureFlagExists('addParent', options);
  helper.ensureFlagExists('trim', options);
  helper.ensureFlagExists('nativeType', options);
  helper.ensureFlagExists('nativeTypeAttributes', options);
  helper.ensureFlagExists('sanitize', options);
  helper.ensureFlagExists('instructionHasAttributes', options);
  helper.ensureFlagExists('captureSpacesBetweenElements', options);
  helper.ensureAlwaysArrayExists(options);
  helper.ensureKeyExists('declaration', options);
  helper.ensureKeyExists('instruction', options);
  helper.ensureKeyExists('attributes', options);
  helper.ensureKeyExists('text', options);
  helper.ensureKeyExists('comment', options);
  helper.ensureKeyExists('cdata', options);
  helper.ensureKeyExists('doctype', options);
  helper.ensureKeyExists('type', options);
  helper.ensureKeyExists('name', options);
  helper.ensureKeyExists('elements', options);
  helper.ensureKeyExists('parent', options);
  helper.checkFnExists('doctype', options);
  helper.checkFnExists('instruction', options);
  helper.checkFnExists('cdata', options);
  helper.checkFnExists('comment', options);
  helper.checkFnExists('text', options);
  helper.checkFnExists('instructionName', options);
  helper.checkFnExists('elementName', options);
  helper.checkFnExists('attributeName', options);
  helper.checkFnExists('attributeValue', options);
  helper.checkFnExists('attributes', options);
  return options;
}

function nativeType(value) {
  var nValue = Number(value);
  if (!isNaN(nValue)) {
    return nValue;
  }
  var bValue = value.toLowerCase();
  if (bValue === 'true') {
    return true;
  } else if (bValue === 'false') {
    return false;
  }
  return value;
}

function addField(type, value) {
  var key;
  if (options.compact) {
    if (
      !currentElement[options[type + 'Key']] &&
      (isArray(options.alwaysArray) ? options.alwaysArray.indexOf(options[type + 'Key']) !== -1 : options.alwaysArray)
    ) {
      currentElement[options[type + 'Key']] = [];
    }
    if (currentElement[options[type + 'Key']] && !isArray(currentElement[options[type + 'Key']])) {
      currentElement[options[type + 'Key']] = [currentElement[options[type + 'Key']]];
    }
    if (type + 'Fn' in options && typeof value === 'string') {
      value = options[type + 'Fn'](value, currentElement);
    }
    if (type === 'instruction' && ('instructionFn' in options || 'instructionNameFn' in options)) {
      for (key in value) {
        if (value.hasOwnProperty(key)) {
          if ('instructionFn' in options) {
            value[key] = options.instructionFn(value[key], key, currentElement);
          } else {
            var temp = value[key];
            delete value[key];
            value[options.instructionNameFn(key, temp, currentElement)] = temp;
          }
        }
      }
    }
    if (isArray(currentElement[options[type + 'Key']])) {
      currentElement[options[type + 'Key']].push(value);
    } else {
      currentElement[options[type + 'Key']] = value;
    }
  } else {
    if (!currentElement[options.elementsKey]) {
      currentElement[options.elementsKey] = [];
    }
    var element = {};
    element[options.typeKey] = type;
    if (type === 'instruction') {
      for (key in value) {
        if (value.hasOwnProperty(key)) {
          break;
        }
      }
      element[options.nameKey] = 'instructionNameFn' in options ? options.instructionNameFn(key, value, currentElement) : key;
      if (options.instructionHasAttributes) {
        element[options.attributesKey] = value[key][options.attributesKey];
        if ('instructionFn' in options) {
          element[options.attributesKey] = options.instructionFn(element[options.attributesKey], key, currentElement);
        }
      } else {
        if ('instructionFn' in options) {
          value[key] = options.instructionFn(value[key], key, currentElement);
        }
        element[options.instructionKey] = value[key];
      }
    } else {
      if (type + 'Fn' in options) {
        value = options[type + 'Fn'](value, currentElement);
      }
      element[options[type + 'Key']] = value;
    }
    if (options.addParent) {
      element[options.parentKey] = currentElement;
    }
    currentElement[options.elementsKey].push(element);
  }
}

function manipulateAttributes(attributes) {
  if ('attributesFn' in options && attributes) {
    attributes = options.attributesFn(attributes, currentElement);
  }
  if ((options.trim || 'attributeValueFn' in options || 'attributeNameFn' in options || options.nativeTypeAttributes) && attributes) {
    var key;
    for (key in attributes) {
      if (attributes.hasOwnProperty(key)) {
        if (options.trim) attributes[key] = attributes[key].trim();
        if (options.nativeTypeAttributes) {
          attributes[key] = nativeType(attributes[key]);
        }
        if ('attributeValueFn' in options) attributes[key] = options.attributeValueFn(attributes[key], key, currentElement);
        if ('attributeNameFn' in options) {
          var temp = attributes[key];
          delete attributes[key];
          attributes[options.attributeNameFn(key, attributes[key], currentElement)] = temp;
        }
      }
    }
  }
  return attributes;
}

function onInstruction(instruction) {
  var attributes = {};
  if (instruction.body && (instruction.name.toLowerCase() === 'xml' || options.instructionHasAttributes)) {
    var attrsRegExp = /([\w:-]+)\s*=\s*(?:"([^"]*)"|'([^']*)'|(\w+))\s*/g;
    var match;
    while ((match = attrsRegExp.exec(instruction.body)) !== null) {
      attributes[match[1]] = match[2] || match[3] || match[4];
    }
    attributes = manipulateAttributes(attributes);
  }
  if (instruction.name.toLowerCase() === 'xml') {
    if (options.ignoreDeclaration) {
      return;
    }
    currentElement[options.declarationKey] = {};
    if (Object.keys(attributes).length) {
      currentElement[options.declarationKey][options.attributesKey] = attributes;
    }
    if (options.addParent) {
      currentElement[options.declarationKey][options.parentKey] = currentElement;
    }
  } else {
    if (options.ignoreInstruction) {
      return;
    }
    if (options.trim) {
      instruction.body = instruction.body.trim();
    }
    var value = {};
    if (options.instructionHasAttributes && Object.keys(attributes).length) {
      value[instruction.name] = {};
      value[instruction.name][options.attributesKey] = attributes;
    } else {
      value[instruction.name] = instruction.body;
    }
    addField('instruction', value);
  }
}

function onStartElement(name, attributes) {
  var element;
  if (typeof name === 'object') {
    attributes = name.attributes;
    name = name.name;
  }
  attributes = manipulateAttributes(attributes);
  if ('elementNameFn' in options) {
    name = options.elementNameFn(name, currentElement);
  }
  if (options.compact) {
    element = {};
    if (!options.ignoreAttributes && attributes && Object.keys(attributes).length) {
      element[options.attributesKey] = {};
      var key;
      for (key in attributes) {
        if (attributes.hasOwnProperty(key)) {
          element[options.attributesKey][key] = attributes[key];
        }
      }
    }
    if (
      !(name in currentElement) &&
      (isArray(options.alwaysArray) ? options.alwaysArray.indexOf(name) !== -1 : options.alwaysArray)
    ) {
      currentElement[name] = [];
    }
    if (currentElement[name] && !isArray(currentElement[name])) {
      currentElement[name] = [currentElement[name]];
    }
    if (isArray(currentElement[name])) {
      currentElement[name].push(element);
    } else {
      currentElement[name] = element;
    }
  } else {
    if (!currentElement[options.elementsKey]) {
      currentElement[options.elementsKey] = [];
    }
    element = {};
    element[options.typeKey] = 'element';
    element[options.nameKey] = name;
    if (!options.ignoreAttributes && attributes && Object.keys(attributes).length) {
      element[options.attributesKey] = attributes;
    }
    if (options.alwaysChildren) {
      element[options.elementsKey] = [];
    }
    currentElement[options.elementsKey].push(element);
  }
  element[options.parentKey] = currentElement; // will be deleted in onEndElement() if !options.addParent
  currentElement = element;
}

function onText(text) {
  if (options.ignoreText) {
    return;
  }
  if (!text.trim() && !options.captureSpacesBetweenElements) {
    return;
  }
  if (options.trim) {
    text = text.trim();
  }
  if (options.nativeType) {
    text = nativeType(text);
  }
  if (options.sanitize) {
    text = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  addField('text', text);
}

function onComment(comment) {
  if (options.ignoreComment) {
    return;
  }
  if (options.trim) {
    comment = comment.trim();
  }
  addField('comment', comment);
}

function onEndElement(name) {
  var parentElement = currentElement[options.parentKey];
  if (!options.addParent) {
    delete currentElement[options.parentKey];
  }
  currentElement = parentElement;
}

function onCdata(cdata) {
  if (options.ignoreCdata) {
    return;
  }
  if (options.trim) {
    cdata = cdata.trim();
  }
  addField('cdata', cdata);
}

function onDoctype(doctype) {
  if (options.ignoreDoctype) {
    return;
  }
  doctype = doctype.replace(/^ /, '');
  if (options.trim) {
    doctype = doctype.trim();
  }
  addField('doctype', doctype);
}

function onError(error) {
  error.note = error; //console.error(error);
}

module.exports = function (xml, userOptions) {

  var parser = pureJsParser ? sax.parser(true, {}) : parser = new expat.Parser('UTF-8');
  var result = {};
  currentElement = result;

  options = validateOptions(userOptions);

  if (pureJsParser) {
    parser.opt = {strictEntities: true};
    parser.onopentag = onStartElement;
    parser.ontext = onText;
    parser.oncomment = onComment;
    parser.onclosetag = onEndElement;
    parser.onerror = onError;
    parser.oncdata = onCdata;
    parser.ondoctype = onDoctype;
    parser.onprocessinginstruction = onInstruction;
  } else {
    parser.on('startElement', onStartElement);
    parser.on('text', onText);
    parser.on('comment', onComment);
    parser.on('endElement', onEndElement);
    parser.on('error', onError);
    //parser.on('startCdata', onStartCdata);
    //parser.on('endCdata', onEndCdata);
    //parser.on('entityDecl', onEntityDecl);
  }

  if (pureJsParser) {
    parser.write(xml).close();
  } else {
    if (!parser.parse(xml)) {
      throw new Error('XML parsing error: ' + parser.getError());
    }
  }

  if (result[options.elementsKey]) {
    var temp = result[options.elementsKey];
    delete result[options.elementsKey];
    result[options.elementsKey] = temp;
    delete result.text;
  }

  return result;

};

},{"1568":1568,"1572":1572,"1576":1576}],1568:[function(require,module,exports){
(function (Buffer){(function (){
;(function (sax) { // wrapper for non-node envs
  sax.parser = function (strict, opt) { return new SAXParser(strict, opt) }
  sax.SAXParser = SAXParser
  sax.SAXStream = SAXStream
  sax.createStream = createStream

  // When we pass the MAX_BUFFER_LENGTH position, start checking for buffer overruns.
  // When we check, schedule the next check for MAX_BUFFER_LENGTH - (max(buffer lengths)),
  // since that's the earliest that a buffer overrun could occur.  This way, checks are
  // as rare as required, but as often as necessary to ensure never crossing this bound.
  // Furthermore, buffers are only tested at most once per write(), so passing a very
  // large string into write() might have undesirable effects, but this is manageable by
  // the caller, so it is assumed to be safe.  Thus, a call to write() may, in the extreme
  // edge case, result in creating at most one complete copy of the string passed in.
  // Set to Infinity to have unlimited buffers.
  sax.MAX_BUFFER_LENGTH = 64 * 1024

  var buffers = [
    'comment', 'sgmlDecl', 'textNode', 'tagName', 'doctype',
    'procInstName', 'procInstBody', 'entity', 'attribName',
    'attribValue', 'cdata', 'script'
  ]

  sax.EVENTS = [
    'text',
    'processinginstruction',
    'sgmldeclaration',
    'doctype',
    'comment',
    'opentagstart',
    'attribute',
    'opentag',
    'closetag',
    'opencdata',
    'cdata',
    'closecdata',
    'error',
    'end',
    'ready',
    'script',
    'opennamespace',
    'closenamespace'
  ]

  function SAXParser (strict, opt) {
    if (!(this instanceof SAXParser)) {
      return new SAXParser(strict, opt)
    }

    var parser = this
    clearBuffers(parser)
    parser.q = parser.c = ''
    parser.bufferCheckPosition = sax.MAX_BUFFER_LENGTH
    parser.opt = opt || {}
    parser.opt.lowercase = parser.opt.lowercase || parser.opt.lowercasetags
    parser.looseCase = parser.opt.lowercase ? 'toLowerCase' : 'toUpperCase'
    parser.tags = []
    parser.closed = parser.closedRoot = parser.sawRoot = false
    parser.tag = parser.error = null
    parser.strict = !!strict
    parser.noscript = !!(strict || parser.opt.noscript)
    parser.state = S.BEGIN
    parser.strictEntities = parser.opt.strictEntities
    parser.ENTITIES = parser.strictEntities ? Object.create(sax.XML_ENTITIES) : Object.create(sax.ENTITIES)
    parser.attribList = []

    // namespaces form a prototype chain.
    // it always points at the current tag,
    // which protos to its parent tag.
    if (parser.opt.xmlns) {
      parser.ns = Object.create(rootNS)
    }

    // mostly just for error reporting
    parser.trackPosition = parser.opt.position !== false
    if (parser.trackPosition) {
      parser.position = parser.line = parser.column = 0
    }
    emit(parser, 'onready')
  }

  if (!Object.create) {
    Object.create = function (o) {
      function F () {}
      F.prototype = o
      var newf = new F()
      return newf
    }
  }

  if (!Object.keys) {
    Object.keys = function (o) {
      var a = []
      for (var i in o) if (o.hasOwnProperty(i)) a.push(i)
      return a
    }
  }

  function checkBufferLength (parser) {
    var maxAllowed = Math.max(sax.MAX_BUFFER_LENGTH, 10)
    var maxActual = 0
    for (var i = 0, l = buffers.length; i < l; i++) {
      var len = parser[buffers[i]].length
      if (len > maxAllowed) {
        // Text/cdata nodes can get big, and since they're buffered,
        // we can get here under normal conditions.
        // Avoid issues by emitting the text node now,
        // so at least it won't get any bigger.
        switch (buffers[i]) {
          case 'textNode':
            closeText(parser)
            break

          case 'cdata':
            emitNode(parser, 'oncdata', parser.cdata)
            parser.cdata = ''
            break

          case 'script':
            emitNode(parser, 'onscript', parser.script)
            parser.script = ''
            break

          default:
            error(parser, 'Max buffer length exceeded: ' + buffers[i])
        }
      }
      maxActual = Math.max(maxActual, len)
    }
    // schedule the next check for the earliest possible buffer overrun.
    var m = sax.MAX_BUFFER_LENGTH - maxActual
    parser.bufferCheckPosition = m + parser.position
  }

  function clearBuffers (parser) {
    for (var i = 0, l = buffers.length; i < l; i++) {
      parser[buffers[i]] = ''
    }
  }

  function flushBuffers (parser) {
    closeText(parser)
    if (parser.cdata !== '') {
      emitNode(parser, 'oncdata', parser.cdata)
      parser.cdata = ''
    }
    if (parser.script !== '') {
      emitNode(parser, 'onscript', parser.script)
      parser.script = ''
    }
  }

  SAXParser.prototype = {
    end: function () { end(this) },
    write: write,
    resume: function () { this.error = null; return this },
    close: function () { return this.write(null) },
    flush: function () { flushBuffers(this) }
  }

  var Stream
  try {
    Stream = require(1569).Stream
  } catch (ex) {
    Stream = function () {}
  }
  if (!Stream) Stream = function () {}

  var streamWraps = sax.EVENTS.filter(function (ev) {
    return ev !== 'error' && ev !== 'end'
  })

  function createStream (strict, opt) {
    return new SAXStream(strict, opt)
  }

  function SAXStream (strict, opt) {
    if (!(this instanceof SAXStream)) {
      return new SAXStream(strict, opt)
    }

    Stream.apply(this)

    this._parser = new SAXParser(strict, opt)
    this.writable = true
    this.readable = true

    var me = this

    this._parser.onend = function () {
      me.emit('end')
    }

    this._parser.onerror = function (er) {
      me.emit('error', er)

      // if didn't throw, then means error was handled.
      // go ahead and clear error, so we can write again.
      me._parser.error = null
    }

    this._decoder = null

    streamWraps.forEach(function (ev) {
      Object.defineProperty(me, 'on' + ev, {
        get: function () {
          return me._parser['on' + ev]
        },
        set: function (h) {
          if (!h) {
            me.removeAllListeners(ev)
            me._parser['on' + ev] = h
            return h
          }
          me.on(ev, h)
        },
        enumerable: true,
        configurable: false
      })
    })
  }

  SAXStream.prototype = Object.create(Stream.prototype, {
    constructor: {
      value: SAXStream
    }
  })

  SAXStream.prototype.write = function (data) {
    if (typeof Buffer === 'function' &&
      typeof Buffer.isBuffer === 'function' &&
      Buffer.isBuffer(data)) {
      if (!this._decoder) {
        var SD = require(1570).StringDecoder
        this._decoder = new SD('utf8')
      }
      data = this._decoder.write(data)
    }

    this._parser.write(data.toString())
    this.emit('data', data)
    return true
  }

  SAXStream.prototype.end = function (chunk) {
    if (chunk && chunk.length) {
      this.write(chunk)
    }
    this._parser.end()
    return true
  }

  SAXStream.prototype.on = function (ev, handler) {
    var me = this
    if (!me._parser['on' + ev] && streamWraps.indexOf(ev) !== -1) {
      me._parser['on' + ev] = function () {
        var args = arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments)
        args.splice(0, 0, ev)
        me.emit.apply(me, args)
      }
    }

    return Stream.prototype.on.call(me, ev, handler)
  }

  // this really needs to be replaced with character classes.
  // XML allows all manner of ridiculous numbers and digits.
  var CDATA = '[CDATA['
  var DOCTYPE = 'DOCTYPE'
  var XML_NAMESPACE = 'http://www.w3.org/XML/1998/namespace'
  var XMLNS_NAMESPACE = 'http://www.w3.org/2000/xmlns/'
  var rootNS = { xml: XML_NAMESPACE, xmlns: XMLNS_NAMESPACE }

  // http://www.w3.org/TR/REC-xml/#NT-NameStartChar
  // This implementation works on strings, a single character at a time
  // as such, it cannot ever support astral-plane characters (10000-EFFFF)
  // without a significant breaking change to either this  parser, or the
  // JavaScript language.  Implementation of an emoji-capable xml parser
  // is left as an exercise for the reader.
  var nameStart = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/

  var nameBody = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/

  var entityStart = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/
  var entityBody = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/

  function isWhitespace (c) {
    return c === ' ' || c === '\n' || c === '\r' || c === '\t'
  }

  function isQuote (c) {
    return c === '"' || c === '\''
  }

  function isAttribEnd (c) {
    return c === '>' || isWhitespace(c)
  }

  function isMatch (regex, c) {
    return regex.test(c)
  }

  function notMatch (regex, c) {
    return !isMatch(regex, c)
  }

  var S = 0
  sax.STATE = {
    BEGIN: S++, // leading byte order mark or whitespace
    BEGIN_WHITESPACE: S++, // leading whitespace
    TEXT: S++, // general stuff
    TEXT_ENTITY: S++, // &amp and such.
    OPEN_WAKA: S++, // <
    SGML_DECL: S++, // <!BLARG
    SGML_DECL_QUOTED: S++, // <!BLARG foo "bar
    DOCTYPE: S++, // <!DOCTYPE
    DOCTYPE_QUOTED: S++, // <!DOCTYPE "//blah
    DOCTYPE_DTD: S++, // <!DOCTYPE "//blah" [ ...
    DOCTYPE_DTD_QUOTED: S++, // <!DOCTYPE "//blah" [ "foo
    COMMENT_STARTING: S++, // <!-
    COMMENT: S++, // <!--
    COMMENT_ENDING: S++, // <!-- blah -
    COMMENT_ENDED: S++, // <!-- blah --
    CDATA: S++, // <![CDATA[ something
    CDATA_ENDING: S++, // ]
    CDATA_ENDING_2: S++, // ]]
    PROC_INST: S++, // <?hi
    PROC_INST_BODY: S++, // <?hi there
    PROC_INST_ENDING: S++, // <?hi "there" ?
    OPEN_TAG: S++, // <strong
    OPEN_TAG_SLASH: S++, // <strong /
    ATTRIB: S++, // <a
    ATTRIB_NAME: S++, // <a foo
    ATTRIB_NAME_SAW_WHITE: S++, // <a foo _
    ATTRIB_VALUE: S++, // <a foo=
    ATTRIB_VALUE_QUOTED: S++, // <a foo="bar
    ATTRIB_VALUE_CLOSED: S++, // <a foo="bar"
    ATTRIB_VALUE_UNQUOTED: S++, // <a foo=bar
    ATTRIB_VALUE_ENTITY_Q: S++, // <foo bar="&quot;"
    ATTRIB_VALUE_ENTITY_U: S++, // <foo bar=&quot
    CLOSE_TAG: S++, // </a
    CLOSE_TAG_SAW_WHITE: S++, // </a   >
    SCRIPT: S++, // <script> ...
    SCRIPT_ENDING: S++ // <script> ... <
  }

  sax.XML_ENTITIES = {
    'amp': '&',
    'gt': '>',
    'lt': '<',
    'quot': '"',
    'apos': "'"
  }

  sax.ENTITIES = {
    'amp': '&',
    'gt': '>',
    'lt': '<',
    'quot': '"',
    'apos': "'",
    'AElig': 198,
    'Aacute': 193,
    'Acirc': 194,
    'Agrave': 192,
    'Aring': 197,
    'Atilde': 195,
    'Auml': 196,
    'Ccedil': 199,
    'ETH': 208,
    'Eacute': 201,
    'Ecirc': 202,
    'Egrave': 200,
    'Euml': 203,
    'Iacute': 205,
    'Icirc': 206,
    'Igrave': 204,
    'Iuml': 207,
    'Ntilde': 209,
    'Oacute': 211,
    'Ocirc': 212,
    'Ograve': 210,
    'Oslash': 216,
    'Otilde': 213,
    'Ouml': 214,
    'THORN': 222,
    'Uacute': 218,
    'Ucirc': 219,
    'Ugrave': 217,
    'Uuml': 220,
    'Yacute': 221,
    'aacute': 225,
    'acirc': 226,
    'aelig': 230,
    'agrave': 224,
    'aring': 229,
    'atilde': 227,
    'auml': 228,
    'ccedil': 231,
    'eacute': 233,
    'ecirc': 234,
    'egrave': 232,
    'eth': 240,
    'euml': 235,
    'iacute': 237,
    'icirc': 238,
    'igrave': 236,
    'iuml': 239,
    'ntilde': 241,
    'oacute': 243,
    'ocirc': 244,
    'ograve': 242,
    'oslash': 248,
    'otilde': 245,
    'ouml': 246,
    'szlig': 223,
    'thorn': 254,
    'uacute': 250,
    'ucirc': 251,
    'ugrave': 249,
    'uuml': 252,
    'yacute': 253,
    'yuml': 255,
    'copy': 169,
    'reg': 174,
    'nbsp': 160,
    'iexcl': 161,
    'cent': 162,
    'pound': 163,
    'curren': 164,
    'yen': 165,
    'brvbar': 166,
    'sect': 167,
    'uml': 168,
    'ordf': 170,
    'laquo': 171,
    'not': 172,
    'shy': 173,
    'macr': 175,
    'deg': 176,
    'plusmn': 177,
    'sup1': 185,
    'sup2': 178,
    'sup3': 179,
    'acute': 180,
    'micro': 181,
    'para': 182,
    'middot': 183,
    'cedil': 184,
    'ordm': 186,
    'raquo': 187,
    'frac14': 188,
    'frac12': 189,
    'frac34': 190,
    'iquest': 191,
    'times': 215,
    'divide': 247,
    'OElig': 338,
    'oelig': 339,
    'Scaron': 352,
    'scaron': 353,
    'Yuml': 376,
    'fnof': 402,
    'circ': 710,
    'tilde': 732,
    'Alpha': 913,
    'Beta': 914,
    'Gamma': 915,
    'Delta': 916,
    'Epsilon': 917,
    'Zeta': 918,
    'Eta': 919,
    'Theta': 920,
    'Iota': 921,
    'Kappa': 922,
    'Lambda': 923,
    'Mu': 924,
    'Nu': 925,
    'Xi': 926,
    'Omicron': 927,
    'Pi': 928,
    'Rho': 929,
    'Sigma': 931,
    'Tau': 932,
    'Upsilon': 933,
    'Phi': 934,
    'Chi': 935,
    'Psi': 936,
    'Omega': 937,
    'alpha': 945,
    'beta': 946,
    'gamma': 947,
    'delta': 948,
    'epsilon': 949,
    'zeta': 950,
    'eta': 951,
    'theta': 952,
    'iota': 953,
    'kappa': 954,
    'lambda': 955,
    'mu': 956,
    'nu': 957,
    'xi': 958,
    'omicron': 959,
    'pi': 960,
    'rho': 961,
    'sigmaf': 962,
    'sigma': 963,
    'tau': 964,
    'upsilon': 965,
    'phi': 966,
    'chi': 967,
    'psi': 968,
    'omega': 969,
    'thetasym': 977,
    'upsih': 978,
    'piv': 982,
    'ensp': 8194,
    'emsp': 8195,
    'thinsp': 8201,
    'zwnj': 8204,
    'zwj': 8205,
    'lrm': 8206,
    'rlm': 8207,
    'ndash': 8211,
    'mdash': 8212,
    'lsquo': 8216,
    'rsquo': 8217,
    'sbquo': 8218,
    'ldquo': 8220,
    'rdquo': 8221,
    'bdquo': 8222,
    'dagger': 8224,
    'Dagger': 8225,
    'bull': 8226,
    'hellip': 8230,
    'permil': 8240,
    'prime': 8242,
    'Prime': 8243,
    'lsaquo': 8249,
    'rsaquo': 8250,
    'oline': 8254,
    'frasl': 8260,
    'euro': 8364,
    'image': 8465,
    'weierp': 8472,
    'real': 8476,
    'trade': 8482,
    'alefsym': 8501,
    'larr': 8592,
    'uarr': 8593,
    'rarr': 8594,
    'darr': 8595,
    'harr': 8596,
    'crarr': 8629,
    'lArr': 8656,
    'uArr': 8657,
    'rArr': 8658,
    'dArr': 8659,
    'hArr': 8660,
    'forall': 8704,
    'part': 8706,
    'exist': 8707,
    'empty': 8709,
    'nabla': 8711,
    'isin': 8712,
    'notin': 8713,
    'ni': 8715,
    'prod': 8719,
    'sum': 8721,
    'minus': 8722,
    'lowast': 8727,
    'radic': 8730,
    'prop': 8733,
    'infin': 8734,
    'ang': 8736,
    'and': 8743,
    'or': 8744,
    'cap': 8745,
    'cup': 8746,
    'int': 8747,
    'there4': 8756,
    'sim': 8764,
    'cong': 8773,
    'asymp': 8776,
    'ne': 8800,
    'equiv': 8801,
    'le': 8804,
    'ge': 8805,
    'sub': 8834,
    'sup': 8835,
    'nsub': 8836,
    'sube': 8838,
    'supe': 8839,
    'oplus': 8853,
    'otimes': 8855,
    'perp': 8869,
    'sdot': 8901,
    'lceil': 8968,
    'rceil': 8969,
    'lfloor': 8970,
    'rfloor': 8971,
    'lang': 9001,
    'rang': 9002,
    'loz': 9674,
    'spades': 9824,
    'clubs': 9827,
    'hearts': 9829,
    'diams': 9830
  }

  Object.keys(sax.ENTITIES).forEach(function (key) {
    var e = sax.ENTITIES[key]
    var s = typeof e === 'number' ? String.fromCharCode(e) : e
    sax.ENTITIES[key] = s
  })

  for (var s in sax.STATE) {
    sax.STATE[sax.STATE[s]] = s
  }

  // shorthand
  S = sax.STATE

  function emit (parser, event, data) {
    parser[event] && parser[event](data)
  }

  function emitNode (parser, nodeType, data) {
    if (parser.textNode) closeText(parser)
    emit(parser, nodeType, data)
  }

  function closeText (parser) {
    parser.textNode = textopts(parser.opt, parser.textNode)
    if (parser.textNode) emit(parser, 'ontext', parser.textNode)
    parser.textNode = ''
  }

  function textopts (opt, text) {
    if (opt.trim) text = text.trim()
    if (opt.normalize) text = text.replace(/\s+/g, ' ')
    return text
  }

  function error (parser, er) {
    closeText(parser)
    if (parser.trackPosition) {
      er += '\nLine: ' + parser.line +
        '\nColumn: ' + parser.column +
        '\nChar: ' + parser.c
    }
    er = new Error(er)
    parser.error = er
    emit(parser, 'onerror', er)
    return parser
  }

  function end (parser) {
    if (parser.sawRoot && !parser.closedRoot) strictFail(parser, 'Unclosed root tag')
    if ((parser.state !== S.BEGIN) &&
      (parser.state !== S.BEGIN_WHITESPACE) &&
      (parser.state !== S.TEXT)) {
      error(parser, 'Unexpected end')
    }
    closeText(parser)
    parser.c = ''
    parser.closed = true
    emit(parser, 'onend')
    SAXParser.call(parser, parser.strict, parser.opt)
    return parser
  }

  function strictFail (parser, message) {
    if (typeof parser !== 'object' || !(parser instanceof SAXParser)) {
      throw new Error('bad call to strictFail')
    }
    if (parser.strict) {
      error(parser, message)
    }
  }

  function newTag (parser) {
    if (!parser.strict) parser.tagName = parser.tagName[parser.looseCase]()
    var parent = parser.tags[parser.tags.length - 1] || parser
    var tag = parser.tag = { name: parser.tagName, attributes: {} }

    // will be overridden if tag contails an xmlns="foo" or xmlns:foo="bar"
    if (parser.opt.xmlns) {
      tag.ns = parent.ns
    }
    parser.attribList.length = 0
    emitNode(parser, 'onopentagstart', tag)
  }

  function qname (name, attribute) {
    var i = name.indexOf(':')
    var qualName = i < 0 ? [ '', name ] : name.split(':')
    var prefix = qualName[0]
    var local = qualName[1]

    // <x "xmlns"="http://foo">
    if (attribute && name === 'xmlns') {
      prefix = 'xmlns'
      local = ''
    }

    return { prefix: prefix, local: local }
  }

  function attrib (parser) {
    if (!parser.strict) {
      parser.attribName = parser.attribName[parser.looseCase]()
    }

    if (parser.attribList.indexOf(parser.attribName) !== -1 ||
      parser.tag.attributes.hasOwnProperty(parser.attribName)) {
      parser.attribName = parser.attribValue = ''
      return
    }

    if (parser.opt.xmlns) {
      var qn = qname(parser.attribName, true)
      var prefix = qn.prefix
      var local = qn.local

      if (prefix === 'xmlns') {
        // namespace binding attribute. push the binding into scope
        if (local === 'xml' && parser.attribValue !== XML_NAMESPACE) {
          strictFail(parser,
            'xml: prefix must be bound to ' + XML_NAMESPACE + '\n' +
            'Actual: ' + parser.attribValue)
        } else if (local === 'xmlns' && parser.attribValue !== XMLNS_NAMESPACE) {
          strictFail(parser,
            'xmlns: prefix must be bound to ' + XMLNS_NAMESPACE + '\n' +
            'Actual: ' + parser.attribValue)
        } else {
          var tag = parser.tag
          var parent = parser.tags[parser.tags.length - 1] || parser
          if (tag.ns === parent.ns) {
            tag.ns = Object.create(parent.ns)
          }
          tag.ns[local] = parser.attribValue
        }
      }

      // defer onattribute events until all attributes have been seen
      // so any new bindings can take effect. preserve attribute order
      // so deferred events can be emitted in document order
      parser.attribList.push([parser.attribName, parser.attribValue])
    } else {
      // in non-xmlns mode, we can emit the event right away
      parser.tag.attributes[parser.attribName] = parser.attribValue
      emitNode(parser, 'onattribute', {
        name: parser.attribName,
        value: parser.attribValue
      })
    }

    parser.attribName = parser.attribValue = ''
  }

  function openTag (parser, selfClosing) {
    if (parser.opt.xmlns) {
      // emit namespace binding events
      var tag = parser.tag

      // add namespace info to tag
      var qn = qname(parser.tagName)
      tag.prefix = qn.prefix
      tag.local = qn.local
      tag.uri = tag.ns[qn.prefix] || ''

      if (tag.prefix && !tag.uri) {
        strictFail(parser, 'Unbound namespace prefix: ' +
          JSON.stringify(parser.tagName))
        tag.uri = qn.prefix
      }

      var parent = parser.tags[parser.tags.length - 1] || parser
      if (tag.ns && parent.ns !== tag.ns) {
        Object.keys(tag.ns).forEach(function (p) {
          emitNode(parser, 'onopennamespace', {
            prefix: p,
            uri: tag.ns[p]
          })
        })
      }

      // handle deferred onattribute events
      // Note: do not apply default ns to attributes:
      //   http://www.w3.org/TR/REC-xml-names/#defaulting
      for (var i = 0, l = parser.attribList.length; i < l; i++) {
        var nv = parser.attribList[i]
        var name = nv[0]
        var value = nv[1]
        var qualName = qname(name, true)
        var prefix = qualName.prefix
        var local = qualName.local
        var uri = prefix === '' ? '' : (tag.ns[prefix] || '')
        var a = {
          name: name,
          value: value,
          prefix: prefix,
          local: local,
          uri: uri
        }

        // if there's any attributes with an undefined namespace,
        // then fail on them now.
        if (prefix && prefix !== 'xmlns' && !uri) {
          strictFail(parser, 'Unbound namespace prefix: ' +
            JSON.stringify(prefix))
          a.uri = prefix
        }
        parser.tag.attributes[name] = a
        emitNode(parser, 'onattribute', a)
      }
      parser.attribList.length = 0
    }

    parser.tag.isSelfClosing = !!selfClosing

    // process the tag
    parser.sawRoot = true
    parser.tags.push(parser.tag)
    emitNode(parser, 'onopentag', parser.tag)
    if (!selfClosing) {
      // special case for <script> in non-strict mode.
      if (!parser.noscript && parser.tagName.toLowerCase() === 'script') {
        parser.state = S.SCRIPT
      } else {
        parser.state = S.TEXT
      }
      parser.tag = null
      parser.tagName = ''
    }
    parser.attribName = parser.attribValue = ''
    parser.attribList.length = 0
  }

  function closeTag (parser) {
    if (!parser.tagName) {
      strictFail(parser, 'Weird empty close tag.')
      parser.textNode += '</>'
      parser.state = S.TEXT
      return
    }

    if (parser.script) {
      if (parser.tagName !== 'script') {
        parser.script += '</' + parser.tagName + '>'
        parser.tagName = ''
        parser.state = S.SCRIPT
        return
      }
      emitNode(parser, 'onscript', parser.script)
      parser.script = ''
    }

    // first make sure that the closing tag actually exists.
    // <a><b></c></b></a> will close everything, otherwise.
    var t = parser.tags.length
    var tagName = parser.tagName
    if (!parser.strict) {
      tagName = tagName[parser.looseCase]()
    }
    var closeTo = tagName
    while (t--) {
      var close = parser.tags[t]
      if (close.name !== closeTo) {
        // fail the first time in strict mode
        strictFail(parser, 'Unexpected close tag')
      } else {
        break
      }
    }

    // didn't find it.  we already failed for strict, so just abort.
    if (t < 0) {
      strictFail(parser, 'Unmatched closing tag: ' + parser.tagName)
      parser.textNode += '</' + parser.tagName + '>'
      parser.state = S.TEXT
      return
    }
    parser.tagName = tagName
    var s = parser.tags.length
    while (s-- > t) {
      var tag = parser.tag = parser.tags.pop()
      parser.tagName = parser.tag.name
      emitNode(parser, 'onclosetag', parser.tagName)

      var x = {}
      for (var i in tag.ns) {
        x[i] = tag.ns[i]
      }

      var parent = parser.tags[parser.tags.length - 1] || parser
      if (parser.opt.xmlns && tag.ns !== parent.ns) {
        // remove namespace bindings introduced by tag
        Object.keys(tag.ns).forEach(function (p) {
          var n = tag.ns[p]
          emitNode(parser, 'onclosenamespace', { prefix: p, uri: n })
        })
      }
    }
    if (t === 0) parser.closedRoot = true
    parser.tagName = parser.attribValue = parser.attribName = ''
    parser.attribList.length = 0
    parser.state = S.TEXT
  }

  function parseEntity (parser) {
    var entity = parser.entity
    var entityLC = entity.toLowerCase()
    var num
    var numStr = ''

    if (parser.ENTITIES[entity]) {
      return parser.ENTITIES[entity]
    }
    if (parser.ENTITIES[entityLC]) {
      return parser.ENTITIES[entityLC]
    }
    entity = entityLC
    if (entity.charAt(0) === '#') {
      if (entity.charAt(1) === 'x') {
        entity = entity.slice(2)
        num = parseInt(entity, 16)
        numStr = num.toString(16)
      } else {
        entity = entity.slice(1)
        num = parseInt(entity, 10)
        numStr = num.toString(10)
      }
    }
    entity = entity.replace(/^0+/, '')
    if (isNaN(num) || numStr.toLowerCase() !== entity) {
      strictFail(parser, 'Invalid character entity')
      return '&' + parser.entity + ';'
    }

    return String.fromCodePoint(num)
  }

  function beginWhiteSpace (parser, c) {
    if (c === '<') {
      parser.state = S.OPEN_WAKA
      parser.startTagPosition = parser.position
    } else if (!isWhitespace(c)) {
      // have to process this as a text node.
      // weird, but happens.
      strictFail(parser, 'Non-whitespace before first tag.')
      parser.textNode = c
      parser.state = S.TEXT
    }
  }

  function charAt (chunk, i) {
    var result = ''
    if (i < chunk.length) {
      result = chunk.charAt(i)
    }
    return result
  }

  function write (chunk) {
    var parser = this
    if (this.error) {
      throw this.error
    }
    if (parser.closed) {
      return error(parser,
        'Cannot write after close. Assign an onready handler.')
    }
    if (chunk === null) {
      return end(parser)
    }
    if (typeof chunk === 'object') {
      chunk = chunk.toString()
    }
    var i = 0
    var c = ''
    while (true) {
      c = charAt(chunk, i++)
      parser.c = c

      if (!c) {
        break
      }

      if (parser.trackPosition) {
        parser.position++
        if (c === '\n') {
          parser.line++
          parser.column = 0
        } else {
          parser.column++
        }
      }

      switch (parser.state) {
        case S.BEGIN:
          parser.state = S.BEGIN_WHITESPACE
          if (c === '\uFEFF') {
            continue
          }
          beginWhiteSpace(parser, c)
          continue

        case S.BEGIN_WHITESPACE:
          beginWhiteSpace(parser, c)
          continue

        case S.TEXT:
          if (parser.sawRoot && !parser.closedRoot) {
            var starti = i - 1
            while (c && c !== '<' && c !== '&') {
              c = charAt(chunk, i++)
              if (c && parser.trackPosition) {
                parser.position++
                if (c === '\n') {
                  parser.line++
                  parser.column = 0
                } else {
                  parser.column++
                }
              }
            }
            parser.textNode += chunk.substring(starti, i - 1)
          }
          if (c === '<' && !(parser.sawRoot && parser.closedRoot && !parser.strict)) {
            parser.state = S.OPEN_WAKA
            parser.startTagPosition = parser.position
          } else {
            if (!isWhitespace(c) && (!parser.sawRoot || parser.closedRoot)) {
              strictFail(parser, 'Text data outside of root node.')
            }
            if (c === '&') {
              parser.state = S.TEXT_ENTITY
            } else {
              parser.textNode += c
            }
          }
          continue

        case S.SCRIPT:
          // only non-strict
          if (c === '<') {
            parser.state = S.SCRIPT_ENDING
          } else {
            parser.script += c
          }
          continue

        case S.SCRIPT_ENDING:
          if (c === '/') {
            parser.state = S.CLOSE_TAG
          } else {
            parser.script += '<' + c
            parser.state = S.SCRIPT
          }
          continue

        case S.OPEN_WAKA:
          // either a /, ?, !, or text is coming next.
          if (c === '!') {
            parser.state = S.SGML_DECL
            parser.sgmlDecl = ''
          } else if (isWhitespace(c)) {
            // wait for it...
          } else if (isMatch(nameStart, c)) {
            parser.state = S.OPEN_TAG
            parser.tagName = c
          } else if (c === '/') {
            parser.state = S.CLOSE_TAG
            parser.tagName = ''
          } else if (c === '?') {
            parser.state = S.PROC_INST
            parser.procInstName = parser.procInstBody = ''
          } else {
            strictFail(parser, 'Unencoded <')
            // if there was some whitespace, then add that in.
            if (parser.startTagPosition + 1 < parser.position) {
              var pad = parser.position - parser.startTagPosition
              c = new Array(pad).join(' ') + c
            }
            parser.textNode += '<' + c
            parser.state = S.TEXT
          }
          continue

        case S.SGML_DECL:
          if ((parser.sgmlDecl + c).toUpperCase() === CDATA) {
            emitNode(parser, 'onopencdata')
            parser.state = S.CDATA
            parser.sgmlDecl = ''
            parser.cdata = ''
          } else if (parser.sgmlDecl + c === '--') {
            parser.state = S.COMMENT
            parser.comment = ''
            parser.sgmlDecl = ''
          } else if ((parser.sgmlDecl + c).toUpperCase() === DOCTYPE) {
            parser.state = S.DOCTYPE
            if (parser.doctype || parser.sawRoot) {
              strictFail(parser,
                'Inappropriately located doctype declaration')
            }
            parser.doctype = ''
            parser.sgmlDecl = ''
          } else if (c === '>') {
            emitNode(parser, 'onsgmldeclaration', parser.sgmlDecl)
            parser.sgmlDecl = ''
            parser.state = S.TEXT
          } else if (isQuote(c)) {
            parser.state = S.SGML_DECL_QUOTED
            parser.sgmlDecl += c
          } else {
            parser.sgmlDecl += c
          }
          continue

        case S.SGML_DECL_QUOTED:
          if (c === parser.q) {
            parser.state = S.SGML_DECL
            parser.q = ''
          }
          parser.sgmlDecl += c
          continue

        case S.DOCTYPE:
          if (c === '>') {
            parser.state = S.TEXT
            emitNode(parser, 'ondoctype', parser.doctype)
            parser.doctype = true // just remember that we saw it.
          } else {
            parser.doctype += c
            if (c === '[') {
              parser.state = S.DOCTYPE_DTD
            } else if (isQuote(c)) {
              parser.state = S.DOCTYPE_QUOTED
              parser.q = c
            }
          }
          continue

        case S.DOCTYPE_QUOTED:
          parser.doctype += c
          if (c === parser.q) {
            parser.q = ''
            parser.state = S.DOCTYPE
          }
          continue

        case S.DOCTYPE_DTD:
          parser.doctype += c
          if (c === ']') {
            parser.state = S.DOCTYPE
          } else if (isQuote(c)) {
            parser.state = S.DOCTYPE_DTD_QUOTED
            parser.q = c
          }
          continue

        case S.DOCTYPE_DTD_QUOTED:
          parser.doctype += c
          if (c === parser.q) {
            parser.state = S.DOCTYPE_DTD
            parser.q = ''
          }
          continue

        case S.COMMENT:
          if (c === '-') {
            parser.state = S.COMMENT_ENDING
          } else {
            parser.comment += c
          }
          continue

        case S.COMMENT_ENDING:
          if (c === '-') {
            parser.state = S.COMMENT_ENDED
            parser.comment = textopts(parser.opt, parser.comment)
            if (parser.comment) {
              emitNode(parser, 'oncomment', parser.comment)
            }
            parser.comment = ''
          } else {
            parser.comment += '-' + c
            parser.state = S.COMMENT
          }
          continue

        case S.COMMENT_ENDED:
          if (c !== '>') {
            strictFail(parser, 'Malformed comment')
            // allow <!-- blah -- bloo --> in non-strict mode,
            // which is a comment of " blah -- bloo "
            parser.comment += '--' + c
            parser.state = S.COMMENT
          } else {
            parser.state = S.TEXT
          }
          continue

        case S.CDATA:
          if (c === ']') {
            parser.state = S.CDATA_ENDING
          } else {
            parser.cdata += c
          }
          continue

        case S.CDATA_ENDING:
          if (c === ']') {
            parser.state = S.CDATA_ENDING_2
          } else {
            parser.cdata += ']' + c
            parser.state = S.CDATA
          }
          continue

        case S.CDATA_ENDING_2:
          if (c === '>') {
            if (parser.cdata) {
              emitNode(parser, 'oncdata', parser.cdata)
            }
            emitNode(parser, 'onclosecdata')
            parser.cdata = ''
            parser.state = S.TEXT
          } else if (c === ']') {
            parser.cdata += ']'
          } else {
            parser.cdata += ']]' + c
            parser.state = S.CDATA
          }
          continue

        case S.PROC_INST:
          if (c === '?') {
            parser.state = S.PROC_INST_ENDING
          } else if (isWhitespace(c)) {
            parser.state = S.PROC_INST_BODY
          } else {
            parser.procInstName += c
          }
          continue

        case S.PROC_INST_BODY:
          if (!parser.procInstBody && isWhitespace(c)) {
            continue
          } else if (c === '?') {
            parser.state = S.PROC_INST_ENDING
          } else {
            parser.procInstBody += c
          }
          continue

        case S.PROC_INST_ENDING:
          if (c === '>') {
            emitNode(parser, 'onprocessinginstruction', {
              name: parser.procInstName,
              body: parser.procInstBody
            })
            parser.procInstName = parser.procInstBody = ''
            parser.state = S.TEXT
          } else {
            parser.procInstBody += '?' + c
            parser.state = S.PROC_INST_BODY
          }
          continue

        case S.OPEN_TAG:
          if (isMatch(nameBody, c)) {
            parser.tagName += c
          } else {
            newTag(parser)
            if (c === '>') {
              openTag(parser)
            } else if (c === '/') {
              parser.state = S.OPEN_TAG_SLASH
            } else {
              if (!isWhitespace(c)) {
                strictFail(parser, 'Invalid character in tag name')
              }
              parser.state = S.ATTRIB
            }
          }
          continue

        case S.OPEN_TAG_SLASH:
          if (c === '>') {
            openTag(parser, true)
            closeTag(parser)
          } else {
            strictFail(parser, 'Forward-slash in opening tag not followed by >')
            parser.state = S.ATTRIB
          }
          continue

        case S.ATTRIB:
          // haven't read the attribute name yet.
          if (isWhitespace(c)) {
            continue
          } else if (c === '>') {
            openTag(parser)
          } else if (c === '/') {
            parser.state = S.OPEN_TAG_SLASH
          } else if (isMatch(nameStart, c)) {
            parser.attribName = c
            parser.attribValue = ''
            parser.state = S.ATTRIB_NAME
          } else {
            strictFail(parser, 'Invalid attribute name')
          }
          continue

        case S.ATTRIB_NAME:
          if (c === '=') {
            parser.state = S.ATTRIB_VALUE
          } else if (c === '>') {
            strictFail(parser, 'Attribute without value')
            parser.attribValue = parser.attribName
            attrib(parser)
            openTag(parser)
          } else if (isWhitespace(c)) {
            parser.state = S.ATTRIB_NAME_SAW_WHITE
          } else if (isMatch(nameBody, c)) {
            parser.attribName += c
          } else {
            strictFail(parser, 'Invalid attribute name')
          }
          continue

        case S.ATTRIB_NAME_SAW_WHITE:
          if (c === '=') {
            parser.state = S.ATTRIB_VALUE
          } else if (isWhitespace(c)) {
            continue
          } else {
            strictFail(parser, 'Attribute without value')
            parser.tag.attributes[parser.attribName] = ''
            parser.attribValue = ''
            emitNode(parser, 'onattribute', {
              name: parser.attribName,
              value: ''
            })
            parser.attribName = ''
            if (c === '>') {
              openTag(parser)
            } else if (isMatch(nameStart, c)) {
              parser.attribName = c
              parser.state = S.ATTRIB_NAME
            } else {
              strictFail(parser, 'Invalid attribute name')
              parser.state = S.ATTRIB
            }
          }
          continue

        case S.ATTRIB_VALUE:
          if (isWhitespace(c)) {
            continue
          } else if (isQuote(c)) {
            parser.q = c
            parser.state = S.ATTRIB_VALUE_QUOTED
          } else {
            strictFail(parser, 'Unquoted attribute value')
            parser.state = S.ATTRIB_VALUE_UNQUOTED
            parser.attribValue = c
          }
          continue

        case S.ATTRIB_VALUE_QUOTED:
          if (c !== parser.q) {
            if (c === '&') {
              parser.state = S.ATTRIB_VALUE_ENTITY_Q
            } else {
              parser.attribValue += c
            }
            continue
          }
          attrib(parser)
          parser.q = ''
          parser.state = S.ATTRIB_VALUE_CLOSED
          continue

        case S.ATTRIB_VALUE_CLOSED:
          if (isWhitespace(c)) {
            parser.state = S.ATTRIB
          } else if (c === '>') {
            openTag(parser)
          } else if (c === '/') {
            parser.state = S.OPEN_TAG_SLASH
          } else if (isMatch(nameStart, c)) {
            strictFail(parser, 'No whitespace between attributes')
            parser.attribName = c
            parser.attribValue = ''
            parser.state = S.ATTRIB_NAME
          } else {
            strictFail(parser, 'Invalid attribute name')
          }
          continue

        case S.ATTRIB_VALUE_UNQUOTED:
          if (!isAttribEnd(c)) {
            if (c === '&') {
              parser.state = S.ATTRIB_VALUE_ENTITY_U
            } else {
              parser.attribValue += c
            }
            continue
          }
          attrib(parser)
          if (c === '>') {
            openTag(parser)
          } else {
            parser.state = S.ATTRIB
          }
          continue

        case S.CLOSE_TAG:
          if (!parser.tagName) {
            if (isWhitespace(c)) {
              continue
            } else if (notMatch(nameStart, c)) {
              if (parser.script) {
                parser.script += '</' + c
                parser.state = S.SCRIPT
              } else {
                strictFail(parser, 'Invalid tagname in closing tag.')
              }
            } else {
              parser.tagName = c
            }
          } else if (c === '>') {
            closeTag(parser)
          } else if (isMatch(nameBody, c)) {
            parser.tagName += c
          } else if (parser.script) {
            parser.script += '</' + parser.tagName
            parser.tagName = ''
            parser.state = S.SCRIPT
          } else {
            if (!isWhitespace(c)) {
              strictFail(parser, 'Invalid tagname in closing tag')
            }
            parser.state = S.CLOSE_TAG_SAW_WHITE
          }
          continue

        case S.CLOSE_TAG_SAW_WHITE:
          if (isWhitespace(c)) {
            continue
          }
          if (c === '>') {
            closeTag(parser)
          } else {
            strictFail(parser, 'Invalid characters in closing tag')
          }
          continue

        case S.TEXT_ENTITY:
        case S.ATTRIB_VALUE_ENTITY_Q:
        case S.ATTRIB_VALUE_ENTITY_U:
          var returnState
          var buffer
          switch (parser.state) {
            case S.TEXT_ENTITY:
              returnState = S.TEXT
              buffer = 'textNode'
              break

            case S.ATTRIB_VALUE_ENTITY_Q:
              returnState = S.ATTRIB_VALUE_QUOTED
              buffer = 'attribValue'
              break

            case S.ATTRIB_VALUE_ENTITY_U:
              returnState = S.ATTRIB_VALUE_UNQUOTED
              buffer = 'attribValue'
              break
          }

          if (c === ';') {
            if (parser.opt.unparsedEntities) {
              var parsedEntity = parseEntity(parser)
              parser.entity = ''
              parser.state = returnState
              parser.write(parsedEntity)
            } else {
              parser[buffer] += parseEntity(parser)
              parser.entity = ''
              parser.state = returnState
            }
          } else if (isMatch(parser.entity.length ? entityBody : entityStart, c)) {
            parser.entity += c
          } else {
            strictFail(parser, 'Invalid character in entity name')
            parser[buffer] += '&' + parser.entity + c
            parser.entity = ''
            parser.state = returnState
          }

          continue

        default: /* istanbul ignore next */ {
          throw new Error(parser, 'Unknown state: ' + parser.state)
        }
      }
    } // while

    if (parser.position >= parser.bufferCheckPosition) {
      checkBufferLength(parser)
    }
    return parser
  }

  /*! http://mths.be/fromcodepoint v0.1.0 by @mathias */
  /* istanbul ignore next */
  if (!String.fromCodePoint) {
    (function () {
      var stringFromCharCode = String.fromCharCode
      var floor = Math.floor
      var fromCodePoint = function () {
        var MAX_SIZE = 0x4000
        var codeUnits = []
        var highSurrogate
        var lowSurrogate
        var index = -1
        var length = arguments.length
        if (!length) {
          return ''
        }
        var result = ''
        while (++index < length) {
          var codePoint = Number(arguments[index])
          if (
            !isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
            codePoint < 0 || // not a valid Unicode code point
            codePoint > 0x10FFFF || // not a valid Unicode code point
            floor(codePoint) !== codePoint // not an integer
          ) {
            throw RangeError('Invalid code point: ' + codePoint)
          }
          if (codePoint <= 0xFFFF) { // BMP code point
            codeUnits.push(codePoint)
          } else { // Astral code point; split in surrogate halves
            // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
            codePoint -= 0x10000
            highSurrogate = (codePoint >> 10) + 0xD800
            lowSurrogate = (codePoint % 0x400) + 0xDC00
            codeUnits.push(highSurrogate, lowSurrogate)
          }
          if (index + 1 === length || codeUnits.length > MAX_SIZE) {
            result += stringFromCharCode.apply(null, codeUnits)
            codeUnits.length = 0
          }
        }
        return result
      }
      /* istanbul ignore next */
      if (Object.defineProperty) {
        Object.defineProperty(String, 'fromCodePoint', {
          value: fromCodePoint,
          configurable: true,
          writable: true
        })
      } else {
        String.fromCodePoint = fromCodePoint
      }
    }())
  }
})(typeof exports === 'undefined' ? this.sax = {} : exports)

}).call(this)}).call(this,require(1202).Buffer)
},{"1202":1202,"1569":1569,"1570":1570}],1569:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = require(1547).EventEmitter;
var inherits = require(1550);

inherits(Stream, EE);
Stream.Readable = require(1556);
Stream.Writable = require(1558);
Stream.Duplex = require(1554);
Stream.Transform = require(1557);
Stream.PassThrough = require(1555);
Stream.finished = require(1562)
Stream.pipeline = require(1564)

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};

},{"1547":1547,"1550":1550,"1554":1554,"1555":1555,"1556":1556,"1557":1557,"1558":1558,"1562":1562,"1564":1564}],1564:[function(require,module,exports){
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).

'use strict';

var eos;
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    callback.apply(void 0, arguments);
  };
}
var _require$codes = require(1553).codes,
  ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
function noop(err) {
  // Rethrow the error if it exists to avoid swallowing it
  if (err) throw err;
}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function destroyer(stream, reading, writing, callback) {
  callback = once(callback);
  var closed = false;
  stream.on('close', function () {
    closed = true;
  });
  if (eos === undefined) eos = require(1562);
  eos(stream, {
    readable: reading,
    writable: writing
  }, function (err) {
    if (err) return callback(err);
    closed = true;
    callback();
  });
  var destroyed = false;
  return function (err) {
    if (closed) return;
    if (destroyed) return;
    destroyed = true;

    // request.destroy just do .end - .abort is what we want
    if (isRequest(stream)) return stream.abort();
    if (typeof stream.destroy === 'function') return stream.destroy();
    callback(err || new ERR_STREAM_DESTROYED('pipe'));
  };
}
function call(fn) {
  fn();
}
function pipe(from, to) {
  return from.pipe(to);
}
function popCallback(streams) {
  if (!streams.length) return noop;
  if (typeof streams[streams.length - 1] !== 'function') return noop;
  return streams.pop();
}
function pipeline() {
  for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
    streams[_key] = arguments[_key];
  }
  var callback = popCallback(streams);
  if (Array.isArray(streams[0])) streams = streams[0];
  if (streams.length < 2) {
    throw new ERR_MISSING_ARGS('streams');
  }
  var error;
  var destroys = streams.map(function (stream, i) {
    var reading = i < streams.length - 1;
    var writing = i > 0;
    return destroyer(stream, reading, writing, function (err) {
      if (!error) error = err;
      if (err) destroys.forEach(call);
      if (reading) return;
      destroys.forEach(call);
      callback(error);
    });
  });
  return streams.reduce(pipe);
}
module.exports = pipeline;
},{"1553":1553,"1562":1562}],1555:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.

'use strict';

module.exports = PassThrough;
var Transform = require(1557);
require(1550)(PassThrough, Transform);
function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);
  Transform.call(this, options);
}
PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};
},{"1550":1550,"1557":1557}],1557:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

'use strict';

module.exports = Transform;
var _require$codes = require(1553).codes,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING,
  ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
var Duplex = require(1554);
require(1550)(Transform, Duplex);
function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;
  var cb = ts.writecb;
  if (cb === null) {
    return this.emit('error', new ERR_MULTIPLE_CALLBACK());
  }
  ts.writechunk = null;
  ts.writecb = null;
  if (data != null)
    // single equals check for both `null` and `undefined`
    this.push(data);
  cb(er);
  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}
function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);
  Duplex.call(this, options);
  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;
  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;
    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}
function prefinish() {
  var _this = this;
  if (typeof this._flush === 'function' && !this._readableState.destroyed) {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}
Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;
  if (ts.writechunk !== null && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};
Transform.prototype._destroy = function (err, cb) {
  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
  });
};
function done(stream, er, data) {
  if (er) return stream.emit('error', er);
  if (data != null)
    // single equals check for both `null` and `undefined`
    stream.push(data);

  // TODO(BridgeAR): Write a test for these two error cases
  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
  if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
  return stream.push(null);
}
},{"1550":1550,"1553":1553,"1554":1554}],1554:[function(require,module,exports){
(function (process){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

'use strict';

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
};
/*</replacement>*/

module.exports = Duplex;
var Readable = require(1556);
var Writable = require(1558);
require(1550)(Duplex, Readable);
{
  // Allow the keys array to be GC'ed.
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}
function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);
  Readable.call(this, options);
  Writable.call(this, options);
  this.allowHalfOpen = true;
  if (options) {
    if (options.readable === false) this.readable = false;
    if (options.writable === false) this.writable = false;
    if (options.allowHalfOpen === false) {
      this.allowHalfOpen = false;
      this.once('end', onend);
    }
  }
}
Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});
Object.defineProperty(Duplex.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
Object.defineProperty(Duplex.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});

// the no-half-open enforcer
function onend() {
  // If the writable side ended, then we're ok.
  if (this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  process.nextTick(onEndNT, this);
}
function onEndNT(self) {
  self.end();
}
Object.defineProperty(Duplex.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});
}).call(this)}).call(this,require(1552))
},{"1550":1550,"1552":1552,"1556":1556,"1558":1558}],1558:[function(require,module,exports){
(function (process,global){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

'use strict';

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;
  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var internalUtil = {
  deprecate: require(1571)
};
/*</replacement>*/

/*<replacement>*/
var Stream = require(1566);
/*</replacement>*/

var Buffer = require(1202).Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
var destroyImpl = require(1561);
var _require = require(1565),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = require(1553).codes,
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED,
  ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES,
  ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END,
  ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
var errorOrDestroy = destroyImpl.errorOrDestroy;
require(1550)(Writable, Stream);
function nop() {}
function WritableState(options, stream, isDuplex) {
  Duplex = Duplex || require(1554);
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream,
  // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;
  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'finish' (and potentially 'end')
  this.autoDestroy = !!options.autoDestroy;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};
(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function writableStateBufferGetter() {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function value(object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;
      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function realHasInstance(object) {
    return object instanceof this;
  };
}
function Writable(options) {
  Duplex = Duplex || require(1554);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the WritableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
  this._writableState = new WritableState(options, this, isDuplex);

  // legacy.
  this.writable = true;
  if (options) {
    if (typeof options.write === 'function') this._write = options.write;
    if (typeof options.writev === 'function') this._writev = options.writev;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
    if (typeof options.final === 'function') this._final = options.final;
  }
  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};
function writeAfterEnd(stream, cb) {
  var er = new ERR_STREAM_WRITE_AFTER_END();
  // TODO: defer error events consistently everywhere, not just the cb
  errorOrDestroy(stream, er);
  process.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var er;
  if (chunk === null) {
    er = new ERR_STREAM_NULL_VALUES();
  } else if (typeof chunk !== 'string' && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer'], chunk);
  }
  if (er) {
    errorOrDestroy(stream, er);
    process.nextTick(cb, er);
    return false;
  }
  return true;
}
Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);
  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }
  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
  if (typeof cb !== 'function') cb = nop;
  if (state.ending) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }
  return ret;
};
Writable.prototype.cork = function () {
  this._writableState.corked++;
};
Writable.prototype.uncork = function () {
  var state = this._writableState;
  if (state.corked) {
    state.corked--;
    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};
Object.defineProperty(Writable.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}
Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;
  state.length += len;
  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;
  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }
  return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));else if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;
  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    process.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    process.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}
function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}
function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;
  if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
  onwriteStateUpdate(state);
  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state) || stream.destroyed;
    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }
    if (sync) {
      process.nextTick(afterWrite, stream, state, finished, cb);
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}
function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;
  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;
    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;
    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;
      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }
    if (entry === null) state.lastBufferedRequest = null;
  }
  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}
Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
Writable.prototype._writev = null;
Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;
  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending) endWritable(this, state, cb);
  return this;
};
Object.defineProperty(Writable.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});
function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      errorOrDestroy(stream, err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function' && !state.destroyed) {
      state.pendingcb++;
      state.finalCalled = true;
      process.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}
function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
      if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well
        var rState = stream._readableState;
        if (!rState || rState.autoDestroy && rState.endEmitted) {
          stream.destroy();
        }
      }
    }
  }
  return need;
}
function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) process.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}
function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }

  // reuse the free corkReq.
  state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty(Writable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  cb(err);
};
}).call(this)}).call(this,require(1552),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"1202":1202,"1550":1550,"1552":1552,"1553":1553,"1554":1554,"1561":1561,"1565":1565,"1566":1566,"1571":1571}],1571:[function(require,module,exports){
(function (global){(function (){

/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],1556:[function(require,module,exports){
(function (process,global){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

module.exports = Readable;

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = require(1547).EventEmitter;
var EElistenerCount = function EElistenerCount(emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = require(1566);
/*</replacement>*/

var Buffer = require(1202).Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*<replacement>*/
var debugUtil = require(1201);
var debug;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function debug() {};
}
/*</replacement>*/

var BufferList = require(1560);
var destroyImpl = require(1561);
var _require = require(1565),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = require(1553).codes,
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;

// Lazy loaded to improve the startup performance.
var StringDecoder;
var createReadableStreamAsyncIterator;
var from;
require(1550)(Readable, Stream);
var errorOrDestroy = destroyImpl.errorOrDestroy;
var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}
function ReadableState(options, stream, isDuplex) {
  Duplex = Duplex || require(1554);
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;
  this.paused = true;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'end' (and potentially 'finish')
  this.autoDestroy = !!options.autoDestroy;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;
  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = require(1570).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}
function Readable(options) {
  Duplex = Duplex || require(1554);
  if (!(this instanceof Readable)) return new Readable(options);

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the ReadableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  this._readableState = new ReadableState(options, this, isDuplex);

  // legacy
  this.readable = true;
  if (options) {
    if (typeof options.read === 'function') this._read = options.read;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }
  Stream.call(this);
}
Object.defineProperty(Readable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;
  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }
  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};
function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  debug('readableAddChunk', chunk);
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      errorOrDestroy(stream, er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }
      if (addToFront) {
        if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
      } else if (state.destroyed) {
        return false;
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
      maybeReadMore(stream, state);
    }
  }

  // We can push more data if we are below the highWaterMark.
  // Also, if we have no data yet, we can stand some more bytes.
  // This is to work around cases where hwm=0, such as the repl.
  return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    state.awaitDrain = 0;
    stream.emit('data', chunk);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}
function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk);
  }
  return er;
}
Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = require(1570).StringDecoder;
  var decoder = new StringDecoder(enc);
  this._readableState.decoder = decoder;
  // If setEncoding(null), decoder.encoding equals utf8
  this._readableState.encoding = this._readableState.decoder.encoding;

  // Iterate over current buffer to convert already stored Buffers:
  var p = this._readableState.buffer.head;
  var content = '';
  while (p !== null) {
    content += decoder.write(p.data);
    p = p.next;
  }
  this._readableState.buffer.clear();
  if (content !== '') this._readableState.buffer.push(content);
  this._readableState.length = content.length;
  return this;
};

// Don't raise the hwm > 1GB
var MAX_HWM = 0x40000000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;
  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }
  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }
  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;
  if (ret === null) {
    state.needReadable = state.length <= state.highWaterMark;
    n = 0;
  } else {
    state.length -= n;
    state.awaitDrain = 0;
  }
  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }
  if (ret !== null) this.emit('data', ret);
  return ret;
};
function onEofChunk(stream, state) {
  debug('onEofChunk');
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;
  if (state.sync) {
    // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
  } else {
    // emit 'readable' now to make sure it gets picked up.
    state.needReadable = false;
    if (!state.emittedReadable) {
      state.emittedReadable = true;
      emitReadable_(stream);
    }
  }
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  debug('emitReadable', state.needReadable, state.emittedReadable);
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    process.nextTick(emitReadable_, stream);
  }
}
function emitReadable_(stream) {
  var state = stream._readableState;
  debug('emitReadable_', state.destroyed, state.length, state.ended);
  if (!state.destroyed && (state.length || state.ended)) {
    stream.emit('readable');
    state.emittedReadable = false;
  }

  // The stream needs another readable event if
  // 1. It is not flowing, as the flow mechanism will take
  //    care of it.
  // 2. It is not ended.
  // 3. It is below the highWaterMark, so we can schedule
  //    another readable later.
  state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    process.nextTick(maybeReadMore_, stream, state);
  }
}
function maybeReadMore_(stream, state) {
  // Attempt to read more data if we should.
  //
  // The conditions for reading more data are (one of):
  // - Not enough data buffered (state.length < state.highWaterMark). The loop
  //   is responsible for filling the buffer with enough data if such data
  //   is available. If highWaterMark is 0 and we are not in the flowing mode
  //   we should _not_ attempt to buffer any extra data. We'll get more data
  //   when the stream consumer calls read() instead.
  // - No data in the buffer, and the stream is in flowing mode. In this mode
  //   the loop below is responsible for ensuring read() is called. Failing to
  //   call read here would abort the flow and there's no other mechanism for
  //   continuing the flow if the stream consumer has just subscribed to the
  //   'data' event.
  //
  // In addition to the above conditions to keep reading data, the following
  // conditions prevent the data from being read:
  // - The stream has ended (state.ended).
  // - There is already a pending 'read' operation (state.reading). This is a
  //   case where the the stream has called the implementation defined _read()
  //   method, but they are processing the call asynchronously and have _not_
  //   called push() with new data. In this case we skip performing more
  //   read()s. The execution ends in this method again after the _read() ends
  //   up calling push() with more data.
  while (!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)) {
    var len = state.length;
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;
  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) process.nextTick(endFn);else src.once('end', endFn);
  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }
  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);
  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);
    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    var ret = dest.write(chunk);
    debug('dest.write', ret);
    if (ret === false) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', state.awaitDrain);
        state.awaitDrain++;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);
  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }
  return dest;
};
function pipeOnDrain(src) {
  return function pipeOnDrainFunctionResult() {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}
Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = {
    hasUnpiped: false
  };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;
    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    for (var i = 0; i < len; i++) dests[i].emit('unpipe', this, {
      hasUnpiped: false
    });
    return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;
  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];
  dest.emit('unpipe', this, unpipeInfo);
  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);
  var state = this._readableState;
  if (ev === 'data') {
    // update readableListening so that resume() may be a no-op
    // a few lines down. This is needed to support once('readable').
    state.readableListening = this.listenerCount('readable') > 0;

    // Try start flowing on next tick if stream isn't explicitly paused
    if (state.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.flowing = false;
      state.emittedReadable = false;
      debug('on readable', state.length, state.reading);
      if (state.length) {
        emitReadable(this);
      } else if (!state.reading) {
        process.nextTick(nReadingNextTick, this);
      }
    }
  }
  return res;
};
Readable.prototype.addListener = Readable.prototype.on;
Readable.prototype.removeListener = function (ev, fn) {
  var res = Stream.prototype.removeListener.call(this, ev, fn);
  if (ev === 'readable') {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
Readable.prototype.removeAllListeners = function (ev) {
  var res = Stream.prototype.removeAllListeners.apply(this, arguments);
  if (ev === 'readable' || ev === undefined) {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
function updateReadableListening(self) {
  var state = self._readableState;
  state.readableListening = self.listenerCount('readable') > 0;
  if (state.resumeScheduled && !state.paused) {
    // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;

    // crude way to check if we should resume
  } else if (self.listenerCount('data') > 0) {
    self.resume();
  }
}
function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    // we flow only if there is no one listening
    // for readable, but we still have to call
    // resume()
    state.flowing = !state.readableListening;
    resume(this, state);
  }
  state.paused = false;
  return this;
};
function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    process.nextTick(resume_, stream, state);
  }
}
function resume_(stream, state) {
  debug('resume', state.reading);
  if (!state.reading) {
    stream.read(0);
  }
  state.resumeScheduled = false;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (this._readableState.flowing !== false) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  this._readableState.paused = true;
  return this;
};
function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null);
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;
  var state = this._readableState;
  var paused = false;
  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }
    _this.push(null);
  });
  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };
  return this;
};
if (typeof Symbol === 'function') {
  Readable.prototype[Symbol.asyncIterator] = function () {
    if (createReadableStreamAsyncIterator === undefined) {
      createReadableStreamAsyncIterator = require(1559);
    }
    return createReadableStreamAsyncIterator(this);
  };
}
Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.highWaterMark;
  }
});
Object.defineProperty(Readable.prototype, 'readableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState && this._readableState.buffer;
  }
});
Object.defineProperty(Readable.prototype, 'readableFlowing', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.flowing;
  },
  set: function set(state) {
    if (this._readableState) {
      this._readableState.flowing = state;
    }
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, 'readableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.length;
  }
});

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;
  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.first();else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = state.buffer.consume(n, state.decoder);
  }
  return ret;
}
function endReadable(stream) {
  var state = stream._readableState;
  debug('endReadable', state.endEmitted);
  if (!state.endEmitted) {
    state.ended = true;
    process.nextTick(endReadableNT, state, stream);
  }
}
function endReadableNT(state, stream) {
  debug('endReadableNT', state.endEmitted, state.length);

  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
    if (state.autoDestroy) {
      // In case of duplex streams we need a way to detect
      // if the writable side is ready for autoDestroy as well
      var wState = stream._writableState;
      if (!wState || wState.autoDestroy && wState.finished) {
        stream.destroy();
      }
    }
  }
}
if (typeof Symbol === 'function') {
  Readable.from = function (iterable, opts) {
    if (from === undefined) {
      from = require(1563);
    }
    return from(Readable, iterable, opts);
  };
}
function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
}).call(this)}).call(this,require(1552),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"1201":1201,"1202":1202,"1547":1547,"1550":1550,"1552":1552,"1553":1553,"1554":1554,"1559":1559,"1560":1560,"1561":1561,"1563":1563,"1565":1565,"1566":1566,"1570":1570}],1570:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

/*<replacement>*/

var Buffer = require(1567).Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}
},{"1567":1567}],1567:[function(require,module,exports){
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = require(1202)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}

},{"1202":1202}],1566:[function(require,module,exports){
module.exports = require(1547).EventEmitter;

},{"1547":1547}],1565:[function(require,module,exports){
'use strict';

var ERR_INVALID_OPT_VALUE = require(1553).codes.ERR_INVALID_OPT_VALUE;
function highWaterMarkFrom(options, isDuplex, duplexKey) {
  return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function getHighWaterMark(state, options, duplexKey, isDuplex) {
  var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
  if (hwm != null) {
    if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
      var name = isDuplex ? duplexKey : 'highWaterMark';
      throw new ERR_INVALID_OPT_VALUE(name, hwm);
    }
    return Math.floor(hwm);
  }

  // Default value
  return state.objectMode ? 16 : 16 * 1024;
}
module.exports = {
  getHighWaterMark: getHighWaterMark
};
},{"1553":1553}],1563:[function(require,module,exports){
module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};

},{}],1561:[function(require,module,exports){
(function (process){(function (){
'use strict';

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;
  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;
  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err) {
      if (!this._writableState) {
        process.nextTick(emitErrorNT, this, err);
      } else if (!this._writableState.errorEmitted) {
        this._writableState.errorEmitted = true;
        process.nextTick(emitErrorNT, this, err);
      }
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }
  this._destroy(err || null, function (err) {
    if (!cb && err) {
      if (!_this._writableState) {
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else if (!_this._writableState.errorEmitted) {
        _this._writableState.errorEmitted = true;
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else {
        process.nextTick(emitCloseNT, _this);
      }
    } else if (cb) {
      process.nextTick(emitCloseNT, _this);
      cb(err);
    } else {
      process.nextTick(emitCloseNT, _this);
    }
  });
  return this;
}
function emitErrorAndCloseNT(self, err) {
  emitErrorNT(self, err);
  emitCloseNT(self);
}
function emitCloseNT(self) {
  if (self._writableState && !self._writableState.emitClose) return;
  if (self._readableState && !self._readableState.emitClose) return;
  self.emit('close');
}
function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }
  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finalCalled = false;
    this._writableState.prefinished = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}
function emitErrorNT(self, err) {
  self.emit('error', err);
}
function errorOrDestroy(stream, err) {
  // We have tests that rely on errors being emitted
  // in the same tick, so changing this is semver major.
  // For now when you opt-in to autoDestroy we allow
  // the error to be emitted nextTick. In a future
  // semver major update we should change the default to this.

  var rState = stream._readableState;
  var wState = stream._writableState;
  if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);else stream.emit('error', err);
}
module.exports = {
  destroy: destroy,
  undestroy: undestroy,
  errorOrDestroy: errorOrDestroy
};
}).call(this)}).call(this,require(1552))
},{"1552":1552}],1560:[function(require,module,exports){
'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _require = require(1202),
  Buffer = _require.Buffer;
var _require2 = require(1201),
  inspect = _require2.inspect;
var custom = inspect && inspect.custom || 'inspect';
function copyBuffer(src, target, offset) {
  Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/function () {
  function BufferList() {
    _classCallCheck(this, BufferList);
    this.head = null;
    this.tail = null;
    this.length = 0;
  }
  _createClass(BufferList, [{
    key: "push",
    value: function push(v) {
      var entry = {
        data: v,
        next: null
      };
      if (this.length > 0) this.tail.next = entry;else this.head = entry;
      this.tail = entry;
      ++this.length;
    }
  }, {
    key: "unshift",
    value: function unshift(v) {
      var entry = {
        data: v,
        next: this.head
      };
      if (this.length === 0) this.tail = entry;
      this.head = entry;
      ++this.length;
    }
  }, {
    key: "shift",
    value: function shift() {
      if (this.length === 0) return;
      var ret = this.head.data;
      if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
      --this.length;
      return ret;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.head = this.tail = null;
      this.length = 0;
    }
  }, {
    key: "join",
    value: function join(s) {
      if (this.length === 0) return '';
      var p = this.head;
      var ret = '' + p.data;
      while (p = p.next) ret += s + p.data;
      return ret;
    }
  }, {
    key: "concat",
    value: function concat(n) {
      if (this.length === 0) return Buffer.alloc(0);
      var ret = Buffer.allocUnsafe(n >>> 0);
      var p = this.head;
      var i = 0;
      while (p) {
        copyBuffer(p.data, ret, i);
        i += p.data.length;
        p = p.next;
      }
      return ret;
    }

    // Consumes a specified amount of bytes or characters from the buffered data.
  }, {
    key: "consume",
    value: function consume(n, hasStrings) {
      var ret;
      if (n < this.head.data.length) {
        // `slice` is the same for buffers and strings.
        ret = this.head.data.slice(0, n);
        this.head.data = this.head.data.slice(n);
      } else if (n === this.head.data.length) {
        // First chunk is a perfect match.
        ret = this.shift();
      } else {
        // Result spans more than one buffer.
        ret = hasStrings ? this._getString(n) : this._getBuffer(n);
      }
      return ret;
    }
  }, {
    key: "first",
    value: function first() {
      return this.head.data;
    }

    // Consumes a specified amount of characters from the buffered data.
  }, {
    key: "_getString",
    value: function _getString(n) {
      var p = this.head;
      var c = 1;
      var ret = p.data;
      n -= ret.length;
      while (p = p.next) {
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
          if (nb === str.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = str.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Consumes a specified amount of bytes from the buffered data.
  }, {
    key: "_getBuffer",
    value: function _getBuffer(n) {
      var ret = Buffer.allocUnsafe(n);
      var p = this.head;
      var c = 1;
      p.data.copy(ret);
      n -= p.data.length;
      while (p = p.next) {
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
          if (nb === buf.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = buf.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Make sure the linked list only shows the minimal necessary information.
  }, {
    key: custom,
    value: function value(_, options) {
      return inspect(this, _objectSpread(_objectSpread({}, options), {}, {
        // Only inspect one level.
        depth: 0,
        // It should not recurse.
        customInspect: false
      }));
    }
  }]);
  return BufferList;
}();
},{"1201":1201,"1202":1202}],1559:[function(require,module,exports){
(function (process){(function (){
'use strict';

var _Object$setPrototypeO;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var finished = require(1562);
var kLastResolve = Symbol('lastResolve');
var kLastReject = Symbol('lastReject');
var kError = Symbol('error');
var kEnded = Symbol('ended');
var kLastPromise = Symbol('lastPromise');
var kHandlePromise = Symbol('handlePromise');
var kStream = Symbol('stream');
function createIterResult(value, done) {
  return {
    value: value,
    done: done
  };
}
function readAndResolve(iter) {
  var resolve = iter[kLastResolve];
  if (resolve !== null) {
    var data = iter[kStream].read();
    // we defer if data is null
    // we can be expecting either 'end' or
    // 'error'
    if (data !== null) {
      iter[kLastPromise] = null;
      iter[kLastResolve] = null;
      iter[kLastReject] = null;
      resolve(createIterResult(data, false));
    }
  }
}
function onReadable(iter) {
  // we wait for the next tick, because it might
  // emit an error with process.nextTick
  process.nextTick(readAndResolve, iter);
}
function wrapForNext(lastPromise, iter) {
  return function (resolve, reject) {
    lastPromise.then(function () {
      if (iter[kEnded]) {
        resolve(createIterResult(undefined, true));
        return;
      }
      iter[kHandlePromise](resolve, reject);
    }, reject);
  };
}
var AsyncIteratorPrototype = Object.getPrototypeOf(function () {});
var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
  get stream() {
    return this[kStream];
  },
  next: function next() {
    var _this = this;
    // if we have detected an error in the meanwhile
    // reject straight away
    var error = this[kError];
    if (error !== null) {
      return Promise.reject(error);
    }
    if (this[kEnded]) {
      return Promise.resolve(createIterResult(undefined, true));
    }
    if (this[kStream].destroyed) {
      // We need to defer via nextTick because if .destroy(err) is
      // called, the error will be emitted via nextTick, and
      // we cannot guarantee that there is no error lingering around
      // waiting to be emitted.
      return new Promise(function (resolve, reject) {
        process.nextTick(function () {
          if (_this[kError]) {
            reject(_this[kError]);
          } else {
            resolve(createIterResult(undefined, true));
          }
        });
      });
    }

    // if we have multiple next() calls
    // we will wait for the previous Promise to finish
    // this logic is optimized to support for await loops,
    // where next() is only called once at a time
    var lastPromise = this[kLastPromise];
    var promise;
    if (lastPromise) {
      promise = new Promise(wrapForNext(lastPromise, this));
    } else {
      // fast path needed to support multiple this.push()
      // without triggering the next() queue
      var data = this[kStream].read();
      if (data !== null) {
        return Promise.resolve(createIterResult(data, false));
      }
      promise = new Promise(this[kHandlePromise]);
    }
    this[kLastPromise] = promise;
    return promise;
  }
}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function () {
  return this;
}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
  var _this2 = this;
  // destroy(err, cb) is a private API
  // we can guarantee we have that here, because we control the
  // Readable class this is attached to
  return new Promise(function (resolve, reject) {
    _this2[kStream].destroy(null, function (err) {
      if (err) {
        reject(err);
        return;
      }
      resolve(createIterResult(undefined, true));
    });
  });
}), _Object$setPrototypeO), AsyncIteratorPrototype);
var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
  var _Object$create;
  var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
    value: stream,
    writable: true
  }), _defineProperty(_Object$create, kLastResolve, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kLastReject, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kError, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kEnded, {
    value: stream._readableState.endEmitted,
    writable: true
  }), _defineProperty(_Object$create, kHandlePromise, {
    value: function value(resolve, reject) {
      var data = iterator[kStream].read();
      if (data) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        resolve(createIterResult(data, false));
      } else {
        iterator[kLastResolve] = resolve;
        iterator[kLastReject] = reject;
      }
    },
    writable: true
  }), _Object$create));
  iterator[kLastPromise] = null;
  finished(stream, function (err) {
    if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
      var reject = iterator[kLastReject];
      // reject if we are waiting for data in the Promise
      // returned by next() and store the error
      if (reject !== null) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        reject(err);
      }
      iterator[kError] = err;
      return;
    }
    var resolve = iterator[kLastResolve];
    if (resolve !== null) {
      iterator[kLastPromise] = null;
      iterator[kLastResolve] = null;
      iterator[kLastReject] = null;
      resolve(createIterResult(undefined, true));
    }
    iterator[kEnded] = true;
  });
  stream.on('readable', onReadable.bind(null, iterator));
  return iterator;
};
module.exports = createReadableStreamAsyncIterator;
}).call(this)}).call(this,require(1552))
},{"1552":1552,"1562":1562}],1562:[function(require,module,exports){
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).

'use strict';

var ERR_STREAM_PREMATURE_CLOSE = require(1553).codes.ERR_STREAM_PREMATURE_CLOSE;
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    callback.apply(this, args);
  };
}
function noop() {}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function eos(stream, opts, callback) {
  if (typeof opts === 'function') return eos(stream, null, opts);
  if (!opts) opts = {};
  callback = once(callback || noop);
  var readable = opts.readable || opts.readable !== false && stream.readable;
  var writable = opts.writable || opts.writable !== false && stream.writable;
  var onlegacyfinish = function onlegacyfinish() {
    if (!stream.writable) onfinish();
  };
  var writableEnded = stream._writableState && stream._writableState.finished;
  var onfinish = function onfinish() {
    writable = false;
    writableEnded = true;
    if (!readable) callback.call(stream);
  };
  var readableEnded = stream._readableState && stream._readableState.endEmitted;
  var onend = function onend() {
    readable = false;
    readableEnded = true;
    if (!writable) callback.call(stream);
  };
  var onerror = function onerror(err) {
    callback.call(stream, err);
  };
  var onclose = function onclose() {
    var err;
    if (readable && !readableEnded) {
      if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
    if (writable && !writableEnded) {
      if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
  };
  var onrequest = function onrequest() {
    stream.req.on('finish', onfinish);
  };
  if (isRequest(stream)) {
    stream.on('complete', onfinish);
    stream.on('abort', onclose);
    if (stream.req) onrequest();else stream.on('request', onrequest);
  } else if (writable && !stream._writableState) {
    // legacy streams
    stream.on('end', onlegacyfinish);
    stream.on('close', onlegacyfinish);
  }
  stream.on('end', onend);
  stream.on('finish', onfinish);
  if (opts.error !== false) stream.on('error', onerror);
  stream.on('close', onclose);
  return function () {
    stream.removeListener('complete', onfinish);
    stream.removeListener('abort', onclose);
    stream.removeListener('request', onrequest);
    if (stream.req) stream.req.removeListener('finish', onfinish);
    stream.removeListener('end', onlegacyfinish);
    stream.removeListener('close', onlegacyfinish);
    stream.removeListener('finish', onfinish);
    stream.removeListener('end', onend);
    stream.removeListener('error', onerror);
    stream.removeListener('close', onclose);
  };
}
module.exports = eos;
},{"1553":1553}],1553:[function(require,module,exports){
'use strict';

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var codes = {};

function createErrorType(code, message, Base) {
  if (!Base) {
    Base = Error;
  }

  function getMessage(arg1, arg2, arg3) {
    if (typeof message === 'string') {
      return message;
    } else {
      return message(arg1, arg2, arg3);
    }
  }

  var NodeError =
  /*#__PURE__*/
  function (_Base) {
    _inheritsLoose(NodeError, _Base);

    function NodeError(arg1, arg2, arg3) {
      return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
    }

    return NodeError;
  }(Base);

  NodeError.prototype.name = Base.name;
  NodeError.prototype.code = code;
  codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js


function oneOf(expected, thing) {
  if (Array.isArray(expected)) {
    var len = expected.length;
    expected = expected.map(function (i) {
      return String(i);
    });

    if (len > 2) {
      return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
    } else if (len === 2) {
      return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
    } else {
      return "of ".concat(thing, " ").concat(expected[0]);
    }
  } else {
    return "of ".concat(thing, " ").concat(String(expected));
  }
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith


function startsWith(str, search, pos) {
  return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


function endsWith(str, search, this_len) {
  if (this_len === undefined || this_len > str.length) {
    this_len = str.length;
  }

  return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes


function includes(str, search, start) {
  if (typeof start !== 'number') {
    start = 0;
  }

  if (start + search.length > str.length) {
    return false;
  } else {
    return str.indexOf(search, start) !== -1;
  }
}

createErrorType('ERR_INVALID_OPT_VALUE', function (name, value) {
  return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
  // determiner: 'must be' or 'must not be'
  var determiner;

  if (typeof expected === 'string' && startsWith(expected, 'not ')) {
    determiner = 'must not be';
    expected = expected.replace(/^not /, '');
  } else {
    determiner = 'must be';
  }

  var msg;

  if (endsWith(name, ' argument')) {
    // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  } else {
    var type = includes(name, '.') ? 'property' : 'argument';
    msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  }

  msg += ". Received type ".concat(typeof actual);
  return msg;
}, TypeError);
createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function (name) {
  return 'The ' + name + ' method is not implemented';
});
createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
createErrorType('ERR_STREAM_DESTROYED', function (name) {
  return 'Cannot call ' + name + ' after a stream was destroyed';
});
createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
createErrorType('ERR_UNKNOWN_ENCODING', function (arg) {
  return 'Unknown encoding: ' + arg;
}, TypeError);
createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
module.exports.codes = codes;

},{}],1201:[function(require,module,exports){

},{}],1550:[function(require,module,exports){
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}

},{}],1547:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}

},{}],1575:[function(require,module,exports){
(function (Buffer){(function (){
var js2xml = require(1574);

module.exports = function (json, options) {
  if (json instanceof Buffer) {
    json = json.toString();
  }
  var js = null;
  if (typeof (json) === 'string') {
    try {
      js = JSON.parse(json);
    } catch (e) {
      throw new Error('The JSON structure is invalid');
    }
  } else {
    js = json;
  }
  return js2xml(js, options);
};

}).call(this)}).call(this,require(1202).Buffer)
},{"1202":1202,"1574":1574}],1202:[function(require,module,exports){
(function (Buffer){(function (){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */

'use strict'

var base64 = require(1200)
var ieee754 = require(1549)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

var K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function () { return 42 } }
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  buf.__proto__ = Buffer.prototype
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

// Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
if (typeof Symbol !== 'undefined' && Symbol.species != null &&
    Buffer[Symbol.species] === Buffer) {
  Object.defineProperty(Buffer, Symbol.species, {
    value: null,
    configurable: true,
    enumerable: false,
    writable: false
  })
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayLike(value)
  }

  if (value == null) {
    throw TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Buffer.prototype.__proto__ = Uint8Array.prototype
Buffer.__proto__ = Uint8Array

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  buf.__proto__ = Buffer.prototype
  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      buf = Buffer.from(buf)
    }
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
        : (firstByte > 0xBF) ? 2
          : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  newBuf.__proto__ = Buffer.prototype
  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (var i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

}).call(this)}).call(this,require(1202).Buffer)
},{"1200":1200,"1202":1202,"1549":1549}],1549:[function(require,module,exports){
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}

},{}],1200:[function(require,module,exports){
'use strict'

exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}

},{}],1574:[function(require,module,exports){
var helper = require(1576);
var isArray = require(1572).isArray;

var currentElement, currentElementName;

function validateOptions(userOptions) {
  var options = helper.copyOptions(userOptions);
  helper.ensureFlagExists('ignoreDeclaration', options);
  helper.ensureFlagExists('ignoreInstruction', options);
  helper.ensureFlagExists('ignoreAttributes', options);
  helper.ensureFlagExists('ignoreText', options);
  helper.ensureFlagExists('ignoreComment', options);
  helper.ensureFlagExists('ignoreCdata', options);
  helper.ensureFlagExists('ignoreDoctype', options);
  helper.ensureFlagExists('compact', options);
  helper.ensureFlagExists('indentText', options);
  helper.ensureFlagExists('indentCdata', options);
  helper.ensureFlagExists('indentAttributes', options);
  helper.ensureFlagExists('indentInstruction', options);
  helper.ensureFlagExists('fullTagEmptyElement', options);
  helper.ensureFlagExists('noQuotesForNativeAttributes', options);
  helper.ensureSpacesExists(options);
  if (typeof options.spaces === 'number') {
    options.spaces = Array(options.spaces + 1).join(' ');
  }
  helper.ensureKeyExists('declaration', options);
  helper.ensureKeyExists('instruction', options);
  helper.ensureKeyExists('attributes', options);
  helper.ensureKeyExists('text', options);
  helper.ensureKeyExists('comment', options);
  helper.ensureKeyExists('cdata', options);
  helper.ensureKeyExists('doctype', options);
  helper.ensureKeyExists('type', options);
  helper.ensureKeyExists('name', options);
  helper.ensureKeyExists('elements', options);
  helper.checkFnExists('doctype', options);
  helper.checkFnExists('instruction', options);
  helper.checkFnExists('cdata', options);
  helper.checkFnExists('comment', options);
  helper.checkFnExists('text', options);
  helper.checkFnExists('instructionName', options);
  helper.checkFnExists('elementName', options);
  helper.checkFnExists('attributeName', options);
  helper.checkFnExists('attributeValue', options);
  helper.checkFnExists('attributes', options);
  helper.checkFnExists('fullTagEmptyElement', options);
  return options;
}

function writeIndentation(options, depth, firstLine) {
  return (!firstLine && options.spaces ? '\n' : '') + Array(depth + 1).join(options.spaces);
}

function writeAttributes(attributes, options, depth) {
  if (options.ignoreAttributes) {
    return '';
  }
  if ('attributesFn' in options) {
    attributes = options.attributesFn(attributes, currentElementName, currentElement);
  }
  var key, attr, attrName, quote, result = [];
  for (key in attributes) {
    if (attributes.hasOwnProperty(key) && attributes[key] !== null && attributes[key] !== undefined) {
      quote = options.noQuotesForNativeAttributes && typeof attributes[key] !== 'string' ? '' : '"';
      attr = '' + attributes[key]; // ensure number and boolean are converted to String
      attr = attr.replace(/"/g, '&quot;');
      attrName = 'attributeNameFn' in options ? options.attributeNameFn(key, attr, currentElementName, currentElement) : key;
      result.push((options.spaces && options.indentAttributes? writeIndentation(options, depth+1, false) : ' '));
      result.push(attrName + '=' + quote + ('attributeValueFn' in options ? options.attributeValueFn(attr, key, currentElementName, currentElement) : attr) + quote);
    }
  }
  if (attributes && Object.keys(attributes).length && options.spaces && options.indentAttributes) {
    result.push(writeIndentation(options, depth, false));
  }
  return result.join('');
}

function writeDeclaration(declaration, options, depth) {
  currentElement = declaration;
  currentElementName = 'xml';
  return options.ignoreDeclaration ? '' :  '<?' + 'xml' + writeAttributes(declaration[options.attributesKey], options, depth) + '?>';
}

function writeInstruction(instruction, options, depth) {
  if (options.ignoreInstruction) {
    return '';
  }
  var key;
  for (key in instruction) {
    if (instruction.hasOwnProperty(key)) {
      break;
    }
  }
  var instructionName = 'instructionNameFn' in options ? options.instructionNameFn(key, instruction[key], currentElementName, currentElement) : key;
  if (typeof instruction[key] === 'object') {
    currentElement = instruction;
    currentElementName = instructionName;
    return '<?' + instructionName + writeAttributes(instruction[key][options.attributesKey], options, depth) + '?>';
  } else {
    var instructionValue = instruction[key] ? instruction[key] : '';
    if ('instructionFn' in options) instructionValue = options.instructionFn(instructionValue, key, currentElementName, currentElement);
    return '<?' + instructionName + (instructionValue ? ' ' + instructionValue : '') + '?>';
  }
}

function writeComment(comment, options) {
  return options.ignoreComment ? '' : '<!--' + ('commentFn' in options ? options.commentFn(comment, currentElementName, currentElement) : comment) + '-->';
}

function writeCdata(cdata, options) {
  return options.ignoreCdata ? '' : '<![CDATA[' + ('cdataFn' in options ? options.cdataFn(cdata, currentElementName, currentElement) : cdata.replace(']]>', ']]]]><![CDATA[>')) + ']]>';
}

function writeDoctype(doctype, options) {
  return options.ignoreDoctype ? '' : '<!DOCTYPE ' + ('doctypeFn' in options ? options.doctypeFn(doctype, currentElementName, currentElement) : doctype) + '>';
}

function writeText(text, options) {
  if (options.ignoreText) return '';
  text = '' + text; // ensure Number and Boolean are converted to String
  text = text.replace(/&amp;/g, '&'); // desanitize to avoid double sanitization
  text = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  return 'textFn' in options ? options.textFn(text, currentElementName, currentElement) : text;
}

function hasContent(element, options) {
  var i;
  if (element.elements && element.elements.length) {
    for (i = 0; i < element.elements.length; ++i) {
      switch (element.elements[i][options.typeKey]) {
      case 'text':
        if (options.indentText) {
          return true;
        }
        break; // skip to next key
      case 'cdata':
        if (options.indentCdata) {
          return true;
        }
        break; // skip to next key
      case 'instruction':
        if (options.indentInstruction) {
          return true;
        }
        break; // skip to next key
      case 'doctype':
      case 'comment':
      case 'element':
        return true;
      default:
        return true;
      }
    }
  }
  return false;
}

function writeElement(element, options, depth) {
  currentElement = element;
  currentElementName = element.name;
  var xml = [], elementName = 'elementNameFn' in options ? options.elementNameFn(element.name, element) : element.name;
  xml.push('<' + elementName);
  if (element[options.attributesKey]) {
    xml.push(writeAttributes(element[options.attributesKey], options, depth));
  }
  var withClosingTag = element[options.elementsKey] && element[options.elementsKey].length || element[options.attributesKey] && element[options.attributesKey]['xml:space'] === 'preserve';
  if (!withClosingTag) {
    if ('fullTagEmptyElementFn' in options) {
      withClosingTag = options.fullTagEmptyElementFn(element.name, element);
    } else {
      withClosingTag = options.fullTagEmptyElement;
    }
  }
  if (withClosingTag) {
    xml.push('>');
    if (element[options.elementsKey] && element[options.elementsKey].length) {
      xml.push(writeElements(element[options.elementsKey], options, depth + 1));
      currentElement = element;
      currentElementName = element.name;
    }
    xml.push(options.spaces && hasContent(element, options) ? '\n' + Array(depth + 1).join(options.spaces) : '');
    xml.push('</' + elementName + '>');
  } else {
    xml.push('/>');
  }
  return xml.join('');
}

function writeElements(elements, options, depth, firstLine) {
  return elements.reduce(function (xml, element) {
    var indent = writeIndentation(options, depth, firstLine && !xml);
    switch (element.type) {
    case 'element': return xml + indent + writeElement(element, options, depth);
    case 'comment': return xml + indent + writeComment(element[options.commentKey], options);
    case 'doctype': return xml + indent + writeDoctype(element[options.doctypeKey], options);
    case 'cdata': return xml + (options.indentCdata ? indent : '') + writeCdata(element[options.cdataKey], options);
    case 'text': return xml + (options.indentText ? indent : '') + writeText(element[options.textKey], options);
    case 'instruction':
      var instruction = {};
      instruction[element[options.nameKey]] = element[options.attributesKey] ? element : element[options.instructionKey];
      return xml + (options.indentInstruction ? indent : '') + writeInstruction(instruction, options, depth);
    }
  }, '');
}

function hasContentCompact(element, options, anyContent) {
  var key;
  for (key in element) {
    if (element.hasOwnProperty(key)) {
      switch (key) {
      case options.parentKey:
      case options.attributesKey:
        break; // skip to next key
      case options.textKey:
        if (options.indentText || anyContent) {
          return true;
        }
        break; // skip to next key
      case options.cdataKey:
        if (options.indentCdata || anyContent) {
          return true;
        }
        break; // skip to next key
      case options.instructionKey:
        if (options.indentInstruction || anyContent) {
          return true;
        }
        break; // skip to next key
      case options.doctypeKey:
      case options.commentKey:
        return true;
      default:
        return true;
      }
    }
  }
  return false;
}

function writeElementCompact(element, name, options, depth, indent) {
  currentElement = element;
  currentElementName = name;
  var elementName = 'elementNameFn' in options ? options.elementNameFn(name, element) : name;
  if (typeof element === 'undefined' || element === null || element === '') {
    return 'fullTagEmptyElementFn' in options && options.fullTagEmptyElementFn(name, element) || options.fullTagEmptyElement ? '<' + elementName + '></' + elementName + '>' : '<' + elementName + '/>';
  }
  var xml = [];
  if (name) {
    xml.push('<' + elementName);
    if (typeof element !== 'object') {
      xml.push('>' + writeText(element,options) + '</' + elementName + '>');
      return xml.join('');
    }
    if (element[options.attributesKey]) {
      xml.push(writeAttributes(element[options.attributesKey], options, depth));
    }
    var withClosingTag = hasContentCompact(element, options, true) || element[options.attributesKey] && element[options.attributesKey]['xml:space'] === 'preserve';
    if (!withClosingTag) {
      if ('fullTagEmptyElementFn' in options) {
        withClosingTag = options.fullTagEmptyElementFn(name, element);
      } else {
        withClosingTag = options.fullTagEmptyElement;
      }
    }
    if (withClosingTag) {
      xml.push('>');
    } else {
      xml.push('/>');
      return xml.join('');
    }
  }
  xml.push(writeElementsCompact(element, options, depth + 1, false));
  currentElement = element;
  currentElementName = name;
  if (name) {
    xml.push((indent ? writeIndentation(options, depth, false) : '') + '</' + elementName + '>');
  }
  return xml.join('');
}

function writeElementsCompact(element, options, depth, firstLine) {
  var i, key, nodes, xml = [];
  for (key in element) {
    if (element.hasOwnProperty(key)) {
      nodes = isArray(element[key]) ? element[key] : [element[key]];
      for (i = 0; i < nodes.length; ++i) {
        switch (key) {
        case options.declarationKey: xml.push(writeDeclaration(nodes[i], options, depth)); break;
        case options.instructionKey: xml.push((options.indentInstruction ? writeIndentation(options, depth, firstLine) : '') + writeInstruction(nodes[i], options, depth)); break;
        case options.attributesKey: case options.parentKey: break; // skip
        case options.textKey: xml.push((options.indentText ? writeIndentation(options, depth, firstLine) : '') + writeText(nodes[i], options)); break;
        case options.cdataKey: xml.push((options.indentCdata ? writeIndentation(options, depth, firstLine) : '') + writeCdata(nodes[i], options)); break;
        case options.doctypeKey: xml.push(writeIndentation(options, depth, firstLine) + writeDoctype(nodes[i], options)); break;
        case options.commentKey: xml.push(writeIndentation(options, depth, firstLine) + writeComment(nodes[i], options)); break;
        default: xml.push(writeIndentation(options, depth, firstLine) + writeElementCompact(nodes[i], key, options, depth, hasContentCompact(nodes[i], options)));
        }
        firstLine = firstLine && !xml.length;
      }
    }
  }
  return xml.join('');
}

module.exports = function (js, options) {
  options = validateOptions(options);
  var xml = [];
  currentElement = js;
  currentElementName = '_root_';
  if (options.compact) {
    xml.push(writeElementsCompact(js, options, 0, true));
  } else {
    if (js[options.declarationKey]) {
      xml.push(writeDeclaration(js[options.declarationKey], options, 0));
    }
    if (js[options.elementsKey] && js[options.elementsKey].length) {
      xml.push(writeElements(js[options.elementsKey], options, 0, !xml.length));
    }
  }
  return xml.join('');
};

},{"1572":1572,"1576":1576}],1576:[function(require,module,exports){
var isArray = require(1572).isArray;

module.exports = {

  copyOptions: function (options) {
    var key, copy = {};
    for (key in options) {
      if (options.hasOwnProperty(key)) {
        copy[key] = options[key];
      }
    }
    return copy;
  },

  ensureFlagExists: function (item, options) {
    if (!(item in options) || typeof options[item] !== 'boolean') {
      options[item] = false;
    }
  },

  ensureSpacesExists: function (options) {
    if (!('spaces' in options) || (typeof options.spaces !== 'number' && typeof options.spaces !== 'string')) {
      options.spaces = 0;
    }
  },

  ensureAlwaysArrayExists: function (options) {
    if (!('alwaysArray' in options) || (typeof options.alwaysArray !== 'boolean' && !isArray(options.alwaysArray))) {
      options.alwaysArray = false;
    }
  },

  ensureKeyExists: function (key, options) {
    if (!(key + 'Key' in options) || typeof options[key + 'Key'] !== 'string') {
      options[key + 'Key'] = options.compact ? '_' + key : key;
    }
  },

  checkFnExists: function (key, options) {
    return key + 'Fn' in options;
  }

};

},{"1572":1572}],1572:[function(require,module,exports){
module.exports = {

  isArray: function(value) {
    if (Array.isArray) {
      return Array.isArray(value);
    }
    // fallback for older browsers like  IE 8
    return Object.prototype.toString.call( value ) === '[object Array]';
  }

};

},{}],1551:[function(require,module,exports){
(function (process){(function (){
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

function assertPath(path) {
  if (typeof path !== 'string') {
    throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
  }
}

// Resolves . and .. elements in a path with directory names
function normalizeStringPosix(path, allowAboveRoot) {
  var res = '';
  var lastSegmentLength = 0;
  var lastSlash = -1;
  var dots = 0;
  var code;
  for (var i = 0; i <= path.length; ++i) {
    if (i < path.length)
      code = path.charCodeAt(i);
    else if (code === 47 /*/*/)
      break;
    else
      code = 47 /*/*/;
    if (code === 47 /*/*/) {
      if (lastSlash === i - 1 || dots === 1) {
        // NOOP
      } else if (lastSlash !== i - 1 && dots === 2) {
        if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/ || res.charCodeAt(res.length - 2) !== 46 /*.*/) {
          if (res.length > 2) {
            var lastSlashIndex = res.lastIndexOf('/');
            if (lastSlashIndex !== res.length - 1) {
              if (lastSlashIndex === -1) {
                res = '';
                lastSegmentLength = 0;
              } else {
                res = res.slice(0, lastSlashIndex);
                lastSegmentLength = res.length - 1 - res.lastIndexOf('/');
              }
              lastSlash = i;
              dots = 0;
              continue;
            }
          } else if (res.length === 2 || res.length === 1) {
            res = '';
            lastSegmentLength = 0;
            lastSlash = i;
            dots = 0;
            continue;
          }
        }
        if (allowAboveRoot) {
          if (res.length > 0)
            res += '/..';
          else
            res = '..';
          lastSegmentLength = 2;
        }
      } else {
        if (res.length > 0)
          res += '/' + path.slice(lastSlash + 1, i);
        else
          res = path.slice(lastSlash + 1, i);
        lastSegmentLength = i - lastSlash - 1;
      }
      lastSlash = i;
      dots = 0;
    } else if (code === 46 /*.*/ && dots !== -1) {
      ++dots;
    } else {
      dots = -1;
    }
  }
  return res;
}

function _format(sep, pathObject) {
  var dir = pathObject.dir || pathObject.root;
  var base = pathObject.base || (pathObject.name || '') + (pathObject.ext || '');
  if (!dir) {
    return base;
  }
  if (dir === pathObject.root) {
    return dir + base;
  }
  return dir + sep + base;
}

var posix = {
  // path.resolve([from ...], to)
  resolve: function resolve() {
    var resolvedPath = '';
    var resolvedAbsolute = false;
    var cwd;

    for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
      var path;
      if (i >= 0)
        path = arguments[i];
      else {
        if (cwd === undefined)
          cwd = process.cwd();
        path = cwd;
      }

      assertPath(path);

      // Skip empty entries
      if (path.length === 0) {
        continue;
      }

      resolvedPath = path + '/' + resolvedPath;
      resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/;
    }

    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)

    // Normalize the path
    resolvedPath = normalizeStringPosix(resolvedPath, !resolvedAbsolute);

    if (resolvedAbsolute) {
      if (resolvedPath.length > 0)
        return '/' + resolvedPath;
      else
        return '/';
    } else if (resolvedPath.length > 0) {
      return resolvedPath;
    } else {
      return '.';
    }
  },

  normalize: function normalize(path) {
    assertPath(path);

    if (path.length === 0) return '.';

    var isAbsolute = path.charCodeAt(0) === 47 /*/*/;
    var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/;

    // Normalize the path
    path = normalizeStringPosix(path, !isAbsolute);

    if (path.length === 0 && !isAbsolute) path = '.';
    if (path.length > 0 && trailingSeparator) path += '/';

    if (isAbsolute) return '/' + path;
    return path;
  },

  isAbsolute: function isAbsolute(path) {
    assertPath(path);
    return path.length > 0 && path.charCodeAt(0) === 47 /*/*/;
  },

  join: function join() {
    if (arguments.length === 0)
      return '.';
    var joined;
    for (var i = 0; i < arguments.length; ++i) {
      var arg = arguments[i];
      assertPath(arg);
      if (arg.length > 0) {
        if (joined === undefined)
          joined = arg;
        else
          joined += '/' + arg;
      }
    }
    if (joined === undefined)
      return '.';
    return posix.normalize(joined);
  },

  relative: function relative(from, to) {
    assertPath(from);
    assertPath(to);

    if (from === to) return '';

    from = posix.resolve(from);
    to = posix.resolve(to);

    if (from === to) return '';

    // Trim any leading backslashes
    var fromStart = 1;
    for (; fromStart < from.length; ++fromStart) {
      if (from.charCodeAt(fromStart) !== 47 /*/*/)
        break;
    }
    var fromEnd = from.length;
    var fromLen = fromEnd - fromStart;

    // Trim any leading backslashes
    var toStart = 1;
    for (; toStart < to.length; ++toStart) {
      if (to.charCodeAt(toStart) !== 47 /*/*/)
        break;
    }
    var toEnd = to.length;
    var toLen = toEnd - toStart;

    // Compare paths to find the longest common path from root
    var length = fromLen < toLen ? fromLen : toLen;
    var lastCommonSep = -1;
    var i = 0;
    for (; i <= length; ++i) {
      if (i === length) {
        if (toLen > length) {
          if (to.charCodeAt(toStart + i) === 47 /*/*/) {
            // We get here if `from` is the exact base path for `to`.
            // For example: from='/foo/bar'; to='/foo/bar/baz'
            return to.slice(toStart + i + 1);
          } else if (i === 0) {
            // We get here if `from` is the root
            // For example: from='/'; to='/foo'
            return to.slice(toStart + i);
          }
        } else if (fromLen > length) {
          if (from.charCodeAt(fromStart + i) === 47 /*/*/) {
            // We get here if `to` is the exact base path for `from`.
            // For example: from='/foo/bar/baz'; to='/foo/bar'
            lastCommonSep = i;
          } else if (i === 0) {
            // We get here if `to` is the root.
            // For example: from='/foo'; to='/'
            lastCommonSep = 0;
          }
        }
        break;
      }
      var fromCode = from.charCodeAt(fromStart + i);
      var toCode = to.charCodeAt(toStart + i);
      if (fromCode !== toCode)
        break;
      else if (fromCode === 47 /*/*/)
        lastCommonSep = i;
    }

    var out = '';
    // Generate the relative path based on the path difference between `to`
    // and `from`
    for (i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i) {
      if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/) {
        if (out.length === 0)
          out += '..';
        else
          out += '/..';
      }
    }

    // Lastly, append the rest of the destination (`to`) path that comes after
    // the common path parts
    if (out.length > 0)
      return out + to.slice(toStart + lastCommonSep);
    else {
      toStart += lastCommonSep;
      if (to.charCodeAt(toStart) === 47 /*/*/)
        ++toStart;
      return to.slice(toStart);
    }
  },

  _makeLong: function _makeLong(path) {
    return path;
  },

  dirname: function dirname(path) {
    assertPath(path);
    if (path.length === 0) return '.';
    var code = path.charCodeAt(0);
    var hasRoot = code === 47 /*/*/;
    var end = -1;
    var matchedSlash = true;
    for (var i = path.length - 1; i >= 1; --i) {
      code = path.charCodeAt(i);
      if (code === 47 /*/*/) {
          if (!matchedSlash) {
            end = i;
            break;
          }
        } else {
        // We saw the first non-path separator
        matchedSlash = false;
      }
    }

    if (end === -1) return hasRoot ? '/' : '.';
    if (hasRoot && end === 1) return '//';
    return path.slice(0, end);
  },

  basename: function basename(path, ext) {
    if (ext !== undefined && typeof ext !== 'string') throw new TypeError('"ext" argument must be a string');
    assertPath(path);

    var start = 0;
    var end = -1;
    var matchedSlash = true;
    var i;

    if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
      if (ext.length === path.length && ext === path) return '';
      var extIdx = ext.length - 1;
      var firstNonSlashEnd = -1;
      for (i = path.length - 1; i >= 0; --i) {
        var code = path.charCodeAt(i);
        if (code === 47 /*/*/) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now
            if (!matchedSlash) {
              start = i + 1;
              break;
            }
          } else {
          if (firstNonSlashEnd === -1) {
            // We saw the first non-path separator, remember this index in case
            // we need it if the extension ends up not matching
            matchedSlash = false;
            firstNonSlashEnd = i + 1;
          }
          if (extIdx >= 0) {
            // Try to match the explicit extension
            if (code === ext.charCodeAt(extIdx)) {
              if (--extIdx === -1) {
                // We matched the extension, so mark this as the end of our path
                // component
                end = i;
              }
            } else {
              // Extension does not match, so our result is the entire path
              // component
              extIdx = -1;
              end = firstNonSlashEnd;
            }
          }
        }
      }

      if (start === end) end = firstNonSlashEnd;else if (end === -1) end = path.length;
      return path.slice(start, end);
    } else {
      for (i = path.length - 1; i >= 0; --i) {
        if (path.charCodeAt(i) === 47 /*/*/) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now
            if (!matchedSlash) {
              start = i + 1;
              break;
            }
          } else if (end === -1) {
          // We saw the first non-path separator, mark this as the end of our
          // path component
          matchedSlash = false;
          end = i + 1;
        }
      }

      if (end === -1) return '';
      return path.slice(start, end);
    }
  },

  extname: function extname(path) {
    assertPath(path);
    var startDot = -1;
    var startPart = 0;
    var end = -1;
    var matchedSlash = true;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find
    var preDotState = 0;
    for (var i = path.length - 1; i >= 0; --i) {
      var code = path.charCodeAt(i);
      if (code === 47 /*/*/) {
          // If we reached a path separator that was not part of a set of path
          // separators at the end of the string, stop now
          if (!matchedSlash) {
            startPart = i + 1;
            break;
          }
          continue;
        }
      if (end === -1) {
        // We saw the first non-path separator, mark this as the end of our
        // extension
        matchedSlash = false;
        end = i + 1;
      }
      if (code === 46 /*.*/) {
          // If this is our first dot, mark it as the start of our extension
          if (startDot === -1)
            startDot = i;
          else if (preDotState !== 1)
            preDotState = 1;
      } else if (startDot !== -1) {
        // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension
        preDotState = -1;
      }
    }

    if (startDot === -1 || end === -1 ||
        // We saw a non-dot character immediately before the dot
        preDotState === 0 ||
        // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
      return '';
    }
    return path.slice(startDot, end);
  },

  format: function format(pathObject) {
    if (pathObject === null || typeof pathObject !== 'object') {
      throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
    }
    return _format('/', pathObject);
  },

  parse: function parse(path) {
    assertPath(path);

    var ret = { root: '', dir: '', base: '', ext: '', name: '' };
    if (path.length === 0) return ret;
    var code = path.charCodeAt(0);
    var isAbsolute = code === 47 /*/*/;
    var start;
    if (isAbsolute) {
      ret.root = '/';
      start = 1;
    } else {
      start = 0;
    }
    var startDot = -1;
    var startPart = 0;
    var end = -1;
    var matchedSlash = true;
    var i = path.length - 1;

    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find
    var preDotState = 0;

    // Get non-dir info
    for (; i >= start; --i) {
      code = path.charCodeAt(i);
      if (code === 47 /*/*/) {
          // If we reached a path separator that was not part of a set of path
          // separators at the end of the string, stop now
          if (!matchedSlash) {
            startPart = i + 1;
            break;
          }
          continue;
        }
      if (end === -1) {
        // We saw the first non-path separator, mark this as the end of our
        // extension
        matchedSlash = false;
        end = i + 1;
      }
      if (code === 46 /*.*/) {
          // If this is our first dot, mark it as the start of our extension
          if (startDot === -1) startDot = i;else if (preDotState !== 1) preDotState = 1;
        } else if (startDot !== -1) {
        // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension
        preDotState = -1;
      }
    }

    if (startDot === -1 || end === -1 ||
    // We saw a non-dot character immediately before the dot
    preDotState === 0 ||
    // The (right-most) trimmed path component is exactly '..'
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
      if (end !== -1) {
        if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);else ret.base = ret.name = path.slice(startPart, end);
      }
    } else {
      if (startPart === 0 && isAbsolute) {
        ret.name = path.slice(1, startDot);
        ret.base = path.slice(1, end);
      } else {
        ret.name = path.slice(startPart, startDot);
        ret.base = path.slice(startPart, end);
      }
      ret.ext = path.slice(startDot, end);
    }

    if (startPart > 0) ret.dir = path.slice(0, startPart - 1);else if (isAbsolute) ret.dir = '/';

    return ret;
  },

  sep: '/',
  delimiter: ':',
  win32: null,
  posix: null
};

posix.posix = posix;

module.exports = posix;

}).call(this)}).call(this,require(1552))
},{"1552":1552}],1552:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],1148:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require(1184);
require(1437);
require(1463);
require(1478);
require(1417);
require(1461);
require(1421);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
module.exports = /*#__PURE__*/function () {
  function _class() {
    (0, _classCallCheck2["default"])(this, _class);
    this.fileName = 'content';
    this.kityminder = 'kityminder.json';
    this.imgRegex = /\.(png|jpe?g|gif)/i;
    this.task = ['start', 'oct', 'quarter', '3oct', 'half', '5oct', '3quar', '7oct', 'done', 'pause'];
  }

  //唯一id
  (0, _createClass2["default"])(_class, [{
    key: "guid",
    value: function guid() {
      var S4 = function S4() {
        return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
      };
      return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4();
    }
    // 对象模糊匹配key值
  }, {
    key: "objMatchingkey",
    value: function objMatchingkey() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var key = arguments.length > 1 ? arguments[1] : undefined;
      return Object.keys(obj).find(function (v) {
        return v.indexOf(key) >= 0;
      });
    }
  }]);
  return _class;
}();

},{"1175":1175,"1179":1179,"1184":1184,"1417":1417,"1421":1421,"1437":1437,"1461":1461,"1463":1463,"1478":1478}],1125:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1498);
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDInputFileNamePanelTpl = _interopRequireDefault(require(1130));
var _MDWindowView2 = _interopRequireDefault(require(93));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // MDInputFileNamePanel.js
// jiang
// 2017-4-18
var MDInputFileNamePanel = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDInputFileNamePanel, _MDWindowView);
  function MDInputFileNamePanel() {
    (0, _classCallCheck2["default"])(this, MDInputFileNamePanel);
    return _callSuper(this, MDInputFileNamePanel, arguments);
  }
  (0, _createClass2["default"])(MDInputFileNamePanel, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return _MDInputFileNamePanelTpl["default"];
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDInputFileNamePanel.prototype), "className", this).call(this);
      return "".concat(superCls, " m-outer-person-win input-filename-view");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDInputFileNamePanel.prototype), "events", this).call(this);
      return _.extend(superE, {
        'input input': this.onFileNameChanged,
        'keydown input': this.keyDown
      });
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDInputFileNamePanel.prototype), "initProps", this).call(this);
      return _.extend(superP, {});
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      this.fileName = null;
      var saveStr = props.saveStr ? props.saveStr : BabelStr.str(3080);
      props.title = BabelStr.str(7383);
      props.width = 500;
      props.buttons = [{
        label: BabelStr.str(155),
        className: 'canel'
      }, {
        label: saveStr,
        autoClose: false,
        className: 'save',
        enabled: false,
        type: "done",
        onClick: function onClick() {
          _this.toSaveFile();
        }
      }];
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDInputFileNamePanel.prototype), "initialize", this).call(this, props);
      if (this.defaultFileName) {
        this.$('input').val(this.defaultFileName);
      }
    }
  }, {
    key: "toSaveFile",
    value: function toSaveFile() {
      this.fileName = this.$('input').val().trim();
      var validator = this.$('form').validate();
      if (this.fileName.length == 0 || validator && !validator.form()) {
        return;
      }
      var maxLenth = 100;
      if (this.fileName.length > maxLenth) {
        this.fileName = this.fileName.substr(0, maxLenth);
      }
      ;
      this.saveFile(this.fileName);
    }
  }, {
    key: "onFileNameChanged",
    value: function onFileNameChanged() {
      var fname = this.$('input').val().trim();
      if (fname.length == 0) {
        this.$('.save').disable();
      } else {
        this.$('.save').enable();
      }
    }
  }, {
    key: "keyDown",
    value: function keyDown(e) {
      var code = e.keyCode;
      if (code == 13) {
        this.toSaveFile();
      }
    }
  }, {
    key: "viewDidRendered",
    value: function viewDidRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDInputFileNamePanel.prototype), "viewDidRendered", this).call(this);
      this.$('input').focus();
      if (this.defaultFileName) {
        this.buttons[1].enabled = true;
      }
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MDInputFileNamePanel';
    }
  }]);
  return MDInputFileNamePanel;
}(_MDWindowView2["default"]);

},{"1130":1130,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"1498":1498,"93":93}],1130:[function(require,module,exports){
module.exports = '<!-- MDInputFileNamePanelTpl.html -->\<!-- jiang -->\<!-- 2017-4-18 -->\<div class="input-text-filename">\	<form onsubmit="return false">\	  <input type="text" name="filename" testFileName class="form-control testFileNameEnd testFileName notempty" maxlength="100" placeholder="<%=BabelStr.str(7384)%>">\	  <button class="button f-hide"></button>\	</form>\</div>';
},{}],114:[function(require,module,exports){
"use strict";

require(1454);
require(1503);
require(1500);
require(1463);
require(1502);
require(1423);
require(1487);
require(1538);
require(1452);
require(1462);
require(1475);
require(1437);
require(1478);
require(1460);
require(1412);
require(1471);
require(1421);
require(1541);
require(1461);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require(115);
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function () {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
var DrawioEmbed = /*#__PURE__*/function (_ItvCheck) {
  _inherits(DrawioEmbed, _ItvCheck);
  var _super = _createSuper(DrawioEmbed);
  function DrawioEmbed() {
    var _this;
    _classCallCheck(this, DrawioEmbed);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.drawioIframe = null;
    _this.isIframeVisible = false;
    _this.closeHolding = false;
    _this.initialized = false;
    _this.drawioFrameLoaded = false;
    _this.eventListenerBound = false;
    _this.iframeInserted = false;
    _this.drawioUrl = "";
    _this.container = document.documentElement;
    _this.closeIframe = function () {
      var evc = new Event("drawioClosed");
      window.dispatchEvent(evc);
      _this.hideIframe();
    };
    _this.isOpen = function () {
      return _this.isIframeVisible;
    };
    _this.isLoaded = function () {
      return _this.initialized;
    };
    _this.editImage = function (url) {
      if (!_this.drawioFrameLoaded) return Promise.reject();
      if (!url) {
        _this.sendMsgToDrawio({
          action: "load"
        });
        _this.showIframe();
        return;
      }
      if (url.indexOf("<svg") === 0) {
        _this.sendMsgToDrawio({
          action: "load",
          xml: url
        });
        _this.showIframe();
        return;
      }
      _this.showIframe();
      _this.sendMsgToDrawio({
        action: "spinner",
        message: "加载中...",
        show: true,
        enabled: false
      });
      fetch(url).then(function (response) {
        return response.blob();
      }).then(function (blob) {
        if (_this.type == "vsdx") {
          blob.arrayBuffer().then(function (buffer) {
            _this.sendMsgToDrawio({
              action: "load",
              descriptor: {
                type: "vsdx",
                fileName: _this.fileName,
                lang: _this.lang,
                blobData: buffer,
                noSaveBtn: false,
                readOnly: _this.readOnly
              }
            });
          });
        } else {
          var reader = new FileReader();

          // 设置FileReader的onload事件处理程序，转换完成后执行
          reader.onload = function (event) {
            // 事件的result属性包含了转换完成的Base64字符串
            var text = event.target.result;
            console.log(text); // 输出Base64编码的字符串
            _this.sendMsgToDrawio({
              action: "load",
              xml: text,
              noSaveBtn: false,
              readOnly: _this.readOnly
            });
          };
          reader.readAsText(blob, "UTF-8");
        }
        // 创建一个FileReader实例

        // 使用FileReader的readAsDataURL方法开始转换

        // setTimeout(() => {
        //   this.sendMsgToDrawio({
        //     action: "load",
        //     xml
        //   });
        // }, 50);
        _this.sendMsgToDrawio({
          action: "spinner",
          message: "",
          show: false,
          enabled: true
        });
      })["catch"](function () {
        _this.sendMsgToDrawio({
          action: "spinner",
          message: "流程图加载失败",
          show: true,
          enabled: false
        });
      });
    };
    _this.init = function (drawioUrl, params) {
      _this.editImage.close = _this.closeIframe;
      _this.editImage.isOpen = _this.isOpen;
      _this.editImage.isLoaded = _this.isLoaded;
      _this.container = params.container;
      _this.fileName = params.fileName;
      _this.lang = params.lang;
      _this.readOnly = params.readOnly;
      _this.type = params.type;
      if (_this.iframeInserted) {
        var iframe = _this.getFrame();
        if (!iframe.contentWindow) {
          _this.hideIframe();
          _this.container.appendChild(iframe);
        }
        return _this.editImage;
      }
      _this.iframeInserted = true;
      if (!drawioUrl) drawioUrl = "https://www.draw.io/";
      _this.initCommunication(drawioUrl);
      return _this.editImage;
    };
    return _this;
  }
  _createClass(DrawioEmbed, [{
    key: "sendMsgToDrawio",
    value: function sendMsgToDrawio(obj) {
      var iframe = this.getFrame();
      iframe.contentWindow && iframe.contentWindow.postMessage(obj, "*");
      if (!iframe.contentWindow) {
        console.log('iframe 已被移除');
      }
    }
  }, {
    key: "showIframe",
    value: function showIframe() {
      var iframe = this.getFrame();
      iframe.setAttribute("style", _utils.visibleStyle);
      this.isIframeVisible = true;
    }
  }, {
    key: "hideIframe",
    value: function hideIframe() {
      var _this2 = this;
      var iframe = this.getFrame();
      iframe.setAttribute("style", _utils.hiddenStyle);
      this.isIframeVisible = false; // 清空编辑区
      if (iframe.contentWindow) {
        setTimeout(function () {
          _this2.sendMsgToDrawio({
            action: "load"
          });
        }, 500); // 清空loading

        setTimeout(function () {
          _this2.sendMsgToDrawio({
            action: "spinner",
            message: "",
            show: false,
            enabled: true
          });
        }, 300);
      }
    }
  }, {
    key: "getFrame",
    value: function getFrame() {
      if (!this.drawioIframe) {
        this.drawioIframe = document.createElement("iframe");
        this.drawioIframe.id = "drawio-iframe";
      }
      return this.drawioIframe;
    }
  }, {
    key: "initCommunication",
    value: function initCommunication(drawioUrl) {
      this.drawioUrl = drawioUrl;
      this.closeHolding = !!(0, _utils.getKey)(drawioUrl, "hold");
      if (this.initialized) return;
      this.initialized = true;
      if (drawioUrl.indexOf("?") !== -1) drawioUrl += "&".concat(_utils.queryStr);else drawioUrl += "?".concat(_utils.queryStr);
      var iframe = this.getFrame();
      iframe.src = drawioUrl;
      this.hideIframe();
      this.container.appendChild(iframe);
      this.bindEventListener();
    }
  }, {
    key: "bindEventListener",
    value: function bindEventListener() {
      var _this3 = this;
      if (this.eventListenerBound) return;
      this.eventListenerBound = true;
      window.addEventListener("message", function (e) {
        if (!e.data) return;
        var msg = null;
        try {
          msg = JSON.parse(e.data);
        } catch (error) {}
        if (!msg || _typeof(msg) !== "object") return;
        var _msg = msg,
          event = _msg.event;
        switch (event) {
          case "init":
            _this3.drawioFrameLoaded = true;
            window.dispatchEvent(new Event("drawioLoaded"));
            break;
          case "save":
            _this3.sendMsgToDrawio({
              action: "export",
              format: "png",
              spinKey: "saving"
            });
            _this3.setSavingFlag();
            _this3.checkReady(function () {
              _this3.sendMsgToDrawio({
                action: "export",
                format: "svg",
                spinKey: "saving"
              });
            });
            if (_this3.closeHolding) {
              _this3.sendMsgToDrawio({
                action: "spinner",
                message: "保存中...",
                show: true,
                enabled: false
              });
            } else _this3.hideIframe();
            break;
          case "export":
            if (!msg.data) return;
            _this3.clearSavingFlag();
            if (msg.data.indexOf("data:image/png") !== -1) {
              var ev = new Event("drawioImageCreated");
              ev.imageType = "png";
              ev.imageContent = msg.data;
              window.dispatchEvent(ev);
            } else {
              (0, _utils.processSvg)(msg.xml, msg.data, function (img) {
                var ev = new Event("drawioImageCreated");
                ev.imageType = "svg";
                ev.imageContent = img;
                ev.xml = msg.xml; // 用于导出恢复

                window.dispatchEvent(ev);
              });
            }
            break;
          case "exit":
            _this3.closeIframe();
            break;
          default:
            break;
        }
      });
    }
  }]);
  return DrawioEmbed;
}(_utils.ItvCheck);
var _default = new DrawioEmbed().init;
exports["default"] = _default;

},{"115":115,"1412":1412,"1421":1421,"1423":1423,"1437":1437,"1452":1452,"1454":1454,"1460":1460,"1461":1461,"1462":1462,"1463":1463,"1471":1471,"1475":1475,"1478":1478,"1487":1487,"1500":1500,"1502":1502,"1503":1503,"1538":1538,"1541":1541}],1462:[function(require,module,exports){
var $ = require(1270);
var setPrototypeOf = require(1339);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
$({ target: 'Object', stat: true }, {
  setPrototypeOf: setPrototypeOf
});

},{"1270":1270,"1339":1339}],1460:[function(require,module,exports){
var $ = require(1270);
var fails = require(1271);
var toObject = require(1387);
var nativeGetPrototypeOf = require(1333);
var CORRECT_PROTOTYPE_GETTER = require(1240);

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});


},{"1240":1240,"1270":1270,"1271":1271,"1333":1333,"1387":1387}],1452:[function(require,module,exports){
// TODO: Remove from `core-js@4`
var $ = require(1270);
var DESCRIPTORS = require(1251);
var create = require(1326);

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  create: create
});

},{"1251":1251,"1270":1270,"1326":1326}],115:[function(require,module,exports){
"use strict";

require(1454);
require(1423);
require(1411);
require(1463);
require(1530);
require(1505);
require(1506);
require(1507);
require(1508);
require(1510);
require(1509);
require(1512);
require(1513);
require(1514);
require(1516);
require(1517);
require(1518);
require(1519);
require(1521);
require(1520);
require(1522);
require(1523);
require(1524);
require(1525);
require(1526);
require(1527);
require(1528);
require(1529);
require(1477);
require(1492);
require(1541);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processSvg = processSvg;
exports.getKey = getKey;
exports.ItvCheck = exports.queryStr = exports.hiddenStyle = exports.visibleStyle = void 0;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function HTMLEncode(html) {
  var temp = document.createElement("div");
  temp.textContent != null ? temp.textContent = html : temp.innerText = html;
  var output = temp.innerHTML;
  temp = null;
  return output;
}
function processSvg(xml, data, cb) {
  var content = HTMLEncode(xml);
  data = data.split(",")[1];
  data = atob(data);
  var binaryArr = new Uint8Array(data.length);
  for (var i = 0; i < data.length; i++) {
    binaryArr[i] = data.charCodeAt(i);
  }
  var blob = new Blob([binaryArr], {
    type: "image/svg+xml"
  });
  var reader = new FileReader();
  reader.readAsText(blob);
  reader.onload = function () {
    var txt = reader.result;
    if (typeof cb === "function") cb(txt.replace("<svg ", "<svg content='".concat(content, "' ")));
  };
}
function parse(search) {
  var obj = {};
  (search || "").replace(/([^?&=/]+)=([^?&=/]*)/g, function (res, $1, $2) {
    return obj[decodeURIComponent($1)] = decodeURIComponent($2);
  });
  return obj;
}
function getKey(url, key) {
  var obj = parse(url.split("?")[1]);
  return obj[key];
}
var visibleStyle = "position:absolute;height:100%;width:100%;top:0;left:0;background:white;";
exports.visibleStyle = visibleStyle;
var hiddenStyle = "position:absolute;height:100%;width:100%;top:-10240px;left:0;background:white;";
exports.hiddenStyle = hiddenStyle;
var queryStr = "embed=1&ui=atlas&spin=1&proto=json";
exports.queryStr = queryStr;
var ItvCheck = /*#__PURE__*/function () {
  function ItvCheck() {
    _classCallCheck(this, ItvCheck);
    this.savingSto = null;
    this.isSaving = false;
  }
  _createClass(ItvCheck, [{
    key: "setSavingFlag",
    value: function setSavingFlag() {
      var _this = this;
      this.clearSavingFlag();
      this.isSaving = true;
      this.savingSto = setTimeout(function () {
        _this.isSaving = false;
      }, 5000);
    }
  }, {
    key: "clearSavingFlag",
    value: function clearSavingFlag() {
      this.isSaving = false;
      clearTimeout(this.savingSto);
    }
  }, {
    key: "checkReady",
    value: function checkReady(cb) {
      var _this2 = this;
      var maxtime = 100;
      var cnt = 0;
      var delay = 50;
      var _int = setInterval(function () {
        cnt++;
        if (cnt > maxtime || !_this2.isSaving) {
          clearInterval(_int);
          cb();
        }
      }, delay);
    }
  }]);
  return ItvCheck;
}();
exports.ItvCheck = ItvCheck;

},{"1411":1411,"1423":1423,"1454":1454,"1463":1463,"1477":1477,"1492":1492,"1505":1505,"1506":1506,"1507":1507,"1508":1508,"1509":1509,"1510":1510,"1512":1512,"1513":1513,"1514":1514,"1516":1516,"1517":1517,"1518":1518,"1519":1519,"1520":1520,"1521":1521,"1522":1522,"1523":1523,"1524":1524,"1525":1525,"1526":1526,"1527":1527,"1528":1528,"1529":1529,"1530":1530,"1541":1541}],111:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1451);
require(1417);
require(1463);
require(1541);
var _MMCommonFun = _interopRequireDefault(require(812));
var _MEWatermarkOverlay = _interopRequireDefault(require(809));
// import MMNetDiskDataController from "../net/MMNetDiskDataController.js";

// import MDLoadMaskView from "../base/component/loadmask/MDLoadMaskView.js";
// import MDSnackbarView from "../base/component/snackbars/MDSnackbarView.js";
// import xmind2json from "../vendor/xmind/xmind-to-json.js";

var MDCadFileEditor = function MDCadFileEditor(parentDiv) {
  var _this = this;
  this.id = "webcad" + MDCadFileEditor.getIdIndex();
  this.$content = $("<div id=\"".concat(this.id, "\"></div> "));
  this.urlObj = {};
  this.$parentDiv = $(parentDiv);
  this.$parentDiv.append(this.$content);

  // 初始化GStarSDK
  var lan = BabelStr.getCurrentLanguage();
  lan = lan == "cn" ? "zh" : "en";
  // lan = "en";
  var gstarSDK = new GStarSDK({
    wrapId: this.id,
    //容器ID，CAD图纸将这个id对应的容器里面显示
    language: lan,
    //语言设置，可选'zh'（简中）/'zh-tw'(繁体)/'en'(英语)/'ko'(韩语),默认'zh'
    //toolbarHideItems: hideFunction, // 隐藏hideFunction里面的功能
    isHideMarks: true,
    //是否隐藏软件自带的书签功能
    apiHost: window.location.protocol + "//" + window.location.host //API域名，转换PDF、另存功能需要向该域名发送请求，如果没有用的转PDF、版本转换功能，则无须关注这个参数。
  });
  gstarSDK.enableZoom(5); // 开启鼠标滚轮缩放功能,数字是缩放的速度
  gstarSDK.enablePan(); // 开启鼠标左键、滚轮平移功能
  gstarSDK.enableMap(); //默认状态开启小地图
  // gstarSDK.disableMap() //默认状态关闭小地图
  this.gstarSDK = gstarSDK;
  gstarSDK.on("switchLayout", function (eventName, obj) {
    //obj.globalName是布局名称，根据这个布局名，从json数据里面得到对应ocf图纸链接
    //如果后端将所有布局对应的ocf文件链接都返回了，就可以直接加载。如果只返回了默认布局的ocf，切换布局后需要参考下面注释掉的代码，向后端发送请求，等待后端返回当前切换布局的ocf文件链接。
    //showcad(demoocfurl[obj.globalName])
    _this.showcad(_this.urlObj[obj.globalName].url);
  });
};
MDCadFileEditor.idIndex = 0;
MDCadFileEditor.getIdIndex = function () {
  return MDCadFileEditor.idIndex++;
};
Object.assign(MDCadFileEditor.prototype, Object.prototype, {
  contstructor: MDCadFileEditor,
  openFile: function openFile(curFileInfo, version, callback) {
    _czc && _czc.push(["_trackEvent", "预览", "CAD", "", "", ""]);
    this.curFileInfo = curFileInfo;
    this.version = version;
    this.fileName = curFileInfo.getFileName();
    var self = this;
    // MDLoadMaskView.show();
    this.tryCount = 0;
    this.getUrl(function () {
      callback();
    });
  },
  showcad: function showcad(ocfurl, success, fail) {
    var self = this;
    // 渲染前需要先进行授权验证.使用这个样例代码里面的secret即可
    var secret = "fldXImCGIwhP8ZQO4qecFY4ir2JxCc8bQUQ1ORrusA70H26qenVFScQPm3tMVFJ5";
    this.gstarSDK.setDynamicPW(secret); //授权验证
    console.time("解析ocf共计用时：");
    this.getDrawSheet(ocfurl, function (arraybuffer) {
      self.gstarSDK.render("ocf", arraybuffer, "111", false).then(function (e) {
        console.log(e);
        // console.log(this.arguments);
        console.log("图纸渲染显示完成"); //此处可以添加需要加载完ocf以后才能进行的操作，例如加载批注
        console.timeEnd("解析ocf共计用时：");
        self.drawWaterMarkInfo();
        success && success();
      })["catch"](function (e) {
        console.error(e);
        fail && fail();
      });
    }, fail);
  },
  drawWaterMarkInfo: function drawWaterMarkInfo() {
    var self = this;
    var $parent = this.$parentDiv.find("#".concat(this.id));
    var target = this.$parentDiv.find("#".concat(this.id, " canvas[data-type=\"render2D\"]"))[0];
    this._watermarkOverlay = _MEWatermarkOverlay["default"].createWatermarkOverlay({
      container: $parent[0],
      canvasId: "watermark",
      getSize: function getSize() {
        if (!target) return null;
        return {
          cssWidth: target.clientWidth || target.width,
          cssHeight: target.clientHeight || target.height,
          pixelWidth: target.width,
          pixelHeight: target.height,
          dpr: 1
        };
      },
      getWatermarkInfo: function getWatermarkInfo() {
        return self.curFileInfo.get("watermarkInfo");
      }
    });
  },
  getUrl: function getUrl(_success, fail) {
    var _this2 = this;
    // MDLoadMaskView.show();

    $.ajax({
      type: "post",
      url: "/netdrive/getGStarCADFileUrls.do",
      data: {
        fileId: this.curFileInfo.getFileId(),
        version: this.version
      },
      dataType: "json",
      success: function success(responseData, textStatus, jaXHR) {
        // responseData = {
        //   urls: [
        //     "https://test.babel.cc/document/129ea25ea3114158a540ee5b442557dc/babel.ocf?Expires=1699427067&OSSAccessKeyId=LTAI79cWnFxCa2Qt&Signature=Xd%2B664CcD2ceV%2BMyezGMtk17qCw%3D",
        //     "https://test.babel.cc/document/129ea25ea3114158a540ee5b442557dc/babel1.ocf?Expires=1699427067&OSSAccessKeyId=LTAI79cWnFxCa2Qt&Signature=89Wf4shbO9rPgARCygP%2FBVfD%2FbY%3D",
        //     "https://test.babel.cc/document/129ea25ea3114158a540ee5b442557dc/babel2.ocf?Expires=1699427067&OSSAccessKeyId=LTAI79cWnFxCa2Qt&Signature=Dxv2mAbAvHdnU0QHBxzI865PTMw%3D",
        //     "https://test.babel.cc/document/129ea25ea3114158a540ee5b442557dc/babel3.ocf?Expires=1699427067&OSSAccessKeyId=LTAI79cWnFxCa2Qt&Signature=9l9APG5kqmQuGB8sXVK0oppZpHA%3D",
        //     "https://test.babel.cc/document/129ea25ea3114158a540ee5b442557dc/babel4.ocf?Expires=1699427067&OSSAccessKeyId=LTAI79cWnFxCa2Qt&Signature=Mh60LjPUGwcOVYrdQJI5E9QVqxA%3D",
        //     "https://test.babel.cc/document/129ea25ea3114158a540ee5b442557dc/babel5.ocf?Expires=1699427067&OSSAccessKeyId=LTAI79cWnFxCa2Qt&Signature=Hesg5hd1hZmKzjwjrWVIDeu8ORk%3D",
        //   ],
        //   code: 0,
        //   success: true,
        //   layouts: [
        //     "*Model_Space",
        //     "*Paper_Space",
        //     "*Paper_Space22",
        //     "*Paper_Space23",
        //     "*Paper_Space21",
        //     "*Paper_Space7",
        //   ],
        //   fileNames: [
        //     "babel.ocf",
        //     "babel1.ocf",
        //     "babel2.ocf",
        //     "babel3.ocf",
        //     "babel4.ocf",
        //     "babel5.ocf",
        //   ],
        // };

        // console.warn(responseData);
        _this2.gstarSDK.Tips.showProgress(0, BabelStr.str(21553));
        if (responseData.success) {
          for (var i = 0; i < responseData.layouts.length; i++) {
            _this2.urlObj[responseData.layouts[i]] = {
              url: responseData.urls[i],
              name: responseData.fileNames[i]
            };
          }
          _success && _success();
          // MDLoadMaskView.remove();
          _this2.showcad(responseData.urls[0]);
        } else {
          if (responseData.code == "10010" && _this2.tryCount < 50) {
            _this2.tryCount++;
            setTimeout(function () {
              _this2.getUrl(_success, fail);
            }, 3000);
          } else {
            _success && _success();
            _this2.gstarSDK.Tips.showProgress(0, BabelStr.str(21551));
          }
          // _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  getDrawSheet: function getDrawSheet(url, success, fail) {
    var self = this;
    var req = new XMLHttpRequest();
    req.open("GET", url, true);
    req.responseType = "arraybuffer";
    req.send(null);
    req.addEventListener("progress", function (evt) {
      if (evt.lengthComputable) {
        self.gstarSDK.Tips.showProgress(0, BabelStr.str(21553));
      }
    }, false);
    req.onload = function () {
      if (req.status >= 200 && req.status < 300 || req.status === 304) {
        success && success(req.response);
      } else {
        self.gstarSDK.Tips.showProgress(0, url + BabelStr.str(21552));
      }
    };
    req.onerror = function () {
      self.gstarSDK.Tips.showProgress(0, url + BabelStr.str(21552));
      fail && fail();
    };
  },
  getCenterRatioPosition: function getCenterRatioPosition() {
    var center = {
      x: 0,
      y: 0
    };
    return center;
  },
  restoreCenterPostion: function restoreCenterPostion(ratioCenter) {
    var pos = {
      x: 0,
      y: 0
    };
    var container = this.$content[0];
    container.scrollTop = pos.y;
    container.scrollLeft = pos.x;
  },
  getScale: function getScale() {
    return 1;
  },
  setScale: function setScale() {},
  changeScale: function changeScale(scale, callback) {
    if (callback) {
      callback();
    }
  },
  refreshSize: function refreshSize() {},
  closeCommentPanel: function closeCommentPanel() {},
  getCurrentFileInfo: function getCurrentFileInfo() {
    return this.curFileInfo;
  },
  removeFromSuperView: function removeFromSuperView() {
    if (this._watermarkOverlay) {
      this._watermarkOverlay.cleanup();
      this._watermarkOverlay = null;
    }
    try {
      this.gstarSDK && this.gstarSDK.destroy();
    } catch (error) {
      console.log(error);
    }
    if (!app.canDispInNormalBrowser()) {
      this.$content.off("click");
    }
    this.$content.remove();
  },
  // 以下是为了配合手机界面的接口
  getCurrentBoard: function getCurrentBoard() {
    return this.curFileInfo.getBoard();
  },
  getCurrentFilePageCount: function getCurrentFilePageCount() {
    return 1;
  },
  getKityminderEditorIndex: function getKityminderEditorIndex() {
    return window.kityminderEditorIndex++;
  },
  getCurrentFilePageIndex: function getCurrentFilePageIndex() {
    return 0;
  },
  getCurrentFileIndex: function getCurrentFileIndex() {
    return 0;
  },
  getClassName: function getClassName() {
    return "MDCadFileEditor";
  },
  setCurOperation: function setCurOperation() {}
});
var _default = exports["default"] = MDCadFileEditor;

},{"1184":1184,"1417":1417,"1451":1451,"1454":1454,"1463":1463,"1541":1541,"809":809,"812":812}],55:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMViewBase = _interopRequireDefault(require(22));
/**
 *  MessageBox
 *  Create by manjun.han
 *  2015.9.10
 */

var defaults = {
  renderTo: 'body',
  zIndex: 'initial',
  duration: 4000
};
var MDMessageView = _MMViewBase["default"].extend({
  el: '<div class="m-msgbox"></div>',
  tmpl: '<div class="message-content"></div>\
          <button class="btn-close">×</button></button>',
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      sticked: false
    });
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click >.btn-close': this.close
    });
  },
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.setType('infor');
    if (this.sticked) {
      this.$el.addClass('sticked');
    }
    var zIndex = this.zIndex || defaults.zIndex;
    this.$el.css('z-index', zIndex);
  },
  setContent: function setContent(content) {
    this.$('.message-content').html(content);
  },
  close: function close() {
    var self = this;
    self.$el.removeClass("show");
    // self.$el.transitionEndOnce(function() {
    self.$el.remove();
    // });
  },
  show: function show(opt_renderTo, duration) {
    var self = this;
    opt_renderTo = opt_renderTo || defaults.renderTo;
    duration = duration || defaults.duration;
    this.$el.appendTo(opt_renderTo);
    this.el.offsetWidth;
    this.$el.addClass("show");
    _.delay(function () {
      self.close();
    }, duration);
  },
  setType: function setType(type) {
    var types = {
      'success': 'success',
      'error': 'error',
      'infor': 'infor'
    };
    var style = types[type];
    this.$el.removeClass().addClass('m-msgbox').addClass(style);
  }
}, {
  show: function show() {
    var message = '';
    var type = {};
    var renderTo = null;
    var duration;
    message = arguments[0];
    if (arguments.length >= 2) {
      type = arguments[1];
    }
    if (arguments.length >= 3) {
      renderTo = arguments[2];
    }
    if (arguments.length >= 4) {
      duration = arguments[3];
    }
    var messageView = new MDMessageView({
      zIndex: 3000
    });
    messageView.setContent(message);
    messageView.setType(type);
    messageView.show(renderTo, duration);
    return messageView;
  },
  success: function success(content, opt_renderTo) {
    return MDMessageView.show(content, 'success', opt_renderTo);
  },
  error: function error(content, opt_renderTo) {
    return MDMessageView.show(content, 'error', opt_renderTo);
  },
  infor: function infor(content, opt_renderTo) {
    return MDMessageView.show(content, 'infor', opt_renderTo);
  },
  setDefaults: function setDefaults(opt) {
    _.extend(defaults, opt);
  }
});
window.MDMessageView = MDMessageView;
var _default = exports["default"] = MDMessageView;

},{"1184":1184,"1454":1454,"22":22}],33:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1541);
var _MDWaitingConvertionView = _interopRequireDefault(require(34));
var _MDUpdatePromptWindowView = _interopRequireDefault(require(525));
var _MMFileInfo = _interopRequireDefault(require(297));
var _MDAlertView = _interopRequireDefault(require(32));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _utils = _interopRequireDefault(require(108));
/**
 *  Alert view
 *  Create by jiang
 *  2017.4.13
 */

// import MDClientDownloadWinView from '../../../moladisk/views/file/MDClientDownloadWinView.js'
var MDCheckStatusFromServer = {
  _showUpgradeEditionPrompt: function _showUpgradeEditionPrompt(str) {
    var alert = new _MDUpdatePromptWindowView["default"]({
      title: BabelStr.str(5067),
      content: str
    });
    alert.show();
  },
  checkFromServer: function checkFromServer(fileInfo, fileVersion, success, fail) {
    if (app.isMobile() && fileInfo.dispWithMS360()) {
      success(true);
      return;
    }
    var info = fileInfo.get("finishedVerInfo");
    if (info && info[fileVersion]) {
      success(true);
      return;
    }
    if (fileInfo.isShortcuts()) {
      fileInfo = fileInfo.getShortCutsTargetFile();
    }
    success = _.isFunction(success) ? success : _.noop;

    // if (fileInfo.isCADFile()) {
    //   var downloadWin = new MDClientDownloadWinView({
    //     title: BabelStr.str(4747),
    //   });
    //   downloadWin.show();
    //   _.isFunction(success) && success(false);
    //   return;
    // }

    fail = _.isFunction(fail) ? fail : _.noop;

    // if ((app.isEpVersion() || !fileInfo.canDispInOpenGL() || !fileInfo.isCADFile()) && fileInfo.isVersionReadyToOpen(fileVersion)) {
    //   success(true);
    //   return;
    // }

    // if (fileInfo.canDispWithTextBrowser() && fileInfo.canDownload()) {
    //   success(true);
    //   return;
    // }

    var self = this;
    var fileId = fileInfo.getFileId();
    if (!fileInfo.canRead()) {
      _MDAlertView["default"].showStandardPrompt({
        message: BabelStr.str(8577)
      });
      fail(false);
      return;
    }
    // if (fileInfo.isBannedFile()) {
    //   MDAlertView.showStandardPrompt({
    //     message: BabelStr.str(28225),
    //   });
    //   fail(false);
    //   return;
    // }
    if (fileInfo.getLinkFileUrl()) {
      success(true);
      return;
    }

    // if(fileInfo.getLinkFileUrl()) {
    //   fileInfo.setOnlyDisp(true);
    //   let errCb = function(link) {
    //     app.pathRouter.openNetTabWithoutHead(link)
    //   }
    //   let url = MMCommonFun.getImageDispPath(fileInfo.getFileId(), fileVersion)
    //   url += "&needJump2Url=0"
    //   let linkFileUrl = fileInfo.getLinkFileUrl()
    //   console.log(url)
    //   $.ajax({
    //     url: url,
    //     method: "post",
    //     success: (responseData, textStatus, jaXHR) => {
    //       console.warn(responseData);
    //       if (responseData.success) {
    //         if(responseData.url) {
    //           success(true)
    //         } else {
    //           errCb(linkFileUrl)
    //         }
    //       } else {
    //         errCb(linkFileUrl)
    //       }
    //     },
    //     fail: (res) => {
    //       errCb(linkFileUrl)
    //     },
    //   });
    //   success(true);
    //   return
    // }

    // this._showUpgradeEditionPrompt();

    var ajaxObj = null;
    if (window.canUseOnlyOffice && fileInfo.isExel() && window.readExcelWithOnlyOffice == 1) {
      fileInfo.setOnlyDisp(true);
      success(true);
      return;
    }
    if (!window.user.hasWindowsServer && fileInfo.isOfficeFile()) {
      if (window.canUseOnlyOffice) {
        fileInfo.setOnlyDisp(true);
        success(true);
        return;
      } else {
        fail(false);
        return;
      }
    }
    if (fileInfo.canDispWithKityMinder() && fileInfo.canDownload()) {
      success(true);
      return;
    }
    // if(fileInfo.isTextFile() && fileInfo.canDownload()) {
    //   success(true);
    //   return
    // }
    if (fileInfo.isDrawio()) {
      success(true);
      return;
    }
    if (fileInfo.isBabelOffice()) {
      success(true);
      return;
    }
    if (fileInfo.canDispWithGSCAD()) {
      fileInfo.setOnlyDisp(true);
      success(true);
      return;
    }
    if (app.ep.isClosedViewVideo() && fileInfo.isVideoDirectlyPlay()) {
      _MDAlertView["default"].showStandardPrompt({
        message: BabelStr.str(40072)
      });
      fail(false);
      return;
    }
    if (fileInfo.isAudioDirectlyPlay() || fileInfo.isVideoDirectlyPlay()) {
      success(true);
      return;
    }
    var waitingView = new _MDWaitingConvertionView["default"]();
    waitingView.show({
      className: "MDWaitingConvertionView",
      onHide: function onHide() {
        var successed = waitingView.successed;
        waitingView = null;
        ajaxObj && ajaxObj.abort();
        if (!successed) {
          success(false);
        }
      }
    });
    var showError = function showError(code, errorMsg, limitSize) {
      if (!waitingView) {
        return;
      }
      errorMsg = errorMsg || "";
      switch (code) {
        case 2:
          waitingView.showError(BabelStr.str(5117));
          console.log("参数错误");
          break;
        case 12:
          var isEp = app.isEpVersion();
          if (isEp) {
            waitingView.showError(errorMsg);
          } else {
            if (fileInfo.isAudio() || fileInfo.isVideo()) {
              waitingView.showError(BabelStr.str(5543));
            } else {
              waitingView.showError(BabelStr.str(20010));
            }
          }
          console.log("不支持此类型");
          break;
        case 101:
          waitingView.showError(BabelStr.str(549));
          console.log("文件不存在");
          break;
        case 132:
          waitingView.showError(BabelStr.str(5118));
          console.log("等待超时");
          break;
        case 105:
          waitingView.showError(BabelStr.str(5119));
          console.log("无法预览该文件，请下载查看");
          break;
        case 107:
          waitingView.showError(BabelStr.str(5120));
          console.log("暂不支持转换");
          break;
        case 106:
          waitingView.showError(BabelStr.str(5121));
          console.log("文档有密码");
          break;
        case 118:
          if (fileInfo.isSVGFile()) {
            dataReady = true;
          } else {
            waitingView.showError(BabelStr.str(5122));
            console.log("文件已损坏或者文件信息不完整，请下载查看");
          }
          break;
        case 127:
          var maxSize = fileInfo.getUploadMaxSize(limitSize);
          if (fileInfo.isExel()) {
            waitingView.showError(BabelStr.str(6144, {
              size: maxSize
            }));
          } else {
            waitingView.showError(BabelStr.str(6802, {
              size: maxSize
            }));
          }
          console.log("文件太大，不于转换");
          break;
        case 128:
          waitingView.showError(BabelStr.str(5124));
          console.log("演示文稿是空的");
          break;
        case 134: // auto CAD 文档数量超过了限制
        case 135:
          // 3D 打开文档超过数量限制了, 提示升级
          waitingView.close();
          self._showUpgradeEditionPrompt(errorMsg);
          break;
        case 139:
          // zhaoyuanchao 2017-07-01
          // 打开不是h.264编码的MP4文件时提示
          waitingView.showError(errorMsg);
          console.log(errorMsg);
          break;
        case 227:
          // 企业版过期
          waitingView.showError(errorMsg);
          console.log(errorMsg);
          break;
        case 10010:
          waitingView.showError(BabelStr.str(108));
          console.log(errorMsg);
          break;
        case 20101:
          //文件包含管理员设定的敏感词，禁止访问
          waitingView.showError(errorMsg);
          console.log(errorMsg);
          break;
        default:
          waitingView.showError(BabelStr.str(5125) + code);
      }
    };
    // MMCommonFun.testImageDispPath(
    //   fileInfo,
    //   fileId,
    //   fileVersion,
    //   () => {
    var decryptBySes = function decryptBySes(message) {
      var sessionId = g_sessionId;
      var key = sessionId[0];
      var index = 0;
      var step = 0;
      while (step < 7) {
        step++;
        index += step;
        key += sessionId[index];
      }
      return _MMCommonFun["default"].decryptDesCbc(message, key);
    };
    var maxTryCount = 3;
    var isFileConvertFinishedRequest = function isFileConvertFinishedRequest(reconvert) {
      ajaxObj = $.ajax({
        type: "POST",
        url: "/netdrive/isFileConvertFinished.do",
        dataType: "json",
        data: {
          fileId: fileId,
          version: fileVersion,
          reconvert: reconvert,
          dotmtxcli: app.ep.getdotmtxcli()
        },
        success: function success(resp) {
          if (!waitingView) {
            return;
          }
          var code = resp["code"];
          var fileStatus = resp["fileStatus"];
          if (code == 853) {
            waitingView.toggleHidden(true);
            _MMEnterpriseController["default"].checkFilesSequentially(resp.options.noPassFiles, function () {
              waitingView.toggleHidden();
              isFileConvertFinishedRequest(reconvert);
            }, function () {
              // MDSnackbarView.show(BabelStr.str(27029))
              _.isFunction(fail) && fail(false);
            });
            return;
          }
          // 需要轮询的条件（不满足则继续执行）
          var shouldPoll = resp.code === 10010 && !resp.dispIsReady && !(fileInfo.isSVGFile() && fileInfo.canDownload());
          if (shouldPoll && maxTryCount > 0) {
            setTimeout(function () {
              if (!resp.waterkey) {
                maxTryCount--;
              }
              isFileConvertFinishedRequest(reconvert);
            }, 2000);
            return;
          }
          waitingView.successed = true;

          // resp['canIpDownloadOrigin'] = true
          // resp['code'] = 0
          // resp['isEditingByOnlyOffice'] = false
          // resp['success'] = true

          // fileStatus = 10
          if (fileStatus == 10 && fileInfo.dispNeedWhiteBoard()) {
            var alert = new _MDAlertView["default"]();
            alert.show({
              title: BabelStr.str(170),
              message: "<p>".concat(BabelStr.str(6810), "</p>"),
              buttons: [{
                label: BabelStr.str(6811),
                type: "done",
                onClick: function onClick() {
                  isFileConvertFinishedRequest(1);
                }
              }, {
                label: BabelStr.str(156),
                onClick: function onClick() {
                  requestCallback(resp, code, fileInfo);
                }
              }]
            });
          } else {
            requestCallback(resp, code, fileInfo);
          }
        },
        error: function error(e) {
          _.isFunction(fail) && fail(false);
        }
      });
    };
    // if(fileInfo.isPdf()){
    var request = _MMEnterpriseController["default"].getPdfDispKey(fileId, fileVersion);
    request.then(function (encrpyted) {
      var password = decryptBySes(encrpyted);
      fileInfo.setPassowrdByVersion(fileVersion, password);
      isFileConvertFinishedRequest();
    })["catch"](function (code, msg) {
      console.log(code, msg);
      waitingView.showError(BabelStr.str(12200));
      fail(false);
    });
    // } else {
    //   isFileConvertFinishedRequest();
    // }

    var requestCallback = function requestCallback(resp, code, fileInfo) {
      // code = 118
      // code = 0
      if (resp["success"] || code == 136 || fileInfo.isOnlyTxt() || (code == 118 || code == 10010) && fileInfo.isSVGFile() && fileInfo.canDownload() || ((fileInfo.isImage() && !fileInfo.isImageNeedConvert() || fileInfo.isPdf()) && fileInfo.canDownload() || fileInfo.isOfficeFile()) && code != 101 && code != 227 && code != 127 || code == 127 && fileInfo.isExel() && (window.canUseOnlyOffice || window.readExcelWithOnlyOffice) && fileInfo.canRead()) {
        if (resp.waterkey) {
          // let waterkey = utils.decryptBySes(resp.waterkey)
          // console.log("waterkey", waterkey)
          fileInfo.set("waterkey", resp.waterkey);
        }
        if (fileInfo.canDownload() && !resp["canIpDownloadOrigin"]) {
          fileInfo.setIpCannotDownload();
        }
        if (fileInfo.canDownload() && (fileInfo.isImage() || fileInfo.isPdf()) && code != 0) {
          fileInfo.setOnlyDisp(true);
        }
        if (fileInfo.isOnlyTxt() && (code != 0 || window.user.hasWindowsServer == 0)) {
          fileInfo.setOnlyDisp(true);
        }
        if (window.canUseOnlyOffice && fileInfo.isOfficeFile() && code != 0
        // window.user.hasWindowsServer == 1
        ) {
          fileInfo.setOnlyDisp(true);
        }
        if (fileInfo.isExel() && (window.canUseOnlyOffice || window.readExcelWithOnlyOffice)) {
          fileInfo.setOnlyDisp(true);
        }
        if (window.canUseOnlyOffice && fileInfo.isExel() && window.readExcelWithOnlyOffice == 1) {
          fileInfo.setOnlyDisp(true);
        }
        if (code != 0 && fileInfo.isOfficeFile() && !fileInfo.isOnlyDisp()) {
          var errorMsg = resp["msg"];
          var dataReady = false;
          var limitSize = resp["limitSize"];
          {
            showError(code, errorMsg, limitSize);
          }
          if (!_MMCommonFun["default"].hasGodEye()) {
            MMNetDiskDataController._clearFileUnreadMarkWithIdAndVersion(fileId, fileVersion);
          }
          success(dataReady);
        } else {
          waitingView.stop(function () {
            waitingView.close();
            setBabelTimeout(function () {
              var info = fileInfo.get("finishedVerInfo");
              if (info) {
                info[fileVersion] = true;
              } else {
                info = {};
                info[fileVersion] = true;
                fileInfo.set("finishedVerInfo", info);
              }
              success(true);
            }, 300);
          });
          var isEditingByOnlyOffice = resp["isEditingByOnlyOffice"];
          if (isEditingByOnlyOffice) {
            fileInfo.setOnlyDisp(true);
            // MDAlertView.showStandardPrompt({
            //   message: BabelStr.str(21305),
            // });
          }
        }
      } else {
        var errorMsg = resp["msg"];
        var dataReady = false;
        var limitSize = resp["limitSize"];

        // if (errorMsg) {

        //   waitingView.showError(errorMsg);

        // } else
        {
          showError(code, errorMsg, limitSize);
        }
        if (!_MMCommonFun["default"].hasGodEye()) {
          MMNetDiskDataController._clearFileUnreadMarkWithIdAndVersion(fileId, fileVersion);
        }
        success(dataReady);
      }
    };
    //   },
    //   (code, msg) => {
    //     showError(code, msg);
    //   }
    // );

    //检测文件状态，主要应用于打开文件
  }
};
var _default = exports["default"] = MDCheckStatusFromServer;

},{"108":108,"1098":1098,"1184":1184,"1454":1454,"1541":1541,"297":297,"32":32,"34":34,"525":525,"72":72,"812":812}],34:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1541);
var _MMViewBase = _interopRequireDefault(require(22));
var _MDProgress = _interopRequireDefault(require(30));
var _MMBasicData = _interopRequireDefault(require(811));
var _MDLocalString = _interopRequireDefault(require(1150));
/**
 *  MDWaitingConvertionView view
 *  Create by jiang
 *  2016.12.26
 */

var MDWaitingConvertionView = _MMViewBase["default"].extend({
  el: '<div class="m-convertion"></div>',
  tmpl: '<header>' + '<span class="title convert-title"><%=BabelStr.str(5126)%></span>' + '<button class="icon closeBtn"></button>' + '</header>' + '<section>' + '<div class="processProg"></div>' + '</section>' + '<footer></footer>',
  overlayerTmpl: '<div class="g-conersion-overlayer"></div>',
  events: function events() {
    return {
      'click header .closeBtn': this._closeBtnClickHandler
    };
  },
  initProps: function initProps() {
    var superCls = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superCls, {
      // title: "提示",
      // width: 300,
      // message: "",
      // buttons: [],
      enableMove: false,
      // onShow: null,
      // onHide: null,
      // top: 'auto',
      $layoutWrapper: null,
      hideCloseBtn: false
    });
  },
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.$title = this.$(".title");
    this.$body = this.$("section");
    this.$footer = this.$("footer");
    this.$overlayer = $(this.overlayerTmpl);
    this.$closeBtn = this.$('>header .closeBtn');
    var title = _MDLocalString["default"].getLocalString(5473) + "...";
    this.$title.text(title);

    // if (this.enableMove) {
    //   this._enableMove();
    // }
    // this._setCloseBtnHidden(this.hideCloseBtn);
    var self = this;
    setTimeout(function () {
      if (!self.showErrorCalled) {
        var title = _MDLocalString["default"].getLocalString(108);
        self.$title.text(title);
      }
    }, 5000);
  },
  toggleHidden: function toggleHidden(hide) {
    if (hide) {
      this.$overlayer.addClass("f-hide");
      this.$layoutWrapper.addClass("f-hide");
    } else {
      this.$overlayer.removeClass("f-hide");
      this.$layoutWrapper.removeClass("f-hide");
    }
  },
  _setCloseBtnHidden: function _setCloseBtnHidden(hidden) {
    hidden ? this.$closeBtn.hide() : this.$closeBtn.show();
  },
  _mobileHook: function _mobileHook() {
    var self = this;
    // if (!app.isPC()) {
    this._disableMove();
    this._centerLayout();
    $(window).on(this.$nsEventName('resize'), function () {
      self._centerLayout();
    });
    // }
  },
  _enableMove: function _enableMove() {
    this.bindSelf(this._headerMouseDown, this._docMouseMove, this._docMouseUp);
    this.$('>header').mousedown(this._headerMouseDown);
  },
  _disableMove: function _disableMove() {
    this.$('>header').off('mousedown');
  },
  _headerMouseDown: function _headerMouseDown($e) {
    this.$el.data('startX', $e.clientX);
    this.$el.data('startY', $e.clientY);
    $(document).on(this.$nsEventName('mousemove'), this._docMouseMove).on(this.$nsEventName('mouseup') + this.eventId, this._docMouseUp);
  },
  _docMouseMove: function _docMouseMove($e) {
    var curX = $e.clientX;
    var curY = $e.clientY;
    var deltaX = curX - this.$el.data('startX');
    var deltaY = curY - this.$el.data('startY');
    this.$el.data('startX', curX);
    this.$el.data('startY', curY);
    var curpos = this.$el.position();
    var left = curpos.left + deltaX;
    var top = curpos.top + deltaY;
    left = left < 0 ? 0 : left;
    top = top < 0 ? 0 : top;
    var winWidth = $(window).width();
    var winHeight = $(window).height();
    var width = this.$el.outerWidth();
    var height = this.$el.outerHeight();
    if (left + width > winWidth) {
      left = winWidth - width;
    }
    if (top + height > winHeight) {
      top = winHeight - height;
    }
    this.$el.css('left', left);
    this.$el.css('top', top);
    this.$('>header').css('cursor', 'move');
  },
  _docMouseUp: function _docMouseUp($e) {
    $(document).off(this.$nsEventName('mousemove'), this._docMouseMove).off(this.$nsEventName('mouseup'), this._docMouseUp);
    this.$('>header').css('cursor', 'default');
  },
  /**
   *
   * @param  {{
   *    className:'',
   *    title:'',
   *    message:'',
   *    buttons:'',
   *    width:'',
   *    height:'',
   *    hidecloseBtn: false
   * }} opt
   * @return {[type]}     [description]
   */
  show: function show(opt) {
    // _.extend(this, opt);

    var self = this;
    this._renderOverlayer();
    this.$layoutWrapper = $("<div class='g-convertion'>").appendTo('body');
    this.renderTo(this.$layoutWrapper);
    this._renderButtons(this.buttons);
    this.onHide = opt.onHide;
    var winW = $(window).width();
    var viewW = 800;
    if (viewW > winW) {
      viewW = winW - 20;
    }
    ;
    this.$el.width(viewW);
    var height = this.height;
    var top;
    if (_.isNumber(this.top)) {
      top = this.top;
    } else {
      top = ($(window).height() - this.$el.outerHeight()) / 3;
    }
    top = top < 0 ? 0 : top;
    this.$el.css({
      left: ($(window).width() - this.width) / 2,
      top: top
    });
    this.el.offsetWidth;
    this._mobileHook();
    var zIndex = MDWaitingConvertionView.defaultZIndex + ++MDWaitingConvertionView.curAlertCount;
    this.$layoutWrapper.css("z-index", zIndex);
    this.$overlayer.css("z-index", zIndex);
    this.progress = new _MDProgress["default"]();
    this.progress.renderTo(this.$('.processProg'));
    this.progress.start();
    this.timeout = setBabelTimeout(function () {
      $('.g-convertion').addClass('show-dg');
      self._centerLayout();
    }, 1000);
  },
  _centerLayout: function _centerLayout() {
    var width = this.$el.outerWidth(),
      height = this.$el.outerHeight();
    this.$el.css({
      'left': ($(window).width() - width) / 2,
      'top': ($(window).height() - height) / 2,
      'margin': 0
    });
  },
  close: function close() {
    var self = this;
    $('.g-conersion-overlayer').remove();
    $('.g-convertion').remove();
    if (this.onHide) {
      this.onHide();
    }
    ;
  },
  _closeBtnClickHandler: function _closeBtnClickHandler() {
    this.close();
  },
  _renderOverlayer: function _renderOverlayer() {
    $('body').append(this.$overlayer);
  },
  _renderButtons: function _renderButtons(buttons) {
    var self = this;
    _.each(buttons, function (button, index) {
      var label = button.label || "";
      var onClick = button.onClick;
      var type = button.type || "";
      var $button = null;
      var autoClose = _.isBoolean(button.autoClose) ? button.autoClose : true;
      if (self.isEmptyString(label)) {
        return true;
      }
      var className = "default";
      switch (type) {
        case 'danger':
          className = 'danger';
          break;
        case 'done':
          className = 'done';
          break;
        default:
          className = 'default';
      }
      $button = $("<button>");
      $button.text(label);
      $button.addClass('button');
      $button.addClass(className);
      self.$footer.append($button);
      $button.click(function ($event) {
        if (self.isFunction(onClick)) {
          onClick.call(self, $button[0], $event);
        }
        if (autoClose) {
          self.close();
        }
        $event.stopPropagation();
      });
    });
  },
  viewDidUnRendered: function viewDidUnRendered() {
    _MMViewBase["default"].prototype.viewDidUnRendered.call(this);
    $(window).off(this.$nsEventName('resize'));
  },
  showError: function showError(text) {
    this.showErrorCalled = true;
    var self = this;
    $('.g-convertion').addClass('show-dg');
    var title = _MDLocalString["default"].getLocalString(170);
    self.$('.title').text(title);
    self._centerLayout();
    var $error = $('<div class="error-msg">' + text + '</div>');
    this.$('section').append($error);
    this.progress.done();
  },
  stop: function stop(callback) {
    clearTimeout(this.timeout);
    this.progress.stop(callback);
  }
}, {
  curAlertCount: 0,
  //    defaultZIndex:MMBasicData.getO2OMaxLayerZ_index()
  defaultZIndex: 7 * 100000000
});
var _default = exports["default"] = MDWaitingConvertionView;

},{"1150":1150,"1184":1184,"1454":1454,"1541":1541,"22":22,"30":30,"811":811}],30:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1541);
require(1465);
var _MMViewBase = _interopRequireDefault(require(22));
/**
 *  a progress view
 */

var MDProgress = _MMViewBase["default"].extend({
  el: '<div class="mdprog-root">' + '<div class="mdprog-prog">' + '<div class="mdprog-light"></div>' + '</div>' + '</div>',
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
  },
  setBackgroundcolor: function setBackgroundcolor(color) {
    this.$el.find('.mdprog-prog').css('background-color', color);
  },
  start: function start() {
    var self = this;
    this.$el.find('.mdprog-prog').css('width', '0%');
    if (this.timer) {
      clearInterval(this.timer);
    }
    ;
    this.pointer = 0;
    this.step = 0.001;
    this.finished = false;
    this.timer = setInterval(function () {
      self._progress();
    }, 100);
  },
  done: function done(stopCallback) {
    this.stopCallback = stopCallback;
    this.finished = true;
  },
  _progress: function _progress() {
    if (this.stopped) {
      clearInterval(this.timer);
      this.stopCallback();
      return;
    }
    ;
    if (!this.finished && this.pointer > 0.9) {} else if (this.finished) {
      this.step = 0.1;
      this.pointer += this.step;
    } else {
      this.pointer += this.step;
    }
    this.$el.find('.mdprog-prog').css('width', this.pointer * 100 + '%');
    if (this.pointer >= 1.0) {
      clearInterval(this.timer);
      if (this.stopCallback) {
        this.stopCallback();
      }
    }
    ;
  },
  getMile: function getMile() {
    return this.pointer;
  },
  setMile: function setMile(mile) {
    mile = parseFloat(mile);
    this.pointer = mile;
  },
  stop: function stop(stopCallback) {
    this.stopCallback = stopCallback;
    this.stopped = true;
  }
});
var _default = exports["default"] = MDProgress;

},{"1184":1184,"1417":1417,"1454":1454,"1463":1463,"1465":1465,"1541":1541,"22":22}],16:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1451);
var _MDVideoPlayerView = _interopRequireDefault(require(436));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MDLoadMaskView = _interopRequireDefault(require(49));
var _MDSnackbarView = _interopRequireDefault(require(72));
var MDAVFileBrowser = function MDAVFileBrowser(parentDiv, fileInfo) {
  this.$content = $('<div class="av-browser" style="position:absolute;width:100%;height:100%;top:0"></div>');
  $(parentDiv).append(this.$content);
  if (!app.canDispInNormalBrowser()) {
    this.$content.on('click', function () {
      Dispatcher.trigger(MDEvents.TapOnWhiteSpaceInDoc);
    });
  }
  ;
};
Object.assign(MDAVFileBrowser.prototype, Object.prototype, {
  contstructor: MDAVFileBrowser,
  openFile: function openFile(curFileInfo, version, callback) {
    _czc && _czc.push(["_trackEvent", "预览", "AV", "", "", ""]);
    var self = this;
    this.avPlayer = new _MDVideoPlayerView["default"]({
      fileInfo: curFileInfo
    });
    var fileId = curFileInfo.getFileId();
    this.curFileInfo = curFileInfo;
    self.avPlayer.renderTo(self.$content);
    var request;
    // if (curFileInfo.isMp4()) {
    request = _MMCommonFun["default"].getDocumentDispPath;
    // } else {
    // request = MMCommonFun.getDownloadRealPath;
    // }
    request(fileId, version, function (realUrl) {
      self.avPlayer.openWithUrl(curFileInfo, realUrl, curFileInfo.getFileName());
      callback();
    }, function (errorCode, errorMsg) {
      if (errorCode == 141) {
        _MDSnackbarView["default"].showStandardMsg(42);
      } else {
        _MDSnackbarView["default"].show(errorMsg);
      }
    });
  },
  getScale: function getScale() {
    return 1;
  },
  setScale: function setScale() {},
  refreshSize: function refreshSize() {},
  getClassName: function getClassName() {
    return "MDAVFileBrowser";
  },
  closeCommentPanel: function closeCommentPanel() {},
  removeFromSuperView: function removeFromSuperView() {
    this.avPlayer.close();
    if (!app.canDispInNormalBrowser()) {
      this.$content.off('click');
    }
    ;
    this.$content.remove();
  },
  // 以下是为了配合手机界面的接口
  getCurrentBoard: function getCurrentBoard() {
    return null;
  },
  getCurrentFilePageCount: function getCurrentFilePageCount() {
    return 1;
  },
  getCurrentFilePageIndex: function getCurrentFilePageIndex() {
    return 0;
  },
  getCurrentFileIndex: function getCurrentFileIndex() {
    return 0;
  }
});
var _default = exports["default"] = MDAVFileBrowser;

},{"1104":1104,"1184":1184,"1451":1451,"1454":1454,"436":436,"49":49,"72":72,"812":812}],436:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1541);
require(1417);
require(1463);
require(1471);
var _MMViewBase = _interopRequireDefault(require(22));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _dplayer = _interopRequireDefault(require("dplayer"));
var _MEWatermarkOverlay = _interopRequireDefault(require(809));
/**
 *  video
 *  Created by Dai
 *  2017.6.22
 */

var MDVideoPlayerView = _MMViewBase["default"].extend({
  el: '<div class="video video-bg"></div>',
  tmpl: "<div\n    class=\"dplayer jp-video\"\n  >\n  </div>",
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      "click .video-close": this.close,
      "click .jp-mute": this.toggleVolume,
      "dblclick .jp-jplayer": this.toggleFullscreen,
      "click .jp-jplayer": this.togglePlay,
      "click .rate-btn": this.toggleRatelist,
      "click .rate-list .item": this.checkItemRate,
      "contextmenu video": this._videoClick
    });
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      fileInfo: null
    });
  },
  initialize: function initialize(opt) {
    opt.data = {
      isPC: app.canDispInNormalBrowser()
    };
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.bindSelf(this.setVolumn, this.resizeVideoSize);
    this.$(".jp-header").hide();
  },
  toggleRatelist: function toggleRatelist() {
    this.$(".rate-list").toggle();
  },
  checkItemRate: function checkItemRate($e) {
    var id = $($e.target).data("id");
    this.$("#jquery_jplayer_1").jPlayer({
      playbackRate: id
    });
    $(".rate-list .item").removeClass("check");
    $($e.target).addClass("check");
    $(".rate-list").hide();
  },
  _videoClick: function _videoClick($e) {
    return false;
  },
  openWithUrl: function openWithUrl(fileInfo, url, name) {
    var self = this;
    this.fileInfo = fileInfo;
    if (fileInfo.isVideoDirectlyPlay() || fileInfo.isAudioDirectlyPlay()) {
      this.dispVideo(url);
    } else {
      this.convertFileByUrl(url);
    }

    // if (app.canDispInNormalBrowser()) {
    //   var options = self.$("#jquery_jplayer_1").jPlayer('option');
    //   self.setVolumn(options);
    //   self.$("#jquery_jplayer_1").jPlayer("setMedia", {
    //     title: name,
    //     m4v: url
    //   });
    //   self.$("#jquery_jplayer_1").jPlayer('play', 0);
    //   if(this.fileInfo.isAudio()){
    //     this.$("#jquery_jplayer_1").append('<img class="img-audio" src="../../../../img/mp3.jpg" alt="">');
    //   }else{
    //     this.$("#jquery_jplayer_1").removeClass("audio-play");
    //   }
    // } else {
    //   this.$el.addClass('jp-mobile-video').empty().append('<video width="100%" height="360px" controls oncontextmenu="return(false);" controlslist="nodownload">\
    //     <source src="' + url + '" type="video/mp4">\
    //     '+BabelStr.str(7143)+'\
    //   </video>');
    // }
    self.fileInfo.clearUnReadCount();
    _MMNetDiskDataController["default"].clearUnreadMarkWithVerNum(self.fileInfo, self.fileInfo.getCurVersion());
    MMEnterpriseController.isFileNeedWatermarkPreview(self.fileInfo.getFileId(), function (data) {
      self.watermarkInfo = data;
      self.watermarkInfo.needStroke = 1;
      self.drawWatermark();
    });
  },
  drawWatermark: function drawWatermark() {
    var self = this;
    if (!this.watermarkInfo) {
      return;
    }
    var resizeTimer = null;
    this._watermarkOverlay = _MEWatermarkOverlay["default"].createWatermarkOverlay({
      container: self.dp.container,
      canvasId: "watermark-canvas",
      getSize: function getSize() {
        if (!self.dp || !self.dp.video) return null;
        var video = self.dp.video;
        var dpr = window.devicePixelRatio || 1;
        var rect = video.getBoundingClientRect();
        return {
          cssWidth: rect.width,
          cssHeight: rect.height,
          pixelWidth: Math.round(rect.width * dpr),
          pixelHeight: Math.round(rect.height * dpr),
          dpr: dpr
        };
      },
      getWatermarkInfo: function getWatermarkInfo() {
        return self.watermarkInfo;
      }
    });
    function onResize() {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        self._watermarkOverlay.setNeedsRepaint();
        self._watermarkOverlay.ensureWatermark();
        self._watermarkOverlay.render();
      }, 100);
    }
    function onPlay() {
      self._watermarkOverlay.setNeedsRepaint();
      self._watermarkOverlay.ensureWatermark();
      self._watermarkOverlay.render();
    }
    self.dp.video.addEventListener("loadedmetadata", function () {
      self._watermarkOverlay.render();
    });
    self.dp.video.addEventListener("play", onPlay);
    self.dp.video.addEventListener("seeked", function () {
      self._watermarkOverlay.render();
    });
    window.addEventListener("resize", onResize);
    var oldCleanup = this._watermarkOverlay.cleanup;
    this._watermarkOverlay.cleanup = function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      window.removeEventListener("resize", onResize);
      if (self.dp && self.dp.video) {
        self.dp.video.removeEventListener("loadedmetadata", self._watermarkOverlay.render);
        self.dp.video.removeEventListener("play", onPlay);
        self.dp.video.removeEventListener("seeked", self._watermarkOverlay.render);
      }
      oldCleanup.call(self._watermarkOverlay);
    };
  },
  dispVideo: function dispVideo(url) {
    var self = this;
    this.id = "my-video-" + this.fileInfo.getFileId();
    this.$el.find(".dplayer").attr("id", this.id);
    var pic;
    if (this.fileInfo && this.fileInfo.isAudio()) {
      pic = "img/mp3.jpg";
    }
    var dp = new _dplayer["default"]({
      container: document.getElementById(this.id),
      playbackSpeed: [0.5, 0.75, 1, 1.25, 1.5, 2],
      autoplay: true,
      video: {
        url: url,
        pic: pic
      }
    });
    // 初始化 watermark-canvas
    dp.on("loadeddata", function () {
      self.drawWatermark();
    });
    this.dp = dp;
    self.resizeVideoSize();

    // this.$el.find("video").attr("id", this.id);
    // this.myPlayer = videojs(this.id, {
    //   playbackRates: [0.5, 1, 1.5, 2, 4],
    // });
    // if (this.fileInfo.isFlv() && flvjs.isSupported()) {
    //   var flvPlayer = flvjs.createPlayer({
    //     type: "flv",
    //     url: url,
    //   });
    //   let video = this.$el.find("video")[0];
    //   flvPlayer.attachMediaElement(video);
    //   flvPlayer.load();
    //   flvPlayer.play();
    // } else {
    //   this.myPlayer.src(url);
    //   this.myPlayer.ready(function () {
    //     self.resizeVideoSize();
    //     // get
    //     // var howLoudIsIt = this.myPlayer.volume();
    //     // // set
    //     // this.myPlayer.volume(0.5); // Set volume to half
    //   });
    // }
  },
  convertFileByUrl: function convertFileByUrl(fileUrl) {
    var desiredFileName = this.fileInfo.getFileName(); // 替换为你想要的文件名
    this.dispVideo("http://localhost:3000/getDisplayVideo");
    // this.downloadFileAndCreateFile(fileUrl, desiredFileName)
    //   .then(async (file) => {

    // console.log("文件已下载并转换为File对象:", file);
    // const formData = new FormData();
    // formData.append("file", file);

    // try {
    //   fetch("http://localhost:3000/getDisplayVideo", {
    //     method: "POST",
    //     body: formData,
    //   })
    //     .then((response) => {
    //       if (!response.ok) {
    //         throw new Error("Network response was not ok");
    //       }
    //       // // 设置video.js的源为转换后的MP4流
    //       // player.src({
    //       //   type: "video/mp4",
    //       //   src: URL.createObjectURL(
    //       //     new Blob([response.body], { type: "video/mp4" })
    //       //   ),
    //       // });
    //       this.dispVideo('http://localhost:3000/getDisplayVideo')
    //       // 播放视频
    //       // player.play();
    //     })
    //     .catch((error) => {
    //       console.error(
    //         "There has been a problem with your fetch operation:",
    //         error
    //       );
    //     });

    // // 假设服务器返回了一个包含视频URL的JSON响应
    // const data = await response.json();
    // console.log(data);
    // const videoUrl = data.videoUrl;
    // // 设置video.js的source
    // this.dispVideo(videoUrl);
    // const player = videojs('my-video');
    // player.src({ type: 'video/mp4', src: videoUrl });
    // player.play();
    // } catch (error) {
    //   console.error(
    //     "There has been a problem with your fetch operation:",
    //     error
    //   );
    // }
    // })
    // .catch((error) => {
    //   console.error("下载文件或创建File对象时出错:", error);
    // });
  },
  downloadFileAndCreateFile: function downloadFileAndCreateFile(url, fileName) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob"; // 设置响应类型为Blob

      xhr.onload = function () {
        if (xhr.status === 200) {
          // 请求成功，读取响应数据
          var blob = xhr.response;

          // 创建一个File对象
          var file = new File([blob], fileName, {
            type: blob.type
          });

          // 解析成功，返回File对象
          resolve(file);
        } else {
          // 请求失败
          reject(new Error("\u8BF7\u6C42\u5931\u8D25\uFF0C\u72B6\u6001\u7801\uFF1A".concat(xhr.status)));
        }
      };
      xhr.onerror = function () {
        // 网络错误或其他错误
        reject(new Error("网络错误或请求失败"));
      };

      // 发送请求
      xhr.send();
    });
  },
  setVolumn: function setVolumn(options) {
    var volume = options.volume;
    var $volumeIndicatorButton = this.$(".jp-mute");
    var muted = $("#jquery_jplayer_1").jPlayer("option").muted;
    if (muted) {
      $volumeIndicatorButton.attr("class", "jp-mute jp-volume-silent");
    } else {
      if (volume < 0.001) {
        $volumeIndicatorButton.attr("class", "jp-mute jp-volume-silent");
      } else if (volume < 0.333) {
        $volumeIndicatorButton.attr("class", "jp-mute jp-volume-small");
      } else if (volume < 0.6777) {
        $volumeIndicatorButton.attr("class", "jp-mute ");
      } else {
        $volumeIndicatorButton.attr("class", "jp-mute jp-volume-large");
      }
    }
  },
  close: function close() {
    if (this._watermarkOverlay) {
      this._watermarkOverlay.cleanup();
      this._watermarkOverlay = null;
    }
    this.remove();
    $(".editor-mask").remove();
    if (app.canDispInNormalBrowser()) {
      $(window).off(this.$nsEventName("resize"));
      $("#jquery_jplayer_1").jPlayer("destroy");
    }
    this.myPlayer && this.myPlayer.dispose();
  },
  toggleFullscreen: function toggleFullscreen() {
    this.$(".jp-full-screen").click();
  },
  togglePlay: function togglePlay() {
    this.$(".jp-play").click();
    return false;
  },
  resizeVideoSize: function resizeVideoSize() {
    var winWidth = $(this.el.parentNode).width();
    var winHeight = $(this.el.parentNode).height();
    var vedioPlayerAspectRation = 16 / 9;
    var winAspectRation = winWidth / winHeight;
    var width = 0;
    var height = 0;
    var maxVedioPlayerWidth = 900;
    var minVedioPlayerWidth = 360;
    var percentage = 0.8;
    if (winAspectRation > vedioPlayerAspectRation) {
      height = winHeight * percentage;
      width = height * vedioPlayerAspectRation;
    } else {
      width = winWidth * percentage;
    }
    width = Math.min(width, maxVedioPlayerWidth);
    width = Math.max(width, minVedioPlayerWidth);
    height = width / vedioPlayerAspectRation;
    if (this.fileInfo.isAudio()) {
      var newheight = width * 3 / 4;
      if (newheight > height) {
        width = height * 4 / 3;
      } else {
        height = newheight;
      }
    }
    this.$(".jp-video").css({
      width: width + "px",
      height: height + "px"
    });
  },
  viewDidRendered: function viewDidRendered() {
    var _this = this;
    _MMViewBase["default"].prototype.viewDidRendered.call(this);
    var self = this;
    if (app.canDispInNormalBrowser()) {
      $(window).on(this.$nsEventName("resize"), function () {
        _this.resizeVideoSize();
      });
      //   this.$(".jp-video").hide();
      //   this.$("#jquery_jplayer_1").jPlayer({
      //     volumechange: function($e) {
      //       self.setVolumn($e.jPlayer.options);
      //     },
      //     ready: function() {
      //       // self.$("#jquery_jplayer_1").show();
      //       self.$(".jp-video").show();
      //       self.resizeVideoSize();
      //       var options = self.$("#jquery_jplayer_1").jPlayer('option');
      //       self.setVolumn(options);
      //       self.resizeVideoSize();
      //     },

      //     sizeFull: {
      //       width: '100%'
      //     },
      //     cssSelectorAncestor: "#jp_container_1",
      //     supplied: "ogv, webmv, m4v",
      //     useStateClassSkin: true,
      //     autoBlur: false,
      //     smoothPlayBar: true,
      //     keyEnabled: true,
      //     remainingDuration: true,
      //     toggleDuration: false,
      //     backgroundColor: '#ffffff',
      //     solution: 'html'
      //   });
    }
  },
  viewDidUnRendered: function viewDidUnRendered() {
    _MMViewBase["default"].prototype.viewDidUnRendered.call(this);
    $(window).off(this.$nsEventName("resize"));
  }
});
var _default = exports["default"] = MDVideoPlayerView;

},{"1104":1104,"1184":1184,"1417":1417,"1454":1454,"1463":1463,"1471":1471,"1541":1541,"22":22,"809":809,"dplayer":"dplayer"}],"dplayer":[function(require,module,exports){
"use strict";

module.exports = window.DPlayer;
if (window.DPlayer) module.exports["default"] = window.DPlayer;

},{}],809:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1421);
require(1541);
require(1465);
var _MEWaterMarkRenderer = _interopRequireDefault(require(808));
/**
 * @Author: jichao
 * @Date: 2026-07-16
 * @FilePath: javascript/molasync-source/common/MEWatermarkOverlay.js
 */

function applyWatermarkStyles(el, extraStyles) {
  el.style.setProperty("position", "absolute", "important");
  el.style.setProperty("top", "0", "important");
  el.style.setProperty("left", "0", "important");
  el.style.setProperty("pointer-events", "none", "important");
  el.style.setProperty("z-index", "2147483647", "important");
  el.style.setProperty("display", "block", "important");
  el.style.setProperty("visibility", "visible", "important");
  el.style.setProperty("opacity", "1", "important");
  el.style.setProperty("transform", "none", "important");
  if (extraStyles) {
    for (var key in extraStyles) {
      if (extraStyles.hasOwnProperty(key)) {
        el.style.setProperty(key, extraStyles[key], "important");
      }
    }
  }
  var classList = el.classList;
  if (classList && classList.length) {
    var toRemove = [];
    for (var i = 0; i < classList.length; i++) {
      var cls = classList[i];
      if (cls.indexOf("__web-inspector") === 0 || cls.indexOf("chrome-inspector") === 0) {
        toRemove.push(cls);
      }
    }
    for (var j = 0; j < toRemove.length; j++) {
      classList.remove(toRemove[j]);
    }
  }
}
function createWatermarkOverlay(options) {
  var container = options.container;
  var getSize = options.getSize;
  var getWatermarkInfo = options.getWatermarkInfo;
  var canvasId = options.canvasId || null;
  var canvasClass = options.canvasClass || "";
  var existingCanvas = options.existingCanvas || null;
  var onCanvasRecreated = options.onCanvasRecreated || null;
  var extraStyles = options.extraStyles || null;
  var beforeRender = options.beforeRender || null;
  var theCanvas = null;
  var ctx = null;
  var lastWidth = 0;
  var lastHeight = 0;
  var needsRepaint = true;
  var guardTimer = null;
  var mutationObserver = null;
  var resizeTimer = null;
  var isCleaningUp = false;
  function onResize() {
    if (isCleaningUp) return;
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      needsRepaint = true;
      render();
    }, 100);
  }
  function initCanvas() {
    if (theCanvas && theCanvas.parentNode) {
      ctx = theCanvas.getContext("2d");
      return;
    }
    if (existingCanvas && existingCanvas.parentNode) {
      theCanvas = existingCanvas;
    } else if (canvasId) {
      var found = container.querySelector("#" + canvasId);
      if (found) {
        theCanvas = found;
      }
    }
    if (!theCanvas) {
      theCanvas = document.createElement("canvas");
      if (canvasId) theCanvas.id = canvasId;
      if (canvasClass) theCanvas.className = canvasClass;
      container.appendChild(theCanvas);
    }
    applyWatermarkStyles(theCanvas, extraStyles);
    ctx = theCanvas.getContext("2d");
    needsRepaint = true;
  }
  function render() {
    var size = getSize();
    if (!size || size.cssWidth <= 0 || size.cssHeight <= 0) return;
    var dpr = size.dpr || window.devicePixelRatio || 1;
    var pixelWidth = size.pixelWidth || Math.round(size.cssWidth * dpr);
    var pixelHeight = size.pixelHeight || Math.round(size.cssHeight * dpr);
    var sizeChanged = pixelWidth !== lastWidth || pixelHeight !== lastHeight;
    if (sizeChanged) {
      lastWidth = pixelWidth;
      lastHeight = pixelHeight;
      theCanvas.width = pixelWidth;
      theCanvas.height = pixelHeight;
      theCanvas.style.setProperty("width", size.cssWidth + "px", "important");
      theCanvas.style.setProperty("height", size.cssHeight + "px", "important");
      needsRepaint = true;
    }
    applyWatermarkStyles(theCanvas, extraStyles);
    if (needsRepaint) {
      var watermarkInfo = getWatermarkInfo();
      if (!watermarkInfo) return;
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.clearRect(0, 0, pixelWidth, pixelHeight);
      if (beforeRender) {
        beforeRender(ctx, theCanvas, pixelWidth, pixelHeight, dpr);
      }
      _MEWaterMarkRenderer["default"]._drawWaterMark(ctx, theCanvas, watermarkInfo);
      needsRepaint = false;
    }
  }
  function isCanvasHidden() {
    if (!theCanvas) return true;
    if (theCanvas.hidden) return true;
    var style = getComputedStyle(theCanvas);
    if (style.display === "none" || style.visibility === "hidden" || style.visibility === "collapse") return true;
    if (parseFloat(style.opacity) === 0) return true;
    return false;
  }
  function ensureWatermark() {
    if (isCleaningUp) return;
    if (!theCanvas || !theCanvas.isConnected || theCanvas.parentNode !== container) {
      theCanvas = document.createElement("canvas");
      if (canvasId) theCanvas.id = canvasId;
      if (canvasClass) theCanvas.className = canvasClass;
      if (existingCanvas && existingCanvas.parentNode) {
        existingCanvas.parentNode.removeChild(existingCanvas);
      }
      container.appendChild(theCanvas);
      applyWatermarkStyles(theCanvas, extraStyles);
      if (onCanvasRecreated) onCanvasRecreated(theCanvas);
      ctx = theCanvas.getContext("2d");
      lastWidth = 0;
      lastHeight = 0;
      needsRepaint = true;
      setupMutationObserver();
      render();
    } else if (isCanvasHidden()) {
      applyWatermarkStyles(theCanvas, extraStyles);
      theCanvas.hidden = false;
      if (theCanvas.getAttribute("hidden") !== null) {
        theCanvas.removeAttribute("hidden");
      }
      needsRepaint = true;
      render();
    } else {
      var size = getSize();
      if (size && size.cssWidth > 0 && size.cssHeight > 0) {
        var dpr = size.dpr || window.devicePixelRatio || 1;
        var pixelWidth = size.pixelWidth || Math.round(size.cssWidth * dpr);
        var pixelHeight = size.pixelHeight || Math.round(size.cssHeight * dpr);
        if (pixelWidth !== lastWidth || pixelHeight !== lastHeight) {
          needsRepaint = true;
          render();
        } else if (needsRepaint) {
          render();
        }
      }
    }
  }
  function setupMutationObserver() {
    if (mutationObserver) mutationObserver.disconnect();
    if (!container) return;
    mutationObserver = new MutationObserver(function (mutations) {
      if (isCleaningUp) return;
      var needRestore = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === "childList") {
          for (var j = 0; j < m.removedNodes.length; j++) {
            if (m.removedNodes[j] === theCanvas) {
              needRestore = true;
              break;
            }
          }
        } else if (m.type === "attributes" && m.target === theCanvas) {
          // fix(resize-freeze): applyWatermarkStyles 每次渲染都会重写 style 属性并再次触发本 observer，
          // 形成 render→observer→ensureWatermark→render 自激死循环（改窗口大小时引爆）。
          // 仅当 canvas 被外部真正隐藏或断开时才需要恢复，自身样式写入不再触发。
          if (isCanvasHidden() || !theCanvas.isConnected) {
            needRestore = true;
            break;
          }
        }
        if (needRestore) break;
      }
      if (needRestore) {
        needsRepaint = true;
        ensureWatermark();
      }
    });
    mutationObserver.observe(container, {
      childList: true,
      subtree: false
    });
    if (theCanvas) {
      mutationObserver.observe(theCanvas, {
        attributes: true,
        attributeFilter: ["style", "id", "class", "hidden"]
      });
    }
  }
  function setNeedsRepaint() {
    needsRepaint = true;
  }
  function getCanvas() {
    return theCanvas;
  }
  function cleanup() {
    isCleaningUp = true;
    if (guardTimer) {
      clearInterval(guardTimer);
      guardTimer = null;
    }
    if (mutationObserver) {
      mutationObserver.disconnect();
      mutationObserver = null;
    }
    if (resizeTimer) {
      clearTimeout(resizeTimer);
      resizeTimer = null;
    }
    window.removeEventListener("resize", onResize);
    if (theCanvas && theCanvas.parentNode) {
      theCanvas.parentNode.removeChild(theCanvas);
    }
    theCanvas = null;
    ctx = null;
  }
  initCanvas();
  render();
  setupMutationObserver();
  guardTimer = setInterval(ensureWatermark, 500);
  window.addEventListener("resize", onResize);
  return {
    render: render,
    cleanup: cleanup,
    setNeedsRepaint: setNeedsRepaint,
    getCanvas: getCanvas,
    ensureWatermark: ensureWatermark
  };
}
var MEWatermarkOverlay = {
  createWatermarkOverlay: createWatermarkOverlay,
  applyWatermarkStyles: applyWatermarkStyles
};
var _default = exports["default"] = MEWatermarkOverlay;

},{"1184":1184,"1421":1421,"1454":1454,"1465":1465,"1541":1541,"808":808}],9:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDColladaDisplayer = _interopRequireDefault(require(11));
var _MD3DToolbar = _interopRequireDefault(require(14));
var _MD3DObjectVisibleListPanel = _interopRequireDefault(require(13));
var _MDLoadMaskView = _interopRequireDefault(require(49));
var _MDAlertView = _interopRequireDefault(require(32));
// MD3DEditor.js
//
// jiang
// 2016-9-6

//
//  类结构图 - 3D 模型的显示控制
//
//  类结构如下（+ 代表包含一个， ++ 代表包含一个或多个）：
//
//  MD3DEditor
//           | 
//           +———  MDColladaLoader  // 加载 collada 文件
//           |
//           +---  MDColladaDisplayer  // 显示 3D 模型内容
//           |          |
//           |          +———  THREE.WebGLRenderer
//           |          |
//           |          +---  THREE.Scene
//           |          |
//           |          +---  THREE.PerspectiveCamera
//           |          |
//           |          +---  THREE.AmbientLight
//           |          |
//           |          +---  THREE.SpotLight
//           |          |
//           |          +---  MD3DCommentPosCalculator
//           |          |
//           |          +---  MD3DCommentsController
//           |          |            |
//           |          |            +--- MDCommentsFile
//           |          |            |
//           |          |            ++—— MD3DCommentDiv -- 批注的显示对象
//           |          |            |           |
//           |          |            |           +--- MD3DComment -- 批注的数据对象
//           |          |            |
//           |          |            +——— MDCommentSlidePanelView -- 批注面板
//           |          |
//           |          -
//           |
//           +---   MD3DToolbar  // 控制显示 3D 的工具栏
//           |
//           +---   MD3DObjectVisibleListPanel     // 隐藏对象的控制面板
//           |
//           -
//

function MD3DEditor(parentDiv, opt) {
  this.parentDiv = parentDiv;
  this.editorViewCtl = opt.editorViewCtl;
  this.threeDisp = null;
  this.constructEditor();
  _czc && _czc.push(["_trackEvent", "预览", "3D", "", "", ""]);
}
;
MD3DEditor.prototype = function () {
  //----------------------------------------------------------------------------------------------------
  //       private function
  //----------------------------------------------------------------------------------------------------
  function _clearTouchlayerClass() {
    this.$touchLayer.removeClass('cursor-normal');
    this.$touchLayer.removeClass('cursor-hide');
    this.$touchLayer.removeClass('cursor-ruler');
  }

  //----------------------------------------------------------------------------------------------------
  //       private function
  //----------------------------------------------------------------------------------------------------
  return {
    contstructor: MD3DEditor,
    constructEditor: function constructEditor() {
      var parentDiv = this.parentDiv;
      this.containerId = "3DContainer";
      this.touchId = "3DTouchLayer";
      this.$editorLayer = $('<div id="' + this.containerId + '" style="position:absolute;width:100%;height:100%;top:0px;left:0px"></div>');
      this.$touchLayer = $('<div id="' + this.touchId + '" style="position:absolute;width:100%;height:100%;background-color:rgba(0,0,0,0)"></div>');
      $(this.parentDiv).append(this.$editorLayer);
      $(this.parentDiv).append(this.$touchLayer);
      this.threeDisp = new _MDColladaDisplayer["default"](this.containerId, this.touchId, this);
      this.toolbar3d = new _MD3DToolbar["default"]({
        editor: this
      });
      $(this.parentDiv).append(this.toolbar3d.$el);
      _MDColladaDisplayer["default"].setInstance(this.threeDisp);
      this.visiblePanel = new _MD3DObjectVisibleListPanel["default"]({
        threeDDisp: this.threeDisp
      });
      $(this.parentDiv).append(this.visiblePanel.$el);
    },
    initWith3DFile: function initWith3DFile(curFileInfo, commentsFile, modelUrl, callback) {
      this.curFileInfo = curFileInfo;
      this.loader = new THREE.MDColladaLoader();
      this.threeDisp.setCommentsFile(commentsFile);

      // 初始化 3D 对象的 id 计数器
      THREE.Object3DIdCount = 0;
      var self = this;
      _MDLoadMaskView["default"].show();
      var tempPercent = 0;
      this.loader.load(curFileInfo,
      // resource URL
      modelUrl,
      // Function when resource is loaded
      function (collada) {
        // 如果窗口已经不存在了，就不做任何处理
        if (self.removed) {
          return;
        }
        ;
        collada['scene'].traverse(function (child) {
          if (child instanceof THREE.SkinnedMesh) {
            var animation = new THREE.Animation(child, child.geometry.animation);
            animation.play();
            self.threeDisp.lookAt(child.position);
          }
        });
        var colladaScene = collada['scene'];
        var targetObj = colladaScene;

        // debug code
        // colladaScene.traverse(function(obj3d){
        //  if (obj3d.id == 16) {
        //    targetObj = obj3d;
        //  };
        // })

        self.threeDisp.addSubScene(targetObj);
        self.threeDisp.fitTheScreen();
        self.threeDisp.readCommentsFromFile(callback);
        _MDLoadMaskView["default"].remove();

        // if (callback) {
        //  callback();
        // };
        // self.parseGeo(collada.dae.geometries);
      },
      // Function called when download progresses
      function (xhr) {
        if (tempPercent > 0.90 && tempPercent < 0.99) {
          tempPercent += 0.001;
        } else if (tempPercent >= 0.99) {
          tempPercent = 0.99;
        } else {
          tempPercent += 0.01;
        }
        console.log(xhr.loaded / xhr.total * 100 + '% loaded');
        if (isNaN(xhr.loaded) || isNaN(xhr.total) || xhr.total == null) {} else {
          tempPercent = xhr.loaded / xhr.total;
        }
        _MDLoadMaskView["default"].displayPercent(tempPercent);
      },
      // failed callback 
      function failed() {
        _MDLoadMaskView["default"].remove();
        var message = BabelStr.str(5175);
        _MDAlertView["default"].showStandardPrompt({
          message: '<p>' + message + '</p>',
          width: 400,
          okFun: function okFun() {}
        });
      });
    },
    refreshSize: function refreshSize() {
      this.threeDisp.refreshSize();
    },
    closeCommentPanel: function closeCommentPanel() {},
    refreshObjsInEditor: function refreshObjsInEditor() {},
    focusComment: function focusComment(comment) {
      this.threeDisp.focusComment(comment);
    },
    enableMouseWheel: function enableMouseWheel(enable) {
      this.threeDisp.enableMouseWheel(enable);
      if (enable) {
        console.log('--- enabled');
      }
      ;
    },
    toolChanged: function toolChanged(toolIndex) {
      _clearTouchlayerClass.call(this);
      switch (toolIndex) {
        case 0:
          this.threeDisp.setOperationType(OPERATION_3D_TYPE.comment);
          this.$touchLayer.addClass('cursor-normal');
          break;
        case 1:
          this.threeDisp.setOperationType(OPERATION_3D_TYPE.disassemble);
          this.$touchLayer.addClass('cursor-hide');
          break;
        case 2:
          this.threeDisp.setOperationType(OPERATION_3D_TYPE.measure);
          this.$touchLayer.addClass('cursor-ruler');
          break;
      }
    },
    restoreHomeView: function restoreHomeView() {
      this.threeDisp.fitTheScreen();
    },
    removeFromSuperView: function removeFromSuperView() {
      if (this.loader) {
        this.loader.abort();
      }
      ;
      this.removed = true;
      this.$editorLayer.remove();
      this.$touchLayer.remove();
      this.threeDisp.release();
      _MDColladaDisplayer["default"].setInstance(null);
      this.toolbar3d.removeFromSuperView();
      this.toolbar3d = null;
      this.visiblePanel.removeFromSuperView();
    },
    object3DHided: function object3DHided(obj3DId, imgdata) {
      this.visiblePanel.obj3DHided(obj3DId, imgdata);
    },
    allObjShowed: function allObjShowed() {
      this.visiblePanel.allObjShowed();
    },
    showCommentLayer: function showCommentLayer() {},
    hideCommentLayer: function hideCommentLayer() {},
    getClassName: function getClassName() {
      return "MD3DEditor";
    },
    getScale: function getScale() {
      return 1;
    },
    getCenterRatioPosition: function getCenterRatioPosition() {
      return {
        x: 0,
        y: 0
      };
    }
  };
}();
var _default = exports["default"] = MD3DEditor;

},{"11":11,"1184":1184,"13":13,"14":14,"1454":1454,"32":32,"49":49}],14:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDBasicToolbar = _interopRequireDefault(require(804));
var _MMBasicData = _interopRequireDefault(require(811));
// MD3DToolbar.js
// jiang
// 2016-10-23

var MD3DToolbar = _MDBasicToolbar["default"].extend({
  el: '<div id="Toolbar3D" class="left-tool-panel Toolbar3D-container tool-bar"></div>',
  toolTmp: function toolTmp() {
    return '<li class="b-3d-normal">' + '<button class="button-icon p-tool-normal  button-li  f-pointer"></button>' + '</li>' + '<li class="b-3d-disassemble">' + '<button class="button-icon p-tool-disassem  button-li  f-pointer"></button>' + '</li>' + '<li class="b-3d-measure">' + '<button class="button-icon p-tool-measure  button-li  f-pointer"></button>' + '</li>' + '<li class="b-3d-home">' + '<button class="button-icon p-tool-home  button-li  f-pointer"></button>' + '</li>';
  },
  initProps: function initProps() {
    var superP = _MDBasicToolbar["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      editor: null
    });
  },
  events: function events() {
    var superE = _MDBasicToolbar["default"].prototype.events.call(this);
    return _.extend(superE, {
      "click .b-3d-normal": this._normalToolClicked,
      "click .b-3d-disassemble": this._disassembleToolClicked,
      "click .b-3d-measure": this._measureToolClicked,
      "click .b-3d-home": this._3dHomeClicked
    });
  },
  initialize: function initialize(opt) {
    _MDBasicToolbar["default"].prototype.initialize.call(this, opt);
    this.maitainShow = false;
    this.initWithDefaultTool();
  },
  initWithDefaultTool: function initWithDefaultTool() {
    this._normalToolClicked();
  },
  _normalToolClicked: function _normalToolClicked(e) {
    this.setToolSelected(0);
    this.editor.toolChanged(0);
  },
  _disassembleToolClicked: function _disassembleToolClicked(e) {
    this.setToolSelected(1);
    this.editor.toolChanged(1);
  },
  _measureToolClicked: function _measureToolClicked(e) {
    this.setToolSelected(2);
    this.editor.toolChanged(2);
  },
  removeFromSuperView: function removeFromSuperView() {
    this.$el.remove();
    this.editor = null;
  },
  _3dHomeClicked: function _3dHomeClicked(e) {
    this.editor.restoreHomeView();
  }
}, {
  className: 'MD3DToolbar'
});
var _default = exports["default"] = MD3DToolbar;

},{"1184":1184,"1454":1454,"804":804,"811":811}],804:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1466);
var _MMViewBase = _interopRequireDefault(require(22));
var _MMBasicData = _interopRequireDefault(require(811));
// MDBasicToolbar.js
// jiang
// 2017-10-5

var MDBasicToolbar = _MMViewBase["default"].extend({
  el: '<div class="left-tool-panel tool-panel-pallet tool-bar"></div>',
  toolTmp: function toolTmp() {
    return '<li class="b-样例">' + '<button class="button-icon 样例  button-li  f-pointer" tool-name="样例" data-tooltip="样例"></button>' + '</li>';
  },
  tmpl: function tmpl() {
    return '<div class="handle"><div></div></div>' + '<div class="p-toolbar-root">' + '<ul>' + this.toolTmp() + '</ul>' + '</div>';
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      editor: null
    });
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      "click .button-li": this._toolClicked,
      // "click .b-comment-normal": this._normalToolClicked,
      // "click .b-rect-comment": this._rectCommentClicked,
      // "click .b-ellipse-comment": this._ellipseCommentClicked,
      // "click .b-arrow-comment": this._arrowCommentClicked
      "mousedown .handle": this._moveDown,
      "mousemove .p-toolbar-root": this._moveMove
    });
  },
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    var z_startIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
    $(this.el).css('z-index', z_startIndex);
    this.maitainShow = false;
    this.initWithDefaultTool();
    Dispatcher.on(MDEvents.beforeChangeToNextFile, this._beforeFileChanged, this);
    Dispatcher.on(MDEvents.afterChangeToNextFile, this._afterFileChanged, this);
    Dispatcher.on(MDEvents.COMMENT_CLICKED, this._commentClicked, this);
  },
  setEditorViewCtl: function setEditorViewCtl(editor) {
    this.editor = editor;
  },
  _beforeFileChanged: function _beforeFileChanged(e) {},
  _afterFileChanged: function _afterFileChanged(e) {},
  _commentClicked: function _commentClicked(e) {
    this.clearSelect();
  },
  // tool selected
  _toolClicked: function _toolClicked(e) {
    var curTarget = e.currentTarget;
    var index = $(e.currentTarget).parent().index();
    if (this.disableToggle) {
      this.setToolSelected(index);
      return true;
    } else {
      if (this.$el.find('li').eq(index).hasClass('li-focus')) {
        this.$el.find('li').eq(index).removeClass('li-focus');
        this.removeChecked();
        return false;
      } else {
        this.setToolSelected(index);
        return true;
      }
    }
  },
  removeChecked: function removeChecked() {},
  initWithDefaultTool: function initWithDefaultTool() {
    // this._normalToolClicked();
  },
  setToolSelected: function setToolSelected(index) {
    var data = this.$el.find('li').eq(index).data();
    if (data) {
      var group = this.$el.find('li').eq(index).data().group;
      for (var i = 0; i < this.$el.find('li').length; i++) {
        var $e = this.$el.find('li').eq(i);
        if ($e.data() && $e.data().group == group) {
          $e.removeClass('li-focus');
        }
      }
    } else {
      this.$el.find('li').removeClass('li-focus');
    }
    this.$el.find('li').eq(index).addClass('li-focus');
  },
  clearSelect: function clearSelect() {
    this.setToolSelected();
  },
  _normalToolClicked: function _normalToolClicked(e) {
    this.setToolSelected(0);
    // this.editor.toolChanged(0);
  },
  _moveDown: function _moveDown(e) {
    var preX = e.clientX;
    var preY = e.clientY;
    var inFrame = $('#html-render').contents();
    if (inFrame.length == 0) {
      inFrame = null;
    }
    ;
    var self = this;
    $('.p-editor-root').on('mousemove.leftpanel', function (e) {
      var top = $(self.editorViewCtl.containerDiv).offset().top + 10;
      var curX = e.clientX;
      var curY = e.clientY;
      curY = curY < top ? top : curY;
      var dX = curX - preX;
      var dY = curY - preY;
      var x = parseInt(self.$el.css('left')) + dX;
      var y = parseInt(self.$el.css('top')) + dY;
      self.$el.css('left', x + 'px');
      self.$el.css('top', y + 'px');
      preX = curX;
      preY = curY;
    });
    $('.p-editor-root').on('mouseup.leftpanel', function (e) {
      $('.p-editor-root').off('mousemove.leftpanel');
      $('.p-editor-root').off('mouseup.leftpanel');
    });
  },
  _moveMove: function _moveMove(e) {
    e.stopPropagation();
    Dispatcher.trigger(MDEvents.Mouse_over_toolbar, this);
  }
}, {
  className: 'MDBasicToolbar'
});
var _default = exports["default"] = MDBasicToolbar;

},{"1184":1184,"1417":1417,"1454":1454,"1463":1463,"1466":1466,"22":22,"811":811}],13:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
var _MMBasicData = _interopRequireDefault(require(811));
var _MMViewBase = _interopRequireDefault(require(22));
// MD3DObjectVisibleListPanel.js
// jiang
// 2016-10-24
//

// MD3DToolbar.js
// jiang
// 2016-10-23

var MD3DObjectVisibleListPanel = _MMViewBase["default"].extend({
  el: '<div id="ToolbarVisibleList" class="Toolbar3D-visible-contaner"></div>',
  tmpl: '<button class="b-3d-title"><%=BabelStr.str(5112)%></button>' + '<ul class="p-3d-visiblelist">' + '</ul>',
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      threeDDisp: null
    });
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      "click .b-3d-objectHided": this._showObj3DClicked,
      "click .b-3d-title": this.showAllHided3dObjs,
      "mouseenter": this._mouseEnter
      // "mouseleave": this._mouseLeave
    });
  },
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    var z_startIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
    $(this.el).css('z-index', z_startIndex);
    this.$el.hide();
  },
  _mouseEnter: function _mouseEnter() {
    _MDPcMobileEditorCommonFun["default"].getMainEditor().enableMouseWheel(false);
  },
  _mouseLeave: function _mouseLeave() {
    _MDPcMobileEditorCommonFun["default"].getMainEditor().checkToEnablePrivateMouseWheel();
  },
  _showObj3DClicked: function _showObj3DClicked(e) {
    var objId = $(e.currentTarget).attr('object3d');
    this.threeDDisp.showObj3D(objId);
    var self = this;
    $(e.currentTarget).animate({
      'margin-left': "-100"
    }, 500, function () {
      $(e.currentTarget).remove();
      self._checkIfEmpty();
    });
  },
  showAllHided3dObjs: function showAllHided3dObjs() {
    this.threeDDisp.showAllHided3dObjs();
  },
  _checkIfEmpty: function _checkIfEmpty() {
    var self = this;
    if (self.$el.find('li').length == 0) {
      self._mouseLeave();
      self.$el.hide();
    }
    ;
  },
  obj3DHided: function obj3DHided(id, imgdata) {
    var $divItem = $('<li class="b-3d-objectHided" ' + '>' + '<img></img>' + '<button class="button-icon p-tool-normal  button-li  f-pointer"></button>' + '</li>');
    $divItem.attr('object3d', id);
    $divItem.find('img').attr('src', imgdata);
    this.$el.find('.p-3d-visiblelist').prepend($divItem);
    this.$el.show();
  },
  allObjShowed: function allObjShowed() {
    var self = this;
    var $allItems = this.$('li');
    $allItems.animate({
      'margin-left': "-100"
    }, 500, function () {
      $allItems.remove();
      self._checkIfEmpty();
    });
  },
  removeFromSuperView: function removeFromSuperView() {
    this.$el.remove();
    this.threeDDisp = null;
  }
}, {
  className: 'MD3DObjectVisibleListPanel'
});
var _default = exports["default"] = MD3DObjectVisibleListPanel;

},{"1184":1184,"1417":1417,"1454":1454,"1463":1463,"22":22,"807":807,"811":811}],11:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1451);
require(1438);
require(1432);
require(1423);
require(1411);
require(1511);
require(1505);
require(1506);
require(1507);
require(1508);
require(1510);
require(1509);
require(1512);
require(1513);
require(1514);
require(1516);
require(1517);
require(1518);
require(1519);
require(1521);
require(1520);
require(1522);
require(1523);
require(1524);
require(1525);
require(1526);
require(1527);
require(1528);
require(1529);
require(1497);
var _MD3DTool = _interopRequireDefault(require(4));
var _MD3DComment = _interopRequireDefault(require(6));
var _MD3DCommentPosCalculator = _interopRequireDefault(require(1));
var _MDNew3DCommentInputView = _interopRequireDefault(require(15));
var _MD3DCommentsController = _interopRequireDefault(require(2));
var _MDBasic3DRender = _interopRequireDefault(require(10));
var _MD3DImageCreator = _interopRequireDefault(require(3));
// MDColladaDisplayer.js
// 2016-06-25

/**
 *  控制显示 3D 模型
 *   1. 构建鼠标控制器
 *   2. 控制显示坐标轴
 *   3. 控制显示点光源的当前位置
 *   4. 批注控制器
 *   5. 隐藏和显示对象
 */

var OPERATION_3D_TYPE = {
  comment: "comment",
  disassemble: "disassemble",
  measure: "measure"
};
window.OPERATION_3D_TYPE = OPERATION_3D_TYPE;
function MDColladaDisplayer(divId, touchId, parentEditor) {
  this.editorViewCtl = parentEditor.editorViewCtl;
  _MDBasic3DRender["default"].call(this); // 继承自 MDBasic3DRender

  // this.renderer = null;
  // this.camera = null;
  // this.scene = null;

  this.parentEditor = parentEditor;
  this.$container = $(parentEditor.parentDiv).find('#' + divId);
  this.$touchLayer = $(parentEditor.parentDiv).find('#' + touchId);
  this.objs3dHided = [];
  this.init();
  this.map3dId_ImgData = {}; // 使用 object3d id 映射到 image data
}
MDColladaDisplayer.getInstance = function () {
  return MDColladaDisplayer.instance;
};
MDColladaDisplayer.setInstance = function (instance) {
  MDColladaDisplayer.instance = instance;
};
Object.assign(MDColladaDisplayer.prototype, _MDBasic3DRender["default"].prototype, function () {
  //  private function
  // *********************************************************************************************

  function _getImgDataByObj3DAsync(obj3D, callback) {
    var id = obj3D.id;
    var imgData = this.map3dId_ImgData[id];
    if (!imgData) {
      var faces = [];
      var matrix = obj3D.matrixWorld.clone();
      faces = obj3D.geometry.faces;
      var geo = new THREE.Geometry();
      for (var i = 0; i < faces.length; i++) {
        var face = faces[i].clone();
        geo.vertices.push(obj3D.geometry.vertices[face.a]);
        geo.vertices.push(obj3D.geometry.vertices[face.b]);
        geo.vertices.push(obj3D.geometry.vertices[face.c]);
        face.a = 3 * i;
        face.b = 3 * i + 1;
        face.c = 3 * i + 2;
        face.materialIndex = 1;
        geo.faces.push(face);
      }
      ;

      // var material = new THREE.LineBasicMaterial({
      //   color: 0x00ff00,
      //   opacity: 1,
      //   lineWidth: 5
      // });

      // this.interGeo = new THREE.Line(geo, material);

      var material = new THREE.MeshLambertMaterial({
        // color: 0xaaffaa,
        'color': 0x00ffff,
        'wireframe': true,
        'wireframeLinewidth': 1,
        'vertexColors': THREE.FaceColors
      });
      var tempGeo = new THREE.Mesh(geo, material);
      tempGeo.applyMatrix(matrix);
      var self = this;
      this.imgMaker.renderAsync(tempGeo, function (img) {
        self.map3dId_ImgData[id] = img;
        callback(img);
      });
    } else {
      callback(imgData);
    }
  }
  ;
  function _createAxis(verticesArr, color) {
    var geometry = new THREE.BufferGeometry();

    // itemSize = 3 because there are 3 values (x, y, z) per vertex
    geometry.addAttribute('position', new THREE.BufferAttribute(verticesArr, 3));
    // material
    var material = new THREE.LineBasicMaterial({
      "color": color,
      "linewidth": 2
    });

    // line
    var line = new THREE.Line(geometry, material);
    return line;
  }
  ;
  function _initTrackballControls() {
    this.trackballController = new THREE.TrackballControls(this.camera);
    this.trackballController.rotateSpeed = 2.0;
    this.trackballController.zoomSpeed = 1.0;
    this.trackballController.panSpeed = 1.0;
    this.clock = new THREE.Clock();
    this.scene.trackballCtl = this.trackballController;
    var self = this;
    this.trackballController.addEventListener('change', function () {});
  }
  ; // initTrackballControls

  function _initEvents() {
    var self = this;

    //------------------------------------------------------ mouse wheel

    this.$touchLayer.bind("mousewheel", function (event) {
      self.refreshDiv();
    });

    //------------------------------------------------------ mouse click

    this.$touchLayer.bind("click", function (event) {});

    //------------------------------------------------------ mouse drag

    this.$touchLayer.bind("mousedown", function (event) {
      // console.log('mouse down!');
      if (event.target == self.$touchLayer[0]) {
        self.down = true;
        self.preMouse = {
          x: event.offsetX,
          y: event.offsetY
        };
        self.translate = {
          x: 0,
          y: 0
        };
        self.hasPanelShow = self.removeAllPanels();
      }
      ;
      if (app.canDispInNormalBrowser()) {
        MDPCEditorViewController.setCurrentInstance(self.editorViewCtl);
      } else {}
    });
    this.$touchLayer.bind("mousemove", function (event) {
      if (event.target == self.$touchLayer[0]) {
        self.checkToEnableMouseWheel();
        var curMouse = {
          x: event.offsetX,
          y: event.offsetY
        };
        if (self.down) {
          console.log('draging');
          self.translate.x += curMouse.x - self.preMouse.x;
          self.translate.y += curMouse.y - self.preMouse.y;

          // self.refreshDiv();
        }
        ;
        self.currentTool.mouseMove(curMouse);
      }
      ;
    });
    this.$touchLayer.bind("mouseup", function (event) {
      if (event.target == self.$touchLayer[0]) {
        // console.log('mouse up!');
        if (Math.abs(self.translate.x) + Math.abs(self.translate.y) < 5) {
          var delta = 0;
          var dvPos = {
            x: event.offsetX,
            y: event.offsetY
          };
          if (!self.hasPanelShow) {
            setBabelTimeout(function () {
              self.currentTool.mouseClick(dvPos);

              // switch(self.operationType){

              //   case OPERATION_3D_TYPE.comment:

              //     _create3DCommentAtScreen.call(self, dvPos);
              //     self.refreshDiv();
              //     break;

              //   case OPERATION_3D_TYPE.disassemble:

              //     _disassembleToolClicked.call(self, dvPos);
              //    break;

              //   case OPERATION_3D_TYPE.measure:

              //     self.currentTool.mouseClick(dvPos);
              // }
            }, 1);
          }
          ;
        }
        ;
        self.hasPanelShow = false;
        self.down = false;
      }
      ;
    });
    $('body').bind("mouseup", function (event) {
      // console.log('mouse up!');
      self.down = false;
    });
    Dispatcher.on(MDEvents.Enable3DWheel, function () {
      self.checkToEnableMouseWheel();
    }, self);
    Dispatcher.on(MDEvents.Disable3DWheel, function () {
      self.enableMouseWheel(false);
    }, self);
  }
  ;

  // function _disassembleToolClicked(dvPos) {

  //   var self = this;
  //   var hasObjHided = _hideObjectAtPos.call(self, dvPos);

  //   // if (!hasObjHided) {
  //   //   _showLastHided3dObj.call(self);
  //   // };
  // };

  function _showLastHided3dObj() {
    var self = this;
    if (this.objs3dHided.length) {
      var i = this.objs3dHided.length - 1;
      var obj3d = this.objs3dHided[i];
      obj3d.visible = true;
      this.commentsCtl.showCommentOnObj3dId(obj3d.id);
      this.objs3dHided.splice(i, 1);
      obj3d.traverse(function (node) {
        if (node instanceof THREE.Mesh) {
          self.commentsCtl.showCommentOnObj3dId(node.id);
        }
      });
    }
    ;
  }
  ;
  function _judgeFaceByIndex(vertexIndexes, faces, face, normal) {
    if (face.normal.equals(normal) || Math.abs(face.normal.angleTo(normal)) < 0.1) {
      var includeV = [];
      var noInclueV = [];
      var curIndexes = [face.a, face.b, face.c];
      for (var j = 0; j < curIndexes.length; j++) {
        var index = curIndexes[j];
        for (var k = 0; k < vertexIndexes.length; k++) {
          if (index == vertexIndexes[k]) {
            break;
          }
        }
        ;
        if (k < vertexIndexes.length) {
          includeV.push(index);
        } else {
          noInclueV.push(index);
        }
      }
      ;
      if (includeV.length == 2) {
        vertexIndexes.push(noInclueV[0]);
        faces.push(face);
      }
      ;
    }
    ;
  }
  ; // _judgeFaceByIndex = function(vertexIndexes, faces, face, normal)

  function _expandFacesByIndex(interInfo) {
    var faceIndex = interInfo.faceIndex;
    var geo = interInfo.object.geometry;
    var vertexIndexes = [interInfo.face.a, interInfo.face.b, interInfo.face.c];
    var faces = [interInfo.face];
    var normal = interInfo.face.normal;
    for (var i = faceIndex + 1; i < geo.faces.length; i++) {
      var face = geo.faces[i];
      _judgeFaceByIndex.call(this, vertexIndexes, faces, face, normal);
    }
    ;
    for (var i = faceIndex - 1; i >= 0; i--) {
      var face = geo.faces[i];
      _judgeFaceByIndex.call(this, vertexIndexes, faces, face, normal);
    }
    ;
    return faces;
  }
  ; // _expandFacesByIndex = function(interInfo)

  function _judgeFaceByPoint(vertices, faces, face, mat) {
    var includeV = [];
    var noInclueV = [];
    for (var i = 0; i < faces.length; i++) {
      var oldFace = faces[i];
      var oldIndexes = [oldFace.a, oldFace.b, oldFace.c];
      var equalNum = 0;
      var curIndexes = [face.a, face.b, face.c];
      for (var k = 0; k < curIndexes.length; k++) {
        var index = curIndexes[k];
        var p = vertices[index].clone().multiplyScalar(10).round();
        var vNormal = face.vertexNormals[k];
        for (var j = 0; j < oldIndexes.length; j++) {
          if (j > 1 && equalNum == 0) {
            break;
          }
          ;
          var index2 = oldIndexes[j];
          var p2 = vertices[index2].clone().multiplyScalar(10).round();
          var vNormal2 = oldFace.vertexNormals[j];
          if (p.equals(p2)) {
            if (vNormal.equals(vNormal2) || Math.abs(vNormal.angleTo(vNormal2)) < 0.1) {
              equalNum++;
            }
            ;
          }
        }
        ;
      }
      ;
      if (equalNum >= 2) {
        faces.push(face);
        break;
      }
    }
    ;
  }
  ; // _judgeFaceByPoint = function(vertices, faces, face, mat)

  function _expandFacesByPoint(interInfo) {
    var faceIndex = interInfo.faceIndex;
    var geo = interInfo.object.geometry;
    var matrix = interInfo.object.matrixWorld.clone();
    var v;
    var faces = [interInfo.face];
    var vertices = [];
    for (var i = 0; i < geo.vertices.length; i++) {
      v = geo.vertices[i].clone().applyMatrix4(matrix);
      vertices.push(v);
    }
    ;
    for (var i = faceIndex + 1; i < geo.faces.length; i++) {
      var face = geo.faces[i];
      _judgeFaceByPoint.call(this, vertices, faces, face, matrix);
    }
    ;
    for (var i = faceIndex - 1; i >= 0; i--) {
      var face = geo.faces[i];
      _judgeFaceByPoint.call(this, vertices, faces, face, matrix);
    }
    ;
    return faces;
  }
  ; // _expandFacesByPoint = function(interInfo)

  // 创建地面
  function _createGroundPlane() {
    var center = this.boundingSphere.center.clone();
    var redius = this.boundingSphere.radius;
    var z = center.z - redius;
    var normal = new THREE.Vector3(0, 0, 1);
    var geo = new THREE.Plane(normal, z);
    var geo = new THREE.PlaneGeometry(100000, 100000);
    geo.translate(0, 0, z);

    // var material = new THREE.LineBasicMaterial({
    //   color: 0x00ff00,
    //   opacity: 1,
    //   lineWidth: 5
    // });

    // this.interGeo = new THREE.Line(geo, material);

    var material = new THREE.MeshLambertMaterial({
      // color: 0xaaffaa,
      color: 0xFFFDE7,
      wireframe: false,
      wireframeLinewidth: 4,
      vertexColors: THREE.FaceColors
    });
    if (this.groundPlane) {
      this.scene.remove(this.groundPlane);
    }
    ;
    this.groundPlane = new THREE.Mesh(geo, material);

    // this.interGeo.applyMatrix(this.interInfo.object.matrixWorld.clone());
    // this.interGeo.matrix = this.interInfo.object.matrix.clone();
    // this.interGeo.modelViewMatrix = this.interInfo.object.modelViewMatrix.clone();
    // this.interGeo.normalMatrix = this.interInfo.object.normalMatrix.clone();

    this.scene.add(this.groundPlane);
  }
  ;

  //  public function
  // ****************************************************************************************************

  return {
    // 注意：此函数内不能再添加创建任何 THREE JS 对象！！！，否则会影响旧文档读出的 THREE JS 对象的序号
    // 如果需要添加辅助对象或者灯光等等，请在函数 createOtherAssistObjs 中添加
    //
    init: function init() {
      this.initStats();
      this.renderer = null;
      this.camera = null;
      this.scene = null;
      var width = this.$container.width();
      var height = this.$container.height();
      _MDBasic3DRender["default"].prototype.initWithWinSize.call(this, width, height);
      if (this.renderer == null) {
        throw 'not support OPenGL';
        return;
      }
      ;
      _initEvents.call(this);
      this.$container.append($(this.renderer.domElement));

      // trackball controls
      _initTrackballControls.call(this);
      this.animateRender();
      this.paused = false;
      this.posCalculator = new _MD3DCommentPosCalculator["default"](this.$container.width(), this.$container.height(), this.camera);
      this.commentsCtl = new _MD3DCommentsController["default"](this.$touchLayer, this.scene, this.camera, this);
      this.setOperationType(OPERATION_3D_TYPE.comment);
    },
    // init

    addSubScene: function addSubScene(scene) {
      _MDBasic3DRender["default"].prototype.addSubScene.call(this, scene);
      this.showAxis(true);
    },
    // addSubScene

    // 创建辅助 THREE JS 对象
    createOtherAssistObject3D: function createOtherAssistObject3D() {
      _MDBasic3DRender["default"].prototype.createOtherAssistObject3D.call(this);

      // create a cube
      var cubeGeometry = new THREE.CubeGeometry(2, 2, 2);
      var cubeMaterial = new THREE.MeshLambertMaterial({
        'color': 0xff0000,
        'wireframe': false,
        'vertexColors': THREE.FaceColors
      });
      var cube = new THREE.Mesh(cubeGeometry, cubeMaterial);
      var zAxis = new THREE.Vector3(0, 0, 1);
      cube.translateOnAxis(zAxis, 10);
      cube.castShadow = false;

      // position the cube
      cube.position.x = 0;
      cube.position.y = 0;
      cube.position.z = 0;

      // add the cube to the scene
      // this.scene.add(cube);

      this.cube = cube;
      this.imgMaker = new _MD3DImageCreator["default"](40, 40);

      // _createGroundPlane.call(this);   // 创建地面
    },
    showAxis: function showAxis(show) {
      if (show == undefined) {
        show = true;
      }
      ;
      var axisLen = 4;
      if (!this.xAxis) {
        var xAxisVertics = new Float32Array([0.0, 0.0, 0.0, axisLen, 0.0, 0.0]);
        var yAxisVertics = new Float32Array([0.0, 0.0, 0.0, 0.0, axisLen, 0.0]);
        var zAxisVertics = new Float32Array([0.0, 0.0, 0.0, 0.0, 0.0, axisLen]);
        this.xAxis = _createAxis.call(this, xAxisVertics, 0xff0000);
        this.yAxis = _createAxis.call(this, yAxisVertics, 0x00ff00);
        this.zAxis = _createAxis.call(this, zAxisVertics, 0x0000ff);
      }
      ;
      if (show) {
        this.scene.remove(this.xAxis);
        this.scene.remove(this.yAxis);
        this.scene.remove(this.zAxis);
        this.scene.add(this.xAxis);
        this.scene.add(this.yAxis);
        this.scene.add(this.zAxis);
      } else {
        this.scene.remove(this.xAxis);
        this.scene.remove(this.yAxis);
        this.scene.remove(this.zAxis);
      }
    },
    // showAxis

    showLightPos: function showLightPos(show) {
      if (show == undefined) {
        show = true;
      }
      ;
      if (!this.spotLightMark) {
        var geometry = new THREE.SphereGeometry(5, 32, 32);
        var material = new THREE.MeshBasicMaterial({
          color: 0xffff00
        });
        var sphere = new THREE.Mesh(geometry, material);
        this.spotLightMark = sphere;
        this.spotLightMark.debug = true;
      }
      ;
      var spotLightPos = this.directionalLight.position.clone();
      var revers = this.spotLightMark.matrix.clone();
      revers.getInverse(revers);
      var m = new THREE.Matrix4();
      m.makeTranslation(spotLightPos.x, spotLightPos.y, spotLightPos.z);
      m.premultiply(revers);
      // m.makeTranslation(10, 0, 0);
      this.spotLightMark.applyMatrix(m);
      if (show) {
        this.scene.remove(this.spotLightMark);
        this.scene.add(this.spotLightMark);
      } else {
        this.scene.remove(this.spotLightMark);
      }
    },
    fitTheScreen: function fitTheScreen() {
      if (!this.boundingSphere) {
        return;
      }
      ;
      this.camera.up.set(0, 0, 1);
      var radius = this.boundingSphere.radius;
      var center = this.boundingSphere.center.clone();
      _MDBasic3DRender["default"].prototype.fitTheScreen.call(this);
      this.scene.trackballCtl.target = center;
    },
    // fitTheScreen

    getCameraFitPosition: function getCameraFitPosition(target, curCameraPos) {
      // 求与 bongding box 6 个面的交点
      var delta = this.camera.getWorldDirection().multiplyScalar(-1);
      var intersects = [];

      // 与 x 的两个面的交点
      if (Math.abs(delta.x) > 0.01) {
        var xValues = [this.boundingSphere.min.x, this.boundingSphere.max.x];
        for (var i = xValues.length - 1; i >= 0; i--) {
          var x = xValues[i];
          var interX = new THREE.Vector3();
          var ratio = (x - curCameraPos.x) / delta.x;
          interX.x = x;
          interX.y = ratio * delta.y + curCameraPos.y;
          interX.z = ratio * delta.z + curCameraPos.z;
          intersects.push(interX);
        }
        ;
      }
      ;

      // 与 y 的两个面的交点
      if (Math.abs(delta.y) > 0.01) {
        var yValues = [this.boundingSphere.min.y, this.boundingSphere.max.y];
        for (var i = yValues.length - 1; i >= 0; i--) {
          var y = yValues[i];
          var interY = new THREE.Vector3();
          var ratio = (y - curCameraPos.y) / delta.y;
          interY.x = ratio * delta.x + curCameraPos.x;
          interY.y = y;
          interY.z = ratio * delta.z + curCameraPos.z;
          intersects.push(interY);
        }
        ;
      }
      ;

      // 与 z 的两个面的交点
      if (Math.abs(delta.y) > 0.01) {
        var zValues = [this.boundingSphere.min.z, this.boundingSphere.max.z];
        for (var i = zValues.length - 1; i >= 0; i--) {
          var z = zValues[i];
          var interZ = new THREE.Vector3();
          var ratio = (z - curCameraPos.z) / delta.z;
          interZ.x = ratio * delta.x + curCameraPos.x;
          interZ.y = ratio * delta.y + curCameraPos.y;
          interZ.z = z;
          intersects.push(interZ);
        }
        ;
      }
      ;
      var realInter = [];
      for (var i = 0; i < intersects.length; i++) {
        if (intersects[i].x >= this.boundingSphere.min.x && intersects[i].x <= this.boundingSphere.max.x && intersects[i].y >= this.boundingSphere.min.y && intersects[i].y <= this.boundingSphere.max.y && intersects[i].z >= this.boundingSphere.min.z && intersects[i].z <= this.boundingSphere.max.z) {
          realInter.push(intersects[i]);
        }
      }
      ;
      console.log('intersect points count:', realInter.length);
      var wantIndex = -1;
      for (var i = 0; i < realInter.length; i++) {
        var pt = realInter[i];
        if (pt.clone().distanceToSquared(curCameraPos) < pt.clone().distanceToSquared(target)) {
          wantIndex = i;
          break;
        }
        ;
      }
      ;
      if (wantIndex >= 0) {
        var interPt = realInter[wantIndex];
        var boxRadius = this.boundingSphere.min.distanceTo(this.boundingSphere.max) / 2;
        var dis = boxRadius / Math.tan(this.camera.fov * Math.PI / 360) + boxRadius;
        var fitCameraPos = interPt.add(curCameraPos.clone().sub(target).normalize().multiplyScalar(dis));
        return fitCameraPos;
      } else {
        return curCameraPos.clone();
      }
    },
    // getCameraFitPosition

    lookAt: function lookAt(position) {
      this.camera.lookAt(position);
      this.renderer.render(this.scene, this.camera);
    },
    // lookAt

    initStats: function initStats() {
      var stats = new Stats();
      // stats.setMode(0);
      // stats.domElement.style.position = 'absolute';
      // stats.domElement.style.left = '0px';
      // stats.domElement.style.top = '0px';
      // stats.domElement.style.width = '300px';
      // $('#Stats-output').append(stats.domElement);

      this.stats = stats;
      return stats;
    },
    // initStats

    animateRender: function animateRender() {
      if (!this.paused) {
        this.stats.update();
        TWEEN.update();

        // this.cube.rotation.x += 0.02;

        var delta = this.clock.getDelta();
        this.trackballController.update(delta);
        THREE.AnimationHandler.update(delta);
        var self = this;
        requestAnimationFrame(function () {
          self.animateRender();
        });
      }
      ;

      // _adjustSpotLight.call(this);
      this.updateWithCurCamera();
      this.renderer.render(this.scene, this.camera);
      this.refreshDiv();
      if (this.cameraPathCtl) {
        this.cameraPathCtl.update(delta);
      }
      ;
    },
    // animateRender

    refreshDiv: function refreshDiv() {
      if (this.commentsCtl) {
        this.commentsCtl.refreshDivs();
      }
      ;
      if (this.currentTool) {
        this.currentTool.refreshDisp();
      }
      ;
    },
    // refreshDiv

    logicToDevice: function logicToDevice(pos) {
      var renderer = this.renderer;
      var widthHalf = 0.5 * renderer.context.canvas.width;
      var heightHalf = 0.5 * renderer.context.canvas.height;
      var camera = this.camera;
      var vector = pos.clone();
      vector.project(camera);
      vector.x = vector.x * widthHalf + widthHalf;
      vector.y = -(vector.y * heightHalf) + heightHalf;
      return {
        x: vector.x,
        y: vector.y
      };
    },
    // logicToDevice

    deviceToLogic: function deviceToLogic(dvPos) {
      var vector = new THREE.Vector3();
      vector.set(dvPos.x / this.$touchLayer.width() * 2 - 1, -(dvPos.y / this.$touchLayer.height()) * 2 + 1, 0.5);
      vector.unproject(this.camera);
      // var dir = vector.sub(this.camera.position).normalize();
      // var distance = - this.camera.position.z / dir.z;
      // var position = this.camera.position.clone().add(dir.multiplyScalar(distance));
      // console.log("x: " + position.x + " y: " + position.y);
      var position = vector;
      return new THREE.Vector3(position.x, position.y, position.z);
    },
    // deviceToLogic = function(dvPos)

    pause: function pause() {
      this.paused = !this.paused;
      this.animateRender();
    },
    // pause = function()

    removeAllPanels: function removeAllPanels() {
      var hasPanelShow = false;
      if (this.currentTool) {
        this.currentTool.clearPanel();
      }
      ;
      return this.commentsCtl.removeCommentPanel() || hasPanelShow;
    },
    // removeAllPanels = function()

    release: function release() {
      this.$touchLayer.off();
      this.paused = true;
      this.parentEditor = null;
      this.trackballController.removeEventListener('change');
      this.trackballController.dispose();
      this.commentsCtl.clearMemory();
      if (this.currentTool) {
        this.currentTool.clear();
      }
      ;
      Dispatcher.off(MDEvents.Enable3DWheel);
      Dispatcher.off(MDEvents.Disable3DWheel);
    },
    // release = function()

    refreshSize: function refreshSize() {
      var winW = this.$container.width();
      var winH = this.$container.height();
      this.camera.aspect = winW / winH;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(winW, winH);
      this.posCalculator.updateWinSize(winW, winH);
      if (this.currentTool) {
        this.currentTool.refreshSize();
      }
      ;
    },
    // refreshSize = function()

    setCameraPathCtl: function setCameraPathCtl(pathControls) {
      this.cameraPathCtl = pathControls;
    },
    enableMouseWheel: function enableMouseWheel(enable) {
      if (!this.trackballController) {
        return;
      }
      ;
      this.trackballController.enabled = enable;
    },
    checkToEnableMouseWheel: function checkToEnableMouseWheel() {
      if (!this.trackballController.enabled) {
        this.enableMouseWheel(true);
      }
      ;
    },
    setCommentsFile: function setCommentsFile(commentsFile) {
      this.commentsFile = commentsFile;
      if (this.commentsCtl) {
        this.commentsCtl.setCommentsFile(commentsFile);
      }
      ;
    },
    focusComment: function focusComment(comment) {
      this.commentsCtl.focusComment(comment);
    },
    readCommentsFromFile: function readCommentsFromFile(callback) {
      if (this.commentsCtl) {
        this.commentsCtl.readCommentsFromFile(callback);
      } else {
        if (callback) {
          callback();
        }
        ;
      }
    },
    setOperationType: function setOperationType(type) {
      this.operationType = type;
      if (this.currentTool) {
        this.currentTool.clear();
        this.currentTool = null;
      }
      ;
      if (this.scene) {
        this.scene.remove(this.interGeo);
      } else {
        return;
      }
      switch (type) {
        case OPERATION_3D_TYPE.comment:
          this.enableMouseWheel(true);
          this.currentTool = new _MD3DTool["default"].MD3DCommentController(this.$touchLayer, this.scene, this.camera, this);
          break;
        case OPERATION_3D_TYPE.disassemble:
          this.enableMouseWheel(true);
          this.currentTool = new _MD3DTool["default"].MD3DDisassembleController(this.$touchLayer, this.scene, this.camera, this);
          // this.showAllHided3dObjs();
          break;
        case OPERATION_3D_TYPE.measure:
          this.enableMouseWheel(true);
          this.currentTool = new _MD3DTool["default"].MD3DMeasureController(this.$touchLayer, this.scene, this.camera, this);
          break;
      }
      this.currentTool.editorViewCtl = this.editorViewCtl;
    },
    showAllHided3dObjs: function showAllHided3dObjs() {
      for (var i = 0; i < this.objs3dHided.length; i++) {
        this.objs3dHided[i].visible = true;
        this.commentsCtl.showCommentOnObj3dId(this.objs3dHided[i].id);
      }
      ;
      this.objs3dHided = [];
      this.parentEditor.allObjShowed();
    },
    showObj3D: function showObj3D(objId) {
      for (var i = 0; i < this.objs3dHided.length; i++) {
        var obj = this.objs3dHided[i];
        if (obj.id == objId) {
          this.objs3dHided[i].visible = true;
          this.commentsCtl.showCommentOnObj3dId(this.objs3dHided[i].id);
          break;
        }
        ;
      }
      ;
      if (i < this.objs3dHided.length) {
        this.objs3dHided.splice(i, 1);
      }
      ;
    },
    getImgDataByObj3D: function getImgDataByObj3D(obj3D) {
      var id = obj3D.id;
      var imgData = this.map3dId_ImgData[id];
      if (!imgData) {
        var faces = [];
        var matrix = obj3D.matrixWorld.clone();
        faces = obj3D.geometry.faces;
        var geo = new THREE.Geometry();
        for (var i = 0; i < faces.length; i++) {
          var face = faces[i].clone();
          geo.vertices.push(obj3D.geometry.vertices[face.a]);
          geo.vertices.push(obj3D.geometry.vertices[face.b]);
          geo.vertices.push(obj3D.geometry.vertices[face.c]);
          face.a = 3 * i;
          face.b = 3 * i + 1;
          face.c = 3 * i + 2;
          face.materialIndex = 1;
          geo.faces.push(face);
        }
        ;

        // var material = new THREE.LineBasicMaterial({
        //   color: 0x00ff00,
        //   opacity: 1,
        //   lineWidth: 5
        // });

        // this.interGeo = new THREE.Line(geo, material);

        var material = new THREE.MeshLambertMaterial({
          // color: 0xaaffaa,
          color: 0x00ffff,
          wireframe: true,
          wireframeLinewidth: 1,
          vertexColors: THREE.FaceColors
        });
        var tempGeo = new THREE.Mesh(geo, material);
        tempGeo.applyMatrix(matrix);
        this.imgMaker.renderMeshToImage(tempGeo);
        imgData = this.imgMaker.getImage();
        this.map3dId_ImgData[id] = imgData;
      }
      ;
      return imgData;
    },
    hide3DObjsById: function hide3DObjsById(objIds) {
      this.showAllHided3dObjs();
      if (!objIds) {
        return;
      }
      ;
      var self = this;
      for (var i = 0; i < objIds.length; i++) {
        var id = objIds[i];
        for (var k = 0; k < this.origin3DObjs.length; k++) {
          var obj3d = this.origin3DObjs[k];
          if (obj3d.id == id) {
            obj3d.visible = false;
            this.commentsCtl.hideCommentOnObj3dId(obj3d.id);
            this.objs3dHided.push(obj3d);

            // var img = _getImgDataByObj3DAsync.call(this, obj3d, function(img){
            //   self.parentEditor.object3DHided(obj3d.id, img);
            // });

            this.parentEditor.object3DHided(obj3d.id, this.getImgDataByObj3D(obj3d));
            break;
          }
          ;
        }
        ;
      }
      ;
    }
  };
}());
var _default = exports["default"] = MDColladaDisplayer;

},{"1":1,"10":10,"1184":1184,"1411":1411,"1417":1417,"1423":1423,"1432":1432,"1438":1438,"1451":1451,"1454":1454,"1463":1463,"1497":1497,"15":15,"1505":1505,"1506":1506,"1507":1507,"1508":1508,"1509":1509,"1510":1510,"1511":1511,"1512":1512,"1513":1513,"1514":1514,"1516":1516,"1517":1517,"1518":1518,"1519":1519,"1520":1520,"1521":1521,"1522":1522,"1523":1523,"1524":1524,"1525":1525,"1526":1526,"1527":1527,"1528":1528,"1529":1529,"2":2,"3":3,"4":4,"6":6}],1511:[function(require,module,exports){
var createTypedArrayConstructor = require(1395);

// `Float32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Float32', function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"1395":1395}],4:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1451);
require(1412);
require(1414);
var _MDNew3DCommentInputView = _interopRequireDefault(require(15));
// MD3DMeasureController.js
//
// jiang
// 2016-8-26

var MD3DTool = {
  REVISION: '1'
};
MD3DTool.MD3DToolController = function ($parentDiv, scene, camera, displayer) {
  this.scene = scene;
  this.camera = camera;
  this.displayer = displayer;
  this.$parentDiv = $parentDiv;
  this.refreshSize();
};
Object.assign(MD3DTool.MD3DToolController.prototype, {}, function () {
  //  private function
  // *********************************************************************************************

  function _overFace(dvPos) {
    this.origin3DObjs = this.displayer.origin3DObjs;
    this.posCalculator = this.displayer.posCalculator;
    var allObjs = this.origin3DObjs;
    var intersects = this.posCalculator.intersects(dvPos, allObjs);
    if (intersects.length > 0) {
      if (!this.interInfo || this.interInfo.face != intersects[0].face) {
        // console.log('different face!')
        if (this.interInfo) {
          this.scene.remove(this.interGeo);
        }
        ;
        this.interInfo = intersects[0];

        // this.focusObj = this.interInfo.object.clone();

        var faces = [];
        if (this.interInfo.face.normal.length() == 0) {
          // faces = _expandFacesByPoint.call(this, this.interInfo);
          faces = this.interInfo.object.geometry.faces;
        } else {

          // faces = _expandFacesByIndex.call(this, this.interInfo);
        }
        var geo = new THREE.Geometry();
        for (var i = 0; i < faces.length; i++) {
          var face = faces[i].clone();
          geo.vertices.push(this.interInfo.object.geometry.vertices[face.a]);
          geo.vertices.push(this.interInfo.object.geometry.vertices[face.b]);
          geo.vertices.push(this.interInfo.object.geometry.vertices[face.c]);
          face.a = 3 * i;
          face.b = 3 * i + 1;
          face.c = 3 * i + 2;
          face.materialIndex = 1;
          geo.faces.push(face);
        }
        ;

        // var material = new THREE.LineBasicMaterial({
        //   color: 0x00ff00,
        //   opacity: 1,
        //   lineWidth: 5
        // });

        // this.interGeo = new THREE.Line(geo, material);

        var material = new THREE.MeshLambertMaterial({
          // color: 0xaaffaa,
          color: 0x00ffff,
          wireframe: true,
          wireframeLinewidth: 4,
          vertexColors: THREE.FaceColors
        });
        this.interGeo = new THREE.Mesh(geo, material);
        this.interGeo.applyMatrix(this.interInfo.object.matrixWorld.clone());
        // this.interGeo.matrix = this.interInfo.object.matrix.clone();
        // this.interGeo.modelViewMatrix = this.interInfo.object.modelViewMatrix.clone();
        // this.interGeo.normalMatrix = this.interInfo.object.normalMatrix.clone();

        this.scene.add(this.interGeo);
      }
      ;
    } else {
      if (this.interInfo) {
        this.scene.remove(this.interGeo);
      }
      ;
      this.interGeo = null;
    }
  }
  ; // _overFace = function(dvPos)

  //  public function
  // *********************************************************************************************

  return {
    constructor: MD3DTool.MD3DToolController,
    mouseDown: function mouseDown(dvPos) {},
    mouseMove: function mouseMove(dvPos, option) {
      this.curMousePos = dvPos;
      if (option && option.showFocusObj) {
        _overFace.call(this, dvPos);
      }
      ;
    },
    mouseUp: function mouseUp(dvPos) {},
    mouseClick: function mouseClick(dvPos) {},
    clear: function clear() {
      this.scene = null;
      this.camera = null;
      this.displayer = null;
      this.$parentDiv = null;
    },
    refreshDisp: function refreshDisp() {},
    refreshSize: function refreshSize() {},
    clearPanel: function clearPanel() {}
  };
}());
MD3DTool.MD3DMeasureController = function ($parentDiv, scene, camera, displayer) {
  MD3DTool.MD3DToolController.call(this, $parentDiv, scene, camera, displayer);
  this.$canvas = $('<canvas class="measureTool" style="position:absolute; width:100%;height:100%"></canvas>');
  this.$canvas.insertBefore(this.$parentDiv);
  this.refreshSize();
};
Object.assign(MD3DTool.MD3DMeasureController.prototype, MD3DTool.MD3DToolController.prototype, function () {
  //  private function
  // *********************************************************************************************
  function _clearSteps() {
    this.firstPt = null;
    this.secondPt = null;
    var canvas = this.$canvas[0];
    var cxt = canvas.getContext("2d");
    cxt.clearRect(0, 0, canvas.offsetWidth, canvas.offsetHeight);
  }
  ;
  function _processStep(dvPos) {
    var allObjs = this.displayer.origin3DObjs;
    var intersectInfos = this.displayer.posCalculator.intersects(dvPos, allObjs);
    if (intersectInfos.length) {
      var interInfo = intersectInfos[0];
      var lgPos = interInfo.point.clone();
      // var matrix = interInfo.object.matrixWorld;
      // lgPos.applyMatrix4(matrix);

      if (!this.measureStep) {
        this.measureStep = 1;
        _create1stPoint.call(this, lgPos);
      } else if (this.measureStep == 1) {
        this.measureStep = 2;
        _create2ndPoint.call(this, lgPos);
      } else {
        this.measureStep = 0;
        _clearSteps.call(this);
      }
    } else {
      _clearSteps.call(this);
    }
  }
  ;
  function _create1stPoint(lgPos) {
    this.firstPt = lgPos.clone();
  }
  ;
  function _create2ndPoint(lgPos) {
    this.secondPt = lgPos.clone();
    this.dist = this.secondPt.distanceTo(this.firstPt);
    this.dist = Math.round(this.dist * 1000) / 1000;
  }
  ;
  function _getTriangleEdgeMid(trianglePoints) {
    var mid = [];
    for (var i = 0; i < trianglePoints.length; i++) {
      var v = trianglePoints[i];
      var k = i + 1;
      if (k == trianglePoints.length) {
        k = 0;
      }
      ;
      var nextV = trianglePoints[k];
      var m = v.clone();
      m.add(nextV).multiplyScalar(0.5);
      mid.push(m);
    }
    ;
    return mid;
  }
  function _getTheNearestPoint(pts, mousePt) {}
  function _lockPoint(dvPos) {
    var allObjs = this.displayer.origin3DObjs;
    var intersectInfos = this.displayer.posCalculator.intersects(dvPos, allObjs);
    if (intersectInfos.length) {
      var interInfo = intersectInfos[0];
      var face = interInfo.face;
      var obj3d = interInfo.object;
      var lgPos = interInfo.point.clone();
      var vertices = obj3d.geometry.vertices;
      var trianglePoints = [vertices[face.a].clone(), vertices[face.b].clone(), vertices[face.c].clone()];
      var midPoints = _getTriangleEdgeMid(trianglePoints);
      trianglePoints.concat(midPoints);
      var nearestPt = _getTheNearestPoint(trianglePoints, lgPos);
    }
    ;
  }
  ;

  //  public function
  // *********************************************************************************************

  return {
    constructor: MD3DTool.MD3DMeasureController,
    mouseDown: function mouseDown(dvPos) {
      MD3DTool.MD3DToolController.prototype.mouseDown.call(this, dvPos);
    },
    mouseMove: function mouseMove(dvPos) {
      MD3DTool.MD3DToolController.prototype.mouseMove.call(this, dvPos);
      this.curMousePos = dvPos;
      _lockPoint.call(this, dvPos);
    },
    mouseUp: function mouseUp(dvPos) {
      MD3DTool.MD3DToolController.prototype.mouseUp.call(this, dvPos);
    },
    mouseClick: function mouseClick(dvPos) {
      MD3DTool.MD3DToolController.prototype.mouseClick.call(this, dvPos);
      _processStep.call(this, dvPos);
    },
    clear: function clear() {
      _clearSteps.call(this);
      MD3DTool.MD3DToolController.prototype.clear.call(this);
      this.$canvas.remove();
    },
    refreshDisp: function refreshDisp() {
      MD3DTool.MD3DToolController.prototype.refreshDisp.call(this);
      var canvas = this.$canvas[0];
      var ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.offsetWidth, canvas.offsetHeight);
      ctx.strokeStyle = "yellow";
      ctx.fillStyle = "yellow";
      if (this.firstPt) {
        var pt1 = this.displayer.logicToDevice(this.firstPt);
        var pt2 = this.curMousePos;
        if (this.secondPt) {
          pt2 = this.displayer.logicToDevice(this.secondPt);
        }
        ;
        ctx.beginPath();
        ctx.moveTo(pt1.x, pt1.y);
        ctx.lineTo(pt2.x, pt2.y);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(pt1.x, pt1.y, 3, 0, Math.PI * 2, 1);
        ctx.fill();
        if (this.secondPt) {
          ctx.beginPath();
          ctx.arc(pt2.x, pt2.y, 3, 0, Math.PI * 2, 1);
          ctx.fill();

          // show distance
          ctx.fillStyle = "white";
          // ctx.strokeStyle = "white";
          ctx.font = "10pt serif";
          var text = BabelStr.str(5111) + ': ' + this.dist + '';
          var size = ctx.measureText(text);
          var mid = {
            x: (pt1.x + pt2.x) / 2,
            y: (pt1.y + pt2.y) / 2
          };
          var textPos = {
            x: mid.x - size.width / 2,
            y: mid.y + 10
          };
          ctx.fillText(text, textPos.x, textPos.y);
          // ctx.strokeText(text, textPos.x, textPos.y);
        }
        ;
      }
      ;
    },
    refreshSize: function refreshSize() {
      MD3DTool.MD3DToolController.prototype.refreshSize.call(this);
      if (this.$canvas) {
        this.$canvas.attr('width', this.$parentDiv.width() + 'px');
        this.$canvas.attr('height', this.$parentDiv.height() + 'px');
      }
      ;
    }
  };
}());
MD3DTool.MD3DCommentController = function ($parentDiv, scene, camera, displayer) {
  MD3DTool.MD3DToolController.call(this, $parentDiv, scene, camera, displayer);
};
Object.assign(MD3DTool.MD3DCommentController.prototype, MD3DTool.MD3DToolController.prototype, function () {
  //  private function
  // *********************************************************************************************

  function _create3DCommentAtScreen(dvPos) {
    if (!this.displayer.parentEditor.curFileInfo.canCreateComment()) {
      return;
    }
    ;
    Dispatcher.trigger(MDEvents.SHOW_COMMENTS);
    this.origin3DObjs = this.displayer.origin3DObjs;
    this.posCalculator = this.displayer.posCalculator;
    var allObjs = this.origin3DObjs;
    this.displayer.removeAllPanels();
    var self = this;
    var showVisibleScope = true;
    this.commentPosInfo = this.posCalculator.objInfoAtScreenPos(dvPos, allObjs);
    dvPos = MMCommonFun.convertPointBetweenElements(self.displayer.$touchLayer[0], $('body')[0], dvPos);
    if (this.commentPosInfo && this.camera.frustum.containsPoint(this.commentPosInfo.point)) {
      if (!app.currentUser.logined()) {
        app.popupInnerLogin();
        return;
      }
      this.displayer.commentsCtl.createTempCommentDiv(this.displayer.$touchLayer, this.commentPosInfo);
      if (this.commentCreationPanel) {
        this.commentCreationPanel.removeFromSuperView();
      }
      ;
      this.commentCreationPanel = new _MDNew3DCommentInputView["default"]({
        v_pos: dvPos,
        showVisibleScope: showVisibleScope,
        editorViewCtl: this.editorViewCtl,
        cancelFun: function cancelFun() {
          console.log('-------> cancel');
          self.displayer.commentsCtl.popTempCommentDiv();
          self.commentCreationPanel = null;
        },
        okFun: function okFun(text, atIds, visibleScope) {
          self.commentCreationPanel.showWaiting();
          _czc && _czc.push(["_trackEvent", "讨论", "创建批注", "3D", "", "#submitButton"]);
          self.displayer.commentsCtl.saveTempCommentDiv(text, atIds, visibleScope, self.displayer.objs3dHided, function () {
            self.commentCreationPanel.removeWaitingShow();
            if (self.commentCreationPanel) {
              self.commentCreationPanel.removeFromSuperView();
            }
            ;
            self.displayer.enableMouseWheel(true);
            self.commentCreationPanel = null;
          });
        }
      });
    } else {
      this.clearPanel();
    }
  }
  ; // _create3DCommentAtScreen = function(dvPos)

  //  public function
  // *********************************************************************************************

  return {
    constructor: MD3DTool.MD3DCommentController,
    mouseDown: function mouseDown(dvPos) {
      MD3DTool.MD3DToolController.prototype.mouseDown.call(this, dvPos);
    },
    mouseMove: function mouseMove(dvPos) {
      var option = {
        showFocusObj: false
      };
      MD3DTool.MD3DToolController.prototype.mouseMove.call(this, dvPos, option);
      this.curMousePos = dvPos;
    },
    mouseUp: function mouseUp(dvPos) {
      MD3DTool.MD3DToolController.prototype.mouseUp.call(this, dvPos);
    },
    mouseClick: function mouseClick(dvPos) {
      MD3DTool.MD3DToolController.prototype.mouseClick.call(this, dvPos);
      _create3DCommentAtScreen.call(this, dvPos);
    },
    clear: function clear() {
      var self = this;
      if (self.commentCreationPanel) {
        self.commentCreationPanel.removeFromSuperView();
        self.commentCreationPanel = null;
      }
      ;
      MD3DTool.MD3DToolController.prototype.clear.call(this);
    },
    refreshDisp: function refreshDisp() {
      MD3DTool.MD3DToolController.prototype.refreshDisp.call(this);
    },
    refreshSize: function refreshSize() {
      MD3DTool.MD3DToolController.prototype.refreshSize.call(this);
    },
    clearPanel: function clearPanel() {
      if (this.commentCreationPanel) {
        this.commentCreationPanel.removeFromSuperView();
        this.commentCreationPanel = null;
        this.displayer.commentsCtl.popTempCommentDiv();
      }
      ;
    }
  };
}()); // MD3DCommentController

MD3DTool.MD3DDisassembleController = function ($parentDiv, scene, camera, displayer) {
  MD3DTool.MD3DToolController.call(this, $parentDiv, scene, camera, displayer);
};
Object.assign(MD3DTool.MD3DDisassembleController.prototype, MD3DTool.MD3DToolController.prototype, function () {
  //  private function
  // *********************************************************************************************

  function _hideObjectAtPos(dvPos) {
    this.origin3DObjs = this.displayer.origin3DObjs;
    this.posCalculator = this.displayer.posCalculator;
    var allObjs = this.origin3DObjs;
    var self = this;
    var intersectInfos = this.posCalculator.intersects(dvPos, allObjs);
    if (intersectInfos.length > 0) {
      var intersection = intersectInfos[0];
      if (this.camera.frustum.containsPoint(intersection.point)) {
        intersection.object.visible = false;
        this.scene.remove(this.interGeo);
        _hide3DObj.call(this, intersection.object);

        // var material = new THREE.MeshLambertMaterial({
        //                                 color: 0x00ffff,
        //                                 wireframe:true,
        //                                 wireframeLinewidth:1,
        //                                 vertexColors: THREE.FaceColors
        //                               });
        // var dispObj3D = this.interGeo;
        // if (dispObj3D == null) {
        //   dispObj3D = intersection.object.clone();
        // };

        // this.interGeo = null;

        // dispObj3D.material = material;

        // // this.imgMaker.renderMeshToImage(this.focusObj);
        // this.imgMaker.renderMeshToImage(dispObj3D);
        // this.parentEditor.object3DHided(intersection.object.id, this.imgMaker.getImage());
        var img = this.displayer.getImgDataByObj3D(intersection.object);
        this.displayer.parentEditor.object3DHided(intersection.object.id, img);
      }
      ;
    }
    ;
    return intersectInfos.length > 0;
  }
  ;
  function _hide3DObj(obj3d) {
    var self = this;
    this.displayer.objs3dHided.push(obj3d);
    this.displayer.commentsCtl.hideCommentOnObj3dId(obj3d.id);
    obj3d.traverse(function (node) {
      if (node instanceof THREE.Mesh) {
        self.displayer.commentsCtl.hideCommentOnObj3dId(node.id);
      }
    });
  }
  ;

  //  public function
  // *********************************************************************************************

  return {
    constructor: MD3DTool.MD3DDisassembleController,
    mouseDown: function mouseDown(dvPos) {
      MD3DTool.MD3DToolController.prototype.mouseDown.call(this, dvPos);
    },
    mouseMove: function mouseMove(dvPos) {
      var option = {
        showFocusObj: true
      };
      MD3DTool.MD3DToolController.prototype.mouseMove.call(this, dvPos, option);
      this.curMousePos = dvPos;
    },
    mouseUp: function mouseUp(dvPos) {
      MD3DTool.MD3DToolController.prototype.mouseUp.call(this, dvPos);
    },
    mouseClick: function mouseClick(dvPos) {
      MD3DTool.MD3DToolController.prototype.mouseClick.call(this, dvPos);
      _hideObjectAtPos.call(this, dvPos);
    },
    clear: function clear() {
      MD3DTool.MD3DToolController.prototype.clear.call(this);
    },
    refreshDisp: function refreshDisp() {
      MD3DTool.MD3DToolController.prototype.refreshDisp.call(this);
    },
    refreshSize: function refreshSize() {
      MD3DTool.MD3DToolController.prototype.refreshSize.call(this);
    }
  };
}());
var _default = exports["default"] = MD3DTool;

},{"1184":1184,"1412":1412,"1414":1414,"1451":1451,"1454":1454,"15":15}],15:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
var _MDNewCommentInputView = _interopRequireDefault(require(334));
var _MMBasicData = _interopRequireDefault(require(811));
var _MDPCEditorViewController = _interopRequireDefault(require(940));
var _MDSnackbarView = _interopRequireDefault(require(72));
/**
 *  任务版页面
 *
 *  Create by jiang
 *  2016.9.24
 */

var MDNew3DCommentInputView = _MDNewCommentInputView["default"].extend({
  // el: '<div class="m-newcom-panel"></div>',

  // tmpl:
  //   '<div class="newcom-panel-content">' +
  //     '<div class="input-wrap">' +
  //       '<span id="js-input-slot"></span>' +
  //       '<div class="scribble-placeholder">' +
  //         '<div class="scribbleDisplayView">' +
  //           '<div class="icon scribble"></div>你附加了图文批注' +
  //           '<span class="icon close"></span>' +
  //         '</div>' +
  //         // '<span id="js-scribble-btn" class="icon scribble addScribbleBtn"></span>' +
  //       '</div>' +
  //     '</div>' +
  // '</div>',

  // initProps: function() {
  //   var superP = MMViewBase.prototype.initProps.call(this);
  //   return _.extend(superP, {
  //     _openDirection: -1,
  //     _clickOutsideHandler: null,
  //     parent: null,
  //     position: null,
  //     page: null,
  //     editor: null
  //   });
  // },

  // events: function() {
  //   var superE = MMViewBase.prototype.events.call(this);
  //   var selfE = _.extend(superE , {
  //     'click #submitButton': this.submitButtonEventHandler
  //   });

  //   if(app.canDispInNormalBrowser()){
  //     _.extend(selfE , {
  //       'click #js-scribble-btn': this._openScribbleView,
  //       'click .scribbleDisplayView .close': this._removeScribble,
  //       'click .scribbleDisplayView': this._displayScribble,
  //       'click .visibleScopeBtn':this._selectScope
  //     })
  //   }
  //   return selfE ;
  // },

  // submitButtonEventHandler: function() {
  //   var text = this.inputView.getText();
  //   if (this.hasSketch() || this.getContent().length) {
  //     this.sendText(text);
  //   }
  // },

  customInitialize: function customInitialize(options) {
    this.$el.find('#js-scribble-btn').remove();
    this.$el.find('.scribble-placeholder').remove();
  },
  initialize: function initialize(options) {
    _MDNewCommentInputView["default"].prototype.initialize.call(this, options);
    var self = this;
    // this.inputView = new MDMessageInputAreaView({
    //   parent: this,
    //   maxLineCount: 5,
    //   placeholder: '输入批注内容',
    //   noSendOnEnter: true,
    //   onInputChange: function(){
    //                   self.update()
    //                 },
    //   enterSubmit: false
    // });
    // // this.addSubView(this.inputView, this.$('#js-input-slot')[0], true);
    // this.$('#js-input-slot').append(this.inputView.$el);

    // this.$container = this.$('.newcom-panel-content');
    // this.$button = this.$('#submitButton');
    // this.$scribbleWrap = this.$('.scribble-placeholder');

    this.okFun = options.okFun;
    this.cancelFun = options.cancelFun;
    this.v_pos = options.v_pos;

    // if (app.canDispInNormalBrowser()) {
    //   var editorCtl = MDPCEditorViewController.getCurrentInstance();
    //   if (editorCtl) {
    //     editorCtl.enableMouseWheel(false);
    //   };
    // };

    app.application.addSubView(this);
    // $('body').append(this.$el);
    // this.$el.css('left', options.v_pos.x + 'px');
    // this.$el.css('top', options.v_pos.y + 'px');

    var z_startIndex = _MMBasicData["default"].getO2OStartLayerZ_index();
    this.$el.css('z-index', z_startIndex);

    // this.$el.find('textarea').focus();

    this.inputView.setFocus();

    // this.visibleScope = 0;
    // if (options.showVisibleScope) {
    //   var $scopeAndOkBtn = $(
    //       '<div class="newCommentPanelFooter">'+
    //         '<button class="visibleScopeBtn">'+
    //           '<span>' + MMObject.scopeDispStrings[0] + '</span>'+
    //           '<i class="button-icon selectBoxSmall"></i>'+
    //         '</button>'+
    //         '<div class="okBtnZone">'+
    //           '<button id="submitButton" class="button main">完成</button>'+
    //         '</div>'+
    //       '</div>'
    //     );
    //   this.$el.find('.newcom-panel-content').append($scopeAndOkBtn);
    // } else {
    //   var $okBtn = $('<button id="submitButton" class="button main">完成</button>');
    //   this.$el.find('.newcom-panel-content').append($okBtn);
    // }
  },
  // _removeScribble: function() {
  //   var self = this ;
  //   var _allObjects = MMSketchCommentController.getAllObjects();
  //   var _actionManager = this.getBoard().m_actionManager;
  //   _actionManager.deleteObjects(_allObjects, false, false, true);
  //   self.update();
  //   return false ;
  // },

  // _displayScribble: function($e) {
  //   var self = this;
  //   var marker = MMImageMarkerCtl.getSingleInstance();
  //   var obj = self.editor.getPicObject();
  //   marker.displayToEdit(obj, undefined, function() {
  //     self.update();
  //   });
  // },

  // _openScribbleView: function($e) {
  //   var self = this;
  //   if (!app.currentUser.logined()) {
  //     app.popupInnerLogin();
  //     return;
  //   }
  //   var marker = MMImageMarkerCtl.getSingleInstance();
  //   var obj = self.editor.getPicObject();
  //   marker.displayToEdit(obj, undefined, function() {
  //     self.inputView.setFocus(true);
  //     self.update();
  //   });
  // },

  // update: function() {
  //   if (this.hasSketch()) {
  //     this.$scribbleWrap.addClass('has-scribble');
  //   } else {
  //     this.$scribbleWrap.removeClass('has-scribble');
  //   }
  //   if (this.hasSketch()|| this.getContent().length) {
  //     this.$button.removeClass('disabled');
  //   } else {
  //     this.$button.addClass('disabled');
  //   }
  // },

  // hasSketch: function(){
  //   return MMSketchCommentController.getAllObjects().length >= 1;
  // },

  // getBoard: function() {
  //   return MMCommonFun.getMainEditor().getCurrentBoard();
  // },

  send: function send(text, atIds) {
    if (this.$button.hasClass('disabled')) {
      return;
    }
    var text = this.getContent();
    if (text == '' && !this.hasSketch()) {
      _MDSnackbarView["default"].show(BabelStr.str(3294));
      return;
    }
    if (this.sending) {
      return;
    }
    ;
    this.sending = true;
    if (this.okFun) {
      this.okFun(text, atIds, this.visibleScope);
    }
    ;
    this.sendClicked = true;
  },
  sendText: function sendText(text, atIds) {
    var self = this;
    self.send(text, atIds);
    setBabelTimeout(function () {
      Dispatcher.trigger(MDEvents.Comment_State_Sync, self.getBoard().fileInfo.getFileId(), self);
    }, 300);
  },
  hide: function hide(cb) {
    _MDNewCommentInputView["default"].prototype.hide.call(this, cb);
    // if (this.cancelFun) {
    //   this.cancelFun();
    // };
  },
  // getContent: function() {
  //   return this.inputView.getText().trim();
  // },

  // setContent: function(text) {
  //   this.inputView.setText(text);
  //   this.update();
  // },

  viewWillUnRendered: function viewWillUnRendered() {
    _MDNewCommentInputView["default"].prototype.viewWillUnRendered.call(this);
    if (app.canDispInNormalBrowser()) {
      var editorCtl = _MDPCEditorViewController["default"].getCurrentInstance();
      if (editorCtl) {
        editorCtl.checkToEnablePrivateMouseWheel();
      }
      ;
    }
    ;

    // if (this._clickOutsideHandler) {
    //   $(this.editor.getAssistantCanvas()).off('click', this._clickOutsideHandler);
    // }
    // if (this.recognizer) {
    //   this.recognizer.destroy();
    // }
    viewManager.remove('newCommentInput');
    if (!this.sendClicked && this.cancelFun) {
      this.cancelFun();
    }
    ;
  },
  viewDidRendered: function viewDidRendered() {
    _MDNewCommentInputView["default"].prototype.viewDidRendered.call(this);
    // // var $window = $(window);
    // // var parentWidth = parseInt($window.width());
    // // var parentHeight = parseInt($window.height());
    // // var myWidth = parseInt(this.$container.width());
    // // var myHeight = parseInt(this.$container.height());
    // // var myLeft = this.v_pos.x;
    // // var myTop = this.v_pos.y;

    // // var color = g_keyColor;

    // // if (app.canDispInNormalBrowser()) {
    // //   var pointPos = {
    // //     upward: 'top',
    // //     sideward: 'left'
    // //   };

    // //   // keeping the view in frame,
    // //   if ((myLeft + myWidth) > parentWidth) {
    // //     myLeft -= myWidth;
    // //     pointPos.sideward = 'right';
    // //   }
    // //   if ((myTop + myHeight) > parentHeight) {
    // //     myTop -= myHeight;
    // //     pointPos.upward = 'bottom';
    // //   }
    // //    //prepare the commentCircle
    // //   this._$circleParent = $('<div class="comment-pt cursor-move">');
    // //   this._$circleParent.css(pointPos.upward , 0);
    // //   this._$circleParent.css(pointPos.sideward , 0);

    // //   this.recognizer = new MDGestureRecognizer(this._$circleParent[0]);
    // //   this.recognizer.on(MDEvents.PAN, function(finger, e) {
    // //     var maxOffset;
    // //     // for Portrait, enought for the current edition (17.07.2015)
    // //     var editorCtl = this.editor;
    // //     var imageRect = editorCtl.getPicObject().getRect();
    // //     //example: {top: 1725.78125, right: 15, bottom: 1734.21875, left: 0}
    // //     // {x:5,y:1727}
    // //     var trsfm = editorCtl.getCanvasTransformer();
    // //     var lgOffset = {
    // //       x: trsfm.dv2lgLen(finger.offset.x),
    // //       y: trsfm.dv2lgLen(finger.offset.y)
    // //     };
    // //     if (lgOffset.x > 0) {
    // //       maxOffset = imageRect.right - this.position.x;
    // //       if (lgOffset.x > maxOffset) lgOffset.x = maxOffset;
    // //     } else {
    // //       maxOffset = imageRect.left - this.position.x;
    // //       if (lgOffset.x < maxOffset) lgOffset.x = maxOffset;
    // //     }

    // //     if (lgOffset.y > 0) {
    // //       maxOffset = imageRect.bottom - this.position.y;
    // //       if (lgOffset.y > maxOffset) lgOffset.y = maxOffset;
    // //     } else {
    // //       maxOffset = imageRect.top - (this.position.y);
    // //       if (lgOffset.y < maxOffset) lgOffset.y = maxOffset;
    // //     }

    // //     this.position.x += lgOffset.x;
    // //     this.$el[0].style.left = parseFloat(this.$el[0].style.left) + trsfm.lg2dvLen(lgOffset.x) + "px";
    // //     this.position.y += lgOffset.y;
    // //     this.$el[0].style.top = parseFloat(this.$el[0].style.top) + trsfm.lg2dvLen(lgOffset.y) + "px";
    // //   }.bind(this));

    // //   var _mainEditor = this.editor;
    // //   MMObjElementsController.getSingleInstance().zoomScaleChanged(
    // //     _mainEditor.getScale(), _mainEditor
    // //   );

    // //   MDCommentAnimator.createColoredClasses(color);

    // //   //prepareing the touch recognizer
    // //   MDCommentAnimator.init(this._$circleParent, 'CommentReaded-' + MDCommentAnimator.fixeColorName(color));
    // //   // adding the new index to the comment circle
    // //   var currentBoard = this.getBoard();
    // //   var curDispVer = currentBoard.getVersionShowing();
    // //   var commentDisplayIndex = currentBoard.getCommentsForVersion(curDispVer).length + 1;
    // //   this._$circleParent.children().append(commentDisplayIndex);
    // //   this.$container.append(this._$circleParent);

    // }

    // viewManager.add('newCommentInput', this);

    // this.$el.css({
    //   'left': myLeft,
    //   'top': myTop
    // });
    // this.show();
    // this.update();
  },
  removeFromSuperView: function removeFromSuperView() {
    _MDNewCommentInputView["default"].prototype.removeFromSuperView.call(this);
  },
  closePanel: function closePanel() {
    if (this.cancelFun) {
      this.cancelFun();
    }
    ;
    this.cancelFun = null;
    this.removeFromSuperView();
  }
}, {
  className: "MDNew3DCommentInputView"
});
var _default = exports["default"] = MDNew3DCommentInputView;

},{"1184":1184,"1417":1417,"1454":1454,"1463":1463,"334":334,"72":72,"811":811,"940":940}],334:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1498);
require(1466);
var _MMViewBase = _interopRequireDefault(require(22));
var _MDMessageInputAreaView = _interopRequireDefault(require(331));
var _MDCommentAnimator = _interopRequireDefault(require(317));
var _MDEvents = _interopRequireDefault(require(325));
var _MDPCEditorViewController = _interopRequireDefault(require(940));
var _MMBasicData = _interopRequireDefault(require(811));
var _MDCommentVisibleScopeListView = _interopRequireDefault(require(408));
var _MMCommentObj = _interopRequireDefault(require(1005));
var _MMFillType = _interopRequireDefault(require(795));
var _MMColor = _interopRequireDefault(require(794));
var _int = _interopRequireDefault(require(820));
var _popupPos = _interopRequireDefault(require(65));
var _MMSketchCommentController = _interopRequireDefault(require(885));
var _MMObject = _interopRequireDefault(require(1081));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
var _MDSpinnerloaderView = _interopRequireDefault(require(76));
var _MMCommonFun = _interopRequireDefault(require(812));
/**
 *  任务版页面
 *
 *  Create by manjun.han
 *  2014.12.30
 */

var MDNewCommentInputView = _MMViewBase["default"].extend({
  el: '<div class="m-newcom-panel"></div>',
  tmpl: "<div class=\"newcom-panel-content\">\n          <div class=\"input-wrap\">\n            <span id=\"js-input-slot\"></span>\n            <div class=\"scribble-placeholder \">\n              <div class=\"scribbleDisplayView flex-align between\">\n                <div><span class=\"icon scribble\"></span><%=scrAttach%></div>\n                <span class=\"icon close\"></span>\n              </div>\n            </div>\n            <span id=\"js-scribble-btn\" class=\"addScribbleBtn flex-align center middle\" data-tooltip=\"<%=scribble%>\" data-tooltip-dir=\"top\">\n              <i class=\"icon scribble\"></i>\n            </span>\n        </div>\n      </div>",
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      _openDirection: -1,
      _clickOutsideHandler: null,
      parent: null,
      position: null,
      page: null,
      editor: null
    });
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    var selfE = _.extend(superE, {
      'click #submitButton': this.submitButtonEventHandler
    });
    if (app.canDispInNormalBrowser()) {
      _.extend(selfE, {
        'click #js-scribble-btn': this._openScribbleView,
        'click .scribbleDisplayView .close': this._removeScribble,
        'click .scribbleDisplayView': this._displayScribble
      });
    }
    return selfE;
  },
  submitButtonEventHandler: function submitButtonEventHandler() {
    var text = this.inputView.getText();
    var atIds = this.inputView.getAtIds();
    if (this.hasSketch() || this.getContent().length) {
      this.sendText(this.getContent(), atIds);
    }
  },
  customInitialize: function customInitialize(options) {},
  initialize: function initialize(options) {
    var _this = this;
    _MMCommonFun["default"].setTextInputInEditor('newComment');
    var self = this;
    options.data = _.extend({
      'scrAttach': BabelStr.str(463),
      // 你附加了图文批注
      'scribble': BabelStr.str(130) // 手绘批注
    }, options.data);
    _MMViewBase["default"].prototype.initialize.call(this, options);
    this.customInitialize(options);
    this.bindSelf([this.update]);
    this._getEvalInfo(function (evalFlow) {
      _this._constructComponents(evalFlow);
    });
    var fileInfo = this.getBoard().fileInfo;
    if (fileInfo.isCADFile()) {
      this.$("#js-scribble-btn").remove();
    }
    this.$el.css('z-index', 3000000000);
  },
  _constructComponents: function _constructComponents(evalFlow) {
    var self = this;
    var toEvaluate = false;
    if (evalFlow) {
      var curUserIsCreator = evalFlow.isCurUserCreator();
      var curUserGroupIndex = evalFlow.getCurrentUserGroupIndex();
      var curStep = evalFlow.getCurStep();

      // toEvaluate = !curUserIsCreator && (curUserGroupIndex == curStep);       // ------------------------- 非评审发起人且是评审人员才可以建立审批意见
      toEvaluate = curUserGroupIndex == curStep; // ------------------------- 非评审发起人且是评审人员才可以建立审批意见
    }
    var str = BabelStr.str(118); // '输入批注内容'
    if (toEvaluate) {
      str = BabelStr.str(805); // '输入评审意见'
    }
    this.inputView = new _MDMessageInputAreaView["default"]({
      editorViewCtl: this.editorViewCtl,
      parent: this,
      maxLineCount: 5,
      placeholder: str,
      // '输入批注内容',
      onInputChange: this.update,
      enterSubmit: false
    });
    this.addSubView(this.inputView, this.$('#js-input-slot')[0], true);
    this.$container = this.$('.newcom-panel-content');
    this.$button = this.$('#submitButton');
    this.$scribbleWrap = this.$('.scribble-placeholder');
    if (app.canDispInNormalBrowser()) {
      var editorCtl = _MDPCEditorViewController["default"].getCurrentInstance();
      if (editorCtl) {
        editorCtl.enableMouseWheel(false);
      }
      ;
    }
    ;
    this.visibleScope = 0;
    if (toEvaluate) {
      this.visibleScope = 8; // -------------------------- 8 表示审批意见
    }
    var finishStr = BabelStr.str(89); // 完成
    if (!toEvaluate && app.isEpVersion() && !app.currentUser.isEnterpriseGuest() && _MDPcMobileEditorCommonFun["default"].currentFileBelongsToCurUserEnterprise()) {
      var $scopeAndOkBtn = $('<div class="newCommentPanelFooter">' + '<button class="visibleScopeBtn">' + '<div class="text-hide">' + _MMObject["default"].scopeDispStrings[0] + '</div>' + '<i class="button-icon selectBoxSmall"></i>' + '</button>' + '<div class="okBtnZone">' + '<button id="submitButton" class="button main">' + finishStr + '</button>' + '</div>' + '</div>');
      this.$el.find('.newcom-panel-content').append($scopeAndOkBtn);
    } else {
      var $okBtn = $('<button id="submitButton" class="button main">' + finishStr + '</button>');
      this.$el.find('.newcom-panel-content').append($okBtn);
    }
    _MDCommentVisibleScopeListView["default"].createPopup({
      triggerView: this.$('.visibleScopeBtn'),
      center: true,
      direction: _popupPos["default"].TOP_LEFT,
      width: 300,
      onShow: function onShow() {
        var scopeList = self.$('.visibleScopeBtn').data('popupView');
        var z_startIndex = _MMBasicData["default"].getO2OStartLayerZ_index();
        scopeList.$el.css("z-index", z_startIndex);
      },
      onSelectItem: function onSelectItem(scopeSelected) {
        var scopeList = self.$('.visibleScopeBtn').data('popupView');
        self.visibleScope = scopeSelected;
        self.$el.find('.visibleScopeBtn span').text(scopeList.getDispString());
      }
    });
  },
  _getEvalInfo: function _getEvalInfo(callback) {
    if (this.getBoard().fileInfo.isInEvaluation()) {
      var version = this.editorViewCtl.getVersionShowing();
      this.getBoard().fileInfo.getEvalFlowInfo(version, function (evalFlow) {
        callback(evalFlow);
      });
    } else {
      callback(null);
    }
  },
  _removeScribble: function _removeScribble() {
    var self = this;
    var _allObjects = _MMSketchCommentController["default"].getAllObjects();
    var _actionManager = this.getBoard().m_actionManager;
    if (_actionManager) {
      _actionManager.deleteObjects(_allObjects, {
        toUndo: false,
        realtime: false,
        isMark_: true
      });
    }
    ;
    self.update();
    return false;
  },
  _displayScribble: function _displayScribble($e) {
    var self = this;
    var marker = this.imgMarkerCtl.getSingleInstance();
    var obj = self.editor.getPicObject();
    var editorClass = self.editor.getClassName();
    var swfEditor = false;
    if (editorClass == "MDSWFEditor") {
      swfEditor = true;
    }
    var opt = {
      swfEditor: swfEditor,
      isOpenOldScribble: true,
      editorViewCtl: this.editorViewCtl
    };
    marker.displayToEdit(obj, opt, function () {
      self.update();
    });
  },
  _openScribbleView: function _openScribbleView($e) {
    var self = this;
    if (!app.currentUser.logined()) {
      app.popupInnerLogin();
      return;
    }
    var marker = this.imgMarkerCtl.getSingleInstance();
    var obj = self.editor.getPicObject();
    var editorClass = self.editor.getClassName();
    var swfEditor = false;
    if (editorClass == "MDSWFEditor") {
      swfEditor = true;
    }
    var opt = {
      swfEditor: swfEditor,
      editorViewCtl: this.editorViewCtl
    };
    marker.displayToEdit(obj, opt, function () {
      self.inputView.setFocus(true);
      self.update();
    });
  },
  update: function update() {
    if (this.hasSketch()) {
      this.$el.addClass('has-scribble');
    } else {
      this.$el.removeClass('has-scribble');
    }
    if (this.hasSketch() || this.getContent().length) {
      this.$button.removeClass('disabled');
    } else {
      this.$button.addClass('disabled');
    }
  },
  hasSketch: function hasSketch() {
    return _MMSketchCommentController["default"].getAllObjects().length >= 1;
  },
  getBoard: function getBoard() {
    return this.editorViewCtl.getCurrentBoard();
    return _MDPcMobileEditorCommonFun["default"].getMainEditor().getCurrentBoard();
  },
  send: function send(text, atIds) {
    if (this.$button.hasClass('disabled')) {
      return;
    }
    var text = this.getContent();
    if (text == '' && !this.hasSketch()) {
      _MDSnackbarView["default"].showStandardMsg(0);
      return;
    }
    var curWhiteboard = this.getBoard();
    var curDispVer = this.editorViewCtl.getVersionShowing();
    var comment = new _MMCommentObj["default"](curWhiteboard, curDispVer);
    var editorCtl = this.editor;
    comment.setPageIndex(this.page);
    comment.setPos(this.position); // 先设置属性，再进入 undo
    var filltype = new _MMFillType["default"]();
    ;
    filltype.setFill(true);
    var color = new _MMColor["default"]();
    color.m_r = 1;
    color.m_g = 0;
    color.m_b = 0;
    color.m_alpha = 1;
    filltype.setFillColor(color);
    comment.setFillType(filltype);
    var creatorId = new _int["default"](app.currentUser.id);
    comment.setRead(creatorId);
    comment.setCreator(creatorId);
    var editor = this.editorViewCtl.getCurEditor();
    comment.curScale = editor.getScale();
    comment.centerPos = editor.getCenterRatioPosition();
    var self = this;
    var option = {
      toUndo: true,
      realtime: true,
      isMark_: false
    };
    curWhiteboard.m_actionManager.addObject(comment, option, function (error) {
      if (!error) {
        if (self.hasSketch()) {
          _MMSketchCommentController["default"].sendText(text, atIds, comment.getVisibleScope(), comment, function success() {
            _MDSnackbarView["default"].showStandardMsg('commentCreated');
          }, function fail() {
            _MDSnackbarView["default"].showStandardMsg('commentFailed');
          });
        } else {
          curWhiteboard.m_actionManager.sendMessage(JSON.stringify({
            'Type': 'Text',
            'Body': text
          }), comment.getId(), function (error2) {
            if (!error2) {
              _MDSnackbarView["default"].showStandardMsg('commentCreated');
              Dispatcher.trigger(_MDEvents["default"].Comment_changed);
            } else {
              _MDSnackbarView["default"].showStandardMsg('commentFailed');
            }
          });
        }
      } else {
        _MDSnackbarView["default"].showStandardMsg('commentFailed');
      }
    });
    var curOperation = editorCtl.getCurOperation();
    if (curOperation && curOperation.closeCommentInputView) {
      curOperation.closeCommentInputView();
    } else {
      /*
       * mashx to handle some bad situation...
       */
      self.removeFromSuperView();
    }
    g_textCached = undefined;
    editorCtl.setCurOperation();
    this.setContent("");
  },
  sendText: function sendText(text, atIds) {
    var self = this;
    self.send(text, atIds);
    setBabelTimeout(function () {
      Dispatcher.trigger(_MDEvents["default"].Comment_State_Sync, self.getBoard().fileInfo.getFileId(), self);
    }, 300); //有待改进8/28 2016
  },
  hide: function hide(cb) {
    // if (app.canDispInNormalBrowser()) {
    //   var editorCtl = MDPCEditorViewController.getCurrentInstance();
    //   if (editorCtl) {
    //     editorCtl.checkToEnablePrivateMouseWheel();
    //   };
    // };

    if (app.canDispInNormalBrowser()) {
      this.inputView && this.inputView.destroyAtWhoView();
      this.$el.css('display', 'none');
      if (cb) {
        cb();
      }
    } else {
      var height = this.$el.height();
      this.$el.animate({
        bottom: '-150px'
      }, 250, 'linear');
      if (this._$circleParent) {
        this._$circleParent.css('display', 'none');
      }
      this.$el.css('display', 'none');
      if (cb) {
        cb();
      }
    }
    _MMCommonFun["default"].removeTextInputInEditor('newComment');
  },
  getContent: function getContent() {
    return _.escape(this.inputView.getText().trim());
  },
  setContent: function setContent(text) {
    this.inputView.setText(text);
    this.update();
  },
  viewWillUnRendered: function viewWillUnRendered() {
    _MMViewBase["default"].prototype.viewWillUnRendered.call(this);
    this.inputView && this.inputView.destroyAtWhoView();
    if (this._clickOutsideHandler) {
      $(this.editor.getAssistantCanvas()).off('click', this._clickOutsideHandler);
    }
    if (this.recognizer) {
      this.recognizer.destroy();
    }
    _MMCommonFun["default"].removeTextInputInEditor('newComment');
  },
  viewDidRendered: function viewDidRendered() {
    _MMViewBase["default"].prototype.viewDidRendered.call(this);
    var $window = $(window);
    // var parentWidth = parseInt($window.width());
    // var parentHeight = parseInt($window.height());
    var parentWidth = parseInt($(".p-editor-zone").width());
    var parentHeight = parseInt($(".p-editor-zone").height());
    var myWidth = parseInt(this.$container.width());
    var myHeight = parseInt(this.$container.height());
    var myLeft = this.v_pos.x;
    var myTop = this.v_pos.y;
    var leftInWin = myLeft;
    var topInWin = myTop;
    if (this.$el.parent().hasClass('page-cell')) {
      var tpos = _MMCommonFun["default"].convertPointBetweenElements(this.$el.parent()[0], $(".p-editor-zone")[0], this.v_pos);
      leftInWin = tpos.x;
      topInWin = tpos.y;
    }
    ;
    var color = g_keyColor;
    if (app.canDispInNormalBrowser()) {
      var pointPos = {
        upward: 'top',
        sideward: 'left'
      };

      // keeping the view in frame,
      if (leftInWin + myWidth > parentWidth) {
        myLeft -= myWidth;
        pointPos.sideward = 'right';
      }
      if (topInWin + myHeight > parentHeight) {
        myTop -= myHeight;
        pointPos.upward = 'bottom';
      }
      //prepare the commentCircle
      this._$circleParent = $('<div class="comment-pt cursor-move">');
      this._$circleParent.css(pointPos.upward, 0);
      this._$circleParent.css(pointPos.sideward, 0);
      this.setContent('');
    }
    this.$el.css({
      'left': myLeft,
      'top': myTop
    });
  },
  showWaiting: function showWaiting() {
    _MDSpinnerloaderView["default"].showIn(this.$el[0], {
      position: 'absolute'
    });
    this.sending = true;
  },
  removeWaitingShow: function removeWaitingShow() {
    _MDSpinnerloaderView["default"].clearFrom(this.$el[0]);
    this.sending = false;
  }
});
var _default = exports["default"] = MDNewCommentInputView;

},{"1005":1005,"1081":1081,"1184":1184,"1417":1417,"1454":1454,"1463":1463,"1466":1466,"1498":1498,"22":22,"317":317,"325":325,"331":331,"408":408,"65":65,"72":72,"76":76,"794":794,"795":795,"807":807,"811":811,"812":812,"820":820,"885":885,"940":940}],408:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDPopupView = _interopRequireDefault(require(64));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MMObject = _interopRequireDefault(require(1081));
var _MDPcMobileEditorCommonFun = _interopRequireDefault(require(807));
/**
 *  Menu for comment visible scopes choices
 *  Create by jiang
 *  2016.11.1
 */

var MDCommentVisibleScopeListView = _MDPopupView["default"].extend({
  contentTmpl: '<ul class="m-menu"></ul>',
  events: function events() {
    var superEvents = _MDPopupView["default"].prototype.events.call(this);
    return _.extend({}, superEvents, {
      'click li': this._menuItemClickHandler
    });
  },
  initProps: function initProps() {
    var superP = _MDPopupView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      scopeSelected: -1,
      $scopeList: null,
      scopeNameList: [],
      parentDiv: $('.app-root')[0],
      onSelectItem: _.noop
    });
  },
  initialize: function initialize(opt) {
    _MDPopupView["default"].prototype.initialize.call(this, opt);
    this.initScopeList();
  },
  initScopeList: function initScopeList() {
    var fileEditor = _MDPcMobileEditorCommonFun["default"].getMainEditor().getCurFileEditor();
    this.scopeNameList = _MMObject["default"].getScopeDispStrings();
    if (this.$scopeList) {
      this.$scopeList.remove();
    }
    var html = "";
    for (var i = 0; i < this.scopeNameList.length; i++) {
      var scopeName = this.scopeNameList[i];
      var tooltip = "";
      if (BabelStr.isRu()) {
        tooltip = "data-tooltip-dir=\"top\" data-tooltip=\"".concat(scopeName, "\"");
      }
      html += "<li " + tooltip + ">" + scopeName + "</li>";
    }
    ;
    this.$(".m-menu").append(html);
    this.$scopeList = $(html);
    this.title = this.scopeNameList[0];
  },
  _menuItemClickHandler: function _menuItemClickHandler($e) {
    var index = $($e.target).index();
    this.scopeSelected = -1;
    if (index < this.scopeNameList.length) {
      this.scopeSelected = index;
      this.title = this.scopeNameList[index];
    }
    ;
    _.isFunction(this.onSelectItem) && this.onSelectItem(this.scopeSelected);
    this.close();
  },
  getDispString: function getDispString() {
    return this.title;
  }
});
var _default = exports["default"] = MDCommentVisibleScopeListView;

},{"1081":1081,"1184":1184,"1454":1454,"64":64,"807":807,"812":812}],64:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1424);
require(1417);
require(1463);
var _MMViewBase = _interopRequireDefault(require(22));
var _MDFocusManager = _interopRequireDefault(require(44));
var _MDLayerManager = _interopRequireDefault(require(48));
var _popupPos = _interopRequireDefault(require(65));
var _keycode = _interopRequireDefault(require(104));
/**
 *  PopupView支持相对于浏览器窗口视口布局和相对于定位父元素布局
 *  注意: 触发popup显示的事件需要mousedown事件，请不要使用click事件
 *  Create by manjun.han
 *  2015.9.8
 */

var defaults = {
  asDropdown: false,
  triggerEvent: "mousedown",
  closeWhenWindowResize: false,
  autoCloseWhenClickOutside: true
};
var MDPopupView = _MMViewBase["default"].extend({
  className: function className() {
    var superCls = _MMViewBase["default"].prototype.className.call(this);
    return superCls + " m-popup";
  },
  tmpl: function tmpl() {
    var stringBuilder = [];
    var content = "";
    stringBuilder.push('<div class="content"><i class="popup-arrow"></i><div class="content-inner">');
    if (_.isFunction(this.contentTmpl)) {
      content = this.contentTmpl();
    } else {
      content = this.contentTmpl;
    }
    stringBuilder.push(content);
    stringBuilder.push("</div></div>");
    return stringBuilder.join("");
  },
  /**
   *
   * 内容模板
   * @type {string|function}
   */
  contentTmpl: "",
  initProps: function initProps() {
    var superE = _MMViewBase["default"].prototype.initProps.call(this);
    var props = {
      arrowHeight: 11,
      arrowWidth: 22,
      hasArrow: false,
      hasShadow: false,
      arrowClass: "",
      width: 300,
      height: "auto",
      animate: false,
      cls: "",
      autoCloseWhenClickOutside: true,
      closeWhenWindowResize: undefined,
      autoScroll: false,
      triggerView: null,
      alignmentView: null,
      onClose: null,
      onShow: null,
      gapX: 0,
      gapY: 4,
      offsetX: 0,
      offsetY: 0,
      direction: _popupPos["default"].BOTTOM,
      container: undefined,
      $triggerView: null,
      triggerEvent: undefined,
      enableESC: true,
      onlyHide: false // use hide to instead close
    };
    return _.extend(superE, props);
  },
  /**
   *
   * @param  {object} opt
   * @param {boolean} [opt.asDropdown=false] - 是否是以dropdown形式显示popup，选择true则会将popup添加到triggerView的父容器，
   *                                     或指定的container中
   * @param {numer} [opt.width=300] - popup的宽度
   * @param {number|string} [opt.height='auto'] - popup的高度，可以是height属性的任意合法值
   * @param {number} [opt.gapY=0] - 竖直方向上，相对于triggerView的额外边距
   * @param {number} [opt.gapX=4] - 水平方向上相对于triggerView的额外边距
   * @param {HTMLElement|string} opt.triggerView - popup的定位元素，如果为字符串，则是css的选择器
   * @param {HTMLElement|string} [opt.container] - 如果asDropdown=true，此参数可以设定包含popup的父元素
   * @param {boolean} [opt.closeWhenWindowResize=false] - 窗口resize后是否关闭popup
   * @param {boolean} [opt.autoCloseWhenClickOutside] - 点击在popup之外的位置是否自动关闭popup
   * @param {POPUP_POS | function} [opt.direction] - 定位方向,或返回定位方向的函数
   * @param {boolean} [opt.animate] - 是否以动画方式显示
   * @param {boolean} [opt.autoScroll] - 是否自定滚动
   * @param {string} [opt.triggerEvent] - 触发popup的事件
   * @param {boolean} [opt.hasArrow] - 是否右箭头
   *
   */
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.setDefaults(defaults);
    this.bindSelf(this._removeWhenClickOutside, this.layoutForPopup, this.layout, this.show, this.close, this._onKeyup);
    this.$arrow = this.$(".popup-arrow");
    if (this.enableESC) {
      $(document).on(this.$nsEventName("keyup"), this._onKeyup);
    }
    var layer = _MDLayerManager["default"].getLayer();
    this.$el.css("z-index", layer);
    if (this.cls) {
      this.$el.addClass(this.cls);
    }
  },
  show: function show(opt) {
    if (_.isFunction(this.beforeShow)) {
      if (!this.beforeShow()) {
        return;
      }
    }
    var self = this;
    _.extend(this, opt);
    this.$el.show();
    this.$triggerView = $(this.triggerView);
    this.$triggerView.data("popupView", this).addClass("with-popup");
    //
    // 这里的parentDiv只是暂时兼容editor的上的弹出面板，以后需要去掉
    //
    //
    var container = this.parentDiv || document.body;
    var direction = this.getLayoutPosition(this.direction);
    if (this.asDropdown) {
      if (_.isFunction(this.container)) {
        container = this.container(this.triggerView);
      } else if (this.container) {
        container = $(this.container);
      } else {
        container = $(this.triggerView).parent()[0];
      }
      this.$el.addClass("as-dropdown");
    }
    this.$el.css({
      width: this.width,
      height: this.height
    });
    this.renderTo(container);
    _MDFocusManager["default"].setFocus(this);
    if (this.asDropdown) {
      this.layoutForDropDown(direction);
      this.appendShadow(direction);
      _.isFunction(self.onShow) && self.onShow(self);
      self.$triggerView.data("popupOpened", true);
    } else {
      this.layoutForPopup();
      if (this.animate) {
        var aniCls = {
          top: "fadeUp",
          bottom: "fadeDown",
          left: "fadeLeft",
          right: "fadeRight"
        };
        this.$el.addClass(aniCls[direction]);
        this.el.offsetWidth;
        this.$el.addClass("ani");
        self.$el.addClass("in").transitionEndOnce(function () {
          _.isFunction(self.onShow) && self.onShow(self);
          self.$triggerView.data("popupOpened", true);
        });
      } else {
        _.isFunction(self.onShow) && self.onShow(self);
        self.$triggerView.data("popupOpened", true);
      }
    }
    if (this.hasShadow) {
      this.$el.addClass("shadow");
    }
  },
  /**
   * @private
   * @param  {jQuery.Event} $e
   * @return {void}
   */
  _onKeyup: function _onKeyup($e) {
    var key = $e.keyCode;
    if (!_MDFocusManager["default"].isFocused(this)) {
      return;
    }
    if (_keycode["default"].isEscKey(key) && !this.disableClose) {
      this.close();
    }
  },
  /**
   * private
   */
  layout: function layout() {
    var direction = this.getLayoutPosition(this.direction);
    if (this.asDropdown) {
      this.layoutForDropDown(direction);
    } else {
      this.layoutForPopup();
    }
  },
  /**
   * 作为dropdown进行布局，主要解决滚动视口不是body的问题，fixed布局依赖于body
   * @private
   */
  layoutForDropDown: function layoutForDropDown(direction) {
    var alignmentView = this.alignmentView || this.triggerView;
    var $alignmentView = $(alignmentView);
    var outHeight = $alignmentView.outerHeight();
    var outWidth = $alignmentView.outerWidth();
    var alignmentViewHeight = $alignmentView.outerHeight(true);
    var alignmentViewWidth = $alignmentView.outerWidth(true);
    var withDir = "with-bl";
    var D = _popupPos["default"];
    switch (this.direction) {
      case D.TOP_LEFT:
        withDir = "with-tl";
        break;
      case D.BOTTOM_LEFT:
        withDir = "with-bl";
        break;
      case D.TOP_RIGHT:
        withDir = "with-tr";
        break;
      case D.BOTTOM_RIGHT:
        withDir = "with-br";
        break;
      case D.LEFT_TOP:
        withDir = "with-lt";
        break;
      case D.LEFT_BOTTOM:
        withDir = "with-lb";
        break;
      case D.RIGHT_TOP:
        withDir = "with-rt";
        break;
      case D.RIGHT_BOTTOM:
        withDir = "with-rb";
        break;
    }
    this.$el.addClass(withDir);
    if (direction == "bottom") {
      this.$el.css("top", alignmentViewHeight + this.gapY);
    } else if (direction == "top") {
      this.$el.css("bottom", alignmentViewHeight + this.gapY);
    }
  },
  appendShadow: function appendShadow(dirStr) {
    if (dirStr === "top") {
      this.$el.addClass("vt");
    } else if (dirStr === "bottom") {
      this.$el.addClass("vb");
    } else {
      this.$el.addClass("vt");
    }
  },
  /**
   * @private
   * 执行定位
   */
  layoutForPopup: function layoutForPopup(isForResize) {
    var self = this;
    var D = _popupPos["default"];
    var $alignmentView = $(this.alignmentView || this.triggerView);
    var offset = $alignmentView.offset();
    var alignmentViewHeight = $alignmentView.outerHeight();
    var alignmentViewWidth = $alignmentView.outerWidth();

    // 获取视口坐标
    offset.top = offset.top - $(document).scrollTop();
    offset.left = offset.left - $(document).scrollLeft();
    var triggerCenterX = offset.left + alignmentViewWidth / 2.0;
    var triggerCenterY = offset.top + alignmentViewHeight / 2.0;
    this.el.offsetWidth;
    var width = this.$el.outerWidth();
    var height = this.$el.outerHeight();
    var biggerThanTrigger = width > alignmentViewWidth;
    var d = this.direction;
    var dirStr = this.getLayoutPosition(d);
    var hasArrow = this.hasArrow;
    var arrowWidth = this.arrowWidth;
    var arrowHeight = this.arrowHeight;
    var arrowLeft = "auto";
    var arrowTop = "auto";
    var arrowClass = "";
    var triggerWidthBigger = alignmentViewWidth > width;
    var triggerHeightBigger = alignmentViewHeight > height;
    var winHeight = $(window).height();
    var winWidth = $(window).width();
    var positionInfo = {
      dirStr: dirStr,
      triggerSize: {
        width: alignmentViewWidth,
        height: alignmentViewHeight
      },
      popupSize: {
        width: width,
        height: height
      },
      offset: {
        top: offset.top + this.offsetY,
        left: offset.left + this.offsetX
      },
      gap: {
        x: this.gapX,
        y: this.gapY
      },
      winSize: {
        height: winHeight,
        width: winWidth
      },
      arrowHeight: arrowHeight,
      hasArrow: hasArrow
    };
    var position = {};
    this._fixDir(positionInfo);
    dirStr = positionInfo.dirStr;
    position = positionInfo.position;
    this.$arrow.removeClass("top bottom left right");
    this.$el.removeClass("vt vb");
    if (dirStr == "bottom" || dirStr == "top") {
      // 设置左边距left, 横向不支持gap
      if (d === D.BOTTOM_LEFT || d === D.TOP_LEFT) {
        position.left = offset.left;
        //  + alignmentViewWidth;
      } else if (d === D.BOTTOM_RIGHT || d === D.TOP_RIGHT) {
        position.left = positionInfo.offset.left + alignmentViewWidth - width;
      } else {
        position.left = triggerCenterX - width / 2.0;
      }
      // 边界检测
      if (position.left < 0) {
        position.left = positionInfo.offset.left;
      } else if (position.left + width > winWidth) {
        position.left = positionInfo.offset.left + alignmentViewWidth - width;
      }
      if (hasArrow) {
        if (triggerWidthBigger) {
          if (d === D.BOTTOM_LEFT || d === D.TOP_LEFT) {
            arrowLeft = 0;
          } else if (d === D.BOTTOM_RIGHT || d === D.TOP_RIGHT) {
            arrowLeft = width - arrowWidth;
          } else {
            arrowLeft = (width - arrowWidth) / 2.0;
          }
        } else {
          arrowLeft = Math.max(0, triggerCenterX - position.left - arrowWidth / 2.0);
        }
        this.$arrow.css("left", arrowLeft);
      }
    } else {
      if (d === D.LEFT_TOP || d === D.RIGHT_TOP) {
        position.top = triggerHeightBigger ? offset.top : triggerCenterY - arrowWidth / 2.0;
      } else if (d === D.LEFT_BOTTOM || d === D.RIGHT_BOTTOM) {
        position.top = triggerHeightBigger ? offset.top + alignmentViewHeight - height : triggerCenterY - (height - arrowWidth / 2.0) + this.gapY;
      } else {
        position.top = triggerCenterY - height / 2.0 + this.gapY;
      }

      // 边界检测
      if (d != D.LEFT_TOP && d != D.RIGHT_TOP) {
        //顶部对齐的不应再检测top
        if (position.top < 0) {
          position.top = offset.top;
        } else if (position.top + height > winHeight) {
          position.top = offset.top + alignmentViewHeight - height;
        }
      }
      if (hasArrow) {
        if (triggerHeightBigger) {
          if (d === D.LEFT_TOP || d === D.RIGHT_TOP) {
            arrowTop = 0;
          } else if (d === D.LEFT_BOTTOM || d === D.RIGHT_BOTTOM) {
            arrowTop = height - arrowWidth;
          } else {
            arrowTop = (height - arrowWidth) / 2.0;
          }
        } else {
          arrowTop = Math.max(0, triggerCenterY - position.top - arrowWidth / 2.0);
        }
        this.$arrow.css("top", arrowTop);
      }
    }
    if (hasArrow) {
      this.$arrow.addClass(positionInfo.arrowClass);
      this.$arrow.addClass(this.arrowClass);
    }
    if (this.autoScroll) {
      var maxHeight = $(window).height() - position.top - 20;
      self.$(".content-inner").css({
        "max-height": maxHeight,
        "overflow-y": "auto"
      });
    }
    self.$el.css(position);
    this.appendShadow(dirStr);
    _.isFunction(this.onAfterLayout) && this.onAfterLayout();
  },
  getLayoutPosition: function getLayoutPosition(direction) {
    direction = _.isFunction(direction) ? direction() : direction;
    var D = _popupPos["default"];
    switch (direction) {
      case D.TOP:
      case D.TOP_LEFT:
      case D.TOP_RIGHT:
        return "top";
      case D.BOTTOM:
      case D.BOTTOM_LEFT:
      case D.BOTTOM_RIGHT:
        return "bottom";
      case D.LEFT:
      case D.LEFT_TOP:
      case D.LEFT_BOTTOM:
        return "left";
      case D.RIGHT:
      case D.RIGHT_TOP:
      case D.RIGHT_BOTTOM:
        return "right";
    }
  },
  /**
   * @private
   * 相对于窗口视口边界检测，阻止Popup弹窗溢出窗口,前提是使用position:fixed布局
   */
  _fixDir: function _fixDir(positionInfo) {
    var dirStr = positionInfo.dirStr;
    var triggerSize = positionInfo.triggerSize;
    var popupSize = positionInfo.popupSize;
    var offset = positionInfo.offset;
    var gap = positionInfo.gap;
    var arrowHeight = positionInfo.arrowHeight;
    var hasArrow = positionInfo.hasArrow;
    var winHeight = positionInfo.winSize.height;
    var winWidth = positionInfo.winSize.width;
    var position = {};
    var lengthTop = 0;
    var lengthBottom = 0;
    var lengthLeft = 0;
    var lengthRight = 0;
    var height = 0;
    var width = 0;
    if (dirStr == "top" || dirStr == "bottom") {
      this.$el.height(this.height);
    } else {
      this.$el.width(this.width);
    }
    this.el.offsetWidth;
    popupSize.width = this.$el.width();
    popupSize.height = this.$el.height();
    lengthTop = offset.top - gap.y;
    if (hasArrow) {
      lengthTop -= arrowHeight;
    }
    lengthLeft = offset.left - gap.x;
    if (hasArrow) {
      lengthLeft -= arrowHeight;
    }
    // 设置顶部top
    switch (dirStr) {
      case "bottom":
        position.top = offset.top + triggerSize.height + gap.y;
        if (hasArrow) {
          position.top += arrowHeight;
        }
        if (position.top + popupSize.height >= winHeight) {
          lengthBottom = winHeight - position.top;
          if (lengthBottom < lengthTop) {
            dirStr = "top";
            position.top = lengthTop - popupSize.height;
          }
        }
        break;
      case "top":
        position.top = offset.top - gap.y - popupSize.height;
        if (hasArrow) {
          position.top -= arrowHeight;
        }
        if (position.top <= 0) {
          lengthBottom = winHeight - offset.top - triggerSize.height - gap.y;
          if (hasArrow) {
            lengthBottom -= arrowHeight;
          }
          if (lengthTop < lengthBottom) {
            dirStr = "bottom";
            position.top = offset.top + gap.y + triggerSize.height;
            if (hasArrow) {
              position.top += arrowHeight;
            }
          }
        }
        break;
      case "left":
        position.left = offset.left - gap.x - popupSize.width;
        if (hasArrow) {
          position.left -= arrowHeight;
        }
        if (position.left <= 0) {
          lengthRight = winWidth - offset.left - triggerSize.width - gap.x;
          if (hasArrow) {
            lengthRight -= arrowHeight;
          }
          if (lengthLeft < lengthRight) {
            dirStr = "right";
            position.left = offset.left + gap.x + triggerSize.width;
            if (hasArrow) {
              position.left += arrowHeight;
            }
          }
        }
        break;
      case "right":
        position.left = offset.left + triggerSize.width + gap.x;
        hasArrow && (position.left += arrowHeight);
        if (position.left + popupSize.width >= winWidth) {
          lengthRight = winWidth - position.left;
          if (lengthLeft > lengthRight) {
            dirStr = "left";
            position.left = lengthLeft - popupSize.width;
          }
        }
    }
    positionInfo.position = position;
    positionInfo.dirStr = dirStr;
    var arrowClassDirMap = {
      top: "bottom",
      left: "right"
    };
    _.extend(arrowClassDirMap, _.invert(arrowClassDirMap));
    positionInfo.arrowClass = arrowClassDirMap[dirStr];
    switch (dirStr) {
      case "bottom":
        if (position.top + this.$el.height() >= winHeight) {
          height = lengthBottom - 10;
        } else {
          height = "auto";
        }
        break;
      case "top":
        if (position.top < 0) {
          position.top = 10;
          height = lengthTop - 10;
        } else {
          height = "auto";
        }
        break;
      case "right":
        if (position.left + this.$el.width() >= winWidth) {
          width = lengthRight - 10;
        } else {
          width = this.width;
        }
        break;
      case "left":
        if (position.left < 0) {
          position.left = 10;
          width = lengthLeft - 10;
        } else {
          width = this.width;
        }
        break;
    }
    if (dirStr == "top" || dirStr == "bottom") {
      this.$el.height(height);
    } else {
      this.$el.width(width);
    }
    return dirStr;
  },
  _removeWhenClickOutside: function _removeWhenClickOutside($e) {
    var clickedDOM = $e.target;
    if (!$.contains(this.el, clickedDOM) && !$.contains(this.$triggerView[0], clickedDOM) && this.$triggerView[0] !== clickedDOM) {
      return this.close();
    }
  },
  /**
   * @public
   */
  close: function close() {
    if (this.onlyHide) {
      this.$el.addClass("f-hide");
    } else {
      var self = this;
      if (this.animate) {
        this.$el.transitionEnd(function () {
          self._clearMemory();
        }).removeClass("in");
      } else {
        this._clearMemory();
      }
    }
  },
  showEl: function showEl() {
    this.$el.removeClass("f-hide");
  },
  isElHide: function isElHide() {
    return this.$el.hasClass("f-hide");
  },
  _clearMemory: function _clearMemory() {
    this.remove();
  },
  _removeEvents: function _removeEvents() {
    if (_.isFunction(this.onClose)) {
      this.onClose(this);
      this.onClose = null; // remove cycle reference
    }
  },
  remove: function remove(params) {
    _MMViewBase["default"].prototype.remove.call(this, params);
    this._removeEvents();
  },
  /**
   * protected
   * @return {void}
   */
  viewWillUnRendered: function viewWillUnRendered() {
    _MDFocusManager["default"].removeFocus(this);
    _MDLayerManager["default"].releaseLayer();
    this.$triggerView.data("popupOpened", false);
    this.$triggerView.removeData("popupView").removeClass("with-popup");
    _MMViewBase["default"].prototype.viewWillUnRendered.call(this);
    if (this.outsideArea) {
      this.outsideArea.removeEventListener("mousedown", this._removeWhenClickOutside, true);
    } else if (this.autoCloseWhenClickOutside) {
      $("body")[0].removeEventListener("mousedown", this._removeWhenClickOutside, true);
    }
    $(window).off(this.$nsEventName("resize"));
  },
  /**
   * @protected
   * @return {void}
   */
  viewDidRendered: function viewDidRendered() {
    _MMViewBase["default"].prototype.viewDidRendered.call(this);
    var self = this;
    if (this.autoCloseWhenClickOutside) {
      _.delay(function () {
        // 使用捕获阶段去掉popup，解决popup需要顺序操作的问题
        if (self.outsideArea) {
          self.outsideArea.addEventListener("mousedown", self._removeWhenClickOutside, true);
        } else if (self.autoCloseWhenClickOutside) {
          $("body")[0].addEventListener("mousedown", self._removeWhenClickOutside, true);
        }
      }, 1);
    }
    if (this.closeWhenWindowResize) {
      _.delay(function () {
        $(window).on(self.$nsEventName("resize"), self._removeWhenClickOutside);
      }, 1);
    } else {
      $(window).on(self.$nsEventName("resize"), self.layout);
    }
  },
  addSubView: function addSubView(subView, opt_parent, opt_slot) {
    opt_parent = opt_parent || this.$(".content-inner");
    _MMViewBase["default"].prototype.addSubView.call(this, subView, opt_parent, opt_slot);
  },
  addSubViewAt: function addSubViewAt(subView, index, opt_parent, opt_slot) {
    opt_parent = opt_parent || this.$(".content-inner");
    _MMViewBase["default"].prototype.addSubViewAt.call(this, subView, index, opt_parent, opt_slot);
  }
}, {
  className: "MDPopupView",
  /**
   * @static
   * @param {object} options - 参见MDPopupView的initialize方法的参数说明
   * @return {void}
   */
  createPopup: function createPopup(options) {
    var constructor = this.prototype.constructor;
    var triggerEvent = options.triggerEvent || defaults.triggerEvent;
    var $triggerView = $(options.triggerView);
    $triggerView.data("popupView", null);
    $triggerView.off(".popupView");
    if (triggerEvent == "mousedown") {
      $triggerView.on("mousedown.popupView", function ($e) {
        // 去掉鼠标右键
        if ($e.which == 3) {
          return;
        }
        togglePopup.call(this, constructor, options);
      });
    } else {
      $triggerView.on("mouseenter.popupView mouseleave.popupView", function () {
        togglePopup.call(this, constructor, options);
      });
    }
    if (options.immediatelyShow) {
      togglePopup.call(this, constructor, options);
    }
  },
  /**
   * 代理dom来创建popup
   * @static
   * @param  {stirng|HTMLElement} selector - css选择器,或dom对象
   * @param  {string|HTMLElement} container  - 父容器的选择器或dom对象
   * @param  {object} options - popup选项，参见initialize说明
   * @return {void}
   */
  delegateCreate: function delegateCreate(selector, container, options) {
    var triggerEvent = options.triggerEvent || defaults.triggerEvent;
    var eventName = triggerEvent + ".popupview";
    if (triggerEvent == "hover") {
      eventName = "mouseenter.popupview mouseleave.popupview";
    }
    var constructor = this.prototype.constructor;
    $(container).off(eventName, selector).on(eventName, selector, function ($e) {
      if (triggerEvent == "mousedown" && $e.which == 3) {
        return;
      }
      options.triggerView = this;
      togglePopup.call(this, constructor, options);
    });
  },
  /**
   * 取消代理创建popup
   * @static
   * @param  {string|HTMLElement} container  - 父容器的选择器或dom对象
   * @return {void}
   */
  unDelegateCreate: function unDelegateCreate(container) {
    $(container).off(".popupview");
    $(container).find(".with-popup").each(function () {
      var popupView = $(this).data("popupView");
      popupView.close();
    });
  },
  /**
   * @static
   * @param  {[type]} triggerView [description]
   * @return {void}
   */
  removePopup: function removePopup(triggerView) {
    var popupView = $(triggerView).data("popupView");
    popupView && popupView.close();
  }
});
/**
 * popup 的触发函数
 * @param  {constructor} constructor - popup的constructor
 * @param  {object} options - popup的选项
 * @return {void}
 */
function togglePopup(constructor, options) {
  var $triggerView = $(this);
  var disabled = $triggerView.hasClass("disabled") || $triggerView.prop("disabled");
  var popupOpened = $(this).data("popupOpened");
  var popupView = $(this).data("popupView");
  if (disabled) {
    return;
  }
  if (popupOpened) {
    if (popupView) {
      if (popupView.isElHide()) {
        popupView.showEl();
      } else {
        popupView.close();
      }
    }
  } else {
    popupView = new constructor(options);
    popupView.show();
  }
}
var _default = exports["default"] = MDPopupView;

},{"104":104,"1184":1184,"1417":1417,"1424":1424,"1454":1454,"1463":1463,"22":22,"44":44,"48":48,"65":65}],331:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1498);
require(1421);
require(1426);
require(1439);
require(1417);
require(1463);
var _MMViewBase = _interopRequireDefault(require(22));
var _app = _interopRequireDefault(require(17));
var _regexp = _interopRequireDefault(require(106));
var _MDAtWhoView = _interopRequireDefault(require(35));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MMSketchCommentController = _interopRequireDefault(require(885));
/**
 *  任务版页面
 *
 *  Create by manjun.han
 *  2014.12.30
 */

var MDMessageInputAreaView = _MMViewBase["default"].extend({
  tmpl: '<textarea placeholder="发送消息"></textarea>',
  className: function className() {
    var superCls = _MMViewBase["default"].prototype.className.call(this);
    return superCls + ' m-input';
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      'focus textarea': this._textAreaFocusEventHandler,
      'blur textarea': this._textAreaBlurEventHandler,
      'keyup textarea': this._textAreaKeyupEventHandler,
      'input textarea': this._textAreaInputEventHandler
    });
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      parent: null,
      $textfield: null,
      rows: 3,
      onBlur: _.noop,
      onFocus: _.noop,
      onInputChange: _.noop,
      onEnterSend: _.noop,
      placeholder: BabelStr.str(326) + "",
      // '发送消息',

      atObj: {},
      enterSubmit: false,
      disableEnterSubmit: false
    });
  },
  initialize: function initialize(options) {
    var self = this;
    _MMViewBase["default"].prototype.initialize.call(this, options);
    this.$textfield = this.$('textarea');
    this.$textfield.attr("placeholder", this.placeholder);
    this.$textfield.attr('rows', this.rows);
    if (this.disabled) {
      this.$('textarea').prop('disabled', true);
      if (_app["default"].currentUser.logined()) {
        this.$('textarea').text(BabelStr.str(7107));
      } else {
        this.$('textarea').text(BabelStr.str(7108));
      }
    }
    this.bindSelf(this._textAreaKeydownEventHandler);
    this.$textfield.on({
      'keydown': self._textAreaKeydownEventHandler
    });
  },
  _textAreaInputEventHandler: function _textAreaInputEventHandler() {
    var text = this.$textfield.val();
    text = text || "";
    text = text.trim();
    this.onInputChange(text);
  },
  _textAreaKeydownEventHandler: function _textAreaKeydownEventHandler(e) {
    var self = this;
    var message;
    if (e.keyCode == 13 && !this.disableEnterSubmit && !e.shiftKey && !e.altKey && this.enterSubmit) {
      message = self.$textfield[0].value.trim();
      message = _.escape(message);
      if (message.length > 0 || _MMSketchCommentController["default"].getAllObjects().length) {
        if (_.isFunction(this.onEnterSend)) {
          var atIds = this.getAtIds();
          this.onEnterSend(message, atIds);
          this.$textfield.val('');
          this.atObj = {};
        }
      }
      return false; // 阻止默认的换行
    }
  },
  _textAreaKeyupEventHandler: function _textAreaKeyupEventHandler(e) {
    var self = this;
    var message = self.$textfield[0].value.trim();
    if (e.keyCode == 8) {
      _.each(this.atObj, function (value, key) {
        if (message.indexOf(key) === -1) {
          delete self.atObj[key];
        }
      });
    }
  },
  _textAreaFocusEventHandler: function _textAreaFocusEventHandler(e) {
    var self = this;
    if (_.isFunction(this.onFocus)) {
      this.onFocus();
    }
  },
  _textAreaBlurEventHandler: function _textAreaBlurEventHandler(e) {
    var self = this;
    if (_.isFunction(this.onBlur)) {
      this.onBlur();
    }
  },
  setFocus: function setFocus() {
    this.$textfield[0].focus();
  },
  blur: function blur() {
    this.$textfield[0].blur();
  },
  getText: function getText() {
    return this.$textfield[0].value.trim();
  },
  getAtIds: function getAtIds() {
    var atIds = [];
    _.each(this.atObj, function (id, name) {
      if (id === 'All') {
        atIds = 'All';
        return;
      }
      atIds.push(id);
    });
    return atIds;
  },
  setText: function setText(text) {
    if (this.$textfield[0].value == text) {
      return;
    }
    this.$textfield[0].value = text;
    this.onInputChange(text);
    return this;
  },
  setAtObjEmpty: function setAtObjEmpty() {
    this.atObj = {};
  },
  destroyAtWhoView: function destroyAtWhoView() {
    this.atwhoView && this.atwhoView.destroySelf();
  },
  viewDidRendered: function viewDidRendered() {
    _MMViewBase["default"].prototype.viewDidRendered.call(this);
    var self = this;
    var board = this.editorViewCtl.getCurrentBoard();
    var fileId = board.fileInfo.getFileId();
    if (_app["default"].canDispInNormalBrowser()) {
      _MMNetDiskDataController["default"].getAtTargetUserList(fileId, function (userInfos) {
        var userList = _.map(userInfos, function (userInfo) {
          var account = userInfo['email'];
          if (!_regexp["default"].isEmail(account)) {
            account = userInfo['phone'];
            if (!account) {
              account = "--";
            }
          }
          return {
            id: userInfo['id'],
            name: userInfo['name'],
            email: account,
            url: _app["default"].getAvatarImageURL(userInfo['id'])
          };
        });
        userList.unshift({
          id: 'All',
          name: BabelStr.str(253)
        });
        self.atwhoView = new _MDAtWhoView["default"]({
          triggerBlock: self.$textfield,
          at: "@",
          data: userList,
          insertTpl: '@<%= name %>',
          displayTpl: '<% if(id != "All") {%>' + '<li data-id="<%= id %>">' + '<img src="<%= url %>">' + '<div class="member-info"><div class="name"><%= name %></div>' + '<div class="email"><%= email %></div></div>' + '</li>' + '<% } else { %>' + '<li class="at-all" data-id="<%= id %>">' + BabelStr.str(253) + '</li>' + '<% } %>',
          displayTimeout: 1000
        });
        self.$textfield.on('inserted.atwho', function (evt, li) {
          var id = li.attr('data-id');
          var name = '@' + li.find('div.name').text();
          if (!self.atObj[name]) {
            self.atObj[name] = id;
          }
        });
        self.$textfield.on('shown.atwho', function (evt) {
          self.disableEnterSubmit = true;
        });
        self.$textfield.on('hidden.atwho', function (evt) {
          self.disableEnterSubmit = false;
        });
      }, function () {});
    }
  },
  viewWillUnRendered: function viewWillUnRendered() {
    _MMViewBase["default"].prototype.viewWillUnRendered.call(this);
    this.destroyAtWhoView();
  }
});
var _default = exports["default"] = MDMessageInputAreaView;

},{"106":106,"1104":1104,"1184":1184,"1417":1417,"1421":1421,"1426":1426,"1439":1439,"1454":1454,"1463":1463,"1498":1498,"17":17,"22":22,"35":35,"885":885}],885:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
require(1432);
require(1461);
require(1418);
require(1537);
require(1477);
require(1492);
var _MDMessageType = _interopRequireDefault(require(271));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MMColor = _interopRequireDefault(require(794));
var _MMRect = _interopRequireDefault(require(831));
var _MMCommentObj = _interopRequireDefault(require(1005));
var _OBJ_ID = _interopRequireDefault(require(818));
var _MMFillType = _interopRequireDefault(require(795));
var _MMObject = _interopRequireDefault(require(1081));
var _map = _interopRequireDefault(require(821));
var _MMInsertAction = _interopRequireDefault(require(975));
var _objectArray = [];
var _curWhiteboard = null;
var _commentTempId = 1;
var MMSketchCommentController = {
  __checkValidity: function __checkValidity() {
    var mainEditor = MDPcMobileEditorCommonFun.getMainEditor();
    var newCurrentBoard = mainEditor && mainEditor.getCurrentBoard();
    if (newCurrentBoard != _curWhiteboard) {
      _curWhiteboard = newCurrentBoard;
      _objectArray = [];
    }
  },
  addObject: function addObject(object_) {
    MMSketchCommentController.__checkValidity();
    if (object_ instanceof _MMObject["default"]) {
      _objectArray.push(object_);
    } else {
      console.assert(object_ instanceof _OBJ_ID["default"]);
      var _object = _curWhiteboard.getObject(object_);
      if (_object) _objectArray.push(_object);
    }
  },
  removeObject: function removeObject(objId_) {
    for (var i = 0; i < _objectArray.length; i++) {
      var _id = _objectArray[i].getId();
      if (_id.toString() == objId_.toString()) {
        _objectArray.splice(i, 1);
        return;
      }
    }
  },
  getLayer: function getLayer(objId_) {
    for (var i = 0; i < _objectArray.length; i++) {
      var _id = _objectArray[i].getId();
      if (_id.toString() == objId_.toString()) {
        return -1 - i;
      }
    }
  },
  objectContained: function objectContained(object_) {
    for (var i = 0; i < _objectArray.length; i++) {
      if (object_ == _objectArray[i]) return true;
    }
    return false;
  },
  clearAllObjects: function clearAllObjects() {
    _objectArray = [];
  },
  enterSketch: function enterSketch() {
    if (_curWhiteboard) {
      _curWhiteboard.clearActionStacks();
    }
  },
  getAllObjects: function getAllObjects() {
    MMSketchCommentController.__checkValidity();
    return _objectArray;
  },
  hasMarks: function hasMarks(objects_) {
    MMSketchCommentController.__checkValidity();
    return _objectArray.length > 0 ? true : false;
  },
  setAllObjects: function setAllObjects(objects_) {
    _objectArray = [];
    for (var i = 0; i < objects_.length; i++) {
      _objectArray.push(objects_[i]);
    }
  },
  sendSketchComment: function sendSketchComment(text_, comment_, ver) {
    if (comment_ instanceof _MMCommentObj["default"] || !comment_) {
      MMSketchCommentController.sendSketch(text_, comment_);
    } else {
      console.assert(comment_.page != undefined && comment_.position != undefined);
      var curDispVer = ver;
      var _comment = new _MMCommentObj["default"](_curWhiteboard, curDispVer);
      _comment.setPageIndex(comment_.page);
      _comment.setPos(comment_.position); // 先设置属性，再进入 undo
      var filltype = new _MMFillType["default"]();
      ;
      filltype.setFill(true);
      var color = new _MMColor["default"]();
      color.m_r = 1;
      color.m_g = 0;
      color.m_b = 0;
      color.m_alpha = 1;
      filltype.setFillColor(color);
      _comment.setFillType(filltype);
      var creatorId = app.currentUser.getUserId_Int();
      _comment.setRead(creatorId);
      _comment.setCreator(creatorId);
      var option = {
        toUndo: true,
        realtime: true,
        isMark_: false
      };
      _curWhiteboard.addObject(_comment, option, function () {
        MMSketchCommentController.sendSketch(text_, _comment);
      });
    }
  },
  /**
   *
   * @typedef {object} messageInfo
   * @property {string} messageInfo.fileName - 文件名称
   * @property {number} messageInfo.fileSize - 文件大小 (B)
   * @property {number} messageInfo.fileRefId - 文件上传成功后的引用id
   * @property {fileId} messageInfo.fileId - 包含此文件的fileInfo的id
   */
  /**
   *
   * @param  {messageInfo} messageInfo  - 文件描述
   * @param  {number} visibleScope  - 可见范围
   * @param  {[type]} comment  - 批注
   * @param  {function} onSuccess
   * @param  {function} onFail
   */
  sendFile: function sendFile(messageInfo, visibleScope, comment, onSuccess, onFail) {
    messageInfo = messageInfo || {};
    var message = JSON.stringify({
      'Type': 'File',
      'visibleScope': visibleScope,
      'Body': JSON.stringify(messageInfo),
      'atIds': [],
      'curScale': comment.curScale,
      'centerPos': JSON.stringify(comment.centerPos)
    });
    var atIds = [];
    MMSketchCommentController.sendSketch(message, atIds, visibleScope, comment, onSuccess, onFail);
  },
  // send comment chat message
  sendMessage: function sendMessage(message, comment, param, onSuccess) {
    var tempId = _commentTempId++;
    var chatMessage = _curWhiteboard.sendMessage(message, comment ? comment.getId() : undefined, param, function (error, messageId) {
      if (!error) {
        Dispatcher.trigger(MDEvents.ChatMessageSendSuccess, _MDMessageType["default"].COMMENT_CHAT, tempId, messageId);
      } else {
        Dispatcher.trigger(MDEvents.ChatMessageSendFailed, _MDMessageType["default"].COMMENT_CHAT, tempId);
      }
    });
    if (_.isFunction(onSuccess)) {
      onSuccess();
    }
    chatMessage['tempId'] = tempId;
    var payload = {
      message: chatMessage,
      comment: comment,
      sender: app.currentUser.getUserId(),
      tempId: tempId
    };
    Dispatcher.trigger(MDEvents.NEW_MESSAGE, payload);
  },
  sendText: function sendText(text, atIds, visibleScope, comment, onSuccess, onFail) {
    var message = JSON.stringify({
      'Type': 'Text',
      'visibleScope': visibleScope,
      'Body': text,
      'atIds': atIds,
      'curScale': comment.curScale,
      'centerPos': JSON.stringify(comment.centerPos)
    });
    MMSketchCommentController.sendSketch(message, atIds, visibleScope, comment, onSuccess, onFail);
  },
  sendSketch: function sendSketch(message, atIds, visibleScope, comment, onSuccess, onFail) {
    if (!message) {
      return;
    }
    message = message || {
      'text': ''
    };
    MMSketchCommentController.__checkValidity();
    var hasSketch = _objectArray.length > 0;
    var payload = {};
    //
    // send pure text
    //
    var msgObj = JSON.parse(message);
    var type = msgObj.Type;
    if (!hasSketch || type == "File") {
      var parameters = {
        visibleScope: visibleScope,
        clientUsers: []
      };
      if (visibleScope) {
        var curBoard = MDPcMobileEditorCommonFun.getMainEditor().getCurrentBoard();
        if (!curBoard || !curBoard.fileInfo) {
          console.error('---- 当前没有打开的文件');
        }
        ;
        var fileId = curBoard.fileInfo.getFileId();
        _MMNetDiskDataController["default"].getShareParticipants(fileId, function (usersArr) {
          var clientUserIds = [];
          usersArr.forEach(function (user) {
            if (user.isEnterpriseGuest()) {
              clientUserIds.push(user.getUserId_Int());
            }
            ;
          });
          parameters.clientUsers = clientUserIds;
          MMSketchCommentController.sendMessage(message, comment, parameters, onSuccess);
        }, function () {
          _.isFunction(onFail) && onFail();
        });
      } else {
        MMSketchCommentController.sendMessage(message, comment, parameters, onSuccess);
      }
      return;
    }
    var _layerObjects = new _map["default"]();
    for (var i = _objectArray.length - 1, len = _objectArray.length; i >= 0; i--) {
      _layerObjects.set(-1 - i, _objectArray[i]);
    }
    var iInfo = new _MMInsertAction["default"](_layerObjects);
    iInfo.onSuccess = function () {
      console.log('================succeed================');
      var _strObjIds = [];
      var _objects = MMSketchCommentController.getAllObjects();
      var _lgRect = new _MMRect["default"](0, 0, 0, 0); //MMLgRect
      for (var i = 0; i < _objectArray.length; i++) {
        var _object = _objectArray[i];
        var _objId = _object.getId();
        var _strObjId = _objId.toString();
        _strObjIds.push(_strObjId);
        var _rect = _object.getExpandRect();
        if (i == 0) {
          _lgRect = _rect;
        } else {
          _lgRect.expandToInclude(_rect);
        }
      }
      _curWhiteboard.clearActionStacks();
      var marker = MMSketchCommentController.imgMarkerCtl.getSingleInstance();
      //I comment the thumbnail logic temporarily, when you uncomment it, please consider a bug that might happen: In firefox, when the thumbnail failed to generate, the callback will not
      //happen. Please pay attention about this.
      //marker.createScribbleThumbnail(function (img) {

      MMSketchCommentController.clearAllObjects();
      marker.interupted = true;
      var __sendMessage = function __sendMessage(filename_) {
        var tempId = _commentTempId++;
        message = JSON.parse(message);
        var text = message['Body'] || "";
        var _imageObjId = marker.mmImg.getId();
        _imageObjId = _imageObjId.toString();
        var payload = null;
        var _thumbUrl = filename_ ? _curWhiteboard.getRemoteDURL(filename_) : "";
        var newMessageItem = _curWhiteboard.sendMessage(JSON.stringify({
          'Type': 'Mark',
          'visibleScope': visibleScope,
          'ObjIds': _strObjIds,
          'Url': _thumbUrl,
          'Text': text,
          'ImageId': _imageObjId,
          'curScale': comment.curScale,
          'centerPos': JSON.stringify(comment.centerPos)
        }), comment ? comment.getId() : undefined, function (error, messageId) {
          if (!error) {
            Dispatcher.trigger(MDEvents.ChatMessageSendSuccess, _MDMessageType["default"].COMMENT_CHAT, tempId, messageId);
          } else {
            Dispatcher.trigger(MDEvents.ChatMessageSendFailed, _MDMessageType["default"].COMMENT_CHAT, tempId);
          }
        });
        newMessageItem['tempId'] = tempId;
        payload = {
          comment: comment,
          sender: app.currentUser.getUserId(),
          message: newMessageItem,
          tempId: tempId
        };
        if (_.isFunction(onSuccess)) {
          onSuccess();
        }
        Dispatcher.trigger(MDEvents.NEW_MESSAGE, payload);
        Dispatcher.trigger(MDEvents.Comment_changed);
      };
      __sendMessage();
    };
    iInfo.onFail = function () {
      console.log('================failed================');
      console.assert(false);
      if (_.isFunction(onFail)) {
        onFail();
      }
    };
    console.log('================sendScribble notify================');
    _curWhiteboard.notify(iInfo, true);
  },
  getSketchHTML: function getSketchHTML(msg_) {
    var _strObjs = msg_['ObjIds'];
    var _markThumb = msg_['Url'];
    _markThumb = '/img/marker.png';
    MMSketchCommentController.__checkValidity();
    var _text = msg_['Text'];
    if (!_text || _text.length == 0) {
      _text = BabelStr.str(5153);
    }
    _text = _.escape(_text).replace(/\n/g, "<br>");
    var tmpl = "<div class=\"mark-schetch \">\n                  <span>".concat(_text, "</span>\n                  <span class=\"mark-placehilder f-pointer\"></span>\n                </div>");
    var messageDisplay = $(tmpl);
    messageDisplay.on('click', '.mark-placehilder', function () {
      var _objects = [];
      for (var i = 0; i < _strObjs.length; i++) {
        var _objId = new _OBJ_ID["default"]();
        _objId.fromString(_strObjs[i]);
        _objects.push(_curWhiteboard.getObject(_objId));
      }
      var _imageId = new _OBJ_ID["default"]();
      _imageId.fromString(msg_['ImageId']);
      var _imageObj = _curWhiteboard.getObject(_imageId);
      var _marker = MMSketchCommentController.imgMarkerCtl.getSingleInstance();
      var swfEditor = false;
      var mainEditor = MDPcMobileEditorCommonFun.getMainEditor();
      var param = {
        swfEditor: mainEditor.isSwfEditor(),
        editorViewCtl: mainEditor
      };
      _marker.displayToReadOnly(_imageObj, _objects, param, function () {}, _text);
    });
    return messageDisplay;
  }
};
var _default = exports["default"] = MMSketchCommentController;

},{"1005":1005,"1081":1081,"1104":1104,"1184":1184,"1418":1418,"1432":1432,"1437":1437,"1454":1454,"1461":1461,"1463":1463,"1477":1477,"1478":1478,"1492":1492,"1537":1537,"271":271,"794":794,"795":795,"812":812,"818":818,"821":821,"831":831,"975":975}],975:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1418);
require(1463);
require(1537);
var _MMAction = _interopRequireDefault(require(963));
var _ACTION_TYPE = _interopRequireDefault(require(1076));
var _Encoder = _interopRequireDefault(require(800));
var _MMDeleteAction = _interopRequireDefault(require(972));
var _MMSketchCommentController = _interopRequireDefault(require(885));
var _MMInsertInfo = _interopRequireDefault(require(976));
var _MMUndoInfo = _interopRequireDefault(require(992));
function MMInsertAction(Objs_, isMark_) {
  _MMAction["default"].call(this);
  console.assert(Objs_);
  this.m_type = _ACTION_TYPE["default"].INSERT;
  this.m_dataImage = this.__CreateDataImg(Objs_);
  this.m_objects = Objs_;
  this.m_isMark = isMark_;
}
;
MMInsertAction.prototype = new _MMAction["default"]();
MMInsertAction.superclass = _MMAction["default"].prototype;
MMInsertAction.prototype.__CreateDataImg = function (objs_) {
  var _enc = new _Encoder["default"]();
  var _ver = _enc.encode4Bytes(___MM_DOC_VERSION__);
  _enc.encodeMap(objs_, '4Bytes', 'Meta');
  var arrayObjects = objs_.getValues();
  for (var i = 0; i < arrayObjects.length; i++) {
    var _object = arrayObjects[i];
    if (!_object.getIncludeData()) {
      var _objData = _object.getObjData();
      _objData.encode(_enc);
    }
  }
  return _enc.getStream();
};
MMInsertAction.prototype.getClassName = function () {
  return 'MMInsertAction';
};

/**
 *
 * @param whiteboard_
 * @param active_  {bool}
 */
MMInsertAction.prototype.execute = function (whiteboard_, active_) {
  /*
   */

  console.log("execute MMInsertAction");
  this.m_objsRect = new Array(); //清除原来的

  var arrayObjects = this.m_objects.getValues(); //MMObject
  for (var i = 0; i < arrayObjects.length; i++) {
    var _obj = arrayObjects[i];
    this.m_objsRect.push(_obj.getExpandRect());
  }
  var _layer = whiteboard_.addObjectFromMap(this.m_objects); // map<__int32_t, OBJ_ID>

  var arrayId = _layer.getValues(); //Array<OBJ_ID>
  for (var i = 0; i < arrayId.length; i++) {
    var _objId = arrayId[i];
    this.m_ids.push(_objId);
    if (this.m_isMark) {
      if (_MMSketchCommentController["default"]) {
        _MMSketchCommentController["default"].addObject(_objId);
      }
    }
  }
  this.m_collabIds = whiteboard_.getCollabIds(this.m_ids);
};
MMInsertAction.prototype.postExecuteA = function (whiteboard_) {
  MMInsertAction.superclass.postExecuteA.call(this, whiteboard_);
};
MMInsertAction.prototype.postExecuteP = function (whiteboard_) {
  //  whiteboard_.shuffle(this.m_ids, this.m_baseObj) ;
  return this.getRefreshRect();
};
MMInsertAction.prototype.encode = function (enc_) {
  var _insertInfo = new _MMInsertInfo["default"](this);
  _insertInfo.encode(enc_);
};
/**
 *
 * @returns {MMUndoInfo}
 */
MMInsertAction.prototype.getRefreshRect = function () {
  var info = new _MMUndoInfo["default"]();
  info.m_refreshRcts = this.m_objsRect;
  return info;
};
MMInsertAction.prototype.createReverse = function (whiteboard) {
  var objects = [];
  this.m_objects.forEach(function (value, key) {
    objects.push(value);
  });
  return new _MMDeleteAction["default"](objects, whiteboard, this.m_isMark);
};
var _default = exports["default"] = MMInsertAction;

},{"1076":1076,"1184":1184,"1418":1418,"1454":1454,"1463":1463,"1537":1537,"800":800,"885":885,"963":963,"972":972,"976":976,"992":992}],976:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMActionInfo = _interopRequireDefault(require(1077));
var _MMInsertAction = _interopRequireDefault(require(975));
var _ACTION_TYPE = _interopRequireDefault(require(1076));
var _ACTION_SOURCE = _interopRequireDefault(require(1075));
var _Decoder = _interopRequireDefault(require(799));
var _map = _interopRequireDefault(require(821));
/*
 * @param {Array.<MMObject>}
 */
function MMInsertInfo(InsertAction_) {
  _MMActionInfo["default"].call(this, InsertAction_);
  this.m_className = 'MMInsertInfo';
  this.m_type = _ACTION_TYPE["default"].INSERT;
  this.m_source = _ACTION_SOURCE["default"].LOCAL;
  this.m_dataImage = null; //arryBuffer
  this.m_length = 0;
  this.m_seq = -1;
  if (InsertAction_) {
    this.m_dataImage = InsertAction_.m_dataImage;
  }
}
;
MMInsertInfo.prototype = new _MMActionInfo["default"]();
MMInsertInfo.superclass = _MMActionInfo["default"].prototype;
MMInsertInfo.prototype.getDataImage = function () {
  return this.m_dataImage;
};
MMInsertInfo.prototype.getClassName = function () {
  return this.m_className;
};
MMInsertInfo.prototype.__getObjects = function (whiteboard_) {
  //  var _ret = new Array ;

  var _ret = new _map["default"]();
  ; //map<__int32_t, MMObject*>

  if (this.m_dataImage == null) {
    return null;
  }
  var _dec = new _Decoder["default"](whiteboard_);
  _dec.setStream(this.m_dataImage);
  var _ver = _dec.decodeFrom4Bytes(___MM_DOC_VERSION__);
  _ret = _dec.decodeFromMap(_ver, "4Bytes", "Meta");
  var arrayObjects = _ret.getValues(); //MMObject
  for (var i = 0; i < arrayObjects.length; i++) {
    if (!arrayObjects[i].m_includeData) {
      arrayObjects[i].m_includeData = true;
      arrayObjects[i]._createObjData();
      arrayObjects[i].m_dataForNew.decode(_dec, _ver);
    }
  }
  return _ret;
};
MMInsertInfo.prototype.encode = function (enc_) {
  MMInsertInfo.superclass.encode.call(this, enc_);
  enc_.encodeBuffer(this.m_dataImage);
};
MMInsertInfo.prototype.decode = function (dec_, ver_) {
  MMInsertInfo.superclass.decode.call(this, dec_, ver_);
  this.m_dataImage = dec_.decodeFromBuffer(ver_);
};
MMInsertInfo.prototype.getCompatible = function (whiteboard_) {
  var _newObjs = this.__getObjects(whiteboard_);
  return new _MMInsertAction["default"](_newObjs);
};
var _default = exports["default"] = MMInsertInfo;

},{"1075":1075,"1076":1076,"1077":1077,"1184":1184,"1454":1454,"799":799,"821":821,"975":975}],972:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1418);
require(1463);
require(1537);
var _MMAction = _interopRequireDefault(require(963));
var _MMInsertAction = _interopRequireDefault(require(975));
var _OBJ_ID = _interopRequireDefault(require(818));
var _Encoder = _interopRequireDefault(require(800));
var _MMSketchCommentController = _interopRequireDefault(require(885));
var _MMCommentObj = _interopRequireDefault(require(1005));
var _MMUndoInfo = _interopRequireDefault(require(992));
var _MMDeleteInfo = _interopRequireDefault(require(973));
var _Decoder = _interopRequireDefault(require(799));
/**
 * @param newObjs_ {Object, ObjectIDs or Array of one kind}
 * @param whiteboard need to be set, when you hand over a list of ObjectIDs
 */
function MMDeleteAction(newObjs_, whiteboard, isMark_) {
  _MMAction["default"].call(this);
  if (!(newObjs_ instanceof Array)) {
    newObjs_ = [newObjs_];
  }
  this.m_objects = [];
  this.m_ids = [];
  //  console.assert(newObjs_ instanceof Array) ;
  if (typeof newObjs_[0] === "string" || newObjs_[0] instanceof String) {
    for (var i = 0; i < newObjs_.length; i++) {
      var idObj = new _OBJ_ID["default"]();
      idObj.fromString(newObjs_[i]);
      newObjs_[i] = idObj;
    }
    ;
  }
  if (newObjs_[0] instanceof _OBJ_ID["default"]) {
    this.m_objects = [];
    this.m_ids = newObjs_;
    for (var i = 0; i < newObjs_.length; i++) {
      this.m_objects.push(whiteboard.getObjsById(newObjs_[i]));
    }
  } else {
    this.m_objects = newObjs_;
    this.m_ids = [];
    for (var i = 0; i < newObjs_.length; i++) {
      this.m_ids.push(newObjs_[i].getId());
    }
  }
  var _enc = new _Encoder["default"]();
  var objectLayers = whiteboard.getObjectLayer(this.m_ids);
  _enc.encodeMap(objectLayers, '4Bytes', 'Meta');
  objectLayers.forEach(function (value_, key_) {
    var object = value_;
    object && object.getObjData().encode(_enc);
  });
  this.m_image = _enc.getStream();
  this.m_isMark = isMark_;
}
;
MMDeleteAction.prototype = new _MMAction["default"]();
MMDeleteAction.superclass = _MMAction["default"].prototype;
MMDeleteAction.prototype.getClassName = function () {
  return 'MMDeleteAction';
};

/**
 *
 * @param whiteboard_
 * @param active_  {bool}
 */
MMDeleteAction.prototype.execute = function (whiteboard_, active_) {
  /*
   */
  console.log("execute MMDeleteAction");
  var _objs = whiteboard_.getObjectLayer(this.m_ids); //map<__int32_t, MMObject*>
  //var _objs = whiteboard_.getObjsById(this.m_ids);

  this.m_objsRect = new Array(); //清空

  var objArray = _objs.getValues(); //Array<MMObject>
  //var objArray = _objs; //Array<MMObject>

  for (var k = 0; k < objArray.length; k++) {
    var obj = objArray[k];
    if (obj) {
      this.m_objsRect.push(obj.getExpandRect());
      if (obj instanceof _MMCommentObj["default"]) {
        /*
         * 注意：pageIndex的必须在删除之前获取，而COMMENT_REMOVE事件必须在删除之后发送，这就是为什么下面的
         * 的代码使用了setBabelTimeout的原因。
         */
        var _pageIndex = obj.getPageIndex();
        setBabelTimeout(function () {
          Dispatcher.trigger(MDEvents.COMMENT_REMOVE, obj.m_board, _pageIndex);
          Dispatcher.trigger(MDEvents.Comment_State_Sync, obj.m_board.fileInfo.getFileId(), this);
        });
      }
    }
    ;
  }
  var commentSlidePanel = viewManager.get("commentSlidePanel");
  var currentCommentSlidePanelId = null;
  if (commentSlidePanel) {
    currentCommentSlidePanelId = commentSlidePanel.comment.m_id.m_localIndex;
  }
  var objs = whiteboard_.getObjectLayer(this.m_ids).getValues();
  //var objs = _objs;

  for (var i = 0; i < this.m_ids.length; i++) {
    var _objId = this.m_ids[i];
    var obj = objs[0];
    if (obj) {
      var pageIndex = obj.getPageIndex();
      if (commentSlidePanel && currentCommentSlidePanelId.isEqualTo(_objId.m_localIndex)) {
        commentSlidePanel.remove();
        setBabelTimeout(function () {
          Dispatcher.trigger(MDEvents.COMMENT_REMOVE, obj.m_board, _pageIndex);
          Dispatcher.trigger(MDEvents.Comment_State_Sync, obj.m_board.fileInfo.getFileId(), this);
        });
      }
      if (this.m_isMark) {
        if (_MMSketchCommentController["default"]) {
          _MMSketchCommentController["default"].removeObject(_objId);
        }
      }
    }
    ;
    whiteboard_.__delObject(_objId);
  }

  /*
   */
  this.m_collabId = whiteboard_.getCollabIds(this.m_ids);
};

/*
 */

MMDeleteAction.prototype.postExecuteA = function (whiteboard_) {
  MMDeleteAction.superclass.postExecuteA.call(this, whiteboard_);
  /*
   */
};

/*
 */

MMDeleteAction.prototype.postExecuteP = function (whiteboard_) {
  return this.getRefreshRect();
};

//MMDeleteAction.prototype.__CreateDataImg = function () {
//  var _enc = new Coder.Encoder ;
//  _enc.encode4Bytes(___MM_DOC_VERSION__) ;
//
//  var _count = this.m_objects.length ;
//  _enc.encode4Bytes(_count) ;
//  for (var i = 0 ; i < _count ; i ++) {
//    var _object = this.m_objects[i] ;
//    _enc.encodeObject(_object) ;
//    /*
//     *
//     */
//    if (!_object.getIncludeData()) {
//      var _objData = _object.getObjData() ;
//      _objData.encode(_enc) ;
//    }
//  }
//  this.m_image = _enc.getStream() ;
//} ;

/*

 */
MMDeleteAction.prototype.encode = function (enc_) {
  /*
   */
  var _DeleteInfo = new _MMDeleteInfo["default"](this);
  _DeleteInfo.encode(enc_);
};

//MMDeleteAction.prototype.decode = function (dec_, ver_) {
//
//} ;

/**
 *
 * @returns {MMUndoInfo}
 */
MMDeleteAction.prototype.getRefreshRect = function () {
  var info = new _MMUndoInfo["default"]();
  info.m_refreshRcts = this.m_objsRect;
  return info;
};
MMDeleteAction.prototype.createReverse = function (whiteboard_) {
  var _newObjects = [];
  var _dec = new _Decoder["default"](whiteboard_);
  _dec.setStream(this.m_image);
  var objectLayers = _dec.decodeFromMap(___MM_DOC_VERSION__, '4Bytes', 'Meta');
  objectLayers.forEach(function (value_, key_) {
    var object = value_;
    object.getObjData().decode(_dec);
  });
  return new _MMInsertAction["default"](objectLayers, this.m_isMark);
};
var _default = exports["default"] = MMDeleteAction;

},{"1005":1005,"1184":1184,"1418":1418,"1454":1454,"1463":1463,"1537":1537,"799":799,"800":800,"818":818,"885":885,"963":963,"973":973,"975":975,"992":992}],1005:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1466);
require(1437);
require(1463);
require(1478);
var _MMPointObj = _interopRequireDefault(require(1023));
var _ObjType = _interopRequireDefault(require(1084));
var _MMObjElementsController = _interopRequireDefault(require(893));
// import MDPcMobileEditorCommonFun from '../../../common/MDPcMobileEditorCommonFun.js';

/**
 * MMCircle 是所有需要绘制 bezier 曲线的基础类
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMCircle}
 */
function MMCommentObj(board, ver) {
  _MMPointObj["default"].call(this, board, ver); //
  this.m_className = 'MMCommentObj';
  this.m_objType = _ObjType["default"].Obj_comment;
  this.active = false;
  this.chatlogFatched = false;
  this.firstMessage = null; //{senderName,senderId,message-string}

  this.setRead(app.currentUser.getUserId_Int());
}
;
MMCommentObj.prototype = new _MMPointObj["default"](); //
MMCommentObj.superclass = _MMPointObj["default"].prototype;
MMCommentObj.prototype.encode = function (enc_) {
  MMCommentObj.superclass.encode.call(this, enc_);
};
MMCommentObj.prototype.decode = function (dec_, ver_) {
  MMCommentObj.superclass.decode.call(this, dec_, ver_);
};
MMCommentObj.prototype.decode = function (dec_, ver_) {
  MMCommentObj.superclass.decode.call(this, dec_, ver_);
};
MMCommentObj.prototype.drawInDiv = function (editor, trsfm, pgindex) {
  var elementsCtl = _MMObjElementsController["default"].getSingleInstance();
  elementsCtl.displayInDiv(editor, this, trsfm, pgindex);
};
MMCommentObj.prototype.setActive = function (active) {
  this.active = active;
};
MMCommentObj.prototype.isActive = function () {
  return this.active;
};
MMCommentObj.prototype.isComment = function () {
  return true;
};
MMCommentObj.prototype.setRead = function (usrId) {
  this.getObjData().setRead(usrId);
};
MMCommentObj.prototype.getReadStatus = function (usrId) {
  return this.getObjData().getReadStatus(usrId);
};
MMCommentObj.prototype.setStatusForUserId = function (userId, status) {
  this.getObjData().setStatusForUserId(userId, status);
};
MMCommentObj.prototype.setHasNewReplyFromUser = function (userId) {
  this.getObjData().setHasNewReplyFromUser(userId);
};
MMCommentObj.prototype.setFinished = function (finished) {
  this.getObjData().setFinished(finished);
};
MMCommentObj.prototype.isFinished = function () {
  return this.getObjData().isFinished();
};
MMCommentObj.prototype.praise = function (userId_) {
  this.getObjData().praise(userId_);
};
MMCommentObj.prototype.isPraised = function (userId_) {
  return this.getObjData().isPraised(userId_);
};
MMCommentObj.prototype._creationTime = null;
MMCommentObj.prototype.getCreationTime = function (pt, error) {
  if (this._creationTime) return this._creationTime;
  var data = this.getObjData();
  var currentWhiteboard = this.getBoard();
  if (!currentWhiteboard) return null;
  var firstPost = currentWhiteboard.getChatLog(this.getId())[0];
  var time = parseInt(firstPost.m_time.toString());
  return time || null;
};
MMCommentObj.prototype.getIndex = function () {
  var curDispVer = this.getFileVersion();
  // return this.getBoard().getCommentsForVersion(curDispVer).indexOf(this)+1;
  var comments = this.getBoard().getVisibleCommentsForVersion(curDispVer);
  var index = 0;
  for (var i = 0; i < comments.length; i++) {
    if (comments[i].getVisibleScope() == this.getVisibleScope()) {
      index++;
      if (comments[i] == this) {
        break;
      }
      ;
    }
  }
  ;
  return index;
};
MMCommentObj.prototype.isEvalComment = function () {
  var scope = this.getVisibleScope();
  if (scope >= 8) {
    return true;
  }
  return false;
};
MMCommentObj.prototype.fetchChatlog = function (callback) {
  this.getObjData().commentBasicData.fetchChatlog(this.getId(), callback);
};
var _default = exports["default"] = MMCommentObj;

},{"1023":1023,"1084":1084,"1184":1184,"1437":1437,"1454":1454,"1463":1463,"1466":1466,"1478":1478,"893":893}],1023:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMPoint = _interopRequireDefault(require(830));
var _MMObject = _interopRequireDefault(require(1081));
var _MMRect = _interopRequireDefault(require(831));
var POINT_SIZE = 1.0;
window.POINT_SIZE = POINT_SIZE;

/**
 * MMCircle 是所有需要绘制 bezier 曲线的基础类
 * @constructor
 * @static
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMCircle}
 */
function MMPointObj(board, ver) {
  _MMObject["default"].call(this, board, ver); //
  this.m_className = 'MMPointObj';
}
;
MMPointObj.prototype = new _MMObject["default"](); //
MMPointObj.superclass = _MMObject["default"].prototype;
MMPointObj.prototype.encode = function (enc_) {
  MMPointObj.superclass.encode.call(this, enc_);
};
MMPointObj.prototype.decode = function (dec_, ver_) {
  MMPointObj.superclass.decode.call(this, dec_, ver_);
};
MMPointObj.prototype.move = function (offset, moveAll) {
  //var _moveAll = arguments[1] ? arguments[1] : true;
  var newPos = this.getPos().clone();
  newPos.x += offset.x;
  newPos.y += offset.y;
  this.setPos(newPos);
};
MMPointObj.prototype.getPos = function () {
  var data = this.getObjData();
  if (data) {
    return data.m_pos;
  } else {
    return new _MMPoint["default"](0, 0);
  }
};
MMPointObj.prototype.setPos = function (pos) {
  var data = this.getObjData();
  if (data) {
    data.m_pos = pos;
  }
  var lgRect = new _MMRect["default"](pos.y - POINT_SIZE, pos.x + POINT_SIZE, pos.y + POINT_SIZE, pos.x - POINT_SIZE);
  this.setRect(lgRect);
  this.setExpandRect(lgRect);
};
var _default = exports["default"] = MMPointObj;

},{"1081":1081,"1184":1184,"1454":1454,"830":830,"831":831}],992:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMRect = _interopRequireDefault(require(831));
/**
 *  undo redo 时的返回信息
 *
 *  added by lishusheng, 2014-6-17
 */
function MMUndoInfo() {
  this.m_refreshRcts; // 刷新区域, vector<MMLgRect>
  this.m_refreshFullScreen = false; //bool
  this.m_pagesIndex = new Array(); //vector<int>

  this.getTotalRect = function () {
    //        var  _rect  ;//MMLgRect
    var _rect = new _MMRect["default"](0, 0, 0, 0); //MMLgRect
    for (var i = 0; i < this.m_refreshRcts.length; i++) {
      if (i == 0) {
        _rect = new _MMRect["default"](this.m_refreshRcts[i].top, this.m_refreshRcts[i].right, this.m_refreshRcts[i].bottom, this.m_refreshRcts[i].left);
      } else {
        _rect.expandToInclude(this.m_refreshRcts[i]);
      }
    }
    return _rect;
  };
}
;
var _default = exports["default"] = MMUndoInfo;

},{"1184":1184,"1454":1454,"831":831}],973:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMDeleteAction = _interopRequireDefault(require(972));
var _MMActionInfo = _interopRequireDefault(require(1077));
var _ACTION_TYPE = _interopRequireDefault(require(1076));
var _ACTION_SOURCE = _interopRequireDefault(require(1075));
/**
 * @param {Array.<MMObject>}
 */
function MMDeleteInfo(deleteAction_) {
  _MMActionInfo["default"].call(this, deleteAction_);
  this.m_className = 'MMDeleteInfo';
  this.m_type = _ACTION_TYPE["default"].DELETE;
  this.m_source = _ACTION_SOURCE["default"].LOCAL;
  this.m_ids = new Array(); //vector<OBJ_ID>

  if (deleteAction_) {
    this.m_ids = deleteAction_.m_ids;
  }
}
;
MMDeleteInfo.prototype = new _MMActionInfo["default"]();
MMDeleteInfo.superclass = _MMActionInfo["default"].prototype;
MMDeleteInfo.prototype.getObjs = function () {
  return this.m_ids;
};
MMDeleteInfo.prototype.getClassName = function () {
  return this.m_className;
};
MMDeleteInfo.prototype.encode = function (enc_) {
  MMDeleteInfo.superclass.encode.call(this, enc_);
  enc_.encodeArray(this.m_ids, "ObjID");
};
MMDeleteInfo.prototype.decode = function (dec_, ver_) {
  MMDeleteInfo.superclass.decode.call(this, dec_, ver_);
  this.m_ids = dec_.decodeFromArray(ver_, "ObjID");
};
MMDeleteInfo.prototype.getCompatible = function (whiteboard_) {
  var _newObjIds = this.getObjs();
  return new _MMDeleteAction["default"](_newObjIds, whiteboard_);
};
var _default = exports["default"] = MMDeleteInfo;

},{"1075":1075,"1076":1076,"1077":1077,"1184":1184,"1454":1454,"972":972}],1077:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMMeta = _interopRequireDefault(require(1080));
var _set = _interopRequireDefault(require(822));
var _ACTION_TYPE = _interopRequireDefault(require(1076));
var _ACTION_SOURCE = _interopRequireDefault(require(1075));
function MMActionInfo(action_) {
  _MMMeta["default"].call(this);
  /*
   * 操作类型
   * @private {ACTION_TYPE}
   */
  this.m_type = _ACTION_TYPE["default"].NONE;

  /*
   * 本机操作？协同操作？
   * @private {ACTION_SOURCE}
   */
  this.m_source = _ACTION_SOURCE["default"].LOCAL;

  /*
   * 涉及到的协同id
   * @private {Set.<ID>}
   */
  this.m_collabs = new _set["default"]();

  /*
   * 总序列号
   * @private {SEQUENCE}
   */
  this.m_seq = action_ ? action_.m_seq : -1;

  /*
   * 消息来源：这是一个ID类型的变量，由MAC地址生成。
   * @private {ID}
   */
  this.m_macaddr = action_ ? action_.m_identifier : -1;

  /*
   * 分序列号（每个消息来源各有自己的序列）
   * @private {SEQUENCE}
   */
  this.m_indseq = action_ ? action_.m_indSeq : -1;

  /*
   * 是否是系统自动产生的 action，系统的 action 不在 undo redo 中单独占一步，而是连带 undo
   * @private {boolean}
   */
  this.m_system = action_ ? action_.m_system : false;
}
;
MMActionInfo.prototype = new _MMMeta["default"]();
MMActionInfo.superclass = _MMMeta["default"].prototype;
MMActionInfo.prototype.setIdentifier = function (identifier_) {
  this.m_macaddr = identifier_;
};
MMActionInfo.prototype.setIndSeq = function (indSeq_) {
  this.m_indseq = indSeq_;
};
MMActionInfo.prototype.getIndSeq = function () {
  return this.m_indseq;
};
MMActionInfo.prototype.encode = function (enc_) {
  MMActionInfo.superclass.encode.call(this, enc_);
  enc_.encode4Bytes(this.m_type);
  enc_.encode4Bytes(this.m_source);
  enc_.encodeSet(this.m_collabs, '8Bytes');
  enc_.encode8Bytes(this.m_seq);
  enc_.encode8Bytes(this.m_macaddr);
  enc_.encode8Bytes(this.m_indseq);
  enc_.encodeBool(this.m_system);
};
MMActionInfo.prototype.decode = function (dec_, ver_) {
  MMActionInfo.superclass.decode.call(this, dec_, ver_);
  this.m_type = dec_.decodeFrom4Bytes(ver_);
  this.m_source = dec_.decodeFrom4Bytes(ver_);
  this.m_collabs = dec_.decodeFromSet(ver_, '8Bytes');
  this.m_seq = dec_.decodeFrom8Bytes(ver_);
  this.m_macaddr = dec_.decodeFrom8Bytes(ver_);
  this.m_indseq = dec_.decodeFrom8Bytes(ver_);
  this.m_system = dec_.decodeFromBool(ver_);
};
MMActionInfo.prototype.getCompatible = function (whiteboard_) {};
var _default = exports["default"] = MMActionInfo;

},{"1075":1075,"1076":1076,"1080":1080,"1184":1184,"1454":1454,"822":822}],1076:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/*
 * @enum
 */
var ACTION_TYPE = {
  NONE: 100,
  CREATE: 0,
  DELETE: 1,
  UPDATE: 2,
  INSERT: 3,
  PASTE: 4,
  PAGE_OP: 5,
  BACKGROUND: 6,
  ADDCOOP: 7,
  MESSAGE: 8,
  CHANGELAYER: 9,
  FETCH: 10,
  COMMIT_ROUND: 11,
  READ_STATUS: 12
};
var _default = exports["default"] = ACTION_TYPE;

},{"1454":1454}],1075:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var ACTION_SOURCE = {
  LOCAL: 0,
  //白板内容
  MARK: 1 //批注内容
};
var _default = exports["default"] = ACTION_SOURCE;

},{"1454":1454}],963:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _set = _interopRequireDefault(require(822));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDEvents = _interopRequireDefault(require(325));
var _MMIdManager = _interopRequireDefault(require(951));
function MMAction() {
  /*
   *涉及到的对象ID
   */
  this.m_ids = new Array();
  this.m_objsRect = new Array(); // 操作涉及到的对象区域

  /*
   *涉及到的协同ID
   */
  this.m_collabIds = new _set["default"]();
  /*
   *总序列号
   */
  this.m_seq = -1;
  this.m_identifier = _MMIdManager["default"].locator;
  /*
   *分序列号（每个消息来源各有自己的序列）
   */
  this.m_indSeq = -1;
  this.m_valid = true; // 是否有效
  this.m_system = true; // 是否时系统自动产生的动作
}
;
MMAction.prototype.getIdentifier = function () {};
MMAction.prototype.setIdentifier = function () {};
MMAction.prototype.setIndSeq = function (indSeq_) {
  this.m_indSeq = indSeq_;
};
MMAction.prototype.getSeq = function () {
  return this.m_seq;
};
/*
 * @param {MMWhiteboard} whiteboard_
 */
MMAction.prototype.execActionA = function (whiteboard_) {
  this.preExecuteA(whiteboard_);
  this.execute(whiteboard_);
  this.postExecuteA(whiteboard_);

  /*
   */
  if (!this.notRefresh) {
    var _refreshInfo = this.getRefreshRect();
    if (_refreshInfo) {
      var _refreshRect = _refreshInfo.getTotalRect();
      _refreshRect.expand(0.5, 0.5, 0.5, 0.5);
      if (this.m_isMark) {
        _Dispatcher["default"].trigger(_MDEvents["default"].MARK_READY, whiteboard_, _refreshRect);
      } else {
        setBabelTimeout(function () {
          _Dispatcher["default"].trigger(_MDEvents["default"].DATA_READY, whiteboard_, _refreshRect);
        });
      }
    }
  }
  ;
};

/*
 * @param {MMWhiteboard} whiteboard_
 * @return{MMUndoInfo}
 */
MMAction.prototype.execActionP = function (whiteboard_) {
  this.preExecuteP(whiteboard_);
  this.execute(whiteboard_);
  return this.postExecuteP(whiteboard_);
};
MMAction.prototype.markP = function (whiteboard_) {};
MMAction.prototype.preExecuteA = function (whiteboard_) {};
MMAction.prototype.execute = function (whiteboard_) {};
MMAction.prototype.postExecuteA = function (whiteboard_) {
  whiteboard_.markPageDirtyByObjects(this.m_ids);
};
MMAction.prototype.preExecuteP = function (whiteboard_) {};
MMAction.prototype.postExecuteP = function (whiteboard_) {};
MMAction.prototype.createReverse = function () {
  return this;
};
MMAction.prototype.notSent = function () {
  return this.m_seq == -1;
};
MMAction.prototype.compDetail_deprecated = function (actionInfo_) {
  this.m_collabs = actionInfo_.m_collabs;
  this.m_seq = actionInfo_.m_seq;
  this.m_indSeq = actionInfo_.m_indseq;
  this.m_system = actionInfo_.m_system;
  this.m_identifier = actionInfo_.m_macaddr;
};
//计算白板里面涉及到的对象的矩形框
MMAction.prototype.calcObjsRectFromWhiteBoard = function (whiteboard_) {
  //var _objects = new Array();
  //for(var i=0; i<this.m_ids.length; i++){
  //  var _obj = whiteboard_.getObjsById(this.m_ids[i]); //getObject
  //  if(_objects){
  //    _objects.push(_obj);
  //  }
  //}
  var _objects = whiteboard_.getObjsById(this.m_ids);
  this.calcObjsRect(_objects);
};
//计算对象的矩形框
MMAction.prototype.calcObjsRect = function (objects_) {
  this.m_objsRect = []; //清空
  for (var i = 0; i < objects_.length; i++) {
    this.m_objsRect.push(objects_[i].getExpandRect().clone()); //clone(),2014-07-03
  }
};
MMAction.prototype.getType = function () {
  return this.m_type;
};
MMAction.prototype.getRefreshRect = function () {
  return null;
};
MMAction.prototype.isUndoable = function () {
  return this.m_isUndoable ? true : false;
};
MMAction.prototype.isRealtime = function () {
  return this.m_isRealtime ? true : false;
};
MMAction.prototype.isMark = function () {
  return this.m_isMark ? true : false;
};
MMAction.prototype.setContext = function (undoable_, realtime_, mark_) {
  this.m_isRealtime = realtime_;
  this.m_isUndoable = undoable_;
  this.m_isMark = mark_; //这个参数目前有没有用到？
};
var _default = exports["default"] = MMAction;

},{"1184":1184,"1454":1454,"18":18,"325":325,"822":822,"951":951}],35:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMViewBase = _interopRequireDefault(require(22));
/*
  全局at某人的基类
*/
var _default = exports["default"] = _MMViewBase["default"].extend({
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      triggerBlock: null,
      at: '@',
      data: null,
      searchKey: 'name',
      insertTpl: '<%= name %>',
      displayTpl: '<li><%= name %></li>',
      displayTimeout: 300,
      limit: 200,
      startWithSpace: false,
      autoClose: true
    });
  },
  /**
   * input {DOM Element} The input element where the auto complete component will recieve key
   */
  initialize: function initialize(options) {
    var self = this;
    _MMViewBase["default"].prototype.initialize.call(this, options);
    this.$triggerBlock = $(this.triggerBlock);
    this.$triggerBlock.atwho({
      at: this.at,
      data: this.data,
      searchKey: this.searchKey,
      insertTpl: this.insertTpl,
      displayTpl: this.displayTpl,
      displayTimeout: this.displayTimeout,
      limit: this.limit,
      startWithSpace: this.startWithSpace,
      callbacks: {
        tplEval: function tplEval(tpl, data) {
          return _.template(tpl)(data);
        }
      }
    }).on('shown.atwho', function () {
      self.popupShown = true;
      self.onShow && self.onShow();
    }).on('hidden.atwho', function () {
      _.defer(function () {
        self.popupShown = false;
        self.onHide && self.onHide();
      });
    });
    var app1 = this.$triggerBlock.data('atwho');
    if (!app1) {
      return;
    }
    ;
    if (_.isUndefined(window.num)) {
      window.num = 0;
    } else {
      ++window.num;
    }
    app1.$el.attr('data-id', window.num);
  },
  isShown: function isShown() {
    return this.$triggerBlock.atwho('isSelecting');
  },
  isPopupShown: function isPopupShown() {
    return this.popupShown;
  },
  hide: function hide($e) {
    this.$triggerBlock.atwho('hide');
  },
  destroySelf: function destroySelf() {
    this.$triggerBlock.atwho('destroy');
  },
  onShow: function onShow() {},
  onHide: function onHide() {}
});

},{"1184":1184,"1454":1454,"22":22}],76:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
var _SPINNER = _interopRequireDefault(require(77));
var _MMViewBase = _interopRequireDefault(require(22));
var _MDLocalString = _interopRequireDefault(require(1150));
/**
 * Simple inline loading indicator view.
 * Created by manjun.han
 * 2016.03.18
 */

var MDSpinnerloaderView = _MMViewBase["default"].extend({
  el: '<div class="spinner-loader"></div>',
  tmpl: '<div class="spinner"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>',
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend({}, superP, {
      $spinner: null,
      autoHeight: false,
      isLight: false
    });
  },
  /**
   *
   * @param  {SPINNER} [opt.size=SPINNER.SMALL] - loader的大小
   * @param {boolean} [opt.isLight=false] - 是否是浅色
   * @param {boolean} [opt.autoHeight] - 是否撑起高度，默认为高度为0
   * @return {void}
   */
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.$spinner = this.$('.spinner');
    this.setSizeType(_SPINNER["default"].SMALL);
    this.$el.data('loadView', this);
    if (this.autoHeight) {
      this.$el.addClass('auto-height');
    }
    if (this.isLight) {
      this.$el.addClass('with-light');
    }
    if (_MDLocalString["default"].getCurrentLanguage() != 'cn') {
      this.$el.addClass("english");
    }
  },
  setSizeType: function setSizeType(sizeType) {
    var cls = "";
    switch (sizeType) {
      case _SPINNER["default"].SMALL:
        cls = "spinner-small";
        break;
      case _SPINNER["default"].MIDDLE:
        cls = "spinner-middle";
        break;
    }
    this.$spinner.addClass(cls);
  },
  viewDidRendered: function viewDidRendered() {
    _MMViewBase["default"].prototype.viewDidRendered.call(this);
    this.$el.data('loadView');
    if (this.position) {
      this.$el.addClass('full-center');
    }
    ;
  }
}, {
  // showIn: function(parent, options) {
  //   var children = $(parent).find('.spinner-loader').eq(0);
  //   var loadView = children.data('loadView');
  //   if (!loadView) {
  //     loadView = new MDSpinnerloaderView(options);
  //     loadView.renderTo(parent);
  //     parent.offsetWidth;
  //   }
  // },

  // clearFrom: function(parent) {
  //   $(parent).find('.spinner-loader').each(function() {
  //     var loadView = $(this).data('loadView');
  //     if (loadView) loadView.remove();
  //   });
  // }
  /**
   * @param {domProps} parent 渲染的父节点
   * @param {object} options 参数设置，参考25行
   */
  showIn: function showIn(parent, options) {
    var loadView = $(parent).data('spinner-loader');
    if (!loadView) {
      loadView = new MDSpinnerloaderView(options);
      loadView.renderTo(parent);
      $(parent).data('spinner-loader', loadView);
      parent.offsetWidth;
    }
    return loadView;
  },
  clearFrom: function clearFrom(parent) {
    $(parent).find('.spinner-loader').remove();
    $(parent).data('spinner-loader', null);
  }
});
var _default = exports["default"] = MDSpinnerloaderView;

},{"1150":1150,"1184":1184,"1417":1417,"1454":1454,"1463":1463,"22":22,"77":77}],77:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * @enum {number}
 */
var SPINNER = {
  SMALL: 0,
  MEDDLE: 1
};
var _default = exports["default"] = SPINNER;

},{"1454":1454}],65:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var POPUP_POS = {
  TOP: 0,
  LEFT: 1,
  RIGHT: 2,
  BOTTOM: 3,
  TOP_LEFT: 4,
  TOP_RIGHT: 5,
  BOTTOM_RIGHT: 6,
  BOTTOM_LEFT: 7,
  LEFT_TOP: 8,
  LEFT_BOTTOM: 9,
  RIGHT_TOP: 10,
  RIGHT_BOTTOM: 11
};
var _default = exports["default"] = POPUP_POS;

},{"1454":1454}],3:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1451);
require(1497);
require(1432);
var _MDBasic3DRender = _interopRequireDefault(require(10));
// MD3DImageCreator.js
// jiang
// 2016-10-23
//

/**
 *  将 3D 模型生成 2D 图片
 *
 *
 */

function MD3DImageCreator(width, height) {
  _MDBasic3DRender["default"].call(this);
  this.near = 0.001;
  this.far = 100000;
  this.initWithWinSize(width, height, true);
  this.meshBuffer = [];
}
Object.assign(MD3DImageCreator.prototype, _MDBasic3DRender["default"].prototype, function () {
  return {
    constructor: MD3DImageCreator,
    fitTheScreen: function fitTheScreen() {
      _MDBasic3DRender["default"].prototype.fitTheScreen.call(this);
      var radius = this.boundingSphere.radius;
      var center = this.boundingSphere.center.clone();
      var cameraPos = this.camera.position.clone();
      var direct = center.clone().sub(cameraPos);
      var near = direct.length() - radius;
      var far = direct.length() + radius;
      if (this.near > near) {
        this.near = near;
      }
      ;
      if (this.far < far) {
        this.far = far;
      }
      ;

      // TODO
      // 设置了 near 与 far 不起作用
      // this.camera.matrixAutoUpdate = true;
      // this.camera.near = this.near;
      // this.camera.far = this.far;

      // this.camera.updateMatrixWorld( true );
    },
    renderMeshToImage: function renderMeshToImage(mesh) {
      this.clearSubScene();
      this.addSubScene(mesh);
      // this.createMeshByCopy(mesh);

      this.fitTheScreen();
      this.renderer.render(this.scene, this.camera);
      var strMime = "image/jpeg";
      this.imgData = this.renderer.domElement.toDataURL(strMime);
    },
    renderAsync: function renderAsync(mesh, callback) {
      function renderOneByOne() {
        if (this.meshBuffer.length == 0) {
          return;
        }
        ;
        var mesh = this.meshBuffer[0].mesh;
        var callback = this.meshBuffer[0].callback;
        var img = this.renderMeshToImage(mesh);
        if (callback) {
          callback(img);
        }
        ;
        this.meshBuffer.splice(0, 1);
        var self = this;
        requestAnimationFrame(function () {
          renderOneByOne.call(self);
        });
      }
      ;
      this.meshBuffer.push({
        mesh: mesh,
        callback: callback
      });
      if (this.meshBuffer.length == 1) {
        renderOneByOne.call(this);
      }
      ;
    },
    getImage: function getImage() {
      return this.imgData;
    }
  };
}());
var _default = exports["default"] = MD3DImageCreator;

},{"10":10,"1184":1184,"1432":1432,"1451":1451,"1454":1454,"1497":1497}],10:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1424);
require(1451);
require(1497);
// MDBasic3DRender.js
// jiang
// 2016-10-23

//
//  类结构图 - 3D 显示控制器的继承关系
//  类继承关系图(< 代表继承):
//
//  MDBasic3DRender
//      |
//      |<--- MDColladaDisplayer    //--------- 显示操控
//      |
//      |<--- MD3DImageCreator      //--------- 将 3D 模型生成 2D 图片
//      |
//
//

/**
 *  基本的 3D 模型显示配置
 *    1. 构建 renderer
 *    2. 构建 灯光
 *    3. 构建 camera
 *    4. 适配窗口
 */

function MDBasic3DRender() {
  this.renderer = null;
  this.camera = null;
  this.scene = null;
  this.subScene = [];
  this.near = 1;
  this.far = 4000000;
}

/**
 * @author alteredq / http://alteredqualia.com/
 * @author mr.doob / http://mrdoob.com/
 */

MDBasic3DRender.Detector = {
  canvas: !!window.CanvasRenderingContext2D,
  webgl: function () {
    try {
      var canvas = document.createElement('canvas');
      return !!(window.WebGLRenderingContext && (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')));
    } catch (e) {
      return false;
    }
  }(),
  workers: !!window.Worker,
  fileapi: window.File && window.FileReader && window.FileList && window.Blob,
  getWebGLErrorMessage: function getWebGLErrorMessage() {
    var element = document.createElement('div');
    element.id = 'webgl-error-message';
    element.style.fontFamily = 'monospace';
    element.style.fontSize = '13px';
    element.style.fontWeight = 'normal';
    element.style.textAlign = 'center';
    element.style.background = '#fff';
    element.style.color = '#000';
    element.style.padding = '1.5em';
    element.style.width = '400px';
    element.style.margin = '5em auto 0';
    if (!this.webgl) {
      element.innerHTML = window.WebGLRenderingContext ? [BabelStr.str(7001) + ' <a href="http://khronos.org/webgl/wiki/Getting_a_WebGL_Implementation" style="color:#000">WebGL</a>.<br />', BabelStr.str(7002) //,'<a href="http://get.webgl.org/" style="color:#000">here</a>.'
      ].join('\n') : [BabelStr.str(7003) + ' <a href="http://khronos.org/webgl/wiki/Getting_a_WebGL_Implementation" style="color:#000">WebGL</a>.<br/>', BabelStr.str(7004) //,' <a href="http://get.webgl.org/" style="color:#000">here</a>.'
      ].join('\n');
    }
    return element;
  },
  addGetWebGLMessage: function addGetWebGLMessage(parameters) {
    var parent, id, element;
    parameters = parameters || {};
    parent = parameters.parent !== undefined ? parameters.parent : document.body;
    id = parameters.id !== undefined ? parameters.id : 'oldie';
    element = MDBasic3DRender.Detector.getWebGLErrorMessage();
    element.id = id;
    parent.appendChild(element);
    setBabelTimeout(function () {
      $(element).remove();
    }, 1000);
  }
};
Object.assign(MDBasic3DRender.prototype, {}, function () {
  function _calcuBoundingSphere(origin3DObjs) {
    var min = null,
      max = null;
    for (var i = 0; i < origin3DObjs.length; i++) {
      var mesh = origin3DObjs[i];
      var objBox = new THREE.Box3();
      objBox.setFromObject(mesh);
      var curBoxMin = objBox.min.clone();
      var curBoxMax = objBox.max.clone();
      if (min == null) {
        min = curBoxMin.clone();
        max = curBoxMax.clone();
      } else {
        if (curBoxMin.x < min.x) {
          min.x = curBoxMin.x;
        }
        ;
        if (curBoxMin.y < min.y) {
          min.y = curBoxMin.y;
        }
        ;
        if (curBoxMin.z < min.z) {
          min.z = curBoxMin.z;
        }
        ;
        if (curBoxMax.x > max.x) {
          max.x = curBoxMax.x;
        }
        ;
        if (curBoxMax.y > max.y) {
          max.y = curBoxMax.y;
        }
        ;
        if (curBoxMax.z > max.z) {
          max.z = curBoxMax.z;
        }
        ;
      }
    }
    ;
    if (min) {
      var sphere = {
        center: new THREE.Vector3(0, 0, 0),
        radius: 0,
        min: min.clone(),
        max: max.clone()
      };
      sphere.center = min.clone();
      sphere.center.add(max);
      sphere.center.multiplyScalar(0.5);
      sphere.radius = sphere.center.clone().sub(min).length();
      return sphere;
    }
    ;
    return null;
  }
  ;
  function _adjustSpotLight() {
    var cameraPos = this.camera.position.clone();
    if (!this.spotLight) {
      return;
    }
    ;
    this.spotLight.position.set(cameraPos.x, cameraPos.y, cameraPos.z);
  }
  ;
  function _updateLightPosition() {
    if (!this.boundingSphere) {
      return;
    }
    ;
    var center = this.boundingSphere.center;
    var radius = this.boundingSphere.radius;
    if (!center) {
      console.error('must call this function after the boundingSphere created!');
    }
    ;
    var cameraPos = this.camera.position.clone();

    // 平行光初始化为从摄像机角度去照射
    var direction = cameraPos.clone().sub(center).normalize();
    var dist = radius > 100 ? radius : 100;
    var dirLightPos = direction.clone().multiplyScalar(dist);
    dirLightPos.add(center);
    this.directionalLight.position.set(dirLightPos.x, dirLightPos.y, dirLightPos.z);
    _adjustSpotLight.call(this);
  }
  ;
  function _initLights() {
    // 环境光
    if (this.ambientLight) {
      this.scene.remove(this.ambientLight);
    }
    ;
    this.ambientLight = new THREE.AmbientLight(0xAAAAAA);
    this.scene.add(this.ambientLight);

    // 平行光
    if (this.directionalLight) {
      this.scene.remove(this.directionalLight);
    }
    ;
    var pointColor = "#ffffff";
    this.directionalLight = new THREE.DirectionalLight(pointColor);
    var directionalLight = this.directionalLight;
    directionalLight.position.set(-40, 0, 70);
    directionalLight.castShadow = false;
    directionalLight.shadowCameraNear = 2;
    directionalLight.shadowCameraFar = 200;
    directionalLight.shadowCameraLeft = -50;
    directionalLight.shadowCameraRight = 50;
    directionalLight.shadowCameraTop = 50;
    directionalLight.shadowCameraBottom = -50;
    directionalLight.distance = 0;
    directionalLight.intensity = 0.5;
    directionalLight.shadowMapHeight = 1024;
    directionalLight.shadowMapWidth = 1024;

    // this.scene.add(directionalLight);

    // 点光
    if (this.spotLight) {
      this.scene.remove(this.spotLight);
    }
    ;
    this.spotLight = new THREE.SpotLight(0x444444);
    this.spotLight.position.set(-100, 40, 30);
    this.scene.add(this.spotLight);
    _updateLightPosition.call(this);

    // // 点光
    // var spotLight1 = new THREE.SpotLight(0xffffff);
    // spotLight1.position.set(5, 5, 5);
    // this.scene.add(spotLight1);
  }
  ;
  function _refreshFrustum() {
    var camera = this.camera;
    if (!camera) {
      return;
    }
    ;
    var frustum = new THREE.Frustum();
    var projScreenMatrix = new THREE.Matrix4();
    projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
    frustum.setFromMatrix(projScreenMatrix);
    this.camera.frustum = frustum;
  }
  ;
  return {
    constructor: MDBasic3DRender,
    // 注意：此函数内不能再添加创建任何 THREE JS 对象！！！，否则会影响旧文档读出的 THREE JS 对象的序号
    // 如果需要添加辅助对象或者灯光等等，请在函数 createOtherAssistObject3D 或者 _initLights 中添加
    //
    initWithWinSize: function initWithWinSize(width, height, preserveDrawingBuffer) {
      if (!this.renderer) {
        // try {
        if (MDBasic3DRender.Detector.webgl) {
          this.renderer = new THREE.WebGLRenderer();
        } else {
          var warning = MDBasic3DRender.Detector.getWebGLErrorMessage();
          $('.p-editor-root').append($(warning));
          setBabelTimeout(function () {
            $(warning).remove();
          }, 1000);
          return;
        }
      }
      ;
      this.renderer.setSize(width, height);
      if (!this.scene) {
        this.scene = new THREE.Scene();
      }
      ;
      if (!this.camera) {
        this.camera = new THREE.PerspectiveCamera(25, width / height, this.near, this.far);
        this.scene.add(this.camera);
      }
      ;
      var cameraPos = new THREE.Vector3(-35, 35, 35);
      this.camera.position.set(cameraPos.x, cameraPos.y, cameraPos.z);
      this.camera.up.set(0, 0, 1);
    },
    addSubScene: function addSubScene(scene) {
      // return;
      this.scene.add(scene);
      this.subScene.push(scene);

      // 此函数必须调用，调用后会影响 scene 中对象的 worldMatrix 属性
      this.renderer.render(this.scene, this.camera);
      var allObjs = [];
      this.scene.traverse(function (node) {
        if (node instanceof THREE.Mesh) {
          // insert your code here, for example:
          if (!node.debug) {
            allObjs.push(node);
          }
          ;

          // console.log('id --------->', node.id);
          // console.log('UUID --------->', node.uuid);
        }
      });
      console.assert(allObjs.length > 0, "----------- no 3d data readed");
      this.origin3DObjs = allObjs;
      this.boundingSphere = _calcuBoundingSphere(allObjs);

      // 这些调用必须在前面的基本数据对象加入后再调用
      _initLights.call(this);
      this.createOtherAssistObject3D();
    },
    // addSubScene

    clearSubScene: function clearSubScene() {
      for (var i = 0; i < this.subScene.length; i++) {
        this.scene.remove(this.subScene[i]);
      }
      ;
      this.subScene = [];
    },
    // 创建辅助 THREE JS 对象
    createOtherAssistObject3D: function createOtherAssistObject3D() {},
    updateWithCurCamera: function updateWithCurCamera() {
      _updateLightPosition.call(this);
      _refreshFrustum.call(this);
    },
    fitTheScreen: function fitTheScreen() {
      if (!this.boundingSphere) {
        return;
      }
      ;
      var radius = this.boundingSphere.radius;
      var center = this.boundingSphere.center.clone();
      var dis = radius / Math.sin(this.camera.fov * Math.PI / 360);
      // var dis = zHeight / Math.tan(this.camera.fov * Math.PI / 360) + max.y + 1; // 1 是多出来点儿边界空白

      // console.log('distance:', dis);

      var direct = new THREE.Vector3(1, -1, .7);
      direct.normalize();
      direct.multiplyScalar(dis);
      var cameraPos = center.clone().add(direct);
      this.camera.position.set(cameraPos.x, cameraPos.y, cameraPos.z);
      this.camera.lookAt(center);

      // // debug
      // var cubeGeometry = new THREE.CubeGeometry(0.5, 0.5, 0.5);
      // var cubeMaterial = new THREE.MeshLambertMaterial({
      //                                             color: 0xff0000,
      //                                             wireframe:false,
      //                                             vertexColors: THREE.FaceColors
      //                                           });
      // var cube = new THREE.Mesh(cubeGeometry, cubeMaterial);
      // var zAxis = new THREE.Vector3(0, 0, 1);
      // cube.translateOnAxis(zAxis, min.z);
      // this.scene.add(cube);
      // // debug end

      this.updateWithCurCamera();
    },
    // fitTheScreen

    createMeshByCopy: function createMeshByCopy(obj3d) {
      var newvertices = [];
      var geo = obj3d.geometry.clone();
      var vertices = obj3d.geometry.vertices;
      for (var i = 0; i < vertices.length; i++) {
        var v = vertices[i].clone();
        var n = v.clone().normalize();
        v.applyMatrix4(obj3d.matrixWorld);
        newvertices.push(v);
      }
      ;
      geo.vertices = newvertices;
      var material = new THREE.MeshLambertMaterial({
        // color: 0xaaffaa,
        'color': 0x00ffff,
        'wireframe': true,
        'wireframeLinewidth': 1,
        'vertexColors': THREE.FaceColors
      });
      var tempMesh = new THREE.Mesh(geo, material);
      this.addSubScene(tempMesh);
    }
  };
}());
var _default = exports["default"] = MDBasic3DRender;

},{"1424":1424,"1451":1451,"1454":1454,"1497":1497}],912:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1432);
var _goog = _interopRequireDefault(require(823));
var _MMAndroidScrollView = _interopRequireDefault(require(913));
var _MMBasicData = _interopRequireDefault(require(811));
var _MMCell = _interopRequireDefault(require(927));
var _MMCollectionFlowLayout = _interopRequireDefault(require(928));
var _rect = _interopRequireDefault(require(836));
var _MDEvents = _interopRequireDefault(require(325));
var _MDTouchMenu = _interopRequireDefault(require(339));
/**
 * 本类支持多页但画面中仅显示一页的 view， 同时支持左右或者上下滑动换页，以及当前页的放大缩小
 * jiang
 * 2015-4-7
 */

/**
 * @param {HTMLElement} containerDiv  page scroll view's parent div
 * @param {String} scrollDirection 横向还是竖向滚动 "horizontal, vertical"
 * @param {?Number} pgnum 共有多少页
 */
function MMAndroidCollectionView(containerDiv, scrollDirection, pgnum, pageSpacing) {
  if (pageSpacing == undefined || pageSpacing == null) {
    this.pageSpacing = 20;
  } else {
    this.pageSpacing = pageSpacing;
  }
  this.initialPage = -1; // 从界面而来的要求跳转到的位置

  this.layout = new _MMCollectionFlowLayout["default"](null, scrollDirection, this.pageSpacing);
  this.scrollDirection = scrollDirection;
  this.pgNum = pgnum;
  this.curPage = 0;
  this.dispCells = new Array();
  this.bufferCells = new Array();
  this.clickTimer = null;
  this.animateScroll = false;
  this.animateStep = null;
  _MMAndroidScrollView["default"].call(this, containerDiv);
}
;
_goog["default"].inherits(MMAndroidCollectionView, _MMAndroidScrollView["default"]);
MMAndroidCollectionView.prototype.isScrollHorizontal = function () {
  return this.scrollDirection == "horizontal";
};
MMAndroidCollectionView.prototype.pageNumChanged = function (pgnum) {
  if (this.pgNum != pgnum) {
    //    console.log("----------> page count changed:", pgnum);
    this.pgNum = pgnum;
    this.setContentSize(this.layout.getContentSize(this.pgNum));
    var curLeft = this.container.scrollLeft;
    var curTop = this.container.scrollTop;
    var mostLeft = this.container.scrollWidth - this.container.offsetWidth;
    if (curLeft > mostLeft) {
      curLeft = mostLeft;
    }
    var mostTop = this.container.scrollHeight - this.container.offsetHeight;
    if (curTop > mostTop) {
      curTop = mostTop;
    }
    this.displayCellsInCurViewPort();
    if (this.initialPage >= 0 && this.initialPage < pgnum) {
      this.changeToPage(this.initialPage, false);
      this.initialPage = -1; // 清除
    }
  }
};
MMAndroidCollectionView.prototype.refreshSize = function () {
  //!{ added by jiang, 2015-12-1, for mobile rotation
  _MDTouchMenu["default"].hide();
  //!}

  if (MMAndroidCollectionView.superClass_.refreshSize.call(this)) {
    var curPg = this.getCurrentCellIndex();
    this.pageSize = {
      width: 0,
      height: 0
    };
    this.pageSize.width = this.viewSize.width;
    this.pageSize.height = this.viewSize.height;
    this.layout.setItemSize(this.pageSize);
    this.setContentSize(this.layout.getContentSize(this.pgNum));
    this.reloadData();
    this.displayCellsInCurViewPort();
    this.changeToPage(curPg);
    return true;
  }
  return false;
};
MMAndroidCollectionView.prototype.changeScrollDirection = function (direction) {
  this.layout.setDirection(direction);
  this.contentSize = this.layout.getContentSize(this.pgNum);
  this.$contentDiv.css("width", this.contentSize.width + "px");
  this.$contentDiv.css("height", this.contentSize.height + "px");
  this.adjustSlider();
  this.displayCellsInCurViewPort();
};
MMAndroidCollectionView.prototype.addCellToBuffer = function (cell) {
  var found = false;
  for (var i = 0; i < this.bufferCells.length; i++) {
    if (this.bufferCells[i] == cell) {
      found = true;
      break;
    }
  }
  if (!found) {
    this.bufferCells.push(cell);
  }
};
MMAndroidCollectionView.prototype.onTouchUp = function (e) {
  var autoAdjustHappaned = false;
  if (!this.scrolling && this.touching) {
    this.scrollToShowFullPage();
    this.swipeDirection = "none";
    // console.log("=== touch up called check");
    this.autoAdjustHappaned = true;
  } else {
    // console.log("------- not call adjust");
  }
  MMAndroidCollectionView.superClass_.onTouchUp.call(this);

  // console.log('touch up ');
  return autoAdjustHappaned;
};
MMAndroidCollectionView.prototype.scrollStopped = function () {
  // console.log('scroll stop : touching:' + this.touching + ", animateScroll:" + this.animateScroll);
  if (this.touching) {
    // console.log('*** scroll stop not call check');
  } else {
    this.scrollToShowFullPage();
    // console.log('*** scroll stop called check');
  }
  MMAndroidCollectionView.superClass_.scrollStopped.call(this);
};
MMAndroidCollectionView.prototype.scrollToShowFullPage = function () {
  var left = this.container.scrollLeft;
  var top = this.container.scrollTop;
  var target = {
    x: left,
    y: top
  };
  if (this.swipeDirection == "swipeLeft") {
    target = this.layout.getNextTargetPosition(left, top, true, this.pgNum);
  } else if (this.swipeDirection == "swipeRight") {
    target = this.layout.getNextTargetPosition(left, top, false, this.pgNum);
  } else {
    target = this.layout.getNearestTargetPosition(left, top);
  }
  if (Math.abs(left - target.x) >= 1 || Math.abs(top - target.y) >= 1) this.scrollToPosition(target, true);
};
MMAndroidCollectionView.prototype.onScroll = function (event) {
  MMAndroidCollectionView.superClass_.onScroll.call(this);
  this.displayCellsInCurViewPortOnScroll();
};
MMAndroidCollectionView.prototype.displayCellsInCurViewPortOnScroll = function () {
  var curLeft = this.container.scrollLeft;
  var curTop = this.container.scrollTop;
  var visiblePageIndexes = this.layout.getVisibleItemIndex(curLeft, curTop, this.viewSize);

  //  this.debugCellsInfo(visiblePageIndexes);

  var indexesNotFound = [];
  for (var i = 0; i < this.dispCells.length; i++) {
    var cell = this.dispCells[i];
    cell.needRemain = false;
  }
  for (var i = 0; i < visiblePageIndexes.length; i++) {
    var pgIndex = visiblePageIndexes[i];
    var notfound = true;
    for (var k = 0; k < this.dispCells.length; k++) {
      var cell = this.dispCells[k];
      if (pgIndex == cell.getIndex()) {
        cell.needRemain = true;
        notfound = false;
        break;
      }
    }
    if (notfound) {
      indexesNotFound.push(pgIndex);
    }
  }
  for (var i = 0; i < this.dispCells.length;) {
    var cell = this.dispCells[i];
    if (!cell.needRemain) {
      this.addCellToBuffer(cell);
      this.dispCells.splice(i, 1);
      //      console.log("--- remove cell:" + cell.getIndex());
    } else {
      i++;
    }
  }
  for (var i = 0; i < indexesNotFound.length; i++) {
    var pgIndex = indexesNotFound[i];
    var cell = this.getCellForPage(pgIndex);
    this.dispCells.push(cell);
    // this.changeBackgroundColor();
    //    console.log("--- create cell:" + pgIndex);

    // Dispatcher.trigger(MDEvents.REFRESH_VERSIONS);
  }
};
MMAndroidCollectionView.prototype.displayCellsInCurViewPort = function () {
  var curLeft = this.container.scrollLeft;
  var curTop = this.container.scrollTop;
  var visiblePageIndexes = this.layout.getVisibleItemIndex(curLeft, curTop, this.viewSize);

  // var visiblePageIndexes =[];
  // for (var i = 0; i < this.pgNum; i++) {
  //  visiblePageIndexes.push(i);
  // };

  //  this.debugCellsInfo(visiblePageIndexes);

  var indexesNotFound = new Array();
  for (var i = 0; i < this.dispCells.length; i++) {
    var cell = this.dispCells[i];
    cell.needRemain = false;
  }
  for (var i = 0; i < visiblePageIndexes.length; i++) {
    var pgIndex = visiblePageIndexes[i];
    var notfound = true;
    for (var k = 0; k < this.dispCells.length; k++) {
      var cell = this.dispCells[k];
      if (pgIndex == cell.getIndex()) {
        cell.needRemain = true;
        notfound = false;
        break;
      }
    }
    if (notfound) {
      indexesNotFound.push(pgIndex);
    }
  }
  for (var i = 0; i < this.dispCells.length;) {
    var cell = this.dispCells[i];
    if (!cell.needRemain) {
      this.addCellToBuffer(cell);
      this.dispCells.splice(i, 1);
      //      console.log("--- remove cell:" + cell.getIndex());
    } else {
      i++;
    }
  }
  for (var i = 0; i < indexesNotFound.length; i++) {
    var pgIndex = indexesNotFound[i];
    var cell = this.getCellForPage(pgIndex);
    this.dispCells.push(cell);
    //    console.log("--- create cell:" + pgIndex);
  }

  //  if(!this.animateScroll){
  //    if(this.clickTimer != null){
  //      window.clearTimeout(this.clickTimer);
  //    }
  //
  //    var that = this;
  //    this.clickTimer = window.setBabelTimeout(function(e){
  ////      console.log("*****  time out   this.animateScroll = " + that.animateScroll);
  //      that.scrollToShowFullPage();
  //    }, 1000);
  //  }
};
MMAndroidCollectionView.prototype.debugCellsInfo = function (visiblePageIndexes) {
  if (!MMCommonFun.isArraysEqual(this.debug_visiblePages, visiblePageIndexes)) {
    this.debug_visiblePages = new Array();
    console.log("-------- ========   visible page indexs:------------------------");
    var str = "";
    for (var i = 0; i < visiblePageIndexes.length; i++) {
      this.debug_visiblePages.push(visiblePageIndexes[i]);
      str += visiblePageIndexes[i] + ", ";
    }
    console.log("***    >>>> " + str);
    str = "";
    for (var i = 0; i < this.dispCells.length; i++) {
      var cell = this.dispCells[i];
      str += cell.getIndex() + ", ";
    }
    console.log(" ^^^ displayed cells: [ " + str + "]");
    str = "";
    for (var i = 0; i < this.bufferCells.length; i++) {
      var cell = this.bufferCells[i];
      str += cell.getIndex() + ", ";
    }
    console.log(" ~~~~ buffered cells: [ " + str + "]");
  }
};
MMAndroidCollectionView.prototype.getCellForPage = function (pageIndex) {
  var cell = null;
  if (this.bufferCells.length > 0) {
    cell = this.bufferCells.shift();
  }
  if (cell == null) {
    cell = this.createCellForPage(pageIndex);
    cell.asSubViewTo(this.$contentDiv[0]);
  }
  cell.setIndex(pageIndex);
  cell.setSize(this.pageSize);
  var pos = this.layout.getItemPositionByIndex(pageIndex);
  cell.setPos(pos.x, pos.y);
  cell.setBackgroundColor("rgba(255, 0, 0, 0.0)");

  //  console.log("--------> cell position:(" + pos.x + "," + pos.y + ") - size(" + this.pageSize.width + "," + this.pageSize.height + ")");

  this.initCell(cell, pageIndex);
  return cell;
};
MMAndroidCollectionView.prototype.createCellForPage = function (pageIndex) {
  return new _MMCell["default"]();
};
MMAndroidCollectionView.prototype.initCell = function (cell, pageIndex) {};

// MMAndroidCollectionView.prototype.scrollToShowFullPage = function(){
//  var curLeft = this.container.scrollLeft;
//  var curTop = this.container.scrollTop;
//  var target = this.layout.getNearestTargetPosition(curLeft, curTop);

//  // Dispatcher.trigger(MDEvents.TASK_BOARD_STROLLING,0);

// // console.log("------ need auto scroll to (" + target.x + "," + target.y + ")");
//  if(Math.abs(curLeft - target.x) >= 1 || Math.abs(curTop - target.y) >= 1)
//    this.scrollToPosition(target, true);
// };

MMAndroidCollectionView.prototype.scrollToPosition = function (pos, animated, callback) {
  //  console.log("------called pos.x:" + pos.x);
  var finished = MMAndroidCollectionView.superClass_.scrollToPosition.call(this, pos, animated, callback);
  if (finished) {
    var newPage = this.getCurrentCellIndex();
    this.curPage = newPage;
    this.setOtherCellFitScreen();
    if (animated) {
      Dispatcher.trigger(_MDEvents["default"].SET_PAGE_INDEX, newPage);
    } else {
      this.displayCellsInCurViewPort();
    }
  }
  ;
};
MMAndroidCollectionView.prototype.setOtherCellFitScreen = function () {
  for (var i = 0; i < this.dispCells.length; i++) {
    var cell = this.dispCells[i];
    if (cell.getIndex() != this.curPage) {
      cell.checkToFitScreen();
    }
    ;
  }
  ;
};
MMAndroidCollectionView.prototype.scrollToNextPage = function (next, animated, callback) {
  var left = this.container.scrollLeft;
  var top = this.container.scrollTop;
  if (this.clickTimer != null) {
    window.clearTimeout(this.clickTimer);
    this.clickTimer = null;
  }
  if (animated == undefined || animated == null) {
    animated = true;
  }
  var nextPosition = this.layout.getNextTargetPosition(left, top, next, this.pgNum);
  this.scrollToPosition(nextPosition, animated, callback);

  // Dispatcher.trigger(MDEvents.TASK_BOARD_STROLLING,0);

  // Dispatcher.trigger(MDEvents.CLOSE_PANELS);

  return nextPosition.pgIndex;
};
MMAndroidCollectionView.prototype.hasNextPage = function (next) {
  var curPage = this.getCurrentCellIndex();
  if (next && curPage < this.pgNum - 1) {
    return true;
  }
  ;
  if (!next && curPage > 0) {
    return true;
  }
  ;
  return false;
};
MMAndroidCollectionView.prototype.changeToPage = function (index, animated) {
  if (animated == undefined || animated == null) {
    animated = false;
  }
  //  console.log("======== change to page:", index);
  if (index >= 0 && index < this.pgNum) {
    var target = this.layout.getItemPositionByIndex(index);
    this.scrollToPosition(target, animated);
    this.curPage = index;
  }
  return this.curPage;
};
MMAndroidCollectionView.prototype.setInitialPageIndex = function (index) {
  this.initialPage = index;
};
MMAndroidCollectionView.prototype.restoreToPage = function (index) {
  if (index >= 0 && index < this.pgNum) {
    var target = this.layout.getItemPositionByIndex(index);
    this.scrollToPosition(target, false);
    //        this.displayCellsInCurViewPort();
  }
};
MMAndroidCollectionView.prototype.scrollOffset = function (offset) {
  var left = this.container.scrollLeft;
  var top = this.container.scrollTop;
  if (offset !== 0) {
    Dispatcher.trigger(_MDEvents["default"].TASK_BOARD_STROLLING, offset);
  }
  if (this.layout.isScrollHorizontal()) {
    this.container.scrollLeft += offset.x;
  } else {
    this.container.scrollTop += offset.y;
  }
};
MMAndroidCollectionView.prototype.getVisibleCells = function () {
  if (!this.container) {
    return [];
  }
  ;
  var left = this.container.scrollLeft;
  var top = this.container.scrollTop;
  var indexes = this.layout.getVisibleItemIndex(left, top, this.viewSize);
  var visibleCells = new Array();
  for (var k = 0; k < indexes.length; k++) {
    var index = indexes[k];
    for (var i = 0; i < this.dispCells.length; i++) {
      var cell = this.dispCells[i];
      if (cell.getIndex() == index) {
        visibleCells.push(cell);
      }
    }
  }
  return visibleCells;
};
MMAndroidCollectionView.prototype.getCurrentCell = function () {
  var visibleCells = this.getVisibleCells();
  if (visibleCells.length > 0) {
    var left = this.container.scrollLeft;
    var top = this.container.scrollTop;
    var viewRect = new _rect["default"](left, top, this.viewSize.width, this.viewSize.height);
    var finalCell = visibleCells[0];
    var cellRect = finalCell.getRect();
    var interRct = _rect["default"].intersection(cellRect, viewRect);
    var maxArea = 0;
    if (interRct != null) maxArea = Math.abs(interRct.width * interRct.height);
    for (var i = 1; i < visibleCells.length; i++) {
      var cell = visibleCells[i];
      var cellRect = cell.getRect();
      var interRct = _rect["default"].intersection(cellRect, viewRect);
      var area = 0;
      if (interRct) {
        area = Math.abs(interRct.width * interRct.height);
      }
      if (area > maxArea) {
        maxArea = area;
        finalCell = cell;
      }
    }
    return finalCell;
  }
  return null;
};
MMAndroidCollectionView.prototype.getCurEditor = function () {
  var cell = this.getCurrentCell();
  if (cell != undefined && cell != null) {
    return cell.getEditor();
  }
  return null;
};
MMAndroidCollectionView.prototype.reloadData = function () {
  for (var i = 0; i < this.dispCells.length; i++) {
    var cell = this.dispCells[i];
    cell.removeFromSuperView();
  }
  for (var i = 0; i < this.bufferCells.length; i++) {
    var cell = this.bufferCells[i];
    cell.removeFromSuperView();
  }
  this.dispCells.splice(0, this.dispCells.length);
  this.bufferCells.splice(0, this.bufferCells.length);
  this.displayCellsInCurViewPort();
};
MMAndroidCollectionView.prototype.getCurrentCellIndex = function () {
  var pgIndex = this.layout.getCurPage(this.container.scrollLeft, this.container.scrollTop);
  return pgIndex;
};
MMAndroidCollectionView.prototype.getCellsCount = function () {
  return this.pgNum;
};
MMAndroidCollectionView.prototype.refreshView = function () {};
var _default = exports["default"] = MMAndroidCollectionView;

},{"1184":1184,"1432":1432,"1454":1454,"325":325,"339":339,"811":811,"823":823,"836":836,"913":913,"927":927,"928":928}],928:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MMCollectionFlowLayout;
var _size = _interopRequireDefault(require(837));
var _MMPoint = _interopRequireDefault(require(830));
/**
 *
 */

var g_pageError = 0.01;
function MMCollectionFlowLayout(itemSize, layoutDirection, itemSpacing) {
  this.itemSize = itemSize;
  this.layoutDirection = layoutDirection;
  this.itemSpacing = itemSpacing;
}
;
MMCollectionFlowLayout.prototype.setItemSize = function (size) {
  this.itemSize = new _size["default"](size.width, size.height);
};
MMCollectionFlowLayout.prototype.setDirection = function (direction) {
  this.layoutDirection = direction;
};
MMCollectionFlowLayout.prototype.isScrollHorizontal = function () {
  if (this.layoutDirection == "horizontal") {
    return true;
  } else {
    return false;
  }
};
MMCollectionFlowLayout.prototype.getContentSize = function (itemCount) {
  this.itemCount = itemCount;
  var contentSize = new _size["default"](0, 0);
  if (itemCount < 1) return contentSize;
  if (this.isScrollHorizontal()) {
    contentSize.width = this.itemSize.width * itemCount + this.itemSpacing * (itemCount - 1);
    contentSize.height = this.itemSize.height;
  } else {
    contentSize.height = this.itemSize.height * itemCount + this.itemSpacing * (itemCount - 1);
    contentSize.width = this.itemSize.width;
  }
  return contentSize;
};
MMCollectionFlowLayout.prototype.getVisibleItemIndex = function (left, top, viewSize, preload) {
  if (!this.itemSize) {
    return [];
  }
  ;
  if (!preload || preload < 0) {
    preload = 0;
  }
  ;
  var itemIndexes = new Array();
  var start = 0;
  var end = 0;
  if (this.isScrollHorizontal()) {
    start = Math.floor(left / (this.itemSize.width + this.itemSpacing) + g_pageError);
    end = Math.floor((left + viewSize.width) / (this.itemSize.width + this.itemSpacing) + g_pageError);
  } else {
    start = Math.floor(top / (this.itemSize.height + this.itemSpacing) + g_pageError);
    end = Math.floor((top + viewSize.height) / (this.itemSize.height + this.itemSpacing) + g_pageError);
  }
  if (start < 0) start = 0;
  if (end < 0) end = 0;
  if (preload > 0) {
    start -= preload / 2;
    if (start < 0) {
      end += preload / 2 - start;
      if (end >= this.itemCount) {
        end = this.itemCount - 1;
      }
      ;
      start = 0;
    } else {
      end += preload / 2;
      if (end >= this.itemCount) {
        start -= end - this.itemCount;
        end = this.itemCount - 1;
        if (start < 0) {
          start = 0;
        }
        ;
      }
      ;
    }
  }
  ;
  for (var i = start; i < end + 1; i++) {
    itemIndexes.push(i);
  }
  return itemIndexes;
};
MMCollectionFlowLayout.prototype.getCurPage = function (left, top) {
  var curPg = 0;
  var start, nextPg;
  if (!this.itemSize) {
    return 0;
  }
  ;
  if (this.isScrollHorizontal()) {
    var full = left / (this.itemSize.width + this.itemSpacing);
    start = Math.floor(full + g_pageError);
    nextPg = start + 1;
    if (nextPg * (this.itemSize.width + this.itemSpacing) - left > left + this.itemSize.width + this.itemSpacing - nextPg * (this.itemSize.width + this.itemSpacing)) {
      curPg = start;
    } else {
      curPg = nextPg;
    }
  } else {
    var full = top / (this.itemSize.height + this.itemSpacing);
    start = Math.floor(full + g_pageError);
    if (nextPg * this.itemSize.height - top > top + this.itemSize.height - nextPg * (this.itemSize.height + this.itemSpacing)) {
      curPg = start;
    } else {
      curPg = nextPg;
    }
  }
  return curPg;
};
MMCollectionFlowLayout.prototype.getNearestTargetPosition = function (left, top) {
  var target = new _MMPoint["default"](0, 0);
  if (this.isScrollHorizontal()) {
    var full = left / (this.itemSize.width + this.itemSpacing);
    var start = Math.floor(full + g_pageError);
    if (full - start > 0.5) {
      target.x = (start + 1) * (this.itemSize.width + this.itemSpacing);
    } else {
      target.x = start * (this.itemSize.width + this.itemSpacing);
    }
  } else {
    var full = top / (this.itemSize.height + this.itemSpacing);
    var start = Math.floor(full + g_pageError);
    if (full - start > 0.5) {
      target.y = (start + 1) * (this.itemSize.height + this.itemSpacing);
    } else {
      target.y = start * (this.itemSize.height + this.itemSpacing);
    }
  }
  return target;
};
MMCollectionFlowLayout.prototype.getNextTargetPosition = function (left, top, forward, maxPgNum) {
  var target = new _MMPoint["default"](0, 0);
  if (this.isScrollHorizontal()) {
    var full = left / (this.itemSize.width + this.itemSpacing);
    var start = Math.floor(full + g_pageError);
    if (forward && start < maxPgNum - 1) {
      target.x = (start + 1) * (this.itemSize.width + this.itemSpacing);
      target.pgIndex = start + 1;
    } else if (!forward) {
      if (Math.abs(start - full) < g_pageError) {
        start--;
        if (start < 0) start = 0;
      }
      target.x = start * (this.itemSize.width + this.itemSpacing);
      target.pgIndex = start;
    } else {
      target.x = left;
      target.y = top;
      target.pgIndex == start;
    }
  } else {
    var full = top / (this.itemSize.height + this.itemSpacing);
    var start = Math.floor(full);
    if (forward && start < maxPgNum - 1) {
      target.y = (start + 1) * (this.itemSize.height + this.itemSpacing);
      target.pgIndex = start + 1;
    } else if (!forward) {
      if (Math.abs(start - full) < g_pageError) {
        start--;
        if (start < 0) start = 0;
      }
      target.y = start * (this.itemSize.height + this.itemSpacing);
      target.pgIndex = start; //------------------------------------ 将下一页的页码返回
    } else {
      target.x = left;
      target.y = top;
      target.pgIndex == start;
    }
  }
  return target; //------------------------------------ 含有下一页的页码
};
MMCollectionFlowLayout.prototype.getItemPositionByIndex = function (index) {
  var origin = new _MMPoint["default"](0, 0);
  if (!this.itemSize) {
    return origin;
  }
  ;
  if (this.isScrollHorizontal()) {
    origin.x = this.itemSpacing * index + this.itemSize.width * index;
    origin.y = 0;
  } else {
    origin.x = 0;
    origin.y = this.itemSpacing * index + this.itemSize.height * index;
  }
  return origin;
};

},{"1184":1184,"1454":1454,"830":830,"837":837}],927:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _rect = _interopRequireDefault(require(836));
var _size = _interopRequireDefault(require(837));
/**
 * 此类用于控制显示一个 page
 */

function MMCell(parentDiv) {
  this.pageIndex = 0;
  this.remain = true;
  this.$rootDiv = $("<div class='page-cell' style='position:absolute;'></div>");
  this.rect = new _rect["default"](0, 0, 0, 0);
  this.asSubViewTo(parentDiv);
  this.$testDiv = null;
}
;
MMCell.prototype.asSubViewTo = function (parentDiv) {
  if (parentDiv != undefined && parentDiv != null) {
    $(parentDiv).append(this.$rootDiv);
  }
};
MMCell.prototype.setIndex = function (index) {
  this.pageIndex = index;
};
MMCell.prototype.getIndex = function () {
  return this.pageIndex;
};
MMCell.prototype.setSize = function (size) {
  this.size = new _size["default"](size.width, size.height);
  this.$rootDiv.css("width", size.width + "px");
  this.$rootDiv.css("height", size.height + "px");
  this.rect.width = size.width;
  this.rect.height = size.height;
};
MMCell.prototype.setPos = function (left, top) {
  this.$rootDiv.css("left", left + "px");
  this.$rootDiv.css("top", top + "px");
  this.rect.left = left;
  this.rect.top = top;
};
MMCell.prototype.setBackgroundColor = function (color) {
  this.$rootDiv.css("background-color", color);
};
MMCell.prototype.removeFromSuperView = function () {
  this.$rootDiv.remove();
};
MMCell.prototype.checkToFitScreen = function () {};
MMCell.prototype.getRect = function () {
  var rect = this.rect.clone();
  return rect;
};
MMCell.prototype.displayTestImages = function () {
  if (this.$testDiv) {
    this.$testDiv.remove();
  }
  ;
  this.$testDiv = $("<div class='test-div' style='position:relative; width:100%;height:100%;'></div>");
  this.$rootDiv.append(this.$testDiv);
  var imgIndex = this.pageIndex + 1;
  var total = 30;
  if (imgIndex >= total) {
    imgIndex = imgIndex % total + 1;
  }
  var cols = 1;
  var vols = 1;
  var w = 100 / cols;
  var h = 100 / vols;
  var x = 0;
  for (var i = 0; i < 1; i++) {
    var y = 0;
    for (var j = 0; j < 1; j++) {
      var $div = $("<div class = 'imgDiv' style = 'position:absolute; left:0px; top:0px;  background-color:blue; width:100px; height:100px;background-image:url(img/avatar/1.jpg);background-size:100px 100px'></div>");
      $div.css("left", x + "px");
      $div.css("top", y + "px");
      $div.css("width", w + "%");
      $div.css("height", h + "%");
      $div.css("background-size", w + "% " + h + "%");
      var ext = ".jpg";
      if (imgIndex > 16) {
        ext = ".JPG";
      }
      ;
      $div.css("background-image", "url(img/test/img" + imgIndex + ext + ")");
      this.$testDiv.append($div);
      y += 100;
    }
    x += 100;
  }

  // var x = 0;
  //    for(var i=0; i<10; i++){
  //        var y = 0;
  //        for(var j=0; j<10;j++){
  //            var $div = $("<div class = 'imgDiv' style = 'position:absolute; left:0px; top:0px;  background-color:rgba(255,0,0,0.5); width:20px; height:20px;'></div>");
  //            $div.css("left", x+"px");
  //            $div.css("top", y+"px");
  //            this.$testDiv.append($div);
  //            y+=40;
  //        }
  //        x+=40;
  //    }

  var $canvas = $("<canvas width='300px' height='500px' style='position:absolute; pointer-events:none'></canvas>");
  this.$testDiv.append($canvas);
  $canvas.css("left", "0px");
  $canvas.css("top", "0px");
  $canvas[0].onselectstart = function () {
    return false;
  };

  // setBabelTimeout(function(){
  var ctx = $canvas[0].getContext("2d");
  ctx.fillStyle = "f0f0ff";
  ctx.fillRect(20, 20, 150, 100);
  // },1000);

  var $cover = $("<div style='position:absolute; left:0px; top:0px; width:100%;height:100%;'></div>");
  this.$testDiv.append($cover);
};
MMCell.prototype.dispThumbnailAsBackground = function (imgObj) {
  var thumbUrl = imgObj.getThumbnailUrl(false);
  this.$rootDiv.css("background-size", "100% 100%");
  this.$rootDiv.css("background-repeat", "none");
  this.$rootDiv.css("background-image", "url(" + thumbUrl + ")");
};
MMCell.prototype.clearCellBackground = function (imgObj) {
  this.$rootDiv.css("background-image", 'none');
};
var _default = exports["default"] = MMCell;

},{"1184":1184,"1454":1454,"836":836,"837":837}],913:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1438);
require(1466);
var _MMBasicData = _interopRequireDefault(require(811));
var _size = _interopRequireDefault(require(837));
var _MDEvents = _interopRequireDefault(require(325));
var _MMRect = _interopRequireDefault(require(831));
var _MDDispOpLayer = _interopRequireDefault(require(917));
/**
 * 本类支持带有缩放且带有滚动条的 view
 * jiang
 * 2015-4-7
 */

//
//  类结构图 - pdf 和 图片显示的继承关系
//  类继承关系图(< 代表继承):
//
//  MMAndroidScrollView
//      |
//      |<--- MMCommonEditorView
//      |      |<--- MMPCImageEditor         图片的显示
//      |      |<--- MDPCSinglePagePdfView   单页的 pdf 文档显示
//      |
//      |<--- MMVerticalCollectionView
//      |      |<--- MMPDFCollectionView    多页 pdf 文件显示
//      |                 +------------- MMPdfPageCell
//      |                       +------------- MDPCPdfPageView
//      |
//      |<--- MMAndroidCollectionView
//             |<--- MMNetDiskImageCollectionView  手机图片文件的显示
//
//

/**
 * @param {HTMLElement} containerDiv  page scroll view's parent div
 * @param {String} scrollDirection 横向还是竖向滚动 "horizontal, vertical"
 * @param {?Number} pgnum 共有多少页
 */
function MMAndroidScrollView(containerDiv) {
  this.indebug = false;
  this.useJQueryMobile = false;
  this.enableInteraction = false;
  if (containerDiv instanceof $.fn.init) containerDiv = containerDiv[0];
  this.parentDiv = containerDiv;
  this.createSubView();

  // this.createSlider();

  this.refreshSize();
  this.swipeDirection = "none";
  this.swipeStarted = false;
  this.touching = false;
  this.scrolling = false;
  this.canScroll = true;
  this.enableEvents = true;
  this.dispAuxiliaryTimer = null;
  this.scale = 1.0;
  this.zooming = false;
  this.className = "MMAndroidScrollView";
}
;
MMAndroidScrollView.prototype.createSubView = function () {
  var $container = $("<div class='android-container' style='position:relative;overflow:hidden;-webkit-overflow-scrolling:none;pointer-events:none'></div>");
  $(this.parentDiv).append($container);

  // testing code
  if (this.indebug) {
    this.$debugTitle = $("<textarea class='debug-output' style='position:absolute;left:0px;top:0px;width:400px; height:200px; background-color:#aaaaaa'> log </textarea>");
    $(this.parentDiv).append(this.$debugTitle);
    this.$debugTitle.attr("class", "debug-output");
    this.$auixiliary = $("<div class='auxiliaryContainer' style='position:absolute;left:0px;top:0px;width:100%;height:100%;pointer-events:none' ></div>");
    $(this.parentDiv).append(this.$auixiliary);
    // var x = 0;
    //       for(var i=0; i<10; i++){
    //           var y = 0;
    //           for(var j=0; j<10;j++){
    //               var $div = $("<div class = 'imgDiv' style = 'position:absolute; left:0px; top:0px;  background-color:rgba(255,0,0,0.5); width:20px; height:20px;pointer-events:none'></div>");
    //               $div.css("left", x+"px");
    //               $div.css("top", y+"px");
    //               this.$auixiliary.append($div);
    //               y+=40;
    //           }
    //           x+=40;
    //       }
  }
  // -----------------------------------     test end

  this.container = $container[0];
  this.$wrap = $("<div class='scroll-wrap' style='position:absolute;width:0px;height:0px'></div>");
  $container.append(this.$wrap);
  this.$contentDiv = $("<div class='scroll-content' style='position: absolute; left: 0px; top: 0px;-webkit-overflow-scrolling:none;'> </div>");
  // this.$contentDiv.css("background-color", "black");// this is not a color: rgba(0.7, 0.7, 0.7, 1)
  $container.append(this.$contentDiv);
  if (!app.canDispInNormalBrowser()) {
    this.$touchEventLayer = $("<canvas class='touchEventLayer' style='position:absolute;overflow:hidden;left:0px;top:0px;width:100%;height:100%;background-color:rgba(255,0,0,0.0);z-index: 200000000; '></canvas>");
    $(this.parentDiv).append(this.$touchEventLayer);
  }
  $(this.parentDiv).css("overflow:hidden");
  if (this.useJQueryMobile) this.addJQueryMobileEvents();else this.addOriginEvents();
};
MMAndroidScrollView.prototype.setBackgroundColor = function (color) {
  $(this.container).css("background-color", color);
};
MMAndroidScrollView.prototype.disableSysTouchEvents = function () {
  if (!app.canDispInNormalBrowser()) {
    this.$touchEventLayer.css("pointer-events", "none");
  }
};
MMAndroidScrollView.prototype.setDebugTitle = function (title) {
  if (this.indebug) {
    this.$debugTitle.attr("class", "debug-output");
    this.$debugTitle.css("height", "200px");
    var text = this.$debugTitle.text() + "\n " + title;
    this.$debugTitle.text(text);
  }
};
MMAndroidScrollView.prototype.clearDebugTitle = function () {
  if (this.indebug) {
    this.$debugTitle.attr("class", "debug-output");
    this.$debugTitle.css("height", "200px");
    this.$debugTitle.text("");
  }
};
MMAndroidScrollView.prototype.addJQueryMobileEvents = function () {
  var that = this;
  $(this.container).scroll(function (event) {
    if (that.canScroll) {
      that.onScroll(event);
    }
    ;
  });

  /*  $(this.container).bind("touchend", function(event){
      that.onTouchUp();
    });
    $(this.container).bind("touchstart", function(event){
      that.touching = true;;
      that.swipeDirection = "none";
    });
  
    $(this.container).on("swipe", function(e){
      that.swipeHappened();
    });
      $(this.container).on("swipeleft", function(){
      that.swipeDirection = "swipeLeft";
    });
    $(this.container).on("swiperight", function(){
      that.swipeDirection = "swipeRight";
    });
      $(this.container).on("scrollstart", function(){
      console.log(" --- scroll start");
    }); */

  $(this.container).on("scrollstop", function () {
    if (that.canScroll) {
      that.scrollStopped();
    }
  });
  if (!this.enableInteraction) {
    return;
  }
  ;
  if (!app.canDispInNormalBrowser()) {
    var eventName = "vmousedown";
    this.$touchEventLayer.on(eventName, function (e) {});
    eventName = "vmousemove";
    this.$touchEventLayer.on(eventName, function (e) {});
    eventName = "vmouseup";
    this.$touchEventLayer.on(eventName, function (e) {});
  }
};
MMAndroidScrollView.prototype.getOperationLayer = function () {
  return this.$touchEventLayer[0];
};
MMAndroidScrollView.prototype.addOriginEvents = function () {
  var that = this;

  // that.setDebugTitle("--- add original events\n");

  $(this.container).bind("scroll", function (event) {
    if (that.canScroll) {
      that.onScroll(event);
      if (that.indebug) {
        // that.setDebugTitle("--- scroll happened!\n");
      }
      ;
    }
    ;
  });
  if (!this.enableInteraction) {
    return;
  }
  ;
  if (!app.canDispInNormalBrowser()) {
    var eventName;
    eventName = "touchstart";
    this.$touchEventLayer.bind(eventName, function (e) {
      that.panStart(e.originalEvent);
    });
    eventName = "touchmove";
    this.$touchEventLayer.bind(eventName, function (e) {
      that.panMove(e.originalEvent);
    });
    eventName = "touchend";
    this.$touchEventLayer.bind(eventName, function (e) {
      that.panEnd(e.originalEvent);
    });
  }
};
MMAndroidScrollView.prototype.panStart = function (e) {
  var that = this;
  if (that.canScroll) {
    // console.log("***--------> ", e.changedTouches[0].screenX);
    e.preventDefault();
    // if (e.currentTarget == that.$touchEventLayer[0]) {
    that.touching = true;
    that.animateScroll = false;
    that.swipeDirection = "none";
    this.scrolling = false;

    // that.clearDebugTitle();
    that.startX = e.changedTouches[0].screenX;
    that.startY = e.changedTouches[0].screenY;
    // }
  }
  ;
};
MMAndroidScrollView.prototype.panMove = function (e) {
  var scrollHappened = false; // 滚到边缘就不会在滚动了
  var that = this;
  if (that.canScroll) {
    // console.log("------ screen x:" + e.changedTouches[0].screenX);
    e.preventDefault();
    // if (e.currentTarget == that.$touchEventLayer[0]) {
    var oldLeft = that.container.scrollLeft;
    var oldTop = that.container.scrollTop;
    var offsetX = e.changedTouches[0].screenX - that.startX;
    var offsetY = e.changedTouches[0].screenY - that.startY;
    that.startX = e.changedTouches[0].screenX;
    that.startY = e.changedTouches[0].screenY;
    if (offsetX > 0) {
      that.swipeDirection = "swipeRight";
    } else if (offsetX < 0) {
      that.swipeDirection = "swipeLeft";
    } else {
      that.swipeDirection = "none";
    }

    // that.setDebugTitle("screenX:" + e.changedTouches[0].screenX + " startX:" + that.startX + " offset:" + offsetX + "  scrollLeft:" + that.container.scrollLeft);
    that.container.scrollLeft -= offsetX;
    that.container.scrollTop -= offsetY;
    if (Math.abs(that.container.scrollLeft - oldLeft) > 0.1 || Math.abs(that.container.scrollTop - oldTop) > 0.1) {
      scrollHappened = true;
    }
    ;
    // };
  }
  ;
  return scrollHappened;
};
MMAndroidScrollView.prototype.panEnd = function (e) {
  var that = this;
  if (that.canScroll) {
    // that.scrolling = false;
    that.onTouchUp();
    e.preventDefault();
  } else {
    console.error('cant scroll');
  }

  //console.log("touch end:" + e.changedTouches.length);
};
MMAndroidScrollView.prototype.setScrollable = function (canScroll) {
  this.canScroll = canScroll;
  if (!canScroll) {
    // console.log('set cant scroll');
  }
  ;
};
MMAndroidScrollView.prototype.onScroll = function (event) {
  // this.removeAuxiliary();

  // this.updateSliderMarkPosition();   更新滑块位置

  if (this.swipeDirection == "none") {
    this.swipeDirection = "scrolled";
  }
  ;
  this.scrolling = true;
  // this.setDebugTitle("scroll happened scrollLeft:" + this.container.scrollLeft);

  var timerSpan = 100;
  if (this.useJQueryMobile) {
    timerSpan = 1000;
  }
  ;
  var that = this;
  clearTimeout(this.dispAuxiliaryTimer);
  this.dispAuxiliaryTimer = setBabelTimeout(function () {
    if (that.animateScroll) {
      return;
    }
    ;
    if (!that.useJQueryMobile) {
      that.scrollStopped(); // 模拟 scroll stop 事件
    }
    ;
    if (!that.touching) {
      that.displayAuxiliary();
    }
    ;
    that.dispAuxiliaryTimer = null;

    // console.log('-------------- scroll stopped')
    Dispatcher.trigger(_MDEvents["default"].WindowScrolled);
    that.switchLapOpLayer();
  }.bind(this), timerSpan);
};
MMAndroidScrollView.prototype.tryToDispAuxiliaryInTimer = function () {
  var that = this;
  if (!this.dispAuxiliaryTimer) {
    this.dispAuxiliaryTimer = setBabelTimeout(function () {
      that.displayAuxiliary();
      that.dispAuxiliaryTimer = null;
    }.bind(this), 1000);
  }
  ;
};
MMAndroidScrollView.prototype.recordOriginScrollSize = function () {
  this.scrollSize = {
    width: this.container.scrollWidth,
    height: this.container.scrollHeight
  };
  this.offsetSize = {
    width: this.container.offsetWidth,
    height: this.container.offsetHeight
  };
  if (this.needRefreshSize()) {
    this.viewSize.width = this.parentDiv.offsetWidth;
    this.viewSize.height = this.parentDiv.offsetHeight;
  }
  ;
  this.setDebugTitle("----- scroll width:" + this.container.scrollWidth);
};

//
// 为了提高速度，将画面分为主画面和辅助画面，此处提供去除和现实辅助画面的机制
//
MMAndroidScrollView.prototype.removeAuxiliary = function () {
  // console.log("-------- remove aux");
  if (this.indebug) this.$auixiliary.css("display", "none");
};
MMAndroidScrollView.prototype.displayAuxiliary = function () {
  // console.log("-------- disp aux");
  if (this.indebug) this.$auixiliary.css("display", "block");
};
MMAndroidScrollView.prototype.onTouchUp = function (e) {
  this.touching = false;
};
MMAndroidScrollView.prototype.swipeHappened = function (e) {
  var left = this.container.scrollLeft;
  var top = this.container.scrollTop;
  if (!this.swipeStarted) {
    this.swipeStarted = true;
    this.startX = left;
  } else {
    if (left - this.startX > 1) {
      this.swipeDirection = "swipeRight";
    } else if (left - this.startX < 1) {
      this.swipeDirection = "swipeLeft";
    }
  }
};
MMAndroidScrollView.prototype.removeEvents = function () {
  $(this.container).off("swipeleft");
  $(this.container).off("swiperight");
  $(this.container).off("scrollstart");
  $(this.container).off("scrollstop");
};
MMAndroidScrollView.prototype.scrollStopped = function () {
  this.swipeStarted = false;
  if (!this.touching) {
    this.swipeDirection = "none";
  }
  ;
  this.scrolling = false;
  this.animateScroll = false;
};

//
//  测试专用  
//
//
var colorIndex = 0;
MMAndroidScrollView.prototype.changeBackgroundColor = function (color) {
  // var colors = ["#aaff00", "#aaffbb", "#aa00ff", "#00ffff", "#00ff00", "#0000ff"];
  // colorIndex++;
  // if (colorIndex >= colors.length) {
  //   colorIndex = 0;
  // };

  // var color = colors[colorIndex];

  this.$contentDiv.css("background-color", color);
};
MMAndroidScrollView.prototype.getRootDiv = function () {
  return this.container;
};
MMAndroidScrollView.prototype.getScrollContentDiv = function () {
  return this.$contentDiv[0];
};
MMAndroidScrollView.prototype.needRefreshSize = function () {
  if (this.viewSize == undefined || this.viewSize == null) {
    this.viewSize = {
      width: 0,
      height: 0
    };
  }
  if (this.viewSize.width != this.parentDiv.offsetWidth || this.viewSize.height != this.parentDiv.offsetHeight) {
    return true;
  }
  return false;
};
MMAndroidScrollView.prototype.refreshSize = function () {
  var suc = false;
  if (this.needRefreshSize()) {
    suc = true;
  }
  this.viewSize.width = this.parentDiv.offsetWidth;
  this.viewSize.height = this.parentDiv.offsetHeight;
  //
  $(this.container).css("width", this.viewSize.width + "px");
  $(this.container).css("height", this.viewSize.height + "px");
  if (!app.canDispInNormalBrowser()) {
    this.$touchEventLayer.attr("width", this.viewSize.width + "px");
    this.$touchEventLayer.attr("height", this.viewSize.height + "px");
  }
  if (suc && this.scale) {
    this.zoomDiv(this.scale);
  }
  ;
  return suc;
};
MMAndroidScrollView.prototype.setContentSize = function (size) {
  this.contentSize = {
    width: size.width,
    height: size.height
  };
  this.restoreDefaultTransform();
  this.$contentDiv.css("width", this.contentSize.width + "px");
  this.$contentDiv.css("height", this.contentSize.height + "px");

  // this.adjustSlider();
};
MMAndroidScrollView.prototype.restoreDefaultTransform = function () {
  // var scrollview = this.container;
  // var oldScrollWidth = scrollview.scrollWidth;
  // var oldOffsetWidth = scrollview.offsetWidth;

  this.$contentDiv.css("transform", "none");
  this.$wrap.css("transform", "none");

  // var that = this;
  // setBabelTimeout(function(){
  //  if (oldScrollWidth != scrollview.scrollWidth) {
  //    that.setDebugTitle("*** before scrollwidth:" + oldScrollWidth + ", offsetWidth" + oldOffsetWidth);
  //    that.setDebugTitle("*** after scrollwidth:" + scrollview.scrollWidth + ", offsetWidth" + scrollview.offsetWidth);
  //  };
  // }, 100);
};
MMAndroidScrollView.prototype.createSlider = function () {
  // 横向
  this.$sliderBox_h = $("<div class='slider-box' style='position:absolute;-webkit-overflow-scrolling:touch;'></div>");
  this.$sliderMarking_h = $("<div class='slider-mark' style='position:absolute;-webkit-overflow-scrolling:touch;'> </div>");
  this.$sliderBox_h.append(this.$sliderMarking_h);
  this.$sliderMarking_h.css("background-color", "rgba(0, 0, 0, 0.3)");
  $(this.parentDiv).append(this.$sliderBox_h);

  // 纵向
  this.$sliderBox_v = $("<div class='slider-box' style='position:absolute;-webkit-overflow-scrolling:touch;'></div>");
  this.$sliderMarking_v = $("<div class='slider-mark' style='position:absolute;-webkit-overflow-scrolling:touch;'> </div>");
  this.$sliderBox_v.append(this.$sliderMarking_v);
  this.$sliderMarking_v.css("background-color", "rgba(0, 0, 0, 0.3)");
  $(this.parentDiv).append(this.$sliderBox_v);
};
MMAndroidScrollView.prototype.adjustSlider = function () {
  this.adjustSliderFor(this.$sliderBox_h, this.$sliderMarking_h, true);
  this.adjustSliderFor(this.$sliderBox_v, this.$sliderMarking_v, false);
  this.updateSliderMarkPosition();
};

// 获得滚屏信息
MMAndroidScrollView.prototype.getScrollableInfo = function () {
  var scrollableInfo = {
    canMoveToLeft: false,
    canMoveToRight: false,
    canMoveToTop: false,
    canMoveToBottom: false
  };
  var view_left = this.container.scrollLeft;
  var view_top = this.container.scrollTop;
  var view_width = this.container.offsetWidth;
  var view_height = this.container.offsetHeight;
  var contentWidth = this.container.scrollWidth;
  var contentHeight = this.container.scrollHeight;
  if (view_left > 0) {
    scrollableInfo.canMoveToLeft = true;
  }
  if (view_top > 0) {
    scrollableInfo.canMoveToTop = true;
  }
  if (view_left + view_width < contentWidth) {
    scrollableInfo.canMoveToRight = true;
  }
  if (view_top + view_height < contentHeight) {
    scrollableInfo.canMoveToBottom = true;
  }
  return scrollableInfo;
};
MMAndroidScrollView.prototype.adjustSliderFor = function ($slider, $sliderMarking, horizontal) {
  // box
  var left = 0,
    top = 0,
    width = 0,
    height = 0;
  var w = 10;
  if (horizontal) {
    top = this.viewSize.height - w;
    width = this.viewSize.width;
    height = w;
  } else {
    left = this.viewSize.width - w;
    width = w;
    height = this.viewSize.height;
  }
  $slider.css("left", left + "px");
  $slider.css("top", top + "px");
  $slider.css("width", width + "px");
  $slider.css("height", height + "px");

  // marking
  var edge = 2;
  if (horizontal) {
    top = edge;
    width = this.viewSize.width / 2;
    height = w - 2 * edge;
  } else {
    left = edge;
    width = w - 2 * edge;
    height = this.viewSize.height / 2;
  }
  $sliderMarking.css("border-radius", w - 2 * edge + "px");
  $sliderMarking.css("left", left + "px");
  $sliderMarking.css("top", top + "px");
  $sliderMarking.css("width", width + "px");
  $sliderMarking.css("height", height + "px");
};
MMAndroidScrollView.prototype.updateSliderMarkPosition = function ($slider, $sliderMarking, horizontal) {
  if (this.viewSize.width < this.container.scrollWidth) {
    this.$sliderBox_h.css("display", "block");
    var boxW = this.viewSize.width;
    var markWidth = boxW * boxW / this.container.scrollWidth;
    var left = (boxW - markWidth) * this.container.scrollLeft / (this.container.scrollWidth - this.viewSize.width);
    this.$sliderMarking_h.css("left", left + "px");
    this.$sliderMarking_h.css("width", markWidth + "px");
  } else {
    this.$sliderBox_h.css("display", "none");
  }
  if (this.viewSize.height < this.container.scrollHeight) {
    this.$sliderBox_v.css("display", "block");
    var boxH = this.viewSize.height;
    var height = boxH * boxH / this.container.scrollHeight;
    var top = (boxH - height) * this.container.scrollTop / (this.container.scrollHeight - this.viewSize.height);
    this.$sliderMarking_v.css("top", top + "px");
    this.$sliderMarking_v.css("height", height + "px");
  } else {
    this.$sliderBox_v.css("display", "none");
  }
  if (this.sliderTimer != undefined && this.sliderTimer != null) {
    window.clearTimeout(this.sliderTimer);
  }
  var that = this;
  this.sliderTimer = window.setBabelTimeout(function (e) {
    that.$sliderBox_v.css("display", "none");
    that.$sliderBox_h.css("display", "none");
  }, 1000);
};
MMAndroidScrollView.prototype.scrollToShowFullPage = function () {
  var curLeft = this.container.scrollLeft;
  var curTop = this.container.scrollTop;
  var target = {
    x: 0,
    y: 0
  };
  if (curLeft < 0) {
    target.x = 0;
  } else if (curLeft + this.container.offsetWidth > this.container.scrollWidth) {
    target.x = this.container.scrollWidth - this.container.offsetWidth;
  } else {
    target.x = curLeft;
  }
  if (curTop < 0) {
    target.y = 0;
  } else if (curTop + this.container.offsetHeight > this.container.scrollHeight) {
    target.y = this.container.scrollHeight - this.container.offsetHeight;
  } else {
    target.y = curTop;
  }

  //  console.log("------ need auto scroll to (" + target.x + "," + target.y + ")");
  if (Math.abs(curLeft - target.x) >= 1 || Math.abs(curTop - target.y) >= 1) this.scrollToPosition(target, true);
};
MMAndroidScrollView.prototype.scrollToPosition = function (pos, animated, callback) {
  // ---------- test
  // if (!this.recordX) {

  // } else {
  //  if (pos.x < this.recordX) {
  //    console.log("hehe!");
  //  };
  // }
  // this.recordX = pos.x;
  // end

  if (pos.x < 0) {
    pos.x = 0;
  } else {
    if (pos.x + this.container.offsetWidth > this.container.scrollWidth) {
      pos.x = this.container.scrollWidth - this.container.offsetWidth;
    }
    ;
  }
  if (pos.y < 0) {
    pos.y = 0;
  } else {
    if (pos.y + this.container.offsetHeight > this.container.scrollHeight) {
      pos.y = this.container.scrollHeight - this.container.offsetHeight;
    }
    ;
  }
  var scrollFinished = false;
  this.animateScroll = true;
  var curLeft = this.container.scrollLeft;
  var curTop = this.container.scrollTop;
  if (animated != undefined && animated != null && animated) {
    var error = 10;
    var that = this;
    var dx = pos.x - curLeft;
    var dy = pos.y - curTop;
    var stepX = dx / 4;
    var stepY = dy / 4;
    //    if(dx > error) {
    //      stepX = error;
    //    } else if(dx < - error) {
    //      stepX = - error;
    //    }
    //    if(dy > error){
    //      stepY = error;
    //    } else if(dy < -error){
    //      stepY = - error;
    //    }

    var tx, ty;
    var finished = true;
    if (Math.abs(dx) < error) {
      tx = pos.x;
    } else {
      tx = curLeft + stepX;
      finished = false;
    }
    if (Math.abs(dy) < error) {
      ty = pos.y;
    } else {
      ty = curTop + stepY;
      finished = false;
    }
    this.container.scrollLeft = tx;
    this.container.scrollTop = ty;
    this.target = {
      x: pos.x,
      y: pos.y
    };
    if (!finished) {
      setBabelTimeout(function (e) {
        // console.log("------>>> call target.x:" + that.target.x);
        that.scrollToPosition(that.target, true, callback);
      }, 1000 / 36);
    } else {
      //console.log("1  set animate scroll to " + this.animateScroll);
      scrollFinished = true;
    }
  } else {
    this.container.scrollLeft = pos.x;
    this.container.scrollTop = pos.y;
    scrollFinished = true;

    //console.log("2 set animate scroll to " + this.animateScroll);
  }
  if (scrollFinished) {
    this.animateScroll = false;
    if (callback) {
      callback();
    }
    ;
  }
  ;
  return scrollFinished;
};
MMAndroidScrollView.prototype.scrollOffset = function (offset) {
  this.container.scrollLeft += offset.x;
  this.container.scrollTop += offset.y;
};
MMAndroidScrollView.prototype.scrollPageUp = function () {
  this.scrollOffset({
    x: 0,
    y: -this.container.offsetHeight
  });
};
MMAndroidScrollView.prototype.scrollPageDown = function () {
  this.scrollOffset({
    x: 0,
    y: this.container.offsetHeight
  });
};
MMAndroidScrollView.prototype.getScale = function () {
  return this.scale;
};
MMAndroidScrollView.prototype.zoomToFit = function () {
  if (this.scrollSize) {
    var scaleX = this.offsetSize.width / this.scrollSize.width;
    var scaleY = this.offsetSize.height / this.scrollSize.height;
    var scale = scaleX < scaleY ? scaleX : scaleY;
    this.zoomDiv(scale);
    this.setDebugTitle("*** scale:" + scale);
  }
  ;
};

//
//  缩放到宽度适合屏幕，即不能出现横向的滚动条
//
MMAndroidScrollView.prototype.zoomToFitWidth = function () {
  // this.restoreDefaultTransform();

  var scaleX = this.offsetSize.width / this.scrollSize.width;
  var scaleY = this.offsetSize.height / this.scrollSize.height;

  // if (app.canDispInNormalBrowser() && scaleY < scaleX) {  // 此时在宽度适合时，高度一定超出, 右侧会出现滚动条，导致会挡住部分宽度内容，从而又导致出现下面出现滚动条
  //  // 让出滚动条的宽度，从新计算比例
  //  scaleX = (scrollview.offsetWidth - 60) / scrollview.scrollWidth;
  // };

  var scale = scaleX < 1 ? scaleX : 1;
  this.zoomDiv(scale);
  $(this.container).css("overflow-x", "hidden");
  return scale;
};
MMAndroidScrollView.prototype.pinchStart = function (scale) {
  this.oldScale = this.scale;
  this.setScrollable(false);
  this.zooming = true;
};
MMAndroidScrollView.prototype.pinchMove = function (scale) {
  this.setScrollable(false);
  // console.log("-- zooming: " + scale);
  scale = this.scale * scale;
  this.zoomDiv(scale);
};
MMAndroidScrollView.prototype.pinchEnd = function (scale, callback) {
  console.log("####### zoom end #######");
  this.zooming = false;
  this.setScrollable(true);
  if (!app.canDispInNormalBrowser()) {
    this.changeDivSizeForZoom(callback);
  }
  ;
};
MMAndroidScrollView.prototype.changeDivSizeForZoom = function (callback) {
  //{! deleted by jiang, 2015-12-10
  //  手机中当文件管理画面较长时，打开编辑器，缩小时，编辑器突然消失
  // document.body.style.webkitTransform = 'scale(1)';

  //!}

  var that = this;
  this.checkToMaintainMinimalSize(function () {
    var containerSize = {
      w: $(that.container).width(),
      h: $(that.container).height()
    };
    var originConentSize = {
      w: that.$contentDiv.width(),
      h: that.$contentDiv.height()
    };
    var scaledSize = {
      w: originConentSize.w * that.scale,
      h: originConentSize.h * that.scale
    };
    var tr = MMCommonFun.getElementTranslate(that.$contentDiv);
    var curScale = that.scale;
    that.scale = 1.0;
    that.$contentDiv.css("transform-origin", "0% 0%");
    that.$contentDiv.css("transform", " translate(0px,0px) " + " scale(1,1)");
    that.$contentDiv.css("width", scaledSize.w + "px");
    that.$contentDiv.css("height", scaledSize.h + "px");
    $(that.container).css('overflow', 'hidden');
    $(that.container).css('overflow', 'auto');

    // 这些代码本质上没有意义，但可以保障更新 container 的 scrollWidth 和 scrollHeight
    that.$contentDiv[0].style.display = 'none';
    that.$contentDiv[0].offsetHeight;
    that.$contentDiv[0].style.display = '';
    that.container.style.display = 'none';
    that.container.offsetHeight;
    that.container.style.display = '';

    // setBabelTimeout(function(){
    that.container.scrollLeft = -tr.x;
    that.container.scrollTop = -tr.y;
    console.log("======= scrollSize:" + that.container.scrollWidth + ", " + that.container.scrollHeight);
    console.log("******* scrollLeft:" + that.container.scrollLeft + ", scrollTop:" + that.container.scrollTop + " scrollHeight:" + that.container.scrollHeight);
    if (callback && Math.abs(that.oldScale - curScale) > 0.1) {
      callback();
    }
    ;

    // }, 100);
  });
};
MMAndroidScrollView.prototype.zoomDiv = function (scale) {
  if (!this.scrollSize) {
    return;
  }
  ;

  // document.body.style.webkitTransform = 'scale(1)';

  var tr = MMCommonFun.getElementTranslate(this.$contentDiv);
  if (this.container.scrollLeft > 0) {
    tr.x -= this.container.scrollLeft;
  }
  ;
  if (this.container.scrollTop > 0) {
    tr.y -= this.container.scrollTop;
  }
  ;
  this.container.scrollLeft = 0;
  this.container.scrollTop = 0;
  // this.$contentDiv.css("transform-origin", "0% 0%");
  // this.$contentDiv.css("transform", " translate(" + tr.x +"px," + tr.y +"px) " + " scale(" + 1 + "," + 1 + ")");
  // return;

  var containerSize = {
    w: $(this.container).width(),
    h: $(this.container).height()
  };
  var originConentSize = {
    w: this.$contentDiv.width(),
    h: this.$contentDiv.height()
  };

  //console.log("origin contianer size:(" + containerSize.w + " ," + containerSize.h + ") - (" +  originConentSize.w + " ," + originConentSize.h + ")")

  var scaledSize = {
    w: originConentSize.w * this.scale,
    h: originConentSize.h * this.scale
  };
  var centerX = (containerSize.w / 2 - tr.x) / scaledSize.w;
  var centerY = (containerSize.h / 2 - tr.y) / scaledSize.h;

  //console.log('***-------> center:(' + centerX + "," + centerY + ") - tr:(" + tr.x + "," + tr.y + ")");

  this.scale = scale;
  var newScaleSize = {
    w: originConentSize.w * scale,
    h: originConentSize.h * scale
  };
  centerX = centerX * newScaleSize.w;
  centerY = centerY * newScaleSize.h;
  tr.x = containerSize.w / 2 - centerX;
  tr.y = containerSize.h / 2 - centerY;
  if (tr.x > 0 && containerSize.w < newScaleSize.w) {
    tr.x = 0;
  }
  ;
  if (tr.y > 0 && containerSize.h < newScaleSize.h) {
    tr.y = 0;
  }
  ;

  // test
  var centerX = (containerSize.w / 2 - tr.x) / newScaleSize.w;
  var centerY = (containerSize.h / 2 - tr.y) / newScaleSize.h;
  //console.log('***-------> center:(' + centerX + "," + centerY + ") - tr:(" + tr.x + "," + tr.y + ")");

  // end

  this.$contentDiv.css("transform-origin", "0% 0%");
  this.$contentDiv.css("transform", " translate(" + tr.x + "px," + tr.y + "px) " + " scale(" + scale + "," + scale + ")");
  tr = MMCommonFun.getElementTranslate(this.$contentDiv);
  //console.log('>>>-------> center:(' + centerX + "," + centerY + ") - tr:(" + tr.x + "," + tr.y + ")");

  // console.log('scale = ' + this.scale);

  if (this.scale) {
    Dispatcher.trigger(_MDEvents["default"].SCALE_CHANGED, this.scale, this);
  }
  ;

  // document.body.style.webkitTransform = 'scale(1)';

  return scale;
};
MMAndroidScrollView.prototype.old_zoomDiv2 = function (scale) {
  if (!this.scrollSize) {
    return;
  }
  ;
  $(this.container).css('overflow', 'auto');
  this.scale = scale;

  // document.body.style.webkitTransform = 'scale(1)';

  var containerSize = {
    w: $(this.container).width(),
    h: $(this.container).height()
  };
  var originConentSize = {
    w: this.$contentDiv.width(),
    h: this.$contentDiv.height()
  };
  var scrollview = this.container;
  var centerX = (scrollview.scrollLeft + containerSize.w / 2) / scrollview.scrollWidth;
  var centerY = (scrollview.scrollTop + containerSize.h / 2) / scrollview.scrollHeight;
  this.$contentDiv.css("transform-origin", "0% 0%");
  var newContentSize = {
    w: originConentSize.w * scale,
    h: originConentSize.h * scale
  };
  var translate = {
    x: 0,
    y: 0
  };
  if (newContentSize.w > containerSize.w) {
    scrollview.scrollLeft = newContentSize.w * centerX - scrollview.offsetWidth / 2;
  } else {
    translate.x = -(newContentSize.w - containerSize.w) / 2;
  }
  if (newContentSize.h > containerSize.h) {
    scrollview.scrollTop = newContentSize.h * centerY - scrollview.offsetHeight / 2;
  } else {
    translate.y = -(newContentSize.h - containerSize.h) / 2;
  }
  this.$contentDiv.css("transform", " translate(" + translate.x + "px," + translate.y + "px) " + " scale(" + scale + "," + scale + ")");
  $(this.container).css("width", $(this.container).css('width'));
  console.log("*** content width:" + this.$contentDiv.width() + " disp width:" + scrollview.scrollWidth);
  $(this.container).addClass("zooming");
  if (this.scale) {
    Dispatcher.trigger(_MDEvents["default"].SCALE_CHANGED, this.scale, this);
  }
  ;

  // document.body.style.webkitTransform = 'scale(1)';

  $(this.container).css('overflow', 'hidden');
  return scale;
};
MMAndroidScrollView.prototype.old_zoomDiv1 = function (scale) {
  if (!this.scrollSize) {
    return;
  }
  ;
  this.scale = scale;
  var scrollview = this.container;
  var centerX = (scrollview.scrollLeft + scrollview.offsetWidth / 2) / scrollview.scrollWidth;
  var centerY = (scrollview.scrollTop + scrollview.offsetHeight / 2) / scrollview.scrollHeight;
  this.restoreDefaultTransform();
  var originScrollW = this.scrollSize.width;
  var originScrollH = this.scrollSize.height;
  this.$contentDiv.css("transform", "scale(" + scale + "," + scale + ")");

  // calculate translation
  var newWidth = originScrollW * scale;
  var newHeight = originScrollH * scale;
  var newX = (newWidth - originScrollW) / 2;
  var newY = (newHeight - originScrollH) / 2;
  if (newX < 0) {
    if (scrollview.offsetWidth > newWidth) {
      newX += (scrollview.offsetWidth - newWidth) / 2;
    }
    ;
  }
  ;
  if (newY < 0) {
    if (scrollview.offsetHeight > newHeight) {
      newY += (scrollview.offsetHeight - newHeight) / 2;
    }
    ;
  }
  ;
  this.$wrap.css("transform", "translate(" + newX + "px," + newY + "px)");
  var scrollLeft = scrollview.scrollWidth * centerX - scrollview.offsetWidth / 2;
  var scrollTop = scrollview.scrollHeight * centerY - scrollview.offsetHeight / 2;
  if (scrollLeft > 0) {
    scrollview.scrollLeft = scrollLeft;
  }
  ;
  if (scrollTop > 0) {
    scrollview.scrollTop = scrollTop;
  }
  ;

  // $('#content').css("width", newWidth + "px");
  // $('#content').css("height", newHeight + "px");
  // console.log('---- transform:' + $('#content').css('transform'));

  $(this.container).css("overflow", "auto");
  if (this.scale) {
    Dispatcher.trigger(_MDEvents["default"].SCALE_CHANGED, this.scale, this);
  }
  ;
  return scale;
};

// MMAndroidScrollView.prototype.zoomTo = function(scale){
//  var center = {x:0, y:0};
//  center.x = (this.container.scrollLeft + this.container.offsetWidth / 2) / this.container.scrollWidth;
//  center.y = (this.container.scrollTop + this.container.offsetHeight / 2) / this.container.scrollHeight;

//  this.scale = scale;
//  this.$contentDiv.css("transform-origin", "0% 0%");
//  this.$contentDiv.css("transform", "scale(" + scale + "," + scale + ")");

//  var pos = {x:0, y:0};
//  pos.x = center.x * this.container.scrollWidth - this.container.offsetWidth / 2;
//  pos.y = center.y * this.container.scrollHeight - this.container.offsetHeight / 2;

//  this.scrollToPosition(pos, false);
// };

//
// 检测显示不要小于当前屏幕 也不能大于原尺寸的 2 倍
//
MMAndroidScrollView.prototype.checkToMaintainMinimalSize = function (callback) {
  var bodyEvent = $('body').css('pointer-events');
  if (bodyEvent != 'none') {
    this.bodyEvent = bodyEvent;
  }
  ;
  $('body').css('pointer-events', 'none');
  var containerSize = {
    w: $(this.container).width(),
    h: $(this.container).height()
  };
  var originConentSize = {
    w: this.$contentDiv.width(),
    h: this.$contentDiv.height()
  };
  var scaledSize = {
    w: originConentSize.w * this.scale,
    h: originConentSize.h * this.scale
  };
  var targetScale = 0.0;
  if (scaledSize.w < containerSize.w) {
    targetScale = containerSize.w / originConentSize.w;
  } else if (scaledSize.w > containerSize.w * 2) {
    targetScale = containerSize.w * 2 / originConentSize.w;
    ;
  } else {
    this.restoreBodyEvent();
    if (callback) {
      callback();
    }
    ;
  }
  if (targetScale > 0) {
    if (Math.abs(targetScale - this.scale) < 0.05) {
      this.zoomDiv(targetScale);
      this.restoreBodyEvent();
      if (callback) {
        callback();
      }
      ;
    } else {
      this.zoomDiv((this.scale + targetScale) / 2);
      var that = this;
      setBabelTimeout(function () {
        that.checkToMaintainMinimalSize(callback);
      }, 10);
    }
  }
  ;
};
MMAndroidScrollView.prototype.restoreBodyEvent = function () {
  if (this.bodyEvent) {
    $('body').css('pointer-events', this.bodyEvent);
    this.bodyEvent = null;
  }
  ;
};
MMAndroidScrollView.prototype.checkToFitParentDiv = function () {
  var that = this;
  var containerSize = {
    w: $(that.container).width(),
    h: $(that.container).height()
  };
  var originConentSize = {
    w: that.$contentDiv.width(),
    h: that.$contentDiv.height()
  };
  var scaledSize = {
    w: originConentSize.w * that.scale,
    h: originConentSize.h * that.scale
  };
  that.scale = 1.0;
  that.$contentDiv.css("transform", " translate(0px,0px) " + " scale(1,1)");
  if (containerSize.w != originConentSize.w) {
    that.$contentDiv.css("width", containerSize.w + "px");
    that.$contentDiv.css("height", containerSize.h + "px");
    return true;
  }
  ;
  return false;
};
MMAndroidScrollView.prototype.zoomEnded = function (callback) {
  // var center = {x:0, y:0};
  // center.x = (this.container.scrollLeft + this.container.offsetWidth / 2) / this.container.scrollWidth;
  // center.y = (this.container.scrollTop + this.container.offsetHeight / 2) / this.container.scrollHeight;

  // var contentSize = {
  //    width:0,
  //    height:0
  // };
  // contentSize.width = this.container.scrollWidth;
  // contentSize.height = this.container.scrollHeight;
  // this.setContentSize(contentSize);

  // var pos = {x:0, y:0};
  // pos.x = center.x * this.container.scrollWidth - this.container.offsetWidth / 2;
  // pos.y = center.y * this.container.scrollHeight - this.container.offsetHeight / 2;

  // this.scrollToPosition(pos, false);
};
MMAndroidScrollView.prototype.getCenterRatioPosition = function () {
  var center = {
    x: 0,
    y: 0
  };
  center.x = (this.container.scrollLeft + this.container.offsetWidth / 2) / this.container.scrollWidth;
  center.y = (this.container.scrollTop + this.container.offsetHeight / 2) / this.container.scrollHeight;
  return center;
};
MMAndroidScrollView.prototype.restoreCenterPostion = function (ratioCenter) {
  var pos = {
    x: 0,
    y: 0
  };
  pos.x = ratioCenter.x * this.container.scrollWidth - this.container.offsetWidth / 2;
  pos.y = ratioCenter.y * this.container.scrollHeight - this.container.offsetHeight / 2;
  this.scrollToPosition(pos, false);
};
MMAndroidScrollView.prototype.getWidth = function () {
  var contentW = parseInt($(this.parentDiv).css('width'));
  return contentW;
};
MMAndroidScrollView.prototype.useTransformToScale = function () {
  //this.hotZoneCtl = new MMHotZoneDispCtl(this.$root[0]);
  return false;
  if (!app.canDispInNormalBrowser()) {
    return true;
  }
  ;
  return false;
};
MMAndroidScrollView.prototype.removeFromSuperView = function () {
  if (this.container) {
    $(this.container).remove();
  }
  ;
  this.removed = true;
};
MMAndroidScrollView.prototype.getScrollView = function () {
  return this.container;
};
MMAndroidScrollView.prototype.getClassName = function () {
  return this.className;
};
MMAndroidScrollView.prototype.getScrollViewSize = function () {
  var size = new _size["default"](this.container.clientWidth, this.container.clientHeight);
  return size;
};

// 滚动显示 div 的中心
MMAndroidScrollView.prototype.scrollToShowDiv = function (objDiv) {
  var scrollView = this.container;
  var divPos = MMCommonFun.getDivCenter($(objDiv));
  var divPosInScroll = MMCommonFun.convertPointBetweenElements(objDiv, scrollView, divPos);
  this.scrollToShow(divPosInScroll);
};
MMAndroidScrollView.prototype.scrollToShow = function (divPosInScroll) {
  var viewSize = this.getScrollViewSize();
  var scrollView = this.container;
  var contentSize = new _size["default"](scrollView.scrollWidth, scrollView.scrollHeight);
  var left = scrollView.scrollLeft;
  var top = scrollView.scrollTop;
  var w = 0;
  var expand = 80;
  if (divPosInScroll.x + expand > left + viewSize.width - w) {
    console.log("scroll left:" + window.pageXOffset);
    var distX = divPosInScroll.x + expand - (left + viewSize.width - w); //left + viewSize.width
    left += distX;
    console.log("scroll left:" + window.pageXOffset);
  } else if (divPosInScroll.x - expand < left) {
    left = divPosInScroll.x - expand;
  }
  if (divPosInScroll.y + expand > top + viewSize.height) {
    var distY = divPosInScroll.y + expand - (top + viewSize.height);
    top += distY;
  } else if (divPosInScroll.y - expand < top) {
    top = divPosInScroll.y - expand;
  }
  scrollView.scrollLeft = left;
  scrollView.scrollTop = top;
};
MMAndroidScrollView.prototype.scrollToShowLink = function (divPosInScroll, height) {
  var viewSize = this.getScrollViewSize();
  var scrollView = this.container;
  var contentSize = new _size["default"](scrollView.scrollWidth, scrollView.scrollHeight);
  var left = scrollView.scrollLeft;
  var top = scrollView.scrollTop;
  var w = 0;
  var expand = 80;
  if (divPosInScroll.x + expand > left + viewSize.width - w) {
    console.log("scroll left:" + window.pageXOffset);
    var distX = divPosInScroll.x + expand - (left + viewSize.width - w); //left + viewSize.width
    left += distX;
    console.log("scroll left:" + window.pageXOffset);
  } else if (divPosInScroll.x - expand < left) {
    left = divPosInScroll.x - expand;
  }
  if (divPosInScroll.y + expand > top + viewSize.height) {
    var distY = divPosInScroll.y + expand - (top + viewSize.height);
    top += distY + height;
  } else if (divPosInScroll.y - expand < top) {
    top = divPosInScroll.y - expand;
  }
  scrollView.scrollLeft = left;
  scrollView.scrollTop = top;
};
MMAndroidScrollView.prototype.followTeacher = function (dispPosition, callback) {
  if (dispPosition.fileDim != '2D') {
    if (callback) {
      callback();
    }
    ;
    return;
  }
  ;
  this.scale = dispPosition.scale;
  var that = this;
  this.zoomDiv(this.scale);
  setBabelTimeout(function () {
    if (dispPosition.centerPos) {
      that.restoreCenterPostion(dispPosition.centerPos);
    } else {
      that.restoreCenterLogicPosition(dispPosition.lgCenter);
    }
    if (callback) {
      callback();
    }
    ;
  }, 100);
};
MMAndroidScrollView.prototype.setReadOnly = function () {
  this.editorReadOnly = true;
};
MMAndroidScrollView.prototype.createOverLapOpLayer = function () {
  this.enabledOLOLayer = true;
  if (this.$overlapOpLayer) {
    return;
  }
  ;
  this.overlapOpLayer = [];
  this.overlapOpLayer[0] = new _MDDispOpLayer["default"]();
  this.overlapOpLayer[1] = new _MDDispOpLayer["default"]();
  this.curOpLayerIndex = 0;
  this.switchLapOpLayer();
};
MMAndroidScrollView.prototype.getCurLayer = function () {
  return this.overlapOpLayer[this.curOpLayerIndex];
};
MMAndroidScrollView.prototype.switchLapOpLayer = function () {
  if (this.curOpLayerIndex == undefined) {
    return;
  }
  ;
  var cur = this.curOpLayerIndex + 1;
  if (cur == 2) {
    cur = 0;
  }
  ;
  var curLayer = this.overlapOpLayer[cur];
  curLayer.remove();
  curLayer.appendTo(this.$contentDiv);
  var rect = this.getViewPortRect();
  rect.shrink(30);
  curLayer.setPosition(rect);
  this.getCurLayer().remove();
  this.curOpLayerIndex = cur;
  this.getCurLayer().enableMouseEvent(this.enabledOLOLayer);
};
MMAndroidScrollView.prototype.enableOverLapOpLayerEvents = function (enable) {
  this.enabledOLOLayer = enable;
  if (this.enabledOLOLayer) {
    this.getCurLayer().css('pointer-events', 'auto');
  } else {
    this.getCurLayer().css('pointer-events', 'none');
  }
};
MMAndroidScrollView.prototype.getViewPortRect = function () {
  var viewPort = new _MMRect["default"]();
  viewPort.setRct(this.container.scrollLeft, this.container.scrollTop, this.container.offsetWidth, this.container.offsetHeight);
  return viewPort;
};
var _default = exports["default"] = MMAndroidScrollView;

},{"1184":1184,"1438":1438,"1454":1454,"1466":1466,"325":325,"811":811,"831":831,"837":837,"917":917}],917:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDOpElType = _interopRequireDefault(require(924));
var _MDOpRectController = _interopRequireDefault(require(918));
// MDDispOpLayer.js
//
// jiang
// 2017-7-24

function MDDispOpLayer(parent) {
  this.$el = $('<div class="overlap-layer" >' + '<canvas></canvas>' + '</div>');
  this.setOperationType(_MDOpElType["default"].OpText);
}
;
MDDispOpLayer.prototype = function () {
  //----------------------------------------------------------------------------------------------------
  //       private function
  //----------------------------------------------------------------------------------------------------

  //----------------------------------------------------------------------------------------------------
  //       private function
  //----------------------------------------------------------------------------------------------------

  return {
    contstructor: MDDispOpLayer,
    appendTo: function appendTo($parent) {
      var self = this;
      this.$el.off();
      $parent.append(this.$el);
      this.$el.on('mousedown', function (e) {
        self._mouseDown(e);
      });
      this.$el.on('mousemove', function (e) {
        self._mouseMove(e);
      });
      this.$el.on('mouseup', function (e) {
        self._mouseUp(e);
      });
    },
    setOperationType: function setOperationType(type) {
      this.opType = type;
      this.opCtl = new _MDOpRectController["default"](this.$el, this.opType);
    },
    _mouseDown: function _mouseDown(e) {
      this.mouseMoveEnough = false;
      this.down = true;
      this.opCtl.mouseDown(e);
    },
    _mouseMove: function _mouseMove(e) {
      if (this.down) {
        this.opCtl.mouseMove(e);
      }
      ;
    },
    _mouseUp: function _mouseUp(e) {
      if (this.down) {
        this.opCtl.mouseUp(e);
      }
      ;
      this.down = false;
    },
    setPosition: function setPosition(rect) {
      var $curLayer = this.$el;
      $curLayer.css('position', 'absolute');
      $curLayer.css('left', rect.left + 'px');
      $curLayer.css('top', rect.top + 'px');
      $curLayer.css('width', rect.getWidth() + 'px');
      $curLayer.css('height', rect.getHeight() + 'px');
    },
    enableMouseEvent: function enableMouseEvent(enable) {
      if (enable) {
        this.$el.css('pointer-events', 'auto');
      } else {
        this.$el.css('pointer-events', 'none');
      }
    },
    remove: function remove() {
      this.$el.remove();
      this.$el.off();
    }
  };
}();
var _default = exports["default"] = MDDispOpLayer;

},{"1184":1184,"1454":1454,"918":918,"924":924}],918:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDTextHtmlElement = _interopRequireDefault(require(926));
var _MDCircleHtmlElement = _interopRequireDefault(require(921));
var _MDRectHtmlElement = _interopRequireDefault(require(925));
var _MDOpElType = _interopRequireDefault(require(924));
var _MDSelectFrame = _interopRequireDefault(require(919));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MMRect = _interopRequireDefault(require(831));
// MDOpRectController.js
// 方形对象的选中控制， 包括 矩形， 圆， 文本框
// jiang
// 2017-7-24

function MDOpRectController(editor, elCtl, $parent, type) {
  this.editor = editor;
  this.elCtl = elCtl;
  this.type = type;
  this.$parent = $parent;
  this.$el = $('<div class="op-obj op-rect">' + '</div>');
  this.construct();
}
;
MDOpRectController.prototype = function () {
  //----------------------------------------------------------------------------------------------------
  //       private function
  //----------------------------------------------------------------------------------------------------

  //----------------------------------------------------------------------------------------------------
  //       public function
  //----------------------------------------------------------------------------------------------------

  return {
    contstructor: MDOpRectController,
    construct: function construct() {},
    mouseDown: function mouseDown(e) {
      this.rect = new _MMRect["default"]();
      this.$parent.append(this.$el);
      var pos = _MMCommonFun["default"].getMousePosition(e, this.$parent[0]);
      this.rect.left = this.rect.right = pos.x;
      this.rect.top = this.rect.bottom = pos.y;
      this.mouseMoveEnough = false;
      if (this.type == _MDOpElType["default"].OpRect) {
        this.mdEl = new _MDRectHtmlElement["default"](this.elCtl, this.$parent, this.rect);
      } else if (this.type == _MDOpElType["default"].OpCircle) {
        this.mdEl = new _MDCircleHtmlElement["default"](this.elCtl, this.$parent, this.rect);
      } else if (this.type == _MDOpElType["default"].OpText) {
        this.mdEl = new _MDTextHtmlElement["default"](this.elCtl, this.$parent, this.rect);
      }
      ;
      this.mdEl.setEditorViewCtl(this.editor);
      this.mdEl.refresh();
      console.log('1 ------------ mouse down!');
    },
    mouseMove: function mouseMove(e) {
      var pos = _MMCommonFun["default"].getMousePosition(e, this.$parent[0]);
      this.rect.right = pos.x;
      this.rect.bottom = pos.y;
      if (this.rect.getWidth() > 10 || this.rect.getHeight() > 10) {
        this.mouseMoveEnough = true;
        this.mdEl.refresh();
      }
      ;
      console.log('2 ------------ mouse move!');
    },
    mouseUp: function mouseUp(e) {
      if (!this.mouseMoveEnough && e.currentTarget != this.$el[0]) {
        if (_MDSelectFrame["default"].focus()) {
          this.mdEl.remove();
          _MDSelectFrame["default"].clear();
          return;
        }
      }
      ;
      var self = this;
      if (this.type == _MDOpElType["default"].OpRect || this.type == _MDOpElType["default"].OpText) {
        if (this.rect.getWidth() < 10) {
          this.rect.setWidth(200);
          this.mdEl.refresh();
        }
        ;
        if (this.rect.getHeight() < 10) {
          this.rect.setHeight(150);
          this.mdEl.refresh();
        }
        ;
      }
      ;
      this.mdEl.finishCreate();
      this.mdEl.setSelected();
      console.log('3 ------------ mouse move!');
    },
    refresh: function refresh() {
      this.$el.css('left', this.rect.left + 'px');
      this.$el.css('top', this.rect.top + 'px');
      this.$el.css('width', this.rect.getWidth() + 'px');
      this.$el.css('height', this.rect.getHeight() + 'px');
    },
    _createRect: function _createRect(rect) {},
    remove: function remove() {
      this.$el.remove();
    },
    getRect: function getRect() {
      return this.rect;
    },
    getClassName: function getClassName() {
      return this.className;
    }
  };
}();
var _default = exports["default"] = MDOpRectController;

},{"1184":1184,"1454":1454,"812":812,"831":831,"919":919,"921":921,"924":924,"925":925,"926":926}],926:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1498);
var _MDLineWidthAndFont = _interopRequireDefault(require(861));
var _MDColorDisk = _interopRequireDefault(require(856));
var _MDOpElType = _interopRequireDefault(require(924));
var _MDDispHtmlElement = _interopRequireDefault(require(922));
var _MDSelectFrame = _interopRequireDefault(require(919));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MMRect = _interopRequireDefault(require(831));
// MDTextHtmlElement.js
// 用于显示 文本框
//
// jiang
// 2017-7-24

function MDTextHtmlElement(elCtl, $parent, rect) {
  _MDDispHtmlElement["default"].call(this, elCtl, $parent, rect);
}
;
_.extend(MDTextHtmlElement.prototype, _MDDispHtmlElement["default"].prototype, function () {
  return {
    contstructor: MDTextHtmlElement,
    construct: function construct() {
      _MDDispHtmlElement["default"].prototype.construct.call(this);
      this.$el.addClass('op-text');
      this.$el.append('<textarea disabled></textarea>');
      this.opElType = _MDOpElType["default"].OpText;
      this.$el.css('border', '1px solid ' + _MDColorDisk["default"].getCurColor());
    },
    _registerEvents: function _registerEvents() {
      this.$el.off();
      _MDDispHtmlElement["default"].prototype.registerEvents.call(this);
      this.$el.find('textarea').off();
      var self = this;
      this.$el.find('textarea').on('click', function (e) {
        self._clicked(e);
      });
      this.$el.find('textarea').on('focus', function (e) {
        setBabelTimeout(function () {
          if (_MDSelectFrame["default"].focus() != self) {
            self.setSelected();
          }
          ;
        }, 10);
      });
      this.$el.on('mousedown', function (e) {
        e.stopPropagation();
      });
    },
    refresh: function refresh() {
      _MDDispHtmlElement["default"].prototype.refresh.call(this);
    },
    setFontSize: function setFontSize(size) {
      this.fontSize = size;
      this.$el.find('textarea').css('font-size', size + 'px');
    },
    getFontSize: function getFontSize() {
      return this.fontSize;
    },
    setColor: function setColor(color) {
      this.color = color;
      this.$el.find('textarea').css('color', color);
    },
    getColor: function getColor() {
      return this.color;
    },
    needClickEventThrough: function needClickEventThrough() {
      return true;
    },
    finishCreate: function finishCreate() {
      this.$el.off('mousedown');
      this.$el.off('mousemove');
      this.$el.off('mouseup');
      this.$el.on('mousedown', function (e) {
        e.stopPropagation();
      });
      this.$el.on('mousemove', function (e) {
        e.stopPropagation();
      });
      this.$el.on('mouseup', function (e) {
        e.stopPropagation();
      });
      this.setColor(_MDColorDisk["default"].getCurColor());
      this.setFontSize(_MDLineWidthAndFont["default"].getCurFontSize());
    },
    didSelected: function didSelected() {
      _MDDispHtmlElement["default"].prototype.didSelected.call(this);
      this.$el.find('textarea').removeAttr('disabled');
      this.$el.css('border', 'none');

      // this.$el.find('textarea').css('pointer-events', 'auto');
      this.$el.find('textarea').focus();
      this._registerEvents();
    },
    unSelected: function unSelected() {
      _MDDispHtmlElement["default"].prototype.unSelected.call(this);
      // this.$el.find('textarea').css('pointer-events', 'none');
      if (this.$el.find('textarea').val().trim().length == 0) {
        // 空白的文本框为无效输入
        this.elCtl.removeObjByMdEl(this);
        this.$el.remove();
      } else {
        this.elCtl.addMdEl(this, this.editor);
      }
    },
    getText: function getText() {
      return this.$el.find('textarea').val().trim();
    },
    setText: function setText(str) {
      return this.$el.find('textarea').val(str);
    },
    hideBorder: function hideBorder() {
      this.$el.css('border', 'none');
    },
    setReadOnly: function setReadOnly() {
      this.readOnly = true;
      this.$el.off();
      this.$el.find('textarea').off();
      this.$el.find('textarea').attr('readonly', 'readonly');
    }
  };
}());
var _default = exports["default"] = MDTextHtmlElement;

},{"1184":1184,"1417":1417,"1454":1454,"1463":1463,"1498":1498,"812":812,"831":831,"856":856,"861":861,"919":919,"922":922,"924":924}],925:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDOpElType = _interopRequireDefault(require(924));
var _MDDispHtmlElement = _interopRequireDefault(require(922));
var _MDSelectFrame = _interopRequireDefault(require(919));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MMRect = _interopRequireDefault(require(831));
// MDRectHtmlElement.js
//
// jiang
// 2017-7-24

function MDRectHtmlElement(elCtl, $parent, rect) {
  _MDDispHtmlElement["default"].call(this, elCtl, $parent, rect);
  this.$el.addClass('op-rect');
  this.opElType = _MDOpElType["default"].OpRect;
}
;
_.extend(MDRectHtmlElement.prototype, _MDDispHtmlElement["default"].prototype, function () {
  return {
    contstructor: MDRectHtmlElement,
    construct: function construct() {
      _MDDispHtmlElement["default"].prototype.construct.call(this);
    },
    refresh: function refresh() {
      _MDDispHtmlElement["default"].prototype.refresh.call(this);
    }
  };
}());
var _default = exports["default"] = MDRectHtmlElement;

},{"1184":1184,"1454":1454,"812":812,"831":831,"919":919,"922":922,"924":924}],921:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDOpElType = _interopRequireDefault(require(924));
var _MDDispHtmlElement = _interopRequireDefault(require(922));
var _MDSelectFrame = _interopRequireDefault(require(919));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MMRect = _interopRequireDefault(require(831));
// MDCircleHtmlElement.js
//
// jiang
// 2017-7-24

function MDCircleHtmlElement(elCtl, $parent, rect) {
  _MDDispHtmlElement["default"].call(this, elCtl, $parent, rect);
  this.$el.addClass('op-circle');
  this.opElType = _MDOpElType["default"].OpCircle;
}
;
_.extend(MDCircleHtmlElement.prototype, _MDDispHtmlElement["default"].prototype, function () {
  return {
    contstructor: MDCircleHtmlElement,
    construct: function construct() {
      _MDDispHtmlElement["default"].prototype.construct.call(this);
    },
    refresh: function refresh() {
      _MDDispHtmlElement["default"].prototype.refresh.call(this);
    }
  };
}());
var _default = exports["default"] = MDCircleHtmlElement;

},{"1184":1184,"1454":1454,"812":812,"831":831,"919":919,"922":922,"924":924}],924:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var MDOpElType = {
  OpNULL: 'null',
  OpRect: 'rect',
  OpCircle: 'circle',
  OpText: 'text',
  OpArrow: 'arrow',
  OpCanvas: 'canvas'
};
var _default = exports["default"] = MDOpElType;

},{"1454":1454}],922:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMRect = _interopRequireDefault(require(831));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MDSelectFrame = _interopRequireDefault(require(919));
// MDDispHtmlElement.js
//
// jiang
// 2017-7-24

function MDDispHtmlElement(elCtl, $parent, rect) {
  this.elCtl = elCtl;
  this.$parent = $parent;
  this.rect = rect;
  this.canScale = true;
  this.$el = $('<div class="op-obj op-rect" style="left:0px;top:0px:width:0px;height:0px">' + '</div>');
  this.$parent.append(this.$el);
  this.construct();
  var self = this;
  setBabelTimeout(function () {
    self.registerEvents();
  }, 10);
}
;
MDDispHtmlElement.prototype = function () {
  return {
    contstructor: MDDispHtmlElement,
    construct: function construct() {
      var self = this;
      this.refresh();
    },
    registerEvents: function registerEvents() {
      var self = this;
      this.$el.off();
      this.$el.on('click', function (e) {
        self._clicked(e);
      });
    },
    // ------ click
    _clicked: function _clicked(e) {
      if (this.readOnly) {
        return;
      }
      ;
      if (_MDSelectFrame["default"].focus() != this) {
        _MDSelectFrame["default"].focus(this);
      }
      ;
      e.stopPropagation();
    },
    moveRect: function moveRect(deltaX, deltaY) {
      this.rect.translate(deltaX, deltaY);
      this.refresh();
    },
    setRect: function setRect(rct) {
      this.rect = rct;
      this.refresh();
    },
    refresh: function refresh() {
      if (!this.selected) {
        this.$el.css('left', this.rect.left + 'px');
        this.$el.css('top', this.rect.top + 'px');
        this.$el.css('width', this.rect.getWidth() + 'px');
        this.$el.css('height', this.rect.getHeight() + 'px');
      }
      ;
    },
    remove: function remove() {
      this.$el.remove();
    },
    getRect: function getRect() {
      return this.rect;
    },
    setSelected: function setSelected() {
      _MDSelectFrame["default"].focus(this);
    },
    didSelected: function didSelected() {
      this.selected = true;
      this.$el.css('left', '0px');
      this.$el.css('top', '0px');
      this.$el.css('width', '100%');
      this.$el.css('height', '100%');
      this.registerEvents();
    },
    unSelected: function unSelected() {
      this.selected = false;
      this.$el.remove();
      this.$parent.append(this.$el);
      this.refresh();
      this.registerEvents();
    },
    setBorderWidth: function setBorderWidth(w) {
      this.$el.css('border-width', w + 'px');
    },
    setBorderColor: function setBorderColor(c) {
      this.$el.css('border-color', c);
    },
    needClickEventThrough: function needClickEventThrough() {
      return false;
    },
    finishCreate: function finishCreate() {},
    getCtrlPts: function getCtrlPts(onlyCorner) {
      return this.rect.getCtrlPts(onlyCorner);
    },
    setEditorViewCtl: function setEditorViewCtl(editor) {
      this.editor = editor;
    },
    getLgObj: function getLgObj() {
      return this.lgObj;
    },
    setLgObj: function setLgObj(lgObj) {
      this.lgObj = lgObj;
    },
    adJustScale: function adJustScale(type, rect) {},
    adjustMoveOffset: function adjustMoveOffset(dx, dy) {
      return {
        x: dx,
        y: dy
      };
    }
  };
}();
var _default = exports["default"] = MDDispHtmlElement;

},{"1184":1184,"1454":1454,"812":812,"831":831,"919":919}],919:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
var _MDEvents = _interopRequireDefault(require(325));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDContextMenue = _interopRequireDefault(require(858));
// MDSelectFrame.js
//
// jiang
// 2017-7-24

function MDSelectFrame(mdDispHtmlElement) {
  var mdEl = this.mdEl = mdDispHtmlElement;
  this.parentDiv = mdEl.$parent[0];
  this.rect = mdEl.rect;
  this.canScale = mdEl.canScale;
  this.startDvPos = mdDispHtmlElement.startDvPos;
  this.endDvPos = mdDispHtmlElement.endDvPos;
  this.construct();
  this.refreshFrame();
}
;
MDSelectFrame.prototype = function () {
  //----------------------------------------------------------------------------------------------------
  //       private function
  //----------------------------------------------------------------------------------------------------

  //----------------------------------------------------------------------------------------------------
  //       private function
  //----------------------------------------------------------------------------------------------------

  return {
    contstructor: MDSelectFrame,
    construct: function construct() {
      var self = this;
      if (this.startDvPos && this.endDvPos) {
        // -------------------------------  segment object
        this.$el = $('<div class="op-frame">' + '<div class="op-inter" style="position: absolute; left:-10px; top:-10px; right:-10px; bottom:-10px; cursor: move;"></div>' + '<div class="op-ctl-p start-p" data-id="start-p"></div>' + '<div class="op-ctl-p end-p" data-id="end-p"></div>' + '</div>');
      } else if (this.canScale && this.rect) {
        this.$el = $('<div class="op-frame">' + '<div class="op-inter" style="position: absolute; left:-10px; top:-10px; right:-10px; bottom:-10px; cursor: move;"></div>' + '<div class="op-ctl-p lt-p" data-id="corner0"></div>' + '<div class="op-ctl-p mt-p" data-id="corner1"></div>' + '<div class="op-ctl-p rt-p" data-id="corner2"></div>' + '<div class="op-ctl-p rm-p" data-id="corner3"></div>' + '<div class="op-ctl-p rb-p" data-id="corner4"></div>' + '<div class="op-ctl-p mb-p" data-id="corner5"></div>' + '<div class="op-ctl-p lb-p" data-id="corner6"></div>' + '<div class="op-ctl-p lm-p" data-id="corner7"></div>' + '</div>');
      }
      $(this.parentDiv).append(this.$el);
      this.mdEl.$el.remove();
      this.mdEl.$el.insertAfter(this.$el.find('.op-inter'));
      this.mdEl.didSelected();
      this.$el.find('.op-ctl-p').on('touchstart mousedown', function (e) {
        self._ctlPtMouseDown(e);
      });
      this.$el.find('.op-inter').on('contextmenu', function (e) {
        e.stopPropagation();
        e.preventDefault();
      });
      this.$el.find('.op-inter').on('touchstart mousedown', function (e) {
        self._mouseDown(e);
      });
      this.$el.find('.op-inter').on('touchmove mousemove', function (e) {
        self._mouseMove(e);
      });
      this.$el.find('.op-inter').on('touchend mouseup', function (e) {
        self._mouseUp(e);
      });
      if (this.mdEl.isCanvas) {
        this.$el.find('.op-inter').css('z-index', 2);
      }
      ;
    },
    _mouseDown: function _mouseDown(e) {
      var _this = this;
      var lgObj = this.mdEl.getLgObj();
      if (lgObj && e.button != 0 && e.type != "touchstart") {
        var file = lgObj.m_board.getFileInfo();
        if (lgObj.getClassName() == "MMSignatureFrame" && !file.isNormalSig()) {
          _MDContextMenue["default"].show({
            e: e,
            menus: [{
              title: BabelStr.str(6055),
              //"旋转",
              callback: function callback() {
                lgObj.rotate90();
                _this.mdEl.userActionFinished();
                _this.refreshFrame();
              }
            }]
          });
        } else {
          if (this.mdEl) {
            this.mdEl.unSelected();
          }
          ;
          var operateLayer = this.$el.siblings('.operate-layer');
          e.target = operateLayer[0];
          e.currentTarget = operateLayer[0];
          operateLayer.trigger(e);
          return true;
        }
        e.preventDefault();
      } else {
        var self = this;
        this.down = true;
        this.curPos = MMCommonFun.touchPosition(e);
        this.canBeClick = true;
        $('body').on('touchmove.moveframe mousemove.moveframe', function (e) {
          self._mouseMove(e);
        });
        $('body').on('touchend.moveframe mouseup.moveframe', function (e) {
          self._mouseUp(e);
        });
      }
      e.stopPropagation();
      e.preventDefault();
    },
    _mouseMove: function _mouseMove(e) {
      if (!this.down) {
        return;
      }
      ;
      var self = this;
      e.stopPropagation();
      var curPos = MMCommonFun.touchPosition(e);
      var deltaX = curPos.x - self.curPos.x;
      var deltaY = curPos.y - self.curPos.y;
      if (Math.abs(deltaX) + Math.abs(deltaY) > 10) {
        self.curPos = curPos;
        self.moveRect(deltaX, deltaY);
        self.canBeClick = false;
      }
      ;
    },
    _mouseUp: function _mouseUp(e) {
      if (!this.down) {
        return;
      }
      ;
      this.down = false;
      var self = this;
      e.stopPropagation();
      if (self.canBeClick) {}
      ;
      $('body').off('touchmove.moveframe mousemove.moveframe');
      $('body').off('touchend.moveframe mouseup.moveframe');
      if (this.mdEl && this.mdEl.userActionFinished) {
        this.mdEl.userActionFinished();
      }
      ;
    },
    _ctlPtMouseDown: function _ctlPtMouseDown(e) {
      var self = this;
      this.ctlPtdown = true;
      this.curCtlPos = MMCommonFun.touchPosition(e);
      this.data = $(e.currentTarget).attr('data-id');
      $('body').on('touchmove.scaleframe mousemove.scaleframe', function (e) {
        var curPos = MMCommonFun.touchPosition(e);
        var deltaX = curPos.x - self.curCtlPos.x;
        var deltaY = curPos.y - self.curCtlPos.y;
        self.curCtlPos = curPos;
        self.adjustRect(deltaX, deltaY);
      });
      $('body').on('touchend.scaleframe mouseup.scaleframe', function (e) {
        $('body').off('touchmove.scaleframe mousemove.scaleframe');
        $('body').off('touchend.scaleframe mouseup.scaleframe');
        if (self.mdEl && self.mdEl.userActionFinished) {
          self.mdEl.userActionFinished();
        }
        ;
      });
      e.stopPropagation();
      e.preventDefault();
    },
    moveRect: function moveRect(deltaX, deltaY) {
      if (this.startDvPos && this.endDvPos) {
        this.startDvPos.translate(deltaX, deltaY);
        this.endDvPos.translate(deltaX, deltaY);
      } else {
        var newOffset = this.mdEl.adjustMoveOffset(deltaX, deltaY);
        deltaX = newOffset.x;
        deltaY = newOffset.y;
        this.rect.translate(deltaX, deltaY);
      }
      this.refreshFrame();
    },
    adjustRect: function adjustRect(deltaX, deltaY) {
      switch (this.data) {
        case 'corner0':
          this.rect.top += deltaY;
          this.rect.left += deltaX;
          break;
        case 'corner1':
          this.rect.top += deltaY;
          break;
        case 'corner2':
          this.rect.top += deltaY;
          this.rect.right += deltaX;
          break;
        case 'corner3':
          this.rect.right += deltaX;
          break;
        case 'corner4':
          this.rect.bottom += deltaY;
          this.rect.right += deltaX;
          break;
        case 'corner5':
          this.rect.bottom += deltaY;
          break;
        case 'corner6':
          this.rect.bottom += deltaY;
          this.rect.left += deltaX;
          break;
        case 'corner7':
          this.rect.left += deltaX;
          break;
        case 'start-p':
          this.startDvPos.translate(deltaX, deltaY);
          break;
        case 'end-p':
          this.endDvPos.translate(deltaX, deltaY);
          break;
      }
      this.mdEl.adJustScale(this.data, this.rect);
      this.refreshFrame();
    },
    refreshFrame: function refreshFrame() {
      if (this.startDvPos && this.endDvPos) {
        this.rect.initWith2Pts(this.startDvPos, this.endDvPos); // --------------------- 根据两个点获得外接矩形
        if (this.startDvPos.x < this.endDvPos.x) {
          this.$el.find('.start-p').css('left', '0%');
          this.$el.find('.end-p').css('left', '100%');
        } else {
          this.$el.find('.start-p').css('left', '100%');
          this.$el.find('.end-p').css('left', '0%');
        }
        if (this.startDvPos.y < this.endDvPos.y) {
          this.$el.find('.start-p').css('top', '0%');
          this.$el.find('.end-p').css('top', '100%');
        } else {
          this.$el.find('.start-p').css('top', '100%');
          this.$el.find('.end-p').css('top', '0%');
        }
      }
      this.$el.css('left', this.rect.left + 'px');
      this.$el.css('top', this.rect.top + 'px');
      this.$el.css('width', this.rect.getWidth() + 'px');
      this.$el.css('height', this.rect.getHeight() + 'px');
      if (this.startDvPos && this.endDvPos) {
        this.mdEl.endPtsChanged(this.startDvPos, this.endDvPos);
      } else if (this.mdEl && this.mdEl.rectChanged) {
        this.mdEl.rectChanged(this.rect);
      }
      var lgObj = this.mdEl.getLgObj();
      if (lgObj && lgObj.getAngle) {
        var angle = lgObj.getAngle() * 180 / Math.PI;
        this.$el.css("transform", "rotate(" + angle + "deg)");
      }
    },
    remove: function remove() {
      if (!this.$el) {
        return;
      }
      ;
      this.$el.find('.op-ctl-p').off();
      this.$el.remove();
      this.$el.off();
      this.$el = null;
    },
    beforeRemove: function beforeRemove() {
      if (this.mdEl) {
        this.mdEl.unSelected();
      }
      ;
    }
  };
}();
MDSelectFrame.focus = function (mdDispHtmlElement) {
  if (mdDispHtmlElement) {
    if (MDSelectFrame.instance) {
      MDSelectFrame.instance.beforeRemove();
      MDSelectFrame.instance.remove();
    }
    ;
    MDSelectFrame.instance = new MDSelectFrame(mdDispHtmlElement);
    _Dispatcher["default"].trigger(_MDEvents["default"].Obj_Selected);
  } else {
    if (MDSelectFrame.instance) {
      return MDSelectFrame.instance.mdEl;
    }
    ;
    return null;
  }
};
MDSelectFrame.getSelectedLgObj = function () {
  var el = MDSelectFrame.focus();
  if (el) {
    return el.getLgObj();
  }
  ;
};
MDSelectFrame.setSelectedElBorderWidth = function (w) {
  if (MDSelectFrame.instance) {
    MDSelectFrame.instance.mdEl && MDSelectFrame.instance.mdEl.setBorderWidth(w);
  }
  ;
};
MDSelectFrame.setColor = function (c) {
  if (MDSelectFrame.instance) {
    MDSelectFrame.instance.mdEl && MDSelectFrame.instance.mdEl.setColor(c);
  }
  ;
};
MDSelectFrame.setFontSize = function (size) {
  if (MDSelectFrame.instance) {
    MDSelectFrame.instance.mdEl && MDSelectFrame.instance.mdEl.setFontSize(size);
  }
  ;
};
MDSelectFrame.setLineWidth = function (size) {
  if (MDSelectFrame.instance) {
    MDSelectFrame.instance.mdEl && MDSelectFrame.instance.mdEl.setLineWidth(size);
  }
  ;
};
MDSelectFrame.clear = function (d) {
  if (MDSelectFrame.instance) {
    MDSelectFrame.instance.beforeRemove();
    MDSelectFrame.instance.remove();
    MDSelectFrame.instance = null;
  }
  ;
  _Dispatcher["default"].trigger(_MDEvents["default"].Null_Selected);
};
var _default = exports["default"] = MDSelectFrame;

},{"1184":1184,"1417":1417,"1454":1454,"1463":1463,"18":18,"325":325,"858":858}],858:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1438);
var MDContextMenu = {
  /**
   * the domElement that is displayed
   */
  contextManue: null,
  /**
   * the original Method was: MMOperationCenter.prototype.showContextMenue
   * @params {object} e, menus = [{tile, callback},]
   * usage: MDContextMenu.show
   */
  show: function show(params) {
    //return; // disabled in the first online version of net_drive
    var e = params.e;
    var menus = params.menus;
    if (!menus || menus.length == 0) {
      return;
    }
    requestAnimationFrame(function () {
      var _this = this;
      this.close();
      this._addwindowHandler();
      var template = '<div id="MMOperationCenterContextMenue" class="f-noselect"' + 'style="top:' + e.pageY + 'px;left:' + (e.pageX + 3) + 'px;"></div>';
      this.contextMenu = $(template);
      // document.body.appendChild(this.contextMenu[0]);
      $('.app-root').append(this.contextMenu);
      var _loop = function _loop() {
          var m = menus[i];
          editEntry = _this._createContextMenueEntry(m.title); //next
          editEntry.on('click', function () {
            m.callback();
          });
          _this.contextMenu.append(editEntry);
        },
        editEntry;
      for (var i = 0; i < menus.length; i++) {
        _loop();
      }
      if (this.contextMenu.height() > window.innerHeight - e.pageY) {
        this.contextMenu.css('top', '-=' + this.contextMenu.height());
      }
      if (this.contextMenu.width() > window.innerWidth - e.pageX) {
        this.contextMenu.css('left', '-=' + this.contextMenu.width());
      }
    }.bind(this));
  },
  //hide the current contextManue
  close: function close() {
    if (this.contextMenu) {
      this._removeWindowHandler();
      this.contextMenu.remove();
      this.contextMenu = null;
    }
  },
  _createContextMenueSeparator: function _createContextMenueSeparator() {
    return $('<div class="contextMenueSeparator" ></div>');
  },
  _createContextMenueEntry: function _createContextMenueEntry(text, disabled) {
    return $('<div class="contextMenueEntry' + (disabled ? " disabled" : '') + '">' + text + '</div>');
  },
  _addwindowHandler: function _addwindowHandler() {
    if (!this._windowClickCallback) {
      var handler = function handler(e) {
        if (e.button === 0) {
          MDContextMenu.close();
        }
      };
      document.body.addEventListener("click", handler);
      this._windowClickCallback = handler;
    }
  },
  _removeWindowHandler: function _removeWindowHandler() {
    if (this._windowClickCallback) {
      document.body.removeEventListener('click', this._windowClickCallback);
      this._windowClickCallback = null;
    }
  }
};
var _default = exports["default"] = MDContextMenu;

},{"1438":1438,"1454":1454}],339:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1466);
require(1417);
require(1463);
var _MDEvents = _interopRequireDefault(require(325));
var MDTouchMenu = {
  curMenu: undefined,
  hideCB: null,
  pop: function pop(container, devicePoint, buttons, hideCB) {
    //text, cb, hideCB){
    var $root = container;
    var that = MDTouchMenu;
    that.buttons = buttons;
    if (MDTouchMenu.curMenu) {
      MDTouchMenu.curMenu.remove();
    }
    MDTouchMenu.curMenu = $('<div class="tooltip-root">' + '<div class="tooltip" style="width:' + 80 * buttons.length + 'px"></div>' + '</div>');
    for (var id = 0; id < buttons.length; id++) {
      var $button = $('<span id="' + id + '" style="display: inline-block; width:75px;">' + buttons[id].text + '</span>');
      if (id !== buttons.length - 1) $button.css({
        "border-right": '1px #555 solid'
      });
      $button.on(_MDEvents["default"].touchstart, function (e) {
        e.preventDefault();
        e.stopPropagation();
      });
      $button.on(_MDEvents["default"].touchend, function (e) {
        e.preventDefault();
        e.stopPropagation();
        var id = parseInt(e.currentTarget.getAttribute('id'));
        var click = that.buttons[id].click;
        that.hide();
        if (click) {
          click();
        }
      });
      MDTouchMenu.curMenu.find('.tooltip').append($button);
    }
    $root.append(MDTouchMenu.curMenu);
    MDTouchMenu.curMenu.find('.tooltip').css('top', devicePoint.y - 68 + 'px');
    MDTouchMenu.curMenu.find('.tooltip').css('left', devicePoint.x - 40 * buttons.length + 'px');
    MDTouchMenu.curMenu.on(_MDEvents["default"].touchstart, function (e) {
      e.preventDefault();
      that.hide();
      console.log("----------------> close <-------------");
    });
    MDTouchMenu.buttons = buttons;
    MDTouchMenu.hideCB = hideCB;

    // add the arrow
    var arrow = $('<div>');
    arrow.css({
      "width": '0px',
      "height": '0px',
      "display": "block",
      "border-style": "solid",
      "border-width": "10px",
      "border-color": "rgba(41,36,33,0.95) transparent transparent transparent",
      "position": "absolute",
      "z-index": '-1',
      "bottom": '-20px',
      "left": 40 * buttons.length - 11 + 'px'
    });
    MDTouchMenu.curMenu.find('.tooltip').append(arrow);
    if (MDTouchMenu.orientationHandler) Dispatcher.off(_MDEvents["default"].ORIENTATION_CHANGED, MDTouchMenu.orientationHandler);
    MDTouchMenu.orientationHandler = function () {
      MDTouchMenu.hide();
    };
    Dispatcher.on(_MDEvents["default"].ORIENTATION_CHANGED, MDTouchMenu.orientationHandler);
  },
  hide: function hide() {
    if (MDTouchMenu.hideCB) {
      MDTouchMenu.hideCB();
      MDTouchMenu.hideCB = null;
    }
    if (MDTouchMenu.curMenu) {
      MDTouchMenu.curMenu.remove();
      MDTouchMenu.curMenu = undefined;
    }
    MDTouchMenu.buttons = null;
  }
};
var _default = exports["default"] = MDTouchMenu;

},{"1184":1184,"1417":1417,"1454":1454,"1463":1463,"1466":1466,"325":325}],317:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1461);
require(1429);
require(1421);
var _MDCircleAnimator = _interopRequireDefault(require(316));
/*jslint nomen: true, vars: true, plusplus:true, browser:true */
/*global goog,_,keyMirror,MMWcModalPanelView*/

var MDCommentAnimator = new _MDCircleAnimator["default"]();
MDCommentAnimator.data = {};
MDCommentAnimator.data.readed = {
  radius: 12,
  borderWidth: 2,
  borderColor: 'white',
  color: g_keyColor,
  //opacity: 0.9,
  boxShadow: '0px 0px 15px rgba（0,0,0,0.15）, 0px 0px 1px rgba （0,0,0,0.1）'
};
MDCommentAnimator.data.moving = {
  radius: 25,
  borderWidth: 2,
  borderColor: 'white',
  color: g_keyColor,
  boxShadow: '0px 0px 6px 2px rgba(100,100,100,0.45)'
};
MDCommentAnimator.data.notReaded = [[{
  //3. Layer
  radius: 10,
  borderColor: 'rgb(140,140,140)',
  // color(0 140 245)
  borderWidth: 1,
  boxShadow: '0px 0px 3px 1px rgba(255,255,255,0.1)'
}, {
  radius: 18.5,
  borderColor: 'rgba(198,198,198,0.5)',
  // color(188 193 43)
  borderWidth: 2,
  //        opacity: 0.01,
  duration: 500,
  boxShadow: '0px 0px 3px 1px rgba(255,255,255,0.1)'
}, {
  radius: 28,
  borderColor: 'rgba(255,255,255,0.00)',
  // color(87 162 148)
  borderWidth: 2,
  //            opacity: 0.55,
  duration: 500,
  boxShadow: '0px 0px 3px 1px rgba(255,255,255,0.1)'
}], [{
  //2. Layer
  radius: 9,
  //borderColor: 'rgb(255,255,255)', // color(0 140 245)
  //borderWidth: 1,
  color: 'rgba(0,0,0,0.4)',
  // 'rgba(194,216,252,0.70)',
  boxShadow: '0px 0px 3px 1px rgba(255,255,255,0.1)'
}, {
  radius: 14,
  //borderColor: 'rgb(255,255,255)', // color(210 210 210)
  //borderWidth: 1,
  duration: 500,
  color: 'rgba(0,0,0,0.4)',
  // "rgba(248,201,143,0.70)",
  boxShadow: '0px 0px 3px 1px rgba(255,255,255,0.1)'
}, {
  radius: 9,
  //borderColor: 'rgb(255,255,255)', // color(0 140 245)
  //borderWidth: 1,
  duration: 500,
  color: 'rgba(0,0,0,0.4)',
  // 'rgba(194,216,252,0.70)',
  boxShadow: '0px 0px 3px 1px rgba(255,255,255,0.1)'
}], MDCommentAnimator.data.readed];
MDCommentAnimator.data.onAir = [[{
  //3. Layer
  radius: 10,
  color: 'rgba(194,216,255,1.00)',
  borderColor: 'rgba(255,255,255,1.00)',
  // color(0 140 245)
  borderWidth: 1,
  boxShadow: '0px 0px 3px 1px rgba(255,255,255,0.1)'
}, {
  //3. Layer
  radius: 10,
  color: 'rgba(194,216,255,1.00)',
  borderColor: 'rgba(255,255,255,1.00)',
  // color(0 140 245)
  borderWidth: 1,
  boxShadow: '0px 0px 3px 1px rgba(255,255,255,0.1)',
  duration: 2000
}, {
  //3. Layer
  radius: 25,
  color: 'rgba(194,216,255,0.00)',
  borderColor: 'rgba(194,216,255,0.00)',
  // color(188 193 43)
  borderWidth: 1,
  //        opacity: 0.01,
  duration: 1000,
  boxShadow: '0px 0px 3px 1px rgba(255,255,255,0.1)'
}], MDCommentAnimator.data.readed];
MDCommentAnimator.data.reading = [[{
  //3. Layer
  radius: 15,
  borderColor: '#008cf5',
  // color(0 140 245)
  color: '#d5e4ff',
  // color(213 228 255)
  borderWidth: 1
}, {
  //3. Layer
  radius: 15,
  borderColor: '#008cf5',
  // color(0 140 245)
  color: '#d5e4ff',
  // color(213 228 255)
  borderWidth: 1,
  duration: 1500
}, {
  radius: 23,
  borderColor: '#57a294',
  // color(87 162 148)
  borderWidth: 1,
  opacity: 0.55,
  color: '#d5e4ff',
  // color(213 228 255)
  duration: 500
}, {
  radius: 38,
  borderColor: '#bcc12b',
  // color(188 193 43)
  borderWidth: 2,
  color: '#d5e4ff',
  // color(213 228 255)
  opacity: 0.01,
  duration: 500
}], MDCommentAnimator.data.readed];
MDCommentAnimator.data.newMessage = [MDCommentAnimator.data.readed, [{
  //3. Layer
  radius: 4,
  color: '#ffa500',
  // color(213 228 255)
  offset: 20,
  rotation: 0
}, {
  //3. Layer
  radius: 4,
  offset: 20,
  duration: 800,
  rotation: 180
}, {
  //3. Layer
  radius: 4,
  offset: 20,
  rotation: 360,
  duration: 800
}]];

/* -------------------------------------------------------------------------
 * mobileData
 * -------------------------------------------------------------------------
 */

/**
 * methods to get Comment AnimationObjectData, in a given color
 */
MDCommentAnimator.getUnreadCommentData = function (color) {
  var data = JSON.parse(JSON.stringify(MDCommentAnimator.data.notReaded));
  data[2].color = color;
  return data;
};
MDCommentAnimator.getReadedCommentData = function (color) {
  var data = JSON.parse(JSON.stringify(MDCommentAnimator.data.readed));
  data.color = color;
  return data;
};
MDCommentAnimator.getMovingCommentData = function (color) {
  var data = JSON.parse(JSON.stringify(MDCommentAnimator.data.moving));
  data.color = color;
  return data;
};
MDCommentAnimator.getNewMessageCommentData = function (color) {
  var data = JSON.parse(JSON.stringify(MDCommentAnimator.data.newMessage));
  data[0].color = color;
  data[1][0].color = color;
  data[1][1].color = color;
  return data;
};
MDCommentAnimator.getClosedCommentData = function (color) {
  var data = JSON.parse(JSON.stringify(MDCommentAnimator.data.readed));
  data.color = color;
  data.opacity = 0.5;
  return data;
};
MDCommentAnimator.getOnAirCommentData = function (color) {
  var data = JSON.parse(JSON.stringify(MDCommentAnimator.data.onAir));
  data[1].color = color;
  return data;
};
MDCommentAnimator.fixeColorName = function (color) {
  if (!color) return "0077FF";
  return color[0] == '#' ? color.slice(1) : color;
};
MDCommentAnimator.createColoredClassesColors = [];
MDCommentAnimator.createColoredClasses = function (color) {
  if (this.createColoredClassesColors.indexOf(color) !== -1) return this;
  this.createColoredClassesColors.push(color);
  this.prepareSetting('CommentNewMessage-' + this.fixeColorName(color), this.getNewMessageCommentData(color));
  this.prepareSetting('CommentOnAir-' + this.fixeColorName(color), this.getOnAirCommentData(color));
  this.prepareSetting('CommentClosed-' + this.fixeColorName(color), this.getClosedCommentData(color));
  this.prepareSetting('CommentReaded-' + this.fixeColorName(color), this.getReadedCommentData(color));
  this.prepareSetting('CommentUnReaded-' + this.fixeColorName(color), this.getUnreadCommentData(color));
  this.prepareSetting('CommentMoving-' + this.fixeColorName(color), this.getMovingCommentData(color));
  return this;
};
var _default = exports["default"] = MDCommentAnimator;

},{"1184":1184,"1421":1421,"1429":1429,"1454":1454,"1461":1461,"316":316}],316:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var MDCircleAnimator = function MDCircleAnimator() {
  this.settings = {};
  this.styleTag = $('<style>');
  this.css = '';
  var that = this;
  $(window).on('load', function () {
    $(document.body).append(that.styleTag);
  });
};
MDCircleAnimator.prototype.prepareSetting = function (name, framesets) {
  var newSetting = {};
  newSetting.classId = 'c' + Math.round(Math.random() * 100000) + '' + Math.round(Math.random() * 100000000);
  if (!(framesets instanceof Array)) framesets = [framesets];
  newSetting.framesets = framesets;
  var duration = 0;
  var newCSS = '';
  var j = 0;
  var curFrame = null;
  for (var i = 0; i < framesets.length; i++) {
    if (!(framesets[i] instanceof Array)) framesets[i] = [framesets[i]];
    var curFramesrameSet = framesets[i];
    this._normaliseAnimationKeyFrames(curFramesrameSet);
    var animateProps = this._getAnimateProperties(curFramesrameSet);
    for (j = 0; j < curFramesrameSet.length; j++) {
      curFrame = curFramesrameSet[j];
      duration += curFrame.duration;
    }
    var now = 0;
    if (animateProps.animatings) {
      var curFramesetKeyFrames = '';
      var curFrameCSS = '';
      var curFrameCSSoffsetter = '';
      for (j = 0; j < curFramesrameSet.length; j++) {
        curFrame = curFramesrameSet[j];
        now += curFrame.duration;
        var nowInPercent = now / duration * 100;
        nowInPercent = nowInPercent ? nowInPercent : 0;
        curFrameCSS += '\n\t' + nowInPercent + '%' + '{/* ' + name + ' */' + (
        //'padding-top:' + curFrame.offset*2 + 'px;' +
        curFrame.color != null ? 'background-color:' + curFrame.color + ";" : '') + (animateProps.radius ? 'border-width:' + curFrame.borderWidth + 'px;' : '') + (animateProps.radius ? 'width:' + curFrame.radius * 2 + 'px;' : '') + (animateProps.radius ? 'height:' + curFrame.radius * 2 + 'px;' : '') + (
        //'border-radius:' + curFrame.radius*2 + 'px;' +
        animateProps.radius ? 'margin-top:' + -curFrame.radius + 'px;' : '') + (animateProps.radius ? 'margin-left:' + -curFrame.radius + 'px;' : '') + (curFrame.borderColor != null ? 'border-color:' + curFrame.borderColor + ";" : '') + (animateProps.opacity ? 'opacity:' + curFrame.opacity + ';' : '') + (
        //opacity: 1
        animateProps.boxShadow ? '-webkit-box-shadow:' + curFrame.boxShadow + ';' : '') + (
        //opacity: 1
        animateProps.boxShadow ? '-moz-box-shadow:' + curFrame.boxShadow + ';' : '') + (
        //opacity: 1
        animateProps.boxShadow ? 'box-shadow:' + curFrame.boxShadow + ';' : '') +
        //opacity: 1
        '}';
        curFrameCSSoffsetter += animateProps.rotation ? "\n\t" + nowInPercent + "%" + '{' + 'transform: rotate(' + curFrame.rotation + 'deg);' +
        //rotation: 0
        '-moz-transform: rotate(' + curFrame.rotation + 'deg);' +
        //rotation: 0
        '-webkit-transform: rotate(' + curFrame.rotation + 'deg);' +
        //rotation: 0
        '}' : '';
      }
      newCSS += '@keyframes ' + newSetting.classId + '-' + i + '{' + curFrameCSS + '\n}\n';
      newCSS += '@-webkit-keyframes ' + newSetting.classId + '-' + i + '{' + curFrameCSS + '\n}\n';
      newCSS += '@-0-keyframes ' + newSetting.classId + '-' + i + '{' + curFrameCSS + '\n}\n';
      newCSS += '@-moz-keyframes ' + newSetting.classId + '-' + i + '{' + curFrameCSS + '\n}\n';
      if (this._hasoffset(curFramesrameSet)) {
        newCSS += '@keyframes offsetter-' + newSetting.classId + '-' + i + '{' + curFrameCSSoffsetter + '\n}\n';
        newCSS += '@-webkit-keyframes offsetter-' + newSetting.classId + '-' + i + '{' + curFrameCSSoffsetter + '\n}\n';
        newCSS += '@-o-keyframes offsetter-' + newSetting.classId + '-' + i + '{' + curFrameCSSoffsetter + '\n}\n';
        newCSS += '@-moz-keyframes offsetter-' + newSetting.classId + '-' + i + '{' + curFrameCSSoffsetter + '\n}\n';
      }
    }
    var durationInSeconds = duration / 1000;
    durationInSeconds = durationInSeconds ? durationInSeconds : 1000;
    curFrame = curFramesrameSet[0]; // first frame is used as default class
    newCSS += "." + newSetting.classId + '-' + i + '{' + (animateProps.animatings ? ' animation: ' + newSetting.classId + '-' + i + ' ' + durationInSeconds + 's linear infinite;' : '') + (animateProps.animatings ? '-webkit-animation: ' + newSetting.classId + '-' + i + ' ' + durationInSeconds + 's linear infinite; ' : '') + (animateProps.animatings ? '-o-animation: ' + newSetting.classId + '-' + i + ' ' + durationInSeconds + 's linear infinite; ' : '') + (animateProps.animatings ? '-moz-animation: ' + newSetting.classId + '-' + i + ' ' + durationInSeconds + 's linear infinite; ' : '') + 'border-style: solid; ' + 'padding: 0px;' + 'margin: 0px;' + (
    //'padding-top:' + curFrame.offset*2 + 'px;' +
    curFrame.color != null ? 'background-color:' + curFrame.color + ";" : '') + 'border-width:' + curFrame.borderWidth + 'px;' + 'width:' + curFrame.radius * 2 + 'px;' + 'height:' + curFrame.radius * 2 + 'px;' + 'position:absolute;' + 'top:0px;' + 'left:0px;' + '-webkit-border-radius:50%;' + '-moz-border-radius:50%;' + 'border-radius:50%;' + 'margin-top:' + -curFrame.radius + 'px;' + 'margin-left:' + -curFrame.radius + 'px;' + (curFrame.borderColor != null ? 'border-color:' + curFrame.borderColor + ";" : '') + (curFrame.opacity != 1 ? 'opacity:' + curFrame.opacity + ';' : '') + '-webkit-box-shadow:' + curFrame.boxShadow + ';' + '-moz-box-shadow:' + curFrame.boxShadow + ';' + 'box-shadow:' + curFrame.boxShadow + ';' + (curFrame.rotation ? 'transform: rotate(' + curFrame.rotation + 'deg);' +
    //rotation: 0
    '-o-transform: rotate(' + curFrame.rotation + 'deg);' +
    //rotation: 0
    '-moz-transform: rotate(' + curFrame.rotation + 'deg);' +
    //rotation: 0
    '-webkit-transform: rotate(' + curFrame.rotation + 'deg);' : '') + 'color: white;  font-size: 12px;  text-align: center;  padding-top: 1px;' + '}\n';
    if (this._hasoffset(curFramesrameSet)) {
      newCSS += ".offsetter-" + newSetting.classId + "-" + i + "{" + 'top:0px;' + 'margin:0px;' + 'top:' + -curFrame.offset / 2 + 'px;' + 'left:0px;' + 'width:0px;' + 'height:0px;' + 'position:absolute;' + 'padding-top:' + curFrame.offset + 'px;' + '-webkit-animation: offsetter-' + newSetting.classId + '-' + i + ' ' + durationInSeconds + 's linear infinite;' + '-o-animation: offsetter-' + newSetting.classId + '-' + i + ' ' + durationInSeconds + 's linear infinite;' + '-moz-animation: offsetter-' + newSetting.classId + '-' + i + ' ' + durationInSeconds + 's linear infinite;' + 'animation: offsetter-' + newSetting.classId + '-' + i + ' ' + durationInSeconds + 's linear infinite;' + '}';
    }
  }
  //console.log(newCSS);
  this.css += newCSS;
  this.styleTag.html(this.css);
  newSetting.count = i;
  this.settings[name] = newSetting;
};
MDCircleAnimator.prototype.init = function (parentElement, name) {
  var setting = this.settings[name];
  var $circle = "";
  if (!setting) throw 'setting not found';
  var $parentElement = $(parentElement);
  $parentElement.html('');
  for (var i = 0; i < setting.framesets.length; i++) {
    var classname = setting.classId + '-' + i;
    if (this._hasoffset(setting.framesets[i])) {
      var $offsetter = $('<div class="offsetter-' + classname + '">');
      $circle = $('<div class="' + classname + '">');
      $offsetter.append($circle);
      $parentElement.append($offsetter);
    } else {
      $circle = $('<div class="' + classname + '">');
      $parentElement.append($circle);
    }
  }
  return this;
};
MDCircleAnimator.prototype._normaliseAnimationKeyFrames = function (frames) {
  var lastFrame = {
    radius: 6,
    color: null,
    duration: 0,
    borderWidth: 0,
    borderColor: 0,
    opacity: 1,
    delay: 0,
    boxShadow: '',
    offset: 0,
    rotation: 0
  };
  for (var i = 0; i < frames.length; i++) {
    frames[i] = {
      radius: frames[i].radius === undefined ? lastFrame.radius : frames[i].radius,
      color: frames[i].color === undefined ? lastFrame.color : frames[i].color,
      duration: frames[i].duration === undefined ? lastFrame.duration : frames[i].duration,
      borderWidth: frames[i].borderWidth === undefined ? lastFrame.borderWidth : frames[i].borderWidth,
      borderColor: frames[i].borderColor === undefined ? lastFrame.borderColor : frames[i].borderColor,
      opacity: frames[i].opacity === undefined ? lastFrame.opacity : frames[i].opacity,
      delay: frames[i].delay === undefined ? lastFrame.delay : frames[i].delay,
      boxShadow: frames[i].boxShadow === undefined ? lastFrame.boxShadow : frames[i].boxShadow,
      offset: frames[i].offset === undefined ? lastFrame.offset : frames[i].offset,
      rotation: frames[i].rotation === undefined ? lastFrame.rotation : frames[i].rotation
    };
    lastFrame = frames[i];
  }
  return frames;
};

/**
 *
 * @param frames {nomealized frameset}
 * @returns {object} the properties set there, need to be animated
 */
MDCircleAnimator.prototype._getAnimateProperties = function (frames) {
  var draft = frames[0];
  var props = {
    animatings: 0
  };
  for (var i = 1; i < frames.length; i++) {
    if (frames[i].radius != draft.radius) {
      props.radius = true;
      props.animatings++;
    }
    ;
    if (frames[i].color != draft.color) {
      props.color = true;
      props.animatings++;
    }
    ;
    if (frames[i].duration != draft.duration) {
      props.duration = true;
      props.animatings++;
    }
    ;
    if (frames[i].borderWidth != draft.borderWidth) {
      props.borderWidth = true;
      props.animatings++;
    }
    ;
    if (frames[i].borderColor != draft.borderColor) {
      props.borderColor = true;
      props.animatings++;
    }
    ;
    if (frames[i].opacity != draft.opacity) {
      props.opacity = true;
      props.animatings++;
    }
    ;
    if (frames[i].boxShadow != draft.boxShadow) {
      props.boxShadow = true;
      props.animatings++;
    }
    ;
    if (frames[i].offset != draft.offset) {
      props.offset = true;
      props.animatings++;
    }
    ;
    if (frames[i].rotation != draft.rotation) {
      props.rotation = true;
      props.animatings++;
    }
    ;
  }
  return props;
};
/**
 *
 * @param frames {nomealized frameset}
 * @returns {object} the properties set there, need to be animated
 */
MDCircleAnimator.prototype._hasoffset = function (frames) {
  for (var i = 0; i < frames.length; i++) {
    if (frames[i].offset != 0) {
      return true;
    }
  }
  return false;
};
var _default = exports["default"] = MDCircleAnimator;

},{"1454":1454}],891:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMBasicData = _interopRequireDefault(require(811));
var _goog = _interopRequireDefault(require(823));
var _MMObjElementController = _interopRequireDefault(require(892));
/**
 * 此类用于管理图片在屏幕上的使用 <img> 标签显示
 */

function MMImgViewCtl(obj) {
  _MMObjElementController["default"].call(this, obj);
  this.canvasQu = new Array();
}
;

//MMImgViewCtl.prototype = new MMObjElementController() ;//
//MMImgViewCtl.superclass = MMObject.prototype ;//

_goog["default"].inherits(MMImgViewCtl, _MMObjElementController["default"]);
MMImgViewCtl.prototype.createDiv = function () {
  var index = this.mmobj.getLayerIndex() + _MMBasicData["default"].getPdfStartlayerZ_index(); // 控制 z-index  来保证 pdf 的显示在手写 canvas 层的下面

  return $("<img style='position:absolute;z-index:" + index + ";' />");
};

/**
 * 在 img 中绘制 image 文档
 * @param {MMTransform} trsfm 坐标转换器
 * @param {Number} pgindex  当前显示的是逻辑第几页
 */
MMImgViewCtl.prototype.displayInDiv = function ($parentDiv, trsfm, pgindex) {
  MMImgViewCtl.superClass_.displayInDiv.call(this, $parentDiv, trsfm, pgindex);
  var _imgData = this.mmobj.getObjData();
  var imgSrc = _imgData.getFilePath(trsfm);
  if (imgSrc.length == 0) {
    return;
  }
  var $img = this.$div;
  $img.attr("src", imgSrc);
};
MMImgViewCtl.prototype.refreshImg = function (parentDiv) {
  var index = -1;
  for (var i = 0; i < this.parentDivs.length; i++) {
    if (this.parentDivs[i] == parentDiv) {
      index = i;
      break;
    }
  }
  if (index == -1) {
    for (i = 0; i < this.divs.length; i++) {
      var canvas = this.divs[i];
      this.applyForRender(canvas);
    }
  } else {
    for (i = 0; i < this.divs.length; i++) {
      if (index == i) {
        var canvas = this.divs[i];
        this.applyForRender(canvas);
      }
    }
  }
};
var _default = exports["default"] = MMImgViewCtl;

},{"1184":1184,"1454":1454,"811":811,"823":823,"892":892}],892:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1432);
var _MMBasicData = _interopRequireDefault(require(811));
var _MMCenterRect = _interopRequireDefault(require(829));
/**
 * 用于控制对象在屏幕上使用 HTMLElement 进行显示的机制
 */

/**
 * 构造函数
 * @param {MMObject} 显示的数据对象
 * @param {HTMLElement} parentDiv 父元素
 */

function MMObjElementController(obj) {
  this.mmobj = obj;
  this.parentDivs = new Array(); // 显示的元素所在的父 div 数组
  this.divs = new Array();
}
;
MMObjElementController.prototype.displayInDiv = function ($parentDiv, trsfm, pgindex) {
  var parentDiv = $parentDiv[0];
  if (parentDiv != undefined && parentDiv != null) {
    var i = 0;
    for (i = 0; i < this.parentDivs.length; i++) {
      if (this.parentDivs[i] == parentDiv) {
        break;
      }
    }
    if (i < this.parentDivs.length) {
      this.$div = $(this.divs[i]);
    } else {
      this.$div = this.createDiv();
      this.parentDivs.push(parentDiv);
      this.divs.push(this.$div[0]);
      $(parentDiv).append(this.$div);
      this.addEventHandler();
    }
    this.setAttr(this.$div, trsfm);
  }
  this.placeElement(this.$div, trsfm);
  var data = this.mmobj.getObjData();
  if (data) {
    var alpha = data.m_fillType.m_fillColor.m_alpha;
    this.$div.css("opacity", alpha);
    //    console.log("obj" + this.mmobj.m_className +  " opacity -----------> " + alpha);
    data.m_strokeType.setDivAppearance(this.$div[0], trsfm);
    data.m_shadowType.setDivAppearance(this.$div[0], trsfm);
  }
};
MMObjElementController.prototype.createDiv = function (parentDiv) {};
MMObjElementController.prototype.refreshLayerIndex = function (index_) {
  var startIndex = _MMBasicData["default"].getPdfStartlayerZ_index();
  for (var i = 0; i < this.divs.length; i++) {
    var $div = $(this.divs[i]);
    $div.css("z-index", startIndex + index_);
  }
};
MMObjElementController.prototype.addEventHandler = function () {
  return null;
};
MMObjElementController.prototype.placeElement = function ($element, trsfm) {
  if (this.mmobj.getDrawRect() != undefined) {
    var lgrct = new _MMCenterRect["default"]();
    lgrct.setRect(this.mmobj.getDrawRect());
    lgrct.setAngle(this.mmobj.getDrawAngle());
    var dvrct = trsfm.lg2dvCenterRect(lgrct, trsfm.getStartPageIndex());
    $element.css("left", Math.round(dvrct.getLeftTop().x) + 'px');
    $element.css("top", Math.round(dvrct.getLeftTop().y) + 'px');
    $element.css("box-sizing", "border-box");
    if ($element[0].tagName == 'CANVAS') {
      $element.attr("width", Math.round(dvrct.width));
      $element.attr("height", Math.round(dvrct.height));
    } else {
      $element.css("width", Math.round(dvrct.width) + 'px');
      $element.css("height", Math.round(dvrct.height) + 'px');
    }
    $element.css('transform', 'rotate(' + dvrct.angle + 'deg)');
  }
};
MMObjElementController.prototype.release = function () {
  this.mmobj = null;
  for (var i = 0; i < this.parentDivs.length; i++) {
    $(this.divs[i]).remove();
    this.divs[i] = null;
  }
};
MMObjElementController.prototype.removeDiv = function (parentDiv) {
  for (var i = 0; i < this.parentDivs.length; i++) {
    if (this.parentDivs[i] == parentDiv) {
      $(this.divs[i]).remove();
      this.divs[i] = null;
      break;
    }
  }
  if (i < this.parentDivs.length) {
    this.parentDivs.splice(i, 1);
    this.divs.splice(i, 1);
  }
};
MMObjElementController.prototype.empty = function () {
  return this.divs.length == 0;
};
MMObjElementController.prototype.changeEditable = function (trsfm) {
  var parentDiv = trsfm.$viewcontent[0];
  if (parentDiv != undefined && parentDiv != null) {
    var i = 0;
    for (i = 0; i < this.parentDivs.length; i++) {
      if (this.parentDivs[i] == parentDiv) {
        break;
      }
    }
    if (i < this.parentDivs.length) {
      var $div = $(this.divs[i]);
      this.setAttr($div, trsfm);
    }
  }
};
MMObjElementController.prototype.setAttr = function ($div, trsfm) {
  while ($div.length > 0) {
    if (trsfm.view_editable) {
      $div.css("pointer-events", "auto");
    } else {
      $div.css("pointer-events", "none");
    }
    $div = $div.children();
  }
};
var _default = exports["default"] = MMObjElementController;

},{"1184":1184,"1432":1432,"1454":1454,"811":811,"829":829}],7:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1451);
require(1437);
require(1463);
require(1478);
require(1432);
var _MDRectHtmlComment = _interopRequireDefault(require(223));
var _MDArrowHtmlComment = _interopRequireDefault(require(216));
var _MDHtmlComment = _interopRequireDefault(require(219));
var _ObjVisibleScope = _interopRequireDefault(require(1085));
var _MDEvents = _interopRequireDefault(require(325));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDCommentActionManager = _interopRequireDefault(require(5));
var _MMCommonFun = _interopRequireDefault(require(812));
var _CommentStatus = _interopRequireDefault(require(1036));
var _MD3DComment = _interopRequireDefault(require(6));
var _MMCommentDataController = _interopRequireDefault(require(1097));
var _MMIdManager = _interopRequireDefault(require(951));
var _MMChatMessage = _interopRequireDefault(require(950));
var _MDVirtualBoard = _interopRequireDefault(require(97));
// MDCommentsFile.js
//
// jiang
// 2016-9-1

function MDCommentsFile(fileId) {
  _MDVirtualBoard["default"].call(this, fileId);
  this.comments = []; //new ds.Map;
  this.m_actionManager = new _MDCommentActionManager["default"]({
    fileId: this.fileId
  });
  this.className = "MDCommentsFile";
}
;
Object.assign(MDCommentsFile.prototype, _MDVirtualBoard["default"].prototype, {
  contstructor: MDCommentsFile,
  addComment: function addComment(comment, text, atIds, ver, sucess, fail) {
    comment.id = _MMIdManager["default"].getNewId();
    this.comments.push(comment);
    var versionShowing = ver;
    comment.setFileVersion(versionShowing);
    var that = this;
    this.m_actionManager.addComment(comment, function () {
      that.m_actionManager.replyComment(versionShowing, comment.getVisibleScope(), comment.id.toString(), JSON.stringify({
        'Type': 'Text',
        'Body': text,
        'atIds': atIds
      }), function () {
        _Dispatcher["default"].trigger(_MDEvents["default"].Comment_changed);
        if (sucess) {
          sucess();
        }
        ;
      }, function () {
        if (fail) {
          fail(2);
        }
        ;
      });
    }, function () {
      if (fail) {
        fail(1);
      }
      ;
    });
  },
  getObject: function getObject(id) {
    for (var i = 0; i < this.comments.length; i++) {
      var comment = this.comments[i];
      if (comment.getId().isEqualTo(id)) {
        return comment;
      }
      ;
    }
    ;
    return null;
  },
  set3DCommentsCtl: function set3DCommentsCtl(ctl) {
    this.commentsCtl = ctl;
  },
  removeComment: function removeComment(commentId) {
    this.comments.remove(commentId);
  },
  getComment: function getComment(index) {
    return this.comments[index];
  },
  getAllComments: function getAllComments(version, callback) {
    //this.m_actionManager.getAllComments(function sucess(){
    if (callback) {
      callback(this.comments);
    }
    ;
    //})
    return this.comments;
  },
  getDisplayComments: function getDisplayComments(callback) {
    if (callback) {
      var commentsShowing = [];
      for (var i = 0; i < this.comments.length; i++) {
        var comment = this.comments[i];
        if (comment.getFileVersion() == this.verShowing) {
          commentsShowing.push(comment);
        }
        ;
      }
      ;
      callback(commentsShowing);
    }
    ;
  },
  getFileThumbnailInfo: function getFileThumbnailInfo() {
    var urlInfo = {};
    urlInfo.url = 'img/mdisk/3d.jpg';
    urlInfo.imgSize = {
      x: 300,
      y: 300
    };
    urlInfo.fileName = this.fileInfo.getFileName();
    return urlInfo;
  },
  getAllCommentsForVersion: function getAllCommentsForVersion() {
    return [];
  },
  clearMemory: function clearMemory() {
    _MDVirtualBoard["default"].prototype.clearMemory.call(this);
    this.commentsCtl = null;
  },
  isClosed: function isClosed() {
    return false;
  },
  commentCompleted: function commentCompleted(comment, completed) {
    var self = this;
    this.m_actionManager.setCompleted(comment.getId().toString(), completed, function () {
      if (self.commentsCtl) {
        comment.setFinished(completed);
        self.commentsCtl.onCommentStatusChanged(comment);
      }
    }, function () {});
  },
  // commentsfile comment readed
  commentReaded: function commentReaded(comment) {
    var self = this;
    this.m_actionManager.commentReaded(comment.getId().toString(), function () {
      if (self.commentsCtl) {
        comment.setReadStatus(_CommentStatus["default"].Comment_read);
        self.commentsCtl.onCommentStatusChanged(comment);
      }
      ;
    }, function () {});
  },
  deleteComment: function deleteComment(comment, sucess) {
    var self = this;
    this.m_actionManager.removeComment(comment.getId().toString(), function () {
      if (self.commentsCtl) {
        self.commentsCtl.onCommentDeleted(comment);
      }
      ;
      if (sucess) {
        sucess();
      }
      ;
    }, function fail() {});
  },
  deleteCommentById: function deleteCommentById(commentId, sucess, fail) {
    var self = this;
    this.m_actionManager.removeComment(commentId, function () {
      if (self.commentsCtl) {
        self.commentsCtl.onCommentDeleted(commentId);
        if (sucess) {
          sucess();
        }
        ;
      }
      ;
    }, fail);
  },
  deleteComment_Local: function deleteComment_Local(commentId) {
    var deletedComment = undefined;
    for (var i = 0; i < this.comments.length; i++) {
      if (this.comments[i].getId().isEqualTo(commentId)) {
        deletedComment = this.comments.splice(i, 1);
        deletedComment = deletedComment[0];
        break;
      }
    }
    if (deletedComment && this.commentsCtl) {
      this.commentsCtl.onCommentDeleted(deletedComment);
    }
    ;
  },
  clearActionStacks: function clearActionStacks() {

    // self.m_actionManager.clearActionStacks();
  },
  sendMessage: function sendMessage(message, commentId, param, callback) {
    var strCommentId = commentId.toString();
    this.m_actionManager.replyComment(undefined, undefined, strCommentId, message, function (messageId) {
      callback && callback(0, messageId);
    }, function () {
      callback && callback(1);
    });
    var userId = app.currentUser.getUserId_Int();
    var userName = app.currentUser.getUserName();
    return new _MMChatMessage["default"](0, userId, 0, new Date().getTime(), userName, message, commentId);
  },
  // 为了和旧接口兼容
  addObject: function addObject(comment) {},
  addComment_Local: function addComment_Local(comment) {
    var commentId = comment.id;
    for (var i = 0; i < this.comments.length; i++) {
      if (this.comments[i].getId().isEqualTo(commentId)) {
        return;
      }
    }
    var self = this;
    self.comments.push(comment);
    // 刷新
    if (self.commentsCtl) {
      self.commentsCtl.onCommentCreated(comment);
    }
    ;
  },
  // 为了和旧接口兼容
  notify: function notify() {},
  // create comment from server data
  initData: function initData(data) {
    var that = this;
    for (var i = 0; i < data.length; i++) {
      var comment = null;
      if (data[i]['cameraPosX'] != undefined) {
        comment = new _MD3DComment["default"]();
      } else if (data[i]['className'] == 'MDArrowHtmlComment') {
        comment = new _MDArrowHtmlComment["default"]();
      } else if (data[i]['className'] == 'MDRectHtmlComment') {
        comment = new _MDRectHtmlComment["default"]();
      } else {
        comment = new _MDHtmlComment["default"]();
      }
      comment.setBoard(this);
      comment.decode(data[i]);
      var visible = false;
      if (!comment.getVisibleScope()) {
        visible = true;
      } else {
        if (app.isEpVersion() && !app.currentUser.isEnterpriseGuest() && this.fileInfo.belongsToCurrentUserEnterprise()) {
          if (comment.getVisibleScope() == _ObjVisibleScope["default"].privateObject) {
            var uid = app.currentUser.getUserId_Int();
            var cid = comment.getCreator();
            if (uid.isEqualTo(cid)) {
              visible = true;
            }
          } else {
            visible = true;
          }
        }
        ;
      }
      if (visible) {
        this.comments.push(comment);
      }
      ;
    }
    _MMCommentDataController["default"].getFileCommentInfos(this.fileId, function (data) {
      for (var j = 0; j < data.length; j++) {
        var strId = data[j].id;
        for (var i = 0; i < that.comments.length; i++) {
          if (strId === that.comments[i].getId().toString()) {
            if (data[j].unreadedCount == 0) {
              that.comments[i].setReadStatus(_CommentStatus["default"].Comment_read);
            } else {
              that.comments[i].setReadStatus(_CommentStatus["default"].Comment_unread);
            }
            that.comments[i].setFinished(data[j].completed);
          }
        }
      }
    }, function () {});
  },
  registerFindController: function registerFindController() {}
});
var _default = exports["default"] = MDCommentsFile;

},{"1036":1036,"1085":1085,"1097":1097,"1184":1184,"1432":1432,"1437":1437,"1451":1451,"1454":1454,"1463":1463,"1478":1478,"18":18,"216":216,"219":219,"223":223,"325":325,"5":5,"6":6,"812":812,"950":950,"951":951,"97":97}],97:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDVirtualDocument = _interopRequireDefault(require(98));
// MDVirtualBoard.js
//
// jiang
// 2016-9-1

function MDVirtualBoard(fileId) {
  this.curVersion = 0;
  this.verShowing = 0;
  this.fileId = fileId;
  this.className = "MDVirtualBoard";
}
;
MDVirtualBoard.prototype = {
  contstructor: MDVirtualBoard,
  // setVersionShowing: function(v) {
  //   this.verShowing = v;
  // },

  // getVersionShowing: function() {
  //   return this.verShowing;
  // },

  isVirtualBoard: function isVirtualBoard() {
    return true;
  },
  getCurVersion: function getCurVersion() {
    return this.fileInfo.getCurVersion();
  },
  getId: function getId() {
    return this.fileId;
  },
  getStringId: function getStringId() {
    return this.fileId;
  },
  isOperateOnPDFFile: function isOperateOnPDFFile() {
    return false;
  },
  getDispFilePath: function getDispFilePath(fileInfo, version, callback) {
    if (fileInfo.canDispInWebBrowser()) {
      MMCommonFun.getDocumentDispRelativePath(fileInfo, version, function (url) {
        // MMCommonFun.getRealRequestURL(url, function(url) {
        if (callback) {
          callback(url);
        }
        ;
        // });
      }, function (errorCode, errorMsg) {
        if (errorCode == 141) {
          _MDSnackbarView["default"].showStandardMsg(42);
        } else {
          _MDSnackbarView["default"].show(errorMsg);
        }
      });
    } else {
      MMCommonFun.getDocumentDispPath(fileInfo.getFileId(), version, function (url, type, key) {
        // MMCommonFun.getRealRequestURL(url, function(url) {
        if (callback) {
          callback(url, type, key);
        }
        ;
        // });
      }, function (errorCode, errorMsg) {
        if (errorCode == 141) {
          _MDSnackbarView["default"].showStandardMsg(42);
        } else {
          _MDSnackbarView["default"].show(errorMsg);
        }
      });
    }
  },
  getFileThumbnailInfo: function getFileThumbnailInfo() {
    var ext = this.fileInfo.getLowerCaseExt();
    var urlInfo = null;
    if (ext == 'md') {
      urlInfo = {};
      urlInfo.url = 'img/mdisk/markdown.jpg';
      urlInfo.imgSize = {
        x: 300,
        y: 300
      };
      urlInfo.fileName = this.fileInfo.getFileName();
    } else {
      urlInfo = {};
      urlInfo.url = 'img/mdisk/store1.png';
      urlInfo.imgSize = {
        x: 76,
        y: 76
      };
      urlInfo.fileName = this.fileInfo.getFileName();
    }
    return urlInfo;
  },
  getAllCommentsForVersion: function getAllCommentsForVersion() {
    return [];
  },
  getFileInfo: function getFileInfo() {
    return this.fileInfo;
  },
  setFileInfo: function setFileInfo(fileInfo) {
    this.fileInfo = fileInfo;
  },
  clearMemory: function clearMemory() {},
  isClosed: function isClosed() {
    return false;
  },
  commentCompleted: function commentCompleted(comment, completed) {},
  commentReaded: function commentReaded(comment) {},
  deleteComment: function deleteComment(comment) {
    var self = this;
    this.m_actionManager.removeComment(comment.getId().toString(), function sucess() {
      if (self.commentsCtl) {
        self.commentsCtl.onCommentDeleted(comment);
      }
      ;
    }, function fail() {});
  },
  clearActionStacks: function clearActionStacks() {

    // self.m_actionManager.clearActionStacks();
  },
  // 为了和旧接口兼容
  addObject: function addObject(comment) {},
  // 为了和旧接口兼容
  notify: function notify() {},
  setDisplayName: function setDisplayName(name) {
    this.displayName = name;
  },
  getDisplayName: function getDisplayName(name) {
    return this.displayName;
  },
  getPageCount: function getPageCount() {
    return 1;
  },
  isCADFile: function isCADFile() {
    return false;
  },
  getPageCountByVersion: function getPageCountByVersion() {
    return 1;
  },
  sendScribbles2Server: function sendScribbles2Server(ver, sucess, fail) {
    sucess && sucess();
  },
  sendWeldMark2Server: function sendWeldMark2Server(ver) {},
  getScribbleGroupByCreator: function getScribbleGroupByCreator() {
    return [];
  },
  registerFindController: function registerFindController() {},
  canDispWithSVG: function canDispWithSVG() {
    return this.fileInfo.dispWithSVG();
  },
  getImgPdfObjectsForVersion: function getImgPdfObjectsForVersion(version) {
    if (this.canDispWithSVG()) {
      if (!this.svgDocs) {
        this.svgDocs = {};
      }
      if (!this.svgDocs[version]) {
        var svgDoc = new _MDVirtualDocument["default"](this, this.fileInfo, version);
        this.svgDocs[version] = [svgDoc];
      }
      return this.svgDocs[version];
    }
    return [];
  },
  getObjsInPageByFilter: function getObjsInPageByFilter() {
    return [];
  },
  clearPdfPage: function clearPdfPage() {}
};
var _default = exports["default"] = MDVirtualBoard;

},{"1184":1184,"1437":1437,"1454":1454,"1463":1463,"1478":1478,"72":72,"98":98}],98:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * 
 * @param {*} board 
 * @param {*} init 
 * jiang
 * 2021-12-2
 */
function MDVirtualDocument(board, fileInfo, version) {
  this.board = board;
  this.fileInfo = fileInfo;
  this.version = version;
}
;
MDVirtualDocument.prototype.getDispFilePath = function () {
  return "temp.path"; // 不能为空， 随便给个值即可
};
MDVirtualDocument.prototype.getDispSVGFilePath = function (callback) {
  var ver_ = this.version;
  if (ver_ < 0 || ver_ == undefined) {
    ver_ = 0;
  }
  ;
  MMCommonFun.getDownloadRealPath(this.board.getStringId(), ver_, function (path) {
    callback(path);
  });
};
MDVirtualDocument.prototype.getBoard = function () {
  return this.board;
};
MDVirtualDocument.prototype.setShowingOriginFile = function (show) {
  this.showOriginFile = show;
};
MDVirtualDocument.prototype.getOriginSize = function () {
  return this.originSize;
};
MDVirtualDocument.prototype.getObjType = function () {
  return null;
};
MDVirtualDocument.prototype.getPageIndex = function () {
  return 0;
};
MDVirtualDocument.prototype.setOriginSize = function (point) {
  this.originSize = {
    x: point.x,
    y: point.y
  };
};
MDVirtualDocument.prototype.getDrawAngle = function () {
  return 0;
};
MDVirtualDocument.prototype.getExpandRect = function () {
  return null;
};
MDVirtualDocument.prototype.getDrawRect = function () {
  return null;
};
MDVirtualDocument.prototype.getThumbnailUrl = function () {
  return null;
};
MDVirtualDocument.prototype.setRotateAngle90 = function () {};
var _default = exports["default"] = MDVirtualDocument;

},{"1454":1454}],223:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1451);
var _MDHtmlComment = _interopRequireDefault(require(219));
var _int = _interopRequireDefault(require(820));
// MDHtmlComment.js
//
// jiang
// 2017-10-3

function MDRectHtmlComment() {
  _MDHtmlComment["default"].call(this);
  // this.id = MDHtmlComment.id++;

  this.rectWidth = 0;
  this.rectHeight = 0;
  this.m_className = "MDRectHtmlComment";
  this.grahType = 'rect'; // 还可能是 ellipse
}
;
MDRectHtmlComment.prototype = Object.assign(MDRectHtmlComment.prototype, _MDHtmlComment["default"].prototype, {
  constructor: MDRectHtmlComment,
  encode: function encode() {
    var code = _MDHtmlComment["default"].prototype.encode.call(this);
    return _.extend(code, {
      "rectWidth": this.rectWidth,
      "rectHeight": this.rectHeight,
      "graphType": this.graphType
    });
  },
  // decode arrow comment
  decode: function decode(stream) {
    _MDHtmlComment["default"].prototype.decode.call(this, stream);
    this.rectWidth = stream["rectWidth"];
    this.rectHeight = stream['rectHeight'];
    this.graphType = stream['graphType'];
    if (!this.graphType) {
      this.graphType = 'rect';
    }
    ;
  },
  initWithPosInfo: function initWithPosInfo(posInfo) {
    this.domIndex = posInfo.posInfo.domIndex;
    this.x = posInfo.posInfo.x;
    this.y = posInfo.posInfo.y;
    this.rectWidth = posInfo.rectWidth;
    this.rectHeight = posInfo.rectHeight;
    this.lineWidth = posInfo.lineWidth;
    this.graphType = posInfo.graphType;
  }
});
var _default = exports["default"] = MDRectHtmlComment;

},{"1184":1184,"1451":1451,"1454":1454,"219":219,"820":820}],216:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1451);
var _MDHtmlComment = _interopRequireDefault(require(219));
var _ObjType = _interopRequireDefault(require(1084));
var _OBJ_ID = _interopRequireDefault(require(818));
var _MMObject = _interopRequireDefault(require(1081));
var _int = _interopRequireDefault(require(820));
// MDArrowHtmlComment.js
//
// jiang
// 2017-10-2

function MDArrowHtmlComment() {
  _MDHtmlComment["default"].call(this);
  // this.id = MDHtmlComment.id++;

  this.domIndex2 = -1;
  this.x2 = null;
  this.y2 = null;
  this.m_className = "MDArrowHtmlComment";
}
;
MDArrowHtmlComment.prototype = Object.assign(MDArrowHtmlComment.prototype, _MDHtmlComment["default"].prototype, {
  constructor: MDArrowHtmlComment,
  encode: function encode() {
    var code = _MDHtmlComment["default"].prototype.encode.call(this);
    return _.extend(code, {
      "domIndex2": this.domIndex2,
      "x2": this.x2,
      "y2": this.y2
    });
  },
  // decode arrow comment
  decode: function decode(stream) {
    _MDHtmlComment["default"].prototype.decode.call(this, stream);
    this.domIndex2 = stream["domIndex2"];
    this.x2 = stream['x2'];
    this.y2 = stream['y2'];
  },
  initWithPosInfo: function initWithPosInfo(posInfo) {
    this.domIndex = posInfo.posInfo1.domIndex;
    this.x = posInfo.posInfo1.x;
    this.y = posInfo.posInfo1.y;
    this.domIndex2 = posInfo.posInfo2.domIndex;
    this.x2 = posInfo.posInfo2.x;
    this.y2 = posInfo.posInfo2.y;
  }
});
var _default = exports["default"] = MDArrowHtmlComment;

},{"1081":1081,"1084":1084,"1184":1184,"1451":1451,"1454":1454,"219":219,"818":818,"820":820}],219:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1451);
require(1437);
require(1463);
require(1478);
require(1466);
require(1446);
var _MDLineWidthAndFont = _interopRequireDefault(require(861));
var _MDColorDisk = _interopRequireDefault(require(856));
var _MDNewComment = _interopRequireDefault(require(94));
var _MMIdManager = _interopRequireDefault(require(951));
var _ObjType = _interopRequireDefault(require(1084));
var _OBJ_ID = _interopRequireDefault(require(818));
var _MMObject = _interopRequireDefault(require(1081));
var _int = _interopRequireDefault(require(820));
// MDHtmlComment.js
//
// jiang
// 2017-9-4

function MDHtmlComment() {
  _MDNewComment["default"].call(this);
  this.m_id = this.id;
  this.domIndex = -1;
  this.x = null;
  this.y = null;
  this.m_className = "MDHtmlComment";

  // to mashixiong, save this attribute to server
  this.fileVersion = 0;
  this.visibleScope = 0;
  this.graphColor = 'red';
  this.lineWidth = 4;
  this.setRead(app.currentUser.getUserId_Int());
}
;
MDHtmlComment.id = 0;
MDHtmlComment.prototype = Object.assign(MDHtmlComment.prototype, _MDNewComment["default"].prototype, {
  constructor: MDHtmlComment,
  encode: function encode() {
    return {
      "id": this.id.toString(),
      "creatorId": parseInt(this.creatorId.toString()),
      "fileVersion": this.fileVersion,
      "domIndex": this.domIndex,
      "x": this.x,
      "y": this.y,
      "visibleScope": this.visibleScope,
      "className": this.m_className,
      "graphColor": this.graphColor,
      "lineWidth": this.lineWidth
    };
  },
  // decode html comment
  decode: function decode(stream) {
    this.id = new _OBJ_ID["default"]();
    this.id.fromString(stream["id"]);
    this.creatorId = new _int["default"](stream["creatorId"]);
    this.fileVersion = Number(stream["fileVersion"]);
    this.domIndex = stream["domIndex"];
    this.x = stream['x'];
    this.y = stream['y'];
    this.visibleScope = stream["visibleScope"];
    if (!this.visibleScope) {
      this.visibleScope = 0;
    }
    ;
    this.graphColor = stream["graphColor"];
    if (!this.graphColor) {
      this.graphColor = _MDColorDisk["default"].getCurColor();
    }
    ;
    this.className = stream["className"];
    this.lineWidth = stream["lineWidth"];
    if (!this.lineWidth) {
      this.lineWidth = _MDLineWidthAndFont["default"].getCurLineWidth();
    }
    ;
  },
  setGraphColor: function setGraphColor(color) {
    this.graphColor = color;
  },
  setLineWidth: function setLineWidth(w) {
    this.lineWidth = w;
  }
});
var _default = exports["default"] = MDHtmlComment;

},{"1081":1081,"1084":1084,"1184":1184,"1437":1437,"1446":1446,"1451":1451,"1454":1454,"1463":1463,"1466":1466,"1478":1478,"818":818,"820":820,"856":856,"861":861,"94":94,"951":951}],861:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var MDLineWidthAndFont = {
  lineWidths: [5, 10, 14],
  curWidthIndex: 0,
  fontSizes: [18, 20, 24, 28, 32, 36, 42, 46, 52, 56],
  curFontIndex: 2,
  getCurLineWidth: function getCurLineWidth() {
    return this.lineWidths[this.curWidthIndex];
  },
  getCurFontSize: function getCurFontSize() {
    return this.fontSizes[this.curFontIndex];
  },
  getGraphCommentLineWidth: function getGraphCommentLineWidth() {
    return 2;
  }
};
var _default = exports["default"] = MDLineWidthAndFont;

},{"1454":1454}],856:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var MDColorDisk = {
  colors: ['#fd3f71', '#ff0000', '#00ff00', '#0000ff', '#ffffff', '#000000'],
  curIndex: 0,
  getCurColor: function getCurColor() {
    return this.colors[this.curIndex];
  },
  getGraphCommentBorderColor: function getGraphCommentBorderColor() {
    return '#ffc107';
  },
  getGraphCommentContentColor: function getGraphCommentContentColor() {
    return 'rgba(255, 235,59, 0.2)';
  },
  commentColor: {
    "private": "blue",
    ent: "#696B6F",
    evaluation: "rgb(238, 10, 200)"
  }
};
var _default = exports["default"] = MDColorDisk;

},{"1454":1454}],313:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1466);
var _MDEvents = _interopRequireDefault(require(325));
var _MDSnackbarView = _interopRequireDefault(require(72));
var MDAudioPlayer = function () {
  'use strict';

  var player = {};
  _.extend(player, Backbone.Events);
  player.playing = [];
  var palyingButton;
  var $playerContainer = $('<div style="position:absolute;width:0px;height:0px;display:none;">');
  player.$container = $playerContainer;
  $(document.body).append($playerContainer);
  $playerContainer.jPlayer({
    'swfPath': '/img/mdisk',
    //jquery.jplayer.swf
    'supplied': 'm4a',
    'volume': 1,
    'timeupdate': function timeupdate(e) {
      player.trigger(_MDEvents["default"].TIME_UPDATE, e.jPlayer.status);
    },
    'ended': function ended(_ended) {
      player.trigger(_MDEvents["default"].PLAY, null);
    }
  });
  $playerContainer.on($.jPlayer.event.error, function ($e) {
    palyingButton && palyingButton.removeClass('sprite_pic_speaker-actived');
    var type = $e['jPlayer']['error']['type'];
    if ("e_no_support" == type || 'e_url' == type) {
      _MDSnackbarView["default"].show(BabelStr.str(7058));
    }
  });

  /**
   * start playing
   * @param url {string} the file to play
   */
  player.play = function (url, button) {
    if (!url) {
      $playerContainer.jPlayer('stop');
      return;
    }
    player.playingURL = url;
    player.trigger(_MDEvents["default"].PLAY, url);
    $playerContainer.jPlayer('stop');
    $playerContainer.jPlayer('setMedia', {
      'm4a': url
    });
    $playerContainer.jPlayer('play');
  };

  /**
   * stops playing
   */
  player.stop = function () {
    $playerContainer.jPlayer('stop');
    for (var i = 0; i < player.playing.length; i++) {
      player.playing[i].removeClass('sprite_pic_speaker-actived');
    }
    player.playing = [];
    player.trigger(_MDEvents["default"].PLAY, null);
  };

  /**
   * is creating an html Element, where the user can click on to play the given file.
   * @param url {string} the file to play
   * @param time {string}
   */
  player.getAudioPlayer = function (fileName, time, boardDecId, getPrototype) {
    var tmpl = '<dic class="audioPlayer f-noselect">' + '<div class="popCommentListenBtn sprite_pic_speaker-default"></div>' + '<div class="time">' + time + '</div>' + '</div>';
    var $messageDisplay = $(tmpl);
    var eventName;
    var $popCommentListenBtn = $messageDisplay.find('.popCommentListenBtn');
    time = parseInt(time) * 1000;
    var realURL = fileName;
    if (getPrototype) {
      return $messageDisplay;
    }
    MMCommonFun.downloadAttachmentURL(boardDecId, 0, fileName, function (real) {
      if (real) {
        realURL = real;
      }
    });
    if (MMCommonFun.isPC()) {
      eventName = 'click';
    } else {
      eventName = 'touchstart';
    }
    $messageDisplay.on(eventName, function () {
      palyingButton = $popCommentListenBtn;
      player.play(realURL, $popCommentListenBtn);
      player.playing.push($popCommentListenBtn);
      $popCommentListenBtn.addClass('sprite_pic_speaker-actived');
      _.delay(function () {
        $popCommentListenBtn.removeClass('sprite_pic_speaker-actived');
        player.playing = _.without(player.playing, $popCommentListenBtn);
      }, time);
    });
    return $messageDisplay;
  };
  return player;
}();
var _default = exports["default"] = MDAudioPlayer;

},{"1184":1184,"1417":1417,"1454":1454,"1463":1463,"1466":1466,"325":325,"72":72}],307:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
require(1432);
require(1421);
var _MMCollectionBase = _interopRequireDefault(require(20));
var _MMParticipant = _interopRequireDefault(require(306));
var _int = _interopRequireDefault(require(820));
/**
 *
 * MMParticipantCollection
 *
 * MolaTask user collection class , used to save user models ,
 * and communicate with the server side .
 *
 * Create by manjun.han
 * 2014.1.6
 *
 */

var MMParticipantCollection = _MMCollectionBase["default"].extend({
  model: _MMParticipant["default"],
  getUserListOfTaskAction: "/task/getTaskParticipant.do",
  addUserToTaskAction: "",
  deleteParticipantAction: "/task/deleteParticipant.do",
  searchUserByName: "",
  /*
   * the users whose content need to be hiden.
   */
  m_usersHide: [],
  /**
   * Get the participant list of current task
   * @param  {String} taskId The task's id .
   * @param  {Options} opt
   */
  getTaskUserListOfTask: function getTaskUserListOfTask(taskInfor, opt) {
    opt = _.extend({}, opt);
    var taskId = taskInfor.get("stringId");
    opt.data = {
      'boardId': taskId
    };
    var self = this,
      success = opt.onSuccess;
    opt.onSuccess = function (data, jqXhr, textStatus) {
      if (data['success']) {
        self.reset();
        var participantList = data['participantList'];
        // 去掉id
        _.each(participantList, function (element, index) {
          participantList[index] = _.omit(element, "id");
        });
        var currentUserId = app.currentUser.getUserId();

        // 不管是打开我创建的还是我参与的项目，我的头像始终显示在第一位
        var mySelf = _.find(participantList, function (participant) {
          if (participant['stringParticipantId'] == currentUserId) {
            return true;
          }
        });
        participantList = _.reject(participantList, function (participant) {
          return mySelf == participant;
        });
        participantList.unshift(mySelf);
        self.add(participantList);
      }
      if (self.isFunction(success)) {
        success(data, jqXhr, textStatus);
      }
    };
    var url = this.buildAppRequestURL(this.getUserListOfTaskAction);
    this.httpPost(url, opt);
  },
  /**
   * Delete the specified participant from the task .
   * @param  {String} taskId      The task id
   * @param  {MMPaticipant} participant The participant that will be deleted from the task.
   * @param  {Options} opt
   */
  deleteParticipant: function deleteParticipant(taskId, participant, opt) {
    opt = _.extend({}, opt);
    opt.data = {
      'boardId': taskId,
      'participantId': participant.get("stringParticipantId")
    };
    var self = this,
      success = opt.onSuccess;
    opt.onSuccess = function (data, jqXhr) {
      if (data['success']) {
        self.remove(participant);
        if (self.isFunction(success)) {
          success(data);
        }
      } else {
        if (_.isFunction(opt.onError)) {
          opt.onError();
        }
      }
    };
    var url = this.buildAppRequestURL(this.deleteParticipantAction);
    this.httpGet(url, opt);
  },
  /**
   * mashx
   * @param
   * @param
   * @param
   */
  getParticipantIndexInCurrentBoard: function getParticipantIndexInCurrentBoard(userId) {
    var uId = userId instanceof _int["default"] ? userId.toDecString() : userId;
    var participant = this.findWhere({
      'stringParticipantId': uId
    });
    var ret = participant ? participant.get("joinOrder") : 0;
    return ret;

    // //不知道为什么，上面的joinOrder值不对。为了和iOS端保持一致，我们采用下面的代码。
    // var uId = (userId instanceof Int64)?userId.toDecString():userId;
    // var ret = {'index':0,'i':0};
    // this.each(function(participant){
    // 	var uxId = participant.get('stringParticipantId');
    // 	if (uId == uxId) {
    // 		ret['index'] = ret.i;
    // 	}
    // 	ret['i'] ++;
    // });
    // return ret['index'];
  },
  isUserVisible: function isUserVisible(userId) {
    if (this.m_usersHide) {
      for (var i = 0; i < this.m_usersHide.length; i++) {
        if (this.m_usersHide[i] == userId) {
          return false;
        }
      }
    }
    return true;
  },
  setUserVisible: function setUserVisible(userId, visible) {
    var i = 0;
    for (i = 0; i < this.m_usersHide.length; i++) {
      if (this.m_usersHide[i] == userId) {
        break;
      }
    }
    if (i < this.m_usersHide.length && visible) {
      this.m_usersHide.splice(i, 1);
    } else if (!visible) {
      this.m_usersHide.push(userId);
    }
  },
  setOnlyUserVisible: function setOnlyUserVisible(userId) {
    var that = this;
    this.m_usersHide = [];
    this.each(function (participant) {
      var uId = participant.get('stringParticipantId');
      if (uId != userId) {
        that.m_usersHide.push(uId);
      }
    });
  },
  clearHiddenUser: function clearHiddenUser() {
    this.m_usersHide = [];
  },
  searchForNameLike: function searchForNameLike(part) {
    part = part.toLowerCase();
    var out = [];
    for (var i = 0; i < this.models.length; i++) {
      if (this.models[i].attributes['userName'].toLowerCase().indexOf(part) !== -1) {
        out.push(this.models[i].attributes);
      }
    }
    return out;
  }
}, {
  singleton: null
});
var _default = exports["default"] = MMParticipantCollection;

},{"1184":1184,"1417":1417,"1421":1421,"1432":1432,"1454":1454,"1463":1463,"20":20,"306":306,"820":820}],306:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
var _MMModelBase = _interopRequireDefault(require(21));
var _int = _interopRequireDefault(require(820));
/**
 *
 * MMMolaUser
 *
 * MolaTask user model class
 *
 * Create by manjun.han
 * 2014.1.6
 *
 */

var MMParticipant = _MMModelBase["default"].extend({
  defaults: {
    'appVersion': 0,
    'avatarType': "",
    'id': -1,
    'joinOrder': -1,
    'languageType': -1,
    'joinTime': new Date(),
    'sessionId': -1,
    'participantId': -1,
    'leaveTime': new Date(),
    'sessionName': "",
    'stringId': "",
    'stringParticipantId': "",
    'token': "",
    'userName': BabelStr.str(722),
    'stringSessionId': ""
  },
  avatarImageBaseURL: "downloadFile.do",
  // get user avatar base url

  getTaskParticipantAction: "/task/getTaskParticipant.do",
  getAvatarImageURL: function getAvatarImageURL(style) {
    style = style || Math.round(window.devicePixelRatio || 1) + 10;
    var self = this;
    var strUserId = self.get('stringParticipantId');
    var valueUserId = new _int["default"](strUserId).valueOf();
    var url = this.buildAppRequestURL(this.avatarImageBaseURL, {
      'fileName': "avatar" + valueUserId + ".jpg",
      'typeFlag': 1,
      'userId': strUserId,
      'style': style
    });
    return url;
  }
});
var _default = exports["default"] = MMParticipant;

},{"1184":1184,"1437":1437,"1454":1454,"21":21,"820":820}],6:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1451);
require(1437);
require(1463);
require(1478);
require(1466);
require(1446);
var _MDNewComment = _interopRequireDefault(require(94));
var _MMObject = _interopRequireDefault(require(1081));
var _OBJ_ID = _interopRequireDefault(require(818));
var _ObjType = _interopRequireDefault(require(1084));
var _int = _interopRequireDefault(require(820));
// MD3DComment.js
//
// javascript/3d/data/MD3DComment.js
// jiang
// 2016-8-26

function MD3DComment() {
  _MDNewComment["default"].call(this);
  this.m_id = this.id;
  this.cameraPos = null;
  this.up = null;
  this.target = null;
  this.hostId = undefined;
  this.faceIndex = undefined;
  this.k1 = undefined;
  this.k2 = undefined;
  this.ptIndexes = undefined;

  // 当前隐藏的 3d object 的 id 数组， id 与上面的 this.hostId 同一个类型
  this.objIdHided = [];
  this.m_className = "MD3DComment";

  // to mashixiong, save this attribute to server
  this.fileVersion = 0;
  this.visibleScope = 0;
  this.setRead(app.currentUser.getUserId_Int());
}
;
MD3DComment.id = 0;
MD3DComment.prototype = Object.assign(MD3DComment.prototype, _MDNewComment["default"].prototype, {
  constructor: MD3DComment,
  encode: function encode() {
    return {
      "id": this.id.toString(),
      "creatorId": parseInt(this.creatorId.toString()),
      "host_obj_id": this.hostId,
      "host_face_index": this.faceIndex,
      "host_k1": this.k1,
      "host_k2": this.k2,
      "pt_indexes": this.ptIndexes,
      "cameraPosX": this.cameraPos.x,
      "cameraPosY": this.cameraPos.y,
      "cameraPosZ": this.cameraPos.z,
      "cameraUpX": this.up.x,
      "cameraUpY": this.up.y,
      "cameraUpZ": this.up.z,
      "cameraTargetX": this.target.x,
      "cameraTargetY": this.target.y,
      "cameraTargetZ": this.target.z,
      "objIdHided": this.objIdHided,
      "fileVersion": this.fileVersion,
      "visibleScope": this.visibleScope
    };
  },
  decode: function decode(stream) {
    this.id = new _OBJ_ID["default"]();
    this.id.fromString(stream["id"]);
    this.m_id = this.id;
    this.creatorId = new _int["default"](stream["creatorId"]);
    this.hostId = stream["host_obj_id"];
    this.faceIndex = stream["host_face_index"];
    this.k1 = stream["host_k1"];
    this.k2 = stream["host_k2"];
    this.ptIndexes = stream["pt_indexes"];
    this.cameraPos = new THREE.Vector3(stream["cameraPosX"], stream["cameraPosY"], stream["cameraPosZ"]);
    this.up = new THREE.Vector3(stream["cameraUpX"], stream["cameraUpY"], stream["cameraUpZ"]);
    var x = Number(stream["cameraTargetX"]);
    var y = Number(stream["cameraTargetY"]);
    var z = Number(stream["cameraTargetZ"]);
    this.target = new THREE.Vector3(x, y, z);
    this.objIdHided = stream["objIdHided"];
    this.fileVersion = Number(stream["fileVersion"]);
    this.visibleScope = stream["visibleScope"];
    if (!this.visibleScope) {
      this.visibleScope = 0;
    }
    ;
  },
  setHided3DObjs: function setHided3DObjs(obj3DIds) {
    this.objIdHided = [];
    for (var i = 0; i < obj3DIds.length; i++) {
      this.objIdHided.push(obj3DIds[i]);
    }
    ;
  },
  getHided3DObjs: function getHided3DObjs(obj3DIds) {
    return this.objIdHided;
  }
});
var _default = exports["default"] = MD3DComment;

},{"1081":1081,"1084":1084,"1184":1184,"1437":1437,"1446":1446,"1451":1451,"1454":1454,"1463":1463,"1466":1466,"1478":1478,"818":818,"820":820,"94":94}],94:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1451);
var _MMCommentBasicData = _interopRequireDefault(require(1043));
var _MMObject = _interopRequireDefault(require(1081));
var _OBJ_ID = _interopRequireDefault(require(818));
var _ObjType = _interopRequireDefault(require(1084));
var _int = _interopRequireDefault(require(820));
var _MMIdManager = _interopRequireDefault(require(951));
// MDNewComment.js
//
// jiang
// 2017-9-4

function MDNewComment() {
  _MMCommentBasicData["default"].call(this);
  this.id = _MMIdManager["default"].getNewId();
  this.domIndex = -1;
  this.x = null;
  this.y = null;
  this.m_className = "MDNewComment";

  // to mashixiong, save this attribute to server
  this.fileVersion = 0;
  this.visibleScope = 0;
  this.setRead(app.currentUser.getUserId_Int());
}
;
MDNewComment.id = 0;
MDNewComment.prototype = Object.assign(MDNewComment.prototype, _MMCommentBasicData["default"].prototype, {
  constructor: MDNewComment,
  getClassName: function getClassName() {
    return this.m_className;
  },
  // functions
  setId: function setId(id) {
    this.id = id;
    this.m_id = id;
  },
  getId: function getId() {
    return this.id;
  },
  setText: function setText(text) {
    this.text = text;
  },
  encode: function encode() {
    return {};
  },
  decode: function decode(stream) {},
  fetchChatlog: function fetchChatlog(callback) {
    _MMCommentBasicData["default"].prototype.fetchChatlog.call(this, this.getId(), callback);
  },
  setFinished: function setFinished(finished) {
    this.finished = finished;
  },
  isFinished: function isFinished() {
    return this.finished;
  },
  setBoard: function setBoard(board) {
    this.board = board;
  },
  getBoard: function getBoard() {
    return this.board;
  },
  setCreator: function setCreator(creatorId) {
    this.creatorId = creatorId;
  },
  getCreator: function getCreator() {
    return this.creatorId;
  },
  getPageIndex: function getPageIndex() {
    return 0;
  },
  getObjType: function getObjType() {
    return _ObjType["default"].Obj_comment;
  },
  setCommentsCtl: function setCommentsCtl(ctl) {
    this.commentsCtl = ctl;
  },
  clearMemory: function clearMemory() {
    this.commentsCtl = null;
    this.board = null;
  },
  getReadStatus: function getReadStatus() {
    var userId = app.currentUser.getUserId_Int();
    var creatorId = this.getCreator();
    return _MMCommentBasicData["default"].prototype.getReadStatus.call(this, userId, creatorId);
  },
  setReadStatus: function setReadStatus(status_) {
    var userId = app.currentUser.getUserId_Int();
    _MMCommentBasicData["default"].prototype.setReadStatus.call(this, userId, status_);
  },
  setFileVersion: function setFileVersion(ver) {
    this.fileVersion = ver;
  },
  getFileVersion: function getFileVersion() {
    return this.fileVersion;
  },
  setVisibleScope: function setVisibleScope(scopeType) {
    this.visibleScope = scopeType;
  },
  getVisibleScope: function getVisibleScope() {
    return this.visibleScope;
  },
  getScopeDispStr: function getScopeDispStr() {
    return _MMObject["default"].scopeDispStrings[this.visibleScope];
  },
  isComment: function isComment() {
    return true;
  },
  isEvalComment: function isEvalComment() {
    var scope = this.getVisibleScope();
    if (scope >= 8) {
      return true;
    }
    return false;
  }
});
var _default = exports["default"] = MDNewComment;

},{"1043":1043,"1081":1081,"1084":1084,"1184":1184,"1451":1451,"1454":1454,"818":818,"820":820,"951":951}],1081:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1446);
require(1477);
require(1489);
var _MMIdManager = _interopRequireDefault(require(951));
var _ObjType = _interopRequireDefault(require(1084));
var _MMMeta = _interopRequireDefault(require(1080));
var _Encoder = _interopRequireDefault(require(800));
var _Decoder = _interopRequireDefault(require(799));
var _ObjVisibleScope = _interopRequireDefault(require(1085));
var _MMIndicateArrowData = _interopRequireDefault(require(1056));
var _MMBrokenLineData = _interopRequireDefault(require(1039));
var _MMRectangleData = _interopRequireDefault(require(1065));
var _MMRoundRectData = _interopRequireDefault(require(1066));
var _MMTriangleData = _interopRequireDefault(require(1073));
var _MMHexagonData = _interopRequireDefault(require(1054));
var _MMCircleData = _interopRequireDefault(require(1040));
var _MMSegmentData = _interopRequireDefault(require(1069));
var _MMDiamondData = _interopRequireDefault(require(1045));
var _MMDocData = _interopRequireDefault(require(1047));
var _MMHalfRoundRectData = _interopRequireDefault(require(1053));
var _MMPentagonData = _interopRequireDefault(require(1061));
var _MMFivestarData = _interopRequireDefault(require(1050));
var _MMDirectionArrowData = _interopRequireDefault(require(1046));
var _MMScribbleData = _interopRequireDefault(require(1067));
var _MMCircleMarkData = _interopRequireDefault(require(1041));
var _MMCloudData = _interopRequireDefault(require(1042));
var _MMNoteData = _interopRequireDefault(require(1059));
var _MMRectMarkData = _interopRequireDefault(require(1064));
var _MMTextData = _interopRequireDefault(require(1072));
var _MMEmojiTextData = _interopRequireDefault(require(1049));
var _MMImageData = _interopRequireDefault(require(1055));
var _MMPDFDocumentData = _interopRequireDefault(require(1060));
var _MMRecorderData = _interopRequireDefault(require(1063));
var _MMNitePenData = _interopRequireDefault(require(1058));
var _MMDocumentData = _interopRequireDefault(require(1048));
var _MMCommentObjData = _interopRequireDefault(require(1044));
var _MMNiceTagData = _interopRequireDefault(require(1057));
var _MMTextCommentData = _interopRequireDefault(require(1071));
var _MMCenterRect = _interopRequireDefault(require(829));
var _MMRect = _interopRequireDefault(require(831));
var _MMObjectData = _interopRequireDefault(require(1082));
var _MMSignatureFrameData = _interopRequireDefault(require(1070));
var _MMSealObjData = _interopRequireDefault(require(1068));
/**
 * @param {int} ver
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMMeta}
 */
function MMObject(board, ver) {
  _MMMeta["default"].call(this, board);
  this.m_id = null;
  this.m_expandRect = null; //--------------------- isPtOn时，需要的矩形
  /**
   * m_rect
   * @type {MMRect}
   */
  this.m_rect = null; //  ------------------------ 每个对象存储一个外接矩形，正的，没有旋转的

  this.m_objType = _ObjType["default"].Obj_default;
  this.m_lock = false;
  this.m_dataMgr = null;
  /**
   * m_dataForNew
   * @type {mola.math.MMObjData}
   */
  this.m_dataForNew = null;
  this.m_readFromData; // test  {bool}
  this.m_init = false;
  this.m_identity = -1; //上次修改的源  {ID }
  this.m_oper; //上次操作的类型  { enum OPERATOR}

  this.m_includeData = false; //记录是否自包含 data 数据，true 表示自包含，不需要从 datamanager 获得 data

  this.angle = 0;
  this.m_ver = 2;
  if (board) {
    this.m_dataMgr = board.getObjDataManager();
  }

  //  this.m_id = new OBJ_ID();
  //  this.m_id.m_localIndex = new Int64(-1);
  //  this.m_id.m_macAddr = new Int64(-1);

  // added by jiang, 2014-6-12
  this.dispCtl = null; // MMObjElementController
  this.visibleScope = 0; // 0 - public, 1 - enterprise, 2 - private

  // added by jiang, 2015-8-22   对象是针对哪个版本的
  this.fileVersion = ver;

  // added by jiang, 2018-12-20
  this.rotateAngle90 = 0; // 图片的旋转，0， 90， 180， 270
}
;
MMObject.prototype = new _MMMeta["default"]();
MMObject.superclass = _MMMeta["default"].prototype;
var open = BabelStr.str(460); // 此批注所有分享参与人可见
var protect = BabelStr.str(461); // 此批注仅企业内部参与人可见
var priv = BabelStr.str(462); //此批注仅自己可见
var evalStr = BabelStr.str(809); //评审意见
MMObject.scopeDispStrings = {
  0: open,
  1: protect,
  2: priv,
  8: evalStr
};
MMObject.SCOPE = {
  OPEN: 0,
  PROTECT: 1,
  PRIVATE: 2,
  IN_EVAL: 8
};
MMObject.prototype.initBy = function (obj) {
  MMObject.superclass.initBy.call(this, obj);
  this.m_id = null;
  this.m_expandRect = obj.m_expandRect ? obj.m_expandRect.clone() : null;
  this.m_rect = obj.m_rect ? obj.m_rect.clone() : null;
  this.getObjData().initBy(obj.getObjData());
};
MMObject.prototype.initWithWihteBoard = function (wihteBoard) {
  if (wihteBoard) {
    this.m_board = wihteBoard;
    this.m_dataMgr = wihteBoard.getObjDataManager();
  }
};
MMObject.prototype.getBoard = function () {
  return this.m_board;
};
MMObject.prototype.isAuxiliary = function () {
  return this.m_objType != _ObjType["default"].Obj_Image && this.m_objType != _ObjType["default"].Obj_PDF;
};
MMObject.prototype.decode = function (dc_, ver_) {
  MMObject.superclass.decode.call(this, dc_, ver_);
  var _objVer = 0;
  _objVer = dc_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
  this.m_id = dc_.decodeFromObjID(ver_);
  this.m_rect = dc_.decodeFromMMRect(ver_);
  this.m_expandRect = dc_.decodeFromMMRect(ver_);
  this.m_objType = dc_.decodeFrom4Bytes(ver_);
  this.m_lock = dc_.decodeFromBool(ver_);
  this.m_includeData = dc_.decodeFromBool(ver_);
  if (this.m_includeData) {
    if (this.m_dataForNew == null) {
      this._createObjData();
    }
    this.m_dataForNew.decode(dc_, ver_);
  }
  this.fileVersion = dc_.decodeFrom4Bytes(ver_);
  if (_objVer > 1) {
    this.visibleScope = dc_.decodeFrom4Bytes(ver_);
  }
  if (this.visibleScope == undefined || this.visibleScope == null) {
    this.visibleScope = 0;
  }
  ;
};
MMObject.prototype.encode = function (ec_) {
  MMObject.superclass.encode.call(this, ec_);
  var _objVer = 2;
  ec_.encode4Bytes(_objVer);
  ec_.encodeObjID(this.m_id);
  //for compatibility begin
  if (!this.m_rect) {
    this.m_rect = new _MMRect["default"](0, 0, 0, 0);
  }
  if (!this.m_expandRect) {
    this.m_expandRect = new _MMRect["default"](0, 0, 0, 0);
  }
  //for compatibility end
  ec_.encodeMMRect(this.m_rect);
  ec_.encodeMMRect(this.m_expandRect);
  ec_.encode4Bytes(this.m_objType);
  ec_.encodeBool(this.m_lock);
  ec_.encodeBool(this.m_includeData);
  if (this.m_includeData) {
    this.m_dataForNew.encode(ec_);
  }
  ec_.encode4Bytes(this.fileVersion);
  ec_.encode4Bytes(this.visibleScope);
};
MMObject.prototype.getObjType = function () {
  return this.m_objType;
};
MMObject.prototype.setLayerIndex = function (index_) {
  var data = this.getObjData();
  data.setLayerIndex(index_);
  if (this.dispCtl != null) {
    this.dispCtl.refreshLayerIndex(index_);
  }
};
MMObject.prototype.getLayerIndex = function () {
  var data = this.getObjData();
  return data.getLayerIndex();
};
/**
 *
 * @param color_ {MMColor}
 */
MMObject.prototype.changeColor = function (color_) {
  var data = this.getObjData();
  data.changeColor(color_);
};
/**
 *
 * @param fillType_ {MMFillType}
 */
MMObject.prototype.setFillType = function (fillType_) {
  var data = this.getObjData();
  data.setFillType(fillType_);
};

/**
 *
 * @param shadowType_ {MMShadowType}
 */
MMObject.prototype.setShadowType = function (shadowType_) {
  var data = this.getObjData();
  data.setShadowType(shadowType_);
};

/**
 *
 * @param strokeType_ {MMStrokeType}
 */
MMObject.prototype.setStrokeType = function (strokeType_) {
  var data = this.getObjData();
  data.setStrokeType(strokeType_);
};
MMObject.prototype.getStrokeType = function () {
  var data = this.getObjData();
  return data.getStrokeType();
};
MMObject.prototype.setId = function (id_) {
  this.m_id = id_;
};
MMObject.prototype.getId = function () {
  return this.m_id;
};
MMObject.prototype.getCreator = function () {
  var data = this.getObjData();
  if (data) {
    var dId = data.getId();
    if (dId != null && dId != undefined && dId.isEqualTo(this.m_id)) {
      return data.getCreator();
    }
  }
  return -1;
};
MMObject.prototype.setCreator = function (creator_) {
  this.getObjData().setCreator(creator_);
};
MMObject.prototype.isRegistered = function () {
  return this.m_id != null;
};
MMObject.prototype.getExpandRect = function () {
  if (!this.m_expandRect) {
    this.m_expandRect = new _MMRect["default"](0, 0, 0, 0);
    console.log("出错了");
  }
  return this.m_expandRect.clone();
};
MMObject.prototype.getIncludeData = function () {
  return this.m_includeData;
};
MMObject.prototype.setIncludeData = function (flag_) {
  this.m_includeData = flag_;
};

//MMObject.prototype.getLogicRect = function () {
//  return this.m_rect;
//} ;
//
///**
// *
// * @param rct {MMRect}
// */
MMObject.prototype.setRect = function (rct) {
  this.m_rect = rct;
};
MMObject.prototype.getCenter = function () {
  return this.m_rect.getCenter();
};
MMObject.prototype.getDispCenter = function () {
  return this.m_rect.getCenter();
};
///**
// *
// * @param rct {MMRect}
// */
//MMObject.prototype.getDrawRect = function(rct){
//  var data = this.getObjData();
//  return data.getDrawRect();
//};
//
///**
// *
// * return rct {MMRect}
// */
MMObject.prototype.getRect = function () {
  return this.m_rect.clone();
};
//
///**
// *
// * @param rct {MMRect}
// */
MMObject.prototype.setExpandRect = function (rct) {
  this.m_expandRect = rct;
};
MMObject.prototype.getObjData = function () {
  var _data = null;
  if (this.m_includeData) {
    if (this.m_dataForNew == null) {
      this._createObjData();
    }
    _data = this.m_dataForNew;
  } else {
    if (this.m_id && !this.m_id.isBlank()) {
      _data = this.m_dataMgr.getObjData(this.m_id);
      if (_data == null) {
        if (this.m_dataForNew == null) {
          this._createObjData();
        }
        _data = this.m_dataForNew;
      } else {
        if (this.m_dataForNew) {
          //                      delete m_dataForNew;
          this.m_dataForNew = null;
        }
      }
    } else {
      if (this.m_dataForNew == null) {
        this._createObjData();
      }
      _data = this.m_dataForNew;
    }
  }

  //      assertNotEquals(_data, null); // 需要在发布时移除此行

  return _data;
};
MMObject.prototype._createObjData = function () {
  switch (this.m_objType) {
    case _ObjType["default"].GObj_indicateline:
      this.m_dataForNew = new _MMIndicateArrowData["default"](this.m_board, this.m_init);
      break;
    case _ObjType["default"].GObj_brokenline:
      this.m_dataForNew = new _MMBrokenLineData["default"](this.m_board, this.m_init);
      break;
    case _ObjType["default"].GObj_rect:
      this.m_dataForNew = new _MMRectangleData["default"](this.m_board, this.m_init);
      break;
    case _ObjType["default"].GObj_roundrect:
      this.m_dataForNew = new _MMRoundRectData["default"](this.m_board, this.m_init);
      break;
    case _ObjType["default"].GObj_triangle:
      this.m_dataForNew = new _MMTriangleData["default"](this.m_board, this.m_init);
      break;
    case _ObjType["default"].GObj_hexagon:
      this.m_dataForNew = new _MMHexagonData["default"](this.m_board, this.m_init);
      break;
    case _ObjType["default"].GObj_circle:
      this.m_dataForNew = new _MMCircleData["default"](this.m_board, this.m_init);
      break;
    case _ObjType["default"].GObj_line:
      this.m_dataForNew = new _MMSegmentData["default"](this.m_board, this.m_init);
      break;
    case _ObjType["default"].GObj_diamond:
      this.m_dataForNew = new _MMDiamondData["default"](this.m_board, this.m_init);
      break;
    case _ObjType["default"].GObj_doc:
      this.m_dataForNew = new _MMDocData["default"](this.m_board, this.m_init);
      break;
    case _ObjType["default"].GObj_halfroundrect:
      this.m_dataForNew = new _MMHalfRoundRectData["default"](this.m_board, this.m_init);
      break;
    case _ObjType["default"].GObj_pentagon:
      this.m_dataForNew = new _MMPentagonData["default"](this.m_board, this.m_init);
      break;
    case _ObjType["default"].GObj_fivestar:
      this.m_dataForNew = new _MMFivestarData["default"](this.m_board, this.m_init);
      break;
    case _ObjType["default"].GObj_directionarrow:
      this.m_dataForNew = new _MMDirectionArrowData["default"](this.m_board, this.m_init);
      break;
    case _ObjType["default"].GObj_scribble:
      this.m_dataForNew = new _MMScribbleData["default"](this.m_board, this.m_init);
      break;
    case _ObjType["default"].GObj_circlemark:
      this.m_dataForNew = new _MMCircleMarkData["default"](this.m_board, this.m_init);
      break;
    case _ObjType["default"].GObj_cloud:
      this.m_dataForNew = new _MMCloudData["default"](this.m_board, this.m_init);
      break;
    case _ObjType["default"].GObj_note:
      this.m_dataForNew = new _MMNoteData["default"](this.m_board, this.m_init);
      break;
    case _ObjType["default"].GObj_rectMark:
      this.m_dataForNew = new _MMRectMarkData["default"](this.m_board, this.m_init);
      break;
    case _ObjType["default"].GObj_text:
      this.m_dataForNew = new _MMTextData["default"](this.m_board, this.m_init);
      break;
    case _ObjType["default"].GObj_emoji:
      this.m_dataForNew = new _MMEmojiTextData["default"](this.m_board, this.m_init);
      break;
    case _ObjType["default"].Obj_Image:
      this.m_dataForNew = new _MMImageData["default"](this.m_board, this.m_init);
      break;
    case _ObjType["default"].Obj_PDF:
      this.m_dataForNew = new _MMPDFDocumentData["default"](this.m_board, this.m_init);
      break;
    case _ObjType["default"].Obj_Recorder:
      this.m_dataForNew = new _MMRecorderData["default"](this.m_board, this.m_init);
      break;
    case _ObjType["default"].GObj_nitePen:
      this.m_dataForNew = new _MMNitePenData["default"](this.m_board, this.m_init);
      break;
    case _ObjType["default"].Obj_Document:
      this.m_dataForNew = new _MMDocumentData["default"](this.m_board, this.m_init);
      break;
    case _ObjType["default"].Obj_comment:
      this.m_dataForNew = new _MMCommentObjData["default"](this.m_board, this.m_init);
      break;
    case _ObjType["default"].Obj_niceTag:
      this.m_dataForNew = new _MMNiceTagData["default"](this.m_board, this.m_init);
      break;
    case _ObjType["default"].Obj_textComment:
      this.m_dataForNew = new _MMTextCommentData["default"](this.m_board, this.m_init);
      break;
    case _ObjType["default"].Obj_weldMark:
      this.m_dataForNew = new _MMObjectData["default"](this.m_board, this.m_init);
      this.m_dataForNew.setObjType(_ObjType["default"].Obj_weldMark);
      this.m_dataForNew.isPtOn = _.noop;
      break;
    case _ObjType["default"].Obj_signatureFrame:
      this.m_dataForNew = new _MMSignatureFrameData["default"](this.m_board, this.m_init);
      break;
    case _ObjType["default"].Obj_seal:
      this.m_dataForNew = new _MMSealObjData["default"](this.m_board, this.m_init);
      break;
    // case ObjType.Obj_seal:
    //   this.m_dataForNew = new MMSignatureFrameData(this.m_board, this.m_init);
    //   break;

    default:
      break;
  }
  if (this.m_dataForNew) {
    this.m_dataForNew.setObject(this);
  }
};
MMObject.prototype.canDrawInDiv = function () {
  var can = false;
  switch (this.m_objType) {
    case _ObjType["default"].GObj_indicateline:
      break;
    case _ObjType["default"].GObj_brokenline:
      break;
    case _ObjType["default"].GObj_rect:
      break;
    case _ObjType["default"].GObj_roundrect:
      break;
    case _ObjType["default"].GObj_triangle:
      break;
    case _ObjType["default"].GObj_hexagon:
      break;
    case _ObjType["default"].GObj_circle:
      break;
    case _ObjType["default"].GObj_line:
      break;
    case _ObjType["default"].GObj_diamond:
      break;
    case _ObjType["default"].GObj_doc:
      break;
    case _ObjType["default"].GObj_halfroundrect:
      break;
    case _ObjType["default"].GObj_pentagon:
      break;
    case _ObjType["default"].GObj_fivestar:
      break;
    case _ObjType["default"].GObj_directionarrow:
      break;
    case _ObjType["default"].GObj_scribble:
      break;
    case _ObjType["default"].GObj_circlemark:
      break;
    case _ObjType["default"].GObj_cloud:
      break;
    case _ObjType["default"].GObj_note:
      break;
    case _ObjType["default"].GObj_rectMark:
      break;
    case _ObjType["default"].GObj_text:
      can = true;
      break;
    case _ObjType["default"].GObj_emoji:
      break;
    case _ObjType["default"].Obj_Image:
      can = true;
      break;
    case _ObjType["default"].Obj_PDF:
      can = true;
      break;
    case _ObjType["default"].Obj_comment:
      can = true;
      break;
    case _ObjType["default"].Obj_graphComment:
      can = true;
      break;
    case _ObjType["default"].Obj_niceTag:
      can = true;
      break;
    case _ObjType["default"].Obj_Recorder:
      break;
    case _ObjType["default"].GObj_nitePen:
      break;
    case _ObjType["default"].Obj_Document:
      break;
    default:
      break;
  }
  return can;
};
MMObject.prototype.setArrPoints = function (pts) {
  var data = this.getObjData();
  data.m_arrPoints = pts;
};
MMObject.prototype.getArrPoints = function () {
  var data = this.getObjData();
  return data.m_arrPoints;
};
MMObject.prototype.setAngle = function (angle) {
  var data = this.getObjData();
  data.m_angle = angle;
  this.angle = angle;
};

//MMObject.prototype.getAngle = function () {
//  var data = this.getObjData();
//  this.angle = data.m_angle;
//  return this.angle;
//} ;
//
//MMObject.prototype.getDrawAngle = function () {
//  var data = this.getObjData();
//  return data.getDrawAngle();
//} ;

MMObject.prototype.calcuExpandRect = function () {
  var pts = this.getArrPoints();
  if (pts == undefined || pts == null) {
    return;
  }
  var rct = new _MMRect["default"](Number.POSITIVE_INFINITY, Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY, Number.POSITIVE_INFINITY);
  for (var i = 0; i < pts.length; i++) {
    if (pts[i].x < rct.left) rct.left = pts[i].x;
    if (pts[i].x > rct.right) rct.right = pts[i].x;
    if (pts[i].y < rct.top) rct.top = pts[i].y;
    if (pts[i].y > rct.bottom) rct.bottom = pts[i].y;
  }
  //解决deleteAction的bug，lishusheng，2014-06-24
  if (this.m_expandRect == null) {
    this.m_expandRect = rct;
  }
  return rct.clone();
};
MMObject.prototype.clearDispDiv = function (parentDiv) {
  if (this.dispCtl != null) {
    if (parentDiv == undefined) {
      this.dispCtl.release();
      this.dispCtl = null;
    } else {
      this.dispCtl.removeDiv(parentDiv);
      if (this.dispCtl.empty()) {
        this.dispCtl = null;
      }
    }
  }
};
MMObject.prototype.draw = function (ctx, trsfm, pgindex) {
  return 0;
};
MMObject.prototype.isComment = function () {
  return false;
};
MMObject.prototype.drawInCanvas = function (ctx, trsfm, pgindex) {
  return 0;
};
MMObject.prototype.drawInDiv = function ($div, trsfm, pgindex) {};
MMObject.prototype.drawObjInRct = function (ctx, trsfm, pgindex, rect) {};

/**
 * 删除掉对象对应的显示对象 - HTMLElement
 */
MMObject.prototype.releaseElement = function () {
  if (this.dispCtl != null) {
    this.dispCtl.release();
  }
  this.dispCtl = null;
};
MMObject.prototype.placeElement = function ($element, trsfm) {
  var lgrct = new _MMCenterRect["default"]();
  lgrct.setRect(this.m_rect);
  lgrct.setAngle(this.angle);
  var dvrct = trsfm.lg2dvCenterRect(lgrct, 0);
  $element.css({
    "left": Math.round(dvrct.getLeftTop().x) + 'px',
    "top": Math.round(dvrct.getLeftTop().y) + 'px',
    "width": Math.round(dvrct.width) + 'px',
    "height": Math.round(dvrct.height) + 'px',
    "box-sizing": "border-box"
  });
  $element.css('transform', 'rotate(' + dvrct.angle + 'deg)');
};
MMObject.prototype.changeEditable = function (trsfm) {};
MMObject.prototype.saveToDataManager = function () {
  console.assert(this.m_dataForNew != null);
  console.assert(!this.m_id.isBlank());
  if (this.m_dataForNew == null || this.m_id.isBlank()) {
    return;
  }
  this.m_dataMgr.addObjData(this.m_id, this.m_dataForNew);
  this.m_dataForNew = null;
  this.m_includeData = false;
};
MMObject.prototype.getIdentity = function (identity_) {
  return this.m_identity;
};
MMObject.prototype.setIdentity = function (identity_) {
  this.m_identity = identity_;
};

//move操作
MMObject.prototype.move = function (offset_, moveAll_) {
  var _moveAll = arguments[1] ? arguments[1] : true;
  var objData = this.getObjData();
  objData.move(offset_, moveAll_);
  if (objData.getRect) this.m_rect = objData.getRect();
  if (objData.getExpandRect) this.m_expandRect = objData.getExpandRect();
  if (_moveAll) {}
};
//transform操作
MMObject.prototype.transform = function (option, basePt_,
// 参考点 MMLgPoint
scale_,
// 拉伸比例 MMLgPoint
angleInfect_,
// 缩放时是否受原有角度影响？在多个对象同时被选中拉伸时，此参数置为 false
alpha_,
// 相对旋转角度(0, 360) float
offset_ // 相对位移 MMLgPoint
) {
  var objData = this.getObjData();
  var scale = objData.transform(option, basePt_, scale_, angleInfect_, alpha_, offset_);
  this.m_rect = objData.getRect();
  this.m_expandRect = objData.getExpandRect();
  if (!this.m_id.isBlank()) {
    this.m_dataMgr.markDataModified(this.m_id);
  }
  return scale;
};
MMObject.prototype.setYellowPtsAndIsClose = function (yellowPts_, isClose_) {
  var objData = this.getObjData();
  objData.setYellowPtsAndIsClose(yellowPts_, isClose_);
};
MMObject.prototype.setLogicPts = function (logicPts) {
  var objData = this.getObjData();
  objData.setLogicPts(logicPts);
  this.m_rect = objData.getRect().clone();
  this.m_expandRect = objData.getExpandRect().clone();
};
MMObject.prototype.calInitShapePts = function (lgPts) {
  var objData = this.getObjData();
  objData.calInitShapePts(lgPts);
};
MMObject.prototype.changeAngleByDirection = function () {
  var objData = this.getObjData();
  objData.changeAngleByDirection();
};

/**
 * 返回包含指定匹配的部分字符串
 * @param reg_
 * @returns {String}
 */
MMObject.prototype.includeStr = function (reg_) {
  var _matches = this.match(reg_);
  var subStr = "";
  var len = 16;
  if (_matches != undefined && _matches.length > 0) {
    var m = _matches[0];
    subStr = _matches.input;
    if (subStr.length - _matches.index > len) {
      subStr = subStr.substr(_matches.index, len);
    } else if (subStr.length > len) {
      subStr = subStr.substr(_matches.length - len, len);
    }
  }
  return subStr;
};
MMObject.prototype.match = function (reg_) {
  return null;
};
MMObject.prototype.removeFromDataManager = function () {
  this.m_dataMgr.delObjData(this.m_id);
  this.m_dataForNew = null;
};
MMObject.prototype.isPtOn = function (pt, error) {
  if (error == undefined) {
    error = 0.01;
  }
  return this.getObjData().isPtOn(pt, error);
};
MMObject.prototype.setPageIndex = function (pgIndex_) {
  this.getObjData().setPageIndex(pgIndex_);
};
MMObject.prototype.getPageIndex = function () {
  var pgIndex = -1;
  var data = this.getObjData();
  if (data) {
    pgIndex = data.getPageIndex();
  }
  return pgIndex;
};
MMObject.prototype.isCommited = function () {
  var data = this.getObjData();
  if (data) {
    return data.isCommited();
  }
  return false;
};
MMObject.prototype.setCommited = function (flag_) {
  var data = this.getObjData();
  if (data) {
    return data.setCommited(flag_);
  }
};
MMObject.prototype.setFileVersion = function (ver_) {
  this.fileVersion = ver_;
};
MMObject.prototype.getFileVersion = function () {
  return this.fileVersion;
};
MMObject.prototype.setTestMode = function (testing) {
  this.inTesting = testing;
};
MMObject.prototype.setVisibleScope = function (scopeType) {
  if (scopeType == undefined || scopeType == null) {
    scopeType = 0;
  }
  ;
  this.visibleScope = scopeType;
};
MMObject.prototype.getVisibleScope = function () {
  if (this.visibleScope == _ObjVisibleScope["default"].protectedObject || this.visibleScope == _ObjVisibleScope["default"].privateObject || this.visibleScope >= _ObjVisibleScope["default"].evaluation) {
    return this.visibleScope;
  }
  ;
  return _ObjVisibleScope["default"].publicObject;
};
MMObject.prototype.getScopeDispStr = function () {
  return MMObject.scopeDispStrings[this.getVisibleScope()];
};
MMObject.prototype.duplicateFrom = function (sourceObj) {
  var enc = new _Encoder["default"]();
  this.encode(enc);
  var dec = new _Decoder["default"](this.m_board);
  dec.setStream(enc.getStream());
  this.decode(dec, ___MM_DOC_VERSION__);
};

// 设置此属性后，对象在绘制时不再显示线宽，线宽永远为 1 px
MMObject.prototype.isSkeleton = function (skeleton) {
  var data = this.getObjData();
  if (data) {
    return data.isSkeleton(skeleton);
  }
};
MMObject.prototype.setRotateAngle90 = function (angle) {
  this.rotateAngle90 = angle;
};
MMObject.prototype.getRatateAgnle90 = function () {
  return this.rotateAngle90;
};
MMObject.getScopeDispStrings = function () {
  var strings = [];
  for (var i = 0; i < 3; i++) {
    strings.push(MMObject.scopeDispStrings[i]);
  }
  return strings;
};
MMObject.prototype.setAngle = function (angle) {
  this.angle = angle;
};
MMObject.prototype.getAngle = function () {
  return this.angle;
};
var _default = exports["default"] = MMObject;

},{"1039":1039,"1040":1040,"1041":1041,"1042":1042,"1044":1044,"1045":1045,"1046":1046,"1047":1047,"1048":1048,"1049":1049,"1050":1050,"1053":1053,"1054":1054,"1055":1055,"1056":1056,"1057":1057,"1058":1058,"1059":1059,"1060":1060,"1061":1061,"1063":1063,"1064":1064,"1065":1065,"1066":1066,"1067":1067,"1068":1068,"1069":1069,"1070":1070,"1071":1071,"1072":1072,"1073":1073,"1080":1080,"1082":1082,"1084":1084,"1085":1085,"1184":1184,"1446":1446,"1454":1454,"1477":1477,"1489":1489,"799":799,"800":800,"829":829,"831":831,"951":951}],1073:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ObjType = _interopRequireDefault(require(1084));
var _MMGraphicsData = _interopRequireDefault(require(1052));
var _MMPoint = _interopRequireDefault(require(830));
function MMTriangleData(board, init) {
  _MMGraphicsData["default"].call(this, board, init);
  this.m_className = 'MMTriangleData';
  this.m_objType = _ObjType["default"].GObj_triangle;
}
;
MMTriangleData.prototype = new _MMGraphicsData["default"]();
MMTriangleData.superclass = _MMGraphicsData["default"].prototype;
MMTriangleData.prototype.encode = function (enc_) {
  MMTriangleData.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMTriangleData.prototype.decode = function (dec_, ver_) {
  MMTriangleData.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
MMTriangleData.prototype.calInitShapePts = function (lgPts) {
  var _shapePts = new Array();
  if (this.m_orientation.isLandscape()) {
    _shapePts.push(this.m_arrYellowPoints[0].clone());
    _shapePts.push(new _MMPoint["default"](lgPts[1].x, lgPts[0].y));
    _shapePts.push(lgPts[1].clone());
  } else {
    _shapePts.push(this.m_arrYellowPoints[0].clone());
    _shapePts.push(new _MMPoint["default"](lgPts[0].x, lgPts[1].y));
    _shapePts.push(lgPts[1].clone());
  }
  return _shapePts;
};
MMTriangleData.prototype.setYellowPtsAndIsClose = function (yellowPts_, isClose_) {
  var _lgPts = new Array();
  var arc = this.m_angle * Math.PI / 180;
  var leftBottom = this.m_arrCtrlPts[0].clone();
  var rightTop = null;
  var leftTop = null;
  var rightBottom = null;
  if (this.m_arrCtrlPts.length == 4) {
    rightTop = this.m_arrCtrlPts[2].clone();
    leftTop = this.m_arrCtrlPts[3].clone();
    rightBottom = this.m_arrCtrlPts[1].clone();
  } else if (this.m_arrCtrlPts.length == 8) {
    rightTop = this.m_arrCtrlPts[4].clone();
    leftTop = this.m_arrCtrlPts[6].clone();
    rightBottom = this.m_arrCtrlPts[2].clone();
  }
  var center = new _MMPoint["default"]((leftBottom.x + rightTop.x) / 2, (leftBottom.y + rightTop.y) / 2);
  if (Math.abs(this.m_angle) > 0.00001) {
    this.roatate(center, -arc);
    MMCommonFun.rotateAroundPts(yellowPts_, center, -arc);
    leftBottom = this.m_arrCtrlPts[0].clone();
    if (Math.abs(this.m_arrCtrlPts.length - 4) < 0.00001) {
      rightTop = this.m_arrCtrlPts[2].clone();
      leftTop = this.m_arrCtrlPts[3].clone();
      rightBottom = this.m_arrCtrlPts[1].clone();
    } else if (Math.abs(this.m_arrCtrlPts.length - 8) < 0.00001) {
      rightTop = this.m_arrCtrlPts[4].clone();
      leftTop = this.m_arrCtrlPts[6].clone();
      rightBottom = this.m_arrCtrlPts[2].clone();
    } else {
      //      assert(false);
      return;
    }
  }
  var _signedx = 1;
  var _signedy = 1;
  if (this.m_orientation.isLandscape()) {
    _lgPts.push(rightBottom.clone());
    _lgPts.push(leftTop.clone());
    if (_lgPts[0].y > _lgPts[1].y) _signedy = -1;
    yellowPts_[0].x = _lgPts[0].x;
    if ((yellowPts_[0].y - _lgPts[0].y) * _signedy < 0) {
      yellowPts_[0].y = _lgPts[0].y;
    } else if ((yellowPts_[0].y - _lgPts[1].y) * _signedy > 0) {
      yellowPts_[0].y = _lgPts[1].y;
    }
  } else {
    _lgPts.push(leftBottom.clone());
    _lgPts.push(rightTop.clone());
    if (_lgPts[0].x > _lgPts[1].x) _signedx = -1;
    if ((yellowPts_[0].x - _lgPts[0].x) * _signedx < 0) {
      yellowPts_[0].x = _lgPts[0].x;
    } else if ((yellowPts_[0].x - _lgPts[1].x) * _signedx > 0) {
      yellowPts_[0].x = _lgPts[1].x;
    }
    yellowPts_[0].y = _lgPts[0].y;
  }
  this.m_arrYellowPoints = new Array();
  this.m_arrYellowPoints = yellowPts_;
  var _newLgPts = this.calInitShapePts(_lgPts);
  this.setLogicPts(_newLgPts);
  if (Math.abs(this.m_angle) > 0.00001) {
    this.roatate(center, arc);
    MMCommonFun.rotateAroundPts(yellowPts_, center, arc);
  }
  this.m_isClose = isClose_;
};
var _default = exports["default"] = MMTriangleData;

},{"1052":1052,"1084":1084,"1184":1184,"1454":1454,"830":830}],1071:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMObjectData = _interopRequireDefault(require(1082));
var _MMCommentBasicData = _interopRequireDefault(require(1043));
var _ObjType = _interopRequireDefault(require(1084));
var _MMColor = _interopRequireDefault(require(794));
var _MMRect = _interopRequireDefault(require(831));
/**
 *
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMCircleData}
 */

function MMTextCommentData(board, init) {
  _MMObjectData["default"].call(this, board, init);
  this.commentBasicData = new _MMCommentBasicData["default"]();
  this.m_objType = _ObjType["default"].Obj_textComment;
  this.m_rects = new Array();
  var _color = new _MMColor["default"]();
  _color.m_r = 1.0;
  _color.m_g = 1.0;
  _color.m_b = 0.0;
  _color.m_alpha = 0.5;
  this.m_fillType.setFillColor(_color);
  this.m_fillType.setFill(true);
  this.m_strokeType.setHasBorder(false);
}
;
MMTextCommentData.prototype = new _MMObjectData["default"]();
MMTextCommentData.superclass = _MMObjectData["default"].prototype;
MMTextCommentData.prototype.encode = function (enc_) {
  MMTextCommentData.superclass.encode.call(this, enc_);
  this.commentBasicData.encode(enc_);
  enc_.encodeArray(this.m_rects, 'MMRect');
};
MMTextCommentData.prototype.decode = function (dec_, ver_) {
  MMTextCommentData.superclass.decode.call(this, dec_, ver_);
  this.commentBasicData.decode(dec_, ver_);
  this.m_rects = dec_.decodeFromArray(ver_, 'MMRect');
};

/**
 */
MMTextCommentData.prototype.isPtOn = function (pt, error) {
  var _ret = false;
  for (var i = this.m_rects.length - 1; i >= 0; i--) {
    if (this.m_rects[i].include(pt)) {
      _ret = true;
      break;
    }
  }
  ;
  return _ret;
};
MMTextCommentData.prototype.getReadStatus = function (userId) {
  var creator = this.getCreator();
  var status = this.commentBasicData.getReadStatus(userId, creator);
  return status;
};
MMTextCommentData.prototype.setReadStatus = function (userId, status_) {
  this.commentBasicData.setReadStatus(userId, status_);
};
MMTextCommentData.prototype.setRects = function (rects) {
  this.m_rects = rects;
};
MMTextCommentData.prototype.setRead = function (usrId) {
  this.commentBasicData.setRead(usrId);
};
MMTextCommentData.prototype.setHasNewReplyFromUser = function (replier) {
  this.commentBasicData.setHasNewReplyFromUser(replier);
};
MMTextCommentData.prototype.praise = function (userId_) {
  this.commentBasicData.praise(userId_);
};
MMTextCommentData.prototype.unPraise = function (userId_) {
  this.commentBasicData.unPraise(userId_);
};
MMTextCommentData.prototype.isPraised = function (userId_) {
  return this.commentBasicData.isPraised(userId_);
};
MMTextCommentData.prototype.setFinished = function (finished_) {
  this.commentBasicData.setFinished(finished_);
};
MMTextCommentData.prototype.isFinished = function () {
  return this.commentBasicData.isFinished();
};
var _default = exports["default"] = MMTextCommentData;

},{"1043":1043,"1082":1082,"1084":1084,"1184":1184,"1454":1454,"794":794,"831":831}],1070:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1446);
var _MMRectangleData = _interopRequireDefault(require(1065));
var _MMPoint = _interopRequireDefault(require(830));
var _ObjType = _interopRequireDefault(require(1084));
var _MMCommonFun = _interopRequireDefault(require(812));
function MMSignatureFrameData(board, init) {
  _MMRectangleData["default"].call(this, board, init);
  this.m_className = 'MMSignatureFrameData';
  this.m_objType = _ObjType["default"].Obj_signatureFrame;
}
;
MMSignatureFrameData.prototype = new _MMRectangleData["default"]();
MMSignatureFrameData.superclass = _MMRectangleData["default"].prototype;
MMSignatureFrameData.prototype.encode = function (enc_) {
  MMSignatureFrameData.superclass.encode.call(this, enc_);
};
MMSignatureFrameData.prototype.decode = function (dec_, ver_) {
  MMSignatureFrameData.superclass.decode.call(this, dec_, ver_);
};
MMSignatureFrameData.prototype.isPtOn = function (pt, error) {
  var size = this.m_arrPoints.length;
  var minX = Number.MAX_VALUE,
    minY = Number.MAX_VALUE;
  var maxX = Number.MIN_VALUE,
    maxY = Number.MIN_VALUE;
  for (var i = 0; i < size; i++) {
    var p = this.m_arrPoints[i];
    if (p.x < minX) {
      minX = p.x;
    }
    if (p.y < minY) {
      minY = p.y;
    }
    if (p.x > maxX) {
      maxX = p.x;
    }
    if (p.y > maxY) {
      maxY = p.y;
    }
  }
  if (pt.x >= minX && pt.x <= maxX && pt.y >= minY && pt.y <= maxY) {
    return true;
  }
  return false;
};
var _default = exports["default"] = MMSignatureFrameData;

},{"1065":1065,"1084":1084,"1184":1184,"1446":1446,"1454":1454,"812":812,"830":830}],1068:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ObjType = _interopRequireDefault(require(1084));
var _MMBlockObjData = _interopRequireDefault(require(1038));
/**
 *
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMCircleData}
 */
function MMSealObjData(board, init) {
  _MMBlockObjData["default"].call(this, board, init); //
  this.m_objType = _ObjType["default"].Obj_seal;
}
;
MMSealObjData.prototype = new _MMBlockObjData["default"](); //
MMSealObjData.superclass = _MMBlockObjData["default"].prototype;
MMSealObjData.prototype.encode = function (enc_) {
  MMSealObjData.superclass.encode.call(this, enc_);

  // var objVer = 0;
  // enc_.encode4Bytes(objVer);
  // enc_.encodeMMPoint(this.m_pos);
};
MMSealObjData.prototype.decode = function (dec_, ver_) {
  MMSealObjData.superclass.decode.call(this, dec_, ver_);
  console.log("MMSealObjData.prototype.decode");
  // var _objVer = dec_.decodeFrom4Bytes(ver_);

  // this.m_pos = dec_.decodeFromMMPoint(ver_);

  // var lgRect = new MMRect(this.m_pos.y - POINT_SIZE, this.m_pos.x + POINT_SIZE, this.m_pos.y + POINT_SIZE, this.m_pos.x - POINT_SIZE);
  // var lgRect;
  // this.m_rect = lgRect;
  // this.m_expandRect = lgRect;

  // console.count("decode label")
};
MMSealObjData.prototype.isPtOn = function (pt, error) {
  // console.log("MMSealObjData.prototype.isPtOn")
  return false;
};
MMSealObjData.prototype.setDevPts = function (trsfm_, devPts_, pageIndex_) {
  MMSealObjData.superclass.setDevPts.call(this, trsfm_, devPts_, pageIndex_);
  if (devPts_.length < 2) {
    return;
  }
  var _lgPts = trsfm_.dv2lgPoints(devPts_, pageIndex_);
  this.m_expandRect = this.m_rect = MMCommonFun.getRect(_lgPts);
  // console.log("MMRectangleData m_rect改变了", this.m_rect)
};
var _default = exports["default"] = MMSealObjData;

},{"1038":1038,"1084":1084,"1184":1184,"1454":1454}],1067:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMBezierObjData = _interopRequireDefault(require(1037));
var _ObjType = _interopRequireDefault(require(1084));
var _MMCommonFun = _interopRequireDefault(require(812));
function MMScribbleData() {
  _MMBezierObjData["default"].call(this);
  this.m_className = 'MMScribbleData';
  this.m_objType = _ObjType["default"].GObj_scribble;
  this.m_isClose = false;
}
;
MMScribbleData.prototype = new _MMBezierObjData["default"]();
MMScribbleData.superclass = _MMBezierObjData["default"].prototype;
MMScribbleData.prototype.initBy = function (obj) {
  MMScribbleData.superclass.initBy.call(this, obj); //IOS遗留的问题
  this.m_isClose = obj.m_isClose;
};
MMScribbleData.prototype.encode = function (enc_) {
  MMScribbleData.superclass.encode.call(this, enc_); //IOS遗留的问题
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMScribbleData.prototype.decode = function (dec_, ver_) {
  MMScribbleData.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
MMScribbleData.prototype.isPtOn = function (pt, error) {
  //将曲线打断成折线断，然后判断图形是否在多边形内。
  var _brokenLinePoint = _MMCommonFun["default"].getBrokenLineCubicBezierPts(this.m_arrPoints, false);
  var size = _brokenLinePoint.length;
  for (var i = 0; i < size - 1; i++) {
    if (_MMCommonFun["default"].isOnSegment(_brokenLinePoint[i], _brokenLinePoint[i + 1], pt, 5 * error)) {
      return true;
    }
  }
  return false;
};
MMScribbleData.prototype.setDevPts = function (trfmer_, devPts_, pageIndex_) {
  MMScribbleData.superclass.setDevPts.call(this, trfmer_, devPts_, pageIndex_);
  var _devPts = this.calInitShapePts(devPts_);
  var _lgPts = trfmer_.dv2lgPoints(_devPts, pageIndex_);
  this.m_expandRect = this.m_rect = _MMCommonFun["default"].getRect(_lgPts);
  // var _error = trfmer_.dv2lgLen(4);
  //this.m_expandRect.expand(_error + m_strokeType.getLineWidth());

  this.setLogicPts(_lgPts);
  this.setPageIndex(pageIndex_);
};
var _default = exports["default"] = MMScribbleData;

},{"1037":1037,"1084":1084,"1184":1184,"1454":1454,"812":812}],1065:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMGraphicsData = _interopRequireDefault(require(1052));
var _MMPoint = _interopRequireDefault(require(830));
var _ObjType = _interopRequireDefault(require(1084));
var _MMCommonFun = _interopRequireDefault(require(812));
function MMRectangleData(board, init) {
  _MMGraphicsData["default"].call(this, board, init);
  this.m_className = 'MMRectangleData';
  this.m_objType = _ObjType["default"].GObj_rect;
  this.m_rect = {};
}
;
MMRectangleData.prototype = new _MMGraphicsData["default"]();
MMRectangleData.superclass = _MMGraphicsData["default"].prototype;
MMRectangleData.prototype.encode = function (enc_) {
  MMRectangleData.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMRectangleData.prototype.decode = function (dec_, ver_) {
  MMRectangleData.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
MMRectangleData.prototype.calInitShapePts = function (lgPts) {
  var _shapePts = new Array();
  if (lgPts.length < 2) {
    return _shapePts;
  }
  _shapePts.push(lgPts[0].clone());
  _shapePts.push(new _MMPoint["default"](lgPts[1].x, lgPts[0].y));
  _shapePts.push(lgPts[1].clone());
  _shapePts.push(new _MMPoint["default"](lgPts[0].x, lgPts[1].y));
  return _shapePts;
};
MMRectangleData.prototype.reCalInitShapePts = function (yellowPts, lgPts, yellowIndex) {
  var _newlgPts = new Array();
  var _signedx = 1;
  var _signedy = 1;
  if (this.m_orientation.isLandscape()) {
    if (lgPts[0].y > lgPts[1].y) _signedy = -1;
    if (Math.abs(yellowIndex) < 0.00001) {
      if ((this.m_arrYellowPoints[1].y - lgPts[1].y) * _signedy > 0.00001) {
        this.m_arrYellowPoints[1].y = lgPts[1].y;
      } else if ((this.m_arrYellowPoints[1].y - (lgPts[0].y + lgPts[1].y) / 2) * _signedy < 0.00001) {
        this.m_arrYellowPoints[1].y = lgPts[0].y;
      }
      this.m_arrYellowPoints[1].x = lgPts[0].x;
      _newlgPts.push(new _MMPoint["default"](lgPts[0].x, lgPts[0].y + lgPts[1].y - this.m_arrYellowPoints[1].y));
      _newlgPts.push(new _MMPoint["default"](lgPts[1].x, lgPts[0].y));
      _newlgPts.push(lgPts[1]);
      _newlgPts.push(this.m_arrYellowPoints[1]);
    } else if (Math.abs(yellowIndex - 1) < 0.00001) {
      if ((this.m_arrYellowPoints[1].y - lgPts[1].y) * _signedy > 0.00001) {
        this.m_arrYellowPoints[1].y = lgPts[1].y;
      } else if ((this.m_arrYellowPoints[1].y - lgPts[0].y) * _signedy < 0.00001) {
        this.m_arrYellowPoints[1].y = lgPts[0].y;
      }
      this.m_arrYellowPoints[1].x = lgPts[0].x;
      _newlgPts.push(this.m_arrYellowPoints[0].clone());
      _newlgPts.push(new _MMPoint["default"](lgPts[0].x, lgPts[1].y));
      _newlgPts.push(new _MMPoint["default"](lgPts[1].x, lgPts[0].y + lgPts[1].y - this.m_arrYellowPoints[0].y));
      _newlgPts.push(new _MMPoint["default"](lgPts[1].x, lgPts[0].y));
    }
  } else {
    if (lgPts[0].x > lgPts[1].x) _signedx = -1;
    if (Math.abs(yellowIndex) < 0.00001) {
      if ((this.m_arrYellowPoints[1].x - lgPts[1].x) * _signedx > 0.00001) {
        this.m_arrYellowPoints[1].x = lgPts[1].x;
      } else if ((this.m_arrYellowPoints[1].x - (lgPts[0].x + lgPts[1].x) / 2) * _signedx < 0.00001) {
        this.m_arrYellowPoints[1].x = (lgPts[0].x + lgPts[1].x) / 2;
      }
      this.m_arrYellowPoints[1].y = lgPts[0].y;
      _newlgPts.push(new _MMPoint["default"](lgPts[0].x + lgPts[1].x - this.m_arrYellowPoints[1].x, lgPts[0].y));
      _newlgPts.push(new _MMPoint["default"](lgPts[0].x, lgPts[1].y));
      _newlgPts.push(lgPts[1].clone());
      _newlgPts.push(this.m_arrYellowPoints[1]);
    } else if (Math.abs(yellowIndex - 1) < 0.00001) {
      if ((this.m_arrYellowPoints[0].x - lgPts[1].x) * _signedx > 0.00001) {
        this.m_arrYellowPoints[0].x = lgPts[1].x;
      } else if ((this.m_arrYellowPoints[0].x - lgPts[0].x) * _signedx < 0.00001) {
        this.m_arrYellowPoints[0].x = lgPts[0].x;
      }
      this.m_arrYellowPoints[0].y = lgPts[0].y;
      _newlgPts.push(this.m_arrYellowPoints[0].clone());
      _newlgPts.push(new _MMPoint["default"](lgPts[0].x, lgPts[1].y));
      _newlgPts.push(new _MMPoint["default"](lgPts[0].x + lgPts[1].x - this.m_arrYellowPoints[0].x, lgPts[1].y));
      _newlgPts.push(new _MMPoint["default"](lgPts[1].x, lgPts[0].y));
    }
  }
  return _newlgPts;
};
MMRectangleData.prototype.setYellowPtsAndIsClose = function (yellowPts_, isClose_) {
  var arc = this.m_angle * Math.PI / 180;
  var leftBottom = this.m_arrCtrlPts[0].clone();
  var rightTop = null;
  var leftTop = null;
  var rightBottom = null;
  if (this.m_arrCtrlPts.length == 4) {
    rightTop = this.m_arrCtrlPts[2].clone();
    leftTop = this.m_arrCtrlPts[3].clone();
    rightBottom = this.m_arrCtrlPts[1].clone();
  } else if (this.m_arrCtrlPts.length == 8) {
    rightTop = this.m_arrCtrlPts[4].clone();
    leftTop = this.m_arrCtrlPts[6].clone();
    rightBottom = this.m_arrCtrlPts[2].clone();
  }
  var center = new _MMPoint["default"]((leftBottom.x + rightTop.x) / 2, (leftBottom.y + rightTop.y) / 2);
  if (Math.abs(this.m_angle) > 0.00001) {
    this.roatate(center, -arc);
    _MMCommonFun["default"].rotateAroundPts(yellowPts_, center, -arc);
    leftBottom = this.m_arrCtrlPts[0].clone();
    if (Math.abs(this.m_arrCtrlPts.length - 4) < 0.00001) {
      rightTop = this.m_arrCtrlPts[2].clone();
      leftTop = this.m_arrCtrlPts[3].clone();
      rightBottom = this.m_arrCtrlPts[1].clone();
    } else if (Math.abs(this.m_arrCtrlPts.length - 8) < 0.00001) {
      rightTop = this.m_arrCtrlPts[4].clone();
      leftTop = this.m_arrCtrlPts[6].clone();
      rightBottom = this.m_arrCtrlPts[2].clone();
    } else {
      //      assert(false);
      return;
    }
  }
  this.m_arrYellowPoints = new Array();
  if (yellowPts_.length < 2) {
    return;
  }
  this.m_arrYellowPoints = yellowPts_;
  var _lbPt, _rbPt;
  var _lgPts = new Array();
  var _newlgPts;
  if (this.m_orientation.isLandscape()) {
    _lgPts.push(rightBottom.clone());
    _lgPts.push(leftTop.clone());
    _lbPt = rightBottom.clone();
    _rbPt = rightTop.clone();
  } else {
    _lgPts.push(leftBottom);
    _lgPts.push(rightTop);
    _lbPt = leftBottom.clone();
    _rbPt = rightBottom.clone();
  }
  if (_lbPt.equals(yellowPts_[0])) {
    _newlgPts = this.reCalInitShapePts(yellowPts_, _lgPts, 0);
  } else if (_rbPt.equals(yellowPts_[1])) {
    _newlgPts = this.reCalInitShapePts(yellowPts_, _lgPts, 1);
  } else {
    if (_MMPoint["default"].distance(_lbPt, yellowPts_[0]) <= _MMPoint["default"].distance(_rbPt.yellowPts_[1])) {
      _newlgPts = this.reCalInitShapePts(yellowPts_, _lgPts, 0);
    } else {
      _newlgPts = this.reCalInitShapePts(yellowPts_, _lgPts, 1);
    }
  }
  this.setLogicPts(_newlgPts);
  if (Math.abs(this.m_angle) > 0.00001) {
    this.roatate(center, arc);
    _MMCommonFun["default"].rotateAroundPts(yellowPts_, center, arc);
  }
  this.m_isClose = isClose_;
};
MMRectangleData.prototype.setDevPts = function (trsfm_, devPts_, pageIndex_) {
  MMRectangleData.superclass.setDevPts.call(this, trsfm_, devPts_, pageIndex_);
  if (devPts_.length < 2) {
    return;
  }
  var _lgPts = trsfm_.dv2lgPoints(devPts_, pageIndex_);
  this.m_expandRect = this.m_rect = _MMCommonFun["default"].getRect(_lgPts);
  // console.log("MMRectangleData m_rect改变了", this.m_rect)
  var _error = trsfm_.dv2lgLen(4);
  //    m_expandRect.expand(_error + m_strokeType.getLineWidth());
  //设定初始黄点
  this.m_arrYellowPoints = [];
  this.m_arrYellowPoints.push(_lgPts[0]);
  if (this.m_orientation.isLandscape()) {
    this.m_arrYellowPoints.push(new _MMPoint["default"](_lgPts[0].x, _lgPts[1].y));
  } else {
    this.m_arrYellowPoints.push(new _MMPoint["default"](_lgPts[1].x, _lgPts[0].y));
  }
  var _shapePts = this.calInitShapePts(_lgPts);
  this.setLogicPts(_shapePts);
};
var _default = exports["default"] = MMRectangleData;

},{"1052":1052,"1084":1084,"1184":1184,"1454":1454,"812":812,"830":830}],1064:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1432);
var _MMYellowObjData = _interopRequireDefault(require(1074));
var _ObjType = _interopRequireDefault(require(1084));
var _MMRect = _interopRequireDefault(require(831));
var _MMPoint = _interopRequireDefault(require(830));
//
// import MMText from '../../../whiteboard/elements/graphics/MMText.js'
//
/**
 * @author lishusheng 2014-06-06
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMRectMarkData}
 */
function MMRectMarkData(board, init) {
  _MMYellowObjData["default"].call(this, board, init); //
  this.m_className = 'MMRectMarkData';
  this.m_objType = _ObjType["default"].GObj_rectMark;
  this.m_textObj = null; //MMText

  this.m_standardSize = new _MMPoint["default"](130, 30);
}
;
MMRectMarkData.prototype = new _MMYellowObjData["default"](); //
MMRectMarkData.superclass = _MMYellowObjData["default"].prototype;
MMRectMarkData.prototype.encode = function (enc_) {
  MMRectMarkData.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);

  // 判空处理
  //    assert(this.m_textObj != null) ;
  if (this.m_textObj != null) {
    this.m_textObj.encode(enc_);
  } else {
    //容错处理
    var _temp = new MMText(this.m_board, true);
    _temp.encode(enc_);
  }
};
MMRectMarkData.prototype.decode = function (dec_, ver_) {
  MMRectMarkData.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
  if (this.m_textObj == null) {
    this.m_textObj = new MMText(this.m_board, true);
  }
  this.m_textObj.decode(dec_, ver_);
  this.m_textObj.setCorrelationGraphic(this);
  this.m_fillType.m_hasFill = true;
};

/**
 * 当前标注框的平移变换
 */
MMRectMarkData.prototype.move = function (offset_, moveAll_) {
  MMRectMarkData.superclass.move.call(this, offset_, moveAll_);
  // 判空处理
  //    assert(this.m_textObj != null) ;
  if (this.m_textObj != null) {
    this.m_textObj.move(offset_, moveAll_);
  }
};
MMRectMarkData.prototype.getTextObj = function () {
  return this.m_textObj;
};
/**
 * 当标注内嵌的文本框发生变化时，需要重置标注框
 * @param rect_ {MMRect}
 */
MMRectMarkData.prototype.reSetGraphic = function (rect_) {
  var _drect = new _MMRect["default"]();
  _drect = rect_.clone();
  _drect.left = rect_.left - 0.1;
  _drect.top = rect_.top - 0.04;
  this.m_rect = _drect;
  var _lgPts = new Array();
  var _shapePts = new Array();
  if (this.m_orientation.isLandscape()) {
    _lgPts.push(new _MMPoint["default"](_drect.right, _drect.top));
    _lgPts.push(new _MMPoint["default"](_drect.left, _drect.bottom));
  } else {
    _lgPts.push(new _MMPoint["default"](_drect.left, _drect.top));
    _lgPts.push(new _MMPoint["default"](_drect.right, _drect.bottom));
  }
  _shapePts = this.calInitShapePts(_lgPts);
  this.m_arrCtrlPts = new Array();
  this.setLogicPts(_shapePts);
  var _lgRect = this.getLogicRect();
  var _center = _lgRect.getCenter();
  this.roatate(_center, this.m_angle * Math.PI / 180);
  this.calcStardardRect();
  var object = this.getObject();
  object.setRect(this.m_rect);
  object.setExpandRect(this.m_expandRect);
  var textData = this.m_textObj.getObjData();
  var _textRect = textData.getRect();
  var _textExpRect = textData.getExpandRect();
  this.m_textObj.setRect(_textRect);
  this.m_textObj.setExpandRect(_textExpRect);
};
/**
 * 当前标注框的边框点的计算
 * @param lgPts_ {Array<MMPoint>}
 */
MMRectMarkData.prototype.calInitShapePts = function (lgPts_) {
  var _shapeOffset = new Array();
  var _shapePts = new Array();
  var _offset = new Array();
  _offset.push(0);
  _offset.splice(0, 1, 0, 0, 200, 0, 200, 45, 8, 45, 0, 53);
  for (var i = 0; i < _offset.length - 1; i = i + 2) {
    var _pt = new _MMPoint["default"](_offset[i], _offset[i + 1]);
    _shapeOffset.push(_pt);
  }
  var width = (lgPts_[1].x - lgPts_[0].x) / 200;
  var height = (lgPts_[1].y - lgPts_[0].y) / 45;
  var leftBottom = new _MMPoint["default"](lgPts_[0].x, lgPts_[0].y);
  var leftTop = new _MMPoint["default"](lgPts_[0].x, lgPts_[1].y);
  var rightBottom = new _MMPoint["default"](lgPts_[1].x, lgPts_[0].y);
  var iv = rightBottom.subtract(leftBottom).normalize(); // i 方向的单位向量
  var jv = leftTop.subtract(leftBottom).normalize(); // j 方向的单位向量

  for (var i = 0; i < _shapeOffset.length; i++) {
    var pt = leftBottom.clone();
    if (this.m_orientation.isLandscape()) {
      width = (lgPts_[1].x - lgPts_[0].x) / 45;
      height = (lgPts_[1].y - lgPts_[0].y) / 200;
      var iv_clone = iv.clone();
      var jv_clone = jv.clone();
      pt.subtract(iv_clone.scale(width * _shapeOffset[i].y));
      pt.add(jv_clone.scale(height * _shapeOffset[i].x));
      //            pt = leftBottom.clone();
      //            pt =  leftBottom - iv * width * _shapeOffset.y + jv * height * _shapeOffset.x;
    } else {
      var iv_clone = iv.clone();
      var jv_clone = jv.clone();
      pt.add(iv_clone.scale(width * _shapeOffset[i].x));
      pt.add(jv_clone.scale(height * _shapeOffset[i].y));
      //           pt = leftBottom.clone();
      //            pt =  leftBottom + iv * width * _shapeOffset.x + jv * height * _shapeOffset.y;
    }
    _shapePts.push(pt);
  }
  return _shapePts;
};
/**
 * 当前标注框的几何操作控制
 */
MMRectMarkData.prototype.setLogicPts = function (logicPts) {
  this.m_arrPoints = logicPts;
  //初始时的控制点，根据图形来
  if (this.m_arrCtrlPts.length == 0) {
    this.m_arrCtrlPts = this.m_rect.getLogicPts();
  }

  // 计算每个点相对于控制点的相对位移
  this.m_arrOffset = new Array();
  if (this.m_arrCtrlPts.length == 0) {
    return;
  }
  //获得矩形的左上角点跟右下角点，左上角点默认为角点0 。
  var left_bottom = this.m_arrCtrlPts[0].clone();
  var right_top;
  if (this.m_arrCtrlPts.length == 4) {
    right_top = this.m_ar;
    this.m_arrCtrlPts[2].clone();
  } else if (this.m_arrCtrlPts.length == 8) {
    right_top = this.m_arrCtrlPts[4].clone();
  } else {
    console.assert(false);
    return;
  }
  var width = right_top.x - left_bottom.x;
  var height = right_top.y - left_bottom.y;
  console.assert(Math.abs(width) > 0.00001);
  console.assert(Math.abs(height) > 0.00001);
  if (Math.abs(width) < 0.00001 || Math.abs(height) < 0.00001) {
    return;
  }

  //计算每个点相对于左上角点的偏移量
  for (var i = 0; i < this.m_arrPoints.length; i++) {
    var offset = new _MMPoint["default"](0, 0);
    ;
    offset.x = (this.m_arrPoints[i].x - left_bottom.x) / width;
    offset.y = (this.m_arrPoints[i].y - left_bottom.y) / height;
    this.m_arrOffset.push(offset);
  }
};
/**
 * 重写calcStardardRect方法
 */
MMRectMarkData.prototype.calcStardardRect = function () {
  MMRectMarkData.superclass.calcStardardRect.call(this);
  this.m_expandRect = MMCommonFun.getRect(this.m_arrPoints);
  var expandNum = 0.078125 + this.m_strokeType.getLineWidth();
  this.m_expandRect.expand(expandNum, expandNum, expandNum, expandNum);
  this.getObject().setExpandRect(this.m_expandRect);
};

//transform操作,当前便签框的旋转拉伸变换，需要设限范围
MMRectMarkData.prototype.transform = function (option, basePt_,
// 参考点 MMLgPoint
scale_,
// 拉伸比例 MMLgPoint
angleInfect_,
// 缩放时是否受原有角度影响？在多个对象同时被选中拉伸时，此参数置为 false
alpha_,
// 相对旋转角度(0, 360) float
offset_ // 相对位移 MMLgPoint
) {
  //    console.log("************************ transform after");
  //    this.m_rect.debugOutput(" rect mark  rect:");
  //  MMCommonFun.debugOutputArrPts("ctrl logic pts:", this.m_arrCtrlPts);

  MMRectMarkData.superclass.transform.call(this, option, basePt_, scale_, angleInfect_, alpha_, offset_);

  //    console.log("----------------------transform after");
  //    this.m_rect.debugOutput(" rect mark  rect:");
  //  MMCommonFun.debugOutputArrPts("ctrl logic pts:", this.m_arrCtrlPts);

  if (this.m_textObj != null) {
    //根据新的拉伸比便，计算图形中的文本框的变化比例
    this.m_textObj.transform(option, basePt_, scale_, angleInfect_, alpha_, offset_);
  }
  return scale_;
};
var _default = exports["default"] = MMRectMarkData;

},{"1074":1074,"1084":1084,"1184":1184,"1432":1432,"1454":1454,"830":830,"831":831}],1063:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMBlockObjData = _interopRequireDefault(require(1038));
var _ObjType = _interopRequireDefault(require(1084));
/**
 *
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMRecorderData}
 */
function MMRecorderData(board, init) {
  _MMBlockObjData["default"].call(this, board, init); //
  this.m_className = 'MMRecorderData';
  this.m_objType = _ObjType["default"].Obj_Recorder;
  this.m_textObjName; // MMText *
  this.m_textObjTime; //MMText *
  this.m_filePath; //    string
  this.m_recorderCreateTime; // string
  this.m_recorderFileName; //string
  this.m_showPlayerPanel; //bool
  this.m_durationTime; //double
  this.m_displayTime; //string
  this.m_fileType; //string
  this.m_fileSize; //string
}
;
MMRecorderData.prototype = new _MMBlockObjData["default"](); //
MMRecorderData.superclass = _MMBlockObjData["default"].prototype;
MMRecorderData.prototype.encode = function (enc_) {
  MMRecorderData.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
  this.m_textObjName.encode(enc_);
  this.m_textObjTime.encode(enc_);
  enc_.encodeString(this.m_filePath);
  enc_.encodeString(this.m_recorderFileName);
  enc_.encodeString(this.m_recorderCreateTime);
  enc_.encodeBool(this.m_showPlayerPanel);
  enc_.encodeFloat(this.m_durationTime);
  // if (false) {
  //   enc_.encodeString(this.m_fileType);
  //   enc_.encodeString(this.m_fileSize);
  // }
};
MMRecorderData.prototype.decode = function (dec_, ver_) {
  MMRecorderData.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
  if (this.m_textObjName == null) {
    this.m_textObjName = new MMText(this.m_board);
  }
  if (this.m_textObjTime == null) {
    this.m_textObjTime = new MMText(this.m_board);
  }
  this.m_textObjName.decode(dec_, ver_);
  this.m_textObjTime.decode(dec_, ver_);
  this.m_filePath = dec_.decodeFromString(ver_);
  this.m_recorderFileName = dec_.decodeFromString(ver_);
  this.m_recorderCreateTime = dec_.decodeFromString(ver_);
  this.m_showPlayerPanel = dec_.decodeFromBool(ver_);
  this.m_durationTime = dec_.decodeFromFloat(ver_);
  if (ver_ > 2) {
    if (_objVer == 1) {
      this.m_fileSize = dec_.decodeFromString(ver_);
      this.m_fileType = dec_.decodeFromString(ver_);
    }
  }
  this.setShowPlayer(false);

  //  this.changeAngleByDirection();

  this.m_fillType.m_fillColor.m_alpha = 1;
};
MMRecorderData.prototype.setShowPlayer = function (show_) {
  this.m_showPlayerPanel = show_;
};
MMRecorderData.prototype.getShowPlayer = function (show_) {
  return this.m_showPlayerPanel;
};
var _default = exports["default"] = MMRecorderData;

},{"1038":1038,"1084":1084,"1184":1184,"1454":1454}],1061:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMGraphicsData = _interopRequireDefault(require(1052));
var _ObjType = _interopRequireDefault(require(1084));
function MMPentagonData(board, init) {
  _MMGraphicsData["default"].call(this, board, init);
  this.m_className = 'MMPentagonData';
  this.m_objType = _ObjType["default"].GObj_pentagon;
}
;
MMPentagonData.prototype = new _MMGraphicsData["default"]();
MMPentagonData.superclass = _MMGraphicsData["default"].prototype;
MMPentagonData.prototype.encode = function (enc_) {
  MMPentagonData.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMPentagonData.prototype.decode = function (dec_, ver_) {
  MMPentagonData.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
var _default = exports["default"] = MMPentagonData;

},{"1052":1052,"1084":1084,"1184":1184,"1454":1454}],1060:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1425);
var _MMBlockObjData = _interopRequireDefault(require(1038));
var _ObjType = _interopRequireDefault(require(1084));
/**
 * @author lishusheng 2014-06-06
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMPDFDocumentData}
 */
function MMPDFDocumentData(board, init) {
  _MMBlockObjData["default"].call(this, board, init); //
  this.m_className = 'MMPDFDocumentData';
  this.m_objType = _ObjType["default"].Obj_PDF;
  this.m_vc = null;
  this.m_filePath = ""; //string

  this.pdfIndex = 0;
}
;
MMPDFDocumentData.prototype = new _MMBlockObjData["default"](); //
MMPDFDocumentData.superclass = _MMBlockObjData["default"].prototype;
MMPDFDocumentData.prototype.encode = function (enc_) {
  MMPDFDocumentData.superclass.encode.call(this, enc_);
  var _objVer = 1;
  enc_.encode4Bytes(_objVer);
  enc_.encodeString(this.m_filePath);
  enc_.encode4Bytes(this.pdfIndex);
};
MMPDFDocumentData.prototype.decode = function (dec_, ver_) {
  MMPDFDocumentData.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
  this.m_filePath = dec_.decodeFromString(ver_);
  this.pdfIndex = dec_.decodeFrom4Bytes(ver_);

  //  this.changeAngleByDirection();
};
MMPDFDocumentData.prototype.getFilePath_Original = function () {
  return MMPDFDocumentData.superclass.getFilePath.call(this);
};
MMPDFDocumentData.prototype.getFilePath = function () {
  //  // test
  //  console.error("----- only for test");
  //  return this.m_filePath;
  //  // end

  if (this.m_filePath != undefined && this.m_filePath.length > 0) {
    if (window.location.host) {
      // temporary code, need to more elegant.
      var extent = this.m_filePath;
      extent = extent.substr(extent.lastIndexOf('.')).toLowerCase();
      var _ret = "downloadFile.do?fileName=" + this.m_filePath + "&typeFlag=0&userId=" + this.m_board.getCreatorId().toDecString() + "&boardId=" + this.m_board.getMotherBoardStringId();
      // if (IWORK_FILETYPE.indexOf(extent)==-1) {
      return _ret;
      // } else {
      //     return iWorkConvertorSrc + '/' + _ret;
      // }
    }
    var _ret = "http://192.168.2.17:9090/downloadFile.do?fileName=" + this.m_filePath + "&typeFlag=0&userId=" + this.m_board.getCreatorId().toDecString() + "&boardId=" + this.m_board.getMotherBoardStringId();
    return _ret;
  } else {
    return "";
  }
};
MMPDFDocumentData.prototype.setPdfPageIndex = function (index) {
  this.pdfIndex = index;
};
MMPDFDocumentData.prototype.getPdfPageIndex = function () {
  return this.pdfIndex;
};
MMPDFDocumentData.prototype.setLogicPts = function (logicPts) {
  this.m_arrCtrlPts = logicPts;
};
var _default = exports["default"] = MMPDFDocumentData;

},{"1038":1038,"1084":1084,"1184":1184,"1425":1425,"1454":1454}],1059:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMBezierObjData = _interopRequireDefault(require(1037));
var _ObjType = _interopRequireDefault(require(1084));
var _MMPoint = _interopRequireDefault(require(830));
/**
 * @author lishusheng 2014-06-06
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMNoteData}
 */
function MMNoteData(board, init) {
  _MMBezierObjData["default"].call(this, board, init); //
  this.m_className = 'MMNoteData';
  this.m_objType = _ObjType["default"].GObj_note;
  this.m_textRect = null; //MMLgRect
  this.m_textId = null; //OBJ_ID
  this.m_textObj = null; //MMText
  this.m_cornerPoint = null; //MMDvPoint
  this.m_width = 0.0; // --------------double  记录初始进来便签的宽度

  this.m_standardSize = new _MMPoint["default"](120, 105);
}
;
MMNoteData.prototype = new _MMBezierObjData["default"](); //
MMNoteData.superclass = _MMBezierObjData["default"].prototype;
MMNoteData.prototype.encode = function (enc_) {
  MMNoteData.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);

  // 判空处理
  //    assert(this.m_textObj != null) ;
  if (this.m_textObj != null) {
    this.m_textObj.encode(enc_);
  } else {
    //容错处理
    var _temp = new MMText(this.m_board, true);
    _temp.encode(enc_);
  }
  enc_.encodeMMRect(this.m_textRect);
  enc_.encodeFloat(this.m_width);
};
MMNoteData.prototype.decode = function (dec_, ver_) {
  MMNoteData.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
  if (this.m_textObj == null) {
    this.m_textObj = new MMText(this.m_board, true);
  }
  this.m_textObj.decode(dec_, ver_);
  this.m_textRect = dec_.decodeFromMMRect(ver_);
  this.m_width = dec_.decodeFromFloat(ver_);
  this.m_textObj.setCorrelationGraphic(this);
  this.m_fillType.m_hasFill = true;
};
MMNoteData.prototype.getTextObj = function () {
  return this.m_textObj;
};
/**
 * 当前便签框的平移变换
 */
MMNoteData.prototype.move = function (offset_, moveAll_) {
  MMNoteData.superclass.move.call(this, offset_, moveAll_);

  // 判空处理
  //    assert(this.m_textObj != null) ;
  if (this.m_textObj != null) {
    this.m_textObj.move(offset_, moveAll_);
  }
};
/**
 *
 * @param rect_ {MMRect}
 */
MMNoteData.prototype.reSetGraphic = function (rect_) {};

//transform操作,当前便签框的旋转拉伸变换，需要设限范围
MMNoteData.prototype.transform = function (option, basePt_,
// 参考点 MMLgPoint
scale_,
// 拉伸比例 MMLgPoint
angleInfect_,
// 缩放时是否受原有角度影响？在多个对象同时被选中拉伸时，此参数置为 false
alpha_,
// 相对旋转角度(0, 360) float
offset_ // 相对位移 MMLgPoint
) {
  MMNoteData.superclass.transform.call(this, option, basePt_, scale_, angleInfect_, alpha_, offset_);
  if (this.m_textObj != null) {
    //根据新的拉伸比便，计算图形中的文本框的变化比例
    this.m_textObj.transform(option, basePt_, scale_, angleInfect_, alpha_, offset_);
  }
  return scale_;
};
var _default = exports["default"] = MMNoteData;

},{"1037":1037,"1084":1084,"1184":1184,"1454":1454,"830":830}],1058:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMSegmentData = _interopRequireDefault(require(1069));
var _ObjType = _interopRequireDefault(require(1084));
/**
 * @author lishusheng 2014-06-06
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMNitePenData}
 */
function MMNitePenData(board, init) {
  _MMSegmentData["default"].call(this, board, init); //
  this.m_className = 'MMNitePenData';
  this.m_objType = _ObjType["default"].GObj_nitePen;
}
;
MMNitePenData.prototype = new _MMSegmentData["default"](); //
MMNitePenData.superclass = _MMSegmentData["default"].prototype;
MMNitePenData.prototype.encode = function (enc_) {
  MMNitePenData.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMNitePenData.prototype.decode = function (dec_, ver_) {
  MMNitePenData.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
var _default = exports["default"] = MMNitePenData;

},{"1069":1069,"1084":1084,"1184":1184,"1454":1454}],1057:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MMNiceTagData;
var _MMPointObjData = _interopRequireDefault(require(1062));
var _ObjType = _interopRequireDefault(require(1084));
//
//  Created by jiang on 15/5/21.
//  Copyright (c) 2015年 Molamola. All rights reserved.
//

/**
 *
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMCircleData}
 */

// 标签类型
var MMNiceTagType = {
  normal: 0,
  location: 1,
  person: 2,
  date: 3
};
function MMNiceTagData(board, init) {
  _MMPointObjData["default"].call(this, board, init); //

  this.label = "tag label";
  this.rightSide = true;
  this.tagRecordId = "123456789";
  this.tagType = MMNiceTagType.normal;
  this.m_objType = _ObjType["default"].Obj_niceTag;
}
;
MMNiceTagData.prototype = new _MMPointObjData["default"](); //
MMNiceTagData.superclass = _MMPointObjData["default"].prototype;
MMNiceTagData.prototype.encode = function (enc_) {
  MMNiceTagData.superclass.encode.call(this, enc_); // 1

  var objVer = 0;
  enc_.encode4Bytes(objVer);
  enc_.encodeString(this.label);
  enc_.encodeString(this.tagRecordId);
  enc_.encode1Byte(this.tagType);
  enc_.encode1Byte(this.rightSide);
};
MMNiceTagData.prototype.decode = function (dec_, ver_) {
  MMNiceTagData.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.label = dec_.decodeFromString(ver_);
  this.tagRecordId = dec_.decodeFromString(ver_);
  this.tagType = dec_.decodeFrom1Byte(ver_);
  this.rightSide = dec_.decodeFrom1Byte(ver_);
};

},{"1062":1062,"1084":1084,"1184":1184,"1454":1454}],1056:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ObjType = _interopRequireDefault(require(1084));
var _MMGraphicsData = _interopRequireDefault(require(1052));
function MMIndicateArrowData(board, init) {
  _MMGraphicsData["default"].call(this, board, init);
  this.m_className = 'MMIndicateArrowData';
  this.m_objType = _ObjType["default"].GObj_indicateline;
}
;
MMIndicateArrowData.prototype = new _MMGraphicsData["default"]();
MMIndicateArrowData.superclass = _MMGraphicsData["default"].prototype;
MMIndicateArrowData.prototype.encode = function (enc_) {
  MMIndicateArrowData.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMIndicateArrowData.prototype.decode = function (dec_, ver_) {
  MMIndicateArrowData.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
var _default = exports["default"] = MMIndicateArrowData;

},{"1052":1052,"1084":1084,"1184":1184,"1454":1454}],1055:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1429);
var _MMBlockObjData = _interopRequireDefault(require(1038));
var _ObjType = _interopRequireDefault(require(1084));
var _MMPoint = _interopRequireDefault(require(830));
// import MDPcMobileEditorCommonFun from '../../../common/MDPcMobileEditorCommonFun.js';

/**
 *
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMImageData}
 */
function MMImageData(board) {
  _MMBlockObjData["default"].call(this, board); //继承属性
  this.m_className = 'MMImageData';
  this.m_objType = _ObjType["default"].Obj_Image;
  /**
   * 图片的文件路径
   * @type {string}
   */
  this.m_filePath = "";
  /**
   * @type {UIImage}
   */
  this.m_image = null;
  this.m_imgLock = null; //@type NSLock
  this.m_vc = null; //@type MMLoadingImageTipViewController

  this.m_strokeType.m_lineWidth = 0.0;
  //this.m_hotzoneCtl = new Element.MMHotZoneInImageCtl();
}
;
MMImageData.prototype = new _MMBlockObjData["default"](); //继承方法
MMImageData.superclass = _MMBlockObjData["default"].prototype;
MMImageData.prototype.encode = function (enc_) {
  MMImageData.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
  enc_.encodeString(this.m_filePath);
};
MMImageData.prototype.decode = function (dec_, ver_) {
  MMImageData.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
  this.m_filePath = dec_.decodeFromString(ver_);

  //  this.changeAngleByDirection();
};

//MMImageData.prototype.getHotZoneCtl = function () {
//  return this.m_hotzoneCtl;
//}

MMImageData.prototype.setDevPts = function (trfmer_, devPts_, pageIndex_) {
  MMImageData.superclass.setDevPts.call(this, trfmer_, devPts_, pageIndex_);
  if (devPts_.length < 2) {
    return;
  }
  var lgPts = trfmer_.dv2lgPoints(devPts_, pageIndex_);
  this.m_expandRect = this.m_rect = MMCommonFun.getRect(lgPts);
  //need adjustment here
  //double _error = trfmer_.dev2Logic(4);
  //this.m_expandRect.expand(_error + m_strokeType.getLineWidth());
  var _shapePts = this.calInitShapePts(lgPts);
  this.setLogicPts(_shapePts);
};
MMImageData.prototype.calInitShapePts = function (lgPts_) {
  var _shapePts = [];
  _shapePts.push((0, _MMPoint["default"])(this.m_rect.minX, this.m_rect.minY));
  _shapePts.push((0, _MMPoint["default"])(this.m_rect.maxX, this.m_rect.minY));
  _shapePts.push((0, _MMPoint["default"])(this.m_rect.maxX, this.m_rect.maxY));
  _shapePts.push((0, _MMPoint["default"])(this.m_rect.minX, this.m_rect.maxY));
  return _shapePts;
};
MMImageData.prototype.setLogicPts = function (logicPts_) {
  //初始时的控制点，根据图形来
  if (this.m_arrCtrlPts.length === 0) this.m_arrCtrlPts = this.m_rect.getLogicPts();
};
MMImageData.prototype.setFilePath = function (path_) {
  this.m_filePath = path_;
};
MMImageData.prototype.getFilePath = function (transformer) {
  //return "http://www.babel.cc/downloadFile.do?fileName=26550402868000475315874413394.jpg&typeFlag=0&userId=10&boardId=54e31f8e00000010&style=13";

  var path = MMImageData.superclass.getFilePath.call(this);
  if (path.length > 0) {
    if (transformer == undefined || transformer == null) {
      var editCtrl = MDPcMobileEditorCommonFun.getMainEditor();
      transformer = editCtrl.getTransformer();
    }
    var size = 512;
    if (transformer == null || transformer == undefined) {} else {
      var w = this.m_rect.getWidth();
      var h = this.m_rect.getHeight();
      var dW = transformer.lg2dvLen(w);
      var dH = transformer.lg2dvLen(h);
      size = Math.max(dW, dH);
    }
    var styleN;
    var t = this.m_filePath.slice(-4);
    if (t == '.png') {
      if (size <= 512) {
        styleN = 81;
        if (window.devicePixelRatio) {
          styleN = Math.round(styleN + window.devicePixelRatio - 1);
          if (styleN > 83) {
            styleN = 83;
          }
        }
      } else if (size <= 1024) {
        styleN = 82;
        if (window.devicePixelRatio) {
          styleN = Math.round(styleN + window.devicePixelRatio - 1);
          if (styleN > 83) {
            styleN = 83;
          }
        }
      } else {
        styleN = 83;
      }
    } else {
      if (size <= 512) {
        styleN = 71;
        if (window.devicePixelRatio) {
          styleN = Math.round(styleN + window.devicePixelRatio - 1);
          if (styleN > 73) {
            styleN = 73;
          }
        }
      } else if (size <= 1024) {
        styleN = 72;
        if (window.devicePixelRatio) {
          styleN = Math.round(styleN + window.devicePixelRatio - 1);
          if (styleN > 73) {
            styleN = 73;
          }
        }
      } else {
        styleN = 73;
      }
    }
    path = path + "&style=" + styleN;
  }
  return path;
};
MMImageData.prototype.getLowPixelFilePath = function (size) {
  //return "http://www.babel.cc/downloadFile.do?fileName=26550402868000475315874413394.jpg&typeFlag=0&userId=10&boardId=54e31f8e00000010&style=13";
  size = size ? size : 512;
  var path = MMImageData.superclass.getFilePath.call(this);
  if (path.length > 0) {
    var styleN;
    var t = this.m_filePath.slice(-4);
    if (t == '.png') {
      if (size <= 512) {
        styleN = 81;
      } else if (size <= 1024) {
        styleN = 82;
      } else {
        styleN = 83;
      }
    } else {
      if (size <= 512) {
        styleN = 71;
      } else if (size <= 1024) {
        styleN = 72;
      } else {
        styleN = 73;
      }
    }
    path = path + "&style=" + styleN;
  }
  return path;
};
MMImageData.prototype.getLowPixelFilePathForVersion = function (ver_) {
  //return "http://www.babel.cc/downloadFile.do?fileName=26550402868000475315874413394.jpg&typeFlag=0&userId=10&boardId=54e31f8e00000010&style=13";
  var size = size ? size : 512;
  var path = MMImageData.superclass.getFilePathForVersion.call(this, ver_);
  if (path.length > 0) {
    var styleN;
    var t = this.m_filePath.slice(-4);
    if (t == '.png') {
      if (size <= 512) {
        styleN = 81;
      } else if (size <= 1024) {
        styleN = 82;
      } else {
        styleN = 83;
      }
    } else {
      if (size <= 512) {
        styleN = 71;
      } else if (size <= 1024) {
        styleN = 72;
      } else {
        styleN = 73;
      }
    }
    path = path + "&style=" + styleN;
  }
  return path;
};
MMImageData.prototype.getFilePath_Original = function () {
  return MMImageData.superclass.getFilePath.call(this);
};
MMImageData.prototype.getOriginFilePath = function () {
  return this.m_filePath;
  return this.getFilePath_Original();
};
MMImageData.prototype.isPng = function () {
  var t = this.m_filePath.slice(-4);
  if (t.toLowerCase() == '.png') {
    return true;
  }
  return false;
};
MMImageData.prototype.setImage = function (image) {
  this.m_image = image || null;
};
MMImageData.prototype.getImage = function (image) {
  return this.m_image;
};
MMImageData.prototype.isPtOn = function (pt, error) {};
/**
 * indicates if the imageobject is uploaded
 * @returns {boolean}
 */
MMImageData.prototype.isLoaded = function () {
  return !!this.m_filePath;
};
MMImageData.prototype.setLogicPts = function (logicPts) {
  this.m_arrCtrlPts = logicPts;
};
var _default = exports["default"] = MMImageData;

},{"1038":1038,"1084":1084,"1184":1184,"1429":1429,"1454":1454,"830":830}],1054:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMGraphicsData = _interopRequireDefault(require(1052));
var _ObjType = _interopRequireDefault(require(1084));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MMPoint = _interopRequireDefault(require(830));
/**
 * @author lishusheng,2014-06-04
 * @param board
 * @param init
 * @returns {MMHexagonData}
 */
function MMHexagonData(board, init) {
  _MMGraphicsData["default"].call(this, board, init);
  this.m_className = 'MMHexagonData';
  this.m_objType = _ObjType["default"].GObj_hexagon;
}
;
MMHexagonData.prototype = new _MMGraphicsData["default"]();
MMHexagonData.superclass = _MMGraphicsData["default"].prototype;
MMHexagonData.prototype.encode = function (enc_) {
  MMHexagonData.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMHexagonData.prototype.decode = function (dec_, ver_) {
  MMHexagonData.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
MMHexagonData.prototype.calInitShapePts = function (lgPts) {
  var _shapePts = new Array();
  if (lgPts.length < 2) {
    return _shapePts;
  }
  if (this.m_orientation.isLandscape()) {
    _shapePts.push(this.m_arrYellowPoints[0].clone());
    _shapePts.push(new _MMPoint["default"]((lgPts[0].x + lgPts[1].x) / 2, lgPts[0].y));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x, this.m_arrYellowPoints[0].y));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x, lgPts[0].y + lgPts[1].y - this.m_arrYellowPoints[0].y));
    _shapePts.push(new _MMPoint["default"]((lgPts[0].x + lgPts[1].x) / 2, lgPts[1].y));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x, lgPts[0].y + lgPts[1].y - this.m_arrYellowPoints[0].y));
  } else {
    _shapePts.push(this.m_arrYellowPoints[0].clone());
    _shapePts.push(new _MMPoint["default"](lgPts[0].x, (lgPts[0].y + lgPts[1].y) / 2));
    _shapePts.push(new _MMPoint["default"](this.m_arrYellowPoints[0].x, lgPts[1].y));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x + lgPts[1].x - this.m_arrYellowPoints[0].x, lgPts[1].y));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x, (lgPts[0].y + lgPts[1].y) / 2));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x + lgPts[1].x - this.m_arrYellowPoints[0].x, lgPts[0].y));
  }
  return _shapePts;
};
MMHexagonData.prototype.setYellowPtsAndIsClose = function (yellowPts_, isClose_) {
  var _lgPts = new Array();
  var arc = this.m_angle * Math.PI / 180;
  var leftBottom = this.m_arrCtrlPts[0].clone();
  var rightTop = null;
  var leftTop = null;
  var rightBottom = null;
  if (this.m_arrCtrlPts.length == 4) {
    rightTop = this.m_arrCtrlPts[2].clone();
    leftTop = this.m_arrCtrlPts[3].clone();
    rightBottom = this.m_arrCtrlPts[1].clone();
  } else if (this.m_arrCtrlPts.length == 8) {
    rightTop = this.m_arrCtrlPts[4].clone();
    leftTop = this.m_arrCtrlPts[6].clone();
    rightBottom = this.m_arrCtrlPts[2].clone();
  }
  var center = new _MMPoint["default"]((leftBottom.x + rightTop.x) / 2, (leftBottom.y + rightTop.y) / 2);
  if (Math.abs(this.m_angle) > 0.00001) {
    this.roatate(center, -arc);
    _MMCommonFun["default"].rotateAroundPts(yellowPts_, center, -arc);
    leftBottom = this.m_arrCtrlPts[0].clone();
    if (Math.abs(this.m_arrCtrlPts.length - 4) < 0.00001) {
      rightTop = this.m_arrCtrlPts[2].clone();
      leftTop = this.m_arrCtrlPts[3].clone();
      rightBottom = this.m_arrCtrlPts[1].clone();
    } else if (Math.abs(this.m_arrCtrlPts.length - 8) < 0.00001) {
      rightTop = this.m_arrCtrlPts[4].clone();
      leftTop = this.m_arrCtrlPts[6].clone();
      rightBottom = this.m_arrCtrlPts[2].clone();
    }
  }
  var _signedx = 1;
  var _signedy = 1;
  if (this.m_orientation.isLandscape()) {
    _lgPts.push(rightBottom.clone());
    _lgPts.push(leftTop.clone());
    if (_lgPts[0].y > _lgPts[1].y) _signedy = -1;
    yellowPts_[0].x = _lgPts[0].x;
    if ((yellowPts_[0].y - _lgPts[0].y) * _signedy < 0) {
      yellowPts_[0].y = _lgPts[0].y;
    } else if ((yellowPts_[0].y - (_lgPts[0].y + _lgPts[1].y) / 2) * _signedy > 0) {
      yellowPts_[0].y = (_lgPts[0].y + _lgPts[1].y) / 2;
    }
  } else {
    _lgPts.push(leftBottom.clone());
    _lgPts.push(rightTop.clone());
    if (_lgPts[0].x > _lgPts[1].x) _signedx = -1;
    if ((yellowPts_[0].x - _lgPts[0].x) * _signedx < 0) {
      yellowPts_[0].x = _lgPts[0].x;
    } else if ((yellowPts_[0].x - (_lgPts[0].x + _lgPts[1].x) / 2) * _signedx > 0) {
      yellowPts_[0].x = (_lgPts[0].x + _lgPts[1].x) / 2;
    }
    yellowPts_[0].y = _lgPts[0].y;
  }
  this.m_arrYellowPoints = new Array();
  this.m_arrYellowPoints = yellowPts_;
  var _newLgPts = this.calInitShapePts(_lgPts);
  this.setLogicPts(_newLgPts);
  if (Math.abs(this.m_angle) > 0.00001) {
    this.roatate(center, arc);
    _MMCommonFun["default"].rotateAroundPts(yellowPts_, center, arc);
  }
  this.m_isClose = isClose_;
};
var _default = exports["default"] = MMHexagonData;

},{"1052":1052,"1084":1084,"1184":1184,"1454":1454,"812":812,"830":830}],1053:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMPoint = _interopRequireDefault(require(830));
var _MMRoundRectData = _interopRequireDefault(require(1066));
var _ObjType = _interopRequireDefault(require(1084));
/**
 * @author lishusheng 2014-06-04
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMHalfRoundRectData}
 */

function MMHalfRoundRectData(board, init) {
  _MMRoundRectData["default"].call(this, board, init);
  this.m_className = 'MMHalfRoundRectData';
  this.m_objType = _ObjType["default"].GObj_halfroundrect;
  this.m_standardSize = new _MMPoint["default"](150, 120);
}
;
MMHalfRoundRectData.prototype = new _MMRoundRectData["default"]();
MMHalfRoundRectData.superclass = _MMRoundRectData["default"].prototype;
MMHalfRoundRectData.prototype.encode = function (enc_) {
  MMHalfRoundRectData.superclass.encode.call(this, enc_); //
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMHalfRoundRectData.prototype.decode = function (dec_, ver_) {
  MMHalfRoundRectData.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
MMHalfRoundRectData.prototype.calInitShapePts = function (lgPts) {
  this.reCalcYellowPts(lgPts);
  var _signedx = 1;
  var _signedy = 1;
  var _shapePts = new Array();
  var _dis = 0;
  var _d = 0;
  if (lgPts.length < 2) {
    return _shapePts;
  }
  if (this.m_orientation.isLandscape()) {
    //设备为横向
    if (lgPts[0].x > lgPts[1].x) {
      _signedx = 1;
    } else {
      _signedx = -1;
    }
    if (lgPts[0].y > lgPts[1].y) _signedy = -1;
    _dis = Math.abs(this.m_arrYellowPoints[0].y - lgPts[0].y);
    _d = (1 - 4 * (Math.sqrt(2) - 1) / 3) * _dis;
    _shapePts.push(new _MMPoint["default"](lgPts[0].x - _signedx * _d, lgPts[0].y));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x - _signedx * _dis, lgPts[0].y));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x - _signedx * _dis, lgPts[0].y));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x, lgPts[0].y));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x, lgPts[0].y));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x, lgPts[0].y));
    _shapePts.push(lgPts[1].clone());
    _shapePts.push(lgPts[1].clone());
    _shapePts.push(lgPts[1].clone());
    _shapePts.push(new _MMPoint["default"](lgPts[0].x - _signedx * _dis, lgPts[1].y));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x - _signedx * _dis, lgPts[1].y));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x - _signedx * _d, lgPts[1].y));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x, lgPts[1].y - _signedy * _d));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x, lgPts[1].y - _signedy * _dis));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x, lgPts[1].y - _signedy * _dis));
    _shapePts.push(this.m_arrYellowPoints[0].clone());
    _shapePts.push(this.m_arrYellowPoints[0].clone());
    _shapePts.push(new _MMPoint["default"](lgPts[0].x, lgPts[0].y + _signedy * _d));
  } else {
    //设备为竖向
    if (lgPts[0].x > lgPts[1].x) _signedx = -1;
    if (lgPts[0].y > lgPts[1].y) _signedy = -1;
    _dis = Math.abs(this.m_arrYellowPoints[0].x - lgPts[0].x);
    _d = (1 - 4 * (Math.sqrt(2) - 1) / 3) * _dis;
    _shapePts.push(new _MMPoint["default"](lgPts[0].x, lgPts[0].y + _signedy * _d));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x, lgPts[0].y + _signedy * _dis));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x, lgPts[0].y + _signedy * _dis));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x, lgPts[1].y));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x, lgPts[1].y));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x, lgPts[1].y));
    _shapePts.push(lgPts[1].clone());
    _shapePts.push(lgPts[1].clone());
    _shapePts.push(lgPts[1].clone());
    _shapePts.push(new _MMPoint["default"](lgPts[1].x, lgPts[0].y + _signedy * _dis));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x, lgPts[0].y + _signedy * _dis));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x, lgPts[0].y + _signedy * _d));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x - _signedx * _d, lgPts[0].y));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x - _signedx * _dis, lgPts[0].y));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x - _signedx * _dis, lgPts[0].y));
    _shapePts.push(this.m_arrYellowPoints[0].clone());
    _shapePts.push(this.m_arrYellowPoints[0].clone());
    _shapePts.push(new _MMPoint["default"](lgPts[0].x + _signedx * _d, lgPts[0].y));
  }
  return _shapePts;
};
var _default = exports["default"] = MMHalfRoundRectData;

},{"1066":1066,"1084":1084,"1184":1184,"1454":1454,"830":830}],1066:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMCircleData = _interopRequireDefault(require(1040));
var _MMPoint = _interopRequireDefault(require(830));
var _ObjType = _interopRequireDefault(require(1084));
/**
 * @author lishusheng 2014-06-04
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMRoundRectData}
 */

function MMRoundRectData(board, init) {
  _MMCircleData["default"].call(this, board, init);
  this.m_className = 'MMRoundRectData';
  this.m_objType = _ObjType["default"].GObj_roundrect;
  this.m_standardSize = new _MMPoint["default"](150, 120);
}
;
MMRoundRectData.prototype = new _MMCircleData["default"]();
MMRoundRectData.superclass = _MMCircleData["default"].prototype;
MMRoundRectData.prototype.encode = function (enc_) {
  MMRoundRectData.superclass.encode.call(this, enc_); //
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMRoundRectData.prototype.decode = function (dec_, ver_) {
  MMRoundRectData.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
MMRoundRectData.prototype.transform = function (option, basePt_,
// 参考点 MMLgPoint
scale_,
// 拉伸比例 MMLgPoint
angleInfect_,
// 缩放时是否受原有角度影响？在多个对象同时被选中拉伸时，此参数置为 false
alpha_,
// 相对旋转角度(0, 360) float
offset_ // 相对位移 MMLgPoint
) {
  angleInfect_ = true;
  MMRoundRectData.superclass.transform.call(this, option, basePt_, scale_, angleInfect_, alpha_, offset_);
};
MMRoundRectData.prototype.updatePtsFromCtlPts = function () {
  var leftBottom = this.m_arrCtrlPts[0].clone();
  var rightTop = null;
  var leftTop = null;
  var rightBottom = null;
  if (this.m_arrCtrlPts.length == 8) {
    rightTop = this.m_arrCtrlPts[4].clone();
    leftTop = this.m_arrCtrlPts[6].clone();
    rightBottom = this.m_arrCtrlPts[2].clone();
  } else {
    //        assert(false);
    return;
  }
  var right_bottom_pt = rightBottom.clone();
  var width = right_bottom_pt.subtract(leftBottom).magnitude(); //向量求模
  var left_top_pt = leftTop.clone();
  var height = left_top_pt.subtract(leftBottom).magnitude();
  //    assert(Math.abs(width) > 0.00001);
  //    assert(Math.abs(height) > 0.00001);
  if (Math.abs(width) < 0.00001 || Math.abs(height) < 0.00001) {
    return;
  }
  right_bottom_pt = rightBottom.clone();
  var iv = right_bottom_pt.subtract(leftBottom).normalize(); // i 方向的单位向量
  left_top_pt = leftTop.clone();
  var jv = left_top_pt.subtract(leftBottom).normalize();
  for (var i = 0; i < this.m_arrYellowOffset.length; i++) {
    var pt = leftBottom.clone();
    var iv_clone = iv.clone();
    var jv_clone = jv.clone();
    pt.add(iv_clone.scale(width * this.m_arrYellowOffset[i].x)).add(jv_clone.scale(height * this.m_arrYellowOffset[i].y));
    this.m_arrYellowPoints.push(pt);
  }
  var _lgPts = new Array();
  var _newlgpts = new Array();
  var _signedx = 1;
  var _signedy = 1;
  var _minDis = Math.min(width, height);
  if (this.getDevOrientation() == 1 || this.getDevOrientation() == 2) {
    _lgPts.push(rightBottom.clone());
    _lgPts.push(leftTop.clone());
    if (_lgPts[0].y > _lgPts[1].y) _signedy = -1;
    if ((this.m_arrYellowPoints[0].y - _lgPts[0].y - _signedy * _minDis / 2) * _signedy > 0) {
      this.m_arrYellowPoints[0].y = _lgPts[0].y + _signedy * _minDis / 2;
    } else if ((this.m_arrYellowPoints[0].y - _lgPts[0].y) * _signedy < 0) {
      this.m_arrYellowPoints[0].y = _lgPts[0].y;
    }
    this.m_arrYellowPoints[0].x = _lgPts[0].x;
  } else {
    _lgPts.push(leftBottom.clone());
    _lgPts.push(rightTop.clone());
    if (_lgPts[0].x > _lgPts[1].x) _signedx = -1;
    if ((this.m_arrYellowPoints[0].x - _lgPts[0].x - _signedx * _minDis / 2) * _signedx > 0) {
      this.m_arrYellowPoints[0].x = _lgPts[0].x + _signedx * _minDis / 2;
    } else if ((this.m_arrYellowPoints[0].x - _lgPts[0].x) * _signedx < 0) {
      this.m_arrYellowPoints[0].x = _lgPts[0].x;
    }
    this.m_arrYellowPoints[0].y = _lgPts[0].y;
  }
  //重置图形的形状数据
  _newlgpts = this.calInitShapePts(_lgPts);
  this.setLogicPts(_newlgpts);
};
MMRoundRectData.prototype.calInitShapePts = function (lgPts) {
  this.reCalcYellowPts(lgPts);
  var _signedx = 1;
  var _signedy = 1;
  var _shapePts = new Array();
  if (lgPts.length < 2) {
    return _shapePts;
  }
  var _dis = 0;
  var _d = 0;
  if (this.m_orientation.isLandscape()) {
    //设备横向时
    if (lgPts[0].x > lgPts[1].x) {
      _signedx = 1;
    } else {
      _signedx = -1;
    }
    if (lgPts[0].y > lgPts[1].y) _signedy = -1;
    _dis = Math.abs(this.m_arrYellowPoints[0].y - lgPts[0].y);
    _d = (1 - 4 * (Math.sqrt(2) - 1) / 3) * _dis;
    _shapePts.push(new _MMPoint["default"](lgPts[0].x - _signedx * _d, lgPts[0].y));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x - _signedx * _dis, lgPts[0].y));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x - _signedx * _dis, lgPts[0].y));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x + _signedx * _dis, lgPts[0].y));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x + _signedx * _dis, lgPts[0].y));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x + _signedx * _d, lgPts[0].y));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x, lgPts[0].y + _signedy * _d));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x, lgPts[0].y + _signedy * _dis));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x, lgPts[0].y + _signedy * _dis));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x, lgPts[1].y - _signedy * _dis));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x, lgPts[1].y - _signedy * _dis));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x, lgPts[1].y - _signedy * _d));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x + _signedx * _d, lgPts[1].y));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x + _signedx * _dis, lgPts[1].y));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x + _signedx * _dis, lgPts[1].y));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x - _signedx * _dis, lgPts[1].y));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x - _signedx * _dis, lgPts[1].y));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x - _signedx * _d, lgPts[1].y));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x, lgPts[1].y - _signedy * _d));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x, lgPts[1].y - _signedy * _dis));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x, lgPts[1].y - _signedy * _dis));
    _shapePts.push(this.m_arrYellowPoints[0].clone());
    _shapePts.push(this.m_arrYellowPoints[0].clone());
    _shapePts.push(new _MMPoint["default"](lgPts[0].x, lgPts[0].y + _signedy * _d));
  } else {
    //设备竖向时
    if (lgPts[0].x > lgPts[1].x) _signedx = -1;
    if (lgPts[0].y > lgPts[1].y) _signedy = -1;
    _dis = Math.abs(this.m_arrYellowPoints[0].x - lgPts[0].x);
    _d = (1 - 4 * (Math.sqrt(2) - 1) / 3) * _dis;
    _shapePts.push(new _MMPoint["default"](lgPts[0].x, lgPts[0].y + _signedy * _d));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x, lgPts[0].y + _signedy * _dis));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x, lgPts[0].y + _signedy * _dis));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x, lgPts[1].y - _signedy * _dis));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x, lgPts[1].y - _signedy * _dis));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x, lgPts[1].y - _signedy * _d));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x + _signedx * _d, lgPts[1].y));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x + _signedx * _dis, lgPts[1].y));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x + _signedx * _dis, lgPts[1].y));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x - _signedx * _dis, lgPts[1].y));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x - _signedx * _dis, lgPts[1].y));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x - _signedx * _d, lgPts[1].y));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x, lgPts[1].y - _signedy * _d));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x, lgPts[1].y - _signedy * _dis));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x, lgPts[1].y - _signedy * _dis));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x, lgPts[0].y + _signedy * _dis));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x, lgPts[0].y + _signedy * _dis));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x, lgPts[0].y + _signedy * _d));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x - _signedx * _d, lgPts[0].y));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x - _signedx * _dis, lgPts[0].y));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x - _signedx * _dis, lgPts[0].y));
    _shapePts.push(this.m_arrYellowPoints[0].clone());
    _shapePts.push(this.m_arrYellowPoints[0].clone());
    _shapePts.push(new _MMPoint["default"](lgPts[0].x + _signedx * _d, lgPts[0].y));
  }
  return _shapePts;
};
MMRoundRectData.prototype.reCalcYellowPts = function (lgPts_) {
  if (this.m_arrYellowPoints.length == 0) {
    return;
  }
  var leftBottom = lgPts_[0].clone();
  //MMLgPoint rightTop = lgPts_[1];
  var leftTop = new _MMPoint["default"](lgPts_[0].x, lgPts_[1].y);
  var rightBottom = new _MMPoint["default"](lgPts_[1].x, lgPts_[0].y);
  var right_bottom_pt = rightBottom.clone();
  var width = right_bottom_pt.subtract(leftBottom).magnitude(); //向量求模
  var left_top_pt = leftTop.clone();
  var height = left_top_pt.subtract(leftBottom).magnitude();
  //    assert(Math.abs(width) > 0.00001);
  //    assert(Math.abs(height) > 0.00001);
  if (Math.abs(width) < 0.00001 || Math.abs(height) < 0.00001) {
    return;
  }
  var _signedx = 1;
  var _signedy = 1;
  var _minDis = Math.min(width, height);
  if (this.getDevOrientation() == 1 || this.getDevOrientation() == 2) {
    if (lgPts_[0].y > lgPts_[1].y) _signedy = -1;
    if ((this.m_arrYellowPoints[0].y - lgPts_[0].y - _signedy * _minDis / 2) * _signedy > 0) {
      this.m_arrYellowPoints[0].y = lgPts_[0].y + _signedy * _minDis / 2;
    } else if ((this.m_arrYellowPoints[0].y - lgPts_[0].y) * _signedy < 0) {
      this.m_arrYellowPoints[0].y = lgPts_[0].y;
    }
    this.m_arrYellowPoints[0].x = lgPts_[0].x;
  } else {
    if (lgPts_[0].x > lgPts_[1].x) _signedx = -1;
    if ((this.m_arrYellowPoints[0].x - lgPts_[0].x - _signedx * _minDis / 2) * _signedx > 0) {
      this.m_arrYellowPoints[0].x = lgPts_[0].x + _signedx * _minDis / 2;
    } else if ((this.m_arrYellowPoints[0].x - lgPts_[0].x) * _signedx < 0) {
      this.m_arrYellowPoints[0].x = lgPts_[0].x;
    }
    this.m_arrYellowPoints[0].y = lgPts_[0].y;
  }
};
MMRoundRectData.prototype.setYellowPtsAndIsClose = function (yellowPts_, isClose_) {
  var _lgPts = new Array();
  var arc = this.m_angle * Math.PI / 180;
  var leftBottom = this.m_arrCtrlPts[0].clone();
  var rightTop = null;
  var leftTop = null;
  var rightBottom = null;
  if (this.m_arrCtrlPts.length == 4) {
    rightTop = this.m_arrCtrlPts[2].clone();
    leftTop = this.m_arrCtrlPts[3].clone();
    rightBottom = this.m_arrCtrlPts[1].clone();
  } else if (this.m_arrCtrlPts.length == 8) {
    rightTop = this.m_arrCtrlPts[4].clone();
    leftTop = this.m_arrCtrlPts[6].clone();
    rightBottom = this.m_arrCtrlPts[2].clone();
  } else {
    //      assert(false);
    return;
  }
  var right_bottom_pt = rightBottom.clone();
  var width = right_bottom_pt.subtract(leftBottom).magnitude(); //向量求模
  var left_top_pt = leftTop.clone();
  var height = left_top_pt.subtract(leftBottom).magnitude();
  var _signedx = 1;
  var _signedy = 1;
  var _minDis = Math.min(width, height);
  var center = new _MMPoint["default"]((leftBottom.x + rightTop.x) / 2, (leftBottom.y + rightTop.y) / 2);
  if (Math.abs(this.m_angle) > 0.00001) {
    this.roatate(center, -arc);
    MMCommonFun.rotateAroundPts(yellowPts_, center, -arc);
    leftBottom = this.m_arrCtrlPts[0].clone();
    if (Math.abs(this.m_arrCtrlPts.length - 4) < 0.00001) {
      rightTop = this.m_arrCtrlPts[2].clone();
      leftTop = this.m_arrCtrlPts[3].clone();
      rightBottom = this.m_arrCtrlPts[1].clone();
    } else if (Math.abs(this.m_arrCtrlPts.length - 8) < 0.00001) {
      rightTop = this.m_arrCtrlPts[4].clone();
      leftTop = this.m_arrCtrlPts[6].clone();
      rightBottom = this.m_arrCtrlPts[2].clone();
    } else {
      //            assert(false);
      return;
    }
  }
  if (this.m_orientation.isLandscape()) {
    //重新计算图形的数据点
    _lgPts.push(rightBottom.clone());
    _lgPts.push(leftTop.clone());
    if (_lgPts[0].y > _lgPts[1].y) _signedy = -1;
    if ((yellowPts_[0].y - _lgPts[0].y) * _signedy < 0.000001) {
      yellowPts_[0].y = _lgPts[0].y;
    } else if ((yellowPts_[0].y - (_lgPts[0].y + _signedy * _minDis / 2)) * _signedy > 0.000001) {
      yellowPts_[0].y = _lgPts[0].y + _signedy * _minDis / 2;
    }
    yellowPts_[0].x = _lgPts[0].x;
  } else {
    //重新计算图形的数据点
    _lgPts.push(leftBottom.clone());
    _lgPts.push(rightTop.clone());
    if (_lgPts[0].x > _lgPts[1].x) _signedx = -1;
    if ((yellowPts_[0].x - _lgPts[0].x) * _signedx < 0.000001) {
      yellowPts_[0].x = _lgPts[0].x;
    } else if ((yellowPts_[0].x - (_lgPts[0].x + _signedx * _minDis / 2)) * _signedx > 0.000001) {
      yellowPts_[0].x = _lgPts[0].x + _signedx * _minDis / 2;
    }
    yellowPts_[0].y = _lgPts[0].y;
  }
  this.m_arrYellowPoints = new Array();
  this.m_arrYellowPoints = yellowPts_;
  var _newLgPts = this.calInitShapePts(_lgPts);
  this.setLogicPts(_newLgPts);
  if (Math.abs(this.m_angle) > 0.00001) {
    this.roatate(center, arc);
    MMCommonFun.rotateAroundPts(yellowPts_, center, arc);
  }
  this.m_isClose = isClose_;
};
var _default = exports["default"] = MMRoundRectData;

},{"1040":1040,"1084":1084,"1184":1184,"1454":1454,"830":830}],1050:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMCircleData = _interopRequireDefault(require(1040));
var _MMPoint = _interopRequireDefault(require(830));
var _ObjType = _interopRequireDefault(require(1084));
/**
 * @author lishusheng 2014-06-04
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMFivestarData}
 */

function MMFivestarData(board, init) {
  _MMCircleData["default"].call(this, board, init);
  this.m_className = 'MMFivestarData';
  this.m_objType = _ObjType["default"].GObj_fivestar;
  this.m_standardSize = new _MMPoint["default"](150, 75);
}
;
MMFivestarData.prototype = new _MMCircleData["default"]();
MMFivestarData.superclass = _MMCircleData["default"].prototype;
MMFivestarData.prototype.encode = function (enc_) {
  MMFivestarData.superclass.encode.call(this, enc_); //
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMFivestarData.prototype.decode = function (dec_, ver_) {
  MMFivestarData.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
var _default = exports["default"] = MMFivestarData;

},{"1040":1040,"1084":1084,"1184":1184,"1454":1454,"830":830}],1049:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMTextData = _interopRequireDefault(require(1072));
var _ObjType = _interopRequireDefault(require(1084));
var _MMPoint = _interopRequireDefault(require(830));
/**
 * @author lishusheng 2014-06-06
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMEmojiTextData}
 */
function MMEmojiTextData(board, init) {
  _MMTextData["default"].call(this, board, init); //
  this.m_className = 'MMEmojiTextData';
  this.m_objType = _ObjType["default"].GObj_emoji;
  this.m_canScale = false;
  this.m_bActive = false;
  this.m_standardSize = new _MMPoint["default"](45, 45);
}
;
MMEmojiTextData.prototype = new _MMTextData["default"](); //
MMEmojiTextData.superclass = _MMTextData["default"].prototype;
MMEmojiTextData.prototype.encode = function (enc_) {
  MMEmojiTextData.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMEmojiTextData.prototype.decode = function (dec_, ver_) {
  MMEmojiTextData.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
var _default = exports["default"] = MMEmojiTextData;

},{"1072":1072,"1084":1084,"1184":1184,"1454":1454,"830":830}],1072:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMBezierObjData = _interopRequireDefault(require(1037));
var _ObjType = _interopRequireDefault(require(1084));
var _MolaTextAlignment = _interopRequireDefault(require(817));
var _MMFont = _interopRequireDefault(require(815));
/**
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMTextData}
 */
function MMTextData(board) {
  _MMBezierObjData["default"].call(this, board); //
  this.m_className = 'MMTextData';
  this.m_objType = _ObjType["default"].GObj_text;
  this.m_width = 0; //float
  this.m_height = 0; //float
  this.m_shrink = 0; // const float
  this.m_delta = 0; //const float
  this.m_text = ""; //String

  this.m_autoResizeBox = true; // -------------------------------   是否允许系统自动调整文本框大小，自动调整不允许自动换行
  this.m_autoResizeFont = true; // ------------------------------   是否允许系统自动调整文本字体大小，使得文字不越出边界
  this.m_maxDevFontSize = true; // ---------------------------   自动调整文字字体大小时的最大文字字号
  this.m_maxTextAreaHeight = true; // ------------------------------   文字输入区的最大高度，当文字显示超过这个高度时，需要自动调整文字字号
  this.m_correlationGraphic = null; // MMObjData 由外边设置，本身不需要存储

  this.m_font = new _MMFont["default"](); //MMFont
  this.m_textAlignment = new _MolaTextAlignment["default"](0); //MolaTextAlignment
  this.m_autoFit = true; // boom_len
  this.m_pTextInputer = null; //MMTextInputer
  this.m_textHeightRatio = 0.0; //double

  this.m_minBoxSize = null; //MMDvPoint

  this.m_matchingRang = null; //vector<NSRange>
}
;
MMTextData.prototype = new _MMBezierObjData["default"](); //
MMTextData.superclass = _MMBezierObjData["default"].prototype; //

MMTextData.prototype.encode = function (enc_) {
  MMTextData.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
  enc_.encodeFloat(this.m_width);
  enc_.encodeFloat(this.m_height);
  enc_.encodeString(this.m_text);
  enc_.encodeMMFont(this.m_font);
  enc_.encodeMolaTextAlignment(this.m_textAlignment);
  enc_.encodeBool(this.m_autoResizeBox);
  enc_.encodeBool(this.m_autoResizeFont);
  enc_.encodeFloat(this.m_maxDevFontSize);
  enc_.encodeFloat(this.m_maxTextAreaHeight);
};
MMTextData.prototype.decode = function (dec_, ver_) {
  MMTextData.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
  this.m_width = dec_.decodeFromFloat(ver_);
  this.m_height = dec_.decodeFromFloat(ver_);
  this.m_text = dec_.decodeFromString(ver_);
  //console.log("decode text:" + this.m_text);

  this.m_font = dec_.decodeFromMMFont(ver_);
  this.m_textAlignment = dec_.decodeFromMolaTextAlignment(ver_);
  this.m_autoResizeBox = dec_.decodeFromBool(ver_);
  this.m_autoResizeFont = dec_.decodeFromBool(ver_);
  this.m_maxDevFontSize = dec_.decodeFromFloat(ver_);
  this.m_maxTextAreaHeight = dec_.decodeFromFloat(ver_);
  this.m_fillType.m_hasFill = true;

  //  this.changeAngleByDirection();

  //  console.log("text alginment ----->" + this.m_textAlignment.textAlignment);//�?�???��??
  //  console.log("font name:" + this.m_font.m_fontName);
};

/**
 * @param color {MMColor}
 */
MMTextData.prototype.setTextColor = function (color) {
  this.m_fillType.setFillColor(color);
};
MMTextData.prototype.getTextColor = function () {
  return this.m_fillType.getFillColor();
};
/**
 * @param text_ {string}
 */
MMTextData.prototype.setText = function (text_) {
  this.m_text = text_;
  //console.log("set text:" + this.m_text);
};
MMTextData.prototype.getText = function () {
  //console.log("get text:" + this.m_text);
  return this.m_text;
};

/**
 * @param font_ {MMFont}
 */
MMTextData.prototype.setLgFont = function (font_) {
  this.m_font = font_;
};
MMTextData.prototype.getLgFont = function () {
  return this.m_font;
};
/**
 * @param alignment_ {MolaTextAlignment}
 */
MMTextData.prototype.setAlignment = function (alignment_) {
  this.m_textAlignment.textAlignment = alignment_;
};
/**
 *
 * @returns {MolaTextAlignment}
 */
MMTextData.prototype.getAlignment = function () {
  return this.m_textAlignment;
};
MMTextData.prototype.setLogicPts = function (logicPts) {
  MMTextData.superclass.setLogicPts.call(this, logicPts);

  //  MMCommonFun.debugOutputArrPts("*** set text ctrl logic pts:", this.m_arrCtrlPts);
};
MMTextData.prototype.transform = function (option, basePt_, scale_, angleInfect_, alpha_, offset_) {
  //    console.log("----------------------transform before");
  //    this.m_rect.debugOutput(" text obj rect:");
  //  MMCommonFun.debugOutputArrPts("ctrl logic pts:", this.m_arrCtrlPts);

  var realScale = scale_.clone();
  MMTextData.superclass.transform.call(this, option, basePt_, scale_, angleInfect_, alpha_, offset_);
  //mashx:temporary code for now.
  if (!option) option = {
    m_updateAll: true
  };
  if (this.getClassName() == "MMTextData" && option.m_updateAll) {
    //        scaleFont(realScale);
    var font = this.getLgFont();
    font.m_fontSize = option.m_newFont;
    this.setLgFont(font);
  }

  //    console.log("----------------------transform after");
  //    this.m_rect.debugOutput(" text obj rect:");
  //  MMCommonFun.debugOutputArrPts("ctrl logic pts:", this.m_arrCtrlPts);

  return realScale;
};
MMTextData.prototype.move = function (offset_, moveAll_) {
  //    console.log("----------------------move before");
  //    this.m_rect.debugOutput(" text obj rect:");
  //  MMCommonFun.debugOutputArrPts("ctrl logic pts:", this.m_arrCtrlPts);

  MMTextData.superclass.move.call(this, offset_, moveAll_);

  //    console.log("----------------------move after");
  //    this.m_rect.debugOutput(" text obj rect:");
  //  MMCommonFun.debugOutputArrPts("ctrl logic pts:", this.m_arrCtrlPts);
};

/**
 * 将指定位置的文本替换为新的文本
 * @param range {MMRange} 位置信息（以字节为单位）
 * @param newStr {String}  新文本
 * @param rect {MMRect} 新矩形框
 * @param size {float} 新字体大小
 */
MMTextData.prototype.replaceText = function (range, newStr, rect, size) {
  //若是便签对象，需要重置便签的外接矩形
  if (this.m_correlationGraphic != null) {
    this.m_correlationGraphic.reSetGraphic(rect);
    this.reSetTextRect(rect);
  } else {
    this.reSetTextRect(rect);
  }
  this.m_font.m_fontSize = size;
  if (range.m_start <= this.m_text.length) {
    var r = range;
    if (range.m_start + range.m_len > this.m_text.length) {
      r.m_len = this.m_text.length - range.m_start;
    }
    //        this.m_text.replace(r.m_start, r.m_len, newStr);
    this.m_text = newStr;
  }
  this.rotateRectByDirection();
};
/**
 * @param rect {MMRect} 新矩形框
 */
MMTextData.prototype.reSetTextRect = function (rect_) {
  //  if(this.m_orientation.isLandscape()){
  //    rect_ = rect_.rotateAroundPt(rect_.getCenter(), -90);
  //  }

  var logicPts = rect_.getLogicPts();
  this.m_arrPoints = new Array();
  this.m_arrCtrlPts = new Array();
  this.setLogicPts(logicPts);
  var rect = this.getLogicRectFromSrcPts();
  this.m_arrCtrlPts = rect.getLogicPts(); //getImageCtlPts

  var _center = rect.getCenter();
  this.roatate(_center, this.m_angle * Math.PI / 180);
  this.m_rect = rect_;
  this.m_expandRect = MMCommonFun.getRect(this.m_arrCtrlPts);
  var expandNum = 0.078125 + this.m_strokeType.getLineWidth();
  this.m_expandRect.expand(expandNum, expandNum, expandNum, expandNum);
  this.rotateRectByDirection();

  //  console.log("******  reset Text Rect");
  //  MMCommonFun.debugOutputArrPts("ctl pts:", this.m_arrCtrlPts);
};
/**
 *
 * @param realtionGraphic_  {MMObjData}
 */
MMTextData.prototype.setCorrelationGraphic = function (realtionGraphic_) {
  this.m_correlationGraphic = realtionGraphic_;
};
MMTextData.prototype.isPtOn = function (pt, error) {
  return this._isPtInRect(pt);
};
var _default = exports["default"] = MMTextData;

},{"1037":1037,"1084":1084,"1184":1184,"1454":1454,"815":815,"817":817}],1048:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMBlockObjData = _interopRequireDefault(require(1038));
var _ObjType = _interopRequireDefault(require(1084));
/**
 * @author lishusheng 2014-06-05
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMDocumentData}
 */
function MMDocumentData(board, init) {
  _MMBlockObjData["default"].call(this, board, init); //
  this.m_className = 'MMDocumentData';
  this.m_objType = _ObjType["default"].Obj_Document;
  this.m_canScale = false;
  this.m_image = null;
  this.m_imageNext = null;
  this.m_vc = null;
  this.m_textObjName = null; //MMText
  this.m_textObjSize = null; //MMText

  this.m_fileSize = ""; //string
  this.m_filePath = ""; //string
  this.m_fileName = ""; //string
  this.m_fileType = ""; //string
}
;
MMDocumentData.prototype = new _MMBlockObjData["default"](); //
MMDocumentData.superclass = _MMBlockObjData["default"].prototype;
MMDocumentData.prototype.encode = function (enc_) {
  MMDocumentData.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
  this.m_textObjName.encode(enc_);
  this.m_textObjSize.encode(enc_);
  enc_.encodeString(this.m_filePath);
  enc_.encodeString(this.m_fileSize);
  enc_.encodeString(this.m_fileName);
  enc_.encodeString(this.m_fileType);
};
MMDocumentData.prototype.decode = function (dec_, ver_) {
  MMDocumentData.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
  if (this.m_textObjName == null) {
    this.m_textObjName = new MMText(this.m_board, true);
  }
  this.m_textObjName.decode(dec_, ver_);
  this.m_textObjName.setCorrelationGraphic(this);
  if (this.m_textObjSize == null) {
    this.m_textObjSize = new MMText(this.m_board, true);
  }
  this.m_textObjSize.decode(dec_, ver_);
  this.m_textObjSize.setCorrelationGraphic(this);
  this.m_filePath = dec_.decodeFromString(ver_);
  this.m_fileSize = dec_.decodeFromString(ver_);
  this.m_fileName = dec_.decodeFromString(ver_);
  this.m_fileType = dec_.decodeFromString(ver_);

  //  this.changeAngleByDirection();

  this.m_fillType.m_fillColor.m_alpha = 1;
};
var _default = exports["default"] = MMDocumentData;

},{"1038":1038,"1084":1084,"1184":1184,"1454":1454}],1047:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ObjType = _interopRequireDefault(require(1084));
var _MMCircleData = _interopRequireDefault(require(1040));
/**
 *
 */

function MMDocData(board) {
  _MMCircleData["default"].call(this, board); //
  this.m_className = 'MMDocData';
  this.m_objType = _ObjType["default"].Obj_doc;
  this.title = "file name";
  this.filesize = "1.3M";
}
;
MMDocData.prototype = new _MMCircleData["default"](); //
MMDocData.superclass = _MMCircleData["default"].prototype; //

MMDocData.prototype.encode = function (enc_) {
  MMDocData.superclass.encode.call(this, enc_); //
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMDocData.prototype.decode = function (dec_, ver_) {
  MMDocData.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
var _default = exports["default"] = MMDocData;

},{"1040":1040,"1084":1084,"1184":1184,"1454":1454}],1046:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMCircleData = _interopRequireDefault(require(1040));
var _MMPoint = _interopRequireDefault(require(830));
var _ObjType = _interopRequireDefault(require(1084));
/**
 * @author lishusheng 2014-06-04
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMDirectionArrowData}
 */

function MMDirectionArrowData(board, init) {
  _MMCircleData["default"].call(this, board, init);
  this.m_className = 'MMDirectionArrowData';
  this.m_objType = _ObjType["default"].GObj_directionarrow;
  this.m_standardSize = new _MMPoint["default"](150, 75);
}
;
MMDirectionArrowData.prototype = new _MMCircleData["default"]();
MMDirectionArrowData.superclass = _MMCircleData["default"].prototype;
MMDirectionArrowData.prototype.encode = function (enc_) {
  MMDirectionArrowData.superclass.encode.call(this, enc_); //
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMDirectionArrowData.prototype.decode = function (dec_, ver_) {
  MMDirectionArrowData.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
MMDirectionArrowData.prototype.calInitShapePts = function (lgPts) {
  var _shapePts = new Array();
  if (lgPts.length < 2) {
    return _shapePts;
  }
  if (this.m_orientation.isLandscape()) {
    _shapePts.push(new _MMPoint["default"](this.m_arrYellowPoints[0].x, lgPts[0].y));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x + lgPts[1].x - this.m_arrYellowPoints[0].x, lgPts[0].y));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x + lgPts[1].x - this.m_arrYellowPoints[0].x, this.m_arrYellowPoints[0].y));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x, this.m_arrYellowPoints[0].y));
    _shapePts.push(new _MMPoint["default"]((lgPts[0].x + lgPts[1].x) / 2, lgPts[1].y));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x, this.m_arrYellowPoints[0].y));
    _shapePts.push(this.m_arrYellowPoints[0].clone());
  } else {
    _shapePts.push(new _MMPoint["default"](lgPts[0].x, this.m_arrYellowPoints[0].y));
    _shapePts.push(new _MMPoint["default"](lgPts[0].x, lgPts[0].y + lgPts[1].y - this.m_arrYellowPoints[0].y));
    _shapePts.push(new _MMPoint["default"](this.m_arrYellowPoints[0].x, lgPts[0].y + lgPts[1].y - this.m_arrYellowPoints[0].y));
    _shapePts.push(new _MMPoint["default"](this.m_arrYellowPoints[0].x, lgPts[1].y));
    _shapePts.push(new _MMPoint["default"](lgPts[1].x, (lgPts[0].y + lgPts[1].y) / 2));
    _shapePts.push(new _MMPoint["default"](this.m_arrYellowPoints[0].x, lgPts[0].y));
    _shapePts.push(this.m_arrYellowPoints[0].clone());
  }
  return _shapePts;
};
var _default = exports["default"] = MMDirectionArrowData;

},{"1040":1040,"1084":1084,"1184":1184,"1454":1454,"830":830}],1045:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMGraphicsData = _interopRequireDefault(require(1052));
var _ObjType = _interopRequireDefault(require(1084));
function MMDiamondData(board, init) {
  _MMGraphicsData["default"].call(this, board, init);
  this.m_className = 'MMDiamondData';
  this.m_objType = _ObjType["default"].GObj_diamond;
}
;
MMDiamondData.prototype = new _MMGraphicsData["default"]();
MMDiamondData.superclass = _MMGraphicsData["default"].prototype;
MMDiamondData.prototype.encode = function (enc_) {
  MMDiamondData.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMDiamondData.prototype.decode = function (dec_, ver_) {
  MMDiamondData.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
var _default = exports["default"] = MMDiamondData;

},{"1052":1052,"1084":1084,"1184":1184,"1454":1454}],1052:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMYellowObjData = _interopRequireDefault(require(1074));
/**
 *
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMGraphicsData}
 */
function MMGraphicsData(board, init) {
  _MMYellowObjData["default"].call(this, board, init); //
}
;
MMGraphicsData.prototype = new _MMYellowObjData["default"](); //
MMGraphicsData.superclass = _MMYellowObjData["default"].prototype;
MMGraphicsData.prototype.encode = function (enc_) {
  MMGraphicsData.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMGraphicsData.prototype.decode = function (dec_, ver_) {
  MMGraphicsData.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
var _default = exports["default"] = MMGraphicsData;

},{"1074":1074,"1184":1184,"1454":1454}],1044:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMPointObjData = _interopRequireDefault(require(1062));
var _MMCommentBasicData = _interopRequireDefault(require(1043));
var _ObjType = _interopRequireDefault(require(1084));
/**
 *
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMCircleData}
 */

function MMCommentObjData(board, init) {
  _MMPointObjData["default"].call(this, board, init);
  this.commentBasicData = new _MMCommentBasicData["default"]();
  this.m_objType = _ObjType["default"].Obj_comment;
}
;
MMCommentObjData.prototype = new _MMPointObjData["default"]();
MMCommentObjData.superclass = _MMPointObjData["default"].prototype;
MMCommentObjData.prototype.encode = function (enc_) {
  MMCommentObjData.superclass.encode.call(this, enc_);
  this.commentBasicData.encode(enc_);
};
MMCommentObjData.prototype.decode = function (dec_, ver_) {
  MMCommentObjData.superclass.decode.call(this, dec_, ver_);
  this.commentBasicData.decode(dec_, ver_);
};

/**
 */
MMCommentObjData.prototype.isPtOn = function (pt, error) {
  return false;
};
MMCommentObjData.prototype.getReadStatus = function (userId) {
  var creator = this.getCreator();
  //  var status = MMCommentBasicData.getReadStatus(userId, creator);
  var status = this.commentBasicData.getReadStatus(userId, creator);
  return status;
};
MMCommentObjData.prototype.setReadStatus = function (userId, status_) {
  //  MMCommentBasicData.setReadStatus(userId, status_);
  this.commentBasicData.setReadStatus(userId, status_);
};
MMCommentObjData.prototype.setRead = function (usrId) {
  //  MMCommentBasicData.setRead(usrId);
  this.commentBasicData.setRead(usrId);
};
MMCommentObjData.prototype.setHasNewReplyFromUser = function (replier) {
  //  MMCommentBasicData.setHasNewReplyFromUser(replier);
  this.commentBasicData.setHasNewReplyFromUser(replier);
};
MMCommentObjData.prototype.praise = function (userId_) {
  //  MMCommentBasicData.praise(userId_);
  this.commentBasicData.praise(userId_);
};
MMCommentObjData.prototype.unPraise = function (userId_) {
  //  MMCommentBasicData.unPraise(userId_);
  this.commentBasicData.unPraise(userId_);
};
MMCommentObjData.prototype.isPraised = function (userId_) {
  //  return MMCommentBasicData.isPraised(userId_);
  return this.commentBasicData.isPraised(userId_);
};
MMCommentObjData.prototype.setFinished = function (finished_) {
  //  MMCommentBasicData.setFinished(finished_);
  this.commentBasicData.setFinished(finished_);
};
MMCommentObjData.prototype.isFinished = function () {
  //  return MMCommentBasicData.isFinished();
  return this.commentBasicData.isFinished();
};
MMCommentObjData.prototype.setVisibleScope = function (scope) {
  //  MMCommentBasicData.setFinished(finished_);
  this.commentBasicData.setVisibleScope(scope);
};
MMCommentObjData.prototype.getVisibleScope = function () {
  //  return MMCommentBasicData.isFinished();
  return this.commentBasicData.getVisibleScope();
};
MMCommentObjData.prototype.getScopeDispStr = function () {
  return this.commentBasicData.getScopeDispStr();
};
var _default = exports["default"] = MMCommentObjData;

},{"1043":1043,"1062":1062,"1084":1084,"1184":1184,"1454":1454}],1062:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMObjectData = _interopRequireDefault(require(1082));
var _MMPoint = _interopRequireDefault(require(830));
var _MMRect = _interopRequireDefault(require(831));
/**
 *
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMCircleData}
 */
function MMPointObjData(board, init) {
  _MMObjectData["default"].call(this, board, init); //

  this.m_pos = new _MMPoint["default"](0, 0);
}
;
MMPointObjData.prototype = new _MMObjectData["default"](); //
MMPointObjData.superclass = _MMObjectData["default"].prototype;
MMPointObjData.prototype.encode = function (enc_) {
  MMPointObjData.superclass.encode.call(this, enc_);
  var objVer = 0;
  enc_.encode4Bytes(objVer);
  enc_.encodeMMPoint(this.m_pos);
};
MMPointObjData.prototype.decode = function (dec_, ver_) {
  MMPointObjData.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_pos = dec_.decodeFromMMPoint(ver_);
  var lgRect = new _MMRect["default"](this.m_pos.y - POINT_SIZE, this.m_pos.x + POINT_SIZE, this.m_pos.y + POINT_SIZE, this.m_pos.x - POINT_SIZE);
  this.m_rect = lgRect;
  this.m_expandRect = lgRect;

  // console.count("decode label")
};
MMPointObjData.prototype.isPtOn = function (pt, error) {
  return false;
};
var _default = exports["default"] = MMPointObjData;

},{"1082":1082,"1184":1184,"1454":1454,"830":830,"831":831}],1042:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMPoint = _interopRequireDefault(require(830));
var _MMCircleData = _interopRequireDefault(require(1040));
var _ObjType = _interopRequireDefault(require(1084));
/**
 * @author lishusheng 2014-06-04
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMCloudData}
 */

function MMCloudData(board, init) {
  _MMCircleData["default"].call(this, board, init);
  this.m_className = 'MMCloudData';
  this.m_objType = _ObjType["default"].GObj_cloud;
  this.m_standardSize = new _MMPoint["default"](145, 100);
}
;
MMCloudData.prototype = new _MMCircleData["default"]();
MMCloudData.superclass = _MMCircleData["default"].prototype;
MMCloudData.prototype.encode = function (enc_) {
  MMCloudData.superclass.encode.call(this, enc_); //
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMCloudData.prototype.decode = function (dec_, ver_) {
  MMCloudData.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
var _default = exports["default"] = MMCloudData;

},{"1040":1040,"1084":1084,"1184":1184,"1454":1454,"830":830}],1041:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _vec = _interopRequireDefault(require(839));
var _MMCircleData = _interopRequireDefault(require(1040));
var _MMPoint = _interopRequireDefault(require(830));
var _ObjType = _interopRequireDefault(require(1084));
var _MMCommonFun = _interopRequireDefault(require(812));
/**
 * @author lishusheng 2014-06-04
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMCircleMarkData}
 */
function MMCircleMarkData(board, init) {
  _MMCircleData["default"].call(this, board, init);
  this.m_className = 'MMCircleMarkData';
  this.m_objType = _ObjType["default"].GObj_circlemark;
  this.m_standardSize = new _MMPoint["default"](150, 120);
}
;
MMCircleMarkData.prototype = new _MMCircleData["default"]();
MMCircleMarkData.superclass = _MMCircleData["default"].prototype;
MMCircleMarkData.prototype.encode = function (enc_) {
  MMCircleMarkData.superclass.encode.call(this, enc_); //
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMCircleMarkData.prototype.decode = function (dec_, ver_) {
  MMCircleMarkData.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
MMCircleMarkData.prototype.setLogicPtsForSelf = function (logicPts) {
  this.m_arrPoints = new Array();
  this.m_arrPoints = this.calInitShapePts(logicPts);
  if (this.m_arrCtrlPts.length == 0) this.m_arrCtrlPts = this.m_rect.getCtrlPts();

  // 计算每个点相对于控制点的相对位移
  this.m_arrOffset = new Array();
  this.m_arrYellowOffset = new Array();
  if (this.m_arrCtrlPts.length == 0) {
    return;
  }
  var left_bottom = this.m_arrCtrlPts[0].clone();
  var right_top;
  if (this.m_arrCtrlPts.length == 4) {
    right_top = this.m_arrCtrlPts[2].clone();
  } else if (this.m_arrCtrlPts.length == 8) {
    right_top = this.m_arrCtrlPts[4].clone();
  } else {
    return;
  }
  var width = right_top.x - left_bottom.x;
  var height = right_top.y - left_bottom.y;
  //    assert(Math.abs(width) > 0.00001);
  //    assert(Math.abs(height) > 0.00001);
  if (Math.abs(width) < 0.00001 || Math.abs(height) < 0.00001) {
    return;
  }
  for (var i = 0; i < this.m_arrPoints.length; i++) {
    var offset = new _MMPoint["default"]();
    offset.x = (this.m_arrPoints[i].x - left_bottom.x) / width;
    offset.y = (this.m_arrPoints[i].y - left_bottom.y) / height;
    this.m_arrOffset.push(offset);
  }
  for (var i = 0; i < this.m_arrYellowPoints.length; i++) {
    var offset = new _MMPoint["default"]();
    offset.x = (this.m_arrYellowPoints[i].x - left_bottom.x) / width;
    offset.y = (this.m_arrYellowPoints[i].y - left_bottom.y) / height;
    this.m_arrYellowOffset.push(offset);
  }
};
MMCircleMarkData.prototype.calcStardardRect = function () {
  MMCircleMarkData.superclass.calcStardardRect.call(this);
  this.m_expandRect = _MMCommonFun["default"].getRect(this.m_arrPoints);
  var delta = this.m_strokeType.m_lineWidth + 0.078125;
  this.m_expandRect.expand(delta, delta, delta, delta);
  var object = this.getObject();
  object.setExpandRect(this.m_expandRect);
};
MMCircleMarkData.prototype.setYellowPtsAndIsClose = function (yellowPts_, isClose_) {
  MMCircleMarkData.superclass.setYellowPtsAndIsClose.call(this, yellowPts_, isClose_);
  this.calcStardardRect();
};
MMCircleMarkData.prototype.transform = function (option, basePt_,
// 参考点 MMLgPoint
scale_,
// 拉伸比例 MMLgPoint
angleInfect_,
// 缩放时是否受原有角度影响？在多个对象同时被选中拉伸时，此参数置为 false
alpha_,
// 相对旋转角度(0, 360) float
offset_ // 相对位移 MMLgPoint
) {
  angleInfect_ = true;
  MMCircleMarkData.superclass.transform.call(this, option, basePt_, scale_, angleInfect_, alpha_, offset_);
};
MMCircleMarkData.prototype.updatePtsFromCtlPts = function () {
  if (this.m_arrCtrlPts.length == 0) {
    return;
  }
  var leftBottom = this.m_arrCtrlPts[0].clone();
  var rightTop = null;
  var leftTop = null;
  var rightBottom = null;
  if (this.m_arrCtrlPts.length == 4) {
    rightTop = this.m_arrCtrlPts[2].clone();
    leftTop = this.m_arrCtrlPts[3].clone();
    rightBottom = this.m_arrCtrlPts[1].clone();
  } else if (this.m_arrCtrlPts.length == 8) {
    rightTop = this.m_arrCtrlPts[4].clone();
    leftTop = this.m_arrCtrlPts[6].clone();
    rightBottom = this.m_arrCtrlPts[2].clone();
  } else {
    console.assert(false);
    return;
  }

  //////
  var right_bottom_pt = rightBottom.clone();
  var width = right_bottom_pt.subtract(leftBottom).magnitude(); //向量求模
  var left_top_pt = leftTop.clone();
  var height = left_top_pt.subtract(leftBottom).magnitude();
  //    assert(Math.abs(width) > 0.00001);
  //    assert(Math.abs(height) > 0.00001);
  if (Math.abs(width) < 0.00001 || Math.abs(height) < 0.00001) {
    return;
  }
  right_bottom_pt = rightBottom.clone();
  var iv = right_bottom_pt.subtract(leftBottom).normalize(); // i 方向的单位向量
  left_top_pt = leftTop.clone();
  var jv = left_top_pt.subtract(leftBottom).normalize(); // j 方向的单位向量

  for (var i = 0; i < this.m_arrYellowOffset.length; i++) {
    var pt = leftBottom.clone();
    var iv_clone = iv.clone();
    var jv_clone = jv.clone();
    pt.add(iv_clone.scale(width * this.m_arrYellowOffset[i].x)).add(jv_clone.scale(height * this.m_arrYellowOffset[i].y));
    this.m_arrYellowPoints.push(pt);
  }

  //重置图形的形状数据
  var _lgPts = new Array();
  _lgPts.push(leftBottom.clone());
  _lgPts.push(rightTop.clone());
  this.setLogicPtsForSelf(_lgPts);
};
MMCircleMarkData.prototype.calInitShapePts = function (lgPts_) {
  var _shapePts = new Array();
  if (lgPts_.length < 2) {
    return _shapePts;
  }
  //获得语音泡泡的椭圆
  _shapePts = MMCircleMarkData.superclass.calInitShapePts.call(this, lgPts_);
  //获得椭圆的圆心坐标
  var _center = new _MMPoint["default"]((lgPts_[0].x + lgPts_[1].x) / 2, (lgPts_[0].y + lgPts_[1].y) / 2);
  //获得黄点与圆心所在的直线与Ｘ轴正方向的夹角
  var vector = new _vec["default"](1, 0);
  var vector1 = new _vec["default"](this.m_arrYellowPoints[0].x - _center.x, this.m_arrYellowPoints[0].y - _center.y);
  var _arc = vector.angleBetweenVector(vector1);
  //获得椭圆的横轴半径与纵轴半径
  var _radiusx = Math.abs(lgPts_[1].x - lgPts_[0].x) / 2;
  var _radiusy = Math.abs(lgPts_[1].y - lgPts_[0].y) / 2;
  //设定一个误差，判定点是否在椭圆内的误差
  var _err = 0.000001;
  //判断黄点是否在椭圆内，如果在则直接返加椭圆数据
  if (Math.pow((_center.x - this.m_arrYellowPoints[0].x) / _radiusx, 2) + Math.pow((_center.y - this.m_arrYellowPoints[0].y) / _radiusy, 2) - 1 <= _err) {
    _shapePts = MMCircleMarkData.superclass.calInitShapePts.call(this, lgPts_);
  } else {
    _shapePts = new Array();
    //设定一个角度，确定椭圆的一个开口，高定为30度。
    var _arc1 = _arc + Math.PI / 18;
    var _arc2 = _arc + Math.PI / 18 * 35;
    //获得圆上开口的两个端点坐标
    var _startPt = new _MMPoint["default"](_center.x + _radiusx * Math.cos(_arc1), _center.y + _radiusy * Math.sin(_arc1));
    var _endPt = new _MMPoint["default"](_center.x + _radiusx * Math.cos(_arc2), _center.y + _radiusy * Math.sin(_arc2));
    //计算椭圆的数据点坐标
    _shapePts = _MMCommonFun["default"].getArcControlPts(_center, _startPt, _endPt, _radiusx, _radiusy);
    _shapePts.push(this.m_arrYellowPoints[0].clone());
    _shapePts.push(this.m_arrYellowPoints[0].clone());
    _shapePts.push(this.m_arrYellowPoints[0].clone());
  }
  return _shapePts;
};
var _default = exports["default"] = MMCircleMarkData;

},{"1040":1040,"1084":1084,"1184":1184,"1454":1454,"812":812,"830":830,"839":839}],1040:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMYellowObjData = _interopRequireDefault(require(1074));
var _MMPoint = _interopRequireDefault(require(830));
/**
 *
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMCircleData}
 */
function MMCircleData(board, init) {
  _MMYellowObjData["default"].call(this, board, init); //
}
;
MMCircleData.prototype = new _MMYellowObjData["default"](); //
MMCircleData.superclass = _MMYellowObjData["default"].prototype;
MMCircleData.prototype.encode = function (enc_) {
  MMCircleData.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMCircleData.prototype.decode = function (dec_, ver_) {
  MMCircleData.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
MMCircleData.prototype.calInitShapePts = function (lgPts_) {
  var _shapePts = new Array();
  var _lgPts = new Array();
  if (lgPts_.length < 2) {
    return _shapePts;
  }
  var _d = (Math.sqrt(2) - 1) * 4 / 3;
  for (var i = 0; i < lgPts_.length; i++) {
    _lgPts.push(lgPts_[i].clone());
  }
  if (_lgPts[0].x >= _lgPts[1].x) {
    _lgPts[0].x = _lgPts[0].x + _lgPts[1].x;
    _lgPts[1].x = _lgPts[0].x - _lgPts[1].x;
    _lgPts[0].x = _lgPts[0].x - _lgPts[1].x;
  }
  if (_lgPts[0].y >= _lgPts[1].y) {
    _lgPts[0].y = _lgPts[0].y + _lgPts[1].y;
    _lgPts[1].y = _lgPts[0].y - _lgPts[1].y;
    _lgPts[0].y = _lgPts[0].y - _lgPts[1].y;
  }
  var _midx = (_lgPts[0].x + _lgPts[1].x) / 2;
  var _midy = (_lgPts[0].y + _lgPts[1].y) / 2;
  var _radiusx = Math.abs(_lgPts[0].x - _lgPts[1].x) / 2 * _d;
  var _radiusy = Math.abs(_lgPts[0].y - _lgPts[1].y) / 2 * _d;
  _shapePts.push(new _MMPoint["default"](_lgPts[0].x, _midy - _radiusy));
  _shapePts.push(new _MMPoint["default"](_lgPts[0].x, _midy));
  _shapePts.push(new _MMPoint["default"](_lgPts[0].x, _midy + _radiusy));
  _shapePts.push(new _MMPoint["default"](_midx - _radiusx, _lgPts[1].y));
  _shapePts.push(new _MMPoint["default"](_midx, _lgPts[1].y));
  _shapePts.push(new _MMPoint["default"](_midx + _radiusx, _lgPts[1].y));
  _shapePts.push(new _MMPoint["default"](_lgPts[1].x, _midy + _radiusy));
  _shapePts.push(new _MMPoint["default"](_lgPts[1].x, _midy));
  _shapePts.push(new _MMPoint["default"](_lgPts[1].x, _midy - _radiusy));
  _shapePts.push(new _MMPoint["default"](_midx + _radiusx, _lgPts[0].y));
  _shapePts.push(new _MMPoint["default"](_midx, _lgPts[0].y));
  _shapePts.push(new _MMPoint["default"](_midx - _radiusx, _lgPts[0].y));
  return _shapePts;
};
var _default = exports["default"] = MMCircleData;

},{"1074":1074,"1184":1184,"1454":1454,"830":830}],1039:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMSegmentData = _interopRequireDefault(require(1069));
var _ObjType = _interopRequireDefault(require(1084));
/**
 * @author lishusheng 2014-06-05
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMBrokenLineData}
 */
function MMBrokenLineData(board, init) {
  _MMSegmentData["default"].call(this, board, init); //
  this.m_className = 'MMBrokenLineData';
  this.m_objType = _ObjType["default"].GObj_brokenline;
}
;
MMBrokenLineData.prototype = new _MMSegmentData["default"](); //
MMBrokenLineData.superclass = _MMSegmentData["default"].prototype;
MMBrokenLineData.prototype.encode = function (enc_) {
  MMBrokenLineData.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMBrokenLineData.prototype.decode = function (dec_, ver_) {
  MMBrokenLineData.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
var _default = exports["default"] = MMBrokenLineData;

},{"1069":1069,"1084":1084,"1184":1184,"1454":1454}],1069:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMYellowObjData = _interopRequireDefault(require(1074));
var _ObjType = _interopRequireDefault(require(1084));
var _MMPoint = _interopRequireDefault(require(830));
/**
 * @author lishusheng 2014-06-05
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMSegmentData}
 */
function MMSegmentData(board, init) {
  _MMYellowObjData["default"].call(this, board, init); //
  this.m_className = 'MMSegmentData';
  this.m_objType = _ObjType["default"].GObj_line;
}
;
MMSegmentData.prototype = new _MMYellowObjData["default"](); //
MMSegmentData.superclass = _MMYellowObjData["default"].prototype;
MMSegmentData.prototype.encode = function (enc_) {
  MMSegmentData.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
};
MMSegmentData.prototype.decode = function (dec_, ver_) {
  MMSegmentData.superclass.decode.call(this, dec_, ver_);
  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
};
MMSegmentData.prototype._setLogicPtsWithYellowPts = function () {
  var _rect = this.getLogicRectFromSrcPts();
  this.m_arrCtrlPts = new Array();
  this.m_arrCtrlPts = _rect.getCtrlPts();

  // 计算每个点相对于控制点的相对位移
  this.m_arrOffset = new Array();
  this.m_arrYellowOffset = new Array();
  if (this.m_arrCtrlPts.length == 0) {
    return;
  }
  //获得矩形的左上角点跟右下角点，左上角点默认为角点0 。
  var left_bottom = this.m_arrCtrlPts[0].clone();
  var right_top;
  if (this.m_arrCtrlPts.length == 4) {
    right_top = this.m_arrCtrlPts[2].clone();
  } else if (this.m_arrCtrlPts.length == 8) {
    right_top = this.m_arrCtrlPts[4].clone();
  } else {
    return;
  }
  var width = right_top.x - left_bottom.x;
  var height = right_top.y - left_bottom.y;

  //计算每个点相对于左上角点的偏移量
  for (var i = 0; i < this.m_arrPoints.length; i++) {
    var offset = new _MMPoint["default"]();
    if (Math.abs(width) < 0.000001) {
      offset.x = 0;
    } else {
      offset.x = (this.m_arrPoints[i].x - left_bottom.x) / width;
    }
    if (Math.abs(height < 0.000001)) {
      offset.y = 0;
    } else {
      offset.y = (this.m_arrPoints[i].y - left_bottom.y) / height;
    }
    this.m_arrOffset.push(offset);
  }
  for (var i = 0; i < this.m_arrYellowPoints.length; i++) {
    var offset = new _MMPoint["default"]();
    if (Math.abs(width) < 0.000001) {
      offset.x = 0;
    } else {
      offset.x = (this.m_arrYellowPoints[i].x - left_bottom.x) / width;
    }
    if (Math.abs(height < 0.000001)) {
      offset.y = 0;
    } else {
      offset.y = (this.m_arrYellowPoints[i].y - left_bottom.y) / height;
    }
    this.m_arrYellowOffset.push(offset);
  }
  this.m_expandRect = this.m_rect = MMCommonFun.getRect(this.m_arrPoints);
  var delta = this.m_strokeType.getLineWidth() + 0.078125;
  this.m_expandRect.expand(delta, delta, delta, delta);
  this.m_angle = 0;
};
MMSegmentData.prototype.setLogicPts = function (logicPts) {
  this.m_arrPoints = new Array();
  this.m_arrYellowPoints = new Array();
  for (var i = 0; i < logicPts.length; i++) {
    this.m_arrPoints.push(logicPts[i].clone());
    this.m_arrYellowPoints.push(logicPts[i].clone());
  }
  //重新设置点的offset
  this._setLogicPtsWithYellowPts();
};
MMSegmentData.prototype.setYellowPtsAndIsClose = function (yellowPts_, isClose_) {
  this.m_arrYellowPoints = new Array();
  this.m_arrPoints = new Array();
  for (var i = 0; i < yellowPts_.length; i++) {
    this.m_arrYellowPoints.push(yellowPts_[i].clone());
    this.m_arrPoints.push(yellowPts_[i].clone());
  }
  this.m_isClose = isClose_;

  //重新设置点的offset
  this._setLogicPtsWithYellowPts();
};
MMSegmentData.prototype.setDevPts = function (trsfm_, devPts_, pageIndex_) {
  MMSegmentData.superclass.setDevPts.call(this, trsfm_, devPts_, pageIndex_);
  if (devPts_.length < 2) {
    return;
  }
  var _lgPts = trsfm_.dv2lgPoints(devPts_, pageIndex_);
  this.m_expandRect = this.m_rect = MMCommonFun.getRect(_lgPts);
  var _error = trsfm_.dv2lgPoint(4);
  //this.m_expandRect.expand(_error + m_strokeType.getLineWidth());

  this.setLogicPts(_lgPts);
  this.setPageIndex(pageIndex_);
};
var _default = exports["default"] = MMSegmentData;

},{"1074":1074,"1084":1084,"1184":1184,"1454":1454,"830":830}],1074:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMBezierObjData = _interopRequireDefault(require(1037));
var _MMPoint = _interopRequireDefault(require(830));
/**
 *
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMCircleData}
 */
function MMYellowObjData(board, init) {
  _MMBezierObjData["default"].call(this, board, init); //
  this.m_arrYellowPoints = new Array();
  this.m_arrYellowOffset = new Array();
}
;
MMYellowObjData.prototype = new _MMBezierObjData["default"](); //
MMYellowObjData.superclass = _MMBezierObjData["default"].prototype;
MMYellowObjData.prototype.encode = function (enc_) {
  MMYellowObjData.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
  enc_.encodeArray(this.m_arrYellowPoints, 'MMPoint');
  enc_.encodeArray(this.m_arrYellowOffset, 'MMPoint');
};
MMYellowObjData.prototype.decode = function (dec_, ver_) {
  MMYellowObjData.superclass.decode.call(this, dec_, ver_);
  var _objVer = 0;
  _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_arrYellowPoints = dec_.decodeFromArray(ver_, 'MMPoint');
  this.m_arrYellowOffset = dec_.decodeFromArray(ver_, 'MMPoint');
};
MMYellowObjData.prototype.updatePtsFromCtlPts = function () {
  MMYellowObjData.superclass.updatePtsFromCtlPts.call(this);
  var leftBottom = this.m_arrCtrlPts[0].clone();
  var rightTop = null;
  var leftTop = null;
  var rightBottom = null;
  if (this.m_arrCtrlPts.length == 4) {
    rightTop = this.m_arrCtrlPts[2].clone();
    leftTop = this.m_arrCtrlPts[3].clone();
    rightBottom = this.m_arrCtrlPts[1].clone();
  } else if (this.m_arrCtrlPts.length == 8) {
    rightTop = this.m_arrCtrlPts[4].clone();
    leftTop = this.m_arrCtrlPts[6].clone();
    rightBottom = this.m_arrCtrlPts[2].clone();
  } else {
    //        assert(false);
    return;
  }

  //////
  var right_bottom_pt = rightBottom.clone();
  var width = right_bottom_pt.subtract(leftBottom).magnitude(); //向量求模
  var left_top_pt = leftTop.clone();
  var height = left_top_pt.subtract(leftBottom).magnitude();
  //    assert(fabs(width) > 0.00001);
  //    assert(fabs(height) > 0.00001);
  right_bottom_pt = rightBottom.clone();
  var iv = right_bottom_pt.subtract(leftBottom).normalize(); // i 方向的单位向量
  left_top_pt = leftTop.clone();
  var jv = left_top_pt.subtract(leftBottom).normalize(); // j 方向的单位向量

  for (var i = 0; i < this.m_arrYellowOffset.length; i++) {
    var pt = leftBottom.clone();
    var iv_clone = iv.clone();
    var jv_clone = jv.clone();
    pt.add(iv_clone.scale(width * this.m_arrYellowOffset[i].x)).add(jv_clone.scale(height * this.m_arrYellowOffset[i].y));
    this.m_arrYellowPoints.push(pt);
  }
};
MMYellowObjData.prototype.transform = function (option, basePt_,
// 参考点 MMLgPoint
scale_,
// 拉伸比例 MMLgPoint
angleInfect_,
// 缩放时是否受原有角度影响？在多个对象同时被选中拉伸时，此参数置为 false
alpha_,
// 相对旋转角度(0, 360) float
offset_ // 相对位移 MMLgPoint
) {
  this.m_arrYellowPoints = new Array();
  return MMYellowObjData.superclass.decode.call(this, option, basePt_, scale_, angleInfect_, alpha_, offset_);
};
MMYellowObjData.prototype.move = function (offset_, moveAll_) {
  MMYellowObjData.superclass.move.call(this, offset_, moveAll_);
  if (moveAll_) {
    for (var i = 0; i < this.m_arrYellowPoints.length; i++) {
      this.m_arrYellowPoints[i].x += offset_.x;
      this.m_arrYellowPoints[i].y += offset_.y;
    }
  }
};
MMYellowObjData.prototype.rotate = function (alpha_, rotateAll_) {
  MMYellowObjData.superclass.rotate.call(this, alpha_, rotateAll_);
  var arc = alpha_ * Math.PI / 180;
  var cos = Math.cos(arc);
  var sin = Math.sin(arc);
  var x, y;
  if (rotateAll_) {
    for (var i = 0; i < this.m_arrYellowPoints.length; i++) {
      x = this.m_arrYellowPoints[i].x;
      y = this.m_arrYellowPoints[i].y;
      this.m_arrYellowPoints[i].x = x * cos - y * sin;
      this.m_arrYellowPoints[i].y = y * cos + x * sin;
    }
  }
};
MMYellowObjData.prototype.setLogicPts = function (logicPts) {
  MMYellowObjData.superclass.setLogicPts.call(this, logicPts);
  this.m_arrYellowOffset = [];
  if (this.m_arrCtrlPts.length == 0) {
    return;
  }
  var left_bottom = this.m_arrCtrlPts[0];
  var right_top;
  if (this.m_arrCtrlPts.length == 4) {
    right_top = this.m_arrCtrlPts[2];
  } else if (this.m_arrCtrlPts.length == 8) {
    right_top = this.m_arrCtrlPts[4];
  } else {
    console.assert(false);
    return;
  }
  var width = right_top.x - left_bottom.x;
  var height = right_top.y - left_bottom.y;
  for (var i = 0; i < this.m_arrYellowPoints.length; i++) {
    var p = this.m_arrYellowPoints[i];
    var offset = new _MMPoint["default"]();
    ;
    offset.x = (p.x - left_bottom.x) / width;
    offset.y = (p.y - left_bottom.y) / height;
    this.m_arrYellowOffset.push(offset);
  }
};
var _default = exports["default"] = MMYellowObjData;

},{"1037":1037,"1184":1184,"1454":1454,"830":830}],1037:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMBlockObjData = _interopRequireDefault(require(1038));
var _ObjType = _interopRequireDefault(require(1084));
var _MMPoint = _interopRequireDefault(require(830));
/**
 *
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMCircleData}
 */
function MMBezierObjData(board, init) {
  _MMBlockObjData["default"].call(this, board, init); //

  this.m_arrPoints = new Array();
  this.m_arrOffset = new Array(); // ------------------ 记录每个点相对于 4 角控制点的相对位置，以第 0 个控制点为基准

  this.m_strokeType.m_hasBoard = true;
}
;
MMBezierObjData.prototype = new _MMBlockObjData["default"](); //
MMBezierObjData.superclass = _MMBlockObjData["default"].prototype;
MMBezierObjData.prototype.initBy = function (obj) {
  MMBezierObjData.superclass.initBy.call(this, obj);
  this.m_arrPoints = [];
  for (var i = 0; i < obj.m_arrPoints.length; i++) {
    this.m_arrPoints.push(obj.m_arrPoints[i].clone());
  }
  ;
  this.m_arrOffset = [];
  for (var i = 0; i < obj.m_arrOffset.length; i++) {
    this.m_arrOffset.push(obj.m_arrOffset[i].clone());
  }
  ;
  this.m_strokeType.m_hasBoard = obj.m_strokeType.m_hasBoard;
};
MMBezierObjData.prototype.encode = function (enc_) {
  MMBezierObjData.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
  enc_.encodeArray(this.m_arrPoints, 'MMPoint');
  enc_.encodeArray(this.m_arrOffset, 'MMPoint');
};
MMBezierObjData.prototype.decode = function (dec_, ver_) {
  MMBezierObjData.superclass.decode.call(this, dec_, ver_);
  var _objVer = 0;
  _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_arrPoints = dec_.decodeFromArray(ver_, 'MMPoint');
  this.m_arrOffset = dec_.decodeFromArray(ver_, 'MMPoint');
};
MMBezierObjData.prototype.updatePtsFromCtlPts = function () {
  MMBezierObjData.superclass.updatePtsFromCtlPts.call(this);
  var leftBottom = this.m_arrCtrlPts[0].clone();
  var rightTop = null;
  var leftTop = null;
  var rightBottom = null;
  if (this.m_arrCtrlPts.length == 4) {
    rightTop = this.m_arrCtrlPts[2].clone();
    leftTop = this.m_arrCtrlPts[3].clone();
    rightBottom = this.m_arrCtrlPts[1].clone();
  } else if (this.m_arrCtrlPts.length == 8) {
    rightTop = this.m_arrCtrlPts[4].clone();
    leftTop = this.m_arrCtrlPts[6].clone();
    rightBottom = this.m_arrCtrlPts[2].clone();
  } else {
    //        assert(false);
    return;
  }

  //////
  var right_bottom_pt = rightBottom.clone();
  var width = right_bottom_pt.subtract(leftBottom).magnitude(); //向量求模
  var left_top_pt = leftTop.clone();
  var height = left_top_pt.subtract(leftBottom).magnitude();
  //    assert(fabs(width) > 0.00001);
  //    assert(fabs(height) > 0.00001);
  right_bottom_pt = rightBottom.clone();
  var iv = right_bottom_pt.subtract(leftBottom).normalize(); // i 方向的单位向量
  left_top_pt = leftTop.clone();
  var jv = left_top_pt.subtract(leftBottom).normalize(); // j 方向的单位向量

  for (var i = 0; i < this.m_arrOffset.length; i++) {
    var pt = leftBottom.clone();
    var iv_clone = iv.clone();
    var jv_clone = jv.clone();
    pt.add(iv_clone.scale(width * this.m_arrOffset[i].x)).add(jv_clone.scale(height * this.m_arrOffset[i].y)); //向量加法
    this.m_arrPoints.push(pt);
  }
};
MMBezierObjData.prototype.transformWithArrPoints = function (scale_) {
  // 4. 根据相对位移重新计算对象的点
  this.m_arrPoints = new Array();
  if (this.m_arrOffset.length == 0) {
    return scale_;
  }
};
MMBezierObjData.prototype.moveWithArrPoints = function (offset_, moveAll_) {
  var _moveAll = moveAll_ ? moveAll_ : true;
  if (_moveAll) {
    for (var i = 0; i < this.m_arrPoints.length; i++) {
      this.m_arrPoints[i].x += offset_.x;
      this.m_arrPoints[i].y += offset_.y;
    }
  }
};
MMBezierObjData.prototype.rotateWithArrPoints = function (alpha_, rotateAll_) {
  var _rotateAll = rotateAll_ ? rotateAll_ : true;
  var arc = alpha_ * Math.PI / 180;
  var cos = Math.cos(arc);
  var sin = Math.sin(arc);
  var x, y;
  if (_rotateAll) {
    for (var i = 0; i < this.m_arrPoints.length; i++) {
      x = this.m_arrPoints[i].x;
      y = this.m_arrPoints[i].y;
      this.m_arrPoints[i].x = x * cos - y * sin;
      this.m_arrPoints[i].y = y * cos + x * sin;
    }
  }
};
MMBezierObjData.prototype.isPtOn = function (pt, error) {
  var size = this.m_arrPoints.length;
  for (var i = 0; i < size; i++) {
    if (MMCommonFun.isOnSegment(this.m_arrPoints[i], this.m_arrPoints[(i + 1) % size], pt, 5 * error)) {
      return true;
    }
  }
  return false;
};
MMBezierObjData.prototype.getLogicRectFromSrcPts = function () {
  return MMCommonFun.getRect(this.m_arrPoints);
};
MMBezierObjData.prototype.getLogicPts = function () {
  return this.m_arrPoints;
};
MMBezierObjData.prototype.setLogicPts = function (logicPts) {
  MMBezierObjData.superclass.setLogicPts.call(this, logicPts);
  // 调用此函数要求对象是水平中正的
  //    assert(fabs(fmod(m_angle, 360)) < 0.00001);

  //    MMCommonFun::debugOutput(logicPts, "object set logic pts:");
  this.m_arrPoints = [];
  for (var i = 0; i < logicPts.length; i++) {
    this.m_arrPoints.push(logicPts[i]);
  }
  var rect = this.getLogicRectFromSrcPts(this.m_arrPoints);
  if (this.m_arrCtrlPts.length == 0 && rect.length > 0) this.m_arrCtrlPts = rect.getCtrlPts(false);

  // 计算每个点相对于控制点的相对位移
  this.m_arrOffset = [];

  //    this->m_arrYellowOffset.clear();        -------------!

  if (this.m_arrCtrlPts.length == 0) {
    return;
  }
  var left_bottom = this.m_arrCtrlPts[0];
  var right_top;
  if (this.m_arrCtrlPts.length == 4) {
    right_top = this.m_arrCtrlPts[2];
  } else if (this.m_arrCtrlPts.size() == 8) {
    right_top = this.m_arrCtrlPts[4];
  } else {
    console.assert(false);
    return;
  }
  var width = right_top.x - left_bottom.x;
  var height = right_top.y - left_bottom.y;
  if (this.m_objType != _ObjType["default"].GObj_scribble && this.m_objType != _ObjType["default"].GObj_nitePen) {
    console.assert(Math.abs(width) > 0.00001);
    console.assert(Math.abs(height) > 0.00001);
    if (Math.abs(width) < 0.00001 || Math.abs(height) < 0.00001) {
      return;
    }
    for (var i = 0; i < this.m_arrPoints.length; i++) {
      var p = this.m_arrPoints[i];
      var offset = new _MMPoint["default"]();
      offset.x = (p.x - left_bottom.x) / width;
      offset.y = (p.y - left_bottom.y) / height;
      this.m_arrOffset.push(offset);
    }
  } else {
    for (var i = 0; i < this.m_arrPoints.length; i++) {
      var p = this.m_arrPoints[i];
      var offset = new _MMPoint["default"]();
      if (Math.abs(width < 0.00001)) {
        offset.x = 0;
      } else {
        offset.x = (p.x - left_bottom.x) / width;
      }
      if (Math.abs(height < 0.00001)) {
        offset.y = 0;
      } else {
        offset.y = (p.y - left_bottom.y) / height;
      }
      this.m_arrOffset.push(offset);
    }
  }
};
var _default = exports["default"] = MMBezierObjData;

},{"1038":1038,"1084":1084,"1184":1184,"1454":1454,"830":830}],1038:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMObjectData = _interopRequireDefault(require(1082));
var _MMRect = _interopRequireDefault(require(831));
var _MMPoint = _interopRequireDefault(require(830));
var _ObjType = _interopRequireDefault(require(1084));
var _MMDevOrientation = _interopRequireDefault(require(814));
/**
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMCircleData}
 */
function MMBlockObjData(board, init) {
  _MMObjectData["default"].call(this, board, init); //

  // 记录创建此对象时的设备方向
  this.m_orientation = null;
  // 旋转角度 (0 - 360)
  this.m_angle = 0;
  this.m_rect = new _MMRect["default"](); // 每个对象存储一个外接矩形，正的，没有旋转的

  this.m_isClose = true; // 拉伸黄点时需要用到该值，判断拉伸的是否闭合
  this.m_userScaled; // 用户是否主动拉伸过该对象
  this.m_scale = new _MMPoint["default"](1, 1); //选择拉伸进入undo_redo时调用
  this.m_arrCtrlPts = [];
  this.m_canScale = true;
}
;
MMBlockObjData.prototype = new _MMObjectData["default"](); //
MMBlockObjData.superclass = _MMObjectData["default"].prototype;
MMBlockObjData.prototype.initBy = function (obj) {
  MMBlockObjData.superclass.initBy.call(this, obj);
  this.m_orientation = obj.m_orientation ? obj.m_orientation : null;
  // 旋转角度 (0 - 360)
  this.m_angle = obj.m_angle;
  this.m_rect = obj.m_rect.clone(); // 每个对象存储一个外接矩形，正的，没有旋转的
  // console.log("m_rect改变了", this.m_rect)
  this.m_isClose = obj.m_isClose; // 拉伸黄点时需要用到该值，判断拉伸的是否闭合
  this.m_userScaled = obj.m_userScaled; // 用户是否主动拉伸过该对象
  this.m_scale = obj.m_scale.clone(); //选择拉伸进入undo_redo时调用
  this.m_canScale = obj.m_canScale;
};
MMBlockObjData.prototype.encode = function (enc_) {
  MMBlockObjData.superclass.encode.call(this, enc_);
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
  enc_.encodeFloat(this.m_angle);
  enc_.encodeDevOrientation(this.m_orientation);
  enc_.encodeBool(this.m_canScale);
  enc_.encodeBool(this.m_userScaled);
  enc_.encodeBool(this.m_isClose);
  enc_.encodeMMRect(this.m_rect);
};
MMBlockObjData.prototype.get8ArrCtrlPoints = function () {
  var out = [];
  var acp = this.m_arrCtrlPts;
  var center = this.getCenter();
  for (var i = 0; i < acp.length; i++) {
    out.push(acp[i].clone());
    if (acp.length == 4) {
      out.push(new _MMPoint["default"]((acp[i].x + acp[(i + 1) % 4].x) / 2, (acp[i].y + acp[(i + 1) % 4].y) / 2));
    }
  }
  return out;
};
MMBlockObjData.prototype.getExpandArrCtrlPoints = function (width) {
  if (width === undefined) width = 0.1;
  var out = [];
  var acp = this.m_arrCtrlPts;
  var center = this.getCenter();
  for (var i = 0; i < acp.length; i++) {
    out.push(acp[i].clone());
  }
  var out = MMCommonFun.rotateAroundPts(out, center, -this.m_angle * Math.PI / 180);
  if (out.length == 4) {
    out[0] = new _MMPoint["default"](out[0].x - width, out[0].y - width); //top left
    out[1] = new _MMPoint["default"](out[1].x + width, out[1].y - width); //top left
    out[2] = new _MMPoint["default"](out[2].x + width, out[2].y + width); // left bottom
    out[3] = new _MMPoint["default"](out[3].x - width, out[3].y + width); // bottom right
  } else {
    out[0] = new _MMPoint["default"](out[0].x - width, out[0].y - width); //top left
    out[1] = new _MMPoint["default"](out[1].x, out[1].y - width); //top center
    out[2] = new _MMPoint["default"](out[2].x + width, out[2].y - width); //top left
    out[3] = new _MMPoint["default"](out[3].x + width, out[3].y); // left center
    out[4] = new _MMPoint["default"](out[4].x + width, out[4].y + width); // left bottom
    out[5] = new _MMPoint["default"](out[5].x, out[5].y + width); // bottom center
    out[6] = new _MMPoint["default"](out[6].x - width, out[6].y + width); // bottom right
    out[7] = new _MMPoint["default"](out[7].x - width, out[7].y); // right center
  }
  MMCommonFun.rotateAroundPts(out, center, this.m_angle * Math.PI / 180);
  return out;
};
MMBlockObjData.prototype.get8ExpandArrCtrlPoints = function (width) {
  if (width === undefined) width = 0.1;
  var out = [];
  var center = this.getCenter();
  var out = this.get8ArrCtrlPoints();
  if (!out.length) return out;
  MMCommonFun.rotateAroundPts(out, center, -this.m_angle * Math.PI / 180);
  out[0] = new _MMPoint["default"](out[0].x - width, out[0].y - width); //top left
  out[1] = new _MMPoint["default"](out[1].x, out[1].y - width); //top center
  out[2] = new _MMPoint["default"](out[2].x + width, out[2].y - width); //top left
  out[3] = new _MMPoint["default"](out[3].x + width, out[3].y); // left center
  out[4] = new _MMPoint["default"](out[4].x + width, out[4].y + width); // left bottom
  out[5] = new _MMPoint["default"](out[5].x, out[5].y + width); // bottom center
  out[6] = new _MMPoint["default"](out[6].x - width, out[6].y + width); // bottom right
  out[7] = new _MMPoint["default"](out[7].x - width, out[7].y); // right center
  MMCommonFun.rotateAroundPts(out, center, this.m_angle * Math.PI / 180);
  return out;
};
MMBlockObjData.prototype.decode = function (dec_, ver_) {
  MMBlockObjData.superclass.decode.call(this, dec_, ver_);
  var _objVer = 0;
  _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_angle = dec_.decodeFromFloat(ver_);
  this.m_orientation = dec_.decodeFromDevOrientation(ver_);
  this.m_canScale = dec_.decodeFromBool(ver_);
  this.m_userScaled = dec_.decodeFromBool(ver_);
  this.m_isClose = dec_.decodeFromBool(ver_);
  this.m_rect = dec_.decodeFromMMRect(ver_);
  // console.log("m_rect改变了", this.m_rect)
  this.m_arrCtrlPts = this.generateShapePointsWithRectAndAngle();
};
MMBlockObjData.prototype.getCenter = function () {
  var rect = this.m_expandRect;
  if (rect == undefined || rect == null) {
    return new _MMPoint["default"](0, 0);
  }
  return new _MMPoint["default"]((rect.left + rect.right) / 2, (rect.top + rect.bottom) / 2);
};
MMBlockObjData.prototype.setDevPts = function (trsfm_, devPts_, pageIndex_) {
  this.m_needRefresh = true;
  this.setPageIndex(pageIndex_);
  if (devPts_.length < 2) {
    return;
  }
  var _lgPts = trsfm_.dv2lgPoints(devPts_, pageIndex_);
  this.setLogicPts(_lgPts);
};
MMBlockObjData.prototype.setLogPts = function (lgPts_, pageIndex_) {
  this.m_needRefresh = true;
  this.setPageIndex(pageIndex_);
  if (lgPts_.length < 2) {
    return;
  }
  var _lgPts = lgPts_;
  this.setLogicPts(_lgPts);
};
MMBlockObjData.prototype.setLogicPts = function (logicPts) {
  this.m_expandRect = this.m_rect = MMCommonFun.getRect(logicPts);
  // console.log("m_rect改变了", this.m_rect)
};
MMBlockObjData.prototype.getDevOrientation = function () {
  return this.m_orientation;
};
MMBlockObjData.prototype.setDevOrientation = function (devOri_) {
  if (devOri_ instanceof _MMDevOrientation["default"]) {
    this.m_orientation = devOri_;
  } else {
    this.m_orientation = _MMDevOrientation["default"].createObjByStr(devOri_);
  }
};

/**
 *
 */
MMBlockObjData.prototype.updatePtsFromCtlPts = function () {
  this.m_needRefresh = true;
};
MMBlockObjData.prototype.transform = function (option, basePt_,
// 参考点 MMLgPoint
scale_,
// 拉伸比例 MMLgPoint
angleInfect_,
// 缩放时是否受原有角度影响？在多个对象同时被选中拉伸时，此参数置为 false
alpha_,
// 相对旋转角度(0, 360) float
offset_ // 相对位移 MMLgPoint
) {
  this.m_needRefresh = true;
  this.m_scale.x = this.m_scale.x * scale_.x;
  this.m_scale.y = this.m_scale.y * scale_.y;
  var scaleFactor = scale_;
  if (!this.m_canScale) {
    scaleFactor.x = scaleFactor.y = 1.0;
  }

  // 1. 位移
  var point = new _MMPoint["default"](-basePt_.x, -basePt_.y);
  this.move(point, false);

  // 2. 逆旋转（旋转到角度 0）
  var initAngle = this.m_angle; // 保存原有角度，以便恢复
  if (angleInfect_ && Math.abs(initAngle) > 0.001) {
    this.rotate(-initAngle);
  }

  // 3. 缩放控制点
  if (Math.abs(scaleFactor.x - 1) > 0.001 || Math.abs(scaleFactor.y - 1) > 0.001) {
    for (var i = 0; i < this.m_arrCtrlPts.length; i++) {
      this.m_arrCtrlPts[i].x *= scaleFactor.x;
      this.m_arrCtrlPts[i].y *= scaleFactor.y;
    }
  }

  // 4. 根据相对位移重新计算对象的点
  this.transformWithArrPoints(scale_);
  this.updatePtsFromCtlPts();

  // 5. 旋转(恢复以前的角度)
  if (angleInfect_ && Math.abs(initAngle) > 0.001) {
    var angle = initAngle + alpha_;
    this.rotate(angle);
  } else if (Math.abs(alpha_) > 0.1) {
    this.rotate(alpha_);
  }

  // 6. 逆位移
  var pointTemp = new _MMPoint["default"](0, 0);
  pointTemp.x = basePt_.x + offset_.x;
  pointTemp.y = basePt_.y + offset_.y;
  this.move(pointTemp);
  this.calcStardardRect();
  this.adjustGradient(); // added by jiang, 2014-6-28

  return scale_;
};
MMBlockObjData.prototype.transformWithArrPoints = function (scale_) {
  return scale_;
};
MMBlockObjData.prototype.move = function (offset_, moveAll_) {
  var _moveAll = arguments[1] ? arguments[1] : true;
  if (Math.abs(offset_.x) < 0.0001 && Math.abs(offset_.y) < 0.0001) {
    return;
  }
  this.m_needRefresh = true;
  for (var i = 0; i < this.m_arrCtrlPts.length; i++) {
    this.m_arrCtrlPts[i].x += offset_.x;
    this.m_arrCtrlPts[i].y += offset_.y;
  }
  this.moveWithArrPoints(offset_, moveAll_);
  this.m_rect.left += offset_.x;
  this.m_rect.top += offset_.y;
  this.m_rect.right += offset_.x;
  this.m_rect.bottom += offset_.y;
  this.calcStardardRect();
  this.adjustGradient(); // added by jiang, 2014-6-28
};
MMBlockObjData.prototype.moveWithArrPoints = function (offset_, moveAll_) {};
MMBlockObjData.prototype.rotate = function (alpha_, rotateAll_) {
  var _rotateAll = rotateAll_ != undefined ? rotateAll_ : true;
  this.m_needRefresh = true;
  var arc = alpha_ * Math.PI / 180;
  var cos = Math.cos(arc);
  var sin = Math.sin(arc);
  var x, y;
  for (var i = 0; i < this.m_arrCtrlPts.length; i++) {
    x = this.m_arrCtrlPts[i].x;
    y = this.m_arrCtrlPts[i].y;
    this.m_arrCtrlPts[i].x = x * cos - y * sin;
    this.m_arrCtrlPts[i].y = y * cos + x * sin;
  }
  this.rotateWithArrPoints(alpha_, rotateAll_);
  this.m_angle += alpha_;
  this.m_angle = this.m_angle % 360; //取模
};
MMBlockObjData.prototype.rotateWithArrPoints = function (alpha_, rotateAll_) {};
MMBlockObjData.prototype.calcStardardRect = function () {
  if (this.m_arrCtrlPts.length == 0) {
    return;
  }

  //将当前角度转化为弧度
  var arc = this.m_angle * Math.PI / 180;

  //获得当前的旋转中心，及最大矩形，最大矩形中心即为旋转中心
  var leftBottom = this.m_arrCtrlPts[0].clone();
  var rightTop;
  if (this.m_arrCtrlPts.length == 4) {
    rightTop = this.m_arrCtrlPts[2].clone();
  } else if (this.m_arrCtrlPts.length == 8) {
    rightTop = this.m_arrCtrlPts[4].clone();
  } else {
    //        assert(false);
    return;
  }
  var _center = new _MMPoint["default"](); //中心点
  _center.x = (leftBottom.x + rightTop.x) / 2;
  _center.y = (leftBottom.y + rightTop.y) / 2;

  //    MMCommonFun.debugOutputArrPts("before rotate ---- object pts:", this.m_arrCtrlPts);

  if (Math.abs(this.m_angle) > 0.0001) {
    MMCommonFun.rotateAroundPts(this.m_arrCtrlPts, _center, -arc);
    //获得未旋转矩形的左上角点跟右下角点，左上角点默认为角点0 。
    leftBottom = this.m_arrCtrlPts[0].clone();
    if (this.m_arrCtrlPts.length == 4) {
      rightTop = this.m_arrCtrlPts[2].clone();
    } else if (this.m_arrCtrlPts.length == 8) {
      rightTop = this.m_arrCtrlPts[4].clone();
    } else {
      //            assert(false);
      return;
    }
  }

  //    MMCommonFun.debugOutputArrPts("after rotate ----- object pts:", this.m_arrCtrlPts);

  this.m_rect.left = leftBottom.x;
  this.m_rect.top = leftBottom.y;
  this.m_rect.right = rightTop.x;
  this.m_rect.bottom = rightTop.y;
  if (Math.abs(this.m_angle) > 0.0001) {
    MMCommonFun.rotateAroundPts(this.m_arrCtrlPts, _center, arc);
  }
  this.m_expandRect = MMCommonFun.getRect(this.m_arrCtrlPts);
  //    this.m_expandRect.expand(0.078125 + this.m_strokeType.getLineWidth());//不懂，暂注释掉，lishusheng
  var delta = 0.078125 + this.m_strokeType.getLineWidth();
  this.m_expandRect.expand(delta, delta, delta, delta);
};
MMBlockObjData.prototype.generateShapePointsWithRectAndAngle = function () {
  var flag = false;
  if (this.m_objType == _ObjType["default"].Obj_Image || this.m_objType == _ObjType["default"].Obj_PDF || this.m_objType == _ObjType["default"].Obj_Document || this.m_objType == _ObjType["default"].Obj_Recorder || this.m_objType == _ObjType["default"].GObj_text || this.m_objType == _ObjType["default"].GObj_note || this.m_objType == _ObjType["default"].GObj_rectMark || this.m_objType == _ObjType["default"].Obj_Group) {
    flag = true;
  }
  var res = this.m_rect.getCtrlPts(flag);
  if (Math.abs(this.m_angle % 360) > 0.000001) {
    res = this.m_rect.getCtrlPts(flag);
    MMCommonFun.rotateAroundPts(res, this.m_rect.getCenter(), this.m_angle * Math.PI / 180);
  }
  return res;
};
MMBlockObjData.prototype.getRect = function () {
  return this.m_rect.clone();
};
MMBlockObjData.prototype.getArcAngle = function () {
  var angle = this.m_angle;
  angle *= Math.PI / 180;
  return angle;
};
MMBlockObjData.prototype._isPtInRect = function (pt_) {
  if (this.m_arrCtrlPts.length.length == 0) {
    return false;
  }
  var arrRectPt = [];
  for (var i = 0; i < this.m_arrCtrlPts.length; i++) {
    arrRectPt.push(this.m_arrCtrlPts[i].clone());
  }
  var pt = pt_.clone();
  if (arrRectPt.length == 0) return false;
  var centerPt = arrRectPt[0].clone();
  MMCommonFun.rotateAroundPts(arrRectPt, centerPt, -this.m_angle * Math.PI / 180);
  MMCommonFun.rotateAroundPt(pt, centerPt, -this.m_angle * Math.PI / 180);
  var _rect = MMCommonFun.getRect(arrRectPt);
  if (_rect.include(pt)) {
    return true;
  }
  return false;
};
MMBlockObjData.prototype.getLogicRect = function () {
  return MMCommonFun.getRect(this.m_arrCtrlPts);
};
MMBlockObjData.prototype.getLogicRectFromSrcPts = function () {
  var _arrLgPts = this.getShapePointsWithRectAndAngle();
  return MMCommonFun.getRect(_arrLgPts);
};
MMBlockObjData.prototype.getShapePointsWithRectAndAngle = function () {
  var flag = false;
  if (this.m_objType == _ObjType["default"].Obj_Image || this.m_objType == _ObjType["default"].Obj_PDF || this.m_objType == _ObjType["default"].Obj_Document || this.m_objType == _ObjType["default"].Obj_Recorder || this.m_objType == _ObjType["default"].GObj_text || this.m_objType == _ObjType["default"].GObj_note || this.m_objType == _ObjType["default"].GObj_rectMark || this.m_objType == _ObjType["default"].Obj_Group) {
    flag = true;
  }
  var pts = this.m_rect.getCtrlPts(flag);
  if (Math.abs(this.m_angle % 360) > 0.000001) {
    MMCommonFun.rotateAroundPts(pts, this.m_rect.getCenter(), this.m_angle * Math.PI / 180);
  }
  return pts;
};
MMBlockObjData.prototype.changeAngleByDirection = function (devOri_) {
  var angle = this.m_angle;
  //  if(this.m_orientation!= undefined && this.m_orientation!= null && devOri_ != undefined && devOri_ != null){
  //    if(this.m_orientation.isLandscape() && !devOri_.isLandscape()){
  //      angle = this.m_angle + 90;
  //    }else if(!this.m_orientation.isLandscape() && devOri_.isLandscape()){
  //      angle = this.m_angle - 90;
  //    }
  //  }
  if (this.m_orientation != undefined && this.m_orientation != null && this.m_orientation.isLandscape()) {
    angle = this.m_angle + 90;
  }
  return angle;
};
MMBlockObjData.prototype.rotateRectByDirection = function (devOri_) {
  var rect = this.m_rect;
  //  if(this.m_orientation!= undefined && this.m_orientation!= null && devOri_ != undefined && devOri_ != null){
  //    if(this.m_orientation.isLandscape() && !devOri_.isLandscape()){
  //      rect = this.m_rect.rotateAroundPt(this.m_rect.getCenter(), 90);
  //    }else if(!this.m_orientation.isLandscape() && devOri_.isLandscape()){
  //      rect = this.m_rect.rotateAroundPt(this.m_rect.getCenter(), -90);
  //    }
  //  }
  if (this.m_orientation != undefined && this.m_orientation != null && this.m_orientation.isLandscape()) {
    rect = this.m_rect.rotateAroundPt(this.m_rect.getCenter(), -90);
  }
  return rect;
};
MMBlockObjData.prototype.initObjectWithLogicRect = function (rect) {
  // console.log("m_rect改变了", this.m_rect)
  this.m_rect = this.m_expandRect = rect;
  this.m_arrCtrlPts = this.m_rect.getCtrlPts();
  this.setLogicPts(this.m_arrCtrlPts);
};
var _default = exports["default"] = MMBlockObjData;

},{"1082":1082,"1084":1084,"1184":1184,"1454":1454,"814":814,"830":830,"831":831}],1082:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _OBJ_ID = _interopRequireDefault(require(818));
var _MMShadowType = _interopRequireDefault(require(797));
var _MMStrokeType = _interopRequireDefault(require(798));
var _MMFillType = _interopRequireDefault(require(795));
var _MMMeta = _interopRequireDefault(require(1080));
var _MMPoint = _interopRequireDefault(require(830));
var _ObjType = _interopRequireDefault(require(1084));
var _MMIdManager = _interopRequireDefault(require(951));
var _MMRect = _interopRequireDefault(require(831));
var _int = _interopRequireDefault(require(820));
/*
 * Copyright 2014 http://www.molasync.com/, All Rights Reserved.
 *
 * Purpose:
 * Version: 1.0
 * Author: 黎曙升
 * Date: 2014/05/21
 *
 */

/**
 *
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMMeta}
 */
function MMObjectData(board, init) {
  _MMMeta["default"].call(this, board);
  this.m_ver; //-------------------- 版本号
  this.m_id = null;

  //  this.m_arrPoints = new Array();
  this.m_arrYellowPoints;
  this.m_fillType = new _MMFillType["default"]();
  this.m_strokeType = new _MMStrokeType["default"]();
  this.m_shadowType = new _MMShadowType["default"]();
  this.m_arrCtrlPts; // ------------------- 8 个控制点

  this.m_objType = _ObjType["default"].Obj_default; //
  this.m_expandRect; //--------------------- isPtOn时，需要的矩形

  /**
   * m_rect
   * @type {MMRect}
   */
  //  this.m_arrOffset;   // ------------------ 记录每个点相对于 4 角控制点的相对位置，以第 0 个控制点为基准
  //  this.m_arrYellowOffset; //--------------- 记录每个黄点相对于 4 角控制点的相对位置，以第 0 个控制点为基准
  this.m_selected; // --------------------- 是否被单独选中,只有单个选中对象的选中状态才能设置为真，多个对象同时选中时每个对象的选中状态必须为假
  this.m_bActive;
  this.m_lock = false;
  this.m_standardSize;
  this.m_needRefresh; // ------------------ 脏数据标志
  this.m_layerIndex; // ----------------- 层次标记

  this.m_originObj; //相应的Object
  this.m_isDrawDelObj; //------------------ 橡皮檫状态下，删除对象；
  this.m_scale = new _MMPoint["default"](1, 1); //选择拉伸进入undo_redo时调用
  this.m_needMoving; //对象是否在几何变化中

  this.m_creator = 0;
  this.m_pageIndex = -1;
  this.m_isCommited = false;

  //  this.m_id = new OBJ_ID();
  //  this.m_id.m_localIndex = -1 ;
  //  this.m_id.m_macAddr = -1 ;
  if (board) {
    this.m_creator = app.currentUser.getUserId_Int();
  }
}
;
MMObjectData.prototype = new _MMMeta["default"]();
MMObjectData.superclass = _MMMeta["default"].prototype;
MMObjectData.prototype.setObjType = function (m_objType) {
  this.m_objType = m_objType;
};
MMObjectData.prototype.initWithWihteBoard = function (wihteBoard) {
  if (wihteBoard) {
    this.m_board = wihteBoard;
  }
};
MMObjectData.prototype.decode = function (dc_, ver_) {
  MMObjectData.superclass.decode.call(this, dc_, ver_);
  var _objVer = 0;
  _objVer = dc_.decodeFrom4Bytes(ver_);
  this.m_id = dc_.decodeFromObjID(ver_);
  this.m_fillType = dc_.decodeFromObject(ver_);
  this.m_strokeType = dc_.decodeFromObject(ver_);
  this.m_shadowType = dc_.decodeFromObject(ver_);
  this.m_lock = dc_.decodeFromBool(ver_);
  this.m_expandRect = dc_.decodeFromMMRect(ver_);
  this.m_objType = dc_.decodeFrom4Bytes(ver_);
  this.m_creator = dc_.decodeFrom8Bytes(ver_);
  this.m_pageIndex = dc_.decodeFrom4Bytes(ver_);
  if (_objVer > 2) {
    this.m_isCommited = dc_.decodeFromBool(ver_);
  } else {
    this.m_isCommited = true;
  }
  this.m_needRefresh = true;
  this.m_isDrawDelObj = false;
  this.m_needMoving = false;
  this.adjustGradient(); // added by jiang, 2014-6-28
};
MMObjectData.prototype.encode = function (ec_) {
  MMObjectData.superclass.encode.call(this, ec_);
  var _objVer = 3;
  ec_.encode4Bytes(_objVer);
  ec_.encodeObjID(this.m_id);
  ec_.encodeObject(this.m_fillType);
  ec_.encodeObject(this.m_strokeType);
  ec_.encodeObject(this.m_shadowType);

  //for compatibility begin
  if (!this.m_expandRect) {
    this.m_expandRect = new _MMRect["default"](0, 0, 0, 0);
  }
  //for compatibility end
  ec_.encodeBool(this.m_lock);
  ec_.encodeMMRect(this.m_expandRect);
  ec_.encode4Bytes(this.m_objType);
  ec_.encode8Bytes(this.m_creator);
  ec_.encode4Bytes(this.m_pageIndex);
  if (_objVer > 2) {
    if (MMCommonFun.isPC()) {
      ec_.encodeBool(this.m_isCommited);
    } else {
      ec_.encodeBool(true);
    }
  }
  if (this.m_objType == _ObjType["default"].Obj_default) {
    console.assert(this.m_objType != _ObjType["default"].Obj_default); //
  }
  ;
};
MMObjectData.prototype.setId = function (id_) {
  this.m_id = id_;
};
MMObjectData.prototype.getId = function () {
  return this.m_id;
};
MMObjectData.prototype.setCreator = function (usrId) {
  if (!(usrId instanceof _int["default"])) {
    usrId = new _int["default"](usrId);
  }
  this.m_creator = usrId;
};
MMObjectData.prototype.getCreator = function () {
  return this.m_creator;
};
MMObjectData.prototype.isCommited = function () {
  return this.m_isCommited;
};
MMObjectData.prototype.setCommited = function (flag_) {
  this.m_isCommited = flag_;
};
MMObjectData.prototype.setLayerIndex = function (index_) {
  this.m_layerIndex = index_;
};
MMObjectData.prototype.getLayerIndex = function () {
  if (this.m_layerIndex != undefined) {
    return this.m_layerIndex;
  } else {
    return 0;
  }
};
MMObjectData.prototype.isRegistered = function () {
  //  return !(this.m_id.m_local_index==-1&&this.m_id.m_mac_addr==-1) ;
  /*
   */
  return this.m_id != null;
};

/**
 *
 * @param color_ {MMColor}
 */
MMObjectData.prototype.changeColor = function (color_) {
  if (this.m_objType == _ObjType["default"].GObj_scribble || this.m_objType == _ObjType["default"].GObj_line || this.m_objType == _ObjType["default"].GObj_nitePen || this.m_objType == _ObjType["default"].GObj_brokenline && !this.m_isClose) {
    this.m_strokeType.setLineColor(color_);
  } else {
    this.m_fillType.setFillColor(color_);
  }
  this.m_needRefresh = true;
};
/**
 *
 * @param strokeType_ {MMStrokeType}
 */
MMObjectData.prototype.setStrokeType = function (strokeType_) {
  this.m_needRefresh = true;
  this.m_strokeType = strokeType_;
};
MMObjectData.prototype.getStrokeType = function () {
  return this.m_strokeType;
};
/**
 *
 * @param fillType_ {MMFillType}
 */
MMObjectData.prototype.setFillType = function (fillType_) {
  this.m_needRefresh = true;
  this.m_fillType = fillType_;
  this.adjustGradient();
};
/**
 *
 * @param shadowType_ {MMShadowType}
 */
MMObjectData.prototype.setShadowType = function (shadowType_) {
  this.m_needRefresh = true;
  this.m_shadowType = shadowType_;
};
MMObjectData.prototype.getExpandRect = function () {
  return this.m_expandRect;
};
MMObjectData.prototype.getDrawRect = function (devOri_) {
  var rect = this.m_rect;
  if (this.m_objType == _ObjType["default"].GObj_text || this.m_objType == _ObjType["default"].Obj_Document || this.m_objType == _ObjType["default"].Obj_Image || this.m_objType == _ObjType["default"].Obj_Recorder || this.m_objType == _ObjType["default"].Obj_PDF) {
    rect = this.rotateRectByDirection(devOri_);
  }
  return rect;
};
MMObjectData.prototype.getDrawAngle = function (devOri_) {
  var angle = this.m_angle;
  if (this.m_objType == _ObjType["default"].GObj_text || this.m_objType == _ObjType["default"].Obj_Document || this.m_objType == _ObjType["default"].Obj_Image || this.m_objType == _ObjType["default"].Obj_Recorder || this.m_objType == _ObjType["default"].Obj_PDF) {
    angle = this.changeAngleByDirection(devOri_);
  }
  return angle;
};
MMObjectData.prototype.setObject = function (obj) {
  this.m_originObj = obj;
};

/**
 *
 * @param offset_  {MMPoint}
 * @param moveAll_ {bool}
 */
MMObjectData.prototype.move = function (offset_, moveAll_) {};
MMObjectData.prototype.roatate = function (center_, arc_) {
  this.m_needRefresh = true;
  MMCommonFun.rotateAroundPts(this.m_arrPoints, center_, arc_);
  MMCommonFun.rotateAroundPts(this.m_arrCtrlPts, center_, arc_);
  MMCommonFun.rotateAroundPts(this.m_arrYellowPoints, center_, arc_);
};
MMObjectData.prototype.setYellowPtsAndIsClose = function (yellowPts_, isClose_) {
  var _lgPts = new Array();
  var arc = this.m_angle * Math.PI / 180;
  var leftBottom = this.m_arrCtrlPts[0].clone();
  var rightTop = null;
  var leftTop = null;
  var rightBottom = null;
  if (this.m_arrCtrlPts.length == 4) {
    rightTop = this.m_arrCtrlPts[2].clone();
    leftTop = this.m_arrCtrlPts[3].clone();
    rightBottom = this.m_arrCtrlPts[1].clone();
  } else if (this.m_arrCtrlPts.length == 8) {
    rightTop = this.m_arrCtrlPts[4].clone();
    leftTop = this.m_arrCtrlPts[6].clone();
    rightBottom = this.m_arrCtrlPts[2].clone();
  }
  var center = new _MMPoint["default"]((leftBottom.x + rightTop.x) / 2, (leftBottom.y + rightTop.y) / 2);
  if (Math.abs(this.m_angle) > 0.00001) {
    this.roatate(center, -arc);
    MMCommonFun.rotateAroundPts(yellowPts_, center, -arc);
    leftBottom = this.m_arrCtrlPts[0].clone();
    if (Math.abs(this.m_arrCtrlPts.length - 4) < 0.00001) {
      rightTop = this.m_arrCtrlPts[2].clone();
      leftTop = this.m_arrCtrlPts[3].clone();
      rightBottom = this.m_arrCtrlPts[1].clone();
    } else if (Math.abs(this.m_arrCtrlPts.length - 8) < 0.00001) {
      rightTop = this.m_arrCtrlPts[4].clone();
      leftTop = this.m_arrCtrlPts[6].clone();
      rightBottom = this.m_arrCtrlPts[2].clone();
    }
  }
  if (this.m_orientation.m_orientation == 1 || this.m_orientation.m_orientation == 2) {
    _lgPts.push(rightBottom.clone());
    _lgPts.push(leftTop.clone());
  } else {
    _lgPts.push(leftBottom.clone());
    _lgPts.push(rightTop.clone());
  }
  this.m_arrYellowPoints = new Array();
  this.m_arrYellowPoints = yellowPts_;
  var _newLgPts = this.calInitShapePts(_lgPts);
  this.setLogicPts(_newLgPts);
  if (Math.abs(this.m_angle) > 0.00001) {
    this.roatate(center, arc);
    MMCommonFun.rotateAroundPts(yellowPts_, center, arc);
  }
  this.m_isClose = isClose_;
};
MMObjectData.prototype.getObject = function () {
  if (!this.m_id.isBlank()) {
    this.m_originObj = this.m_board.getObject(this.m_id);
  }
  return this.m_originObj;
};
MMObjectData.prototype.setLogicPts = function (logicPts) {
  this.m_needRefresh = true;
  this.m_arrPoints = new Array();
  for (var i = 0; i < logicPts.length; i++) {
    this.m_arrPoints.push(logicPts[i].clone());
  }
  var rect = MMCommonFun.getRect(this.m_arrPoints);
  if (this.m_arrCtrlPts.length == 0) this.m_arrCtrlPts = rect.getCtrlPts();

  // 计算每个点相对于控制点的相对位移
  this.m_arrOffset = new Array();
  this.m_arrYellowOffset = new Array();
  if (this.m_arrCtrlPts.length == 0) {
    return;
  }
  var left_bottom = this.m_arrCtrlPts[0].clone();
  var right_top;
  if (this.m_arrCtrlPts.length == 4) {
    right_top = this.m_arrCtrlPts[2].clone();
  } else if (this.m_arrCtrlPts.length == 8) {
    right_top = this.m_arrCtrlPts[4].clone();
  } else {
    //        assert(false);
    return;
  }
  var width = right_top.x - left_bottom.x;
  var height = right_top.y - left_bottom.y;
  if (this.m_objType != _ObjType["default"].GObj_scribble && this.m_objType != _ObjType["default"].GObj_nitePen) {
    //        assert(Math.abs(width) > 0.00001);
    //        assert(Math.abs(height) > 0.00001);
    if (Math.abs(width) < 0.00001 || Math.abs(height) < 0.00001) {
      return;
    }
    for (var i = 0; i < this.m_arrPoints.length; i++) {
      var offset = new _MMPoint["default"]();
      offset.x = (this.m_arrPoints[i].x - left_bottom.x) / width;
      offset.y = (this.m_arrPoints[i].y - left_bottom.y) / height;
      this.m_arrOffset.push(offset);
    }
    for (var i = 0; i < this.m_arrYellowPoints.length; i++) {
      var offset = new _MMPoint["default"]();
      offset.x = (this.m_arrYellowPoints[i].x - left_bottom.x) / width;
      offset.y = (this.m_arrYellowPoints[i].y - left_bottom.y) / height;
      this.m_arrYellowOffset.push(offset);
    }
  } else {
    for (var i = 0; i < this.m_arrPoints.length; i++) {
      var offset = new _MMPoint["default"]();
      if (Math.abs(width < 0.00001)) {
        offset.x = 0;
      } else {
        offset.x = (this.m_arrPoints[i].x - left_bottom.x) / width;
      }
      if (Math.abs(height < 0.00001)) {
        offset.y = 0;
      } else {
        offset.y = (this.m_arrPoints[i].y - left_bottom.y) / height;
      }
      this.m_arrOffset.push(offset);
    }
  }
};
MMObjectData.prototype.calInitShapePts = function (lgPts) {
  return lgPts;
};

/**
 * 根据对象的位置，计算渐变的坐标
 * @author jiang
 */
MMObjectData.prototype.adjustGradient = function () {
  if (!this.m_fillType.m_notGradient) {
    this.m_fillType.m_gradient.initWithObjRectAndAngle(this.m_rect, this.m_angle);
  }
};
MMObjectData.prototype.getFilePath = function () {
  if (this.m_filePath != undefined && this.m_filePath.length > 0) {
    if (window.location.host) {
      var _ret = "downloadFile.do?fileName=" + this.m_filePath + "&typeFlag=0&userId=" + this.m_board.getCreatorId().toDecString() + "&boardId=" + this.m_board.getMotherBoardStringId();
      return _ret;
    }
    var _ret = "http://192.168.2.17:9090/downloadFile.do?fileName=" + this.m_filePath + "&typeFlag=0&userId=" + this.m_board.getCreatorId().toDecString() + "&boardId=" + this.m_board.getMotherBoardStringId();
    return _ret;
  } else {
    return "";
  }
};
MMObjectData.prototype.getFilePathForVersion = function (ver_) {
  if (ver_ === undefined || ver_ == null) {
    ver_ = -1;
  }
  ;
  if (this.m_filePath != undefined && this.m_filePath.length > 0) {
    if (window.location.host) {
      var _ret = "newDownloadFile.do?fileId=" + this.m_board.getStringId() + "&v=" + ver_;
      return _ret;
    }
    var _ret = "http://192.168.2.17:9090/newDownloadFile.do?fileId=" + this.m_board.getId().toDecString() + "&v=" + ver_;
    return _ret;
  } else {
    return "";
  }
};
MMObjectData.prototype.setFilePath = function (path) {
  this.m_filePath = path;
};
MMObjectData.prototype.getPageIndex = function () {
  return this.m_pageIndex;
};
MMObjectData.prototype.setPageIndex = function (pgIndex_) {
  if (pgIndex_ != undefined) {
    this.m_pageIndex = pgIndex_;
  }
};
MMObjectData.prototype.getBoard = function () {
  return this.m_board;
};
MMObjectData.prototype.initBy = function (obj) {
  MMObjectData.superclass.initBy.call(this, obj);
  this.m_id = null;
  this.m_expandRect = obj.m_expandRect ? obj.m_expandRect.clone() : null;
  this.m_rect = obj.m_rect ? obj.m_rect.clone() : null;
  if (obj.m_arrYellowPoints) {
    this.m_arrYellowPoints = [];
    for (var i = 0; i < obj.m_arrYellowPoints.length; i++) {
      var pt = obj.m_arrYellowPoints[i].clone();
      this.m_arrYellowPoints.push(pt);
    }
    ;
  }
  ;
  this.m_fillType = obj.m_fillType.clone();
  this.m_strokeType = obj.m_strokeType.clone();
  this.m_shadowType = obj.m_shadowType.clone();
  if (obj.m_arrCtrlPts) {
    this.m_arrCtrlPts = [];
    for (var i = 0; i < obj.m_arrCtrlPts.length; i++) {
      this.m_arrCtrlPts.push(obj.m_arrCtrlPts[i].clone());
    }
    ;
  }
  ;
  // ------------------- 8 个控制点
};
// 设置此属性后，对象在绘制时不再显示线宽，线宽永远为 1 px
MMObjectData.prototype.isSkeleton = function (skeleton) {
  if (skeleton == undefined) {} else {
    this._isSkeleton = skeleton;
  }
  return this._isSkeleton;
};
var _default = exports["default"] = MMObjectData;

},{"1080":1080,"1084":1084,"1184":1184,"1454":1454,"795":795,"797":797,"798":798,"818":818,"820":820,"830":830,"831":831,"951":951}],798:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMMeta = _interopRequireDefault(require(1080));
var _MMColor = _interopRequireDefault(require(794));
var DEFAULT_WIDTH = 0.078125 / 4;
/**
 * @Author lishusheng  2014-05-28
 * @returns {MMStrokeType}
 */
function MMStrokeType() {
  _MMMeta["default"].call(this, null);
  this.m_className = "MMStrokeType";
  this.m_ver = 0; //

  this.m_length = [0.0, 0.0]; //float
  this.m_lineWidth = DEFAULT_WIDTH; //float
  this.m_lineColor = new _MMColor["default"](); //MMColor
  this.m_arrowType = 0; //unsigned    1: 箭头在 end， 2： 头尾都有箭头
  this.m_hasBoard = true;
}
;
MMStrokeType.prototype = new _MMMeta["default"](); //
MMStrokeType.superclass = _MMMeta["default"].prototype;
MMStrokeType.prototype.clone = function (enc_) {
  var newType = new MMStrokeType();
  newType.m_length = [];
  for (var i = 0; i < this.m_length.length; i++) {
    newType.m_length.push(this.m_length[i]);
  }
  ;
  newType.m_lineWidth = this.m_lineWidth; //float
  newType.m_lineColor = this.m_lineColor.clone(); //MMColor
  newType.m_arrowType = this.m_arrowType; //unsigned
  newType.m_hasBoard = this.m_hasBoard;
  return newType;
};
MMStrokeType.prototype.encode = function (enc_) {
  //  MMStrokeType.superclass.encode.call(this, enc_) ;
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
  enc_.encodeFloat(this.m_length[0]);
  enc_.encodeFloat(this.m_length[1]);
  enc_.encodeFloat(this.m_lineWidth);
  enc_.encodeObject(this.m_lineColor);
  enc_.encode4Bytes(this.m_arrowType);
  enc_.encodeBool(this.m_hasBoard);
};
MMStrokeType.prototype.decode = function (dec_, ver_) {
  //	MMStrokeType.superclass.decode.call(this, dec_, ver_) ;

  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
  this.m_length[0] = dec_.decodeFromFloat(ver_);
  this.m_length[1] = dec_.decodeFromFloat(ver_);
  this.m_lineWidth = dec_.decodeFromFloat(ver_);
  this.m_lineColor = dec_.decodeFromObject(ver_);
  this.m_arrowType = dec_.decodeFrom4Bytes(ver_);
  this.m_hasBoard = dec_.decodeFromBool(ver_);
};
MMStrokeType.prototype.isEmpty = function () {
  return this.m_lineWidth < 0.001 || this.m_lineColor.isEmpty();
};
MMStrokeType.prototype.setContext = function (ctx, trsfm) {
  if (this.m_lineWidth == 0.0 || !this.m_hasBoard) {
    ctx.lineWidth = 0.0;
    return;
  }
  ;
  var dvW = trsfm.lg2dvLen(this.m_lineWidth);
  if (this.m_lineColor == null) {
    ctx.strokeStyle = "#000000";
  } else {
    ctx.strokeStyle = this.m_lineColor.getRGBA(dvW);
  }
  if (dvW < 1) dvW = 1;
  ctx.lineWidth = dvW;
  ctx.lineCap = "round";
  ctx.lineJoin = "round";
};
MMStrokeType.prototype.setDivAppearance = function (div, trsfm) {
  div = $(div);
  if (this.m_hasBoard) {
    var w = trsfm.lg2dvLen(this.m_lineWidth);
    var c = this.m_lineColor.getRGBA();
    div.css("border-width", w + "px");
    div.css("border-color", c);
    if (this.isDashed()) {
      div.css("border-style", "dashed");
    } else {
      div.css("border-style", "solid");
    }
  } else {
    div.css("border-width", "0px");
  }
};
MMStrokeType.prototype.getLineWidth = function () {
  return this.m_lineWidth;
};
MMStrokeType.prototype.setLineWidth = function (w_) {
  this.m_lineWidth = w_;
};
MMStrokeType.prototype.setLineColor = function (lineColor_) {
  this.m_lineColor = lineColor_;
  this.m_hasBoard = true;
};
MMStrokeType.prototype.isDashed = function () {
  return this.m_length[0] > 0 || this.m_length[1] > 0;
};
MMStrokeType.prototype.setHasBorder = function (has) {
  this.m_hasBoard = has;
};
MMStrokeType.prototype.setArrowType = function (arrowType) {
  this.m_arrowType = arrowType;
};
var _default = exports["default"] = MMStrokeType;

},{"1080":1080,"1184":1184,"1454":1454,"794":794}],797:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMMeta = _interopRequireDefault(require(1080));
var _MMColor = _interopRequireDefault(require(794));
function MMShadowType() {
  _MMMeta["default"].call(this, null);
  this.m_className = "MMShadowType";
  this.m_ver = 0; //
  this.m_hasShadow = false;
  this.m_blur = 0.0; //float
  this.m_offsetX = 0.0; //float
  this.m_offsetY = 0.0; //float
  this.m_ShadowColor = new _MMColor["default"](); //MMColor
}
;
MMShadowType.prototype = new _MMMeta["default"](); //
MMShadowType.superclass = _MMMeta["default"].prototype;
MMShadowType.prototype.clone = function (enc_) {
  var newType = new MMShadowType();
  newType.m_ver = this.m_ver; //
  newType.m_hasShadow = this.m_hasShadow;
  newType.m_blur = this.m_blur; //float
  newType.m_offsetX = this.m_offsetX; //float
  newType.m_offsetY = this.m_offsetY; //float
  newType.m_ShadowColor = this.m_ShadowColor.clone(); //MMColor

  return newType;
};
MMShadowType.prototype.encode = function (enc_) {
  //  MMShadowType.superclass.encode.call(this, enc_) ;
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
  enc_.encodeBool(this.m_hasShadow);
  enc_.encodeFloat(this.m_blur);
  enc_.encodeFloat(this.m_offsetX);
  enc_.encodeFloat(this.m_offsetY);
  enc_.encodeObject(this.m_ShadowColor);
};
MMShadowType.prototype.decode = function (dec_, ver_) {
  //  MMShadowType.superclass.decode.call(this, dec_, ver_) ;

  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
  this.m_hasShadow = dec_.decodeFromBool(ver_);
  this.m_blur = dec_.decodeFromFloat(ver_);
  this.m_offsetX = dec_.decodeFromFloat(ver_);
  this.m_offsetY = dec_.decodeFromFloat(ver_);
  this.m_ShadowColor = dec_.decodeFromObject(ver_);

  //console.log("--------------> has shadow:" + this.m_hasShadow);
};
MMShadowType.prototype.setContext = function (ctx, trsfm) {
  var blur = this.m_blur;
  var offsetX = this.m_offsetX;
  var offsetY = this.m_offsetY;
  var color = "none";
  if (this.m_hasShadow) {
    if (this.m_ShadowColor == null) {
      color = "black";
    } else {
      color = this.m_ShadowColor.getRGBA();
    }
  } else {
    blur = 0;
    offsetX = 0;
    offsetY = 0;
  }
  ctx.shadowColor = color;
  ctx.shadowBlur = blur;
  ctx.shadowOffsetX = offsetX;
  ctx.shadowOffsetY = offsetY;
};
MMShadowType.prototype.setDivAppearance = function (div, trsfm) {
  var blur = this.m_blur;
  var offsetX = this.m_offsetX;
  var offsetY = this.m_offsetY;
  var color = "rgba(0,0,0,0)";
  if (this.m_hasShadow) {
    if (this.m_ShadowColor == null) {
      color = "black";
    } else {
      color = this.m_ShadowColor.getRGBA();
    }
  } else {
    blur = 0;
    offsetX = 0;
    offsetY = 0;
  }
  $(div).css("box-shadow", offsetX + "px " + offsetY + "px " + blur + "px " + color);
};
var _default = exports["default"] = MMShadowType;

},{"1080":1080,"1184":1184,"1454":1454,"794":794}],795:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMMeta = _interopRequireDefault(require(1080));
var _MMGradient = _interopRequireDefault(require(796));
var _MMColor = _interopRequireDefault(require(794));
//"use strict"

var MMFillType = function MMFillType() {
  _MMMeta["default"].call(this, null);
  this.m_className = "MMFillType";
  this.m_ver = 0; //
  this.m_hasFill = false;
  this.m_notGradient = true;
  this.m_fillColor = new _MMColor["default"](); //MMColor
  this.m_gradient = new _MMGradient["default"](); //MMGradient
};
MMFillType.prototype = new _MMMeta["default"](); //
MMFillType.superclass = _MMMeta["default"].prototype;
_.extend(MMFillType.prototype, {
  encode: function encode(enc_) {
    //	MMFillType.superclass.encode.call(this, enc_) ;
    var _objVer = 0;
    enc_.encode4Bytes(_objVer);
    enc_.encodeBool(this.m_notGradient);
    enc_.encodeObject(this.m_fillColor);
    enc_.encodeObject(this.m_gradient);
    enc_.encodeBool(this.m_hasFill);
  },
  decode: function decode(dec_, ver_) {
    //	MMFillType.superclass.decode.call(this, dec_, ver_) ;

    var _objVer = dec_.decodeFrom4Bytes(ver_);
    this.m_ver = _objVer;
    this.m_notGradient = dec_.decodeFromBool(ver_);
    this.m_fillColor = dec_.decodeFromObject(ver_);
    this.m_gradient = dec_.decodeFromObject(ver_);
    this.m_hasFill = dec_.decodeFromBool(ver_);
  },
  getFillColor: function getFillColor() {
    return this.m_fillColor;
  },
  /**
   *
   * @param fillColor_ {MMColor}
   */
  setFillColor: function setFillColor(fillColor_) {
    this.m_fillColor = fillColor_;
    this.m_hasFill = true; //测试
  },
  getGradient: function getGradient() {
    return this.m_gradient;
  },
  /**
   *
   * @param gradient_ {MMGradient}
   */
  setGradient: function setGradient(gradient_) {
    this.m_gradient = gradient_;
  },
  isEmpty: function isEmpty() {
    return this.m_fillColor.isEmpty() && this.m_hasFill;
  },
  setContext: function setContext(ctx, trsfm, pgIndex) {
    if (!this.m_hasFill || this.isEmpty()) {
      if (!this.m_notGradient) {
        this.m_gradient.setContext(ctx, trsfm, pgIndex);
      } else {
        ctx.fillStyle = "rgba(0, 0, 0, 0)";
      }
    } else {
      if (this.m_fillColor == null) {
        ctx.fillStyle = "#000000";
      } else {
        ctx.fillStyle = this.m_fillColor.getRGBA();
      }
    }
  },
  getFill: function getFill() {
    return this.m_hasFill;
  },
  setFill: function setFill(flag_) {
    this.m_hasFill = flag_;
  },
  clone: function clone() {
    var newtype = new MMFillType();
    newtype.m_hasFill = this.m_hasFill;
    newtype.m_notGradient = this.m_notGradient;
    newtype.m_fillColor = this.m_fillColor.clone(); //MMColor
    newtype.m_gradient = this.m_gradient.clone(); //MMGradient
    return newtype;
  }
});
var _default = exports["default"] = MMFillType;

},{"1080":1080,"1184":1184,"1454":1454,"794":794,"796":796}],796:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MMGradient;
var _GradientDirection = _interopRequireDefault(require(803));
var _MMMeta = _interopRequireDefault(require(1080));
var _MMColor = _interopRequireDefault(require(794));
var _MMPoint = _interopRequireDefault(require(830));
function MMGradient(isLineGradient_, startPt_, endPt_, startColor_, endColor_, index_) {
  _MMMeta["default"].call(this, null);
  this.m_className = "MMGradient";
  this.m_ver = 0;
  this.m_isLineGradient = isLineGradient_ ? isLineGradient_ : false; //Bool
  this.m_startPoint = startPt_ ? startPt_ : new _MMPoint["default"](); //MMDvPoint
  this.m_endPoint = endPt_ ? endPt_ : new _MMPoint["default"](); //MMDvPoint
  this.m_startColor = startColor_ ? startColor_ : new _MMColor["default"](); //MMColor
  this.m_endColor = endColor_ ? endColor_ : new _MMColor["default"](); //MMColor
  this.m_gradientIndex = index_ ? index_ : 0; //int

  this.m_GradientDir = _GradientDirection["default"].NOGradient;
}
;
MMGradient.prototype = new _MMMeta["default"](); //
MMGradient.superclass = _MMMeta["default"].prototype;
MMGradient.prototype.encode = function (enc_) {
  //  MMGradient.superclass.encode.call(this, enc_) ;
  var _objVer = 0;
  enc_.encode4Bytes(_objVer);
  enc_.encodeBool(this.m_isLineGradient);
  enc_.encode4Bytes(this.m_GradientDir);
  enc_.encodeMMPoint(this.m_startPoint);
  enc_.encodeMMPoint(this.m_endPoint);
  enc_.encodeObject(this.m_startColor);
  enc_.encodeObject(this.m_endColor);
  enc_.encode4Bytes(this.m_gradientIndex);
};
MMGradient.prototype.clone = function (enc_) {
  //  MMGradient.superclass.encode.call(this, enc_) ;
  var newObj = new MMGradient();
  newObj.m_ver = 0;
  newObj.m_isLineGradient = this.m_isLineGradient;
  newObj.m_startPoint = this.m_startPoint.clone();
  newObj.m_endPoint = this.m_endPoint.clone();
  newObj.m_startColor = this.m_startColor.clone();
  newObj.m_endColor = this.m_endColor.clone();
  newObj.m_gradientIndex = this.m_gradientIndex;
  newObj.m_GradientDir = this.m_GradientDir;
  return newObj;
};
MMGradient.prototype.decode = function (dec_, ver_) {
  //  MMGradient.superclass.decode.call(this, dec_, ver_) ;

  var _objVer = dec_.decodeFrom4Bytes(ver_);
  this.m_ver = _objVer;
  this.m_isLineGradient = dec_.decodeFromBool(ver_);
  this.m_GradientDir = dec_.decodeFrom4Bytes(ver_);
  this.m_startPoint = dec_.decodeFromMMPoint(ver_);
  this.m_endPoint = dec_.decodeFromMMPoint(ver_);
  this.m_startColor = dec_.decodeFromObject(ver_);
  this.m_endColor = dec_.decodeFromObject(ver_);
  this.m_gradientIndex = dec_.decodeFrom4Bytes(ver_);
  this.m_startPoint.x = 332;
  this.m_startPoint.y = 217;
};
MMGradient.prototype.setContext = function (ctx, trsfm, pgIndex) {
  var p0 = trsfm.lg2dvPoint(this.m_startPoint, pgIndex);
  var p1 = trsfm.lg2dvPoint(this.m_endPoint, pgIndex);
  var my_gradient = null;
  if (this.m_isLineGradient) {
    my_gradient = ctx.createLinearGradient(p0.x, p0.y, p1.x, p1.y);
    my_gradient.addColorStop(0, this.m_startColor.getRGBA());
    my_gradient.addColorStop(1, this.m_endColor.getRGBA());
  } else {}
  ctx.fillStyle = my_gradient;
};
MMGradient.prototype.initWithObjRectAndAngle = function (rect, angle) {
  var minX = rect.left;
  var minY = rect.top;
  var maxX = rect.right;
  var maxY = rect.bottom;
  var center = rect.getCenter();
  switch (this.m_GradientDir) {
    case 0:
      this.m_startPoint.x = minX;
      this.m_startPoint.y = minY;
      this.m_endPoint.x = maxX;
      this.m_endPoint.y = minY;
      break;
    case 1:
      this.m_startPoint.x = maxX;
      this.m_startPoint.y = minY;
      this.m_endPoint.x = minX;
      this.m_endPoint.y = minY;
      break;
    case 2:
      this.m_startPoint.x = maxX;
      this.m_startPoint.y = minY;
      this.m_endPoint.x = maxX;
      this.m_endPoint.y = maxY;
      break;
    case 3:
      this.m_startPoint.x = maxX;
      this.m_startPoint.y = maxY;
      this.m_endPoint.x = maxX;
      this.m_endPoint.y = minY;
      break;
    case 4:
      this.m_startPoint.x = minX;
      this.m_startPoint.y = minY;
      this.m_endPoint.x = maxX;
      this.m_endPoint.y = maxY;
      break;
    case 5:
      this.m_startPoint.x = maxX;
      this.m_startPoint.y = maxY;
      this.m_endPoint.x = minX;
      this.m_endPoint.y = minY;
      break;
    case 6:
      this.m_startPoint.x = minX;
      this.m_startPoint.y = maxY;
      this.m_endPoint.x = maxX;
      this.m_endPoint.y = minY;
      break;
    case 7:
      this.m_startPoint.x = maxX;
      this.m_startPoint.y = minY;
      this.m_endPoint.x = minX;
      this.m_endPoint.y = maxY;
      break;
  }
  this.m_startPoint.rotateDegrees(angle, center);
  this.m_endPoint.rotateDegrees(angle, center);
};

},{"1080":1080,"1184":1184,"1454":1454,"794":794,"803":803,"830":830}],803:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var GradientDirection = {
  FromLeftToRight: 0,
  FromRightToLeft: 1,
  FromTopToBottom: 2,
  FromBottomToTop: 3,
  FromLeftTopToRightBottom: 4,
  FromTightBottomToLeftTop: 5,
  FromLeftBottomToRightTop: 6,
  FromRightTopToLeftBottom: 7,
  NOGradient: 8
};
var _default = exports["default"] = GradientDirection;

},{"1454":1454}],794:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1466);
require(1429);
require(1437);
require(1463);
require(1478);
var _MMMeta = _interopRequireDefault(require(1080));
function MMColor() {
  _MMMeta["default"].call(this, null);
  this.m_className = "MMColor";
  this.m_ver = 1; // 存储颜色时的版本号
  this.m_r = 0;
  this.m_g = 0;
  this.m_b = 0;
  this.m_alpha = 1.0;
}
;
MMColor.prototype = new _MMMeta["default"]();
MMColor.superclass = _MMMeta["default"].prototype;
_.extend(MMColor.prototype, {
  encode: function encode(enc_) {
    //	MMColor.superclass.encode.call(this, enc_) ;
    var _objVer = 0;
    enc_.encode4Bytes(_objVer);
    enc_.encodeFloat(this.m_r);
    enc_.encodeFloat(this.m_g);
    enc_.encodeFloat(this.m_b);
    enc_.encodeFloat(this.m_alpha);
  },
  clone: function clone() {
    var newColor = new MMColor();
    newColor.m_r = this.m_r;
    newColor.m_g = this.m_g;
    newColor.m_b = this.m_b;
    newColor.m_alpha = this.m_alpha;
    return newColor;
  },
  decode: function decode(dec_, ver_) {
    //	MMColor.superclass.decode.call(this, dec_, ver_) ;

    var _objVer = dec_.decodeFrom4Bytes(ver_);
    this.m_ver = _objVer;
    this.m_r = dec_.decodeFromFloat(ver_);
    this.m_g = dec_.decodeFromFloat(ver_);
    this.m_b = dec_.decodeFromFloat(ver_);
    this.m_alpha = dec_.decodeFromFloat(ver_);
  },
  getRGBA: function getRGBA(lineWidth) {
    if (lineWidth == undefined || lineWidth < 0) lineWidth = 1;
    if (lineWidth == 0) console.log("line widht :" + lineWidth);
    var alpha = this.m_alpha;
    if (this.m_alpha > 0.4) {
      if (lineWidth < 1) alpha *= lineWidth;
      if (alpha < 0.4) {
        //			console.log("--------> alpha:" + alpha);
        alpha = 0.4;
      }
    }
    var rgbStr = "rgba(" + Math.floor(this.m_r * 256) + "," + Math.floor(this.m_g * 256) + "," + Math.floor(this.m_b * 256) + "," + alpha + ")";
    if (alpha < 0.5) {
      //		console.log(rgbStr);
    }
    return rgbStr;
  },
  setColorByVec4: function setColorByVec4(vec4) {
    this.m_alpha = vec4.w;
    this.m_r = vec4.x;
    this.m_g = vec4.y;
    this.m_b = vec4.z;
  },
  isEmpty: function isEmpty() {
    return this.m_alpha < 0.001;
  },
  fromString: function fromString(str_) {
    console.assert(str_[0] == '#');
    this.m_r = parseInt("0x" + str_.slice(1, 3)) / 255.;
    this.m_g = parseInt("0x" + str_.slice(3, 5)) / 255.;
    this.m_b = parseInt("0x" + str_.slice(5, 7)) / 255.;
    this.m_alpha = 1.0;
  },
  toString: function toString() {
    var r = Math.round(this.m_r * 255).toString(16);
    if (r.length < 2) {
      r = '0' + r;
    }
    ;
    var g = Math.round(this.m_g * 255).toString(16);
    if (g.length < 2) {
      g = '0' + g;
    }
    ;
    var b = Math.round(this.m_b * 255).toString(16);
    if (b.length < 2) {
      b = '0' + b;
    }
    ;
    return '#' + r + g + b;
  }
});
var _default = exports["default"] = MMColor;

},{"1080":1080,"1184":1184,"1429":1429,"1437":1437,"1454":1454,"1463":1463,"1466":1466,"1478":1478}],829:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1450);
var _MMPoint = _interopRequireDefault(require(830));
var _MMRect = _interopRequireDefault(require(831));
/**
 * 常用数学类
 * jiang
 * 2014-5-21
 */

function MMCenterRect() {
  this.center = null;
  this.width = 0;
  this.height = 0;
  this.angle = 0;
}
;
MMCenterRect.prototype.setRect = function (rct) {
  this.center = new _MMPoint["default"]((rct.left + rct.right) / 2, (rct.top + rct.bottom) / 2);
  this.width = rct.getWidth();
  this.height = rct.getHeight();
};
MMCenterRect.prototype.setAngle = function (angle) {
  this.angle = angle;
};
MMCenterRect.prototype.getRect = function () {
  return new _MMRect["default"](this.center.y - this.height / 2, this.center.x + this.width / 2, this.center.y + this.height / 2, this.center.x - this.width / 2);
};
MMCenterRect.prototype.getLeftTop = function () {
  var lt = new _MMPoint["default"](this.center.x - this.width / 2, this.center.y - this.height / 2);
  return lt;
};
MMCenterRect.prototype.debugOutput = function (head) {
  console.log(head + "center(x,y):(" + this.center.x.toFixed(3) + "," + this.center.y.toFixed(3) + ") -- (w, h):" + this.width.toFixed(3) + "," + this.height.toFixed(3));
};
var _default = exports["default"] = MMCenterRect;

},{"1184":1184,"1450":1450,"1454":1454,"830":830,"831":831}],1043:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1418);
require(1463);
require(1537);
require(1432);
require(1437);
require(1478);
var _map = _interopRequireDefault(require(821));
var _CommentStatus = _interopRequireDefault(require(1036));
var _MMCommentDataController = _interopRequireDefault(require(1097));
/**
 *
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMCircleData}
 */
function MMCommentBasicData() {
  this.m_userReadStatus = new _map["default"]();
  this.m_userPraised = [];
  this.m_isFinished = false;
  this.m_commentType = 0;
}
;
MMCommentBasicData.prototype.encode = function (enc_) {
  var objVer = 2;
  enc_.encode4Bytes(objVer);

  //for compatibility
  enc_.encode4Bytes(0);
  enc_.encode4Bytes(this.m_userReadStatus.getCount());
  this.m_userReadStatus.forEach(function (value_, key_) {
    enc_.encode8Bytes(key_);
    enc_.encode4Bytes(value_);
  });
  enc_.encode4Bytes(this.m_userPraised.length);
  for (var i = 0; i < this.m_userPraised.length; i++) {
    enc_.encode8Bytes(this.m_userPraised[i]);
  }
  enc_.encodeBool(this.m_isFinished);
  enc_.encode4Bytes(this.m_commentType);
};
MMCommentBasicData.prototype.decode = function (dec_, ver_) {
  var objVer = dec_.decodeFrom4Bytes(ver_);
  var itemLength = dec_.decodeFrom4Bytes(ver_);
  console.assert(itemLength == 0);
  this.m_userReadStatus.clear();
  var count = dec_.decodeFrom4Bytes(ver_);
  for (var i = 0; i < count; i++) {
    var userId = dec_.decodeFrom8Bytes(ver_);
    var status = dec_.decodeFrom4Bytes(ver_);
    this.m_userReadStatus.set(userId, status);
  }
  if (objVer >= 2) {
    this.m_userPraised = [];
    var length = dec_.decodeFrom4Bytes(ver_);
    for (var i = 0; i < length; i++) {
      var uId = dec_.decodeFrom8Bytes(ver_);
      this.m_userPraised.push(uId);
    }
    this.m_isFinished = dec_.decodeFromBool(ver_);
    this.m_commentType = dec_.decodeFrom4Bytes(ver_);
  }
};
MMCommentBasicData.prototype.getReadStatus = function (userId, creatorId) {
  var status = _CommentStatus["default"].Comment_unread;
  if (userId.isEqualTo(creatorId)) {
    status = _CommentStatus["default"].Comment_newReply;
  }
  var temp = this.m_userReadStatus.get(userId);
  if (temp) status = temp;
  return status;
};
MMCommentBasicData.prototype.setReadStatus = function (userId, status_) {
  this.m_userReadStatus.set(userId, status_);
};
MMCommentBasicData.prototype.setRead = function (usrId) {
  this.m_userReadStatus.set(usrId, _CommentStatus["default"].Comment_read);
};
MMCommentBasicData.prototype.setHasNewReplyFromUser = function (replier) {
  var that = this;
  this.m_userReadStatus.forEach(function (value_, key_) {
    if (!key_.isEqualTo(replier)) {
      that.m_userReadStatus.set(key_, _CommentStatus["default"].Comment_newReply);
    }
  });
  this.m_userReadStatus.set(replier, _CommentStatus["default"].Comment_read);
};
MMCommentBasicData.prototype.praise = function (userId_) {
  for (var i = 0; i < this.m_userPraised.length; i++) {
    if (this.m_userPraised[i].valueOf() == userId_.valueOf()) {
      return;
    }
  }
  this.m_userPraised.push(userId_);
};
MMCommentBasicData.prototype.unPraise = function (userId_) {
  for (var i = 0; i < this.m_userPraised.length; i++) {
    if (this.m_userPraised[i].valueOf() == userId_.valueOf()) {
      this.m_userPraised.splice(i, 1);
      break;
    }
  }
};
MMCommentBasicData.prototype.isPraised = function (userId_) {
  for (var i = 0; i < this.m_userPraised.length; i++) {
    if (this.m_userPraised[i].valueOf() == userId_.valueOf()) {
      return true;
    }
  }
  return false;
};
MMCommentBasicData.prototype.setFinished = function (finished_) {
  this.m_isFinished = finished_;
};
MMCommentBasicData.prototype.isFinished = function () {
  return this.m_isFinished;
};
MMCommentBasicData.prototype.fetchChatlog = function (objId, callback) {
  var self = this;
  _MMCommentDataController["default"].getCommentMessages(objId.toString(), function success(messages) {
    self.msgObjs = messages;
    if (callback) {
      callback(self.msgObjs);
    }
    ;
    self.chatlogFatched = true;
  }, function failed() {
    if (callback) {
      callback();
    }
    ;
  });
};
var _default = exports["default"] = MMCommentBasicData;

},{"1036":1036,"1097":1097,"1184":1184,"1418":1418,"1432":1432,"1437":1437,"1454":1454,"1463":1463,"1478":1478,"1537":1537,"821":821}],1097:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1418);
require(1463);
require(1537);
var _ObjVisibleScope = _interopRequireDefault(require(1085));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MMChatMessage = _interopRequireDefault(require(950));
var _MDSnackbarView = _interopRequireDefault(require(72));
//
// MMCommentDataController
// 2016-02-16
//

var MMCommentDataController = {
  /**
   * execute a pomelo request, with defaultParams
   * @param route {string} the method to call
   * @param msg optional {object} the parameter for the remote method
   * @param callback {function} the response callback
   */
  request: function request(route, msg, callback) {
    _MMNetDiskDataController["default"].request(route, msg, callback);
  },
  getFileCommentInfos: function getFileCommentInfos(fileId, success, fail) {
    var route = "netDrive.fileHandler.getFileCommentInfos";
    MMCommentDataController.request(route, {
      "fileId": fileId
    }, function (res) {
      setBabelTimeout(function () {
        if (res["resultCode"] === 0) {
          var out = [];
          if (res["infos"]) {
            res["infos"].forEach(function (info) {
              var commentInfo = {
                id: info["id"],
                createTime: info["cTime"] * 1000,
                unreadedCount: info["unreadReplyCount"] || 0,
                completed: info["completed"],
                creator: info["creator"],
                fileId: info["fileId"],
                creatorName: info["creatorName"],
                version: info["version"],
                message: info["message"],
                //json
                visibleScope: info['visibleScope'],
                evalMark: info['visibleScope'] >= 8,
                messageSender: info['messageSender'],
                messageSenderName: info['messageSenderName']
              };
              out.push(commentInfo);

              // if (!commentInfo.visibleScope) {

              //   out.push(commentInfo);

              // } else {

              //   if (app.isEpVersion() && !app.currentUser.isEnterpriseGuest() && MDPcMobileEditorCommonFun.currentFileBelongsToCurUserEnterprise()) {
              //     if (commentInfo.visibleScope == ObjVisibleScope.privateObject) {
              //       var uid = app.currentUser.getUserId();
              //       var cid = commentInfo.creator;
              //       if (uid == cid) {
              //         out.push(commentInfo)
              //       }
              //     } else {
              //       out.push(commentInfo);
              //     }
              //   };
              // }
            });
          }

          // sort by time and unread count
          for (var i = 0; i < out.length - 1; i++) {
            var info1 = out[i];
            for (var k = i + 1; k < out.length; k++) {
              var info2 = out[k];
              var needSwap = false;
              if (info2.unreadedCount > 0) {
                if (info1.unreadedCount == 0 || info1.unreadedCount > 0 && info2.createTime > info1.createTime) {
                  needSwap = true;
                }
              } else {
                if (info1.unreadedCount == 0 && info2.createTime > info1.createTime) {
                  needSwap = true;
                }
                ;
              }
              out[i] = info2;
              out[k] = info1;
              info1 = info2;
            }
            ;
          }
          ;
          success(out);
        } else {
          fail(res["resultCode"]);
        }
      }, 0);
    });
  },
  /**
   *  get the all the comment infos in a file for the version
   *
   *   TODO: Tobias
   */
  getFileCommentInfosForVersion: function getFileCommentInfosForVersion(fileId, version, success, fail) {
    MMCommentDataController.getFileCommentInfos(fileId, function (commentInfos) {
      var out = [];
      var i;
      for (i = 0; i < commentInfos.length; i++) {
        var info = commentInfos[i];
        if (info.version == version || version == -1) {
          out.push(info);
        }
        ;
      }
      ;

      // sort by time and unread count
      for (i = 0; i < out.length - 1; i++) {
        var info1 = out[i];
        for (var k = i + 1; k < out.length; k++) {
          var info2 = out[k];
          var needSwap = false;
          if (info2.unreadedCount > 0) {
            if (info1.unreadedCount == 0 || info1.unreadedCount > 0 && info2.createTime > info1.createTime) {
              needSwap = true;
            }
          } else {
            if (info1.unreadedCount == 0 && info2.createTime > info1.createTime) {
              needSwap = true;
            }
            ;
          }
          if (needSwap) {
            out[i] = info2;
            out[k] = info1;
            info1 = info2;
          }
        }
        ;
      }
      ;
      success(out);
    }, function () {
      _MDSnackbarView["default"].showStandardMsg(4);
      if (fail) {
        fail();
      }
      ;
    });
  },
  getCommentMessages: function getCommentMessages(commentId, success, fail) {
    var route = "netDrive.fileHandler.getCommentMessages";
    MMCommentDataController.request(route, {
      "commentId": commentId
    }, function (res) {
      setBabelTimeout(function () {
        var out = [];
        if (res["messages"]) {
          res["messages"].forEach(function (message) {
            //crate messageOBJs
            var msgObj = new _MMChatMessage["default"](message['id'], message['sender'], 0, message['sendTime'] * 1000, message['senderName'], message['message'], message['commentId']);
            out.push(msgObj);
          });
        }
        success(out);
      }, 0);
    });
  },
  accessComment: function accessComment(commentId, success, fail) {
    var route = "netDrive.fileHandler.accessComment";
    MMCommentDataController.request(route, {
      "commentId": commentId
    }, function (res) {
      setBabelTimeout(function () {
        if (res["resultCode"] === 0) {
          if (success) success();
        } else {
          if (fail) fail(res["resultCode"]);
        }
      }, 0);
    });
  },
  completeComment: function completeComment(commentId, completed, success, fail) {
    var route = "netDrive.fileHandler.completeComment";
    MMCommentDataController.request(route, {
      "commentId": commentId,
      "completed": completed
    }, function (res) {
      setBabelTimeout(function () {
        if (res["resultCode"] === 0) {
          if (success) success();
        } else {
          if (fail) fail(res["resultCode"]);
        }
      }, 0);
    });
  },
  getCommentReadSatus: function getCommentReadSatus(commentId, success, fail) {
    var route = "netDrive.fileHandler.completeComment";
    MMCommentDataController.request('netDrive.fileHandler.getCommentReadStatus', {
      commentId: commentId
    }, function (res) {
      setBabelTimeout(function () {
        if (res["resultCode"] === 0) {
          if (success) success(res['commentUnReadCount']);
        } else {
          if (fail) fail(res["resultCode"]);
        }
      }, 0);
    });
  }
};
var _default = exports["default"] = MMCommentDataController;

},{"1085":1085,"1104":1104,"1184":1184,"1418":1418,"1454":1454,"1463":1463,"1537":1537,"72":72,"950":950}],1104:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require(1192));
require(1437);
require(1432);
require(1415);
require(1463);
require(1426);
require(1418);
require(1537);
require(1422);
require(1439);
require(1435);
require(1478);
require(1541);
require(1455);
require(1461);
require(1466);
require(1423);
require(1443);
require(1487);
require(1538);
require(1412);
require(1428);
require(1451);
var _MDEvaluationStatus = _interopRequireDefault(require(254));
var _MDLevel = _interopRequireDefault(require(263));
var _MDMessage = _interopRequireDefault(require(270));
var _MDMessageType = _interopRequireDefault(require(271));
var _MDEvents = _interopRequireDefault(require(325));
var _MDSalonMsg = _interopRequireDefault(require(205));
var _MDContact = _interopRequireDefault(require(243));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _tStabilizer = _interopRequireDefault(require(107));
var _MDConversation = _interopRequireDefault(require(245));
var _MMFileInfoCollection = _interopRequireDefault(require(298));
var _MDMolaUser = _interopRequireDefault(require(272));
var _FILE_ACTION_BITS = _interopRequireDefault(require(235));
var _MMFileInfo = _interopRequireDefault(require(297));
var _MMFileType = _interopRequireDefault(require(303));
var _MDTeamInfo = _interopRequireDefault(require(289));
var _MDFileAccessInfo = _interopRequireDefault(require(255));
var _MDConversationCollection = _interopRequireDefault(require(246));
var _MMVersionInfoCollection = _interopRequireDefault(require(311));
var _MMVersionInfo = _interopRequireDefault(require(310));
var _MDRoleInfoCollection = _interopRequireDefault(require(282));
var _MDShareParticipantCollection = _interopRequireDefault(require(285));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDBrowserNotificator = _interopRequireDefault(require(315));
var _regexp = _interopRequireDefault(require(106));
var _MDFileLog = _interopRequireDefault(require(256));
var _MDFileLogCollection = _interopRequireDefault(require(257));
var _MDEvaluationInfo = _interopRequireDefault(require(253));
var _MDEvaluationFlowInfo = _interopRequireDefault(require(252));
var _MDDepartment = _interopRequireDefault(require(247));
var _MDNetDriveFileHandler = _interopRequireDefault(require(1091));
var _MDWebMessageController = _interopRequireDefault(require(1095));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDChannelType = _interopRequireDefault(require(717));
var _MDSelfMessageController = _interopRequireDefault(require(1092));
var _SystemError = _interopRequireDefault(require(1110));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDConstant = _interopRequireDefault(require(321));
var _ErrorCode = _interopRequireDefault(require(1087));
var _app = _interopRequireDefault(require(17));
var _MDUploadFile = _interopRequireDefault(require(341));
var _part = _interopRequireDefault(require(1105));
var _part2 = _interopRequireDefault(require(1106));
var _utils = _interopRequireDefault(require(108));
/*jshint sub:true*/
/*jslint nomen: true, vars: true, plusplus:true, browser:true */
/*global console, app, goog, $, _, Backbone,MMFileInfo, MMFileType */

//
//  网络访问的接口实现
//  javascript/net/MMNetDiskDataController.js
//  created by jiang, and modified by tobias, and tobias is responsible for MMNetDiskDataController file.
// 2015-8-27
//

var MMNetDiskDataController = {
  _connector: null,
  curDirectoryId: 0,
  // current folder id
  curFileInfoList: null,
  // current file info collection, type : MMFileInfoCollection

  initialize: function initialize() {
    _MDWebMessageController["default"].initialize();
    _MDSelfMessageController["default"].initialize();
  },
  setConnector: function setConnector(connector) {
    MMNetDiskDataController._connector = connector;
    _MDNetDriveFileHandler["default"]._connector = connector;
  },
  /**
   * execute a pomelo request, with defaultParams
   * @param route {string} the method to call
   * @param msg optional {object} the parameter for the remote method
   * @param callback {function} the response callback
   */
  request: function request(route, msg, callback) {
    MMNetDiskDataController._connector.request(route, msg, callback);
  },
  /* ---------------------------------------- file and directory -------------------------------------- */
  getHomeDir: function getHomeDir(success) {
    var currentUser = _app["default"].currentUser;
    var currentUserId = currentUser.getUserId();
    var currentUserName = currentUser.get("name");
    var actions = _FILE_ACTION_BITS["default"].READ | _FILE_ACTION_BITS["default"].WRITE | _FILE_ACTION_BITS["default"].UPLOAD;
    if (_app["default"].isEpVersion() && currentUser.isEnterpriseGuest()) {
      actions = 0;
      currentUserId = null;
      currentUserName = "";
    }
    var fileInfo = new _MMFileInfo["default"]({
      actions: actions,
      fileId: "0",
      parentId: "-1",
      type: _MMFileType["default"].FOLDER,
      name: BabelStr.str(7372),
      fileName: BabelStr.str(11),
      //  '全部文件',
      ownerId: currentUserId,
      creatorId: currentUserId,
      lastModifyUserId: currentUserId,
      ownerName: currentUserName,
      creatorName: currentUserName,
      lastModifyUserName: currentUserName
    });
    success && success(fileInfo);
    return fileInfo;
  },
  getFileTreeRootFoldersOnlyDep: function getFileTreeRootFoldersOnlyDep(parentId, orderName, isAsc, page, pageSize, success, fail, params) {
    var files = [{
      //企业文件
      fileId: "0--001",
      type: _MMFileType["default"].FOLDER,
      actions: 1029,
      teamMark: 2,
      fileName: BabelStr.str(337)
    }];
    var out = new _MMFileInfoCollection["default"](files);
    success(out);
  },
  getFileTreeRootFolders: function getFileTreeRootFolders(parentId, orderName, isAsc, page, pageSize, success, fail, params) {
    var files = [];
    if (_app["default"].isEpVersion()) {
      files.push({
        //企业文件
        fileId: "0--001",
        type: _MMFileType["default"].FOLDER,
        actions: 1029,
        teamMark: 2,
        fileName: BabelStr.str(337)
      });
    }
    files.push({
      //个人文件
      fileId: "0--002",
      type: _MMFileType["default"].FOLDER,
      actions: 1029,
      personAllFile: true,
      fileName: BabelStr.str(5010)
    });
    if (_app["default"].isEpVersion()) {
      if (_app["default"].currentUser.isEpManager()) {
        files.push({
          //项目
          fileId: "0--006",
          type: _MMFileType["default"].FOLDER,
          actions: 1029,
          teamMark: 5,
          fileName: BabelStr.str(6557)
        });
      }
      files.push({
        //项目
        fileId: "0--003",
        type: _MMFileType["default"].FOLDER,
        actions: 1029,
        teamMark: 5,
        fileName: BabelStr.str(4776)
      });
    } else {
      files.push({
        //团队
        fileId: "0--005",
        type: _MMFileType["default"].FOLDER,
        actions: 1029,
        teamMark: 1,
        fileName: BabelStr.str(17)
      });
    }
    files.push({
      ///参与分享
      fileId: "0--004",
      type: _MMFileType["default"].FOLDER,
      actions: 1029,
      isSharing: true,
      fileName: BabelStr.str(20)
    });
    var out = new _MMFileInfoCollection["default"](files);
    success(out);
  },
  getFileTreeRootFoldersLibrary: function getFileTreeRootFoldersLibrary(parentId, orderName, isAsc, page, pageSize, success, fail, params) {
    var fileId = window.materialLibrary.fileId;
    MMNetDiskDataController.getFileInfoFromServer(fileId, function (file) {
      var files = [file];
      var out = new _MMFileInfoCollection["default"](files);
      success(out);
    }, fail);
  },
  getFileTreeRootFoldersOnlyEp: function getFileTreeRootFoldersOnlyEp(parentId, orderName, isAsc, page, pageSize, success, fail, params) {
    var files = [];
    files.push({
      //企业文件
      fileId: "0--001",
      type: _MMFileType["default"].FOLDER,
      actions: 1029,
      teamMark: 2,
      fileName: BabelStr.str(337)
    });
    var out = new _MMFileInfoCollection["default"](files);
    success(out);
  },
  getDirByChannelRouter: function getDirByChannelRouter(channelRouter, success) {
    var currentUser = _app["default"].currentUser;
    var currentUserId = currentUser.getUserId();
    var currentUserName = currentUser.get("name");
    var actions = _FILE_ACTION_BITS["default"].READ | _FILE_ACTION_BITS["default"].WRITE | _FILE_ACTION_BITS["default"].UPLOAD;
    if (_app["default"].isEpVersion() && currentUser.isEnterpriseGuest()) {
      actions = 0;
      currentUserId = null;
      currentUserName = "";
    }
    var fileName = "";
    switch (channelRouter) {
      case "myshare":
        fileName = BabelStr.str(19);
        break;
      case "personfile":
        fileName = BabelStr.str(5010);
        break;
      case "epfile":
        fileName = BabelStr.str(337);
        actions = _FILE_ACTION_BITS["default"].READ;
        break;
      case "recently":
        fileName = BabelStr.str(383);
        actions = _FILE_ACTION_BITS["default"].READ;
        break;
      case "project":
        fileName = BabelStr.str(4776);
        actions = _FILE_ACTION_BITS["default"].READ;
        break;
      case "allproject":
        fileName = BabelStr.str(6557);
        actions = _FILE_ACTION_BITS["default"].READ;
        break;
      case "joinshare":
        fileName = BabelStr.str(20);
        break;
      case "library":
        fileName = BabelStr.str(12500);
        break;
      case "myfocus":
        fileName = BabelStr.str(144);
        break;
      case "msbox":
        fileName = BabelStr.str(145);
        break;
      case "evaluation":
        fileName = BabelStr.str(146);
        break;
      case "team":
        fileName = BabelStr.str(17);
        break;
      case "trash":
        fileName = BabelStr.str(22);
        break;
      case "archive":
        fileName = BabelStr.str(2700);
        break;
      case "borrowedArchive":
        fileName = BabelStr.str(2715);
        break;
      case "myArchiveApply":
        fileName = BabelStr.str(40149);
        break;
      case "classificationapproval":
        fileName = BabelStr.str(2701);
        break;
      case "archiveLibrary":
        fileName = BabelStr.str(40142);
        break;
      case "ArchiveApplyToReview":
        fileName = BabelStr.str(2702);
        break;
      case "archivehistory":
        fileName = BabelStr.str(2731);
        break;
      case "transfer":
        fileName = BabelStr.str(6893);
        break;
      case "webai":
        fileName = BabelStr.str(13040);
        actions = _FILE_ACTION_BITS["default"].READ;
        break;
      default:
        fileName = BabelStr.str(11);
        break;
    }
    var fileInfo = new _MMFileInfo["default"]({
      actions: actions,
      fileId: "0",
      parentId: "-1",
      type: _MMFileType["default"].FOLDER,
      name: BabelStr.str(7372),
      fileName: fileName,
      //  '全部文件',
      ownerId: currentUserId,
      creatorId: currentUserId,
      lastModifyUserId: currentUserId,
      ownerName: currentUserName,
      creatorName: currentUserName,
      lastModifyUserName: currentUserName
    });
    if (channelRouter == "epfile") {
      fileInfo.set("teamMark", 2);
    } else if (channelRouter == "personfile") {
      fileInfo.set("personAllFile", true);
    }
    success && success(fileInfo);
    return fileInfo;
  },
  getTrash: function getTrash() {
    var currentUser = _app["default"].currentUser;
    var currentUserId = currentUser.getUserId();
    var currentUserName = currentUser.get("name");
    var trashBin = new _MMFileInfo["default"]({
      fileId: 0,
      "type:": _MMFileType["default"].FOLDER,
      fileName: BabelStr.str(22),
      //  "回收站",
      parentId: "-1",
      ownerId: currentUserId,
      creatorId: currentUserId,
      lastModifyUserId: currentUserId,
      ownerName: currentUserName,
      creatorName: currentUserName,
      lastModifyUserName: currentUserName,
      isTrashFolder: true,
      inTrash: 1
    });
    trashBin.listDir = function (success, fail) {
      MMNetDiskDataController.listBin(this.getFileId(), success, fail);
    };
    return trashBin;
  },
  getArchive: function getArchive(success, fail) {
    // if (MMEnterpriseController.archiveRoot) {
    //   success(MMEnterpriseController.archiveRoot);
    // } else {
    //   MMEnterpriseController.getRootDepartmentFolder(function(dep) {
    //     MMEnterpriseController.archiveRoot = dep;
    //     success(dep);
    //   }, function(code){
    //     fail && fail(code);
    //   })

    // }

    var currentUser = _app["default"].currentUser;
    var currentUserId = currentUser.getUserId();
    var currentUserName = currentUser.get("name");
    var actions = _FILE_ACTION_BITS["default"].READ;
    if (_app["default"].currentUser.canManageArchive()) {
      actions = actions | _FILE_ACTION_BITS["default"].MOVE;
    }
    var fileInfo = new _MMFileInfo["default"]({
      actions: actions,
      fileId: "0",
      parentId: "-1",
      type: _MMFileType["default"].FOLDER,
      name: BabelStr.str(40142),
      fileName: BabelStr.str(40142),
      //  '全部文件',
      ownerId: currentUserId,
      creatorId: currentUserId,
      lastModifyUserId: currentUserId,
      ownerName: currentUserName,
      creatorName: currentUserName,
      lastModifyUserName: currentUserName
    });
    // fileInfo.isArchiveHouse = true;
    success && success(fileInfo);
    return fileInfo;
  },
  LISTTYPES: _MDNetDriveFileHandler["default"].LISTTYPES,
  //
  // 列出指定文件夹的内容 use folderid 0 to query the current users homedirectory
  // cache object = {
  //    reqTime , folderId, type, succsee, fail, readInfoSuccess, page, pageSize
  // }
  listDir: function listDir(folderId, type, success, fail, readInfoSuccess, page, pageSize) {
    // MMNetDiskDataController.checkEpUserLogined(()=>{
    if (!MMNetDiskDataController.cache) {
      MMNetDiskDataController.cache = {};
    }
    console.log("------- list dir id:", folderId);
    if (folderId == 1508485689344) {
      var x = 0;
      console.log("------- this folder");
    }
    var cache = MMNetDiskDataController.cache;
    var requestObj = {
      reqTime: new Date(),
      folderId: folderId,
      type: type,
      success: success,
      fail: fail,
      readInfoSuccess: readInfoSuccess,
      page: page,
      pageSize: pageSize
    };
    if (!cache[folderId]) {
      cache[folderId] = [];
    }
    var queue = cache[folderId];
    var curTime = new Date();
    var i = 0;
    var removeHappened = false;
    while (i < queue.length) {
      var req = queue[i];
      if (curTime - req.reqTime > 5000) {
        queue.splice(i, 1);
        removeHappened = true;
        continue;
      }
      i++;
    }
    cache[folderId].push(requestObj);
    if (cache[folderId].length == 1 || removeHappened) {
      MMNetDiskDataController._listDirForNextRequest(folderId);
    } else {
      console.log("-------queue folder id:", folderId);
    }
    // })
  },
  returnBorrow: function returnBorrow(applicationId, success, fail) {
    _MDNetDriveFileHandler["default"].returnBorrow(applicationId, success, fail);
  },
  //常用文件
  getRecentlyUsedFile: function getRecentlyUsedFile(success, fail, readInfoSuccess) {
    _MDNetDriveFileHandler["default"].getRecentlyUsedFile(function (fileCollection) {
      success(fileCollection);
      var param = {
        channelroot: _MDConstant["default"].ChannelRoot.MyRecent
      };
      MMNetDiskDataController.get2ndFileInfo(fileCollection.models, param, readInfoSuccess);
    }, fail);
  },
  _listDirForNextRequest: function _listDirForNextRequest(folderId) {
    var cache = MMNetDiskDataController.cache;
    var queue = cache[folderId];
    if (queue.length > 0) {
      var request = null;
      for (var i = 0; i < queue.length; i++) {
        if (!queue[i].repTime) {
          request = queue[i];
          break;
        }
      }
      if (!request) {
        return;
      }
      MMNetDiskDataController.realListDir(request, request.folderId, request.type, function succ(rObj, fileInforCollection, page) {
        var fId = rObj.folderId;
        if (fId == 1508485689344) {
          console.log("returned");
        }
        queue = cache[fId];
        if (rObj.success) {
          rObj.success(fileInforCollection, page);
        }
        for (var i = 0; i < queue.length; i++) {
          if (queue[i] == rObj) {
            queue.splice(i, 1);
            break;
          }
        }
        var i = 0;
        while (i < queue.length) {
          var rObj2 = queue[i];
          var canRemove = false;
          if (rObj2.type == rObj.type) {
            if (rObj2.success) {
              rObj2.success(fileInforCollection, page);
            }
            rObj2.repTime = new Date();
          } else if (rObj2.type == MMNetDiskDataController.LISTTYPES.FOLDER) {
            var folders = fileInforCollection.filter(function (fileInfo) {
              return fileInfo.isFolder();
            });
            rObj2.success(new _MMFileInfoCollection["default"](folders));
            rObj2.repTime = new Date();
          }
          if (rObj2.repTime) {
            if (!rObj2.readInfoSuccess) {
              queue.splice(i, 1);
              continue;
            }
          }
          i++;
        }
        MMNetDiskDataController._listDirForNextRequest(fId);
      }, function fail(rObj, result) {
        var fId = rObj.folderId;
        queue = cache[fId];
        for (var i = 0; i < queue.length; i++) {
          if (queue[i] == rObj) {
            queue.splice(i, 1);
            break;
          }
        }
        MMNetDiskDataController._listDirForNextRequest(fId);
        if (rObj.fail) {
          rObj.fail(result);
        }
      }, function readInfoSucc(rObj, result) {
        var fId = rObj.folderId;
        queue = cache[fId];
        if (rObj.readInfoSuccess) {
          rObj.readInfoSuccess(result);
        }
        var i = 0;
        while (i < queue.length) {
          var rObj2 = queue[i];
          var canRemove = false;
          if (rObj2.readInfoSuccess) {
            rObj2.readInfoSuccess(result);
            queue.splice(i, 1);
            continue;
          }
          i++;
        }
      }, request.page, request.pageSize);
    }
  },
  realListDir: function realListDir(reqObj, folderId, type, success, fail, readInfoSuccess, page, pageSize) {
    _MDNetDriveFileHandler["default"].realListDir(reqObj, folderId, type, success, fail, readInfoSuccess, page, pageSize);
  },
  getHomeFiles: function getHomeFiles(folderId, type, success, fail, readInfoSuccess, page, pageSize) {
    MMNetDiskDataController.listDir(folderId, type, function (fileInforCollection) {
      MMNetDiskDataController.curDirectoryId = folderId;
      MMNetDiskDataController.curFileInfoList = fileInforCollection;
      if (_.isFunction(success)) success(fileInforCollection);
    }, fail, readInfoSuccess, page, pageSize);
  },
  getMyTeamFolders: function getMyTeamFolders(success, fail, readInfoSuccess) {
    _MDNetDriveFileHandler["default"].getMyTeamFolders(success, fail, readInfoSuccess);
  },
  get2ndFileInfo: function get2ndFileInfo(fileInfos, param, success, fail) {
    _MDNetDriveFileHandler["default"].get2ndFileInfo(fileInfos, param, success, fail);
  },
  listBin: function listBin(fileId, success, fail) {
    _MDNetDriveFileHandler["default"].listBin(fileId, success, fail);
  },
  useAdvancedSearchsearchFileByName: function useAdvancedSearchsearchFileByName(options, success, fail) {
    _MDNetDriveFileHandler["default"].useAdvancedSearchsearchFileByName(options, success, fail);
  },
  searchFileByName: function searchFileByName(options, success, fail) {
    _MDNetDriveFileHandler["default"].searchFileByName(options, success, fail);
  },
  getPathById: function getPathById(fid, channelType, top, success, fail) {
    _MDNetDriveFileHandler["default"].getPathById(fid, channelType, top, success, fail);
  },
  getLastPathFolder: function getLastPathFolder(fid, channelType, success, fail) {
    _MDNetDriveFileHandler["default"].getLastPathFolder(fid, channelType, success, fail);
  },
  getArchiveReviewHistory: function getArchiveReviewHistory(startIndex, pageSize, options, success, fail) {
    _MDNetDriveFileHandler["default"].getArchiveReviewHistory(startIndex, pageSize, options, success, fail);
  },
  listArchiveDir: function listArchiveDir(fid, success, fail) {
    _MDNetDriveFileHandler["default"].listArchiveDir(fid, success, fail);
  },
  searchArchive: function searchArchive(queryString, parentId, success, fail) {
    _MDNetDriveFileHandler["default"].searchArchive(queryString, parentId, success, fail);
  },
  useAdvancedSearchsearchArchive: function useAdvancedSearchsearchArchive(options, success, fail) {
    _MDNetDriveFileHandler["default"].useAdvancedSearchsearchArchive(options, success, fail);
  },
  acceptOrDenyArchiveApplication: function acceptOrDenyArchiveApplication(applicationId, endTime, flag, success, fail) {
    _MDNetDriveFileHandler["default"].acceptOrDenyArchiveApplication(applicationId, endTime, flag, success, fail);
  },
  getMyBorrowed: function getMyBorrowed(success, fail) {
    _MDNetDriveFileHandler["default"].getMyBorrowed(success, fail);
  },
  getMyArchiveApply: function getMyArchiveApply(success, fail) {
    _MDNetDriveFileHandler["default"].getMyArchiveApply(success, fail);
  },
  getMyArchiveApplyHistory: function getMyArchiveApplyHistory(success, fail) {
    _MDNetDriveFileHandler["default"].getMyArchiveApplyHistory(success, fail);
  },
  getArchiveApplyToReview: function getArchiveApplyToReview(success, fail) {
    _MDNetDriveFileHandler["default"].getArchiveApplyToReview(success, fail);
  },
  /**
   * @param fileIds {id or array of ids} the is of files to restore
   * @param success {function()}
   * @param success {function(resultCode, fileErrors)}
   *      fileErrors: {fid:string, code:number}
   */
  restore: function restore(deleteVersionIds, fidArr, success, fail) {
    _MDNetDriveFileHandler["default"].restore(deleteVersionIds, fidArr, success, fail);
  },
  /**
   * @param fileIds {id or array of ids} the is of files to restore
   * @param success {function()}
   * @param success {function(resultCode, fileErrors)}
   *      fileErrors: {fid:string, code:number}
   */
  sendUploadEmails: function sendUploadEmails(fileIds, success, fail) {
    _MDNetDriveFileHandler["default"].sendUploadEmails(fileIds, success, fail);
  },
  getCurDisplayDocumentList: function getCurDisplayDocumentList() {
    var docList = [];
    if (MMNetDiskDataController.curFileInfoList) {
      for (var i = 0; i < MMNetDiskDataController.curFileInfoList.length; i++) {
        var fileInfo = MMNetDiskDataController.curFileInfoList.models[i];
        if (!fileInfo.isFolder() && fileInfo.canDispInEditor()) {
          docList.push(fileInfo);
        }
      }
    }
    return docList;
  },
  getDispFilesInFolder: function getDispFilesInFolder(folderId, success, fail) {
    // var docList = MMNetDiskDataController.getCurDisplayDocumentList();
    // if (docList.length == 0 || (docList[0].get('parentId') != folderId)) {
    var type = MMNetDiskDataController.LISTTYPES.FILES;
    MMNetDiskDataController.listDir(folderId, type, function (fileInfoArr) {
      var dispArr = _.filter(fileInfoArr.models, function (fInfo) {
        return !fInfo.isFolder() && fInfo.canDispInEditor();
      });
      if (success) {
        success(dispArr);
      }
    }, fail);
  },
  getCurrentUsersVolume: function getCurrentUsersVolume(success, fail) {
    _MDNetDriveFileHandler["default"].getCurrentUsersVolume(success, fail);
  },
  getImageFilesInFolder: function getImageFilesInFolder(folderId, success, fail) {
    var docList = MMNetDiskDataController.getCurImageList();
    if (docList.length == 0 || docList[0].get("parentId") != folderId) {
      var type = MMNetDiskDataController.LISTTYPES.FILES;
      MMNetDiskDataController.listDir(folderId, type, function (fileInfoArr) {
        var dispArr = _.filter(fileInfoArr.models, function (fInfo) {
          return fInfo.isImage();
        });
        if (success) {
          success(dispArr);
        }
      }, fail);
    } else {
      if (success) {
        setBabelTimeout(function () {
          success(docList);
        }, 0);
      }
    }
  },
  getFileInCurDisplayDocumentList: function getFileInCurDisplayDocumentList(fid) {
    var rtFileInfo = null;
    for (var i = 0; i < MMNetDiskDataController.curFileInfoList.length; i++) {
      var fileInfo = MMNetDiskDataController.curFileInfoList.models[i];
      if (fileInfo.getFileId() == fid) {
        rtFileInfo = fileInfo;
        break;
      }
    }
    return rtFileInfo;
  },
  getCurImageList: function getCurImageList() {
    var docList = [];
    if (MMNetDiskDataController.curFileInfoList) {
      for (var i = 0; i < MMNetDiskDataController.curFileInfoList.length; i++) {
        var fileInfo = MMNetDiskDataController.curFileInfoList.models[i];
        if (!fileInfo.isFolder() && fileInfo.isImage()) {
          docList.push(fileInfo);
        }
      }
    }
    return docList;
  },
  //
  // get file info by id
  // @param fileId - the file to be get info
  // @param success - callback function of success: success(MMFileInfo){ }
  // @param fail - callback function when failed: fail(){ }
  getFileInfoByFileId: function getFileInfoByFileId(fileId, success, fail) {
    if (fileId == "0") {
      setBabelTimeout(function () {
        success(MMNetDiskDataController.getHomeDir());
      }, 0);
      return;
    }
    var target = null;
    if (MMNetDiskDataController.curFileInfoList) {
      for (var i = 0; i < MMNetDiskDataController.curFileInfoList.length; i++) {
        var fileInfo = MMNetDiskDataController.curFileInfoList.models[i];
        if (fileInfo.getFileId() == fileId) {
          target = fileInfo;
          break;
        }
      }
    }
    if (target) {
      setBabelTimeout(function () {
        if (success) {
          success(target);
        }
      }, 0);
    } else {
      MMNetDiskDataController.getFileInfoFromServer(fileId, success, fail);
    }
    return target;
  },
  getFileInfoFromServer: function getFileInfoFromServer(fileId, success, fail) {
    if (fileId == '0') {
      MMNetDiskDataController.getHomeDir(success);
      return;
    }
    _MDNetDriveFileHandler["default"].getFileInfoFromServer(fileId, success, fail);
  },
  getFileInfosFromServer: function getFileInfosFromServer(fileIds, needReadInfo, success, fail) {
    _MDNetDriveFileHandler["default"].getFileInfosFromServer(fileIds, needReadInfo, success, fail);
  },
  getFileActions: function getFileActions(fileIds, success, fail) {
    _MDNetDriveFileHandler["default"].getFileActions(fileIds, success, fail);
  },
  updateFileInfoFromServer: function updateFileInfoFromServer(fileInfo, success, fail) {
    var fileId = fileInfo.getFileId();
    MMNetDiskDataController.getFileInfoFromServer(fileId, function (newFileInfo) {
      fileInfo.initBy(newFileInfo); // update actions

      if (success) {
        success();
      }
    });
  },
  getFileInfoFromServerWithoutTrash: function getFileInfoFromServerWithoutTrash(fileId, success, fail) {
    _MDNetDriveFileHandler["default"].getFileInfoFromServerWithoutTrash(fileId, success, fail);
  },
  /**
   * @param path {string} path to file or directory, path uses the / as seperator
   * @param success - callback function of success: success(fid) fid is the fileId or folderId
   * @param fail - callback function when failed: fail(e) e is the error code
   */
  getFileIdByPath: function getFileIdByPath(path, success, fail) {
    var route = "netDrive.fileHandler.queryIdByPath";
    MMNetDiskDataController.request(route, {
      path: path
    }, function (res) {
      console.assert(res["resultCode"] !== undefined);
      if (res["resultCode"] === 0) {
        console.assert(res["fid"], "fid is missing");
        success(res["fid"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  getFileAccessUsers: function getFileAccessUsers(fid, success, fail) {
    _MDNetDriveFileHandler["default"].getFileAccessUsers(fid, success, fail);
  },
  isSharingOrhasSharingChildren: function isSharingOrhasSharingChildren(fileIds, success, fail) {
    _MDNetDriveFileHandler["default"].isSharingOrhasSharingChildren(fileIds, success, fail);
  },
  addFileAccessUser: function addFileAccessUser(fid, userId, success, fail) {
    _MDNetDriveFileHandler["default"].addFileAccessUser(fid, userId, success, fail);
  },
  getFileCommentAccessUsers: function getFileCommentAccessUsers(fid, success, fail) {
    _MDNetDriveFileHandler["default"].getFileCommentAccessUsers(fid, success, fail);
  },
  addFileCommentAccessUser: function addFileCommentAccessUser(fid, userId, success, fail) {
    _MDNetDriveFileHandler["default"].addFileCommentAccessUser(fid, userId, success, fail);
  },
  makeWhiteBoardAndBroadcast: function makeWhiteBoardAndBroadcast(parentId, file, pageSizes, fileRefId, version, success, fail) {
    _MDNetDriveFileHandler["default"].makeWhiteBoardAndBroadcast(parentId, file, pageSizes, fileRefId, version, success, fail);
  },
  /**
   *
   */
  addVersion: function addVersion(file, version, parentId, size, success, fail) {
    _MDNetDriveFileHandler["default"].addVersion(file, version, parentId, size, success, fail);
  },
  getFileVersionsByFileInfo: function getFileVersionsByFileInfo(fileInfo, startIndex, pageSize, success, fail) {
    _MDNetDriveFileHandler["default"].getFileVersionsByFileInfo(fileInfo, startIndex, pageSize, success, fail);
  },
  setLatestVersion: function setLatestVersion(versionInfo, success, fail) {
    _MDNetDriveFileHandler["default"].setLatestVersion(versionInfo, success, fail);
  },
  /**
   * @param newName {string} name of the new Folder
   * @param destDirId {id} the fileInfo
   */
  createDir: function createDir(newName, destDirInfo, forceRename, dontNotify, success, fail, otherParams) {
    _MDNetDriveFileHandler["default"].createDir(newName, destDirInfo, forceRename, dontNotify, success, fail, otherParams);
  },
  createArchiveFolder: function createArchiveFolder(newName, destDirInfo, forceRename, dontNotify, success, fail, otherParams) {
    _MDNetDriveFileHandler["default"].createArchiveFolder(newName, destDirInfo, forceRename, dontNotify, success, fail, otherParams);
  },
  batchCreateDir: function batchCreateDir(newNames, destDirInfo, success, fail) {
    _MDNetDriveFileHandler["default"].batchCreateDir(newNames, destDirInfo, success, fail);
  },
  getMsBoxLimits: function getMsBoxLimits(fileId, success, fail) {
    _MDNetDriveFileHandler["default"].getMsBoxLimits(fileId, success, fail);
  },
  /**
   * will be used for files and directories
   * @author:mashx
   * @param options {object}
   *      fileId {string} the fileId in Hex
   *      version {optional int} the version to delete, default all
   *      type: {value from MDNetDriveFileHandler.DELETEOPTIONS} the Delete Option
   */
  deleteFilesByIds: function deleteFilesByIds(options, success, fail) {
    _MDNetDriveFileHandler["default"].deleteFilesByIds(options, success, fail);
  },
  /**
   * will be used for files and directories
   * @param options {object}
   *      fileId {string} the fileId in Hex
   *      version {optional int} the version to delete, default all
   *      option: {value from MDNetDriveFileHandler.DELETEOPTIONS} the Delete Option
   *      isFolder {bool}
   */
  deleteFileById: function deleteFileById(options, success, fail) {
    _MDNetDriveFileHandler["default"].deleteFileById(options, success, fail);
  },
  /**
   * will be used for files and directories
   * @param options {object}
   *      fileId {string} the fileId in Hex
   *      version {optional int} the version to delete, default all
   *      option: {value from MDNetDriveFileHandler.DELETEOPTIONS} the Delete Option
   *      isFolder {bool}
   */
  deleteFilesInTrash: function deleteFilesInTrash(options, success, fail) {
    _MDNetDriveFileHandler["default"].deleteFilesInTrash(options, success, fail);
  },
  deleteEntFileInTrash: function deleteEntFileInTrash(options, success, fail) {
    _MDNetDriveFileHandler["default"].deleteEntFileInTrash(options, success, fail);
  },
  renameFile: function renameFile(fileId, version, newName, success, fail) {
    _MDNetDriveFileHandler["default"].renameFile(fileId, version, newName, success, fail);
  },
  clearTrash: function clearTrash(success, fail) {
    _MDNetDriveFileHandler["default"].clearTrash(success, fail);
  },
  moveFile: function moveFile(arrFileId, targetDirId, success, fail) {
    _MDNetDriveFileHandler["default"].moveFile(arrFileId, targetDirId, success, fail);
  },
  copyFile: function copyFile(fileIds, destId, version, success, fail, params) {
    _MDNetDriveFileHandler["default"].copyFile(fileIds, destId, version, success, fail, params);
  },
  saveSendFilePersonal: function saveSendFilePersonal(fileIds, destId, version, success, fail, params) {
    _MDNetDriveFileHandler["default"].saveSendFilePersonal(fileIds, destId, version, success, fail, params);
  },
  joinShareLink: function joinShareLink(fileId, password, success, fail) {
    _MDNetDriveFileHandler["default"].joinShareLink(fileId, password, success, fail);
  },
  leaveSharedFile: function leaveSharedFile(fileId, success, fail) {
    _MDNetDriveFileHandler["default"].leaveSharedFile(fileId, success, fail);
  },
  leaveMultipleSharedFile: function leaveMultipleSharedFile(fileIds, success, fail) {
    _MDNetDriveFileHandler["default"].leaveMultipleSharedFile(fileIds, success, fail);
  },
  /* ---------------------------------------- share -------------------------------------- */
  /**
   * @param fileid
   * @param success { function(shareURL [,password]) }
   * @param fail { function(resultCode) }
   */
  getShareUrl: function getShareUrl(fid, isHttps, success, fail) {
    _MDNetDriveFileHandler["default"].getShareUrl(fid, isHttps, success, fail);
  },
  /**
   * get a file's share url in the shared folder
   * @param path - from share id to the nearest parent
   * @param fileid - the file we want the share url
   * @param success { function(shareURL [,password]) }
   * @param fail { function(resultCode) }
   */
  getFileShareURL: function getFileShareURL(shareId, fileId, success, fail) {
    _MDNetDriveFileHandler["default"].getFileShareURL(shareId, fileId, success, fail);
  },
  /**
   * @param fileid
   * @param success { function() }
   * @param fail { function(resultCode) }
   */
  setFilePassword: function setFilePassword(fileId, password, isHttps, success, fail) {
    _MDNetDriveFileHandler["default"].setFilePassword(fileId, password, isHttps, success, fail);
  },
  /**
   * @param fileid
   * @param success { function() }
   * @param fail { function(resultCode) }
   */
  setFileSticktotop: function setFileSticktotop(fileId, newSticktotop, success, fail) {
    _MDNetDriveFileHandler["default"].setFileSticktotop(fileId, newSticktotop, success, fail);
  },
  setFileSticktotopByChannel: function setFileSticktotopByChannel(fileId, newSticktotop, channelType, success, fail) {
    _MDNetDriveFileHandler["default"].setFileSticktotopByChannel(fileId, newSticktotop, channelType, success, fail);
  },
  openShareLink: function openShareLink(fileId, success, fail) {
    _MDNetDriveFileHandler["default"].openShareLink(fileId, success, fail);
  },
  // to set the shareAll attibute for the bableFile
  setShareOpenToAnyone: function setShareOpenToAnyone(fileId, openToAnyone, success, fail) {
    _MDNetDriveFileHandler["default"].setShareOpenToAnyone(fileId, openToAnyone, success, fail);
  },
  closeShareLink: function closeShareLink(fileId, success, fail) {
    _MDNetDriveFileHandler["default"].closeShareLink(fileId, success, fail);
  },
  removeMyFileFocus: function removeMyFileFocus(fileIds, success, fail) {
    _MDNetDriveFileHandler["default"].removeMyFileFocus(fileIds, success, fail);
  },
  /**
   * calles closeShareLink for each file. can be optimized later.
   */
  closeMultipleShareLink: function closeMultipleShareLink(fileIds, success, fail) {
    _MDNetDriveFileHandler["default"].closeMultipleShareLink(fileIds, success, fail);
  },
  isSharingHasPassword: function isSharingHasPassword(fileId, success, fail) {
    _MDNetDriveFileHandler["default"].isSharingHasPassword(fileId, success, fail);
  },
  joinFileTemporary: function joinFileTemporary(fileId, password, success, fail) {
    _MDNetDriveFileHandler["default"].joinFileTemporary(fileId, password, success, fail);
  },
  didIJoinFile: function didIJoinFile(fileId, success, fail) {
    _MDNetDriveFileHandler["default"].didIJoinFile(fileId, success, fail);
  },
  getQuota: function getQuota(success, fail) {
    _MDNetDriveFileHandler["default"].getQuota(success, fail);
  },
  getAllLevels: function getAllLevels(success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.level_getAll", {}, function (res) {
      if (res["resultCode"] !== 0) {
        fail(res["resultCode"]);
      } else {
        var out = res["levels"].map(function (level) {
          return new _MDLevel["default"](level);
        });
        success(out);
      }
    });
  },
  getShareParticipants: function getShareParticipants(fileId, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.getShareParticipants", {
      fid: fileId
    }, function (res) {
      if (res["resultCode"] !== 0) {
        fail(res["resultCode"]);
      } else {
        var out = new _MDMolaUserCollection["default"]();
        if (res["list"]) {
          res["list"].forEach(function (userInfo) {
            out.push(new _MDMolaUser["default"](userInfo));
          });
        }
        success(out);
      }
    });
  },
  getConversationParticipants: function getConversationParticipants(fileInfo, success, fail) {
    if (fileInfo.isDepartmentFolder() || fileInfo.isProject()) {
      var router = "netDrive.fileHandler.getDepConversationParticipants";
      if (fileInfo.isProject()) {
        router = "netDrive.fileHandler.getProjectParticipants";
      }
      MMNetDiskDataController.request(router, {
        fid: fileInfo.getFileId()
      }, function (res) {
        if (res["resultCode"] !== 0) {
          fail(res["resultCode"]);
        } else {
          var out = new _MDMolaUserCollection["default"]();
          if (res["list"]) {
            res["list"].forEach(function (userInfo) {
              out.push(new _MDMolaUser["default"](userInfo));
            });
          }
          success(out);
        }
      });
    } else {
      MMNetDiskDataController.getShareParticipants(fileInfo.getFileId(), success, fail);
    }
  },
  // 获得用户的好友列表，包括邮箱地址用户名
  getFriends: function getFriends(success, fail) {
    // test
    if (success) {
      var list = [{
        name: "八戒",
        address: "bajie@molasync.com"
      }, {
        name: "沙僧",
        address: "shaseng@molasync.com"
      }];
      success(list);
    }
  },
  /* ---------------------------------------- starmark -------------------------------------- */

  getMyStarmarkFiles: function getMyStarmarkFiles(success, fail, readInfoSuccess) {
    var route = "netDrive.fileHandler.starmark_getMy";
    MMNetDiskDataController.request(route, {
      /*no params*/
    }, function (res) {
      if (res["resultCode"] === 0) {
        var out = new _MMFileInfoCollection["default"]();
        if (!res["fileArr"]) {
          success(out);
          return;
        }
        res["fileArr"].forEach(function (fileInfo) {
          out.push(new _MMFileInfo["default"](fileInfo));
        });
        success(out);
        var param = {
          channelroot: _MDConstant["default"].ChannelRoot.MyStarmark
        };
        MMNetDiskDataController.get2ndFileInfo(out.models, param, readInfoSuccess);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  addStarmarkFile: function addStarmarkFile(fileIds, success, fail) {
    if (!Array.isArray(fileIds)) fileIds = [fileIds];
    var route = "netDrive.fileHandler.starmark_addMultiple";
    MMNetDiskDataController.request(route, {
      fileIds: fileIds
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  removeStarmarkFile: function removeStarmarkFile(fileIds, success, fail) {
    if (!Array.isArray(fileIds)) fileIds = [fileIds];
    var route = "netDrive.fileHandler.starmark_removeMultiple";
    MMNetDiskDataController.request(route, {
      fileIds: fileIds
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  /* ---------------------------------------- version -------------------------------------- */

  //
  // get all version for file
  // @param fileId
  // @param success - callback function of success: success(array of MMVersionInfo){  }
  // @param fail - callback function when failed: fail(){ }
  getVersionInfoByFileId: function getVersionInfoByFileId(fileId, success, fail) {},
  deleteVersion: function deleteVersion(fileId, versionNo, success, fail) {
    MMNetDiskDataController.deleteFileById({
      fileId: fileId,
      version: versionNo
    }, success, fail);
  },
  /**
   * @param fileid
   * @param success { function() }
   * @param fail { function(resultCode) }
   */
  setCurrentVersion: function setCurrentVersion(fileId, version, success, fail) {
    var route = "netDrive.fileHandler.setCurrentVersion";
    if (success) {
      success();
    }
    MMNetDiskDataController.request(route, {
      fid: fileId + "",
      ver: version + ""
    }, function (res) {
      try {
        if (res["resultCode"] !== 0) {
          fail(res["resultCode"]);
        } else {
          success();
        }
      } catch (e) {
        console.log(e);
      }
    });
  },
  /***********************************************************
   * UPLOADSTUFF                      cd
   ***********************************************************/

  getXhr: function getXhr() {
    /* returns cross-browser XMLHttpRequest, or null if unable */
    try {
      return new XMLHttpRequest();
    } catch (e) {}
    return null;
  },
  /**
   * to query the upload url the native file object is needed.
   * @param {Function(error , resultData)} callback
   */
  getUploadURL: function getUploadURL(file, fileInfo, _success, fail) {
    //optional parameter fileInfo
    if (typeof fileInfo === "function") {
      fileInfo = null;
    }
    var destDirInfo = file.uploadFile.get("destDirInfo");
    var postData = {};
    postData["userId"] = _app["default"].currentUser.getUserId();
    if (fileInfo) {
      postData["fileId"] = fileInfo.getFileId();
    }
    postData["uploadNewVersion"] = fileInfo ? "1" : "0";
    postData["fileName"] = MMCommonFun.filterFileName(file.name);
    postData["fileSize"] = file.size;
    postData["folderId"] = destDirInfo.getFileId();
    console.log("*********  call /netdrive/getUploadUrl.do :", file);
    $.ajax({
      method: "post",
      url: "/netdrive/getUploadUrl.do",
      data: postData,
      success: function success(responseData, textStatus, jqXHR) {
        console.log("*********  return from /netdrive/getUploadUrl.do:", file);
        if (responseData["success"] === true) {
          if (responseData["url"]) {
            var fileId = null;
            if (responseData["fileId"]) {
              fileId = responseData["fileId"];
            } else {
              fileId = fileInfo.getFileId();
            }
            file.uploadFile.set("fileId", fileId);
            _success(responseData["url"], fileId);
          }
        } else {
          fail(responseData);
          // MMNetDiskDataController.errorProcess(responseData, fail);
        }
      }
    });
  },
  errorProcess: function errorProcess(responseData, callback) {
    var Convert_Doc_Error = 105;
    var Document_Has_Password = 106;
    var User_Not_Login = 207;
    var FileSize_Limited = 7;
    if (responseData.code == User_Not_Login) {
      window.location = "/account/login.do";
    }
    if (responseData.code == Document_Has_Password) {
      _MDSnackbarView["default"].show(BabelStr.str(7373));
    }
    if (responseData.code == Convert_Doc_Error) {
      _MDSnackbarView["default"].show(BabelStr.str(7374));
    } else {
      callback(responseData);
    }
  },
  getDownloadURL: function getDownloadURL(fileInfo, version, callback) {
    if (typeof version === "function") {
      // optional version parameter
      callback = version;
      version = 1;
    }
    var resMap = {};
    resMap["userId"] = _app["default"].currentUser.getUserId();
    resMap["fileId"] = fileInfo.getFileId();
    resMap["ext"] = MMCommonFun.getFileExtension(fileInfo.get("name"));
    resMap["version"] = MMCommonFun.getFileExtension(fileInfo.get("name"));
    var getParams = "";
    for (var i in resMap) {
      getParams += (getParams.length ? "&" : "?") + i + "=" + resMap[i];
    }
    $.get("/netdrive/getDownloadUrl.do" + getParams, function (res) {
      if (res["success"] === true) {
        if (res["url"]) {
          callback(null, res.url);
        }
      } else {
        callback(res);
      }
    });
  },
  calcFileHashAndUpload: function calcFileHashAndUpload(file, fileInfo, folderId, param, successCB, failCB, progressCB) {
    param.ignoreVirus = param.ignoreVirus || 0; // ignoreVirus 不能为 undefined
    var self = this;
    var next = function next() {
      if (!file.uploadFile || file.uploadFile.get("state") === _MDUploadFile["default"].states.uploading) {
        // 上传状态的文件进入下一步
        self.testFileHashAndUpload(file.hash, file, fileInfo, folderId, param, successCB, failCB, progressCB);
      }
    };
    if (!(file instanceof File)) {
      var hash = "";
      file.progress = 0.1;
      file.loaded = false;
      file.bitrate = 600;
      file.hash = "";
      file.quickHash = "";
      progressCB(file, param.uploadId);
      next();
      return;
    }
    if (file.useFullHash) {
      if (!file.hash) {
        MMNetDiskDataController.calcMd5(file, function (sign) {
          if (!sign) {
            failCB();
          } else {
            next();
          }
        }, function () {
          progressCB(file, param.uploadId);
        });
      } else {
        next();
      }
    } else {
      if (!file.quickHash) {
        MMNetDiskDataController.calcHeadMd5(file, function (sign) {
          if (!sign) {
            failCB();
          } else {
            next();
          }
        });

        // MMNetDiskDataController.calcMd5(file, (sign)=>{

        // }, ()=>{

        // })
      } else {
        next();
      }
    }
  },
  calcMd5: function calcMd5(file, callback, progressCB) {
    var self = this;
    // console.time("计算MD5值");
    var blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice,
      // file = this.files[0],
      chunkSize = 2097152,
      // Read in chunks of 2MB
      chunks = Math.ceil(file.size / chunkSize),
      currentChunk = 0,
      spark = new SparkMD5.ArrayBuffer();
    file.fileReader = new FileReader();
    var lastTimeStamp = Date.now() - 1000;
    file.fileReader.onload = function (e) {
      // console.log('read chunk nr', currentChunk + 1, 'of', chunks);
      spark.append(e.target.result); // Append array buffer
      currentChunk++;
      var deltaTime = Date.now() - lastTimeStamp;
      if (currentChunk < chunks) {
        loadNext();
      } else {
        // success(spark.end());
        var hash = spark.end();
        // console.log('finished loading');
        console.info("computed hash", hash); // Compute hash
        // return
        // console.timeEnd("计算MD5值");
        //
        file.hash = hash; // 记录文件MD5，重传时避免再次计算

        callback(true);
        return;
      }
      if (deltaTime < 1000) {
        return;
      }
      lastTimeStamp = Date.now();
      var percent = 0;
      percent = (currentChunk + 1) / chunks * 0.1;
      file.progress = percent;
      file.loaded = false;
      file.bitrate = RandomNum(500, 800);
      progressCB();
    };
    var RandomNum = function RandomNum(Min, Max) {
      var Range = Max - Min;
      var Rand = Math.random();
      var num = Min + Math.round(Rand * Range);
      return num;
    };
    file.fileReader.onerror = function () {
      callback(false);
      console.warn("oops, something went wrong.");
    };
    function loadNext() {
      var start = currentChunk * chunkSize,
        end = start + chunkSize >= file.size ? file.size : start + chunkSize;
      file.fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
    }
    loadNext();
  },
  calcHeadMd5: function calcHeadMd5(file, callback) {
    // const MD5_BUFFER_SIZE = 1024 * 1024;
    var blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice,
      // file = this.files[0],
      chunkSize = 1024 * 1024,
      // Read in chunks of 1MB
      spark = new SparkMD5.ArrayBuffer();
    file.fileReader = new FileReader();
    file.fileReader.onload = function (e) {
      // console.log('read chunk nr', currentChunk + 1, 'of', chunks);
      spark.append(e.target.result); // Append array buffer

      // 将文件大小转换为字符串并追加到SparkMD5实例中
      var fileSizeStr = file.size.toString();
      var fileSizeBuffer = new TextEncoder().encode(fileSizeStr);
      spark.append(fileSizeBuffer);
      var hash = spark.end();
      // console.log('finished loading');
      console.info("computed quickhash", hash); // Compute hash
      // return
      // console.timeEnd("计算MD5值");
      //
      file.quickHash = hash; // 记录文件MD5，重传时避免再次计算
      console.log("----- md5DigestHash:", hash);
      callback(true);
    };
    file.fileReader.onerror = function () {
      console.warn("oops, something went wrong.");
      callback(false);
    };
    file.fileReader.readAsArrayBuffer(blobSlice.call(file, 0, chunkSize));
  },
  check4batchCreateFiles: function check4batchCreateFiles(folderId, successCB, failCB) {
    var postData = {
      folderId: folderId
    };
    $.ajax({
      method: "post",
      url: "/file/batchUploadCheck.do",
      // ------------------- 获取批量上传的 key 值，准备批量上传
      data: postData,
      success: function success(responseData, textStatus, jaXHR) {
        if (responseData["success"] === true) {
          var key = responseData["uploadToken"];
          successCB(key, responseData["code"], responseData["msg"]);
        } else {
          failCB(responseData["code"], responseData["msg"]);
        }
      },
      fail: function fail(res) {
        console.log(res);
      }
    });
  },
  getBatchCreateFileUrl: function getBatchCreateFileUrl(hash, file, fileInfo, folderId, param, successCB, failCB, progressCB) {
    var batchUploadInfo = window[file.batchUploadMark];
    if (!batchUploadInfo) {
      console.error("----------- testFileHashAndUpload： 没有 key 值");
      return;
    }
    var postData = {
      uploadToken: batchUploadInfo.key,
      fileName: MMCommonFun.filterFileName(file.name),
      fileSize: file.size,
      forbidAutoRename: param.forbidAutoRename,
      sameNameAsNewVersion: param.sameNameAsNewVersion
    };
    if (file.useFullHash) {
      postData.fileHash = file.hash;
    } else {
      postData.quickHash = file.quickHash;
    }
    var tryCount = 0;
    var request = function request() {
      $.ajax({
        method: "post",
        url: "/file/isFileCanSecUpload.do",
        data: postData,
        success: function success(responseData, textStatus, jaXHR) {
          if (responseData["success"] === true) {
            var url = responseData["url"];
            {
              successCB(url, responseData["code"], responseData["msg"]);
            }
          } else {
            if (responseData["code"] == "247") {
              // -- key 值无效, 重新申请
              var folderInfo = file.batchTargetRoot;
              if (folderInfo) {
                var folderId = folderInfo.getFileId();
                MMNetDiskDataController.check4batchCreateFiles(folderId, function (key, code, msg) {
                  if (key) {
                    window[file.batchUploadMark] = {
                      key: key,
                      batchTargetRoot: folderInfo
                    };
                    MMNetDiskDataController.getBatchCreateFileUrl(hash, file, fileInfo, folderId, param, successCB, failCB, progressCB);
                  }
                });
              }
            } else {
              failCB(file, responseData["code"], responseData["msg"]);
            }
          }
        },
        error: function error(xhr, status, _error) {
          console.log(xhr);
          if (xhr.status == 403 && tryCount < 3 && file.uploadFile.get("state") === _MDUploadFile["default"].states.uploading) {
            setTimeout(function () {
              request();
            }, 1500);
          } else {
            failCB(file, xhr.status, BabelStr.str(2349));
          }
          tryCount++;
          console.log(xhr);
        }
      });
    };
    request();
  },
  testFileHashAndUpload: function testFileHashAndUpload(hash, file, fileInfo, folderId, param, successCB, failCB, progressCB) {
    var _this = this;
    if (file.uploadUrl) {
      if (file.blockUpload) {
        this.uploadBlockBabelFile(hash, file, fileInfo, folderId, param, successCB, failCB, progressCB);
      } else {
        MMNetDiskDataController.uploadBabelFile(file.uploadUrl, hash, file, fileInfo, folderId, param, successCB, failCB, progressCB);
      }
      return;
    }
    if (file.batchUploadMark) {
      var batchUploadInfo = window[file.batchUploadMark];
      if (!batchUploadInfo) {
        console.error("----------- testFileHashAndUpload： 没有 key 值");
        return;
      }
      MMNetDiskDataController.getBatchCreateFileUrl(hash, file, fileInfo, folderId, param, function (url, code, msg) {
        if (code == "0") {
          file.uploadUrl = url;
          if (file.blockUpload) {
            MMNetDiskDataController.uploadBlockBabelFile(hash, file, fileInfo, folderId, param, successCB, failCB, progressCB);
          } else {
            MMNetDiskDataController.uploadBabelFile(url, hash, file, fileInfo, folderId, param, successCB, failCB, progressCB);
          }
        } else if (code == "19") {
          MMNetDiskDataController.uploadFileCTPdf(url, hash, file, fileInfo, folderId, param, successCB, failCB, progressCB);
        } else if (code == "20022") {
          console.log("该文件需要进一步判断是否可以秒传");
          file.useFullHash = true;
          MMNetDiskDataController.calcFileHashAndUpload(file, fileInfo, folderId, param, successCB, failCB, progressCB);
        }
      }, failCB, progressCB);
    } else if (file.blockUpload) {
      this.uploadBlockBabelFile(hash, file, fileInfo, folderId, param, successCB, failCB, progressCB);
    } else {
      var postData = {
        folderId: folderId,
        fileName: MMCommonFun.filterFileName(file.name),
        fileSize: file.size,
        fileId: fileInfo && fileInfo.getFileId()
      };
      if (file.useFullHash) {
        postData.fileHash = file.hash;
      } else {
        postData.quickHash = file.quickHash;
      }
      var tryCount = 0;
      var request = function request() {
        $.ajax({
          method: "post",
          url: "/file/filePreUpload.do",
          data: postData,
          success: function success(responseData, textStatus, jaXHR) {
            if (responseData["success"] === true) {
              if (file.blocked) {
                return;
              }
              var url = responseData["url"];
              if (responseData["code"] == 10004) {
                successCB(file, {
                  fileId: fileInfo.getFileId(),
                  fileSize: fileInfo.get("fileSize"),
                  // pageSize: response["pageSize"] || [],
                  version: fileInfo.get("version") || 0,
                  fileName: responseData.newFileName || fileInfo.get("fileName"),
                  versionNo: fileInfo.get("versionNo"),
                  needRefreshFileInfo: !!responseData.newFileName
                });
              }
              if (responseData["code"] == "0") {
                file.uploadUrl = url;
                console.log("该文件不能秒传");
                _this.uploadBabelFile(url, hash, file, fileInfo, folderId, param, successCB, failCB, progressCB);
              } else if (responseData["code"] == "19") {
                console.log("该文件可以秒传");
                _this.uploadFileCTPdf(url, hash, file, fileInfo, folderId, param, successCB, failCB, progressCB);
              } else if (responseData["code"] == "20022") {
                console.log("该文件需要进一步判断是否可以秒传");
                file.useFullHash = true;
                MMNetDiskDataController.calcFileHashAndUpload(file, fileInfo, folderId, param, successCB, failCB, progressCB);
              }
            } else {
              failCB(file, responseData["code"], responseData["msg"]);
            }
          },
          error: function error(xhr, status, _error2) {
            console.log(xhr);
            if (xhr.status == 403 && tryCount < 3 && file.uploadFile.get("state") === _MDUploadFile["default"].states.uploading) {
              setTimeout(function () {
                request();
              }, 1500);
            } else {
              failCB(file, xhr.status, BabelStr.str(2349));
            }
            tryCount++;
            console.log(xhr);
          }
        });
      };
      request();
    }
  },
  uploadFileCTPdf: function uploadFileCTPdf(url, hash, file, fileInfo, folderId, param, successCB, failCB, progressCB, formParams) {
    var postData = {
      // fileHash: 'hash',
      folderId: folderId,
      fileId: fileInfo ? fileInfo.getFileId() : "",
      fileName: MMCommonFun.filterFileName(file.name),
      fileSize: file.size,
      sid: window.g_sessionId,
      forbidAutoRename: param.forbidAutoRename,
      sameNameAsNewVersion: param.sameNameAsNewVersion,
      ignoreVirus: param.ignoreVirus ? param.ignoreVirus : 0
    };
    if (formParams) {
      Object.entries(formParams).forEach(function (_ref) {
        var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        postData[key] = value;
      });
    }
    if (file.useFullHash) {
      postData.fileHash = file.hash;
    } else {
      postData.quickHash = file.quickHash;
    }
    if (file.batchUploadMark) {
      var batchUploadInfo = window[file.batchUploadMark];
      postData.uploadToken = batchUploadInfo.key;
    }
    var count = 1;
    var ontimeout = function ontimeout() {
      if (count > 10) {
        var msg = _SystemError["default"][10001];
        failCB(file, "", msg);
        return;
      }
      count++;
      _MMEnterpriseController["default"].getUploadStatus(hash, window.g_sessionId, folderId, function (res) {
        if (res.code == 0 && res["fileId"]) {
          file.done = true;
          file.progress = 1.0;
          progressCB(file, param.uploadId);
          successCB(file, {
            fileId: res["fileId"],
            fileSize: res["fileSize"],
            // pageSize: res["pageSize"] || [],
            version: res["version"] || 0,
            fileName: res["fileName"],
            versionNo: res["versionNo"]
          });
          _czc && _czc.push(["_trackEvent", "创建", "上传文件", "", "", ""]);
        } else if (res.code = 20005 || res.code == 0 && !res["fileId"]) {
          setTimeout(function () {
            ontimeout();
          }, 30000);
        } else {
          failCB(file, res.code, res["msg"]);
        }
      }, function () {});
    };
    file.xhr = $.ajax({
      method: "post",
      url: url,
      data: postData,
      success: function success(response) {
        if (response["success"] === true) {
          _czc && _czc.push(["_trackEvent", "创建", "秒传文件", "", "", ""]);
          file.fileId = response["fileId"];
          file.done = true;
          file.progress = 1.0;
          progressCB(file, param.uploadId);
          successCB(file, {
            fileId: response["fileId"],
            fileSize: response["fileSize"],
            // pageSize: response["pageSize"] || [],
            // fileRefId: response["fileRefId"],
            version: response["version"] || 0,
            // versionId: response["versionId"],
            fileName: response["fileName"],
            versionNo: response["versionNo"]
          });
        } else {
          var code = response["code"];
          if (code == _ErrorCode["default"].SameFileExists) {
            var fileInfo = response["fileInfo"];
            if (fileInfo) {
              successCB(file, {
                fileId: fileInfo["fileId"],
                fileSize: fileInfo["fileSize"],
                // pageSize: response["pageSize"] || [],
                version: fileInfo["version"] || 0,
                fileName: fileInfo["fileName"],
                versionNo: fileInfo["versionNo"]
              });
              return;
            }
          }
          failCB(file, code, response["msg"]);
        }
      },
      // timeout: 2000,
      error: function error(res) {
        ontimeout(res);
      }
    });
  },
  uploadBabelFile: function uploadBabelFile(uploadURL, hash, file, fileInfo, folderId, param, successCB, failCB, progressCB, formParams) {
    //optional parameter fileInfo
    if (typeof fileInfo === "function") {
      progressCB = failCB;
      failCB = successCB;
      successCB = fileInfo;
      fileInfo = null;
    }
    var that = MMNetDiskDataController;

    /**
     * in the first version, the name is just the original name, later here we cen set the VersionNumber
     */
    file.uploadName = file.name;

    // MMNetDiskDataController.getUploadURL(file, fileInfo, function(uploadURL, fileId) {

    if (!(file.blocked !== true && !file["canceled"])) {
      failCB(file);
      return;
    }
    var formData = new FormData();
    if (file instanceof File) {
      formData.append("file", file, file.uploadName);
      formData.append("fileName", MMCommonFun.filterFileName(file.name));
    } else {
      formData.append("fileName", MMCommonFun.filterFileName(file.fileName));
      // let blob = new Blob([file.text], { type: 'text/plain' });
      formData.append("text", file.text);
    }
    if (file.batchUploadMark) {
      var batchUploadInfo = window[file.batchUploadMark];
      formData.append("uploadToken", batchUploadInfo.key);
    }
    formData.append("lang", _MDLocalString["default"].getCurrentLanguage());
    if (file.useFullHash) {
      formData.append("fileHash", file.hash);
    } else {
      formData.append("quickHash", file.quickHash);
    }
    formData.append("sid", window.g_sessionId);
    formData.append("fileId", fileInfo ? fileInfo.getFileId() : "");
    formData.append("folderId", folderId);
    formData.append("forbidAutoRename", param.forbidAutoRename);
    formData.append("sameNameAsNewVersion", param.sameNameAsNewVersion);
    formData.append("ignoreVirus", param.ignoreVirus);
    if (formParams) {
      Object.entries(formParams).forEach(function (_ref3) {
        var _ref4 = (0, _slicedToArray2["default"])(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];
        formData.append(key, value);
      });
    }
    var queryString = "?";
    var xhr = that.getXhr();
    var speedTimer = null;

    // Set up a handler for when the request finishes.
    var onload = function onload(ep) {
      xhr.progressing = true;
      clearInterval(speedTimer);
      speedTimer = null;
      if (xhr.readyState == 4) {
        var status = xhr.status;
        if (status >= 200 && status < 300 || status === 304) {
          try {
            var response = JSON.parse(xhr.response);
            file.done = true;
            file.progress = 1.0;
            progressCB(file, param.uploadId);
            if (response["success"]) {
              successCB(file, {
                fileId: response["fileId"],
                fileSize: response["fileSize"],
                // pageSize: response["pageSize"] || [],
                version: response["version"] || 0,
                fileName: response["fileName"],
                versionNo: response["versionNo"]
              });
              _czc && _czc.push(["_trackEvent", "创建", "上传文件", "", "", ""]);
            } else {
              var code = response["code"];
              if (code == _ErrorCode["default"].SameFileExists) {
                var fileInfo = response["fileInfo"];
                if (fileInfo) {
                  successCB(file, {
                    fileId: fileInfo["fileId"],
                    fileSize: fileInfo["fileSize"],
                    // pageSize: response["pageSize"] || [],
                    version: fileInfo["version"] || 0,
                    fileName: fileInfo["fileName"],
                    versionNo: fileInfo["versionNo"]
                  });
                  return;
                }
              }
              failCB(file, code, response["msg"]);
            }
          } catch (error) {
            failCB(file, "", BabelStr.str(7375));
          }
        }
      }
    };
    var tryErrorCount = 0;
    var onerror = function onerror(ep, code) {
      if (code == 404 || _.isUndefined(code)) {
        if (code == 404) {
          if (tryErrorCount++ < 3) {
            tryUpload4error();
            return;
          }
        } else {
          ontimeout();
          return;
        }
      }
      xhr.progressing = true;
      clearInterval(speedTimer);
      speedTimer = null;
      var status = code || xhr.status;
      var msg = BabelStr.str(7376);
      if (status) {
        msg = _SystemError["default"][status];
        if (!msg) {
          msg = BabelStr.str(7377) + " status:" + status;
        }
      }

      // var response = JSON.parse(xhr.response);
      file.done = true;
      failCB(file, undefined, msg);
    };
    var onreadystatechange = function onreadystatechange(event) {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          console.log(xhr.responseText);
        } else {
          console.log("Error", xhr.statusText);
        }
      }
    };
    var lastLoaded = 0;
    var lastTimeStamp = Date.now() - 1000;
    var interpolateLenth = 5;
    var bitrateStabilizer = new _tStabilizer["default"](interpolateLenth);
    _.times(interpolateLenth, function (i) {
      bitrateStabilizer.pushLoaded(0);
    });
    function progressCalculate(ep) {
      var deltaTime = Date.now() - lastTimeStamp;
      var progress = ep.loaded / ep.total * 0.9 + 0.1;
      if (progress < 1 && deltaTime < 1000) {
        return;
      }
      var deltaLoaded = ep.loaded - lastLoaded;
      var bitrate = parseInt(deltaLoaded / deltaTime);
      if (bitrate !== Infinity && !_.isNaN(bitrate) && deltaTime && bitrate >= 0) {
        file.total = ep.total;
        file.loaded = ep.loaded;
        file.progress = progress;
        bitrateStabilizer.pushLoaded(ep.loaded);
        file.bitrate = bitrateStabilizer.getAvarage();
        if (_.isNaN(file.bitrate)) file.bitrate = 0;
        lastLoaded = ep.loaded;
        lastTimeStamp = Date.now();
        progressCB(file, param.uploadId);
      }
    }
    var g_ep = null;
    var onprogress = function onprogress(ep) {
      xhr.progressing = true;
      progressCalculate(ep);
      g_ep = ep;
      if (!speedTimer) {
        speedTimer = setInterval(function () {
          progressCalculate(g_ep);
        }, 1000);
      }
      if (ep.loaded / ep.total > 9.999) {
        clearInterval(speedTimer);
      }
    };
    var onabort = function onabort() {
      xhr.progressing = true;
      clearInterval(speedTimer);
    };
    var count = 1;
    var ontimeout = function ontimeout(res) {
      if (count > 10) {
        onerror(res, 10001);
        return;
      }
      count++;
      _MMEnterpriseController["default"].getUploadStatus(hash, window.g_sessionId, folderId, function (res) {
        if (res.code == 0 && res["fileId"]) {
          file.done = true;
          file.progress = 1.0;
          progressCB(file, param.uploadId);
          successCB(file, {
            fileId: res["fileId"],
            fileSize: res["fileSize"],
            // pageSize: res["pageSize"] || [],
            version: res["version"] || 0,
            fileName: res["fileName"],
            versionNo: res["versionNo"]
          });
          _czc && _czc.push(["_trackEvent", "创建", "上传文件", "", "", ""]);
        } else if (res.code = 20005 || res.code == 0 && !res["fileId"]) {
          setTimeout(function () {
            ontimeout(res);
          }, 30000);
        } else {
          onerror(res, res.code);
        }
      }, function () {});
    };
    var tryUpload4error = function tryUpload4error() {
      setTimeout(function () {
        checkToSendAgain();
      }, 1000);
    };

    // 如果长时间没有反应，应该再试一次
    var checkToSendAgain = function checkToSendAgain() {
      // Send the Data.
      xhr.open("POST", uploadURL, true);
      xhr.onload = onload;
      xhr.onerror = onerror;
      xhr.onreadystatechange = onreadystatechange;
      xhr.upload.onprogress = onprogress;
      xhr.upload.onabort = onabort;
      xhr.ontimeout = ontimeout;
      // xhr.timeout = 2000;               //测试代码，需删除
      xhr.send(formData);
      var tryCount = 1;
      file.xhr = xhr;
      file.xhr._uploadSuccess = successCB;
      file.xhr._uploadFail = failCB;
      file.xhr._uploadProgress = progressCB;

      // file.monitorState = setBabelTimeout(function(){
      //   if (!xhr.progressing && tryCount == 3) {
      //     xhr.abort();
      //     failCB &&failCB(file);
      //     return;
      //   };
      //   if (!xhr.progressing) {
      //     xhr.abort();

      //     xhr = that.getXhr();
      //     tryCount++;
      //     checkToSendAgain();

      //     console.error('-------- send again:', tryCount, ' , file:', file.name);
      //   };
      // }, 10000);
    };
    checkToSendAgain();

    // }, function(response) {
    //   failCB(file, response['code'], response['msg']);
    // });
  },
  uploadBlockBabelFile: function uploadBlockBabelFile(hash, file, fileInfo, folderId, param, successCB, failCB, progressCB) {
    // if(file.blockUploadUrl) {
    //   this.goBlockUpload(file, file.blockUploadUrl, file.blockUploadFormData, file ,progressCB, successCB, failCB)
    //   return
    // }

    //optional parameter fileInfo
    var self = this;
    if (typeof fileInfo === "function") {
      progressCB = failCB;
      failCB = successCB;
      successCB = fileInfo;
      fileInfo = null;
    }
    var formData = {
      // fileId:fileId,
      forbidAutoRename: param.forbidAutoRename,
      sameNameAsNewVersion: param.sameNameAsNewVersion,
      fileName: MMCommonFun.filterFileName(file.name),
      fileSize: file.size + "",
      folderId: folderId,
      ignoreVirus: param.ignoreVirus,
      fileId: fileInfo ? fileInfo.getFileId() : ""
    };
    if (file.useFullHash) {
      formData.fileHash = file.hash;
    } else {
      formData.quickHash = file.quickHash;
    }
    $.ajax({
      method: "post",
      url: "/file/preBlockUpload.do",
      data: formData,
      success: function success(data) {
        // data.success = false;
        // data.code = 10002;
        // data.msg = '操作失败'
        if (data.success) {
          if (file.blocked) {
            return;
          }
          if (data.code == 0) {
            file.uploadUrl = data.url;
            var blockUploadFormData = new FormData();
            var fileId = fileInfo ? fileInfo.getFileId() : "";

            // Pass a simple key-value pair
            blockUploadFormData.append("fileId", fileId), blockUploadFormData.append("forbidAutoRename", param.forbidAutoRename);
            blockUploadFormData.append("sameNameAsNewVersion", param.sameNameAsNewVersion);
            blockUploadFormData.append("fileName", MMCommonFun.filterFileName(file.name));
            blockUploadFormData.append("folderId", folderId);
            blockUploadFormData.append("sId", window.g_sessionId); //sId：身份验)证
            if (file.useFullHash) {
              blockUploadFormData.append("fileHash", file.hash);
            } else {
              blockUploadFormData.append("quickHash", file.quickHash);
            }
            blockUploadFormData.append("fileId", fileInfo ? fileInfo.getFileId() : "");
            file.start = data.start;
            blockUploadFormData.append("uploadToken", data.uploadToken);
            console.warn("token: " + data.uploadToken);

            // file.blockUploadFormData = blockUploadFormData
            self.goBlockUpload(file, data.url, blockUploadFormData, param, progressCB, successCB, failCB);
          } else if (data["code"] == "19") {
            console.log("该文件可以秒传");
            self.uploadFileCTPdf(data.url, hash, file, fileInfo, folderId, param, successCB, failCB, progressCB);
          } else if (data["code"] == "20022") {
            console.log("该文件需要进一步判断是否可以秒传");
            file.useFullHash = true;
            MMNetDiskDataController.calcFileHashAndUpload(file, fileInfo, folderId, param, successCB, failCB, progressCB);
          }
        } else {
          failCB(file, data["code"], data["msg"]);
        }
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        // 请求最终失败后的处理
        failCB();
      }
    });
  },
  goBlockUpload: function goBlockUpload(file, url, blockUploadFormData, param, progressCB, successCB, failCB) {
    var self = this;
    var fileSize = file.size;
    // var uploadStart = file.start;
    // var uploadedSize = uploadStart;

    var needNextBlockUpload = true;
    var lastLoaded = 0;
    var lastTimeStamp = Date.now() - 1000;
    var interpolateLenth = 5;
    var bitrateStabilizer = new _tStabilizer["default"](interpolateLenth);
    _.times(interpolateLenth, function (i) {
      bitrateStabilizer.pushLoaded(0);
    });
    var remainSize = fileSize - file.start;
    var uploadSize = remainSize > window.blockSize ? window.blockSize : remainSize;
    var blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
    function calcMd5AndUpload() {
      if (!file.md5Start) {
        file.md5Start = 0;
      }
      var md5Start = file.md5Start;
      var readChunkSize = uploadSize;
      if (md5Start + window.blockSize <= file.start) {
        readChunkSize = window.blockSize;
      }
      if (file.start >= md5Start && !file.hash) {
        if (!file.spark) {
          file.spark = new SparkMD5.ArrayBuffer();
        }
        var spark = file.spark;
        var chunkSpark = new SparkMD5.ArrayBuffer();
        file.fileReader = new FileReader();
        file.fileReader.onload = function (e) {
          // console.log('read chunk nr', currentChunk + 1, 'of', chunks);
          spark.append(e.target.result); // Append array buffer

          chunkSpark.append(e.target.result);
          var chunkHask = chunkSpark.end();
          if (!file.chunkMd5Map) {
            file.chunkMd5Map = new Map();
          }
          file.chunkMd5Map.set(md5Start, chunkHask);
          file.md5Start = file.md5Start + readChunkSize;
          if (file.md5Start <= file.start) {
            calcMd5AndUpload();
          } else if (file.md5Start >= fileSize) {
            //计算完全部
            // success(spark.end());
            var hash = spark.end();
            // console.log('finished loading');
            console.info("computed hash", hash); // Compute hash
            file.hash = hash; // 记录文件MD5，重传时避免再次计算
            uploadItem();
          } else {
            uploadItem();
          }
        };
        file.fileReader.readAsArrayBuffer(blobSlice.call(file, file.md5Start, file.md5Start + readChunkSize));
        // file.fileReader.readAsArrayBuffer(blobSlice.call(file, file.md5Start, file.start + uploadSize));
      } else {
        uploadItem();
      }
    }
    function uploadItem() {
      var result = blobSlice.call(file, file.start, file.start + uploadSize);
      console.log("file uploaded is ".concat(file.start, ", new upload end is ").concat(file.start + uploadSize - 1));
      blockUploadFormData.set("file", result);
      blockUploadFormData.set("start", file.start);

      //**********分块md5******** */
      if (!file.chunkMd5Map) {
        console.error("出错了，chunkMd5Map 没有初始化");
      }
      console.log("file.start", file.start, "md5", file.chunkMd5Map.get(file.start));
      blockUploadFormData.set("blockMd5", file.chunkMd5Map.get(file.start));
      if (file.hash) {
        blockUploadFormData.set("fileHash", file.hash);
      }
      var onload = function onload(res) {
        console.error('uploaded', new Date());
        try {
          var response = JSON.parse(xhr.response);
        } catch (e) {
          console.log(e);
        }
        console.log("file size is ".concat(file.size, ", new upload start is ").concat(file.start + uploadSize));
        if (response.code == 20) {
          var msg = BabelStr.str(7376);
          file.done = true;
          failCB(file, undefined, msg);
        } else if (response.success == true) {
          file.start = response.start || file.start + uploadSize;
          if (file.start < fileSize && needNextBlockUpload) {
            calcMd5AndUpload();
          } else {
            console.log(response);
            successCB(file, {
              fileId: response["fileId"],
              fileSize: response["fileSize"],
              // pageSize: response["pageSize"] || [],
              version: response["version"] || 0,
              fileName: response["fileName"],
              versionNo: response["versionNo"]
            });
          }
        } else {
          var _msg = BabelStr.str(11323);
          file.done = true;
          failCB(file, undefined, _msg);
        }
      };
      var onerror = function onerror(ep, code) {
        var status = code || xhr.status;
        var msg = BabelStr.str(7376);
        if (status) {
          msg = _SystemError["default"][status];
          if (!msg) {
            msg = BabelStr.str(7377) + " status:" + status;
          }
        }
        file.done = true;
        failCB(file, undefined, msg);
      };
      var xhr = self.getXhr();
      file.xhr = xhr;
      xhr.open("POST", url, true);
      xhr.onload = onload;
      xhr.onerror = onerror;
      xhr.upload.onprogress = progressCalculate;
      xhr.send(blockUploadFormData);
    }
    if (file.start < fileSize && needNextBlockUpload) {
      calcMd5AndUpload();
    } else {
      console.error("该换文件了");
    }
    function progressCalculate(ep) {
      var deltaTime = Date.now() - lastTimeStamp;
      var progress = (ep.loaded + file.start) / file.size * 0.9 + 0.1;
      if (progress < 1 && deltaTime < 1000) {
        console.warn(ep.loaded / ep.total, new Date());
        return;
      }
      var deltaLoaded = ep.loaded + file.start - lastLoaded;
      var bitrate = parseInt(deltaLoaded / deltaTime);
      if (bitrate !== Infinity && !_.isNaN(bitrate) && deltaTime && bitrate >= 0) {
        // file.total = ep.total;
        // file.loaded = ep.loaded;
        file.progress = progress;
        bitrateStabilizer.pushLoaded(ep.loaded + file.start);
        file.bitrate = bitrateStabilizer.getAvarage();
        if (_.isNaN(file.bitrate)) file.bitrate = 0;
        lastLoaded = ep.loaded + file.start;
        lastTimeStamp = Date.now();
        progressCB(file, param.uploadId);
      }
    }
  },
  uploadFile: function uploadFile(file, uploadURL, otherParams, successCB, failCB, progressCB) {
    var formData = new FormData();
    formData.append("file", file);
    var keys = Object.keys(otherParams);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      formData.append(key, otherParams[key]);
    }
    var that = MMNetDiskDataController;
    var xhr = that.getXhr();
    xhr.open("POST", uploadURL, true);
    xhr.onload = function (ep) {
      if (xhr.status === 200) {
        var response = JSON.parse(xhr.response);
        if (response["success"]) {
          successCB();
        } else {
          failCB(response["code"], response["msg"]);
        }
      } else {
        //error
        failCB(BabelStr.str(7378));
      }
    };
    xhr.onerror = function (ep) {
      // url 错误

      failCB();
    };
    xhr.upload.onprogress = function (ep) {
      var progress = ep.loaded / ep.total;
      progressCB(progress);
    };
    xhr.send(formData);
  },
  downLoadFileData: function downLoadFileData(imgUrl, successCB, failCB, progressCB, key) {
    var xhr = this.getXhr();
    xhr.open("get", imgUrl, true);
    xhr.responseType = "arraybuffer";

    // Set up a handler for when the request finishes.
    xhr.onload = function (ep) {
      var data = xhr.response;
      if (key) {
        data = _utils["default"].decryptDesECBArryBuffer(data, key);
      }
      successCB(data);

      // var response = JSON.parse(xhr.response);
      // if (xhr.status === 200) {
      //   file.done = true;
      //   file.progress = 1.0;
      //   progressCB(file);

      //   if (response["success"]) {
      //     successCB();
      //   } else {
      //     failCB();s
      //   }
      // } else {
      //   //error
      //   failCB();
      // }
    };
    xhr.onerror = function (ep) {
      var response = JSON.parse(xhr.response);
      failCB();
    };
    var g_ep = null;
    xhr.onprogress = function (ep) {
      // console.log('---------- progress:', ep.loaded / ep.total)
      if (progressCB) {
        progressCB(ep.loaded / ep.total);
      }
    };
    try {
      xhr.send();
    } catch (error) {
      failCB(error);
    }
  },
  downloadFile: function downloadFile(url) {
    var $iframe = $("#file-downloader");
    if ($iframe.length == 0) {
      $iframe = $("<iframe>");
      $iframe.attr("id", "file-downloader").appendTo("body");
      $iframe.width(0).height(0).css("visibility", "hidden");
    }
    $iframe.attr("src", url);
  },
  abordUpload: function abordUpload(file) {
    if (file.xhr) {
      file.xhr.abort();
      file.xhr._uploadFail(new Error("abort by app"));
      file.xhr = null;
    }
  },
  /////////////////////////////////////////////////////////////////////////////
  ////////////////           MESSAGES             /////////////////////////////
  /////////////////////////////////////////////////////////////////////////////
  getAccessList: function getAccessList(success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.getAccessList", {}, function (res) {
      try {
        if (res["resultCode"] !== 0) {
          if (fail) fail();
          return;
        }
        if (success) {
          var out = [];
          (res["msgArr"] || []).forEach(function (accessInfo) {
            out.push(new _MDConversation["default"]({
              fileInfo: new _MMFileInfo["default"](accessInfo["fInfo"]),
              unreadMsgCount: accessInfo["unreadCount"],
              lastTime: new Date(accessInfo["lastTime"]),
              lastMsg: accessInfo["latestMessage"]
            }));
          });
          success(out);
        }
      } catch (e) {
        console.log("error", e);
      }
    });
  },
  sendFileMessage: function sendFileMessage(fid, content, commentId, success, fail) {
    var params = {};
    params["fid"] = fid;
    params["msgContent"] = content;
    if (typeof commentId == "function") {
      fail = success;
      success = commentId;
      commentId = null;
    }
    if (commentId) {
      params["commentId"] = commentId;
    }
    MMNetDiskDataController.request("netDrive.fileHandler.sendMessage", params, function (res) {
      try {
        if (res["resultCode"] !== 0) {
          if (fail) {
            fail();
          } else {
            MMNetDiskDataController.errorTimes++;
            if (MMNetDiskDataController.errorTimes > 3) {
              _MDSnackbarView["default"].show(BabelStr.str(7379));
            } else {
              MMNetDiskDataController._connector.reconnectAndCall(function () {
                MMNetDiskDataController.sendFileMessage(fid, content, commentId, success, fail);
              });
            }
          }
          return;
        }
        MMNetDiskDataController.errorTimes = 0;
        if (success) success(res["messageId"]);
      } catch (e) {
        console.log("error", e);
      }
    });
  },
  sendDepChatMessage: function sendDepChatMessage(fid, content, commentId, success, fail) {
    var params = {};
    params["fid"] = fid;
    params["msgContent"] = content;
    if (typeof commentId == "function") {
      fail = success;
      success = commentId;
      commentId = null;
    }
    if (commentId) {
      params["commentId"] = commentId;
    }
    MMNetDiskDataController.request("netDrive.fileHandler.sendDepChatMessage", params, function (res) {
      try {
        if (res["resultCode"] !== 0) {
          if (fail) {
            fail();
          } else {
            MMNetDiskDataController.errorTimes++;
            if (MMNetDiskDataController.errorTimes > 3) {
              _MDSnackbarView["default"].show(BabelStr.str(7379));
            } else {
              MMNetDiskDataController._connector.reconnectAndCall(function () {
                MMNetDiskDataController.sendFileMessage(fid, content, commentId, success, fail);
              });
            }
          }
          return;
        }
        MMNetDiskDataController.errorTimes = 0;
        if (success) success(res["messageId"]);
      } catch (e) {
        console.log("error", e);
      }
    });
  },
  sendProjectChatMessage: function sendProjectChatMessage(fid, content, commentId, success, fail) {
    var params = {};
    params["fid"] = fid;
    params["msgContent"] = content;
    if (typeof commentId == "function") {
      fail = success;
      success = commentId;
      commentId = null;
    }
    if (commentId) {
      params["commentId"] = commentId;
    }
    MMNetDiskDataController.request("netDrive.fileHandler.sendProjectChatMessage", params, function (res) {
      try {
        if (res["resultCode"] !== 0) {
          if (fail) {
            fail();
          } else {
            MMNetDiskDataController.errorTimes++;
            if (MMNetDiskDataController.errorTimes > 3) {
              _MDSnackbarView["default"].show(BabelStr.str(7379));
            } else {
              MMNetDiskDataController._connector.reconnectAndCall(function () {
                MMNetDiskDataController.sendFileMessage(fid, content, commentId, success, fail);
              });
            }
          }
          return;
        }
        MMNetDiskDataController.errorTimes = 0;
        if (success) success(res["messageId"]);
      } catch (e) {
        console.log("error", e);
      }
    });
  },
  touchFile: function touchFile(fileId, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.touchFile", {
      fid: fileId
    }, function (res) {
      _.delay(function () {
        if (res["resultCode"] !== 0) {
          if (fail) fail();
          return;
        }
        if (success) success();
      }, 0);
    });
  },
  getFileMessages: function getFileMessages(fileId, startId, pageSize, success, fail) {
    if (typeof startId == "function") {
      success = startId;
      fail = pageSize;
      startId = 0;
      pageSize = 50;
    } else if (typeof pageSize == "function") {
      fail = success;
      success = pageSize;
      pageSize = 50;
    }
    var params = {
      fid: fileId,
      startId: startId || 0,
      pageSize: pageSize || 50
    };
    MMNetDiskDataController.request("netDrive.fileHandler.getMessages", params, function (res) {
      _.delay(function () {
        if (res["resultCode"] !== 0) {
          if (fail) fail();
          return;
        }
        var msgArr = res["msgArr"] || [];
        msgArr = msgArr.map(function (messageInfo) {
          var msgText = messageInfo["msgContent"];
          if (msgText) {
            var message;
            try {
              message = JSON.parse(msgText);
            } catch (e) {
              message = {
                Body: msgText,
                Type: "Text",
                pageIndex: -1
              };
            }
            messageInfo["msg"] = new Backbone.Model(message);
          }
          messageInfo["time"] = new Date(parseInt(messageInfo["time"]) * 1000);
          return new _MDMessage["default"](messageInfo);
        });
        msgArr.reverse();
        if (success) {
          success(msgArr, res["gotMoreMessages"]);
        }
      }, 0);
    });
  },
  getDepartmentMessages: function getDepartmentMessages(fileId, startId, pageSize, success, fail) {
    if (typeof startId == "function") {
      success = startId;
      fail = pageSize;
      startId = 0;
      pageSize = 50;
    } else if (typeof pageSize == "function") {
      fail = success;
      success = pageSize;
      pageSize = 50;
    }
    var params = {
      fid: fileId,
      startId: startId || 0,
      pageSize: pageSize || 50
    };
    MMNetDiskDataController.request("netDrive.fileHandler.getDepartmentMessages", params, function (res) {
      _.delay(function () {
        if (res["resultCode"] !== 0) {
          if (fail) fail();
          return;
        }
        var msgArr = res["msgArr"] || [];
        msgArr = msgArr.map(function (messageInfo) {
          var msgText = messageInfo["msgContent"];
          if (msgText) {
            var message;
            try {
              message = JSON.parse(msgText);
            } catch (e) {
              message = {
                Body: msgText,
                Type: "Text",
                pageIndex: -1
              };
            }
            messageInfo["msg"] = new Backbone.Model(message);
          }
          messageInfo["time"] = new Date(parseInt(messageInfo["time"]) * 1000);
          return new _MDMessage["default"](messageInfo);
        });
        msgArr.reverse();
        if (success) {
          success(msgArr, res["gotMoreMessages"]);
        }
      }, 0);
    });
  }
};
Object.assign(MMNetDiskDataController, _part["default"], _part2["default"]);
//do not change here, we will overwrite MMNetDiskDataController from the Serverside. Tobias (shared/code.js)
MMNetDiskDataController.code = {
  SUCCESS: 0,
  ERROR: 1,
  ERROR_CLIENT_VERSION_NOT_SUPPORT: 100,
  ERROR_SERVER_RUNTIME_ERROR: 101,
  ERROR_TO_BUSY: 302,
  ERROR_ALREADY_IN: 303,
  ERROR_COLLABORATION_CREATE: 201,
  ERROR_COLLABORATION_SENDACTION_INTERNAL: 203,
  ERROR_COLLABORATION_NOT_FOUND: 204,
  ERROR_COLLABORATION_GET_DATABLOCK: 205,
  ERROR_COLLABORATION_NO_AUTHORITY: 206,
  ERROR_COLLABORATION_DELETE_INTERNAL: 207,
  ERROR_COLLABORATION_RENAME_INTERNAL: 208,
  ERROR_COLLABORATION_CLOSE_INTERNAL: 209,
  ERROR_COLLABORATION_QUIT_INTERNAL: 210,
  ERROR_COLLABORATION_NO_PRIVILEGE: 211,
  ERROR_COLLABORATION_JOIN_DUPLICATE: 251,
  ERROR_COLLABORATION_NOT_JOIN: 252,
  ERROR_COLLABORATION_MISSING_BUFFER: 253,
  ERROR_COULD_NOT_SAVE: 254,
  ERROR_NOT_FOUND: 404,
  ERROR_NOT_IMPLEMENTED: 405,
  ERROR_OUT_OF_LIMIT: 406,
  ERROR_SESSION_ALREADY_EXIST: 501,
  ERROR_SESSION_NOT_VALID: 502,
  ERROR_SESSION_NO_USER_ID: 503,
  ERROR_CACHE_STORE_USER_SESSION: 601,
  ERROR_CACHE_GET_USER_SESSION: 602,
  ERROR_CACHE_STORE_SESSION_CID: 621,
  ERROR_CACHE_GET_SESSION_CID: 622,
  ERROR_DB_BOARD_CREATE: 801,
  ERROR_DB_COLLABORATION_ADD_PARTICIPANT: 831,
  ERROR_DB_COLLABORATION_NOT_EXIST: 832,
  ERROR_DB_COLLABORATION_ALREADY_EXIST: 833,
  ERROR_DB_DIRECTORY_ALREADY_EXIST: 851,
  ERROR_DB_DIRECTORY_NOT_EXIST: 852,
  ERROR_DB_FILE_NOT_EXIST: 901,
  ERROR_DB_FILE_NAME_EXIST: 314,
  ERROR_DB_FILE_ALREADY_EXISTS: 903,
  ERROR_DB_FILESIZE_EXCEEDED: 904,
  ERROR_MESSAGE_INVALID_FORMAT: 1001,
  ERROR_MESSAGE_INVALID_CONTENT: 1002,
  ERROR_MESSAGE_USER_ID_MISMATCH: 1003,
  ERROR_MESSAGE_BOARD_ID_INVALID: 1004,
  ERROR_MESSAGE_DATABLOCK_ID_INVALID: 1005,
  ERROR_MESSAGE_READ_NO_AUTHORITY: 1006,
  ERROR_CHAT_TO_ADDRESS_INVALID: 2001,
  ERROR_CHAT_FROM_ADDRESS_INVALID: 2002,
  ERROR_CHAT_FROM_ADDRESS_MISMATCH: 2003,
  ERROR_CHAT_BODY_INVALID: 2004,
  ERROR_MONGODB_STORE_MESSAGE: 3001,
  ERROR_MONGODB_GET_MESSAGE: 3002,
  ERROR_DIRECTORY_CREATE: 4001,
  ERROR_DIRECROTY_DELETE_INTERNAL: 4002,
  ERROR_DELETE_INTERNAL: 4003,
  ERROR_PARENT_STILL_IN_TRASH: 316,
  ERROR_SHARE_ERROR: 4101,
  ERROR_SHARE_CANCEL_ERROR: 4102,
  ERROR_FILE_ABSENT: 9001,
  ERROR_FILE_UPLOAD_INTERNAL: 9100,
  ERROR_FILE_SOMETHING: 9101,
  ERROR_FILENAME: 9102,
  ERROR_FILE_DELETE_INTERNAL: 317,
  ERROR_FILE_NOT_FOUND: 101,
  ERROR_FILE_MOVE_TO_PARENT: 9105,
  ERROR_FILE_IS_NOT_SHARED: 9106,
  ERROR_FILE_ACCESS_DENIED: 319,
  ERROR_FILE_HAS_SHARING_CHILDREN: 320,
  ERROR_FILE_IS_HOME_DIR: 9109,
  ERROR_FILE_MOVE_TO_YOU: 9110,
  ERROR_NO_VALID_JSON: 9146,
  ERROR_PERMISSION_DENIED: 12,
  ERROR_ALREADY_EXISTS: 9151,
  ERROR_PERMISSION_DENIED_FOR_ANONYMOUS: 9152,
  ERROR_DONT_DO_OT_YOURSELF: 9153,
  ERROR_MISSING_PARAMETER: 9154,
  ERROR_WRONG_PARAMETER: 9155,
  ERROR_CANT_LOAD_VERSIONS: 9164,
  ERROR_LAST_REMAINING_VERSION: 9165,
  ERROR_FILE_NOT_SHARED: 9200,
  ERROR_JOIN_FILE_INTERNAL: 9201,
  ERROR_COULD_NOT_RESTORE: 322,
  ERROR_CANT_SHARE: 9300,
  ERROR_CANT_SET_PASSWORD: 9301,
  ERROR_PASSWORD_NOTMATCH: 9302,
  ERROR_PARTICIPANT_LOAD_LIST: 9401,
  ERROR_USER_LOAD_LIST: 9501,
  ERROR_USER_NOT_FOUND: 203,
  ERROR_CONTACT_LOAD_LIST: 9601,
  ERROR_INVITATION_SEND: 9602,
  ERROR_INVITATION_REMOVE: 9603,
  ERROR_INVITATION_LIST: 9604,
  ERROR_FILEACCESSUSER_LIST: 9701,
  ERROR_FILEACCESSUSER_ADD: 9702,
  ERROR_FILECOMMENTACCESSUSER_LIST: 9703,
  ERROR_FILECOMMENTACCESSUSER_ADD: 9704,
  ERROR_FILECOMMENTCREATEUSER_ADD: 9705,
  ERROR_FILEVERSIONACCESSUSER_ADD: 9706,
  ERROR_FILESREAD_SET: 9707,
  ERROR_ORDERS_GET: 9708,
  ERROR_ORDER_ADD: 9709,
  ERROR_ORDER_GET: 9710,
  ERROR_ORDER_CANCEL: 9711,
  ERROR_ORDER_UPDATE: 9712,
  ERROR_PRODUCTS_GET: 9801,
  ERROR_PARAMETER_MISSING: 4001,
  ERROR_DEPART_HAS_CHILD: 323,
  ERROR_DELETE_IS_EVALUATING: 330,
  ERROR_EMPTY_EVALUATIONGROUPS: 332,
  ERROR_DEPART_HAS_ARCHIVE: 337,
  ERROR_FILE_NAME_EXISTS: 10004
};
window.MMNetDiskDataController = MMNetDiskDataController;
var _default = exports["default"] = MMNetDiskDataController;

},{"106":106,"107":107,"108":108,"1087":1087,"1091":1091,"1092":1092,"1095":1095,"1098":1098,"1105":1105,"1106":1106,"1110":1110,"1150":1150,"1184":1184,"1192":1192,"1412":1412,"1415":1415,"1418":1418,"1422":1422,"1423":1423,"1426":1426,"1428":1428,"1432":1432,"1435":1435,"1437":1437,"1439":1439,"1443":1443,"1451":1451,"1454":1454,"1455":1455,"1461":1461,"1463":1463,"1466":1466,"1478":1478,"1487":1487,"1537":1537,"1538":1538,"1541":1541,"17":17,"205":205,"235":235,"243":243,"245":245,"246":246,"247":247,"252":252,"253":253,"254":254,"255":255,"256":256,"257":257,"263":263,"270":270,"271":271,"272":272,"273":273,"282":282,"285":285,"289":289,"297":297,"298":298,"303":303,"310":310,"311":311,"315":315,"321":321,"325":325,"341":341,"717":717,"72":72}],1110:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var SystemError = {
  '400': "参数错误！",
  '401': "未授权",
  '403': "资源禁止访问",
  '500': "服务器内部错误",
  '503': "服务没有就绪",
  '10001': "上传超时，请刷新页面重试"
};
var _default = exports["default"] = SystemError;

},{"1454":1454}],1106:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {};

},{"1454":1454}],1105:[function(require,module,exports){
(function (global){(function (){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1418);
require(1463);
require(1537);
require(1417);
require(1422);
require(1426);
require(1421);
require(1439);
require(1503);
require(1500);
require(1415);
require(1471);
require(1478);
require(1423);
require(1487);
require(1538);
var _MDEvaluationStatus = _interopRequireDefault(require(254));
var _MDEvents = _interopRequireDefault(require(325));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MMFileInfoCollection = _interopRequireDefault(require(298));
var _MDMolaUser = _interopRequireDefault(require(272));
var _MMFileInfo = _interopRequireDefault(require(297));
var _MDConversationCollection = _interopRequireDefault(require(246));
var _MMVersionInfo = _interopRequireDefault(require(310));
var _MDRoleInfoCollection = _interopRequireDefault(require(282));
var _MDShareParticipantCollection = _interopRequireDefault(require(285));
var _regexp = _interopRequireDefault(require(106));
var _MDFileLog = _interopRequireDefault(require(256));
var _MDFileLogCollection = _interopRequireDefault(require(257));
var _MDEvaluationFlowInfo = _interopRequireDefault(require(252));
var _MDNetDriveFileHandler = _interopRequireDefault(require(1091));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDConstant = _interopRequireDefault(require(321));
var _app = _interopRequireDefault(require(17));
var _underscore = (typeof window !== "undefined" ? window['underscore'] : typeof global !== "undefined" ? global['underscore'] : null);
var _default = exports["default"] = {
  /**
   * get a list of fileInfo of files, that I have shared.
   */
  getAllMyShare: function getAllMyShare(success, fail, readInfoSuccess) {
    var route = "netDrive.fileHandler.getAllMyShareFiles";
    console.error(new Date().getTime());
    MMNetDiskDataController.request(route, {}, function (res) {
      console.error(new Date().getTime());
      setBabelTimeout(function () {
        console.error(new Date().getTime());
        var out = new _MMFileInfoCollection["default"](); //[];
        if (res["resultCode"] === 0) {
          if (!res["fileArr"]) {
            success(out);
            return;
          }
          res["fileArr"].forEach(function (fileInfo) {
            out.push(new _MMFileInfo["default"](fileInfo));
          });
          success(out);
          var param = {
            channelroot: _MDConstant["default"].ChannelRoot.MyShare
          };
          MMNetDiskDataController.get2ndFileInfo(out.models, param, readInfoSuccess);
        } else {
          fail(res["resultCode"]);
        }
        MMNetDiskDataController.curFileInfoList = out;
      }, 0);
    });
  },
  /**
   * get a list of fileInfo, of files that others have shared and the current user has Joined
   * excluding the current Users Share
   */
  getOthersShare: function getOthersShare(success, fail, readInfoSuccess) {
    var route = "netDrive.fileHandler.getOthersShareFiles";
    MMNetDiskDataController.request(route, {}, function (res) {
      setBabelTimeout(function () {
        if (res["resultCode"] === 0) {
          var out = new _MMFileInfoCollection["default"](); //[];
          if (!res["fileArr"]) {
            success(out);
            return;
          }
          res["fileArr"].forEach(function (fileInfo) {
            out.push(new _MMFileInfo["default"](fileInfo));
          });
          success(out);
          var param = {
            channelroot: _MDConstant["default"].ChannelRoot.MyJoinShare
          };
          MMNetDiskDataController.get2ndFileInfo(out.models, param, readInfoSuccess);
        } else {
          fail(res["resultCode"]);
        }
      }, 0);
    });
  },
  getAllMsgGroupInfo: function getAllMsgGroupInfo(clearOld, success, fail) {
    if (!MMNetDiskDataController.conversationList || clearOld) {
      MMNetDiskDataController.conversationList = new _MDConversationCollection["default"]();
    } else {
      MMNetDiskDataController.conversationList.checkToClearAllGroupForDifferentUser();
    }
    var conversationList = [];
    MMNetDiskDataController.getAccessList(function (conversationList) {
      //console.log("get " + cvsList.length + " conversations!");
      if (!clearOld) {
        conversationList.forEach(function (msg, k) {
          var found = MMNetDiskDataController.conversationList.find(function (item) {
            return item.get("fileInfo").getFileId() === msg.get("fileInfo").getFileId();
          });
          if (!found) {
            MMNetDiskDataController.conversationList.push(msg);
          } else {
            found.initByOhter(msg);
          }
        });
      } else {
        MMNetDiskDataController.conversationList.reset(conversationList);
      }
      if (success) {
        setBabelTimeout(function () {
          success(MMNetDiskDataController.conversationList);
        }, 0);
      }
    }, fail);
  },
  /**
   * get number of all unread messages
   */
  getAccessUnreadCount: function getAccessUnreadCount(success, fail) {
    var route = "netDrive.fileHandler.file_getAccessUnreadCount";
    MMNetDiskDataController.request(route, {}, function (res) {
      setBabelTimeout(function () {
        if (res["resultCode"] === 0) {
          _.isFunction(success) && success(res["total"]);
        } else {
          fail(res["resultCode"]);
        }
      }, 0);
    });
  },
  getContactList: function getContactList(success, fail) {
    var route = "netDrive.fileHandler.getContactList";
    MMNetDiskDataController.request(route, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail();
      } else {
        var out = [];
        _.each(res["contactList"], function (obj) {
          obj["userId"] = obj["id"];
          out.push(obj);
        });
        if (_.isFunction(success)) success(out);
      }
    });
  },
  sendInvitations: function sendInvitations(params, success, fail) {
    var route = "netDrive.fileHandler.sendInvitations";
    MMNetDiskDataController.request(route, {
      fid: params.fid,
      approvers: params.approvers || [],
      roleId: params.roleId,
      leaveMessage: params.leaveMessage,
      participantInfo: params.participantInfo
    }, function (res) {
      if (res["resultCode"] !== 0) {
        var code = res["resultCode"];
        var errorMsg = BabelStr.str(309);
        if (code == 337) {
          errorMsg = BabelStr.str(7380);
        }
        if (_.isFunction(fail)) fail(res["resultCode"], errorMsg);
      } else {
        var addedUserIdArr = res["addedUserIds"];
        var departmentUsers = new _MDMolaUserCollection["default"](res["departmentUsers"]);
        if (_.isFunction(success)) success(addedUserIdArr, departmentUsers, res["sendApprove"]);
      }
    });
  },
  sendShareLink: function sendShareLink(fid, participantInfo, link, leaveMessage, success, fail) {
    var route = "netDrive.shareHandler.sendShareLink";
    MMNetDiskDataController.request(route, {
      fid: fid,
      link: link,
      participantInfo: participantInfo,
      leaveMessage: leaveMessage
    }, function (res) {
      if (res["resultCode"] !== 0) {
        var code = res["resultCode"];
        var errorMsg = BabelStr.str(309);
        if (code == 337) {
          errorMsg = BabelStr.str(7381);
        }
        if (_.isFunction(fail)) fail(res["resultCode"], errorMsg);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  getInvitationList: function getInvitationList(fid, success, fail) {
    var route = "netDrive.fileHandler.getInvitationList";
    MMNetDiskDataController.request(route, {
      fid: fid
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (fail) fail(res["resultCode"], res["message"]);
      } else {
        var contactList = res["list"] || [];
        var collection = new _MDMolaUserCollection["default"]();
        collection.add(contactList);
        if (_.isFunction(success)) success(collection);
      }
    });
  },
  /**
   * [removeInvitations description]
   * @param  {array} babelshareId
   */
  removeInvitations: function removeInvitations(fid, babelshareIds, success, fail) {
    var route = "netDrive.fileHandler.removeInvitations";
    MMNetDiskDataController.request(route, {
      fid: fid,
      babelshareIds: babelshareIds
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail();
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  getFileProgress: function getFileProgress(fileIds, success, fail) {
    if (!Array.isArray(fileIds)) fileIds = [fileIds];
    if (!success) return;
    var route = "netDrive.fileProgressHandler.getProgressByFile";
    MMNetDiskDataController.request(route, {
      fileIds: fileIds
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail();
      } else {
        var progressTags = res["progressTags"].map(function (tag) {
          return {
            userId: tag["userId"],
            fileId: tag["fileId"],
            progress: tag["progress"]
          };
        });
        var finishedFiles = res["finishedFileIds"];
        success(finishedFiles, progressTags);
      }
    });
  },
  setFileProgress: function setFileProgress(fileIds, progress, success, fail) {
    if (!Array.isArray(fileIds)) fileIds = [fileIds];
    if (["editing", "finished", "done"].indexOf(progress) === -1) {
      console.error('progress need to be in ["editing","finished","done"]');
      return;
    }
    var route = "netDrive.fileProgressHandler.setProgress";
    MMNetDiskDataController.request(route, {
      fileIds: fileIds,
      progress: progress
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail();
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  getBelongShareLink: function getBelongShareLink(fileId, success, fail) {
    var route = "netDrive.fileHandler.getBelongLinkShare";
    MMNetDiskDataController.request(route, {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail();
      } else {
        if (_.isFunction(success)) success(res);
      }
    });
  },
  // ******************** 与教程相关的代码

  // 编辑器教程是否已经演示完毕？
  // return: ture or false
  isEditorCourseDisplayed: function isEditorCourseDisplayed(success, fail) {
    var currentUser = _app["default"].currentUser;
    if (currentUser.isAnonymous()) {
      if (success) {
        success(localStorage.courseMark);
      }
    } else {
      MMNetDiskDataController.getCourseMark(function s(mark) {
        if (success) {
          success(!!(mark & 2));
        }
      }, function f() {
        if (fail) {
          fail();
        }
      });
    }
  },
  getCourseMark: function getCourseMark(success, fail) {
    var courseMark = 0;
    if (MMNetDiskDataController.courseMark !== undefined) {
      setBabelTimeout(function () {
        success(MMNetDiskDataController.courseMark);
      }, 0);
      return;
    }
    //----- call the server
    var route = "netDrive.fileHandler.getCourseMark";
    MMNetDiskDataController.request(route, {}, function (res) {
      setBabelTimeout(function () {
        if (res["resultCode"] !== 0) {
          if (_.isFunction(fail)) fail();
        } else {
          // commented to test the server
          MMNetDiskDataController.courseMark = res["courseMark"];
          if (_.isFunction(success)) success(res["courseMark"]);
        }
      }, 0);
    });
  },
  // 将编辑器教程设置为已经演示完毕
  setEditorCourseDisplayed: function setEditorCourseDisplayed(success, fail) {
    var currentUser = _app["default"].currentUser;
    if (currentUser.isAnonymous()) {
      localStorage.courseMark = true;
    } else {
      if (MMNetDiskDataController.courseMark == undefined) {
        return;
      }
      MMNetDiskDataController.getCourseMark(function s(mark) {
        if (!(mark & 2)) {
          MMNetDiskDataController.setCourseMark(mark | 2, function () {
            if (_.isFunction(success)) success();
          }, fail);
        } else {
          if (_.isFunction(success)) success();
        }
      }, fail);
    }
  },
  setCourseMark: function setCourseMark(mark, success, fail) {
    MMNetDiskDataController.courseMark = mark;

    // ----- call the server to set mark
    var route = "netDrive.fileHandler.setCourseMark";
    MMNetDiskDataController.request(route, {
      courseMark: mark
    }, function (res) {
      setBabelTimeout(function () {
        if (res["resultCode"] !== 0) {
          if (_.isFunction(fail)) fail();
        } else {
          if (_.isFunction(success)) success();
        }
      }, 0);
    });
  },
  requestApplication: function requestApplication(options, success, fail) {
    var route = "netDrive.fileHandler.requestApplication";
    MMNetDiskDataController.request(route, {
      name: options.name || "",
      email: options.email || "",
      mobile: options.mobile || "",
      company: options.company || "",
      position: options.position || ""
    }, function (res) {
      setBabelTimeout(function () {
        if (res["resultCode"] !== 0) {
          if (_.isFunction(fail)) fail();
        } else {
          if (_.isFunction(success)) success();
        }
      }, 0);
    });
  },
  // ******************** end

  // ******************** functions to access file unread mark and folder unread file count

  /**
   * @param fileInfo {MMFileInfo}
   * @param verInfo {MMVersionInfo}
   */
  clearFileVersionUnreadMark: function clearFileVersionUnreadMark(fileInfo, verInfo, success, fail) {
    var fileVer;
    if (verInfo) {
      if (verInfo.isCommitter()) {
        // if the file is committed by me, need not clear anything
        return;
      }
      fileVer = verInfo.get("ver");
    } else {
      if (fileInfo.isCommitter()) {
        return;
      }
      fileVer = fileInfo.getCurVersion();
    }
    var fileId = fileInfo.getFileId();
    MMNetDiskDataController._clearFileUnreadMarkWithIdAndVersion(fileId, fileVer, success, fail);
    if (fileInfo.isCurVersion(fileVer)) {
      fileInfo.clearUnReadCount();
    }
  },
  /**
   * @param fileInfo {MMFileInfo}
   * @param ver {int}
   */
  clearUnreadMarkWithVerNum: function clearUnreadMarkWithVerNum(fileInfo, ver, success, fail) {
    var fver = ver;
    fileInfo.isVerCommitter(fver, function (isCommitter) {
      if (!isCommitter) {
        var fileId = fileInfo.getFileId();
        MMNetDiskDataController._clearFileUnreadMarkWithIdAndVersion(fileId, fver, success, fail);
      }
      if (fileInfo.isCurVersion(fver)) {
        fileInfo.clearUnReadCount();
      }
    });
  },
  /**
   *   @param:
   *       fileInfos {array of MMFileInfo}
   *       fileVers {array of int} - array of versions corresponding to the file in fileInfos
   */
  clearFilesUnreadMarks: function clearFilesUnreadMarks(fileInfos, success, fail) {
    for (var i = 0; i < fileInfos.length; i++) {
      fileInfos[i].clearUnReadCount();
    }
    var fileIdsTodo = [];
    var fileVersTodo = [];
    for (var j = 0; j < fileInfos.length; j++) {
      var fileinfo = fileInfos[j];
      if (fileinfo.isFolder() || !fileinfo.isFolder() && !fileinfo.isCommitter()) {
        fileIdsTodo.push(fileinfo.getFileId());
        fileVersTodo.push(fileinfo.getCurVersion());
      }
    }
    if (fileIdsTodo.length > 0) {
      MMNetDiskDataController._clearFileUnreadMarkWithIdsAndVersions(fileIdsTodo, fileVersTodo, success, fail);
    }
  },
  /**
   *   @param fileId - can not be undefined
   *   @param fileVer - can not be undefined
   */
  _clearFileUnreadMarkWithIdAndVersion: function _clearFileUnreadMarkWithIdAndVersion(fileId, fileVer, success, fail) {
    console.log("-------- clearFileUnreadMarkWithIdAndVersion:" + fileId + "  version:" + fileVer);
    MMNetDiskDataController._clearFileUnreadMarkWithIdsAndVersions([fileId], [fileVer], success, fail);
  },
  /**
   *   @param fileIds {array of string} - can not be undefined
   *   @param fileVers  {array of int} - can not be undefined
   */
  _clearFileUnreadMarkWithIdsAndVersions: function _clearFileUnreadMarkWithIdsAndVersions(fileIds, fileVers, success, fail) {
    if (fileIds.length === 0 || fileIds.length != fileVers.length) {
      return;
    }

    // TODO - send request to the server;
    var user = _app["default"].currentUser;
    if (user.isAnonymous()) {
      return;
    }
    for (var i = 0; i < fileVers.length; i++) {
      fileVers[i] += "";
    }
    var route = "netDrive.fileHandler.setFilesRead";
    MMNetDiskDataController.request(route, {
      fids: fileIds,
      versions: fileVers
    }, function (res) {
      setBabelTimeout(function () {
        if (res["resultCode"] !== 0) {
          if (_.isFunction(fail)) fail();
        } else {
          if (_.isFunction(success)) success();
        }
      }, 0);
    });
  },
  // 获得文件访问用户的列表
  // return array of MDMolaUser
  getFileReaders: function getFileReaders(fileId, success, fail) {
    var route = "netDrive.fileHandler.getFileAccessUsers";
    MMNetDiskDataController.request(route, {
      fid: fileId + ""
    }, function (res) {
      setBabelTimeout(function () {
        if (res["resultCode"] !== 0) {
          if (_.isFunction(fail)) fail();
        } else {
          var userInfos = [];
          res["userList"].forEach(function (userInfo) {
            var user = new _MDMolaUser["default"]();
            user.set("userId", userInfo["id"]);
            user.set("name", userInfo["name"]);
            user.set("email", userInfo["email"]);
            user.set("avatartype", userInfo["avatartype"]);
            userInfos.push(user);
          });
          if (_.isFunction(success)) success(userInfos);
        }
      }, 0);
    });
  },
  /**
   * get file's unread info and comments info
   *
   * @param fileIds {array of file Id}
   * @return array of MDFileAccessInfo
   */
  getFileTagPraiseInfo: function getFileTagPraiseInfo(fileIds, success, fail) {
    _MDNetDriveFileHandler["default"].getFileTagPraiseInfo(fileIds, success, fail);
  },
  // ******************** end
  setRole: function setRole(fileId, babelshareId, roleId, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.file_setRole", {
      fileId: fileId,
      babelshareId: babelshareId,
      roleId: roleId
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"]);
      } else {
        if (_.isFunction(success)) success(!!res["result"]);
      }
    });
  },
  setParticipantExpireTime: function setParticipantExpireTime(fileId, babelshareId, endtime, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.setShareParticipantEndTime", {
      fileId: fileId,
      babelshareId: babelshareId,
      endtime: endtime
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"]);
      } else {
        if (_.isFunction(success)) success(!!res["result"]);
      }
    });
  },
  /**
   * change the share‘s default role
   */
  changeShareDefaultPermission: function changeShareDefaultPermission(fileId, roleId, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.file_setDefaultRole", {
      fileId: fileId,
      roleId: roleId
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"]);
      } else {
        if (_.isFunction(success)) success(!!res["result"]);
      }
    });
  },
  /**
   * find if there is an ancestor folder shared and
   * current user participating in the share
   * @param fileId
   * @return 1 - is manager, 0 - not a manager
   */
  canCurrentUserManageShare: function canCurrentUserManageShare(fileId, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.file_canCurrentUserManageShare", {
      fileId: fileId
    }, function (res) {
      //850 分享给外部用户需要审批
      if (res["resultCode"] == 0 || res["resultCode"] == 850) {
        if (_.isFunction(success)) success(res['canShareout'], res["managerInfos"]);
      } else {
        if (_.isFunction(fail)) fail(res['canShareout'], res["managerInfos"], res);
      }
    });
  },
  /**
   * get the current user's permission for the file
   * @param fileId {int} - the id of file
   * @return the permission
   */
  getCurUserPermissionForFile: function getCurUserPermissionForFile(fileId, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.file_getCurUserPermissionForFile", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] !== 0) {
        fail(res["resultCode"]);
      } else {
        success(res["permission"], !!res["result"]);
      }
    });
  },
  openLinkShare: function openLinkShare(fileId, linkRoleId, isHttps, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.openLinkShare", {
      fid: fileId,
      linkRoleId: linkRoleId,
      isHttps: isHttps
    }, function (res) {
      if (res["resultCode"] !== 0) {
        fail(res["resultCode"], res.message);
      } else {
        if (_app["default"].ep.isPrivateCloud()) {
          res["shareURL"] = location.origin + res["shareURL"];
        }
        success(res["shareURL"], !!res["resultCode"], res["fileInfo"]);
      }
    });
  },
  closeLinkShare: function closeLinkShare(fileId, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.closeLinkShare", {
      fid: fileId
    }, function (res) {
      if (res["resultCode"] !== 0) {
        fail(res["resultCode"]);
      } else {
        success(res["resultCode"]);
        Dispatcher.trigger(_MDEvents["default"].ShareChanged, fileId);
      }
    });
  },
  isLinkOpenClosed: function isLinkOpenClosed(newShareAll, fileId, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.isLinkOpenClosed", {
      newShareAll: newShareAll,
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] !== 0) {
        fail(res["resultCode"]);
      } else {
        success(res["linkOpen"]);
      }
    });
  },
  isLinkParticipant: function isLinkParticipant(fileId, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.isLinkParticipant", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] !== 0) {
        fail(res["resultCode"]);
      } else {
        success(res["isLinkParticipant"]);
      }
    });
  },
  closeInvShare: function closeInvShare(fileId, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.cancelShare", {
      fid: fileId
    }, function (res) {
      if (res["resultCode"] !== 0) {
        fail(res["resultCode"]);
      } else {
        if (_.isFunction(success)) success();
        Dispatcher.trigger(_MDEvents["default"].ShareChanged, fileId);
      }
    });
  },
  modifyLinkShareRole: function modifyLinkShareRole(fileId, linkRoleId, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.modifyLinkShareRole", {
      fid: fileId,
      linkRoleId: linkRoleId
    }, function (res) {
      if (res["resultCode"] !== 0) {
        fail(res["resultCode"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  manipulateReshare: function manipulateReshare(fileId, option, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.manipulateReshare", {
      fileId: fileId,
      option: option
    }, function (res) {
      if (res["resultCode"] !== 0) {
        fail(res["resultCode"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  requestForLinkShare: function requestForLinkShare(fileId, linkRoleId, message, approvers, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.requestForLinkShare", {
      fileId: fileId,
      linkRoleId: linkRoleId,
      approvers: approvers,
      message: message
    }, function (res) {
      if (res["resultCode"] !== 0) {
        fail(res["resultCode"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  answerRequestForLinkShare: function answerRequestForLinkShare(requestShareId, option, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.answerRequestForLinkShare", {
      requestShareId: requestShareId,
      option: option
    }, function (res) {
      if (res["resultCode"] !== 0) {
        fail(res["resultCode"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  // answerRequestForLin: function(shareId, option, success, fail) {
  //   MMNetDiskDataController.request("netDrive.fileHandler.answerRequestForLin", {
  //     'requestShareId': shareId,
  //     'option': option
  //   }, function(res) {
  //     if (res["resultCode"] !== 0) {
  //       fail(res["resultCode"]);
  //     } else {
  //       _.isFunction(success) && success();
  //     }
  //   });
  // },

  requestForInviteShare: function requestForInviteShare(fileId, roleId, targetEmails, targetPhones, targetGroupIds, targetDepIds, message, approvers, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.requestForInviteShare", {
      fileId: fileId,
      roleId: roleId,
      targetEmails: targetEmails,
      targetPhones: targetPhones,
      targetGroupIds: targetGroupIds,
      targetDepIds: targetDepIds,
      message: message,
      approvers: approvers
    }, function (res) {
      if (res["resultCode"] !== 0) {
        fail(res["resultCode"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  answerRequestForInviteShare: function answerRequestForInviteShare(shareId, option, acceptedEmails, targetPhones, roleId, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.answerRequestForInviteShare", {
      requestShareId: shareId,
      option: option,
      acceptedEmails: acceptedEmails,
      roleId: roleId,
      targetPhones: targetPhones
    }, function (res) {
      if (res["resultCode"] !== 0) {
        fail(res["resultCode"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  getLinkShareParticipant: function getLinkShareParticipant(fileId, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.getLinkShareParticipant", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] !== 0) {
        fail(res["resultCode"]);
      } else {
        var anonymouseCount = res["anonymouseCount"];
        var contactList = res["usersInfo"] || [];
        var collection = new _MDShareParticipantCollection["default"]();
        collection.add(contactList);
        if (_.isFunction(success)) success({
          anonymouseCount: anonymouseCount,
          collection: collection
        });
      }
    });
  },
  getLinkShareUsers: function getLinkShareUsers(fileId, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.getLinkShareParticipant", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] !== 0) {
        fail(res["resultCode"]);
      } else {
        var anonymouseCount = res["anonymouseCount"];
        var contactList = res["usersInfo"] || [];
        var collection = new _MDMolaUserCollection["default"](contactList);
        collection.add(contactList);
        if (_.isFunction(success)) success(collection);
      }
    });
  },
  setAnonymousVisit: function setAnonymousVisit(fileId, option, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.setAnonymousVisit", {
      fileId: fileId,
      option: option
    }, function (res) {
      if (res["resultCode"] !== 0) {
        fail(res["resultCode"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  /**
   *   get all the user level
   *   return {MDUserLevelCollection}
   */
  getAllUserLevels: function getAllUserLevels(success, fail) {},
  getAllPaidOrders: function getAllPaidOrders(success, fail) {},
  setCurrentUsersReceivedEmailFlag: function setCurrentUsersReceivedEmailFlag(flag, success, fail) {
    MMNetDiskDataController.request("netDrive.userHandler.setMyReceiveEmailFlag", {
      receiveEmailFlag: flag
    }, function (res) {
      if (res["resultCode"] !== 0) {
        fail(res["resultCode"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  //
  //------------------------------- dashboard message -----------------------------
  //
  listDashboardMessage: function listDashboardMessage(option, success, fail) {
    option = _.extend({
      atMe: 0,
      forFile: 0,
      forComment: 0,
      fileId: null,
      limit: 20,
      lastKnownMessageId: "",
      isArchive: _app["default"].ep.isArchive() ? 1 : 0
    }, option);
    MMNetDiskDataController.request("netDrive.dashboardHandler.listDashboard", {
      forComment: option.forComment,
      forFile: option.forFile,
      lastKnownMessageId: option.lastKnownMessageId,
      limit: option.limit,
      atMe: option.atMe,
      fileId: option.fileId,
      searchKeys: option.searchKeys,
      isArchive: option.isArchive
    }, function (res) {
      if (res["resultCode"] !== 0) {
        fail(res["resultCode"]);
      } else {
        var messageList = res["dashboardMessages"];
        success(messageList);
      }
    });
  },
  praiseDashboardMessage: function praiseDashboardMessage(options, success, fail) {
    if (!options.messageId) {
      throw new Error("missing messageId");
    }
    MMNetDiskDataController.request("netDrive.dashboardHandler.praiseDashboardMessage", {
      messageId: options.messageId,
      praise: options.praise ? 1 : 0
    }, function (res) {
      if (res["resultCode"] !== 0) {
        fail(res["resultCode"]);
      } else {
        var messageList = res["dashboardMessages"];
        success(messageList);
      }
    });
  },
  touchDashboard: function touchDashboard(success, fail) {
    MMNetDiskDataController.request("netDrive.dashboardHandler.touchDashboard", {}, function (res) {
      if (res["resultCode"] === 0) {
        _.isFunction(success) && success();
      } else {
        fail(res["resultCode"], res);
      }
    });
  },
  getUnreadMessageCount: function getUnreadMessageCount(success, fail) {
    MMNetDiskDataController.request("netDrive.dashboardHandler.getUnreadMessageCount", {
      isArchive: _app["default"].ep.isArchive() ? 1 : 0
    }, function (res) {
      if (res["resultCode"] === 0) {
        _.isFunction(success) && success(res["count"]);
      } else {
        fail(res["resultCode"], res);
      }
    });
  },
  getRoles: function getRoles(fid, success, fail) {
    MMNetDiskDataController.request("netDrive.shareHandler.getRolesForFile", {
      fileId: fid
    }, function (res) {
      if (res["resultCode"] === 0) {
        var lan = BabelStr.getCurrentLanguage();
        if (lan == "en") {
          _.each(res["list"], function (item) {
            item.description = item.descriptionEN;
            item.name = item.nameEN;
          });
          res.defaultRole.description = res.defaultRole.descriptionEN;
        }
        var out = new _MDRoleInfoCollection["default"]();
        if (res["list"]) {
          out.add(res["list"]);
        }
        var defaultRoleId = res["defaultRole"] && res["defaultRole"]["id"];
        success(out, defaultRoleId);
      } else {
        fail(res["resultCode"], res);
      }
    });
  },
  getAllRoles: function getAllRoles(success, fail) {
    MMNetDiskDataController.request("netDrive.shareHandler.getRoles", {}, function (res) {
      console.log("----------> call netDrive.shareHandler.getRoles successfully!");
      if (res["resultCode"] === 0) {
        var out = new _MDRoleInfoCollection["default"]();
        _.each(res["list"], function (item) {
          item.filePermission = item.permission;
        });
        if (res["list"]) {
          var lan = BabelStr.getCurrentLanguage();
          if (lan == "en") {
            _.each(res["list"], function (item) {
              item.description = item.descriptionEN;
              item.name = item.nameEN;
            });
            res.defaultRole.description = res.defaultRole.descriptionEN;
          }
          out.add(res["list"]);
        }
        var defaultRoleId = res["defaultRole"]["id"];
        success(out, defaultRoleId, res["permissions"], []);
      } else {
        fail(res["resultCode"], res);
      }
    });
  },
  getAllRolesByEpId: function getAllRolesByEpId(enterpriseId, success, fail) {
    MMNetDiskDataController.request("netDrive.shareHandler.getRoles", {
      enterpriseId: enterpriseId
    }, function (res) {
      console.log("----------> call netDrive.shareHandler.getRoles successfully!");
      if (res["resultCode"] === 0) {
        var out = new _MDRoleInfoCollection["default"]();
        _.each(res["list"], function (item) {
          item.filePermission = item.permission;
        });
        var lan = BabelStr.getCurrentLanguage();
        if (lan == "en") {
          _.each(res["list"], function (item) {
            item.description = item.descriptionEN;
            item.name = item.nameEN;
          });
          res.defaultRole.description = res.defaultRole.descriptionEN;
        }
        if (res["list"]) {
          out.add(res["list"]);
        }
        var defaultRoleId = res["defaultRole"]["id"];
        success(out, defaultRoleId, res["permissions"], []);
      } else {
        fail(res["resultCode"], res);
      }
    });
  },
  getAtTargetUserList: function getAtTargetUserList(fileId, success, fail) {
    console.assert(typeof fileId === "string");
    MMNetDiskDataController.request("netDrive.fileHandler.getAtTargetUserList", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        var userInfos = res["userInfos"];
        if (userInfos) {
          userInfos = userInfos.map(function (user) {
            var email = user["email"];
            email = _regexp["default"].isEmail(email) ? email : " ";
            return {
              id: user["id"],
              name: user["name"],
              email: email,
              sex: user["sex"],
              phone: user["phone"]
            };
          });
          userInfos = _.filter(userInfos, function (user) {
            return user["id"] != _app["default"].currentUser.getUserId();
          });
          success(userInfos);
        } else {
          success([]);
        }
      } else {
        fail(res["resultCode"], res);
      }
    });
  },
  praiseFile: function praiseFile(fileIds, success, fail) {
    console.assert(Array.isArray(fileIds), "fileIds is an array");
    fileIds.forEach(function (id) {
      console.assert(typeof id === "string", "each id need to be a string");
    });
    MMNetDiskDataController.request("netDrive.fileHandler.praiseFile", {
      fileIds: fileIds,
      praise: 1
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  unPraiseFile: function unPraiseFile(fileIds, success, fail) {
    console.assert(Array.isArray(fileIds), "fileIds is an array");
    fileIds.forEach(function (id) {
      console.assert(typeof id === "string", "each id need to be a string");
    });
    MMNetDiskDataController.request("netDrive.fileHandler.praiseFile", {
      fileIds: fileIds,
      praise: 0
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  getFileNumInFolder2: function getFileNumInFolder2(folderId, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.getFileNumInFolder", {
      folderId: folderId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["fileCount"], res["fileSize"], res["folderCount"]);
        _MMFileInfo["default"].saveCachedFolderSize(folderId, res["fileSize"], res["fileCount"], res["folderCount"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  getFileNumInFolder: function getFileNumInFolder(folderId, success, fail) {
    var sizeInfo = _MMFileInfo["default"].getCachedFolderSizeInfo(folderId);
    if (sizeInfo) {
      success(sizeInfo.fileCount, sizeInfo.size, sizeInfo.folderCount);
    } else {
      MMNetDiskDataController.request("netDrive.fileHandler.getFileNumInFolder", {
        folderId: folderId
      }, function (res) {
        if (res["resultCode"] === 0) {
          success(res["fileCount"], res["fileSize"], res["folderCount"]);
          _MMFileInfo["default"].saveCachedFolderSize(folderId, res["fileSize"], res["fileCount"], res["folderCount"]);
        } else {
          fail(res["resultCode"]);
        }
      });
    }
  },
  getArchiveFileNumInFolder: function getArchiveFileNumInFolder(folderId, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.getArchiveFileNumInFolder", {
      folderId: folderId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["fileCount"], res["fileSize"], res["folderCount"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  /**
   * focus file
   */
  focusFile: function focusFile(fileId, userIds, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.focusFile", {
      fileId: fileId,
      userIds: userIds
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  removeFileFocus: function removeFileFocus(fileId, userIds, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.removeFileFocus", {
      fileId: fileId,
      userIds: userIds
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail([res["resultCode"]]);
      }
    });
  },
  getMyFocusFiles: function getMyFocusFiles(success, fail, readInfoSuccess) {
    MMNetDiskDataController.request("netDrive.fileHandler.getMyFocusFiles", {}, function (res) {
      setBabelTimeout(function () {
        if (res["resultCode"] === 0) {
          var out = new _MMFileInfoCollection["default"](); //[];
          if (!res["list"]) {
            success(out);
            return;
          }
          res["list"].forEach(function (fileInfo) {
            var f = new _MMFileInfo["default"](fileInfo);
            f.setIsFocusFile(true);
            out.push(f);
          });
          success(out);
          var param = {
            channelroot: _MDConstant["default"].ChannelRoot.MyFocus
          };
          MMNetDiskDataController.get2ndFileInfo(out.models, param, readInfoSuccess);
        } else {
          fail(res["resultCode"]);
        }
      }, 0);
    });
  },
  getUsersCanFocusFile: function getUsersCanFocusFile(fileId, noNeedDepInfo, fileOrganizationInfo, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.getUsersCanFocusFile", {
      fileId: fileId,
      noNeedDep: noNeedDepInfo,
      fileOrganizationInfo: fileOrganizationInfo
    }, function (res) {
      if (res["resultCode"] === 0) {
        var out = new _MDMolaUserCollection["default"]();
        var curUserId = _app["default"].currentUser.getUserId();
        if (res["users"]) {
          res["users"].forEach(function (userInfo) {
            if (userInfo["id"] == curUserId) {
              out.unshift(new _MDMolaUser["default"](userInfo));
            } else {
              out.push(new _MDMolaUser["default"](userInfo));
            }
          });
        }
        success(out);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  getFileFocusUsers: function getFileFocusUsers(fileId, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.getFileFocusUsers", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        var out = new _MDMolaUserCollection["default"]();
        var curUserId = _app["default"].currentUser.getUserId();
        if (res["users"]) {
          res["users"].forEach(function (userInfo) {
            out.push(new _MDMolaUser["default"](userInfo));
          });
        }
        success(out);
      } else {
        fail([res["resultCode"]]);
      }
    });
  },
  sendFileReview: function sendFileReview(fileId, content, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.sendFileReview", {
      fileId: fileId,
      text: content
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  /**
   * @param {string} fileId
   * @param {string} [startId] - id of review, works like getMessage, can be null
   */
  getFileReviews: function getFileReviews(fileId, startId, pageSize, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.getFileReviews", {
      fileId: fileId,
      startId: startId,
      pageSize: pageSize
    }, function (res) {
      if (res["resultCode"] === 0) {
        var out = new Backbone.Collection();
        if (!res["reviews"]) {
          success(out);
          return;
        }
        res["reviews"].forEach(function (commentInfo) {
          out.push(new Backbone.Model(commentInfo));
        });
        success(out);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  deleteTransferFile: function deleteTransferFile(fileRefId, success, fail) {
    $.post("/netdrive/deleteTransferFile.do?fileRefId=" + fileRefId, function (res) {
      if (res["success"] === true) {
        success(res["url"]);
      } else {
        fail(res["msg"]);
      }
    });
  },
  getFileLogByFileIdForBabelManager: function getFileLogByFileIdForBabelManager(fileId, startIndex, pageSize, type, userName, success, fail) {
    MMNetDiskDataController.request("netDrive.adminHandler.getFileLogByFileIdForBabelManager", {
      fileId: fileId,
      startIndex: startIndex,
      pageSize: pageSize,
      userName: userName,
      type: type
    }, function (res) {
      if (res["resultCode"] === 0) {
        var out = new _MDFileLogCollection["default"](res["logs"]);
        if (res["creationInfo"]) {
          var cInfo = res["creationInfo"];
          var log = new _MDFileLog["default"]({
            userId: cInfo.id,
            userName: cInfo.name,
            time: new Date(cInfo.ctime)
          });
          log.setFileCreationInfo(res["creationInfo"]);
          out.push(log);
        }
        success(out, res["total"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  /**
   * file logs
   */
  getLogsForFile: function getLogsForFile(fileId, startIndex, pageSize, type, userName, success, fail) {
    _czc && _czc.push(["_trackEvent", "报表", "查看文件日志", "", "", ""]);
    if (fileId == 0) {
      MMNetDiskDataController.request("netDrive.fileHandler.getUserHomeDirLog", {
        startIndex: startIndex,
        pageSize: pageSize,
        userName: userName,
        type: type
      }, function (res) {
        if (res["resultCode"] === 0) {
          var out = new _MDFileLogCollection["default"]();
          if (res["logs"]) {
            res["logs"].forEach(function (log) {
              out.push(new _MDFileLog["default"](log));
            });
          }
          success(out, res["total"]);
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    } else {
      MMNetDiskDataController.request("netDrive.fileHandler.getLogsForFile", {
        fileId: fileId,
        startIndex: startIndex,
        pageSize: pageSize,
        userName: userName,
        type: type
      }, function (res) {
        if (res["resultCode"] === 0) {
          var out = new _MDFileLogCollection["default"](res["logs"]);
          if (res["creationInfo"]) {
            var cInfo = res["creationInfo"];
            var log = new _MDFileLog["default"]({
              userId: cInfo.id,
              userName: cInfo.name,
              time: new Date(cInfo.ctime)
            });
            log.setFileCreationInfo(res["creationInfo"]);
            out.push(log);
          }
          success(out, res["total"]);
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    }
  },
  getUserFileLogInShare: function getUserFileLogInShare(userId, fileId, startIndex, pageSize, type, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.getUserFileLogInShare", {
      fileId: fileId,
      userId: userId,
      startIndex: startIndex,
      pageSize: pageSize,
      type: type
    }, function (res) {
      if (res["resultCode"] === 0) {
        var out = new _MDFileLogCollection["default"]();
        if (res["logs"]) {
          res["logs"].forEach(function (log) {
            out.push(new _MDFileLog["default"](log));
          });
        }
        success(out, res["total"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  getUserFileLogInAllMyShare: function getUserFileLogInAllMyShare(userId, sessionId, startIndex, pageSize, type, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.getUserFileLogInAllMyShare", {
      userId: userId,
      sessionId: sessionId,
      startIndex: startIndex,
      pageSize: pageSize,
      type: type
    }, function (res) {
      if (res["resultCode"] === 0) {
        var out = new _MDFileLogCollection["default"]();
        if (res["logs"]) {
          res["logs"].forEach(function (log) {
            out.push(new _MDFileLog["default"](log));
          });
        }
        success(out, res["total"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  /* @param {number} expireTime - 单位秒
   */
  setLinkShareExpireTime: function setLinkShareExpireTime(fileId, expireTime, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.setLinkShareExpireTime", {
      fileId: fileId,
      expireTime: expireTime
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        if (fail) {
          fail();
        }
      }
    });
  },
  setDefaultExpireTime: function setDefaultExpireTime(fileId, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.setDefaultExpireTime", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["expireTime"] * 1000);
      } else {
        if (fail) {
          fail();
        }
      }
    });
  },
  setFileVersionLog: function setFileVersionLog(fileId, version, logStr, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.setFileVersionLog", {
      fileId: fileId,
      version: version,
      versionLog: logStr
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  /**
   * @param {[][]} evaluatorGroups - array of userId array
  fileId,steps,name,finalizedStep,forEnterprise,comment,endTime,tmplId
   */

  createEvaluationFlow: function createEvaluationFlow(options, success, fail) {
    MMNetDiskDataController.request("netDrive.evaluationHandler.createEvaluationFlow", {
      fileId: options.fileIds,
      steps: options.steps,
      name: options.name,
      finalizedStep: options.finalizedStep,
      forEnterprise: options.forEnterprise,
      comment: options.comment,
      endTime: options.endTime,
      tmplId: options.tmplId,
      flowType: options.flowType
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["actions"], res["flowId"], res["evaluationStatus"]);
      } else {
        fail(res["resultCode"], res["step"]);
      }
    });
  },
  updateEvaluationFlow: function updateEvaluationFlow(flowId, name, comment, evaluatorGroups, success, fail) {
    MMNetDiskDataController.request("netDrive.evaluationHandler.updateEvaluationFlow", {
      flowId: flowId,
      name: name,
      comment: comment,
      evaluatorGroups: evaluatorGroups
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  updateEvaluationFlowTime: function updateEvaluationFlowTime(flowId, endtime, success, fail) {
    MMNetDiskDataController.request("netDrive.evaluationHandler.updateEvaluationFlow", {
      flowId: flowId,
      endTime: endtime
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  /**
   * 用户审批文件
   * @param {FILE_EVALUATION_STATUS} evaluation
   */
  createEvaluation: function createEvaluation(evaluationFlowId, fileId, evaluation, commentStr, success, fail) {
    MMNetDiskDataController.request("netDrive.evaluationHandler.createEvaluation", {
      fileId: fileId,
      evaluationFlowId: evaluationFlowId,
      evaluation: evaluation,
      commentStr: commentStr
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["fileEvaluationId"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  createMultiFileEvaluation: function createMultiFileEvaluation(evaluationFlowId, evaluation, commentStr, success, fail) {
    MMNetDiskDataController.request("netDrive.evaluationHandler.createMultiFileEvaluation", {
      evaluationFlowId: evaluationFlowId,
      evaluation: evaluation,
      commentStr: commentStr
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["fileEvaluationId"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  /**
   * 文件重启审批，必须当文件一个版本审批被驳回，然后上传新版本后才可重启
   */
  restartEvaluation: function restartEvaluation(fileId, success, fail) {
    MMNetDiskDataController.request("netDrive.evaluationHandler.restartEvaluation", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  restartMultFileEvaluation: function restartMultFileEvaluation(flowId, success, fail) {
    MMNetDiskDataController.request("netDrive.evaluationHandler.restartMultFileEvaluation", {
      flowId: flowId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  setEvaluationToUnstart: function setEvaluationToUnstart(fileId, success, fail) {
    MMNetDiskDataController.request("netDrive.evaluationHandler.setEvaluationToUnstart", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  updateEvaluation: function updateEvaluation(fileEvaluationId, evaluation, commentStr, success, fail) {
    MMNetDiskDataController.request("netDrive.evaluationHandler.updateEvaluation", {
      fileEvaluationId: fileEvaluationId,
      evaluation: evaluation,
      commentStr: commentStr
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  updateMultEvaluation: function updateMultEvaluation(fileEvaluationId, evaluation, commentStr, success, fail) {
    MMNetDiskDataController.request("netDrive.evaluationHandler.updateMultEvaluation", {
      fileEvaluationId: fileEvaluationId,
      evaluation: evaluation,
      commentStr: commentStr
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  passTheFileEvaluation: function passTheFileEvaluation(fileId, success, fail) {
    MMNetDiskDataController.request("netDrive.evaluationHandler.setFileEvaluationStatus", {
      fileId: fileId,
      evaluationStatus: _MDEvaluationStatus["default"].PASSED
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["actions"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  rejectTheFileEvaluation: function rejectTheFileEvaluation(fileId, success, fail) {
    MMNetDiskDataController.request("netDrive.evaluationHandler.setFileEvaluationStatus", {
      fileId: fileId,
      evaluationStatus: _MDEvaluationStatus["default"].REJECTED
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  getEvaluatorsGroup: function getEvaluatorsGroup(fileId, version, flowId, success, fail) {
    MMNetDiskDataController.request("netDrive.evaluationHandler.getEvaluatorsGroup", {
      fileId: fileId,
      version: version
    }, function (res) {
      if (res["resultCode"] === 0) {
        // var result = new MDEvaluationFlowInfo(res['evaluationFlow']);
        // var groups = [];
        // var copyGroups = [];
        // _.each(result.getEvaluationGroups() , (evaluationGroup)=>{
        //   var group = [];
        //   _.each(evaluationGroup , (evaluation)=>{
        //     var eva = new MDEvaluationInfo();
        //     eva.initData(evaluation);
        //     group.push(eva);
        //   })
        //   groups.push(group);
        // })
        // result.setEvaluationGroups(groups);
        // _.each(result.getCopyToGroups() , (evaluationGroup)=>{
        //   var group = [];
        //   _.each(evaluationGroup , (evaluation)=>{
        //     var eva = new MDEvaluationInfo();
        //     eva.initData(evaluation);
        //     group.push(eva);
        //   })
        //   copyGroups.push(group);
        // })
        // result.setEvaluationGroups(groups);
        // result.setCopyToGroups(copyGroups);
        // result.setCurStep(res['evaluationFlow'].curStep);

        if (res.multFile) {
          MMNetDiskDataController.getMultEvaluatorGroup(flowId, -1, function (result) {
            success(result);
          }, function (code) {
            fail(code);
          });
        } else {
          var result = _MDEvaluationFlowInfo["default"].createObjWith(res["evaluationFlow"]);
          success(result);
        }
      } else {
        fail(res["resultCode"]);
        console.log("getEvaluationGroups fail" + res);
      }
    });
  },
  getMultEvaluatorGroup: function getMultEvaluatorGroup(flowId, time, success, fail) {
    MMNetDiskDataController.request("netDrive.evaluationHandler.getMultEvaluatorGroup", {
      flowId: flowId,
      times: time
    }, function (res) {
      if (res["resultCode"] === 0) {
        var result = _MDEvaluationFlowInfo["default"].createObjWith(res["evaluationFlow"]);
        console.warn(result);
        success(result);
      } else {
        fail(res["resultCode"]);
        console.log("getEvaluationGroups fail" + res);
      }
    });
  },
  getFileAllEvaluatorsGroup: function getFileAllEvaluatorsGroup(fileId, success, fail) {
    MMNetDiskDataController.request("netDrive.evaluationHandler.getFileAllEvaluatorsGroup", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        var result = _MDEvaluationFlowInfo["default"].createObjWith(res["evaluationFlow"]);
        success(result);
      } else {
        fail(res["resultCode"]);
        console.log("getEvaluationGroups fail" + res);
      }
    });
  },
  /**
   * 重置审批
   */
  deleteEvaluationRecordForFile: function deleteEvaluationRecordForFile(fileId, success, fail) {
    MMNetDiskDataController.request("netDrive.evaluationHandler.deleteEvaluationRecordForFile", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  cleanFileEvaluationStatus: function cleanFileEvaluationStatus(fileId, success, fail) {
    MMNetDiskDataController.request("netDrive.evaluationHandler.cleanFileEvaluationStatus", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  cleanFlowEvaluationStatus: function cleanFlowEvaluationStatus(flowId, success, fail) {
    MMNetDiskDataController.request("netDrive.evaluationHandler.cleanFlowEvaluationStatus", {
      flowId: flowId + ""
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  /**
   * 获取我待审批的文件
   */
  getEvaluatingFile: function getEvaluatingFile(type, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.getEvaluatingFiles", {
      type: type
    }, function (res) {
      setBabelTimeout(function () {
        if (res["resultCode"] === 0) {
          var out = new _MMFileInfoCollection["default"](); //[];
          if (!res["fileArr"]) {
            success(out);
            return;
          }
          var flowsIds = _.pluck(res["flows"], "id");
          res["fileArr"].forEach(function (fileInfo) {
            if (_.indexOf(flowsIds, fileInfo.evaluationFlowId) < 0) {
              out.push(new _MMFileInfo["default"](fileInfo));
            }
          });
          res["flows"].forEach(function (item) {
            out.push(new _MMFileInfo["default"].createMultFIleEvalFolder(item));
          });
          success(out);
          var param = {
            channelroot: _MDConstant["default"].ChannelRoot.Evaluating
          };
          MMNetDiskDataController.get2ndFileInfo(out.models, param);
        } else {
          fail(res["resultCode"]);
        }
      }, 0);
    });
  },
  hasEvaluatingFile: function hasEvaluatingFile(success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.getEvaluatingFiles", {
      type: 1
    }, function (res) {
      if (res["resultCode"] === 0) {
        if (res["fileArr"] && res["fileArr"].length) {
          success(true);
        } else {
          success(false);
        }
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  addPersonToEvaluation: function addPersonToEvaluation(fileId, step, userIds, emails, phones, success, fail) {
    MMNetDiskDataController.request("netDrive.evaluationHandler.addEvaluatorToFile", {
      fileId: fileId,
      step: step,
      userIds: userIds,
      emails: emails,
      phones: phones
    }, function (res) {
      setBabelTimeout(function () {
        if (res["resultCode"] === 0) {
          if (!res["evalFlow"]) {
            var out = new _MDEvaluationFlowInfo["default"](res["evalFlow"]); //[];
            success(out);
          } else {
            success(null);
          }
        } else {
          fail(res["resultCode"]);
        }
      }, 0);
    });
  },
  skip2EvalFlowStep: function skip2EvalFlowStep(fileId, success, fail) {
    MMNetDiskDataController.request("netDrive.evaluationHandler.skipFileCurrentStep", {
      fileId: fileId
    }, function (res) {
      setBabelTimeout(function () {
        if (res["resultCode"] === 0) {
          success();
        } else {
          fail(res["resultCode"]);
        }
      }, 0);
    });
  },
  getAccessUserInAllMyShare: function getAccessUserInAllMyShare(success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.getAccessUsersInAllMyShare", {}, function (res) {
      if (res["resultCode"] === 0) {
        var userCollection = new _MDMolaUserCollection["default"](res["users"]);
        success(userCollection, res["anonymouse"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  getShareCountInDepartment: function getShareCountInDepartment(departmentId, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.getShareCountInDepartment", {
      departmentId: departmentId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["fileCount"], res["shareCount"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  getAllMyShareUserJoin: function getAllMyShareUserJoin(userId, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.getAllMyShareUserJoin", {
      userId: userId
    }, function (res) {
      if (res["resultCode"] === 0) {
        var out = new _MMFileInfoCollection["default"](); //[];
        if (!res["list"]) {
          success(out);
          return;
        }
        res["list"].forEach(function (fileInfo) {
          out.push(new _MMFileInfo["default"](fileInfo));
        });
        success(out);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  setSendAccessInfoToLinkedIn: function setSendAccessInfoToLinkedIn(fileId, value, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.setSendAccessInfoToLinkedIn", {
      fileId: fileId,
      value: value
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  updateFileCommentStr: function updateFileCommentStr(fileId, commentStr, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.updateFileCommentStr", {
      fileId: fileId,
      commentStr: commentStr
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  lockFile: function lockFile(fileId, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.lockFile", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["lockUser"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  unlockFile: function unlockFile(fileId, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.unLockFile", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  /**
   * file permission
   */
  getSpecialFilePermission: function getSpecialFilePermission(fileId, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.getSpecialFilePermission", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["users"], res["roles"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  createGroup: function createGroup(groupName, belongToEnterprise, success, fail) {
    MMNetDiskDataController.request("netDrive.shareHandler.createGroup", {
      groupName: groupName,
      belongToEnterprise: belongToEnterprise
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["groupId"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  deleteGroup: function deleteGroup(groupId, success, fail) {
    MMNetDiskDataController.request("netDrive.shareHandler.deleteGroup", {
      groupId: groupId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  addGroupMember: function addGroupMember(groupId, userIds, success, fail) {
    MMNetDiskDataController.request("netDrive.shareHandler.addGroupMember", {
      groupId: groupId,
      userIds: userIds
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  removeUserFromGroup: function removeUserFromGroup(groupId, userIds, success, fail) {
    MMNetDiskDataController.request("netDrive.shareHandler.removeUsersFromGroup", {
      groupId: groupId,
      userIds: userIds
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  setFileHiddenToUsers: function setFileHiddenToUsers(fileId, userIds, depRoleIds, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.setFileHiddenToUsers", {
      fileId: fileId,
      userIds: userIds,
      depRoleIds: depRoleIds
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  setFileReadOnlyToUsers: function setFileReadOnlyToUsers(fileId, userIds, depRoleIds, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.setFileReadOnlyToUsers", {
      fileId: fileId,
      userIds: userIds,
      depRoleIds: depRoleIds
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  //设置分享文件的水印开关   flag   0: 关 ，1：开
  setShareWatermark: function setShareWatermark(fileId, flag, success, fail) {
    MMNetDiskDataController.request("netDrive.shareHandler.setShareWatermark", {
      fileId: fileId,
      flag: flag
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  createLinkForFile: function createLinkForFile(destDir, fileId, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.createLinkForFile", {
      fileId: fileId,
      destDir: destDir
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  createLinkForFiles: function createLinkForFiles(destDir, fileIds, success, fail) {
    MMNetDiskDataController.request("netDrive.fileHandler.createLinkForFiles", {
      fileIds: fileIds,
      destDir: destDir
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["fileInfos"]);
      } else {
        fail(res);
      }
    });
  },
  initMaterialLibrary: function initMaterialLibrary(fail) {
    return new Promise(function (resolve, reject) {
      if (!_app["default"].isEpVersion() || !window.ep.enableMaterial) {
        resolve();
        return;
      }
      $.ajax({
        method: "post",
        url: "/enterprise/getMaterialLibrary.do",
        data: {},
        success: function success(responseData, textStatus, jqXHR) {
          console.dir(responseData);
          if (responseData["success"] === true) {
            window.materialLibrary = responseData.materialLibrary;
            if (window.materialLibrary && window.materialLibrary.fileId) {
              window.materialLibrary.fileId = window.materialLibrary.fileId.toString();
            }
          } else {
            _.isFunction(fail) && fail(responseData);
          }
          resolve();
        }
      });
    });
  },
  initSystemSetting: function initSystemSetting(success, fail) {
    var getDefaultSortIndexPromise = new Promise(function (resolve, reject) {
      MMNetDiskDataController.request("netDrive.fileExHandler.getDefaultSortIndex", {}, function (res) {
        if (res["resultCode"] === 0) {
          var defaultSortIndex = res["defaultSortIndex"] || "fileName";
          window.app.currentUser.defaultSortIndex = defaultSortIndex;
          _app["default"] && _app["default"].currentUser.set("defaultSortIndex", defaultSortIndex);
          resolve();
        } else {
          // reject()
          resolve(); // 初始设置，忽略请求失败，防止某一个请求失败，Promise.all 直接走catch
        }
      });
    });
    var getMaterialLibraryPromise = this.initMaterialLibrary(fail);

    // Java 侧未配置 Formbricks 时,不显示问卷相关的新建入口;
    // 放在 Promise.all 里保证主界面渲染前 window.canUseFormbricks 已就绪
    var canUseFormbricksPromise = new Promise(function (resolve, reject) {
      $.ajax({
        method: "post",
        url: "/netdrive/canUseFormbricks.do",
        success: function success(responseData) {
          if (responseData["code"] === 0) {
            window.canUseFormbricks = true;
          }
          resolve();
        },
        error: function error() {
          resolve(); // 请求失败视为不可用,但不阻塞其余初始设置
        }
      });
    });
    var getCurUserLibraryPromise = new Promise(function (resolve, reject) {
      // resolve()
      _MMEnterpriseController["default"].isUserCanAccessMaterialLibrary(_app["default"].currentUser.getUserId(), function (canAccessMaterialLibrary) {
        _app["default"].currentUser.setCanAccessMaterialLibrary(canAccessMaterialLibrary);
        resolve();
      }, function () {
        resolve();
      });
    });
    var getCloseRecmmend = new Promise(function (resolve, reject) {
      MMNetDiskDataController.request("netDrive.fileExHandler.getCloseRecmmend", {}, function (res) {
        _app["default"].currentUser.setHideRecommendView(res.close);
        resolve();
      }, function name(params) {
        console.error(params);
        resolve();
      });
    });
    var getUserOptionsAsEntMember = new Promise(function (resolve, reject) {
      if (!_app["default"].isEpVersion()) {
        resolve();
      }
      _MMEnterpriseController["default"].getUserOptionsAsEntMember(_app["default"].currentUser.getUserId(), function (memberOptions) {
        _app["default"].currentUser.set("memberOptions", memberOptions);
        resolve();
        // this.updateAITokenSwitch()
      }, function () {
        resolve();
      });
    });
    var getCloseDirectOpenDep = new Promise(function (resolve, reject) {
      MMNetDiskDataController.request("netDrive.fileExHandler.getCloseDirectOpenDep", {}, function (res) {
        _app["default"].currentUser.setCloseDirectOpenDep(res.close);
        resolve();
      }, function name(params) {
        console.error(params);
        resolve();
      });
    });
    Promise.all([getDefaultSortIndexPromise, getMaterialLibraryPromise, getCurUserLibraryPromise, getCloseRecmmend, getCloseDirectOpenDep, getUserOptionsAsEntMember, canUseFormbricksPromise]) // 存放需要在页面加载前发送的请求
    .then(function () {
      _.isFunction(success) && success();
    });

    /*********** 可以滞后返回的初始值 *************/
    $.ajax('/netdrive/getConvertPdfExt.do', {
      method: 'post',
      data: {},
      success: function success(responseData) {
        if (responseData["success"] === true) {
          window.convertPdfExts = responseData.exts;
        }
        console.log(responseData);
      },
      error: function error() {
        console.error("---- error call ajax");
      }
    });
    MMNetDiskDataController.request("netDrive.shareHandler.isEnterpriseHasSecretDepartments", {}, function (res) {
      if (res["resultCode"] === 0) {
        window.app.currentUser.hasSecret = res["hasSecret"];
        _app["default"] && _app["default"].currentUser.set("hasSecret", res["hasSecret"]);
        // resolve()
      } else {
        // resolve()
      }
    });
    MMNetDiskDataController.request("netDrive.dispatchFileHandler.getUserSendPort", {}, function (res) {
      if (res["resultCode"] === 0) {
        window.portInfos = res["portInfos"];
      } else {
        // resolve()
      }
    });
    MMNetDiskDataController.request("netDrive.enterpriseHandler.isOpenPersonalShare", {}, function (res) {
      if (res["resultCode"] === 0) {
        window.app.currentUser.isOpenPersonalShare = res["isOpen"];
        _app["default"] && _app["default"].currentUser.set("isOpenPersonalShare", res["isOpen"]);
        // resolve()
      } else {
        // resolve()
      }
    });
    MMNetDiskDataController.request("netDrive.enterpriseHandler.isShowingStructor", {}, function (res) {
      if (res["resultCode"] === 0) {
        window.app.currentUser.isShowingStructor = res["isShowing"];
        _app["default"] && _app["default"].currentUser.set("isShowingStructor", res["isShowing"]);
        // resolve()
      } else {
        // resolve()
      }
    });
    _MMEnterpriseController["default"].getEnterpriseAttr();
  },
  downgradeEdition: function downgradeEdition(success, fail) {
    MMNetDiskDataController.request("netDrive.userHandler.downgradeEdition", {}, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  checkEpUserLogined: function checkEpUserLogined(_success, fail) {
    if (!window.ep) {
      _success && _success();
      return;
    }
    if (!_app["default"] || !_app["default"].currentUser.logined()) {
      _success && _success();
      return;
    }
    if (!_MMEnterpriseController["default"].checkEpUserLogine_checking) {
      // if (window.ep) {
      _MMEnterpriseController["default"].checkEpUserLogine_checking = true;
      $.ajax({
        method: "post",
        url: "/enterprise/isSessionValid.do",
        success: function success(data) {
          _MMEnterpriseController["default"].checkEpUserLogine_checking = false;
          if (data["isServerInMaintenance"]) {
            window.location.reload();
            return;
          }
          if (data["success"]) {
            _success && _success();
          } else {
            if (data["code"] == 207) {
              // 未登录 或 session 失效
              location.href = "/account/userLogout.do";
            }
            fail && fail(data["code"], data["msg"]);
          }
        },
        error: function error(e) {
          _MMEnterpriseController["default"].checkEpUserLogine_checking = false;
        }
      });
      // } else {
      //   success && success();
      // }
    }
  },
  checkFolderSize: function checkFolderSize(folderId, _success2, fail) {
    $.ajax({
      method: "post",
      url: "/file/checkFolderSize.do",
      data: {
        folderId: folderId
      },
      success: function success(data) {
        _MMEnterpriseController["default"].checkEpUserLogine_checking = false;
        if (data["success"]) {
          _success2();
        } else {
          fail && fail(data["code"], data["msg"]);
        }
      },
      error: function error(e) {
        fail && fail(1, "network error");
      }
    });
  }
};

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"106":106,"1091":1091,"1098":1098,"1184":1184,"1415":1415,"1417":1417,"1418":1418,"1421":1421,"1422":1422,"1423":1423,"1426":1426,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1471":1471,"1478":1478,"1487":1487,"1500":1500,"1503":1503,"1537":1537,"1538":1538,"17":17,"246":246,"252":252,"254":254,"256":256,"257":257,"272":272,"273":273,"282":282,"285":285,"297":297,"298":298,"310":310,"321":321,"325":325}],1095:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
require(1424);
require(1426);
require(1461);
require(1439);
require(1421);
var _MDBrowserNotificator = _interopRequireDefault(require(315));
var _MMFileType = _interopRequireDefault(require(303));
var _MDSalonMsg = _interopRequireDefault(require(205));
var _MDEvents = _interopRequireDefault(require(325));
var _MDLocalString = _interopRequireDefault(require(1150));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDMessageType = _interopRequireDefault(require(271));
var _MDMessage = _interopRequireDefault(require(270));
var _MDAlertView = _interopRequireDefault(require(32));
var MDWebMessageController = {
  initialize: function initialize() {
    if (MDWebMessageController.isInitialized) return;
    MDWebMessageController.isInitialized = true;

    //
    // message data structor {
    //  category:  0 - conversation, 1 - dashboard, 2 - notification
    //  type:
    //  fileId:
    //  senderId:
    //  msg:
    // }
    //
    //

    var _depMsgInfluenceCurrentUser = function _depMsgInfluenceCurrentUser(msg) {
      var members = msg['members'];
      var department = msg['department'];
      var depFolderId = department['folderId'];
      var curUid = app.currentUser.getUserId();
      for (var i = 0; i < members.length; i++) {
        var mem = members[i];
        if (mem.user.id == curUid) {
          return true;
        }
        ;
      }
      ;
      return false;
    };
    var _depMsgInfluenceCurrentEnterprise = function _depMsgInfluenceCurrentEnterprise(msg) {
      var department = msg['department'];
      var entId = department['enterpriseId'];
      if (app.isEpVersion() && app.ep.getEpID() == entId) {
        return true;
      }
      ;
      return false;
    };
    pomelo.on('onMessage', function (data) {
      data["time"] = new Date(data["time"] * 1000);

      // 确保 fileId 是字符串类型
      if (data['fileId']) {
        data["fileId"] = data["fileId"].toString();
      }
      var _msgContent = data["msgContent"];
      if (_msgContent) {
        if (_msgContent["fileId"]) {
          _msgContent["fileId"] = _msgContent["fileId"].toString();
        }
      }
      ;
      var msg = data["msg"] = new Backbone.Model(data["msgContent"]);
      var messageModel = new _MDMessage["default"](data);
      _Dispatcher["default"].trigger(_MDEvents["default"].NewMsgReceived, data["fileId"], messageModel);
      var msgType = data['type'];
      var fileType = msg.get('type');
      var shareId = data["fileId"];
      var userId = app.currentUser.getUserId();
      var list;
      var i;
      var fileId;
      var commentContent;
      var type;
      var textContent;
      var commentStr = '';
      var inEvaluation = false;
      var msgContent = messageModel.get('msgContent');
      if (app.currentUser.isSelf(data['senderId'])) {
        return;
      } else {
        _Dispatcher["default"].trigger(_MDEvents["default"].NewDashboardMsg);
      }
      // if(msgType != MDMessageType.SALON){
      //     if ((data['enterpriseId'] || "0") != (app.ep.getEpID() || "0")) {
      //       return;
      //     }
      // }
      console.log('--------------- msgType - ', msgType);
      switch (msgType) {
        case _MDMessageType["default"].EP_ROLE_CHANGED:
          _MDAlertView["default"].showStandardPrompt({
            message: BabelStr.str(21529, {
              name: data.msgContent.roleName
            }),
            okFun: function okFun() {
              location.reload();
            }
          });
          break;
        case _MDMessageType["default"].STOP_SHARE:
          _Dispatcher["default"].trigger(_MDEvents["default"].ShareChanged, shareId, messageModel);
          _Dispatcher["default"].trigger(_MDEvents["default"].ShareClosed, shareId, messageModel);
          _Dispatcher["default"].trigger(_MDEvents["default"].ShareClosed_board, shareId, messageModel);
          break;
        case _MDMessageType["default"].UNDO_COMMENT_CHAT:
          console.log('--------------111111111-------------');
          _Dispatcher["default"].trigger(_MDEvents["default"].undo_chat, messageModel);
          break;
        case _MDMessageType["default"].DELETE:
          var files = data["msg"].get('files');
          var fileIds = [];
          for (i = 0; i < files.length; i++) {
            fileId = files[i]["fileId"];
            var file = files[i];
            _Dispatcher["default"].trigger(_MDEvents["default"].ShareClosed, file, messageModel);
            _Dispatcher["default"].trigger(_MDEvents["default"].ShareClosed_board, file, messageModel);
          }

          //Dispatcher.trigger(MDEvents.SOME_SHARE_DELETE, list);
          break;
        case _MDMessageType["default"].INVITATION:
          //mashx
          list = data["msg"];
          _Dispatcher["default"].trigger(_MDEvents["default"].ShareChanged, shareId, messageModel);
          _Dispatcher["default"].trigger(_MDEvents["default"].FileUploadedByOther, list, messageModel);
          break;
        case _MDMessageType["default"].REMOVE_INVITATION:
          var targetIds = data['msgContent']['targetIds'];
          if (targetIds && targetIds.length > 0) {
            for (i = 0; i < targetIds.length; i++) {
              if (app.currentUser.isSelf(targetIds[i])) {
                _Dispatcher["default"].trigger(_MDEvents["default"].ShareChanged);
                _Dispatcher["default"].trigger(_MDEvents["default"].ShareClosed, shareId, messageModel);
                _Dispatcher["default"].trigger(_MDEvents["default"].ShareClosed_board, shareId, messageModel);
                break;
              }
            }
          }
          break;
        case _MDMessageType["default"].SET_SHARE_DEFAULT_ROLE:
          if (userId == data["msg"].get('userId')) {
            _Dispatcher["default"].trigger(_MDEvents["default"].SharePermissionChanged, shareId, messageModel);
          } else {
            var fileId = msg.get('fileId');
            var parentId = data.parentId;
            _Dispatcher["default"].trigger(_MDEvents["default"].SharePermissionChangedNew, {
              fileId: fileId,
              parentId: parentId
            }, messageModel);
          }
          break;
        case _MDMessageType["default"].SET_USER_ROLE:
          if (userId == data["msg"].get('userId')) {
            _Dispatcher["default"].trigger(_MDEvents["default"].SharePermissionChanged, shareId, messageModel);
          }
          break;
        case _MDMessageType["default"].MODIFY_LINK_LEVEL:
          _Dispatcher["default"].trigger(_MDEvents["default"].SharePermissionChanged, shareId, messageModel);
          break;
        case _MDMessageType["default"].KICK_FROM_SHARE:
          _Dispatcher["default"].trigger(_MDEvents["default"].ShareClosed, shareId, messageModel);
          _Dispatcher["default"].trigger(_MDEvents["default"].TeamKick, shareId, messageModel);
          break;
        case _MDMessageType["default"].REMOVED_TEAM_INVITATION_APPLICATION:
          _Dispatcher["default"].trigger(_MDEvents["default"].RemovedBeforeJoin, shareId, messageModel);
          break;
        case _MDMessageType["default"].COMMENT_CHAT:
          _Dispatcher["default"].trigger(_MDEvents["default"].Comment_State_Sync, data["msg"].get('fileId'), messageModel);
          // Dispatcher.trigger(MDEvents.NewNotificationRecived);
          break;
        case _MDMessageType["default"].RENAME:
          var fileId = data["msg"].get('fileId');
          _Dispatcher["default"].trigger(_MDEvents["default"].Comment_State_Sync, fileId, messageModel);
          break;
        case _MDMessageType["default"].CREATE:
          list = data["msg"];
          _Dispatcher["default"].trigger(_MDEvents["default"].FileUploadedByOther, list, messageModel);
          break;
        case _MDMessageType["default"].NEW_VERSION:
          list = data["msg"];
          _Dispatcher["default"].trigger(_MDEvents["default"].FileUploadedByOther, list, messageModel);
          break;
        case _MDMessageType["default"].REQUEST_LINK_SHARE:
          _Dispatcher["default"].trigger(_MDEvents["default"].ShareChanged);
          break;
        case _MDMessageType["default"].REQUEST_INVITE_SHARE:
          _Dispatcher["default"].trigger(_MDEvents["default"].ShareChanged);
          break;
        case _MDMessageType["default"].CLOSE_LINK:
          var fileId = data["msg"].get('fileId');
          _Dispatcher["default"].trigger(_MDEvents["default"].CloseLink, fileId, messageModel);
          var fileId = msg.get('fileId');
          var parentId = data.parentId;
          _Dispatcher["default"].trigger(_MDEvents["default"].SharePermissionChangedNew, {
            fileId: fileId,
            parentId: parentId
          }, messageModel);
          break;
        case _MDMessageType["default"].COPY:
          list = data["msg"];
          _Dispatcher["default"].trigger(_MDEvents["default"].FileCopy, list, messageModel);
          break;
        case _MDMessageType["default"].MOVE_IN:
          list = data["msg"];
          _Dispatcher["default"].trigger(_MDEvents["default"].FileMoveIn, list, messageModel);
          break;
        case _MDMessageType["default"].MOVE:
          list = data["msg"];
          _Dispatcher["default"].trigger(_MDEvents["default"].FileMove, list, messageModel);
          break;
        case _MDMessageType["default"].MOVE_OUT:
          list = data["msg"];
          _Dispatcher["default"].trigger(_MDEvents["default"].FileMoveOut, list, messageModel);
          break;
        case _MDMessageType["default"].DEPARTMENT_ADDMEMBER:
          list = data["msgContent"];
          if (_depMsgInfluenceCurrentUser(list)) {
            _Dispatcher["default"].trigger(_MDEvents["default"].Department_addMem, list, messageModel);
          }
          ;
          break;
        case _MDMessageType["default"].DEPARTMENT_UPDATE:
          list = data["msgContent"];
          _Dispatcher["default"].trigger(_MDEvents["default"].Department_update, list, messageModel);
          break;
        case _MDMessageType["default"].DEPARTMENT_REMOVE_MEMBER:
          var members = msg.get("members");
          for (i = 0; i < members.length; i++) {
            if (members[i].user.id == app.currentUser.getUserId()) {
              var path = "message";
              app.pathRouter.navigate(path, {
                trigger: true
              });
            }
          }
          list = data["msgContent"];
          if (_depMsgInfluenceCurrentUser(list)) {
            _Dispatcher["default"].trigger(_MDEvents["default"].Department_removeMem, list, messageModel);
          }
          ;
          break;
        case _MDMessageType["default"].DEPARTMENT_UPDATE_MEMBER:
          list = data["msgContent"];
          if (list.members[0].user.id === app.currentUser.getId()) {
            _Dispatcher["default"].trigger(_MDEvents["default"].Department_updateMem, list, messageModel);
          }
          if (_depMsgInfluenceCurrentEnterprise(list)) {
            _Dispatcher["default"].trigger(_MDEvents["default"].Department_created, list, messageModel);
          }
          ;
          break;
        case _MDMessageType["default"].DEPARTMENT_CREATE:
          list = data["msgContent"];
          if (_depMsgInfluenceCurrentEnterprise(list)) {
            _Dispatcher["default"].trigger(_MDEvents["default"].Department_created, list, messageModel);
          }
          ;
          break;
        case _MDMessageType["default"].DEPARTMENT_REMOVE:
          list = data["msgContent"];
          if (_depMsgInfluenceCurrentEnterprise(list)) {
            _Dispatcher["default"].trigger(_MDEvents["default"].Department_removed, list, messageModel);
          }
          ;
          break;
        case _MDMessageType["default"].SET_VERSION_LOG:
          list = data["msgContent"];
          _Dispatcher["default"].trigger(_MDEvents["default"].Department_updateMem, list, messageModel);
          break;
        case _MDMessageType["default"].EVALUATION_PASS:
        case _MDMessageType["default"].EVALUATION_REJECT:
        case _MDMessageType["default"].INVITE_EVALUATIONkey:
          var fileId = data["msgContent"]['fileId'];
          _Dispatcher["default"].trigger(_MDEvents["default"].evaluationChanged, fileId, messageModel);
          break;
        case _MDMessageType["default"].SALON:
          console.log('--------------- salo message received');
          var msg = data["msg"] = new _MDSalonMsg["default"](data["msgContent"]);
          _Dispatcher["default"].trigger(_MDEvents["default"].SALON_MESSAGE, msg);
          break;
        case _MDMessageType["default"].CHAT:
        case _MDMessageType["default"].FOCUS_FILE:
        // case MDMessageType.INVITE_EVALUATION:
        case _MDMessageType["default"].INVITE_CONTRIBUTOR:
        case _MDMessageType["default"].ENTERPRISE_BROADCAST:
          // Dispatcher.trigger(MDEvents.NewNotificationRecived);
          break;
        case _MDMessageType["default"].INVITE_EVALUATION:
          _Dispatcher["default"].trigger(_MDEvents["default"].InviteEvaluation);
          break;
        case _MDMessageType["default"].MULTI_UPLOAD:
          var fileId = data["msgContent"]['fileId'];
          _Dispatcher["default"].trigger(_MDEvents["default"].FilesUploadedByOther, fileId, messageModel);
          break;
        case _MDMessageType["default"].APPEND_FILE_PERMISSION:
        case _MDMessageType["default"].REMOVE_FILE_PERMISSION:
          var fileId = msg.get('fileId');
          var parentId = data.parentId;
          _Dispatcher["default"].trigger(_MDEvents["default"].SharePermissionChangedNew, {
            fileId: fileId,
            parentId: parentId
          }, messageModel);
          break;
        case _MDMessageType["default"].FILE_SIGNATURE_CREATED:
        case _MDMessageType["default"].FILE_SIGNATURE_UPDATED:
        case _MDMessageType["default"].FILE_SIGNATURE_DELETED:
          var fileId = messageModel.get('content').fileId;
          var version = messageModel.get('content').version;
          if (version == undefined) {
            version = 0;
          }
          _Dispatcher["default"].trigger(_MDEvents["default"].FileSignatureChanged, {
            fileId: fileId,
            version: version
          }, messageModel);
          break;
        case _MDMessageType["default"].UNLOCK_FILE:
          var fileId = msg.get('fileId');
          _Dispatcher["default"].trigger(_MDEvents["default"].UNLOCK_FILE, {
            fileId: fileId,
            type: _MDMessageType["default"].UNLOCK_FILE
          }, messageModel);
          break;
        case _MDMessageType["default"].LOCK_FILE:
          var fileId = msg.get('fileId');
          var userId = msg.get("userId");
          var userName = msg.get("userName");
          _Dispatcher["default"].trigger(_MDEvents["default"].LOCK_FILE, {
            fileId: fileId.toString(),
            userId: userId,
            userName: userName,
            type: _MDMessageType["default"].LOCK_FILE
          }, messageModel);
          break;
      }
      var formatMessage = function formatMessage(data) {
        var senderName = _.unescape(data['senderName']);
        var fileName = msg.get('fileName');
        var content = senderName;
        var fileTypeName = fileType == _MMFileType["default"].FILE ? _MDLocalString["default"].getLocalString(1) : _MDLocalString["default"].getLocalString(8);
        switch (msgType) {
          case _MDMessageType["default"].CHAT:
            var type = msg.get('Type');
            if (type === 'Text') {
              content += _MDLocalString["default"].getLocalString(1500) + msg.get('Body');
            } else if (type === 'File') {
              content += _MDLocalString["default"].getLocalString(1501);
            } else if (type == 'Mark') {
              content += _MDLocalString["default"].getLocalString(1502);
            } else if (type == "Audio") {
              content += _MDLocalString["default"].getLocalString(1503);
            }
            break;
          case _MDMessageType["default"].CREATE:
            var isArchive = msg.get('isArchive');
            var num = 1504;
            if (isArchive) {
              num = 1537;
            }
            content += _MDLocalString["default"].getLocalString(num, {
              'fileName': '《' + fileName + '》'
            });
            break;
          case _MDMessageType["default"].NEW_VERSION:
            var param = {
              'fileEdition': msg.get('version') === 0 ? _MDLocalString["default"].getLocalString(1003) : _MDLocalString["default"].getLocalString(1004),
              'fileName': '《' + fileName + '》'
            };
            content += _MDLocalString["default"].getLocalString(1505, param);
            break;
          case _MDMessageType["default"].RENAME:
            var enterprisePub = msg.get("enterprisePub");
            if (enterprisePub == 4) {
              fileTypeName = _MDLocalString["default"].getLocalString(24020);
            } else if (enterprisePub == 5) {
              fileTypeName = _MDLocalString["default"].getLocalString(24021);
            }
            var param = {
              'file': fileTypeName + '《' + msg.get('oldName') + '》',
              'newName': '《' + msg.get('newName') + '》'
            };
            content += _MDLocalString["default"].getLocalString(1506, param);
            break;
          case _MDMessageType["default"].MOVE:
            // content += ' 将' + fileTypeName + '《' + fileName + '》移动到了' + (msg.get('destName') ? ('文件夹：' + '《' + msg.get('destName') + '》') : '根目录');
            var param = {
              'file': fileTypeName + '《' + fileName + '》',
              'folder': msg.get('destName') ? _MDLocalString["default"].getLocalString(8) + '：' + '《' + msg.get('destName') + '》' : _MDLocalString["default"].getLocalString(135)
            };
            content += _MDLocalString["default"].getLocalString(1534, param);
            break;
          case _MDMessageType["default"].DELETE:
            var names = msg.get('files').map(function (file) {
              var fileTypeName = file['type'] == _MMFileType["default"].FOLDER ? _MDLocalString["default"].getLocalString(8) : _MDLocalString["default"].getLocalString(1);
              if (file['version']) {
                var p = {
                  'file': '《' + file['fileName'] + '》'
                };
                return fileTypeName + _MDLocalString["default"].getLocalString(1010, p);
              } else {
                return fileTypeName + '《' + file['fileName'] + '》';
              }
            }).join(", ");
            var parentName = msg.get('parentName');
            // if (parentName) {
            //   content += ' 从文件夹 ' + parentName + ' 中';
            // }
            // content += ' 删除了' + names;

            var param = {
              'somebody': senderName,
              'file': names
            };
            if (parentName) {
              param['folder'] = '《' + parentName + '》';
              content = _MDLocalString["default"].getLocalString(1007, param);
            } else {
              content = _MDLocalString["default"].getLocalString(1009, param);
            }
            break;
          case _MDMessageType["default"].JOIN_SHARE:
            content += ' ' + _MDLocalString["default"].getLocalString(1507);
            break;
          case _MDMessageType["default"].LEAVE_SHARE:
            if (msg.get("teamId")) {
              if (msg.get('removedUserName') === senderName) {
                var param = {
                  'teamName': msg.get('teamName')
                };
                content += _MDLocalString["default"].getLocalString(1508, param);
                // content += ' 退出了团队 ' + msg.get('teamName');
              } else {
                var param = {
                  'user': msg.get('removedUserName'),
                  'teamName': msg.get('teamName')
                };
                content += ' ' + _MDLocalString["default"].getLocalString(1509, param);
                // content += ' 将 ' + msg.get('removedUserName') + ' 移除团队 ' + msg.get('teamName');
              }
            } else {
              content += _MDLocalString["default"].getLocalString(1510); //' 退出了讨论';
            }
            break;
          case _MDMessageType["default"].KICK_FROM_SHARE:
            if (msg.get('teamId')) {
              var param = {
                'teamName': msg.get('teamName')
              };
              content = _MDLocalString["default"].getLocalString(1511, param); //'你已被移除出团队 ' + msg.get('teamName');
            } else {
              var param = {
                'sharename': msg.get('fileName')
              };
              content = _MDLocalString["default"].getLocalString(1512, param); // '你已被移除出文件 ' + msg.get('fileName');
            }
            break;
          case _MDMessageType["default"].RESTORE:
            var param = {
              'somebody': senderName,
              'file': '《' + fileName + '》'
            };
            content = _MDLocalString["default"].getLocalString(1011, param); //' 从回收站恢复了' + fileTypeName + ' 《' + fileName + '》';
            break;
          case _MDMessageType["default"].SHARE:
            var param = {
              'file': '《' + fileName + '》'
            };
            content += _MDLocalString["default"].getLocalString(1513, param); //' 分享了' + fileTypeName + '《' + fileName + '》';
            break;
          case _MDMessageType["default"].MODIFY_LINK_LEVEL:
            var isChinese = BabelStr.getCurrentLanguage() != "en";
            var param = {
              'somebody': senderName,
              'file': '《' + fileName + '》',
              'oldRole': '"' + (isChinese ? msg.get('oldLinkRoleName') : msg.get('oldLinkRoleNameEn')) + '"',
              'newRole': '"' + (isChinese ? msg.get('newLinkRoleName') : msg.get('newLinkRoleNameEn')) + '"'
            };
            content = _MDLocalString["default"].getLocalString(1029, param);
            // content += ' 将' + fileTypeName + '《' + fileName + '》的分享链接权限由 \n"' + msg.get('oldLinkRoleName') + '" 修改为 "' + msg.get('newLinkRoleName') + '"';
            break;
          case _MDMessageType["default"].STOP_SHARE:
            if (msg.get("teamId")) {
              var param = {
                'teamName': '《' + fileName + '》'
              };
              content += _MDLocalString["default"].getLocalString(1514, param);
              // content += ' 取消了分享团队 《' + fileName + '》';
            } else {
              var param = {
                'somebody': senderName,
                'file': '《' + fileName + '》'
              };
              content = _MDLocalString["default"].getLocalString(1021, param);
              // content += ' 取消了分享 《' + fileName + '》';
            }
            break;
          case _MDMessageType["default"].SET_SHARE_DEFAULT_ROLE:
            var isChinese = BabelStr.getCurrentLanguage() != "en";
            var param = {
              'somebody': senderName,
              'file': '《' + fileName + '》',
              'oldRole': '"' + (isChinese ? msg.get('oldRoleName') : msg.get('oldRoleNameEn')) + '"',
              'newRole': '"' + (isChinese ? msg.get('newRoleName') : msg.get('newRoleNameEn')) + '"'
            };
            content = _MDLocalString["default"].getLocalString(1029, param);
            // content += ' 将分享《' + fileName + '》的权限从"' + msg.get('oldRoleName') + '"修改为"' + msg.get('newRoleName') + '"';
            break;
          case _MDMessageType["default"].SET_USER_ROLE:
            var isChinese = BabelStr.getCurrentLanguage() != "en";
            var param = {
              'file': '《' + _.unescape(fileName) + '》',
              'user': _.unescape(msg.get('userName')),
              'oldRole': '"' + (isChinese ? _.unescape(msg.get('oldRoleName')) : _.unescape(msg.get('oldRoleNameEn')) || _.unescape(msg.get('oldRoleName'))) + '"',
              'newRole': '"' + (isChinese ? _.unescape(msg.get('newRoleName')) : _.unescape(msg.get('newRoleNameEn')) || _.unescape(msg.get('newRoleName'))) + '"'
            };
            if (msg.get('teamId')) {
              //A将团队《B》的成员C的角色由xx修改为yy
              // content += ' 将团队《' + fileName + '》的成员 ' + msg.get('userName') + ' 的角色由 ' + msg.get('oldRoleName') + " 修改为 " + msg.get('newRoleName');
              content += _MDLocalString["default"].getLocalString(1515, param);
            } else {
              content += _MDLocalString["default"].getLocalString(1516, param);
              // content += ' 将文件《' + fileName + '》的参与者 ' + msg.get('userName') + ' 的角色由 ' + msg.get('oldRoleName') + " 修改为 " + msg.get('newRoleName');
            }
            break;
          case _MDMessageType["default"].FILEREVIEW_CREATE:
            var textContent = msg.get('content')["Body"];
            textContent = _.unescape(textContent);
            var commentStr = messageModel.isDashboardAtmeMessage() ? _MDLocalString["default"].getLocalString(1517) : _MDLocalString["default"].getLocalString(128) + ':';
            content += commentStr + textContent;
            break;
          case _MDMessageType["default"].COMMENT_CREATED:
            // content += ' 在文件《' + fileName + '》上添加了一个批注';
            var param = {
              'file': '《' + fileName + '》'
            };
            content += _MDLocalString["default"].getLocalString(1518);
            break;
          case _MDMessageType["default"].COMMENT_CHAT:
            console.log(msg);
            commentContent = JSON.parse(msg.get('commentContent'));
            var inEval = msg.get('inEvaluation');
            type = commentContent['Type'];
            textContent = _.unescape(commentContent['Body']);
            commentStr = '';
            if (messageModel.isDashboardAtmeMessage()) {
              commentStr = _MDLocalString["default"].getLocalString(1517) + ':' + textContent;
            } else {
              var action = commentContent['newComment'] ? _MDLocalString["default"].getLocalString(1519) : _MDLocalString["default"].getLocalString(1520);
              if (type === 'Text') {
                if (inEval) {
                  commentStr = action + _MDLocalString["default"].getLocalString(809) + ':' + textContent;
                } else {
                  commentStr = action + _MDLocalString["default"].getLocalString(109) + ':' + textContent;
                }
              } else if (type === 'File') {
                commentStr = _MDLocalString["default"].getLocalString(1521);
              } else if (type === 'Audio') {
                commentStr = action + _MDLocalString["default"].getLocalString(129);
              } else if (type == "Mark" || !textContent) {
                commentStr = action + _MDLocalString["default"].getLocalString(130);
              }
            }
            content += commentStr;
            break;
          case _MDMessageType["default"].COMMENT_DELETE:
            var commentType = _MDLocalString["default"].getLocalString(42);
            if (inEvaluation) {
              commentType = BabelStr.str(809);
            }
            var param = {
              'somebody': senderName,
              'file': '《' + fileName + '》',
              'commentType': commentType
            };
            // content += ' 删除了位于文件《' + fileName + '》中的一个批注';
            content = _MDLocalString["default"].getLocalString(1033, param);
            break;
          case _MDMessageType["default"].COMMENT_COMPLETED:
            var status = msgContent['completed'];
            var messageHTML = '';
            if (status == 1) {
              var param = {
                'file': msgContent['fileName'],
                'comment': _MDLocalString["default"].getLocalString(42),
                'finish': _MDLocalString["default"].getLocalString(131)
              };
              messageHTML = _MDLocalString["default"].getLocalString(6099, param);
            }
            if (status == 2) {
              var creatorName = msgContent['creatorName'];
              var param = {
                'somebody': creatorName,
                'file': msgContent['fileName'],
                'evaluation': _MDLocalString["default"].getLocalString(809)
              };
              messageHTML = _MDLocalString["default"].getLocalString(817, param);
            } else if (status == 3) {
              var creatorName = msgContent['creatorName'];
              var param = {
                'somebody': creatorName,
                'file': msgContent['fileName'],
                'evaluation': _MDLocalString["default"].getLocalString(809)
              };
              messageHTML = _MDLocalString["default"].getLocalString(818, param);
            }
            content += messageHTML;
            break;
          case _MDMessageType["default"].COMMENT_UNCOMPLETED:
            // content += ' 将位于文件《' + fileName + '》中的一个批注设置为未完成';
            var param = {
              'file': '《' + fileName + '》'
            };
            content += _MDLocalString["default"].getLocalString(1523, param);
            break;
          case _MDMessageType["default"].MOVE_IN:
            // content += ' 移入了 《' + fileName + '》';
            var param = {
              'file': '《' + fileName + '》'
            };
            content += _MDLocalString["default"].getLocalString(1524, param);
            break;
          case _MDMessageType["default"].MOVE_OUT:
            // content += ' 移出了 《' + fileName + '》';
            var param = {
              'file': '《' + fileName + '》'
            };
            content += _MDLocalString["default"].getLocalString(1525, param);
            break;
          case _MDMessageType["default"].DEPARTMENT_REMOVE_MEMBER:
            var members = msg.get("members");
            var remove_other_flag = true;
            var remove_arr = '';
            for (var i = 0; i < members.length; i++) {
              if (members[i].user.id == app.currentUser.getUserId()) {
                var path = "message";
                app.pathRouter.navigate(path, {
                  trigger: true
                });
                var param = {
                  'department': msg.get('department')['name']
                };
                // content = ' 您被移出了部门   ' + msg.get('department')['name'];
                content = _MDLocalString["default"].getLocalString(1526, param);
                remove_other_flag = false;
              } else {
                remove_arr += members[i].user.name + ' ';
              }
            }
            if (remove_other_flag) {
              // content += '将 ' + remove_arr + '移出了部门' + msg.get('department')['name'];
              var param = {
                'department': msg.get('department')['name'],
                'user': remove_arr
              };
              content += _MDLocalString["default"].getLocalString(1527, param);
            }
            break;
          case _MDMessageType["default"].DEPARTMENT_ADDMEMBER:
            var members = msg.get("members");
            var add_other_flag = true;
            var add_arr = '';
            for (var i = 0; i < members.length; i++) {
              if (members[i].user.id == app.currentUser.getUserId()) {
                var path = "message";
                app.pathRouter.navigate(path, {
                  trigger: true
                });
                var param = {
                  'department': msg.get('department')['name']
                };
                // content = ' 您被添加到部门   ' + msg.get('department')['name'];
                content = _MDLocalString["default"].getLocalString(1528, param);
                add_other_flag = false;
              } else {
                add_arr += members[i].user.name + ' ';
              }
            }
            if (add_other_flag) {
              // content += '将 ' + add_arr + '添加到了部门' + msg.get('department')['name'];
              var param = {
                'user': add_arr,
                'department': msg.get('department')['name']
              };
              content += ' ' + _MDLocalString["default"].getLocalString(1529, param);
            }
            break;
          case _MDMessageType["default"].INVITATION:
            var targetEmails = msg.get('targetEmails');
            if (targetEmails && targetEmails.indexOf(app.currentUser.get('email')) != -1) {
              var teamName = msg.get('teamName');
              if (teamName) {
                var param = {
                  'team': teamName
                };
                content += _MDLocalString["default"].getLocalString(1530, param); //' 邀请您参与团队 ' + teamName;
              } else {
                var param = {
                  'file': '《' + fileName + '》'
                };
                content += _MDLocalString["default"].getLocalString(1531, param); //' 给您分享了文档 《' + fileName + '》';
              }
            } else {
              return null;
            }
            break;
          case _MDMessageType["default"].REMOVE_INVITATION:
            var targetEmails = msg.get('targetEmails');
            if (targetEmails && targetEmails.indexOf(app.currentUser.get('email')) != -1) {
              // content += ' 将您移出了分享文档 《' + fileName + '》';
              var param = {
                'file': '《' + fileName + '》'
              };
              content += _MDLocalString["default"].getLocalString(1532, param);
            } else {
              return null;
            }
            break;
          case _MDMessageType["default"].SET_VERSION_LOG:
            // content += ' 将《' + fileName + '》的版本说明设置为"' + msg.get('versionLog') + '"';
            var param = {
              'file': '《' + fileName + '》',
              'remark': '"' + msg.get('versionLog') + '"'
            };
            content += _MDLocalString["default"].getLocalString(1533, param);
            break;
          default:
            return null;
        }
        return content;
      };
      setBabelTimeout(function () {
        var notfyContent = formatMessage(data);
        if (notfyContent) {
          _MDBrowserNotificator["default"].notify({
            type: msgType,
            title: BabelStr.str(170),
            body: notfyContent,
            callback: function callback() {
              var path = '';
              if (messageModel.isDashboardFileMessage()) {
                path = 'dashboard/file';
              } else if (messageModel.isDashboardCommentMessage()) {
                path = 'dashboard/comment';
              } else if (messageModel.isDashboardAtmeMessage()) {
                path = 'dashboard/atme';
              } else if (messageModel.isConversition()) {
                path = 'message/' + shareId;
              }
              app.pathRouter.navigate(path, {
                trigger: true,
                force: true
              });
            }
          });
        }
      });
    });
  }
};
var _default = exports["default"] = MDWebMessageController;

},{"1150":1150,"1184":1184,"1421":1421,"1424":1424,"1426":1426,"1437":1437,"1439":1439,"1454":1454,"1461":1461,"1463":1463,"1478":1478,"18":18,"205":205,"270":270,"271":271,"303":303,"315":315,"32":32,"325":325}],1092:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1541);
var _MDMessage = _interopRequireDefault(require(270));
var _MDMessageType = _interopRequireDefault(require(271));
var MDSelfMessageController = {
  initialize: function initialize() {
    if (MDSelfMessageController.isInitialized) {
      return;
    }
    MDSelfMessageController.isInitialized = true;
    pomelo.on('onSelf', function (data) {
      // console.log(data);
      data["time"] = new Date(data["time"] * 1000);
      var msg = data["msg"] = new Backbone.Model(data["msgContent"]);
      var messageModel = new _MDMessage["default"](data);
      Dispatcher.trigger(MDEvents.NewMsgReceived, data["fileId"], messageModel);
      var msgType = data['msgContent']['msgType'];
      var fileType = data['type'];
      var shareId = data["fileId"];
      var userId = app.currentUser.getUserId();
      var msgContent = data['msgContent'];
      var list;
      var i;
      var fileId;
      var commentContent;
      var type;
      var textContent;
      var commentStr = '';
      // console.log(messageModel);
      switch (msgType) {
        case _MDMessageType["default"].NEW_VERSION:
          list = {
            fileId: msgContent['fileId'],
            parentId: msgContent['parentId'],
            editorType: msgContent['editorType']
          };
          setTimeout(function () {
            Dispatcher.trigger(MDEvents.SELF_NEW_VERSION, list, messageModel);
          }, 1000);
          // Dispatcher.trigger(MDEvents.SELF_NEW_VERSION, list, messageModel);
          break;
        case _MDMessageType["default"].MULTI_UPLOAD:
        case _MDMessageType["default"].CREATE:
          list = {
            fileId: msgContent['fileId'],
            parentId: msgContent['parentId']
          };
          setTimeout(function () {
            Dispatcher.trigger(MDEvents.SELF_CREATEL, list, messageModel);
          }, 1000);
          break;
        case _MDMessageType["default"].DELETE:
          list = {
            // fileId: msgContent['fileId'],
            parentId: msgContent['parentId']
          };
          setTimeout(function () {
            Dispatcher.trigger(MDEvents.SELF_DELETE, list, messageModel);
          }, 1000);
      }
    });
  }
};
var _default = exports["default"] = MDSelfMessageController;

},{"1184":1184,"1437":1437,"1454":1454,"1541":1541,"270":270,"271":271}],341:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require(1199));
require(1439);
require(1477);
require(1423);
require(1463);
require(1480);
require(1487);
require(1538);
require(1437);
require(1541);
require(1412);
require(1489);
require(1411);
require(1530);
require(1505);
require(1506);
require(1507);
require(1508);
require(1510);
require(1509);
require(1512);
require(1513);
require(1514);
require(1516);
require(1517);
require(1518);
require(1519);
require(1521);
require(1520);
require(1522);
require(1523);
require(1524);
require(1525);
require(1526);
require(1527);
require(1528);
require(1529);
require(1435);
require(1466);
var _asyncToGenerator2 = _interopRequireDefault(require(1172));
var _MMModelBase = _interopRequireDefault(require(21));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDUpdatePromptWindowView = _interopRequireDefault(require(525));
var _MMVersionInfo = _interopRequireDefault(require(310));
var _MDAlertView = _interopRequireDefault(require(32));
var _MMFileInfo = _interopRequireDefault(require(297));
var _MMFileType = _interopRequireDefault(require(303));
var _ErrorCode = _interopRequireDefault(require(1087));
var _videoThumb = _interopRequireDefault(require(348));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var MDUploadFile = _MMModelBase["default"].extend({
  defaults: {
    size: -1,
    // size in bytes
    loaded: 0,
    //uplaoded bytes
    progress: 0,
    //progress between 0 and 1
    type: "",
    name: "",
    //the original Name
    bitrate: 0,
    state: -1,
    file: null,
    // the native uploadFile
    id: -1,
    directory: null,
    fileId: null,
    // will be available after upload is started
    fileInfo: null,
    // fileinfo this uploadFile is a new version for
    newVersion: false,
    destDirInfo: null,
    isPersonal: true,
    teamId: -1
  },
  /**
   * file is a native file object
   */
  initialize: function () {
    var _initialize = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(file, dir, fileInfo, parentFolder, param, callback) {
      "use strict";
      var that, reader, thumbnail;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (_.isFunction(param)) {
              callback = param;
              param = null;
            }
            parentFolder = parentFolder || app.currentFolder;
            that = this;
            this.set("size", file.size);
            this.set("type", file.type);
            this.set("name", file.name);
            this.set("bitrate", file.bitrate);
            this.set("file", file);
            this.set("id", this._generateId());
            this.set("directory", dir);
            this.set("fileInfo", fileInfo);
            this.set("destDirInfo", parentFolder);
            this.set("state", MDUploadFile.states.notStarted);
            this.set("isPersonal", app.currentFolder.isTeamFolder());
            this.set("forbidAutoRename", param && param.forbidAutoRename);
            this.set("sameNameAsNewVersion", param && param.sameNameAsNewVersion);
            if (file.size > window.blockSize) {
              file.blockUpload = true;
              file.blockUploadStart = 0;
            }
            //1024 * 1024 * 50
            if (file.size <= window.blockSize) {
              file.useFullHash = true;
            }

            //        this.set("teamId" , app.currentFolder.get('teamId')),

            file.uploadFile = this;
            this.callback = callback;
            if (!(MMCommonFun.isImageNotNeedConvert(file.name) && window.dexieDB && window.dexieDB["file_img_paths"])) {
              _context.next = 28;
              break;
            }
            that.hasImgThumb = true;
            file.hasImgThumb = true;
            reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = function () {
              if (file.size > 200 * 1024) {
                var $canvas = $("<canvas width=\"300\" height=\"300\" style=\"position: fixed; left: -999px; top: -999px\"></canvas>");
                $("body").append($canvas);
                var canvas = $canvas[0];
                var img = new Image();
                img.src = reader.result;
                img.onload = function () {
                  // 计算图像的宽高比
                  var ratio = img.width / img.height;

                  // 根据canvas的尺寸和图像的宽高比，确定绘制图像的尺寸
                  var canvasWidth = canvas.width;
                  var canvasHeight = canvas.height;
                  var imgWidth = canvasWidth;
                  var imgHeight = canvasWidth / ratio;
                  if (imgHeight > canvasHeight) {
                    imgHeight = canvasHeight;
                    imgWidth = imgHeight * ratio;
                  }
                  // 在canvas上绘制图像，保持纵横比
                  canvas.width = imgWidth;
                  canvas.height = imgHeight;
                  var ctx = canvas.getContext("2d");
                  ctx.drawImage(img, 0, 0, imgWidth, imgHeight);
                  that.imgThumbPath = canvas.toDataURL();
                  $canvas.remove();
                  that.set("imgThumbPath", that.imgThumbPath);
                  if (that.loadFileData) {
                    window.dexieDB["file_img_paths"].put({
                      fileId: that.get("fileId"),
                      version: that.version,
                      path: that.imgThumbPath
                    });
                  }
                };
              } else {
                that.imgThumbPath = reader.result;
                that.set("imgThumbPath", that.imgThumbPath);
                if (that.loadFileData) {
                  window.dexieDB["file_img_paths"].put({
                    fileId: that.get("fileId"),
                    version: that.version,
                    path: that.imgThumbPath
                  });
                }
              }
            };
            _context.next = 35;
            break;
          case 28:
            if (!this.isVideoCanGetThumb(file)) {
              _context.next = 35;
              break;
            }
            that.hasImgThumb = true;
            file.hasImgThumb = true;
            _context.next = 33;
            return _videoThumb["default"].extract(file);
          case 33:
            thumbnail = _context.sent;
            if (thumbnail) {
              that.imgThumbPath = thumbnail;
              that.set('imgThumbPath', that.imgThumbPath);
              if (that.loadFileData) {
                window.dexieDB["file_img_paths"].put({
                  fileId: that.get("fileId"),
                  version: that.version,
                  path: that.imgThumbPath
                });
              }
              // 你的数据库保存逻辑...
            } else {
              // 提取失败，你可以选择设置默认图或不处理
              console.warn('视频缩略图提取失败');
            }
          case 35:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function initialize(_x, _x2, _x3, _x4, _x5, _x6) {
      return _initialize.apply(this, arguments);
    }
    return initialize;
  }(),
  // 或兼容旧版同步逻辑（简化版）
  isVideoCanGetThumb: function isVideoCanGetThumb(file) {
    var video = document.createElement("video");
    return file.type ? video.canPlayType(file.type) !== "" : /\.(mov|mp4|webm|ogg)$/.test(file.name.toLowerCase());
  },
  isUploading: function isUploading() {
    "use strict";

    return this.get("state") === MDUploadFile.states.uploading;
  },
  isNewVersion: function isNewVersion() {
    return this.get("newVersion");
  },
  _generateId: function _generateId() {
    "use strict";

    var id = MDUploadFile.idCount;
    MDUploadFile.idCount += 1;
    return "id" + id;
  },
  isNotStarted: function isNotStarted() {
    return this.get("state") === MDUploadFile.states.notStarted;
  },
  startUpload: function startUpload(stopUploadCallback, loadFinished, onCancel) {
    var that = this;
    var file = this.get("file");
    var fileInfo = this.get("fileInfo");
    var folderId = this.get("directory");
    var destDirInfo = this.get("destDirInfo");
    if (onCancel) {
      this.onCancel = onCancel;
    }
    if (stopUploadCallback) {
      this.set("stopUploadCallback", stopUploadCallback);
    }
    if (loadFinished) {
      this.set("loadFinished", loadFinished);
    }
    stopUploadCallback = this.get("stopUploadCallback");
    loadFinished = this.get("loadFinished");
    file.blocked = false;
    // file['canceled'] = false;

    this.set("state", MDUploadFile.states.uploading);
    var tryCount = 0; // 上传失败后的尝试次数；

    var param = {
      forbidAutoRename: this.get("forbidAutoRename"),
      sameNameAsNewVersion: this.get("sameNameAsNewVersion"),
      uploadId: this.get("id"),
      ignoreVirus: this.get("ignoreVirus")
    };
    var uploadFileFuction = function uploadFileFuction() {
      _MMNetDiskDataController["default"].calcFileHashAndUpload(file, fileInfo, folderId, param, function success(file, response) {
        if (!window.newUploadFids) {
          window.newUploadFids = new Set();
        }
        window.newUploadFids.add(response.fileId);
        console.log("***   upload success:", file);
        that.__makeBoardDataAndBroadcast(response, loadFinished);
        if (that.hasImgThumb && that.imgThumbPath) {
          window.dexieDB["file_img_paths"].put({
            fileId: response.fileId,
            version: response.version,
            path: that.imgThumbPath
          });
        }
        that.loadFileData = true;
        // let f = that.get("file")
        if (that.isVideoCanGetThumb(file)) {
          that.uploadThumbnail(response.fileId, file);
        }
        if (response.needRefreshFileInfo && fileInfo) {
          fileInfo.setFileName(response.fileName);
          fileInfo.set("lastModifyUserName", app.currentUser.getUserName());
          fileInfo.set("mtime", new Date().getTime() / 1000);
        }
      }, function fail(e, code, msg) {
        // console.log('***   upload fail:', file);
        var str = msg || BabelStr.str(232);
        var showUpgrade = false;
        if ((code == 6 || code == 142 || code == 117 || code == undefined) && tryCount++ < 3) {
          setTimeout(function () {
            uploadFileFuction();
          }, 1000);
          return;
        }
        if (code == "133") {
          stopUploadCallback && stopUploadCallback("versionLimit");
          if (app.currentUser.inFreeEdition()) {
            showUpgrade = true;
          }
        } else if (code == "7") {
          stopUploadCallback && stopUploadCallback("spaceLimit");
          if (app.currentUser.inFreeEdition()) {
            showUpgrade = true;
          }
          str = BabelStr.str(233);
          if (app.isEpVersion && app.isEpVersion()) {
            str = BabelStr.str(20051);
          }
        } else if (code == "226") {
          stopUploadCallback && stopUploadCallback("spaceLimit");
        } else if (code == 10002) {
          stopUploadCallback && stopUploadCallback("typeForbidden");
          str = BabelStr.str(20003);
        } else if (code == 312) {
          str = BabelStr.str(20042);
        } else if (code == 12) {
          str = BabelStr.str(20053);
        } else if (code == _ErrorCode["default"].SameFileExists) {
          str = BabelStr.str(20100, {
            fileName: file.name
          });
        } else if (code == 10006) {
          str = BabelStr.str(21231);
        }
        if (code == "8" && app.isEpVersion()) {
          str = BabelStr.str(753);
        }
        if (!_.isUndefined(code)) {
          str += "  《" + file.name + "》";
        }
        if (!that.isCaneled()) {
          if (showUpgrade) {
            var entId = destDirInfo.getEnterpriseId();
            var ownerId = destDirInfo.getOwnerId();
            var curEntId = app.ep.get("id");
            if (curEntId != entId || ownerId != app.currentUser.get("id")) {
              var param = {
                message: BabelStr.str(7524)
              };
              _MDAlertView["default"].showStandardPrompt(param);
            } else {
              // 给出用户升级提示
              var alert = new _MDUpdatePromptWindowView["default"]({
                title: BabelStr.str(3314),
                content: str
              });
              alert.show();
            }
          } else {
            if (!self.alertView) {
              self.alertView = new _MDAlertView["default"]();
              var msg = '<p class="title">' + str + "</p>";
              self.alertView.show({
                title: BabelStr.str(232),
                message: msg,
                className: "m-delAlertWin",
                onHide: function onHide() {
                  self.alertView = null;
                },
                buttons: [{
                  label: BabelStr.str(154),
                  type: "done",
                  onClick: function onClick(e) {
                    if (code == "207" || code == "312") {
                      window.location.reload();
                    }
                  }
                }]
              });
            } else {
              self.alertView.appendMsg(str);
            }
          }
        }
        that.set("errorcode", code);
        that.set("state", MDUploadFile.states.error, {
          code: code
        });
        that.trigger("fail");
        if (loadFinished) {
          loadFinished();
        }
      }, function progress(s, id) {
        console.log("file upload id is ".concat(that.get("id"), ", progress id is ").concat(id, " progress  is ").concat(file.progress));
        if (id != that.get("id")) {
          return;
        }
        that.set("progress", file.progress);
        that.set("loaded", file.loaded);
        that.set("bitrate", file.bitrate);
        if (file.progress == 1) {
          that._finishUploadThePureFile(file);
        }
      }); // ----   MMNetDiskDataController.calcFileHashAndUpload   end
    }; // ---- uploadFileFuction  end

    uploadFileFuction();
  },
  uploadThumbnail: function uploadThumbnail(fileId, file) {
    var imgThumbPath = file.uploadFile.get("imgThumbPath");
    var thumbnailFile = this.dataURLtoFile(imgThumbPath, 'thumbnail.jpg');
    _MMEnterpriseController["default"].uploadThumbnail(fileId, thumbnailFile, function () {
      console.log("缩略图上传成功了");
    }, function (res) {
      console.error(res);
    });
  },
  dataURLtoFile: function dataURLtoFile(dataUrl) {
    var filename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'thumbnail.jpg';
    // 提取 Base64 数据部分
    var arr = dataUrl.split(',');
    var mime = arr[0].match(/:(.*?);/)[1]; // 提取 MIME 类型（如 image/jpeg）
    var bstr = atob(arr[1]); // Base64 解码
    var n = bstr.length;
    var u8arr = new Uint8Array(n);

    // 将二进制字符串转换为 Uint8Array
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    // 返回 File 对象（Blob 的子类）
    return new File([u8arr], filename, {
      type: mime
    });
  },
  _finishUploadThePureFile: function _finishUploadThePureFile(file) {
    //!replace { 不再在文件列表中显示刚传输完此时正在等待后台处理的文件
    //this._showFileRowInFileList();
    //!} with {
    // this.set("state", MDUploadFile.states.uploaded);
    //!}
  },
  saveImgLocalPath: function saveImgLocalPath(file) {},
  /**
   * to register the uploaded file on the server
   */
  __makeBoardDataAndBroadcast: function __makeBoardDataAndBroadcast(res, loadFinished) {
    var that = this;
    var oldFileId = this.get("fileId");
    if (oldFileId != res.fileId) {
      that.set("fileId", res.fileId);
      var pageSize = res.pageSize;
      var fileSize = res.fileSize;
      var version = this.version = res.version;
      var fileRefId = res.fileRefId;
      if (res.fileName) this.set("name", res.fileName);
      this.versionNo = res.versionNo;

      // when safari was sleeping and the user is then uploading a file,
      // without further interaction with pomelo,
      // the creation of a whiteboard fail.
      // Now I try it two times if one has failed.
      // (call the "add" method one or two times.)

      that.__complete(res, [], fileSize, fileRefId, loadFinished);
    }
    return;
  },
  /**
   * used when the file is uploaded and registered on the servers Database
   */
  __complete: function __complete(res, pageSize, fileSize, fileRefId, loadFinished) {
    //!replace { 不再在文件列表中显示刚传输完此时正在等待后台处理的文件
    //this._refreshWaitingStatusInFileList(res,pageSize,fileSize,fileRefId);
    //!} with {
    this._insertFileIconInFileList(res, pageSize, fileSize, fileRefId, loadFinished);
    //!}
  },
  // 在文件列表中显示上传后后台处理完毕的文件项
  _insertFileIconInFileList: function _insertFileIconInFileList(res, pageSize, fileSize, fileRefId, loadFinished) {
    var self = this;
    var fileInfo = null;
    if (this.isNewVersion()) {
      var newVerson = new _MMVersionInfo["default"]({
        fileId: "0",
        ver: res.version,
        versionNo: res.versionNo,
        createTime: Math.round(Date.now() / 1000),
        // some timestamp
        committerId: app.currentUser.getUserId(),
        committerName: app.currentUser.get("name"),
        fileSize: parseInt(fileSize),
        currentVersionSize: parseInt(fileSize)
      });
      fileInfo = this.get("fileInfo");
      console.assert(fileInfo);
      fileInfo.set("currentVersionSize", parseInt(fileSize));
      fileInfo.set("fileSize", parseInt(fileSize));
      var versionIndex = res.version;
      fileInfo.set("latestVer", versionIndex);
      newVerson.setFileInfo(fileInfo);
      fileInfo.setFileName(res.fileName);
      fileInfo.setCurVersion(versionIndex, newVerson);
      newVerson.setCurVersion(versionIndex, newVerson);
      fileInfo.appendVersion(newVerson);
      fileInfo.set("unreadedCommentCount", 0);
      fileInfo.set("commentCount", 0);
      fileInfo.set("unreadFileCount", 0);
      fileInfo.set("lastModifyUserName", app.currentUser.getUserName());
      fileInfo.set("versionNo", res.versionNo);
      if (this.versionCollection) {
        this.versionCollection.setCurVersion(res.version);
        newVerson.setCurVersion(res.version);
        this.versionCollection.add(newVerson, {
          at: 0
        });
      }
      Dispatcher.trigger(MDEvents.REFRESH_VERSIONS, fileInfo.getFileId());
      // this.trigger(MDEvents.UPLOAD_FINISHED);
      this.set("state", MDUploadFile.states.boardDataReady);
      if (loadFinished) {
        loadFinished();
      }
      if (this.callback) {
        this.callback(fileInfo);
      }
    } else {
      var folderId = this.get("directory");
      if (folderId == app.currentFolder.getFileId()) {
        var callCount = 0;
        var getFileInfoFromServer = function getFileInfoFromServer() {
          var targetId = self.get("fileId");
          _MMNetDiskDataController["default"].getFileInfosFromServer([targetId], false, function s(fileInfos) {
            var fileInfo = null;
            if (fileInfos.length == 0) {
              if (window.app.currentUser.isAnonymous() || window.isMsAnonyBoxUploader) {
                // 由于匿名用户也不需要访问自己上传的文件，此处需要虚构一个 fileInfo
                fileInfo = self.createFakeFileInfo();
              } else {
                console.error("------ 第 " + ++callCount + " 次调用返回, 没有新上传的 fileInfo:" + targetId);
                if (callCount < 100) {
                  setTimeout(function () {
                    getFileInfoFromServer();
                  }, 1000);
                } else {
                  console.error("------ 结束！！！ 居然没有新上传的 fileInfo: " + targetId);
                }
                return;
              }
            } else {
              console.error("------ 第 " + ++callCount + " 次调用 获取到了上传的 fileInfo : " + targetId);
              fileInfo = fileInfos[0];
            }
            self.set("fileInfo", fileInfo);
            if (self.fileInforCollection && fileInfo.getParentFolderId() == app.currentFolder.getFileId()) {
              if (window.isMsboxUploadPage) {
                self.fileInforCollection.addFileBlowStickonTop(fileInfo);
              } else if (!app.pathRouter.isInSearch()) {
                self.fileInforCollection.addFileBlowStickonTop(fileInfo);
              }
            }
            // self.trigger(MDEvents.UPLOAD_FINISHED);
            self.set("state", MDUploadFile.states.boardDataReady);
            if (loadFinished) {
              loadFinished();
            }
            if (self.callback) {
              self.callback(fileInfo);
            }
          }, function f(e) {
            console.log("----------- error upload get file from server:", self.get("fileId"));
            self.set("state", MDUploadFile.states.error);
            self.set("errorcode", 0);
            if (loadFinished) {
              loadFinished();
            }
            // self.trigger(MDEvents.UPLOAD_FINISHED);
          });
        };
        setTimeout(function () {
          getFileInfoFromServer();
        }, 1000);
        self.set("fileInfo", fileInfo);
        if (app.pathRouter && self.fileInforCollection && !app.pathRouter.isInSearch()) {
          self.fileInforCollection.addFileBlowStickonTop(fileInfo);
        }
      } else {
        // self.trigger(MDEvents.UPLOAD_FINISHED);
        self.set("state", MDUploadFile.states.boardDataReady);
        if (loadFinished) {
          loadFinished();
        }
        if (self.callback) {
          self.callback(fileInfo);
        }
      }
    }
  },
  // 清除当前文件列表中等待后台处理的文件的等待标记
  _refreshWaitingStatusInFileList: function _refreshWaitingStatusInFileList(res, pageSize, fileSize, fileRefId) {
    var fileInfo = null;
    if (this.isNewVersion()) {
      var newVerson = new _MMVersionInfo["default"]({
        fileId: "0",
        ver: res.newVersion,
        createTime: Math.round(Date.now() / 1000),
        // some timestamp
        committerId: app.currentUser.getUserId(),
        committerName: app.currentUser.get("name"),
        fileSize: parseInt(fileSize)
      });
      fileInfo = this.get("fileInfo");
      console.assert(fileInfo);
      fileInfo.set("fileSize", parseInt(fileSize));
      fileInfo.set("latestVer", res.newVersion);
      fileInfo.setCurVersion(res.newVersion, newVerson);
      newVerson.setFileInfo(fileInfo);
      fileInfo.set("unreadedCommentCount", 0);
      fileInfo.set("commentCount", 0);
      fileInfo.set("unreadFileCount", 0);
      fileInfo.set("currentVersionSize", parseInt(fileSize));
      fileInfo.set("pdfPassword", res.pdfPassword);
      if (this.versionCollection) {
        this.versionCollection.setCurVersion(res.newVersion);
        newVerson.setCurVersion(res.newVersion);
        this.versionCollection.add(newVerson, {
          at: 0
        });
      }
      Dispatcher.trigger(MDEvents.REFRESH_VERSIONS, fileInfo.getFileId());
    } else {
      // new file
      var now = Date.now() / 1000;
      fileInfo = this.get("fileInfo");
      fileInfo.set("fileName", res.fileName);
      fileInfo.set("ctime", now);
      fileInfo.set("mtime", now);
      fileInfo.set("pdfPassword", res.pdfPassword);
    }
    fileInfo.setUploadStatus("finished");
  },
  notFinish: function notFinish() {
    var state = this.get("state");
    return state == MDUploadFile.states.uploading || state == MDUploadFile.states.notStarted;
  },
  uploaded: function uploaded() {
    var state = this.get("state");
    return state == MDUploadFile.states.uploaded || state == MDUploadFile.states.boardDataReady;
  },
  uploading: function uploading() {
    var state = this.get("state");
    return state == MDUploadFile.states.uploading;
  },
  cancelUpload: function cancelUpload() {
    if (this.get("state") == MDUploadFile.states.uploading) {
      this.abort();
    } else {
      this.set("state", MDUploadFile.states.abort);
    }
    var file = this.get("file");
    // if (file) {
    //   file['canceled'] = true;
    // };
  },
  reUpload: function reUpload() {
    if (this.get("file")) {
      this.set("id", this._generateId());
      this.startUpload();
    } else {
      this.reloadClient();
    }
  },
  reloadClient: function reloadClient() {
    var that = this;
    this.set("state", MDUploadFile.states.uploading);

    // client upload need to do
    var id = this.get("id");
  },
  abort: function abort(forClear) {
    if (this.get("state") === MDUploadFile.states.uploading) {
      if (!forClear) {
        this.set("state", MDUploadFile.states.abort);
      }
      var file = this.get("file");
      if (file) {
        file.blocked = true;
        if (file.xhr) {
          file.xhr.abort();
        } else if (file.fileReader) {
          file.fileReader.abort();
        } else {
          // stop after getting an upload URL
          // file.blocked = true;
        }
        if (file.monitorState) {
          clearTimeout(file.monitorState);
        }
        _.isFunction(this.onCancel) && this.onCancel();
      } else {
        // client upload need to do something
        var id = this.get("id");
      }
      if (this.version !== undefined) {
        _MMNetDiskDataController["default"].deleteFileById({
          fileId: this.get("fileId"),
          version: this.version
        }, function success() {}, function fail() {});
      }
    }
  },
  isCaneled: function isCaneled() {
    if (this.get("state") == MDUploadFile.states.abort) {
      return true;
    }
    return false;
  },
  remove: function remove() {
    this.abort();
    MDfileUploadList.list.remove(this);
  },
  uploadSuccessed: function uploadSuccessed() {
    var state = this.get("state");
    return state == MDUploadFile.states.boardDataReady;
  },
  createFakeFileInfo: function createFakeFileInfo() {
    var fileInfo = new _MMFileInfo["default"]();
    fileInfo.setFileId(window.uploadFileId++);
    fileInfo.setFileName(this.get("name"));
    fileInfo.set("type", _MMFileType["default"].FILE);
    fileInfo.set("currentVerCommitterId", 0);
    fileInfo.set("currentVersionSize", this.get("size"));
    fileInfo.set("fileSize", this.get("size"));
    fileInfo.set("ctime", new Date());
    fileInfo.setParentFolderId(app.currentFolder.getFileId());
    return fileInfo;
  }
});
MDUploadFile.states = {
  notStarted: "notStarted",
  // selected on the fileFinder or dropped, but not jet started uploading.
  uploading: "uploading",
  // while uplaod, you can display a progressbar
  abort: "abort",
  // started to upload, but stoped
  error: "error",
  // an error on any stage, the user has to select the file again to uplaod
  uploaded: "uploaded",
  // uploaded to the cloud, but not jet registered on pomelo, can't be abort anymore
  boardDataReady: "boardDataReady",
  clientError: "clientError"
};
window.blockSize = 1024 * 1024 * 16;
window.uploadFileId = 0;
MDUploadFile.idCount = 0;
var _default = exports["default"] = MDUploadFile;

},{"1087":1087,"1098":1098,"1104":1104,"1172":1172,"1184":1184,"1199":1199,"1411":1411,"1412":1412,"1423":1423,"1435":1435,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1466":1466,"1477":1477,"1480":1480,"1487":1487,"1489":1489,"1505":1505,"1506":1506,"1507":1507,"1508":1508,"1509":1509,"1510":1510,"1512":1512,"1513":1513,"1514":1514,"1516":1516,"1517":1517,"1518":1518,"1519":1519,"1520":1520,"1521":1521,"1522":1522,"1523":1523,"1524":1524,"1525":1525,"1526":1526,"1527":1527,"1528":1528,"1529":1529,"1530":1530,"1538":1538,"1541":1541,"21":21,"297":297,"303":303,"310":310,"32":32,"348":348,"525":525}],525:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDWindowView = _interopRequireDefault(require(93));
var _MDKnowProfessWindowView = _interopRequireDefault(require(505));
/**
 *  free update window
 *  Created by dai
 *  2017.3.2
 */

var MDUpdatePromptWindowView = _MDWindowView["default"].extend({
  contentTmpl: '<div>' + '<%= content %>' + '</div>',
  className: function className() {
    var superCls = _MDWindowView["default"].prototype.className.call(this);
    return superCls + " update-prompt-window";
  },
  initProps: function initProps() {
    var superP = _MDWindowView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      title: BabelStr.str(170)
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    var content = opt.content;
    /*content = '巴别鸟免费版存储空间最大为50G, 你可以删掉部分不用的文件, 或是升级当前账户为专业版';
    content = '很抱歉, 巴别鸟免费版只能创建2个团队, 要创建更多团队, 请升级至专业版';
    content = '很抱歉, 巴别鸟免费版只能预览2个CAD及2个3D文件, 升级至专业版可以无限制预览所有巴别鸟支持的文件';
    opt.title = '空间已满';*/

    opt.data = {
      'content': content
    };
    opt.width = 560;
    opt.buttonsAlign = 'center';
    opt.needVerticalMiddleAlign = true;
    opt.buttons = [{
      label: BabelStr.str(47),
      type: 'done',
      onClick: function onClick() {
        self._updateToProfess();
      }
    }, {
      label: BabelStr.str(7260),
      onClick: function onClick() {
        self._knowProfess();
      }
    }];
    _MDWindowView["default"].prototype.initialize.call(this, opt);
  },
  _updateToProfess: function _updateToProfess() {
    location.href = "/payment/upgrade.do";
  },
  _knowProfess: function _knowProfess() {
    var win = new _MDKnowProfessWindowView["default"]();
    win.show();
  }
});
var _default = exports["default"] = MDUpdatePromptWindowView;

},{"1184":1184,"1454":1454,"505":505,"93":93}],505:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDWindowView = _interopRequireDefault(require(93));
/**
 *  know profess window
 *  Created by dai
 *  2017.3.2
 */

var MDKnowProfessWindowView = _MDWindowView["default"].extend({
  contentTmpl: '<div class="head">' + BabelStr.str(7251) + '</div>' + '<ul class="feature-list">' + '<li>' + BabelStr.str(7252) + '</li>' + '<li>' + BabelStr.str(7253) + '</li>' + '<li>' + BabelStr.str(7254) + '</li>' + '<li>' + BabelStr.str(7255) + '</li>' + '<li>' + BabelStr.str(7256) + '</li>' + '<li>' + BabelStr.str(7257) + '</li>' + '<li>' + BabelStr.str(7258) + '</li>' + '<li>' + BabelStr.str(7259) + '</li>' + '</ul>',
  className: function className() {
    var superCls = _MDWindowView["default"].prototype.className.call(this);
    return superCls + " know-profess-window";
  },
  initProps: function initProps() {
    var superP = _MDWindowView["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      needVerticalMiddleAlign: true
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    opt.title = BabelStr.str(7260);
    opt.width = 500;
    opt.buttonsAlign = 'center';
    opt.buttons = [{
      label: BabelStr.str(47),
      type: 'done',
      onClick: function onClick() {
        self._updateToProfess();
      }
    }];
    _MDWindowView["default"].prototype.initialize.call(this, opt);
  },
  _updateToProfess: function _updateToProfess() {
    location.href = "/payment/upgrade.do";
  }
});
var _default = exports["default"] = MDKnowProfessWindowView;

},{"1184":1184,"1454":1454,"93":93}],348:[function(require,module,exports){
"use strict";

require(1461);
require(1503);
require(1415);
require(1456);
require(1418);
require(1537);
require(1457);
require(1453);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require(1199));
require(1439);
require(1429);
require(1412);
require(1463);
require(1471);
require(1423);
require(1487);
require(1538);
require(1545);
require(1543);
require(1541);
require(1430);
require(1482);
require(1496);
require(1450);
var _asyncToGenerator2 = _interopRequireDefault(require(1172));
var _defineProperty2 = _interopRequireDefault(require(1180));
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * videoThumb.js - 视频缩略图提取核心模块
 * 专注提取缩略图，失败返回null
 */
var VideoThumbnailExtractor = /*#__PURE__*/function () {
  function VideoThumbnailExtractor() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2["default"])(this, VideoThumbnailExtractor);
    this.config = _objectSpread({
      // 加载策略
      smallFileThreshold: 20 * 1024 * 1024,
      // 20MB以下算小文件
      initialChunkSize: 3 * 1024 * 1024,
      // 初始加载3MB
      maxChunkSize: 10 * 1024 * 1024,
      // 最大加载10MB
      maxFileThumbSize: 500 * 1024 * 1024,
      // 最多完整加载500M
      // 处理参数
      timeout: 10000,
      // 10秒超时
      thumbnailWidth: 300,
      thumbnailQuality: 0.85,
      minBrightness: 15,
      // 尝试策略
      attemptPoints: [0.1, 0.3, 0.5, 1, 2, 3],
      // 时间点
      maxAttempts: 6,
      // 调试
      debug: true
    }, options);
  }

  /**
   * 主方法：提取缩略图
   * @param {File} file - 视频文件
   * @returns {Promise<string|null>} - 缩略图dataURL或null
   */
  (0, _createClass2["default"])(VideoThumbnailExtractor, [{
    key: "extract",
    value: (function () {
      var _extract = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(file) {
        var thumbnail;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              console.log("[VideoThumb] \u5F00\u59CB\u5904\u7406: ".concat(file.name));

              // 验证文件
              if (this._isValidVideoFile(file)) {
                _context.next = 5;
                break;
              }
              console.warn("[VideoThumb] \u65E0\u6548\u7684\u89C6\u9891\u6587\u4EF6: ".concat(file.type));
              return _context.abrupt("return", null);
            case 5:
              if (!(file.size <= this.config.smallFileThreshold)) {
                _context.next = 12;
                break;
              }
              console.log("[VideoThumb] \u5C0F\u6587\u4EF6\uFF0C\u52A0\u8F7D\u5B8C\u6574\u6587\u4EF6");
              _context.next = 9;
              return this._processSmallFile(file);
            case 9:
              thumbnail = _context.sent;
              _context.next = 21;
              break;
            case 12:
              console.log("[VideoThumb] \u5927\u6587\u4EF6\uFF0C\u52A0\u8F7D\u6587\u4EF6\u5934\u90E8");
              _context.next = 15;
              return this._processLargeFile(file);
            case 15:
              thumbnail = _context.sent;
              if (!(!thumbnail && file.size < this.config.maxFileThumbSize)) {
                _context.next = 21;
                break;
              }
              console.log("尝试加载全部文件");
              //尝试加载全部文件
              _context.next = 20;
              return this._processSmallFile(file);
            case 20:
              thumbnail = _context.sent;
            case 21:
              if (!thumbnail) {
                _context.next = 26;
                break;
              }
              console.log("[VideoThumb] \u63D0\u53D6\u6210\u529F: ".concat(file.name));
              return _context.abrupt("return", thumbnail);
            case 26:
              console.warn("[VideoThumb] \u63D0\u53D6\u5931\u8D25: ".concat(file.name));
              return _context.abrupt("return", null);
            case 28:
              _context.next = 34;
              break;
            case 30:
              _context.prev = 30;
              _context.t0 = _context["catch"](0);
              console.error("[VideoThumb] \u5904\u7406\u5F02\u5E38: ".concat(_context.t0.message));
              return _context.abrupt("return", null);
            case 34:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 30]]);
      }));
      function extract(_x) {
        return _extract.apply(this, arguments);
      }
      return extract;
    }()
    /**
     * 处理小文件（完整加载）
     */
    )
  }, {
    key: "_processSmallFile",
    value: (function () {
      var _processSmallFile2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(file) {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this._extractFromBlob(file));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function _processSmallFile(_x2) {
        return _processSmallFile2.apply(this, arguments);
      }
      return _processSmallFile;
    }()
    /**
     * 处理大文件（只加载头部）
     */
    )
  }, {
    key: "_processLargeFile",
    value: (function () {
      var _processLargeFile2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(file) {
        var chunkSizes, _i, _chunkSizes, chunkSize, chunk, thumbnail;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              // 尝试不同大小的数据块
              chunkSizes = [this.config.initialChunkSize, this.config.maxChunkSize, Math.min(file.size, this.config.maxChunkSize * 2)];
              _i = 0, _chunkSizes = chunkSizes;
            case 2:
              if (!(_i < _chunkSizes.length)) {
                _context3.next = 21;
                break;
              }
              chunkSize = _chunkSizes[_i];
              _context3.prev = 4;
              console.log("[VideoThumb] \u5C1D\u8BD5\u52A0\u8F7D ".concat(this._formatSize(chunkSize)));
              chunk = file.slice(0, chunkSize);
              _context3.next = 9;
              return this._extractFromBlob(chunk);
            case 9:
              thumbnail = _context3.sent;
              if (!thumbnail) {
                _context3.next = 12;
                break;
              }
              return _context3.abrupt("return", thumbnail);
            case 12:
              _context3.next = 18;
              break;
            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](4);
              console.log("[VideoThumb] ".concat(this._formatSize(chunkSize), " \u5931\u8D25: ").concat(_context3.t0.message));
              return _context3.abrupt("continue", 18);
            case 18:
              _i++;
              _context3.next = 2;
              break;
            case 21:
              return _context3.abrupt("return", null);
            case 22:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[4, 14]]);
      }));
      function _processLargeFile(_x3) {
        return _processLargeFile2.apply(this, arguments);
      }
      return _processLargeFile;
    }()
    /**
     * 从Blob提取缩略图
     */
    )
  }, {
    key: "_extractFromBlob",
    value: (function () {
      var _extractFromBlob2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(blob) {
        var _this = this;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", new Promise(function (resolve, reject) {
                var video = document.createElement('video');
                var url = URL.createObjectURL(blob);
                video.src = url;
                video.muted = true;
                video.playsInline = true;
                video.crossOrigin = 'anonymous';
                video.preload = 'metadata';
                var attempts = 0;

                // 清理函数
                var cleanup = function cleanup() {
                  URL.revokeObjectURL(url);
                  video.src = '';
                  video.load();
                  if (video.parentNode) {
                    video.parentNode.removeChild(video);
                  }
                };

                // 超时处理
                var timeoutId = setTimeout(function () {
                  cleanup();
                  reject(new Error('提取超时'));
                }, _this.config.timeout);

                // 尝试捕获帧
                var tryCaptureFrame = function tryCaptureFrame() {
                  attempts++;
                  if (attempts > _this.config.maxAttempts) {
                    cleanup();
                    clearTimeout(timeoutId);
                    reject(new Error('达到最大尝试次数'));
                    return;
                  }
                  var timePoint = _this.config.attemptPoints[attempts - 1];
                  if (timePoint === undefined) {
                    cleanup();
                    clearTimeout(timeoutId);
                    reject(new Error('没有更多时间点可尝试'));
                    return;
                  }
                  video.currentTime = timePoint;
                  var onSeeked = function onSeeked() {
                    video.removeEventListener('seeked', onSeeked);
                    setTimeout(function () {
                      try {
                        var canvas = document.createElement('canvas');
                        var ctx = canvas.getContext('2d');

                        // 设置画布尺寸
                        var targetWidth = _this.config.thumbnailWidth;
                        var targetHeight = video.videoHeight ? video.videoHeight * targetWidth / video.videoWidth : targetWidth * 0.75;
                        canvas.width = targetWidth;
                        canvas.height = targetHeight;

                        // 绘制视频帧
                        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

                        // 验证图像
                        var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                        if (_this._isValidImage(imageData)) {
                          var thumbnail = canvas.toDataURL('image/jpeg', _this.config.thumbnailQuality);
                          cleanup();
                          clearTimeout(timeoutId);
                          resolve(thumbnail);
                        } else {
                          setTimeout(tryCaptureFrame, 50);
                        }
                      } catch (error) {
                        setTimeout(tryCaptureFrame, 50);
                      }
                    }, 100);
                  };
                  video.addEventListener('seeked', onSeeked, {
                    once: true
                  });

                  // 跳转超时
                  setTimeout(function () {
                    video.removeEventListener('seeked', onSeeked);
                    if (video.readyState >= 2) {
                      setTimeout(tryCaptureFrame, 50);
                    }
                  }, 2000);
                };

                // 视频元数据加载成功
                video.addEventListener('loadedmetadata', function () {
                  if (video.videoWidth === 0 || video.videoHeight === 0) {
                    cleanup();
                    clearTimeout(timeoutId);
                    reject(new Error('视频尺寸为0'));
                    return;
                  }

                  // 开始尝试捕获
                  setTimeout(tryCaptureFrame, 200);
                });

                // 视频加载错误
                video.addEventListener('error', function () {
                  cleanup();
                  clearTimeout(timeoutId);
                  reject(new Error('视频加载失败'));
                });

                // 添加到DOM（有助于加载）
                video.style.display = 'none';
                document.body.appendChild(video);

                // 开始加载
                video.load();
              }));
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function _extractFromBlob(_x4) {
        return _extractFromBlob2.apply(this, arguments);
      }
      return _extractFromBlob;
    }()
    /**
     * 验证图像有效性
     */
    )
  }, {
    key: "_isValidImage",
    value: function _isValidImage(imageData) {
      var data = imageData.data;
      var total = 0;
      var count = 0;

      // 采样检测亮度
      for (var i = 0; i < data.length; i += 64 * 4) {
        var r = data[i];
        var g = data[i + 1];
        var b = data[i + 2];
        var brightness = 0.299 * r + 0.587 * g + 0.114 * b;
        total += brightness;
        count++;
      }
      var avgBrightness = count > 0 ? total / count : 0;
      return avgBrightness > this.config.minBrightness;
    }

    /**
     * 验证视频文件
     */
  }, {
    key: "_isValidVideoFile",
    value: function _isValidVideoFile(file) {
      if (!file || file.size === 0) return false;
      var type = (file.type || '').toLowerCase();
      var name = (file.name || '').toLowerCase();

      // 常见视频扩展名
      var videoExts = ['.mp4', '.webm', '.ogg', '.mov', '.avi', '.mkv', '.flv', '.wmv', '.3gp', '.m4v'];
      var hasVideoExt = videoExts.some(function (ext) {
        return name.endsWith(ext);
      });

      // 视频MIME类型或未知类型
      return type.startsWith('video/') || type === 'application/octet-stream' || hasVideoExt;
    }

    /**
     * 格式化文件大小
     */
  }, {
    key: "_formatSize",
    value: function _formatSize(bytes) {
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    }
  }]);
  return VideoThumbnailExtractor;
}();
/**
 * 导出单例
 */
var videoThumbnailExtractor = new VideoThumbnailExtractor();
var _default = exports["default"] = videoThumbnailExtractor;

},{"1172":1172,"1175":1175,"1179":1179,"1180":1180,"1184":1184,"1199":1199,"1412":1412,"1415":1415,"1418":1418,"1423":1423,"1429":1429,"1430":1430,"1439":1439,"1450":1450,"1453":1453,"1454":1454,"1456":1456,"1457":1457,"1461":1461,"1463":1463,"1471":1471,"1482":1482,"1487":1487,"1496":1496,"1503":1503,"1537":1537,"1538":1538,"1541":1541,"1543":1543,"1545":1545}],1482:[function(require,module,exports){
'use strict';
var $ = require(1270);
var uncurryThis = require(1280);
var getOwnPropertyDescriptor = require(1329).f;
var toLength = require(1386);
var toString = require(1393);
var notARegExp = require(1322);
var requireObjectCoercible = require(1359);
var correctIsRegExpLogic = require(1239);
var IS_PURE = require(1308);

// eslint-disable-next-line es/no-string-prototype-endswith -- safe
var nativeEndsWith = uncurryThis(''.endsWith);
var slice = uncurryThis(''.slice);
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('endsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'endsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = toString(requireObjectCoercible(this));
    notARegExp(searchString);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = that.length;
    var end = endPosition === undefined ? len : min(toLength(endPosition), len);
    var search = toString(searchString);
    return nativeEndsWith
      ? nativeEndsWith(that, search, end)
      : slice(that, end - search.length, end) === search;
  }
});

},{"1239":1239,"1270":1270,"1280":1280,"1308":1308,"1322":1322,"1329":1329,"1359":1359,"1386":1386,"1393":1393}],315:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var MDBrowserNotificator = function () {
  /**
   * modified version of the notifyMe method from: https://developer.mozilla.org/en-US/docs/Web/API/notification
   */
  function notifyMe(options) {
    // theBody, theIcon, theTitle, callback) {
    // Let's check if the browser supports notifications
    if (!("Notification" in window)) {
      //alert("This browser does not support desktop notification");
      return;
    }

    // Let's check if the user is okay to get some notification
    else if (Notification.permission === "granted") {
      // If it's okay let's create a notification
      spawnNotification(options);
    }

    // Otherwise, we need to ask the user for permission
    else if (Notification.permission !== 'denied') {
      Notification.requestPermission(function (permission) {
        // If the user is okay, let's create a notification
        if (permission === "granted") {
          spawnNotification(options);
        }
      });
    }

    // At last, if the user already denied any notification, and you
    // want to be respectful there is no need to bother them any more.
  }

  /**
   * modified version from https://developer.mozilla.org/en-US/docs/Web/API/notification
   * this one allowes a callback for click on the notification
   */
  function spawnNotification(options) {
    // theBody, theIcon, theTitle, callback) {}
    var nOptions = {
      body: options.body,
      icon: options.icon
    };
    console.log('show Notification', options);
    var n = new Notification(options.title, nOptions);
    n.addEventListener('click', options.callback);
    MDBrowserNotificator._displayed[options.signature] = n;
    if (options.type) {
      MDBrowserNotificator._notification[options.type] = n;
      n.addEventListener('close', function () {
        if (MDBrowserNotificator._notification[options.type] === n) MDBrowserNotificator._notification[options.type] = null;
        delete MDBrowserNotificator._displayed[options.signature];
      });
    }
  }
  return {
    c: 0,
    _notification: {},
    _displayed: {},
    /**
     * the notifyMethod for the app.
     * it takes an options object as parameter
     * options.type: used to not fire to often,(during a chat, it is enought to display one newmessage notification at once)
     * options.body: the body text
     * options.title:the title text
     * options.callback: method that will be executed when the notification is clicked
     *                      (focus the window is already done);
     * options.icon: to display an image, Usefull when a new image was published, by default is the babelBird
     *
     */
    notify: function notify(options) {
      if (options.type) {
        if (MDBrowserNotificator._notification[options.type]) {
          var notification = MDBrowserNotificator._notification[options.type];
          setBabelTimeout(function () {
            notification.close();
          }, 1);
        }
      }
      options.body = options.body || '';
      options.icon = options.icon || '/img/babel_ntf.png';
      options.title = options.title || 'babelbird';
      var signature = MDBrowserNotificator.getSignature(options);
      if (MDBrowserNotificator._displayed[signature]) {
        return;
      }
      var callback = options.callback;
      options.callback = function () {
        window.focus();
        delete MDBrowserNotificator._displayed[signature];
        if (options.type) {
          MDBrowserNotificator._notification[options.type] = null;
        }
        if (callback) {
          callback();
        }
      };
      notifyMe(options);
    },
    getSignature: function getSignature(options) {
      if (!options.signature) {
        options.signature = JSON.stringify(options);
      }
      return options.signature;
    }
  };
}();
var _default = exports["default"] = MDBrowserNotificator;

},{"1454":1454}],285:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMCollectionBase = _interopRequireDefault(require(20));
var _MDShareParticipant = _interopRequireDefault(require(284));
var MDShareParticipantCollection = _MMCollectionBase["default"].extend({
  model: _MDShareParticipant["default"]
});
var _default = exports["default"] = MDShareParticipantCollection;

},{"1184":1184,"1454":1454,"20":20,"284":284}],284:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDPerformer = _interopRequireDefault(require(278));
var MDShareParticipant = _MDPerformer["default"].extend({
  idAttribute: 'email',
  defaults: {
    "userId": "",
    "shareId": ""
  },
  getUserId: function getUserId() {
    var uid = this.get('userId');
    if (!uid) {
      uid = this.get('id');
    }
    ;
    return uid;
  },
  setUserId: function setUserId(id) {
    this.set('userId', id);
  },
  getShareId: function getShareId() {
    return this.get('shareId');
  },
  setShareId: function setShareId(id) {
    this.set('shareId', id);
  },
  isInvited: function isInvited() {
    return this.get('invited');
  }
});
var _default = exports["default"] = MDShareParticipant;

},{"1184":1184,"1454":1454,"278":278}],278:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMModelBase = _interopRequireDefault(require(21));
var _regexp = _interopRequireDefault(require(106));
var MDPerformer = _MMModelBase["default"].extend({
  defaults: function defaults() {
    return {
      "mail": "",
      "alias": "",
      "description": "",
      "memberShip": "",
      "roleId": "",
      "roleName": "",
      "permission": 1,
      "disabled": false,
      "hint": ""
    };
  },
  getMail: function getMail() {
    var mail = this.get('mail');
    if (!mail) {
      mail = this.get('email');
    }
    ;
    if (!_regexp["default"].isEmail(mail)) {
      mail = '--';
    }
    return mail;
  },
  setMail: function setMail(mail) {
    this.set('mail', mail);
  },
  getAlias: function getAlias() {
    return this.get('alias');
  },
  setAlias: function setAlias(alias) {
    this.set('alias', alias);
  },
  getDescription: function getDescription() {
    return this.get('description');
  },
  setDescription: function setDescription(description) {
    this.set('description', description);
  },
  getMembership: function getMembership() {
    return this.get('memberShip');
  },
  setMembership: function setMembership(memberShip) {
    this.set('memberShip', memberShip);
  },
  getRoleId: function getRoleId() {
    return this.get('roleId');
  },
  setRoleId: function setRoleId(roleId) {
    this.set('roleId', roleId);
  },
  getRoleName: function getRoleName() {
    return this.get('roleName');
  },
  setRoleName: function setRoleName(name) {
    this.set('roleName', name);
  },
  toJSON: function toJSON() {
    var json = _.clone(this.attributes);
    json['mail'] = this.getMail();
    json.cid = this.cid;
    return json;
  },
  setRoleInfo: function setRoleInfo(roleInfo) {
    this.setRoleId(roleInfo.getRoleId());
    this.setRoleName(roleInfo.getRoleName);
    this.set('permission', roleInfo.getPermission());
  }
});
var _default = exports["default"] = MDPerformer;

},{"106":106,"1184":1184,"1454":1454,"21":21}],270:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMModelBase = _interopRequireDefault(require(21));
var _MDMessageType = _interopRequireDefault(require(271));
//
// 消息对象类型
// Created by manjun.han
// 2016.11.9
//

/* eslint-disable no-fallthrough */

var MDMessage = _MMModelBase["default"].extend({
  defaults: {
    'type': -1,
    'category': 0,
    /**
     * @type { string | Backbone.Model | object}
     */
    'msg': null
  },
  getCategory: function getCategory() {
    return this.get('category');
  },
  isConversition: function isConversition() {
    return this.getCategory() & 1;
  },
  isDashboard: function isDashboard() {
    return this.getCategory() & 2;
  },
  isNotification: function isNotification() {
    return this.getCategory() & 4;
  },
  isDashboardFileMessage: function isDashboardFileMessage() {
    if (!this.isDashboard()) {
      return false;
    }
    if (this.isDashboardAtmeMessage()) {
      return false;
    }
    var type = this.get('type');
    switch (type) {
      case _MDMessageType["default"].CREATE:
      case _MDMessageType["default"].NEW_VERSION:
      case _MDMessageType["default"].RENAME:
      case _MDMessageType["default"].MOVE:
      case _MDMessageType["default"].DELETE:
      case _MDMessageType["default"].RESTORE:
      case _MDMessageType["default"].MOVE_IN:
      case _MDMessageType["default"].MOVE_OUT:
      case _MDMessageType["default"].SET_CURRENT_VERSION:
      case _MDMessageType["default"].COPY:
      case _MDMessageType["default"].JOIN_SHARE:
      case _MDMessageType["default"].LEAVE_SHARE:
      case _MDMessageType["default"].STOP_SHARE:
      case _MDMessageType["default"].INVITATION:
      case _MDMessageType["default"].REMOVE_INVITATION:
      case _MDMessageType["default"].SET_SHARE_DEFAULT_ROLE:
      case _MDMessageType["default"].SET_USER_ROLE:
      case _MDMessageType["default"].KICK_FROM_SHARE:
      case _MDMessageType["default"].OPEN_LINK:
      case _MDMessageType["default"].CLOSE_LINK:
      case _MDMessageType["default"].MODIFY_LINK_LEVEL:
      case _MDMessageType["default"].FILEREVIEW_CREATE:
        return true;
    }
  },
  isDashboardCommentMessage: function isDashboardCommentMessage() {
    if (!this.isDashboard()) {
      return false;
    }
    if (this.isDashboardAtmeMessage()) {
      return false;
    }
    var type = this.get('type');
    switch (type) {
      case _MDMessageType["default"].COMMENT_CREATED:
      case _MDMessageType["default"].COMMENT_CHAT:
      case _MDMessageType["default"].COMMENT_DELETE:
      case _MDMessageType["default"].COMMENT_COMPLETED:
      case _MDMessageType["default"].COMMENT_PRAISE:
      case _MDMessageType["default"].COMMENT_UNCOMPLETED:
      case _MDMessageType["default"].CHAT:
        return true;
    }
    return false;
  },
  isDashboardAtmeMessage: function isDashboardAtmeMessage() {
    if (!this.isDashboard()) {
      return false;
    }
    var atArr;
    var type = this.get('type');
    var atFlag = false;
    switch (type) {
      case _MDMessageType["default"].COMMENT_CHAT:
        atArr = this.get('msg').get('atMeUserIds');
        if (atArr.length > 0) {
          _.each(atArr, function (value) {
            if (value === app.currentUser.getId()) {
              atFlag = true;
            }
          });
        }
        break;
      case _MDMessageType["default"].FILEREVIEW_CREATE:
        atArr = this.get('msg').get('content')['atIds'];
        if (atArr === 'All') {
          atFlag = true;
        }
        if (atArr && atArr.length > 0) {
          _.each(atArr, function (value) {
            if (value === app.currentUser.getId()) {
              atFlag = true;
            }
          });
        }
        break;
    }
    return atFlag;
  }
});
var _default = exports["default"] = MDMessage;

},{"1184":1184,"1454":1454,"21":21,"271":271}],271:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  CREATE: 1,
  // create dir
  NEW_VERSION: 2,
  // 上传新版本
  RENAME: 3,
  MOVE: 4,
  //分享文件夹内部移动，入从文件A中移动到A.B中（B是A的子文件夹）
  DELETE: 5,
  RESTORE: 6,
  MOVE_IN: 7,
  //向文件夹中移入某一文件夹
  MOVE_OUT: 8,
  //从文件夹中移出某一文件
  SET_CURRENT_VERSION: 9,
  // UPLOAD_VERSION: 10, // not used ??
  MULTI_UPLOAD: 11,
  COPY: 12,
  PRAISE_FILE: 13,
  JOIN_SHARE: 31,
  LEAVE_SHARE: 32,
  SHARE: 33,
  STOP_SHARE: 34,
  INVITATION: 35,
  REMOVE_INVITATION: 36,
  SET_SHARE_DEFAULT_ROLE: 37,
  SET_USER_ROLE: 38,
  KICK_FROM_SHARE: 39,
  OPEN_LINK: 40,
  // new 10/2016
  CLOSE_LINK: 41,
  // new 10/2016
  MODIFY_LINK_LEVEL: 42,
  // new 10/2016
  ACCEPT_OR_DENY_INVITATION: 43,
  // new 11/2016
  REMOVED_TEAM_INVITATION_APPLICATION: 44,
  // new 02/2017

  FOCUS_FILE: 47,
  // new 06/2017
  REMOVE_FOCUS_FILE: 48,
  // new 06/2017

  COMMENT_CREATED: 51,
  COMMENT_CHAT: 52,
  COMMENT_DELETE: 53,
  COMMENT_COMPLETED: 54,
  COMMENT_PRAISE: 55,
  COMMENT_UNCOMPLETED: 56,
  PEN_DRAW: 57,
  PEN_REMOVE: 58,
  UNDO_COMMENT_CHAT: 59,
  DEPARTMENT_ADDMEMBER: 61,
  DEPARTMENT_UPDATE: 62,
  DEPARTMENT_REMOVE_MEMBER: 63,
  DEPARTMENT_UPDATE_MEMBER: 64,
  DEPARTMENT_CREATE: 65,
  DEPARTMENT_REMOVE: 67,
  FILEREVIEW_CREATE: 76,
  EP_ROLE_CHANGED: 82,
  CHAT: 101,
  SET_VERSION_LOG: 112,
  LOCK_FILE: 113,
  UNLOCK_FILE: 114,
  APPEND_FILE_PERMISSION: 116,
  REMOVE_FILE_PERMISSION: 117,
  REQUEST_LINK_SHARE: 201,
  // new 10/2016
  REQUEST_INVITE_SHARE: 202,
  // new 10/2016

  PAYMENT_MESSAGE: 301,
  INVITE_CONTRIBUTOR: 309,
  // ------------------ 文件收集箱邀请投件人的通知
  INVITE_EVALUATION: 302,
  // 邀请参与审批的消息
  EVALUATION_PASS: 303,
  EVALUATION_REJECT: 304,
  ENTERPRISE_BROADCAST: 306,
  FILE_USER_EVLUATION: 307,
  //用户审批文件
  SALON: 308,
  //沙龙消息

  EVALUATION_COPYTO: 310,
  DESTINATION_FILE: 321,
  ARCHIVEDFILE: 322,
  BORROW_APPLY: 323,
  APPLY_PASSED: 324,
  APPLY_REFUSED: 325,
  SHIFTFILEMANAGER: 326,
  JOIN_PROJECT: 328,
  PROJECT_SHIFT_INFO: 327,
  CLEAR_EVALUATION: 311,
  EVALUATION_ADDUSER: 312,
  // 临时添加评审人

  MSBOX_FILE_RECEIVE: 341,
  // 接受稿件
  MSBOX_FILE_REJECT: 342,
  // 退回稿件

  FILE_SIGNATURE_CREATED: 360,
  FILE_SIGNATURE_UPDATED: 361,
  FILE_SIGNATURE_DELETED: 362,
  PROJECT_CREATE: 376,
  TRANSMITTAL_PROJECT_CREATE: 377,
  SHARE_LINK_OUT_OF_DATE: 380,
  CREATE_SNAP_SHARE: 398,
  Send_File: 402,
  MONITOR_ALERT: 403,
  // --------------- 监控警报

  SEND_FILE_REVIEW: 410,
  // 发送文件的审批

  CREATE_MATERIAL_CLASS_OR_FOLDER: 420,
  // 创建素材分类或文件夹
  MODIFY_MATERIAL_CLASS_OR_FOLDER: 421,
  // 修改素材分类或文件夹
  UPDATE_LINK_FILE: 422,
  // 更新链接文件

  MULTI_MODIFY_MATERIAL_CLASS_OR_FOLDER: 427,
  // 批量修改素材分类或文件夹

  DOWNLOAD_SEAL_FILE: 430,
  CREATE_CLASS: 431
};

},{"1454":1454}],263:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMModelBase = _interopRequireDefault(require(21));
var MDLevel = _MMModelBase["default"].extend({
  defaults: {
    'id': 0,
    'level': -1,
    'name': "",
    'price': "",
    'totalSpace': "",
    'inviteUpper': ""
  },
  getId: function getId() {
    return this.get("id");
  },
  setLevel: function setLevel(newLevel) {
    return this.set("level", newLevel);
  },
  getLevel: function getLevel() {
    return this.get("level");
  },
  setName: function setName(newLevel) {
    return this.set("name", newLevel);
  },
  getName: function getName() {
    return this.get("name");
  },
  setPrice: function setPrice(newPrice) {
    return this.set("price", newPrice);
  },
  getPrice: function getPrice() {
    return this.get("price");
  },
  setTotalSpace: function setTotalSpace(newTotalSpace) {
    return this.set("totalSpace", newTotalSpace);
  },
  getTotalSpace: function getTotalSpace() {
    return this.get("totalSpace");
  },
  setInviteUpper: function setInviteUpper(newInviteUpper) {
    return this.set("inviteUpper", newInviteUpper);
  },
  getInviteUpper: function getInviteUpper() {
    return this.get("inviteUpper");
  }
});
var _default = exports["default"] = MDLevel;

},{"1184":1184,"1454":1454,"21":21}],252:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
var _MMModelBase = _interopRequireDefault(require(21));
var _MDEvalStep = _interopRequireDefault(require(250));
var _MMFileInfo = _interopRequireDefault(require(297));
var MDEvaluationFlowInfo = _MMModelBase["default"].extend({
  defaults: {
    'evaluationFlowId': null,
    'name': null,
    'creatorId': null,
    'creatorName': null,
    'comment': null,
    'curStep': 0,
    'endTime': null,
    'steps': [],
    'finalizedStep': null,
    'files': []
  },
  getSteps: function getSteps() {
    return this.get("steps");
  },
  getProgress: function getProgress() {
    var stepCount = this.getEvaluationStepCount();
    var curStep = this.getCurStep();
    var stepPer = curStep / stepCount;
    var steps = this.getSteps();
    var curStepInfo = steps[curStep];
    var evaluatorCount = curStepInfo.get('evaluators') && curStepInfo.get('evaluators').length || 0;
    var minNumPer = curStepInfo.get('minNum') / 100 || 1;
    var curStepNeededPassedUserCount = Math.ceil(evaluatorCount * minNumPer);
    var curStepPassedUserCount = 0;
    _.each(curStepInfo.get('evaluators'), function (item) {
      if (item.getEvaluation() == 12) {
        curStepPassedUserCount++;
      }
    });
    if (curStepNeededPassedUserCount == 0) {
      curStepNeededPassedUserCount = 1;
    }
    var curStepPassedPer = curStepPassedUserCount / curStepNeededPassedUserCount / stepCount;
    curStepPassedPer = curStepPassedPer > 1 ? 1 : curStepPassedPer;
    var result = (stepPer + curStepPassedPer) * 100;
    result = Math.ceil(result);
    result = result > 100 ? 100 : result;
    return result;
  },
  getEvaluationStepCount: function getEvaluationStepCount() {
    return this.getSteps().length;
  },
  getCompletedTimeStr: function getCompletedTimeStr() {
    var completedTime = this.get('completedTime');
    if (!completedTime) {
      return '';
    } else {
      return new Date(completedTime * 1000).format('yyyy-MM-dd');
    }
  },
  getFinalizedStep: function getFinalizedStep() {
    return this.get("finalizedStep");
  },
  getForEnterprise: function getForEnterprise() {
    return this.get("forEnterprise");
  },
  setId: function setId(id) {
    this.set('id', id);
  },
  getId: function getId() {
    return this.get('evaluationFlowId');
  },
  getFiles: function getFiles() {
    return this.get('files');
  },
  getName: function getName() {
    return this.get('name');
  },
  setName: function setName(name) {
    this.set('name', name);
  },
  getComment: function getComment() {
    return this.get('comment');
  },
  setComment: function setComment(commentStr) {
    this.set('comment', commentStr);
  },
  getCurStep: function getCurStep() {
    return this.get('curStep');
  },
  setCurStep: function setCurStep(step) {
    this.set('curStep', step);
  },
  getEndTime: function getEndTime() {
    return this.get('endTime');
  },
  setEndTime: function setEndTime(time) {
    this.set('endTime', time);
  },
  getCreateTime: function getCreateTime() {
    return this.get('time');
  },
  // getEvaluationGroups: function() {
  //   return this.get('evaluationGroups');
  // },

  // setEvaluationGroups: function(groups) {
  //   this.set('evaluationGroups', groups);
  // },

  // getEvaluatorGroups: function() {
  //   return this.get('evaluatorGroups');
  // },

  // setEvaluatorGroups: function(groups) {
  //   this.set('evaluatorGroups', groups);
  // },

  getCopyToGroups: function getCopyToGroups() {
    return this.get('copyToGroups');
  },
  setCopyToGroups: function setCopyToGroups(groups) {
    this.set('copyToGroups', groups);
  },
  hasRejectEval: function hasRejectEval() {
    var curStep = this.getCurStep();
    var steps = this.get('steps');
    if (curStep >= steps.length) {
      return false;
    }
    ;
    var evaluations = steps[curStep].get('evaluators');
    for (var i = 0; i < evaluations.length; i++) {
      if (evaluations[i].isRejected()) {
        return true;
      }
    }
    ;
    return false;
  },
  getFileEvaluation: function getFileEvaluation() {},
  isAllPassed: function isAllPassed() {
    var steps = this.get('steps');
    for (var i = 0; i < steps.length; i++) {
      var arrEval = steps[i].get('evaluators');
      for (var j = 0; j < arrEval.length; j++) {
        var evalObj = arrEval[j];
        if (!evalObj.isPassed()) {
          return false;
        }
        ;
      }
      ;
    }
    ;
    return true;
  },
  getCurrentUserEvaluation: function getCurrentUserEvaluation() {
    var steps = this.get('steps');
    var curStep = this.getCurStep();
    var evalInfo = null;
    for (var i = 0; i < steps.length; i++) {
      var arrEval = steps[i].get('evaluators');
      for (var j = 0; j < arrEval.length; j++) {
        if (arrEval[j].getUserId() == app.currentUser.getUserId()) {
          evalInfo = arrEval[j];
          if (i == curStep) {
            return evalInfo;
          }
        }
        ;
      }
      ;
    }
    ;
    return evalInfo;
  },
  isCurStepAllPassed: function isCurStepAllPassed() {
    //当前阶段所有用户均已审批，且全部通过
    var steps = this.get('steps');
    var curStep = this.getCurStep();
    var arrEval = steps[curStep].get('evaluators');
    for (var j = 0; j < arrEval.length; j++) {
      var evalObj = arrEval[j];
      if (!evalObj.isPassed()) {
        return false;
      }
      ;
    }
    ;
    return true;
  },
  isCurStepAllEvaluationWithNot: function isCurStepAllEvaluationWithNot() {
    //当前阶段所有用户已审批，但含有驳回的
    var rejected = false;
    var steps = this.get('steps');
    var curStep = this.getCurStep();
    var arrEval = steps[curStep].get('evaluators');
    for (var j = 0; j < arrEval.length; j++) {
      var evalObj = arrEval[j];
      if (!evalObj.isPassed() && !evalObj.isRejected()) {
        return false;
      } else if (evalObj.isRejected()) {
        rejected = true;
      }
    }
    ;
    return rejected;
  },
  getCurrentUserGroupIndex: function getCurrentUserGroupIndex() {
    var curStep = this.getCurStep();
    var steps = this.get('steps');
    var index = -1;
    for (var i = 0; i < steps.length; i++) {
      var arrEval = steps[i].get('evaluators');
      for (var j = 0; j < arrEval.length; j++) {
        var evalObj = arrEval[j];
        if (evalObj.getUserId() == app.currentUser.getUserId()) {
          if (i == curStep) {
            index = i;
            return i;
          } else {
            index = i;
          }
        }
        ;
      }
      ;
    }
    ;
    return index;
  },
  isCurUserCreator: function isCurUserCreator() {
    var creatorId = this.get('creatorId');
    var curUserId = app.currentUser.getUserId();
    return creatorId == curUserId;
  },
  isStepCanSkip: function isStepCanSkip(step) {
    return true;
  },
  getStepId: function getStepId(step) {
    return -1;
  },
  isCurUserPassed: function isCurUserPassed() {
    var steps = this.get('steps');
    var evalInfo = null;
    for (var i = steps.length - 1; i >= 0; i--) {
      var arrEval = steps[i].get('evaluators');
      var found = false;
      for (var j = 0; j < arrEval.length; j++) {
        if (arrEval[j].getUserId() == app.currentUser.getUserId()) {
          evalInfo = arrEval[j];
          found = true;
          break;
        }
        ;
      }
      ;
      if (found) {
        break;
      }
    }
    ;
    if (evalInfo && evalInfo.isPassed()) {
      return true;
    }
    return false;
  }
}, {
  className: 'MDEvaluationFlowInfo',
  createObjWith: function createObjWith(data) {
    var result = new MDEvaluationFlowInfo(data);
    var steps = data['steps'];
    var evalSteps = [];
    for (var i = 0; i < steps.length; i++) {
      var stepInfo = steps[i];
      var evalStep = _MDEvalStep["default"].createObjWith(stepInfo);
      evalSteps.push(evalStep);
    }
    var files = data.files || [];
    var fileArr = [];
    for (var _i = 0; _i < files.length; _i++) {
      fileArr.push(new _MMFileInfo["default"](files[_i]));
    }
    result.set('steps', evalSteps);
    result.set('files', fileArr);
    return result;
  }
});
var _default = exports["default"] = MDEvaluationFlowInfo;

},{"1184":1184,"1437":1437,"1454":1454,"21":21,"250":250,"297":297}],297:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require(1180));
require(1451);
require(1437);
var _MMModelBase = _interopRequireDefault(require(21));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDTeamInfo = _interopRequireDefault(require(289));
var _MDTagCollection = _interopRequireDefault(require(288));
var _MMFileType = _interopRequireDefault(require(303));
var _MMFileInfoPrototypePart = _interopRequireDefault(require(299));
var _MMFileInfoPrototypePart2 = _interopRequireDefault(require(300));
var _MMFileInfoPrototypePart3 = _interopRequireDefault(require(301));
var _MMFileInfoStatic = _interopRequireDefault(require(302));
/**
 * javascript/model/MMFileInfo.js
 * 统一出口，合并所有原型方法和静态方法
 */

var MMFileInfo = _MMModelBase["default"].extend(Object.assign({}, _MMFileInfoPrototypePart["default"], _MMFileInfoPrototypePart2["default"], _MMFileInfoPrototypePart3["default"], {
  idAttribute: "fileId",
  defaults: (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({
    actions: undefined,
    thumbnailPath: null,
    fileId: "0",
    fileName: "",
    type: _MMFileType["default"].FOLDER,
    fileType: 0,
    ctime: 0,
    creatorId: 0,
    creatorName: "",
    ownerId: 0,
    ownerName: "",
    subChildNum: undefined,
    latestVer: 0,
    currentVersion: 0,
    mtime: 0,
    lastModifyUserId: 0,
    lastModifyUserName: "",
    shareAll: 0,
    isSharing: false,
    shareTime: 0,
    fileSize: 0,
    parentId: "0",
    score: 1,
    inOtherPersonSharingFolder: false,
    delTime: 0,
    permission: 0,
    accessCount: 0,
    commentCount: 0,
    unreadedCommentCount: 0,
    unreadFileCount: 0,
    currentVerCommitterId: 0,
    versionList: null,
    teamMark: 0,
    teamInfo: null,
    sharerId: 0,
    sharerName: "",
    belongTeam: 0,
    belongDepartment: 0,
    userBelongToTeam: 0,
    inTrash: false,
    stickontop: 0,
    starmark: 0,
    fileStatus: -1,
    currentVersionSize: 0,
    enterpriseId: app.currentUser.get("enterpriseId"),
    newShareAll: 2,
    praiseArray: [],
    tagArray: [],
    fileReviewCount: 0,
    canPraise: true,
    canAddTag: true,
    canDelTag: true,
    linkedFileId: 0,
    linkedFileInfo: null,
    linkedFileExt: "txt",
    isFocusFile: false,
    focusCount: 0,
    linkShareExpireTime: null,
    evaluationStatus: 0,
    evaluationFlowId: null,
    openCount: 0,
    accessUserCount: 0,
    downloadCount: 0,
    sendAccessInfoToLinkedIn: 0,
    manuscriptBoxMark: 0,
    comment: "",
    endtime: new Date().getTime() / 1000,
    lockedByUser: "0",
    lockedByUserName: "",
    enterprisePub: 0,
    openWatermark: -1,
    recentType: -1,
    secretLevelId: -1,
    secrectList: [],
    loadedSectlist: false,
    belongEnterprisePub: 0,
    hasAppendedPermission: 0,
    borrowStatus: 0,
    departmentId: undefined,
    manager: "-1",
    managerName: "",
    latestVersionTime: 0
  }, "sharerId", "0"), "show", true), "evaluationStep", -1), "evaluationStepCount", "..."), "manuscriptStatus", undefined), "searchType", 1), "applyForTeamOrProj", undefined), "transmittalProjectId", undefined),
  initialize: function initialize(opt) {
    if (opt) {
      opt.idAttribute = opt.fileId + "--" + opt.version;
    }
    _MMModelBase["default"].prototype.initialize.call(this, opt);
    var teamInfo = this.get("teamInfo");
    if (teamInfo && !(teamInfo instanceof _MDTeamInfo["default"])) {
      this.setTeamInfo(new _MDTeamInfo["default"](teamInfo));
    }
    if (_MDLocalString["default"].getCurrentLanguage() != "cn") {
      if (this.get("creatorName") == "企业") {
        this.set("creatorName", "System");
      }
      if (this.get("currentVerCommitterName") == "企业") {
        this.set("currentVerCommitterName", "System");
      }
      if (this.get("lastModifyUserName") == "企业") {
        this.set("lastModifyUserName", "System");
      }
      if (this.get("ownerName") == "企业") {
        this.set("ownerName", "System");
      }
    }
    var tagCollection = this.get("tagCollection");
    if (tagCollection && _.isArray(tagCollection)) {
      tagCollection = new _MDTagCollection["default"](tagCollection);
      this.set("tagCollection", tagCollection);
    }
  }
}), _MMFileInfoStatic["default"]);
var _default = exports["default"] = MMFileInfo;

},{"1150":1150,"1180":1180,"1184":1184,"1437":1437,"1451":1451,"1454":1454,"21":21,"288":288,"289":289,"299":299,"300":300,"301":301,"302":302,"303":303}],302:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1439);
require(1476);
require(1477);
require(1478);
require(1489);
require(1421);
require(1465);
require(1423);
require(1463);
require(1480);
require(1487);
require(1538);
require(1419);
var _MMCommonFun = _interopRequireDefault(require(812));
var _PropType = _interopRequireDefault(require(90));
var _ErrorCode = _interopRequireDefault(require(1087));
var _MMFileInfo = _interopRequireDefault(require(297));
var _MDSnackbarView = _interopRequireDefault(require(72));
/**
 * MMFileInfo 静态方法集合
 */

// 注意循环引用，实际应为动态引用或调整结构

var staticMethods = {
  className: "MMFileInfo",
  folderSizeArr: [],
  getCachedFolderSize: function getCachedFolderSize(fileInfo) {
    if (fileInfo.isFolder()) {
      var sizeInfo = _MMFileInfo["default"].getCachedFolderSizeInfo(fileInfo.getFileId());
      if (sizeInfo) {
        return sizeInfo.size;
      }
    }
    return -1;
  },
  getCachedFolderSizeInfo: function getCachedFolderSizeInfo(fileId) {
    var curTime = new Date();
    var validtime = 1000 * 60 * 10;
    for (var k = 0; k < _MMFileInfo["default"].folderSizeArr.length; k++) {
      var sizeInfo = _MMFileInfo["default"].folderSizeArr[k];
      if (sizeInfo.fileId == fileId && curTime - sizeInfo.time < validtime) {
        return sizeInfo;
      }
    }
  },
  saveCachedFolderSize: function saveCachedFolderSize(fileId, size, fileCount, folderCount) {
    var found = false;
    for (var k = 0; k < _MMFileInfo["default"].folderSizeArr.length; k++) {
      var sizeInfo = _MMFileInfo["default"].folderSizeArr[k];
      if (sizeInfo.fileId == fileId) {
        sizeInfo.size = size;
        sizeInfo.fileCount = fileCount;
        sizeInfo.folderCount = folderCount;
        sizeInfo.time = new Date();
        found = true;
        break;
      }
    }
    if (!found) {
      _MMFileInfo["default"].folderSizeArr.push({
        fileId: fileId,
        size: size,
        fileCount: fileCount,
        folderCount: folderCount,
        time: new Date()
      });
    }
  },
  getFileStatusDescription: function getFileStatusDescription(status) {
    var des = "";
    switch (status) {
      case -1:
        des = BabelStr.str(435);
        break;
      case 0:
        des = BabelStr.str(436);
        break;
      case 1:
        des = BabelStr.str(437);
        break;
      case 2:
        des = BabelStr.str(438);
        break;
      case 10:
        des = BabelStr.str(439);
        break;
      case 11:
        des = BabelStr.str(440);
        break;
      case 12:
        des = BabelStr.str(441);
        break;
      case 14:
        des = BabelStr.str(442);
        break;
      case 15:
        des = BabelStr.str(443);
        break;
    }
    return des;
  },
  needLoadFromServer: function needLoadFromServer(status) {
    return status == -1 || status == 2;
  },
  waitingServerToConvert: function waitingServerToConvert(status) {
    return status == -1 || status == 2;
  },
  isReady: function isReady(status) {
    return true;
  },
  prepareLinkedFileInfo: function prepareLinkedFileInfo(fileInfo, callback, params) {
    if (fileInfo.isShortcuts() && fileInfo.get("linkedFileInfo") == null) {
      var fileId = fileInfo.get("linkedFileId");
      MMNetDiskDataController.getFileInfoByFileId(fileId, function (linkedFileInfo) {
        fileInfo.set("linkedFileInfo", linkedFileInfo);
        if (callback) {
          callback(linkedFileInfo);
        }
      }, function (code, msg, options) {
        if (code == _ErrorCode["default"].Cannot_Access_Archive || options && options.isArchive) {
          var archive = new _MMFileInfo["default"]();
          archive.setArchived();
          // var depFolder = MMCommonFun.getCurDepfolder();
          // archive.setParentFolderId(depFolder.getFileId());
          fileInfo.set("linkedFileInfo", archive);
          if (callback) {
            callback(archive);
          }
        } else {
          if (params && params.hideError) {
            return;
          }
          _MDSnackbarView["default"].show(BabelStr.str(7043));
        }
      });
    } else {
      if (callback) {
        callback(fileInfo.getShortCutsTargetFile());
      }
    }
  },
  createArchiveHouseFolder: function createArchiveHouseFolder() {
    var fileInfo = new _MMFileInfo["default"]();
    fileInfo.isArchiveHouse = true;
    fileInfo.setFileName(BabelStr.str(760));
    return fileInfo;
  },
  createMultFIleEvalFolder: function createMultFIleEvalFolder(data) {
    return new _MMFileInfo["default"]({
      fileId: window.multFileId(),
      fileName: BabelStr.str(6302) + "-" + data.name,
      evaluationFlowId: data.id,
      evaluationStatus: data.status,
      multFile: 1,
      evaluationStepCount: data.stepCount,
      curStep: data.curStep,
      time: data.time,
      comment: data.comment,
      actions: 1,
      ownerId: data.creatorId,
      creatorName: data.creatorName
    });
  },
  comparer: function comparer(pre, next, option) {
    var order = option.order;
    var fieldName = option.fieldName;
    var propType = option.propType;
    var compareFun = function compareFun(v1, v2) {
      if (propType == _PropType["default"].String) {
        return v1.localeCompare(v2) * order;
      } else {
        if (v1 == v2) {
          return 0;
        } else if (v1 > v2) {
          return order;
        } else {
          return -order;
        }
      }
    };
    var compareFileName = function compareFileName(v1, v2) {
      var patt1 = new RegExp("^(((星期|礼拜)(一|二|三|四|五|六|六|日|天))|(monday|tuesday|wednesday|thursday|friday|saturday|sunday))");
      var dateArr = ["星期一", "礼拜一", "monday", "星期二", "礼拜二", "tuesday", "星期三", "wednesday", "礼拜三", "星期四", "礼拜四", "thursday", "星期五", "礼拜五", "friday", "星期六", "礼拜六", "saturday", "星期日", "星期天", "礼拜天", "sunday"];
      var v1Result = v1.match(patt1);
      var v2Result = v2.match(patt1);
      if (v1Result && v2Result) {
        if (_.indexOf(dateArr, v1Result[0]) > _.indexOf(dateArr, v2Result[0])) {
          return order;
        } else {
          return -order;
        }
      }
      var patt2 = new RegExp("^(一月|1月|Jan|二月|2月|Feb|三月|3月|Mar|四月|4月|Apr|五月|5月|May|六月|6月|Jun|七月|7月|Jul|八月|8月|Aug|九月|9月|Sept|十月|10月|Oct|十一月|11月|Nov|十二月|12月|Dec)", "i");
      var monthArr = ["一月", "1月", "jan", "二月", "2月", "feb", "三月", "3月", "mar", "四月", "4月", "apr", "五月", "5月", "may", "六月", "6月", "jun", "七月", "7月", "jul", "八月", "8月", "aug", "九月", "9月", "sept", "十月", "10月", "oct", "十一月", "11月", "nov", "十二月", "12月", "dec"];
      var v3Result = v1.match(patt2);
      var v4Result = v2.match(patt2);
      if (v3Result && v4Result) {
        if (_.indexOf(monthArr, v3Result[0].toLowerCase()) > _.indexOf(monthArr, v4Result[0].toLowerCase())) {
          return order;
        } else {
          return -order;
        }
      }
      if (v1Result && v4Result) {
        return order;
      } else if (v2Result && v3Result) {
        return -order;
      }
      var i1 = parseFloat(v1);
      var i2 = parseFloat(v2);
      if (!_.isNaN(i1) && !_.isNaN(i2)) {
        if (i1 > i2) {
          return order;
        } else {
          return -order;
        }
      } else {
        return _MMCommonFun["default"].compareStrAndNum(v1, v2) * order;
      }
    };
    var v1 = pre.get(fieldName);
    var v2 = next.get(fieldName);
    if (fieldName == "delTime") {
      return compareFun(v1, v2);
    }
    if (pre.isEpPublicFolder() && next.isEpPublicFolder()) {
      return 0;
    }
    if (pre.isEpPublicFolder()) {
      return -1;
    } else if (next.isEpPublicFolder()) {
      return 1;
    }
    if (pre.isFolder() && next.isFolder()) {
      if (pre.isDepartmentFolder() && next.isDepartmentFolder()) {} else if (pre.isDepartmentFolder()) {
        return -1;
      } else if (next.isDepartmentFolder()) {
        return 1;
      }
    } else {
      if (pre.isFolder()) {
        return -1;
      } else if (next.isFolder()) {
        return 1;
      }
    }
    if (fieldName == "fileName") {
      return compareFileName(v1, v2);
    }
    return compareFun(v1, v2);
  },
  typeFilter: [BabelStr.str(2660), BabelStr.str(7044), BabelStr.str(7045), BabelStr.str(7046), BabelStr.str(7047), BabelStr.str(7048)],
  typeIdFilter: ["All", "Image", "Office", "Adobe", "CAD", "Others"],
  timeFilter: [{
    text: BabelStr.str(7049),
    value: -1
  }, {
    text: BabelStr.str(7050),
    value: 3
  }, {
    text: BabelStr.str(7051),
    value: 7
  }, {
    text: BabelStr.str(7052),
    value: 30
  }, {
    text: BabelStr.str(7053),
    value: 180
  }],
  captureTimeFilter: [{
    text: BabelStr.str(7049),
    value: -1
  }, {
    text: BabelStr.str(7050),
    value: 3
  }, {
    text: BabelStr.str(7051),
    value: 7
  }, {
    text: BabelStr.str(7052),
    value: 30
  }, {
    text: BabelStr.str(7053),
    value: 180
  }],
  timeIdFilter: [-1, 3, 7, 30, 180],
  sizeFilter: [{
    id: "1",
    text: BabelStr.str(7054),
    value: null
  }, {
    id: "2",
    text: BabelStr.str(7055),
    value: [0, 100]
  }, {
    id: "3",
    text: BabelStr.str(7056),
    value: [100, 1024]
  }, {
    id: "4",
    text: "1K ~ 10K",
    value: [1024, 10 * 1024]
  }, {
    id: "5",
    text: "10K~100K",
    value: [10 * 1024, 100 * 1024]
  }, {
    id: "6",
    text: "100K~1M",
    value: [100 * 1024, 1024 * 1024]
  }, {
    id: "7",
    text: "1M~10M",
    value: [1024 * 1024, 10 * 1024 * 1024]
  }, {
    id: "8",
    text: "10M~100M",
    value: [10 * 1024 * 1024, 100 * 1024 * 1024]
  }, {
    id: "9",
    text: "100M~1G",
    value: [100 * 1024 * 1024, 1024 * 1024 * 1024]
  }, {
    id: "10",
    text: "1G~10G",
    value: [1024 * 1024 * 1024, 10 * 1024 * 1024 * 1024]
  }, {
    id: "11",
    text: BabelStr.str(7057),
    value: [10 * 1024 * 1024 * 1024, Infinity]
  }],
  dimensionsFilter: [{
    id: "2",
    text: BabelStr.str(8541),
    value: [3840, Infinity]
  }, {
    id: "3",
    text: BabelStr.str(8542),
    value: [1920, 3839]
  }, {
    id: "4",
    text: BabelStr.str(8543),
    value: [0, 1919]
  }],
  getMatchedSizeArray: function getMatchedSizeArray(fileDataCollection) {
    var sizeFilter = _MMFileInfo["default"].sizeFilter;
    var sizeSet = new Set();
    if (!fileDataCollection.length) {
      sizeSet.add(sizeFilter[0]);
    } else {
      var _loop = function _loop(i) {
        var size = sizeFilter[i].value;
        fileDataCollection.each(function (file) {
          if (file.inSize(size)) {
            sizeSet.add(sizeFilter[i]);
          }
        });
      };
      for (var i = 0; i < sizeFilter.length; i++) {
        _loop(i);
      }
    }
    sizeFilter = Array.from(sizeSet);
    return sizeFilter;
  },
  getMatchedTimeArray: function getMatchedTimeArray(fileDataCollection, attr, attrName) {
    var timeFilter = _MMFileInfo["default"].timeFilter;
    var timeSet = new Set();
    var all = timeFilter[0];
    if (attrName) {
      all = _.extend({}, all);
      all.text = attrName;
    }
    timeSet.add(all);
    if (!fileDataCollection.length) {
      timeSet.add(all);
    } else {
      timeSet.add(all);
      fileDataCollection.each(function (file) {
        for (var i = 1; i < timeFilter.length; i++) {
          var time = timeFilter[i].value;
          if (file.inTime(time, attr)) {
            timeSet.add(timeFilter[i]);
            break;
          }
        }
      });
    }
    timeFilter = Array.from(timeSet);
    for (var i = 0; i < timeFilter.length - 1; i++) {
      for (var k = i + 1; k < timeFilter.length; k++) {
        if (timeFilter[i].value > timeFilter[k].value) {
          var t = timeFilter[i];
          timeFilter[i] = timeFilter[k];
          timeFilter[k] = t;
        }
      }
    }
    return timeFilter;
  },
  getCaptureTimeArray: function getCaptureTimeArray(fileDataCollection) {
    var timeFilter = _MMFileInfo["default"].captureTimeFilter;
    var timeSet = new Set();
    var all = timeFilter[0];
    all.text = BabelStr.str(8533);
    timeSet.add(all);
    if (!fileDataCollection.length) {
      timeSet.add(all);
    } else {
      timeSet.add(all);
      fileDataCollection.each(function (file) {
        for (var i = 1; i < timeFilter.length; i++) {
          var time = timeFilter[i].value;
          if (file.inCaptureTime(time)) {
            timeSet.add(timeFilter[i]);
            break;
          }
        }
      });
    }
    timeFilter = Array.from(timeSet);
    for (var i = 0; i < timeFilter.length - 1; i++) {
      for (var k = i + 1; k < timeFilter.length; k++) {
        if (timeFilter[i].value > timeFilter[k].value) {
          var t = timeFilter[i];
          timeFilter[i] = timeFilter[k];
          timeFilter[k] = t;
        }
      }
    }
    return timeFilter;
  },
  getMatchedExtArray: function getMatchedExtArray(fileDataCollection) {
    var typeSet = new Set();
    var hasFolder = false;
    fileDataCollection.each(function (file) {
      if (!file.isFolder()) {
        var name = file.getFileName();
        var nameArr = name.split(".");
        typeSet.add(nameArr[nameArr.length - 1]);
      } else {
        hasFolder = true;
      }
    });
    var typeArr = Array.from(typeSet);
    for (var i = 0; i < typeArr.length - 1; i++) {
      for (var k = i + 1; k < typeArr.length; k++) {
        if (typeArr[i] > typeArr[k]) {
          var t = typeArr[i];
          typeArr[i] = typeArr[k];
          typeArr[k] = t;
        }
      }
    }
    hasFolder && typeArr.unshift(BabelStr.str(21520));
    typeArr.unshift(BabelStr.str(2660));
    return typeArr;
  },
  getMatchedExtArrayNew: function getMatchedExtArrayNew(fileDataCollection) {
    var typeSet = new Set();
    fileDataCollection.each(function (file) {
      if (!file.isFolder()) {
        var name = file.getFileName();
        var nameArr = name.split(".");
        var ext = nameArr[nameArr.length - 1];
        ext = ext.toLocaleLowerCase();
        typeSet.add(ext);
      }
    });
    var typeArr = Array.from(typeSet);
    for (var i = 0; i < typeArr.length - 1; i++) {
      for (var k = i + 1; k < typeArr.length; k++) {
        if (typeArr[i] > typeArr[k]) {
          var t = typeArr[i];
          typeArr[i] = typeArr[k];
          typeArr[k] = t;
        }
      }
    }
    for (var _i = 0; _i < typeArr.length; _i++) {
      typeArr[_i] = {
        id: typeArr[_i],
        label: typeArr[_i]
      };
    }
    return typeArr;
  },
  getMatchedPlaceArray: function getMatchedPlaceArray(fileDataCollection) {
    var placeSet = new Set();
    fileDataCollection.each(function (file) {
      var maybePosition = file.get("maybePosition");
      maybePosition && placeSet.add(maybePosition);
    });
    var placeArr = Array.from(placeSet);
    for (var i = 0; i < placeArr.length - 1; i++) {
      for (var k = i + 1; k < placeArr.length; k++) {
        if (placeArr[i] > placeArr[k]) {
          var t = placeArr[i];
          placeArr[i] = placeArr[k];
          placeArr[k] = t;
        }
      }
    }
    for (var _i2 = 0; _i2 < placeArr.length; _i2++) {
      placeArr[_i2] = {
        id: placeArr[_i2],
        label: placeArr[_i2]
      };
    }
    return placeArr;
  },
  getMatchedETagArray: function getMatchedETagArray(fileDataCollection) {
    var tagArr = [];
    var uniqObj = {};
    fileDataCollection.each(function (file) {
      var tagCol = file.getTagCollection();
      tagCol.each(function (tag) {
        var name = tag.getText();
        var id = tag.getId();
        if (uniqObj[id]) {
          return;
        } else {
          uniqObj[id] = true;
        }
        tagArr.push({
          id: id,
          name: name
        });
      });
    });
    for (var i = 0; i < tagArr.length - 1; i++) {
      for (var k = i + 1; k < tagArr.length; k++) {
        if (tagArr[i].name.localeCompare(tagArr[k].name) > 1) {
          var t = tagArr[i];
          tagArr[i] = tagArr[k];
          tagArr[k] = t;
        }
      }
    }
    return tagArr;
  },
  getMatchedUserArray: function getMatchedUserArray(fileDataCollection, inTrash) {
    var userArr = [];
    var uniqObj = {};
    fileDataCollection.each(function (file) {
      if (inTrash) {
        if (uniqObj[file.get("deleteByUserId")]) {
          return;
        }
        uniqObj[file.get("deleteByUserId")] = true;
      } else {
        if (uniqObj[file.get("lastModifyUserId")]) {
          return;
        }
        uniqObj[file.get("lastModifyUserId")] = true;
      }
      if (inTrash) {
        userArr.push({
          id: file.get("deleteByUserId"),
          name: file.get("deleteByUsername")
        });
      } else {
        userArr.push({
          id: file.get("lastModifyUserId"),
          name: file.get("lastModifyUserName")
        });
      }
    });
    for (var i = 0; i < userArr.length - 1; i++) {
      for (var k = i + 1; k < userArr.length; k++) {
        if (userArr[i].name.localeCompare(userArr[k].name) > 1) {
          var t = userArr[i];
          userArr[i] = userArr[k];
          userArr[k] = t;
        }
      }
    }
    return userArr;
  }
};
var _default = exports["default"] = staticMethods;

},{"1087":1087,"1184":1184,"1419":1419,"1421":1421,"1423":1423,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1465":1465,"1476":1476,"1477":1477,"1478":1478,"1480":1480,"1487":1487,"1489":1489,"1538":1538,"297":297,"72":72,"812":812,"90":90}],1480:[function(require,module,exports){
// TODO: Remove this module from `core-js@4` since it's replaced to module below
require(1479);

},{"1479":1479}],1479:[function(require,module,exports){
'use strict';
var collection = require(1237);
var collectionStrong = require(1235);

// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
collection('Set', function (init) {
  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);

},{"1235":1235,"1237":1237}],301:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1463);
require(1471);
require(1416);
require(1417);
require(1466);
require(1437);
require(1421);
require(1415);
var _MDEvaluationStatus = _interopRequireDefault(require(254));
var _MDTagCollection = _interopRequireDefault(require(288));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MMFileInfo = _interopRequireDefault(require(297));
var _FILE_ACTION_BITS = _interopRequireDefault(require(235));
var _MDLocalString = _interopRequireDefault(require(1150));
/**
 * MMFileInfo 原型方法 Part3（MMFileInfo 自身方法，不包括 defaults/initialize）
 */

var part3 = {
  setSubImgCollection: function setSubImgCollection(subImgCollection) {
    this.set("subImgCollection", subImgCollection);
  },
  getSubImgCollection: function getSubImgCollection() {
    return this.get("subImgCollection");
  },
  setSubFileCounts: function setSubFileCounts(subFileCounts) {
    this.set("subFileCounts", subFileCounts);
  },
  getSubFileCounts: function getSubFileCounts() {
    return this.get("subFileCounts");
  },
  needLoadFromServer: function needLoadFromServer() {
    if (this.isInTrash() || this.isShortcuts()) {
      return;
    }
    var status = this.getFileStatus();
    return _MMFileInfo["default"].needLoadFromServer(status);
  },
  waitingServerToConvert: function waitingServerToConvert() {
    var status = this.getFileStatus();
    return _MMFileInfo["default"].waitingServerToConvert(status);
  },
  getFileStatusDes: function getFileStatusDes() {
    var status = this.getFileStatus();
    return _MMFileInfo["default"].getFileStatusDescription(status);
  },
  isReady: function isReady() {
    var status = this.getFileStatus();
    return _MMFileInfo["default"].isReady(status);
  },
  canUpdateFileCommentStr: function canUpdateFileCommentStr() {
    return this.isOwner() || this.isCreator() || this.canRename();
  },
  getPassowrdByVersion: function getPassowrdByVersion(ver, needRefresh) {
    var _this = this;
    var password = "";
    var verInfo = this.getVersionInfo(ver);
    if (verInfo) {
      password = verInfo.get("pdfPassword");
      if (!password && ver == this.getCurVersion()) {
        password = this.get("pdfPassword");
      }
    } else {
      password = this.get("pdfPassword");
    }
    if (!password && needRefresh && !this.pwdRequest) {
      // 惰性 require：避免 model → controller → model 循环依赖
      var MMEnterpriseController = require(1098)["default"];
      this.pwdRequest = MMEnterpriseController.getPdfDispKey(this.getFileId(), ver);
      this.pwdRequest.then(function (encrpyted) {
        var password = _this.decryptBySes(encrpyted);
        _this.setPassowrdByVersion(ver, password);
        if (ver == _this.getCurVersion()) {
          password = _this.set("pdfPassword", password);
        }
        _this.pwdRequest = undefined;
      })["catch"](function (code, msg) {
        console.log(code, msg);
        _this.pwdRequest = undefined;
      });
    }
    return password;
  },
  decryptBySes: function decryptBySes(message) {
    var sessionId = g_sessionId;
    var key = sessionId[0];
    var index = 0;
    var step = 0;
    while (step < 7) {
      step++;
      index += step;
      key += sessionId[index];
    }
    return _MMCommonFun["default"].decryptDesCbc(message, key);
  },
  setPassowrdByVersion: function setPassowrdByVersion(ver, pdfPassword) {
    var verInfo = this.getVersionInfo(ver);
    if (verInfo) {
      verInfo.set("pdfPassword", pdfPassword);
    } else {
      this.set("pdfPassword", pdfPassword);
    }
  },
  canShowLinkShare: function canShowLinkShare() {
    var id = this.getSecretLevelId();
    if (id == "1" || !id || id == "-1") {
      return true;
    }
    return false;
  },
  getSecretLevelsForFile: function getSecretLevelsForFile(callback) {
    var _this2 = this;
    // 惰性 require：避免 model → controller → model 循环依赖
    var MMEnterpriseController = require(1098)["default"];
    var secrectList;
    var promise = new Promise(function (resolve, rejected) {
      if (_this2.loadedSectlist) {
        if (_this2.get("secrectList").length > 0) {
          var list = _this2.get("secrectList");
          var curLevelSetted = _this2.get("curLevelSetted");
          resolve({
            list: list,
            curLevelSetted: curLevelSetted,
            callback: callback
          });
        } else {
          MMEnterpriseController.getSecretLevelsForFile(_this2.getFileId(), function (list, curLevelSetted) {
            _this2.set("secrectList", list);
            _this2.set("curLevelSetted", curLevelSetted);
            console.log(list);
            resolve({
              list: list,
              curLevelSetted: curLevelSetted,
              callback: callback
            });
          }, function () {
            _this2.loadedSectlist = false;
          });
        }
      } else {
        MMEnterpriseController.getSecretLevelsForFile(_this2.getFileId(), function (list, curLevelSetted) {
          _this2.set("secrectList", list);
          _this2.set("curLevelSetted", curLevelSetted);
          console.log(list);
          resolve({
            list: list,
            curLevelSetted: curLevelSetted,
            callback: callback
          });
        }, function () {
          _this2.loadedSectlist = false;
        });
      }
    });
    promise.then(function (data) {
      var list = data.list,
        curLevelSetted = data.curLevelSetted,
        callback = data.callback;
      callback(list, curLevelSetted);
    });
    promise["catch"](function (e) {
      console.log(e);
    });
    this.loadedSectlist = true;
  },
  initBy: function initBy(fileInfo) {
    this.set("thumbnailPath", null);
    this.set("fileId", fileInfo.get("fileId"));
    this.set("fileName", fileInfo.get("fileName"));
    this.set("creatorId", fileInfo.get("creatorId"));
    this.set("creatorName", fileInfo.get("creatorName"));
    this.set("parentId", fileInfo.get("parentId"));
    this.set("mtime", fileInfo.get("mtime"));
    this.set("lastModifyUserId", fileInfo.get("lastModifyUserId"));
    this.set("lastModifyUserName", fileInfo.get("lastModifyUserName"));
    this.set("currentVerCommitterId", fileInfo.get("currentVerCommitterId"));
    this.set("stickontop", fileInfo.getStickonTop());
    this.set("starmark", fileInfo.getStarmark());
    this.set("actions", fileInfo.get("actions"));
    this.set("latestVer", fileInfo.get("latestVer"));
    this.set("currentVersion", fileInfo.get("currentVersion"));
    this.set("fileStatus", fileInfo.get("fileStatus"));
    this.set("pdfPassword", fileInfo.get("pdfPassword"));
    if (this.getFileStatus() == 2) {
      this.set("uploadStatus", "processNewFile");
    }
  },
  canDispWithKityMinder: function canDispWithKityMinder() {
    var kityMinder = ["km", "xmind"];
    var ext = this.getFileExtension().toLowerCase();
    var index = _.findIndex(kityMinder, function (notExt) {
      return notExt == ext;
    });
    return index != -1;
  },
  isBabelOffice: function isBabelOffice() {
    var ext = this.getFileExtension().toLowerCase();
    return ext == 'sdoc';
  },
  isDrawio: function isDrawio() {
    var ext = this.getFileExtension().toLowerCase();
    return ext == 'drawio' || ext == 'vsdx' || ext == 'vsd';
  },
  isSurveyFile: function isSurveyFile() {
    return this.getFileExtension().toLowerCase() == 'survey';
  },
  isVsdx: function isVsdx() {
    var ext = this.getFileExtension().toLowerCase();
    return ext == 'vsdx' || ext == 'vsd';
  },
  canDispWithGSCAD: function canDispWithGSCAD() {
    return this.isCADFile() && app.currentUser.isCadSupport();
  },
  canEditWithTextEditer: function canEditWithTextEditer() {
    return this.isTextFile();
  },
  canEditWithSVG: function canEditWithSVG() {
    return this.isSVGFile();
  },
  needApply: function needApply() {
    return this.get("read_needApply");
  },
  isOfficeFile: function isOfficeFile() {
    var officeFiles = ["doc", "docx", "xls", "xlsx", "ppt", "pptx", "et", "ett", "wpt", "dps", "dpt", "wps", "csv", "key", "numbers", "pages"];
    var ext = this.getLowerCaseExt();
    var index = _.findIndex(officeFiles, function (officeExt) {
      return officeExt == ext;
    });
    return index != -1;
  },
  canUseAIFinal: function canUseAIFinal() {
    return this.canUseAI() && window.isOpenOneFileAI && !app.currentUser.isCloseAI() && !app.currentUser.isAnonymous() && window.supportAI && !this.isArchived();
  },
  canUseAI: function canUseAI() {
    var officeFiles = window.supportAiFiles || ["docx", "xlsx", "pptx", "pdf", "doc", "xsl", "ppt", "csv"];
    var ext = this.getLowerCaseExt();
    var index = _.findIndex(officeFiles, function (officeExt) {
      return officeExt == ext;
    });
    return index != -1;
  },
  isSVGFile: function isSVGFile() {
    var svgFiles = ["svg"];
    var ext = this.getLowerCaseExt();
    var index = _.findIndex(svgFiles, function (svgExt) {
      return svgExt == ext;
    });
    return index != -1;
  },
  canEditWithOnlyOffice: function canEditWithOnlyOffice() {
    return this.isOfficeFile() && window.canUseOnlyOffice && this.canUploadVersion && (!window.user || !window.user.disableOnlyOfficeEdit);
  },
  isAIExel: function isAIExel() {
    var ext = this.getFileExtension().toLocaleLowerCase();
    return ext == "xls" || ext == "xlsx" || ext == "csv";
  },
  isExel: function isExel() {
    var ext = this.getFileExtension().toLocaleLowerCase();
    return ext == "xls" || ext == "xlsx";
  },
  isWord: function isWord() {
    var ext = this.getFileExtension().toLocaleLowerCase();
    return ext == "doc" || ext == "docx";
  },
  isPpt: function isPpt() {
    var ext = this.getFileExtension().toLocaleLowerCase();
    return ext == "ppt" || ext == "pptx";
  },
  dispWithMS360: function dispWithMS360() {
    var exlsFiles = ["xls", "xlsx"];
    var ext = this.getLowerCaseExt();
    var index = _.findIndex(exlsFiles, function (officeExt) {
      return officeExt == ext;
    });
    return index != -1;
  },
  isAdobeFile: function isAdobeFile() {
    var officeFiles = ["pdf", "psd", "ai"];
    var ext = this.getLowerCaseExt();
    var index = _.findIndex(officeFiles, function (officeExt) {
      return officeExt == ext;
    });
    return index != -1;
  },
  dispNeedWhiteBoard: function dispNeedWhiteBoard() {
    var testOffice = false;
    var testImage = false;
    var testPdf = false;
    if (this.isOfficeFile() && this.isOnlyDisp()) {
      testOffice = true;
    }
    if (this.isPdf() && this.isOnlyDisp()) {
      testPdf = true;
    }
    if (this.isImage() && this.isOnlyDisp()) {
      testImage = true;
    }
    return !(this.isDrawio() || this.isSurveyFile() || this.isBabelOffice() || this.canDispWithKityMinder() || this.canDispWithTextBrowser() || this.canDispWithGSCAD() || testOffice || testPdf || this.isVideo() || this.isAudio() || this.isMail());
  },
  getLinkShareExpireTime: function getLinkShareExpireTime() {
    return this.get("linkShareExpireTime") * 1000;
  },
  setLinkShareExpireTime: function setLinkShareExpireTime(miliSec) {
    this.set("linkShareExpireTime", miliSec / 1000);
  },
  setEvaluationStatus: function setEvaluationStatus(status) {
    this.set("evaluationStatus", status);
  },
  getEvaluationStatus: function getEvaluationStatus() {
    return this.get("evaluationStatus");
  },
  isWaitToStartEvaluation: function isWaitToStartEvaluation() {
    var status = this.getEvaluationStatus();
    if (status == _MDEvaluationStatus["default"].NOT_START && this.getEvaluationFlowId() == null) {
      return true;
    }
    return false;
  },
  isNormalSig: function isNormalSig() {
    return this.isWaitToStartEvaluation();
  },
  isWaitToReStartEvaluation: function isWaitToReStartEvaluation() {
    var curstatus = this.getCurrentVersionEvaluation();
    var status = this.getEvaluationStatus();
    if (status == _MDEvaluationStatus["default"].EVALUATING) {
      return false;
    }
    if (curstatus == _MDEvaluationStatus["default"].NOT_START && (status == _MDEvaluationStatus["default"].REJECTED || this.getEvaluationFlowId() != null)) {
      return true;
    }
    return false;
  },
  isEvaluating: function isEvaluating() {
    var status = this.getEvaluationStatus();
    return status == _MDEvaluationStatus["default"].EVALUATING;
  },
  isLinkFile: function isLinkFile() {
    var v = this.get("extraStatus");
    return v & 1024 || this.get("linkFileUrl");
  },
  isRejected: function isRejected() {
    var status = this.getEvaluationStatus();
    return status == _MDEvaluationStatus["default"].REJECTED;
  },
  isPassed: function isPassed() {
    var status = this.getEvaluationStatus();
    return status == _MDEvaluationStatus["default"].PASSED;
  },
  getCurrentVersionEvaluation: function getCurrentVersionEvaluation() {
    return this.get("currentVersionEvaluation");
  },
  setCurrentVersionEvaluation: function setCurrentVersionEvaluation(eva) {
    this.set("currentVersionEvaluation", eva);
  },
  setEvaluationFlowId: function setEvaluationFlowId(id) {
    this.set("evaluationFlowId", id);
  },
  getEvaluationFlowId: function getEvaluationFlowId() {
    return this.get("evaluationFlowId");
  },
  getSendAccessInfoToLinkedIn: function getSendAccessInfoToLinkedIn() {
    return this.get("sendAccessInfoToLinkedIn");
  },
  setSendAccessInfoToLinkedIn: function setSendAccessInfoToLinkedIn(send) {
    this.set("sendAccessInfoToLinkedIn", send);
  },
  setEvaluationStepCount: function setEvaluationStepCount(evaluationStepCount) {
    this.set("evaluationStepCount", evaluationStepCount);
  },
  createEvalStrHtml: function createEvalStrHtml() {
    var curStep = this.get("curStep") + 1;
    var evaluationStepCount = this.get("evaluationStepCount");
    var evalInfo = "";
    if (this.isRejected()) {
      if (this.isWaitToReStartEvaluation()) {
        var ready = BabelStr.str(432);
        evalInfo = '<span class="file-flag eval-btn version-restart">' + ready + "</span>";
      } else {
        var reject = BabelStr.str(134);
        evalInfo = '<span class="file-flag eval-btn version-reject">' + reject + "</span>";
      }
    } else if (this.isPassed()) {
      if (this.isWaitToReStartEvaluation()) {
        var ready = BabelStr.str(432);
        evalInfo = '<span class="file-flag eval-btn version-restart">' + ready + "</span>";
      } else {
        var passed = BabelStr.str(433);
        evalInfo = '<span class="file-flag eval-btn version-pass">' + passed + "</span>";
      }
    } else if (this.isEvaluating()) {
      var doing = BabelStr.str(434);
      evalInfo = '<span class="file-flag eval-btn version-eval">' + doing + "..." + curStep + "/" + evaluationStepCount + "</span>";
    }
    return evalInfo;
  },
  updateEvalElement: function updateEvalElement($el) {
    var $btn = $el.find(".eval-btn");
    if ($btn.length) {
      $btn.removeClass("version-restart version-reject version-pass version-eval");
      if (this.isRejected()) {
        if (this.isWaitToReStartEvaluation()) {
          $btn.addClass("version-restart");
          var ready = BabelStr.str(432);
          $btn.text(ready);
        } else {
          $btn.addClass("version-reject");
          var reject = BabelStr.str(134);
          $btn.text(reject);
        }
      } else if (this.isPassed()) {
        if (this.isWaitToReStartEvaluation()) {
          $btn.addClass("version-restart");
          var ready = BabelStr.str(432);
          $btn.text(ready);
        } else {
          $btn.addClass("version-pass");
          var passed = BabelStr.str(433);
          $btn.text(passed);
        }
      } else if (this.isEvaluating()) {
        $btn.addClass("version-eval");
        var doing = BabelStr.str(434);
        $btn.text(doing + "...");
      }
    }
  },
  getCodeMirrorModeStr: function getCodeMirrorModeStr() {
    var ext = this.getFileExtension().toLowerCase();
    var mode = "text";
    switch (ext) {
      case "js":
        mode = "javascript";
        break;
      case "java":
        mode = "text/x-java";
        break;
      case "hpp" || ext == "cpp":
        mode = "text/x-c++src";
        break;
      case "h" || ext == "c":
        mode = "text/x-csrc";
        break;
      case "m" || ext == "m":
        mode = "text/x-objectivec";
        break;
      case "php":
        mode = "application/x-httpd-php";
        break;
      case "jsp":
        mode = "application/x-ejs";
        break;
      case "html":
        mode = {
          name: "htmlmixed",
          scriptTypes: [{
            matches: /\/x-handlebars-template|\/x-mustache/i,
            mode: null
          }, {
            matches: /(text|application)\/(x-)?vb(a|script)/i,
            mode: "vbscript"
          }]
        };
        break;
      case "md":
        mode = "markdown";
        break;
      case "xml":
        mode = "text/html";
        break;
      case "css":
        mode = "text/css";
        break;
      case "scss":
        mode = "text/x-scss";
        break;
      case "txt":
      case "csv":
        mode = "shell";
        break;
      case "apl":
        mode = "text/apl";
        break;
      case "ml":
        mode = "text/x-ocaml";
        break;
      case "fs":
        mode = "text/x-fsharp";
        break;
      case "asn":
        mode = "text/x-ttcn-asn";
        break;
      case "oz":
        mode = "text/x-oz";
        break;
      case "bf":
        mode = "text/x-brainfuck";
        break;
      case "perl":
        mode = "text/x-perl";
        break;
      case "clj":
        mode = "text/x-clojure";
        break;
      case "pgp":
        mode = "application/pgp";
        break;
      case "gss":
        mode = "text/x-gss";
        break;
      case "cmake":
        mode = "text/x-cmake";
        break;
      case "pig":
        mode = "text/x-pig";
        break;
      case "cobol":
        mode = "application/octet-stream";
        break;
      case "ps1":
        mode = "application/x-powershell";
        break;
      case "coffee":
        mode = "application/vnd.coffeescript, text/coffeescript, text/x-coffeescript";
        break;
      case "properties":
        mode = "text/x-properties, text/x-ini";
        break;
      case "lisp":
        mode = "text/x-common-lisp";
        break;
      case "proto":
        mode = "text/x-protobuf";
        break;
      case "pug":
        mode = "text/x-pug";
        break;
      case "pp":
        mode = "text/x-puppet";
        break;
      case "cyp":
        mode = "text/x-puppet";
        break;
      case "q":
        mode = "text/x-q";
        break;
      case "d":
        mode = "text/x-d";
        break;
      case "r":
        mode = "text/x-rsrc";
        break;
      case "rpm":
        mode = "text/x-rpm-spec, text/x-rpm-changes";
        break;
      case "rst":
        mode = "text/x-rst";
        break;
      case "ruby":
        mode = "text/x-ruby";
        break;
      case "diff":
        mode = "text/x-diff";
        break;
      case "rs":
        mode = "text/x-rustsrc";
        break;
      case "dtd":
        mode = "application/xml-dtd";
        break;
      case "sas":
        mode = "text/x-sas";
        break;
      case "sass":
        mode = "text/x-sass";
        break;
      case "ecl":
        mode = "text/x-ecl";
        break;
      case "scheme":
        mode = "text/x-scheme";
        break;
      case "elm":
        mode = "text/x-elm";
        break;
      case "erl":
        mode = "text/x-erlang";
        break;
      case "factor":
        mode = "text/x-factor";
        break;
      case "slim":
        mode = "text/x-slim";
        break;
      case "fcl":
        mode = "text/x-fcl";
        break;
      case "forth":
        mode = "text/x-forth";
        break;
      case "soy":
        mode = "text/x-soy";
        break;
      case "gas":
        mode = "text/x-gas";
        break;
      case "styl":
        mode = "text/x-styl";
        break;
      case "go":
        mode = "text/x-go";
        break;
      case "sparql":
        mode = "application/sparql-query";
        break;
      case "groovy":
        mode = "text/x-groovy";
        break;
      case "swift":
        mode = "text/x-swift";
        break;
      case "hbs":
        mode = "text/x-handlebars-template";
        break;
      case "has":
        mode = "text/x-haskell";
        break;
      case "tcl":
        mode = "text/x-tcl";
        break;
      case "textile":
        mode = "text/x-textile";
        break;
      case "toml":
        mode = "text/x-toml";
        break;
      case "idl":
        mode = "text/x-idl";
        break;
      case "troff":
        mode = "troff";
        break;
      case "vbscript":
        mode = "text/vbscript";
        break;
      case "lua":
        mode = "text/x-lua";
        break;
      case "vhdl":
        mode = "text/x-vhdl";
        break;
      case "mobx":
        mode = "application/mbox";
        break;
      case "vue":
        mode = "text/x-vue";
        break;
      case "idl":
        mode = "text/x-webidl";
        break;
      case "xquery":
        mode = "application/xquery";
        break;
      case "yaml":
        mode = "text/x-yaml";
        break;
      case "nsis":
        mode = "text/x-nsis";
        break;
      case "z80":
        mode = "text/x-z80";
        break;
    }
    return mode;
  },
  needDoubelView: function needDoubelView() {
    var ext = this.getFileExtension().toLowerCase();
    return ext == "md";
  },
  isManuscriptBox: function isManuscriptBox() {
    return this.get("manuscriptBoxMark") != 0 && this.isFolder();
  },
  belongMsBox: function belongMsBox() {
    return this.get("belongMsBox");
  },
  isNormalManuscriptBox: function isNormalManuscriptBox() {
    return this.get("manuscriptBoxMark") == 1 && this.isFolder();
  },
  isMsAnonyBox: function isMsAnonyBox() {
    return this.get("manuscriptBoxMark") == 2 && this.isFolder();
  },
  getCommentStr: function getCommentStr() {
    return this.get("comment");
  },
  setCommentStr: function setCommentStr(str) {
    this.set("comment", str);
  },
  canManageMsBox: function canManageMsBox() {
    return app.isEpVersion() && (this.isOwner() || this.isCreator() || this.canManageSecret()) && this.isManuscriptBox();
  },
  getEndTime: function getEndTime() {
    return this.get("manuscriptBoxTime");
  },
  getEndTimeLocalStr: function getEndTimeLocalStr() {
    var time = this.getEndTime();
    if (time) {
      return _MMCommonFun["default"].formatOnlyDate(time);
    }
    return null;
  },
  getMsBoxEndTimeDispString: function getMsBoxEndTimeDispString() {
    var endTimeStr = "";
    if (this.isMsgBoxTimeExpired()) {
      endTimeStr = _MDLocalString["default"].getLocalString(2502);
    } else {
      var localTimeStr = this.getEndTimeLocalStr();
      if (localTimeStr) {
        endTimeStr = _MDLocalString["default"].getLocalString(176) + " " + localTimeStr;
      }
    }
    return endTimeStr;
  },
  setEndTime: function setEndTime(time) {
    this.set("manuscriptBoxTime", time);
  },
  isFileLocked: function isFileLocked() {
    return this.get("lockedByUser") != "0";
  },
  isFileLockedByOnline: function isFileLockedByOnline() {
    return this.get("lockedByUser") == "-1";
  },
  setFileLockUser: function setFileLockUser(id, name) {
    this.set("lockedByUserName", name);
    this.set("lockedByUser", id);
  },
  getFileLockerName: function getFileLockerName() {
    return this.get("lockedByUserName");
  },
  getFileLockerDispName: function getFileLockerDispName() {
    var name = this.get("lockedByUserName");
    if (name && name.length > 10) {
      name = name.substr(0, 10) + "..";
    }
    return name;
  },
  isFileLockedByMe: function isFileLockedByMe() {
    return this.get("lockedByUser") == app.currentUser.getUserId();
  },
  setSalonInfo: function setSalonInfo(salonInfo) {
    this.set("salonInfo", salonInfo);
  },
  belongEnterprisePub: function belongEnterprisePub() {
    return this.get("belongEnterprisePub");
  },
  canShowStartEvaluation: function canShowStartEvaluation() {
    return app.isEpVersion() && !this.isDepartmentFolder() && this.isWaitToStartEvaluation() && this.canStartEvaluation() || !app.isEpVersion() && this.isWaitToStartEvaluation();
  },
  canShowReStartEvaluation: function canShowReStartEvaluation() {
    return app.isEpVersion() && this.isWaitToReStartEvaluation() && this.canStartEvaluation();
  },
  canShowDoingvaluation: function canShowDoingvaluation() {
    if (!app.isEpVersion()) {
      return false;
    }
    var passed = this.isPassed();
    var rejected = this.isRejected();
    var isDoing = this.isEvaluating();
    var isWaitRestart = this.isWaitToReStartEvaluation();
    return passed || rejected || isDoing;
  },
  canManageDepMember: function canManageDepMember() {
    if (this.isDeleted()) {
      return false;
    }
    if (this.isDepartmentFolder() && this.get("canManageMember") == 1) {
      return true;
    }
    return false;
  },
  canCreateSubDepartment: function canCreateSubDepartment() {
    if (this.isDepartmentFolder() && this.get("canCreateDepartment") == 1) {
      return true;
    }
    return false;
  },
  canCreateEnterpriseMember: function canCreateEnterpriseMember() {
    if (app.currentUser.isEpAdminUser()) {
      return true;
    }
    if (this.isDepartmentFolder() && this.get("canCreateNewEnterpriseMember") == 1) {
      return true;
    }
    return false;
  },
  getSalonInfo: function getSalonInfo() {
    return this.get("salonInfo");
  },
  canSalon: function canSalon() {
    if (app.currentUser.isAnonymous() || this.canDispInOpenGL() || this.canDispInWebBrowser() || !this.dispNeedWhiteBoard() || this.isInTrash()) {
      return false;
    } else {
      return true;
    }
  },
  canManageFilePermission: function canManageFilePermission() {
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].MANAGE_FILE_PERMISSION);
  },
  canSendTransmittal: function canSendTransmittal() {
    if (this.isShortcuts()) {
      return false;
    }
    if (this.isDeleted()) {
      return false;
    }
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].SEND_TRANSMITTAL);
  },
  isDeleteVersion: function isDeleteVersion() {
    return this.get("deleteVersion") != undefined;
  },
  getDeleteVersion: function getDeleteVersion() {
    return this.get("deleteVersion");
  },
  getThumbnailUrl: function getThumbnailUrl(size) {
    size = size ? size : 128;
    var fileId = this.getFileId();
    var version = this.getCurVersion();
    if (this.isDeleteVersion()) {
      version = this.getDeleteVersion();
    }
    size = parseInt(size);
    var param = "fileId=" + fileId + "&size=" + size + "&version=" + version;
    var thumbUrl = "/netdrive/downloadThumbnail.do?" + param;
    return thumbUrl;
  },
  isMsgBoxTimeExpired: function isMsgBoxTimeExpired() {
    if (!this.getEndTime()) {
      return false;
    }
    var endTime = new Date((this.getEndTime() - 0) * 1000);
    var curDate = new Date();
    return endTime < curDate;
  },
  getTypeCls: function getTypeCls() {
    var fileInfor = this;
    var icon = "tree-folder-node";
    if (fileInfor.isTeamFolder()) {
      icon = fileInfor.showMyFileColor() ? "my-team-folder" : "join-team-folder";
    } else if (fileInfor.isSharing()) {
      icon = "my-share-folder";
    } else if (fileInfor.isDepartmentFolder()) {
      icon = "depart-folder";
    } else if (fileInfor.isMaterialLibrary()) {
      icon = "library-folder";
    } else if (fileInfor.isMaterialLibraryFolder()) {
      icon = "library-folder";
    } else if (fileInfor.isMaterialClass()) {
      icon = "classify-folder";
    } else if (fileInfor.isEpPublicFolder()) {
      icon = "ep-pub-folder";
    } else if (fileInfor.isMsAnonyBox()) {
      icon = "ms-box-folder msanonybox";
    } else if (fileInfor.isManuscriptBox()) {
      icon = "ms-box-folder";
    } else if (fileInfor.isShortcuts()) {
      icon = "linked-folder";
    } else if (fileInfor.isReadingRoom()) {
      icon = "reading-room-folder";
    } else if (fileInfor.isProject()) {
      icon = "project-folder";
    } else if (fileInfor.isHQSMProject()) {
      icon = "hqsm-project-folder";
    } else if (fileInfor.get("personAllFile")) {
      icon = "person-all-folder";
    } else if (fileInfor.isEncryptedFolder()) {
      icon = "encrypted-folder";
    }
    return icon;
  },
  getTreeNodeInfo: function getTreeNodeInfo(parent, testUpload) {
    var fileInfor = this;
    var icon = this.getTypeCls();
    var disabled = false;
    var cls = icon + "__node";
    if (this.isOwner()) {
      cls += " owner__node";
    }
    if (this.getFileId() == "0") {
      cls = "root__node owner__node";
    }
    if (!this.canUploadOnlyActions() && testUpload && !app.ep.isArchive()) {
      cls += " no_upload__node";
    }
    icon = "icon " + icon;
    return {
      text: fileInfor.getFileName(),
      id: fileInfor.getFileId(),
      children: !disabled,
      icon: icon,
      li_attr: {
        "class": cls
      },
      state: {
        disabled: disabled
      },
      data: {
        isOtherChannelLinkedFoler: fileInfor.get("isOtherChannelLinkedFoler")
      },
      parent: parent
    };
  },
  getFilePath: function getFilePath() {
    return this.get("path");
  },
  inFolder: function inFolder(folderId) {
    var path = this.getFilePath();
    return path.indexOf(folderId) >= 0;
  },
  matchType: function matchType(type) {
    if (type == "All") {
      return true;
    }
    if (type == "Image") {
      return this.isImage();
    } else if (type == "Office") {
      return this.isOfficeFile();
    } else if (type == "Adobe") {
      return this.isAdobeFile();
    } else if (type == "CAD") {
      return this.isCADFile();
    } else {
      return !this.isImage() && !this.isOfficeFile() && !this.isAdobeFile() && !this.isCADFile();
    }
  },
  matchExt: function matchExt(type) {
    if (type == "全部类型" || type == BabelStr.str(2660)) {
      return true;
    } else {
      if (!this.isFolder()) {
        var name = this.getFileName();
        var nameArr = name.split(".");
        return nameArr[nameArr.length - 1] == type;
      } else if (type == BabelStr.str(21520)) {
        return true;
      } else {
        return false;
      }
    }
  },
  matchPlace: function matchPlace(type) {
    if (type == "拍摄地点" || type == BabelStr.str(8557)) {
      return true;
    } else {
      var maybePosition = this.get("maybePosition");
      return maybePosition == type;
    }
  },
  matchPlaceByCondition: function matchPlaceByCondition(condition) {
    console.log('place condition');
    console.log(condition);
    if (!condition) {
      return true;
    }
    var place = condition.selections;
    var showEmpty = condition.showEmpty;
    if (!showEmpty && !place.length) {
      return true;
    }
    var maybePosition = this.get("maybePosition");
    if (showEmpty && !maybePosition) {
      return true;
    }
    return _.indexOf(place, maybePosition) > -1;
  },
  inTime: function inTime(dayTime, attr) {
    if (dayTime < 0) {
      return true;
    }
    attr = attr || "latestVersionTime";
    var today = new Date();
    var time = new Date(this.get(attr) * 1000);
    var delta = (today - time) / (24 * 60 * 60 * 1000);
    return delta < dayTime;
  },
  inTimeBetween: function inTimeBetween(startTime, endTime, attr) {
    attr = attr || "latestVersionTime";
    var time = this.get(attr) * 1000;
    if (time < startTime) {
      return false;
    }
    if (time > endTime) {
      return false;
    }
    return true;
  },
  nameContainStr: function nameContainStr(str) {
    if (!str.length) {
      return true;
    }
    str = str.toLowerCase();
    var fileName = this.getFileName().toLowerCase();
    if (fileName.indexOf(str) > -1) {
      return true;
    }
    return false;
  },
  commentContainStr: function commentContainStr(str) {
    if (!str.length) {
      return true;
    }
    str = str.toLowerCase();
    var fileName = this.get("comment").toLowerCase();
    if (fileName.indexOf(str) > -1) {
      return true;
    }
    return false;
  },
  inSize: function inSize(sizeArr) {
    if (!sizeArr) {
      return true;
    }
    if (this.isFolder()) {
      return false;
    }
    var min = sizeArr[0];
    var max = sizeArr[1];
    var size = this.get("currentVersionSize");
    if (this.isInTrash()) {
      size = this.get("fileSize");
    }
    if (size >= min && size < max) {
      return true;
    }
    return false;
  },
  matchSizeByCondition: function matchSizeByCondition(sizeArrs) {
    if (!sizeArrs || !sizeArrs.length) {
      return true;
    }
    for (var i = 0; i < sizeArrs.length; i++) {
      var element = sizeArrs[i];
      if (this.inSize(element)) {
        return true;
      }
    }
    return false;
  },
  inDimensions: function inDimensions(sizeArr) {
    if (!sizeArr) {
      return true;
    }
    if (!this.hasMetaData()) {
      return;
    }
    if (this.isFolder()) {
      return false;
    }
    var min = sizeArr[0];
    var max = sizeArr[1];
    var meta_data = this.get("meta_data");
    if (!meta_data) {
      return false;
    }
    var width = meta_data.width;
    width = width > meta_data.height ? width : meta_data.height;
    if (width >= min && width < max) {
      return true;
    }
    return false;
  },
  matchDimensionsByCondition: function matchDimensionsByCondition(sizeArrs) {
    if (!sizeArrs || !sizeArrs.length) {
      return true;
    }
    for (var i = 0; i < sizeArrs.length; i++) {
      var element = sizeArrs[i];
      if (this.inDimensions(element)) {
        return true;
      }
    }
    return false;
  },
  matchFilter: function matchFilter(filter) {
    return this.inFolder(filter.parentId) && this.matchExt(filter.fileType) && this.inTime(filter.dayTime) && this.inSize(filter.size);
  },
  isArchived: function isArchived() {
    var v = this.get("extraStatus");
    return v & 2;
  },
  canAnonymousUpload: function canAnonymousUpload() {
    if (!this.isFolder) {
      return false;
    }
    if (!this.get("anonymousVisit")) {
      return false;
    }
    var v = this.get("extraStatus");
    return v & 4;
  },
  setAnonymousUpload: function setAnonymousUpload(can) {
    var extraStatus = this.get("extraStatus");
    if (can) {
      this.set("extraStatus", extraStatus | 4);
    } else {
      this.set("extraStatus", extraStatus & ~4);
    }
  },
  isShareWithinEnt: function isShareWithinEnt() {
    var v = this.get("extraStatus");
    return v & 128;
  },
  setShareWithinEnt: function setShareWithinEnt(can) {
    var extraStatus = this.get("extraStatus");
    if (can) {
      this.set("extraStatus", extraStatus | 128);
    } else {
      this.set("extraStatus", extraStatus & ~128);
    }
  },
  isShareNotAllowd: function isShareNotAllowd() {
    var v = this.get("extraStatus");
    return v & 256;
  },
  setShareNotAllowd: function setShareNotAllowd(can) {
    var extraStatus = this.get("extraStatus");
    if (can) {
      this.set("extraStatus", extraStatus | 256);
    } else {
      this.set("extraStatus", extraStatus & ~256);
    }
  },
  isOnlineOfficeNotAllowd: function isOnlineOfficeNotAllowd() {
    var v = this.get("extraStatus");
    return v & 512;
  },
  setOnlineOfficeNotAllowd: function setOnlineOfficeNotAllowd(can) {
    var extraStatus = this.get("extraStatus");
    if (can) {
      this.set("extraStatus", extraStatus | 512);
    } else {
      this.set("extraStatus", extraStatus & ~512);
    }
  },
  setArchived: function setArchived() {
    this.set("extraStatus", 2);
  },
  setLocalArchived: function setLocalArchived() {
    this.set("extraStatus", this.get("extraStatus") | 16);
  },
  isLocalArchived: function isLocalArchived() {
    return this.get("extraStatus") & 16;
  },
  createBorrowStrHtml: function createBorrowStrHtml() {
    var borrowInfo = "";
    var v = this.getBorrowStatus();
    if (v == 1) {
      var ready = BabelStr.str(767);
      borrowInfo = '<span class="file-flag apply-status borrow-mark">' + ready + "</span>";
    } else if (v > 1) {
      var ready = BabelStr.str(768);
      borrowInfo = '<span class="file-flag borrow-status borrow-mark">' + ready + "</span>";
    }
    return borrowInfo;
  },
  isInEvaluation: function isInEvaluation() {
    return this.getEvaluationFlowId();
  },
  setEvalFlowInfo: function setEvalFlowInfo(version, evalFlow) {
    if (version == -1) {
      version = this.getCurVersion();
    }
    this.set("evalFlowInfo" + version, evalFlow);
  },
  getEvalFlowInfo: function getEvalFlowInfo(version, callback) {
    var _this3 = this;
    var evalFlow = this.get("evalFlowInfo" + version);
    if (!callback) {
      return evalFlow;
    } else {
      if (evalFlow) {
        callback(evalFlow);
      } else {
        var arrCallbacks = this.get("evalFlowInfoCb" + version);
        if (!arrCallbacks) {
          arrCallbacks = [];
        }
        arrCallbacks.push(callback);
        this.set("evalFlowInfoCb" + version, arrCallbacks);
        if (arrCallbacks.length == 1) {
          MMNetDiskDataController.getEvaluatorsGroup(this.getFileId(), version, this.getEvaluationFlowId(), function (evalFlow) {
            _this3.setEvalFlowInfo(version, evalFlow);
            var callbacks = _this3.get("evalFlowInfoCb" + version);
            for (var i = 0; i < callbacks.length; i++) {
              var cb = callbacks[i];
              cb(evalFlow);
            }
            _this3.set("evalFlowInfoCb" + version, null);
          }, function (res) {
            if (res == MMNetDiskDataController.code.ERROR_EMPTY_EVALUATIONGROUPS) {
              var callbacks = _this3.get("evalFlowInfoCb" + version);
              for (var i = 0; i < callbacks.length; i++) {
                var cb = callbacks[i];
                cb(null);
              }
              _this3.set("evalFlowInfoCb" + version, null);
            } else {
              _MDSnackbarView["default"].show(BabelStr.str(510));
            }
          });
        }
      }
    }
  },
  canCreateCommentForVersion: function canCreateCommentForVersion(version, callback) {
    if (!this.canCreateComment()) {
      callback(false);
      return;
    }
    if (!app.ep.canShowEvalModel()) {
      if (this.getEvaluationStatus() == 0) {
        callback(true);
      } else {
        callback(false);
      }
      return;
    }
    var canCreate = false;
    var isEval = false;
    this.getEvalFlowInfo(version, function (evalFlow) {
      if (evalFlow) {
        var curUserIsCreator = evalFlow.isCurUserCreator();
        var curUserGroupIndex = evalFlow.getCurrentUserGroupIndex();
        var curStep = evalFlow.getCurStep();
        if (!curUserIsCreator && curUserGroupIndex != curStep) {
          canCreate = false;
          isEval = true;
        } else {
          canCreate = true;
          isEval = true;
        }
      } else {
        canCreate = true;
      }
      callback(canCreate, isEval);
    });
  },
  getManuscriptStatus: function getManuscriptStatus() {
    var manuscriptStatus = this.get("manuscriptStatus");
    if (this.isManuscriptBox()) {
      manuscriptStatus = undefined;
    }
    return manuscriptStatus;
  },
  bloneManuscript: function bloneManuscript() {
    var status = this.getManuscriptStatus();
    return !_.isUndefined(status);
  },
  belongAnonymousBox: function belongAnonymousBox() {
    return this.get("belongAnonymousBox");
  },
  getManuscriptStatusText: function getManuscriptStatusText() {
    if (this.belongAnonymousBox() || this.isFolder()) {
      return "";
    }
    var status = this.getManuscriptStatus();
    var result = "";
    switch (status) {
      case 0:
        result = "<span class=\"manuscript-status untreated\">".concat(BabelStr.str(6000), "</span>");
        break;
      case 1:
        result = "<span class=\"manuscript-status passed\">".concat(BabelStr.str(6001), "</span>");
        break;
      case 2:
        result = "<span class=\"manuscript-status rejected\">".concat(BabelStr.str(6002), "</span>");
        break;
      default:
        result = "";
    }
    return result;
  },
  canSetManuscriptStatus: function canSetManuscriptStatus() {
    var status = this.getManuscriptStatus();
    if (_.isUndefined(status)) {
      return false;
    }
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].EDIT_PROJECT);
  },
  hasTag: function hasTag(tagStr) {
    var tagCol = this.getTagCollection();
    return tagCol && tagCol.find(function (tag) {
      var name = tag.getText();
      return name == tagStr;
    });
  },
  matchTagByCondition: function matchTagByCondition(condition) {
    if (!condition) {
      return true;
    }
    var tagCol = this.getTagCollection();
    var showEmpty = condition.showEmpty;
    if (showEmpty && !tagCol.length) {
      return true;
    }
    var conditionType = condition.conditionType;
    var tagIds = condition.selections;
    if (!showEmpty && !tagIds.length) {
      return true;
    }
    var filterTags = tagCol.filter(function (tagModel) {
      var id = tagModel.getId();
      if (_.indexOf(tagIds, id) > -1) {
        return true;
      } else {
        return false;
      }
    });
    if (filterTags.length == 0) {
      return false;
    }
    if (filterTags.length > 0 && tagIds.length == 1) {
      return true;
    }
    var result = false;
    switch (conditionType) {
      case 1:
        result = filterTags.length > 0;
        break;
      case 2:
        result = filterTags.length == tagIds.length;
        break;
      case 3:
        result = filterTags.length > 0 && filterTags.length < tagIds.length;
        break;
    }
    return result;
  },
  matchTypeByCondition: function matchTypeByCondition(condition) {
    if (!condition) {
      return true;
    }
    var exts = condition.selections;
    var showEmpty = condition.showEmpty;
    if (!exts.length && !showEmpty) {
      return true;
    }
    if (this.isFolder()) {
      if (showEmpty) {
        return true;
      } else {
        return false;
      }
    }
    var ext = this.getFileExtension();
    return _.indexOf(exts, ext) > -1;
  },
  matchUserByCondition: function matchUserByCondition(condition, isTrash) {
    if (!condition) {
      return true;
    }
    var userIds = condition.selections;
    if (!userIds.length) {
      return true;
    }
    var id = this.isTrash ? this.get("deleteByUserId") : this.get("lastModifyUserId");
    return _.indexOf(userIds, id) > -1;
  },
  matchTimeByCondition: function matchTimeByCondition(condition, attr) {
    if (!condition) {
      return true;
    }
    attr = attr || "latestVersionTime";
    var time = this.get(attr) * 1000;
    if (condition.startTime && time < condition.startTime) {
      return false;
    }
    if (condition.endTime && time > condition.endTime) {
      return false;
    }
    return true;
  },
  matchCaptureTimeByCondition: function matchCaptureTimeByCondition(condition) {
    if (!condition) {
      return true;
    }
    return this.inCaptureTimeBetween(condition.startTime, condition.endTime);
  },
  inCaptureTime: function inCaptureTime(dayTime) {
    if (dayTime < 0) {
      return true;
    }
    var meta_data = this.get("meta_data");
    if (!meta_data || !meta_data.capture_time) {
      return false;
    }
    var today = new Date();
    var time = new Date(meta_data.capture_time);
    var delta = (today - time) / (24 * 60 * 60 * 1000);
    return delta < dayTime;
  },
  inCaptureTimeBetween: function inCaptureTimeBetween(startTime, endTime) {
    var meta_data = this.get("meta_data");
    if (!meta_data) {
      return false;
    }
    if (!meta_data.capture_time) {
      return;
    }
    var time = new Date(meta_data.capture_time);
    if (time < startTime) {
      return false;
    }
    if (time > endTime) {
      return false;
    }
    return true;
  },
  getUploadMaxSize: function getUploadMaxSize(limitSize) {
    var extension = _MMCommonFun["default"].getFileExtension1(this.getFileName());
    var maxSize = 100;
    switch (extension) {
      case "epub":
        maxSize = 3;
        break;
      case "ofd":
        maxSize = 40;
        break;
      case "rtf":
        maxSize = 30;
        break;
      case "png":
        maxSize = 20;
        break;
      case "indd":
      case "indt":
      case "idml":
        maxSize = 300;
        break;
      case "cr2":
      case "arw":
      case "dng":
      case "nef":
      case "pef":
      case "txt":
        maxSize = 50;
        break;
      case "ai":
      case "psd":
      case "stl":
      case "x3d":
      case "fbx":
      case "obj":
      case "ply":
      case "3ds":
      case "abc":
        maxSize = 500;
        break;
      case "ico":
      case "tif":
      case "tiff":
      case "svg":
      case "eps":
      case "dwg":
      case "dwt":
      case "doc":
      case "docx":
      case "wps":
      case "wpt":
      case "pages":
        maxSize = 100;
        break;
      case "xls":
      case "xlsx":
      case "et":
      case "ett":
      case "numbers":
        maxSize = 3;
        break;
      case "ppt":
      case "pptx":
      case "dps":
      case "dpt":
      case "key":
      case "dxf":
        maxSize = 200;
        break;
    }
    if (limitSize) {
      maxSize = limitSize / (1024 * 1024);
      maxSize = parseInt(maxSize);
    }
    return maxSize;
  },
  onOnlyOfficeEdited: function onOnlyOfficeEdited() {
    this.onlyOfficedEdited = true;
    this.onlyOfficeEditVersion = this.getCurVersion();
  },
  hasChangedByOnlyOffice: function hasChangedByOnlyOffice() {
    return this.onOnlyOfficeEdited;
  },
  onlyOfficeSaved: function onlyOfficeSaved(saved) {
    this._onlyOfficeSaved = saved;
  },
  isOnlyOfficeSaved: function isOnlyOfficeSaved() {
    return this._onlyOfficeSaved;
  },
  isVersionUpdatedAfterOnlyOffice: function isVersionUpdatedAfterOnlyOffice() {
    if (this.onlyOfficedEdited) {
      if (this.onlyOfficeEditVersion != this.getCurVersion()) {
        this.onlyOfficedEdited = false;
        this.onlyOfficeEditVersion = -1;
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  },
  setCalcFolderSize: function setCalcFolderSize(size) {
    this.calcFolderSize = size;
  },
  getCalcFolderSize: function getCalcFolderSize() {
    return this.calcFolderSize;
  },
  getOrganizationInfo: function getOrganizationInfo() {
    return {
      departmentId: this.get("departmentId"),
      projectId: this.get("projectId"),
      transmittalProjectId: this.get("transmittalProjectId")
    };
  },
  useVirtualBoard: function useVirtualBoard() {
    return this.get("useVirtualBoard");
  },
  markVirtualBoard: function markVirtualBoard() {
    this.set("useVirtualBoard", 1);
  },
  dispWithSVG: function dispWithSVG() {
    return this.isSVGFile() && this.useVirtualBoard();
  },
  isMyJoinedShare: function isMyJoinedShare() {
    return this.get("joinedShare");
  },
  isSnapshotFile: function isSnapshotFile() {
    var v = this.get("extraStatus");
    return v & 8;
  }
};
var _default = exports["default"] = part3;

},{"1098":1098,"1150":1150,"1184":1184,"1415":1415,"1416":1416,"1417":1417,"1421":1421,"1437":1437,"1454":1454,"1463":1463,"1466":1466,"1471":1471,"235":235,"254":254,"288":288,"297":297,"72":72,"812":812}],300:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require(1199));
var _asyncToGenerator2 = _interopRequireDefault(require(1172));
require(1416);
require(1412);
require(1437);
require(1463);
require(1471);
require(1417);
require(1466);
var _MDEvaluationStatus = _interopRequireDefault(require(254));
var _MDTag = _interopRequireDefault(require(287));
var _FILE_ACTION_BITS = _interopRequireDefault(require(235));
var _MMVersionInfo = _interopRequireDefault(require(310));
var _MMFileIconMaker = _interopRequireDefault(require(296));
var _MMFileType = _interopRequireDefault(require(303));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MDTeamInfo = _interopRequireDefault(require(289));
var _MDTagCollection = _interopRequireDefault(require(288));
var _ErrorCode = _interopRequireDefault(require(1087));
var _PropType = _interopRequireDefault(require(90));
var _MMFileConvertStatus = _interopRequireDefault(require(295));
var _MDSnackbarView = _interopRequireDefault(require(72));
/**
 * MMFileInfo 原型方法 Part2（来自原 MMFileInfo2 后半部分）
 */

var part2 = {
  setFileReviewCount: function setFileReviewCount(count) {
    this.set("fileReviewCount", count);
  },
  getFileReviewCount: function getFileReviewCount() {
    return this.get("fileReviewCount");
  },
  isShortcuts: function isShortcuts() {
    return this.get("linkedFileId") != 0 && this.getFileId() != 0;
  },
  getShortCutsTargetFile: function getShortCutsTargetFile() {
    return this.get("linkedFileInfo");
  },
  getLinkFileUrl: function getLinkFileUrl() {
    return this.get("linkFileUrl");
  },
  getShortCutsTargetFileId: function getShortCutsTargetFileId() {
    return this.get("linkedFileId");
  },
  markShortcutsTargetDeleted: function markShortcutsTargetDeleted(fileIds) {
    var linkedId = this.getShortCutsTargetFileId();
    var fileInfo = this.getShortCutsTargetFile();
    if (fileInfo && linkedId) {
      for (var i = 0; i < fileIds.length; i++) {
        var fid = fileIds[i];
        if (fid == linkedId) {
          fileInfo.set("status", 1);
          break;
        }
      }
    }
  },
  isVersionReady: function isVersionReady(ver) {
    if (!this.readyList) {
      return false;
    }
  },
  setVersionReady: function setVersionReady(ver) {
    if (!this.readyList) {
      this.readyList = [];
    }
    var index = _.findIndex(this.readyList, function (readyV) {
      return readyV == ver;
    });
    if (index == -1) {
      this.readyList.push(ver);
    }
  },
  isTextFile: function isTextFile() {
    var notNeedWhiteBoardFiles = ["md", "srt", "js", "java", "php", "hpp", "cpp", "jsp", "php", "css", "scss", "xml", "c", "h", "m", "mm", "txt", "sh", "bat", "py", "bash", "sql"];
    notNeedWhiteBoardFiles = notNeedWhiteBoardFiles.concat(["apl", "ml", "fs", "asn", "oz", "bf", "perl", "clj", "pgp", "gss", "cmake", "pig", "cobol", "ps1", "coffee", "properties", "lisp", "proto", "pug", "pp", "cyp", "q", "d", "r", "rpm", "rst", "ruby", "diff", "rs", "dtd", "sas", "sass", "ecl", "scheme", "elm", "erl", "factor", "slim", "fcl", "forth", "soy", "gas", "styl", "go", "sparql", "groovy", "swift", "hbs", "has", "tcl", "textile", "toml", "idl", "troff", "vbscript", "lua", "vhdl", "mbox", "vue", "idl", "xquery", "yaml", "nsis", "z80"]);
    var ext = this.getFileExtension().toLowerCase();
    var index = _.findIndex(notNeedWhiteBoardFiles, function (notExt) {
      return notExt == ext;
    });
    return index != -1;
  },
  isMDFile: function isMDFile() {
    var ext = this.getFileExtension().toLowerCase();
    return ext == "md";
  },
  isOnlyTxt: function isOnlyTxt() {
    var ext = this.getFileExtension().toLowerCase();
    return ext == "txt";
  },
  canDispWithTextBrowser: function canDispWithTextBrowser() {
    var notNeedWhiteBoardFiles = ["md", "srt", "js", "java", "php", "hpp", "cpp", "jsp", "php", "css", "scss", "xml", "c", "h", "m", "mm", "sh", "bat", "py", "bash", "sql"];
    if (this.isOnlyTxt() && this.isOnlyDisp()) {
      notNeedWhiteBoardFiles.push("txt");
    }
    notNeedWhiteBoardFiles = notNeedWhiteBoardFiles.concat(["apl", "ml", "fs", "asn", "oz", "bf", "perl", "clj", "pgp", "gss", "cmake", "pig", "cobol", "ps1", "coffee", "properties", "lisp", "proto", "pug", "pp", "cyp", "q", "d", "r", "rpm", "rst", "ruby", "diff", "rs", "dtd", "sas", "sass", "ecl", "scheme", "elm", "erl", "factor", "slim", "fcl", "forth", "soy", "gas", "styl", "go", "sparql", "groovy", "swift", "hbs", "has", "tcl", "textile", "toml", "idl", "troff", "vbscript", "lua", "vhdl", "mbox", "vue", "idl", "xquery", "yaml", "nsis", "z80"]);
    var ext = this.getFileExtension().toLowerCase();
    var index = _.findIndex(notNeedWhiteBoardFiles, function (notExt) {
      return notExt == ext;
    });
    return index != -1;
  },
  fetchIconUrl: function () {
    var _fetchIconUrl = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(node, jsTree) {
      var customIcon4File, curTime, maxCatchTime, useLocal, hasLocal, result, time, MMEnterpriseController, out, _result, response, blob, base64, hasCustom;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            customIcon4File = {};
            curTime = new Date().getTime();
            maxCatchTime = 1000 * 60 * 30;
            useLocal = false;
            hasLocal = false;
            if (!(window.dexieDB && window.dexieDB["file_default_thumbs"])) {
              _context.next = 10;
              break;
            }
            _context.next = 8;
            return window.dexieDB["file_default_thumbs"].where({
              fileId: this.getFileId()
            }).first();
          case 8:
            result = _context.sent;
            if (result) {
              time = result.time;
              hasLocal = true;
              if (curTime - time < maxCatchTime) {
                customIcon4File = result;
                useLocal = true;
              } else if (window.dexieDB && window.dexieDB.file_default_thumbs) {
                window.dexieDB.file_default_thumbs["delete"](this.getFileId());
              }
            }
          case 10:
            if (useLocal) {
              _context.next = 17;
              break;
            }
            // 惰性 require：MMFileInfo 与 net 层存在循环依赖（model → controller → model），
            // 顶层 import 会在模块初始化阶段拿到未完整的 exports，导致 undefined.extend
            MMEnterpriseController = require(1098)["default"];
            _context.next = 14;
            return MMEnterpriseController.dedupGetGetCustomIcon4File(this.getFileId());
          case 14:
            out = _context.sent;
            customIcon4File = out.customIcon4File || {};
            // await 期间 window.dexieDB 可能已失效（页面未初始化或已切换），需重新检查
            if (window.dexieDB && window.dexieDB.file_default_thumbs) {
              window.dexieDB.file_default_thumbs.put({
                fileId: this.getFileId(),
                asIconType: customIcon4File.asIconType,
                customIconId: customIcon4File.customIconId,
                time: curTime
              });
            }
          case 17:
            if (!customIcon4File.customIconId) {
              _context.next = 39;
              break;
            }
            if (!(window.dexieDB && window.dexieDB["default_thumbs"])) {
              _context.next = 22;
              break;
            }
            _context.next = 21;
            return window.dexieDB["default_thumbs"].where({
              id: customIcon4File.customIconId
            }).first();
          case 21:
            _result = _context.sent;
          case 22:
            if (!_result) {
              _context.next = 27;
              break;
            }
            customIcon4File.fileUrl = _result.fileUrl;
            console.log("使用了缓存的图" + customIcon4File.customIconId);
            _context.next = 39;
            break;
          case 27:
            _context.next = 29;
            return fetch(customIcon4File.fileUrl);
          case 29:
            response = _context.sent;
            _context.next = 32;
            return response.blob();
          case 32:
            blob = _context.sent;
            _context.next = 35;
            return new Promise(function (resolve, reject) {
              var reader = new FileReader();
              reader.onloadend = function () {
                return resolve(reader.result);
              };
              reader.onerror = reject;
              reader.readAsDataURL(blob);
            });
          case 35:
            base64 = _context.sent;
            customIcon4File.fileUrl = base64;
            if (window.dexieDB && window.dexieDB.default_thumbs) {
              window.dexieDB.default_thumbs.put({
                id: customIcon4File.customIconId,
                fileUrl: base64
              });
            }
            console.log("又获取了新的" + customIcon4File.customIconId);
          case 39:
            this.set("customIcon4File", customIcon4File);
            hasCustom = false;
            if (customIcon4File) {
              if (customIcon4File.fileUrl || customIcon4File.asIconType) {
                hasCustom = true;
              }
            }
            if (hasCustom) {
              this.setCustomIconForFileInfo(node, jsTree);
            }
          case 43:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function fetchIconUrl(_x, _x2) {
      return _fetchIconUrl.apply(this, arguments);
    }
    return fetchIconUrl;
  }(),
  setCustomIconForFileInfo: function setCustomIconForFileInfo(node, jsTree) {
    var customIcon4File = this.get("customIcon4File");
    var nodeData = jsTree.get_node(node.id).data;
    nodeData.customIcon4File = customIcon4File;
    if (customIcon4File.fileUrl) {
      jsTree.set_icon(node.id, customIcon4File.fileUrl);
      var $nodeElement = jsTree.get_node(node.id, true);
      var $iconElement = $nodeElement.find(" > .jstree-anchor .jstree-themeicon-custom");
      $iconElement.addClass("default-icon").css({
        "background-size": "20px",
        "border-radius": "10px"
      });
    } else {
      var x = 0;
      var y = 0;
      var i = parseInt(customIcon4File.asIconType);
      var bkgroundSize = {};
      var size = 24;
      var s_size = 40.0;
      var ratio = 1.0;
      ratio = size / s_size;
      x = -i * 40 % 400 * ratio;
      y = -Math.floor(i / 10) * 40 * ratio;
      bkgroundSize.x = 400 * ratio;
      bkgroundSize.y = 400 * ratio;
      var _$nodeElement = jsTree.get_node(node.id, true);
      var _$iconElement = _$nodeElement.find(" > .jstree-anchor .jstree-themeicon-custom");
      _$iconElement.addClass("default-icon").prop('style').cssText = "background-position: ".concat(x, "px ").concat(y, "px !important; ") + "background-size: ".concat(bkgroundSize.x, "px ").concat(bkgroundSize.y, "px !important; ");
    }
  }
};
var _default = exports["default"] = part2;

},{"1087":1087,"1098":1098,"1172":1172,"1184":1184,"1199":1199,"1412":1412,"1416":1416,"1417":1417,"1437":1437,"1454":1454,"1463":1463,"1466":1466,"1471":1471,"235":235,"254":254,"287":287,"288":288,"289":289,"295":295,"296":296,"303":303,"310":310,"72":72,"812":812,"90":90}],299:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1425);
require(1424);
require(1466);
require(1416);
require(1423);
require(1463);
require(1487);
require(1538);
require(1545);
require(1543);
require(1541);
require(1417);
require(1478);
require(1449);
require(1446);
require(1421);
require(1415);
var _MDEvaluationStatus = _interopRequireDefault(require(254));
var _MDTag = _interopRequireDefault(require(287));
var _FILE_ACTION_BITS = _interopRequireDefault(require(235));
var _MMVersionInfo = _interopRequireDefault(require(310));
var _MMFileIconMaker = _interopRequireDefault(require(296));
var _MMFileType = _interopRequireDefault(require(303));
var _MMCommonFun = _interopRequireDefault(require(812));
var _MDTeamInfo = _interopRequireDefault(require(289));
var _MDTagCollection = _interopRequireDefault(require(288));
var _ErrorCode = _interopRequireDefault(require(1087));
var _PropType = _interopRequireDefault(require(90));
var _MMFileConvertStatus = _interopRequireDefault(require(295));
var _MDSnackbarView = _interopRequireDefault(require(72));
/**
 * MMFileInfo 原型方法 Part1（来自原 MMFileInfo2 前半部分）
 */

var part1 = {
  canAddSig: function canAddSig() {
    return this.canCreateComment() && !this.isOnlyDisp() && !this.isArchived();
  },
  isNeedApproval: function isNeedApproval() {
    var outShareApprovers = this.get("outShareApprovers");
    if (!outShareApprovers) {
      return false;
    }
    if (outShareApprovers.strategy == 2 && outShareApprovers.approvers.length) {
      return true;
    }
    return false;
  },
  isLinkNeedApproval: function isLinkNeedApproval() {
    var outShareApprovers = this.get("outShareApprovers");
    if (!outShareApprovers) {
      return false;
    }
    if (outShareApprovers.strategy == 2) {
      return this.get('newShareAll') != 1;
    }
    return false;
  },
  isBannedFile: function isBannedFile() {
    return this.get("banned");
  },
  getTransmittalProjectId: function getTransmittalProjectId() {
    return this.get("transmittalProjectId");
  },
  getTaskORGid: function getTaskORGid() {
    return this.get("taskORGid");
  },
  getTaskCONid: function getTaskCONid() {
    return this.get("taskCONid");
  },
  getTaskDELid: function getTaskDELid() {
    return this.get("taskDELid");
  },
  getTaskRENid: function getTaskRENid() {
    return this.get("taskRENid");
  },
  getShow: function getShow() {
    return this.get("show");
  },
  setShow: function setShow(show) {
    this.set("show", show);
  },
  getManagerName: function getManagerName() {
    return this.get("managerName");
  },
  setManagerName: function setManagerName(managerName) {
    this.set("managerName", managerName);
  },
  getManager: function getManager() {
    return this.get("manager");
  },
  setManager: function setManager(manager) {
    this.set("manager", manager);
  },
  setHasAppendedPermission: function setHasAppendedPermission(hasAppendedPermission) {
    this.set("hasAppendedPermission", hasAppendedPermission);
  },
  getBorrowStatus: function getBorrowStatus() {
    return this.get("borrowStatus");
  },
  setBorrowStatus: function setBorrowStatus(status) {
    this.set("borrowStatus", status);
  },
  getHasAppendedPermission: function getHasAppendedPermission() {
    return this.get("hasAppendedPermission");
  },
  setUnreadCommentCount: function setUnreadCommentCount(count) {
    this.set("unreadedCommentCount", count);
  },
  clearUnReadCount: function clearUnReadCount() {
    this.set("unreadFileCount", 0);
  },
  isCommitter: function isCommitter() {
    var committer = this.get("currentVerCommitterId");
    var curUserId = app.currentUser.getUserId();
    return committer === curUserId || app.currentUser.isAnonymous();
  },
  setCommitter: function setCommitter(id) {
    this.set("currentVerCommitterId", id);
  },
  setVersionList: function setVersionList(verList) {
    this.set("versionList", verList);
  },
  hasVersionList: function hasVersionList() {
    return this.get("versionList") != null;
  },
  getSecretLevelId: function getSecretLevelId() {
    return this.get("secretLevelId");
  },
  setSecretLevelId: function setSecretLevelId(secretLevelId) {
    this.set("secretLevelId", secretLevelId);
  },
  getRecentType: function getRecentType() {
    return this.get("recentType");
  },
  canShareout: function canShareout() {
    return this.get("canShareout");
  },
  getRecentTypeStr: function getRecentTypeStr() {
    var type = this.getRecentType();
    var str = "";
    switch (type) {
      case 0:
        str = " " + BabelStr.str(384);
        break;
      case 1:
        str = " " + BabelStr.str(385);
        break;
      case 2:
        str = " " + BabelStr.str(386);
        break;
    }
    return str;
  },
  getRecentTime: function getRecentTime() {
    return this.get("recentTime");
  },
  canFocus: function canFocus() {
    if (this.isMaterialClass()) {
      return false;
    }
    return this.get("canFocus");
  },
  getOpenCount: function getOpenCount() {
    return this.get("openCount");
  },
  setOpenCount: function setOpenCount(openCount) {
    this.set("openCount", openCount);
  },
  getAccessUserCount: function getAccessUserCount() {
    return this.get("accessUserCount");
  },
  setAccessUserCount: function setAccessUserCount(accessUserCount) {
    this.set("accessUserCount", accessUserCount);
  },
  getDownloadCount: function getDownloadCount() {
    return this.get("downloadCount");
  },
  setDownloadCount: function setDownloadCount(downloadCount) {
    this.set("downloadCount", downloadCount);
  },
  enablePraise: function enablePraise(enable) {
    this.set("canPraise", enable);
  },
  canPraise: function canPraise() {
    return this.get("canPraise");
  },
  getLastModifyUserName: function getLastModifyUserName() {
    if (this.isMultFile()) {
      return this.get('creatorName');
    }
    if (this.get("lastModifyUserId") != 0) {
      return this.get("lastModifyUserName");
    } else {
      return BabelStr.str(722);
    }
  },
  getFileId: function getFileId() {
    if (this.get("idUsedFileIdAndVersion")) {
      var ids = this.get("fileId").split("--");
      return ids[0];
    }
    return this.get("fileId");
  },
  setFileId: function setFileId(id) {
    return this.set("fileId", id);
  },
  getCreatorId: function getCreatorId() {
    return this.get("creatorId");
  },
  getParentFolderId: function getParentFolderId() {
    return this.get("parentId");
  },
  setParentFolderId: function setParentFolderId(folderId) {
    this.set("parentId", folderId);
  },
  getFileName: function getFileName() {
    return this.get("fileName") || this.get("name") || "";
  },
  setFileName: function setFileName(name) {
    return this.set("fileName", name);
  },
  initActionsBy: function initActionsBy(fileInfo) {
    this.set("actions", fileInfo.get("actions"));
  },
  getOpenWatermark: function getOpenWatermark() {
    return this.get("openWatermark");
  },
  setOpenWatermark: function setOpenWatermark(openWatermark) {
    this.set("openWatermark", openWatermark);
  },
  getShareTime: function getShareTime() {
    return this.get("shareTime");
  },
  getCurrentVersion: function getCurrentVersion() {
    return this.get("currentVersion");
  },
  getCurrentVersionSize: function getCurrentVersionSize() {
    return this.get("currentVersionSize");
  },
  isFolder: function isFolder() {
    return this.get("type") == _MMFileType["default"].FOLDER;
  },
  getModifyDateStr: function getModifyDateStr() {
    var t = this.get("mtime");
    if (t) {
      return new Date(t).format("yyyy-MM-dd");
    }
    return "";
  },
  isInOtherPersonSharingFolder: function isInOtherPersonSharingFolder() {
    return this.get("inOtherPersonSharingFolder");
  },
  isOtherPersonSharingFile: function isOtherPersonSharingFile() {
    var pathRouter = app.pathRouter;
    if (pathRouter.hasTeamFolder()) {
      return false;
    }
    return this.isSharing() && !this.isOwner();
  },
  isSharing: function isSharing() {
    return this.get("isSharing") == true;
  },
  changeShareState: function changeShareState(share) {
    if (share) {
      this.set("canFocus", share);
    } else {
      if (!this.belongDepartment()) {
        this.set("canFocus", share);
      }
    }
    this.set("isSharing", share);
  },
  isMine: function isMine() {
    return this.get("ownerId") == app.currentUser.getUserId();
  },
  teamCreateByMe: function teamCreateByMe() {
    return this.isTeamFolder() && this.isCreator();
  },
  isRoot: function isRoot() {
    return this.getFileId() == "0";
  },
  getFileNameWithoutExt: function getFileNameWithoutExt() {
    var name = this.getFileName();
    name = name || "";
    if (!this.isFolder() && name) {
      var dotIndex = name.lastIndexOf(".");
      name = dotIndex < 0 ? name : name.substring(0, dotIndex);
    }
    return name;
  },
  getFileExtension: function getFileExtension() {
    var extension = "";
    var name = this.getFileName() || "";
    if (!this.isFolder()) {
      var dotIndex = name.lastIndexOf(".");
      if (dotIndex >= 0) {
        extension = name.substring(dotIndex + 1);
      }
    }
    return extension.toLocaleLowerCase();
  },
  getLowerCaseExt: function getLowerCaseExt() {
    return this.getFileExtension().toLowerCase();
  },
  isOwner: function isOwner() {
    var ownerId = this.get("ownerId");
    var curUserId = app.currentUser.getUserId();
    return ownerId === curUserId;
  },
  isCreator: function isCreator() {
    var creatorId = this.get("creatorId");
    var curUserId = app.currentUser.getUserId();
    return creatorId === curUserId;
  },
  getFullFileName: function getFullFileName() {
    var sb = [];
    sb.push(this.getFileName());
    if (!this.isFolder()) {
      sb.push(".");
      sb.push();
    }
    return sb.join("");
  },
  listDir: function listDir(type, success, fail) {
    if (typeof type === "function") {
      fail = success;
      success = type;
      type = MMNetDiskDataController.LISTTYPES.ALL;
    }
    if (this.isFolder()) {
      MMNetDiskDataController.listDir(this.getFileId(), type, success, fail);
    } else {
      _.delay(function () {
        fail("not a folder");
      }, 0);
    }
  },
  listDirWithType: function listDirWithType(type, success, fail) {
    if (this.isFolder()) {
      MMNetDiskDataController.listDir(null, type, success, fail);
    } else {
      _.delay(function () {
        fail("not a folder");
      }, 0);
    }
  },
  getShareURL: function getShareURL(success, fail) {
    var isHttps;
    if (location.protocol == "https:") {
      isHttps = true;
    } else {
      isHttps = false;
    }
    MMNetDiskDataController.getShareUrl(this.getFileId(), isHttps, success, fail);
  },
  getShareParticipants: function getShareParticipants(success, fail) {
    var self = this;
    MMNetDiskDataController.getShareParticipants(this.getFileId(), function (collection) {
      if (success) {
        success(collection, self);
      }
    }, fail);
  },
  setFilePassword: function setFilePassword(password, success, fail) {
    var isHttps;
    if (location.protocol == "https:") {
      isHttps = true;
    } else {
      isHttps = false;
    }
    MMNetDiskDataController.setFilePassword(this.getFileId(), password, isHttps, success, fail);
  },
  listVersions: function listVersions(startIndex, pageSize, success, fail) {
    MMNetDiskDataController.getFileVersionsByFileInfo(this, startIndex, pageSize, success, fail);
  },
  hasMultiVersions: function hasMultiVersions() {
    var ver = parseInt(this.get("latestVer"));
    if (this.isBabelOffice()) {
      return ver > 1;
    }
    return ver > 0;
  },
  setIconForDiv: function setIconForDiv($div, large, size, hideThumbnail, fullfill, otherParams) {
    var size = size || 40;
    $div.attr("style", "");
    if (this.isMsAnonyBox()) {
      $div.addClass("msanonybox");
    } else {
      $div.removeClass("msanonybox");
    }
    if (this.get("snapShare")) {
      $div.addClass("snap-share");
    } else {
      $div.removeClass("snap-share");
    }
    var ver = this.getCurVersion();
    if (this.isDeleteVersion()) {
      ver = this.get("deleteVersion");
    }
    var noThumbnail = false;
    if (hideThumbnail) {
      var officeAndPdfFiles = ["doc", "docx", "xls", "xlsx", "ppt", "pptx", "pdf"];
      var ext = this.getLowerCaseExt();
      var index = _.findIndex(officeAndPdfFiles, function (officeExt) {
        return officeExt == ext;
      });
      if (index > -1) {
        noThumbnail = true;
      }
    }
    if (otherParams && otherParams.noThumbnail) {
      noThumbnail = otherParams.noThumbnail;
    }
    _MMFileIconMaker["default"].setIconForDiv(this, ver, $div, null, large, size, fullfill, noThumbnail, otherParams);
    this.refreshSyncIcon($div);
  },
  loadThumb: function loadThumb(callback) {
    var _this = this;
    var path = _MMFileIconMaker["default"]._getThumbnailPath(this, -1, 300);
    var retry = 1;
    var loadImg = function loadImg() {
      var currentXhr = _this.get("thumbCurrentXhr");
      if (currentXhr) {
        currentXhr.abort();
        currentXhr = null;
      }
      currentXhr = new XMLHttpRequest();
      currentXhr.open('GET', path, true);
      currentXhr.responseType = 'blob';
      currentXhr.onload = function () {
        if (currentXhr.status === 200) {
          var blob = currentXhr.response;
          if (blob.type == "application/json") {
            currentXhr = null;
            return;
          }
          var imgUrl = URL.createObjectURL(blob);
          var img = new Image();
          img.src = imgUrl;
          callback(img);
        } else {
          console.error('图片加载失败，状态码:', currentXhr.status);
          if (retry++ < 3) {
            console.log("重试加载图片:" + retry);
            setTimeout(function () {
              loadImg();
            }, 1000 * 60 * retry);
          } else {
            currentXhr = null;
          }
        }
        _this.set("thumbCurrentXhr", currentXhr);
      };
      currentXhr.onerror = function () {
        console.error('请求发生错误');
        currentXhr = null;
        _this.set("thumbCurrentXhr", currentXhr);
      };
      currentXhr.send();
      _this.set("thumbCurrentXhr", currentXhr);
    };
    loadImg();
  },
  cancelLoadThumb: function cancelLoadThumb() {
    var currentXhr = this.get("thumbCurrentXhr");
    if (currentXhr) {
      currentXhr.abort();
      currentXhr = null;
      console.log('图片加载已取消');
    }
  },
  refreshShareIcon: function refreshShareIcon($div) {
    if (this.isSharing() || this.get("snapShare")) {
      $div.find("i").removeClass("ver-icon");
      if (!this.get("teamMark")) {
        $div.find("i").addClass("share-icon");
      }
      $div.find("i").removeClass("synced-icon");
    } else {
      $div.find("i").removeClass("share-icon");
      if (this.hasMultiVersions() && !this.isDeleteVersion()) {
        $div.find("i").addClass("ver-icon");
        $div.find("i").removeClass("synced-icon");
      } else {
        $div.find("i").removeClass("ver-icon");
      }
    }
  },
  isFolderSynced: function isFolderSynced() {
    return this.isFolder() && app.isFolderSynced(this.getFileId());
  },
  refreshSyncIcon: function refreshSyncIcon($div) {
    if (this.isFolderSynced()) {
      $div.find("i").removeClass("ver-icon");
      $div.find("i").removeClass("share-icon");
      $div.find("i").addClass("synced-icon");
    } else if (!this.isFolderSynced() && this.isFolder() && app && app.pathRouter && app.pathRouter.isInSyncFolderPath && app.pathRouter.isInSyncFolderPath()) {
      $div.find("i").addClass("synced-icon");
      this.refreshShareIcon($div);
    } else {
      $div.find("i").removeClass("synced-icon");
      this.refreshShareIcon($div);
    }
  },
  refreshFileStatusIcon: function refreshFileStatusIcon($div) {
    this.refreshSyncIcon($div);
  },
  setCurVersion: function setCurVersion(ver, versionInfor) {
    var vList = this.getFileVersionList();
    if (!vList) {
      return;
    }
    if (!versionInfor) {
      versionInfor = vList.findWhere({
        ver: ver.toString()
      });
    }
    if (!versionInfor) {
      return;
    }
    this.set("thumbnailPath", null);
    this.set("currentVerCommitterId", versionInfor.get("committerId"));
    this.set("currentVersionSize", versionInfor.get("fileSize"));
    if (vList) {
      vList.each(function (veritem) {
        veritem.setCurVersion(ver, versionInfor);
      });
    }
    return this.set("currentVersion", ver, {
      versionInfor: versionInfor
    });
  },
  setCurVersionWithVerNum: function setCurVersionWithVerNum(ver, opt) {
    this.set("currentVersion", ver, opt);
  },
  getCurVersion: function getCurVersion() {
    return this.get("currentVersion");
  },
  getVersionNo: function getVersionNo() {
    if (this.isFolder()) {
      return "--";
    } else if (_.isUndefined(this.get("versionNo")) || _.isNull(this.get("versionNo"))) {
      return Number.parseInt(this.get("currentVersion")) + 1;
    }
    return this.get("versionNo");
  },
  canDispInEditor: function canDispInEditor() {
    if (!this.canRead()) {
      return false;
    }
    var fileName = this.getFileName();
    if (this.isShortcuts()) {
      fileName = "xx." + this.get("linkedFileExt");
    }
    if (this.getLinkFileUrl()) {
      return true;
    }
    return _MMCommonFun["default"].fileCanDispInEditor(fileName) || this.canEditWithTextEditer();
  },
  canDispInOpenGL: function canDispInOpenGL() {
    if (this.isArchived() && !this.canRead()) {
      return false;
    }
    var fileName = this.getFileName();
    if (this.isShortcuts()) {
      fileName = "xx." + this.get("linkedFileExt");
    }
    return _MMCommonFun["default"].fileCanDispInOpenGL(fileName);
  },
  canDispInWebBrowser: function canDispInWebBrowser() {
    if (this.isArchived() && !this.canRead()) {
      return false;
    }
    var fileName = this.getFileName();
    return _MMCommonFun["default"].fileCanDispInWebBrowser(fileName);
  },
  isOnlyDisp: function isOnlyDisp() {
    return this.get("onlyDisp");
  },
  setOnlyDisp: function setOnlyDisp(onlyDisp) {
    this.set("onlyDisp", onlyDisp);
  },
  isImage: function isImage() {
    var name = this.getFileName();
    return _MMCommonFun["default"].isImageName(name);
  },
  hasMetaData: function hasMetaData() {
    if (this.isFolder() || this.isShortcuts()) {
      return false;
    }
    var name = this.getFileName();
    return _MMCommonFun["default"].hasMetaData(name);
  },
  isImageNeedConvert: function isImageNeedConvert() {
    var name = this.getFileName();
    return _MMCommonFun["default"].isImageNeedConvert(name);
  },
  isImageNotNeedConvert: function isImageNotNeedConvert() {
    var name = this.getFileName();
    return _MMCommonFun["default"].isImageNotNeedConvert(name);
  },
  canCopyToClipBoard: function canCopyToClipBoard() {
    var name = this.getFileName();
    return _MMCommonFun["default"].canCopyToClipBoard(name);
  },
  isPdf: function isPdf() {
    var name = this.getFileName();
    return _MMCommonFun["default"].isPdfName(name);
  },
  isAudio: function isAudio() {
    var name = this.getFileName();
    return _MMCommonFun["default"].isAudioName(name);
  },
  isVideo: function isVideo() {
    var name = this.getFileName();
    return _MMCommonFun["default"].isVideoName(name);
  },
  isMp4: function isMp4() {
    var ext = this.getLowerCaseExt();
    return ext == "mp4";
  },
  isMp3: function isMp3() {
    var ext = this.getLowerCaseExt();
    return ext == "mp3";
  },
  isVideoNeedConvert: function isVideoNeedConvert() {
    var ext = this.getLowerCaseExt();
    var arr = ["mkv", "avi", "3gp"];
    return _.indexOf(arr, ext) > -1;
  },
  isAiImg: function isAiImg() {
    if (this.isFolder()) {
      return false;
    }
    var ext = this.getLowerCaseExt();
    var arr = window.supportAiImgSearchFiles;
    return _.indexOf(arr, ext) > -1;
  },
  isFlv: function isFlv() {
    var ext = this.getLowerCaseExt();
    return ext == "flv";
  },
  isVideoDirectlyPlay: function isVideoDirectlyPlay() {
    var ext = this.getLowerCaseExt();
    var arr = ["flv", "mov", "mp4", "webm", "ogg", "mkv"];
    return _.indexOf(arr, ext) > -1;
  },
  isAudioDirectlyPlay: function isAudioDirectlyPlay() {
    var ext = this.getLowerCaseExt();
    var arr = ["mp3", "wav", "flac", "m4a", "aac", "ogg", "m4r"];
    return _.indexOf(arr, ext) > -1;
  },
  isMail: function isMail() {
    var name = this.getFileName();
    return _MMCommonFun["default"].isEmailName(name);
  },
  getMediaType: function getMediaType() {
    var name = this.getFileName();
    return _MMCommonFun["default"].getMediaType(name);
  },
  belongsToCurrentUserEnterprise: function belongsToCurrentUserEnterprise() {
    return this.get("enterpriseId") == app.currentUser.get("enterpriseId");
  },
  getEnterpriseId: function getEnterpriseId() {
    return this.get("enterpriseId");
  },
  isEpPublicFolder: function isEpPublicFolder() {
    return this.get("enterprisePub") == 1 || this.get("enterprisePub") == 2;
  },
  getEnterprisePub: function getEnterprisePub() {
    return this.get("enterprisePub");
  },
  isLibraryFiles: function isLibraryFiles() {
    var enterprisePub = this.getEnterprisePub();
    return enterprisePub == 3 || enterprisePub == 4 || enterprisePub == 5 || enterprisePub == 6;
  },
  isMaterialLibrary: function isMaterialLibrary() {
    var enterprisePub = this.getEnterprisePub();
    return enterprisePub == 3;
  },
  isMaterialClass: function isMaterialClass() {
    var enterprisePub = this.getEnterprisePub();
    return enterprisePub == 4;
  },
  isMaterialLibraryFolder: function isMaterialLibraryFolder() {
    var enterprisePub = this.getEnterprisePub();
    return enterprisePub == 5;
  },
  beloneMaterialLibrary: function beloneMaterialLibrary() {
    var enterprisePub = this.getEnterprisePub();
    return enterprisePub == 6;
  },
  setActions: function setActions(actions) {
    this.set("actions", actions);
  },
  getActions: function getActions(actions) {
    return this.get("actions");
  },
  isNotCalcActions: function isNotCalcActions(actions) {
    return _.isUndefined(this.getActions());
  },
  isNoActions: function isNoActions(actions) {
    return !this.isNotCalcActions() && !(this.get("actions") & 1);
  },
  // 权限判断部分开始
  canRead: function canRead() {
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].READ);
  },
  canReadComment: function canReadComment() {
    if (app.userBeingViewed) {
      return false;
    }
    if (this.isOwner()) {
      return true;
    } else {
      return !!(this.get("actions") & _FILE_ACTION_BITS["default"].COMMENT_READ);
    }
  },
  canReadCommentOnlyByAction: function canReadCommentOnlyByAction() {
    if (this.isArchiveHouse || this.isShortcuts()) {
      return false;
    }
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].COMMENT_READ) || this.getFileId() == "0" && !this.get("multFile");
  },
  canCreateFolder: function canCreateFolder() {
    if (app.currentUser.isAnonymous()) {
      return false;
    }
    if (this.isMaterialLibrary() || this.isMaterialClass()) {
      return false;
    }
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].WRITE);
  },
  canShare: function canShare() {
    if (app.currentUser.isAnonymous()) {
      return this.canManageSharePermission();
    }
    if (app.pathRouter && app.pathRouter.isInMsgBoxFolderPath && app.pathRouter.isInMsgBoxFolderPath()) {
      return false;
    }
    if (!app.currentUser.get("isOpenPersonalShare")) {
      if (this.isOwner()) {
        return false;
      }
    }
    if (this.get("multFile")) {
      return;
    }
    if (this.get("templateStoreFolderId")) {
      return false;
    }
    if (this.isSnapshotFile()) {
      return;
    }
    if (this.isTemplateStore()) {
      return false;
    }
    if (this.isDeleted()) {
      return false;
    }
    if (!this.canRead()) {
      return false;
    }
    if (this.getFileId() == 0) {
      return false;
    }
    if (this.isShortcuts() || this.isManuscriptBox()) {
      return false;
    }
    if (app.userBeingViewed) {
      return false;
    }
    if (this.isTeamFolder() || this.isDepartmentFolder() || this.getEnterprisePub() || this.isTransitStation() || this.isReadingRoom()) {
      return false;
    }
    if (this.isArchived()) {
      return false;
    }
    if (this.isProject()) {
      return false;
    }
    if (this.isHQSMProject()) {
      return false;
    }
    return true;
  },
  canManageSharePermission: function canManageSharePermission() {
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].SHARE);
  },
  canMove: function canMove() {
    if (app.currentUser.isAnonymous()) {
      return false;
    }
    if (this.getFileId() == 0) {
      return false;
    }
    if (app.userBeingViewed) {
      return false;
    }
    if (!this.isReady()) {
      return false;
    }
    if (this.isHQSMProject()) {
      return false;
    }
    if (this.isDeleted()) {
      return false;
    }
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].MOVE);
  },
  canArchive: function canArchive() {
    if (app.currentUser.isAnonymous()) {
      return false;
    }
    if (this.getFileId() == 0 || this.isShortcuts()) {
      return false;
    }
    if (app.userBeingViewed) {
      return false;
    }
    if (!this.isReady()) {
      return false;
    }
    if (this.isDeleted()) {
      return false;
    }
    if (this.isFolder()) {
      return false;
    }
    if (this.isTemplateStore() || this.get("templateStoreFolderId")) {
      return false;
    }
    if (this.isDepartmentFolder()) {
      return false;
    }
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].ARCHIVE);
  },
  canDownload: function canDownload() {
    // .survey 只是指向 Formbricks 的指针文件，下载无意义
    if (this.isSurveyFile()) {
      return false;
    }
    if (this.ipCannotDownload()) {
      return false;
    }
    if (this.get("multFile")) {
      return;
    }
    if (this.getFileId() == 0) {
      return false;
    }
    if (app.ep.isArchive() && this.isDepartmentFolder()) {
      return false;
    }
    if (!app.isInClient() && this.isDepartmentFolder()) {
      return false;
    }
    if (this.getDownloadNeedApply()) {
      return false;
    }
    if (this.isOwner() && !this.isArchived()) {
      return true;
    } else {
      return !!(this.get("actions") & _FILE_ACTION_BITS["default"].DOWNLOAD);
    }
  },
  getDownloadNeedApply: function getDownloadNeedApply() {
    return this.get("download_needApply");
  },
  getCanApplyJoin: function getCanApplyJoin() {
    return this.get("canApplyJoin");
  },
  setIpCannotDownload: function setIpCannotDownload() {
    this.set("ipCannotDownload", true);
  },
  ipCannotDownload: function ipCannotDownload() {
    return this.get("ipCannotDownload");
  },
  canSendFile: function canSendFile() {
    if (this.isFolder()) {
      return false;
    }
    if (!this.canShare()) {
      return false;
    }
    if (!this.canDownload()) {
      return false;
    }
    return true;
  },
  canDownloadPassedPdf: function canDownloadPassedPdf() {
    if (!this.canDownload() || !this.isPassed()) {
      return false;
    }
    return this.canCoverToPdf();
  },
  ifNeedWindowsServer: function ifNeedWindowsServer() {
    var ext = this.getLowerCaseExt();
    var coverPdfFiles = ["dwg", "dwt", "dxf", "indd", "indt", "idml", "doc", "docx", "ppt", "pptx", "xls", "xlsx", "txt", "rtf", "wps", "wpt", "dps", "dpt", "et", "ett", "stl", "x3d", "fbx", "obj", "ply", "3ds", "abc"];
    var index = _.findIndex(coverPdfFiles, function (officeExt) {
      return officeExt == ext;
    });
    return index != -1;
  },
  canUseOCRFinal: function canUseOCRFinal() {
    return this.canUseOCR() && !app.ep.isArchive() && window.isOpenOneFileAI && !app.currentUser.isCloseAI() && !app.currentUser.isAnonymous() && window.supportAI;
  },
  canUseOCR: function canUseOCR() {
    var ext = this.getLowerCaseExt();
    var ocrFiles = window.supportOcrFiles;
    var index = _.findIndex(ocrFiles, function (officeExt) {
      return officeExt == ext;
    });
    return index != -1;
  },
  canUseAITaginal: function canUseAITaginal() {
    return this.canUseAITag() && !app.ep.isArchive() && window.isOpenOneFileAI && !app.currentUser.isCloseAI() && !app.currentUser.isAnonymous() && window.supportAI;
  },
  canUseAITag: function canUseAITag() {
    var ext = this.getLowerCaseExt();
    var ocrFiles = window.suppertAITags;
    var index = _.findIndex(ocrFiles, function (officeExt) {
      return officeExt == ext;
    });
    return index != -1;
  },
  canCoverToPdf: function canCoverToPdf() {
    var ext = this.getLowerCaseExt();
    var coverPdfFiles = ["jpeg", "jpg", "png", "bmp", "gif", "pdf", "ai", "svg", "eps", "ico", "doc", "docx", "ppt", "pptx", "xls", "xlsx", "rtf", "wps", "wpt", "dps", "dpt", "et", "ett", "key", "numbers", "pages", "dwg", "dwt", "dxf", "indd", "indt", "idml", "epub", "psd", "tif", "tiff", "cr2", "arw", "dng", "nef", "pef", "dcm", "heic"];
    var index = _.findIndex(coverPdfFiles, function (officeExt) {
      return officeExt == ext;
    });
    return index != -1;
  },
  canCopy: function canCopy() {
    // 复制出的 .survey 拿到新 fileId，与 Formbricks 的映射对不上，会成为打不开的孤儿文件
    if (this.isSurveyFile()) {
      return false;
    }
    if (this.getFileId() == 0) {
      return false;
    }
    if (app.userBeingViewed) {
      return false;
    }
    if (!this.isReady()) {
      return false;
    }
    if (this.isTeamFolder()) {
      return false;
    }
    if (this.isHQSMProject()) {
      return false;
    }
    if (this.isProject()) {
      return false;
    }
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].COPY);
  },
  canStickonTop: function canStickonTop() {
    if (this.get("applyForTeamOrProj")) {
      return false;
    }
    if (!this.canRead()) {
      return false;
    }
    if (this.isMaterialLibrary()) {
      return false;
    }
    if (app.currentUser.isAnonymous()) {
      return false;
    }
    if (this.getFileId() == 0) {
      return false;
    }
    var pathRouter = app.pathRouter;
    if (pathRouter.isRecently()) {
      return false;
    }
    if (this.isMultFile()) {
      return false;
    }
    if (pathRouter.isInChannelRoot()) {
      return true;
    }
    if (this.isOwner()) {
      return true;
    }
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].STICK_TO_TOP);
  },
  canDelete: function canDelete() {
    if (app.currentUser.isAnonymous() || this.isArchiveHouse) {
      return false;
    }
    if (this.getFileId() == 0) {
      return false;
    }
    if (this.isEpPublicFolder()) {
      return false;
    }
    if (app.userBeingViewed) {
      return false;
    }
    if (this.isDepartmentFolder() && this.getParentFolderId() == 0) {
      return false;
    }
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].DELETE);
  },
  canUnlock: function canUnlock() {
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].UNLOCK);
  },
  canDelVersion: function canDelVersion() {
    if (app.currentUser.isAnonymous()) {
      return false;
    }
    if (this.getFileId() == 0) {
      return false;
    }
    if (app.userBeingViewed) {
      return false;
    }
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].DELETE);
  },
  canRename: function canRename() {
    if (app.currentUser.isAnonymous()) {
      return false;
    }
    if (app.userBeingViewed) {
      return false;
    }
    if (this.getFileId() == 0) {
      return false;
    }
    if (this.isProject() && this.get("parentId") == "0") {
      return false;
    }
    if (!this.isReady()) {
      return false;
    }
    if (this.isTeamFolder() || this.isTimeExpired()) {
      return false;
    }
    if (this.isHQSMProject()) {
      return false;
    }
    if (this.isDepartmentFolder() && this.getParentFolderId() == 0) {
      return false;
    }
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].RENAME);
  },
  canUpload: function canUpload() {
    if (app.userBeingViewed) {
      return false;
    }
    if (this.isMaterialLibrary()) {
      return false;
    }
    if (this.isMaterialClass()) {
      return false;
    }
    if (app.isEpVersion() && this.isOwner() && !app.currentUser.canOwnFile()) {
      return false;
    }
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].UPLOAD);
  },
  canUploadOnlyActions: function canUploadOnlyActions() {
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].UPLOAD);
  },
  canUploadVersion: function canUploadVersion() {
    // .survey 内容存在 Formbricks 侧，上传新版本会覆盖破坏指针
    if (this.isSurveyFile()) {
      return false;
    }
    if (app.userBeingViewed) {
      return false;
    }
    if (this.isFileLocked() && !this.isFileLockedByMe()) {
      return false;
    }
    if (!this.isReady()) {
      return false;
    }
    if (this.isFolder() || this.isShortcuts()) {
      return false;
    }
    if (this.getLinkFileUrl()) {
      return false;
    }
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].UPLOADVERSION);
  },
  canUploadVersionIgnoreLocked: function canUploadVersionIgnoreLocked() {
    if (app.userBeingViewed) {
      return false;
    }
    if (this.getLinkFileUrl()) {
      return false;
    }
    if (this.isFileLocked() && this.get("lockedByUser") != "-1" && !this.isFileLockedByMe()) {
      return false;
    }
    if (!this.isReady()) {
      return false;
    }
    if (this.isFolder() || this.isShortcuts()) {
      return false;
    }
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].UPLOADVERSION);
  },
  canUploadVersionOnlyActions: function canUploadVersionOnlyActions() {
    if (app.userBeingViewed) {
      return false;
    }
    if (!this.isReady()) {
      return false;
    }
    if (this.isFolder() || this.isShortcuts()) {
      return false;
    }
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].UPLOADVERSION);
  },
  canListVersion: function canListVersion() {
    if (this.isFolder() || this.isShortcuts()) {
      return false;
    }
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].LIST_ALL_VERSION);
  },
  canSetCurrentVersion: function canSetCurrentVersion() {
    if (app.currentUser.isAnonymous()) {
      return false;
    }
    if (this.isFileLocked() && !this.isFileLockedByMe()) {
      return false;
    }
    if (this.isFolder()) {
      return false;
    }
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].SET_CURRENT_VERSION);
  },
  canLeaveShare: function canLeaveShare() {
    if (this.isDepartmentFolder() || this.isArchiveHouse) {
      return false;
    }
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].LEAVE);
  },
  canCreateComment: function canCreateComment() {
    if (app.currentUser.isAnonymous() || this.isArchiveHouse) {
      return false;
    }
    if (!this.dispNeedWhiteBoard() || this.dispWithSVG()) {
      return false;
    }
    if (this.canDispInWebBrowser() && !this.isOwner() && this.getParentFolderId() == 0) {
      return false;
    }
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].COMMENT_CREATE);
  },
  canCreateCommentIgnoreLogined: function canCreateCommentIgnoreLogined() {
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].COMMENT_CREATE);
  },
  canDelMyComment: function canDelMyComment() {
    if (app.currentUser.isAnonymous()) {
      return false;
    }
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].COMMENT_DEL);
  },
  canFinishComment: function canFinishComment() {
    if (app.currentUser.isAnonymous()) {
      return false;
    }
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].COMMENT_FINISH);
  },
  canManageTag: function canManageTag() {
    if (app.currentUser.isAnonymous()) {
      return false;
    }
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].TAG);
  },
  canReadFileLog: function canReadFileLog() {
    if (app.ep && app.ep.isArchive() && app.pathRouter.isInRoot() || this.isArchiveHouse) {
      return false;
    }
    if (this.get("multFile")) {
      return;
    }
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].LOG) || this.getFileId() == "0";
  },
  hasPassword: function hasPassword() {
    return this.getFileStatus() == _MMFileConvertStatus["default"].HasPassword;
  },
  canEdit: function canEdit() {
    var canEditFiles = ["md", "txt", "js", "txt", "xml"];
    var ext = this.getFileExtension().toLowerCase();
    var index = _.findIndex(canEditFiles, function (notExt) {
      return notExt == ext;
    });
    return index != -1;
  },
  canStartEvaluation: function canStartEvaluation() {
    if (app.currentUser.isAnonymous()) {
      return false;
    }
    if (this.getLinkFileUrl()) {
      return false;
    }
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].START_EVALUATION);
  },
  isOnlyUpload: function isOnlyUpload() {
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].ONLY_UPLOAD);
  },
  canPrint: function canPrint() {
    if (this.canDispInOpenGL() || this.canDispInWebBrowser() || !this.dispNeedWhiteBoard()) {
      return false;
    }
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].PRINT);
  },
  canManageSecret: function canManageSecret() {
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].MANAGE_SECRET);
  },
  canEditProject: function canEditProject() {
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].EDIT_PROJECT);
  },
  onlyReadName: function onlyReadName() {
    return !!(this.get("actions") & _FILE_ACTION_BITS["default"].ONLY_READ_NAME);
  },
  canCreateProject: function canCreateProject() {
    if (this.isDepartmentFolder() && this.canCreateFolder()) {
      return true;
    }
    if (!app.currentUser.get("isOpenPersonalShare")) {
      if (this.isOwner()) {
        return false;
      }
    }
    if (this.isProject() && !this.isSubProject() && this.canEditProject()) {
      return true;
    }
    if (app.pathRouter && app.pathRouter.inDepartment()) {
      return true;
    }
    return false;
  },
  canCreateFolderDir: function canCreateFolderDir() {
    if (app.ep && app.ep.isArchive() || this.isArchived()) {
      return false;
    }
    return this.canManageFilePermission() && !this.isEpPublicFolder() && !this.belongEnterprisePub();
  },
  isShareAll: function isShareAll() {
    return this.get("shareAll");
  },
  setShareAll: function setShareAll(shareAll) {
    this.set("shareAll", shareAll);
  },
  getUnReadCount: function getUnReadCount() {
    return this.get("unreadFileCount");
  },
  setUnReadCount: function setUnReadCount(count) {
    if (isNaN(count)) {
      return;
    }
    this.set("unreadFileCount", count);
  },
  setCommentCount: function setCommentCount(count) {
    this.set("commentCount", count);
  },
  appendVersion: function appendVersion(version) {
    var vList = this.getFileVersionList();
    if (vList) {
      vList.add(version);
    }
  },
  getVersionInfo: function getVersionInfo(ver) {
    var verInfos = this.get("versionList");
    if (verInfos) {
      return verInfos.findWhere({
        ver: ver + ""
      });
    }
    return null;
  },
  getFileVersionList: function getFileVersionList(force, success, fail) {
    var verInfos = this.get("versionList");
    if (!force) {
      return verInfos;
    }
    MMNetDiskDataController.getFileVersionsByFileInfo(this, function () {
      success && success();
    }, function () {
      if (fail) {
        fail();
      }
    });
  },
  isVerCommitter: function isVerCommitter(ver, success, fail) {
    var verInfos = this.get("versionList");
    if (verInfos) {
      var verInfo = verInfos.findWhere({
        ver: ver + ""
      });
      if (verInfo) {
        success(verInfo.isCommitter());
      } else {
        success();
      }
    } else if (ver == this.getCurVersion()) {
      success(this.isCommitter());
    } else {
      MMNetDiskDataController.getFileVersionsByFileInfo(this, function (versionInfos) {
        var verInfo = versionInfos.findWhere({
          ver: ver + ""
        });
        if (verInfo) {
          success(verInfo.isCommitter());
        } else {
          success();
        }
      }, fail);
    }
  },
  isCurVersion: function isCurVersion(ver) {
    if (ver instanceof _MMVersionInfo["default"]) {
      ver = ver.get("ver");
    }
    return this.getCurVersion() == ver;
  },
  getRoleId: function getRoleId() {
    return this.get("roleId");
  },
  setRoleId: function setRoleId(id) {
    this.set("roleId", id);
  },
  getTeamInfo: function getTeamInfo() {
    return this.get("teamInfo");
  },
  setTeamInfo: function setTeamInfo(teamInfo) {
    this.set("teamInfo", teamInfo);
  },
  isCurUserManager: function isCurUserManager() {
    return this.get("permission") == 65535;
  },
  isTeamFolder: function isTeamFolder() {
    return this.get("teamMark") == 1;
  },
  isDepartmentFolder: function isDepartmentFolder() {
    return this.get("teamMark") == 2;
  },
  isTransitStation: function isTransitStation() {
    return this.get("teamMark") == 3;
  },
  isProject: function isProject() {
    return this.get("teamMark") == 5;
  },
  isReadingRoom: function isReadingRoom() {
    return this.get("teamMark") == 6;
  },
  isHQSMProject: function isHQSMProject() {
    return this.get("teamMark") == 7;
  },
  isTemplateStore: function isTemplateStore() {
    return this.get("teamMark") == 11;
  },
  isMultFile: function isMultFile() {
    return this.get("multFile");
  },
  isSubProject: function isSubProject() {
    if (!this.belongProject()) {
      return false;
    }
    return this.isProject();
  },
  isEncryptedFolder: function isEncryptedFolder() {
    return this.get("teamMark") == 14;
  },
  isBackupPolicyFolder: function isBackupPolicyFolder() {
    // 备份策略文件夹   
    return this.get("teamMark") == 17;
  },
  isBeloneEncryptedFolder: function isBeloneEncryptedFolder() {
    return this.get("encryptedFileIds") && this.get("encryptedFileIds").length;
  },
  canManageFile: function canManageFile() {
    var isCurTeamManager = app.pathRouter && app.pathRouter.isCurTeamManager && app.pathRouter.isCurTeamManager();
    return isCurTeamManager || this.isCurUserManager();
  },
  canManageShareMember: function canManageShareMember() {
    if (this.isSharing() || this.isTeamFolder()) {
      return this.isOwner() || this.isCurUserManager() || this.isSharer();
    }
  },
  getOwnerName: function getOwnerName() {
    return this.get("ownerName");
  },
  getOwnerId: function getOwnerId() {
    return this.get("ownerId");
  },
  isTimeExpired: function isTimeExpired() {
    var teamInfo = this.getTeamInfo();
    if (this.isTeamFolder() && teamInfo) {
      var today = app.pathRouter.getToday();
      return teamInfo.calculateRemainDay(today) == 0;
    }
    return false;
  },
  getSharerId: function getSharerId() {
    return this.get("sharerId");
  },
  getSharerName: function getSharerName() {
    return this.get("sharerName");
  },
  setSharerId: function setSharerId(id) {
    return this.set("sharerId", id);
  },
  setSharerName: function setSharerName(name) {
    return this.set("sharerName", name);
  },
  isSharer: function isSharer() {
    return this.getSharerId() == app.currentUser.getUserId();
  },
  getPermission: function getPermission() {
    return this.get("permission");
  },
  setPermission: function setPermission(permission) {
    return this.set("permission", permission);
  },
  belongsToTeam: function belongsToTeam() {
    var inTeam = this.get("belongTeam");
    return inTeam;
  },
  belongDepartment: function belongDepartment() {
    var inDep = this.get("belongDepartment");
    return inDep;
  },
  belongProject: function belongProject() {
    return this.get("belongProject");
  },
  belongTransmittalProject: function belongTransmittalProject() {
    return this.get("transmittalProjectId");
  },
  belongQuickSend: function belongQuickSend() {
    return this.get("belongQuickSend");
  },
  showMyFileColor: function showMyFileColor() {
    var showMine = false;
    if (this.isTeamFolder()) {
      if (this.isCreator() || this.canManageFile()) {
        showMine = true;
      }
    } else {
      if (this.belongsToTeam()) {
        if (this.isCreator() || this.canManageFile()) {
          showMine = true;
        }
      } else {
        if (this.isOwner()) {
          showMine = true;
        }
      }
    }
    return showMine;
  },
  userBelongToTeam: function userBelongToTeam() {
    return this.get("userBelongToTeam");
  },
  canUseOnlyOffice: function canUseOnlyOffice() {
    return true;
  },
  setUploadStatus: function setUploadStatus(uploadStatus) {
    this.set("uploadStatus", uploadStatus);
  },
  getUploadStatus: function getUploadStatus() {
    return this.get("uploadStatus");
  },
  isInTrash: function isInTrash() {
    return this.get("inTrash") || this.get("status") == 1 || this.isDeleteVersion();
  },
  getStickonTop: function getStickonTop() {
    if (this.isArchived()) {
      return false;
    }
    return this.get("stickontop");
  },
  setStickonTop: function setStickonTop(onTop) {
    this.set("stickontop", onTop);
  },
  changeStickontop: function changeStickontop(newStickontop, success) {
    newStickontop = newStickontop ? 1 : 0;
    var currentStickontop = this.getStickonTop();
    if (newStickontop != currentStickontop) {
      this.set("stickontop", newStickontop);
    } else {
      setBabelTimeout(success, 0);
    }
    return this;
  },
  getStarmark: function getStarmark() {
    return this.get("starmark");
  },
  changeStarmark: function changeStarmark(newStarmark, success, fail) {
    newStarmark = newStarmark ? 1 : 0;
    var currentStarmark = this.getStarmark();
    if (newStarmark != currentStarmark) {
      this.set("starmark", newStarmark);
      var self = this;
      if (newStarmark) {
        MMNetDiskDataController.addStarmarkFile(this.getFileId(), success, function f() {
          self.set("starmark", currentStarmark);
          if (fail) fail();
        });
      } else {
        MMNetDiskDataController.removeStarmarkFile(this.getFileId(), success, function f() {
          self.set("starmark", currentStarmark);
          if (fail) fail();
        });
      }
    } else {
      setBabelTimeout(success, 0);
    }
    return this;
  },
  getFileStatus: function getFileStatus() {
    return this.get("fileStatus");
  },
  setFileStatus: function setFileStatus(status) {
    this.set("fileStatus", status);
  },
  isReadyToOpen: function isReadyToOpen() {
    var status = this.getFileStatus();
    return status == 0;
  },
  isVersionReadyToOpen: function isVersionReadyToOpen(ver) {
    if (ver == this.getCurVersion() || ver == undefined || ver == -1 || ver == null) {
      return this.isReadyToOpen();
    } else {
      var verInfo = this.getVersionInfo(ver);
      if (verInfo) {
        return verInfo.isFileStatusOK();
      }
    }
    return false;
  },
  isCADFile: function isCADFile() {
    var name = this.getFileName();
    var ext = name.split(".").pop();
    ext = ext.toLowerCase();
    if (ext == "dxf" || ext == "dwg" || ext == "dwt" || ext == "ocf") {
      return true;
    }
  },
  isFileStatusOK: function isFileStatusOK() {
    var status = this.getFileStatus();
    return status == 0;
  },
  readyToDisplay: function readyToDisplay() {
    if (this.isFolder()) {
      if (this.canRead()) {
        return true;
      }
      return false;
    }
    if (this.isArchived()) {
      return this.canRead() || this.getBorrowStatus() > 1 || app.currentUser.canManageArchive();
    } else {
      var status = this.getFileStatus();
      return status == 0 || status == 2 || status == 3 || (this.isPdf() || this.isImage()) && this.canDownload();
    }
  },
  isDeleted: function isDeleted() {
    return this.get("isRemoved") == 1;
  },
  isDeletedOrgin: function isDeletedOrgin() {
    return this.get("status") == 1;
  },
  getFilesInSameFolder: function getFilesInSameFolder() {
    var collection = this.collection;
    var dispArr = [];
    if (collection) {
      dispArr = _.filter(collection.models, function (fInfo) {
        return !fInfo.isFolder() && (fInfo.canDispInEditor() || fInfo.canDispInOpenGL() || fInfo.isVideoDirectlyPlay() || fInfo.isAudioDirectlyPlay());
      });
    }
    return dispArr;
  },
  isPermissionReadonly: function isPermissionReadonly() {
    var permission = this.getPermission();
    return permission == 1;
  },
  setBoard: function setBoard(board) {
    this.board = board;
  },
  getBoard: function getBoard() {
    return this.board;
  },
  getTagCollection: function getTagCollection() {
    var tagCollection;
    if (this.get("tagCollection")) {
      return this.get("tagCollection");
    } else {
      tagCollection = new _MDTagCollection["default"](this.get("tagArray"));
      this.set("tagCollection", tagCollection);
    }
    return tagCollection;
  },
  setTagCollection: function setTagCollection(tags) {
    this.set("tagArray", tags);
  },
  removeTagById: function removeTagById(tagId) {
    var tagCollection = this.getTagCollection();
    tagCollection && tagCollection.remove({
      id: tagId
    });
  },
  removeTag: function removeTag(tagId) {
    this.removeTagById(tagId);
  },
  addTag: function addTag(tag) {
    if (!(tag instanceof _MDTag["default"])) {
      tag = new _MDTag["default"](tag);
    }
    var tagCollection = this.getTagCollection();
    tagCollection && tagCollection.add(tag);
  },
  getTagModelById: function getTagModelById(tagId) {
    var tagCollection = this.getTagCollection();
    if (tagCollection) {
      return tagCollection.find(function (tag) {
        return tag.getId() == tagId;
      });
    }
    return null;
  },
  replaceTag: function replaceTag(oldTagId, newTag) {
    if (!(newTag instanceof _MDTag["default"])) {
      var tempTagData = newTag;
      newTag = new _MDTag["default"]();
      newTag.initWithTagData(tempTagData);
    }
    var tag = this.getTagModelById(oldTagId);
    if (tag) {
      this.removeTagById(oldTagId);
      this.addTag(newTag);
    }
  },
  enableAddTag: function enableAddTag(enabled) {
    this.set("canAddTag", enabled);
  },
  enableDelTag: function enableDelTag(enabled) {
    this.set("canDelTag", enabled);
  },
  canAddTag: function canAddTag() {
    if (!app.currentUser || app.currentUser.isAnonymous() || this.isArchiveHouse || this.isShortcuts()) {
      return false;
    }
    if (this.get("multFile")) {
      return false;
    }
    if (!app.currentUser.canManageArchive() && app.ep.isArchive()) {
      return false;
    }
    return this.get("canAddTag") && true;
  },
  canDelTag: function canDelTag(tagId) {
    if (!app.currentUser || app.currentUser.isAnonymous()) {
      return false;
    }
    var canDelete = false;
    var tagCollection = this.getTagCollection();
    var isTagCreator = false;
    var found = false;
    tagCollection.each(function (tagModel) {
      if (tagModel.getId() == tagId) {
        found = true;
        if (!tagModel.getFileTagCreatorId() || tagModel.getFileTagCreatorId() == app.currentUser.getUserId()) {
          isTagCreator = true;
        }
      }
    });
    if (!found) {
      return true;
    }
    if (this.get("canDelTag") == false) {
      return false;
    }
    if (this.isCreator()) {
      canDelete = true;
    }
    if (isTagCreator) {
      canDelete = true;
    }
    if (this.canManageFile()) {
      canDelete = true;
    }
    if (this.canManageTag()) {
      canDelete = true;
    }
    if (tagId) {
      return this.get("canDelTag") && canDelete;
    } else {
      return this.get("canDelTag");
    }
  },
  getPraisedUsers: function getPraisedUsers() {
    return this.get("praiseArray");
  },
  setPraisedUsers: function setPraisedUsers(users) {
    return this.set("praiseArray", users);
  },
  getFocusCount: function getFocusCount() {
    return this.get("focusCount");
  },
  setFocusCount: function setFocusCount(focusCount, opt_silent) {
    return this.set({
      focusCount: focusCount
    }, {
      silent: opt_silent
    });
  },
  setAccessType: function setAccessType(accessType) {
    return this.set("accessType", accessType);
  },
  getAccessType: function getAccessType() {
    return this.get("accessType");
  },
  getIsFocusFile: function getIsFocusFile() {
    return this.get("isFocusFile");
  },
  setIsFocusFile: function setIsFocusFile(isFocusFile) {
    return this.set("isFocusFile", isFocusFile);
  }
};
var _default = exports["default"] = part1;

},{"1087":1087,"1184":1184,"1415":1415,"1416":1416,"1417":1417,"1421":1421,"1423":1423,"1424":1424,"1425":1425,"1437":1437,"1446":1446,"1449":1449,"1454":1454,"1463":1463,"1466":1466,"1478":1478,"1487":1487,"1538":1538,"1541":1541,"1543":1543,"1545":1545,"235":235,"254":254,"287":287,"288":288,"289":289,"295":295,"296":296,"303":303,"310":310,"72":72,"812":812,"90":90}],812:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require(1180));
var _typeof2 = _interopRequireDefault(require(1197));
require(1421);
require(1450);
require(1476);
require(1477);
require(1478);
require(1489);
require(1465);
require(1437);
require(1418);
require(1463);
require(1537);
require(1493);
require(1431);
require(1466);
require(1432);
require(1410);
require(1411);
require(1423);
require(1530);
require(1505);
require(1506);
require(1507);
require(1508);
require(1510);
require(1509);
require(1512);
require(1513);
require(1514);
require(1516);
require(1517);
require(1518);
require(1519);
require(1521);
require(1520);
require(1522);
require(1523);
require(1524);
require(1525);
require(1526);
require(1527);
require(1528);
require(1529);
require(1429);
require(1492);
require(1425);
require(1419);
require(1487);
require(1471);
require(1412);
require(1538);
require(1545);
require(1543);
require(1541);
require(1498);
require(1416);
require(1415);
require(1434);
require(1503);
require(1500);
require(1420);
require(1428);
require(1515);
require(1424);
require(1496);
var _MDSnackbarView = _interopRequireDefault(require(72));
var _ErrorCode = _interopRequireDefault(require(1087));
var _MMRect = _interopRequireDefault(require(831));
var _vec = _interopRequireDefault(require(839));
var _ObjType = _interopRequireDefault(require(1084));
var _MMPoint = _interopRequireDefault(require(830));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDChannelType = _interopRequireDefault(require(717));
var _MDClientDownloadWinView = _interopRequireDefault(require(484));
var _MDLoadMaskView = _interopRequireDefault(require(49));
var _MEWaterMarkRenderer = _interopRequireDefault(require(808));
/*jslint nomen: true, vars: true, plusplus:true, browser:true */
/*global console, goog, $, _,Int64, MDAudioPlayer, MMCommonFun.isPC*/

var MMCommonFun = {};
MMCommonFun.setDivRect = function (div, rect) {
  var $div = $(div);
  $div.css({
    width: rect.width,
    height: rect.height,
    left: rect.left,
    top: rect.top
  });
};

/**
 * 将一个 div 的宽高缩放后，左上角放置到指定的位置
 * 参数说明：
 *  div - element
 *  scale - number  缩放比例
 *  left - number  左上角 x 位置
 *  top - number  左上角 y 位置
 */
MMCommonFun.placeScaledDiv = function (div, scale, left, top) {
  var $div = $(div);
  $div.css("transform", "scale(1, 1)");
  var centerx = left + $div.width() * scale / 2;
  var centery = top + $div.height() * scale / 2;
  var top_setted = centery - $div.height() / 2;
  var left_setted = centerx - $div.width() / 2;
  $div.css({
    transform: "scale(" + scale + "," + scale + ")",
    "float": "none",
    position: "absolute",
    top: top_setted + "px",
    left: left_setted + "px"
  });
};
MMCommonFun.debugOutputRect = function (title, rect) {
  console.log(title + "(" + rect.left + "," + rect.top + "," + rect.width + "," + rect.height);
};
MMCommonFun.getSessionId = function () {
  var c_name = 'JSESSIONID';
  var c_start;
  var c_end;
  if (document.cookie.length > 0) {
    c_start = document.cookie.indexOf(c_name + "=");
    if (c_start != -1) {
      c_start = c_start + c_name.length + 1;
      c_end = document.cookie.indexOf(";", c_start);
      if (c_end == -1) c_end = document.cookie.length;
      return unescape(document.cookie.substring(c_start, c_end));
    }
  }
};
MMCommonFun.debugOutputArrPts = function (title, pts) {
  //console.log(title + " 共有 " + pts.length + " 个点：");
  var str = "";
  var i;
  for (i = 0; i < pts.length; i++) {
    str += "(" + pts[i].x.toFixed(2) + "," + pts[i].y.toFixed(2) + ")";
  }
  //console.log(str);
};
MMCommonFun.debugOutputArr = function (title, arr) {
  var str = "";
  var i;
  for (i = 0; i < arr.length; i++) {
    str += arr[i] + ", ";
  }
  str = title + " " + str;
  //console.log(str);
};
MMCommonFun.debugOutputDIVRect = function (title, div) {
  var left = $(div).css("left");
  var top = $(div).css("top");
  //console.log(title + "(" + left + "," + top + "," + size.width + "," + size.height + ")");
};

/**
 * 将一组点arrayPts_，围绕旋转中心点centerPt_， 旋转arc_ 弧度
 */
MMCommonFun.rotateAroundPts = function (arrayPts_, centerPt_, arc_) {
  var cos = Math.cos(arc_);
  var sin = Math.sin(arc_);
  var x, y;
  for (var i = 0; i < arrayPts_.length; i++) {
    arrayPts_[i].x = arrayPts_[i].x - centerPt_.x; //没有实现-
    arrayPts_[i].y = arrayPts_[i].y - centerPt_.y; //没有实现-

    x = arrayPts_[i].x;
    y = arrayPts_[i].y;
    arrayPts_[i].x = x * cos - y * sin;
    arrayPts_[i].y = y * cos + x * sin;
    arrayPts_[i].x = arrayPts_[i].x + centerPt_.x; //没有实现+
    arrayPts_[i].y = arrayPts_[i].y + centerPt_.y; //没有实现+
  }
};

/**
 * 将一个点，围绕旋转中心点centerPt_， 旋转arc_ 弧度
 */
MMCommonFun.rotateAroundPt = function (point_, centerPt_, arc_) {
  var cos = Math.cos(arc_);
  var sin = Math.sin(arc_);
  var x, y;
  point_.x = point_.x - centerPt_.x; //没有实现-
  point_.y = point_.y - centerPt_.y; //没有实现-

  x = point_.x;
  y = point_.y;
  point_.x = x * cos - y * sin;
  point_.y = y * cos + x * sin;
  point_.x = point_.x + centerPt_.x; //没有实现+
  point_.y = point_.y + centerPt_.y; //没有实现+
};

/*
 *
 */
MMCommonFun.isOnSegment = function (segP1_, segP2_, pt_, error_) {
  //确定线段的两点X的差值和Y的差值
  var k1 = segP1_.y - segP2_.y;
  var k2 = segP1_.x - segP2_.x;
  //确定误差范围上限
  var _TOL_NUM = error_;
  //确定出线段上，X的最大最小值，Y的最大最小值
  var _maxX = segP1_.x > segP2_.x ? segP1_.x : segP2_.x;
  var _minX = segP1_.x < segP2_.x ? segP1_.x : segP2_.x;
  var _maxY = segP1_.y > segP2_.y ? segP1_.y : segP2_.y;
  var _minY = segP1_.y < segP2_.y ? segP1_.y : segP2_.y;
  var flag = false;
  //判段点是否在线段上
  if (pt_.x >= _minX - _TOL_NUM && pt_.x <= _maxX + _TOL_NUM && pt_.y >= _minY - _TOL_NUM && pt_.y <= _maxY + _TOL_NUM) {
    if (Math.abs(k2) < _TOL_NUM) flag = true;else if (Math.abs(k2 * (segP1_.y - pt_.y) - k1 * (segP1_.x - pt_.x)) < _TOL_NUM * Math.max(Math.abs(k2), Math.abs(k1))) flag = true;
  }
  return flag;
};

/**
 * 获得一组浮点型点的外接矩形
 */
MMCommonFun.getRect = function (arrayPts_) {
  var rect = new _MMRect["default"](0, 0, 0, 0);
  if (arrayPts_.length > 0) {
    rect.left = rect.right = arrayPts_[0].x;
    rect.top = rect.bottom = arrayPts_[0].y;
    for (var i = 1; i < arrayPts_.length; i++) {
      var ptX = arrayPts_[i].x;
      if (ptX < rect.left) {
        rect.left = ptX;
      }
      if (ptX > rect.right) {
        rect.right = ptX;
      }
      var ptY = arrayPts_[i].y;
      if (ptY < rect.top) {
        rect.top = ptY;
      }
      if (ptY > rect.bottom) {
        rect.bottom = ptY;
      }
    }
  }
  return rect;
};

/*
 *将一段贝塞尔曲线打断成贝塞尔曲线
 */
MMCommonFun.getBrokenLineCubicBezierPts = function (bezierPts_, isClose_) {
  var brokenLinePts = [];
  if (bezierPts_.length < 1) {
    return brokenLinePts;
  }
  if (isClose_) {
    bezierPts_.push(bezierPts_[0]);
    bezierPts_.push(bezierPts_[1]);
    bezierPts_.push(bezierPts_[2]);
  }
  var partCount = 10;
  for (var i = 0; i < bezierPts_.length - 2; i++) {
    if (i % 3 == 1) {
      for (var t = 0; t < 1.0; t += 1.0 / partCount) {
        var _pt = new _MMPoint["default"]();
        _pt.x = bezierPts_[i].x * Math.pow(1 - t, 3) + 3 * t * (1 - t) * (1 - t) * bezierPts_[i + 1].x + 3 * t * t * (1 - t) * bezierPts_[i + 2].x + t * t * t * bezierPts_[i + 3].x;
        _pt.y = bezierPts_[i].y * Math.pow(1 - t, 3) + 3 * t * (1 - t) * (1 - t) * bezierPts_[i + 1].y + 3 * t * t * (1 - t) * bezierPts_[i + 2].y + t * t * t * bezierPts_[i + 3].y;
        brokenLinePts.push(_pt);
      }
    }
  }
  return brokenLinePts;
};
/**
 * 获得任意弧的贝塞尔控制点
 */
MMCommonFun.getArcControlPts = function (center_, startePt_, endPt_, radiusx_, radiusy_) {
  var controlPoints = new Array();
  //确定三个向量
  var vector = new _vec["default"](1, 0);
  var vector1 = new _vec["default"]((startePt_.x - center_.x) / radiusx_, (startePt_.y - center_.y) / radiusy_);
  var vector2 = new _vec["default"]((endPt_.x - center_.x) / radiusx_, (endPt_.y - center_.y) / radiusy_);
  //判定另两个向量在水平向量的什么位置
  //if( radiusx >=0 )
  var MM_PI = Math.PI;
  var startAngle = vector.angleBetweenVector(vector1);
  var endAngle = vector.angleBetweenVector(vector2);
  if (startAngle < 0) {
    startAngle += 2 * MM_PI;
  }
  if (endAngle < 0) {
    endAngle += 2 * MM_PI;
  }
  if (startAngle >= endAngle) startAngle -= 2 * Math.PI;
  // var sweepAngle  = MMCommonFun.getAngle(vector1, vector2);
  var sweepAngle = endAngle - startAngle;
  //弧线的角度小于等于90时
  if (sweepAngle <= Math.PI / 2) {
    var controlPts = MMCommonFun.calcArcControlPts(center_, startAngle, sweepAngle, radiusx_, radiusy_);
    controlPoints.push(controlPts[0].clone());
    for (var i = 0; i < controlPts.length; i++) controlPoints.push(controlPts[i].clone());
    controlPoints.push(controlPts[controlPts.length - 1].clone());
  }
  //弧线的角度大于90小于等于180时
  if (sweepAngle > Math.PI / 2 && sweepAngle <= Math.PI) {
    var radian = sweepAngle / 2;
    var controlPts1 = MMCommonFun.calcArcControlPts(center_, startAngle, radian, radiusx_, radiusy_);
    var controlPts2 = MMCommonFun.calcArcControlPts(center_, startAngle + radian, radian, radiusx_, radiusy_);
    controlPts1.pop();
    controlPoints.push(controlPts1[0].clone());
    for (var i = 0; i < controlPts1.length; i++) controlPoints.push(controlPts1[i].clone());
    for (var i = 0; i < controlPts2.length; i++) controlPoints.push(controlPts2[i].clone());
    controlPoints.push(controlPts2[controlPts2.length - 1].clone());
  }
  //弧线的角度大于180小于等于270时
  if (sweepAngle > Math.PI && sweepAngle <= 3 * Math.PI / 2) {
    var radian = sweepAngle / 3;
    var controlPts1 = MMCommonFun.calcArcControlPts(center_, startAngle, radian, radiusx_, radiusy_);
    controlPts1.pop();
    var controlPts2 = MMCommonFun.calcArcControlPts(center_, startAngle + radian, radian, radiusx_, radiusy_);
    controlPts2.pop();
    var controlPts3 = MMCommonFun.calcArcControlPts(center_, startAngle + 2 * radian, radian, radiusx_, radiusy_);
    controlPoints.push(controlPts1[0].clone());
    for (var i = 0; i < controlPts1.length; i++) controlPoints.push(controlPts1[i].clone());
    for (var i = 0; i < controlPts2.length; i++) controlPoints.push(controlPts2[i].clone());
    for (var i = 0; i < controlPts3.length; i++) controlPoints.push(controlPts3[i].clone());
    controlPoints.push(controlPts3[controlPts3.length - 1].clone());
  }
  //弧线的角度大于270小于等于360时
  if (sweepAngle > 3 * Math.PI / 2 && sweepAngle <= 2 * Math.PI) {
    var radian = sweepAngle / 4;
    var controlPts1 = MMCommonFun.calcArcControlPts(center_, startAngle, radian, radiusx_, radiusy_);
    controlPts1.pop();
    var controlPts2 = MMCommonFun.calcArcControlPts(center_, startAngle + radian, radian, radiusx_, radiusy_);
    controlPts2.pop();
    var controlPts3 = MMCommonFun.calcArcControlPts(center_, startAngle + 2 * radian, radian, radiusx_, radiusy_);
    controlPts3.pop();
    var controlPts4 = MMCommonFun.calcArcControlPts(center_, startAngle + 3 * radian, radian, radiusx_, radiusy_);
    controlPoints.push(controlPts1[0].clone());
    for (var i = 0; i < controlPts1.length; i++) controlPoints.push(controlPts1[i].clone());
    for (var i = 0; i < controlPts2.length; i++) controlPoints.push(controlPts2[i].clone());
    for (var i = 0; i < controlPts3.length; i++) controlPoints.push(controlPts3[i].clone());
    for (var i = 0; i < controlPts4.length; i++) controlPoints.push(controlPts4[i].clone());
    controlPoints.push(controlPts4[controlPts4.length - 1].clone());
  }
  return controlPoints;
};

/**
 * 获得小于90度角弧的控制点
 */
MMCommonFun.calcArcControlPts = function (center_, startArc_, sweepArc_, radiusx_, radiusy_) {
  var _controlPts = new Array();
  var _pts = new Array();
  var B = Math.sin(sweepArc_ / 2);
  var C = Math.cos(sweepArc_ / 2);
  var A = 1 - C;
  var dx = A * 4 / 3;
  var dy = B - dx * C / B;
  _pts.push(new _MMPoint["default"](C, -B));
  _pts.push(new _MMPoint["default"](C + dx, -dy));
  _pts.push(new _MMPoint["default"](C + dx, dy));
  _pts.push(new _MMPoint["default"](C, B));
  var theta = startArc_ + sweepArc_ / 2;
  for (var i = 0; i < _pts.length; i++) {
    var _x = center_.x + (_pts[i].x * Math.cos(theta) - _pts[i].y * Math.sin(theta)) * radiusx_;
    var _y = center_.y + (_pts[i].x * Math.sin(theta) + _pts[i].y * Math.cos(theta)) * radiusy_;
    _controlPts.push(new _MMPoint["default"](_x, _y));
  }
  return _controlPts;
};
MMCommonFun.findObjInArray = function (array, obj) {
  var index = -1;
  for (var i = 0; i < array.length; i++) {
    if (array[i] == obj) {
      index = i;
      break;
    }
  }
  return index;
};
MMCommonFun.secondToShowTime = function (seconds) {
  var m = Math.floor(seconds / 60);
  var s = seconds - m * 60;
  var str = (m < 10 ? "0" + m : m) + ":" + (s < 10 ? "0" + s : s);
  return str;
};
MMCommonFun.getNumFromBegin = function (str) {
  var reg = new RegExp("[0-9\\.\\-]+");
  var matches = str.match(reg);
  if (matches != undefined && matches.length > 0) {
    return parseFloat(matches[matches.length - 1]);
  }
};
MMCommonFun.formatTime = function (time_) {
  var _stringDate = new Date(time_ * 1000);
  _stringDate = _stringDate.format("yyyy-MM-dd HH:mm");
  return _stringDate;
};
MMCommonFun.formatOnlyTime = function (time_) {
  var _stringDate = new Date(time_ * 1000);
  _stringDate = _stringDate.format("hh:mm:ss");
  return _stringDate;
};
MMCommonFun.formatOnlyDate = function (time_) {
  var _stringDate = new Date(time_ * 1000);
  _stringDate = _stringDate.format("yyyy-MM-dd");
  return _stringDate;
};

/**
 * 将10进制转化为36进制
 * @param number
 * @param length 转化成的36进制长度，不足length长度的话高位补0，否则不改变什么
 * @return
 */
MMCommonFun.DecTo36 = function (dig_) {
  var charSet = "0123456789abcdefghijklmnopqrstuvwxyz";
  var LENGTH_36 = 6;
  var _result = "";
  var _rest = dig_;
  var _stack = [];
  while (_rest != 0) {
    var _temp = Math.floor(_rest / 36);
    _stack.push(charSet[_rest - _temp * 36]);
    _rest = _temp;
  }
  for (; _stack.length > 0;) {
    _result += _stack.pop();
  }
  var _temp = "";
  var _result_length = _result.length;
  for (var i = 0; i < LENGTH_36 - _result_length; i++) {
    _temp += "0";
  }
  _temp = _temp + _result;
  return _temp;
};

/**
 * 将36进制转换成10进制数
 *
 * @param ident62
 * @return
 */
MMCommonFun.M36ToDec = function (text_) {
  var _digarray = [];
  for (var i = 0; i < text_.length; i++) {
    _digarray[i] = text_.charCodeAt(i);
  }
  var decimal = 0;
  var base = 36;
  var keisu = 0;
  var cnt = 0;
  for (var i = _digarray.length - 1; i >= 0; i--) {
    var num = 0;
    /*
     *0~9
     */
    if (_digarray[i] >= 48 && _digarray[i] <= 57) {
      num = _digarray[i] - 48;
    } else if (_digarray[i] >= 97 && _digarray[i] <= 122) {
      /*
       *a~z
       */
      num = _digarray[i] - 97 + 10;
    } else {
      console.assert(false);
    }
    keisu = Math.pow(base, cnt);
    decimal += num * keisu;
    cnt++;
  }
  return decimal;
};

/**
 * 变换 cover 的大小去覆盖目标，要求等比例变换
 */
MMCommonFun.sizeToCoverSize = function (cover, target) {
  var r = cover.width / cover.height;
  var rt = target.widht / target.height;
  if (rt > r) {
    cover.width = target.width;
    cover.height = cover.width / r;
  } else {
    cover.height = target.height;
    cover.width = cover.height * r;
  }
};
/**
 * 获得恰好放置在矩形容器中的矩形内容的尺寸，
 * @param {Size}  continaerSize   - 矩形容器的尺寸
 * @param {Number}          whRatio         - 内容的宽高比
 * @param {Number}          margin          - 内容距离容器的最小边距
 */
MMCommonFun.sizeFitInSize = function (containerSize, whRatio, margin) {
  var r = containerSize.width / containerSize.height;
  var resultSize = containerSize.clone();
  if (r > whRatio) {
    resultSize.height = containerSize.height - 2 * margin;
    if (resultSize.height < 0) resultSize.height = 0;
    resultSize.width = resultSize.height * whRatio;
  } else {
    resultSize.width = containerSize.width - 2 * margin;
    if (resultSize.width < 0) resultSize.width = 0;
    resultSize.height = resultSize.width / whRatio;
  }
  return resultSize;
};

// MMCommonFun.showEachInView = function(viewCol_, viewFunc_, strapFunc_, sortType_) {
//   var _that = viewCol_;
//   var _arrayBoardInfos = [];
//   _that.m_mapModels.forEach(function(value_, key_) {
//     _arrayBoardInfos.push(value_);
//   });
//   _arrayBoardInfos.sort(function(a, b) {
//     var _rst = g_sortOrder ? 1 : -1;
//     if (sortType_ == CREATETIME) {
//       return b.getCreateTime() < a.getCreateTime() ? _rst : -_rst;
//     } else if (sortType_ == LATESTTIME) {
//       return b.getModifyTime() < a.getModifyTime() ? _rst : -_rst;
//     } else if (sortType_ == FILENAME) {
//       //return b.getName()<a.getName()?_rst:-_rst ;
//       return a.getName().toLocaleLowerCase().localeCompare(b.getName().toLocaleLowerCase()) * _rst;
//     }
//   });

//   var _boardInfoSlots = [];

//   _arrayBoardInfos.forEach(function(value_, key_) {
//     var __key = null;
//     if (sortType_ == CREATETIME) {
//       var _time = new Date();
//       var _now = new Date();
//       _time.setTime(value_.getCreateTime() * 1000);
//       if (_time.getFullYear() == _now.getFullYear()) {
//         __key = MMCommonFun.getMonthText(_time.getMonth());
//       } else {
//         __key = MMCommonFun.getMonthText(12);
//       }
//     } else if (sortType_ == LATESTTIME) {
//       var _time = new Date();
//       var _now = new Date();
//       _time.setTime(value_.getModifyTime() * 1000);
//       if (_time.getFullYear() == _now.getFullYear()) {
//         __key = MMCommonFun.getMonthText(_time.getMonth());
//       } else {
//         __key = MMCommonFun.getMonthText(12);
//       }
//     } else if (sortType_ == FILENAME) {
//       var _name = value_.getName();
//       if (_name.length > 0) {
//         __key = _name.trim().toLocaleLowerCase().charAt(0);
//         if (__key >= 'a' && __key <= 'z') {

//         } else if (__key >= '0' && __key <= '9') {
//           __key = "0~9";
//         } else {
//           __key = stringCtl.getString("_others");
//         }
//       } else {
//         __key = stringCtl.getString("_untitled");
//       }
//     }
//     if (_boardInfoSlots.length > 0 && _boardInfoSlots[_boardInfoSlots.length - 1].title == __key) {
//       _boardInfoSlots[_boardInfoSlots.length - 1].data.push(value_);
//     } else {
//       var _newSlot = {
//         title: __key,
//         data: [value_]
//       };
//       _boardInfoSlots.push(_newSlot);
//     }
//   });

//   _boardInfoSlots.forEach(function(v_, k_) {
//     var _title = v_.title;
//     strapFunc_(_title);

//     v_.data.forEach(function(value_, key_) {
//       viewFunc_(value_);
//     });
//     //strapFunc_(null) ;
//   });
// };

MMCommonFun.filtInView = function (col_, pattern_, viewFunc_) {
  var _reg = new RegExp(pattern_, "i");
  var _arrayBoardInfos = [];
  col_.m_mapModels.forEach(function (value_, key_) {
    var _fileName = value_.getName();
    if (_fileName.search(_reg) >= 0) {
      _arrayBoardInfos.push(value_);
    }
  });
  _arrayBoardInfos.sort(function (a, b) {
    return b.getName() < a.getName() ? 1 : -1;
  });
  _arrayBoardInfos.forEach(function (value_, key_) {
    viewFunc_(value_);
  });
};

// MMCommonFun.getMonthText = function(index_) {
//   return g_monthText[index_];
// };

MMCommonFun.getDivLeftTop = function ($div) {
  var x = parseInt($div.css("left"));
  var y = parseInt($div.css("top"));
  return {
    x: x,
    y: y
  };
};
MMCommonFun.getDivCenter = function ($div) {
  var w = $div.width(); //[0].clientWidth;  //parseInt($div.css("width")) + parseInt($div.css("padding-left")) + parseInt($div.css("padding-right"));
  var h = $div.height(); //[0].clientHeight;    //parseInt($div.css("height")) + parseInt($div.css("padding-top")) + parseInt($div.css("padding-bottom"));

  return {
    x: w / 2,
    y: h / 2
  };
};
MMCommonFun.setDivLeftTop = function ($div, pos) {
  $div.css({
    left: pos.x + "px",
    top: pos.y + "px"
  });
};
MMCommonFun.collectParent = function (element, parents) {
  if (parents == null || element == null) return;
  parents.push(element);
  var p = element.offsetParent;
  while (p != null && p != undefined) {
    parents.push(p);
    var curP = p;
    p = curP.offsetParent;
  }
  var lastParent = parents[parents.length - 1];
  if ((p == null || p == undefined) && lastParent != window) {
    parents.push(window);
  }
};
/**
 * to remove the first e from the array
 */
Array.prototype.remove = function (e) {
  var index = this.indexOf(e);
  if (index != -1) {
    this.splice(index, 1);
  }
  return this;
};
/**
 * 在两个 dom 元素之间转换点的坐标
 * @param {html.elemnt} fromElement  源
 * @param {html elment} toElement 目标
 * @param {x, y} point 点在源中的坐标
 * @returns {x, y} 点在目标中的坐标
 */
MMCommonFun.convertPointBetweenElements = function (fromElement, toElement, point) {
  if (!fromElement || !toElement) {
    console.error("wrong parameters!");
    return point;
  }
  if (fromElement == toElement) {
    return point;
  }
  //    var fromOffset = $(fromElement).offset();
  //    var toOffset = $(toElement).offset();
  //
  //    return new MMPoint(
  //        fromOffset.left - toOffset.left + point.x,
  //        fromOffset.top - toOffset.top + point.y
  //    );
  //old
  var fromParents = new Array();
  MMCommonFun.collectParent(fromElement, fromParents);
  var toParents = new Array();
  MMCommonFun.collectParent(toElement, toParents);
  var fromIndex = -1;
  var toIndex = -1;
  for (var i = 0; i < fromParents.length; i++) {
    for (var k = 0; k < toParents.length; k++) {
      var to = toParents[k];
      var from = fromParents[i];
      if (from == to) {
        fromIndex = i;
        toIndex = k;
        break;
      }
    }
    if (fromIndex != -1) break;
  }

  // 公共节点是 body 情况下，非 chrome 浏览器的需要公共节点改为 window, 即最后一个公共元素
  var parentInCommon = fromParents[fromIndex];
  var isChrome = false;
  if (navigator.userAgent.indexOf("Chrome") > -1) isChrome = true;
  if (!isChrome && parentInCommon != window) {
    var divName = $(parentInCommon)[0].tagName;
    if (fromIndex != fromParents.length - 1 && divName.toLowerCase() == "body") {
      fromIndex = fromParents.length - 1;
      toIndex = toParents.length - 1;
    }
  }

  // 收集 window 和顶部可能的 fixed 元素
  parentInCommon = fromParents[fromIndex];
  var grandSonFrom = null;
  var grandSonTo = null;
  if (parentInCommon == window) {
    grandSonFrom = fromParents[fromIndex - 2];
    if ($(grandSonFrom).css("position") != "fixed") {
      grandSonFrom = fromParents[fromIndex - 1];
    }
    grandSonTo = toParents[toIndex - 2];
    if ($(grandSonTo).css("position") != "fixed") {
      grandSonTo = toParents[toIndex - 1];
    }
  }

  // 转换到公共父节点的坐标
  var pos = {
    x: 0,
    y: 0
  };
  pos.x = point.x;
  pos.y = point.y;
  for (var i = 0; i < fromIndex; i++) {
    var curElement = fromParents[i];
    var scaleOrigin = MMCommonFun.getElementScaleOrigin(curElement);

    // var scale = MMCommonFun.getElementScale(curElement);
    // var translate = MMCommonFun.getElementTranslate(curElement);

    var transData = MMCommonFun.getTransformPara(curElement);
    var scale = {
      x: transData.ScaleX,
      y: transData.ScaleY
    };
    var translate = {
      x: transData.MovX,
      y: transData.MovY
    };
    var angle = transData.Angle * Math.PI / 180;
    pos.x = pos.x * scale.x + curElement.offsetLeft - curElement.scrollLeft;
    pos.y = pos.y * scale.y + curElement.offsetTop - curElement.scrollTop;
    pos.x = pos.x + translate.x + (scaleOrigin.x - scaleOrigin.x * scale.x);
    pos.y = pos.y + translate.y + (scaleOrigin.y - scaleOrigin.y * scale.y);
    var center = {
      x: curElement.offsetLeft + scaleOrigin.x,
      y: curElement.offsetTop + scaleOrigin.y
    };
    MMCommonFun.rotateAroundPt(pos, center, angle);
  }

  // 公共节点是 window 情况下，非 chrome 浏览器的 fixed 类型的节点需要特殊处理
  var isChrome = false;
  if (navigator.userAgent.indexOf("Chrome") > -1) isChrome = true;
  if (!isChrome) {
    if (grandSonFrom != null && $(grandSonFrom).css("position") == "fixed" || grandSonFrom == $("body")[0]) {
      pos.x += window.pageXOffset;
      pos.y += window.pageYOffset;
    }
    if (grandSonTo != null && $(grandSonTo).css("position") == "fixed" || grandSonTo == $("body")[0]) {
      pos.x -= window.pageXOffset;
      pos.y -= window.pageYOffset;
    }
  }

  // 转换到目标坐标
  for (var i = toIndex - 1; i >= 0; i--) {
    var curElement = toParents[i];
    if (curElement == $("body")[0] && window.scrollX) {
      pos.x += window.scrollX;
    } else {}
    var scaleOrigin = MMCommonFun.getElementScaleOrigin(curElement);

    // var scale = MMCommonFun.getElementScale(curElement);
    // var translate = MMCommonFun.getElementTranslate(curElement);
    var transData = MMCommonFun.getTransformPara(curElement);
    var scale = {
      x: transData.ScaleX,
      y: transData.ScaleY
    };
    var translate = {
      x: transData.MovX,
      y: transData.MovY
    };
    var angle = -transData.Angle * Math.PI / 180;
    pos.x = pos.x - translate.x - curElement.offsetLeft + curElement.scrollLeft - (scaleOrigin.x - scaleOrigin.x * scale.x);
    pos.y = pos.y - translate.y - curElement.offsetTop + curElement.scrollTop - (scaleOrigin.y - scaleOrigin.y * scale.y);
    pos.x = pos.x / scale.x;
    pos.y = pos.y / scale.y;
    MMCommonFun.rotateAroundPt(pos, scaleOrigin, angle);
  }
  return pos;
};
MMCommonFun.getElementAngle = function (el) {
  var st = window.getComputedStyle(el, null);
  var tr = st.getPropertyValue("-webkit-transform") || st.getPropertyValue("-moz-transform") || st.getPropertyValue("-ms-transform") || st.getPropertyValue("-o-transform") || st.getPropertyValue("transform") || "FAIL";

  // With rotate(30deg)...
  // matrix(0.866025, 0.5, -0.5, 0.866025, 0px, 0px)
  // console.log('Matrix: ' + tr);

  // rotation matrix - http://en.wikipedia.org/wiki/Rotation_matrix
  if (tr === "none" || tr === "FAIL") {
    tr = "matrix(1,0,0,1,0,0)";
  }
  var values = tr.split("(")[1].split(")")[0].split(",");
  var a = values[0];
  var b = values[1];
  var c = values[2];
  var d = values[3];
  var scale = Math.sqrt(a * a + b * b);
  console.log("Scale: " + scale);

  // arc sin, convert from radians to degrees, round
  var sin = b / scale;
  // next line works for 30deg but not 130deg (returns 50);
  // var angle = Math.round(Math.asin(sin) * (180/Math.PI));
  var angle = Math.round(Math.atan2(b, a) * (180 / Math.PI));
  return angle;
};
MMCommonFun.getElementScaleOrigin = function (el) {
  if (el instanceof $.fn.init) el = el[0];
  var scaleOrigin = $(el).css("transform-origin");
  if (scaleOrigin.length == 0) {
    return {
      x: 0.5,
      y: 0.5
    };
  }
  var values = scaleOrigin.split(" ");
  var a = parseFloat(values[0]);
  var b = parseFloat(values[1]);
  console.assert(!isNaN(a) && !isNaN(b));
  var origin = {
    x: a,
    y: b
  };
  return origin;
};
MMCommonFun.getElementScale = function (el) {
  if (el instanceof $.fn.init) el = el[0];
  var st = window.getComputedStyle(el, null);
  var tr = st.getPropertyValue("-webkit-transform") || st.getPropertyValue("-moz-transform") || st.getPropertyValue("-ms-transform") || st.getPropertyValue("-o-transform") || st.getPropertyValue("transform") || "FAIL";

  // With rotate(30deg)...
  // matrix(0.866025, 0.5, -0.5, 0.866025, 0px, 0px)
  // console.log('Matrix: ' + tr);

  // var org = st.getPropertyValue("-webkit-transform-origin") ||
  //          st.getPropertyValue("-moz-transform-origin") ||
  //          st.getPropertyValue("-ms-transform-origin") ||
  //          st.getPropertyValue("-o-transform-origin") ||
  //          st.getPropertyValue("transform-origin") ||
  //          "FAIL";

  if (tr === "none" || tr === "FAIL") {
    tr = "matrix(1,0,0,1,0,0)";
  }
  if (!tr.split("(")[1]) {
    tr = "matrix(1,0,0,1,0,0)";
  }
  // rotation matrix - http://en.wikipedia.org/wiki/Rotation_matrix

  var values = tr.split("(")[1].split(")")[0].split(",");
  var a = values[0];
  var b = values[1];
  var c = values[2];
  var d = values[3];
  var scale1 = Math.sqrt(a * a + b * b);
  var scale2 = Math.sqrt(c * c + d * d);
  var scale = {
    x: scale1,
    y: scale2
  };
  return scale;
};
MMCommonFun.getElementTranslate = function (el) {
  if (el instanceof $.fn.init) el = el[0];
  var st = window.getComputedStyle(el, null);
  var tr = st.getPropertyValue("-webkit-transform") || st.getPropertyValue("-moz-transform") || st.getPropertyValue("-ms-transform") || st.getPropertyValue("-o-transform") || st.getPropertyValue("transform") || "FAIL";

  // With rotate(30deg)...
  // matrix(0.866025, 0.5, -0.5, 0.866025, 0px, 0px)
  // console.log('Matrix: ' + tr);

  // var org = st.getPropertyValue("-webkit-transform-origin") ||
  //          st.getPropertyValue("-moz-transform-origin") ||
  //          st.getPropertyValue("-ms-transform-origin") ||
  //          st.getPropertyValue("-o-transform-origin") ||
  //          st.getPropertyValue("transform-origin") ||
  //          "FAIL";

  if (tr === "none" || tr === "FAIL") {
    tr = "matrix(1,0,0,1,0,0)";
  }
  // rotation matrix - http://en.wikipedia.org/wiki/Rotation_matrix

  var values = tr.split("(")[1].split(")")[0].split(",");
  var a = values[0];
  var b = values[1];
  var c = values[2];
  var d = values[3];
  var e = values[4];
  var f = values[5];
  var translate = {
    x: parseFloat(e),
    y: parseFloat(f)
  };
  return translate;
};
MMCommonFun.getTransformPara = function (el) {
  var st = window.getComputedStyle(el, null);
  var tr = st.getPropertyValue("-webkit-transform") || st.getPropertyValue("-moz-transform") || st.getPropertyValue("-ms-transform") || st.getPropertyValue("-o-transform") || st.getPropertyValue("transform") || "FAIL";
  if (tr === "none" || tr === "FAIL") {
    tr = "matrix(1,0,0,1,0,0)";
  }
  if (tr != "none") {
    var values = tr.split("(")[1].split(")")[0].split(",");
    var a = values[0];
    var b = values[1];
    var c = values[2];
    var d = values[3];
    var e = values[4];
    var f = values[5];
    var scale1 = Math.sqrt(a * a + b * b);
    var scale2 = Math.sqrt(c * c + d * d);
    var angle = Math.atan2(b, a) * (180.0 / Math.PI);
    e = parseFloat(e);
    f = parseFloat(f);
    var radian = -Math.PI / 180.0 * angle;
    var lastX = Math.cos(radian) * e - Math.sin(radian) * f;
    var LastY = Math.sin(radian) * e + Math.cos(radian) * f;
    return {
      ScaleX: scale1,
      ScaleY: scale2,
      Angle: angle,
      MovX: lastX,
      MovY: LastY
    };
  } else {
    return {
      ScaleX: 1,
      ScaleY: 1,
      Angle: 0,
      MovX: 0,
      MovY: 0
    };
  }
};
MMCommonFun.isElementVisible = function (element) {
  var visible = true;
  while (element) {
    if ($(element).css("display") == "none" || $(element).css("visibility") == "hidden") {
      visible = false;
      break;
    } else {
      element = element.parentElement;
    }
  }
  return visible;
};
MMCommonFun.dataURItoBlob = function (dataURI) {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does MMCommonFun
  var byteString = atob(dataURI.split(",")[1]);

  // separate out the mime component
  var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

  // write the bytes of the string to an ArrayBuffer
  var ab = new ArrayBuffer(byteString.length);
  var ia = new Uint8Array(ab);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  // write the ArrayBuffer to a blob, and you're done
  var bb = new BlobBuilder();
  bb.append(ab);
  return bb.getBlob(mimeString);
};
MMCommonFun.isRetina = function () {
  return (window.matchMedia && (window.matchMedia("only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx), only screen and (min-resolution: 75.6dpcm)").matches || window.matchMedia("only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2)").matches) || window.devicePixelRatio && window.devicePixelRatio > 2) && /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
};
MMCommonFun.isArraysEqual = function (arr1, arr2) {
  if (arr1 == undefined || arr2 == undefined || arr1 == null || arr2 == null) {
    return false;
  }
  if (arr1 == arr2) return true;
  if (arr1.length != arr2.length) return false;
  for (var i = 0; i < arr1.length; i++) {
    if (arr1[i] != arr2[i]) return false;
  }
  return true;
};
MMCommonFun.isIOSDevice = function () {
  var iOS = navigator.userAgent.match(/(iPad|iPhone|iPod)/g) ? true : false;
  return iOS;
};
MMCommonFun.isInMobile = function () {
  var check = false;
  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};
MMCommonFun.clipContext = function (ctx, dvRct, noClear) {
  if (!noClear) {
    ctx.clearRect(dvRct.left, dvRct.top, dvRct.getWidth(), dvRct.getHeight());
  }

  //只在刷新区域里面重绘，ctx.clip()
  ctx.beginPath();
  ctx.strokeStyle = "rgba(255,0,0,0.0)";
  ctx.lineWidth = 0;
  ctx.rect(dvRct.left, dvRct.top, dvRct.getWidth(), dvRct.getHeight());
  ctx.stroke();
  ctx.clip();
};
MMCommonFun.isInIE = function () {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf("MSIE ");
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
  }
  var trident = ua.indexOf("Trident/");
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf("rv:");
    return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
  }
  var edge = ua.indexOf("Edge/");
  if (edge > 0) {
    // IE 12 => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
  }

  // other browser
  return false;
};

/**
 * create a rect by pageindex
 */
MMCommonFun.getPageRect = function (index) {
  return new _MMRect["default"](index * 20, 15, index * 20 + 20, 0);
};
MMCommonFun.getDefaultDevLineWidth = function () {
  return 4;
};
MMCommonFun.getDivRect = function ($div) {
  var x = parseInt($div.css("left"));
  var y = parseInt($div.css("top"));
  var w = parseInt($div.css("width"));
  var h = parseInt($div.css("height"));
  return {
    x: x,
    y: y,
    w: w,
    h: h
  };
};
MMCommonFun.setDivRect = function ($div, rect) {
  $div.css("left", rect.x + "px");
  $div.css("top", rect.y + "px");
  $div.css("width", rect.w + "px");
  $div.css("height", rect.h + "px");
};
MMCommonFun.getRemoteDURL = function (octetCreator_, octetBoard_, fileName_) {
  var url = "downloadFile.do?typeFlag=0&userId=" + octetCreator_ + "&boardId=" + octetBoard_ + "&fileName=" + fileName_;
  return url;
};
MMCommonFun.validateEmail = function (email) {
  var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
  return re.test(email);
};
MMCommonFun.mapSearch = function mapSearch() {
  var list = location.search.slice(1).split("&");
  var out = {};
  for (var i = 0; i < list.length; i++) {
    var k = list[i].split("=");
    out[k[0]] = k[1] === undefined ? null : k[1];
  }
  return out;
};
MMCommonFun.mapCockie = function mapCookies() {
  var list = document.cookie.split("; ");
  var out = {};
  for (var i = 0; i < list.length; i++) {
    var k = list[i].split("=");
    out[k[0]] = k[1] === undefined ? null : k[1];
  }
  return out;
};
MMCommonFun.setCanvasMetric = function (canvas, width, height) {
  if (!canvas) {
    return;
  }
  var ctx = canvas.getContext("2d");
  var backingStorePixelRatio = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
  var ratio = devicePixelRatio / backingStorePixelRatio;
  canvas.width = width * ratio;
  canvas.height = height * ratio;
  // canvas.style.width = width+'px';
  // canvas.style.height = height+'px';
  // ctx.scale(1, 1);
  $(canvas).css("transform-origin", "0px 0px");
  $(canvas).css("transform", "scale(" + 1 / ratio + "," + 1 / ratio + ")");
};
MMCommonFun.initCanvasSize = function ($canvas, targetWidth, targetHeight) {
  var targetSize = {
    width: targetWidth,
    height: targetHeight
  };
  for (var i = 0; i < $canvas.length; i++) {
    var canvas = $canvas[i];
    var ctx = canvas.getContext("2d");
    var backingStorePixelRatio = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
    var ratio = devicePixelRatio / backingStorePixelRatio;
    if (ratio > 2) {
      ratio = 2;
    }
    canvas.width = targetSize.width * ratio;
    canvas.height = targetSize.height * ratio;
  }
};
MMCommonFun.setContextScale = function (canvas) {
  if (!canvas) {
    return;
  }
  var ctx = canvas.getContext("2d");
  var scaleX = canvas.width / parseInt(canvas.style.width);
  var scaleY = canvas.height / parseInt(canvas.style.height);
  ctx.setTransform(scaleX, 0, 0, scaleY, 0, 0);
};

// MMCommonFun.getThumbnailOfDoc = function(userId_, taskId_, pageIndex_, style_, isIWork) {
//   var stringBuilder = [];
//   stringBuilder.push(isIWork ? iWorkConvertorSrc : MMBackboneExtend.appBaseAddress);
//   stringBuilder.push("/downloadFile.do?");
//   var url = stringBuilder.join("");

//   stringBuilder = [];
//   stringBuilder.push("fileName=PAGE__" + pageIndex_ + ".jpg");
//   stringBuilder.push("typeFlag=2");
//   stringBuilder.push("userId=" + userId_);
//   stringBuilder.push("boardId=" + taskId_);
//   if (style_) {
//     stringBuilder.push("style=" + style_);
//   }
//   url += stringBuilder.join("&");

//   return url;
// };

MMCommonFun.getRealRequestURL = function (originURL, callback, errorCallback) {
  // test
  // console.error("----- only for test");
  // if (callback) {
  //     callback(originURL);
  // };
  // return;
  // end

  var requestUrl;
  console.assert(callback);
  console.assert(typeof originURL === "string");
  var isIWork = MMCommonFun.isIWorkPath(originURL);
  if (callback) {
    if (isIWork) {
      requestUrl = iWorkConvertorSrc + "/" + originURL;
    } else {
      requestUrl = originURL.replace("downloadFile.do?", "downloadDocument.do?");
    }
    $.ajax({
      type: "get",
      url: requestUrl,
      cache: false,
      success: function success(response) {
        if (response.success === true && response.url) {
          callback(response.url, response.downloadFilename, response.fileSize);
        } else {
          // console.error("get realpath error");
          var code = response["code"];
          if (code == 207) {
            app.redirectToLogin();
          } else {
            if (code) {
              if (code == 853) {
                MMEnterpriseController.checkFilesSequentially(response.options.noPassFiles, function () {
                  MMCommonFun.getRealRequestURL(originURL, callback, errorCallback);
                }, function () {
                  _MDAlertView["default"].showStandardPrompt({
                    message: code + "-" + BabelStr.str(27029)
                  });
                  if (errorCallback) {
                    errorCallback(response);
                  }
                });
              } else {
                if (code == "10006") {
                  response["msg"] = BabelStr.str(5542);
                }
                if (code == "10010") {
                  response["msg"] = BabelStr.str(108);
                }
                _MDAlertView["default"].showStandardPrompt({
                  message: code + "-" + response["msg"]
                });
                if (errorCallback) {
                  errorCallback(response);
                }
              }
            }
          }
        }
      }
    });
  }
};
MMCommonFun.getRealRequestURLByPost = function (originURL, callback, errorCallback) {
  var requestUrl;
  console.assert(callback);
  console.assert(typeof originURL === "string");
  var isIWork = MMCommonFun.isIWorkPath(originURL);
  if (callback) {
    if (isIWork) {
      requestUrl = iWorkConvertorSrc + "/" + originURL;
    } else {
      requestUrl = originURL.replace("downloadFile.do?", "downloadDocument.do?");
    }
    var spark = new SparkMD5.ArrayBuffer();
    spark.append(requestUrl);
    var hash = spark.end();
    if ($("." + hash).length > 0) {
      _MDSnackbarView["default"].show(BabelStr.str(7360));
      return;
    }
    $("body").append("<div class='" + hash + "'></div>");
    $.post(requestUrl, function (response) {
      if (response.code == 0 && !response.url && response.zipStatusKey) {
        callback(null, response.zipStatusKey, response.downloadFilename, response.fileSize);
        $("." + hash).remove();
      } else if (response.url) {
        callback(response.url, undefined, response.downloadFilename, response.fileSize);
        $("." + hash).remove();
      } else {
        $("." + hash).remove();
        var code = response["code"];
        if (code == 853) {
          MMEnterpriseController.checkFilesSequentially(response.options.noPassFiles, function () {
            MMCommonFun.getRealRequestURLByPost(originURL, callback, errorCallback);
          }, function () {
            _MDAlertView["default"].showStandardPrompt({
              message: code + "-" + BabelStr.str(27029)
            });
            if (errorCallback) {
              errorCallback(response);
            }
          });
        } else {
          if (code && code != 126 && code != 125) {
            if (code == "10006") {
              response["msg"] = BabelStr.str(5542);
            }
            _MDAlertView["default"].showStandardPrompt({
              message: code + "-" + response["msg"]
            });
          }
          if (errorCallback) {
            errorCallback(response);
          }
        }
      }
    });
  }
};

/**
 *  you are not allowed to upload a filename like "name.pages.pdf"
 */
MMCommonFun.isIWorkPath = function (originURL) {
  var i;
  var result = false;
  var iWorkFormats = IWORK_FILETYPE.split(",");
  iWorkFormats.forEach(function (format) {
    var lastIndex = originURL.lastIndexOf(format);
    if (lastIndex !== -1) {
      result = true;
    }
  });
  return result;
};
_.maxExecutionRepeation = function (f, maxSpeed) {
  maxSpeed = maxSpeed || 1000;
  var lastCall = new Date().getTime();
  var func = function func() {
    var now = new Date().getTime();
    if (now - lastCall > maxSpeed) {
      f.apply(undefined, arguments);
      lastCall = new Date().getTime();
    } else if (now - lastCall !== maxSpeed) {
      setBabelTimeout(func, now - lastCall - maxSpeed);
    }
  };
  return func;
};

/**
 * returns a point, that is in the rect, but as close as possible in the rect;
 * @param point {MMPoint} the given Point
 * @param rect {MMRect} the given Rect
 */
MMCommonFun.movePointIntoRect = function (point, rect) {
  return new _MMPoint["default"](point.x <= rect.left ? rect.left : point.x >= rect.right ? rect.right : point.x, point.y <= rect.top ? rect.top : point.y >= rect.bottom ? rect.bottom : point.y);
};
MMCommonFun.mapCookies = function mapCookies() {
  "use strict";

  var list = document.cookie.split("; ");
  var out = {};
  var i;
  var k;
  for (i = 0; i < list.length; i++) {
    k = list[i].split("=");
    out[k[0]] = k[1];
  }
  return out;
};
MMCommonFun.getFileTypeDescription = function (fileType) {
  return BabelStr.str(7361);
};
/**
 * returns the extension including the last dot.
 * @param filename {string} the filename including the filextension.
 */
MMCommonFun.getFileExtension = function (filename) {
  console.assert(typeof filename === "string");
  var dotIndex = filename.lastIndexOf(".");
  if (dotIndex == -1) {
    return "";
  }
  return filename.slice(dotIndex).toLowerCase();
};
MMCommonFun.getFileExtension1 = function (filename) {
  var ext = MMCommonFun.getFileExtension(filename) || "";
  if (ext) {
    return ext.slice(1);
  }
  return "";
};
MMCommonFun.getFileNameWithoutExtension = function (filename) {
  console.assert(typeof filename === "string");
  var dotIndex = filename.lastIndexOf(".");
  if (dotIndex == -1) {
    return filename;
  }
  return filename.slice(0, dotIndex);
};

/**
 * generate a random password
 * @param length {number} the length of the password, default 6
 * @param alphabet {string} string, containing all possible character. default a-z0-9
 */
MMCommonFun.generatePassword = function (length, alphabet) {
  if (!length) length = 6;
  alphabet = alphabet || "abcdefghijklmnopqrstuvwxyz1234567890";
  var out = "";
  for (var i = 0; i < length; i++) {
    out += alphabet[parseInt(Math.random() * alphabet.length)];
  }
  return out;
};
MMCommonFun.getMSTime = function (sTime) {
  return parseInt(sTime * 1000);
};
MMCommonFun.formatSec2Date = function (second, format) {
  format = format || "yyyy-MM-dd HH:mm";
  if (second) {
    var t = second;
    if (typeof second == "string") {
      t = parseInt(second);
    }
    return new Date(parseInt(t * 1000)).format(format);
  } else {
    return "--";
  }
};
MMCommonFun.formatDate = function (time, format) {
  format = format || "yyyy-MM-dd HH:mm";
  if (time) {
    return new Date(time).format(format);
  } else {
    return "--";
  }
};
MMCommonFun.formatsec2DateAndWek = function (second) {
  var t = second;
  if (typeof second == "string") {
    t = parseInt(second);
  }
  if (second) {
    var a = new Date(parseInt(t * 1000)).format("yyyy年MM月dd日 EEE HH:mm");
    return unescape(a.replace(/\/u/gi, "%u"));
  } else {
    return "--";
  }
};
MMCommonFun.downloadOriginFile = function (fileId, version, targetName, finished, progressCallback, downFun, errcb) {
  _czc && _czc.push(["_trackEvent", "文件操作", "下载", "", "", ""]);
  MMCommonFun.getDownloadRealPath(fileId, version, function (realUrl, zipStatusKey, downloadFilename, fileSize) {
    MMCommonFun.downloadByUrl(realUrl, zipStatusKey, progressCallback, downloadFilename || targetName, finished, downFun, fileSize);
    // finished && finished();
  }, function (response) {
    finished && finished();
    if (response && response.code != 0) {
      _MDLoadMaskView["default"].remove();
      // if (response["code"] == "10006") {
      //   response["msg"] = BabelStr.str(5542);
      //   MDSnackbarView.show(response["msg"]);
      // }
      if (response.code == _ErrorCode["default"].Not_Login) {
        var msg = BabelStr.str(4865);
        if (fileId instanceof Array && fileId.length > 0) {
          msg = BabelStr.str(4864);
        }
        var alert = new _MDAlertView["default"]({
          title: BabelStr.str(170),
          message: msg,
          buttons: [{
            label: BabelStr.str(155)
          }, {
            label: BabelStr.str(6753),
            type: "done",
            onClick: function onClick() {
              app.redirectToClientDownload();
            }
          }, {
            label: BabelStr.str(483),
            type: "done",
            onClick: function onClick() {
              if (window.isSharePage) {
                location.href = "/account/login.do?url=" + encodeURIComponent(location.href);
              } else {
                app.redirectToLogin();
              }
            }
          }]
        });
        alert.show();
      }
      if (response["code"] == 125 || response["code"] == 126) {
        var downloadWin = new _MDClientDownloadWinView["default"]({
          title: BabelStr.str(5183, {
            multiFilesCount: window.multiFilesCount,
            multiFilesSize: MMCommonFun.getDispStorageIntStr(window.multiFilesSize)
          })
        });
        downloadWin.show();
      }
      _.isFunction(errcb) && errcb(response);
    }
  });
};
MMCommonFun.downloadByUrl = function (fileUrl, zipStatusKey, progressCallback, saveAsFilename, finished, downFun, fileSize) {
  // 文件URL
  // const fileUrl = 'https://example.com/largefile.zip';
  // 每个分段的大小（例如：1MB）
  var chunkSize = 1024 * 1024; // 1MB
  // 最大并发请求数
  var maxConcurrentRequests = 5;
  // 文件总大小（你需要通过HEAD请求或其他方式获取）
  var totalFileSize = 0;
  // 当前已下载的分段数量
  var downloadedChunks = 0;
  // 用于存储每个分段数据的数组
  var chunks = [];
  // 总的已下载大小
  var totalDownloadedSize = 0;
  // 开始时间
  var startTime;
  // 请求数组
  var requests = [];
  var chunkCount = 0;
  var notStartIndexArr = [];
  // 获取文件总大小
  function generateArray(length) {
    return Array.from({
      length: length
    }, function (_, index) {
      return index;
    });
  }
  function getFileSize() {
    if (fileSize) {
      totalFileSize = fileSize;
      chunkCount = Math.ceil(totalFileSize / chunkSize);
      notStartIndexArr = generateArray(chunkCount);
      startDownloads();
    } else {
      var xhr = new XMLHttpRequest();
      xhr.open('HEAD', fileUrl, true);
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          if (xhr.status === 200 || xhr.status === 206) {
            totalFileSize = parseInt(xhr.getResponseHeader('Content-Length'), 10);
            chunkCount = Math.ceil(totalFileSize / chunkSize);
            notStartIndexArr = generateArray(chunkCount);
            startDownloads();
          } else {
            console.error('Failed to get file size.');
          }
        }
      };
      xhr.send();
    }
  }
  // 开始下载
  function startDownloads() {
    while (notStartIndexArr.length && requests.length < maxConcurrentRequests) {
      startNextDownload();
    }
  }
  // 开始下一个分段的下载（如果有的话）
  function startNextDownload() {
    if (notStartIndexArr.length && requests.length < maxConcurrentRequests) {
      var nextIndex = notStartIndexArr.shift();
      var promise = downloadChunk(nextIndex);
      // startDownloadChunksIndex++;
      requests.push(promise);
      promise.then(function () {
        // 当一个请求完成时，从请求数组中移除，并尝试开始新的请求
        var index = requests.indexOf(promise);
        if (index !== -1) {
          requests.splice(index, 1);
        }
        if (notStartIndexArr.length) {
          startNextDownload();
        } else if (downloadedChunks == chunkCount) {
          // 所有分段都下载完成，合并Blob并保存文件
          var blob = new Blob(chunks);
          saveBlobAsFile(blob);
        }
      })["catch"](function (error) {
        console.error(error);
      });
    }
  }

  // 下载指定分段的函数
  function downloadChunk(index) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", fileUrl, true);
      xhr.responseType = "blob";
      var start = index * chunkSize;
      var end = Math.min(start + chunkSize - 1, totalFileSize - 1); // 确保不会超出文件总大小
      xhr.setRequestHeader("Range", "bytes=".concat(start, "-").concat(end));
      xhr.onload = function () {
        if (xhr.status === 206) {
          // Partial Content
          chunks[index] = xhr.response;
          totalDownloadedSize += xhr.response.size;
          downloadedChunks++;
          // updateProgressAndSpeed();
          resolve();
        } else {
          reject(new Error("Failed to fetch the range. Status: " + xhr.status));
        }
      };

      // xhr.onprogress = function (event) {
      //   if (event.lengthComputable) {
      //     var percentComplete = (event.loaded / event.total) * 100;
      //     console.log(percentComplete + "% 下载完成");
      //   }
      // };

      xhr.onerror = function () {
        reject(new Error("An error occurred during the request."));
      };
      xhr.send();
    });
  }

  // // 更新进度和速度
  // function updateProgressAndSpeed() {
  //   const currentTime = Date.now();
  //   const timeElapsed = (currentTime - startTime) / 1000; // 秒
  //   const progress = (downloadedChunks / Math.ceil(totalFileSize / chunkSize) * 100).toFixed(2);
  //   const speed = (totalDownloadedSize / timeElapsed / 1024).toFixed(2); // KB/s
  //   console.log(`Progress: ${progress}%, Speed: ${speed} KB/s`);
  // }

  function saveBlobAsFile(blob) {
    // 创建一个指向Blob对象的URL
    var url = URL.createObjectURL(blob);

    // 创建一个a标签
    var a = document.createElement('a');
    // 设置下载链接的href属性为Blob对象的URL
    a.href = url;
    // 设置下载文件的名称
    a.download = saveAsFilename;

    // 触发下载
    document.body.appendChild(a);
    a.click();

    // 清理：从DOM中移除a标签，并撤销URL对象
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }
  var down = function down(fileUrl) {
    if (_.isFunction(downFun)) {
      downFun(fileUrl, saveAsFilename, fileSize);
      return true;
    }
    if (!app.canDispInNormalBrowser()) {
      var progress = 0.1;
      var oReq = new XMLHttpRequest();
      oReq.responseType = "blob";
      //Download progress
      oReq.addEventListener("progress", function (evt) {
        if (evt.lengthComputable) {
          var percentComplete = evt.loaded / evt.total;
          //Do something with download progress
          if (percentComplete > progress) {
            progress += 0.1;
          }
          if (progressCallback) {
            progressCallback(percentComplete);
          }
        }
      }, false);
      oReq.onload = function () {
        var $fileDownloader = $("#file-downloader");
        if ($fileDownloader.length == 0) {
          $fileDownloader = $("<a>");
          $fileDownloader.attr("id", "file-downloader").appendTo("body");
          $fileDownloader.width(0).height(0).css("visibility", "hidden");
        }
        $fileDownloader.attr("href", fileUrl);
        $fileDownloader[0].click();

        // var a = document.createElement('a');
        // a.href = fileUrl;
        // a.href = window.URL.createObjectURL(oReq.response); // xhr.response is a blob
        // a.download = targetName; // Set the file name.
        // a.style.display = 'none';
        // document.body.appendChild(a);
        // a.click();
        // if (finished) {
        //     finished();
        // };
      };
      oReq.open("get", fileUrl, true);
      oReq.send();
    } else {
      // var $iframe = $('#file-downloader');
      // if ($iframe.length == 0) {
      // var $iframe = $("<iframe>");
      // $iframe.attr("id", "file-downloader").appendTo("body");
      // $iframe.width(0).height(0).css("visibility", "hidden");
      // // }
      // $iframe.attr("src", fileUrl);

      getFileSize();
      return true;
    }
  };
  var getZipStatus = function getZipStatus(zipStatusKey, success, fail) {
    MMEnterpriseController.getZipStatus(zipStatusKey, function (obj) {
      obj.msg = obj.msg || BabelStr.str(3576);
      if (obj.code == 0 && obj.url) {
        fileSize = obj.fileSize;
        success(obj.url);
        if (obj.zipIgnoredLink) {
          _MDSnackbarView["default"].show(BabelStr.str(27106, {}));
        }
      } else if (obj.code == 0 && obj.zipStatusKey) {
        setTimeout(function () {
          getZipStatus(zipStatusKey, success, fail);
        }, 10000);
      } else if (obj.code == 125 && obj.zipStatusKey) {
        _MDSnackbarView["default"].show(BabelStr.str(5183, {
          multiFilesCount: window.multiFilesCount,
          multiFilesSize: MMCommonFun.getDispStorageIntStr(window.multiFilesSize)
        }));
      } else {
        _MDSnackbarView["default"].show(obj.msg);
      }
    }, function (obj) {
      obj.msg = obj.msg || BabelStr.str(3576);
      _MDSnackbarView["default"].show(obj.msg);
    });
  };
  if (!fileUrl && zipStatusKey) {
    getZipStatus(zipStatusKey, function (url) {
      _MDLoadMaskView["default"].remove();
      down(url);
    });
  } else {
    down(fileUrl);
    _MDLoadMaskView["default"].remove();
  }
};
MMCommonFun.downloadAttachmentURL = function (fileId, version, targetName, callback) {
  var param = "fileId=" + fileId + "&version=" + version + "&fileName=" + encodeURIComponent(targetName);
  var url = "netdrive/getAttachmentFileUrl.do?" + param;
  $.get(url, function (res) {
    if (res["success"]) {
      callback(res["url"]);
    } else {
      callback(null);
    }
  });
};

// 判断name是否是图片
MMCommonFun.isImageName = function (name) {
  name = name.trim();
  var ext = name.split(".").pop();
  var imgExt = ["jxl", "avif", "webp",
  // "jxl",
  "jpg", "jpeg", "png", "bmp", "ico", "tiff", "tif", "gif", "psd", "dcm", "heic"];
  return MMCommonFun.isSpecialExt(ext, imgExt);
};
MMCommonFun.isImageNeedConvert = function (name) {
  name = name.trim();
  var ext = name.split(".").pop();
  var imgExt = ["psd", "tif", "tiff", "cr2", "arw", "dng", "nef", "pef", "dcm", "heic"];
  return MMCommonFun.isSpecialExt(ext, imgExt);
};
MMCommonFun.isImageNotNeedConvert = function (name) {
  name = name.trim();
  var ext = name.split(".").pop();
  var imgExt = ["jpg", "jpeg", "png"];
  return MMCommonFun.isSpecialExt(ext, imgExt);
};
MMCommonFun.hasMetaData = function (name) {
  name = name.trim();
  var ext = name.split(".").pop();
  var imgExt = ["heic", "jpg", "jpeg", "png", "tiff", "tif", "bmp", "gif", "ico", "psd", "dcm"];
  return MMCommonFun.isSpecialExt(ext, imgExt);
};
MMCommonFun.canCopyToClipBoard = function (name) {
  name = name.trim();
  var ext = name.split(".").pop();
  var imgExt = ["jpg", "jpeg", "png"];
  return MMCommonFun.isSpecialExt(ext, imgExt);
};
MMCommonFun.isPdfName = function (name) {
  name = name.trim();
  var ext = name.split(".").pop();
  var imgExt = ["pdf"];
  return MMCommonFun.isSpecialExt(ext, imgExt);
};

// 判断name是否是声音
MMCommonFun.isAudioName = function (name) {
  name = name.trim();
  var temp = name.split(".");
  if (temp.length < 2) {
    return false;
  }
  var ext = temp.pop();
  var audioExt = ["mp3", "wav", "wma", "ape", "flac", "wv", "mp2", "m4a", "aac", "m4r", "ogg", "amr", "oc3", "ac3"];
  return MMCommonFun.isSpecialExt(ext, audioExt);
};
// 判断name是否是视频
MMCommonFun.isVideoName = function (name) {
  name = name.trim();
  var temp = name.split(".");
  if (temp.length < 2) {
    return false;
  }
  var ext = temp.pop();
  var videoExt = ["flv", "f4v", "mp4", "m4v", "webm", "3gp", "3gpp", "wmv", "avi", "rm", "rmvb", "mkv", "asf", "mov", "mpeg", "swf", "mpg", "mts", "m2ts"];
  return MMCommonFun.isSpecialExt(ext, videoExt);
};
MMCommonFun.isEmailName = function (name) {
  name = name.trim();
  var temp = name.split(".");
  if (temp.length < 2) {
    return false;
  }
  var ext = temp.pop();
  var videoExt = ["mail", "msg"];
  return MMCommonFun.isSpecialExt(ext, videoExt);
};

// 判断name是否是指定的扩展名
MMCommonFun.isSpecialExt = function (ext, targetExt) {
  if (!ext) {
    return false;
  }
  ext = ext.toLowerCase();
  for (var i = 0; i < targetExt.length; i++) {
    var imgt = targetExt[i];
    if (imgt == ext) {
      return true;
    }
  }
  return false;
};
MMCommonFun.getMediaType = function (name) {
  name = name.trim();
  var ext = name.split(".").pop();
  if (MMCommonFun.isAudioName(name)) {
    return "audio/" + ext;
  } else if (MMCommonFun.isVideoName(name)) {
    return "video/" + ext;
  }
};
MMCommonFun.isPC = function () {
  var userAgentInfo = navigator.userAgent;
  var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
  /* return false ; */
};
MMCommonFun.getImageDispPath = function (fid, fver, w, h) {
  var winW = 0;
  winW = $("body")[0].offsetWidth;
  if (winW < 300) {
    winW = 300;
  }
  if (w && h) {
    var minSize = w > h ? w : h;
    if (winW < minSize) {
      winW = minSize;
    }
  }
  winW *= window.devicePixelRatio;
  winW = Math.round(winW);
  var param = "fileId=" + fid + "&version=" + fver + "&size=" + winW;
  if (window.location.host) {
    var _ret = "/netdrive/downloadDisplayImage.do?" + param;
    return _ret;
  }
  var _ret = "http://192.168.2.17:9090/newDownloadFile.do?" + param;
  return _ret;
};
MMCommonFun.getImageOnlyDispPath = function (fileId, version) {
  var param = "fileId=" + fileId + "&version=" + version + "&needJump2Url=2";
  var url = "/netdrive/getOriginFileUrl.do?" + param;
  return url;
};
MMCommonFun.testImageDispPath = function (fileInfo, fid, fver, _success, fail) {
  if (!fileInfo.isImage()) {
    _success && _success();
    return;
  }
  var url = MMCommonFun.getImageDispPath(fid, fver);
  url += "&needJump2Url=0";
  var count = 0;
  var callUrl = function callUrl() {
    $.ajax({
      method: "post",
      dataType: "json",
      url: url,
      success: function success(responseData, textStatus, jqXHR) {
        var code = responseData["code"];
        if (responseData["success"] === true) {
          _success();
        } else {
          if (count++ < 3 && code == 10010) {
            setTimeout(function () {
              callUrl();
            }, 1000);
          } else {
            fail(code, responseData.msg);
          }
        }
      }
    });
  };
  callUrl();
};
MMCommonFun.getFitZoomScale = function (margin, parentDiv, originRotateW, originRotateH) {
  var containerW = parentDiv.offsetWidth - margin;
  var containerH = parentDiv.offsetHeight - margin;
  if (containerW > 0 && containerH > 0 && originRotateW > 0 && originRotateH > 0) {
    var scaleX = containerW / originRotateW;
    var scaleY = containerH / originRotateH;
    var scale = scaleX < scaleY ? scaleX : scaleY;
    if (scale > 1.0) {
      scale = 1.0;
    }
    return scale;
  }
  return 1.0;
};
MMCommonFun.getDocumentDispPath = function (fid, fver, callback, errorCallback, otherParam) {
  var param = "fileId=" + fid + "&version=" + fver;
  if (window.location.host) {
    var dispIsReady;
    if (otherParam) {
      param += "&dispIsReady=" + otherParam.dispIsReady;
    }
    if (app.ep.getdotmtxcli()) {
      param += "&dotmtxcli=1";
    }
    var _ret = "/netdrive/getDisplayDocumentUrl.do?" + param;
    if (callback) {
      $.get(_ret, function (response) {
        if (response.success === true && response.url) {
          callback(response.url, response.type, response.key);
        } else {
          console.error("get realpath error");
          if (errorCallback) {
            errorCallback(response.code, response.msg);
          }
        }
      });
      //callback(_ret);
    }
    return _ret;
  }
  var _ret = "http://192.168.2.17:9090/getDisplayDocumentUrl.do?" + param;
  return _ret;
};
MMCommonFun.getCadDocumentDispPath = function (fid, fver, callback, errorCallback) {
  var param = "fileId=" + fid + "&version=" + fver;
  if (window.location.host) {
    var _ret = "/netdrive/getCadDisplayDocumentUrl.do?" + param;
    if (callback) {
      $.get(_ret, function (response) {
        if (response.success === true && response.url) {
          callback(response.url, response.type);
        } else {
          console.error("get realpath error");
          if (errorCallback) {
            errorCallback(response.code, response.msg);
          }
        }
      });
      //callback(_ret);
    }
    return _ret;
  }
  var _ret = "http://192.168.2.17:9090/getDisplayDocumentUrl.do?" + param;
  return _ret;
};
MMCommonFun.getDocumentDispRelativePath = function (fileInfo, fver, callback, errorCallback) {
  if (window.location.host) {
    var _ret = "/htmlF/" + fileInfo.getFileId() + "/" + fileInfo.getFileName();
    callback(_ret);
    return _ret;
  }
};
MMCommonFun.getDownloadRealPath = function (fileId, version, callback, errorCallback, url) {
  if (fileId instanceof Array && fileId.length > 0) {
    var ids = fileId;
    var urlParam = "?fileId=" + ids[0];
    for (var i = 1; i < ids.length; i++) {
      urlParam += "!" + ids[i];
    }
    // var urlParam ={
    //   "fileId":ids
    // }
    var url = "/netdrive/downloadMultiFile2.do" + urlParam;
    MMCommonFun.getRealRequestURLByPost(url, function (realUrl, zipStatusKey, downloadFilename, fileSize) {
      callback(realUrl, zipStatusKey, downloadFilename, fileSize);
    }, errorCallback);
  } else {
    var param = "fileId=" + fileId + "&version=" + version;
    var url = "/netdrive/getOriginFileUrl.do?" + param;
    MMCommonFun.getRealRequestURL(url, function (realUrl, downloadFilename, fileSize) {
      callback(realUrl, undefined, downloadFilename, fileSize);
    }, errorCallback);
  }
};
MMCommonFun.userDisplayTrash = function () {
  return !!window.location.hash === "#trash";
};
MMCommonFun.fileCanDispInEditor = function (fileName) {
  var ext = fileName.split(".").pop().toLowerCase();
  var canOpen = false;
  var notsupportInMobile = [];
  if (!app.canDispInNormalBrowser()) {
    var index = _.findIndex(notsupportInMobile, function (notSupport) {
      return notSupport == ext;
    });
    if (index != -1) {
      return false;
    }
  }

  // supportFileFormat 是全局变量，在 main.jsp 中定义
  for (var i = 0; i < window.supportFileFormat.length; i++) {
    var type = window.supportFileFormat[i];
    if (ext == type) {
      canOpen = true;
      break;
    }
  }
  return canOpen;
};
MMCommonFun.fileCanDispInOpenGL = function (fileName) {
  if (!fileName) {
    return false;
  }
  var ext = fileName.split(".").pop().toLowerCase();
  var canOpen = false;

  // openGLFileFormat 是全局变量，在 main.jsp 中定义
  for (var i = 0; i < openGLFileFormat.length; i++) {
    var type = openGLFileFormat[i];
    if (ext == type) {
      canOpen = true;
      break;
    }
  }
  return canOpen;
};
MMCommonFun.fileCanDispInWebBrowser = function (fileName) {
  if (!fileName) {
    return false;
  }
  var ext = fileName.split(".").pop().toLowerCase();
  var canOpen = ext == "html" || ext == "htm";
  return canOpen;
};
MMCommonFun.setWechatForwardTitle = function (fileInfo, ver) {
  $("title").text(fileInfo.getFileName());
  var thumbUrl = "/img/qr_code@1x.png";
  if (fileInfo.isFolder()) {} else {
    var fileId = fileInfo.getFileId();
    var version = ver ? ver : fileInfo.getCurVersion();
    var param = "fileId=" + fileId + "&size=" + 400 + "&version=" + version + "&index=" + 0;
    thumbUrl = "/netdrive/downloadThumbnail.do?" + param;
  }
  $(".wechatTitleIcon").attr("src", thumbUrl);
};
MMCommonFun.refreshTextCommentStatus = function (textComment, pageEditor) {
  if (!textComment || !pageEditor || textComment.getObjType() != _ObjType["default"].Obj_textComment) {
    return;
  }
  if (!pageEditor.getPicObject() || textComment.getPageIndex() != pageEditor.getPicObject().getPageIndex()) {
    return;
  }
  var trsfm = pageEditor.getCanvasTransformer();
  var lgPt = textComment.getStatusPosition();
  var pgIndex = textComment.getPageIndex();
  if (lgPt) {
    var dvPt = trsfm.lg2dvPoint(lgPt, pgIndex);
    var radius = textComment.getStatusRadius() + 5;
    var dvRect = new _MMRect["default"](dvPt.y - radius, dvPt.x + radius, dvPt.y + radius, dvPt.x - radius);
    var lgRect = trsfm.dv2lgRect(dvRect, pgIndex);
    pageEditor.refreshObjsInCanvas(lgRect);
  }
};
MMCommonFun.getDispStorageStr = function (storage) {
  var spaceeDisp = storage / (1024 * 1024);
  var unit = "MB";
  if (spaceeDisp >= 1024) {
    spaceeDisp /= 1024;
    unit = "GB";
  }
  return spaceeDisp.toFixed(2) + unit;
};
MMCommonFun.getDispStorageIntStr = function (storage) {
  var spaceeDisp = storage / (1024 * 1024);
  var unit = "MB";
  if (spaceeDisp >= 1024) {
    spaceeDisp /= 1024;
    unit = "GB";
  }
  return parseInt(spaceeDisp) + unit;
};
MMCommonFun.hasGodEye = function () {
  if (window["departmentFolderId"]) {
    return 1;
  }
  if (app.userBeingViewed) {
    return 2;
  }
  return 0;
};
MMCommonFun.isChrome = function () {
  var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  return isChrome;
};
MMCommonFun.sortByAscllAndLocal = function (arr) {
  var re1 = new RegExp("^[0-9a-zA-Z]");
  var re2 = new RegExp("^[^0-9a-zA-Z]");
  var arr1 = _.filter(arr, function (item) {
    if (re1.test(item)) {
      return item;
    }
  });
  arr1.sort(function (a, b) {
    return a + "" > b + "";
  });
  var arr2 = _.filter(arr, function (item) {
    if (re2.test(item)) {
      return item;
    }
  });
  arr2.sort(function (a, b) {
    return a.localeCompare(b);
  });
  return arr1.concat(arr2);
};
MMCommonFun.decodeFromUTF8Array = function (data) {
  var decodedString = data;
  if (window.TextDecoder) {
    if (data instanceof Uint8Array) {
      data = data.buffer;
    }
    var dataView = new DataView(data);
    // The TextDecoder interface is documented at http://encoding.spec.whatwg.org/#interface-textdecoder
    var decoder = new TextDecoder("utf-8");
    decodedString = decoder.decode(dataView);
  } else {
    if (data instanceof ArrayBuffer) {
      decodedString = MMCommonFun.utf8byteToString(new Uint8Array(data));
    } else {
      console.error("错误的输入");
    }
  }
  return decodedString;
};
MMCommonFun.utf8byteToString = function (arr) {
  if (typeof arr === "string") {
    return arr;
  }
  var str = "",
    _arr = arr;
  for (var i = 0; i < _arr.length; i++) {
    var one = _arr[i].toString(2),
      v = one.match(/^1+?(?=0)/);
    if (v && one.length == 8) {
      var bytesLength = v[0].length;
      var store = _arr[i].toString(2).slice(7 - bytesLength);
      for (var st = 1; st < bytesLength; st++) {
        store += _arr[st + i].toString(2).slice(2);
      }
      str += String.fromCharCode(parseInt(store, 2));
      i += bytesLength - 1;
    } else {
      str += String.fromCharCode(_arr[i]);
    }
  }
  return str;
};
MMCommonFun.isMouseEvent = function (e) {
  var type = e.type;
  return type == "mousedown" || type == "mousemove" || type == "mouseup" || type == "click";
};
MMCommonFun.isCustomEvent = function (e) {
  return !(e instanceof $.Event) && !(e instanceof Event);
};
MMCommonFun.touchPosition = function (e) {
  if (!MMCommonFun.isMouseEvent(e) && (app.isTablet() || app.isMobile())) {
    if (MMCommonFun.isCustomEvent(e)) {
      return new _MMPoint["default"](e.clientX, e.clientY);
    } else if (e.originalEvent.touches.length > 0) {
      var pos = new _MMPoint["default"](e.originalEvent.touches[0].clientX, e.originalEvent.touches[0].clientY);
      return pos;
    } else {
      return null;
    }
  } else {
    return new _MMPoint["default"](e.clientX, e.clientY);
  }
};
MMCommonFun.getMousePosition = function (e, targetDom) {
  var point = null;
  var $root = "";
  if (!app.canDispInNormalBrowser()) {
    $root = $(".m-editor-zone");
  } else {
    $root = $("body");
  }
  var pos = MMCommonFun.touchPosition(e);
  var newpos = MMCommonFun.convertPointBetweenElements($root[0], e.currentTarget, pos);
  if (targetDom) {
    newpos = MMCommonFun.convertPointBetweenElements(e.currentTarget, targetDom, newpos);
  }
  var xPosition = newpos.x;
  var yPosition = newpos.y;
  point = new _MMPoint["default"](xPosition, yPosition);
  return point;
};
MMCommonFun.drawWaterMark = function (ctx, canvas, editor) {
  _MEWaterMarkRenderer["default"].drawWaterMark(ctx, canvas, editor);
};
MMCommonFun._drawWaterMark = function (ctx, canvas, watermarkInfo) {
  _MEWaterMarkRenderer["default"]._drawWaterMark(ctx, canvas, watermarkInfo);
};
MMCommonFun.drawWordWaterMark = function (ctx, canvas, watermarkInfo) {
  _MEWaterMarkRenderer["default"].drawWordWaterMark(ctx, canvas, watermarkInfo);
};
MMCommonFun.drawimgWaterMark = function (ctx, canvas, watermarkInfo) {
  _MEWaterMarkRenderer["default"].drawimgWaterMark(ctx, canvas, watermarkInfo);
};
MMCommonFun.isSupportFlash = function () {
  var result = false;
  var UNDEF = "undefined",
    OBJECT = "object",
    SHOCKWAVE_FLASH = "Shockwave Flash",
    SHOCKWAVE_FLASH_AX = "ShockwaveFlash.ShockwaveFlash",
    FLASH_MIME_TYPE = "application/x-shockwave-flash",
    win = window,
    doc = document,
    nav = navigator;
  if ((0, _typeof2["default"])(nav.plugins) != UNDEF && (0, _typeof2["default"])(nav.plugins[SHOCKWAVE_FLASH]) == OBJECT) {
    var d = nav.plugins[SHOCKWAVE_FLASH].description;
    if (d && !((0, _typeof2["default"])(nav.mimeTypes) != UNDEF && nav.mimeTypes[FLASH_MIME_TYPE] && !nav.mimeTypes[FLASH_MIME_TYPE].enabledPlugin)) {
      // navigator.mimeTypes["application/x-shockwave-flash"].enabledPlugin indicates whether plug-ins are enabled or disabled in Safari 3+
      result = true;
    }
  } else if ((0, _typeof2["default"])(win.ActiveXObject) != UNDEF) {
    try {
      var a = new ActiveXObject(SHOCKWAVE_FLASH_AX);
      if (a) {
        // a will return null when ActiveX is disabled
        result = true;
      }
    } catch (e) {}
  }
  return result;
};
MMCommonFun.setTextInputInEditor = function (name) {
  app[name] = true;
};
MMCommonFun.removeTextInputInEditor = function (name) {
  app[name] = false;
};
MMCommonFun.hasTextInputInEditor = function () {
  var textNames = ["newComment", "replyComment", "handGraphPanel", "fileAttr", "aiPanel", "fileNaviPanel", "approvePanel", "sharePanel", "textEditor", "MarkSettingPanel"];
  for (var _i = 0; _i < textNames.length; _i++) {
    var name = textNames[_i];
    if (app[name]) {
      return true;
    }
  }
  return false;
};
MMCommonFun.allowNumberic = function (e) {
  if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
  // Allow: Ctrl/cmd+A
  e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true) ||
  // Allow: Ctrl/cmd+C
  e.keyCode == 67 && (e.ctrlKey === true || e.metaKey === true) ||
  // Allow: Ctrl/cmd+X
  e.keyCode == 88 && (e.ctrlKey === true || e.metaKey === true) ||
  // Allow: home, end, left, right
  e.keyCode >= 35 && e.keyCode <= 39) {
    // let it happen, don't do anything
    return;
  }
  // Ensure that it is a number and stop the keypress
  if ((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
    e.preventDefault();
  }
};
MMCommonFun.getCurDepfolder = function () {
  var filepaths = app.pathRouter.getFilePaths();
  var depFolder = null;
  if (filepaths.length > 1) {
    for (var _i2 = filepaths.length - 1; _i2 >= 0; _i2--) {
      var fileInfo = filepaths[_i2];
      if (fileInfo.isDepartmentFolder()) {
        depFolder = fileInfo;
        break;
      }
    }
  } else {
    depFolder = filepaths[0];
    depFolder.set("teamMark", 2);
  }
  console.assert(depFolder != null);
  return depFolder;
};
MMCommonFun.canUseSWF2DispPdf = function (opt, callback, errorCallback) {
  var fileId = opt.fileId;
  var version = opt.version;
  var param = "fileId=" + fileId + "&version=" + version;
  var _ret = "/netdrive/isPdfCanUseSwfPreview.do?" + param;
  if (callback) {
    $.get(_ret, function (response) {
      if (response.success === true) {
        callback();
      } else {
        console.error("get canUseSWF2DispPdf error");
        if (errorCallback) {
          errorCallback(response.code, response.msg);
        }
      }
    });
    //callback(_ret);
  }
  return _ret;
};
MMCommonFun.getWindowSize = function () {
  var winWidth, winHeight;
  if (window.innerWidth) winWidth = window.innerWidth;else if (document.body && document.body.clientWidth) winWidth = document.body.clientWidth;
  // 获取窗口高度
  if (window.innerHeight) winHeight = window.innerHeight;else if (document.body && document.body.clientHeight) winHeight = document.body.clientHeight;
  // 通过深入 Document 内部对 body 进行检测，获取窗口大小
  if (document.documentElement && document.documentElement.clientHeight && document.documentElement.clientWidth) {
    winHeight = document.documentElement.clientHeight;
    winWidth = document.documentElement.clientWidth;
  }
  return {
    width: winWidth,
    height: winHeight
  };
};
MMCommonFun.getDefaultRotate = function (fileId, pgIndex) {
  var key = MMCommonFun.PreStorageRotateKey + fileId + "- " + pgIndex;
  var angle = localStorage[key];
  return angle == undefined ? 0 : angle;
};
MMCommonFun.setDefaultRotate = function (fileId, pgIndex, angle) {
  var key = MMCommonFun.PreStorageRotateKey + fileId + "- " + pgIndex;
  localStorage[key] = angle;
};
MMCommonFun.testFileName = function (fileName) {
  var result = [];
  var filterArr = ["\\", "/", ":", "*", "?", '"', "<", ">", "|"];
  for (var i = 0; i < fileName.length; i++) {
    if (fileName.charCodeAt(i) < 32 || filterArr.includes(fileName[i])) {
      result.push(fileName[i]);
    }
  }
  return _.uniq(result);
};
MMCommonFun.validateFileType = function (name, limits) {
  var fileType = name.split(".").reverse();
  fileType = fileType.length > 1 ? fileType[0] : "";
  fileType = fileType.toLocaleLowerCase();
  if (_.isArray(limits) && limits[0]) {
    var type = limits[0]["type"];
    if (type == 1) {
      var typeArr = _.pluck(limits, "stringLimit");
      return ~_.indexOf(typeArr, fileType);
    } else if (type == 2) {
      return name == limits[0]["stringLimit"];
    } else {
      return true;
    }
  }
  return true;
};
MMCommonFun.saveString2File = function (name, text) {
  var urlObject = window.URL || window.webkitURL || window;
  var export_blob = new Blob([text]);
  var save_link = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
  save_link.href = urlObject.createObjectURL(export_blob);
  save_link.download = name;
  var ev = document.createEvent("MouseEvents");
  ev.initMouseEvent("click", true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
  save_link.dispatchEvent(ev);
};
MMCommonFun.convertDataURIToBinary = function (dataURI) {
  var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
  var base64 = dataURI.substring(base64Index);
  var raw = window.atob(base64);
  var rawLength = raw.length;
  var array = new Uint8Array(new ArrayBuffer(rawLength));
  for (i = 0; i < rawLength; i++) {
    array[i] = raw.charCodeAt(i);
  }
  return array;
};
MMCommonFun.base64ToUint8Array = function (base64) {
  var raw = atob(base64);
  var uint8Array = new Uint8Array(raw.length);
  for (var i = 0; i < raw.length; i++) {
    uint8Array[i] = raw.charCodeAt(i);
  }
  return uint8Array;
};
MMCommonFun.openMindMap2Edit = function (fileId) {
  app.pathRouter.openNetTab("/p/order.do");
};
MMCommonFun.openOffice2Edit = function (fileId) {
  var key = "attention_to_onlyoffcie";
  var value = localStorage[key];
  var needShowAlert = true;
  var now = new Date();
  if (value) {
    var d = parseInt(value);
    if (now - d < 1000 * 60 * 60 * 24) {
      needShowAlert = false;
    }
  }

  // if (needShowAlert) {
  //   localStorage[key] = now.getTime();
  //   var opt = {
  //     message: BabelStr.str(20012),
  //     okFun: function() {
  //       app.pathRouter.openNetTab("/netdrive/openFileByBabelOffice.do?fileId=" + fileId);
  //     }
  //   }
  //   MDAlertView.showStandardSelection(opt);
  // } else {
  app.pathRouter.openNetTab("/netdrive/openFileByBabelOffice.do?fileId=" + fileId);
  // }
};
MMCommonFun.setLanguage = function () {
  var lan = BabelStr.getCurrentLanguage();
  if (lan == "cn") {
    localStorage["language"] = "en";
  } else {
    localStorage["language"] = "cn";
  }
  var setLanguage = null;
  if (app.isInClient && app.isInClient() && window["ElectronRequire"]) {
    var electron = window["ElectronRequire"]("electron");
    setLanguage = electron.remote.require("./utils/cppAPI").setLanguage;
  }
  if (setLanguage) {
    setLanguage(localStorage["language"]);
  }
  setTimeout(function () {
    location.reload();
  }, 400);
};
MMCommonFun.setLanguageNew = function (lan) {
  var setLanguage = null;
  localStorage["language"] = lan;
  if (app.isInClient && app.isInClient() && window["ElectronRequire"]) {
    var electron = window["ElectronRequire"]("electron");
    setLanguage = electron.remote.require("./utils/cppAPI").setLanguage;
    // if(lan != 'en') {
    //   lan = 'cn'
    // }
  }
  if (setLanguage) {
    setLanguage(lan);
  }
  setTimeout(function () {
    location.reload();
  }, 400);
};
MMCommonFun.debounce = function (func, wait) {
  var timeout;
  return function () {
    var context = this;
    var args = arguments;
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(function () {
      func.apply(context, args);
    }, wait);
  };
};
MMCommonFun.getOpenPath = function (fid, channelType, callback) {
  channelType = channelType || 0;
  var path;
  var channel;
  if (fid == "0") {
    path = "personfile";
    channel = _MDChannelType["default"].personfile;
    callback(path, channel);
    return;
  }
  if (channelType == 0) {
    if (fid == 1) {
      callback("epfile", _MDChannelType["default"].epfile);
      return;
    }
    if (fid == 2) {
      callback("personfile", _MDChannelType["default"].personfile);
      return;
    }
    if (fid == 3) {
      callback("project", _MDChannelType["default"].project);
      return;
    }
    if (fid == 4) {
      callback("myshare", _MDChannelType["default"].myshare);
      return;
    }
  }
  MMNetDiskDataController.getLastPathFolder(fid, channelType, function (file, isDel) {
    if (isDel) {
      path = "trash/";
      if (file.get("extraStatus") & 64) {
        path = "trash/index/3/";
      } else if (file.get("deleteByUserId") != app.currentUser.getUserId()) {
        path = "trash/index/2/";
      }
      channel = _MDChannelType["default"].trash;
    } else if (file.isOwner() && !file.isSnapshotFile()) {
      path = "personfile/";
      channel = _MDChannelType["default"].trash;
    } else if (file.isDepartmentFolder() || file.getEnterprisePub()) {
      path = "epfile/";
      channel = _MDChannelType["default"].epfile;
    } else if (file.isProject() || file.isHQSMProject()) {
      path = "project/";
      channel = _MDChannelType["default"].project;
    } else if (file.isTeamFolder()) {
      if (app.isEpVersion()) {
        path = "project/";
        channel = _MDChannelType["default"].project;
      } else {
        path = "team/";
        channel = _MDChannelType["default"].team;
      }
    } else if (file.isManuscriptBox()) {
      path = "msbox/index/1/";
      channel = _MDChannelType["default"].msbox;
    } else {
      path = "joinshare/";
      channel = _MDChannelType["default"].joinshare;
    }
    path = path + fid;
    callback(path, channel);
  }, function () {
    path = "personfile";
    callback(path, channel);
    _MDSnackbarView["default"].show(BabelStr.str(5474));
  });
};
MMCommonFun.clipboardCopyCanvas = function (canvas, success, fail) {
  var url = canvas.toDataURL();
  var blob = dataURLtoBlob(url);
  try {
    navigator.clipboard.write([new ClipboardItem((0, _defineProperty2["default"])({}, blob.type, blob))]).then(function () {
      /* success */
      success && success();
    }, function (e) {
      /* failure */
      console.error(e);
      fail && fail();
    });
  } catch (e) {
    fail && fail();
  }
};

/**
 * 复制 Canvas 内容到剪切板（兼容 HTTP 和 HTTPS）
 * @param {HTMLCanvasElement} canvas - 要复制的 Canvas 元素
 * @param {HTMLElement|string} div - 要复制内容的 div 元素或其 id
 * @param {Function} success - 成功回调
 * @param {Function} fail - 失败回调
 */
MMCommonFun.clipboardCopyCanvasAndDiv = function (canvas, div, success, fail) {
  // 兼容 div 传入 id 字符串或 DOM 元素
  var divElement = typeof div === 'string' ? document.getElementById(div) : div;
  if (!divElement) {
    console.error('div 元素不存在');
    fail && fail();
    return;
  }
  var url = canvas.toDataURL();
  var blob = dataURLtoBlob(url);

  // 获取 div 的内容
  var htmlContent = divElement.innerHTML;
  var textContent = divElement.innerText || divElement.textContent || '';

  // ============ 方案一：尝试使用 Clipboard API (HTTPS) ============
  if (navigator.clipboard && navigator.clipboard.write) {
    try {
      navigator.clipboard.write([new ClipboardItem((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, blob.type, blob), 'text/html', new Blob([htmlContent], {
        type: 'text/html'
      })), 'text/plain', new Blob([textContent], {
        type: 'text/plain'
      })))]).then(function () {
        success && success();
      }, function (e) {
        console.warn('Clipboard API 失败，尝试降级方案', e);
        // 降级到传统方案
        MMCommonFun.fallbackCopyCanvas(canvas, divElement, success, fail);
      });
    } catch (e) {
      console.warn('Clipboard API 异常，尝试降级方案', e);
      MMCommonFun.fallbackCopyCanvas(canvas, divElement, success, fail);
    }
  } else {
    // ============ 方案二：传统方案 (HTTP) ============
    MMCommonFun.fallbackCopyCanvas(canvas, divElement, success, fail);
  }
};

// ============ 降级方案：传统复制方式 ============
MMCommonFun.fallbackCopyCanvas = function (canvas, divElement, success, fail) {
  try {
    // 1. 复制图片（通过创建临时 img 标签，然后选中复制）
    var img = new Image();
    img.src = canvas.toDataURL();

    // 创建一个临时容器来显示图片
    var tempDiv = document.createElement('div');
    tempDiv.contentEditable = true;
    tempDiv.style.position = 'fixed';
    tempDiv.style.left = '-9999px';
    tempDiv.style.top = '-9999px';
    tempDiv.appendChild(img);
    document.body.appendChild(tempDiv);

    // 选中并复制
    var range = document.createRange();
    range.selectNodeContents(tempDiv);
    var selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    var successFlag = document.execCommand('copy');
    document.body.removeChild(tempDiv);
    if (successFlag) {
      // 图片复制成功，再尝试复制文本（部分浏览器不支持同时复制）
      MMCommonFun.fallbackCopyText(divElement.innerText || divElement.textContent || '');
      success && success();
    } else {
      // 如果图片复制失败，至少复制文本
      MMCommonFun.fallbackCopyText(divElement.innerText || divElement.textContent || '');
      success && success(); // 仍然认为成功，因为至少复制了文本
    }
  } catch (e) {
    console.error('降级方案失败', e);
    // 最后的救命稻草：只复制文本
    try {
      MMCommonFun.fallbackCopyText(divElement.innerText || divElement.textContent || '');
      success && success();
    } catch (e2) {
      fail && fail();
    }
  }
};

// ============ 纯文本降级复制 ============
MMCommonFun.fallbackCopyText = function (text) {
  var textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.position = 'fixed';
  textarea.style.left = '-9999px';
  textarea.style.top = '-9999px';
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
};
MMCommonFun.imgtoURL = function (img) {
  var canvas = MMCommonFun.imgtocanvas(img);
  var url = canvas.toDataURL();
  // var blob = MMCommonFun.dataURLtoBlob(url)
  return url;
};
MMCommonFun.imgtocanvas = function (img) {
  var canvas = document.createElement("canvas");
  var ctx = canvas.getContext("2d");
  canvas.width = img.width;
  canvas.height = img.height;
  ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
  return canvas;
};
MMCommonFun.dataURLtoBlob = function (dataurl) {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {
    type: mime
  });
};
MMCommonFun.getFileMidDotsString = function (str, left, right, limit) {
  var ext = MMCommonFun.getFileExtension(str);
  var extL = ext.length;
  if (str.length - extL <= limit) {
    return str;
  }
  right += extL;
  var leftStr = str.slice(0, left);
  var rightStr = str.slice(str.length - right, str.length);
  return leftStr + "..." + rightStr;
};
MMCommonFun.getLeftTimeStr = function (time) {
  //ms
  var now = new Date().getTime();
  var hour = 1000 * 60 * 60;
  var day = hour * 24;
  var diff = time - now;
  var leftDay = Math.floor(diff / day);
  var outStr = "";
  if (leftDay >= 1) {
    return BabelStr.str(5562, {
      day: leftDay
    });
  }
  var leftHover = Math.ceil(diff / hour);
  return BabelStr.str(5563, {
    hour: leftHover
  });
};
MMCommonFun.openExcel2Read = function (fid, v, forMobile) {
  //ms
  if (isNaN(v)) {
    v = -1;
  }
  var openFunc = function openFunc() {
    if (forMobile) {
      location.href = location.origin + "/netdrive/openFileByBabelOffice.do?fileId=" + fid + "&readOnly=1&version=" + v;
    } else {
      app.pathRouter.openNetTab("/netdrive/openFileByBabelOffice.do?fileId=" + fid + "&readOnly=1&version=" + v);
    }
  };

  //----------------------------------------------------- 暂不检查，直接调用 openFunc();
  // var url = "/netdrive/isDocEditedByOnlyOffice.do";
  // var postData = {
  //   fileId: fid
  // }
  // $.ajax({
  //   method: 'post',
  //   dataType: "json",
  //   url: url,
  //   data: postData,
  //   success: function(responseData, textStatus, jqXHR) {
  //     if (responseData["success"] === true) {
  //       var isEditing = responseData["isEditing"];
  //       if (isEditing) {
  //         MDAlertView.showDangerSelection({
  //           message: BabelStr.str(21305),
  //           okStr: BabelStr.str(3331),
  //           okFun: function(){
  //             openFunc();
  //           }
  //         })
  //       } else {
  //         openFunc();
  //       }
  //     }
  //   },
  // });

  openFunc();
};
MMCommonFun.stringToArray = function (str) {
  var bytes = new Array();
  var len, c;
  len = str.length;
  for (var i = 0; i < len; i++) {
    c = str.charCodeAt(i);
    if (c >= 0x010000 && c <= 0x10ffff) {
      bytes.push(c >> 18 & 0x07 | 0xf0);
      bytes.push(c >> 12 & 0x3f | 0x80);
      bytes.push(c >> 6 & 0x3f | 0x80);
      bytes.push(c & 0x3f | 0x80);
    } else if (c >= 0x000800 && c <= 0x00ffff) {
      bytes.push(c >> 12 & 0x0f | 0xe0);
      bytes.push(c >> 6 & 0x3f | 0x80);
      bytes.push(c & 0x3f | 0x80);
    } else if (c >= 0x000080 && c <= 0x0007ff) {
      bytes.push(c >> 6 & 0x1f | 0xc0);
      bytes.push(c & 0x3f | 0x80);
    } else {
      bytes.push(c & 0xff);
    }
  }
  var array = new Int8Array(bytes.length);
  for (var i = 0; i <= bytes.length; i++) {
    array[i] = bytes[i];
  }
  return array;
};
MMCommonFun.stringToArrayBuffer = function (str) {
  var array = MMCommonFun.stringToArray(str);
  return array.buffer;
};
MMCommonFun.arrayBufferToString = function (buffer) {
  return String.fromCharCode.apply(null, new Uint8Array(buffer));
};
MMCommonFun.encrptFileId = function (fileId) {
  var key = ("Mola_" + fileId).substr(0, 8);
  var iv = key;
  console.log("----> key:" + key);
  var _key2 = CryptoJS.enc.Utf8.parse(key); // key
  var _iv2 = CryptoJS.enc.Utf8.parse(iv); // iv
  var encrypted = CryptoJS.TripleDES.encrypt(fileId, _key2, {
    iv: _iv2,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
};
MMCommonFun.filterFileName = function (value) {
  var result = "";
  var filterArr = ["\\", "/", ":", "*", "?", '"', "<", ">", "|"];
  for (var i = 0; i < value.length; i++) {
    if (value.charCodeAt(i) >= 32 && !filterArr.includes(value[i])) {
      result += value[i];
    }
  }
  return result;
};
MMCommonFun.getClientVersion = function () {
  var getClientVersionFun = window["ElectronRequire"]("electron").remote.require("./utils/cppAPI").getClientVersion;
  if (!getClientVersionFun) {
    return null;
  }
  var clientVersion = getClientVersionFun();
  var nums = clientVersion.split(".");
  for (var _i3 = 0; _i3 < nums.length; _i3++) {
    nums[_i3] = parseInt(nums[_i3]);
  }
  return nums;
};
MMCommonFun.isTheClientVersionTooLow = function (v1, v2, v3) {
  var nums = MMCommonFun.getClientVersion();
  if (!nums) {
    return true;
  }
  return nums[0] < v1 || nums[0] == v1 && nums[1] < v2 || nums[0] == v1 && nums[1] == v2 && nums[2] < v3;
};
MMCommonFun.isTheClientSupportAnonymouseDownload = function () {
  var isBelow6_1_7 = MMCommonFun.isTheClientVersionTooLow(6, 1, 7);
  return !isBelow6_1_7;
};
MMCommonFun.getStartTime = function (dateStr) {
  var now = new Date(dateStr); // 当前日期和时间
  var startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return startOfDay;
};
MMCommonFun.getEndTime = function (dateStr) {
  var now = new Date(dateStr);
  var endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 0);
  // let endOfDayTimestamp = endOfDay.getTime(); // 获取 Unix 时间戳（毫秒）
  return endOfDay;
};
var num_reg = /[0-9]+/;
MMCommonFun.compareStrAndNum = function (v1, v2) {
  var r1 = num_reg.exec(v1);
  var r2 = num_reg.exec(v2);
  // console.warn("------ v1:", v1, "\n  ------ v2:", v2);
  if (r1 && r2 && r1.index == r2.index) {
    var pre1 = v1.substr(0, r1.index);
    var pre2 = v2.substr(0, r2.index);
    // console.warn("------ pre1:", pre1, ", pre2:", pre2);
    if (pre1 == pre2) {
      var num1 = parseInt(r1[0]);
      var num2 = parseInt(r2[0]);
      // console.warn("------ num1:", num1, ", num2:", num2);
      if (num1 > num2) {
        return 1;
      } else if (num1 < num2) {
        return -1;
      } else {
        v1 = v1.substr(r1.index + r1[0].length);
        v2 = v2.substr(r2.index + r2[0].length);
        return MMCommonFun.compareStrAndNum(v1, v2);
      }
    } else {
      return pre1.localeCompare(pre1);
    }
  } else {
    return v1.localeCompare(v2);
  }
};
MMCommonFun.decryptDesCbc = function (message, key) {
  message = CryptoJS.enc.Base64.parse(message);
  var keyWords = CryptoJS.enc.Utf8.parse(key);
  var ivWords = keyWords;
  var decrypted = CryptoJS.DES.decrypt({
    ciphertext: message
  }, keyWords, {
    iv: ivWords,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  var result = decrypted.toString(CryptoJS.enc.Utf8);
  return decodeURIComponent(result);
};
MMCommonFun.encrptDesCbc2 = function (data) {
  var key = window.g_sessionId.substr(0, 8);
  var iv = key;
  console.log("----> key:" + key);
  var _key2 = CryptoJS.enc.Utf8.parse(key); // key
  var _iv2 = CryptoJS.enc.Utf8.parse(iv); // iv
  var encrypted = CryptoJS.DES.encrypt(data, _key2, {
    iv: _iv2,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
};

// MMCommonFun.decryptDesECB = function (message, key) {
//   message = CryptoJS.enc.Base64.parse(message);
//   var keyWords = CryptoJS.enc.Utf8.parse(key);
//   var ivWords = keyWords;
//   var decrypted = CryptoJS.DES.decrypt(message, keyWords, { iv: ivWords,
//     mode: CryptoJS.mode.ECB,
//     padding: CryptoJS.pad.Pkcs7
//    });
//   var result = decrypted.toString(CryptoJS.enc.Utf8);
//   return result;
// };

// MMCommonFun.decryptAES = function (message, key) {
//   // message = CryptoJS.enc.Base64.parse(message);
//   var keyWords = CryptoJS.enc.Utf8.parse(key);
//   var ivWords = keyWords;
//   var decrypted = CryptoJS.TripleDES.decrypt(message, keyWords, { iv: ivWords,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.Pkcs7
//    });
//   var result = decrypted.toString(CryptoJS.enc.Utf8);
//   return result;
// };

MMCommonFun.generateRandomString = function (length) {
  // 定义一个包含大小写字母和数字的字符串
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var result = '';
  var charactersLength = characters.length;
  for (var _i4 = 0; _i4 < length; _i4++) {
    // 使用Math.random()生成一个随机索引，并通过charAt()方法获取对应的字符
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};
MMCommonFun.getMaterialFileChanges = function (localStr, opreationType) {
  var fileChanges = [];
  var index = 1;
  while (opreationType > 0) {
    var zeroBit = opreationType & 1;
    if (zeroBit > 0) {
      var tName = localStr[index];
      if (tName) {
        fileChanges.push(tName);
      }
    }
    index = index << 1;
    opreationType = opreationType >> 1;
  }
  return fileChanges.join(',');
};
MMCommonFun.downloadFileByUrl = function (fileUrl, fileName) {
  // 1. 创建隐藏的 a 标签
  var link = document.createElement('a');
  link.href = fileUrl;

  // 2. 设置下载属性（指定文件名，若不设置则用 URL 中的文件名）
  if (fileName) {
    link.download = fileName; // 注意：跨域且不支持 CORS 时，此属性可能失效
  }
  // 3. 新 tab 页触发下载，加 rel 提升安全性
  link.target = '_blank';
  link.rel = 'noopener noreferrer';

  // 3. 隐藏标签（不影响页面布局）
  link.style.display = 'none';
  document.body.appendChild(link);

  // 4. 触发点击下载
  link.click();

  // 5. 下载后移除标签（清理 DOM）
  document.body.removeChild(link);

  // 6. 若为 blob URL，需释放内存（可选，避免内存泄漏）
  if (fileUrl.startsWith('blob:')) {
    URL.revokeObjectURL(fileUrl);
  }
};
MMCommonFun.PreStorageRotateKey = "FileRotate";
window.MMCommonFun = MMCommonFun;
var _default = exports["default"] = MMCommonFun;

},{"1084":1084,"1087":1087,"1180":1180,"1184":1184,"1197":1197,"1410":1410,"1411":1411,"1412":1412,"1415":1415,"1416":1416,"1418":1418,"1419":1419,"1420":1420,"1421":1421,"1423":1423,"1424":1424,"1425":1425,"1428":1428,"1429":1429,"1431":1431,"1432":1432,"1434":1434,"1437":1437,"1450":1450,"1454":1454,"1463":1463,"1465":1465,"1466":1466,"1471":1471,"1476":1476,"1477":1477,"1478":1478,"1487":1487,"1489":1489,"1492":1492,"1493":1493,"1496":1496,"1498":1498,"1500":1500,"1503":1503,"1505":1505,"1506":1506,"1507":1507,"1508":1508,"1509":1509,"1510":1510,"1512":1512,"1513":1513,"1514":1514,"1515":1515,"1516":1516,"1517":1517,"1518":1518,"1519":1519,"1520":1520,"1521":1521,"1522":1522,"1523":1523,"1524":1524,"1525":1525,"1526":1526,"1527":1527,"1528":1528,"1529":1529,"1530":1530,"1537":1537,"1538":1538,"1541":1541,"1543":1543,"1545":1545,"32":32,"484":484,"49":49,"717":717,"72":72,"808":808,"830":830,"831":831,"839":839}],1515:[function(require,module,exports){
var createTypedArrayConstructor = require(1395);

// `Int8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Int8', function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"1395":1395}],1496:[function(require,module,exports){
'use strict';
var $ = require(1270);
var uncurryThis = require(1280);
var getOwnPropertyDescriptor = require(1329).f;
var toLength = require(1386);
var toString = require(1393);
var notARegExp = require(1322);
var requireObjectCoercible = require(1359);
var correctIsRegExpLogic = require(1239);
var IS_PURE = require(1308);

// eslint-disable-next-line es/no-string-prototype-startswith -- safe
var nativeStartsWith = uncurryThis(''.startsWith);
var stringSlice = uncurryThis(''.slice);
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = toString(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString(searchString);
    return nativeStartsWith
      ? nativeStartsWith(that, search, index)
      : stringSlice(that, index, index + search.length) === search;
  }
});

},{"1239":1239,"1270":1270,"1280":1280,"1308":1308,"1322":1322,"1329":1329,"1359":1359,"1386":1386,"1393":1393}],1322:[function(require,module,exports){
var isRegExp = require(1309);

var $TypeError = TypeError;

module.exports = function (it) {
  if (isRegExp(it)) {
    throw $TypeError("The method doesn't accept regular expressions");
  } return it;
};

},{"1309":1309}],1239:[function(require,module,exports){
var wellKnownSymbol = require(1408);

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

},{"1408":1408}],1493:[function(require,module,exports){
'use strict';
var call = require(1278);
var fixRegExpWellKnownSymbolLogic = require(1272);
var anObject = require(1209);
var isNullOrUndefined = require(1306);
var requireObjectCoercible = require(1359);
var sameValue = require(1360);
var toString = require(1393);
var getMethod = require(1285);
var regExpExec = require(1352);

// @@search logic
fixRegExpWellKnownSymbolLogic('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible(this);
      var searcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, SEARCH);
      return searcher ? call(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeSearch, rx, S);

      if (res.done) return res.value;

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});

},{"1209":1209,"1272":1272,"1278":1278,"1285":1285,"1306":1306,"1352":1352,"1359":1359,"1360":1360,"1393":1393}],1360:[function(require,module,exports){
// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

},{}],1434:[function(require,module,exports){
// TODO: Remove this module from `core-js@4` since it's replaced to module below
require(1433);

},{"1433":1433}],1433:[function(require,module,exports){
var $ = require(1270);
var ArrayBufferModule = require(1213);
var NATIVE_ARRAY_BUFFER = require(1210);

// `DataView` constructor
// https://tc39.es/ecma262/#sec-dataview-constructor
$({ global: true, constructor: true, forced: !NATIVE_ARRAY_BUFFER }, {
  DataView: ArrayBufferModule.DataView
});

},{"1210":1210,"1213":1213,"1270":1270}],1420:[function(require,module,exports){
'use strict';
var $ = require(1270);
var $includes = require(1219).includes;
var fails = require(1271);
var addToUnscopables = require(1206);

// FF99+ bug
var BROKEN_ON_SPARSE = fails(function () {
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

},{"1206":1206,"1219":1219,"1270":1270,"1271":1271}],1084:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var ObjType = {
  Obj_default: 0,
  GObj_indicateline: 1,
  GObj_brokenline: 2,
  GObj_rect: 3,
  GObj_roundrect: 4,
  GObj_triangle: 5,
  GObj_circle: 6,
  GObj_line: 7,
  GObj_dottedline: 8,
  //
  GObj_arrow: 9,
  //
  GObj_doubleArrow: 10,
  //
  GObj_hexagon: 11,
  GObj_diamond: 12,
  GObj_doc: 13,
  GObj_halfroundrect: 14,
  GObj_pentagon: 15,
  GObj_fivestar: 16,
  GObj_directionarrow: 17,
  GObj_circlemark: 18,
  GObj_cloud: 19,
  GObj_scribble: 20,
  GObj_nitePen: 21,
  GObj_emoji: 22,
  //
  GObj_text: 23,
  //
  GObj_note: 24,
  GObj_rectMark: 25,
  Obj_Image: 26,
  //
  Obj_PDF: 27,
  //
  Obj_Recorder: 28,
  //
  Obj_Document: 29,
  //
  Obj_Group: 30,
  // 组
  Obj_comment: 31,
  // 标注
  Obj_niceTag: 32,
  Obj_textComment: 33,
  // 文字批注
  Obj_graphComment: 34,
  // 图形批注

  Obj_weldMark: 35,
  // 焊接批注
  Obj_signatureFrame: 36,
  // 签名位置框

  Obj_seal: 40,
  //签章
  Obj_sig: 41,
  //普通签名

  getCanvasObjType: function getCanvasObjType() {
    var types = [];
    for (var i = 1; i < 25; i++) {
      types.push(i);
    }
    ;
    types.push(ObjType.Obj_textComment);
    types.push(ObjType.Obj_graphComment);
    types.push(ObjType.Obj_weldMark);
    types.push(ObjType.Obj_signatureFrame);
    types.push(ObjType.Obj_seal);
    types.push(ObjType.Obj_sig);
    return types;
  }
};
var _default = exports["default"] = ObjType;

},{"1454":1454}],808:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1423);
require(1443);
require(1463);
require(1487);
require(1538);
require(1445);
require(1414);
require(1415);
require(1429);
require(1412);
require(1431);
require(1444);
require(1432);
require(1477);
require(1437);
require(1421);
/*
 * @Author: jichao
 * @Date: 2026-07-15 00:00:00
 * @FilePath: \WebContent\javascript\molasync-source\common\MEWaterMarkRenderer.js
 */

var _imgWatermarkCache = new Map();
var GRID_CODE_MAP = {
  '0': [3, 5, 6, 8],
  '1': [1, 2, 3, 4],
  '2': [1, 4, 6, 8],
  '3': [2, 4, 5, 7],
  '4': [0, 2, 3, 7],
  '5': [2, 6, 7, 8],
  '6': [1, 2, 5, 6],
  '7': [1, 3, 6, 7],
  '8': [0, 1, 4, 7],
  '9': [0, 3, 4, 5],
  'A': [0, 2, 5, 8],
  'B': [3, 4, 7, 8],
  'C': [1, 5, 7, 8],
  'D': [0, 2, 4, 6],
  'E': [0, 1, 3, 8],
  'F': [0, 5, 6, 7]
};
var SYNC_CODE = [0, 6, 8];
function getPayloadSeed(text) {
  var seed = 2166136261;
  for (var i = 0; i < text.length; i++) {
    seed ^= text.charCodeAt(i);
    seed = Math.imul(seed, 16777619);
  }
  return seed >>> 0;
}
function isAntiAiMode(mode) {
  return mode === 'cmy' || mode === 'cluster' || mode === 'scatter';
}
function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}
function seededNoise(row, col, seed, salt) {
  var value = Math.sin((row + 1) * 127.1 + (col + 1) * 311.7 + seed * 0.017 + salt * 74.7) * 43758.5453;
  return value - Math.floor(value);
}
function getPerceptualScatter(value) {
  var normalized = clamp(value, 0, 1);
  return normalized === 0 ? 0 : Math.pow(normalized, 0.72);
}
function getVectorCellRatio(scaleUi) {
  var t = Math.min(1, Math.max(0, (scaleUi - 1) / 19));
  return 0.026 + Math.pow(t, 1.05) * 0.048;
}
function getReadableCellSize(cellRatio, canvas) {
  var shortSide = Math.max(1, Math.min(canvas.width, canvas.height));
  return Math.max(24, shortSide * cellRatio);
}
function getGridOverflowCells(densityFactor) {
  if (densityFactor <= 0.7) return 0;
  return Math.min(1, (densityFactor - 0.7) / 0.3);
}
function getModuleAxisCapacity(canvasSize, cellSize, blockCells, stepCells, overflowCells) {
  var availableCells = canvasSize / Math.max(1, cellSize) + overflowCells * 2;
  return Math.max(1, Math.floor(Math.max(0, availableCells - blockCells) / stepCells) + 1);
}
function getModuleGridCapacity(width, height, cellSize, groupCells, groupGapCells, rowGapCells, overflowCellsX, overflowCellsY) {
  var maxCols = getModuleAxisCapacity(width, cellSize, groupCells, groupCells + groupGapCells, overflowCellsX);
  var maxRows = getModuleAxisCapacity(height, cellSize, 1, 1 + rowGapCells, overflowCellsY);
  return {
    maxCols: maxCols,
    maxRows: maxRows,
    maxGroups: Math.max(1, maxCols * maxRows)
  };
}
function getTargetGroupCount(densityFactor, maxGroups) {
  var easedDensity = Math.pow(densityFactor, 1.18);
  return Math.max(1, Math.round(1 + easedDensity * (maxGroups - 1)));
}
function getCoveragePenalty(count, maxCount) {
  if (maxCount <= 1 || count > 1) return 0;
  return 0.08;
}
function getCenterCoveragePenalty(count, maxCount, targetGroups) {
  if (maxCount < 3 || targetGroups < 4 || count % 2 === 1) return 0;
  return 0.06;
}
function pickModuleGrid(maxCols, maxRows, targetGroups, groupCells, groupGapCells, rowGapCells, canvas) {
  var imageAspect = canvas.width / Math.max(1, canvas.height);
  var needsFullCoverage = targetGroups > 2;
  var minCols = needsFullCoverage && maxCols >= 3 ? 3 : 1;
  var minRows = needsFullCoverage && maxCols < 3 && maxRows >= 3 ? 3 : 1;
  var best = {
    cols: 1,
    rows: 1,
    score: Infinity
  };
  for (var cols = minCols; cols <= maxCols; cols++) {
    for (var rows = minRows; rows <= maxRows; rows++) {
      var copies = cols * rows;
      var footprintCellsX = groupCells + Math.max(0, cols - 1) * (groupCells + groupGapCells);
      var footprintCellsY = 1 + Math.max(0, rows - 1) * (1 + rowGapCells);
      var footprintAspect = footprintCellsX / Math.max(1, footprintCellsY);
      var coverageAspect = cols / Math.max(1, rows);
      var copyScore = Math.abs(copies - targetGroups) / Math.max(1, targetGroups);
      var aspectScore = Math.min(Math.abs(Math.log(footprintAspect / imageAspect)), Math.abs(Math.log(coverageAspect / imageAspect))) * 0.18;
      var underTargetPenalty = copies < targetGroups ? 1 + (targetGroups - copies) / Math.max(1, targetGroups) : 0;
      var edgeCoveragePenalty = getCoveragePenalty(cols, maxCols) + getCoveragePenalty(rows, maxRows);
      var centerCoveragePenalty = getCenterCoveragePenalty(cols, maxCols, targetGroups) + getCenterCoveragePenalty(rows, maxRows, targetGroups);
      var score = copyScore + aspectScore + underTargetPenalty + edgeCoveragePenalty + centerCoveragePenalty;
      if (score < best.score) best = {
        cols: cols,
        rows: rows,
        score: score
      };
    }
  }
  return best;
}
function getMaxCellSizeForGrid(width, height, cols, rows, groupCells, groupGapCells, rowGapCells, overflowCellsX, overflowCellsY) {
  var footprintCellsX = groupCells + Math.max(0, cols - 1) * (groupCells + groupGapCells);
  var footprintCellsY = 1 + Math.max(0, rows - 1) * (1 + rowGapCells);
  var fitCellsX = Math.max(1, footprintCellsX - overflowCellsX * 2);
  var fitCellsY = Math.max(1, footprintCellsY - overflowCellsY * 2);
  return Math.min(width / fitCellsX, height / fitCellsY);
}
function getVectorMetrics(cellRatio, densityFactor, digitCount, canvas) {
  var groupCells = digitCount + 1;
  var groupGapCells = 1;
  var rowGapCells = 1;
  var minCellSize = getReadableCellSize(cellRatio, canvas);
  var overflowCellsX = getGridOverflowCells(densityFactor);
  var overflowCellsY = 0;
  var capacity = getModuleGridCapacity(canvas.width, canvas.height, minCellSize, groupCells, groupGapCells, rowGapCells, overflowCellsX, overflowCellsY);
  var targetGroups = getTargetGroupCount(densityFactor, capacity.maxGroups);
  var tileGrid = pickModuleGrid(capacity.maxCols, capacity.maxRows, targetGroups, groupCells, groupGapCells, rowGapCells, canvas);
  var maxCellSize = getMaxCellSizeForGrid(canvas.width, canvas.height, tileGrid.cols, tileGrid.rows, groupCells, groupGapCells, rowGapCells, overflowCellsX, overflowCellsY);
  var preferredCellSize = minCellSize * (1 + Math.pow(1 - densityFactor, 1.45) * 0.5);
  var cellSize = Math.max(minCellSize, Math.min(preferredCellSize, maxCellSize));
  var overflowAllowanceX = cellSize * overflowCellsX;
  var overflowAllowanceY = cellSize * overflowCellsY;
  var dotRadius = Math.max(1.85, cellSize * 0.048);
  var gridStep = Math.max(dotRadius * 4.9, cellSize * 0.29);
  var glyphSize = dotRadius * 2 + gridStep * 2;
  var maxGlyphSize = cellSize * 0.78;
  if (glyphSize > maxGlyphSize) {
    gridStep = Math.max(dotRadius * 3.8, (maxGlyphSize - dotRadius * 2) / 2);
    glyphSize = dotRadius * 2 + gridStep * 2;
  }
  var cellPadding = (cellSize - glyphSize) / 2;
  return {
    cellSize: cellSize,
    cellPadding: cellPadding,
    dotRadius: dotRadius,
    gridStep: gridStep,
    glyphSize: glyphSize,
    blockWidth: groupCells * cellSize,
    blockHeight: cellSize,
    tileStepX: (groupCells + groupGapCells) * cellSize,
    tileStepY: (1 + rowGapCells) * cellSize,
    tileCols: tileGrid.cols,
    tileRows: tileGrid.rows,
    minCellSize: minCellSize,
    cellRatio: cellRatio,
    targetGroups: targetGroups,
    maxGroups: capacity.maxGroups,
    overflowCellsX: overflowCellsX,
    overflowCellsY: overflowCellsY,
    overflowAllowanceX: overflowAllowanceX,
    overflowAllowanceY: overflowAllowanceY,
    rowOffsetRatio: 0
  };
}
function getUniformAxisPositions(canvasSize, blockSize, minimumStep, overflowAllowance, count) {
  if (count <= 1) {
    return [Math.max(-overflowAllowance, Math.min(canvasSize - blockSize + overflowAllowance, (canvasSize - blockSize) / 2))];
  }
  var stratumStep = canvasSize / count;
  var minPos = -overflowAllowance;
  var maxPos = canvasSize - blockSize + overflowAllowance;
  if (stratumStep >= minimumStep) {
    var positions = [];
    for (var i = 0; i < count; i++) {
      var centered = (i + 0.5) * stratumStep - blockSize / 2;
      positions.push(Math.max(minPos, Math.min(maxPos, centered)));
    }
    return positions;
  }
  var availableSpan = Math.max(0, maxPos - minPos);
  var fittedStep = count > 1 ? availableSpan / (count - 1) : 0;
  var actualStep = Math.min(minimumStep, Math.max(0, fittedStep));
  var packedSpan = blockSize + (count - 1) * actualStep;
  var start = Math.max(minPos, Math.min(maxPos, (canvasSize - packedSpan) / 2));
  var positions = [];
  for (var i = 0; i < count; i++) {
    positions.push(Math.max(minPos, Math.min(maxPos, start + i * actualStep)));
  }
  return positions;
}
function getWatermarkTileCount(canvasSize, blockSize, step, densityFactor) {
  var available = Math.max(0, canvasSize - blockSize);
  var strictCount = Math.max(1, Math.floor(available / step) + 1);
  var overflowCount = Math.max(1, Math.ceil(available / step) + 1);
  var canOverflowOneTile = densityFactor > 0.72;
  if (!canOverflowOneTile) return strictCount;
  return Math.min(strictCount + 1, overflowCount);
}
function toRgba(color, alpha) {
  return 'rgba(' + color[0] + ',' + color[1] + ',' + color[2] + ',' + alpha + ')';
}
function traceDot(ctx, cx, cy, radius, isAnchor) {
  ctx.beginPath();
  if (isAnchor) {
    ctx.rect(cx - radius, cy - radius, radius * 2, radius * 2);
  } else {
    ctx.arc(cx, cy, radius, 0, Math.PI * 2);
  }
}
function sampleAdaptiveBackground(sampler, canvas, cx, cy, radius) {
  if (!sampler) return {
    r: 240,
    g: 248,
    b: 255
  };
  var sx = Math.max(0, Math.min(sampler.width - 1, Math.round(cx / canvas.width * (sampler.width - 1))));
  var sy = Math.max(0, Math.min(sampler.height - 1, Math.round(cy / canvas.height * (sampler.height - 1))));
  var reach = Math.max(1, Math.min(3, Math.round(radius * sampler.width / canvas.width * 2.2)));
  var r = 0,
    g = 0,
    b = 0,
    count = 0;
  for (var y = sy - reach; y <= sy + reach; y++) {
    if (y < 0 || y >= sampler.height) continue;
    for (var x = sx - reach; x <= sx + reach; x++) {
      if (x < 0 || x >= sampler.width) continue;
      var idx = (y * sampler.width + x) * 4;
      r += sampler.data[idx];
      g += sampler.data[idx + 1];
      b += sampler.data[idx + 2];
      count++;
    }
  }
  return {
    r: r / Math.max(1, count),
    g: g / Math.max(1, count),
    b: b / Math.max(1, count)
  };
}
function getAntiAiVisualProfile(mode) {
  var profiles = {
    cmy: {
      probes: [[0, 214, 255], [255, 52, 188], [255, 226, 32]],
      probeAlpha: 0.54,
      shards: 2
    },
    cluster: {
      probes: [[28, 238, 118], [255, 64, 82], [255, 216, 42], [68, 132, 255]],
      probeAlpha: 0.5,
      shards: 3
    },
    scatter: {
      probes: [[76, 206, 255], [255, 72, 178], [255, 244, 72]],
      probeAlpha: 0.46,
      shards: 2
    }
  };
  return profiles[mode] || profiles.cmy;
}
function drawSmartAdaptiveDot(ctx, cx, cy, radius, isAnchor, sampler, canvas, styleCache) {
  var bg = sampleAdaptiveBackground(sampler, canvas, cx, cy, radius);
  var qr = Math.max(0, Math.min(255, Math.round(bg.r / 32) * 32));
  var qg = Math.max(0, Math.min(255, Math.round(bg.g / 32) * 32));
  var qb = Math.max(0, Math.min(255, Math.round(bg.b / 32) * 32));
  var key = qr + ',' + qg + ',' + qb;
  var style;
  if (styleCache && styleCache.has(key)) {
    style = styleCache.get(key);
  } else {
    var lum = (0.2126 * qr + 0.7152 * qg + 0.0722 * qb) / 255;
    var chroma = Math.max(qr, qg, qb) - Math.min(qr, qg, qb);
    var fill;
    if (chroma > 26) {
      fill = [255 - qr, 255 - qg, 255 - qb];
      fill = lum > 0.56 ? [Math.round(fill[0] * 0.58 + 8 * 0.42), Math.round(fill[1] * 0.58 + 16 * 0.42), Math.round(fill[2] * 0.58 + 32 * 0.42)] : [Math.round(fill[0] * 0.64 + 250 * 0.36), Math.round(fill[1] * 0.64 + 252 * 0.36), Math.round(fill[2] * 0.64 + 255 * 0.36)];
    } else {
      fill = lum > 0.56 ? [12, 28, 58] : [244, 248, 255];
    }
    var fillLum = (0.2126 * fill[0] + 0.7152 * fill[1] + 0.0722 * fill[2]) / 255;
    if (lum > 0.56 && fillLum > 0.42) fill = [Math.round(fill[0] * 0.54), Math.round(fill[1] * 0.54), Math.round(fill[2] * 0.54)];
    if (lum <= 0.56 && fillLum < 0.62) fill = [Math.round(fill[0] * 0.48 + 255 * 0.52), Math.round(fill[1] * 0.48 + 255 * 0.52), Math.round(fill[2] * 0.48 + 255 * 0.52)];
    fillLum = (0.2126 * fill[0] + 0.7152 * fill[1] + 0.0722 * fill[2]) / 255;
    var stroke = lum > 0.56 ? [250, 252, 255] : [10, 16, 28];
    var glint = fillLum > 0.5 ? [255, 255, 255] : [18, 28, 46];
    style = {
      fill: toRgba(fill, 1.0),
      stroke: toRgba(stroke, 1.0),
      glint: toRgba(glint, 1.0)
    };
    if (styleCache) styleCache.set(key, style);
  }
  var visualRadius = radius * 1.46;
  ctx.save();
  ctx.lineJoin = 'round';
  ctx.lineCap = 'round';
  ctx.globalCompositeOperation = 'source-over';
  ctx.globalAlpha = Math.max(ctx.globalAlpha, 0.16);
  ctx.strokeStyle = style.stroke;
  ctx.lineWidth = Math.max(1.55, visualRadius * 0.46);
  traceDot(ctx, cx, cy, visualRadius * 1.03, isAnchor);
  ctx.stroke();
  ctx.fillStyle = style.fill;
  traceDot(ctx, cx, cy, visualRadius * 0.70, isAnchor);
  ctx.fill();
  if (radius >= 3.2) {
    ctx.globalAlpha = Math.max(ctx.globalAlpha * 0.72, 0.12);
    ctx.fillStyle = style.glint;
    traceDot(ctx, cx - visualRadius * 0.2, cy - visualRadius * 0.2, Math.max(0.8, visualRadius * 0.15), false);
    ctx.fill();
  }
  ctx.restore();
}
function drawResilientAntiAiDot(ctx, cx, cy, radius, mode, glitchScale, isAnchor) {
  var profile = getAntiAiVisualProfile(mode);
  var strength = Math.max(1, glitchScale || 1);
  var visualRadius = radius * (1.1 + strength * 0.05);
  var inheritedOpacity = ctx.globalAlpha;
  ctx.save();
  ctx.globalCompositeOperation = 'source-over';
  ctx.lineJoin = 'round';
  ctx.lineCap = 'round';
  ctx.globalAlpha = inheritedOpacity * (0.15 + strength * 0.05);
  ctx.fillStyle = isAnchor ? 'rgba(0,0,0,0.5)' : 'rgba(0,0,0,0.3)';
  ctx.beginPath();
  ctx.arc(cx, cy, visualRadius * 1.3, 0, Math.PI * 2);
  ctx.fill();
  ctx.globalAlpha = inheritedOpacity * Math.min(1, profile.probeAlpha + strength * 0.05);
  ctx.fillStyle = toRgba(profile.probes[0], 1);
  ctx.beginPath();
  if (isAnchor) {
    ctx.rect(cx - visualRadius * 0.75, cy - visualRadius * 0.75, visualRadius * 1.5, visualRadius * 1.5);
  } else {
    ctx.arc(cx, cy, visualRadius * 0.85, 0, Math.PI * 2);
  }
  ctx.fill();
  var satellites = profile.shards + Math.floor(strength / 2);
  ctx.globalAlpha = inheritedOpacity;
  for (var i = 1; i <= satellites; i++) {
    var color = profile.probes[i % profile.probes.length];
    ctx.fillStyle = toRgba(color, 0.85);
    var angle = Math.PI * 2 / satellites * i + cx * 0.1;
    var offset = visualRadius * (0.6 + i % 2 * 0.4);
    var px = cx + Math.cos(angle) * offset;
    var py = cy + Math.sin(angle) * offset;
    var particleRadius = visualRadius * (0.35 + strength * 0.04);
    ctx.beginPath();
    ctx.arc(px, py, particleRadius, 0, Math.PI * 2);
    ctx.fill();
  }
  ctx.restore();
}
function getGlyphStyle(mode) {
  var styles = {
    adaptive: {
      fill: 'rgba(8, 38, 105, 0.98)',
      stroke: 'rgba(248, 224, 154, 0.96)',
      glow: 'rgba(255,255,255,0.72)',
      highlight: 'rgba(255,255,255,0.82)'
    },
    pearl: {
      fill: 'rgba(225,230,236,0.92)',
      stroke: 'rgba(58,68,84,0.9)',
      glow: 'rgba(255,255,255,0.54)',
      highlight: 'rgba(255,255,255,0.9)'
    },
    blue: {
      fill: 'rgba(0, 74, 153, 0.98)',
      stroke: 'rgba(143, 220, 255, 0.98)',
      glow: 'rgba(255,255,255,0.58)',
      highlight: 'rgba(235,250,255,0.9)'
    },
    amber: {
      fill: 'rgba(255,198,72,0.94)',
      stroke: 'rgba(36,49,72,0.92)',
      glow: 'rgba(255,255,255,0.58)',
      highlight: 'rgba(255,255,255,0.84)'
    },
    black: {
      fill: 'rgba(0,0,0,0.98)',
      stroke: 'rgba(255,255,255,0.98)',
      glow: 'rgba(255,216,77,0.42)',
      highlight: 'rgba(255,255,255,0.82)'
    },
    cmy: {
      fill: 'rgba(255,0,180,0.82)',
      stroke: 'rgba(255,255,255,0.86)',
      glow: 'rgba(0,210,255,0.38)',
      highlight: 'rgba(255,255,255,0.72)'
    },
    scatter: {
      fill: 'rgba(70,210,255,0.82)',
      stroke: 'rgba(255,255,255,0.86)',
      glow: 'rgba(255,0,200,0.34)',
      highlight: 'rgba(255,255,255,0.68)'
    },
    cluster: {
      fill: 'rgba(30,255,120,0.72)',
      stroke: 'rgba(255,255,255,0.84)',
      glow: 'rgba(30,30,255,0.34)',
      highlight: 'rgba(255,255,255,0.7)'
    }
  };
  return styles[mode] || styles.adaptive;
}
function drawStyledDot(ctx, cx, cy, radius, mode, glitchScale, isAnchor, sampler, canvas, styleCache) {
  if (mode === 'smart') {
    drawSmartAdaptiveDot(ctx, cx, cy, radius, isAnchor, sampler, canvas, styleCache);
    return;
  }
  if (isAntiAiMode(mode)) {
    drawResilientAntiAiDot(ctx, cx, cy, radius, mode, glitchScale, isAnchor);
    return;
  }
  var style = getGlyphStyle(mode);
  var passRadius = mode === 'cluster' ? radius * 0.74 : radius;
  ctx.save();
  if (style.glow) {
    ctx.filter = 'blur(' + Math.max(0.35, radius * 0.18) + 'px)';
    ctx.fillStyle = style.glow;
    traceDot(ctx, cx, cy, passRadius * 1.95, isAnchor);
    ctx.fill();
    ctx.filter = 'none';
  }
  if (style.outerStroke) {
    ctx.fillStyle = style.outerStroke;
    traceDot(ctx, cx, cy, passRadius * 1.88, isAnchor);
    ctx.fill();
  }
  ctx.fillStyle = style.stroke;
  traceDot(ctx, cx, cy, passRadius * 1.42, isAnchor);
  ctx.fill();
  ctx.fillStyle = style.fill;
  traceDot(ctx, cx, cy, passRadius, isAnchor);
  ctx.fill();
  ctx.fillStyle = style.highlight;
  traceDot(ctx, cx - passRadius * 0.22, cy - passRadius * 0.22, Math.max(1, passRadius * 0.28), false);
  ctx.fill();
  ctx.restore();
}
function drawGridGlyph(ctx, points, x, y, metrics, mode, glitchScale, isAnchor, sampler, canvas, styleCache) {
  for (var i = 0; i < points.length; i++) {
    var index = points[i];
    var col = index % 3;
    var row = Math.floor(index / 3);
    var cx = x + metrics.dotRadius + col * metrics.gridStep;
    var cy = y + metrics.dotRadius + row * metrics.gridStep;
    drawStyledDot(ctx, cx, cy, metrics.dotRadius, mode, glitchScale, isAnchor, sampler, canvas, styleCache);
  }
}
function createPayloadBlock(text, mode, cellRatio, glitchScale, densityUi, aiGuard, scatterUi, canvas) {
  var payloadText = (text || '00000000').slice(0, 8);
  var rawDensityFactor = (densityUi - 1) / 39;
  var densityFactor = Math.min(1, Math.max(0, rawDensityFactor));
  var metrics = getVectorMetrics(cellRatio, densityFactor, payloadText.length, canvas);
  var blockCanvas = document.createElement('canvas');
  blockCanvas.width = Math.ceil(metrics.blockWidth);
  blockCanvas.height = Math.ceil(metrics.blockHeight);
  blockCanvas.tileStepX = metrics.tileStepX;
  blockCanvas.tileStepY = metrics.tileStepY;
  blockCanvas.tileCols = metrics.tileCols;
  blockCanvas.tileRows = metrics.tileRows;
  blockCanvas.rowOffsetRatio = metrics.rowOffsetRatio;
  blockCanvas.densityFactor = densityFactor;
  blockCanvas.overflowAllowanceX = metrics.overflowAllowanceX;
  blockCanvas.overflowAllowanceY = metrics.overflowAllowanceY;
  blockCanvas.adaptiveRender = mode === 'smart';
  blockCanvas.metrics = metrics;
  blockCanvas.payloadText = payloadText;
  blockCanvas.mode = mode;
  blockCanvas.glitchScale = glitchScale;
  blockCanvas.aiGuard = aiGuard;
  blockCanvas.payloadSeed = getPayloadSeed(payloadText);
  blockCanvas.scatterFactor = Math.min(1, Math.max(0, (scatterUi || 0) / 10));
  blockCanvas.gridStats = {
    cellSize: metrics.cellSize,
    minCellSize: metrics.minCellSize,
    cellRatio: metrics.cellRatio,
    cols: metrics.tileCols,
    rows: metrics.tileRows,
    targetGroups: metrics.targetGroups,
    maxGroups: metrics.maxGroups,
    overflowCellsX: metrics.overflowCellsX,
    overflowCellsY: metrics.overflowCellsY,
    scatterFactor: blockCanvas.scatterFactor
  };
  if (blockCanvas.adaptiveRender) return blockCanvas;
  var bCtx = blockCanvas.getContext('2d');
  var glyphY = metrics.cellPadding;
  drawGridGlyph(bCtx, SYNC_CODE, metrics.cellPadding, glyphY, metrics, mode, glitchScale, false, null, canvas, null);
  for (var i = 0; i < payloadText.length; i++) {
    var glyphX = (i + 1) * metrics.cellSize + metrics.cellPadding;
    var code = GRID_CODE_MAP[payloadText[i]] || GRID_CODE_MAP['0'];
    drawGridGlyph(bCtx, code, glyphX, glyphY, metrics, mode, glitchScale, false, null, canvas, null);
  }
  return blockCanvas;
}
function prepareAdaptiveBackgroundSampler(canvas, baseImage) {
  if (!canvas || !canvas.width || !canvas.height) return null;
  var maxSamplerSide = 256;
  var sampleRatio = Math.min(1, maxSamplerSide / Math.max(canvas.width, canvas.height));
  var sampleWidth = Math.max(16, Math.round(canvas.width * sampleRatio));
  var sampleHeight = Math.max(16, Math.round(canvas.height * sampleRatio));
  var sampleCanvas = document.createElement('canvas');
  sampleCanvas.width = sampleWidth;
  sampleCanvas.height = sampleHeight;
  var sampleCtx = sampleCanvas.getContext('2d', {
    willReadFrequently: true
  });
  sampleCtx.imageSmoothingEnabled = true;
  if (baseImage) {
    sampleCtx.drawImage(baseImage, 0, 0, sampleWidth, sampleHeight);
  } else {
    sampleCtx.drawImage(canvas, 0, 0, sampleWidth, sampleHeight);
  }
  return {
    width: sampleWidth,
    height: sampleHeight,
    data: sampleCtx.getImageData(0, 0, sampleWidth, sampleHeight).data
  };
}
function rectanglesOverlap(a, b) {
  return !(a.x + a.width <= b.x || b.x + b.width <= a.x || a.y + a.height <= b.y || b.y + b.height <= a.y);
}
function getRectBucketRange(rect, bucketSize) {
  return {
    minX: Math.floor(rect.x / bucketSize),
    maxX: Math.floor((rect.x + rect.width) / bucketSize),
    minY: Math.floor(rect.y / bucketSize),
    maxY: Math.floor((rect.y + rect.height) / bucketSize)
  };
}
function storeRectInBuckets(rect, buckets, bucketSize) {
  var range = getRectBucketRange(rect, bucketSize);
  for (var y = range.minY; y <= range.maxY; y++) {
    for (var x = range.minX; x <= range.maxX; x++) {
      var key = x + ',' + y;
      if (!buckets.has(key)) buckets.set(key, []);
      buckets.get(key).push(rect);
    }
  }
}
function hasRectCollision(rect, buckets, bucketSize) {
  var range = getRectBucketRange(rect, bucketSize);
  for (var y = range.minY; y <= range.maxY; y++) {
    for (var x = range.minX; x <= range.maxX; x++) {
      var bucket = buckets.get(x + ',' + y);
      if (!bucket) continue;
      for (var i = 0; i < bucket.length; i++) {
        if (rectanglesOverlap(rect, bucket[i])) return true;
      }
    }
  }
  return false;
}
function selectNonOverlappingCandidates(candidates, targetCount, blockCanvas, frame, relax) {
  var selected = [];
  var padX = frame.padX * relax;
  var padY = frame.padY * relax;
  var width = blockCanvas.width + padX * 2;
  var height = blockCanvas.height + padY * 2;
  var buckets = new Map();
  var bucketSize = Math.max(1, width, height);
  for (var i = 0; i < candidates.length; i++) {
    var candidate = candidates[i];
    var rect = {
      x: candidate.x - padX,
      y: candidate.y - padY,
      width: width,
      height: height
    };
    if (hasRectCollision(rect, buckets, bucketSize)) continue;
    storeRectInBuckets(rect, buckets, bucketSize);
    selected.push({
      x: candidate.x,
      y: candidate.y
    });
    if (selected.length >= targetCount) break;
  }
  return selected;
}
function mergePoissonCandidates(randomCandidates, slotCandidates, seed, relax, randomMix) {
  var randomPenalty = (1 - randomMix) * 1.35;
  var slotPenalty = randomMix * 0.18;
  var random = [];
  for (var i = 0; i < randomCandidates.length; i++) {
    random.push({
      x: randomCandidates[i].x,
      y: randomCandidates[i].y,
      rank: randomCandidates[i].rank + randomPenalty + seededNoise(i, Math.round(relax * 1000), seed, 857) * 0.015
    });
  }
  var slots = [];
  for (var j = 0; j < slotCandidates.length; j++) {
    slots.push({
      x: slotCandidates[j].x,
      y: slotCandidates[j].y,
      rank: slotCandidates[j].rank + slotPenalty + seededNoise(j, Math.round(relax * 1000), seed, 859) * 0.015
    });
  }
  var merged = random.concat(slots);
  merged.sort(function (a, b) {
    return a.rank - b.rank;
  });
  return merged;
}
function buildPackedPoissonCandidates(bounds, targetCount, blockCanvas, frame, relax, seed, scatter) {
  var padX = frame.padX * relax;
  var padY = frame.padY * relax;
  var pitchX = Math.max(1, blockCanvas.width + padX * 2);
  var pitchY = Math.max(1, blockCanvas.height + padY * 2);
  var spanX = Math.max(0, bounds.maxX - bounds.minX);
  var spanY = Math.max(0, bounds.maxY - bounds.minY);
  var cols = Math.max(1, Math.ceil(spanX / pitchX) + 1);
  var rows = Math.max(1, Math.ceil(spanY / pitchY) + 1);
  var total = cols * rows;
  var candidates = [];
  var jitterX = Math.min(padX * 0.48, pitchX * 0.18) * scatter;
  var jitterY = Math.min(padY * 0.48, pitchY * 0.18) * scatter;
  var startX = bounds.minX + Math.max(0, spanX - (cols - 1) * pitchX) / 2;
  var startY = bounds.minY + Math.max(0, spanY - (rows - 1) * pitchY) / 2;
  for (var row = 0; row < rows; row++) {
    for (var col = 0; col < cols; col++) {
      var waveX = (row % 2 - 0.5) * jitterX * 0.42;
      var noiseX = seededNoise(row, col, seed, 811) * 2 - 1;
      var noiseY = seededNoise(row, col, seed, 823) * 2 - 1;
      var x = clamp(startX + col * pitchX + waveX + noiseX * jitterX, bounds.minX, bounds.maxX);
      var y = clamp(startY + row * pitchY + noiseY * jitterY, bounds.minY, bounds.maxY);
      var rank = seededNoise(row, col, seed, 839) + Math.abs((row + col) / Math.max(1, total) - 0.5) * 0.08;
      candidates.push({
        x: x,
        y: y,
        rank: rank
      });
    }
  }
  return candidates;
}
function buildPoissonCandidates(bounds, targetCount, seed) {
  var width = Math.max(1, bounds.maxX - bounds.minX);
  var height = Math.max(1, bounds.maxY - bounds.minY);
  var candidateTarget = Math.min(4200, Math.max(targetCount * 48, 260));
  var aspect = width / Math.max(1, height);
  var strataCols = Math.max(1, Math.ceil(Math.sqrt(candidateTarget * aspect)));
  var strataRows = Math.max(1, Math.ceil(candidateTarget / strataCols));
  var candidates = [];
  var index = 0;
  for (var row = 0; row < strataRows; row++) {
    for (var col = 0; col < strataCols; col++) {
      var jx = seededNoise(row, col, seed, 401);
      var jy = seededNoise(row, col, seed, 503);
      var x = bounds.minX + (col + jx) / strataCols * width;
      var y = bounds.minY + (row + jy) / strataRows * height;
      var rank = seededNoise(index, targetCount, seed, 607);
      candidates.push({
        x: x,
        y: y,
        rank: rank
      });
      index++;
    }
  }
  candidates.sort(function (a, b) {
    return a.rank - b.rank;
  });
  return candidates;
}
function getPoissonOuterFrame(blockCanvas, scatter) {
  var metrics = blockCanvas.metrics || {};
  var cellSize = metrics.cellSize || Math.max(1, blockCanvas.height);
  var densityFactor = blockCanvas.densityFactor || 0;
  var sizeFactor = metrics.cellRatio ? clamp((metrics.cellRatio - 0.026) / 0.048, 0, 1) : 0.5;
  var marginCellsX = clamp(1.28 - densityFactor * 0.92 - sizeFactor * 0.3 - scatter * 0.1, 0.08, 1.35);
  var marginCellsY = clamp(0.92 - densityFactor * 0.68 - sizeFactor * 0.24 - scatter * 0.08, 0.06, 0.98);
  return {
    padX: cellSize * marginCellsX,
    padY: cellSize * marginCellsY
  };
}
function generatePoissonWatermarkPositions(blockCanvas, targetCount, stepX, stepY, scatter, randomMix, canvas) {
  var seed = blockCanvas.payloadSeed || 1;
  var minX = -(blockCanvas.overflowAllowanceX || 0);
  var maxX = canvas.width - blockCanvas.width + (blockCanvas.overflowAllowanceX || 0);
  var minY = 0;
  var maxY = Math.max(0, canvas.height - blockCanvas.height);
  if (maxX < minX) {
    var centerX = (minX + maxX) / 2;
    minX = centerX;
    maxX = centerX;
  }
  if (maxY < minY) {
    var centerY = (minY + maxY) / 2;
    minY = centerY;
    maxY = centerY;
  }
  var bounds = {
    minX: minX,
    maxX: maxX,
    minY: minY,
    maxY: maxY
  };
  var frame = getPoissonOuterFrame(blockCanvas, scatter);
  var randomCandidates = buildPoissonCandidates(bounds, targetCount, seed);
  var relaxSteps = [1, 0.72, 0.5, 0.32, 0.16, 0];
  var best = [];
  for (var s = 0; s < relaxSteps.length; s++) {
    var relax = relaxSteps[s];
    var slotCandidates = buildPackedPoissonCandidates(bounds, targetCount, blockCanvas, frame, relax, seed, scatter);
    var candidates = mergePoissonCandidates(randomCandidates, slotCandidates, seed, relax, randomMix);
    var points = selectNonOverlappingCandidates(candidates, targetCount, blockCanvas, frame, relax);
    if (points.length > best.length) best = points;
    if (points.length >= targetCount) return points;
  }
  return best;
}
function enforceNonOverlappingBodyPositions(positions, blockCanvas) {
  var safe = [];
  var buckets = new Map();
  var bucketSize = Math.max(1, blockCanvas.width, blockCanvas.height);
  for (var i = 0; i < positions.length; i++) {
    var point = positions[i];
    var rect = {
      x: point.x,
      y: point.y,
      width: blockCanvas.width,
      height: blockCanvas.height
    };
    if (hasRectCollision(rect, buckets, bucketSize)) continue;
    storeRectInBuckets(rect, buckets, bucketSize);
    safe.push(point);
  }
  return safe;
}
function buildGuaranteedSlotPositions(blockCanvas, positionsX, positionsY, scatter, canvas) {
  var points = [];
  var minX = -(blockCanvas.overflowAllowanceX || 0);
  var maxX = canvas.width - blockCanvas.width + (blockCanvas.overflowAllowanceX || 0);
  var minY = 0;
  var maxY = Math.max(0, canvas.height - blockCanvas.height);
  var seed = blockCanvas.payloadSeed || 1;
  for (var row = 0; row < positionsY.length; row++) {
    for (var col = 0; col < positionsX.length; col++) {
      var baseX = positionsX[col];
      var baseY = positionsY[row];
      var leftGap = col > 0 ? baseX - (positionsX[col - 1] + blockCanvas.width) : baseX - minX;
      var rightGap = col < positionsX.length - 1 ? positionsX[col + 1] - (baseX + blockCanvas.width) : maxX - baseX;
      var topGap = row > 0 ? baseY - (positionsY[row - 1] + blockCanvas.height) : baseY - minY;
      var bottomGap = row < positionsY.length - 1 ? positionsY[row + 1] - (baseY + blockCanvas.height) : maxY - baseY;
      var jitterX = Math.max(0, Math.min(leftGap, rightGap) * 0.48) * scatter;
      var jitterY = Math.max(0, Math.min(topGap, bottomGap) * 0.48) * scatter;
      var noiseX = seededNoise(row, col, seed, 881) * 2 - 1;
      var noiseY = seededNoise(row, col, seed, 883) * 2 - 1;
      points.push({
        x: clamp(baseX + noiseX * jitterX, minX, maxX),
        y: clamp(baseY + noiseY * jitterY, minY, maxY)
      });
    }
  }
  return enforceNonOverlappingBodyPositions(points, blockCanvas);
}
function blendNonOverlappingPlacementPositions(basePoints, randomPoints, mix, blockCanvas) {
  var count = Math.min(basePoints.length, randomPoints.length);
  var base = basePoints.slice().sort(function (a, b) {
    return a.y - b.y || a.x - b.x;
  }).slice(0, count);
  var remainingRandom = randomPoints.slice();
  var random = [];
  for (var i = 0; i < base.length; i++) {
    var point = base[i];
    var bestIndex = 0;
    var bestDistance = Infinity;
    for (var j = 0; j < remainingRandom.length; j++) {
      var distance = Math.hypot(remainingRandom[j].x - point.x, remainingRandom[j].y - point.y);
      if (distance < bestDistance) {
        bestDistance = distance;
        bestIndex = j;
      }
    }
    random.push(remainingRandom.splice(bestIndex, 1)[0]);
  }
  var selected = [];
  var buckets = new Map();
  var bucketSize = Math.max(1, blockCanvas.width, blockCanvas.height);
  for (var k = 0; k < count; k++) {
    var blended = {
      x: base[k].x + (random[k].x - base[k].x) * mix,
      y: base[k].y + (random[k].y - base[k].y) * mix
    };
    var fallbacks = mix < 0.5 ? [blended, base[k], random[k]] : [blended, random[k], base[k]];
    for (var f = 0; f < fallbacks.length; f++) {
      var fbPoint = fallbacks[f];
      var rect = {
        x: fbPoint.x,
        y: fbPoint.y,
        width: blockCanvas.width,
        height: blockCanvas.height
      };
      if (hasRectCollision(rect, buckets, bucketSize)) continue;
      storeRectInBuckets(rect, buckets, bucketSize);
      selected.push({
        x: fbPoint.x,
        y: fbPoint.y
      });
      break;
    }
  }
  return selected;
}
function getWatermarkPlacementPositions(blockCanvas, positionsX, positionsY, cols, rows, stepX, stepY, canvas) {
  var scatter = blockCanvas.scatterFactor || 0;
  if (scatter <= 0.05) {
    var gridPoints = [];
    for (var row = 0; row < positionsY.length; row++) {
      var offsetRatio = blockCanvas.rowOffsetRatio != null ? blockCanvas.rowOffsetRatio : 0;
      var rowShift = offsetRatio > 0 && cols > 1 && row % 2 === 1 ? Math.min(stepX * offsetRatio, blockCanvas.width * 0.08) : 0;
      for (var col = 0; col < positionsX.length; col++) {
        var baseX = positionsX[col] + rowShift;
        var baseY = positionsY[row];
        gridPoints.push({
          x: baseX,
          y: baseY
        });
      }
    }
    return gridPoints;
  }
  var scatterCurve = getPerceptualScatter(scatter);
  if (scatter <= 0.5) {
    return buildGuaranteedSlotPositions(blockCanvas, positionsX, positionsY, scatterCurve, canvas);
  }
  var targetCount = Math.max(1, cols * rows);
  var highBand = Math.min(1, Math.max(0, (scatter - 0.5) / 0.5));
  var randomMix = highBand * highBand * (3 - 2 * highBand);
  var guaranteedPoints = buildGuaranteedSlotPositions(blockCanvas, positionsX, positionsY, scatterCurve, canvas);
  var poissonPoints = generatePoissonWatermarkPositions(blockCanvas, targetCount, stepX, stepY, scatterCurve, randomMix, canvas);
  if (poissonPoints.length >= targetCount && guaranteedPoints.length >= targetCount) {
    return blendNonOverlappingPlacementPositions(guaranteedPoints, poissonPoints, randomMix, blockCanvas);
  }
  if (poissonPoints.length >= targetCount) return poissonPoints;
  return guaranteedPoints.length >= poissonPoints.length ? guaranteedPoints : poissonPoints;
}
function drawAiGuardRows(ctx, blockCanvas, canvas) {
  var REFERENCE_VIEWPORT_WIDTH = 2560;
  var REFERENCE_VIEWPORT_HEIGHT = 1440;
  var scale = Math.min(REFERENCE_VIEWPORT_WIDTH / Math.max(1, canvas.width), REFERENCE_VIEWPORT_HEIGHT / Math.max(1, canvas.height));
  var refWidth = Math.max(1, Math.round(canvas.width * scale));
  var refHeight = Math.max(1, Math.round(canvas.height * scale));
  var shortSide = Math.max(1, Math.min(refWidth, refHeight));
  var fontSize = Math.max(16, Math.min(24, shortSide * 0.032));
  var texts = ['COPYRIGHT WATERMARK - DO NOT REMOVE', 'PROTECTED MATERIAL - VIEW ONLY', 'RIGHTS NOTICE - DO NOT REMOVE'];
  var fontFamily = 'Arial, Helvetica, sans-serif';
  var expand = Math.max(canvas.width, canvas.height) * 1.8;
  ctx.save();
  ctx.globalAlpha = 1;
  ctx.font = '400 ' + fontSize + 'px ' + fontFamily;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillStyle = 'rgba(210, 210, 218, 0.34)';
  ctx.translate(canvas.width / 2, canvas.height / 2);
  ctx.rotate(-45 * Math.PI / 180);
  var maxTextWidth = 0;
  for (var ti = 0; ti < texts.length; ti++) {
    var w = ctx.measureText(texts[ti]).width;
    if (w > maxTextWidth) maxTextWidth = w;
  }
  var stepX = Math.max(fontSize * 20, maxTextWidth + fontSize * 4.2);
  var stepY = fontSize * 5.4;
  var rowIndex = 0;
  for (var y = -expand; y <= expand; y += stepY) {
    var rowOffset = rowIndex % 2 === 0 ? 0 : stepX / 2;
    var columnIndex = 0;
    for (var x = -expand; x <= expand; x += stepX) {
      var text = texts[Math.abs(rowIndex + columnIndex) % texts.length];
      ctx.fillText(text, x + rowOffset, y);
      columnIndex++;
    }
    rowIndex++;
  }
  ctx.restore();
}
function drawPayloadAt(ctx, blockCanvas, x, y, canvas, sampler, styleCache) {
  if (x > canvas.width || y > canvas.height || x + blockCanvas.width < 0 || y + blockCanvas.height < 0) return;
  if (blockCanvas.adaptiveRender) {
    var metrics = blockCanvas.metrics;
    var glyphY = y + metrics.cellPadding;
    drawGridGlyph(ctx, SYNC_CODE, x + metrics.cellPadding, glyphY, metrics, blockCanvas.mode, blockCanvas.glitchScale, false, sampler, canvas, styleCache);
    for (var j = 0; j < blockCanvas.payloadText.length; j++) {
      var glyphX = x + (j + 1) * metrics.cellSize + metrics.cellPadding;
      var code = GRID_CODE_MAP[blockCanvas.payloadText[j]] || GRID_CODE_MAP['0'];
      drawGridGlyph(ctx, code, glyphX, glyphY, metrics, blockCanvas.mode, blockCanvas.glitchScale, false, sampler, canvas, styleCache);
    }
  } else {
    ctx.drawImage(blockCanvas, x, y);
  }
}
function drawVectorWatermarkDistribution(ctx, blockCanvas, canvas, sampler, styleCache) {
  var stepX = Math.max(blockCanvas.width + 1, blockCanvas.tileStepX || blockCanvas.width);
  var stepY = Math.max(blockCanvas.height + 1, blockCanvas.tileStepY || blockCanvas.height);
  var densityFactor = blockCanvas.densityFactor || 0;
  var cols = blockCanvas.tileCols || getWatermarkTileCount(canvas.width, blockCanvas.width, stepX, densityFactor);
  var rows = blockCanvas.tileRows || getWatermarkTileCount(canvas.height, blockCanvas.height, stepY, densityFactor);
  var overflowX = blockCanvas.overflowAllowanceX || 0;
  var overflowY = blockCanvas.overflowAllowanceY || 0;
  var positionsX = getUniformAxisPositions(canvas.width, blockCanvas.width, stepX, overflowX, cols);
  var positionsY = getUniformAxisPositions(canvas.height, blockCanvas.height, stepY, overflowY, rows);
  var positions = enforceNonOverlappingBodyPositions(getWatermarkPlacementPositions(blockCanvas, positionsX, positionsY, cols, rows, stepX, stepY, canvas), blockCanvas);
  for (var i = 0; i < positions.length; i++) {
    drawPayloadAt(ctx, blockCanvas, positions[i].x, positions[i].y, canvas, sampler, styleCache);
  }
  blockCanvas.placementStats = {
    targetGroups: Math.max(1, cols * rows),
    actualGroups: positions.length
  };
  if (blockCanvas.aiGuard) {
    drawAiGuardRows(ctx, blockCanvas, canvas);
  }
  return blockCanvas;
}
function drawDotmatrixWatermark(ctx, canvas, watermarkInfo) {
  var payload = (watermarkInfo.dotmatrixPayload || '00000000').slice(0, 8);
  var engineMode = watermarkInfo.dotmatrixEngineMode || 'smart';
  var densityUi = watermarkInfo.dotmatrixDensity != null ? watermarkInfo.dotmatrixDensity : 22;
  var scaleUi = watermarkInfo.dotmatrixScale != null ? watermarkInfo.dotmatrixScale : 5;
  var scatterUi = watermarkInfo.dotmatrixScatter != null ? watermarkInfo.dotmatrixScatter : 2;
  var glitchUi = watermarkInfo.dotmatrixGlitch != null ? watermarkInfo.dotmatrixGlitch : 5;
  var aiGuard = watermarkInfo.dotmatrixAiGuard != null ? watermarkInfo.dotmatrixAiGuard : true;
  var opacity = watermarkInfo.transparent != null ? watermarkInfo.transparent : 30;
  var cellRatio = getVectorCellRatio(scaleUi);
  var sampler = watermarkInfo._adaptiveSampler || null;
  var styleCache = watermarkInfo._adaptiveStyleCache || new Map();
  if ((engineMode === 'smart' || isAntiAiMode(engineMode)) && !sampler) {
    sampler = prepareAdaptiveBackgroundSampler(canvas, null);
  }
  var blockCanvas = createPayloadBlock(payload, engineMode, cellRatio, glitchUi, densityUi, aiGuard, scatterUi, canvas);
  ctx.save();
  ctx.globalAlpha = opacity / 100;
  drawVectorWatermarkDistribution(ctx, blockCanvas, canvas, sampler, styleCache);
  ctx.restore();
}
function getTestWatermarkInfo() {
  return {
    "isNeedWatermark": true,
    "watermarkType": 7,
    "watermarkScope": 0,
    "positionType": 0,
    "transparent": 99,
    "color": null,
    "fontSizeType": 0,
    "dotmatrixPayload": "7C52DAAF",
    "dotmatrixEngineMode": "cluster",
    "dotmatrixAiGuard": true,
    "dotmatrixDensity": 22,
    "dotmatrixScale": 10,
    "dotmatrixScatter": 2,
    "dotmatrixGlitch": 5,
    "dotmatrixAntiAi": true
  };
}
function drawWaterMark(ctx, canvas, editor) {
  if (!(editor && editor.board && editor.board.fileInfo)) {
    return;
  }
  var fileInfo = editor.board.fileInfo;
  var watermarkInfo = fileInfo.get("watermarkInfo");
  _drawWaterMark(ctx, canvas, watermarkInfo);
}
function _drawWaterMark(ctx, canvas, watermarkInfo) {
  // watermarkInfo = getTestWatermarkInfo();
  if (watermarkInfo.dotMatrixInfo) {
    var dm = watermarkInfo.dotMatrixInfo;
    watermarkInfo.dotmatrixPayload = dm.dotmatrixPayload || watermarkInfo.dotmatrixPayload;
    watermarkInfo.dotmatrixEngineMode = dm.dotmatrixEngineMode || watermarkInfo.dotmatrixEngineMode;
    watermarkInfo.dotmatrixDensity = dm.dotmatrixDensity != null ? dm.dotmatrixDensity : watermarkInfo.dotmatrixDensity;
    watermarkInfo.dotmatrixScale = dm.dotmatrixScale != null ? dm.dotmatrixScale : watermarkInfo.dotmatrixScale;
    watermarkInfo.dotmatrixScatter = dm.dotmatrixScatter != null ? dm.dotmatrixScatter : watermarkInfo.dotmatrixScatter;
    watermarkInfo.dotmatrixGlitch = dm.dotmatrixGlitch != null ? dm.dotmatrixGlitch : watermarkInfo.dotmatrixGlitch;
    watermarkInfo.dotmatrixAiGuard = dm.dotmatrixAiGuard != null ? dm.dotmatrixAiGuard == 1 ? true : false : watermarkInfo.dotmatrixAiGuard;
    watermarkInfo.dotmatrixAntiAi = dm.dotmatrixAntiAi != null ? dm.dotmatrixAntiAi == 1 ? true : false : watermarkInfo.dotmatrixAntiAi;
  }
  if (watermarkInfo.isNeedWatermark) {
    switch (watermarkInfo.watermarkType) {
      case 1:
        if (!/--\d{2}-\d{2}-\d{2}$/.test(watermarkInfo.watermarkWord || '')) {
          watermarkInfo.watermarkWord = watermarkInfo.watermarkWord + "--" + new Date().format("yy-MM-dd");
        }
        drawWordWaterMark(ctx, canvas, watermarkInfo);
        break;
      case 2:
        drawimgWaterMark(ctx, canvas, watermarkInfo);
        break;
      case 3:
        if (watermarkInfo.watermarkWord) {
          drawWordWaterMark(ctx, canvas, watermarkInfo);
        } else {
          var userId = app.currentUser.getUserId();
          if (userId == 0) {
            if (!/--\d{2}-\d{2}-\d{2}$/.test(watermarkInfo.watermarkWord || '')) {
              watermarkInfo.watermarkWord = watermarkInfo.watermarkWord + "--" + new Date().format("yy-MM-dd");
            }
            drawWordWaterMark(ctx, canvas, watermarkInfo);
          } else {
            var str = app.currentUser.getWatermarkAccount();
            if (str || app.pathRouter.sharerName) {
              str = str.length ? str : BabelStr.str(194, {
                user: app.pathRouter.sharerName
              });
              if (!/--\d{2}-\d{2}-\d{2}$/.test(str)) {
                str = str + "--" + new Date().format("yy-MM-dd");
              }
              watermarkInfo.watermarkWord = str;
              drawWordWaterMark(ctx, canvas, watermarkInfo);
            } else {
              MMNetDiskDataController.getFileInfoFromServer(app.pathRouter.rootFileId, function (fileInfo) {
                var str = BabelStr.str(194, {
                  user: fileInfo.getSharerName()
                });
                if (!/--\d{2}-\d{2}-\d{2}$/.test(str)) {
                  str = str + "--" + new Date().format("yy-MM-dd");
                }
                watermarkInfo.watermarkWord = str;
                drawWordWaterMark(ctx, canvas, watermarkInfo);
              }, function () {});
            }
          }
        }
        break;
      case 7:
        drawDotmatrixWatermark(ctx, canvas, watermarkInfo);
        break;
    }
  }
}
function drawWordWaterMark(ctx, canvas, watermarkInfo) {
  // watermarkInfo = getTestWatermarkInfo();
  var text = watermarkInfo.watermarkWord || watermarkInfo.wordWaterMark || '';
  if (!text) return;
  var scaleUi = watermarkInfo.dotmatrixScale || 5;
  var densityUi = watermarkInfo.dotmatrixDensity || 22;
  var effScale = 0.6 + (scaleUi - 1) * (7.4 / 19);
  var effDensity = 7 + (densityUi - 1) * (43 / 39);
  var transparent = watermarkInfo.transparent != null ? watermarkInfo.transparent / 100 : 0.30;
  var fontSize;
  if (watermarkInfo.wordFontSizeCss) {
    // 固定 CSS 像素字号（全局水印）, 按画布物理像素与视口宽度的比值换算
    var cssScale = canvas.width / Math.max(1, window.innerWidth || canvas.width);
    fontSize = watermarkInfo.wordFontSizeCss * cssScale;
  } else {
    var ratio = canvas.width / 800;
    fontSize = Math.max(12, 18 * ratio);
  }
  var color = watermarkInfo.color || '#FD18F8';
  var positionType = watermarkInfo.positionType || 0;
  ctx.save();
  ctx.globalAlpha = transparent;
  ctx.font = fontSize + 'px sans-serif';
  ctx.fillStyle = color;
  ctx.strokeStyle = 'rgba(255,255,255,0.6)';
  ctx.lineWidth = 1;
  var lines = text.indexOf('--') >= 0 ? text.split('--') : [text];
  if (lines.length === 1 && text.indexOf(' ') >= 0) {
    lines = text.split(' ');
  }
  var maxTextWidth = 0;
  for (var li = 0; li < lines.length; li++) {
    var w = ctx.measureText(lines[li]).width;
    if (w > maxTextWidth) maxTextWidth = w;
  }
  var lineHeight = fontSize * 1.3;
  var itemWidth = maxTextWidth;
  var itemHeight = lines.length * lineHeight;
  var gapX = Math.max(10, canvas.width / (effDensity * 0.4));
  var gapY = Math.max(10, canvas.height / (effDensity * 0.4));
  var spacingX = itemWidth + gapX;
  var spacingY = itemHeight + gapY;
  if (positionType === 2) {
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    var startY = (canvas.height - (lines.length - 1) * lineHeight) / 2;
    for (var i = 0; i < lines.length; i++) {
      ctx.fillText(lines[i], canvas.width / 2, startY + i * lineHeight);
      if (watermarkInfo.needStroke) {
        ctx.strokeText(lines[i], canvas.width / 2, startY + i * lineHeight);
      }
    }
  } else if (positionType === 1) {
    ctx.translate(canvas.width / 2, canvas.height / 2);
    var expand2 = Math.max(canvas.width, canvas.height) * 2;
    var rowIdx2 = 0;
    for (var y2 = -expand2; y2 <= expand2; y2 += spacingY) {
      var shiftX2 = rowIdx2 % 2 === 0 ? 0 : spacingX / 2;
      for (var x2 = -expand2; x2 <= expand2; x2 += spacingX) {
        var drawX2 = x2 + shiftX2;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        var sY2 = y2 - (lines.length - 1) * lineHeight / 2;
        for (var k2 = 0; k2 < lines.length; k2++) {
          ctx.fillText(lines[k2], drawX2, sY2 + k2 * lineHeight);
          if (watermarkInfo.needStroke) {
            ctx.strokeText(lines[k2], drawX2, sY2 + k2 * lineHeight);
          }
        }
      }
      rowIdx2++;
    }
  } else {
    ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.rotate(-45 * Math.PI / 180);
    var expand = Math.max(canvas.width, canvas.height) * 2;
    var rowIdx = 0;
    for (var y = -expand; y <= expand; y += spacingY) {
      var shiftX = rowIdx % 2 === 0 ? 0 : spacingX / 2;
      for (var x = -expand; x <= expand; x += spacingX) {
        var drawX = x + shiftX;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        var sY = y - (lines.length - 1) * lineHeight / 2;
        for (var k = 0; k < lines.length; k++) {
          ctx.fillText(lines[k], drawX, sY + k * lineHeight);
          if (watermarkInfo.needStroke) {
            ctx.strokeText(lines[k], drawX, sY + k * lineHeight);
          }
        }
      }
      rowIdx++;
    }
  }
  ctx.restore();
}
function drawimgWaterMark(ctx, canvas, watermarkInfo) {
  // watermarkInfo = getTestWatermarkInfo();
  var url = watermarkInfo.url || watermarkInfo.imageWaterMark;
  if (!url) return;
  var scaleUi = watermarkInfo.dotmatrixScale || 5;
  var densityUi = watermarkInfo.dotmatrixDensity || 22;
  var effScale = 0.6 + (scaleUi - 1) * (7.4 / 19);
  var effDensity = 7 + (densityUi - 1) * (43 / 39);
  var transparent = watermarkInfo.transparent != null ? watermarkInfo.transparent / 100 : 0.30;
  var positionType = watermarkInfo.positionType || 0;
  var ratio = canvas.width / 800;
  function drawImg(img) {
    var imgW = Math.max(1, img.width * effScale * 0.2 * ratio);
    var imgH = Math.max(1, img.height * effScale * 0.2 * ratio);
    var gapX = Math.max(10, canvas.width / (effDensity * 0.4));
    var gapY = Math.max(10, canvas.height / (effDensity * 0.4));
    var spacingX = imgW + gapX;
    var spacingY = imgH + gapY;
    ctx.save();
    ctx.globalAlpha = transparent;
    if (positionType === 2) {
      ctx.drawImage(img, (canvas.width - imgW) / 2, (canvas.height - imgH) / 2, imgW, imgH);
    } else if (positionType === 1) {
      ctx.translate(canvas.width / 2, canvas.height / 2);
      var expand2 = Math.max(canvas.width, canvas.height) * 2;
      var rowIdx2 = 0;
      for (var y2 = -expand2; y2 <= expand2; y2 += spacingY) {
        var shiftX2 = rowIdx2 % 2 === 0 ? 0 : spacingX / 2;
        for (var x2 = -expand2; x2 <= expand2; x2 += spacingX) {
          ctx.drawImage(img, x2 + shiftX2 - imgW / 2, y2 - imgH / 2, imgW, imgH);
        }
        rowIdx2++;
      }
    } else {
      ctx.translate(canvas.width / 2, canvas.height / 2);
      ctx.rotate(-45 * Math.PI / 180);
      var expand = Math.max(canvas.width, canvas.height) * 2;
      var rowIdx = 0;
      for (var y = -expand; y <= expand; y += spacingY) {
        var shiftX = rowIdx % 2 === 0 ? 0 : spacingX / 2;
        for (var x = -expand; x <= expand; x += spacingX) {
          ctx.drawImage(img, x + shiftX - imgW / 2, y - imgH / 2, imgW, imgH);
        }
        rowIdx++;
      }
    }
    ctx.restore();
  }
  var cached = _imgWatermarkCache.get(url);
  if (cached && cached.complete && cached.naturalWidth > 0) {
    drawImg(cached);
    return;
  }
  var img = new Image();
  img.crossOrigin = "Anonymous";
  img.onload = function () {
    _imgWatermarkCache.set(url, img);
    drawImg(img);
  };
  img.src = url;
}
var MEWaterMarkRenderer = {
  GRID_CODE_MAP: GRID_CODE_MAP,
  SYNC_CODE: SYNC_CODE,
  getPayloadSeed: getPayloadSeed,
  isAntiAiMode: isAntiAiMode,
  clamp: clamp,
  seededNoise: seededNoise,
  getPerceptualScatter: getPerceptualScatter,
  getUniformAxisPositions: getUniformAxisPositions,
  getWatermarkTileCount: getWatermarkTileCount,
  rectanglesOverlap: rectanglesOverlap,
  getRectBucketRange: getRectBucketRange,
  storeRectInBuckets: storeRectInBuckets,
  hasRectCollision: hasRectCollision,
  selectNonOverlappingCandidates: selectNonOverlappingCandidates,
  mergePoissonCandidates: mergePoissonCandidates,
  buildPackedPoissonCandidates: buildPackedPoissonCandidates,
  buildPoissonCandidates: buildPoissonCandidates,
  getPoissonOuterFrame: getPoissonOuterFrame,
  generatePoissonWatermarkPositions: generatePoissonWatermarkPositions,
  enforceNonOverlappingBodyPositions: enforceNonOverlappingBodyPositions,
  buildGuaranteedSlotPositions: buildGuaranteedSlotPositions,
  blendNonOverlappingPlacementPositions: blendNonOverlappingPlacementPositions,
  getWatermarkPlacementPositions: getWatermarkPlacementPositions,
  getVectorCellRatio: getVectorCellRatio,
  getReadableCellSize: getReadableCellSize,
  getGridOverflowCells: getGridOverflowCells,
  getVectorMetrics: getVectorMetrics,
  createPayloadBlock: createPayloadBlock,
  drawGridGlyph: drawGridGlyph,
  drawStyledDot: drawStyledDot,
  drawSmartAdaptiveDot: drawSmartAdaptiveDot,
  drawResilientAntiAiDot: drawResilientAntiAiDot,
  drawVectorWatermarkDistribution: drawVectorWatermarkDistribution,
  drawAiGuardRows: drawAiGuardRows,
  drawPayloadAt: drawPayloadAt,
  prepareAdaptiveBackgroundSampler: prepareAdaptiveBackgroundSampler,
  drawDotmatrixWatermark: drawDotmatrixWatermark,
  drawWaterMark: drawWaterMark,
  _drawWaterMark: _drawWaterMark,
  drawWordWaterMark: drawWordWaterMark,
  drawimgWaterMark: drawimgWaterMark,
  getTestWatermarkInfo: getTestWatermarkInfo
};
var _default = exports["default"] = MEWaterMarkRenderer;

},{"1412":1412,"1414":1414,"1415":1415,"1421":1421,"1423":1423,"1429":1429,"1431":1431,"1432":1432,"1437":1437,"1443":1443,"1444":1444,"1445":1445,"1454":1454,"1463":1463,"1477":1477,"1487":1487,"1538":1538}],1445:[function(require,module,exports){
var $ = require(1270);
var fails = require(1271);

// eslint-disable-next-line es/no-math-imul -- required for testing
var $imul = Math.imul;

var FORCED = fails(function () {
  return $imul(0xFFFFFFFF, 5) != -5 || $imul.length != 2;
});

// `Math.imul` method
// https://tc39.es/ecma262/#sec-math.imul
// some WebKit versions fails with big numbers, some has wrong arity
$({ target: 'Math', stat: true, forced: FORCED }, {
  imul: function imul(x, y) {
    var UINT16 = 0xFFFF;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});

},{"1270":1270,"1271":1271}],1444:[function(require,module,exports){
var $ = require(1270);

// eslint-disable-next-line es/no-math-hypot -- required for testing
var $hypot = Math.hypot;
var abs = Math.abs;
var sqrt = Math.sqrt;

// Chrome 77 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=9546
var BUGGY = !!$hypot && $hypot(Infinity, NaN) !== Infinity;

// `Math.hypot` method
// https://tc39.es/ecma262/#sec-math.hypot
$({ target: 'Math', stat: true, arity: 2, forced: BUGGY }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  hypot: function hypot(value1, value2) {
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * sqrt(sum);
  }
});

},{"1270":1270}],1414:[function(require,module,exports){
var $ = require(1270);
var fill = require(1215);
var addToUnscopables = require(1206);

// `Array.prototype.fill` method
// https://tc39.es/ecma262/#sec-array.prototype.fill
$({ target: 'Array', proto: true }, {
  fill: fill
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('fill');

},{"1206":1206,"1215":1215,"1270":1270}],484:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * 下载客户端
 * Created by jichao
 * 2017.9.14
 */
var MDClientDownloadWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDClientDownloadWinView, _MDWindowView);
  function MDClientDownloadWinView() {
    (0, _classCallCheck2["default"])(this, MDClientDownloadWinView);
    return _callSuper(this, MDClientDownloadWinView, arguments);
  }
  (0, _createClass2["default"])(MDClientDownloadWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n        <div class=\"file-sync\"><%=BabelStr.str(7202)%></div>\n        <div class=\"f-tc\"><%=BabelStr.str(7203)%></div>\n        <div class=\"f-tc mgb-15\">\n          <span class=\"text-color\"><%=BabelStr.str(7204)%> </span>/\n          <span class=\"text-color\"><%=BabelStr.str(4094)%> </span>/\n          <span class=\"text-color\"><%=BabelStr.str(7205)%> </span>/\n          <span class=\"text-color\"><%=BabelStr.str(7206)%></span>\n          <%=BabelStr.str(7207)%>\n        </div>\n        <div class=\"buttons flex-align center\">\n            <a href=\"" + window.windowClientUrl + "\" class=\"windowslink mgr-15\">\n              <span class=\"icon mgr-10 ic-windows\"> </span>\n              <span><%=BabelStr.str(7208)%></span>\n            </a>\n            <a href=\"" + window.macClientUrl + "\" class=\"maclink \">\n              <span class=\"icon mgr-20 ic-mac\"> </span>\n              <span><%=BabelStr.str(7209)%></span>\n            </a>\n        </div>\n        <div class=\"help-block mgt-10 f-tc\"><%=BabelStr.str(7210)%></div>\n        <div class=\"for-office f-tc red1\"><%=BabelStr.str(7211)%>  400-9204020</div>\n        <div class=\"bottom-msg f-hide f-tc red1\"></div>\n        <div class=\"mgt-20\"></div>\n    ";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDClientDownloadWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " m-slient-download-win");
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      if (!props.title) {
        props.title = BabelStr.str(7212);
      }
      props.width = 600;
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDClientDownloadWinView.prototype), "initialize", this).call(this, props);
      if (!this.showSyncMsg) {
        this.$(".file-sync").remove();
      }
      if (this.msg) {
        this.$(".file-sync").html(this.msg);
      }
      if (!this.forOffice) {
        this.$('.for-office').remove();
      }
      if (this.bottomMsg) {
        this.$('.bottom-msg').html(this.bottomMsg);
        this.$('.bottom-msg').removeClass('f-hide');
      }
    }
  }]);
  return MDClientDownloadWinView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"93":93}],303:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  FOLDER: 2,
  FILE: 1
};

},{"1454":1454}],296:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require(1199));
var _asyncToGenerator2 = _interopRequireDefault(require(1172));
require(1466);
require(1417);
require(1463);
require(1437);
require(1423);
require(1487);
require(1538);
require(1545);
require(1543);
require(1541);
require(1471);
require(1421);
require(1412);
var _MDFileTypeIconMap = _interopRequireDefault(require(258));
var MMFileIconMaker = {
  _getThumbnailPath: function _getThumbnailPath(fileInfo, version, size) {
    var fileId = fileInfo.getFileId();
    if (fileInfo.isShortcuts()) {
      fileId = fileInfo.get("linkedFileId");
      version = -1;
    }
    size = parseInt(size);
    var thumbUrl = "/netdrive/downloadThumbnail.do?fileId=" + fileId + "&size=" + size + "&version=" + version;
    return thumbUrl;
  },
  setIconForDiv: function () {
    var _setIconForDiv = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(fileInfo, version, $div, success, large, size, fullfill, noThumbnail, otherParams) {
      var MMEnterpriseController, curSrc, thumbSize, path, loadImg, dateTime, $img, loadLocalPath, retry, hasImgTable, hasDefaultThumbsTable, hasDefaultThumbsStore, customIcon4File, curTime, maxCatchTime, useLocal, hasLocal, needLoadImg, thumbInfo, _hasDefaultThumbsTable, result, time, hasSetDefaultType, setDefault, out, _hasDefaultThumbsStore, _result, _out, response, blob, base64, _out2, hasCustom;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if ($div) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            // 惰性 require：MMFileIconMaker 与 net 层存在循环依赖（model → controller → model），
            // 顶层 import 会在模块初始化阶段拿到未完成的 exports，导致 undefined.extend
            MMEnterpriseController = require(1098)["default"];
            $div = $div instanceof jQuery ? $div : $($div);
            if (!size) {
              size = $div.width();
              size = size ? size : 40;
            }
            $img = $div.find(".thumb");
            curSrc = $img.attr("src"); // console.log(curSrc, path)
            if (!(window.isMsboxUploadPage || (!fileInfo.isArchived() || fileInfo.isArchived() && fileInfo.canRead() || fileInfo.canManageFilePermission()) && MMFileIconMaker.hasThumbnail(fileInfo))) {
              _context.next = 21;
              break;
            }
            thumbSize = size;
            if (large && size < 300) {
              thumbSize = 300;
            }
            if (window.devicePixelRatio) {
              thumbSize = thumbSize * window.devicePixelRatio;
            }
            path = MMFileIconMaker._getThumbnailPath(fileInfo, version, thumbSize);
            if (!($img.length > 0)) {
              _context.next = 16;
              break;
            }
            $img.show().one({
              error: function error(err) {
                $img.remove();
                MMFileIconMaker.setTypeIconForFileInfo(fileInfo, $div, success, large, thumbSize, otherParams);
              },
              load: function load() {
                $div.removeClass("file-icon");
              }
            }).attr("src", path);
            $div.removeClass("file-icon f-hidden");
            return _context.abrupt("return");
          case 16:
            MMFileIconMaker.setTypeIconForFileInfo(fileInfo, $div, success, large, thumbSize, otherParams);
            if (!noThumbnail) {
              loadImg = function loadImg(haslocal, errorPath) {
                if (haslocal) {
                  var img = new Image();
                  img.crossOrigin = "anonymous";
                  img.src = path;
                  img.onload = function () {
                    $img.one({
                      load: function load() {
                        if ((fileInfo.isImageNotNeedConvert() || fileInfo.isVideoDirectlyPlay()) && hasImgTable && $img[0].src != errorPath) {
                          window.dexieDB["file_img_paths"].where({
                            fileId: fileInfo.getFileId(),
                            version: fileInfo.getCurVersion()
                          })["delete"]();
                        }
                        $div.removeClass("file-icon f-hidden");
                        $img.show();
                      },
                      error: function error() {
                        if (!errorPath) {
                          $img.remove();
                        } else {
                          $img.attr("src", errorPath);
                        }
                      }
                    });
                    var $canvas = $("<canvas width=\"300\" height=\"300\" style=\"position: fixed; left: -99999px; top: -99999px\"></canvas>");
                    $("body").append($canvas);
                    var canvas = $canvas[0];
                    canvas.width = img.width;
                    canvas.height = img.height;
                    var ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, img.width, img.height);
                    var imgThumbPath = canvas.toDataURL();
                    canvas.toBlob(function (blob) {
                      var blobUrl = URL.createObjectURL(blob);
                      $canvas.remove();
                      $img.attr("src", blobUrl);
                    });
                  };
                  img.onerror = function () {
                    if (!errorPath) {
                      $img.remove();
                    }
                  };
                } else {
                  $img.one({
                    load: function load() {
                      $div.removeClass("file-icon f-hidden");
                      $img.show();
                    },
                    error: function error(err, e, data) {
                      if (!$("#".concat(dateTime)).length) {
                        console.warn("img标签已被移除");
                        return;
                      }
                      // $img.remove();
                      if (++retry < 3) {
                        console.log("重试加载图片:" + retry);
                        $img.attr("src", "");
                        setTimeout(function () {
                          loadImg(haslocal, errorPath);
                        }, 1000 * 60);
                      } else {
                        $img.remove();
                      }
                    }
                  });
                  $img.attr("src", path);
                }
              };
              dateTime = new Date().getTime();
              $img = $("<img class=\"thumb\" id=\"".concat(dateTime, "\" crossOrigin = \"Anonymous\";>"));
              $img.hide();
              if (fullfill) {
                $img.css({
                  width: "100%",
                  height: "auto",
                  "margin-bottom": "-6px"
                });
              } else {
                $img.css({
                  width: "100%",
                  height: "auto",
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%,-50%)"
                });
              }
              loadLocalPath = false;
              retry = 0;
              hasImgTable = !!(window.dexieDB && window.dexieDB["file_img_paths"]);
              hasDefaultThumbsTable = !!(window.dexieDB && window.dexieDB["file_default_thumbs"]);
              hasDefaultThumbsStore = !!(window.dexieDB && window.dexieDB["default_thumbs"]);
              if ((fileInfo.isImageNotNeedConvert() || fileInfo.isVideoDirectlyPlay()) && hasImgTable && !loadLocalPath) {
                window.dexieDB["file_img_paths"].where({
                  fileId: fileInfo.getFileId(),
                  version: fileInfo.getCurVersion()
                }).first().then(function (result) {
                  if (result) {
                    loadLocalPath = true;
                    $img.attr("src", result.path);
                    $img.show();
                    $div.removeClass("file-icon f-hidden");
                    loadImg(true, result.path);
                  } else {
                    loadImg(false);
                  }
                });
              } else {
                loadImg(false);
              }
              $div.append($img);
            }
            if ($div.hasClass("m-dlgFileThumb")) {
              if (!fileInfo.isImage()) {
                $img.css("border", "1px solid lightgray");
              }
            }
            _context.next = 93;
            break;
          case 21:
            if (app.isEpVersion()) {
              _context.next = 28;
              break;
            }
            if (window.devicePixelRatio) {
              size = size * window.devicePixelRatio;
            }
            MMFileIconMaker.setTypeIconForFileInfo(fileInfo, $div, success, large, size, otherParams);
            if ($div.hasClass("m-dlgFileThumb")) {
              if (window.devicePixelRatio) {
                size = size / window.devicePixelRatio;
              }
              $div.css("height", size + "px");
              if (!fileInfo.isImage()) {
                $img.css("border", "1px solid lightgray");
              }
            }
            if (large) {
              $div.css("position", "relative");
            }
            _context.next = 93;
            break;
          case 28:
            if (window.devicePixelRatio) {
              size = size * window.devicePixelRatio;
            }
            $img.hide();
            customIcon4File = {};
            curTime = new Date().getTime();
            maxCatchTime = 1000 * 60 * 30;
            useLocal = false;
            hasLocal = false;
            needLoadImg = false;
            _hasDefaultThumbsTable = !!(window.dexieDB && window.dexieDB["file_default_thumbs"]);
            if (!_hasDefaultThumbsTable) {
              _context.next = 42;
              break;
            }
            _context.next = 40;
            return window.dexieDB["file_default_thumbs"].where({
              fileId: fileInfo.getFileId()
            }).first();
          case 40:
            result = _context.sent;
            if (result) {
              time = result.time;
              if (result.customIconId || result.asIconType) {
                hasLocal = true;
              }
              if (curTime - time < maxCatchTime) {
                customIcon4File = result;
                useLocal = true;
              } else if (window.dexieDB && window.dexieDB.file_default_thumbs) {
                window.dexieDB.file_default_thumbs["delete"](fileInfo.getFileId());
              }
            }
          case 42:
            hasSetDefaultType = false;
            setDefault = function setDefault() {
              MMFileIconMaker.setTypeIconForFileInfo(fileInfo, $div, success, large, size, otherParams);
              if ($div.hasClass("m-dlgFileThumb")) {
                var heightSize = size;
                if (window.devicePixelRatio) {
                  heightSize = heightSize / window.devicePixelRatio;
                }
                $div.css("height", heightSize + "px");
                if (!fileInfo.isImage()) {
                  $img.css("border", "1px solid lightgray");
                }
              }
              if (large) {
                $div.css("position", "relative");
              }
            };
            if (!useLocal) {
              setDefault();
              hasSetDefaultType = true;
            }
            if (useLocal) {
              _context.next = 51;
              break;
            }
            _context.next = 48;
            return MMEnterpriseController.dedupGetGetCustomIcon4File(fileInfo.getFileId());
          case 48:
            out = _context.sent;
            customIcon4File = out.customIcon4File || {};

            // await 期间 window.dexieDB 可能已失效（页面未初始化或已切换），需重新检查
            if (window.dexieDB && window.dexieDB.file_default_thumbs) {
              window.dexieDB.file_default_thumbs.put({
                fileId: fileInfo.getFileId(),
                asIconType: customIcon4File.asIconType,
                customIconId: customIcon4File.customIconId,
                time: curTime
              });
            }
          case 51:
            if (!customIcon4File.customIconId) {
              _context.next = 88;
              break;
            }
            _hasDefaultThumbsStore = !!(window.dexieDB && window.dexieDB["default_thumbs"]);
            if (!_hasDefaultThumbsStore) {
              _context.next = 83;
              break;
            }
            _context.next = 56;
            return window.dexieDB["default_thumbs"].where({
              id: customIcon4File.customIconId
            }).first();
          case 56:
            _result = _context.sent;
            if (!_result) {
              _context.next = 62;
              break;
            }
            customIcon4File.fileUrl = _result.fileUrl;
            console.log("使用了缓存的图" + customIcon4File.customIconId);
            _context.next = 81;
            break;
          case 62:
            _context.next = 64;
            return MMEnterpriseController.dedupGetGetCustomIcon4File(fileInfo.getFileId());
          case 64:
            _out = _context.sent;
            customIcon4File = _out.customIcon4File || {};
            if (customIcon4File.fileUrl) {
              _context.next = 69;
              break;
            }
            console.error("有id没路径");
            return _context.abrupt("return");
          case 69:
            _context.next = 71;
            return fetch(customIcon4File.fileUrl);
          case 71:
            response = _context.sent;
            _context.next = 74;
            return response.blob();
          case 74:
            blob = _context.sent;
            _context.next = 77;
            return new Promise(function (resolve, reject) {
              var reader = new FileReader();
              reader.onloadend = function () {
                return resolve(reader.result);
              };
              reader.onerror = reject;
              reader.readAsDataURL(blob);
            });
          case 77:
            base64 = _context.sent;
            customIcon4File.fileUrl = base64;
            if (window.dexieDB && window.dexieDB.default_thumbs) {
              window.dexieDB.default_thumbs.put({
                id: customIcon4File.customIconId,
                fileUrl: base64
              });
            }
            console.log("又获取了新的" + customIcon4File.customIconId);
          case 81:
            _context.next = 88;
            break;
          case 83:
            _context.next = 85;
            return MMEnterpriseController.dedupGetGetCustomIcon4File(fileInfo.getFileId());
          case 85:
            _out2 = _context.sent;
            customIcon4File = _out2.customIcon4File || {};
            if (customIcon4File.fileUrl) {
              // 尝试直接使用
            }
          case 88:
            if (!customIcon4File.fileUrl) {
              $img.hide();
            }
            fileInfo.set("customIcon4File", customIcon4File);
            hasCustom = false;
            if (customIcon4File) {
              if (customIcon4File.fileUrl || customIcon4File.asIconType) {
                hasCustom = true;
              }
            }
            if (hasCustom) {
              MMFileIconMaker.setCustomIconForFileInfo(fileInfo, $div, success, large, size, otherParams);
            } else if (!hasSetDefaultType) {
              setDefault();
            }
          case 93:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function setIconForDiv(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8, _x9) {
      return _setIconForDiv.apply(this, arguments);
    }
    return setIconForDiv;
  }(),
  setCustomIconForFileInfo: function setCustomIconForFileInfo(fileInfo, $div, success, large, size, otherParams) {
    var customIcon4File = fileInfo.get("customIcon4File");
    if (customIcon4File.fileUrl) {
      var _$img = $div.find(".thumb");
      if (!_$img.length) {
        _$img = $('<img class="thumb custom-thumb" crossOrigin = "Anonymous";>');
        $div.append(_$img);
      }
      var _retry = 0;
      _$img.one({
        load: function load() {
          $div.removeClass("file-icon f-hidden");
          $div.removeClass("default-icon");
          _$img.css({
            width: "100%",
            height: "100%",
            "object-fit": "cover",
            "border-radius": "4px"
          });
          _$img.show();
        },
        error: function error(err, e, data) {
          // $img.remove();
          if (++_retry < 3) {
            console.log("重试加载图片:" + _retry);
            _$img.attr("src", "");
            setTimeout(function () {
              _$img.attr("src", customIcon4File.fileUrl);
            }, 1000 * 60 * _retry);
          } else {
            _$img.hide();
          }
        }
      });
      _$img.attr("src", customIcon4File.fileUrl);
    } else {
      var x = 0;
      var y = 0;
      var i = parseInt(customIcon4File.asIconType);
      var bkgroundSize = {};
      var s_size = 40.0;
      var ratio = 1.0;
      if (!size) {
        size = 40;
      }
      if (otherParams && otherParams.defaultSize) {
        size = otherParams.defaultSize;
      }
      if (window.devicePixelRatio) {
        size = size / window.devicePixelRatio;
      }
      ratio = size / s_size;
      x = -i * 40 % 400 * ratio;
      y = -Math.floor(i / 10) * 40 * ratio;
      bkgroundSize.x = 400 * ratio;
      bkgroundSize.y = 400 * ratio;
      $div.addClass("file-icon").removeClass("f-hidden").addClass("default-icon").css("background-position", x + "px " + y + "px").css("background-size", bkgroundSize.x + "px " + bkgroundSize.y + "px");
    }
  },
  // async LoadImageFromLocalStorage: function(fileInfo) {
  //   if(window.dexieDB && window.dexieDB["file_img_paths"]) {
  //     const pathData = await window.dexieDB["file_img_paths"].where({fileId: fileInfo.getFileId(), version: fileInfo.getCurVersion()}).first();
  //   }

  // }

  setTypeIconForFileInfoNotCalcDevice: function setTypeIconForFileInfoNotCalcDevice(fileInfo, $div, success, large, size, otherParams) {
    if (window.devicePixelRatio) {
      //retina屏幕显示高清图
      size = size * window.devicePixelRatio;
    }
    this.setTypeIconForFileInfo(fileInfo, $div, success, large, size, otherParams);
  },
  setTypeIconForFileInfo: function setTypeIconForFileInfo(fileInfo, $div, success, large, size, otherParams) {
    $div = $($div);
    if (window.devicePixelRatio) {
      //retina屏幕显示高清图
      size = size / window.devicePixelRatio;
    }
    if (large && size < 60) {
      size = 60;
    }
    if (otherParams && otherParams.defaultSize) {
      size = otherParams.defaultSize;
    }
    var bkgroundSize = {
      x: 0,
      y: 0
    };
    var iconPos = _MDFileTypeIconMap["default"].getIconPositionForFilInfo(fileInfo, size, bkgroundSize);
    $div.removeClass("f-hidden");
    $div.addClass("file-icon").removeClass("default-icon").css("background-position", iconPos.x + "px " + iconPos.y + "px").css("background-size", bkgroundSize.x + "px " + bkgroundSize.y + "px");
    // .css("width", size + 'px')
    // .css("height", size + 'px');
    if (large) {
      $div.addClass("ic-large");
    }
    $div.addClass("ic-file-" + size);
    if (_.isFunction(success)) {
      success();
    }
  },
  setTypeIconForFileName: function setTypeIconForFileName(name, $div) {
    $div = $($div);
    var iconPos = _MDFileTypeIconMap["default"].getPositionForFileName(name);
    $div.addClass("file-icon").removeClass("f-hidden").css("background-position", iconPos.x + "px " + iconPos.y + "px");
  },
  hasThumbnail: function hasThumbnail(fileInfo) {
    if (!fileInfo || fileInfo.isFolder()) {
      return false;
    }
    var types = ["avif", "webp",
    // "jxl",
    "ico", "bmp", "jpeg", "png", "gif", "psd", "jpg", "pdf", "ai", "doc", "xls", "ppt", "docx", "xlsx", "pptx", "dwg", "tiff", "tif", "wps", "dps", "et", "bmp", "svg", "indd", "cr2", "arw", "dng", "nef", "pef", "txt", "eps", "heic", "flv", "mov", "mp4", "webm", "ogg", "mkv"];
    var ext = fileInfo.getFileExtension().toLowerCase();
    if (fileInfo.isShortcuts()) {
      ext = fileInfo.get("linkedFileExt").toLowerCase();
    }
    if (fileInfo.get("linkFileUrl")) {
      return true;
    }
    return types.indexOf(ext) > -1;
  },
  reFreshNodeIcon: function reFreshNodeIcon(node, jsTree) {
    if (!node) {
      return;
    }
    var nodeId = node.id;
    var nodeData = node.data; // 获取节点数据

    // 检查是否有自定义图标
    if (nodeData.customIcon4File) {
      if (nodeData.customIcon4File.fileUrl) {
        var $nodeElement = jsTree.get_node(nodeId, true);
        // 注意：这里可能需要根据 jstree 版本调整选择器
        var $iconElement = $nodeElement.find(" > .jstree-anchor .jstree-themeicon-custom");
        $iconElement.css({
          "background-size": "20px",
          // 背景大小
          "border-radius": "10px"
        });
      } else {
        var x = 0;
        var y = 0;
        var i = parseInt(nodeData.customIcon4File.asIconType);
        var bkgroundSize = {};
        var size = 24;
        var s_size = 40.0;
        var ratio = 1.0;
        ratio = size / s_size;
        x = -i * 40 % 400 * ratio;
        y = -Math.floor(i / 10) * 40 * ratio;
        bkgroundSize.x = 400 * ratio;
        bkgroundSize.y = 400 * ratio;

        // 3. 定位节点的图标元素（关键步骤！）
        var _$nodeElement = jsTree.get_node(node.id, true); // 节点的 DOM 元素
        var _$iconElement = _$nodeElement.find(" > .jstree-anchor .jstree-themeicon-custom"); // 图标元素（jstree 默认类）

        _$iconElement.addClass("default-icon").prop('style').cssText = "background-position: ".concat(x, "px ").concat(y, "px !important; ") + "background-size: ".concat(bkgroundSize.x, "px ").concat(bkgroundSize.y, "px !important; ");
      }
    }
  }
};
var _default = exports["default"] = MMFileIconMaker;

},{"1098":1098,"1172":1172,"1184":1184,"1199":1199,"1412":1412,"1417":1417,"1421":1421,"1423":1423,"1437":1437,"1454":1454,"1463":1463,"1466":1466,"1471":1471,"1487":1487,"1538":1538,"1541":1541,"1543":1543,"1545":1545,"258":258}],1199:[function(require,module,exports){
// TODO(Babel 8): Remove this file.

var runtime = require(1190)();
module.exports = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}

},{"1190":1190}],1190:[function(require,module,exports){
var _typeof = require(1197)["default"];
function _regeneratorRuntime() {
  "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function value(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"1197":1197}],1172:[function(require,module,exports){
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],1098:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require(1180));
require(1439);
require(1418);
require(1463);
require(1537);
require(1437);
require(1466);
require(1541);
require(1412);
require(1426);
require(1478);
require(1451);
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MDFileLog = _interopRequireDefault(require(256));
var _MDFileLogCollection = _interopRequireDefault(require(257));
var _MMFileInfo = _interopRequireDefault(require(297));
var _MMFileInfoCollection = _interopRequireDefault(require(298));
var _MDMacAddressCollection = _interopRequireDefault(require(267));
var _MDLocalString = _interopRequireDefault(require(1150));
var _MDTransmittalCollection = _interopRequireDefault(require(292));
var _app = _interopRequireDefault(require(17));
var _utils = _interopRequireDefault(require(108));
var _part = _interopRequireDefault(require(1099));
var _part2 = _interopRequireDefault(require(1100));
var _part3 = _interopRequireDefault(require(1101));
var _part4 = _interopRequireDefault(require(1102));
var _part5 = _interopRequireDefault(require(1103));
var _MMEnterpriseControll;
/**
 * 企业版数据请求对象
 * 注意，为了避免混淆，所有的用户相关id统一使用userId
 *
 */
var MMEnterpriseController = (_MMEnterpriseControll = {
  _connector: null,
  /**
   * execute a pomelo request, with defaultParams
   * @param route {string} the method to call
   * @param msg optional {object} the parameter for the remote method
   * @param callback {function} the response callback
   */
  request: function request(route, msg, callback) {
    return MMEnterpriseController._connector.request(route, msg, callback);
  },
  getTransmittalList: function getTransmittalList(fileId, success, fail) {
    var result = [{
      id: "HQSM12-GXX-2XX-146",
      name: "MCC",
      status: 0
    }, {
      id: "HQSM12-GXX-2XX-147",
      name: "MCC",
      status: 1
    }, {
      id: "HQSM12-GXX-2XX-148",
      name: "MCC",
      status: 1
    }, {
      id: "HQSM12-GXX-2XX-149",
      name: "MCC",
      status: 1
    }];
    var out = new _MDTransmittalCollection["default"](result);
    success(out, 4);
    // MMEnterpriseController.request('netDrive.fileHandler.getTransmittalList', {
    //   fileId: fileId,
    //   reviewId: reviewId
    // },function(res) {
    //   if(res["resultCode"] === 0){
    //     success()
    //   }else {
    //     fail(res['message'])
    //   }
    // })
  },
  delFileBlackList: function delFileBlackList(id, successCB, failCb) {
    $.ajax({
      url: "/enterprise/delFileBlackList.do",
      method: "post",
      data: {
        blacklistId: id
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB();
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  addFileBlackList: function addFileBlackList(ext, successCB, failCb) {
    $.ajax({
      url: "/enterprise/addFileBlackList.do",
      method: "post",
      data: {
        ext: ext
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB();
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  getFileBlackList: function getFileBlackList(successCB, failCb) {
    $.ajax({
      url: "/enterprise/getFileBlackList.do",
      method: "post",
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData["exts"]);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  delFileBlackListForFolder: function delFileBlackListForFolder(params, successCB, failCb) {
    MMEnterpriseController.request("netDrive.fileExHandler.delFileBlackListForFolder", {
      blacklist_ids: params.blacklist_ids,
      fileId: params.fileId
    }, function (res) {
      if (res["code"] === 0) {
        _.isFunction(successCB) && successCB(res["blacklist"]);
      } else {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  addFileBlackListForFolder: function addFileBlackListForFolder(params, successCB, failCb) {
    MMEnterpriseController.request("netDrive.fileExHandler.addFileBlackListForFolder", {
      ext: params.ext,
      fileId: params.fileId,
      type: params.type
    }, function (res) {
      if (res["code"] === 0) {
        _.isFunction(successCB) && successCB(res["blacklist"]);
      } else {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  getFileBlackListForFolder: function getFileBlackListForFolder(fileId, successCB, failCb) {
    MMEnterpriseController.request("netDrive.fileExHandler.getFileBlackListForFolder", {
      fileId: fileId
    }, function (res) {
      if (res["code"] === 0) {
        _.isFunction(successCB) && successCB(res["blacklist"]);
      } else {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  updateCustomerResult: function updateCustomerResult(feedbackId, successCB, failCb) {
    $.ajax({
      url: "/public/updateCustomerResult.do",
      method: "post",
      data: {
        feedbackId: feedbackId
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  insertCustomerFeedback: function insertCustomerFeedback(feedback, successCB, failCb) {
    $.ajax({
      url: "/public/insertCustomerFeedback.do",
      method: "post",
      data: {
        feedback: feedback
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  updateEnterpriseOwner: function updateEnterpriseOwner(pwd, userId, successCB, failCb) {
    $.ajax({
      url: "/enterprise/updateEnterpriseOwner.do",
      method: "post",
      data: {
        password: pwd,
        userId: userId
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB();
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  }
}, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_MMEnterpriseControll, "updateEnterpriseOwner", function updateEnterpriseOwner(pwd, userId, successCB, failCb) {
  $.ajax({
    url: "/enterprise/updateEnterpriseOwner.do",
    method: "post",
    data: {
      password: pwd,
      userId: userId
    },
    success: function success(responseData, textStatus, jaXHR) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB();
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    fail: function fail(res) {
      _.isFunction(failCb) && failCb(res);
    }
  });
}), "deleteAccount", function deleteAccount(pwd, successCB, failCb) {
  $.ajax({
    url: "/account/deleteAccount.do",
    method: "post",
    data: {
      password: pwd
    },
    success: function success(responseData, textStatus, jaXHR) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB();
      } else {
        _.isFunction(failCb) && failCb();
      }
    },
    fail: function fail(res) {
      _.isFunction(failCb) && failCb();
    }
  });
}), "dissolveEnterprise", function dissolveEnterprise(pwd, successCB, failCb) {
  $.ajax({
    url: "/enterprise/dissolveEnterprise.do",
    method: "post",
    data: {
      password: pwd
    },
    success: function success(responseData, textStatus, jaXHR) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB();
      } else {
        _.isFunction(failCb) && failCb();
      }
    },
    fail: function fail(res) {
      _.isFunction(failCb) && failCb();
    }
  });
}), "localeLanguage", function localeLanguage(successCB, failCb) {
  var lan = BabelStr.getCurrentLanguage();
  $.ajax({
    url: "/public/localeLanguage.do",
    method: "post",
    data: {
      language: lan
    },
    success: function success(responseData, textStatus, jaXHR) {
      console.warn(responseData);
    },
    fail: function fail(res) {
      console.log(res);
    }
  });
}), "createOfficeFile", function createOfficeFile(parentFolderId, fileName, successCB, failCb) {
  fileName = encodeURI(fileName);
  var param = {
    parentFolderId: parentFolderId,
    fileName: fileName
  };
  $.ajax({
    // url: `netdrive/createOfficeFile.do?parentFolderId=${parentFolderId}&fileName=${fileName}`,     // ------------------- 获取项目和团队的分享链接
    url: "/netdrive/createOfficeFile.do",
    data: param,
    success: function success(responseData, textStatus, jaXHR) {
      if (responseData["success"] === true) {
        successCB(responseData);
      } else {
        console.log(responseData);
        failCb(responseData["code"], responseData["msg"]);
      }
    },
    fail: function fail(res) {
      console.log(res);
      failCb(res.code, res.msg);
    }
  });
}), "refreshSessionInfo", function refreshSessionInfo() {
  $.ajax({
    url: "/enterprise/refreshSessionInfo.do",
    method: "post",
    success: function success(responseData, textStatus, jaXHR) {
      console.warn(responseData);
    },
    fail: function fail(res) {
      console.log(res);
    }
  });
}), "removeFileReview", function removeFileReview(fileId, reviewId, success, fail) {
  MMEnterpriseController.request("netDrive.fileHandler.removeFileReview", {
    fileId: fileId,
    reviewId: reviewId
  }, function (res) {
    if (res["resultCode"] === 0) {
      success();
    } else {
      fail(res["message"]);
    }
  });
}), "searchUserFromUserlist", function searchUserFromUserlist(params, success, fail) {
  MMEnterpriseController.request("netDrive.enterpriseHandler.searchUserFromUserList", params, function (res) {
    if (res["resultCode"] === 0) {
      success(res["userInfos"], res.groupInfos, res.departmentInfos);
    } else {
      fail && fail(res["message"]);
    }
  });
}), "acceptEnterpriseInvitation", function acceptEnterpriseInvitation(invitationId, success, fail) {
  MMEnterpriseController.request("netDrive.userHandler.acceptEnterpriseInvitation", {
    invitationId: invitationId
  }, function (res) {
    if (res["resultCode"] === 0) {
      success();
    } else {
      fail(res["message"]);
    }
  });
}), "skipMultFlowCurrentStep", function skipMultFlowCurrentStep(flowId, success, fail) {
  MMEnterpriseController.request("netDrive.evaluationHandler.skipMultFlowCurrentStep", {
    flowId: flowId
  }, function (res) {
    if (res["resultCode"] === 0) {
      success();
    } else {
      fail(res["message"]);
    }
  });
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_MMEnterpriseControll, "deleteEnterpriseBroadcast", function deleteEnterpriseBroadcast(broadcastId, success, fail) {
  MMEnterpriseController.request("netDrive.enterpriseHandler.deleteEnterpriseBroadcast", {
    broadcastId: broadcastId
  }, function (res) {
    if (res["resultCode"] === 0) {
      success();
    } else {
      fail(res["message"]);
    }
  });
}), "updateMyEnterpriseRemarkName", function updateMyEnterpriseRemarkName(name, success, fail) {
  MMEnterpriseController.request("netDrive.enterpriseHandler.updateMyEnterpriseRemarkName", {
    name: name
  }, function (res) {
    if (res["resultCode"] === 0) {
      success();
    } else {
      if (res["resultCode"] === 12 && _app["default"].isEpVersion()) {
        res.message = BabelStr.str(28247);
      }
      fail(res["message"]);
    }
  });
}), "changeMyName", function changeMyName(name, success, fail) {
  MMEnterpriseController.request("netDrive.userHandler.changeMyName", {
    name: name
  }, function (res) {
    if (res["resultCode"] === 0) {
      success();
    } else {
      if (res["resultCode"] === 12 && _app["default"].isEpVersion()) {
        res.message = BabelStr.str(28247);
      }
      fail(res["message"]);
    }
  });
}), "acceptOrDenyApplyForTeamOrProj", function acceptOrDenyApplyForTeamOrProj(applyId, flag, roleId, success, fail) {
  MMEnterpriseController.request("netDrive.fileExHandler.acceptOrDenyApplyForTeamOrProj", {
    flag: flag,
    applyId: applyId,
    roleId: roleId
  }, function (res) {
    if (res["resultCode"] === 0) {
      success(res["needReview"]);
    } else {
      fail(res["message"]);
    }
  });
}), "getProgressInfo", function getProgressInfo(key, success, fail) {
  MMEnterpriseController.request("netDrive.fileExHandler.getProgressInfo", {
    key: key
  }, function (res) {
    console.log(res);
    if (res["resultCode"] === 0) {
      success(res["completed"], res["total"], res["result"] && res["result"]["copyResults"]);
    } else {
      fail(res["message"], res["resultCode"]);
    }
  });
}), "getFileNumInFolder", function getFileNumInFolder(folderId, success, fail) {
  MMEnterpriseController.request("netDrive.fileHandler.getFileNumInFolder", {
    folderId: folderId
  }, function (res) {
    if (res["resultCode"] === 0) {
      success(res["fileCount"], res["fileSize"]);
    } else {
      fail(res["message"]);
    }
  });
}), "getFileNumInFolder2", function getFileNumInFolder2(folderId, success, fail) {
  MMEnterpriseController.request("netDrive.fileHandler.getFileNumInFolder2", {
    folderId: folderId
  }, function (res) {
    if (res["resultCode"] === 0) {
      console.log(res);
      success(res["docCount"], res["fileSize"], res["folderCount"], res["fileCount"]);
    } else {
      fail(res["message"]);
    }
  });
}), "getFileNumInFolder2New", function getFileNumInFolder2New(folderId, success, fail) {
  MMEnterpriseController.request("netDrive.fileHandler.getFileNumInFolder2", {
    folderId: folderId
  }, function (res) {
    if (res["resultCode"] === 0) {
      console.log(res);
      success(res["fileCount"], res["fileSize"], res["folderCount"], res["docCount"]);
    } else {
      fail(res["message"]);
    }
  });
}), "getTeamInvUrl", function getTeamInvUrl(params, successCB, failCb) {
  $.ajax({
    method: "get",
    url: "file/getTeamInvUrl.do?".concat(params),
    // ------------------- 获取项目和团队的分享链接
    success: function success(responseData, textStatus, jaXHR) {
      if (responseData["success"] === true) {
        console.log(responseData);
        _czc && _czc.push(["_trackEvent", "团队(项目)", "获取链接", "", responseData["url"], ""]);
        successCB(responseData["url"]);
      } else {
        console.log(responseData);
        failCb();
        // failCB(responseData['code'], responseData['msg']);
      }
    },
    fail: function fail(res) {
      console.log(res);
      failCb();
    }
  });
}), "getFileBelongDepartment", function getFileBelongDepartment(fileId, success, fail) {
  MMEnterpriseController.request("netDrive.fileExHandler.getFileBelongDepartment", {
    fileId: fileId
  }, function (res) {
    if (res["resultCode"] === 0) {
      console.log(res);
      success(res["department"]);
    } else {
      fail(res["message"]);
    }
  });
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_MMEnterpriseControll, "statisFileWorkloadDetail", function statisFileWorkloadDetail(options, success, fail) {
  MMEnterpriseController.request("netDrive.statisHandler.statisFileWorkloadDetail", {
    fileId: options.fileId,
    startIndex: options.startIndex,
    pageSize: options.pageSize,
    startTime: options.startTime,
    endTime: options.endTime,
    type: options.type,
    userId: options.userId
  }, function (res) {
    if (res["resultCode"] === 0) {
      console.log(res);
      success(res["records"]);
    } else {
      fail(res["message"]);
    }
  });
}), "getMsBoxFileAllStatus", function getMsBoxFileAllStatus(fileId, version, success, fail) {
  MMEnterpriseController.request("netDrive.fileExHandler.getMsBoxFileAllStatus", {
    fileId: fileId,
    version: version
  }, function (res) {
    if (res["resultCode"] === 0) {
      console.log(res);
      success();
    } else {
      fail(res["message"]);
    }
  });
}), "getMsBoxFileStatus", function getMsBoxFileStatus(fileId, version, success, fail) {
  MMEnterpriseController.request("netDrive.fileExHandler.getMsBoxFileStatus", {
    fileId: fileId,
    version: version
  }, function (res) {
    if (res["resultCode"] === 0) {
      console.log(res);
      success(res["status"]);
    } else {
      fail(res["message"]);
    }
  });
}), "setMsBoxFileStatus", function setMsBoxFileStatus(fileId, version, status, comment, success, fail) {
  _czc && _czc.push(["_trackEvent", "文件收集箱", "接收退回", status + "", "", ""]);
  MMEnterpriseController.request("netDrive.fileExHandler.setMsBoxFileStatus", {
    fileId: fileId,
    version: version,
    status: status,
    comment: comment
  }, function (res) {
    if (res["resultCode"] === 0) {
      console.log(res);
      success();
    } else {
      fail(res["message"]);
    }
  });
}), "project", {
  transformProjectToParent: function transformProjectToParent(fileId, success, fail) {
    MMEnterpriseController.request("netDrive.fileExHandler.transformProjectToParent", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.log(res);
        success();
      } else {
        fail(res["message"]);
      }
    });
  },
  updateProject: function updateProject(params, success, fail) {
    MMEnterpriseController.request("netDrive.fileExHandler.updateProject", {
      fileId: params.fileId,
      name: params.name,
      startTime: params.startTime,
      endTime: params.endTime,
      participantInfo: params.participantInfo,
      removeUserInfos: params.removeUserInfos,
      updateUserInfos: params.updateUserInfos
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.log(res);
        success(res["members"]);
      } else {
        fail(res["message"], res["resultCode"]);
      }
    });
  },
  getProjectMembers: function getProjectMembers(fileId, success, fail) {
    MMEnterpriseController.request("netDrive.fileExHandler.getProjectMembers", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.log(res);
        success(res["members"]);
      } else {
        fail(res["message"]);
      }
    });
  },
  searchProjectPersonalMembers: function searchProjectPersonalMembers(options, success, fail) {
    MMEnterpriseController.request("netDrive.fileExHandler.searchProjectPersonalMembers", {
      fileId: options.fileId,
      searchKey: options.searchKey,
      pageIndex: options.pageIndex,
      pageSize: options.pageSize
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.log(res);
        success(res["members"]);
      } else {
        fail(res["message"]);
      }
    });
  },
  transformProject: function transformProject(options, success, fail) {
    MMEnterpriseController.request("netDrive.fileExHandler.transformProject", {
      fileId: options.fileId,
      destDirId: options.destDirId,
      directorId: options.directorId,
      remainManager: options.remainOwner,
      directorUserType: options.directorUserType
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["message"], res["resultCode"]);
      }
    });
  },
  getDepartmentProjects: function getDepartmentProjects(id, success, fail) {
    MMEnterpriseController.request("netDrive.fileExHandler.getDepartmentProjects", {
      departmentId: id
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["projects"]);
      } else {
        fail(res["message"]);
      }
    });
  },
  getProjectByFileId: function getProjectByFileId(id, success, fail) {
    MMEnterpriseController.request("netDrive.fileExHandler.getProjectByFileId", {
      fileIds: [id]
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["projects"]);
      } else {
        fail && fail(res["message"]);
      }
    });
  },
  createProject: function createProject(options, success, fail) {
    MMEnterpriseController.request("netDrive.fileExHandler.createProject", {
      directorId: options.directorId,
      parentId: options.parentId,
      name: options.name,
      startTime: options.startTime,
      endTime: options.endTime,
      participantInfo: options.participantInfo
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["fileInfo"]);
      } else {
        fail(res["message"], res["resultCode"]);
      }
    });
  },
  changeFolder2Project: function changeFolder2Project(options, success, fail) {
    MMEnterpriseController.request("netDrive.fileExHandler.changeFolder2Project", {
      directorId: options.directorId,
      folderId: options.folderId,
      startTime: options.startTime,
      endTime: options.endTime,
      participantInfo: options.participantInfo
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["fileInfo"]);
      } else {
        fail(res["message"], res["resultCode"]);
      }
    });
  }
}), "statistics", {
  statisFileWorkload: function statisFileWorkload(options, success, fail) {
    _czc && _czc.push(["_trackEvent", "报表", "个人工作量统计", "", "", ""]);
    MMEnterpriseController.request("netDrive.statisHandler.statisFileWorkload2", {
      fileId: options.fileId,
      startIndex: options.startIndex,
      pageSize: options.pageSize,
      startTime: options.startTime,
      endTime: options.endTime
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["users"], res["count"]);
      } else {
        fail(res["message"], res["resultCode"]);
      }
    });
  },
  statisFileWorkload2: function statisFileWorkload2(options, success, fail) {
    _czc && _czc.push(["_trackEvent", "报表", "个人工作量统计", "", "", ""]);
    MMEnterpriseController.request("netDrive.statisHandler.statisFileWorkload3", {
      depId: options.depId,
      depFolderId: options.depFolderId,
      startIndex: options.startIndex,
      pageSize: options.pageSize,
      startTime: options.startTime,
      endTime: options.endTime
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["users"], res["count"]);
      } else {
        fail(res["message"], res["resultCode"]);
      }
    });
  },
  countCreationInDepartment: function countCreationInDepartment(options, success, fail) {
    _czc && _czc.push(["_trackEvent", "报表", "部门工作量统计", "", "", ""]);
    MMEnterpriseController.request("netDrive.statisHandler.countCreationInDepartment", {
      depId: options.depId,
      depFolderId: options.depFolderId,
      startIndex: options.startIndex,
      pageSize: options.pageSize,
      startTime: options.startTime,
      endTime: options.endTime
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res.result["folderCount"], res.result["fileCount"]);
      } else {
        fail(res["message"], res["resultCode"]);
      }
    });
  },
  countCreationInDepartmentByES: function countCreationInDepartmentByES(options, success, fail) {
    MMEnterpriseController.request("netDrive.statisHandler.countCreationInDepartmentByES", {
      depFolderId: options.depFolderId,
      startTime: options.startTime,
      endTime: options.endTime
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res.result["teamMarks"], res.result["types"]);
      } else {
        fail(res["message"], res["resultCode"]);
      }
    });
  },
  getUserDepartmentUploadFile: function getUserDepartmentUploadFile(startIndex, pageSize, success, fail) {
    MMEnterpriseController.request("netDrive.statisHandler.getUserDepartmentUploadFile", {
      startIndex: startIndex,
      pageSize: pageSize
    }, function (res) {
      if (res["resultCode"] === 0) {
        if (res["resultCode"] === 0) {
          var out = new _MMFileInfoCollection["default"]();
          if (!res["files"]) {
            //list->files
            success(out);
            return;
          }
          res["files"].forEach(function (fileInfo) {
            var info = new _MMFileInfo["default"](fileInfo);
            out.push(info);
          });
          success(out);
        } else {
          fail(res["resultCode"]);
        }
      } else {
        fail(res["message"], res["resultCode"]);
      }
    });
  },
  getUserProjectionUploadFile: function getUserProjectionUploadFile(startIndex, pageSize, success, fail) {
    MMEnterpriseController.request("netDrive.statisHandler.getUserProjectionUploadFile", {
      startIndex: startIndex,
      pageSize: pageSize
    }, function (res) {
      if (res["resultCode"] === 0) {
        if (res["resultCode"] === 0) {
          var out = new _MMFileInfoCollection["default"]();
          if (!res["files"]) {
            //list->files
            success(out);
            return;
          }
          res["files"].forEach(function (fileInfo) {
            var info = new _MMFileInfo["default"](fileInfo);
            out.push(info);
          });
          success(out);
        } else {
          fail(res["resultCode"]);
        }
      } else {
        fail(res["message"], res["resultCode"]);
      }
    });
  },
  getUserRecentUploadFile: function getUserRecentUploadFile(startIndex, pageSize, success, fail) {
    MMEnterpriseController.request("netDrive.statisHandler.getUserRecentUploadFile", {
      startIndex: startIndex,
      pageSize: pageSize
    }, function (res) {
      if (res["resultCode"] === 0) {
        if (res["resultCode"] === 0) {
          var out = new _MMFileInfoCollection["default"](res["files"]);
          success(out);
        } else {
          fail(res["resultCode"]);
        }
      } else {
        fail(res["message"], res["resultCode"]);
      }
    });
  },
  getUserDepActiveFiles: function getUserDepActiveFiles(startIndex, pageSize, success, fail) {
    MMEnterpriseController.request("netDrive.statisHandler.getUserDepActiveFiles", {
      startIndex: startIndex,
      pageSize: pageSize
    }, function (res) {
      if (res["resultCode"] === 0) {
        if (res["resultCode"] === 0) {
          var out = new _MMFileInfoCollection["default"](res["list"]);
          success(out);
        } else {
          fail(res["resultCode"]);
        }
      } else {
        fail(res["message"], res["resultCode"]);
      }
    });
  },
  getStasticsActiveFileCounts: function getStasticsActiveFileCounts(success, fail) {
    var outs = [{
      depName: "市场部",
      userCounts: 1000,
      fileCounts: 600
    }, {
      depName: "苹果委员会",
      userCounts: 100,
      fileCounts: 200
    }, {
      depName: "会所",
      userCounts: 400,
      fileCounts: 400
    }, {
      depName: "研发部",
      userCounts: 600,
      fileCounts: 300
    }, {
      depName: "销售部",
      userCounts: 900,
      fileCounts: 700
    }, {
      depName: "体育部",
      userCounts: 100,
      fileCounts: 300
    }, {
      depName: "后勤部",
      userCounts: 300,
      fileCounts: 800
    }, {
      depName: "总经办",
      userCounts: 700,
      fileCounts: 300
    }];
    outs = _.sortBy(outs, "fileCounts");
    setBabelTimeout(function () {
      success(outs);
    }, 1000);
    return;
  },
  getSubDepFileExtension: function getSubDepFileExtension(parentDepFolderId, success, fail) {
    MMEnterpriseController.request("netDrive.statisHandler.getSubDepFileExtension", {
      parentDepFolderId: parentDepFolderId
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.log(res);
        success(res["departments"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  countActiveInDepartment: function countActiveInDepartment(grade, startTime, endTime, success, fail) {
    MMEnterpriseController.request("netDrive.statisHandler.countActiveInDepartment", {
      grade: grade,
      startTime: startTime,
      endTime: endTime
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.log(res);
        success(res["departments"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  countActiveInDepartment2: function countActiveInDepartment2(departId, startTime, endTime, success, fail) {
    if (typeof startTime != "number") {
      startTime = new Date(startTime).getTime();
    }
    if (typeof endTime != "number") {
      endTime = new Date(endTime).getTime();
    }
    MMEnterpriseController.request("netDrive.statisHandler.countActiveInDepartment2", {
      departId: departId,
      startTime: startTime,
      endTime: endTime
    }, function (res) {
      if (res["code"] === 0) {
        console.log(res);
        success(res["result"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  getDepartmentMaxGrade: function getDepartmentMaxGrade(success, fail) {
    MMEnterpriseController.request("netDrive.statisHandler.getDepartmentMaxGrade", {}, function (res) {
      if (res["resultCode"] === 0) {
        var grades = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", "十一", "十二", "十三", "十四", "十五", "十六", "十七", "十八", "十九", "二十"];
        if (_MDLocalString["default"].getCurrentLanguage() != "cn") {
          grades = ["1st", "2nd", "3rd", "4th", "5th", "6th", "7th", "8th", "9th", "10th", "11th", "12th", "13th", "14th", "15th", "16th", "17th", "18th", "19th", "20th"];
        }
        var out = [];
        out.push({
          name: grades[0] + " " + BabelStr.str(2672),
          id: 0
        });
        for (var i = 1; i <= res.grade; i++) {
          out.push({
            name: grades[i] + " " + BabelStr.str(2672),
            id: i
          });
        }
        success(out);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  getEnterpriseMonthSatistics: function getEnterpriseMonthSatistics(startTime, endTime, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.getEnterpriseMonthSatistics", {
      startTime: startTime,
      endTime: endTime
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.log(res);
        success(res["result"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  getEntFileflowBetween: function getEntFileflowBetween(startTime, endTime, _success, fail) {
    $.ajax({
      type: "POST",
      url: "enterprise/getEntFileflowBetween.do",
      dataType: "json",
      data: {
        startTime: parseInt(startTime),
        endTime: parseInt(endTime)
      },
      success: function success(response) {
        _success(response.flowInfos);
      },
      error: function error(response) {
        c;
        fail(response);
      }
    });
  },
  countAllDepFile: function countAllDepFile(parentDepFolderId, success, fail) {
    // if(parentDepFolderId == '3144804780896656') {
    //   fail()
    //   return
    // } else  if(parentDepFolderId == '5333763153660839') {
    //   return
    // }
    MMEnterpriseController.request("netDrive.statisHandler.countAllDepFile", {
      parentDepFolderId: parentDepFolderId
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.log(res);
        success(res["count"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  getDepartmentActivityFile: function getDepartmentActivityFile(parentDepFolderId, startTime, endTime, success, fail) {
    MMEnterpriseController.request("netDrive.statisHandler.getDepartmentActivityFile", {
      parentDepFolderId: parentDepFolderId,
      startTime: startTime,
      endTime: endTime
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.log(res);
        success(res["list"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  getEnterpriseActivityFile: function getEnterpriseActivityFile(startTime, endTime, success, fail) {
    MMEnterpriseController.request("netDrive.statisHandler.getEnterpriseActivityFile", {
      startTime: startTime,
      endTime: endTime
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.log(res);
        success(res["list"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  countDepFileByExtension: function countDepFileByExtension(parentDepFolderId, success, fail) {
    MMEnterpriseController.request("netDrive.statisHandler.countDepFileByExtension", {
      parentDepFolderId: parentDepFolderId
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.log(res);
        success(res["extensionCount"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  }
}), "mail", {
  getEmailSetting: function getEmailSetting(_success2, fail) {
    $.ajax({
      method: "post",
      url: "/email/getEmailSetting.do",
      success: function success(responseData, textStatus, jqXHR) {
        console.log(responseData);
        if (responseData["success"] === true) {
          _success2(responseData);
        } else {
          fail(responseData);
        }
      }
    });
  },
  getEmailHost: function getEmailHost(email, _success3, fail) {
    $.ajax({
      method: "post",
      url: "/email/getEmailHost.do",
      data: {
        email: email
      },
      success: function success(responseData, textStatus, jqXHR) {
        if (responseData["success"] === true) {
          console.log(responseData);
          _success3(responseData);
        } else {
          fail(responseData);
        }
      }
    });
  },
  enableEmailSetting: function enableEmailSetting(_success4, fail) {
    $.ajax({
      method: "post",
      url: "/email/enableEmailSetting.do",
      success: function success(responseData, textStatus, jqXHR) {
        if (responseData["success"] === true) {
          _success4();
        } else {
          fail();
        }
      }
    });
  },
  pullUserEmail: function pullUserEmail(_success5, fail) {
    $.ajax({
      method: "post",
      url: "/email/pullUserEmail.do",
      success: function success(responseData, textStatus, jqXHR) {
        if (responseData["success"] === true) {
          _success5();
        } else {
          fail();
        }
      }
    });
  },
  initUserEmailSetting: function initUserEmailSetting(data, _success6, fail) {
    $.ajax({
      method: "post",
      url: "/email/initUserEmailSetting.do",
      data: data,
      success: function success(responseData, textStatus, jqXHR) {
        if (responseData["success"] === true) {
          _success6();
        } else {
          fail(responseData);
        }
      }
    });
  }
}), "onlineEquipment", {
  // getOnlineEquipmentInfo: function(success) {
  // let time = new Date();
  // time = time.getTime()/1000;
  // let data = {
  //   lastLoginTime: time,
  //   equipment: {
  //     "name": "huangfu的iPhone6s",
  //     "browserName": "chrome",
  //     "ip": "",
  //     "addr": "",
  //     "browserName": ""
  //   },
  //   onlineEpArr: [
  //     {id: 1, name: "huangfu的iPhone6s", ip: "127.0.0.1", addr: "上海 黄埔区", browserType: "", browserName:"巴别鸟客户端", isCurrentEq: false},
  //     {id: 2, name: "huangfu的iPhone6s", ip: "127.0.0.1", addr: "上海 黄埔区", browserType: "", browserName:"巴别鸟客户端", isCurrentEq: false},
  //     {id: 3, name: "", ip: "127.0.0.1", addr: "上海 黄埔区", browserType: "chrome", browserName:"巴别鸟网页版", isCurrentEq: true},
  //     {id: 4, name: "", ip: "127.0.0.1", addr: "上海 黄埔区", browserType: "firefox", browserName:"巴别鸟网页版", isCurrentEq: true},
  //     {id: 5, name: "", ip: "127.0.0.1", addr: "上海 黄埔区", browserType: "ie", browserName:"巴别鸟网页版", isCurrentEq: true},
  //     {id: 6, name: "", ip: "127.0.0.1", addr: "上海 黄埔区", browserType: "safari", browserName:"巴别鸟网页版", isCurrentEq: true},
  //     {id: 6, name: "", ip: "127.0.0.1", addr: "上海 黄埔区", browserType: "opera", browserName:"巴别鸟网页版", isCurrentEq: true}
  //   ]
  // }
  // success(data)
  getTerminalInfosById: function getTerminalInfosById(userId, success, fail) {
    MMEnterpriseController.request("netDrive.userHandler.getTerminalInfosById", {
      userId: userId
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.log(res);
        success(res["terminals"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  kickUserSession: function kickUserSession(sessionId, success, fail) {
    MMEnterpriseController.request("netDrive.userHandler.kickUserSession", {
      sessionId: sessionId
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.log(res);
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  }
}), "macBind", {
  setOnlyClientLogin: function setOnlyClientLogin(flag, success, fail) {
    flag = flag ? 1 : 0;
    MMEnterpriseController.request("netDrive.enterpriseHandler.setOnlyClientLogin", {
      flag: flag
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.log(res);
        success();
        MMEnterpriseController.refreshSessionInfo();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  setBindMac: function setBindMac(flag, success, fail) {
    flag = flag ? 1 : 0;
    MMEnterpriseController.request("netDrive.enterpriseHandler.setBindMac", {
      flag: flag
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
        MMEnterpriseController.refreshSessionInfo();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  getAllMacPoolsInfo: function getAllMacPoolsInfo(options, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.getAllMacPoolInfo", {
      startIndex: options.startIndex,
      pageSize: options.pageSize
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.log(res);
        success(new _MDMacAddressCollection["default"](res["pools"]));
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  getAllMacPool: function getAllMacPool(options, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.getAllMacPool", {
      startIndex: 0,
      pageSize: 20
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.log(res);
        success(res["pools"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  updateMacPool: function updateMacPool(options, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.updateMacPool", {
      poolId: options.poolId,
      poolName: options.poolName,
      macAddrs: options.macAddress
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.log("mac地址池更新成功");
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  createMacPool: function createMacPool(options, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.createMacPool", {
      poolName: options.poolName,
      macAddrs: options.macAddress
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.log("mac地址池创建成功");
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  removeMacPool: function removeMacPool(poolId, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.removeMacPool", {
      poolId: poolId
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.log("mac地址池删除成功");
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  getPoolAddresses: function getPoolAddresses(poolId, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.getPoolAddresses", {
      poolId: poolId
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.log(res);
        success(res["addresses"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  checkMacPoolNameExists: function checkMacPoolNameExists(poolName, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.checkMacPoolNameExists", {
      poolName: poolName
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.log(res);
        success(res["exists"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  searchMacBind: function searchMacBind(options, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.searchMacBind", {
      options: options
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.log(res);
        success(new _MDMolaUserCollection["default"](res["users"]), res["total"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  bindAddrAndPool: function bindAddrAndPool(options, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.bindAddrAndPool", {
      userIds: options.userIds,
      macAddrs: options.macAddress,
      macPools: options.macPools
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.log(res);
        success(res["exists"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  removeUserMacBind: function removeUserMacBind(userIds, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.removeUserMacBind", {
      userIds: userIds
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.log(res);
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  getBindInfoByUser: function getBindInfoByUser(userId, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.getBindInfoByUser", {
      userId: userId
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.log(res);
        success(res["addresses"], res["pools"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  rebindAddrAndPool: function rebindAddrAndPool(options, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.rebindAddrAndPool", {
      userIds: options.userIds,
      macAddrs: options.macAddress,
      macPools: options.macPools
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.log(res);
        success(res["exists"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  }
}), "generateExcelOfFileStruct", function generateExcelOfFileStruct(fileId, _success7, fail) {
  // window.open("/enterprise/generateExcelOfFileStruct.do?fileId="+ fileId)
  $.ajax({
    method: "post",
    url: "/enterprise/generateExcelOfFileStruct.do",
    data: {
      fileId: fileId
    },
    success: function success(responseData, textStatus, jqXHR) {
      console.log(responseData);
      if (responseData["success"] === true) {
        // success(responseData['token'])
        MMEnterpriseController.getExcelOfFileStruct(responseData["token"], _success7, fail);
      } else {
        fail(responseData);
      }
    }
  });
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_MMEnterpriseControll, "getExcelOfFileStruct", function getExcelOfFileStruct(token, _success8, fail) {
  // window.open("/enterprise/generateExcelOfFileStruct.do?token="+ token)
  $.ajax({
    method: "post",
    url: "/enterprise/getExcelOfFileStruct.do",
    data: {
      token: token
    },
    success: function success(responseData, textStatus, jqXHR) {
      console.log(responseData);
      if (responseData["success"] === true) {
        if (responseData["code"] == 0) {
          if (responseData["status"] == 1) {
            setTimeout(function () {
              MMEnterpriseController.getExcelOfFileStruct(token, _success8, fail);
            }, 6000);
          } else if (responseData["status"] == 0) {
            if (responseData["url"]) {
              _success8(responseData["url"]);
            } else {
              fail({
                msg: BabelStr.str(6763)
              });
            }
          }
        } else {
          var msg = BabelStr.str(7155);
          if (responseData["exception"]) {
            msg = BabelStr.str(6764);
          }
          fail({
            msg: msg
          });
        }
      } else {
        var _msg = BabelStr.str(7155);
        if (responseData["exception"]) {
          _msg = BabelStr.str(6764);
        }
        fail({
          msg: _msg
        });
      }
    }
  });
}), "getMyAppendedPermissionFiles", function getMyAppendedPermissionFiles(success, fail) {
  MMEnterpriseController.request("netDrive.fileHandler.getMyAppendedPermissionFiles", {}, function (res) {
    console.log(res);
    if (res["resultCode"] === 0) {
      var fileInfoCollection = new _MMFileInfoCollection["default"](res["fileArr"]);
      success(fileInfoCollection);
    } else {
      fail(res["resultCode"]);
    }
  });
}), "setManagerLog", function setManagerLog(flag, success, fail) {
  var temp = flag ? 1 : 0;
  MMEnterpriseController.request("netDrive.enterpriseHandler.setHideAdminLog", {
    flag: temp
  }, function (res) {
    if (res["resultCode"] === 0) {
      success();
    } else {
      fail(res["resultCode"]);
    }
  });
}), "setTagLimit", function setTagLimit(flag, success, fail) {
  var temp = flag ? 1 : 0;
  MMEnterpriseController.request("netDrive.enterpriseHandler.setTagLimit", {
    flag: temp
  }, function (res) {
    if (res["resultCode"] === 0) {
      success();
      MMEnterpriseController.refreshSessionInfo();
    } else {
      fail(res["resultCode"]);
    }
  });
}), "getQSendUrl", function getQSendUrl(quickSendId, fileId, _success9, fail) {
  $.ajax({
    method: "post",
    url: "/file/getQSendUrl.do",
    data: {
      quickSendId: quickSendId,
      fileId: fileId
    },
    success: function success(responseData, textStatus, jqXHR) {
      if (responseData["success"] == true) {
        _success9(responseData["url"]);
      } else {
        fail && fail();
      }
    }
  });
}), "isFileNeedWatermarkPreview", function isFileNeedWatermarkPreview(fileId, _success10, fail) {
  $.ajax({
    method: "post",
    url: "/public/isFileNeedWatermarkPreview.do",
    data: {
      fileId: fileId
    },
    success: function success(responseData, textStatus, jqXHR) {
      if (responseData["success"] === true) {
        if (responseData.dotMatrixInfo && responseData.dotMatrixInfo.dotmatrixPayload) {
          responseData.dotMatrixInfo.dotmatrixPayload = _utils["default"].decryptBySes(responseData.dotMatrixInfo.dotmatrixPayload);
        }
        _success10(responseData);
      } else {
        fail(responseData["msg"]);
      }
    }
  });
}), "getSecurityConfidentiality", function getSecurityConfidentiality(success, fail) {
  MMEnterpriseController.request("netDrive.enterpriseHandler.getSecurityConfidentiality", {}, function (res) {
    if (res["resultCode"] === 0) {
      console.log(res);
      _.each(res.groups, function (group) {
        group.userType = 2;
        group.name = group.groupName;
      });
      var out = res["members"].concat(res["groups"]);
      success(out);
    } else {
      fail(res["resultCode"]);
    }
  });
}), "removeSecurityConfidentiality", function removeSecurityConfidentiality(params, success, fail) {
  MMEnterpriseController.request("netDrive.enterpriseHandler.removeSecurityConfidentiality", params, function (res) {
    if (res["resultCode"] === 0) {
      console.log(res);
      success(res);
    } else {
      fail(res["resultCode"]);
    }
  });
}), "addSecurityConfidentiality", function addSecurityConfidentiality(params, success, fail) {
  MMEnterpriseController.request("netDrive.enterpriseHandler.addSecurityConfidentiality", params, function (res) {
    if (res["resultCode"] === 0) {
      console.log(res);
      success(res);
    } else {
      fail(res["resultCode"]);
    }
  });
}), "getSecurityAssessor", function getSecurityAssessor(success, fail) {
  MMEnterpriseController.request("netDrive.enterpriseHandler.getSecurityAssessor", {}, function (res) {
    if (res["resultCode"] === 0) {
      console.log(res);
      _.each(res.groups, function (group) {
        group.userType = 2;
        group.name = group.groupName;
      });
      var out = res["members"].concat(res["groups"]);
      success(out);
    } else {
      fail(res["resultCode"]);
    }
  });
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_MMEnterpriseControll, "getOperationsManager", function getOperationsManager(success, fail) {
  MMEnterpriseController.request("netDrive.enterpriseHandler.getOperationsManager", {}, function (res) {
    if (res["resultCode"] === 0) {
      console.log(res);
      _.each(res.groups, function (group) {
        group.userType = 2;
        group.name = group.groupName;
      });
      var out = res["members"].concat(res["groups"]);
      success(out);
    } else {
      fail(res["resultCode"]);
    }
  });
}), "removeSecurityAssessor", function removeSecurityAssessor(params, success, fail) {
  MMEnterpriseController.request("netDrive.enterpriseHandler.removeSecurityAssessor", params, function (res) {
    if (res["resultCode"] === 0) {
      console.log(res);
      success(res);
    } else {
      fail(res["resultCode"]);
    }
  });
}), "removeOperationsManager", function removeOperationsManager(params, success, fail) {
  MMEnterpriseController.request("netDrive.enterpriseHandler.removeOperationsManager", params, function (res) {
    if (res["resultCode"] === 0) {
      console.log(res);
      success(res);
    } else {
      fail(res["resultCode"]);
    }
  });
}), "addSecurityAssessor", function addSecurityAssessor(params, success, fail) {
  MMEnterpriseController.request("netDrive.enterpriseHandler.addSecurityAssessor", params, function (res) {
    if (res["resultCode"] === 0) {
      console.log(res);
      success(res);
    } else {
      fail(res["resultCode"]);
    }
  });
}), "addOperationsManager", function addOperationsManager(params, success, fail) {
  MMEnterpriseController.request("netDrive.enterpriseHandler.addOperationsManager", params, function (res) {
    if (res["resultCode"] === 0) {
      console.log(res);
      success(res);
    } else {
      fail(res["resultCode"]);
    }
  });
}), "answerRequestForShareApprove", function answerRequestForShareApprove(option, requestShareId, acceptedApproveIds, roleId, success, fail) {
  MMEnterpriseController.request("netDrive.shareHandler.answerRequestForShareApprove", {
    requestShareId: requestShareId,
    acceptedApproveIds: acceptedApproveIds,
    option: option,
    roleId: roleId
  }, function (res) {
    if (res["resultCode"] === 0) {
      console.log("同意请求");
      success();
    } else {
      console.log("同意请求出错了");
      fail(res["resultCode"]);
    }
  });
}), "getSecretLevelsForFile", function getSecretLevelsForFile(fileId, success, fail) {
  MMEnterpriseController.request("netDrive.fileHandler.getSecretLevelsForFile", {
    fileId: fileId
  }, function (res) {
    if (res["resultCode"] === 0) {
      console.log("获取文件密级成功");
      var secretLevels = res["secretLevels"];
      var lan = BabelStr.getCurrentLanguage();
      if (lan == "en") {
        _.each(secretLevels, function (secretLevel) {
          secretLevel.comment = secretLevel.commentEn;
        });
      }
      success(secretLevels, res["curLevelSetted"]);
    } else {
      fail(res["resultCode"]);
    }
  });
}), "setFileSecret", function setFileSecret(fileId, secretLevel, success, fail, params) {
  MMEnterpriseController.request("netDrive.fileHandler.setFileSecret", {
    fileId: fileId,
    secretLevel: secretLevel,
    coverAll: params && params.coverAll || false
  }, function (res) {
    if (res["resultCode"] === 0) {
      console.log("设置文件密级成功");
      success();
    } else {
      fail();
    }
  });
}), "getAllSecretLevels", function getAllSecretLevels(success, fail) {
  MMEnterpriseController.request("netDrive.fileHandler.getAllSecretLevels", {}, function (res) {
    if (res["resultCode"] === 0) {
      console.log(res);
      var secretLevels = res["secretLevels"];
      var lan = BabelStr.getCurrentLanguage();
      if (lan == "en") {
        _.each(secretLevels, function (secretLevel) {
          secretLevel.comment = secretLevel.commentEn;
        });
      }
      success(secretLevels);
    } else {
      fail();
    }
  });
}), "getAppendPermissionUserList", function getAppendPermissionUserList(fileId, startIndex, pageSize, searchKey, success, fail) {
  MMEnterpriseController.request("netDrive.fileHandler.getAppendPermissionUserList", {
    fileId: fileId,
    searchKey: searchKey,
    startIndex: startIndex,
    pageSize: pageSize
  }, function (res) {
    if (res["resultCode"] === 0) {
      console.log(res);
      var userInfos = _.map(res["userInfos"], function (user) {
        user.name = user.name || user.groupName;
        if (user.userType == 1) {
          user.type = 4;
        } else if (user.userType == 2) {
          user.type = 2;
        } else {
          user.type = 0;
        }
        // user.type = user.userType == 1 ;
        return user;
      });
      success(userInfos, res["total"], res["all"], res["sub_inheritance"]);
    } else {
      fail();
    }
  });
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_MMEnterpriseControll, "setFileExPermissionInheritation", function setFileExPermissionInheritation(fileId, sub_inheritance, success, fail) {
  MMEnterpriseController.request("netDrive.fileHandler.setFileExPermissionInheritation", {
    fileId: fileId,
    sub_inheritance: sub_inheritance
  }, function (res) {
    if (res["resultCode"] === 0) {
      success();
    } else {
      fail(res);
    }
  });
}), "getDepartmentSecurityPolicy", function getDepartmentSecurityPolicy(depId, success, fail) {
  MMEnterpriseController.request("netDrive.enterpriseHandler.getDepartmentSecurityPolicy", {
    departmentId: depId
  }, function (res) {
    if (res["resultCode"] === 0) {
      var policy = res["policy"];
      var lan = BabelStr.getCurrentLanguage();
      if (policy && lan == "en") {
        policy.name = policy.nameEn;
        policy.comment = policy.commentEn;
      }
      success(policy);
    } else {
      fail();
    }
  });
}), "setDepartmentSecurityPolicy", function setDepartmentSecurityPolicy(policyId, depId, success, fail) {
  MMEnterpriseController.request("netDrive.enterpriseHandler.setDepartmentSecurityPolicy", {
    departmentId: depId,
    policyId: policyId
  }, function (res) {
    if (res["resultCode"] === 0) {
      success();
    } else {
      fail();
    }
  });
}), "removeDepartmentSecurityPolicy", function removeDepartmentSecurityPolicy(depId, success, fail) {
  MMEnterpriseController.request("netDrive.enterpriseHandler.removeDepartmentSecurityPolicy", {
    departmentId: depId
  }, function (res) {
    if (res["resultCode"] === 0) {
      success();
    } else {
      fail();
    }
  });
}), "getEnterpriseSecurityPolicy", function getEnterpriseSecurityPolicy(success, fail) {
  MMEnterpriseController.request("netDrive.enterpriseHandler.getEnterpriseSecurityPolicy", {}, function (res) {
    if (res["resultCode"] === 0) {
      var lan = BabelStr.getCurrentLanguage();
      if (lan == "en") {
        res["policy"]["name"] = res["policy"]["nameEn"];
        res["policy"]["comment"] = res["policy"]["commentEn"];
      }
      success(res["policy"]);
    } else {
      fail();
    }
  });
}), "setEnterpriseSecurityPolicy", function setEnterpriseSecurityPolicy(policyId, success, fail) {
  MMEnterpriseController.request("netDrive.enterpriseHandler.setEnterpriseSecurityPolicy", {
    policyId: policyId
  }, function (res) {
    if (res["resultCode"] === 0) {
      success(res);
    } else {
      fail();
    }
  });
}), "getAllSecurityPolicy", function getAllSecurityPolicy(success, fail) {
  MMEnterpriseController.request("netDrive.enterpriseHandler.getAllSecurityPolicy", {}, function (res) {
    if (res["resultCode"] === 0) {
      var policies = res["policies"];
      var lan = BabelStr.getCurrentLanguage();
      if (lan == "en") {
        _.each(policies, function (policie) {
          policie.name = policie.nameEn;
          policie.comment = policie.commentEn;
        });
      }
      success(policies);
    } else {
      fail();
    }
  });
}), "isPhoneRegistered", function isPhoneRegistered(phone, success, fail) {
  MMEnterpriseController.request("netDrive.userHandler.isPhoneRegistered", {
    phone: phone
  }, function (res) {
    if (res["resultCode"] === 0) {
      // console.log(res)
      success(res["registered"]);
    } else {
      fail();
    }
  });
}), "isEmailRegistered", function isEmailRegistered(email, success, fail) {
  MMEnterpriseController.request("netDrive.userHandler.isEmailRegistered", {
    email: email
  }, function (res) {
    if (res["resultCode"] === 0) {
      success(res["registered"]);
    } else {
      fail();
    }
  });
}), "getFilePathTree", function getFilePathTree(options, success, fail) {
  MMEnterpriseController.request("netDrive.fileHandler.getFilePathTree", {
    fileId: options.fileId.toString(),
    pathIds: options.pathIds,
    tyoe: options.type,
    forMove: options.forMove,
    files2move: options.files2move
  }, function (res) {
    if (res["resultCode"] === 0) {
      success(res["tree"]);
    } else {
      fail();
    }
  });
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_MMEnterpriseControll, "getRootDepartment", function getRootDepartment(success, fail) {
  MMEnterpriseController.request("netDrive.enterpriseHandler.getRootDepartment", function (res) {
    if (res["resultCode"] === 0) {
      success(res["department"]);
    } else {
      fail(res["resultCode"]);
    }
  });
}), "getRootDepartmentFolder", function getRootDepartmentFolder(success, fail) {
  MMEnterpriseController.request("netDrive.fileHandler.getRootDepartmentFolder", function (res) {
    if (res["resultCode"] === 0) {
      var file = res["file"];
      var fileInfo = new _MMFileInfo["default"](file);
      success(fileInfo);
    } else {
      fail(res["resultCode"]);
    }
  });
}), "getFilePathTreeInDep", function getFilePathTreeInDep(options, success, fail) {
  MMEnterpriseController.request("netDrive.fileHandler.getFilePathTreeInDep", {
    depFolderId: options.depFolderId + "",
    pathIds: options.pathIds
  }, function (res) {
    if (res["resultCode"] === 0) {
      success(res["tree"]);
    } else {
      fail(res["resultCode"]);
    }
  });
}), "getEnterpriseFileLog", function getEnterpriseFileLog(parameters, success, fail) {
  // MDLoadMaskView.show();
  _czc && _czc.push(["_trackEvent", "报表", "下载系统访问日志", "", "", ""]);
  MMEnterpriseController.request("netDrive.fileHandler.getEnterpriseFileLogNew", {
    keyword: parameters.keyword,
    departmentId: parameters.departmentId,
    departmentName: parameters.departmentName,
    typesStr: parameters.typesStr,
    // "roleId": parameters.roleId,
    types: parameters.types,
    startTime: parameters.startTime,
    endTime: parameters.endTime,
    startIndex: parameters.startIndex,
    pageSize: parameters.pageSize
  }, function (res) {
    if (res["resultCode"] === 0) {
      var out = new _MDFileLogCollection["default"]();
      if (res["logs"]) {
        res["logs"].forEach(function (log) {
          var filelog = new _MDFileLog["default"](log);
          var userId = filelog.getUserId();
          // let departments = res["memberByUid"][userId];
          // filelog.set("departments", departments);
          out.push(filelog);
        });
      }
      success(out, res["total"]);
    } else {
      fail();
    }
  });

  // setBabelTimeout(()=>{
  //   MDLoadMaskView.remove();
  // }, 1000)
}), "downloadFilelog", function downloadFilelog(parameters, successCb, fail) {
  // window.downloadingPanel.setDownloadItem(BabelStr.str(6767));

  // MDLoadMaskView.show();
  _czc && _czc.push(["_trackEvent", "报表", "下载文件访问日志", "", "", ""]);
  var url = location.origin + "/enterprise/getFileAccessLog.do";
  url = url + "?types=" + (parameters.types ? parameters.types : 0) + (parameters.keyword ? "&keyword=" + parameters.keyword : "") + (parameters.departmentId ? "&departmentId=" + parameters.departmentId : "") + "&departmentName=" + (parameters.departmentName ? parameters.departmentName : "所有部门") + (parameters.typesStr ? "&typesStr=" + parameters.typesStr : "") + "&startTime=" + (parameters.startTime ? parameters.startTime : 0) + "&endTime=" + (parameters.endTime ? parameters.endTime : 0) + "&frontPage=" + parameters.frontPage;
  $.ajax({
    url: url,
    success: function success(responseData, textStatus, jqXHR) {
      if (responseData["success"] === true) {
        successCb && successCb();
      } else {
        fail && fail(responseData);
      }
    }
  });
  MMEnterpriseController.showExportMsg();
}), "getFileAccessLogStatusForFirst", function getFileAccessLogStatusForFirst(token, _success11, fail) {
  // window.open("/enterprise/generateExcelOfFileStruct.do?token="+ token)
  $.ajax({
    method: "post",
    url: "/enterprise/getFileAccessLogStatus.do",
    data: {
      token: token
    },
    success: function success(responseData, textStatus, jqXHR) {
      console.log(responseData);
      if (responseData["success"] === true) {
        if (responseData["code"] == 0) {
          _success11(true);
        } else {
          _success11(false);
        }
      } else {
        _success11(false);
      }
    }
  });
}));
Object.assign(MMEnterpriseController, _part["default"], _part2["default"], _part3["default"], _part4["default"], _part5["default"]);
window.MMEnterpriseController = MMEnterpriseController;
var _default = exports["default"] = MMEnterpriseController;

},{"108":108,"1099":1099,"1100":1100,"1101":1101,"1102":1102,"1103":1103,"1150":1150,"1180":1180,"1184":1184,"1412":1412,"1418":1418,"1426":1426,"1437":1437,"1439":1439,"1451":1451,"1454":1454,"1463":1463,"1466":1466,"1478":1478,"1537":1537,"1541":1541,"17":17,"256":256,"257":257,"267":267,"273":273,"292":292,"297":297,"298":298}],1103:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1463);
require(1471);
require(1423);
require(1487);
require(1538);
require(1543);
require(1418);
require(1537);
require(1431);
var _utils = _interopRequireDefault(require(108));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MMNormalCollection = _interopRequireDefault(require(305));
var out = {
  getGuestICanSee: function getGuestICanSee() {
    return new Promise(function (resolve, reject) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.getGuestICanSee", {}, function (res) {
        console.log("getGuestICanSee 调用了后台");
        if (res && res["resultCode"] === 0) {
          var memberCollection = new _MDMolaUserCollection["default"](res["members"]);
          var status = res["status"];
          resolve({
            members: memberCollection,
            status: status
          });
        } else {
          reject(res ? res["resultCode"] : new Error('Request failed'));
        }
      });
    });
  },
  getGroups: function getGroups() {
    return new Promise(function (resolve, reject) {
      MMEnterpriseController.request("netDrive.shareHandler.getGroups", {}, function (res) {
        console.log("getGroups 调用了后台");
        if (res["resultCode"] === 0) {
          var groups = res["groups"];
          var _out = [{
            groupId: "publicGroup",
            groupName: BabelStr.str(2362),
            // "企业公共分组",
            groupMembers: []
          }, {
            groupId: "privateGroup",
            groupName: BabelStr.str(2384),
            // "个人分组",
            groupMembers: []
          }];
          _.each(groups, function (groupItem) {
            if (groupItem["belongToEnterprise"]) {
              _out[0]["groupMembers"].push(groupItem);
            } else {
              _out[1]["groupMembers"].push(groupItem);
            }
          });
          resolve({
            groupsArr: _out,
            rawGroups: res["groups"]
          });
        } else {
          reject(res["resultCode"]);
        }
      });
    });
  },
  getDepartmentMembersAndSubDep: function getDepartmentMembersAndSubDep(departmentId) {
    return new Promise(function (resolve, reject) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.getDepartmentMembersAndSubDep", {
        departmentId: departmentId
      }, function (res) {
        console.log("GetDepartmentMembersAndSubDep 调用了后台");
        if (res["resultCode"] === 0) {
          resolve(res); // 成功时返回完整响应
        } else {
          reject(res["message"]); // 失败时返回错误信息
        }
      });
    });
  },
  getCustomIcon4File: function getCustomIcon4File(fileId) {
    return fetch('/netdrive/getCustomIcon4File.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams({
        fileId: fileId
      })
    }).then(function (response) {
      if (!response.ok) return {};
      return response.json();
    })["catch"](function (error) {
      console.error("---- error call ajax", error);
      return {};
    });
  },
  getEntCustoms: function getEntCustoms(successCB, failCb) {
    $.ajax('/enterprise/getCustomAttrs4Ent.do', {
      method: 'post',
      data: {},
      success: function success(responseData) {
        console.warn(responseData);
        if (responseData.success) {
          var customAttrs = responseData.customAttrs || [];
          customAttrs.forEach(function (attr) {
            if (attr.altEntries) {
              attr.altEntries.sort(function (a, b) {
                var _a$v_order, _b$v_order;
                return ((_a$v_order = a.v_order) !== null && _a$v_order !== void 0 ? _a$v_order : 0) - ((_b$v_order = b.v_order) !== null && _b$v_order !== void 0 ? _b$v_order : 0);
              });
            }
          });
          var _out2 = new _MMNormalCollection["default"](responseData.customAttrs);
          _.isFunction(successCB) && successCB(_out2);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(responseData) {
        _.isFunction(failCb) && failCb(responseData);
      }
    });
  },
  // 获取当前企业的扫描备份策略列表（接口层直接返回 MMNormalCollection，与 getAllMember 风格一致）
  getScanBackupPolicies: function getScanBackupPolicies(successCB, failCb) {
    $.ajax('/enterprise/getScanBackupPolicies.do', {
      method: 'post',
      data: {},
      success: function success(responseData) {
        console.log('getScanBackupPolicies 返回:', responseData);
        if (responseData.success) {
          var policies = new _MMNormalCollection["default"](responseData.list || []);
          _.isFunction(successCB) && successCB(policies, responseData.total);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(responseData) {
        console.error('getScanBackupPolicies 请求失败:', responseData);
        _.isFunction(failCb) && failCb(responseData);
      }
    });
  },
  // 统计备份文件数量与大小（policyRunning 执行中策略数 / policyDraft 草稿数 / policyStop 停用数 / fileCount 文件数 / fileSize 总字节数）
  // 返回兼容顶层字段与 countInfo 嵌套两种结构（同 countUserScanbackupFiles 的包装风格）
  countBackupFiles: function countBackupFiles() {
    return new Promise(function (resolve, reject) {
      MMEnterpriseController.request("netDrive.fileExHandler.countBackupFiles", {}, function (res) {
        console.log("countBackupFiles 返回:", res);
        if (res && res["resultCode"] === 0) {
          resolve(res["countInfo"] || res);
        } else {
          reject(res ? res["resultCode"] : new Error('Request failed'));
        }
      });
    });
  },
  // 统计单个用户的备份文件：countInfo.userRoot 备份根目录，countInfo.userComputers[] 各设备 count/size（字符串）
  countUserScanbackupFiles: function countUserScanbackupFiles(userId) {
    return new Promise(function (resolve, reject) {
      MMEnterpriseController.request("netDrive.enterpriseExHandler.countUserScanbackupFiles", {
        userId: userId
      }, function (res) {
        console.log("countUserScanbackupFiles 调用了后台");
        if (res && res["resultCode"] === 0) {
          resolve(res);
        } else {
          reject(res ? res["resultCode"] : new Error('Request failed'));
        }
      });
    });
  },
  // 获取企业扫描备份根目录（没有记录时由服务层生成新 fileId 并写入）
  getScanBkRootFile: function getScanBkRootFile(successCB, failCb) {
    $.ajax('/enterprise/getScanBkRootFile.do', {
      method: 'post',
      data: {},
      success: function success(responseData) {
        console.log('getScanBkRootFile 返回:', responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData.fileInfo);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(responseData) {
        console.error('getScanBkRootFile 请求失败:', responseData);
        _.isFunction(failCb) && failCb(responseData);
      }
    });
  },
  // 创建扫描备份策略，params 字段见 createScanBackupPolicyAction（policyName/rootFolder 必填）
  createScanBackupPolicy: function createScanBackupPolicy(params, successCB, failCb) {
    $.ajax('/enterprise/createScanBackupPolicy.do', {
      method: 'post',
      data: params,
      success: function success(responseData) {
        console.log('createScanBackupPolicy 返回:', responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(responseData) {
        console.error('createScanBackupPolicy 请求失败:', responseData);
        _.isFunction(failCb) && failCb(responseData);
      }
    });
  },
  // 按 id 更新扫描备份策略（需传全部策略字段，scanPolicyId/policyName/rootFolder 必填；不更新备份人员）
  updateScanBackupPolicy: function updateScanBackupPolicy(params, successCB, failCb) {
    $.ajax('/enterprise/updateScanBackupPolicy.do', {
      method: 'post',
      data: params,
      success: function success(responseData) {
        console.log('updateScanBackupPolicy 返回:', responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(responseData) {
        console.error('updateScanBackupPolicy 请求失败:', responseData);
        _.isFunction(failCb) && failCb(responseData);
      }
    });
  },
  // 按 id 删除扫描备份策略（后端同时清理部门/账号/分组/设备关联表）
  deleteScanBackupPolicy: function deleteScanBackupPolicy(params, successCB, failCb) {
    $.ajax('/enterprise/deleteScanBackupPolicy.do', {
      method: 'post',
      data: params,
      success: function success(responseData) {
        console.log('deleteScanBackupPolicy 返回:', responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(responseData) {
        console.error('deleteScanBackupPolicy 请求失败:', responseData);
        _.isFunction(failCb) && failCb(responseData);
      }
    });
  },
  // 为策略批量添加备份人员（backupUserIds 逗号分隔，按 backupUserType 写入对应关联表；update 接口不动人员，编辑后用它同步范围）
  addScanBackupUsers: function addScanBackupUsers(params, successCB, failCb) {
    $.ajax('/enterprise/addScanBackupUsers.do', {
      method: 'post',
      data: params,
      success: function success(responseData) {
        console.log('addScanBackupUsers 返回:', responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(responseData) {
        console.error('addScanBackupUsers 请求失败:', responseData);
        _.isFunction(failCb) && failCb(responseData);
      }
    });
  },
  // 删除策略的备份人员：传 backupUserId 删除单条，不传则删除该策略该类型全部
  deleteScanBackupUsers: function deleteScanBackupUsers(params, successCB, failCb) {
    $.ajax('/enterprise/deleteScanBackupUsers.do', {
      method: 'post',
      data: params,
      success: function success(responseData) {
        console.log('deleteScanBackupUsers 返回:', responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(responseData) {
        console.error('deleteScanBackupUsers 请求失败:', responseData);
        _.isFunction(failCb) && failCb(responseData);
      }
    });
  },
  // 按类型获取策略的备份人员信息（scanPolicyId + backupUserType，返回 list/total；设备类型暂返回空列表）
  getBackupUserInfos: function getBackupUserInfos(params, successCB, failCb) {
    $.ajax('/enterprise/getBackupUserInfos.do', {
      method: 'post',
      data: params,
      success: function success(responseData) {
        console.log('getBackupUserInfos 返回:', responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData.list || [], responseData.total);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(responseData) {
        console.error('getBackupUserInfos 请求失败:', responseData);
        _.isFunction(failCb) && failCb(responseData);
      }
    });
  },
  // 获取分组覆盖的账号 ids（groupIds 逗号分隔字符串；返回 userIds 为账号 id 字符串数组）
  getAllUserIdsInGroups: function getAllUserIdsInGroups(groupIds) {
    return new Promise(function (resolve, reject) {
      MMEnterpriseController.request("netDrive.statisHandler.getAllUserIdsInGroups", {
        groupIds: groupIds
      }, function (res) {
        console.log('getAllUserIdsInGroups 返回:', res);
        if (res && res["resultCode"] === 0) {
          resolve(res["userIds"] || []);
        } else {
          reject(res ? res["resultCode"] : new Error('Request failed'));
        }
      });
    });
  },
  // 获取部门覆盖的账号 ids（depIds 逗号分隔字符串；返回 userIds 为 {userId} 对象数组）
  getAllUserIdsInDepartments: function getAllUserIdsInDepartments(depIds) {
    return new Promise(function (resolve, reject) {
      MMEnterpriseController.request("netDrive.enterpriseExHandler.getAllUserIdsInDepartments", {
        depIds: depIds
      }, function (res) {
        console.log('getAllUserIdsInDepartments 返回:', res);
        if (res && res["resultCode"] === 0) {
          resolve(res["userIds"] || []);
        } else {
          reject(res ? res["resultCode"] : new Error('Request failed'));
        }
      });
    });
  },
  // 获取单个用户的扫描备份策略（userId 不传则查当前登录人；查他人需管理员身份）
  // 返回 scanBackupPolicy（含 name/rootFolder/exts/running/backupAccessToken 等），用户无策略时为 undefined
  getScanPolicyForUser: function getScanPolicyForUser(userId, successCB, failCb) {
    $.ajax('/enterprise/getScanPolicyForUser.do', {
      method: 'post',
      data: {
        userId: userId
      },
      success: function success(responseData) {
        console.log('getScanPolicyForUser 返回:', responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData.scanBackupPolicy);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(responseData) {
        console.error('getScanPolicyForUser 请求失败:', responseData);
        _.isFunction(failCb) && failCb(responseData);
      }
    });
  }
};
out.dedupGetGuestICanSee = _utils["default"].createDeduplicatedRequest(out.getGuestICanSee, {
  cacheTTL: 5000
} // 缓存 5 秒
);
out.dedupGetGroups = _utils["default"].createDeduplicatedRequest(out.getGroups, {
  cacheTTL: 5000
} // 缓存 5 秒
);
out.dedupGetDepartmentMembersAndSubDep = _utils["default"].createDeduplicatedRequest(out.getDepartmentMembersAndSubDep, {
  cacheTTL: 5000
} // 缓存 5 秒
);
out.dedupGetGetCustomIcon4File = _utils["default"].createDeduplicatedRequest(out.getCustomIcon4File, {
  cacheTTL: 5000
} // 缓存 5 秒
);
out.dedupGetEntCustoms = _utils["default"].createDeduplicatedRequest(out.getEntCustoms, {
  cacheTTL: 5000
} // 缓存 5 秒
);
var _default = exports["default"] = out;

},{"108":108,"1184":1184,"1418":1418,"1423":1423,"1431":1431,"1454":1454,"1463":1463,"1471":1471,"1487":1487,"1537":1537,"1538":1538,"1543":1543,"273":273,"305":305}],1102:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require(1180));
var _slicedToArray2 = _interopRequireDefault(require(1192));
require(1429);
require(1432);
require(1541);
require(1412);
require(1461);
require(1439);
require(1424);
require(1423);
require(1463);
require(1487);
require(1538);
require(1545);
require(1543);
require(1471);
require(1418);
require(1537);
require(1455);
var _MDArchiveCollection = _interopRequireDefault(require(240));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MMFileInfo = _interopRequireDefault(require(297));
var _MMFileInfoCollection = _interopRequireDefault(require(298));
var _MMNormal = _interopRequireDefault(require(304));
var _MMNormalCollection = _interopRequireDefault(require(305));
var _getReviewConfig4File;
var _default = exports["default"] = (_getReviewConfig4File = {
  getReviewConfig4File: function getReviewConfig4File(fileId, success, fail) {
    var route = "netDrive.fileExHandler.getReviewConfig4File";
    _MMEnterpriseController["default"].request(route, {
      fileId: fileId
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success(res["config"]);
      }
    });
  },
  addFileWhiteList: function addFileWhiteList(ext, successCB, failCb) {
    $.ajax({
      url: "/enterprise/addFileWhiteList.do",
      method: "post",
      data: {
        ext: ext
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB();
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  getFileWhiteList: function getFileWhiteList(successCB, failCb) {
    $.ajax({
      url: "/enterprise/getFileWhiteList.do",
      method: "post",
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData["exts"]);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  setSendFilePersonalReview: function setSendFilePersonalReview(sendId, reviewResult, success, fail) {
    var route = "netDrive.fileExHandler.setSendFilePersonalReview";
    _MMEnterpriseController["default"].request(route, {
      sendId: sendId,
      reviewResult: reviewResult
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  restoreSelectedFilesInTrash: function restoreSelectedFilesInTrash(deleteVersionIds, fidArr, trashType, success, fail) {
    var route = "netDrive.fileHandler.restoreSelectedFilesInTrash";
    var step = 20; // 一次最多恢复20个文件
    var renamedList = [];
    var copiedVersionIds = [];
    var copiedFileIds = [];
    if (deleteVersionIds) {
      copiedVersionIds = deleteVersionIds.slice(0, deleteVersionIds.length);
    }
    if (fidArr) {
      copiedFileIds = fidArr.slice(0, fidArr.length);
    }
    var callRestore = function callRestore() {
      console.warn("copiedFileIds.length: " + copiedFileIds.length, "copiedVersionIds.length: " + copiedVersionIds.length);
      if (copiedFileIds.length > 0 || copiedVersionIds.length > 0) {
        var _stepFids = copiedFileIds.splice(0, step);
        var _stepVersionIds = copiedVersionIds.splice(0, step);
        _MMEnterpriseController["default"].request(route, {
          trashType: trashType,
          fidArr: _stepFids,
          deleteVersionIds: _stepVersionIds
        }, function (res) {
          var errors = res["errors"] || [];
          if (res["resultCode"] === 0 && errors.length === 0) {
            if (copiedFileIds.length > 0 || copiedVersionIds.length > 0) {
              setTimeout(function () {
                callRestore();
              }, 100);
            } else {
              success([]);
              if (renamedList.length > 0) {
                MDAlertView.showRenamedFileList(renamedList);
              }
            }
          } else {
            // map the errors, so outside no brackets are needed
            for (var i = 0; i < errors.length; i++) {
              errors[i] = {
                fid: errors[i]["fid"],
                code: errors[i]["code"],
                msg: errors[i]["msg"]
              };
            }
            fail(res["resultCode"], res["message"], errors, res["finished"]);
          }
          if (res["renameList"]) {
            renamedList = renamedList.concat(res["renameList"]);
          }
        });
      } else {
        success([]);
        if (renamedList.length > 0) {
          MDAlertView.showRenamedFileList(renamedList);
        }
      }
    };
    callRestore();
  },
  removeReviewConfig4File: function removeReviewConfig4File(reviewId, success, fail) {
    var route = "netDrive.fileExHandler.removeReviewConfig4File";
    _MMEnterpriseController["default"].request(route, {
      reviewId: reviewId
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  addReviewConfig4File: function addReviewConfig4File(fileIds, reviewerIds, reviewType, options, success, fail) {
    var route = "netDrive.fileExHandler.addReviewConfig4File";
    _MMEnterpriseController["default"].request(route, {
      fileIds: fileIds,
      reviewerIds: reviewerIds,
      reviewType: reviewType,
      options: options
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  updateReviewConfig4File: function updateReviewConfig4File(reviewId, addReviewerId, delReviewerId, reviewType, options, success, fail) {
    var route = "netDrive.fileExHandler.updateReviewConfig4File";
    _MMEnterpriseController["default"].request(route, {
      reviewId: reviewId,
      addReviewerId: addReviewerId,
      delReviewerId: delReviewerId,
      reviewType: reviewType,
      options: options
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  canAddDepartmentMember: function canAddDepartmentMember(departmentId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.canAddDepartmentMember", {
      departmentId: departmentId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["can"]);
      } else {
        fail();
      }
    });
  },
  getEnterpriseUsedSpace: function getEnterpriseUsedSpace(enforceRefresh, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.getEnterpriseUsedSpace", {
      enforceRefresh: enforceRefresh
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["usedSpace"]);
      } else {
        fail();
      }
    });
  },
  getMyDepartmentInfos: function getMyDepartmentInfos(onlyFileId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.getMyDepartmentInfos", {
      onlyFileId: onlyFileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["fileIds"]);
      } else {
        fail();
      }
    });
  },
  updateUserExtraAttr: function updateUserExtraAttr(extraAttr, _success, fail) {
    $.ajax({
      method: "post",
      url: "/user/updateUserExtraAttr.do",
      data: {
        extraAttr: extraAttr
      },
      success: function success(responseData, textStatus, jqXHR) {
        if (responseData["success"] === true) {
          _.isFunction(_success) && _success();
        } else {
          fail(responseData);
        }
      }
    });
  },
  getMaterialLibrary: function getMaterialLibrary(_success2, fail) {
    $.ajax({
      method: "post",
      url: "/enterprise/getMaterialLibrary.do",
      data: {},
      success: function success(responseData, textStatus, jqXHR) {
        if (responseData["success"] === true) {
          _.isFunction(_success2) && _success2(responseData['materialLibrary']);
        } else {
          fail(responseData);
        }
      }
    });
  },
  initMaterialLibrary: function initMaterialLibrary(_success3, fail) {
    $.ajax({
      method: "post",
      url: "/enterprise/initMaterialLibrary.do",
      data: {},
      success: function success(responseData, textStatus, jqXHR) {
        if (responseData["success"] === true) {
          console.log(responseData);
          _.isFunction(_success3) && _success3(responseData['materialLibrary']);
        } else {
          fail(responseData);
        }
      }
    });
  },
  isUserCanAccessMaterialLibrary: function isUserCanAccessMaterialLibrary(userId, success, fail) {
    var route = "netDrive.materialHandler.isUserCanAccessMaterialLibrary";
    _MMEnterpriseController["default"].request(route, {
      userId: userId
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success(res['canAccessMaterialLibrary']);
      }
    });
  },
  setUserCanAccessMaterialLibrary: function setUserCanAccessMaterialLibrary(userId, can, success, fail) {
    var route = "netDrive.materialHandler.setUserCanAccessMaterialLibrary";
    _MMEnterpriseController["default"].request(route, {
      userId: userId,
      can: can
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  getUserOptionsAsEntMember: function getUserOptionsAsEntMember(userId, success, fail) {
    var route = "netDrive.enterpriseHandler.getUserOptionsAsEntMember";
    _MMEnterpriseController["default"].request(route, {
      userId: userId
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success(res['memberOptions']);
      }
    });
  },
  setUserOptionsAsEntMemberByBit: function setUserOptionsAsEntMemberByBit(userIds, position, flag, success, fail) {
    var route = "netDrive.enterpriseHandler.setUserOptionsAsEntMemberByBit";
    _MMEnterpriseController["default"].request(route, {
      userIds: userIds,
      position: position,
      flag: flag
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success(res['memberOptions']);
      }
    });
  },
  // {
  //   destDirFileId: 5774667615096642,
  //   name: "原神",
  //   accessType: 1,
  //   managerIds: [11302078],
  //   departmentIds: [2317]
  // },
  createMaterialClass: function createMaterialClass(params, success, fail) {
    var route = "netDrive.materialHandler.createMaterialClass";
    _MMEnterpriseController["default"].request(route, params, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success(res['materialClass']);
      }
    });
  },
  getMaterialClassDispInfo: function getMaterialClassDispInfo(fileId, success, fail) {
    var route = "netDrive.materialHandler.getMaterialClassDispInfo";
    _MMEnterpriseController["default"].request(route, {
      fileId: fileId
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success(res['materialClassDispInfo']);
      }
    });
  },
  updateMaterialClass: function updateMaterialClass(params, success, fail) {
    var route = "netDrive.materialHandler.updateMaterialClass";
    _MMEnterpriseController["default"].request(route, params, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success(res['materialClass']);
      }
    });
  },
  // {
  //   destDirFileId: 5774667615096642,
  //   name: "黑神话素材",
  //   accessType: 0,
  //   managerIds: [11302078],
  //   assistantIds: [],
  //   option: 0,
  //   dueTime: null,
  //   nextAccessType: null,
  //   memberInfos: [{userId: 30158, roleId:15}]
  // }

  createMaterialFolder: function createMaterialFolder(params, success, fail) {
    var route = "netDrive.materialHandler.createMaterialFolder";
    _MMEnterpriseController["default"].request(route, params, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success(res['materialFolder']);
      }
    });
  },
  getMaterialManagers: function getMaterialManagers(fileId, success, fail) {
    var route = "netDrive.materialHandler.getMaterialManagers";
    _MMEnterpriseController["default"].request(route, {
      fileId: fileId
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success(res['managerInfos']);
      }
    });
  },
  getMaterialFolderDispInfo: function getMaterialFolderDispInfo(fileId, success, fail) {
    var route = "netDrive.materialHandler.getMaterialFolderDispInfo";
    _MMEnterpriseController["default"].request(route, {
      fileId: fileId
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success(res['materialFolderDispInfo']);
      }
    });
  },
  updateMaterialFolder: function updateMaterialFolder(params, success, fail) {
    var route = "netDrive.materialHandler.updateMaterialFolder";
    _MMEnterpriseController["default"].request(route, params, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success(res['materialClass']);
      }
    });
  },
  getMaterialApplyInfo: function getMaterialApplyInfo(fileId, success, fail) {
    var route = "netDrive.materialHandler.getMaterialApplyInfo";
    _MMEnterpriseController["default"].request(route, {
      fileId: fileId
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success(res['applyInfo']);
      }
    });
  },
  getMaterialApprovers: function getMaterialApprovers(fileId, success, fail) {
    var route = "netDrive.materialHandler.getMaterialApprovers";
    _MMEnterpriseController["default"].request(route, {
      fileId: fileId
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success(res['approverInfos']);
      }
    });
  },
  getEditFileApprovers: function getEditFileApprovers(fileId, success, fail) {
    var route = "netDrive.shareHandler.getEditFileApprovers";
    _MMEnterpriseController["default"].request(route, {
      fileId: fileId
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success(res['approvers']);
      }
    });
  },
  getEntArchiveManagers: function getEntArchiveManagers(success, fail) {
    var route = "netDrive.enterpriseHandler.getEntArchiveManagers";
    _MMEnterpriseController["default"].request(route, {}, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success(res['managers']);
      }
    });
  },
  reviewMaterialApplyInfo: function reviewMaterialApplyInfo(fileId, reviewResult, success, fail) {
    var route = "netDrive.materialHandler.reviewMaterialApplyInfo";
    _MMEnterpriseController["default"].request(route, {
      fileId: fileId,
      reviewResult: reviewResult
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success(res['applyInfo']);
      }
    });
  },
  applyAccess: function applyAccess(fileId, applyReason, success, fail) {
    var route = "netDrive.materialHandler.applyAccess";
    _MMEnterpriseController["default"].request(route, {
      fileId: fileId,
      applyReason: applyReason
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success(res['applyInfo']);
      }
    });
  },
  reviewApplyAccess: function reviewApplyAccess(fileId, applicantUserId, reviewResult, success, fail) {
    var route = "netDrive.materialHandler.reviewApplyAccess";
    _MMEnterpriseController["default"].request(route, {
      fileId: fileId,
      reviewResult: reviewResult,
      applicantUserId: applicantUserId
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success(res['applyInfo']);
      }
    });
  },
  reviewApplyDownloadFile: function reviewApplyDownloadFile(applyId, reviewResult, success, fail) {
    var route = "netDrive.materialHandler.reviewApplyDownloadFile";
    _MMEnterpriseController["default"].request(route, {
      applyId: applyId,
      reviewResult: reviewResult
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success(res['applyInfo']);
      }
    });
  },
  applyDownloadFile: function applyDownloadFile(fileIds, success, fail) {
    var route = "netDrive.materialHandler.applyDownloadFile";
    _MMEnterpriseController["default"].request(route, {
      fileIds: fileIds
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success(res['applyInfo']);
      }
    });
  },
  // {
  //   fileId: 8572080171639384,
  //   pageIndex: 0,
  //   pageSize:20
  // },
  getDownloadAppliedUsers: function getDownloadAppliedUsers(params, success, fail) {
    var route = "netDrive.materialHandler.getDownloadAppliedUsers";
    _MMEnterpriseController["default"].request(route, params, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        var out = new _MDMolaUserCollection["default"](res.userInfos);
        if (_.isFunction(success)) success(out, res.total);
      }
    });
  },
  countDownloadAppliedUsers: function countDownloadAppliedUsers(fileId, success, fail) {
    var route = "netDrive.materialHandler.countDownloadAppliedUsers";
    _MMEnterpriseController["default"].request(route, {
      fileId: fileId
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success(res.count);
      }
    });
  },
  countApplyDownloadsInMaterialfolder: function countApplyDownloadsInMaterialfolder(fileId, success, fail) {
    var route = "netDrive.materialHandler.countApplyDownloadsInMaterialfolder";
    _MMEnterpriseController["default"].request(route, {
      fileId: fileId
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["count"]);
      } else {
        if (_.isFunction(success)) success(res.count);
      }
    });
  },
  removeUserDownloadAppliedFileId: function removeUserDownloadAppliedFileId(fileId, userIds, success, fail) {
    var route = "netDrive.materialHandler.removeUserDownloadAppliedFileId";
    _MMEnterpriseController["default"].request(route, {
      fileId: fileId,
      userIds: userIds
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["code"], res["message"]);
      } else {
        if (_.isFunction(success)) success(res.count);
      }
    });
  },
  removeUserAppliedAccess: function removeUserAppliedAccess(fileId, userIds, success, fail) {
    var route = "netDrive.materialHandler.removeUserAppliedAccess";
    _MMEnterpriseController["default"].request(route, {
      fileId: fileId,
      userIds: userIds
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["code"], res["message"]);
      } else {
        if (_.isFunction(success)) success(res.count);
      }
    });
  },
  reviewNextAccessType: function reviewNextAccessType(fileId, reviewResult, success, fail) {
    var route = "netDrive.materialHandler.reviewNextAccessType";
    _MMEnterpriseController["default"].request(route, {
      fileId: fileId,
      reviewResult: reviewResult
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  // const fileIds = msg.fileIds;
  // const accessType = msg.accessType;
  // const otherOptions = msg.otherOptions;
  // const dueTime = msg.dueTime;
  // const nextAccessType = msg.nextAccessType;
  // const managerIds = msg.managerIds;
  updateForClassOrFolders: function updateForClassOrFolders(params, success, fail) {
    var route = "netDrive.materialHandler.updateForClassOrFolders";
    _MMEnterpriseController["default"].request(route, params, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  acceptOrDenyJoinMaterial: function acceptOrDenyJoinMaterial(params, success, fail) {
    var route = "netDrive.materialHandler.reviewJoinMember";
    _MMEnterpriseController["default"].request(route, params, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  addlMaterialReaders: function addlMaterialReaders(fileId, readerIds, success, fail) {
    var route = "netDrive.materialHandler.addlMaterialReaders";
    _MMEnterpriseController["default"].request(route, {
      fileId: fileId,
      readerIds: readerIds
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  applyJoinMember: function applyJoinMember(fileId, roleId, message, success, fail) {
    var route = "netDrive.materialHandler.applyJoinMember";
    _MMEnterpriseController["default"].request(route, {
      fileId: fileId,
      roleId: roleId,
      message: message
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  getUserTokenInfo: function getUserTokenInfo(successCB, failCb) {
    $.ajax('/ai/getUserTokenInfo.do', {
      method: 'post',
      data: {},
      success: function success(responseData) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData['info']);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(responseData) {
        _.isFunction(failCb) && failCb(responseData);
      }
    });
  },
  getEnterpriseTokenInfo: function getEnterpriseTokenInfo(successCB, failCb) {
    $.ajax('/ai/getEnterpriseTokenInfo.do', {
      method: 'post',
      data: {},
      success: function success(responseData) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData['info']);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(responseData) {
        _.isFunction(failCb) && failCb(responseData);
      }
    });
  },
  listEntUsedTokens: function listEntUsedTokens(params, successCB, failCb) {
    $.ajax('/ai/listEntUsedTokens.do', {
      method: 'post',
      data: params,
      success: function success(responseData) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData['list'], responseData['total']);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(responseData) {
        _.isFunction(failCb) && failCb(responseData);
      }
    });
  },
  listUserUsedTokens: function listUserUsedTokens(params, successCB, failCb) {
    $.ajax('/ai/listUserUsedTokens.do', {
      method: 'post',
      data: params,
      success: function success(responseData) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData['list'], responseData['total']);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(responseData) {
        _.isFunction(failCb) && failCb(responseData);
      }
    });
  },
  listTokenPrice: function listTokenPrice(successCB, failCb) {
    $.ajax('/ai/listTokenPrice.do', {
      method: 'post',
      data: {},
      success: function success(responseData) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData['list']);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(responseData) {
        _.isFunction(failCb) && failCb(responseData);
      }
    });
  },
  getStandardConsumeTokens: function getStandardConsumeTokens(successCB, failCb) {
    $.ajax('/ai/getStandardConsumeTokens.do', {
      method: 'post',
      data: {},
      success: function success(responseData) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData['list']);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(responseData) {
        _.isFunction(failCb) && failCb(responseData);
      }
    });
  },
  getFileIdNameSign: function getFileIdNameSign(curFileId, successCB, failCb) {
    $.ajax('/ai/getFileIdNameSign.do', {
      method: 'post',
      data: {
        curFileId: curFileId
      },
      success: function success(responseData) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData['sign']);
          // MMEnterpriseController.getTextSearch(responseData['sign'], query, successCB, failCb)
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(responseData) {
        _.isFunction(failCb) && failCb(responseData);
      }
    });
  },
  getTextSearchSign: function getTextSearchSign(query, successCB, failCb) {
    $.ajax('/ai/getTextSearchSign.do', {
      method: 'post',
      data: {
        query: query
      },
      success: function success(responseData) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData['sign']);
          // MMEnterpriseController.getTextSearch(responseData['sign'], query, successCB, failCb)
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(responseData) {
        _.isFunction(failCb) && failCb(responseData);
      }
    });
  },
  getTextSearch: function getTextSearch(sign, query, successCB, failCb) {
    // let res = {
    //   "code": 0,
    //   "sources": [
    //     {
    //       "fileId": "5292726193531895",
    //       "fileName": "无限极证书切换指引.docx"
    //     },
    //     {
    //       "fileId": "3710444230730074",
    //       "fileName": "公开招标第一册——终稿.doc"
    //     }
    //   ],
    //   "content": "你好，我是Babel，一个智能助手。现在是测试时间。",
    //   "token": "eyJhbGciOiJIUzI1NiIsInNpZ25fdHlwZSI6IlNJR04iLCJ0eXAiOiJKV1QifQ.eyJhcGlfa2V5IjoiMGY1Y2JlYTU3MWU1ZDM4YWU0YTkzOWMwMzcyY2ZlZmMiLCJleHAiOjE3MzUyMTQ2MDQzOTUsInRpbWVzdGFtcCI6MTczNTIxMTAwNDM5NX0.DSnNjusSlaYuoX1LrAI0DXB8KxnxI-7DhvJbINrTWVc"
    // }
    // successCB(res)
    // return

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/chat/text_query', true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader('Authorization', 'bearer ' + sign);
    xhr.onload = function () {
      console.log(xhr.responseText);
      if (xhr.status === 200) {
        var _responseData = JSON.parse(xhr.responseText);
        _.isFunction(successCB) && successCB(_responseData);
      } else {
        _.isFunction(failCb) && failCb();
      }
    };
    xhr.onerror = function () {
      console.error('Network error.');
      _.isFunction(failCb) && failCb();
    };
    query = query || "";
    // var params = `query=${query}&image=${image}`;

    var params = JSON.stringify({
      query: query
    });
    xhr.send(params);
  },
  getImageTokenByFileId: function getImageTokenByFileId(curFileId, successCB, failCb) {
    $.ajax('/ai/getImageTokenByFileId.do', {
      method: 'post',
      data: {
        curFileId: curFileId
      },
      success: function success(responseData) {
        console.warn(responseData);
        if (responseData.success) {
          successCB(responseData["uploadToken"]);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(responseData) {
        _.isFunction(failCb) && failCb(responseData);
      }
    });
  },
  filePreAiQuoteUpload: function filePreAiQuoteUpload(params, successCB, failCb) {
    $.ajax('/ai/filePreAiQuoteUpload.do', {
      method: 'post',
      data: {
        fileName: params.file.name,
        fileSize: params.file.size
      },
      success: function success(responseData) {
        console.warn(responseData);
        if (responseData.success) {
          var newParams = _.extend({
            uploadToken: responseData.uploadToken,
            url: responseData.url
          }, params);
          _MMEnterpriseController["default"].fileAiQuoteUpload(newParams, successCB, failCb);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(responseData) {
        _.isFunction(failCb) && failCb(responseData);
      }
    });
  },
  fileAiQuoteUpload: function fileAiQuoteUpload(params, successCB, failCb) {
    var formData = new FormData();
    formData.append("file", params.file, params.file.uploadName);
    formData.append("fileName", MMCommonFun.filterFileName(params.file.name));
    formData.append("uploadToken", params.uploadToken);
    formData.append("fileSize", params.file.size);
    var xhr = new XMLHttpRequest();
    xhr.open('POST', params.url, true);
    xhr.onload = function () {
      if (xhr.status === 200) {
        _.isFunction(successCB) && successCB(params.uploadToken);
        // MMEnterpriseController.getImgSearchSign(params.uploadToken, successCB, failCb)
      } else {
        console.error('Error:', xhr.statusText);
      }
    };
    xhr.onerror = function () {
      console.error('Network error.');
      _.isFunction(failCb) && failCb();
    };
    xhr.send(formData);
  },
  getFileIdsSign: function getFileIdsSign(fileIdArr, successCB, failCb) {
    if (_.isArray(fileIdArr)) {
      fileIdArr = fileIdArr.join(",");
    }
    $.ajax('/ai/getFileIdsSign.do', {
      method: 'post',
      data: {
        "fileIdArr": fileIdArr
      },
      success: function success(responseData) {
        console.warn(responseData);
        if (responseData.success) {
          successCB(responseData.sign);
        } else {
          if (responseData.code == "10101") {
            responseData.msg = BabelStr.str(12659);
          } else if (responseData.code == "20500") {
            responseData.msg = BabelStr.str(12660, {
              num: responseData.max || 5
            });
          }
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(responseData) {
        if (responseData.code == "10101") {
          responseData.msg = BabelStr.str(12659);
        }
        _.isFunction(failCb) && failCb(responseData);
      }
    });
  },
  aiAddtags: function aiAddtags(fileIdArr, successCB, failCb) {
    var _this = this;
    this.getFileIdsSign(fileIdArr, function (sign) {
      _this.aiAddtagsWithSign(sign, fileIdArr, successCB, failCb);
    }, function (err) {
      err = err || {};
      failCb(err.msg);
    });
  },
  aiAddtagsWithSign: function aiAddtagsWithSign(sign, mentionedDocIds, successCB, failCb) {
    if (!_.isArray(mentionedDocIds)) {
      mentionedDocIds = [mentionedDocIds];
    }
    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/chat/add_tags', true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader('Authorization', 'bearer ' + sign);
    xhr.onload = function () {
      console.log(xhr.responseText);
      if (xhr.status === 200) {
        var _responseData2 = JSON.parse(xhr.responseText);
        if (_responseData2.code == 0) {
          _.isFunction(successCB) && successCB();
        } else {
          _.isFunction(failCb) && failCb(_responseData2.content);
        }
      } else {
        _.isFunction(failCb) && failCb();
      }
    };
    xhr.onerror = function () {
      console.error('Network error.');
      _.isFunction(failCb) && failCb();
    };
    var params = JSON.stringify({
      mentionedDocIds: mentionedDocIds,
      lang: BabelStr.getCurrentLanguage()
    });
    xhr.send(params);
  },
  getExcelSearch: function getExcelSearch(sign, mentionedDocIds, messages, successCB, failCb) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/chat/excel_chat', true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader('Authorization', 'bearer ' + sign);
    xhr.onload = function () {
      console.log(xhr.responseText);
      if (xhr.status === 200) {
        var _responseData3 = JSON.parse(xhr.responseText);
        _.isFunction(successCB) && successCB(JSON.parse(_responseData3.content));
      } else {
        _.isFunction(failCb) && failCb();
      }
    };
    xhr.onerror = function () {
      console.error('Network error.');
      _.isFunction(failCb) && failCb();
    };
    var params = JSON.stringify({
      mentionedDocIds: mentionedDocIds,
      messages: messages
    });
    xhr.send(params);
  },
  getImgSearchSign: function getImgSearchSign(uploadToken, query, successCB, failCb) {
    $.ajax('/ai/getImgSearchSign.do', {
      method: 'post',
      data: {
        uploadToken: uploadToken
      },
      success: function success(responseData) {
        console.warn(responseData);
        if (responseData.success) {
          // _.isFunction(successCB) && successCB(responseData['sign'], uploadToken);
          var path = responseData['path'] || null;
          successCB(responseData['sign'], path);
          // MMEnterpriseController.getImgSearch(responseData['sign'], query, path, successCB, failCb )
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(responseData) {
        _.isFunction(failCb) && failCb(responseData);
      }
    });
  },
  getImgSearch: function getImgSearch(sign, query, image, successCB, failCb) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/chat/visual_query', true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader('Authorization', 'bearer ' + sign);
    xhr.onload = function () {
      console.log(xhr.responseText);
      if (xhr.status === 200) {
        var _responseData4 = JSON.parse(xhr.responseText);
        _.isFunction(successCB) && successCB(_responseData4.fileIds);
      } else {
        _.isFunction(failCb) && failCb();
      }
    };
    xhr.onerror = function () {
      console.error('Network error.');
      _.isFunction(failCb) && failCb();
    };
    image = image || "";
    query = query || "";
    // var params = `query=${query}&image=${image}`;

    var params = JSON.stringify({
      query: query,
      image: image
    });
    xhr.send(params);
  },
  getChatData: function getChatData(param, successCB, failCb) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/chat/babelqa_chat', true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onload = function () {
      console.log(xhr.responseText);
      if (xhr.status === 200) {
        var _responseData5 = JSON.parse(xhr.responseText);
        _.isFunction(successCB) && successCB(_responseData5);
      } else {
        _.isFunction(failCb) && failCb();
      }
    };
    xhr.onerror = function () {
      _.isFunction(failCb) && failCb();
    };
    var messages = param.messages;
    var params = JSON.stringify({
      messages: messages
    });
    xhr.send(params);
  },
  getChatDataForFile: function getChatDataForFile(param, query, successCB, failCb) {
    var messages = param.messages;
    var mentionedDocIds = [param.fileId];
    _MMEnterpriseController["default"].getTextSearchSign(query, function (sign) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', '/chat/knowledge_chat', true);
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.setRequestHeader('Authorization', 'bearer ' + sign);
      xhr.onload = function () {
        console.log(xhr.responseText);
        if (xhr.status === 200) {
          var _responseData6 = JSON.parse(xhr.responseText);
          _.isFunction(successCB) && successCB(_responseData6);
        } else {
          _.isFunction(failCb) && failCb();
        }
      };
      xhr.onerror = function () {
        _.isFunction(failCb) && failCb();
      };
      var params = JSON.stringify({
        messages: messages,
        mentionedDocIds: mentionedDocIds
      });
      xhr.send(params);
    }, failCb);
  },
  setReviewConfigOptions: function setReviewConfigOptions(reviewId, options, success, fail) {
    var route = "netDrive.fileExHandler.setReviewConfigOptions";
    _MMEnterpriseController["default"].request(route, {
      reviewId: reviewId,
      options: options
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  consumeTokens: function consumeTokens(data, successCB, failCb) {
    $.ajax('/ai/consumeTokens.do', {
      method: 'post',
      data: data,
      success: function success(responseData) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(responseData) {
        _.isFunction(failCb) && failCb(responseData);
      }
    });
  },
  createBabelOffice: function createBabelOffice(parentFolderId, fileName, successCB, failCb) {
    $.ajax('/netdrive/createBabelOffice.do', {
      method: 'post',
      data: {
        parentFolderId: parentFolderId,
        fileName: fileName
      },
      success: function success(responseData) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB('7590571308576614');
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(responseData) {
        _.isFunction(failCb) && failCb(responseData);
      }
    });
  },
  createLinkFile: function createLinkFile(params, file, successCB, failCB, progressCB) {
    $.ajax('/file/createLinkFile.do', {
      method: 'post',
      data: params,
      success: function success(responseData) {
        console.warn(responseData);
        if (responseData.success) {
          // _.isFunction(successCB) && successCB(responseData);
          var url = responseData.url;
          if (responseData.linkFileUrl) {
            successCB();
            return;
          }
          if (responseData["code"] == "0") {
            file.uploadUrl = url;
            console.log("该文件不能秒传");
            MMNetDiskDataController.uploadBabelFile(url, params.hash, file, undefined, params.folderId, {
              forbidAutoRename: 0,
              ignoreVirus: 0
            }, successCB, failCB, progressCB, {
              linkFileUrl: params.linkFileUrl,
              linkFileName: params.linkFileName,
              fileSize: params.fileSize
            });
          } else if (responseData["code"] == "19") {
            console.log("该文件可以秒传");
            MMNetDiskDataController.uploadFileCTPdf(url, params.hash, file, undefined, params.folderId, {
              forbidAutoRename: 0,
              ignoreVirus: 0
            }, successCB, failCB, progressCB, {
              linkFileUrl: params.linkFileUrl,
              linkFileName: params.linkFileName,
              fileSize: params.fileSize
            });
          }
        } else {
          _.isFunction(failCb) && failCb(undefined, responseData.code, responseData.msg);
        }
      },
      error: function error(responseData) {
        _.isFunction(failCb) && failCb(undefined, responseData.code, responseData.msg);
      }
    });
  },
  canUploadFileVersion: function canUploadFileVersion(fileId, successCB, failCb) {
    $.ajax('/netdrive/canUploadFileVersion.do', {
      method: 'post',
      data: {
        fileId: fileId
      },
      success: function success(responseData) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(responseData) {
        _.isFunction(failCb) && failCb(responseData);
      }
    });
  },
  addUserExpect: function addUserExpect(data, successCB, failCb) {
    $.ajax('/ai/addUserExpect.do', {
      method: 'post',
      data: data,
      success: function success(responseData) {
        console.warn(responseData);
      },
      error: function error(responseData) {
        _.isFunction(failCb) && failCb(responseData);
      }
    });
  },
  exportToFile: function exportToFile(sign, data, successCB, failCb) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/ocr/export_to_file', true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader('Authorization', 'bearer ' + sign);
    xhr.onload = function () {
      console.log(xhr.responseText);
      if (xhr.status === 200) {
        var url = URL.createObjectURL(xhr.response);

        // 创建一个a标签
        var a = document.createElement("a");
        // 设置下载链接的href属性为Blob对象的URL
        a.href = url;
        // 设置下载文件的名称
        a.download = this.saveAsFilename;

        // 触发下载
        document.body.appendChild(a);
        a.click();

        // 清理：从DOM中移除a标签，并撤销URL对象
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        _.isFunction(successCB) && successCB(responseData);
      } else {
        _.isFunction(failCb) && failCb();
      }
    };
    xhr.onerror = function () {
      _.isFunction(failCb) && failCb();
    };
    // let messages = param.messages
    var params = JSON.stringify(data);
    xhr.send(params);

    // $.ajax('/ocr/export_to_file', {
    //   method: 'post',
    //   data: data,
    //   success: function(responseData) {
    //     console.warn(responseData);
    //     if (responseData.success) {
    //       _.isFunction(successCB) && successCB(responseData);
    //     } else {
    //       _.isFunction(failCb) && failCb(responseData);
    //     }
    //   },
    //   error: function(responseData) {
    //     _.isFunction(failCb) && failCb(responseData);
    //   }

    // });
  },
  changeLinkFile: function changeLinkFile(params, successCB, failCB, progressCB) {
    // let cb = function() {
    MMNetDiskDataController.request("netDrive.fileExHandler.changeLinkFile", {
      "fid": params.fileInfor.getFileId(),
      "linkFileName": params.linkFileName,
      "linkFileUrl": params.linkFileUrl
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) failCB(undefined, res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(successCB)) successCB();
      }
    }, function (err) {
      console.error(err);
      _.isFunction(failCb) && failCb(undefined, err.code, err.msg);
    });

    // }

    // if(params.file) {
    //   MMNetDiskDataController.calcFileHashAndUpload(params.file, params.fileInfor,
    //     params.folderId,
    //     {
    //       forbidAutoRename: 0,
    //       ignoreVirus: 0
    //     },
    //     cb,
    //     failCB,
    //     progressCB)
    // } else {
    //   cb()
    // }
  },
  getMaterialPublicInfo: function getMaterialPublicInfo(fileId, successCB, failCB) {
    MMNetDiskDataController.request("netDrive.materialHandler.getMaterialPublicInfo", {
      "fileId": fileId
    }, function (res) {
      console.log(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(failCB)) failCB(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(successCB)) successCB(res.publicInfo);
      }
    }, function (err) {
      console.error(err);
      _.isFunction(failCB) && failCB(undefined, err.code, err.msg);
    });
  },
  needInputEncryptPassword: function needInputEncryptPassword(fileId, successCB, failCB) {
    MMNetDiskDataController.request("netDrive.fileExHandler.needInputEncryptPassword", {
      "fid": fileId
    }, function (res) {
      console.log(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(failCB)) failCB(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(successCB)) successCB(res);
      }
    }, function (err) {
      console.error(err);
      _.isFunction(failCB) && failCB(undefined, err.code, err.msg);
    });
  },
  createDir: function createDir(params, successCB, failCB) {
    _MMEnterpriseController["default"].request("netDrive.fileHandler.createDir", params, function (res) {
      console.log(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(failCB)) failCB(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(successCB)) successCB(res.fileInfo);
      }
    }, function (err) {
      console.error(err);
      _.isFunction(failCb) && failCb(err.code, err.msg);
    });
  },
  inputEncryptPassword: function inputEncryptPassword(params, successCB, failCB) {
    _MMEnterpriseController["default"].request("netDrive.fileExHandler.inputEncryptPassword", params, function (res) {
      console.log(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(failCB)) failCB(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(successCB)) successCB(res);
      }
    }, function (err) {
      console.error(err);
      _.isFunction(failCb) && failCb(err.code, err.msg);
    });
  },
  getRecommendFiles: function getRecommendFiles(channel, fileId, successCB, failCB) {
    _MMEnterpriseController["default"].request("netDrive.fileExHandler.getRecommendFiles", {
      channel: channel,
      fileId: fileId
    }, function (res) {
      console.log(res);
      if (res["code"] !== 0) {
        if (_.isFunction(failCB)) failCB(res["code"], res["message"]);
      } else {
        var usernamesById = res["users"];
        _.each(res.rt_files, function (file) {
          file.showParentMenu = true;
          file["managerName"] = usernamesById[file["manager"]];
          file["creatorName"] = usernamesById[file["creator"]];
          file["lastModifyUserName"] = usernamesById[file["lastModifyUserId"]];
          file["ownerName"] = usernamesById[file["ownerId"]];
          file["sharerName"] = usernamesById[file["sharerId"]];
          file["currentVerCommitterName"] = usernamesById[file["currentVerCommitterId"]];
        });
        if (_.isFunction(successCB)) successCB(res['rt_files']);
      }
    });
  },
  setCloseRecmmend: function setCloseRecmmend(close, successCB, failCB) {
    _MMEnterpriseController["default"].request("netDrive.fileExHandler.setCloseRecmmend", {
      close: close
    }, function (res) {
      console.log(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(failCB)) failCB(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(successCB)) successCB();
      }
    });
  },
  setCloseDirectOpenDep: function setCloseDirectOpenDep(close, successCB, failCB) {
    _MMEnterpriseController["default"].request("netDrive.fileExHandler.setCloseDirectOpenDep", {
      close: close
    }, function (res) {
      console.log(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(failCB)) failCB(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(successCB)) successCB();
      }
    });
  },
  getRecentlyFiles: function getRecentlyFiles(parentId, orderName, isAsc, page, pageSize, successCB, failCB, params) {
    params = _.extend({}, params);
    if (parentId == 0) {
      parentId = undefined;
    }
    _MMEnterpriseController["default"].request("netDrive.fileExHandler.getRecentlyFiles", {
      fileId: parentId,
      pageIndex: page ? page : 0,
      pageSize: pageSize ? pageSize : 50,
      orderBy: orderName,
      isAsc: isAsc,
      channel: params.channel
    }, function (res) {
      console.log(res);
      if (res["code"] === 0) {
        console.error(res);
        var out = new _MMFileInfoCollection["default"]();
        if (!res["resultSet"] || !res["resultSet"]["fileInfos"]) {
          successCB(out, res["total"], res["pages"]);
          return;
        }
        out = _MMEnterpriseController["default"].listFilesByPagesCallback(res, params.no2ndFileInfo);
        _.isFunction(successCB) && successCB(out, res["total"], res["pages"]);
      } else {
        if (res["code"] == 853 && res.options && res.options.noPassFiles) {
          _MMEnterpriseController["default"].checkFilesSequentially(res.options.noPassFiles, function () {
            _MMEnterpriseController["default"].getRecentlyFiles(parentId, orderName, isAsc, page, pageSize, successCB, failCB, params);
          }, function () {
            _.isFunction(failCB) && failCB(res["code"], BabelStr.str(27029), res);
          });
        } else {
          _.isFunction(failCB) && failCB(res["code"], res["message"], res);
        }
      }
    });
  },
  getFocusFiles: function getFocusFiles(parentId, orderName, isAsc, page, pageSize, successCB, failCB, params) {
    params = _.extend({}, params);
    if (parentId == 0) {
      parentId = undefined;
    }
    _MMEnterpriseController["default"].request("netDrive.fileExHandler.getFocusFiles", {
      fileId: parentId,
      pageIndex: page ? page : 0,
      pageSize: pageSize ? pageSize : 50,
      orderBy: orderName,
      isAsc: isAsc,
      channel: params.channel
    }, function (res) {
      console.log(res);
      if (res["code"] === 0) {
        console.error(res);
        var out = new _MMFileInfoCollection["default"]();
        if (!res["resultSet"] || !res["resultSet"]["fileInfos"]) {
          successCB(out, res["total"], res["pages"]);
          return;
        }
        out = _MMEnterpriseController["default"].listFilesByPagesCallback(res, params.no2ndFileInfo);
        _.isFunction(successCB) && successCB(out, res["total"], res["pages"]);
      } else {
        if (res["code"] == 853 && res.options && res.options.noPassFiles) {
          _MMEnterpriseController["default"].checkFilesSequentially(res.options.noPassFiles, function () {
            _MMEnterpriseController["default"].getFocusFiles(parentId, orderName, isAsc, page, pageSize, successCB, failCB, params);
          }, function () {
            _.isFunction(failCB) && failCB(res["code"], BabelStr.str(27029), res);
          });
        } else {
          _.isFunction(failCB) && failCB(res["code"], res["message"], res);
        }
      }
    });
  },
  getSomeFileInFolder: function getSomeFileInFolder(fileId, successCB, failCB) {
    _MMEnterpriseController["default"].request("netDrive.fileExHandler.getSomeFileInFolder", {
      fileId: fileId
    }, function (res) {
      // console.log(res)
      if (res["resultCode"] === 0) {
        // console.error(res);
        var out = new _MMFileInfoCollection["default"](res.fileInfos);
        _.isFunction(successCB) && successCB(out);
      } else {
        // if(res["resultCode"] == 853 && res.options && res.options.noPassFiles){
        //   MMEnterpriseController.checkFilesSequentially(res.options.noPassFiles, ()=>{
        //     MMEnterpriseController.getSomeFileInFolder(parentId, orderName, isAsc, page, pageSize, successCB, failCB, params)
        //   }, ()=>{
        //     _.isFunction(failCB) && failCB(res["resultCode"], BabelStr.str(27029), res);
        //   })
        // } else {
        _.isFunction(failCB) && failCB(res["resultCode"], res["message"], res);
        // }
      }
    });
  },
  createAgent: function createAgent(params, successCB, failCb) {
    // params :  {
    //   title: "good",
    //   comment: "comment ",
    //   type: 0   // 0 - 知识库
    // },
    // console.log(params)
    // return

    var formData = new FormData();
    formData.append('file', params.file);
    formData.append('comment', params.comment);
    formData.append('title', params.title);
    formData.append('type', params.type);
    fetch('/ai/createAgent.do', {
      method: 'POST',
      body: formData
    }).then(function (response) {
      if (!response.ok) {
        throw new Error("\u8BF7\u6C42\u5931\u8D25\uFF0C\u72B6\u6001\u7801\uFF1A".concat(response.status));
      }
      return response.json();
    }).then(function (result) {
      console.log('上传成功:', result);
      if (result.code != 0) {
        _.isFunction(failCb) && failCb(result);
      } else {
        _.isFunction(successCB) && successCB(result);
      }
    })["catch"](function (error) {
      _.isFunction(failCb) && failCb(error);
    });
  },
  updateAgent: function updateAgent(params, successCB, failCb) {
    // params :  {
    //   title: "good",
    //   comment: "comment ",
    //   type: 0   // 0 - 知识库
    // },
    // console.log(params)
    // return

    var formData = new FormData();
    formData.append('agentId', params.agentId);
    !_.isUndefined(params.file) && formData.append('file', params.file);
    !_.isUndefined(params.comment) && formData.append('comment', params.comment);
    !_.isUndefined(params.title) && formData.append('title', params.title);
    !_.isUndefined(params.type) && formData.append('type', params.type);
    fetch('/ai/updateAgent.do', {
      method: 'POST',
      body: formData
    }).then(function (response) {
      if (!response.ok) {
        throw new Error("\u8BF7\u6C42\u5931\u8D25\uFF0C\u72B6\u6001\u7801\uFF1A".concat(response.status));
      }
      return response.json();
    }).then(function (result) {
      console.log('更新成功:', result);
      if (result.code != 0) {
        _.isFunction(failCb) && failCb(result);
      } else {
        _.isFunction(successCB) && successCB(result);
      }
    })["catch"](function (error) {
      _.isFunction(failCb) && failCb(error);
    });
  },
  updateAgentKnowledgeBase: function updateAgentKnowledgeBase(params, successCB, failCb) {
    // agentId: 1,
    // status: 0,   // 0 公开， 1 - 限定部门， 2 - 收到链接的人， 3 - 私密
    // opRemarks: "update remarks",
    // prompt: "update prompt",
    // shareType: 1,
    // delFileIds: "",
    // fileIdArr: "5774667615096642,3793786914100842"

    var formData = new FormData();
    Object.entries(params).forEach(function (_ref) {
      var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      formData.append(key, value);
    });
    fetch('/ai/updateAgentKnowledgeBase.do', {
      method: 'POST',
      body: formData
    }).then(function (response) {
      if (!response.ok) {
        throw new Error("\u8BF7\u6C42\u5931\u8D25\uFF0C\u72B6\u6001\u7801\uFF1A".concat(response.status));
      }
      return response.json();
    }).then(function (result) {
      console.log('更新成功:', result);
      if (result.code != 0) {
        _.isFunction(failCb) && failCb(result);
      } else {
        _.isFunction(successCB) && successCB(result);
      }
    })["catch"](function (error) {
      _.isFunction(failCb) && failCb(error);
    });
  },
  getMyAgent: function getMyAgent(successCB, failCb) {
    $.ajax({
      url: "/ai/getMyAgent.do",
      method: "post",
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData["agents"]);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  getJoinedAgent: function getJoinedAgent(successCB, failCb) {
    $.ajax({
      url: "/ai/getJoinedAgent.do",
      method: "post",
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.each(responseData["otherKnowledgeBases"], function (item) {
            item.id = item.agent_id;
            item.onlyRead = true;
          });
          _.isFunction(successCB) && successCB(responseData["otherKnowledgeBases"]);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  followAgent: function followAgent(agentId, successCB, failCb) {
    $.ajax({
      url: "/ai/followAgent.do",
      method: "post",
      data: {
        agentId: agentId
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  removeFollowAgent: function removeFollowAgent(agentId, successCB, failCb) {
    $.ajax({
      url: "/ai/removeFollowAgent.do",
      method: "post",
      data: {
        agentId: agentId
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  getAgentFileIdsSign: function getAgentFileIdsSign(agentId, successCB, failCb) {
    $.ajax({
      url: "/ai/getAgentFileIdsSign.do",
      method: "post",
      data: {
        agentId: agentId
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData["sign"]);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  getAgentUrl: function getAgentUrl(agentId, successCB, failCb) {
    $.ajax({
      url: "/ai/getAgentUrl.do",
      method: "post",
      data: {
        agentId: agentId
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          var url = location.origin + responseData["url"];
          _.isFunction(successCB) && successCB(url);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  getKnowledgeBaseById: function getKnowledgeBaseById(agentId, successCB, failCb) {
    $.ajax({
      url: "/ai/getKnowledgeBaseById.do",
      method: "post",
      data: {
        agentId: agentId
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData);
        } else {
          if (responseData.code == 2) {
            responseData.msg = BabelStr.str(13264);
          }
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  removeAgent: function removeAgent(agentId, successCB, failCb) {
    $.ajax({
      url: "/ai/removeAgent.do",
      method: "post",
      data: {
        agentId: agentId
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  insertUpdateTaskDEL: function insertUpdateTaskDEL(params, successCB, failCB) {
    _MMEnterpriseController["default"].request("netDrive.autoTaskHandler.insertUpdateTaskDEL", params, function (res) {
      console.log(res);
      if (res["code"] !== 0) {
        if (_.isFunction(failCB)) failCB(res["code"], res["message"]);
      } else {
        if (_.isFunction(successCB)) successCB(res.value);
      }
    });
  },
  findTaskDELByFileId: function findTaskDELByFileId(fileId, successCB, failCB) {
    _MMEnterpriseController["default"].request("netDrive.autoTaskHandler.findTaskDELByFileId", {
      fileId: fileId
    }, function (res) {
      console.log(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(failCB)) failCB(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(successCB)) successCB(res.value);
      }
    });
  },
  delTaskDELByFileId: function delTaskDELByFileId(fileId, successCB, failCB) {
    _MMEnterpriseController["default"].request("netDrive.autoTaskHandler.delTaskDELByFileId", {
      fileId: fileId
    }, function (res) {
      console.log(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(failCB)) failCB(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(successCB)) successCB();
      }
    });
  }
}, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_getReviewConfig4File, "delTaskDELByFileId", function delTaskDELByFileId(fileId, successCB, failCB) {
  _MMEnterpriseController["default"].request("netDrive.autoTaskHandler.delTaskDELByFileId", {
    fileId: fileId
  }, function (res) {
    console.log(res);
    if (res["resultCode"] !== 0) {
      if (_.isFunction(failCB)) failCB(res["resultCode"], res["message"]);
    } else {
      if (_.isFunction(successCB)) successCB();
    }
  });
}), "findMyTaskDEL", function findMyTaskDEL(params, successCB, failCB) {
  _MMEnterpriseController["default"].request("netDrive.autoTaskHandler.findMyTaskDEL", {}, function (res) {
    console.log(res);
    if (res["resultCode"] !== 0) {
      if (_.isFunction(failCB)) failCB(res["resultCode"], res["message"]);
    } else {
      if (_.isFunction(successCB)) successCB(res.taskInfos);
    }
  });
}), "insertUpdateTaskREN", function insertUpdateTaskREN(params, successCB, failCB) {
  _MMEnterpriseController["default"].request("netDrive.autoTaskHandler.insertUpdateTaskREN", params, function (res) {
    console.log(res);
    if (res["code"] !== 0) {
      if (_.isFunction(failCB)) failCB(res["code"], res["message"]);
    } else {
      if (_.isFunction(successCB)) successCB(res.value);
    }
  });
}), "findTaskRENByFileId", function findTaskRENByFileId(fileId, successCB, failCB) {
  _MMEnterpriseController["default"].request("netDrive.autoTaskHandler.findTaskRENByFileId", {
    fileId: fileId
  }, function (res) {
    console.log(res);
    if (res["resultCode"] !== 0) {
      if (_.isFunction(failCB)) failCB(res["resultCode"], res["message"]);
    } else {
      if (_.isFunction(successCB)) successCB(res.value);
    }
  });
}), "delTaskRENByFileId", function delTaskRENByFileId(fileId, successCB, failCB) {
  _MMEnterpriseController["default"].request("netDrive.autoTaskHandler.delTaskRENByFileId", {
    fileId: fileId
  }, function (res) {
    console.log(res);
    if (res["resultCode"] !== 0) {
      if (_.isFunction(failCB)) failCB(res["resultCode"], res["message"]);
    } else {
      if (_.isFunction(successCB)) successCB();
    }
  });
}), "findMyTaskREN", function findMyTaskREN(params, successCB, failCB) {
  _MMEnterpriseController["default"].request("netDrive.autoTaskHandler.findMyTaskREN", {}, function (res) {
    console.log(res);
    if (res["resultCode"] !== 0) {
      if (_.isFunction(failCB)) failCB(res["resultCode"], res["message"]);
    } else {
      if (_.isFunction(successCB)) successCB(res.taskInfos);
    }
  });
}), "findTaskORGByFileId", function findTaskORGByFileId(fileId, successCB, failCB) {
  _MMEnterpriseController["default"].request("netDrive.autoTaskHandler.findTaskORGByFileId", {
    fileId: fileId
  }, function (res) {
    console.log(res);
    if (res["resultCode"] !== 0) {
      if (_.isFunction(failCB)) failCB(res["resultCode"], res["message"]);
    } else {
      if (_.isFunction(successCB)) successCB(res.value);
    }
  });
}), "delTaskORGByFileId", function delTaskORGByFileId(fileId, successCB, failCB) {
  _MMEnterpriseController["default"].request("netDrive.autoTaskHandler.delTaskORGByFileId", {
    fileId: fileId
  }, function (res) {
    console.log(res);
    if (res["resultCode"] !== 0) {
      if (_.isFunction(failCB)) failCB(res["resultCode"], res["message"]);
    } else {
      if (_.isFunction(successCB)) successCB();
    }
  });
}), "findMyTaskORG", function findMyTaskORG(params, successCB, failCB) {
  _MMEnterpriseController["default"].request("netDrive.autoTaskHandler.findMyTaskORG", {}, function (res) {
    console.log(res);
    if (res["resultCode"] !== 0) {
      if (_.isFunction(failCB)) failCB(res["resultCode"], res["message"]);
    } else {
      if (_.isFunction(successCB)) successCB(res.taskInfos);
    }
  });
}), "insertUpdateTaskORG", function insertUpdateTaskORG(params, successCB, failCB) {
  _MMEnterpriseController["default"].request("netDrive.autoTaskHandler.insertUpdateTaskORG", params, function (res) {
    console.log(res);
    if (res["code"] !== 0) {
      if (_.isFunction(failCB)) failCB(res["code"] || res["resultCode"], res["message"]);
    } else {
      if (_.isFunction(successCB)) successCB(res.value);
    }
  });
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_getReviewConfig4File, "findTaskCONByFileId", function findTaskCONByFileId(fileId, successCB, failCB) {
  _MMEnterpriseController["default"].request("netDrive.autoTaskHandler.findTaskCONByFileId", {
    fileId: fileId
  }, function (res) {
    console.log(res);
    if (res["resultCode"] !== 0) {
      if (_.isFunction(failCB)) failCB(res["resultCode"], res["message"]);
    } else {
      if (_.isFunction(successCB)) successCB(res.value);
    }
  });
}), "delTaskCONByFileId", function delTaskCONByFileId(fileId, successCB, failCB) {
  _MMEnterpriseController["default"].request("netDrive.autoTaskHandler.delTaskCONByFileId", {
    fileId: fileId
  }, function (res) {
    console.log(res);
    if (res["resultCode"] !== 0) {
      if (_.isFunction(failCB)) failCB(res["resultCode"], res["message"]);
    } else {
      if (_.isFunction(successCB)) successCB();
    }
  });
}), "findMyTaskCON", function findMyTaskCON(params, successCB, failCB) {
  _MMEnterpriseController["default"].request("netDrive.autoTaskHandler.findMyTaskCON", {}, function (res) {
    console.log(res);
    if (res["resultCode"] !== 0) {
      if (_.isFunction(failCB)) failCB(res["resultCode"], res["message"]);
    } else {
      if (_.isFunction(successCB)) successCB(res.taskInfos);
    }
  });
}), "insertUpdateTaskCON", function insertUpdateTaskCON(params, successCB, failCB) {
  _MMEnterpriseController["default"].request("netDrive.autoTaskHandler.insertUpdateTaskCON", params, function (res) {
    console.log(res);
    if (res["code"] !== 0) {
      if (_.isFunction(failCB)) failCB(res["code"], res["message"]);
    } else {
      if (_.isFunction(successCB)) successCB(res.value);
    }
  });
}), "setOrUpdateEntBannedWords", function setOrUpdateEntBannedWords(params, successCB, failCB) {
  _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.setOrUpdateEntBannedWords", params, function (res) {
    console.log(res);
    if (res["resultCode"] !== 0) {
      if (_.isFunction(failCB)) failCB(res["resultCode"], res["message"]);
    } else {
      if (_.isFunction(successCB)) successCB(res.value);
    }
  });
}), "getEntBannedWords", function getEntBannedWords(successCB, failCB) {
  _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.getEntBannedWords", {}, function (res) {
    console.log(res);
    if (res["resultCode"] !== 0) {
      if (_.isFunction(failCB)) failCB(res["resultCode"], res["message"]);
    } else {
      if (_.isFunction(successCB)) successCB(res.data);
    }
  });
}), "setEnableBannedWordsFilter", function setEnableBannedWordsFilter(open, successCB, failCB) {
  _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.setEnableBannedWordsFilter", {
    open: open
  }, function (res) {
    console.log(res);
    if (res["resultCode"] !== 0) {
      if (_.isFunction(failCB)) failCB(res["resultCode"], res["message"]);
    } else {
      if (_.isFunction(successCB)) successCB();
    }
  });
}), "importDirList", function importDirList(file, successCB, failCb) {
  $.ajax('/user/importDirList.do', {
    method: 'post',
    processData: false,
    // 禁用数据转换
    contentType: false,
    // 禁用默认 Content-Type
    data: function () {
      var formData = new FormData();
      formData.append('file', file); // 添加文件到 FormData
      return formData;
    }(),
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        if (responseData["code"] == 0) {
          _.isFunction(successCB) && successCB(responseData['dirList']);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), "createFormbricksSurvey", function createFormbricksSurvey(fileName, parentFolderId, successCB, failCb) {
  $.ajax('/netdrive/createFormbricksSurvey.do', {
    method: 'post',
    dataType: 'json',
    data: {
      fileName: fileName,
      parentFolderId: parentFolderId
    },
    success: function success(responseData) {
      if (responseData && responseData.success === true && responseData.fileId) {
        _.isFunction(successCB) && successCB(responseData);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(xhr) {
      _.isFunction(failCb) && failCb(xhr);
    }
  });
}), "copyFormbricksSurvey", function copyFormbricksSurvey(fileId, successCB, failCb) {
  $.ajax('/netdrive/copyFormbricksSurvey.do', {
    method: 'post',
    dataType: 'json',
    data: {
      fileId: fileId
    },
    success: function success(responseData) {
      if (responseData && responseData.success === true && responseData.fileId) {
        _.isFunction(successCB) && successCB(responseData);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(xhr) {
      _.isFunction(failCb) && failCb(xhr);
    }
  });
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_getReviewConfig4File, "getBannedFiles", function getBannedFiles(params, successCB, failCB) {
  _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.getBannedFiles", params, function (res) {
    console.log(res);
    if (res["resultCode"] !== 0) {
      if (_.isFunction(failCB)) failCB(res["resultCode"], res["message"]);
    } else {
      if (_.isFunction(successCB)) successCB(res.result, res.total);
    }
  });
}), "insertUpdatePersonShare", function insertUpdatePersonShare(params, successCB, failCB) {
  _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.insertUpdatePersonShare", params,
  //outSharePersonFileStrategy: 2, // 0 - 关闭， 1 - 开放 2 - 需要审批 approvers: [] // 审批人， 需要审批时有效 }
  function (res) {
    console.log(res);
    if (res["resultCode"] !== 0) {
      if (_.isFunction(failCB)) failCB(res["resultCode"], res["message"]);
    } else {
      if (_.isFunction(successCB)) successCB(res.result, res.total);
    }
  });
}), "removeDepOutShareSetting", function removeDepOutShareSetting(fileId, successCB, failCB) {
  _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.removeDepOutShareSetting", {
    fileId: fileId
  }, function (res) {
    console.log(res);
    if (res["resultCode"] !== 0) {
      if (_.isFunction(failCB)) failCB(res["resultCode"], res["message"]);
    } else {
      if (_.isFunction(successCB)) successCB(res.result, res.total);
    }
  });
}), "removePersonOutShareSetting", function removePersonOutShareSetting(successCB, failCB) {
  _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.removePersonOutShareSetting", {}, function (res) {
    console.log(res);
    if (res["resultCode"] !== 0) {
      if (_.isFunction(failCB)) failCB(res["resultCode"], res["message"]);
    } else {
      if (_.isFunction(successCB)) successCB(res.result, res.total);
    }
  });
}), "getEntSettings", function getEntSettings(successCB, failCB) {
  _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.getEntSettings", {}, function (res) {
    console.log(res);
    if (res["resultCode"] !== 0) {
      if (_.isFunction(failCB)) failCB(res["resultCode"], res["message"]);
    } else {
      if (_.isFunction(successCB)) successCB(res.settings || {});
    }
  });
}), "insertUpdateDepOutShareSetting", function insertUpdateDepOutShareSetting(params, successCB, failCB) {
  _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.insertUpdateDepOutShareSetting", params,
  //outSharePersonFileStrategy: 2, // 0 - 关闭， 1 - 开放 2 - 需要审批 approvers: [] // 审批人， 需要审批时有效 }
  function (res) {
    console.log(res);
    if (res["resultCode"] !== 0) {
      if (_.isFunction(failCB)) failCB(res["resultCode"], res["message"]);
    } else {
      if (_.isFunction(successCB)) successCB(res.result, res.total);
    }
  });
}), "getDepOutShareSettings", function getDepOutShareSettings(fileId, successCB, failCB) {
  _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.getDepOutShareSettings", {
    fileId: fileId
  }, function (res) {
    console.log(res);
    if (res["resultCode"] !== 0) {
      if (_.isFunction(failCB)) failCB(res["resultCode"], res["message"]);
    } else {
      var settings = _.extend({
        groupInfos: [],
        userInfos: []
      }, res.settings);
      if (_.isFunction(successCB)) successCB(settings || {}, res.canShareOutInDepartment);
    }
  });
}), "getOutShareApprovers", function getOutShareApprovers(fileId, successCB, failCB) {
  _MMEnterpriseController["default"].request("netDrive.shareHandler.getOutShareApprovers", {
    fileId: fileId
  }, function (res) {
    console.log(res);
    if (res["resultCode"] !== 0) {
      if (_.isFunction(failCB)) failCB(res["resultCode"], res["message"]);
    } else {
      if (_.isFunction(successCB)) successCB(res.result || {});
    }
  });
}), "setBannedIgnoreFile", function setBannedIgnoreFile(params, successCB, failCB) {
  _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.setBannedIgnoreFile", params, function (res) {
    console.log(res);
    if (res["resultCode"] !== 0) {
      if (_.isFunction(failCB)) failCB(res["resultCode"], res["message"]);
    } else {
      if (_.isFunction(successCB)) successCB(res.result || {});
    }
  });
}), "getEntBannedWordsStrategy", function getEntBannedWordsStrategy(successCB, failCB) {
  _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.getEntBannedWordsStrategy", {}, function (res) {
    console.log(res);
    if (res["resultCode"] !== 0) {
      if (_.isFunction(failCB)) failCB(res["resultCode"], res["message"]);
    } else {
      if (_.isFunction(successCB)) successCB(res.strategy);
    }
  });
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_getReviewConfig4File, "uploadThumbnail", function uploadThumbnail(fileId, file, successCB, failCb) {
  var formData = new FormData();
  formData.append("file", file);
  formData.append("fileId", fileId);
  var xhr = MMNetDiskDataController.getXhr();
  xhr.onload = function () {
    if (xhr.status >= 200 && xhr.status < 300) {
      console.log('请求成功（onload）', xhr.responseText);
      var response = JSON.parse(xhr.response);
      if (response["code"] == 0) {
        _.isFunction(successCB) && successCB(response);
      } else {
        _.isFunction(failCb) && failCb(response);
      }
    } else {
      console.log('请求失败（onload）', xhr.statusText);
      _.isFunction(failCb) && failCb(response);
    }
  };
  xhr.open("POST", "file/uploadThumbnail.do", true);
  xhr.send(formData);
}), "uploadCustomIcon", function uploadCustomIcon(fileName, file, successCB, failCb) {
  var formData = new FormData();
  formData.append("file", file);
  formData.append("fileName", fileName);
  var xhr = MMNetDiskDataController.getXhr();
  xhr.onload = function () {
    if (xhr.status >= 200 && xhr.status < 300) {
      console.log('请求成功（onload）', xhr.responseText);
      var response = JSON.parse(xhr.response);
      if (response["code"] == 0) {
        _.isFunction(successCB) && successCB(response);
      } else {
        _.isFunction(failCb) && failCb(response);
      }
    } else {
      console.log('请求失败（onload）', xhr.statusText);
      _.isFunction(failCb) && failCb(response);
    }
  };
  xhr.open("POST", "netdrive/uploadCustomIcon.do", true);
  xhr.send(formData);
}), "getEntCustomIcons", function getEntCustomIcons(successCB, failCb) {
  $.ajax('/netdrive/getEntCustomIcons.do', {
    method: 'post',
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), "removeCustomIcon", function removeCustomIcon(customIconId, successCB, failCb) {
  $.ajax('/netdrive/removeCustomIcon.do', {
    method: 'post',
    data: {
      customIconId: customIconId
    },
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), "setCustomIcon4File", function setCustomIcon4File(params, successCB, failCb) {
  $.ajax('/netdrive/setCustomIcon4File.do', {
    method: 'post',
    data: params,
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), "getAnonymouseDownloadUrl", function getAnonymouseDownloadUrl(param, successCB, failCb) {
  $.ajax('/netdrive/getAnonymouseDownloadUrl.do', {
    method: 'post',
    data: param,
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), "removeCustomIcon4File", function removeCustomIcon4File(params, successCB, failCb) {
  $.ajax('/netdrive/removeCustomIcon4File.do', {
    method: 'post',
    data: params,
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), "updateAnonymouseDownloadUrl", function updateAnonymouseDownloadUrl(params, successCB, failCb) {
  $.ajax('/netdrive/updateAnonymouseDownloadUrl.do', {
    method: 'post',
    data: params,
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), "deleteAnonymousDownloadUrl", function deleteAnonymousDownloadUrl(params, successCB, failCb) {
  $.ajax('/netdrive/deleteAnonymousDownloadUrl.do', {
    method: 'post',
    data: params,
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), "getWatermark4File", function getWatermark4File(fileId, successCB, failCb) {
  $.ajax('/netdrive/getWatermark4File.do', {
    method: 'post',
    data: {
      fileId: fileId
    },
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData.watermark);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_getReviewConfig4File, "createDefaultWatermakr4File", function createDefaultWatermakr4File(param, successCB, failCb) {
  $.ajax('/netdrive/createDefaultWatermakr4File.do', {
    method: 'post',
    data: param,
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData.watermark);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), "updateWatermark4File", function updateWatermark4File(param, successCB, failCb) {
  $.ajax('/netdrive/updateWatermark4File.do', {
    method: 'post',
    data: param,
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData.watermark);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), "deleteWatermark4File", function deleteWatermark4File(fileId, successCB, failCb) {
  $.ajax('/netdrive/deleteWatermark4File.do', {
    method: 'post',
    data: {
      fileId: fileId
    },
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData.watermark);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), "createClassification", function createClassification(param, successCB, failCb) {
  $.ajax('/netdrive/createClassification.do', {
    method: 'post',
    data: param,
    // 应包含 parentId, name
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), "deleteClassification", function deleteClassification(param, successCB, failCb) {
  $.ajax('/netdrive/deleteClassification.do', {
    method: 'post',
    data: param,
    // 应包含 classificationId
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), "addClassifications4Archives", function addClassifications4Archives(param, successCB, failCb) {
  $.ajax('/netdrive/addClassifications4Archives.do', {
    method: 'post',
    data: param,
    // 应包含 classificationIds, fileIds
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), "removeClassifications4Archives", function removeClassifications4Archives(param, successCB, failCb) {
  $.ajax('/netdrive/removeClassifications4Archives.do', {
    method: 'post',
    data: param,
    // 应包含 classificationIds, fileIds
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), "getClassificationByParent", function getClassificationByParent(param, successCB, failCb) {
  $.ajax('/netdrive/getClassificationByParent.do', {
    method: 'post',
    data: param,
    // 应包含 parentId
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), "updateClassification", function updateClassification(param, successCB, failCb) {
  $.ajax('/netdrive/updateClassification.do', {
    method: 'post',
    data: param,
    // 应包含 classificationId, name, parentId（可选）
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), "getClassification", function getClassification(classificationId, successCB, failCb) {
  $.ajax('/netdrive/getClassification.do', {
    method: 'post',
    data: {
      classificationId: classificationId
    },
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        responseData.classification.fileId = responseData.classification.id;
        var out = new _MMFileInfo["default"](responseData.classification);
        _.isFunction(successCB) && successCB(out);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_getReviewConfig4File, "getArchivesByClassification", function getArchivesByClassification(param, successCB, failCb) {
  // param 应包含 classificationId, page, pageSize, orderBy, isAsc
  _MMEnterpriseController["default"].request("netDrive.fileExHandler.getArchivesByClassification", param, function (res) {
    console.warn(res);
    if (res["resultCode"] === 0) {
      var out = new _MMFileInfoCollection["default"]();
      if (!res["fileInfos"]) {
        successCB(out);
        return;
      }
      res["fileInfos"].forEach(function (fileInfo) {
        if (param.classificationId == 0) {
          fileInfo["parentId"] = "0";
        }
        out.push(new _MMFileInfo["default"](fileInfo));
      });
      successCB(out, res.total, res.pages);
    } else {
      failCb(res["resultCode"]);
    }
    // 该接口可能没有统一的 success 字段，直接认为请求成功即调用 successCB
    // _.isFunction(successCB) && successCB(res);
  }, function (err) {
    console.error(err);
    _.isFunction(failCbCb) && failCb(err);
  });
}), "getArchiveNotClassified", function getArchiveNotClassified(param, successCB, failCb) {
  // param 应包含 page, pageSize, orderBy, isAsc
  _MMEnterpriseController["default"].request("netDrive.fileExHandler.getArchiveNotClassified", param, function (res) {
    console.warn(res);
    if (res["resultCode"] === 0) {
      var out = new _MMFileInfoCollection["default"]();
      if (!res["fileInfos"]) {
        successCB(out);
        return;
      }
      res["fileInfos"].forEach(function (fileInfo) {
        // if (param.classificationId == 0) {
        //   fileInfo["parentId"] = "0";
        // }
        out.push(new _MMFileInfo["default"](fileInfo));
      });
      successCB(out, res.total, res.pages);
    } else {
      failCb(res["resultCode"]);
    }
    // 该接口可能没有统一的 success 字段，直接认为请求成功即调用 successCB
    // _.isFunction(successCB) && successCB(res);
  }, function (err) {
    console.error(err);
    _.isFunction(failCbCb) && failCb(err);
  });
}), "getMostActivedArchives", function getMostActivedArchives(param, successCB, failCb) {
  // param 应包含 page, pageSize
  _MMEnterpriseController["default"].request("netDrive.fileExHandler.getMostActivedArchives", param, function (res) {
    console.warn(res);
    if (res["resultCode"] === 0) {
      var out = new _MMFileInfoCollection["default"]();
      if (!res["fileInfos"]) {
        successCB(out);
        return;
      }
      res["fileInfos"].forEach(function (fileInfo) {
        // if (param.classificationId == 0) {
        //   fileInfo["parentId"] = "0";
        // }
        out.push(new _MMFileInfo["default"](fileInfo));
      });
      successCB(out, res.total, res.pages);
    } else {
      failCb(res["resultCode"]);
    }
    // 该接口可能没有统一的 success 字段，直接认为请求成功即调用 successCB
    // _.isFunction(successCB) && successCB(res);
  }, function (err) {
    console.error(err);
    _.isFunction(failCbCb) && failCb(err);
  });
}), "getRecentlyArchived", function getRecentlyArchived(param, successCB, failCb) {
  // param 应包含 page, pageSize
  _MMEnterpriseController["default"].request("netDrive.fileExHandler.getRecentlyArchived", param, function (res) {
    console.warn(res);
    if (res["resultCode"] === 0) {
      var out = new _MMFileInfoCollection["default"]();
      if (!res["fileInfos"]) {
        successCB(out);
        return;
      }
      res["fileInfos"].forEach(function (fileInfo) {
        // if (param.classificationId == 0) {
        //   fileInfo["parentId"] = "0";
        // }
        out.push(new _MMFileInfo["default"](fileInfo));
      });
      successCB(out, res.total, res.pages);
    } else {
      failCb(res["resultCode"]);
    }
    // 该接口可能没有统一的 success 字段，直接认为请求成功即调用 successCB
    // _.isFunction(successCB) && successCB(res);
  }, function (err) {
    console.error(err);
    _.isFunction(failCbCb) && failCb(err);
  });
}), "listArchClassApply", function listArchClassApply(param, successCB, failCb) {
  $.ajax('/netdrive/listArchClassApply.do', {
    method: 'post',
    data: param,
    // 应包含 pageSize, page
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        // 使用 underscore 处理
        _.each(responseData.applies, function (apply) {
          var user = _.findWhere(responseData.users, {
            id: apply.commiter
          });
          if (user) {
            apply.commiterName = user.name;
          }
          apply.fileId = apply.id;
        });
        var fileCollection = new _MMFileInfoCollection["default"](responseData.applies);
        _.isFunction(successCB) && successCB(fileCollection);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), "getClassificationsByArchiveIds", function getClassificationsByArchiveIds(fileIds, successCB, failCb) {
  $.ajax('/netdrive/getClassificationsByArchiveIds.do', {
    method: 'post',
    data: {
      fileIds: fileIds
    },
    // 逗号隔开
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), "editClassArchive", function editClassArchive(params, successCB, failCb) {
  $.ajax('/netdrive/editClassArchive.do', {
    method: 'post',
    data: params,
    // fileIds,classificationIds.delFileIds,delClassificationIds
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), "countArchClassApply", function countArchClassApply(successCB, failCb) {
  $.ajax('/netdrive/countArchClassApply.do', {
    method: 'post',
    data: {},
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData["total"]);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), "getOneArchClassApplyInfo", function getOneArchClassApplyInfo(applyId, successCB, failCb) {
  $.ajax('/netdrive/getOneArchClassApplyInfo.do', {
    method: 'post',
    data: {
      applyId: applyId
    },
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), "reviewApplyArchiveClass", function reviewApplyArchiveClass(param, successCB, failCb) {
  $.ajax('/netdrive/reviewApplyArchiveClass.do', {
    method: 'post',
    data: param,
    //fileIds,classificationIds,delClassificationIds,applyId:
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_getReviewConfig4File, "searchClassification", function searchClassification(param, successCB, failCb) {
  $.ajax('/netdrive/searchClassification.do', {
    method: 'post',
    data: {
      name: param.keyword
    },
    //fileIds,classificationIds,delClassificationIds,applyId:
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), "createCusttomEntAttr", function createCusttomEntAttr(param, successCB, failCb) {
  $.ajax('/enterprise/createCusttomEntAttr.do', {
    method: 'post',
    data: param,
    //title type notNull
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        var out = new _MMNormal["default"](responseData.customAttr);
        _.isFunction(successCB) && successCB(out);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), "updateCusttomEntAttr", function updateCusttomEntAttr(param, successCB, failCb) {
  $.ajax('/enterprise/updateCusttomEntAttr.do', {
    method: 'post',
    traditional: true,
    data: param,
    //attrId title notNull
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), "insertEntAltEntries", function insertEntAltEntries(params, successCB, failCb) {
  $.ajax('/enterprise/insertEntAltEntries.do', {
    method: 'post',
    traditional: true,
    data: {
      attrId: params.attrId,
      valueArr: params.valueArr,
      orderArr: params.orderArr || []
    },
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), "updateCustomEntAttrAltEntries", function updateCustomEntAttrAltEntries(params, successCB, failCb) {
  $.ajax('/enterprise/updateCustomEntAttrAltEntries.do', {
    method: 'post',
    traditional: true,
    data: {
      attrId: params.attrId,
      altIdArr: params.altIdArr || [],
      valueArr: params.valueArr || [],
      orderArr: params.orderArr || []
    },
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), "deleteCustomEntAttrAltEntry", function deleteCustomEntAttrAltEntry(params, successCB, failCb) {
  $.ajax('/enterprise/deleteCustomEntAttrAltEntry.do', {
    method: 'post',
    traditional: true,
    data: {
      attrId: params.attrId,
      altIdArr: params.altIdArr || []
    },
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), "updateCustomEntAttrAltEntryOrders", function updateCustomEntAttrAltEntryOrders(params, successCB, failCb) {
  $.ajax('/enterprise/updateCustomEntAttrAltEntryOrders.do', {
    method: 'post',
    traditional: true,
    data: {
      attrId: params.attrId,
      altIdArr: params.altIdArr || [],
      orderArr: params.orderArr || []
    },
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), "deleteCustomEntAttr", function deleteCustomEntAttr(params, successCB, failCb) {
  $.ajax('/enterprise/deleteCustomEntAttr.do', {
    method: 'post',
    data: {
      attrId: params.attrId
    },
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), "updateFilesAttrs", function updateFilesAttrs(params, successCB, failCb) {
  $.ajax('/enterprise/updateFilesAttrs.do', {
    method: 'post',
    traditional: true,
    data: params,
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), "getFileAttr", function getFileAttr(params, successCB, failCb) {
  $.ajax('/enterprise/getFileAttr.do', {
    method: 'post',
    traditional: true,
    data: params,
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_getReviewConfig4File, "reviewApplyFileAttr", function reviewApplyFileAttr(params, successCB, failCb) {
  $.ajax('/enterprise/reviewApplyFileAttr.do', {
    method: 'post',
    traditional: true,
    data: params,
    success: function success(responseData) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    error: function error(responseData) {
      _.isFunction(failCb) && failCb(responseData);
    }
  });
}), "searchFilesByAttr", function searchFilesByAttr(params, successCB, failCb) {
  _MMEnterpriseController["default"].request("netDrive.fileExHandler.searchFilesByAttr", params, function (rt) {
    if (rt && rt.resultCode === 0) {
      _.isFunction(successCB) && successCB(rt);
    } else {
      _.isFunction(failCb) && failCb(rt);
    }
  });
}), "createMcpApp", function createMcpApp(fileId, app_name, successCB, failCb) {
  $.ajax({
    url: "/mcp_service/createMcpApp.do",
    method: "post",
    data: {
      fileId: fileId,
      app_name: app_name
    },
    success: function success(responseData, textStatus, jaXHR) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    fail: function fail(res) {
      _.isFunction(failCb) && failCb(res);
    }
  });
}), "updateMcpAppName", function updateMcpAppName(mcp_id, app_name, successCB, failCb) {
  $.ajax({
    url: "/mcp_service/updateMcpAppName.do",
    method: "post",
    data: {
      mcp_id: mcp_id,
      app_name: app_name
    },
    success: function success(responseData, textStatus, jaXHR) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB();
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    fail: function fail(res) {
      _.isFunction(failCb) && failCb(res);
    }
  });
}), "listMcpApp", function listMcpApp(successCB, failCb) {
  $.ajax({
    url: "/mcp_service/listMcpApp.do",
    method: "post",
    data: {},
    success: function success(responseData, textStatus, jaXHR) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData.mcp_apps);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    fail: function fail(res) {
      _.isFunction(failCb) && failCb(res);
    }
  });
}), "updateCallbackUrl", function updateCallbackUrl(callback_uri, mcp_id, successCB, failCb) {
  $.ajax({
    url: "/mcp_service/updateCallbackUrl.do",
    method: "post",
    data: {
      callback_uri: callback_uri,
      mcp_id: mcp_id
    },
    success: function success(responseData, textStatus, jaXHR) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB();
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    fail: function fail(res) {
      _.isFunction(failCb) && failCb(res);
    }
  });
}), "updateMcpJwtKey", function updateMcpJwtKey(jwt_key, mcp_id, successCB, failCb) {
  $.ajax({
    url: "/mcp_service/updateMcpJwtKey.do",
    method: "post",
    data: {
      jwt_key: jwt_key,
      mcp_id: mcp_id
    },
    success: function success(responseData, textStatus, jaXHR) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB();
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    fail: function fail(res) {
      _.isFunction(failCb) && failCb(res);
    }
  });
}), "updateMcpAccountPermission", function updateMcpAccountPermission(account_permisson, mcp_id, successCB, failCb) {
  $.ajax({
    url: "/mcp_service/updateMcpAccountPermission.do",
    method: "post",
    data: {
      account_permisson: account_permisson,
      mcp_id: mcp_id
    },
    success: function success(responseData, textStatus, jaXHR) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB();
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    fail: function fail(res) {
      _.isFunction(failCb) && failCb(res);
    }
  });
}), "updateMcpFilePermission", function updateMcpFilePermission(file_permisson, mcp_id, successCB, failCb) {
  $.ajax({
    url: "/mcp_service/updateMcpFilePermission.do",
    method: "post",
    data: {
      file_permisson: file_permisson,
      mcp_id: mcp_id
    },
    success: function success(responseData, textStatus, jaXHR) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB();
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    fail: function fail(res) {
      _.isFunction(failCb) && failCb(res);
    }
  });
}), "updateMcpCollabPermission", function updateMcpCollabPermission(collab_permisson, mcp_id, successCB, failCb) {
  $.ajax({
    url: "/mcp_service/updateMcpCollabPermission.do",
    method: "post",
    data: {
      collab_permisson: collab_permisson,
      mcp_id: mcp_id
    },
    success: function success(responseData, textStatus, jaXHR) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB();
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    fail: function fail(res) {
      _.isFunction(failCb) && failCb(res);
    }
  });
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_getReviewConfig4File, "deleteMcpApp", function deleteMcpApp(mcp_id, successCB, failCb) {
  $.ajax({
    url: "/mcp_service/deleteMcpApp.do",
    method: "post",
    data: {
      mcp_id: mcp_id
    },
    success: function success(responseData, textStatus, jaXHR) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB();
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    fail: function fail(res) {
      _.isFunction(failCb) && failCb(res);
    }
  });
}), "insertMcpAppCallback", function insertMcpAppCallback(callback_uri, mcp_id, successCB, failCb) {
  $.ajax({
    url: "/mcp_service/insertMcpAppCallback.do",
    method: "post",
    data: {
      mcp_id: mcp_id,
      callback_uri: callback_uri
    },
    success: function success(responseData, textStatus, jaXHR) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB();
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    fail: function fail(res) {
      _.isFunction(failCb) && failCb(res);
    }
  });
}), "deleteMcpCallbackUri", function deleteMcpCallbackUri(mcp_id, successCB, failCb) {
  $.ajax({
    url: "/mcp_service/deleteMcpCallbackUri.do",
    method: "post",
    data: {
      mcp_id: mcp_id
    },
    success: function success(responseData, textStatus, jaXHR) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB();
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    fail: function fail(res) {
      _.isFunction(failCb) && failCb(res);
    }
  });
}), "getMcpAppCallback", function getMcpAppCallback(mcp_id, successCB, failCb) {
  $.ajax({
    url: "/mcp_service/getMcpAppCallback.do",
    method: "post",
    data: {
      mcp_id: mcp_id
    },
    success: function success(responseData, textStatus, jaXHR) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData["mcp_callbackUris"]);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    fail: function fail(res) {
      _.isFunction(failCb) && failCb(res);
    }
  });
}), "getAccessToken", function getAccessToken(app_key, reset, successCB, failCb) {
  $.ajax({
    url: "/api/getAccessToken.do",
    method: "post",
    data: {
      app_key: app_key,
      reset: reset
    },
    success: function success(responseData, textStatus, jaXHR) {
      console.warn(responseData);
      if (responseData.success) {
        _.isFunction(successCB) && successCB(responseData["appAccessCode"]);
      } else {
        _.isFunction(failCb) && failCb(responseData);
      }
    },
    fail: function fail(res) {
      _.isFunction(failCb) && failCb(res);
    }
  });
}));

},{"1098":1098,"1180":1180,"1184":1184,"1192":1192,"1412":1412,"1418":1418,"1423":1423,"1424":1424,"1429":1429,"1432":1432,"1439":1439,"1454":1454,"1455":1455,"1461":1461,"1463":1463,"1471":1471,"1487":1487,"1537":1537,"1538":1538,"1541":1541,"1543":1543,"1545":1545,"240":240,"273":273,"297":297,"298":298,"304":304,"305":305}],1545:[function(require,module,exports){
// TODO: Remove this module from `core-js@4` since it's replaced to module below
require(1544);

},{"1544":1544}],1544:[function(require,module,exports){
'use strict';
// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
require(1487);
var $ = require(1270);
var DESCRIPTORS = require(1251);
var USE_NATIVE_URL = require(1401);
var global = require(1287);
var bind = require(1275);
var uncurryThis = require(1281);
var defineBuiltIn = require(1247);
var defineBuiltInAccessor = require(1246);
var anInstance = require(1208);
var hasOwn = require(1288);
var assign = require(1325);
var arrayFrom = require(1218);
var arraySlice = require(1226);
var codeAt = require(1369).codeAt;
var toASCII = require(1372);
var $toString = require(1393);
var setToStringTag = require(1363);
var validateArgumentsLength = require(1404);
var URLSearchParamsModule = require(1542);
var InternalStateModule = require(1298);

var setInternalState = InternalStateModule.set;
var getInternalURLState = InternalStateModule.getterFor('URL');
var URLSearchParams = URLSearchParamsModule.URLSearchParams;
var getInternalSearchParamsState = URLSearchParamsModule.getState;

var NativeURL = global.URL;
var TypeError = global.TypeError;
var parseInt = global.parseInt;
var floor = Math.floor;
var pow = Math.pow;
var charAt = uncurryThis(''.charAt);
var exec = uncurryThis(/./.exec);
var join = uncurryThis([].join);
var numberToString = uncurryThis(1.0.toString);
var pop = uncurryThis([].pop);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var shift = uncurryThis([].shift);
var split = uncurryThis(''.split);
var stringSlice = uncurryThis(''.slice);
var toLowerCase = uncurryThis(''.toLowerCase);
var unshift = uncurryThis([].unshift);

var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';

var ALPHA = /[a-z]/i;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var ALPHANUMERIC = /[\d+-.a-z]/i;
var DIGIT = /\d/;
var HEX_START = /^0x/i;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */
var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+|[\u0000-\u0020]+$/g;
var TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */
var EOF;

// https://url.spec.whatwg.org/#ipv4-number-parser
var parseIPv4 = function (input) {
  var parts = split(input, '.');
  var partsLength, numbers, index, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] == '') {
    parts.length--;
  }
  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];
  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part == '') return input;
    radix = 10;
    if (part.length > 1 && charAt(part, 0) == '0') {
      radix = exec(HEX_START, part) ? 16 : 8;
      part = stringSlice(part, radix == 8 ? 1 : 2);
    }
    if (part === '') {
      number = 0;
    } else {
      if (!exec(radix == 10 ? DEC : radix == 8 ? OCT : HEX, part)) return input;
      number = parseInt(part, radix);
    }
    push(numbers, number);
  }
  for (index = 0; index < partsLength; index++) {
    number = numbers[index];
    if (index == partsLength - 1) {
      if (number >= pow(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }
  ipv4 = pop(numbers);
  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow(256, 3 - index);
  }
  return ipv4;
};

// https://url.spec.whatwg.org/#concept-ipv6-parser
// eslint-disable-next-line max-statements -- TODO
var parseIPv6 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var chr = function () {
    return charAt(input, pointer);
  };

  if (chr() == ':') {
    if (charAt(input, 1) != ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (chr()) {
    if (pieceIndex == 8) return;
    if (chr() == ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && exec(HEX, chr())) {
      value = value * 16 + parseInt(chr(), 16);
      pointer++;
      length++;
    }
    if (chr() == '.') {
      if (length == 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;
      while (chr()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (chr() == '.' && numbersSeen < 4) pointer++;
          else return;
        }
        if (!exec(DIGIT, chr())) return;
        while (exec(DIGIT, chr())) {
          number = parseInt(chr(), 10);
          if (ipv4Piece === null) ipv4Piece = number;
          else if (ipv4Piece == 0) return;
          else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
      }
      if (numbersSeen != 4) return;
      break;
    } else if (chr() == ':') {
      pointer++;
      if (!chr()) return;
    } else if (chr()) return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex != 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex != 8) return;
  return address;
};

var findLongestZeroSequence = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;
  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }
  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }
  return maxIndex;
};

// https://url.spec.whatwg.org/#host-serializing
var serializeHost = function (host) {
  var result, index, compress, ignore0;
  // ipv4
  if (typeof host == 'number') {
    result = [];
    for (index = 0; index < 4; index++) {
      unshift(result, host % 256);
      host = floor(host / 256);
    } return join(result, '.');
  // ipv6
  } else if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);
    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;
      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += numberToString(host[index], 16);
        if (index < 7) result += ':';
      }
    }
    return '[' + result + ']';
  } return host;
};

var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
});
var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
  '#': 1, '?': 1, '{': 1, '}': 1
});
var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
});

var percentEncode = function (chr, set) {
  var code = codeAt(chr, 0);
  return code > 0x20 && code < 0x7F && !hasOwn(set, chr) ? chr : encodeURIComponent(chr);
};

// https://url.spec.whatwg.org/#special-scheme
var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};

// https://url.spec.whatwg.org/#windows-drive-letter
var isWindowsDriveLetter = function (string, normalized) {
  var second;
  return string.length == 2 && exec(ALPHA, charAt(string, 0))
    && ((second = charAt(string, 1)) == ':' || (!normalized && second == '|'));
};

// https://url.spec.whatwg.org/#start-with-a-windows-drive-letter
var startsWithWindowsDriveLetter = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(stringSlice(string, 0, 2)) && (
    string.length == 2 ||
    ((third = charAt(string, 2)) === '/' || third === '\\' || third === '?' || third === '#')
  );
};

// https://url.spec.whatwg.org/#single-dot-path-segment
var isSingleDot = function (segment) {
  return segment === '.' || toLowerCase(segment) === '%2e';
};

// https://url.spec.whatwg.org/#double-dot-path-segment
var isDoubleDot = function (segment) {
  segment = toLowerCase(segment);
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};

// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

var URLState = function (url, isBase, base) {
  var urlString = $toString(url);
  var baseState, failure, searchParams;
  if (isBase) {
    failure = this.parse(urlString);
    if (failure) throw TypeError(failure);
    this.searchParams = null;
  } else {
    if (base !== undefined) baseState = new URLState(base, true);
    failure = this.parse(urlString, null, baseState);
    if (failure) throw TypeError(failure);
    searchParams = getInternalSearchParamsState(new URLSearchParams());
    searchParams.bindURL(this);
    this.searchParams = searchParams;
  }
};

URLState.prototype = {
  type: 'URL',
  // https://url.spec.whatwg.org/#url-parsing
  // eslint-disable-next-line max-statements -- TODO
  parse: function (input, stateOverride, base) {
    var url = this;
    var state = stateOverride || SCHEME_START;
    var pointer = 0;
    var buffer = '';
    var seenAt = false;
    var seenBracket = false;
    var seenPasswordToken = false;
    var codePoints, chr, bufferCodePoints, failure;

    input = $toString(input);

    if (!stateOverride) {
      url.scheme = '';
      url.username = '';
      url.password = '';
      url.host = null;
      url.port = null;
      url.path = [];
      url.query = null;
      url.fragment = null;
      url.cannotBeABaseURL = false;
      input = replace(input, LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE, '');
    }

    input = replace(input, TAB_AND_NEW_LINE, '');

    codePoints = arrayFrom(input);

    while (pointer <= codePoints.length) {
      chr = codePoints[pointer];
      switch (state) {
        case SCHEME_START:
          if (chr && exec(ALPHA, chr)) {
            buffer += toLowerCase(chr);
            state = SCHEME;
          } else if (!stateOverride) {
            state = NO_SCHEME;
            continue;
          } else return INVALID_SCHEME;
          break;

        case SCHEME:
          if (chr && (exec(ALPHANUMERIC, chr) || chr == '+' || chr == '-' || chr == '.')) {
            buffer += toLowerCase(chr);
          } else if (chr == ':') {
            if (stateOverride && (
              (url.isSpecial() != hasOwn(specialSchemes, buffer)) ||
              (buffer == 'file' && (url.includesCredentials() || url.port !== null)) ||
              (url.scheme == 'file' && !url.host)
            )) return;
            url.scheme = buffer;
            if (stateOverride) {
              if (url.isSpecial() && specialSchemes[url.scheme] == url.port) url.port = null;
              return;
            }
            buffer = '';
            if (url.scheme == 'file') {
              state = FILE;
            } else if (url.isSpecial() && base && base.scheme == url.scheme) {
              state = SPECIAL_RELATIVE_OR_AUTHORITY;
            } else if (url.isSpecial()) {
              state = SPECIAL_AUTHORITY_SLASHES;
            } else if (codePoints[pointer + 1] == '/') {
              state = PATH_OR_AUTHORITY;
              pointer++;
            } else {
              url.cannotBeABaseURL = true;
              push(url.path, '');
              state = CANNOT_BE_A_BASE_URL_PATH;
            }
          } else if (!stateOverride) {
            buffer = '';
            state = NO_SCHEME;
            pointer = 0;
            continue;
          } else return INVALID_SCHEME;
          break;

        case NO_SCHEME:
          if (!base || (base.cannotBeABaseURL && chr != '#')) return INVALID_SCHEME;
          if (base.cannotBeABaseURL && chr == '#') {
            url.scheme = base.scheme;
            url.path = arraySlice(base.path);
            url.query = base.query;
            url.fragment = '';
            url.cannotBeABaseURL = true;
            state = FRAGMENT;
            break;
          }
          state = base.scheme == 'file' ? FILE : RELATIVE;
          continue;

        case SPECIAL_RELATIVE_OR_AUTHORITY:
          if (chr == '/' && codePoints[pointer + 1] == '/') {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
            pointer++;
          } else {
            state = RELATIVE;
            continue;
          } break;

        case PATH_OR_AUTHORITY:
          if (chr == '/') {
            state = AUTHORITY;
            break;
          } else {
            state = PATH;
            continue;
          }

        case RELATIVE:
          url.scheme = base.scheme;
          if (chr == EOF) {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = base.query;
          } else if (chr == '/' || (chr == '\\' && url.isSpecial())) {
            state = RELATIVE_SLASH;
          } else if (chr == '?') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = '';
            state = QUERY;
          } else if (chr == '#') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.path.length--;
            state = PATH;
            continue;
          } break;

        case RELATIVE_SLASH:
          if (url.isSpecial() && (chr == '/' || chr == '\\')) {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          } else if (chr == '/') {
            state = AUTHORITY;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            state = PATH;
            continue;
          } break;

        case SPECIAL_AUTHORITY_SLASHES:
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          if (chr != '/' || charAt(buffer, pointer + 1) != '/') continue;
          pointer++;
          break;

        case SPECIAL_AUTHORITY_IGNORE_SLASHES:
          if (chr != '/' && chr != '\\') {
            state = AUTHORITY;
            continue;
          } break;

        case AUTHORITY:
          if (chr == '@') {
            if (seenAt) buffer = '%40' + buffer;
            seenAt = true;
            bufferCodePoints = arrayFrom(buffer);
            for (var i = 0; i < bufferCodePoints.length; i++) {
              var codePoint = bufferCodePoints[i];
              if (codePoint == ':' && !seenPasswordToken) {
                seenPasswordToken = true;
                continue;
              }
              var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
              if (seenPasswordToken) url.password += encodedCodePoints;
              else url.username += encodedCodePoints;
            }
            buffer = '';
          } else if (
            chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
            (chr == '\\' && url.isSpecial())
          ) {
            if (seenAt && buffer == '') return INVALID_AUTHORITY;
            pointer -= arrayFrom(buffer).length + 1;
            buffer = '';
            state = HOST;
          } else buffer += chr;
          break;

        case HOST:
        case HOSTNAME:
          if (stateOverride && url.scheme == 'file') {
            state = FILE_HOST;
            continue;
          } else if (chr == ':' && !seenBracket) {
            if (buffer == '') return INVALID_HOST;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PORT;
            if (stateOverride == HOSTNAME) return;
          } else if (
            chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
            (chr == '\\' && url.isSpecial())
          ) {
            if (url.isSpecial() && buffer == '') return INVALID_HOST;
            if (stateOverride && buffer == '' && (url.includesCredentials() || url.port !== null)) return;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PATH_START;
            if (stateOverride) return;
            continue;
          } else {
            if (chr == '[') seenBracket = true;
            else if (chr == ']') seenBracket = false;
            buffer += chr;
          } break;

        case PORT:
          if (exec(DIGIT, chr)) {
            buffer += chr;
          } else if (
            chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
            (chr == '\\' && url.isSpecial()) ||
            stateOverride
          ) {
            if (buffer != '') {
              var port = parseInt(buffer, 10);
              if (port > 0xFFFF) return INVALID_PORT;
              url.port = (url.isSpecial() && port === specialSchemes[url.scheme]) ? null : port;
              buffer = '';
            }
            if (stateOverride) return;
            state = PATH_START;
            continue;
          } else return INVALID_PORT;
          break;

        case FILE:
          url.scheme = 'file';
          if (chr == '/' || chr == '\\') state = FILE_SLASH;
          else if (base && base.scheme == 'file') {
            if (chr == EOF) {
              url.host = base.host;
              url.path = arraySlice(base.path);
              url.query = base.query;
            } else if (chr == '?') {
              url.host = base.host;
              url.path = arraySlice(base.path);
              url.query = '';
              state = QUERY;
            } else if (chr == '#') {
              url.host = base.host;
              url.path = arraySlice(base.path);
              url.query = base.query;
              url.fragment = '';
              state = FRAGMENT;
            } else {
              if (!startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.shortenPath();
              }
              state = PATH;
              continue;
            }
          } else {
            state = PATH;
            continue;
          } break;

        case FILE_SLASH:
          if (chr == '/' || chr == '\\') {
            state = FILE_HOST;
            break;
          }
          if (base && base.scheme == 'file' && !startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
            if (isWindowsDriveLetter(base.path[0], true)) push(url.path, base.path[0]);
            else url.host = base.host;
          }
          state = PATH;
          continue;

        case FILE_HOST:
          if (chr == EOF || chr == '/' || chr == '\\' || chr == '?' || chr == '#') {
            if (!stateOverride && isWindowsDriveLetter(buffer)) {
              state = PATH;
            } else if (buffer == '') {
              url.host = '';
              if (stateOverride) return;
              state = PATH_START;
            } else {
              failure = url.parseHost(buffer);
              if (failure) return failure;
              if (url.host == 'localhost') url.host = '';
              if (stateOverride) return;
              buffer = '';
              state = PATH_START;
            } continue;
          } else buffer += chr;
          break;

        case PATH_START:
          if (url.isSpecial()) {
            state = PATH;
            if (chr != '/' && chr != '\\') continue;
          } else if (!stateOverride && chr == '?') {
            url.query = '';
            state = QUERY;
          } else if (!stateOverride && chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr != EOF) {
            state = PATH;
            if (chr != '/') continue;
          } break;

        case PATH:
          if (
            chr == EOF || chr == '/' ||
            (chr == '\\' && url.isSpecial()) ||
            (!stateOverride && (chr == '?' || chr == '#'))
          ) {
            if (isDoubleDot(buffer)) {
              url.shortenPath();
              if (chr != '/' && !(chr == '\\' && url.isSpecial())) {
                push(url.path, '');
              }
            } else if (isSingleDot(buffer)) {
              if (chr != '/' && !(chr == '\\' && url.isSpecial())) {
                push(url.path, '');
              }
            } else {
              if (url.scheme == 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
                if (url.host) url.host = '';
                buffer = charAt(buffer, 0) + ':'; // normalize windows drive letter
              }
              push(url.path, buffer);
            }
            buffer = '';
            if (url.scheme == 'file' && (chr == EOF || chr == '?' || chr == '#')) {
              while (url.path.length > 1 && url.path[0] === '') {
                shift(url.path);
              }
            }
            if (chr == '?') {
              url.query = '';
              state = QUERY;
            } else if (chr == '#') {
              url.fragment = '';
              state = FRAGMENT;
            }
          } else {
            buffer += percentEncode(chr, pathPercentEncodeSet);
          } break;

        case CANNOT_BE_A_BASE_URL_PATH:
          if (chr == '?') {
            url.query = '';
            state = QUERY;
          } else if (chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr != EOF) {
            url.path[0] += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case QUERY:
          if (!stateOverride && chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr != EOF) {
            if (chr == "'" && url.isSpecial()) url.query += '%27';
            else if (chr == '#') url.query += '%23';
            else url.query += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case FRAGMENT:
          if (chr != EOF) url.fragment += percentEncode(chr, fragmentPercentEncodeSet);
          break;
      }

      pointer++;
    }
  },
  // https://url.spec.whatwg.org/#host-parsing
  parseHost: function (input) {
    var result, codePoints, index;
    if (charAt(input, 0) == '[') {
      if (charAt(input, input.length - 1) != ']') return INVALID_HOST;
      result = parseIPv6(stringSlice(input, 1, -1));
      if (!result) return INVALID_HOST;
      this.host = result;
    // opaque host
    } else if (!this.isSpecial()) {
      if (exec(FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return INVALID_HOST;
      result = '';
      codePoints = arrayFrom(input);
      for (index = 0; index < codePoints.length; index++) {
        result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
      }
      this.host = result;
    } else {
      input = toASCII(input);
      if (exec(FORBIDDEN_HOST_CODE_POINT, input)) return INVALID_HOST;
      result = parseIPv4(input);
      if (result === null) return INVALID_HOST;
      this.host = result;
    }
  },
  // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
  cannotHaveUsernamePasswordPort: function () {
    return !this.host || this.cannotBeABaseURL || this.scheme == 'file';
  },
  // https://url.spec.whatwg.org/#include-credentials
  includesCredentials: function () {
    return this.username != '' || this.password != '';
  },
  // https://url.spec.whatwg.org/#is-special
  isSpecial: function () {
    return hasOwn(specialSchemes, this.scheme);
  },
  // https://url.spec.whatwg.org/#shorten-a-urls-path
  shortenPath: function () {
    var path = this.path;
    var pathSize = path.length;
    if (pathSize && (this.scheme != 'file' || pathSize != 1 || !isWindowsDriveLetter(path[0], true))) {
      path.length--;
    }
  },
  // https://url.spec.whatwg.org/#concept-url-serializer
  serialize: function () {
    var url = this;
    var scheme = url.scheme;
    var username = url.username;
    var password = url.password;
    var host = url.host;
    var port = url.port;
    var path = url.path;
    var query = url.query;
    var fragment = url.fragment;
    var output = scheme + ':';
    if (host !== null) {
      output += '//';
      if (url.includesCredentials()) {
        output += username + (password ? ':' + password : '') + '@';
      }
      output += serializeHost(host);
      if (port !== null) output += ':' + port;
    } else if (scheme == 'file') output += '//';
    output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
    if (query !== null) output += '?' + query;
    if (fragment !== null) output += '#' + fragment;
    return output;
  },
  // https://url.spec.whatwg.org/#dom-url-href
  setHref: function (href) {
    var failure = this.parse(href);
    if (failure) throw TypeError(failure);
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-origin
  getOrigin: function () {
    var scheme = this.scheme;
    var port = this.port;
    if (scheme == 'blob') try {
      return new URLConstructor(scheme.path[0]).origin;
    } catch (error) {
      return 'null';
    }
    if (scheme == 'file' || !this.isSpecial()) return 'null';
    return scheme + '://' + serializeHost(this.host) + (port !== null ? ':' + port : '');
  },
  // https://url.spec.whatwg.org/#dom-url-protocol
  getProtocol: function () {
    return this.scheme + ':';
  },
  setProtocol: function (protocol) {
    this.parse($toString(protocol) + ':', SCHEME_START);
  },
  // https://url.spec.whatwg.org/#dom-url-username
  getUsername: function () {
    return this.username;
  },
  setUsername: function (username) {
    var codePoints = arrayFrom($toString(username));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.username = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-password
  getPassword: function () {
    return this.password;
  },
  setPassword: function (password) {
    var codePoints = arrayFrom($toString(password));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.password = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-host
  getHost: function () {
    var host = this.host;
    var port = this.port;
    return host === null ? ''
      : port === null ? serializeHost(host)
      : serializeHost(host) + ':' + port;
  },
  setHost: function (host) {
    if (this.cannotBeABaseURL) return;
    this.parse(host, HOST);
  },
  // https://url.spec.whatwg.org/#dom-url-hostname
  getHostname: function () {
    var host = this.host;
    return host === null ? '' : serializeHost(host);
  },
  setHostname: function (hostname) {
    if (this.cannotBeABaseURL) return;
    this.parse(hostname, HOSTNAME);
  },
  // https://url.spec.whatwg.org/#dom-url-port
  getPort: function () {
    var port = this.port;
    return port === null ? '' : $toString(port);
  },
  setPort: function (port) {
    if (this.cannotHaveUsernamePasswordPort()) return;
    port = $toString(port);
    if (port == '') this.port = null;
    else this.parse(port, PORT);
  },
  // https://url.spec.whatwg.org/#dom-url-pathname
  getPathname: function () {
    var path = this.path;
    return this.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
  },
  setPathname: function (pathname) {
    if (this.cannotBeABaseURL) return;
    this.path = [];
    this.parse(pathname, PATH_START);
  },
  // https://url.spec.whatwg.org/#dom-url-search
  getSearch: function () {
    var query = this.query;
    return query ? '?' + query : '';
  },
  setSearch: function (search) {
    search = $toString(search);
    if (search == '') {
      this.query = null;
    } else {
      if ('?' == charAt(search, 0)) search = stringSlice(search, 1);
      this.query = '';
      this.parse(search, QUERY);
    }
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-searchparams
  getSearchParams: function () {
    return this.searchParams.facade;
  },
  // https://url.spec.whatwg.org/#dom-url-hash
  getHash: function () {
    var fragment = this.fragment;
    return fragment ? '#' + fragment : '';
  },
  setHash: function (hash) {
    hash = $toString(hash);
    if (hash == '') {
      this.fragment = null;
      return;
    }
    if ('#' == charAt(hash, 0)) hash = stringSlice(hash, 1);
    this.fragment = '';
    this.parse(hash, FRAGMENT);
  },
  update: function () {
    this.query = this.searchParams.serialize() || null;
  }
};

// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */) {
  var that = anInstance(this, URLPrototype);
  var base = validateArgumentsLength(arguments.length, 1) > 1 ? arguments[1] : undefined;
  var state = setInternalState(that, new URLState(url, false, base));
  if (!DESCRIPTORS) {
    that.href = state.serialize();
    that.origin = state.getOrigin();
    that.protocol = state.getProtocol();
    that.username = state.getUsername();
    that.password = state.getPassword();
    that.host = state.getHost();
    that.hostname = state.getHostname();
    that.port = state.getPort();
    that.pathname = state.getPathname();
    that.search = state.getSearch();
    that.searchParams = state.getSearchParams();
    that.hash = state.getHash();
  }
};

var URLPrototype = URLConstructor.prototype;

var accessorDescriptor = function (getter, setter) {
  return {
    get: function () {
      return getInternalURLState(this)[getter]();
    },
    set: setter && function (value) {
      return getInternalURLState(this)[setter](value);
    },
    configurable: true,
    enumerable: true
  };
};

if (DESCRIPTORS) {
  // `URL.prototype.href` accessors pair
  // https://url.spec.whatwg.org/#dom-url-href
  defineBuiltInAccessor(URLPrototype, 'href', accessorDescriptor('serialize', 'setHref'));
  // `URL.prototype.origin` getter
  // https://url.spec.whatwg.org/#dom-url-origin
  defineBuiltInAccessor(URLPrototype, 'origin', accessorDescriptor('getOrigin'));
  // `URL.prototype.protocol` accessors pair
  // https://url.spec.whatwg.org/#dom-url-protocol
  defineBuiltInAccessor(URLPrototype, 'protocol', accessorDescriptor('getProtocol', 'setProtocol'));
  // `URL.prototype.username` accessors pair
  // https://url.spec.whatwg.org/#dom-url-username
  defineBuiltInAccessor(URLPrototype, 'username', accessorDescriptor('getUsername', 'setUsername'));
  // `URL.prototype.password` accessors pair
  // https://url.spec.whatwg.org/#dom-url-password
  defineBuiltInAccessor(URLPrototype, 'password', accessorDescriptor('getPassword', 'setPassword'));
  // `URL.prototype.host` accessors pair
  // https://url.spec.whatwg.org/#dom-url-host
  defineBuiltInAccessor(URLPrototype, 'host', accessorDescriptor('getHost', 'setHost'));
  // `URL.prototype.hostname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hostname
  defineBuiltInAccessor(URLPrototype, 'hostname', accessorDescriptor('getHostname', 'setHostname'));
  // `URL.prototype.port` accessors pair
  // https://url.spec.whatwg.org/#dom-url-port
  defineBuiltInAccessor(URLPrototype, 'port', accessorDescriptor('getPort', 'setPort'));
  // `URL.prototype.pathname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-pathname
  defineBuiltInAccessor(URLPrototype, 'pathname', accessorDescriptor('getPathname', 'setPathname'));
  // `URL.prototype.search` accessors pair
  // https://url.spec.whatwg.org/#dom-url-search
  defineBuiltInAccessor(URLPrototype, 'search', accessorDescriptor('getSearch', 'setSearch'));
  // `URL.prototype.searchParams` getter
  // https://url.spec.whatwg.org/#dom-url-searchparams
  defineBuiltInAccessor(URLPrototype, 'searchParams', accessorDescriptor('getSearchParams'));
  // `URL.prototype.hash` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hash
  defineBuiltInAccessor(URLPrototype, 'hash', accessorDescriptor('getHash', 'setHash'));
}

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
defineBuiltIn(URLPrototype, 'toJSON', function toJSON() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
defineBuiltIn(URLPrototype, 'toString', function toString() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
  // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  if (nativeCreateObjectURL) defineBuiltIn(URLConstructor, 'createObjectURL', bind(nativeCreateObjectURL, NativeURL));
  // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
  if (nativeRevokeObjectURL) defineBuiltIn(URLConstructor, 'revokeObjectURL', bind(nativeRevokeObjectURL, NativeURL));
}

setToStringTag(URLConstructor, 'URL');

$({ global: true, constructor: true, forced: !USE_NATIVE_URL, sham: !DESCRIPTORS }, {
  URL: URLConstructor
});

},{"1208":1208,"1218":1218,"1226":1226,"1246":1246,"1247":1247,"1251":1251,"1270":1270,"1275":1275,"1281":1281,"1287":1287,"1288":1288,"1298":1298,"1325":1325,"1363":1363,"1369":1369,"1372":1372,"1393":1393,"1401":1401,"1404":1404,"1487":1487,"1542":1542}],1372:[function(require,module,exports){
'use strict';
// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var uncurryThis = require(1281);

var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;

var $RangeError = RangeError;
var exec = uncurryThis(regexSeparators.exec);
var floor = Math.floor;
var fromCharCode = String.fromCharCode;
var charCodeAt = uncurryThis(''.charCodeAt);
var join = uncurryThis([].join);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var split = uncurryThis(''.split);
var toLowerCase = uncurryThis(''.toLowerCase);

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */
var ucs2decode = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = charCodeAt(string, counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = charCodeAt(string, counter++);
      if ((extra & 0xFC00) == 0xDC00) { // Low surrogate.
        push(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        push(output, value);
        counter--;
      }
    } else {
      push(output, value);
    }
  }
  return output;
};

/**
 * Converts a digit/integer into a basic code point.
 */
var digitToBasic = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */
var adapt = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor(delta / damp) : delta >> 1;
  delta += floor(delta / numPoints);
  while (delta > baseMinusTMin * tMax >> 1) {
    delta = floor(delta / baseMinusTMin);
    k += base;
  }
  return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */
var encode = function (input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue;

  // Handle the basic code points.
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 0x80) {
      push(output, fromCharCode(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.
  var handledCPCount = basicLength; // number of code points that have been handled;

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    push(output, delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
      throw $RangeError(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt) {
        throw $RangeError(OVERFLOW_ERROR);
      }
      if (currentValue == n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        var k = base;
        while (true) {
          var t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          push(output, fromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor(qMinusT / baseMinusT);
          k += base;
        }

        push(output, fromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
        delta = 0;
        handledCPCount++;
      }
    }

    delta++;
    n++;
  }
  return join(output, '');
};

module.exports = function (input) {
  var encoded = [];
  var labels = split(replace(toLowerCase(input), regexSeparators, '\u002E'), '.');
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    push(encoded, exec(regexNonASCII, label) ? 'xn--' + encode(label) : label);
  }
  return join(encoded, '.');
};

},{"1281":1281}],1246:[function(require,module,exports){
var makeBuiltIn = require(1318);
var defineProperty = require(1328);

module.exports = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};

},{"1318":1318,"1328":1328}],1543:[function(require,module,exports){
// TODO: Remove this module from `core-js@4` since it's replaced to module below
require(1542);

},{"1542":1542}],1542:[function(require,module,exports){
'use strict';
// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
require(1423);
var $ = require(1270);
var global = require(1287);
var call = require(1278);
var uncurryThis = require(1281);
var DESCRIPTORS = require(1251);
var USE_NATIVE_URL = require(1401);
var defineBuiltIn = require(1247);
var defineBuiltIns = require(1248);
var setToStringTag = require(1363);
var createIteratorConstructor = require(1313);
var InternalStateModule = require(1298);
var anInstance = require(1208);
var isCallable = require(1302);
var hasOwn = require(1288);
var bind = require(1275);
var classof = require(1234);
var anObject = require(1209);
var isObject = require(1307);
var $toString = require(1393);
var create = require(1326);
var createPropertyDescriptor = require(1244);
var getIterator = require(1284);
var getIteratorMethod = require(1283);
var validateArgumentsLength = require(1404);
var wellKnownSymbol = require(1408);
var arraySort = require(1228);

var ITERATOR = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState = InternalStateModule.set;
var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
var safeGetBuiltIn = function (name) {
  if (!DESCRIPTORS) return global[name];
  var descriptor = getOwnPropertyDescriptor(global, name);
  return descriptor && descriptor.value;
};

var nativeFetch = safeGetBuiltIn('fetch');
var NativeRequest = safeGetBuiltIn('Request');
var Headers = safeGetBuiltIn('Headers');
var RequestPrototype = NativeRequest && NativeRequest.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var RegExp = global.RegExp;
var TypeError = global.TypeError;
var decodeURIComponent = global.decodeURIComponent;
var encodeURIComponent = global.encodeURIComponent;
var charAt = uncurryThis(''.charAt);
var join = uncurryThis([].join);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var shift = uncurryThis([].shift);
var splice = uncurryThis([].splice);
var split = uncurryThis(''.split);
var stringSlice = uncurryThis(''.slice);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = replace(it, plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = replace(result, percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replacements = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replacements[match];
};

var serialize = function (it) {
  return replace(encodeURIComponent(it), find, replacer);
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    iterator: getIterator(getInternalParamsState(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;
  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  } return step;
}, true);

var URLSearchParamsState = function (init) {
  this.entries = [];
  this.url = null;

  if (init !== undefined) {
    if (isObject(init)) this.parseObject(init);
    else this.parseQuery(typeof init == 'string' ? charAt(init, 0) === '?' ? stringSlice(init, 1) : init : $toString(init));
  }
};

URLSearchParamsState.prototype = {
  type: URL_SEARCH_PARAMS,
  bindURL: function (url) {
    this.url = url;
    this.update();
  },
  parseObject: function (object) {
    var iteratorMethod = getIteratorMethod(object);
    var iterator, next, step, entryIterator, entryNext, first, second;

    if (iteratorMethod) {
      iterator = getIterator(object, iteratorMethod);
      next = iterator.next;
      while (!(step = call(next, iterator)).done) {
        entryIterator = getIterator(anObject(step.value));
        entryNext = entryIterator.next;
        if (
          (first = call(entryNext, entryIterator)).done ||
          (second = call(entryNext, entryIterator)).done ||
          !call(entryNext, entryIterator).done
        ) throw TypeError('Expected sequence with length 2');
        push(this.entries, { key: $toString(first.value), value: $toString(second.value) });
      }
    } else for (var key in object) if (hasOwn(object, key)) {
      push(this.entries, { key: key, value: $toString(object[key]) });
    }
  },
  parseQuery: function (query) {
    if (query) {
      var attributes = split(query, '&');
      var index = 0;
      var attribute, entry;
      while (index < attributes.length) {
        attribute = attributes[index++];
        if (attribute.length) {
          entry = split(attribute, '=');
          push(this.entries, {
            key: deserialize(shift(entry)),
            value: deserialize(join(entry, '='))
          });
        }
      }
    }
  },
  serialize: function () {
    var entries = this.entries;
    var result = [];
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      push(result, serialize(entry.key) + '=' + serialize(entry.value));
    } return join(result, '&');
  },
  update: function () {
    this.entries.length = 0;
    this.parseQuery(this.url.query);
  },
  updateURL: function () {
    if (this.url) this.url.update();
  }
};

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance(this, URLSearchParamsPrototype);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  setInternalState(this, new URLSearchParamsState(init));
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

defineBuiltIns(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    validateArgumentsLength(arguments.length, 2);
    var state = getInternalParamsState(this);
    push(state.entries, { key: $toString(name), value: $toString(value) });
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var key = $toString(name);
    var index = 0;
    while (index < entries.length) {
      if (entries[index].key === key) splice(entries, index, 1);
      else index++;
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString(name);
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString(name);
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) push(result, entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString(name);
    var index = 0;
    while (index < entries.length) {
      if (entries[index++].key === key) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var found = false;
    var key = $toString(name);
    var val = $toString(value);
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) splice(entries, index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) push(entries, { key: key, value: val });
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    arraySort(state.entries, function (a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
defineBuiltIn(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, { name: 'entries' });

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
defineBuiltIn(URLSearchParamsPrototype, 'toString', function toString() {
  return getInternalParamsState(this).serialize();
}, { enumerable: true });

setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$({ global: true, constructor: true, forced: !USE_NATIVE_URL }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!USE_NATIVE_URL && isCallable(Headers)) {
  var headersHas = uncurryThis(HeadersPrototype.has);
  var headersSet = uncurryThis(HeadersPrototype.set);

  var wrapRequestOptions = function (init) {
    if (isObject(init)) {
      var body = init.body;
      var headers;
      if (classof(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();
        if (!headersHas(headers, 'content-type')) {
          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
        return create(init, {
          body: createPropertyDescriptor(0, $toString(body)),
          headers: createPropertyDescriptor(0, headers)
        });
      }
    } return init;
  };

  if (isCallable(nativeFetch)) {
    $({ global: true, enumerable: true, dontCallGetSet: true, forced: true }, {
      fetch: function fetch(input /* , init */) {
        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable(NativeRequest)) {
    var RequestConstructor = function Request(input /* , init */) {
      anInstance(this, RequestPrototype);
      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;

    $({ global: true, constructor: true, dontCallGetSet: true, forced: true }, {
      Request: RequestConstructor
    });
  }
}

module.exports = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};

},{"1208":1208,"1209":1209,"1228":1228,"1234":1234,"1244":1244,"1247":1247,"1248":1248,"1251":1251,"1270":1270,"1275":1275,"1278":1278,"1281":1281,"1283":1283,"1284":1284,"1287":1287,"1288":1288,"1298":1298,"1302":1302,"1307":1307,"1313":1313,"1326":1326,"1363":1363,"1393":1393,"1401":1401,"1404":1404,"1408":1408,"1423":1423}],1401:[function(require,module,exports){
var fails = require(1271);
var wellKnownSymbol = require(1408);
var IS_PURE = require(1308);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = !fails(function () {
  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var searchParams = url.searchParams;
  var result = '';
  url.pathname = 'c%20d';
  searchParams.forEach(function (value, key) {
    searchParams['delete']('b');
    result += key + value;
  });
  return (IS_PURE && !url.toJSON)
    || !searchParams.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || searchParams.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !searchParams[ITERATOR]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});

},{"1271":1271,"1308":1308,"1408":1408}],1455:[function(require,module,exports){
var $ = require(1270);
var $entries = require(1340).entries;

// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});

},{"1270":1270,"1340":1340}],1340:[function(require,module,exports){
var DESCRIPTORS = require(1251);
var uncurryThis = require(1281);
var objectKeys = require(1337);
var toIndexedObject = require(1384);
var $propertyIsEnumerable = require(1338).f;

var propertyIsEnumerable = uncurryThis($propertyIsEnumerable);
var push = uncurryThis([].push);

// `Object.{ entries, values }` methods implementation
var createMethod = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || propertyIsEnumerable(O, key)) {
        push(result, TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

module.exports = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: createMethod(true),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: createMethod(false)
};

},{"1251":1251,"1281":1281,"1337":1337,"1338":1338,"1384":1384}],1101:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1541);
require(1437);
require(1466);
require(1439);
require(1418);
require(1463);
require(1537);
require(1422);
require(1426);
require(1415);
require(1412);
require(1478);
require(1503);
require(1500);
require(1429);
var _MDGroupInfo = _interopRequireDefault(require(260));
var _MDRole = _interopRequireDefault(require(280));
var _MDEnterprise = _interopRequireDefault(require(249));
var _MDMolaUser = _interopRequireDefault(require(272));
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MDFileLog = _interopRequireDefault(require(256));
var _MDFileLogCollection = _interopRequireDefault(require(257));
var _MDEvaluationCollection = _interopRequireDefault(require(251));
var _MMFileInfo = _interopRequireDefault(require(297));
var _MDRoleInfoCollection = _interopRequireDefault(require(282));
var _MDLoadMaskView = _interopRequireDefault(require(49));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MEExportMsgWinView = _interopRequireDefault(require(163));
var _utils = _interopRequireDefault(require(108));
var out = {
  getFileAccessLogStatus: function getFileAccessLogStatus(token, _success, fail) {
    // window.open("/enterprise/generateExcelOfFileStruct.do?token="+ token)
    $.ajax({
      method: "post",
      url: "/enterprise/getFileAccessLogStatus.do",
      data: {
        token: token
      },
      success: function success(responseData, textStatus, jqXHR) {
        console.log(responseData);
        if (responseData["success"] === true) {
          if (responseData["code"] == 0) {
            if (responseData["status"] == 1) {
              setTimeout(function () {
                MMEnterpriseController.getFileAccessLogStatus(token, _success, fail);
              }, 6000);
            } else if (responseData["status"] == 0) {
              localStorage.removeItem("epLogDownloadToken");
              var realUrl = location.origin + "/enterprise/downloadFileAccessLog.do?token=".concat(token);
              var $fileDownloader = $("#file-downloader");
              if ($fileDownloader.length == 0) {
                $fileDownloader = $("<a ></a>");
                $fileDownloader.attr("id", "file-downloader").appendTo("body");
                $fileDownloader.width(0).height(0).css("visibility", "hidden");
              }
              $fileDownloader.attr("href", realUrl);
              $fileDownloader[0].click();
              setBabelTimeout(function () {
                _MDLoadMaskView["default"].remove();
              }, 1000);
              window.exportEpLog = false;
              _success({
                msg: BabelStr.str(6766)
              });
            }
          } else {
            var msg = BabelStr.str(7155);
            if (responseData["exception"]) {
              msg = BabelStr.str(6764);
            }
            localStorage.removeItem("epLogDownloadToken");
            fail({
              msg: msg
            });
          }
        } else {
          var _msg = BabelStr.str(7155);
          if (responseData["exception"]) {
            _msg = BabelStr.str(6764);
          }
          localStorage.removeItem("epLogDownloadToken");
          fail({
            msg: _msg
          });
        }
      }
    });
  },
  getFileStatusByToken: function getFileStatusByToken(token, _success2, fail, errCount) {
    if (!errCount) {
      errCount = 1;
    }
    // window.open("/enterprise/generateExcelOfFileStruct.do?token="+ token)
    $.ajax({
      method: "post",
      // method: "get",
      url: "/enterprise/getFileStatusByToken.do",
      data: {
        token: token // 使用这个方式传递参数，有时候服务器接收不到这个参数
      },
      success: function success(responseData, textStatus, jqXHR) {
        console.log(responseData);
        if (responseData["success"] === true) {
          var exportLog = responseData["exportLog"] || {};
          if (exportLog.fileUrlInfo && exportLog.fileUrlInfo.length) {
            _success2();
          } else {
            fail(responseData, BabelStr.str(11019));
          }
        } else {
          if (responseData.code == 2 && errCount < 3) {
            setTimeout(function () {
              MMEnterpriseController.getFileStatusByToken(token, _success2, fail, ++errCount);
            }, 5000);
          } else fail(responseData, BabelStr.str(11019));
        }
      }
    });
  },
  isFileExportedByToken: function isFileExportedByToken(token, _success3, fail, errCount) {
    // window.open("/enterprise/generateExcelOfFileStruct.do?token="+ token)
    if (!errCount) {
      errCount = 1;
    }
    $.ajax({
      method: "post",
      // method: "get",
      url: "/enterprise/getFileStatusByToken.do",
      // url: "/enterprise/getFileStatusByToken.do?token=" + token,
      data: {
        token: token // 使用这个方式传递参数，有时候服务器接收不到这个参数
      },
      success: function success(responseData, textStatus, jqXHR) {
        console.log(responseData);
        if (responseData["success"] === true) {
          var exportLog = responseData["exportLog"] || {};
          if (exportLog.fileUrlInfo && exportLog.fileUrlInfo.length) {
            setTimeout(function () {
              _success3();
            }, 2000);
          } else if (exportLog.status == -1) {
            setTimeout(function () {
              MMEnterpriseController.isFileExportedByToken(token, _success3, fail);
            }, 5000);
          } else {
            fail(responseData, BabelStr.str(11019));
          }
        } else {
          if (responseData.code == 2 && errCount < 3) {
            setTimeout(function () {
              MMEnterpriseController.isFileExportedByToken(token, _success3, fail, ++errCount);
            }, 5000);
          } else fail(responseData, BabelStr.str(11019));
        }
      }
    });
  },
  saveExportLog: function saveExportLog(params, success, fail) {
    // window.open("/enterprise/generateExcelOfFileStruct.do?token="+ token)
    $.ajax({
      method: "post",
      url: "/enterprise/saveExportLog.do",
      data: params,
      success: function success(responseData, textStatus, jqXHR) {
        console.log(responseData);
        if (responseData["success"] === true) {
          console.log(responseData);
        } else {
          // fail(responseData, BabelStr.str(11019))
          console.log(responseData);
        }
      }
    });
  },
  downloadFilelogByFileId: function downloadFilelogByFileId(parameters, success, fail) {
    _MDLoadMaskView["default"].show();
    var url = location.origin + "/enterprise/getAccessLogForFile.do";
    url = url + "?fileId=" + (parameters.fileId ? parameters.fileId : "0") + "&types=" + (parameters.types ? parameters.types : 0) + (parameters.keyword ? "&keyword=" + parameters.keyword : "") + (parameters.typesStr ? "&typesStr=" + parameters.typesStr : "");
    var realUrl = encodeURI(encodeURI(url));
    var $fileDownloader = $("#file-downloader");
    if ($fileDownloader.length == 0) {
      $fileDownloader = $("<a></a>");
      $fileDownloader.attr("id", "file-downloader").appendTo("body");
      $fileDownloader.width(0).height(0).css("visibility", "hidden");
    }
    $fileDownloader.attr("href", realUrl);
    $fileDownloader[0].click();
    setBabelTimeout(function () {
      _MDLoadMaskView["default"].remove();
    }, 1000);
  },
  downloadEntUserListFile: function downloadEntUserListFile(option, successCb, fail) {
    // if(option.forManager) {
    //   this.showExportMsg()
    // }
    _czc && _czc.push(["_trackEvent", "报表", "下载企业用户列表", "", "", ""]);
    var url = location.origin + "/enterprise/getEntUserListFile.do?";
    if (option.departmentId) {
      url += "depId=" + option.departmentId + "&" + "departmentName=" + option.departmentName + "&";
    }
    if (option.roleId) {
      url += "roleId=" + option.roleId + "&" + "departmentRole=" + option.departmentRole + "&";
    }
    if (option.groupId) {
      url += "groupId=" + option.groupId + "&" + "groupName=" + option.groupName + "&";
    }
    if (option.keyName) {
      url += "keyword=" + option.keyName;
    }
    if (option.norecursion) {
      url += "&" + "norecursion=1";
    }
    if (option.frontPage) {
      url += "&" + "frontPage=" + option.frontPage;
    }
    $.ajax({
      url: url,
      success: function success(responseData, textStatus, jqXHR) {
        if (responseData["success"] === true) {
          successCb && successCb(responseData.token);
          // this.showExportMsg()
        } else {
          fail && fail(responseData);
        }
      }
    });
  },
  showExportMsg: function showExportMsg() {
    var win = new _MEExportMsgWinView["default"]();
    win.show();
  },
  downloadDepShareFileList: function downloadDepShareFileList(option) {
    _MDLoadMaskView["default"].show();
    _czc && _czc.push(["_trackEvent", "报表", "下载部门分享文件列表", "", "", ""]);
    var url = location.origin + "/enterprise/downloadDepShareFileList.do?";
    if (option.fileId) {
      url += "fileId=" + option.fileId + "&" + "departmentName=" + option.departmentName + "&";
    }
    if (option.key) {
      url += "keyword=" + option.key + "&";
    }
    var realUrl = url;
    var $fileDownloader = $("#file-downloader");
    if ($fileDownloader.length == 0) {
      $fileDownloader = $("<a></a>");
      $fileDownloader.attr("id", "file-downloader").appendTo("body");
      $fileDownloader.width(0).height(0).css("visibility", "hidden");
    }
    $fileDownloader.attr("href", realUrl);
    $fileDownloader[0].click();
    _MDSnackbarView["default"].show(BabelStr.str(20174));
    setBabelTimeout(function () {
      _MDLoadMaskView["default"].remove();
    }, 1000);
  },
  downloadDepSecretFileList: function downloadDepSecretFileList(option) {
    _MDLoadMaskView["default"].show();
    _czc && _czc.push(["_trackEvent", "报表", "下载部门密级文件列表", "", "", ""]);
    var url = location.origin + "/enterprise/downloadDepSecretFileList.do?";
    if (option.fileId) {
      url += "fileId=" + option.fileId + "&" + "departmentName=" + option.departmentName + "&";
    }
    var realUrl = url;
    var $fileDownloader = $("#file-downloader");
    if ($fileDownloader.length == 0) {
      $fileDownloader = $("<a></a>");
      $fileDownloader.attr("id", "file-downloader").appendTo("body");
      $fileDownloader.width(0).height(0).css("visibility", "hidden");
    }
    $fileDownloader.attr("href", realUrl);
    $fileDownloader[0].click();
    _MDSnackbarView["default"].show(BabelStr.str(20174));
    setBabelTimeout(function () {
      _MDLoadMaskView["default"].remove();
    }, 1000);
  },
  migrateDepartmentRoleTo: function migrateDepartmentRoleTo(oldRoleId, newRoleId, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.migrateDepartmentRoleTo", {
      newRoleId: newRoleId - 0,
      oldRoleId: oldRoleId - 0
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail();
      }
    });
  },
  getChannelUnredFileNum: function getChannelUnredFileNum(success, fail) {
    MMEnterpriseController.request("netDrive.fileHandler.getChannelUnreadFileNum", {}, function (res) {
      if (res["resultCode"] === 0) {
        success(res["unreadNumInfo"]);
      } else {
        fail();
      }
    });
  },
  getArchiveUnreadFileNum: function getArchiveUnreadFileNum(success, fail) {
    MMEnterpriseController.request("netDrive.fileHandler.getArchiveUnreadFileNum", {}, function (res) {
      if (res["resultCode"] === 0) {
        success(res["unreadNumInfo"]);
      } else {
        fail();
      }
    });
  },
  setEnterpriseMemberRole: function setEnterpriseMemberRole(userIds, roleId, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.setEnterpriseMemberRole", {
      userIds: userIds,
      roleId: roleId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail();
      }
    });
  },
  getEnterpriseWaterMark: function getEnterpriseWaterMark(success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.getEnterpriseWaterMark", {}, function (res) {
      if (res["resultCode"] == 0) {
        // console.log(res);
        success(res["waterMark"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  setWaterMarkColor: function setWaterMarkColor(color, _success4, fail) {
    var url = "/enterprise/setWaterMarkColor.do?color=".concat(color);
    $.ajax({
      url: url,
      success: function success(responseData, textStatus, jqXHR) {
        if (responseData["success"] === true) {
          _success4();
        } else {
          fail(responseData);
        }
      }
    });
  },
  setWaterMarkScope: function setWaterMarkScope(watermarkScope, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.setWaterMarkScope", {
      watermarkScope: watermarkScope
    }, function (res) {
      if (res["resultCode"] == 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  setWaterMarkPositionType: function setWaterMarkPositionType(positionType, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.setWaterMarkPositionType", {
      positionType: positionType
    }, function (res) {
      if (res["resultCode"] == 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  setWaterMarkTransparent: function setWaterMarkTransparent(transparent, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.setWaterMarkTransparent", {
      transparent: transparent
    }, function (res) {
      if (res["resultCode"] == 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  closeWaterMark: function closeWaterMark(success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.closeWaterMark", {}, function (res) {
      if (res["resultCode"] == 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  setWordWaterMark: function setWordWaterMark(wordWaterMark, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.setWordWaterMark", {
      wordWaterMark: wordWaterMark
    }, function (res) {
      if (res["resultCode"] == 0) {
        console.log("文字");
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  setUsernameWaterMark: function setUsernameWaterMark(success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.setUsernameWaterMark", {}, function (res) {
      if (res["resultCode"] == 0) {
        console.log("当前用户名");
        success(res["waterMark"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  setImageWaterMark: function setImageWaterMark(imageWaterMark, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.setImageWaterMark", {
      imageWaterMark: imageWaterMark
    }, function (res) {
      if (res["resultCode"] == 0) {
        console.log("图片");
        success(res["waterMark"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  updateWaterMarkDotMatrixInfo: function updateWaterMarkDotMatrixInfo(watermarkId, dotMatrixInfo, watermarkType, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.updateWaterMarkDotMatrixInfo", {
      watermarkId: watermarkId,
      dotMatrixInfo: dotMatrixInfo,
      watermarkType: watermarkType
    }, function (res) {
      if (res["resultCode"] == 0) {
        success(res);
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  getInfoFromDotMatrixPayload: function getInfoFromDotMatrixPayload(payload, fuzzy, _success5, fail) {
    $.ajax('/enterprise/getInfoFromDotMatrixPayload.do', {
      method: 'post',
      traditional: true,
      data: {
        payload: payload,
        fuzzy: fuzzy
      },
      success: function success(data) {
        if (data && data.success) {
          _success5(data);
        } else {
          fail(data);
        }
      },
      error: function error() {
        fail();
      }
    });
  },
  setMemberSpaceByDepartment: function setMemberSpaceByDepartment(depId, roleId, space, success, fail, options) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.setMemberSpaceByDepartment", {
      departmentId: depId,
      roleId: roleId,
      space: space,
      sign: options.sign
    }, function (res) {
      if (res["resultCode"] == 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  increaseMemberSpaceByDepartment: function increaseMemberSpaceByDepartment(depId, roleId, space, success, fail, options) {
    options = options || {};
    MMEnterpriseController.request("netDrive.enterpriseHandler.increaseMemberSpaceByDepartment", {
      departmentId: depId,
      roleId: roleId,
      space: space,
      sign: options.sign
    }, function (res) {
      if (res["resultCode"] == 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  setMemberCanOwnPersonFileByDepartment: function setMemberCanOwnPersonFileByDepartment(depId, roleId, sign, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.setMemberCanOwnPersonFileByDepartment", {
      departmentId: depId,
      roleId: roleId,
      sign: sign // -1 企业默认 0 不允许  1 允许
    }, function (res) {
      if (res["resultCode"] == 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  countMemberByDepartment: function countMemberByDepartment(depId, roleId, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.countMemberByDepartment", {
      departmentId: depId,
      roleId: roleId
    }, function (res) {
      if (res["resultCode"] == 0) {
        console.log(res);
        success(res["total"], res["online"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  getAllSysBroadcast: function getAllSysBroadcast(success) {
    var out = [];
    var item;
    for (var i = 9 - 1; i >= 0; i--) {
      item = {
        id: i,
        theme: BabelStr.str(481),
        // "通知主题",
        creatorName: BabelStr.str(482),
        // "发布人姓名",
        date: new Date()
      };
      out.push(item);
    }
    success(out);
  },
  createGroup: function createGroup(params, success, fail) {
    var belongToEnterprise = parseInt(params.belongEnterprise);
    MMEnterpriseController.request("netDrive.shareHandler.createGroup", {
      belongToEnterprise: belongToEnterprise,
      groupName: params.groupName,
      subGroupIds: params.subGroupIds,
      userIds: params.userIds,
      depIds: params.depIds
    }, function (res) {
      if (res["resultCode"] === 0) {
        var groupId = res["groupId"];
        success(new _MDGroupInfo["default"]({
          groupId: groupId,
          groupName: params.groupName,
          memberNum: 0,
          belongToEnterprise: params.belongToEnterprise
        }));
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  getGroupsWithoutMember: function getGroupsWithoutMember(success, fail) {
    MMEnterpriseController.request("netDrive.shareHandler.getGroupsWithoutMember", {}, function (res) {
      if (res["resultCode"] === 0) {
        var groups = res["groups"];
        var users = res["users"];
        var groupInfos = [];
        var group;
        var user = null;
        for (var i = 0; i < groups.length; i++) {
          group = groups[i];
          user = _.findWhere(users, {
            id: group["creatorId"]
          }) || {
            name: ""
          };
          group["creatorName"] = user["name"];
          groupInfos.push(new _MDGroupInfo["default"](group));
        }
        success(groupInfos);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  getEntGroups: function getEntGroups(success, fail) {
    MMEnterpriseController.getGroupsWithoutMember(function (groupInfos) {
      var groups = [];
      _.each(groupInfos, function (group) {
        if (group.belongToEnterprise()) {
          groups.push(group);
        }
      });
      success(groups);
    }, fail);
  },
  updateGroupName: function updateGroupName(groupId, name, success, fail) {
    MMEnterpriseController.request("netDrive.shareHandler.updateGroupName", {
      groupId: groupId,
      groupName: name
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  delGroupById: function delGroupById(groupId, success, fail) {
    MMEnterpriseController.request("netDrive.shareHandler.deleteGroup", {
      groupId: groupId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  getGroupMembers: function getGroupMembers(groupId, startPageIndex, pageSize, success, fail) {
    MMEnterpriseController.request("netDrive.shareHandler.getGroupMembers", {
      groupId: groupId,
      startPageIndex: startPageIndex,
      pageSize: pageSize
    }, function (res) {
      console.log(res);
      if (res["resultCode"] === 0) {
        var totalCount = res["totalCount"];
        var users = res["users"];
        var userInfos = [];
        for (var i = 0; i < users.length; i++) {
          userInfos.push(new _MDMolaUser["default"](users[i]));
        }
        var deps = res["departments"];
        _.each(deps, function (dep) {
          dep.userType = 1;
          userInfos.push(new _MDMolaUser["default"](dep));
        });
        var subGroups = res["subGroups"];
        _.each(subGroups, function (group) {
          group.userType = 2;
          group.name = group.groupName;
          userInfos.push(new _MDMolaUser["default"](group));
        });
        success(userInfos, totalCount);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  removeMemFromGroup: function removeMemFromGroup(groupId, userIds, success, fail) {
    MMEnterpriseController.request("netDrive.shareHandler.removeUsersFromGroup", {
      groupId: groupId,
      userIds: userIds
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  addMemForGroup: function addMemForGroup(params, success, fail) {
    MMEnterpriseController.request("netDrive.shareHandler.addGroupMember", {
      groupId: params.groupId,
      subGroupIds: params.subGroupIds,
      userIds: params.userIds,
      depIds: params.depIds
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"], res["msg"]);
      }
    });
  },
  /**
   * evaluation
   */
  createEvaluationTmpl: function createEvaluationTmpl(name, steps, finalizedStep, forEnterprise, success, fail) {
    MMEnterpriseController.request("netDrive.evaluationHandler.createEvaluationTmpl", {
      name: name,
      steps: steps,
      finalizedStep: finalizedStep,
      forEnterprise: forEnterprise
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["flowId"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  updateEvaluationTmpl: function updateEvaluationTmpl(tmplId, name, steps, finalizedStep, success, fail) {
    MMEnterpriseController.request("netDrive.evaluationHandler.updateEvaluationTmpl", {
      tmplId: tmplId,
      name: name,
      steps: steps,
      finalizedStep: finalizedStep
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  getAllEvaluationTmpls: function getAllEvaluationTmpls(success, fail) {
    MMEnterpriseController.request("netDrive.evaluationHandler.getAllEvaluationTmpls", {}, function (res) {
      if (res["resultCode"] === 0) {
        var users = res["users"] || [];
        var userIdInfoMap = {};
        _.each(users, function (user) {
          userIdInfoMap[user["id"]] = user;
        });
        var evaluationCollection = new _MDEvaluationCollection["default"](res["list"]);
        success(evaluationCollection);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  deleteEvaluationTmpl: function deleteEvaluationTmpl(tmplId, success, fail) {
    MMEnterpriseController.request("netDrive.evaluationHandler.deleteEvaluationTmpl", {
      tmplId: tmplId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  /*
  department file log
   */
  getDepartmentFileLog: function getDepartmentFileLog(departmentId, startIndex, pageSize, type, userName, success, fail) {
    MMEnterpriseController.request("netDrive.fileHandler.getDepartmentFileLog2", {
      departmentId: departmentId,
      startIndex: startIndex,
      pageSize: pageSize,
      type: type,
      userName: userName
    }, function (res) {
      if (res["resultCode"] === 0) {
        var out = new _MDFileLogCollection["default"]();
        if (res["logs"]) {
          res["logs"].forEach(function (log) {
            out.push(new _MDFileLog["default"](log));
          });
        }
        success(out, res["total"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  getDepartmentFileLogByUser: function getDepartmentFileLogByUser(departmentId, userId, sessionId, startIndex, pageSize, type, success, fail) {
    MMEnterpriseController.request("netDrive.fileHandler.getDepartmentFileLogByUser", {
      departmentId: departmentId,
      userId: userId,
      pageSize: pageSize,
      startIndex: startIndex,
      type: type,
      sessionId: sessionId
    }, function (res) {
      if (res["resultCode"] === 0) {
        var out = new _MDFileLogCollection["default"]();
        if (res["logs"]) {
          res["logs"].forEach(function (log) {
            out.push(new _MDFileLog["default"](log));
          });
        }
        success(out, res["total"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  getAccessUserInDepartment: function getAccessUserInDepartment(departmentId, success, fail) {
    MMEnterpriseController.request("netDrive.fileHandler.getAccessUsersInDepartment", {
      departmentId: departmentId
    }, function (res) {
      if (res["resultCode"] === 0) {
        var out = new _MDMolaUserCollection["default"]();
        if (res["users"]) {
          _.each(res["users"], function (user) {
            out.push(new _MDMolaUser["default"](user));
          });
        }
        success(out, res["anonymouse"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  getShareCountInDepartment: function getShareCountInDepartment(departmentId, success, fail) {
    MMEnterpriseController.request("netDrive.fileHandler.getShareCountInDepartment", {
      departmentId: departmentId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["fileCount"], res["shareCount"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  /*
   * @return {object} - {
   *   enterpriseId, enterpiseNamegetAllDepartmentStructor
   *
   *   }
   *
   */
  getCurrentEnterpriseInfo: function getCurrentEnterpriseInfo(success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.getCurrentEnterpriseInfo", {}, function (res) {
      if (res["resultCode"] === 0) {
        var enterprise = new _MDEnterprise["default"](res["enterprise"]);
        success(enterprise);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  // NEW
  // 获得 企业的人员数量信息
  //
  // return Object {

  //    total, // 总人数
  //    member, // 正式员工数量
  //    guest,  // 企业外部员工数量

  //    online, // 在线用户数量
  //    online_member, // 在线正式员工数量
  //    online_guest,  // 在线外部员工数量
  //
  //    managers,     // 企业管理员数组 array of MDMolaUser
  // }
  getMemberInfo: function getMemberInfo(success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.countByEnterpriseMember", {}, function (res) {
      if (res["resultCode"] === 0) {
        success(res);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  /**
   * 获取企业所有成员，包括外部人员
   *
   * @param parameters - {
   *   userType: 0,  // 0 for enterprise member, 1 for guest
   *   pageSize: 1000,
   *   startIndex: 0
       sortBy: null // ['name', 'usedSpace', 'contacts', 'departments', 'recentAccessTime']
   * }
   */
  getAllMember: function getAllMember(parameters, success, fail) {
    parameters.needDepartment = 1;
    parameters.norecursion = parameters.norecursion ? 1 : 0;
    MMEnterpriseController.request("netDrive.enterpriseHandler.searchEnterpriseMember", {
      options: parameters
    }, function (res) {
      if (res["resultCode"] === 0) {
        var memberCollection = new _MDMolaUserCollection["default"](res["members"]);
        memberCollection.each(function (user) {
          user.setRoleId(user.get("enterpriseRole"));
        });
        success(memberCollection, res["total"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  importMembersByMail: function importMembersByMail(mails, success, fail) {
    if (!Array.isArray(mails)) mails = [mails];
    MMEnterpriseController.request("netDrive.enterpriseHandler.importMembersByMail", {
      mails: mails
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  deleteMembersById: function deleteMembersById(userIds, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.deleteMembersById", {
      userIds: userIds
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  setDomain: function setDomain(domainName, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.setDomain", {
      domainName: domainName
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  setLogoUrl: function setLogoUrl(logoURL, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.setLogoUrl", {
      logoURL: logoURL
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  /**
   * @typedef Enterprise_UpdateEnterprise_Params
   * @property {string} [name] - 企业全称
   * @property {string} [shortName] - 企业简称
   * @property {string} [registerMail] - 注册邮箱
   * @property {string} [registerPhone] - 绑定手机
   */
  updateEnterpriseInfo: function updateEnterpriseInfo(parameters, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.updateEnterpriseInfo", {
      options: parameters
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  setSendMail: function setSendMail(isSendMail, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.setSendMail", {
      sendMail: isSendMail
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  /**
   * 设置联系人
   * @parm {Object} parameters:{
   *   contactsName,
   *   contactsPhone,
   *   contactsMail
   * }
   *
   */
  setContacts: function setContacts(parameters, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.setContact", {
      options: parameters
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  /**
   * 获取企业用户信息列表
   * @param {Object} searchParameters
   *   {
   *       keyName:    用户名称或邮箱    // 可选
   *       name: 用户名
   *       email: 邮箱
   *       departmentId:  所在部门 // 可选
   *       roleId:  职位, 同时匹配企业身份和部门身份       // 可选
   *       userType: 0 - 企业内， 1 - 企业外， 2 - 包含两者
   *       pageSize: 15,       // 每次显示的条目数
   *       startIndex：0        // 从第几条开始
   *   }
   *
   * @return array of {
   *        userId,
   *        userName,
   *        mail,
   *        phone,
   *        storageUsed,
   *        array of {departmentId, pepartmentName, roleId, roleName}
   *        }
   */
  searchEntperiseUsers: function searchEntperiseUsers(searchParameters, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.searchEnterpriseMember", {
      options: searchParameters
    }, function (res) {
      if (res["resultCode"] === 0 && res["members"] != undefined) {
        var members = res["members"].map(function (member) {
          //TODO convert
          return member;
        });
        success(members, res["total"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  searchUserByEmail: function searchUserByEmail(email, success, fail) {
    MMEnterpriseController.request("netDrive.userHandler.searchUserByEmail", {
      email: email
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["list"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  checkEmailInfo: function checkEmailInfo(email, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.checkEmailInfoInEnterprise", {
      email: email
    }, function (res) {
      if (res["resultCode"] === 0) {
        var emailInfo = res["emailInfo"];
        if (emailInfo["isBabelUser"]) {
          console.log("is babel user");
        }
        if (emailInfo["isEnterpriseMember"]) {
          console.log("is enterprise member");
        }
        if (emailInfo["isEnterpriseGuest"]) {
          console.log("is enterprise guest");
        }

        // otherEnterpriseMember: 其他企业成员
        // otherEnterpriseGuest: 其他企业外部人员
        // enterprise: 所在企业
        success(emailInfo);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  checkPhoneInfo: function checkPhoneInfo(phone, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.checkPhoneInfoInEnterprise", {
      phone: phone
    }, function (res) {
      if (res["resultCode"] === 0) {
        var emailInfo = res["emailInfo"];
        if (emailInfo["isBabelUser"]) {
          console.log("is babel user");
        }
        if (emailInfo["isEnterpriseMember"]) {
          console.log("is enterprise member");
        }
        if (emailInfo["isEnterpriseGuest"]) {
          console.log("is enterprise guest");
        }
        success(emailInfo);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  checkUserInfo: function checkUserInfo(data, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.checkUserInfoInEnterprise", {
      phone: data.phone,
      email: data.email
    }, function (res) {
      if (res["resultCode"] === 0) {
        var emailInfo = res["emailInfo"];
        var phoneInfo = res["phoneInfo"];
        if (emailInfo["isBabelUser"]) {
          console.log("is babel user");
        }
        if (emailInfo["isEnterpriseMember"]) {
          console.log("is enterprise member");
        }
        if (emailInfo["isEnterpriseGuest"]) {
          console.log("is enterprise guest");
        }
        success(emailInfo, phoneInfo);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  inviteEnterpriseMember: function inviteEnterpriseMember(userId, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.inviteEnterpriseMember", {
      userId: userId,
      isPrivateCloud: window.isPrivateCloud ? 1 : 0
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  // NEW 2016-12-1
  /**
   * 获得所有在线用户
   *
   * @return array of MDMolaUser
   *
   */
  getOnlineUsers: function getOnlineUsers(success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.getOnlineMember", {}, function (res) {
      if (res["resultCode"] === 0) {
        var members = res["members"].map(function (member) {
          return member;
        });
        success(members);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  getOnlineInnerUsers: function getOnlineInnerUsers(success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.getOnlineMember", {}, function (res) {
      if (res["resultCode"] === 0) {
        var members = res["members"].filter(function (member) {
          return member["guest"] === 0;
        });
        var memberCollection = new _MDMolaUserCollection["default"](members);
        success(memberCollection);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  getOnlineOuterUsers: function getOnlineOuterUsers(success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.getOnlineMember", {}, function (res) {
      if (res["resultCode"] === 0) {
        var members = res["members"].filter(function (member) {
          return member["guest"] === 1;
        });
        var memberCollection = new _MDMolaUserCollection["default"](members);
        success(memberCollection);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  // ---------------------------------------------------------------  function about users
  roleAndUsers: {
    setEnterpriseUseFileManager: function setEnterpriseUseFileManager(flag, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.setEnterpriseUseFileManager", {
        flag: flag
      }, function (res) {
        if (res["resultCode"] === 0) {
          success();
          MMEnterpriseController.refreshSessionInfo();
        } else {
          fail(res["resultCode"]);
        }
      });
    },
    /**
     *  get the user's enterprise memeber info:
     *   {avatar, phone, mail, name, guest, status, workerId, roleId, roleName, permission}
     *
     */
    getUserEnterpriseRoleInfo: function getUserEnterpriseRoleInfo(userId, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.getUserEnterpriseMemberInfo", {
        userId: userId
      }, function (res) {
        if (res["resultCode"] === 0 && res["member"] != undefined) {
          success(res["member"]);
        } else {
          fail(res["resultCode"]);
        }
      });
    },
    // NEW
    /**
     *   获得用户信息
     *
     *   return MDMolaUser;
     */
    getUserInfoById: function getUserInfoById(userId, success, fail) {
      return MMEnterpriseController.roleAndUsers.getUserEnterpriseRoleInfo(userId, success, fail);
    },
    /**
     *   获得用户参与的所有分享信息
     *
     *   return array of MDShareParticipantInfo;
     */
    getUserParticipantedShares: function getUserParticipantedShares(userId, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.getUserParticipantShares", {
        userId: userId
      }, function (res) {
        if (res["resultCode"] === 0) {
          var files = res["files"];
          success(res["files"]);
        } else {
          fail(res["resultCode"]);
        }
      });
    },
    /**
     * @typedef RegisterAsGuestParamsOptions
     * @property {string} [name] 用户名
     * @property {string} [password] 密码
     * @property {string} [phone] 手机
     * @property {string} [affiliatedCompany] 所属公司
     * @property {string} [remarks] 备注
     */
    /**
     * @param {string} email
     * @param {string} password
     * @param {RegisterAsGuestParamsOptions} options
     */
    registerAsGuest: function registerAsGuest(mail, options, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.registerAsGuest", {
        email: mail,
        options: options
      }, function (res) {
        if (res["resultCode"] === 0) {
          success();
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    // NEW
    /**
     * 获取用户空间使用情况
     *
     * @param {Object} parameters {
     *     userId, personalSpace(是否需要统计个人空间), allDepartment(是否获得所有相关部门的空间), departmentIds(获得指定的部门空间)
     *  }
     *
     *  @return { array of MDUserSpaceInDepartment  }
     */
    getUserSpaceInfo: function getUserSpaceInfo(userIds, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.getUserSpaceInfo", {
        userIds: userIds
      }, function (res) {
        if (res["resultCode"] === 0) {
          success(res["userSpaceInfos"]);
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    getPersonalSpaceInfo: function getPersonalSpaceInfo(userIds, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.getPersonalSpaceInfoInEnterprise", {
        userIds: userIds
      }, function (res) {
        if (res["resultCode"] === 0) {
          success(res["userSpaceInfos"]);
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    /**
     * 获取分享用户的空间信息
     * 返回参与的分享文件和其大小信息
     */
    getGuestSpaceInfo: function getGuestSpaceInfo(userId, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.getGuestSpaceInfo", {
        userId: userId
      }, function (res) {
        if (res["resultCode"] === 0) {
          var shareInfos = res["infos"];
          success(shareInfos);
        } else {
          fail(res["resultCode"]);
        }
      });
    },
    /**
     * 获取外部用户被邀请的详细信息
     */
    getGuestInvitedInfos: function getGuestInvitedInfos(guestId, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.getGuestInvitedInfos", {
        userId: guestId
      }, function (res) {
        if (res["resultCode"] === 0) {
          var shareInfos = res["shareInfos"];
          success(shareInfos);
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    /**
     * @typedef AddEnterpriseMemberOptions
     * @property {string|string[]} [departmentIds]
     * @property {number|number[]} [roleIds] - roleIds 和 departmentIds必须数量匹配
     * @property {string} name - 用户名，如果相应邮箱的用户已存在，忽略这个
     * @property {number} addAsAdmin - 是否添加为管理员
     * @property {string} remarks - 备注
     * @property {string} phone - 手机号
     */
    /**
     * @param {string} mail
     * @param {string} password
     * @param {AddEnterpriseMemberOptions} options
     */
    addEnterpriseMember: function addEnterpriseMember(mail, phone, password, options, success, fail) {
      var data = {
        password: password,
        options: options
      };
      if (mail && mail != "") {
        data["email"] = mail;
      }
      if (phone) {
        data["phone"] = phone;
      }
      MMEnterpriseController.request("netDrive.enterpriseHandler.addEnterpriseMember", data, function (res) {
        if (res["resultCode"] === 0) {
          success();
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    // NEW 2016-12-1
    /**
     * 将指定人员设置为管理员角色
     *
     *
     */
    addAdministrators: function addAdministrators(params, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.addAdministrators", params, function (res) {
        if (res["resultCode"] === 0) {
          success();
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    addDocAdministrators: function addDocAdministrators(params, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.addDocAdministrators", params, function (res) {
        if (res["resultCode"] === 0) {
          success();
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    // NEW 2016-12-1
    /**
     * 删除指定人员的管理员角色
     *
     *
     */
    removeAdministrators: function removeAdministrators(params, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.removeAdministrators", params, function (res) {
        if (res["resultCode"] === 0) {
          success();
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    removeDocAdministrators: function removeDocAdministrators(params, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.removeDocAdministrators", params, function (res) {
        if (res["resultCode"] === 0) {
          success();
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    getAdministrators: function getAdministrators(success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.getAdministrators", {}, function (res) {
        if (res["resultCode"] === 0) {
          _.each(res.groups, function (group) {
            group.userType = 2;
            group.name = group.groupName;
          });
          var _out = res["members"].concat(res["groups"]);
          success(_out);
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    getDocAdministrators: function getDocAdministrators(success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.getDocAdministrators", {}, function (res) {
        if (res["resultCode"] === 0) {
          _.each(res.groups, function (group) {
            group.userType = 2;
            group.name = group.groupName;
          });
          var _out2 = res["members"].concat(res["groups"]);
          success(_out2);
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    freezeUsers: function freezeUsers(userIds, _success6, fail) {
      var logoutUrl = "/enterprise/logoutEntMembersSession.do";
      var usrIds = userIds.toString();
      $.ajax({
        url: logoutUrl,
        method: "post",
        data: {
          userIds: usrIds
        },
        success: function success(data) {
          if (data["success"]) {
            MMEnterpriseController.request("netDrive.enterpriseHandler.freezeUsers", {
              userIds: userIds,
              freeze: 1
            }, function (res) {
              if (res["resultCode"] === 0) {
                _success6();
              } else {
                fail(res["resultCode"], res["message"]);
              }
            });
          } else {
            if (data["code"] == 207) {
              // 未登录 或 session 失效
              location.href = "/account/userLogout.do";
            }
            fail(data["code"], data["msg"]);
          }
        }
      });
    },
    unfreezeUsers: function unfreezeUsers(userIds, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.freezeUsers", {
        userIds: userIds,
        freeze: 0
      }, function (res) {
        if (res["resultCode"] === 0) {
          success();
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    /**
     * 转移文件
     * @param {Object} parameters
     *   {
     *       fromUserId:
     *       toUserId:
     *   }
     */
    shiftAllFilesOfUser: function shiftAllFilesOfUser(fromUserId, toUserId, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.shiftAllFilesOfUser", {
        fromUser: fromUserId,
        toUser: toUserId
      }, function (res) {
        if (res["resultCode"] === 0) {
          success();
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    /**
     *
     *
     * return array of MDRole
     */
    getAllEnterpriseRoles: function getAllEnterpriseRoles(success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.getAllEnterpriseRoles", {}, function (res) {
        if (res["resultCode"] === 0 && res["roles"] != undefined) {
          var lan = BabelStr.getCurrentLanguage();
          var roles = res["roles"].map(function (role) {
            if (lan == "en") {
              role.description = role.descriptionEN;
              role.name = role.descriptionEN;
              role.commentCN = role.commentEN;
            }
            role = new _MDRole["default"](role);
            // role.set("id" ,role['id']);
            // role.set("name" ,role['name']);
            // role.set("permission" ,role['permission']);
            return role;
          });
          success(roles);
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    getEnterpriseRoleCanSet: function getEnterpriseRoleCanSet(success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.getEnterpriseRoleCanSet", {}, function (res) {
        if (res["resultCode"] === 0 && res["roles"] != undefined) {
          var lan = BabelStr.getCurrentLanguage();
          var roles = res["roles"].map(function (role) {
            if (lan == "en") {
              role.description = role.descriptionEN;
              role.name = role.descriptionEN;
              role.commentCN = role.commentEN;
            }
            role = new _MDRole["default"](role);
            // role.set("id" ,role['id']);
            // role.set("name" ,role['name']);
            // role.set("permission" ,role['permission']);
            return role;
          });
          success(roles);
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    getAllDepartmentRoles: function getAllDepartmentRoles(success, fail) {
      if (MMEnterpriseController.bufferRoles) {
        success(MMEnterpriseController.bufferRoles.roles.slice());
        return;
      }
      if (MMEnterpriseController.getAllDepartmentRolesTimer) {
        clearTimeout(MMEnterpriseController.getAllDepartmentRolesTimer);
      }
      MMEnterpriseController.getAllDepartmentRolesTimer = setTimeout(function () {
        MMEnterpriseController.bufferRoles = null;
      }, 2000);
      if (MMEnterpriseController.getAllDepartmentRolesArr) {
        MMEnterpriseController.getAllDepartmentRolesArr.push({
          success: success,
          fail: fail
        });
        return;
      }
      MMEnterpriseController.getAllDepartmentRolesArr = [{
        success: success,
        fail: fail
      }];
      MMEnterpriseController.request("netDrive.enterpriseHandler.getAllDepartmentRoles", {}, function (res) {
        if (res["resultCode"] === 0 && res["roles"] != undefined) {
          var lan = BabelStr.getCurrentLanguage();
          var roles = res["roles"].map(function (role) {
            if (lan == "en") {
              role.name = role.nameEN;
            }
            role = new _MDRole["default"](role);
            // role.set("id" ,role['id']);
            // role.set("name" ,role['name']);
            // role.set("permission" ,role['permission']);
            return role;
          });
          MMEnterpriseController.bufferRoles = {
            roles: roles.slice(),
            bufferTime: new Date()
          };
          _.each(MMEnterpriseController.getAllDepartmentRolesArr, function (item) {
            item.success(MMEnterpriseController.bufferRoles.roles.slice());
          });
          MMEnterpriseController.getAllDepartmentRolesArr = null;
        } else {
          _.each(MMEnterpriseController.getAllDepartmentRolesArr, function (item) {
            item.fail(res["resultCode"], res["message"]);
          });
          MMEnterpriseController.getAllDepartmentRolesArr = null;
        }
      });
    },
    getAllDepartmentRolesAndPermission: function getAllDepartmentRolesAndPermission(success, fail, refresh) {
      if (MMEnterpriseController.bufferRolesAndPermission && !refresh) {
        var bufferRoles = MMEnterpriseController.bufferRolesAndPermission;
        var today = new Date();
        var passed = today - bufferRoles.bufferTime;
        if (passed < 1 * 60 * 60 * 1000) {
          // 一小时以内有效
          setBabelTimeout(function () {
            console.log(bufferRoles);
            success(bufferRoles.roles.slice(), bufferRoles.filePermissions, bufferRoles.managerPermissions);
          }, 100);
          return;
        }
      }
      MMEnterpriseController.request("netDrive.enterpriseHandler.getAllDepartmentRolesAndPermission", {}, function (res) {
        if (res["resultCode"] === 0) {
          var lan = BabelStr.getCurrentLanguage();
          var roles = res["roles"].map(function (role) {
            if (lan == "en") {
              role.name = role.nameEN;
            }
            return new _MDRole["default"](role);
          });
          MMEnterpriseController.bufferRolesAndPermission = {
            roles: roles,
            bufferTime: new Date(),
            filePermissions: res["filePermissions"],
            managerPermissions: res["managerPermissions"]
          };
          console.log(res);
          success(roles.slice(), res["filePermissions"], res["managerPermissions"]);
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    getAllRoles: function getAllRoles(success, fail) {
      MMEnterpriseController.request("netDrive.shareHandler.getRoles", {}, function (res) {
        console.log("----------> call netDrive.shareHandler.getRoles successfully!");
        if (res["resultCode"] === 0) {
          var out = new _MDRoleInfoCollection["default"]();
          _.each(res["list"], function (item) {
            item.filePermission = item.permission;
          });
          var lan = BabelStr.getCurrentLanguage();
          if (lan == "en") {
            _.each(res["list"], function (item) {
              item.description = item.descriptionEN;
              item.name = item.nameEN;
            });
            res.defaultRole.description = res.defaultRole.descriptionEN;
          }
          if (res["list"]) {
            out.add(res["list"]);
          }
          var defaultRoleId = res["defaultRole"]["id"];
          success(out, defaultRoleId, res["permissions"], []);
        } else {
          fail(res["resultCode"], res);
        }
      });
    },
    /**
     * @typedef AddEnterpriseRoleParams
     * @property {number} permission
     * @property {string} name
     * @property {string} [description] - optional
     */
    /**
     * @warn 目前不再使用
     * 增加企业角色（职位）
     * @param {AddEnterpriseRoleParams} parameters
     */
    addEnterpriseRole: function addEnterpriseRole(name, filePermission, managerPermission, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.addEnterpriseRole", {
        filePermission: filePermission,
        name: name,
        managerPermission: managerPermission
      }, function (res) {
        if (res["resultCode"] === 0) {
          success();
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    createEnterpriseShareRole: function createEnterpriseShareRole(name, permission, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.createEnterpriseShareRole", {
        permission: permission,
        name: name,
        desc: name
      }, function (res) {
        if (res["resultCode"] === 0) {
          success();
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    /**
     * @typedef AddDepartmentRoleParams
     * @property {number} permission
     * @property {string} name
     * @property {string} [description] - optional
     */
    /**
     * 增加企业部门角色（职位）
     * @param {AddDepartmentRoleParams} parameters
     */
    addDepartmentRole: function addDepartmentRole(name, filePermission, managerPermission, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.addDepartmentRole", {
        filePermission: filePermission,
        name: name,
        managerPermission: managerPermission
      }, function (res) {
        if (res["resultCode"] === 0) {
          success();
          MMEnterpriseController.bufferRoles = undefined;
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    /**
     * @warning 不再使用
     * 删除企业角色（职位）- 将该角色的相关人员的角色 id 设置为 0
     *
     */
    delEnterpriseRole: function delEnterpriseRole(roleId, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.deleteEnterpriseRole", {
        roleId: roleId
      }, function (res) {
        if (res["resultCode"] === 0) {
          success();
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    /**
     * 删除部门角色（职位）- 将该角色的相关人员的角色 id 设置为 0
     *
     */
    delDepartmentRole: function delDepartmentRole(roleId, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.deleteDepartmentRole", {
        roleId: roleId
      }, function (res) {
        if (res["resultCode"] === 0) {
          MMEnterpriseController.bufferRoles = undefined;
          success();
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    deleteEnterpriseShareRole: function deleteEnterpriseShareRole(roleIds, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.deleteEnterpriseShareRole", {
        roleIds: roleIds
      }, function (res) {
        if (res["resultCode"] === 0) {
          success();
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    /**
     * @typedef ChangeRoleInfoParameters
     * @property {number} [filePermission]
     * @property {number} [managerPermission]
     * @property {string} [description]
     * @property {name} [name] - optional
     */
    /**
     * 修改角色属性
     *
     * @param {string} roleId
     * @param {ChangeRoleInfoParameters} parameters
     */
    changeRoleInfo: function changeRoleInfo(roleId, filePermission, managerPermission, name, success, fail) {
      var options = {
        filePermission: filePermission,
        managerPermission: managerPermission,
        name: name
      };
      MMEnterpriseController.request("netDrive.enterpriseHandler.changeRoleInfo", {
        roleId: roleId,
        options: options
      }, function (res) {
        if (res["resultCode"] === 0) {
          MMEnterpriseController.bufferRoles = undefined;
          success();
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    updateEnterpriseShareRole: function updateEnterpriseShareRole(roleId, name, permission, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.updateEnterpriseShareRole", {
        roleId: roleId,
        name: name,
        desc: name,
        permission: permission
      }, function (res) {
        if (res["resultCode"] === 0) {
          success();
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    // NEW
    /**
     * @typedef EditUserOptions
     * @property {number} guest - 1 for guest
     * @property {number} status - 1 for frozen
     * @property {number} roleId -
     * @property {string} workId -
     * @property {string} remarks -
     * @property {number} spaceLimit -
     */
    /**
     * 编辑企业人员
     *
     * @param {string} userId
     * @param {EditUserOptions} options
     */

    editUser: function editUser(userId, options, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.updateMemberInfo", {
        userId: userId,
        options: options
      }, function (res) {
        if (res["resultCode"] === 0) {
          success();
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    }
  },
  // ---------------------------------------------------------------  function about deparment
  department: {
    /**
     * @typedef CreateDepartmentOptions
     * @property {number} spaceLimit - in byte
     * @property {string} description
     */
    /**
     * 同一个企业中的部门，不允许重名
     * @param {string} name
     * @param {string} parentId - can be '0'
     * @param {CreateDepartmentOptions} options - options
     * @return
     * {resultCode: 0 - success, 1 - error, other see error code}
     * {resultCode: {Array}department}
     */
    createDepartment: function createDepartment(name, parentId, options, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.createDepartment", {
        name: name,
        parentId: parentId,
        options: options
      }, function (res) {
        if (res["resultCode"] === 0) {
          if (options.needFileInfo) {
            success(new _MMFileInfo["default"](res["file"]), res["department"]);
          } else {
            success(res["department"]);
          }
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    /**
     * @typedef GetSubDepartmentsOptions
     * @property {number} recursive - 1 for get sub recursive
     */
    /**
     * 获得所有子部门
     * @param {int} parentId - if parentId is 0, to get root departments of the enterprise
     * @param {GetSubDepartmentsOptions} [options] - optional
     * @return array of MDDepartment
     *
     */
    getSubDepartments: function getSubDepartments(parentId, options, success, fail) {
      if (typeof options === "function") {
        fail = success;
        success = options;
        options = {};
      }
      MMEnterpriseController.request("netDrive.enterpriseHandler.getSubDepartments", {
        parentId: parentId,
        options: options
      }, function (res) {
        if (res["resultCode"] === 0) {
          success(res["departments"]);
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    // DELETED
    // *
    // * 按名字查找部门
    // * @param {string} searchStr
    // * @return {departments:[d1, d2, d3, ...]}, di = {id, name}
    // *

    // searchDepartmentsByName:function(searchStr, success, fail){

    // },

    // NEW
    /**
     * 获得所有的部门的树形结构信息
     *
     * return :  array of MDDepartment
     *
     *
     */
    getAllDepartmentStructor: function getAllDepartmentStructor(success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.getAllDepartments", {}, function (res) {
        if (res["resultCode"] === 0) {
          var validDeps = [];
          var allDeps = res["departments"];
          if (allDeps) {
            for (var i = 0; i < allDeps.length; i++) {
              var dep = allDeps[i];
              if (dep.validate) {
                validDeps.push(dep);
              }
            }
          }
          success(validDeps);
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    getEnterpriseAllDepAndProject: function getEnterpriseAllDepAndProject(success, fail) {
      MMEnterpriseController.request("netDrive.fileExHandler.getEnterpriseAllDepAndProject", {}, function (res) {
        if (res["resultCode"] === 0) {
          success(res["files"]);
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    getDepartmentDetailInfo: function getDepartmentDetailInfo(departmentId, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.getDepartmentDetailInfo3", {
        departmentId: departmentId
      }, function (res) {
        if (res["resultCode"] === 0) {
          var departmentIds = [];
          var depFolderIds = [];
          var allOwners = [];
          var allDepIds = [];
          var curDepartment = res["curDepartment"];
          var subDepartments = res["subDepartments"];
          departmentIds.push(curDepartment.id);
          depFolderIds.push(curDepartment.folderId);
          allOwners.push(curDepartment.allOwners);
          allDepIds.push(curDepartment.allDepIds);
          for (var i = 0; i < subDepartments.length; i++) {
            var dep = subDepartments[i];
            departmentIds.push(dep.id);
            depFolderIds.push(dep.folderId);
            allOwners.push(dep.allOwners);
            allDepIds.push(dep.allDepIds);
          }
          var spaceAPIParam = {
            curDepParentId: curDepartment.parent,
            departmentIds: departmentIds,
            depFolderIds: depFolderIds,
            allOwners: allOwners
          };
          var memberCountAPIParam = {
            curDepParentId: curDepartment.parent,
            departmentIds: departmentIds,
            allDepIds: allDepIds
          };
          success(res["curDepartment"], res["subDepartments"], departmentId, spaceAPIParam, memberCountAPIParam);
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    getDepartmentUsedSpace3: function getDepartmentUsedSpace3(params, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.getDepartmentUsedSpace3", params, function (res) {
        if (res["resultCode"] === 0) {
          success(res["usedSpaces"]);
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    countDepartmentsMemberIncludeSub2: function countDepartmentsMemberIncludeSub2(params, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.countDepartmentsMemberIncludeSub2", params, function (res) {
        if (res["resultCode"] === 0) {
          var result = res['result'];
          success(result["subDepartments"], result["curDepartment"]);
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    fetchRealUsedSpace: function fetchRealUsedSpace(userIds, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.fetchRealUsedSpace", {
        userIds: userIds
      }, function (res) {
        if (res["resultCode"] === 0) {
          _.each(res["userSpaceInfos"], function (item) {
            item.id = item.userId;
          });
          success(res["userSpaceInfos"]);
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    setDisableShareInDepartment: function setDisableShareInDepartment(params, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.setDisableShareInDepartment", {
        departmentId: params.departmentId,
        disable: params.disable,
        coverSub: params.coverSub
      }, function (res) {
        if (res["resultCode"] === 0) {
          success();
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    setDisableOnlineEditOfficeDepartment: function setDisableOnlineEditOfficeDepartment(params, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.setDisableOnlineEditOfficeDepartment", {
        departmentId: params.departmentId,
        disable: params.disable,
        coverSub: params.coverSub
      }, function (res) {
        if (res["resultCode"] === 0) {
          success();
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    /**
     *
     * 返回值：
     *   success: {status:0 - no error}
     */
    delDepartment: function delDepartment(departmentId, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.deleteDepartment", {
        departmentId: departmentId
      }, function (res) {
        if (res["resultCode"] === 0) {
          success();
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    delDepartmentByFolderId: function delDepartmentByFolderId(departmentId, depFolderId, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.deleteDepartment", {
        departmentId: departmentId,
        depFolderId: depFolderId
      }, function (res) {
        if (res["resultCode"] === 0) {
          success();
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    /**
     * @typedef ChangeDepartmentInfoParameter
     * @property {string} [name]
     * @property {string} [description]
     * @property {number} [spaceLimit] - in byte
     * @property {number} parentId 父部门ID
     *
     */
    /**
     *  修改部门
     * @param {string} departmentId
     * @param {ChangeDepartmentInfoParameter} parameter
     */
    changeDepartmentInfo: function changeDepartmentInfo(departmentId, parameter, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.updateDepartmentInfo", {
        departmentId: departmentId,
        options: parameter
      }, function (res) {
        if (res["resultCode"] === 0) {
          success();
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    setDepartmentSpaceInfo: function setDepartmentSpaceInfo(departmentId, spaceLimit, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.setDepartmentSpaceInfo", {
        departmentId: departmentId,
        spaceLimit: spaceLimit
      }, function (res) {
        if (res["resultCode"] === 0) {
          success();
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    /**
     * @typedef DepartmentSpaceInfo
     * @property {string} departmentId
     * @property {string} name - department name
     * @property {string} parent - parent departmentId
     * @property {string} folderId - folderId of department
     * @property {number} spaceLimit - spaceLimit of department
     * @property {number} used - used space of department
     */
    /**
     * @typedef GetDepartmentSpaceInfoResult
     * @property {DepartmentSpaceInfo[]} spaceInfos;
     *
    /**
    * 获得指定部门的空间使用状况
    * @param {string[]|string} departmentIds - single or array
    * @return {DepartmentSpaceInfo[]}
    */
    getDepartmentSpaceInfo: function getDepartmentSpaceInfo(departmentIds, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.getDepartmentSpaceInfo", {
        departmentIds: departmentIds
      }, function (res) {
        if (res["resultCode"] === 0) {
          success(res["spaceInfos"]);
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    /**
     * 设置部门空间限制
     */
    editDepartmentSpaceInfo: function editDepartmentSpaceInfo(departmentId, spaceLimited, success, fail) {
      this.changeDepartmentInfo(departmentId, {
        spaceLimit: spaceLimited
      }, success, fail);
    },
    moveDepartment: function moveDepartment(departmentId, destId, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.moveDepartment", {
        departmentId: departmentId,
        destId: destId
      }, function (res) {
        if (res["resultCode"] === 0) {
          success();
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    /**
     * 获取部门人员情况
     *
     * @return :[m1, m2, m3,...],  其中 mi 结构 {userId, userName, roleId, roleName}
     *
     */
    getDepartmentMemberInfo: function getDepartmentMemberInfo(departmentId, maxRoleNum, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.getDepartmentMembers", {
        departmentId: departmentId,
        pageSize: maxRoleNum
      }, function (res) {
        if (res["resultCode"] === 0) {
          success(res["members"]);
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    getNoDepartmentMemberInfo: function getNoDepartmentMemberInfo(maxRoleNum, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.getMemberNotInDepartment", {
        maxRoleNum: maxRoleNum
      }, function (res) {
        if (res["resultCode"] === 0) {
          success(res["members"]);
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    /**
     * match currentUser {
     *  enterprise administrator => all department and members,
     *  _ => join department which has read department member permission
     * }
     */
    getDepartmentAndMembersICanSee: function getDepartmentAndMembersICanSee(success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.getDepartmentMembersICanSee", {}, function (res) {
        if (res["resultCode"] === 0) {
          success(res["departments"]);
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    /**
     *  get the user's department memeber info:
     *
     * @return [department1, department2, ...], where department[i] is
     *   {departmentId, departmentName, roleId, roleName, permission}
     *
     */
    getUserDepartmentRoleInfo: function getUserDepartmentRoleInfo(userId, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.getAllDepartmentsByMember", {
        userId: userId
      }, function (res) {
        if (res["resultCode"] === 0) {
          success(res["departments"]);
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    getMyDepartmentFolders: function getMyDepartmentFolders(success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.getMyDepartmentFolders", {}, function (res) {
        if (res["resultCode"] === 0) {
          success(res["list"], res["departments"], res["projects"]);
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    /**
     * @typedef AddDepartmentMemberOptions
     * @property {string} roleId
     * @property {number} spaceLimit
     */

    /**
     * @param {string} departmentId
     * @param {string[] | string} userIds
     * @param {AddDepartmentMemberOptions} options
     * @param success
     * @param fail
     */
    addDepartmentMembers: function addDepartmentMembers(departmentId, userIds, options, success, fail) {
      if (typeof options === "function") {
        fail = success;
        success = options;
        options = {};
      }
      MMEnterpriseController.request("netDrive.enterpriseHandler.addDepartmentMembers", {
        userIds: userIds,
        departmentId: departmentId,
        options: options
      }, function (res) {
        if (res["resultCode"] === 0) {
          success();
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    /**
     * @param {string} departmentId
     * @param {string[]} userIds
     *
     */
    delDepartmentMembers: function delDepartmentMembers(departmentId, userIds, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.deleteDepartmentMembers", {
        departmentId: departmentId,
        userIds: userIds
      }, function (res) {
        if (res["resultCode"] === 0) {
          success();
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    // NEW
    /**
     * 修改用户在部门中的空间限制
     *
     * @param {Object} {
     *   userId,
     *   departmentId,
     *   spaceLimited,
     * }
     *
     */
    editUserDepartmentSpaceInfo: function editUserDepartmentSpaceInfo(departmentId, userId, spaceLimit, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.updateDepartmentMemberInfo", {
        departmentId: departmentId,
        userIds: userId,
        options: {
          spaceLimit: spaceLimit
        }
      }, function (res) {
        if (res["resultCode"] === 0) {
          success();
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    // NEW
    /**
     *
     * 将修改用户在部门中的角色
     *
     * @param {array of id} userIds
     *
     */
    changeUsersRoleInDepartment: function changeUsersRoleInDepartment(userIds, departmentId, roleId, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.updateDepartmentMemberInfo", {
        departmentId: departmentId,
        userIds: userIds,
        options: {
          roleId: roleId
        }
      }, function (res) {
        if (res["resultCode"] === 0) {
          success();
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    /**
     * 将用户从所有原部门中移除，并且加入新的部门
     */
    moveUsersToDepartment: function moveUsersToDepartment(userIds, oldDepartments, newDepartments, roleId, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.moveUsersToDepartment", {
        userIds: userIds,
        newDepartments: newDepartments,
        oldDepartments: oldDepartments,
        roleId: roleId
      }, function (res) {
        if (res["resultCode"] === 0) {
          success();
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    setUserDepartmentAndRoles: function setUserDepartmentAndRoles(userId, departmentIds, roleIds, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.setUserDepartmentAndRoles", {
        userId: userId,
        departmentIds: departmentIds,
        roleIds: roleIds
      }, function (res) {
        if (res["resultCode"] === 0) {
          success();
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    getSubDepartmentsFileCounts: function getSubDepartmentsFileCounts(depFolderId, success, fail) {
      // var depFileCounts = [
      //   {depName: "市场部", fileCounts:1000},
      //   {depName: "苹果委员会", fileCounts:100},
      //   {depName: "会所", fileCounts:400},
      //   {depName: "研发部", fileCounts:600},
      //   {depName: "销售部", fileCounts:900},
      //   {depName: "体育部", fileCounts:100},
      //   {depName: "后勤部", fileCounts:300},
      //   {depName: "总经办", fileCounts:700},
      // ];
      // depFileCounts = _.sortBy(depFileCounts, 'fileCounts');
      // setBabelTimeout(()=>{
      //   success(depFileCounts);
      // }, 1000)
      // return;

      MMEnterpriseController.request("netDrive.statisHandler.getSubDepFileCount", {
        parentDepFolderId: depFolderId
      }, function (res) {
        if (res["resultCode"] === 0) {
          var departments = res["departments"];
          departments = _.sortBy(departments, "fileCount");
          success(departments);
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    },
    /**
     * @param parameters {
     *     name, parentId, folderId, creatorId
     * }
     */
    searchDepartment: function searchDepartment(parameters, success, fail) {
      MMEnterpriseController.request("netDrive.enterpriseHandler.searchDepartment", {
        options: parameters
      }, function (res) {
        if (res["resultCode"] === 0) {
          success(res["departments"]);
        } else {
          fail(res["resultCode"], res["message"]);
        }
      });
    }
  }
};
var _default = exports["default"] = out;

},{"108":108,"1184":1184,"1412":1412,"1415":1415,"1418":1418,"1422":1422,"1426":1426,"1429":1429,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1466":1466,"1478":1478,"1500":1500,"1503":1503,"1537":1537,"1541":1541,"163":163,"249":249,"251":251,"256":256,"257":257,"260":260,"272":272,"273":273,"280":280,"282":282,"297":297,"49":49,"72":72}],282:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMCollectionBase = _interopRequireDefault(require(20));
var _MDRoleInfo = _interopRequireDefault(require(281));
var MDRoleInfoCollection = _MMCollectionBase["default"].extend({
  model: _MDRoleInfo["default"],
  comparator: function comparator(info) {
    return info.get('roleOrder');
  }
});
var _default = exports["default"] = MDRoleInfoCollection;

},{"1184":1184,"1454":1454,"20":20,"281":281}],281:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMModelBase = _interopRequireDefault(require(21));
var MDRoleInfo = _MMModelBase["default"].extend({
  defaults: {
    'id': 0,
    'name': BabelStr.str(731),
    'description': BabelStr.str(7042)
  },
  getRoleId: function getRoleId() {
    return this.get('id');
  },
  setRoleId: function setRoleId(id) {
    this.set('id', id);
  },
  getRoleDesName: function getRoleDesName(defaultRoleName) {
    if (defaultRoleName && this.getRoleId() == 0) {
      return this.get('name') + '（' + defaultRoleName + '）';
    }
    ;
    return this.get('name') + '（' + this.get('description') + '）';
  },
  getRoleName: function getRoleName() {
    return this.get('name');
  },
  getForShare: function getForShare() {
    return this.get('forShare');
  },
  getForTeamShare: function getForTeamShare() {
    return this.get('forTeamShare');
  },
  setRoleName: function setRoleName(name) {
    this.set('name', name);
  },
  isManager: function isManager() {
    return this.get('permission') == 65535;
  },
  // 仅上传等功能不能用于文件
  onlyForFolder: function onlyForFolder() {
    return (this.get('permission') & 256) == 256;
  },
  /**
   * get the int value of permission
   *
   * @return permission { int }
   */
  getPermission: function getPermission() {
    return this.get('permission');
  },
  getDescription: function getDescription() {
    return this.get('description');
  }
});
var _default = exports["default"] = MDRoleInfo;

},{"1184":1184,"1454":1454,"21":21}],280:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMModelBase = _interopRequireDefault(require(21));
/**
 * Modified by manjun.han 适配cmd
 * 2016.12.5
 */

var MDRole = _MMModelBase["default"].extend({
  defaults: {
    "id": null,
    "name": null,
    "filePermission": null,
    "managerPermission": null,
    'default': -1
  },
  getName: function getName() {
    return this.get('name');
  },
  getId: function getId() {
    return this.get('id');
  }
});
var _default = exports["default"] = MDRole;

},{"1184":1184,"1454":1454,"21":21}],260:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1466);
var _MMModelBase = _interopRequireDefault(require(21));
// MDGroupInfo.js
// jiang
// 2017-7-8

var MDGroupInfo = _MMModelBase["default"].extend({
  "default": {
    'groupId': "001",
    'groupName': "企业公共分组111",
    'memberNum': 10,
    'belongToEnterprise': 1,
    'groupMembers': null,
    'creatorName': '',
    'creatorId': -1,
    "hidden": false
  },
  initialize: function initialize(attr, opts) {
    this.set({
      'groupId': parseInt(attr['groupId'])
    }, {
      silent: true
    });
  },
  groupId: function groupId() {
    return this.get('groupId');
  },
  groupName: function groupName() {
    return this.get('groupName');
  },
  setGroupName: function setGroupName(name) {
    this.set('groupName', name);
  },
  memberNum: function memberNum() {
    return this.get('memberNum');
  },
  belongToEnterprise: function belongToEnterprise() {
    return this.get('belongToEnterprise') == 1;
  },
  groupMembers: function groupMembers() {
    return this.get('groupMembers');
  },
  setMemberNum: function setMemberNum(num) {
    this.set('memberNum', num);
  }
}, {});
var _default = exports["default"] = MDGroupInfo;

},{"1184":1184,"1454":1454,"1466":1466,"21":21}],163:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MEExportMsgWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MEExportMsgWinView, _MDWindowView);
  function MEExportMsgWinView() {
    (0, _classCallCheck2["default"])(this, MEExportMsgWinView);
    return _callSuper(this, MEExportMsgWinView, arguments);
  }
  (0, _createClass2["default"])(MEExportMsgWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "<div class=\"flex-align middle info center f-pointer with-wrap\">\n        <%=BabelStr.str(11017)%>\n      </div>";
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEExportMsgWinView.prototype), "className", this).call(this);
      return "".concat(superCls, " export-msg-win");
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEExportMsgWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        'click .info': this._infoClickHandle
      });
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      props.size = 'small';
      props.title = BabelStr.str(170);
      props.buttons = [{
        label: BabelStr.str(156),
        /*确认*/
        type: 'default'
      }];
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MEExportMsgWinView.prototype), "initialize", this).call(this, props);
    }
  }, {
    key: "_infoClickHandle",
    value: function _infoClickHandle() {
      this.close();
      app.pathRouter.openNetTab("/enterpriseIndex.do#export");
    }
  }], [{
    key: "className",
    value: function className() {
      return 'MEExportMsgWinView';
    }
  }]);
  return MEExportMsgWinView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"93":93}],1100:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1439);
require(1437);
require(1418);
require(1463);
require(1537);
require(1426);
require(1431);
require(1423);
require(1471);
require(1487);
require(1538);
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MMFileInfo = _interopRequireDefault(require(297));
var _MMFileInfoCollection = _interopRequireDefault(require(298));
var _MMTrashFileInfoCollection = _interopRequireDefault(require(309));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MASessionCollection = _interopRequireDefault(require(238));
var _app = _interopRequireDefault(require(17));
var _MMNormalCollection = _interopRequireDefault(require(305));
var _FILE_ACTION_BITS = _interopRequireDefault(require(235));
var _MDLoginLogCollection = _interopRequireDefault(require(265));
var _MDLoadMaskView = _interopRequireDefault(require(49));
var _default = exports["default"] = {
  listReceiveFilesFromPort: function listReceiveFilesFromPort(fileNameSearch, orderName, isAsc, pageIndex, pageSize, success, fail, params) {
    params = _.extend({}, params);
    MMEnterpriseController.request("netDrive.dispatchFileHandler.listReceiveFilesFromPort", {
      fileNameSearch: fileNameSearch ? fileNameSearch : undefined,
      pageIndex: pageIndex ? pageIndex : 0,
      pageSize: pageSize ? pageSize : 50,
      orderBy: orderName,
      isAsc: isAsc
    }, function (res) {
      if (res["resultCode"] === 0) {
        _.each(res["filesReceived"], function (item) {
          item.fileName = item.name;
          item.type = 1;
          item.fileStatus = 0;
          item.time = new Date(item.time).getTime() / 1000;
          item.reviewTime = new Date(item.reviewTime);
          item.currentVersionSize = item.currentVersionSize || item.fileSize;
          item.actions = _FILE_ACTION_BITS["default"].DOWNLOAD | _FILE_ACTION_BITS["default"].COPY | _FILE_ACTION_BITS["default"].READ;
        });
        console.error(res);
        var out = new _MMFileInfoCollection["default"](res["filesReceived"]);
        if (!res["filesReceived"]) {
          success(out, res["total"], res["pages"]);
          return;
        }
        // out = MMEnterpriseController.listFilesByPagesCallback(res, params.no2ndFileInfo)
        _.isFunction(success) && success(out, res["total"]);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  listSendFiles2Port: function listSendFiles2Port(fileNameSearch, orderName, isAsc, pageIndex, pageSize, success, fail, params) {
    params = _.extend({}, params);
    MMEnterpriseController.request("netDrive.dispatchFileHandler.listSendFiles2Port", {
      fileNameSearch: fileNameSearch ? fileNameSearch : undefined,
      pageIndex: pageIndex ? pageIndex : 0,
      pageSize: pageSize ? pageSize : 50,
      orderBy: orderName,
      isAsc: isAsc
    }, function (res) {
      if (res["resultCode"] === 0) {
        _.each(res["filesReceived"], function (item) {
          item.fileName = item.name;
          item.type = 1;
          item.fileStatus = 0;
          item.time = new Date(item.time).getTime() / 1000;
          item.reviewTime = item.reviewTime ? new Date(item.reviewTime) : null;
          item.currentVersionSize = item.currentVersionSize || item.fileSize;
          item.actions = _FILE_ACTION_BITS["default"].DOWNLOAD | _FILE_ACTION_BITS["default"].COPY | _FILE_ACTION_BITS["default"].READ;
        });
        console.error(res);
        var out = new _MMFileInfoCollection["default"](res["filesReceived"]);
        if (!res["filesReceived"]) {
          success(out, res["total"], res["pages"]);
          return;
        }
        // out = MMEnterpriseController.listFilesByPagesCallback(res, params.no2ndFileInfo)
        _.isFunction(success) && success(out, res["total"]);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  listPersonalFiles: function listPersonalFiles(parentId, orderName, isAsc, page, pageSize, success, fail, params) {
    params = _.extend({}, params);
    MMEnterpriseController.request("netDrive.fileHandler.listPersonalFiles", {
      did: parentId,
      page: page ? page : 0,
      pageSize: pageSize ? pageSize : 50,
      orderBy: orderName,
      isAsc: isAsc,
      type: params && params.type
    }, function (res) {
      res.pages; // 总页数
      res.total; // 总记录数
      res.fileInfos; // 文件信息
      if (res["resultCode"] === 0) {
        console.error(res);
        var out = new _MMFileInfoCollection["default"]();
        if (!res["resultSet"] || !res["resultSet"]["fileInfos"]) {
          success(out, res["total"], res["pages"]);
          return;
        }
        out = MMEnterpriseController.listFilesByPagesCallback(res, params.no2ndFileInfo);
        _.isFunction(success) && success(out, res["total"], res["pages"]);
      } else {
        if (res["resultCode"] == 853 && res.options && res.options.noPassFiles) {
          MMEnterpriseController.checkFilesSequentially(res.options.noPassFiles, function () {
            MMEnterpriseController.listPersonalFiles(parentId, orderName, isAsc, page, pageSize, success, fail, params);
          }, function () {
            _.isFunction(fail) && fail(res["resultCode"], BabelStr.str(27029), res);
          });
        } else {
          _.isFunction(fail) && fail(res["resultCode"], res["message"], res);
        }
      }
    });
  },
  listFilesByPagesCallback: function listFilesByPagesCallback(res, no2ndFileInfo) {
    var out = new _MMFileInfoCollection["default"]();
    var defaults = res["resultSet"]["defaults"];
    var usernamesById = res["resultSet"]["userNames"] || res["resultSet"]["users"];
    var fileInfos = res["resultSet"]["fileInfos"];
    fileInfos.forEach(function (file) {
      _.defaults(file, defaults);
      if (file["parentId"] == "0") {
        file["path"] = "/" + file["fileId"] + "/0/";
      } else if (file.path === "") {
        file["path"] = "/" + file["fileId"] + "/" + file["parentId"] + "/0/";
      }
      // else {
      //   file["path"] =
      //     "/" +
      //     file["fileId"] +
      //     "/" +
      //     file["parentId"] +
      //     "/" +
      //     file["path"] +
      //     "/0/";
      // }

      if (file["currentVersionSize"] === undefined) file["currentVersionSize"] = file["fileSize"];
      if (file["lastModifyUserId"] === undefined) file["lastModifyUserId"] = file["creatorId"];
      if (file["ownerId"] === undefined) file["ownerId"] = file["creatorId"];
      if (file.isSharing && file["sharerId"] === undefined) file["sharerId"] = file["creatorId"];
      if (file["currentVerCommitterId"] === undefined) file["currentVerCommitterId"] = file["creatorId"];
      if (file["mtime"] === undefined) file["mtime"] = file["ctime"];
      file["managerName"] = usernamesById[file["manager"]];
      file["creatorName"] = usernamesById[file["creatorId"]];
      file["lastModifyUserName"] = usernamesById[file["lastModifyUserId"]];
      file["ownerName"] = usernamesById[file["ownerId"]];
      file["sharerName"] = usernamesById[file["sharerId"]];
      file["currentVerCommitterName"] = usernamesById[file["currentVerCommitterId"]];
    });
    fileInfos.forEach(function (file) {
      var fileInfo = new _MMFileInfo["default"](file);
      out.push(fileInfo);
    });
    if (!no2ndFileInfo) {
      _MMNetDiskDataController["default"].get2ndFileInfo(out.models, function () {});
    }
    return out;
  },
  listProjectFiles: function listProjectFiles(parentId, orderName, isAsc, page, pageSize, success, fail, params) {
    params = _.extend({}, params);
    MMEnterpriseController.request("netDrive.fileHandler.listProjectFiles", {
      did: parentId,
      page: page ? page : 0,
      pageSize: pageSize ? pageSize : 50,
      orderBy: orderName,
      isAsc: isAsc,
      type: params.type
    }, function (res) {
      res.pages; // 总页数
      res.total; // 总记录数
      res.fileInfos; // 文件信息
      if (res["resultCode"] === 0) {
        console.error(res);
        var out = new _MMFileInfoCollection["default"]();
        if (!res["resultSet"] || !res["resultSet"]["fileInfos"]) {
          success(out, res["total"], res["pages"]);
          return;
        }
        out = MMEnterpriseController.listFilesByPagesCallback(res, params.no2ndFileInfo);
        _.isFunction(success) && success(out, res["total"], res["pages"]);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  getAllProjectFoldersInEnterpriseInPage: function getAllProjectFoldersInEnterpriseInPage(parentId, orderName, isAsc, page, pageSize, success, fail, params) {
    params = _.extend({}, params);
    var datas = {
      page: page ? page : 0,
      pageSize: pageSize ? pageSize : 50,
      orderBy: orderName,
      isAsc: isAsc
    };
    var router;
    if (parentId != "0") {
      datas.did = parentId, datas.type = params && params.type;
      router = "netDrive.fileHandler.listEnterpriseFiles";
    } else {
      router = "netDrive.fileHandler.getAllProjectFoldersInEnterpriseInPage";
    }
    MMEnterpriseController.request(router, datas, function (res) {
      res.pages; // 总页数
      res.total; // 总记录数
      res.fileInfos; // 文件信息
      if (res["resultCode"] === 0) {
        console.error(res);
        var out = new _MMFileInfoCollection["default"]();
        if (!res["resultSet"] || !res["resultSet"]["fileInfos"]) {
          success(out, res["total"], res["pages"]);
          return;
        }
        out = MMEnterpriseController.listFilesByPagesCallback(res, params.no2ndFileInfo);
        _.isFunction(success) && success(out, res["total"], res["pages"]);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  listMyShareFiles: function listMyShareFiles(parentId, orderBy, isAsc, page, pageSize, success, fail, readInfoSuccess) {
    var route = "netDrive.fileHandler.listMyShareFiles";
    console.error(new Date().getTime());
    _MMNetDiskDataController["default"].request(route, {
      did: parentId,
      page: page,
      pageSize: pageSize,
      orderBy: orderBy,
      isAsc: isAsc
    }, function (res) {
      console.error(res);
      var out = new _MMFileInfoCollection["default"]();
      if (!res["resultSet"] || !res["resultSet"]["fileInfos"]) {
        success(out, res["total"], res["pages"]);
        return;
      }
      out = MMEnterpriseController.listFilesByPagesCallback(res);
      _.isFunction(success) && success(out, res["total"], res["pages"]);
    });
  },
  listJoinShareFiles: function listJoinShareFiles(parentId, orderBy, isAsc, page, pageSize, success, fail, params) {
    params = _.extend({}, params);
    MMEnterpriseController.request("netDrive.fileHandler.listJoinShareFiles", {
      did: parentId,
      page: page ? page : 0,
      pageSize: pageSize ? pageSize : 50,
      orderBy: orderBy,
      isAsc: isAsc,
      type: params && params.type
    }, function (res) {
      res.pages; // 总页数
      res.total; // 总记录数
      res.fileInfos; // 文件信息
      if (res["resultCode"] === 0) {
        // _.isFunction(fail) && fail(res['resultCode'], res["message"]);
        // return
        console.error(res);
        var out = new _MMFileInfoCollection["default"]();
        if (!res["resultSet"] || !res["resultSet"]["fileInfos"]) {
          success(out, res["total"], res["pages"]);
          return;
        }
        out = MMEnterpriseController.listFilesByPagesCallback(res, params.no2ndFileInfo);
        out.each(function (item) {
          item.setParentFolderId(parentId);
        });
        _.isFunction(success) && success(out, res["total"], res["pages"]);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  listMyBinFiles: function listMyBinFiles(did, orderBy, isAsc, page, pageSize, success, fail) {
    var route = "netDrive.fileHandler.listMyBinFiles";
    MMEnterpriseController.request(route, {
      did: did,
      page: page,
      pageSize: pageSize,
      orderBy: orderBy,
      isAsc: isAsc
    }, function (res) {
      if (res.resultCode == 0) {
        console.error(res);
        res.fileArr;
        res.pages;
        res.total;
        if (!res["fileArr"]) {
          success(out, res["total"], res["pages"]);
          return;
        }
        _.each(res["fileArr"], function (file) {
          file.parentId = did;
          file.id = file.fileId + "-" + file["deleteVersion"] || 0;
        });
        var out = new _MMTrashFileInfoCollection["default"](res["fileArr"]);
        _.isFunction(success) && success(out, res["total"], res["pages"]);
        _MMNetDiskDataController["default"].get2ndFileInfo(out.models, function () {});
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  listEntRootBinInPage: function listEntRootBinInPage(did, orderBy, isAsc, page, pageSize, success, fail) {
    var route = "netDrive.fileHandler.listEntRootBinInPage";
    MMEnterpriseController.request(route, {
      did: did,
      page: page,
      pageSize: pageSize,
      orderBy: orderBy,
      isAsc: isAsc
    }, function (res) {
      if (res.resultCode == 0) {
        console.error(res);
        res.fileArr;
        res.pages;
        res.total;
        if (!res["fileArr"]) {
          success(out, res["total"], res["pages"]);
          return;
        }
        _.each(res["fileArr"], function (file) {
          file.parentId = did;
          file.id = file.fileId + "-" + file["deleteVersion"] || 0;
        });
        var out = new _MMTrashFileInfoCollection["default"](res["fileArr"]);
        _.isFunction(success) && success(out, res["total"], res["pages"]);
        _MMNetDiskDataController["default"].get2ndFileInfo(out.models, function () {});
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  listMyDeletedFilesInPage: function listMyDeletedFilesInPage(did, orderBy, isAsc, page, pageSize, success, fail) {
    MMEnterpriseController.listBinWithRouter({
      did: did,
      orderBy: orderBy,
      isAsc: isAsc,
      page: page,
      pageSize: pageSize,
      success: success,
      fail: fail
    }, "netDrive.fileHandler.listMyDeletedFilesInPage");
  },
  getDepDeletedFiles: function getDepDeletedFiles(did, orderBy, isAsc, page, pageSize, success, fail) {
    MMEnterpriseController.listBinWithRouter({
      did: did,
      orderBy: orderBy,
      isAsc: isAsc,
      page: page,
      pageSize: pageSize,
      success: success,
      fail: fail
    }, "netDrive.fileHandler.getDepDeletedFiles");
  },
  getStdEditionOtherDeletedFiles: function getStdEditionOtherDeletedFiles(did, orderBy, isAsc, page, pageSize, success, fail) {
    MMEnterpriseController.listBinWithRouter({
      did: did,
      orderBy: orderBy,
      isAsc: isAsc,
      page: page,
      pageSize: pageSize,
      success: success,
      fail: fail
    }, "netDrive.fileHandler.getStdEditionOtherDeletedFiles");
  },
  listBinWithRouter: function listBinWithRouter(params, router) {
    MMEnterpriseController.request(router, {
      did: params.did,
      page: params.page,
      pageSize: params.pageSize,
      orderBy: params.orderBy,
      isAsc: params.isAsc
    }, function (res) {
      if (res.resultCode == 0) {
        console.error(res);
        res.fileArr;
        res.pages;
        res.total;
        if (!res["fileArr"]) {
          params.success(out, res["total"], res["pages"]);
          return;
        }
        _.each(res["fileArr"], function (file) {
          file.parentId = params.did;
          file.id = file.fileId + "-" + file["deleteVersion"] || 0;
        });
        var out = new _MMTrashFileInfoCollection["default"](res["fileArr"]);
        _.isFunction(params.success) && params.success(out, res["total"], res["pages"]);
        _MMNetDiskDataController["default"].get2ndFileInfo(out.models, function () {});
      } else {
        _.isFunction(params.fail) && params.fail(res["resultCode"], res["message"]);
      }
    });
  },
  listMyFocusFiles: function listMyFocusFiles(did, orderBy, isAsc, page, pageSize, success, fail) {
    var route = "netDrive.fileHandler.listMyFocusFiles";
    MMEnterpriseController.request(route, {
      did: did,
      page: page,
      pageSize: pageSize,
      orderBy: orderBy,
      isAsc: isAsc
    }, function (res) {
      if (res.resultCode == 0) {
        console.error(res);
        res.list; // files
        res.pages;
        res.total;
        if (!res["fileInfos"]) {
          success(out, 0);
          return;
        }
        var out = new _MMFileInfoCollection["default"](res["fileInfos"]);
        _.isFunction(success) && success(out, res["total"], res["pages"]);
        _MMNetDiskDataController["default"].get2ndFileInfo(out.models, function () {});
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  listFilesForTag: function listFilesForTag(tagIds, orderBy, isAsc, page, pageSize, success, fail) {
    var route = "netDrive.tagHandler.listFilesForTag";
    var setOp = localStorage.getItem("filter_tag_set_op") || 0;
    MMEnterpriseController.request(route, {
      tagIds: tagIds,
      page: page,
      pageSize: pageSize,
      orderBy: orderBy,
      isAsc: isAsc,
      setOp: setOp
    }, function (res) {
      if (res.resultCode == 0) {
        console.error(res);
        res.fileInfos; // files
        res.pages;
        res.total;
        res["fileInfos"].forEach(function (fileInfo) {
          fileInfo.searchResult = 1;
        });
        var out = new _MMFileInfoCollection["default"](res["fileInfos"]);
        _.isFunction(success) && success(out, res["total"], res["pages"]);
        _MMNetDiskDataController["default"].get2ndFileInfo(out.models, function () {});
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  getAccountAuthInfo: function getAccountAuthInfo(successCB, failCb) {
    $.ajax({
      type: "POST",
      url: "/config/getAccountAuthInfo.do",
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData["info"]);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  getAuthAccessInfo: function getAuthAccessInfo(type, successCB, failCb) {
    $.ajax({
      type: "POST",
      url: "/config/getAuthAccessInfo.do",
      data: {
        type: type
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          var _data = responseData["config"] && responseData["config"];
          _.isFunction(successCB) && successCB(_data);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  updateAccountAuthInfo: function updateAccountAuthInfo(data, successCB, failCb) {
    $.ajax({
      type: "POST",
      url: "/config/updateAccountAuthInfo.do",
      data: data,
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData["info"]);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  updateAuthAccessInfo: function updateAuthAccessInfo(data, successCB, failCb) {
    $.ajax({
      type: "POST",
      url: "/config/updateAuthAccessInfo.do",
      data: data,
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData["info"]);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  getAccountAuthInfoByType: function getAccountAuthInfoByType(type, successCB, failCb) {
    $.ajax({
      type: "POST",
      data: {
        type: type
      },
      url: "/config/getAccountAuthInfo.do",
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData["info"]);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  getConfigOthers: function getConfigOthers(successCB, failCb) {
    $.ajax({
      type: "POST",
      url: "/config/getConfigOthers.do",
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData["info"]);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  updateEmailServerInfo: function updateEmailServerInfo(data, successCB, failCb) {
    $.ajax({
      type: "POST",
      url: "/config/updateEmailServerInfo.do",
      data: data,
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  sendTestEmail: function sendTestEmail(data, successCB, failCb) {
    $.ajax({
      type: "POST",
      url: "/config/sendTestEmail.do",
      data: data,
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  updateUseBabelId: function updateUseBabelId(useBabelId, successCB, failCb) {
    $.ajax({
      type: "POST",
      url: "/config/updateUseBabelId.do",
      data: {
        useBabelId: useBabelId
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  updateUseHighStrengthPassword: function updateUseHighStrengthPassword(highStrengthPassword, successCB, failCb) {
    $.ajax({
      type: "POST",
      url: "/config/updateUseHighStrengthPassword.do",
      data: {
        highStrengthPassword: highStrengthPassword
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  getEmailServerInfo: function getEmailServerInfo(successCB, failCb) {
    $.ajax({
      type: "POST",
      url: "/config/getEmailServerInfo.do",
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData["info"]);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  getStorageTypeInfo: function getStorageTypeInfo(successCB, failCb) {
    $.ajax({
      type: "POST",
      url: "/config/getStorageTypeInfo.do",
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData["info"]);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  updateStorageTypeInfo: function updateStorageTypeInfo(type, successCB, failCb) {
    $.ajax({
      type: "POST",
      data: {
        type: type
      },
      url: "/config/updateStorageTypeInfo.do",
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData["info"]);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  updateStorageS3: function updateStorageS3(data, successCB, failCb) {
    $.ajax({
      type: "POST",
      data: data,
      url: "/config/updateStorageS3.do",
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  hasSameNameInFolder: function hasSameNameInFolder(params, successCB, failCb) {
    var callServer = function callServer() {
      if (!MMEnterpriseController.sameNameQueue || MMEnterpriseController.sameNameQueue.length == 0) {
        MMEnterpriseController.sameNameQueue = null;
        return;
      }
      var data = MMEnterpriseController.sameNameQueue.shift();
      var curQequest = function curQequest(data) {
        $.ajax({
          url: "/file/hasSameNameInFolder.do",
          method: "post",
          data: {
            folderId: data.params.folderId,
            fileName: data.params.fileName,
            fileSize: data.params.fileSize
          },
          success: function success(responseData, textStatus, jaXHR) {
            callServer();
            console.warn(responseData);
            if (responseData.success) {
              var file = null;
              if (responseData["fileInfo"]) {
                file = new _MMFileInfo["default"](responseData["fileInfo"]);
                if (responseData.canUploadVersion) {
                  file.set("actions", 2049);
                  // file.set("type", 1)
                  file.set("parentId", params.folderId);
                }
              }
              _.isFunction(data.successCB) && data.successCB(file);
            } else {
              if (responseData["code"] == 853 && responseData.options && responseData.options.noPassFiles) {
                MMEnterpriseController.checkFilesSequentially(responseData.options.noPassFiles, function () {
                  curQequest(data);
                }, function () {
                  _MDLoadMaskView["default"].remove();
                  // _.isFunction(data.failCb) && data.failCb(responseData);
                });
              } else {
                _.isFunction(data.failCb) && data.failCb(responseData);
              }
            }
          },
          fail: function fail(res) {
            callServer();
            _.isFunction(data.failCb) && data.failCb(res);
          }
        });
      };
      curQequest(data);
    };
    var data = {
      params: params,
      successCB: successCB,
      failCb: failCb
    };
    // 排队，一条条执行，禁止直接发往服务器
    if (!MMEnterpriseController.sameNameQueue) {
      MMEnterpriseController.sameNameQueue = [data];
      callServer();
    } else {
      MMEnterpriseController.sameNameQueue.push(data);
    }
  },
  hasSameNameInFolderRequest: function hasSameNameInFolderRequest(params, successCB, failCb) {
    var _this = this;
    $.ajax({
      url: "/file/hasSameNameInFolder.do",
      method: "post",
      data: {
        folderId: params.folderId,
        fileName: params.fileName,
        fileSize: params.fileSize
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          var file = null;
          if (responseData["fileInfo"]) {
            file = new _MMFileInfo["default"](responseData["fileInfo"]);
            if (responseData.canUploadVersion) {
              file.set("actions", 2049);
              // file.set("type", 1)
              file.set("parentId", params.folderId);
            }
          }
          _.isFunction(successCB) && successCB(file);
        } else {
          if (responseData["code"] == 853 && responseData.options && responseData.options.noPassFiles) {
            MMEnterpriseController.checkFilesSequentially(responseData.options.noPassFiles, function () {
              _this.hasSameNameInFolderRequest(params, successCB, failCb);
            }, function () {
              _MDLoadMaskView["default"].remove();
              // _.isFunction(data.failCb) && data.failCb(responseData);
            });
          } else {
            if (responseData["code"] == 226) {
              responseData["msg"] = BabelStr.str(11351);
            }
            _.isFunction(failCb) && failCb(responseData);
          }
        }
        // callServer();
      },
      fail: function fail(res) {
        _.isFunction(data.failCb) && data.failCb(res);
        // callServer();
      }
    });
  },
  getMyTeamFolders: function getMyTeamFolders(parentId, orderName, isAsc, page, pageSize, success, fail, params) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.getMyDepartmentFolders", {}, function (res) {
      if (res["resultCode"] === 0) {
        _.map(res["list"], function (fileinfo) {
          _.each(res["projects"], function (project) {
            if (fileinfo.fileId === project.folderId) {
              fileinfo.projectInfo = project;
            }
          });
        });
        var out = new _MMFileInfoCollection["default"](res["list"]);
        // self.setDataCollection(res["list"]);
        success(out);
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  getQuickSendInfo: function getQuickSendInfo(sendId, success, fail) {
    MMEnterpriseController.request("netDrive.shareHandler.getQuickSendInfo", {
      sendId: sendId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res.qsInfo, res.quickSendFiles, res.senderInfo, res.receivers);
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  quickSendReview: function quickSendReview(quickSendId, result, success, fail) {
    MMEnterpriseController.request("netDrive.shareHandler.quickSendReview", {
      quickSendId: quickSendId,
      result: result
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"], res["message"], res);
      }
    });
  },
  setDefaultSortIndex: function setDefaultSortIndex(defaultSortIndex, success, fail) {
    MMEnterpriseController.request("netDrive.fileExHandler.setDefaultSortIndex", {
      defaultSortIndex: defaultSortIndex
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["message"]);
      }
    });
  },
  getShareSecretReview: function getShareSecretReview(shareId, success, fail) {
    MMEnterpriseController.request("netDrive.shareHandler.getShareSecretReview", {
      shareId: shareId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["shareInfos"]);
      } else {
        fail(res["message"]);
      }
    });
  },
  setShareSecretReview: function setShareSecretReview(shareId, reviewResult, success, fail, params) {
    MMEnterpriseController.request("netDrive.shareHandler.setShareSecretReview", {
      shareId: shareId,
      reviewResult: reviewResult,
      force: params && params.force
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res);
      } else {
        fail(res["resultCode"], res["message"], res);
      }
    });
  },
  getProjectMemberReivew: function getProjectMemberReivew(memberId, success, fail) {
    MMEnterpriseController.request("netDrive.fileExHandler.getProjectMemberReivew", {
      memberId: memberId
    }, function (res) {
      console.log(res);
      if (res["resultCode"] === 0) {
        success(res["reviewInfo"]);
      } else {
        fail(res["message"]);
      }
    });
  },
  setProjectMemberReivew: function setProjectMemberReivew(memberId, reviewResult, success, fail, params) {
    MMEnterpriseController.request("netDrive.fileExHandler.setProjectMemberReivew", {
      memberId: memberId,
      reviewResult: reviewResult,
      force: params && params.force
    }, function (res) {
      console.log(res);
      if (res["resultCode"] === 0) {
        success(res);
      } else {
        fail(res["resultCode"], res["message"], res);
      }
    });
  },
  getAllIpStrategyNames: function getAllIpStrategyNames(success, fail) {
    MMEnterpriseController.request("netDrive.fileExHandler.getAllIpStrategyNames", {}, function (res) {
      console.log(res);
      if (res["resultCode"] === 0) {
        success(res["strategyNames"]);
      } else {
        fail(res["resultCode"], res["message"], res);
      }
    });
  },
  getAllDepStrategies: function getAllDepStrategies(success, fail) {
    MMEnterpriseController.request("netDrive.fileExHandler.getAllDepStrategies", {}, function (res) {
      console.log(res);
      if (res["resultCode"] === 0) {
        success(res["allInfo"]);
      } else {
        fail(res["resultCode"], res["message"], res);
      }
    });
  },
  createIpStrategy: function createIpStrategy(strategyName, ipConfigs, success, fail) {
    MMEnterpriseController.request("netDrive.fileExHandler.createIpStrategy", {
      strategyName: strategyName,
      ipConfigs: ipConfigs
    }, function (res) {
      console.log(res);
      if (res["resultCode"] === 0) {
        var strategyInfo = res["strategyInfo"] || {};
        var strategyId = strategyInfo.strategyId + "";
        success(strategyId);
      } else {
        fail(res["resultCode"], res["message"], res);
      }
    });
  },
  updateDepStrategy: function updateDepStrategy(id, depId, strategyId, success, fail) {
    MMEnterpriseController.request("netDrive.fileExHandler.updateDepStrategy", {
      id: id,
      depId: depId,
      strategyId: strategyId
    }, function (res) {
      console.log(res);
      if (res["resultCode"] === 0) {
        success(res[""]);
      } else {
        fail(res["resultCode"], res["message"], res);
      }
    });
  },
  addDepStrategy: function addDepStrategy(depId, strategyId, success, fail) {
    MMEnterpriseController.request("netDrive.fileExHandler.addDepStrategy", {
      depId: depId,
      strategyId: strategyId
    }, function (res) {
      console.log(res);
      if (res["resultCode"] === 0) {
        success(res["id"]);
      } else {
        fail(res["resultCode"], res["message"], res);
      }
    });
  },
  removeDepStrategy: function removeDepStrategy(id, success, fail) {
    MMEnterpriseController.request("netDrive.fileExHandler.removeDepStrategy", {
      id: id
    }, function (res) {
      console.log(res);
      if (res["resultCode"] === 0) {
        success(res["id"]);
      } else {
        fail(res["resultCode"], res["message"], res);
      }
    });
  },
  removeIpStrategy: function removeIpStrategy(id, success, fail) {
    MMEnterpriseController.request("netDrive.fileExHandler.removeIpStrategy", {
      strategyId: id
    }, function (res) {
      console.log(res);
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"], res["message"], res);
      }
    });
  },
  getIpStrategyInfo: function getIpStrategyInfo(id, success, fail) {
    MMEnterpriseController.request("netDrive.fileExHandler.getIpStrategyInfo", {
      strategyId: id
    }, function (res) {
      console.log(res);
      if (res["resultCode"] === 0) {
        var strategyInfo = res["strategyInfo"];
        success(strategyInfo["ipConfigs"], strategyInfo["strategyInfo"][0]);
      } else {
        fail(res["resultCode"], res["message"], res);
      }
    });
  },
  updateIpStrategy: function updateIpStrategy(id, strategyName, ipAdd, ipRemove, ipUpdate, success, fail) {
    MMEnterpriseController.request("netDrive.fileExHandler.updateIpStrategy", {
      strategyId: id,
      strategyName: strategyName,
      ipAdd: ipAdd,
      ipRemove: ipRemove,
      ipUpdate: ipUpdate
    }, function (res) {
      console.log(res);
      if (res["resultCode"] === 0) {
        var strategyInfo = res["strategyInfo"];
        success();
      } else {
        fail(res["resultCode"], res["message"], res);
      }
    });
  },
  setVersionRetainInfo: function setVersionRetainInfo(versionRetainTime, versionRetainNum, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.setVersionRetainInfo", {
      versionRetainTime: versionRetainTime,
      versionRetainNum: versionRetainNum
    }, function (res) {
      console.log(res);
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"], res["message"], res);
      }
    });
  },
  sendFilePersonal: function sendFilePersonal(receivers, fileIds, success, fail) {
    MMEnterpriseController.request("netDrive.shareHandler.sendFilePersonal", {
      receivers: receivers,
      fileIds: fileIds
    }, function (res) {
      console.log(res);
      if (res["resultCode"] === 0) {
        success(res.result);
      } else {
        if (res["resultCode"] == 853 && res.options && res.options.noPassFiles) {
          MMEnterpriseController.checkFilesSequentially(res.options.noPassFiles, function () {
            MMEnterpriseController.sendFilePersonal(receivers, fileIds, success, fail);
          }, function () {
            _.isFunction(fail) && fail(res["resultCode"], BabelStr.str(27029), res);
          });
        } else {
          fail(res["resultCode"], res["message"], res);
        }
      }
    });
  },
  getFilesOfSendPersonalById: function getFilesOfSendPersonalById(sendId, success, fail) {
    MMEnterpriseController.request("netDrive.shareHandler.getFilesOfSendPersonalById", {
      sendId: sendId
    }, function (res) {
      console.log(res);
      if (res["resultCode"] === 0) {
        success(res["result"], res['receivers'], res['reviewResult']);
      } else {
        fail(res["resultCode"], res["message"], res);
      }
    });
  },
  emptyMyTrashStepByStep: function emptyMyTrashStepByStep(firstCall, success, fail) {
    MMEnterpriseController.request("netDrive.fileHandler.emptyMyTrashStepByStep", {
      firstCall: firstCall ? true : false
    }, function (res) {
      console.log(res);
      if (res["resultCode"] === 0) {
        success(res["finished"], res["deleted"]);
      } else {
        fail(res["resultCode"], res["message"], res);
      }
    });
  },
  emptyEntOtherDeletedFilesStepByStep: function emptyEntOtherDeletedFilesStepByStep(firstCall, success, fail) {
    MMEnterpriseController.request("netDrive.fileHandler.emptyEntOtherDeletedFilesStepByStep", {
      firstCall: firstCall ? true : false
    }, function (res) {
      console.log(res);
      if (res["resultCode"] === 0) {
        success(res["finished"], res["deleted"]);
      } else {
        fail(res["resultCode"], res["message"], res);
      }
    });
  },
  emptyStdEditionOtherDeletedFilesStepByStep: function emptyStdEditionOtherDeletedFilesStepByStep(firstCall, success, fail) {
    MMEnterpriseController.request("netDrive.fileHandler.emptyStdEditionOtherDeletedFilesStepByStep", {
      firstCall: firstCall ? true : false
    }, function (res) {
      console.log(res);
      if (res["resultCode"] === 0) {
        success(res["finished"], res["deleted"]);
      } else {
        fail(res["resultCode"], res["message"], res);
      }
    });
  },
  emptyTrashStepByStep: function emptyTrashStepByStep(firstCall, success, fail) {
    MMEnterpriseController.request("netDrive.fileHandler.emptyTrashStepByStep", {
      firstCall: firstCall ? true : false
    }, function (res) {
      console.log(res);
      if (res["resultCode"] === 0) {
        success(res["finished"], res["deleted"]);
      } else {
        fail(res["resultCode"], res["message"], res);
      }
    });
  },
  emptyEntTrashStepByStep: function emptyEntTrashStepByStep(firstCall, success, fail) {
    MMEnterpriseController.request("netDrive.fileHandler.emptyEntTrashStepByStep", {
      firstCall: firstCall ? true : false
    }, function (res) {
      console.log(res);
      if (res["resultCode"] === 0) {
        success(res["finished"], res["deleted"]);
      } else {
        fail(res["resultCode"], res["message"], res);
      }
    });
  },
  getReceiveFileList: function getReceiveFileList(sendId, receiveToken, _success, fail) {
    $.ajax({
      method: "post",
      url: "/netdrive/getReceiveFileList.do",
      data: {
        sendId: sendId,
        t: receiveToken
      },
      success: function success(responseData, textStatus, jqXHR) {
        console.warn(responseData);
        if (responseData["success"] === true) {
          _.isFunction(_success) && _success(responseData["files"]);
        } else {
          fail(responseData);
        }
      }
    });
  },
  reportIllegalShare: function reportIllegalShare(_success2, fail) {
    $.ajax({
      method: "post",
      url: "/reportIllegalShare.do",
      success: function success(responseData, textStatus, jqXHR) {
        console.warn(responseData);
        if (responseData["success"] === true) {
          _.isFunction(_success2) && _success2();
        } else {
          fail(responseData);
        }
      }
    });
  },
  getGroupInfoById: function getGroupInfoById(groupId, success, fail) {
    MMEnterpriseController.request("netDrive.fileExHandler.getGroupInfoById", {
      groupId: groupId
    }, function (res) {
      console.log(res);
      if (res["resultCode"] === 0) {
        success(res["groupInfo"]);
      } else {
        fail(res["resultCode"], res["message"], res);
      }
    });
  },
  getTransmittalProjectMemberReivew: function getTransmittalProjectMemberReivew(memberId, success, fail) {
    MMEnterpriseController.request("netDrive.fileExHandler.getTransmittalProjectMemberReivew", {
      memberId: memberId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["reviewInfo"]);
      } else {
        fail(res["message"]);
      }
    });
  },
  setTransmittalProjectMemberReivew: function setTransmittalProjectMemberReivew(memberId, reviewResult, success, fail, params) {
    MMEnterpriseController.request("netDrive.fileExHandler.setTransmittalProjectMemberReivew", {
      memberId: memberId,
      reviewResult: reviewResult,
      force: params && params.force
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res);
      } else {
        fail(res["resultCode"], res["message"], res);
      }
    });
  },
  createSnapshotLinkShare: function createSnapshotLinkShare(fid, linkRoleId, success, fail, params) {
    MMEnterpriseController.request("netDrive.shareHandler.createSnapshotLinkShare", {
      fid: fid,
      linkRoleId: linkRoleId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res);
      } else {
        fail(res["resultCode"], res["message"], res);
      }
    });
  },
  getAllSnapshotLinkShares: function getAllSnapshotLinkShares(fid, success, fail, params) {
    MMEnterpriseController.request("netDrive.shareHandler.getAllSnapshotLinkShares", {
      fid: fid
    }, function (res) {
      if (res["resultCode"] === 0) {
        if (_app["default"].ep.isPrivateCloud()) {
          _.each(res["shareInfos"], function (item) {
            item.shareUrl = location.origin + item["shareUrl"];
          });
        }
        res.shareInfos.sort(function (pre, next) {
          return new Date(pre).getTime() > new Date(next).getTime() ? 1 : -1;
        });
        var out = new _MMFileInfoCollection["default"](res["shareInfos"]);
        success(out);
      } else {
        fail(res["resultCode"], res["message"], res);
      }
    });
  },
  getRolesForSnapshotFile: function getRolesForSnapshotFile(fid, success, fail, params) {
    MMEnterpriseController.request("netDrive.shareHandler.getRolesForSnapshotFile", {
      fileId: fid
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res.list, res.defaultRole);
      } else {
        fail(res["resultCode"], res["message"], res);
      }
    });
  },
  setShareWithinEnt: function setShareWithinEnt(fileId, withinEnt, success, fail) {
    var route = "netDrive.shareHandler.setShareWithinEnt";
    MMEnterpriseController.request(route, {
      fileId: fileId,
      withinEnt: withinEnt
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail();
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  updateSnapshotShareOption: function updateSnapshotShareOption(params, success, fail) {
    MMEnterpriseController.request("netDrive.shareHandler.updateSnapshotShareOption", {
      snapshotId: params.snapshotId,
      linkRoleId: params.linkRoleId,
      anonymousVisit: params.anonymousVisit,
      expireTime: params.expireTime,
      password: params.password,
      sendAccessInfo: params.sendAccessInfo
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res.list, res.defaultRole);
      } else {
        fail(res["resultCode"], res["message"], res);
      }
    });
  },
  removeSnapshotLinkShare: function removeSnapshotLinkShare(snapshotId, success, fail) {
    MMEnterpriseController.request("netDrive.shareHandler.removeSnapshotLinkShare", {
      snapshotId: snapshotId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res.list, res.defaultRole);
      } else {
        fail(res["resultCode"], res["message"], res);
      }
    });
  },
  setDownloadSpeedForUsers: function setDownloadSpeedForUsers(userIds, speed, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.setDownloadSpeedForUsers", {
      userIds: userIds,
      speed: speed
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"], res["message"], res);
      }
    });
  },
  countUserUploadFileInEnterprise: function countUserUploadFileInEnterprise(param, success, fail) {
    MMEnterpriseController.request("netDrive.statisHandler.countUserUploadFileInEnterprise", {
      committerId: param.userId,
      pageIndex: param.curPageIndex,
      pageSize: param.pageSize
    }, function (res) {
      if (res["resultCode"] !== 0) {
        _.isFunction(fail) && fail(res["resultCode"], res["message"], res);
      } else {
        var fileCollection = new _MMFileInfoCollection["default"]();
        _.each(res["files"], function (file) {
          if (file.owner == param.userId) {
            file.isPrivateFile = true;
          }
          file.idUsedFileIdAndVersion = true;
          file.fileId = file.fileId + "--" + file.version;
          file.parentId = file.parent;
          file = new _MMFileInfo["default"](file);
          fileCollection.add(file);
        });
        _.isFunction(success) && success(fileCollection, res["count"]);
      }
    });
  },
  getUsersAllOrganizations: function getUsersAllOrganizations(param, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.getUsersAllOrganizations", {
      userId: param.userId,
      page: param.curPageIndex,
      pageSize: param.pageSize,
      orderBy: "fileName",
      isAsc: true,
      organizeType: param.organizeType // 0 - 分享， 1 - 项目或团队
    }, function (res) {
      if (res["resultCode"] !== 0) {
        _.isFunction(fail) && fail(res["resultCode"], res["message"], res);
      } else {
        var out = MMEnterpriseController.listFilesByPagesCallback(res, false);
        _.isFunction(success) && success(out, res["total"]);
      }
    });
  },
  listUserAppendPermissions: function listUserAppendPermissions(param, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.listUserAppendPermissions", {
      userId: param.userId,
      page: param.curPageIndex,
      pageSize: param.pageSize,
      orderBy: "fileName",
      isAsc: true
    }, function (res) {
      if (res["resultCode"] !== 0) {
        _.isFunction(fail) && fail(res["resultCode"], res["message"], res);
      } else {
        var out = MMEnterpriseController.listFilesByPagesCallback(res, false);
        _.isFunction(success) && success(out, res["total"]);
      }
    });
  },
  getContactList: function getContactList(success, fail) {
    var route = "netDrive.fileHandler.getContactList";
    MMEnterpriseController.request(route, {}, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail();
      } else {
        var out = [];
        _.each(res["contactList"], function (obj) {
          obj["userId"] = obj["id"];
          out.push(obj);
        });
        if (_.isFunction(success)) success(out);
      }
    });
  },
  getUploadStatus: function getUploadStatus(fileHash, sid, folderId, successCB, failCb) {
    $.ajax({
      url: "/file/getUploadStatus.do",
      method: "post",
      data: {
        fileHash: fileHash,
        sid: sid,
        folderId: folderId
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  getDepartmentTemplateFolderId: function getDepartmentTemplateFolderId(departmentId, success, fail) {
    var route = "netDrive.enterpriseHandler.getDepartmentTemplateFolderId";
    MMEnterpriseController.request(route, {
      departmentId: departmentId
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail();
      } else {
        if (_.isFunction(success)) success(res["folderId"]);
      }
    });
  },
  getAllTemplateFilesByDepId: function getAllTemplateFilesByDepId(departmentId, success, fail) {
    var route = "netDrive.enterpriseHandler.getAllTemplateFilesByDepId";
    MMEnterpriseController.request(route, {
      departmentId: departmentId
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res);
      } else {
        var out = new _MMFileInfoCollection["default"](res["fileInfos"]);
        if (_.isFunction(success)) success(out);
      }
    });
  },
  clearUserAllOrgnizationPermission: function clearUserAllOrgnizationPermission(userId, success, fail) {
    var route = "netDrive.enterpriseHandler.clearUserAllOrgnizationPermission";
    MMEnterpriseController.request(route, {
      userId: userId
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  copyFromTemplate: function copyFromTemplate(templateFileIds, folderId, newName, success, fail) {
    var route = "netDrive.enterpriseHandler.copyFromTemplate";
    MMEnterpriseController.request(route, {
      templateFileIds: templateFileIds,
      folderId: folderId,
      newName: newName
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success(res["newFileIds"], res["result"]);
      }
    });
  },
  setEnterprisePersonalSpaceLimit: function setEnterprisePersonalSpaceLimit(spaceLimit, success, fail) {
    var route = "netDrive.enterpriseHandler.setEnterprisePersonalSpaceLimit";
    MMEnterpriseController.request(route, {
      spaceLimit: spaceLimit
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success(res["illegalCount"]);
      }
    });
  },
  setEnterpriseMemberSpaceLimit: function setEnterpriseMemberSpaceLimit(spaceLimit, success, fail) {
    var route = "netDrive.enterpriseHandler.setEnterpriseMemberSpaceLimit";
    MMEnterpriseController.request(route, {
      spaceLimit: spaceLimit
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  getAllEnterpriseMonitorType: function getAllEnterpriseMonitorType(success, fail) {
    var route = "netDrive.enterpriseHandler.getAllEnterpriseMonitorType";
    MMEnterpriseController.request(route, {}, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        var lan = BabelStr.getCurrentLanguage();
        if (res["enterpriseMonitor"] && lan == "en") {
          _.each(res["enterpriseMonitor"], function (item) {
            item.name = item.nameEn;
          });
        }
        var out = new _MMNormalCollection["default"](res["enterpriseMonitor"]);
        if (_.isFunction(success)) success(out);
      }
    });
  },
  allAllMonitorType: function allAllMonitorType(success, fail) {
    var route = "netDrive.enterpriseHandler.allAllMonitorType";
    MMEnterpriseController.request(route, {}, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        var lan = BabelStr.getCurrentLanguage();
        if (res["types"] && lan == "en") {
          _.each(res["types"], function (item) {
            item.name = item.nameEn;
          });
        }
        if (_.isFunction(success)) success(res["types"]);
      }
    });
  },
  addEnterpriseMonitorType: function addEnterpriseMonitorType(monitorType, threshhold, success, fail) {
    var route = "netDrive.enterpriseHandler.addEnterpriseMonitorType";
    MMEnterpriseController.request(route, {
      monitorType: monitorType,
      threshhold: threshhold
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        var out = new _MMNormalCollection["default"](res["types"]);
        if (_.isFunction(success)) success(out);
      }
    });
  },
  removeEnterpriseMonitorType: function removeEnterpriseMonitorType(monitorType, success, fail) {
    var route = "netDrive.enterpriseHandler.removeEnterpriseMonitorType";
    MMEnterpriseController.request(route, {
      monitorType: monitorType
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  addFileRecentAccessUser: function addFileRecentAccessUser(fileId, success, fail) {
    var route = "netDrive.fileHandler.addFileRecentAccessUser";
    MMEnterpriseController.request(route, {
      fileId: fileId
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  recordPrintAction: function recordPrintAction(fileId, success, fail) {
    var route = "netDrive.fileHandler.recordPrintAction";
    MMEnterpriseController.request(route, {
      fileId: fileId
    }, function (res) {
      console.dir(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  getSidebarShortcutMenu: function getSidebarShortcutMenu(success, fail) {
    var route = "netDrive.userHandler.getSidebarShortcutMenu";
    MMEnterpriseController.request(route, {}, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(success)) success([], []);
        // if (_.isFunction(fail)) fail(res['resultCode'], res['message']);
      } else {
        if (_.isFunction(success)) success(res["menuIds"], res["folderInfos"]);
      }
    });
  },
  updateSendPort: function updateSendPort(id, identifier, receiverPortIdentifier, token, comment, url, success, fail) {
    var route = "netDrive.dispatchFileHandler.updateSendPort";
    MMEnterpriseController.request(route, {
      id: id,
      identifier: identifier,
      receiverPortIdentifier: receiverPortIdentifier,
      token: token,
      url: url,
      comment: comment
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  deleteSendPort: function deleteSendPort(id, success, fail) {
    var route = "netDrive.dispatchFileHandler.deleteSendPort";
    MMEnterpriseController.request(route, {
      id: id
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  commitFileToPort: function commitFileToPort(portId, fileIds, comment, success, fail) {
    var route = "netDrive.dispatchFileHandler.commitFileToPort";
    MMEnterpriseController.request(route, {
      portId: portId,
      fileIds: fileIds,
      comment: comment,
      userId: _app["default"].currentUser.getUserId()
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        var out = new _MMNormalCollection["default"](res["sendPorts"]);
        if (_.isFunction(success)) success(out);
      }
    });
  },
  getSendPort: function getSendPort(success, fail) {
    var route = "netDrive.dispatchFileHandler.getSendPort";
    MMEnterpriseController.request(route, {}, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        // let out = new MMNormalCollection()
        var out = new _MMNormalCollection["default"](res["sendPorts"]);
        if (_.isFunction(success)) success(out);
      }
    });
  },
  markResendFile: function markResendFile(dispatchId, success, fail) {
    var route = "netDrive.dispatchFileHandler.markResendFile";
    MMEnterpriseController.request(route, {
      dispatchId: dispatchId
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        var out = new _MMNormalCollection["default"](res["sendPorts"]);
        if (_.isFunction(success)) success(out);
      }
    });
  },
  addSendPort: function addSendPort(identifier, receiverPortIdentifier, token, comment, url, success, fail) {
    var route = "netDrive.dispatchFileHandler.addSendPort";
    MMEnterpriseController.request(route, {
      identifier: identifier,
      receiverPortIdentifier: receiverPortIdentifier,
      comment: comment,
      token: token,
      url: url
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  deleteSendPortUser: function deleteSendPortUser(options, success, fail) {
    var route = "netDrive.dispatchFileHandler.deleteSendPortUser";
    MMEnterpriseController.request(route, {
      portId: options.portId,
      userIds: options.userIds,
      departmentIds: options.departmentIds
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  getSendPortUser: function getSendPortUser(portId, success, fail) {
    var route = "netDrive.dispatchFileHandler.getSendPortUser";
    MMEnterpriseController.request(route, {
      portId: portId
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        _.each(res["departments"], function (item) {
          item.userType = 1;
        });
        if (_.isFunction(success)) success(new _MDMolaUserCollection["default"](res["departments"]), new _MDMolaUserCollection["default"](res["users"]));
      }
    });
  },
  addSendPortUser: function addSendPortUser(options, success, fail) {
    var route = "netDrive.dispatchFileHandler.addSendPortUser";
    MMEnterpriseController.request(route, {
      portId: options.portId,
      userIds: options.userIds,
      departmentIds: options.departmentIds
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  deleteReceivePortUser: function deleteReceivePortUser(options, success, fail) {
    var route = "netDrive.dispatchFileHandler.deleteReceivePortUser";
    MMEnterpriseController.request(route, {
      portId: options.portId,
      userIds: options.userIds,
      departmentIds: options.departmentIds
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  getReceivePortUser: function getReceivePortUser(portId, success, fail) {
    var route = "netDrive.dispatchFileHandler.getReceivePortUser";
    MMEnterpriseController.request(route, {
      portId: portId
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        _.each(res["departments"], function (item) {
          item.userType = 1;
        });
        if (_.isFunction(success)) success(new _MDMolaUserCollection["default"](res["departments"]), new _MDMolaUserCollection["default"](res["users"]));
      }
    });
  },
  addReceivePortUser: function addReceivePortUser(options, success, fail) {
    var route = "netDrive.dispatchFileHandler.addReceivePortUser";
    MMEnterpriseController.request(route, {
      portId: options.portId,
      userIds: options.userIds,
      departmentIds: options.departmentIds
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  getReceivePort: function getReceivePort(success, fail) {
    var route = "netDrive.dispatchFileHandler.getReceivePort";
    MMEnterpriseController.request(route, {}, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        // let out = new MMNormalCollection()
        var out = new _MMNormalCollection["default"](res["receivePorts"]);
        if (_.isFunction(success)) success(out);
      }
    });
  },
  isIdentifierValid: function isIdentifierValid(identifier, success, fail) {
    var route = "netDrive.dispatchFileHandler.isIdentifierValid";
    MMEnterpriseController.request(route, {
      identifier: identifier
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success(res["valid"]);
      }
    });
  },
  createReceivePort: function createReceivePort(identifier, comment, success, fail) {
    var route = "netDrive.dispatchFileHandler.createReceivePort";
    MMEnterpriseController.request(route, {
      identifier: identifier,
      comment: comment
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  deleteReceivePort: function deleteReceivePort(id, success, fail) {
    var route = "netDrive.dispatchFileHandler.deleteReceivePort";
    MMEnterpriseController.request(route, {
      id: id
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  updateReceivePort: function updateReceivePort(id, identifier, comment, success, fail) {
    var route = "netDrive.dispatchFileHandler.updateReceivePort";
    MMEnterpriseController.request(route, {
      id: id,
      identifier: identifier,
      comment: comment
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  getReceiverFileInfosByIds: function getReceiverFileInfosByIds(receiveIds, success, fail) {
    var route = "netDrive.dispatchFileHandler.getReceiverFileInfosByIds";
    MMEnterpriseController.request(route, {
      receiveIds: receiveIds
    }, function (res) {
      console.log(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success(res["receiveFileInfo"], res["userInfos"]);
      }
    });
  },
  getDispatchInfosByIds: function getDispatchInfosByIds(dispatchIds, success, fail) {
    var route = "netDrive.dispatchFileHandler.getDispatchInfosByIds";
    MMEnterpriseController.request(route, {
      dispatchIds: dispatchIds
    }, function (res) {
      console.log(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success(res["dispatchInfos"], res["userInfos"]);
      }
    });
  },
  saveSidebarShortcutMenu: function saveSidebarShortcutMenu(menuIds, success, fail) {
    var route = "netDrive.userHandler.saveSidebarShortcutMenu";
    MMEnterpriseController.request(route, {
      menuIds: menuIds
    }, function (res) {
      console.log(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  reviewReceiveFromPort: function reviewReceiveFromPort(receiveId, reviewResult, success, fail) {
    var route = "netDrive.dispatchFileHandler.reviewReceiveFromPort";
    MMEnterpriseController.request(route, {
      receiveId: receiveId,
      reviewResult: reviewResult
    }, function (res) {
      console.log(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  canMagageDepMember: function canMagageDepMember(depId, success, fail) {
    var route = "netDrive.enterpriseHandler.canMagageDepMember";
    MMEnterpriseController.request(route, {
      depId: depId
    }, function (res) {
      console.log(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success(res["can"]);
      }
    });
  },
  getMetaData: function getMetaData(fileId, ver, success, fail) {
    var route = "netDrive.fileHandler.getMetaData";
    MMEnterpriseController.request(route, {
      fileId: fileId,
      ver: ver
    }, function (res) {
      console.log(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success(res["metaData"]);
      }
    });
  },
  getMetaDatas: function getMetaDatas(fileIds, success, fail) {
    if (!fileIds.length) {
      if (_.isFunction(success)) success();
    }
    var route = "netDrive.fileHandler.getMetaDatas";
    MMEnterpriseController.request(route, {
      fileIds: fileIds
    }, function (res) {
      console.log(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(success)) success(res["metaDatas"]);
      } else {
        if (res["metaDatas"].length && window.BMapGL) {
          MMEnterpriseController.getMaybePositionByLaLo(window, res["metaDatas"]).then(function (positionDatas) {
            // 批量处理完地址逆解析后进行业务逻辑处理
            if (_.isFunction(success)) success(res["metaDatas"]);
          });
        } else {
          if (_.isFunction(success)) success(res["metaDatas"]);
        }
      }
    });
  },
  getUserPermissionListForFile: function getUserPermissionListForFile(fileId, searchKey, startIndex, pageSize, success, fail) {
    var route = "netDrive.fileHandler.getUserPermissionListForFile";
    MMEnterpriseController.request(route, {
      fileId: fileId,
      searchKey: searchKey,
      startIndex: startIndex,
      pageSize: pageSize
    }, function (res) {
      console.log(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success(res["permissionList"]);
      }
    });
  },
  isOnlyUseCustomShareRole: function isOnlyUseCustomShareRole(success, fail) {
    var route = "netDrive.enterpriseHandler.isOnlyUseCustomShareRole";
    MMEnterpriseController.request(route, {}, function (res) {
      console.log(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success(res["onlyUseCustom"]);
      }
    });
  },
  getMaybePositionByLaLo: function getMaybePositionByLaLo(window, metaDatas) {
    // 定义一个Promise数组，来将异步操作放进来
    var apiDatas = [];
    metaDatas.forEach(function (gpsItem) {
      if (gpsItem && gpsItem.meta_data && gpsItem.meta_data.lat) {
        var apiItem = MMEnterpriseController.getMapInfo(window, gpsItem);
        apiDatas.push(apiItem);
      }
    });
    // 这里.all会将所有的异步操作一起放在队列中，等待所有异步执行完毕后才会执行.then，这就保证了我们的同步获取数据
    return Promise.all(apiDatas).then(function (gpsData) {
      return gpsData;
    });
  },
  getMapInfo: function getMapInfo(window, gpsItem) {
    var meta_data = gpsItem.meta_data;
    return new Promise(function (resolve, reject) {
      // 创建地理编码实例
      var geoc = new window.BMapGL.Geocoder();
      // 根据坐标得到地址描述
      geoc.getLocation(new window.BMapGL.Point(meta_data.lon, meta_data.lat), function (result) {
        if (result && result.address) {
          var address = result.addressComponents;
          var out = address.province;
          out += address.city == address.province ? "" : address.city;
          out += address.district == address.city ? "" : address.district;
          gpsItem.maybePosition = out;
          resolve(gpsItem);
        }
      });
    });
  },
  reviewDispatchFile: function reviewDispatchFile(dispatchId, reviewResult, successCB, failCb) {
    $.ajax({
      url: "/enterprise/reviewDispatchFile.do",
      method: "post",
      data: {
        dispatchId: dispatchId,
        reviewResult: reviewResult
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB();
        } else {
          _.isFunction(failCb) && failCb(responseData["code"], responseData["msg"]);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  setEntSessionValidTime: function setEntSessionValidTime(validSessionTime, successCB, failCb) {
    $.ajax({
      url: "/enterprise/setEntSessionValidTime.do",
      method: "post",
      data: {
        validSessionTime: validSessionTime
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB();
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  getEntSessionValidTime: function getEntSessionValidTime(successCB, failCb) {
    $.ajax({
      url: "/enterprise/getEntSessionValidTime.do",
      method: "post",
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData.validSessionTime);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  getAllEnterpriseInfo: function getAllEnterpriseInfo(successCB, failCb) {
    $.ajax({
      url: "/enterprise/getAllEnterpriseInfo.do",
      method: "post",
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData.list);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  setEnterpriseMaxMemberCount: function setEnterpriseMaxMemberCount(domain, maxMemberCount, successCB, failCb) {
    $.ajax({
      url: "enterprise/setEnterpriseMaxMemberCount.do",
      method: "post",
      data: {
        domain: domain,
        maxMemberCount: maxMemberCount
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData.list);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  setEnterpriseEndTime: function setEnterpriseEndTime(domain, endTime, successCB, failCb) {
    $.ajax({
      url: "/enterprise/setEnterpriseEndTime.do",
      method: "post",
      data: {
        domain: domain,
        endTime: endTime
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData.list);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  updateEnterpriseSpace: function updateEnterpriseSpace(domain, capacity, successCB, failCb) {
    $.ajax({
      url: "enterprise/updateEnterpriseSpace.do",
      method: "post",
      data: {
        domain: domain,
        capacity: capacity
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData.list);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  dissolveEnterpriseForAdmin: function dissolveEnterpriseForAdmin(id, successCB, failCb) {
    $.ajax({
      url: " /enterprise/dissolveEnterprise.do?userEnterpriseId=".concat(id),
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB();
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  countFileInEnterprise: function countFileInEnterprise(userEnterpriseId, successCB, failCb) {
    $.ajax({
      url: " enterprise/countFileInEnterprise.do",
      method: "post",
      data: {
        userEnterpriseId: userEnterpriseId
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData.result);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  isIpAllowUpload: function isIpAllowUpload(fileId, successCB, failCb) {
    if (fileId == 0) {
      successCB();
      return;
    }
    $.ajax({
      url: " /file/isIpAllowUpload.do?fileId=".concat(fileId),
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData.result);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  isIpAllowDownload: function isIpAllowDownload(fileId, successCB, failCb) {
    if (fileId == 0) {
      successCB();
      return;
    }
    $.ajax({
      url: " /file/isIpAllowDownload.do?fileId=".concat(fileId),
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData.result);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  getEditOnlineFile: function getEditOnlineFile(fileId, successCB, failCb) {
    $.ajax({
      url: " /netdrive/getEditOnlineFile.do",
      method: "post",
      data: {
        fileId: fileId,
        token: MMCommonFun.encrptFileId(fileId)
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData.url);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  getSessionInfos: function getSessionInfos(successCB, failCb) {
    $.ajax({
      url: "/babelmanager/getSessionInfos.do",
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          var out = new _MASessionCollection["default"](responseData.sessionInfos);
          _.isFunction(successCB) && successCB(out, responseData.tomcatPath);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  canFreeUseOnlyOffice: function canFreeUseOnlyOffice(fileIds, successCB, failCb) {
    $.ajax({
      url: "/netdrive/canUseOnlyOffice.do",
      data: {
        fileIds: fileIds
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData.result);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  readFileConvertStatus: function readFileConvertStatus(fileId, version, successCB, failCb) {
    $.ajax({
      url: "/netdrive/readFileConvertStatus.do",
      data: {
        fileId: fileId,
        version: version
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData.result);
        } else {
          if (responseData["code"] == 853 && responseData.options && responseData.options.noPassFiles) {
            MMEnterpriseController.checkFilesSequentially(responseData.options.noPassFiles, function () {
              MMEnterpriseController.readFileConvertStatus(fileId, version, successCB, failCb);
            }, function () {
              responseData.msg = BabelStr.str(27029);
              _.isFunction(failCb) && failCb(responseData);
            });
          } else {
            _.isFunction(failCb) && failCb(responseData);
          }
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  updateUserTagStyle: function updateUserTagStyle(params, successCB, failCb) {
    $.ajax({
      url: "/user/updateUserTagStyle.do",
      data: params,
      type: "POST",
      dataType: "json",
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData.result);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  listUserLoginHistory: function listUserLoginHistory(param, success, fail) {
    MMEnterpriseController.request("netDrive.enterpriseHandler.listUserLoginHistory", {
      userId: param.userId,
      page: param.curPageIndex,
      pageSize: param.pageSize
    }, function (res) {
      if (res["resultCode"] !== 0) {
        _.isFunction(fail) && fail(res["resultCode"], res["message"], res);
      } else {
        var logList = new _MDLoginLogCollection["default"](res["list"]);
        _.isFunction(success) && success(logList, res["total"]);
      }
    });
  },
  getZipStatus: function getZipStatus(zipStatusKey, successCB, failCb) {
    $.ajax({
      url: "/netdrive/getZipStatus.do",
      data: {
        zipStatusKey: zipStatusKey
      },
      type: "POST",
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  sendQuestion: function sendQuestion(params, successCB, failCb) {
    $.ajax({
      url: "/ai/sendQuestion.do",
      data: {
        question: params.question,
        curFileId: params.fileId,
        fileVersion: params.fileVersion
      },
      type: "POST",
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData.answer, responseData.token);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  getAnswer: function getAnswer(token, successCB, failCb) {
    $.ajax({
      url: "/ai/getAnswer.do",
      data: {
        answerToken: token
      },
      type: "POST",
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData.prompt, responseData.token, responseData.intent);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  searchExportLog: function searchExportLog(params, successCB, failCb) {
    $.ajax({
      url: "/enterprise/searchExportLog.do",
      data: params,
      type: "POST",
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          var out = new _MMNormalCollection["default"](responseData["list"]);
          _.isFunction(successCB) && successCB(out, responseData["total"]);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      fail: function fail(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  }
};

},{"1104":1104,"1184":1184,"1418":1418,"1423":1423,"1426":1426,"1431":1431,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1471":1471,"1487":1487,"1537":1537,"1538":1538,"17":17,"235":235,"238":238,"265":265,"273":273,"297":297,"298":298,"305":305,"309":309,"49":49}],309:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMFileInfoCollection = _interopRequireDefault(require(298));
var _MMTrashFile = _interopRequireDefault(require(308));
//----------------------------------------------------------------------------------------------  MMVersionInfo

//----------------------------------------------------------------------------------------------  MMTrashFileInfoCollection

var MMTrashFileInfoCollection = _MMFileInfoCollection["default"].extend({
  model: _MMTrashFile["default"]
}, {
  className: "MMTrashFileInfoCollection"
});
var _default = exports["default"] = MMTrashFileInfoCollection;

},{"1184":1184,"1454":1454,"298":298,"308":308}],308:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMFileInfo = _interopRequireDefault(require(297));
/**
 * javascript/model/MMTrashFile.js
 */

var MMTrashFile = _MMFileInfo["default"].extend({
  idAttribute: "id"
});
var _default = exports["default"] = MMTrashFile;

},{"1184":1184,"1454":1454,"297":297}],305:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMCollectionBase = _interopRequireDefault(require(20));
var _MMNormal = _interopRequireDefault(require(304));
// 假设 MMCollectionBase 和 MMNormal 已正确导入

var MMNormalCollection = _MMCollectionBase["default"].extend({
  // 默认模型（仅作为后备，构造函数中会动态替换）
  model: _MMNormal["default"],
  // 重写构造函数，接收外部 options
  constructor: function constructor(models, options) {
    options = options || {};
    // 获取外部指定的 idAttribute，默认为 'id'
    var idAttr = options.idAttribute || 'id';

    // 动态创建一个继承自 MMNormal 的子类，并设置 idAttribute
    var DynamicModel = _MMNormal["default"].extend({
      idAttribute: idAttr
    });

    // 将当前集合的 model 指向新生成的动态模型类
    this.model = DynamicModel;

    // 调用父类构造函数（MMCollectionBase 的 constructor）
    _MMCollectionBase["default"].prototype.constructor.call(this, models, options);
  }
});
var _default = exports["default"] = MMNormalCollection;

},{"1184":1184,"1454":1454,"20":20,"304":304}],304:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMModelBase = _interopRequireDefault(require(21));
var _MDChannelType = _interopRequireDefault(require(717));
/**
 * Modified by manjun.han 适配cmd
 * 2016.12.5
 */

var MMNormal = _MMModelBase["default"].extend({
  defaults: {},
  initialize: function initialize(opt) {
    _MMModelBase["default"].prototype.initialize.call(this, opt);
  },
  isMaterialLibrary: function isMaterialLibrary() {
    return this.get("id") == _MDChannelType["default"].library;
  }
});
var _default = exports["default"] = MMNormal;

},{"1184":1184,"1454":1454,"21":21,"717":717}],717:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
//
// 频道类型， added by jiang, 2015-12-15
// 此处的属性名称需要与MDLeftPanelView中的html字符串一致
var MDChannelType = {
  home: 0,
  file: 0,
  trash: 1,
  message: 2,
  editor: 3,
  myshare: 4,
  joinshare: 5,
  team: 6,
  star: 7,
  dashboard: 8,
  depart: 9,
  search: 10,
  myfocus: 11,
  evaluation: 12,
  msbox: 13,
  msbox_receive: 14,
  msbox_contribute: 15,
  workspace: 16,
  archive: 17,
  myArchiveApply: 18,
  receiveArchive: 19,
  ArchiveApplyToReview: 20,
  borrowedArchive: 21,
  archivehistory: 22,
  myarchivehistory: 23,
  preview: 24,
  recentlyList: 25,
  myupload: 26,
  mybroadcast: 27,
  depuoload: 28,
  depactive: 29,
  recently: 30,
  teamupload: 31,
  teamactive: 32,
  epfile: 33,
  personfile: 34,
  project: 35,
  filterTag: 36,
  allproject: 37,
  transfer: 38,
  library: 39,
  tool: 50,
  archiveLibrary: 51,
  classificationapproval: 52,
  ai: 50,
  webai: 51,
  aiSearch: 52,
  getServerChannelType: function getServerChannelType(type) {
    var serverChannelType = 0;
    switch (type) {
      case this.team:
        serverChannelType = 6;
        break;
      case this.myshare:
        serverChannelType = 2;
        break;
      case this.joinshare:
        serverChannelType = 3;
        break;
      case this.star:
        serverChannelType = 4;
        break;
      case this.trash:
        serverChannelType = 5;
        break;
      case this.depart:
        serverChannelType = 6;
        break;
      case this.myfocus:
        serverChannelType = 7;
        break;
      case this.evaluation:
        serverChannelType = 8;
        break;
      case this.epfile:
        serverChannelType = 6;
        break;
      case this.project:
        serverChannelType = 18;
        break;
      case this.allproject:
        serverChannelType = 19;
        break;
      case this.msbox_contribute:
        serverChannelType = 9;
        break;
      case this.msbox_receive:
        serverChannelType = 10;
        break;
      case this.recently:
        serverChannelType = 20;
        break;
    }
    return serverChannelType;
  },
  getServerChannelByRouter: function getServerChannelByRouter(type) {
    var serverChannelType = 0;
    switch (type) {
      case "team":
        serverChannelType = 6;
        break;
      case "myshare":
        serverChannelType = 2;
        break;
      case "joinshare":
        serverChannelType = 3;
        break;
      case "star":
        serverChannelType = 4;
        break;
      case "trash":
        serverChannelType = 5;
        break;
      case "depart":
        serverChannelType = 6;
        break;
      case "myfocus":
        serverChannelType = 7;
        break;
      case "evaluation":
        serverChannelType = 8;
        break;
      case "epfile":
        serverChannelType = 6;
        break;
      case "project":
        serverChannelType = 18;
        break;
      case "allproject":
        serverChannelType = 19;
        break;
      case "msbox_contribute":
        serverChannelType = 9;
        break;
      case "msbox_receive":
        serverChannelType = 10;
        break;
      case "recently":
        serverChannelType = 20;
        break;
    }
    return serverChannelType;
  }
};
var _default = exports["default"] = MDChannelType;

},{"1454":1454}],265:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMCollectionBase = _interopRequireDefault(require(20));
var _MDLoginLog = _interopRequireDefault(require(264));
var MDLoginLogCollection = _MMCollectionBase["default"].extend({
  model: _MDLoginLog["default"]
});
var _default = exports["default"] = MDLoginLogCollection;

},{"1184":1184,"1454":1454,"20":20,"264":264}],264:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMModelBase = _interopRequireDefault(require(21));
//----------------------------------------------------------------------------------------------  MMFileInfo

var MDLoginLog = _MMModelBase["default"].extend({
  defaults: {
    "address": null,
    "datetime": null,
    "terminalType": null,
    "terminalName": null
  },
  getAddress: function getAddress() {
    return this.get('address');
  },
  getDatetime: function getDatetime() {
    return this.get('datetime');
  },
  getTerminalType: function getTerminalType() {
    return this.get('terminalType');
  },
  getTerminalName: function getTerminalName() {
    return this.get('terminalName');
  }
});
var _default = exports["default"] = MDLoginLog;

},{"1184":1184,"1454":1454,"21":21}],238:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MASession = _interopRequireDefault(require(237));
var _MMCollectionBase = _interopRequireDefault(require(20));
var MASessionCollection = _MMCollectionBase["default"].extend({
  model: _MASession["default"]
});
var _default = exports["default"] = MASessionCollection;

},{"1184":1184,"1454":1454,"20":20,"237":237}],237:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMModelBase = _interopRequireDefault(require(21));
//----------------------------------------------------------------------------------------------  MMFileInfo

var MASession = _MMModelBase["default"].extend({
  defaults: {
    "sid": null,
    "URI": 0
  },
  getSid: function getSid() {
    return this.get('sid');
  },
  getURI: function getURI() {
    return this.get('URI');
  }
});
var _default = exports["default"] = MASession;

},{"1184":1184,"1454":1454,"21":21}],1099:[function(require,module,exports){
"use strict";

require(1429);
require(1478);
require(1419);
require(1477);
require(1503);
require(1500);
require(1502);
require(1422);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require(1192));
require(1439);
require(1412);
require(1466);
require(1541);
require(1461);
require(1423);
require(1443);
require(1463);
require(1487);
require(1538);
require(1432);
require(1437);
require(1418);
require(1471);
var _MDMolaUserCollection = _interopRequireDefault(require(273));
var _MDEvaluationCollection = _interopRequireDefault(require(251));
var _MDBroadcastCollection = _interopRequireDefault(require(242));
var _MMFileInfo = _interopRequireDefault(require(297));
var _MMFileInfoCollection = _interopRequireDefault(require(298));
var _MDSalonInfo = _interopRequireDefault(require(204));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var _MDWorkbenchColumnCollection = _interopRequireDefault(require(294));
var _MDLoadMaskView = _interopRequireDefault(require(49));
var _MDTransmittalCollection = _interopRequireDefault(require(292));
var _MDAlertView = _interopRequireDefault(require(32));
var _app = _interopRequireDefault(require(17));
var _MMEnterpriseController = _interopRequireDefault(require(1098));
var _MDNetDriveFileHandler = _interopRequireDefault(require(1091));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDCheckEncryptedFolderPwdWinView = _interopRequireDefault(require(557));
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var _default = exports["default"] = {
  // NEW
  // 费用相关接口
  fee: {
    /**
     * 获得账户余额
     *
     *
     */
    getBalance: function getBalance(success, fail) {},
    /**
     * 形成订单
     *
     * @param {Object} parameters {
     *   amountMoney,
     * }
     *
     * @return 订单信息 {
     *   orderId,
     *  }
     */
    createOrder: function createOrder(parameters, success, fail) {},
    /**
     * 获得存储容量和价格的列表 - 即收费标准表的内容
     *
     * @return {
     *   currentIndex,    // 当前的容量， index in the capacityList
     *   capacityList : array of {id, capacity, monthFee}
     * }
     */
    getPriceList: function getPriceList(success, fail) {},
    /**
     *
     * 设置当前用户选择的空间大小， 注意 24小时内只能设置一次空间大小，后台需要对此进行检验
     *
     * @param {Number} ourpriceId  - 规定的收费标准表的 id
     *
     */
    setCurrentCapacityLimit: function setCurrentCapacityLimit(ourPriceId, success, fail) {
      // 说明：
      // resultCode : 0 - 成功， 1 - 失败，24小时内只能设置一次空间大小

      if (success) {
        success();
      }
      if (fail) {
        fail();
      }
    }
  },
  api: {
    getDevelopAccount: function getDevelopAccount(_success, fail) {
      $.ajax({
        method: "post",
        url: "/enterprise/getDevelopAccount.do",
        data: {},
        success: function success(responseData, textStatus, jqXHR) {
          if (responseData["success"] === true) {
            var account = responseData["account"];
            _success(account);
          } else {
            fail(responseData);
          }
        }
      });
    },
    applyDevelopAccount: function applyDevelopAccount(param, _success2, fail) {
      $.ajax({
        method: "post",
        url: "/enterprise/applyDevelopAccount.do",
        data: {
          callbackUri: param["callbackUri"]
        },
        success: function success(responseData, textStatus, jqXHR) {
          if (responseData["success"] === true) {
            _success2();
          } else {
            fail(responseData);
          }
        }
      });
    },
    updateDevelopUrl: function updateDevelopUrl(param, _success3, fail) {
      $.ajax({
        method: "post",
        url: "/enterprise/updateDevelopUrl.do",
        data: {
          callbackUri: param["callbackUri"]
        },
        success: function success(responseData, textStatus, jqXHR) {
          if (responseData["success"] === true) {
            _success3();
          } else {
            fail(responseData);
          }
        }
      });
    }
  },
  getMsBoxInfoById: function getMsBoxInfoById(fileId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileHandler.getMsBoxInfoByFolder", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["msBoxInfo"]);
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  createMsBox: function createMsBox(boxInfo, success, fail) {
    console.log(boxInfo);
    var boxName = boxInfo.boxName;
    var commentStr = boxInfo.commentStr;
    var endTime = boxInfo.endTime;
    var userIds = boxInfo.userIds;
    var depIds = boxInfo.depIds;
    var groupIds = boxInfo.groupIds;
    var limits = boxInfo.limits;
    _MMEnterpriseController["default"].request("netDrive.fileHandler.createMsBox", {
      parentId: boxInfo.parentId,
      boxName: boxName,
      endTime: endTime,
      commentStr: commentStr,
      userIds: userIds,
      depIds: depIds,
      groupIds: groupIds,
      receiverIds: boxInfo.receiverIds,
      limits: limits,
      phones: boxInfo.addPhones,
      emails: boxInfo.addEmails
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(new _MMFileInfo["default"](res["fileInfo"]));
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  /**
   *
   */
  updateMsBox: function updateMsBox(boxId, params, success, fail) {
    console.log(params);
    var removeUserIds = params.removeUserIds;
    var removeDepIds = params.removeDepIds;
    var removeGroupIds = params.removeGroupIds;
    var addUserIds = params.addUserIds;
    var addDepIds = params.addDepIds;
    var addGroupIds = params.addGroupIds;
    _MMEnterpriseController["default"].request("netDrive.fileHandler.updateMsBox", {
      fileId: boxId,
      options: {
        folderId: params.folderId,
        name: params.name,
        commentStr: params.comment,
        endTime: params.endtime,
        removeUserIds: removeUserIds,
        removeDepIds: removeDepIds,
        addUserIds: addUserIds,
        addDepIds: addDepIds,
        removeGroupIds: removeGroupIds,
        addGroupIds: addGroupIds,
        addReceiverIds: params.addReceiverIds,
        removeReceiverIds: params.removeReceiverIds,
        removeLimitIds: params.removeLimitIds,
        addLimits: params.addLimits,
        addPhones: params.addPhones,
        addEmails: params.addEmails
      }
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  // 获得需要我投稿的投稿箱
  getMsBoxToContribute: function getMsBoxToContribute(success, fail) {
    /*
    var out = new MMFileInfoCollection(); //[];
    var fileInfo = new MMFileInfo({fileName: '文件收集箱1'});
      out.add(fileInfo);
    success(out);
    */
    _MMEnterpriseController["default"].request("netDrive.fileHandler.getMyMsBoxToContribute", {}, function (res) {
      if (res["resultCode"] === 0) {
        var fileInfoCollection = new _MMFileInfoCollection["default"](res["list"]);
        success(fileInfoCollection);
        _MMNetDiskDataController["default"].get2ndFileInfo(fileInfoCollection.models, function () {});
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  getMsBoxToContributeWithout2nd: function getMsBoxToContributeWithout2nd(success, fail) {
    /*
    var out = new MMFileInfoCollection(); //[];
    var fileInfo = new MMFileInfo({fileName: '文件收集箱1'});
      out.add(fileInfo);
    success(out);
    */
    _MMEnterpriseController["default"].request("netDrive.fileHandler.getMyMsBoxToContribute", {}, function (res) {
      if (res["resultCode"] === 0) {
        var fileInfoCollection = new _MMFileInfoCollection["default"](res["list"]);
        success(fileInfoCollection);
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  acceptOrDenyMsBoxReceiver: function acceptOrDenyMsBoxReceiver(recordId, accept, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileHandler.acceptOrDenyMsBoxReceiver", {
      recordId: recordId,
      accept: accept
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  // 获得需要我来审稿的投稿箱
  getMsBoxToReview: function getMsBoxToReview(success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileHandler.getMyMsBoxToReview", {}, function (res) {
      if (res["resultCode"] === 0) {
        var fileInfoCollection = new _MMFileInfoCollection["default"](res["list"]);
        success(fileInfoCollection);
        _MMNetDiskDataController["default"].get2ndFileInfo(fileInfoCollection.models, function () {});
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  getMsBoxToByType: function getMsBoxToByType(type, success, fail) {
    if (type == 1) {
      _MMEnterpriseController["default"].getMsBoxToContribute(success, fail);
    } else {
      _MMEnterpriseController["default"].getMsBoxToReview(success, fail);
    }
  },
  getEntBroadcastById: function getEntBroadcastById(netBCId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.getEnterpriseBroadcastById", {
      broadcastId: netBCId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["broadcast"]);
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  getEnterpriseBroadcast: function getEnterpriseBroadcast(success, fail) {
    _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.getEnterpriseBroadcast", {}, function (res) {
      if (res["resultCode"] === 0) {
        success(new _MDBroadcastCollection["default"](res["broadcasts"]));
      } else {}
    });
  },
  searchEnterpriseBroadcast: function searchEnterpriseBroadcast(params, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.searchEnterpriseBroadcast", {
      key: params["key"],
      startIndex: params["startIndex"],
      pageSize: params["pageSize"]
    }, function (res) {
      if (res["resultCode"] === 0) {
        var users = res["users"] || [];
        var userMap = {};
        _.each(users, function (user) {
          userMap[user["id"]] = user["name"];
        });
        _.each(res["broadcasts"], function (broadcast) {
          broadcast["creatorName"] = userMap[broadcast["creator"]];
        });
        success(new _MDBroadcastCollection["default"](res["broadcasts"]), res["count"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  publishEntBC: function publishEntBC(title, content, targetUserIds, targetDepIds, targetGroupIds, files, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.pushlishEnterpriseBroadcast", {
      title: title,
      content: content,
      targetUserIds: targetUserIds,
      targetDepIds: targetDepIds,
      targetGroupIds: targetGroupIds,
      files: files
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  /**
   * 获取企业中可以发通知的人
   */
  getUserCanBroadcast: function getUserCanBroadcast(success, fail) {
    _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.getUserCanBroadcast", {}, function (res) {
      if (res["resultCode"] === 0) {
        success(new _MDMolaUserCollection["default"](res["users"]));
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  setPersonToPublisher: function setPersonToPublisher(userIds, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.setPersonToPublisher", {
      userIds: userIds
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  deprivePublishPower: function deprivePublishPower(userIds, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.deprivePublishPower", {
      userIds: userIds
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  //
  // --------------------------------------------  salon
  //

  getSalonForFile: function getSalonForFile(fileId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileHandler.getSalonForFile", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        var salon = res["salon"];
        success(new _MDSalonInfo["default"](salon));
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  setUpSalon: function setUpSalon(fileId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileHandler.setUpSalon", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(new _MDSalonInfo["default"](res["salon"]));
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  transferSalon: function transferSalon(salonId, targetUserId, fileId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileHandler.transferSalon", {
      salonId: salonId,
      targetUserId: targetUserId,
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  closeSalon: function closeSalon(salonId, fileId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileHandler.closeSalon", {
      salonId: salonId,
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  addSalon: function addSalon(salonId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileHandler.joinSalon", {
      salonId: salonId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  leaveSalon: function leaveSalon(salonId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileHandler.leaveSalon", {
      salonId: salonId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  broadCastSalonMsg: function broadCastSalonMsg(fileId, msg, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileHandler.broadcastSalon", {
      fileId: fileId,
      message: msg
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  /**
   * 单发消息
   */
  sendSalonMsgTo: function sendSalonMsgTo(fileId, msg, targetUid, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileHandler.sendSalonMsgTo", {
      fileId: fileId,
      message: msg,
      targetUserId: targetUid
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  getTurnCredentials: function getTurnCredentials(success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileHandler.getTurnCredentials", {}, function (res) {
      if (res["resultCode"] === 0) {
        var config = {
          username: res["username"],
          password: res["password"]
        };
        success(config);
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  getSpecialFilePermission: function getSpecialFilePermission(fileId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileHandler.getSpecialFilePermission", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        var list = res["list"];
        var out = [];
        _.each(list, function (item) {
          var groupItem = {
            id: item.targetId,
            name: item.targetName,
            appendedRoleId: item.roleId,
            authorizeDeadline: item.authorizeDeadline
          };
          out.push(groupItem);
        });
        success(out);
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  removeFilePermission: function removeFilePermission(fileId, targetIds, targetType, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileHandler.removeFileAppendedPermission", {
      fileId: fileId,
      targetIds: targetIds,
      targetType: targetType
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  changeFilePermission: function changeFilePermission(fileId, sign, targetId, targetType, roleId, deadline, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileHandler.setFileAppendedPermission", {
      fileId: fileId,
      deadline: deadline,
      targetId: targetId,
      targetType: targetType,
      //0 or 2  0:user, 2:group
      roleId: roleId,
      deleteChildren: 0 // 0 or 1  ,1:cover
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  addFilePermission: function addFilePermission(fileId, targetId, targetType, roleId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileHandler.addFileAppendedPermission", {
      fileId: fileId,
      targetId: targetId,
      targetType: targetType,
      roleId: roleId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["insertId"]);
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  resetUserPassword: function resetUserPassword(password, userIds, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.resetUserPassword", {
      password: password,
      userIds: userIds
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["insertId"]);
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  setCanOwnPersonalFile: function setCanOwnPersonalFile(flag, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.setEnterpriseCanOwnPersonalFile", {
      flag: flag
    }, function (res) {
      if (res["resultCode"] === 0) {
        window.ep.canOwnPersonalFile = flag;
        _app["default"].ep.set("canOwnPersonalFile", flag);
        success();
      } else {
        fail();
      }
    });
  },
  setClosePersonalShare: function setClosePersonalShare(flag, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.setClosePersonalShare", {
      closePersonalShare: flag
    }, function (res) {
      if (res["resultCode"] === 0) {
        window.ep.isOpenPersonalShare = flag;
        _app["default"].ep.set("isOpenPersonalShare", flag);
        success();
      } else {
        fail();
      }
    });
  },
  setEnterpriseAttr: function setEnterpriseAttr(entAttr, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.setEnterpriseAttr", {
      entAttr: entAttr
    }, function (res) {
      if (res["resultCode"] === 0) {
        // window.ep.isOpenPersonalShare = flag;
        console.log(entAttr);
        _app["default"].ep.set("entAttr", entAttr);
        success();
      } else {
        fail();
      }
    });
  },
  setEnterpriseAttrByBit: function setEnterpriseAttrByBit(pos, flag, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.setEnterpriseAttrByBit", {
      position: pos,
      flag: flag
    }, function (res) {
      if (res["resultCode"] === 0) {
        _app["default"].ep.setEntattr(pos, flag);
        success();
      } else {
        fail();
      }
    });
  },
  getEnterpriseAttr: function getEnterpriseAttr(success, fail) {
    _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.getEnterpriseAttr", {}, function (res) {
      if (res["resultCode"] === 0) {
        // window.ep.isOpenPersonalShare = flag;
        console.log(res["entAttr"]);
        _app["default"].ep.set("entAttr", res["entAttr"]);
        _.isFunction(success) && success();
      } else {
        _.isFunction(fail) && fail();
      }
    });
  },
  setEnterpriseUseGlobalShareFolder: function setEnterpriseUseGlobalShareFolder(flag, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.setEnterpriseUseGlobalShareFolder", {
      flag: flag
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail();
      }
    });
  },
  setCloseShowingStructor: function setCloseShowingStructor(closeShowingStructor, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.setCloseShowingStructor", {
      closeShowingStructor: closeShowingStructor
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail();
      }
    });
  },
  isShowingStructor: function isShowingStructor(success, fail) {
    _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.isShowingStructor", {}, function (res) {
      if (res["resultCode"] === 0) {
        success(res["isShowing"]);
      } else {
        fail();
      }
    });
  },
  setRecycleTime: function setRecycleTime(day, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.setRecycleTime", {
      day: day
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail();
      }
    });
  },
  getUsersByIds: function getUsersByIds(userIds, readPhone, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.userHandler.getUserById", {
      userIds: userIds,
      readPhone: readPhone ? 1 : 0
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["users"]);
      } else {
        fail();
      }
    });
  },
  fileHasAppendedPermissionInChildren: function fileHasAppendedPermissionInChildren(fileId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileHandler.fileHasAppendedPermissionInChildren", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        // console.error(res['hasAppendedPermission'])
        success(res["hasAppendedPermission"]);
      } else {
        fail();
      }
    });
  },
  getAllFileRelations: function getAllFileRelations(success, fail) {
    _MMEnterpriseController["default"].request("netDrive.statisHandler.getMyFileRelations", {}, function (res) {
      if (res["resultCode"] === 0) {
        success(res["files"], res["relations"]);
      } else {
        fail();
      }
    });
  },
  closeShare: function closeShare(fileIds, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.shareHandler.closeShare", {
      fileIds: fileIds
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  getDepAppendedPermissionFiles: function getDepAppendedPermissionFiles(fileId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileHandler.getDepAppendedPermissionFiles", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        var files = new _MMFileInfoCollection["default"](res["fileArr"]);
        success(files);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  getShareInDepartment: function getShareInDepartment(param, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.shareHandler.getShareInDepartment", {
      fileId: param.fileId,
      key: param.key,
      startIndex: param.startIndex,
      pageSize: param.pageSize
    }, function (res) {
      if (res["resultCode"] === 0) {
        var files = new _MMFileInfoCollection["default"](res["files"]);
        success(files, res["count"]);
      } else {
        fail();
      }
    });
  },
  getShareInCommonFolder: function getShareInCommonFolder(param, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.shareHandler.getShareInCommonFolder", {
      fileId: param.fileId,
      key: param.key,
      startIndex: param.startIndex,
      pageSize: param.pageSize
    }, function (res) {
      if (res["resultCode"] === 0) {
        var files = new _MMFileInfoCollection["default"](res["files"]);
        success(files, res["count"]);
      } else {
        fail();
      }
    });
  },
  getBroadcastUserReceived: function getBroadcastUserReceived(startIndex, pageSize, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.statisHandler.getBroadcastUserReceived", {
      startIndex: startIndex,
      pageSize: pageSize
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(new _MDBroadcastCollection["default"](res["broadcasts"]));
      } else {
        fail();
      }
    });
  },
  getDepartmentSecretFiles: function getDepartmentSecretFiles(fileId, pageIndex, pageSize, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileExHandler.getDepartmentSecretFiles", {
      fileId: fileId,
      pageIndex: pageIndex,
      pageSize: pageSize
    }, function (res) {
      if (res["resultCode"] === 0) {
        var files = new _MMFileInfoCollection["default"](res["files"]);
        success(files, res["total"]);
      } else {
        fail();
      }
    });
  },
  recallCommentMessage: function recallCommentMessage(options, success, fail) {
    _MMEnterpriseController["default"].request("collaborate.collaborateHandler.recallCommentMessage", {
      fileId: options.fileId,
      messageId: options.messageId,
      commentId: options.commentId
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.log("success");
        if (success) success();
      } else {
        if (fail) fail(res["resultCode"]);
      }
    });
  },
  countShareInDepartment: function countShareInDepartment(departmentId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.shareHandler.countShareInDepartment", {
      departmentId: departmentId
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.log("success");
        if (success) success(res["count"]);
      } else {
        if (fail) fail(res["resultCode"]);
      }
    });
  },
  closeAllShareInDepartment: function closeAllShareInDepartment(departmentId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.shareHandler.closeAllShareInDepartment", {
      departmentId: departmentId
    }, function (res) {
      if (res["resultCode"] === 0) {
        if (success) success();
      } else {
        if (fail) fail(res["resultCode"]);
      }
    });
  },
  getMyRefuseType: function getMyRefuseType(success, fail) {
    _MMEnterpriseController["default"].request("netDrive.dashboardHandler.getMyRefuseType", {}, function (res) {
      if (res["resultCode"] === 0) {
        if (success) success(res["refuseType"]);
      } else {
        if (fail) fail(res["resultCode"]);
      }
    });
  },
  setMyRefusePush: function setMyRefusePush(refusePush, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.dashboardHandler.setMyRefusePush", {
      refusePush: refusePush
    }, function (res) {
      if (res["resultCode"] === 0) {
        if (success) success();
      } else {
        if (fail) fail(res["resultCode"]);
      }
    });
  },
  setMyRefuseType: function setMyRefuseType(refuseType, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.dashboardHandler.setMyRefuseType", {
      refuseType: refuseType
    }, function (res) {
      if (res["resultCode"] === 0) {
        if (success) success();
      } else {
        if (fail) fail(res["resultCode"]);
      }
    });
  },
  setDepartmentEvaluationLimited: function setDepartmentEvaluationLimited(departmentId, type, tmplIds, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.evaluationHandler.setDepartmentEvaluationLimited", {
      departmentId: departmentId,
      type: type,
      tmplIds: tmplIds
    }, function (res) {
      if (res["resultCode"] === 0) {
        if (success) success();
      } else {
        if (fail) fail(res["resultCode"]);
      }
    });
  },
  getDepartmentEvaluationLimited: function getDepartmentEvaluationLimited(departmentId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.evaluationHandler.getDepartmentEvaluationLimited", {
      departmentId: departmentId
    }, function (res) {
      if (res["resultCode"] === 0) {
        if (success) success(res["department"]);
      } else {
        if (fail) fail(res["resultCode"]);
      }
    });
  },
  getAppendPermissionDepRoles: function getAppendPermissionDepRoles(fileId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileHandler.getAppendPermissionDepRoles", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        // console.log(res)
        success(res["roles"]);
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  getFileEvaluationTmpl: function getFileEvaluationTmpl(fileId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.evaluationHandler.getFileEvaluationTmpl", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        var evaluationCollection = new _MDEvaluationCollection["default"](res["list"]);
        success(evaluationCollection, res["type"]);
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  getFileEvaluationType: function getFileEvaluationType(fileId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.evaluationHandler.getFileEvaluationType", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["type"]);
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  getEnterpriseGlobalFolder: function getEnterpriseGlobalFolder(success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileExHandler.getEnterpriseGlobalFolder", {}, function (res) {
      if (res["resultCode"] === 0) {
        var info = new _MMFileInfo["default"](res["file"]);
        success(info);
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  getEnterpriseCustomColumns: function getEnterpriseCustomColumns(success, fail) {
    _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.getEnterpriseCustomColumns", {}, function (res) {
      if (res["resultCode"] === 0) {
        var columns = res["columns"];
        columns = _.sortBy(columns, "order");
        _.each(columns, function (item, index) {
          item.sortIndex = index;
        });
        var columnCollection = new _MDWorkbenchColumnCollection["default"](columns);
        success(columnCollection, columns);
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  createCustomColumn: function createCustomColumn(fileId, name, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.createCustomColumn", {
      fileId: fileId,
      name: name
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  exchangeCustomColumn: function exchangeCustomColumn(fromId, toId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.exchangeCustomColumn", {
      fromId: fromId,
      toId: toId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  updateCustomColumn: function updateCustomColumn(columnId, fileId, title, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.updateCustomColumn", {
      columnId: columnId,
      title: title,
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  deleteCustomColumn: function deleteCustomColumn(columnId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.deleteCustomColumn", {
      columnId: columnId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  setDepartmentOrder: function setDepartmentOrder(departmentId, order, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.setDepartmentOrder", {
      departmentId: departmentId,
      order: order
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  getEnterpriseDepartmentOrder: function getEnterpriseDepartmentOrder(success, fail) {
    _MMEnterpriseController["default"].request("netDrive.enterpriseHandler.getEnterpriseDepartmentOrder", {}, function (res) {
      if (res["resultCode"] === 0) {
        success(res["orders"]);
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  getUserTeamActiveFiles: function getUserTeamActiveFiles(startIndex, pageSize, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.statisHandler.getUserTeamActiveFiles", {
      startIndex: startIndex,
      pageSize: pageSize
    }, function (res) {
      if (res["resultCode"] === 0) {
        var out = new _MMFileInfoCollection["default"](res["list"]);
        success(out);
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  getUserTeamUploadFile: function getUserTeamUploadFile(startIndex, pageSize, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.statisHandler.getUserTeamUploadFile", {
      startIndex: startIndex,
      pageSize: pageSize
    }, function (res) {
      if (res["resultCode"] === 0) {
        var out = new _MMFileInfoCollection["default"](res["files"]);
        success(out);
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  createPersonalFileList: function createPersonalFileList(fileId, title, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.userHandler.createPersonalFileList", {
      title: title,
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res["insertId"]);
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  getMyFileListShow: function getMyFileListShow(success, fail) {
    _MMEnterpriseController["default"].request("netDrive.userHandler.getMyFileListShow", {}, function (res) {
      if (res["resultCode"] === 0) {
        success(res);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  setMyFileListShow: function setMyFileListShow(list, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.userHandler.setMyFileListShow", {
      list: list
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  getMyProjects: function getMyProjects(startIndex, pageSize, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileExHandler.getMyProjects", {
      startIndex: startIndex,
      pageSize: pageSize
    }, function (res) {
      if (res["resultCode"] === 0) {
        var out = new _MMFileInfoCollection["default"](res["files"]);
        success(out);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  getMyOpenLinkShareFiles: function getMyOpenLinkShareFiles(success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileExHandler.getMyOpenLinkShareFiles", {}, function (res) {
      if (res["resultCode"] === 0) {
        var out = new _MMFileInfoCollection["default"](res["files"]);
        success(out);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  getMyInviterShareFiles: function getMyInviterShareFiles(success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileExHandler.getMyInviterShareFiles", {}, function (res) {
      if (res["resultCode"] === 0) {
        var out = new _MMFileInfoCollection["default"](res["files"]);
        success(out);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  getMyCommentOrReviewFiles: function getMyCommentOrReviewFiles(startIndex, pageSize, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileExHandler.getMyCommentOrReviewFiles", {
      startIndex: startIndex,
      pageSize: pageSize
    }, function (res) {
      if (res["resultCode"] === 0) {
        var out = new _MMFileInfoCollection["default"](res["files"]);
        success(out);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  applyRoleForFile: function applyRoleForFile(fileId, roleId, message, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileExHandler.applyRoleForFile", {
      fileId: fileId,
      roleId: roleId,
      message: message
    }, function (res) {
      if (res["resultCode"] === 0) {
        _.isFunction(success) && success();
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  applyRoleForFiles: function applyRoleForFiles(fileIds, roleId, message, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileExHandler.applyRoleForFiles", {
      fileIds: fileIds,
      roleId: roleId,
      message: message
    }, function (res) {
      if (res["resultCode"] === 0) {
        _.isFunction(success) && success();
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  applyRenameFiles: function applyRenameFiles(fileId, newName, message, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileExHandler.applyRenameFiles", {
      fileId: fileId,
      newName: newName,
      message: message
    }, function (res) {
      if (res["resultCode"] === 0) {
        _.isFunction(success) && success();
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  applyMoveFiles: function applyMoveFiles(fileId, targetId, message, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileExHandler.applyMoveFiles", {
      fileId: fileId,
      targetId: targetId,
      message: message
    }, function (res) {
      if (res["resultCode"] === 0) {
        _.isFunction(success) && success();
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  acceptOrDenyApplyFileRole: function acceptOrDenyApplyFileRole(applyId, flag, endTime, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileExHandler.acceptOrDenyApplyFileRole", {
      applyId: applyId,
      flag: flag,
      endTime: endTime
    }, function (res) {
      if (res["resultCode"] === 0) {
        _.isFunction(success) && success();
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  acceptOrDenyApplyFileOperation: function acceptOrDenyApplyFileOperation(applyId, flag, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileExHandler.acceptOrDenyApplyFileOperation", {
      applyId: applyId,
      flag: flag
    }, function (res) {
      if (res["resultCode"] === 0) {
        _.isFunction(success) && success();
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  createReadingRoom: function createReadingRoom(options, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileExHandler.createReadingRoom", {
      name: options.name,
      openType: options.openType,
      targets: options.targets
    }, function (res) {
      if (res["resultCode"] === 0) {
        _.isFunction(success) && success();
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  getReadingRoomScope: function getReadingRoomScope(fileId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileExHandler.getReadingRoomScope", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.log(res);
        _.isFunction(success) && success(res);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  updateReadingRoom: function updateReadingRoom(options, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileExHandler.updateReadingRoom", {
      newName: options.name,
      fileId: options.fileId,
      openType: options.openType,
      targets: options.targets
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.log(res);
        _.isFunction(success) && success(res);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  setFileAnonymouseUpload: function setFileAnonymouseUpload(fileId, flag, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileExHandler.setFileAnonymouseUpload", {
      fileId: fileId,
      flag: flag
    }, function (res) {
      if (res["resultCode"] === 0) {
        _.isFunction(success) && success(res);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  getMsBoxCommitStatus: function getMsBoxCommitStatus(options, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileExHandler.getMsBoxCommitStatus", {
      fileId: options.fileId,
      type: options.type,
      sortBy: options.sortBy,
      desc: options.desc,
      startIndex: options.startIndex,
      pageSize: options.pageSize
    }, function (res) {
      if (res["resultCode"] === 0) {
        _.isFunction(success) && success(new _MDMolaUserCollection["default"](res["users"]), res["total"], res["commitedNum"]);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  testCallTransmittal: function testCallTransmittal(data, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.transmittalHandler.testCall", data, function (res) {
      if (res["resultCode"] === 0) {
        _.isFunction(success) && success(res);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  getValidTransmittalNo: function getValidTransmittalNo(transmittalProjectId, transmittalReceiverId, departmentId, success, fail) {
    var data = {
      transmittalReceiverId: transmittalReceiverId,
      transmittalProjectId: transmittalProjectId,
      departmentId: departmentId
    };
    _MMEnterpriseController["default"].request("netDrive.transmittalHandler.getValidTransmittalNo", data, function (res) {
      if (res["resultCode"] === 0) {
        _.isFunction(success) && success(res);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  getVersionInfoForTransmittal: function getVersionInfoForTransmittal(transmittalProjectId, departmentId, fileIds, success, fail) {
    var data = {
      transmittalProjectId: transmittalProjectId,
      departmentId: departmentId,
      fileIds: fileIds
    };
    _MMEnterpriseController["default"].request("netDrive.transmittalHandler.getTransmittalFileVersionInfos", data, function (res) {
      if (res["resultCode"] === 0) {
        _.isFunction(success) && success(res["versionInfos"]);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  sendTransmittal: function sendTransmittal(params, success, fail) {
    var data = {
      transmittalProjectId: params.transmittalProjectId,
      transmittalNo: params.transmittalNo,
      sendTo: params.sendTo,
      copyTo: params.copyTo,
      versionSendInfos: params.versionSendInfos,
      // 里面新增用户输入的 sendAs， comment
      fileStyle: params.fileStyle,
      // 提交的文件类型
      confirmerId: params.confirmerId,
      //  确认人
      committerId: params.committerId,
      // 提交人
      comment: params.comment,
      needSign: params.needSign,
      departmentId: params.departmentId
    };
    _MMEnterpriseController["default"].request("netDrive.transmittalHandler.sendTransmittal", data, function (res) {
      if (res["resultCode"] === 0) {
        _.isFunction(success) && success(res["transmittalInfo"]);
      } else {
        var msg = res["message"] || res["msg"] || "error code:" + res["resultCode"];
        _.isFunction(fail) && fail(res["resultCode"], msg);
      }
    });
  },
  sendTransmittalEmail: function sendTransmittalEmail(transmittalProjectId, transmittalId, success, fail) {
    var data = {
      transmittalProjectId: transmittalProjectId,
      transmittalId: transmittalId
    };
    _MMEnterpriseController["default"].request("netDrive.transmittalHandler.sendTransmittalEmail", data, function (res) {
      if (res["resultCode"] === 0) {
        _.isFunction(success) && success(res);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  getTransmittalById: function getTransmittalById(transmittalId, enterpriseId, success, fail) {
    var data = {
      transmittalId: transmittalId,
      enterpriseId: enterpriseId
    };
    _MMEnterpriseController["default"].request("netDrive.transmittalHandler.getTransmittalById", data, function (res) {
      if (res["resultCode"] === 0) {
        _.isFunction(success) && success(res["fileInfos"], res["transmittalInfos"]);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  createTransmittalProject: function createTransmittalProject(params, success, fail) {
    //managerId, parentId, transmittalTitle, participantInfo, versionTemplate, comment, time
    _MMEnterpriseController["default"].request("netDrive.transmittalHandler.createTransmittalProject", params, function (res) {
      console.dir(res);
      if (res["resultCode"] === 0) {
        _.isFunction(success) && success(res);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  getTransmittalReceiverInProjectByFolderId: function getTransmittalReceiverInProjectByFolderId(fileId, success, fail) {
    //managerId, parentId, transmittalTitle, participantInfo, versionTemplate, comment, time
    _MMEnterpriseController["default"].request("netDrive.transmittalHandler.getTransmittalReceiverInProjectByFolderId", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.warn(res);
        _.isFunction(success) && success(res["transmittalReceivers"]);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  getTransmittalReceiverInProjectByProjectId: function getTransmittalReceiverInProjectByProjectId(projectId, success, fail) {
    //managerId, parentId, transmittalTitle, participantInfo, versionTemplate, comment, time
    _MMEnterpriseController["default"].request("netDrive.transmittalHandler.getTransmittalReceiverInProjectByProjectId", {
      projectId: projectId
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.warn(res);
        _.isFunction(success) && success(res["transmittalReceivers"]);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  downloadTransmittalFile: function downloadTransmittalFile(transmittalId, fileId, success, fail) {
    $.ajax({
      method: "post",
      url: "/netdrive/getDownloadTransmittalFileUrl.do",
      data: {
        transmittalId: transmittalId,
        fileId: fileId
      },
      success: function success(responseData, textStatus, jqXHR) {
        if (responseData["success"] === true) {
          var url = responseData["url"];
          _MDLoadMaskView["default"].show();
          var $fileDownloader = $("#file-downloader");
          if ($fileDownloader.length == 0) {
            $fileDownloader = $("<a></a>");
            $fileDownloader.attr("id", "file-downloader").appendTo("body");
            $fileDownloader.width(0).height(0).css("visibility", "hidden");
          }
          $fileDownloader.attr("href", url);
          $fileDownloader[0].click();
          setBabelTimeout(function () {
            _MDLoadMaskView["default"].remove();
          }, 1000);
        } else {
          fail && fail(responseData);
        }
      }
    });
  },
  checkTransmittalNoValid: function checkTransmittalNoValid(transmittalReceiverId, transmittalNo, transmittalNoTemplate, success, fail) {
    var params = {
      transmittalReceiverId: transmittalReceiverId,
      transmittalNo: transmittalNo,
      transmittalNoTemplate: transmittalNoTemplate
    };
    _MMEnterpriseController["default"].request("netDrive.transmittalHandler.checkTransmittalNoValid", params, function (res) {
      if (res["resultCode"] === 0) {
        _.isFunction(success) && success(res.valid);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  getTransmittalFileSendedRecoders: function getTransmittalFileSendedRecoders(fileId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.transmittalHandler.getTransmittalFileSendedRecoders", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        _.isFunction(success) && success(res.recoders);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  // updateTransmittalProject   { transmittalTitle, comment, fileId, versionTemplate, participantInfo, removeUserIds, updateUserInfos  }
  updateTransmittalProject: function updateTransmittalProject(params, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.transmittalHandler.updateTransmittalProject", params, function (res) {
      if (res["resultCode"] === 0) {
        _.isFunction(success) && success(res.recoders);
      } else {
        console.error(res);
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  updateTransmittalReceiverInProject: function updateTransmittalReceiverInProject(params, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.transmittalHandler.updateTransmittalReceiverInProject", params, function (res) {
      console.log(res);
      if (res["resultCode"] === 0) {
        _.isFunction(success) && success(res);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  getTransmittalProjectByFolder: function getTransmittalProjectByFolder(fileId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.transmittalHandler.getTransmittalProjectByFolder", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.error(res);
        _.isFunction(success) && success(res["transmittalProject"][0]);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  getTransmittalProjectMember: function getTransmittalProjectMember(transmittalProjectId, departmentId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.transmittalHandler.getTransmittalProjectMember", {
      transmittalProjectId: transmittalProjectId,
      departmentId: departmentId
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.error(res);
        _.isFunction(success) && success(res.members, res.manager, res["currentUserInfo"]);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  getAllTransmittalByProject: function getAllTransmittalByProject(params, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.transmittalHandler.getAllTransmittalByProject", {
      projectId: params.projectId,
      startIndex: params.startIndex,
      pageSize: params.pageSize,
      keyword: params.keyword
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.error(res);
        _.each(res.transmittals, function (item) {
          item.canSend = res.canSend;
        });
        var out = new _MDTransmittalCollection["default"](res.transmittals);
        var total = res.total || out.length;
        _.isFunction(success) && success(out, total - 0);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  getTransmittalFilesByTransmittalId: function getTransmittalFilesByTransmittalId(transmittalId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.transmittalHandler.getTransmittalFilesByTransmittalId", {
      transmittalId: transmittalId
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.error(res);
        _.isFunction(success) && success(res.transmittalFiles);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  getAllTransmittalForUser: function getAllTransmittalForUser(userId, enterpriseId, keyword, startIndex, pageSize, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.transmittalHandler.getAllTransmittalForUser", {
      userId: userId,
      enterpriseId: enterpriseId,
      startIndex: startIndex,
      pageSize: pageSize,
      getCount: 1,
      keyword: keyword
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.error(res);
        _.isFunction(success) && success(res.transmittals, res.total);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  updateTransmittalReadTime: function updateTransmittalReadTime(transmittalId, _success4, fail) {
    $.ajax({
      method: "post",
      url: "/updateTransmittalReadTime.do",
      data: {
        transmittalId: transmittalId
      },
      success: function success(responseData, textStatus, jqXHR) {
        if (responseData["success"] === true) {
          _.isFunction(_success4) && _success4();
        } else {
          fail(responseData);
        }
      }
    });
  },
  deleteTransmittalByIds: function deleteTransmittalByIds(transmittalIds, transmittalProjectId, departmentId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.transmittalHandler.deleteTransmittalByIds", {
      transmittalIds: transmittalIds,
      transmittalProjectId: transmittalProjectId,
      departmentId: departmentId
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.error(res);
        _.isFunction(success) && success();
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  restoreTrash: function restoreTrash(restoreEntTrash, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileHandler.restoreTrash", {
      restoreEntTrash: restoreEntTrash
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.error(res);
        if (res["finished"]) {
          _MDNetDriveFileHandler["default"]._notifyFormbricksSurveyState(res["finished"], "restore");
        }
        _.isFunction(success) && success();
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
      if (res["renameList"]) {
        _MDAlertView["default"].showRenamedFileList(res["renameList"]);
      }
    });
  },
  restoreEntTrash: function restoreEntTrash(success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileHandler.restoreTrash", {
      restoreEntTrash: true
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.error(res);
        _MDNetDriveFileHandler["default"]._notifyFormbricksSurveyState(res["finished"], "restore");
        _.isFunction(success) && success(res["finished"]);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
      if (res["renameList"]) {
        _MDAlertView["default"].showRenamedFileList(res["renameList"]);
      }
    });
  },
  restoreMyTrash: function restoreMyTrash(success, fail, finished, renamed) {
    finished = finished || [];
    renamed = renamed || [];
    _MMEnterpriseController["default"].request("netDrive.fileHandler.restoreMyTrash", {}, function (res) {
      if (res["resultCode"] === 0) {
        console.error(res);
        var pageSize = res["pageSize"];
        var _finished = res["finished"];
        finished = finished.concat(_finished);
        renamed = renamed.concat(res["renameList"]);
        if (!pageSize || !_finished || parseInt(pageSize) > _finished.length) {
          _MDSnackbarView["default"].show("已恢复所有" + finished.length + "个文件");
          _MDNetDriveFileHandler["default"]._notifyFormbricksSurveyState(finished, "restore");
          _.isFunction(success) && success(finished);
        } else {
          _MDSnackbarView["default"].show("已恢复" + finished.length + "个文件，请等待...");
          _MMEnterpriseController["default"].restoreMyTrash(success, fail, finished, renamed);
          return;
        }
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
      if (renamed) {
        _MDAlertView["default"].showRenamedFileList(renamed);
      }
    });
  },
  restoreEntOtherDeletedFiles: function restoreEntOtherDeletedFiles(success, fail, finished, renamed) {
    finished = finished || [];
    renamed = renamed || [];
    _MMEnterpriseController["default"].request("netDrive.fileHandler.restoreEntOtherDeletedFiles", {}, function (res) {
      if (res["resultCode"] === 0) {
        console.error(res);
        var pageSize = res["pageSize"];
        var _finished = res["finished"];
        finished = finished.concat(_finished);
        renamed = renamed.concat(res["renameList"]);
        if (!pageSize || !_finished || parseInt(pageSize) > _finished.length) {
          _MDSnackbarView["default"].show("已恢复所有" + finished.length + "个文件");
          _MDNetDriveFileHandler["default"]._notifyFormbricksSurveyState(finished, "restore");
          _.isFunction(success) && success(finished);
        } else {
          _MDSnackbarView["default"].show("已恢复" + finished.length + "个文件，请等待...");
          _MMEnterpriseController["default"].restoreEntOtherDeletedFiles(success, fail, finished, renamed);
          return;
        }
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
      if (renamed) {
        _MDAlertView["default"].showRenamedFileList(renamed);
      }
    });
  },
  restoreStdEditionOtherDeletedFiles: function restoreStdEditionOtherDeletedFiles(success, fail, finished, renamed) {
    finished = finished || [];
    renamed = renamed || [];
    _MMEnterpriseController["default"].request("netDrive.fileHandler.restoreStdEditionOtherDeletedFiles", {}, function (res) {
      // if (res["resultCode"] === 0) {
      //   console.error(res);
      //   _.isFunction(success) && success(res["finished"]);
      // } else {
      //   _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      // }
      // if (res["renameList"]) {
      //   MDAlertView.showRenamedFileList(res["renameList"]);
      // }
      if (res["resultCode"] === 0) {
        console.error(res);
        var pageSize = res["pageSize"];
        var _finished = res["finished"];
        finished = finished.concat(_finished);
        renamed = renamed.concat(res["renameList"]);
        if (!pageSize || !_finished || parseInt(pageSize) > _finished.length) {
          _MDSnackbarView["default"].show("已恢复所有" + finished.length + "个文件");
          _MDNetDriveFileHandler["default"]._notifyFormbricksSurveyState(finished, "restore");
          _.isFunction(success) && success(finished);
        } else {
          _MDSnackbarView["default"].show("已恢复" + finished.length + "个文件，请等待...");
          _MMEnterpriseController["default"].restoreStdEditionOtherDeletedFiles(success, fail, finished, renamed);
          return;
        }
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
      if (renamed) {
        _MDAlertView["default"].showRenamedFileList(renamed);
      }
    });
  },
  createAnonyBox: function createAnonyBox(boxName, isHttps, endTime, commentStr, parentId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.msboxHandler.createAnonyBox", {
      boxName: boxName,
      endTime: endTime,
      commentStr: commentStr,
      parentId: parentId || "",
      isHttps: isHttps
    }, function (res) {
      console.log(res);
      if (res["resultCode"] === 0) {
        console.error(res);
        _.isFunction(success) && success(res);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  updateAnonyBox: function updateAnonyBox(fileId, boxId, boxName, endTime, commentStr, parentId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.msboxHandler.updateAnonyBox", {
      fileId: fileId,
      boxId: boxId,
      boxName: boxName,
      endTime: endTime,
      commentStr: commentStr,
      parentId: parentId
    }, function (res) {
      console.log(res);
      if (res["resultCode"] === 0) {
        console.error(res);
        _.isFunction(success) && success();
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  getMsAnonyBoxUrl: function getMsAnonyBoxUrl(boxId, success, faile) {
    var isHttps;
    if (location.protocol == "https:") {
      isHttps = true;
    } else {
      isHttps = false;
    }
    _MMEnterpriseController["default"].request("netDrive.msboxHandler.getMsAnonyBoxUrl", {
      boxId: boxId,
      isHttps: isHttps
    }, function (res) {
      console.log(res);
      if (res["resultCode"] === 0) {
        console.error(res);
        _.isFunction(success) && success(res["msAnonyBoxUrl"]);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  getMsAnonyBoxUploaderMetaData: function getMsAnonyBoxUploaderMetaData(msBoxId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.msboxHandler.getMsAnonyBoxUploaderMetaData", {
      msBoxId: msBoxId
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.error(res);
        _.each(res.results, function (item) {
          item.caption = _.escape(item.caption);
          item.value = _.escape(item.value);
          item.placeholder = _.escape(item.placeholder);
        });
        _.isFunction(success) && success(res.results);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  /**
   * 根据用户信息创建用户的投件文件夹
   * 参数：
   *  msBoxId：
   *  uploaderInfo： 由用户的信息组成的数组，如： [{metaDataId:6, value: "李平"}, {metaDataId:5, value: "13522005866"}]
   * 返回值：
   *  uploadFolderId： 返回用户上传的文件夹 id，该用户上传的文件上传的这个文件夹
   */
  createUploadForMsAnonyBox: function createUploadForMsAnonyBox(msBoxId, uploaderInfo, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.msboxHandler.createUpload", {
      msBoxId: msBoxId,
      uploaderInfo: uploaderInfo // 由用户的信息组成的数组，如： [{metaDataId:6, value: "李平"}, {metaDataId:5, value: "13522005866"}]
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.error(res);
        _.isFunction(success) && success(res.uploadFolderId); // 返回用户上传的文件夹 id，该用户上传的文件上传的这个文件夹
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  /**
   * 更新匿名投件箱的投件人须填的元数据
   * @param {*} msboxId
   * @param {数组} addMetadata ：需要添加的元数据组成的数组 [{caption:xxx, placeholder: xxx}, ...]
   * @param {数组} deleteIds : 需要删除的 metadata id 组成的数组 [id1, id2, ...]
   * @param {数组} updateMetadata : 如 [{id:3, caption:"学号", placeholder:"请输入学号"}, ...]
   * @param {*} success
   * @param {*} fail
   */
  updateMsAnonyBoxUploaderMetaData: function updateMsAnonyBoxUploaderMetaData(params, success, faile) {
    _MMEnterpriseController["default"].request("netDrive.msboxHandler.updateMsAnonyBoxUploaderMetaData", {
      addMetaData: params.addMetaData,
      msBoxId: params.msBoxId,
      deleteIds: params.deleteIds,
      updateMetaData: params.updateMetaData
    }, function (res) {
      console.log(res);
      if (res["resultCode"] === 0) {
        console.error(res);
        _.isFunction(success) && success();
      }
    });
  },
  /**
   * 根据当前的 session 获取上传文件夹和上传者的信息
   * @param {long} msBoxId
   * @param {*} success
   * @param {*} fail
   */
  getMsAnonyBoxUploadInfo: function getMsAnonyBoxUploadInfo(msBoxId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.msboxHandler.getMsAnonyBoxUploadInfo", {
      msBoxId: msBoxId
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.error(res);
        _.each(res.uploaderInfo, function (item) {
          item.caption = _.escape(item.caption);
          item.value = _.escape(item.value);
          item.placeholder = _.escape(item.placeholder);
        });
        _.isFunction(success) && success(res.uploadFolderId, res.uploaderInfo); // uploadFolderId：返回上传的文件夹 id， 如果是 -1 表示没有上传过，和上传人的信息
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  getAnonyBoxByBoxId: function getAnonyBoxByBoxId(boxId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.msboxHandler.getAnonyBoxByBoxId", {
      boxId: boxId
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.error(res);
        _.isFunction(success) && success(res.msAnonyBox);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  getAnonyBoxByFolder: function getAnonyBoxByFolder(fileId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.msboxHandler.getAnonyBoxByFolder", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.error(res);
        _.isFunction(success) && success(res.msAnonyBox[0]);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  listFilesForMsAnonyBoxUpload: function listFilesForMsAnonyBoxUpload(msBoxId, uploadFolderId, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.msboxHandler.listDir", {
      msBoxId: msBoxId,
      uploadFolderId: uploadFolderId
    }, function (res) {
      if (res["resultCode"] === 0) {
        console.error(res);
        _.each(res.fileInfos, function (file) {
          file.fileName = file.name;
        });
        _.isFunction(success) && success(res.fileInfos);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  updateUploaderInfo: function updateUploaderInfo(msBoxId, uploaderInfo, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.msboxHandler.updateUploaderInfo", {
      msBoxId: msBoxId,
      uploaderInfo: uploaderInfo
    }, function (res) {
      console.log(res);
      if (res["resultCode"] === 0) {
        console.error(res);
        _.isFunction(success) && success();
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  deleteFilesForMsAnonyBoxUpload: function deleteFilesForMsAnonyBoxUpload(msBoxId, uploadFolderId, fileIds, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.msboxHandler.deleteFilesForMsAnonyBoxUpload", {
      msBoxId: msBoxId,
      uploadFolderId: uploadFolderId,
      fileIds: fileIds
    }, function (res) {
      console.log(res);
      if (res["resultCode"] === 0) {
        console.error(res);
        _.isFunction(success) && success();
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  getRecentUploadFilesInFolder: function getRecentUploadFilesInFolder(parentId, startIndex, pageSize, success, fail, params) {
    params = _.extend({}, params);
    _MMEnterpriseController["default"].request("netDrive.statisHandler.getRecentUploadFilesInFolder", {
      folderId: parentId,
      startIndex: startIndex ? startIndex : 0,
      pageSize: pageSize ? pageSize : 20
    }, function (res) {
      res.pages; // 总页数
      res.total; // 总记录数
      res.fileInfos; // 文件信息
      if (res["resultCode"] === 0) {
        console.error(res);
        var out = new _MMFileInfoCollection["default"](res["files"]);
        _.isFunction(success) && success(out);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  listAllFilesInFolder: function listAllFilesInFolder(parentId, orderName, isAsc, page, pageSize, success, fail, params) {
    params = _.extend({}, params);
    window.disabledchangeSubFolderstatus = true;
    var timmer = setTimeout(function () {
      window.disabledchangeSubFolderstatus = false;
    }, 10000);
    _MMEnterpriseController["default"].request("netDrive.fileExHandler.listAllFilesInFolder", {
      did: parentId,
      page: page ? page : 0,
      pageSize: pageSize ? pageSize : 50,
      orderBy: orderName,
      isAsc: isAsc
      // type: params && params.type,
    }, function (res) {
      clearTimeout(timmer);
      window.disabledchangeSubFolderstatus = false;
      res.pages; // 总页数
      res.total; // 总记录数
      res.fileInfos; // 文件信息
      if (res["resultCode"] === 0) {
        if (!window.showSubFolderFiles) {
          return;
        }
        console.error(res);
        var out = new _MMFileInfoCollection["default"](res["filesReceived"]);
        if (!res["resultSet"] || !res["resultSet"]["fileInfos"]) {
          success(out, res["total"], res["pages"]);
          return;
        }
        out = _MMEnterpriseController["default"].listFilesByPagesCallback(res, params.no2ndFileInfo);
        _.isFunction(success) && success(out, res["total"], res["pages"]);
      } else {
        _.isFunction(fail) && fail(res["resultCode"], res["message"]);
      }
    });
  },
  listEnterpriseFiles: function listEnterpriseFiles(parentId, orderName, isAsc, page, pageSize, success, fail, params) {
    params = _.extend({}, params);
    _MMEnterpriseController["default"].request("netDrive.fileHandler.listEnterpriseFiles", {
      did: parentId,
      page: page ? page : 0,
      pageSize: pageSize ? pageSize : 50,
      orderBy: orderName,
      isAsc: isAsc,
      type: params && params.type
    }, function (res) {
      res.pages; // 总页数
      res.total; // 总记录数\
      res.fileInfos; // 文件信息
      if (res["resultCode"] === 0) {
        console.error(res);
        var out = new _MMFileInfoCollection["default"](res["filesReceived"]);
        if (!res["resultSet"] || !res["resultSet"]["fileInfos"]) {
          success(out, res["total"], res["pages"]);
          return;
        }
        out = _MMEnterpriseController["default"].listFilesByPagesCallback(res, params.no2ndFileInfo);
        _.isFunction(success) && success(out, res["total"], res["pages"]);
      } else {
        if (res["resultCode"] == 853 && res.options && res.options.noPassFiles) {
          _MMEnterpriseController["default"].checkFilesSequentially(res.options.noPassFiles, function () {
            _MMEnterpriseController["default"].listEnterpriseFiles(parentId, orderName, isAsc, page, pageSize, success, fail, params);
          }, function () {
            _.isFunction(fail) && fail(res["resultCode"], BabelStr.str(27029), res);
          });
        } else {
          _.isFunction(fail) && fail(res["resultCode"], res["message"], res);
        }
      }
    });
  },
  countFileNumInFolders: function countFileNumInFolders(folderIds, fileInfos, success, fail) {
    _MMEnterpriseController["default"].request("netDrive.fileExHandler.countFileNumInFolders", {
      fileIds: folderIds
    }, function (res) {
      console.error(res);
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"]);
      } else {
        var infos = [];
        var infoList = res["fileInfos"];
        for (var i = 0; i < fileInfos.length; i++) {
          var fileId = fileInfos[i].getFileId();
          for (var k = 0; k < infoList.length; k++) {
            var id = infoList[k].parent;
            if (fileId == id) {
              fileInfos[i].setSubFileCounts(infoList[k].count);
              break;
            }
          }
        }
      }
      success && success();
    });
  },
  needCheckFilesArray: [],
  isPwdFileChecking: false,
  checkFilesSequentially: function checkFilesSequentially(files, callback, errcb) {
    if (_MMEnterpriseController["default"].isPwdFileChecking) {
      _MMEnterpriseController["default"].needCheckFilesArray.push({
        files: files,
        callback: callback,
        errcb: errcb
      });
      return;
    }
    _MMEnterpriseController["default"].isPwdFileChecking = true;
    if (_.isString(files)) {
      files = JSON.parse(files);
    }
    var index = 0; // 初始化索引
    if (typeof files === "string") {
      files = JSON.parse(files);
    }
    if (!window.filePwdMap) {
      window.filePwdMap = new Map();
    } else {
      _MMEnterpriseController["default"].checkFilePwdObj();
    }
    function validateNeedCheckFilesArray(fileId) {
      if (!_MMEnterpriseController["default"].needCheckFilesArray.length) {
        return;
      }
      for (var i = 0; i < _MMEnterpriseController["default"].needCheckFilesArray.length; i++) {
        var element = _MMEnterpriseController["default"].needCheckFilesArray[i];
        var _files = element.files;
        var file = _.findWhere(_files, function (item) {
          return item.fileId == fileId;
        });
        if (file) {
          element.errcb();
          _MMEnterpriseController["default"].needCheckFilesArray.splice(i, 1);
          i--;
        }
      }
      if (!_MMEnterpriseController["default"].needCheckFilesArray.length) {
        return;
      }
      var nextNeedCheckData = _MMEnterpriseController["default"].needCheckFilesArray.shift();
      var files = nextNeedCheckData.files,
        callback = nextNeedCheckData.callback,
        errcb = nextNeedCheckData.errcb;
      _MMEnterpriseController["default"].checkFilesSequentially(files, callback, errcb);
    }
    function checkNextFile() {
      if (index >= files.length) {
        console.log("All files have been checked.");
        _MMEnterpriseController["default"].isPwdFileChecking = false;
        callback();
        validateNeedCheckFilesArray();
        return;
      }
      var file = files[index];
      var newTime = new Date().getTime();
      if (window.filePwdMap.has(file.fileId)) {
        var time = window.filePwdMap.get(file.fileId);
        if (newTime - time < 20 * 60 * 1000) {
          // 20分钟重新输入
          console.log("file ID: ".concat(file.name, " is alreadty exit"));
          index++; // 移动到下一个文件
          checkNextFile(); // 检查下一个文件
          return;
        }
      }
      var win = new _MDCheckEncryptedFolderPwdWinView["default"]({
        fileId: file.fileId,
        fileName: file.name,
        successCb: function successCb() {
          var newTime = new Date().getTime();
          window.filePwdMap.set(file.fileId, newTime);
          console.log("Success for file ID: ".concat(file.name));
          index++; // 移动到下一个文件
          checkNextFile(); // 检查下一个文件
        },
        onClose: function onClose() {
          if (win.passed) {
            return;
          }
          _MMEnterpriseController["default"].isPwdFileChecking = false;
          errcb();
          validateNeedCheckFilesArray(file.fileId);
        }
      });
      win.show();
    }

    // 开始检查第一个文件
    checkNextFile();
  },
  checkFilePwdObj: function checkFilePwdObj() {
    if (!window.filePwdMap) {
      return;
    }
    if (window.filePwdMap.size < 20) {
      return;
    }
    console.log("start checkFilePwdObj");
    // 输出更新前的 Map
    console.log(window.filePwdMap); // 输出: Map { 'name' => 'Alice', 'age' => 25, 'city' => 'New York' }
    var newTime = new Date().getTime();
    // 收集需要删除的键
    var keysToDelete = [];

    // 遍历 Map，检查值并收集需要删除的键
    var _iterator = _createForOfIteratorHelper(window.filePwdMap),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = (0, _slicedToArray2["default"])(_step.value, 2),
          key = _step$value[0],
          value = _step$value[1];
        if (newTime - value > 20 * 60 * 1000) {
          keysToDelete.push(key);
        }
      }
      // 删除收集到的键
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    keysToDelete.forEach(function (key) {
      return window.filePwdMap["delete"](key);
    });

    // 输出更新后的 Map
    console.warn(window.filePwdMap); // 输出: Map
  },
  downloadUserSpecialFileList: function downloadUserSpecialFileList(userId, _success5, fail) {
    $.ajax({
      method: "post",
      url: "/enterprise/downloadUserSpecialFileList.do",
      data: {
        userId: userId,
        frontPage: 8
      },
      success: function success(responseData, textStatus, jqXHR) {
        if (responseData["success"] === "success") {
          _MMEnterpriseController["default"].showExportMsg();
          _success5(responseData["token"], responseData);
        } else {
          fail(responseData);
        }
      }
    });
  },
  getPdfDispKey: function getPdfDispKey(fileId, ver) {
    return new Promise(function (resolve, reject) {
      _MMEnterpriseController["default"].request("netDrive.userHandler.getPdfDispKey", {
        fileId: fileId,
        ver: ver
      }, function (res) {
        if (res["code"] === 0) {
          var encrpyted = res.key;
          console.log("decrpyted:", encrpyted);
          resolve(encrpyted);
        } else {
          reject(res["code"], res["message"]);
        }
      });
    });
  }
};

},{"1091":1091,"1098":1098,"1104":1104,"1184":1184,"1192":1192,"1412":1412,"1418":1418,"1419":1419,"1422":1422,"1423":1423,"1429":1429,"1432":1432,"1437":1437,"1439":1439,"1443":1443,"1454":1454,"1461":1461,"1463":1463,"1466":1466,"1471":1471,"1477":1477,"1478":1478,"1487":1487,"1500":1500,"1502":1502,"1503":1503,"1538":1538,"1541":1541,"17":17,"204":204,"242":242,"251":251,"273":273,"292":292,"294":294,"297":297,"298":298,"32":32,"49":49,"557":557,"72":72}],1502:[function(require,module,exports){
var defineWellKnownSymbol = require(1406);

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');

},{"1406":1406}],1192:[function(require,module,exports){
var arrayWithHoles = require(1169);
var iterableToArrayLimit = require(1186);
var unsupportedIterableToArray = require(1198);
var nonIterableRest = require(1187);
function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"1169":1169,"1186":1186,"1187":1187,"1198":1198}],1198:[function(require,module,exports){
var arrayLikeToArray = require(1168);
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"1168":1168}],1168:[function(require,module,exports){
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],1187:[function(require,module,exports){
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],1186:[function(require,module,exports){
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],1169:[function(require,module,exports){
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],1091:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1418);
require(1463);
require(1537);
require(1466);
require(1439);
require(1421);
require(1432);
require(1422);
require(1437);
require(1478);
require(1431);
require(1541);
require(1424);
require(1426);
var _MDArchive = _interopRequireDefault(require(239));
var _MDArchiveCollection = _interopRequireDefault(require(240));
var _MMVersionInfo = _interopRequireDefault(require(310));
var _MMVersionInfoCollection = _interopRequireDefault(require(311));
var _MMFileInfoCollection = _interopRequireDefault(require(298));
var _MMFileInfo = _interopRequireDefault(require(297));
var _MDFileAccessInfo = _interopRequireDefault(require(255));
var _MDTeamInfo = _interopRequireDefault(require(289));
var _MMRect = _interopRequireDefault(require(831));
var _MDMolaUser = _interopRequireDefault(require(272));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDAlertView = _interopRequireDefault(require(32));
var _ErrorCode = _interopRequireDefault(require(1087));
var _MDConstant = _interopRequireDefault(require(321));
var _MMNetDiskDataController = _interopRequireDefault(require(1104));
var MDNetDriveFileHandler = {
  _connector: null,
  LISTTYPES: {
    ALL: 0,
    FILES: 1,
    FOLDER: 2
  },
  request: function request(route, msg, callback) {
    MDNetDriveFileHandler._connector.request(route, msg, callback);
  },
  returnBorrow: function returnBorrow(applicationId, success, fail) {
    var route = "netDrive.fileHandler.returnMyBorrow";
    MDNetDriveFileHandler.request(route, {
      applicationId: applicationId
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  removeMyFileFocus: function removeMyFileFocus(fileIds, success, fail) {
    var route = "netDrive.fileHandler.removeMyFileFocus";
    MDNetDriveFileHandler.request(route, {
      fileIds: fileIds
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  //常用文件
  getRecentlyUsedFile: function getRecentlyUsedFile(success, fail) {
    // var route = "netDrive.fileHandler.getMyFocusFiles";
    var route = "netDrive.fileHandler.getRecentlyUsedFile";
    MDNetDriveFileHandler.request(route, {}, function (res) {
      if (res["resultCode"] === 0) {
        var out = new _MMFileInfoCollection["default"]();
        if (!res["files"]) {
          //list->files
          success(out);
          return;
        }
        res["files"].forEach(function (fileInfo) {
          // if(fileId == 0){
          //   fileInfo["parentId"] = "0";
          // }
          var info = new _MMFileInfo["default"](fileInfo);
          out.push(info);
        });
        success(out);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  acceptOrDenyArchiveApplication: function acceptOrDenyArchiveApplication(applicationId, endTime, flag, success, fail) {
    var route = "netDrive.fileHandler.acceptOrDenyArchiveApplication";
    MDNetDriveFileHandler.request(route, {
      applicationId: applicationId,
      flag: flag,
      endTime: endTime
    }, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  realListDir: function realListDir(reqObj, folderId, type, success, fail, readInfoSuccess, page, pageSize) {
    var route = "netDrive.fileHandler.listDir";
    if (typeof type == "function") {
      fail = success;
      success = type;
      type = MDNetDriveFileHandler.LISTTYPES.ALL;
    }
    MDNetDriveFileHandler.request(route, {
      did: folderId + "",
      type: parseInt(type),
      page: page || 0,
      pageSize: pageSize || 10000,
      callByWeb: true
    }, function (res) {
      if (res["resultCode"] == 853 && res.options && res.options.noPassFiles) {
        MMEnterpriseController.checkFilesSequentially(res.options.noPassFiles, function () {
          MDNetDriveFileHandler.realListDir(reqObj, folderId, type, success, fail, readInfoSuccess, page, pageSize);
        }, function () {
          res.message = BabelStr.str(27029);
          _.isFunction(fail) && fail(reqObj, res["resultCode"]);
        });
        return;
      }
      if (res["resultCode"] !== 0) {
        fail(reqObj, res["resultCode"]);
        return;
      }
      var out = new _MMFileInfoCollection["default"]();
      if (!res["resultSet"] || !res["resultSet"]["fileInfos"]) {
        success(reqObj, out, 0);
        return;
      }
      var defaults = res["resultSet"]["defaults"];
      var usernamesById = res["resultSet"]["userNames"];
      var fileInfos = res["resultSet"]["fileInfos"];
      fileInfos.forEach(function (file) {
        _.defaults(file, defaults);
        if (file["parentId"] == "0") {
          file["path"] = "/" + file["fileId"] + "/0/";
        } else if (file.path === "") {
          file["path"] = "/" + file["fileId"] + "/" + file["parentId"] + "/0/";
        } else {
          file["path"] = "/" + file["fileId"] + "/" + file["parentId"] + "/" + file["path"] + "/0/";
        }
        if (file["currentVersionSize"] === undefined) file["currentVersionSize"] = file["fileSize"];
        if (file["lastModifyUserId"] === undefined) file["lastModifyUserId"] = file["creatorId"];
        if (file["ownerId"] === undefined) file["ownerId"] = file["creatorId"];
        if (file.isSharing && file["sharerId"] === undefined) file["sharerId"] = file["creatorId"];
        if (file["currentVerCommitterId"] === undefined) file["currentVerCommitterId"] = file["creatorId"];
        if (file["mtime"] === undefined) file["mtime"] = file["ctime"];
        file["managerName"] = usernamesById[file["manager"]];
        file["creatorName"] = usernamesById[file["creatorId"]];
        file["lastModifyUserName"] = usernamesById[file["lastModifyUserId"]];
        file["ownerName"] = usernamesById[file["ownerId"]];
        file["sharerName"] = usernamesById[file["sharerId"]];
        file["currentVerCommitterName"] = usernamesById[file["currentVerCommitterId"]];
      });
      fileInfos.forEach(function (file) {
        var fileInfo = new _MMFileInfo["default"](file);
        fileInfo.setTeamInfo(new _MDTeamInfo["default"](file["teamInfo"]));
        out.push(fileInfo);
      });
      success(reqObj, out, res["pages"]);

      // 记录访问者的信息
      if (type != MDNetDriveFileHandler.LISTTYPES.FOLDER && readInfoSuccess) {
        var usrId = app.currentUser.id;
        if (MDNetDriveFileHandler.listdirTimeout) {
          clearTimeout(MDNetDriveFileHandler.listdirTimeout);
        }
        MDNetDriveFileHandler.listdirTimeout = setBabelTimeout(function () {
          var param = undefined;
          if (folderId == 0) {
            param = {
              channelroot: _MDConstant["default"].ChannelRoot.MyRoot
            };
          }
          MDNetDriveFileHandler.get2ndFileInfo(out.models, param, function () {
            if (readInfoSuccess) {
              readInfoSuccess(reqObj);
            }
          });
          MDNetDriveFileHandler.addFileAccessUser(folderId, usrId, function () {}, function () {});
        }, 5000);
      }
    });
  },
  getMyTeamFolders: function getMyTeamFolders(success, fail, readInfoSuccess) {
    var route = "netDrive.fileHandler.team_getMyTeamFolders";
    MDNetDriveFileHandler.request(route, {}, function (res) {
      setBabelTimeout(function () {
        if (res["resultCode"] !== 0) {
          fail();
          return;
        }
        var out = new _MMFileInfoCollection["default"]();
        if (!res["list"]) {
          success(out);
          return;
        }
        res["list"].forEach(function (fileInfo) {
          out.push(new _MMFileInfo["default"](fileInfo));
        });
        success(out);
        var param = {
          channelroot: _MDConstant["default"].ChannelRoot.MyTeam
        };
        MDNetDriveFileHandler.get2ndFileInfo(out.models, param, readInfoSuccess);
      }, 0);
    });
  },
  listBin: function listBin(fileId, success, fail) {
    var route = "netDrive.fileHandler.listDirInBin";
    MDNetDriveFileHandler.request(route, {
      did: fileId
    }, function (res) {
      setBabelTimeout(function () {
        if (res["resultCode"] === 0) {
          var out = new _MMFileInfoCollection["default"]();
          if (!res["fileArr"]) {
            success(out);
            return;
          }
          res["fileArr"].forEach(function (fileInfo) {
            if (fileId == 0) {
              fileInfo["parentId"] = "0";
            }
            out.push(new _MMFileInfo["default"](fileInfo));
          });
          success(out);
        } else {
          fail(res["resultCode"]);
        }
      }, 0);
    });
  },
  listArchiveDir: function listArchiveDir(fileId, success, fail) {
    var route = "netDrive.fileHandler.listArchiveDir";
    MDNetDriveFileHandler.request(route, {
      fileId: fileId + ""
    }, function (res) {
      setBabelTimeout(function () {
        if (res["resultCode"] === 0) {
          var out = new _MMFileInfoCollection["default"]();
          if (!res["files"]) {
            success(out);
            return;
          }
          res["files"].forEach(function (fileInfo) {
            if (fileId == 0) {
              fileInfo["parentId"] = "0";
            }
            out.push(new _MMFileInfo["default"](fileInfo));
          });
          success(out);
        } else {
          fail(res["resultCode"]);
        }
      }, 0);
    });
  },
  getMyArchiveApply: function getMyArchiveApply(success, fail) {
    var route = "netDrive.fileHandler.getMyArchiveApply";
    MDNetDriveFileHandler.request(route, {}, function (res) {
      setBabelTimeout(function () {
        if (res["resultCode"] === 0) {
          var out = new _MDArchiveCollection["default"]();
          res["applications"].forEach(function (archiveInfo) {
            archiveInfo.file = new _MMFileInfo["default"](archiveInfo["file"]);
            out.push(new _MDArchive["default"](archiveInfo));
          });
          success(out);
        } else {
          fail(res["resultCode"]);
        }
      }, 0);
    });
  },
  getMyArchiveApplyHistory: function getMyArchiveApplyHistory(success, fail) {
    var route = "netDrive.fileHandler.getMyArchiveApplyHistory";
    MDNetDriveFileHandler.request(route, {}, function (res) {
      setBabelTimeout(function () {
        if (res["resultCode"] === 0) {
          var out = new _MDArchiveCollection["default"]();
          res["applications"].forEach(function (archiveInfo) {
            archiveInfo.file = new _MMFileInfo["default"](archiveInfo["file"]);
            archiveInfo.dep = archiveInfo.department.name;
            out.push(new _MDArchive["default"](archiveInfo));
          });
          success(out);
        } else {
          fail(res["resultCode"]);
        }
      }, 0);
    });
  },
  getArchiveReviewHistory: function getArchiveReviewHistory(startIndex, pageSize, options, success, fail) {
    var route = "netDrive.fileHandler.getArchiveReviewHistory";
    MDNetDriveFileHandler.request(route, {
      startIndex: startIndex,
      pageSize: pageSize,
      startCreateTime: options.startCreateTime,
      endCreateTime: options.endCreateTime,
      fileName: options.fileName || undefined,
      userName: options.userName || undefined,
      getCount: true
    }, function (res) {
      setBabelTimeout(function () {
        if (res["resultCode"] === 0) {
          var out = new _MDArchiveCollection["default"]();
          res["applications"].forEach(function (archiveInfo) {
            archiveInfo.file = new _MMFileInfo["default"](archiveInfo["file"]);
            out.push(new _MDArchive["default"](archiveInfo));
          });
          success(out, res["count"]);
        } else {
          fail(res["resultCode"]);
        }
      }, 0);
    });
  },
  getArchiveApplyToReview: function getArchiveApplyToReview(success, fail) {
    var route = "netDrive.fileHandler.getArchiveApplyToReview";
    MDNetDriveFileHandler.request(route, {}, function (res) {
      setBabelTimeout(function () {
        if (res["resultCode"] === 0) {
          var out = new _MDArchiveCollection["default"]();
          res["applications"].forEach(function (archiveInfo) {
            archiveInfo.file = new _MMFileInfo["default"](archiveInfo["file"]);
            out.push(new _MDArchive["default"](archiveInfo));
          });
          success(out);
        } else {
          fail(res["resultCode"]);
        }
      }, 0);
    });
  },
  getMyBorrowed: function getMyBorrowed(success, fail) {
    var route = "netDrive.fileHandler.getMyBorrowed";
    MDNetDriveFileHandler.request(route, {}, function (res) {
      setBabelTimeout(function () {
        if (res["resultCode"] === 0) {
          console.log(res);
          var out = new _MDArchiveCollection["default"]();
          res["applications"].forEach(function (archiveInfo) {
            archiveInfo.file = new _MMFileInfo["default"](archiveInfo["file"]);
            out.push(new _MDArchive["default"](archiveInfo));
          });
          success(out);
        } else {
          fail(res["resultCode"]);
        }
      }, 0);
    });
  },
  searchArchive: function searchArchive(queryString, parentId, success, fail) {
    var route = "netDrive.fileHandler.searchArchive";
    MDNetDriveFileHandler.request(route, {
      queryString: queryString,
      parentId: parentId || undefined
    }, function (res) {
      setBabelTimeout(function () {
        if (res["resultCode"] === 0) {
          var out = new _MMFileInfoCollection["default"]();
          if (!res["files"]) {
            success(out);
            return;
          }
          res["files"].forEach(function (fileInfo) {
            // fileInfo["parentId"] = "0";
            out.push(new _MMFileInfo["default"](fileInfo));
          });
          success(out);
        } else {
          fail(res["resultCode"]);
        }
      }, 0);
    });
  },
  useAdvancedSearchsearchArchive: function useAdvancedSearchsearchArchive(options, success, fail) {
    if (typeof options == "string") {
      options = {
        queryString: options
      };
    }
    var queryString = options.queryString || "";
    var scope = options.scope || 0;
    var pageSize = options.pageSize || 50;
    var page = options.page || 0;
    var parentId = options.parentId;
    var type = options.type || 0;
    var orderBy = options.orderBy || "latestVersionTime";
    var scopePageIndex = options.scopePageIndex || 0;
    var scopePageSize = options.scopePageSize || 10000;
    var opts = {
      queryString: queryString,
      scope: scope,
      type: type,
      advancedOption: options.advancedOption,
      orderBy: orderBy,
      isAsc: options.isAsc,
      channel: options.channel,
      from: options.from
    };
    if (parentId) {
      opts["parentId"] = parentId;
    }
    var route = "netDrive.fileHandler.searchArchive";
    console.log(opts);
    MDNetDriveFileHandler.request(route, opts, function (res) {
      console.log(res);
      setBabelTimeout(function () {
        if (res["resultCode"] === 0) {
          var out = new _MMFileInfoCollection["default"]();
          if (!res["files"]) {
            success(out, res["totalNumber"], queryString, res);
            return;
          }
          res["files"].forEach(function (fileInfo) {
            fileInfo.querystring = queryString;
            fileInfo.searchResult = 1;
            out.push(new _MMFileInfo["default"](fileInfo));
          });
          // success(out, res["totalNumber"], queryString);
          success(out, undefined, undefined, res);
        } else {
          fail(res["resultCode"], queryString);
        }
      }, 0);
    });
  },
  // MMEnterpriseController.request('netDrive.fileHandler.searchFileByName', {
  //     "advancedOption": {
  //         fromDate: 1672538882000,
  //         toDate: undefined,
  //         useCaptureTime: true,
  //         uploader: undefined
  //         extendNames: []
  //     },
  //     "queryString": "jpeg",
  //     "scope": 0,
  //     "type": 1,
  //     "orderBy": "currentVersionSize",
  //     "isAsc": true,
  // }, function(res) {
  //     console.log(res);
  // });

  searchFileByName: function searchFileByName(options, success, fail) {
    //        console.assert(typeof queryString === "string");

    if (typeof options == "string") {
      options = {
        queryString: options
      };
    }
    var queryString = options.queryString || "";
    var scope = options.scope || 0;
    var pageSize = options.pageSize || 50;
    var page = options.page || 0;
    var parentId = options.parentId;
    var type = options.type || 0;
    var orderBy = options.orderBy || "latestVersionTime";
    var scopePageIndex = options.scopePageIndex || 0;
    var scopePageSize = options.scopePageSize || 10000;
    var opts = {
      queryString: queryString,
      scope: scope,
      page: page,
      pageSize: pageSize,
      type: type,
      scopePageIndex: scopePageIndex,
      scopePageSize: scopePageSize,
      orderBy: orderBy,
      isAsc: options.isAsc,
      channel: options.channel
    };
    if (parentId) {
      opts["parentId"] = parentId;
    }
    var route = "netDrive.fileHandler.searchFileByName";
    MDNetDriveFileHandler.request(route, opts, function (res) {
      var scopeTotal = res["scopeTotal"];
      console.warn("-------> scopeTotal:" + scopeTotal);
      console.log(res);
      setBabelTimeout(function () {
        if (res["resultCode"] === 0) {
          var out = new _MMFileInfoCollection["default"]();
          if (!res["fileArr"]) {
            success(out, res["totalNumber"], queryString);
            return;
          }
          res["fileArr"].forEach(function (fileInfo) {
            fileInfo.idUsedFileIdAndVersion = true;
            fileInfo.fileId = fileInfo.fileId + "--" + fileInfo.version;
            fileInfo.querystring = queryString;
            fileInfo.searchResult = 1;
            out.push(new _MMFileInfo["default"](fileInfo));
          });
          // success(out, res["totalNumber"], queryString);
          success(out, scopeTotal, queryString, res["useAdvancedSearch"]);
        } else {
          fail(res["resultCode"], queryString);
        }
      }, 0);
    });
  },
  //高级搜索

  useAdvancedSearchsearchFileByName: function useAdvancedSearchsearchFileByName(options, success, fail) {
    if (typeof options == "string") {
      options = {
        queryString: options
      };
    }
    var queryString = options.queryString || "";
    var scope = options.scope || 0;
    var pageSize = options.pageSize || 50;
    var page = options.page || 0;
    var parentId = options.parentId;
    var type = options.type || 0;
    var orderBy = options.orderBy || "latestVersionTime";
    var scopePageIndex = options.scopePageIndex || 0;
    var scopePageSize = options.scopePageSize || 10000;
    var opts = {
      queryString: queryString,
      scope: scope,
      type: type,
      advancedOption: options.advancedOption,
      orderBy: orderBy,
      isAsc: options.isAsc,
      channel: options.channel,
      from: options.from
    };
    if (parentId) {
      opts["parentId"] = parentId;
    }
    var route = "netDrive.fileHandler.searchFileByName";
    console.log(opts);
    MDNetDriveFileHandler.request(route, opts, function (res) {
      console.log(res);
      setBabelTimeout(function () {
        if (res["resultCode"] === 0) {
          var out = new _MMFileInfoCollection["default"]();
          if (!res["fileArr"]) {
            success(out, res["totalNumber"], queryString, res);
            return;
          }
          res["fileArr"].forEach(function (fileInfo) {
            fileInfo.idUsedFileIdAndVersion = true;
            fileInfo.fileId = fileInfo.fileId + "--" + fileInfo.version;
            fileInfo.querystring = queryString;
            fileInfo.searchResult = 1;
            out.push(new _MMFileInfo["default"](fileInfo));
          });
          // success(out, res["totalNumber"], queryString);
          success(out, undefined, undefined, res);
        } else {
          fail(res["resultCode"], queryString);
        }
      }, 0);
    });
  },
  getLastPathFolder: function getLastPathFolder(fid, channelType, success, fail) {
    var route = "netDrive.fileHandler.getPathById";
    MDNetDriveFileHandler.request(route, {
      fid: fid,
      channel: channelType
    }, function (res) {
      if (res["resultCode"] === 0) {
        var fileArr = res["fileArr"];
        if (!fileArr.length) {
          return fail(res);
        }
        var top = fileArr[fileArr.length - 1];
        var status = top.status;
        top = new _MMFileInfo["default"](top);
        var isDel = res.fileArr[0].isRemoved || status == 1;
        success(top, isDel);
      } else {
        fail(res);
      }
    });
  },
  getPathById: function getPathById(fid, channelType, top, success, fail) {
    if (fid == "0") {
      if (success) {
        setBabelTimeout(function () {
          success(new _MMFileInfoCollection["default"]());
        });
      }
      return;
    }
    if (app.ep.isArchive()) {
      channelType = 17; //所有的档案频道都是17
    }
    var route = "netDrive.fileHandler.getPathById";
    MDNetDriveFileHandler.request(route, {
      fid: fid,
      channel: channelType
    }, function (res) {
      console.warn(res);
      setBabelTimeout(function () {
        if (res["resultCode"] === 0) {
          var out = new _MMFileInfoCollection["default"]();
          if (!res["fileArr"]) {
            success(out);
            return;
          }
          if (top && app.currentUser.isAnonymous()) {
            var index = _.indexOf(res["fileArr"], _.findWhere(res["fileArr"], {
              fileId: top
            }));
            if (index != -1) {
              res["fileArr"] = res["fileArr"].splice(0, index + 1);
            }
          } else if (channelType != 0 && channelType != 6) {
            var index = _.indexOf(res["fileArr"], _.findWhere(res["fileArr"], {
              fileId: fid
            }));
            if (index != -1) {
              res["fileArr"] = res["fileArr"].splice(0, index + 1);
            }
          }
          res["fileArr"].forEach(function (fileInfo) {
            var info = new _MMFileInfo["default"](fileInfo);
            out.push(info);
            if (fileInfo["teamInfo"]) {
              info.setTeamInfo(new _MDTeamInfo["default"](fileInfo["teamInfo"]));
            }
          });
          _.each(out.models, function (file) {
            if (file.isManuscriptBox()) {
              file.set("limitsState", true);
              MDNetDriveFileHandler.getMsBoxLimits(file.getFileId(), function (limits) {
                file.set("limits", limits);
              });
            }
          });
          success && success(out);
        } else {
          fail && fail(res["resultCode"]);
        }
      }, 0);
    });
  },
  getMsBoxLimits: function getMsBoxLimits(fileId, success, fail) {
    MDNetDriveFileHandler.request("netDrive.fileHandler.getMsBoxLimits", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] == 0) {
        success(res["limits"]);
      } else {
        _.isFunction(fail) && fail();
      }
    });
  },
  restore: function restore(deleteVersionIds, fidArr, success, fail) {
    var route = "netDrive.fileHandler.restoreInTrash";
    MDNetDriveFileHandler.request(route, {
      fidArr: fidArr,
      deleteVersionIds: deleteVersionIds
    }, function (res) {
      var errors = res["errors"] || [];
      if (res["resultCode"] === 0 && errors.length === 0) {
        MDNetDriveFileHandler._notifyFormbricksSurveyState(fidArr, "restore");
        success([]);
      } else {
        // map the errors, so outside no brackets are needed
        for (var i = 0; i < errors.length; i++) {
          errors[i] = {
            fid: errors[i]["fid"],
            code: errors[i]["code"],
            msg: errors[i]["msg"]
          };
        }
        fail(res["resultCode"], res["message"], errors, res["finished"]);
      }
      if (res["renameList"]) {
        _MDAlertView["default"].showRenamedFileList(res["renameList"]);
      }
    });
  },
  sendUploadEmails: function sendUploadEmails(fileIds, success, fail) {
    if (!Array.isArray(fileIds)) fileIds = [fileIds];
    if (fileIds.length === 0) {
      setBabelTimeout(success, 0);
      return;
    }
    var route = "netDrive.fileHandler.sendUploadsCompletedMessage";
    MDNetDriveFileHandler.request(route, {
      fileIds: Array.isArray(fileIds) ? fileIds : [fileIds]
    }, function (res) {
      if (res["resultCode"] === 0) {
        if (success) success();
      } else {
        if (fail) fail(res["resultCode"]);
      }
    });
  },
  getCurrentUsersVolume: function getCurrentUsersVolume(success, fail) {
    var route = "netDrive.fileHandler.getMyVolume";
    MDNetDriveFileHandler.request(route, {}, function (res) {
      var errors = res["errors"] || [];
      if (res["resultCode"] === 0) {
        success(res["used"], res["total"]);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  getFileInfoFromServer: function getFileInfoFromServer(fileId, success, fail) {
    // if (_.isFunction(option)) {
    //   fail = success;
    //   success = option;
    //   option = {};
    // };

    fileId = fileId.toString();
    var route = "netDrive.fileHandler.fileInfoById";
    MDNetDriveFileHandler.request(route, {
      fid: fileId
    }, function (res) {
      if (res["resultCode"] === 0 && res["file"]) {
        var file = res["file"];
        var fileInfo = new _MMFileInfo["default"](file);
        fileInfo.setTeamInfo(new _MDTeamInfo["default"](file["teamInfo"]));
        // if (fileInfo.isReady() && !option.dontNeedReadInfo) {
        //   MDNetDriveFileHandler.get2ndFileInfo([fileInfo]);
        // };

        success(fileInfo);
      } else {
        if (fail) fail(res["resultCode"], res["message"], res["options"]);
      }
    });
  },
  getFileInfosFromServer: function getFileInfosFromServer(fileIds, needReadInfo, success, fail) {
    var route = "netDrive.fileHandler.file_getInfosById";
    MDNetDriveFileHandler.request(route, {
      fileIds: fileIds
    }, function (res) {
      console.warn(res);
      if (res["resultCode"] === 0 && res["list"]) {
        var out = [];
        res["list"].forEach(function (file) {
          var fileInfo = new _MMFileInfo["default"](file);
          fileInfo.setTeamInfo(new _MDTeamInfo["default"](file["teamInfo"]));
          out.push(fileInfo);
        });
        if (needReadInfo) {
          MDNetDriveFileHandler.get2ndFileInfo(out);
        }
        success(out);
      } else {
        if (fail) fail(res["resultCode"]);
      }
    });
  },
  getFileActions: function getFileActions(fileIds, success, fail) {
    var route = "netDrive.fileHandler.file_getInfosById";
    MDNetDriveFileHandler.request(route, {
      fileIds: fileIds
    }, function (res) {
      console.warn(res);
      if (res["resultCode"] === 0 && res["list"]) {
        var out = res["list"];
        success(out);
      } else {
        if (fail) fail(res["resultCode"]);
      }
    });
  },
  getFileInfoFromServerWithoutTrash: function getFileInfoFromServerWithoutTrash(fileId, success, fail) {
    fileId = fileId.toString();
    var route = "netDrive.fileHandler.fileInfoByIdNotInTrash";
    MDNetDriveFileHandler.request(route, {
      fid: fileId
    }, function (res) {
      if (res["resultCode"] === 0 && res["file"]) {
        var file = res["file"];
        var fileInfo = new _MMFileInfo["default"](file);
        fileInfo.setTeamInfo(new _MDTeamInfo["default"](file["teamInfo"]));
        if (fileInfo.isReady()) {
          MDNetDriveFileHandler.get2ndFileInfo([fileInfo]);
        }
        success(fileInfo);
      } else {
        if (fail) fail(res["resultCode"], res["message"]);
      }
    });
  },
  getFileAccessUsers: function getFileAccessUsers(fid, success, fail) {
    var route = "netDrive.fileHandler.getFileAccessUsers";
    MDNetDriveFileHandler.request(route, {
      fid: fid
    }, function (res) {
      console.assert(res["resultCode"] !== undefined);
      if (res["resultCode"] === 0) {
        var out = [];
        res["userList"].forEach(function (user) {
          out.push(user); // todo: for compression, change copy the properties of each userObject
        });
        success(out);
      } else {
        if (fail) fail(res["resultCode"]);
      }
    });
  },
  isSharingOrhasSharingChildren: function isSharingOrhasSharingChildren(fileIds, success, fail) {
    var route = "netDrive.fileHandler.file_isSharingOrhasSharingChildren";
    MDNetDriveFileHandler.request(route, {
      fileIds: fileIds
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(!!res["sharing"]);
      } else {
        if (fail) fail(res["resultCode"]);
      }
    });
  },
  addFileAccessUser: function addFileAccessUser(fid, userId, success, fail) {
    if (fid == "0") {
      success && setBabelTimeout(success, 0);
      return;
    }
    var key = userId + "-" + fid;
    if (!localStorage) return;
    // if (g_lastReadMarkTimer) {
    //     clearTimeout(g_lastReadMarkTimer);
    // }

    var t1 = localStorage[key];
    var t2 = new Date();
    var keyDelta = 1 * 60 * 60 * 1000;
    var delta = keyDelta + 1; // 1小时
    if (t1 && t1 != 0) {
      t1 = new Date($.parseJSON(t1));
      delta = t2 - t1;
    }
    if (delta > keyDelta) {
      // 需要记录
      localStorage[key] = JSON.stringify(t2);
      window.g_lastReadMarkTimer = setBabelTimeout(function () {
        var route = "netDrive.fileHandler.addFileAccessUser";
        MDNetDriveFileHandler.request(route, {
          fid: fid,
          userId: userId
        }, function (res) {
          setBabelTimeout(function () {
            console.assert(res["resultCode"] !== undefined);
            if (res["resultCode"] === 0) {
              success && success();
            } else {
              localStorage[key] = 0;
              fail && fail(res["resultCode"]);
            }
          }, 0);
        });
      }, 0);
    }
  },
  getFileCommentAccessUsers: function getFileCommentAccessUsers(fid, success, fail) {
    var route = "netDrive.fileHandler.getFileCommentAccessUsers";
    MDNetDriveFileHandler.request(route, {
      fid: fid
    }, function (res) {
      console.assert(res["resultCode"] !== undefined);
      if (res["resultCode"] === 0) {
        var out = [];
        res["userList"].forEach(function (user) {
          out.push(user); // todo: for compression, change copy the properties of each userObject
        });
        success(out);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  addFileCommentAccessUser: function addFileCommentAccessUser(fid, userId, success, fail) {
    var route = "netDrive.fileHandler.addFileCommentAccessUser";
    MDNetDriveFileHandler.request(route, {
      fid: fid,
      userId: userId
    }, function (res) {
      console.assert(res["resultCode"] !== undefined);
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  makeWhiteBoardAndBroadcast: function makeWhiteBoardAndBroadcast(parentId, file, pageSizes, fileRefId, version, success, fail) {
    var route = "netDrive.fileHandler.upload";
    var fileId = file.get("fileId");
    var size = file.get("size") || 0;
    console.assert(fileId, "fileid is not jet available, first upload it.");
    var params = {
      fid: fileId,
      fileName: file.get("name"),
      fileSize: size,
      destDirId: parentId,
      newVer: parseInt(version),
      // 0 for make it new
      fileRefId: fileRefId + "",
      //"options": 0, // no longer needed
      permission: 0
    };
    if (pageSizes) {
      params["pageSizes"] = pageSizes;
    }
    MDNetDriveFileHandler.request(route, params, function (res) {
      var result = {
        resultCode: res["resultCode"],
        uploadUrl: res["uploadUrl"],
        fileName: res["fileName"],
        newVersion: res["newVersion"]
      };
      if (res["resultCode"] === 0) {
        success(result);
      } else {
        fail(result);
      }
    });
  },
  addVersion: function addVersion(file, version, parentId, size, success, fail) {
    var route = "netDrive.fileHandler.upload";
    var fileId = file.get("fileId");

    //optional version
    if (typeof version === "function") {
      fail = success;
      success = version;
      version = 0;
    }
    console.assert(fileId, "fileid is not jet available, first upload it.");
    MDNetDriveFileHandler.request(route, {
      fid: fileId,
      fileName: file.get("name"),
      fileSize: size,
      destDirId: parentId,
      newVer: 0,
      // 0 for make it new
      permission: 0
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res);
      } else {
        fail(res);
      }
    });
  },
  getFileVersionsByFileInfo: function getFileVersionsByFileInfo(fileInfo, startIndex, pageSize, success, fail) {
    if (_.isFunction(startIndex)) {
      success = startIndex;
      fail = pageSize;
      startIndex = 0;
      pageSize = 10000;
    }
    var route = "netDrive.fileHandler.getAllVersion";
    var fileId;
    fileId = fileInfo.get("fileId");
    console.assert(fileId, "fileid missing");
    MDNetDriveFileHandler.request(route, {
      fid: fileId,
      startIndex: startIndex,
      pageSize: pageSize
    }, function (res) {
      if (res["resultCode"] === 0) {
        var versionInfos = res["verArr"] || [];
        var total = res["total"];
        var out = new _MMVersionInfoCollection["default"]();
        var idUsedFileIdAndVersion = fileInfo.get('idUsedFileIdAndVersion');
        versionInfos.forEach(function (versionInfo) {
          versionInfo["fileId"] = fileId;
          versionInfo["idUsedFileIdAndVersion"] = idUsedFileIdAndVersion;
          versionInfo["curVersion"] = res.curVersion;
          versionInfo["displaying"] = res.curVersion;
          versionInfo["fileInfo"] = fileInfo;
          out.push(new _MMVersionInfo["default"](versionInfo));
        });
        var curVerInfo = out.findWhere({
          ver: res.curVersion.toString()
        });
        fileInfo.setCurVersion(res.curVersion, curVerInfo);
        out.comparator = function (a, b) {
          var t0 = parseInt(a.get("ver"));
          var t1 = parseInt(b.get("ver"));
          return t0 > t1 ? -1 : t0 < t1 ? 1 : 0;
        };
        out.sort();
        fileInfo.setVersionList(out);
        success(out, total);
      } else {
        fail(res);
      }
    });
  },
  getAllVersion: function getAllVersion(fileId, success, fail) {
    var route = "netDrive.fileHandler.getAllVersion";
    MDNetDriveFileHandler.request(route, {
      fid: fileId
    }, function (res) {
      if (res["resultCode"] === 0) {
        var versionInfos = res["verArr"] || [];
        success(versionInfos);
      } else {
        fail(res);
      }
    });
  },
  getFileVersionNoForFiles: function getFileVersionNoForFiles(fileIds, success, fail) {
    var route = "netDrive.fileHandler.getFileVersionNoForFiles";
    MDNetDriveFileHandler.request(route, {
      fileIds: fileIds
    }, function (res) {
      if (res["resultCode"] === 0) {
        var versionInfos = res["versionNos"] || [];
        success(versionInfos);
      } else {
        fail(res);
      }
    });
  },
  setLatestVersion: function setLatestVersion(versionInfo, success, fail) {
    var route = "netDrive.fileHandler.setCurrentVersion";
    var fileId = versionInfo.get("fileId");
    var version = versionInfo.get("id");
    console.assert(fileId, "fileid is not jet available, first upload it.");
    MDNetDriveFileHandler.request(route, {
      fid: fileId,
      ver: version
    }, function (res) {
      if (res["resultCode"] === 0) {
        success(res);
      } else {
        fail(res);
      }
    });
  },
  createDir: function createDir(newName, destDirInfo, forceRename, dontNotify, success, fail, otherParam) {
    var route = "netDrive.fileHandler.createDir";
    var curUserId = app.currentUser.getUserId();
    var curUserName = app.currentUser.get("name");
    if (_.isFunction(dontNotify)) {
      otherParam = fail;
      fail = success;
      success = dontNotify;
      dontNotify = false;
    }

    //console.assert(destDirId, "fileid is not jet available, first upload it.")
    if (!newName.length) {
      setBabelTimeout(function () {
        fail(new Error(""));
      });
      return;
    }
    if (typeof destDirInfo == "string") {
      throw "the destDirInfo need to be a fileInfo";
    }
    var device = "web";
    if (window.app && app.isInClient && app.isInClient()) {
      device = "client web";
    }
    var callCreationFun = function callCreationFun(forceRename, failFun) {
      MDNetDriveFileHandler.request(route, {
        dirName: newName,
        destDir: destDirInfo.get("fileId"),
        permission: 0,
        dontNotify: dontNotify,
        forceRename: forceRename,
        device: device
      }, function (res) {
        console.error("文件夹创建成功了，下边是返回值");
        console.log(res);
        if (res["resultCode"] === 0 && res["did"]) {
          success(new _MMFileInfo["default"](res["fileInfo"]));
        } else {
          failFun(res["resultCode"], res["fileInfo"]);
        }
      });
    };
    var count = 0;
    var timewait = 1000;
    var failedCallback = function failedCallback(code, fileInfo) {
      if (code == 1 || code == 142 || code == 404 || code == 302 || code == undefined) {
        // 再被别人锁住或者异常情况时要重试
        if (count++ < 20 || otherParam && otherParam.isBatchCreate) {
          // 如果是批量上传，则必须保证都上传成功，临时报错没有意义
          if (code == 302 && timewait < 5000) {
            timewait = 5000;
          }
          setTimeout(function () {
            callCreationFun(forceRename, failedCallback);
          }, timewait);
          timewait += 1000;
          if (timewait > 10000) {
            timewait = 10000;
          }
          return;
        }
      } else if (code == _ErrorCode["default"].SameFileExists && (!otherParam || !otherParam.sameFileReturnFalse)) {
        // 这种情况只有 forceRename = 0 时出现，即禁止强制重命名
        success(new _MMFileInfo["default"](res["fileInfo"]));
      }
      fail && fail(code);
    };
    callCreationFun(forceRename, failedCallback);
    return;
  },
  batchCreateDir: function batchCreateDir(newNames, destDirInfo, success, fail) {
    var route = "netDrive.fileHandler.batchCreateFolders";
    var curUserId = app.currentUser.getUserId();
    var curUserName = app.currentUser.get("name");

    //console.assert(destDirId, "fileid is not jet available, first upload it.")
    if (!newName.length) {
      setBabelTimeout(function () {
        fail(new Error(""));
      });
      return;
    }
    if (typeof destDirInfo == "string") {
      throw "the destDirInfo need to be a fileInfo";
    }
    MDNetDriveFileHandler.request(route, {
      fileNames: newNames,
      parentId: destDirInfo.get("fileId")
    }, function (res) {
      if (res["resultCode"] === 0 && res["did"]) {
        success(new _MMFileInfo["default"](res["fileInfo"]));
      } else {
        fail(res["resultCode"]);
      }
    });
    return;
  },
  /**
   * the discribing how to delete
   */
  DELETEOPTIONS: {
    TO_TRASCH: 0,
    DELETE_ALL: 1
  },
  /**
   * will be used for files and directories
   * @author:mashx
   * @param options {object}
   *      fileId {string} the fileId in Hex
   *      version {optional int} the version to delete, default all
   *      type: {value from MDNetDriveFileHandler.DELETEOPTIONS} the Delete Option
   */
  /**
   * .survey 的内容存在 Formbricks 侧,而删除/恢复/重命名走 pomelo 不经过 Java,
   * 操作成功后必须补发通知,否则已删除问卷的公开链接仍可作答、改名后两侧名称漂移。
   * Java 侧自行过滤非 survey 文件与权限,这里 fire-and-forget 即可。
   */
  _notifyFormbricksSurveyState: function _notifyFormbricksSurveyState(fileIds, operation) {
    if (!fileIds) return;
    var ids = Array.isArray(fileIds) ? fileIds : [fileIds];
    if (ids.length === 0) return;
    $.ajax({
      method: "post",
      dataType: "json",
      url: "/netdrive/" + operation + "FormbricksSurveys.do",
      data: {
        fileIds: ids.join(",")
      }
    }).fail(function () {
      console.warn("notify formbricks " + operation + " failed:", ids);
    });
  },
  deleteFilesByIds: function deleteFilesByIds(options, success, fail) {
    var route = "netDrive.fileHandler.deleteByIds";
    var fileArray = options.fileArray;
    console.assert(fileArray instanceof Array);
    var params = {
      fidArr: fileArray
    };
    if (typeof options.type === "number") {
      params["deleteOption"] = options.type;
    } else {
      params["deleteOption"] = MDNetDriveFileHandler.DELETEOPTIONS.TO_TRASCH;
    }
    MDNetDriveFileHandler.request(route, params, function (res) {
      if (res["resultCode"] === 0) {
        MDNetDriveFileHandler._notifyFormbricksSurveyState(fileArray, "archive");
        success();
        Dispatcher.trigger(MDEvents.ShareChanged, 0);
      } else {
        var out = new Backbone.Collection();
        if (res["errors"]) {
          res["errors"].forEach(function (e) {
            out.push(new Backbone.Model(e));
          });
        }
        fail(res["resultCode"], out);
      }
    });
    return;
  },
  /**
   * will be used for files and directories
   * @param options {object}
   *      fileId {string} the fileId in Hex
   *      version {optional int} the version to delete, default all
   *      option: {value from MDNetDriveFileHandler.DELETEOPTIONS} the Delete Option
   *      isFolder {bool}
   */
  deleteFileById: function deleteFileById(options, success, fail) {
    var route = "netDrive.fileHandler.delete";
    var fileId = options.fileId;
    console.assert(fileId, "fileid is not jet available, first upload it.");
    var params = {
      fid: fileId
    };
    if (options.isFolder) {
      MDNetDriveFileHandler.deleteFilesByIds({
        fileArray: [fileId],
        type: options.type
      }, success, fail);
      return;
    } else {
      if (options.version !== undefined) {
        params["version"] = options.version + "";
      }
    }
    if (typeof options.type === "number") {
      params["deleteOption"] = options.type + "";
    } else {
      params["deleteOption"] = MDNetDriveFileHandler.DELETEOPTIONS.TO_TRASCH + "";
    }
    MDNetDriveFileHandler.request(route, params, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        fail(res["resultCode"]);
      }
    });
    return;
  },
  /**
   * will be used for files and directories
   * @param options {object}
   *      fileId {string} the fileId in Hex
   *      version {optional int} the version to delete, default all
   *      option: {value from MDNetDriveFileHandler.DELETEOPTIONS} the Delete Option
   *      isFolder {bool}
   */
  deleteFilesInTrash: function deleteFilesInTrash(options, success, fail) {
    var route = "netDrive.fileHandler.deleteFileInTrash2";
    var deleteVersionIds = options.deleteVersionIds;
    var fidArr = options.fidArr || [];
    var params = {
      deleteVersionIds: deleteVersionIds,
      fidArr: fidArr
    };
    MDNetDriveFileHandler.request(route, params, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        var errMsg = "";
        if (res["resultCode"] == 12) {
          errMsg = BabelStr.str(2403);
        } else {
          errMsg = BabelStr.str(309);
        }
        fail(res["resultCode"], errMsg);
      }
    });
    return;
  },
  deleteEntFileInTrash: function deleteEntFileInTrash(options, success, fail) {
    var route = "netDrive.fileHandler.deleteEntFileInTrash";
    var deleteVersionIds = options.deleteVersionIds;
    var fidArr = options.fidArr || [];
    var params = {
      deleteVersionIds: deleteVersionIds,
      fidArr: fidArr
    };
    MDNetDriveFileHandler.request(route, params, function (res) {
      if (res["resultCode"] === 0) {
        success();
      } else {
        var errMsg = "";
        if (res["resultCode"] == 12) {
          errMsg = BabelStr.str(2403);
        } else {
          errMsg = BabelStr.str(309);
        }
        fail(res["resultCode"], errMsg);
      }
    });
    return;
  },
  renameFile: function renameFile(fileId, version, newName, success, fail) {
    var route = "netDrive.fileHandler.rename";
    console.assert(typeof fileId === "string", "fileId should be a HexString");
    console.assert(typeof newName === "string", "name need to be a string");
    if (!newName.length) {
      // once async, always async
      setBabelTimeout(function () {
        fail(new Error("empty Name"));
      });
      return;
    }
    MDNetDriveFileHandler.request(route, {
      fid: fileId + "",
      version: version + "",
      newName: newName + ""
    }, function (res) {
      if (res["resultCode"] === 0) {
        // 重命名也走 pomelo 不经过 Java:.survey 改名同步问卷名、文件夹改名同步工作区名。
        // 这里是所有重命名入口(菜单/批量/撤销/移动端)的唯一汇聚点。
        MDNetDriveFileHandler._notifyFormbricksSurveyState(fileId, "rename");
        success();
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
    return;
  },
  clearTrash: function clearTrash(success, fail) {
    MDNetDriveFileHandler.request("netDrive.fileHandler.emptyTrash", {}, function (res) {
      if (res["resultCode"] !== 0) {
        var errMsg = "";
        if (res["resultCode"] == 12) {
          errMsg = BabelStr.str(2403);
        }
        if (fail) fail(res["resultCode"], errMsg);
      } else {
        if (success) success();
      }
    });
  },
  moveFile: function moveFile(arrFileId, targetDirId, success, fail) {
    if (!Array.isArray(arrFileId)) {
      arrFileId = [arrFileId];
    }
    var route = "netDrive.fileHandler.moveMult";
    MDNetDriveFileHandler.request(route, {
      fileIds: arrFileId,
      destDirId: targetDirId
    }, function (res) {
      if (res["resultCode"] === 0) {
        // .survey 的工作区绑定在文件本身(FILE 作用域),跨文件夹移动不需要同步 Formbricks
        var errors = res["errors"];
        if (errors.length > 0) {
          fail(errors);
        } else {
          success();
        }
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  saveSendFilePersonal: function saveSendFilePersonal(fileIds, destId, version, success, fail, otherParams) {
    if (!Array.isArray(fileIds)) {
      fileIds = [fileIds];
    }
    var params = {
      fileIds: fileIds,
      destId: destId
    };
    //optional parameter version
    if (typeof version == "function") {
      otherParams = fail;
      fail = success;
      success = version;
    } else {
      params["version"] = version;
    }
    params["sendId"] = otherParams.sendId;
    params["receiveToken"] = window.fileAccessToken;
    MDNetDriveFileHandler.request("netDrive.shareHandler.saveSendFilePersonal", params, function done(res) {
      if (res["resultCode"] === 0) {
        success(res["copyKey"], res["fileNum"]);
      } else {
        fail(res["resultCode"], res["message"]);
      }
    });
  },
  copyFile: function copyFile(fileIds, destId, version, success, fail, otherParams) {
    if (!Array.isArray(fileIds)) {
      fileIds = [fileIds];
    }
    var params = {
      fileIds: fileIds,
      destId: destId
    };
    //optional parameter version
    if (typeof version == "function") {
      otherParams = fail;
      fail = success;
      success = version;
    } else {
      params["version"] = version;
    }
    params.inTrash = otherParams && otherParams.inTrash;
    params.copyVersionInfos = otherParams && otherParams.copyVersionInfos;
    MDNetDriveFileHandler.request("netDrive.fileHandler.file_copy", params, function done(res) {
      if (res["resultCode"] === 0) {
        // var out = [];
        // if (res["results"]) {
        //   res["results"].forEach(function(result) {
        //     out.push({
        //       oldFileId: result["oldFileId"],
        //       newFileId: result["newFileId"]
        //     });
        //   });
        // }
        success(res["copyKey"], res["fileNum"]);
      } else {
        if (res["resultCode"] == 853 && res.options && res.options.noPassFiles) {
          MMEnterpriseController.checkFilesSequentially(res.options.noPassFiles, function () {
            MDNetDriveFileHandler.copyFile(fileIds, destId, version, success, fail, otherParams);
          }, function () {
            _.isFunction(fail) && fail(res["resultCode"], BabelStr.str(27029), res);
          });
        } else {
          fail(res["resultCode"], res["message"]);
        }
      }
    });
  },
  joinShareLink: function joinShareLink(fileId, password, success, fail) {
    var route = "netDrive.fileHandler.joinFile";
    var date = new Date();
    var time = date.getTime();
    var params = {
      fid: fileId,
      password: password
    };
    MDNetDriveFileHandler.request(route, params, function (res) {
      if (res["resultCode"] === 0) {
        success(new _MMFileInfo["default"](res["fileInfo"]));
        Dispatcher.trigger(MDEvents.ShareChanged, fileId);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  leaveSharedFile: function leaveSharedFile(fileId, success, fail) {
    var route = "netDrive.fileHandler.leaveFile";
    var params = {
      fid: fileId
    };
    MDNetDriveFileHandler.request(route, params, function (res) {
      if (res["resultCode"] === 0) {
        success();
        Dispatcher.trigger(MDEvents.ShareChanged, fileId);
      } else {
        fail(res["resultCode"]);
      }
    });
  },
  leaveMultipleSharedFile: function leaveMultipleSharedFile(fileIds, success, fail) {
    var route = "netDrive.fileHandler.leaveMultiFile";
    var params = {
      fids: fileIds
    };
    MDNetDriveFileHandler.request(route, params, function (res) {
      if (res["resultCode"] === 0) {
        success();
        Dispatcher.trigger(MDEvents.SharesChanged, fileIds);
      } else {
        var errors = [];
        if (res["errors"]) {
          errors = res["errors"].map(function (error) {
            return {
              fid: error["fid"],
              code: error["code"]
            };
          });
        }
        fail(res["resultCode"], errors);
      }
    });
  },
  getShareUrl: function getShareUrl(fid, isHttps, success, fail) {
    var route = "netDrive.fileHandler.getShareURL";
    MDNetDriveFileHandler.request(route, {
      fid: fid,
      isHttps: isHttps
    }, function (res) {
      if (res["resultCode"] !== 0) {
        fail(res["resultCode"]);
      } else {
        if (app.ep.isPrivateCloud()) {
          res["shareURL"] = location.origin + res["shareURL"];
        }
        if (res["password"]) {
          success(res["shareURL"], res["linkRoleId"], res["password"]);
        } else {
          success(res["shareURL"], res["linkRoleId"]);
        }
      }
    });
  },
  getFileShareURL: function getFileShareURL(shareId, fileId, success, fail) {
    var route = "netDrive.fileHandler.getFileShareURL";
    MDNetDriveFileHandler.request(route, {
      fileId: fileId,
      shareId: shareId
    }, function (res) {
      if (res["resultCode"] !== 0) {
        fail(res["resultCode"]);
      } else {
        success(res["shareURL"], res["password"]);
      }
    });
  },
  setFilePassword: function setFilePassword(fileId, password, isHttps, success, fail) {
    MDNetDriveFileHandler.request("netDrive.fileHandler.setSharePassword", {
      fid: fileId,
      password: password,
      isHttps: isHttps
    }, function (res) {
      if (res["resultCode"] !== 0) {
        fail && fail(res["resultCode"]);
      } else {
        success(res["shareURL"]);
      }
    });
  },
  setFileSticktotop: function setFileSticktotop(fileId, newSticktotop, success, fail) {
    var pathRouter = app.pathRouter;
    if (pathRouter.isInChannelRoot() && !pathRouter.isInPersonFileChannel()) {
      var channelType = 0;
      if (pathRouter.inTeam()) {
        // channelType = 1;
        channelType = 6;
      } else if (pathRouter.inMyShare()) {
        channelType = 2;
      } else if (pathRouter.inJoinShare()) {
        channelType = 3;
      } else if (pathRouter.inMyStar()) {
        channelType = 4;
      } else if (pathRouter.inTrash()) {
        channelType = 5;
      } else if (pathRouter.inDepartment()) {
        channelType = 6;
      } else if (pathRouter.isInMyfocus()) {
        channelType = 7;
      } else if (pathRouter.isInEvaluation()) {
        channelType = 8;
      } else if (pathRouter.isEpfile()) {
        channelType = 6;
      } else if (pathRouter.isProjectChannel()) {
        channelType = 18;
      } else if (pathRouter.isAllProjectChannel()) {
        channelType = 19;
      }
      this.setFileSticktotopByChannel(fileId, newSticktotop, channelType, success, fail);
    } else {
      _czc && _czc.push(["_trackEvent", "文件操作", "置顶文件", "", "", ""]);
      MDNetDriveFileHandler.request("netDrive.fileHandler.file_setStickontop", {
        fileId: fileId,
        stickontop: newSticktotop
      }, function (res) {
        if (res["resultCode"] !== 0) {
          fail(res["resultCode"]);
        } else {
          success(res["shareURL"]);
        }
      });
    }
  },
  setFileSticktotopByChannel: function setFileSticktotopByChannel(fileId, newSticktotop, channelType, success, fail) {
    _czc && _czc.push(["_trackEvent", "文件操作", "置顶文件", channelType + "", "", ""]);
    var route = newSticktotop == 0 ? "netDrive.fileHandler.stickontop_remove" : "netDrive.fileHandler.stickontop_add";
    MDNetDriveFileHandler.request(route, {
      fileId: fileId,
      channelType: channelType
    }, function (res) {
      if (res["resultCode"] !== 0) {
        _.isFunction(fail) && fail(res["resultCode"]);
      } else {
        _.isFunction(success) && success(res["shareURL"]);
      }
    });
  },
  openShareLink: function openShareLink(fileId, success, fail) {
    MDNetDriveFileHandler.request("netDrive.fileHandler.share", {
      fid: fileId
    }, function (res) {
      if (res["resultCode"] !== 0) {
        fail(res["resultCode"]);
      } else {
        success(res["shareURL"], res["shareRoleId"]);
        Dispatcher.trigger(MDEvents.ShareChanged, fileId);
      }
    });
  },
  setShareOpenToAnyone: function setShareOpenToAnyone(fileId, openToAnyone, success, fail) {
    MDNetDriveFileHandler.request("netDrive.fileHandler.file_setShareAll", {
      fileId: fileId,
      shareAll: openToAnyone ? 1 : 0
    }, function (res) {
      if (res["resultCode"] !== 0) {
        fail(res["resultCode"]);
      } else {
        success();
      }
    });
  },
  closeShareLink: function closeShareLink(fileId, success, fail) {
    MDNetDriveFileHandler.request("netDrive.fileHandler.cancelShare", {
      fid: fileId
    }, function (res) {
      if (res["resultCode"] !== 0) {
        fail(res["resultCode"]);
      } else {
        success();
        Dispatcher.trigger(MDEvents.ShareChanged, fileId);
      }
    });
  },
  closeMultipleShareLink: function closeMultipleShareLink(fileIds, success, fail) {
    var fails = [];
    var doneCount = 0;
    fileIds.forEach(function (fid) {
      MDNetDriveFileHandler.closeShareLink(fid, function successHandler() {
        done();
      }, function failHandler() {
        fails.push(fid);
        done();
      });
    });
    function done() {
      doneCount++;
      if (doneCount == fileIds.length) {
        if (fails.length) {
          if (fail) fail(fails);
        } else {
          if (success) success();
        }
      }
    }
  },
  isSharingHasPassword: function isSharingHasPassword(fileId, success, fail) {
    MDNetDriveFileHandler.request("netDrive.fileHandler.isSharingHasPassword", {
      fid: fileId,
      shareTime: app.pathRouter.getShareTime()
    }, function (res) {
      if (res["resultCode"] !== 0) {
        fail(res["resultCode"]);
      } else {
        success(!!res["isSharing"], !!res["hasPassword"], new _MMFileInfo["default"](res["fileInfo"]));
      }
    });
  },
  joinFileTemporary: function joinFileTemporary(fileId, password, success, fail) {
    MDNetDriveFileHandler.request("netDrive.fileHandler.joinFileTemporary", {
      fid: fileId,
      password: password
    }, function (res) {
      if (res["resultCode"] !== 0) {
        fail(res["resultCode"], res["message"]);
      } else {
        success(!!res["result"]);
        $.ajax({
          method: "post",
          url: "/account/recordSharePassword.do",
          data: {
            fileId: fileId,
            password: CryptoJS.MD5(password).toString()
          },
          success: function success(responseData, textStatus, jqXHR) {
            if (responseData["success"] === true) {
              console.log("--->" + responseData["success"]);
            } else {}
          }
        });
      }
    });
  },
  didIJoinFile: function didIJoinFile(fileId, success, fail) {
    MDNetDriveFileHandler.request("netDrive.fileHandler.didIJoinFile", {
      fid: fileId,
      ip: window.user.ip
    }, function (res) {
      if (res["resultCode"] !== 0) {
        fail(res["resultCode"]);
      } else {
        success(!!res["result"]);
      }
    });
  },
  getQuota: function getQuota(success, fail) {
    MDNetDriveFileHandler.request("netDrive.fileHandler.file_getQuota", {}, function (res) {
      if (res["resultCode"] !== 0) {
        fail(res["resultCode"]);
      } else {
        app.currentUser.setExpiration(res["expiration"]);
        app.currentUser.setLevel(res["level"]);
        app.currentUser.setUsedSpace(res["usedSpace"]);
        app.currentUser.setUsedSpaceJoin(res["usedSpaceJoin"]);
        app.currentUser.setUsedSpaceTeam(res["usedSpaceTeam"]);
        app.currentUser.setUsedSpaceHome(res["usedSpaceHome"]);
        app.currentUser.setTotalSpace(res["totalSpace"]);
        success(res["usedSpace"], res["totalSpace"], res["result"]);
      }
    });
  },
  get2ndFileInfo: function get2ndFileInfo(fileInfos, param, success, fail) {
    if (_.isFunction(param)) {
      success == param;
      fail = success;
      param = undefined;
    }
    if (fileInfos.length === 0) {
      return;
    }
    var ids = [];
    var folderIds = [];
    for (var i = 0; i < fileInfos.length; i++) {
      ids.push(fileInfos[i].getFileId());
      if (fileInfos[i].isFolder()) {
        folderIds.push(fileInfos[i].getFileId());
      }
    }
    MDNetDriveFileHandler.getFileTagPraiseInfo(ids, param, function (accessInfos) {
      for (var i = 0; i < fileInfos.length; i++) {
        var fileId = fileInfos[i].getFileId();
        for (var k = 0; k < accessInfos.length; k++) {
          var id = accessInfos[k].getId();
          if (fileId == id) {
            // fileInfos[i].setCommentCount(accessInfos[k].getCommentCount());
            // fileInfos[i].setUnreadCommentCount(accessInfos[k].getUnreadCommentCount());
            fileInfos[i].setUnReadCount(accessInfos[k].getUnreadFileCount());
            fileInfos[i].setPraisedUsers(accessInfos[k].getPraisingUsers());
            fileInfos[i].setFocusCount(accessInfos[k].getFocusCount());
            fileInfos[i].setAccessType(accessInfos[k].getAccessType());
            fileInfos[i].setFileReviewCount(accessInfos[k].getFileReviewCount());
            fileInfos[i].setIsFocusFile(accessInfos[k].getIsFocusFile());
            // fileInfos[i].setOpenCount(accessInfos[k].getOpenCount());
            // fileInfos[i].setAccessUserCount(accessInfos[k].getAccessUserCount());
            // fileInfos[i].setDownloadCount(accessInfos[k].getDownloadCount());
            // fileInfos[i].set('fileIdHasAppendPermission', accessInfos[k].get('fileIdHasAppendPermission'));
            fileInfos[i].setHasAppendedPermission(accessInfos[k].getHasAppendedPermission());
            fileInfos[i].set("evaluationStepCount", accessInfos[k].get("evaluationStepCount"));
            fileInfos[i].set("taskDELid", accessInfos[k].get("taskDELid"));
            fileInfos[i].set("taskRENid", accessInfos[k].get("taskRENid"));
            fileInfos[i].set("taskORGid", accessInfos[k].get("taskORGid"));
            fileInfos[i].set("taskCONid", accessInfos[k].get("taskCONid"));
            fileInfos[i].set("banned", accessInfos[k].get("banned"));
            // =====>  设置标签数据

            var tagDataArray = accessInfos[k].getTags() || [];
            var tags = [];
            var tagCollection = fileInfos[i].getTagCollection();
            tagCollection.add(tagDataArray);
            tagCollection.each(function (tagModel) {
              var canDel = fileInfos[i].canDelTag(tagModel.getId());
              tagModel.set("canDelete", canDel);
              tagModel.set("canAdd", true);
            });
            break;
          }
        }
      }
      if (_.isFunction(success)) success();
    }, function (e) {});
  },
  // 统计 点赞个数， 提醒关注个数，评论个数
  //
  getFileTagPraiseInfo: function getFileTagPraiseInfo(fileIds, param, success, fail) {
    if (_.isFunction(param)) {
      success == param;
      fail = success;
      param = undefined;
    }
    if (!Array.isArray(fileIds)) {
      if (typeof fileIds !== "string") {
        console.error("getFileTagPraiseInfo takes a string or a list of strings");
        setBabelTimeout(fail, 0);
        return;
      }
      fileIds = [fileIds];
    }
    var channelroot = undefined;
    channelroot = param ? param.channelroot : undefined;
    MDNetDriveFileHandler.request("netDrive.fileHandler.file_getAccessInfos", {
      fids: fileIds,
      channelroot: channelroot
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"]);
      } else {
        var infos = [];
        var infoList = res["resultSet"]["infos"] || [];
        var defaults = res["resultSet"]["defaults"] || {};
        infoList.forEach(function (info) {
          _.defaults(info, defaults);
          infos.push(new _MDFileAccessInfo["default"](info));
        });
        if (_.isFunction(success)) success(infos);
      }
    });
  },
  // 统计文件阅读数量，批注数量，下载数量
  //
  getFileVisitInfo: function getFileVisitInfo(fileIds, success, fail) {
    if (!Array.isArray(fileIds)) {
      if (typeof fileIds !== "string") {
        console.error("getFileVisitInfo takes a string or a list of strings");
        setBabelTimeout(fail, 0);
        return;
      }
      fileIds = [fileIds];
    }
    MDNetDriveFileHandler.request("netDrive.fileHandler.getFileVisitInfo", {
      fids: fileIds
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"]);
      } else {
        var infos = [];
        var infoList = res["resultSet"]["infos"] || [];
        var defaults = res["resultSet"]["defaults"] || {};
        infoList.forEach(function (info) {
          _.defaults(info, defaults);
          infos.push(new _MDFileAccessInfo["default"](info));
        });
        if (_.isFunction(success)) success(infos);
      }
    });
  },
  updateFileVisitInfo: function updateFileVisitInfo(fileInfo, success) {
    if (!fileInfo) {
      return;
    }
    MDNetDriveFileHandler.getFileVisitInfo([fileInfo.getFileId()], function (arrAccessInfo) {
      if (arrAccessInfo && arrAccessInfo.length > 0) {
        var k = 0;
        fileInfo.setCommentCount(arrAccessInfo[k].getCommentCount());
        fileInfo.setUnreadCommentCount(arrAccessInfo[k].getUnreadCommentCount());
        // fileInfo.setUnReadCount(arrAccessInfo[k].getUnreadFileCount());
        fileInfo.setFileReviewCount(arrAccessInfo[k].getFileReviewCount());
        fileInfo.setOpenCount(arrAccessInfo[k].getOpenCount());
        fileInfo.setAccessUserCount(arrAccessInfo[k].getAccessUserCount());
        fileInfo.setDownloadCount(arrAccessInfo[k].getDownloadCount());
      }
      _.isFunction(success) && success();
    });
  },
  getFileRelations: function getFileRelations(fileId, success, fail) {
    MDNetDriveFileHandler.request("netDrive.fileHandler.getFileRelation", {
      fileId: fileId
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"]);
      } else {
        var infos = [];
        var infoList = res["fileArr"] || [];
        infoList.forEach(function (info) {
          infos.push(new _MMFileInfo["default"](info));
        });
        if (_.isFunction(success)) success(infos);
      }
    });
  },
  createFileRelation: function createFileRelation(fileId, relatedFileId, success, fail) {
    MDNetDriveFileHandler.request("netDrive.fileHandler.createFileRelation", {
      fileId: fileId,
      relatedFileId: relatedFileId
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  deleteFileRelation: function deleteFileRelation(fileId, relatedFileId, success, fail) {
    MDNetDriveFileHandler.request("netDrive.fileHandler.deleteFileRelation", {
      fileId: fileId,
      relatedFileId: relatedFileId
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  localArchiveFile: function localArchiveFile(fileIds, success, fail) {
    MDNetDriveFileHandler.request("netDrive.fileHandler.localArchiveFile", {
      fileIds: fileIds
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"]);
      } else {
        if (_.isFunction(success)) success(res["archiveKey"]);
      }
    });
  },
  archiveFiles: function archiveFiles(params, success, fail) {
    MDNetDriveFileHandler.request("netDrive.fileHandler.archiveFile", params,
    //fileIds, classificationIds
    function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"]);
      } else {
        if (_.isFunction(success)) success(res["archiveKey"]);
      }
    });
  },
  apply2BorrowFiles: function apply2BorrowFiles(fileIds, type, comment, success, fail) {
    MDNetDriveFileHandler.request("netDrive.fileHandler.applyForBorrowArchive", {
      fileIds: fileIds,
      accessType: type,
      comment: comment
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  createArchiveFolder: function createArchiveFolder(newName, destDirInfo, forceRename, dontNotify, success, fail, otherParam) {
    var route = "netDrive.fileHandler.createArchiveFolder";
    var curUserId = app.currentUser.getUserId();
    var curUserName = app.currentUser.get("name");
    if (_.isFunction(dontNotify)) {
      otherParam = fail;
      fail = success;
      success = dontNotify;
      dontNotify = false;
    }

    //console.assert(destDirId, "fileid is not jet available, first upload it.")
    if (!newName.length) {
      setBabelTimeout(function () {
        fail(new Error(""));
      });
      return;
    }
    if (typeof destDirInfo == "string") {
      throw "the destDirInfo need to be a fileInfo";
    }
    MDNetDriveFileHandler.request(route, {
      dirName: newName,
      destDir: destDirInfo.get("fileId"),
      permission: 0,
      dontNotify: dontNotify
    }, function (res) {
      if (res["resultCode"] === 0 && res["did"]) {
        success(new _MMFileInfo["default"](res["fileInfo"]));
      } else {
        fail(res["resultCode"]);
      }
    });
    return;
  },
  getFilesUploadedByUser: function getFilesUploadedByUser(param, success, fail) {
    // var files = [
    //   new MMFileInfo({
    //     fileId: 100,
    //     fileName: "file1",
    //     ctime: new Date().getTime() / 1000 - 5000
    //   }),
    //   new MMFileInfo({
    //     fileId: 100,
    //     fileName: "file2",
    //     ctime: new Date().getTime() / 1000 - 50000
    //   }),
    //   new MMFileInfo({
    //     fileId: 100,
    //     fileName: "file3",
    //     ctime: new Date().getTime() / 1000 - 500000
    //   }),
    //   new MMFileInfo({
    //     fileId: 100,
    //     fileName: "file4",
    //     ctime: new Date().getTime() / 1000 - 5000000
    //   }),

    // ];
    // var fileCollection = new MMFileInfoCollection(files);
    // setBabelTimeout(()=>{
    //   success(fileCollection);
    // }, 100)
    // return;

    MDNetDriveFileHandler.request("netDrive.statisHandler.countUserFileInFolder", {
      creator: param.userId,
      folderId: param.folderId,
      startIndex: param.startIndex || 0,
      pageSize: param.pageSize || 4000,
      userType: param.userType
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"]);
      } else {
        var fileCollection = new _MMFileInfoCollection["default"]();
        _.each(res["files"], function (file) {
          file.idUsedFileIdAndVersion = true;
          file.fileId = file.fileId + "--" + file.version;
          file = new _MMFileInfo["default"](file);
          fileCollection.add(file);
        });
        if (_.isFunction(success)) success(fileCollection, res["count"]);
      }
    });
  },
  getFilesInDepUploadedByUser: function getFilesInDepUploadedByUser(param, success, fail) {
    delete param.userType;
    MDNetDriveFileHandler.request("netDrive.statisHandler.countUserFileInDepartment", {
      creator: param.userId,
      departmentId: param.depId,
      startIndex: param.startIndex || 0,
      pageSize: param.pageSize || 4000
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"]);
      } else {
        var fileCollection = new _MMFileInfoCollection["default"]();
        _.each(res["files"], function (file) {
          file.idUsedFileIdAndVersion = true;
          file.fileId = file.fileId + "--" + file.version;
          file = new _MMFileInfo["default"](file);
          fileCollection.add(file);
        });
        if (_.isFunction(success)) success(fileCollection, res["count"]);
      }
    });
  },
  getScribblesInFile: function getScribblesInFile(fileId, version, success, fail) {
    version = parseInt(version);
    MDNetDriveFileHandler.request("collaborate.collaborateHandler.getBoardData", {
      fileId: fileId,
      version: version
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"]);
      } else {
        if (_.isFunction(success)) success(res["datas"]);
      }
    });
  },
  sendBoardDatas: function sendBoardDatas(fileId, version, datas, success, fail) {
    version = parseInt(version);
    MDNetDriveFileHandler.request("collaborate.collaborateHandler.sendBoardDatas", {
      fileId: fileId,
      version: version,
      datas: datas // {data, dataId, type}
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  sendScribbleInFile: function sendScribbleInFile(fileId, version, data, dataId, success, fail) {
    version = parseInt(version);
    MDNetDriveFileHandler.request("collaborate.collaborateHandler.sendBoardData", {
      fileId: fileId,
      version: version,
      data: data,
      dataId: dataId,
      type: "scribble"
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  deleteBoardDataById: function deleteBoardDataById(fileId, ids, success, fail) {
    MDNetDriveFileHandler.request("collaborate.collaborateHandler.deleteBoardDataById", {
      fileId: fileId,
      ids: ids
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  shiftFileManager: function shiftFileManager(fileId, toUser, success, fail) {
    MDNetDriveFileHandler.request("netDrive.fileExHandler.shiftFileManager", {
      fileId: fileId,
      toUser: toUser
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  getFileSeals: function getFileSeals(fileId, version, success, fail) {
    MDNetDriveFileHandler.request("collaborate.collaborateHandler.getFileSeals", {
      fileId: fileId,
      version: version
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"]);
      } else {
        var sealInfos = [];
        var userMap = {};
        for (var i = 0; i < res["sealInfos"].length; i++) {
          var element = res["sealInfos"][i];
          var user = void 0;
          if (!userMap[element.userInfo.id]) {
            user = new _MDMolaUser["default"](element.userInfo);
          } else {
            user = userMap[element.userInfo.id];
          }
          element.user = user;
          element.rect = new _MMRect["default"]();
          element.rect.setRct(element.x, element.y, element.width, element.height);
          sealInfos.push(element);
        }
        if (_.isFunction(success)) success(sealInfos);
      }
    });
  },
  deleteFileSeal: function deleteFileSeal(fileId, version, id, success, fail) {
    MDNetDriveFileHandler.request("collaborate.collaborateHandler.deleteFileSeal", {
      fileId: fileId,
      version: version,
      id: id
    }, function (res) {
      if (res["resultCode"] !== 0) {
        if (_.isFunction(fail)) fail(res["resultCode"], res["message"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  saveFileSignatures: function saveFileSignatures(fileId, version, sigFrame, success, fail) {
    var rect = sigFrame.getRect2Save();
    var pgIndex = sigFrame.getPageIndex();
    var angle = -sigFrame.getAngle();
    _czc && _czc.push(["_trackEvent", "签名", "对文件签名", fileId, "", ""]);
    MDNetDriveFileHandler.request("collaborate.collaborateHandler.addSignToFile", {
      fileId: fileId,
      signId: app.currentUser.getSigData().id,
      version: version,
      pageIndex: pgIndex,
      x: rect.getOrigin().x,
      y: rect.getOrigin().y,
      height: rect.getHeight(),
      width: rect.getWidth(),
      angle: angle
    }, function (res) {
      if (res["resultCode"] !== 0) {
        _MDSnackbarView["default"].show(BabelStr.str(168));
        if (_.isFunction(fail)) fail(res["resultCode"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  },
  addSealToFile: function addSealToFile(fileId, version, sigFrame, success, fail) {
    var rect = sigFrame.getRect2Save();
    var pgIndex = sigFrame.getPageIndex();
    var angle = -sigFrame.getAngle();
    _czc && _czc.push(["_trackEvent", "签名", "对文件签名", fileId, "", ""]);
    MDNetDriveFileHandler.request("collaborate.collaborateHandler.addSealToFile", {
      fileId: fileId,
      sealId: sigFrame.getSigDataId(),
      // app.currentUser.getSigData().id,
      version: version,
      pageIndex: pgIndex,
      x: rect.getOrigin().x,
      y: rect.getOrigin().y,
      height: rect.getHeight(),
      width: rect.getWidth(),
      angle: angle
    }, function (res) {
      if (res["resultCode"] !== 0) {
        _MDSnackbarView["default"].show(BabelStr.str(168));
        if (_.isFunction(fail)) fail(res["resultCode"]);
      } else {
        if (_.isFunction(success)) success(res);
      }
    });
  },
  updateFileSealPosition: function updateFileSealPosition(fileId, version, sigFrame, success, fail) {
    var rect = sigFrame.getRect2Save();
    var pgIndex = sigFrame.getPageIndex();
    var angle = -sigFrame.getAngle();
    var sealId = sigFrame.getSigData().id;
    var sealedId = sigFrame.getSealedId();
    MDNetDriveFileHandler.request("collaborate.collaborateHandler.updateFileSealPosition", {
      id: sealedId,
      fileId: fileId,
      sealId: sealId,
      version: version,
      pageIndex: pgIndex,
      x: rect.getOrigin().x,
      y: rect.getOrigin().y,
      height: rect.getHeight(),
      width: rect.getWidth(),
      angle: angle
    }, function (res) {
      if (res["resultCode"] !== 0) {
        _MDSnackbarView["default"].show(BabelStr.str(168));
        if (_.isFunction(fail)) fail(res["resultCode"]);
      } else {
        if (_.isFunction(success)) success();
      }
    });
  }
};
var _default = exports["default"] = MDNetDriveFileHandler;

},{"1087":1087,"1104":1104,"1184":1184,"1418":1418,"1421":1421,"1422":1422,"1424":1424,"1426":1426,"1431":1431,"1432":1432,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1466":1466,"1478":1478,"1537":1537,"1541":1541,"239":239,"240":240,"255":255,"272":272,"289":289,"297":297,"298":298,"310":310,"311":311,"32":32,"321":321,"72":72,"831":831}],1087:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var ErrorCode = {
  ACCESS_DENIED: 12,
  FILE_LOCKED_BY_OTHERS: 142,
  Email_Illegal: 208,
  Email_Exist_Error: 201,
  Uname_Illegal: 209,
  Pwd_Illegal: 210,
  ValidateCode_Error: 235,
  Email_Not_Exist: 202,
  Pwd_UnMatch: 206,
  Not_Login: 207,
  Wrong_SmsCode: 234,
  Phone_Exist: 237,
  SmsCode_Exprie: 238,
  Params_Illegal: 2,
  Unbinded_Phone: 229,
  Phone_Format_Error: 2,
  Account_NotExist: 203,
  Param_Format_Error: 2,
  Account_Frozen: 230,
  WaitToSendCode: 231,
  Eval_Tmpl_Exist: 334,
  Dep_has_subDep: 323,
  Cannot_Access_Archive: 337,
  Error_Secret_Dep: 352,
  DuplicatedKey: 800,
  // 有重复的 key 导致错误

  UploadFileTypeForbidden: 10002,
  SameFileExists: 10004
};
var _default = exports["default"] = ErrorCode;

},{"1454":1454}],321:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Application global constant key/value
 * Created by manjun.han
 * 2015.11.16
 */

var SUPPORTED_FILETYPE = '.jpg,.jpeg,.png,.pdf,.ppt,.pptx,.doc,.docx,.key,.pages,.numbers';
var IMAGE_FILETYPE = '.jpg,.jpeg,.png';
var LOCAL_FILETYPE = '.jpg,.jpeg,.png,.pdf';
var IWORK_FILETYPE = '.key, .pages,.numbers';
window.SUPPORTED_FILETYPE = SUPPORTED_FILETYPE;
window.IMAGE_FILETYPE = IMAGE_FILETYPE;
window.LOCAL_FILETYPE = LOCAL_FILETYPE;
window.IWORK_FILETYPE = IWORK_FILETYPE;
var MDConstant = {
  SUPPORTED_FILETYPE: SUPPORTED_FILETYPE,
  IMAGE_FILETYPE: IMAGE_FILETYPE,
  LOCAL_FILETYPE: LOCAL_FILETYPE,
  IWORK_FILETYPE: IWORK_FILETYPE,
  ChannelRoot: {
    MyRoot: "myRoot",
    MyRecent: "myRecent",
    MyStarmark: "myStarmark",
    MyShare: "myShare",
    MyJoinShare: "myJoinShare",
    MyFocus: "myFocus",
    Evaluating: "evaluating",
    MyTeam: "myTeam",
    MyBin: "myBin"
  }
};
var _default = exports["default"] = MDConstant;

},{"1454":1454}],311:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1418);
require(1463);
require(1537);
require(1430);
var _MMVersionInfo = _interopRequireDefault(require(310));
var _MMCollectionBase = _interopRequireDefault(require(20));
var MMVersionInfoCollection = _MMCollectionBase["default"].extend({
  model: _MMVersionInfo["default"],
  setCurVersion: function setCurVersion(ver) {
    this.forEach(function (verInfo) {
      verInfo.setCurVersion(ver);
    });
  },
  isValidateVersion: function isValidateVersion(index) {
    return this.some(function (versionInfo) {
      var versionId = versionInfo.getVersion();
      return versionId == index;
    });
  }
});
var _default = exports["default"] = MMVersionInfoCollection;

},{"1184":1184,"1418":1418,"1430":1430,"1454":1454,"1463":1463,"1537":1537,"20":20,"310":310}],310:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1425);
require(1449);
require(1446);
var _MMModelBase = _interopRequireDefault(require(21));
var _MMFileIconMaker = _interopRequireDefault(require(296));
var MMVersionInfo = _MMModelBase["default"].extend({
  defaults: {
    "thumbnailPath": null,
    "fileId": "0",
    "ver": "0",
    "createTime": null,
    // unix timestamp
    "committerId": "",
    "committerName": '',
    "fileSize": 0,
    "fileName": "",
    "curVersion": "0",
    // only for display
    "displaying": "0",
    "fileInfo": null,
    "fileStatus": 0,
    "evaluationStatus": 0
  },
  getCommitterName: function getCommitterName() {
    if (this.get("committerId") != 0) {
      return this.get("committerName");
    } else {
      return BabelStr.str(722);
    }
  },
  getFileId: function getFileId() {
    if (this.get("idUsedFileIdAndVersion")) {
      var ids = this.get("fileId").split("--");
      return ids[0];
    }
    return this.get("fileId");
  },
  getFileName: function getFileName() {
    return this.get('fileName');
  },
  isFolder: function isFolder() {
    return false;
  },
  isCurVersion: function isCurVersion() {
    return this.get('curVersion') == this.get('ver');
  },
  setCurVersion: function setCurVersion(ver, versionInfo) {
    // this.set('thumbnailPath', null);
    return this.set('curVersion', ver, {
      versionInfor: versionInfo
    });
  },
  isDispalaying: function isDispalaying() {
    return this.get('displaying') == this.get('ver');
  },
  setDisplayVer: function setDisplayVer(ver) {
    this.set('displaying', ver);
  },
  setFileInfo: function setFileInfo(fileInfo) {
    this.set("fileInfo", fileInfo);
    this.set("idUsedFileIdAndVersion", fileInfo.get("idUsedFileIdAndVersion"));
    this.set("fileId", fileInfo.get("fileId"));
    this.set("fileName", fileInfo.getFileName());
  },
  setIconForDiv: function setIconForDiv($div) {
    if (this.$div != $div) {
      this.$div = $div;
      var that = this;
      _MMFileIconMaker["default"].setIconForDiv(this.get('fileInfo'), this.get("ver"), $div, function () {
        that.$div = null;
      });
    }
    ;
  },
  getFileExtension: function getFileExtension() {
    var extension = "";
    var name = this.getFileName() || "";
    var dotIndex = name.lastIndexOf('.');
    if (dotIndex >= 0) {
      extension = name.substring(dotIndex + 1);
    }
    return extension;
  },
  getCurVersion: function getCurVersion() {
    return this.get('curVersion');
  },
  getVersion: function getVersion() {
    return this.get('ver');
  },
  getOwnerId: function getOwnerId() {
    var fileInfo = this.get('fileInfo');
    if (fileInfo) {
      return fileInfo.get('ownerId');
    }
    ;
  },
  canUpload: function canUpload() {
    if (app.userBeingViewed) {
      return false;
    }
    ;
    var fileInfo = this.get('fileInfo');
    if (fileInfo) {
      return fileInfo.canUploadVersion();
    }
    ;
    return false;
  },
  canDelete: function canDelete() {
    if (app.userBeingViewed) {
      return false;
    }
    ;
    var fileInfo = this.get('fileInfo');
    if (fileInfo && fileInfo.canDelVersion()) {
      return true;
    }
    ;
    return false;
  },
  canDownload: function canDownload() {
    if (app.userBeingViewed) {
      return false;
    }
    ;
    var fileInfo = this.get('fileInfo');
    if (fileInfo) {
      return fileInfo.canDownload();
    }
    ;
    return false;
  },
  isOwner: function isOwner() {
    var fileInfo = this.get('fileInfo');
    if (fileInfo) {
      return fileInfo.isOwner();
    }
    ;
    return false;
  },
  clearUnReadCount: function clearUnReadCount() {
    var fileInfo = this.get('fileInfo');
    if (fileInfo && fileInfo.getCurVersion() == this.get('ver')) {
      fileInfo.clearUnReadCount();
    }
    ;
  },
  isCommitter: function isCommitter() {
    var committer = this.get('committerId');
    var curUserId = app.currentUser.getUserId();
    return committer === curUserId || app.currentUser.isAnonymous();
  },
  getFileStatus: function getFileStatus() {
    return this.get('fileStatus');
  },
  setFileStatus: function setFileStatus(status) {
    this.set('fileStatus', status);
  },
  getFileStatusDes: function getFileStatusDes() {
    var status = this.getFileStatus();
    return MMFileInfo.getFileStatusDescription(status); // eslint-disable-line
  },
  isFileStatusOK: function isFileStatusOK() {
    var status = this.getFileStatus();
    return status == 0;
  },
  readyToDisplay: function readyToDisplay() {
    var fileInfo = this.get('fileInfo');
    if (fileInfo.isArchived()) {
      return fileInfo.readyToDisplay();
    } else {
      var status = this.getFileStatus();
      return status == 0 || status == 2 || status == 3;
    }
  },
  needLoadFromServer: function needLoadFromServer() {
    var status = this.getFileStatus();
    return MMFileInfo.needLoadFromServer(status); // eslint-disable-line
  },
  getFileInfo: function getFileInfo() {
    return this.get("fileInfo");
  },
  isShortcuts: function isShortcuts() {
    var fileInfo = this.getFileInfo();
    if (fileInfo) {
      return fileInfo.isShortcuts();
    }
    ;
    return false;
  },
  getVersionLog: function getVersionLog() {
    return this.get('versionLog');
  },
  setVersionLog: function setVersionLog(log) {
    this.set('versionLog', log);
  },
  setEvaluationStatus: function setEvaluationStatus(status) {
    this.set('evaluationStatus', status);
  },
  getEvaluationStatus: function getEvaluationStatus() {
    return this.get('evaluationStatus');
  },
  isRejected: function isRejected() {
    var status = this.getEvaluationStatus();
    return status == 10;
  },
  isPassed: function isPassed() {
    var status = this.getEvaluationStatus();
    return status == 12;
  },
  isEvaluating: function isEvaluating() {
    var status = this.getEvaluationStatus();
    return status == 11;
  },
  createEvalStrHtml: function createEvalStrHtml() {
    var evalInfo = '';
    if (this.isRejected()) {
      evalInfo = '<span class="version-reject">' + BabelStr.str(134) + '</span>';
    } else if (this.isPassed()) {
      evalInfo = '<span class="version-pass">' + BabelStr.str(433) + '</span>';
    } else if (this.isEvaluating()) {
      evalInfo = '<span class="version-eval">' + BabelStr.str(434) + '...</span>';
    }
    ;
    return evalInfo;
  },
  isInTrash: function isInTrash() {
    var fileInfo = this.get("fileInfo");
    if (fileInfo) {
      return fileInfo.isInTrash();
    }
    ;
    return null;
  },
  getVersionNo: function getVersionNo() {
    var no = this.get("versionNo");
    if (!no) {
      no = Number.parseInt(this.get('ver')) + 1;
    }
    return no;
  },
  isBabelOffice: function isBabelOffice() {
    var ext = this.getFileExtension().toLowerCase();
    return ext == 'sdoc';
  }
});
var _default = exports["default"] = MMVersionInfo;

},{"1184":1184,"1425":1425,"1446":1446,"1449":1449,"1454":1454,"21":21,"296":296}],1425:[function(require,module,exports){
var $ = require(1270);
var lastIndexOf = require(1221);

// `Array.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
// eslint-disable-next-line es/no-array-prototype-lastindexof -- required for testing
$({ target: 'Array', proto: true, forced: lastIndexOf !== [].lastIndexOf }, {
  lastIndexOf: lastIndexOf
});

},{"1221":1221,"1270":1270}],255:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMModelBase = _interopRequireDefault(require(21));
var MDFileAccessInfo = _MMModelBase["default"].extend({
  defaults: {
    "fileId": "0",
    "commentCount": 0,
    "unreadedCommentCount": 0,
    "parent": "0",
    "parentName": "",
    "praisingUsers": [],
    "unreadFileCount": 0,
    //for folder:the number of unread files; for file:unread mark
    "tags": [],
    "focusCount": 0,
    //the number of users who focus this file
    "fileReviewCount": 0,
    //文件评论数量
    "isFocusFile": false,
    //是否为我关注的文件

    'openCount': 0,
    'accessUserCount': 0,
    'downloadCount': 0,
    'hasAppendedPermission': 0,
    accessType: 0
  },
  getId: function getId() {
    return this.get("fileId");
  },
  getAccessType: function getAccessType() {
    return this.get("accessType");
  },
  getCommentCount: function getCommentCount() {
    return this.get("commentCount");
  },
  getUnreadCommentCount: function getUnreadCommentCount() {
    return this.get("unreadedCommentCount");
  },
  getUnreadFileCount: function getUnreadFileCount() {
    return this.get("unreadFileCount");
  },
  getTags: function getTags() {
    return this.get('tags');
  },
  getPraisingUsers: function getPraisingUsers() {
    return this.get("praisingUsers");
  },
  getFocusCount: function getFocusCount() {
    return this.get("focusCount");
  },
  getFileReviewCount: function getFileReviewCount() {
    return this.get('fileReviewCount');
  },
  getIsFocusFile: function getIsFocusFile() {
    return this.get('isFocusFile');
  },
  getOpenCount: function getOpenCount() {
    return this.get('openCount');
  },
  getAccessUserCount: function getAccessUserCount() {
    return this.get('accessUserCount');
  },
  getDownloadCount: function getDownloadCount() {
    return this.get('downloadCount');
  },
  getHasAppendedPermission: function getHasAppendedPermission() {
    return this.get('hasAppendedPermission');
  }
});
var _default = exports["default"] = MDFileAccessInfo;

},{"1184":1184,"1454":1454,"21":21}],240:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMCollectionBase = _interopRequireDefault(require(20));
var _MDArchive = _interopRequireDefault(require(239));
var MDArchiveCollection = _MMCollectionBase["default"].extend({
  model: _MDArchive["default"]
});
var _default = exports["default"] = MDArchiveCollection;

},{"1184":1184,"1454":1454,"20":20,"239":239}],239:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1437);
var _MMModelBase = _interopRequireDefault(require(21));
var _default = exports["default"] = _MMModelBase["default"].extend({
  defaults: {
    accessTime: "",
    accessType: 0,
    // 0在线阅读 ， 1下载， 2复制
    applicantId: "",
    depApproveTime: "",
    depApprover: "0",
    depApproverName: undefined,
    depResult: 0,
    endTime: "",
    entApproveTime: "2018-08-28T09:09:11.000Z",
    entApprover: "0",
    entApproverName: undefined,
    entResult: 0,
    enterpriseId: "7",
    file: {},
    fileId: "5222307364466830",
    id: "4",
    isCrossDepartment: 1,
    //是否跨部门
    applicantName: '',
    department: null,
    dep: '',
    createTime: ''
  },
  getDepResult: function getDepResult(is2line) {
    var depResult = this.get("depResult");
    var depApproverName = this.get('depApproverName');
    switch (depResult) {
      case 0:
        return BabelStr.str(2707);
        break;
      case 1:
        return "<span class=\"green-border-text\">".concat(BabelStr.str(514), "</span> ").concat(is2line ? '<br>' : '', "\uFF08").concat(BabelStr.str(2711), "\uFF1A").concat(depApproverName, "\uFF09");
        break;
      case 2:
        return "<span class=\"red-background-text\">".concat(BabelStr.str(517), "</span> ").concat(is2line ? '<br>' : '', "\uFF08").concat(BabelStr.str(2711), "\uFF1A").concat(depApproverName, "\uFF09");
        break;
    }
  },
  getEntResult: function getEntResult(is2line) {
    var entResult = this.get("entResult");
    var depApproverName = this.get('entApproverName');
    switch (entResult) {
      case 0:
        return BabelStr.str(2707);
        break;
      case 1:
        return "<span class=\"green-border-text\">".concat(BabelStr.str(514), "</span> ").concat(is2line ? '<br>' : '', "\uFF08").concat(BabelStr.str(2711), "\uFF1A").concat(depApproverName, "\uFF09");
        break;
      case 2:
        return "<span class=\"red-background-text\">".concat(BabelStr.str(517), "</span> ").concat(is2line ? '<br>' : '', "\uFF08").concat(BabelStr.str(2711), "\uFF1A").concat(depApproverName, "\uFF09");
        break;
    }
  },
  needOptApply: function needOptApply() {
    if (this.getReadonly()) {
      return false;
    }
    if (this.get('entResult') == 0) {
      return true;
    }
    return false;
  },
  getApplicantName: function getApplicantName() {
    return this.get("applicantName");
  },
  getReadonly: function getReadonly() {
    return this.get("readonly");
  },
  getDepApproverName: function getDepApproverName() {
    return this.get("depApproverName");
  },
  getEntApproverName: function getEntApproverName() {
    return this.get("entApproverName");
  },
  getApproveNameStr: function getApproveNameStr() {
    var result = "";
    if (this.isCrossDepartment()) {
      result += this.getEntApproverName() || BabelStr.str(2650); //企业管理员
    }
    result += this.getDepApproverName() || BabelStr.str(2651); //部门经理
    return result;
  },
  getAccessType: function getAccessType() {
    return this.get("accessType");
  },
  getFileInfo: function getFileInfo() {
    return this.get("file");
  },
  getAccessTypeStr: function getAccessTypeStr() {
    var type = this.getAccessType();
    var result;
    switch (type) {
      case 0:
        result = BabelStr.str(2652);
        break;
      case 1:
        result = BabelStr.str(29);
        break;
      case 2:
        result = BabelStr.str(2653);
        break;
    }
    return result;
  },
  getFileName: function getFileName() {
    var name = this.getFileInfo().getFileName();
    this.set('fileName', name);
    return name;
  },
  getAccessTime: function getAccessTime() {
    return new Date(this.get("accessTime") * 1000).format("yyyy-MM-dd HH:mm");
  },
  getCreateTime: function getCreateTime() {
    return new Date(this.get("createTime") * 1000).format("yyyy-MM-dd HH:mm");
  },
  getEndTime: function getEndTime() {
    return new Date(this.get("endTime") * 1000).format("yyyy-MM-dd HH:mm");
  },
  isCrossDepartment: function isCrossDepartment() {
    return this.get("isCrossDepartment");
  },
  getResultStr: function getResultStr() {
    var sign = 0;
    var depResult = this.get("depResult");
    var entResult = this.get("entResult");
    var resultStr = "";
    if (this.isCrossDepartment()) {
      depResult == entResult == 0 && (sign = 0);
      depResult == entResult == 1 && (sign = 1);
      depResult + entResult > 2 && (sign = 2);
      depResult != entResult && depResult + entResult < 3 && (sign = 3);
    } else {
      sign = this.get("depResult");
    }
    switch (sign) {
      case 0:
        resultStr = BabelStr.str(2707);
        break;
      case 1:
        resultStr = BabelStr.str(2707);
        break;
      case 2:
        resultStr = BabelStr.str(2707);
        break;
      case 3:
        resultStr = BabelStr.str(2707);
        break;
    }
    return resultStr;
  }
});

},{"1184":1184,"1412":1412,"1437":1437,"1454":1454,"21":21}],557:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1498);
var _MDWindowView = _interopRequireDefault(require(93));
var MDCheckEncryptedFolderPwdWinView = _MDWindowView["default"].extend({
  contentTmpl: "\n    <form>\n      <div class=\"form-item row\">\n        <input  name=\"encryped-pwd\" class=\"form-control pwd\" type=\"password\" autocomplete=\"off\" placeholder=\"<%=BabelStr.str(27029)%>\"/>\n        <span class=\"pwd-menu icon icon30 opend\"></span>\n      </div>\n    </form>\n\n  ",
  className: function className() {
    var superCls = _MDWindowView["default"].prototype.className.call(this);
    return superCls + " m-encrypted-check-win";
  },
  events: function events() {
    var superE = _MDWindowView["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click .pwd-menu': this._togglePwd
    });
  },
  _togglePwd: function _togglePwd($e) {
    if ($($e.target).closest('.pwd-menu').hasClass("opend")) {
      $($e.target).siblings('input').attr("type", 'text');
      $($e.target).closest('.pwd-menu').removeClass("opend").addClass('closed');
    } else {
      $($e.target).siblings('input').attr("type", 'password');
      $($e.target).closest('.pwd-menu').addClass("opend").removeClass('closed');
    }
  },
  initProps: function initProps() {
    var props = _MDWindowView["default"].prototype.initProps.call(this);
    return _.extend(props, {
      parentFolder: app.pathRouter.getCurrentFolder(),
      fileId: '',
      fileName: '',
      layer: 100000001
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    opt.title = BabelStr.str(27030, {
      name: opt.fileName
    });
    opt.buttons = [{
      label: BabelStr.str(155),
      // '取消',
      type: 'default'
    }, {
      label: BabelStr.str(154),
      //  '确认',
      type: 'done',
      autoClose: false,
      onClick: function onClick($e) {
        self._submit();
      }
    }];
    _MDWindowView["default"].prototype.initialize.call(this, opt);
    var $buttons = this.getActionButtons();
    this.$doneBtn = $buttons.eq(1);
    this.$('form')[0].addEventListener('submit', function (event) {
      event.preventDefault(); // 阻止默认提交行为
      // 在这里添加你的自定义提交逻辑（如 AJAX 请求）
      console.log('表单提交被拦截，可在此处理逻辑');
      self._submit();
    });
  },
  _submit: function _submit() {
    var self = this;
    var validator = this.$('form').validate();
    if (validator.form()) {
      self._postCreateFolder();
      // self.close();
    }
  },
  _postCreateFolder: function _postCreateFolder(text) {
    var self = this;
    if (this.creating) {
      return;
    }
    this.creating = true;
    this.$doneBtn.prop('disabled', true);
    var pwd = this.$(".pwd").val().trim();
    var params = {
      "fid": this.fileId,
      "encrypted_password": MMCommonFun.encrptDesCbc2(pwd)
    };
    MMEnterpriseController.inputEncryptPassword(params, function (fileInfo) {
      self.successCb();
      self.passed = true;
      self.close();
    }, function (code, msg) {
      if (code == 2) {
        msg = BabelStr.str(7394);
      }
      self.creating = false;
      self.$doneBtn.prop('disabled', false);
      MDMessageView.error(msg, self.$body);
    });
  },
  viewDidRendered: function viewDidRendered() {
    _MDWindowView["default"].prototype.viewDidRendered.call(this);
    this.$('form').validate({
      rules: {
        'encryped-pwd': {
          'required': true,
          'lowpassword': true,
          'password': false
        },
        'encryped-pwd2': {
          'required': true,
          'lowpassword': true,
          'password': false,
          'equalTo': "#js-encryped-pwd"
        }
      },
      messages: {
        'encryped-pwd': {
          'required': BabelStr.str(40009),
          //'请输入新密码',
          'lowpassword': BabelStr.str(2329) // '密码格式错误，密码为6到20位字母，数字组成'
        },
        'encryped-pwd2': {
          'required': BabelStr.str(2352),
          //'请输入确认密码',
          'lowpassword': BabelStr.str(2329),
          // ''密码格式错误，密码为6到20位字母，数字组成',
          'equalTo': BabelStr.str(2353) // ''两次输入的密码不一致'
        }
      }
    });

    // var self = this;
    // setBabelTimeout(function() {
    //   self.$("#nameInput").focus();
    // }, 100);
  },
  _submitOnEnter: function _submitOnEnter($e) {
    var disabled = this.$doneBtn.prop('disabled');
    if (disabled) {
      return;
    }
    if (keycode.isEnterKey($e.keyCode)) {
      this._submit();
      return false;
    }
  }
});
var _default = exports["default"] = MDCheckEncryptedFolderPwdWinView;

},{"1184":1184,"1454":1454,"1498":1498,"93":93}],294:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDWorkbenchColumn = _interopRequireDefault(require(293));
var _MMCollectionBase = _interopRequireDefault(require(20));
var MDWorkbenchColumnCollection = _MMCollectionBase["default"].extend({
  model: _MDWorkbenchColumn["default"]
});
var _default = exports["default"] = MDWorkbenchColumnCollection;

},{"1184":1184,"1454":1454,"20":20,"293":293}],293:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1439);
var _MMModelBase = _interopRequireDefault(require(21));
var MDWorkbenchColumn = _MMModelBase["default"].extend({
  defaults: {
    "title": "",
    "id": "-1",
    'creatorName': '',
    "file": {},
    'time': new Date()
  },
  getId: function getId() {
    return this.get("id");
  },
  getTitle: function getTitle() {
    return this.get("title");
  },
  getcreatorName: function getcreatorName() {
    return this.get("creatorName");
  },
  getFileName: function getFileName() {
    return this.get("file").name;
  },
  getFolderId: function getFolderId() {
    return this.get("file").fileId;
  },
  getTime: function getTime() {
    return new Date(this.get("time") * 1000);
  },
  getParentId: function getParentId() {
    return this.get("file").parent;
  }
});
var _default = exports["default"] = MDWorkbenchColumn;

},{"1184":1184,"1437":1437,"1439":1439,"1454":1454,"21":21}],251:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMCollectionBase = _interopRequireDefault(require(20));
var _MDEvaluationFlowInfo = _interopRequireDefault(require(252));
var MDEvaluationCollection = _MMCollectionBase["default"].extend({
  model: _MDEvaluationFlowInfo["default"]
});
var _default = exports["default"] = MDEvaluationCollection;

},{"1184":1184,"1454":1454,"20":20,"252":252}],242:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMCollectionBase = _interopRequireDefault(require(20));
var _MDBroadcast = _interopRequireDefault(require(241));
var MDBroadcastCollection = _MMCollectionBase["default"].extend({
  model: _MDBroadcast["default"]
});
var _default = exports["default"] = MDBroadcastCollection;

},{"1184":1184,"1454":1454,"20":20,"241":241}],241:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
var _MMModelBase = _interopRequireDefault(require(21));
var _utils = _interopRequireDefault(require(108));
var MDBroadcast = _MMModelBase["default"].extend({
  defaults: {
    'id': -1,
    'creator': '',
    'creatorName': '',
    'createTime': new Date().getTime() / 1000,
    'endTime': '',
    'enterpriseId': -1,
    'text': '',
    'title': ''
  },
  setId: function setId(id) {
    this.set('id', id);
  },
  getId: function getId() {
    return this.get('id');
  },
  setName: function setName(name) {
    this.set('creatorName', name);
  },
  getName: function getName() {
    return this.get('creatorName');
  },
  setTitle: function setTitle(title) {
    this.set('title', title);
  },
  getTitle: function getTitle() {
    return this.get('title');
  },
  setText: function setText(text) {
    this.set('text', text);
  },
  getText: function getText() {
    return this.get('text');
  },
  setCreateTime: function setCreateTime(createTime) {
    this.set('createTime', createTime);
  },
  getCreateTime: function getCreateTime() {
    var time = this.get('createTime');
    time = _utils["default"].formatTime(time, 'yyyy-MM-dd HH:mm');
    return time;
  }
});
var _default = exports["default"] = MDBroadcast;

},{"108":108,"1184":1184,"1437":1437,"1454":1454,"21":21}],204:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1439);
require(1432);
var _MMModelBase = _interopRequireDefault(require(21));
var MDSalonInfo = _MMModelBase["default"].extend({
  defaults: {
    'salonId': 0,
    "speaker": {
      id: app.currentUser.getUserId(),
      name: app.currentUser.getUserName()
    },
    // 缩略图地址
    // "speaker": {id: 100, name:'abc'},
    "fileId": 0,
    "audiences": []
  },
  setFileId: function setFileId(fileId) {
    this.set('fileId', fileId);
  },
  getFileId: function getFileId() {
    return this.get('fileId');
  },
  getSalonId: function getSalonId() {
    return this.get('salonId');
  },
  getAudiences: function getAudiences() {
    return this.get('audiences');
  },
  getSpeaker: function getSpeaker() {
    return this.get('speaker');
  },
  getSpeakerName: function getSpeakerName() {
    return this.get('speaker').name;
  },
  isCurrentUserSpeaker: function isCurrentUserSpeaker() {
    return this.get('speaker').id == app.currentUser.getUserId();
  },
  isCurrentUserAudience: function isCurrentUserAudience() {
    var audiences = this.getAudiences();
    var curUid = app.currentUser.getUserId();
    for (var i = 0; i < audiences.length; i++) {
      if (audiences[i].id == curUid) {
        return true;
      }
    }
    ;
    return false;
  },
  addCurrentUserAudience: function addCurrentUserAudience() {
    var user = app.currentUser;
    var audiences = this.getAudiences();
    audiences.push({
      id: user.getUserId(),
      name: user.getUserName()
    });
  },
  hasMe: function hasMe() {
    return this.isCurrentUserAudience() || this.isCurrentUserSpeaker();
  },
  leaveAudience: function leaveAudience() {
    var curUid = app.currentUser.getUserId();
    this.removeAudienceById(curUid);
  },
  becomeSpeaker: function becomeSpeaker() {
    this.set('speaker', {
      id: app.currentUser.getUserId(),
      name: app.currentUser.getUserName()
    });
  },
  setAudienceToSpeaker: function setAudienceToSpeaker(audience) {
    var audiences = this.getAudiences();
    var speaker = this.getSpeaker();
    audiences.push({
      id: speaker.id,
      name: speaker.name
    });
    this.set('speaker', {
      id: audience.id,
      name: audience.name
    });
    this.removeAudienceById(audience.id);
  },
  removeAudienceById: function removeAudienceById(audienceId) {
    var audiences = this.getAudiences();
    for (var i = 0; i < audiences.length; i++) {
      if (audiences[i].id == audienceId) {
        audiences.splice(i, 1);
      }
    }
    ;
  },
  close: function close() {}
}, {
  className: 'MDSalonInfo'
});
var _default = exports["default"] = MDSalonInfo;

},{"1184":1184,"1432":1432,"1439":1439,"1454":1454,"21":21}],49:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
var _MMViewBase = _interopRequireDefault(require(22));
/**
 *  Load mask view for indicate ajax loading.
 *  Created by manjun.han
 *  2015.9.22
 */

var MDLoadMaskView = _MMViewBase["default"].extend({
  el: '<div class="loadmask"></div>',
  tmpl: '<div class="mask">\
          <button class="icon close"></button>\
          <div class="f-tc body-msg f-none"></div>\
        </div>\
        <div class="indicator"></div>' + '<div class="percent">100%</div>',
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      "click .close": this._close
    });
  },
  getDefault: function getDefault() {
    return {
      style: "style-2",
      render: true,
      bodyMsg: "",
      cls: ""
      // width: 150,
    };
  },
  initialize: function initialize(opt) {
    opt = _.extend({}, this.getDefault(), opt);
    this.closedCallback = opt && opt.closedCallback;
    this._opt = opt;
    if (opt.render) {
      this.render();
    }
    var self = this;
    if (opt.bodyMsg) {
      this.$(".body-msg").show().html(opt.bodyMsg);
      this.$el.addClass("has-title");
    }
    this.$(".mask").width(opt.width);
    this.$el.addClass(opt.cls);
    if (opt.noClose) {
      this.$(".close").remove();
    }
    this.$el.find(".percent").hide();
    // this.$el.find('.mask button').hide();
  },
  _close: function _close(e) {
    this.remove();
    this.closedCallback && this.closedCallback();
  },
  render: function render() {
    _MMViewBase["default"].prototype.render.call(this);
    var $indicator = this.$(".indicator");
    switch (this._opt.style) {
      case "style-1":
        $indicator.append("<div></div><div></div><div></div><div></div>");
        break;
      case "style-2":
        $indicator.append("<div></div><div></div><div></div>").addClass("style-2");
        break;
    }
  },
  show: function show(opt_renderTo) {
    var _this = this;
    opt_renderTo = opt_renderTo || "body";
    this.$el.find(".mask button").off("click");
    this.$el.find(".mask button").on("click", function () {
      _this.remove();
    });
    this.renderTo($(opt_renderTo));
  },
  displayBodyMsg: function displayBodyMsg(msg) {
    var $perDiv = this.$el.find(".body-msg");
    if ($perDiv) {
      $perDiv.show();
      $perDiv.text(msg);
    }
  },
  displayPercent: function displayPercent(percent) {
    var $perDiv = this.$el.find(".percent");
    if ($perDiv) {
      $perDiv.show();
      var perStr = Math.round(percent * 100) + "%";
      $perDiv.text(perStr);
    }
  },
  hidePercent: function hidePercent() {
    var $perDiv = this.$el.find(".percent");
    if ($perDiv) {
      $perDiv.hide();
    }
  },
  initPercent: function initPercent() {
    this.percent = 0;
  }
}, {
  _singleton: null,
  show: function show(opt_renderTo, params) {
    if (!MDLoadMaskView._singleton) {
      if ($(".loadmask").length > 0) {
        if (!params) {
          params = {};
        }
        params = _.extend(params, {
          el: $(".loadmask").get(0),
          render: false
        });
        MDLoadMaskView._singleton = new MDLoadMaskView(params);
      } else {
        MDLoadMaskView._singleton = new MDLoadMaskView(params);
      }
    } else {
      MDLoadMaskView._singleton.remove();
    }
    MDLoadMaskView._singleton.show(opt_renderTo);
  },
  remove: function remove() {
    if (MDLoadMaskView._singleton) {
      MDLoadMaskView._singleton.hidePercent();
      MDLoadMaskView._singleton.remove();
      MDLoadMaskView._singleton = null;
    }
  },
  initPercent: function initPercent() {
    if (MDLoadMaskView._singleton) {
      MDLoadMaskView._singleton.initPercent();
    }
  },
  displayPercent: function displayPercent(percent) {
    if (MDLoadMaskView._singleton) {
      MDLoadMaskView._singleton.displayPercent(percent);
    }
  },
  displayBodyMsg: function displayBodyMsg(msg) {
    if (MDLoadMaskView._singleton) {
      MDLoadMaskView._singleton.displayBodyMsg(msg);
    }
  }
}, {
  className: "MDLoadMaskView"
});
window.MDLoadMaskView = MDLoadMaskView;
var _default = exports["default"] = MDLoadMaskView;

},{"1184":1184,"1417":1417,"1454":1454,"1463":1463,"22":22}],298:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1432);
require(1428);
require(1463);
require(1471);
require(1431);
require(1417);
require(1415);
var _MMFileInfo = _interopRequireDefault(require(297));
var _MMCollectionBase = _interopRequireDefault(require(20));
//
//  jiang
//  2015-8-31
//

//----------------------------------------------------------------------------------------------  MMVersionInfo

//----------------------------------------------------------------------------------------------  MMFileInfoCollection

var MMFileInfoCollection = _MMCollectionBase["default"].extend({
  model: _MMFileInfo["default"],
  delFile: function delFile(ids) {
    var cids = [];
    this.each(function (fileInfo) {
      var fileId = fileInfo.getFileId();
      var parentId = fileInfo.get('parentId');
      for (var i = 0; i < ids.length; i++) {
        if (ids[i] == fileId || ids[i] == parentId) {
          cids.push(fileInfo.cid);
          break;
        }
      }
      ;
    });
    this.remove(cids);
  },
  renameFile: function renameFile(fileId, newName) {
    this.each(function (fileInfo) {
      var fId = fileInfo.getFileId();
      if (fId == fileId) {
        fileInfo.set('fileName', newName);
      }
    });
  },
  multiSortBy: function multiSortBy(sortAttributes, opt_order) {
    if (!_.isArray(sortAttributes) && !_.isString(sortAttributes)) {
      throw new Error("multiSortBy method error , sortAttributes param must be  array or string type");
    }
    opt_order = _.isNumber(opt_order) ? opt_order : 1;
    if (sortAttributes.length) {
      this._sortAttributes = sortAttributes;
    }
    this.models = this._multiSortBy(this.models, sortAttributes, opt_order);
    this._sorted = true;
  },
  // Recursive sort on supplied sort attributes
  _multiSortBy: function _multiSortBy(models, attributes, opt_order) {
    var attr,
      that = this;
    if (!attributes.length) {
      return this.models;
    }
    var stickontopFiles = [];
    var i = 0;
    while (i < models.length) {
      if (models[i].getStickonTop()) {
        stickontopFiles.push(models[i]);
        models.splice(i, 1);
      } else {
        i++;
      }
    }
    ;
    attr = attributes[0];
    //Base case
    if (attributes.length === 1) {
      models = _(models).sortBy(function (model) {
        return model.get(attr);
      });
      // 如果是降序
      if (opt_order >= 1) {
        models = models.reverse();
      }
      if (stickontopFiles.length) {
        for (i = stickontopFiles.length - 1; i >= 0; i--) {
          stickontopFiles[i];
          models.unshift(stickontopFiles[i]);
        }
        ;
      }
      ;
      return models;
    }
    //Splits up models by sort attribute,
    //and then does a recursive sort on each group
    else {
      // underscore sortBy method's default order is asc
      models = _(models).chain().sortBy(function (model) {
        return model.get(attr);
      }).groupBy(function (model) {
        return model.get(attr);
      }).toArray().value();
      // 如果是降序
      if (opt_order >= 1) {
        models = models.reverse();
      }
      attributes = _.last(attributes, attributes.length - 1);
      _(models).each(function (modelSet, index) {
        models[index] = that._multiSortBy(models[index], attributes, opt_order);
      });
      var result = _(models).flatten();
      if (stickontopFiles.length) {
        for (i = stickontopFiles.length - 1; i >= 0; i--) {
          stickontopFiles[i];
          result.unshift(stickontopFiles[i]);
        }
        ;
      }
      ;
      return result;
    }
  },
  // each: function(iterator) {
  //   _.each(this.models, iterator)
  // },

  resetReference: function resetReference() {
    var _this = this;
    _.each(this.models, function (model) {
      _this._byId[model.cid] = model;
      var id = _this.modelId(model.attributes);
      if (id != null) _this._byId[id] = model;
    });
  },
  sort: function sort(options) {
    if (options.isNative) {
      _MMCollectionBase["default"].prototype.sort.call(this, {
        silent: true
      });
      return;
    }
    var stickontopFiles = [];
    var stickSart = 0;
    var i = 0;
    var tempLength = 0;
    while (i < this.models.length) {
      if (this.models[i].getStickonTop()) {
        stickontopFiles.push(this.models[i]);
        tempLength = this.models.length;
        this.remove(this.models[i], {
          silent: true
        });
        if (tempLength == this.models.length) {
          this.models.splice(i, 1);
        }
      } else {
        i++;
      }
    }
    ;
    stickontopFiles.sort(function (a, b) {
      if (a.get('stickTime') < b.get('stickTime')) {
        return -1;
      }
      ;
      if (a.get('stickTime') == b.get('stickTime')) {
        return 0;
      }
      ;
      if (a.get('stickTime') > b.get('stickTime')) {
        return 1;
      }
      ;
    });
    if (this.needPage) {
      this.end = 50;
    }
    _MMCollectionBase["default"].prototype.sort.call(this, {
      silent: true
    });
    if (stickontopFiles.length) {
      for (var i = 0; i < stickontopFiles.length; i++) {
        this.add(stickontopFiles[i], {
          at: 0,
          silent: true
        });
      }
      ;
    }
    ;
    if (!options.sort) {
      this.trigger('sort');
    }
  },
  sortByName: function sortByName() {
    MMFileInfoCollection.sortByName(this.models);
  },
  addFileBlowStickonTop: function addFileBlowStickonTop(newfileInfo) {
    if (!newfileInfo) return;
    var pos = -1;
    var fileExists = this.find({
      fileId: newfileInfo.fileId
    });
    if (!fileExists) {
      this.each(function (fileInfo, index) {
        if (fileInfo.getStickonTop()) {
          pos = index;
        }
        ;
      });
      this.add(newfileInfo, {
        at: pos + 1
      });
    } else {}
  },
  filterFiles: function filterFiles(filter) {
    var self = this;
    var files = this.filter(function (file) {
      if (file.matchFilter(filter)) {
        return true;
      }
    });
    return new MMFileInfoCollection(files);
  }
}, {
  className: "MMFileInfoCollection",
  sortByName: function sortByName(models) {
    models.sort(function (file1, file2) {
      var fileName1 = file1.get('fileName').toLowerCase();
      var fileName2 = file2.get('fileName').toLowerCase();
      return fileName1.localeCompare(fileName2, 'zh');
    });
    return models;
  }
});
var _default = exports["default"] = MMFileInfoCollection;

},{"1184":1184,"1415":1415,"1417":1417,"1428":1428,"1431":1431,"1432":1432,"1454":1454,"1463":1463,"1471":1471,"20":20,"297":297}],1431:[function(require,module,exports){
'use strict';
var $ = require(1270);
var uncurryThis = require(1281);
var aCallable = require(1203);
var toObject = require(1387);
var lengthOfArrayLike = require(1317);
var deletePropertyOrThrow = require(1250);
var toString = require(1393);
var fails = require(1271);
var internalSort = require(1228);
var arrayMethodIsStrict = require(1223);
var FF = require(1257);
var IE_OR_EDGE = require(1261);
var V8 = require(1267);
var WEBKIT = require(1268);

var test = [];
var nativeSort = uncurryThis(test.sort);
var push = uncurryThis(test.push);

// IE8-
var FAILS_ON_UNDEFINED = fails(function () {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function () {
  test.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var STABLE_SORT = !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 70;
  if (FF && FF > 3) return;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test.push({ k: chr + index, v: value });
    }
  }

  test.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test.length; index++) {
    chr = test[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString(x) > toString(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$({ target: 'Array', proto: true, forced: FORCED }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable(comparefn);

    var array = toObject(this);

    if (STABLE_SORT) return comparefn === undefined ? nativeSort(array) : nativeSort(array, comparefn);

    var items = [];
    var arrayLength = lengthOfArrayLike(array);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) push(items, array[index]);
    }

    internalSort(items, getSortCompare(comparefn));

    itemsLength = lengthOfArrayLike(items);
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) deletePropertyOrThrow(array, index++);

    return array;
  }
});

},{"1203":1203,"1223":1223,"1228":1228,"1250":1250,"1257":1257,"1261":1261,"1267":1267,"1268":1268,"1270":1270,"1271":1271,"1281":1281,"1317":1317,"1387":1387,"1393":1393}],292:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMCollectionBase = _interopRequireDefault(require(20));
var _MDTransmittal = _interopRequireDefault(require(291));
var MDTransmittalCollection = _MMCollectionBase["default"].extend({
  model: _MDTransmittal["default"]
});
var _default = exports["default"] = MDTransmittalCollection;

},{"1184":1184,"1454":1454,"20":20,"291":291}],291:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMModelBase = _interopRequireDefault(require(21));
var MDTransmittal = _MMModelBase["default"].extend({
  defaults: {
    "id": undefined,
    "sendTo": undefined,
    "senderId": undefined,
    "fileStyle": undefined,
    'confirmerId': undefined,
    "committerId": undefined,
    "needSign": undefined,
    "comment": undefined,
    "copyTo": undefined,
    "signedBy": undefined,
    "signedByName": undefined,
    "SignerPosition": undefined,
    "signComment": undefined
  },
  getId: function getId() {
    return this.get('id');
  },
  getSenderName: function getSenderName() {
    return this.get('name');
  },
  getStatusStr: function getStatusStr() {
    var status = this.get('status');
    if (status == 0) {
      return "<span class=\"red\">".concat(BabelStr.str(5242), "</span>");
    } else {
      return BabelStr.str(5243);
    }
  }
});
var _default = exports["default"] = MDTransmittal;

},{"1184":1184,"1454":1454,"21":21}],273:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMCollectionBase = _interopRequireDefault(require(20));
var _MDMolaUser = _interopRequireDefault(require(272));
/**
 * Modified by manjun.han 适配cmd
 * 2016.12.5
 */

var MDMolaUserCollection = _MMCollectionBase["default"].extend({
  model: _MDMolaUser["default"]
});
var _default = exports["default"] = MDMolaUserCollection;

},{"1184":1184,"1454":1454,"20":20,"272":272}],267:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMCollectionBase = _interopRequireDefault(require(20));
var _MDMacAddress = _interopRequireDefault(require(266));
var MDMacAddressCollection = _MMCollectionBase["default"].extend({
  model: _MDMacAddress["default"]
});
var _default = exports["default"] = MDMacAddressCollection;

},{"1184":1184,"1454":1454,"20":20,"266":266}],266:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMModelBase = _interopRequireDefault(require(21));
var _utils = _interopRequireDefault(require(108));
var MDMacAddress = _MMModelBase["default"].extend({
  defaults: {
    "poolName": "",
    "id": "-1"
  },
  getId: function getId() {
    return this.get("id");
  },
  getName: function getName() {
    return this.get("poolName");
  }
});
var _default = exports["default"] = MDMacAddress;

},{"108":108,"1184":1184,"1454":1454,"21":21}],257:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMCollectionBase = _interopRequireDefault(require(20));
var _MDFileLog = _interopRequireDefault(require(256));
var MDFileLogCollection = _MMCollectionBase["default"].extend({
  model: _MDFileLog["default"]
});
var _default = exports["default"] = MDFileLogCollection;

},{"1184":1184,"1454":1454,"20":20,"256":256}],256:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1477);
require(1492);
require(1412);
require(1439);
require(1424);
require(1461);
var _MMModelBase = _interopRequireDefault(require(21));
/**
 * Modified by jichao
 * 2016.12.5
 */

// import MDAnswerSendFileWinView from '../moladisk/views/notification/MDAnswerSendFileWinView.js'
var MDFileLog = _MMModelBase["default"].extend({
  defaults: function defaults() {
    return {
      "userId": 0,
      "userName": "",
      "formatObj": null,
      "operationType": -1,
      "time": new Date()
    };
  },
  initialize: function initialize(opt) {
    _MMModelBase["default"].prototype.initialize.call(this, opt);
    if (this.getFormatObj()) {
      this.set("formatStr", this.initFormatStr());
      this.set("time", new Date(this.get("time") * 1000));
      this.set("userName", this.getFormatObj()["creator"]["str"]);
    }
  },
  getFormatStr: function getFormatStr() {
    return this.get("formatStr");
  },
  initFormatStr: function initFormatStr() {
    var formatObj = this.getFormatObj();
    if (formatObj) {
      var formatStr = formatObj.formatStr;
      var self = this;
      formatStr = formatStr.replace(/{(\w*)}/g, function ($1, key) {
        var logType = self.getOperationType();
        var value = formatObj[key];
        var count = self.getCount();
        return self.formatValue(logType, key, value, count);
      });
      if (this.fun) {
        formatStr = "<a  onClick=\"".concat(this.fun, "\" target = _blank class = \" \">").concat(formatStr, "</a>");
      }
      return "<div class=\"log-item \">".concat(formatStr, "</div>");
    } else if (this.get("creationInfo")) {
      return "<div class=\"log-item \">".concat(BabelStr.str(8355), "</div>");
    }
  },
  formatValue: function formatValue(logType, key, value, count) {
    var str = '';
    var str1 = '';
    var fun;
    var userArr = [];
    if (!value && key != "webSendFile") {
      return '';
    }
    if (this.get("creationInfo")) {
      str = "创建了本文件";
    } else if (key == "creator") {
      return value.str;
    } else if (key == "parentClass" || key == "class") {
      str = _.escape(_.unescape(value["str"]));
      var fid = value["id"];
      str = '<span onclick="app.pathRouter.openNetTab(\'/archive.do#archiveLibrary/1/' + fid + '\')" class = "blue-text-btn ' + key + '">' + str + '</span>';
    } else if (key == "parent" || key == "file" || key == "srcFile" || key == "destFile" || key == 'destinationFile') {
      if (logType == 402) {
        value = this.getFormatObj()['file'];
        str1 = _.escape(_.unescape(value["str"]));
        var sendId = this.getSendId();
        fun = "window.showMDSendFileWinView(".concat(sendId, ")");
        str = "<span class='text-button done'>".concat(str1, "</span>");
      } else {
        str = _.escape(_.unescape(value["str"] || value['fileName']));
        var fid = value["id"] || value['fileId'];
        str = '<span onclick="app.pathRouter.openNewTabByFileId(' + fid + ')" class = "blue-text-btn ' + key + '">' + str + '</span>';
      }
    } else if (key == "quickSendFile") {
      str1 = _.escape(_.unescape(value["str"]));
      fun = "window.showMDAnswerSendFileWinView(".concat(value['quickSendId'], ",'").concat(str1, "')");
      // var url = window.location.origin + "/main.do#file/"+ (value["id"] || value['fileId']);
      // str = '<a data-id="'+value['quickSendId']+'" onClick="window.showMDAnswerSendFileWinView('+value['quickSendId']+','+str1+')" target = _blank class = "blue-text-btn '+key+'">'+str1+'</a>'
      str = "<span>".concat(str1, "</span>");
      // str = `<a data-id="${value['quickSendId']}" onClick="window.showMDAnswerSendFileWinView(${value['quickSendId']},'${str1}')" target = _blank class = "blue-text-btn ${key}">${str1}</a>`
    } else if (key == "department" || key == "departName") {
      str = "/enterpriseIndex.do#depart/" + value["id"];
      str = '<span onclick="app.pathRouter.openNetTab(' + str + ')" class = "blue-text-btn ' + key + '">' + value["str"] + '</span>';
    } else if (key == "secretFile") {
      str1 = _.escape(_.unescape(value["str"]));
      if (value['teamMark'] == 5) {
        fun = "window.showMDProjectSecretReviewWinView(".concat(value['id'], ",'").concat(str1, "')");
      } else if (value['teamMark'] == 7) {
        fun = "window.showMDhqsmProjectSecretReviewWinView(".concat(value['id'], ",'").concat(str1, "')");
      } else {
        fun = "window.showMDSecretReviewWinView(".concat(value['id'], ",'").concat(str1, "')");
      }
      str = "<span>".concat(str1, "</span>");
      // str = `<a data-id="${value['id']}" onClick="${fun}(${value['id']},'${str1}')" target = _blank class = "blue-text-btn ${key}">${str1}</a>`
    } else if (key == "user") {
      str1 = _.escape(_.unescape(value["str"]));
      if (!!value['userType'] == 0) {
        str = "window.showMEEditInnerPersonWindowView(".concat(value['id'], ")");
        str = "<a  onClick=\"".concat(str, "\" target = _blank class = \"blue-text-btn ").concat(key, " \">").concat(str1, "</a>");
      } else if (value['userType'] == 1) {
        str = "/enterpriseIndex.do#depart/" + value["id"];
        str = '<span onclick="app.pathRouter.openNetTab(' + str + ')" class = "blue-text-btn ' + key + '">' + value["str"] + '</span>';
      } else {
        str = "window.showMDOneGroupNavWinView(".concat(value['id'], ")");
        str = "<a  onClick=\"".concat(str, "\" target = _blank class = \"blue-text-btn ").concat(key, " \">").concat(str1, "</a>");
      }
      str = "<span>".concat(str, "</span>");
    } else if (key == "targetUsers" && logType != 402) {
      _.each(value.users, function (user) {
        if (!!user['userType'] == 0) {
          str1 = "window.showMEEditInnerPersonWindowView(".concat(user['userId'], ")");
          str1 = "<a  onClick=\"".concat(str1, "\" target = _blank class = \"blue-text-btn user \">").concat(user.name, "</a>");
        } else if (user['userType'] == 1) {
          str1 = "/enterpriseIndex.do#depart/" + user['userId'];
          str1 = '<span onclick="app.pathRouter.openNetTab(' + str1 + ')" class = "blue-text-btn user">' + user["name"] + '</span>';
        } else {
          str1 = "window.showMDOneGroupNavWinView('".concat(user['userId'], "')");
          str1 = "<a  onClick=\"".concat(str1, "\" target = _blank class = \"blue-text-btn user \">").concat(user.name, "</a>");
        }
        userArr.push("<span>".concat(str1, "</span>"));
      });
      str = userArr.join('、');
    } else if (key == "files" || key == 'copyFiles') {
      if (value.files.length) {
        var file = value.files[0];
        var url = file["fileId"];
        str = '<span onclick="app.pathRouter.openNewTabByFileId(' + url + ')" class = "blue-text-btn file">' + (file.name || file.fileName) + '</span>';
        if (count && count > 1) {
          str += BabelStr.str(1048, {
            count: count
          });
        } else if (value.files.length > 1) {
          str += BabelStr.str(1048, {
            count: value.files.length
          });
        }
      } else {
        str = _.escape(_.unescape(value["str"]));
        var url = value["id"];
        str = '<span onclick="app.pathRouter.openNewTabByFileId(' + url + ')" target = _blank class = "blue-text-btn ' + key + '">' + str + '</span>';
      }
    } else if (value.type == 2) {
      str = _.escape(_.unescape(value["str"]));
      str = '<span class = "text-button done ' + key + '">' + str + '</span>';
    } else {
      str = _.escape(_.unescape(value["str"]));
      str = '<span class = "' + key + '">' + str + '</span>';
    }
    if (fun) {
      this.fun = fun;
    }
    return str;
  },
  getOperationType: function getOperationType() {
    return this.get("operationType");
  },
  getFormatObj: function getFormatObj() {
    return this.get("formatObj");
  },
  getTime: function getTime() {
    return this.get("time");
  },
  getUserName: function getUserName() {
    return this.get("userName");
  },
  getUserId: function getUserId() {
    return this.get("userId");
  },
  getSendId: function getSendId() {
    var content = this.get("content");
    if (content) {
      content = JSON.parse(content);
      return content.sendId || '';
    } else {
      return '';
    }
  },
  getCount: function getCount() {
    var content = this.get("content");
    if (content) {
      content = JSON.parse(content);
      return content.count || 0;
    } else {
      return 0;
    }
  },
  setFileCreationInfo: function setFileCreationInfo(creationInfo) {
    this.set("creationInfo", creationInfo);
    this.set("formatStr", this.initFormatStr());
  }
});
var _default = exports["default"] = MDFileLog;

},{"1184":1184,"1412":1412,"1424":1424,"1437":1437,"1439":1439,"1454":1454,"1461":1461,"1477":1477,"1492":1492,"21":21}],258:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1430);
require(1463);
require(1498);
var EnlargeFactor = 1.5;
var MDFileTypeIconMap = {
  _fileTypeList: [['pdf', 'cloud', "ofd", "sdoc", "link", "survey"], ['doc|docx|dot|dotx|docm|dotm', 'ppt|pptx|pot|potx|ppsx|pps|pptm|potm|ppsm|thmx|ppam|ppa', 'xlsx|xls|xlt|xltx|csv|xlsb|xlsm|xltm|xml|xlam|xla|prn|dif|slk', 'vsdx', 'mpp', 'drawio', 'km|xmind'], ["key", "pages", "numbers", 'wps|wpt', 'dps|dpt', 'et|eet'], ['ps|psd', 'xfl|indd', 'sketch'], ['dxf|dws|dwt', 'dwg'], ['3ds|max|skp|3mf|ply|obj|fbx|stl|gltf|stl', 'dae'], ['bat|sh|c|h|hpp|cpp|java|srt|m|mm|py|sql|bash', 'txt', 'rtf', 'epub', 'md'], ['asp|php|net|jsp', 'html', 'htm', 'js', 'css'], ['avif|webp|pns|tga|ico|icns|wbmp|rle|dib|jpf|jps|jpe|pcx|pxr|pod|pxr|hdr|iff|raw|pbm|sct|pic|pict|pct|wmf|pdd|cgm|mpo|emf|dcm|heic', 'bmp', 'pcm', 'tif|tiff', 'gif', 'jpeg|jpg', 'png'], ['', 'ai', 'cdr', 'eps', 'svg'], ['x3f|mrw|chm|crw|pef', 'nef', 'pef', 'dng', 'cr2', 'arw'], ['m4v|webm|3gp|3gpp|wmv|rm|asf|mpeg|mpg|m2ts', 'mp4', 'avi', 'mov', 'mkv', 'flv', 'f4v', 'swf', 'rmvb', 'mts'], ['', 'cd', 'wav', 'mp3', 'midi', 'wma', 'amr', 'ape', 'flac', 'aac'], ['', 'rar', 'zip'], ['eml|mime|msg|pst|mail', 'ttf|otf', 'apk', 'dmg', 'fla', 'ae', '', 'sai']],
  getPositionForExt: function getPositionForExt(ext, size) {
    var s_size = 40.0;
    var ratio = 1.0;
    if (!size) {
      size = 40;
    }
    ratio = size / s_size;
    ext = ext.toLowerCase();
    var y = -1;
    var x = -1;
    var fileTypeList = MDFileTypeIconMap._fileTypeList;
    for (var i = 0; i < fileTypeList.length; i++) {
      var fileRow = fileTypeList[i];
      x = -1;
      for (var j = 0; j < fileRow.length; j++) {
        var types = fileRow[j].split('|');
        var res = _.some(types, function (type) {
          if (type === ext) {
            return true;
          }
          ;
        });
        if (res) {
          x = j;
          break;
        }
      }
      ;
      if (x != -1) {
        y = i;
        break;
      }
      ;
    }
    ;
    if (y != -1) {
      x = -x * s_size;
      y = -y * s_size;
    } else {
      x = -1 * s_size;
      y = 0;
    }
    x *= ratio;
    y *= ratio;
    return {
      x: x,
      y: y
    };
  },
  getPositionForFileName: function getPositionForFileName(name, size) {
    name = name.trim();
    var ext = name.split('.').pop();
    return MDFileTypeIconMap.getPositionForExt(ext, size);
  },
  getIconPositionForFolder: function getIconPositionForFolder(fileInfo, size) {
    var s_size = 40.0;
    var ratio = 1.0;
    if (!size) {
      size = 40;
    }
    ratio = size / s_size;
    if (fileInfo.isEncryptedFolder()) {
      return {
        x: -5 * 40 * ratio,
        y: -18 * 40 * ratio
      };
    } else if (fileInfo.isBackupPolicyFolder()) {
      return {
        x: -4 * 40 * ratio,
        y: -18 * 40 * ratio - 1
      };
    } else if (fileInfo.isMaterialClass()) {
      return {
        x: -3 * 40 * ratio,
        y: -18 * 40 * ratio
      };
    } else if (fileInfo.isMaterialLibrary() || fileInfo.isMaterialLibraryFolder()) {
      return {
        x: -1 * 40 * ratio,
        y: -18 * 40 * ratio
      };
    } else if (fileInfo.isTeamFolder()) {
      // if (!fileInfo.showMyFileColor()) {
      //   return {
      //     x: -1 * 40,
      //     y: -16 * 40
      //   }
      // } else {
      return {
        x: -2 * 40 * ratio,
        y: -16 * 40 * ratio
      };
      // }
    } else if (fileInfo.isManuscriptBox()) {
      return {
        x: -7 * 40 * ratio,
        y: -16 * 40 * ratio
      };
    } else if (fileInfo.isDepartmentFolder()) {
      return {
        x: -6 * 40 * ratio,
        y: (-16 * 40 + 1) * ratio
      };
    } else if (fileInfo.isEpPublicFolder()) {
      return {
        x: -8 * 40 * ratio,
        y: -16 * 40 * ratio
      };
    } else if (fileInfo.isProject()) {
      return {
        x: -0 * 40 * ratio,
        y: -15 * 40 * ratio
      };
    } else if (fileInfo.isHQSMProject()) {
      return {
        x: -0 * 40 * ratio,
        y: -18 * 40 * ratio
      };
    } else if (fileInfo.isArchiveHouse) {
      return {
        x: -9 * 40 * ratio,
        y: -16 * 40 * ratio
      };
    } else if (fileInfo.isReadingRoom()) {
      return {
        x: -3 * 40 * ratio,
        y: -15 * 40 * ratio
      };
    } else if (fileInfo.isSharing()) {
      return {
        x: 0,
        y: -16 * 40 * ratio
      };
    } else {
      return {
        x: 0,
        y: -16 * 40 * ratio
      };
    }
  },
  getIconPositionForFilInfo: function getIconPositionForFilInfo(fileInfo, size, bkgroundSize) {
    if (!fileInfo) {
      return null;
    }
    ;
    var s_size = 40.0;
    var ratio = 1.0;
    if (!size) {
      size = 40;
    }
    ratio = size / s_size;
    bkgroundSize.x = 400 * ratio;
    bkgroundSize.y = 800 * ratio;
    if (fileInfo.isFolder()) {
      return MDFileTypeIconMap.getIconPositionForFolder(fileInfo, size);
    } else {
      var fileName = fileInfo.getFileName();
      if (fileInfo.isShortcuts()) {
        fileName = 'xx.' + fileInfo.get('linkedFileExt');
      }
      ;
      if (fileInfo.getLinkFileUrl()) {
        fileName = 'xx.link';
      }
      ;
      return MDFileTypeIconMap.getPositionForFileName(fileName, size);
    }
  }
};
var _default = exports["default"] = MDFileTypeIconMap;

},{"1430":1430,"1454":1454,"1463":1463,"1498":1498}],295:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var MMFileConvertStatus = {
  OK: 0,
  UnConvert: 1,
  Converting: 2,
  WaitConvert: 3,
  UseSmallImageFirst: 4,
  CanNotConvert: 10,
  HasPassword: 11,
  FileDamaged: 12,
  UploadToCloudFail: 13,
  ConvertFileSizeBeyondLimit: 14,
  PowerPointNoSliders: 15
};
var _default = exports["default"] = MMFileConvertStatus;

},{"1454":1454}],254:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Evaluation status type
 * jiang
 * 2015-5-10
 */

var MDEvaluationStatus = {
  NOT_START: 0,
  EVALUATING: 11,
  REJECTED: 10,
  PASSED: 12
};
window.MDEvaluationStatus = MDEvaluationStatus;
var _default = exports["default"] = MDEvaluationStatus;

},{"1454":1454}],90:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var PropType = {
  Number: 0,
  String: 1,
  Date: 2
};
var _default = exports["default"] = PropType;

},{"1454":1454}],289:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1466);
require(1503);
require(1500);
var _app = _interopRequireDefault(require(17));
var _MMModelBase = _interopRequireDefault(require(21));
var _regexp = _interopRequireDefault(require(106));
//
//  Team info
//
//  created by jiang, and modified by tobias, and tobias is responsible for this file.
// 2016-3-2
//

var MDTeamInfo = _MMModelBase["default"].extend({
  defaults: {
    "id": -1,
    "name": "",
    "alias": "",
    "description": "",
    "memberLimit": 10,
    "usedSpace": '',
    "totalSpace": '',
    "createTime": new Date().getTime(),
    "creatorId": 0,
    "creatorName": '',
    "creatorMail": '',
    "folderId": -1,
    //

    "payTime": 0,
    "permission": 0,
    "phone": "",
    "validationCode": "",
    "price": 0,
    "expireTime": 0
  },
  getDescription: function getDescription() {
    return this.get('description');
  },
  getId: function getId() {
    return this.get('id');
  },
  setId: function setId(id) {
    return this.set('id', id);
  },
  getDisplayName: function getDisplayName() {
    var alias = this.get('alias');
    if (alias && alias.length) {
      return alias;
    }
    return this.get('name');
  },
  getName: function getName() {
    return this.get('name');
  },
  setName: function setName(name) {
    return this.set('name', name);
  },
  getDiscription: function getDiscription() {
    return this.get('description');
  },
  setDiscription: function setDiscription(desc) {
    return this.set('description', desc);
  },
  getMemLimit: function getMemLimit() {
    return this.get('memberLimit');
  },
  setMemLimit: function setMemLimit(limit) {
    return this.set('memberLimit', limit);
  },
  getCreatorId: function getCreatorId() {
    return this.get('creatorId');
  },
  getCreatorName: function getCreatorName() {
    return this.get('creatorName');
  },
  getCreatorMail: function getCreatorMail() {
    var creatorMail = this.get('creatorMail');
    if (!_regexp["default"].isEmail(creatorMail)) {
      return '--';
    }
    return creatorMail;
  },
  getFolderId: function getFolderId() {
    return this.get('folderId');
  },
  isNeedToPay: function isNeedToPay() {
    return false;
  },
  isCurUserManager: function isCurUserManager() {
    return this.get('permission') == 65535;
  },
  getPhone: function getPhone() {
    return this.get('phone');
  },
  setPhone: function setPhone() {
    this.set('phone');
  },
  setValidationCode: function setValidationCode(code) {
    this.set('validationCode', code);
  },
  getValidationCode: function getValidationCode() {
    return this.get('validationCode');
  },
  setJoined: function setJoined() {
    this.set('joined', 1);
  },
  setFolderId: function setFolderId(folderId) {
    this.set('folderId', folderId);
  },
  isJoined: function isJoined() {
    return this.get('joined');
  },
  getPrice: function getPrice() {
    var price = this.get('price');
    if (isNaN(price)) {
      price = parseInt(price);
    }
    ;
    return price;
  },
  isFree: function isFree() {
    var today = new Date();
    var expireDate = this.get('expireTime');
    expireDate = new Date().setTime(expireDate * 1000);
    var remain = (expireDate - today) / (365 * 24 * 60 * 60 * 1000);
    if (remain > 10) {
      return true;
    }
    ;
    return false;
  },
  isCreatedByMe: function isCreatedByMe() {
    var curUserId = _app["default"].currentUser.getUserId();
    if (curUserId == this.getCreatorId()) {
      return true;
    }
    ;
    return false;
  },
  getRemainDay: function getRemainDay(success, fail) {
    var self = this;
    MDTeamDataController.getSystemTimeFromServer(function (time) {
      var today = time * 1000;
      var days = self.calculateRemainDay(today);
      success(days);
    }, function () {
      if (fail) {
        fail();
      }
      ;
    });
  },
  calculateRemainDay: function calculateRemainDay(today) {
    var expireDate = this.get('expireTime');
    expireDate = new Date().setTime(expireDate * 1000);
    var remain = expireDate - today;
    if (remain < 0) {
      remain = 0;
    }
    ;
    var days = remain / (1000 * 60 * 60 * 24);
    return days;
  },
  isExpire: function isExpire() {
    return this.calculateRemainDay(new Date()) == 0;
  },
  setUnpaidOrderInfo: function setUnpaidOrderInfo(orderInfo) {
    this.unpaidOrder = orderInfo;
    if (orderInfo) {
      orderInfo.setTeamName(this.getDisplayName());
    }
    ;
  },
  getUnpaidOrderInfo: function getUnpaidOrderInfo() {
    if (this.unpaidOrder) {
      this.unpaidOrder.set('description', this.unpaidOrder.get('product')['description']);
      this.unpaidOrder.set('id', this.unpaidOrder.get('orderId'));
    }
    ;
    return this.unpaidOrder;
  }
});
var _default = exports["default"] = MDTeamInfo;

},{"106":106,"1184":1184,"1437":1437,"1454":1454,"1466":1466,"1500":1500,"1503":1503,"17":17,"21":21}],1500:[function(require,module,exports){
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description
'use strict';
var $ = require(1270);
var DESCRIPTORS = require(1251);
var global = require(1287);
var uncurryThis = require(1281);
var hasOwn = require(1288);
var isCallable = require(1302);
var isPrototypeOf = require(1335);
var toString = require(1393);
var defineProperty = require(1328).f;
var copyConstructorProperties = require(1238);

var NativeSymbol = global.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
  var thisSymbolValue = uncurryThis(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);

  defineProperty(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

},{"1238":1238,"1251":1251,"1270":1270,"1281":1281,"1287":1287,"1288":1288,"1302":1302,"1328":1328,"1335":1335,"1393":1393}],288:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMCollectionBase = _interopRequireDefault(require(20));
var _MDTag = _interopRequireDefault(require(287));
/**
 * 标签企业
 * Created by manjun.han
 * 2017.2.7
 */

var MDTagCollection = _MMCollectionBase["default"].extend({
  model: _MDTag["default"]
});
var _default = exports["default"] = MDTagCollection;

},{"1184":1184,"1454":1454,"20":20,"287":287}],287:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
require(1424);
require(1446);
var _MMModelBase = _interopRequireDefault(require(21));
/**
 * 标签企业
 * Created by manjun.han
 * 2017.1.19
 */

var MDTag = _MMModelBase["default"].extend({
  defaults: function defaults() {
    return {
      'id': undefined,
      'text': undefined,
      'color': undefined,
      'enterpriseId': undefined,
      'creatorId': undefined,
      'fileId': undefined,
      'customColor': undefined,
      'quoteNum': 0,
      //
      // UI state
      //
      'draggable': false,
      'selected': false,
      'canDelete': true,
      'canAdd': true,
      'enterpriseUsed': false
    };
  },
  initialize: function initialize(tagData) {
    tagData = tagData || {};
    this.initWithTagData(tagData);
  },
  initWithTagData: function initWithTagData(tagData) {
    this.set('id', tagData['tagId']);
    this.set('text', tagData['tagStr']);
    this.set('color', tagData['tagColor']);
    this.set('customColor', tagData['tagColor']);
    this.set('userId', tagData['creatorId']);
    this.set('creatorId', tagData['creatorId']);
    this.set('quoteNum', tagData['numOfReference'] || 0);
  },
  getFileTagCreatorId: function getFileTagCreatorId() {
    return this.get('creatorId');
  },
  canDelete: function canDelete() {
    return this.get('canDelete');
  },
  canAdd: function canAdd() {
    return this.get('canAdd');
  },
  setWithClientData: function setWithClientData(tagInfo) {
    this.set(tagInfo);
  },
  setId: function setId(tagId) {
    this.set('id', tagId);
  },
  getEpId: function getEpId() {
    return this.get('enterpriseId');
  },
  getUserId: function getUserId() {
    return this.get('userId');
  },
  getFileId: function getFileId() {
    return this.get('fileId');
  },
  getColor: function getColor() {
    var color = this.get('color');
    if (typeof color === 'string') {
      return color;
    }
    return '#' + ('00000' + (color | 0).toString(16)).substr(-6);
  },
  setColor: function setColor(color) {
    this.set("tagColor", color);
    this.set("color", color);
  },
  getId: function getId() {
    return this.get('id');
  },
  getText: function getText() {
    return this.get('text');
  },
  setText: function setText(text) {
    this.set("text", text);
  },
  getCustomColor: function getCustomColor() {
    return this.get('customColor');
  },
  getColorNum: function getColorNum() {
    var hexCode = this.getColor();
    return MDTag.getColorNum(hexCode);
  },
  setSelected: function setSelected(selected) {
    this.set('selected', selected);
  },
  isSelected: function isSelected() {
    return this.get('selected');
  },
  increaseQuoteNumBy: function increaseQuoteNumBy(num) {
    var quoteNum = this.get('quoteNum');
    quoteNum = _.isNumber(quoteNum) ? quoteNum : 0;
    num = quoteNum + num;
    this.set('quoteNum', num);
  },
  decreaseQuoteNumBy: function decreaseQuoteNumBy(num) {
    var quoteNum = this.get('quoteNum');
    quoteNum = _.isNumber(quoteNum) ? quoteNum : 0;
    num = quoteNum - num;
    num = num < 0 ? 0 : num;
    this.set('quoteNum', num);
  },
  getQuoteNum: function getQuoteNum() {
    return this.get('quoteNum');
  },
  setQuoteNum: function setQuoteNum(quoteNum) {
    this.set('quoteNum', quoteNum);
  }
}, {
  getColorNum: function getColorNum(hexCode) {
    if (hexCode.charAt(0) == '#') {
      hexCode = hexCode.substring(1);
    }
    var components = [];
    var i, hex;
    if (hexCode.length == 3) {
      for (i = 0; i < 3; i++) {
        hex = hexCode.substr(i, 1);
        components.push(hex + hex);
      }
      hexCode = components.join('');
    }
    return Number('0x' + hexCode);
  }
});
var _default = exports["default"] = MDTag;

},{"1184":1184,"1424":1424,"1437":1437,"1446":1446,"1454":1454,"1463":1463,"1478":1478,"21":21}],250:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
var _MDMolaUser = _interopRequireDefault(require(272));
var _MMModelBase = _interopRequireDefault(require(21));
var _MDEvaluationInfo = _interopRequireDefault(require(253));
var MDEvalStep = _MMModelBase["default"].extend({
  defaults: {
    'canBeIgnore': 0,
    'evaluators': [],
    'flowId': 0,
    'id': 0,
    'minNum': 100,
    'startTime': null,
    'step': 0,
    'title': BabelStr.str(7038)
  },
  isStarted: function isStarted() {
    return this.get('startTime') != null;
  },
  getStartTime: function getStartTime() {
    return new Date(this.get('startTime')) / 1000;
  },
  getEvalInfos: function getEvalInfos() {
    return this.get('evaluators');
  },
  getTitle: function getTitle() {
    return this.get('title');
  },
  canBeIgnore: function canBeIgnore() {
    return this.get('canBeIgnore');
  },
  addUsers: function addUsers(users) {
    this.get('evaluators').push({});
  }
}, {
  className: 'MDEvalStep',
  createObjWith: function createObjWith(data) {
    var result = new MDEvalStep(data);
    var evaluators = data['evaluators'];
    var evaluations = [];
    for (var i = 0; i < evaluators.length; i++) {
      var evalu = evaluators[i];
      var evaluation = new _MDEvaluationInfo["default"](evalu);
      evaluation.initData(evalu);
      evaluations.push(evaluation);
    }
    result.set('evaluators', evaluations);
    return result;
  }
});
var _default = exports["default"] = MDEvalStep;

},{"1184":1184,"1437":1437,"1454":1454,"21":21,"253":253,"272":272}],253:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1439);
var _MDMolaUser = _interopRequireDefault(require(272));
var _MMModelBase = _interopRequireDefault(require(21));
var MDEvaluationInfo = _MMModelBase["default"].extend({
  defaults: {
    'fileEvaluationId': null,
    'userInfo': null,
    'evaluation': 1,
    'comment': 'ok',
    'time': 0
  },
  initData: function initData(data) {
    var userInfo = new _MDMolaUser["default"](data['userInfo']);
    this.setUserInfo(userInfo);
    this.setTime(data['time']);
    this.setComment(data['comment']);
    this.setEvaluation(data['evaluation']);
    this.setEvaluationId(data['fileEvaluationId']);
  },
  getCurStep: function getCurStep() {
    return this.get('curStep');
  },
  getSteps: function getSteps() {
    return this.get("steps");
  },
  setEvaluationId: function setEvaluationId(id) {
    this.set('fileEvaluationId', id);
  },
  setUserInfo: function setUserInfo(userInfo) {
    this.set('userInfo', userInfo);
  },
  setEvaluation: function setEvaluation(evalue) {
    this.set('evaluation', evalue);
  },
  setComment: function setComment(commentstr) {
    this.set('comment', commentstr);
  },
  setTime: function setTime(time) {
    this.set('time', time);
  },
  getEvaluationId: function getEvaluationId() {
    return this.get('fileEvaluationId');
  },
  getUserInfo: function getUserInfo() {
    return this.get('userInfo');
  },
  getEvaluation: function getEvaluation() {
    return this.get('evaluation');
  },
  getEvaluationStr: function getEvaluationStr(passed, followFinalized) {
    var evalValue = this.get('evaluation');
    if (evalValue == 12) {
      return BabelStr.str(514); // '已通过'
    } else if (evalValue == 10) {
      return BabelStr.str(517); // '已驳回'
    } else {
      if (followFinalized) {
        if (passed) {
          return BabelStr.str(5151); // 
        } else {
          return BabelStr.str(5152); // 
        }
      } else {
        if (passed) {
          return BabelStr.str(569); // '未审批'
        } else {
          return BabelStr.str(570); // '待审批...'
        }
      }
    }
    return '';
  },
  getSpendsTimeStr: function getSpendsTimeStr(startTime) {
    var time;
    var spendDays = '';
    var evaluation = this.get('evaluation');
    if (evaluation == 10 || evaluation == 12) {
      time = this.getTime();
      spendDays = Math.ceil((time - startTime) / (60 * 60 * 24));
    }
    spendDays = spendDays < 0 ? 0 : spendDays;
    return spendDays ? BabelStr.str(3496, {
      days: spendDays
    }) : '';
  },
  getEvaluationClassName: function getEvaluationClassName() {
    var evalValue = this.get('evaluation');
    if (evalValue == 1) {
      return 'passed';
    }
    ;
    if (evalValue == 2) {
      return 'rejected';
    }
    ;
    return '';
  },
  getComment: function getComment() {
    return this.get('comment');
  },
  getTime: function getTime() {
    return this.get('time');
  },
  getDateStr: function getDateStr() {
    var t = this.get('time') * 1000;
    if (t) {
      var d = new Date(t);
      return d.format("yyyy-MM-dd");
    } else {
      return '';
    }
  },
  isRejected: function isRejected() {
    return this.get('evaluation') == 10;
  },
  isPassed: function isPassed() {
    return this.get('evaluation') == 12;
  },
  isNoInput: function isNoInput() {
    return !this.get('evaluation');
  },
  getUserName: function getUserName() {
    return this.get('userInfo').getUserName();
  },
  getUserId: function getUserId() {
    return this.get('userInfo').getUserId();
  },
  getUserDepName: function getUserDepName() {
    var deps = this.get('departments');
    if (deps && deps.length > 0) {
      var dep = deps[0];
      return dep.name;
    }
    return "";
  }
}, {
  className: 'MDEvaluationInfo'
});
var _default = exports["default"] = MDEvaluationInfo;

},{"1184":1184,"1437":1437,"1439":1439,"1454":1454,"21":21,"272":272}],247:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMModelBase = _interopRequireDefault(require(21));
var _DateFromat = _interopRequireDefault(require(99));
/**
 * Modified by manjun.han 适配cmd
 * 2016.12.5
 */

var MDDepartment = _MMModelBase["default"].extend({
  defaults: {
    "id": -1,
    "name": null,
    "parent": null,
    "parentName": null,
    "spaceLimit": null,
    "spaceUsed": null,
    "remarks": null,
    "used": null,
    "creatorId": null,
    "creatorName": null,
    "time": null,
    "memberCount": -1,
    "enterpriseId": null,
    "folderId": null
  },
  getName: function getName() {
    return this.get('name');
  },
  getId: function getId() {
    return this.get('id');
  },
  getParentId: function getParentId() {
    return this.get('parent');
  },
  getParentName: function getParentName() {
    return this.get('parentName');
  },
  getRemarks: function getRemarks() {
    return this.get('remarks');
  },
  getFormattedTime: function getFormattedTime() {
    var time = this.get('time');
    return _DateFromat["default"].format(time * 1000, 'yyyy-MM-dd');
  }
});
var _default = exports["default"] = MDDepartment;

},{"1184":1184,"1454":1454,"21":21,"99":99}],246:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMCollectionBase = _interopRequireDefault(require(20));
var _MDConversation = _interopRequireDefault(require(245));
/**
 * 从MDConversition.js中移出来单独成一个文件
 * Created by manjun.han
 * 2016.11.4
 */

var MDConversationCollection = _MMCollectionBase["default"].extend({
  model: _MDConversation["default"],
  usrId: null,
  initialize: function initialize(opts) {
    _MMCollectionBase["default"].prototype.initialize.call(this, opts);
    this.usrId = app.currentUser.getUserId();
  },
  checkToClearAllGroupForDifferentUser: function checkToClearAllGroupForDifferentUser() {
    if (this.usrId != app.currentUser.getUserId()) {
      this.usrId = app.currentUser.getUserId();
      this.reset();
    }
  }
});
var _default = exports["default"] = MDConversationCollection;

},{"1184":1184,"1454":1454,"20":20,"245":245}],20:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMBackboneExtend = _interopRequireDefault(require(19));
/**
 *
 * MolaTask app global base Collection class , extends Backbone.Collection ,
 * add many of userful properties and functions copy from MMBackboneExtend class
 *
 * 全局Collection基类，继承自Backbone.Collection类，同时添加了来自MMBackboneExtend类
 * 中定义的一些常用方法和属性
 *
 *
 * Create by manjun.han
 */

var MMCollectionBase = Backbone.Collection.extend({
  initialize: function initialize(arr) {
    if (arr) {
      console.assert(arr instanceof Array, "Collection 初始化错误，参数不是数组");
    }
    ;
    Backbone.Collection.prototype.initialize.call(this, arr);
  },
  addWithoutSort: function addWithoutSort(models, options) {
    // 临时移除comparator
    var comparator = this.comparator;
    this.comparator = null;

    // 添加模型
    this.add(models, options);

    // 恢复comparator
    this.comparator = comparator;
    // 如果需要，可以在这里添加其他逻辑
  }
}, {
  className: "MMCollectionBase"
});
(function () {
  var excludeMethods = ["toJSON"];
  _.each(_MMBackboneExtend["default"], function (value, key) {
    var exclude = false;
    _.each(excludeMethods, function (method, index) {
      if (key === method) {
        exclude = true;
        return false;
      }
    });
    if (!exclude) {
      MMCollectionBase.prototype[key] = _MMBackboneExtend["default"][key];
    }
  });
})();
var _default = exports["default"] = MMCollectionBase;

},{"1184":1184,"1454":1454,"19":19}],245:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMModelBase = _interopRequireDefault(require(21));
//
//  jiang
//  2015-10-23
//

//----------------------------------------------------------------------------------------------  MMFileInfo

var MDConversation = _MMModelBase["default"].extend({
  defaults: {
    "fileInfo": null,
    "unreadMsgCount": 0,
    "lastMsg": "",
    "selected": false
  },
  initByOhter: function initByOhter(item) {
    this.set('fileInfo', item.get('fileInfo'));
    this.set('unreadMsgCount', item.get('unreadMsgCount'));
    this.set('lastMsg', item.get('lastMsg'));
  },
  getId: function getId() {
    return this.get('fileInfo').getFileId();
  },
  getFileInfo: function getFileInfo() {
    return this.get('fileInfo');
  },
  getFileId: function getFileId() {
    var fileInfo = this.getFileInfo();
    return fileInfo.getFileId();
  },
  setSelected: function setSelected(selected) {
    this.set('selected', selected);
  },
  isSelected: function isSelected() {
    return this.get('selected');
  }
});
var _default = exports["default"] = MDConversation;

},{"1184":1184,"1454":1454,"21":21}],243:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1498);
var _MDMolaUser = _interopRequireDefault(require(272));
/**
 * 常用联系人
 */

var MDContact = _MDMolaUser["default"].extend({
  // idAttribute: 'email',

  initialize: function initialize(opt) {
    _MDMolaUser["default"].prototype.initialize.call(this, opt);
    this.setId(this.getOriginalEmail());
    this.set('avatarImageURL', this.getAvatarImageURL());
    var name = $.trim(this.get('name'));
    if (name.length == 0 || name == '-1') {
      this.set('name', BabelStr.str(710));
      this.set('avatarImageURL', 'img/avatar/anonymous.jpg');
    }
  }
});
var _default = exports["default"] = MDContact;

},{"1184":1184,"1454":1454,"1498":1498,"272":272}],235:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  READ: 1,
  //---------------------- 0
  COMMENT_READ: 2,
  //----------------- 1
  WRITE: 4,
  //------------------------ 2
  SHARE: 8,
  //------------------------ 3
  MOVE: 16,
  //------------------------ 4
  DOWNLOAD: 32,
  //-------------------- 5
  COPY: 64,
  //------------------------ 6
  STICK_TO_TOP: 128,
  //-------------- 7
  DELETE: 256,
  //-------------------- 8
  RENAME: 512,
  //-------------------- 9
  UPLOAD: 1024,
  //-------------------- 10
  UPLOADVERSION: 2048,
  //-----------  11
  LIST_ALL_VERSION: 4096,
  //--------- 12
  SET_CURRENT_VERSION: 8192,
  //------ 13
  LEAVE: 16384,
  //-----------------  14
  COMMENT_CREATE: Math.pow(2, 15),
  COMMENT_DEL: Math.pow(2, 16),
  COMMENT_FINISH: Math.pow(2, 17),
  TAG: Math.pow(2, 18),
  LOG: Math.pow(2, 19),
  ONLY_UPLOAD: Math.pow(2, 20),
  START_EVALUATION: Math.pow(2, 21),
  UNLOCK: Math.pow(2, 22),
  MANAGE_FILE_PERMISSION: Math.pow(2, 23),
  PRINT: Math.pow(2, 24),
  MANAGE_SECRET: Math.pow(2, 25),
  ARCHIVE: Math.pow(2, 26),
  EDIT_PROJECT: Math.pow(2, 27),
  ONLY_READ_NAME: Math.pow(2, 28),
  SEND_TRANSMITTAL: Math.pow(2, 29)
};

},{"1454":1454}],205:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMModelBase = _interopRequireDefault(require(21));
var _MD_SALON_MSG_TYPE = _interopRequireDefault(require(212));
// MDSalonMsg.js
// jiang
// 2017-6-16

var MDSalonMsg = _MMModelBase["default"].extend({
  defaults: {
    'type': _MD_SALON_MSG_TYPE["default"].WindowPos,
    'fileId': 0,
    'salonId': 0,
    'versionDisp': 0,
    'fileDim': '2D',
    'center': null,
    'lgCenter': null,
    'winW2DocW': 0.5,
    'winW2H': 0.5,
    'clickPos': null,
    'cameraPos': null,
    //{x: 0, y: 0, z: 0},
    'cameraUp': null,
    //{x: 0, y: 0, z: 1},
    'lookAt': null,
    //{x: 0, y: 0, z: 0},

    'uId': 0,
    'uName': '',
    'time': 0,
    'text': '',
    'targetUid': '0',
    // 点对点时目标id
    'sdp': '',
    'candidate': '',
    'ids': [],
    //擦除对象的id
    'index': 0
  },
  getType: function getType() {
    return this.get('type');
  },
  getFileId: function getFileId() {
    return this.get('fileId');
  },
  getVersionDisp: function getVersionDisp() {
    return this.get('versionDisp');
  },
  get2DPosInfo: function get2DPosInfo() {
    if (this.get('fileDim') == '2D') {
      var position = {
        fileId: this.getFileId(),
        scale: this.get('winW2DocW'),
        centerPos: this.get('center'),
        lgCenter: this.get('lgCenter'),
        fileDim: '2D',
        index: 'index'
      };
      return position;
    }
    ;
    return null;
  },
  is2D: function is2D() {
    return this.get('fileDim') == '2D';
  },
  getMouseClickPos: function getMouseClickPos() {
    return this.get('clickPos');
  },
  getUId: function getUId() {
    return this.get('uId');
  },
  getUName: function getUName() {
    return this.get('uName');
  },
  getTime: function getTime() {
    return this.get('time');
  },
  getText: function getText() {
    return this.get('text');
  },
  getTargetUid: function getTargetUid() {
    return this.get('targetUid');
  },
  getSdp: function getSdp() {
    return this.get('sdp');
  },
  getCandidate: function getCandidate() {
    return this.get('candidate');
  },
  getPenScribble: function getPenScribble() {
    return this.get("scribble");
  },
  getEaraserIds: function getEaraserIds() {
    return this.get("ids");
  },
  getCurrentPageIndex: function getCurrentPageIndex() {
    return this.get("index");
  }
}, {
  className: 'MDSalonMsg'
});
window.MDSalonMsg = MDSalonMsg;
var _default = exports["default"] = MDSalonMsg;

},{"1184":1184,"1454":1454,"21":21,"212":212}],212:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Events type for mola disk app
 * Created by manjun.han
 * 2015.9.1
 */

var MD_SALON_MSG_TYPE = {
  SalonCreated: 0,
  SalonClosed: 1,
  SalonTransfered: 2,
  MemAdded: 5,
  MemLeaved: 6,
  ChatMsg: 11,
  WindowPos: 15,
  MouseClickPos: 16,
  ChangeVersion: 17,
  SessionOffer: 21,
  SessionAnswer: 22,
  IceCandidateOffer: 23,
  IceCandidateAnswer: 24,
  SalonPenAdd: 30,
  SalonEaraser: 31
};
window.MD_SALON_MSG_TYPE = MD_SALON_MSG_TYPE;
var _default = exports["default"] = MD_SALON_MSG_TYPE;

},{"1454":1454}],107:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1423);
require(1463);
require(1538);
require(1435);
require(1437);
require(1466);
/**
 *@autor: Tobias Nickel
 *@license: MIT, do what you want, but don't fuck me up
 *@description: helps you stabilize data.
 * if you have a lot of event data, like the rotation of a mobile device values of other sensors,
 * it can be helpfull to stabilize the values, to display a stable output.
 * I wrote this small lib, to stabilize the display of an upload speed in kb
 */

/**
 *@class
 *@description: provides the nessasary methods.
 * you can push data, and read the max, min and avarage values.
 */
var tStabilizer = function tStabilizer(length) {
  length = length || Infinity;
  // values as a queue, new values get pushed, old values removed my shift
  this.values = [];
  // /**
  //  *@param value {number} the new value
  //  */
  // this.push = function(value) {
  //     this.values.push(value);
  //     while (this.values.length > length) {
  //       this.values.shift();
  //     }
  //   }
  //   /**
  //    *@return the avarave from the current values
  //    */
  // this.getAvarage = function() {
  //   var sum = this.getSum();
  //   return sum / this.values.length;
  // };
  // /**
  //  *@return the highest of the current values
  //  */
  // this.getMax = function() {
  //   var v = -Infinity;
  //   var i = this.values.length;
  //   while (i--) {
  //     v = v < this.values[i] ? this.values[i] : v;
  //   }
  //   return v;
  // };
  // /**
  //  *@return the lowest of the current values
  //  */
  // this.getMin = function() {
  //   var v = Infinity;
  //   var i = this.values.length;
  //   while (i--) {
  //     v = v > this.values[i] ? this.values[i] : v;
  //   }
  //   return v;
  // };
  // /**
  //  *return the sum of the current values
  //  */
  // this.getSum = function() {
  //   var sum = 0;
  //   var i = this.values.length;
  //   while (i--) {
  //     sum += this.values[i];
  //   }
  //   return sum;
  // };

  this.pushLoaded = function (bitLoaded) {
    var timeStamp = {
      bitLoaded: bitLoaded,
      time: Date.now()
    };
    this.values.push(timeStamp);
    while (this.values.length > length) {
      this.values.shift();
    }
  };
  this.getAvarage = function () {
    if (this.values.length < 2) {
      return 0;
    } else {
      var deltaLoaded = this.values[this.values.length - 1].bitLoaded - this.values[0].bitLoaded;
      var deltaTime = this.values[this.values.length - 1].time - this.values[0].time;
      var bitrate = parseInt(deltaLoaded / deltaTime);
      return bitrate;
    }
  };
};
var _default = exports["default"] = tStabilizer;

},{"1423":1423,"1435":1435,"1437":1437,"1454":1454,"1463":1463,"1466":1466,"1538":1538}],17:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1463);
require(1471);
require(1541);
require(1437);
require(1421);
require(1465);
require(1450);
require(1477);
require(1492);
require(1412);
require(1498);
require(1489);
var _MDInnerLoginWindowView = _interopRequireDefault(require(328));
var _MDMolaUser = _interopRequireDefault(require(272));
var _MDEnterprise = _interopRequireDefault(require(249));
var _MDOnlineEventHandler = _interopRequireDefault(require(59));
var _OnlineEvent = _interopRequireDefault(require(60));
var _UA = _interopRequireDefault(require(110));
var _MDSnackbarView = _interopRequireDefault(require(72));
var _MDAlertView = _interopRequireDefault(require(32));
var _MDDownloadPathForClientWinView = _interopRequireDefault(require(489));
var app = function app() {
  app.initialize();
  _UA["default"].exportTo(app);
  app.prepareAcrossBrowserAPI();
};
_.extend(app, Backbone.Events, {
  application: null,
  MOLA_DEBUG: false,
  // app.currentUser should be null or undefined when the user is logged out.
  currentUser: new _MDMolaUser["default"](window['user']),
  userBeingViewed: window['viewUser'] ? new _MDMolaUser["default"](window['viewUser']) : null,
  ep: new _MDEnterprise["default"](window['ep']),
  initialize: function initialize() {
    var self = this;
    var offlineEventHandler = new _MDOnlineEventHandler["default"]();
    this.listenTo(offlineEventHandler, _OnlineEvent["default"].OnlineStateChange, function (isOnline) {
      self.isAppOnline = isOnline;
    });
    this.disableDiffAccountInDiffTab();
    if (window.personnalEditionLimit) {
      this.currentUser.setPersonalEditionInfo(window.personnalEditionLimit);
    }
    ;
    app.initLoginLocalSession();
    this.loadedSectlist = false;
    this.secrectList = [];
    this.hasSecrectlist = false;
  },
  preventOpenDropFile: function preventOpenDropFile() {
    $(document.documentElement).on('dragenter', function () {
      return false;
    });
    $(document.documentElement).on('dragover', function () {
      return false;
    });
    $(document.documentElement).on('drop', function () {
      return false;
    });
  },
  getDownloadFileTargetForClient: function getDownloadFileTargetForClient(fileInfors, callback) {
    if (!this.getTransferController()) {
      callback();
      return;
    }
    var win = new _MDDownloadPathForClientWinView["default"]({
      fileInfors: fileInfors,
      callback: callback
    });
    win.show();
  },
  isDebug: function isDebug() {
    return window['appConfig']['debug'];
  },
  /**
   *
   * 在同一个浏览器会话中只能有一个账户登录，当在不同的tab中登录不同账户时要刷新到同一个账号下
   * 通过localStorage的storage事件可以实现此功能
   */
  disableDiffAccountInDiffTab: function disableDiffAccountInDiffTab() {
    var nameChangeKey = 'storage-userId';
    localStorage.setItem(nameChangeKey, app.currentUser.getUserId());
    $(window).on('storage', function ($e) {
      var storageEvent = $e.originalEvent;
      var key = storageEvent.key;
      var newValue = storageEvent.newValue;
      // if not localStorage event
      if (storageEvent.storageArea != localStorage) {
        return;
      }
      // userId changed
      if (key == nameChangeKey) {
        if (newValue && newValue != app.currentUser.getUserId()) {
          location.href = '/main.do';
        }
      }
    });
  },
  isEpVersion: function isEpVersion() {
    return app.ep.getEpID() !== null;
  },
  isUseV2022: function isUseV2022() {
    return app.isEpVersion() && !app.isInClient();
  },
  stopMobileBrowserBounch: function stopMobileBrowserBounch() {
    if (!MMCommonFun.isPC()) {
      return;
    }
    document.body.ontouchmove = function (e) {
      e.preventDefault();
    };
  },
  prepareLogout: function prepareLogout() {
    $.ajax({
      method: "post",
      url: "/account/userLogout.do",
      success: function success() {
        console.error("2345");
      }
    });
  },
  logout: function logout() {
    window.location.href = window.location.origin + "/account/userLogout.do";
  },
  redirectToLogin: function redirectToLogin() {
    window.location.href = window.location.origin + "/account/userLogout.do";
  },
  redirectToClientDownload: function redirectToClientDownload() {
    window.location.href = "https://www.babel.cc/p/download.do";
  },
  detectBrowser: function detectBrowser() {
    var $browserDetectTip = $('<div class="u-browser-detect"></div>');
    if (!document.createElement('canvas').getContext('2d')) {
      $('body').append($browserDetectTip);
    }
  },
  isOnline: function isOnline() {
    return this.isAppOnline;
  },
  promotUpdateBrowserInner: function promotUpdateBrowserInner() {
    if (app.browser.ie && app.browser.version <= 9.0) {
      var message = BabelStr.str(5113);
      _MDSnackbarView["default"].show(message);
    }
  },
  disableButtonAutoFocus: function disableButtonAutoFocus() {
    $(document).on('click.disable-button-auto-focus', function ($e) {
      var $target = $($e.target);
      if ($target.is('.button') || $target.is('button')) {
        $e.target.blur();
      }
    });
  },
  getAllSecretLevels: function getAllSecretLevels(callback) {
    var _this = this;
    var self = this;
    var secrectList;
    var promise = new Promise(function (resolve, rejected) {
      var timeout = function timeout(ms) {
        return new Promise(function (resolve1, rejected1) {
          setTimeout(resolve1, ms, "done");
        });
      };
      var interval = function interval() {
        timeout(100).then(function () {
          if (self.secrectList.length > 0) {
            resolve(self.secrectList);
            // console.log(self.secrectList)
          } else {
            interval();
          }
        });
      };
      if (_this.hasSecrectlist) {
        interval();
      } else {
        _this.hasSecrectlist = true;
        MMEnterpriseController.getAllSecretLevels(function (list) {
          _.each(list, function (item) {
            switch (item.id) {
              case 2:
                item.text = BabelStr.str(3336);
                break;
              case 3:
                item.text = BabelStr.str(3335);
                break;
              case 4:
                item.text = BabelStr.str(3334);
                break;
            }
          });
          _this.secrectList = list;
          console.log(list);
          resolve(list);
        }, function () {
          _this.loadedSectlist = false;
        });
      }
    });
    promise.then(function (list) {
      callback(list);
    });
    this.loadedSectlist = true;
  },
  isMobile: function isMobile() {
    return app.os.phone;
  },
  isTablet: function isTablet() {
    return app.os.tablet;
  },
  isPC: function isPC() {
    return !app.isTablet() && !app.isMobile();
  },
  canDispInNormalBrowser: function canDispInNormalBrowser() {
    return !app.isMobile();
  },
  isIOS: function isIOS() {
    return app.os.ios;
  },
  isIPhone: function isIPhone() {
    return app.os.iphone;
  },
  isIPad: function isIPad() {
    return app.os.ipad;
  },
  getAvatarImageURL: function getAvatarImageURL(userId, size, notForce) {
    size = size ? size : 80;
    var t = new Date().getTime();
    if (notForce) {
      t = Math.floor(new Date().getTime() / 36000000); // 1 小时内不刷新
    }
    ;
    if (userId == -1) {
      return 'img/avatar/anonymous.jpg';
    }
    return "/user/getUserAvatar.do?userId=" + userId + "&t=" + t + "&size=" + size;
  },
  setAvatarImage: function setAvatarImage(img, userId, size, notForce) {
    img = $(img);
    img.attr('src', app.getAvatarImageURL(userId, size, notForce));
    img.data("count", 0);
    img.on('error', function () {
      img.on('error', null);
      var count = img.data("count");
      if (count == 3) {
        return;
      }
      img.data("count", ++count);
      img.attr('src', app.getAvatarImageURL(userId));
    });
  },
  isFromWechat: function isFromWechat() {
    if (app.MOLA_DEBUG) {
      return !MMCommonFun.isPC();
    }
    return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1;
  },
  isLandscape: function isLandscape() {
    return window.orientation == -90 || window.orientation == 90;
  },
  isPortrait: function isPortrait() {
    return window.orientation == 0 || window.orientation == 180;
  },
  prepareAcrossBrowserAPI: function prepareAcrossBrowserAPI() {
    var m = Modernizr;
    window.requestAnimationFrame = window[m.prefixed('requestAnimationFrame', window, false)];
    window.AudioContext = window[m.prefixed('AudioContext', window, false)];
  },
  getFileSizeDescription: function getFileSizeDescription(fileSize, unit) {
    var kb = 1024;
    var mb = kb * 1024;
    var gb = mb * 1024;
    var tb = gb * 1024;
    var size = Math.abs(fileSize);
    var desp = '--';
    if (size < 1 * kb && (!unit || unit == "B")) {
      size < 0.1 ? "0" : size;
      desp = size + "B";
    } else if (size > 1 * kb && size < 1 * mb && (!unit || unit == "KB")) {
      size = parseFloat((fileSize / kb).toFixed(2));
      desp = size + 'KB';
    } else if (size > 1 * mb && size < 1 * gb && (!unit || unit == "MB")) {
      size = parseFloat((fileSize / mb).toFixed(2));
      desp = size + "MB";
    } else if (!unit || unit == "GB") {
      size = parseFloat((fileSize / gb).toFixed(2));
      desp = size + "GB";
    } else {
      size = parseFloat((fileSize / tb).toFixed(2));
      desp = size + "TB";
    }
    return desp;
  },
  promotUpdateBrowser: function promotUpdateBrowser() {
    if (app.browser.ie && app.browser.version <= 9.0) {
      var message = BabelStr.str(5113);
      var promot = '<div class="m-browser-version text-center">' + '<span id="js-promot">' + message + '</span>' + '<button class="icon close"></button>' + '</div>';
      var $promot = $(promot);
      $promot.addClass('m-browser-version');
      setTimeout(function () {
        $promot.animate({
          'height': 0
        }, {
          complete: function complete() {
            $promot.remove();
          }
        });
      }, 5000);
      $promot.on('click', '.close', function () {
        $promot.animate({
          'height': 0
        }, {
          complete: function complete() {
            $promot.remove();
          }
        });
      });
      $('.m-body').before($promot);
      $promot.hide();
      $promot.slideDown();
    }
  },
  popupInnerLogin: function popupInnerLogin(needMessage, success, fail) {
    needMessage = _.isUndefined(needMessage) ? true : needMessage;
    var message = '';
    if (needMessage) {
      message = BabelStr.str(5114);
    }
    // if (!app.currentUser.logined()) {
    var width = 300;
    if (!app.isMobile()) {
      width = 460;
    }
    var loginView = new _MDInnerLoginWindowView["default"]({
      onSuccess: success,
      onFail: fail,
      width: width,
      message: message
    });
    loginView.show();
  },
  initLoginLocalSession: function initLoginLocalSession() {
    window.localStorage['login'] = 'true';
    window.addEventListener('storage', function (e) {
      var key = e.key;
      var storage = e.storageArea;
      var newValue = e.newValue;
      var action;
      if (!newValue && key == 'login') {
        action = 'userLogout';
      }
      if (storage == localStorage && action == 'userLogout') {
        location.replace("/account/userLogout.do");
      }
      if (storage == localStorage && key == 'forOfficeSave') {
        setTimeout(function () {
          newValue = newValue.split('-');
          $.ajax({
            url: "/netdrive/getOnlyOfficeEditorStatus.do?fileId=".concat(newValue[0], "&version=").concat(newValue[1]),
            success: function success(responseData, textStatus, jaXHR) {
              console.warn(responseData);
              if (responseData.success) {
                _.isFunction(successCB) && successCB();
              } else {
                var alert = new _MDAlertView["default"]({
                  title: BabelStr.str(170),
                  message: BabelStr.str(6754),
                  buttons: [{
                    label: BabelStr.str(154),
                    type: 'done'
                  }]
                });
                alert.show();
                _.isFunction(failCb) && failCb(responseData);
              }
            },
            fail: function fail(res) {
              _.isFunction(failCb) && failCb(res);
            }
          });
        }, 20 * 1000);
      }
    });
  },
  syncSessionState: function syncSessionState() {
    window.localStorage.removeItem('login');
  },
  userClentMode: function userClentMode() {
    // return true
    return this.isInClient() || !app.isEpVersion();
  },
  isInClient: function isInClient() {
    var isClient = window['ElectronRequire'] != undefined;
    return isClient;
  },
  isClientHasCompareFun: function isClientHasCompareFun() {
    if (!this.isInClient()) {
      return false;
    }
    var compareF = window['ElectronRequire']('electron').remote.require('./utils/cppAPI').compare;
    return compareF;
  },
  isUnSupportSync: function isUnSupportSync() {
    if (!this.isInClient()) {
      return false;
    }
    return window['ElectronRequire']('electron').remote.require('./utils/config').UNSUPPORTSYNC;
  },
  tabForward: function tabForward() {
    if (!this.isInClient()) {
      return false;
    }
    var tabForward = window['ElectronRequire']('electron').remote.require('./utils/cppAPI').tabForward;
    return tabForward;
  },
  tabBack: function tabBack() {
    if (!this.isInClient()) {
      return false;
    }
    var tabBack = window['ElectronRequire']('electron').remote.require('./utils/cppAPI').tabBack;
    return tabBack;
  },
  openSync: function openSync() {
    if (!this.isInClient() || app.currentUser && app.currentUser.isCloseSync()) {
      return false;
    }
    var openSync = window['ElectronRequire']('electron').remote.require('./utils/cppAPI').openSync;
    return openSync;
  },
  openTransfer: function openTransfer() {
    if (!this.isInClient()) {
      return false;
    }
    var openTransfer = window['ElectronRequire']('electron').remote.require('./utils/cppAPI').openTransfer;
    return openTransfer;
  },
  openSetting: function openSetting() {
    if (!this.isInClient()) {
      return false;
    }
    var openSetting = window['ElectronRequire']('electron').remote.require('./utils/cppAPI').openSetting;
    return openSetting;
  },
  getTransferController: function getTransferController() {
    if (!this.isInClient()) {
      return null;
    }
    try {
      var transferController = window['ElectronRequire']('electron').remote.require('./utils/Transfer/TransferController');
      return transferController ? transferController.TransferController : null;
    } catch (e) {
      return null;
    }
  },
  isDarkMode: function isDarkMode() {
    return document.querySelector("html").classList.contains('dark') || document.querySelector("html").classList.contains('client-dark');
  },
  getCSSVariableValue: function getCSSVariableValue(variableName) {
    return getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();
  },
  isClientFlashReady: function isClientFlashReady() {
    if (!this.isInClient()) {
      return false;
    }
    return window['ElectronRequire']('electron').remote.require('./utils/cppAPI').flashReady;
  },
  isFolderSynced: function isFolderSynced(folderId) {
    if (window['ElectronRequire']) {
      var cppAPI = window['ElectronRequire']('electron').remote.require('./utils/cppAPI');
      return cppAPI && cppAPI.isSynced && cppAPI.isSynced(folderId);
    } else {
      return false;
    }
  },
  getCurBrowserType: function getCurBrowserType() {
    var ua = navigator.userAgent;
    if (ua.match(/MSIE\s([\d.]+)/) || ua.match(/Trident\/[\d](?=[^\?]+).*rv:([0-9.].)/)) {
      return "ie";
    } else if (ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/)) {
      return "chrome";
    } else if (ua.match(/Firefox\/([\d.]+)/)) {
      return "firefox";
    } else if (ua.match(/Version\/([\d.]+)([^S](Safari)|[^M]*(Mobile)[^S]*(Safari))/)) {
      return "safari";
    } else if (ua.indexOf("Opera") > -1) {
      return "opera";
    } else {
      return "default-browser";
    }
  },
  setShowMiniLeftMenu: function setShowMiniLeftMenu() {
    localStorage.setItem("layout-actions-0", 1);
  },
  isShowMiniLeftMenu: function isShowMiniLeftMenu() {
    return localStorage.getItem("layout-actions-0");
  },
  isShowDirectoriesPanel: function isShowDirectoriesPanel() {
    return localStorage.getItem("layout-actions-1");
  },
  setShowDirectoriesPanel: function setShowDirectoriesPanel() {
    localStorage.setItem("layout-actions-1", 1);
  },
  hideMiniLeftMenu: function hideMiniLeftMenu() {
    return localStorage.removeItem("layout-actions-0");
  },
  hideDirectoriesPanel: function hideDirectoriesPanel() {
    return localStorage.removeItem("layout-actions-1");
  }
});
app();
window.app = app;
window.app.currentUser = app.currentUser;
window.babelTimeoutMem = {};
window.setBabelTimeout = function (fun, time) {
  var t = new Date().getTime() + Math.random();
  babelTimeoutMem[t] = false;
  var tout = setTimeout(function () {
    if (babelTimeoutMem[t]) {
      return;
    }
    babelTimeoutMem[t] = true;
    fun();
  }, time);
  return tout;
};
$.ajax({
  method: "post",
  url: "/netdrive/canUseOnlyOffice.do",
  success: function success(msg) {
    if (msg.code == 0) {
      window.canUseOnlyOffice = true;
    }
  }
});
var _default = exports["default"] = app;

},{"110":110,"1184":1184,"1412":1412,"1421":1421,"1437":1437,"1450":1450,"1454":1454,"1463":1463,"1465":1465,"1471":1471,"1477":1477,"1489":1489,"1492":1492,"1498":1498,"1541":1541,"249":249,"272":272,"32":32,"328":328,"489":489,"59":59,"60":60,"72":72}],489:[function(require,module,exports){
"use strict";

require(1475);
require(1463);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _possibleConstructorReturn2 = _interopRequireDefault(require(1189));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
var _inherits2 = _interopRequireDefault(require(1183));
var _MDWindowView2 = _interopRequireDefault(require(93));
var _MDCheckboxView = _interopRequireDefault(require(37));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MDDownloadPathForClientWinView = exports["default"] = /*#__PURE__*/function (_MDWindowView) {
  (0, _inherits2["default"])(MDDownloadPathForClientWinView, _MDWindowView);
  function MDDownloadPathForClientWinView() {
    (0, _classCallCheck2["default"])(this, MDDownloadPathForClientWinView);
    return _callSuper(this, MDDownloadPathForClientWinView, arguments);
  }
  (0, _createClass2["default"])(MDDownloadPathForClientWinView, [{
    key: "contentTmpl",
    value: function contentTmpl() {
      return "\n        <div class=\"fileinfo-show-view\">\n          <div class=\"file-info flex-align middle mgb-15\">\n            <div class=\"image mgr-10 no-shrink\"></div>\n            <div class=\"name mgr-10 text-hide fullfill\"></div>\n            <div class=\"count no-shrink\"></div>\n          </div>\n        </div>\n        <div class=\"file-info flex-align middlep center pdb-10 mgb-20 path-block\">\n          <div class=\"no-shrink mgr-10\"><%=BabelStr.str(6908)%></div>\n          <input class=\"path fullfill form-control mgr-10\"/>\n          <div class=\"find-dir button no-shrink\"><%=BabelStr.str(6909)%></div>\n        </div>\n        <div class=\"check-box mgb-15\"></div>\n        <div class=\"flex-align end\">\n          <button class=\"button mgr-10 cancel\"><%=BabelStr.str(155)%></button>\n          <button class=\"button done save\"><%=BabelStr.str(154)%></button>\n        </div>\n      ";
    }
  }, {
    key: "events",
    value: function events() {
      var superE = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDownloadPathForClientWinView.prototype), "events", this).call(this);
      return _.extend(superE, {
        "click .cancel": this._cancelHandler,
        "click .find-dir": this._findDir,
        "click .save": this._save
      });
    }
  }, {
    key: "initProps",
    value: function initProps() {
      var superP = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDownloadPathForClientWinView.prototype), "initProps", this).call(this);
      return _.extend(superP, {
        fileInfors: null,
        hiddenClose: true
      });
    }
  }, {
    key: "className",
    value: function className() {
      var superCls = (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDownloadPathForClientWinView.prototype), "className", this).call(this);
      return superCls + " down-forClient";
    }
  }, {
    key: "initialize",
    value: function initialize(props) {
      var _this = this;
      props.title = BabelStr.str(29);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDownloadPathForClientWinView.prototype), "initialize", this).call(this, props);
      var fileInfo = this.fileInfors[0];
      if (this.fileInfors.length < 2) {
        this.$(".count").hide();
      }
      fileInfo.setIconForDiv(this.$(".image"));
      this.$(".name").html(fileInfo.getFileName());
      this.$(".count").html(BabelStr.str(1048, {
        count: this.fileInfors.length
      }));
      var saveToDefault = new _MDCheckboxView["default"]({
        label: BabelStr.str(6910),
        onChanged: function onChanged(checked) {
          _this.saveToDefault = checked;
        }
      });
      this.path = app.getTransferController().getDefaultDownloadDestFolder();
      this.$(".path").val(this.path);
      this.addSubView(saveToDefault, this.$(".check-box")[0]);
    }
  }, {
    key: "_cancelHandler",
    value: function _cancelHandler() {
      this.close();
    }
  }, {
    key: "_save",
    value: function _save() {
      if (this.saveToDefault) {
        this.setDefaultDownloadDestFolder();
      }
      this.callback(this.path);
      this.close();
    }
  }, {
    key: "setDefaultDownloadDestFolder",
    value: function setDefaultDownloadDestFolder() {
      app.getTransferController().setDefaultDownloadDestFolder(this.path);
    }
  }, {
    key: "_findDir",
    value: function _findDir() {
      var _this2 = this;
      // var dialog = window['ElectronRequire']('electron').remote.dialog
      var paths = app.getTransferController().selectDestDir(function (path) {
        if (path) {
          _this2.path = path;
          _this2.$(".path").val(path);
        }
      });
      // var path = paths && paths[0]
      // this.path = path
      // this.$('.path').val(path)
      // paths.then(result=>{console.error(result)})
    }
  }, {
    key: "viewDidUnRendered",
    value: function viewDidUnRendered() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MDDownloadPathForClientWinView.prototype), "viewDidUnRendered", this).call(this);
    }
  }]);
  return MDDownloadPathForClientWinView;
}(_MDWindowView2["default"]);

},{"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1183":1183,"1184":1184,"1189":1189,"1454":1454,"1463":1463,"1475":1475,"37":37,"93":93}],1475:[function(require,module,exports){
var $ = require(1270);
var getBuiltIn = require(1282);
var apply = require(1274);
var bind = require(1277);
var aConstructor = require(1204);
var anObject = require(1209);
var isObject = require(1307);
var create = require(1326);
var fails = require(1271);

var nativeConstruct = getBuiltIn('Reflect', 'construct');
var ObjectPrototype = Object.prototype;
var push = [].push;

// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
});

var ARGS_BUG = !fails(function () {
  nativeConstruct(function () { /* empty */ });
});

var FORCED = NEW_TARGET_BUG || ARGS_BUG;

$({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
  construct: function construct(Target, args /* , newTarget */) {
    aConstructor(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aConstructor(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      apply(push, $args, args);
      return new (apply(bind, Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : ObjectPrototype);
    var result = apply(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});

},{"1204":1204,"1209":1209,"1270":1270,"1271":1271,"1274":1274,"1277":1277,"1282":1282,"1307":1307,"1326":1326}],1189:[function(require,module,exports){
var _typeof = require(1197)["default"];
var assertThisInitialized = require(1171);
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return assertThisInitialized(self);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"1171":1171,"1197":1197}],1171:[function(require,module,exports){
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],1183:[function(require,module,exports){
var setPrototypeOf = require(1191);
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"1191":1191}],1191:[function(require,module,exports){
function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],37:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMViewBase = _interopRequireDefault(require(22));
/**
 *  control for checkbox
 *  Created by jichaoHu
 *  2016.9.20
 */
var _default = exports["default"] = _MMViewBase["default"].extend({
  el: '<div></div>',
  tmpl: '<div class="box no-shrink"></div><span class="label"></span>',
  className: function className() {
    var superCls = _MMViewBase["default"].prototype.className.call(this);
    return superCls + ' m-chb flex-align middle';
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      $label: null,
      onChanged: _.noop,
      label: '',
      checked: false,
      isBlockLevel: true,
      onBeforeChange: _.noop,
      editable: true
    });
  },
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click': this._clickHandler
    });
  },
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.$label = this.$(".label");
    this.setLabel(this.label);
    this.setChecked(this.checked, true);
    this.enableBlockLevel(this.isBlockLevel);
    if (this.editable) {
      this.$el.css('pointer-events', 'auto');
    } else {
      this.$el.css('pointer-events', 'none');
    }
  },
  setLabel: function setLabel(label) {
    this.$label.text(label);
    this.label = label;
  },
  setEditable: function setEditable(editable) {
    this.editable = editable;
    if (this.editable) {
      this.$el.css('pointer-events', 'auto');
    } else {
      this.$el.css('pointer-events', 'none');
    }
  },
  toggleChecked: function toggleChecked() {
    if (this.editable) {
      var res = this.onBeforeChange(!this.checked);
      if (_.isBoolean(res) && !res) {
        return;
      }
      this.$el.toggleClass("checked");
      this.checked = !this.checked;
      if (_.isFunction(this.onChanged)) {
        this.onChanged(this.checked);
      }
    }
    ;
  },
  setChecked: function setChecked(checked, opt_silent) {
    opt_silent = !!opt_silent;
    if (checked) {
      this.$el.addClass("checked");
    } else {
      this.$el.removeClass("checked");
    }
    this.checked = checked;
    if (!opt_silent && _.isFunction(this.onChanged)) {
      this.onChanged(this.isChecked());
    }
  },
  setDisabled: function setDisabled(disabled) {
    if (disabled) {
      this.$el.addClass("disabled");
    } else {
      this.$el.removeClass("disabled");
    }
  },
  isChecked: function isChecked() {
    return this.checked;
  },
  enableBlockLevel: function enableBlockLevel(isBlock) {
    if (isBlock) {
      this.$el.removeClass("is-inline");
    } else {
      this.$el.addClass("is-inline");
    }
    this.isBlockLevel = isBlock;
  },
  _clickHandler: function _clickHandler($e) {
    if (this.$el.hasClass('disabled')) {
      return;
    }
    this.toggleChecked();
    _.isFunction(this.onClickedAfter) && this.onClickedAfter(this.checked);
  }
});

},{"1184":1184,"1454":1454,"22":22}],328:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1432);
var _MDWindowView = _interopRequireDefault(require(93));
var _ValidateHelper = _interopRequireDefault(require(793));
var _Dispatcher = _interopRequireDefault(require(18));
var _codeBtn = _interopRequireDefault(require(1115));
var _SMSType = _interopRequireDefault(require(101));
var _utils = _interopRequireDefault(require(108));
var _errorCode = _interopRequireDefault(require(1117));
var _error = _interopRequireDefault(require(1118));
var _regexp = _interopRequireDefault(require(106));
var _MMBasicData = _interopRequireDefault(require(811));
/**
 *  内部登录窗口
 *  Created by manjun.han
 *  2016.5.2
 */

var MDInnerLoginWindowView = _MDWindowView["default"].extend({
  contentTmpl: "<div class=\"text-center\">\n      <p>\n        <span><%=BabelStr.str(7066)%></span>\n        <span id=\"js-login-btn\" class=\"text-button done\"><%=BabelStr.str(744)%></span>\n      </p>\n      <p>\n        <%=BabelStr.str(7068)%>?<span id=\"js-reg-btn\" class=\"text-button done\"><%=BabelStr.str(7067)%></span>\n      </p>\n    </div>",
  events: function events() {
    var superE = _MDWindowView["default"].prototype.events.call(this);
    return _.extend(superE, {
      'click #js-login-btn': this.gotoLogin,
      'click #js-reg-btn': this.gotoRegister
    });
  },
  initialize: function initialize(opt) {
    var self = this;
    opt.title = BabelStr.str(7069);
    opt.buttonsAlign = 'center';
    opt.disableAutoFocusWhenClose = true;
    opt.buttons = [{
      label: BabelStr.str(3081)
    }];
    if (!window.app.isEpVersion && window.app.isFromWechat()) {
      opt.buttons.splice(0, 0, {
        label: BabelStr.str(492),
        cls: 'link-button main mgr-10',
        autoClose: false,
        onClick: function onClick() {
          location.href = "/account/wechatLogin.do?url=" + encodeURIComponent(location.href);
        }
      });
    }
    opt.data = {
      'isWechat': window.app.isFromWechat(),
      'message': opt.message,
      'isEpVersion': window.app.isEpVersion()
    };
    _MDWindowView["default"].prototype.initialize.call(this, opt);
    this.listenTo(window.app.pathRouter, 'route', function () {
      self.close();
    });
  },
  show: function show(opts) {
    var z_maxIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
    opts = _.extend({}, opts, {
      layer: z_maxIndex
    });
    _MDWindowView["default"].prototype.show.call(this, opts);
  },
  gotoLogin: function gotoLogin() {
    location.href = "/account/login.do?url=" + encodeURIComponent(location.href);
  },
  gotoRegister: function gotoRegister() {
    location.href = "/account/signup.do?url=" + encodeURIComponent(location.href);
  },
  wechatLogin: function wechatLogin($e) {
    location.href = "/account/wechatLogin.do?url=" + encodeURIComponent(location.href);
    return false;
  }
});
var _default = exports["default"] = MDInnerLoginWindowView;

},{"101":101,"106":106,"108":108,"1115":1115,"1117":1117,"1118":1118,"1184":1184,"1432":1432,"1454":1454,"18":18,"793":793,"811":811,"93":93}],1117:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var Code = {
  Email_Illegal: 208,
  Email_Exist_Error: 201,
  Uname_Illegal: 209,
  Pwd_Illegal: 210,
  ValidateCode_Error: 235,
  Email_Not_Exist: 202,
  Pwd_UnMatch: 206,
  Wrong_SmsCode: 234,
  Phone_Exist: 237,
  SmsCode_Exprie: 238,
  Params_Illegal: 2,
  Unbinded_Phone: 229,
  Phone_Format_Error: 2,
  Account_NotExist: 203,
  Account_Frozen: 230,
  WaitToSendCode: 231,
  EP_Account_Frozen: 224,
  Not_Enterprise_User: 223,
  Too_Many_Times: 219,
  LoginTokenError: 10000,
  WebSiginDesKeyError: 10001,
  CanNotUseOldPassword: 10100
};
var _default = exports["default"] = Code;

},{"1454":1454}],1115:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require(1175));
var _createClass2 = _interopRequireDefault(require(1179));
var _get2 = _interopRequireDefault(require(1181));
var _getPrototypeOf2 = _interopRequireDefault(require(1182));
require(1435);
require(1437);
require(1477);
require(1498);
require(1541);
var _regexp = _interopRequireDefault(require(106));
var _common = _interopRequireDefault(require(1116));
var _error = _interopRequireDefault(require(1118));
var _SMSType = _interopRequireDefault(require(101));
//
// 验证码获取
// Created by manjun.han
// 2017.5.29
//

function ensureDivHasUniqueId(divElement) {
  // 检查是否已经是 Element 对象（避免选择器字符串误传）
  if (!(divElement instanceof HTMLElement)) {
    console.error("请传入一个 DOM 元素对象");
    return;
  }

  // 如果没有 id，则生成一个唯一 id
  if (!divElement.id) {
    // 生成唯一 id（基于时间戳 + 随机数）
    var uniqueId = "div-" + Date.now() + "-" + Math.floor(Math.random() * 10000);
    divElement.id = uniqueId;
  }
}
var VerifyCodeButton = exports["default"] = /*#__PURE__*/function () {
  function VerifyCodeButton(opt) {
    (0, _classCallCheck2["default"])(this, VerifyCodeButton);
    (0, _get2["default"])((0, _getPrototypeOf2["default"])(VerifyCodeButton.prototype), "constructor", this).call(this, opt);
    this.initProps(opt);
  }
  (0, _createClass2["default"])(VerifyCodeButton, [{
    key: "initProps",
    value: function initProps(opt) {
      this.isPhoneType = opt.isPhoneType || true;
      this.verifyCodeType = opt.verifyCodeType;
      this.$generateCodeBtn = $(opt.el);
      this.timerId = -1;
      this.$targetInput = $(opt.targetInput);
      this.$vcodeInput = opt.vcodeInput ? $(opt.vcodeInput) : $(opt.targetInput);
      this.autoDetect = opt.autoDetect || false;
      this.noNeedValidate = opt.noNeedValidate || false;
      this.codeSubmitBtn = opt.codeSubmitBtn || undefined;
      this.initEvents();
      this.isApplyEp = opt.isApplyEp || false, this.interceptor = opt.interceptor || undefined;
      this.isApplyAi = opt.isApplyAi || false;
    }
  }, {
    key: "sendSmsCode",
    value: function sendSmsCode(phone) {
      var _this = this;
      $.ajax("/account/getSMSCode.do", {
        method: "post",
        data: {
          phone: phone,
          verifyCodeType: this.verifyCodeType,
          token: _common["default"].getEncrptToken()
        },
        success: function success(data) {
          if (!data["success"]) {
            _common["default"].showError(_this.$targetInput, data["msg"]);
            _this.reset();
            $("#j-vcode-2").attr("src", "/validate/getValidateCode.do" + "?t=" + Math.round(Math.random() * 10000));
          }
        }
      });
    }
  }, {
    key: "getSmsCode",
    value: function getSmsCode(param) {
      var _this2 = this;
      $.ajax("/account/getSMSCode.do", {
        method: "post",
        data: {
          phone: param.phone,
          // imageVerifyCode: param.vcode,
          verifyCodeType: this.verifyCodeType,
          token: _common["default"].getEncrptToken()
        },
        success: function success(data) {
          if (!data["success"]) {
            if (data["code"] == 2) {
              data["msg"] = BabelStr.str(7403);
            }
            if (data["code"] == 235 || data["code"] == 242 || data["code"] == 237) {
              // common.showError(this.$vcodeInput, data["msg"]);
              _common["default"].showError(_this2.$targetInput, data["msg"]);
            }
            //  else if(data.code == 236 && $('.sign-alert-contain.vcode').length) {
            //     $('.sign-alert-contain.vcode').show()
            // }
            else {
              // $(".m-alert-overlayer").hide();
              // $(".sign-alert-contain.vcode").hide();
              _common["default"].showError(_this2.$targetInput, data["msg"]);
            }
            _this2.reset();

            // $("#j-vcode-2").attr(
            //   "src",
            //   "/validate/getValidateCode.do" +
            //     "?t=" +
            //     Math.round(Math.random() * 10000)
            // );
          } else {
            // $(".m-alert-overlayer").hide();
            // $(".sign-alert-contain.vcode").hide();
            // $('#j-vcode-2').attr('src', '/validate/getValidateCode.do' + '?t=' + Math.round(Math.random() * 10000))
          }
        }
      });
    }
  }, {
    key: "validatePhone",
    value: function validatePhone(value) {
      var validate = true;
      if (value.length == 0) {
        _common["default"].showError(this.$targetInput, _error["default"].PHONE_EMPTY);
        validate = false;
      } else if (!_regexp["default"].phone.test(value)) {
        _common["default"].showError(this.$targetInput, _error["default"].PHONE_ILLEGAL);
        validate = false;
      }
      return validate;
    }
  }, {
    key: "validateEmail",
    value: function validateEmail(value) {
      var validate = true;
      if (value.length == 0) {
        _common["default"].showError(this.$targetInput, _error["default"].EMAIL_EMPTY);
        validate = false;
      } else if (!_regexp["default"].isLoginEmail(value)) {
        _common["default"].showError(this.$targetInput, _error["default"].EMAIL_ILLEGAL);
        validate = false;
      }
      return validate;
    }
  }, {
    key: "validateAuto",
    value: function validateAuto(value) {
      var validate = true;
      if (value.length == 0) {
        _common["default"].showError(this.$targetInput, _error["default"].Field_Empty);
        validate = false;
      } else if (!_regexp["default"].isLoginEmail(value) && !_regexp["default"].phone.test(value)) {
        _common["default"].showError(this.$targetInput, _error["default"].EmailAndPhone_Illegal);
        validate = false;
      }
      return validate;
    }
  }, {
    key: "sendEmailVerifyCode",
    value: function sendEmailVerifyCode(value, vcode) {
      var _this3 = this;
      $.ajax("/account/sendEmailVerifyCode.do", {
        method: "post",
        data: {
          email: value,
          verifyCodeType: this.verifyCodeType
          // imageVerifyCode: vcode,
        },
        success: function success(data) {
          if (!data["success"]) {
            if (data["code"] == 235 || data["code"] == 242 || data["code"] == 237) {
              _common["default"].showError(_this3.$targetInput, data["msg"]);
            }
            //  else if(data.code == 236 && $('.sign-alert-contain.vcode').length) {
            //     $('.sign-alert-contain.vcode').show()
            // }
            else {
              // $(".m-alert-overlayer").hide();
              // $(".sign-alert-contain.vcode").hide();
              _common["default"].showError(_this3.$targetInput, data["msg"]);
            }
            _this3.reset();

            // $("#j-vcode-2").attr(
            //   "src",
            //   "/validate/getValidateCode.do" +
            //     "?t=" +
            //     Math.round(Math.random() * 10000)
            // );
          } else {
            // $(".m-alert-overlayer").hide();
            // $(".sign-alert-contain.vcode").hide();
            // $('#j-vcode-2').attr('src', '/validate/getValidateCode.do' + '?t=' + Math.round(Math.random() * 10000))
          }
        }
      });
    }
  }, {
    key: "initEvents",
    value: function initEvents() {
      var _this4 = this;
      if (!this.$generateCodeBtn.length) {
        console.log("不存在元素", this.$generateCodeBtn);
        return;
      }
      var btn = this.$generateCodeBtn[0];
      ensureDivHasUniqueId(btn);
      $("body").append("<div class=\"".concat(btn.id, "-block\"></div>"));
      $(".".concat(btn.id, "-block")).slideVerify({
        baseUrl: location.origin,
        //服务器请求地址, 默认地址为安吉服务器;
        mode: "pop",
        //展示模式
        containerId: btn.id,
        //pop模式 必填 被点击之后出现行为验证码的元素id
        imgSize: {
          //图片的大小对象,有默认值{ width: '310px',height: '155px'},可省略
          width: "400px",
          height: "200px"
        },
        lan: BabelStr.getCurrentLanguage(),
        barSize: {
          //下方滑块的大小对象,有默认值{ width: '310px',height: '50px'},可省略
          width: "400px",
          height: "40px"
        },
        beforeCheck: function beforeCheck() {
          //检验参数合法性的函数  mode ="pop"有效
          if (_this4.$generateCodeBtn.hasClass("disabled")) {
            return;
          }
          var value = $.trim(_this4.$targetInput.val());
          var vcode = $.trim(_this4.$vcodeInput.val());
          if (_.isFunction(_this4.interceptor) && _this4.interceptor(_regexp["default"].phone.test(value))) {
            return;
          }
          if (vcode.length == 0) {
            vcode = undefined;
          }
          var validate = true;
          //
          // 自动检测字段是否是邮箱或手机号
          //
          if (!_this4.noNeedValidate) {
            if (_this4.autoDetect) {
              // validate =
              _this4.isPhoneType = !_regexp["default"].phone.test(value) ? false : true;
              validate = _this4.validateAuto(value);
            } else {
              if (_this4.isPhoneType) {
                validate = _this4.validatePhone(value);
              } else {
                validate = _this4.validateEmail(value);
              }
            }
          } else {
            _this4.isPhoneType = !_regexp["default"].phone.test(value) ? false : true;
          }
          if (!validate) {
            return;
          } else {
            if (!value) {
              return;
            }
            // if (this.isPhoneType) {
            //   if (!window.isPrivateCloud) {
            //     var selectedCountryData =
            //     this.$targetInput.intlTelInput && this.$targetInput.intlTelInput("getSelectedCountryData") || {};
            //     if (
            //       selectedCountryData.dialCode &&
            //       selectedCountryData.dialCode != "86"
            //     ) {
            //       value = selectedCountryData.dialCode + "-" + value;
            //     }
            //   }

            //   if(this.isApplyEp) {
            //     this.getUserInfoByPhone(value)

            //   // }else if (this.verifyCodeType == 3) {
            //   } else if (this.isApplyAi) {
            //     this.getUserInfoByPhoneForAi(value);
            //   } else {
            //     $('#j-vcode-2').attr('src', '/validate/getValidateCode.do' + '?t=' + Math.round(Math.random() * 10000))
            //     $(".m-alert-overlayer").show();
            //     $(".sign-alert-contain.vcode").show();
            //   }
            //   // else {
            //   //   this.getSmsCode({
            //   //     phone: value,
            //   //     vcode: vcode
            //   //   })
            //   //   this.timeOut();
            //   // }
            // } else {
            //   $('#j-vcode-2').attr('src', '/validate/getValidateCode.do' + '?t=' + Math.round(Math.random() * 10000))
            //   $(".m-alert-overlayer").show();
            //   $(".sign-alert-contain.vcode").show();
            //   // this.sendEmailVerifyCode(value);
            //   // this.timeOut();
            // }

            // this.isPhoneType ? this.sendSmsCode(value) : this.sendEmailVerifyCode(value)
          }
          return true;
        },
        ready: function ready() {},
        //加载完毕的回调
        success: function success(params) {
          var value = $.trim(_this4.$targetInput.val());
          if (_this4.isPhoneType) {
            if (!window.isPrivateCloud) {
              var selectedCountryData = _this4.$targetInput.intlTelInput && _this4.$targetInput.intlTelInput("getSelectedCountryData") || {};
              if (selectedCountryData.dialCode && selectedCountryData.dialCode != "86") {
                value = selectedCountryData.dialCode + "-" + value;
              }
            }
            if (_this4.isApplyEp) {
              _this4.getUserInfoByPhone(value);

              // }else if (this.verifyCodeType == 3) {
            } else if (_this4.isApplyAi) {
              _this4.getUserInfoByPhoneForAi(value);
            } else {
              _this4.getSmsCode({
                phone: value
              });
            }
            // else {
            //   this.getSmsCode({
            //     phone: value,
            //     vcode: vcode
            //   })
            //   this.timeOut();
            // }
          } else {
            // $("#j-vcode-2").attr(
            //   "src",
            //   "/validate/getValidateCode.do" +
            //     "?t=" +
            //     Math.round(Math.random() * 10000)
            // );
            // $(".m-alert-overlayer").show();
            // $(".sign-alert-contain.vcode").show();
            _this4.sendEmailVerifyCode(value);
            // this.timeOut();
          }
          _this4.timeOut();
        },
        error: function error() {} //失败的回调
      });
      // $(".vcode-submit-btn").on("click.vcode", () => {
      //   let value = $.trim(this.$targetInput.val());
      //   let vcode = $.trim(this.$vcodeInput.val());
      //   if (!value || !vcode) {
      //     return;
      //   }
      //   if (!window.isPrivateCloud) {
      //     var selectedCountryData =
      //       this.$targetInput.intlTelInput("getSelectedCountryData") || {};
      //     if (
      //       selectedCountryData.dialCode &&
      //       selectedCountryData.dialCode != "86"
      //     ) {
      //       value = selectedCountryData.dialCode + "-" + value;
      //     }
      //   }
      //   if (this.isPhoneType) {
      //     // if (this.verifyCodeType == 3) {
      //     this.getSmsCode({
      //       phone: value,
      //       vcode: vcode,
      //     });
      //     // } else {
      //     //   this.sendSmsCode(value)
      //     // }
      //   } else {
      //     this.sendEmailVerifyCode(value, vcode);
      //   }
      //   this.timeOut();
      // });

      $(".continue-apply .cancel-apply-btn").on("click.vcode", function (e) {
        $(".sign-alert-contain.continue-apply").hide();
        $(".m-alert-overlayer").hide();
      });
      $(".ep-member .cancel-apply-btn").on("click.vcode", function (e) {
        $(".sign-alert-contain.ep-member").hide();
        $(".m-alert-overlayer").hide();
      });
      $(".continue-apply .continue-apply-btn").on("click.vcode", function (e) {
        var value = $.trim(_this4.$targetInput.val());
        if (_this4.isPhoneType) {
          if (!window.isPrivateCloud) {
            var selectedCountryData = _this4.$targetInput.intlTelInput && _this4.$targetInput.intlTelInput("getSelectedCountryData") || {};
            if (selectedCountryData.dialCode && selectedCountryData.dialCode != "86") {
              value = selectedCountryData.dialCode + "-" + value;
            }
          }
        }
        _this4.getSmsCode({
          phone: value
        });
        $(".sign-alert-contain.continue-apply").hide();
        $(".m-alert-overlayer").hide();
        // $(".sign-alert-contain.vcode").show();
      });
    }
  }, {
    key: "getUserInfoByPhoneForAi",
    value: function getUserInfoByPhoneForAi(account) {
      var self = this;
      $.ajax({
        method: "post",
        url: "/user/queryUserByPhone.do",
        data: {
          email: account
        },
        success: function success(data, textStatus, jqXHR) {
          $("#j-vcode-2").attr("src", "/validate/getValidateCode.do" + "?t=" + Math.round(Math.random() * 10000));
          if (data.code == 0) {
            window.isRegister = true;
            self.verifyCodeType = _SMSType["default"].USER_LOGIN;
            $(".m-alert-overlayer").show();
            $(".sign-alert-contain.vcode").show();
          } else {
            self.verifyCodeType = _SMSType["default"].USER_REG;
            $(".m-alert-overlayer").show();
            $(".sign-alert-contain.vcode").show();
          }
        }
      });
    }
  }, {
    key: "getUserInfoByPhone",
    value: function getUserInfoByPhone(account) {
      var self = this;
      $.ajax({
        method: "post",
        url: "/user/queryUserByPhone.do",
        data: {
          email: account
        },
        success: function success(data, textStatus, jqXHR) {
          // $("#j-vcode-2").attr(
          //   "src",
          //   "/validate/getValidateCode.do" +
          //     "?t=" +
          //     Math.round(Math.random() * 10000)
          // );
          if (data.code == 0) {
            $(".m-alert-overlayer").show();
            window.isRegister = true;
            self.verifyCodeType = _SMSType["default"].USER_LOGIN;
            $("#j-apply-ep .pwd-input").attr("placeholder", BabelStr.str(9514));
            if (data.isEnterpriseMember) {
              $(".sign-alert-contain.ep-member").show();
            } else {
              $(".sign-alert-contain.continue-apply").show();
              var babelType = data.editionId ? BabelStr.str(8347) : BabelStr.str(8348);
              $(".sign-alert-contain.continue-apply .babel-type").html(babelType);
              if (data.editionId) {
                $(".sign-alert-contain.continue-apply .continue-apply-btn").hide();
                $(".sign-alert-contain.continue-apply .cancel-apply-btn").html(BabelStr.str(156));
              } else {
                $(".sign-alert-contain.continue-apply .continue-apply-btn").show();
                $(".sign-alert-contain.continue-apply .cancel-apply-btn").html(BabelStr.str(3356));
              }
            }
          } else {
            self.getSmsCode({
              phone: account
            });
            //***发送短信
            // self.verifyCodeType = SMSType.USER_REG;
            // $("#j-apply-ep .j-pwd").show();
            // $(".m-alert-overlayer").show();
            // $(".sign-alert-contain.vcode").show();
          }
        }
      });
    }
  }, {
    key: "timeOut",
    value: function timeOut() {
      var _this5 = this;
      //
      // 60秒间隔
      //
      clearInterval(this.timerId);
      var count = 60;
      this.$generateCodeBtn.addClass("disabled");
      var desc = BabelStr.str(7323) + " " + count;
      this.$generateCodeBtn.text(desc);
      this.timerId = setInterval(function () {
        desc = BabelStr.str(7323) + " " + --count;
        _this5.$generateCodeBtn.text(desc);
        if (count == 0) {
          _this5.reset();
        }
      }, 1000);
    }
  }, {
    key: "reset",
    value: function reset() {
      this.$generateCodeBtn.removeClass("disabled");
      this.$generateCodeBtn.text(BabelStr.str(4737));
      clearInterval(this.timerId);
    }
  }]);
  return VerifyCodeButton;
}();
$(".closeBtn").on("click", function () {
  $(".m-alert-overlayer").hide();
  $(".sign-alert-contain.vcode").hide();
  $("#j-vcode-img").attr("src", "/validate/getValidateCode.do" + "?t=" + Math.round(Math.random() * 10000));
});

},{"101":101,"106":106,"1116":1116,"1118":1118,"1175":1175,"1179":1179,"1181":1181,"1182":1182,"1184":1184,"1435":1435,"1437":1437,"1454":1454,"1477":1477,"1498":1498,"1541":1541}],1181:[function(require,module,exports){
var superPropBase = require(1193);
function _get() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    module.exports = _get = Reflect.get.bind(), module.exports.__esModule = true, module.exports["default"] = module.exports;
  } else {
    module.exports = _get = function _get(target, property, receiver) {
      var base = superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  }
  return _get.apply(this, arguments);
}
module.exports = _get, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"1193":1193}],1193:[function(require,module,exports){
var getPrototypeOf = require(1182);
function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = getPrototypeOf(object);
    if (object === null) break;
  }
  return object;
}
module.exports = _superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"1182":1182}],1182:[function(require,module,exports){
function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _getPrototypeOf(o);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],1179:[function(require,module,exports){
var toPropertyKey = require(1196);
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"1196":1196}],1175:[function(require,module,exports){
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],1118:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDLocalString = _interopRequireDefault(require(1150));
var _default = exports["default"] = {
  USER_NAME_EMPTY: BabelStr.str(7388),
  USER_NAME_ERROR: BabelStr.str(7389),
  USER_NAME_FORMAT_ERROR: BabelStr.str(7390),
  PASSWORD_EMPTY: BabelStr.str(7391),
  REGISTER_PASSWORD_ILLEGAL: BabelStr.str(7392),
  USER_NAME_NOT_EXIST: BabelStr.str(7393),
  LOGIN_PASSWORD_ERROR: BabelStr.str(7394),
  EMAIL_ILLEGAL: BabelStr.str(7395),
  EMAIL_EMPTY: BabelStr.str(7396),
  VCODE_EMPTY: BabelStr.str(7397),
  VCODE_ERROR: BabelStr.str(7398),
  Email_Not_Exsit: BabelStr.str(7399),
  Pwd_UnMatch: BabelStr.str(7400),
  REG_PASSWORD_DIFF: BabelStr.str(7401),
  PHONE_EMPTY: BabelStr.str(7402),
  PHONE_ILLEGAL: BabelStr.str(7403),
  SMSCODE_EMPTY: BabelStr.str(7404),
  SMSCODE_ERROR: BabelStr.str(7405),
  LOGIN_KEY_ERROR: BabelStr.str(7406),
  Unbinded_Phone: BabelStr.str(7407),
  Account_NotExist: BabelStr.str(7408),
  SmsCode_Exprie: BabelStr.str(7409),
  Account_Frozen: BabelStr.str(7410),
  EmailAndPhone_Illegal: BabelStr.str(7411),
  Field_Empty: BabelStr.str(7412),
  VerifyCode_Error: BabelStr.str(7413),
  VerifyCode_Empty: BabelStr.str(7414),
  Not_Enterprise_User: BabelStr.str(7415),
  No_role_selected: BabelStr.str(7416),
  NO_EPNAME: BabelStr.str(7417),
  NO_CONTACTS_NAME: BabelStr.str(7418),
  NO_CONTACTS_EMAIL: BabelStr.str(7419),
  NO_EP_DOMAIN: BabelStr.str(7420),
  not_all_number: BabelStr.str(7421),
  ERROR_EP_DOMAIN: BabelStr.str(7422),
  PASSWORD_FORMAT_ERROR: BabelStr.str(7423)
};

},{"1150":1150,"1184":1184,"1454":1454}],1116:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1477);
require(1492);
require(1437);
require(1463);
require(1478);
var common = {
  showError: function showError($input, errorMsg) {
    var $error = $input.siblings('.form-control-error');
    if (!$error.length) {
      try {
        $error = $input.closest('.intl-tel-input').siblings('.form-control-error');
      } catch (e) {}
    }
    if (!$error.length) {
      return;
    }
    $error.text(errorMsg).addClass('show');
    $error[0].offsetWidth;
    $error.addClass('ani');
  },
  hideError: function hideError($input) {
    var $error = $input.siblings('.form-control-error');
    if (!$error.length) {
      try {
        $error = $input.closest('.intl-tel-input').siblings('.form-control-error');
      } catch (e) {}
    }
    if (!$error.length) {
      return;
    }
    if ($error.css('display') === 'none') return;
    // $error.one('transitionend webkitTransitionEnd', function() {
    $error.removeClass('show');
    // }).removeClass('ani');
    $error.removeClass('ani');
  },
  hideAllError: function hideAllError(form) {
    $('.form-control-error', form).removeClass('show ani');
  },
  /**
   * @description 禁用启用按钮，并设置相应按钮文字
   * @param {Object} button dom对象
   * @param {Boolean} isEnable false:禁用;true:启用
   * @param {String} text 按钮显示的文字
   */
  setButtonEnable: function setButtonEnable(button, isEnable, text) {
    if (button.hasAttribute('disabled')) {
      button.removeAttribute('disabled');
      button.value = text;
    }
    if (!isEnable) {
      button.setAttribute('disabled', 'disabled');
      button.value = text;
    }
  },
  escape: function escape(htmlString) {
    var escapeMapping = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#x27;'
    };
    if (htmlString) {
      return htmlString.toString().replace(/[&<>\"']/g, function (match) {
        return escapeMapping[match];
      });
    } else {
      return "";
    }
  },
  encrpt: function encrpt(data) {
    var key = $("#session-key").text();
    var iv = key;
    console.log("----> key:" + key);
    var _key2 = CryptoJS.enc.Utf8.parse(key); // key
    var _iv2 = CryptoJS.enc.Utf8.parse(iv); // iv
    var encrypted = CryptoJS.TripleDES.encrypt(data, _key2, {
      iv: _iv2,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  },
  getEncrptToken: function getEncrptToken() {
    var data = new Date().getTime().toString();
    var key = $("#session-key").text();
    var iv = key;
    console.log("----> key:" + key);
    var _key2 = CryptoJS.enc.Utf8.parse(key); // key
    var _iv2 = CryptoJS.enc.Utf8.parse(iv); // iv
    var encrypted = CryptoJS.TripleDES.encrypt(data, _key2, {
      iv: _iv2,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  }
};
var _default = exports["default"] = common;

},{"1437":1437,"1454":1454,"1463":1463,"1477":1477,"1478":1478,"1492":1492}],793:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 *
 */

var ValidateHelper = {};
_.extend(ValidateHelper, {
  showError: function showError(input, msg) {
    ValidateHelper._showMsg(input, msg, true);
  },
  showOk: function showOk(input, msg) {
    ValidateHelper._showMsg(input, msg, false);
  },
  _showMsg: function _showMsg(input, msg, error) {
    var $ipt = $(input);
    var $errorTip = $ipt.data('errorTip');
    if (!!!$errorTip) {
      $errorTip = $('<span class="form-control-error">');
      $ipt.closest('.form-item').append($errorTip);
    }
    var className = 'form-control-error';
    if (!error) {
      className = 'form-control-no-error';
    }
    ;
    $errorTip.removeClass();
    $errorTip.addClass(className);
    $errorTip.text(msg).show();
    $errorTip[0].offsetWidth;
    $errorTip.addClass('ani');
    $ipt.data('errorTip', $errorTip);
    $ipt.one('mousedown', function () {
      ValidateHelper.hideError(this);
    });
  },
  hideError: function hideError(input) {
    var $ipt = $(input);
    var $errorTip = $ipt.data('errorTip');
    if ($errorTip.css('display') === 'none') return;
    $errorTip.one('transitionend webkitTransitionEnd', function () {
      $errorTip.removeClass('show');
    }).removeClass('ani');
  }
});
var _default = exports["default"] = ValidateHelper;

},{"1454":1454}],101:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var SMSType = {
  USER_REG: 3,
  USER_LOGIN: 2,
  BIND_PHONE: 1,
  FIND_PWD: 4,
  INIT_PWD: 5,
  REBIND_PHONE: 6,
  OUTSIDE_LOGIN: 7,
  APPLY_EP: 8
};
var _default = exports["default"] = SMSType;

},{"1454":1454}],93:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1424);
require(1417);
require(1463);
var _MDFocusManager = _interopRequireDefault(require(44));
var _MDLayerManager = _interopRequireDefault(require(48));
var _keycode = _interopRequireDefault(require(104));
var _MMViewBase = _interopRequireDefault(require(22));
/**
 *  Window view
 *  Create by manjun.han
 *
 */

/**
 * 底部action按钮对齐方式
 * @enum {string}
 */
var ButtonAlign = {
  'left': 'text-left',
  'right': 'text-right',
  'center': 'text-center'
};
var DEFAULTS = {
  bodyOverflowHidden: false,
  enableMobileHook: false,
  disableAutoFocusWhenClose: false,
  allowFormControlDisable: true,
  parent: document.body
};
var MDWindowView = _MMViewBase["default"].extend({
  el: '<div class="m-window" tabindex="1"></div>',
  tmpl: function tmpl() {
    var stringBuilder = [];
    var content = _.isFunction(this.contentTmpl) ? this.contentTmpl() : this.contentTmpl;
    stringBuilder.push(this.headerTmpl());
    stringBuilder.push('<section class="window-body">');
    stringBuilder.push(content);
    stringBuilder.push('</section>');
    stringBuilder.push('<footer class="window-footer"></footer>');
    return stringBuilder.join("");
  },
  headerTmpl: function headerTmpl() {
    if (this.headerMode === 'modern') {
      return '<header class="window-header header-modern">' + '<div class="header-main"><span class="title"></span><p class="subtitle f-hide"></p></div>' + '<button class="icon closeBtn"></button></header>';
    }
    return '<header class="window-header"><span class="title"></span><button class="icon closeBtn"></button></header>';
  },
  /**
   * This property needed to be overrided by subclass
   * @type {String | Function}
   */
  contentTmpl: "",
  /**
   * This method can be overrided by subclass,but must call super's method
   *
   * events:function(){
   *    var supEvent = MMWindowView.property.events.call(this) ;
   *    return _.extend({},supEvent,{
   *      // subClass events
   *    })
   * }
   */
  events: function events() {
    var superE = _MMViewBase["default"].prototype.events.call(this);
    return _.extend(superE, {
      "click >header .closeBtn": this._onCloseButtonClick
    });
  },
  initProps: function initProps() {
    var superP = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superP, {
      width: 540,
      size: '',
      // large , normal
      height: 'auto',
      title: '',
      headerMode: 'classic',
      // classic | modern
      subtitle: '',
      showFooter: true,
      onClose: null,
      data: {},
      buttons: [],
      modal: true,
      enableESC: true,
      enableMove: true,
      onShow: _.noop,
      onHide: _.noop,
      top: 'auto',
      enableMobileHook: undefined,
      // for dom refs
      $winLayoutWrapper: null,
      $header: null,
      $body: null,
      $footer: null,
      $title: null,
      $overlayer: null,
      buttonsAlign: 'right',
      disableClose: false,
      hiddenClose: false,
      animated: true,
      bodyOverflowHidden: undefined,
      _preDocumentActiveEl: null,
      disableAutoFocusWhenClose: undefined,
      allowFormControlDisable: undefined,
      needVerticalMiddleAlign: false,
      parent: document.body,
      needFooter: true,
      withBodyPadding: true
    });
  },
  /**
   * @typedef {object} ButtonConfig
   * @property {string}   label - button的label
   * @property {stirng}   [type='default'] - button的类型
   * @property {function} [onClick] - button的点击回调
   * @property {boolean}  [autoClose] - 点击button是否自动关闭窗口
   * @property {string}   [className] - button classname
   * @property {string}   [id] - id属性
   * @property {boolean}  [focused=undefined] - 是否获取焦点
   * @property {booelan}  [enabled] - 是否禁用
   */

  /**
   * @param {object} [opt] - 选项参数
   * @param {boolean} [opt.animated] - 是否动画显示或关闭窗口
   * @param {string} [opt.title] - 窗口标题
   * @param {ButtonAlign}   [opt.buttonsAlign='right'] - 底部aciton按钮对齐方式
   * @param {boolean} [opt.showFooter=true] - 是否显示底部footer部分
   * @param {function} [opt.onShow] - 显示后的回调
   * @param {function} [opt.onHide] - 窗口隐藏后的回调
   * @param {number} [opt.width=600] - 窗口的宽度
   * @param {(number|string)} [opt.height='auto'] - 窗口的高度
   * @param {boolean} [opt.enableESC=true] - 是否使用esc键关闭窗口
   * @param {boolean} [opt.enableMove=true] - 是否允许窗口拖动
   * @param {Array.<ButtonConfig>} [opt.buttons] - 窗口底部按钮
   * @param {boolean} [opt.disableClose] - 是否禁用右上角close按钮
   * @param {boolean} [opt.modal] - 是否是模态窗口
   * @param {boolean} [opt.disableAutoFocusWhenClose] - 窗口关闭后是否将浏览器焦点设置到之前的对象上
   * @param {HTMLElement|Selector} [opt.parent] - Window所要挂载的层
   */
  initialize: function initialize(opt) {
    var self = this;
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.setDefaults(DEFAULTS);
    this.$header = this.$(">header").eq(0);
    this.$body = this.$(">section").eq(0);
    this.$footer = this.$(">footer").eq(0);
    this.$title = this.$header.find(".title");
    this.setTitle(this.title);
    this.setSubtitle(this.subtitle);
    this.bindSelf(this._onKeyup, this.close);
    this.setButtonAlign(this.buttonsAlign);
    if (this.modal) {
      this.$overlayer = $('<div class="m-window-overlayer"></div>');
      $(this.parent).append(this.$overlayer);
    }
    this.$winLayoutWrapper = $("<div class='g-window'>").appendTo(this.parent);
    // 早于render之前，以便下级节点获得正确的参考尺寸

    if (this.size == 'normal') {
      this.width = 540;
    } else if (this.size == 'large') {
      this.width = 710;
    } else if (this.size == 'small') {
      this.width = 400;
    }
    if (_.isFunction(app.isMobile) && app.isMobile()) {
      var bw = $("body").width() - 20;
      if (this.width > bw) {
        this.width = bw;
      }
    }
    this.$el.css({
      height: this.height,
      width: this.width
    });
    if (this.enableESC) {
      $(document).on(this.$nsEventName('keyup'), this._onKeyup);
    }
    if (this.enableMove) {
      this._enableMove();
    }
    if (this.bodyOverflowHidden) {
      this.$body.addClass('with-clip');
    }
    this._preDocumentActiveEl = document.activeElement;
    if (this.hiddenClose) {
      this.$(".closeBtn").remove();
    }
    if (!this.withBodyPadding) {
      this.$el.addClass('without-padding');
    }
    if (!this.needFooter) {
      this.$footer.addClass('f-hide');
    }
  },
  hideElement: function hideElement() {
    this.$el.addClass('f-hide');
    this.$overlayer.addClass('f-hide');
    this.$winLayoutWrapper.addClass('f-hide');
  },
  showElement: function showElement() {
    this.$el.removeClass('f-hide');
    this.$overlayer.removeClass('f-hide');
    this.$winLayoutWrapper.removeClass('f-hide');
  },
  /**
   *
   * @param {[emnu<ButtonAlign>]} align
   */
  setButtonAlign: function setButtonAlign(align) {
    var preAlign = ButtonAlign[this.buttonsAlign];
    this.$footer.removeClass(preAlign);
    this.buttonsAlign = align || 'right';
    this.$footer.addClass(ButtonAlign[this.buttonsAlign]);
  },
  hideCloseBtn: function hideCloseBtn() {
    this.$(".closeBtn").addClass('f-hide');
  },
  showCloseBtn: function showCloseBtn() {
    this.$(".closeBtn").removeClass('f-hide');
  },
  _mobileHook: function _mobileHook() {
    var self = this;
    this._disableMove();
    this._centerLayout();
    $(window).on('resize.windowView', function () {
      self._centerLayout();
    });
  },
  _centerLayout: function _centerLayout() {
    var width = this.$el.outerWidth(),
      height = this.$el.outerHeight();
    this.$el.css({
      'left': ($(window).width() - width) / 2,
      'top': ($(window).height() - height) / 2,
      'margin': 0
    });
  },
  _disableMove: function _disableMove() {
    this.$header.off('mousedown');
  },
  _enableMove: function _enableMove() {
    this._disableMove();
    this.bindSelf(this._headerMouseDown, this._docMouseMove, this._docMouseUp);
    this.$header.mousedown(this._headerMouseDown);
  },
  _headerMouseDown: function _headerMouseDown($e) {
    this.$el.data('startX', $e.clientX);
    this.$el.data('startY', $e.clientY);
    $(document).on(this.$nsEventName('mousemove'), this._docMouseMove).on(this.$nsEventName('mouseup'), this._docMouseUp);
    // for chrome ,
    // remove the text selection , or the move will be problem
    var selection = window.getSelection();
    selection.removeAllRanges();
  },
  _docMouseMove: function _docMouseMove($e) {
    var curX = $e.clientX;
    var curY = $e.clientY;
    var deltaX = curX - this.$el.data('startX');
    var deltaY = curY - this.$el.data('startY');
    this.$el.data('startX', curX);
    this.$el.data('startY', curY);
    var curpos = this.$el.position();
    var left = curpos.left + deltaX;
    var top = curpos.top + deltaY;
    left = left < 0 ? 0 : left;
    top = top < 0 ? 0 : top;
    var winWidth = $(window).width();
    var winHeight = $(window).height() - 40;
    var width = this.$el.outerWidth();
    var height = this.$el.outerHeight();
    if (left + width > winWidth && winWidth > width) {
      left = winWidth - width;
    }
    if (top + height > winHeight && winHeight > height) {
      top = winHeight - height;
    }
    this.$el.css('left', left);
    this.$el.css('top', top);
    this.$header.css('cursor', 'move');
  },
  _docMouseUp: function _docMouseUp($e) {
    $(document).off(this.$nsEventName('mousemove'), this._docMouseMove).off(this.$nsEventName('mouseup'), this._docMouseUp);
    this.$header.css('cursor', 'default');
  },
  /**
   * 参见initialize方法中关于opt的说明
   * @param  {object} opt
   */
  show: function show(opt) {
    var self = this;
    try {
      // IE11全屏下blur()会报错
      // 获得DOM焦点，防止触发显示窗口的button再次点击后重新显示新的窗口
      document.activeElement && document.activeElement.blur();
    } catch (e) {}
    //
    // 解决在viewDidRendered方法中拿不到jQuery对象的问题，
    // 此处应该用PopupManager来管理，或许比较好
    //
    this.renderTo(this.$winLayoutWrapper);
    if (!this.showFooter || this.buttons.length <= 0) {
      this.$footer.addClass("f-hide");
    } else {
      if (this.buttons.length > 0) {
        this._renderButtons(this.buttons);
      }
    }
    var top,
      winHeight = $(window).height();
    _.extend(this, opt);
    this.$el.css({
      height: this.height,
      width: this.width
    });
    this.setTitle(this.title);
    top = _.isNumber(this.top) ? this.top : 10; //(winHeight - this.$el.height())/4 ;
    top = top < 0 ? 0 : top;
    this.$el.css({
      left: ($(window).width() - this.width) / 2,
      top: top
    });
    this.enableMobileHook && this._mobileHook();
    if (this.needVerticalMiddleAlign) {
      this._centerLayout();
    }
    if (this.animated) {
      this.$el.addClass('animated');
      this.$overlayer && this.$overlayer.addClass("animated");
      this.$el.animationEndOnce(function () {
        if (_.isFunction(self.onShow)) {
          self.onShow();
        }
        self.$el.removeClass('fadeInDown');
        self.$overlayer && self.$overlayer.removeClass("fadeIn");
      }).addClass("fadeInDown");
      this.$overlayer && this.$overlayer.addClass("fadeIn");
    }
    var layer = _MDLayerManager["default"].getLayer();
    layer = this.layer || layer;
    // layer = 700000000;

    this.realLayer = layer;
    this.$winLayoutWrapper.css('z-index', layer);
    this.$overlayer && this.$overlayer.css('z-index', layer);
    _MDFocusManager["default"].setFocus(this);
  },
  getZindex: function getZindex() {
    return this.realLayer;
  },
  setButtons: function setButtons(buttons) {
    this.$footer.empty();
    buttons.length && this.$footer.removeClass("f-hide");
    this._renderButtons(buttons);
  },
  _renderButtons: function _renderButtons(buttons) {
    var self = this;
    this.buttons = buttons;
    _.each(buttons, function (button, index) {
      var label = button.label || "",
        onClick = button.onClick,
        type = button.type || "",
        autoClose = _.isBoolean(button.autoClose) ? button.autoClose : true,
        enabled = _.isBoolean(button.enabled) ? button.enabled : true,
        $button = null;
      if (self.isEmptyString(label)) {
        return true;
      }
      var className = 'button';
      switch (type) {
        case 'danger':
          className += ' danger';
          break;
        case 'done':
          className += ' done';
          break;
        case 'pass':
          className += ' pass';
          break;
        case 'reject':
          className += ' reject';
          break;
        default:
          className += ' default';
      }
      if (button.className) {
        className += ' ' + button.className;
      }
      $button = $("<button>");
      $button.text(label);
      $button.addClass(className);
      $button.prop("disabled", !enabled);
      _.isString(button.id) && $button.attr('id', button.id);
      self.$footer.append($button);
      if (button.focused && enabled) {
        $button.focus();
      }
      $button.click(function ($event) {
        if (self.isFunction(onClick)) {
          onClick.call(self, $event);
        }
        if (autoClose) {
          self.close();
        }
        $event.stopPropagation();
      });
    });
  },
  close: function close() {
    var self = this;
    _.isFunction(this.onClose) && this.onClose(this);
    if (this.animated) {
      this.$el.animationEndOnce(function ($e) {
        self.remove();
        if (_.isFunction(self.onHide)) {
          self.onHide();
        }
      });
      this.$el.addClass("fadeOutUp");
      this.$overlayer && this.$overlayer.addClass("fadeOut");
    } else {
      self.remove();
    }
    if (!this.disableAutoFocusWhenClose) {
      this._preDocumentActiveEl && this._preDocumentActiveEl.focus();
    }
  },
  _onCloseButtonClick: function _onCloseButtonClick($e) {
    if (this.disableClose) {
      return;
    }
    this.close();
  },
  _onKeyup: function _onKeyup($e) {
    var key = $e.keyCode;
    if (!_MDFocusManager["default"].isFocused(this)) {
      return;
    }
    if (_keycode["default"].isEscKey(key) && !this.disableClose) {
      this.close();
    }
  },
  setDisableClose: function setDisableClose(disabled) {
    this.disableClose = disabled;
    disabled ? this.$el.addClass('disabled') : this.$el.removeClass('disabled');
    this.setActionButtonDisabled(disabled);
  },
  setFormControlDisabled: function setFormControlDisabled(disabled) {
    this.$body.find('input,textarea,select,button').prop('disabled', disabled);
  },
  setActionButtonDisabled: function setActionButtonDisabled(disabled) {
    var $buttons = this.getActionButtons();
    $buttons.each(function () {
      $(this).prop('disabled', disabled);
      if (disabled) {
        $(this).addClass('disabled');
      } else {
        $(this).removeClass('disabled');
      }
    });
  },
  setDisabled: function setDisabled(disabled) {
    this.setDisableClose(disabled);
    this.setActionButtonDisabled(disabled);
    if (this.allowFormControlDisable) {
      this.setFormControlDisabled(disabled);
    }
  },
  remove: function remove() {
    _MMViewBase["default"].prototype.remove.call(this);
    this.$overlayer && this.$overlayer.remove();
    this.$winLayoutWrapper.remove();
    $(document).off(this.$nsEventName("keyup"), this._onKeyup);
  },
  setTitle: function setTitle(title) {
    if (this.$title) {
      this.$title.html(title);
      this.title = title;
    }
    ;
  },
  setSubtitle: function setSubtitle(subtitle) {
    this.subtitle = subtitle;
    var $subtitle = this.$header && this.$header.find(".subtitle");
    if ($subtitle && $subtitle.length) {
      $subtitle.html(subtitle || '');
      $subtitle.toggleClass('f-hide', !subtitle);
    }
  },
  getActionButtons: function getActionButtons() {
    var $buttons = this.$footer.find('.button');
    return $buttons;
  },
  setActionButtonDisabledByIndex: function setActionButtonDisabledByIndex(disabled, index) {
    var $buttons = this.getActionButtons();
    $buttons.eq(index).prop('disabled', disabled);
  },
  // default append to #bd section
  addSubView: function addSubView(subView, opt_parent, opt_slot) {
    opt_parent = opt_parent || this.$body[0];
    _MMViewBase["default"].prototype.addSubView.call(this, subView, opt_parent, opt_slot);
  },
  addSubViewAt: function addSubViewAt(subView, index, opt_parent, opt_slot) {
    opt_parent = opt_parent || this.$body[0];
    _MMViewBase["default"].prototype.addSubViewAt.call(this, subView, index, opt_parent, opt_slot);
  },
  /**
   * 通过选择器获取dom
   * @param  {string} selector - button的DOM选择器
   * @return {jQuery}
   */
  getActionButton: function getActionButton(selector) {
    return this.$footer.find(selector);
  },
  viewDidUnRendered: function viewDidUnRendered() {
    _MMViewBase["default"].prototype.viewDidUnRendered.call(this);
    _MDFocusManager["default"].removeFocus(this);
    _MDLayerManager["default"].releaseLayer();
    $('.simple-tooltip').remove();
  },
  getBody$El: function getBody$El() {
    return this.$body;
  }
}, {
  setDefaults: function setDefaults(options) {
    _.extend(DEFAULTS, options);
  }
});
var _default = exports["default"] = MDWindowView;

},{"104":104,"1184":1184,"1417":1417,"1424":1424,"1454":1454,"1463":1463,"22":22,"44":44,"48":48}],104:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _UA = _interopRequireDefault(require(110));
var keycode = {
  codes: {
    WIN_KEY_FF_LINUX: 0,
    MAC_ENTER: 3,
    BACKSPACE: 8,
    TAB: 9,
    NUM_CENTER: 12,
    // NUMLOCK on FF/Safari Mac
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    PAUSE: 19,
    CAPS_LOCK: 20,
    ESC: 27,
    SPACE: 32,
    PAGE_UP: 33,
    // also NUM_NORTH_EAST
    PAGE_DOWN: 34,
    // also NUM_SOUTH_EAST
    END: 35,
    // also NUM_SOUTH_WEST
    HOME: 36,
    // also NUM_NORTH_WEST
    LEFT: 37,
    // also NUM_WEST
    UP: 38,
    // also NUM_NORTH
    RIGHT: 39,
    // also NUM_EAST
    DOWN: 40,
    // also NUM_SOUTH
    PRINT_SCREEN: 44,
    INSERT: 45,
    // also NUM_INSERT
    DELETE: 46,
    // also NUM_DELETE
    ZERO: 48,
    ONE: 49,
    TWO: 50,
    THREE: 51,
    FOUR: 52,
    FIVE: 53,
    SIX: 54,
    SEVEN: 55,
    EIGHT: 56,
    NINE: 57,
    FF_SEMICOLON: 59,
    // Firefox (Gecko) fires this for semicolon instead of 186
    FF_EQUALS: 61,
    // Firefox (Gecko) fires this for equals instead of 187
    FF_DASH: 173,
    // Firefox (Gecko) fires this for dash instead of 189
    QUESTION_MARK: 63,
    // needs localization
    A: 65,
    B: 66,
    C: 67,
    D: 68,
    E: 69,
    F: 70,
    G: 71,
    H: 72,
    I: 73,
    J: 74,
    K: 75,
    L: 76,
    M: 77,
    N: 78,
    O: 79,
    P: 80,
    Q: 81,
    R: 82,
    S: 83,
    T: 84,
    U: 85,
    V: 86,
    W: 87,
    X: 88,
    Y: 89,
    Z: 90,
    META: 91,
    // WIN_KEY_LEFT
    WIN_KEY_RIGHT: 92,
    CONTEXT_MENU: 93,
    NUM_ZERO: 96,
    NUM_ONE: 97,
    NUM_TWO: 98,
    NUM_THREE: 99,
    NUM_FOUR: 100,
    NUM_FIVE: 101,
    NUM_SIX: 102,
    NUM_SEVEN: 103,
    NUM_EIGHT: 104,
    NUM_NINE: 105,
    NUM_MULTIPLY: 106,
    NUM_PLUS: 107,
    NUM_MINUS: 109,
    NUM_PERIOD: 110,
    NUM_DIVISION: 111,
    F1: 112,
    F2: 113,
    F3: 114,
    F4: 115,
    F5: 116,
    F6: 117,
    F7: 118,
    F8: 119,
    F9: 120,
    F10: 121,
    F11: 122,
    F12: 123,
    NUMLOCK: 144,
    SCROLL_LOCK: 145,
    // OS-specific media keys like volume controls and browser controls.
    FIRST_MEDIA_KEY: 166,
    LAST_MEDIA_KEY: 183,
    SEMICOLON: 186,
    // needs localization
    DASH: 189,
    // needs localization
    EQUALS: 187,
    // needs localization
    COMMA: 188,
    // needs localization
    PERIOD: 190,
    // needs localization
    SLASH: 191,
    // needs localization
    APOSTROPHE: 192,
    // needs localization
    TILDE: 192,
    // needs localization
    SINGLE_QUOTE: 222,
    // needs localization
    OPEN_SQUARE_BRACKET: 219,
    // needs localization
    BACKSLASH: 220,
    // needs localization
    CLOSE_SQUARE_BRACKET: 221,
    // needs localization
    WIN_KEY: 224,
    MAC_FF_META: 224,
    // Firefox (Gecko) fires this for the meta key instead of 91
    MAC_WK_CMD_LEFT: 91,
    // WebKit Left Command key fired, same as META
    MAC_WK_CMD_RIGHT: 93,
    // WebKit Right Command key fired, different from META
    WIN_IME: 229,
    // We've seen users whose machines fire this keycode at regular one
    // second intervals. The common thread among these users is that
    // they're all using Dell Inspiron laptops, so we suspect that this
    // indicates a hardware/bios problem.
    // http://en.community.dell.com/support-forums/laptop/f/3518/p/19285957/19523128.aspx
    PHANTOM: 255
  },
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= keycode.codes.ZERO && keyCode <= keycode.codes.NINE) {
      return true;
    }
    if (keyCode >= keycode.codes.NUM_ZERO && keyCode <= keycode.codes.NUM_MULTIPLY) {
      return true;
    }
    if (keyCode >= keycode.codes.A && keyCode <= keycode.codes.Z) {
      return true;
    }

    // Safari sends zero key code for non-latin characters.
    if (_UA["default"].webkit && keyCode == 0) {
      return true;
    }
    switch (keyCode) {
      case keycode.codes.SPACE:
      case keycode.codes.QUESTION_MARK:
      case keycode.codes.NUM_PLUS:
      case keycode.codes.NUM_MINUS:
      case keycode.codes.NUM_PERIOD:
      case keycode.codes.NUM_DIVISION:
      case keycode.codes.SEMICOLON:
      case keycode.codes.FF_SEMICOLON:
      case keycode.codes.DASH:
      case keycode.codes.EQUALS:
      case keycode.codes.FF_EQUALS:
      case keycode.codes.COMMA:
      case keycode.codes.PERIOD:
      case keycode.codes.SLASH:
      case keycode.codes.APOSTROPHE:
      case keycode.codes.SINGLE_QUOTE:
      case keycode.codes.OPEN_SQUARE_BRACKET:
      case keycode.codes.BACKSLASH:
      case keycode.codes.CLOSE_SQUARE_BRACKET:
        return true;
      default:
        return false;
    }
  },
  isShiftKey: function isShiftKey(keyCode) {
    return keyCode == keycode.codes.SHIFT;
  },
  isEnterKey: function isEnterKey(keyCode) {
    return keyCode == keycode.codes.ENTER;
  },
  isEscKey: function isEscKey(keyCode) {
    return keyCode == keycode.codes.ESC;
  },
  isNumberKey: function isNumberKey(keyCode) {
    if (keyCode >= keycode.codes.ZERO && keyCode <= keycode.codes.NINE) {
      return true;
    }
    if (keyCode >= keycode.codes.NUM_ZERO && keyCode <= keycode.codes.NUM_MULTIPLY) {
      return true;
    }
  },
  isLetterKey: function isLetterKey(keyCode) {
    return !keycode.isLowerCaseLetterKey(keyCode) && !keycode.isUpperCase(keyCode);
  },
  isLowerCaseLetterKey: function isLowerCaseLetterKey(keyCode) {
    return keycode.isUpperCase(keyCode - 32);
  },
  isUpperCase: function isUpperCase(keyCode) {
    if (keyCode >= keycode.codes.A && keyCode <= keycode.codes.Z) {
      return true;
    }
  },
  isPageUpKey: function isPageUpKey(keyCode) {
    return keyCode == keycode.codes.UP;
  },
  isBackspace: function isBackspace(keyCode) {
    return keyCode == keycode.codes.BACKSPACE;
  },
  isDelete: function isDelete(keyCode) {
    return keyCode == keycode.codes.DELETE;
  }
};
var _default = exports["default"] = keycode;

},{"110":110,"1184":1184,"1454":1454}],48:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * 组件层次管理器
 *
 */
var ZIndex = 10000;
var _default = exports["default"] = {
  getLayer: function getLayer() {
    return ++ZIndex;
  },
  releaseLayer: function releaseLayer() {
    // return --ZIndex;
  }
};

},{"1454":1454}],272:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1439);
require(1477);
require(1466);
require(1421);
var _MMModelBase = _interopRequireDefault(require(21));
var _utils = _interopRequireDefault(require(108));
var _int = _interopRequireDefault(require(820));
var _regexp = _interopRequireDefault(require(106));
var _ENTERPRISE_PERMISSIONS_MANAGER = _interopRequireDefault(require(234));
var _ENTERPRISE_PERMISSIONS_FILE = _interopRequireDefault(require(233));
var _MMUserDataController = _interopRequireDefault(require(1108));
var _MDSignatureData = _interopRequireDefault(require(286));
var _MDSealData = _interopRequireDefault(require(283));
/**
 * MolaTask user model class
 *
 * Created by manjun.han
 * 2015.9.21
 */

// import MMNetDiskDataController from '../net/MMNetDiskDataController.js';

/**
 * @typedef {object} PersonnalEditionLimit
 * @property {number} editionId -
 * @property {number} basicSpace -
 * @property {number} cadLimit -
 * @property {boolean} canUpgradeSpace -
 * @property {string} name -
 * @property {number} teamLimit -
 * @property {number} threeDLimit -
 * @property {number} versionLimit -
 * @property {number} yearFee -
 */

var MDMolaUser = _MMModelBase["default"].extend({
  defaults: {
    id: -1,
    name: "",
    nickName: "",
    email: "",
    avatartype: -1,
    lastAccessTime: new Date(),
    // 用户登录系统的时间
    enrolltime: new Date(),
    isSponsor: false,
    sex: 1,
    uType: 0,
    shareTaskConfig: null,
    registered: true,
    userId: 0,
    anonymousName: window.localStorage ? window.localStorage.getItem("anonymousName") : undefined,
    roleId: -1,
    enterpriseRole: -1,
    level: 1,
    expiration: 1483266933,
    usedSpace: 0,
    totalSpace: 0,
    levelInfo: null,
    receiveEmailFlag: 1,
    recentAccessTime: null,
    status: -1,
    // 用户状态 目前 0正常 1停用
    onlineState: -1,
    // 在线状态 0离线 1在线
    joinEnterpriseTime: -1,
    // NEW  - 部门角色信息
    departments: [],
    // array of {departmentId, departmentName, roleId, roleName， time}

    // NEW  - 入职企业时间
    enrollEnterpriseTime: null,
    phone: null,
    enterpriseName: null,
    isEnterpriseManager: null,
    // 是否企业管理员
    guest: false,
    // 是否企业外用户？
    affiliatedCompany: "",
    // 所属公司
    device: "",
    //终端
    shareInfos: [],
    // 文件分享信息
    editionId: 1,
    contacts: "--",
    // 联系方式不用于登录
    /**
     * @property {PersonnalEditionLimit} personnalEditionLimit
     */
    personnalEditionLimit: {},
    maxUploadFileSize: 0,
    //单个文件上传大小限制
    isBindEmail: true,
    //
    // 前台字段
    //
    originalEmail: "",
    spaceLimit: 0,
    userExtraAttr: 0,
    canAccessMaterialLibrary: undefined,
    closeDirectOpenDep: 0
  },
  changePasswordAction: "user/modifyUserPassword.do",
  changeNameAction: "user/modifyUserName.do",
  bindMailAction: "user/bindUserEmail.do",
  postLoginAction: "/account/login.do",
  changePassword: function changePassword(newPwd, oldPwd, opt) {
    opt = _.extend({}, opt);
    opt.data = {
      password: oldPwd,
      newPassword: newPwd
    };
    var url = this.buildAppRequestURL(this.changePasswordAction);
    this.httpPost(url, opt);
  },
  postLogin: function postLogin(email, pwd, opt) {
    opt = _.extend({}, opt);
    opt.data = {
      email: email,
      password: pwd
    };
    var self = this,
      success = opt.onSuccess;
    opt.onSuccess = function (data, jqXhr, textStatus) {
      if (data["success"]) {
        self.set(data["user"]);
      }
      if (self.isFunction(success)) {
        success(data, jqXhr, textStatus);
      }
    };
    var url = this.buildAppRequestURL(this.postLoginAction);
    this.httpPost(url, opt);
  },
  changeName: function changeName(name, opt) {
    opt = _.extend({}, opt);
    opt.data = {
      name: name
    };
    var self = this,
      success = opt.onSuccess;
    opt.onSuccess = function (data, jqXhr, textStatus) {
      if (data["success"]) {
        self.set("name", name);
      } else {
        MMNetDiskDataController.errorProcess(data);
      }
      if (self.isFunction(success)) {
        success(data, jqXhr, textStatus);
      }
    };
    var url = this.buildAppRequestURL(this.changeNameAction);
    this.httpPost(url, opt);
  },
  initialize: function initialize(opts) {
    opts = _.extend({
      email: ""
    }, opts);
    _MMModelBase["default"].prototype.initialize.call(this, opts);
    this.set({
      originalEmail: opts.email,
      name: _.escape(_.unescape(opts.name))
    }, {
      silent: true
    });
  },
  getUserExtraAttr: function getUserExtraAttr() {
    return this.get("userExtraAttr");
  },
  getComputedUserExtraAttr: function getComputedUserExtraAttr(index, sign) {
    var result = this.getUserExtraAttr();
    if (sign) {
      result = result | Math.pow(2, index);
    } else {
      if (result & Math.pow(2, index)) {
        result = this.getUserExtraAttr() ^ Math.pow(2, index);
      }
    }
    return result;
  },
  setUserExtraAttr: function setUserExtraAttr(result) {
    this.set("userExtraAttr", result);
  },
  isEpFileTop: function isEpFileTop() {
    return this.getUserExtraAttr() & 1;
  },
  isCadSupport: function isCadSupport() {
    return this.get("cadSupport") == "GStarCAD";
  },
  getOriginalEmail: function getOriginalEmail() {
    return this.get("originalEmail");
  },
  getUserId: function getUserId() {
    var userId = this.get("userId");
    if (userId == 0 || userId == -1 || userId == undefined) {
      userId = this.get("id");
    }
    return userId;
  },
  setUserId: function setUserId(userId) {
    this.set("userId", userId);
  },
  getId: function getId() {
    return this.getUserId();
  },
  setId: function setId(id) {
    this.set("id", id);
  },
  getAvatarImageURL: function getAvatarImageURL(size, notForce) {
    var regMail = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
    var userId = this.getUserId();
    size = size ? size : 80;
    var t = new Date().getTime();
    if (notForce) {
      t = Math.floor(new Date().getTime() / 36000000); // 1 小时内不刷新
    }
    if (userId == -1 || this.get("accountType") || regMail.test(userId)) {
      return "img/avatar/anonymous.jpg";
    }
    return "/user/getUserAvatar.do?userId=" + userId + "&t=" + t + "&size=" + size;
  },
  bindEmail: function bindEmail(email, password, opt) {
    opt = _.extend({}, opt);
    opt.data = {
      email: email,
      password: password
    };
    var self = this,
      success = opt.onSuccess;
    opt.onSuccess = function (data, jqXhr, textStatus) {
      if (data["success"]) {
        self.set("email", email);
      } else {
        MMNetDiskDataController.errorProcess(data);
      }
      if (self.isFunction(success)) {
        success(data, jqXhr, textStatus);
      }
    };
    var url = this.buildAppRequestURL(this.bindMailAction);
    this.httpPost(url, opt);
  },
  //
  // 是否是匿名用户(未注册的用户)
  //
  isAnonymous: function isAnonymous() {
    return !this.logined();
  },
  //
  // 设置匿名用户的显示名
  //
  setAnonymousInfo: function setAnonymousInfo(name_, email_, callback_) {
    console.assert(this.isAnonymous() && !this.hasAnonymouseName());
    this.set("anonymousName", name_);
    if (window.localStorage) {
      window.localStorage.setItem("anonymousName", name_);
    }
    if (callback_) {
      callback_();
    }
  },
  getAnonymousName: function getAnonymousName() {
    var anonymousName = this.get("anonymousName");
    if (anonymousName) {
      return BabelStr.str(7039) + " - " + anonymousName;
    } else {
      return BabelStr.str(722);
    }
  },
  //
  // 是否已经设置过匿名用户的显示名？
  //
  hasAnonymouseName: function hasAnonymouseName() {
    if (this.get("anonymousName")) {
      return true;
    }
    return false;
  },
  getUserName: function getUserName() {
    if (!this.logined()) {
      return this.getAnonymousName();
    } else {
      return this.get("nickName") || this.get("name");
    }
  },
  setUserName: function setUserName(name) {
    this.set("name", name);
  },
  getUserId_Int: function getUserId_Int() {
    return new _int["default"](parseInt(this.getUserId()));
  },
  logined: function logined() {
    // var name = this.get('name');
    // return name && name.length > 0;
    return this.getId() != "0";
  },
  getDefaultSortDirIsAsc: function getDefaultSortDirIsAsc() {
    var isAsc = true;
    var defaultSortIndex = app.currentUser.get("defaultSortIndex");
    if (defaultSortIndex == "latestVersionTime") {
      isAsc = false;
    }
    return isAsc;
  },
  isFileOwner: function isFileOwner(ownerId) {
    return ownerId == this.getUserId();
  },
  isSelf: function isSelf(userId) {
    return this.getUserId() == userId;
  },
  isObjectCreator: function isObjectCreator(obj) {
    return this.getUserId() === obj.getCreator().toDecString();
  },
  isUnBindUser: function isUnBindUser() {
    return this.get("email").indexOf("-third-party-user") > 0;
  },
  isThirdAuthorizer: function isThirdAuthorizer() {
    return this.get("uType") > 0;
  },
  setUserInfo: function setUserInfo(uInfo) {
    this.set("userId", uInfo["id"]);
    this.set("name", uInfo["name"]);
    this.set("nickname", uInfo["nickname"]);
    this.set("totalSpace", uInfo["totalSpace"]);
    this.set("usedSpace", uInfo["usedSpace"]);
    this.set("userType", uInfo["userType"]);
  },
  getEmail: function getEmail() {
    var email = this.get("email");
    if (!_regexp["default"].isEmail(email)) {
      email = "--";
    }
    return email;
  },
  hasEmail: function hasEmail() {
    var email = this.get("email");
    var has = true;
    if (!_regexp["default"].isEmail(email)) {
      has = false;
    }
    return has;
  },
  getAccount: function getAccount() {
    var account = this.getPhone();
    if (!account) {
      account = this.get("email");
      if (!_regexp["default"].isEmail(account)) {
        account = "--";
      }
    }
    return account;
  },
  getWatermarkAccount: function getWatermarkAccount() {
    var account = this.get("originPhone");
    if (!account) {
      account = this.getPhone();
      if (!account) {
        account = this.get("originalEmail");
        if (!_regexp["default"].isEmail(account)) {
          account = this.get("email");
          if (!_regexp["default"].isEmail(account)) {
            account = this.get("babelId");
            if (!account) {
              account = "--";
            }
          }
        }
      }
    } else {
      var nickName = this.get("nickName");
      if (nickName) {
        var phone = account.substring(account.length - 4);
        if (nickName.length > 10) {
          nickName = nickName.substring(0, 10) + "..";
        }
        account = nickName + "(" + phone + ")";
      }
    }
    return account;
  },
  setEmail: function setEmail(email) {
    this.set("email", email);
    this.set("originalEmail", email);
  },
  getMemberOptions: function getMemberOptions() {
    return this.get('memberOptions') - 0;
  },
  setMemberOptions: function setMemberOptions(index, sign) {
    var result;
    if (sign) {
      result = this.getMemberOptions() | Math.pow(2, index);
    } else {
      if (this.getMemberOptions() & Math.pow(2, index)) {
        result = this.getMemberOptions() ^ Math.pow(2, index);
      } else {
        return;
      }
    }
    this.set('memberOptions', result);
  },
  isCloseAI: function isCloseAI() {
    return this.getMemberOptions() & 2; // 第一个权限位
  },
  isCloseSync: function isCloseSync() {
    return this.getMemberOptions() & 4; // 第2个权限位
  },
  getAvatarType: function getAvatarType() {
    return this.get("avatartype");
  },
  getLevel: function getLevel() {
    return this.get("level");
  },
  getExpiration: function getExpiration() {
    return this.get("expiration");
  },
  getExpirationDate: function getExpirationDate() {
    return new Date((this.get("expiration") - 0) * 1000);
  },
  getExpirationDateStr: function getExpirationDateStr() {
    var date = new Date(this.getExpiration() * 1000);
    return date.format("yyyy-MM-dd");
  },
  getRemainTime: function getRemainTime() {
    var today = new Date();
    var expireDate = this.getExpiration();
    if (!expireDate) {
      return 0;
    }
    expireDate = new Date().setTime(expireDate * 1000);
    var remain = expireDate - today;
    if (remain < 0) {
      remain = 0;
    }
    return remain;
  },
  getRemainDay: function getRemainDay() {
    var remain = Math.round(this.getRemainTime() / (24 * 60 * 60 * 1000));
    return remain;
  },
  // getRemainMoney:function(){
  //     var startTime = new Date().setTime(this.get('startTime')*1000);
  //     var endTime = new Date().setTime(this.getExpiration()*1000);
  //     var fullTime = endTime - startTime;

  //     var remainTime = this.getRemainTime();

  //     if (fullTime > 0 && remainTime > 0) {
  //         var remainMoney = this.get('money') * remainTime / fullTime;
  //         return Math.round(remainMoney);
  //     }
  //     return 0;
  // },

  calculateFee: function calculateFee(levelInfo) {
    var curLevelInfo = this.get("levelInfo");
    if (curLevelInfo) {
      var remainDay = this.getRemainDay();
      var fee = (levelInfo.getPrice() - curLevelInfo.getPrice()) * remainDay / 365;
      if (fee < 0) {
        fee = 0;
      }
      return fee;
    } else {
      console.error("not have current level info!");
      return levelInfo.getPrice();
    }

    // var remainMoney = this.getRemainMoney();
    // var needPay = fee - remainMoney;
    // return needPay < 0 ? 0:needPay;
  },
  setLevel: function setLevel(newLevel) {
    return this.set("level", newLevel);
  },
  setExpiration: function setExpiration(newExpiration) {
    return this.set("expiration", newExpiration);
  },
  setUsedSpace: function setUsedSpace(newUsedSpace) {
    return this.set("usedSpace", newUsedSpace);
  },
  setUsedSpaceJoin: function setUsedSpaceJoin(newUsedSpaceJoin) {
    return this.set("usedSpaceJoin", newUsedSpaceJoin);
  },
  setUsedSpaceTeam: function setUsedSpaceTeam(newUsedSpaceTeam) {
    return this.set("usedSpaceTeam", newUsedSpaceTeam);
  },
  setUsedSpaceHome: function setUsedSpaceHome(newUsedSpaceHome) {
    return this.set("usedSpaceHome", newUsedSpaceHome);
  },
  getUsedSpaceJoin: function getUsedSpaceJoin() {
    return this.get("usedSpaceJoin");
  },
  getUsedSpaceTeam: function getUsedSpaceTeam() {
    return this.get("usedSpaceTeam");
  },
  getUsedSpaceHome: function getUsedSpaceHome() {
    return this.get("usedSpaceHome");
  },
  setTotalSpace: function setTotalSpace(newTotalSpace) {
    return this.set("totalSpace", newTotalSpace);
  },
  getUsedSpace: function getUsedSpace() {
    return this.get("usedSpace");
  },
  getTotalSpace: function getTotalSpace() {
    return this.get("totalSpace");
  },
  setLevelInfo: function setLevelInfo(levelInfo) {
    this.set("levelInfo", levelInfo);
  },
  receiveEmailFlag: function receiveEmailFlag() {
    return this.get("receiveEmailFlag");
  },
  setReceiveEmailFlag: function setReceiveEmailFlag(notify) {
    this.set("receiveEmailFlag", notify);
  },
  isEpAdminUser: function isEpAdminUser() {
    return this.get("isEnterpriseManager");
  },
  isEpDocAdminUser: function isEpDocAdminUser() {
    return this.get("isDocManager");
  },
  // 是否是运维人员
  isOperatorAndMaintainer: function isOperatorAndMaintainer() {
    return this.getEnterpriseRoleId() == 16;
  },
  isEpManager: function isEpManager() {
    return this.getEnterpriseRoleId() == 13;
  },
  isEnterpriseGuest: function isEnterpriseGuest() {
    return this.get("guest") && this.get("guest") != -1;
  },
  getStatus: function getStatus() {
    return this.get("status");
  },
  getMaxUploadFileSize: function getMaxUploadFileSize() {
    return this.get("maxUploadFileSize");
  },
  getMaxUploadFileSizeStr: function getMaxUploadFileSizeStr() {
    var size = this.get("maxUploadFileSize");
    size = size / (1024 * 1024);
    if (size > 1024) {
      size = size / 1024;
      return size + "GB";
    } else {
      return size + "MB";
    }
  },
  getExactStatus: function getExactStatus() {
    var status = this.get("status");
    var state = this.get("onlineState");
    if (status === 1) {
      return 2; //冻结
    } else if (status === 0) {
      if (state === 0) {
        return 1; //离线
      } else {
        return 0; //在线
      }
    }
  },
  getCompany: function getCompany() {
    return this.get("affiliatedCompany");
  },
  getDevice: function getDevice() {
    return this.get("device");
  },
  getRecentAccessTime: function getRecentAccessTime() {
    var recentAccessTime = this.get("recentAccessTime");
    if (recentAccessTime) {
      var recent = new Date(recentAccessTime * 1000);
      return recent.format("yyyy-MM-dd HH:mm:ss");
    } else {
      return BabelStr.str(7040);
    }
  },
  getRecentAccessTimeCls: function getRecentAccessTimeCls() {
    var rTime = this.get("recentAccessTime");
    var nTime = new Date().getTime() / 1000;
    var time = nTime - rTime;
    if (!rTime) {
      return " C14 boldfont2";
    }
    if (time < 60 * 60 * 24 * 3) {
      return "";
    } else if (time >= 60 * 60 * 24 * 3 && time < 60 * 60 * 24 * 7) {
      return " blue";
    } else if (time >= 60 * 60 * 24 * 7 && time < 60 * 60 * 24 * 14) {
      return " Corange10";
    } else if (time >= 60 * 60 * 24 * 14) {
      return " C14";
    }
  },
  getLoginTime: function getLoginTime() {
    var recent = new Date(this.get("recentAccessTime") * 1000);
    var now = new Date();
    return _utils["default"].prettyDate(now, recent);
  },
  setPersonalEditionInfo: function setPersonalEditionInfo(personnalEditionLimit) {
    this.set("personnalEditionLimit", personnalEditionLimit);
    this.set("editionId", personnalEditionLimit["editionId"]);
  },
  inFreeEdition: function inFreeEdition() {
    var editionId = this.get("personnalEditionLimit")["editionId"];
    return editionId == !!0;
  },
  /**
   * 是否能创建团队
   * @param  {number} curTeamNum - 当前团队数量
   * @return {boolean}
   */
  canCreateTeam: function canCreateTeam(curTeamNum) {
    var teamLimit = this.get("personnalEditionLimit")["teamLimit"];
    if (_.isUndefined(teamLimit) || teamLimit == -1) {
      return true;
    }
    return teamLimit > curTeamNum;
  },
  canopenCadFile: function canopenCadFile() {
    if (this.inFreeEdition()) {
      return false;
    }
    return true;
  },
  hasBindPhone: function hasBindPhone() {
    return this.get("isBindPhone");
  },
  hasBindEmail: function hasBindEmail() {
    return this.get("isBindEmail") || _regexp["default"].isEmail(this.get("email"));
  },
  hasInitPwd: function hasInitPwd() {
    return !this.get("needChangePassword");
  },
  setHasInitPwd: function setHasInitPwd() {
    this.set("needChangePassword", false);
  },
  isUndefinedcanAccessMaterialLibrary: function isUndefinedcanAccessMaterialLibrary() {
    return _.isUndefined(this.getCanAccessMaterialLibrary());
  },
  getCanAccessMaterialLibrary: function getCanAccessMaterialLibrary() {
    return this.get('canAccessMaterialLibrary');
  },
  setCanAccessMaterialLibrary: function setCanAccessMaterialLibrary(canAccessMaterialLibrary) {
    return this.set('canAccessMaterialLibrary', canAccessMaterialLibrary);
  },
  getHideRecommendView: function getHideRecommendView() {
    return this.get('hideRecommendView');
  },
  setHideRecommendView: function setHideRecommendView(hideRecommendView) {
    return this.set('hideRecommendView', hideRecommendView);
  },
  getCloseDirectOpenDep: function getCloseDirectOpenDep() {
    return this.get('closeDirectOpenDep');
  },
  setCloseDirectOpenDep: function setCloseDirectOpenDep(closeDirectOpenDep) {
    return this.set('closeDirectOpenDep', closeDirectOpenDep);
  },
  getPhone: function getPhone() {
    return this.get("phone");
  },
  getContacts: function getContacts() {
    var contacts = this.get("contacts");
    if (!contacts) {
      contacts = "--";
    }
    return contacts;
  },
  setPhone: function setPhone(phone) {
    this.set("phone", phone);
  },
  getRoleId: function getRoleId() {
    return this.get("roleId");
  },
  setRoleId: function setRoleId(roleId) {
    return this.set("roleId", roleId);
  },
  toJSON: function toJSON() {
    var user = _.clone(this.attributes);
    user["email"] = this.getEmail();
    return user;
  },
  canBroadCastInEnt: function canBroadCastInEnt() {
    return !!(this.get("entPermission") & MDMolaUser.Permission.BroadCast);
  },
  canManageTag: function canManageTag() {
    return !!(this.get("entPermission") & MDMolaUser.Permission.ManageTag);
  },
  canManageTrash: function canManageTrash() {
    if (this.isEnterpriseGuest()) {
      return false;
    }
    return true;
    if (!app.isEpVersion()) {
      return true;
    }
    return !!(this.get("entPermission") & MDMolaUser.Permission.ManageTrash);
  },
  getEmailAddPhone: function getEmailAddPhone() {
    var obj = {
      emails: [],
      phones: []
    };
    if (this.getOriginalEmail()) {
      obj.emails.push(this.getOriginalEmail());
    } else {
      obj.phones.push(this.getPhone());
    }
    return obj;
  },
  isActivedUser: function isActivedUser() {
    return this.get("registered");
  },
  isMe: function isMe() {
    var id = this.getUserId();
    var curId = app.currentUser.getUserId();
    return id == curId;
  },
  getCreatorId: function getCreatorId() {
    return this.get("createBy");
  },
  getUserItemHtmlStr: function getUserItemHtmlStr(param) {
    return MDMolaUser.getUserItemHtmlStr(this, param);
  },
  getDepItemAsUserHtmlStr: function getDepItemAsUserHtmlStr(param) {
    var cls = param && param.cls || "";
    var str = '<li class="item flex-align middle ' + cls + '" data-id="' + this.getUserId() + '">';
    if (!param || !param.noImg) {
      str += '<div class="list-item img no-shrink"><div class="dep-icon"></div></div>';
    }
    str += '<div class="list-item name">' + this.getUserName() + "</div>";
    str += '<div class="list-item  col-auto"></div>';
    if (param && param.canRemove) {
      str += '<button class="list-item icon remove dep" user-id=' + this.getUserId() + "></button> ";
    }
    str += "</li>";
    return str;
  },
  getGroupItemAsUserHtmlStr: function getGroupItemAsUserHtmlStr(param) {
    var cls = param && param.cls || "";
    var str = '<li class="item flex-align middle uset-item-comp' + cls + '" data-id="' + this.getUserId() + '">';
    if (!param || !param.noImg) {
      str += '<div class="list-item img no-shrink"><div class="group-icon icon"></div></div>';
    }
    str += '<div class="list-item name">' + this.getUserName() + "</div>";
    str += '<div class="list-item  col-auto"></div>';
    if (param && param.canRemove) {
      str += '<button class="list-item icon remove dep" user-id=' + this.getUserId() + "></button> ";
    }
    str += "</li>";
    return str;
  },
  isUser: function isUser() {
    return !this.isDep() && !this.isGroup();
  },
  isDep: function isDep() {
    return this.get("participantType") == MDParticipantInfo.DEP_TYPE;
  },
  isGroup: function isGroup() {
    return this.get("participantType") == MDParticipantInfo.GROUP_TYPE;
  },
  getSpaceLimit: function getSpaceLimit() {
    return this.get("spaceLimit") / 1024;
  },
  setSpaceLimit: function setSpaceLimit(value) {
    var space = (value - 0) * 1024;
    this.set("spaceLimit", space);
  },
  getOwnFile: function getOwnFile() {
    return this.get("ownFile");
  },
  canOwnFile: function canOwnFile() {
    var sysMark = app.ep.get("canOwnPersonalFile");
    var i = this.getOwnFile();
    if (i == -1) {
      return sysMark == "1";
    } else if (i == 0) {
      return false;
    } else if (i == 1) {
      return true;
    }
  },
  getOwnFileStr: function getOwnFileStr() {
    var sysMark = app.ep.get("canOwnPersonalFile");
    var i = this.get("ownFile");
    var str = BabelStr.str(3636); // 系统默认
    var not = BabelStr.str(3637); // 不许可
    var can = BabelStr.str(3638); // 许可
    if (i == -1) {
      if (sysMark == 0) {
        str += "-" + not;
      } else {
        str += "-" + can;
      }
    } else if (i == 0) {
      str = not;
    } else if (i == 1) {
      str = can;
    }
    return str;
  },
  setOwnFile: function setOwnFile(sign) {
    // sign: 0 or 1
    return this.set("ownFile", sign);
  },
  getEnterpriseRoleId: function getEnterpriseRoleId() {
    var roleId = this.get("roleId");
    if (roleId == -1) {
      roleId = this.get("enterpriseRole");
    }
    return roleId;
  },
  canLoginEpManagePage: function canLoginEpManagePage() {
    var roleId = this.getEnterpriseRoleId();
    if (roleId == 13 || roleId == 14 || roleId == 15 || roleId == 16) {
      return true;
    } else {
      return false;
    }
  },
  canCurUserManageEpGroup: function canCurUserManageEpGroup() {
    var roleId = this.getEnterpriseRoleId();
    if (roleId == 13 || roleId == 16) {
      return true;
    } else {
      return false;
    }
  },
  isSecurityOfficer: function isSecurityOfficer() {
    var roleId = this.getEnterpriseRoleId();
    return roleId == 14;
  },
  isSafetyAuditor: function isSafetyAuditor() {
    var roleId = this.getEnterpriseRoleId();
    return roleId == 15;
  },
  canManageArchive: function canManageArchive() {
    var roleId = this.getEnterpriseRoleId();
    if (roleId == 13 || roleId == 11) {
      return true;
    } else {
      return false;
    }
  },
  getEnterFilePermission: function getEnterFilePermission() {
    return this.get("filePermission");
  },
  getEnterpriseManagePermission: function getEnterpriseManagePermission() {
    return this.get("managerPermission");
  },
  getSignature: function getSignature(callback) {
    var _this = this;
    var _selectActiveSig_ = function _selectActiveSig_(signatures) {
      if (signatures && signatures.length) {
        var sigInfo = signatures[0];
        for (var i = 0; i < signatures.length; i++) {
          var _sig = signatures[i];
          if (_sig.active) {
            sigInfo = _sig;
          }
        }
        var sigData = sigInfo.signData;
        var sig = new _MDSignatureData["default"](sigInfo.id);
        sig.decodeStream(sigData);
        sig.standsizeData();
        _this.signature = sig;
        callback(_this.signature);
      }
    };
    if (this.signature) {
      callback(this.signature);
    } else if (this == app.currentUser) {
      _MMUserDataController["default"].getMySignatures(function (signatures) {
        _selectActiveSig_(signatures);
      }, function () {
        callback();
      });
    } else {
      _MMUserDataController["default"].getUserSignatures(this.getUserId(), function (signatures) {
        _selectActiveSig_(signatures);
      }, function () {
        callback();
      });
    }
  },
  getMySealSignature: function getMySealSignature(callback) {
    var _this2 = this;
    var _selectActiveSig_ = function _selectActiveSig_(sealInfos, currentSealInfo) {
      if (sealInfos && sealInfos.length) {
        var sig;
        var seal;
        for (var i = 0; i < sealInfos.length; i++) {
          var item = sealInfos[i];
          if (item.id == currentSealInfo.currentSign) {
            sig = item;
          } else if (item.id == currentSealInfo.currentSeal) {
            seal = item;
          }
        }
        _this2.sealAndSig = {
          seal: seal && new _MDSealData["default"](seal),
          sig: sig && new _MDSealData["default"](sig)
        };
        callback && callback(_this2.sealAndSig);
      }
    };
    if (this.sealAndSig) {
      callback && callback(this.sealAndSig);
    } else if (this == app.currentUser) {
      _MMUserDataController["default"].getMySealSignature(function (res) {
        _selectActiveSig_(res.sealInfos, res.currentSealInfo);
      }, function () {
        callback && callback();
      });
    } else {
      _MMUserDataController["default"].getUserSignatures(this.getUserId(), function (sealInfos) {
        _selectActiveSig_(sealInfos);
      }, function () {
        callback && callback();
      });
    }
  },
  getSealData: function getSealData() {
    return sealAndSig.seal;
  },
  getSigData: function getSigData() {
    return sealAndSig.sig;
  },
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //
  //                              企业后台管理权限判断
  //
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //1. 管理权限

  canManageEpBasicInfo: function canManageEpBasicInfo() {
    return this.getEnterpriseManagePermission() & _ENTERPRISE_PERMISSIONS_MANAGER["default"].MANAGE_ENTERPRISE_INFO;
  },
  canManageEpOrganization: function canManageEpOrganization() {
    return this.getEnterpriseManagePermission() & _ENTERPRISE_PERMISSIONS_MANAGER["default"].MANAGE_ORGANIZATION;
  },
  canManageEpMember: function canManageEpMember() {
    return this.getEnterpriseManagePermission() & _ENTERPRISE_PERMISSIONS_MANAGER["default"].MANAGE_ENTERPRISE_ROLE;
  },
  canManageEpRolelist: function canManageEpRolelist() {
    return this.getEnterpriseManagePermission() & _ENTERPRISE_PERMISSIONS_MANAGER["default"].MANAGE_ENTERPRISE_ROLE;
  },
  canManageEpTag: function canManageEpTag() {
    return this.getEnterFilePermission() & _ENTERPRISE_PERMISSIONS_FILE["default"].MANAGE_TAG;
  },
  canManageEpEvaluation: function canManageEpEvaluation() {
    return this.getEnterFilePermission() & _ENTERPRISE_PERMISSIONS_FILE["default"].MANAGE_APPROVE;
  },
  canManageEpBroadcast: function canManageEpBroadcast() {
    return this.getEnterFilePermission() & _ENTERPRISE_PERMISSIONS_FILE["default"].BROADCAST;
  },
  canManageEpGroup: function canManageEpGroup() {
    return this.getEnterpriseManagePermission() & _ENTERPRISE_PERMISSIONS_MANAGER["default"].MANAGE_ENTERPRISE_GROUP;
  },
  canManageEpWatermark: function canManageEpWatermark() {
    return this.getEnterpriseManagePermission() & _ENTERPRISE_PERMISSIONS_MANAGER["default"].MANAGE_WATERMARK;
  },
  canManageEpAdmin: function canManageEpAdmin() {
    return this.getEnterpriseManagePermission() & _ENTERPRISE_PERMISSIONS_MANAGER["default"].SET_ADMIN;
  },
  //  canManageEpLog: function() {
  //   return this.getEnterpriseManagePermission() & ENTERPRISE_PERMISSIONS_MANAGER.READ_FILELOG
  // },

  //2.只读权限

  canReadEpGroup: function canReadEpGroup() {
    return this.getEnterpriseManagePermission() & _ENTERPRISE_PERMISSIONS_MANAGER["default"].READ_ENTERPRISE_GROUP;
  },
  canReadEpLog: function canReadEpLog() {
    return this.getEnterpriseManagePermission() & _ENTERPRISE_PERMISSIONS_MANAGER["default"].READ_FILELOG;
  },
  canManageEpSecurityPolicy: function canManageEpSecurityPolicy() {
    return this.getEnterpriseManagePermission() & _ENTERPRISE_PERMISSIONS_MANAGER["default"].MANAGE_SECURITY_POLICY;
  },
  canManageMacBind: function canManageMacBind() {
    return this.getEnterpriseManagePermission() & _ENTERPRISE_PERMISSIONS_MANAGER["default"].MANAGE_MACBIND;
  }
}, {
  Permission: {
    ViewPersonFile: Math.pow(2, 1),
    TransferPersonFile: Math.pow(2, 2),
    ManageTag: Math.pow(2, 3),
    ManageTrash: Math.pow(2, 4),
    BroadCast: Math.pow(2, 5)
  }
});
MDMolaUser.getUserItemHtmlStr = function (user, param) {
  var outMem = BabelStr.str(382); // 外部人员
  var mgr = BabelStr.str(72); // 管理员
  var avatarUrl = user.getAvatarImageURL(40);
  var cls = param && param.cls || "";
  var account = user.getAccount();
  account = account ? account : "--";
  var str = '<li class="item flex-align middle ' + cls + '" data-id="' + user.getUserId() + '">';
  if (param && param.needChecked) {
    str += "<div class=\"check-box no-shrink\"></div>";
  }
  if (!param || !param.noImg) {
    str += '<div class="list-item img no-shrink"><img data-src="' + avatarUrl + '" alt="" src="' + avatarUrl + '" style="display: inline;"></div>';
  }
  if (param && param.typeIcon) {
    var type = user.get("userType") || user.get("participantType");
    var typeCls = "";
    if (type == 0) {
      typeCls = "user-s-icon";
    } else if (type == 1) {
      typeCls = "dep-s-icon";
    } else {
      typeCls = "grp-s-icon";
    }
    str += "<span class=\"icon ".concat(typeCls, "\"></span>");
  }
  if (user.isEnterpriseGuest()) {
    str += '<div class="list-item sign">' + outMem + "</div>";
  }
  if (user.isEpAdminUser()) {
    str += '<div class="list-item sign adm">' + mgr + "</div>";
  }
  str += '<div class="list-item name text-hide">' + user.getUserName() + "</div>";
  str += '<div class="list-item email col-auto text-hide">(' + account + ")</div> ";
  if (param && param.slot) {
    str += '<div class="slot">' + param.slotInner || "" + "</div>";
  }
  if (param && param.canRemove) {
    str += '<button class="list-item icon remove no-shrink" user-id=' + user.getUserId() + "></button> ";
  }
  str += "</li>";
  return str;
};
var _default = exports["default"] = MDMolaUser;

},{"106":106,"108":108,"1108":1108,"1184":1184,"1421":1421,"1437":1437,"1439":1439,"1454":1454,"1466":1466,"1477":1477,"21":21,"233":233,"234":234,"283":283,"286":286,"820":820}],1108:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MDConnector = _interopRequireDefault(require(1089));
var _MDMolaUser = _interopRequireDefault(require(272));
var _MDSnackbarView = _interopRequireDefault(require(72));
var MMUserDataController = {
  request: function request(route, msg, callback) {
    return _MDConnector["default"].request(route, msg, callback);
  },
  getMyUserData: function getMyUserData(success, fail) {
    return MMUserDataController.request('netDrive.userHandler.getMyUserInfo', {}, function (res) {
      if (res['resultCode']) {
        fail();
      } else {
        success(new _MDMolaUser["default"](res['info']));
      }
    });
  },
  setReceiveEmailType: function setReceiveEmailType(type, success, fail) {
    MMUserDataController.request('netDrive.userHandler.setReceiveEmailType', {
      'type': type
    }, function (res) {
      if (res['resultCode'] === 0) {
        success();
      } else {
        fail(res['resultCode']);
      }
    });
  },
  getReceiveEmailType: function getReceiveEmailType(success, fail) {
    MMUserDataController.request('netDrive.userHandler.getReceiveEmailType', {}, function (res) {
      if (res['resultCode'] === 0) {
        success(res['type']);
      } else {
        fail(res['resultCode']);
      }
    });
  },
  getMySignatures: function getMySignatures(success, fail) {
    MMUserDataController.request('netDrive.userHandler.getMySignatures', {}, function (res) {
      if (res['resultCode'] === 0) {
        success(res['signatures']);
      } else {
        fail(res['resultCode']);
      }
    });
  },
  getUserSignatures: function getUserSignatures(userId, success, fail) {
    MMUserDataController.request('netDrive.userHandler.getUserSignatures', {
      userId: userId
    }, function (res) {
      if (res['resultCode'] === 0) {
        success(res['signatures']);
      } else {
        fail(res['resultCode']);
      }
    });
  },
  createSignature: function createSignature(data, success, fail) {
    _czc && _czc.push(["_trackEvent", "签名", "创建个人签名", "", "", ""]);
    MMUserDataController.request('netDrive.userHandler.createSignature', {
      data: data
    }, function (res) {
      if (res['resultCode'] === 0) {
        success();
      } else {
        fail(res['resultCode']);
      }
    });
  },
  deleteMySignature: function deleteMySignature(ids, success, fail) {
    _czc && _czc.push(["_trackEvent", "签名", "删除个人签名", "", "", ""]);
    MMUserDataController.request('netDrive.userHandler.deleteMySignature', {
      ids: ids
    }, function (res) {
      if (res['resultCode'] === 0) {
        success();
      } else {
        fail(res['resultCode']);
      }
    });
  },
  setMyActiveSignature: function setMyActiveSignature(id, success, fail) {
    _czc && _czc.push(["_trackEvent", "签名", "设置活跃签名", "", "", ""]);
    MMUserDataController.request('netDrive.userHandler.activeUserSignature', {
      signId: id + ''
    }, function (res) {
      if (res['resultCode'] === 0) {
        success();
      } else {
        _MDSnackbarView["default"].show(BabelStr.str(168));
        fail(res['resultCode']);
      }
    });
  },
  filePreUpload4Seal: function filePreUpload4Seal(params, successCB, failCb) {
    $.ajax({
      url: "/seal/filePreUpload4Seal.do",
      method: "post",
      data: {
        fileName: params.fileName,
        fileHash: params.fileHash,
        sealType: params.sealType // 0 印章， 1 - 签名
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  getSealImage: function getSealImage(fileId, successCB, failCb) {
    $.ajax({
      url: "/seal/getSealImage.do",
      method: "post",
      data: {
        fileId: fileId
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  getMySealSignature: function getMySealSignature(successCB, failCb) {
    $.ajax({
      url: "/seal/getMySealSignature.do",
      method: "post",
      data: {},
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  getSealByIdAndFileId: function getSealByIdAndFileId(fileId, sealId, successCB, failCb) {
    $.ajax({
      url: "/seal/getSealByIdAndFileId.do",
      method: "post",
      data: {
        fileId: fileId,
        sealId: sealId
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData["sealInfo"]);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  delSealByFileId: function delSealByFileId(fileId, successCB, failCb) {
    $.ajax({
      url: "/seal/delSealByFileId.do",
      method: "post",
      data: {
        fileId: fileId
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  setUserCurrentSealSignatrue: function setUserCurrentSealSignatrue(params, successCB, failCb) {
    $.ajax({
      url: "/seal/setUserCurrentSealSignatrue.do",
      method: "post",
      data: params,
      //      currentSealId:2,currentSignId:5,
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  sealFile: function sealFile(sealData, copyToCurrentFolder, fileId, version, forceSeal, successCB, failCb) {
    // var sealData = [{
    //   seal_sign_id: 2,
    //   pageIndex: 0,
    //   x: 0.60,
    //   y: 0.60,
    //   width: 0.15,
    //   height: 0.15
    // }]

    $.ajax({
      url: "/seal/sealFile.do",
      method: "post",
      data: {
        fileId: fileId,
        copyToCurrentFolder: copyToCurrentFolder,
        version: version,
        forceSeal: forceSeal,
        sealData: JSON.stringify(sealData)
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        // responseData.code = 10004
        // responseData.fileName = "test.pdf"
        // responseData.downloadUrl = "https://test.babel.cc/document/6baf387bfb204aceaf38c6b784886a67/babel.pdf?Expires=1760773176&OSSAccessKeyId=LTAI79cWnFxCa2Qt&Signature=Kgrf8JOPO4G0b9F5wU%2FupOiTo8U%3D&response-content-disposition=attachment%3B%20filename%3D%22testSeal.pdf%22%3Bfilename%2A%3DUTF-8%27%27testSeal.pdf"
        if (responseData.success) {
          if (responseData.code == 0) {
            _.isFunction(successCB) && successCB(responseData);
          } else {
            _.isFunction(failCb) && failCb(responseData);
          }
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(res) {
        _.isFunction(failCb) && failCb(res);
      }
    });
  },
  getSealedStatus: function getSealedStatus(sealedId, successCB, failCb) {
    $.ajax({
      url: "/seal/getSealedStatus.do",
      method: "post",
      data: {
        sealedId: sealedId
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(res) {
        _.isFunction(failCb) && failCb(res, res.msg);
      }
    });
  },
  verifySeal: function verifySeal(fileHash, fileName, successCB, failCb) {
    $.ajax({
      url: "/seal/verifySeal.do",
      method: "post",
      data: {
        fileHash: fileHash,
        fileName: fileName
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
        if (responseData.success) {
          _.isFunction(successCB) && successCB(responseData['sealFile'], responseData["sealSignData"]);
        } else {
          _.isFunction(failCb) && failCb(responseData);
        }
      },
      error: function error(res) {
        _.isFunction(failCb) && failCb(res, res.msg);
      }
    });
  }
};
var _default = exports["default"] = MMUserDataController;

},{"1089":1089,"1184":1184,"1454":1454,"272":272,"72":72}],1089:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1418);
require(1463);
require(1537);
require(1541);
require(1437);
require(1439);
require(1435);
var _Dispatcher = _interopRequireDefault(require(18));
var _MDAlertView = _interopRequireDefault(require(32));
var _ErrorMessage = _interopRequireDefault(require(1088));
var _MDLocalString = _interopRequireDefault(require(1150));
/**
 * creator Tobias Nickel
 * this module will make shure that pomelo is connected to a connector.
 * when it is disconnected it will reconnect to Pomelo
 *
 * it requires pomelo-clientLibrary to be loaded
 *
 * it is now a singleton, because a client need only one connection.
 *
 */

// import MMEnterpriseController from './MMEnterpriseController.js'

var pomelo = window.pomelo;
var _ipAddress = window['user']['ip'];
var MDConnector = {
  _host: window['pomeloAddr']['host'],
  //"192.168.2.195" // remotetest:"118.178.24.11" // tobias(shanghai office only):"192.168.2.81" // developweb: "120.27.245.68"
  _port: window['pomeloAddr']['port'],
  _protocal: window['pomeloAddr']['protocal'],
  _connectRoute: window['pomeloAddr']['connectRoute'],
  _ip: window['user']['ip'],
  _sid: null,
  _connectCallbacks: [],
  _isConnecting: false,
  isConnected: false,
  /**
   * different parts in your app can call this method, just to be sure it is connected.
   * it should be used only once, when the app starts
   */
  connect: function connect(callback) {
    if (MDConnector.isConnected) {
      setBabelTimeout(callback, 0);
      return;
    }
    if (callback) MDConnector._connectCallbacks.push(callback);
    if (!MDConnector._isConnecting) {
      MDConnector.sid = g_sessionId + '-' + Math.random() * 1000000000000 + "" + Math.round(Math.random() * 10000000000);
      MDConnector._isConnecting = true;
      MDConnector._connect(function () {
        MDConnector._connectCallbacks.forEach(function (callback) {
          callback();
        });
        MDConnector._connectCallbacks = [];
      });
    }
  },
  _connect: function _connect(callback) {
    //var host = (window.location.hostname === "localhost" || window.location.hostname.indexOf('192') === 0) ? MDConnector._host : window.location.hostname;
    pomelo.init({
      'host': this._host,
      'port': this._port,
      'protocal': this._protocal,
      'reconnect': true,
      'log': true
    }, function () {
      MDConnector._registerConnection(callback);
    });
    MDConnector._initEvents();
  },
  getMacAddress: function getMacAddress() {
    // return "";   //临时代码

    if (window['ElectronRequire'] != undefined) {
      var cppAPI = window['ElectronRequire']('electron').remote.require('./utils/cppAPI');
      if (!cppAPI.getMacAddress) {
        return "";
      }
      var address = cppAPI.getMacAddress();
      address = !!address ? address : "";
      return address;
    } else {
      return "";
    }
  },
  localeLanguage: function localeLanguage(successCB, failCb) {
    var lan = BabelStr.getCurrentLanguage();
    $.ajax({
      url: "/public/localeLanguage.do",
      method: 'post',
      data: {
        language: lan
      },
      success: function success(responseData, textStatus, jaXHR) {
        console.warn(responseData);
      },
      fail: function fail(res) {
        console.log(res);
      }
    });
  },
  _registerConnection: function _registerConnection(callback) {
    var that = this;
    var addr = this.getMacAddress();
    var browser = app.getCurBrowserType();
    console.log(addr);
    var browserName = app.isInClient() ? BabelStr.str(2568) : BabelStr.str(2569);
    var terminalNumber = app.isInClient() ? 2568 : 2569;
    if (app.isInClient()) {
      browser = "babel-client";
    }
    console.warn('------------- register connection, _ipAddress:' + _ipAddress);
    this.localeLanguage();
    var lan = _MDLocalString["default"].getCurrentLanguage();
    pomelo.request(this._connectRoute, {
      'sid': MDConnector.sid,
      'ipAddress': _ipAddress,
      'userId': app.currentUser && app.currentUser.getUserId && app.currentUser.getUserId() || "0",
      // sarahs new ID as default
      'hostname': window.location.hostname,
      'terminalInfo': {
        'macAddr': addr,
        "terminalType": browser,
        //chrome/firefox/client/android/ios
        "terminalName": browserName,
        "terminalNumber": terminalNumber
      },
      'lang': lan
    }, /*'sarahs'*/
    function (data) {
      if (data['resultCode'] == MMNetDiskDataController.code.ERROR_PERMISSION_DENIED) {
        //not allowed to connect go to home
        that._showPomeloDisconnectInfo();
        return;
      }
      that._initBaseInfos();
      MDConnector.isConnected = true;
      MDConnector._isConnecting = false;
      callback(data);
    });
  },
  _showPomeloDisconnectInfo: function _showPomeloDisconnectInfo() {
    var that = this;
    if (!that.sessionErrAlert) {
      that.sessionErrAlert = new _MDAlertView["default"]();
      that.sessionErrAlert.show({
        message: BabelStr.str(5099),
        hideCloseBtn: true,
        onHide: function onHide() {
          that.sessionErrAlert = null;
          app.redirectToLogin();
        },
        buttons: [{
          label: BabelStr.str(154),
          type: 'done'
        }]
      });
    }
  },
  _initBaseInfos: function _initBaseInfos() {
    // 1. 获取系统默认的用户设置的文件排序方式
    // pomelo.request('netDrive.fileExHandler.getDefaultSortIndex', {
    //   },
    //   function(data) {
    //     if (data.resultCode == 0) {
    //       window.app.currentUser.defaultSortIndex = data['defaultSortIndex'];
    //     }
    //   }
    // );
  },
  _clearPomeloDisconnectInfo: function _clearPomeloDisconnectInfo() {
    var that = this;
    if (that.sessionErrAlert) {
      that.sessionErrAlert.close();
    }
    that.sessionErrAlert = null;
  },
  disconnect: function disconnect() {
    pomelo.disconnect();
    MDConnector._isConnecting = false;
    MDConnector.connected = false;
    MDConnector._connectCallbacks = [];
  },
  _initEvents: function _initEvents() {
    var that = this;

    // this.checkUserIsLogin();

    pomelo.on('disconnect', function (res) {
      console.log("disconnect", res);
      _Dispatcher["default"].trigger(MDEvents.POMELO_DISCONNECT);
    });
    pomelo.on('heartbeat timeout', function (res) {
      console.log("heartbeat timeout", res);
    });
    pomelo.on('reconnect', function (res) {
      console.log("reconnect", res);
      MDConnector._registerConnection(function () {});
      _Dispatcher["default"].trigger(MDEvents.POMELO_RECONNECT);
    });
    pomelo.on('onPasswordChanged', function (res) {
      var alert = new _MDAlertView["default"]();
      alert.show({
        title: BabelStr.str(170),
        message: BabelStr.str(5100),
        autoClose: true,
        hideCloseBtn: true,
        buttons: [{
          label: BabelStr.str(3096),
          onClick: function onClick() {
            app.logout();
          }
        }]
      });
    });
    pomelo.on('onMacBindRemove', function (res) {
      that.disconnect();
      app.prepareLogout();
      var alert = new _MDAlertView["default"]();
      alert.show({
        title: BabelStr.str(170),
        message: BabelStr.str(5101),
        autoClose: true,
        hideCloseBtn: true,
        buttons: [{
          label: BabelStr.str(3096),
          onClick: function onClick() {
            app.logout();
          }
        }]
      });
    });

    // KICK_TYPE: {
    //     DELETE_MAC_BIND: 1, // mac地址绑定发生变动
    //     KICK_BY_MYSELF: 2,  // 自己管理设备时
    // }

    pomelo.on('onKick', function (res) {
      console.log("pomelo:onKick", res);
      var msg = "";
      switch (res['type']) {
        case 1:
          msg = BabelStr.str(5101);
          break;
        case 2:
          msg = BabelStr.str(5102);
          break;
        case 4:
          msg = BabelStr.str(5103);
          break;
        default:
          msg = BabelStr.str(5104);
          break;
      }
      that.disconnect();
      app.prepareLogout();
      that.m_connect = null;
      var alert = new _MDAlertView["default"]();
      alert.show({
        title: BabelStr.str(170),
        message: msg,
        autoClose: false,
        hideCloseBtn: true,
        buttons: [{
          label: BabelStr.str(3096),
          onClick: function onClick() {
            app.logout();
          }
        }]
      });
      // pomelo.disconnect();
    });
    pomelo.on('deleteMemberFromEnterprise', function (data) {
      var enterpriseId = data['enterpriseId'] || '0';
      var memberIds = data['memberIds'];
      if (enterpriseId != (app.ep.getEpID() || "0")) {
        return;
      }
      var event = {
        enterpriseId: enterpriseId,
        memberIds: memberIds,
        type: data["type"]
      };
      _Dispatcher["default"].trigger('deleteMemberFromEnterprise', event);
    });
    pomelo.on('error', function (res) {
      console.log("Pomelo:error", res);
    });
    pomelo.on('onBoardData', function (data) {
      _Dispatcher["default"].trigger('editPenScribblesFromServer', data);
    });
    pomelo.on('signInFromOther', function (res) {
      if (window.signInFromOtherAlert) {
        window.signInFromOtherAlert.close();
      }
      console.error("signInFromOther:", res);
      window.signInFromOtherAlert = new _MDAlertView["default"]();
      window.signInFromOtherAlert.show({
        title: BabelStr.str(220),
        width: 540,
        message: BabelStr.str(21606, res),
        autoClose: false,
        hideCloseBtn: true,
        buttons: [{
          label: BabelStr.str(154),
          onClick: function onClick() {
            window.signInFromOtherAlert = null;
          }
        }]
      });
      setTimeout(function () {
        if (window.signInFromOtherAlert) {
          window.signInFromOtherAlert.close();
          window.signInFromOtherAlert = null;
        }
      }, 30 * 60 * 1000);
    });
  },
  on: function on(name, handler) {
    pomelo.on(name, handler);
  },
  off: function off(name, handler) {
    pomelo.off(name, handler);
  },
  checkUserIsLogin: function checkUserIsLogin() {
    var _this = this;
    // 匿名分享不需要检测
    if (app.isShareApp) {
      return;
    }
    clearInterval(this.check);
    this.check = setInterval(function () {
      $.ajax({
        method: 'post',
        url: '/account/isUserSignin.do',
        success: function success(response) {
          if (response['success'] === true) {
            _this._clearPomeloDisconnectInfo();
            console.log("处于登录状态" + new Date());
          } else {
            _this._showPomeloDisconnectInfo();
            console.log(response["msg"] + new Date());
          }
        }
      });
    }, 1000 * 60 * 60);
  },
  /**
   * not used today, but this can be used to request the connectorHandler for LoadBalancing
   * it is now only a copy from the old MMConnection and need to be change to return the
   * connectHandler IP and port
   *
   * ask Tobias for details or to implement the usage
   */
  queryEntry: function queryEntry(uid, host, port, callback) {
    if (this.m_entry !== null) return;
    var gateRoute = 'gate.gateHandler.queryEntry';
    var that = this;
    that.isInitiating = true;
    //pomelo = new pomelo;
    pomelo.init({
      "host": host,
      "port": port,
      "log": true
    }, function () {
      // console.log("connection setup success");
      pomelo.request(gateRoute, {
        'sid': uid
      }, function (data) {
        try {
          pomelo.disconnect();
          that.m_entry = data;
          that.appHost = data["host"];
          that.appPort = data["port"];
          that.isInitiating = false;
          if (callback) {
            callback(data);
          }
        } catch (e) {
          console.log(e.name + ":" + e.message);
        }
      });
    });
  },
  reconnectAndCall: function reconnectAndCall(callback) {
    pomelo.disconnect();
    MDConnector._isConnecting = false;
    MDConnector.connected = false;
    MDConnector._connectCallbacks = [];
    MDConnector.connect(callback);
  },
  pomeloDefaultParam: {
    // parameter that will be send on every request
    "appVer": 5.0,
    // the current App Version
    "app": "web",
    "callByWeb": 1
    // "lang": MDLocalString.getCurrentLanguage()
  },
  requestCount: 0,
  request: function request(route, msg, callback, tryTime) {
    this.checkUserIsLogin();
    MDConnector.requestCount++;
    if (typeof window.departmentFolderId !== 'undefined' && window.departmentFolderId) {
      msg['focusFolders'] = [window['departmentFolderId']];
    } else {
      if (app.userBeingViewed) {
        msg['beViewedUserId'] = app.userBeingViewed.getUserId();
      }
      ;
    }
    var start = Date.now();
    if (typeof msg === 'function') {
      callback = msg;
      msg = {};
    }
    if (!msg) {
      msg = {};
    }
    if (tryTime == undefined) {
      tryTime = 0;
    } else {
      tryTime++;
    }
    var _msg = _.extend(msg, MDConnector.pomeloDefaultParam);
    if (!_msg.lang) {
      _msg.lang = _MDLocalString["default"].getCurrentLanguage();
    }
    if (!msg['userDatabaseName']) {
      msg['userDatabaseName'] = window['user']['defaultDataName'];
    }
    var reqId = pomelo.request(route, _msg, function (res, two, three) {
      if (stopped) {
        if (stoppedCB) stoppedCB();
        return;
      }
      if (typeof res["resultCode"] == 'undefined') {
        //res instanceof Error
        callback(res, two, three);
        return;
      }
      setBabelTimeout(function () {
        MDConnector.resetConnectError();
        var end = Date.now();
        delete msg.app;
        delete msg.appVer;
        console.log("REQUEST " + MDConnector.requestCount + ":", end - start + 'ms', res["resultCode"], route, msg);
        if (res['dataultCode'] != 0 && !res['message']) {
          res['message'] = _ErrorMessage["default"][res['resultCode']];
        }
        callback(res, two, three);
      }, 0);
    });
    var stopped = false;
    var stoppedCB = null;
    return {
      // the request object
      stop: function stop(cb) {
        stopped = true;
        stoppedCB = cb;
        callback = null;
        if (reqId) {
          pomelo.abort(reqId);
        }
      }
    };
  },
  resetConnectError: function resetConnectError() {
    localStorage.connectErrorCount = 0;
  },
  handleConnectError: function handleConnectError() {
    localStorage.connectErrorCount = localStorage.connectErrorCount + 1 || 1;
    return;
    var alert = new _MDAlertView["default"]();
    alert.show({
      title: "connection error",
      message: BabelStr.str(5105),
      buttons: [{
        label: BabelStr.str(5106),
        // refresh
        onClick: function onClick() {
          window.location.reload();
        }
      }, {
        //     label: "取消", // cancel
        //     onClick: function(){}
        // },{
        label: BabelStr.str(154),
        // OK
        onClick: function onClick() {}
      }]
    });
    alert.on("remove", function () {
      console.log("alert is gone");
    });
    //alert("the client can not connect, try to refresh")//😞😞😞 连接出了点故障，刷新一下页面就好了。
  },
  repleyComment: function repleyComment(fileId, commentId, commentContent, success, fail, noNewComment) {
    var params = {
      'fileId': fileId,
      'commentId': commentId,
      'visibleScope': 0,
      'commentContent': commentContent,
      'noNewComment': noNewComment
    };
    MDConnector.request('collaborate.glCollaborateHandler.replyComment', params, function (response) {
      if (response['resultCode'] === 0) {
        success && success();
      } else {
        fail && fail(response["resultCode"]);
      }
    });
  }
};
var _default = exports["default"] = MDConnector;

},{"1088":1088,"1150":1150,"1184":1184,"1418":1418,"1435":1435,"1437":1437,"1439":1439,"1454":1454,"1463":1463,"1537":1537,"1541":1541,"18":18,"32":32}],1541:[function(require,module,exports){
// TODO: Remove this module from `core-js@4` since it's split to modules listed below
require(1539);
require(1540);

},{"1539":1539,"1540":1540}],1540:[function(require,module,exports){
var $ = require(1270);
var global = require(1287);
var schedulersFix = require(1361);

var setTimeout = schedulersFix(global.setTimeout, true);

// Bun / IE9- setTimeout additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
$({ global: true, bind: true, forced: global.setTimeout !== setTimeout }, {
  setTimeout: setTimeout
});

},{"1270":1270,"1287":1287,"1361":1361}],1539:[function(require,module,exports){
var $ = require(1270);
var global = require(1287);
var schedulersFix = require(1361);

var setInterval = schedulersFix(global.setInterval, true);

// Bun / IE9- setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
$({ global: true, bind: true, forced: global.setInterval !== setInterval }, {
  setInterval: setInterval
});

},{"1270":1270,"1287":1287,"1361":1361}],1361:[function(require,module,exports){
'use strict';
var global = require(1287);
var apply = require(1274);
var isCallable = require(1302);
var ENGINE_IS_BUN = require(1259);
var USER_AGENT = require(1266);
var arraySlice = require(1227);
var validateArgumentsLength = require(1404);

var Function = global.Function;
// dirty IE9- and Bun 0.3.0- checks
var WRAP = /MSIE .\./.test(USER_AGENT) || ENGINE_IS_BUN && (function () {
  var version = global.Bun.version.split('.');
  return version.length < 3 || version[0] == 0 && (version[1] < 3 || version[1] == 3 && version[2] == 0);
})();

// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
module.exports = function (scheduler, hasTimeArg) {
  var firstParamIndex = hasTimeArg ? 2 : 1;
  return WRAP ? function (handler, timeout /* , ...arguments */) {
    var boundArgs = validateArgumentsLength(arguments.length, 1) > firstParamIndex;
    var fn = isCallable(handler) ? handler : Function(handler);
    var params = boundArgs ? arraySlice(arguments, firstParamIndex) : [];
    var callback = boundArgs ? function () {
      apply(fn, this, params);
    } : fn;
    return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
  } : scheduler;
};

},{"1227":1227,"1259":1259,"1266":1266,"1274":1274,"1287":1287,"1302":1302,"1404":1404}],1259:[function(require,module,exports){
/* global Bun -- Deno case */
module.exports = typeof Bun == 'function' && Bun && typeof Bun.version == 'string';

},{}],1088:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var message = {
  0: "OK",
  1: "您的操作失败，请稍后重试。",
  2: "客户端参数错误，服务器拒绝处理。",
  3: "客户端的请求方法错误",
  4: "对不起，您没有下载的权限。",
  5: "对不起，您没有上传的权限。",
  6: "上传到云存储失败",
  7: "您的存储空间不足",
  8: "验证用户的操作权限时发生错误",
  9: "数据库错误",
  12: "禁止的用户操作",
  13: "对不起, 您没有这个订单。",
  14: "您的订单已经取消，不能再支付。",
  15: "您的订单已经删除，不能再支付。",
  16: "您的订单处于验证状态，请稍后。",
  17: "订单已经支付成功。",
  18: "您有未支付的订单，不能再创建订单。",
  100: "不支持的客户端版本",
  101: "您所操作的文件不存在或者已经被删除了",
  102: "您所操作的文件夹不存在或者已经被删除了",
  103: "转换文档时，文档没有扩展名，无法识别文档的类型。",
  104: "转换文档时，不支持的文档类型。",
  105: "文件转换失败，请稍后重试。",
  106: "您上传的文件设置了打开密码，所以我们无法转换该文件，请您删除打开密码后重新上传。",
  107: "暂不支持预览该类型的文件",
  108: "您上传的文件没有任何文件内容，请您查看本地的文件。",
  109: "创建文件夹失败，请稍后重试。",
  110: "创建文件失败，请稍后重试。",
  111: "移动文件失败，请稍后重试。",
  112: "重命名文件失败，请稍后重试。",
  113: "请求的action有错误，要下载的文档类型与所调用的接口不匹配。",
  115: "压缩文件夹失败",
  117: "保存上传文件的基本信息出错",
  118: "文件已损坏或者文件信息不完整",
  119: "阿里云分片上传大文件超时",
  120: "阿里云分片上传大文件失败",
  122: "Autocad中无法获取需要的打印纸张",
  123: "无法启动Autocad程序",
  124: "无法plot该cad文件",
  125: "下载的文件太多，超出限制（每次最多下载500个文件）。",
  126: "下载文件累计大小太大了，超出限制（单次下载累计的文件大小不能超过1GB）。",
  127: "您上传的文件过大，超出转换限制，请您下载后预览。",
  128: "您上传的演示文稿中没有任何幻灯片",
  131: "转换文档时，从存储系统中下载文件失败。",
  132: "文档转换超时",
  133: "您上传的文件版本数量超过限制，请升级到专业版。",
  134: "打开的Autocad文件数量超过限制，请升级到专业版。",
  135: "打开的3D文件超过限制，请升级到专业版。",
  136: "先用小图预览图片, 不要使用切片预览方式.",
  137: "个人版用户不允许上传视频，请升级到专业版或者企业版。",
  138: "文件被锁定",
  139: "您的视频文件不是H.264编码的，不能在线预览，请您下载查看。",
  201: "你填写的邮箱已存在",
  202: "邮箱不存在",
  203: "用户不存在",
  206: "密码错误",
  207: "您尚未登录，请您返回到登录页面去登录。",
  208: "您填写的邮箱不符合要求，请重新填写。",
  210: "您填写的密码不符合要求，请重新填写。",
  211: "您填写的验证码不正确",
  216: "您的验证链接时错误的",
  217: "您的验证链接已经过期了",
  219: "用户频繁登录注册",
  220: "第三方用户还没有绑定邮箱",
  221: "从pomelo服务器获得用户空间信息时发生错误",
  222: "从pomelo获得信息时超时",
  223: "您不是该企业的用户",
  224: "您的账户已经冻结",
  225: "您创建的团队数量已经达到上限，请升级到专业版。",
  226: "您的专业版已过期，为了不影响您的正常使用，请您尽快续费。",
  227: "您的企业版已过期，为了不影响您的正常使用，请您尽快续费。",
  228: "Pomelo处于繁忙状态，无法处理WEB服务器的请求。",
  229: "用户需要实名认证",
  230: "您的账户已被冻结",
  231: "用户请求过于频繁，请您稍后再试。",
  232: "用户已经登录，不需要再发送短信消息。",
  233: "错误的短信类型",
  234: "验证码错误",
  235: "验证码错误",
  236: "手机号未注册",
  237: "该手机号已经注册",
  238: "验证码已过期",
  239: "登录后需要初始化密码",
  240: "企业不存在",
  302: "服务器繁忙",
  303: "用户已经在团队中",
  304: "协同找不到",
  305: "删除白板失败",
  306: "关闭白板失败",
  307: "重复加入白板",
  308: "没有加入白板",
  309: "用户已登录pomelo",
  310: "无效的session(for pomelo)",
  311: "保存session失败",
  312: "获取session失败",
  313: "文件不在数据库中",
  314: "文件名已存在啊啊啊啊",
  315: "mongo读取数据失败",
  316: "父文件夹还在垃圾箱",
  317: "删除文件失败",
  318: "文件未分享",
  319: "无权访问该文件",
  320: "文件有子分享",
  321: "已存在",
  322: "恢复文件失败",
  323: "部门含有子部门",
  324: "部门名已存在",
  325: "不能移除企业拥有者",
  326: "无法对快捷方式进行该操作",
  327: "分享文件的密码不正确",
  328: "目标文件夹的存储空间不足",
  329: "分享文件的拥有者的专业版或企业版已经过期，请联系分享人。",
  330: "文件正在审批中",
  331: "文件不在审批",
  332: "文件没有审批id",
  333: "用户不在当前审批阶段",
  334: "模板名已存在",
  335: "原地移动文件（夹）失败",
  404: "请求的资源不存在"
};
var _default = exports["default"] = message;

},{"1454":1454}],286:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1451);
require(1449);
require(1446);
var _Encoder = _interopRequireDefault(require(800));
var _Decoder = _interopRequireDefault(require(799));
/**
 * MDSignatureData.js
 * jiang
 * 2019-3-27
 */

var MDSignatureData = function MDSignatureData(id, active) {
  this.id = id;
  this.signature = [];
  this.active = active;
  this.isSeal = 0;
};
Object.assign(MDSignatureData.prototype, {}, {
  push: function push(pts) {
    this.signature.push(pts);
  },
  size: function size() {
    return this.signature.length;
  },
  at: function at(i) {
    return this.signature[i];
  },
  setId: function setId(id) {
    this.id = id;
  },
  getId: function getId() {
    return this.id;
  },
  // encodeStream: function() {
  //   var enc = new Encoder();
  //   enc.encode4Bytes(this.signature.length);
  //   for (let i = 0; i < this.signature.length; i++) {
  //     const pts = this.signature[i];
  //     enc.encodeArray(pts, 'MMPoint');
  //   }
  //   return enc.getBuffer();
  // },

  // decodeStream: function(stream) {
  //   var encode = new Encoder();
  //   encode.setBuffer(stream);

  //   var dec = new Decoder();
  //   dec.setStream(encode.getStream());

  //   this.signature = [];
  //   var _length = dec.decodeFrom4Bytes(0);
  //   for (var i = 0; i < _length; i++) {
  //     var pts = dec.decodeFromArray(0, 'MMPoint');
  //     this.signature.push(pts);
  //   }
  // }

  encodeStream: function encodeStream() {
    var resultStr = "";
    for (var i = 0; i < this.signature.length; i++) {
      if (i > 0) {
        resultStr += ";";
      }
      var pts = this.signature[i];
      for (var k = 0; k < pts.length; k++) {
        var pt = pts[k];
        if (k > 0) {
          resultStr += ",";
        }
        resultStr += pt.x + ',' + pt.y;
      }
    }
    return resultStr;
  },
  decodeStream: function decodeStream(str) {
    var strokes = str.split(';');
    this.signature = [];
    for (var i = 0; i < strokes.length; i++) {
      var stroke = strokes[i];
      var vals = stroke.split(",");
      var pts = [];
      for (var k = 0; k < vals.length; k += 2) {
        var x = Number.parseInt(vals[k]);
        var y = Number.parseInt(vals[k + 1]);
        pts.push({
          x: x,
          y: y
        });
      }
      this.signature.push(pts);
    }
  },
  // 将数据转换为 0-1 之间的实数
  standsizeData: function standsizeData() {
    var minX = Number.MAX_VALUE,
      minY = Number.MAX_VALUE;
    var maxX = Number.MIN_VALUE,
      maxY = Number.MIN_VALUE;
    for (var i = 0; i < this.signature.length; i++) {
      var pts = this.signature[i];
      for (var k = 0; k < pts.length; k++) {
        var p = pts[k];
        if (p.x < minX) {
          minX = p.x;
        }
        if (p.y < minY) {
          minY = p.y;
        }
        if (p.x > maxX) {
          maxX = p.x;
        }
        if (p.y > maxY) {
          maxY = p.y;
        }
      }
    }
    var width = maxX - minX;
    var height = maxY - minY;
    if (width <= 1 || height <= 1) {
      return;
    }
    this.width = 1;
    this.height = height / width; //  ------------------ 宽为 1， 高即为比例
    for (var _i = 0; _i < this.signature.length; _i++) {
      var stroke = this.signature[_i];
      for (var _k = 0; _k < stroke.length; _k += 1) {
        var _p = stroke[_k];
        _p.x = (_p.x - minX) / width;
        _p.y = (_p.y - minY) / height;
      }
    }
  },
  getData: function getData() {
    return this.signature;
  },
  getHeight: function getHeight() {
    return this.height;
  },
  getWidth: function getWidth() {
    return this.width;
  },
  getRatio: function getRatio() {
    return this.height;
  },
  setActive: function setActive(active) {
    this.active = active;
  },
  isActive: function isActive() {
    return this.active;
  }
});
var _default = exports["default"] = MDSignatureData;

},{"1184":1184,"1446":1446,"1449":1449,"1451":1451,"1454":1454,"799":799,"800":800}],1451:[function(require,module,exports){
var $ = require(1270);
var assign = require(1325);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});

},{"1270":1270,"1325":1325}],1325:[function(require,module,exports){
'use strict';
var DESCRIPTORS = require(1251);
var uncurryThis = require(1281);
var call = require(1278);
var fails = require(1271);
var objectKeys = require(1337);
var getOwnPropertySymbolsModule = require(1332);
var propertyIsEnumerableModule = require(1338);
var toObject = require(1387);
var IndexedObject = require(1294);

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

},{"1251":1251,"1271":1271,"1278":1278,"1281":1281,"1294":1294,"1332":1332,"1337":1337,"1338":1338,"1387":1387}],1449:[function(require,module,exports){
var $ = require(1270);
var parseInt = require(1324);

// `Number.parseInt` method
// https://tc39.es/ecma262/#sec-number.parseint
// eslint-disable-next-line es/no-number-parseint -- required for testing
$({ target: 'Number', stat: true, forced: Number.parseInt != parseInt }, {
  parseInt: parseInt
});

},{"1270":1270,"1324":1324}],800:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1410);
require(1411);
require(1463);
require(1423);
require(1530);
require(1505);
require(1506);
require(1507);
require(1508);
require(1510);
require(1509);
require(1512);
require(1513);
require(1514);
require(1516);
require(1517);
require(1518);
require(1519);
require(1521);
require(1520);
require(1522);
require(1523);
require(1524);
require(1525);
require(1526);
require(1527);
require(1528);
require(1529);
require(1437);
require(1478);
require(1412);
require(1466);
require(1418);
require(1537);
var _set = _interopRequireDefault(require(822));
var _map = _interopRequireDefault(require(821));
var _MMRect = _interopRequireDefault(require(831));
var _MolaTextAlignment = _interopRequireDefault(require(817));
var _MMPoint = _interopRequireDefault(require(830));
var _OBJ_ID = _interopRequireDefault(require(818));
var _vec = _interopRequireDefault(require(839));
var _vec2 = _interopRequireDefault(require(840));
var _vec3 = _interopRequireDefault(require(841));
var _int = _interopRequireDefault(require(820));
function Encoder() {
  this.m_buffer = [];
  this.m_length = 0;
}
;
Encoder.prototype.getStream = function () {
  var _stream = this.__getBuffer();
  var _newDataBuffer = new ArrayBuffer(_stream.length);
  var _srcArray = new Uint8Array(_stream);
  var _desArray = new Uint8Array(_newDataBuffer);
  _desArray.set(_srcArray);
  return _newDataBuffer;
};
Encoder.prototype.__debugOutput = function () {
  var stream = this.getStream();
  var charArr = new Uint8Array(stream);
  var length = charArr.byteLength;
  var tmp = "m_buffer is : [";
  for (var i = 0; i < length; i++) {
    tmp = tmp + charArr[i].toString(16) + ", ";
  }
  tmp += "]";
  console.log(tmp);
};
Encoder.prototype.setBuffer = function (buffer) {
  this.m_buffer = buffer;
  this.m_length = buffer.length;
};
Encoder.prototype.__getBuffer = function () {
  var _stream = [];
  //首先填上数组长度
  if (this.m_length < 16) {
    _stream.push(0x90 + this.m_length);
  } else if (this.m_length < 0x10000) {
    //16
    _stream.push(0xdc, this.m_length >> 8, this.m_length & 0xff);
  } else if (this.m_length < 0x100000000) {
    //32
    _stream.push(0xdd, this.m_length >> 24, this.m_length >> 16 & 0xff, this.m_length >> 8 & 0xff, this.m_length & 0xff);
  }
  return _stream.concat(this.m_buffer);
};
Encoder.prototype.getBuffer = function () {
  return this.m_buffer;
};
Encoder.prototype.encode = function (data_) {
  var _packed = msgpack.pack(data_);
  this.m_length += 1;
  this.m_buffer = this.m_buffer.concat(_packed);
};
Encoder.prototype.encode1Byte = function (data_) {
  if (data_ == undefined) {
    this.encode(0);
  } else {
    if (typeof data_ == 'string') {
      this.encode(parseInt(data_));
    } else {
      this.encode(data_);
    }
  }
};
Encoder.prototype.encode2Bytes = function (data_) {
  if (data_ == undefined) {
    this.encode(0);
  } else {
    if (typeof data_ == 'string') {
      this.encode(parseInt(data_));
    } else {
      this.encode(data_);
    }
  }
};
Encoder.prototype.encode4Bytes = function (data_) {
  if (data_ == undefined) {
    this.encode(0);
  } else {
    if (typeof data_ == 'string') {
      this.encode(parseInt(data_));
    } else {
      this.encode(data_);
    }
  }
};
Encoder.prototype.encode8Bytes = function (data_) {
  var _64Data = null;
  if (data_ instanceof _int["default"]) {
    _64Data = data_;
  } else {
    _64Data = new _int["default"](data_);
  }
  var negate = _64Data.toNumber(true) < 0;
  if (negate) {
    //int64
    this.m_buffer.push(0xd3);
  } else {
    //uint64
    this.m_buffer.push(0xcf);
  }
  this.m_buffer = this.m_buffer.concat(_64Data.buffer);
  this.m_length += 1;
};
Encoder.prototype.encodeFloat = function (data_) {
  var _mix = data_;
  if (data_ === undefined) {
    _mix = 0;
  }
  var sign = _mix < 0;
  sign && (_mix *= -1);
  var exp = Math.log(_mix) / 0.6931471805599453 + 1023 | 0;
  var frac = _mix * Math.pow(2, 52 + 1023 - exp);
  var low = frac & 0xffffffff;
  sign && (exp |= 0x800);
  var high = frac / 0x100000000 & 0xfffff | exp << 20;
  this.m_buffer.push(0xcb, high >> 24 & 0xff, high >> 16 & 0xff, high >> 8 & 0xff, high & 0xff, low >> 24 & 0xff, low >> 16 & 0xff, low >> 8 & 0xff, low & 0xff);
  this.m_length += 1;
};
Encoder.prototype.encodeString = function (data_) {
  this.encode(data_);
};
Encoder.prototype.encodeBool = function (data_) {
  if (data_ == undefined) {
    this.encode(false);
  } else {
    this.encode(data_);
  }
};
/**
 *
 * @param {MMRect} rect_
 */
Encoder.prototype.encodeMMRect = function (rect_) {
  this.encodeFloat(rect_.right);
  this.encodeFloat(rect_.bottom);
  this.encodeFloat(rect_.left);
  this.encodeFloat(rect_.top);
};
/**
 *
 * @param {MMPoint} point_
 */
Encoder.prototype.encodeMMPoint = function (point_) {
  this.encodeFloat(point_.x);
  this.encodeFloat(point_.y);
};
/**
 *
 * @param {MMFont} font_
 */
Encoder.prototype.encodeMMFont = function (font_) {
  this.encodeString(font_.m_fontName);
  this.encodeFloat(font_.m_fontSize);
};
/**
 *
 * @param {MolaTextAlignment} molaTextAlignment_
 */
Encoder.prototype.encodeMolaTextAlignment = function (molaTextAlignment_) {
  this.encode(molaTextAlignment_.textAlignment);
};
/**
 *
 * @param {Vec2} vec2_
 * @param type_ vec2值的类型
 */
Encoder.prototype.encodeVec2 = function (vec2_, type_) {
  this.__encodeStuff(vec2_.x, type_);
  this.__encodeStuff(vec2_.y, type_);
};
/**
 *
 * @param {Vec3} vec3_
 * @param type_ Vec3值的类型
 */
Encoder.prototype.encodeVec3 = function (vec3_, type_) {
  this.__encodeStuff(vec3_.x, type_);
  this.__encodeStuff(vec3_.y, type_);
  this.__encodeStuff(vec3_.z, type_);
};
/**
 *
 * @param {Vec4} vec4_
 * @param type_ Vec4值的类型
 */
Encoder.prototype.encodeVec4 = function (vec4_, type_) {
  this.__encodeStuff(vec4_.w, type_);
  this.__encodeStuff(vec4_.x, type_);
  this.__encodeStuff(vec4_.y, type_);
  this.__encodeStuff(vec4_.z, type_);
};
Encoder.prototype.encodeDevOrientation = function (orientation) {
  this.encode(orientation.devOrientation);
};
Encoder.prototype.encodeObjID = function (objID_) {
  this.encode8Bytes(objID_.m_localIndex);
  this.encode8Bytes(objID_.m_macAddr);
};
Encoder.prototype.encodeObject = function (obj_) {
  var coder = new Encoder(),
    classId = MMDClass.getClassId(obj_);
  this.encode(classId);
  obj_.encode(coder);
  this.m_buffer = this.m_buffer.concat(coder.__getBuffer());
  this.m_length += 1;
};
Encoder.prototype.__encodeStuff = function (elem_, type_, type1_) {
  if (type_ == 'Meta') {
    return this.encodeObject(elem_);
  } else if (type_ == 'Float') {
    return this.encodeFloat(elem_);
  } else if (type_ == 'ObjID') {
    return this.encodeObjID(elem_);
  } else if (type_ == 'MMRect') {
    return this.encodeMMRect(elem_);
  } else if (type_ == 'MMPoint') {
    return this.encodeMMPoint(elem_);
  } else if (type_ == 'Vec2') {
    return this.encodeVec2(elem_, type1_);
  } else if (type_ == 'Vec3') {
    return this.encodeVec3(elem_, type1_);
  } else if (type_ == 'Vec4') {
    return this.encodeVec4(elem_, type1_);
  } else if (type_ == '8Bytes') {
    return this.encode8Bytes(elem_);
  } else {
    return this.encode(elem_);
  }
};
Encoder.prototype.encodeBuffer = function (buffer_) {
  if (buffer_ instanceof ArrayBuffer) {
    var _length = buffer_.byteLength;
    var _src = new Uint8Array(buffer_);
    if (_length < 1 << 8) {
      this.m_buffer.push(0xc4);
      this.m_buffer.push(_length & 0xff);
    } else if (_length < 1 << 16) {
      this.m_buffer.push(0xc5);
      this.m_buffer.push(_length >> 8 & 0xff);
      this.m_buffer.push(_length & 0xff);
    } else {
      this.m_buffer.push(0xc6);
      this.m_buffer.push(_length >>> 24);
      this.m_buffer.push(_length >> 16 & 0xff);
      this.m_buffer.push(_length >> 8 & 0xff);
      this.m_buffer.push(_length & 0xff);
    }
    for (var i = 0; i < _length; ++i) {
      this.m_buffer.push(_src[i]);
    }
    this.m_length += 1;
  } else if (buffer_ == null) {
    this.m_buffer.push(0xc4);
    this.m_buffer.push(0);
    this.m_length += 1;
  } else {
    console.assert(false);
  }
};
Encoder.prototype.encodeArray = function (array_, type_, type1_) {
  console.assert(array_ instanceof Array && type_ != null);
  var _length = array_.length;
  this.encode4Bytes(_length);
  for (var i = 0; i < _length; i++) {
    var _elem = array_[i];
    this.__encodeStuff(_elem, type_, type1_);
  }
};
Encoder.prototype.encodeMap = function (map_, type1_, type2_, type3_, type4_) {
  console.assert(map_ instanceof _map["default"] && type1_ != null && type2_ != null);
  var _length = map_.getCount();
  var _that = this;
  this.encode4Bytes(_length);
  map_.forEach(function (value_, key_) {
    _that.__encodeStuff(key_, type1_, type3_);
    _that.__encodeStuff(value_, type2_, type4_);
  });
};
Encoder.prototype.encodeSet = function (set_, type_, type1_) {
  console.assert(set_ instanceof _set["default"] && type_ != null);
  var _length = set_.getCount(),
    _that = this;
  this.encode4Bytes(_length);
  var t = set_.getValues();
  t.forEach(function (val_) {
    _that.__encodeStuff(val_, type_, type1_);
  });
};
var _default = exports["default"] = Encoder;

},{"1184":1184,"1410":1410,"1411":1411,"1412":1412,"1418":1418,"1423":1423,"1437":1437,"1454":1454,"1463":1463,"1466":1466,"1478":1478,"1505":1505,"1506":1506,"1507":1507,"1508":1508,"1509":1509,"1510":1510,"1512":1512,"1513":1513,"1514":1514,"1516":1516,"1517":1517,"1518":1518,"1519":1519,"1520":1520,"1521":1521,"1522":1522,"1523":1523,"1524":1524,"1525":1525,"1526":1526,"1527":1527,"1528":1528,"1529":1529,"1530":1530,"1537":1537,"817":817,"818":818,"820":820,"821":821,"822":822,"830":830,"831":831,"839":839,"840":840,"841":841}],799:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1423);
require(1411);
require(1463);
require(1530);
require(1505);
require(1506);
require(1507);
require(1508);
require(1510);
require(1509);
require(1512);
require(1513);
require(1514);
require(1516);
require(1517);
require(1518);
require(1519);
require(1521);
require(1520);
require(1522);
require(1523);
require(1524);
require(1525);
require(1526);
require(1527);
require(1528);
require(1529);
var _MMFont = _interopRequireDefault(require(815));
var _set = _interopRequireDefault(require(822));
var _map = _interopRequireDefault(require(821));
var _MMRect = _interopRequireDefault(require(831));
var _MolaTextAlignment = _interopRequireDefault(require(817));
var _MMPoint = _interopRequireDefault(require(830));
var _OBJ_ID = _interopRequireDefault(require(818));
var _vec = _interopRequireDefault(require(839));
var _vec5 = _interopRequireDefault(require(840));
var _vec6 = _interopRequireDefault(require(841));
var _int = _interopRequireDefault(require(820));
var _MMDevOrientation = _interopRequireDefault(require(814));
function Decoder(whiteboard_) {
  this.m_whiteboard = whiteboard_;
  this.m_buffer = [];
  this.m_totalLength = -1;
  this.m_curLength = -1;
}
;
Decoder.prototype.setStream = function (stream_) {
  var _packBuffer = [],
    _desArray = new Uint8Array(stream_),
    _length = _desArray.length;
  for (var i = 0; i < _length; i++) {
    _packBuffer[i] = _desArray[i];
  }
  this.m_buffer = msgpack.unpack(_packBuffer);
  this.m_totalLength = this.m_buffer.length;
  this.m_curLength = 0;
};
Decoder.prototype.__setBuffer = function (buffer_) {
  this.m_buffer = buffer_;
  this.m_totalLength = this.m_buffer.length;
  this.m_curLength = 0;
};
Decoder.prototype.decode = function () {
  if (this.m_curLength < this.m_totalLength) {
    var ret = this.m_buffer[this.m_curLength];
    this.m_curLength += 1;
    return ret;
  } else {
    return null;
  }
};
Decoder.prototype.decodeFrom1Byte = function (ver_) {
  return this.decode();
};
Decoder.prototype.decodeFrom2Bytes = function (ver_) {
  return this.decode();
};
Decoder.prototype.decodeFrom4Bytes = function (ver_) {
  return this.decode();
};
Decoder.prototype.decodeFrom8Bytes = function (ver_) {
  var _value = this.decode();
  return this.__unpack8Bytes(_value);
};
Decoder.prototype.decodeFromFloat = function (ver_) {
  return this.decode();
};
Decoder.prototype.decodeFromString = function (ver_) {
  return this.decode();
};
Decoder.prototype.decodeFromBool = function (ver_) {
  return this.decode();
};
/**
 *
 * @param ver_
 * @returns {MMRect} rect_
 */
Decoder.prototype.decodeFromMMRect = function (ver_) {
  var rect_ = new _MMRect["default"](0, 0, 0, 0);
  rect_.right = this.decodeFromFloat(ver_);
  rect_.bottom = this.decodeFromFloat(ver_);
  rect_.left = this.decodeFromFloat(ver_);
  rect_.top = this.decodeFromFloat(ver_);
  return rect_;
};
/**
 *
 * @param ver_
 * @returns {MMPoint} ponit_
 */
Decoder.prototype.decodeFromMMPoint = function (ver_) {
  var ponit_ = new _MMPoint["default"]();
  ponit_.x = this.decodeFromFloat(ver_);
  ponit_.y = this.decodeFromFloat(ver_);
  return ponit_;
};
/**
 *
 * @param ver_
 * @returns {MMFont}
 */
Decoder.prototype.decodeFromMMFont = function (ver_) {
  var _font = new _MMFont["default"]();
  _font.m_fontName = this.decodeFromString(ver_);
  _font.m_fontSize = this.decodeFromFloat(ver_);
  return _font;
};

/**
 *
 * @param ver_
 * @returns {MolaTextAlignment}
 */
Decoder.prototype.decodeFromMolaTextAlignment = function (ver_) {
  var _textAlignment = this.decodeFrom4Bytes(ver_);
  var _molaTextAlignment = new _MolaTextAlignment["default"](_textAlignment);
  return _molaTextAlignment;
};
/**
 * @returns {Vec2}
 */
Decoder.prototype.decodeFromVec2 = function (ver_, type_) {
  var _vec2 = new _vec["default"]();
  _vec2.x = this.__decodeFromStuff(ver_, type_);
  _vec2.y = this.__decodeFromStuff(ver_, type_);
  return _vec2;
};
/**
 * @returns {Vec3}
 */
Decoder.prototype.decodeFromVec3 = function (ver_, type_) {
  var _vec3 = new _vec5["default"]();
  _vec3.x = this.__decodeFromStuff(ver_, type_);
  _vec3.y = this.__decodeFromStuff(ver_, type_);
  _vec3.z = this.__decodeFromStuff(ver_, type_);
  return _vec3;
};
Decoder.prototype.decodeFromVec4 = function (ver_, type_) {
  var _vec4 = new _vec6["default"]();
  _vec4.w = this.__decodeFromStuff(ver_, type_);
  _vec4.x = this.__decodeFromStuff(ver_, type_);
  _vec4.y = this.__decodeFromStuff(ver_, type_);
  _vec4.z = this.__decodeFromStuff(ver_, type_);
  return _vec4;
};
Decoder.prototype.decodeFromDevOrientation = function (ver_) {
  var devOrientation = this.decodeFrom4Bytes(ver_);
  var _orientation = new _MMDevOrientation["default"](devOrientation);
  return _orientation;
};
Decoder.prototype.decodeFromObjID = function (ver_) {
  var _objID = new _OBJ_ID["default"]();
  _objID.m_localIndex = this.decodeFrom8Bytes();
  _objID.m_macAddr = this.decodeFrom8Bytes();
  return _objID;
};
Decoder.prototype.decodeFromObject = function (ver_) {
  var _classId = this.decode();
  var _objBuffer = this.decode();
  var _retObj = MMDClass.newObject(_classId, this.m_whiteboard);
  if (_retObj == null) {
    return null;
  } else {
    var _decoder = new Decoder(this.m_whiteboard);
    _decoder.__setBuffer(_objBuffer);
    try {
      _retObj.decode(_decoder);
    } catch (err_) {
      console.error(err_);
      return null;
    }
    if (_retObj.getCompatible) {
      var _realObj = _retObj.getCompatible(this.m_whiteboard);
      _realObj.compDetail_deprecated(_retObj);
      return _realObj;
    } else {
      return _retObj;
    }
  }
};
Decoder.prototype.__unpack8Bytes = function (val_) {
  var _64Data = null;
  if (val_ instanceof _int["default"]) {
    _64Data = val_;
  } else {
    _64Data = new _int["default"](val_);
  }
  return _64Data;
};
Decoder.prototype.__decodeFromStuff = function (ver_, type_, type1_) {
  if (type_ == 'Meta') {
    return this.decodeFromObject(ver_);
  } else if (type_ == 'ObjID') {
    return this.decodeFromObjID(ver_);
  } else if (type_ == 'MMRect') {
    return this.decodeFromMMRect(ver_);
  } else if (type_ == 'MMPoint') {
    return this.decodeFromMMPoint(ver_);
  } else if (type_ == 'Vec2') {
    return this.decodeFromVec2(ver_, type1_);
  } else if (type_ == 'Vec3') {
    return this.decodeFromVec3(ver_, type1_);
  } else if (type_ == 'Vec4') {
    return this.decodeFromVec4(ver_, type1_);
  } else if (type_ == '8Bytes') {
    return this.decodeFrom8Bytes(ver_);
  } else {
    return this.decode(ver_);
  }
};
Decoder.prototype.decodeFromArray = function (ver_, type_, type1_) {
  var _retArray = [];
  var _length = this.decodeFrom4Bytes(ver_);
  for (var i = 0; i < _length; i++) {
    var _elem = this.__decodeFromStuff(ver_, type_, type1_);
    _retArray.push(_elem);
  }
  return _retArray;
};
Decoder.prototype.decodeFromMap = function (ver_, type1_, type2_, type3_, type4_) {
  var _retMap = new _map["default"]();
  var _length = this.decodeFrom4Bytes(ver_);
  for (var i = 0; i < _length; i++) {
    var _key = this.__decodeFromStuff(ver_, type1_, type3_);
    var _value = this.__decodeFromStuff(ver_, type2_, type4_);
    _retMap.set(_key, _value);
  }
  return _retMap;
};
Decoder.prototype.decodeFromSet = function (ver_, type_, type1_) {
  var _retSet = new _set["default"]();
  var _length = this.decodeFrom4Bytes(ver_);
  for (var i = 0; i < _length; i++) {
    var _value = this.__decodeFromStuff(ver_, type_, type1_);
    _retSet.add(_value);
  }
  return _retSet;
};
Decoder.prototype.decodeFromBuffer = function (ver_) {
  return this.decode();
};
Decoder.prototype.shift = function (steps_) {
  this.m_curLength += steps_;
};
var _default = exports["default"] = Decoder;

},{"1184":1184,"1411":1411,"1423":1423,"1454":1454,"1463":1463,"1505":1505,"1506":1506,"1507":1507,"1508":1508,"1509":1509,"1510":1510,"1512":1512,"1513":1513,"1514":1514,"1516":1516,"1517":1517,"1518":1518,"1519":1519,"1520":1520,"1521":1521,"1522":1522,"1523":1523,"1524":1524,"1525":1525,"1526":1526,"1527":1527,"1528":1528,"1529":1529,"1530":1530,"814":814,"815":815,"817":817,"818":818,"820":820,"821":821,"822":822,"830":830,"831":831,"839":839,"840":840,"841":841}],841:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Vec4 class
 *
 * lishusheng
 * 2014-5-27
 */

function Vec4(w, x, y, z) {
  if (z == undefined) {
    w = x = y = z = 0;
  }
  this.w = w;
  this.x = x;
  this.y = y;
  this.z = z;
  return this;
}
;
var _default = exports["default"] = Vec4;

},{"1454":1454}],840:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _coordinate = _interopRequireDefault(require(835));
var _basicMath = _interopRequireDefault(require(832));
var _goog = _interopRequireDefault(require(823));
/**
 * Created by mashx on 16-7-27.
 */

// Copyright 2008 The Closure Library Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS-IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

/**
 * @fileoverview Defines a 3-element vector class that can be used for
 * coordinate math, useful for animation systems and point manipulation.
 *
 * Based heavily on code originally by:
 */

/**
 * Class for a three-dimensional vector object and assorted functions useful for
 * manipulation.
 *
 * Inherits from Coordinate3 so that a Vec3 may be passed in to any
 * function that requires a Coordinate.
 *
 * @param {number} x The x value for the vector.
 * @param {number} y The y value for the vector.
 * @param {number} z The z value for the vector.
 * @constructor
 * @extends {Coordinate3}
 */
function Vec3(x, y, z) {
  /**
   * X-value
   * @type {number}
   */
  this.x = x;

  /**
   * Y-value
   * @type {number}
   */
  this.y = y;

  /**
   * Z-value
   * @type {number}
   */
  this.z = z;
}
;
_goog["default"].inherits(Vec3, _coordinate["default"]);

/**
 * Generates a random unit vector.
 *
 * http://mathworld.wolfram.com/SpherePointPicking.html
 * Using (6), (7), and (8) to generate coordinates.
 * @return {!Vec3} A random unit-length vector.
 */
Vec3.randomUnit = function () {
  var theta = Math.random() * Math.PI * 2;
  var phi = Math.random() * Math.PI * 2;
  var z = Math.cos(phi);
  var x = Math.sqrt(1 - z * z) * Math.cos(theta);
  var y = Math.sqrt(1 - z * z) * Math.sin(theta);
  return new Vec3(x, y, z);
};

/**
 * Generates a random vector inside the unit sphere.
 *
 * @return {!Vec3} A random vector.
 */
Vec3.random = function () {
  return Vec3.randomUnit().scale(Math.random());
};

/**
 * Returns a new Vec3 object from a given coordinate.
 *
 * @param {Coordinate3} a The coordinate.
 * @return {!Vec3} A new vector object.
 */
Vec3.fromCoordinate3 = function (a) {
  return new Vec3(a.x, a.y, a.z);
};

/**
 * Creates a new copy of this Vec3.
 *
 * @return {!Vec3} A new vector with the same coordinates as this one.
 * @override
 */
Vec3.prototype.clone = function () {
  return new Vec3(this.x, this.y, this.z);
};

/**
 * Returns the magnitude of the vector measured from the origin.
 *
 * @return {number} The length of the vector.
 */
Vec3.prototype.magnitude = function () {
  return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
};

/**
 * Returns the squared magnitude of the vector measured from the origin.
 * NOTE(brenneman): Leaving out the square root is not a significant
 * optimization in JavaScript.
 *
 * @return {number} The length of the vector, squared.
 */
Vec3.prototype.squaredMagnitude = function () {
  return this.x * this.x + this.y * this.y + this.z * this.z;
};

/**
 * Scales the current vector by a constant.
 *
 * @param {number} s The scale factor.
 * @return {!Vec3} This vector, scaled.
 */
Vec3.prototype.scale = function (s) {
  this.x *= s;
  this.y *= s;
  this.z *= s;
  return this;
};

/**
 * Reverses the sign of the vector. Equivalent to scaling the vector by -1.
 *
 * @return {!Vec3} This vector, inverted.
 */
Vec3.prototype.invert = function () {
  this.x = -this.x;
  this.y = -this.y;
  this.z = -this.z;
  return this;
};

/**
 * Normalizes the current vector to have a magnitude of 1.
 *
 * @return {!Vec3} This vector, normalized.
 */
Vec3.prototype.normalize = function () {
  return this.scale(1 / this.magnitude());
};

/**
 * Adds another vector to this vector in-place.
 *
 * @param {Vec3} b The vector to add.
 * @return {!Vec3} This vector with {@code b} added.
 */
Vec3.prototype.add = function (b) {
  this.x += b.x;
  this.y += b.y;
  this.z += b.z;
  return this;
};

/**
 * Subtracts another vector from this vector in-place.
 *
 * @param {Vec3} b The vector to subtract.
 * @return {!Vec3} This vector with {@code b} subtracted.
 */
Vec3.prototype.subtract = function (b) {
  this.x -= b.x;
  this.y -= b.y;
  this.z -= b.z;
  return this;
};

/**
 * Compares this vector with another for equality.
 *
 * @param {Vec3} b The other vector.
 * @return {boolean} True if this vector's x, y and z equal the given vector's
 *     x, y, and z, respectively.
 */
Vec3.prototype.equals = function (b) {
  return this == b || !!b && this.x == b.x && this.y == b.y && this.z == b.z;
};

/**
 * Returns the distance between two vectors.
 *
 * @param {Vec3} a The first vector.
 * @param {Vec3} b The second vector.
 * @return {number} The distance.
 */
Vec3.distance = _coordinate["default"].distance;

/**
 * Returns the squared distance between two vectors.
 *
 * @param {Vec3} a The first vector.
 * @param {Vec3} b The second vector.
 * @return {number} The squared distance.
 */
Vec3.squaredDistance = _coordinate["default"].squaredDistance;

/**
 * Compares vectors for equality.
 *
 * @param {Vec3} a The first vector.
 * @param {Vec3} b The second vector.
 * @return {boolean} True if the vectors have equal x, y, and z coordinates.
 */
Vec3.equals = _coordinate["default"].equals;

/**
 * Returns the sum of two vectors as a new Vec3.
 *
 * @param {Vec3} a The first vector.
 * @param {Vec3} b The second vector.
 * @return {!Vec3} The sum vector.
 */
Vec3.sum = function (a, b) {
  return new Vec3(a.x + b.x, a.y + b.y, a.z + b.z);
};

/**
 * Returns the difference of two vectors as a new Vec3.
 *
 * @param {Vec3} a The first vector.
 * @param {Vec3} b The second vector.
 * @return {!Vec3} The difference vector.
 */
Vec3.difference = function (a, b) {
  return new Vec3(a.x - b.x, a.y - b.y, a.z - b.z);
};

/**
 * Returns the dot-product of two vectors.
 *
 * @param {Vec3} a The first vector.
 * @param {Vec3} b The second vector.
 * @return {number} The dot-product of the two vectors.
 */
Vec3.dot = function (a, b) {
  return a.x * b.x + a.y * b.y + a.z * b.z;
};

/**
 * Returns the cross-product of two vectors.
 *
 * @param {Vec3} a The first vector.
 * @param {Vec3} b The second vector.
 * @return {!Vec3} The cross-product of the two vectors.
 */
Vec3.cross = function (a, b) {
  return new Vec3(a.y * b.z - a.z * b.y, a.z * b.x - a.x * b.z, a.x * b.y - a.y * b.x);
};

/**
 * Returns a new Vec3 that is the linear interpolant between vectors a and b at
 * scale-value x.
 *
 * @param {Vec3} a Vector a.
 * @param {Vec3} b Vector b.
 * @param {number} x The proportion between a and b.
 * @return {!Vec3} The interpolated vector.
 */
Vec3.lerp = function (a, b, x) {
  return new Vec3(_basicMath["default"].lerp(a.x, b.x, x), _basicMath["default"].lerp(a.y, b.y, x), _basicMath["default"].lerp(a.z, b.z, x));
};
var _default = exports["default"] = Vec3;

},{"1184":1184,"1454":1454,"823":823,"832":832,"835":835}],835:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
require(1471);
var _goog = _interopRequireDefault(require(823));
/**
 * Created by mashx on 16-7-27.
 */
// Copyright 2008 The Closure Library Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS-IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

/**
 * @fileoverview A utility class for representing three-dimensional points.
 *
 * Based heavily on coordinate.js by:
 */

/**
 * Class for representing coordinates and positions in 3 dimensions.
 *
 * @param {number=} opt_x X coordinate, defaults to 0.
 * @param {number=} opt_y Y coordinate, defaults to 0.
 * @param {number=} opt_z Z coordinate, defaults to 0.
 * @constructor
 */
function Coordinate3(opt_x, opt_y, opt_z) {
  /**
   * X-value
   * @type {number}
   */
  this.x = _goog["default"].isDef(opt_x) ? opt_x : 0;

  /**
   * Y-value
   * @type {number}
   */
  this.y = _goog["default"].isDef(opt_y) ? opt_y : 0;

  /**
   * Z-value
   * @type {number}
   */
  this.z = _goog["default"].isDef(opt_z) ? opt_z : 0;
}
;

/**
 * Returns a new copy of the coordinate.
 *
 * @return {!Coordinate3} A clone of this coordinate.
 */
Coordinate3.prototype.clone = function () {
  return new Coordinate3(this.x, this.y, this.z);
};
if (_goog["default"].DEBUG) {
  /**
   * Returns a nice string representing the coordinate.
   *
   * @return {string} In the form (50, 73, 31).
   * @override
   */
  Coordinate3.prototype.toString = function () {
    return '(' + this.x + ', ' + this.y + ', ' + this.z + ')';
  };
}

/**
 * Compares coordinates for equality.
 *
 * @param {Coordinate3} a A Coordinate3.
 * @param {Coordinate3} b A Coordinate3.
 * @return {boolean} True iff the coordinates are equal, or if both are null.
 */
Coordinate3.equals = function (a, b) {
  if (a == b) {
    return true;
  }
  if (!a || !b) {
    return false;
  }
  return a.x == b.x && a.y == b.y && a.z == b.z;
};

/**
 * Returns the distance between two coordinates.
 *
 * @param {Coordinate3} a A Coordinate3.
 * @param {Coordinate3} b A Coordinate3.
 * @return {number} The distance between {@code a} and {@code b}.
 */
Coordinate3.distance = function (a, b) {
  var dx = a.x - b.x;
  var dy = a.y - b.y;
  var dz = a.z - b.z;
  return Math.sqrt(dx * dx + dy * dy + dz * dz);
};

/**
 * Returns the squared distance between two coordinates. Squared distances can
 * be used for comparisons when the actual value is not required.
 *
 * Performance note: eliminating the square root is an optimization often used
 * in lower-level languages, but the speed difference is not nearly as
 * pronounced in JavaScript (only a few percent.)
 *
 * @param {Coordinate3} a A Coordinate3.
 * @param {Coordinate3} b A Coordinate3.
 * @return {number} The squared distance between {@code a} and {@code b}.
 */
Coordinate3.squaredDistance = function (a, b) {
  var dx = a.x - b.x;
  var dy = a.y - b.y;
  var dz = a.z - b.z;
  return dx * dx + dy * dy + dz * dz;
};

/**
 * Returns the difference between two coordinates as a new
 * Coordinate3.
 *
 * @param {Coordinate3} a A Coordinate3.
 * @param {Coordinate3} b A Coordinate3.
 * @return {!Coordinate3} A Coordinate3 representing the difference
 *     between {@code a} and {@code b}.
 */
Coordinate3.difference = function (a, b) {
  return new Coordinate3(a.x - b.x, a.y - b.y, a.z - b.z);
};

/**
 * Returns the contents of this coordinate as a 3 value Array.
 *
 * @return {!Array.<number>} A new array.
 */
Coordinate3.prototype.toArray = function () {
  return [this.x, this.y, this.z];
};

/**
 * Converts a three element array into a Coordinate3 object.  If the value
 * passed in is not an array, not array-like, or not of the right length, an
 * error is thrown.
 *
 * @param {Array.<number>} a Array of numbers to become a coordinate.
 * @return {!Coordinate3} A new coordinate from the array values.
 * @throws {Error} When the oject passed in is not valid.
 */
Coordinate3.fromArray = function (a) {
  if (a.length <= 3) {
    return new Coordinate3(a[0], a[1], a[2]);
  }
  throw Error('Conversion from an array requires an array of length 3');
};
var _default = exports["default"] = Coordinate3;

},{"1184":1184,"1437":1437,"1454":1454,"1463":1463,"1471":1471,"1478":1478,"823":823}],831:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1450);
var _rect = _interopRequireDefault(require(836));
var _MMPoint = _interopRequireDefault(require(830));
var _vec = _interopRequireDefault(require(839));
var _goog = _interopRequireDefault(require(823));
var _box = _interopRequireDefault(require(833));
var _size = _interopRequireDefault(require(837));
/**
 * Class for representing a rect. A rect is specified as a top, right, bottom,
 * and left. A rect is useful for representing margins and padding.
 *
 * @param {number} top Top.
 * @param {number} right Right.
 * @param {number} bottom Bottom.
 * @param {number} left Left.
 * @constructor
 */
function MMRect(top, right, bottom, left) {
  _box["default"].call(this, top, right, bottom, left); //
}
;
_goog["default"].inherits(MMRect, _box["default"]); //

MMRect.prototype.getWidth = function () {
  return Math.abs(this.right - this.left);
};
MMRect.prototype.getHeight = function () {
  return Math.abs(this.bottom - this.top);
};
MMRect.prototype.setRct = function (left, top, width, height) {
  this.left = left;
  this.top = top;
  this.right = left + width;
  this.bottom = top + height;
};
MMRect.prototype.setWidth = function (width) {
  this.right = this.left + width;
};
MMRect.prototype.setHeight = function (height) {
  this.bottom = this.top + height;
};
MMRect.prototype.initWith2Pts = function (pt0, pt1) {
  this.left = Math.min(pt0.x, pt1.x);
  this.top = Math.min(pt0.y, pt1.y);
  this.right = Math.max(pt0.x, pt1.x);
  this.bottom = Math.max(pt0.y, pt1.y);
};
MMRect.prototype.initWithPtsBounadingBox = function (pts) {
  var maxX = pts[0].x,
    minX = pts[0].x;
  var maxY = pts[0].y,
    minY = pts[0].y;
  for (var i = 1; i < pts.length; i++) {
    if (pts[i].x < minX) {
      minX = pts[i].x;
    } else if (pts[i].x > maxX) {
      maxX = pts[i].x;
    }
    ;
    if (pts[i].y < minY) {
      minY = pts[i].y;
    } else if (pts[i].y > maxY) {
      maxY = pts[i].y;
    }
    ;
  }
  ;
  this.left = minX;
  this.top = minY;
  this.right = maxX;
  this.bottom = maxY;
};
MMRect.prototype.getSize = function () {
  var size = new _size["default"](this.getWidth(), this.getHeight());
  return size;
};
MMRect.prototype.getOrigin = function () {
  var origin = new _MMPoint["default"](this.left, this.top);
  return origin;
};
MMRect.prototype.include = function (pt) {
  if (pt.x >= this.left && pt.x <= this.right && pt.y >= this.top && pt.y <= this.bottom) {
    return true;
  }
  return false;
};
MMRect.prototype.getCenter = function () {
  var centerPoint = new _MMPoint["default"]();
  centerPoint.x = (this.left + this.right) / 2;
  centerPoint.y = (this.top + this.bottom) / 2;
  return centerPoint;
};
MMRect.prototype.getCtrlPts = function (onlyCorner_) {
  var _onlyCorner = onlyCorner_ ? onlyCorner_ : false;
  var ctlPts = new Array();
  ctlPts.push(new _MMPoint["default"](this.left, this.top));
  if (!_onlyCorner) ctlPts.push(new _MMPoint["default"]((this.left + this.right) / 2, this.top));
  ctlPts.push(new _MMPoint["default"](this.right, this.top));
  if (!_onlyCorner) ctlPts.push(new _MMPoint["default"](this.right, (this.top + this.bottom) / 2));
  ctlPts.push(new _MMPoint["default"](this.right, this.bottom));
  if (!_onlyCorner) ctlPts.push(new _MMPoint["default"]((this.left + this.right) / 2, this.bottom));
  ctlPts.push(new _MMPoint["default"](this.left, this.bottom));
  if (!_onlyCorner) ctlPts.push(new _MMPoint["default"](this.left, (this.top + this.bottom) / 2));
  return ctlPts;
};
MMRect.prototype.getLogicPts = function () {
  var logicPts = new Array();
  logicPts.push(new _MMPoint["default"](this.left, this.top));
  logicPts.push(new _MMPoint["default"](this.right, this.top));
  logicPts.push(new _MMPoint["default"](this.right, this.bottom));
  logicPts.push(new _MMPoint["default"](this.left, this.bottom));
  return logicPts;
};
MMRect.prototype.empty = function () {
  if (Math.abs(this.getWidth()) < 0.00001 || Math.abs(this.getHeight()) < 0.00001) {
    return true;
  } else if (this.left >= this.right || this.top >= this.bottom) {
    return true;
  }
  return false;
};
MMRect.prototype.scale = function (scaleX, scaleY) {
  if (!scaleY) {
    scaleY = scaleX;
  }
  ;
  this.left *= scaleX;
  this.right *= scaleX;
  this.top *= scaleY;
  this.bottom *= scaleY;
};
MMRect.prototype.clone = function () {
  return new MMRect(this.top, this.right, this.bottom, this.left);
};
MMRect.prototype.intRect = function () {
  var intR = this.clone();
  intR.left = Math.round(intR.left);
  intR.top = Math.round(intR.top);
  intR.right = Math.round(intR.right);
  intR.bottom = Math.round(intR.bottom);
  return intR;
};
MMRect.prototype.getGoogRect = function () {
  return new _rect["default"](this.left, this.top, this.getWidth(), this.getHeight());
};

/**
 * 标准化矩形
 */
MMRect.prototype.getStandardRect = function () {
  var standardRect = new MMRect(0, 0, 0, 0);
  standardRect.top = this.top < this.bottom ? this.top : this.bottom;
  standardRect.bottom = this.top < this.bottom ? this.bottom : this.top;
  standardRect.left = this.left < this.right ? this.left : this.right;
  standardRect.right = this.left < this.right ? this.right : this.left;
  return standardRect;
};
MMRect.prototype.rotateAroundPt = function (anchor, degree, isArc) {
  var r = this.clone();
  var lt = new _MMPoint["default"](r.left, r.top);
  var rb = new _MMPoint["default"](r.right, r.bottom);
  if (!isArc) {
    degree = degree * Math.PI / 180;
  }
  lt = _vec["default"].rotateAroundPoint(lt, anchor, degree);
  rb = _vec["default"].rotateAroundPoint(rb, anchor, degree);
  r.left = Math.min(lt.x, rb.x);
  r.right = Math.max(lt.x, rb.x);
  r.top = Math.min(lt.y, rb.y);
  r.bottom = Math.max(lt.y, rb.y);
  return r;
};

// return {bool} - whether intersect
MMRect.prototype.intersects = function (another) {
  return _box["default"].intersects(this, another);
};

// return {MMRect} - intersection rect
MMRect.prototype.intersectsRect = function (another) {
  var r1 = this.getStandardRect();
  var r2 = another.getStandardRect();
  var left = r1.left > r2.left ? r1.left : r2.left;
  var right = r1.right < r2.right ? r1.right : r2.right;
  var top = r1.top > r2.top ? r1.top : r2.top;
  var bottom = r1.bottom < r2.bottom ? r1.bottom : r2.bottom;
  if (left >= right || top >= bottom) {
    return null;
  } else {
    return new MMRect(top, right, bottom, left);
  }
};
MMRect.prototype.area = function () {
  return this.getWidth() * this.getHeight();
};
MMRect.prototype.debugOutput = function (head) {
  console.log(head + "left top :(" + this.left.toFixed(3) + "," + this.top.toFixed(3) + ") -- right bottom:" + this.right.toFixed(3) + "," + this.bottom.toFixed(3) + " === w:" + this.getWidth().toFixed(3) + " h:" + this.getHeight().toFixed(3));
};
MMRect.prototype.shrink = function (gap) {
  this.left += gap;
  this.top += gap;
  this.right -= gap;
  this.bottom -= gap;
};
var _default = exports["default"] = MMRect;

},{"1184":1184,"1450":1450,"1454":1454,"823":823,"830":830,"833":833,"836":836,"837":837,"839":839}],836:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
var _box = _interopRequireDefault(require(833));
var _size = _interopRequireDefault(require(837));
var _coordinate = _interopRequireDefault(require(834));
var _goog = _interopRequireDefault(require(823));
/**
 * Created by mashx on 16-7-27.
 */
// Copyright 2006 The Closure Library Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS-IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governin·g permissions and
// limitations under the License.

/**
 * @fileoverview A utility class for representing rectangles.
 */

/**
 * Class for representing rectangular regions.
 * @param {number} x Left.
 * @param {number} y Top.
 * @param {number} w Width.
 * @param {number} h Height.
 * @constructor
 */
function Rect(x, y, w, h) {
  /** @type {number} */
  this.left = x;

  /** @type {number} */
  this.top = y;

  /** @type {number} */
  this.width = w;

  /** @type {number} */
  this.height = h;
}
;

/**
 * @return {!Rect} A new copy of this Rectangle.
 */
Rect.prototype.clone = function () {
  return new Rect(this.left, this.top, this.width, this.height);
};

/**
 * Returns a new Box object with the same position and dimensions as this
 * rectangle.
 * @return {!Box} A new Box representation of this Rectangle.
 */
Rect.prototype.toBox = function () {
  var right = this.left + this.width;
  var bottom = this.top + this.height;
  return new _box["default"](this.top, right, bottom, this.left);
};

/**
 * Creates a new Rect object with the same position and dimensions as a given
 * Box.  Note that this is only the inverse of toBox if left/top are defined.
 * @param {Box} box A box.
 * @return {!Rect} A new Rect initialized with the box's position
 *     and size.
 */
Rect.createFromBox = function (box) {
  return new Rect(box.left, box.top, box.right - box.left, box.bottom - box.top);
};
if (_goog["default"].DEBUG) {
  /**
   * Returns a nice string representing size and dimensions of rectangle.
   * @return {string} In the form (50, 73 - 75w x 25h).
   * @override
   */
  Rect.prototype.toString = function () {
    return '(' + this.left + ', ' + this.top + ' - ' + this.width + 'w x ' + this.height + 'h)';
  };
}

/**
 * Compares rectangles for equality.
 * @param {Rect} a A Rectangle.
 * @param {Rect} b A Rectangle.
 * @return {boolean} True iff the rectangles have the same left, top, width,
 *     and height, or if both are null.
 */
Rect.equals = function (a, b) {
  if (a == b) {
    return true;
  }
  if (!a || !b) {
    return false;
  }
  return a.left == b.left && a.width == b.width && a.top == b.top && a.height == b.height;
};

/**
 * Computes the intersection of this rectangle and the rectangle parameter.  If
 * there is no intersection, returns false and leaves this rectangle as is.
 * @param {Rect} rect A Rectangle.
 * @return {boolean} True iff this rectangle intersects with the parameter.
 */
Rect.prototype.intersection = function (rect) {
  var x0 = Math.max(this.left, rect.left);
  var x1 = Math.min(this.left + this.width, rect.left + rect.width);
  if (x0 <= x1) {
    var y0 = Math.max(this.top, rect.top);
    var y1 = Math.min(this.top + this.height, rect.top + rect.height);
    if (y0 <= y1) {
      this.left = x0;
      this.top = y0;
      this.width = x1 - x0;
      this.height = y1 - y0;
      return true;
    }
  }
  return false;
};

/**
 * Returns the intersection of two rectangles. Two rectangles intersect if they
 * touch at all, for example, two zero width and height rectangles would
 * intersect if they had the same top and left.
 * @param {Rect} a A Rectangle.
 * @param {Rect} b A Rectangle.
 * @return {Rect} A new intersection rect (even if width and height
 *     are 0), or null if there is no intersection.
 */
Rect.intersection = function (a, b) {
  // There is no nice way to do intersection via a clone, because any such
  // clone might be unnecessary if this function returns null.  So, we duplicate
  // code from above.

  var x0 = Math.max(a.left, b.left);
  var x1 = Math.min(a.left + a.width, b.left + b.width);
  if (x0 <= x1) {
    var y0 = Math.max(a.top, b.top);
    var y1 = Math.min(a.top + a.height, b.top + b.height);
    if (y0 <= y1) {
      return new Rect(x0, y0, x1 - x0, y1 - y0);
    }
  }
  return null;
};

/**
 * Returns whether two rectangles intersect. Two rectangles intersect if they
 * touch at all, for example, two zero width and height rectangles would
 * intersect if they had the same top and left.
 * @param {Rect} a A Rectangle.
 * @param {Rect} b A Rectangle.
 * @return {boolean} Whether a and b intersect.
 */
Rect.intersects = function (a, b) {
  return a.left <= b.left + b.width && b.left <= a.left + a.width && a.top <= b.top + b.height && b.top <= a.top + a.height;
};

/**
 * Returns whether a rectangle intersects this rectangle.
 * @param {Rect} rect A rectangle.
 * @return {boolean} Whether rect intersects this rectangle.
 */
Rect.prototype.intersects = function (rect) {
  return Rect.intersects(this, rect);
};

/**
 * Computes the difference regions between two rectangles. The return value is
 * an array of 0 to 4 rectangles defining the remaining regions of the first
 * rectangle after the second has been subtracted.
 * @param {Rect} a A Rectangle.
 * @param {Rect} b A Rectangle.
 * @return {!Array.<!Rect>} An array with 0 to 4 rectangles which
 *     together define the difference area of rectangle a minus rectangle b.
 */
Rect.difference = function (a, b) {
  var intersection = Rect.intersection(a, b);
  if (!intersection || !intersection.height || !intersection.width) {
    return [a.clone()];
  }
  var result = [];
  var top = a.top;
  var height = a.height;
  var ar = a.left + a.width;
  var ab = a.top + a.height;
  var br = b.left + b.width;
  var bb = b.top + b.height;

  // Subtract off any area on top where A extends past B
  if (b.top > a.top) {
    result.push(new Rect(a.left, a.top, a.width, b.top - a.top));
    top = b.top;
    // If we're moving the top down, we also need to subtract the height diff.
    height -= b.top - a.top;
  }
  // Subtract off any area on bottom where A extends past B
  if (bb < ab) {
    result.push(new Rect(a.left, bb, a.width, ab - bb));
    height = bb - top;
  }
  // Subtract any area on left where A extends past B
  if (b.left > a.left) {
    result.push(new Rect(a.left, top, b.left - a.left, height));
  }
  // Subtract any area on right where A extends past B
  if (br < ar) {
    result.push(new Rect(br, top, ar - br, height));
  }
  return result;
};

/**
 * Computes the difference regions between this rectangle and {@code rect}. The
 * return value is an array of 0 to 4 rectangles defining the remaining regions
 * of this rectangle after the other has been subtracted.
 * @param {Rect} rect A Rectangle.
 * @return {!Array.<!Rect>} An array with 0 to 4 rectangles which
 *     together define the difference area of rectangle a minus rectangle b.
 */
Rect.prototype.difference = function (rect) {
  return Rect.difference(this, rect);
};

/**
 * Expand this rectangle to also include the area of the given rectangle.
 * @param {Rect} rect The other rectangle.
 */
Rect.prototype.boundingRect = function (rect) {
  // We compute right and bottom before we change left and top below.
  var right = Math.max(this.left + this.width, rect.left + rect.width);
  var bottom = Math.max(this.top + this.height, rect.top + rect.height);
  this.left = Math.min(this.left, rect.left);
  this.top = Math.min(this.top, rect.top);
  this.width = right - this.left;
  this.height = bottom - this.top;
};

/**
 * Returns a new rectangle which completely contains both input rectangles.
 * @param {Rect} a A rectangle.
 * @param {Rect} b A rectangle.
 * @return {Rect} A new bounding rect, or null if either rect is
 *     null.
 */
Rect.boundingRect = function (a, b) {
  if (!a || !b) {
    return null;
  }
  var clone = a.clone();
  clone.boundingRect(b);
  return clone;
};

/**
 * Tests whether this rectangle entirely contains another rectangle or
 * coordinate.
 *
 * @param {Rect|Coordinate} another The rectangle or
 *     coordinate to test for containment.
 * @return {boolean} Whether this rectangle contains given rectangle or
 *     coordinate.
 */
Rect.prototype.contains = function (another) {
  if (another instanceof Rect) {
    return this.left <= another.left && this.left + this.width >= another.left + another.width && this.top <= another.top && this.top + this.height >= another.top + another.height;
  } else {
    // (another instanceof Coordinate)
    return another.x >= this.left && another.x <= this.left + this.width && another.y >= this.top && another.y <= this.top + this.height;
  }
};

/**
 * @param {!Coordinate} point A coordinate.
 * @return {number} The squared distance between the point and the closest
 *     point inside the rectangle. Returns 0 if the point is inside the
 *     rectangle.
 */
Rect.prototype.squaredDistance = function (point) {
  var dx = point.x < this.left ? this.left - point.x : Math.max(point.x - (this.left + this.width), 0);
  var dy = point.y < this.top ? this.top - point.y : Math.max(point.y - (this.top + this.height), 0);
  return dx * dx + dy * dy;
};

/**
 * @param {!Coordinate} point A coordinate.
 * @return {number} The distance between the point and the closest point
 *     inside the rectangle. Returns 0 if the point is inside the rectangle.
 */
Rect.prototype.distance = function (point) {
  return Math.sqrt(this.squaredDistance(point));
};

/**
 * @return {!Size} The size of this rectangle.
 */
Rect.prototype.getSize = function () {
  return new _size["default"](this.width, this.height);
};

/**
 * @return {!Coordinate} A new coordinate for the top-left corner of
 *     the rectangle.
 */
Rect.prototype.getTopLeft = function () {
  return new _coordinate["default"](this.left, this.top);
};

/**
 * @return {!Coordinate} A new coordinate for the center of the
 *     rectangle.
 */
Rect.prototype.getCenter = function () {
  return new _coordinate["default"](this.left + this.width / 2, this.top + this.height / 2);
};

/**
 * @return {!Coordinate} A new coordinate for the bottom-right corner
 *     of the rectangle.
 */
Rect.prototype.getBottomRight = function () {
  return new _coordinate["default"](this.left + this.width, this.top + this.height);
};

/**
 * Rounds the fields to the next larger integer values.
 * @return {!Rect} This rectangle with ceil'd fields.
 */
Rect.prototype.ceil = function () {
  this.left = Math.ceil(this.left);
  this.top = Math.ceil(this.top);
  this.width = Math.ceil(this.width);
  this.height = Math.ceil(this.height);
  return this;
};

/**
 * Rounds the fields to the next smaller integer values.
 * @return {!Rect} This rectangle with floored fields.
 */
Rect.prototype.floor = function () {
  this.left = Math.floor(this.left);
  this.top = Math.floor(this.top);
  this.width = Math.floor(this.width);
  this.height = Math.floor(this.height);
  return this;
};

/**
 * Rounds the fields to nearest integer values.
 * @return {!Rect} This rectangle with rounded fields.
 */
Rect.prototype.round = function () {
  this.left = Math.round(this.left);
  this.top = Math.round(this.top);
  this.width = Math.round(this.width);
  this.height = Math.round(this.height);
  return this;
};

/**
 * Translates this rectangle by the given offsets. If a
 * {@code Coordinate} is given, then the left and top values are
 * translated by the coordinate's x and y values. Otherwise, top and left are
 * translated by {@code tx} and {@code opt_ty} respectively.
 * @param {number|Coordinate} tx The value to translate left by or the
 *     the coordinate to translate this rect by.
 * @param {number=} opt_ty The value to translate top by.
 * @return {!Rect} This rectangle after translating.
 */
Rect.prototype.translate = function (tx, opt_ty) {
  if (tx instanceof _coordinate["default"]) {
    this.left += tx.x;
    this.top += tx.y;
  } else {
    this.left += tx;
    if (_goog["default"].isNumber(opt_ty)) {
      this.top += opt_ty;
    }
  }
  return this;
};

/**
 * Scales this rectangle by the given scale factors. The left and width values
 * are scaled by {@code sx} and the top and height values are scaled by
 * {@code opt_sy}.  If {@code opt_sy} is not given, then all fields are scaled
 * by {@code sx}.
 * @param {number} sx The scale factor to use for the x dimension.
 * @param {number=} opt_sy The scale factor to use for the y dimension.
 * @return {!Rect} This rectangle after scaling.
 */
Rect.prototype.scale = function (sx, opt_sy) {
  var sy = _goog["default"].isNumber(opt_sy) ? opt_sy : sx;
  this.left *= sx;
  this.width *= sx;
  this.top *= sy;
  this.height *= sy;
  return this;
};

/**
 * 向外扩展矩形
 * @param expW {Number} 宽的扩展
 * @param expH {Number} 高的扩展
 * @return {Rect} 扩展后的新矩形
 * @since 2014-6-17
 * @author jiang
 */
Rect.prototype.expand = function (expW, expH) {
  var rct = new Rect(this.left, this.top, this.width, this.height);
  if (expW == undefined) expW = 0;
  if (expH == undefined) expH = expW;
  rct.left -= expW;
  rct.top -= expH;
  rct.width += expW * 2;
  rct.height += expH * 2;
  return rct;
};
var _default = exports["default"] = Rect;

},{"1184":1184,"1437":1437,"1454":1454,"1463":1463,"1478":1478,"823":823,"833":833,"834":834,"837":837}],833:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
var _coordinate = _interopRequireDefault(require(834));
var _goog = _interopRequireDefault(require(823));
/**
 * Created by mashx on 16-7-27.
 */
// Copyright 2006 The Closure Library Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS-IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

/**
 * @fileoverview A utility class for representing a numeric box.
 */

/**
 * Class for representing a box. A box is specified as a top, right, bottom,
 * and left. A box is useful for representing margins and padding.
 *
 * @param {number} top Top.
 * @param {number} right Right.
 * @param {number} bottom Bottom.
 * @param {number} left Left.
 * @constructor
 */
function Box(top, right, bottom, left) {
  /**
   * Top
   * @type {number}
   */
  this.top = top;

  /**
   * Right
   * @type {number}
   */
  this.right = right;

  /**
   * Bottom
   * @type {number}
   */
  this.bottom = bottom;

  /**
   * Left
   * @type {number}
   */
  this.left = left;
}
;

/**
 * Creates a Box by bounding a collection of Coordinate objects
 * @param {...Coordinate} var_args Coordinates to be included inside
 *     the box.
 * @return {!Box} A Box containing all the specified Coordinates.
 */
Box.boundingBox = function (var_args) {
  var box = new Box(arguments[0].y, arguments[0].x, arguments[0].y, arguments[0].x);
  for (var i = 1; i < arguments.length; i++) {
    var coord = arguments[i];
    box.top = Math.min(box.top, coord.y);
    box.right = Math.max(box.right, coord.x);
    box.bottom = Math.max(box.bottom, coord.y);
    box.left = Math.min(box.left, coord.x);
  }
  return box;
};

/**
 * Creates a copy of the box with the same dimensions.
 * @return {!Box} A clone of this Box.
 */
Box.prototype.clone = function () {
  return new Box(this.top, this.right, this.bottom, this.left);
};
if (_goog["default"].DEBUG) {
  /**
   * Returns a nice string representing the box.
   * @return {string} In the form (50t, 73r, 24b, 13l).
   * @override
   */
  Box.prototype.toString = function () {
    return '(' + this.top + 't, ' + this.right + 'r, ' + this.bottom + 'b, ' + this.left + 'l)';
  };
}

/**
 * Returns whether the box contains a coordinate or another box.
 *
 * @param {Coordinate|Box} other A Coordinate or a Box.
 * @return {boolean} Whether the box contains the coordinate or other box.
 */
Box.prototype.contains = function (other) {
  return Box.contains(this, other);
};

/**
 * Expands box with the given margins.
 *
 * @param {number|Box} top Top margin or box with all margins.
 * @param {number=} opt_right Right margin.
 * @param {number=} opt_bottom Bottom margin.
 * @param {number=} opt_left Left margin.
 * @return {!Box} A reference to this Box.
 */
Box.prototype.expand = function (top, opt_right, opt_bottom, opt_left) {
  if (_goog["default"].isObject(top)) {
    this.top -= top.top;
    this.right += top.right;
    this.bottom += top.bottom;
    this.left -= top.left;
  } else {
    this.top -= top;
    this.right += opt_right;
    this.bottom += opt_bottom;
    this.left -= opt_left;
  }
  return this;
};

/**
 * Expand this box to include another box.
 * NOTE(user): This is used in code that needs to be very fast, please don't
 * add functionality to this function at the expense of speed (variable
 * arguments, accepting multiple argument types, etc).
 * @param {Box} box The box to include in this one.
 */
Box.prototype.expandToInclude = function (box) {
  this.left = Math.min(this.left, box.left);
  this.top = Math.min(this.top, box.top);
  this.right = Math.max(this.right, box.right);
  this.bottom = Math.max(this.bottom, box.bottom);
};

/**
 * Compares boxes for equality.
 * @param {Box} a A Box.
 * @param {Box} b A Box.
 * @return {boolean} True iff the boxes are equal, or if both are null.
 */
Box.equals = function (a, b) {
  if (a == b) {
    return true;
  }
  if (!a || !b) {
    return false;
  }
  return a.top == b.top && a.right == b.right && a.bottom == b.bottom && a.left == b.left;
};

/**
 * Returns whether a box contains a coordinate or another box.
 *
 * @param {Box} box A Box.
 * @param {Coordinate|Box} other A Coordinate or a Box.
 * @return {boolean} Whether the box contains the coordinate or other box.
 */
Box.contains = function (box, other) {
  if (!box || !other) {
    return false;
  }
  if (other instanceof Box) {
    return other.left >= box.left && other.right <= box.right && other.top >= box.top && other.bottom <= box.bottom;
  }

  // other is a Coordinate.
  return other.x >= box.left && other.x <= box.right && other.y >= box.top && other.y <= box.bottom;
};

/**
 * Returns the relative x position of a coordinate compared to a box.  Returns
 * zero if the coordinate is inside the box.
 *
 * @param {Box} box A Box.
 * @param {Coordinate} coord A Coordinate.
 * @return {number} The x position of {@code coord} relative to the nearest
 *     side of {@code box}, or zero if {@code coord} is inside {@code box}.
 */
Box.relativePositionX = function (box, coord) {
  if (coord.x < box.left) {
    return coord.x - box.left;
  } else if (coord.x > box.right) {
    return coord.x - box.right;
  }
  return 0;
};

/**
 * Returns the relative y position of a coordinate compared to a box.  Returns
 * zero if the coordinate is inside the box.
 *
 * @param {Box} box A Box.
 * @param {Coordinate} coord A Coordinate.
 * @return {number} The y position of {@code coord} relative to the nearest
 *     side of {@code box}, or zero if {@code coord} is inside {@code box}.
 */
Box.relativePositionY = function (box, coord) {
  if (coord.y < box.top) {
    return coord.y - box.top;
  } else if (coord.y > box.bottom) {
    return coord.y - box.bottom;
  }
  return 0;
};

/**
 * Returns the distance between a coordinate and the nearest corner/side of a
 * box. Returns zero if the coordinate is inside the box.
 *
 * @param {Box} box A Box.
 * @param {Coordinate} coord A Coordinate.
 * @return {number} The distance between {@code coord} and the nearest
 *     corner/side of {@code box}, or zero if {@code coord} is inside
 *     {@code box}.
 */
Box.distance = function (box, coord) {
  var x = Box.relativePositionX(box, coord);
  var y = Box.relativePositionY(box, coord);
  return Math.sqrt(x * x + y * y);
};

/**
 * Returns whether two boxes intersect.
 *
 * @param {Box} a A Box.
 * @param {Box} b A second Box.
 * @return {boolean} Whether the boxes intersect.
 */
Box.intersects = function (a, b) {
  var standard_a = a.getStandardRect(); //a 为Box子类 并且有getStandardRect（）方法
  var standard_b = b.getStandardRect(); //lishusheng,2014-07-05
  return standard_a.left <= standard_b.right && standard_b.left <= standard_a.right && standard_a.top <= standard_b.bottom && standard_b.top <= standard_a.bottom;
  //  return (a.left <= b.right && b.left <= a.right &&
  //          a.top <= b.bottom && b.top <= a.bottom);
};
/**
 * 标准化,lishusheng,2014-07-05
 */
Box.prototype.getStandardRect = function () {
  var standardRect = new Box(0, 0, 0, 0);
  standardRect.top = this.top < this.bottom ? this.top : this.bottom;
  standardRect.bottom = this.top < this.bottom ? this.bottom : this.top;
  standardRect.left = this.left < this.right ? this.left : this.right;
  standardRect.right = this.left < this.right ? this.right : this.left;
  return standardRect;
};

/**
 * Returns whether two boxes would intersect with additional padding.
 *
 * @param {Box} a A Box.
 * @param {Box} b A second Box.
 * @param {number} padding The additional padding.
 * @return {boolean} Whether the boxes intersect.
 */
Box.intersectsWithPadding = function (a, b, padding) {
  return a.left <= b.right + padding && b.left <= a.right + padding && a.top <= b.bottom + padding && b.top <= a.bottom + padding;
};

/**
 * Rounds the fields to the next larger integer values.
 *
 * @return {!Box} This box with ceil'd fields.
 */
Box.prototype.ceil = function () {
  this.top = Math.ceil(this.top);
  this.right = Math.ceil(this.right);
  this.bottom = Math.ceil(this.bottom);
  this.left = Math.ceil(this.left);
  return this;
};

/**
 * Rounds the fields to the next smaller integer values.
 *
 * @return {!Box} This box with floored fields.
 */
Box.prototype.floor = function () {
  this.top = Math.floor(this.top);
  this.right = Math.floor(this.right);
  this.bottom = Math.floor(this.bottom);
  this.left = Math.floor(this.left);
  return this;
};

/**
 * Rounds the fields to nearest integer values.
 *
 * @return {!Box} This box with rounded fields.
 */
Box.prototype.round = function () {
  this.top = Math.round(this.top);
  this.right = Math.round(this.right);
  this.bottom = Math.round(this.bottom);
  this.left = Math.round(this.left);
  return this;
};

/**
 * Translates this box by the given offsets. If a {@code Coordinate}
 * is given, then the left and right values are translated by the coordinate's
 * x value and the top and bottom values are translated by the coordinate's y
 * value.  Otherwise, {@code tx} and {@code opt_ty} are used to translate the x
 * and y dimension values.
 *
 * @param {number|Coordinate} tx The value to translate the x
 *     dimension values by or the the coordinate to translate this box by.
 * @param {number=} opt_ty The value to translate y dimension values by.
 * @return {!Box} This box after translating.
 */
Box.prototype.translate = function (tx, opt_ty) {
  if (tx instanceof _coordinate["default"]) {
    this.left += tx.x;
    this.right += tx.x;
    this.top += tx.y;
    this.bottom += tx.y;
  } else {
    this.left += tx;
    this.right += tx;
    if (_goog["default"].isNumber(opt_ty)) {
      this.top += opt_ty;
      this.bottom += opt_ty;
    }
  }
  return this;
};

/**
 * Scales this coordinate by the given scale factors. The x and y dimension
 * values are scaled by {@code sx} and {@code opt_sy} respectively.
 * If {@code opt_sy} is not given, then {@code sx} is used for both x and y.
 *
 * @param {number} sx The scale factor to use for the x dimension.
 * @param {number=} opt_sy The scale factor to use for the y dimension.
 * @return {!Box} This box after scaling.
 */
Box.prototype.scale = function (sx, opt_sy) {
  var sy = _goog["default"].isNumber(opt_sy) ? opt_sy : sx;
  this.left *= sx;
  this.right *= sx;
  this.top *= sy;
  this.bottom *= sy;
  return this;
};
var _default = exports["default"] = Box;

},{"1184":1184,"1437":1437,"1454":1454,"1463":1463,"1478":1478,"823":823,"834":834}],830:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _goog = _interopRequireDefault(require(823));
var _vec = _interopRequireDefault(require(839));
/**
 * point class
 *
 * jiang
 * 2014-5-21
 */

function MMPoint(x, y) {
  //goog.isDef(opt_x) ? opt_x : 0
  _vec["default"].call(this, x, y);
  return this;
}
;
_goog["default"].inherits(MMPoint, _vec["default"]);
MMPoint.prototype.equals = function (point) {
  if (Math.abs(this.x - point.x) < 0.00001 && Math.abs(this.y - point.y) < 0.00001) {
    return true;
  }
  return false;
};
MMPoint.prototype.offsetTo = function (point) {
  return new MMPoint(point.x - this.x, point.y - this.y);
};
MMPoint.prototype.clone = function () {
  return new MMPoint(this.x, this.y);
};
MMPoint.prototype.negative = function () {
  return new MMPoint(-this.x, -this.y);
};
MMPoint.movePoints = function (points, offset) {
  var out = [];
  var i = points.length;
  while (i--) {
    out.unshift(new MMPoint(points[i].x + offset.x, points[i].y + offset.y));
  }
  return out;
};
/**
 * Calculates the distance to an other Point.
 * @param otherPoint {MMPoint} The Opint to calculate the distance
 */
MMPoint.prototype.distanceTo = function (otherPoint) {
  return MMPoint.distance(this, otherPoint);
};
MMPoint.prototype.translate = function (tx, opt_ty) {
  if (tx instanceof MMPoint) {
    this.x += tx.x;
    this.y += tx.y;
  } else {
    this.x += tx;
    if (_goog["default"].isNumber(opt_ty)) {
      this.y += opt_ty;
    } else {
      this.y += tx;
    }
  }
  return this;
};
MMPoint.prototype.multiple = function (m) {
  this.x *= m;
  this.y *= m;
};
MMPoint.distance = _vec["default"].distance;
var _default = exports["default"] = MMPoint;

},{"1184":1184,"1454":1454,"823":823,"839":839}],839:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _basicMath = _interopRequireDefault(require(832));
var _coordinate = _interopRequireDefault(require(834));
var _goog = _interopRequireDefault(require(823));
/**
 * Created by mashx on 16-7-27.
 */

// Copyright 2007 The Closure Library Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS-IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

/**
 * @fileoverview Defines a 2-element vector class that can be used for
 * coordinate math, useful for animation systems and point manipulation.
 *
 * Vec2 objects inherit from Coordinate and may be used wherever a
 * Coordinate is required. Where appropriate, Vec2 functions accept both Vec2
 * and Coordinate objects as input.
 *
 * @author brenneman@google.com (Shawn Brenneman)
 */

/**
 * Class for a two-dimensional vector object and assorted functions useful for
 * manipulating points.
 *
 * @param {number} x The x coordinate for the vector.
 * @param {number} y The y coordinate for the vector.
 * @constructor
 * @extends {Coordinate}
 */
function Vec2(x, y) {
  /**
   * X-value
   * @type {number}
   */
  this.x = x;

  /**
   * Y-value
   * @type {number}
   */
  this.y = y;
}
;
_goog["default"].inherits(Vec2, _coordinate["default"]);

/**
 * @return {!Vec2} A random unit-length vector.
 */
Vec2.randomUnit = function () {
  var angle = Math.random() * Math.PI * 2;
  return new Vec2(Math.cos(angle), Math.sin(angle));
};
Vec2.prototype.angleBetweenVector = function (vec) {
  var rad = 0;
  //计算两个向量间的叉乘
  var value1 = vec.x * this.y - vec.y * this.x;
  //两向量之间的点积
  var value2 = this.x * vec.x + this.y * vec.y;
  //两向量模的乘积
  var value3 = this.magnitude() * vec.magnitude();
  //两向量之间的夹角
  if (value1 <= 0) {
    rad = Math.acos(value2 / value3);
  } else if (value1 > 0) {
    rad = 2 * Math.PI - Math.acos(value2 / value3);
  }
  return rad;
};

/**
 * @return {!Vec2} A random vector inside the unit-disc.
 */
Vec2.random = function () {
  var mag = Math.sqrt(Math.random());
  var angle = Math.random() * Math.PI * 2;
  return new Vec2(Math.cos(angle) * mag, Math.sin(angle) * mag);
};

/**
 * Returns a new Vec2 object from a given coordinate.
 * @param {!Coordinate} a The coordinate.
 * @return {!Vec2} A new vector object.
 */
Vec2.fromCoordinate = function (a) {
  return new Vec2(a.x, a.y);
};

/**
 * @return {!Vec2} A new vector with the same coordinates as this one.
 * @override
 */
Vec2.prototype.clone = function () {
  return new Vec2(this.x, this.y);
};

/**
 * Returns the magnitude of the vector measured from the origin.
 * @return {number} The length of the vector.
 */
Vec2.prototype.magnitude = function () {
  return Math.sqrt(this.x * this.x + this.y * this.y);
};

/**
 * Returns the squared magnitude of the vector measured from the origin.
 * NOTE(brenneman): Leaving out the square root is not a significant
 * optimization in JavaScript.
 * @return {number} The length of the vector, squared.
 */
Vec2.prototype.squaredMagnitude = function () {
  return this.x * this.x + this.y * this.y;
};

/**
 * @return {!Vec2} This coordinate after scaling.
 * @override
 */
Vec2.prototype.scale = /** @type {function(number, number=):!Vec2} */
_coordinate["default"].prototype.scale;

/**
 * Reverses the sign of the vector. Equivalent to scaling the vector by -1.
 * @return {!Vec2} The inverted vector.
 */
Vec2.prototype.invert = function () {
  this.x = -this.x;
  this.y = -this.y;
  return this;
};

/**
 * Normalizes the current vector to have a magnitude of 1.
 * @return {!Vec2} The normalized vector.
 */
Vec2.prototype.normalize = function () {
  return this.scale(1 / this.magnitude());
};

/**
 * Adds another vector to this vector in-place.
 * @param {!Coordinate} b The vector to add.
 * @return {!Vec2}  This vector with {@code b} added.
 */
Vec2.prototype.add = function (b) {
  this.x += b.x;
  this.y += b.y;
  return this;
};

/**
 * Subtracts another vector from this vector in-place.
 * @param {!Coordinate} b The vector to subtract.
 * @return {!Vec2} This vector with {@code b} subtracted.
 */
Vec2.prototype.subtract = function (b) {
  this.x -= b.x;
  this.y -= b.y;
  return this;
};

/**
 * Rotates this vector in-place by a given angle, specified in radians.
 * @param {number} angle The angle, in radians.
 * @return {!Vec2} This vector rotated {@code angle} radians.
 */
Vec2.prototype.rotate = function (angle) {
  var cos = Math.cos(angle);
  var sin = Math.sin(angle);
  var newX = this.x * cos - this.y * sin;
  var newY = this.y * cos + this.x * sin;
  this.x = newX;
  this.y = newY;
  return this;
};

/**
 * Rotates a vector by a given angle, specified in radians, relative to a given
 * axis rotation point. The returned vector is a newly created instance - no
 * in-place changes are done.
 * @param {!Vec2} v A vector.
 * @param {!Vec2} axisPoint The rotation axis point.
 * @param {number} angle The angle, in radians.
 * @return {!Vec2} The rotated vector in a newly created instance.
 */
Vec2.rotateAroundPoint = function (v, axisPoint, angle) {
  var res = v.clone();
  return res.subtract(axisPoint).rotate(angle).add(axisPoint);
};

/**
 * Compares this vector with another for equality.
 * @param {!Vec2} b The other vector.
 * @return {boolean} Whether this vector has the same x and y as the given
 *     vector.
 */
Vec2.prototype.equals = function (b) {
  return this == b || !!b && this.x == b.x && this.y == b.y;
};

/**
 * Returns the distance between two vectors.
 * @param {!Coordinate} a The first vector.
 * @param {!Coordinate} b The second vector.
 * @return {number} The distance.
 */
Vec2.distance = _coordinate["default"].distance;

/**
 * Returns the squared distance between two vectors.
 * @param {!Coordinate} a The first vector.
 * @param {!Coordinate} b The second vector.
 * @return {number} The squared distance.
 */
Vec2.squaredDistance = _coordinate["default"].squaredDistance;

/**
 * Compares vectors for equality.
 * @param {!Coordinate} a The first vector.
 * @param {!Coordinate} b The second vector.
 * @return {boolean} Whether the vectors have the same x and y coordinates.
 */
Vec2.equals = _coordinate["default"].equals;

/**
 * Returns the sum of two vectors as a new Vec2.
 * @param {!Coordinate} a The first vector.
 * @param {!Coordinate} b The second vector.
 * @return {!Vec2} The sum vector.
 */
Vec2.sum = function (a, b) {
  return new Vec2(a.x + b.x, a.y + b.y);
};

/**
 * Returns the difference between two vectors as a new Vec2.
 * @param {!Coordinate} a The first vector.
 * @param {!Coordinate} b The second vector.
 * @return {!Vec2} The difference vector.
 */
Vec2.difference = function (a, b) {
  return new Vec2(a.x - b.x, a.y - b.y);
};

/**
 * Returns the dot-product of two vectors.
 * @param {!Coordinate} a The first vector.
 * @param {!Coordinate} b The second vector.
 * @return {number} The dot-product of the two vectors.
 */
Vec2.dot = function (a, b) {
  return a.x * b.x + a.y * b.y;
};
Vec2.cross = function (a, b) {
  return a.x * b.y - a.y * b.x;
};

/**
 * Returns a new Vec2 that is the linear interpolant between vectors a and b at
 * scale-value x.
 * @param {!Coordinate} a Vector a.
 * @param {!Coordinate} b Vector b.
 * @param {number} x The proportion between a and b.
 * @return {!Vec2} The interpolated vector.
 */
Vec2.lerp = function (a, b, x) {
  return new Vec2(_basicMath["default"].lerp(a.x, b.x, x), _basicMath["default"].lerp(a.y, b.y, x));
};
var _default = exports["default"] = Vec2;

},{"1184":1184,"1454":1454,"823":823,"832":832,"834":834}],834:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
var _basicMath = _interopRequireDefault(require(832));
var _goog = _interopRequireDefault(require(823));
/**
 * Created by mashx on 16-7-27.
 */
// Copyright 2006 The Closure Library Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS-IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

/**
 * @fileoverview A utility class for representing two-dimensional positions.
 */

/**
 * Class for representing coordinates and positions.
 * @param {number=} opt_x Left, defaults to 0.
 * @param {number=} opt_y Top, defaults to 0.
 * @constructor
 */
function Coordinate(opt_x, opt_y) {
  /**
   * X-value
   * @type {number}
   */
  this.x = _goog["default"].isDef(opt_x) ? opt_x : 0;

  /**
   * Y-value
   * @type {number}
   */
  this.y = _goog["default"].isDef(opt_y) ? opt_y : 0;
}
;

/**
 * Returns a new copy of the coordinate.
 * @return {!Coordinate} A clone of this coordinate.
 */
Coordinate.prototype.clone = function () {
  return new Coordinate(this.x, this.y);
};
if (_goog["default"].DEBUG) {
  /**
   * Returns a nice string representing the coordinate.
   * @return {string} In the form (50, 73).
   * @override
   */
  Coordinate.prototype.toString = function () {
    return '(' + this.x + ', ' + this.y + ')';
  };
}

/**
 * Compares coordinates for equality.
 * @param {Coordinate} a A Coordinate.
 * @param {Coordinate} b A Coordinate.
 * @return {boolean} True iff the coordinates are equal, or if both are null.
 */
Coordinate.equals = function (a, b) {
  if (a == b) {
    return true;
  }
  if (!a || !b) {
    return false;
  }
  return a.x == b.x && a.y == b.y;
};

/**
 * Returns the distance between two coordinates.
 * @param {!Coordinate} a A Coordinate.
 * @param {!Coordinate} b A Coordinate.
 * @return {number} The distance between {@code a} and {@code b}.
 */
Coordinate.distance = function (a, b) {
  var dx = a.x - b.x;
  var dy = a.y - b.y;
  return Math.sqrt(dx * dx + dy * dy);
};

/**
 * Returns the magnitude of a coordinate.
 * @param {!Coordinate} a A Coordinate.
 * @return {number} The distance between the origin and {@code a}.
 */
Coordinate.magnitude = function (a) {
  return Math.sqrt(a.x * a.x + a.y * a.y);
};

/**
 * Returns the angle from the origin to a coordinate.
 * @param {!Coordinate} a A Coordinate.
 * @return {number} The angle, in degrees, clockwise from the positive X
 *     axis to {@code a}.
 */
Coordinate.azimuth = function (a) {
  return _basicMath["default"].angle(0, 0, a.x, a.y);
};

/**
 * Returns the squared distance between two coordinates. Squared distances can
 * be used for comparisons when the actual value is not required.
 *
 * Performance note: eliminating the square root is an optimization often used
 * in lower-level languages, but the speed difference is not nearly as
 * pronounced in JavaScript (only a few percent.)
 *
 * @param {!Coordinate} a A Coordinate.
 * @param {!Coordinate} b A Coordinate.
 * @return {number} The squared distance between {@code a} and {@code b}.
 */
Coordinate.squaredDistance = function (a, b) {
  var dx = a.x - b.x;
  var dy = a.y - b.y;
  return dx * dx + dy * dy;
};

/**
 * Returns the difference between two coordinates as a new
 * Coordinate.
 * @param {!Coordinate} a A Coordinate.
 * @param {!Coordinate} b A Coordinate.
 * @return {!Coordinate} A Coordinate representing the difference
 *     between {@code a} and {@code b}.
 */
Coordinate.difference = function (a, b) {
  return new Coordinate(a.x - b.x, a.y - b.y);
};

/**
 * Returns the sum of two coordinates as a new Coordinate.
 * @param {!Coordinate} a A Coordinate.
 * @param {!Coordinate} b A Coordinate.
 * @return {!Coordinate} A Coordinate representing the sum of the two
 *     coordinates.
 */
Coordinate.sum = function (a, b) {
  return new Coordinate(a.x + b.x, a.y + b.y);
};

/**
 * Rounds the x and y fields to the next larger integer values.
 * @return {!Coordinate} This coordinate with ceil'd fields.
 */
Coordinate.prototype.ceil = function () {
  this.x = Math.ceil(this.x);
  this.y = Math.ceil(this.y);
  return this;
};

/**
 * Rounds the x and y fields to the next smaller integer values.
 * @return {!Coordinate} This coordinate with floored fields.
 */
Coordinate.prototype.floor = function () {
  this.x = Math.floor(this.x);
  this.y = Math.floor(this.y);
  return this;
};

/**
 * Rounds the x and y fields to the nearest integer values.
 * @return {!Coordinate} This coordinate with rounded fields.
 */
Coordinate.prototype.round = function () {
  this.x = Math.round(this.x);
  this.y = Math.round(this.y);
  return this;
};

/**
 * Translates this box by the given offsets. If a {@code Coordinate}
 * is given, then the x and y values are translated by the coordinate's x and y.
 * Otherwise, x and y are translated by {@code tx} and {@code opt_ty}
 * respectively.
 * @param {number|Coordinate} tx The value to translate x by or the
 *     the coordinate to translate this coordinate by.
 * @param {number=} opt_ty The value to translate y by.
 * @return {!Coordinate} This coordinate after translating.
 */
Coordinate.prototype.translate = function (tx, opt_ty) {
  if (tx instanceof Coordinate) {
    this.x += tx.x;
    this.y += tx.y;
  } else {
    this.x += tx;
    if (_goog["default"].isNumber(opt_ty)) {
      this.y += opt_ty;
    }
  }
  return this;
};

/**
 * Scales this coordinate by the given scale factors. The x and y values are
 * scaled by {@code sx} and {@code opt_sy} respectively.  If {@code opt_sy}
 * is not given, then {@code sx} is used for both x and y.
 * @param {number} sx The scale factor to use for the x dimension.
 * @param {number=} opt_sy The scale factor to use for the y dimension.
 * @return {!Coordinate} This coordinate after scaling.
 */
Coordinate.prototype.scale = function (sx, opt_sy) {
  var sy = _goog["default"].isNumber(opt_sy) ? opt_sy : sx;
  this.x *= sx;
  this.y *= sy;
  return this;
};

/**
 * Rotates this coordinate clockwise about the origin (or, optionally, the given
 * center) by the given angle, in radians.
 * @param {number} radians The angle by which to rotate this coordinate
 *     clockwise about the given center, in radians.
 * @param {!Coordinate=} opt_center The center of rotation. Defaults
 *     to (0, 0) if not given.
 */
Coordinate.prototype.rotateRadians = function (radians, opt_center) {
  var center = opt_center || new Coordinate(0, 0);
  var x = this.x;
  var y = this.y;
  var cos = Math.cos(radians);
  var sin = Math.sin(radians);
  this.x = (x - center.x) * cos - (y - center.y) * sin + center.x;
  this.y = (x - center.x) * sin + (y - center.y) * cos + center.y;
};

/**
 * Rotates this coordinate clockwise about the origin (or, optionally, the given
 * center) by the given angle, in degrees.
 * @param {number} degrees The angle by which to rotate this coordinate
 *     clockwise about the given center, in degrees.
 * @param {!Coordinate=} opt_center The center of rotation. Defaults
 *     to (0, 0) if not given.
 */
Coordinate.prototype.rotateDegrees = function (degrees, opt_center) {
  this.rotateRadians(_basicMath["default"].toRadians(degrees), opt_center);
};
var _default = exports["default"] = Coordinate;

},{"1184":1184,"1437":1437,"1454":1454,"1463":1463,"1478":1478,"823":823,"832":832}],832:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1465);
/**
 * Created by mashx on 16-7-27.
 */

// Copyright 2006 The Closure Library Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS-IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

/**
 * @fileoverview Additional mathematical functions.
 */

var math = {};

/**
 * Returns a random integer greater than or equal to 0 and less than {@code a}.
 * @param {number} a  The upper bound for the random integer (exclusive).
 * @return {number} A random integer N such that 0 <= N < a.
 */
math.randomInt = function (a) {
  return Math.floor(Math.random() * a);
};
math.intersects = function (rct1, rct2) {
  return rct2.intersects(rct1);
};

/**
 * Returns a random number greater than or equal to {@code a} and less than
 * {@code b}.
 * @param {number} a  The lower bound for the random number (inclusive).
 * @param {number} b  The upper bound for the random number (exclusive).
 * @return {number} A random number N such that a <= N < b.
 */
math.uniformRandom = function (a, b) {
  return a + Math.random() * (b - a);
};

/**
 * Takes a number and clamps it to within the provided bounds.
 * @param {number} value The input number.
 * @param {number} min The minimum value to return.
 * @param {number} max The maximum value to return.
 * @return {number} The input number if it is within bounds, or the nearest
 *     number within the bounds.
 */
math.clamp = function (value, min, max) {
  return Math.min(Math.max(value, min), max);
};

/**
 * The % operator in JavaScript returns the remainder of a / b, but differs from
 * some other languages in that the result will have the same sign as the
 * dividend. For example, -1 % 8 == -1, whereas in some other languages
 * (such as Python) the result would be 7. This function emulates the more
 * correct modulo behavior, which is useful for certain applications such as
 * calculating an offset index in a circular list.
 *
 * @param {number} a The dividend.
 * @param {number} b The divisor.
 * @return {number} a % b where the result is between 0 and b (either 0 <= x < b
 *     or b < x <= 0, depending on the sign of b).
 */
math.modulo = function (a, b) {
  var r = a % b;
  // If r and b differ in sign, add b to wrap the result to the correct sign.
  return r * b < 0 ? r + b : r;
};

/**
 * Performs linear interpolation between values a and b. Returns the value
 * between a and b proportional to x (when x is between 0 and 1. When x is
 * outside this range, the return value is a linear extrapolation).
 * @param {number} a A number.
 * @param {number} b A number.
 * @param {number} x The proportion between a and b.
 * @return {number} The interpolated value between a and b.
 */
math.lerp = function (a, b, x) {
  return a + x * (b - a);
};

/**
 * Tests whether the two values are equal to each other, within a certain
 * tolerance to adjust for floating point errors.
 * @param {number} a A number.
 * @param {number} b A number.
 * @param {number=} opt_tolerance Optional tolerance range. Defaults
 *     to 0.000001. If specified, should be greater than 0.
 * @return {boolean} Whether {@code a} and {@code b} are nearly equal.
 */
math.nearlyEquals = function (a, b, opt_tolerance) {
  return Math.abs(a - b) <= (opt_tolerance || 0.000001);
};

// TODO(user): Rename to normalizeAngle, retaining old name as deprecated
// alias.
/**
 * Normalizes an angle to be in range [0-360). Angles outside this range will
 * be normalized to be the equivalent angle with that range.
 * @param {number} angle Angle in degrees.
 * @return {number} Standardized angle.
 */
math.standardAngle = function (angle) {
  return math.modulo(angle, 360);
};

/**
 * Normalizes an angle to be in range [0-2*PI). Angles outside this range will
 * be normalized to be the equivalent angle with that range.
 * @param {number} angle Angle in radians.
 * @return {number} Standardized angle.
 */
math.standardAngleInRadians = function (angle) {
  return math.modulo(angle, 2 * Math.PI);
};

/**
 * Converts degrees to radians.
 * @param {number} angleDegrees Angle in degrees.
 * @return {number} Angle in radians.
 */
math.toRadians = function (angleDegrees) {
  return angleDegrees * Math.PI / 180;
};

/**
 * Converts radians to degrees.
 * @param {number} angleRadians Angle in radians.
 * @return {number} Angle in degrees.
 */
math.toDegrees = function (angleRadians) {
  return angleRadians * 180 / Math.PI;
};

/**
 * For a given angle and radius, finds the X portion of the offset.
 * @param {number} degrees Angle in degrees (zero points in +X direction).
 * @param {number} radius Radius.
 * @return {number} The x-distance for the angle and radius.
 */
math.angleDx = function (degrees, radius) {
  return radius * Math.cos(math.toRadians(degrees));
};

/**
 * For a given angle and radius, finds the Y portion of the offset.
 * @param {number} degrees Angle in degrees (zero points in +X direction).
 * @param {number} radius Radius.
 * @return {number} The y-distance for the angle and radius.
 */
math.angleDy = function (degrees, radius) {
  return radius * Math.sin(math.toRadians(degrees));
};

/**
 * Computes the angle between two points (x1,y1) and (x2,y2).
 * Angle zero points in the +X direction, 90 degrees points in the +Y
 * direction (down) and from there we grow clockwise towards 360 degrees.
 * @param {number} x1 x of first point.
 * @param {number} y1 y of first point.
 * @param {number} x2 x of second point.
 * @param {number} y2 y of second point.
 * @return {number} Standardized angle in degrees of the vector from
 *     x1,y1 to x2,y2.
 */
math.angle = function (x1, y1, x2, y2) {
  return math.standardAngle(math.toDegrees(Math.atan2(y2 - y1, x2 - x1)));
};

/**
 * Computes the difference between startAngle and endAngle (angles in degrees).
 * @param {number} startAngle  Start angle in degrees.
 * @param {number} endAngle  End angle in degrees.
 * @return {number} The number of degrees that when added to
 *     startAngle will result in endAngle. Positive numbers mean that the
 *     direction is clockwise. Negative numbers indicate a counter-clockwise
 *     direction.
 *     The shortest route (clockwise vs counter-clockwise) between the angles
 *     is used.
 *     When the difference is 180 degrees, the function returns 180 (not -180)
 *     angleDifference(30, 40) is 10, and angleDifference(40, 30) is -10.
 *     angleDifference(350, 10) is 20, and angleDifference(10, 350) is -20.
 */
math.angleDifference = function (startAngle, endAngle) {
  var d = math.standardAngle(endAngle) - math.standardAngle(startAngle);
  if (d > 180) {
    d = d - 360;
  } else if (d <= -180) {
    d = 360 + d;
  }
  return d;
};

/**
 * Returns the sign of a number as per the "sign" or "signum" function.
 * @param {number} x The number to take the sign of.
 * @return {number} -1 when negative, 1 when positive, 0 when 0.
 */
math.sign = function (x) {
  return x == 0 ? 0 : x < 0 ? -1 : 1;
};

/**
 * JavaScript implementation of Longest Common Subsequence problem.
 * http://en.wikipedia.org/wiki/Longest_common_subsequence
 *
 * Returns the longest possible array that is subarray of both of given arrays.
 *
 * @param {Array.<Object>} array1 First array of objects.
 * @param {Array.<Object>} array2 Second array of objects.
 * @param {Function=} opt_compareFn Function that acts as a custom comparator
 *     for the array ojects. Function should return true if objects are equal,
 *     otherwise false.
 * @param {Function=} opt_collectorFn Function used to decide what to return
 *     as a result subsequence. It accepts 2 arguments: index of common element
 *     in the first array and index in the second. The default function returns
 *     element from the first array.
 * @return {!Array.<Object>} A list of objects that are common to both arrays
 *     such that there is no common subsequence with size greater than the
 *     length of the list.
 */
math.longestCommonSubsequence = function (array1, array2, opt_compareFn, opt_collectorFn) {
  var compare = opt_compareFn || function (a, b) {
    return a == b;
  };
  var collect = opt_collectorFn || function (i1, i2) {
    return array1[i1];
  };
  var length1 = array1.length;
  var length2 = array2.length;
  var arr = [];
  for (var i = 0; i < length1 + 1; i++) {
    arr[i] = [];
    arr[i][0] = 0;
  }
  for (var j = 0; j < length2 + 1; j++) {
    arr[0][j] = 0;
  }
  for (i = 1; i <= length1; i++) {
    for (j = 1; j <= length2; j++) {
      if (compare(array1[i - 1], array2[j - 1])) {
        arr[i][j] = arr[i - 1][j - 1] + 1;
      } else {
        arr[i][j] = Math.max(arr[i - 1][j], arr[i][j - 1]);
      }
    }
  }

  // Backtracking
  var result = [];
  var i = length1,
    j = length2;
  while (i > 0 && j > 0) {
    if (compare(array1[i - 1], array2[j - 1])) {
      result.unshift(collect(i - 1, j - 1));
      i--;
      j--;
    } else {
      if (arr[i - 1][j] > arr[i][j - 1]) {
        i--;
      } else {
        j--;
      }
    }
  }
  return result;
};

/**
 * Returns whether the supplied number represents an integer, i.e. that is has
 * no fractional component.  No range-checking is performed on the number.
 * @param {number} num The number to test.
 * @return {boolean} Whether {@code num} is an integer.
 */
math.isInt = function (num) {
  return isFinite(num) && num % 1 == 0;
};

/**
 * Returns whether the supplied number is finite and not NaN.
 * @param {number} num The number to test.
 * @return {boolean} Whether {@code num} is a finite number.
 */
math.isFiniteNumber = function (num) {
  return isFinite(num) && !isNaN(num);
};

/**
 * Returns the precise value of floor(log10(num)).
 * Simpler implementations didn't work because of floating point rounding
 * errors. For example
 * <ul>
 * <li>Math.floor(Math.log(num) / Math.LN10) is off by one for num == 1e+3.
 * <li>Math.floor(Math.log(num) * Math.LOG10E) is off by one for num == 1e+15.
 * <li>Math.floor(Math.log10(num)) is off by one for num == 1e+15 - 1.
 * </ul>
 * @param {number} num A floating point number.
 * @return {number} Its logarithm to base 10 rounded down to the nearest
 *     integer if num > 0. -Infinity if num == 0. NaN if num < 0.
 */
math.log10Floor = function (num) {
  if (num > 0) {
    var x = Math.round(Math.log(num) * Math.LOG10E);
    return x - (parseFloat('1e' + x) > num);
  }
  return num == 0 ? -Infinity : NaN;
};
var _default = exports["default"] = math;

},{"1454":1454,"1465":1465}],1465:[function(require,module,exports){
var $ = require(1270);
var $parseFloat = require(1323);

// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
$({ global: true, forced: parseFloat != $parseFloat }, {
  parseFloat: $parseFloat
});

},{"1270":1270,"1323":1323}],1323:[function(require,module,exports){
var global = require(1287);
var fails = require(1271);
var uncurryThis = require(1281);
var toString = require(1393);
var trim = require(1375).trim;
var whitespaces = require(1409);

var charAt = uncurryThis(''.charAt);
var $parseFloat = global.parseFloat;
var Symbol = global.Symbol;
var ITERATOR = Symbol && Symbol.iterator;
var FORCED = 1 / $parseFloat(whitespaces + '-0') !== -Infinity
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR && !fails(function () { $parseFloat(Object(ITERATOR)); }));

// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
module.exports = FORCED ? function parseFloat(string) {
  var trimmedString = trim(toString(string));
  var result = $parseFloat(trimmedString);
  return result === 0 && charAt(trimmedString, 0) == '-' ? -0 : result;
} : $parseFloat;

},{"1271":1271,"1281":1281,"1287":1287,"1375":1375,"1393":1393,"1409":1409}],822:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
var _typeof2 = _interopRequireDefault(require(1197));
var _map = _interopRequireDefault(require(821));
var _int = _interopRequireDefault(require(820));
/**
 * Created by mashx on 16-7-27.
 */

/**
 * A set that can contain both primitives and objects.  Adding and removing
 * elements is O(1).  Primitives are treated as identical if they have the same
 * type and convert to the same string.  Objects are treated as identical only
 * if they are references to the same object.  WARNING: A Set can
 * contain both 1 and (new Number(1)), because they are not the same.  WARNING:
 * Adding (new Number(1)) twice will yield two distinct elements, because they
 * are two different objects.  WARNING: Any object that is added to a
 * Set will be modified!  Because goog.getUid() is used to
 * identify objects, every object in the set will be mutated.
 * @param {Array.<T>|Object.<?,T>=} opt_values Initial values to start with.
 * @constructor
 * @implements {Collection.<T>}
 * @final
 * @template T
 */
function Set() {
  this.map_ = new _map["default"]();
}
;

/**
 * Obtains a unique key for an element of the set.  Primitives will yield the
 * same key if they have the same type and convert to the same string.  Object
 * references will yield the same key only if they refer to the same object.
 * @param {*} val Object or primitive value to get a key for.
 * @return {string} A unique key for this value/object.
 * @private
 */
Set.getKey_ = function (val) {
  var type = (0, _typeof2["default"])(val);
  if (val instanceof _int["default"]) {
    return 'Int64' + val.toString();
  } else if (type == 'object' && val || type == 'function') {
    //return 'o' + goog.getUid(/** @type {Object} */ (val));
    console.error('object is not supportted yet...');
  } else {
    return type.substr(0, 1) + val;
  }
};

/**
 * @return {number} The number of elements in the set.
 * @override
 */
Set.prototype.getCount = function () {
  return this.map_.getCount();
};

/**
 * Add a primitive or an object to the set.
 * @param {T} element The primitive or object to add.
 * @override
 */
Set.prototype.add = function (element) {
  this.map_.set(Set.getKey_(element), element);
};

/**
 * Removes the given element from this set.
 * @param {T} element The primitive or object to remove.
 * @return {boolean} Whether the element was found and removed.
 * @override
 */
Set.prototype.remove = function (element) {
  return this.map_.remove(Set.getKey_(element));
};

/**
 * Removes all elements from this set.
 */
Set.prototype.clear = function () {
  this.map_.clear();
};

/**
 * Tests whether this set is empty.
 * @return {boolean} True if there are no elements in this set.
 */
Set.prototype.isEmpty = function () {
  return this.map_.isEmpty();
};

/**
 * Tests whether this set contains the given element.
 * @param {T} element The primitive or object to test for.
 * @return {boolean} True if this set contains the given element.
 * @override
 */
Set.prototype.contains = function (element) {
  return this.map_.containsKey(Set.getKey_(element));
};

/**
 * Returns an array containing all the elements in this set.
 * @return {!Array.<T>} An array containing all the elements in this set.
 */
Set.prototype.getValues = function () {
  return this.map_.getValues();
};

/**
 * Creates a shallow clone of this set.
 * @return {!Set.<T>} A new set containing all the same elements as
 *     this set.
 */
Set.prototype.clone = function () {
  return new Set(this);
};
var _default = exports["default"] = Set;

},{"1184":1184,"1197":1197,"1437":1437,"1454":1454,"1463":1463,"1478":1478,"820":820,"821":821}],817:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function MolaTextAlignment(alignment) {
  this.textAlignment = 0; //0:TextAlignmentLeft,1:TextAlignmentCenter,2:TextAlignmentRight
  if (alignment && (alignment == 0 || alignment == 1 || alignment == 2)) {
    this.textAlignment = alignment;
  }
}
;
var _default = exports["default"] = MolaTextAlignment;

},{"1454":1454}],815:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function MMFont() {
  this.m_fontName = "Helvetica";
  this.m_fontSize = 20;
}
;
var _default = exports["default"] = MMFont;

},{"1454":1454}],814:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _BoardOrientation = _interopRequireDefault(require(802));
function MMDevOrientation(orientation) {
  this.devOrientation = 0; //0:Portrait,1:LandscapeLeft,2:LandscapeRight,3:UpsideDown
  if (orientation && (orientation == 0 || orientation == 1 || orientation == 2 || orientation == 3)) {
    this.devOrientation = orientation;
  }
}
;
MMDevOrientation.prototype.isLandscape = function () {
  return this.devOrientation == 1 || this.devOrientation == 2;
};
MMDevOrientation.createObjByStr = function (direction) {
  if (direction == _BoardOrientation["default"].Landscape) {
    return new MMDevOrientation(1);
  } else {
    return new MMDevOrientation(0);
  }
};
var _default = exports["default"] = MMDevOrientation;

},{"1184":1184,"1454":1454,"802":802}],802:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * @enum {string}
 */
var BoardOrientation = {
  Landscape: 'landscape',
  Portrait: 'portrait'
};
var _default = exports["default"] = BoardOrientation;

},{"1454":1454}],283:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMModelBase = _interopRequireDefault(require(21));
var MDSealData = _MMModelBase["default"].extend({
  defaults: {
    "creator": "",
    "ctime": "",
    "delTime": "",
    "enterpriseId": 0,
    "id": null,
    "type": 0,
    "sealUrl": "",
    "fileId": "",
    "status": 0
  },
  initialize: function initialize(opt) {
    _MMModelBase["default"].prototype.initialize.call(this, opt);
    this.loadImg();
    this.waitCallback = [];
  },
  loadImg: function loadImg(callback) {
    var _this = this;
    if (this.getAvatarImg()) {
      callback && callback();
      return;
    }
    if (this.get("loading")) {
      this.waitCallback.push(callback);
      return;
    }
    var avatarImg = new Image();
    avatarImg.crossOrigin = 'Anonymous';
    this.set("loading", true);
    avatarImg.onload = function () {
      var w = Math.min(avatarImg.width, 300);
      var h = avatarImg.height / avatarImg.width * w;
      _this.setWidth(w);
      _this.setHeight(h);
      _this.setAvatarImg(avatarImg);
      _this.loading = false;
      callback && callback();
      if (_this.waitCallback.length) {
        for (var i = 0; i < _this.waitCallback.length; i++) {
          var cb = _this.waitCallback[i];
          cb && cb();
        }
        _this.waitCallback.length = [];
      }
    };
    avatarImg.onerror = function () {
      _this.set("loading", false);
      console.error('Failed to load avatar image');
    };
    avatarImg.src = this.getUrl();
  },
  getUrl: function getUrl() {
    return this.get("sealUrl");
  },
  getId: function getId() {
    return this.get("id");
  },
  getAvatarImg: function getAvatarImg() {
    return this.get("avatarImg");
  },
  setAvatarImg: function setAvatarImg(avatarImg) {
    this.set("avatarImg", avatarImg);
  },
  getHeight: function getHeight() {
    return this.get("height");
  },
  getWidth: function getWidth() {
    return this.get("width");
  },
  setHeight: function setHeight(height) {
    this.set("height", height);
  },
  setWidth: function setWidth(width) {
    this.set("width", width);
  },
  gethwRatio: function gethwRatio() {
    return this.getHeight() / this.getWidth();
  }
});
var _default = exports["default"] = MDSealData;

},{"1184":1184,"1454":1454,"21":21}],234:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  LOGIN: Math.pow(2, 0),
  READ_ENTERPRISE_MEMBER: Math.pow(2, 1),
  MANAGE_ENTERPRISE_MEMBER: Math.pow(2, 2),
  READ_ENTERPRISE_ROLE: Math.pow(2, 3),
  MANAGE_ENTERPRISE_ROLE: Math.pow(2, 4),
  READ_ENTERPRISE_INFO: Math.pow(2, 5),
  MANAGE_ENTERPRISE_INFO: Math.pow(2, 6),
  READ_ORGANIZATION: Math.pow(2, 7),
  MANAGE_ORGANIZATION: Math.pow(2, 8),
  SET_ADMIN: Math.pow(2, 9),
  READ_EXTERNAL_MEMBER: Math.pow(2, 10),
  MANAGE_EXTERNAL_MEMBER: Math.pow(2, 11),
  MANAGE_ENTERPRISE_GROUP: Math.pow(2, 12),
  READ_GLOBAL_FOLDER: Math.pow(2, 13),
  READ_BROADCAST: Math.pow(2, 14),
  READ_ENTERPRISE_GROUP: Math.pow(2, 15),
  // MANAGE_ENTERPRISE_GROUP: Math.pow(2, 16),
  READ_FILELOG: Math.pow(2, 17),
  MANAGE_SECURITY_POLICY: Math.pow(2, 18),
  READ_WATERMARK: Math.pow(2, 19),
  MANAGE_WATERMARK: Math.pow(2, 20),
  MANAGE_MACBIND: Math.pow(2, 21)
};

},{"1454":1454}],233:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  OWN_FILE: Math.pow(2, 0),
  VIEW_MEMBER_FILE: Math.pow(2, 1),
  SHIFT_MEMBER_FILE: Math.pow(2, 2),
  MANAGE_TAG: Math.pow(2, 3),
  MANAGE_RECYCLE_BIN: Math.pow(2, 4),
  BROADCAST: Math.pow(2, 5),
  MANAGE_APPROVE: Math.pow(2, 6)
};

},{"1454":1454}],108:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1424);
require(1437);
require(1450);
require(1446);
require(1421);
require(1439);
require(1498);
require(1429);
require(1463);
require(1478);
require(1423);
require(1411);
require(1530);
require(1505);
require(1506);
require(1507);
require(1508);
require(1510);
require(1509);
require(1512);
require(1513);
require(1514);
require(1516);
require(1517);
require(1518);
require(1519);
require(1521);
require(1520);
require(1522);
require(1523);
require(1524);
require(1525);
require(1526);
require(1527);
require(1528);
require(1529);
require(1410);
require(1443);
require(1487);
require(1538);
require(1412);
require(1419);
require(1435);
require(1471);
require(1470);
var _MDLocalString = _interopRequireDefault(require(1150));
var _DateFromat = _interopRequireDefault(require(99));
var _cryptoJs = _interopRequireDefault(require("crypto-js"));
var _default = exports["default"] = {
  randomString: function randomString(length) {
    var seeds = '1234567890';
    var seeds2 = 'abcdefghigklmnopqrstuvwxyz';
    var seeds3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var length1 = seeds.length - 1;
    var length2 = seeds2.length - 1;
    var length3 = seeds3.length - 1;
    var str = [];
    _.times(3, function () {
      var index = _.random(0, length1);
      str.push(seeds[index]);
    });
    _.times(3, function () {
      var index = _.random(0, length2);
      str.push(seeds2[index]);
    });
    _.times(2, function () {
      var index = _.random(0, length3);
      str.push(seeds3[index]);
    });
    str = str.join('');
    return str;
  },
  timeDiff: function timeDiff(timeStart, timeEnd) {
    var oneMin = 1000 * 60;
    var oneHour = oneMin * 60;
    var oneDay = oneHour * 24;
    var diff = Math.abs(timeStart.getTime() - timeEnd.getTime());
    if (diff < oneMin) {
      return BabelStr.str(315); // '刚刚';
    } else if (diff < oneHour) {
      var minutes = Math.floor(diff / oneMin);
      return BabelStr.str(316, {
        'num': minutes
      }); //  'xxx 分钟前';
    } else if (diff < oneDay) {
      var hour = Math.floor(diff / oneHour);
      return BabelStr.str(317, {
        'num': hour
      }); //  'xxx小时前';
    } else {
      var day = Math.floor(diff / oneDay);
      return BabelStr.str(318, {
        'num': day
      }); //   'xxx天前';
    }
  },
  dayDiff: function dayDiff(timeStart, timeEnd) {
    var now = timeStart;
    var second = 1000;
    var minute = second * 60;
    var hour = minute * 60;
    var day = hour * 24;
    var week = day * 7;
    var hoursNow = timeStart.getHours();
    var minutesNow = timeStart.getMinutes();
    var secondsNow = timeStart.getSeconds();
    var timeDiff = timeEnd.getTime() - timeStart.getTime();
    var secondDiff = Math.ceil(timeDiff / second);
    var minuteDiff = Math.ceil(timeDiff / minute);
    var hourDiff = Math.ceil(timeDiff / hour);
    var pretty = '';
    var _dayDiff = Math.ceil(timeDiff / day);
    return {
      day: _dayDiff,
      hour: hourDiff
    };
  },
  prettyDate: function prettyDate(now, time) {
    var second = 1000;
    var minute = second * 60;
    var hour = minute * 60;
    var day = hour * 24;
    var week = day * 7;
    var hoursNow = new Date(now).getHours();
    var minutesNow = new Date(now).getMinutes();
    var secondsNow = new Date(now).getSeconds();
    var timeDiff = new Date(now).getTime() - new Date(time).getTime();
    var secondDiff = Math.floor(timeDiff / second);
    var minuteDiff = Math.floor(timeDiff / minute);
    var hourDiff = Math.floor(timeDiff / hour);
    var pretty = '';
    var weekDayDiff = new Date(now).getDay() - new Date(time).getDay();
    if (timeDiff <= day && weekDayDiff == 0) {
      if (timeDiff < minute) {
        pretty = BabelStr.str(315); //'刚刚';
      } else if (timeDiff < hour) {
        pretty = BabelStr.str(316, {
          'num': minuteDiff
        }); // minuteDiff + '分钟前';
      } else {
        pretty = BabelStr.str(317, {
          'num': hourDiff
        }); //  hourDiff + '小时前';
      }
    } else {
      var timeRelativeDiff = timeDiff - hoursNow * hour - minutesNow * minute - secondsNow * second;
      var dayDiff = Math.floor(timeRelativeDiff / day);
      if (timeRelativeDiff <= day) {
        var t = BabelStr.str(319); //'昨天 '
        pretty = t + ' ' + new Date(time).format('HH:mm');
      } else if (timeRelativeDiff <= 2 * day) {
        var t = BabelStr.str(320); //'前天 '
        pretty = t + ' ' + new Date(time).format('HH:mm');
      } else if (timeRelativeDiff <= 7 * day) {
        pretty = BabelStr.str(318, {
          'num': dayDiff
        }); //dayDiff + '天前';
      } else {
        pretty = new Date(time).format('yyyy-MM-dd HH:mm');
      }
    }
    return pretty;
  },
  prettyShortDate: function prettyShortDate(now, time) {
    var second = 1000;
    var minute = second * 60;
    var hour = minute * 60;
    var day = hour * 24;
    var week = day * 7;
    var hoursNow = new Date(now).getHours();
    var minutesNow = new Date(now).getMinutes();
    var secondsNow = new Date(now).getSeconds();
    var timeDiff = new Date(now).getTime() - new Date(time).getTime();
    var secondDiff = Math.floor(timeDiff / second);
    var minuteDiff = Math.floor(timeDiff / minute);
    var hourDiff = Math.floor(timeDiff / hour);
    var pretty = '';
    var weekDayDiff = new Date(now).getDay() - new Date(time).getDay();
    if (timeDiff <= day && weekDayDiff == 0) {
      if (timeDiff < minute) {
        pretty = BabelStr.str(315); //'刚刚';
      } else if (timeDiff < hour) {
        pretty = BabelStr.str(316, {
          'num': minuteDiff
        }); // minuteDiff + '分钟前';
      } else {
        pretty = BabelStr.str(317, {
          'num': hourDiff
        }); //  hourDiff + '小时前';
      }
    } else {
      var timeRelativeDiff = timeDiff - hoursNow * hour - minutesNow * minute - secondsNow * second;
      var dayDiff = Math.floor(timeRelativeDiff / day);
      if (timeRelativeDiff <= day) {
        var t = BabelStr.str(319); //'昨天 '
        pretty = t + ' ' + new Date(time).format('HH:mm');
        // } else if (timeRelativeDiff <= (2 * day)) {
        //   var t = BabelStr.str(320);    //'前天 '
        //   pretty = t + ' ' + new Date(time).format('HH:mm');
      } else if (timeRelativeDiff <= 7 * day) {
        pretty = BabelStr.str(318, {
          'num': dayDiff
        }); //dayDiff + '天前';
      } else {
        pretty = new Date(time).format('yy-MM-dd HH:mm');
      }
    }
    return pretty;
  },
  prettyNewDate: function prettyNewDate(now, time) {
    var second = 1000;
    var minute = second * 60;
    var hour = minute * 60;
    var day = hour * 24;
    var week = day * 7;
    var month = day * 30;
    var year = day * 365;
    var maxdate = 5 * year;
    var timeDiff = new Date(now).getTime() - new Date(time).getTime();
    var pretty = '';
    if (timeDiff < week) {
      pretty = this.prettyDate(now, time);
    } else if (timeDiff < month) {
      var week = Math.floor(timeDiff / week);
      pretty = BabelStr.str(321, {
        'num': week
      }); // "xx 周前";
    } else if (timeDiff < year) {
      var month = Math.floor(timeDiff / month);
      pretty = BabelStr.str(322, {
        'num': month
      }); // "xx个月前";
    } else if (timeDiff < year * 5) {
      var year = Math.floor(timeDiff / year);
      pretty = BabelStr.str(323, {
        'num': year
      }); //  "xx年前";
    } else {
      pretty = BabelStr.str(324);
    }
    return pretty;
  },
  convertSpace: function convertSpace(num) {
    var kb = 1024;
    var mb = kb * 1024;
    var gb = mb * 1024;
    var tb = gb * 1024;
    if (num === 0) {
      return '0';
    } else if (num < mb) {
      return Number(num / kb).toFixed(2) + 'KB';
    } else if (num < gb) {
      return Number(num / mb).toFixed(2) + 'MB';
    } else if (num < tb) {
      return Number(num / gb).toFixed(2) + 'GB';
    } else {
      return Number(num / tb).toFixed(2) + 'TB';
    }
    return '0';
  },
  formatTime: function formatTime(appTime, format) {
    format = format ? format : 'yyyy-MM-dd hh:mm:ss';
    return new Date(appTime * 1000).format(format);
  },
  inherits: function inherits(childCtor, parentCtor) {
    /** @constructor */
    function tempCtor() {}
    tempCtor.prototype = parentCtor.prototype;
    childCtor.superClass_ = parentCtor.prototype;
    childCtor.prototype = new tempCtor();
    /** @override */
    childCtor.prototype.constructor = childCtor;

    /**
     * Calls superclass constructor/method.
     *
     * This function is only available if you use goog.inherits to
     * express inheritance relationships between classes.
     *
     * NOTE: This is a replacement for goog.base and for superClass_
     * property defined in childCtor.
     *
     * @param {!Object} me Should always be "this".
     * @param {string} methodName The method name to call. Calling
     *     superclass constructor can be done with the special string
     *     'constructor'.
     * @param {...*} var_args The arguments to pass to superclass
     *     method/constructor.
     * @return {*} The return value of the superclass method/constructor.
     */
    childCtor.base = function (me, methodName, var_args) {
      // Copying using loop to avoid deop due to passing arguments object to
      // function. This is faster in many JS engines as of late 2014.
      var args = new Array(arguments.length - 2);
      for (var i = 2; i < arguments.length; i++) {
        args[i - 2] = arguments[i];
      }
      return parentCtor.prototype[methodName].apply(me, args);
    };
  },
  scrollBarWidth: function scrollbarSize() {
    var $wrapper = $("<div>").css({
      width: 50,
      height: 50,
      overflowY: "scroll",
      position: "absolute",
      top: -10000
    });
    var $inner = $("<div>").css({
      width: "100%",
      height: "100%"
    });
    $wrapper.append($inner).appendTo("body");
    var w1 = $wrapper.innerWidth();
    var w2 = $inner.innerWidth();
    $wrapper.remove();
    return w1 - w2;
  }(),
  hasScrollBar: function hasScrollBar(el, horizonal) {
    if (horizonal) {
      return el.offsetHeight > el.clientHeight;
    } else {
      return el.offsetWidth > el.clientWidth;
    }
  },
  queryStringToObject: function queryStringToObject(queryString) {
    var result = {};
    var k = "";
    var v = "";
    var tmp = null;
    queryString = queryString.indexOf('?') > -1 ? queryString.substring(1) : queryString;
    var pairs = queryString.split("&");
    _.each(pairs, function (pair, index) {
      // queryString = "" || "a=c&"
      if (!pair) {
        return true;
      }
      pair = pair.split("=");
      k = pair[0];
      v = decodeURIComponent(pair[1] || "");
      if (result[k]) {
        // queryString = "" || "a=c&a=b"
        if (!_.isArray(result[k])) {
          tmp = result[k];
          result[k] = [];
          result[k].push(tmp);
          result[k].push(v);
        } else {
          result[k].push(v);
        }
      } else {
        result[k] = v;
      }
    });
    return result;
  },
  getAvatarImageURL: function getAvatarImageURL(userId, size, notForce) {
    size = size ? size : 80;
    var t = new Date().getTime();
    if (notForce) {
      t = Math.floor(new Date().getTime() / 36000000); // 1 小时内不刷新
    }
    ;
    if (userId == -1) {
      return 'img/avatar/anonymous.jpg';
    }
    return "/user/getUserAvatar.do?userId=" + userId + "&t=" + t + "&size=" + size;
  },
  formValue: function formValue(form) {
    var params = $(form).serializeArray();
    var res = {};
    $.each(params, function (index, field) {
      res[field.name] = $.trim(field.value);
    });
    return res;
  },
  isDayBeyond: function isDayBeyond(date, beyondDate) {
    var y = date.getFullYear();
    var beyondY = beyondDate.getFullYear();
    var m = date.getMonth();
    var beyondM = beyondDate.getMonth();
    var d = date.getDay();
    var beyondD = beyondDate.getDay();
    var beyond = y > beyondY || y == beyondY && m > beyondM || y == beyondY && m == beyondM && d > beyondD;
    console.error(" ----- beyond:", beyond, "---- y: ", y, ', beyondY:', beyondY, ' m: ', m, ", beyondM:", beyondM, ", d:", d, ", beyondD:", beyondD);
    return beyond;
  },
  decryptBySes: function decryptBySes(message) {
    var sessionId = g_sessionId;
    var key = sessionId[0];
    var index = 0;
    var step = 0;
    while (step < 7) {
      step++;
      index += step;
      key += sessionId[index];
    }
    return MMCommonFun.decryptDesCbc(message, key);
  },
  chunkSize: 1024 * 1024 + 8,
  maximumEncryptionThreshold: 1024 * 1024 * 30 + 8,
  decryptDesECBArryBuffer: function decryptDesECBArryBuffer(fullFileData, key) {
    if (fullFileData.byteLength >= this.maximumEncryptionThreshold) {
      console.log('部分加密');
      return this.decryptDesECBArryBufferPart(fullFileData, key);
    } else {
      console.log('全部加密');
      return this.decryptDesECBArryBufferFull(fullFileData, key);
    }
  },
  decryptFirstChunk: function decryptFirstChunk(fullFileData, key) {
    return this.decryptDesECBArryBufferPart(fullFileData, key);
  },
  decryptDesECBArryBufferFull: function decryptDesECBArryBufferFull(fullFileData, key) {
    var encryptedChunk = fullFileData;
    key = this.decryptBySes(key);
    var keyHex = _cryptoJs["default"].enc.Utf8.parse(key);
    var ciphertext = _cryptoJs["default"].lib.WordArray.create(encryptedChunk);

    // 注意：CryptoJS 实际上并没有一个名为 createDecryptor 的方法
    // 我们应该直接使用 CryptoJS.DES.decrypt 方法
    var decrypted = _cryptoJs["default"].DES.decrypt({
      ciphertext: ciphertext
    }, keyHex, {
      mode: _cryptoJs["default"].mode.ECB,
      padding: _cryptoJs["default"].pad.Pkcs7
    });
    var arrayBuffer = this.CryptJsWordArrayToUint8Array(decrypted);
    return arrayBuffer.buffer;
  },
  decryptDesECBArryBufferPart: function decryptDesECBArryBufferPart(fullFileData, key) {
    var encryptedChunk = fullFileData.slice(0, this.chunkSize);
    var remainingData = fullFileData.slice(this.chunkSize);
    key = this.decryptBySes(key);
    var keyHex = _cryptoJs["default"].enc.Utf8.parse(key);
    var ciphertext = _cryptoJs["default"].lib.WordArray.create(encryptedChunk);

    // 注意：CryptoJS 实际上并没有一个名为 createDecryptor 的方法
    // 我们应该直接使用 CryptoJS.DES.decrypt 方法
    var decrypted = _cryptoJs["default"].DES.decrypt({
      ciphertext: ciphertext
    }, keyHex, {
      mode: _cryptoJs["default"].mode.ECB,
      padding: _cryptoJs["default"].pad.Pkcs7
    });
    var arrayBuffer = this.CryptJsWordArrayToUint8Array(decrypted);
    // return arrayBuffer.buffer
    var newBuffer = this.concatenateArrayBuffers(arrayBuffer, remainingData);
    return newBuffer;
    decrypted.toString(_cryptoJs["default"].enc.Utf8);
  },
  concatenateArrayBuffers: function concatenateArrayBuffers(ut8Array, buffer2) {
    // 创建两个 Uint8Array 视图来访问 ArrayBuffer
    var uint8Array1 = ut8Array;
    var uint8Array2 = new Uint8Array(buffer2);

    // 创建一个新的 ArrayBuffer，其大小为两个 ArrayBuffer 之和
    var combinedArrayBuffer = new ArrayBuffer(uint8Array1.length + uint8Array2.length);

    // 创建一个 Uint8Array 视图来访问新的 ArrayBuffer，并复制数据
    var combinedUint8Array = new Uint8Array(combinedArrayBuffer);

    // 复制第一个 ArrayBuffer 的数据
    combinedUint8Array.set(uint8Array1);

    // 在新 ArrayBuffer 的末尾复制第二个 ArrayBuffer 的数据
    combinedUint8Array.set(uint8Array2, uint8Array1.length);

    // 返回新的 ArrayBuffer
    return combinedArrayBuffer;
  },
  CryptJsWordArrayToUint8Array: function CryptJsWordArrayToUint8Array(wordArray) {
    var l = wordArray.sigBytes;
    var words = wordArray.words;
    var result = new Uint8Array(l);
    var i = 0 /*dst*/,
      j = 0 /*src*/;
    while (true) {
      // here i is a multiple of 4
      if (i == l) break;
      var w = words[j++];
      result[i++] = (w & 0xff000000) >>> 24;
      if (i == l) break;
      result[i++] = (w & 0x00ff0000) >>> 16;
      if (i == l) break;
      result[i++] = (w & 0x0000ff00) >>> 8;
      if (i == l) break;
      result[i++] = w & 0x000000ff;
    }
    return result;
  },
  /**
   * 创建去重版本的请求函数
   * @param {Function} originalFn - 原始请求函数（必须返回 Promise）
   * @param {Object} [options] - 配置项
   * @param {number} [options.cacheTTL=0] - 缓存存活时间（ms），0 表示永久缓存
   * @returns {Function} - 去重版本的请求函数
   */
  createDeduplicatedRequest: function createDeduplicatedRequest(originalFn) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (typeof originalFn !== 'function') {
      throw new TypeError('originalFn must be a function');
    }
    var _options$cacheTTL = options.cacheTTL,
      cacheTTL = _options$cacheTTL === void 0 ? 1000 : _options$cacheTTL;
    var pendingRequests = new Map(); // 存储正在进行的请求：key -> Promise
    var lastResults = new Map(); // 存储成功结果：key -> { result, timestamp }

    // 生成唯一的缓存 key（函数引用 + 参数序列化）
    var getCacheKey = function getCacheKey(args) {
      try {
        // 使用函数自身引用（避免同名函数冲突） + 参数序列化
        // 注意：originalFn 是对象，作为 key 的一部分会调用其 toString，但为了可读性，我们将其与参数组合
        // 更保险的做法是使用 WeakMap 为每个 originalFn 分配唯一 ID，但这里简单组合已够用
        var fnKey = originalFn.name || originalFn.toString().slice(0, 50);
        var argsKey = JSON.stringify(args);
        return "".concat(fnKey, "_").concat(argsKey);
      } catch (e) {
        // 如果参数无法序列化（如循环引用），使用参数的字符串表示
        console.warn('Failed to serialize arguments, using fallback key', e);
        return "".concat(originalFn.name || 'anonymous', "_").concat(Array.from(args).join('|'));
      }
    };
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var cacheKey = getCacheKey(args);

      // 1. 检查是否有正在进行的相同请求（去重核心）
      if (pendingRequests.has(cacheKey)) {
        return pendingRequests.get(cacheKey);
      }

      // 2. 检查缓存结果是否有效
      var cached = lastResults.get(cacheKey);
      if (cached && (cacheTTL <= 0 || Date.now() - cached.timestamp < cacheTTL)) {
        return Promise.resolve(cached.result);
      }

      // 3. 发起新请求
      var promise = originalFn.apply(void 0, args).then(function (result) {
        // 请求成功：存入缓存（更新时间戳）
        lastResults.set(cacheKey, {
          result: result,
          timestamp: Date.now()
        });
        return result;
      })["catch"](function (error) {
        // 请求失败：清理缓存（避免永久缓存错误）
        lastResults["delete"](cacheKey);
        throw error;
      })["finally"](function () {
        // 无论成功或失败，都清理 pending 记录，使后续相同参数可以重新发起
        pendingRequests["delete"](cacheKey);
      });

      // 存入 pending 记录，后续相同参数的调用会直接等待这个 Promise
      pendingRequests.set(cacheKey, promise);
      return promise;
    };
  }
};

},{"1150":1150,"1184":1184,"1410":1410,"1411":1411,"1412":1412,"1419":1419,"1421":1421,"1423":1423,"1424":1424,"1429":1429,"1435":1435,"1437":1437,"1439":1439,"1443":1443,"1446":1446,"1450":1450,"1454":1454,"1463":1463,"1470":1470,"1471":1471,"1478":1478,"1487":1487,"1498":1498,"1505":1505,"1506":1506,"1507":1507,"1508":1508,"1509":1509,"1510":1510,"1512":1512,"1513":1513,"1514":1514,"1516":1516,"1517":1517,"1518":1518,"1519":1519,"1520":1520,"1521":1521,"1522":1522,"1523":1523,"1524":1524,"1525":1525,"1526":1526,"1527":1527,"1528":1528,"1529":1529,"1530":1530,"1538":1538,"99":99,"crypto-js":"crypto-js"}],"crypto-js":[function(require,module,exports){
"use strict";

module.exports = window.CryptoJS;
if (window.CryptoJS) module.exports["default"] = window.CryptoJS;

},{}],1538:[function(require,module,exports){
var global = require(1287);
var DOMIterables = require(1255);
var DOMTokenListPrototype = require(1256);
var ArrayIteratorMethods = require(1423);
var createNonEnumerableProperty = require(1243);
var wellKnownSymbol = require(1408);

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

},{"1243":1243,"1255":1255,"1256":1256,"1287":1287,"1408":1408,"1423":1423}],1487:[function(require,module,exports){
'use strict';
var charAt = require(1369).charAt;
var toString = require(1393);
var InternalStateModule = require(1298);
var defineIterator = require(1314);
var createIterResultObject = require(1242);

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject(undefined, true);
  point = charAt(string, index);
  state.index += point.length;
  return createIterResultObject(point, false);
});

},{"1242":1242,"1298":1298,"1314":1314,"1369":1369,"1393":1393}],1470:[function(require,module,exports){
'use strict';
var $ = require(1270);
var IS_PURE = require(1308);
var NativePromiseConstructor = require(1347);
var fails = require(1271);
var getBuiltIn = require(1282);
var isCallable = require(1302);
var speciesConstructor = require(1367);
var promiseResolve = require(1348);
var defineBuiltIn = require(1247);

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!NativePromiseConstructor && fails(function () {
  // eslint-disable-next-line unicorn/no-thenable -- required for testing
  NativePromisePrototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = isCallable(onFinally);
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['finally'];
  if (NativePromisePrototype['finally'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'finally', method, { unsafe: true });
  }
}

},{"1247":1247,"1270":1270,"1271":1271,"1282":1282,"1302":1302,"1308":1308,"1347":1347,"1348":1348,"1367":1367}],1450:[function(require,module,exports){
'use strict';
var $ = require(1270);
var uncurryThis = require(1281);
var toIntegerOrInfinity = require(1385);
var thisNumberValue = require(1380);
var $repeat = require(1373);
var fails = require(1271);

var $RangeError = RangeError;
var $String = String;
var floor = Math.floor;
var repeat = uncurryThis($repeat);
var stringSlice = uncurryThis(''.slice);
var nativeToFixed = uncurryThis(1.0.toFixed);

var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};

var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

var multiply = function (data, n, c) {
  var index = -1;
  var c2 = c;
  while (++index < 6) {
    c2 += n * data[index];
    data[index] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};

var divide = function (data, n) {
  var index = 6;
  var c = 0;
  while (--index >= 0) {
    c += data[index];
    data[index] = floor(c / n);
    c = (c % n) * 1e7;
  }
};

var dataToString = function (data) {
  var index = 6;
  var s = '';
  while (--index >= 0) {
    if (s !== '' || index === 0 || data[index] !== 0) {
      var t = $String(data[index]);
      s = s === '' ? t : s + repeat('0', 7 - t.length) + t;
    }
  } return s;
};

var FORCED = fails(function () {
  return nativeToFixed(0.00008, 3) !== '0.000' ||
    nativeToFixed(0.9, 0) !== '1' ||
    nativeToFixed(1.255, 2) !== '1.25' ||
    nativeToFixed(1000000000000000128.0, 0) !== '1000000000000000128';
}) || !fails(function () {
  // V8 ~ Android 4.3-
  nativeToFixed({});
});

// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
$({ target: 'Number', proto: true, forced: FORCED }, {
  toFixed: function toFixed(fractionDigits) {
    var number = thisNumberValue(this);
    var fractDigits = toIntegerOrInfinity(fractionDigits);
    var data = [0, 0, 0, 0, 0, 0];
    var sign = '';
    var result = '0';
    var e, z, j, k;

    // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
    if (fractDigits < 0 || fractDigits > 20) throw $RangeError('Incorrect fraction digits');
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number != number) return 'NaN';
    if (number <= -1e21 || number >= 1e21) return $String(number);
    if (number < 0) {
      sign = '-';
      number = -number;
    }
    if (number > 1e-21) {
      e = log(number * pow(2, 69, 1)) - 69;
      z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(data, 0, z);
        j = fractDigits;
        while (j >= 7) {
          multiply(data, 1e7, 0);
          j -= 7;
        }
        multiply(data, pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(data, 1 << 23);
          j -= 23;
        }
        divide(data, 1 << j);
        multiply(data, 1, 1);
        divide(data, 2);
        result = dataToString(data);
      } else {
        multiply(data, 0, z);
        multiply(data, 1 << -e, 0);
        result = dataToString(data) + repeat('0', fractDigits);
      }
    }
    if (fractDigits > 0) {
      k = result.length;
      result = sign + (k <= fractDigits
        ? '0.' + repeat('0', fractDigits - k) + result
        : stringSlice(result, 0, k - fractDigits) + '.' + stringSlice(result, k - fractDigits));
    } else {
      result = sign + result;
    } return result;
  }
});

},{"1270":1270,"1271":1271,"1281":1281,"1373":1373,"1380":1380,"1385":1385}],1373:[function(require,module,exports){
'use strict';
var toIntegerOrInfinity = require(1385);
var toString = require(1393);
var requireObjectCoercible = require(1359);

var $RangeError = RangeError;

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
module.exports = function repeat(count) {
  var str = toString(requireObjectCoercible(this));
  var result = '';
  var n = toIntegerOrInfinity(count);
  if (n < 0 || n == Infinity) throw $RangeError('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};

},{"1359":1359,"1385":1385,"1393":1393}],1443:[function(require,module,exports){
// TODO: Remove this module from `core-js@4` since it's replaced to module below
require(1442);

},{"1442":1442}],1442:[function(require,module,exports){
'use strict';
var collection = require(1237);
var collectionStrong = require(1235);

// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
collection('Map', function (init) {
  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);

},{"1235":1235,"1237":1237}],1237:[function(require,module,exports){
'use strict';
var $ = require(1270);
var global = require(1287);
var uncurryThis = require(1281);
var isForced = require(1304);
var defineBuiltIn = require(1247);
var InternalMetadataModule = require(1297);
var iterate = require(1311);
var anInstance = require(1208);
var isCallable = require(1302);
var isNullOrUndefined = require(1306);
var isObject = require(1307);
var fails = require(1271);
var checkCorrectnessOfIteration = require(1232);
var setToStringTag = require(1363);
var inheritIfRequired = require(1295);

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var uncurriedNativeMethod = uncurryThis(NativePrototype[KEY]);
    defineBuiltIn(NativePrototype, KEY,
      KEY == 'add' ? function add(value) {
        uncurriedNativeMethod(this, value === 0 ? 0 : value);
        return this;
      } : KEY == 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY == 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY == 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  var REPLACE = isForced(
    CONSTRUCTOR_NAME,
    !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
      new NativeConstructor().entries().next();
    }))
  );

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.enable();
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, NativePrototype);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, constructor: true, forced: Constructor != NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};

},{"1208":1208,"1232":1232,"1247":1247,"1270":1270,"1271":1271,"1281":1281,"1287":1287,"1295":1295,"1297":1297,"1302":1302,"1304":1304,"1306":1306,"1307":1307,"1311":1311,"1363":1363}],1235:[function(require,module,exports){
'use strict';
var defineProperty = require(1328).f;
var create = require(1326);
var defineBuiltIns = require(1248);
var bind = require(1275);
var anInstance = require(1208);
var isNullOrUndefined = require(1306);
var iterate = require(1311);
var defineIterator = require(1314);
var createIterResultObject = require(1242);
var setSpecies = require(1362);
var DESCRIPTORS = require(1251);
var fastKey = require(1297).fastKey;
var InternalStateModule = require(1298);

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor = wrapper(function (that, iterable) {
      anInstance(that, Prototype);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        index: create(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!DESCRIPTORS) that.size = 0;
      if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var Prototype = Constructor.prototype;

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (DESCRIPTORS) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key == key) return entry;
      }
    };

    defineBuiltIns(Prototype, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }
        state.first = state.last = undefined;
        if (DESCRIPTORS) state.size = 0;
        else that.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first == entry) state.first = next;
          if (state.last == entry) state.last = prev;
          if (DESCRIPTORS) state.size--;
          else that.size--;
        } return !!entry;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    defineBuiltIns(Prototype, IS_MAP ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS) defineProperty(Prototype, 'size', {
      get: function () {
        return getInternalState(this).size;
      }
    });
    return Constructor;
  },
  setStrong: function (Constructor, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
    // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
    // https://tc39.es/ecma262/#sec-map.prototype.entries
    // https://tc39.es/ecma262/#sec-map.prototype.keys
    // https://tc39.es/ecma262/#sec-map.prototype.values
    // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
    // https://tc39.es/ecma262/#sec-set.prototype.entries
    // https://tc39.es/ecma262/#sec-set.prototype.keys
    // https://tc39.es/ecma262/#sec-set.prototype.values
    // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
    defineIterator(Constructor, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return createIterResultObject(undefined, true);
      }
      // return step by kind
      if (kind == 'keys') return createIterResultObject(entry.key, false);
      if (kind == 'values') return createIterResultObject(entry.value, false);
      return createIterResultObject([entry.key, entry.value], false);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // `{ Map, Set }.prototype[@@species]` accessors
    // https://tc39.es/ecma262/#sec-get-map-@@species
    // https://tc39.es/ecma262/#sec-get-set-@@species
    setSpecies(CONSTRUCTOR_NAME);
  }
};

},{"1208":1208,"1242":1242,"1248":1248,"1251":1251,"1275":1275,"1297":1297,"1298":1298,"1306":1306,"1311":1311,"1314":1314,"1326":1326,"1328":1328,"1362":1362}],1297:[function(require,module,exports){
var $ = require(1270);
var uncurryThis = require(1281);
var hiddenKeys = require(1289);
var isObject = require(1307);
var hasOwn = require(1288);
var defineProperty = require(1328).f;
var getOwnPropertyNamesModule = require(1331);
var getOwnPropertyNamesExternalModule = require(1330);
var isExtensible = require(1334);
var uid = require(1400);
var FREEZING = require(1273);

var REQUIRED = false;
var METADATA = uid('meta');
var id = 0;

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + id++, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!hasOwn(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!hasOwn(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && REQUIRED && isExtensible(it) && !hasOwn(it, METADATA)) setMetadata(it);
  return it;
};

var enable = function () {
  meta.enable = function () { /* empty */ };
  REQUIRED = true;
  var getOwnPropertyNames = getOwnPropertyNamesModule.f;
  var splice = uncurryThis([].splice);
  var test = {};
  test[METADATA] = 1;

  // prevent exposing of metadata key
  if (getOwnPropertyNames(test).length) {
    getOwnPropertyNamesModule.f = function (it) {
      var result = getOwnPropertyNames(it);
      for (var i = 0, length = result.length; i < length; i++) {
        if (result[i] === METADATA) {
          splice(result, i, 1);
          break;
        }
      } return result;
    };

    $({ target: 'Object', stat: true, forced: true }, {
      getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
    });
  }
};

var meta = module.exports = {
  enable: enable,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;

},{"1270":1270,"1273":1273,"1281":1281,"1288":1288,"1289":1289,"1307":1307,"1328":1328,"1330":1330,"1331":1331,"1334":1334,"1400":1400}],1334:[function(require,module,exports){
var fails = require(1271);
var isObject = require(1307);
var classof = require(1233);
var ARRAY_BUFFER_NON_EXTENSIBLE = require(1211);

// eslint-disable-next-line es/no-object-isextensible -- safe
var $isExtensible = Object.isExtensible;
var FAILS_ON_PRIMITIVES = fails(function () { $isExtensible(1); });

// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
module.exports = (FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE) ? function isExtensible(it) {
  if (!isObject(it)) return false;
  if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) == 'ArrayBuffer') return false;
  return $isExtensible ? $isExtensible(it) : true;
} : $isExtensible;

},{"1211":1211,"1233":1233,"1271":1271,"1307":1307}],1211:[function(require,module,exports){
// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
var fails = require(1271);

module.exports = fails(function () {
  if (typeof ArrayBuffer == 'function') {
    var buffer = new ArrayBuffer(8);
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
    if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', { value: 8 });
  }
});

},{"1271":1271}],1273:[function(require,module,exports){
var fails = require(1271);

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});

},{"1271":1271}],1439:[function(require,module,exports){
var DESCRIPTORS = require(1251);
var FUNCTION_NAME_EXISTS = require(1279).EXISTS;
var uncurryThis = require(1281);
var defineProperty = require(1328).f;

var FunctionPrototype = Function.prototype;
var functionToString = uncurryThis(FunctionPrototype.toString);
var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec = uncurryThis(nameRE.exec);
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return regExpExec(nameRE, functionToString(this))[1];
      } catch (error) {
        return '';
      }
    }
  });
}

},{"1251":1251,"1279":1279,"1281":1281,"1328":1328}],1435:[function(require,module,exports){
// TODO: Remove from `core-js@4`
var $ = require(1270);
var uncurryThis = require(1281);

var $Date = Date;
var thisTimeValue = uncurryThis($Date.prototype.getTime);

// `Date.now` method
// https://tc39.es/ecma262/#sec-date.now
$({ target: 'Date', stat: true }, {
  now: function now() {
    return thisTimeValue(new $Date());
  }
});

},{"1270":1270,"1281":1281}],1419:[function(require,module,exports){
var $ = require(1270);
var from = require(1218);
var checkCorrectnessOfIteration = require(1232);

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});

},{"1218":1218,"1232":1232,"1270":1270}],1218:[function(require,module,exports){
'use strict';
var bind = require(1275);
var call = require(1278);
var toObject = require(1387);
var callWithSafeIterationClosing = require(1231);
var isArrayIteratorMethod = require(1299);
var isConstructor = require(1303);
var lengthOfArrayLike = require(1317);
var createProperty = require(1245);
var getIterator = require(1284);
var getIteratorMethod = require(1283);

var $Array = Array;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this === $Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];
    for (;!(step = call(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = lengthOfArrayLike(O);
    result = IS_CONSTRUCTOR ? new this(length) : $Array(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};

},{"1231":1231,"1245":1245,"1275":1275,"1278":1278,"1283":1283,"1284":1284,"1299":1299,"1303":1303,"1317":1317,"1387":1387}],1231:[function(require,module,exports){
var anObject = require(1209);
var iteratorClose = require(1312);

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};

},{"1209":1209,"1312":1312}],99:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1477);
require(1492);
require(1476);
require(1478);
require(1437);
/**
 * 对Date的扩展，将 Date 转化为指定格式的String
 * 月(M)、日(d)、12小时(h)、24小时(H)、分(m)、秒(s)、周(E)、季度(q) 可以用 1-2 个占位符
 * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 * eg:
 * (new Date()).format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
 * (new Date()).format("yyyy-MM-dd E HH:mm:ss") ==> 2009-03-10 二 20:09:04
 * (new Date()).format("yyyy-MM-dd EE hh:mm:ss") ==> 2009-03-10 周二 08:09:04
 * (new Date()).format("yyyy-MM-dd EEE hh:mm:ss") ==> 2009-03-10 星期二 08:09:04
 * (new Date()).format("yyyy-M-d h:m:s.S") ==> 2006-7-2 8:9:4.18
 */
function format(fmt) {
  var o = {
    "M+": this.getMonth() + 1,
    //月份
    "d+": this.getDate(),
    //日
    "h+": this.getHours() % 12 == 0 ? 12 : this.getHours() % 12,
    //小时
    "H+": this.getHours(),
    //小时
    "m+": this.getMinutes(),
    //分
    "s+": this.getSeconds(),
    //秒
    "q+": Math.floor((this.getMonth() + 3) / 3),
    //季度
    "S": this.getMilliseconds() //毫秒
  };
  var week = {
    "0": "/u65e5",
    "1": "/u4e00",
    "2": "/u4e8c",
    "3": "/u4e09",
    "4": "/u56db",
    "5": "/u4e94",
    "6": "/u516d"
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length > 1 ? RegExp.$1.length > 2 ? "/u661f/u671f" : "/u5468" : "") + week[this.getDay() + ""]);
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }
  }
  return fmt;
}
Date.prototype.format = format;
var _default = exports["default"] = {
  format: function format(time, _format) {
    return new Date(time).format(_format);
  }
};

},{"1437":1437,"1454":1454,"1476":1476,"1477":1477,"1478":1478,"1492":1492}],1476:[function(require,module,exports){
var DESCRIPTORS = require(1251);
var global = require(1287);
var uncurryThis = require(1281);
var isForced = require(1304);
var inheritIfRequired = require(1295);
var createNonEnumerableProperty = require(1243);
var getOwnPropertyNames = require(1331).f;
var isPrototypeOf = require(1335);
var isRegExp = require(1309);
var toString = require(1393);
var getRegExpFlags = require(1355);
var stickyHelpers = require(1356);
var proxyAccessor = require(1350);
var defineBuiltIn = require(1247);
var fails = require(1271);
var hasOwn = require(1288);
var enforceInternalState = require(1298).enforce;
var setSpecies = require(1362);
var wellKnownSymbol = require(1408);
var UNSUPPORTED_DOT_ALL = require(1357);
var UNSUPPORTED_NCG = require(1358);

var MATCH = wellKnownSymbol('match');
var NativeRegExp = global.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
var SyntaxError = global.SyntaxError;
var exec = uncurryThis(RegExpPrototype.exec);
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);
// TODO: Use only proper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var MISSED_STICKY = stickyHelpers.MISSED_STICKY;
var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;

var BASE_FORCED = DESCRIPTORS &&
  (!CORRECT_NEW || MISSED_STICKY || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG || fails(function () {
    re2[MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
  }));

var handleDotAll = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;
  for (; index <= length; index++) {
    chr = charAt(string, index);
    if (chr === '\\') {
      result += chr + charAt(string, ++index);
      continue;
    }
    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      } result += chr;
    }
  } return result;
};

var handleNCG = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = {};
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;
  for (; index <= length; index++) {
    chr = charAt(string, index);
    if (chr === '\\') {
      chr = chr + charAt(string, ++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;
      case chr === '(':
        if (exec(IS_NCG, stringSlice(string, index + 1))) {
          index += 2;
          ncg = true;
        }
        result += chr;
        groupid++;
        continue;
      case chr === '>' && ncg:
        if (groupname === '' || hasOwn(names, groupname)) {
          throw new SyntaxError('Invalid capture group name');
        }
        names[groupname] = true;
        named[named.length] = [groupname, groupid];
        ncg = false;
        groupname = '';
        continue;
    }
    if (ncg) groupname += chr;
    else result += chr;
  } return [result, named];
};

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = isPrototypeOf(RegExpPrototype, this);
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || isPrototypeOf(RegExpPrototype, pattern)) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = getRegExpFlags(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString(pattern);
    flags = flags === undefined ? '' : toString(flags);
    rawPattern = pattern;

    if (UNSUPPORTED_DOT_ALL && 'dotAll' in re1) {
      dotAll = !!flags && stringIndexOf(flags, 's') > -1;
      if (dotAll) flags = replace(flags, /s/g, '');
    }

    rawFlags = flags;

    if (MISSED_STICKY && 'sticky' in re1) {
      sticky = !!flags && stringIndexOf(flags, 'y') > -1;
      if (sticky && UNSUPPORTED_Y) flags = replace(flags, /y/g, '');
    }

    if (UNSUPPORTED_NCG) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState(result);
      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }
      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) { /* empty */ }

    return result;
  };

  for (var keys = getOwnPropertyNames(NativeRegExp), index = 0; keys.length > index;) {
    proxyAccessor(RegExpWrapper, NativeRegExp, keys[index++]);
  }

  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  defineBuiltIn(global, 'RegExp', RegExpWrapper, { constructor: true });
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');

},{"1243":1243,"1247":1247,"1251":1251,"1271":1271,"1281":1281,"1287":1287,"1288":1288,"1295":1295,"1298":1298,"1304":1304,"1309":1309,"1331":1331,"1335":1335,"1350":1350,"1355":1355,"1356":1356,"1357":1357,"1358":1358,"1362":1362,"1393":1393,"1408":1408}],1350:[function(require,module,exports){
var defineProperty = require(1328).f;

module.exports = function (Target, Source, key) {
  key in Target || defineProperty(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};

},{"1328":1328}],1309:[function(require,module,exports){
var isObject = require(1307);
var classof = require(1233);
var wellKnownSymbol = require(1408);

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};

},{"1233":1233,"1307":1307,"1408":1408}],106:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1477);
/**
 * 一些常用的正则表达式
 * Created by manjun.han
 * 2017.1.1
 */

var regexp = {
  username: /^.{2,20}$/,
  password: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[a-zA-Z0-9].{6,20}$/,
  // /^\S{1,20}$/, // ^.*[A-Za-z0-9\\w_-]+.*

  login_email: /^([a-z0-9A-Z]+[-|\._]?)+[a-z0-9A-Z]@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\.)+[a-zA-Z]{2,}$/,
  email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})?$/,
  // phone: /^1[3456789]\d{9}$/,
  phone: /^\d+$/,
  allNumber: /^\d+$/,
  domain: /^[0-9a-zA-Z]*$/,
  textinput: /(<|:|\\|\/|\||>|\?|\"|\n|\r)/,
  isEmail: function isEmail(value) {
    return regexp.email.test(value);
  },
  isDomain: function isDomain(value) {
    return regexp.domain.test(value);
  },
  isLoginEmail: function isLoginEmail(value) {
    return regexp.login_email.test(value);
  },
  isPhone: function isPhone(value) {
    return regexp.phone.test(value);
  },
  validateTextinput: function validateTextinput(value) {
    return !regexp.textinput.test(value);
  },
  registerLoginEmail: function registerLoginEmail() {
    if (jQuery && jQuery.validator && !jQuery.validator.login_email) {
      jQuery.validator.addMethod("login_email", function (value, element) {
        return regexp.login_email.test(value);
      }, "".concat(BabelStr.str(7015), "(xx@xx.xx)"));
      jQuery.validator.addMethod("emailOrPhone", function (value, element) {
        return regexp.isLoginEmail(value) || regexp.isPhone(value);
      }, BabelStr.str(7016));
    }
  }
};
var _default = exports["default"] = regexp;

},{"1454":1454,"1477":1477}],249:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1446);
require(1463);
require(1471);
require(1426);
require(1478);
var _MMModelBase = _interopRequireDefault(require(21));
/**
 * Modified by manjun.han 适配cmd
 * 2016.12.5
 */

var MDEnterprise = _MMModelBase["default"].extend({
  defaults: {
    "id": null,
    "name": null,
    "shortName": null,
    "registerMail": null,
    "registerPhone": null,
    "administrator": null,
    "domain": null,
    "logoUrl": null,
    "datetime": null,
    'admin': {
      'id': null,
      'name': ''
    },
    "contactsName": '',
    'contactsPhone': '',
    'contactsMail': '',
    'sendMail': 0,
    //是否发送企业邮件

    'isAuth': null,
    //是否认证
    'ownerId': null,
    "usedSpace": 0,
    "basicCapacity": 0,
    //基础空间
    "upgradeCapacity": 0,
    //升级空间
    'endTime': -1,
    'isNeedShowEnableWatermarkButton': 0,
    'securityPolity': [],
    'isBindMac': '0',
    'onlyClientLoginWithMacBind': 0,
    // 'securityPolity': []
    'tagLimit': true,
    'canOwnPersonalFile': null,
    'isarchive': false,
    'rootDepartFolderId': '',
    'recycleTime': -1,
    'useFileManager': 0,
    'turnOnApi': 0,
    'entComponent': "31",
    // 'entAttr': '0',
    'dotmtxcli': 1
  },
  initialize: function initialize(opt) {
    _MMModelBase["default"].prototype.initialize.call(this, opt);
    console.log("MDEnterprise initialized");
  },
  getdotmtxcli: function getdotmtxcli() {
    return this.get('dotmtxcli') - 0;
  },
  getRelativeModelActions: function getRelativeModelActions() {
    return this.get('entComponent') == -1 ? 31 : this.get('entComponent') - 0;
  },
  getUseFileManager: function getUseFileManager() {
    return this.get('useFileManager') - 0;
  },
  setUseFileManager: function setUseFileManager(useFileManager) {
    return this.set('useFileManager', useFileManager);
  },
  setrootDepartFolderId: function setrootDepartFolderId(folderId) {
    this.set('rootDepartFolderId', folderId);
  },
  getRootDepartFolderId: function getRootDepartFolderId() {
    return this.get('rootDepartFolderId');
  },
  setMark: function setMark(flag) {
    flag = flag ? 1 : 0;
    this.set('mark', flag);
  },
  getMark: function getMark() {
    return this.get('mark');
  },
  setEntattr: function setEntattr(index, sign) {
    var result;
    if (sign) {
      result = this.getEntattr() | Math.pow(2, index);
    } else {
      if (this.getEntattr() & Math.pow(2, index)) {
        result = this.getEntattr() ^ Math.pow(2, index);
      } else {
        return;
      }
    }
    this.set('entAttr', result);
  },
  getEntattr: function getEntattr() {
    return this.get('entAttr') - 0;
  },
  isOpenPersonalShare: function isOpenPersonalShare() {
    return !(this.getEntattr() & 1); // 第一个权限位
  },
  isShareAnoymousClosed: function isShareAnoymousClosed() {
    return this.getEntattr() & 4; // 第2个权限位
  },
  isAnoymousClosed: function isAnoymousClosed() {
    return this.getEntattr() & 32; // 第5个权限位
  },
  isAllNotifyClosed: function isAllNotifyClosed() {
    return this.getEntattr() & 64; // 第6个权限位
  },
  isUseDefaultRoles: function isUseDefaultRoles() {
    return this.getEntattr() & 128; // 第7个权限位
  },
  isTwoWayBinding: function isTwoWayBinding() {
    return this.getEntattr() & 256; // 第8个权限位
  },
  isUseShortNameTitle: function isUseShortNameTitle() {
    // 0 表示打开
    return !(this.getEntattr() & 512); // 第9个权限位
  },
  noDownloadNoThumb: function noDownloadNoThumb() {
    // 1 表示打开
    return this.getEntattr() & 1024; // 第10个权限位
  },
  useStrictSearch: function useStrictSearch() {
    // 1 表示打开
    return this.getEntattr() & 4096; // 第12个权限位
  },
  isAutoUnlockClosed: function isAutoUnlockClosed() {
    return this.getEntattr() & Math.pow(2, 13); // 第13个权限位
  },
  isEnableBannedWordsFilter: function isEnableBannedWordsFilter() {
    // 1 表示关闭
    return this.getEntattr() & 16384; // 第14个权限位
  },
  isUserEditClosed: function isUserEditClosed() {
    return this.getEntattr() & Math.pow(2, 15); // 第15个权限位
  },
  isClosedViewVideo: function isClosedViewVideo() {
    return this.getEntattr() & Math.pow(2, 16); // 第16个权限位
  },
  isShareFileWatermarkCannotCustom: function isShareFileWatermarkCannotCustom() {
    return this.getEntattr() & Math.pow(2, 17); // 第17个权限位
  },
  isAllPageWatermark: function isAllPageWatermark() {
    return this.getEntattr() & Math.pow(2, 18); // 第18个权限位, 0仅预览模式有水印, 1所有页面均有水印
  },
  isHeadShowShortName: function isHeadShowShortName() {
    return true;
  },
  getToggleAnonymousClosedAttr: function getToggleAnonymousClosedAttr(sign) {
    var entAttr = this.getEntattr();
    if (!sign) {
      return entAttr ^ 4;
    } else {
      return entAttr | 4;
    }
  },
  isOnlyEpFolderOpened: function isOnlyEpFolderOpened() {
    return !(this.getEntattr() & 8); // 3  0显示1隐藏,默认0
  },
  getOnlyEpFolderOpenedAttr: function getOnlyEpFolderOpenedAttr(sign) {
    var entAttr = this.getEntattr();
    if (sign) {
      return entAttr ^ 8;
    } else {
      return entAttr | 8;
    }
  },
  isCloseLinkWhenStopUser: function isCloseLinkWhenStopUser() {
    return this.getEntattr() & 16; // 4  0正常1开启该模式,默认0
  },
  getCloseLinkWhenStopUseAttr: function getCloseLinkWhenStopUseAttr(sign) {
    var entAttr = this.getEntattr();
    if (!sign) {
      return entAttr ^ 16;
    } else {
      return entAttr | 16;
    }
  },
  canShowSecurityPolicyModel: function canShowSecurityPolicyModel() {
    return this.getRelativeModelActions() & 2;
  },
  canShowArchiveModel: function canShowArchiveModel() {
    return this.getRelativeModelActions() & 4;
  },
  canShowBroadcast: function canShowBroadcast() {
    return this.getRelativeModelActions() & 8;
  },
  canShowEvalModel: function canShowEvalModel() {
    return this.getRelativeModelActions() & 16;
  },
  getEpModelNameArr: function getEpModelNameArr() {
    var entComponent = this.get('entComponent');
    var out = [];
    if (entComponent == -1) {
      return [BabelStr.str(7034)];
    } else {
      if (entComponent & 1) {
        out.push(BabelStr.str(7035));
      }
      if (entComponent & 2) {
        out.push(BabelStr.str(3351));
      }
      if (entComponent & 4) {
        out.push(BabelStr.str(7036));
      }
      if (entComponent & 8) {
        out.push(BabelStr.str(7037));
      }
      if (entComponent & 16) {
        out.push(BabelStr.str(256));
      }
    }
    return out;
  },
  getTagLimit: function getTagLimit() {
    if (!app.isEpVersion()) {
      return false;
    }
    var tagLimit = this.get("tagLimit");
    if (_.isString(tagLimit)) {
      tagLimit = !!(tagLimit - 0);
    }
    return tagLimit;
  },
  setTagLimit: function setTagLimit(flag) {
    this.set("tagLimit", !!flag);
  },
  getIsBindMac: function getIsBindMac() {
    var sign = this.get("isBindMac");
    if (_.isString(sign)) {
      sign = !!(sign - 0);
    }
    return sign;
  },
  setIsBindMac: function setIsBindMac(isBindMac) {
    //boolean or number
    this.set("isBindMac", isBindMac);
  },
  getIsOnlyClientLoginWithMacBind: function getIsOnlyClientLoginWithMacBind() {
    var sign = this.get("onlyClientLoginWithMacBind");
    if (_.isString(sign)) {
      sign = !!(sign - 0);
    }
    return sign;
  },
  setIsOnlyClientLoginWithMacBind: function setIsOnlyClientLoginWithMacBind(onlyClientLoginWithMacBind) {
    //boolean or number
    this.set("onlyClientLoginWithMacBind", onlyClientLoginWithMacBind);
  },
  getIsNeedShowEnableWatermarkButton: function getIsNeedShowEnableWatermarkButton() {
    return this.get("isNeedShowEnableWatermarkButton");
  },
  getEpName: function getEpName() {
    return this.get('name');
  },
  getEpShortName: function getEpShortName() {
    return this.get('shortName');
  },
  getEpID: function getEpID() {
    return this.get('id');
  },
  getEpAdminID: function getEpAdminID() {
    return this.get('admin')['id'];
  },
  getUsedSpace: function getUsedSpace() {
    return this.get('usedSpace');
  },
  getBasicCapacity: function getBasicCapacity() {
    return this.get('basicCapacity');
  },
  getUpgradeCapacity: function getUpgradeCapacity() {
    return this.get('upgradeCapacity');
  },
  getLogoURL: function getLogoURL() {
    return '/user/getEnterpriseLogo.do?size=400&t=' + new Date().getTime();
  },
  isAuth: function isAuth() {
    var isAuth = this.get('isAuth');
    if (isAuth === 1) {
      return true;
    } else {
      return false;
    }
  },
  getSendMail: function getSendMail() {
    return this.get('sendMail') - 0;
  },
  getOwnerId: function getOwnerId() {
    return this.get('ownerId');
  },
  getEndTime: function getEndTime() {
    return Number(this.get('endTime'));
  },
  getEndTimeDate: function getEndTimeDate() {
    return new Date((this.get("endTime") - 0) * 1000);
  },
  getRegisterTimeDate: function getRegisterTimeDate() {
    return new Date((this.get("datetime") - 0) * 1000);
  },
  canExpirated: function canExpirated() {
    return this.getEndTime() > -1;
  },
  getExpirationDay: function getExpirationDay() {
    var endTime = Number(this.getEndTime()) * 1000;
    var today = new Date().getTime();
    var diff = (endTime - today) / (1000 * 60 * 60 * 24);
    return Math.ceil(diff);
  },
  isPrivateCloud: function isPrivateCloud() {
    return this.get("isPrivateCloud");
  },
  canEditPersonPwd: function canEditPersonPwd() {
    return this.isPrivateCloud();
  },
  getEpSecurityPolicy: function getEpSecurityPolicy(callback) {
    var _this = this;
    var securityPolity;
    var promise = new Promise(function (resolve, rejected) {
      if (_this.get("securityPolity").length > 0) {
        resolve(_this.get("securityPolity"));
      } else {
        MMEnterpriseController.getAllSecurityPolicy(function (list) {
          _this.set("securityPolity", list);
          console.log(list);
          resolve(list);
        }, function () {});
      }
    });
    promise.then(function (list) {
      callback(list);
    });
  },
  setEpSecurityPolicy: function setEpSecurityPolicy(securityPolity) {
    this.set("securityPolity", securityPolity);
  },
  canOwnPersonalFile: function canOwnPersonalFile() {
    return this.get('canOwnPersonalFile') == 1;
  },
  useGlobalShareFolder: function useGlobalShareFolder() {
    return this.get('useGlobalShareFolder');
  },
  setUseGlobalShareFolder: function setUseGlobalShareFolder(useGlobalShareFolder) {
    return this.set('useGlobalShareFolder', useGlobalShareFolder);
  },
  isArchive: function isArchive() {
    return this.get('isarchive');
  },
  setArchive: function setArchive(isarchive) {
    this.set('isarchive', isarchive);
  },
  isTurnOnApi: function isTurnOnApi() {
    return this.get('turnOnApi');
  },
  isSupportPdfUseOnlyEdit: function isSupportPdfUseOnlyEdit() {
    var targetVer = 9.2;
    var currentVer = this.get("onlyver") || "";
    var parseVersion = function parseVersion(ver) {
      var parts = ver.toString().split('.').map(Number);
      return {
        major: parts[0] || 0,
        minor: parts[1] || 0
      };
    };
    var current = parseVersion(currentVer);
    var target = parseVersion(targetVer);
    return current.major > target.major || current.major === target.major && current.minor > target.minor;
  }
});
var _default = exports["default"] = MDEnterprise;

},{"1184":1184,"1426":1426,"1437":1437,"1446":1446,"1454":1454,"1463":1463,"1471":1471,"1478":1478,"21":21}],1471:[function(require,module,exports){
// TODO: Remove this module from `core-js@4` since it's split to modules listed below
require(1469);
require(1467);
require(1468);
require(1472);
require(1473);
require(1474);

},{"1467":1467,"1468":1468,"1469":1469,"1472":1472,"1473":1473,"1474":1474}],1474:[function(require,module,exports){
'use strict';
var $ = require(1270);
var getBuiltIn = require(1282);
var IS_PURE = require(1308);
var NativePromiseConstructor = require(1347);
var FORCED_PROMISE_CONSTRUCTOR = require(1346).CONSTRUCTOR;
var promiseResolve = require(1348);

var PromiseConstructorWrapper = getBuiltIn('Promise');
var CHECK_WRAPPER = IS_PURE && !FORCED_PROMISE_CONSTRUCTOR;

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$({ target: 'Promise', stat: true, forced: IS_PURE || FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(CHECK_WRAPPER && this === PromiseConstructorWrapper ? NativePromiseConstructor : this, x);
  }
});

},{"1270":1270,"1282":1282,"1308":1308,"1346":1346,"1347":1347,"1348":1348}],1348:[function(require,module,exports){
var anObject = require(1209);
var isObject = require(1307);
var newPromiseCapability = require(1321);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

},{"1209":1209,"1307":1307,"1321":1321}],1473:[function(require,module,exports){
'use strict';
var $ = require(1270);
var call = require(1278);
var newPromiseCapabilityModule = require(1321);
var FORCED_PROMISE_CONSTRUCTOR = require(1346).CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    call(capability.reject, undefined, r);
    return capability.promise;
  }
});

},{"1270":1270,"1278":1278,"1321":1321,"1346":1346}],1472:[function(require,module,exports){
'use strict';
var $ = require(1270);
var call = require(1278);
var aCallable = require(1203);
var newPromiseCapabilityModule = require(1321);
var perform = require(1345);
var iterate = require(1311);
var PROMISE_STATICS_INCORRECT_ITERATION = require(1349);

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        call($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

},{"1203":1203,"1270":1270,"1278":1278,"1311":1311,"1321":1321,"1345":1345,"1349":1349}],1469:[function(require,module,exports){
'use strict';
var $ = require(1270);
var IS_PURE = require(1308);
var IS_NODE = require(1264);
var global = require(1287);
var call = require(1278);
var defineBuiltIn = require(1247);
var setPrototypeOf = require(1339);
var setToStringTag = require(1363);
var setSpecies = require(1362);
var aCallable = require(1203);
var isCallable = require(1302);
var isObject = require(1307);
var anInstance = require(1208);
var speciesConstructor = require(1367);
var task = require(1379).set;
var microtask = require(1320);
var hostReportErrors = require(1290);
var perform = require(1345);
var Queue = require(1351);
var InternalStateModule = require(1298);
var NativePromiseConstructor = require(1347);
var PromiseConstructorDetection = require(1346);
var newPromiseCapabilityModule = require(1321);

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var PromiseConstructor = NativePromiseConstructor;
var PromisePrototype = NativePromisePrototype;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;

var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && isCallable(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state == FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(TypeError('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call(then, value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable(executor);
    call(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process.domain : undefined;
    if (state.state == PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };

  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && isCallable(NativePromiseConstructor) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype, PromisePrototype);
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);

},{"1203":1203,"1208":1208,"1247":1247,"1264":1264,"1270":1270,"1278":1278,"1287":1287,"1290":1290,"1298":1298,"1302":1302,"1307":1307,"1308":1308,"1320":1320,"1321":1321,"1339":1339,"1345":1345,"1346":1346,"1347":1347,"1351":1351,"1362":1362,"1363":1363,"1367":1367,"1379":1379}],1351:[function(require,module,exports){
var Queue = function () {
  this.head = null;
  this.tail = null;
};

Queue.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    if (this.head) this.tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      this.head = entry.next;
      if (this.tail === entry) this.tail = null;
      return entry.item;
    }
  }
};

module.exports = Queue;

},{}],1320:[function(require,module,exports){
var global = require(1287);
var bind = require(1275);
var getOwnPropertyDescriptor = require(1329).f;
var macrotask = require(1379).set;
var IS_IOS = require(1263);
var IS_IOS_PEBBLE = require(1262);
var IS_WEBOS_WEBKIT = require(1265);
var IS_NODE = require(1264);

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var document = global.document;
var process = global.process;
var Promise = global.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise;
    then = bind(promise.then, promise);
    notify = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // strange IE + webpack dev server bug - use .bind(global)
    macrotask = bind(macrotask, global);
    notify = function () {
      macrotask(flush);
    };
  }
}

module.exports = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify();
  } last = task;
};

},{"1262":1262,"1263":1263,"1264":1264,"1265":1265,"1275":1275,"1287":1287,"1329":1329,"1379":1379}],1379:[function(require,module,exports){
var global = require(1287);
var apply = require(1274);
var bind = require(1275);
var isCallable = require(1302);
var hasOwn = require(1288);
var fails = require(1271);
var html = require(1291);
var arraySlice = require(1227);
var createElement = require(1253);
var validateArgumentsLength = require(1404);
var IS_IOS = require(1263);
var IS_NODE = require(1264);

var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var Dispatch = global.Dispatch;
var Function = global.Function;
var MessageChannel = global.MessageChannel;
var String = global.String;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

try {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = global.location;
} catch (error) { /* empty */ }

var run = function (id) {
  if (hasOwn(queue, id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global.postMessage(String(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable(handler) ? handler : Function(handler);
    var args = arraySlice(arguments, 1);
    queue[++counter] = function () {
      apply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global.addEventListener &&
    isCallable(global.postMessage) &&
    !global.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails(post)
  ) {
    defer = post;
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};

},{"1227":1227,"1253":1253,"1263":1263,"1264":1264,"1271":1271,"1274":1274,"1275":1275,"1287":1287,"1288":1288,"1291":1291,"1302":1302,"1404":1404}],1404:[function(require,module,exports){
var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw $TypeError('Not enough arguments');
  return passed;
};

},{}],1265:[function(require,module,exports){
var userAgent = require(1266);

module.exports = /web0s(?!.*chrome)/i.test(userAgent);

},{"1266":1266}],1263:[function(require,module,exports){
var userAgent = require(1266);

module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);

},{"1266":1266}],1262:[function(require,module,exports){
var userAgent = require(1266);
var global = require(1287);

module.exports = /ipad|iphone|ipod/i.test(userAgent) && global.Pebble !== undefined;

},{"1266":1266,"1287":1287}],1290:[function(require,module,exports){
var global = require(1287);

module.exports = function (a, b) {
  var console = global.console;
  if (console && console.error) {
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  }
};

},{"1287":1287}],1468:[function(require,module,exports){
'use strict';
var $ = require(1270);
var IS_PURE = require(1308);
var FORCED_PROMISE_CONSTRUCTOR = require(1346).CONSTRUCTOR;
var NativePromiseConstructor = require(1347);
var getBuiltIn = require(1282);
var isCallable = require(1302);
var defineBuiltIn = require(1247);

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}

},{"1247":1247,"1270":1270,"1282":1282,"1302":1302,"1308":1308,"1346":1346,"1347":1347}],1467:[function(require,module,exports){
'use strict';
var $ = require(1270);
var call = require(1278);
var aCallable = require(1203);
var newPromiseCapabilityModule = require(1321);
var perform = require(1345);
var iterate = require(1311);
var PROMISE_STATICS_INCORRECT_ITERATION = require(1349);

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

},{"1203":1203,"1270":1270,"1278":1278,"1311":1311,"1321":1321,"1345":1345,"1349":1349}],1349:[function(require,module,exports){
var NativePromiseConstructor = require(1347);
var checkCorrectnessOfIteration = require(1232);
var FORCED_PROMISE_CONSTRUCTOR = require(1346).CONSTRUCTOR;

module.exports = FORCED_PROMISE_CONSTRUCTOR || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor.all(iterable).then(undefined, function () { /* empty */ });
});

},{"1232":1232,"1346":1346,"1347":1347}],1346:[function(require,module,exports){
var global = require(1287);
var NativePromiseConstructor = require(1347);
var isCallable = require(1302);
var isForced = require(1304);
var inspectSource = require(1296);
var wellKnownSymbol = require(1408);
var IS_BROWSER = require(1258);
var IS_DENO = require(1260);
var IS_PURE = require(1308);
var V8_VERSION = require(1267);

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var SPECIES = wellKnownSymbol('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT = isCallable(global.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
  if (IS_PURE && !(NativePromisePrototype['catch'] && NativePromisePrototype['finally'])) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT;
});

module.exports = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT,
  SUBCLASSING: SUBCLASSING
};

},{"1258":1258,"1260":1260,"1267":1267,"1287":1287,"1296":1296,"1302":1302,"1304":1304,"1308":1308,"1347":1347,"1408":1408}],1347:[function(require,module,exports){
var global = require(1287);

module.exports = global.Promise;

},{"1287":1287}],1258:[function(require,module,exports){
var IS_DENO = require(1260);
var IS_NODE = require(1264);

module.exports = !IS_DENO && !IS_NODE
  && typeof window == 'object'
  && typeof document == 'object';

},{"1260":1260,"1264":1264}],1264:[function(require,module,exports){
var classof = require(1233);
var global = require(1287);

module.exports = classof(global.process) == 'process';

},{"1233":1233,"1287":1287}],1260:[function(require,module,exports){
/* global Deno -- Deno case */
module.exports = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';

},{}],1345:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

},{}],1321:[function(require,module,exports){
'use strict';
var aCallable = require(1203);

var $TypeError = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw $TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f = function (C) {
  return new PromiseCapability(C);
};

},{"1203":1203}],1311:[function(require,module,exports){
var bind = require(1275);
var call = require(1278);
var anObject = require(1209);
var tryToString = require(1394);
var isArrayIteratorMethod = require(1299);
var lengthOfArrayLike = require(1317);
var isPrototypeOf = require(1335);
var getIterator = require(1284);
var getIteratorMethod = require(1283);
var iteratorClose = require(1312);

var $TypeError = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw $TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};

},{"1209":1209,"1275":1275,"1278":1278,"1283":1283,"1284":1284,"1299":1299,"1312":1312,"1317":1317,"1335":1335,"1394":1394}],1312:[function(require,module,exports){
var call = require(1278);
var anObject = require(1209);
var getMethod = require(1285);

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};

},{"1209":1209,"1278":1278,"1285":1285}],21:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MMBackboneExtend = _interopRequireDefault(require(19));
/**
 * 基于Backbone.Model的全局Model基类，主要作用是二次封装一些工具方法，
 * 最主要的功能是定义与后台通信需要的方法和辅助方法
 *
 * Create by manjun.han
 * 2014.12.27
 *
 */

var MMModelBase = Backbone.Model.extend({});
(function () {
  _.each(_MMBackboneExtend["default"], function (value, key) {
    MMModelBase.prototype[key] = _MMBackboneExtend["default"][key];
  });
})();
window.MMModelBase = MMModelBase;
var _default = exports["default"] = MMModelBase;

},{"1184":1184,"1454":1454,"19":19}],110:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1477);
require(1489);
require(1492);
function detect(ua, platform) {
  var os = this.os = {},
    browser = this.browser = {},
    webkit = ua.match(/Web[kK]it[\/]{0,1}([\d.]+)/),
    android = ua.match(/(Android)\;?[\s\/]+([\d.]+)?/),
    osx = !!ua.match(/\(Macintosh\; Intel /),
    ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
    ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/),
    iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
    webos = ua.match(/(webOS|hpwOS)[\s\/]([\d.]+)/),
    win = /Win\d{2}|Windows/.test(platform),
    wp = ua.match(/Windows Phone ([\d.]+)/),
    touchpad = webos && ua.match(/TouchPad/),
    kindle = ua.match(/Kindle\/([\d.]+)/),
    silk = ua.match(/Silk\/([\d._]+)/),
    blackberry = ua.match(/(BlackBerry).*Version\/([\d.]+)/),
    bb10 = ua.match(/(BB10).*Version\/([\d.]+)/),
    rimtabletos = ua.match(/(RIM\sTablet\sOS)\s([\d.]+)/),
    playbook = ua.match(/PlayBook/),
    chrome = ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/),
    firefox = ua.match(/Firefox\/([\d.]+)/),
    firefoxos = ua.match(/\((?:Mobile|Tablet); rv:([\d.]+)\).*Firefox\/[\d.]+/),
    ie = ua.match(/MSIE\s([\d.]+)/) || ua.match(/Trident\/[\d](?=[^\?]+).*rv:([0-9.].)/),
    webview = !chrome && ua.match(/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/),
    safari = webview || ua.match(/Version\/([\d.]+)([^S](Safari)|[^M]*(Mobile)[^S]*(Safari))/);

  // Todo: clean this up with a better OS/browser seperation:
  // - discern (more) between multiple browsers on android
  // - decide if kindle fire in silk mode is android or not
  // - Firefox on Android doesn't specify the Android version
  // - possibly devide in os, device and browser hashes

  if (browser.webkit = !!webkit) browser.version = webkit[1];
  if (android) os.android = true, os.version = android[2];
  if (iphone && !ipod) os.ios = os.iphone = true, os.version = iphone[2].replace(/_/g, '.');
  if (ipad) os.ios = os.ipad = true, os.version = ipad[2].replace(/_/g, '.');
  if (ipod) os.ios = os.ipod = true, os.version = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
  if (wp) os.wp = true, os.version = wp[1];
  if (webos) os.webos = true, os.version = webos[2];
  if (touchpad) os.touchpad = true;
  if (blackberry) os.blackberry = true, os.version = blackberry[2];
  if (bb10) os.bb10 = true, os.version = bb10[2];
  if (rimtabletos) os.rimtabletos = true, os.version = rimtabletos[2];
  if (playbook) browser.playbook = true;
  if (kindle) os.kindle = true, os.version = kindle[1];
  if (silk) browser.silk = true, browser.version = silk[1];
  if (!silk && os.android && ua.match(/Kindle Fire/)) browser.silk = true;
  if (chrome) browser.chrome = true, browser.version = chrome[1];
  if (firefox) browser.firefox = true, browser.version = firefox[1];
  if (firefoxos) os.firefoxos = true, os.version = firefoxos[1];
  if (ie) browser.ie = true, browser.version = ie[1];
  if (safari && (osx || os.ios || win)) {
    browser.safari = true;
    if (!os.ios) browser.version = safari[1];
  }
  if (webview) browser.webview = true;
  os.tablet = !!(ipad || playbook || android && !ua.match(/Mobile/) || firefox && ua.match(/Tablet/) || ie && !ua.match(/Phone/) && ua.match(/Touch/));
  os.phone = !!(!os.tablet && !os.ipod && (android || iphone || webos || blackberry || bb10 || chrome && ua.match(/Android/) || chrome && ua.match(/CriOS\/([\d.]+)/) || firefox && ua.match(/Mobile/) || ie && ua.match(/Touch/)));
  os.desktop = !os.tablet && !os.phone;
  os.win = win;
  os.mac = osx;
}
var UA = {
  exportTo: function exportTo(namespace) {
    detect.call(namespace, navigator.userAgent, navigator.platform);
  }
};
UA.exportTo(UA);
var _default = exports["default"] = UA;

},{"1454":1454,"1477":1477,"1489":1489,"1492":1492}],59:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1438);
var _OnlineEvent = _interopRequireDefault(require(60));
/**
 * 浏览器离线在线状态监测的处理类
 *
 * @class
 * @see {@link http://stackoverflow.com/questions/3181080/how-to-detect-online-offline-event-cross-browser}
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/NavigatorOnLine/onLine#Specification}
 * @see {@link https://developer.mozilla.org/en-US/docs/Online_and_offline_events}
 * @see {@link http://caniuse.com/#search=online}
 */
var MDOnlineEventHandler = function MDOnlineEventHandler() {
  this.initialize();
};
_.extend(MDOnlineEventHandler.prototype, Backbone.Events, {
  /**
   * 初始化方法
   *
   * @return {void}
   */
  initialize: function initialize() {
    this._handleChange = this._handleChange.bind(this);
    window.addEventListener('online', this._handleChange);
    window.addEventListener('offline', this._handleChange);
  },
  /**
   * 判断当前浏览器的网络链接是否正常
   *
   * @return {Boolean} 浏览器是否在线
   */
  isOnline: function isOnline() {
    return window.navigator.onLine;
  },
  /**
   * 浏览器离线事件监听函数
   *
   * @private
   * @param  {Event} event
   * @return {void}
   */
  _handleChange: function _handleChange(event) {
    var isOnline = this.isOnline();
    var evt = isOnline ? _OnlineEvent["default"].OnLine : _OnlineEvent["default"].OffLine;
    this.trigger(_OnlineEvent["default"].OnlineStateChange, isOnline);
  },
  /**
   * 注销注册的离线事件
   *
   * @return {[void}
   */
  dispose: function dispose() {
    window.removeEventListener('online', this._handleChange);
    window.removeEventListener('offline', this._handleChange);
  }
});
var _default = exports["default"] = MDOnlineEventHandler;

},{"1184":1184,"1438":1438,"1454":1454,"60":60}],60:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * 在线离线事件类型
 *
 * @enum {String}
 */

var OnlineEvent = {
  OnlineStateChange: 'OnlineStateChange'
};
var _default = exports["default"] = OnlineEvent;

},{"1454":1454}],32:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
var _MDLocalString = _interopRequireDefault(require(1150));
var _MMViewBase = _interopRequireDefault(require(22));
var _MDFocusManager = _interopRequireDefault(require(44));
var _MMBasicData = _interopRequireDefault(require(811));
/**
 *  Alert view
 *  Create by manjun.han
 *  2015.9.7
 */

var defaults = {
  zIndex: 7 * 100000000,
  hideCloseBtn: false,
  width: 540,
  enableMove: true,
  enableMobileHook: false,
  animated: false,
  stopClickEvent: true
};
var MDAlertView = _MMViewBase["default"].extend({
  el: '<div class="m-alert" tabindex="1"></div>',
  tmpl: '<header>' + '<span class="title"></span>' + '<button class="icon closeBtn"></button>' + '</header>' + '<section></section>' + '<footer class="flex-align"></footer>',
  overlayerTmpl: '<div class="m-alert-overlayer"></div>',
  events: function events() {
    return {
      'click header .closeBtn': this._closeBtnClickHandler
    };
  },
  initProps: function initProps() {
    var superCls = _MMViewBase["default"].prototype.initProps.call(this);
    return _.extend(superCls, {
      zIndex: undefined,
      title: BabelStr.str(170),
      width: undefined,
      message: "",
      buttons: [],
      enableMove: undefined,
      onShow: null,
      onHide: null,
      top: 'auto',
      $layoutWrapper: null,
      hideCloseBtn: undefined,
      animated: undefined,
      enableMobileHook: undefined,
      stopClickEvent: undefined,
      _preDocumentActiveEl: null,
      messages: []
    });
  },
  initialize: function initialize(opt) {
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.setDefaults(defaults);
    this.$title = this.$(".title");
    this.$body = this.$("section");
    this.$footer = this.$("footer");
    this.$overlayer = $(this.overlayerTmpl);
    this.$closeBtn = this.$('>header .closeBtn');
    if (this.enableMove) {
      this._enableMove();
    }
    this._setCloseBtnHidden(this.hideCloseBtn);
    this._preDocumentActiveEl = document.activeElement;
  },
  _setCloseBtnHidden: function _setCloseBtnHidden(hidden) {
    hidden ? this.$closeBtn.hide() : this.$closeBtn.show();
  },
  _mobileHook: function _mobileHook() {
    var self = this;
    this._disableMove();
    this._centerLayout();
    $(window).on(this.$nsEventName('resize'), function () {
      self._centerLayout();
    });
  },
  _enableMove: function _enableMove() {
    this.bindSelf(this._headerMouseDown, this._docMouseMove, this._docMouseUp);
    this.$('>header').mousedown(this._headerMouseDown);
  },
  _disableMove: function _disableMove() {
    this.$('>header').off('mousedown');
  },
  _headerMouseDown: function _headerMouseDown($e) {
    this.$el.data('startX', $e.clientX);
    this.$el.data('startY', $e.clientY);
    $(document).on(this.$nsEventName('mousemove'), this._docMouseMove).on(this.$nsEventName('mouseup') + this.eventId, this._docMouseUp);
  },
  _docMouseMove: function _docMouseMove($e) {
    var curX = $e.clientX;
    var curY = $e.clientY;
    var deltaX = curX - this.$el.data('startX');
    var deltaY = curY - this.$el.data('startY');
    this.$el.data('startX', curX);
    this.$el.data('startY', curY);
    var curpos = this.$el.position();
    var left = curpos.left + deltaX;
    var top = curpos.top + deltaY;
    left = left < 0 ? 0 : left;
    top = top < 0 ? 0 : top;
    var winWidth = $(window).width();
    var winHeight = $(window).height();
    var width = this.$el.outerWidth();
    var height = this.$el.outerHeight();
    if (left + width > winWidth) {
      left = winWidth - width;
    }
    if (top + height > winHeight) {
      top = winHeight - height;
    }
    this.$el.css('left', left);
    this.$el.css('top', top);
    this.$('>header').css('cursor', 'move');
  },
  _docMouseUp: function _docMouseUp($e) {
    $(document).off(this.$nsEventName('mousemove'), this._docMouseMove).off(this.$nsEventName('mouseup'), this._docMouseUp);
    this.$('>header').css('cursor', 'default');
  },
  /**
   *
   * @param  {{
   *    className:'',         附加在alert上样式
   *    title:'',             标题
   *    message:'',           显示内容，可插入都没片段
   *    buttons:'',           array of button
   *    width:'',
   *    height:'',
   *    hidecloseBtn: false, 是否隐藏关闭按钮
   *    focused: undefined
   * }} opt
   */
  /*
   button : {
     type: "",
     label: "",
     onClick: _.noop,
     autoClose: true or false
      }
  */

  show: function show(opt) {
    opt = opt || {};
    _.extend(this, opt);
    var self = this;
    var winWidth = $(window).width();
    if (!winWidth) {
      console.error("\u5F39\u7A97\u5931\u8D25, \u5185\u5BB9\u4E3A\uFF1A ".concat(this.message));
      return;
    }
    var $parentDiv = $('body');
    if (opt.$parentDiv) {
      $parentDiv = opt.$parentDiv;
    }
    ;
    $parentDiv.append(this.$overlayer);
    this.$layoutWrapper = $("<div class='g-alert'>").appendTo($parentDiv);
    this.renderTo(this.$layoutWrapper);
    this.$el.focus();
    if (this.stopClickEvent) {
      this.$layoutWrapper.on('click', function () {
        return false;
      });
    }
    this._renderButtons(this.buttons);
    this._renderButtonDir(this.direction);
    this.$title.html(this.title);
    this.$body.html('<div>' + this.message + '</div>');
    this.messages.push(this.message);
    var temp = this.el.offsetWidth;
    temp = $(window)[0].offsetWidth;
    var winWidth = $(window).width();
    var bodywidth = $("body")[0].offsetWidth;
    console.log("winWidth: ".concat(winWidth));
    console.log("body: ".concat(bodywidth));
    this.width = this.width == -1 ? defaults.defaultWidth : this.width;
    if (winWidth && this.width > winWidth) {
      this.width = winWidth - 20;
    }
    this.$el.width(this.width);
    var height = this.height;
    var top;
    if (_.isNumber(this.top)) {
      top = this.top;
    } else {
      top = ($(window).height() - this.$el.outerHeight()) / 3;
    }
    top = top < 0 ? 0 : top;
    this.$el.css({
      left: ($(window).width() - this.width) / 2,
      top: top
    });
    this.enableMobileHook && this._mobileHook();
    if (this.animated) {
      this.$el.addClass('animated');
      this.$overlayer.addClass("animated");
      this.$el.animationEndOnce(function () {
        self.$el.removeClass('fadeInDown');
        self.$overlayer.removeClass("fadeIn");
        _.isFunction(self.onShow) && self.onShow();
      }).addClass("fadeInDown");
      this.$overlayer.addClass("fadeIn");
    } else {
      _.isFunction(this.onShow) && this.onShow();
    }
    var zIndex = this.zIndex + ++MDAlertView.curAlertCount;
    this.$layoutWrapper.css("z-index", zIndex);
    this.$overlayer.css("z-index", zIndex);
    this._setCloseBtnHidden(this.hideCloseBtn);
    _MDFocusManager["default"].setFocus(this);
  },
  _centerLayout: function _centerLayout() {
    var width = this.$el.outerWidth(),
      height = this.$el.outerHeight();
    this.$el.css({
      'left': ($(window).width() - width) / 2,
      'top': ($(window).height() - height) / 2,
      'margin': 0
    });
  },
  close: function close() {
    var self = this;
    if (this.animated) {
      this.$el.animationEndOnce(function ($e) {
        self.remove();
        MDAlertView.curAlertCount--;
      });
      this.$el.addClass("fadeOutUp");
      this.$overlayer.addClass("fadeOut");
      _.isFunction(self.onHide) && self.onHide();
    } else {
      self.remove();
      _.isFunction(self.onHide) && self.onHide();
    }
    this._preDocumentActiveEl.focus();
  },
  _closeBtnClickHandler: function _closeBtnClickHandler() {
    var _this = this;
    this.close();
    if (this.onClose) {
      setBabelTimeout(function () {
        _this.onClose();
      }, 10);
    }
  },
  _renderButtons: function _renderButtons(buttons) {
    var self = this;
    _.each(buttons, function (button, index) {
      var label = button.label || "";
      var onClick = button.onClick;
      var type = button.type || "";
      var $button = null;
      var autoClose = _.isBoolean(button.autoClose) ? button.autoClose : true;
      if (self.isEmptyString(label)) {
        return true;
      }
      var className = "text-button done";
      switch (type) {
        case 'danger':
          className = 'button danger';
          break;
        case 'done':
          className = 'button done';
          break;
        default:
          className = 'text-button done';
      }
      $button = $("<button>");
      $button.text(label);
      $button.addClass(className);
      if (button.focused) {
        $button.focus();
      }
      self.$footer.append($button);
      $button.click(function ($event) {
        if (self.isFunction(onClick)) {
          onClick.call(self, $button[0], $event);
        }
        if (autoClose) {
          self.close();
        }
        $event.stopPropagation();
      });
    });
  },
  _renderButtonDir: function _renderButtonDir(direction) {
    if (!direction) {
      direction = 'right';
    }
    switch (direction) {
      case 'left':
        this.$footer.addClass('flex-align start');
      case 'between':
        this.$footer.addClass('flex-align between');
        break;
      case 'right':
        this.$footer.addClass('flex-align end');
    }
  },
  viewDidUnRendered: function viewDidUnRendered() {
    _MMViewBase["default"].prototype.viewDidUnRendered.call(this);
    $(window).off(this.$nsEventName('resize'));
  },
  remove: function remove() {
    _MMViewBase["default"].prototype.remove.call(this);
    this.$overlayer && this.$overlayer.remove();
    this.$layoutWrapper.remove();
    _MDFocusManager["default"].removeFocus(this);
  },
  appendMsg: function appendMsg(msgText) {
    var notFound = true;
    for (var i = 0; i < this.messages.length; i++) {
      var element = this.messages[i];
      if (element == msgText) {
        notFound = false;
        break;
      }
    }
    if (notFound) {
      this.$body.append('<p class="title">' + msgText + '</p>');
      this.messages.push(msgText);
    }
  }
}, {
  curAlertCount: 0,
  setDefaults: function setDefaults(options) {
    _.extend(defaults, options);
  },
  showAlert: function showAlert(title) {
    var alert = new MDAlertView();
    var z_maxIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
    alert.$el.css('z-index', z_maxIndex);
    var msg = '<p class="title">' + title + '</p>';
    alert.show({
      title: BabelStr.str(170),
      // '提示',
      message: msg,
      className: 'm-delAlertWin',
      width: MMCommonFun.isInMobile() ? 300 : 470,
      onHide: function onHide() {},
      buttons: [{
        label: BabelStr.str(154),
        // '确定',
        type: 'danger'
      }]
    });
  },
  showStandardPrompt: function showStandardPrompt(opt) {
    var alert = new MDAlertView();
    var titleStr = _MDLocalString["default"].getLocalString(170);
    var okStr = _MDLocalString["default"].getLocalString(154);
    if (opt.okStr) {
      okStr = opt.okStr;
    }
    if (opt.title) {
      titleStr = opt.title;
    }
    ;
    if (!opt.width) {
      opt.width = 500;
    }
    ;
    if (app.isMobile && app.isMobile()) {
      opt.width = 300;
    }
    alert.show({
      title: titleStr,
      message: '<p class="title">' + opt.message + '</p>',
      className: 'm-delAlertWin',
      width: opt.width,
      hideCloseBtn: true,
      buttons: [{
        label: okStr,
        type: 'done',
        onClick: function onClick() {
          opt.okFun && opt.okFun();
        }
      }]
    });
  },
  showStandardSelection: function showStandardSelection(opt) {
    var alert = new MDAlertView();
    var titleStr = _MDLocalString["default"].getLocalString(170);
    if (opt.title) {
      titleStr = opt.title;
    }
    ;
    var okStr = opt.okStr || _MDLocalString["default"].getLocalString(154);
    var cancelStr = opt.cancelStr || _MDLocalString["default"].getLocalString(155);
    if (!opt.width) {
      opt.width = 470;
    }
    ;
    if (app.isMobile && app.isMobile()) {
      opt.width = 300;
    }
    alert.show({
      title: titleStr,
      message: '<p class="title">' + opt.message + '</p>',
      className: 'm-delAlertWin',
      width: opt.width,
      hideCloseBtn: true,
      buttons: [{
        label: cancelStr,
        onClick: function onClick() {
          opt.cancelFun && opt.cancelFun();
        }
      }, {
        label: okStr,
        type: 'done',
        onClick: function onClick() {
          opt.okFun && opt.okFun();
        }
      }]
    });
    return alert;
  },
  showDangerSelection: function showDangerSelection(opt) {
    var alert = new MDAlertView();
    var titleStr = _MDLocalString["default"].getLocalString(170);
    if (opt.title) {
      titleStr = opt.title;
    }
    ;
    var okStr = opt.okStr || _MDLocalString["default"].getLocalString(154);
    var cancelStr = opt.cancelStr || _MDLocalString["default"].getLocalString(155);
    if (!opt.width) {
      opt.width = 470;
    }
    ;
    if (app.isMobile && app.isMobile()) {
      opt.width = 300;
    }
    alert.show({
      title: titleStr,
      message: '<p class="title">' + opt.message + '</p>',
      className: 'm-delAlertWin',
      width: opt.width,
      hideCloseBtn: true,
      buttons: [{
        label: okStr,
        type: 'danger',
        onClick: function onClick() {
          opt.okFun && opt.okFun();
        }
      }, {
        label: cancelStr,
        onClick: function onClick() {
          opt.cancelFun && opt.cancelFun();
        }
      }]
    });
  },
  showRemoveTeamSelection: function showRemoveTeamSelection(opt) {
    var curTeamInfor = opt.teamInfo;
    var msg = '';
    if (curTeamInfor.getCreatorId() == app.currentUser.getUserId()) {
      msg = BabelStr.str(5115);
    } else {
      msg = BabelStr.str(5116);
    }
    var alert = new MDAlertView();
    var z_maxIndex = _MMBasicData["default"].getO2OMaxLayerZ_index();
    alert.$el.css('z-index', z_maxIndex);
    alert.show({
      title: BabelStr.str(170),
      message: msg,
      className: 'm-delAlertWin',
      buttons: [{
        label: BabelStr.str(154),
        type: 'danger',
        onClick: function onClick() {
          opt.onRemove();
        }
      }, {
        label: BabelStr.str(155)
      }]
    });
  },
  showAboutSecurity: function showAboutSecurity() {
    var html = "\n      <p class=\"text-left\">".concat(BabelStr.str(2557), "</p>\n      <p class=\"text-left\">").concat(BabelStr.str(2558), "</p>\n      <p class=\"text-left\">").concat(BabelStr.str(2559), "</p>\n      <p class=\"text-left\">").concat(BabelStr.str(2560), "</p>\n\n    ");
    if (app.ep && app.ep.isArchive()) {
      html = "\n      <p class=\"text-left\">".concat(BabelStr.str(2397), "</p>\n      <p class=\"text-left\">").concat(BabelStr.str(2398), "</p>\n      <p class=\"text-left\">").concat(BabelStr.str(2399), "</p>\n      ");
    }
    html += "<p class=\"text-left\">".concat(BabelStr.str(2577), "</p>\n    <p class=\"text-left\">").concat(BabelStr.str(7501), "</p>");
    var alert = new MDAlertView({
      title: BabelStr.str(170),
      message: html,
      width: 500,
      buttons: [{
        label: BabelStr.str(3096),
        type: "done"
      }]
    });
    alert.show();
  },
  showRenamedFileList: function showRenamedFileList(renameList) {
    if (renameList && renameList.length) {
      var html = "\n              <p class=\"text-left\">".concat(BabelStr.str(20035), "</p>\n            ");
      html += "<table class='renamed-table'>";
      html += "<thead>\n                  <tr>\n                    <th></th>\n                    <th>".concat(BabelStr.str(20037), "</th>\n                    <th></th>\n                    <th>").concat(BabelStr.str(20038), "</th>\n                  </tr>\n                </thead>");
      html += "<tbody>";
      for (var i = 0; i < renameList.length; i++) {
        var info = renameList[i];
        html += "\n        <tr class=\"text-left\">\n          <td ><span class=\"\"></span></td>\n          <td class=\"name old\">".concat(info.oldName, "</td>\n          <td class=\"icon-td\"><span class=\"icon icon30 rename-as-icon\"></span></td>\n          <td class=\"name new\">").concat(info.newName, "</td>\n        </tr>\n      ");
      }
      html += "</tbody>";
      html += "</table>";
      var alert = new MDAlertView({
        title: BabelStr.str(170),
        message: html,
        width: 900,
        hideCloseBtn: true,
        buttons: [{
          label: BabelStr.str(3096),
          type: "done"
        }]
      });
      alert.show();
    }
  }
});
var _default = exports["default"] = MDAlertView; // window.MDAlertView = MDAlertView

},{"1150":1150,"1184":1184,"1412":1412,"1454":1454,"22":22,"44":44,"811":811}],44:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * View组件焦点管理对象，解决多个层级界面下键盘事件处理的先后顺序问题
 *
 * Created by manjun.han
 * 2016.12.30
 */

/**
 * @type {Array.MMViewBase}
 */
var focusedViews;

/**
 * 焦点管理对象
 * @see  http://help.adobe.com/en_US/FlashPlatform/reference/actionscript/3/fl/managers/FocusManager.html
 * @type {Object}
 */
var _default = exports["default"] = {
  /**
   * 设置焦点到当前view上
   * @param {MMViewBase} view 组件对象
   */
  setFocus: function setFocus(view) {
    focusedViews = focusedViews || [];
    focusedViews.push(view);
  },
  /**
   * 获取当前持有焦点的对象
   * @return {MMViewBase}
   */
  getFocus: function getFocus() {
    if (!focusedViews) {
      return null;
    }
    ;
    return focusedViews[focusedViews.length - 1] || null;
  },
  /**
   * 判断当前view是否持有焦点，持有焦点的对象优先接受键盘事件
   * @param  {MMViewBase}  view 组件对象
   * @return {Boolean}
   */
  isFocused: function isFocused(view) {
    return view === this.getFocus();
  },
  /**
   * 删除当前view的焦点，一般在view从页面删除后执行
   * @param  {MMVieBase} removedView 被移除的对象
   */
  removeFocus: function removeFocus(removedView) {
    focusedViews = _.reject(focusedViews, function (view) {
      return view == removedView;
    });
  }
};

},{"1454":1454}],1085:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var ObjVisibleScope = {
  publicObject: 0,
  protectedObject: 1,
  privateObject: 2,
  evaluation: 8
};
var _default = exports["default"] = ObjVisibleScope;

},{"1454":1454}],950:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1466);
var _MMMeta = _interopRequireDefault(require(1080));
var _int = _interopRequireDefault(require(820));
var _OBJ_ID = _interopRequireDefault(require(818));
/**
 * 对应Xcode中的类--------Mola_message
 * @param id_
 * @param creator_
 * @param boardId_
 * @param name_
 * @param location_
 * @param readonly_
 * @param starttime_
 * @param endtime_
 * @returns {MMChatMessage}
 */
function MMChatMessage(id_, userId_, sessionId_, time_, name_, msg_, objId_) {
  _MMMeta["default"].call(this);
  this.m_className = 'MMChatMessage';
  this.m_ver = 2;
  if (typeof id_ == 'string') {
    id_ = parseInt(id_);
    id_ = new _int["default"](id_);
  }
  ;
  if (typeof userId_ == 'string') {
    userId_ = parseInt(userId_);
    userId_ = new _int["default"](userId_);
  }
  ;
  this.m_id = id_; //{Id} int64
  this.m_userid = userId_; //{Id} int64
  this.m_sessionid = sessionId_; //{Id}
  this.m_time = time_; //__int64_t
  this.m_message = msg_ ? msg_ : ""; //std::string
  this.m_username = name_; //std::string

  if (typeof objId_ == 'string') {
    var objId = new _OBJ_ID["default"]();
    objId.fromString(objId_);
    objId_ = objId;
  }
  ;
  this.m_objId = objId_ ? objId_ : new _OBJ_ID["default"](); //OBJ_ID

  this.m_visibleScope = 0;
  this.m_clientUsers = [];
}
;
MMChatMessage.prototype = new _MMMeta["default"]();
MMChatMessage.superclass = _MMMeta["default"].prototype;
MMChatMessage.prototype.decode = function (dc_, ver_) {
  MMChatMessage.superclass.decode.call(this, dc_, ver_);
  this.m_id = dc_.decodeFrom8Bytes(ver_);
  this.m_userid = dc_.decodeFrom8Bytes(ver_);
  this.m_sessionid = dc_.decodeFrom8Bytes(ver_);
  this.m_message = dc_.decodeFromString(ver_);
  this.m_time = dc_.decodeFrom8Bytes(ver_) * 1000;
  this.m_username = dc_.decodeFromString(ver_);
  if (this.m_ver >= 1) {
    this.m_objId = dc_.decodeFromObjID(ver_);
  }
  if (this.m_ver >= 2) {
    this.m_visibleScope = dc_.decodeFrom4Bytes(ver_);
    this.m_clientUsers = dc_.decodeFromArray(ver_);
  }
};
MMChatMessage.prototype.encode = function (ec_) {
  MMChatMessage.superclass.encode.call(this, ec_);
  ec_.encode8Bytes(this.m_id);
  ec_.encode8Bytes(this.m_userid);
  ec_.encode8Bytes(this.m_sessionid);
  ec_.encodeString(this.m_message);
  ec_.encode8Bytes(this.m_time / 1000);
  ec_.encodeString(this.m_username);
  ec_.encodeObjID(this.m_objId);
  ec_.encode4Bytes(this.m_visibleScope);
  ec_.encodeArray(this.m_clientUsers, "8Bytes");
};
MMChatMessage.prototype.set_auxiliaryInfo = function (visibleScope, clientUsers) {
  this.m_visibleScope = visibleScope;
  this.m_clientUsers = clientUsers;
};
MMChatMessage.prototype.getId = function () {
  return this.m_id;
};
MMChatMessage.prototype.setId = function (id) {
  this.m_id = id;
};
MMChatMessage.prototype.getSessionid = function () {
  return this.m_sessionid;
};
MMChatMessage.prototype.getObjId = function () {
  return this.m_objId;
};
MMChatMessage.prototype.getUserId = function () {
  return this.m_userid;
};
MMChatMessage.prototype.getMessage = function () {
  return this.m_message;
};
MMChatMessage.prototype.getSenderName = function () {
  return this.m_username;
};
var _default = exports["default"] = MMChatMessage;

},{"1080":1080,"1184":1184,"1454":1454,"1466":1466,"818":818,"820":820}],1080:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 *
 * @param {MMWhiteboard} board  a MMWhiteboard.
 * @returns {MMMeta}
 */
function MMMeta(board) {
  //this.m_className = "MMMeta" ;
  this.m_ver = 0;
  this.m_board = board;
}
MMMeta.prototype.m_className = "MMMeta";
_.extend(MMMeta.prototype, {
  encode: function encode(ec_) {
    ec_.encode4Bytes(this.m_ver);
  },
  decode: function decode(dc_, ver_) {
    this.m_ver = dc_.decodeFrom4Bytes();
  },
  duplicate: function duplicate() {},
  duplicateTo: function duplicateTo(sourceData_) {},
  getClassName: function getClassName() {
    return this.m_className;
  },
  initBy: function initBy(meta) {
    this.m_ver = meta.m_ver;
    this.m_board = meta.m_board;
  }
});
var _default = exports["default"] = MMMeta;

},{"1454":1454}],72:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1417);
require(1463);
var _MMViewBase = _interopRequireDefault(require(22));
var _MMBasicData = _interopRequireDefault(require(811));
var _SnackbarSide = _interopRequireDefault(require(73));
var _MDEvents = _interopRequireDefault(require(325));
var _Dispatcher = _interopRequireDefault(require(18));
var _MDLocalString = _interopRequireDefault(require(1150));
/**
 * View for snackbar Created by manjun.han 2015.9.18
 */
// MMBasicData

// import MDFileOperationManager from '../../../moladisk/common/MDFileOperationManager.js'

var SnackbarMargin = 10; // px

var MDSnackbarView = _MMViewBase["default"].extend({
  el: '<div class="m-snackbar"></div>',
  tmpl: "<span class='msg'></span><span class='roll-back'>" + BabelStr.str(3293) + "</span><button class='icon closeBtn'></button>",
  events: function events() {
    return {
      'click .closeBtn': this._closeBtnClickHandler,
      'click .roll-back': this._rollbackBtnClickHandler
    };
  },
  _defaults: {
    side: _SnackbarSide["default"].BottomRight,
    delay: 6000,
    msg: "",
    multi: false
  },
  _tid: -1,
  _showing: false,
  side: -1,
  $msg: "",
  initialize: function initialize(opt) {
    this.opt = _.extend({}, this._defaults, opt);
    _MMViewBase["default"].prototype.initialize.call(this, opt);
    this.$el.appendTo('body');
    this.$msg = this.$('.msg');
    this.setMsg(this.opt.msg);
    var z_startIndex = _MMBasicData["default"].getO2OTopLayerZ_index();
    $(this.el).css('z-index', z_startIndex);
  },
  setMsg: function setMsg(msg) {
    this.$msg.html(msg);
    this.msg = msg;
  },
  /**
   * opt = { msg:'', side:SnackbarSide.BottomLeft }
   */
  show: function show(opt) {
    var self = this;
    opt = _.extend({}, this.opt, opt);
    this.side = opt.side;
    var multi = opt.multi;
    var autoDismiss = _.isUndefined(opt.autoDismiss) ? true : opt.autoDismiss;
    // var codeStr = _.isUndefined(opt.code) ? '' : '<span>（' + BabelStr.str(3607) + '：'+opt.code+'）</span>';
    var codeStr = "";
    if (multi) {
      this.setMsg(this.msg + "<p>" + opt.msg + "</p>" + codeStr);
    } else {
      this.setMsg(opt.msg + codeStr);
    }
    clearTimeout(this._tid);
    if (!opt.showRollback) {
      this.$el.find('.roll-back').hide();
    } else {
      this.$el.find('.roll-back').show();
    }
    this.$el.show();
    this._setPosition();
    this.el.offsetWidth;
    this._show();
    if (autoDismiss) {
      this._tid = setBabelTimeout(function () {
        self.dismiss();
      }, opt.delay);
    }
    console.log('------> show!');
  },
  _show: function _show() {
    this.$el.show();
    this.$el.css({
      bottom: SnackbarMargin,
      opacity: 1
    });
    this._showing = true;
  },
  dismiss: function dismiss() {
    var self = this;
    clearTimeout(this._tid);
    this.msg = "";
    self._showing = false;
    this.$el.css({
      bottom: 0,
      opacity: 0
    }).transitionEndOnce(function () {
      if (!self._showing) {
        self.$el.hide();
      }
      ;
    });
    console.log('------> dismissed!');
  },
  _setPosition: function _setPosition() {
    switch (this.side) {
      case _SnackbarSide["default"].TopLeft:
      case _SnackbarSide["default"].TopRight:
      case _SnackbarSide["default"].TopCenter:
      case _SnackbarSide["default"].BottomLeft:
        this.$el.css({
          left: SnackbarMargin,
          bottom: 0
        });
        break;
      case _SnackbarSide["default"].BottomRight:
        this.$el.css({
          right: SnackbarMargin,
          left: 'auto',
          bottom: 0
        });
        break;
      case _SnackbarSide["default"].BottomCenter:
    }
  },
  _closeBtnClickHandler: function _closeBtnClickHandler() {
    this.dismiss();
  },
  _rollbackBtnClickHandler: function _rollbackBtnClickHandler() {
    // MDFileOperationManager.undo();
    _Dispatcher["default"].trigger(_MDEvents["default"].FileOperationUndo);
    this.dismiss();
  },
  remove: function remove() {
    _MMViewBase["default"].prototype.remove.call(this);
  }
}, {
  singleton: null,
  show: function show(msg, opt) {
    if (!MDSnackbarView.singleton) {
      MDSnackbarView.singleton = new MDSnackbarView();
      var z_startIndex = _MMBasicData["default"].getO2OTopLayerZ_index();
      $(this.el).css('z-index', z_startIndex);
    }
    opt = _.extend({
      multi: false
    }, opt);
    opt.msg = msg;
    MDSnackbarView.singleton.show(opt);
  },
  showStandardMsg: function showStandardMsg(msgIndex, opt) {
    var msg = g_snackStandardMessages[msgIndex];
    MDSnackbarView.show(msg, opt);
  },
  dismiss: function dismiss() {
    MDSnackbarView.singleton && MDSnackbarView.singleton.dismiss();
  }
});
var g_snackStandardMessages = {
  '0': BabelStr.str(3294),
  'commentCreated': BabelStr.str(3295),
  'commentFailed': BabelStr.str(3296),
  '3': BabelStr.str(3297),
  '4': BabelStr.str(3298),
  '5': BabelStr.str(309),
  // 操作失败
  '6': BabelStr.str(308),
  // 操作成功

  '20': BabelStr.str(3299),
  '30': BabelStr.str(3300) + '!',
  '31': BabelStr.str(3301) + '!',
  '40': BabelStr.str(3302),
  '41': BabelStr.str(742),
  '42': BabelStr.str(4244),
  '43': BabelStr.str(20058),
  'evalOpiCreated': BabelStr.str(7014),
  'opFailed': BabelStr.str(168),
  'networkerror': BabelStr.str(5196)
};
var _default = exports["default"] = MDSnackbarView;

},{"1150":1150,"1184":1184,"1417":1417,"1454":1454,"1463":1463,"18":18,"22":22,"325":325,"73":73,"811":811}],1150:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1461);
require(1477);
require(1492);
var _localString_cn = _interopRequireDefault(require(1151));
var _localString_en = _interopRequireDefault(require(1155));
var _localString_hk = _interopRequireDefault(require(1159));
var _localString_ru = _interopRequireDefault(require(1163));
var MDLocalString = {
  getLanguage: function getLanguage() {
    // 暂时去掉中英文切换
    var lan = this.getCurrentLanguage();
    if (app.currentUser && lan == 'en') {
      return _localString_en["default"];
    } else if (app.currentUser && lan == 'zh-HK') {
      return _localString_hk["default"];
    } else if (app.currentUser && lan == 'ru') {
      return _localString_ru["default"];
    } else {
      return _localString_cn["default"];
    }
  },
  getDefaultLanguage: function getDefaultLanguage() {
    return _localString_cn["default"];
  },
  getCurrentLanguage: function getCurrentLanguage() {
    var lan = navigator.language || navigator.userLanguage; //常规浏览器语言和IE浏览器
    lan = lan.substr(0, 2);
    if (lan == "zh") {
      lan = "cn";
    }
    if (app.currentUser && app.currentUser.get && app.currentUser.get("lang")) {
      lan = app.currentUser.get("lang");
    } else if (app.currentUser && app.currentUser.lang) {
      lan = app.currentUser.lang;
    }
    var getClientLocalInfo = null;
    var localeInfo = null;
    var local = null;
    if (!window.isLoadGetClientLocalInfo) {
      window.isLoadGetClientLocalInfo = true;
      if (window["ElectronRequire"]) {
        var electron = window["ElectronRequire"]("electron");
        var getClientLocalInfo = electron.remote.require("./utils/cppAPI").getClientLocalInfo;
        if (getClientLocalInfo) {
          localeInfo = getClientLocalInfo() || {};
          local = localeInfo.locale;
        }
        if (local) {
          localStorage["language"] = local;
        }
      }
    }
    if (localStorage["language"]) {
      lan = localStorage["language"];
    }
    return lan;
  },
  getLocalString: function getLocalString(key, param) {
    if (param) {
      try {
        return this.initByParam(key, param);
      } catch (e) {
        console.error("initByParam error:", key, param);
      }
    }
    var lang = this.getLanguage();
    return lang[key] || this.getDefaultLanguage()[key];
  },
  str: function str(key, param) {
    return this.getLocalString(key, param);
  },
  initByParam: function initByParam(key, option) {
    var str = this.getLocalString(key);
    var keys = Object.keys(option);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var val = option[key];
      str = str.replace("{-" + key + "-}", val);
    }
    if (option["UpperCase1st"]) {
      str = str[0].toUpperCase() + str.substr(1);
    }
    if (option["LowerCase1st"]) {
      str = str[0].toLowerCase() + str.substr(1);
    }
    return str;
  },
  isRu: function isRu() {
    return this.getCurrentLanguage() == 'ru';
  },
  isZH: function isZH() {
    var lan = this.getCurrentLanguage();
    return lan == 'cn' || lan == "zh-HK";
  }
};
window.BabelStr = MDLocalString;
var _default = exports["default"] = MDLocalString;

},{"1151":1151,"1155":1155,"1159":1159,"1163":1163,"1184":1184,"1454":1454,"1461":1461,"1477":1477,"1492":1492}],1163:[function(require,module,exports){
"use strict";

require(1461);
require(1503);
require(1415);
require(1463);
require(1456);
require(1418);
require(1537);
require(1457);
require(1453);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require(1180));
var _localString_ru_part = _interopRequireDefault(require(1164));
var _localString_ru_part2 = _interopRequireDefault(require(1165));
var _localString_ru_part2_ = _interopRequireDefault(require(1166));
var _localString_ru_part3 = _interopRequireDefault(require(1167));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var localString_ru = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _localString_ru_part["default"]), _localString_ru_part2["default"]), _localString_ru_part2_["default"]), _localString_ru_part3["default"]);
var _default = exports["default"] = localString_ru;

},{"1164":1164,"1165":1165,"1166":1166,"1167":1167,"1180":1180,"1184":1184,"1415":1415,"1418":1418,"1453":1453,"1454":1454,"1456":1456,"1457":1457,"1461":1461,"1463":1463,"1503":1503,"1537":1537}],1167:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require(1180));
var _localString_ru_part;
var localString_ru_part3 = (_localString_ru_part = {
  //******************************* 初始化密码界面 */
  11001: "Инициализация пароля",
  11002: "При первом входе вам нужно заново инициализировать пароль",
  //////////////**************9.1.4*************//////////////// */
  11003: 'Статус экспорта',
  11004: 'Журнал экспорта',
  11005: 'Страница экспорта',
  11006: 'Поиск экспортёра',
  11007: 'Время запроса',
  11008: 'Время экспорта',
  11009: 'Экспортируемый файл',
  11010: 'Экспортёр',
  11011: 'Подсказка: из-за большого размера экспортируемого файла, для обеспечения безопасного и эффективного скачивания, ваш запрос на экспорт будет временно храниться на облачном сервере и автоматически истечёт через три дня',
  11012: 'Отчёт по участникам',
  11013: 'Генерируется',
  11014: 'Сгенерировано',
  11015: 'Ошибка генерации',
  11016: 'Нет записей экспорта',
  11017: 'Операция выполнена успешно! Пожалуйста, позже перейдите на страницу «<span class="main-color">Журнал экспорта</span>», чтобы скачать и просмотреть.',
  11018: 'Все статусы',
  11019: 'Эта запись истекла',
  11020: 'Ошибка получения журнала экспорта',
  11021: 'Информация о участниках предприятия',
  11022: 'Участие пользователя в файлах',
  /**********************ai******************* */
  11100: "Умное гнездо AI",
  11101: "Настройка интеллектуального гнезда",
  11102: "Помощник Птицы Баве",
  11103: "Настройка принадлежащих вам AI - помощников",
  11104: "Помощник AI Palbirds может учиться с использованием файлов, назначенных компанией, стать эксклюзивным помощником AI в вашей компании, вести диалог с компанией в форме вопросов и вопросов, связанных с компанией, и давать ответы в пределах своих полномочий в зависимости от того, кто имеет разные полномочия. ",
  11105: "Вопросы истории",
  11106: "Новые вопросы",
  11107: "Строго",
  11108: "Обычные",
  11109: "Творчество",
  11110: "Подключите свою корпоративную библиотеку документов к умным гнездам",
  11111: "Помощник AI Palbirds может учиться с использованием файлов, назначенных компанией, стать эксклюзивным помощником AI в вашей компании, вести диалог с компанией в форме вопросов и вопросов, связанных с компанией, и давать ответы в пределах своих полномочий в зависимости от того, кто имеет разные полномочия. ",
  11112: "После успешной покупки вы можете выбрать диапазон документов, требующих обучения в CIGLE. Терпеливо ожидая завершения обучения в CIGLE, у вас будет эксклюзивный помощник AI",
  11113: "Обучение ИИ требует большого количества ресурсов CPU, поэтому доступ к CIGNE требует отдельной платы за открытие, пожалуйста, выберите пакет услуг, подходящий для вас",
  11114: "Нет ограничений на создание ассистентов ИИ, каждый из которых может изучать до 10 000 документов. Срок действия: 10 000 юаней / год в течение одного года с этого момента ",
  11115: "Можно создать 5 помощников ИИ, каждый из которых может изучать до 5000 документов. Срок действия услуги: 5 000 юаней / год в течение одного года с этого момента ",
  11116: "Можно создать 2 помощника ИИ, каждый из которых может изучать до 1000 документов. Срок действия услуги: вступает в силу в течение одного года с этого момента 2000 юаней / год ",
  11117: "Создание эксклюзивного помощника ИИ",
  11118: "Имя помощника",
  11119: "Пожалуйста, выберите диапазон документов для изучения:",
  11120: "Новые помощники ИИ",
  11121: "Поддерживает флажок",
  11122: "Мой AI помощник:",
  11123: "Удалить",
  11124: "Создание кода внешней цепи:",
  11125: "Помощник AI Palbe также может стать вашим собственным продуктом и сервисом только для обслуживания клиентов. Просто создайте новый помощник AI и выберите учебные материалы, необходимые для онлайн - обслуживания клиентов, и AI сможет отвечать на вопросы пользователей в качестве интеллектуального обслуживания клиентов после завершения обучения. Вы можете выбрать конкретного помощника ИИ для создания фрагмента кода, вставленного на ваш сайт, и у вас есть эксклюзивный ИИ, который полностью автоматически отвечает на вопросы пользователя",
  11126: "Выберите помощника ИИ, который должен быть выпущен",
  11127: "Создано",
  11128: "Умное гнездо",
  11129: "Не может отправить пустую информацию",
  11130: "В настоящее время ИИ также нуждается в индивидуальной настройке данных и сценариев использования для каждого предприятия, создавая эксклюзивные модели ИИ для компании», - сказал он",
  11131: "Если вам нужно приобрести AI - ассистента « умных гнездов», пожалуйста, свяжитесь с нашим продавцом (онлайн - обслуживание клиентов) или наберите 400920",
  11132: "Вы также можете отправить письмо по адресу: huangfu@molasync.com ",
  11133: "Понял",
  11134: "Очистить исторические записи",
  11135: "Освобождение ценности корпоративного контента",
  11136: " Немедленно используйте интеллектуальное гнездо AI",
  11137: "Отвечайте на все вопросы о документе",
  11138: "Используя ИИ для анализа содержимого документа, он может ответить на все вопросы о содержимом документа. От обобщения документов до раскрытия ключевых открытий в длительных исследованиях. Благодаря пониманию контента на основе искусственного интеллекта вы можете принимать решения по ключевым задачам быстрее и увереннее. Это означает, что вместо того, чтобы читать сотни страниц документа лично, вы передадите его непосредственно ИИ, и вы можете задать ему вопросы, которые вас волнуют. Это значительно повышает эффективность работы. ",
  11139: "Настройка AI - помощника, принадлежащего вашему предприятию",
  11140: "Самая большая проблема с существующими системами ИИ заключается в том, что они не могут дать точные ответы на вопросы, основанные на эксклюзивном контенте вашего предприятия. Команда AI - ассистентов Babe Birds помогает компаниям готовить учебные наборы, настраивать и обучать эксклюзивные модели AI на основе корпоративной информации для реализации доступных AI - ассистентов. Информация и вопросы, касающиеся бизнеса, могут быть обсуждены непосредственно в форме вопросов и « мозговых гнездов». Ответы могут быть даны в пределах компетенции в зависимости от того, кто имеет разные полномочия. Вы даже можете использовать интеллектуальную систему обслуживания клиентов вашего предприятия, чтобы создать блок кода, прикрепленный к вашему сайту, используя интеллектуальное гнездо ",
  11141: "Создайте собственную платформу обслуживания клиентов",
  11142: "Обучение работе с клиентами часто отнимает много энергии и рабочей силы у предприятий, а аренда или покупка роботов для обслуживания клиентов не является неэффективной и неудовлетворительной. Использование AI Palbe Birds позволяет создавать недорогие платформы обслуживания клиентов AI, а малые и средние предприятия могут иметь интеллектуальные платформы обслуживания клиентов, сопоставимые с крупными предприятиями. Команда AI Pabel Birds Ziggé может использовать существующие учебные материалы по обслуживанию клиентов, вопросники и ответы, инструкции и другие материалы для оптимизации, формирования материала для обучения AI, а также в соответствии с вашей отраслью для настройки AI, в конечном итоге создать систему обслуживания клиентов AI, подходящую для вашего бизнеса. ",
  11143: "Помочь вам создать контент, ответить на вопросы",
  11144: "Создание контента должно быть легким и интересным, а не тратить время на обдумывание предложений. У интеллектуального интеллекта есть фундаментальные возможности для всех больших моделей, независимо от того, составляете ли вы пресс - релизы, пишете ли вы персонализированные электронные письма для продажи или намечаете действия на конференции, вы можете использовать контент - интеллект, чтобы ускорить работу, высвободив время, чтобы сосредоточиться на клиентах и инновациях». Так как вы работаете в Pabbirds, все инструменты, необходимые для интеллектуального управления контентом, встроены, и вы можете просто найти интеллектуальное гнездо AI. ",
  11145: "Безопасный, надежный и приватный искусственный интеллект корпоративного уровня",
  11146: "Как сделать так, чтобы искусственный интеллект не говорил глупости? Как сделать так, чтобы искусственный интеллект не притворялся, что знает (умел сказать «не знаю»)? Как сделать так, чтобы искусственный интеллект не раскрывал секреты? Это важные показатели для оценки качества системы искусственного интеллекта. Уровень точности системы искусственного интеллекта Zhichao AI значительно повышен, она также автоматически подключается к системе прав доступа Babebird. Если пользователь задает вопрос, выходящий за пределы его прав доступа, Zhichao AI ответит «не знаю». Кроме того, все документы, используемые для обучения, указываются и согласовываются пользователем.",
  11147: "Принесите бесконечные возможности для вашего предприятия",
  11148: "Используйте контент предприятия для создания аналитических отчетов",
  11149: "Используйте корпуус языковых данных предприятия для обучения AI-консультанта, который автоматически отвечает на вопросы клиентов",
  11150: "Автоматическое создание маркетинговых писем, описаний должностей и других текстов",
  11151: "Легко и точно переводите отчеты или документы на разные языки стран мира",
  11152: "Помощь ИИ при чтении для быстрого поиска ключевых моментов и знаний в статье, повышение эффективности",
  11153: "Создание базы знаний с вопросами и ответами, специфичными для предприятия, на основе документов предприятия",
  11154: "Обладайте системой искусственного интеллекта Zhichao AI",
  11155: "Хотите использовать систему искусственного интеллекта Zhichao AI от BabeBird для повышения производительности вашего предприятия или предоставления лучшего обслуживания вашим клиентам? Пользователи корпоративной версии BabeBird теперь могут сразу же использовать систему искусственного интеллекта Zhichao AI. Если у вас нет учетной записи корпоративной версии, зарегистрируйтесь прямо сейчас!",
  11156: "Кроме того, мы предоставляем услуги обучения искусственного интеллекта, специфичные для предприятий, чтобы помочь предприятиям быстро развиваться с помощью искусственного интеллекта.",
  11157: "Заполните информацию о заявке, чтобы стать одним из первых, кто запустит систему искусственного интеллекта Zhichao AI",
  11158: "Нет учетной записи?",
  11159: "Нажмите, чтобы зарегистрироваться в корпоративной версии BabeBird",
  11160: "Ваш учетный номер для входа в корпоративную версию (номер телефона)",
  11161: "Имя контактного лица",
  11162: "Номер телефона контактного лица",
  11163: "Получить код проверки",
  11164: "Код проверки",
  11165: "Отправить заявку",
  11166: "Пожалуйста, введите учетный номер корпоративной версии",
  11167: "Пожалуйста, введите правильный номер телефона учетной записи",
  11168: "Благодарим вас за поддержку. Ваша заявка принята, пожалуйста, дождитесь уведомления.",
  11169: "Пожалуйста, введите имя контактного лица",
  11170: "Пожалуйста, введите правильный учетный номер для входа в корпоративную версию",
  11171: "*Поскольку для вычислений с использованием ИИ требуется большое количество ресурсов GPU, количество тестовых модулей, открываемых еженедельно, ограничено.",
  11172: "Поговорите с системой искусственного интеллекта Zhichao AI",
  11173: "Это помощник BabeBird Zhichao AI. Вы можете задавать ему в чате любые вопросы о использовании BabeBird.",
  11174: "В чем разница между проектом и отделом в BabeBird?",
  11175: "У меня есть файл, который я не хочу показывать членам отдела. Как это сделать?",
  11176: "Я хочу отправить файл всему персоналу компании, но не хочу, чтобы они его скачивали. Как это сделать?",
  11177: "В чем разница между редактированием в клиенте и онлайн-редактированием?",
  11178: "Это помощник по документам Zhichao AI. Вы можете задавать ему в чате любые вопросы о данном документе.",
  11179: "Составьте план этого документа",
  11180: "В чем основная идея этого документа?",
  11181: "Кратко опишите этот документ",
  11182: "Отправить сообщение",
  11183: "Не удалось отправить сообщение. Пожалуйста, повторите попытку позже.",
  11184: "Ответ на этот вопрос длинный, дайте мне минутку на раздумывание, я отвечу в течение минуты.",
  11185: "Помощник по чтению Zhichao AI",
  11186: "Войти в корпоративную версию BabeBird",
  /* * * * * * * * * * * * * * * * * 9.3.6 * * * * * * * * * * * * * * * * * * * * * * * * */
  11300: "После установки подписи вы можете использовать подпись при предварительном просмотре документа",
  11301: "Настройка подписи",
  11302: "Добавить рукописную подпись",
  11303: "Загрузить подписанный фотофайл",
  11304: "Настройка печати",
  11305: "Загрузить графический файл с печатью",
  11306: "текущее",
  11307: "установить текущий",
  11308: "Типы изображений, которые поддерживаются для загрузки: png, jpg, jpeg, размер файла не более 2 МБ",
  11309: "Перетащите изображение в новую подпись в регионе",
  11310: "или",
  11311: "Выберите файл...",
  11312: "Загрузить подписанный фотофайл",
  11313: "Пожалуйста, загрузите изображения в формате png, jpg или jpeg",
  11314: "Размер файла не может превышать 2 МБ",
  11315: "Перетащите изображение в новую подпись в регионе",
  11316: "Белый становится прозрачным",
  11317: "Добавить печать",
  11318: "Подпись",
  11319: "Скачать Подписать PDF",
  11320: "Сохранить в текущий каталог",
  11321: "Скачать PDF файлы",
  11322: "Сбой в получении информации о подписи",
  11323: "Не удалось загрузить",
  11324: "Создается PDF, пожалуйста, подождите",
  11325: "Ошибка генерации PDF, попробуйте позже",
  11326: "Подписанные документы",
  11327: "{-somebody-} генерирует подписанный PDF - файл файла {-file-}",
  11328: "Аккредитация подписи",
  11329: "Загрузите PDF - файл подписи, созданный на веб - диске, чтобы подтвердить происхождение подписи и то, была ли подпись сгенерирована системой, чтобы определить подлинность подписанного файла. ",
  11330: "Нажмите или перетащите PDF - файл для загрузки",
  11331: "Пожалуйста, загрузите PDF файл",
  11332: '{-user-} создал в {-time-} файл" {-file-} "подписанный pdf - файл" {-sealedfileName-}',
  11333: "Подписавший составитель документов",
  11334: "Дата создания подписанного документа",
  11335: "Действительность подписания",
  11336: "Информация о подписании документа не запрашивалась",
  11337: "Эффективно",
  11338: "Подписавшие",
  11339: "Файл создал подпись (глава) pdf, <br> Вы можете скачать существующую подпись pdf (рекомендуется), <br> также можно нажать кнопку ниже, чтобы снова создать новый подпись (глава) pdf файл",
  11340: "Неэффективность",
  11341: "Создать новый файл подписи",
  11342: "Language",
  11343: "{-somebody-} удалил подпись из файла {-file-}",
  11344: "Выберите файл изображения",
  11345: "Каталог, в котором находится проект, не имеет необязательного сектора",
  11346: "Создается файл подписи...",
  11347: "Все подсекторы / папки нижнего уровня наследуют эти права",
  11348: "Все подкатегории / папки нижнего уровня унаследуют этот параметр прав, параметр прав человека / роли в подразделении / папке нижнего уровня будет очищен, чтобы унаследовать этот параметр прав, и эта операция необратима",
  11349: "Нажмите на корпоративные документы, чтобы напрямую войти в свой отдел",
  11350: "После открытия щелчок по каналу корпоративных файлов будет напрямую входить в отдел, в котором вы находитесь",
  11351: "Ваша профессиональная версия истекла, чтобы не повлиять на ваше нормальное использование, пожалуйста, обновите ее как можно скорее",
  11251: "Повышение аккаунта {-somebody-} до профессиональной версии",
  11252: "Профессиональная версия услуги Птица Бабель",
  11253: "Срок действия профессиональной версии услуги истекает до",
  11254: "Общая сумма расходов",
  11255: " Текущий аккаунт был обновлен до профессиональной версии",
  11256: " Если у вас есть какие - либо вопросы, пожалуйста, свяжитесь с гостевой службой",
  11257: "Возвращение на домашнюю страницу",
  11258: "Налоговый номер",
  11259: "Счета - фактуры компании должны заполнять этот пункт",
  11260: "Выберите историю для отправки информации",
  11261: "Адрес отправки",
  11262: "Номер заказа",
  11263: "Способы оплаты",
  11264: "Договор загрузки",
  11265: "Крайний срок оплаты",
  11266: "Просрочка закроет сделку",
  11267: "Пожалуйста, не закрывайте это окно проверки платежа до завершения платежа, после завершения платежа нажмите кнопку ниже в соответствии с вашими обстоятельствами",
  11268: "Выплачивается",
  11269: "Оплата успешно",
  11270: "Неудачный платеж",
  11271: "Повторная оплата",
  //////////////**************9.1.5*************//////////////// */
  12100: "Расширенные настройки",
  12101: "Белый список типов файлов для загрузки",
  12102: "Чёрный список типов файлов для загрузки",
  12103: "Только типы файлов, добавленные в белый список, могут быть загружены",
  12104: "Приоритет белого списка выше чёрного списка; типы файлов в белом списке не подпадают под чёрный список",
  12105: "Нажмите для ввода расширений файлов для добавления в белый список. Например: jpg;png (регистр не важен)",
  12106: "Несколько расширений разделяются «;», например jpg;png;doc",
  12107: "Типы файлов, добавленные в чёрный список, запрещены к загрузке",
  12108: "Нажмите для ввода расширений файлов для добавления в чёрный список. Например: jpg;png (регистр не важен)",
  12109: "Двусторонняя привязка",
  12110: "После включения двусторонней привязки устройства с привязанным MAC-адресом смогут входить только с привязанным аккаунтом (веб-версия не ограничена)",
  12111: "Разрешить онлайн-редактирование файлов Office",
  12112: "При отключении этой опции файлы Office в отделе не смогут быть отредактированы онлайн",
  12113: "Запретить внешнее совместное использование файлов отдела",
  12114: "При включении этой опции все участники отдела не смогут делиться файлами с внешними пользователями предприятия, а также делиться файлами по ссылке",
  12115: "Применить это настройку ко всем подразделениям текущего отдела",
  12116: "Запретить совместное использование файлов отдела",
  12117: "Запретить онлайн-редактирование файлов отдела",
  12118: "Опции отдела",
  12119: "Чёрный список, установленный на уровне отдела или проекта, имеет приоритет над этим чёрным списком",
  12120: "Прямые участники классифицированы по ролям, можно редактировать и управлять.",
  12121: "Нет прав на просмотр ссылок для совместного использования",
  12122: "Неизвестная роль",
  12123: "Файл {-file-} запущен в новый этап утверждения",
  12130: "Сообщение истекло",
  ////////////////////9.1.6//////////////////

  12200: "Ошибка получения пароля файла",
  12201: "Отображать сокращённое название предприятия в заголовке системы",
  12202: "Запретить ввод специальных символов",
  12203: "Название роли не может содержать специальные символы",
  12204: "Название политики не может содержать специальные символы",
  12205: "Название группы не может содержать специальные символы",
  12206: "Заявка на отправку файла не утверждена",
  12207: "Заявка на отправку файла утверждена",
  12220: "Слишком много попыток, попробуйте через 10 минут",
  12221: "Неверный пароль",
  12222: "Список участников",
  12223: "При отключении этой опции в верхней панели заголовка будет отображаться только логотип предприятия",
  ////////////////////9.1.7//////////////////

  12300: "Нажмите",
  12301: "Установить снимок",
  12302: "Нажмите для выбора ответственного; если ответственный не меняется, это поле может быть пустым",
  12303: "Не отображать миниатюры для файлов без прав на скачивание",
  12304: "При включении этой опции, если у пользователя нет прав на скачивание файла, миниатюра файла не будет отображаться. Это предотвращает утечку файлов через скриншоты миниатюр",
  12305: "Нельзя повторно использовать старый пароль",
  12306: "У вас нет прав на загрузку этого файла",
  12307: "Количество файлов превышает {-max-}, пожалуйста, используйте функцию синхронизации клиента!",
  ////////////////////9.1.8//////////////////

  12400: "Диаграмма процесса drawio",
  12401: "Результаты поиска",
  12402: "Содержимое файла",
  12403: "Строго проверять права при поиске",
  12404: "Строгая проверка прав снижает эффективность поиска; нестрогая проверка может в особых случаях найти недоступные файлы, но доступ будет запрещён даже если найдены",
  12405: "Отфильтрованы файлы без прав доступа",
  /////////////////////9.2.0///////////////////////

  12500: "Библиотека материалов",
  12501: "Доступно только после инициализации администратором",
  12502: "Функция библиотеки материалов ещё не включена. Включить сейчас?",
  12503: "Библиотека материалов успешно включена",
  12504: "Разрешить доступ к библиотеке материалов",
  12505: "При отключении на интерфейсе пользователя не будет входа в библиотеку материалов, и пользователь не сможет получить доступ к библиотеке материалов",
  12506: "Пакетное управление правами доступа к разделам",
  12507: "Создать категорию",
  12508: "Введите название категории для создания категории; в категории нельзя загружать файлы, но можно создавать библиотеку материалов или новые категории в категории",
  12509: "Введите название категории",
  12510: "Видимость категории",
  12511: "Администратор категории",
  12512: "Склад материалов",
  12513: "У вас нет прав на создание категории, но вы можете подать заявку администратору категории на создание; после утверждения категория будет создана автоматически.",
  12514: "Подать заявку на создание категории",
  12515: "Управление категориями",
  12516: "Введите название библиотеки материалов",
  12517: "Ассистент библиотеки материалов",
  12518: "Добавить ассистента библиотеки материалов",
  12519: "Видимость библиотеки материалов",
  12520: "Скачивание файлов библиотеки материалов требует утверждения",
  12521: "Ограничить публичный доступ отделом",
  12522: "Ограниченный отдел требует утверждения",
  12523: "Доступ требует заявки",
  12524: "Внутренний (конфиденциальный)",
  12525: "Все, кто имеет доступ к родительской категории, могут получить доступ",
  12526: "Участники подбиблиотеки должны подать заявку администратору подбиблиотеки; доступ возможен только после утверждения",
  12527: "Доступен только администраторам материалов и участникам библиотеки материалов",
  12528: "Не отображать миниатюры для этой библиотеки материалов",
  12529: "Не отображать миниатюры для посетителей библиотеки материалов без прав на скачивание",
  12530: "Скачивание всеми посетителями, кроме администраторов, требует утверждения",
  12531: "Срок действия видимости  Внутренний (конфиденциальный)",
  12532: "После истечения срока",
  12533: "После истечения срока требуется утверждение для изменения видимости",
  12534: "Ассистент библиотеки материалов",
  12535: "Участники библиотеки материалов не подвержены влиянию видимости библиотеки материалов и видимости категории; они могут получить доступ по правам (ограничены настройками утверждения для скачивания внутренней библиотеки материалов)",
  12536: "Ассистент библиотеки материалов может добавлять и удалять участников библиотеки материалов, назначать права участникам. Но ассистент библиотеки материалов не может перемещать или удалять библиотеку материалов.",
  12537: "Участник библиотеки материалов",
  12538: "Пожалуйста, выберите ответственного",
  12539: "Управление категориями",
  12540: "Склад материалов",
  12541: "Категория",
  12542: "Подать заявку на создание подбиблиотеки материалов",
  12543: "Подать заявку на доступ",
  12544: "Заявка",
  12545: "Подать заявку на доступ к категории «{-file-}»",
  12546: "Подать заявку на доступ к библиотеке материалов «{-file-}»",
  12547: "Заявка на доступ",
  12548: "Подать заявку на скачивание следующих файлов из {-file-}",
  12549: "Подать заявку на скачивание следующих файлов",
  12550: "Заявитель на скачивание",
  12551: "Управление заявителями",
  12552: "Вы установили для текущей библиотеки скачивание без заявки, но в библиотеке есть исторические данные заявок на скачивание. Очистить эти данные?",
  12553: "Очистить",
  12554: "Сохранить",
  12555: "У вас нет прав на создание подбиблиотеки материалов, но вы можете подать заявку администратору на создание библиотеки материалов; после утверждения библиотека материалов будет создана автоматически.",
  12556: "Вы уже подавали заявку на создание библиотеки материалов в этой директории; в директории можно подать только одну заявку на создание библиотеки материалов",
  12557: "Выбрать участников библиотеки материалов",
  12558: "Пожалуйста, выберите ограниченный отдел",
  12559: "Просмотреть список авторизованных заявителей",
  12560: "Авторизованные посетители",
  12561: "Авторизованные файлы для скачивания",
  12562: "Просмотреть авторизованных для скачивания",
  12563: "Авторизованная информация",
  12564: "После удаления пользователь не сможет получить доступ к текущей библиотеке материалов",
  12565: "После удаления пользователь не сможет скачать текущий файл",
  12566: "Неверное имя пользователя или пароль, пожалуйста, проверьте и введите заново",
  12567: "Ваш предыдущий запрос еще не был одобрен, только после одобрения предыдущего запроса вы сможете отправить новый запрос.",
  12568: "В категории нельзя напрямую загружать файлы; вы можете создать подбиблиотеку материалов в категории и затем загружать файлы в библиотеку материалов",
  12569: "Текущая категория пуста",
  12570: "Текущая библиотека материалов пуста",
  12571: "настройка",
  12572: "настройка",
  12573: 'Пакетная настройка "{-name1-}""{-name2-}".. и т.д. {-len-} категорий',
  12574: 'Пакетная настройка "{-name1-}""{-name2-}" 2 категории',
  12575: "После сохранения настройки выбранных категорий будут перезаписаны",
  12576: 'Пакетная настройка "{-name1-}""{-name2-}".. и т.д. {-len-} библиотек материалов',
  12577: 'Пакетная настройка "{-name1-}""{-name2-}" 2 библиотеки материалов',
  12578: "Если оставить пустым, ответственный не будет установлен пакетно, сохранится существующий ответственный",
  12579: "После сохранения настройки выбранных библиотек материалов будут перезаписаны",
  12580: "Если оставить пустым, администратор не будет установлен пакетно, сохранится существующий администратор",
  12581: "После удаления пользователь не сможет получить доступ к текущей категории",
  12582: "Введите имя файла для фильтрации соответствующих файлов",
  12583: "Не скрывать конфиденциальную библиотеку материалов (участники неконфиденциальных библиотек материалов также могут видеть эту библиотеку материалов)",
  12584: "Подать заявку на участие",
  12585: "Подать заявку на участие в библиотеке материалов",
  12586: "Вы подаёте заявку на участие в библиотеке материалов {-name-}",
  12587: "Введите имя пользователя для фильтрации",
  12588: "Новый клиент для Windows",
  // 11116: 'Ошибка открытия совместного использования, пожалуйста, свяжитесь с администратором',
  //*************hotfix****************/
  /*******************ocr******************* */
  12600: 'Извлечение текста',
  12601: 'Поддерживается загрузка не более одного файла, размер одного файла не более 20 МБ',
  12602: 'Поддерживается загрузка файлов в формате {-exts-}',
  12603: 'Поддерживается загрузка только файлов в формате {-exts-} размером менее 20 МБ',
  12604: 'Поддерживается загрузка только одного файла',
  12605: 'Повторное OCR',
  12606: 'Результаты распознавания',
  12607: 'Экспортировать в документ',
  12608: 'Результаты распознавания OCR',
  12609: 'Распознавание текста на изображении (OCR)',
  12610: 'Идет распознавание...',
  12611: 'Вы можете щелкнуть и вставить изображение сюда',
  12612: 'Повторить попытку',
  12613: 'Сохранить как документ',
  12614: '«Мы используем корпоративный облачный диск Бабельбёрд уже почти три года. Важные файлы и дизайн - проекты хранятся на Бабельбёрде, и мы совместно с командой Бабельбёрд разработали функцию библиотеки материалов для единого управления материалами и дизайном различных IP»',
  12615: '—— Руководитель IT - отдела POP MART: Лю Цзюньли',
  /////////////////************ai tag***************//////////////////// */

  12650: 'Автоматическая маркировка с помощью AI',
  12651: 'Автоматическая маркировка с помощью AI может автоматически подбирать наиболее подходящие теги для текущего файла из предустановленных тегов в библиотеке тегов. Вы также можете выбрать несколько файлов и применить автоматическую маркировку с помощью AI к ним одновременно.',
  12652: 'После успешной маркировки с каждого файла будет снято 1 единица вычислительной мощности Zhidian',
  12653: 'В вашей библиотеке тегов пока нет никаких тегов',
  12654: 'Автоматическая маркировка с помощью AI может автоматически подбирать наиболее подходящие теги для текущего файла из предустановленных тегов в вашей или корпоративной библиотеке тегов. Сначала вы можете добавить несколько тегов, а затем использовать функцию автоматической маркировки для маркировки файлов.',
  12655: 'Перейти к добавлению тегов',
  12656: 'Больше не показывать это напоминание',
  12657: 'Для данного типа файлов автоматическая маркировка с помощью AI пока не поддерживается',
  12658: 'Хотите, чтобы это поддерживалось в будущем? Нажмите, чтобы закрыть и отправить пожелание',
  12659: 'Осталось недостаточное количество вычислительной мощности Zhidian на текущем аккаунте. Пожалуйста, купите ее, чтобы продолжить использование',
  12660: 'Поддерживается выбор не более {-num-} файлов',
  12661: 'Идет массовая маркировка, пожалуйста, вернитесь позже для просмотра результатов',
  12662: "Язык",
  12663: "Файл заблокирован, операцию невозможно выполнить. Возможно, кто - то сейчас редактирует этот файл с помощью клиента. Нужно дождаться окончания редактирования и потом повторить попытку",
  /***************************9.3.0*********************************/
  13000: 'Babel AI',
  13001: 'Количество оставшихся токенов',
  13002: 'Количество использованных токенов',
  13003: 'Купить токены',
  13004: 'Один поиск AI примерно потребует 1000 токенов; обычный полнотекстовый поиск не потребляет токены',
  13005: 'Один поиск AI по изображению примерно потребует 10 000 токенов',
  13006: 'AI-ассистент потребляет 3k–10k токенов на вопрос в зависимости от вопроса',
  13007: 'Просмотреть детали использования',
  13008: 'Начиная с сегодняшнего дня наслаждайтесь изменениями, принесёнными AI',
  13009: 'Счёт',
  13010: 'Купить аккаунт',
  13011: 'Действителен до',
  13012: 'Нужен счёт-фактура? Нажмите для ввода',
  13013: 'Информация для счёта-фактуры',
  13014: 'Купленный продукт',
  13015: 'Покупка пакета токенов Babel AI',
  13016: 'Действителен до',
  13017: 'Один год',
  13018: 'Общая цена',
  13019: 'Оплатить сейчас',
  13020: 'Количество токенов для покупки',
  13021: 'Срок действия',
  13022: "Пожалуйста, введите правильный адрес электронной почты; после выдачи счёта-фактуры он будет отправлен на этот email",
  13023: 'Нужен счёт-фактура',
  13024: 'Время операции',
  13025: 'Доход/Расход',
  13026: 'Остаток',
  13027: 'Детали использования токенов',
  13028: 'Пользователь',
  13029: 'Разрешить использование AI',
  13030: 'При отключении вход в функции AI на интерфейсе пользователя не отображается; доступен только AI-поддержка',
  13031: "Перейти к оплате",
  13032: "Гнездо ИИ：",
  13033: "Поиск изображений",
  13034: "Искать текст ",
  13035: "Умное тело",
  13036: "Онлайн-служба поддержки BabeBird",
  13037: 'Гнездо ИИ',
  13038: 'Ваш личный корпоративный ассистент, отвечающий на любые вопросы, связанные с вашим предприятием',
  13039: 'Поиск с помощью ИИ',
  13040: 'Поиск изображений с помощью ИИ',
  13041: 'Введите свой вопрос, например, «Какова процедура оформления возмещения расходов?»',
  13042: 'Создание',
  13043: 'Создать интеллектуального консультанта',
  13044: 'ИИ-сущность, предоставляющая услуги консультирования внешним клиентам',
  13045: 'Создать робота-базу знаний',
  13046: 'Робот, отвечающий на конкретные вопросы',
  13047: 'Задавайте любые вопросы о BabeBird',
  13048: 'Внутреннее тестирование... Скоро появится, ждите!',
  13049: 'Перетащите изображение сюда или нажмите',
  13050: 'Извините, загруженный вами файл не в формате изображения, пожалуйста,',
  13051: 'загрузите заново',
  13052: 'Поддерживаются только файлы формата {-exts-} размером до 10 МБ',
  13053: 'Идет загрузка изображения...',
  13054: 'Загрузить с локального компьютера',
  13055: 'Нажмите здесь, чтобы найти изображение по описанию',
  13056: 'Нажмите здесь, чтобы найти похожие изображения по образцу',
  13057: 'Введите описание изображения или вставьте изображение сюда, поддерживается поиск по тексту и изображению',
  13058: 'Поиск изображений',
  13059: 'Загрузка завершена',
  13060: 'Пока нет подходящих изображений',
  13061: 'Посмотреть больше',
  13062: 'Извините, загруженный вами файл слишком большой, пожалуйста,',
  13063: 'Интеллектуальная база знаний',
  13064: 'Попробуйте еще раз',
  13065: 'Правила начисления счетов за использование системы Zhichao Dian',
  13066: 'Пункт начисления (за каждый раз)',
  13067: 'Списание баллов Zhichao Dian',
  13068: 'Посмотреть правила начисления счетов за использование баллов Zhichao Dian',
  13069: '10 000',
  13070: '1000',
  13071: 'Источник ссылки',
  13072: 'Копирование успешно',
  13073: 'Включить',
  13074: 'У вас недостаточно баллов Zhichao Dian для использования поиска с помощью ИИ, пожалуйста, купите баллы, чтобы продолжить',
  13075: 'Пожалуйста, подождите...',
  13076: 'Включить интеллектуальный поиск',
  13077: 'Введите описание изображения для поиска',
  //****************************excel ai********************* */
  13078: "Excel Поиск",
  13079: "Предварительный просмотр файла",
  13080: "Результаты анализа",
  13081: "Нажмите или перетащите файл для загрузки",
  13082: "Выбрать файл из моего облачного диска",
  13083: "Инструкция по требованиям к загрузке файла",
  13084: "Поддерживается загрузка не более трех файлов, размер одного файла не более 10 МБ<br>Поддерживаются форматы csv, xls, xlsx",
  13085: "В настоящее время поддерживается обработка только первых трех действительных листов таблицы",
  13086: "Попробуйте ввести запрос на анализ документа",
  13087: "Пожалуйста, выберите файл",
  13088: "Сохранить как изображение",
  13089: "Идет сохранение изображения",
  13090: "Сохранение успешно",
  13091: "Сохранение не удалось, пожалуйста, повторите попытку позже",
  13092: "Новый диалог",
  13093: "Hello！Добро пожаловать в Помощник по данным Excel, после загрузки документа вы можете попробовать задать вопрос:",
  13094: "Помогите рассчитать среднее значение XXX",
  13095: "Сравните таблицу XXX и таблицу XXX и проведите анализ",
  13096: "Проанализируйте тренд трафика XXX",
  13097: "Соберите результаты учеников, чьи баллы выше XXX",
  13098: "Извлеките данные XXX и создайте столбчатую диаграмму",
  13099: "Проанализируйте данные о продажах в июле и августе",
  13100: "Данные о росте и временной корреляции по регионам с 2014 по 2024 год",
  13101: "Подсчитайте денежный доход, где XXX равно XXX",
  13102: "Бабельбёрд Чжичао&nbsp;AI&nbsp;облачный диск",
  13103: "Позволяет вам",
  13104: "работать",
  13105: "Бабельбёрд Чжичао полностью интегрирован",
  13106: "AI-поиск",
  13107: "Изучает файлы, хранящиеся на облачном диске, строит граф знаний на основе содержания файлов и изображений, осуществляет поиск, запросы, ретривал, задает вопросы и пишет статьи в соответствии с правами доступа.",
  13108: "Интеллектуальный агент&nbsp;LLM&nbsp;Agent",
  13109: "Настраиваемый интеллектуальный агент, может изучать содержание облачного диска и автоматически обновляться, выполнять по требованию различные задачи, такие как обслуживание клиентов, сбор информации, обработка файлов…",
  13110: "AI-ассистент для предприятия",
  13111: "AI-ассистент, знакомый с вашим предприятием, предоставляет услуги в соответствии с правами доступа пользователя. Подключается к DeepSeek для ответа на вопросы предприятия, поиска файлов, написания статей.",
  13112: "Поиск изображения по изображению&nbsp;Поиск изображения по тексту",
  13113: "Поиск соответствующих изображений по описанию или демонстрационному изображению, предоставляет различные результаты в соответствии с правами доступа пользователя.",
  13114: "AI-база знаний",
  13115: "Изучает файлы предприятия и предоставляет ответы на вопросы по знаниям, позволяет настраивать источники знаний, поддерживает создание нескольких баз знаний.",
  13116: "Помощник по анализу данных",
  13117: "Анализирует структурированные данные, такие как excel, csv, предоставляет точные услуги по анализу данных, созданию диаграмм, запросам данных, классификации данных, поддерживает перекрестное сравнение нескольких таблиц.",
  13118: 'Пожалуйста, загрузите файлы с расширениями xls, xls, csv',
  13119: 'Пожалуйста, сначала выберите файл Excel',
  13120: 'В вашем личном каталоге у вас нет прав на загрузку файлов',
  //****************ai agent**************** */
  13200: "Мой AI-инструмент",
  13201: "Мой AI-инструмент",
  13202: "Созданные мной",
  13203: "Опубликовано",
  13204: "Не опубликовано",
  13205: "Поиск агента",
  13206: "Выберите тип агента",
  13207: "Бот-база знаний",
  13208: "Простая настройка для ответа на вопросы в определенной области",
  13209: "Бот-база знаний, может служить в качестве инструкции",
  13210: "Генерация длинного текста",
  13211: "AI-помощник для написания статей и задач по генерации текста",
  13212: "Интеллектуальная поддержка",
  13213: "Бот, который можно встроить на ваш веб-сайт для ответа на вопросы о продуктах вашим клиентам",
  13214: "Рабочий процесс",
  13215: "Автоматическая обработка файлов в определенной папке по определенным требованиям",
  13216: "Создано {-name-}",
  13217: "Название и иконка агента",
  13218: "Дайте агенту имя",
  13219: "Описание",
  13220: "(необязательно)",
  13221: "Введите описание приложения",
  13222: "Изменить иконку",
  13223: "Загрузить иконку",
  13224: "Предварительный просмотр иконки",
  13225: "Название агента не должно содержать специальных символов",
  13226: "Введите название агента",
  13227: "Не опубликовано",
  13228: "Опубликовано успешно",
  13229: "Настройки агента",
  13230: "Опубликовать агент",
  13231: "База знаний",
  13232: "Персонаж и логика ответа",
  13233: "Введите персонажа и логику ответа",
  13234: "Источник знаний",
  13235: "Вы уверены, что хотите удалить папку «{-name-}» из источника знаний?",
  13236: "Вступительная речь",
  13237: "Введите текст вступительной речи",
  13238: "Фоновое изображение",
  13239: "Отладка и предварительный просмотр",
  13240: "Мониторинг",
  13241: "Редактировать агент",
  13242: "Обновление успешно",
  13243: "Обновление не удалось",
  13244: "Добавьте фоновое изображение для вашего агента, чтобы диалог был более иммерсивным",
  13245: "Добавьте источник знаний к вашему интеллекту, источник знаний - это источник информации для базы знаний, которая читает файлы, а источник знаний может добавлять несколько. После добавления источника знаний необходимо подождать до 30 минут для хранения.",
  13246: "Видимость",
  13247: "Доступно всем",
  13248: "Доступно по ссылке",
  13249: "Закрыто",
  13250: "Опубликовать обновление",
  13251: "Запуск",
  13252: "Встроить на сайт (доступно всем)",
  13253: "Опубликовано успешно",
  13254: "Не опубликовано",
  13255: "Не найден источник знаний в базе знаний, добавьте источник знаний",
  13256: "Вы уже подписались на этого агента",
  13257: "Вы отписались от этого агента",
  13258: "ясно",
  13259: "Скопировать",
  13260: "Не удалось получить ссылку, повторите попытку позже",
  13261: "Удалить агент",
  13262: "Недавно использованные",
  13263: "Вы успешно удалили этого агента",
  13264: "Ошибка данных агента",
  13265: "Скопировать ссылку",
  13266: "Ссылка скопирована, поделитесь ею с друзьями!",
  13267: "Не найден источник знаний в базе знаний, добавьте источник знаний",
  15000: "Вы уверены, что хотите восстановить все файлы?",
  // ****************************** 7.9.5
  20000: "Обнаружен вход в ваш аккаунт с другого места:",
  20001: "Многократный вход в аккаунт",
  20002: "У вас нет прав на управление совместным использованием; пожалуйста, свяжитесь с инициатором! Если вы хотите получить адрес ссылки, используйте правую кнопку мыши в меню для получения адреса ссылки",
  20003: "Предприятие запрещает загрузку файлов этого типа!",
  // ****************************** 8.0
  20010: "Персональная версия не поддерживает онлайн-просмотр файлов этого типа, пожалуйста, обновитесь",
  20011: "Ссылку здесь можно распространять по email или QQ и другим средствам связи; лица, получившие эту ссылку, смогут получить доступ к файлу по ней.",
  20012: "Онлайн-редактирование Office требует покупки лицензии на онлайн-редактирование; вы можете бесплатно попробовать 30 дней, после истечения срока, если нужно продолжить использование, свяжитесь с нашими продавцами для покупки лицензии.",
  20013: "Файл не существует в указанном месте",
  // ***************************** transmittal
  20020: "Уважаемый {-name-}:",
  20021: "{-somebody-} отправил файл во внешний мир в проекте {-file-}, номер отправки {-transmittal-}",
  20022: "Эта отправка удалена",
  20023: "В папке нет файлов",
  20024: "Добро пожаловать в систему управления документами; просто перейдите по этой ссылке, чтобы использовать вашу почту и код подтверждения для просмотра отправленных вам файлов. Настоятельно рекомендуется сохранить эту ссылку для удобного просмотра в любое время",
  20025: "Номер отправки (Transmittal NO.) не может быть пустым",
  20026: "Список файлов не может быть пустым",
  20027: "Полученные файлы в этот раз",
  20028: "История получений",
  20029: "Версия",
  // 对应大写版本号
  20030: "Получатель и email обязательны",
  20031: "У получателя не установлен email",
  20032: "Вы уверены, что хотите удалить эти {-num-} отправок?",
  20033: "Нажмите для выбора email для входа",
  20034: "Получить код подтверждения email",
  20035: "Обнаружены следующие имена файлов, которые уже существуют; операция автоматически переименована:",
  20036: "{-oldName-} --> {-newName-}",
  20037: "Старое имя",
  20038: "Новое имя",
  20040: "<p>\u0412\u0435\u0440\u0441\u0438\u044F \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043B\u0438\u0435\u043D\u0442\u0430 \u0441\u043B\u0438\u0448\u043A\u043E\u043C \u043D\u0438\u0437\u043A\u0430\u044F, \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u043D\u043E\u0440\u043C\u0430\u043B\u044C\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0444\u0443\u043D\u043A\u0446\u0438\u0438 \u0432\u0440\u043E\u0434\u0435 Cloud Bridge \u0438 \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0430\u0446\u0438\u0438; \u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0441\u043A\u0430\u0447\u0430\u0439\u0442\u0435 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u044E\u044E \u0432\u0435\u0440\u0441\u0438\u044E \u043A\u043B\u0438\u0435\u043D\u0442\u0430 \u0441 \u043E\u0444\u0438\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0441\u0430\u0439\u0442\u0430.</p><p>\u0410\u0434\u0440\u0435\u0441 \u0441\u043A\u0430\u0447\u0438\u0432\u0430\u043D\u0438\u044F: <a style=\"margin-left: 0;\" href=\"https://www.babel.cc/p/download.do\" target=\"_blank\" >https://www.babel.cc/p/download.do</a></p>",
  20041: 'Ошибка создания пути папки "{-folder-}", попробуйте позже',
  20042: "Данные сессии недействительны!",
  // ***************************** release 8.2
  20050: "",
  20051: "Недостаточно доступного пространства; возможно, целевая папка для загрузки имеет ограничение по пространству, свяжитесь с администратором.",
  20052: ", всего {-fileNum-} файлов",
  20053: "У вас нет прав на создание папки",
  20054: "Подсказка по использованию",
  20055: "Обнаружено, что вы используете корпоративный WeChat для открытия облачного диска; для лучшего опыта рекомендуется использовать браузер.",
  20056: "Нажмите иконку «Открыть в браузере» в правом верхнем углу окна корпоративного WeChat, чтобы получить доступ через браузер",
  20057: "Эта корзина сбора файлов истекла, загрузка файлов невозможна",
  20058: "Аномалия файла, попробуйте позже или перезагрузите файл",
  // *****************************  release 8.3
  20100: 'Файл "{-fileName-}" уже существует в целевой папке, обновите список файлов для просмотра!  ',
  20101: "Нажмите для сброса пароля, чтобы установить пароль в фоновом режиме",
  20102: "Этот пользователь существует, но находится в спящем состоянии; нажмите OK, чтобы активировать и добавить в предприятие",
  // *****************************  release8.4
  20147: "Пожалуйста, откройте соответствующий отдел перед загрузкой файлов",
  20148: "Загрузка файлов не поддерживается в текущей директории файлов",
  20149: "Просмотреть больше сообщений",
  20150: "Область отдела",
  20151: "Создать отдел",
  20152: "Создать проект",
  20153: "Создать папку",
  20154: "Совместное использование {-file-} истекло и автоматически закрыто.",
  20155: "Совместное использование истекло и автоматически закрыто!",
  20156: "Ответственный за проект не может одновременно быть ассистентом!",
  20157: "статистика",
  20158: "Последняя посещенная папка",
  20159: "В процессе операции",
  20160: "Проверка на дубликаты файлов",
  20161: "Последняя выбранная папка",
  20162: "На сервере уже существует папка с таким именем, пожалуйста, переименуйте!",
  20163: "Данные неполные, пожалуйста, сообщите об этой проблеме",
  20170: "Только просмотр записей удаления",
  20171: "Анонимный доступ к видео запрещён, пожалуйста, войдите для просмотра",
  20172: "Настройки получения push-уведомлений",
  20173: "Недавно загруженные файлы проекта",
  20174: "Генерация отчёта в процессе, подождите",
  21000: "Игнорировать и продолжить загрузку",
  21001: "Количество файлов для загрузки превышает 500, что может замедлить систему и привести к сбою загрузки. Рекомендуется использовать функцию синхронизации клиента для пакетной загрузки файлов.",
  21002: "* После установки клиента правой кнопкой мыши на папке для загрузки выберите «Babel Bird — Синхронизировать папку»",
  21003: "Пожалуйста, введите email или номер телефона, используемый для входа, чтобы получить код подтверждения для сброса пароля. Если вы входите по номеру сотрудника, свяжитесь с администратором для сброса пароля.",
  21100: "Используется для отображения списка недавно загруженных файлов в указанной папке",
  // *********************************  release8.5.1
  21200: "Отправка файла {-file-} требует вашего утверждения",
  21201: "Ваша отправка файла {-file-} утверждена и успешно отправлена",
  21202: "Ваша отправка файла {-file-} не утверждена, отправка неудачна",
  21203: "Участники совместного использования файла {-file-} включают персонал конфиденциального отдела, требуется ваше утверждение",
  21204: "Конфиденциальная операция",
  21205: "Инициатор {-user-} отозвал этот запрос, сообщение недействительно",
  21206: "Участники проекта {-file-} включают персонал конфиденциального отдела, требуется ваше утверждение",
  21207: "Ссылка, к которой вы обращаетесь, не существует, или файл отменён для совместного использования, или у вас нет прав на просмотр файла!",
  21208: "Присоединение к совместному использованию требует утверждения корпоративного специалиста по конфиденциальности или администратора; запрос отправлен соответствующим лицам, подождите проверки!",
  21209: "Ваш запрос на присоединение к совместному использованию {-file-} утверждён",
  21210: "Ваш запрос на присоединение к совместному использованию {-file-} отклонён",
  21211: "Из-за вовлечения персонала конфиденциального отдела требуется дальнейшее утверждение корпоративного управления<br>Пожалуйста, подождите результата утверждения</br>",
  21212: "Инициация совместного использования участником",
  21213: "Присоединение участника к совместному использованию и проекту",
  21214: "Отправка файла участником",
  21215: "Утверждающий",
  21216: "Отправка файла участниками нескольких отделов",
  21217: "Требует утверждения",
  21218: "Специалист по безопасности и конфиденциальности или суперадминистратор",
  21219: "Утверждающий — специалист по безопасности и конфиденциальности или суперадминистратор",
  21220: "Не требует утверждения",
  21221: "Прямой руководитель",
  21222: "Совместное использование с персоналом других отделов требует утверждения",
  21223: "При совместном использовании или приглашении в проект персонала конфиденциального отдела требуется утверждение специалиста по безопасности и конфиденциальности или суперадминистратора.",
  21224: "В предприятиях с конфиденциальными отделами анонимная загрузка по ссылкам запрещена; создание открытых корзин сбора файлов запрещено.",
  21225: "Только отделы под политикой «Публичный» поддерживают совместное использование по ссылкам; другие политики поддерживают только приглашения для совместного использования;",
  21226: "Сверхсекретные файлы: по умолчанию, кроме создателя, ответственного за проект, ответственного за файл и менеджера отдела, другие в отделе не видят; совместное использование требует авторизации специалиста по конфиденциальности;",
  21227: "Ограниченные файлы: обычный персонал только для чтения, совместное использование требует авторизации прямого руководителя;",
  21228: "Внутренние файлы: совместное использование с персоналом вне отдела требует авторизации прямого руководителя;",
  21229: "Сверхсекретные файлы, ограниченные файлы: обычный персонал не может перемещать/копировать/загружать новые версии/скачивать/переименовывать/просматривать версии; только прямой руководитель и персонал с правами управления файлами отдела могут.",
  21230: "Операция неудачна, файл был сообщён!",
  21231: "Этот пользователь не может загружать файлы с текущего IP-адреса",
  21232: "",
  // ***************************************  release8.5.3
  21300: "{-somebody-} создал снимок совместного использования для {-file-}",
  21301: "Снимок",
  21302: "У вас нет прав на просмотр снимка совместного использования этого файла",
  21303: "Решение по заявке на права",
  21304: "Ваша заявка на права для файла {-file-} получила решение: {-result-}",
  21305: "Последняя версия этого файла всё ещё редактируется; отображается старая версия",
  21306: "Последняя версия этого файла всё ещё редактируется; скачивается старая версия",
  21307: "Скачать старую версию",
  // **************************************  release8.5.4
  21400: "Загрузки сегодня:",
  21401: "Скачивания сегодня:",
  21402: "Операция неудачна, содержит сверхсекретный отдел или его персонал",
  21403: "Количество персонала в текущем предприятии превысило авторизованное; пожалуйста, обработайте как можно скорее, чтобы не повлиять на вход и использование обычного персонала",
  21404: "Ошибка разблокировки, файл заблокирован другим пользователем!",
  21405: "Ошибка удаления, файл заблокирован другим пользователем!",
  21406: "Поиск в архиве, подтвердите Enter",
  ///////////////////////////////////////////////////////9.0.2/////////////////////////////////////

  21500: "Название политики повторяется, сохранение неудачно",
  21501: "Совместное использование с участниками вне отдела",
  21502: "Совместное использование с участниками вне проекта",
  21503: "{-somebody-} создал проект {-folder-} в {-parentFolder-}",
  21504: "{-somebody-} создал проект управления документами {-folder-} в {-parentFolder-}",
  21505: "Проект от {-user-}",
  21506: "Вы можете просмотреть этот файл в «Мои проекты»",
  21507: "Вы можете просмотреть этот файл в «Корзине сбора файлов»",
  21508: "В текущей папке уже существует папка с именем {-name-}; загрузка этой папки неудачна, пожалуйста, измените имя файла и загрузите заново",
  21509: "Игнорировать подсказку для следующих папок с таким именем (папки с таким именем по умолчанию не загружаются)",
  21510: "Обнаружена папка с таким именем",
  21511: "Управление отделами",
  21512: "Количество файлов превышает {-limit-}, снимок совместного использования не поддерживается; пожалуйста, используйте обычную функцию совместного использования",
  21513: "Статистика использования",
  21514: "Расчёт в процессе, подождите",
  21515: "Занятое пространство предприятия  ",
  21516: "После удаления шаблонной папки отдела она не попадёт в корзину, а будет удалена напрямую; вы уверены в удалении?",
  21517: "Babel Bird White Paper.pdf",
  21518: "Отделы, в которых я участвую",
  21519: "Общеоблачная версия в настоящее время не поддерживает онлайн-воспроизведение видео этого формата; вы можете скачать для воспроизведения или связаться с поддержкой для выбора частного развёртывания",
  21520: "Только папки",
  21521: "Корзина",
  21522: "Управление удалёнными файлами предприятия",
  21523: "Отдел, к которому принадлежит файл",
  21524: "Отдел утверждения удаления",
  21525: "Цвет темы",
  21526: "Как в системе",
  21527: "Тёмный",
  21528: "Светлый",
  21529: "Ваша корпоративная идентичность изменилась, новая корпоративная идентичность: {-name-}",
  // 21529: "Ваша корпоративная идентичность изменилась!",
  21530: "Локальное редактирование",
  21531: "Открыть локально только для чтения",
  21532: "Участники отдела",
  // 21525: "",
  // 21525: "",
  // 21525: "",

  //********************cad************************************** */
  21550: "Подготовка данных для предварительного просмотра",
  21551: "Сервер кодирует, подождите и попробуйте заново",
  21552: "Ошибка скачивания чертежа",
  21553: "Загрузка",
  // ************************************* release 8.7.1
  21601: "Просмотреть историю входов",
  21602: "Просмотреть участвующие совместные использования",
  21603: "IP",
  21604: "Тип устройства",
  21605: "Имя устройства",
  21606: "Этот аккаунт входит с другого места, IP: {-ip-}; если это не вы, пожалуйста, измените пароль как можно скорее и выкиньте его в интерфейсе управления устройствами в личных настройках",
  21607: "Нет истории входов",
  21608: "Подсказка: этот человек никогда не входил в систему",
  21609: "Просмотреть участвующие специальные файлы",
  21610: "Нет участвующих файлов специального контроля доступа",
  21611: "Просмотреть участвующие совместные использования",
  21612: "Просмотреть участвующие проекты",
  21613: "Список файлов участвующих совместных использований",
  21614: "Нет участвующих совместных использований",
  21615: "Нет участвующих проектов",
  21616: "Список файлов участвующих проектов"
}, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, "21611", "Просмотреть участвующие совместные использования"), "21612", "Просмотреть участвующие проекты"), "21613", "Список файлов участвующих совместных использований"), "21614", "Нет участвующих совместных использований"), "21615", "Нет участвующих проектов"), "21616", "Список файлов участвующих проектов"), 21617, "Превышено ограничение по количеству, суперадминистратор получит напоминание по email или SMS"), 21650, "Все теги"), 21700, "Версия клиента слишком низкая, пожалуйста, скачайте последнюю версию клиента для завершения скачивания"), 21800, "Корпоративные теги"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 21801, "Личные теги"), 21802, "Система поддерживает максимум {-maxTerminals-} устройств онлайн одновременно"), 21900, "Объединение"), 21901, "Пересечение"), 21902, "Симметрическая разность"), 21903, "Без тегов"), 21904, "минут"), 21905, "часов"), 21906, "дней"), 21907, "недель"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 21908, "месяцев"), 21909, "Недавно"), 21910, "Более"), 21911, "До"), 21912, "По настоящее время"), 21913, "Недавно {-time-} {-unit-}"), 21914, "{-time-} {-unit-} назад"), 21915, "С {-start-} по {-end-}"), 21916, "В"), 21917, "И"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 21918, "Между"), 21919, "Мои удалённые файлы"), 21920, "Удалённые файлы других"), 21921, "Доступен только персоналу предприятия"), 21922, "Настроить утверждение для совместного использования"), 21923, "Операции с файлами, требующие утверждения"), 21924, "Совместное использование файлов"), 21925, "Отправка файлов"), 21926, "Утверждающий персонал"), 21927, "Добавить утверждающего персонал"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 21928, "Очистить элемент конфигурации"), 21929, "{-user-} установил в {-time-}"), 21930, "Подать заявку на права «{-roleName-}» для файла {-file-}"), 21931, "Отправка файла требует вашего утверждения"), 21932, "Администратор может добавить процесс утверждения в разделе «Корпоративная консоль — Конфигурация файлов»"), 21933, "Без места"), 21934, "Для любого файла в текущей папке, если есть конфиденциальные требования, здесь можно настроить уведомление соответствующего персонала для утверждения при совместном использовании или отправке файлов"), 21935, "После прохождения этого этапа положение файла:"), 21936, "Текущее положение (не перемещать файл)"), 21937, "Переместить в выбранную папку"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 21938, "После окончания этого этапа переместить файл в:"), 21939, "Белый список файлов"), 21940, "Белый список файлов, то есть белый список типов файлов; типы файлов в белом списке могут быть загружены только если они в белом списке; введите расширения файлов, которые вы хотите загрузить, в список ниже"), 21941, "Пожалуйста, введите расширения файлов для добавления в белый список, например jpg"), 21942, "Список белого списка"), 21943, "Приоритет белого списка выше чёрного списка; если тип файла в списке белого списка, чёрный список не применяется. Белый список, установленный на уровне отдела или проекта, имеет приоритет над этим белым списком."), 21944, "Пожалуйста, выберите политику безопасности"), 21945, "Отправка файлов в этот раз требует утверждения; после утверждения отправка выполнится автоматически"), 21946, "Модуль онлайн-просмотра CAD не установлен. Для просмотра файлов DWG свяжитесь с администратором предприятия"), 21947, "Текущее положение (не перемещать файл)"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 21948, "Целевая папка удалена"), 21949, "（веб-версия не ограничена）"), 21950, "Пакетное переименование"), 21951, "Количество файлов"), 21952, "Способ переименования"), 21953, "Пользовательский"), 21954, "Замена"), 21955, "Вставка"), 21956, "Удаление"), 21957, "Переименование по времени"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 21958, "Новое имя файла"), 21959, "Преобразование регистра"), 21960, "Без изменений"), 21961, "Все заглавные"), 21962, "Все строчные"), 21963, "Первая буква заглавная"), 21964, "Первая буква строчная"), 21965, "Пожалуйста, введите новое имя файла"), 21966, "Настройки нумерации"), 21967, "Начало"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 21968, "Первый номер"), 21969, "Приращение"), 21970, "Увеличиваемое число"), 21971, "Количество цифр"), 21972, "Общее количество цифр в номере"), 21973, "Начать пакетное переименование"), 21974, "Исходное имя файла"), 21975, "Новое имя файла"), 21976, "Статус"), 21977, "Источник имени"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 21978, "Время создания файла"), 21979, "Время изменения файла"), 21980, "Текущее время"), 21981, "Формат времени"), 21982, "yyyy年mm月dd日HH时mm分"), 21983, "Положение вставки времени"), 21984, "Начало имени файла"), 21985, "Конец имени файла"), 21986, "Удалить имя файла"), 21987, "Удалить имя файла и добавить нумерацию"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 21988, "yyyy年MM月dd日HH时mm分"), 21989, "Положение вставки"), 21990, "Тип вставки"), 21991, "Пользовательское содержимое"), 21992, "Нумерация"), 21993, "Вставляемое содержимое"), 21994, "Искомое содержимое"), 21995, "Заменяемое содержимое"), 21996, "По положению в имени файла"), 21997, "Пробелы в имени файла"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 21998, "Цифры в имени файла"), 21999, "Кавычки в имени файла"), 22000, "Тип удаления"), 22001, "Начальная позиция"), 22002, "Длина"), 22003, "Удаляемое содержимое"), 22004, "Атрибуты файла"), 22005, "Создатель файла"), 22006, "Ответственный за файл"), 22007, "Последний редактор версии"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 22008, "Вставить атрибуты файла"), 22009, "В ожидании операции"), 22010, "Файл начинает переименование, подождите"), 22011, "Переименование файла завершено"), 22012, "Имя файла слишком длинное"), 22013, "Вы можете правой кнопкой мыши использовать локальный просмотр CAD<br/>Для онлайн-просмотра требуется покупка модуля онлайн-просмотра CAD"), 22014, "Просмотреть устройства входа"), 22015, "Данные сервера для текущего списка файлов изменились<br/>Обновить интерфейс для просмотра последних данных?"), 22016, "Можно открыть для просмотра с помощью правой кнопки мыши «Локальное редактирование»"), 22017, "Ошибка скачивания"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 22018, "Файл в процессе онлайн-редактирования"), 22019, "Старая версия клиента Win"), 22020, "Клиент для Linux"), 22021, "Ubuntu, Tongxin UOS, Kylin"), 22022, "Испытание"), 22050, "Просмотреть файлы совместного использования"), 22051, "Ошибка загрузки"), 22052, "Нет файлов совместного использования"), 22053, "Все файлы совместного использования в папке"), 22054, "В текущей папке нет открытых файлов (папок) для совместного использования"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 22055, "Закрытие совместного использования в процессе..."), 22056, "Добавить папку"), 23000, "Принудительное обновление пароля"), 24000, "Сообщения библиотеки материалов"), 24001, "Заявка на создание категории «{-file-}» в библиотеке материалов"), 24002, "Заявка на создание подбиблиотеки материалов «{-file-}» в библиотеке материалов"), 24003, "{-name-}  подал заявку на создание следующих категорий в  {-type-} «{-file-}»"), 24004, "{-result-} вашу заявку на создание категории «{-file-}»"), 24005, "{-result-} вашу заявку на создание подбиблиотеки материалов «{-file-}»"), 24006, "{-name-}  подал заявку на создание следующих библиотек материалов в  {-type-} «{-file-}»"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 24007, "{-name-}  подал заявку на доступ к {-type-} «{-file-}»"), 24010, "Срок действия видимости библиотеки материалов «{-name-}» ({-accessType-}) истёк; видимость автоматически установлена в ({-nextAccessType-}) по предустановке, требуется ваше утверждение"), 24011, "Срок действия видимости библиотеки материалов «{-name-}» истёк; видимость автоматически установлена в ({-accessType-}) по предустановке"), 24012, "Заявка на скачивание файлов (папок) из библиотеки материалов, таких как «{-name-}»"), 24013, "Ваша заявка на скачивание файлов (папок) из библиотеки материалов, таких как «{-name-}», {-result-} администратором"), 24014, "{-result-} вашу заявку на доступ к категории «{-file-}»"), 24015, "{-result-} вашу заявку на доступ к подбиблиотеке материалов «{-file-}»"), 24016, "Онлайн-редактирование завершено и отправлено, <br/>обновить для просмотра последней версии?"), 24017, "Создана категория «{-file-}» в библиотеке материалов"), 24018, "Создана подбиблиотека материалов «{-file-}» в библиотеке материалов"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 24019, "Изменены настройки отдела «{-file-}»"), 24020, "Категория материалов"), 24021, "Подбиблиотека материалов"), 24022, "Онлайн-просмотр файлов этого типа не поддерживается"), 24023, "Заявка на присоединение к подбиблиотеке материалов «{-name-}»"), 24024, "{-result-} вашу заявку на присоединение к подбиблиотеке материалов «{-file-}»"), 24025, "Заявка на присоединение к библиотеке материалов"), 24026, "Библиотека материалов"), 'AI_SEARCH', "Поиск с помощью ИИ"), 'WORD_S_IMAGE', "Поиск изображения по тексту"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 'IMAGE_S_IMAGE', "Поиск изображения по изображению"), 'AI_TALK', "Диалог с ИИ"), 'IMAGE_OCR', "OCR-распознавание изображений"), 'DOC_ASSISTANT', "Помощник по документам"), 'SPREAD_SHEETS', "Вопросы и ответы по таблицам"), 'buy tokens', "Покупка баллов Zhichao Dian"), 'DEEP_SEARCH', "Глубокое мышление (Deepseek-R1)"), 'ONLINE_SERCH', "Поиск в сети"), 'DEEP_RESEARCH', "Глубокое исследование"), 24100, "Вернуться к последней версии"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 24101, 'Здесь можно описать изображение для поиска, например, «фон — голубое небо с облаками»'), 24102, 'В вашем предприятии есть старые данные, которые нужно обработать с помощью ИИ. Обработать сейчас?'), 24103, "У вас лично есть старые данные, которые нужно обработать с помощью ИИ. Обработать сейчас?"), 24104, "Обработка личных файлов..."), 24105, "Обработка корпоративных файлов..."), 24106, "Обработка личных файлов завершена"), 24107, "Обработка корпоративных файлов завершена"), 24108, "Личных файлов в ожидании обработки: {-count-}"), 24109, "Корпоративных файлов в ожидании обработки: {-count-}"), 24110, "Обработка исторических данных ИИ"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 24111, "Обработка завершена"), 24112, 'Остаток баллов Zhichao Dian у предприятия'), 24113, 'Скопировать в формате markdown'), 25000, "Добавить авторизованных сотрудников"), 25001, "Только просмотр при входе в систему"), 26000, "Напиши статью для публичного аккаунта"), 26001, "Что может делать Zhichao AI"), 26002, 'Резюмируй «Белую книгу»'), 26003, "Какие этапы входа в компанию?"), 26004, "Найти все изображения с морем"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 26005, "Какие основные продукты у нашей компании?"), 26006, "Привет! Ты можешь спросить меня"), 26007, "Попробуй ввести вопрос, чтобы начать диалог"), 26008, "Глубокое мышление"), 26009, "Поиск в сети"), 26010, "Мышление..."), 26011, "Глубокое мышление завершено, время ({-num-}) секунд"), 26012, "Новый диалог"), 26013, "Глубокое мышление проведено"), 26014, "Ответ завершен, время ({-num-}) секунд"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 26015, "Ответ завершен"), 26016, "Время ответа истекло, повторите попытку позже"), 26017, "Кратко опиши это изображение"), 26018, "Покажи текст, присутствующий на изображении"), 26019, "Найдено {-num-} источников"), 26020, "Быстрый поиск"), 26021, "Адаптация к каждому запросу"), 26022, "Глубокое исследование"), 26023, "Подробный отчет по сложной теме"), 26024, "Поиск исторических сеансов"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 26025, "Сегодня"), 26026, "На этой неделе"), 26027, "В этом месяце"), 26028, "В этом году"), 26029, "Понедельник"), 26030, "Вторник"), 26031, "Среда"), 26032, "Четверг"), 26033, "Пятница"), 26034, "Суббота"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 26035, "Воскресенье"), 26036, "Исторические сеансы"), 26037, "Идет поиск, пожалуйста, подождите"), 26038, 'Осталось баллов Zhichao Dian: {-num-}'), 26039, 'Баллы Zhichao Dian'), 26040, 'Поддерживаются только файлы форматов csv, xls, xlsx размером до 10 МБ'), 26050, 'Глубокий поиск занимает много времени. Выпите кофе, оставьте все остальное Zhichao AI и вернитесь к этому интерфейсу через несколько минут...'), 26051, "Начинается поиск, пожалуйста, подождите"), 26052, "Найти похожие"), 26053, "Поиск похожих изображений"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 27000, "Создать файл-ссылку"), 27001, "Ссылка"), 27002, "Название"), 27003, "Миниатюра"), 27004, "Ошибка создания файла-ссылки"), 27005, "Открыть ссылку"), 27006, "Файл-ссылка успешно создан"), 27007, "Создание подбиблиотеки материалов посетителями, кроме администраторов, требует утверждения"), 27008, "Введите адрес ссылки"), 27009, "Укажите название для файла-ссылки"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 27010, "Неверный формат ссылки"), 27011, "Редактировать файл-ссылку"), 27012, "Отображать содержимое подпапок"), 27013, "Файл-ссылка успешно отредактирован"), 27014, "Размер файла превышает лимит 5 МБ, пожалуйста, выберите меньший файл"), 27015, "Ошибка редактирования файла-ссылки"), 27016, "Файлы-ссылки не поддерживают скачивание"), 27017, "Зашифрованная папка"), 27018, "Создать зашифрованную папку"), 27019, "Зашифрованная папка Babel Bird использует асимметричное шифрование; пароль, который вы установите, — единственный способ открыть эту папку."), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 27020, "Пожалуйста, введите название"), 27021, "Нажмите для ввода названия папки"), 27022, "Пожалуйста, надёжно храните ваш пароль"), 27023, "Пароль нельзя восстановить после потери! И после потери пароля файлы в папке нельзя восстановить"), 27024, "Нажмите для ввода вашего пароля"), 27025, "Введите пароль заново"), 27026, "Пароль должен быть комбинацией 6–20 заглавных/строчных букв или цифр"), 27027, "* После шифрования папки файлы внутри нельзя синхронизировать или получить доступ через сетевой диск"), 27028, "Пожалуйста, введите комбинацию из 6–20 заглавных/строчных букв или цифр"), 27029, "Введите пароль зашифрованной папки"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 27030, "Введите пароль зашифрованной папки «{-name-}»"), 27031, ""), 27032, ""), 27033, ""), 27100, "Установить срок хранения версий файлов предприятия в {-time-} дней"), 27101, "Установить количество хранимых версий файлов предприятия в {-num-} штук"), 28000, "Автоматизированные задачи"), 28001, "Просмотреть список существующих задач"), 28002, "Автоматическая очистка файлов"), 28003, "Автоматическое переименование"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 28004, "Автоматический поворот PDF"), 28005, "Автоматическая сортировка документов"), 28006, "Задачи могут быть установлены для удаления файлов из указанной папки в соответствии с определенными правилами"), 28007, "Файлы, загруженные в указанную папку, автоматически переименовываются в соответствии с установленными правилами"), 28008, "Файлы, загруженные в указанную папку, могут автоматически генерировать PDF - копии"), 28009, "Классификация и сортировка файлов по заранее установленным правилам в указанной папке"), 28010, "Миссия"), 28011, "Автоматическая очистка папок"), 28012, "Создать папку автоматической очистки"), 28013, "Выберите папку цели"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 28014, "Нажмите, чтобы выбрать папку"), 28015, "Включает все файлы в подкаталоги"), 28016, "Если в подкаталоге также установлена задача очистки, очистите наложение задач"), 28017, "Выберите триггерные условия очистки"), 28018, "Советы выпадающего меню: выберите условия запуска"), 28019, "Изменить папку"), 28020, "После учреждения миссии"), 28021, "Файл входит в эту папку (после загрузки файла)"), 28022, "Количество документов"), 28023, "Размер папки"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 28024, "Удалить только файлы, не удалять подкаталоги"), 28025, "Выберите условия запуска"), 28026, "Выберите режим времени"), 28027, "Фиксированный временной интервал"), 28028, "По циклу"), 28029, "Все файлы (по умолчанию)"), 28030, "Определенный размер"), 28031, "Конкретный тип файла"), 28032, "Ключевое слово"), 28033, "Повторяющийся файл"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 28034, "Автоматическое удаление файла"), 28035, "Каждые"), 28036, "Выберите диапазон для удаления файлов"), 28037, "Автоматически очистить папку"), 28038, "Удалить файл с именем файла, содержащим следующие ключевые слова"), 28039, "Документы, содержание которых совпадает, сохраняют только один"), 28040, "Заполните здесь расширение, которое требует удаления типа файла, между несколькими расширениями, чтобы, разделить, например: jpg, png, mp4 (без различия размера записи)"), 28041, 'Заполните здесь ключевые слова, содержащиеся в названии файла, который необходимо удалить, чтоб "," разделить'), 28042, "Автоматическое удаление файлов определенного размера"), 28043, "Удалить размер"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 28044, "До"), 28045, "Документы"), 28046, "Автоматически удалить файл с расширением"), 28047, "Каждый день"), 28048, "Каждое воскресенье"), 28049, "Частота очистки"), 28050, "Первое воскресенье месяца"), 28051, "Ежегодно 31 декабря"), 28052, "Выберите время"), 28053, "Время"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 28054, "Включает файлы в подкаталоги"), 28055, "Общее количество документов превышает"), 28056, "Заполните число триггерных условий, минимум 1 максимум 99999"), 28057, "Общий размер файла превышает"), 28058, "Выберите условия запуска для очистки"), 28059, "Редактировать автоматическую очистку"), 28060, "Секунда"), 28061, "Год"), 28062, "Целевая папка"), 28063, "Отменить миссию"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 28064, "Нет задач автоматизации"), 28065, "Список задач автоматизации"), 28066, "Имя папки (имя задачи)"), 28067, "Тип миссии"), 28068, "Автоматическая очистка"), 28069, "Вы хотите отменить эту автоматизированную задачу, больше не выполняете"), 28070, "Автоматизация"), 28071, "Создание задачи автоматического переименования"), 28072, "Автоматическое переименование"), 28073, "Файл автоматически переименовывается после добавления в следующую папку"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 28074, "Применяется к существующим документам"), 28075, "Не применяется, если количество документов превышает 1000"), 28076, "Примерное имя файла"), 28077, "Не все правила или метаданные применимы или могут быть использованы для каждого файла или типа файла"), 28078, "Правила выбора"), 28079, "Стандартные опции"), 28080, "Номер"), 28081, "Пользовательский контент"), 28082, "Загрузчик файлов"), 28083, "Руководитель документации"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 28084, "Папка сверху"), 28085, "Время загрузки"), 28086, "Медиа метаданные"), 28087, "Дата съемки"), 28088, "Производитель камеры"), 28089, "Модель камеры"), 28090, "Модель объектива"), 28091, "Размер"), 28092, "Количество пунктов на дюйм (DPI)"), 28093, "Количество пунктов на сантиметр (DPCM)"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 28094, "Добавить правило"), 28095, "Выберите правило изменения имени файла"), 28096, "Заменить содержимое"), 28097, "Удалить содержимое"), 28098, "Удалить символ"), 28099, "Оригинальное имя файла"), 28100, "Введите ключевое слово для замены"), 28101, "Введите замещающее содержимое"), 28102, "Введите содержимое для удаления"), 28103, "Пробелы в названии файла"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 28104, "Цифры в названии файла"), 28105, "кавычки в названии файла"), 28106, "Ломки и подчёркивание в названии файла"), 28107, "Начало:"), 28108, "Прирост:"), 28109, "Цифры:"), 28110, "Начало: обозначает приращение первого номера \n число добавленных \n цифр: число номеров"), 2811, "Нажмите, чтобы заполнить пользовательский контент"), 28112, "Год - месяц - день"), 28113, "Год - месяц"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 28114, "День месяца года"), 28115, "Год - месяц - день - час. мин."), 28116, "Год, месяц, день - час, минута"), 28117, "Месяц - день - час. мин. сек"), 28118, "Заменить дату, обнаруженную в имени файла"), 28119, "Преобразование в регистр"), 28120, "Заглавные буквы"), 28121, "Нижний регистр"), 28122, "Все с большой буквы"), 28123, "Все в нижнем регистре"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 28124, "Разделитель слов"), 28125, "Пробелы"), 28126, "Подчеркнуто"), 28127, "Слом"), 28128, "Изменить задачу автоматического переименования"), 28129, "Новая автоматизированная отделка"), 28130, "Ведение документооборота"), 28131, "Редактирование задач автоматической сортировки"), 28132, "Выбор правил сортировки"), 28133, "Классификация по месяцам"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 28134, "оздать папку и переместить файл в папку изменения"), 28135, "Классификация по годам"), 28136, "оздайте папку по году добавления в сетку и переместите файл в папку"), 28137, "Классификация ключевых слов"), 28138, "ереместить файл в определенную папку в соответствии с определенным ключевым словом, содержащимся в названии файла"), 28139, "лассифицировать файлы по ключевым словам, содержащимся в названии файла, и обрабатывать их в порядке выполнения заданий"), 28140, "Добавить классификацию ключевых слов"), 28141, "Переместить файл в"), 28142, "Выберите папку"), 28143, "Введите ключевое слово"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 28144, "Имя папки"), 28145, "Пожалуйста, выберите папку"), 28146, "Ключевое слово не может быть повторено"), 28147, "Файл может быть автоматически преобразован в PDF - файл после добавления в выбранный каталог"), 28148, "Новый автоматический поворот PDF"), 28149, "Редактирование автоматического преобразования PDF"), 28150, "Выберите тип файла для преобразования PDF"), 28151, "Все поддерживаемые документы"), 28152, "Преобразование в PDF"), 28153, "Файлы, превышающие 30М, не будут преобразованы"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 28154, "Удалить исходный файл после успешного преобразования"), 28155, "Категория фотографий"), 28156, "Класс документов"), 28157, "Графический класс"), 28158, "Отменить все выборы"), 28159, "Выбран тип файла {-exts-} {-num-}"), 28160, "Выбран тип файла {-exts-}... и т. д. {-num-}"), 28161, "Пожалуйста, выберите тип файла для перехода в PDF"), 28162, "Применяется к новым папкам загрузки"), 28163, "Введите имя файла для поиска в текущем каталоге"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 28164, "Сохранить два десятичных знака"), 28165, "У вас нет прав перемещать файлы из текущей папки в целевую папку"), 28166, "Вы можете выбрать одного или нескольких из указанных ниже утверждающих для одобрения вашего запроса на обмен. При этом, если хотя бы один из них одобрит ваш запрос, система автоматически отправит приглашение."), 28167, "У приглашенных вами участников совместного доступа есть внешние пользователи, которые могут быть приглашены только после утверждения. Вы можете заполнить список предполагаемых приглашаемых для отправки запроса на приглашение."), 28168, ""), 28169, ""), 28170, "Создать печать"), 28171, "Вы можете ставить печать и подписывать документы в облачном хранилище, поддерживаются различные типы файлов, подписанные документы можно экспортировать в формат PDF"), 28172, "Как использовать печать?"), 28173, "Нажмите, чтобы просмотреть учебник по использованию печати"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 28174, "Пакетное создание папок"), 28175, "Пакетно создавать папки, импортируя файлы excel в соответствии с требованиями"), 28176, "Выберите целевой каталог для пакетного создания папок, проектные файлы могут создаваться только в корневом каталоге папок отдела и личных файлов"), 28177, "Выберите тип создаваемой папки"), 28178, "Импортировать список названий папок"), 28179, "Названия папок разделяются переносом строки, одно название папки в строке. Поддерживаемые типы импортируемых файлов: xls, xlsx, максимальное ограничение 5000 строк"), 28180, "Проектные папки"), 28181, "После загрузки шаблона заполните его в соответствии с шаблоном. Если ответственный за проект не указан, то создатель по умолчанию является ответственным за проект. Названия проектных папок разделяются переносом строки, одно название папки в строке. Ответственный за проект указывается по почте и номеру телефона. Поддерживаемые типы импортируемых файлов: xls, xlsx, csv, максимальное ограничение 5000 строк."), 28182, "Нажмите здесь, чтобы загрузить шаблон для пакетного создания проектных папок"), 28183, "Нажмите здесь, чтобы загрузить шаблон для пакетного создания папок"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 28184, "Нажмите или перетащите файл для загрузки"), 28185, "Включить распознавание чувствительного содержания"), 28186, "Список файлов с чувствительным содержанием"), 28187, "Пользовательские чувствительные слова"), 28188, "Введите здесь чувствительные слова, которые нужно распознавать"), 28189, "Распознавание чувствительного содержания"), 28190, "Введите выше чувствительные слова, которые нужно распознавать, не более 500 слов, каждое слово не более 10 символов, разделяйте слова запятыми или пробелами"), 28191, "Загрузить словарь чувствительных слов"), 28192, "Нажмите кнопку загрузки, чтобы загрузить словарь чувствительных слов, он вступит в силу в течение 30 минут после загрузки."), 28193, "Файл должен быть в формате TXT, не более 500 слов, каждое слово не более 10 символов, размер файла не более 100 КБ, кодировка UTF-8 (без BOM), разделяйте слова запятыми, пробелами или переносом строки."), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 28194, "Стратегия обработки файлов с чувствительными словами"), 28195, "Только отметить (отметить файлы с чувствительными словами)"), 28196, "Запретить просмотр и редактирование (заменить на предупреждающее изображение о чувствительных словах)"), 28197, "Запретить общий доступ (общий доступ к файлам с чувствительными словами будет автоматически отключен)"), 28198, "Список файлов с чувствительными словами"), 28199, "Введите название файла или ключевое слово для поиска"), 28200, "Не загружено"), 28201, "Удалить файл"), 28202, "Принадлежность файла"), 28203, "Пока нет файлов с чувствительными словами"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 28204, "Пожалуйста, загрузите файл в формате .txt!"), 28205, "Загрузить повторно"), 28206, "Загруженный вами словарь чувствительных слов не соответствует системным требованиям, пожалуйста, отредактируйте его в соответствии с требованиями и загрузите повторно"), 28207, "Общий доступ с внешними пользователями не требует одобрения"), 28208, "После включения можно вводить почту и номер телефона пользователей, не являющихся сотрудниками предприятия, при приглашении к общему доступу и включать общий доступ по внешней ссылке"), 28209, "Общий доступ с внешними пользователями требует одобрения"), 28210, "Добавить пользователя для внешнего обмена, можно выбрать утверждающего, нажмите для добавления утверждающего"), 28211, "Нажмите, чтобы добавить одобряющих"), 28212, "Список одобряющих"), 28213, "Вы уверены, что хотите удалить этого пользователя из списка одобряющих?"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 28214, "Выбрать одобряющего"), 28215, "Разрешить отделу предоставлять общий доступ с внешними пользователями"), 28216, "В список одобряющих может входить не более 5 членов"), 28217, "Вы можете выбрать одного или нескольких одобряющих из списка ниже для одобрения вашего запроса на общий доступ, после того как любой из них одобрит ваш запрос, система автоматически отправит приглашение"), 28218, "Вы пригласили пользователей, не являющихся сотрудниками предприятия, для предоставления общего доступа необходимо одобрение."), 28219, "Пожалуйста, сначала загрузите шаблонный файл, необходимый для создания"), 28220, "Не удалось разобрать шаблонный файл"), 28221, "Идет разбор шаблонного файла"), 28222, "Импортированное название папки"), 28223, "Всего импортировано {-total-} папок, из них {-num-} папок не удалось импортировать из-за несоответствия названия требованиям"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 28224, "Начать создание"), 28225, "Этот файл является чувствительным, доступ к нему ограничен"), 28226, "Публикация предприятия"), 28227, "Пожалуйста, выберите одобряющего"), 28228, "Инструменты управления"), 28229, "После закрытия общего доступа по ссылке его повторное включение требует одобрения администратора файлов, вы уверены, что хотите закрыть общий доступ по этой ссылке?"), 28230, "Неименованный узел (можно переименовать, щелкнув правой кнопкой мыши)"), 28231, "Вы можете щелкнуть правой кнопкой мыши на узле файлового каталога, чтобы открыть меню и выполнить операции создания, удаления, переименования, если создание не удалось, можно отредактировать и попробовать создать заново"), 28232, "Идет создание, пожалуйста, подождите завершения и повторите попытку"), 28233, "(проигнорировано)"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 28234, "Вы уверены, что хотите проигнорировать этот файл? Эта операция необратима."), 28235, "Вы уверены, что хотите удалить этот файл?"), 28236, "Пользовательские чувствительные слова изменились, сохранить изменения на сервер?"), 28237, "Пожалуйста, загрузите файлы .xlsx, .xls"), 28238, "Загруженная структура каталога пуста, пожалуйста, отредактируйте и загрузите заново"), 28239, "В пользовательских чувствительных словах содержатся специальные символы"), 28240, "Не допускается внешний доступ"), 28241, "Запрещается пользователям самостоятельно изменять личную информацию"), 28242, "При включении этого параметра члены компании не могут самостоятельно изменять личные данные через интерфейс настроек"), 28243, 'После установки этого параметра для обмена личными файлами пользователя здесь будет применяться данная конфигурация, которая перезапишет настройку предприятия "Запретить обмен файлами с пользователями вне предприятия".'), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 28244, "(предприятие разрешает)"), 28245, "(предприятия не допускаются)"), 28246, "(наследование настроек вышестоящего подразделения)"), 28247, "Предприятие запрещает изменять эту информацию"), 28248, "Файл содержит конфиденциальные слова, установленные администратором, доступ к которым запрещен"), 28249, "Только корпоративная версия поддерживает эту функцию"), 28250, "Бесплатная версия не поддерживает эту функцию. Эту функцию можно обновить до профессиональной или корпоративной версии"), 28300, "Выберите тип водяного знака"), 28301, "Горизонтальная плитка"), 28302, "Центр одиночный"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 28303, "Введите пользовательский текст в качестве содержимого водяного знака, поддерживает синхронное отображение на нескольких терминалах."), 28304, "Загрузка PNG-изображений с прозрачным фоном даёт наилучший эффект. Пожалуйста, контролируйте размер исходного изображения."), 28305, "Использовать графический (векторный) водяной знак"), 28306, "Использует графическое векторное кодирование для переноса Hex-кодов признаков. Скриншоты можно отследить с помощью проявки и таблиц кодирования."), 28307, "Код признака (Hex, 8 цифр)"), 28308, "Анти-изменяющий движок"), 28309, "Серия естественной распознаваемости"), 28310, "Серия Anti-AI скрытой защиты"), 28311, "Тестовый режим"), 28312, "Адаптивный свет-тень (высокая производительность)"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 28313, "Контрастные двойные обводные точки"), 28314, "Серо-белые рельефные точки (низкое воздействие)"), 28315, "Точки с обводкой глубокого синего"), 28316, "Точки с обводкой тёплого золота"), 28317, "Текстурный камуфляжный зонд (низкая видимость)"), 28318, "Остаточные избыточные фрагменты (приоритет проявки)"), 28319, "Связанная с объектом текстура (анти-распознавание)"), 28320, "Чёрно-белый высококонтрастный тест"), 28321, "Заявление о защите от удаления AI (сохраняется в скриншоте)"), 28322, "Явный слой: может быть наложен на кодирование. Если модель всё же попытается обработать водяной знак, сначала будет виден слой заявления. Графическое кодирование Anti-AI должно продолжать маскироваться в текстурах изображения и может быть отслежено через проявку."), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 28323, "Вход отслеживания утечек"), 28324, "Вернуться к настройкам графического (векторного) водяного знака"), 28325, "После загрузки подозрительного скриншота утечки система снизит фоновые помехи в соответствии с текущим режимом водяного знака и усилит области, близкие к цвету водяного знака, обводке и локальным искажениям, что облегчит идентификацию кодов признаков по таблице кодирования."), 28326, "Таблица кодирования"), 28327, "Загрузить скриншот утечки (начать проявку)"), 28328, "Режим оптимизации проявки"), 28329, "Адаптивный по яркости-контрасту"), 28330, "Серо-белые рельефные точки (низкая помеха)"), 28331, "Строгость очистки проявки"), 28332, "Изображение не загружено. После загрузки вы можете просмотреть результат проявки справа. Сначала найдите 3-точечную синхропозицию, затем считайте Hex-кодировку по 3x3 кластеру точек и таблице кодирования."), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 28333, "Поиск кода"), 28334, "Введите фрагмент кода, маску, имя файла или отправителя"), 28335, "Поддерживается нечёткий поиск: достаточно идентифицировать хотя бы 2 символа кодирования. В масках * обозначает любое количество неизвестных символов, ? обозначает 1 неизвестный символ, например *A?2 или *A*2*; также поддерживается нечёткий поиск по имени файла, отправителю, получателю. Текущие данные — пример интерфейса."), 28336, "Таблица кодирования проявки"), 28337, "Перетащите изображение сюда или нажмите для выбора"), 28338, "Выбрать изображение"), 28339, "Проявленное"), 28340, "Оригинал"), 28341, "По размеру"), 28342, "Перетащите скриншот утечки сюда или нажмите для выбора"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 28343, "Выбрать скриншот утечки"), 28344, "Загрузите подозрительный скриншот утечки и выполните очистку проявки для облегчения идентификации Hex-кодов признаков в графических (векторных) водяных знаках."), 28345, "Плотность водяного знака"), 28346, "Физическое масштабирование (отношение короткой стороны)"), 28347, "Случайность разброса"), 28348, "Интенсивность помех против удаления"), 28349, "Графические водяные знаки используют модульную сеточную раскладку."), 28350, "Обновить настройки водяного знака"), 28351, "Ошибка запроса, повторите попытку позже."), 28352, "Совпадающих записей не найдено. Попробуйте ввести более короткий фрагмент кода."), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 28353, "Текущий пользователь предпросмотра"), 28354, "ID пользователя: "), 28355, "Отправитель"), 28356, "Код "), 28357, "ID файла: "), 28358, "Разрешить пользователям настраивать водяной знак общего файла"), 28359, "При включении пользователи не смогут настраивать параметры водяного знака при совместном использовании файлов"), 28360, "Область отображения водяного знака"), 28361, "Только режим предпросмотра"), 28362, "Все страницы"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 28363, "Область отображения водяного знака сохранена"), 28364, "Не удалось сохранить область отображения водяного знака, попробуйте позже"), "27102.0", " В корпоративной панели {-Prohibited_allowed-} совместное использование личных приватных файлов"), 27102.1, " В корпоративной панели {-Open_close-} отображение структуры сборки"), 27102.2, " В корпоративной панели {-Prohibited_allowed-} внешнее совместное использование файлов"), 27102.3, " В корпоративной панели {-Open_close-} публикацию папок предприятия"), 27102.4, " В корпоративной панели {-Open_close-} автоматическое закрытие ссылок совместного использования корпоративных файлов, открытых отключённым пользователем"), 27102.5, " В корпоративной панели {-Prohibited_allowed-} анонимное совместное использование"), 27102.6, " В корпоративной панели {-Open_close-} функцию динамических уведомлений"), 27102.7, " В корпоративной панели {-Prohibited_allowed-} использование системных прав совместного использования"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 27102.8, " В корпоративной панели {-Open_close-} функцию двусторонней привязки MAC-адреса"), 27102.9, " В корпоративной панели {-Open_close-} функцию отображения сокращённого названия предприятия"), "27102.10", " В корпоративной панели {-Open_close-} функцию отключения отображения миниатюр для пользователей без прав на скачивание"), 27102.11, " В корпоративной панели {-Open_close-} функцию периодического принудительного изменения старых паролей"), 27102.12, " В корпоративной панели {-Open_close-} расчёт прав поиска"), 27102.13, " В корпоративной панели {-Open_close-} автоматическую разблокировку"), 27102.15, " В корпоративной панели  {-Open_close-} Функция настройки личной информации"), 27102.16, " В корпоративной панели {-Open_close-} функцию видео-предпросмотра"), 27102.17, " В корпоративной панели {-Open_close-} функцию настройки водяного знака для общих ссылок"), 27102.18, " В корпоративной панели {-Open_close-} функцию водяного знака на всех страницах"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, "27103.0", "В корпоративной панели {-Open_close-} функцию отображения совместно публикуемых папок"), 27103.1, "В корпоративной панели {-Open_close-} функцию скрытия структуры организации"), 27103.2, "В корпоративной панели {-Open_close-} элемент конфигурации разрешения загрузки личных файлов пользователям"), 27103.3, "В корпоративной панели {-Open_close-} элемент конфигурации разрешения совместного использования личных файлов пользователям"), 27103.4, "В корпоративной панели {-Open_close-} элемент конфигурации отправки уведомлений по email"), 27103.5, "В корпоративной панели {-Open_close-} функцию скрытия лога администратора"), "Open_close.0", "Включил"), "Open_close.1", "Отключил"), "Prohibited_allowed.0", "Запретил"), "Prohibited_allowed.1", "Разрешил"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 27104.1, "{-somebody-} в библиотеке материалов изменил следующие настройки категории {-files-}: {-fileChanges-}"), 27104.2, "{-somebody-} в библиотеке материалов изменил следующие настройки подбиблиотеки {-files-}: {-fileChanges-}"), "MATERIAL_OP_NAME", {
  1: "Изменить видимость",
  2: "Изменить правила доступа",
  4: "Добавить ассистента",
  8: "Добавить участника",
  16: "Добавить авторизованный персонал",
  32: "Изменить список ограниченных отделов",
  64: "Изменить список администраторов",
  128: "Изменить чёрный/белый список файлов",
  256: "Удалить участника",
  512: "Удалить авторизованный персонал"
}), 27105, "{-somebody-} изменил атрибуты файла-ссылки {-file-}"), 27106, "Файлы-ссылки не поддерживают скачивание; скачивание игнорирует все файлы-ссылки"), 30000, "Лёгкий документ"), 40000, "Рекомендуем для вас"), 40001, "Рекомендации на основе вашего контента активности"), 40002, "Недавние посещения"), 40003, "Недавние подписки"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 40004, "Нет рекомендуемого контента"), 40005, "Нажмите для предварительного просмотра"), 40006, "Примечание:"), 40007, "Отключить интеллектуальные рекомендации"), 40008, "После отключения интеллектуальные рекомендации не будут отображаться в этой области; вы можете снова включить их в интерфейсе настроек"), 40009, "Введите пароль зашифрованной папки"), 40010, "Понял"), 40011, "Перейти к настройкам"), 40012, "Экспорт в Word"), 40020, "Для названия предприятия выполнены следующие настройки, {-nameChanges-}"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 40021, "Автоматическая разблокировка"), 40022, "Если отключить этот пункт, блокировка может быть снята только после окончания редактирования пользователем или принудительной разблокировкой администратором. При включении блокировки старше 2 часов будут автоматически сняты"), "set_ent_name", "Полное название изменено на: {-name-}"), "set_ent_short_name", "Сокращённое название изменено на: {-name-}"), 40050, "{-count-} файлов"), 40051, "В директории проекта нет доступных проектов"), 40061, "Сдвиньте вправо для подтверждения"), 40052, "В настоящее время скачать"), 40053, "В настоящее время удален"), 40054, "В настоящее время загружен"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 40055, "Уже напечатано"), 40070, "Запретить пользователям предварительный просмотр видеофайлов в Интернете"), 40071, "Открывая эту опцию, члены бизнеса не могут просматривать видеофайлы онлайн"), 40072, "Предприятие запретило предварительный просмотр видеофайлов в Интернете, пожалуйста, свяжитесь с администратором"), 40073, "Позволяет использовать клиентскую синхронизацию"), 40074, "Открывая эту опцию, этот участник может синхронизировать файлы с помощью клиента"), 40075, "Предприятие запретило синхронизацию клиентских файлов, обратитесь к администратору"), 40076, "Введите имя группы"), 40077, "Поиск имени группы"), 40078, "В настоящее время в общей сложности {-num-} подгруппы"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 40079, "Введите ник, почтовый ящик, номер телефона, или имя группы"), 40080, "Введите ник, почтовый ящик, номер телефона, отдел или имя группы"), 40090, "Определить удаление этой подгруппы из утверждающего персонала?"), 50000, "Ключ API"), 50001, "Краткое введение в API"), 50002, "Создать ключ API"), 50003, "Ключ"), 50004, "Приложение"), 50005, "Название приложения"), 50006, "URL-адрес доступа к API"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50007, "Права доступа к файлам и папкам"), 50008, "Права на просмотр и управление файлами и папками через API"), 50009, "Просматривать и редактировать информацию о файлах и папках Babebird, к которым у вас есть доступ"), 50010, "Просматривать информацию о файлах и папках Babebird, к которым у вас есть доступ"), 50011, "Редактировать содержимое файлов и папок Babebird"), 50012, "Просматривать содержимое файлов и папок Babebird"), 50013, "Создать свой ключ API"), 50014, "Создание и использование ключа API позволяет сторонним AI-приложениям (например, openclaw, Cursor) быстро подключаться к вашему Babebird, получать доступ к файлам и подключаться к AI-базе знаний Babebird, а также даже хранить файлы. Вы можете создать новый ключ API, нажав кнопку выше"), 50015, "Узнать подробности"), 50016, "Создать новое приложение"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50017, "Назовите свое приложение"), 50018, "Пожалуйста, введите название приложения"), 50019, "Выберите тип прав доступа, которые вам нужны"), 50020, "Папка приложения - доступ к одной папке, созданной специально для вашего приложения."), 50021, "Полный - доступ ко всем файлам и папкам, доступным вам в Babebird в рамках ваших прав"), 50022, "Создать ключ"), 50023, "Папка приложения"), 50024, "Полные права доступа"), 50025, "Переименовать приложение"), 50026, "Удалить приложение"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50027, "Вы уверены, что хотите удалить это приложение?"), 50028, "Подробная информация о ключе API"), 50029, "URL-адрес для подключения"), 50030, "Скопировать ключ"), 50031, "Копирование выполнено успешно"), 50032, "Копирование не удалось, пожалуйста, выберите текст вручную и скопируйте"), 50033, "Авторизация (OAuth 2)"), 50034, "URI перенаправления (OAuth 2)"), 50035, "Ключ доступа (Access Token)"), 50036, "Получить ключ доступа"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50037, "Нажмите, чтобы показать"), 50038, "Область доступа"), 50039, "Для подключения ИИ-агентов"), 50040, "Сбросить ключ"), 50041, "Промпт для подключения ИИ"), 50042, "Скопируйте промпт ИИ-агенту для автоматического подключения к MCP"), 50043, "Дополнительные параметры:"), 50044, "Мне нужно подключиться к Babel MCP. URL MCP: {0}, ключ API: {1}. После настройки выведите список доступных инструментов и выполните тестовое подключение в режиме чтения."), 40091, "Предприятия обмениваются документами за рубежом под контролем, временно не разрешается выбирать личные группы"), 40092, "Не удалось получить информацию об утверждении, у вас нет прав на просмотр этого утверждения»"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 40093, "комментарии"), 40100, "Иконка папки"), 40101, "Изменить иконку папки"), 40102, "Выбрать иконку для замены"), 40103, "Загрузить пользовательскую иконку"), 40104, "Применить к подпапкам"), 40105, "Применить к папкам того же типа (только суперадмин)"), 40106, "Пример папки"), 40107, "Поддерживаются PNG, SVG, JPG"), 40108, "Разрешение изображения более 60*60 PX, максимум 2 МБ"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 40109, "Пользовательская иконка"), 40110, "Предпросмотр эффекта"), 40111, "Вы уверены, что хотите удалить эту пользовательскую иконку файла?"), 40112, "Восстановить иконку по умолчанию"), 40113, "Вы уверены, что хотите восстановить иконку файла по умолчанию?"), 40114, "Введите пользовательский водяной знак"), 40115, "Пользовательский водяной знак успешно установлен"), 40116, "Использовать водяной знак по умолчанию"), 40117, "Пользовательский водяной знак"), 40118, "Получить ссылку для скачивания"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 40119, "Сгенерировать ссылку для скачивания {-name-}"), 40120, "Предупреждение безопасности:Эта ссылка является прямой ссылкой доступа. Любой, кто получит эту ссылку, сможет напрямую скачать или прочитать этот файл без входа в систему. Будьте осторожны при передаче."), 40121, "Ссылка для скачивания файла:"), 40122, "Настройки ссылки:"), 40123, "Срок действия ссылки"), 40124, "Максимальное количество скачиваний"), 40125, "Действует 7 дней"), 40126, "Действует 30 дней"), 40127, "Введите количество действительных дней"), 40128, "Без ограничений"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 40129, "10 раз"), 40130, "50 раз"), 40131, "100 раз"), 40132, "Введите действительное количество раз"), 40133, "Пользовательское..."), 40134, "Ссылка успешно скопирована"), 40135, "Не удалось получить ссылку, данный файл не поддерживает анонимное скачивание!"), 40136, "Вы уверены, что хотите восстановить иконку соответствующей папки до системной иконки по умолчанию?"), 40137, "Скачано"), 40138, "Количество допустимых скачиваний равно 0, данная ссылка недействительна"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 40139, "Текст водяного знака"), 40140, "Диагональное мощение"), 40141, "Вы можете создать новую папку через правый клик по каталогу"), 40142, "Архив"), 40143, "Архивный индекс"), 40144, "Индекс категорий"), 40145, "Часто используемые"), 40146, "Без категории"), 40147, "Наиболее посещаемые"), 40148, "Последние архивные"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 40149, "Утверждение классификации документов"), 40150, "Запрос на создание категории"), 40151, "Редактировать категорию"), 40153, "Создать подкатегорию"), 40154, "Удалить категорию"), 40155, "Вы уверены, что хотите удалить эту категорию?"), 40156, "Название категории"), 40157, "Путь категории"), 40158, "Введите название категории"), 40159, "Установить категорию для архива"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 40160, "Утвердить запрос на категорию"), 40161, "Список файлов запроса на категорию"), 40162, "Запрос на категорию без архивных файлов"), 40163, "Категория не может быть пустой"), 40164, "{-somebody-} создал(а) категорию {-sub-} в архиве {-parent-}"), 40165, "Поиск классификации..."), 40166, "Поиск папки..."), 40167, "Очистить поиск"), 40168, "Пожалуйста, введите другие ключевые слова или очистите поле поиска, чтобы просмотреть все"), 40169, "Классификация, содержащая {-name-}, не найдена"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 40201, "Поиск по названию пользовательских метаданных и ключевым словам..."), 40223, "Вы уверены, что хотите удалить пользовательские метаданные <span class=\"main-color\">{-name-}</span>?"), 40225, "Варианты"), 40226, "Поля, помеченные звездочкой, должны быть заполнены"), 40227, "Найдено записей метаданных: {-num-}"), 40228, "Совпадений не найдено, отображаются все метаданные"), 40229, "--Пожалуйста, выберите--"), 40230, "Поддерживает китайский, английский, цифры и подчеркивание, максимум 50 символов"), 40231, "Формат: ГГГГ-ММ-ДД"), 40232, "Пожалуйста, введите число (можно включать десятичные)"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 40233, "Например: 3.14 или 2.0"), 40234, "Пожалуйста, введите число"), 40235, "Например: -1 или 1"), 40236, "Изменения будут автоматически сохранены на сервере"), 40237, "Пользовательские метаданные"), 40238, "Сохранение..."), 40239, "Пожалуйста, введите не более {-num-} символов"), 40240, "Пожалуйста, введите не более {-num-} символов (исключая \" и ;)"), 40241, "Введенные данные содержат недопустимые символы"), 40242, "Поиск только по пользовательским метаданным"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 40243, "Запрос на изменение пользовательских метаданных файла"), 40244, "Категория <span class=\"main-color\">{-name-}</span>, созданная вами для архива, была удалена администратором"), 40257, "Фильтр пользовательских метаданных"), 40258, "Очистить"), 40260, "ОК"), 40261, "От"), 40262, "До"), 40263, "Пожалуйста, выберите"), 40264, "Диапазон"), 40265, "Текст"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 40266, "Одиночный выбор"), 40267, "Множественный выбор"), 40268, "Нет вложенных опций"), 40269, "Введите ключевое слово"), 40270, "Пожалуйста, введите содержимое"), 40271, "Пожалуйста, введите действительное число"), 40272, "Пожалуйста, введите действительное целое число"), 40273, "Пожалуйста, выберите метаданные"), 40274, "Выбрано {-num-} элем."), 40275, "Отправитель"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 40276, "Имя файла"), 40277, "Критерии поиска не изменились"), 40278, "Ошибка поиска, попробуйте позже"), 40279, "Ошибка загрузки следующей страницы, попробуйте позже"), 40280, "Минимальное значение не может быть больше максимального"), 40281, "Пожалуйста, введите действительную дату"), 40282, "Метаданные файла не определены. Перейдите в консоль администратора предприятия для настройки."), 40283, "Метаданные файла не определены. Для использования пользовательских метаданных обратитесь к администратору для настройки в консоли администратора предприятия."), 40284, "Перейти в консоль администратора"), 48287, "Облачная версия пока не поддерживает эту функцию. Этот водяной знак доступен только при локальном развертывании. Обратитесь в службу поддержки."), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 42888, "Нажмите, чтобы просмотреть полный путь"), 42889, "Нет пользовательских метаданных"), 42890, "Совет: предприятие еще не настроило пользовательские метаданные файла"), 50100, "Создать опрос"), 50101, "Создать новый опрос Formbricks"), 50102, "Копировать и редактировать"), 50103, "Функция копирования и редактирования пока недоступна"), 50104, "Созданы тестовые данные опроса: {-name-}"), 50105, "Опрос"), 50106, "Новый опрос"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50107, "Черновик"), 50108, "Закрыть опрос"), 50109, "Просмотр формы"), 50110, "Черновик"), 50111, "Идёт сбор"), 50112, "Приостановлен"), 50113, "Завершён"), 50114, "Выберите папку для сохранения опроса"), 50115, "Название опроса"), 50116, "Введите название опроса"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50117, "Опросы"), 50118, "Мои файлы"), 50120, "Только просмотр политик резервного копирования"), 50121, "Принудительное копирование"), 50122, "Политики корпоративного резервного копирования и управление устройствами"), 50123, "Обновить состояние"), 50125, "Политики копирования"), 50126, "Сотрудники и клиенты"), 50127, "Резервные файлы"), 50128, "Журнал операций"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50129, "Корневая папка корпоративного копирования ещё не получена. Повторите попытку позже."), 50130, "Открыть корневую папку копирования?"), 50131, "Корневая папка корпоративного сканирования и копирования откроется в новой вкладке."), 50132, "Активные политики"), 50134, "{-num-} черновиков"), 50135, "Управляемые устройства"), 50136, "/ {-num-}"), 50137, "Проблемные устройства"), 50138, ""), 50139, "Файлов в очереди: {-num-}"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50140, "Всего резервных файлов"), 50142, "{-size-} надёжно сохранено"), 50143, "Ошибки копирования на {-num-} устройствах, {-num2-} файлов не выгружены. Завершённые облачные копии не затронуты."), 50144, "Просмотреть ошибки"), 50145, "Скрыть уведомление"), 50146, "Загрузка статистики…"), 50150, "Детали политики"), 50151, "Политика не найдена"), 50152, "№ политики"), 50153, "Область действия"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50154, "(включая все подотделы)"), 50155, "Учётные записи и устройства"), 50156, "{-users-} уч. записей · {-assigned-} назначенных устройств · {-waiting-} уч. записей без клиента"), 50157, "Последующие подключения"), 50158, "Действует только на выбранные устройства и не затрагивает другие компьютеры учётной записи"), 50159, "Windows-устройства, подключаемые выбранными учётными записями в дальнейшем, автоматически получают эту политику"), 50160, "Папка копирования"), 50161, "Сканируемые диски"), 50162, "Все локальные жёсткие диски"), 50163, "{-drives-}"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50165, "{-list-}, файлы без расширения"), 50166, "Режим работы"), 50167, "Копирование в реальном времени · сканирование при запуске · ежедневная проверка в {-time-}"), 50168, "Ограничение выгрузки"), 50169, "{-bw-} МБ/с · {-size-} МБ на файл"), 50170, "Последнее обновление"), 50175, "Ожидает подтверждения отзыва"), 50176, "v{-ver-} действует"), 50177, "Ожидание подтверждения v{-ver-}"), 50178, "Ожидание подключения клиента"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50179, "Клиентов пока нет"), 50180, "Целевые устройства"), 50181, "Версия подтверждена"), 50183, "Конфигурация копирования"), 50184, "Сотрудники не могут приостановить или закрыть исполнитель"), 50185, "Удалено локально, сохранено в облаке"), 50186, "Сотрудники не могут удалять облачные копии"), 50187, "Подтверждения отзыва"), 50188, "Подтверждения развёртывания"), 50189, "Эта политика ещё не развёрнута на устройства."), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50190, "Учётные записи без клиента ({-num-})"), 50191, "Изменить политику"), 50250, "Все состояния"), 50251, "Активна"), 50253, "Ожидает применения клиентом"), 50256, "Поиск по названию, типу файлов или области действия"), 50258, "Всего политик: {-num-}"), 50259, "Экспортировать список политик?"), 50260, "Будет экспортировано {-num-} записей политик по текущему фильтру (файл CSV)."), 50261, "Подтвердить экспорт"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50266, "Уч. записи"), 50267, "Устройства"), 50268, "Белый список расширений"), 50271, "Принудительное копирование-Политики"), 50272, "Экспортировать список"), 50273, "Список политик"), 50274, "Экспортировано записей по текущему фильтру: {-num-}"), 50275, "Экспортировано записей: {-num-}"), 50276, "Дублировать как новую политику"), 50277, "Отключить политику"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50278, "Удалить черновик"), 50279, "Удалить политику"), 50280, "Отключить эту политику копирования?"), 50281, "После отключения политика больше не выполняет новое копирование. Выгруженные файлы и все предыдущие версии сохраняются, корпоративные облачные данные не удаляются."), 50282, "Выгруженные файлы и все предыдущие версии сохраняются. Корпоративные облачные данные не удаляются."), 50283, "Продолжить копирование"), 50284, "Подтвердить отключение"), 50285, "Политика отключена. Облачные копии сохраняются."), 50286, "Не удалось отключить. Повторите попытку позже."), 50287, "Команда отключения записана и ожидает подтверждения устройства. Облачные копии сохраняются."), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50288, "Удалить неопубликованный черновик?"), 50289, "Удалить отключённую политику?"), 50290, "{-name-} не развёрнута. Клиенты и облачные копии не затронуты."), 50291, "{-name-} отключена. После удаления конфигурацию политики невозможно восстановить. Скопированные файлы и все предыдущие версии сохраняются."), 50292, "Черновик удалён"), 50293, "Политика удалена"), 50294, "Не удалось удалить. Повторите попытку позже."), 50400, "Политики не найдены"), 50401, "Измените условия фильтра или создайте новую политику копирования."), 50404, "Типы копируемых файлов"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50405, "Состояние политики"), 50406, "Подтверждения устройств"), 50409, "Файлы предприятия/папка копирования"), 50411, "Файлы предприятия / {-target-}"), 50413, "{-users-} уч. записей · {-devices-} устройств"), 50414, "вкл. подотделы"), 50415, "Уч. записей ожидают подключения клиента: {-num-}"), 50416, "Без расширения"), 50417, "Выгружаются только выбранные типы"), 50418, "Действует на {-num-}"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50419, "Устройств нет, не развёрнута"), 50420, "Не развёрнута"), 50421, "Ожидают подтверждения отзыва: {-num-}"), 50423, "Опубликовать"), 50425, "Ещё действия"), 50551, "Содержимое копирования"), 50553, "Подтвердить развёртывание"), 50554, "Изменить политику копирования"), 50555, "Новая политика копирования"), 50556, "Настраивает администратор · исполняет управляемый клиент"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50557, "Отменить изменения?"), 50558, "Изменения не сохранены и будут потеряны при выходе."), 50559, "Продолжить изменение"), 50560, "Отменить и выйти"), 50562, "напр. Постоянное копирование документов R&D"), 50563, "Папка облачного копирования"), 50564, "Выбрать папку"), 50565, "Опубликованные политики не переносят прежние папки. Чтобы сменить целевую папку, создайте новую политику."), 50566, "Можно выбирать только папки под управлением предприятия. Сотрудники не могут удалять, перемещать их и открывать внешний доступ."), 50567, "Структура папки: учётная запись + имя устройства"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50568, "Учётная запись (ID уч. записи)"), 50569, "Имя устройства (ID устройства)"), 50570, "Диск C: / Users / исходный путь / файлы"), 50571, "Для одного и нескольких устройств действуют одинаковые правила папок. Компьютеры одной учётной записи хранятся раздельно; устройства с одинаковыми именами различаются по ID. Существующие прежние копии не переносятся."), 50572, "Примечание (необязательно)"), 50573, "Назначение политики или пояснение для управления"), 50574, "Только выгрузка копий"), 50576, "Сотрудники не могут отключить"), 50577, "Область сканирования"), 50579, "Указанные диски"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50580, "Диск {-disk-}"), 50581, "Переносные диски, сетевые подключённые диски и виртуальный диск Babel не включаются. Системные папки, корзина и кэш клиента пропускаются автоматически."), 50582, "Типы файлов для копирования"), 50583, "(белый список расширений)"), 50584, "Другие расширения, напр. cad, tar.gz"), 50586, "Копируются только выбранные расширения; невыбранные типы не выгружаются. Без учёта регистра, поддерживаются составные расширения."), 50587, "Также копировать файлы без расширения"), 50588, "Проверка соответствия файлов"), 50589, "годовой-договор.docx"), 50591, "Параметры работы"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50592, "Ограничение скорости выгрузки (МБ/с)"), 50593, "Максимальный размер файла (МБ)"), 50594, "Ежедневная проверка в часы низкой нагрузки"), 50595, "Наблюдение в реальном времени и сканирование при запуске всегда включены. Занятые или недоступные файлы остаются в очереди и выгружаются после восстановления."), 50596, "Нажмите, чтобы удалить"), 50597, "Выбрано: {-num-}"), 50598, "Загрузка учётных записей…"), 50599, "Подходящих учётных записей нет"), 50600, "Загрузка отделов…"), 50601, "Совпадений нет"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50602, "Загрузка групп…"), 50604, "Развернуть подотделы"), 50605, "Входит вместе с родительским отделом"), 50606, "{-num-} чел."), 50609, "Есть политика"), 50610, "Не назначено"), 50611, "отделов"), 50612, "уч. записей"), 50613, "групп"), 50614, "устройств"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50615, "Выбор учётных записей или устройств для копирования"), 50616, "По отделам"), 50617, "По учётным записям"), 50618, "По группам"), 50619, "По устройствам"), 50621, "Поиск по имени или учётной записи"), 50622, "Поиск групп"), 50623, "Поиск учётной записи или имени устройства"), 50624, "Включая все подотделы выбранных отделов"), 50625, "Действует только на выбранные устройства. Другие устройства той же учётной записи не подключаются автоматически."), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50626, "Область по учётным записям охватывает все их Windows-устройства, включая подключаемые в дальнейшем."), 50627, "Не заполнено"), 50628, "Количество учётных записей"), 50629, "Количество устройств"), 50630, "Последующие устройства"), 50631, "Только выбранные устройства"), 50632, "Новые Windows-устройства учётных записей подключаются автоматически"), 50633, "Размер области"), 50634, "Облачная папка"), 50635, "Учётная запись / имя устройства (ID устройства) / диск / исходный путь"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50637, "{-disks-}"), 50639, "Файлы без расширения"), 50640, "Наблюдение · сканирование при запуске · ежедневная проверка в {-time-}"), 50641, "Ограничения ресурсов"), 50642, "{-bandwidth-} МБ/с · {-size-} МБ на файл"), 50643, "Опубликовать версию"), 50644, "Встроенные правила защиты"), 50645, "Выгружаются только подходящие файлы, пустые папки не создаются"), 50646, "Локальное удаление или переименование не удаляет облачные оригиналы"), 50647, "Сотрудники не могут приостановить, изменить или отключить копирование"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50648, "Выход из веб-версии не останавливает задачу копирования"), 50649, "Версии сохраняются, данные принадлежат предприятию"), 50650, "Файлы нескольких устройств одной учётной записи хранятся раздельно"), 50651, "После публикации политика попадает в очередь развёртывания и вступает в силу после подключения Windows-клиентов из области действия."), 50652, "Сохранить черновик"), 50653, "Подтвердить публикацию и развёртывание"), 50654, "Черновик сохранён и пока не развёрнут на клиенты."), 50655, "Политика v{-version-} добавлена в очередь развёртывания и ожидает подтверждения клиента."), 50656, "Политика для учётных записей сохранена, ожидает подключения Windows-клиента и пока не действует."), 50657, "Корневая папка корпоративного копирования не получена. Обновите страницу и повторите попытку."), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50658, "Политика создана и опубликована, ожидает подтверждения клиента."), 50659, "Политика обновлена и опубликована, ожидает подтверждения клиента."), 50660, "Не удалось сохранить. Повторите попытку позже."), 50662, "Введите расширение для копирования"), 50663, "Введите корректное расширение, например docx или tar.gz. Не используйте подстановочный знак *."), 50664, "Введите имя файла"), 50665, "Соответствует белому списку. Файлы этого типа будут копироваться."), 50666, "Не соответствует белому списку. Не выгружается, облачная папка для него не создаётся."), 50667, "Выбор папки корпоративного копирования"), 50668, "Выберите конкретную папку предприятия"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50850, "Все состояния подключения"), 50851, "Клиент в сети"), 50852, "Все клиенты не в сети"), 50853, "Клиент не подключён"), 50854, "Одна учётная запись, несколько устройств"), 50855, "Все состояния копирования"), 50856, "Копирование в норме"), 50857, "Идёт копирование"), 50858, "Ошибки копирования"), 50859, "Ожидает вступления в силу"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50861, "Политика не назначена"), 50865, "Поиск по имени, учётной записи или имени устройства"), 50866, "Экспорт сотрудников"), 50867, "«Не подключён» означает отсутствие записей Windows-клиента и не означает отключение учётной записи или офлайн устройства."), 50868, "Корпоративные учётные записи"), 50870, "Подключён Windows-клиент"), 50871, "чел. / устройств: {-num-}"), 50872, "Все отделы"), 50873, "Экспорт устройств"), 50874, "Идентификатор учётной записи"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50878, "Подключение клиента"), 50879, "Связанных устройств"), 50880, "В сети"), 50881, "Список устройств"), 50883, "№ устройства"), 50885, "Сотрудник"), 50886, "Подключение клиента"), 50887, "Состояние копирования"), 50888, "Выгружено файлов"), 50889, "Выгружено байт"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50890, "Последнее успешное копирование"), 50891, "Принудительное копирование-{-type-}.csv"), 50893, "Устройства"), 50895, "Список сотрудников"), 50899, "Связанные устройства"), 50900, "Windows-устройств: {-num-} · в сети: {-num2-}"), 50903, "Папка копирования учётной записи"), 50904, "Клиент {-ver-}"), 50905, "Последний сигнал: {-time-}"), 50906, "Файлов: {-num-} · {-size-}"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50907, "Детали устройства"), 50908, "Windows-клиент ещё не подключён"), 50909, "У этой учётной записи нет записей регистрации Windows-клиента. Работа только в вебе не создаёт задач копирования устройств."), 50910, "Политика для учётной записи настроена и будет развёрнута после подключения клиента."), 50911, "Учётные записи и клиенты"), 50912, "Windows-клиенты этой учётной записи"), 50913, "У этой учётной записи несколько устройств. Каждое устройство выполняет, подтверждает и хранит данные независимо; последнее вошедшее устройство не заменяет остальные."), 50914, "Устройства учитываются только после регистрации клиента и привязки к корпоративной учётной записи. «Не подключён» не означает «офлайн» и не говорит о том, устанавливалось ли приложение."), 50915, "Папки и привязка устройств"), 50916, "Имя устройства (ID устройства) / диск C: / исходный путь"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50917, "Имя устройства служит для распознавания; ID учётной записи и ID устройства обеспечивают стабильную привязку. Компьютеры с одинаковыми именами всё равно хранят копии раздельно. Существующие прежние папки не перемещаются автоматически."), 50918, "{-num-} (текущее: {-id-})"), 50919, "Идентификатор устройства"), 50920, "Папка копирования устройства"), 50921, "Операционная система"), 50922, "Применённая политика"), 50923, "(цель v{-ver-} / подтверждено v{-ver2-})"), 50924, "Политика не назначена"), 50925, "Последний сигнал"), 50926, "Последнее копирование"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50927, "Детали конечного устройства"), 50928, "Скопированные файлы"), 50930, "Файлы в очереди выгрузки"), 50931, "{-cmd-}. Результат определяется следующим подтверждением клиента."), 50932, "Необработанные ошибки"), 50933, "Файлов: {-num-}"), 50934, "Документ занят другой программой. После её закрытия клиент повторит автоматически; можно также отправить запрос повтора."), 50935, "Исполнитель не может прочитать папку с ограниченным доступом. Попросите администратора устройства проверить права доступа и повторить копирование."), 50936, "Защита задачи"), 50937, "Сотрудники не могут изменить или отключить политику"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50938, "Выход из веб-версии не останавливает управляемые задачи"), 50939, "Только выгрузка, локальные удаления не переносятся"), 50940, "Облачные папки принадлежат предприятию"), 50941, "Это управляемая задача клиента. Защита от принудительного завершения процесса или удаления локальным администратором по-прежнему требует служб Windows и корпоративного контроля устройств."), 50943, "Досканировать файлы"), 50944, "Повторить неудавшиеся файлы"), 50945, "На выбранных устройствах нет неудавшихся файлов для повтора."), 50946, "Досканирование доступно только для управляемых устройств с назначенной политикой."), 50947, "Досканировать резервные файлы"), 50948, "Отправить запрос «{-type-}» на {-num-} устройств."), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 50950, "Досканирование"), 50951, "Повторяются только неудавшиеся файлы. Завершённые файлы повторно не выгружаются."), 50952, "Повторное сканирование по белому списку расширений текущей политики. Облачные файлы не удаляются."), 50953, "Устройств не в сети: {-num-}. Запросы будут обработаны после повторного подключения."), 50954, "Подтвердить отправку"), 50955, "Запрос записан, ожидается подтверждение выполнения клиентом."), 51050, "Подходящих учётных записей или устройств нет"), 51051, "Имя / учётная запись"), 51053, "Windows-клиент"), 51055, "Последний сигнал клиента"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 51056, "Охват копирования"), 51058, "Учётная запись / имя устройства"), 51061, "Скопировано"), 51063, "в сети: {-online-} / подключено: {-total-}"), 51064, "Нет записей регистрации Windows-устройств"), 51065, "Связанных устройств нет"), 51066, "управляемых: {-managed-} / {-total-}"), 51068, "Политика не настроена"), 51069, "Сигналов нет"), 51071, "Настроить политику"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 51072, "Несколько устройств на учётную запись"), 51075, "Сигнал"), 51076, "Файлов: {-count-}"), 51077, "{-count-} · {-size-}"), 51078, "Последнее копирование {-time-}"), 51080, "Подтверждено v{-applied-} / цель v{-target-}"), 51200, "Записей пока нет"), 51301, "Клиент в сети"), 51302, "Клиент не в сети"), 51303, "Файлы предприятия / Принудительное копирование"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 51304, ""), 51305, "({-text-})"), 51306, "Офисные документы"), 51307, "Исходные файлы дизайна"), 51308, "Файлы R&D"), 51321, "Введите название политики."), 51322, "Политика с таким названием уже существует. Укажите другое название."), 51323, "Выберите папку копирования, принадлежащую предприятию."), 51324, "Выберите хотя бы одно расширение для копирования."), 51325, "Неверный формат расширения. Укажите docx, pdf или tar.gz, без подстановочных знаков."), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 51326, "Выберите хотя бы один жёсткий диск."), 51327, "Укажите ограничение скорости выгрузки от 1 до 1024 МБ/с."), 51328, "Укажите максимальный размер файла от 1 до 2048 МБ."), 51329, "Выберите время ежедневной проверки."), 51330, "Выберите хотя бы одну учётную запись, отдел или группу."), 51331, "Успешно"), 51332, "Отзыв политики, ожидание подтверждения устройства"), 51333, "Политика v{-ver-} ожидает подтверждения"), 51334, "Опубликовать политику"), 51335, "Опубликовано v{-ver-}, охвачено уч. записей: {-count-}; подтверждений от устройств: {-dev-}, уч. записей без клиента: {-wait-}"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 51336, "Для действующей политики публикуйте новую версию — напрямую заменить её черновиком нельзя."), 51338, "Ещё не развёрнута на клиенты"), 51341, "Остановить новое копирование; отзыв ожидает подтверждения клиента. Облачные файлы и все предыдущие версии сохраняются"), 51342, "Учётная запись не найдена"), 51343, "Введите имя устройства"), 51344, "Конфликт политик для этой учётной записи, требуется вмешательство администратора"), 51346, "Подобрана политика {-name-}, ожидается подтверждение клиента"), 51347, "Учётная запись привязана, политика не назначена"), 51348, "Политика {-id-}"), 51351, "Удаление неразвёрнутых или отключённых политик"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 51352, "{-name-} — копия"), 51353, "Ожидается повтор неудавшихся файлов"), 51354, "Ожидается досканирование файлов"), 51355, "Запрос повтора"), 51356, "Запрос досканирования"), 51357, "Запрос записан, ожидается выполнение клиентом; существующие результаты копирования не изменены"), 51358, "Ожидает выполнения"), 51359, "Файлы предприятия / Восстановление копий / "), 51360, "Заявка на восстановление"), 51361, "Заявка на восстановление v{-ver-} с устройства {-dev-} в {-path-}, исходная копия не изменяется"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 51362, "Область действия не выбрана"), 51363, "Все Windows-устройства"), 51364, "Функция доступна только при приватном развёртывании; в публичном облаке доступно только сохранение черновика."), 51365, "Предприятие не приобрело этот модуль; сейчас доступно только сохранение черновика."), 51366, "Обычные участники используют первую действующую настройку в порядке: <strong>персональная → по роли → все участники отдела → базовые права роли отдела</strong>"), 51367, "Права не суммируются; после истечения срока применяется следующий уровень. Участники с правом «Управление файлами отдела» не ограничиваются настройками ниже."), 51368, "Применяется к обычным участникам без действующей персональной настройки или настройки по роли"), 51369, "Порядок применения прав на файлы"), 51370, "<p>Сначала проверяется право «Управление файлами отдела»; участники с ним не ограничиваются настройками ниже.</p><ol><li><b>Персональная:</b> если есть действующая настройка, применяется она.</li><li><b>По роли:</b> если у участника нет действующей личной настройки, проверяется, заданы ли права на файл для группы с его ролью. Если заданы, применяются именно они, а не базовые права роли.</li><li><b>Все участники отдела:</b> применяется, когда на двух уровнях выше нет действующих настроек.</li><li><b>Базовые права роли отдела:</b> используются, только если ни на одном из трёх уровней выше нет действующей настройки.</li></ol><p>Применяется первая действующая настройка, права не суммируются. Более высокий приоритет не означает больше прав.</p>"), 51371, "К кому применяется «Все участники отдела»"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 51372, "<p>Это общая настройка для обычных участников. Те, у кого есть действующая персональная настройка или настройка по роли, используют её в первую очередь.</p><p>Участники с правом «Управление файлами отдела» никогда не ограничиваются.</p>"), 51373, "«Не задавать отдельно» не означает отсутствие прав"), 51374, "<p>При выборе «Не задавать отдельно» система проверяет следующий уровень, а не запрещает доступ.</p><p>«Невидимый» — это действующая настройка; после её применения уровни с более низким приоритетом не проверяются.</p><p>Наборы прав берутся из списка настраиваемых прав на файлы предприятия; фактические операции зависят от конфигурации предприятия.</p>"), 51375, "Понятно"), 51380, "Позволяет просматривать примечания в файлах, созданных или загруженных другими участниками, включая ваши примечания и примечания других."), 51381, "Позволяет добавлять примечания к файлам, созданным или загруженным другими участниками, не изменяя содержимое файла."), 51382, "Позволяет удалять примечания, добавленные другими участниками. «Другие» — автор примечания, независимо от того, кто создал или загрузил файл."), 51383, "Позволяет видеть подотделы текущего отдела и просматривать их файлы. При отключении подотделы не отображаются."), 51384, "Позволяет печатать созданные или загруженные вами файлы или скачивать версию PDF с водяным знаком. Для скачивания исходного файла требуется разрешение «Скачивать свои файлы»."), 51385, "Позволяет печатать файлы, созданные или загруженные другими участниками, или скачивать версию PDF с водяным знаком. Для скачивания исходного файла требуется разрешение «Скачивать чужие файлы»."), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 51386, "Позволяет просматривать журнал операций с созданными или загруженными вами файлами: кто, когда и что делал."), 51387, "Позволяет просматривать журнал операций с файлами, созданными или загруженными другими участниками: кто, когда и что делал."), 51388, "Позволяет отображать в списке файлы, недоступные для просмотра, но не открывать их."), 51389, "Позволяет редактировать содержимое созданных или загруженных вами файлов онлайн."), 51390, "Позволяет редактировать содержимое файлов, созданных или загруженных другими участниками, онлайн."), 51391, "Для управления файлами текущего отдела; см. пункты управления ниже."), 51392, "Включает права на создание, удаление и изменение подотделов текущего отдела."), 51393, "Позволяет настраивать, какие участники могут обращаться к файлам и какие действия им доступны."), 51394, "Позволяет задавать или изменять уровень конфиденциальности файлов."), 51395, "Позволяет рассматривать заявки на передачу файлов и решать, согласовать их или нет."), (0, _defineProperty2["default"])(_localString_ru_part, 51396, "Позволяет передавать роль ответственного за файл другому участнику. Передача не меняет автора или загрузившего файл."));
var _default = exports["default"] = localString_ru_part3;

},{"1180":1180,"1184":1184,"1454":1454}],1166:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var localString_ru_part2_1 = {
  //*****************营销页面
  8000: "Настройте свой BabelBird",
  8001: "Ядро корпоративных услуг - обслуживание компаний. Чтобы предоставить более детальные услуги, мы запустили бизнес по кастомной разработке BabelBird. Помогаем компаниям преодолеть ограничения стандартных продуктов и значительно повысить эффективность производства",
  8002: "Свяжитесь с нами",
  8003: "Начиная с мышления продукта, поможем вам спроектировать продукт",
  8004: "Разные отрасли имеют разные рабочие процессы и привычки использования, а между требованиями и конечным продуктом часто глубокая пропасть. Только требования без хорошего дизайна продукта часто приводят к тому, что проект не может быть реализован. Чтобы лучше подойти к вашему сценарию, наша команда Babel care под руководством профессионального менеджера продукта настроит для вашей компании решение и поддержку вторичной разработки.",
  8005: "Мощные возможности R&D",
  8006: "У нас есть команда из 10 человек для поддержки кастомной разработки, основные члены - ключевые разработчики системы BabelBird. Из Пекинского университета, Цзяотунского университета и Чэндуского технологического университета. Мы поддерживаем кастомную разработку на различных языках и платформах. У нас есть核心 технологии в базах данных, облачных вычислениях, графике и изображениях, особенно в алгоритмах. Обширный опыт разработки различных систем.",
  8007: "Тонкое управление оценкой времени",
  8008: "У нас есть система тонкой оценки времени, которая ранее обслуживала Peking University Founder, позволяющая точно управлять оценкой разработки, повышая успех проектов и эффективность реализации. Оценка проектов ясна и проверяема, эффективно снижая затраты компании и повышая эффективность.",
  8009: "Прозрачное отслеживание и приёмка проектов",
  8010: "На каждом этапе проекта у нас есть dedicated менеджер проекта и менеджер продукта для отслеживания. Обеспечиваем прогресс и стандарты приёмки. Мы можем открыть наш Jira (инструмент управления проектами) для вас, чтобы вы могли в любое время видеть прогресс и затраты времени.",
  8011: "Прозрачно, профессионально, ответственно",
  8012: "Ответственность - это то, что клиенты дают нам чаще всего и высоко оценивают. В период обслуживания проекта мы будем думать с позиции компании, timely исправлять баги и корректировать функции. Предоставляем долгосрочные устойчивые услуги обслуживания для компаний.",
  8013: "“Система кастомной разработки BabelBird решила проблему автоматической подачи и единого управления визовыми файлами. Теперь материалы виз, поданные пользователями, безопасно и упорядоченно управляются в нашей системе и быстро запрашиваются.”",
  8014: "Они используют нашу кастомную систему",
  8015: "Интеграция делает нас всемогущими",
  8016: "Онлайн-консультация",
  8017: "Скачать документацию API",
  8018: "Нет нужды изобретать велосипед заново",
  8019: "Мы вошли в эру открытых платформ. Используя API BabelBird, вы можете использовать почти все возможности BabelBird в вашей системе. Строить кастомные приложения и интеграции в облаке, без необходимости строить и поддерживать свою службу управления контентом. В то же время, BabelBird может интегрировать такие услуги, как электронная подпись, продвинутый CAD-менеджмент, office, распознавание текста и графики и другие сторонние услуги для решения ваших проблем.",
  8020: "Полная интерфейсизация системы",
  8021: "Почти все функции BabelBird можно вызвать через API-интерфейсы, с single sign-on для быстрой интеграции. Наша команда разработчиков может предоставить соответствующую техническую поддержку, помогая быстро интегрировать BabelBird. Делает обмен цифровой информацией лёгким и предоставляет безопасный способ для ваших клиентов и команды напрямую доступать, аннотировать, делиться и сотрудничать с контентом в ваших кастомных приложениях.",
  8022: "Ставьте продуктивность и сотрудничество на первое место",
  8023: "Работа часто вращается вокруг документов, интегрируя различные продукты с входом управления документами, вы можете наслаждаться различными SAAS-услугами без частого переключения программ или платформ. BabelBird может по требованию подключать only office, Yongzhong office, office365, cad, iWork, Rhino 3D, Haochen CAD, Tianrui Green Shield и многие другие наборы продуктивности и приложения. Позволяя вам удовлетворять потребности в сотрудничестве и редактировании без копирования файлов между приложениями или переключения аккаунтов.",
  8024: "Коммерческая лицензия",
  8025: "Хотите предоставить клиентам больше разнообразных услуг? Безопасное управление хранением контента, отображение продажных материалов, управление контрактами и предложениями, управление файлами агентов, управление знаниями компании, архив, система аннотаций и обсуждений... Используя коммерческую лицензию BabelBird, ваша компания может разработать свои коммерческие приложения на основе системы BabelBird и продавать их (поддержка приватного развертывания), позволяя компаниям быстро иметь облачные сервисные продукты.",
  8026: "“На основе BabelBird в сочетании с Yongzhong office мы запустили Yongzhong Youyun. Позволяя нашей онлайн-системе office иметь функции управления файлами корпоративного уровня, предоставляя клиентам лучшее решение для корпоративного office, чем office365.”",
  8027: "Начните интегрировать BabelBird в вашу систему сейчас",
  8028: "Просмотреть подробный список функций BabelBird",
  8029: "Настроено для компаний",
  8030: "От технологий к приложениям, единство знания и действия",
  8031: "Хранение файлов",
  8032: "Сотрудничество и редактирование",
  8033: "Мобильный офис",
  8034: "Управление фоном компании",
  8035: "Безопасность данных",
  8036: "Мощная продвинутая система хранения файлов",
  8037: "Помогает быстро настроить облачную рабочую среду",
  8038: "Используя клиент системы хранения файлов BabelBird (Mac, Windows) и APP (Android, iOS), вы можете быстро установить среду обмена файлами с командой и другими отделами компании, и синхронизировать рабочие файлы на ваши и коллег устройства, гарантируя, что рабочий контент команды и личный всегда актуален. Вы можете использовать клиент BabelBird как вход в работу, напрямую открывать облачные файлы для редактирования и сохранять в облако. Новые и обновлённые файлы коллег вы также получите第一时间 и сможете обсудить в BabelBird. Отныне ваши файлы будут надёжно храниться в облаке, содержимое папок вас и коллег будет一致, и вы сможете использовать полнотекстовый поиск для быстрого нахождения нужных файлов.",
  8039: "Нажмите, чтобы скачать Excel-версию подробного списка функций",
  8040: "Подробный список функций хранения файлов",
  8041: "Кросс-платформенный, мульти-терминальный",
  8042: "Клиенты для PC, MAC, мобильных и планшетов, H5 веб-версия",
  8043: "Автоматическое резервное копирование, синхронизация",
  8044: "Укажите любую папку для двунаправленной синхронизации (облако в локальное, локальное в облако)<br>Поддержка реального времени, ручной синхронизации<br>Управление версиями с синхронизацией для разрешения конфликтов",
  8045: "Быстрая точка-точка передача файлов",
  8046: "Правой кнопкой мыши быстро отправить локальный файл любому пользователю",
  8047: "Секундная передача больших файлов",
  8048: "Быстрая секундная передача больших файлов с одинаковым содержимым",
  8049: "Продолжение с точки прерывания",
  8050: "При прерывании сети можно переподключиться и продолжить передачу с прогресса",
  8051: "Улучшенное управление файлами",
  8052: "Иконки предпросмотра, многомерная сортировка, загрузка перетаскиванием, свойства файлов, закрепление, копирование перемещение удаление, блокировка... ",
  8053: "Древовидный каталог",
  8054: "Поддержка древовидного отображения файлов и папок, подобно Проводнику и Finder",
  8055: "Журнал файлов",
  8056: "Можно отдельно просмотреть журнал любого файла, понять все записи жизненного цикла файла",
  8057: "Статистика доступа",
  8058: "Количество открытий файла, количество посетителей, количество скачиваний, количество аннотаций, список посетителей",
  8059: "CDN-ускорение и оптимизация сети",
  8060: "Адаптирует ближайший узел в любом месте мира для быстрого открытия",
  8061: "Онлайн-предпросмотр",
  8062: "Поддержка онлайн-предпросмотра почти 200 форматов, кроме обычных office и изображений, поддержка Apple office (iWork), 3D-моделей, векторных дизайнов, CAD-чертежей, PSD, AI и т.д. Поддержка онлайн-воспроизведения аудио-видео файлов",
  8063: "Блокировка файлов",
  8064: "Редактируемый файл автоматически блокируется, другие не могут редактировать. Также можно вручную заблокировать файл, чтобы предотвратить изменения другими",
  8065: "Онлайн-предпросмотр сверхбольших изображений",
  8066: "Прямой онлайн-предпросмотр оригинала изображений 5K или даже 10K. Патентованная технология",
  8067: "Онлайн-аннотирование обсуждения",
  8068: "Можно напрямую аннотировать, рисовать, даже голосово обсуждать содержимое файла в предпросмотре",
  8069: "Онлайн-редактирование",
  8070: "Онлайн-редактирование и совместное редактирование файлов, также онлайн-редактирование в app",
  8071: "Локальное редактирование с автоматической загрузкой",
  8072: "Поддержка прямого вызова локальной программы для редактирования онлайн-файла, результаты редактирования автоматически загружаются",
  8073: "Подписка на файл",
  8074: "Можно напомнить членам компании подписаться на файл и самому подписаться, обновления автоматически уведомляют",
  8075: "Ящик для сбора файлов, ящик для вкладов",
  8076: "Сбор документов, приём заданий, специальные папки с контролем прав",
  8077: "Разделение управления корпоративными и личными файлами",
  8078: "Разделение папок компании и отделов от личных папок",
  8079: "Управление версиями",
  8080: "Неограниченное количество исторических версий файлов, можно управлять, скачивать, удалять, устанавливать как текущую, поддержка журнала версий",
  8081: "Общие метки",
  8082: "Можно установить несколько меток для файлов и папок, быстрый поиск, метки общие, члены с правами могут использовать",
  8083: "Список меток в левой панели",
  8084: "Можно добавить список меток в левую панель, быстро классифицировать, позиционировать файлы",
  8085: "Напоминание о непрочитанных файлах",
  8086: "Статус напоминания о непрочитанных файлах, новые файлы от других членов не пропускаются",
  8087: "Многоуровневая корзина",
  8088: "В эффективный период (администратор может установить) удалённые корпоративные файлы обычными членами могут быть восстановлены или окончательно удалены вышестоящим руководителем, по уровням.",
  8089: "Полнотекстовый поиск",
  8090: "Можно искать текст в документах и векторных чертежах, искать метки и искать файлы в указанном диапазоне",
  8091: "Права файлов",
  8092: "Можно добавить права корпоративных файлов, тонкий контроль любого файла (папки) для участников обмена: доступ, редактирование, аннотирование, печать, скачивание, срок действия и т.д.",
  8093: "Уровень конфиденциальности и безопасности файлов",
  8094: "Четыре уровня, строго контролируют распространение файлов",
  8095: "Многоязычный",
  8096: "Китайская и английская версии",
  8097: "Эпохальное сотрудничество",
  8098: "Делает общение проще и эффективнее",
  8099: "Подробный список функций сотрудничества и редактирования",
  8100: "Отделы и команды",
  8101: "Можно создать отделы по организационной структуре, с соответствующими отношениями подчинения и управлением правами файлов отделов",
  8102: "Временные группы компании",
  8103: "Через создание проектов члены компании могут быстро комбинироваться кросс-отделами, организовывать людей из разных отделов в проект, проекты можно передавать кросс-отделами",
  8104: "Общая папка компании",
  8105: "Общее пространство, доступное всей компании (кроме ограниченных лиц)",
  8106: "Автоматический обмен файлами членами компании по настройкам",
  8107: "Члены отдела автоматически получают последние версии файлов и динамические уведомления без напоминаний, и могут напрямую использовать общие папки",
  8108: "Обмен ссылками на файлы",
  8109: "Правой кнопкой мыши напрямую открыть обмен ссылкой, можно установить срок действия ссылки, пароль и различные права доступа, и поделиться через WeChat и email",
  8110: "Приглашение файлов",
  8111: "Через приглашение поделиться файлом с конкретными людьми для сотрудничества, не-приглашённые аккаунты не могут войти, права приглашённых можно индивидуально регулировать",
  8112: "Механизм авторизации обмена и приглашений",
  8113: "Пользователи без прав на приглашение/обмен могут отправить запрос на авторизацию обмена пользователям с правами",
  8114: "Система email",
  8115: "Новые загрузки файлов, новые аннотации и обсуждения, приглашения и отправки файлов могут быть отправлены на email пользователя, и можно напрямую просмотреть и использовать в email",
  8116: "Журнал доступа",
  8117: "Совместное аннотирование обсуждения",
  8118: "На содержимом файла можно напрямую создать аннотации для реального времени общения, совместного обсуждения проблем. Поддержка текста, рукописного ввода, голоса, вложений и т.д. Содержимое обсуждения можно показывать и скрывать по правам.",
  8119: "3D-аннотирование",
  8120: "В 3D-моделях можно создать аннотации на основе трёхмерных координат для обсуждения, клик на точку аннотации возвращает к перспективе пользователя при создании аннотации",
  8121: "Комментарии файлов",
  8122: "и быстрые ответы в списке динамики.",
  8123: "Динамика",
  8124: "Платформа сводки информации команды, связанной с пользователем, и информации обсуждений аннотаций файлов, в динамике можно напрямую перейти к соответствующему файлу для просмотра или быстро ответить на аннотацию и комментарий. Через динамику и командное сотрудничество, проще и прямее.",
  8125: "Сообщения и напоминания",
  8126: ", напоминания о подписке, важные уведомления, приглашения и авторизации и т.д. важные операции будут доставлены как уведомления сообщений. Помогают пользователям игнорировать шум и фокусироваться на самом важном",
  8127: "Внешнее сотрудничество",
  8128: "Установить сотрудничество с братскими компаниями или клиентами. Внутренние и внешние файлы разделены маркировкой, внешние члены управляются отдельно, быстрое приглашение по email и номеру телефона. Безопасно и эффективно",
  8129: "Чат отделов, проектов и команд",
  8130: "Чат групп, подобный WeChat, на основе отделов, проектов и команд, поддержка передачи вложений",
  8131: "и вложения",
  8132: "Члены и передача вложений, делают работу более сосредоточенной",
  8133: "Одобрение и процесс одобрения",
  8134: "Поддержка одобрения файлов, можно предустановить процесс одобрения, поддержка группового или последовательного одобрения. После одобрения файл фиксируется и не может быть изменён",
  8135: "Фиксация файлов",
  8136: "Одобренные файлы становятся фиксированными, фиксированные файлы не могут быть изменены, удобно для отделов разработки и производства確定 и оставить доказательства.",
  8137: "Объявления компании",
  8138: "Просто и быстро публиковать объявления компании, быстро передавать членам компании",
  8139: "Управление членами сотрудничества",
  8140: "Все общие файлы сотрудничества можно быстро управлять участвующими членами, изменять права членов, добавлять удалять участников.",
  8141: "Сотрудничество на основе организационной структуры",
  8142: "Внутреннее сотрудничество компании может импортировать организационную структуру, быстро установить отношения сотрудничества и распределить права по отношениям подчинения структуры",
  8143: "Онлайн-совместное редактирование",
  8144: "Поддержка онлайн-совместного редактирования office-документов, чёткая маркировка точек изменений, совместное завершение документа",
  8145: "Совместная демонстрация экрана",
  8146: "Для удалённых встреч поддержка совместной демонстрации экрана, после включения перспективы участников совпадают с демонстратором, можно использовать кисть и лазерную указку для маркировки ключевого контента",
  8147: "Легко и без ограничений",
  8148: "С телефоном и планшетом можно выполнить большинство работ",
  8149: "Полнофункциональный мобильный конец BabelBird не только имеет все функции веб-версии, но и эксклюзивные функции мобильных устройств, такие как голосовые аннотации,优质 рукописные аннотации с сенсорным экраном. Позволяя вам в любое время и в любом месте открывать файлы до 200 форматов и обсуждать их с командой. Без установки других приложений можно онлайн-редактировать office-документы. Для экрана iPad BabelBird оптимизировал опыт, дизайн с файлами слева и динамикой справа делает использование мобильного конца лучше. Клиент для win10 может сделать ваш surface ещё мощнее. Используя мобильный конец BabelBird, вы можете носить с собой все файлы компании и мудрость команды, в любое время проверять схему, только что сделанную подчинённым, извлекать последние дизайны для клиента, удалённо демонстрировать PPT, одобрять последний бюджет. Конечно, мы поддерживаем WeChat.",
  8150: "Подробный список функций мобильного офиса",
  8151: "Полное покрытие Android, iOS, WeChat",
  8152: "Поддержка устройств Android, iPhone и кастомной версии для iPad. Поддержка H5",
  8153: "windows10 и Mac",
  8154: "На планшетах surface и ноутбуках Apple можно использовать клиент и синхронизировать",
  8155: "Нативное APP, выше эффективность выполнения",
  8156: "Мобильный конец BabelBird - нативные APP, специально написанные для целевой системы, не вложенные веб-страницы",
  8157: "Полнофункциональный мобильный конец",
  8158: "Будь то клиент или мобильный конец, поддерживают все функции веб-версии",
  8159: "Рождён для мобильного",
  8160: "Мобильный конец поддерживает создание голосовых аннотаций, загрузку фото с камеры, прямые фото вложения",
  8161: "Интерфейс, кастомизированный для iPad, божественное взаимодействие",
  8162: "BabelBird на iPad имеет отличный опыт, в горизонтальном режиме слева список файлов, справа содержимое файла, быстрое переключение эффективное сотрудничество. Начните работать с iPad",
  8163: "Открывать документы из других App",
  8164: "Документы из WeChat и QQ можно открыть в BabelBird и загрузить",
  8165: "Скачивание и пересылка файлов с мобильного конца",
  8166: "Файлы, скачанные в мобильном конце BabelBird, можно напрямую переслать в WeChat",
  8167: "Делиться файлами с мобильного конца",
  8168: "Мобильный конец может напрямую делиться файлами через WeChat, также напрямую публиковать в Moments",
  8169: "Онлайн-редактирование",
  8170: "Мобильный конец может открывать office-документы для онлайн-редактирования, без установки другого ПО",
  8171: "Онлайн-предпросмотр",
  8172: "Большинство файлов, которые можно предпросмотреть в веб-версии, можно в мобильном конце (почти 200 видов, кроме 3D-файлов)",
  8173: "Прямое аннотирование обсуждения",
  8174: "На файлах, открытых в мобильном конце BabelBird, клик для прямого аннотирования обсуждения и управления точками аннотаций",
  8175: "Отображение водяного знака",
  8176: "Файлы, открытые в мобильном конце, также поддерживают водяной знак",
  8177: "Экстремально быстрый просмотр файлов",
  8178: "Перелистывание страниц вверх-вниз, переключение файлов влево-вправо, быстрое переключение между несколькими файлами, лучше соответствует привычкам мобильного использования",
  8179: "Рукописный ввод, лучше на мобильном конце",
  8180: "С сенсорным экраном мобильных устройств, на файлах, открытых в APP BabelBird, можно рукописно обводить для обсуждения, опыт лучше.",
  8181: "Полнотекстовый поиск",
  8182: "Мобильный конец также может быстро полнотекстово искать все файлы в пределах прав, без перелистывания",
  8183: "Метки, подписки, комментарии все на месте",
  8184: "Настоящий полнофункциональный, все функции в мобильном конце все на месте и ещё мощнее",
  8185: "Чат отделов и команд",
  8186: "Опыт чата групп, близкий к WeChat, лучше соответствует привычкам пользователей",
  8187: "Просмотр журналов",
  8188: "В мобильном конце также можно просмотреть журналы, управлять",
  8189: "Центр уведомлений",
  8190: "Используя мобильный конец, можно в любое время получать чат-сообщения и уведомления об обновлениях файлов, в реальном времени понимать динамику команды",
  8191: "Приватное развертывание также может использовать APP",
  8192: "После простой настройки мобильный конец может предоставлять услуги пользователям приватного развертывания",
  8193: "Рождён для компаний",
  8194: "Фон управления компанией, соответствующий требованиям деталей корпоративного управления, единое управление всей компанией",
  8195: "Замена логотипа компании",
  8196: "От интерфейса входа до интерфейса использования и страницы открытия обмена можно использовать логотип компании пользователя, едино и профессионально, учитывая имидж компании",
  8197: "Независимый вторичный домен",
  8198: "Каждая компания имеет свой независимый вход,不易 спутать, более профессионально",
  8199: "Обзор компании",
  8200: "На одном взгляде показывает использование компании, занятие пространства",
  8201: "Многоуровневые администраторы",
  8202: "Аккаунт владельца компании, администратор компании, администратор архивов, администратор эксплуатации, офицер безопасности, аудитор безопасности и другие типы администраторов, тонкое распределение прав управления, без утечек",
  8203: "Предустановленные стратегии безопасности",
  8204: "5 видов стратегий безопасности на выбор, от процессов до распределения прав защищают данные компании",
  8205: "Организационная структура",
  8206: "Распределение отделов и структуры файлов по организационной структуре, разные отделы могут использовать разные стратегии безопасности",
  8207: "Управление отделами",
  8208: "Детальное управление использованием пространства отделов, персоналом, менеджерами, подотделами, стратегиями безопасности",
  8209: "Разделение прав администраторов",
  8210: "Администраторы могут делегировать права отделам, позволяя отделам управлять своим использованием, и назначать администраторов отделов. Разгружая IT-персонал.",
  8211: "Управление членами",
  8212: "Можно управлять всеми членами компании, внутренними и внешними",
  8213: "Массовое добавление, массовое редактирование",
  8214: "Можно массово добавлять и импортировать членов компании, быстро создавать аккаунты, email автоматически уведомляет членов",
  8215: "Передача одним кликом",
  8216: "Файлы уволенного члена одним кликом передаются другому члену",
  8217: "Быстрое отключение",
  8218: "Можно массово быстро отключить аккаунты конкретных сотрудников",
  8219: "Поиск и фильтрация",
  8220: "Мощные инструменты поиска и фильтрации, удобное быстрое управление членами",
  8221: "Ограничение пространства",
  8222: "Можно ограничить личное пространство хранения каждого пользователя, оптимизируя распределение пространства",
  8223: "Управление ролями и правами",
  8224: "Можно кастомизировать роли и соответствующие права, до 40 видов детальных прав на выбор и регулировку",
  8225: "Управление метками",
  8226: "Управлять или создавать общие метки всей компании, и просматривать использование меток",
  8227: "Управление одобрениями",
  8228: "Предустановить процессы одобрения, управлять существующими процессами и просматривать использование",
  8229: "Управление группами",
  8230: "Члены компании могут свободно быстро комбинироваться, временно создавать проектные группы. И управлять существующими группами, добавлять удалять членов в группах",
  8231: "Настройка водяного знака",
  8232: "Поддержка текстового водяного знака, водяного знака ID пользователя просмотра, изображение водяного знака. Можно управлять диапазоном применения, способом использования, способом отображения и прозрачностью и т.д.",
  8233: "Привязка MAC-адреса",
  8234: "Установить пул MAC-адресов, позволяя конкретным сотрудникам компании доступать к BabelBird только на конкретных устройствах",
  8235: "Журнал доступа",
  8236: "Детально записывает журнал использования BabelBird всей компании, детально проверяемо. Поддержка поиска и多种 способов фильтрации. Можно экспортировать.",
  8237: "Кастомная система безопасности для конфиденциальных компаний",
  8238: "От распределения прав до использования, от передачи до хранения. BabelBird предоставляет самую профессиональную защиту безопасности",
  8239: "Независимый контроль доступа для каждого файла",
  8240: "Можно независимо просмотреть и управлять контролем доступа каждого файла, добавлять или изменять права доступа",
  8241: "Настройка уровня безопасности файлов",
  8242: "Можно установить уровень безопасности любого корпоративного файла, четыре уровня: открытый, внутренний, ограниченный, конфиденциальный, разные уровни соответствуют разным стратегиям безопасности. Гарантируя безопасность на уровне файлов",
  8243: "Независимый проверяемый журнал для каждого файла",
  8244: "Гранулярность журналов до файла, можно просмотреть детальный журнал доступа каждого файла",
  8245: "С аннотациями, только просмотр может завершить общение",
  8246: "BabelBird поддерживает предпросмотр большинства файлов, и можно напрямую аннотировать предложения обсуждения на содержимом файла, значит, если не редактор файла, можно завершить работу без включения прав скачивания. Используя BabelBird, можно отключить права скачивания, максимально гарантируя, что файлы не утекают",
  8247: "Статистика посетителей файлов",
  8248: "Будь то внутренние члены, внешние члены или анонимные пользователи, посетители файлов могут быть статистированы и просмотрены в свойствах файла (анонимные показывают IP)",
  8249: "Настоящий водяной знак",
  8250: "В отличие от водяных знаков, отображаемых в интерфейсе обычных сетевых дисков, водяной знак BabelBird встроен в файл, и можно установить ID просмотра как водяной знак, эффективно гарантируя, что файл не распространяется через скриншоты.",
  8251: "Права обмена и шифрование",
  8252: "Правой кнопкой мыши напрямую открыть обмен ссылкой на файл, можно установить срок действия ссылки, пароль и различные права доступа",
  8253: "Безопасный способ сотрудничества через приглашения",
  8254: "Через приглашение поделиться файлом с конкретными людьми для сотрудничества, не-приглашённые аккаунты не могут войти, права приглашённых можно индивидуально регулировать",
  8255: "Обмен и приглашения могут быть авторизованы",
  8256: "Обмен и приглашения можно включить авторизацию, делая поведение обмена важных файлов управляемым",
  8257: "Управление поведением обмена",
  8258: "Контроль поведения обмена до файла, можно просмотреть управлять всеми записями обмена файлов и папок",
  8259: "Передача одним кликом уволенным сотрудникам",
  8260: "Файлы уволенного сотрудника одним кликом передаются приёмнику, сохраняя данные чата и аннотаций уволенного",
  8261: "Разделение внутренних и внешних файлов",
  8262: "BabelBird может разделять внутренние файлы (файлы компании и личные файлы сотрудников) и внешние файлы (файлы, загруженные другими компаниями или партнёрами) гарантируя источник файлов",
  8263: "Управление версиями",
  8264: "Изменения файлов навсегда сохраняют старые версии, предотвращая покрытие файлов из-за ошибок",
  8265: "Контроль корзины",
  8266: "В эффективный период (администратор может установить) удалённые корпоративные файлы обычными членами могут быть восстановлены или окончательно удалены вышестоящим руководителем, по уровням.",
  8267: "Структура много администраторов",
  8268: "Предотвращая слишком большие права администратора или незнакомость с бизнесом, вызывающие риски безопасности. BabelBird от общего управления до управления людьми, файлами, безопасностью разделяет администраторов на администратора компании, администратора архивов, администратора эксплуатации, офицера безопасности, аудитора безопасности и т.д. Адаптируясь к нуждам разных компаний",
  8269: "Владелец файла - отдел и компания",
  8270: "Владелец файлов в BabelBird - отдел и компания, отдел и компания имеют высшие права",
  8271: "Стратегии безопасности",
  8272: "5 видов стратегий безопасности на выбор, от процессов до распределения прав защищают данные компании, разные отделы могут установить разные стратегии безопасности, только офицер безопасности может установить стратегии отдела",
  8273: "Детальный просмотр журналов",
  8274: "Детально записывает журнал использования BabelBird всей компании (записи операций), можно экспортировать как доказательство. Можно фильтровать просмотр ситуации доступа конкретных членов",
  8275: "Вторичная верификация",
  8276: "Можно провести вторичную верификацию аккаунта через SMS на телефон",
  8277: "Ограниченные члены",
  8278: "Ограниченные члены не могут доступать к общей папке компании, не могут получать динамику компании",
  8279: "Управление внешними членами",
  8280: "Можно отдельно управлять не-членами компании, понимать ситуацию доступа внешних членов, удалять или изменять права внешних членов",
  8281: "Тонкое управление ролями и правами",
  8282: "Поддержка кастомных ролей и до 40 пунктов управления правами ролей",
  8283: "Контроль пространства использования членов",
  8284: "Точный контроль доступного пространства каждого члена",
  8285: "Привязка MAC-адреса",
  8286: "Можно привязать аккаунт пользователя к одному MAC-адресу или пулу MAC-адресов, ограничивая конкретных пользователей доступом только с конкретных устройств",
  8287: "Шифрование всей цепочки передачи и хранения",
  8288: "Файлы загружаются и скачиваются с использованием HTTPS в качестве протокола передачи, в процессе передачи к самим файлам применяется повторное шифрование AES CTR 256 с потоковой блочной обработкой, обеспечивая, что файлы, хранящиеся в облачной системе, являются зашифрованными, и исключая возможность кражи во время передачи и хранения",
  8289: "Высший уровень EV",
  8290: "Использование высшего уровня EV SSL для аутентификации передачи, получена оценка безопасности A+ от зарубежной третьей стороны Qualys",
  8291: "Множественные резервные копии",
  8292: "Облако использует сервис хранения Alibaba OSS, одна и та же копия данных распределяется по 4 узлам; для частного облака опционально применяется распределенное хранение и RAID-массивы для резервного копирования данных, обеспечивая отсутствие потери данных при повреждении оборудования",
  8293: "Проверка хэша MD5",
  8294: "Хранимые файлы на сервере проходят проверку хэша MD5, обеспечивая уникальность файлов и предотвращая их изменение",
  8295: "Фрагментированное хранение",
  8296: "Файлы разбиваются на фрагменты и хранятся на разных серверах, обеспечивая, что копирование диска не позволит получить полные данные для гарантии безопасности",
  8297: "Восстановление после катастроф",
  8298: "Облако основано на сервисе восстановления после катастроф Alibaba, с мощной функцией резервного копирования в удаленных местах, позволяющей быстро переключаться на данные без влияния на использование файлов пользователями; в чрезвычайных ситуациях быстро восстанавливать данные пользователей",
  8299: "Распределенная база данных",
  8300: "Распределенная база данных гарантирует стабильность и безопасность базы данных, а также скорость чтения/записи; в случае повреждения базы данных позволяет быстро восстановить",
  8301: "Защита YunDun",
  8302: "Облако использует защиту Alibaba YunDun для предотвращения взлома хакерами и атак DDoS",
  8303: "Миграция данных",
  8304: "Предоставление сервисов импорта и экспорта данных",
  8305: "Массив нескольких серверов",
  8306: "Функции и сервисы распределены по нескольким серверам, обеспечивая, что сбой одного сервера не повлияет на другие модули функций",
  8307: "Множественные платформы мониторинга",
  8308: "Использование нескольких сторонних платформ мониторинга, таких как Alibaba и Yunzhihui, для отслеживания работы всей системы; при аномалиях timely SMS-уведомления и предупреждения, персонал эксплуатации в режиме 7*24 часа наготове, обеспечивая стабильность платформы.",
  8309: "Сканирование безопасности третьей стороны",
  8310: "Использование платформ третьей стороны, таких как Qualys, для регулярного сканирования, поиска уязвимостей и timely устранения",
  8311: "Резерв для пиковых нагрузок",
  8312: "Облако при внезапных пиковых нагрузках автоматически увеличивает вычислительную мощность серверов и ограничивает пропускную способность для одного пользователя, обеспечивая доступность для корпоративных пользователей",
  8313: "Использование корпоративной версии облака повышает эффективность и обеспечивает более детальное управление",
  8314: "Бесплатный пробный период",
  8315: "Babelniao позволяет открывать и просматривать файлы более 200 форматов без установки приложений. Еще лучше: в Babelniao вы можете напрямую кликать на содержимое открытого файла, чтобы добавить аннотацию; после создания аннотации все ваши партнеры по сотрудничеству получат уведомление и смогут присоединиться к обсуждению деталей файла. Будь то прототип продукта или текст речи, все участники с правами доступа могут высказывать мнения в форме голоса, ручного рисунка, текста и прикреплять вложения. В то же время все изменения и обсуждения связанных с вами рабочих файлов вы можете timely видеть в ленте активности и напрямую отвечать, поддерживая",
  8316: "Будь то обмен ссылками (анонимный доступ показывает IP-адрес), приглашения или доступ внутри отдела — все операции имеют логи для просмотра и управления",
  8317: "Исполнительность предприятия опирается на дисциплину",
  8318: "Всесторонние правила для хранения и сотрудничества в предприятии",
  8319: "Корпоративная версия Babelniao имеет мощную административную панель предприятия, где вы можете не только выделять пространство для каждого члена, но и отслеживать использование пространства. Кроме того, вы можете быстро импортировать членов предприятия, создавать организационную структуру, управлять правами членов, предустанавливать стратегии безопасности. Также можно настраивать процессы одобрения, управлять тегами и ограничивать устройства, используемые пользователями. Предустановленные типы администраторов и делегирование прав снижают нагрузку на IT-персонал при обслуживании, одновременно повышая безопасность системы. До 40 опциональных ролей прав позволяют четко контролировать ответственность и права каждой роли члена. Можно сказать, что Babelniao имеет самую мощную и настраиваемую административную систему среди отечественных сетевых дисков, помогая предприятиям реализовать детальное управление.",
  8320: "Подробный список функций административной панели предприятия",
  8321: "Система безопасности, адаптированная для конфиденциальных предприятий",
  8322: "Babelniao предоставляет самую профессиональную защиту безопасности",
  8323: "Мы глубоко понимаем важность безопасности данных для предприятия и ставим безопасность в основу всей системы. При добавлении каждой новой функции首要考虑яется наличие уязвимостей безопасности и влияние на безопасность системы. Для безопасности, которую пользователь не видит, мы предпочитаем жертвовать частью производительности системы, использовать самые сложные методы разработки и нести дополнительные затраты. Конечно, мы получили отдачу: Babelniao получила рейтинг A+ в оценке безопасности Qualys, что является самым высоким среди отечественных корпоративных сетевых дисков. Кроме того, мы получили заказы от конфиденциальных предприятий с крайне высокими требованиями к безопасности данных. От распределения прав до использования, от передачи до хранения — Babelniao предоставляет самую профессиональную защиту безопасности!",
  8324: "Подробный список функций безопасности данных",
  8325: "Стратегии безопасности доступа к файлам",
  8326: "Безопасность передачи и хранения данных",
  8327: "Стратегии безопасности эксплуатации ",
  8328: "Стратегии безопасности для членов и отделов",
  8329: "Пожалуйста, выберите версию для регистрации",
  8330: "Персональная версия",
  8331: "Хранение персональных файлов, быстрое присоединение к сотрудничеству",
  8332: "Бесплатно",
  8333: "Удовлетворяет базовые потребности персонального использования. Просто, удобно, безопасно. Можно обновить до профессиональной версии для большего пространства хранения и более мощных функций.",
  8334: "Зарегистрироваться сейчас",
  8335: "Корпоративная версия облака",
  8336: "Детальное управление членами предприятия, ориентировано на малый и средний бизнес",
  8337: "/чел./мес.",
  8338: "Обильное пространство хранения, мощная административная панель и система контроля прав, независимый домен доступа, создавая эксклюзивные облачные сервисы для предприятия.",
  8339: "30 дней бесплатного пробного периода",
  8340: "Узнать о различиях версий",
  8341: "Проверка подлинности",
  8342: "Требуется проверка подлинности для присоединения к приглашению",
  8343: "Отправлено в{-time-}",
  8344: "»После нескольких раундов отбора продуктов мы в итоге выбрали Babelniao в качестве ядра хранения данных; тщательный сервис и всесторонние функции — причины нашего выбора.«",
  8345: "— Директор Ся, больница дружбы Китая и Японии",
  8346: "/чел./мес.",
  8347: "Обнаружено, что ваш номер телефона уже зарегистрирован в профессиональной версии Babelniao; если вы хотите обновить аккаунт до корпоративной версии, пожалуйста, свяжитесь с службой поддержки.",
  8348: "<p>\u0412\u0430\u0448 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u0443\u0436\u0435 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D \u0432 Babelniao, \u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435, \u0445\u043E\u0442\u0438\u0442\u0435 \u043B\u0438 \u0432\u044B \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u044D\u0442\u043E\u0442 \u0430\u043A\u043A\u0430\u0443\u043D\u0442 \u0434\u043E \u043A\u043E\u0440\u043F\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u0439 \u0432\u0435\u0440\u0441\u0438\u0438?</p>\n<p>\u0412\u044B\u0431\u043E\u0440 \xAB\u0414\u0430\xBB \u0432\u044B\u043F\u043E\u043B\u043D\u0438\u0442 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435; \u044D\u0442\u0430 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u044F \u043D\u0435\u043E\u0431\u0440\u0430\u0442\u0438\u043C\u0430 \u0438 \u043C\u043E\u0436\u0435\u0442 \u043F\u0440\u0438\u0432\u0435\u0441\u0442\u0438 \u043A \u043F\u043E\u0442\u0435\u0440\u0435 \u0434\u0430\u043D\u043D\u044B\u0445, \u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0441\u0434\u0435\u043B\u0430\u0439\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0443\u044E \u043A\u043E\u043F\u0438\u044E \u0434\u0430\u043D\u043D\u044B\u0445.</p>\n<p>\u0415\u0441\u043B\u0438 \u0432\u044B \u043D\u0435 \u0445\u043E\u0442\u0438\u0442\u0435 \u043E\u0431\u043D\u043E\u0432\u043B\u044F\u0442\u044C \u044D\u0442\u043E\u0442 \u0430\u043A\u043A\u0430\u0443\u043D\u0442, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \xAB\u041D\u0435\u0442\xBB \u0438 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u0443\u0439\u0442\u0435\u0441\u044C \u0432 \u043A\u043E\u0440\u043F\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u0439 \u0432\u0435\u0440\u0441\u0438\u0438 \u0441 \u0434\u0440\u0443\u0433\u0438\u043C \u043D\u043E\u043C\u0435\u0440\u043E\u043C \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430.</p>",
  8349: "Можно самостоятельно добавлять аккаунты членов предприятия",
  8350: "Операция с файлом не удалась: файл не существует или уже удален",
  8351: "Обновление не удалось, этот номер телефона уже существует",
  8352: "Этот номер телефона не зарегистрирован в Babelniao, кликните «Зарегистрироваться», чтобы перейти на страницу регистрации. Если у вас есть другие аккаунты Babelniao, вы можете войти с другого аккаунта и привязать номер телефона в настройках для входа.",
  8353: "Войти с другим аккаунтом",
  8354: "Зарегистрироваться",
  8355: "Создал этот файл",
  8356: "У вас нет прав или конфигурация файла не поддерживает эту операцию",
  ///////////////////////////////8.6.5 + /////////////////////
  8500: "Файл{-fileName-} отправлен в корпоративный порт отправки{-identifier-}, заявка на отправку файла, уже одобрена",
  8501: "Список отправок",
  8502: "Список получений",
  8503: "Дата отправки",
  8504: "Дата одобрения",
  8505: "Дата одобрения",
  8506: "Ожидает отправки",
  8507: "Дата получения",
  8508: "Предприятие не настроило порт отправки",
  8509: "Предприятие не настроило порт получения",
  ///////////////////////////////8.6.6 + /////////////////////

  8510: "Передача",
  8511: "Синхронизация",
  8512: "Все активности",
  8513: "Аннотации файлов",
  8514: "Клик для возврата назад",
  8515: "Клик для перехода вперед",
  8516: "Операция не удалась, у вас нет прав на очистку всех прав этого аккаунта",
  8517: "Расширенный",
  8518: "Расширенный поиск",
  8519: "Введите ключевые слова для поиска, несколько ключевых слов разделите пробелами",
  8520: "Показывать только результаты поиска, содержащие все ключевые слова",
  8521: "Ключевые слова поиска",
  8522: "Поиск по времени создания или времени съемки",
  8523: "Ограничение времени обновления файлов для поиска",
  8524: "Формат файла",
  8525: "Выберите типы файлов для поиска",
  8526: "Загрузчик",
  8527: "Область поиска",
  8528: "Ручной выбор папок для поиска",
  8529: "Тип поиска",
  8530: "Содержимое файлов (полный текст)",
  8531: "Клик для выбора членов",
  8532: "Выберите загрузчика",
  8533: "Время съемки",
  8534: "Размер",
  8535: "Разрешение",
  8536: "Модель устройства",
  8537: "Цветовое пространство",
  8538: "Место",
  8539: "Дополнительная информация (метаданные)",
  8540: "Все размеры",
  8541: "Большой размер (4K+)",
  8542: "Средний размер (1080P)",
  8543: "Маленький размер",
  8544: "Максимум 5 загрузчиков можно указать",
  8545: "Документы Office (включая документы WPS)",
  8546: "Документы PDF",
  8547: "Файлы изображений",
  8548: "Аудио- и видеофайлы",
  8549: "Введите расширения, несколько через ','",
  8550: "Пользовательский тип",
  8551: "Пожалуйста, введите ключевые слова поиска",
  8552: "Пожалуйста, выберите тип поиска",
  8553: "Время последнего доступа",
  8554: "Пожалуйста, выберите отдел",
  8555: "Статистика новых файлов предприятия",
  8556: "Отменить фильтр",
  8557: "Место съемки",
  8558: "（Файлы хранятся максимум 30 дней）",
  8559: "Загрузка метаданных изображений",
  8560: "Очистка не удалась, у вас нет прав на удаление оставшихся файлов",
  8561: "Выполнено{-cur-}/{-total-}",
  8562: "Выполнено{-cur-}",
  8563: "Пожалуйста, выберите папки для поиска",
  8564: "Показывать только перемещения и копирования",
  8565: "Статус получения подтверждается получателем; после получения отправитель не сможет изменить загруженные файлы.",
  8566: "Показывать только изменения отделов",
  8567: "Эта функция требует поддержки SMS-канала, пожалуйста, свяжитесь с службой поддержки",
  8568: "Может редактировать (включая удаление) свои файлы",
  8569: "",
  //////////////////////////////////*************8.7.0***************************////////

  8570: "Создать из выбранного шаблона",
  8571: "Просмотреть людей, имеющих доступ к текущему файлу (папке)",
  8572: "Источник персонала",
  8573: "Показывать только имя файла",
  8574: "Этот проект",
  8575: "Участники обмена",
  8576: "Использовать только пользовательские права",
  8577: "У вас нет прав на просмотр этого файла",
  8578: "Операция не удалась, у вас нет прав на создание папки или файла в этой директории",
  8579: "Настройки тегов",
  8580: "Настройки стиля",
  8581: "Пример",
  8582: "Размер иконки",
  8583: "Цвет фона тега",
  8584: "Содержимое тега",
  8585: "Использовать настройки по умолчанию",
  8588: "Без фона",
  8589: "Темно-серый",
  8590: "Кроваво-красный",
  8591: "Темно-синий",
  8592: "Пурпурно-красный",
  8593: "Ярко-желтый",
  8594: "салатовый",
  8595: "Светло-серый",
  8596: "Бледно-синий",
  8597: "Чисто черный",
  //////////////////////////////////*************10.0***************************////////
  8600: "Файл скачивается, пожалуйста, подождите",
  8601: "Файл скачивается...",
  8602: "Скачивание завершено",
  8603: "Скачивание завершено",
  8604: "Скачивание успешно",
  8605: "Приостановить скачивание",
  8606: "Скачать заново",
  8607: "Ожидает скачивания",
  //////////////////////////////////*************8.7.2***************************////////

  8650: "Экспорт в процессе",
  8651: "Экспорт в процессе, пожалуйста, подождите",
  ////////////////////////////*************menu*****************/////////// */

  8660: "Способ открытия",
  8661: "Обмен и сотрудничество",
  8662: "Организация",
  8663: "Очистить историю",
  8664: "Очистить историю",
  8665: "Удалить эту запись",
  /////////////////********************************************////////////// */

  //*********9500-9999 私有云独有字段*************//

  9500: "Синхронизация домена",
  9501: "Управление аккаунтами домена",
  9502: "Конфигурация сервера домена",
  9503: "Синхронизировать аккаунты домена",
  9504: "Присоединиться к Babelniao",
  9505: "Импортировать всех в Babelniao",
  9506: "Псевдоним",
  9507: "Название организации",
  9508: "Пока не синхронизировано никаких аккаунтов домена",
  9509: "Нет результатов запроса, соответствующих условиям",
  9510: "Псевдоним (email)",
  9511: "Является ли аккаунтом Babelniao",
  9512: "Адрес сервера домена",
  9513: "Аккаунт входа",
  9514: "Пароль входа",
  9515: "Тест связи",
  9516: "Соединение успешно",
  9517: "Импорт в процессе...",
  9518: "Импорт успешен",
  9519: "Импорт не удался, попробуйте позже",
  9520: "Синхронизация в процессе...",
  9521: "Соединение не удалось, измените параметры и попробуйте снова",
  9522: "Пока нет аккаунтов домена",
  9523: "Фоновая карта страницы входа",
  9524: "Поддерживается загрузка изображений в формате jpg и меньше 5 МБ. ",
  9525: "Обнаружен вирус",
  9526: "Открыть в {- name -}",
  9527: "Дополнительные модули",
  9528: "Рабочий номер или номер почтового ящика или мобильного телефона",
  9529: "Пожалуйста, введите рабочий номер или номер почтового ящика или мобильного телефона",
  9530: "Доменное имя не может быть пустым",
  9531: "Пожалуйста, введите рабочий номер",
  9532: "Номер работы",
  9533: "Имя и фамилия (рабочий номер)",
  9534: "Введите комбинацию прописных букв или цифр",
  9535: "Введите имя / рабочий номер / номер почтового ящика / или номер мобильного телефона",
  9536: "Система еще не настроила синхронизацию учетных записей",
  9537: "Рабочий номер уже существует",
  9628: "К сожалению, мы не поддерживаем гибридную загрузку файлов и папок в пакете. Вы можете скачать файлы и папки отдельно или связаться с корпоративным администратором, чтобы получить клиента для загрузки",
  //************易明******//
  9600: "К сожалению, мы не поддерживаем упаковку для скачивания более 100 файлов или папок размером более 500 МБ. Вы можете открыть папку и скачать файлы по одному или связаться с суперадминистратором для получения клиента для скачивания",
  /****************7.3***************/

  9900: "Клик для смены изображения验证码",
  9901: "Вход в частное облако",
  9902: "Вход с email или мобильным паролем",
  9904: "Войти в частное облако",
  9905: "Пожалуйста, введите домен вашего предприятия",
  9906: "Домен предприятия",
  9907: "Я прочитал и принимаю",
  9908: "Babelniao активно отвечает на призыв национальной акции по очистке сети и будет строго бороться с незаконным контентом в системе. Все загруженные пользователем материалы будут автоматически проверены ИИ; аккаунты с непристойным или порнографическим контентом будут автоматически заблокированы, и информация будет передана в органы公安",
  9909: "Установить пароль",
  9910: "Введите 10 - 20 - битные комбинации, содержащие большие буквы, специальные символы и цифры",
  9911: "Текущая отраслевая организация и номер счета синхронизированы с {-type-}, автоматически в",
  9912: "Корпоративные гвозди",
  9913: "WeChat Work",
  9914: "Центральная станция",
  9915: "Сервер управления доменом",
  9916: "Дальняя открытая платформа",
  9917: "База данных OA",
  9918: "Автосинхронизация один раз, вы также можете нажать кнопку ниже, чтобы синхронизировать прямо сейчас!",
  9919: "Время синхронизации учетной записи установлено успешно",
  9920: "Ошибка синхронизации учетной записи",
  9921: "Feishu",
  9922: "База данных NC",
  9950: "Игнорировать",
  9951: "Текущая страница уже обновлена",
  9952: "Регион",
  9953: "Сброс в процессе...",
  9954: "Не удалось распаковать",
  9955: "В декомпрессии, пожалуйста, позже",
  9956: "Введите пароль декомпрессии",
  9957: "Компрессионный пакет имеет пароль",
  9958: "Пока не поддерживается распаковка RAR - файлов в сжатом формате Rar5 и выше",
  9959: "Ошибка распаковки пароля, ошибка распаковки",
  9980: "Обновление",
  9981: "Базовый модуль",
  9982: "Модуль конфиденциальности",
  9983: "Архивный модуль",
  9984: "Модуль отправки сообщений и корпоративных уведомлений",
  9985: "Модуль утверждения",
  9986: "Рабочий модуль",
  9987: "Модуль дискуссионной группы",
  9988: "Модуль почтового ящика",
  9989: "Модуль модификации персональных данных",
  9990: "Модуль хранения почты",
  9991: "Модуль настройки подписи",
  9992: "WeChat Work",
  9993: "Dingtalk",
  9994: "Фоновые картинки",
  9995: "Feishu",
  9996: "Войти в систему с помощью пароля учетной записи",
  9997: "WeChat Work",
  9998: "Dingtalk",
  9999: "Feishu"
};
var _default = exports["default"] = localString_ru_part2_1;

},{"1454":1454}],1165:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require(1180));
var _localString_ru_part;
var localString_ru_part2 = (_localString_ru_part = {
  /////////////////////////////**************************8.7.1***************************//

  5000: "Настройки подписи",
  5001: "Тип отчёта",
  5002: "Согласование файлов",
  5003: "Рецензирование чертежей",
  5004: "Добавить вложение",
  5005: "Здесь вы можете настроить права доступа к файлам вашей компании, права выбора для проектов и права контроля доступа к файлам. Определённые здесь права появятся в списках выбора разрешений для вышеупомянутых функций.",
  5006: "Поиск по названию прав доступа к файлам",
  //----------------6.6-------------

  5007: "После удаления учётной записи все файлы, принадлежащие ей, также будут удалены. Пожалуйста, выполняйте это действие с осторожностью.",
  5008: "История приглашений к доступу",
  5009: "Время приглашения",
  5010: "Личные файлы",
  5011: "Псевдоним",
  5012: "Чёрный фон",
  5013: "Белый фон",
  5014: "Фон по умолчанию",
  5015: "Повернуть на 90°",
  5016: "Добавить подпись",
  5017: "Изменение цвета фона действует только для изображений с прозрачным фоном!",
  5018: "Больше не напоминать",
  5019: "Подтвердить восстановление учётной записи <strong>{-userName-}</strong>?",
  5020: "Подтвердить деактивацию учётной записи <strong>{-userName-}</strong>?",
  5021: "После настройки подписи вы сможете использовать её при предварительном просмотре утверждённых вами документов.",
  5022: "Пожалуйста, введите вашу подпись в области ниже, а затем нажмите 'Сохранить'.",
  5023: "Вы уверены, что хотите удалить эту подпись?",
  5024: "Эта подпись уже используется и не может быть удалена.",
  5025: "Текущая используемая подпись",
  5026: "Используйте это",
  5027: "Не удалось обновить!",
  5028: "Настройки общего доступа",
  5029: "Напомнить отслеживать файл",
  5030: "Свойства файла",
  5031: "Добавить",
  5032: "Файл был безвозвратно удалён.",
  5033: "Не удалось удалить файл, попробуйте позже.",
  5034: "Файл восстановлен в исходное местоположение.",
  5035: "Не удалось восстановить файл, попробуйте позже.",
  5036: "Тип файла новой версии должен совпадать с типом файла старой версии.",
  5037: "Скачать файл?",
  5038: "Отмена",
  5039: "Открыть в {-type-}",
  5040: "Выберите 'Открыть в браузере'",
  5041: "Пожалуйста, используйте функцию 'Ещё' в правом верхнем углу WeChat.",
  // 5042: "Доступ к этому файлу разрешён только приглашённым пользователям. Пожалуйста, войдите, используя email, на который было отправлено приглашение!",
  5042: "Данный файл не поддерживает анонимный доступ, пожалуйста, войдите",
  5043: "Владелец закрыл доступ к этому файлу, вы больше не можете просматривать документ!",
  5044: "Вы уверены, что хотите покинуть общий доступ?",
  5045: "Выбрано более 30 человек, продолжить?",
  5046: "У вас нет прав для просмотра участников компании!",
  5047: "Пожалуйста, введите пароль длиной 6-20 символов, содержащий заглавные и строчные буквы, а также цифры.",
  5048: "Ваша учётная запись была заблокирована суперадминистратором.",
  5049: "Вы были удалены из этой компании суперадминистратором.",
  5050: "Извините, {-str-}, нажмите ОК для выхода.",
  5051: "Сеть недоступна, проверьте ваше интернет-соединение.",
  5052: "Анонимным пользователям доступ запрещён!",
  5053: "Не удалось переместить файл.",
  5054: "В целевой папке не поддерживается создание папок.",
  5055: "Создать подпапку",
  5056: "Не удалось загрузить каталог файлов.",
  5057: "Не удалось удалить группу.",
  5058: "Проблемы с сетью. Пожалуйста, обновите страницу и попробуйте снова.",
  5059: "Бесплатная версия не поддерживает предпросмотр этого типа файлов. Пожалуйста, обновите вашу версию при необходимости.",
  5060: "Введите пароль, чтобы открыть этот PDF-файл.",
  5061: "Автор",
  5062: "Ключевые слова",
  5063: "Дата изменения",
  5064: "Создатель",
  5065: "Количество страниц",
  5066: "Подготовка документа к печати...",
  5067: "Не удалось открыть файл.",
  5068: "Доступ к файлу запрещён.",
  5069: "Предпросмотр этого файла временно не поддерживается.",
  5070: "Выйти из режима редактирования",
  5071: "Удалить связь",
  5072: "Вы уверены, что хотите удалить эту связь с файлом?",
  5073: "Не удалось заблокировать, редактирование невозможно. Код ошибки:",
  5074: "Одобрить вступление",
  5075: "Отклонить вступление",
  5076: "Вы уверены, что хотите удалить этого участника?",
  5077: "Администратор",
  5078: "(я)",
  5079: "Описание команды",
  5080: "Не в команде",
  5081: "Ожидает одобрения",
  5082: "Неизвестная ошибка сервера, попробуйте позже.",
  5083: "Название команды (до 40 символов)",
  5084: "Название команды не может быть пустым.",
  5085: "Описание команды (до 100 символов)",
  5086: "Не удалось обновить!",
  5087: "выход",
  5088: "Не удалось удалить, попробуйте позже.",
  5089: "Не удалось обновить!",
  5090: "Ещё не присоединился",
  5091: "Ошибка в изображении, не удаётся открыть!",
  5092: "У вас нет прав на просмотр версии, к которой относится эта аннотация.",
  5093: "Внимание: вы просматриваете не последнюю версию!",
  5094: "Точка аннотации удалена.",
  5095: "Не удалось сохранить рисунок, попробуйте позже.",
  5096: "Это действие приведёт к выходу из текущей демонстрации. Выйти и продолжить?",
  5097: "Не удалось закрыть демонстрацию, попробуйте позже.",
  5098: "Не удалось выйти из демонстрации, попробуйте позже.",
  5099: "Ваша сессия в браузере истекла, необходимо снова войти в систему.",
  5100: "Пароль пользователя был сброшен, нажмите ОК для выхода.",
  5101: "Администратор ограничил вход по вашему MAC-адресу. Нажмите ОК для выхода.",
  5102: "Вы были выведены из системы. Нажмите ОК для выхода.",
  5103: "Ваша учётная запись заблокирована системой. Для восстановления свяжитесь со службой поддержки. Нажмите ОК для выхода.",
  5104: "Ваша сессия истекла, пожалуйста, войдите снова.",
  5105: "😞😞😞 Произошла ошибка соединения. Просто обновите страницу.",
  5106: "Обновить",
  5107: "Не удалось присоединиться, команда заполнена!",
  5108: "Содержимое файла было изменено, пожалуйста, выберите:",
  5109: "Не сохранять",
  5110: "Введите содержимое файла.",
  5111: "Длина",
  5112: "Показать всё",
  5113: "Версия вашего браузера устарела. Рекомендуется обновиться до IE11 или выше.",
  5114: "Вам необходимо войти в систему.",
  5115: "Вы уверены, что хотите удалить эту команду?<br>Все её файлы будут автоматически удалены без возможности восстановления!",
  5116: "Вы уверены, что хотите покинуть эту команду?",
  5117: "Ошибка в параметрах.",
  5118: "Время ожидания истекло.",
  5119: "Невозможно просмотреть файл, пожалуйста, скачайте его.",
  5120: "Ошибка обработки файла, предпросмотр временно не поддерживается.",
  5121: "Это зашифрованный документ. Для просмотра и редактирования, пожалуйста, скачайте его.",
  5122: "Файл повреждён или информация о нём неполная. Пожалуйста, скачайте для просмотра.",
  5123: "Файл слишком большой, создание файла для предпросмотра временно не поддерживается.",
  5124: "Презентация пуста.",
  5125: "Произошла неизвестная ошибка, обратитесь к администратору.",
  5126: "Сервер обрабатывает запрос.",
  5127: "Ограничить использование личного пространства для этого участника.",
  5128: "В этом случае объём пространства, занимаемый участником, не будет ограничен в пределах доступного пространства его отдела.",
  5129: "Общий объём пространства, доступный для настройки в отделе этого участника.",
  5130: "Пространство, уже занятое этим участником.",
  5131: "Ограничение личного пространства",
  5132: "Ограничение пространства отдела",
  5133: "Нет папок для сбора файлов, куда вы могли бы отправить документ.",
  5134: "Вы не создавали папок для сбора файлов.",
  5135: "Новый пароль:",
  5136: "Подтвердите новый пароль:",
  5137: "Подтвердите новый пароль:",
  5138: "пароль",
  5139: "Не удалось изменить пароль.",
  5140: "Узнать о роли участника",
  5141: "Ограничение пространства для сотрудника",
  5142: "Если установленное значение равно занятому пространству, загрузка нового контента будет невозможна.",
  5143: "Ластиком нельзя стирать линии, нарисованные другими пользователями!",
  5144: "Добавленные здесь разделы будут отображаться в рабочем пространстве каждого корпоративного пользователя.",
  5145: "Добавить комментарий к утверждению",
  5146: "Комментарий к утверждению в прямоугольнике",
  5147: "Комментарий к утверждению в круге",
  5148: "Комментарий к утверждению со стрелкой",
  5149: "Текстовый комментарий к утверждению",
  5150: "Не удалось скачать файл.",
  5151: "Уведомлён",
  5152: "Ожидает получения",
  5153: "Я сделал графическую пометку, нажмите на изображение ниже, чтобы посмотреть.",
  5154: "Сообщение было отозвано.",
  5155: "Не удалось загрузить файл.",
  5156: "Комментарии к файлу",
  5157: "Не удалось скачать документ.",
  5158: "Нажмите здесь, чтобы ввести текст аннотации.",
  5159: "Поиск по тексту",
  5160: "Выделите текст в документе с помощью мыши, чтобы создать аннотацию.",
  5161: "По размеру",
  5162: "Список версий",
  5163: "Пожалуйста, используйте функцию WeChat в правом верхнем углу: Открыть в браузере.",
  5164: " аннотаций",
  5165: "Последняя версия",
  5166: "Текущая версия",
  5167: "Версия {-v-}",
  5168: "Инициатор не может участвовать в рецензировании.",
  5169: "Этот пользователь уже является рецензентом.",
  5170: "Ход утверждения",
  5171: "Добавить утверждающего",
  5172: "Нажмите здесь, чтобы перейти к следующему этапу утверждения.",
  5173: "Нажмите здесь, чтобы завершить утверждение.",
  5174: "Администратор прав доступа к файлу",
  5175: "Недопустимый формат 3D-файла.",
  5176: "Операция не удалась, проверьте сетевое подключение.",
  5177: "",
  5178: "",
  5179: "",
  5180: "",
  5181: "",
  5182: "Идёт архивация папки, пожалуйста, подождите.",
  5183: "Для папок, содержащих более {-multiFilesCount-} файлов или размером более {-multiFilesSize-}, используйте клиент для скачивания.",
  5184: "",
  5200: "Пожалуйста, введите положительное целое число для количества скачиваний.",
  /*********************HQSM*************************/

  5201: "Выберите тип проекта",
  5202: "Создать обычный проект",
  5203: "Управление документацией",
  5204: "Создайте независимое общее пространство для проекта, где назначенный руководитель проекта будет распределять права доступа участникам. Можно приглашать другие отделы и даже внешних пользователей для совместной работы.",
  5205: "Специально разработано для управления документацией проекта. Специалисты по документообороту могут отправлять файлы заказчикам и подрядчикам. Каждая отправка строго регистрируется, автоматически генерируется накладная, доступно управление и поиск.",
  5206: "Менеджер по документообороту",
  5207: "Нажмите, чтобы выбрать менеджера по документообороту",
  5208: "Специалист по документообороту",
  5209: "Нажмите, чтобы выбрать специалиста по документообороту",
  5210: "Другие участники",
  5211: "Правило нумерации версий",
  5212: "Введите префикс",
  5213: "Введите информацию, которая должна отображаться в сопроводительной ведомости (TRANSMITTAL), например, контактные данные, адрес, телефон и т.д.",
  5214: "Нажмите, чтобы выбрать других участников",
  5215: "Алфавитный порядок (ABC)",
  5216: "Числовой порядок (123)",
  5217: "Информация о получателе",
  5218: "Введите имя получателя",
  5219: "Введите email, несколько адресов разделяйте точкой с запятой (;)",
  5220: "Нажмите, чтобы ввести",
  5221: "Правило нумерации накладных",
  5222: "Выберите правило кодирования",
  5223: "Числовой порядок (1-2-3)",
  5224: "Алфавитный порядок (a-b-c)",
  5225: "Дата + число, например: 20200123001",
  5226: "Введите текст",
  5227: "Пусто",
  5228: "Подрядчик",
  5229: "Заказчик",
  5230: "Добавить получателя",
  5231: "Добавить проект",
  5232: "Список накладных на отправку",
  5233: "Управление проектом",
  5234: "Синхронизировать эту папку",
  5235: "Отменить синхронизацию",
  5236: "Поиск по номеру накладной или отправителю, нажмите Enter для подтверждения",
  5237: "Список передачи файлов проекта по документообороту {-name-} (TRANSMITTAL List)",
  5238: "Для этого проекта ещё не создано накладных.",
  5239: "Нет накладных, соответствующих условиям.",
  5240: "Номер накладной (Transmittal NO.)",
  5241: "Статус получения",
  5242: "Не получено",
  5243: "Получено",
  5244: "Отправить повторно",
  5245: "Основная информация",
  5246: "Основная информация о проекте",
  5247: "Всего в проекте {-num-} получателей",
  5248: "Управление получателями проекта",
  5249: "Участники проекта",
  5250: "Управление руководителями проекта",
  5251: "Добавить менеджера по документообороту",
  5252: "Добавить специалиста по документообороту",
  5253: "Добавить других участников",
  5254: "Управление проектом по документообороту",
  5255: "Копия (CC)",
  5256: "Тип отправляемого файла",
  5257: "Оригинал",
  5258: "Сканированная копия",
  5259: "TRANSPARENCY",
  5260: "LINEN",
  5261: "Номер файла",
  5262: "Описание",
  5263: "Способ обработки",
  5264: "Подтверждающее лицо",
  5265: "Составитель и отправитель",
  5266: "По умолчанию - отправитель",
  5267: "Введите сопроводительное сообщение для email",
  5268: "Отправить файлы",
  5269: "Отправить файлы",
  5270: "Для архивации",
  5271: "Для ознакомления",
  5272: "Для внесения правок",
  5273: "Для утверждения",
  5274: "Нажмите, чтобы ввести описание",
  5275: "Дата отправки",
  5276: "Список вложений",
  5277: "Сопроводительная ведомость",
  5278: "Экспорт в PDF",
  5279: "Номер накладной",
  5280: "Номер накладной",
  5281: "Мы рады предоставить следующие документы:",
  5282: "Составитель",
  5283: "Подпись",
  5284: "Должность",
  5285: "transmittal info",
  5286: "История отправки файлов",
  5287: "Просмотреть историю отправки файлов",
  5288: "Срок рассмотрения",
  5289: "Версия: {-ver-}",
  5290: "Хронологический порядок",
  5291: "Тип получателя",
  5292: "Пожалуйста, введите правильный Transmittal Number",
  5293: "Пожалуйста, введите email, разделяя адреса точкой с запятой",
  5294: "Успешно отправлено.",
  5295: "Файлы успешно отправлены. Хотите просмотреть детали сопроводительной ведомости (TRANSMITTAL)?",
  5296: "Transmittal NO.",
  5297: "Отправитель",
  5298: "Дата отправки",
  5299: "Отправленная версия",
  5300: "Номер версии",
  5301: "Просмотреть сопроводительную ведомость",
  5302: "Введите номер сопроводительной ведомости",
  5303: "Количество файлов",
  5304: "Просмотрено",
  5305: "Не просмотрено",
  5306: "Количество файлов: {-num-}, Занимаемое место: {-size-}",
  5307: "Для этого проекта не настроены получатели, отправка файлов временно не поддерживается. Если вам нужно отправить файлы, свяжитесь с менеджером по документообороту.",
  5308: "Последовательная нумерация: 001, 002...",
  5309: "Последовательная нумерация: 0001, 0002...",
  5310: "Выберите пользователя",
  5311: "Неверный формат. Пожалуйста, введите правильный email, разделяя адреса точкой с запятой.",
  5312: "Версия",
  //hqsm 版本
  5313: "Номер",
  5314: "Редактировать онлайн",
  5315: "Администраторы",
  5316: "Восстановить все файлы",
  5317: "Восстановить текущую папку",
  5318: "Удалить текущую папку навсегда",
  5400: "После нажатия 'Присоединиться', если появится запрос на вход, введите логин и пароль. Если у вас нет аккаунта Babel, пожалуйста, нажмите здесь.",
  5401: "Введите название тега и нажмите Enter для подтверждения, или нажмите кнопку тегов справа, чтобы выбрать тег.",
  5402: "Введите название тега.",
  5403: "Создать папку",
  5404: "Создать файл",
  5405: "Вы не можете пригласить самого себя.",
  5406: "Перезаписать уровень безопасности для дочерних файлов?",
  5407: "Перезаписать",
  5408: "Не перезаписывать",
  5409: "'Перезаписать' означает, что если уровень конфиденциальности дочернего файла выше текущего, ему будет присвоен текущий уровень.",
  5410: "Процесс утверждения ещё не настроен.",
  5411: "Проект по документообороту",
  /************8.5*******************/
  5412: "Применить эту настройку ко всем последующим файлам",
  5413: "Массово установить, разрешено ли выбранным пользователям иметь личные файлы.",
  5414: "Скачать наши примеры",
  5415: "QR-код скопирован в буфер обмена.",
  5416: "Скопировать QR-код в буфер обмена",
  5417: "Отсканируйте код, чтобы открыть ссылку",
  5418: "Для использования этой функции, пожалуйста, используйте протокол HTTPS в Google Chrome.",
  5419: "Выберите файлы для утверждения",
  /*****************8.5.1***************/
  5450: "Запросить отправку файлов следующим пользователям",
  5451: "Файлы для отправки",
  5452: "Просмотреть участников и группы компании",
  5453: "Файл больше не существует.",
  5454: "Выберите режим синхронизации для этой папки",
  5455: "Двусторонняя синхронизация",
  5456: "Локальные и облачные файлы идентичны. Локальные изменения синхронизируются в облако, а облачные — на локальное устройство.",
  5457: "Односторонняя синхронизация (с облака)",
  5458: "Локальные изменения не синхронизируются в облако, но облачные изменения синхронизируются на локальное устройство.",
  5459: "Глобальная сортировка по умолчанию",
  5460: "После установки все папки будут использовать выбранный метод сортировки по умолчанию. Однако, если вы измените сортировку в списке какой-либо папки, система запомнит последний использованный метод.",
  5461: "Данные списка сгенерированы, пожалуйста, подождите.",
  5462: "Проверка не пройдена",
  5463: "Ожидание проверки...",
  5464: "Сотрудник из конфиденциального отдела {-user-} запрашивает доступ к общему файлу {-file-} отдела {-dep-}. Одобрить?",
  5465: "Сотрудник из конфиденциального отдела {-user-} запрашивает доступ к общему файлу {-file-}. Одобрить?",
  5466: "Конфиденциальный отдел {-user-} запрашивает доступ к общему файлу {-file-} отдела {-dep-}. Одобрить?",
  5467: "Конфиденциальный отдел {-user-} запрашивает доступ к общему файлу {-file-}. Одобрить?",
  5468: "Нажмите здесь, чтобы зарегистрировать корпоративную версию в публичном облаке.",
  5469: "Сотрудник из конфиденциального отдела {-user-} присоединяется к проекту {-file-} отдела {-dep-}. Одобрить?",
  5470: "Сотрудник из конфиденциального отдела {-user-} присоединяется к проекту {-file-}. Одобрить?",
  5471: "Конфиденциальный отдел {-user-} присоединяется к проекту {-file-} отдела {-dep-}. Одобрить?",
  5472: "Конфиденциальный отдел {-user-} присоединяется к проекту {-file-}. Одобрить?",
  5473: "Получение данных для предпросмотра...",
  5474: "У вас нет прав доступа к этому файлу.",
  5475: "Просматривать только записи конфиденциального утверждения",
  5476: "Вы можете отозвать это утверждение и установить его как",
  /*****************8.5.2***************/

  5500: "Список IP-политик",
  5501: "Пользовательские IP-политики для компании отсутствуют.",
  5502: "Применимый диапазон IP",
  5503: "Тип политики",
  5504: "Добавить политику скачивания",
  5505: "Дайте политике название для удобства использования.",
  5506: "Тип политики",
  5507: "Запретить скачивание",
  5508: "Разрешить скачивание",
  5509: "Редактировать политику скачивания",
  5510: "Если выбрать 'Разрешить скачивание', то после вступления политики в силу устройствам с IP-адресами вне диапазона будет запрещено скачивать файлы.",
  5511: "Политики для сотрудников отдела",
  5512: "Политика",
  5513: "Выберите политику",
  5514: "Создать политику",
  5515: "Создать политику",
  5516: "Добавить IP",
  5517: "Авторизация",
  5518: "Начальный IP",
  5519: "Конечный IP",
  5520: "Приоритет",
  5521: "Область применения",
  5522: "Разрешить авторизацию",
  5523: "Запретить авторизацию",
  5524: "Кем изменено",
  5525: "Все участники",
  5526: "Администраторы",
  5527: "Обычные участники",
  5528: "Политики для сотрудников отдела отсутствуют.",
  5529: "192.168.2.5",
  5530: "192.168.2.98",
  5531: "Введите от 1 до 100, где 1 — наивысший приоритет.",
  5532: "Введите положительное целое число от 1 до 100.",
  5533: "Введите корректный IP-адрес.",
  5534: "Для этого отдела уже существует IP-политика.",
  5535: "Если необходимо удалить эту политику, сначала удалите отделы, использующие её.",
  5536: "Срок хранения исторических версий файлов",
  5537: "Установка значения 0 означает бессрочное хранение истории версий.",
  5538: "Количество хранимых исторических версий файлов",
  5539: "Примечание: количество хранимых версий можно изменить в диапазоне 1-999, 0 — бессрочное хранение.",
  5540: "Введите количество версий",
  5541: "Добавьте IP-политику.",
  5542: "Этому пользователю запрещено скачивать файлы с текущего IP-адреса.",
  5543: "Персональная версия не поддерживает онлайн-просмотр этого типа файлов. Для просмотра обновитесь до Профессиональной или Корпоративной версии.",
  5544: "Пожаловаться",
  5545: "Показать",
  5546: "Скрыть",
  5547: "Вы уверены, что этот общий ресурс содержит нелегальную информацию и хотите сообщить об этом администраторам сайта?",
  5548: "Жалоба успешно отправлена.",
  5549: "Не удалось получить информацию о пользователе.",
  5550: "Сохранить на диск",
  5551: "Если клиент уже установлен",
  5552: "Если клиент не установлен",
  5553: "Корпоративный диск для совместной работы",
  5554: "Скачать сейчас",
  5555: "Скачать приложение Babel",
  5556: "Направление",
  5557: "Скачивание и загрузка",
  5558: "Этому пользователю запрещено загружать файлы с текущего IP-адреса.",
  5559: "Удалено",
  5560: "Количество внешних сотрудников: 10",
  5561: "Неограниченное количество внешних сотрудников",
  5562: "Срок истекает через {-day-} дней",
  5563: "Срок истекает через {-hour-} часов",
  //--------------------6.2---------------
  6000: "Ожидает получения",
  6001: "Получено",
  6002: "Возвращено",
  6003: "Обработать документ",
  6004: "Принять",
  6005: "Вернуть",
  6006: "Комментарий к обработке",
  6007: "Оператор",
  6008: "Статус документа",
  6009: "{-somebody-} принял(а) документ {-file-} с комментарием: {-comment-}",
  6010: "{-somebody-} отклонил(а) документ {-file-} с комментарием: {-comment-}",
  6011: "Дата утверждения",
  6012: "принял(а) ваш документ {-file-} с комментарием: {-comment-}",
  6013: "отклонил(а) ваш документ {-file-} с комментарием: {-comment-}",
  6014: "загрузил(а) новую версию для файла {-file-} в папке {-parent-}",
  6015: "загрузил(а) новый файл в папку {-parent-}",
  6016: "Список файлов с доступом",
  6017: "Список скачанных файлов",
  6018: "Список загруженных файлов",
  6019: "Список файлов с аннотациями",
  6020: "Список файлов с комментариями",
  6021: "Информация о папке для сбора файлов",
  6022: "Нет доступных пунктов меню.",
  6023: "Соответствующие документы",
  6024: "Релевантность",
  //****************6.3******
  6025: "При запуске утверждения сотрудники отдела могут настраивать процесс и утверждающих лиц.",
  6026: "При запуске утверждения сотрудники отдела могут выбирать из всех процессов, предварительно настроенных в панели администратора.",
  6027: "Выберите несколько из предварительно настроенных в панели администратора процессов для использования в отделе.",
  6028: "Использовать настройки процесса утверждения вышестоящего отдела.",
  /*****  6.4  *****/
  6029: "Убрать карточку",
  6030: "Настройки участников проекта",
  6031: "Все в проекте",
  6032: "Все обычные участники проекта без дополнительных прав.",
  6033: "Запрос прав на файл",
  6034: "Запросить права",
  6035: "Управление корзиной",
  6036: "{-user-} приглашает вас принять участие в следующем проекте",
  6037: "Расположение проекта",
  6038: "Передать проект",
  6039: "Передать сотруднику проекта",
  6040: "Выберите руководителя проекта",
  6041: "Автор отзыва",
  6042: "Описание отзыва",
  6043: "Обработка отзыва",
  6044: "Список отзывов рецензентов",
  6045: "Список комментариев к утверждению",
  6046: "Действия по утверждению",
  6047: "Отправить на утверждение",
  6048: "Совместное подписание",
  6049: "Утвердить файл",
  6050: "Уважаемый пользователь, использование пространства вашего аккаунта достигло {-per-}",
  6051: "Уважаемый пользователь, использование пространства вашей компании достигло {-per-}",
  6052: "Вернуться к бесплатной версии",
  6053: "Вы уверены, что хотите перейти на тариф для обычных пользователей? Это приведёт к уменьшению вашего пространства и снижению качества обслуживания!",
  6054: "Участники общего доступа",
  6055: "Повернуть",
  6056: "Онлайн-просмотр этого файла временно не поддерживается. Хотите открыть его с помощью локального приложения?",
  6057: "Ошибка удаления, ошибка сервера.",
  6058: "Подтвердите деактивацию аккаунта внешнего сотрудника - {-name-}?",
  6059: "Подтвердите удаление аккаунта внешнего сотрудника - {-name-}?",
  6060: "Удалить",
  6061: "У вас нет прав на перемещение файлов в целевую папку.",
  6062: "Сопроводительное сообщение",
  /**6.6*************/
  6063: "Пока не состоит в других командах.",
  6064: "Добавить из часто используемых контактов",
  6065: "Введите номер телефона приглашаемого (нажмите Enter или Tab для подтверждения), можно добавить несколько номеров.",
  6066: "Введите номер телефона.",
  /***************6.7************/

  6067: "Папка для совместной публикации",
  6068: "Если включить эту опцию, в разделе файлов компании у всех появится папка для совместной публикации. Все сотрудники смогут загружать в неё файлы. Права на управление этой папкой есть у суперадминистратора.",
  6069: "Отправлено",
  6070: "Не отправлено",
  6071: "Всего",
  6072: "чел.",
  6073: "Статус отправки",
  6074: "Статистика получения",
  6075: "Не отправлено",
  6076: "Отправлено",
  6077: "Нет информации об отправках.",
  6078: "Для текущего аккаунта не установлен пароль. Вы можете войти с помощью SMS-кода и затем установить пароль. Перейти",
  6079: "Войти снова",
  6080: "Получить ссылку-приглашение",
  6081: "копировать",
  6082: "Ссылка скопирована в буфер обмена.",
  6083: "Отправьте эту ссылку соответствующим лицам. После перехода по ссылке, регистрации или входа, они подадут заявку на вступление в команду. После одобрения администратором они станут участниками команды.",
  6084: "Только офицер по безопасности компании может настраивать политики безопасности файлов.",
  6085: "{-sign-} ваш запрос по {-typeStr-} {-fileName-}",
  6086: "Запросить присоединение к {-type-} {-file-}",
  6087: "Запросить присоединение к {-type-}",
  6088: "Ожидание проверки администратором",
  6089: "Нет прав доступа к файлу, ожидание проверки администратором.",
  6090: "Открыть в Babel",
  6091: "Вы можете просмотреть этот файл в разделе 'Общие для меня'.",
  6092: "Политика безопасности ещё не настроена."
}, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, "6092", "Корневой отдел"), 6093, "Отправьте эту ссылку соответствующим лицам. После перехода, регистрации или входа они подадут заявку на присоединение к проекту. После одобрения руководителем проекта они будут добавлены."), 6094, "Название команды"), 6095, "Название проекта"), 6096, "Ожидание проверки руководителем проекта"), 6097, "Руководитель проекта"), 6098, "Нет прав доступа к файлу, ожидание проверки руководителем проекта."), 6099, "установил(а) для комментария {-comment-} в файле {-file-} статус {-finish-}"), 6100, "Общий доступ по ссылке отключён."), 6111, "Название утверждения"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6112, "Список файлов"), 6113, "Копировать файлы"), 6114, "Копирование завершено"), 6115, "Показать прогресс копирования файлов"), 6116, "присоединился к проекту"), 6117, "Ваша компания не приобрела модуль утверждения, эта функция временно недоступна."), 6118, "Ваша компания не приобрела модуль безопасности, эта функция временно недоступна."), 6119, "Ваша компания не приобрела модуль архивации, эта функция временно недоступна."), 6120, "Приглашение отправлено, пожалуйста, ожидайте ответа."), 6121, "Заметка внутри компании"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6122, "Изменить заметку внутри компании"), 6123, "Это действие необратимо. Подтвердите удаление этого уведомления?"), 6124, "приглашает вас присоединиться к компании"), 6125, "Нажмите, чтобы присоединиться. Вы станете сотрудником этой компании, ваша личная версия будет аннулирована, а существующие файлы автоматически перенесены в эту компанию."), 6126, "Babel не поддерживает загрузку скрытых файлов."), 6127, "У вас нет прав на загрузку файлов в этот каталог."), 6128, "Нажмите, чтобы добавить описание файла"), 6129, "Нажмите, чтобы добавить описание версии"), 6130, "Вы выбрали более 100 файлов. Пожалуйста, используйте клиент для скачивания."), 6131, "(синхронизация будет быстрее)"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6132, "Вы выбрали несколько папок. Пожалуйста, используйте клиент для скачивания."), 6133, "Список файлов пуст."), 6134, "приглашает вас в компанию {-name-}"), 6135, "Нажмите 'Просмотр', чтобы добавлять аннотации прямо в файле!"), 6136, "Дважды щёлкните левой кнопкой мыши там, где хотите оставить аннотацию."), 6137, "Целевая компания"), 6138, "Пригласить в компанию"), 6139, "Обсуждение проекта. Вся команда может общаться здесь."), 6140, "Только офицер по безопасности может устанавливать общие политики безопасности для компании или отделов."), 6141, "Офицер по безопасности может одобрять все запросы на общий доступ."), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6142, "{-somebody-} приглашает вас к общему доступу к {-file-}"), 6143, "Не удалось получить информацию об утверждении, оно было отозвано."), 6144, "В настоящее время не поддерживается просмотр файлов размером более {-size-} МБ, таблиц Excel с более чем 2000 строками или документов с более чем 600 страницами. Пожалуйста, скачайте файл для просмотра."), 6145, "Файл не существует или повреждён."), 6146, "После регистрации и входа"), 6147, "{-somebody-} удалил(а) вас из общего доступа к {-file-}"), 6148, "Нажмите и удерживайте палец на месте, где хотите оставить аннотацию."), 6149, "Файл редактируется или обновляется, и предварительный просмотр не является последней версией"), 6150, "Не настраивать"), 6151, "У вас нет прав для присоединения к общему доступу по этой ссылке."), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6152, "Если вам нужно оставлять аннотации, пожалуйста, войдите."), 6153, "После привязки номера телефона вы сможете входить, используя его."), 6154, "Пропустить"), 6156, "Уважаемый пользователь, благодарим вас за использование нашей системы. Потратьте, пожалуйста, немного времени и оставьте ваши ценные замечания, предложения или причины отказа от использования:"), 6157, "{-somebody-} добавил(а) вас в проект {-file-}"), 6158, "добавил(а) вас в проект {-file-}"), 6200, "Нажмите"), 6201, "Настроить политику процесса утверждения для отдела"), 6202, "Управление использованием файлов отдела"), 6203, "Статистика по общим файлам отдела"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6204, "Просмотр и управление всеми открытыми общими доступами в отделе."), 6205, "Открыть список общих файлов"), 6206, "Открыть настройки прав доступа к файлам"), 6207, "Просмотр и управление файлами и папками с индивидуально настроенными правами в отделе."), 6208, "Открыть список конфиденциальных файлов"), 6209, "Просмотр и управление файлами с установленным уровнем конфиденциальности."), 6210, "Открыть журнал доступа к файлам"), 6211, "Просмотр журнала доступа к файлам в отделе."), 6212, "Статистика использования участниками"), 6213, "Открыть статистику использования"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6214, "Просмотр статистики использования файлов участниками отдела."), 6215, "Настройки отдела"), 6216, "Ограничить количество скачиваний"), 6217, "Ошибка настройки, введите правильное количество скачиваний."), 6218, "MAC-адрес, привязанный администратором, недействителен и будет автоматически отфильтрован."), 6219, "Слишком много строк или страниц в файле. Рекомендуется открыть с помощью функции редактирования в клиенте."), 6220, "После установки лимита на скачивание повторные скачивания одним и тем же пользователем в течение получаса будут засчитаны как одно."), 6221, "Если это новый загруженный файл, подождите до 30 минут для обновления индекса полнотекстового поиска на сервере."), 6222, "По политическим причинам персональная и профессиональная версии Babel не поддерживают анонимный доступ к видеофайлам по ссылке. Вы можете зарегистрироваться и войти, чтобы просмотреть или скачать видео в разделе 'Общие для меня'."), 6223, "Это зашифрованный документ. Для просмотра и редактирования, пожалуйста, скачайте его!"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6224, "Файлы отдела принадлежат отделу. Передача владения файлами не влияет на файлы, загруженные пользователем в отдел."), 6225, "Файлы, загруженные в отдел"), 6226, "Файлы отдела принадлежат отделу. Удаление, деактивация пользователя или передача файлов не влияют на файлы отдела."), 6227, "Название не может быть пустым."), 6228, "или"), 6229, "Вы уверены, что хотите удалить этот тег?"), 6300, "Нажмите и удерживайте на месте, где хотите оставить аннотацию."), 6301, "Очистить локальный кэш"), 6302, "Утверждение нескольких файлов"), 6310, "Мобильное приложение"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6311, "Текущее имя файла"), 6312, "Новое имя файла"), 6313, "Запросить переименование файла"), 6314, "Запросить перемещение файла"), 6315, "Идёт архивация, пожалуйста, подождите."), 6316, "Текущий каталог"), 6317, "Целевой каталог"), 6318, "Запрос на переименование файла {-file-} в '{-newName-}'"), 6319, "Запрос на перемещение файла {-file-} из '{-source-}' в '{-target-}'"), 6320, "{-sign-} ваш запрос на переименование файла {-fileName-}"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6321, "{-sign-} ваш запрос на перемещение файла {-fileName-}"), 6322, "{-sign-} ваш запрос по файлу {-fileName-}"), 6323, "Операция не удалась, файл больше не существует в исходном каталоге."), 6324, "Владелец компании не может быть деактивирован."), 6325, "Нельзя деактивировать свою собственную учётную запись."), 6326, "Целевое расположение не может быть корневым каталогом."), 6327, "Отслеживаемые уведомления"), 6328, "Разрешить анонимный доступ"), 6329, "Пожалуйста, введите не менее 6 символов."), 6340, "Поделиться снимком"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6341, "Содержимое снимка останется таким, каким оно было на момент создания ссылки, и не будет обновляться при изменении файла. Получившие эту ссылку смогут получить доступ к файлу в том виде, в каком он был на момент создания снимка. Поддерживается создание нескольких снимков."), 6342, "Создать новый снимок файла"), 6343, "Снимки файла отсутствуют. Вы можете создать новый, нажав кнопку справа."), 6344, "Выберите снимок файла"), 6345, "Снимок файла —"), 6346, "История снимков"), 6347, "Дата снимка"), 6348, "Удалить этот снимок"), 6349, "По умолчанию разрешать пользователям делиться личными файлами."), 6350, "Для фильтрации необходимо загрузить все файлы, пожалуйста, подождите."), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6351, "Фильтрация поддерживается только для уже загруженных файлов. В этом каталоге более 500 файлов. Загрузить все файлы сейчас?"), 6352, "Загрузить все файлы"), 6353, "Фильтровать текущие файлы"), 6354, "Ограничение скорости скачивания"), 6355, "скорость"), 6356, "Примечание: ввод 0 означает отсутствие ограничений скорости скачивания."), 6357, "Введите число от 100 до 20480."), 6358, "Введите имя файла и нажмите Enter для подтверждения."), 6359, "Общий доступ к файлу/папке:"), 6360, "Общий доступ к снимку файла/папки:"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6361, "Интеллект-карта"), 6362, "Скрыть организационную структуру"), 6363, "Если включить эту опцию, все участники компании не смогут выбирать коллег по организационной структуре при приглашении в общий доступ, создании проекта, добавлении утверждающих, получателей сообщений, отправителей, добавлении в группы или в отдел. Однако они смогут добавлять их поиском по имени, email или номеру телефона. (Не действует на администраторов)."), 6364, "Просмотреть загруженные файлы"), 6365, "Список загруженных файлов"), 6366, "Вы можете искать сотрудников компании по имени, номеру телефона или email."), 6367, "Скопировать в буфер обмена"), 6368, "Изображение скопировано в буфер обмена."), 6369, "Копирование изображений поддерживается только по протоколу HTTPS."), 6370, "Запретить делиться файлами с внешними пользователями"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6371, "Если включить эту опцию, участники компании не смогут делиться файлами с внешними пользователями, а также не смогут делиться файлами по ссылке."), 6372, "Скрыть панель инструментов"), 6373, "Показать панель инструментов"), 6400, "Быстрое меню"), 6450, "Этот email уже зарегистрирован в Babel."), 6451, "Этот номер телефона уже зарегистрирован в Babel."), 6552, "Ежемесячная статистика загрузок"), 6553, "Количество загрузок"), 6554, "Месяц"), 6555, "О Babel"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6556, "Диск Babel"), 6557, "Все проекты"), 6558, "Статистика трафика"), 6559, "Статистика трафика (в МБ)"), 6560, "Папка для публикаций компании"), 6561, "Если включить эту опцию, в разделе файлов компании у всех появится папка для публикаций. Только суперадминистраторы, офицеры по безопасности и архивариусы смогут загружать в неё файлы. Права на управление папкой есть у суперадминистратора."), 6562, "Автоматически закрывать ссылки на общие файлы компании при деактивации пользователя."), 6563, "Если включить эту опцию, при деактивации пользователя его ссылки на общие файлы компании будут автоматически закрыты. Если выключить, ссылки останутся активными."), 6564, "Экспорт интеллект-карты"), 6565, "Формат KityMinder (.km)"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6566, "Текстовый план (.txt)"), 6567, "Формат Markdown/GFM (.md)"), 6568, "Векторное изображение SVG (.svg)"), 6569, "Изображение PNG (.png)"), 6570, "Формат XMind (.xmind)"), 6571, "В компании есть конфиденциальные отделы, анонимная загрузка файлов запрещена."), 6572, "Не удалось обновить, этот email уже существует."), 6573, "Этот email уже существует."), 6574, "Этот номер телефона уже существует."), 6575, "Ежемесячная статистика загрузок (в шт.)"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6576, "Не должно заканчиваться на '.'"), 6577, "Ссылки на общие личные файлы закрываются при деактивации аккаунта."), 6578, "Номер телефона и email не могут быть пустыми одновременно."), 6579, "Администратор запретил доступ к папке для публикаций компании, не удалось получить каталог файлов."), 6580, "Не удалось получить каталог файлов."), 6581, "Подтвердите удаление роли."), 6582, "Название прав доступа к файлу"), 6583, ""), 6584, ""), 6585, ""), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6600, "Создать из шаблона"), 6601, "Нет доступных шаблонов."), 6602, "Создать шаблон"), 6603, "Шаблоны файлов"), 6604, "Шаблоны папок"), 6605, "Администраторы могут загружать шаблоны файлов (папок) для отдела в эту папку."), 6606, "Создать шаблон"), 6607, "Загрузить шаблон"), 6608, "Нет доступных шаблонов."), 6609, "Прогресс создания"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6610, "Создание файла"), 6611, "Создание завершено"), 6612, "Если выключить эту опцию, все пользователи не смогут делиться файлами из личного хранилища и создавать там проекты."), 6613, "Статистика трафика"), 6614, "Экспорт отчёта по трафику"), 6615, ""), 6616, ""), 6617, ""), 6618, ""), 6619, ""), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6620, ""), 6621, ""), 6622, ""), 6623, ""), 6624, ""), 6625, ""), 6626, ""), 6627, ""), 6628, ""), 6629, ""), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6630, ""), 6631, ""), 6632, ""), 6633, ""), 6650, "Кодировка"), 6651, "Преобразовать в проект"), 6652, "Запретить анонимный доступ по ссылке"), 6653, "Если включить эту опцию, анонимным пользователям будет запрещён доступ к файлам по ссылке."), 6654, "Компания запретила анонимный доступ."), 6655, "Время истечения сессии"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6656, "Примечание: ввод 0 означает, что сессия истекает при закрытии браузера."), 6657, "загрузил(а) новую версию {-file-} в личные файлы"), 6658, "загрузил(а) новый файл в личные файлы"), 6659, "часов"), 6660, "Введите положительное целое число."), 6661, "добавил(а) папку {-file-} в личные файлы"), 6700, "Имя файла содержит недопустимые символы."), 6701, "Использовано лицензий / Всего лицензий: {-cur-}/{-count-}"), 6702, "Выберите из списка отделов."), 6703, "Нажмите здесь, чтобы зарегистрировать личную версию."), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6704, "Пожалуйста, заполните информацию о вашей компании."), 6705, "Имя контактного лица"), 6706, "Email контактного лица"), 6707, "Введите субдомен в качестве вашего эксклюзивного адреса доступа. Рекомендуется использовать более 4 латинских букв."), 6708, "Активировать корпоративную версию Babel"), 6750, "Начать загрузку"), 6751, "Приостановить загрузку"), 6752, "Приостановлено"), 6753, "Скачать клиент"), 6754, "Произошла ошибка при онлайн-редактировании, не удалось сохранить документ. Автоматически восстановлена последняя доступная версия."), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6755, "Согласившись присоединиться к компании, вы станете её пользователем, а ваш личный/профессиональный аккаунт будет аннулирован. Согласны?"), 6756, "Пропустить и загрузить заново"), 6757, "Нынешний руководитель проекта становится помощником по проекту"), 6758, "Обычные участники"), 6759, "Пожалуйста, выберите другую кодировку и попробуйте открыть снова."), 6760, "Лимит личного пространства успешно установлен. У {-number-} человек в компании был настроен индивидуальный размер пространства. Хотите ли вы унифицировать его для всех?"), 6761, "{-somebody-} приглашает вас в проект {-file-}"), 6762, "{-somebody-} приглашает следующих пользователей {-user-} в проект {-file-}"), 6763, "Данные устарели, пожалуйста, нажмите кнопку снова, чтобы экспортировать список."), 6764, "Произошла ошибка при экспорте, свяжитесь с администратором."), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6765, "Отчёт журнала уже экспортируется, попробуйте позже."), 6766, "Отчёт журнала успешно скачан."), 6767, "Идёт скачивание отчёта журнала, пожалуйста, подождите."), 6768, "Скачивание завершено"), 6800, "Вы можете выбрать одного из участников проекта в качестве нового руководителя."), 6801, "В проекте пока нет участников. Пожалуйста, добавьте их, прежде чем передавать проект."), 6802, "В настоящее время не поддерживается просмотр файлов этого типа размером более {-size-} МБ. Пожалуйста, скачайте файл для просмотра."), 6803, "Нет участников, соответствующих критериям. Пожалуйста, измените условия поиска."), 6804, "Локальная архивация"), 6805, "Архивированные файлы остаются в текущей папке. Загрузка новых версий невозможна, но сохраняются все остальные права. Для чтения не требуется запрос на доступ."), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6806, "Архивировано"), 6807, "У вас нет прав на загрузку этого файла, онлайн-редактирование невозможно."), 6810, "Не удалось создать файл для предпросмотра. Попробовать ещё раз?"), 6811, "Повторить"), 6812, "Срок действия проекта истёк. Обычные участники больше не могут получить к нему доступ."), 6813, "Срок истёк"), 6814, "В настоящее время не поддерживается редактирование файлов этого типа размером более {-size-} МБ. Пожалуйста, скачайте файл для редактирования."), 6815, "Очистить все права этого аккаунта"), 6816, "Очистить"), 6817, "После очистки пользователь сможет получить доступ только к личным файлам. Открытые им общие доступы будут закрыты, и он будет удалён из всех отделов, групп, общих доступов и проектов."), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6818, "Вы уверены, что хотите очистить аккаунт {-name-}?"), 6819, "Это действие необратимо. После очистки все права {-name-} будут аннулированы."), 6820, "Доля занимаемого пространства"), 6821, "Нажмите, чтобы скрыть"), 6822, "Список отправленных файлов"), 6823, "Нет отправленных файлов."), 6824, ", максимум 5"), 6825, "Мониторинг и оповещения"), 6826, "Список мониторинга компании"), 6827, "Добавить элемент мониторинга"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6830, "В компании не настроены элементы мониторинга."), 6831, "Количественное ограничение"), 6832, "Не удалось получить информацию о мониторинге."), 6833, "Выберите элемент мониторинга."), 6834, "Вы уверены, что хотите удалить текущий элемент мониторинга?"), 6835, "Повторная загрузка"), 6836, "Количество файлов отдела, {-opType-} в облачном диске, превысило норму. Текущее значение: {-currentNum-}, пороговое значение: {-threshhold-}."), 6837, "Более 5 человек, функция отправки файлов недоступна."), 6838, "Более 5 файлов, функция отправки файлов недоступна."), 6839, "Отправить файлы документооборота"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6840, "Выберите получателей."), 6841, "Связанные файлы были удалены, свяжитесь с отправителем."), 6842, "Настроить быстрое меню"), 6843, "Отображать быстрое меню в левой панели"), 6844, "Доступные для выбора меню"), 6845, "Двойным щелчком можно удалить ярлык из левой панели. Перетаскиванием можно изменить порядок."), 6846, "Добавить папку в быстрое меню"), 6847, "Двойным щелчком можно добавить этот ярлык для отображения в левой панели."), 6848, "Быстрое меню отсутствует."), 6849, "Нет доступных для выбора меню."), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6850, "Выберите папку."), 6851, "Выберите папку в подкаталоге."), 6852, "Файл унаследовал контроль доступа от родительской папки."), 6853, "Можно добавить не более 20 элементов в быстрое меню."), 6854, "Все элементы мониторинга уже добавлены."), 6855, "Настройка передачи файлов"), 6856, "Порт приёма"), 6857, "Порт отправки"), 6858, "Сбросить"), 6859, "{-somebody-} отправил(а) файл {-file-} пользователям {-targetNames-}"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6860, "Ваш номер телефона уже зарегистрирован в Babel. Хотите ли вы обновить этот аккаунт до корпоративной версии? Выбор 'Да' запустит процесс обновления. Это действие необратимо и может привести к потере данных. Пожалуйста, создайте резервную копию. Если вы не хотите обновлять этот аккаунт, выберите 'Нет' и зарегистрируйте корпоративную версию с другим номером телефона."), 6861, "Обнаружено, что ваш номер телефона уже является корпоративным пользователем Babel. Пожалуйста, используйте другой номер для регистрации."), 6862, "Дополнительные опции"), 6863, "Вырезать"), 6864, "Вставить"), 6865, "Папка для сбора файлов поддерживает только приём файлов типа {-str-}."), 6866, "Описание порта"), 6867, "Номер порта"), 6868, "Вы уверены, что хотите удалить текущий порт?"), 6869, "Название порта"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6870, "Это название уже существует."), 6871, "Создать"), 6872, "Введите название и описание порта."), 6873, "Получатель"), 6874, "Редактировать порт"), 6875, "Создать порт"), 6876, "Список получателей"), 6877, "Здесь вы можете выбрать участников для этого порта."), 6878, "Получатели отсутствуют."), 6879, "Добавить пользователя"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6880, "Вы уверены, что хотите удалить этого человека из списка получателей?"), 6881, "Вы уверены, что хотите удалить этот отдел из списка получателей?"), 6882, "Нажмите, чтобы показать токен"), 6883, "Имя отправителя"), 6884, "Имя получателя"), 6885, "Домен получателя"), 6886, "Например: http://www.babel.cc"), 6887, "Токен получателя"), 6888, "Отправитель"), 6889, "Список отправителей"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6890, "Вы уверены, что хотите удалить этого человека из списка отправителей?"), 6891, "Вы уверены, что хотите удалить этот отдел из списка отправителей?"), 6892, "Отправители отсутствуют."), 6893, "Передать файл"), 6894, "Вы можете выбрать настроенный порт для передачи файлов."), 6895, "Файл {-fileName-} отправлен на корпоративный порт {-identifier-} с запросом на отправку. Пожалуйста, "), 6896, "проверьте"), 6897, "Системный порт приёма {-identifier-} получил файл {-fileName-}, отправленный вам. "), 6898, "Нажмите здесь, чтобы посмотреть детали."), 6899, "Ваш запрос на отправку файла {-fileName-} через корпоративный порт {-identifier-} был администратором "), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6900, "Системный порт приёма {-identifier-} получил файл {-fileName-}. Пожалуйста, "), 6901, "Системный порт приёма {-identifier-} получил файл {-fileName-}, проверено."), 6902, "В компании не настроены порты отправки или нет доступных вам портов. Свяжитесь с администратором."), 6903, "Не поддерживается копирование папки в её подкаталог."), 6904, "Не поддерживается перемещение папки в её подкаталог."), 6905, "Введите количественное ограничение."), 6906, "Только для папок"), 6907, "(отдел в корзине)"), 6908, "Скачать в:"), 6909, "Обзор"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 6910, "Установить как путь по умолчанию"), 6911, "Очистить дату окончания"), 6912, "По умолчанию не получать уведомления"), 6913, "Если включить эту опцию, push-уведомления для пользователей будут отключены по умолчанию. Пользователи, желающие получать уведомления, могут самостоятельно включить их в настройках."), 6914, "Копировать адрес ссылки"), 6915, "Ссылка скопирована"), 6916, "Использовать клиент для доступа к общей ссылке"), 6917, "Одобрить"), 6918, "Отклонить"), 7000, "Файл нельзя переносить в одного и того же участника, пожалуйста, выберите другого целевого участника"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7001, "Ваша видеокарта слишком старая, текущий браузер не может её использовать"), 7002, "Вы можете попробовать старую версию браузера или обновить видеокарту"), 7003, "Версия вашего браузера слишком низкая"), 7004, "Пожалуйста, используйте последнюю версию"), 7005, "Уважаемый пользователь, до окончания срока действия вашей корпоративной версии осталось"), 7006, "Уважаемый пользователь, срок действия вашей корпоративной версии истёк. Если нужно, свяжитесь со службой поддержки, мы с радостью поможем."), 7007, "Осталось менее"), 7008, "часов"), 7009, "дней"), 7010, "Чтобы не повлиять на ваше использование, пожалуйста, свяжитесь со службой поддержки как можно скорее!"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7011, "Не найдено совпадений с"), 7012, "запросом"), 7013, "Пользовательская папка"), 7014, "Мнение по одобрению успешно создано"), 7015, "Неверный формат email"), 7016, "Неверный email или номер телефона"), 7017, "Отменить выбор ограничения"), 7018, "Этот отдел"), 7019, "Удаление отдела не удалось, попробуйте снова"), 7020, "Максимальное"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7021, "настройка"), 7022, "Введите максимальное значение пространства (единица: ГБ)"), 7023, "Без ограничений"), 7024, "Загрузить логотип компании"), 7025, "Предпросмотр логотипа"), 7026, "Пожалуйста, добавьте примечание"), 7027, "Ошибка сети, попробуйте позже"), 7028, "Этот человек уже принадлежит компании {-name-}, пожалуйста, сначала выйдите из этой компании"), 7029, "Этот пользователь уже зарегистрирован, вы можете отправить ему приглашение. После согласия он автоматически присоединится к компании"), 7030, "Отправить приглашение"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7031, "Нельзя повторно отправлять в течение 1 часа"), 7032, "Сервер вернул ошибку"), 7033, "Отключённые пользователи"), 7034, "Не установлено"), 7035, "Базовый"), 7036, "Архив"), 7037, "Уведомление"), 7038, "Этап 1"), 7039, "Не зарегистрирован"), 7040, "Никогда не входил"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7041, "Бесплатная проба 30 дней"), 7042, "Нет прав доступа"), 7043, "Нет прав на открытие исходного файла"), 7044, "Изображение"), 7045, "Документ Office"), 7046, "Документ Adobe"), 7047, "Файл CAD"), 7048, "Другое"), 7049, "Всё время"), 7050, "В течение 3 дней"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7051, "В течение 1 недели"), 7052, "В течение 1 месяца"), 7053, "В течение 6 месяцев"), 7054, "Все размеры"), 7055, "0 ~ 100 байт"), 7056, "100 байт ~ 1 КБ"), 7057, "Более 10 ГБ"), 7058, "Этот голосовой комментарий больше не существует"), 7059, "《Метка》"), 7060, "Сделана графическая отметка (просмотреть отдельно)"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7061, "Загружен файл (просмотреть отдельно)"), 7062, "Исторические версии"), 7063, "Старая"), 7064, "Принять"), 7065, "и т.д."), 7066, "Вы ещё не вошли, сначала войдите"), 7067, "Зарегистрироваться"), 7068, "Нет аккаунта"), 7069, "Подсказка входа"), 7070, "После настройки email вы можете получать уведомления по email о общих файлах. Рекомендуем<br>немедленно открыть настройки профиля и привязать email"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7071, "Открыть настройки профиля"), 7072, "Позже"), 7073, "Руководство по использованию BabelBird"), 7074, "Добро пожаловать в BabelBird, мы покажем, как быстро начать использование"), 7075, "Нажмите кнопку создания, чтобы загрузить файл или создать папку"), 7076, "Здесь вы можете просмотреть все созданные вами файлы и папки"), 7077, "Папки отдела"), 7078, "Здесь вы можете просмотреть файлы вашего отдела"), 7079, "Здесь вы можете просмотреть и управлять всеми созданными или присоединёнными командами"), 7080, "Здесь вы можете просмотреть и управлять всеми файлами или папками, которые вы поделились"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7081, "Здесь вы можете просмотреть и управлять всеми присоединёнными общими файлами или папками"), 7082, "Все добавленные в избранное файлы будут отображаться здесь"), 7083, "Места, где вам нужно внести вклад или управлять вкладами"), 7084, "Одобрение файлов"), 7085, "Ваши файлы для одобрения будут отображаться здесь"), 7086, "Все удалённые файлы временно хранятся в корзине"), 7087, "Навигация"), 7088, "Здесь можно переключать <em>файлы</em>, <em>динамику</em>"), 7089, "Кнопки функций"), 7090, "Здесь вы можете просмотреть детали файла или отсортировать файлы"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7091, "Руководство по использованию"), 7092, "Добро пожаловать в BabelBird для аннотирования документов! Ниже приведено введение в основные инструменты"), 7093, "Список точек аннотаций"), 7094, "Можно просмотреть все точки аннотаций в документе"), 7095, "Нажмите, чтобы просмотреть карту навигации файла -可以看到 все документы в одной папке"), 7096, "Повернуть текущий документ"), 7097, "Выбрать файл или версию для сравнения с текущим файлом"), 7098, "Онлайн-печать текущего файла"), 7099, "Можно поделиться документом с другими"), 7100, "Просмотреть исторические версии документа"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7101, "Скачать документ"), 7102, "Управление отображением аннотаций"), 7103, "Скрыть, показать аннотации"), 7104, "Полноэкранный режим текущей страницы"), 7105, "Нажмите на аватар и выберите"), 7106, ", чтобы войти в панель управления компанией, где можно управлять отделами и персоналом, а также настраивать конфигурацию."), 7107, "У вас нет прав на ответ"), 7108, "У вас нет прав на ответ, пожалуйста, войдите и ответьте"), 7109, "Обычная аннотация"), 7110, "Геометрическая аннотация"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7111, "Текстовая метка"), 7112, "Содержимое аннотации пустое, нельзя отправить"), 7113, "Введите текстовое содержимое"), 7114, "Скачать iOS App"), 7115, "Присоединяйтесь к обсуждению в BabelBird"), 7116, "Введите"), 7117, "Отправить новое сообщение"), 7118, "Нет файлов (папок)"), 7119, "Подсказка: Корзина хранит удалённые файлы (папки) в течение 10 дней"), 7120, "Пожалуйста, следуйте схеме ниже, чтобы открыть"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7121, "Приложение BabelBird"), 7122, "Шаг 1"), 7123, "Нажмите кнопку «Ещё» в правом верхнем углу"), 7124, "Шаг 2"), 7125, "Выберите открыть в Safari"), 7126, "Открыть в приложении"), 7127, "Нажмите здесь, чтобы заполнить примечание"), 7128, "Создано в BabelBird"), 7129, ", пожалуйста, заполните информацию примечания или нажмите «Присоединиться» напрямую, чтобы присоединиться к этому"), 7130, "Присоединиться"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7131, "Через динамику вы можете узнать о всех ситуациях ваших коллег и {-str-}, и быстро перейти к файлу для обсуждения"), 7132, "Ответ успешен"), 7133, "У вас нет прав на ответ"), 7134, "Ответ не удался, файл удалён!"), 7135, "Ответ не удался, аннотация удалена!"), 7136, "Ответ не удался, попробуйте позже"), 7137, "Ответ не удался, у вас нет прав на просмотр версии этой аннотации"), 7138, "Ответ не удался, файл удалён!"), 7139, "Ответ не удался"), 7140, "Комментарий успешен"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7141, "У вас нет прав на комментарий"), 7142, "Комментарий не удался, попробуйте позже"), 7143, "Ваш браузер не поддерживает тег HTML5 video"), 7144, "Идёт скачивание"), 7145, "Есть несохранённые данные"), 7146, "Ваши отредактированные данные не полностью сохранены на сервере"), 7147, "Продолжить закрытие"), 7148, "Телефон"), 7149, "Нажмите ⌘ + C, чтобы скопировать ссылку"), 7150, "Нажмите Ctrl + C, чтобы скопировать ссылку"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7151, "Сварной шов на месте"), 7152, "Сварные швы вокруг"), 7153, "Название файла"), 7154, 'Файл <b id="fileNo" class="top">0</b>, всего <b id="fileCount" class="top">100</b> файлов'), 7155, "Операция не удалась, попробуйте позже"), 7156, "Скоро завершится одобрение этого файла. Вы хотите установить статус одобрения файла как:"), 7157, "Одобрение не запущено (удалить существующие записи одобрения"), 7158, "Список пуст"), 7159, "Отфильтрованы существующие одобрители"), 7160, "У файла нет новой версии, нельзя запустить одобрение"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7161, "Просмотреть отчёт"), 7162, "У файла нет новой версии, нельзя запустить одобрение"), 7163, "Показать список одобрений"), 7164, "Из предустановленного списка отфильтрован текущий пользователь"), 7165, "Инициатор не может участвовать в рецензировании, удалён"), 7166, "Нажмите обновить"), 7167, "Выбрать целевую архивную папку"), 7168, "Переместить в"), 7169, "Текущий выбранный файл уже содержится в этой папке"), 7170, "Нельзя переместить выбранную папку {-title-} внутрь себя"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7171, "Перемещение файла не удалось, пожалуйста, закройте общий доступ к файлу и попробуйте снова"), 7172, "Файл успешно перемещён"), 7173, "Загрузить в"), 7174, "Подписан"), 7175, "Вы сейчас не принадлежите ни к одному отделу или не имеете прав на просмотр файлов отделов"), 7176, "Анонимный посетитель"), 7177, "Участники моих общих файлов"), 7178, "Участники файла"), 7179, "Нет записей доступа"), 7180, "Сводная статистика"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7181, "Заблокировать"), 7182, "Журнал файла пуст"), 7183, "Статистика рабочей нагрузки"), 7184, "Нет персонала в группе"), 7185, "Общая группа пуста"), 7186, "Личная группа пуста"), 7187, "Участие в общих файлах"), 7188, "Записи доступа"), 7189, "Развернуть"), 7190, "Нет персонала"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7191, "Поиск меток"), 7192, "Вы ещё не присоединились к другим общим файлам"), 7193, "Подсказка: Все просмотренные вами файлы (папки) из ссылок обмена будут отображаться здесь"), 7194, "Извините, не найдены файлы или папки с выбранными метками"), 7195, "Пожалуйста, подтвердите"), 7196, "Добавить членов команды"), 7197, "Пожалуйста, выберите целевой путь"), 7198, "Имя файла не может быть пустым"), 7199, "Длина имени файла не может превышать 100 символов"), 7200, "Выбрать целевую папку"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7201, "Серые папки - это папки без прав на загрузку"), 7202, "Для больших файлов и нескольких файлов используйте функцию синхронизации клиента"), 7203, "Полнофункциональный клиент имеет"), 7204, "реальное время синхронизации"), 7205, "уведомления о сообщениях"), 7206, "загрузка папок"), 7207, "и другие мощные функции"), 7208, "Скачать версию для Windows"), 7209, "Скачать версию для Mac"), 7210, "Если уже скачано, откройте клиент для использования этой функции"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7211, "Если нужно купить лицензию на онлайн-совместное редактирование Office, свяжитесь со службой поддержки"), 7212, "Эта функция поддерживается только в клиенте"), 7213, "Ваше пространство хранения заполнено, вы можете удалить ненужные файлы или нажать кнопку ниже, чтобы купить больше пространства"), 7214, ""), 7215, "Расширить пространство хранения"), 7216, "Пространство заполнено"), 7217, "Кто-то редактирует этот файл в веб-версии, вы можете выбрать «Онлайн-редактирование» в меню, чтобы присоединиться к совместному редактированию"), 7218, "Ошибка проверки прав услуги"), 7219, "файлов (папок)"), 7220, "Отменить лайк"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7221, "Маленькие иконки"), 7222, "Средние иконки"), 7223, "Большие иконки"), 7224, "Стандартный"), 7225, "Компактный"), 7226, "Примечание"), 7227, "Это общие файлы, которые вы пригласили других присоединиться"), 7228, "Мои приглашения"), 7229, "Файл имеет контроль доступа"), 7230, "Конфиденциальный файл"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7231, "Ограниченный файл"), 7232, "Внутренний файл"), 7233, "Внешние файлы не принадлежат текущей компании, это общие файлы или команды от внешних сотрудников компании, к которой вы присоединились"), 7234, "Вы уже подписаны на этот файл, хотите отменить подписку?"), 7235, "Продолжить подписку"), 7236, 'В "Примечании" отображается описание файла, которое помогает пометить файл. Вы можете изменить описание любого файла, на который у вас есть права редактирования, в панели деталей файла'), 7237, "Вы хотите отменить это закрепление?"), 7238, "Сохранить закрепление"), 7239, "Файл заблокирован {-userName-}"), 7240, "Другие должны ждать завершения редактирования, чтобы разблокировать"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7241, "Файл заблокирован, хотите разблокировать?"), 7242, "Внимание: Принудительная разблокировка может привести к перезаписи версии, загруженной блокирующим, версиями других, вызывая потерю версий"), 7243, "Разблокировать"), 7244, "Закрыть окно"), 7245, "Этот файл заблокирован кем-то, вы не можете редактировать"), 7246, "Достигнут конец списка"), 7247, "Дата подписки"), 7248, " Внешний контакт компании"), 7249, "Просмотр файлов отдела от имени администратора"), 7250, "Просмотр файлов {-user-} от имени администратора"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7251, "После обновления до профессиональной версии бесплатные функции текущего аккаунта будут улучшены следующим образом:"), 7252, "Ёмкость пространства аккаунта расширена до 1 ТБ"), 7253, "Можно купить пакеты ёмкости для большего пространства"), 7254, "Неограниченное сохранение исторических версий одного файла"), 7255, "Неограниченное создание новых команд"), 7256, "Неограниченный предпросмотр файлов CAD"), 7257, "Неограниченный предпросмотр 3D-файлов"), 7258, "Общие метки"), 7259, "Совместная работа с файлами"), 7260, "Узнать о профессиональной версии"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7261, "Прогресс копирования"), 7262, "Введите новое имя"), 7263, "лайков"), 7264, "У вас ещё нет подписанных файлов (папок)"), 7265, 'Подсказка: Вы можете подписаться на файлы (папки) в "Все файлы"'), 7266, "Вы ещё не делились файлами (папками)"), 7267, 'Подсказка: Вы можете поделиться файлами (папками) в "Все файлы"'), 7268, "Добавить участников"), 7269, "Создание проекта завершено, пожалуйста, добавьте персонал"), 7270, "Не удалось получить список прав"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7271, "Статус этого запроса изменился, пожалуйста, обновите для просмотра"), 7272, "Граф связей документов"), 7273, "Вы недавно не открывали файлы"), 7274, "Подсказка: Недавно открытые файлы появятся здесь"), 7275, "Добавить карточку"), 7276, "Нет внешнего персонала компании"), 7277, "У вас нет прав на просмотр списка внешнего персонала компании!"), 7278, "Нет внешнего персонала компании или нет прав на просмотр"), 7279, "Адрес файла:"), 7280, "Добавленные здесь люди получат права доступа к файлу. Если это зарегистрированный пользователь BabelBird, файл автоматически появится в их разделе «Мои присоединённые общие файлы». Независимо от регистрации, они получат уведомление по email или SMS, и система проверит безопасность по email или номеру телефона, чтобы убедиться, что это указанный вами посетитель"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7281, "Нажмите кнопку ниже, чтобы открыть обмен ссылкой. Вы получите адрес ссылки, который можно распространить по email или QQ и т.д. Получившие ссылку смогут получить доступ к файлу. Для повышения конфиденциальности можно установить пароль, а также срок действия, после которого ссылка станет недействительной."), 7282, "Список приглашённых"), 7283, "Адрес ссылки"), 7284, "Доступ к этому файлу ограничен только лицами, имеющими соответствующие права"), 7285, "Отправить ссылку"), 7286, "Внешний пользователь"), 7287, "Просмотреть журнал"), 7288, "Удалить этого пользователя"), 7289, "Отправить эту ссылку по email или SMS"), 7290, "Отправить эту ссылку немедленно"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7291, "Адрес файла:"), 7292, "Таблица прав участников"), 7293, "Запрос на приглашение пользователя для обмена файлом"), 7294, "Пригласить к обмену"), 7295, "Обмен ссылкой"), 7296, "Не удалось получить список прав"), 7297, "Фильтр по меткам"), 7298, "Вы ещё не создавали или не присоединялись к командам"), 7299, "Неизвестная ошибка, попробуйте позже"), 7300, "Файлы хранятся максимум 10 дней"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7301, "Поиск динамики, нажмите Enter для подтверждения"), 7302, "Пароль состоит из 1-20 букв и цифр"), 7303, "Не присоединён к отделу"), 7304, "Нет групп обсуждения"), 7305, "Описание изменено на"), 7306, "Создана папка"), 7307, "Пригласить к обсуждению"), 7308, "Системное сообщение"), 7309, "Добавление участника не удалось"), 7310, "Введите email приглашённого, разделяя запятыми (или нажмите Enter для подтверждения), максимум 10 за раз"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7311, "Введите email или номер телефона приглашённого"), 7312, "Введите email и номер телефона приглашённого"), 7313, "Добавлено <em>{-num-}</em> шт."), 7314, "Приглашение успешно отправлено"), 7315, "Не является участником компании"), 7316, "Уже присоединён"), 7317, "Отправка приглашения не удалась"), 7318, "Команда успешно создана."), 7319, "Номер телефона успешно изменён"), 7320, "Email успешно изменён"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7321, "Извините, бесплатная версия BabelBird позволяет создать только 2 команды. Чтобы создать больше, обновитесь до профессиональной версии"), 7322, "Настройки аккаунта"), 7323, "Отправить повторно"), 7324, "Введите код подтверждения, отправленный на ваш email"), 7325, "Введите код подтверждения, отправленный на ваш телефон"), 7326, "Новый аккаунт с номером телефона может завершить настройку начального пароля через SMS-код"), 7327, "Введите код подтверждения, отправленный на ваш {-type-}"), 7328, "Удалить метку"), 7329, "Фильтр по меткам"), 7330, "Удаление метки не удалось"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7331, "Метка успешно изменена"), 7332, "Цитата"), 7333, "Название команды:"), 7334, "Название команды (до 40 символов)"), 7335, "Описание команды:"), 7336, "Описание команды, до 100 символов."), 7337, "Это название команды уже существует"), 7338, "Название доступно"), 7339, "Название команды слишком длинное"), 7340, "Создание"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7341, "Введите название команды"), 7342, "Название команды не может превышать 40 символов"), 7343, "Описание не превышает 100 символов"), 7344, "Вы ещё не создали команду"), 7345, "Подсказка: После создания команды вы можете добавить соответствующих сотрудников компании как членов команды"), 7346, "Подсказка: После создания команды вы можете добавить соответствующих сотрудников компании как членов команды"), 7347, "Вы ещё не присоединялись к командам"), 7348, "Не является участником компании"), 7349, "Уже присоединён"), 7350, "Добавление не удалось"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7351, "Отправка приглашения не удалась"), 7352, "Нет участников<br>Нельзя передать!"), 7353, "Команда не создана"), 7354, "Я присоединился."), 7355, "Уже присоединён"), 7356, "Не найдено совпадающих команд"), 7357, "Данные этой точки аннотации ошибочны!"), 7358, "Внимание: Переключено на историческую версию"), 7359, "Переключено на текущую версию!"), 7360, "Скачивание..."), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7361, "файл формата"), 7362, "Введите пароль для совместной работы"), 7363, "Следующая страница"), 7364, "Предыдущая страница"), 7365, "Повернуть вправо"), 7366, "Повернуть влево"), 7367, "Ошибка сетевого соединения, проверьте сеть!"), 7368, "Нет прав на удаление"), 7369, "Данные точки аннотации ошибочны!"), 7370, "Ошибка получения отображаемого файла!"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7371, "Файл {-fileName-} - подготовка к печати"), 7372, "Ваш файл"), 7373, "Не удалось! Документ содержит пароль, удалите пароль и попробуйте снова!"), 7374, "Не удалось сгенерировать файл предпросмотра"), 7375, "Не удалось сохранить файл"), 7376, "Сеть занята, попробуйте позже!"), 7377, "Произошла неизвестная ошибка"), 7378, "Ошибка сети или сервера!"), 7379, "Ошибка сетевого соединения"), 7380, "Приглашение не удалось, бесплатная версия ограничивает максимум 30 приглашённых, обновитесь до неограниченной профессиональной версии!"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7381, "Отправка не удалась, бесплатная версия ограничивает максимум 30 получателей, обновитесь до неограниченной профессиональной версии!"), 7382, "Пожалуйста, подождите..."), 7383, "Введите имя файла"), 7384, "Введите имя файла..."), 7385, "Узнать больше"), 7386, "Связанные файлы"), 7387, "Другие способы входа:"), 7388, "Никнейм не может быть пустым"), 7389, "Никнейм неверный"), 7390, "Введите комбинацию из 6-20 символов, включая заглавные и строчные буквы и цифры"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7391, "Пароль не может быть пустым"), 7392, "Введите комбинацию из 6-20 символов, включая заглавные и строчные буквы и цифры"), 7393, "Никнейм не существует"), 7394, "Пароль неверный"), 7395, "Формат email неверный"), 7396, "Email не может быть пустым"), 7397, "Капча с изображением не может быть пустой"), 7398, "Капча с изображением неверная"), 7399, "Email не существует"), 7400, "Пароли не совпадают"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7401, "Два введённых пароля не совпадают"), 7402, "Номер телефона не может быть пустым"), 7403, "Формат номера телефона неверный"), 7404, "SMS-код не может быть пустым"), 7405, "Код неверный"), 7406, "Введите email или номер телефона"), 7407, "Номер телефона не привязан"), 7408, "Пользователь не существует"), 7409, "Код истёк"), 7410, "Этот аккаунт заморожен, вход запрещён"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7411, "Формат email или номера телефона неверный"), 7412, "Обязательное заполнение"), 7413, "Код неверный"), 7414, "Код не может быть пустым"), 7415, "Вы не пользователь этой компании"), 7416, "Пожалуйста, выберите идентификатор"), 7417, "Введите название компании"), 7418, "Введите никнейм контактного лица"), 7419, "Введите email контактного лица"), 7420, "Введите домен"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7421, "Название компании не может состоять только из цифр"), 7422, "Поддерживается только ввод букв и цифр"), 7423, "Введите комбинацию из 6-20 символов, включая заглавные и строчные буквы и цифры"), 7424, "Восстановить пароль"), 7425, "Введите email или номер телефона, используемый для входа"), 7426, "Получите код для сброса нового пароля"), 7427, "Пароль успешно установлен"), 7428, "Не получили email с кодом?"), 7429, "Проверьте, правильный ли адрес email"), 7430, "Проверьте папку спама в вашем email"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7431, "Возможно, почтовая система сайта занята или неисправна, попробуйте позже"), 7432, "Если всё ещё не получили, попробуйте отправить повторно"), 7433, "Введите новый пароль"), 7434, "Подтвердите новый пароль"), 7435, "Файлы"), 7436, "Папки"), 7437, "Отправка не удалась, подтвердите адрес email или номер телефона и попробуйте снова"), 7438, "Права"), 7439, "Команда"), 7440, "Вы уверены, что хотите удалить выбранные архивные файлы? После удаления архивные файлы нельзя восстановить?"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7441, 'Обнаружено, что вы не вошли, пожалуйста, сначала <a class="link" href="/account/login.do">войдите</a>'), 7442, "Ссылка, которую вы посещаете, не существует или обмен файлом отменён!"), 7443, "Вы также можете:"), 7444, "Вернуться на главную:"), 7445, "Вернуться на предыдущую страницу:"), 7446, "Присоединиться к BabelBird сейчас"), 7447, "Открыть эффективный облачный офис для компании"), 7448, "Используйте технологии, чтобы изменить способ работы и жизни"), 7449, "BabelBird - зарегистрированная торговая марка Shanghai Huaqing Information Technology Co., Ltd., основанной в 2012 году со штаб-квартирой в Шанхае, с филиалом в Пекине в 2016 году. BabelBird - команда, ориентированная на технологии, основатели из Peking University Founder, с сильными технологиями графики и изображений в Китае. В настоящее время BabelBird завершил раунд A инвестиций, с почти 400 000 пользователей и объёмом данных документов более 1000 ТБ."), 7450, "Глубокое развитие в области графики и изображений, неустанное исследование эффективных способов работы и стремление к идеальному пользовательскому опыту создали платформу управления знаниями BabelBird. Вы можете использовать BabelBird для хранения и управления рабочими документами, быстрого обмена знаниями компании и совместного обсуждения документов различных форматов через любое устройство."), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7451, "Маленькая история о <span>BabelBird</span>"), 7452, "Название BabelBird происходит от библейской Вавилонской башни. Легенда гласит, что древние люди имели единый язык, единые идеи и ценности, поэтому были сильны и могли объединить силы для строительства башни до небес в древнем Вавилоне. Башня росла всё выше, Бог почувствовал угрозу от единства людей, разрушил башню, заставил людей говорить на разных языках и иметь разные мысли, что привело к хаосу и войнам. BabelBird - маленькая птица, которая общалась между звеньями во время строительства башни, быстро передавая детали огромного проекта. Теперь BabelBird возродился в интернете, делая наше общение ближе и нас сильнее."), 7453, "О компании"), 7454, "Горячая линия поддержки"), 7455, "Адрес компании"), 7456, "Название компании: Shanghai Huaqing Information Technology Co., Ltd."), 7457, "Адрес: 1055 Pingcheng Road, Jiading District, Shanghai"), 7458, "Почтовый индекс: 201821"), 7459, "Телефон: 400-9204020 (Пн-Вс 8:00 ~ 20:00)"), 7460, "СМИ и продвижение, жалобы и предложения"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7461, "Контакт: Huangfu Shanxin"), 7462, "Мобильный: 13564686107"), 7463, "WeChat: MolaSync"), 7464, "Баги продукта и предложения по улучшению"), 7465, "Email: support@molasync.com"), 7466, "Официальная группа QQ: 512728617"), 7467, "Обучение и консультации"), 7468, "Контакт: Zhang Yongjun"), 7469, "Мобильный: 13261256900"), 7470, "WeChat: zhangyjluck"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7471, "Распаковать всё"), 7472, "Распаковать в"), 7473, "Распаковать"), 7474, "Цвет водяного знака"), 7475, "Файл предпросмотра ещё не сгенерирован успешно! Попробуйте снова через минуту!"), 7476, "Шанхайский штаб"), 7477, "Адрес: 7 эт., корп. 8, Xinye Future Center, ул. Huancheng, 762, Шанхай"), 7478, "Шанхайский исследовательский центр"), 7479, "Адрес: 1801, ул. Wuning South, 488, Шанхай"), 7480, "Тел.: 13584686107"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7481, "Пекинский филиал"), 7482, "Адрес: район B, 3Q Galaxy SOHO, Chaoyangmen, район Dongcheng, Пекин"), 7483, "Чэндуский филиал"), 7484, "Адрес: 9 эт., башня C, Guanghua Center, район Qingyang, Чэнду"), 7485, "Контакт: Ван Юйцзе"), 7486, "Тел.: 13982493667"), 7487, "BabelBird (Гонконг) Интернешнл"), 7488, "Адрес: 8 эт., башня 2, Admiralty Centre, ул. Harcourt, 18, район Центральный и Западный, ОАР Гонконг"), 7489, "Контакт: Ши Юньцин"), 7490, "Тел.: 852-69968224"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7500, "Загрузка через веб не может превышать 100 файлов (папок) за раз, используйте функцию синхронизации папок клиента!"), 7501, "Пожалуйста, измените уровень безопасности файла в панели деталей файла"), 7502, "Приватные файлы - это файлы, не размещённые в отделе или общей папке компании, они принадлежат лично, другие не видят и не могут получить доступ"), 7503, "требуется"), 7504, "Максимум можно ввести {0} символов"), 7505, "Введите число"), 7506, 'Имя файла не может содержать следующие символы: \ / : * ? " < > |'), 7507, "Формат MAC-адреса неверный"), 7508, "Введите правильный номер мобильного телефона"), 7509, "Введите правильный номер телефона"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7510, "Введите китайские символы"), 7511, "Введите правильный почтовый индекс"), 7512, "Никнейм должен быть строкой из 2-20 символов"), 7513, "Введите комбинацию из 6-20 символов, включая заглавные и строчные буквы и цифры"), 7514, "Введите правильные буквы"), 7515, "Название роли"), 7516, "Это обязательный выбор"), 7517, "Одобритель не может быть текущим пользователем"), 7518, "Введите действительную дату"), 7519, "Запрещено перемещать файлы между компаниями!"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_ru_part, 7520, "{-somebody-} переместил {-file-} в папку {-folder-}"), 7521, "{-somebody-} установил права доступа к {-file-} как {-role-}"), 7522, "Поделился с вами файлом {-file-}"), 7523, "Подпись"), 7524, "Недостаточно пространства у владельца целевой папки"), 7525, "Содержит подпункты, удаление запрещено"), 7526, "Сообщение удалено"), 7527, "Владелец компании должен быть администратором"));
var _default = exports["default"] = localString_ru_part2;

},{"1180":1180,"1184":1184,"1454":1454}],1164:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var localString_ru_part1 = {
  0: "Бабель",
  1: "Файлы",
  2: "Активность",
  3: "Обсуждение команды",
  4: "Обсуждение отдела",
  5: "Настройки",
  6: "Выйти",
  7: "Создать",
  8: "Папка",
  9: "Загрузить файл",
  10: "Родительская папка",
  11: "Все файлы",
  12: "Каталог",
  13: "Поделиться",
  14: "Детали",
  15: "Сортировать",
  16: "Поиск файлов, нажмите Enter",
  17: "Моя команда",
  18: "Отделы и проекты",
  19: "Мои расшаренные файлы",
  20: "Шары, к которым я присоединился",
  21: "Избранные",
  22: "Корзина",
  23: "Теги",
  24: "Управление тегами",
  25: "Посетители",
  26: "Последние изменения",
  27: "Размер",
  28: "Загрузить новую версию",
  29: "Скачать",
  30: "Переименовать",
  31: "Переместить",
  32: "Удалить",
  33: "Копировать в",
  34: "Добавить в избранное",
  35: "Просмотреть версии",
  36: "Закрепить",
  37: "Ещё",
  38: "Предпросмотр",
  39: "Получить адрес для доступа",
  40: "Посмотреть детали",
  41: "Создано",
  42: "Комментарии",
  43: "Непрочитанные комментарии",
  44: "Нравится",
  45: "Управление тегами",
  46: "Нажмите {-tagMgr-}, чтобы настроить отображение тегов здесь",
  // {-variable-} 这一部分是将来被替换的变量
  47: "Обновить до профессиональной версии",
  48: "Проблемы с сетью",
  49: "Имя файла",
  50: "Управление аккаунтом",
  51: "Профиль",
  52: "Сменить пароль",
  53: "Забыли пароль?",
  54: "Хранилище",
  55: "Моё пространство",
  56: "Использовано",
  57: "Остаток",
  58: "Занято личными файлами",
  59: "Занято файлами команды",
  60: "Занято в общих файлах",
  61: "Тип пользователя",
  62: "Пользователь бесплатной версии",
  63: "Личные уведомления",
  64: "Разрешить Бабель отправлять письма на мою почту",
  65: "Управление командой",
  66: "Создать команду",
  67: "удалить",
  68: "Создатель",
  69: "Я",
  70: "Члены команды",
  71: "Добавить участника",
  72: "Супер-администратор",
  73: "Настройки",
  74: "Назад",
  75: "Общий доступ по ссылке",
  76: "Любой, кто знает эту ссылку, может комментировать",
  77: "Любой, кто знает ссылку, может редактировать",
  78: "Любой с этой ссылкой может комментировать и скачивать",
  79: "Все, кто знает ссылку, могут просматривать",
  80: "копировать",
  81: "Узнать о правах доступа",
  82: "Для доступа по ссылке требуется пароль",
  83: "Пригласить участников",
  84: "Введите ник или e-mail",
  85: "Может редактировать",
  86: "Может комментировать и скачивать",
  87: "Может комментировать",
  88: "Может просматривать",
  89: "Готово",
  90: "Управление участниками",
  91: "Введено {-curCount-} человек, максимум {-maxCount-} человек",
  92: "После включения ссылки доступа и приглашений вы сможете отдельно управлять правами доступа каждого приглашённого участника",
  93: "Запретить редакторам изменять права и добавлять новых пользователей",
  94: "",
  95: "Посмотреть пользователей, посетивших по ссылке",
  96: "Отключить общий доступ по ссылке",
  97: "Пригласить участников",
  98: "Найти приглашённого пользователя",
  99: "Время публикации",
  100: "Отображать теги в левой панели",
  101: "На левой панели пока нет тегов. Нажмите {-newTag-} или перетащите тег из“{-allTag-}” сюда, чтобы добавить его в левую панель",
  102: "Все теги",
  103: "Теги, которыми я пользовался",
  104: "Теги, которыми поделились другие",
  105: "Нет тегов, можно нажать{-addTag-}",
  106: "Добавить тег",
  107: "Можно перетащить тег в {-leftTag-}",
  108: "Генерируется предварительный просмотр, попробуйте позже",
  109: "Текстовый комментарий",
  110: "Информация о версии",
  111: "Скрыть комментарии",
  112: "На весь экран",
  113: "Всего {-num-} комментариев",
  114: "Комментарии текущего документа",
  115: "Непрочитанные комментарии текущего документа",
  116: "Все комментарии",
  117: "Непрочитанные комментарии",
  118: "Введите текст комментария",
  119: "Отметить как выполнено",
  120: "Удалить",
  // ---- 删除批注调用
  121: "{-second-} секунд назад",
  122: "Нажмите, чтобы добавить ответ",
  123: "Enter для быстрого ответа",
  124: "Ответить",
  125: "Очистить",
  126: "Вы добавили мультимедийный комментарий",
  128: "Комментарий",
  129: "Голосовой комментарий",
  130: "Рукописный комментарий",
  131: "Завершено",
  132: "Не завершено",
  133: "Одобрено",
  134: "Отклонено",
  135: "Корневая папка",
  136: "Открыть папку",
  137: "Мои загрузки",
  138: "Только метки",
  139: "Версия Pro",
  140: "Обратная связь",
  141: "Скачать iOS приложение",
  142: "Скачать Android приложение",
  143: "Скачать десктопную версию",
  144: "Мои подписки",
  145: "Папка сбора файлов",
  146: "Мои согласования",
  147: "Тег успешно добавлен",
  148: "Не удалось добавить тег, попробуйте позже",
  149: "Тег успешно удалён",
  150: "Не удалось удалить тег, попробуйте позже",
  151: "Файл больше не доступен по шарингу или вы не являетесь участником",
  152: "Недостаточно прав",
  153: "У вас нет разрешения на это действие для текущей папки!",
  154: "Подтвердить",
  155: "Отменить",
  156: "Закрыть",
  157: "У вас новое сообщение",
  158: "Название",
  159: "Расположение",
  160: "Текущая папка пуста",
  161: "Подсказка: вы можете здесь",
  162: "или",
  163: "Создать папку",
  164: "В ваших файлах/папках не найдено результатов по этим критериям поиска",
  165: "Попробуйте другие параметры поиска",
  166: "Непрочитано",
  167: "У вас нет прав на открытие этого файла",
  168: "Операция не удалась. Проверьте сеть или нажмите F5 для обновления страницы и повторите попытку",
  169: "Вы потеряли права на этот файл; эта страница будет закрыта",
  170: "Внимание",
  171: "Перетащите сюда, чтобы переместить в текущую папку",
  172: "Перетащите сюда, чтобы загрузить в текущую папку",
  173: "В данный момент поддерживается только загрузка файлов",
  174: "Всего {-count-} комментариев",
  175: "{-count-} непрочитанных",
  176: "Крайний срок",
  177: "Нет",
  178: "Внешние файлы",
  179: "Нажмите, чтобы посмотреть посетителей",
  180: "настройка",
  181: "Запустить согласование",
  182: "Просмотреть согласование",
  183: "Открепить",
  184: "Закрепить файл",
  185: "группа",
  186: "Управление командой",
  187: "Просмотр команды",
  188: "Файл заблокирован мной",
  189: "Файл заблокирован {-user-}",
  190: "Общий доступ от {-user-}",
  191: "Доступ открыт",
  192: "Приглашения включены",
  193: "Доступ по ссылке включён",
  194: "Поделено пользователем {-user-}",
  195: "Доступ по ссылке отключён",
  196: "Получить ссылку общего доступа",
  197: "Перейдите в папку и выберите файл для просмотра!",
  198: "В персональной версии нет функции папки сбора файлов, обновитесь до корпоративной версии!",
  199: "Функция согласования доступна только в корпоративной версии. Переходите на корпоративную версию, чтобы использовать эту функцию",
  200: "В эту группу обсуждения допускаются только определённые пользователи, свяжитесь с администратором",
  201: "Вы не присоединены к этой группе. Нажмите «Поделиться», получите ссылку и зайдите по ней",
  202: "Сотрудник",
  203: "Управление участниками",
  204: "Внутренние участники",
  205: "Внешние участники",
  206: "Пользователи онлайн",
  207: "Посмотреть детали",
  208: "Супер-администратор",
  209: "Управление",
  210: "Администратор архива",
  211: "Владелец компании",
  212: "Добавить супер-администратора",
  213: "Управление супер-администраторами",
  214: "Учётная запись",
  215: "Контакты",
  216: "Роль",
  217: "Действия",
  218: "Добавить администратора архива",
  219: "Управление администраторами архива",
  220: "Предупреждение",
  221: "Подтвердите удаление статуса супер-администратора у {-user-}",
  222: "Подтвердите удаление статуса администратора архива у {-user-}",
  223: "Нельзя создавать файл в текущем канале!",
  224: "Управление синхронизацией",
  225: "Идёт загрузка файла (шифрование)...",
  226: "Загрузка завершена",
  227: "После закрытия окна загрузка будет отменена. Подтвердить закрытие?",
  228: "Ожидает загрузки...",
  229: "Загрузить снова",
  230: "Загрузка завершена, формируется превью...",
  231: "Отменено",
  232: "Загрузка не удалась",
  233: "Лимит хранилища превышен",
  234: "Загрузка прошла успешно",
  235: "Список комментариев",
  236: "На весь экран",
  237: "Скрыть комментарии",
  238: "Редактировать файл",
  239: "Трансляция",
  240: "Поделиться файлом",
  241: "Пожалуйста, ознакомьтесь",
  242: "Посмотреть, кто поставил лайк",
  243: "Отписаться",
  244: "Внимание",
  245: "Показать больше тегов",
  246: "Тег успешно удалён",
  247: "Тег успешно добавлен",
  248: "Нравится",
  249: "Введите название тега",
  250: "Тег с таким именем уже существует",
  251: "Выберите кого напомнить или введите вручную",
  252: "Введите комментарий",
  253: "Все",
  254: "Пока нет комментариев",
  255: "Нет прав для комментирования этого файла",
  256: "Согласование",
  257: "Удалить навсегда",
  258: "Отметить как прочитанное",
  259: "Включить согласование",
  260: "Возобновить согласование",
  261: "Ход рассмотрения",
  262: "Контроль доступа к файлу",
  263: "Заблокировать файл",
  264: "Разблокировать файл",
  265: "Открыть папку",
  266: "Открыть локальную папку",
  267: "Синхронизировать на локальный диск",
  268: "Отменить синхронизацию",
  269: "Создать текстовый файл",
  270: "Создать документ Word",
  271: "Создать документ Excel",
  272: "Создать презентацию PowerPoint",
  273: "Файл Markdown",
  274: "Файл(папка)",
  275: "Всего занято",
  276: "Выберите один файл или папку, чтобы посмотреть подробную информацию",
  277: "Общие",
  278: "Описание",
  279: "Тип",
  280: "Удалил",
  281: "Время удаления",
  282: "Версия",
  283: "Версия №{-index-}",
  284: "Просмотреть историю версий",
  285: "Файл заблокирован",
  286: "Подписчики",
  287: "Статистика просмотров",
  288: "журнал",
  289: "Количество комментариев",
  290: "Скачивания",
  291: "Просмотров",
  292: "Число посетителей",
  293: "Посетители",
  294: "Содержит",
  295: "Идёт подсчёт",
  296: "Дата создания",
  297: "Дата изменения",
  298: "Нет информации о версиях!",
  299: "Текущее",
  300: "Установить как текущую версию",
  301: "Описание версии",
  302: "HTML-файл не поддерживает просмотр истории версий по этой ссылке. Вы можете изменить текущую версию и снова открыть файл.",
  303: "Файл зафиксирован (утверждён), версии удалять нельзя",
  304: "Удалить выбранные версии?",
  305: "Удалено успешно",
  306: "Ошибка при удалении",
  307: "Файл находится на согласовании, завершите процесс согласования прежде чем продолжить!",
  308: "Операция выполнена",
  309: "Операция не выполнена",
  310: "У вас нет прав устанавливать текущую версию",
  311: "Текущий документ утвержден — изменения версий не допускаются",
  312: "Вы уверены, что хотите удалить этот комментарий?",
  313: "Все",
  314: "@меня",
  315: "Только что",
  316: "{-num-} минут назад",
  317: "{-num-} часов назад",
  318: "{-num-} дней назад",
  319: "Вчера",
  320: "Позавчера",
  321: "{-num-} недель назад",
  322: "{-num-} месяцев назад",
  323: "{-num-} лет назад",
  324: "5 лет назад",
  325: "Передача файлов",
  326: "Ответ, Shift+Enter — перенос строки",
  327: "Перенос строки",
  328: "Вы уверены, что хотите удалить выбранные файлы?",
  329: "Внимание: удалённые файлы будут храниться в корзине 10 дней; общие файлы удаляются немедленно.",
  330: "Эта директория пуста",
  331: "Идёт загрузка файла, пожалуйста, подождите...",
  332: "Файлы команды",
  333: "Принадлежит команде",
  334: "Файлы отдела",
  335: "Принадлежит отделу",
  336: "Общая папка компании",
  337: "Файлы компании",
  338: "Посмотреть настройки шаринга",
  339: "очистить",
  340: "Пока нет новых сообщений",
  341: "Запрос приглашения {-num-} человек в {-file-}",
  342: "Отклонить",
  343: "Файл удалён или не существует",
  344: "Запрос на открытие общего доступа по ссылке",
  345: "Приглашают вас совместно управлять папкой сбора файлов",
  346: "Принять",
  347: "Сообщение удалено",
  348: "Системное уведомление Бабель",
  349: "Уведомления",
  350: "Входящие сообщения",
  351: "Запрос на присоединение к команде",
  352: "Открыта папка для сбора файлов",
  353: "Пожалуйста, как можно скорее отправьте материалы",
  354: "Приглашают вас для согласования файла",
  355: "Напомнить вам подписаться на файл/папку",
  356: "В файле {-name-} в {-object-} вас отметили",
  357: "Содержание",
  358: "Запущена трансляция файла {-name-}",
  359: "Срок действия вашего тарифа Бабель истекает {-endTime-}. Пожалуйста, продлите подписку, чтобы не прерывать использование. Спасибо.",
  360: "Запущено согласование файла {-name-}, и отправлено вам копией",
  361: "Примечание:",
  362: "Вернуться в родительскую папку",
  363: "Поиск",
  364: "Всего {-num-}",
  365: "Поиск файла, нажмите Enter для подтверждения",
  366: "Документ Word",
  367: "Документ Excel",
  368: "Презентация PowerPoint",
  369: "Текстовый файл",
  370: "Папка для сбора файлов",
  371: "В текущем канале нельзя создавать файлы",
  372: "Плитка",
  373: "Список",
  374: "Детали файла",
  375: "Детали команды",
  376: "Содержимое папки",
  377: "Посмотреть участников моего шаринга",
  378: "Очистить корзину",
  379: "Файлы в корзине будут удалены навсегда. Уверены, что хотите очистить корзину?",
  380: "Внимание: это действие необратимо!",
  381: "Консоль компании",
  382: "Внешние участники",
  383: "Последние просмотренные файлы",
  384: "Просмотр",
  385: "Напомнить вам подписаться",
  386: "Поделились с вами",
  387: "Все папки",
  388: "Личные папки",
  389: "Общий доступ от {-user-}",
  390: "Сохранить в Бабель",
  391: "Введите пароль для доступа к файлу",
  392: "Файл успешно сохранён в ваш аккаунт Бабель",
  393: "Пожалуйста, войдите в систему или введите пароль для открытия общего файла",
  394: "Пароль",
  395: "Неверный пароль, повторите ввод",
  396: "Владелец",
  397: "В этой компании",
  398: "Внешняя компания",
  399: "Личное",
  400: "Просмотреть участников",
  401: "У вас нет прав приглашать пользователей в шаринг, но вы можете указать желаемых приглашённых — система отправит запрос администратору файла на приглашение.",
  402: "Приглашено",
  403: "…и ещё {-num-} чел.",
  404: "Не удалось получить список приглашённых",
  405: "Приглашённые должны зарегистрироваться, используя адрес приглашения, чтобы просмотреть содержимое",
  406: "Отправить",
  407: "Участники",
  408: "Включите общий доступ, чтобы другие могли просматривать этот файл",
  409: "Ссылка",
  410: "Ссылка и пароль скопированы в буфер обмена",
  411: "Ссылка скопирована в буфер обмена",
  412: "Нажмите ⌘+C, чтобы скопировать ссылку",
  413: "Нажмите Ctrl+C, чтобы скопировать ссылку",
  414: "Не удалось установить приватный шаринг, попробуйте позже",
  415: "Сканируйте QR, чтобы быстро присоединиться",
  416: "Сканируйте QR для входа",
  417: "Откройте WeChat",
  418: "Нажмите внизу «Обнаружить»",
  419: "Используйте «Сканировать»",
  420: "Откройте Бабель",
  421: "Нажмите внизу «Все файлы»",
  422: "В правом верхнем углу нажмите '+' → 'Сканировать и присоединиться'",
  423: "Владелец не включил общий доступ по ссылке для этого файла",
  424: "Запросить включение",
  425: "Оставьте сообщение с просьбой владельцу файла включить доступ по ссылке — тогда вы получите ссылку для общего доступа。",
  426: "Оставить сообщение",
  427: "Можно ввести ещё {-num-} символов",
  428: "Отправить запрос",
  429: "Запросить общий доступ по ссылке",
  430: "Запрос на включение доступа по ссылке для {-file-}",
  431: "Сообщение",
  432: "Ожидает запуска",
  433: "Утверждено",
  434: "На согласовании",
  435: "Значение не задано на сервере",
  436: "Нормально",
  437: "Документ пока не поддерживается",
  438: "Генерируется превью, попробуйте позже",
  439: "Не удалось создать превью!",
  440: "Документ защищён паролем; снимите пароль и загрузите снова",
  441: "Файл повреждён или не полный",
  442: "Файл слишком большой, создание превью невозможно",
  443: "В презентации нет слайдов",
  444: "Двойной клик удалит этот тег из левой панели или перетащите его обратно в «Все теги»",
  445: "На левой панели нет тегов; нажмите здесь",
  446: 'или перетащите тег из "Все теги" сюда, чтобы добавить его в левую панель',
  447: "Перетащите сюда, чтобы добавить на левую панель",
  448: "Перетащите сюда, чтобы удалить тег с левой панели",
  449: "Обнаружен файл с тем же именем",
  450: "В текущей папке уже есть файл с именем {-fileName-}!",
  451: "Отменить загрузку",
  452: "Автопереименование и продолжение загрузки",
  453: "Загрузить как новую версию этого файла",
  454: "Примечание: файлы больше {-size-} пока не поддерживаются для загрузки",
  455: "Размер файла не должен превышать",
  456: "Идёт загрузка файлов в облачное хранилище Бабель. Если вы покинете эту страницу, некоторые файлы могут не загрузиться。",
  457: "В персональной версии пока нет загрузки папок; обновитесь",
  458: "Введите имя тега для поиска или создания",
  459: "Добавить комментарий",
  460: "Этот комментарий виден всем участникам шаринга",
  461: "Этот комментарий видят только внутренние участники компании",
  462: "Этот комментарий виден только мне",
  463: "Вы прикрепили мультимедийный комментарий",
  464: "Отметить как выполнено",
  465: "Не удалось отправить файл",
  466: "Рисованная линия",
  467: "Прямоугольник",
  468: "Прямая линия",
  469: "Стрелка",
  470: "Текст",
  471: "Цвет",
  472: "Толщина линии",
  473: "Размер шрифта",
  474: "Отменить",
  475: "Повторить",
  476: "Введите комментарий здесь или нарисуйте на изображении ниже",
  477: "Показать ещё",
  478: "Выберите согласующих",
  479: "Мои группы",
  480: "Контакты",
  481: "Тема сообщения",
  482: "Ник отправителя",
  483: "Войти",
  484: "Регистрация",
  485: "Email или телефон",
  486: "Вход - Бабель",
  487: "Войти по SMS-коду",
  488: "Номер телефона",
  489: "Код из SMS",
  490: "Войти по паролю (email/телефон)",
  491: "Другие способы:",
  492: "Вход через WeChat",
  493: "Забыли пароль?",
  494: "Войти в корпоративную версию",
  495: "Введите домен вашей компании",
  496: "Домен компании",
  497: "Войти",
  498: "← Войти в персональную версию",
  499: "Регистрация - Бабель",
  500: "Подтверждая, вы соглашаетесь с нашей",
  501: "Политикой конфиденциальности",
  502: "и",
  503: "Условиями использования",
  504: "Введите код для продолжения",
  505: "Картинка-код",
  506: "Управление участниками отдела",
  507: "К сожалению, в бесплатной версии Бабель можно создать только 2 команды. Чтобы создать больше — обновитесь до профессиональной версии",
  508: "Список согласований",
  509: "Инициатор",
  510: "Не удалось получить информацию о согласовании",
  511: "Файл на согласование",
  512: "Информация о согласовании изменилась",
  513: "Этот файл сразу утверждён; нет участников согласования",
  514: "Одобрено",
  515: "Не начато",
  516: "Идёт согласование...",
  517: "Отклонено",
  518: "Файл отклонён; вы можете загрузить новую версию, чтобы начать согласование заново",
  519: "На этом этапе вы пока не можете согласовывать",
  520: "Согласовано",
  521: "Файл отклонён, согласование завершено",
  522: "Согласование завершено",
  523: "Копия",
  524: "Завершить согласование",
  525: "Повторно ввести решение по согласованию",
  526: "Моё решение",
  527: "Решение по согласованию",
  528: "Запустить согласование",
  529: "После успешного согласования файл считается утверждённым; файлы на согласовании и утверждённые нельзя редактировать или загружать в них новые версии",
  530: "Утвердить без согласования",
  531: "Отправить для начала согласования",
  532: "Добавить этап согласования",
  533: "Группа согласования",
  534: "Группа в копии",
  535: "Шаблон процесса",
  536: "Участники согласования",
  537: "Если порядок согласования не нужен (параллельное согласование), добавьте всех участников в этап 1",
  538: "Пожалуйста, выберите процесс согласования",
  539: "Согласование проходит по этапам: участники этапа 2 получают уведомление только после завершения этапа 1 и так далее",
  540: "Согласующие могут видеть информацию участников обсуждения и все комментарии в файле",
  541: "Добавленные процессы доступны для выбора при согласовании файла и позволяют быстро начать согласование",
  542: "Дайте процессу имя для удобства",
  543: "Редактировать процесс согласования",
  544: "Имя шаблона уже существует",
  545: "Не удалось сохранить, попробуйте снова",
  546: "Командное обсуждение — группа по команде, где можно вести дискуссии и совместно работать",
  547: "Создать команду",
  548: "Подсказка: нет сообщений в отделе。",
  549: "Файл не найден！",
  550: "Папка в корзине и не может быть открыта！",
  551: "Файл не найден, возможно, он был перемещён！",
  552: "Файл удалён！",
  553: "Открыть целевую папку",
  554: "Создан отдел",
  555: "Стал(а) новым участником отдела",
  556: "Переименован(а) в",
  557: "Максимальное место изменено на",
  558: "Отдел изменён на",
  559: "Удалён(а) из отдела",
  560: "Роль установлена как",
  561: "Вступил в команду",
  562: "Отказ от присоединения к команде",
  563: "Исключён из обсуждения",
  564: "Покинул(а) команду",
  565: "Запрос на вступление в команду",
  566: "Пригласил(а)",
  567: "Удалил(а)",
  568: "Для файла уже запущено согласование！",
  569: "Не согласовано",
  570: "Ожидает согласования",
  571: "Активность файла",
  572: "Этот ответ виден всем",
  573: "Ответ на комментарий",
  574: "Этот ответ виден только сотрудникам компании",
  575: "Участники шаринга",
  576: "Группы",
  577: "Пользователь",
  578: "Повторное добавление: этот пользователь уже в списке",
  579: "Поиск по нику/почте/телефону",
  580: "Корпоративные группы",
  581: "Редактировать группу",
  582: "Корпоративных групп нет",
  583: "Персональных групп нет",
  584: "Введите название",
  585: "Название не может быть пустым",
  586: "Длина названия не должна превышать 100 символов",
  587: "Базовые услуги профессиональной версии",
  588: "Скоро истекает",
  589: "Истёк",
  590: "Пожалуйста, своевременно {-pay-}",
  591: "Просмотреть заказ",
  592: "Корпоративная версия",
  593: "Срок действия текущего сервиса {-edition-} до {-date-}",
  594: "Продление услуги",
  595: "Содержимое продления услуги",
  596: "Состав услуги",
  597: "Единица（юань）",
  598: "Количество",
  599: "Сумма（юань）",
  600: "Выберите срок продления（в годах）",
  601: "Выбранный срок продления",
  602: "год",
  603: "{-edition-}续费服务内容有效期至{-date-}",
  604: "Общая сумма расходов",
  605: "юань",
  606: "Нужен счёт",
  607: "Оформить заказ",
  608: "Оплатить",
  609: "Обновление сервиса",
  610: "Управление сервисом профессиональной версии",
  611: "Управление сервисом корпоративной версии",
  612: "Личные заказы",
  613: "Корпоративные заказы",
  614: "Все заказы",
  615: "Время подачи",
  616: "Дата начала",
  617: "Дата окончания",
  618: "Название заказа",
  619: "Годы",
  620: "Статус",
  621: "Все элементы",
  622: "Повышение аккаунта",
  623: "Расширение пространства",
  624: "Продление аккаунта",
  625: "Год",
  626: "Не оплачено",
  627: "Ожидает проверки",
  628: "Оплачено",
  629: "Подтвердить удаление этого заказа?",
  630: "Номер заказа",
  631: "Содержание заказа",
  632: "Удалить заказ",
  633: "Подтвердите отмену следующей записи заказа",
  634: "Отменить заказ",
  635: "Обновление до профессионального аккаунта",
  636: "Услуга расширения пространства корпоративной версии",
  637: "Услуга расширения пространства профессиональной версии",
  638: "Услуга продления корпоративной версии",
  639: "Услуга продления профессиональной версии",
  640: "Корпоративный аккаунт",
  641: "Личный аккаунт",
  642: "Отмена заказа не удалась, отменять может не создатель заказа",
  643: "Для дополнительного поиска заказов нажмите {-more-}",
  644: "Срок действия сервиса до",
  645: "Реквизиты для счёта",
  646: "Информация для отправки счёта",
  647: "Если у вас есть вопросы, сразу свяжитесь с поддержкой или отделом продаж. Email: support@molasync.com Тел: 400-9204020",
  648: "Безопасный выход",
  649: "Можно добавить максимум {-max-} , добавлено {-num-}",
  650: "Эта операция не затронет выбранных владельцев компании и самих пользователей",
  651: "Подтвердить {-act-} выбранные аккаунты?",
  652: "Предыдущий",
  653: "Онлайн",
  654: "Выбранные пользователи",
  655: "Массовый сброс паролей",
  656: "Массовая установка лимита личного пространства",
  657: "Введите лимит хранилища; пользователи, превысившие его, не смогут загружать",
  658: "Массовое управление аккаунтами",
  659: "Массовая смена отдела и прав",
  660: "Компания",
  661: "Просмотреть отдел владельца файла",
  662: "Пригласивший",
  663: "Подсказка : внешних участников нет",
  664: "Добавить внешнего участника",
  665: "Введите ник",
  666: "Этот e-mail уже является внутренним участником компании",
  667: "Этот e-mail уже является внешним участником компании",
  668: "Этот e-mail уже зарегистрирован в Бабель, введите остальные данные и подтвердите добавление",
  669: "Новые участники получат регистрационные данные по e-mail или телефону",
  670: "После входа можно изменить пароль",
  671: "Добавить корпоративного пользователя",
  672: "Отдел не может быть пустым",
  673: "Этот аккаунт уже в компании",
  674: "Настройки прав",
  675: "Выберите роль",
  676: "Все роли",
  677: "Пожалуйста выберите пользователя",
  678: "Утверждён（нажмите, чтобы посмотреть результат）",
  679: "Отклонён（нажмите, чтобы посмотреть результат）",
  680: "Не может загрузить новую версию",
  681: "Вы уверены, что хотите закрыть шаринг?",
  682: "Внимание: после закрытия шаринга ссылка перестанет работать.",
  683: "Блокировка файла позволит только вам загружать новые версии",
  684: "Не удалось заблокировать, файл уже заблокирован другим",
  685: "Восстановление файла",
  686: "Файл восстановлен в исходное место",
  687: 'Файл восстановлен, но родительская папка "{-folder-}" всё ещё в корзине<br>',
  688: "Восстановление не удалось, родительская папка была удалена навсегда",
  689: "После удаления файл нельзя восстановить, подтвердить удаление?",
  690: "Идёт удаление файла",
  691: "Блокировка прошла успешно",
  692: "Файл заблокирован пользователем {-userName-}, вы не можете редактировать!",
  693: "Произошла ошибка при попытке блокировки документа<br>Пожалуйста, попробуйте позже",
  694: "Содержит общие файлы(папки), сначала закройте общий доступ",
  695: "Метки ещё не добавлены",
  696: "Перетащите или дважды кликните, чтобы добавить тег на левую панель",
  697: "Подача",
  698: "Получение",
  699: "Получатель",
  700: "Корпоративная онлайн-платформа",
  701: "В процессе",
  702: "Закончилось",
  703: "Мои запросы",
  704: "Нет файлов(папок)",
  705: "Подсказка : очистите корзину, чтобы освободить место",
  706: "Выберите файл или папку для просмотра деталей",
  707: "Введите текст метки...",
  708: "Включить водяной знак",
  709: "Введите ник, e-mail или телефон",
  710: "Незарегистрированный пользователь",
  711: "Отправка...",
  712: "{-somebody-} — член отдела, которому принадлежит файл, и может получить доступ без приглашения. Хотите напомнить им подписаться на файл?",
  713: 'Закрыть общий доступ по ссылке "{-file-}"',
  714: "После отключения ссылки доступа, люди с ней не смогут получить доступ,<br>а все дочерние ссылки в этой папке также будут закрыты",
  715: 'Отключить приглашения для "{-file-}"',
  716: "Доступ по ссылке не включён",
  717: "Перейти для включения",
  718: "После отключения приглашений все приглашённые будут удалены.<br>Файл и его дочерние элементы также будут удалены из аккаунтов приглашённых",
  719: "Владелец не включил доступ по ссылке",
  720: "Отправить запрос",
  721: "Закрыть приглашения",
  722: "Анонимный пользователь",
  723: "Зарегистрированный пользователь",
  724: "Сбросить пароль",
  725: "Любой, кто знает ссылку, может {-do-}",
  726: "Крайний срок",
  727: "Отправлять уведомления о шаринге участникам, присоединившимся по ссылке",
  728: "Успешно установлено — автоматически закроется через 7 дней!",
  729: "Пароль доступа",
  730: "Печать",
  731: "Скрыто",
  732: "Время доступа",
  733: "",
  734: "",
  735: "",
  736: "",
  737: "",
  738: "",
  739: "",
  740: "",
  741: "Открыть в новой вкладке",
  742: "Файл слишком большой для предпросмотра, скачайте для просмотра!",
  743: "У меня есть аккаунт",
  744: "Войти",
  745: "Дата добавления",
  746: "Сравнение файлов",
  747: "Внешние участники",
  748: "Создать тег",
  749: "Выбрать тег",
  750: "Панель фильтров",
  751: "Список слоёв",
  752: "Права, установленные здесь, автоматически применяются ко всем дочерним файлам и папкам",
  753: "В этой папке у вас нет прав на загрузку!",
  754: "Настройки личного хранилища",
  755: "Архивный администратор отвечает за согласование выдачи архивов, не может войти в административную панель компании",
  756: "Сотрудник по безопасности видит и управляет файлами всех отделов в интерфейсе и может войти в корпоративную панель; в панели его права ограничены: формирование политики безопасности (исключительное право), управление структурой, управление участниками и правами",
  757: "Аудитор безопасности может войти в корпоративную панель, но его права ограничены: просмотр политики безопасности, просмотр структуры организации, просмотр прав участников, просмотр управления правами, просмотр журнала доступа к файлам",
  758: "Архивировать в архив",
  759: "После архивирования файл перемещается в специализированный архивный раздел; его нельзя изменять или удалять, доступ возможен только через интерфейс архива",
  760: "Корпоративный архив",
  761: "Хранить исторические документы компании",
  762: "Вы пытаетесь просмотреть архивный файл — перейдите в архив. Нажмите ОК для перехода в архив",
  763: "Запросить онлайн-просмотр",
  764: "Запрос на скачивание",
  765: "Запрос на копирование",
  766: "Запрос отправлен, следите за результатом в вашем канале заявок",
  767: "На рассмотрении",
  768: "Выдано",
  769: "Взять архив",
  770: "Выдача архива требует согласования; после одобрения файл появится в разделе «Мои выдачи»",
  771: "Запросить выдачу",
  772: "Отправить запрос",
  773: "Способ просмотра",
  774: "Причина запроса",
  775: "Архивная папка",
  776: "Создать архивную папку",
  777: "Название архивной папки не может быть пустым",
  778: "Вы пытаетесь скачать архивный файл — перейдите в архив. Нажмите ОК для перехода в архив",
  779: "Есть новая заявка на просмотр архива, требующая вашего согласования!",
  780: "Ваша заявка на просмотр архива одобрена!",
  781: "Ваша заявка на просмотр архива отклонена!",
  782: "Архивный файл можно просмотреть только после выдачи!",
  783: "Редактировать отдел",
  784: "Нельзя удалить отдел, если в нём есть подотделы",
  785: "Отдел с архивными файлами нельзя удалить",
  786: "Файлы, на которые указывают ярлыки, нельзя скачивать",
  787: "Ручка",
  788: "Последняя версия",
  789: "← Войти в публичное облако",
  790: "Рекомендуемые приглашения для доступа",
  791: "Отделы и проекты",
  792: "Вы уверены, что хотите удалить этого пользователя из команды?",
  793: "Удалить участника",
  794: "Принадлежность проекта",
  795: "Ограничения загрузки файлов",
  796: "Тип ограничения",
  797: "Содержание ограничения",
  798: "Без ограничений",
  799: "Ограничить расширения",
  800: "Ограничить полное имя файла",
  801: "Введите ограничения, разделяя запятой, например: jpg,jpeg",
  802: "Введите имя файла для ограничения, например: example.jpg",
  803: "Управление участниками отдела",
  804: "0 или пусто означает, что требуется участие всех",
  805: "Введите комментарий к согласованию",
  806: "Принять это мнение",
  807: "Принято",
  808: "Отклонено",
  809: "Комментарий",
  810: "Подтвердить удаление этого мнения?",
  811: "Отклонить это мнение",
  812: "Ожидает обработки автором",
  813: "Список мнений",
  814: "Всего {-num-} замечаний",
  815: "Комментарий (голосовой)",
  816: "Комментарий (рисунок)",
  817: "В файле {-file-} принято предложение {-somebody-}: {-evaluation-}",
  818: "В файле {-file-} отклонено предложение {-somebody-}: {-evaluation-}",
  819: "{-somebody-} уже подписал(а) файл {-file-}",
  820: "Введите дополнительный объём хранилища для пользователя",
  821: "Для создания папки войдите в систему",
  822: "Нажмите, чтобы загрузить файл, или перетащите файлы в эту область для загрузки",
  823: "Для загрузки с подтверждённой идентификацией или создания папки войдите в систему",
  824: "Если файл загружен недавно, подождите до 30 минут для обновления полнотекстового индекса",
  825: "Поделиться файлом/папкой для вас 【{-name-}】, нажмите ссылку для просмотра;",
  826: "Папка для сбора файлов от {-user-}",
  827: "Эта функция доступна только в профессиональной и корпоративной версиях",
  828: "Истекает позже",
  829: "Введите номер телефона минимум из 5 цифр",
  830: "Нельзя менять роль владельца компании",
  831: "Если вы измените свою роль в компании, вы потеряете права супер-администратора. Подтвердить?",
  832: "Использование файлов",
  833: "Этот файл не поддерживает комментирование",
  // dashboard，
  // 其中 {-  -} 所包含的内容是将来要替换变量内容
  // 以第 1000 条为例，定义对象如下
  //  var param = {
  //		'somebody'    : '李平',
  //		'parentFolder': '历史文件夹',
  //   	'folder'      : '明朝那些事'
  //  }
  //  var s = MDLocalString.getLocalString(1000, param);
  //  s 的值为
  // 		'李平 在 历史文件夹 中新建了文件夹 明朝那些事'
  //
  1000: "{-somebody-} создал(а) папку {-folder-} в {-parentFolder-}",
  1001: "{-somebody-} загрузил(а) {-fileEdition-}{-file-} в {-parentFolder-}",
  1002: "{-somebody-} переименовал(а) {-fileOrFolder-}{-oldName-} в {-newName-}",
  1003: "Новый файл",
  1004: "Новая версия",
  1005: "и др. файлы",
  1006: "{-somebody-} переместил(а) {-fileOrFolder-}{-file-} из {-sourceFolder-} в {-targetFolder-}",
  1007: "{-somebody-} удалил(а) {-file-} из {-folder-}",
  1008: "{-somebody-} загрузил(а) {-file-}",
  1009: "{-somebody-} удалил(а) {-file-}",
  1010: "Версия {-file-}",
  1011: "{-somebody-} восстановил(а) {-file-} из корзины",
  1012: "{-somebody-} поместил(а) {-file-} в {-folder-}",
  1013: "{-somebody-} удалил(а) {-file-} из {-folder-}",
  1014: "{-somebody-} установил(а) текущую версию для {-file-}",
  1015: "{-somebody-} скопировал(а) следующие файлы {-file-} в {-folder-}",
  1016: "{-somebody-} поставил(а) лайк {-file-}",
  1017: "{-somebody-} убрал(а) лайк у {-file-}",
  1018: "{-somebody-} выполнил(а) {-review-} для {-file-}",
  1019: "{-somebody-} напомнил(а) вам подписаться на {-file-}",
  1020: "{-somebody-} отменил(а) вашу подписку на {-file-}",
  1021: "{-somebody-} присоединился(ась) к шарингу {-file-}",
  1022: "{-somebody-} был(а) исключён(а) из шаринга {-file-}",
  1023: "{-somebody-} покинул(а) шаринг {-file-}",
  1024: "{-somebody-} отключил(а) общий доступ для {-file-}",
  1025: "{-somebody-} удалил(а) следующих пользователей {-user-} из шаринга {-file-}",
  1026: "{-somebody-} открыл(а) ссылку на шаринг для {-file-}",
  1027: "{-somebody-} в {-file-} изменил(а) права следующих пользователей с {-oldRole-} на {-newRole-}",
  1028: "{-somebody-} отключил(а) ссылку общего доступа для {-file-}",
  // 1029: '{-somebody-} 将 {-file-} 的分享链接权限由 {-oldRole-} 改为 {-newRole-}',
  1029: "{-somebody-} изменил(а) права доступа по ссылке для {-file-} с {-oldRole-} на {-newRole-}",
  1030: "{-somebody-} добавил(а) в {-file-} комментарий: {-comment-}",
  1031: "{-somebody-} ответил(а) в {-file-} на {-comment-}",
  1032: "{-somebody-} загрузил(а) файл в комментарий к {-file-}",
  1033: "{-somebody-} удалил(а) из {-file-} комментарий типа {-commentType-}",
  1034: "{-somebody-} отметил(а) комментарий {-comment-} в {-file-} как {-finish-}",
  1035: "{-somebody-} изменил(а) описание версии №{-No.-} файла {-file-} на {-remark-}",
  1036: "{-somebody-} открыл(а) папку сбора файлов {-file-}",
  1037: "Пожалуйста, отправьте материалы как можно скорее, крайний срок {-time-}",
  1038: "{-somebody-} обновил(а) настройки папки сбора файлов {-file-}",
  1039: "{-somebody-} пригласил(а) вас к согласованию {-file-}",
  1040: "И добавил(а) примечание: {-comment-}",
  1041: "{-file-} успешно согласован",
  1042: "{-file-} не прошёл согласование, отклонён！",
  1043: "{-somebody-} уже {-pass-}{-file-}",
  1044: "{-somebody-} пригласил(а) следующих пользователей {-user-} в шаринг {-file-}",
  1045: "{-somebody-} загрузил(а) {-file-} в {-folder-}",
  1046: "{-somebody-} загрузил(а) новую версию {-file-} в {-folder-}",
  1047: "{-somebody-} добавил(а) к {-file-} связанный файл {-destinationFile-}",
  1048: "и ещё {-count-} файлов(папок)",
  1049: "{-somebody-} архивировал(а) {-file-}",
  1050: '<p class="title">Подтвердить удаление отдела：{-department-}  ？</p><p class="mgt-20 Cred">Внимание： файлы отдела и связи между сотрудниками будут удалены</p>',
  1051: "{-somebody-} архивировал(а) документ {-file-} в отделе {-depName-}",
  1052: ", и оставил(а) сообщение: {-leaveMessage-}",
  1053: "Администратор",
  1054: "Отозвать согласование",
  1055: "Отзыв согласования удалит все записи о согласовании этого файла, подтвердить отзыв?",
  1056: "{-somebody-} отозвал(а) процесс согласования для {-file-}",
  1057: "{-somebody-} создал(а) архивную папку {-folder-} в {-parentFolder-}",
  1058: "{-somebody-} в {-file-} изменил(а) права следующих пользователей с 'помощника проекта' на обычного участника, права: {-newRole-}",
  // web browser message
  1500: "сказал(а):",
  1501: "отправил(а) файл",
  1502: "нарисовал(а) рукописный комментарий",
  1503: "отправил(а) голосовой комментарий",
  1504: "создал(а) папку {-fileName-}",
  1505: "загрузил(а) {-fileEdition-}:{-fileName-}",
  1506: "переименовал(а) {-file-} в {-newName-}",
  1507: "присоединился(ась) к обсуждению",
  1508: "покинул(а) команду: {-teamName-}",
  1509: "удалил(а) {-user-} из команды：{-teamName-}",
  1510: "покинул(а) обсуждение",
  1511: "Вы были удалены из команды {-teamName-}",
  1512: "Вы были удалены из шаринга {-shareName-}",
  1513: "поделился(ась) {-file-}",
  1514: "закрыл(а) команду {-teamName-}",
  1515: "изменил(а) роль участника {-user-} в команде {-file-} с {-oldRole-} на {-newRole-}",
  1516: "изменил(а) роль участника {-user-} в шаринге {-file-} с {-oldRole-} на {-newRole-}",
  1517: "@Вам:",
  1518: "добавил(а) комментарий в файл {-file-}",
  1519: "Добавил(а)",
  1520: "Ответил(а)",
  1521: "Загрузил(а) файл-референс в комментарий",
  1522: "Отметил(а) комментарий в файле {-file-} как выполненный",
  1523: "Отметил(а) комментарий в файле {-file-} как невыполненный",
  1524: "Переместил(а) в {-file-}",
  1525: "Удалил(а) из {-file-}",
  1526: "Вас исключили из отдела {-department-}",
  1527: "Удалил(а) {-user-} из отдела {-department-}",
  1528: "Вас добавили в отдел {-department-}",
  1529: "Добавил(а) {-user-} в отдел {-department-}",
  1530: "Пригласил(а) вас в команду {-team-}",
  1531: "Пригласил(а) вас в шаринг {-file-}",
  1532: "Удалил(а) вас из приглашения в шаринг {-file-}",
  1533: "Изменил(а) описание версии файла {-file-} на {-remark-}",
  1534: "Переместил(а) {-file-} в {-folder-}",
  1535: "Передал(а) проект {-project-} в отдел {-department-}",
  1536: "Новый руководитель проекта: {-user-}",
  1537: "Создал(а) архивную папку {-fileName-}",
  1538: "(Скачать)",
  1539: "Назначил(а) руководителя проекта {-project-} — {-user-}",
  1540: "Загружено {-num-} из {-total-}",
  1541: "Загружено все, всего {-total-}",
  1542: "Загрузка...",
  1543: "Преобразовать проект {-project-} в родительский проект",
  //-------------------------------------- 分享等 alert 提示

  2000: "Администратор изменил вашу роль в {-depName-} на {-role-}",
  2001: "Текущий отдел был перемещён; эта страница будет закрыта",
  2002: "Администратор изменил ваши права на этот файл. Текущие права: {-role-}",
  2003: "Права по умолчанию",
  2004: "Просмотреть файл",
  2005: "Просмотр",
  2006: "Загрузка",
  2007: "Только загрузка",
  2008: "Показать комментарии",
  2009: "Предыдущая",
  2010: "Навигация по файлам",
  2011: "Файл {-fileNo-} из {-fileCount-}",
  2012: "Следующая",
  2013: "Идёт трансляция",
  2014: "Режим трансляции",
  2015: "Во время трансляции содержимое документа на экранах зрителей будет синхронизировано с вашим",
  2016: "Вы уверены, что хотите прекратить наблюдение?",
  2017: "Вы уверены, что хотите остановить трансляцию?",
  2018: "Отправка...",
  2019: "Отправка не удалась",
  2020: "Текущая трансляция была остановлена",
  2021: "Кто-то запросил голосовой вызов, но локальная среда не готова",
  2022: "На устройстве пользователя нет аудиоустройств",
  2023: "Нет защиты",
  2024: "Пользователь запретил голосовые запросы",
  2025: "Не удалось запустить голос, аудиовызов требует HTTPS",
  2026: "Кто-то хочет связаться с вами голосом, но вы не включили аудио",
  2027: "Добавить комментарий",
  2028: "Прямоугольная аннотация",
  2029: "Круговая аннотация",
  2030: "Аннотация-стрелка",
  2031: "Тег-аннотация",
  2032: "Запустить трансляцию",
  2033: "Ведущий",
  2034: "Сменить ведущего",
  2035: "Остановить трансляцию",
  2036: "Наблюдать",
  2037: "Прекратить наблюдение",
  2038: "Введите сообщение",
  2039: "Зрители",
  2040: "Мел",
  2041: "Ластик",
  2042: "Администратор изменил ваши права на этот файл",
  2043: "Всего файлов",
  2044: "Статистика количества файлов в подчинённых отделах",
  2045: "Нет загруженных файлов",
  2046: "Подсказка: этот пользователь не загружал файлы в текущем отделе",
  2047: "Подсказка: этот пользователь не загружал файлы в текущей папке",
  2048: "Список загруженных файлов",
  2049: "Посмотреть файлы, загруженные этим пользователем в отделе",
  2050: "Посмотреть файлы, загруженные этим пользователем в шаринге",
  2051: "Статистика числа файлов по отделам",
  2052: "Вы уверены, что хотите удалить эти штрихи?",
  2053: "Вы уверены, что хотите удалить все штрихи этого пользователя?",
  2054: "Недопустимое значение ввода",
  2055: "В этой директории нет файлов, соответствующих условиям поиска！",
  2056: "Все пользователи",
  // -------------------------------- 前台设置
  2300: "Информация об аккаунте",
  2301: "Настройки пароля",
  2302: "Настройки уведомлений",
  2303: "Базовые услуги профессиональной версии",
  2304: "Скоро истекает",
  2305: "Истёк",
  2306: "Продлить",
  2307: "Пожалуйста, вовремя {-dosomething-}。",
  2308: "Пользователь корпоративной версии",
  2309: "Пользователь персональной версии",
  2310: "Пользователь профессиональной версии",
  2311: "Дата окончания",
  2312: "Детали заказа",
  2313: "Дней действия",
  2314: "Изменить аватар",
  2315: "Телефон",
  2316: "Не привязан",
  2317: "Привязать",
  2318: "После привязки e-mail вы будете своевременно получать уведомления",
  2319: "Никнейм",
  2320: "Пока не поддерживается онлайн-обновление, пожалуйста, обратитесь в поддержку：",
  2321: "Не удалось получить информацию о пространстве",
  2322: "Загрузить аватар",
  2323: "Привязать номер телефона",
  2324: "Телефон успешно привязан",
  2325: "Введите номер телефона",
  2326: "Неверный формат номера телефона",
  2327: "Код не может быть пустым",
  2328: "Введите пароль",
  2329: "Введите пароль 6–20 символов, содержащий заглавные и строчные буквы и цифры",
  2330: "Изменить никнейм",
  2331: "Введите никнейм",
  2332: "Изменить e-mail",
  2333: "Введите новый e-mail",
  2334: "Изменить номер телефона",
  2335: "Введите новый номер телефона",
  2336: "Код из SMS",
  2337: "Код с e-mail",
  2338: "Привязать e-mail",
  2339: "Введите e-mail",
  2340: "Неверный формат e-mail",
  2341: "Вы ещё не привязали e-mail или телефон, после привязки сможете входить по e-mail(телефон)+пароль.",
  2342: "Старый пароль",
  2343: "Новый пароль",
  2344: "Подтвердите пароль",
  2345: "Сброс",
  2346: "Пароль успешно изменён",
  2347: "Неверный старый пароль",
  2348: "Вы ещё не вошли в систему",
  2349: "Сеть перегружена, попробуйте позже",
  2350: "Введите старый пароль",
  2351: "Введите новый пароль",
  2352: "Введите подтверждение пароля",
  2353: "Пароли не совпадают",
  2354: "Выберите типы уведомлений, которые хотите получать",
  2355: "Загрузка файла",
  2356: "Комментарии к файлу",
  2357: "Управление участниками шаринга",
  2358: "Вы ещё не привязали e-mail, возможно, не получите уведомления; привяжите e-mail как можно скорее.",
  2359: "Привязать",
  2360: "Инициализация пароля входа",
  2361: "Введите код",
  2362: "Общая корпоративная группа",
  2363: "Создать группу",
  2364: "Групп нет",
  2365: "Персональные группы",
  2366: "Не удалось получить информацию о группах, попробуйте позже",
  2367: "Вы уверены, что хотите удалить эту группу？",
  2368: "Название группы не может быть пустым",
  2369: "Вы уверены, что хотите удалить этого человека из группы？",
  2370: "Название группы",
  2371: "член группы",
  2372: "В группе нет участников",
  2373: "Введите название группы",
  2374: "Главная",
  2375: "Предыдущая",
  2376: "Следующая",
  2377: "Последняя",
  2378: "стр.",
  2379: "Перейти на страницу {-no.-}",
  2380: "элем.",
  2381: "Создать папку сбора файлов",
  2382: "настройка",
  2383: "Добавлять из списка корпоративных участников или групп",
  2384: "Персональная группа",
  2385: "Получить SMS-код",
  2386: "Не удалось получить информацию о пространстве пользователя",
  2387: "Нет файлов для переноса",
  2388: "Все роли",
  2389: "Изменить отдел",
  2390: "Пока не состоит в отделе",
  2391: "Введите ник или имя файла",
  2392: "Выберите текстовый водяной знак",
  2393: "Имя отправителя шаринга",
  2394: "Использовать водяной знак учётной записи",
  2395: "При использовании водяного знака учётной записи водяной знак будет отображать аккаунт просматривающего. Анонимные пользователи видят водяной знак отправителя.",
  2396: "Введите e-mail, телефон или ник",
  2397: "Конфиденциальный архив: кроме создателя и менеджера отдела файл невидим",
  2398: "Ограниченный архив: кроме создателя и менеджера отдела файлы нельзя взять",
  2399: "Внутренний архив: только сотрудники отдела могут взять",
  2400: "Каталог файлов",
  2401: "Просмотров",
  2402: "раз",
  2403: "Вы не являетесь владельцем файла и не можете удалить его окончательно",
  2404: "Добавить из списка сотрудников",
  2405: "Вы уверены, что хотите удалить отдел из группы？",
  //-------------------------------------- 胡继超新增

  2500: "Отправитель",
  2501: "{-somebody-} запустил(а) согласование файла {-file-} и прислал(а) вам копию",
  2502: "Срок истёк",
  2503: "Редактировать",
  2504: "Текущая папка",
  2505: "Тип файла",
  2506: "Полнотекстовый поиск",
  2507: "Только имя файла",
  2508: "Управление отделом",
  2509: "Базовые права",
  2510: "Настройки прав доступа к файлу",
  2511: "Дата окончания прав доступа к файлу",
  2512: "Нажмите, чтобы просмотреть контроль доступа к файлу",
  2513: "Привязка адреса",
  2514: "Включить привязку MAC-адреса",
  2515: "После включения привязки MAC-адреса аккаунт, привязанный к MAC, не сможет доступиться к клиенту с других MAC-адресов (веб-версия не ограничена).",
  2516: "Список привязок",
  2517: "Пул MAC-адресов",
  2518: "Добавить привязку",
  2519: "Нет записей о привязке",
  2520: "Подсказка: записей о привязке MAC-адресов нет. Нажмите «Добавить привязку», чтобы привязать MAC-адрес сотрудника",
  2521: "Нет записей привязки, соответствующих критериям",
  2522: "Подсказка: измените параметры поиска и повторите поиск",
  2523: "Привязанный MAC-адрес",
  2524: "Привязанный пул MAC-адресов",
  2525: "Статус клиентов онлайн",
  2526: "Текущий MAC-адрес",
  2527: "Привязать MAC-адрес",
  2528: "Можно добавить максимум {-max-}, добавлено {-num-}",
  2529: "Введите MAC-адрес для привязки",
  2530: "Сотрудники отдела",
  2531: "Участники группы",
  2532: "Несколько адресов разделяйте пробелом или запятой, оставьте пустым для отсутствия привязки（AA:AA:AA:AA:AA:AA）",
  2533: "Выбрать пул MAC-адресов",
  2534: "Создать пул MAC-адресов",
  2535: "Пул MAC-адресов — заранее заданный набор MAC-адресов для управления. Если пула нет, нажмите «{-text-}», чтобы создать. Выбрав «Нет», пул не будет привязан",
  2536: "Добавить",
  2537: "Внимание： массовое редактирование удалит предыдущие записи привязки и перепривяжет MAC-адреса по новым правилам",
  2538: "Количество MAC-адресов в пуле",
  2539: "Количество онлайн клиентов",
  2540: "Редактировать пул MAC-адресов",
  2541: "Название пула MAC-адресов",
  2542: "Редактировать MAC-адреса",
  2543: "Введите MAC-адреса для добавления",
  2544: "Несколько адресов разделяйте пробелом, переводом строки или запятой",
  2545: "Создать пул MAC-адресов",
  2546: "Введите имя пула MAC-адресов: имя должно быть уникальным",
  2547: "Введите MAC-адрес",
  2548: "Добавить пул MAC-адресов",
  2549: "Отвязать",
  2550: "Привязать текущий адрес",
  2551: "Название уже существует",
  2552: "В введённых адресах {-msg-} не соответствует формату MAC-адреса; они будут отфильтрованы при отправке. Продолжить?",
  2553: "MAC-адресов нет, нажмите «Массово добавить адреса», чтобы добавить в пул",
  2554: "Массово добавить адреса",
  2555: "Выберите пул MAC-адресов",
  2556: "Узнать о уровнях безопасности",
  2557: 'Конфиденциальный файл，<span class="gray">по умолчанию, кроме создателя, руководителя проекта, ответственного за файл и менеджера отдела, остальные сотрудники отдела не видят файл; для шаринга требуется авторизация сотрудника по безопасности</span>',
  2558: 'Ограниченный файл，<span class="gray">обычным сотрудникам доступ — только для чтения; для шаринга требуется разрешение руководителя</span>',
  2559: 'Внутренний файл，<span class="gray">для шаринга за пределы отдела требуется разрешение руководителя</span>',
  2560: "Для указанных трёх типов файлов не поддерживается шаринг по ссылке — только по приглашениям",
  2561: "Подсказка: пула MAC-адресов нет, вы можете нажать «Добавить пул MAC-адресов» чтобы создать пул",
  2562: "Управление устройствами",
  2563: "в",
  2564: "Онлайн-устройства",
  2565: "текущий",
  2566: "Выйти",
  2567: "Вы уверены, что хотите завершить сессию на этом устройстве?",
  2568: "Клиент Бабель",
  2569: "Веб-версия Бабель",
  2570: "Отправил(а) вам файл",
  2571: "Нажмите сюда, чтобы скачать",
  2572: "Этот файл был удалён",
  2573: "Файл защищён внутренними настройками; приглашённым потребуется одобрение руководителя отдела, запрос отправлен, пожалуйста, ожидайте",
  2574: "{-sign-} обработал(а) ваш запрос на шаринг файла {-fileName-}",
  2575: "Уровень доступа",
  2576: "Ограниченные отделы",
  2577: "Конфиденциальные и ограниченные файлы: обычные сотрудники не могут перемещать/копировать/загружать новые версии/скачивать/переименовывать/просматривать версии; это могут руководитель и сотрудники с правами управления отделом",
  2578: "Нажмите для просмотра персонала подгруппы",
  2600: "Быстрая отправка файлов",
  2601: "Выберите или введите e-mail получателя",
  2602: "Хранение почты",
  2603: "Сохранять мои письма в Бабель",
  2604: "Домен",
  2605: "Введите домен почтового ящика для приёма почты",
  2606: "Номер порта",
  2607: "Введите номер порта для приёма почты",
  2608: "Синхронизировать почту",
  2609: "Синхронизация почты может занять несколько минут; вы можете покинуть эту страницу и продолжить работу",
  2610: "Показ в большом окне",
  2611: "Выбрать все",
  2612: "Введите аккаунт почты для приёма",
  2613: "Добавлять права к файлу",
  2614: "Статистика настройки прав доступа к файлам",
  2615: "Контроль",
  2616: "Настроить почту",
  2617: "Бабель может управлять доступом к файлам в папках отдела; кликните правой кнопкой по файлу отдела и выберите «Контроль доступа к файлу», чтобы изменить права. Изменённые права можно централизованно управлять здесь",
  2618: "Не сотрудники отдела",
  2619: "У вас нет прав для просмотра этого файла",
  2620: "Бабель может сохранять ваши письма и вложения; включив хранение почты, настройте почтовый ящик, и ваши письма и вложения будут сохраняться в каталоге «Моя почта»",
  2621: "Контроль доступа",
  2622: "Пока нет содержимого",
  2623: "Создать ярлык",
  2624: "Экспорт списка файлов",
  2625: "Ярлык",
  2626: "Синхронизация",
  2627: "Увеличить",
  2628: "Уменьшить",
  2629: "По размеру экрана",
  2630: "После настройки почты нажмите «Синхронизировать почту» для получения",
  2631: "Авторизационный код",
  2632: "Введите код авторизации（войдите в QQ-почту, Настройки--Аккаунт, включите POP3 и сгенерируйте код）",
  2633: "Масштаб по выделению",
  2634: "Подсказка : нет внешних участников онлайн",
  2635: "Этот аккаунт уже зарегистрирован в Бабель, введите другой e-mail или телефон",
  2640: "Поле 'порт' допускает только цифры",
  2650: "Супер-администратор",
  2651: "Менеджер отдела",
  2652: "Чтение онлайн",
  2653: "Копировать",
  2654: "Статистика файлов",
  2655: "Активные файлы",
  2656: "Активность системы",
  2657: "Охват отдела",
  2658: "Период времени",
  2659: "Выберите тип файла",
  2660: "Все типы",
  2661: "В этом отделе пока нет файлов",
  2662: "На этой неделе",
  2663: "В этом месяце",
  2664: "В этом квартале",
  2665: "В этом году",
  2666: "За последний год",
  2667: "За последние два года",
  2668: "Статистика активности файлов",
  2669: "Просмотров",
  2670: "Пожалуйста, выберите период",
  2671: "Число файлов по отделам",
  2672: "Уровень подразделения",
  2673: "Просмотры папок",
  2674: "Просмотры файлов",
  2675: "Показать список рукописных заметок",
  2676: "Описание файла",
  2677: "Настройки корзины",
  2678: "Время хранения файлов в корзине",
  2679: "Введите количество дней",
  2680: "Примечание：время хранения в корзине можно задать от 1 до 999 дней",
  2681: "дн.",
  2682: "Найти в документе…",
  2683: "Найти предыдущее совпадение",
  2684: "Найти следующее совпадение",
  2685: "Предыдущее",
  2686: "Следующее",
  2687: "Найти",
  2688: "Подсветка",
  2689: "Совпадение целого слова",
  2690: "Учитывать регистр",
  2691: "{-somebody-} сменил(а) ответственного за файл/папку {-file-} с {-from-} на {-to-}",
  2692: "Такое название группы уже существует",
  2693: "Поделился с вами файлом",
  2694: "Установить крайний срок",
  2695: "Удалить крайний срок",
  //----------------2700  归档
  2700: "Архив",
  2701: "Мои заявки на доступ",
  2702: "Одобрение займа",
  2703: "Дата последнего изменения",
  2704: "Кто архивировал",
  2705: "Нет архивных файлов(папок)",
  2706: "Корпоративный архив",
  2707: "Не обработано",
  2708: "Дата заявки",
  2709: "Содержание заявки",
  2710: "Статус согласования",
  2711: "Согласующий",
  2712: "Согласование",
  2713: "Дата согласования",
  2714: "Не согласовано(выбрать из списка)",
  2715: "Мои выдачи",
  2716: "Нет выданных файлов(папок)",
  2717: "Нет заявок на выдачу файлов(папок)",
  2718: "Статус согласования отдела",
  2719: "Статус согласования компании",
  2720: "Заявитель",
  2721: "Причина запроса",
  2722: "Согласование отдела",
  2723: "Корпоративное согласование",
  2724: "Вернуть",
  2725: "Уверены, что вернуть этот файл?",
  2726: "{-somebody-} запросил(а) {-type-} архивный файл(папку) {-file-} в {-depName-}, и добавил(а): {-comment-}",
  2727: "{-somebody-} одобрил(а) вашу заявку на выдачу архивного файла(папки) {-file-}",
  2728: "{-somebody-} отклонил(а) вашу заявку на выдачу архивного файла(папки) {-file-}",
  2729: "Расположение",
  2730: "У вас нет прав на выдачу этого файла",
  2731: "Журнал просмотра архива",
  2732: "Дата возврата",
  2733: "Поиск заявителя, нажмите Enter",
  2734: "Поиск имени файла, нажмите Enter",
  2735: "Период заявки",
  //----手绘

  2736: "Скрыть рукописные штрихи",
  2737: "Список рукописных заметок",
  2738: "Просмотреть рукописные штрихи",
  2739: "{-somebody-} добавил(а) рукописные штрихи в файл(папку) {-file-}",
  2740: "{-somebody-} удалил(а) рукописные штрихи в файле(папке) {-file-}",
  //------图形工具
  2741: "Инструменты фигур",
  2742: "Базовые",
  2743: "Выберите фигуру для вставки и кликните в нужном месте на полотне, чтобы вставить",
  2744: "Сохранить значок сварки",
  2745: "{-somebody-} добавил(а) значок сварки в файл(папку) {-file-}",
  2746: "{-somebody-} удалил(а) значок сварки в файле(папке) {-file-}",
  //------
  2747: "Ответственный за файл",
  2748: "Сменить ответственного",
  2749: "Назначить ответственного за файл",
  2750: "Поиск по нику или e-mail",
  2800: "Все в отделе",
  2801: "Все обычные участники отдела без дополнительных прав",
  2802: "Введите примечание",
  2803: "Не задавать (наследовать от {-name-})",
  2804: "В дочерних файлах заданы дополнительные права. Перезаписать существующие настройки? (При перезаписи дополнительные права всех дочерних файлов будут сброшены и установлены как текущие)",
  2805: "Перезаписать",
  2806: "Добавить",
  2810: "Создать проект",
  2811: "Создать подпроект",
  2812: "Информация о проекте",
  2813: "Введите название проекта",
  2814: "Руководитель",
  2815: "Нажмите, чтобы выбрать руководителя",
  2816: "Участники проекта",
  2817: "Выберите руководителя проекта",
  2818: "Выберите участников проекта",
  2819: "В проекте пока нет участников. Нажмите «Добавить участников», чтобы приглашать по одному. После создания проекта можно правым кликом выбрать «Управление проектом» → «Получить ссылку-приглашение», скопировать её (или QR) и разослать желающим",
  2820: "Передача проекта",
  2821: "Текущий отдел",
  2822: "Текущий руководитель",
  2823: "Целевой отдел",
  2824: "Новый руководитель",
  2825: "Передать",
  2826: "Тип проекта",
  2827: "Проект",
  2828: "Подпроект",
  2829: "Сделать подпроектом",
  2830: "Сделать родительским проектом",
  2831: "Целевой проект",
  2832: "Выберите целевой проект",
  2833: "Управление проектом",
  2834: "Пожалуйста, выберите целевой проект",
  2835: "Информация о проекте заполнена не полностью",
  2836: "Запрос на приглашение пользователей в шаринг файла(папки) {-file-}",
  2837: "В этом отделе нет прав на создание проектов",
  2838: "Выберите целевой отдел（проект）",
  2839: "В проекте есть подпроекты — операция не выполнена！",
  // 2332: '目标项目',
  // 2603: '请输入要代收的邮箱',

  2840: "Шаринг внутри отдела",
  2841: "Файлы с дополнительными правами внутри отдела",
  2842: "Управление шарингом файлов",
  2843: "Примечание：здесь отображаются все файлы отдела, для которых настроен контроль доступа",
  2844: "В текущем отделе нет файлов с заданным контролем доступа",
  2845: "Просмотреть шаринг",
  2846: "Отключить шаринг",
  2847: "Автор шаринга",
  2848: "Папка",
  2849: "Шаринг внутри отдела",
  2850: "Все шаринги отдела",
  2851: "В текущем каталоге нет общедоступных файлов(папок)",
  2852: "Уровень секретности",
  2853: "Статистика по секр. файлам",
  2854: "В отделе нет файлов с особыми уровнями секретности",
  2855: "Все секретные файлы отдела",
  2856: "Статистика по уровням секретности",
  2857: "Не удалось отменить сообщение，（время истекло）",
  2858: "Не удалось отменить сообщение，（перезагрузите и повторите）",
  2859: "В отделе {-count-} общих файлов, закрыть шаринг?",
  2860: "Настройки почтовых уведомлений",
  2861: "Настройки получения активности",
  2862: "Получать следующие уведомления",
  2863: "Приоритетные уведомления",
  2864: "Релевантные уведомления",
  2865: "Низкоприоритетные уведомления",
  2866: "Файлы, загруженные мной",
  2867: "Файлы, которые я комментировал(а)",
  2868: "Файлы, за которыми я слежу",
  2869: "Файлы, в которых я участвую в шаринге",
  2870: "Файлы того же отдела",
  2871: "Файлы подразделений",
  2872: 'Файл "{-name-}" содержит недопустимые символы, переименуйте и загрузите заново："{-str-}"',
  2873: 'Не удалось загрузить "{-fileName-}" — папка сбора "{-name-}" принимает только расширения "{-str-}"',
  2874: 'Не удалось загрузить "{-fileName-}" — папка сбора "{-name-}" принимает только файлы с именем "{-str-}"',
  2875: "Установить права по участникам",
  2876: "Установить права по ролям",
  2877: "Добавить права доступа к файлу для роли отдела（действует для файла/папки и её дочерних файлов）",
  2878: "Число авторизованных：{-count-}",
  2879: "Авторизация сервиса",
  2880: "Ваше личное хранилище заполнено более чем на 90%, свяжитесь с супер-админом для расширения",
  2881: "Контактный телефон",
  //------------------------------------- 企业后台

  3000: "Настройки компании",
  3001: "Конфигурация компании",
  3002: "Оргструктура",
  3003: "Управление участниками",
  3004: "Управление правами",
  3005: "Управление тегами",
  3006: "Управление согласованиями",
  3007: "Корпоративные уведомления",
  3008: "Управление группами",
  3009: "Настройки водяного знака",
  3010: "Идентификатор компании",
  3011: "Верифицировано",
  3012: "Не верифицировано",
  3013: "Основная информация",
  3014: "Контакт компании",
  3015: "Логотип компании",
  3016: "Управление доменами",
  3017: "Пространство компании",
  3018: "Расширение пространства",
  3019: "Массовая смена лимитов личного пространства",
  3020: "Пользователи компании",
  3021: "Почтовые уведомления",
  3022: "Отключите это, чтобы запретить корпоративные почтовые уведомления",
  3023: "Краткое название компании",
  3024: "Краткое название отображается в заголовке и является именем корневого отдела",
  3025: "Полное название компании",
  3026: "Полное название отображается на странице входа",
  3027: "e-mail",
  3028: "Привязанный телефон",
  3029: "Ник",
  3030: "E-mail",
  3031: "Телефон",
  3032: "Выбрать изображение",
  3033: "Поддерживаются jpg, jpeg, png, bmp, размер < 5MB。",
  3034: "Адрес домена",
  3035: "Корпоративное хранилище Бабель",
  3036: "Срок действия корпоративной подписки до",
  3037: "Добавить отдел",
  3038: "Поиск отдела",
  3039: "Просмотреть журнал доступа к файлам отдела",
  3040: "Прямые участники классифицируются по ролям, редактируются локально; для нижестоящих участников нажмите просмотреть",
  3041: "Роль/Организация",
  3042: "Переместить отдел",
  3043: "Добавить подразделение",
  3044: "Удалить отдел",
  3045: "- краткое описание функций отдела -",
  3046: "Родительский отдел",
  3047: "Создатель отдела",
  3048: "Дата создания",
  3049: "Подразделения",
  3050: "Участники",
  3051: "Конфигурация пространства компании",
  3052: "Конфигурация пространства отдела",
  3053: "Занято",
  3054: "Просмотреть файлы отдела",
  3055: "Остаток места",
  3056: "Настройки участников компании",
  3057: "Настройки участников отдела",
  3058: "Управление аккаунтами",
  3059: "Перенос владения файлами",
  3060: "Перенести в",
  3061: "Администратор может перенести файлы участника другому участнику",
  3062: "Отключить аккаунт",
  3063: "Восстановить",
  3064: "Отключить",
  3065: "Отключение аккаунта запрещает вход в компанию (восстановимо)",
  3066: "Удалить аккаунт",
  3067: "При удалении аккаунта его личные файлы удаляются (файлы в отделах сохраняются), будьте осторожны",
  3068: "Последний вход",
  3069: "Управление правами",
  3070: "Изменить",
  3071: "Статус участника",
  3072: "Использование личного хранилища",
  3073: "Ник",
  3074: "Пол",
  3075: "М",
  3076: "Ж",
  3077: "Контакты",
  3078: "Дата приёма",
  3079: "Заметки",
  3080: "Сохранить",
  3081: "Отмена",
  3082: "Отключен",
  3083: "Изменить пароль",
  3084: "E-mail",
  3085: "Отдел",
  3086: "Роль",
  3087: "Добавить роль",
  3088: "Бабель позволяет одному человеку иметь разные роли в разных отделах",
  3089: "Лимит личного пространства",
  3090: "Личные файлы",
  3091: "Здесь можно управлять правами всех ролей в компании и добавлять новые; после выбора прав нажмите ОК для применения. (Файлы других — файлы, загруженные другими участниками отдела; свои файлы — файлы, загруженные вами в отделе)",
  3092: "Права управления отделом",
  3093: "Переместить в",
  3094: "Название отдела",
  3095: "Описание отдела",
  3096: "Подтвердить",
  3097: "Выбрать отдел",
  3098: "Пожалуйста, выберите родительский отдел",
  3099: "Введите название отдела",
  3100: "Отдел с таким названием уже существует",
  3101: "Все отделы",
  3102: "Ограничить использование пространства этим отделом",
  3103: "Снимите флажок ограничения, и отдел сможет использовать пространство в пределах родительского отдела без ограничений",
  3104: "Доступно для настройки объёма",
  3105: "Этот отдел уже занял место",
  3106: "Ограничение пространства ",
  3107: "Журнал доступа к файлам",
  3108: "Посмотреть посетителей",
  3109: "Поиск имен или файлов...",
  3110: "Просмотреть все записи",
  3111: "Только записи доступа",
  3112: "Только загрузки/скачивание",
  3113: "Только анонимные пользователи",
  3114: "Файлы в отделе",
  3115: "Включить общий доступ к файлам",
  3116: "Журнал файлов",
  3117: "Будут изменены отделы и роли следующих {-length-} сотрудников",
  3118: "Массовая смена отдела",
  3119: "Отправить",
  3120: "Занято",
  3121: "Онлайн",
  3122: "Офлайн",
  3123: "Заблокирован",
  3124: "Нет сотрудников",
  3125: "Подсказка : В отделе нет внутренних участников",
  3126: "Нет сотрудников по условиям",
  3127: "Подсказка : измените условия и повторите поиск",
  3128: "Ник(аккаунт)",
  3129: "Владение файлом",
  3130: "Управление сотрудниками",
  3131: "Выбрать участника",
  3132: "Подтвердить удаление из отдела?",
  3133: "Вы не можете удалить аккаунт, созданный другим!",
  3134: "Аккаунт уже удалён",
  3135: "Подтвердить {-prompt-} выбранные аккаунты?",
  3136: "Загрузить файлы участников компании",
  3137: "Установить начальный пароль",
  3138: "Выполнить импорт",
  3139: "Далее",
  3140: "Нажмите, чтобы загрузить",
  3141: "Загрузить заполненный файл участников",
  3142: "Поддерживаются только файлы excel, размер не более 2M",
  3143: "Скачать шаблон",
  3144: "Случайный пароль",
  3145: "При входе пользователь будет предложен сменить пароль",
  3146: "Идёт импорт...",
  3147: "Импорт завершён",
  3148: "Неизвестная ошибка",
  3149: "Ошибка сети",
  3150: "Импорт не удался",
  3151: "Отправить сообщение",
  3152: "Отправить сообщение",
  3153: "Просмотреть сообщение",
  3154: "Введите получателя сообщения",
  3155: "Корпоративные сообщения можно отправлять всем сотрудникам или выбранным участникам",
  3156: "Заголовок",
  3157: "Введите заголовок",
  3158: "Содержимое сообщения",
  3159: "Введите содержимое сообщения",
  3160: "Осталось ввести",
  3161: "симв.",
  3162: "Получатели",
  3163: "Пожалуйста, выберите получателей",
  3164: "Введите e-mail",
  3165: "Добавить отправителя",
  3166: "Удалить отправителя",
  3167: "Нажмите, чтобы просмотреть детали",
  3168: "Нет объявлений",
  3169: "Подсказка : нет исторических объявлений",
  3170: "Автор",
  3171: "Тема",
  3172: "Время",
  3173: "Управление авторами",
  3174: "",
  3175: "Поиск по теме сообщения",
  3176: "Просмотр сообщения",
  3177: "Пожалуйста, выберите участников",
  3178: "Участники",
  3179: "Подтвердить удаление шаблона согласования {-name-} ",
  3180: "Нет авторов",
  3181: "Ник(аккаунт)",
  3182: "Отдел-Роль",
  3183: "Подсказка : нет авторов",
  3184: "Не удалось получить информацию об авторах",
  3185: "Процессы согласования",
  3186: "Добавить процесс согласования",
  3187: "Подтвердить удаление шаблона согласования {-name-}",
  3188: "Нет согласований",
  3189: "Подсказка : нет информации о согласованиях",
  3190: "Название процесса",
  3191: "Согласующие",
  3192: "Число использований",
  3193: "Добавить группу",
  3194: "Подтвердить удаление группы {-name-}",
  3195: "Группа удалена",
  3196: "Не удалось удалить группу",
  3197: "Нет групп",
  3198: "Подсказка : нет информации по группам",
  3199: "Название группы",
  3200: "Число участников",
  3201: "Создатель",
  3202: "Выбрать пользователя",
  3203: "Фильтр",
  3204: "Массовая установка лимита пространства для выбранных пользователей",
  3205: "Введите желаемый лимит и нажмите Сохранить; лимиты выбранных пользователей будут установлены в это значение, ввод 0 означает отсутствие ограничения。",
  3206: "Массовое добавление лимита",
  3207: "Добавить",
  3208: "Операция добавления увеличивает лимит пользователя поверх текущего лимита.",
  3209: "Пример：A=20G, B=50G; при добавлении 50G => A=70G, B=100G。",
  3210: "Подходит",
  3211: "пользователей всего {-totalNum-}, {-onlineNum-} онлайн. Можете выполнять массовые операции справа.",
  3212: "Массовое редактирование",
  3213: "Ник(аккаунт)",
  3214: "Последний вход",
  3215: "Отдел",
  3216: "",
  3217: "Онлайн-пользователи компании",
  3218: "Дополнительные опции",
  3219: "Свернуть",
  3220: "Пожалуйста, выберите отправителя",
  3221: "Пожалуйста, выберите других получателей",
  3222: "Название папки сбора не может быть пустым",
  3223: "Примечание к папке не может быть пустым",
  3224: "Крайний срок не может быть пустым",
  3225: "Папка сбора используется для получения материалов; в названии и примечании укажите цель и инструкции",
  3226: "Название папки сбора",
  3227: "Другие получатели",
  3228: "Другие получатели, как и вы, могут просматривать все отправленные материалы и комментарии",
  3229: "Создать",
  3230: "Пожалуйста, выберите отправителя",
  3231: "Пожалуйста, выберите дату",
  3232: "Использовать водяной знак",
  3233: "После включения и настройки водяного знака файлы с водяным знаком будут отображать его при просмотре",
  3234: "Отключить водяной знак",
  3235: "Выберите область применения водяного знака",
  3236: "Все файлы",
  3237: "Все внешне шаренные файлы",
  3238: "Устанавливается отправителем файла",
  3239: "Текстовый водяной знак",
  3240: "Пользовательский текст",
  3241: "Расположение водяного знака",
  3242: "Диагональная плитка",
  3243: "В центре файла",
  3244: "Вверху/внизу файла",
  3245: "Непрозрачность водяного знака",
  3246: "Предпросмотр",
  3247: "Поддерживает *.png，рекомендуемое разрешение 200*300",
  3248: "Использовать изображение как водяной знак",
  3249: "Загрузить изображение водяного знака (PNG)",
  3250: "Правый нижний угол",
  3251: "Загрузка...",
  3252: "Статистика числа участников по ролям",
  3253: "Подтвердите удаление прав",
  3254: "Изображение водяного знака",
  3255: "Предпросмотр водяного знака",
  3256: "Подсказка : нет внутренних участников",
  3257: "Отдел-Роль",
  3258: "Лимит пространства пользователя изменён успешно",
  3259: "Не удалось изменить, ошибка сервера",
  3260: "Не удалось изменить права администратора, ошибка сервера",
  3261: "Ник не может быть пустым",
  3262: "Дублирование отдела",
  3263: "Подтвердите удаление аккаунта сотрудника- <span class='f-emph'> {-name-} </span> ?",
  3264: "Все личные файлы этого сотрудника будут удалены",
  3265: "Подтвердите отключение аккаунта сотрудника- <span class='f-emph'> {-name-} </span> ?",
  3266: "Роль компании успешно изменена",
  3267: "Не удалось изменить роль компании, попробуйте позже",
  3268: "Добавить участника",
  3269: "",
  3270: "Добавить из внутренних участников",
  3271: "Удалить аккаунт",
  3272: "Удалить из отдела",
  3273: "Массовый импорт участников",
  3274: "Внимание!",
  3275: "Эта операция перенесёт файлы владельца в аккаунт другого пользователя и очистит личные файлы владельца в корпоративном аккаунте. Операция необратима; владельцем станет целевой пользователь.",
  3276: "Владелец",
  3277: "Категория файла",
  3278: "Размер файла",
  3279: "Нажмите, чтобы выбрать сотрудника",
  3280: "аккаунт",
  3281: "Добавить из списка внутренних участников",
  3282: "Информация о файле",
  3283: "Подтвердить удаление отдела",
  3284: "При удалении отдела файлы внутри также будут удалены",
  3285: "Отдел-Роль",
  3286: "Дата",
  3287: "Место сохранения",
  3288: "Другое местоположение",
  3289: "Выбрать папку",
  3290: "Скачать файл",
  3291: "Скрыть",
  3292: "Вы уверены, что отменяете скачивание файла {-name-}?",
  3293: "Отменить действие",
  3294: "Введите содержимое",
  3295: "Вы успешно создали комментарий",
  3296: "Не удалось создать комментарий, проверьте сеть или обновите страницу",
  3297: "Не удалось ответить на комментарий, проверьте сеть или обновите страницу",
  3298: "Не удалось получить список комментариев, проверьте сеть или обновите страницу",
  3299: "Не удалось получить файл, обновите страницу и попробуйте снова",
  3300: "Не удалось выбрать пространство, попробуйте позже",
  3301: "Не удалось выбрать пространство, смена возможна 1 раз в 24 часа, попробуйте позже",
  3302: "Сохранены файлы шаринга, от которых нельзя отказаться!",
  3303: "Отправка...",
  3304: "Для доступа по этой ссылке требуется пароль",
  3305: "Не удалось отменить пароль, попробуйте позже",
  3306: "Пароль успешно установлен",
  3307: "Не удалось установить пароль, попробуйте позже",
  3308: "Введите название тега",
  3309: "Тег с таким именем уже существует",
  3310: "Редактировать тег",
  3311: "Всего<strong>{-quoteNum-}</strong> файлов с этим тегом",
  3312: "Обновить только ссылки на файлы, созданные мной",
  3313: "Обновить ссылки на все файлы в компании, использующие этот тег",
  3314: "Ошибка загрузки файла",
  3315: "Открыть группу обсуждения",
  3316: "Сотрудники отдела",
  3317: "Добавить отдел",
  3318: "Пользователь {-name-} не зарегистрирован, подтвердить приглашение этого человека в шаринг?",
  3319: "Сравнить",
  3320: "Сравнить или объединить документы",
  3321: "Выберите файлы для сравнения или объединения",
  3322: "Оригинал",
  3323: "Выбрать документ",
  3324: "Выбрать другой файл",
  3325: "У этого файла пока нет других версий",
  3326: "Вы можете {-other-} для сравнения или объединения",
  3327: "Выбрать из других версий этого файла",
  3328: "Выполнить сравнение документов",
  3329: "Выполнить объединение документов",
  3330: "Выбрать локальный файл",
  3331: "Открыть",
  3332: "Отметить как непройденный",
  3333: "Вы уверены, что хотите установить статус «Не пройдено» для этой папки?",
  3334: "Секр",
  3335: "Огр",
  3336: "Внутр",
  3337: "Уровень секретности",
  3338: "Политика безопасности файлов компании",
  3339: "Узнать о политике безопасности",
  3340: "Наследовать политику родительского отдела",
  3341: "Название политики",
  3342: "Уровень по умолчанию для загружаемых файлов",
  3343: "Требуется ли согласование для всех шарингов",
  3344: "Согласующие шаринга",
  3345: "Политика по умолчанию?",
  3346: "Совершенно секретно",
  3347: "Первый уровень секретности",
  3348: "Второй уровень секретности",
  3349: "Обычный",
  3350: "Публичный",
  3351: "Конфиденциально",
  3352: "Ограничено",
  3353: "Внутренний",
  3354: "Публичный",
  3355: "Да",
  3356: "Нет",
  3357: "Сотрудник по безопасности",
  3358: "Руководитель",
  3359: "По умолчанию",
  3360: "Политика безопасности файлов отдела",
  3361: "Добавить сотрудника по безопасности",
  3362: "Управление сотрудниками по безопасности",
  3363: "Подтвердите удаление статуса сотрудника по безопасности у {-user-}",
  3364: "Аудитор безопасности",
  3365: "Добавить аудитора безопасности",
  3366: "Управление аудиторами безопасности",
  3367: "Подтвердите удаление статуса аудитора безопасности у {-user-}",
  3368: "Подсказка：",
  3369: "Вы уверены, что хотите удалить текущий пул адресов?",
  3370: "",
  3380: "Загрузить файлы сотрудников отдела",
  3381: "",
  3382: "Изображение водяного знака не поддерживает диагональную плитку",
  3383: "Английский",
  3384: "Только доступ через клиент",
  3385: "Пользователи, привязанные по MAC, могут использовать только клиент, не приложение и веб",
  3386: "Только консоль компании может создавать и управлять тегами",
  3387: "Сброс пароля",
  3388: "Сброс",
  3389: "Нажмите, чтобы отправить ссылку для сброса пароля на e-mail пользователя",
  3390: "Письмо со ссылкой для сброса пароля отправлено на e-mail пользователя",
  3391: "Пожалуйста, выберите файлы для просмотра или сравнения",
  3392: "Пользователь {-name-} не зарегистрирован, подтвердить отправку ссылки на шаринг?",
  3393: "Нет логов операций",
  3394: "Подсказка：пока никто не просматривал файл",
  3395: "Нет логов операций по условиям",
  3396: "Вы можете {-other-} для просмотра/сравнения",
  3397: "Скрыть логи доступа администратора",
  3398: "Если включено, в журналах доступа обычные пользователи не увидят записи администраторов",
  3399: "Статистика",
  3400: "Нажмите, чтобы показать файлы, загруженные этим пользователем в отделе",
  3401: "Нажмите, чтобы показать файлы, загруженные этим пользователем в команде",
  3402: "Журнал загрузок",
  3403: "Нажмите, чтобы показать файлы, загруженные этим пользователем в проекте",
  3404: "Число посещённых папок",
  3405: "Число посещённых файлов",
  3406: "Число людей, посетивших папки",
  3407: "Число людей, посетивших файлы",
  3408: "Объём личных файлов",
  3410: "Создать подразделение",
  3411: "Удалить подразделение",
  3412: "Изменить подразделение",
  3413: "Управление корзиной",
  3414: "Управление контролем доступа к файлам",
  3415: "Архивировать файл",
  3416: "Управление уровнем секретности файлов",
  3417: "Рассмотреть запросы на шаринг",
  3418: "Сменить ответственного за файл",
  3419: "Управление согласованиями",
  3420: "Загружать новые версии своих файлов",
  3421: "Переименовывать свои файлы",
  3422: "Загружать новые версии чужих файлов",
  3423: "Переименовывать чужие файлы",
  3424: "Управление участниками отдела",
  3425: "Режим ответственного за файл",
  3426: "Включите режим, чтобы ответственный за файл имел полную ответственность и права управления своим файлом независимо от роли в отделе. По умолчанию загрузивший в отдел становится ответственным за файл; если загрузить в чужую папку — не станет. Ответственный и менеджеры отдела могут менять ответственных. При отключении режима права ответственного равны обычному пользователю.",
  3427: "Список ролей отдела",
  // 3419: '',
  // 3419: '',
  // 3419: '',
  // 3419: '',
  3428: "Оператор",
  3429: "Вы уверены, что хотите закрыть шаринг для этих файлов?",
  3430: "Поле не может быть пустым",
  3431: "Процесс согласования отдела",
  3432: "Текущая стратегия процесса согласования",
  3433: "Редактировать",
  3434: "процесс одобрения",
  3435: "Настройте, как использовать процессы согласования при запуске сотрудниками отдела",
  3436: "Можно выбрать все предустановленные процессы",
  3437: "Ограничить использование определёнными процессами",
  3438: "Как и у родительского отдела",
  3439: "В этой группе должно быть по крайней мере",
  3440: "человек для утверждения, чтобы пройти этап",
  3441: "Нет альтернативных шаблонов процессов",
  3442: "Создать",
  3443: "Пуш в рабочую панель",
  3444: "Выберите участников из списка ниже",
  //----------	5.8*-------------
  3445: "Читальный зал",
  3446: "Создать читальный зал",
  3447: "Только файлы, помещённые в читальный зал, видны и доступны для выдачи",
  3448: "Уровень доступа",
  3449: "отдел",
  3450: "Введите название отдела",
  3451: "Редактировать читальный зал",
  3452: "Добавить связанные файлы",
  3453: "Список связанных файлов",
  3454: "Нет связанных файлов",
  3455: "Добавить из списка отделов компании",
  3456: "Нет участников",
  3457: "Нет",
  3458: "Читальный зал содержит дочерние файлы",
  3459: "Скачать утверждённый PDF",
  3460: "Скачать PDF с водяным знаком",
  3461: "Экспорт отчёта",
  3462: "По текущему фильтру количество логов >2000, экспортируется только первые 2000, продолжить?",
  3463: "Экспорт",
  3464: "{-somebody-} запросил(а) {-type-} архивный файл(папку) {-file-}, и добавил(а): {-comment-}",
  //-------------------5.9-------------

  3465: "Скачать отчёт по участникам",
  3466: "Соответствующая директория не найдена, открыть не удалось",
  3467: "Полнотекстовый поиск，нажмите Enter",
  3468: "Поиск по имени файла，нажмите Enter",
  3469: "Можно приглашать любых людей в папку проекта; создатель по умолчанию руководитель; после завершения этапа руководитель может передать проект следующему руководителю этапа, чтобы папка могла переходить между отделами",
  //---------------6.0------------------

  3470: "Пока нет замороженных аккаунтов",
  3471: "Требуется выдача",
  3472: "Доступен только внутри отдела",
  3473: "Открыт внутри отдела",
  3474: "Файлы в читальном зале видны всем; пользователи могут просматривать и скачивать без выдачи",
  3475: "Файлы в читальном зале видимы, но для просмотра/скачивания требуется выдача",
  3476: "Открыто только для указанных отделов; пользователи могут просматривать и скачивать без выдачи",
  3477: "Читальный зал виден только указанным отделам; для просмотра/скачивания требуется выдача",
  3478: "Руководитель проекта",
  3479: "Разрешить анонимную загрузку（онлайн-редактирование）",
  3480: "При разрешении анонимной загрузки ответственность за загруженные нарушающие правила материалы несёт инициатор шаринга",
  3481: "Требуется установить дату окончания",
  3482: "Перейти к настройке",
  3483: "Ваш аккаунт заблокирован системой; для восстановления свяжитесь с поддержкой, нажмите Подтвердить для выхода",
  //------------------6.1------------------

  3484: "Статистика загрузок компании",
  3485: "Нет пользователей по условиям",
  3486: "Статистика доступа к файлам",
  3487: "Пользователи",
  3488: "Объём",
  3489: "Чтение файлов",
  3490: "Комментарии и обсуждения",
  3491: "Запрос",
  3492: "Нет результатов по условиям",
  3493: "Прошло {-days-} дней",
  3494: "Осталось {-days-} дней",
  3495: "Истёк {-days-} дней назад",
  3496: "Затрачено {-days-} дней",
  3497: "Пожалуйста, выберите роль по умолчанию для выбранных участников",
  3498: "Все папки компании",
  3499: "Текущая дата",
  /***************** 错误提示 *********************/
  3500: "Не удалось добавить, попробуйте позже",
  3501: "Не удалось получить информацию об отделе",
  3502: "Лимит пространства отдела успешно изменён",
  3503: "Не удалось изменить лимит пространства отдела, попробуйте позже",
  3504: "Установленное значение равно уже использованному объёму — загрузить новые файлы не получится",
  3505: "Роль успешно изменена",
  3506: "Не удалось изменить роль, попробуйте позже",
  3507: "Успешно добавлено",
  3508: "Не удалось добавить участника, попробуйте позже",
  3509: "Участник удалён из отдела",
  3510: "Удаление не удалось, попробуйте позже",
  3511: "Подтвердить удаление аккаунта?",
  3512: "Аккаунт отключён",
  3513: "Не удалось отключить аккаунт",
  3514: "Аккаунт восстановлён",
  3515: "Не удалось восстановить аккаунт",
  3516: "Публикация успешно",
  3517: "Публикация не удалась, попробуйте снова",
  3518: "Автор удалён",
  3519: "Подтвердите удаление выбранного автора",
  3520: "Удаление не удалось, попробуйте снова",
  3521: "Не удалось получить историю объявлений",
  3522: "Удаление не удалось, ошибка сервера",
  3523: "Не удалось получить информацию о согласовании",
  3524: "Группа успешно добавлена",
  3525: "Не удалось получить информацию о группе",
  3526: "Ошибка сервера, не удалось получить администраторов",
  3527: "Подтвердите удаление-<strong>{-name-}</strong> статуса администратора",
  3528: "Лимит хранения успешно увеличен",
  3529: "Не удалось увеличить лимит хранения",
  3530: "Лимит хранения успешно изменён",
  3531: "Не удалось изменить лимит хранения",
  3532: "Не удалось получить информацию об онлайн внутренних участниках",
  3533: "Не удалось получить информацию об онлайн внешних участниках",
  3534: "Ссылка не найдена, вернуться в управление",
  3535: "Не удалось создать папку для сбора файлов！",
  3536: "Изменение не удалось или нет прав",
  3537: "Не удалось получить информацию о роли",
  3538: "Не удалось добавить роль, попробуйте позже",
  3539: "Не удалось изменить информацию о роли, попробуйте позже",
  3540: "Не удалось удалить роль, попробуйте позже",
  3541: "Имя роли не должно дублировать существующее",
  3542: "Не удалось получить настройки водяных знаков компании, попробуйте позже",
  3543: "Область воздействия водяного знака успешно установлена",
  3544: "Не удалось установить область водяного знака, попробуйте позже",
  3545: "Текстовый водяной знак успешно установлен",
  3546: "Не удалось установить текстовый водяной знак, попробуйте позже",
  3547: "Изображение водяного знака успешно установлено",
  3548: "Не удалось установить изображение водяного знака, попробуйте позже",
  3549: "Водяной знак успешно отключён",
  3550: "Не удалось отключить водяной знак, попробуйте позже",
  3551: "Выбрано",
  3552: "Загрузить изображение заново",
  3553: "Загрузить изображение",
  3554: "Не удалось получить информацию о компании, попробуйте позже",
  3555: "Не удалось получить информацию о корпоративных пользователях, попробуйте позже",
  3556: "Сохранено успешно",
  3557: "Неверный формат данных, попробуйте снова",
  3558: "Извините, у вас нет прав для выполнения этой операции",
  3559: "Не удалось сохранить, попробуйте позже",
  3560: "Не удалось загрузить логотип компании, попробуйте позже",
  3561: "Не удалось включить почтовые уведомления, попробуйте позже",
  3562: "Не удалось отключить почтовые уведомления, попробуйте позже",
  3563: "Не удалось получить информацию о внутренних участниках",
  3564: "Замена роли",
  3565: "Заменить у всех пользователей определённую роль на новую",
  3566: "Старая роль",
  3567: "",
  3568: "",
  3569: "Заменить на",
  3570: "Роль успешно заменена",
  3571: "Не удалось заменить роль, попробуйте позже",
  3572: "Пожалуйста, выберите",
  3573: "Создать новую роль",
  3574: "Скопировать из существующей роли",
  3575: "Журнал доступа",
  3576: "Ошибка скачивания",
  3577: "Просмотр файла",
  3578: "Прогресс скачивания",
  3579: "Выбрать изображение",
  3580: "Предпросмотр аватара",
  3581: "Размер файла превышает {-size-}MB, выберите другой",
  3582: "Неправильный тип файла",
  3583: "Изображение водяного знака поддерживает только PNG",
  3584: "Не расшарено",
  3585: "<span> {-folderCount-} папок</span><span class='mgl-10'> {-fileCount-} файлов</span>",
  3586: "Папка для сбора файлов создана успешно",
  3587: "Удаление тега...",
  3588: "Удаление не удалось, у вас нет прав",
  3589: "Удаление не удалось, неизвестная ошибка",
  3590: "Откат тега успешно",
  3591: "Откат тега не удался",
  3592: "Копирование файла",
  3593: "Копирование файла успешно",
  3594: "Не удалось скопировать файл, неизвестная ошибка",
  3595: "Не удалось скопировать файл, недостаточно места",
  3596: "Восстановление файла успешно",
  3597: "Восстановление файла не удалось",
  3598: "Папка успешно создана",
  3599: "Не удалось создать папку, попробуйте позже",
  3600: "Файл успешно удалён",
  3601: "Не удалось удалить файл",
  3602: "Удаление не удалось, обновите страницу и попробуйте снова！",
  3603: "Содержит общие файлы(папки)，сначала отключите шаринг！",
  3604: "Понял(а)",
  3605: "Восстановление файла прошло успешно",
  3606: "Не удалось восстановить файл",
  3607: "Код ошибки",
  3608: "Переименование успешно",
  3609: "Переименование не удалось, попробуйте позже",
  3610: "Имя успешно восстановлено",
  3611: "Не удалось восстановить файл",
  3612: "Переместить файл",
  3613: "Файл успешно перемещён",
  3614: "Содержит общие файлы",
  3615: "Файлы отдела нельзя перемещать в папки вне отдела",
  3616: "Файлы отдела нельзя переместить в личные папки",
  3617: "Перемещение не удалось",
  3618: "Файл восстановлен успешно",
  3619: "Ошибка восстановления файла",
  3620: "Личные файлы",
  3621: "Поиск по имени роли",
  3622: "Не удалось установить уровень секретности файла, попробуйте позже",
  3623: "Расположение водяного знака успешно установлено",
  3624: "Не удалось установить расположение водяного знака",
  3625: "Прозрачность водяного знака успешно установлена",
  3626: "Не удалось установить прозрачность водяного знака",
  3627: "Установка водяного знака с учётной записью успешно выполнена",
  3628: "Не удалось установить водяной знак учётной записи",
  3629: "Текущая политика компании успешно установлена",
  3630: "Текущая политика отдела успешно установлена",
  3631: "Не удалось получить информацию о пуле адресов, попробуйте позже",
  3632: "Не удалось получить информацию о привязке MAC-адресов, попробуйте позже",
  3633: "Команда достигла лимита по числу участников, присоединение не удалось",
  3634: "По умолчанию разрешено загружать личные файлы",
  3635: "Отключив опцию, загрузка личных файлов будет запрещена; уже загруженные личные файлы сохранятся. Администратор может индивидуально настроить исключения.",
  3636: "Корпоративно по умолчанию",
  3637: "Не разрешено",
  3638: "Разрешено",
  3639: "Внимание：ввод 0 означает отсутствие ограничения личного пространства",
  3640: 'Папка сбора файлов "{-name-}" принимает только файлы "{-str-}"',
  3641: "Вы уже участник команды",
  3700: "Список прав отдела",
  3701: "Список прав файлов",
  3702: "Права шаринга файлов",
  3703: "Запросить права “{-roleName-}” для файла {-file-}",
  3704: "И добавил(а): ",
  3705: "Запросить права на файл",
  3706: "Отправить сообщение",
  3707: "Пожалуйста, выберите файл",
  3708: "Выбрать из существующих файлов",
  3709: "Загрузить новый файл",
  3710: "Вложение",
  3711: "Загрузить вложение",
  3712: "Вам отправлено сообщение",
  3713: "Nсторию сообщений",
  3714: "Как вложение к сообщению",
  3715: "Отправитель",
  3716: "Переслать",
  3717: "У вас новое системное уведомление Бабель, нажмите для деталей",
  3718: "Отдел",
  3719: "Удалить эту компанию",
  3720: "Роспуск",
  3721: "Удаление компании удалит все файлы, участники станут личными пользователями, операция необратима, введите пароль администратора для продолжения",
  3722: "Удалить этот аккаунт",
  3723: "Удаление аккаунта приведёт к потере всех файлов; операция необратима, требуется пароль",
  3724: "После выполнения этой операции владельцем станет выбранный пользователь; текущий пользователь перестанет быть владельцем. Введите пароль текущего пользователя для продолжения",
  3725: "Вы также можете перетащить файлы сюда для загрузки",
  3726: "Настройки файла",
  3727: "Чёрный список расширений",
  3728: "Чёрный список — расширения, запрещённые для загрузки; введите расширения для блокировки",
  3729: "Введите расширение для чёрного списка, например jpg",
  3730: "Список чёрных расширений",
  3731: "Поиск расширения",
  3732: "Это расширение уже в чёрном списке",
  3733: "Пока нет часто используемых тегов",
  3734: "Количество запрашиваемых файлов не должно превышать 10",
  3735: "После окончания проекта доступ и управление доступны только администратору проекта, если не требуется крайний срок — оставьте поле пустым",
  3736: "Это расширение уже в белом списке",
  ///////////////////////////首页

  4000: "Функции",
  4001: "Цены",
  4002: "Решения",
  4003: "Корпоративное публичное облако",
  4004: "блог",
  4005: "Инновационная платформа управления документами — совместная работа эффективнее",
  4006: "Больше эффективности, более тонкое управление",
  4007: "Бесплатный пробный период",
  4008: "Корпоративное облачное хранилище Бабель, клиент доступен",
  4009: "Доступно для Windows и Mac",
  4010: "Синхронизация любых файлов — легко настроить",
  4011: "Корпоративное облачное хранилище Бабель",
  4012: "Скачать бесплатно",
  4013: "Облачное хранилище для совместной работы с документами",
  4014: "Бесплатная регистрация",
  4015: "или Войти",
  4016: "Профессиональная версия корпоративного облака Бабель доступна",
  4017: 'Более мощная, чем "Персональная версия": больше места и возможностей',
  4018: "Используйте документы в любое время и в любом месте — сотрудничество без преград",
  4019: "Теперь вы можете не только в вебе, но и на смартфоне использовать Бабель",
  4020: "Также вы можете редактировать Office-документы онлайн без установки Office",
  4021: "Скачать клиент Бабель",
  4022: 'Обсуждайте содержимое файла напрямую，<br class="hidden-xs">совместная работа и редактирование',
  4023: "Кликните в месте документа, где хотите обсудить; используйте голос или рукописные пометки, участники видят ответы в реальном времени; мобильная коммуникация удобна, а при редактировании Office-документов онлайн автоматически создаётся новая версия.",
  4024: "Не нужно покупать дополнительные программы，<br>чтобы просматривать большинство файлов",
  4025: "Поддерживается около 200 форматов без установки приложений — от Office и iWork до PSD, AI, DWG, AutoCAD и 3D-форматов; при установке клиента можно редактировать локально и синхронизировать изменения.",
  4026: "Укажите любую папку для автоматической синхронизации<br>и всегда имейте актуальные данные",
  4027: "После настройки синхронизируемой папки все обновления синхронизируются на всех платформах через клиент; нет необходимости скачивать/загружать вручную.<br>Синхронизированные общие папки обеспечивают актуальность документов команды.",
  4028: "Узнать больше",
  4029: "Получено признание безопасности A от QUALYS",
  4030: "",
  4031: "Бабель контролирует доступ к каждому файлу и каждому пользователю, ведёт подробные журналы доступа. Используется EV SSL и банковское шифрование, многосерверное резервирование — всё для безопасности.",
  4032: "Индивидуальные решения для компаний<br>для всех задач с документами",
  4033: "Мы предлагаем корпоративные функции: совместный просмотр экрана, управление версиями, согласования, управление участниками и правами, передача больших файлов и расширяемое хранилище. Поддерживаются публичные и частные облака.",
  4034: "Узнать о корпоративных услугах Бабель",
  4035: "Продукт",
  4036: "Команда",
  4037: "Поддержка",
  4038: "Функции",
  4039: "Цены",
  4040: "Попробовать корпоративную версию",
  4041: "Условия обслуживания",
  4042: "Политика конфиденциальности",
  4043: "О компании",
  4044: "Контакты",
  4045: "Присоединяйтесь к нам",
  4046: "Скачать Бабель iOS",
  4047: "Скачать Бабель Android",
  4048: "Инструкция по продукту Бабель",
  4049: "Отзывы и предложения",
  4050: "Эффективная совместная работа, начиная с документа",
  4051: "Документ — базовая единица в Бабель; перетащите файлы и пригласите команду — обсуждайте прямо в содержимом. Веб, iOS, Android — совместная работа в реальном времени.",
  4052: "Скачать инструкцию по продукту Бабель",
  4053: "Документы",
  4054: "Наши планы и результаты",
  4055: "Документ — основа командной работы; Бабель помогает найти и распределить документы, просмотреть спецформаты и обсуждать.",
  4056: "Общее пространство",
  4057: "Удобно, как обычный облак, но удобнее для команды: создавайте папки и делитесь",
  4058: "Обсуждайте прямо в содержимом файла",
  4059: "Комментируйте прямо в документе, централизованно управляйте обсуждениями и быстро навигируйте к обсуждаемым фрагментам",
  4060: "Обсуждение",
  4061: "Организованность повышает эффективность",
  4062: "Создавайте и управляйте командами, делитесь файлами. Командная папка автоматически доступна всем участникам.",
  4063: "Форматы",
  4064: "Отсутствие ограничений формата — для свободы мышления",
  4065: "Бабель поддерживает большое число форматов — от Office до PSD и CAD — без дополнительного ПО",
  4066: "Права",
  4067: "Гарантия безопасности",
  4068: "Бабель позволяет тонко настроить права, при просмотре через H5 исходный файл не передаётся, все действия отслеживаются",
  4069: "Клиент",
  4070: "Удвойте эффективность совместной работы",
  4071: "Клиент — рабочая точка входа; он позволяет открывать локальные приложения для редактирования файлов в облаке с автоматической блокировкой и созданием версий",
  4072: "В любое время и в любом месте",
  4073: "Веб, мобильные приложения и клиенты позволяют редактировать Office-документы онлайн и синхронизироваться, повышая эффективность до 300%",
  4074: "Мы взаимосвязаны",
  4075: "Интеграция с OA, ERP и другими системами через API позволяет использовать Бабель в любых местах с документами",
  4076: "Бабель — эффективная система совместной работы с документами",
  4077: "Попробовать сейчас",
  4078: "Меньше встреч",
  4079: "С Бабель обсуждайте в документе, создавайте задачи и отслеживайте выполнение — меньше бессмысленных совещаний",
  4080: "Управление версиями",
  4081: "Управляйте версиями файлов, переключайтесь и сравнивайте",
  4082: "Контролируемая безопасность",
  4083: "EV SSL, банковское шифрование и разделение превью/исходника — максимум защиты",
  4084: "Мониторинг и аналитика",
  4085: "Веб-распространение и обсуждение позволяют видеть, кто, когда и сколько просмотрел",
  4086: "Персонализация",
  4087: "Кастомизация логотипа и интерфейса",
  4088: "Настраиваемое хранилище",
  4089: "От начальных 500GB до неограниченного пространства",
  4090: "Частное развёртывание",
  4091: "Все данные хранятся на частных серверах во внутренней сети; внешние лица не имеют доступа; внутренняя сеть даёт высокую скорость",
  4092: "Мобильный бизнес",
  4093: "Мобильные приложения дают тот же UI и функционал на телефоне и iPad",
  4094: "Онлайн-редактирование",
  4095: "Мобильное приложение и веб-версия поддерживают онлайн-редактирование Office с автоматической блокировкой и созданием новых версий; клиент позволяет открывать локальные приложения",
  4096: "Повышение эффективности",
  4097: "Бабель позволяет экономить на хранении и сокращать переписку по e-mail; по тестам эффективность может возрасти до 300%",
  4098: "Открытый API",
  4099: "API для хранения, анализа и обсуждений; интеграция и единая аутентификация",
  4100: "Надёжная поддержка",
  4101: "Babel care: поддержка, обучение, 24/7, настройка и доработка",
  4102: "Бабель повышает эффективность командной работы",
  4103: "Персональная версия",
  4104: "Хранение личных документов, быстрая совместная работа",
  4105: "Бесплатно",
  4106: "Подходит для базовых задач. Просто, удобно, безопасно.",
  4107: "Начать сейчас",
  4108: "2G пространства",
  4109: "Поддержка до 2 команд",
  4110: "Защита HTTPS",
  4111: "До 10 версий файла",
  4112: "Макс. размер загрузки 5G",
  4113: "Поддержка комментирования",
  4114: "Приватные комментарии",
  4115: "Массовая загрузка файлов",
  4116: "Управление правами",
  4117: "Предпросмотр CAD",
  4118: "Предпросмотр 3D",
  4119: "1:1 просмотр больших изображений",
  4120: "Онлайн-видео",
  4121: "Настраиваемые форматы предпросмотра",
  4122: "Общие теги",
  4123: "Управление тегами",
  4124: "Статистика чтения",
  4125: "Совместная работа и согласования",
  4126: "Оргструктура компании",
  4127: "Мощные инструменты админа",
  4128: "Тонкая настройка прав",
  4129: "Настройка логотипа и названия",
  4130: "Индивидуальный UI",
  4131: "Уникальный домен входа",
  4132: "Независимая система пользователей",
  4133: "Частное развёртывание",
  4134: "Поддержка синхронизирующего клиента",
  4135: "Поддержка мобильных приложений",
  4136: "Персональный менеджер",
  4137: "Совместная работа малых команд",
  4138: '<span class="rmb">￥</span>2,000<span class="yearly"> / год</span>',
  4139: "Включает функции персональной версии, больше пространства и возможностей",
  4140: "Купить сейчас",
  4141: "1Т пространства",
  4142: "Неограниченное число команд",
  4143: "Неограниченное число версий",
  4144: "Неограниченный предпросмотр CAD",
  4145: "Неограниченный предпросмотр 3D",
  4146: "Корпоративное публичное облако",
  4147: "Неограниченное число пользователей, подходит для малого и среднего бизнеса",
  4148: "Большой объём хранилища, мощная админпанель, индивидуальный домен",
  4149: "Запросить пробную версию",
  4150: "2T хранилища (гибкое расширение)",
  4151: "Неограниченные отделы",
  4152: "Банковское шифрование",
  4153: "Индивидуальный вход",
  4154: "Аккаунт может входить в корпоративную и персональную версии одновременно",
  4155: "Корпоративное частное облако",
  4156: "Индивидуальная настройка, высокий уровень безопасности — выбор крупного бизнеса и госструктур",
  4157: "индивидуальный",
  4158: "Включает все функции публичного корпоративного облака и даёт частное развёртывание",
  4159: "Неограниченное хранилище по запросу",
  4160: "Выбор способа шифрования",
  4161: "Они используют Бабель",
  4162: "Выберите корпоративную версию, разработанную для бизнеса",
  4163: "Более профессионально, эффективнее и безопаснее",
  4164: "Отраслевые решения",
  4165: "Каждая отрасль имеет свои требования. Бабель предлагает отраслевые решения, упрощающие работу",
  4166: "Инжиниринг и производство",
  4167: "Поддержка чертежей и профессиональных форматов",
  4168: "Наука и образование",
  4169: "Управление учебными материалами и защитами",
  4170: "Издательство",
  4171: "Тройная проверка, управление рукописями",
  4172: "Реклама и дизайн",
  4173: "Управление макетами, поддержка PSD/AI, обсуждение прямо на макете",
  4174: "Интернет-компании",
  4175: "От требований до готовых дизайнов и базы знаний маркетинга",
  4176: "Многонациональные компании",
  4177: "Шаринг, удалённые встречи, оптимизация международных сетей",
  4178: "Другие отрасли",
  4179: "Если у вашей отрасли есть особые требования, свяжитесь с нами. Мы изучим ваши процессы и предложим решение。<br><strong>* Первому клиенту в отрасли — год бесплатного обслуживания.</strong>",
  4180: "Эффективная система совместной работы с документами",
  4181: "Создан для компаний",
  4182: "Жизненный цикл документа",
  4183: "Безопасность",
  4184: "Персональная поддержка",
  4185: "2TB базового пространства для хранения",
  4186: "Предоставляет 2TB базового хранилища, более 100000 файлов при расчёте 10MB/файл",
  4187: "※ (1ТБ = 1048576М, по оценкам 10М для каждого файла)",
  4188: "Бесплатный предпросмотр профессиональных форматов и приватные комментарии",
  4189: "Корпоративная публичная версия допускает бесплатный предпросмотр и приватные комментарии без ограничений",
  4190: "Продвинутая оргструктура — проще управлять",
  4191: "Структура идеально совпадает с офлайн процессами",
  4192: "Сотрудники легче взаимодействуют онлайн",
  4193: "Мощные функции админа: массовые приглашения, настройки ролей",
  4194: "Подробные журналы операций",
  4195: "Передача файлов при уходе или смене роли одним кликом",
  4196: "Индивидуальный домен для входа",
  4197: "Клиент как точка входа для сотрудников",
  4198: "Использование клиента",
  4199: "Используя клиент Бабель, каждый сотрудник получает единый рабочий вход и, в зависимости от прав, видит\
                        <br>разные файлы, задачи и активность отдела. Самое приятное — клиент позволяет\
                        <br>вызвать локальные приложения для прямого редактирования файлов в Бабель; при редактировании файл автоматически блокируется,\
                        <br>а после завершения создаётся новая версия. Это означает, что вы и коллеги можете редактировать\
                        <br>один и тот же Office-документ, 3D-модель или CAD-чертёж без загрузки — вся работа\
                        <br>в облаке。",
  4200: "Настраиваемый водяной знак — защита от несанкционированного распространения",
  4201: "Пользователи корпоративной версии могут использовать настраиваемые водяные знаки，\
                      <br>логотип, изображение или идентификатор сотрудника в качестве водяного знака, а также задать область применения；\
                      <br>водяной знак можно встраивать в скачиваемые PDF, максимально защищая\
                      <br>интеллектуальную собственность компании",
  4202: "Дополнительные корпоративные функции для повышения эффективности",
  4203: "Согласования, совместный показ, папки сбора, разграничение прав по отделам, поддержка очень больших изображений\
                        <br>и другие функции корпоративной версии решают большинство задач при управлении документами。",
  4204: "Почему Бабель заслуживает доверия корпоративных пользователей？",
  4205: "Защита файлов в трёх направлениях\
         <br>Защита от утечек, удаления и скачивания",
  4206: "Защита корпоративных файлов — наш приоритет。\
                        <br>Мы реализовали строгие механизмы безопасности, шифрование при шаринге,\
                        <br>резервное копирование и журналы операций, чтобы предотвратить удаление и отслеживать действия，\
                        <br>а гибкие настройки прав контролируют операции и скачивание。",
  4207: "Множество форматов предпросмотра\
                        <br>Документы, аудио/видео, 2D и 3D",
  4208: "Предпросмотр и аннотации — наши сильные стороны; мы поддерживаем Office, iWork, PSD, DWG, AI, INDD и 3D форматы (.dae, .obj) для удобного просмотра и обсуждения。",
  4209: "Эффективность коммуникации.\
                        <br> Комментарии, обсуждения и синхронизация",
  4210: "Мы не только хранение и шаринг —\
                            <br> но и коммуникация для внутренних и внешних сценариев.",
  4211: "Пользователи с помощью аннотаций, командных обсуждений, синхронизации и кроссплатформенности\
                        <br> могут повысить эффективность и качество работы。",
  4212: "Быстрая служба поддержки\
                        <br> 24/7",
  4213: "Персональный консультант и поддержка 7 дней в неделю，\
                        <br>решение любых вопросов по продукту и сервису",
  4214: "Новые функции скоро",
  4215: "Фильтрация активности",
  4216: "Фильтр активности позволяет показывать только релевантные пользователю файлы и обсуждения。",
  4218: "С клиентом и системой Бабель компании могут шифровать файлы; без авторизации файл открыть нельзя，\
                <br>даже при получении исходного файла. Это делает распространение файлов контролируемым，\
                <br>минимизируя риски утечек。",
  4219: "Глобальное шифрование",
  4220: "Архивирование",
  4221: "Архив позволяет надёжно хранить важные файлы и обеспечивает их неизменяемость，\
                <br>упрощая поиск и управление。",
  4222: "С корпоративным публичным облаком — выше эффективность и тоньше управление",
  4223: "Доступ в любое время",
  4224: "Вы можете использовать Бабель не только в офисе;<br class='hidden-xs'>есть мобильные приложения для смартфонов и iPad;<br class='hidden-xs'>функционал зачастую даже шире веб-версии",
  4225: "iOS универсальная версия",
  4226: "App Store скачать",
  4227: "Android версия",
  4228: "Скачать",
  4229: "Клиент Windows",
  4230: "Win10 и выше",
  4231: "Новый клиент Mac X64",
  4232: "Поддерживает macOS 10.8 и выше",
  4233: "Сканируйте QR<br>и подпишитесь на официальный WeChat",
  4234: "Сканируйте QR<br>и подпишитесь на официальный Weibo",
  4235: "Руководство_Babel.pdf",
  4236: "Введение_Babel.pdf",
  4237: "Руководство_по_установке_Babel.pdf",
  4238: "Скоро будет доступно，следите за обновлениями",
  4239: "Невозможно удалить, в отделе есть подотделы",
  4240: "Copyright © 2013-2019 上海画擎信息科技有限公司",
  4241: "沪公安网备31010102003859  沪ICP备14029220号-3    本站关键词: <strong>корпоративное облачное хранилище</strong>",
  4242: "Создано для офиса, упрощает работу",
  4243: "Просмотреть подробный список функций Бабель",
  4244: "Дневной лимит трафика владельца шаринга превышен，скачивание не удалось！",
  4245: "Вы не можете удалять чужие теги",
  4246: "Продукт",
  4247: "Корпоративное облако — персональная версия",
  4248: "Для частных пользователей",
  4249: "Корпоративное облако — профессиональная версия",
  4250: "Для малых команд, число участников не ограничено",
  4251: "Корпоративный публичный облак",
  4252: "Управление правами для малого и среднего бизнеса",
  4253: "Корпоративный частный облак",
  4254: "Выбор крупных компаний, госструктур и учебных заведений",
  4255: "IT и управление документами",
  4256: "Управление использованием компании",
  4257: "Безопасность и соответствие",
  4258: "Всесторонняя защита ваших цифровых активов",
  4259: "Клиент Бабель",
  4260: "Редактирование онлайн, синхронизация и виртуальный диск",
  4261: "Поддержка рабочих процессов",
  4262: "Обсуждение и согласование, упрощение процессов",
  4263: "Настройка под заказ",
  4264: "Сделайте свой собственный Бабель",
  4265: "API и интеграция приложений",
  4266: "Интеграция с другими приложениями даёт неограниченные возможности",
  4267: "Безопасная совместная работа на любых устройствах",
  4268: "Это так удобно!",
  4269: "Единое управление файлами компании",
  4270: "Совместная работа",
  4271: "Защита данных",
  4272: "Начать",
  4273: "Функция управления ресурсами для дизайнеров — водопадный просмотр",
  4274: "PSD、AI、DWG — легко",
  4275: "Интеграция с проводником",
  4276: "Новая интеграция (облачный мост)",
  4277: "Доступ к файлам облака как к локальному диску с учётом прав",
  4278: "Скачать последний клиент",
  4279: "Что Бабель делает для вашей компании",
  4280: "Централизованное управление документами",
  4281: "Управление по структуре и правам, быстрый полнотекстовый поиск",
  4282: "Реальная синхронизация и резервирование",
  4283: "Файлы синхронизированы на всех устройствах, совместная работа",
  4284: "Комментирование и обсуждение",
  4285: "Предпросмотр большинства форматов и обсуждение прямо в документе",
  4286: "Онлайн-редактирование",
  4287: "Бабель позволяет редактировать онлайн — от Office до CAD",
  4288: "Тонкая настройка прав",
  4289: "Роли, действия, отделы и файлы — всё настраивается; можно делить по отделам",
  4290: "Настраиваемые процессы согласования",
  4291: "Поддерживает все виды согласований, экспорт отчётов, рукописные подписи",
  4292: "Управление архивами знаний",
  4293: "Встроенные модули управления знаниями и архивом",
  4294: "Без изменений привычек",
  4295: "Интеграция с проводником Windows — прямой доступ",
  4296: "Узнать больше о возможностях Бабель",
  4297: "Откройте новую форму работы",
  4298: "Создано для компаний",
  4299: "Жизненный цикл документов",
  4300: "Безопасность",
  4301: "Персонализированная поддержка",
  4302: "С Бабель ваши файлы безопасно хранятся в облаке, участники могут доступаться, редактировать, делиться и комментировать. Корпоративный уровень безопасности помогает выполнять задачи более эффективно, переходя к облачному офису.",
  4303: "Эффективность коммуникации и согласованность знаний определяют конкурентоспособность компании",
  4304: "---- Казуо Инамори",
  4305: "Обсуждение-редактирование-ревью-совместная работа-управление-архивирование",
  4306: "От коммуникаций по черновикам до создания, редактирования и командной работы, до рецензий, утверждений и архива — Бабель управляет всеми этапами жизненного цикла документа.",
  4307: "Безопасность — ключ к бизнесу! Бабель учитывает безопасность в дизайне, архитектуре и управлении серверами, включает EV SSL, банковское шифрование и распределённое резервирование, обеспечивая A+ сертификацию QUALYS",
  4308: "*Бабель использует дата-центры Alibaba Cloud, обеспечивая 99.9% доступности",
  4309: "От обсуждений до архива — Бабель покрывает весь цикл документов",
  4310: "Бабель — это сервис для предприятий с персональной поддержкой: настройка, обучение, интеграция и кастомизация.",
  4311: "Не меняйте привычки, быстро начать",
  4312: "Прямые аннотации и обсуждения",
  4313: "Синхронизация и облачный мост",
  4314: "Открытие большинства файлов без установки",
  4315: "Кроссплатформенность",
  4316: "Нажмите в нужном месте файла, создайте аннотацию и обсуждайте; поддерживаются голос и рукописные пометки; ответы в реальном времени, поддержка @ и вложений.",
  4317: "Клиент позволяет работать без изменений привычек: синхронизация локально, автоматическая блокировка при редактировании, облачный мост дает доступ как к удалённому диску.",
  4318: "Не требуется скачивать: предпросмотр 200+ форматов прямо в Бабель; при клиенте можно вызвать локальные приложения для редактирования и синхронизации.",
  4319: "Просмотр своих и командных файлов в любое время, совместное обсуждение и редактирование",
  4320: "В вебе, мобильном приложении и десктоп-клиенте; онлайн-редактирование Office без установки",
  4321: "Пользователи частного облака получают тот же кроссплатформенный функционал",
  4322: "Создан для командной работы",
  4323: "Отделы и проекты",
  4324: "Мощное управление согласованиями",
  4325: "Тонкая настройка прав",
  4326: "Реальная совместная работа",
  4327: "Мощная админпанель поддерживает организацию, импорт структуры и интеграцию с AD; разделение управления по отделам.",
  4328: "Более продвинутая система согласований: админы могут предустанавливать процессы, настраивать веса рецензентов, приглашать внешних участников.",
  4329: "Права файлов, пользователей, отделов, ролей и шарингов — множество настроек для любой задачи.",
  4330: "Помимо шаринга и процессов, Бабель предоставляет рабочую панель, отделные обсуждения, динамику, комментарии, аннотации, совместное редактирование и многое другое.",
  4331: "Корпоративное облако — мощно и профессионально",
  4332: "Отраслевые решения",
  4333: "Кастомизация рабочего процесса",
  4334: "Частные развёртывания",
  4335: "Открытый API",
  4336: "От Dicom в медицине до CAD и 3D в инженерии — Бабель предлагает отраслевые решения и кастомную разработку.",
  4337: "Команда Babel care работает с вами над специфическими требованиями, настраивая рабочие процессы и интеграции.",
  4338: "Мы предлагаем гибкие частные развёртывания: от одиночного сервера до кластера, суперсистем или Docker-развёртываний.",
  4339: "Платформа Бабель открыта для кастомной разработки и интеграции через API, включая расширенные возможности для приватных развёртываний.",
  4340: "Создайте своё облако с Бабель",
  4341: "Коммерческая лицензия Бабель",
  4342: "Хотите больше сервисов для клиентов? Используйте бизнес-лицензирование Бабель для создания ваших решений на базе платформы.",
  4343: "«Бабель — продукт с тонкой настройкой прав и соответствующий нашим требованиям безопасности. Мощный функционал и профессиональное обслуживание произвели впечатление.»",
  4344: "-- Цянь Сюэсень Лаборатория, Директор Гао",
  4345: "«Бабель настроил систему рецензирования чертежей и управления архивом согласно нашим процессам и существенно ускорил цифровизацию.»",
  4346: "-- Changcheng Huaguan, Менеджер ИТ, Яо Чжицян",
  4347: "«Мы искали год: кастомные API приватной версии Бабель решили наши задачи. Жаль, что не раньше.»",
  4348: "---- Zhichun Tech, IT-менеджер Чжуан Цзя",
  4349: "Они тоже используют Бабель",
  4350: "Узнать о корпоративных услугах Бабель",
  4351: "Сервисы",
  4352: "Ключевые функции",
  4353: "ИТ и управление",
  4354: "Скачать клиент Бабель",
  4355: "Инструкция по продукту Бабель",
  4356: "Полезные ссылки:",
  4357: "Тонкое управление участниками, от 10 человек",
  4358: "Большое хранилище, мощная админпанель и права; собственный домен",
  4359: "5GB в сутки скоростного скачивания",
  4360: "10GB в сутки скоростного скачивания",
  4361: "Каждый новый участник +10GB суточного трафика",
  4362: "Без лимита трафика",
  4363: "Самое экономичное корпоративное решение",
  4364: "Купить профессиональную версию Бабель",
  4365: "Быстрое и недорогое развёртывание корпоративного облака",
  4366: "Профессиональная версия: один аккаунт — неограниченные команды, совместное пространство до 1TB, управление доступом, без лимита версий.",
  4367: "Добавляйте и управляйте участниками команды",
  4368: "Профессиональная версия позволяет создавать неограниченные команды и добавлять участников; участник с бесплатной персональной регистрацией может присоединиться к профессиональной команде.",
  4369: "Неограниченное хранение версий",
  4370: "Профессиональная версия не ограничивает число версий; дельта-загрузка экономит место; можно откатиться к любому историческому состоянию.",
  4371: "Поддержка 3D и CAD предпросмотра",
  4372: "Профессиональная версия поддерживает 3D и CAD (.dwg) предпросмотр и аннотации в 3D пространстве.",
  4373: "Комментарии, динамика, групповой чат — всё включено",
  4374: "Все корпоративные функции, включая обсуждения и аннотации, доступны в профессиональной версии",
  4375: "Синхронизация и виртуальный диск",
  4376: "Профессиональная версия поддерживает все функции клиента, включая синхронизацию, совместное редактирование и Mapping Drive (Cloud Bridge).",
  4377: "Водопадный просмотр",
  4378: "В профессиональной версии доступны плиточные/водопадные превью для изображений",
  4379: "Кроссплатформенность",
  4380: "Профессиональная версия поддерживает почти все устройства: Windows, Mac, мобильные клиенты и интерфейс для iPad.",
  4381: "Начните использовать профессиональную версию сейчас",
  4382: "Купить профессиональную версию Бабель",
  4383: "Корпоративное частное облако Бабель",
  4384: "Экономьте и реализуйте идеи",
  4385: "Настраивается под нужды компании",
  4386: "Свяжитесь с нами",
  4387: "Система выдержала нагрузку сотен тысяч публичных пользователей",
  4388: "Публичное облако Бабель обслуживает сотни тысяч пользователей непрерывно; опыт публичного облака делает частное облако стабильным и надёжным.",
  4389: "Частное облако первым поддержало онлайн-Office",
  4390: "Откройте эпоху совместного редактирования",
  4391: "Многопользовательское редактирование в реальном времени",
  4392: "Совместимость с различными Office-форматами",
  4393: "Комментарии в реальном времени",
  4394: "Гибкие варианты развёртывания",
  4395: "Больше настроек, чем в публичном облаке",
  4396: "Поддерживаем любое развёртывание: от одиночного сервера до кластера, Docker, гибридных сценариев; оптимизируем под ваш железо.",
  4397: "Babel care — профессиональная команда поддержки",
  4398: "Кастомная разработка и отраслевые решения",
  4399: "Мы предоставляем API и поддержку для интеграции и кастомизации, помогая вам создать систему, подходящую под ваш бизнес.",
  4400: "Открытый API для расширенных возможностей",
  4401: "Частные развёртывания позволяют расширить API и интеграции сверх публичного облака; можно построить собственное решение поверх Бабель.",
  4402: "«Мы потратили год, искали систему; кастомный API приватной версии Бабель решил наши задачи. Жаль, что не встретились раньше»",
  4403: "-- Менеджер Сюй, Shenzhen Maoding Tech",
  4404: "Свяжитесь с нами",
  4405: "Узнать больше? Позвоните 4009204020, обсудите с менеджером по продажам",
  4406: "Или свяжитесь по 13564686107 с менеджером продукта",
  4407: "Пользователи частного облака получают онлайн-Office раньше публичного: Word, Excel, PPT поддерживаются онлайн и в реальном времени; (функция доступна только в приватном облаке)",
  4408: "Полный контроль над вашей компанией",
  4409: "Мощная админпанель и поддержка обеспечивают бесперебойную работу",
  4410: "Попробовать сейчас",
  4411: "Свяжитесь с нами",
  4412: "Поддержка развития бизнеса и IT-реализаций",
  4413: "Мы понимаем нагрузку на IT и предоставляем инструменты и поддержку, включая обучение и внедрение.",
  4414: "Мощная админпанель для IT",
  4415: "Управляйте пользователями, файлами, отделами, проектами и шарингом в одном месте.",
  4416: "Удобное управление пользователями",
  4417: "Управляйте сотрудниками, подрядчиками и стажёрами, легко настраивайте права и делегирование при увольнениях.",
  4418: "Управляйте правами через роли",
  4419: "Роли упрощают массовое назначение прав; один пользователь может иметь разные роли в разных отделах.",
  4420: "Контролируйте содержимое",
  4421: "От настроек согласований до водяных знаков и журналов доступа; поддерживаем привязку MAC-адресов.",
  4422: "Многоуровневое управление компанией",
  4423: "Поддержка нескольких уровней администраторов и независимого управления отделами.",
  4424: "Журналы и аналитика",
  4425: "Файловые журналы, статистика и экспорт отчётов делают управление эффективным.",
  4426: "Интеграция с вашими системами",
  4427: "API и SDK позволяют интегрировать Бабель в существующие системы и расширять возможности.",
  4428: "Начните уже сегодня и оцените преимущества Бабель",
  4429: "Всесторонняя защита ваших цифровых активов",
  4430: "Скачать политику безопасности Бабель",
  4431: "Безопасность в основе архитектуры",
  4432: "Безопасность — ключ к бизнесу; в дизайне и управлении серверами мы ориентированы на безопасность.",
  4433: "Тонкий контроль прав",
  4434: "Защита от внутреннего разглашения: права по файлам, пользователям и отделам.",
  4435: "Настраиваемые политики безопасности",
  4436: "Сотрудник по безопасности может устанавливать политики и контролировать секьюрность по отделам.",
  4437: "Банковское шифрование",
  4438: "EV SSL и HTTPS, AES CTR 256 для потокового шифрования — файлы в хранилище зашифрованы.",
  4439: "Фрагментированное хранение",
  4440: "Файлы разбиваются на фрагменты и хранятся на разных серверах; даже при взломе нельзя восстановить файл целиком.",
  4441: "Соответствие стандартам",
  4442: "Прошли проверки авторитетными организациями и получили A+ сертификацию QUALYS",
  4443: "Совместно с поставщиками безопасности расширяем сервисы",
  4444: "Интеграция с антивирусом, DLP и корпоративными фаерволами",
  4445: "Они тоже заботятся о безопасности",
  4446: "Начните сейчас — оцените возможности",
  4447: "Скачать политику безопасности",
  4448: "Новый клиент Бабель",
  4449: "Ещё мощнее, ещё удобнее",
  4450: "Делает корпоративное облако непревзойденным",
  4451: "Клиент содержит 3 модуля: менеджер файлов, синхронизатор и виртуальный диск (Cloud Bridge). Клиент поддерживает автоматическую загрузку версий, дельта-загрузку, автоматическую блокировку, привязку MAC и быстрый шаринг из контекстного меню.",
  4452: "Синхронизация для всех устройств",
  4453: "Синхронизация между рабочими компьютерами, домашними ПК и мобильными — предотвращение конфликтов версий.",
  4454: "Неисчерпаемое пространство",
  4455: "Cloud Bridge монтируется как диск в проводнике и не занимает локальное пространство; доступ к объёмам больше локального диска.",
  4456: "Бесшовное создание и редактирование",
  4457: "Сохраняйте прямо в Бабель; при редактировании файл блокируется; Android поддерживает вызов сторонних приложений для редактирования.",
  4458: "Доступность на определённых устройствах",
  4459: "Можно ограничить доступ только клиентом или мобильными устройствами; в сочетании с привязкой MAC увеличивает безопасность.",
  4460: "Инкрементная загрузка",
  4461: "Дельта-загрузка отправляет только изменения, экономя время и место; 500MB PSD после правки может отправлять только 5MB.",
  4462: "Кроссплатформенно",
  4463: "Поддержка почти всех устройств: Windows, Mac, iOS, Android, iPad и др.",
  4464: "Клиент многократно обновлялся по пожеланиям клиентов",
  4465: "Благодаря рекомендациям клиентов клиент стал мощнее и удобнее.",
  4466: "Скачать клиент Бабель",
  4467: "Автоматизация работы",
  4468: "Упрощайте процессы",
  4469: "Попробовать",
  4470: "Свяжитесь с нами",
  4471: "Управление жизненным циклом документов",
  4472: "Бабель управляет созданием, редактированием, совместной работой, согласованиями, распределением, архивированием и уничтожением файлов; процессы можно настраивать.",
  4473: "Предустановленные процессы согласования",
  4474: "Админ может создать набор шаблонов согласования, отделы выбирают по необходимости",
  4475: "Мощное согласование",
  4476: "Поддержка параллельных, последовательных, групповых, взвешенных, в копии, кросс-отдел и т.д.; аннотации прямо в документе для повышения эффективности.",
  4477: "Быстрый сбор файлов",
  4478: "Папка сбора позволяет собирать материалы анонимно, с дедлайнами, статистикой и управлением отправителями — удобно для преподавателей, тендеров и госорганов.",
  4479: "Управление задачами",
  4480: "Всё управление процессами, результатами и архивами в одном месте; уведомления и динамика собирают всё релевантное для быстрого доступа.",
  4481: "Напоминания и отслеживание",
  4482: "Назначайте задачи, напоминания и подписывайте людей на файлы/папки.",
  4483: "Управление проектами",
  4484: "Создавайте проекты, назначайте руководителя, передавайте ответственность между этапами и отделами.",
  4485: "Архивирование и управление архивами",
  4486: "Отдельный модуль архива: импорт в архив, выдача, поиск, выдача, высокая защита и управление.",
  4487: "Они тоже уделяют внимание процессам",
  4488: "Онлайн-совместное редактирование",
  4489: "Онлайн-редактирование (опция)",
  4490: "Проекты и папки сбора файлов",
  4491: "Архив",
  4492: "Максимальный размер файла 10G",
  4493: "Максимальный размер загружаемого файла настраивается",
  4494: "Можно задать уровни секретности для файлов и отделов",
  4495: "Согласование шаринга",
  4496: "Ограничения входа по устройствам",
  4497: "Управление политиками по IP",
  4498: "Водяной знак и скачивание PDF с водяным знаком",
  4499: "",
  4500: "Операционный администратор",
  4501: "Операционный администратор может входить в админ-панель и управлять отделами, участниками, шаблонами согласования и группами",
  4502: "Добавить операционного администратора",
  4503: "Управление операционными администраторами",
  4504: "Подтвердите удаление роли операционного администратора у {-user-}",
  4505: "Без ограничений по группам",
  4506: "Нажмите здесь для обновления активности",
  4507: "Некорректная информация приглашения：",
  4508: "Отфильтрованы следующие некорректные записи：",
  4509: "Права некоторых файлов в списке изменились, нажмите ОК для обновления списка файлов",
  4510: "Аккаунт разработчика",
  4511: "Если нужно предоставить доступ третьим лицам к данным через API, здесь",
  4512: "Запросить аккаунт разработчика",
  4513: "Callback URL",
  4514: "http url - мы вернём результат аутентификации на этот URL",
  4515: "ID разработчика",
  4516: "Секрет разработчика",
  4517: "Ваш запрос аккаунта разработчика ожидает обработки...",
  4520: "верстак",
  4521: "Дата публикации",
  4522: "Мои последние посещения",
  4523: "Мои последние загрузки",
  4524: "Недавние загрузки отдела",
  4525: "Активные файлы отдела",
  4526: "Недавние загрузки команды",
  4527: "Активные файлы команды",
  4528: "Ещё",
  4529: "В этом разделе пока нет содержимого",
  4530: "Последние корпоративные новости",
  4531: "Фильтр по категориям",
  4532: "Введите имя файла или автора шаринга，нажмите Enter",
  4533: "Порядок",
  4534: "Создать новый элемент рабочей панели",
  4535: "Название карточки",
  4536: "Введите название карточки",
  4537: "Соответствующая корпоративная папка",
  4538: "",
  4539: "Нет пользовательских карточек компании",
  4540: "Редактировать элемент рабочей панели",
  4541: "Название раздела",
  4542: "Можно свободно задать процессы согласования",
  4543: "Группа согласования",
  4550: "Редактировать рабочую панель",
  4551: "Выберите диаграммы для отображения",
  4552: "Я отслеживаю",
  4553: "Открытые мной ссылки на шаринг",
  4554: "Файлы, в которые я приглашал участников",
  4555: "Файлы, которые я комментировал",
  4556: "Мои проекты",
  4557: "Недавняя активность отдела",
  4558: "Облако тегов",
  4559: "Граф связей документов",
  4560: "резервный",
  4561: "настраиваемый",
  4562: "Соответствующая папка",
  4563: "Выберите папку для отображения",
  4564: "У файла нет связанных файлов",
  4565: "Выбрать из связанных файлов этого файла",
  4566: "（Файлы хранятся максимум 10 дней）",
  4567: "Результат обработки",
  4568: "Исполнитель",
  4569: "Время обработки",
  4580: "Новый клиент Mac ARM",
  4581: "Поддерживает macOS 11.0 и выше",
  4582: "Поддерживает Windows 10 и выше",
  4570: '<span class="rmb">￥</span>2 000<span class="yearly"> / год</span>',
  4571: '2000 юаней/год',
  4573: '35 юаней/человек/месяц',
  4574: "Максимальный размер загрузки одного файла составляет 1024 ГБ",
  4575: "Максимальный размер загрузки одного файла составляет 2048 ГБ",
  4600: "Можно ли принудительно пропустить этот этап?",
  4601: "Ограничение доли одобрений：",
  4602: "После одобрения этого этапа можно ли пометить документ как финальный？（Последующий этап — только уведомления на push.）",
  4603: "Название этапа не может быть пустым",
  4604: "Этап",
  4605: "Выберите процесс согласования",
  4606: "Корпоративные шаблоны",
  4607: "Личные шаблоны",
  4608: "Сохранить в личные процессы",
  4609: "Нет предустановленных процессов<br>админ может добавить их в «Консоль компании-Настройки файлов»",
  4610: "Нет",
  4611: "Вверх",
  4612: "Вниз",
  4613: "Роль",
  4614: "Нет процессов согласования",
  4615: "Подсказка：нет информации по процессам",
  4616: "Сохранение не удалось, выберите рецензентов",
  4617: "Сохранение не удалось，в {-title-} выбранная роль не соответствует ни одному пользователю",
  // 4618: '根目录数据错误，请联系客服人员',
  4618: "Сеть истекла по таймауту，обновите и попробуйте снова！",
  4619: "Нет предустановленных процессов",
  4700: "Запрос на включение доступа по ссылке к файлу",
  4701: "Запрос на приглашение участников в шаринг",
  4702: "{-name-} запросил(а) права на файл",
  4703: "{-name-} одобрил(а) запрос",
  4704: "{-name-} отклонил(а) запрос",
  4705: "{-name-} напомнил(а) вам подписаться на файл",
  4706: "{-name-} упомянул(а) вас",
  4707: "{-name-} пригласил(а) вас к согласованию файла",
  4708: "{-name-} одобрил(а) согласование",
  4709: "Корпоративное сообщение：файл одобрен",
  4710: "Корпоративное сообщение：файл отклонён",
  4711: "Уведомление Бабель：Обновление системы",
  4712: "Приглашают вас в команду",
  4713: "Приглашают вас совместно управлять папкой для сбора файлов",
  4714: "{-name-} обработал(а) ваш запрос на открытие доступа по ссылке",
  4715: "{-name-} обработал(а) ваш запрос на приглашение в шаринг",
  4716: "{-name-} отправил(а) вам файл",
  4717: "Системное сообщение：ваш купленный сервис Бабель скоро истекает",
  4718: "{-name-} запустил(а) трансляцию файла",
  4719: "{-name-} опубликовал(а) корпоративное уведомление",
  4720: "Недостаточно прав",
  4721: "У вас нет прав на это; заполните желаемое имя и отправьте запрос ответственному за файл или менеджеру отдела",
  4722: "Требуемые права：",
  4723: "Причина запроса：",
  4724: "Отправить заявку",
  4725: "Связанный файл удалён, это сообщение недействительно",
  4726: "Настроить права",
  4727: "Создать пустой набор прав",
  4728: "Скопировать существующие права для редактирования",
  4729: "Идёт генерация превью, операция недоступна",
  4730: "Слишком частые попытки входа, попробуйте позже",
  4731: "Вы уверенны отменить синхронизацию？После отмены папка больше не будет синхронизироваться локально; доступ останется через Cloud Bridge или веб.",
  4732: "У вас нет прав; укажите желаемое место и отправьте запрос ответственному за файл или менеджеру отдела",
  4733: "Скачать",
  4734: "Печать в PDF",
  4735: "У вас нет прав; выберите желаемые изменения прав и отправьте запрос ответственному за файл или менеджеру отдела",
  //****************** 8.1 ***************

  4736: "Код подтверждения",
  4737: "Получить код",
  /**************8.2***************/

  4738: "Ассистент проекта",
  4739: "Нажмите для выбора ассистента",
  4740: "Выбрать ассистента проекта",
  4741: "Руководитель и ассистент проекта не могут быть одним и тем же",
  4742: "Добавить ассистента проекта",
  4743: "Права",
  4744: "Как пользоваться архивом？",
  4745: "Архив управляется администратором архива; супер-админ может назначить одного или нескольких администраторов архива.",
  4746: "Для доступа к архивным документам обычным сотрудникам необходимо подать заявку, и только после проверки и одобрения архивариусом можно получить доступ к архивным файлам.",
  4747: "Пожалуйста, используйте клиент для предпросмотра и аннотации DWG-файлов",
  4748: "（Приоритет прав: права конкретного сотрудника > права роли > права всех в отделе）",
  4749: "Сохранение...",
  4750: "Выберите критерии и нажмите «Поиск» для просмотра журнала",
  4751: "Папка сбора используется для приёма файлов от отправителей",
  4752: "Открытый сбор",
  4753: "Сбор внутри организации",
  4754: "Открытая папка генерирует ссылку; любой с ссылкой может загрузить файл без регистрации",
  4755: "Внутренний сбор требует списка отправителей компании — только они получат уведомления и смогут загружать",
  4756: "Создать открытую папку для сбора файлов",
  4757: "Поля, которые должны заполнить отправители：",
  4758: "Имя",
  4759: "Введите ваш {-name-}",
  4760: "Добавить поле",
  4761: "Здесь введите заголовок поля",
  4762: "Здесь введите подсказку поля",
  4763: "Предпросмотр формы для отправителя",
  4764: "Пожалуйста, заполните:",
  4765: "Получатель：",
  4766: "Дата публикации：",
  4767: "Вы можете раздать ссылку; отправитель, открыв ссылку, сможет загрузить файлы",
  4768: "Поля ввода пользователя",
  4769: "Пока нет полей",
  4770: "Неизвестный IP",
  4771: "Здесь вы можете задать поля для заполнения отправителем; используйте редактировать/добавить для изменения. После открытия ссылки форма появится.",
  4772: "Все архивы",
  ////////////////*********8.3***************/

  4773: "Только просмотр шаринга и приглашений",
  4774: "Модуль онлайн-редактирования пока не подключён",
  4775: "Ассистент проекта может добавлять/удалять участников и распределять права, но не может передавать или удалять проект.",
  ////////////////*********8.4***************/

  4776: "Мои проекты",
  4777: "Нет файлов в проекте",
  4778: "Нет личных файлов",
  4779: "Пожалуйста, выберите подпапку",
  4780: "Пожалуйста, выберите целевую папку",
  4781: "Настройки push-уведомлений",
  4782: "Файлы, которые я отслеживаю",
  4783: "При выборе, обновления отслеживаемой папки или файла и загрузка новой версии будут приходить в виде push",
  4784: "В текущей директории нельзя загружать новые файлы",
  /////////////////*************9.0*******************/
  4785: "Системная конфигурация",
  4786: "Почтовый сервер",
  4787: "Сторонняя аутентификация",
  4788: "Настройки хранилища",
  4789: "Адрес почтового сервера",
  4790: "Введите адрес почтового сервера",
  4791: "Порт",
  4792: "Введите порт",
  4793: "Код авторизации",
  4794: "Введите код авторизации",
  4795: "Использовать SMTP протокол?",
  4796: "Отмена",
  4797: "Включить стороннюю аутентификацию?",
  4798: "Включить синхронизацию сторонних аккаунтов?",
  4799: "Тип сторонней аутентификации",
  4800: "AD-аутентификация",
  4801: "WeChat для бизнеса",
  4802: "DingTalk",
  4803: "Домен",
  4804: "Введите домен, например domain.com",
  4805: "Путь",
  4806: "например：DC=molasync,DC=cc",
  4807: "Аккаунт",
  4808: "Введите аккаунт",
  4809: "CorpID",
  4810: "Введите CorpID",
  4811: "Agent ID",
  4812: "Введите Agent ID",
  4813: "Secret",
  4814: "Введите secret",
  4815: "Секрет адресной книги",
  4816: "Введите address secret",
  4817: "Мобильная схема (schema)",
  4818: "Введите mobile schema",
  4819: "AppKey мобильного приложения",
  4820: "Введите AppKey мобильного приложения",
  4821: "ID приложения для сканирования",
  4822: "Введите AppId для сканирования",
  4823: "Секрет приложения для сканирования",
  4824: "Введите AppSecret для сканирования",
  4825: "ID мобильного приложения для облака",
  4826: "Секрет мобильного приложения",
  4827: "Локальное хранилище",
  4828: "S3 хранилище",
  4829: "Смонтируйте диск хранения в папку：",
  4830: "Секрет",
  4831: "Введите secret key",
  4832: "Ключ доступа",
  4833: "Введите access key",
  4834: "Сервер",
  4835: "Введите server url",
  4836: "Bucket",
  4837: "Введите bucket name",
  4838: "Режим служебного номера",
  4839: "Включите, чтобы использовать служебный номер как логин",
  4840: "Требовать сложный пароль",
  4841: "Включите, чтобы требовать пароли 10-20 символов с верхним/нижним регистром, спецсимволами и цифрами",
  4842: "Эта настройка действует только в приватной версии; текущая версия не поддерживает",
  4843: "Введите пароль текущего пользователя",
  4844: "Оповещение о аномалиях",
  4845: "Скачиваний файлов за 24 часа больше, чем",
  4846: "шт.",
  4847: "Трафика за 24 часа больше, чем",
  4848: "GB",
  4849: "Оповещение менеджера и админа при аномальном массовом скачивании",
  4850: "Требовать ли аутентификацию при входе",
  4851: "Метод шифрования",
  4852: "Тест",
  4853: "Введите email получателя; мы отправим тестовое письмо и покажем результат",
  4854: "Экспорт списка файлов с участием пользователя",
  4855: "Формируется список файлов",
  4856: "Пожалуйста, выберите получателя",
  4857: "Введите целое число от 1 до 99",
  4858: "Использовать настройки по умолчанию",
  4859: "Только название",
  4860: "Редактируется файл в облаке Бабель. Если вы покинете страницу — изменения не сохранятся。",
  4861: "смешанное",
  4864: "Два способа скачивания папок：через клиент или в режиме авторизации",
  4865: "Этот файл можно скачать в авторизованном режиме",
  4900: "Статистика использования",
  /**************************9.4.3************************** */
  50000: "API ключ",
  50001: "API Быстрый старт",
  50002: "Создать API ключ",
  50003: "Ключ",
  50004: "Проект",
  50005: "Название проекта",
  50006: "URL доступа API",
  50007: "Разрешения для файлов и папок",
  50008: "Разрешения для API на просмотр и управление файлами и папками",
  50009: "Просмотр и редактирование информации о файлах и папках Babbler, к которым у вас есть доступ",
  50010: "Просмотр информации о файлах и папках Babbler, к которым у вас есть доступ",
  50011: "Редактирование содержимого файлов и папок Babbler",
  50012: "Просмотр содержимого файлов и папок Babbler",
  50013: "Создать свой API ключ",
  50014: "Создание и использование API-ключа позволяет сторонним AI-приложениям (например: openclaw, Cursor) быстро подключаться к вашему Babbler, получать файлы и подключаться к базе знаний Babbler AI, а также хранить файлы. Вы можете нажать кнопку выше, чтобы создать новый API-ключ.",
  50015: "Узнать подробнее",
  50016: "Создать новый проект",
  50017: "Назовите ваш проект",
  50018: "Пожалуйста, введите название проекта",
  50019: "Выберите тип прав доступа, которые вам нужны",
  50020: "Папка приложения - доступ к одной папке, созданной специально для вашего приложения.",
  50021: "Полный - доступ ко всем файлам и папкам в Babbler, к которым у вас есть доступ",
  50022: "Создать ключ",
  50023: "Папка приложения",
  50024: "Полный доступ",
  50025: "Переименовать проект",
  50026: "Удалить проект",
  50027: "Вы уверены, что хотите удалить этот проект?",
  50028: "Детали API ключа",
  50029: "URL доступа",
  50030: "Копировать ключ",
  50031: "Копирование успешно",
  50032: "Ошибка копирования, пожалуйста, вручную выделите текст для копирования",
  50033: "Авторизация (OAuth 2)",
  50034: "URI перенаправления (Redirect URIs)",
  50035: "Маркер доступа (Access Token)",
  50036: "Получить маркер",
  50037: "Нажмите, чтобы показать"
};
var _default = exports["default"] = localString_ru_part1;

},{"1454":1454}],1159:[function(require,module,exports){
"use strict";

require(1461);
require(1503);
require(1415);
require(1463);
require(1456);
require(1418);
require(1537);
require(1457);
require(1453);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require(1180));
var _localString_hk_part = _interopRequireDefault(require(1160));
var _localString_hk_part2 = _interopRequireDefault(require(1161));
var _localString_hk_part3 = _interopRequireDefault(require(1162));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var localString_hk = _objectSpread(_objectSpread(_objectSpread({}, _localString_hk_part["default"]), _localString_hk_part2["default"]), _localString_hk_part3["default"]);
var _default = exports["default"] = localString_hk;

},{"1160":1160,"1161":1161,"1162":1162,"1180":1180,"1184":1184,"1415":1415,"1418":1418,"1453":1453,"1454":1454,"1456":1456,"1457":1457,"1461":1461,"1463":1463,"1503":1503,"1537":1537}],1162:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require(1180));
var _localString_hk_part;
var localString_hk_part3 = (_localString_hk_part = {
  //******************************* 初始化密碼界面 */ 
  11001: "初始化密碼",
  11002: "首次登錄，您需要重新初始化密碼",
  //////////////**************9.1.4*************//////////////// */ 
  11003: '導出狀態',
  11004: '導出記錄',
  11005: '導出頁面',
  11006: '搜索導出者',
  11007: '請求時間',
  11008: '導出時間',
  11009: '導出文件',
  11010: '導出人',
  11011: '提示：由於導出文件過大，為了給您提供安全、高效的下載體驗，您的文件導出請求生效後會暫存在雲服務器上，三天後自動失效',
  11012: '成員報表',
  11013: '生成中',
  11014: '已生成',
  11015: '生成失敗',
  11016: '暫無導出記錄',
  11017: '操作成功!請至“<span class="main-color">導出記錄</span>”頁面下載查看。',
  11018: '全部狀態',
  11019: '本條記錄已過期',
  11020: '獲取導出記錄失敗',
  11021: '企業成員信息',
  11022: '用戶參與文件',
  /**********************ai******************* */
  11100: "智巢AI",
  11101: "智巢設置",
  11102: "巴別鳥助手",
  11103: "定製屬於你的AI助理",
  11104: "巴別鳥智巢AI助理可以使用企業指定的文件進行學習，成為你企業的專屬AI助理，對於企業的相關資料及問題可以直接以提問的形式和智巢進行對話，並能根據不同權限的人給出權限範圍內的回答。",
  11105: "歷史提問",
  11106: "新提問",
  11107: "嚴謹",
  11108: "常規",
  11109: "創意",
  11110: "把您的企業文檔庫接入智巢",
  11111: "巴別鳥智巢AI助理可以使用企業指定的文件進行學習，成為你企業的專屬AI助理，對於企業的相關資料及問題可以直接以提問的形式和智巢進行對話，並能根據不同權限的人給出權限範圍內的回答。",
  11112: "購買成功後，你可以選擇需要智巢學習的文檔範圍。耐心等待智巢學習完成後，你將擁有一個專屬AI助理",
  11113: "AI學習需要佔用大量CPU資源，所以接入智巢需要另行支付開通費用，請選擇適合你的服務套餐",
  11114: "不限制創建AI助理數，每個助理最高可學習1萬個文檔。服務有效期：即日起一年內生效 10000元/年",
  11115: "可創建5個AI助理，每個助理最高可學習5000個文檔。服務有效期：即日起一年內生效 5000元/年",
  11116: "可創建2個AI助理，每個助理最高可學習1000個文檔。服務有效期：即日起一年內生效 2000元/年",
  11117: "創建專屬AI助理",
  11118: "助理名稱",
  11119: "請選擇學習的文檔範圍：",
  11120: "新增AI助理",
  11121: "支持複選",
  11122: "我的AI助理:",
  11123: "移除",
  11124: "創建外鏈代碼：",
  11125: "巴別鳥智巢AI助理也可以成為你自己產品和服務的只能客服哦，只要新建AI助理，並選擇在線客服所需的學習材料，AI學習完畢後就能作為智能客服回答用戶問題。可以選擇特定的AI助理創建一個代碼片段，粘貼到你的網站，你就擁有一個全自動回答用戶疑問的專屬AI",
  11126: "選擇需要發佈的AI助理",
  11127: "創建",
  11128: "智巢",
  11129: "不能發送空白信息",
  11130: "目前，智巢AI還需要單獨為每個企業的數據和使用場景進行微調，生成企業專屬的AI模型",
  11131: "如需購買“智巢”AI助理，請聯繫我們的銷售人員（在線客服），或撥打4009204020",
  11132: "你也可以發送郵件至： huangfu@molasync.com",
  11133: "知道了",
  11134: "清空歷史記錄",
  11135: "釋放企業內容價值",
  11136: "即刻使用智巢AI",
  11137: "回答關於文檔的一切問題",
  11138: "通過使用AI分析文檔內容中的豐富知識，智巢AI能回答關於該文檔內容的一切問題。從文檔總結到揭示冗長研究中的關鍵發現。借助人工智能驅動的內容洞察，您可以更快、更自信地做出關鍵任務決策。這意味著，一篇上百頁的文檔你不用親自去讀，而是直接交給AI去讀懂，你向AI詢問你關注的問題即可。能大幅提高工作效率。",
  11139: "定製屬於你企業的AI助理",
  11140: "現有的AI系統最大的問題是沒法根據你企業的專屬內容準確的進行問題回答以致於不可用。巴別鳥智巢AI助理團隊會根據企業的資料幫助企業準備訓練集、調參、訓練企業專屬的AI模型，以實現可用的AI助理。對於企業的相關資料及問題可以直接以提問的形式和智巢進行對話。並能根據不同權限的人給出權限範圍內的回答。甚至可以使用智巢生成代碼塊附在你的網站上快速搭建你企業的對外智能客服系統",
  11141: "打造企業自己的客服平台",
  11142: "客服培訓往往佔用企業大量精力和人力，租用或購買客服機器人成本不低效果也不盡人意。使用巴別鳥智巢AI讓低成本搭建AI客服平台成為可能，讓中小企業也能擁有媲美大型企業的智能客服平台。巴別鳥智巢AI團隊可以利用企業現有的客服培訓材料、問答集、說明書等材料進行優化，形成語料來訓練AI，並且根據你所在行業進行AI調參，最終搭建出適合你企業的AI客服系統。",
  11143: "幫助你創建內容、回答問題",
  11144: "內容創建應該輕鬆有趣，而不是把時間花在斟酌語句上。智巢AI擁有所有大模型具有的基礎能力，無論你是起草新聞稿、撰寫個性化銷售電子郵件，還是在會議中概述行動項目，你都可以利用內容智能加快工作速度，從而騰出時間專注於客戶和創新。由於你是在巴別鳥中工作，因此智能內容管理所需的所有工具都已內置，直接找智巢AI就可以。",
  11145: "安全、可靠且私密的企業級人工智能",
  11146: "如何讓人工智能不瞎說話？如何讓人工智能不要不懂裝懂（會說不知道）？如何讓人工智能不泄密？這些是評價一個人工智能系統好壞的重要指標。智巢AI不僅在準確度上有大幅提升，還會自動匹配巴別鳥的權限體系，如果用戶詢問他權限範圍外的問題，智巢AI會回答不知道。同時，所有參與訓練的文檔都是由用戶指定並同意的。",
  11147: "為你的企業帶來無限可能",
  11148: "使用企業的內容生成數據分析報告",
  11149: "使用企業的語料訓練AI客服，自動回答客戶問題",
  11150: "自動生成營銷郵件、職位說明等文本",
  11151: "輕鬆準確將報告或文檔翻譯成各國語言",
  11152: "AI輔助閱讀，快速找到文章重點及知識點，提升效率",
  11153: "根據企業文檔創建企業專屬問答知識庫",
  11154: "擁有智巢AI",
  11155: "你想使用巴別鳥智巢AI來提高企業生產效率、或是給你的客戶提供更好的服務麼？巴別鳥企業版用戶現在就能直接使用智巢AI了。如果沒有企業版賬號就趕緊註冊一個吧！",
  11156: "同時，我們也提供企業專屬AI訓練服務，讓人工智能幫助企業高速發展。",
  11157: "請完善你的申請信息，成為第一批開啟智巢的人",
  11158: "沒有賬號？",
  11159: "點擊註冊巴別鳥企業版",
  11160: "你的企業登錄賬號（手機號）*",
  11161: "聯繫人姓名*",
  11162: "聯繫人手機號*",
  11163: "獲取驗證碼",
  11164: "驗證碼*",
  11165: "提交申請",
  11166: "請輸入企業版賬號",
  11167: "請輸入正確的手機號賬戶",
  11168: "感謝您對我們的支持，您的申請已經提交，請您等待通知。",
  11169: "請輸入聯繫人姓名",
  11170: "請輸入正確的企業登錄賬號",
  11171: "*因為AI計算需要佔用大量GPU資源，所以每周僅開放數量有限的測試模塊",
  11172: "和智巢聊聊吧",
  11173: "這是智巢巴別鳥助手，你可以用聊天的形式詢問它關於巴別鳥使用中遇到的任何問題",
  11174: "巴別鳥的項目和部門有什麼區別？",
  11175: "我有個文件不想給部門成員看，怎麼操作？",
  11176: "我想發個文件給公司所有人，但不想讓他們下載，如何操作？",
  11177: "客戶端編輯和在線編輯有什麼異同？",
  11178: "這是智巢文檔助手，你可以用聊天的形式詢問它關於此文檔的任何問題",
  11179: "幫我列一個這篇文檔的大綱",
  11180: "這篇文檔的中心思想是什麼？",
  11181: "簡述一下這篇文檔？",
  11182: "發送一個消息",
  11183: "消息發送失敗，請稍後重試",
  11184: "這個問題回答比較長，容我思考下，一分鐘內回復你哦",
  11185: "智巢閱讀助手",
  11186: "登錄巴別鳥企業版",
  11187: "",
  11188: "",
  11189: "",
  11190: "",
  11191: "",
  11192: "",
  11193: "",
  11194: "",
  11195: "",
  11196: "",
  11197: "",
  11198: "",
  11199: "",
  11200: "",
  11201: "",
  11202: "",
  11203: "",
  11204: "",
  11205: "",
  11206: "",
  11207: "",
  11208: "",
  11209: "",
  11210: "",
  11211: "",
  /*******************9.3.6********************** */
  11300: "設定簽章後，你可以在預覽檔案時使用簽章",
  11301: "簽名設定",
  11302: "添加手寫簽名",
  11303: "上傳簽名圖片檔案",
  11304: "圖章設定",
  11305: "上傳圖章圖片檔案",
  11306: "當前使用的圖章",
  11307: "設定默認圖章",
  11308: "支持上傳的圖片類型為png、jpg、jpeg，文件大小不超過2MB",
  11309: "拖入圖片到區域中新建簽名",
  11310: "或",
  11311: "選擇檔案…",
  11312: "上傳簽名圖片檔案",
  11313: "請上傳png、jpg或jpeg格式的圖片",
  11314: "文件大小不能超過2MB",
  11315: "拖入圖片到區域中新建圖章",
  11316: "白色轉為透明",
  11317: "添加圖章",
  11318: "簽署",
  11319: "保存為簽署PDF",
  11320: "保存到目前的目錄",
  11321: "下載PDF檔案",
  11322: "獲取簽章資訊失敗",
  11323: "上傳失敗",
  11324: "正在生成PDF，請稍候",
  11325: "PDF生成失敗，請稍後重試",
  11326: "已簽署檔案",
  11327: "{-somebody-}生成了檔案{-file-}的簽署pdf檔案",
  11328: "簽章認證",
  11329: "在這裡上傳在網盤生成的簽章PDF檔案，可以認證簽章出處及簽章是否是由本系統生成以確定簽署檔案的真實性。 ",
  11330: "點擊或拖拽PDF文件上傳",
  11331: "請上傳pdf檔案",
  11332: "{-user-}在{-time-}生成了檔案《{-file-}》的簽署pdf檔案《{-sealedFileName-}》",
  11333: "簽署檔案生成者",
  11334: "簽署檔案生成日期",
  11335: "簽署有效性",
  11336: "未査詢到該簽署檔案資訊",
  11337: "有效",
  11338: "簽署人",
  11339: "該檔案已經生成了簽名（章）pdf，<br>您可以下載已有的簽章pdf（推薦），<br>也可以點擊下方按鈕再次生成新的簽名（章）pdf檔案",
  11340: "無效",
  11341: "生成新的簽章檔案",
  11342: "Language",
  11343: "{-somebody-}從檔案{-file-}中删除了簽名（章）",
  11344: "請選擇圖片檔案",
  11345: "項目所在目錄沒有可選部門",
  11346: "正在生成簽名文件...",
  11347: "所有下級子部門/資料夾繼承該許可權",
  11348: "所有下級子部門/資料夾將繼承該許可權設定，該設定中的人員/角色在下級部門/資料夾的許可權設定將清空以繼承該許可權設定，此操作不可逆。",
  11349: "點擊企業檔案直接進入所在部門",
  11350: "打開後，點擊企業檔案頻道會直接進入所在部門",
  11351: "您的專業版已過期，為了不影響您的正常使用，請您儘快陞級。",
  11251: "將賬戶 {-somebody-} 升級為專業版",
  11252: "巴別鳥專業版服務",
  11253: "專業版服務有效期至",
  11254: "需支付服務費用合計",
  11255: "當前賬戶已升級為專業版",
  11256: "如您有任何疑問，請聯繫客服",
  11257: "返回主頁",
  11258: "企業稅號",
  11259: "公司發票必填此項",
  11260: "選擇歷史寄送信息",
  11261: "寄送地址",
  11262: "訂單編號",
  11263: "選擇支付方式",
  11264: "下載合同",
  11265: "支付截止時間",
  11266: "逾期將會關閉交易",
  11267: "支付完成前, 請不要關閉此支付驗證窗口, 支付完成後, 請根據您的情況點擊下面按鈕",
  11268: "正在支付",
  11269: "支付成功",
  11270: "支付遇到問題",
  11271: "重新支付",
  //////////////**************9.1.5*************//////////////// */ 
  12100: '高級設置',
  12101: '文件上傳白名單',
  12102: '文件上傳黑名單',
  12103: '只有加入白名單的文件類型才可以上傳',
  12104: '白名單優先級高於黑名單，白名單中的文件類型，黑名單不生效',
  12105: '點擊輸入加入白名單的文件擴展名。例如：jpg;png(不區分大小寫)',
  12106: '多個擴展名可用“;”分隔，如jpg;png;doc',
  12107: '加入黑名單的文件類型禁止上傳',
  12108: '點擊輸入加入黑名單的文件擴展名。例如：jpg;png(不區分大小寫)',
  12109: '雙向綁定',
  12110: '開啟雙向綁定後，綁定mac地址的設備只有綁定的賬號可以登錄（網頁端不受限制）',
  12111: '可在線編輯office文件',
  12112: '關閉該選項該部門office文件將不可使用在線編輯',
  12113: '禁止部門文件對外分享',
  12114: '打開此選項，所有部門成員無法將文件分享給企業外部用戶，同時無法通過鏈接分享文件',
  12115: '是否將此設置應用到當前部門的所有子部門',
  12116: '本部門文件禁止分享',
  12117: '本部門文件禁止在線編輯',
  12118: '部門選項',
  12119: '部門或項目設置的黑名單優先級高於此處的黑名單',
  12120: "直屬成員按角色分類，可編輯管理。",
  12121: '沒有查看鏈接分享的權限',
  12122: '未知角色',
  12123: '將文件 {-file-} 開啟了新的審批階段',
  12130: '消息已過期',
  ////////////////////9.1.6////////////////// 

  12200: '獲取文件密碼失敗',
  12201: '在系統標題欄顯示企業簡稱',
  12202: '不允許輸入特殊字符',
  12203: '角色名不允許輸入特殊字符',
  12204: '策略名不允許輸入特殊字符',
  12205: '分組名不允許輸入特殊字符',
  12206: '發送文件的申請審批未獲通過',
  12207: '發送文件的申請審批獲得通過',
  12220: '嘗試次數過於頻繁，請 10 分鐘後再試',
  12221: '密碼錯誤',
  12222: '成員列表',
  12223: '關閉此選項後，頂部標題欄僅顯示企業logo',
  ////////////////////9.1.7////////////////// 

  12300: '點擊',
  12301: '設置快照',
  12302: "點擊選擇負責人，如果不更換負責人，此項可以為空",
  12303: "沒有下載權限的文件不顯示縮略圖",
  12304: "打開此選項，如果用戶沒有文件的下載權限將不會顯示該文件的縮略圖。防止用戶截取縮略圖泄露文件",
  12305: '不能重複使用舊密碼',
  12306: '你在該文件沒有上傳權限',
  12307: '文件數量多於 {-max-} 個，請使用客戶端同步功能！',
  ////////////////////9.1.8////////////////// 

  12400: '流程圖drawio',
  12401: '搜索結果',
  12402: '文件內容',
  12403: '搜索時嚴格檢測權限',
  12404: '嚴格檢測權限搜索效率會降低，非嚴格檢測權限可能特殊情況下搜到不可訪問文件，但即使搜到也拒絕訪問',
  12405: '已過濾無權訪問文件',
  /////////////////////9.2.0/////////////////////// 

  12500: '素材庫',
  12501: "管理員初始化後才可以使用",
  12502: "素材庫功能還未啟用，是否現在啟用？",
  12503: "素材庫啟用成功",
  12504: "允許訪問素材庫",
  12505: "關閉後，該用戶界面上將沒有素材庫入口，該用戶無法訪問素材庫",
  12506: "批量管理欄目訪問權限",
  12507: "創建分類",
  12508: "輸入分類名字可以創建分類，分類下並不能上傳文件，但可以在分類下創建素材庫或創建新的分類",
  12509: "輸入分類的名字",
  12510: "分類可見性",
  12511: "分類管理員",
  12512: "新建素材庫",
  12513: "你沒有權限創建分類，但你可以向分類管理者申請創建分類，申請通過後，分類會自動創建。",
  12514: "申請創建分類",
  12515: "分類管理",
  12516: "輸入素材庫名稱",
  12517: "素材庫助理",
  12518: "添加素材庫助理",
  12519: "素材庫可見性",
  12520: "下載該素材庫文件需要審批",
  12521: "限定部門公開",
  12522: "限定部門需要審批",
  12523: "訪問需要申請",
  12524: "內部（保密）",
  12525: "能訪問上級分類的所有人都可以訪問",
  12526: "訪問子庫的成員需要向子庫管理者申請，申請通過後才能訪問",
  12527: "僅有素材管理者及素材庫成員可以訪問",
  12528: "該素材庫不顯示縮略圖",
  12529: "沒有下載權限的素材庫訪問者不顯示縮略圖",
  12530: "除管理員外的所有訪問者下載都需要審批",
  12531: "可見性有效期 內部（保密）",
  12532: "到期後轉為",
  12533: "有效期後需要審批通過才能改變可見性",
  12534: "素材庫助理",
  12535: "素材庫成員不受素材庫可見性和分類可見性影響，都可以按權限訪問素材庫（受內部素材庫下載需要審批設置的限制）",
  12536: "素材庫助理可以增加和刪除素材庫成員，為素材庫成員分配權限。但素材庫助理不能移動和刪除素材庫。",
  12537: "素材庫成員",
  12538: "請選擇負責人",
  12539: "管理分類",
  12540: "管理素材庫",
  12541: "分類",
  12542: "申請創建子素材庫",
  12543: "申請訪問",
  12544: "申請",
  12545: "申請訪問分類《{-file-}》",
  12546: "申請訪問素材庫《{-file-}》",
  12547: "訪問申請",
  12548: "申請下載{-file-}中的以下文件",
  12549: "申請下載以下文件",
  12550: "申請下載人員",
  12551: "管理申請人員",
  12552: "你將當前庫設置為下載不再需要申請，而該庫中有申請下載的歷史數據，是否清除這些數據？",
  12553: "清除",
  12554: "保持",
  12555: "你沒有權限創建子素材庫，但你可以向管理者申請創建素材庫，申請通過後，素材庫會自動創建。",
  12556: "同一個目錄下一次只能申請創建一個素材庫",
  12557: "選擇素材庫成員",
  12558: "請選擇限定的部門",
  12559: "查看已授權申請人員名單",
  12560: "已授權訪問人員",
  12561: "已授權下載文件",
  12562: "查看已授權下載人員",
  12563: "已授權信息",
  12564: "刪除後，該用戶將無法訪問當前素材庫",
  12565: "刪除後，該用戶將無法下載當前文件",
  12566: "用戶名或密碼錯誤，請核對後重新輸入",
  12567: "同一個目錄下一次只能申請創建一個分類",
  12568: "分類下無法直接上傳文件，你可以在分類下新建子素材庫後在素材庫上傳文件",
  12569: "當前分類為空",
  12570: "當前素材庫為空",
  12571: "批量設置分類",
  12572: "批量設置子素材庫",
  12573: "批量設置\"{-name1-}\"\"{-name2-}\"..等{-len-}個分類",
  12574: "批量設置\"{-name1-}\"\"{-name2-}\"2個分類",
  12575: "保存後將覆蓋所選分類的設置信息",
  12576: "批量設置\"{-name1-}\"\"{-name2-}\"..等{-len-}個素材庫",
  12577: "批量設置\"{-name1-}\"\"{-name2-}\"2個素材庫",
  12578: "此處為空則不批量設置負責人，保留原有負責人",
  12579: "保存後將覆蓋所選素材庫的設置信息",
  12580: "此處為空則不批量設置管理員，保留原有管理員",
  12581: "刪除後，該用戶將無法訪問當前分類",
  12582: "輸入文件名篩選對應文件",
  12583: "不隱藏保密素材庫(非保密素材庫成員也能看到該素材庫)",
  12584: "申請成為成員",
  12585: "申請成為素材庫成員",
  12586: "你正在申請成為{-name-}素材庫的成員",
  12587: "輸入用戶名進行篩選",
  12588: "新客戶端Windows版",
  12600: "提取圖片文字（OCR）",
  12601: "最多支持一個文件上傳，單個文件最大為20M",
  12602: "支持上傳{-exts-}格式",
  12603: "僅支持上傳20M以下{-exts-}文件",
  12604: "僅支持上傳單個文件",
  12605: "再次OCR",
  12606: "識別結果",
  12607: "導出為文檔",
  12608: "OCR識別結果",
  12609: "識別圖片文字（OCR）",
  12610: "正在識別中...",
  12611: "你可以點擊並粘貼圖片到此處",
  12612: "重試",
  12613: "另存為文檔",
  12614: "“我們使用巴別鳥企業網盤快三年了，重要文件和設計稿件都在巴別鳥上，並且我們和巴別鳥團隊一起合作開發了素材庫功能來統一管理我們各個IP的素材和設計”",
  12615: "—— 泡泡瑪特IT負責人：劉俊利",
  12650: "AI自動打標籤",
  12651: "AI自動打標籤可以根據標籤庫裡的預設標籤自動匹配和當前文件最接近的標籤，你也可以選擇多個文件，批量使用AI自動標籤。",
  12652: "打標成功後，每個文件將扣除1智點算力值",
  12653: "你的標籤庫裡還沒有任何標籤",
  12654: "AI自動打標籤可以根據你或企業標籤庫裡預設的標籤自動匹配和當前文件最接近的標籤。你可以先添加一批標籤，然後用自動打標籤功能為文件打標籤。",
  12655: "去添加標籤",
  12656: "下次不再顯示該提醒",
  12657: "該類型文件目前還不支持AI自動打標籤",
  12658: "希望以後支持？點擊關閉並提交心願",
  12659: "當前賬號剩餘智點數量不足，請購買後繼續使用",
  12660: "最多支持選擇{-num-}個文件",
  12661: "正在批量打標籤，請稍後回來查看",
  12662: "Language",
  12663: "檔案已被鎖定，無法完成操作，可能有人正使用客戶端編輯此檔案，需等待其編輯完成後，再嘗試進行此操作。",
  13000: "智巢AI",
  13001: "你剩餘的智點數量",
  13002: "已使用的智點數量",
  13003: "購買智點",
  13004: "進行一次AI搜索大約會耗費1000個智點、普通全文搜索不會消耗智點",
  13005: "進行一次AI圖搜圖大約會耗費1萬個智點",
  13006: "AI助理根據回答的問題不同每個問題會耗費3k-1W 智點",
  13007: "查看使用詳情",
  13008: "從今天開始享受AI帶來的變革",
  13009: "帳單",
  13010: "購買賬號",
  13011: "有效期至",
  13012: "需要開票？點擊輸入",
  13013: "開票信息",
  13014: "所購產品",
  13015: "巴別鳥AI 智點套餐購買",
  13016: "有效期至",
  13017: "一年",
  13018: "總價",
  13019: "立即支付",
  13020: "購買智點數量",
  13021: "有效期",
  13022: "請填寫正確郵箱地址，發票開具後將發送至該郵箱",
  13023: "需要發票",
  13024: "操作時間",
  13025: "收入/支出",
  13026: "剩餘",
  13027: "智點使用詳情",
  13028: "使用者",
  13029: "允許使用AI",
  13030: "關閉後，該用戶界面上的AI功能入口不顯示，僅可使用AI客服",
  13031: "去支付",
  13032: "智巢AI應用:",
  13033: "智能AI搜圖",
  13034: "智能AI搜索",
  13035: "智體:",
  13036: "巴別鳥在線客服",
  13037: "智巢",
  13038: "你的專屬企業助理，回答和你企業相關的任何問題",
  13039: "AI搜索",
  13040: "AI搜圖",
  13041: "輸入你的問題，例如“報銷流程怎麼走？”",
  13042: "創建智體",
  13043: "創建一個智能客服",
  13044: "可以對外提供客服的智能體",
  13045: "創建一個知識庫機器人",
  13046: "一個回答特定問題的機器人",
  13047: "詢問關於巴別鳥的一切問題",
  13048: "內測中...即將推出，敬請期待！",
  13049: "拖拽圖片到此處或點擊",
  13050: "抱歉，您上傳的文件不是圖片格式，請",
  13051: "重新上傳",
  13052: "僅支持10M以下的{-exts-}格式文件",
  13053: "正在上傳圖片...",
  13054: "本地上傳",
  13055: "點此通過描述尋找圖片",
  13056: "點此通過圖片匹配尋找相似圖片",
  13057: "輸入對圖片的描述或粘貼圖片到此處，支持文字和圖片混合搜索",
  13058: "圖片搜索",
  13059: "上傳完成",
  13060: "暫無符合條件的圖片文件",
  13061: "查看更多",
  13062: "抱歉，您上傳的文件過大，請",
  13063: "智能知識庫",
  13064: "再試一次",
  13065: "智點計費規則",
  13066: "計費項目（每次）",
  13067: "扣除智點數",
  13068: "查看智點扣費規則",
  13069: "萬",
  13070: "千",
  13071: "參考來源",
  13072: "複製成功",
  13073: "開啟",
  13074: "ai搜索所需智點已不足，請購買後繼續使用",
  13075: "請稍候...",
  13076: "啟用智能搜索",
  13077: "輸入對圖片的描述進行搜索",
  13078: "Excel數據助理",
  13079: "文件預覽",
  13080: "分析結果",
  13081: "點擊或拖拽文件上傳",
  13082: "選擇我的雲盤文件",
  13083: "上傳文件要求說明",
  13084: "最多支持三個文件上傳，單個文件最大為10M<br>支持上傳csv、xls、xlsx格式",
  13085: "目前僅支持處理表格前三個有效sheet",
  13086: "試著輸入對文檔的分析請求",
  13087: "請選擇文件",
  13088: "保存成圖片",
  13089: "圖片保存中",
  13090: "保存成功",
  13091: "保存失敗，請稍後重試",
  13092: "新對話",
  13093: "Hello！歡迎使用Excel數據助理，上傳文檔後你可以試著問：",
  13094: "幫我計算XXX的平均值",
  13095: "對比XXX表和XXX表並分析",
  13096: "分析XXX的流量趨勢",
  13097: "整理分數高於XXX的學生成績",
  13098: "提取XXX數據生成一個柱狀圖",
  13099: "分析7月和8月的銷售數據",
  13100: "2014至2024各地區數據增長和時間相關性",
  13101: "統計下XXX為XXX的現金收益",
  13102: "巴別鳥智巢&nbsp;AI&nbsp;網盤",
  13103: "讓你",
  13104: "上工作",
  13105: "巴別鳥智巢已全線接入",
  13106: "AI搜索",
  13107: "學習網盤中存儲的文件，根據文件內容、圖像內容構建知識圖譜，按權限搜索、查詢、檢索、問問題、寫文章。",
  13108: "智體&nbsp;LLM&nbsp;Agent",
  13109: "定制化的智能體，可選擇網盤中的內容學習並自動更新，按需完成如客服、信息收集、文件處理…等各種任務。",
  13110: "企業專屬AI助理",
  13111: "了解你企業的AI助理，根據使用者權限來提供服務。接入DeepSeek回答企業問題，查找文件，撰寫文章。",
  13112: "圖搜圖&nbsp;文搜圖",
  13113: "通過描述或者示範圖片搜索相關圖片，按使用者權限提供不同結果。",
  13114: "AI&nbsp;知識庫",
  13115: "學習企業文件提供知識問答，可自定義知識源，支持創建多個知識庫。",
  13116: "數據分析助理",
  13117: "分析excel、csv等結構化數據，提供準確的數據分析、圖表生成、數據查詢、數據分類等服務，支持多表格交叉比對。",
  13118: "請上傳後綴名為xls、xls、csv的文件",
  13119: "請先選擇Excel文件",
  13120: "個人目錄下，你沒有上傳文件的權限",
  13200: "我的AI工具（智能體）",
  13201: "我的AI工具",
  13202: "我創建的",
  13203: "已發佈",
  13204: "未發佈",
  13205: "搜索項目",
  13206: "選擇智能體類型",
  13207: "知識庫機器人",
  13208: "簡單配置就可以回答特定範圍問題",
  13209: "知識庫機器人，可以當說明書",
  13210: "長文本生成",
  13211: "用於寫文章，文本生成任務的AI助手",
  13212: "智能客服",
  13213: "可以嵌入你的網頁，為你的客戶回答產品問題的機器人",
  13214: "工作流",
  13215: "把某個文件夾的文件按一定要求自動化處理",
  13216: "{-name-}創建",
  13217: "智能體名稱&圖標",
  13218: "給你的智能體起個名字",
  13219: "描述",
  13220: "（可選）",
  13221: "輸入應用描述",
  13222: "更改圖標",
  13223: "上傳圖標",
  13224: "圖標預覽",
  13225: "智能體名稱不能含有特殊字符",
  13226: "請輸入智能體名稱",
  13227: "未發佈",
  13228: "發佈成功",
  13229: "智能體設置",
  13230: "發佈智能體",
  13231: "知識庫",
  13232: "人設與回覆邏輯",
  13233: "請輸入人設與回覆邏輯",
  13234: "知識源",
  13235: "你確定要從知識源中刪除文件夾《{-name-}》嗎？",
  13236: "開場白",
  13237: "請輸入你的開場白文案",
  13238: "背景圖",
  13239: "調試與預覽",
  13240: "監測",
  13241: "編輯智能體",
  13242: "更新成功",
  13243: "更新失敗",
  13244: "為你的智能體增加對話背景圖片，對話時更加沉浸",
  13245: "為你的智慧體新增知識源，知識源是知識庫讀取檔案的信息源，知識源可以添加多個。 添加知識源後最多需要等待30分鐘進行入庫。",
  13246: "可見性",
  13247: "向所有人公開",
  13248: "收到連結的人可見",
  13249: "私密",
  13250: "發佈更新",
  13251: "運行",
  13252: "嵌入網站（向所有人公開）",
  13253: "發佈成功",
  13254: "未發佈",
  13255: "沒有找到知識庫的知識源，請添加知識源",
  13256: "你已關注該智能體",
  13257: "你已取消關注該智能體",
  13258: "開啟新對話",
  13259: "複製連結",
  13260: "獲取連結失敗，請稍後重試",
  13261: "刪除智能體",
  13262: "最近使用",
  13263: "你已成功移除該智能體",
  13264: "智能體數據錯誤",
  13265: "複製連結",
  13266: "已複製連結，分享給好友吧！",
  13267: "沒有找到知識庫的知識源，請添加知識源",
  15000: "確定要恢復所有文件嗎？",
  20000: "發現您的賬號在其他地方登錄：",
  20001: "賬號多地登錄",
  20002: "您無權管理分享，請和分享發起者聯繫！如果您想獲得鏈接地址，可以通過右键菜單中點擊獲取鏈接地址",
  20003: "企業禁止上傳此類型文件！",
  20010: "個人版不支持此類型文件在線預覽，敬請升級",
  20011: "此處的鏈接地址，您可以將其通過郵件或者QQ等第三方通信手段進行傳播，獲得此鏈接的人員即可以通過此鏈接訪問文件。",
  20012: "office 在線編輯需要購買在線編輯授權，您可以免費試用30天，到期後如果還需要繼續使用請聯繫我們銷售人員購買授權。",
  20013: "文件在指定的位置不存在",
  20020: "親愛的 {-name-}:",
  20021: "{-somebody-} 在項目{-file-}中對外發送了文件，發送單號為{-transmittal-}",
  20022: "該文件發送單已被刪除",
  20023: "文件夾裡沒有文件",
  20024: "歡迎使用文控管理系統，只要訪問這個鏈接就可以使用你的郵箱和驗證碼查看發送給您的文件，強烈建議保存此鏈接，方便隨時查詢",
  20025: "發送單號(Transmittal NO.)不能為空",
  20026: "文件列表不能為空",
  20027: "本次收到的文件",
  20028: "歷史接收記錄",
  20029: "版本",
  20030: "接收人和郵箱都為必填項",
  20031: "接收人沒有設置郵箱",
  20032: "確信要刪除這 {-num-} 個傳送單嗎？",
  20033: "點擊選擇登錄的郵箱",
  20034: "獲取郵箱驗證碼",
  20035: "發現下列文件名已經存在，本次操作自動進行了重命名:",
  20036: "{-oldName-} --> {-newName-}",
  20037: "舊名字",
  20038: "新名字",
  20040: "<p>\u60A8\u7684\u5BA2\u6236\u7AEF\u7248\u672C\u904E\u4F4E\uFF0C\u7121\u6CD5\u6B63\u5E38\u4F7F\u7528\u96F2\u6A4B\u3001\u540C\u6B65\u7B49\u529F\u80FD\uFF0C\u8ACB\u53BB\u5B98\u7DB2\u4E0B\u8F09\u6700\u65B0\u7248\u672C\u7684\u5BA2\u6236\u7AEF\u3002</p><p>\u4E0B\u8F09\u5730\u5740\uFF1A<a style=\"margin-left: 0;\" href=\"https://www.babel.cc/p/download.do\" target=\"_blank\" >https://www.babel.cc/p/download.do</a></p>",
  20041: "文件夾路徑 \"{-folder-}\" 創建失敗，請稍後重試",
  20042: "session 數據失效!",
  20050: "",
  20051: "可用空間不足，有可能你上傳的目標文件夾做了空間限制，請聯繫管理員。",
  20052: ", 共{-fileNum-}個文件",
  20053: "您沒有創建文件夾的權限",
  20054: "使用提示",
  20055: "檢測到您正在使用企業微信打開網盤，為了獲得更好的使用體驗，建議使用瀏覽器訪問。",
  20056: "在企業微信窗口右上角點擊“瀏覽器打開”圖標，即可通過瀏覽器訪問",
  20057: "該文件收集箱已過期，不可上傳文件",
  20058: "文件異常，請稍後重試，或者重新上傳此文件",
  20100: "目標文件夾下該文件\"{-fileName-}\"已經存在,請刷新文件列表查看! ",
  20101: "點擊重置密碼可以在後台設置一個密碼 ",
  20102: "此用戶已存在但出於休眠狀態，點擊確定將其激活並加入本企業",
  20147: "請打開相應的部門再上傳文件",
  20148: "當前文件目錄下不支持上傳文件",
  20149: "查看更多未讀消息",
  20150: "部門範圍",
  20151: "創建部門",
  20152: "創建項目",
  20153: "創建文件夾",
  20154: "分享 {-file-} 已到期, 已自動關閉。",
  20155: "分享已經到期，已自動關閉!",
  20156: "項目負責人不能同時兼任助理!",
  20157: "點擊進行統計",
  20158: "上次訪問的文件夾",
  20159: "正在操作",
  20160: "正在檢測重名文件",
  20161: "上次選擇的文件夾",
  20162: "服務器已經存在相同文件夾，請重新命名!",
  20163: "數據不完整，請匯報此問題",
  20170: "僅查看刪除記錄",
  20171: "視頻文件不允許匿名訪問，請登錄後查看",
  20172: "推送消息接收設置",
  20173: "項目最近上傳文件",
  20174: "正在生成報表，請稍後",
  21000: "忽略並繼續上傳",
  21001: "您需要上傳的文件數量超過500個，容易造成系統響應緩慢導致上傳失敗。建議使用客戶端同步功能批量上傳文件。",
  21002: "*安裝客戶端後在需要上傳的文件夾上右鍵點擊，選擇“巴別鳥-同步文件夾”即可",
  21003: "請填寫您用來登錄的郵箱地址或手機號獲取驗證碼來重新設置新密碼。如果您是使用工號登錄，請聯繫管理員重置密碼。",
  21100: "用於顯示指定文件夾內的最近上傳文件列表",
  21200: "發送文件{-file-}需要您的審批",
  21201: "您發送文件{-file-}獲得批准，已經發送成功",
  21202: "您發送文件{-file-}未獲得批准，發送失敗",
  21203: "分享文件{-file-}的參與者涉及到了保密部門人員，需要您的審批",
  21204: "涉密操作",
  21205: "發起方{-user-}已經撤回該請求，此消息已經失效",
  21206: "項目{-file-}的參與者涉及到了保密部門人員，需要您的審批",
  21207: "您訪問的鏈接不存在或文件已取消分享或你無權查看該文件！",
  21208: "加入分享需要獲得企業保密員或者管理員的批准，該請求已經發送給相關人員，請等待審核！",
  21209: "您加入分享{-file-}的請求已經獲得批准",
  21210: "您加入分享{-file-}的請求被否決",
  21211: "由於涉及到保密部門人員，需要企業管理人員進一步審批<br>請等待審批結果</br>",
  21212: "成員發起分享",
  21213: "成員加入分享及項目",
  21214: "成員發送文件",
  21215: "審批人",
  21216: "多部門成員發送文件",
  21217: "需要審批",
  21218: "安全保密員或超級管理員",
  21219: "審批人為安全保密員或超級管理員",
  21220: "無需審批",
  21221: "上級主管",
  21222: "分享給其他部門人員需要審批",
  21223: "分享或項目邀請保密部門人員加入時，需要安全保密員或超級管理員的審批。",
  21224: "有保密部門的企業，鏈接分享不允許匿名上傳；不允許創建開放式文件收集箱。",
  21225: "只有“公開”策略下的部門支持鏈接分享，其他策略都僅支持邀請分享；",
  21226: "絕密文件：默認除了創建者、項目負責人、文件負責人和部門經理外部門內其他人不可見，分享該文件必須獲得安全保密員授權；",
  21227: "限制文件：一般人員只讀，分享該文件必須獲得上級主管授權；",
  21228: "內部文件：分享該文件給部門外人員，必須獲得上級主管授權；",
  21229: "絕密文件，限制文件，一般人員不能移動/複製/上傳新版本/下載/重命名/查看版本，上級主管和有部門文件管理權限的人員才可以。",
  21230: "操作失敗,因該文件已被舉報!",
  21231: "該用戶不允許在當前IP地址上傳文件",
  21232: "",
  // *************************************** release8.5.3 
  21300: "{-somebody-} 為 {-file-} 創建了快照分享",
  21301: "快照",
  21302: "您無權查看此文件的快照分享",
  21303: "權限申請批覆",
  21304: "您對文件{-file-}申請的權限已獲得批覆結果，結論：{-result-}",
  21305: "該文件的最新版本還在編輯處理中，當前顯示的還是舊版本",
  21306: "該文件的最新版本還在編輯處理中，當前下載的還是舊版本",
  21307: "下載舊版本",
  // ************************************** release8.5.4 
  21400: "今日上傳:",
  21401: "今日下載:",
  21402: "操作失敗，不能含有絕密部門或其人員",
  21403: "當前企業人數已經超過了授權人數，請儘快處理，以免影響普通人員的登錄和使用",
  21404: "解鎖失敗，文件已被他人鎖定!",
  21405: "刪除失敗，文件被他人鎖定！",
  21406: "搜索檔案庫,按回車鍵確認",
  ///////////////////////////////////////////////////////9.0.2///////////////////////////////////// 

  21500: "策略名稱重複，保存失敗",
  21501: "分享給部門外成員",
  21502: "分享給項目外成員",
  21503: "{-somebody-} 在 {-parentFolder-} 中新建了項目{-folder-}",
  21504: "{-somebody-} 在 {-parentFolder-} 中新建了文控項目{-folder-}",
  21505: "來自{-user-}的項目",
  21506: "您可以在“我的項目”中查看該文件",
  21507: "您可以在“文件收集箱”中查看該文件",
  21508: "當前文件夾已存在名稱為 {-name-} 的文件夾，該文件夾上傳失敗，請修改文件名後再次上傳",
  21509: "接下來的同名文件夾忽略該提示（同名文件夾默認不上傳）",
  21510: "發現同名文件夾",
  21511: "管理部門",
  21512: "文件數量超過了 {-limit-}，快照分享不支持， 請使用普通分享功能",
  21513: "統計用量",
  21514: "正在計算中，請稍後",
  21515: "企業佔用空間 ",
  21516: "部門模板文件夾刪除後，不會進入回收站，會直接刪除，你是否確定刪除？",
  21517: "巴別鳥白皮書.pdf",
  21518: "我加入的部門",
  21519: "目前公有雲版本不支持在線播放此格式視頻，您可以下載後播放，或聯繫客服選擇私有化部署",
  21520: "僅文件夾",
  21521: "回收站",
  21522: "企業已刪除文件管理",
  21523: "文件所屬部門",
  21524: "刪除審核部門",
  21525: "主題色",
  21526: "和系統一致",
  21527: "深色",
  21528: "淺色",
  21529: "你的企業身份發生了改變，新的企業身份：{-name-}",
  // 21529: "你的企業身份發生了改變！", 
  21530: "本地編輯",
  21531: "本地只讀打開",
  21532: "部門成員",
  // 21525: "", 
  // 21525: "", 
  // 21525: "", 

  //********************cad************************************** */ 
  21550: "正在準備預覽數據",
  21551: "服務器正在轉碼，請稍候重試",
  21552: "圖紙下載失敗",
  21553: "正在載入",
  // ************************************* release 8.7.1 
  21601: "查看登錄歷史",
  21602: "查看參與的分享",
  21603: "IP",
  21604: "設備類型",
  21605: "設備名",
  21606: "本賬號正在其他地點登錄, ip:{-ip-}，如果不是你本人所為，請儘快修改密碼，並在個人設置-設備管理界面中將其踢出",
  21607: "沒有登錄歷史",
  21608: "提示：此人從未登錄過本系統",
  21609: "查看參與的特設文件",
  21610: "暫無參與的特設訪問控制的文件",
  21611: "查看參與的分享",
  21612: "查看參與的項目",
  21613: "參與分享文件列表",
  21614: "暫無參與的分享",
  21615: "暫無參與的項目",
  21616: "參與項目文件列表",
  21617: "超過數量限制，超級管理員將收到郵件或短信提醒",
  //////////////////////////**************9.0.5******************///////////////// */ 
  21650: '所有標籤',
  21700: "客戶端版本太低，請下載最新客戶端來完成下載",
  // ************************************************* release 9.0.5 
  21800: "企業標籤",
  21801: "個人標籤",
  21802: "系統僅支持最多{-maxTerminals-}個設備同時在線",
  /////////////////////////////************release9.0.6************/////////////////////////////// 
  21900: "並集",
  21901: "交集",
  21902: "對稱差集",
  21903: "無標籤",
  21904: "分鐘",
  21905: "小時",
  21906: "天",
  21907: "周",
  21908: "月",
  21909: "最近",
  21910: "超過",
  21911: "之前",
  21912: '至今',
  21913: '最近{-time-}{-unit-}',
  21914: '{-time-}{-unit-}之前',
  21915: '{-start-}至{-end-}',
  21916: "在",
  21917: "和",
  21918: "之間",
  21919: "我刪除的文件",
  21920: "他人刪除的文件",
  21921: "僅允許企業內人員訪問",
  21922: "設置分享的審核",
  21923: "需要審核的文件操作",
  21924: "分享文件",
  21925: "發送文件",
  21926: "審核人員",
  21927: "新增審核人員",
  21928: "清除配置項",
  21929: "{-user-}設置於{-time-}",
  21930: "申請將文件{-file-}的”{-roleName-}“權限",
  21931: "發送文件需要您的審核",
  21932: "管理員可在“企業控制台-文件配置”欄目添加審批流程",
  21933: "無地點",
  21934: "針對當前文件夾內的任何文件，如果有保密的需要，可以在此設置當其中的文件進行分享或發送時需要通知相關人員進行審核",
  21935: "本階段通過後，文件位置：",
  21936: "當前位置（不移動文件）",
  21937: "移動到所選文件夾",
  21938: "本階段結束文件移動至：",
  21939: "文件白名單",
  21940: "文件白名單,即文件類型白名單，加入白名單的文件類型將只允許白名單內文件類型上傳，輸入您想上傳的文件擴展名到下面的列表即可",
  21941: "請輸入加入白名單的文件擴展名，例如jpg",
  21942: "白名單列表",
  21943: "白名單優先級高於黑名單，白名單列表裏有文件類型的話，黑名單不生效。部門或項目設置的白名單優先級高於此處的白名單。",
  21944: "請選擇安全策略",
  21945: "本次發送文件需要審核，審核通過後會自動執行發送",
  21946: "未安裝CAD在線預覽模塊。如需預覽DWG文件，請聯繫企業管理員",
  21947: "當前位置（不移動文件）",
  21948: "目標文件夾已被刪除",
  21949: "（網頁端不受限制）",
  ///////////////////////////////////////9.1.2****************************/ 

  21950: '批量重命名',
  21951: '文件數',
  21952: "重命名方式",
  21953: "自定義",
  21954: "替換",
  21955: "插入",
  21956: "刪除",
  21957: "按時間重命名",
  21958: "新文件名",
  21959: "大小寫轉換",
  21960: "不變",
  21961: "全部大寫",
  21962: "全部小寫",
  21963: "首字母大寫",
  21964: "首字母小寫",
  21965: "請輸入新文件名",
  21966: "編號設置",
  21967: "起始",
  21968: "第一位編號",
  21969: "增量",
  21970: "增加的數字",
  21971: "位數",
  21972: "編號一共有幾位",
  21973: "開始批量重命名",
  21974: "原文件名",
  21975: "新文件名",
  21976: "狀態",
  21977: "名稱來源",
  21978: "文件創建時間",
  21979: "文件修改時間",
  21980: "當前時間",
  21981: "時間樣式",
  21982: "yyyy年mm月dd日HH時mm分",
  21983: "時間插入位置",
  21984: "文件名頭",
  21985: "文件名尾",
  21986: "去除文件名",
  21987: "去除文件名並增加編號",
  21988: "yyyy年MM月dd日HH時mm分",
  21989: "插入位置",
  21990: "插入類型",
  21991: "自定義內容",
  21992: "編號",
  21993: "插入內容",
  21994: "查找內容",
  21995: "替換內容",
  21996: "按文件名位置",
  21997: "文件名中的空格",
  21998: "文件名中的數字",
  21999: "文件名中的引號",
  22000: "刪除類型",
  22001: "開始位置",
  22002: "長度",
  22003: "刪除內容",
  22004: "文件屬性",
  22005: "文件創建者",
  22006: "文件負責人",
  22007: "最近版本修改者",
  22008: "插入文件屬性",
  22009: "待操作",
  22010: "文件開始重命名，請稍後",
  22011: "文件重命名完成",
  22012: "文件名過長",
  22013: "你可以右鍵使用本地預覽CAD<br/>如需在線預覽需要購買在線預覽CAD模塊",
  22014: "查看登錄的設備",
  22015: "當前文件列表的服務器數據發生改變<br/>是否刷新界面查看最新數據？",
  22016: "，可使用右鍵“本地編輯”功能打開預覽",
  22017: "下載失敗",
  22018: "文件正在進行在線編輯",
  22019: "老版本Win客戶端",
  22020: "客戶端Linux版",
  22021: "Ubuntu,統信UOS, 麒麟",
  22022: "聯繫客服試用",
  //************9.1.3 */ 
  22050: "查看分享文件",
  22051: "加載失敗",
  22052: "暫無分享文件",
  22053: "文件夾內所有分享文件",
  22054: "當前文件夾沒有打開分享的文件(夾)",
  22055: "正在關閉分享...",
  22056: "新增文件夾",
  //************9.1.7 */ 
  23000: "強制更新密碼",
  //************9.2.0 */ 
  24000: "素材庫消息",
  24001: "申請在素材庫中創建分類《{-file-}》",
  24002: "申請在素材庫中創建子素材庫《{-file-}》",
  24003: "{-name-} 申請在 {-type-} 《{-file-}》 中創建以下分類",
  24004: "{-result-}了你創建分類《{-file-}》的申請",
  24005: "{-result-}了你創建子素材庫《{-file-}》的申請",
  24006: "{-name-} 申請在 {-type-} 《{-file-}》 中創建以下素材庫",
  24007: "{-name-} 申請訪問{-type-} 《{-file-}》",
  24010: "素材庫 《{-name-}》 原可見性({-accessType-})設定的時間已到期，可見性根據預設將自動設定為({-nextAccessType-})，需要您的審批",
  24011: "素材庫 《{-name-}》 原可見性設定的時間已到期，可見性根據預設已經自動設定為({-accessType-})",
  24012: "申請下載素材庫中的文件（夾）《{-name-}》等文件",
  24013: "您申請下載素材庫中的文件（夾）《{-name-}》等文件，已被管理員{-result-}",
  24014: "{-result-}了你訪問分類《{-file-}》的申請",
  24015: "{-result-}了你訪問子素材庫《{-file-}》的申請",
  24016: "在線編輯已經完成並提交了，<br/>是否刷新查看最新版本？",
  24017: "在素材庫中創建了分類《{-file-}》",
  24018: "在素材庫中創建了子素材庫《{-file-}》",
  24019: "修改了部門設置《{-file-}》",
  24020: "素材分類",
  24021: "子素材庫",
  24022: "不支持此種類型的文件在線預覽",
  24023: "申請加入子素材庫《{-name-}》",
  24024: "{-result-}了你加入子素材庫《{-file-}》的申請",
  24025: "申請加入素材庫",
  24026: "素材庫",
  // ************9.3.0 */ 
  'AI_SEARCH': "AI搜索",
  'WORD_S_IMAGE': "以文搜圖",
  'IMAGE_S_IMAGE': "以圖搜圖",
  'AI_TALK': "AI對話",
  'IMAGE_OCR': "圖片 OCR",
  'DOC_ASSISTANT': "文檔助手",
  'SPREAD_SHEETS': "表格問答",
  'buy tokens': "購買智點",
  'DEEP_SEARCH': "深度思考(Deepseek-R1)",
  'ONLINE_SERCH': "聯網搜索",
  'DEEP_RESEARCH': "深度研究",
  24100: "回到最新版本",
  24101: '可以在這裡描述要搜索的圖片，例如“背景是藍天白雲”',
  24102: '你所在企業有舊數據需要 AI 進行學習處理，是否立即處理？',
  24103: "你個人有舊數據需要 AI 进行學習處理，是否立即處理？",
  24104: "個人文件處理中...",
  24105: "企業文件處理中...",
  24106: "個人文件處理完畢<br>",
  24107: "企業文件處理完畢",
  24108: "等待處理的個人文件：{-count-}個<br>",
  24109: "等待處理的企業文件：{-count-}個",
  24110: "AI 處理歷史數據",
  24111: "處理完畢",
  24112: '企業剩餘的智點數量',
  24113: '複製為markdown',
  //************9.3.0 new*/ 
  25000: "添加授權人員",
  25001: "僅查看登錄",
  26000: "幫我寫一篇公眾號文章",
  26001: "智巢能做什麼",
  26002: '總結一下"白皮書"',
  26003: "入職流程有哪些",
  26004: "搜索有大海的所有圖片",
  26005: "我司產品主要有哪些",
  26006: "Hello! 你可以問我",
  26007: "試著輸入問題開啟對話",
  26008: "深度思考",
  26009: "聯網搜索",
  26010: "思考中",
  26011: "已深度思考，用時（{-num-}）秒",
  26012: "新對話",
  26013: "已深度思考",
  26014: "回答結束，用時（{-num-}）秒",
  26015: "回答結束",
  26016: "回答超時，請稍後重試",
  26017: "簡單描述一下這張圖片",
  26018: "請顯示出圖片中出現的文字",
  26019: "已搜索到{-num-}個來源",
  26020: "快速搜索",
  26021: "適應每個查詢",
  26022: "深度研究",
  26023: "關於複雜主題的深入報告",
  26024: "搜索歷史會話",
  26025: "今天",
  26026: "本周",
  26027: "本月",
  26028: "本年",
  26029: "星期一",
  26030: "星期二",
  26031: "星期三",
  26032: "星期四",
  26033: "星期五",
  26034: "星期六",
  26035: "星期日",
  26036: "歷史會話",
  26037: "正在搜索，請稍候",
  26038: '剩餘智點數 {-num-}',
  26040: '僅支持10M以下的csv、xls、xlsx格式文件',
  26039: '智點'
}, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, "26040", '僅支持10M以下的csv、xls、xlsx格式文件'), 26050, '深度搜索時間較長，來杯咖啡，其他的事情交給智巢，等幾分鐘再回到這個界面...'), 26051, "開始搜索，請稍候"), 26052, "搜相似"), 26053, "搜索相似圖片"), 27000, "創建鏈接文件"), 27001, "鏈接"), 27002, "名稱"), 27003, "縮略圖"), 27004, "創建鏈接文件失敗"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 27005, "打開鏈接"), 27006, "創建鏈接文件成功"), 27007, "除管理員外的訪問者創建子素材庫需要審批"), 27008, "輸入一個鏈接地址"), 27009, "為鏈接文件指定個名字"), 27010, "鏈接格式錯誤"), 27011, "編輯鏈接文件"), 27012, "顯示子文件夾內容"), 27013, "編輯鏈接文件成功"), 27014, "文件大小超過5MB限制，請選擇較小的文件"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 27015, "編輯鏈接文件失敗"), 27016, "鏈接文件不支持下載"), 27017, "加密文件夾"), 27018, "創建加密文件夾"), 27019, "巴別鳥加密文件夾採用非對稱加密技術，你設定的密碼是唯一打開該文件夾的方式。"), 27020, "請填寫名稱"), 27021, "點此輸入文件夾名稱"), 27022, "請妥當保管好你的密碼"), 27023, "密碼丟失後無法找回！並且密碼丟失後也無法恢復該文件夾裡的文件"), 27024, "點此輸入你的密碼"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 27025, "再次輸入你的密碼"), 27026, "密碼要求為6-20位大小寫字母或數字的組合"), 27027, "*文件夾加密後裡面的文件不能同步或者在映射盤訪問"), 27028, "請輸入6-20位包含大小寫字母或數字的組合"), 27029, "請輸入加密文件夾密碼"), 27030, "請輸入加密文件夾《{-name-}》密碼"), 27031, ""), 27032, ""), 27033, ""), 27100, "將企業文件版本保留時間設置為 {-time-} 天"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 27101, "將企業文件版本保留個數設置為 {-num-} 個"), 28000, "自動化任務"), 28001, "查看現有任務清單"), 28002, "自動清理檔案"), 28003, "自動重命名"), 28004, "自動轉PDF"), 28005, "自動整理檔案"), 28006, "可設定任務，按特定規則删除指定資料夾中的檔案。"), 28007, "上傳到指定資料夾中的檔案自動按照設定的規則自動重命名。"), 28008, "上傳到指定資料夾中的檔案可自動生成PDF副本。 "), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 28009, "在指定的資料夾中按預置的規則分類及整理檔案。"), 28010, "任務"), 28011, "自動清理資料夾"), 28012, "新建自動清理資料夾"), 28013, "選擇目標資料夾"), 28014, "點擊選擇一個資料夾"), 28015, "包括所有子資料夾中的檔案"), 28016, "如子資料夾也設定了清理任務，則清理任務疊加"), 28017, "選擇清理觸發條件"), 28018, "下拉式功能表提示：選擇觸發條件"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 28019, "更改資料夾"), 28020, "該任務建立後"), 28021, "檔案進入該資料夾（文件上傳後）"), 28022, "檔案數量"), 28023, "資料夾大小"), 28024, "僅刪除檔，不删除子資料夾"), 28025, "選擇觸發條件"), 28026, "選擇定時管道"), 28027, "固定時間間隔"), 28028, "按週期"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 28029, "全部檔案（默認）"), 28030, "特定大小"), 28031, "特定檔案類型"), 28032, "關鍵字"), 28033, "重複檔案"), 28034, "自動删除該檔案"), 28035, "每隔"), 28036, "選擇刪除檔範圍"), 28037, "自動清空資料夾"), 28038, "删除檔名包含以下關鍵字的檔案"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 28039, "內容一致的檔案只保留一個"), 28041, "在此處填寫需要刪除文件的文件名所包含的關鍵字，以“,”分隔"), 28040, "\u5728\u6B64\u8655\u586B\u5BEB\u9700\u8981\u522A\u9664\u6A94\u985E\u578B\u7684\u526F\u6A94\u540D\uFF0C\u591A\u500B\u526F\u6A94\u540D\u4E4B\u9593\u4EE5 \",\"\u5206\u9694\u4F8B\u5982\uFF1Ajpg\uFF0Cpng\uFF0Cmp4\uFF08\u4E0D\u5340\u5206\u5927\u5C0F\u5BEB\uFF09"), "28041", "\u5728\u6B64\u8655\u586B\u5BEB\u9700\u8981\u522A\u9664\u6A94\u7684\u6A94\u540D\u6240\u5305\u542B\u7684\u95DC\u9375\u5B57\uFF0C\u4EE5 \",\"\u5206\u9694"), 28042, "自動删除特定大小的檔案"), 28043, "删除大小"), 28044, "到"), 28045, "的檔案"), 28046, "自動删除以下副檔名的檔案"), 28047, "每天"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 28048, "每週日"), 28049, "清除頻率"), 28050, "每月第一個周日"), 28051, "每年12月31日"), 28052, "選擇時間"), 28053, "時間"), 28054, "包含子資料夾中的檔案"), 28055, "檔案總數量超過"), 28056, "填寫觸發條件數位，最小1最大99999"), 28057, "檔案總大小超過"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 28058, "請選擇清理觸發條件"), 28059, "編輯自動清理"), 28060, "秒"), 28061, "年"), 28062, "目標資料夾"), 28063, "取消該任務"), 28064, "暫無自動化任務"), 28065, "自動化任務清單"), 28066, "資料夾名稱（任務名）"), 28067, "任務類型"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 28068, "自動清理"), 28069, "你是否要取消該自動化任務，不再執行"), 28070, "自動化"), 28071, "創建自動重命名任務"), 28072, "自動重命名"), 28073, "檔案添加到以下資料夾後自動重命名"), 28074, "應用於現有檔案"), 28075, "如果檔案超過5000個，則不適用"), 28076, "示例檔名"), 28077, "並非所有規則或中繼資料都適用於或可用於每個檔案或檔案類型。"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 28078, "選擇規則"), 28079, "標準選項"), 28080, "編號"), 28081, "自定義內容"), 28082, "檔案上傳者"), 28083, "檔案負責人"), 28084, "上級資料夾"), 28085, "上傳時間"), 28086, "媒體中繼資料"), 28087, "拍攝日期"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 28088, "相機製造商"), 28089, "相機型號"), 28090, "鏡頭型號"), 28091, "尺寸"), 28092, "每英寸點數（DPI）"), 28093, "每釐米點數（DPCM）"), 28094, "添加規則"), 28095, "選擇修改檔名規則"), 28096, "替換內容"), 28097, "删除內容"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 28098, "删除字元"), 28099, "原始檔名"), 28100, "輸入要替換的關鍵字"), 28101, "輸入替換的內容"), 28102, "輸入要删除的內容"), 28103, "檔名中的空格"), 28104, "檔名中的數位"), 28105, "檔名中的引號"), 28106, "檔名中的破折號及底線"), 28107, "起始："), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 28108, "增量："), 28109, "位數："), 28110, "起始：表示第一位編號\n增量：新增的數位\n位數：編號的位數"), 28111, "點擊填寫自定義內容"), 28112, "年-月-日"), 28113, "年-月"), 28114, "年月日"), 28115, "年-月-日-小時.分鐘"), 28116, "年月日-小時.分鐘"), 28117, "月-日-小時.分鐘.秒"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 28118, "替換在檔名中檢測到的日期"), 28119, "大小寫轉換"), 28120, "首字母大寫"), 28121, "首字母小寫"), 28122, "全部大寫"), 28123, "全部小寫"), 28124, "字詞分隔符號"), 28125, "空格"), 28126, "底線"), 28127, "破折號"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 28128, "編輯自動重命名任務"), 28129, "新建自動整理"), 28130, "進行檔案整理"), 28131, "編輯自動整理任務"), 28132, "選擇整理規則"), 28133, "按月分類"), 28134, "按添加到網盤的月份創建資料夾並移動檔案到改資料夾"), 28135, "按年分類"), 28136, "按添加到網盤的年份創建資料夾並移動檔案到改資料夾"), 28137, "關鍵字分類"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 28138, "根據檔名中包含的特定關鍵字移動檔案到特定資料夾"), 28139, "按檔名中包含的關鍵字把檔案進行分類，按關鍵字任務先後順序進行處理"), 28140, "添加關鍵字分類"), 28141, "將檔案移動至"), 28142, "選擇資料夾"), 28143, "輸入關鍵字"), 28144, "資料夾名字"), 28145, "請選擇資料夾"), 28146, "關鍵字不能重複"), 28147, "檔案添加到選定的目錄後可以自動轉換為PDF檔案"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 28148, "新建自動轉PDF"), 28149, "編輯自動轉PDF"), 28150, "選擇轉PDF的檔案類型"), 28151, "所有支持的檔案"), 28152, "轉為PDF"), 28153, "超過30M的檔案將不會轉換"), 28154, "轉換成功後删除原檔案"), 28155, "圖片類"), 28156, "檔案類"), 28157, "圖形類"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 28158, "取消全選"), 28159, "選擇了{-exts-}{-num-}種檔案類型"), 28160, "選擇了{-exts-}…等{-num-}種檔案類型"), 28161, "請選擇轉PDF的檔案類型"), 28162, "應用於新的上傳文件"), 28163, "輸入目前的目錄要蒐索的檔名"), 28164, "保留兩位小數"), 28165, "你沒有許可權將當前資料夾中的檔案移入目標資料夾"), 28166, "你可以選擇下面任意一名或多名審批人來審批你的分享請求,其中任意一名通過你的請求後系統會自動發送邀請"), 28167, "你邀請的共享人有外部使用者，需要通過審批後才能分享。你可以填寫擬邀請人員來發送邀請請求"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 28168, ""), 28169, ""), 28170, "創建簽章"), 28171, "可以在網盤上蓋章簽署文件，支持多種文件類型，簽章文件可導出為PDF"), 28172, "如何使用簽章？"), 28173, "點擊查看簽章教程"), 28174, "批量創建文件夾"), 28175, "按要求導入 excel 文件批量創建文件夾"), 28176, "選擇要批量創建文件夾的目標目錄，項目只能創建於部門文件夾及個人文件根目錄下"), 28177, "選擇創建的文件夾類型"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 28178, "導入文件夾名列表"), 28179, "文件夾名以換行分隔，一行一個文件夾名。支持導入的文件類型為 xls、xlsx，最大限制 5000 行"), 28180, "項目文件夾"), 28181, "下載模版後按模版填寫，項目負責人為空默認創建者為項目負責人，項目文件夾名以換行分隔，一行一個文件夾名。項目負責人為郵箱及手機號，支持導入的文件類型為 xls、xlsx、csv，最大限制 5000 行。"), 28182, "點擊此處下載批量創建項目文件夾模版"), 28183, "點擊此處下載批量創建文件夾模版"), 28184, "點擊或拖拽文件上傳"), 28185, "開啟敏感內容識別"), 28186, "含敏感內容文件列表"), 28187, "自定義敏感詞"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 28188, "在此輸入你需要識別的敏感詞"), 28189, "敏感內容識別"), 28190, "在上方輸入你需要識別的敏感詞，500個詞及以內，每個詞不超過10個字符，使用“,”或空格進行分隔"), 28191, "上傳敏感詞庫"), 28192, "點擊上傳按鈕上傳敏感詞庫，上傳後30分鐘內生效。"), 28193, "文件為TXT格式，500個詞及以內，每個詞不超過10個字符，文件大小100KB以內，UTF-8(無BOM)編碼，使用“,”或空格、換行進行分隔。"), 28194, "含敏感詞文件處理策略"), 28195, "僅標記（把含敏感詞的文件進行標記）"), 28196, "禁止查看及編輯（替換為敏感詞警告畫面）"), 28197, "禁止分享（含敏感詞文件的分享將會被自動關閉）"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 28198, "含敏感詞文件列表"), 28199, "請輸入文件名稱或關鍵詞進行查詢"), 28200, "未上傳"), 28201, "刪除文件"), 28202, "文件所屬"), 28203, "暫無包含敏感詞的文件"), 28204, "請上傳 .txt 文件！"), 28205, "重新上傳"), 28206, "你上傳的敏感詞庫不符合系統要求，請按要求整理後重新上傳"), 28207, "對外分享不需要審批"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 28208, "開啟後邀請分享可以輸入企業成員外郵箱及手機號，並開啟外鏈分享"), 28209, "對外分享需要審批"), 28210, "添加用戶對外分享時可以選擇的審批人，點擊添加審批人員"), 28211, "點擊添加審批人員"), 28212, "審批人員列表"), 28213, "確定從審批人員中移除該用戶？"), 28214, "選擇審批人"), 28215, "允許部門對外分享"), 28216, "審批人員列表最多可以容納5名成員"), 28217, "你可以選擇下面任意一名或多名審批人來審批你的分享請求，其中任意一名通過你的請求後系統後會自動發送邀請"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 28218, "你邀請的共享人有外部用戶，需要通過審批後才能分享。"), 28219, "請先上傳創建所需模板文件"), 28220, "模板文件解析失敗"), 28221, "正在解析模板文件"), 28222, "導入的文件夾名"), 28223, "共導入了{-total-}個文件夾，其中有{-num-}個文件夾因為文件名不符合要求導入失敗"), 28224, "開始創建"), 28225, "該文件為敏感文件，已被限制"), 28226, "企業發佈"), 28227, "請選擇審批人"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 28228, "管理工具"), 28229, "鏈接分享關閉後，再次開啟需要經過文件管理審批，你確定關閉此鏈接分享嗎？"), 28230, "未命名節點(可右鍵重命名)"), 28231, "你可以在文件目錄節點上右鍵打開菜單項，進行新建，刪除，重命名操作，創建失敗的可以編輯後嘗試重新創建"), 28232, "正在創建中，請等待完成後重試"), 28233, "（已忽略）"), 28234, "確定忽略該文件？該操作不可逆。"), 28235, "確定要刪除該文件嗎?"), 28236, "自定義敏感詞發生了變化，是否保存到服務器"), 28237, "請上傳.xlsx, .xls文件"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 28238, "上傳的目錄結構是空的，請編輯後重新上傳"), 28239, "自定義敏感詞中含有特殊符號"), 28240, "不允許對外分享"), 28241, "禁止用戶自己修改個人信息"), 28242, "打開此選項，企業成員無法通過設置界面自己更改個人信息"), 28243, '設置此選項後，對於用戶個人文件分享，這裡的配置將會覆蓋掉企業設置的"禁止分享文件給企業外用戶"配置結果'), 28244, "(企業允許)"), 28245, "(企業不允許)"), 28246, "(繼承上級部門設置)"), 28247, "企業禁止修改此項資訊"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 28248, "檔案包含管理員設定的敏感詞，禁止訪問"), 28249, "僅企業版支持此功能"), 28250, "免費版不支持此功能。可升級至專業版或企業版使用此功能"), 28300, "選擇水印類型"), 28301, "水平平鋪"), 28302, "居中單幅"), 28303, "輸入自定義文字作為水印內容，支持多終端同步展現。"), 28304, "上傳透明背景的PNG圖片效果最佳，請註意控制原圖尺寸。"), 28305, "使用圖形（矢量）水印"), 28306, "使用圖形化矢量編碼承載 Hex 特徵碼，截圖後仍可通過顯影和編碼表回溯識別。"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 28307, "特徵碼(Hex，8位)"), 28308, "對抗形態引擎"), 28309, "自然可識別系列"), 28310, "Anti-AI 隱蔽防護系列"), 28311, "測試模式"), 28312, "明暗反差自適應（高性能）"), 28313, "明暗對比雙描邊點"), 28314, "灰白浮雕點（低打擾）"), 28315, "深海藍描邊點"), 28316, "暖金描邊點"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 28317, "紋理偽裝探針（低可見）"), 28318, "殘留冗餘碎片（顯影優先）"), 28319, "主體耦合紋理（抗識別）"), 28320, "黑白高對比測試"), 28321, "AI 去除防護聲明（截圖保留）"), 28322, "明示層：可與編碼疊加。若模型仍嘗試處理水印，優先暴露的是聲明層，Anti-AI 圖形編碼應繼續偽裝在畫面紋理中並可通過顯影追蹤。"), 28323, "泄漏追蹤顯影入口"), 28324, "返回圖形（矢量）水印設置"), 28325, "上傳疑似泄漏截圖後，系統會按當前水印模式降低背景干擾，並增強接近水印配色、描邊和局部擾動的區域，便於對照編碼表識別特徵碼。"), 28326, "編碼對應表"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 28327, "上傳泄漏截圖 (開始顯影)"), 28328, "顯影優化方式"), 28329, "明暗反差自適應"), 28330, "灰白浮雕點（低打擾）"), 28331, "顯影提純嚴苛度"), 28332, "未上傳圖片。上傳後可在右側查看顯影結果，並先找 3 點同步位，再按其後的 3x3 點簇對照編碼表讀取 Hex 編碼。"), 28333, "編碼查詢"), 28334, "輸入編碼片段、通配符、文件名或分享人"), 28335, "支持模糊查詢：識別出至少 2 個編碼字符即可查。通配符中 * 代表任意多位未知字符，? 代表 1 位未知字符，例如 *A?2 或 *A*2*；也支持文件名、分享人、接收方模糊查詢。當前為界面示例數據。"), 28336, "顯影編碼對應表"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 28337, "請拖拽圖片到此處，或點擊選擇"), 28338, "選擇圖片"), 28339, "顯影圖"), 28340, "原圖"), 28341, "適應"), 28342, "請拖拽泄漏截圖到此處，或點擊選擇"), 28343, "選擇泄漏截圖"), 28344, "上傳疑似泄漏截圖並進行顯影提純，便於識別圖形（矢量）水印中的 Hex 特徵碼。"), 28345, "水印密度"), 28346, "物理縮放（短邊比例）"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 28347, "散布隨機度"), 28348, "抗去除擾動強度"), 28349, "圖形水印採用模塊格子排布。"), 28350, "更新水印設置"), 28351, "查詢失敗，請稍後重試。"), 28352, "未找到匹配記錄。可嘗試輸入更短的編碼片段。"), 28353, "當前預覽人員"), 28354, "用戶ID："), 28355, "分享者"), 28356, "編碼 "), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 28357, "文件ID："), 28358, "允許用戶自定義分享文件水印"), 28359, "開啟後，用戶在分享文件时無法自定義水印設置"), 28360, "水印顯示範圍"), 28361, "僅預覽模式"), 28362, "所有頁面"), 28363, "水印顯示範圍設置成功"), 28364, "水印顯示範圍設置失敗，請稍後重試"), '27102.0', ' 在企業後台 {-Prohibited_allowed-} 分享個人私有文件'), '27102.1', ' 在企業後台 {-Open_close-} 顯示組裝結構'), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, '27102.2', ' 在企業後台 {-Prohibited_allowed-} 對外分享文件'), '27102.3', ' 在企業後台 {-Open_close-} 企業發佈文件夾'), '27102.4', ' 在企業後台 {-Open_close-} 用戶停用自動關閉該用戶開啟的企業文件分享鏈接的功能'), '27102.5', ' 在企業後台 {-Prohibited_allowed-} 匿名分享'), '27102.6', ' 在企業後台 {-Open_close-} 動態通知功能'), '27102.7', ' 在企業後台 {-Prohibited_allowed-} 使用系統分享權限'), '27102.8', ' 在企業後台 {-Open_close-} mac 地址雙向綁定的功能'), '27102.9', ' 在企業後台 {-Open_close-} 顯示企業簡稱的功能'), '27102.10', ' 在企業後台 {-Open_close-} 對沒有下載權限的用戶關閉顯示縮略圖的功能'), '27102.11', ' 在企業後台 {-Open_close-} 定期強制修改舊密碼的功能'), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, '27102.12', ' 在企業後台 {-Open_close-} 計算搜索權限'), '27102.13', ' 在企業後台 {-Open_close-} 自動解鎖'), '27102.15', ' 在企業後台 {-Open_close-} 自定義個人信息功能'), '27102.16', ' 在企業後台 {-Open_close-} 視頻預覽功能'), '27102.17', ' 在企業後台 {-Open_close-} 分享水印自定義功能'), '27102.18', ' 在企業後台 {-Open_close-} 全頁面水印功能'), '27103.0', '在企業後台 {-Open_close-} 共同發佈文件夾的顯示功能'), '27103.1', '在企業後台 {-Open_close-} 隱藏組織結構的功能'), '27103.2', '在企業後台 {-Open_close-} 允許用戶上傳個人文件的配置項'), '27103.3', '在企業後台 {-Open_close-} 允許用戶分享個人文件的配置項'), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, '27103.4', '在企業後台 {-Open_close-} 發送郵箱通知的配置項'), '27103.5', '在企業後台 {-Open_close-} 隱藏管理員日誌的功能'), 'Open_close.0', '開啟了'), 'Open_close.1', '關閉了'), 'Prohibited_allowed.0', '禁止了'), 'Prohibited_allowed.1', '允許了'), '27104.1', '{-somebody-} 在素材庫中修改了分類 {-files-} 如下設置:{-fileChanges-}'), '27104.2', '{-somebody-} 在素材庫中修改了子庫 {-files-} 如下設置:{-fileChanges-}'), 'MATERIAL_OP_NAME', {
  1: '修改可見性',
  2: '修改訪問規則',
  4: '添加助理',
  8: '添加成員',
  16: '添加授權人員',
  32: '修改限定部門名單',
  64: '修改管理員名單',
  128: '修改文件黑/白名單',
  256: '移除成員',
  512: '移除授權人員'
}), '27105', '{-somebody-} 修改了鏈接文件 {-file-} 的屬性'), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, '27106', '鏈接文件不支持下載，下載已忽略所有鏈接文件'), 30000, '輕文檔'), 40000, "為您推薦"), 40001, "根據您的活動內容建議"), 40002, "最近訪問"), 40003, "最近關注"), 40004, "暫無推薦內容"), 40005, "點擊預覽"), 40006, "附言："), 40007, "關閉智能推薦"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 40008, "關閉後，將不會在該區域顯示智能推薦，你可以在設置界面再次打開智能推薦"), 40009, "請輸入加密文件夾密碼"), 40010, "知道了"), 40011, "去設置"), 40012, '導出為word'), 40020, "對企業名稱進行了如下設置，{-nameChanges-}"), 40021, '自動解鎖'), 40022, '如果關閉此項，該鎖只能等待用戶編輯結束自動解鎖，或者管理員強制手動解鎖。打開此項，則超過 2 個小時的鎖會自動解鎖'), 'set_ent_name', '全稱修改為: {-name-}'), 'set_ent_short_name', '簡稱修改為: {-name-}'), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 40050, "{-count-}個檔案"), 40051, "項目所在目錄沒有可選項目"), 40061, "向右滑動完成驗證"), 40052, "現時已下載"), 40053, "現時已删除"), 40054, "現時已上傳"), 40055, "現時已列印"), 40070, "禁止用戶線上預覽視頻檔案"), 40071, "打開此選項，企業成員無法線上預覽視頻檔案"), 40072, "本企業禁止了線上預覽視頻檔案，請聯系管理員"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 40073, "允許使用用戶端同步"), 40074, "打開此選項，該成員可以使用用戶端同步檔案"), 40075, "本企業禁止了用戶端同步檔案，請聯系管理員"), 40076, "輸入分組名稱"), 40077, "蒐索分組名稱"), 40078, "當前共有{-num-}個分組"), 40079, "輸入昵稱，郵箱，手機號，或分組名"), 40080, "輸入昵稱，郵箱，手機號，部門或分組名"), 40090, "確定從審批人員中移除該分組？"), 40091, "企業對外分享檔案受控，暫不允許選擇個人分組"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 40092, "獲取審批信息失敗,你沒有查看該審批的權限"), 40093, "查看附言"), 40100, "資料夾圖標"), 40101, "更改資料夾圖標"), 40102, "選擇圖標替換"), 40103, "上傳自定義圖標"), 40104, "應用到子資料夾"), 40105, "應用到相同類型資料夾（僅超管）"), 40106, "示例資料夾"), 40107, "支持PNG、SVG、JPG"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 40108, "圖片分辯率高於60*60PX，最大為2MB"), 40109, "自定義icon"), 40110, "效果預覽"), 40111, "你確定要删除該自定義檔案圖標嗎？"), 40112, "恢復默認圖標"), 40113, "你確定要恢復默認的檔案圖標嗎？"), 40114, "請輸入自定義浮水印"), 40115, "自定義浮水印設定成功"), 40116, "使用默認浮水印"), 40117, "自定義浮水印"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 40118, "獲取下載地址"), 40119, "生成{-name-}的下載連結"), 40120, "<strong>安全提示：</strong>此連結為直接訪問連結，任何人獲取該連結後均可直接下載或讀取此檔案，無需登入。 請謹慎分享。 "), 40121, "檔案下載連結："), 40122, "連結配寘："), 40123, "連結有效期"), 40124, "最大下載次數"), 40125, "7天有效"), 40126, "30天有效"), 40127, "輸入有效天數"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 40128, "不限制"), 40129, "10次"), 40130, "50次"), 40131, "100次"), 40132, "輸入有效次數"), 40133, "自定義…"), 40134, "連結複製成功"), 40135, "獲取連結失敗，該檔案不支持匿名下載！"), 40136, "你確定要將對應資料夾圖標恢復至系統默認圖標嗎？"), 40137, "已下載"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 40138, "有效下載次數為0，該連結已失效"), 40139, "浮水印文字"), 40140, "斜角平鋪"), 40141, "你可以在目錄上右鍵創建新的資料夾"), 40142, "檔案庫"), 40143, "檔案索引"), 40144, "分類索引"), 40145, "常用入口"), 40146, "未分類"), 40147, "最多訪問"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 40148, "最新歸檔"), 40149, "檔案分類審批"), 40150, "申請創建分類"), 40151, "編輯分類"), 40153, "新建子分類"), 40154, "删除分類"), 40155, "你確定要删除該分類嗎？"), 40156, "分類名稱"), 40157, "分類路徑"), 40158, "請輸入分類名稱"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 40159, "為檔案設定分類"), 40160, "審批分類請求"), 40161, "申請分類檔案清單"), 40162, "沒有檔案的分類申請"), 40163, "分類不能為空"), 40164, "{-somebody-} 在檔案庫 {-parent-} 中建立了分類 {-sub-}"), "40165", "搜尋分類..."), "40166", "搜尋資料夾..."), "40167", "清空搜尋"), "40168", "請輸入其他關鍵詞或清空搜尋框以檢視全部"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, "40169", "未找到包含{-name-}的分類"), 40170, ""), 40171, ""), 40172, ""), 40173, ""), 40244, "你為檔案庫建立的分類 <span class=\"main-color\">{-name-}</span> 已被管理員刪除"), 40245, "審核結果"), 40246, "審核人"), 40247, "審核時間"), 40248, "管理員將你提交的文件{-files-}最終保存到如下分類中：{-classifications-}"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 40249, "管理員處理了你提交的{-fileName-}{-etc-}文件的分類請求，"), 40250, "等"), 40251, "文件列表"), 40252, "新增的分類"), 40253, "刪除的分類"), 40254, "文件分類請求詳情"), 40255, "管理員處理了你的文件分類申請，結果如下："), 40256, "你的文件元數據修改申請已被{-reviewerName-}審核，結果：{-status-}"), 40257, "自訂元數據篩選"), 40258, "清除"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 40260, "確定"), 40261, "從"), 40262, "到"), 40263, "請選擇"), 40264, "區間"), 40265, "文本"), 40266, "單選"), 40267, "多選"), 40268, "暫無子選項"), 40269, "輸入關鍵字"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 40270, "請輸入內容"), 40271, "請輸入有效的數字"), 40272, "請輸入有效的整數"), 40273, "請選擇元數據"), 40274, "已選 {-num-} 項"), 40275, "發送人"), 40276, "檔案名"), 40277, "搜尋條件未變更"), 40278, "搜尋失敗，請稍後重試"), 40279, "載入下一頁失敗，請稍後重試"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 40280, "最小值不能大於最大值"), 40281, "請輸入有效的日期"), 40282, "企業目前未定義文件元數據，請到企業後台進行設置"), 40283, "企業目前未定義文件元數據，如果需要自定義元數據，請聯繫管理員在企業後台設置"), 40284, "去後台設置"), 40285, "{-applicantName-}申請對以下文件設置自定義元數據"), 48287, "公有雲暫不支持此功能，該水印目前僅支持私有化部署，歡迎垂詢客服人員。"), 42888, "點擊查看完整路徑"), 42889, "沒有自訂元數據"), 42890, "提示：企業還沒有設定檔案自訂元數據"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50100, "建立問卷"), 50101, "建立新的 Formbricks 問卷"), 50102, "複製並編輯"), 50103, "複製並編輯介面尚未接入"), 50104, "問卷測試資料已建立：{-name-}"), 50105, "問卷"), 50106, "新建問卷"), 50107, "待發佈"), 50108, "關閉問卷"), 50109, "查看表單"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50110, "草稿"), 50111, "進行中"), 50112, "已暫停"), 50113, "已完成"), 50114, "選擇問卷的保存位置"), 50115, "問卷名稱"), 50116, "請輸入問卷名稱"), 50117, "調查問卷"), 50118, "我的文件"), 50120, "僅查看備份策略"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50121, "強制備份"), 50122, "企業備份策略與終端管理"), 50123, "重新整理狀態"), 50125, "備份策略"), 50126, "人員與客戶端"), 50127, "備份文件"), 50128, "操作日誌"), 50129, "尚未獲取到企業備份根目錄，請稍後重試。"), 50130, "開啟備份根目錄？"), 50131, "即將在新的標籤頁開啟「企業掃描備份根目錄」。"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50132, "執行中的策略"), 50134, "{-num-} 項草稿"), 50135, "受管設備"), 50136, "/ {-num-} 台"), 50137, "異常設備"), 50138, "台"), 50139, "{-num-} 個文件待處理"), 50140, "累計備份文件"), 50142, "{-size-} 已安全留存"), 50143, "{-num-} 台設備備份異常，{-num2-} 個文件尚未成功上傳。已完成的雲端備份不受影響。"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50144, "查看異常"), 50145, "關閉提醒"), 50146, "統計載入中…"), 50150, "策略詳情"), 50151, "策略不存在"), 50152, "策略編號"), 50153, "執行範圍"), 50154, "（含全部子部門）"), 50155, "帳號與設備"), 50156, "{-users-} 個帳號 · {-assigned-} 台已分配設備 · {-waiting-} 個帳號未接入"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50157, "後續接入"), 50158, "僅針對所選設備，不自動覆蓋該帳號其他電腦"), 50159, "所選帳號後續接入的 Windows 設備自動匹配此策略"), 50160, "備份目錄"), 50161, "掃描磁碟"), 50162, "所有本機固定磁碟"), 50163, "{-drives-} 盤"), 50165, "{-list-}、無擴展名文件"), 50166, "執行方式"), 50167, "實時備份 · 開機補掃 · 每日 {-time-} 校驗"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50168, "上傳限制"), 50169, "{-bw-} MB/s · 單文件 {-size-} MB"), 50170, "最近更新"), 50175, "撤銷待確認"), 50176, "v{-ver-} 已生效"), 50177, "等待 v{-ver-} 回執"), 50178, "待客戶端接入"), 50179, "尚無客戶端"), 50180, "目標設備"), 50181, "版本已確認"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50183, "備份配置"), 50184, "員工不可暫停或退出執行器"), 50185, "本機刪除，雲端保留"), 50186, "員工無權刪除雲端備份"), 50187, "撤銷回執"), 50188, "下發回執"), 50189, "尚未向設備下發此策略。"), 50190, "未接入客戶端的帳號（{-num-}）"), 50191, "編輯策略"), 50250, "全部狀態"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50251, "執行中"), 50253, "待客戶端生效"), 50256, "搜尋策略名稱、文件類型或執行範圍"), 50258, "共 {-num-} 項策略"), 50259, "匯出策略清單？"), 50260, "將按當前篩選條件匯出 {-num-} 條策略記錄（CSV 文件）。"), 50261, "確認匯出"), 50266, "帳號數"), 50267, "設備數"), 50268, "擴展名白名單"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50271, "強制備份-策略"), 50272, "匯出清單"), 50273, "策略列表"), 50274, "匯出當前篩選的 {-num-} 條記錄"), 50275, "已匯出 {-num-} 條記錄"), 50276, "複製為新策略"), 50277, "停用策略"), 50278, "刪除草稿"), 50279, "刪除策略"), 50280, "停用此備份策略？"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50281, "停用後該策略不再執行新的備份。已上傳文件與歷史版本全部保留，不刪除企業雲端數據。"), 50282, "已上傳文件與歷史版本全部保留，不刪除企業雲端數據。"), 50283, "繼續備份"), 50284, "確認停用"), 50285, "策略已停用；雲端備份繼續保留。"), 50286, "停用失敗，請稍後重試。"), 50287, "停用指令已記錄，等待設備確認；雲端備份繼續保留。"), 50288, "刪除未發佈的草稿？"), 50289, "刪除已停用的策略？"), 50290, "{-name-} 尚未下發，不影響客戶端和雲端備份。"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50291, "{-name-} 已停用，刪除後策略配置不可恢復；已備份文件與歷史版本全部保留。"), 50292, "草稿已刪除"), 50293, "策略已刪除"), 50294, "刪除失敗，請稍後重試。"), 50400, "沒有找到策略"), 50401, "調整篩選條件，或新建一項備份策略。"), 50404, "備份文件類型"), 50405, "策略狀態"), 50406, "設備回執"), 50409, "企業文件/備份文件夾"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50411, "企業文件 / {-target-}"), 50413, "{-users-} 個帳號 · {-devices-} 台設備"), 50414, "含子部門"), 50415, "{-num-} 個帳號待客戶端接入"), 50416, "無擴展名"), 50417, "僅上傳所選類型"), 50418, "{-num-} 台已生效"), 50419, "暫無設備，未下發"), 50420, "尚未下發"), 50421, "{-num-} 台待撤銷確認"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50423, "發佈"), 50425, "更多操作"), 50551, "備份內容"), 50553, "確認下發"), 50554, "編輯備份策略"), 50555, "新建備份策略"), 50556, "管理員配置 · 客戶端受管執行"), 50557, "放棄修改？"), 50558, "當前修改尚未保存，退出後將丟失。"), 50559, "繼續編輯"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50560, "放棄修改並退出"), 50562, "例如：研發文件持續備份"), 50563, "雲端備份目錄"), 50564, "選擇目錄"), 50565, "已發佈策略不遷移歷史目錄；調整目標目錄請新建策略。"), 50566, "僅可選擇企業管理的目錄，員工無刪除、移動及對外分享權限。"), 50567, "目錄結構：帳號 + 設備名"), 50568, "帳號（帳號 ID）"), 50569, "設備名（設備 ID）"), 50570, "C盤 / Users / 原始路徑 / 文件"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50571, "單設備、多設備使用相同目錄規則；同帳號的不同電腦分開留存，同名設備以設備 ID 區分。已有歷史備份不遷移。"), 50572, "備註（選填）"), 50573, "策略用途或管理說明"), 50574, "僅上傳備份"), 50576, "員工不可停用"), 50577, "掃描範圍"), 50579, "指定盤符"), 50580, "{-disk-}盤"), 50581, "不包含流動硬碟、網絡映射盤和巴別鳥虛擬盤；自動跳過系統、資源回收筒及客戶端快取目錄。"), 50582, "需要備份的文件類型"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50583, "（擴展名白名單）"), 50584, "其他擴展名，例如 cad、tar.gz"), 50586, "只備份已選擴展名，未選類型不上傳；不區分大小寫，支援複合擴展名。"), 50587, "同時備份無擴展名文件"), 50588, "文件匹配測試"), 50589, "年度合同.docx"), 50591, "運行設定"), 50592, "上傳限速（MB/s）"), 50593, "單文件上限（MB）"), 50594, "每日低峰校驗"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50595, "實時監聽與開機補掃始終開啟；文件佔用或離線時保留隊列，恢復後繼續上傳。"), 50596, "點擊移除"), 50597, "已選 {-num-} 個："), 50598, "正在載入帳號…"), 50599, "沒有匹配的帳號"), 50600, "正在載入部門…"), 50601, "沒有匹配結果"), 50602, "正在載入分組…"), 50604, "展開子部門"), 50605, "隨父部門加入"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50606, "{-num-} 人"), 50609, "已有策略"), 50610, "未分配"), 50611, "個部門"), 50612, "個帳號"), 50613, "個分組"), 50614, "台設備"), 50615, "選擇備份帳號或設備"), 50616, "按部門"), 50617, "按帳號"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50618, "按分組"), 50619, "按設備"), 50621, "搜尋姓名或帳號"), 50622, "搜尋分組"), 50623, "搜尋帳號或設備名"), 50624, "包含所選部門的全部子部門"), 50625, "僅對所選設備生效，不自動納入同帳號其他設備。"), 50626, "按帳號範圍覆蓋名下全部 Windows 設備，包括後續接入的新設備。"), 50627, "尚未填寫"), 50628, "帳號數量"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50629, "設備數量"), 50630, "後續設備"), 50631, "僅所選設備"), 50632, "帳號下新接入的 Windows 設備自動匹配"), 50633, "範圍數量"), 50634, "雲端目錄"), 50635, "帳號 / 設備名（設備 ID） / 盤符 / 原始路徑"), 50637, "{-disks-} 盤"), 50639, "無擴展名文件"), 50640, "實時監聽 · 開機補掃 · {-time-} 每日校驗"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50641, "資源限制"), 50642, "{-bandwidth-} MB/s · 單文件 {-size-} MB"), 50643, "發佈版本"), 50644, "固定保護規則"), 50645, "僅上傳命中文件，不生成空目錄"), 50646, "本機刪除或改名不刪除雲端原件"), 50647, "員工不能暫停、修改或解除備份"), 50648, "前台退出帳號不停止備份任務"), 50649, "保留版本，數據歸企業所有"), 50650, "同帳號多設備的文件獨立留存"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50651, "發佈後策略進入下發隊列，執行範圍內的 Windows 客戶端接入後生效。"), 50652, "保存草稿"), 50653, "確認發佈並下發"), 50654, "草稿已保存，尚未向客戶端下發。"), 50655, "策略 v{-version-} 已加入下發隊列，等待客戶端確認。"), 50656, "帳號策略已保存，等待 Windows 客戶端接入，尚未生效。"), 50657, "未獲取到企業備份根目錄，請重新整理頁面後重試。"), 50658, "策略已建立並發佈，等待客戶端確認。"), 50659, "策略已更新並發佈，等待客戶端確認。"), 50660, "保存失敗，請稍後重試。"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50662, "請輸入需要備份的擴展名"), 50663, "請輸入有效擴展名，例如 docx 或 tar.gz，不使用 * 萬用字元。"), 50664, "請輸入文件名稱"), 50665, "命中白名單，將備份此類型文件。"), 50666, "未命中白名單，不上傳，也不因此建立雲端目錄。"), 50667, "選擇企業備份目錄"), 50668, "請選擇具體的企業文件夾"), 50850, "全部接入狀態"), 50851, "有客戶端在線"), 50852, "客戶端全部離線"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50853, "未接入客戶端"), 50854, "一個帳號多台設備"), 50855, "全部備份狀態"), 50856, "備份正常"), 50857, "正在備份"), 50858, "備份異常"), 50859, "等待生效"), 50861, "未分配策略"), 50865, "搜尋姓名、帳號或設備名稱"), 50866, "匯出人員"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50867, "未接入表示暫無 Windows 客戶端記錄，不等同於帳號停用或設備離線。"), 50868, "企業帳號"), 50870, "已接入 Windows 客戶端"), 50871, "人 / {-num-} 台設備"), 50872, "全部部門"), 50873, "匯出設備"), 50874, "帳號標識"), 50878, "客戶端接入"), 50879, "關聯設備數"), 50880, "在線數"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50881, "設備列表"), 50883, "設備編號"), 50885, "員工"), 50886, "客戶端連接"), 50887, "備份狀態"), 50888, "已上傳文件"), 50889, "已上傳位元組"), 50890, "最近成功備份"), 50891, "強制備份-{-type-}.csv"), 50893, "設備"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50895, "人員列表"), 50899, "關聯設備"), 50900, "{-num-} 台 Windows 設備 · {-num2-} 台在線"), 50903, "帳號備份目錄"), 50904, "客戶端 {-ver-}"), 50905, "最近心跳 {-time-}"), 50906, "{-num-} 個文件 · {-size-}"), 50907, "設備詳情"), 50908, "尚未接入 Windows 客戶端"), 50909, "當前帳號沒有 Windows 客戶端註冊記錄。僅使用網頁版不會生成設備備份任務。"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50910, "帳號策略已配置，等待客戶端接入後下發。"), 50911, "帳號與客戶端"), 50912, "此帳號的 Windows 客戶端"), 50913, "此帳號有多台設備。各設備獨立執行、回執和留存，不以最後登入設備替換其他設備。"), 50914, "客戶端註冊並關聯此企業帳號後才計入設備；未接入不等於離線，也不能據此判斷是否安裝過軟件。"), 50915, "目錄與設備歸屬"), 50916, "設備名（設備 ID） / C盤 / 原始路徑"), 50917, "設備名稱用於識別，帳號 ID 與設備 ID 用於穩定關聯；同名電腦仍分別保留備份。已有歷史目錄不自動移動。"), 50918, "{-num-} 台（當前為 {-id-}）"), 50919, "設備標識"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50920, "設備備份目錄"), 50921, "操作系統"), 50922, "執行策略"), 50923, "（目標 v{-ver-} / 已確認 v{-ver2-}）"), 50924, "尚未分配策略"), 50925, "最近心跳"), 50926, "最近備份"), 50927, "終端設備詳情"), 50928, "已備份文件"), 50930, "待上傳文件"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50931, "{-cmd-}。執行結果以客戶端下一次回執為準。"), 50932, "待處理異常"), 50933, "{-num-} 個文件"), 50934, "文件被其他程式獨佔。關閉佔用程式後客戶端將自動重試，也可發送重試請求。"), 50935, "執行器無法讀取受限目錄。請先由終端管理員檢查存取權限，再重試備份。"), 50936, "任務保護"), 50937, "員工不能修改或解除策略"), 50938, "前台登出不停止受管任務"), 50939, "僅上傳，不回傳本機刪除"), 50940, "雲端目錄歸企業所有"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50941, "此方案為客戶端受管任務。針對本機管理員強行結束程序或解除安裝的防護，仍需配合 Windows 服務及企業終端管控。"), 50943, "補掃文件"), 50944, "重試失敗文件"), 50945, "所選設備沒有可重試的失敗文件。"), 50946, "僅可向已分配策略的受管設備發起補掃。"), 50947, "補掃備份文件"), 50948, "向 {-num-} 台設備發送{-type-}請求。"), 50950, "補掃"), 50951, "只重試失敗文件，不重複上傳已完成文件。"), 50952, "按當前策略的擴展名白名單重新掃描，雲端文件不會被刪除。"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 50953, "{-num-} 台設備離線，請求將在重新連接後處理。"), 50954, "確認發送"), 50955, "請求已記錄，等待客戶端執行回執。"), 51050, "沒有符合條件的帳號或設備"), 51051, "姓名 / 帳號"), 51053, "Windows 客戶端"), 51055, "最近客戶端心跳"), 51056, "備份覆蓋"), 51058, "帳號 / 設備名"), 51061, "已備份"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 51063, "{-online-} 台在線 / {-total-} 台已接入"), 51064, "無 Windows 設備註冊記錄"), 51065, "尚無關聯設備"), 51066, "{-managed-} / {-total-} 台受管"), 51068, "尚未配置策略"), 51069, "尚無心跳"), 51071, "配置策略"), 51072, "同帳號多設備"), 51075, "心跳"), 51076, "{-count-} 個文件"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 51077, "{-count-} 個 · {-size-}"), 51078, "最近備份 {-time-}"), 51080, "已確認 v{-applied-} / 目標 v{-target-}"), 51200, "尚無記錄"), 51301, "客戶端在線"), 51302, "客戶端離線"), 51303, "企業文件 / 強制備份"), 51304, "盤"), 51305, "（{-text-}）"), 51306, "辦公文檔"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 51307, "設計源文件"), 51308, "研發文件"), 51321, "請輸入策略名稱。"), 51322, "策略名稱已存在，請使用不同名稱。"), 51323, "請選擇企業擁有的備份目錄。"), 51324, "請至少選擇一個需要備份的擴展名。"), 51325, "擴展名格式不正確，請填寫 docx、pdf 或 tar.gz，不使用萬用字元。"), 51326, "請至少選擇一個固定磁碟。"), 51327, "上傳限速請輸入 1 至 1024 MB/s。"), 51328, "單文件上限請輸入 1 至 2048 MB。"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 51329, "請選擇每日校驗時間。"), 51330, "請選擇至少一個帳號、部門或分組。"), 51331, "成功"), 51332, "撤銷策略，等待設備回執"), 51333, "策略 v{-ver-} 待確認"), 51334, "發佈策略"), 51335, "發佈 v{-ver-}，覆蓋 {-count-} 個帳號；{-dev-} 台設備待回執，{-wait-} 個帳號待客戶端接入"), 51336, "已生效策略請發佈新版本，不能直接覆蓋為草稿。"), 51338, "尚未向客戶端下發"), 51341, "停止新增備份；撤銷待客戶端確認，雲端文件與歷史版本全部保留"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 51342, "帳號不存在"), 51343, "請輸入設備名稱"), 51344, "此帳號存在策略衝突，需要管理員處理"), 51346, "已匹配策略 {-name-}，等待客戶端確認"), 51347, "已關聯帳號，尚未分配策略"), 51348, "策略 {-id-}"), 51351, "刪除未下發的策略或已停用策略"), 51352, "{-name-} - 副本"), 51353, "重試失敗文件待執行"), 51354, "補掃文件待執行"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_hk_part, 51355, "重試請求"), 51356, "補掃請求"), 51357, "已記錄請求，等待客戶端執行；未更改現有備份結果"), 51358, "待執行"), 51359, "企業文件 / 備份恢復 / "), 51360, "恢復申請"), 51361, "申請恢復 {-dev-} 的 v{-ver-} 至 {-path-}，原備份保持不變"), 51362, "待選擇執行範圍"), 51363, "全部 Windows 設備"), 51364, "該功能僅支援私有化部署，公有雲僅支援儲存草稿"), (0, _defineProperty2["default"])(_localString_hk_part, 51365, "企業未購買此模組，當前僅支援儲存草稿"));
var _default = exports["default"] = localString_hk_part3;

},{"1180":1180,"1184":1184,"1454":1454}],1161:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require(1180));
var _localString_cn_part;
var localString_cn_part2 = (_localString_cn_part = {
  5000: "簽名設置",
  5001: "報表類型",
  5002: "文件會簽",
  5003: "圖紙審核",
  5004: "添加附件",
  5005: "您可以在這裡自定義本企業文件的分享權限、項目可選權限及文件訪問控制權限。此處定義的權限會出現在上述功能的權限選擇列表中",
  5006: "搜索文件權限的名稱",
  //----------------6.6------------- 

  5007: "賬戶刪除後，其賬戶下的文件也將移除，執行此操作請慎重",
  5008: "受邀訪問記錄",
  5009: "受邀時間",
  5010: "個人文件",
  5011: "暱稱",
  5012: "黑色背景",
  5013: "白色背景",
  5014: "默認背景",
  5015: "旋轉90",
  5016: "添加簽名",
  5017: "改變背景顏色僅對透明背景的作品有效!",
  5018: "不再提示",
  5019: "確認恢復賬戶-<strong>{-userName-}</strong>?",
  5020: "確認停用賬戶-<strong>{-userName-}</strong>?",
  5021: "設置簽名後，可以在預覽您審批通過的文檔時使用簽名",
  5022: "請在下面的區域內輸入您的簽名，然後點擊保存",
  5023: "確定刪除這個簽名？",
  5024: "該簽名已被使用，不能刪除",
  5025: "當前使用的簽名",
  5026: "設置為當前使用簽名",
  5027: "更新失敗！",
  5028: "分享設置",
  5029: "提醒關注文件",
  5030: "文件屬性",
  5031: "添加",
  5032: "文件已徹底刪除",
  5033: "文件刪除失敗,請稍後重試",
  5034: "文件已恢復到原有位置",
  5035: "文件恢復失敗,請稍後重試",
  5036: "新版本必須與舊版本使用一致的文檔類型",
  5037: "是否下載文件",
  5038: "放棄",
  5039: "在 {-type-} 中打開",
  5040: "選擇“在瀏覽器打開”",
  5041: "請使用右上角微信“更多”功能",
  5042: "該分享僅允許被邀請的用戶訪問，請使用您接收邀請的郵箱登錄！",
  5043: "分享者已經關閉當前分享，您不能再對文檔進行瀏覽了!",
  5044: "確定要退出分享嗎",
  5045: "當前選中人數超過30人，是否繼續",
  5046: "您無權查看企業成員！",
  5047: "請輸入6-20位包含大小寫字母及數字的組合",
  5048: "您已經被超級管理員凍結賬戶",
  5049: "您已經被超級管理員移出該企業",
  5050: "抱歉，{-str-}，點擊確認退出",
  5051: "當前網絡不可用，請檢查您的網絡情況是否正常",
  5052: "匿名用戶無權訪問！",
  5053: "移動文件失敗",
  5054: "目標文件夾不支持創建文件夾",
  5055: "創建子文件夾",
  5056: "文件目錄加載失敗",
  5057: "分組刪除失敗",
  5058: "網絡似乎不通暢，請刷新一下網頁後重試",
  5059: "免費版暫不支持預覽此類文件，如果需要請升級版本",
  5060: "輸入密碼以打開此 PDF 文件。",
  5061: "作者",
  5062: "關鍵詞",
  5063: "修改日期",
  5064: "製作者",
  5065: "頁數",
  5066: "正在準備打印文檔...",
  5067: "打開文件失敗",
  5068: "文件不允許訪問",
  5069: "暫不支持預覽該文件",
  5070: "退出編輯",
  5071: "刪除關聯",
  5072: "確定要刪除這個文件關聯嗎？",
  5073: "鎖定失敗，不能編輯，錯誤碼:",
  5074: "批准加入",
  5075: "拒絕加入",
  5076: "確定刪除該成員嗎",
  5077: "管理者",
  5078: "(我)",
  5079: "團隊描述",
  5080: "未加入",
  5081: "等待批准",
  5082: "服務器未知錯誤，請稍後重試",
  5083: "團隊名稱（小於40字）",
  5084: "團隊名稱不能為空",
  5085: "團隊描述（小於100字）",
  5086: "更新失敗！",
  5087: "退出團隊",
  5088: "刪除失敗，稍後重試",
  5089: "更新失敗！",
  5090: "尚未加入",
  5091: "圖片有錯誤，不能正常打開！",
  5092: "您無權查看該批注所在版本",
  5093: "注意：您當前查看的版本不是最新版本！",
  5094: "批注點已刪除",
  5095: "保存手繪失敗，請稍後重試",
  5096: "此操作將導致退出當前的演播，是否退出演播並繼續？",
  5097: "關閉演播失敗，請稍後重試",
  5098: "退出演播失敗，請稍後重試",
  5099: "您的瀏覽器會話已失效，需要重新登錄",
  5100: "用戶密碼被重置，點擊確認退出",
  5101: "管理員限制了你登錄的mac地址，點擊確認退出",
  5102: "你已被退出當前登錄，點擊確認退出",
  5103: "你的賬戶已被系統凍結，恢復賬號請聯繫客服人員，點擊確認退出",
  5104: "你的登錄已過期，請重新登錄",
  5105: "😞😞😞 連接出了點故障，刷新一下頁面就好了。",
  5106: "刷新",
  5107: "加入失敗，團隊人員已達到上限！",
  5108: "文件內容已經修改，請選擇：",
  5109: "不保存",
  5110: "請輸入文件內容",
  5111: "長度",
  5112: "顯示全部",
  5113: "您的瀏覽器版本過低，建議您升級到IE11及以上版本",
  5114: "您需要登錄",
  5115: "確認要刪除這個團隊嗎？<br>這將自動刪除其所有文件，且不能恢復！",
  5116: "確認要離開這個團隊嗎？",
  5117: "參數錯誤",
  5118: "等待超時",
  5119: "無法預覽該文件，請下載查看",
  5120: "文件處理失敗，暫不支持預覽",
  5121: "此為加密文檔，如需瀏覽編輯，敬請下載操作",
  5122: "文件已損壞或者文件信息不完整，請下載查看",
  5123: "文件太大，暫不支持生成可預覽文件",
  5124: "演示文稿是空的",
  5125: "發生未知錯誤，請聯繫管理員",
  5126: "服務器正在處理",
  5127: "限制此成員個人空間用量",
  5128: "則此成員賬戶可佔用空間量在其所屬部門可用空間量範圍內不受限制",
  5129: "此成員所屬部門可供設置空間總量",
  5130: "此成員已佔用空間",
  5131: "個人賬戶空間限制",
  5132: "部門空間限制",
  5133: "沒有需要您投件的文件收集箱",
  5134: "您沒有創建過文件收集箱",
  5135: "新密碼：",
  5136: "確認新密碼：",
  5137: "確認新密碼：",
  5138: "的密碼",
  5139: "密碼修改失敗",
  5140: "了解成員身份",
  5141: "員工空間限制",
  5142: "設定值等於已佔用空間, 將無法上傳新內容",
  5143: "使用橡皮不能刪除其他人繪製的線條！",
  5144: "此處添加的欄目，會顯示在每個企業用戶的工作台中",
  5145: "添加審批意見",
  5146: "矩形框審批意見",
  5147: "圓形審批意見",
  5148: "箭頭審批意見",
  5149: "文字審批意見",
  5150: "下載文件失敗",
  5151: "已通知",
  5152: "待接收",
  5153: "我做了圖形標記，點擊下圖查看",
  5154: "消息已被撤回",
  5155: "文件上傳失敗",
  5156: "文件評論",
  5157: "下載文檔失敗",
  5158: "點擊此處輸入批註內容",
  5159: "文字搜索",
  5160: "使用鼠標選中文檔中的文本建立批註",
  5161: "適合",
  5162: "版本列表",
  5163: "請使用右上角微信功能：使用瀏覽器打開",
  5164: "個批註",
  5165: "最新版本",
  5166: "當前版本",
  5167: "第{-v-}版本",
  5168: "發起者不能參與評審",
  5169: "此人已是評審人",
  5170: "審批進度",
  5171: "追加審批人",
  5172: "點此處直接進入下一審批階段",
  5173: "點此處結束審批",
  5174: "文件權限管理者",
  5175: "不是合格的 3D 文件格式",
  5176: "操作失敗，請檢查網絡連接",
  5177: "",
  5178: "",
  5179: "",
  5180: "",
  5181: "",
  5182: "正在打包文件夾，請稍後",
  5183: "超過{-multiFilesCount-}個文件或大小超過{-multiFilesSize-}的文件夾請使用客戶端下載",
  5184: "",
  5200: "下載次數請輸入正整數",
  /*********************HQSM*************************/

  5201: "選擇項目類型",
  5202: "創建普通項目",
  5203: "創建文控管理項目",
  5204: "創建一個獨立的項目共享空間，由指定的項目管理者分配項目成員權限，可邀請其他部門甚至外部用戶加入一起工作",
  5205: "專為項目文控管理設計，文控人員可向甲乙方發送文件，每次發件都有嚴格的記錄並自動生成發送單，並可管理查詢",
  5206: "文控經理",
  5207: "點擊選擇文控經理",
  5208: "文控人員",
  5209: "點擊選擇文控人員",
  5210: "其他成員",
  5211: "版本號規則",
  5212: "輸入前綴",
  5213: "輸入需要顯示在傳送單（TRANSMITTAL）上的信息，如聯繫方式、地址、電話等。",
  5214: "點擊選擇其他成員",
  5215: "ABC字母順序",
  5216: "123數字順序",
  5217: "收件方信息",
  5218: "輸入收件方名字",
  5219: "輸入郵箱，多個郵箱用英文分號隔開",
  5220: "點擊輸入",
  5221: "運單號規則",
  5222: "選擇編碼規則",
  5223: "1-2-3數字順序",
  5224: "a-b-c字母順序",
  5225: "日期加數字 例：20200123001",
  5226: "輸入文字",
  5227: "空",
  5228: "承包方",
  5229: "發包方",
  5230: "新增收件方",
  5231: "新增項目",
  5232: "發送單列表",
  5233: "管理項目",
  5234: "同步該文件夾",
  5235: "取消同步",
  5236: "搜索運單號或發件人，按回車鍵確認",
  5237: "{-name-}文控項目文件傳送列表（TRANSMITTAL List）",
  5238: "該項目暫未產生傳送單",
  5239: "沒有符合條件的傳送單",
  5240: "傳送單號（Transmittal NO.）",
  5241: "接收狀態",
  5242: "未接收",
  5243: "已接收",
  5244: "再次發送",
  5245: "基礎信息",
  5246: "項目基本信息",
  5247: "本項目共有收件人{-num-}個",
  5248: "管理項目收件人",
  5249: "項目成員",
  5250: "管理項目負責人",
  5251: "添加文控經理",
  5252: "添加文控人員",
  5253: "添加其他人員",
  5254: "文控項目管理",
  5255: "抄送",
  5256: "提交文件類型",
  5257: "原件",
  5258: "掃描複印件",
  5259: "TRANSPARENCY",
  5260: "LINEN",
  5261: "文件編號",
  5262: "描述",
  5263: "處理方式",
  5264: "確認人",
  5265: "編制和提交人",
  5266: "默認為發件人",
  5267: "輸入郵件中的附言",
  5268: "發送文件",
  5269: "發送文件",
  5270: "供歸檔",
  5271: "供查閱",
  5272: "供修訂",
  5273: "供審批",
  5274: "點擊輸入描述",
  5275: "發件日期",
  5276: "附件列表",
  5277: "文件傳送單",
  5278: "導出為PDF",
  5279: "傳送單號",
  5280: "運單號",
  5281: "我們很高興提交以下文件：",
  5282: "編制人",
  5283: "簽字",
  5284: "職務",
  5285: "transmittla info",
  5286: "文件發送記錄",
  5287: "查看文件發送記錄",
  5288: "審核時效",
  5289: "版本號： {-ver-}",
  5290: "日期順序",
  5291: "收件方類型",
  5292: "請輸入正確的transmittal Number",
  5293: "請輸入郵箱，以分號分隔",
  5294: "發送成功",
  5295: "文件發送成功，是否去查看文件傳送單（TRANSMITTAL）详情",
  5296: "Transmittal NO.",
  5297: "發送人",
  5298: "發送日期",
  5299: "發送版本",
  5300: "版本號",
  5301: "查看文件傳送單",
  5302: "輸入文件傳送單號",
  5303: "文件數量",
  5304: "已查看",
  5305: "未查看",
  5306: "文件數量{-num-} 占用空間{-size-}",
  5307: "本項目未設置接收方，暫不支持發送文件，如需發送文件，請聯繫文控經理",
  5308: "001、002數字順延",
  5309: "0001、0002數字順延",
  5310: "請選擇人員",
  5311: "格式錯誤，請輸入正確的郵箱，以引號分隔",
  5312: "版本",
  //hqsm 版本 
  5313: "編號",
  5314: "在線編輯",
  5315: "管理人員",
  5316: "恢復所有文件",
  5317: "恢復當前文件夾",
  5318: "永久刪除當前文件夾",
  5400: "點擊加入後如提示登錄請輸入賬戶密碼登錄，如果沒有註冊巴別鳥，請點擊",
  5401: "輸入標籤名，按回車鍵確認或點擊右側標籤按鈕選擇標籤",
  5402: "請輸入標籤名",
  5403: "創建文件夾",
  5404: "創建文件",
  5405: "你不能邀請自己加入分享",
  5406: "是否覆蓋子文件安全級別？",
  5407: "覆蓋",
  5408: "不覆蓋",
  5409: "“覆蓋”指的是子文件密級高於此密級的，子文件使用此密級",
  5410: "暫未設置審批流程",
  5411: "文控項目",
  /************8.5*******************/
  5412: "為接下來所有文件應用此設置",
  5413: "批量設定是否允許所選用戶擁有個人私有文件",
  5414: "下載我們的案例",
  5415: "二維碼已拷貝到剪貼板",
  5416: "複製二維碼到剪切板",
  5417: "掃碼打開鏈接",
  5418: "請在谷歌瀏覽器中使用https協議使用此功能",
  5419: "選擇待審批文件",
  /*****************8.5.1***************/
  5450: "請求發送文件給以下人員",
  5451: "待發送的文件",
  5452: "查看企業成員與分組",
  5453: "文件已經不存在了",
  5454: "選擇該文件夾的同步模式",
  5455: "雙向同步模式",
  5456: "本地和雲端文件一致，本地的更新會同步到雲端，雲端的更新會同步到本地",
  5457: "下行同步模式",
  5458: "本地的更新不會同步到雲端，但雲端的更新會同步到本地",
  5459: "全局默認排序",
  5460: "設置後，所有文件夾將使用選擇的排序方式作為默認排序，但在不同文件夾列表更改排序後，系統會記住最後一次所使用的的排序方式",
  5461: "已生成列表數據，請耐心等待",
  5462: "審核未通過",
  5463: "等待審核...",
  5464: "保密部門人員{-user-}要加入{-dep-}部門分享{-file-}，是否同意？",
  5465: "保密部門人員{-user-}要加入分享{-file-}，是否同意？",
  5466: "保密部門{-user-}要加入{-dep-}部門分享{-file-}，是否同意？",
  5467: "保密部門{-user-}要加入分享{-file-}，是否同意？",
  5468: "點此註冊企業公有雲版",
  5469: "保密部門人員{-user-}正在加入{-dep-}部門的項目{-file-}，是否同意？",
  5470: "保密部門人員{-user-}正在加入項目{-file-}，是否同意？",
  5471: "保密部門{-user-}正在加入{-dep-}部門的項目{-file-}，是否同意？",
  5472: "保密部門{-user-}正在加入項目{-file-}，是否同意？",
  5473: "正在獲取預覽數據",
  5474: "你沒有訪問該文件的權限",
  5475: "僅查看保密審批記錄",
  5476: "您可以撤銷這個審批，將其設置為",
  /*****************8.5.2***************/

  5500: "IP 策略列表",
  5501: "暫無企業自定義的IP策略",
  5502: "適用IP段",
  5503: "策略類型",
  5504: "添加下載策略",
  5505: "為策略取個名字，方便使用",
  5506: "策略類型",
  5507: "禁止下載",
  5508: "允許下載",
  5509: "編輯下載策略",
  5510: "若選擇允許下載，策略生效後策略IP段意外的設備將不能下載文件",
  5511: "部門人員策略",
  5512: "策略",
  5513: "請選擇策略",
  5514: "新建策略",
  5515: "新建策略",
  5516: "增加IP",
  5517: "授權",
  5518: "開始IP",
  5519: "終止IP",
  5520: "優先級",
  5521: "適用範圍",
  5522: "允許授權",
  5523: "拒絕授權",
  5524: "修改人",
  5525: "全體成員",
  5526: "管理人員",
  5527: "普通成員",
  5528: "暫無部門人員策略",
  5529: "例：192.168.2.5",
  5530: "例：192.168.2.98",
  5531: "輸入1~100，1為最高優先級",
  5532: "請輸入1~100的正整數",
  5533: "請輸入合法IP",
  5534: "該部門已存在IP策略",
  5535: "如果需要移除該策略，請先刪除使用該策略部門",
  5536: "文件歷史版本保存有效期",
  5537: "設定0表示永久保存歷史記錄",
  5538: "文件歷史版本保存版本數",
  5539: "注：歷史記錄保存版本數可以自由修改為1-999個，0為永久保存",
  5540: "請輸入版本數",
  5541: "請添加IP策略",
  5542: "該用戶不允許在當前IP地址下載文件",
  5543: "個人版不支持此類型文件在線預覽，如需預覽請升級為專業版或企業版",
  5544: "舉報",
  5545: "顯示",
  5546: "隱藏",
  5547: "你是否確定此分享含有非法信息，要將此反映給網站管理者？",
  5548: "舉報成功",
  5549: "獲取用戶信息失敗",
  5550: "保存到網盤",
  5551: "若已安裝客戶端",
  5552: "若未安裝客戶端",
  5553: "企業協同網盤",
  5554: "立即下載",
  5555: "下載巴別鳥APP",
  5556: "方向",
  5557: "下載及上傳",
  5558: "該用戶不允許在當前IP地址上傳文件",
  5559: "已刪除",
  5560: "外部協作人員數10",
  5561: "無限外部協作人員數",
  5562: "{-day-}天後過期",
  5563: "{-hour-}小時後過期",
  5564: "無限團隊用戶數",
  5565: "小團隊文件共享協作，不限成員",
  //--------------------6.2--------------- 
  6000: "待接收",
  6001: "已接收",
  6002: "已退回",
  6003: "處理稿件",
  6004: "接收",
  6005: "退回",
  6006: "處理意見",
  6007: "操作者",
  6008: "稿件狀態",
  6009: "{-somebody-}接收了稿件{-file-}，並附言：{-comment-}",
  6010: "{-somebody-}拒絕了稿件{-file-}，並附言：{-comment-}",
  6011: "定稿日期",
  6012: "接收了你的投件{-file-}，並附言：{-comment-}",
  6013: "拒絕了你的投件{-file-}，並附言：{-comment-}",
  6014: "為文件夾{-parent-}中的{-file-}上傳了一個新版本",
  6015: "在文件夾{-parent-}中上傳了一個新文件",
  6016: "訪問文件列表",
  6017: "下載文件列表",
  6018: "上傳文件列表",
  6019: "批註文件列表",
  6020: "評論文件列表",
  6021: "文件收集箱信息",
  6022: "暫無可用菜單欄目",
  6023: "查看相關文件",
  6024: "相關度",
  //****************6.3****** 
  6025: "部門成員開啟審批時可自定義審批的流程和審批人",
  6026: "部門成員開啟審批時可以選擇在管理後台中預設所有的審批流程",
  6027: "在管理後台預設流程中選擇幾個作為部門使用的審批流程",
  6028: "使用上一級部門所使用的審批流程設置",
  /***** 6.4 *****/
  6029: "移除卡片",
  6030: "項目成員設置",
  6031: "項目內所有人",
  6032: "項目內所有未設置追加權限的普通成員",
  6033: "文件權限申請",
  6034: "申請權限",
  6035: "管理回收站",
  6036: "{-user-}邀請你參與以下項目",
  6037: "項目位置",
  6038: "轉交項目",
  6039: "轉交給項目人員",
  6040: "選擇項目負責人",
  6041: "意見提出人",
  6042: "意見描述",
  6043: "意見處理",
  6044: "評審意見列表",
  6045: "審批意見列表",
  6046: "審批操作",
  6047: "提交審批",
  6048: "會簽",
  6049: "審批文件",
  6050: "尊敬的用户， 您的賬戶空間使用量已達到{-per-}",
  6051: "尊敬的用户， 您的企業空間使用量已達到{-per-}",
  6052: "恢復到免費版",
  6053: "您確信要降級為普通用戶嗎？這樣將導致您的空間和享受服務的降低！",
  6054: "參與分享的人員",
  6055: "旋轉",
  6056: "暫不支持在線預覽該文件，是否用本地應用程序打開？",
  6057: "刪除失敗，服務器錯誤",
  6058: "確認要停用外部人員- {-name-} - 的賬號嗎？",
  6059: "確認要刪除外部人員- {-name-} - 的賬號嗎？",
  6060: "移除",
  6061: "你沒有移入文件到目標文件夾的權限",
  6062: "附言",
  /**6.6*************/
  6063: "暫未加入其它團隊",
  6064: "從常用聯繫人中添加",
  6065: "輸入被邀請者手機（按Enter或Tab鍵確認），一次可添加多個",
  6066: "請輸入手機號",
  /***************6.7************/

  6067: "共同發佈文件夾",
  6068: "打開此選項，會在企業所有人企業文件頻道顯示出共同發佈文件夾，企業成員均可在此文件夾內上傳文件，超級管理員擁有此文件管理權限",
  6069: "已經提交",
  6070: "未提交",
  6071: "總計",
  6072: "人",
  6073: "提交狀態",
  6074: "收件統計",
  6075: "未投件",
  6076: "已投件",
  6077: "暫無投件信息",
  6078: "當前賬戶暫未設置登錄密碼,你可以通過短信驗證碼登錄後,設置登錄密碼。去",
  6079: "重新登錄",
  6080: "獲取邀請鏈接地址",
  6081: "複製此鏈接 ",
  6082: "鏈接已拷貝到剪貼板",
  6083: "將此鏈接發放給相關人員，點此鏈接進行註冊或登錄後即申請加入本團隊，由管理員審核後即可成功進入團隊",
  6084: "僅有企業安全保密員可以設置企業的文件安全策略",
  6085: "{-sign-}了你對{-typeStr-}{-fileName-}的申請",
  6086: "申請加入{-type-}{-file-}",
  6087: "申請加入{-type-}",
  6088: "等待管理員審核",
  6089: "暫無訪問該文件權限，等待管理員審核",
  6090: "在巴別鳥中打開",
  6091: "您可以在”我加入的分享“中查看該文件",
  6092: "暫未設置安全策略"
}, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, "6092", "根部門"), 6093, "將此鏈接發放給相關人員，點此進行註冊或登錄後即申請加入本項目，由項目負責人審核後即可通過"), 6094, "團隊名稱"), 6095, "項目名稱"), 6096, "等待項目負責人審核"), 6097, "項目負責人"), 6098, "暫無訪問該文件權限，等待項目負責人審核"), 6099, "將 {-file-} 中的一个 {-comment-} 設置為 {-finish-}"), 6100, "鏈接分享已關閉"), 6111, "審批名稱"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6112, "文件列表"), 6113, "複製文件"), 6114, "複製完成"), 6115, "顯示複製文件進度"), 6116, "加入了項目"), 6117, "您所在的企業沒有購買審批模塊，暫時無法使用此功能"), 6118, "您所在的企業沒有購買保密模塊，暫時無法使用此功能"), 6119, "您所在的企業沒有購買存檔模塊，暫時無法使用此功能"), 6120, "邀請已發送，請耐心等待反饋"), 6121, "企業內備註"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6122, "修改企業內備註"), 6123, "此操作不可逆，確認刪除該條通知嗎？"), 6124, "邀請你加入企業"), 6125, "點此加入後，你將加入該企業，你個人版將註銷，原有文件自動轉移到此企業"), 6126, "巴別鳥不支持隱藏文件的上傳"), 6127, "當前目錄下，你沒有上傳文件的權限"), 6128, "點擊添加文件說明"), 6129, "點擊添加版本說明"), 6130, "您已選擇100+個文件請使用客戶端下載"), 6131, "（同步更快喲）"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6132, "您選擇了多個文件夾請使用客戶端下載"), 6133, "文件列表為空"), 6134, "邀請你加入了企業 {-name-} "), 6135, "點擊查看可以在預覽文件內容上進行批註！"), 6136, "在要批註的地方鼠標左鍵雙擊進行批註"), 6137, "目標企業"), 6138, "邀請加入企業"), 6139, "項目的討論組，整個項目都可以在這裡討論"), 6140, "僅有安全保密員可以設定企業或部門的整體安全策略"), 6141, "安全保密員可以審批所有的分享請求"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6142, "{-somebody-} 邀請你加入了分享 {-file-}"), 6143, "獲取審批信息失敗,該審批已被撤回"), 6144, "目前不支持預覽文件大小超過 {-size-} M，或者Excel行數超過2000行或者頁數超過600頁的文件。請下載後打開"), 6145, "文件不存在或已損壞"), 6146, "註冊並登錄後"), 6147, "{-somebody-} 將你移出了分享 {-file-}"), 6148, "在要批註的地方手指長按進行批註"), 6149, "文檔更新中，請稍後打開"), 6150, "不設置"), 6151, "你沒有加入該文件鏈接分享的權限"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6152, "如需要批註，請登錄"), 6153, "綁定手機號後可以直接用手機號登錄"), 6154, "跳過"), 6156, "尊敬的用户，感謝您使用我們的網盤系統，耽誤您點兒時間，歡迎您留下寶貴的意見和建議或者棄用的原因："), 6157, "{-somebody-} 將你加入了項目{-file-}"), 6158, "將你加入了項目{-file-}"), 6200, "點擊"), 6201, "設置部門審批流程策略"), 6202, "部門文件使用管理"), 6203, "部門分享文件統計"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6204, "查看並管理部門中所有開啟的分享"), 6205, "打開分享文件列表"), 6206, "打開文件權限設置"), 6207, "查看並管理部門中單獨設置過文件權限的文件及文件夾"), 6208, "打開密級文件列表"), 6209, "查看並管理設置過文件密級的文件"), 6210, "打開文件訪問日誌"), 6211, "查看部門中的文件訪問日誌"), 6212, "成員使用情況"), 6213, "打開使用情況"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6214, "查看部門成員的文件使用情況"), 6215, "部門設置"), 6216, "限制下載次數"), 6217, "設置失敗，請輸入正確的下載次數"), 6218, "管理員綁定mac地址無效，綁定時會被自動過濾"), 6219, "文件行數或頁數過多，建議使用客戶端編輯功能打開"), 6220, "設置下載次數後，同一用戶半小時內重複下載，僅計算一次"), 6221, "如果是新上傳的文件，請等待最長30分鐘，待服務器更新全文搜索索引"), 6222, "因政策原因，巴別鳥個人版和專業版不支持匿名訪問分享的視頻文件。你可以註冊並登錄後，在我加入的分享中預覽或下載該視頻。"), 6223, "此為加密文檔，如需瀏覽編輯，敬請下載操作！"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6224, "部門文件歸屬於部門，轉移文件歸屬並不影響該用戶上傳的部門文件"), 6225, "在部門中上傳的文件"), 6226, "部門文件歸屬於部門。刪除、停用用戶、轉移文件不影響部門文件"), 6227, "名稱不能為空"), 6228, "或"), 6229, "你確定要刪除該標籤嗎？"), 6300, "長按要批註的地方進行批註"), 6301, "清除本地緩存"), 6302, "多文件審批"), 6310, "移動端 App"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6311, "當前文件名"), 6312, "修改後文件名"), 6313, "申請重命名文件"), 6314, "申請移動文件"), 6315, "歸檔中，請稍候"), 6316, "當前目錄"), 6317, "目標目錄"), 6318, "申請將文件{-file-}重命名為“{-newName-}”"), 6319, "申請將文件{-file-}從“{-source-}”移動到“{-target-}”"), 6320, "{-sign-}了你對文件{-fileName-}的重命名請求"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6321, "{-sign-}了你對文件{-fileName-}的移動請求"), 6322, "{-sign-}了你對文件{-fileName-}的請求"), 6323, "操作失敗，原目錄已無此文件"), 6324, "企業擁有者不能被停用"), 6325, "當前登錄賬號不能停用自己"), 6326, "目標位置不能是根目錄"), 6327, "我關注的通知"), 6328, "允許匿名訪問"), 6329, "請至少輸入6個字符"), 6340, "快照分享"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6341, "快照分享的內容會停留在你建立快照鏈接的時間，不會隨文件內容的更新而更新。獲得此鏈接的人員可以通過此鏈接訪問建立快照時的文件。支持建立多個快照。"), 6342, "新建文件快照"), 6343, "暫無文件快照，你可以點擊右側按鈕，新建一個快照"), 6344, "請選擇文件快照"), 6345, "文件快照——"), 6346, "歷史快照"), 6347, "快照日期"), 6348, "刪除此快照"), 6349, "默認允許用戶分享個人私有文件"), 6350, "篩選文件需要加載所有文件，請稍候"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6351, "篩選文件僅支持篩選已加載文件，該目錄下文件數量大於500，是否立即加載所有文件"), 6352, "加載全部文件"), 6353, "篩選當前文件"), 6354, "下載限速"), 6355, "下載最高速率"), 6356, "注意：輸入0表示不限制其下載速度"), 6357, "請輸入100~20480的數"), 6358, "輸入文件名，回車確認"), 6359, "分享文件(夾)："), 6360, "快照分享文件(夾)："), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6361, "思維導圖"), 6362, "隱藏組織結構"), 6363, "打開此選項，企業所有成員無法在分享邀請/建立項目加人/添加審批人員/添加消息接收人/添加投件人/分組加人/從內部成員添加用戶到部門時按組織結構選擇企業成員，但可以通過搜索用戶名，郵箱或手機號的方式添加。（對管理員無效）"), 6364, "查看上傳文件"), 6365, "上傳文件列表"), 6366, "你可以輸入用戶名/手機號/郵箱搜索本企業成員"), 6367, "複製到剪切板"), 6368, "圖片已經複製到剪切板"), 6369, "僅支持https協議下複製圖片"), 6370, "禁止分享文件給企業外用戶"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6371, "打開此選項，企業成員無法將文件分享給企業外部用戶，同時無法通過鏈接分享文件"), 6372, "隱藏工具欄"), 6373, "顯示工具欄"), 6400, "快捷菜單"), 6450, "該郵箱已經註冊為巴別鳥賬號"), 6451, "該手機號已經註冊為巴別鳥賬號"), 6552, "每月上傳統計"), 6553, "上傳個數"), 6554, "月份"), 6555, "關於巴別鳥"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6556, "巴比鳥網盤"), 6557, "所有項目"), 6558, "流量統計"), 6559, "流量統計（單位MB）"), 6560, "企業發布文件夾"), 6561, "打開此選項，會在企業所有人企業文件頻道顯示出企業發布文件夾，僅超級管理員、安全保密員、檔案管理員可在此文件夾上傳文件，超級管理員擁有文件管理權限"), 6562, "用戶停用自動關閉該用戶開啟的企業文件分享鏈接"), 6563, "開啟此項，停用用戶會自動關閉該用戶的企業文件分享鏈接。如關閉此選項，停用用戶開啟的企業文件分享鏈接也能照常使用。"), 6564, "導出思維導圖"), 6565, "KityMinder 格式 (.km)"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6566, "大綱文本 (.txt)"), 6567, "Markdown/GFM 格式 (.md)"), 6568, "SVG 矢量圖 (.svg)"), 6569, "PNG 圖片 (.png)"), 6570, "XMind 格式 (.xmind)"), 6571, "本企業有保密部門，不允許匿名上傳文件"), 6572, "更新失敗，該郵箱已經存在"), 6573, "該郵箱已存在"), 6574, "該手機號已存在"), 6575, "每月上傳統計（單位：個）"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6576, "不允許以“.”結尾"), 6577, "個人文件分享鏈接賬戶停用即關閉。"), 6578, "手機號和郵箱不能同時為空"), 6579, "管理員設置了禁止訪問企業發布文件夾，文件目錄獲取失敗"), 6580, "文件目錄獲取失敗"), 6581, "確認刪除角色"), 6582, "文件權限名稱"), 6583, ""), 6584, ""), 6585, ""), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6600, "從模板創建"), 6601, "沒有可用模板"), 6602, "創建模板"), 6603, "文件模板"), 6604, "文件夾模板"), 6605, "管理員可在此文件夾下上傳部門內的模板文件（夾）"), 6606, "新建模板"), 6607, "上傳模板"), 6608, "沒有可用模板"), 6609, "創建進度"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6610, "創建文件"), 6611, "創建完成"), 6612, "關閉此選項後，所有用戶將無法分享個人文件裡的文件，並且不能在個人文件裡創建項目"), 6613, "流量統計"), 6614, "導出流量統計報表"), 6615, ""), 6616, ""), 6617, ""), 6618, ""), 6619, ""), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6620, ""), 6621, ""), 6622, ""), 6623, ""), 6624, ""), 6625, ""), 6626, ""), 6627, ""), 6628, ""), 6629, ""), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6630, ""), 6631, ""), 6632, ""), 6633, ""), 6650, "編碼方式"), 6651, "轉為項目"), 6652, "禁止匿名分享"), 6653, "打開此選項，通過鏈接分享文件時，不允許匿名人員訪問"), 6654, "企業設置了不允許匿名訪問"), 6655, "登錄失效時間"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6656, "注：輸入0表示瀏覽器關閉時登錄即失效"), 6657, "在個人文件中上傳了一個新版本{-file-}"), 6658, "在個人文件中上傳了一個新文件"), 6659, "小時"), 6660, "請輸入正整數"), 6661, "在個人文件中新增了文件夾{-file-}"), 6700, "文件名中含有非法字符"), 6701, "已用授權數/授權數：{-cur-}/{-count-}"), 6702, "請從部門列表中選擇"), 6703, "點此註冊個人版"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6704, "請完善您的企業信息"), 6705, "聯繫人姓名"), 6706, "聯繫人郵箱"), 6707, "輸入一個二級域名作為您的企業專屬訪問地址，推薦使用4個以上英文字母"), 6708, "開通巴別鳥企業版"), 6750, "開始上傳"), 6751, "暫停上傳"), 6752, "已暫停"), 6753, "下載客戶端"), 6754, "在線編輯發生錯誤保存文檔失敗，已自動恢復為最近的可用文檔"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6755, "您同意加入企業後將成為該企業用戶，同時取消你原來的個人版/專業版賬號，是否同意？"), 6756, "忽略並重傳"), 6757, "轉交後當前項目負責人成為項目成員"), 6758, "普通成員"), 6759, "請選擇其他編碼方式嘗試打開"), 6760, "個人私有文件空間上限設置成功 \n企業中有{-number-}人已自定義空間大小，是否需要統一修改空間大小"), 6761, "{-somebody-} 邀請你加入了項目 {-file-}"), 6762, "{-somebody-} 邀請以下人員 {-user-} 加入了項目 {-file-}"), 6763, "數據已經過期，請重新點擊按鈕導出列表"), 6764, "導出出現異常，請聯繫管理員"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6765, "有一個日誌報表正在導出中，請稍後重試"), 6766, "日誌報表下載成功了"), 6767, "日誌報表下載中，請稍後"), 6768, "下載完成"), 6800, "你可以選擇一個項目成員作為新的項目負責人"), 6801, "暫無項目成員，請添加項目成員後再轉交項目"), 6802, "目前不支持預覽大小超過 {-size-} M 的該類型文件，請下載後打開"), 6803, "暫無符合條件項目成員，請更換搜索條件"), 6804, "本地歸檔"), 6805, "歸檔後的文件保留在當前文件夾，不能再上傳新版本，保留其他原有文件權限，閱讀時不需要借閱"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6806, "已歸檔"), 6807, "你沒有此文件的上傳權限，不能進行在線編輯"), 6810, "生成預覽文件失敗，是否需要再次嘗試？"), 6811, "重試"), 6812, "項目已經過期，普通項目成員已不能訪問本項目。"), 6813, "已過期"), 6814, "目前不支持編輯大小超過 {-size-} M 的該類型文件，請下載後打開"), 6815, "清空該賬戶所有權限"), 6816, "清空"), 6817, "清空後用戶僅能訪問個人文件， 開啟的分享將被關閉，也將從加入的部門、分組、分享、項目中退出"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6818, "你確定要清空{-name-}賬戶麼？"), 6819, "此操作不可逆，清空後{-name-}的所有權限將會失效"), 6820, "空間占比"), 6821, "點擊隱藏"), 6822, "發送文件列表"), 6823, "暫無發送文件"), 6824, "，最多輸入5個"), 6825, "監控預警"), 6826, "企業監控列表"), 6827, "添加監控項"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6830, "企業暫未設置監控項"), 6831, "數量限制"), 6832, "監控信息獲取失敗"), 6833, "請選擇監控項"), 6834, "你確定要刪除當前監控項嗎？"), 6835, "重複上傳"), 6836, "在網盤中{-opType-}部門文件數量超標, 當前值：{-currentNum-}, 閾值:{-threshhold-}"), 6837, "超過5個人員，不能使用發送文件功能"), 6838, "超過5個文件，不能使用發送文件功能"), 6839, "發送文控文件"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6840, "請選擇接收人員"), 6841, "相關文件已被刪除，請聯繫發送者"), 6842, "自定義快捷菜單"), 6843, "左側欄顯示快捷菜單"), 6844, "可選快捷菜單"), 6845, "可通過雙擊將此快捷方式從左側欄移除，可通過拖拽進行排序"), 6846, "添加文件夾至快捷菜單"), 6847, "可通過雙擊將此快捷方式添加至左側欄顯示"), 6848, "暫無快捷菜單"), 6849, "暫無可選快捷菜單"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6850, "請選擇文件夾"), 6851, "請在子目錄中選擇文件夾"), 6852, "文件繼承了上一級的訪問控制"), 6853, "最多可添加20個快捷菜單"), 6854, "所有監控項都已添加"), 6855, "傳送文件配置"), 6856, "接收端口"), 6857, "發送端口"), 6858, "重填"), 6859, "{-somebody-} 將 {-file-} 發送給 {-targetNames-}"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6860, "您的手機號已經註冊了巴別鳥，請確定是否把該賬號升級為企業版？選”是“將進行升級操作，此操作不可逆並有可能造成數據丟失，請注意備份數據。如果您不想升級該賬號，請選”否“後換個手機號註冊企業版。"), 6861, "檢測到您的手機號已經是巴別鳥企業用戶，請換個手機號註冊"), 6862, "更多選項"), 6863, "剪切"), 6864, "粘貼"), 6865, "文件收集箱僅支持收取{-str-}文件"), 6866, "端口說明"), 6867, "端口號"), 6868, "你確定要刪除當前端口嗎？"), 6869, "端口名稱"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6870, "該名稱已存在"), 6871, "新建"), 6872, "請輸入端口名稱及說明"), 6873, "接收者"), 6874, "編輯端口"), 6875, "新建端口"), 6876, "接收人員列表"), 6877, "你可以在這裡選擇該端口的成員"), 6878, "暫無接收人員"), 6879, "添加人員"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6880, "確定要將此人移出接收人員？"), 6881, "確定要將此部門移出接收人員？"), 6882, "點擊顯示token"), 6883, "發送端名稱"), 6884, "接收端名稱"), 6885, "接收端域名"), 6886, "如：http://www.babel.cc"), 6887, "接收端token"), 6888, "發送者"), 6889, "發送人員列表"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6890, "確定要將此人移出發送人員？"), 6891, "確定要將此部門移出發送人員？"), 6892, "暫無發送人員"), 6893, "傳送文件"), 6894, "你可以選擇配置好的端口進行文件傳送"), 6895, "將文件{-fileName-}提交到企業發送端口{-identifier-}，申請發送文件，請"), 6896, "審核"), 6897, "系統接收端口{-identifier-}收到發送給你的文件{-fileName-}, "), 6898, "點擊此處查看詳情"), 6899, "你申請通過企業發送箱{-identifier-}發送文件{-fileName-}的請求,已被管理員 "), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6900, "系統接收端口{-identifier-}收到文件{-fileName-},請"), 6901, "系統接收端口{-identifier-}收到文件{-fileName-},已審核"), 6902, "企業未設置發送端口或沒有您可用的端口，請聯繫管理員"), 6903, "暫不支持將文件夾複製到它的子目錄"), 6904, "暫不支持將文件夾移動到它的子目錄"), 6905, "請輸入數量限制"), 6906, "文件夾專用"), 6907, "（部門在回收站中）"), 6908, "下載到:"), 6909, "瀏覽"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6910, "設為默認路徑"), 6911, "清空結束日期"), 6912, "默認不接收通知"), 6913, "打開此選項後，系統默認關閉用戶推送通知，用戶需要接收通知可以在設置中自行打開需要接收的通知類型"), 6914, "複製鏈接地址"), 6915, "鏈接已複製"), 6916, "使用客戶端訪問分享鏈接"), 6917, "通過"), 6918, "駁回"), 7000, "文件不能在同一成員中轉移，請選擇其他目標成員"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7001, "您的顯卡太舊了，當前瀏覽器不能驅動"), 7002, "您可以嘗試舊版本的瀏覽器或者升級顯卡"), 7003, "您的瀏覽器版本太低了"), 7004, "請使用最新版本"), 7005, "尊敬的用户，您的企业版服务距离最后截止日期"), 7006, "尊敬的用户，您的企业版服务已经到期，如有需要请联系客服，我们将竭诚为您服务。"), 7007, "只剩下不到"), 7008, "小時了"), 7009, "天了"), 7010, "為了不影響您的使用，請儘快聯繫客服為盼！"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7011, "未找到與"), 7012, "匹配的查詢"), 7013, "自定義文件夾"), 7014, "審批意見創建成功"), 7015, "錯誤的郵件格式"), 7016, "錯誤的郵箱或者手機號 "), 7017, "取消勾選限制"), 7018, "本部門"), 7019, "部門刪除失敗,請重試"), 7020, "最大空間限制"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7021, "設置空間限制"), 7022, "請輸入最大空間值（單位:G）"), 7023, "不限制"), 7024, "上傳企業logo"), 7025, "logo預覽"), 7026, "請添加附言"), 7027, "網絡錯誤，請稍後重試"), 7028, "該人員已經屬於{-name-}企業，請該人員先退出該企業"), 7029, "此用戶已註冊，可發送邀請給他，該用戶同意後即可自動加入本企業"), 7030, "發送邀請"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7031, "1 小時內不能重複發送"), 7032, "服務器返回錯誤"), 7033, "已停用用戶"), 7034, "未設置"), 7035, "基礎"), 7036, "存檔"), 7037, "通知"), 7038, "階段1"), 7039, "未註冊"), 7040, "從未登錄"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7041, "免費試用30天"), 7042, "無權訪問"), 7043, "沒有打開源文件的權限"), 7044, "圖片"), 7045, "office 文檔"), 7046, "Adobe 文檔"), 7047, "CAD 文件"), 7048, "其他"), 7049, "全部時間"), 7050, "3日內"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7051, "1周內"), 7052, "1月內"), 7053, "6月內"), 7054, "全部大小"), 7055, "0 ~ 100字節"), 7056, "100字節 ~ 1K"), 7057, "10G以上"), 7058, "該語音批註已不存在"), 7059, "《標籤》"), 7060, "做了圖形標記（另行查看）"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7061, "上傳了文件（另行查看）"), 7062, "歷史版本"), 7063, "舊"), 7064, "採納"), 7065, "等"), 7066, "您尚未登錄，需要先登錄"), 7067, "去註冊"), 7068, "沒有賬號"), 7069, "登錄提示"), 7070, "設置郵箱後，可以接收共享文件有關的郵件通知，建議<br>馬上打開個人設置界面去綁定郵箱"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7071, "打開個人設置"), 7072, "以後再說"), 7073, "巴別鳥使用引導"), 7074, "歡迎您使用巴別鳥，我們引導您如何快速使用"), 7075, "點擊創建按鈕，您可以上傳文件或者創建文件夾"), 7076, "在這裡您可以查看所有您創建的文件及文件夾"), 7077, "部門文件夾"), 7078, "您可以在這裡查看所屬部門的文件"), 7079, "您可以在這裡查看並管理所有您創建或已加入的團隊"), 7080, "您可以在這裡查看並管理所有您分享出去的文件或文件夾"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7081, "您可以在這裡查看並管理所有您加入的分享文件或文件夾"), 7082, "所有添加關注的文件都會顯示在此"), 7083, "需要您投稿或者管理投稿的地方"), 7084, "文件審批"), 7085, "您的審批文件會顯示在此"), 7086, "所有刪除的文件都會暫存在回收站"), 7087, "導航"), 7088, "在這裡可以切換<em>文件</em>，<em>動態</em>"), 7089, "功能按鈕"), 7090, "您可以在此查看文件詳情或對文件排序"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7091, "使用引導"), 7092, "歡迎使用巴別鳥進行文檔批注！下面逐條對主要工具進行介紹"), 7093, "批注點列表"), 7094, "可以查看文檔中所有批注點"), 7095, "點擊查看文件導航圖 - 可以看到同一個文件夾中的所有文檔"), 7096, "旋轉當前文檔"), 7097, "選擇文件或版本與當前文件進行對比"), 7098, "在線打印當前文件"), 7099, "可以將文檔分享給他人"), 7100, "查看文檔的歷史版本"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7101, "下載文檔"), 7102, "批注顯示控制"), 7103, "隱藏、顯示批注"), 7104, "全屏顯示當前頁面"), 7105, "點擊頭像選擇"), 7106, "，就可以進入企業管理後台，可針對本企業進行部門及人員管理，並進行所需配置。"), 7107, "您無權回復"), 7108, "您無權回復,請登錄後進行回復"), 7109, "普通批注"), 7110, "幾何批注"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7111, "文字標記"), 7112, "批注內容為空，不能發送"), 7113, "請輸入文字內容"), 7114, "下載iOS App"), 7115, "來巴別鳥，參與討論"), 7116, "請輸入"), 7117, "發送新消息"), 7118, "無文件（夾）"), 7119, "提示 : 回收站為您保留10天內刪除的文件（夾）"), 7120, "請按照下面的示意圖操作打開"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7121, "巴別鳥App"), 7122, "第1步"), 7123, "點擊右上角的「更多」按鈕"), 7124, "第2步"), 7125, "選擇用Safari打開"), 7126, "在App中打開"), 7127, "點擊此處填寫附言"), 7128, "在巴別鳥中組建了"), 7129, "，請填寫附言信息或直接點擊“加入”按鈕加入此"), 7130, "加入"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7131, "通過動態你可以了解你的協作者及{-str-}的所有情況，並快速進入討論的文件"), 7132, "回復成功"), 7133, "您沒有回復的權限"), 7134, "回復失敗，文件已被刪除！"), 7135, "回復失敗，批注已被刪除！"), 7136, "回復失敗，請稍後重試"), 7137, "回復失敗，您無權查看該批注所在版本"), 7138, "回復失敗，文件已被刪除！"), 7139, "回復失敗"), 7140, "評論成功"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7141, "您沒有評論的權限"), 7142, "評論失敗，請稍後重試"), 7143, "您的瀏覽器不支持 HTML5 video 標籤"), 7144, "正在下載"), 7145, "有數據未保存"), 7146, "您編輯的數據沒有完全保存的服務器"), 7147, "繼續關閉"), 7148, "電話"), 7149, "請按⌘ + C拷貝鏈接"), 7150, "請按Ctrl + C拷貝鏈接"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7151, "現場焊縫"), 7152, "周圍焊縫"), 7153, "文件名稱"), 7154, '第<b id="fileNo" class="top">0</b>個文件,共<b id="fileCount" class="top">100</b>個文件'), 7155, "操作失敗，請稍後重試"), 7156, "即將結束本文件的審批，您希望將文件的審批狀態設置為："), 7157, "未啟動審批（刪除已有審批記錄"), 7158, "列表為空"), 7159, "過濾了已有的審批人"), 7160, "文件沒有新版本，不能開啟審批"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7161, "查看報表"), 7162, "文件沒有新版本，不能開啟審批"), 7163, "顯示審批列表"), 7164, "從預設名單中過濾了當前用戶"), 7165, "發起者不能參與評審，已刪除"), 7166, "點擊刷新"), 7167, "選擇目標檔案夾"), 7168, "移動到"), 7169, "當前選中文件已包含在該文件夾內部"), 7170, "無法將選中文件夾{-title-}文件夾自己內部"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7171, "文件移動失敗，請關閉文件分享後重試"), 7172, "文件移動成功"), 7173, "上傳到"), 7174, "已關注"), 7175, "您目前不屬於任何部門，或者無權查看任何部門文件"), 7176, "匿名訪問者"), 7177, "我的分享參與者"), 7178, "文件參與者"), 7179, "暫無訪問記錄"), 7180, "統計匯總"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7181, "鎖定"), 7182, "文件日誌為空"), 7183, "工作量統計"), 7184, "暫無分組人員"), 7185, "公共分組為空"), 7186, "個人分組為空"), 7187, "參與的分享"), 7188, "訪問記錄"), 7189, "展開"), 7190, "暫無人員"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7191, "搜索標籤"), 7192, "您還沒有加入其它分享的文件"), 7193, "提示 : 所有您瀏覽過的分享鏈接中的文件(夾)都會顯示在此處"), 7194, "抱歉，找不到帶有選擇標籤的文件或文件夾"), 7195, "請確認"), 7196, "添加團隊成員"), 7197, "請選擇目標路徑"), 7198, "文件名不能為空"), 7199, "文件名稱長度不能超過100個字符"), 7200, "選擇目標文件夾"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7201, "灰色的文件夾是沒有上傳權限的文件夾"), 7202, "大文件多文件請使用客戶端同步功能"), 7203, "全功能客戶端擁有"), 7204, "實時同步"), 7205, "消息推送"), 7206, "上傳文件夾"), 7207, "等強大功能"), 7208, "Windows版下載"), 7209, "Mac版下載"), 7210, "若已下載，請打開客戶端使用該功能"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7211, "如需購買office在線協作編輯授權，請聯繫客服人員"), 7212, "該功能僅在客戶端中支持"), 7213, "您的存儲空間已滿, 可以刪掉部分不用的文件, 或點擊下方按鈕購買跟多存儲空間"), 7214, ""), 7215, "擴展存儲空間"), 7216, "空間已滿"), 7217, "有人正在網頁上編輯該文件，你可以選擇菜單中的“在線編輯”加入協同編輯"), 7218, "服務權限判斷錯誤"), 7219, "個文件(夾)"), 7220, "取消贊"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7221, "小圖標"), 7222, "中圖標"), 7223, "大圖標"), 7224, "標準"), 7225, "簡潔"), 7226, "注"), 7227, "這是您邀請其他人參與的分享"), 7228, "我的邀請"), 7229, "文件設置了訪問控制"), 7230, "保密文件"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7231, "限制文件"), 7232, "內部文件"), 7233, "外部文件不屬於當前企業，是您加入的企業外部人員的文件分享或者團隊等"), 7234, "你已經關注了這個文件，是否想取消關注？"), 7235, "繼續關注"), 7236, '"注"中顯示的是文件說明，文件說明可以起到幫助您標記文件的作用，您可以在文件詳情面板中對任何您有編輯權限的文件，修改文件說明的內容'), 7237, "您想要取消這個置頂嗎？"), 7238, "保持置頂"), 7239, "文件已被{-userName-}鎖定"), 7240, "其他人需要等待其編輯完成鎖定狀態才能解除"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7241, "文件已被鎖定，您想解鎖嗎？"), 7242, "注意：強行解鎖可能會造成加鎖人上傳的版本與其他人的編輯版本相互覆蓋從而造成版本丟失"), 7243, "解鎖"), 7244, "關閉窗口"), 7245, "該文件已經被人鎖定，您不能編輯"), 7246, "已到列表底部"), 7247, "關注的日期"), 7248, " 企業外聯繫人"), 7249, "正在以管理員身份查看部門文件"), 7250, "正在以管理員身份查看{-user-}的文件"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7251, "升級至專業版後, 當前賬戶所享有的免費版功能, 將獲得以下提升:"), 7252, "賬戶空間容量擴展至1TB"), 7253, "可購買容量套餐獲取更多空間"), 7254, "單個文件保存歷史版本不限"), 7255, "新建團隊個數不限"), 7256, "無限預覽CAD文件"), 7257, "無限預覽3D文件"), 7258, "共享標籤"), 7259, "文件協作"), 7260, "了解專業版"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7261, "複製進度"), 7262, "請輸入新的名稱"), 7263, "人贊過"), 7264, "您還沒有關注的文件(夾)"), 7265, '提示 : 您可以在"全部文件"中關注文件(夾)'), 7266, "您還沒有分享過文件(夾)"), 7267, '提示 : 您可以在"全部文件"中分享文件(夾)'), 7268, "添加成員"), 7269, "創建項目完畢，請添加人員"), 7270, "獲取權限列表失敗"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7271, "該申請狀態已經改變，請刷新後查看"), 7272, "文檔關聯關係圖"), 7273, "您最近沒有訪問過文件"), 7274, "提示 : 您最近打開的文件會出現在這裡"), 7275, "添加卡片"), 7276, "暫無企業外部人員"), 7277, "您無權查看企業外部人員列表！"), 7278, "暫無企業外部人員或無權查看"), 7279, "文件地址："), 7280, "您在此處添加的人員會獲得訪問文件的權利，如果對方是巴別鳥註冊用戶則該文件會自動出現在對方的“我加入的分享”欄目中。無論是否註冊用戶他們都將收到郵件或者短信通知，並且系統將根據您添加的人員郵箱或手機號進行安全驗證，確保該人是您指定的訪問者"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7281, "點擊下面的按鈕打開鏈接分享，您將獲得一個鏈接地址，您可以将此鏈接地址通過郵件或者QQ等第三方通信手段進行傳播，獲得此鏈接的人員即可以通過此鏈接訪問文件。為了增加保密性，你可以設置口令密碼，此外也可以設置截止日期，到期鏈接自動失效。"), 7282, "被邀請人列表"), 7283, "鏈接地址"), 7284, "您可以複製此鏈接並通過微信或QQ分享給你的好友"), 7285, "發送鏈接"), 7286, "外部用戶"), 7287, "查看日誌"), 7288, "移除此用戶"), 7289, "通過郵件或短信發送此鏈接"), 7290, "立刻發送此鏈接"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7291, "文件地址："), 7292, "成員權限表"), 7293, "請求邀請用戶共享文件"), 7294, "邀請分享"), 7295, "鏈接分享"), 7296, "獲取權限列表失敗"), 7297, "標籤過濾"), 7298, "您還沒有創建或加入過團隊"), 7299, "未知錯誤，請稍後重試"), 7300, "文件最多保留10天"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7301, "搜索動態，按回車確認"), 7302, "密碼為1到20位字母，數字組成"), 7303, "未加入部門"), 7304, "沒有討論組"), 7305, "簡介被修改為"), 7306, "創建了文件夾"), 7307, "邀請參加討論"), 7308, "系統消息"), 7309, "增加成員失敗"), 7310, "輸入被邀請者的郵件地址，以逗號分隔(或按Enter鍵確認)，一次最多發送10個"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7311, "輸入被邀請者郵件或手機號"), 7312, "輸入被邀請者郵件地址和手機號"), 7313, "已添加 <em>{-num-}</em> 個"), 7314, "邀請發送成功"), 7315, "不是企業成員"), 7316, "已加入"), 7317, "邀請發送失敗"), 7318, "團隊創建成功。"), 7319, "手機號修改成功"), 7320, "郵箱修改成功"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7321, "很抱歉, 巴別鳥免費版只能創建2個團隊, 要創建更多團隊, 請升級至專業版"), 7322, "賬戶設置"), 7323, "重新發送"), 7324, "請填寫發到您郵箱里的驗證碼"), 7325, "請填寫發到您手機的驗證碼"), 7326, "新的手機註冊賬戶可以通過短信驗證碼來完成初始化密碼設置"), 7327, "請填寫發到您{-type-}的驗證碼"), 7328, "刪除標籤"), 7329, "標籤過濾"), 7330, "標籤刪除失敗"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7331, "標籤修改成功"), 7332, "引用"), 7333, "團隊名稱："), 7334, "團隊名稱（40個字以內)"), 7335, "團隊描述："), 7336, "團隊描述，一百字以內。"), 7337, "該團隊名稱已存在"), 7338, "名稱可用"), 7339, "團隊名稱過長"), 7340, "創建中"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7341, "請輸入團隊名稱"), 7342, "團隊名稱不能超過40個字符"), 7343, "描述不超過100個字符"), 7344, "您還沒有創建團隊"), 7345, "提示 ：創建團隊後您可以将相關企業人員添加為團隊成員"), 7346, "提示 ：創建團隊後您可以将相關企業人員添加為團隊成員"), 7347, "您還沒有加入過團隊"), 7348, "不是企業成員"), 7349, "已加入"), 7350, "添加失敗"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7351, "邀請發送失敗"), 7352, "沒有成員<br>無法轉讓！"), 7353, "未創建團隊"), 7354, "我加入的團隊"), 7355, "已加入"), 7356, "未找到匹配的團隊"), 7357, "該批注點數據有錯誤！"), 7358, "注意：已經切換到歷史版本"), 7359, "已經切換到當前版本！"), 7360, "下載中..."), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7361, "格式文件"), 7362, "請輸入協同密碼"), 7363, "下一頁面"), 7364, "上一頁面"), 7365, "向右转"), 7366, "向左转"), 7367, "網絡鏈接異常，請檢查網絡！"), 7368, "沒有刪除權限"), 7369, "批注點數據錯誤！"), 7370, "獲取顯示文件錯誤！"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7371, "文件{-fileName-}-打印準備中"), 7372, "您的文件"), 7373, "失敗! 文檔含有密碼，請去除密碼後再試!"), 7374, "生成預覽文件失敗"), 7375, "保存文件失敗"), 7376, "網絡繁忙，稍後再試！"), 7377, "發生未知錯誤"), 7378, "網絡錯誤或者服務器錯誤！"), 7379, "網絡連接有錯誤"), 7380, "邀請失敗，免費版的最大邀請限制 30 人，歡迎升級到不受限的專業版！"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7381, "發送失敗，免費版的最大發送人數限制 30 人，歡迎升級到不受限的專業版！"), 7382, "請等待..."), 7383, "輸入文件名"), 7384, "請輸入文件名..."), 7385, "了解更多"), 7386, "相關文件"), 7387, "其他方式登錄:"), 7388, "暱稱不能為空"), 7389, "暱稱不正確"), 7390, "請輸入6-20位包含大小寫字母及數字的組合"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7391, "密碼不能為空"), 7392, "請輸入6-20位包含大小寫字母及數字的組合"), 7393, "暱稱不存在"), 7394, "密碼錯誤"), 7395, "郵箱格式不正確"), 7396, "郵箱不能為空"), 7397, "圖片驗證碼不能為空"), 7398, "圖片驗證碼錯誤"), 7399, "郵箱不存在"), 7400, "密碼不匹配"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7401, "兩次輸入的密碼不一致"), 7402, "手機號不能為空"), 7403, "手機號格式錯誤"), 7404, "短信驗證碼不能為空"), 7405, "驗證碼錯誤"), 7406, "請輸入郵箱或手機號"), 7407, "手機號尚未綁定"), 7408, "用戶不存在"), 7409, "驗證碼已過期"), 7410, "此賬戶已凍結，禁止登錄"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7411, "郵箱或手機號格式錯誤"), 7412, "請輸入註冊的郵箱或手機號"), 7413, "驗證碼錯誤"), 7414, "驗證碼不能為空"), 7415, "您不是該企業的用戶"), 7416, "請選擇身份"), 7417, "請輸入企業名稱"), 7418, "請輸入聯繫人暱稱"), 7419, "請輸入聯繫人郵箱"), 7420, "請輸入域名"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7421, "企業名稱不能全是數字"), 7422, "僅支持輸入字母及數字"), 7423, "請輸入6-20位包含大小寫字母及數字的組合"), 7424, "找回密碼"), 7425, "請填寫您用來登錄的郵箱地址或手機號"), 7426, "獲取驗證碼來重新設置新密碼"), 7427, "密碼設置成功"), 7428, "沒有收到獲取驗證碼郵件？"), 7429, "請檢查郵箱地址是否正確"), 7430, "檢查您的郵件垃圾箱"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7431, "可能是本站的郵件系統繁忙或者故障，請稍候再試"), 7432, "若仍未收到確認，請嘗試重新發送"), 7433, "輸入新密碼"), 7434, "確認新密碼"), 7435, "文件"), 7436, "文件夾"), 7437, "發送失敗,請確認郵箱地址或手機號並重試"), 7438, "權限"), 7439, "團隊"), 7440, "確定要刪除選中的檔案文件嗎，檔案文件刪除後不可恢復?"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7441, '檢測到您還未登錄，請先<a class="link" href="/account/login.do">登錄</a>'), 7442, "你訪問的鏈接不存在或文件已取消分享!"), 7443, "您還可以:"), 7444, "返回首頁:"), 7445, "返回上一個頁面:"), 7446, "現在加入巴別鳥"), 7447, "開啟企業高效雲辦公"), 7448, "用技術改變工作和生活方式"), 7449, "巴別鳥是上海畫擎信息科技有限公司的註冊商標，上海畫擎成立於2012年，總部位於上海，2016年於北京設立分公司。巴別鳥是一個以技術為主導的團隊，創始人均來自北大方正，擁有國內創業團隊較強的圖形圖像技術。目前，巴別鳥已經完成了A輪投資，用戶數接近40萬，文檔數據量已突破1000TB。"), 7450, "圖形圖像領域的孜孜耕耘，高效工作方式的不懈探索，以及對產品用戶體驗的極致追求，造就了巴別鳥知識管理平台。你可以用巴別鳥存儲和管理工作文檔，快速共享企業知識，並能通過任意設備，直接在各種格式的文檔上協作討論。"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7451, "關於<span>巴別鳥</span>的小故事"), 7452, "巴別鳥的名字源於聖經中的巴別塔，傳說古代人類擁有統一的語言，一致的想法，一樣的價值觀，所以人類很強大以至於能集合全人類的力量在古巴比倫修建一座通天高塔，塔越修越高，上帝感到人類的齊心協力，統一強大會挑戰他的權威，所以推倒了巴別塔，讓人類說不同的語言，產生不一樣的思想，從此人類陷入了思想不一致造成的混亂和無息的戰爭中，再也沒有辦法修築高塔。巴別鳥是巴別塔修建過程中負責溝通各個環節的一種小鳥，能快速傳達巴別塔這浩大工程中的各種協作細節。現在，巴別鳥復活了，它存在於互聯網，它讓我們的溝通更緊密，也讓我們更加強大。"), 7453, "公司介紹"), 7454, "客服熱線"), 7455, "公司地址"), 7456, "公司名稱：上海畫擎信息科技有限公司"), 7457, "地址： 上海市嘉定區平城路1055號"), 7458, "郵編：201821 "), 7459, "電話：400-9204020（週一至週日 8:00 ～ 20:00）"), 7460, "媒體及推廣、投訴及建議"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7461, "聯繫人：皇甫珊欣"), 7462, "手機：13564686107"), 7463, "微信號：MolaSync"), 7464, "產品Bug及改進建議"), 7465, "電子郵件： support@molasync.com"), 7466, "官方QQ交流群： 512728617"), 7467, "培訓及諮詢"), 7468, "聯繫人： 張擁軍"), 7469, "手機：13261256900"), 7470, "微信號：zhangyjluck"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7471, "全部解壓"), 7472, "解壓到"), 7473, "解壓"), 7474, "水印顏色"), 7475, "預覽文件還未成功生成！請一分鐘後重新點擊嘗試！"), 7476, "上海總部"), 7477, "地址：上海市環城路762弄信業未來中心4號樓8棟7樓"), 7478, "上海研發中心"), 7479, "地址：上海市武寧南路488號1801"), 7480, "電話：13584686107"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7481, "北京分公司"), 7482, "地址：北京市東城區朝陽門銀河SOHO 3Q B區"), 7483, "成都分公司"), 7484, "地址：成都市青羊區光華中心C座 9樓"), 7485, "聯繫人：汪宇傑"), 7486, "電話：13982493667"), 7487, "巴別鳥（香港）國際"), 7488, "地址：香港特別行政區中西區夏愨道18號海富中心第二座寫字樓8F層"), 7489, "聯繫人：石芸青"), 7490, "電話：852-69968224"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7500, "網頁上傳一次不能超過 100 個文件（夾），請使用客戶端的同步文件夾功能進行同步！"), 7501, "請在文件詳情面板修改文件的安全級別"), 7502, "所謂私有文件，是指沒有放在部門裡或者企業公共文件夾中的文件，這種文件就屬於個人私有，其他人看不見，更不能訪問"), 7503, "這是必填字段"), 7504, "最多可以輸入 {0} 個字符"), 7505, "請輸入數字"), 7506, '文件名不能包含下列任何字符： \\ / : * ? " < > |'), 7507, "mac地址格式錯誤"), 7508, "請填寫正確的手機號碼"), 7509, "請填寫正確的電話號碼"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7510, "請填寫中文"), 7511, "請填寫正確的郵編"), 7512, "暱稱必須為2-20位的字符串"), 7513, "請輸入6-20位包含大小寫字母及數字的組合"), 7514, "請填寫正確的字母"), 7515, "角色名稱"), 7516, "這是必選項"), 7517, "審批人員不能為當前用戶"), 7518, "請輸入有效的日期"), 7519, "禁止跨企業移動文件！"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7520, "{-somebody-}將{-file-}移進了文件夾{-folder-}"), 7521, "{-somebody-}將{-file-}的訪問權限設置為{-role-}"), 7522, "給你分享了文件{-file-}"), 7523, "簽名"), 7524, "目標文件夾所有者的空間不足"), 7525, "含有子項目，不允許刪除"), 7526, "消息已被刪除"), 7527, "企業擁有者必須是管理員"), 8000, "定制屬於您的巴別鳥"), 8001, "企業服務的核心是服務企業，為了向企業提供更細緻的服務。我們推出了巴別鳥定制開發業務。幫助企業解除標準化產品的局限，大幅提高生產效率"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8002, "聯繫我們"), 8003, "從產品思維出發幫助您設計產品"), 8004, "不同行業有不同的工作流程及使用習慣，同時需求和最終的產品間往往也隔著很深的鴻溝。只有需求沒有好的產品設計往往會使項目遲遲無法落地。為了更好的適用於您的使用場景，我們職業產品經理帶隊的Babel care團隊會為您的企業定制屬於你的解決方案及二次開發支持。"), 8005, "強大的研發實力"), 8006, "我們擁有一個10人的定制開發支持團隊，主要成員均為巴別鳥系統的核心研發人員。來自於北大、交大、及成都理工大學。我們支持各種語言及各種平台的定制開發工作。在數據庫、雲計算、圖形圖像方面有自己的核心技術，尤其擅長算法。擁有大量各類系統的研發經驗。"), 8007, "精細化估時管理"), 8008, "我們擁有曾服務於北大方正的精細化估時管理體系，能精確的進行開發估時管理，提高項目成功率及落地效率。項目估時清晰有據可查，有效降低企業成本並提高效率。"), 8009, "透明的項目跟進及驗收"), 8010, "在項目的每一個階段，我們都有專職項目經理和產品經理跟進。確保項目進度及驗收標準。並且我們可以開放我們的jira（項目管理工具）給您，讓您隨時了解到項目的進度及耗時。"), 8011, "透明、專業、負責"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8012, "負責，是客戶給我們最多的和最高的評價。在項目維護期內，我們會站在企業角度考慮，及時對應修正bug並完成功能調整。為企業提供長期可持續的維護服務。"), 8013, "“巴別鳥定制開發系統解決了我們簽證文件自動提交並統一管理的問題。現在，用戶提交的簽證材料都可以安全有序的在我們系統中統一管理及快速查詢。”"), 8014, "他們在使用我們的定制系統"), 8015, "整合 讓我們無所不能"), 8016, "線上諮詢"), 8017, "下載API文檔"), 8018, "無需重新發明輪子"), 8019, "我們已經進入了開放平台的時代。使用巴別鳥API，您可以在您的系統中使用巴別鳥的幾乎所有能力。並在雲中構建自定義應用程序和集成，而無需構建和維護自己的內容管理服務。同時，巴別鳥也可以集成如電子簽名、高級CAD管理、office、文字識別圖形識別等第三方服務來解決您遇到的需求問題。"), 8020, "全系統接口化"), 8021, "巴別鳥的幾乎所有功能都可以通過API接口進行調用，配合單點登錄可以快速實現整合。我們的開發團隊也能提供相應的技術支持，幫助您快速對接巴別鳥。使得共享數字信息變得容易，並為您的客戶和團隊提供了一種安全的方式來直接在您自己的自定義應用程序中訪問，批註，共享和協作內容。"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8022, "將生產力和協作放在首位"), 8023, "工作往往圍繞著文檔展開，以文檔管理為入口整合各類產品就可以不用頻繁切換軟件或平台無縫享受各類SAAS服務。 巴別鳥可以按需接入only office、永中office、office365、cad、iWork、犀牛3D、浩辰CAD、天銳綠盾等大量生產力套件及應用程序。讓您不用在各個應用程序間copy文件、切換賬號即可滿足協作及編輯需求。"), 8024, "商業授權"), 8025, "想為您的客戶提供更多樣的服務？安全的內容存儲管理、銷售資料的展示、合同報價管理、代理商文件管理、企業知識管理、檔案庫、批註討論系統…使用巴別鳥商業授權服務，您的企業可以在巴別鳥系統基礎上開發自己的商業應用並進行銷售（支持私有化），讓企業快速擁有雲服務產品。"), 8026, "“我們在巴別鳥的基礎上結合永中office推出了永中優雲。讓我們的在线office系統具備了企業級文件管理功能，提供給我們客戶比office365更優的企業office解決方案。”"), 8027, "現在開始整合巴別鳥到您的系統"), 8028, "查看巴別鳥詳細功能列表"), 8029, "為企業量身定制"), 8030, "從技術到應用，知行合一"), 8031, "文件存儲"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8032, "協作及編輯"), 8033, "移動辦公"), 8034, "企業後台管理"), 8035, "數據安全"), 8036, "強大先進的文件存儲系統"), 8037, "幫助您快速搭建雲端工作環境"), 8038, "使用巴別鳥文件存儲系統的客戶端（Mac、windows）及APP（安卓、iOS），你可以快速和團隊及企業的其他部門建立文件共享環境，並且把工作文件同步到你及你同事的各個設備，保證團隊和個人的工作內容隨時保持最新。你可以把巴別鳥客戶端當做你的工作入口，在客戶端上直接打開雲端文件進行編輯並保存至雲端。你同事新建及更新的文件你也可以第一時間收到並在巴別鳥上進行討論。從此，你的文件數據將在雲端得到妥當保存，你和你同事的文件夾內容將保持一致，並且可以使用全文搜索快速找到你所需的文件。"), 8039, "點此下載Excel版本詳細功能列表"), 8040, "文件存儲詳細功能列表"), 8041, "跨平台，多終端"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8042, "PC、MAC、手機及平板客戶端，H5網頁版"), 8043, "自動備份，同步"), 8044, "指定任意文件夾雙向同步（雲端到本地，本地到雲端）<br>支持實時同步、手動同步<br>版本控制配合同步管理解決衝突"), 8045, "文件點對點快速傳輸"), 8046, "鼠標右鍵快速發送本地文件給任意用戶"), 8047, "大文件秒傳"), 8048, "內容相同的大文件快速秒傳"), 8049, "斷點續傳"), 8050, "網絡中斷可重連繼續原有進度傳輸"), 8051, "增強型文件管理"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8052, "預覽圖標、多維度排序、拖動上傳、文件屬性、置頂、複製移動刪除、鎖定…..."), 8053, "樹狀目錄"), 8054, "支持樹狀目錄顯示文件及文件夾，類似資源管理器和訪達的使用體驗"), 8055, "文件日誌"), 8056, "可單獨查看任一文件的日誌，了解文件生命周期的所有記錄"), 8057, "訪問統計"), 8058, "文件打開次數，訪問人數，下載次數，批注數目，訪問者列表"), 8059, "CDN加速及網絡優化"), 8060, "在全球任何地方都適配最近的節點以快速打開"), 8061, "在線預覽"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8062, "支持近200種格式的在線預覽，除普通office文件及圖片文件以外，支持蘋果office（iWork）及3D模型、矢量設計稿、CAD圖稿、PSD、AI等專業格式。支持音視頻文件在線播放"), 8063, "文件鎖定"), 8064, "正在編輯的文件自動鎖定，其他人不可編輯。也可手動鎖定某個文件，防止他人篡改"), 8065, "超大圖片在線預覽"), 8066, "5K甚至10K的大圖片直接在線打開原圖預覽。專利技術"), 8067, "在線批注討論"), 8068, "可以在文件預覽上直接批注、圈畫、甚至語音討論文件內容"), 8069, "在線編輯"), 8070, "文件的在線編輯及協同編輯，在app端也可以在線編輯"), 8071, "本地編輯自動上傳"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8072, "支持直接調用本地程序編輯在線的文件，編輯結果自動上傳"), 8073, "文件關注"), 8074, "可以提醒企業成員關注某文件及自己關注某文件，更新自動提示"), 8075, "文件收集箱，投件箱"), 8076, "彙總文檔、收取作業、權限可控的特殊文件夾"), 8077, "企業文件及個人文件分開管理"), 8078, "企業及部門文件夾及私人文件夾的區分"), 8079, "版本控制"), 8080, "無限多的文件歷史版本，可管理、下載、刪除、設為當前版本，支持版本log"), 8081, "共享標籤"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8082, "可為文件及文件夾設置多個標籤，快速查找，並且標籤通用，有權限的成員都可以調用"), 8083, "左側欄標籤列表"), 8084, "可添加標籤列表至左側欄，快速分類、定位文件"), 8085, "未讀文件提醒"), 8086, "未讀文件狀態提醒，其他成員新上傳文件不被遺漏"), 8087, "多級回收站"), 8088, "有效時間內（管理員可設）普通成員刪除的企業文件上級領導可還原或徹底刪除，按級別類推。"), 8089, "全文檢索"), 8090, "可搜索文檔及矢量圖稿中的文字內容，可搜索標籤及搜索指定範圍內的文件"), 8091, "文件權限"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8092, "可增設企業文件權限，細粒度的控制任意文件（文件夾）針對該文件參與共享人員所擁有的訪問、編輯、批注、打印、下載、有效期等權限"), 8093, "文件密級及安全級別"), 8094, "四個級別，可嚴格控制文件傳播"), 8095, "多語言"), 8096, "中文版及英文版"), 8097, "劃時代的協作方式"), 8098, "讓溝通更簡單、更高效"), 8099, "協作及編輯詳細功能列表"), 8100, "部門及團隊"), 8101, "可以按組織結構建立部門、並擁有相應從屬關係及帶權限管理的部門文件"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8102, "企業臨時組隊"), 8103, "通過創建項目，企業的成員可以實現跨部門隨意快速組合，用項目將不同部門的人組織起來，項目還可以進行跨部門移交"), 8104, "企業共享文件夾"), 8105, "整個企業（除受限人員）都可以訪問的公共空間"), 8106, "企業成員按設定自動共享文件"), 8107, "部門成員無需提醒可自動獲得最新的文件版本及動態通知，並可直接使用共享文件夾"), 8108, "文件鏈接分享"), 8109, "文件右鍵直接開啟鏈接分享，可設定鏈接有效期、密碼及多種訪問權限，並可通過微信及郵件分享"), 8110, "文件邀請"), 8111, "通過邀請分享文件給特定的人進行協作，非邀請賬號無法進入文件，被邀請者的使用權限可分別任意調整"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8112, "分享及邀請授權機制"), 8113, "沒有邀請/分享權限的用戶可以向有權限的用戶發送進行分享的授權請求"), 8114, "郵件系統"), 8115, "新文件上傳、新批註及討論、邀請及文件發送都可通過郵件發送到用戶郵箱，並可在郵箱中直接查看及使用"), 8116, "訪問日誌"), 8117, "協同批註討論"), 8118, "在文件內容上可以直接建立批註進行實時溝通討論，協同探討問題。支持文字、手繪、語音、附件等討論方式。討論內容可以按權限顯示及隱藏。"), 8119, "3D批註"), 8120, "在3D模型中可以建立基於三維坐標的批註進行討論，點擊批註點可回到用戶建立批註時的視角上"), 8121, "文件評論"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8122, "和動態列表中快速回覆。"), 8123, "動態"), 8124, "跟用戶本人相關的團隊信息及文件討論批註信息的匯總平台，在動態中可直接導航至相應文件查看，或快速回覆批註及評論。通過動態和團隊協同，更直接更簡單。"), 8125, "消息及提醒"), 8126, "、提醒關注、重要通知、邀請及授權等重要操作將會以消息通知的方式送達。幫助用戶摒棄雜音，關注最重要的事"), 8127, "對外協作"), 8128, "和兄弟公司或者和客戶建立協作。內部文件及外部文件分開標識、外部成員單獨管理、郵件手機號快速邀請。安全又高效"), 8129, "部門、項目及團隊群聊"), 8130, "類似微信群聊的以部門、項目及團隊為基礎的討論群，支持附件傳輸"), 8131, "及附件"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8132, "成員及傳輸附件，讓工作更專注"), 8133, "審批及審批流程"), 8134, "支持文件審批，可預設審批流程，無論是分組審批還是順序審批都支持。審批後文件直接定稿不可更改"), 8135, "文件定稿"), 8136, "審批通過的文件即為定稿文件，定稿文件不可修改，方便開發及生產部門確定並留下憑據。"), 8137, "企業公告"), 8138, "簡單快速發表企業公告，快速傳達給企業成員"), 8139, "協作成員管理"), 8140, "所有的文件分享協作都可以快捷管理參與協作的成員，改變成員權限、增加刪除參與成員。"), 8141, "基於組織結構的協同"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8142, "企業內部協作可以導入組織結構，可以根據組織結構的從屬關係快速建立協同關係及分配權限"), 8143, "在線協同編輯"), 8144, "支持office文檔的在線協同編輯，清晰標示修改點，共同完成一個文檔"), 8145, "共屏演示"), 8146, "針對遠程會議支持共屏演示，開啟後參與者視角和演示者一致，可使用畫筆及光槍標註重點內容"), 8147, "得心應手無所束縛"), 8148, "用手機和Pad就能完成大多數工作"), 8149, "巴別鳥全功能移動端，不僅具有web端所有功能，還有語音批註、配合觸摸屏的優質手寫批註等移動設備專屬功能。讓你隨時隨地都可以打開多達200種格式的文件並在上面和團隊討論。無需安裝任何其他應用程序就可以在線編輯office文檔。針對iPad屏幕，巴別鳥更優化了體驗，左邊文件結構和動態右邊文件內容的設計讓移動端的使用體驗更佳。支持win10的客戶端還可以讓你的surface如虎添翼。使用巴別鳥移動端，你可以把整個企業的文件和團隊的智慧帶在身上，可以隨時隨地檢查下屬剛做好的方案、調取最新的設計稿給客戶、遠程演示一個PPT、審批通過最新的預算。當然，我們支持微信。"), 8150, "移動辦公詳細功能列表"), 8151, "安卓、iOS平台、微信0全覆蓋"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8152, "支持安卓設備，iPhone及為iPad定制的pad版本。支持H5"), 8153, "windows10及Mac"), 8154, "在surface平板及蘋果筆記本上可以使用客戶端並同步"), 8155, "原生APP，執行效率更高"), 8156, "巴別鳥移動端都是專門為目標系統編寫的原生APP，非嵌套網頁"), 8157, "全功能移動端"), 8158, "無論是客戶端還是移動端，都支持web版的所有功能"), 8159, "為移動而生"), 8160, "移動端支持創建語音批註、相機拍照上傳、直接拍照附件"), 8161, "為iPad定制的界面，神級交互"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8162, "巴別鳥在iPad上體驗極佳，橫屏左側顯示文件列表，右側文件內容，快速切換高效協作。使用iPad開始辦公吧"), 8163, "從其他App打開文檔"), 8164, "微信和QQ等app的文檔可以用巴別鳥打開並上傳"), 8165, "移動端下載文件並轉發"), 8166, "在巴別鳥移動端下載的文件可以直接轉發至微信"), 8167, "用移動端分享文件"), 8168, "移動端可以直接通過微信分享文件還可以直接發朋友圈"), 8169, "在線編輯"), 8170, "移動端可以打開office文檔進行在線編輯，無需安裝其他軟件"), 8171, "在線預覽"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8172, "網頁版能預覽的大多數文件在移動端也能預覽（除3D文件以外的近200種）"), 8173, "直接批註討論"), 8174, "在巴別鳥移動端打開的文件上單擊就可以直接批註討論，並管理批註點"), 8175, "水印顯示"), 8176, "移動端打開的文件也支持水印"), 8177, "極致快速瀏覽文件"), 8178, "上下翻頁，左右切換文件，多個文件間快速切換，更符合移動端使用習慣"), 8179, "手繪，移動端更佳"), 8180, "配合移動設備的觸摸屏，在巴別鳥APP打開的文件上可手繪圈住討論，體驗更佳。"), 8181, "全文搜索"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8182, "移動端也可以快速全文搜索所有權限內可查閱文件，無需翻找"), 8183, "標籤、關注、評論一個不少"), 8184, "真正全功能，所有功能在移動端一個不少還更強大"), 8185, "部門及團隊群聊"), 8186, "和微信接近的群聊體驗，更符合用戶使用習慣"), 8187, "日誌查看"), 8188, "在移動端同樣可以查看日誌，進行管理"), 8189, "通知中心"), 8190, "使用移動端可以隨時接收到聊天信息及文件更新通知，實時了解團隊動態"), 8191, "私有化也可以使用APP"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8192, "簡單配置後，移動端也可以為私有化用戶提供服務"), 8193, "為企業而生"), 8194, "符合企業管理細節要求的企業管理後台，統一管理整個企業"), 8195, "企業logo替換"), 8196, "從登錄界面到使用界面及分享開啟頁面都可使用用戶企業logo，統一專業，兼顧企業形象"), 8197, "獨立二級域名"), 8198, "每個企業擁有自己的獨立入口，不易混淆更專業"), 8199, "企業概況"), 8200, "一目了然顯示企業的使用情況，空間占用情況"), 8201, "多級管理員"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8202, "企業擁有者賬號、企業管理員、檔案管理員、運維管理員、安全保密員、安全審計員等多種管理員身份，精細化分配管理權限，做到滴水不漏"), 8203, "預設安全策略"), 8204, "5種安全策略可選，從流程到權限分配保護企業的數據"), 8205, "組織結構"), 8206, "按組織結構分配部門及文件結構，不同部門可以選用不同的安全策略"), 8207, "部門管理"), 8208, "詳細管理部門的空間使用、人員、管理者、子部門、安全策略"), 8209, "管理員分權"), 8210, "管理員可分權至部門，由部門管理自己的使用情況，並指定部門管理員。為IT維護人員分擔工作。"), 8211, "成員管理"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8212, "可管理企業所有成員，內部及外部成員"), 8213, "批量添加、批量編輯"), 8214, "可批量添加導入企業成員，快速建立賬號，郵件自動通知成員"), 8215, "一鍵轉移"), 8216, "離職成員文件一鍵轉移一鍵交接給其他成員"), 8217, "快速停用"), 8218, "可批量快速停用特定員工賬戶"), 8219, "搜索及篩選"), 8220, "強大的搜索及篩選工具，方便快速管理成員"), 8221, "空間限制"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8222, "可以限制每個用戶的私人存儲空間，以優化空間分配"), 8223, "角色及權限管理"), 8224, "可定制角色及相應的權限，多達40種細節權限可選並調整"), 8225, "標籤管理"), 8226, "管理或新建整個企業的共享標籤，並查看標籤使用情況"), 8227, "審批管理"), 8228, "預設審批流程，管理已有審批流程並查看使用情況"), 8229, "分組管理"), 8230, "企業的成員可以隨意快速組合，臨時組建項目小組。並管理已有分組，在分組中增刪成員"), 8231, "水印設置"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8232, "支持文字水印、查看者用戶ID水印、圖片水印。能管理水印的適用範圍、使用方式、顯示方式及透明度等信息"), 8233, "mac地址綁定"), 8234, "設立mac地址池，讓企業特定員工在特定的設備上才能訪問巴別鳥"), 8235, "訪問日誌"), 8236, "詳細記錄了整個企業的巴別鳥使用日誌，詳細可查。支持搜索及多種篩選方式。可導出。"), 8237, "為保密企業定制的安全系統"), 8238, "從權限分配到使用，從傳輸到存儲。巴別鳥提供最專業的安全保護"), 8239, "每個文件獨立的訪問控制"), 8240, "能獨立查看及管理每個文件的訪問控制，並追加或改變訪問權限"), 8241, "文件安全級別設置"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8242, "可設置任意一個企業文件的安全級別，公開、內部、限制、保密四個級別可選，不同級別對應不同的安全策略。從文件級保證文件的安全"), 8243, "每個文件獨立可查的日誌"), 8244, "日誌粒度細到文件，可以查看每個文件的詳細訪問日誌"), 8245, "配合批註，僅可查看也能完成溝通"), 8246, "巴別鳥支持大多數文件的預覽，並且可以在文件內容上直接批註提意見討論，意味著只要不是文件編輯者，無需開啟下載權限即可完成工作。使用巴別鳥可以關閉下載權限，最大限度保證文件不外泄"), 8247, "文件訪問者統計"), 8248, "不管是內部成員還是外部成員甚至匿名用戶，文件的訪問者都能在文件屬性中統計及查看（匿名用戶顯示IP）"), 8249, "真水印"), 8250, "不同於一般網盤在前台界面顯示的水印，巴別鳥的水印是嵌入文件的，並且能設置開啟查看者的ID作為水印，能有效的保證文件不被截屏傳播。"), 8251, "分享權限及加密"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8252, "文件右鍵直接開啟鏈接分享，可設定鏈接有效期、密碼及多種訪問權限控制"), 8253, "安全的邀請方式協作"), 8254, "通過邀請分享文件給特定的人進行協作，非邀請賬號無法進入文件，被邀請者的使用權限可分別任意調整"), 8255, "分享及邀請可授權"), 8256, "分享及邀請可開啟授權，讓重要文件的分享行為可以管理"), 8257, "分享行為管理"), 8258, "精確到文件的分享行為管控，可查看管理文件及文件夾的所有分享記錄"), 8259, "離職員工一鍵交接"), 8260, "離職員工文件一鍵交接給交接人，同時保留離職員工的聊天及批註數據"), 8261, "內部文件及外部文件區分"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8262, "巴別鳥能區分內部文件（企業的文件及員工的私人文件）及外部文件（其他企業或合作夥伴上傳的文件）保證文件的來源"), 8263, "版本控制"), 8264, "文件改動都永久保存老版本，防止失誤造成的文件覆蓋"), 8265, "回收站控制"), 8266, "有效時間內（管理員可設）普通成員刪除的企業文件上級領導可還原或徹底刪除，按級別類推。"), 8267, "多管理員結構"), 8268, "防止管理員權限過大或不熟悉業務造成安全隱患。巴別鳥從全盤管理到管理人、管理文件、管理安全幾個方面把管理員分為企業管理員、檔案管理員、運維管理員、安全保密員、安全審計員等多種管理員身份。適應不同企業需求"), 8269, "文件擁有者是部門及企業"), 8270, "巴別鳥的文件擁有者是部門及企業，部門及企業擁有最高權限"), 8271, "安全策略"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8272, "5種安全策略可選，從流程到權限分配保護企業的數據，不同部門可以設定不同的安全策略，僅有安全保密員才可設定部門安全策略"), 8273, "詳細日誌查看"), 8274, "詳細記錄了整個企業的巴別鳥使用日誌（操作記錄），可導出作為憑據。可以篩選查看特定成員的訪問情況"), 8275, "二次驗證"), 8276, "可以通過手機短信進行賬號二次驗證"), 8277, "受限成員"), 8278, "受限成員不可訪問企業公共文件夾，不可接收企業動態"), 8279, "外部成員管理"), 8280, "可以分開管理非企業成員，了解外部成員訪問情況，刪除或更改外部成員權限"), 8281, "角色及權限細化管理"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8282, "支持自定義角色，及多達40項角色權限的可選管理"), 8283, "成員使用空間控制"), 8284, "精確的控制每個成員的可用空間"), 8285, "mac地址綁定"), 8286, "可以綁定用戶賬號到某一mac地址或mac地址池，限定特定用戶僅可在特定設備訪問"), 8287, "傳輸存儲全鏈路加密"), 8288, "文件上傳下載使用HTTPS作為傳輸協議，傳輸過程中對文件本身進行了二次AES CTR 256算法流式分塊加密，確保最終保存在雲存儲系統的文件均為密文，在傳輸以及存儲過程中杜絕被竊取可能"), 8289, "最高級別的EV"), 8290, "使用最高級別的EV SSL傳輸認證 獲得國外第三方評測機構Qualys A+安全評定"), 8291, "多重備份"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8292, "公有雲使用阿里OSS存儲服務，同一份數據分佈式存儲於4個節點私有雲可選採用分佈式存儲及raid陣列進行數據備份，確保硬件損傷不丟失數據"), 8293, "MD5哈希校驗"), 8294, "存儲文件在服務器端均進行MD5哈希校驗，確保文件獨一無二，防止篡改"), 8295, "碎片化存儲"), 8296, "文件被打碎存儲在不同的服務器中，確保硬盤copy的方式無法獲得完整的數據以保證安全"), 8297, "容災消災"), 8298, "公有雲基於阿里提供的容災消災服務，強大的異地容災備份功能，可快速完成數據切換而不影響用戶的文件使用，緊急情況下迅速對用戶數據進行還原"), 8299, "分佈式數據庫"), 8300, "分佈式數據庫保證數據庫的穩定安全及讀寫速率，可在數據庫受損的情況下快速還原"), 8301, "雲盾防護"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8302, "公有雲使用阿里雲盾防護，防止黑客入侵及DDOS攻擊"), 8303, "數據遷移"), 8304, "提供數據遷入及數據遷出服務"), 8305, "多服務器陣列"), 8306, "功能及服務分佈在多台服務器上，確保單一服務器出錯不影響其他功能模塊"), 8307, "多監控平台"), 8308, "使用阿里、雲智慧等多個第三方監控平台監控整個系統的運作情況，異常及時短信通知預警，運維人員7*24小時待命，確保平台穩定。"), 8309, "第三方安全掃描"), 8310, "使用Qualys等第三方平台定期掃描，尋找漏洞，並及時補救"), 8311, "大峰值訪問災備"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8312, "公有雲突發大峰值訪問能自動增加服務器運算量，並限制單用戶帶寬，確保企業用戶的可訪問性"), 8313, "使用企業公有雲版，效率更高，管理更細"), 8314, "免費試用"), 8315, "巴別鳥可以不安裝任何應用直接打開並預覽200多種格式的文件。更妙的是，巴別鳥可以在打開的文件內容上直接點擊建立批註，當你建立完批註後你的所有協作夥伴都能收到通知並參與進來一起討論文件中的細節。無論是一個產品原型圖，還是一個演講稿，所有有權限的參與者都能在上面用語音、手繪、文字的形式各抒己見，並支持附件。同時，所有和你相關的工作文件的變動及討論你都可以在動態中及時看到並直接回覆，支持"), 8316, "無論是鏈接分享（匿名訪問顯示IP地址）、還是邀請及部門內訪問，所有操作都有日誌可以查看及管理"), 8317, "企業的執行力靠的就是紀律"), 8318, "全方位的為企業存儲及協作制訂規則"), 8319, "巴別鳥企業版擁有一個強大的企業管理後台，在這裡，你不僅能為每一個使用成員分配空間，了解空間用量。並且能快速導入企業成員及建立組織結構、管理成員的權限、預設安全策略。還可以設置審批流程，管理標籤及限制用戶使用的設備。多種類型的管理員預設及分權管理在降低iT人員維護工作量的同時提升了系統安全性。多達40種可選角色權限能清晰的控製每個成員角色的責任及權限。可以說，巴別鳥擁有了目前國內網盤系統中最为強大可調的後台管理系統，幫助企業實現精細化管理。"), 8320, "企業後台管理詳細功能列表"), 8321, "為保密企業定制的安全系統"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8322, "巴別鳥能提供最專業的安全保護"), 8323, "我們深知數據安全對企業的重要，也把安全放在整個系統的基礎位置上。每新增一項功能，首要考慮的就是它是否有安全漏洞，對系統安全有何影響。為了用戶看不見的安全，我們寧可犧牲部分系統性能，使用最麻煩的開發方式，付出更多成本。當然我們也獲得了回報，巴比鳥在Qualys安全測評中獲得A+評級，是國內企業網盤中得分最高的。同時爭取到了對數據安全要求極高的保密企業訂單。從權限分配到使用，從傳輸到存儲，巴別鳥能提供最專業的安全保護!"), 8324, "數據安全詳細功能列表"), 8325, "文件訪問安全策略"), 8326, "數據傳輸及存儲安全"), 8327, "運維安全策略 "), 8328, "成員及部門安全策略"), 8329, "請選擇你想要註冊的版本"), 8330, "個人版"), 8331, "個人文件存儲、快速加入協作"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8332, "免費"), 8333, "滿足個人基本的使用需求。簡單、方便、安全。可升級至專業版獲得更大存儲空間及更強功能。"), 8334, "立即註冊"), 8335, "企業公有雲版"), 8336, "精細管理企業成員，聚焦中小企業"), 8337, "/人/月"), 8338, "充裕的存儲空間，強大的後台管理及權限管控體系，獨立的訪問域名，為企業打造專屬雲服務。"), 8339, "30天免費試用"), 8340, "了解各版本差異"), 8341, "身份驗證"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8342, "需要身份驗證後才能加入邀請"), 8343, "”經過多輪產品篩選後我們最終選擇了巴別鳥作為我們數據存儲核心，細緻的服務和功能全面的產品是我們做出選擇的原因。“"), 8344, "—中日友好醫院 夏主任"), 8345, "/人/月"), 8346, "檢測到您的手機號已經註冊了巴別鳥專業版，若您想升級您的帳戶為企業版，請聯繫客服。"), 8347, "檢測到您的手機號已經註冊了巴別鳥專業版，若您想升級您的賬戶為企業版，請聯系客服。"), "8347", "<p>\u60A8\u7684\u624B\u6A5F\u865F\u5DF2\u7D93\u8A3B\u518A\u4E86\u5DF4\u5225\u9CE5\uFF0C\u8ACB\u78BA\u5B9A\u662F\u5426\u628A\u8A72\u8CEC\u865F\u5347\u7D1A\u70BA\u4F01\u696D\u7248\uFF1F</p> \n  <p>\u9078\u201D\u662F\u201C\u5C07\u9032\u884C\u5347\u7D1A\u64CD\u4F5C\uFF0C\u6B64\u64CD\u4F5C\u4E0D\u53EF\u9006\u4E26\u6709\u53EF\u80FD\u9020\u6210\u6578\u64DA\u4E1F\u5931\uFF0C\u8ACB\u6CE8\u610F\u5099\u4EFD\u6578\u64DA\u3002</p> \n  <p>\u5982\u679C\u60A8\u4E0D\u60F3\u5347\u7D1A\u8A72\u8CEC\u865F\uFF0C\u8ACB\u9078\u201D\u5426\u201C\u5F8C\u63DB\u500B\u624B\u6A5F\u865F\u8A3B\u518A\u4F01\u696D\u7248\u3002</p>"), 8348, "可自己添加企業成員賬號"), 8349, "您所操作的文件不存在或者已經被刪除了"), 8350, "更新失敗，該手機號已經存在"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8351, "這個手機號沒有註冊過巴別鳥，點擊去註冊我們將跳轉到註冊頁面。如過您還有其他巴別鳥賬號，可以使用其他賬號登錄，在設置裡綁定手機號進行登錄。"), 8352, "使用其他賬號登錄"), 8353, "去註冊"), 8354, "創建了本文件"), 8355, "你沒有權限或者該文件配置不支持此操作"), 8356, "你沒有權限或者該文件配置不支持此操作"), 8500, "將文件{-fileName-}提交到企業發送端口{-identifier-}，申請發送文件，已審核"), 8501, "發送列表"), 8502, "接收列表"), 8503, "提交日期"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8504, "審核日期"), 8505, "審核日期"), 8506, "等待發送中"), 8507, "接收日期"), 8508, "企業未設置發送端口"), 8509, "企業未設置接收端口"), 8510, "傳輸"), 8511, "同步"), 8512, "全部動態"), 8513, "文件批註"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8514, "點擊可後退"), 8515, "點擊可前進"), 8516, "操作失敗，你沒有權限清空該賬戶所有權限"), 8517, "高級"), 8518, "高級搜索"), 8519, "輸入要搜索的關鍵字，多個關鍵字用空格分割"), 8520, "只顯示包含全部關鍵字的搜索結果"), 8521, "搜索關鍵字"), 8522, "按創建時間或拍攝時間進行搜索"), 8523, "限定要搜索的文件更新時間"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8524, "文件格式"), 8525, "選擇要搜索的文件類型"), 8526, "上傳者"), 8527, "搜索範圍"), 8528, "手動選擇搜索文件夾"), 8529, "搜索類型"), 8530, "文件內容（全文）"), 8531, "點擊選擇成員"), 8532, "選擇上傳者"), 8533, "拍攝時間"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8534, "尺寸"), 8535, "分辨率"), 8536, "設備型號"), 8537, "色彩空間"), 8538, "地點"), 8539, "更多信息（元數據）"), 8540, "全部尺寸"), 8541, "大尺寸（4K+）"), 8542, "中尺寸（1080P）"), 8543, "小尺寸"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8544, "最多可指定5個上傳者"), 8545, "office文檔（包括wps文檔）"), 8546, "PDF文檔"), 8547, "圖片文件"), 8548, "音視頻文件"), 8549, "輸入擴展名,多個用','隔開"), 8550, "自定義類型"), 8551, "請輸入搜索關鍵字"), 8552, "請選擇搜索類型"), 8553, "最近訪問時間"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8554, "請選擇部門"), 8555, "企業新建文件統計"), 8556, "取消篩選"), 8557, "拍攝地點"), 8558, "（文件最多保存30天）"), 8559, "正在加載圖片元數據"), 8560, "清空失敗，你沒有清除剩餘文件的權限"), 8561, "已執行{-cur-}/{-total-}"), 8562, "已執行{-cur-}"), 8563, "請選擇您要搜索的文件夾"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8564, "僅查看移動及複製"), 8565, "接收狀態由收件人確認，收件人接收後，發件人將不能更改上傳的文件。"), 8566, "僅查看部門變更"), 8567, "此功能需要有短信通道支持，請聯繫客服人員"), 8568, "可編輯自己的文件"), 8569, ""), 8570, "從已選模板中創建"), 8571, "查看可訪問當前文件（夾）的人"), 8572, "人員來源"), 8573, "僅查看文件名"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8574, "本項目"), 8575, "分享參與者"), 8576, "僅使用自定義權限"), 8577, "你沒有預覽該文件的權限"), 8578, "操作失敗，你在該目錄下沒有權限創建文件夾或文件"), 8579, "標籤設置"), 8580, "樣式設置"), 8581, "示例"), 8582, "圖標大小"), 8583, "標籤背景顏色"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8584, "標籤內容"), 8585, "使用默認設置"), 8588, "無背景"), 8589, "深灰"), 8590, "殷紅"), 8591, "深藍"), 8592, "紫紅"), 8593, "亮黃"), 8594, "淺綠"), 8595, "淺灰"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8596, "淡藍"), 8597, "純黑"), 8600, "文件下載中，請稍後"), 8601, "文件下載中..."), 8602, "下載完成"), 8603, "下載完畢"), 8604, "下載成功"), 8605, "暫停下載"), 8606, "重新下載"), 8607, "待下載"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8650, "正在導出"), 8651, "正在導出,請稍後"), 8660, "打開方式"), 8661, "共享及協作"), 8662, "整理"), 8663, "清空歷史記錄"), 8664, "清空歷史記錄"), 8665, "刪除此記錄"), 9500, "域控同步"), 9501, "域賬號管理"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 9502, "域服務器配置"), 9503, "同步域賬號"), 9504, "加入巴別鳥"), 9505, "將所有人導入巴別鳥"), 9506, "昵稱"), 9507, "組織名稱"), 9508, "暫未同步任何域賬號"), 9509, "暫無符合條件的查詢結果"), 9510, "昵稱（郵箱）"), 9511, "是否巴別鳥賬號"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 9512, "域服務器地址"), 9513, "登錄賬號"), 9514, "登錄密碼"), 9515, "鏈接測試"), 9516, "連接成功"), 9517, "導入中..."), 9518, "導入成功"), 9519, "導入失敗，請稍後重試"), 9520, "同步中..."), 9521, "連接失敗，請修改參數後重試"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 9522, "暫無域賬號"), 9600, "很抱歉，我們不支持超過100個文件或大小超過500MB的文件夾打包下載。您可以打開文件夾單個下載文件，或聯繫超級管理員獲取客戶端進行下載"), 9900, "點擊更換圖片驗證碼"), 9901, "私有雲入口"), 9902, "使用郵箱或手機密碼登錄"), 9904, "登錄私有雲"), 9905, "請輸入您所在企業的域名"), 9906, "企業域名"), 9907, "我已閱讀並接受"), 9908, "巴別鳥積極響應國家淨網行動號召，將大力整治系統中的非法內容。用戶所有上傳內容都將經過AI自動鑒別，有淫穢色情信息內容的賬號一律自動封號，並向公安機關報備"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 9909, "設置一個密碼"), 9950, "忽略"), 9951, "當前頁面已經更新"), 9952, "區域"), 9953, "正在重置..."));
var _default = exports["default"] = localString_cn_part2;

},{"1180":1180,"1184":1184,"1454":1454}],1160:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var localString_cn_part1 = {
  0: "巴別鳥",
  1: "文件",
  2: "動態",
  3: "團隊討論",
  4: "部門討論",
  5: "設置",
  6: "退出登錄",
  7: "新建",
  8: "文件夾",
  9: "上傳文件",
  10: "上級目錄",
  11: "全部文件",
  12: "目錄",
  13: "分享",
  14: "詳情",
  15: "排序",
  16: "搜索文件，按回車確認",
  17: "我的團隊",
  18: "部門及項目",
  19: "我的分享",
  20: "我加入的分享",
  21: "星標文件",
  22: "回收站",
  23: "標籤",
  24: "標籤管理",
  25: "訪問者",
  26: "最近修改",
  27: "大小",
  28: "上傳新版本",
  29: "下載",
  30: "重命名",
  31: "移動",
  32: "刪除",
  33: "複製到",
  34: "添加星標",
  35: "查看版本",
  36: "置頂",
  37: "更多",
  38: "預覽",
  39: "獲取分享鏈接",
  40: "查看詳情",
  41: "創建於",
  42: "批註",
  43: "未讀批註",
  44: "讚好",
  45: "標籤管理",
  46: "點擊{-tagMgr-}可設置標籤在此處顯示",
  // {-variable-} 這一部分是將來被替換的變量 
  47: "升級至專業版",
  48: "網絡不通暢",
  49: "文件名",
  50: "帳戶管理",
  51: "個人資料",
  52: "更改密碼",
  53: "忘記密碼",
  54: "存儲空間",
  55: "我的空間",
  56: "已用空間",
  57: "剩餘空間",
  58: "個人私有文件占用空間",
  59: "團隊占用空間",
  60: "參與分享占用空間",
  61: "用戶類型",
  62: "免費版用戶",
  63: "個人通知",
  64: "接受巴別鳥發送郵件到我的郵箱",
  65: "團隊管理",
  66: "創建團隊",
  67: "刪除團隊",
  68: "創建者",
  69: "我",
  70: "團隊成員",
  71: "添加成員",
  72: "超級管理員",
  73: "設置",
  74: "返回",
  75: "開放式鏈接分享",
  76: "知道此鏈接的任何人都可以批註",
  77: "知道此鏈接的任何人都可以編輯",
  78: "知道此鏈接的任何人都可以批註並下載",
  79: "知道此鏈接的人都可以查看",
  80: "複製鏈接",
  81: "了解權限",
  82: "訪問此鏈接需要輸入密碼",
  83: "邀請共享人",
  84: "輸入暱稱或電子郵件",
  85: "可以編輯",
  86: "可批註並下載",
  87: "可以批註",
  88: "可以查看",
  89: "完成",
  90: "管理參與者",
  91: "已輸入 {-curCount-} 人，最多 {-maxCount-} 人",
  92: "打開分享鏈接和邀請分享後，可以分別控制和管理每個受邀共享者的訪問權限",
  93: "禁止編輯者修改權限和添加新用戶",
  94: "",
  95: "查看通過鏈接訪問的人員",
  96: "關閉鏈接分享",
  97: "邀請共享用戶",
  98: "查找受邀用戶",
  99: "分享時間",
  100: "左側欄顯示標籤",
  101: "左側欄暫無標籤顯示，可再次點擊 {-newTag-} 或從“{-allTag-}”中拖拽標籤至此添加到左側欄標籤",
  102: "全部標籤",
  103: "我使用過的標籤",
  104: "他人共享的標籤",
  105: "暫無標籤，可點擊{-addTag-}",
  106: "添加標籤",
  107: "可通過拖拽將標籤添加至{-leftTag-}",
  108: "正在生成預覽文件，請稍後再試",
  109: "文字批註",
  110: "版本信息",
  111: "隱藏批註",
  112: "全屏",
  113: "共{-num-}個批註",
  114: "當前文檔批註",
  115: "當前文檔未讀批註",
  116: "全部批註",
  117: "未讀批註",
  118: "輸入批註內容",
  119: "設置為完成",
  120: "刪除",
  // ---- 刪除批註調用 
  121: "{-second-}秒前",
  122: "點擊添加回復",
  123: "回車快速回復",
  124: "回復",
  125: "清屏",
  126: "你添加了圖文批註",
  128: "評論",
  129: "語音批註",
  130: "手繪批註",
  131: "已完成",
  132: "未完成",
  133: "通過",
  134: "駁回",
  135: "根目錄",
  136: "打開所在目錄",
  137: "我上傳的",
  138: "僅標籤",
  139: "專業版",
  140: "反饋",
  141: "下載iOS App",
  142: "下載安卓App",
  143: "下載桌面版",
  144: "我的關注",
  145: "文件收集箱",
  146: "我的審批",
  147: "標籤添加成功",
  148: "標籤添加失敗，請稍後重試",
  149: "移除標籤成功",
  150: "移除標籤失敗，請稍後重試",
  151: "文件已取消分享或您已經不在此分享中",
  152: "權限不足",
  153: "針對當前文件夾，您沒有此操作權限!",
  154: "確定",
  155: "取消",
  156: "關閉",
  157: "您收到新的消息",
  158: "名稱",
  159: "所在目錄",
  160: "當前文件夾為空",
  161: "提示：你可以在此",
  162: "或者",
  163: "新建文件夾",
  164: "在您的文件或文件夾中，找不到與此搜索條件相符的結果",
  165: "請嘗試其它搜索條件",
  166: "未讀",
  167: "您沒有打開該文件的權限",
  168: "操作失敗，請檢查網絡或者F5刷新頁面後重試",
  169: "您已失去對該文件的操作權限，此頁面即將關閉",
  170: "提示",
  171: "拖放至此立即移動到當前目錄",
  172: "拖放至此立即上傳到當前目錄",
  173: "暫時只支持文件上傳",
  174: "共{-count-}個批註",
  175: "{-count-}個未讀",
  176: "截止日期",
  177: "無",
  178: "外部文件",
  179: "點擊查看訪問者",
  180: "設置文件收集箱",
  181: "啟動審批",
  182: "查看審批",
  183: "取消置頂",
  184: "將文件置頂",
  185: "討論組",
  186: "管理團隊",
  187: "查看團隊",
  188: "文件已被我鎖定",
  189: "文件已被 {-user-} 鎖定",
  190: "分享人 {-user-}",
  191: "已分享",
  192: "已打開邀請分享",
  193: "已打開鏈接分享",
  194: "分享自{-user-}",
  195: "鏈接分享已關閉",
  196: "獲取分享鏈接地址",
  197: "請進入文件夾選擇其中的文件進行查看！",
  198: "個人版不支持文件收集箱，請升級到企業版！",
  199: "只有企業版支持文件審批功能，您可以開啟企業版使用此功能",
  200: "該討論組只允許指定的人進入，請聯繫管理員",
  201: "你並沒有加入該分享討論組，請點擊分享獲取分享鏈接，通過鏈接進入",
  202: "企業成員",
  203: "管理成員",
  204: "內部成員",
  205: "外部人員",
  206: "在線用戶",
  207: "查看詳情",
  208: "超級管理員",
  209: "管理",
  210: "檔案管理員",
  211: "企業擁有者",
  212: "添加超級管理員",
  213: "管理超級管理員",
  214: "帳戶",
  215: "聯繫方式",
  216: "身份",
  217: "操作",
  218: "添加檔案管理員",
  219: "管理檔案管理員",
  220: "警告",
  221: "確認刪除{-user-}的超級管理員身份",
  222: "確認刪除{-user-}的檔案管理員身份",
  223: "不能在當前頻道創建文件!",
  224: "同步管理",
  225: "文件加密上傳中...",
  226: "上傳完畢",
  227: "窗口關閉後，文件會取消上傳，確認關閉嗎?",
  228: "待上傳...",
  229: "重傳",
  230: "上傳完畢，正在生產預覽文件...",
  231: "已取消",
  232: "上傳失敗",
  233: "空間超限",
  234: "上傳成功",
  235: "批註列表",
  236: "全屏",
  237: "隱藏批註",
  238: "編輯文件",
  239: "演播",
  240: "分享文件",
  241: "請了解",
  242: "查看讚好人員",
  243: "取消關注",
  244: "提醒關注",
  245: "顯示更多標籤",
  246: "標籤刪除成功",
  247: "標籤添加成功",
  248: "讚",
  249: "請填寫標籤名",
  250: "同名標籤已存在",
  251: "選擇要提醒的人或直接輸入",
  252: "輸入評論",
  253: "所有人",
  254: "暫時沒有評論",
  255: "無權評論該文件",
  256: "審批",
  257: "永久刪除",
  258: "標記已讀",
  259: "開啟審批",
  260: "重新開啟審批",
  261: "審批中(點擊查看進度)",
  262: "文件訪問控制",
  263: "鎖定文件",
  264: "解鎖文件",
  265: "打開所在文件夾",
  266: "打開本地文件夾",
  267: "同步到本地",
  268: "取消同步",
  269: "新建文本文件",
  270: "新建 Word 文檔",
  271: "新建 Excel 文檔",
  272: "新建 PPT 文檔",
  273: "markdown文件",
  274: "文件(夾)",
  275: "總占用空間",
  276: "請選擇單個文件或文件夾，查看詳細信息",
  277: "通用",
  278: "說明",
  279: "類型",
  280: "刪除人",
  281: "刪除時間",
  282: "版本",
  283: "第{-index-}個版本",
  284: "查看歷史版本",
  285: "文件已鎖定",
  286: "關注者",
  287: "訪問統計",
  288: "查看文件日誌",
  289: "批註數量",
  290: "下載次數",
  291: "訪問次數",
  292: "訪問人數",
  293: "訪問人員",
  294: "包含",
  295: "正在計算",
  296: "創建時間",
  297: "修改時間",
  298: "無版本信息!",
  299: "當前",
  300: "設置為當前版本",
  301: "版本說明",
  302: "HTML 文件不支持點擊此處查看歷史版本，您可以通過修改當前版本後重新打開文件！",
  303: "該文件已定稿，不能刪除版本",
  304: "確定要刪除選中的版本嗎?",
  305: "刪除成功",
  306: "刪除失敗",
  307: "文件正在審批，請先結束審批！",
  308: "操作成功",
  309: "操作失敗",
  310: "您沒有設置當前版本的權利",
  311: "當前文檔已定稿，不允許修改版本",
  312: "確定刪除該批注點？",
  313: "全部",
  314: "@我",
  315: "剛剛",
  316: "{-num-}分鐘前",
  317: "{-num-}小時前",
  318: "{-num-}天前",
  319: "昨天",
  320: "前天",
  321: "{-num-}周前",
  322: "{-num-}個月前",
  323: "{-num-}年前",
  324: "5年前",
  325: "文件傳輸",
  326: "回覆信息, Shift+Enter 換行",
  327: "換行",
  328: "確定要刪除選中的文件嗎",
  329: "提示:文件刪除後將在回收站中保留10天，分享文件會直接刪除。",
  330: "這個目錄是空的",
  331: "文件下載中，請耐心等待...",
  332: "團隊文件",
  333: "隸屬於團隊",
  334: "部門文件",
  335: "隸屬於部門",
  336: "企業共享文件夾",
  337: "企業文件",
  338: "查看分享設置",
  339: "清除所有",
  340: "暫時沒有新消息",
  341: "請求邀請{-num-}人加入{-file-}",
  342: "拒絕",
  343: "文件已刪除或不存在",
  344: "請求打開鏈接分享",
  345: "邀請您共同管理文件收集箱",
  346: "同意",
  347: "消息已刪除",
  348: "巴別鳥系統通知",
  349: "消息通知",
  350: "我收到的消息",
  351: "請求加入團隊",
  352: "開啟了文件收集箱",
  353: "請您儘快投件",
  354: "邀請你去審批文件",
  355: "提醒你關注文件(夾)",
  356: "在文件 {-name-} 的 {-object-} 中@了你",
  357: "內容",
  358: "開啟了文件 {-name-} 的演播",
  359: "您所購買的巴別鳥服務於{-endTime-}到期,請及時續費,以免影響您的使用，謝謝。",
  360: "對文件 {-name-} 發起了審批，並抄送給你",
  361: "附言:",
  362: "返回上一級目錄",
  363: "搜索",
  364: "共 {-num-} 個",
  365: "搜索文件，按回車鍵確認",
  366: "Word 文檔",
  367: "Excel 文檔",
  368: "PPT 文檔",
  369: "文本文件",
  370: "文件收集箱",
  371: "當前頻道不支持創建文件",
  372: "平鋪",
  373: "列表",
  374: "文件詳情",
  375: "團隊詳情",
  376: "文件夾目錄",
  377: "查看參與我分享的人",
  378: "清空回收站",
  379: "回收站中的文件將會永久刪除，確認要清空嗎?",
  380: "警告:此行為無法撤銷!",
  381: "企業控制台",
  382: "外部人員",
  383: "最近訪問文件",
  384: "訪問",
  385: "提醒你關注",
  386: "分享給你",
  387: "全部文件夾",
  388: "個人私有文件夾",
  389: "來自{-user-}的分享",
  390: "保存到巴別鳥",
  391: "請先輸入分享文件的密碼",
  392: "文件已成功保存到您的巴別鳥中",
  393: "請先登錄或輸入打開分享文件的密碼",
  394: "密碼",
  395: "您輸入的密碼不對，請重新輸入",
  396: "所有者",
  397: "本公司",
  398: "外部公司",
  399: "個人",
  400: "查看參與者",
  401: "你沒有邀請用戶加入分享的權限，但你可以填寫擬邀請人員，系統會發送請求給該文件的管理者來進行邀請",
  402: "已邀請",
  403: "...等{-num-}人。",
  404: "獲取邀請人失敗",
  405: "被邀請者必須使用邀請郵箱註冊才能查看內容",
  406: "發送",
  407: "參與者",
  408: "打開分享以允許其他人查看此文件",
  409: "鏈接",
  410: "鏈接和密碼已拷貝到剪貼板",
  411: "鏈接已拷貝到剪貼板",
  412: "請按 ⌘+C 拷貝鏈接",
  413: "請按 Ctrl+C 拷貝鏈接",
  414: "設置私密分享失敗，請稍後重試",
  415: "掃描二維碼快速加入",
  416: "掃描二維碼加入",
  417: "打開微信",
  418: "點擊底部的“發現”",
  419: "使用“掃一掃”",
  420: "打開巴別鳥",
  421: "點擊底部的“全部文件”",
  422: "使用右上角加號中的“掃碼加入”",
  423: "所有者未開啟此文件鏈接分享",
  424: "請求開啟",
  425: "留言請求有分享權限的人開啟鏈接分享，即可獲得此文件的分享鏈接地址。",
  426: "添加留言",
  427: "還可以輸入 {-num-} 個字",
  428: "發送請求",
  429: "請求鏈接分享",
  430: "請求打開 {-file-} 的鏈接分享",
  431: "留言",
  432: "待啟動",
  433: "定稿",
  434: "審批中",
  435: "服務器沒有設置該值",
  436: "正常",
  437: "暫不支持該文檔",
  438: "正在生成預覽文件，請稍後再試",
  439: "生成預覽失敗！",
  440: "文檔有密碼，請解除密碼再次上傳",
  441: "文件損壞或者文件不完整",
  442: "文件非常大，拒絕生成預覽文件",
  443: "演示文稿中是空的，沒有任何一頁幻燈片",
  444: "可通過雙擊將此標籤從左側欄移除，或拖拽放回到“全部標籤”",
  445: "左側欄暫無標籤顯示，可在此點擊",
  446: '或從"全部標籤"中拖拽標籤至此添加到左側欄標籤',
  447: "拖放至此添加至左側欄",
  448: "拖放至此從左側欄移除此標籤",
  449: "發現同名文件",
  450: "當前文件夾已存在名稱為 {-fileName-} 的文件！",
  451: "取消上傳",
  452: "自動重命名繼續上傳",
  453: "作為該文件的新版本上傳",
  454: "提示：暫不支持大小超過 {-size-} 的文件上傳",
  455: "文件大小不得超過",
  456: "正在向巴別鳥雲端網盤上傳文件。如果您離開此頁面，某些文件可能會無法上傳。",
  457: "個人版暫不支持文件夾上傳，請升級",
  458: "請輸入要搜索的或要新建的標籤名稱",
  459: "建立批註",
  460: "此批註所有分享參與人可見",
  461: "此批註僅企業內部參與人可見",
  462: "此批註僅自己可見",
  463: "你附加了圖文批註",
  464: "設為已完成",
  465: "文件發送失敗",
  466: "手繪線條",
  467: "矩形框",
  468: "直線",
  469: "箭頭",
  470: "文本",
  471: "顏色",
  472: "線寬",
  473: "字號",
  474: "撤銷",
  475: "重做",
  476: "在此輸入批註，也可以手繪下面的圖片",
  477: "加載更多",
  478: "請選擇審批人員",
  479: "我的分組",
  480: "常用聯繫人",
  481: "消息主題",
  482: "發布人暱稱",
  483: "登錄",
  484: "註冊",
  485: "郵箱或手機號",
  486: "登錄 - 巴別鳥",
  487: "使用短信驗證碼登錄",
  488: "手機號",
  489: "短信驗證碼",
  490: "使用郵箱或手機密碼登錄",
  491: "其它方式登錄:",
  492: "微信登錄",
  493: "忘記密碼?",
  494: "登錄企業版",
  495: "請輸入您所在企業的域名",
  496: "企業域名",
  497: "去登錄",
  498: "←登錄個人版",
  499: "註冊 - 巴別鳥",
  500: "確認表示您同意我們的",
  501: "隱私政策",
  502: "和",
  503: "服務條款",
  504: "請輸入驗證碼以繼續",
  505: "圖片驗證碼",
  506: "部門成員管理",
  507: "很抱歉，巴別鳥免費版只能創建2個團隊，要創建更多團隊，請升級至專業版",
  508: "審批列表",
  509: "發起人",
  510: "獲取審批信息失敗",
  511: "審批文件",
  512: "審批信息已改變",
  513: "該文件為直接定稿文件，無審批人員",
  514: "已通過",
  515: "未開始",
  516: "正在審批中...",
  517: "已駁回",
  518: "該文件已被駁回，可通過上傳新版本重新開啟審批",
  519: "當前階段您還不能進行審批",
  520: "已審批",
  521: "文件已駁回，審批結束",
  522: "審批已完成",
  523: "抄送者",
  524: "結束審批",
  525: "重新填寫審批結論",
  526: "我的結論",
  527: "審批結論",
  528: "發起審批",
  529: "審批通過後的文件狀態為定稿，審批中和定稿後的文件不能編輯及上傳新版本",
  530: "不審批直接定稿",
  531: "提交開啟審批",
  532: "新增審批階段",
  533: "審批組",
  534: "抄送組",
  535: "預設流程",
  536: "審批人員",
  537: "如不需要按順序審批(會簽方式)，可將全部審批人員添加到階段1",
  538: "請選擇審批流程",
  539: "審批分階段進行，階段1完成後階段2的人員才能收到審批通知，以此類推",
  540: "審批者可以看到參與討論的成員信息及文件上所有批註",
  541: "添加的審批流程在文件審批時可以直接選擇，並快速開啟審批",
  542: "為流程取個名字，方便使用",
  543: "修改審批流程",
  544: "模板名已存在",
  545: "保存失敗，請重試",
  546: "團隊討論是以團隊為單位的群組，在這裡大家可以展開討論，協同工作。",
  547: "新建團隊",
  548: "提示: 部門消息為空。",
  549: "文件不存在！",
  550: "文件夾在回收站中，不能打開！",
  551: "文件不存在，可能已經被移走！",
  552: "文件已被刪除！",
  553: "打開目標文件夾",
  554: "創建了部門",
  555: "成為部門新成員",
  556: "被更名為",
  557: "最大空間被修改為",
  558: "所屬部門被修改為",
  559: "被移出了部門",
  560: "角色 被設置為",
  561: "加入了團隊",
  562: "拒絕加入團隊",
  563: "被踢出討論",
  564: "退出了團隊",
  565: "申請加入團隊",
  566: "邀請了",
  567: "移除了",
  568: "文件已經開啟過審批！",
  569: "未審批",
  570: "待審批",
  571: "文件動態",
  572: "此回復所有人可見",
  573: "回復批註",
  574: "此回復僅企業內人員可見",
  575: "共享成員",
  576: "分組",
  577: "用戶",
  578: "重複添加，此人已在列表中",
  579: "搜索暱稱/郵箱/手機",
  580: "企業分組",
  581: "編輯分組",
  582: "企業分組為空",
  583: "個人分組為空",
  584: "請填寫名稱",
  585: "名稱不能為空",
  586: "名稱長度不能超過100個字符",
  587: "企業版基礎服務",
  588: "即將到期",
  589: "已經過期",
  590: "請及時{-pay-}",
  591: "查看訂單",
  592: "企業版",
  593: "當前{-edition-}服務有效期至{-date-}",
  594: "服務續費",
  595: "續費服務內容包括",
  596: "服務內容",
  597: "單位（元）",
  598: "數量",
  599: "金額（元）",
  600: "請選擇續費時長（按年計算）",
  601: "已選續費時長",
  602: "年",
  603: "{-edition-}續費服務內容有效期至{-date-}",
  604: "需支付服務費用合計",
  605: "元",
  606: "需要發票",
  607: "提交訂單",
  608: "支付",
  609: "升級服務",
  610: "專業版服務管理",
  611: "企業版服務管理",
  612: "個人訂單",
  613: "企業訂單",
  614: "全部訂單",
  615: "提交時間",
  616: "開始日期",
  617: "結束日期",
  618: "訂單名稱",
  619: "年數",
  620: "狀態",
  621: "全部項目",
  622: "賬戶升級",
  623: "空間擴展",
  624: "賬戶續費",
  625: "年",
  626: "未支付",
  627: "待驗證",
  628: "已支付",
  629: "確定刪除此訂單?",
  630: "訂單號",
  631: "訂單內容",
  632: "刪除訂單",
  633: "確定取消以下訂單記錄",
  634: "取消訂單",
  635: "升級為專業版賬戶",
  636: "企業版擴展空間服務",
  637: "專業版擴展空間服務",
  638: "企業版續費服務",
  639: "專業版續費服務",
  640: "企業賬戶",
  641: "個人賬戶",
  642: "取消訂單失敗，非訂單創建者不能取消訂單",
  643: "更多訂單查詢，請點擊{-more-}",
  644: "服務有效期至",
  645: "發票抬頭",
  646: "發票寄送信息",
  647: "如您有任何疑問， 請立即聯繫客服或銷售人員。郵箱：support@molasync.com 電話：400-9204020",
  648: "安全退出",
  649: "最多添加{-max-}個，已添加{-num-}個",
  650: "此操作不會對已選擇的企業擁有者及用戶自身生效",
  651: "確認{-act-}已選中賬戶?",
  652: "上一步",
  653: "在線人數",
  654: "已選用戶",
  655: "批量重置密碼",
  656: "批量設定個人存儲空間上限",
  657: "輸入存儲空間上限，用戶存儲超過限制將無法上傳",
  658: "批量管理賬戶",
  659: "批量更改部門和權限",
  660: "公司",
  661: "訪問文件所屬部門",
  662: "邀請人",
  663: "提示 : 沒有外部人員",
  664: "添加外部人員",
  665: "請輸入暱稱",
  666: "該郵箱已經是本企業內部成員",
  667: "該郵箱已經是本企業外部成員",
  668: "該郵箱已經註冊為巴別鳥賬號，可以輸入餘下信息，確認添加",
  669: "新增成員將在郵箱或手機中收到註冊信息",
  670: "登錄成功後可以修改密碼",
  671: "新增企業用戶",
  672: "部門不能為空",
  673: "該賬戶已經在本企業中",
  674: "權限設置",
  675: "選擇角色",
  676: "所有角色",
  677: "請選擇用戶",
  678: "已定稿（點擊查看結果）",
  679: "已駁回（點擊查看結果）",
  680: "不能上傳新版本",
  681: "確定取消分享嗎?",
  682: "提示:取消分享後，分享鏈接將失效。",
  683: "鎖定文件將只允許自己上傳新版本",
  684: "鎖定失敗，已被他人鎖定",
  685: "文件恢復中",
  686: "文件已經恢復至原處",
  687: '文件已經恢復，但是其所在父文件夾 "{-folder-}" 還在回收站中<br>',
  688: "恢復失敗，該文件的上級文件夾已經被永久刪除",
  689: "文件刪除後將無法恢復,確定要刪除嗎?",
  690: "文件刪除中",
  691: "加鎖成功",
  692: "文件已被 {-userName-} 鎖定，您不能編輯!",
  693: "我們在試圖鎖定文檔的時候發生了錯誤<br>請稍後再試",
  694: "含有共享文件(夾)的，請先關閉其分享",
  695: "尚未添加任何標籤",
  696: "可通過拖拽或雙擊將標籤添加至左側欄顯示",
  697: "投件",
  698: "收件",
  699: "收件人",
  700: "企業在線辦公平台",
  701: "進行中",
  702: "已結束",
  703: "我發起的",
  704: "沒有任何文件(夾)",
  705: "提示 : 您可以清空回收站來釋放空間",
  706: "請選擇文件或文件夾，查看詳細信息",
  707: "輸入文字標記...",
  708: "開啟水印",
  709: "輸入暱稱,郵箱,或手機號",
  710: "未註冊用戶",
  711: "發送中...",
  712: "{-somebody-}是該文件所在部門的成員，無需邀請即可以直接訪問該文件，你是否想要提醒他們關注該文件？",
  713: '關閉"{-file-}"的鏈接分享',
  714: "關閉鏈接分享後，知道該鏈接的人將無法訪問，<br>同時所有該目錄下的子鏈接也將關閉",
  715: '關閉"{-file-}"的邀請分享',
  716: "鏈接分享未開啟",
  717: "前往開啟",
  718: "關閉邀請分享後，受邀用戶將全部移除。<br>文件本身及其子目錄內容也將從受邀用戶賬號移除",
  719: "所有者未開啟鏈接分享",
  720: "發送請求",
  721: "關閉邀請分享",
  722: "匿名用戶",
  723: "註冊用戶",
  724: "重置密碼",
  725: "知道此鏈接的任何人都可以{-do-}",
  726: "設置分享截止日期",
  727: "發送分享參與動態信息給通過鏈接加入者",
  728: "成功設置7天後自動關閉！",
  729: "訪問密碼",
  730: "打印",
  731: "不可見",
  732: "訪問時間",
  733: "",
  734: "",
  735: "",
  736: "",
  737: "",
  738: "",
  739: "",
  740: "",
  741: "在新的標籤頁打開",
  742: "文件太大不支持預覽，請下載查看！",
  743: "我有註冊賬號",
  744: "去登錄",
  745: "添加日期",
  746: "文件對比",
  747: "外部人員",
  748: "創建標籤",
  749: "選擇標籤",
  750: "篩選面板",
  751: "圖層列表",
  752: "此處所設置的權限會自動應用到所有子文件和子文件夾",
  753: "在這個文件夾中您沒有權限上傳！",
  754: "個人私有文件空間設置",
  755: "檔案管理員負責審批檔案借閱，不可以登錄企業管理後台",
  756: "安全保密員可以在前台看到並管理所有部門的文件，可以登錄企業管理後台。但在企業後台中僅限以下權力：制定公司安全策略(安全保密員獨有權限)、管理組織結構、成員管理、權限管理",
  757: "安全審計員可以登錄企業管理後台，但在企業後台中僅限以下權利：查看企業安全策略，查看組織結構，查看成員權限，查看權限管理，查看文件訪問日誌",
  758: "歸檔至檔案庫",
  759: "文件歸檔後，將移動到專有檔案管理處，不允許修改和刪除，並且文件只能到檔案庫界面進行訪問",
  760: "企業檔案庫",
  761: "保存企業歷史文檔",
  762: "你要查看的是歸檔文件，需要到檔案庫去查看，點擊確定轉到檔案庫",
  763: "申請在線查看",
  764: "申請下載",
  765: "申請複製",
  766: "申請已經發送，請在您的申請頻道關注審批結果",
  767: "申請中",
  768: "已借閱",
  769: "借閱檔案",
  770: "借閱檔案需要相關人員審批，審批通過後檔案即可出現在“我的借閱”頻道中",
  771: "申請借閱",
  772: "提交申請",
  773: "閱讀方式",
  774: "借閱理由",
  775: "檔案夾",
  776: "新建檔案夾",
  777: "檔案夾名不能為空",
  778: "你要下載的是歸檔文件，需要到檔案庫去下載，點擊確定轉到檔案庫",
  779: "有新的檔案閱讀申請需要您審批!",
  780: "您的檔案閱讀申請已審批通過!",
  781: "您的檔案閱讀申請已被駁回!",
  782: "歸檔文件需要借閱後才能查看!",
  783: "編輯部門",
  784: "部門含有子部門時不允許刪除",
  785: "含有歸檔文件的部門不能刪除",
  786: "快捷方式所指向的文件不允許下載",
  787: "手繪筆",
  788: "最近版本",
  789: "←登錄公有雲",
  790: "推薦邀請以下人員訪問",
  791: "部門及項目",
  792: "你確定要從團隊中移除該用戶嗎",
  793: "移除成員",
  794: "項目所屬",
  795: "上傳文件限定",
  796: "限定方式",
  797: "限定內容",
  798: "不限定",
  799: "限定擴展名",
  800: "限定文件全名",
  801: "請輸入限定內容，以逗號隔開。如：jpg,jpeg",
  802: "請輸入限定文件名。如：example.jpg",
  803: "管理部門成員",
  804: "0或不輸入時需要所有人",
  805: "輸入審批意見",
  806: "採納此意見",
  807: "已採納",
  808: "已拒絕",
  809: "意見",
  810: "確定刪除該意見？",
  811: "拒絕此意見",
  812: "等待作者處理",
  813: "意見列表",
  814: "共{-num-}個審批意見",
  815: "意見（語音）",
  816: "意見（手繪）",
  817: "在文件 {-file-} 中採納了 {-somebody-} 提出的 {-evaluation-}",
  818: "在文件 {-file-} 中拒絕了 {-somebody-} 提出的 {-evaluation-}",
  819: "{-somebody-}已經在文件{-file-}中簽名",
  820: "輸入想在用戶現有存儲空間基礎上增加的存儲空間",
  821: "如需創建文件夾請登錄",
  822: "點擊上傳文件或拖動要上傳的內容到此區域完成上傳",
  823: "如需實名上傳或創建文件夾請登錄",
  824: "如果是新上傳的文件，請等待最長30分鐘，待服務器更新全文搜索索引",
  825: "分享一個文件（夾）給你【{-name-}】，點擊鏈接查看;",
  826: "來自{-user-}的投件箱",
  827: "僅專業版和企業版支持此功能",
  828: "後過期",
  829: "請輸入至少5位手機號",
  830: "不允許更改企業擁有者的企業角色",
  831: "如果你修改自己的企業角色，你將失去超級管理員的權限，是否確認修改？",
  832: "文件用量",
  833: "該文件不支持批註",
  // dashboard， 
  // 其中 {- -} 所包含的內容是將來要替換變量內容 
  // 以第 1000 條為例，定義對象如下 
  // var param = { 
  // 'somebody' : '李平', 
  // 'parentFolder': '歷史文件夾', 
  // 'folder' : '明朝那些事' 
  // } 
  // var s = MDLocalString.getLocalString(1000, param); 
  // s 的值為 
  // '李平 在 歷史文件夾 中新建了文件夾 明朝那些事' 
  // 
  1000: "{-somebody-} 在 {-parentFolder-} 中新建了文件夾 {-folder-}",
  1001: "{-somebody-} 在 {-parentFolder-} 中上傳了 {-fileEdition-}{-file-}",
  1002: "{-somebody-} 將 {-fileOrFolder-}{-oldName-} 的名稱修改為 {-newName-}",
  1003: "新文件",
  1004: "新版本",
  1005: "等文件",
  1006: "{-somebody-} 將 {-fileOrFolder-}{-file-} 從 {-sourceFolder-} 移動到了 {-targetFolder-}中",
  1007: "{-somebody-} 從 {-folder-} 中刪除了 {-file-}",
  1008: "{-somebody-} 上傳了 {-file-}",
  1009: "{-somebody-} 刪除了 {-file-}",
  1010: "{-file-} 的一個版本",
  1011: "{-somebody-} 從回收站中恢復了 {-file-}",
  1012: "{-somebody-} 在 {-folder-} 中移入了 {-file-}",
  1013: "{-somebody-} 從 {-folder-} 中移出了 {-file-}",
  1014: "{-somebody-} 設置了 {-file-} 的當前版本",
  1015: "{-somebody-} 將以下文件 {-file-} 複製到了 {-folder-} 中",
  1016: "{-somebody-} 對 {-file-} 點了讚",
  1017: "{-somebody-} 取消了對 {-file-} 的點讚",
  1018: "{-somebody-} 對 {-file-} 進行了 {-review-}",
  1019: "{-somebody-} 提醒你關注 {-file-}",
  1020: "{-somebody-} 取消了你對 {-file-} 的關注",
  1021: "{-somebody-} 加入了分享 {-file-}",
  1022: "{-somebody-} 從分享 {-file-} 中被移出",
  1023: "{-somebody-} 退出了分享 {-file-}",
  1024: "{-somebody-} 關閉了分享 {-file-}",
  1025: "{-somebody-} 將以下人員 {-user-} 移出了分享 {-file-}",
  1026: "{-somebody-} 打開了 {-file-} 的分享鏈接",
  1027: "{-somebody-} 在 {-file-} 中將以下用戶的權限由 {-oldRole-} 改為 {-newRole-}",
  1028: "{-somebody-} 關閉了 {-file-} 的分享鏈接",
  1029: "{-somebody-} 將 {-file-} 的分享鏈接權限由 {-oldRole-} 改為 {-newRole-}",
  1030: "{-somebody-} 在 {-file-} 中添加了 {-comment-}",
  1031: "{-somebody-} 在 {-file-} 中回覆了 {-comment-}",
  1032: "{-somebody-} 在 {-file-} 的批注中上傳了文件",
  1033: "{-somebody-} 從 {-file-} 中刪除了一個 {-commentType-}",
  1034: "{-somebody-} 將 {-file-} 中的一個 {-comment-} 設置為 {-finish-}",
  1035: "{-somebody-} 將 {-file-} 的第 {-No.-} 號版本的版本說明修改為 {-remark-}",
  1036: "{-somebody-} 開放了文件收集箱 {-file-}",
  1037: "請您儘快投遞文件，截止日期 {-time-}",
  1038: "{-somebody-} 更新了文件收集箱 {-file-} 的設置",
  1039: "{-somebody-} 邀請你去審批 {-file-}",
  1040: "並附言：{-comment-}",
  1041: "{-file-} 已經審批通過",
  1042: "{-file-} 沒有通過審批，已被駁回！",
  1043: "{-somebody-} 已經 {-pass-}{-file-}",
  1044: "{-somebody-} 邀請以下人員 {-user-} 加入了分享 {-file-}",
  1045: "{-somebody-} 在 {-folder-} 中上傳了 {-file-}",
  1046: "{-somebody-} 在 {-folder-} 中上傳了 {-file-} 的一個新版本",
  1047: "{-somebody-} 給 {-file-} 添加了相關文件 {-destinationFile-}",
  1048: "等 {-count-} 個文件（夾）",
  1049: "{-somebody-} 對 {-file-} 進行了歸檔",
  1050: '<p class="title">確定要刪除部門：{-department-} ？</p><p class="mgt-20 Cred">提醒：部門內文件及部門成員關係將全部刪除</p>',
  1051: "{-somebody-} 對部門 {-depName-}中的文檔 {-file-} 進行了歸檔",
  1052: "，並留言：{-leaveMessage-}",
  1053: "管理員",
  1054: "撤回審批",
  1055: "撤回審批會清除該文件所有審批記錄，是否確認撤回審批？",
  1056: "{-somebody-} 撤銷了{-file-} 的審批流程",
  1057: "{-somebody-} 在 {-parentFolder-} 中新建了檔案夾 {-folder-}",
  1058: "{-somebody-} 在 {-file-} 中將以下用戶的權限由項目助理改為普通成員，權限是 {-newRole-}",
  // web browser message 
  1500: "說:",
  1501: "發送了一個文件",
  1502: "繪製了一條手繪批注",
  1503: "發送了一條語音批注",
  1504: "創建了文件夾{-fileName-}",
  1505: "上傳了{-fileEdition-}:{-fileName-}",
  1506: "將{-file-}重命名為{-newName-}",
  1507: "加入了討論",
  1508: "退出了團隊: {-teamName-}",
  1509: "將 {-user-} 移出了團隊：{-teamName-}",
  1510: "退出了討論",
  1511: "你已被移出團隊 {-teamName-}",
  1512: "你已被移出分享 {-shareName-}",
  1513: "分享了 {-file-}",
  1514: "關閉了團隊 {-teamName-}",
  1515: "將團隊{-file-}的成員{-user-}的角色由{-oldRole-} 改為 {-newRole-}",
  1516: "將分享{-file-}的參與者{-user-}的角色由{-oldRole-} 改為 {-newRole-}",
  1517: "@你:",
  1518: "在文件{-file-}上添加了一個批注",
  1519: "添加了",
  1520: "回覆了",
  1521: "在批注中上傳了一個參考文件",
  1522: "將文件{-file-}中的一個批注設置為完成",
  1523: "將文件{-file-}中的一個批注設置為未完成",
  1524: "移入了文件{-file-}",
  1525: "移出了文件{-file-}",
  1526: "你被移出了部門 {-department-}",
  1527: "將 {-user-} 移出了部門 {-department-}",
  1528: "你被添加到了部門 {-department-}",
  1529: "將 {-user-} 添加到了部門 {-department-}",
  1530: " 邀請你加入團隊 {-team-}",
  1531: " 邀請你加入分享 {-file-}",
  1532: " 將你從分享邀請{-file-}中移出了",
  1533: " 將文件{-file-}的版本說明修改為{-remark-}",
  1534: " 將{-file-}移入了{-folder-}",
  1535: "將項目{-project-}移交到了{-department-}中",
  1536: "新的項目負責人：{-user-}",
  1537: "創建了檔案夾{-fileName-}",
  1538: "(下載)",
  1539: "將項目{-project-}負責人改為了{-user-}",
  1540: "已加載{-num-}個，共{-total-}個",
  1541: "已全部加載，共{-total-}個",
  1542: "正在加載中",
  1543: "將項目{-project-}轉為父項目",
  //-------------------------------------- 分享等 alert 提示 
  2000: "管理員修改了您在{-depName-}中的角色為 {-role-}",
  2001: "當前部門已被轉移，此頁面即將關閉",
  2002: "管理員修改了您對此文件的操作權限，您當前權限為 {-role-}",
  2003: "默認權限",
  2004: "查看文件",
  2005: "查看",
  2006: "上傳",
  2007: "僅上傳",
  2008: "顯示批注",
  2009: "上一篇",
  2010: "文件導航",
  2011: "第{-fileNo-}個文件，共{-fileCount-}個文件",
  2012: "下一篇",
  2013: "正在演播",
  2014: "演播模式",
  2015: "發起演播後，當前文檔的圍觀的觀眾的屏幕顯示文檔的內容將與您同步",
  2016: "確認要放棄圍觀？",
  2017: "確認要關閉演播？",
  2018: "正在發送",
  2019: "發送失敗",
  2020: "當前演播已被關閉",
  2021: "有人向你發送語音請求，但是本地環境沒準備好",
  2022: "用戶機器沒有語音設備",
  2023: "no security",
  2024: "用戶禁止了語音請求",
  2025: "啟動語音失敗，語音通話需要 https 協議",
  2026: "有人想和你進行語音通話，但是你並沒有打開語音",
  2027: "添加批注",
  2028: "矩形框批注",
  2029: "圓形批注",
  2030: "箭頭批注",
  2031: "標籤標注",
  2032: "開啟演播",
  2033: "主講人",
  2034: "轉換主講人",
  2035: "關閉演播",
  2036: "圍觀",
  2037: "不再圍觀",
  2038: "請輸入聊天信息",
  2039: "觀眾",
  2040: "粉筆",
  2041: "板擦",
  2042: "管理員修改了您對此文件的操作權限",
  2043: "文件總數",
  2044: "下屬部門文件數量統計",
  2045: "沒有上傳文件",
  2046: "提示：此人在當前部門沒有上傳任何文件",
  2047: "提示：此人在當前文件夾沒有上傳任何文件",
  2048: "上傳文件列表",
  2049: "查看此人在部門內上傳的文件",
  2050: "查看此人在分享中上傳的文件",
  2051: "各部門文件數量統計",
  2052: "確定要刪除這些筆畫嗎",
  2053: "確定要刪除此人的所有筆畫嗎？",
  2054: "無效的輸入值",
  2055: "該目錄下沒有符合搜索條件的文件！",
  2056: "全部用戶",
  // -------------------------------- 前台設置 
  2300: "賬戶信息",
  2301: "密碼設置",
  2302: "通知設置",
  2303: "專業版基礎服務",
  2304: "即將到期",
  2305: "已經過期",
  2306: "續費",
  2307: "請及時{-dosomething-}。",
  2308: "企業版用戶",
  2309: "個人版用戶",
  2310: "專業版用戶",
  2311: "到期時間",
  2312: "訂單詳情",
  2313: "有效天數",
  2314: "修改頭像",
  2315: "手機",
  2316: "未綁定",
  2317: "綁定",
  2318: "綁定郵箱後，可及時收到通知",
  2319: "昵稱",
  2320: "暫不支持在線升級,請聯繫客服：",
  2321: "獲取空間信息失敗",
  2322: "上傳頭像",
  2323: "綁定手機號",
  2324: "手機號綁定成功",
  2325: "請輸入手機號",
  2326: "手機號格式錯誤",
  2327: "驗證碼不能為空",
  2328: "請輸入密碼",
  2329: "請輸入6-20位包含大小寫字母及數字的組合",
  2330: "修改昵稱",
  2331: "請輸入昵稱",
  2332: "修改郵箱",
  2333: "請輸入新郵箱",
  2334: "修改手機號",
  2335: "請輸入新手機號",
  2336: "短信驗證碼",
  2337: "郵箱驗證碼",
  2338: "綁定郵箱",
  2339: "請輸入郵箱",
  2340: "郵箱格式錯誤",
  2341: "您尚未綁定郵箱或手機號，綁定後您可以以郵箱(手機號)加密碼的方式登錄。",
  2342: "舊密碼",
  2343: "新密碼",
  2344: "確認密碼",
  2345: "重置",
  2346: "密碼修改成功",
  2347: "舊密碼錯誤",
  2348: "您還未登錄",
  2349: "網絡錯誤,請稍後重試",
  2350: "請輸入舊密碼",
  2351: "請輸入新密碼",
  2352: "請輸入確認密碼",
  2353: "兩次輸入的密碼不一致",
  2354: "請勾選您想接收的消息類型",
  2355: "文件上傳",
  2356: "文件批註",
  2357: "分享的人員管理",
  2358: "您目前尚未綁定郵箱，可能無法收到通知，請儘快綁定您的郵箱。",
  2359: "去綁定",
  2360: "初始化登錄密碼",
  2361: "請輸入驗證碼",
  2362: "企業公共分組",
  2363: "新建分組",
  2364: "暫無分組",
  2365: "個人私有分組",
  2366: "獲取分組信息失敗，請稍後重試",
  2367: "確定要刪除此分組？",
  2368: "分組名稱不能為空",
  2369: "確定要將此人移出分組？",
  2370: "分組名",
  2371: "分組成員",
  2372: "分組成員為空",
  2373: "請輸入分組名稱",
  2374: "首頁",
  2375: "上一頁",
  2376: "下一頁",
  2377: "尾頁",
  2378: "頁",
  2379: "跳轉到 {-no.-} 頁",
  2380: "項",
  2381: "創建文件收集箱",
  2382: "設置文件收集箱",
  2383: "從企業成員列表或者分組中添加",
  2384: "個人分組",
  2385: "獲取短信驗證碼",
  2386: "獲取用戶空間信息獲取失敗",
  2387: "沒有需要被轉移的文件",
  2388: "所有角色",
  2389: "修改部門",
  2390: "暫未加入部門",
  2391: "輸入昵稱或文件名",
  2392: "選擇文字水印方式",
  2393: "分享者的名字",
  2394: "使用註冊賬戶水印",
  2395: "使用註冊賬戶水印後，文件的水印顯示為查看者的註冊賬戶",
  2396: "請輸入郵箱、手機號或者昵稱",
  2397: "保密檔案，除了創建者和部門經理外其他人不可見",
  2398: "限制檔案，除了創建者和本部門經理外其他人不能借閱",
  2399: "內部檔案，只有檔案所在部門內人員可以借閱",
  2400: "文件目錄",
  2401: "訪問次數",
  2402: "次",
  2403: "文件所有權不屬於你，無權徹底刪除",
  2404: "從企業成員列表中添加",
  2405: "確定要將此部門移出分組？",
  //-------------------------------------- 胡繼超新增 

  2500: "投件人",
  2501: "{-somebody-} 開啟了文件{-file-}的審批，並抄送給你",
  2502: "已到期",
  2503: "編輯",
  2504: "當前文件夾",
  2505: "文件類型",
  2506: "全文搜索",
  2507: "僅文件名",
  2508: "部門管理",
  2509: "基礎權限",
  2510: "文件權限設置",
  2511: "文件權限截止日期",
  2512: "點擊查看文件訪問控制",
  2513: "地址綁定",
  2514: "開啟mac地址綁定",
  2515: "開啟mac地址綁定後，綁定mac地址的賬號無法在其他mac地址上訪問客戶端。（網頁端不受限制）",
  2516: "綁定列表",
  2517: "mac地址池",
  2518: "新增綁定",
  2519: "沒有綁定記錄",
  2520: "提示: 當前沒有mac地址綁定記錄,你可以通過點擊“新增綁定”按鈕,綁定員工的mac地址",
  2521: "沒有符合條件的綁定記錄",
  2522: "提示: 你可以更改搜索條件,重新進行搜索",
  2523: "綁定的mac地址",
  2524: "綁定的mac地址池",
  2525: "客戶端在線狀況",
  2526: "當前mac地址",
  2527: "綁定mac地址",
  2528: "最多添加{-max-}個,已添加{-num-}個",
  2529: "輸入綁定的mac地址",
  2530: "部門人員",
  2531: "分組人員",
  2532: "多個地址用空格鍵或者逗號分隔,留空為不綁定（AA:AA:AA:AA:AA:AA）",
  2533: "選擇mac地址池",
  2534: "新建一個mac地址池",
  2535: "mac地址池是事先設定好的mac地址組合，以實現快捷管理。如果沒有設定，可以點擊“{-text-}”建立一個。選擇“無”表示不綁定mac地址池",
  2536: "新增",
  2537: "警告： 批量編輯將清空之前的綁定記錄，按新的規則進行mac地址的重新綁定",
  2538: "內含mac地址個數",
  2539: "客戶端在線數量",
  2540: "編輯mac地址池",
  2541: "mac地址池名稱",
  2542: "編輯mac地址",
  2543: "輸入需要增加的mac地址",
  2544: "多個地址用空格鍵，換行或者逗號分隔",
  2545: "創建mac地址池",
  2546: "輸入mac地址池名稱：此處不允許重名",
  2547: "輸入mac地址",
  2548: "新增mac地址池",
  2549: "解除綁定",
  2550: "綁定當前地址",
  2551: "名稱已存在",
  2552: "你的輸入的地址中{-msg-}不符合mac地址的格式，提交後會被過濾，是否繼續此操作",
  2553: "暫無mac地址，請點擊”批量增加地址“向該地址池中添加mac地址",
  2554: "批量增加新地址",
  2555: "請選擇mac地址池",
  2556: "了解安全級別",
  2557: '保密文件，<span class="gray">默認除了創建者、項目負責人、文件負責人和部門經理外部門內其他人不可見，分享該文件必須獲得安全保密員授權</span>',
  2558: '限制文件，<span class="gray">一般人員只讀，分享該文件必須獲得上級主管授權</span>',
  2559: '內部文件，<span class="gray">分享該文件給部門外人員，必須獲得上級主管授權</span>',
  2560: "以上三種文件，不支持鏈接分享僅支持邀請分享",
  2561: "提示: 當前沒有mac地址池,你可以通過點擊“新增mac地址池”按鈕,添加mac地址池",
  2562: "設備管理",
  2563: "於",
  2564: "在線設備",
  2565: "當前設備",
  2566: "退出",
  2567: "你確定退出該設備的登錄嗎",
  2568: "巴別鳥客戶端",
  2569: "巴別鳥網頁",
  2570: "給你發送了文件",
  2571: "點擊此處下載",
  2572: "該文件已被刪除",
  2573: "文件受內部保護，被邀請人員需要該文件部門負責人審批，申請已經發送，請耐心等待",
  2574: "{-sign-}了你對文件{-fileName-}的分享請求",
  2575: "開放級別",
  2576: "所限部門",
  2577: "保密文件，限制文件，一般人員不能移動/複製/上傳新版本/下載/重命名/查看版本，上級主管和有部門文件管理權限的人員才可以",
  2578: "點擊查看分組人員",
  2600: "快速發送文件",
  2601: "選擇或輸入文件接受者郵箱地址",
  2602: "郵件存儲",
  2603: "使用巴別鳥存儲我的郵件",
  2604: "域名",
  2605: "請輸入要代收郵箱的域名",
  2606: "端口號",
  2607: "請輸入要代收郵箱端口號",
  2608: "同步郵件",
  2609: "同步郵件可能需要花費幾分鐘時間，你可以離開此頁面繼續其他工作",
  2610: "大窗口顯示",
  2611: "全選",
  2612: "請輸入代收郵箱的賬號",
  2613: "追加文件權限",
  2614: "文件權限設置統計",
  2615: "控",
  2616: "設置郵箱",
  2617: "巴別鳥可以在部門文件中管理文件訪問權限，右鍵點擊部門文件選擇“文件訪問控制”可以更改文件的訪問權限。更改訪問權限後的文件及文件夾可以在這裡統一管理",
  2618: "非本企業部門人員",
  2619: "你沒有查看該文件的權限",
  2620: "巴別鳥可以存儲你設定的郵箱郵件及附件，打開郵件存儲按鈕後設置需要存儲的郵箱，你的郵件及附件將會保存在“我的郵箱”目錄中",
  2621: "訪問控制",
  2622: "暫無內容",
  2623: "創建快捷方式",
  2624: "導出文件列表",
  2625: "快捷方式",
  2626: "同步中",
  2627: "放大",
  2628: "縮小",
  2629: "適應屏幕",
  2630: "設置郵箱成功後，點擊“同步郵件”開始接收",
  2631: "授權碼",
  2632: "請輸入授權碼（登錄QQ郵箱，設置--賬戶，開啟POP3服務，生成授權碼）",
  2633: "拉選放大",
  2634: "提示 : 沒有在線的外部人員",
  2635: "該賬戶已經註冊為巴別鳥賬號，請輸入其他郵箱或手機",
  2640: "端口號只允許輸入數字",
  2650: "超級管理員",
  2651: "部門經理",
  2652: "在線閱讀",
  2653: "複製",
  2654: "文件統計",
  2655: "活躍文件",
  2656: "系統活躍度",
  2657: "部門範圍",
  2658: "時間範圍",
  2659: "請選擇文件類型",
  2660: "全部類型",
  2661: "該部門暫無文件",
  2662: "本周",
  2663: "本月",
  2664: "本季度",
  2665: "本年",
  2666: "一年內",
  2667: "兩年內",
  2668: "文件活躍度統計",
  2669: "訪問次數",
  2670: "請選擇時間範圍",
  2671: "各部門文件個數",
  2672: "級部門",
  2673: "文件夾訪問人次",
  2674: "文件訪問人次",
  2675: "顯示手繪筆跡列表",
  2676: "文件說明",
  2677: "回收站設置",
  2678: "文件在回收站的保留時間",
  2679: "請輸入天數",
  2680: "注：文件在回收站的保留時間可以自由修改為1 - 999 天",
  2681: "天",
  2682: "在文檔中查找…",
  2683: "查找詞語上一次出現的位置",
  2684: "查找詞語後一次出現的位置",
  2685: "上一處",
  2686: "下一處",
  2687: "查找",
  2688: "高亮顯示",
  2689: "整詞匹配",
  2690: "區分大小寫",
  2691: "{-somebody-} 將文件（夾）{-file-} 的負責人由 {-from-} 改為 {-to-}",
  2692: "該分組名已存在",
  2693: "給你分享了文件",
  2694: "設置截止日期",
  2695: "去除截止日期",
  //----------------2700 歸檔 
  2700: "檔案",
  2701: "我的訪問申請",
  2702: "我收到的申請",
  2703: "最近修改日期",
  2704: "歸檔人",
  2705: "沒有歸檔文件(夾)",
  2706: "企業檔案",
  2707: "未處理",
  2708: "申請日期",
  2709: "申請內容",
  2710: "審批狀態",
  2711: "審批人",
  2712: "審批",
  2713: "審批日期",
  2714: "未審批(下拉選擇)",
  2715: "我的借閱",
  2716: "沒有借閱文件(夾)",
  2717: "沒有文件(夾)的借閱申請",
  2718: "部門審批狀態",
  2719: "企業審批狀態",
  2720: "申請人",
  2721: "申請理由",
  2722: "部門審批",
  2723: "企業審批",
  2724: "歸還",
  2725: "你確定歸還此文件嗎？",
  2726: "{-somebody-} 申請{-type-} {-depName-} 中的檔案文件(夾){-file-}，並附言：{-comment-}",
  2727: "{-somebody-} 通過了你對文件檔案文件(夾){-file-} 的借閱申請",
  2728: "{-somebody-} 拒絕了你對文件檔案文件(夾){-file-} 的借閱申請",
  2729: "所在目錄",
  2730: "你沒有權限借閱該文件",
  2731: "檔案查看記錄",
  2732: "歸還日期",
  2733: "搜索申請人，回車鍵確認",
  2734: "搜索文件名，回車鍵確認",
  2735: "申請起止日期",
  //----手繪 

  2736: "隱藏手繪筆跡",
  2737: "手繪列表",
  2738: "查看手繪筆跡",
  2739: "{-somebody-} 在文件(夾){-file-}中添加了手繪筆跡",
  2740: "{-somebody-} 在文件(夾){-file-}中刪除了手繪筆跡",
  //------圖形工具 
  2741: "圖形工具",
  2742: "基本",
  2743: "選擇你需要插入的圖形，在圖紙相應位置點擊即可插入",
  2744: "保存焊接圖標",
  2745: "{-somebody-} 在文件(夾){-file-}中添加了焊接圖標",
  2746: "{-somebody-} 在文件(夾){-file-}中刪除了焊接圖標",
  //------ 
  2747: "文件負責人",
  2748: "轉換負責人",
  2749: "設置文件負責人",
  2750: "搜索昵稱或郵箱",
  2800: "部門內所有人",
  2801: "部門內所有未設置追加權限的普通成員",
  2802: "請輸入附言",
  2803: "不設置({-name-}-繼承)",
  2804: "子文件中有設置附加權限，是否要覆蓋原有設置？（覆蓋後，所有子文件的追加權限都會重置為當前追加權限）",
  2805: "覆蓋",
  2806: "追加",
  2810: "新建項目",
  2811: "新建子項目",
  2812: "項目信息",
  2813: "請輸入項目名稱",
  2814: "負責人",
  2815: "點擊選擇負責人",
  2816: "項目成員",
  2817: "選擇項目負責人",
  2818: "選擇項目成員",
  2819: "暫無項目成員，您可以點擊“添加人員”逐個邀請成員加入項目。也可以點擊確定按鈕新建項目完成後右鍵點擊“管理項目”在項目管理面板中點擊“獲取邀請鏈接地址”獲得一個地址並複製（掃碼）分發給想要加入的人或群組",
  2820: "項目轉交",
  2821: "當前所屬部門",
  2822: "當前負責人",
  2823: "目標部門",
  2824: "目標負責人",
  2825: "轉交",
  2826: "項目類型",
  2827: "項目",
  2828: "子項目",
  2829: "轉為子項目",
  2830: "轉為父項目",
  2831: "目標項目",
  2832: "選擇目標項目",
  2833: "管理項目",
  2834: "請選擇目標項目",
  2835: "項目信息填寫不完整",
  2836: "請求邀請人員加入文件（夾）{-file-}的分享",
  2837: "在該部門沒有創建項目的權限",
  2838: "選擇目標部門（項目）",
  2839: "該項目中含有子項目，操作失敗！",
  // 2332: '目標項目', 
  // 2603: '請輸入要代收的郵箱', 

  2840: "部門內的分享",
  2841: "部門內追加權限文件",
  2842: "管理分享文件",
  2843: "注：此處顯示部門內設置了訪問控制的所有文件",
  2844: "當前部門暫無文件被設置訪問控制",
  2845: "查看分享",
  2846: "關閉分享",
  2847: "分享人",
  2848: "所在文件夾",
  2849: "部門內的分享",
  2850: "部門內所有分享文件",
  2851: "當前目錄沒有打開分享的文件(夾)",
  2852: "密級",
  2853: "密級文件統計",
  2854: "部門內沒有特殊密級的文件",
  2855: "部門內所有密級文件",
  2856: "密級文件統計",
  2857: "消息取消失敗，（已超時）",
  2858: "消息取消失敗，（請刷新後重試）",
  2859: "該部門內含有 {-count-} 個分享文件，是否關閉分享？",
  2860: "郵件通知設置",
  2861: "動態接收設置",
  2862: "接收以下通知",
  2863: "密切相關通知",
  2864: "相關通知",
  2865: "弱相關通知",
  2866: "我上傳的文件",
  2867: "我評論過的文件",
  2868: "我關注的文件",
  2869: "我參與分享的文件",
  2870: "同一個部門的文件",
  2871: "子部門文件",
  2872: '文件"{-name-}"中含有以下非法字符，請改名後重新上傳： "{-str-}"',
  2873: '文件"{-fileName-}"上傳失敗，文件收集箱"{-name-}"僅允許上傳擴展名為"{-str-}"的文件',
  2874: '文件"{-fileName-}"上傳失敗，文件收集箱"{-name-}"僅允許上傳文件名为"{-str-}"的文件',
  2875: "按成員設置權限",
  2876: "按角色設置權限",
  2877: "給部門角色追加文件訪問權限（僅對該文件或文件夾及其子文件生效）",
  2878: "授權人數：{-count-}",
  2879: "服務授權",
  2880: "你的個人空間占用率已超過90%，可以聯繫超級管理員擴容空間",
  2881: "聯繫手機",
  //------------------------------------- 企業後台 

  3000: "企業設置",
  3001: "企業配置",
  3002: "組織結構",
  3003: "成員管理",
  3004: "權限管理",
  3005: "標籤管理",
  3006: "審批管理",
  3007: "企業通知",
  3008: "分組管理",
  3009: "水印設置",
  3010: "企業編號",
  3011: "已認證",
  3012: "未認證",
  3013: "基本信息",
  3014: "企業聯繫人",
  3015: "企業logo",
  3016: "域名管理",
  3017: "企業空間",
  3018: "擴展空間",
  3019: "批量修改成員個人空間限制",
  3020: "企業用戶",
  3021: "郵件通知",
  3022: "關閉此項，即禁止企業版郵件提醒功能",
  3023: "企業簡稱",
  3024: "企業簡稱可顯示於頂部標題欄，同時也是企業根部門名稱",
  3025: "企業名稱",
  3026: "企業名稱可填寫企業全稱，會顯示於登錄界面",
  3027: "註冊郵箱",
  3028: "綁定手機",
  3029: "昵稱",
  3030: "郵箱",
  3031: "手機",
  3032: "選擇圖片",
  3033: "支持上傳jpg，jpeg，png，bmp格式並小於 5MB的圖片。",
  3034: "域名地址",
  3035: "巴別鳥企業空間",
  3036: "企業版服務有效期至",
  3037: "添加部門",
  3038: "搜索部門",
  3039: "查看部門文件訪問日志",
  3040: "直屬成員按角色分類，可編輯管理。下級分屬成員請點擊查看，到相應的位置管理",
  3041: "角色/組織",
  3042: "移動此部門",
  3043: "添加子部門",
  3044: "刪除此部門",
  3045: "-對部門職能的簡要說明-",
  3046: "上級部門",
  3047: "部門創建人",
  3048: "創建日期",
  3049: "子部門",
  3050: "成員",
  3051: "企業空間配置",
  3052: "部門空間配置",
  3053: "已占用",
  3054: "查看部門文件",
  3055: "剩餘空間",
  3056: "企業成員配置",
  3057: "部門成員配置",
  3058: "管理賬戶",
  3059: "轉移文件歸屬",
  3060: "轉移至",
  3061: "管理員有權將成員賬號文件轉移至另一成員",
  3062: "停用賬戶",
  3063: "恢復",
  3064: "停用",
  3065: "停用賬戶使其不能登錄本企業(可恢復)",
  3066: "刪除賬戶",
  3067: "賬戶刪除後，其個人文件也將移除（在部門中的文件會保留），執行此操作請慎重",
  3068: "上次登錄",
  3069: "權限管理",
  3070: "修改",
  3071: "成員身份",
  3072: "私有文件用量",
  3073: "昵稱",
  3074: "性別",
  3075: "男",
  3076: "女",
  3077: "聯繫方式",
  3078: "入職時間",
  3079: "備註",
  3080: "保存",
  3081: "取消",
  3082: "已停用",
  3083: "修改密碼",
  3084: "郵箱",
  3085: "所屬部門",
  3086: "角色",
  3087: "新增角色",
  3088: "巴別鳥允許一個人在多個部門使用不同角色",
  3089: "個人私有文件空間上限",
  3090: "個人私有文件",
  3091: "您可以在這裡管理企業內部所有角色的權限，並且新增特定的角色，選擇權限後點擊確定即時生效。（別人的文件是指部門內別人上傳的文件，自己的文件是指部門內自己上傳的文件）",
  3092: "部門管理權限",
  3093: "移動至",
  3094: "部門名稱",
  3095: "部門描述",
  3096: "確認",
  3097: "選擇部門",
  3098: "請選擇上級部門",
  3099: "請填寫部門名稱",
  3100: "該部門名稱已存在",
  3101: "所有部門",
  3102: "限制此部門空間用量",
  3103: "取消勾選限制,則此部門可占用空間量在其所屬部門可用空間量範圍內不受限制",
  3104: "可供設置空間總量",
  3105: "此部門已占用空間",
  3106: "空間限制 ",
  3107: "文件訪問日志",
  3108: "查看訪問者",
  3109: "搜尋暱稱或檔案...",
  3110: "查看所有記錄",
  3111: "僅查看訪問記錄",
  3112: "僅查看上傳下載",
  3113: "僅查看匿名用戶",
  3114: "部門內文件",
  3115: "開啟分享文件",
  3116: "文件日志",
  3117: "將修改以下 {-length-} 個員工部門和角色",
  3118: "批量修改部門",
  3119: "提交",
  3120: "占用",
  3121: "在線",
  3122: "離線",
  3123: "凍結",
  3124: "沒有員工",
  3125: "提示 : 當前部門沒有內部成員",
  3126: "沒有符合條件的員工",
  3127: "提示 : 您可以更改條件重新搜索",
  3128: "昵稱(賬戶)",
  3129: "文件歸屬",
  3130: "員工管理",
  3131: "選擇成員",
  3132: "確認從該部門下移除?",
  3133: "您不能刪除其他人創建的賬號!",
  3134: "賬號已經刪除",
  3135: "確認{-prompt-}已選中賬戶?",
  3136: "上傳企業成員文件",
  3137: "設置初始密碼",
  3138: "執行導入",
  3139: "下一步",
  3140: "點擊上傳",
  3141: "上傳填寫好的成員信息",
  3142: "僅支持 excel 文件，大小不要超過2M ",
  3143: "下載模板",
  3144: "隨機密碼",
  3145: "用戶登錄時系統會提示修改密碼",
  3146: "正在執行導入...",
  3147: "導入完成",
  3148: "未知錯誤",
  3149: "網絡錯誤",
  3150: "導入失敗",
  3151: "發送消息",
  3152: "發送消息",
  3153: "查看消息",
  3154: "請輸入消息接收人",
  3155: "企業內消息，可以發送給企業全體成員或者指定成員",
  3156: "標題",
  3157: "請輸入標題",
  3158: "消息內容",
  3159: "請輸入消息內容",
  3160: "還可輸入",
  3161: "字",
  3162: "接收人",
  3163: "請選擇接收人",
  3164: "請輸入郵箱",
  3165: "新增發布人",
  3166: "刪除發布人",
  3167: "點擊查看詳情",
  3168: "沒有公告",
  3169: "提示 : 沒有歷史公告信息",
  3170: "發布人",
  3171: "主題",
  3172: "時間",
  3173: "發布人管理",
  3174: "",
  3175: "搜索消息主題",
  3176: "查看消息",
  3177: "請選擇成員",
  3178: "成員",
  3179: "確認刪除審批模板 {-name-} ",
  3180: "沒有發布人",
  3181: "昵稱(賬戶)",
  3182: "所屬部門-角色",
  3183: "提示 : 沒有發布人信息",
  3184: "發布人信息獲取失敗",
  3185: "審批流程",
  3186: "添加審批流程",
  3187: "確認刪除審批模板 {-name-}",
  3188: "沒有審批",
  3189: "提示 : 沒有審批信息",
  3190: "流程名稱",
  3191: "審批者",
  3192: "使用次數",
  3193: "添加分組",
  3194: "確認刪除分組 {-name-}",
  3195: "分組已刪除",
  3196: "刪除分組失敗",
  3197: "沒有分組",
  3198: "提示 : 沒有分組信息",
  3199: "分組名",
  3200: "包含人員個數",
  3201: "創建人",
  3202: "選擇用戶",
  3203: "篩選",
  3204: "批量設定所選用戶空間上限",
  3205: "輸入想設定的存儲空間大小後點擊保存按鈕，所有所選用戶的存儲空間上限將會重置為你輸入的數字,輸入數字為0表示不限制。",
  3206: "批量增加所選用戶的存儲上限",
  3207: "增加",
  3208: "增加用戶存儲空間操作可以在用戶現有空間基礎上為用戶增加額外的存儲空間以擴展用戶的存儲空間上限。",
  3209: "實例：A用戶空間上限為20G，B用戶空間上限為50G，選擇AB兩用戶批量增加50G存儲空間，點擊“增加”按鈕後A用戶的空間上限調整為70G，B用戶的空間上限調整為100G。",
  3210: "符合",
  3211: "的用戶共{-totalNum-}名，{-onlineNum-}人目前在線。可在右側列表進行批量處理。",
  3212: "批量編輯",
  3213: "昵稱(賬戶)",
  3214: "本次登錄時間",
  3215: "部門",
  3216: "",
  3217: "企業在線用戶",
  3218: "高級選項",
  3219: "收起",
  3220: "請選擇投件人",
  3221: "請選擇其他收件人",
  3222: "文件收集箱名稱不能為空",
  3223: "文件收集箱附言不能為空",
  3224: "截止日期不能為空",
  3225: "文件收集箱主要用於收集文件，讓投件人上傳文件到文件收集箱中，你可以在文件收集箱名稱和附言中說明此次文件收集的目的和注意事項",
  3226: "文件收集箱名稱",
  3227: "其他收件人",
  3228: "其他收件人和您一樣，可以查看批註文件收集箱內的所有投件",
  3229: "創建",
  3230: "請選擇投件人",
  3231: "請選擇日期",
  3232: "水印設置",
  3233: "打開水印功能，設置後，指定帶水印的文件在預覽時都會顯示水印",
  3234: "關閉水印",
  3235: "水印使用範圍設置",
  3236: "所有文件",
  3237: "所有對外分享文件",
  3238: "由文件分享者設定",
  3239: "使用文字水印",
  3240: "輸入你要設置的水印文字",
  3241: "水印展現位置",
  3242: "斜角平鋪",
  3243: "文件中部",
  3244: "文件頭尾",
  3245: "不透明度",
  3246: "效果預覽",
  3247: "支持*.png文件，推薦分辨率200*300",
  3248: "使用圖片水印",
  3249: "上傳用來設置水印的圖片",
  3250: "右下角",
  3251: "加載中",
  3252: "角色成員數量統計",
  3253: "確認刪除文件權限",
  3254: "水印圖片",
  3255: "水印預覽",
  3256: "提示 : 沒有內部成員",
  3257: "所屬部門-角色",
  3258: "用戶空間上限修改成功",
  3259: "修改失敗，服務器端錯誤",
  3260: "管理員權限修改失敗，服務器端錯誤",
  3261: "昵稱不能為空",
  3262: "部門重複",
  3263: "確認要刪除員工- <span class='f-emph'> {-name-} </span> - 的賬號嗎？",
  3264: "該員工的所有個人文件會一併清除",
  3265: "確認要停用員工- <span class='f-emph'> {-name-} </span> - 的賬號嗎？",
  3266: "企業角色更改成功",
  3267: "企業角色更改失敗，請稍後重試",
  3268: "新增成員",
  3269: "",
  3270: "從內部成員添加",
  3271: "刪除賬號",
  3272: "從該部門移除",
  3273: "批量導入成員",
  3274: "警告!",
  3275: "該操作將把所有者的文件轉移到其他用戶的巴別鳥賬戶中，並清空所有者企業賬號中的所有個人文件。此操作不可逆，文件轉移後，文件所有者將變更為轉入對象。",
  3276: "所有者",
  3277: "文件分類",
  3278: "文件大小",
  3279: "點擊選擇一名員工",
  3280: "的賬戶",
  3281: "從內部成員列表添加",
  3282: "文件信息",
  3283: "確認刪除部門",
  3284: "刪除該部門後部門下的文件也會一併被刪除",
  3285: "部門-角色",
  3286: "日期",
  3287: "保存位置",
  3288: "其他位置",
  3289: "選擇文件夾",
  3290: "下載文件",
  3291: "隱藏",
  3292: "你確認取消文件的{-name-}下載嗎",
  3293: "撤銷此操作",
  3294: "請輸入內容",
  3295: "你已成功創建批註",
  3296: "創建批註失敗，請檢查網絡或者重新刷新頁面",
  3297: "回復批註失敗，請檢查網絡或者重新刷新頁面",
  3298: "獲取批註列表失敗，請檢查網絡或者重新刷新頁面",
  3299: "獲取文件失敗，請重新刷新頁面嘗試",
  3300: "空間選擇失敗，請稍後再試",
  3301: "空間選擇失敗，24小時內只能改變一次，請稍後再試",
  3302: "保留了那些不能退出的分享文件！",
  3303: "提交中",
  3304: "訪問此鏈接需要輸入密碼",
  3305: "取消密碼失敗，請稍後重試",
  3306: "密碼設置成功",
  3307: "設置密碼失敗，請稍後重試",
  3308: "請輸入標籤名稱",
  3309: "同名標籤已存在",
  3310: "編輯標籤",
  3311: "共有<strong>{-quoteNum-}</strong>個文件引用此標籤",
  3312: "僅更新我創建的文件引用",
  3313: "更新企業裡所有使用該標籤的文件引用",
  3314: "上傳文件失敗",
  3315: "打開討論組",
  3316: "部門成員",
  3317: "新增部門",
  3318: "用戶 {-name-} 是未註冊用戶，是否確認邀請該人加入分享？",
  3319: "比較",
  3320: "比較或合併文檔",
  3321: "請選擇文件進行內容比較或合併",
  3322: "原文檔",
  3323: "選擇文檔",
  3324: "選擇其他文件",
  3325: "該文件目前還沒有其他版本",
  3326: "您可以{-other-}進行比較或合併",
  3327: "從該文件的其他版本中選擇",
  3328: "進行文檔比較",
  3329: "進行文檔合併",
  3330: "選擇本地文件",
  3331: "打開",
  3332: "設置為未通過",
  3333: "你確認將此文件夾的審批狀態設置為‘未通過’嗎？",
  3334: "密",
  3335: "限",
  3336: "內",
  3337: "安全級別",
  3338: "企業文件安全策略",
  3339: "了解安全策略",
  3340: "繼承父部門安全策略",
  3341: "策略名稱",
  3342: "上傳文件的默認級別",
  3343: "是否所有分享都要審批",
  3344: "分享的審批人",
  3345: "是否默認策略",
  3346: "絕密",
  3347: "一級保密",
  3348: "二級保密",
  3349: "普通",
  3350: "公開",
  3351: "保密",
  3352: "限制",
  3353: "內部",
  3354: "公開",
  3355: "是",
  3356: "否",
  3357: "安全保密員",
  3358: "上級主管",
  3359: "默認",
  3360: "部門文件安全策略",
  3361: "添加安全保密員",
  3362: "管理安全保密員",
  3363: "確認刪除{-user-}的安全保密員身份",
  3364: "安全審計員",
  3365: "添加安全審計員",
  3366: "管理安全審計員",
  3367: "確認刪除{-user-}的安全審計員身份",
  3368: "提示：",
  3369: "你確定要刪除當前地址池嗎",
  3370: "",
  3380: "上傳部門成員文件",
  3381: "",
  3382: "圖片水印不支持斜角平鋪",
  3383: "English",
  3384: "僅客戶端訪問",
  3385: "綁定mac地址的用戶，只能訪問客戶端，不能訪問APP和網頁端",
  3386: "只允許企業控制台創建和管理標籤",
  3387: "重置密碼",
  3388: "重置",
  3389: "點擊發送重置密碼的鏈接地址到用戶的郵箱",
  3390: "重置密碼的郵件已發送至用戶郵箱",
  3391: "請選擇文件進行內容查看比較",
  3392: "用戶 {-name-} 是未註冊用戶，是否確認給此人發送分享鏈接？",
  3393: "沒有操作日誌",
  3394: "提示：還沒有人訪問文件",
  3395: "沒有符合條件的操作日誌",
  3396: "您可以{-other-}進行查看比較",
  3397: "隱藏管理員訪問日誌",
  3398: "打開此項後，前台文件的訪問記錄中非管理員將不能看到管理員的訪問記錄",
  3399: "統計分析",
  3400: "點擊顯示此人在部門內上傳的文件",
  3401: "點擊顯示此人在團隊中上傳的文件",
  3402: "上傳日誌",
  3403: "點擊顯示此人在項目內上傳的文件",
  3404: "被訪問的文件夾數量",
  3405: "被訪問的文件數量",
  3406: "訪問文件夾的人數",
  3407: "訪問文件的人數",
  3408: "個人文件占用",
  3410: "創建子部門",
  3411: "刪除子部門",
  3412: "修改子部門",
  3413: "回收站管理",
  3414: "管理文件訪問控制",
  3415: "歸檔文件 ",
  3416: "文件密級管理",
  3417: "批示分享請求",
  3418: "轉換文件負責人",
  3419: "審批管理",
  3420: "給自己文件上傳新版本",
  3421: "給自己文件重命名",
  3422: "給別人文件上傳新版本",
  3423: "給別人文件重命名",
  3424: "部門內成員管理",
  3425: "文件負責人模式",
  3426: "啟用該模式，文件的負責人要對自己負責的文件負全責，即自動擁有管理該文件的權利，而不受自己在部門角色的影響。但是對於非自己負責的文件來說，權限仍然受自己的部門角色限制。默認自己上傳到部門中的文件（夾）自己就是負責人，但是如果上傳到別人負責的文件夾中，則文件的負責人就不是自己了。負責人自己和部門管理成員有權轉換文件的負責人。如果關閉該模式，則文件負責人的權限和普通人一樣，完全受部門角色限制。",
  3427: "部門角色列表",
  // 3419: '', 
  // 3419: '', 
  // 3419: '', 
  // 3419: '', 
  3428: "操作人",
  3429: "你確定要關閉這些文件的分享嗎？",
  3430: "字段不能為空",
  3431: "部門審批流程",
  3432: "當前審批流程策略",
  3433: "編輯修改",
  3434: "部門審批流程設置",
  3435: "設置本部門的成員發起審批時如何使用審批流程",
  3436: "可選全部預制審批流程",
  3437: "限用特定審批流程",
  3438: "與父部門限制相同",
  3439: "本組至少有",
  3440: "人通過，審批才可以通过",
  3441: "沒有備選的審批流程模板",
  3442: "去創建",
  3443: "工作台推送",
  3444: "從下方列表選取成員",
  //---------- 5.8*------------- 
  3445: "閱覽室",
  3446: "創建閱覽室",
  3447: "只有放到閱覽室的檔案和檔案夾才能被普通成員看到並借閱",
  3448: "開放級別",
  3449: "限定部門",
  3450: "請輸入部門名稱",
  3451: "編輯閱覽室",
  3452: "添加相關文件",
  3453: "相關文件列表",
  3454: "暫無相關文件",
  3455: "從企業部門列表中添加",
  3456: "暫無成員",
  3457: "暫無",
  3458: "閱覽室含有子文件",
  3459: "下載定稿PDF",
  3460: "下載帶水印PDF",
  3461: "導出報表",
  3462: "當前篩選條件下，需要導出日誌條數超過2000條，系統僅會導出前2000條，確定繼續導出嗎？",
  3463: "導出",
  3464: "{-somebody-} 申請{-type-} 檔案文件(夾){-file-}，並附言：{-comment-}",
  //-------------------5.9------------- 

  3465: "下載成員報表",
  3466: "對應目錄不存在，打開失敗",
  3467: "全文搜索，按回車鍵確認",
  3468: "搜索文件名，按回車鍵確認",
  3469: "可以邀請任意人員加入該項目文件夾，默認創建者為項目負責人（可以通過轉交項目指定新的負責人）；當前項目階段完成後，項目負責人可以選擇轉交該項目給下一個階段的負責人，使得該文件夾可以跨越部門進行流轉",
  //---------------6.0------------------ 

  3470: "暫無被凍結賬戶",
  3471: "需要借閱",
  3472: "限定部門內可借閱",
  3473: "限定部門內公開",
  3474: "閱覽室內文件所有人可見，用戶可直接對閱覽室內文件進行查看、下載等操作",
  3475: "閱覽室內文件所有人可見，用戶需要借閱後，才能對閱覽室內文件進行查看、下載等操作",
  3476: "部門內公開指定部門內成員可見，用戶可直接對閱覽室內文件進行查看、下載等操作",
  3477: "閱覽室僅指定部門內成員可見，用戶需要借閱後，才能對閱覽室內文件進行查看、下載等操作",
  3478: "項目負責人",
  3479: "允許匿名上傳（在線編輯）",
  3480: "允許匿名上傳後，如果有人在该文件夾下匿名上傳違規文件，責任由分享發起者擔負",
  3481: "需要設置截止日期",
  3482: "去設置",
  3483: "你的賬戶已被系統凍結，恢復賬號請聯繫客服人員，點擊確認退出",
  //------------------6.1------------------ 

  3484: "企業上傳統計",
  3485: "暫無符合條件的用戶",
  3486: "文件訪問統計",
  3487: "人員",
  3488: "總量",
  3489: "閱讀文件",
  3490: "批註討論",
  3491: "查詢",
  3492: "暫無符合條件的查詢結果",
  3493: "已用去{-days-}天",
  3494: "僅剩余{-days-}天",
  3495: "已過期{-days-}天",
  3496: "用時{-days-}天",
  3497: "請選擇所選成員的默認角色",
  3498: "企業所有文件夾",
  3499: "當前日期",
  /***************** 錯誤提示 *********************/
  3500: "添加失敗，請稍後重試",
  3501: "獲取部門信息失敗",
  3502: "部門空間修改成功",
  3503: "部門空間修改失敗，請稍後重試",
  3504: "設定值等於已占用空間，將無法上傳新內容",
  3505: "角色修改成功",
  3506: "角色修改失敗，請稍後重試",
  3507: "添加成功",
  3508: "添加人員失敗，請稍後重試",
  3509: "成員已從該部門移除",
  3510: "移除失敗，請稍後重試",
  3511: "確認刪除該賬號?",
  3512: "賬戶已停用",
  3513: "停用賬戶失敗",
  3514: "賬戶已恢復",
  3515: "恢復賬戶失敗",
  3516: "發佈成功",
  3517: "發佈失敗，請重試",
  3518: "發佈人已刪除",
  3519: "確認刪除已選中發佈人",
  3520: "刪除失敗，請重試",
  3521: "歷史公告獲取失敗",
  3522: "刪除失敗，服務器端錯誤",
  3523: "審批信息獲取失敗",
  3524: "添加分組成功",
  3525: "分組信息獲取失敗",
  3526: "服務器端錯誤，獲取管理員失敗",
  3527: "確認刪除-<strong>{-name-}</strong>的管理員身份",
  3528: "增加存儲空間上限成功",
  3529: "增加存儲空間上限失敗",
  3530: "修改存儲空間上限成功",
  3531: "修改存儲空間上限失敗",
  3532: "在線內部成員信息獲取失敗",
  3533: "在線外部人員信息獲取失敗",
  3534: "訪問的鏈接不存在，返回管理",
  3535: "創建文件收集箱失敗！",
  3536: "修改失敗或者無權限",
  3537: "獲取角色信息失敗",
  3538: "添加角色失敗，請稍後重試",
  3539: "修改角色信息失敗，請稍後重試",
  3540: "刪除角色信息失敗，請稍後重試",
  3541: "角色名不能和已有名稱重複",
  3542: "獲取企業水印信息失敗，請稍後重試",
  3543: "水印範圍設置成功",
  3544: "水印範圍設置失敗，請稍後重試",
  3545: "文字水印設置成功",
  3546: "文字水印設置失敗，請稍後重試",
  3547: "圖片水印設置成功",
  3548: "圖片水印設置失敗，請稍後重試",
  3549: "水印關閉成功",
  3550: "水印關閉失敗，請稍後重試",
  3551: "已選擇",
  3552: "重新上傳圖片",
  3553: "上傳圖片",
  3554: "企業信息獲取失敗，請稍後重試",
  3555: "企業用戶信息獲取失敗，請稍後重試'",
  3556: "保存成功",
  3557: "信息格式錯誤，請重試",
  3558: "對不起，您沒有權限操作",
  3559: "保存失敗，請稍後重試",
  3560: "企業logo上傳失敗，請稍後重試",
  3561: "打開郵件提醒失敗，請稍後重試",
  3562: "關閉郵件提醒失敗，請稍後重試",
  3563: "內部成員信息獲取失敗",
  3564: "角色替換",
  3565: "將企業內所有人擁有的某個角色替換為新角色",
  3566: "舊有角色",
  3567: "",
  3568: "",
  3569: "替換為",
  3570: "角色替換成功",
  3571: "角色替換失敗，請稍後重試",
  3572: "請選擇",
  3573: "建立一個新角色",
  3574: "從已有角色複製",
  3575: "訪問日誌",
  3576: "下載失敗",
  3577: "查看文件",
  3578: "下載進度",
  3579: "選擇圖片",
  3580: "頭像預覽",
  3581: "文件大小超過{-size-}MB，請重新選擇",
  3582: "文件類型錯誤",
  3583: "圖片水印只支持png格式",
  3584: "未分享",
  3585: "<span> {-folderCount-} 個文件夾</span><span class='mgl-10'> {-fileCount-} 個文件</span>",
  3586: "文件收集箱創建成功",
  3587: "標籤刪除中",
  3588: "刪除失敗，你沒有刪除權限",
  3589: "刪除失敗，未知錯誤",
  3590: "標籤撤銷成功",
  3591: "標籤撤銷失敗",
  3592: "文件複製中",
  3593: "文件複製成功",
  3594: "文件複製失敗，未知錯誤",
  3595: "文件複製失敗，您的空間不足",
  3596: "文件撤銷成功",
  3597: "文件撤銷失敗",
  3598: "文件夾創建成功",
  3599: "文件夾創建失敗,請稍後重試",
  3600: "文件刪除成功",
  3601: "文件刪除失敗",
  3602: "刪除失敗，請刷新頁面後重試！",
  3603: "含有共享文件(夾)，請先關閉其分享！",
  3604: "知道了",
  3605: "恢複文件成功",
  3606: "恢複文件失敗",
  3607: "錯誤碼",
  3608: "重命名成功",
  3609: "重命名失敗,稍後重試",
  3610: "恢複名稱成功",
  3611: "文件恢複失敗",
  3612: "移動文件",
  3613: "文件移動成功",
  3614: "含有分享文件",
  3615: "部門文件不允許移動到非部門的文件夾",
  3616: "部門文件不允許移入到個人私有文件夾",
  3617: "移動失敗",
  3618: "文件恢複成功",
  3619: "文件恢複失敗",
  3620: "私有文件",
  3621: "搜索角色名稱",
  3622: "文件密級設置失敗，請稍後重試",
  3623: "設置水印位置成功",
  3624: "設置水印位置失敗",
  3625: "設置水印透明度成功",
  3626: "設置水印透明度失敗",
  3627: "設置註冊賬戶水印成功",
  3628: "設置註冊賬戶水印失敗",
  3629: "設置企業當前策略成功",
  3630: "設置部門當前策略成功",
  3631: "獲取地址池信息失敗，請稍後重試",
  3632: "獲取mac地址綁定信息失敗，請稍後重試",
  3633: "團隊人數已達上線，加入失敗",
  3634: "默認允許用戶上傳個人私有文件",
  3635: "關閉該選項，將不允許用戶上傳個人私有文件，已上傳的個人私有文件予以保留。注：管理員可以在成員管理功能中對特定用戶是否擁有個人私有文件進行特殊處理；部門文件夾以及企業共享文件夾以外的文件屬於個人私有文件。",
  3636: "企業默認",
  3637: "不允許",
  3638: "允許",
  3639: "注意：上限輸入 0 表示不限制其個人私有文件空間",
  3640: '文件收集箱"{-name-}"僅收取"{-str-}"文件',
  3641: "你已經是團隊成員了",
  3700: "部門權限列表",
  3701: "文件權限列表",
  3702: "文件分享權限",
  3703: "申請文件{-file-}的”{-roleName-}“權限",
  3704: "並附言：",
  3705: "申請文件權限",
  3706: "發送消息",
  3707: "請選擇文件",
  3708: "從現有文件選擇",
  3709: "上傳新文件",
  3710: "附件",
  3711: "上傳附件",
  3712: "給你發送了一條消息",
  3713: "查看歷史消息",
  3714: "作為消息的附件",
  3715: "發件人",
  3716: "轉發",
  3717: "你有一條新的巴別鳥系統通知，點擊查看詳情",
  3718: "部門",
  3719: "刪除本企業",
  3720: "解散",
  3721: "刪除企業將刪除企業所有文件，企業成員將自動變成個人版用戶，這是一個不可恢複的操作，你需要輸入管理員密碼來執行這個操作",
  3722: "刪除本賬戶",
  3723: "刪除此賬號將導致所有文件丟失，此操作不可恢複，需要慎重！你需要輸入密碼來執行此操作",
  3724: "進行此操作後，企業擁有者將會變為選定的目標用戶，當前用戶將不再是企业擁有者，請輸入當前用戶密碼以繼續此操作",
  3725: "直接拖拽文件到此處也可以上傳哦",
  3726: "文件配置",
  3727: "文件黑名單",
  3728: "文件黑名單,即文件類型黑名單，加入黑名單的文件類型將不允許上傳，輸入您想屏蔽的文件擴展名到下面的列表即可",
  3729: "請輸入加入黑名單的文件擴展名，例如jpg",
  3730: "黑名單列表",
  3731: "搜索的擴展名",
  3732: "該擴展名在黑名單中已經存在",
  3733: "暫無常用標籤",
  3734: "申請文件個數不能超過10個",
  3735: "項目到期後，僅項目管理員可訪問及管理該項目，如無需截止日期此項可以留空。",
  3736: "該擴展名在白名單中已經存在",
  ///////////////////////////首頁 

  4000: "功能",
  4001: "價格",
  4002: "解決方案",
  4003: "企業公有雲版",
  4004: "資源",
  4005: "創新的企業文件管理平台，共享協作更高效",
  4006: "效率更高管理更細",
  4007: "免費試用",
  4008: "巴別鳥企業網盤，客戶端上線",
  4009: "Windows+Mac雙平台發佈",
  4010: "同步任意文件 輕鬆指定",
  4011: "巴別鳥企業網盤",
  4012: "免費下載",
  4013: "文檔內容協同網盤",
  4014: "免費註冊",
  4015: "或 登錄",
  4016: "巴別鳥企業網盤專業版上線",
  4017: '超越"個人版" ，空間更大功能更強',
  4018: "隨時隨地使用你的文檔，協作無間",
  4019: "現在你不僅能在網頁端登錄，也可以通過智能手機使用巴別鳥",
  4020: "同時，你可以直接在線編輯office文檔，無需安裝office軟件",
  4021: "下載巴別鳥客戶端",
  4022: '在文件內容上直接討論，<br class="hidden-xs">協同工作，更可編輯',
  4023: "在想交流的地方直接點擊，即可開啟討論甚至可以使用語音及手繪圈畫，讓交流更生動高效，所有加入分享的成員可以實時回復，移動端交流更順暢，office文檔點擊編輯按鈕更可在線修改並自動生成新版本。",
  4024: "不必另外購買軟件，<br>即可查看大多數文件",
  4025: "支持近200種格式的文件無需下載任何應用程序，無論常用的office，蘋果專屬的iWork，在巴別鳥中都能直接打開。連設計專用的PS、AI甚至AutoCAD，Solidworks等專業3D格式，也能輕預覽鬆協同討論。下載客戶端後，更能在PC及Mac上調用本地應用程序編輯雲端內容並自動同步，真正實現雲端工作無縫協同。",
  4026: "指定任意文件夾自動同步<br>隨時共享最新資料",
  4027: "指定同步文件夾後，任何更新內容通過同步端都可以同步至各平台<br>無需反復下載、上傳，也無需手動設置，自動完成。通過同步共享文<br>件夾，團隊文件實時更新，共享最新資料輕鬆實現。",
  4028: "了解更多",
  4029: "獲權威機構QUALYS安全性A",
  // 4030: "目前國內最安全的SaaS系統", 
  4030: "",
  4031: "巴別鳥可以控制每一個文件及每一位成員的訪問行為，並留有詳細的訪問日誌，可以了解每一位成員的工作動態。同時，巴別鳥使用了安全等級最高的EV SSL認證，銀行級別的加密傳輸，多服務器多機房分佈式備份。確保你的數據安全無憂。",
  4032: "為企業量身定製<br>解決文檔使用的所有需求",
  4033: "針對企業推出大量管理功能，支持共屏會議、版本管理、文稿審批、成員管理、權限分配、大文件傳輸，超大存儲空間。可代替郵件及OA系統，甚至能節約企業office及CAD等專業軟件的採購成本。巴別鳥不僅僅是個企業網盤<br>支持公有雲及私有雲部署方案，全面解決你的文件管理問題。",
  4034: "了解巴別鳥企業服務",
  4035: "產品",
  4036: "團隊",
  4037: "支持",
  4038: "功能",
  4039: "定價",
  4040: "試用企業版",
  4041: "服務條款",
  4042: "隱私政策",
  4043: "公司介紹",
  4044: "聯繫我們",
  4045: "加入我們",
  4046: "下載巴別鳥iOS版",
  4047: "下載巴別鳥安卓版",
  4048: "巴別鳥產品說明書",
  4049: "意見及建議",
  4050: "從文檔出發，高效協作",
  4051: "我們的工作往往圍繞著各種文檔展開又圍繞著各種文檔結束。無論是策劃一場有趣的戶外旅行，或是建造一項壯觀的工程，我們都需要和大量的文檔打交道。小到一個word文檔大到一個水壩的3D設計圖紙，你只要把文件拖拽入巴別鳥並邀請團隊成員加入就可以直接在文件的內容上協作討論。Web、iOS、Android 全平台實時協作。協作、存儲、討論、文件歸檔，人員管理、權限控制，隨時隨地.....使用巴別鳥，體會真正的高效。",
  4052: "下載巴別鳥產品說明書",
  4053: "文檔",
  4054: "我們的工作計劃和工作成果",
  4055: "文檔是巴別鳥管理的基本單元，也是團隊協作、知識共享和創意溝通的核心。所有的工作文檔都可以分門別類地放在巴別鳥上。巴別鳥將提供給你一個井然有序的工作環境，你可以便捷地查找和分發工作所需文檔，也可以快速查閱特殊格式文檔，還能和團隊成員基於文檔內容自由地討論。",
  4056: "我們共同的空間",
  4057: "和你熟悉的網盤使用起來一樣方便，但更適合和同伴一起使用。點擊“新建”按鈕，你可以創建文件夾，並根據實際需要為文件夾命名，通過創建不同的文件夾分門別類管理文檔。你和夥伴可以共同使用一個文件夾，共享文檔更方便。",
  4058: "我們能在文檔內容上直接對話",
  4059: "你可以和團隊成員一起在巴別鳥上開展討論。在文檔上直接建立“批注”針對具體細節深入探討，並可以統一管理，快速定位到討論的內容上，讓討論圍繞主題不失焦。",
  4060: "討論",
  4061: "有組織才能更高效",
  4062: "你可以創建和管理團隊，和團隊成員共享知識。團隊文件夾的文件會自動共享給每一位成員。並且可以管理每個成員的權限，同時團隊也是一個討論組，你甚至可以把團隊當微信群用。",
  4063: "格式",
  4064: "沒有格式才能讓思維飛",
  4065: "使用巴別鳥，你幾乎不用擔心文檔打不開的問題。巴別鳥是支持打開格式最多的網盤。大多數網盤無法預覽的特殊格式，比如PSD、Ai、DWG等，用巴別鳥都能輕鬆查閱和討論。無需購買和安裝其他應用程序。",
  4066: "權限",
  4067: "安全的保證",
  4068: "巴別鳥可以控制使用者的權限，文檔的權限，多種權限方案讓你能在靈活使用和安全穩妥上進行選擇。由於使用H5來顯示文檔，巴別鳥可以有效保護你的源文件，並且可以追蹤文件的訪問和打開情況，文檔的打開、預覽、討論、下載、轉發、編輯權限你都可以控制。",
  4069: "客戶端",
  4070: "協作效率翻倍",
  4071: "客戶端可以作為一個工作入口，開啟後可以查看你在巴別鳥上的所有文件，代辦事項及部門成員動態。最令人振奮的是，使用客戶端可以調取本地的應用程序直接編輯巴別鳥上的文件，編輯過程中自動鎖定，編輯完成後自動生成新的版本。這意味著，你可以和團隊成員修改同一個office文檔，或者3D模型，CAD設計稿。無需上傳，整個團隊的工作都在雲端。",
  4072: "隨時隨地",
  4073: "無論是用手機APP，還是使用網頁版或者是電腦客戶端，巴別鳥都可以直接編輯office文檔，真正做到隨時隨地的協同工作。你可以在地鐵上用手機輕鬆修改你的演講PPT，可以在機場校對銷售數據報表，修改合同條款。並且無需發送郵件你的修改就會實時通知到你的團隊成員或客戶。配合客戶端使用，甚至能調取你的AutoCad編輯你在巴別鳥上的圖紙，無縫的體驗更能提升工作效率高達300",
  4074: "我中有你你中有我",
  4075: "如果你已經擁有OA，ERP甚至其他文檔管理系統，沒關係！你也能享受巴別鳥的服務，只要使用巴別鳥接口，任何有文檔出現的地方我們都可以用巴別鳥完成轉碼和討論，享受巴別鳥帶來的便捷和效率提升。",
  4076: "巴別鳥—高效的文檔協同系統",
  4077: "現在體驗",
  4078: "減少會議",
  4079: "使用巴別鳥我們可以直接在文件內容上討論，支持語音對講，手寫等方式(需要配合巴別鳥app使用)。所有的討論還可統一管理，生成待辦事項並跟進執行結果。告別雜亂無章的會議，提高工作效率。",
  4080: "版本管理",
  4081: "巴別鳥可以方便管理文件各個歷史版本，並可在各個版本間隨意切換對比異同。",
  4082: "可控的安全",
  4083: "堡壘往往是从內部被攻破的，巴別鳥企業版在技術上使用了業界標準RSA+AES 128位加密算法(就是傳說中的銀行級加密）但最重要的是在設計上，巴別鳥使用了預覽文件和源文件分開的辦法，用H5頁面預覽和操作文件，使用時並不調取源文件，權限管理+無需下載即可使用的方式最大程度上保護了你數據的安全。因為使用網頁預覽，所以文件的所有使用情況都能被跟蹤，安全可掌控。",
  4084: "監控及分析",
  4085: "巴別鳥使用網頁傳播和討論文件意味著我們可以了解到我們分享的文件使用情況。通過巴別鳥我們可以知道我們分享的文件被誰打開、什麼時候打開、看了多少頁、停留時間長短等信息，方便我們了解文件的使用情況並做出決策。",
  4086: "個性化",
  4087: "巴別鳥企業版支持logo及界面的個性化定制，在後台就可以輕鬆替換logo，打造企業的專屬應用，提高員工歸屬感。",
  4088: "可定制的存儲",
  4089: "使用巴別鳥企業版我們不用擔心空間不夠用，從初始500G容量到無限的存儲空間你都可以選擇。",
  4090: "私有化部署",
  4091: "所有數據存儲在內網私有服務器中，任何外部人員（包括巴別鳥官方）都無法訪問。此外，內網部署網絡性能優秀，文件同步速度快，最大化提高工作效率。",
  4092: "移動商務",
  4093: "巴別鳥企業版可以使用專屬的APP，無論在手機或iPad都能擁有和網頁版一樣的用戶體驗及功能。讓你隨時隨地可以使用文件並高效完成工作。",
  4094: "在線編輯",
  4095: "巴別鳥手機APP及web版可以在線編輯office文檔，並且編輯時能自動鎖定防止衝突，編輯完成自動生成新版本。使用巴別鳥客戶端更可以調取本地應用編輯在線文件",
  4096: "提升效率",
  4097: "巴別鳥讓公司共用同一個存儲空間，成員在同一個文件副本上協作，可以大幅降低企業存儲成本。同時免去了郵件來回討論問題及複雜的審批流程，文檔一有更改相關人員就能即時收到通知迅速對應。經測試，巴別鳥系統能提升知識型企業300",
  4098: "開放接口API",
  4099: "巴別鳥企業版開放存儲、解析及文件討論的相關接口（API），企業可根據自己的需求，開發各種應用，也可與企業已有系統集成。此外，巴別鳥支持統一認證接口，輕鬆對接企業認證系統，統一管理用戶。",
  4100: "安心的服務",
  4101: "巴別鳥的成長需要你的支持，所以我們會提供讓你最為安心的服務。了解你的需求並改進產品，上門培訓你的員工，7*24小時電話支持，遠程調試 …..這一切只希望巴別鳥能創造越來越多的價值，改變人們使用文件的方式。",
  4102: "使用巴別鳥，團隊協作更高效",
  4103: "個人版",
  4104: "個人文檔存儲，快速完成協作",
  4105: "免費",
  4106: "滿足個人基本的使用需求。簡單、方便、安全。",
  4107: "立即使用",
  4108: "2G存儲空間",
  4109: "支持建立團隊2個",
  4110: "https加密保護",
  4111: "單個文件最多保存10個歷史版本",
  4112: "單個文件上傳最大支持5G",
  4113: "支持批注討論文檔內容",
  4114: "支持私密批注",
  4115: "支持文件批量下載",
  4116: "支持文件權限管理",
  4117: "可預覽CAD文件",
  4118: "可預覽3D文件",
  4119: "1:1模式預覽超大圖片",
  4120: "可在線播放視頻",
  4121: "可定制需要的文件預覽格式",
  4122: "共享標籤",
  4123: "標籤管理",
  4124: "文件閱讀狀態統計",
  4125: "文件協作與審批",
  4126: "企業組織管理架構",
  4127: "強大的管理員工具",
  4128: "細緻權限設置",
  4129: "可自定義企業Logo和名稱",
  4130: "專屬UI界面",
  4131: "企業獨有的域名登錄",
  4132: "獨立的用戶體系",
  4133: "私有化部署",
  4134: "支持同步客戶端",
  4135: "支持APP端訪問使用",
  4136: "專屬客戶經理",
  4137: "小團隊文件共享協作",
  4138: '<span class="rmb">￥</span>2,000<span class="yearly"> / 年</span>',
  4139: "包含“個人版”所有功能，更大的存儲空間，更強的功能。",
  4140: "立即購買",
  4141: "1T存儲空間",
  4142: "新建團隊個數不限",
  4143: "單個文件保存歷史版本不限",
  4144: "無限預覽CAD文件",
  4145: "無限預覽3D文件",
  4146: "企業公有雲版",
  4147: "使用人數不限，適用中小企業",
  4148: "充裕的存儲空間，強大的後台管理及權限管控體系，獨立的訪問域名，為企業打造專屬雲服務。",
  4149: "申請試用",
  4150: "2T存儲空間（可靈活擴容）",
  4151: "無限建立部門",
  4152: "銀行級加密保護",
  4153: "專有的登錄入口",
  4154: "賬號可同時登錄企業版和個人版",
  4155: "企業私有雲版",
  4156: "定制，安全性強，機構及政企首選",
  4157: "量身定制",
  4158: "包含“企業公有雲版”所有功能，為企業提供定制化及私有化部署服務",
  4159: "按需無限定製存儲空間",
  4160: "可選加密保護方式",
  4161: "他們在使用",
  4162: "選擇針對企業用戶設計的巴別鳥企業版",
  4163: "更專業，更高效，也更安全",
  4164: "行業解決方案",
  4165: "每個行業對文件的使用或多或少都有獨特的需求點<br>針對不同行業的特殊需求，巴別鳥提供了一系列行業解決方案，幫助企業能更高效的使用巴別鳥",
  4166: "工程及製造",
  4167: "對圖紙和專業格式的支持",
  4168: "科學與教育",
  4169: "課件管理及論文答辯 知识庫管理",
  4170: "出版發行",
  4171: "三審三校 稿件管理",
  4172: "廣告及設計",
  4173: "設計稿管理，ps，ai支持，快速分法，設計稿上直接討論",
  4174: "互聯網公司",
  4175: "從需求方案，產品原型，到成品設計稿，市場團隊知識庫",
  4176: "跨國企業",
  4177: "文件共享，遠程會議討論，國際網絡優化，傳輸速率",
  4178: "更多行業",
  4179: "如果你所在的行業有特殊需求需要巴別鳥改進，請聯繫我們。<br>我們會派代表聯繫你們，深入了解你們的需求和工作流程，推出適合你所在行業的產品。<br><strong>* 每个行业的第一个用户我们会提供一年的免费服务。</strong>",
  4180: "高效的文檔協同系統",
  4181: "為企業而生",
  4182: "文件存儲、團隊協作和組織管理三位一體",
  4183: "企業公有雲版為企業帶來哪些好處？",
  4184: "除了享有個人版及專業版的所有功能外，還能享受以下特權",
  4185: "超大的基礎空間，滿足海量存儲",
  4186: "提供2TB超大基礎存儲空間，可為企業儲存超100000 份文件。無論企業多少人，都可以統一協調地一起工作。",
  4187: "※（1TB ≈ 1048576M，每份文件按10M估計）",
  4188: "免費預覽更多專業文件格式，可私密批注",
  4189: "企業公有雲版用戶可免費預覽批注更多文件格式，並且不受數量限制，無限量預覽。還可私密批注，交流方式更靈活，為企業的各崗位員工建立便捷的協作平台。",
  4190: "超強的企業組織架構，管理更輕鬆",
  4191: "為企業構建一個完美匹配線下的企業組織管理架構，",
  4192: "員工在線上更容易跨部門對接。",
  4193: "強大的管理員功能，可批量邀請員工，設置不同身份角色。",
  4194: "詳細的操作日誌記錄，可追蹤。",
  4195: "員工離職、升遷，文件一鍵交接遷移。",
  4196: "擁有獨立的登錄域名，自定義企業形象",
  4197: "企業公有雲版用戶，可以使用由企業名構成的獨立登錄域名，自定義企業Logo和名稱，設置統一的形像標識。對內，進一步塑造企業形像；對外，強化企業形像，提升企業的專業度。",
  4198: "客戶端訪問，員工工作入口",
  4199: "使用巴別鳥客戶端，每個員工將擁有統一的工作入口，根據權限的不同看<br>到不同的文件、代辦事項及部門成員動態，最令人振奮的是，使用客戶端<br>可以調取本地的應用程序直接編輯巴別鳥上的文件，編輯過程中自動鎖<br>定，編輯完成後自動生成新的版本。這意味著，你可以和團隊成員修改同<br>一個office文檔，或者3D模型，CAD設計稿，無需上傳，整個團隊的工作<br>都在雲端。",
  4200: "自定義水印，保護文件不被惡意傳播",
  4201: "巴別鳥企業用戶可以使用自定義的水印功能，可以以企業<br>logo、圖片、甚至員工的工號作為水印，並且可以設定水印<br>的使用範圍甚至在下載的PDF文件上內嵌水印，最大限度<br>的保護企業知識產權",
  4202: "更多企業專有功能助力企業高效辦公",
  4203: "審批、共屏演示、文件收集箱、部門文件分權限、超大圖片支<br>持等企業版特有功能，滿足企業用戶在文檔使用時遇到的<br>大多數問題，巴別鳥能解決企業發展過程中已經遇到或者<br>即將遇到的絕大多數文檔管理時的問題。",
  4204: "為什麼巴別鳥值得企業用戶信賴？",
  4205: "文件安全有三防<br>防泄密、防刪除、防下載",
  4206: "保護企業的文件安全是我們的首要任務。<br>為此，我們建立了嚴格的安全機制。文件加密分享，防止文件被泄密。<br>文件備份、後台操作日誌記錄，防止文件被惡意刪除並可追蹤。<br>靈活的文件權限設置，可控制其他人的操作權限，僅當被允許時才能下載。",
  4207: "預覽格式種類多<br>文檔、音視頻、2D和3D圖形",
  4208: "文件預覽及批注功能是我們最突出的特性，我們所支持預覽的文件數量在行業內幾無匹敵。既覆蓋了日常辦公所接觸的Office、iWork、PDF等，也涵蓋了一些專業人員接觸的專業文件格式，如.psd、.dwg、.ai、.indd等，甚至是3D文件格式如.dae、.obj格式。",
  4209: "溝通協作效率高<br>批注、討論、多端同步於一身",
  4210: "我們不僅僅為企業提供存儲、共享文件的服務，<br>還提供可內、外部協作的溝通服務。",
  4211: "用戶通過在線批注、團隊討論、多端同步、跨平台使用等功能，<br>可提升工作效率，改善工作質量。",
  4212: "人工服務快又好<br>每周不間斷提供答疑解難服務",
  4213: "專屬顧問為企業提供一對一的人工服務，<br>每周7天不間斷響應企業用戶的需求，<br>即時解決企業關於產品及服務的任何問題",
  4214: "更多功能敬請期待",
  4215: "動態篩選",
  4216: "動態篩選機制讓“動態”更人性化，只顯<br>示和用戶相關的文件、團隊討論動態。",
  4217: "",
  4218: "使用客戶端和巴別鳥系統配合企業用戶可以<br>加密所有文件，在沒有獲得授權的電腦上，<br>既使獲得了文件也無法開啟。確保企業文<br>件的傳播完全可控，切斷因文件泄露造成的損失。",
  4219: "全局加密",
  4220: "歸檔",
  4221: "歸檔功能可以使企業的重要文件更為有序妥<br>當的保存並確保文件的不可更改性，方便查詢<br>及管理。是企業建立文件檔案的最佳解決方案。",
  4222: "使用企業公有雲版，效率更高，管理更細",
  4223: "隨時隨地都可以使用巴別鳥",
  4224: "你不僅可以在辦公室用電腦使用巴別鳥，<br class='hidden-xs'>也可以在智能手機或iPad上使用巴別鳥APP，<br class='hidden-xs'>功能甚至比網頁端還強大",
  4225: "iOS通用版",
  4226: "App Store 下載",
  4227: "Android版",
  4228: "點擊下載",
  4229: "客戶端Windows版",
  4230: "支持Windows 10 以上系統",
  4231: "客戶端Mac版",
  4232: "支持macOS 10.8以上版本",
  4233: "直接掃描二維碼<br>關注巴別鳥微信公眾號",
  4234: "直接掃描二維碼<br>關注巴別鳥官方微博",
  4235: "巴別鳥說明書.pdf",
  4236: "巴別鳥介紹.pdf",
  4237: "巴別鳥部署安裝指南.pdf",
  4238: "馬上推出 敬請期待",
  4239: "無法刪除，當前部門下仍有子部門",
  4240: "Copyright © 2013-2019 上海畫擎信息科技有限公司",
  4241: "滬公安網備31010102003859 滬ICP備14029220號-3 本站關鍵詞: <strong>企業網盤</strong>",
  4242: "專為辦公打造，開啟簡單工作",
  4243: "查看巴別鳥詳細功能列表",
  4244: "該共享文件擁有者的日共享流量已經超過限制,文件下載失敗！",
  4245: "你無權刪除其他人的標籤",
  4246: "產品",
  4247: "企業網盤個人版",
  4248: "適用於個人用戶",
  4249: "企業網盤專業版",
  4250: "小團隊使用，加入人數不限",
  4251: "企業公有雲盤",
  4252: "中小企業分權限管理",
  4253: "企業私有雲盤",
  4254: "大企業、政府機構、學校首選",
  4255: "IT及企業文檔管理",
  4256: "管理整個企業的使用情況",
  4257: "安全與合規",
  4258: "全面保護您的數字資產",
  4259: "巴別鳥客戶端",
  4260: "編輯線上文件、同步及映射盤",
  4261: "工作流支持",
  4262: "討論及審批，簡化工作流程",
  4263: "定制服務",
  4264: "定制您自己的巴別鳥",
  4265: "API接口與整合應用",
  4266: "可整合多家應用，讓網盤無所不能",
  4267: "隨時隨地在任何設備和任何人進行安全協作",
  4268: "竟然如此好用!",
  4269: "企業文件統一管理",
  4270: "協同工作",
  4271: "數據安全",
  4272: "開始使用",
  4273: "為設計師準備的瀑布流素材管理功能",
  4274: "PSD、AI、DWG也能輕鬆駕馭",
  4275: "資源管理器集成",
  4276: "全新資源管理器集成（雲橋）功能上線",
  4277: "像使用本地磁盤一樣訪問整個企業網盤中有權限查看的所有文件",
  4278: "立即下載最新客戶端體驗",
  4279: "巴別鳥企業網盤能為您的企業做什麼",
  4280: "文檔集中管理",
  4281: "根據組織結構及成員權限統一管理文件，全文搜索快速查找",
  4282: "實時同步備份",
  4283: "文件在所有設備版本一致。與夥伴同步文件，協同工作",
  4284: "批注討論協作",
  4285: "打開大多數格式文件，在文件內容上直接建立批注實時討論",
  4286: "在線編輯文件",
  4287: "巴別鳥可以直接編輯在線文件<br>從office到CAD。高效完成協作",
  4288: "細化權限管理",
  4289: "角色、行為、部門、文件的權限<br>都可自定義。更可分部門管理",
  4290: "自定審批流程",
  4291: "可按業務需求自定義各種審批流程並導出報表，支持手寫簽名",
  4292: "知識檔案管理",
  4293: "內置知識管理及檔案管理模塊<br>滿足專業的檔案存儲及借閱管理",
  4294: "不改變使用習慣",
  4295: "可內嵌於windows資源管理器<br>直接訪問網盤，更方便更安全",
  4296: "進一步了解巴別鳥企業網盤更多功能",
  4297: "開啟新的工作方式",
  4298: "為企業打造",
  4299: "文件生命周期",
  4300: "安全",
  4301: "貼身服務",
  4302: "使用巴別鳥企業網盤，您團隊的所有文件資產（文檔，圖像，視頻等）都安全地存儲在雲中，團隊中的每位成員都可以從不同設備輕鬆的進行訪問、編輯、共享和評論。在企業級的安全性保障下協助您高效的完成所有工作，讓您的企業快速升級到高效雲辦公時代。",
  4303: "溝通效率及知識統一度決定瞭企業的競爭力",
  4304: "——稻盛和夫",
  4305: "討論-編輯-審核-協同-管理-歸檔",
  4306: "從草稿和提綱的溝通討論，文檔的創建、修改及團隊協作，到文件評審分發，給合作夥伴審核定稿，直至最終的歸檔、借閱、存儲。巴別鳥致力於整個文件生命周期各個環節的管理。讓您的企業效率更高，安全更有保障，知識得以沉澱。",
  4307: "安全是業務的關鍵！巴別鳥從產品設計到架構搭建及服務器管理都優先考慮安全性，並且包含瞭許多重要的安全功能。您可以控制每個文件及每位成員的訪問行為，添加文件水印，查看訪問日志。檔案庫可以最大限度保護重要數字資產。同時，巴別鳥使用瞭安全等級最高的EV SSL認證，銀行級的加密傳輸，多機房分布式備份，確保你的數據安全無憂。這些舉措使巴別鳥企業網盤獲得瞭權威機構QUALYS安全性A+認證",
  4308: "*巴別鳥使用阿里雲數據中心，保證99.9%可用性",
  4309: "從草稿和提綱的溝通討論，文檔的創建、修改及團隊協作，到文件評審分發，給合作夥伴審核定稿，直至最終的歸檔、借閱、存儲。巴別鳥致力於整個文件生命周期各個環節的管理。讓您的企業效率更高，安全更有保障，知識得以沉澱。",
  4310: "巴別鳥是一個企業服務類產品，企業服務的本質是服務企業，我們希望和我們的用戶一起成長。除了提供一流的產品，我們也提供您難以想象的專傢貼身服務。我們能為您提供團隊，工具和經驗，幫助您的企業快速上雲。Babel care團隊能深入企業調研需求並根據您的業務運營方式提供解決方案、搭建您的系統、進行培訓甚至能根據業務需求進行二次開發及API接入。讓您高效無憂的完成系統上線目標。",
  4311: "不改變習慣，簡單上手",
  4312: "直接批注討論",
  4313: "同步及雲橋",
  4314: "打開大多數文件",
  4315: "全平台",
  4316: "打開企業網盤中的文件後在想交流的地方直接點擊，即可在點擊的區域建立批注點開啟討論。您甚至可以使用語音及手繪圈畫讓交流更生動高效，企業網盤中所有加入分享的成員都可以實時看到您的批注並回復，移動端交流更順暢。所有的批注點都可以結構化管理，並且支持@及附件上傳。真正做到可管理的內容討論及任務分配。",
  4317: "使用巴別鳥客戶端，可以讓您無需改變操作習慣即可享受巴別鳥的雲服務。同步功能可以自動把巴別鳥企業網盤上的文件同步到本地，文件編輯時自動鎖定，編輯後自動上傳。雲橋功能內嵌於windows資源管理器中，您可以像訪問本地文件一樣訪問存儲在雲端的文件，並可直接在資源管理器中和同事協作。節約流量並且無縫操作。巴別鳥企業私有雲盤也支持客戶端訪問。",
  4318: "想查看文件？無需下載，直接點擊即可！無需安裝任何應用程序，您就能在巴別鳥上直接打開200多種格式的文件。從常用的office，蘋果專屬的iWork，圖片或視頻到設計專用的PS、AI甚至AutoCAD，Solidworks等專業3D格式，也能輕鬆預覽協同討論。下載客戶端後，更能在PC及Mac上調用本地應用程序編輯雲端內容並自動同步，真正實現雲端工作無縫協同。",
  4319: "隨時隨地查看自己和團隊的文件，多人協同討論及編輯",
  4320: "現在您不僅能在網頁端登錄，也可以通過智能手機及windows，mac客戶端來使用巴別鳥。同時，您可以直接在線編輯office文檔，無需安裝office軟件",
  4321: "使用企業私有雲盤的用戶也可以享受全平台服務",
  4322: "為團隊協作而生",
  4323: "部門及項目",
  4324: "強大的審批管理",
  4325: "細緻的權限管理",
  4326: "真正的協作",
  4327: "巴別鳥擁有一個強大的企業管理後台，支持建立或導入組織結構。同時支持windows域控。在巴別鳥中，您可以分部門管理，每個部門使用不同的權限及安全設置甚至不同的部門管理員。您也可以快速創建項目，協調各個部門人手，共享項目文件及跟蹤項目進度。",
  4328: "不同於OA的文件審批，巴別鳥提供瞭更為強大的可針對文件具體內容的審批工具。管理員可以自由預設審批流程及評審者權重，普通用戶也可以自定義多種審批形式，甚至可以邀請外部成員參與文件的審批。審批結果可導出報表打印存檔。",
  4329: "從文件的權限、人的權限到部門的權限、角色的權限、分享的權限。巴別鳥企業網盤提供瞭多個維度多種方式的權限管理。基本覆蓋了企業所需的所有權限配置。安全性到使用便捷性之間的平衡，系統管理員也可以在管理後台根據業務及部門的需求任意調節。",
  4330: "除了最基本的文件共享及流程管理，巴別鳥還提供瞭工作台、部門討論、動態、文件評論、文件內容批注、文件內容審批、文件共同編輯等多維度的協同工具。真正可以結合業務及使用場景在巴別鳥一個系統上完成工作。版本管理及鎖定機制能避免多個版本衝突或文件合併。使用巴別鳥後，團隊可以避免繁瑣的郵件多次溝通，OA的來回折騰。真正把工作重心放在工作中而不是管理中。",
  4331: "企業網盤解決方案強大及專業",
  4332: "面向行業的解決方案",
  4333: "工作流定制開發",
  4334: "私有化服務",
  4335: "開放API",
  4336: "從醫療行業專用的Dicom格式的標記討論，到工程使用CAD文件的協作及評審，再到3D模型細節的批注，簽證信息的分類儲存，AI文件的對比審稿。巴別鳥針對不同行業的用戶提供瞭適用於用戶所在行業的解決方案。同時對於我們不了解的行業，Babel care專傢團隊會深入企業，和用戶一起根據企業需求和我們的產品經驗一起搭建適合用戶使用的巴別鳥系統及巴別鳥企業私有雲盤。",
  4337: "我們的Babel care團隊能與您密切合作，深入了解您的組織的運作方式，包括您的公司文化和工作方式。這有助於我們發現用例和難點，在巴別鳥系統的基礎上定制您的工作流以滿足您獨特的需求，以便每個團隊可以無縫協作。從圖紙管理到簽證提交系統，我們已經幫助大量客戶實現了工作流程的定制開發及企業私有雲盤定制開發。",
  4338: "我們能提供多種靈活的私有化部署方案，從傳統的服務器集群，到超融合系統、混合雲、SD-wan。我們的工程師會根據您現有的硬件系統給出私有化方案，最大限度的利用您目前的硬件資源搭建您的企業私有雲盤。",
  4339: "巴別鳥開放平台支持在巴別鳥系統上的定制開發及系統對接。針對私有雲用戶我們提供了API授權及更高級別的代碼商務授權業務。您可以在巴別鳥系統的基礎上打造屬於您企業自己的系統。快速實現企業雲服務能力。",
  4340: "使用巴別鳥，搭建自己的雲系統",
  4341: "巴別鳥商業授權服務",
  4342: "想為您的客戶提供更多樣的服務？銷售資料的展示、合同報價管理、代理商文件管理、企業知識管理…使用巴別鳥商業授權服務，您的企業可以在巴別鳥系統基礎上開發自己的商業應用，讓企業快速擁有雲服務產品。",
  4343: "“巴別鳥是一個權限管理精細並符合我們安全要求的產品。他們強大的功能和專業的服務讓我印象深刻。”",
  4344: "— 錢學森空間實驗室 高主任",
  4345: "“巴別鳥能根據我們的業務流程搭建我們的圖紙評審系統及檔案管理系統。以很低成本極大提高了我們信息化進程。”",
  4346: "— 長城華冠信息部經理 姚志強",
  4347: "“立項了一年多時間，我們最終選擇了巴別鳥，除了產品優秀外，他們的定制化開發服務解決了我的後顧之憂。”",
  4348: "—— 至純科技 iT經理 莊稼",
  4349: "他們也在使用巴別鳥",
  4350: "了解巴別鳥企業服務",
  4351: "服務",
  4352: "主要功能",
  4353: "IT及管理",
  4354: "下載巴別鳥客戶端",
  4355: "巴別鳥產品說明書",
  4356: "友情鏈接:",
  4357: "精細管理企業成員，10人起訂",
  4358: "充裕的存儲空間，強大的後台管理及權限管控體系，獨立的訪問域名，為企業打造專屬雲服務。",
  4359: "每日5G高速下載流量",
  4360: "每日10G高速下載流量",
  4361: "每增加一名成員增加10G日流量",
  4362: "不限流量",
  4363: "最經濟的企業網盤解決方案",
  4364: "點擊購買巴別鳥專業版",
  4365: "低成本快速搭建企業網盤",
  4366: "使用巴別鳥專業版，您只需要購買一個賬號就可以無限組建團隊，並邀請無限多的用戶加入專業版組建的團隊中共享高達1TB的可擴容存儲空間並管理團隊成員在團隊中的訪問權限。並且不限制文件版本數量。",
  4367: "添加和管理你的團隊成員",
  4368: "專業版可以無限添加團隊及團隊成員，成員只要註冊免費的巴別鳥個人版就可以加入專業創建的團隊中，共享專業版的存儲空間，並和團隊成員共享文件協同工作。專業版賬號可以管理團隊中成員對團隊文件的訪問權限。僅購買一個專業賬號就可以享受到超過其他企業網盤企業版賬號的功能體驗。",
  4369: "無限保存文件新版本",
  4370: "巴別鳥專業版不限制文件保存的新版本數量，配合增量上傳技術可以在有限的空間內存儲大量的文件新版本。強大的版本管理可以下載任意時段的版本，並可回滾當前版本到任意歷史版本。無論是同步、客戶端編輯、還是映射盤（雲橋）上編輯的文件都能自動保存新版本。",
  4371: "3D和CAD文件預覽支持",
  4372: "巴別鳥專業版支持多種3D格式文件及CAD文件（.dwg)的預覽及建立批註點討論。同時巴別鳥的3D文件批註是建立在3D空間上的，可以直觀討論3D文件。",
  4373: "批註、動態、群聊一個都不少",
  4374: "不管是在任意文件上建立批註討論，還是動態列表、團隊討論空間、@其他用戶….這些企業版才有的功能專業版也統統擁有",
  4375: "同步、映射盤（雲橋）",
  4376: "專業版可以享受客戶端的全部功能，無論是任意文件夾的同步，多人編輯在線文件，或是最新推出的映射盤功能。只要安裝巴別鳥客戶端，這些功能專業版用戶均能享受",
  4377: "瀑布流",
  4378: "使用專業版你也可以使用瀑布流效果預覽您的圖片素材和文件，在賞心悅目的查看過程中直觀快速的找到需要的文件。",
  4379: "全平台",
  4380: "專業版一樣支持全平台的使用，幾乎可以在所有設備上使用巴別鳥專業版，我們不僅有windows和mac客戶端和手機移動端，我們還有為iPad界面定制的交互及UI。",
  4381: "現在就開始使用巴別鳥專業版",
  4382: "點擊購買巴別鳥專業版",
  4383: "巴別鳥企業網盤 私有雲",
  4384: "節約成本，放飛想法",
  4385: "可根據企業的需求量身定制",
  4386: "聯繫我們",
  4387: "經過公有雲數十萬用戶考驗的系統",
  4388: "巴別鳥公有雲網盤系統需要同時為包含免費用戶在內的60萬用戶提供持續不間斷服務、要擋住公網上的各種攻擊、要不斷提高系統效率以降低高昂的公有雲服務器成本。多達6年的公有雲不間斷服務經驗使巴別鳥系統久經考驗。巴別鳥私有雲系統是在巴別鳥公有雲系統基礎上發展起來的，繼承了公有雲巴別鳥的所有功能及特性，提供給您其他私有網盤無法比擬的高穩定性及高可用性。",
  4389: "私有雲率先支持在線office",
  4390: "開啟協同編輯時代",
  4391: "多人實時在線編輯",
  4392: "兼容各格式office文檔",
  4393: "實時評論",
  4394: "靈活的部署方式",
  4395: "比公有雲更細的自定義設置",
  4396: "無論是單服務器、多服務器、集群、超融合系統、分布式系統、第三方雲平台甚至Docker方式的部署我們都支持。我們的部署團隊可以根據你的需求和你共同制定部署方案。同時因為私有雲只服務於單一企業的特性，我們可提供遠超公有雲系統的可選自定義設置，從界面操作到流程到權限都可以根據你的需求調整。",
  4397: "Babel care 專業的產品級客服團隊",
  4398: "定制開發及行業解決方案服務",
  4399: "不同行業有不同的工作流程及使用習慣，為了更好的適用於您的使用場景，我們有由職業產品經理帶隊的Babel care團隊為您的企業定制屬於你的解決方案及二次開發支持。在巴別鳥的基礎上做出專屬您所在企業及行業的定制系統。我們曾幫助汽車廠商實現圖紙評審系統、幫建築企業打造設計協同系統、幫旅行公司完成自動簽證系統…",
  4400: "支持更多功能的開放api",
  4401: "巴別鳥私有雲系統能破除標準化產品帶來的限制，提供遠超公有雲系統支持範圍外的API，整個系統所有功能都可以API化，使之可以完美融入您現有的系統或待開發的系統中。巴別鳥商業授權支持您在巴別鳥系統的基礎上開發您自己的系統，以白牌授權的方式獲得巴別鳥的能力。",
  4402: "“我們花了1整年時間尋找能滿足我們要求的系統，最終巴別鳥私有化系統的API定制開發解決了我們的問題。相見恨晚”",
  4403: "—— 許經理 深圳市卯丁技術有限公司",
  4404: "聯繫我們",
  4405: "想了解更多？請撥打 4009204020 和我們銷售顧問聊聊您的需求",
  4406: "你也可以撥打13564686107 和我們的產品經理直接對話",
  4407: "使用巴別鳥私有雲系統可以比公有雲系統更先享受巴別鳥在線office，無論是word、還是excel、ppt都能完美支持。無需安裝軟件即可在手機端，網頁端直接在線編輯office文檔。支持多人實時在線編輯同一個文檔。（此功能目前僅私有雲系統支持，公有雲暫未開放）",
  4408: "全面掌握您的企業",
  4409: "強大的管理後台及客服支持確保您的工作順利開展",
  4410: "立即試用",
  4411: "聯繫我們",
  4412: "推動業務發展和IT規劃落地",
  4413: "我們充分理解IT部門面臨的壓力，和選擇我們需要承擔的責任。正因為如此，我們提供了強大的管理工具及客戶服務幫助IT人員從容應對企業各種瞬息萬變的需求。同時，多管理員及分部門管理功能也能大幅降低IT人員的負擔及維護難度。我們的免費初始化及培訓服務也能幫助IT管理人員快速使用及落地系統。",
  4414: "強大的全面的管理後台",
  4415: "為了讓IT人員能更好的管理企業，我們提供了獨立的管理後臺及強大的管理工具。輕鬆從成員、文件、部門、項目、分享等多個維度來管理企業的文件及協作。",
  4416: "輕鬆管理您的用戶",
  4417: "無論是企業成員還是第三方合作夥伴或是短期實習生，巴別鳥都能以多種方式進行管理。權限範圍一目瞭然，員工離職一鍵交接，部門可獨立管理部門成員。同時支持AD域控對接及單點登錄。",
  4418: "用角色來管理用戶權限",
  4419: "通過預設角色來統一管理用戶的初始權限更加方便高效且不易出錯。支持同一個用戶在不同部門擁有不同的角色。角色可自定義，高達30幾項細節權限可選",
  4420: "控制所有內容",
  4421: "從審批設置到分享行為控制、文件權限精細化調整、水印控制、成員使用情況日誌…..巴別鳥可以讓您完全控制成員使用內容的方式。並且支持mac地址綁定，讓特定成員僅能在特定設備使用巴別鳥。",
  4422: "分層級管理企業",
  4423: "考慮到大型企業權限管理的複雜性和工作量，巴別鳥支持多層級管理和多種職責不同的管理員設置。除超級管理員外還支持4種權限各不相同的管理員結構、支持每個部門獨立管理自己的成員及文件。",
  4424: "日誌及統計，讓管理更高效",
  4425: "除了文件使用日誌、部門使用日誌、成員日誌、系統日誌外，巴別鳥還支持數據統計及數據可視化。並支持導出報表，讓整個企業的使用情況一目瞭然。",
  4426: "連接您的系統",
  4427: "巴別鳥提供完善的API接口及中間件二次開發支持，能高效快速的和您現有的系統對接，讓巴別鳥成為您舊系統的文件存儲及管理平台。除了傳統的泛微OA、office365、企業郵箱、我們還支持和PDM、BIM系統及微信企業號集成。同時你還可以在巴別鳥平台上進行二次開發，為您的客戶推出更好的產品。",
  4428: "現在就開始體驗巴別鳥帶來的強大功能",
  4429: "全方位保護您的數字資產",
  4430: "下載巴別鳥數據安全策略",
  4431: "以安全為核心的系統設計",
  4432: "安全是業務的關鍵！巴別鳥從產品設計到架構搭建及服務器管理都優先考慮安全性，並且包含了許多重要的安全功能。",
  4433: "精細的權限控制",
  4434: "堡壘往往是從內部攻破的，安全的首要考慮是防止使用者泄露。巴別鳥從文件的權限、人的權限、部門的權限三方面切入的精細化權限管理系統能滿足絕大多數權限配置需求，使巴別鳥能更安全有序的保護重要數據。",
  4435: "可制定安全策略",
  4436: "巴別鳥獨有的“安全保密員”可以在管理後臺中制定企業的安全策略，獨立控制每個部門的安全等級。讓重要部門的數據得到妥當保護。",
  4437: "銀行級的加密傳輸",
  4438: "巴別鳥使用了安全等級最高的EV SSL認證，文件上傳下載使用HTTPS作為傳輸協議，傳輸過程中對文件本身進行了二次AES CTR 256算法流式分塊加密，確保最終保存在雲存儲系統的文件均為密文，在傳輸以及存儲過程中杜絕被竊取可能 。",
  4439: "碎片化存儲保護您的數據",
  4440: "巴別鳥采用碎片化存儲技術，文件被打散成若干碎片後分別存儲於不同的磁盤或服務器中，即使服務器被攻破，攻擊者也無法獲得完整的文件碎片以獲得文件。同時，巴別鳥支持私有化部署，讓數據存儲在更加安全的場所。",
  4441: "合規的安全",
  4442: "巴別鳥通過了多個權威機構的第三方檢測，並且我們定期會進行安全合規檢查。我們也獲得了QUALYS安全性A+認證，是目前國內唯一獲得A+認證的企業網盤",
  4443: "與安全廠商聯合推出更多服務",
  4444: "無論是全盤在線殺毒，還是已下載文件防泄密，或者企業級防火牆。巴別鳥和多家其他領域的安全廠商有長期合作關係。可以無縫整合其他廠商的安全產品以提供您更加全面的安全保證。",
  4445: "他們同樣注重安全",
  4446: "現在就開始體驗巴別鳥帶來的強大功能",
  4447: "下載巴別鳥數據安全策略",
  4448: "全新巴別鳥客戶端",
  4449: "更強大、更方便",
  4450: "讓企業網盤無人能及",
  4451: "巴別鳥客戶端其實包含了3個模塊。文件管理模塊、同步端、映射盤（雲橋），使用客戶端可以不改變使用習慣更方便的編輯文件並和團隊保持同步。同時，還擁有自動上傳新版本、增量上傳、自動鎖定文件、mac地址綁定、右鍵快速分享文件等功能，是迄今為止最強大的企業網盤客戶端。",
  4452: "同步、所有人所有設備",
  4453: "同一個項目或部門的文件夾、公司的mac和家裏的PC、還有您的移動設備。是的，巴別鳥支持在這些設備間同步多個用戶的數據。先進的衝突管理判斷機制能有效防止文件版本衝突發生。你可以不改變位置同步任意文件夾到巴別鳥，也可以同步巴別鳥上你有權力下載的任意文件夾到本地。",
  4454: "永遠用不完的硬盤空間",
  4455: "比同步更實用的巴別鳥映射盤（雲橋）功能，可以把巴別鳥作為一個磁盤驅動器並在windows資源管理器中訪問。您可以就像用一塊遠程硬盤一樣用它，訪問及編輯您權限範圍內可以處理的全部文件。不同於同步功能，映射盤並不會佔用太多本地存儲空間，這意味著你可以訪問和存儲比你本地硬盤大得多的數據。同時擁有企業級安全性來保護您所做的一切。",
  4456: "無縫創建及編輯所有文件",
  4457: "在巴別鳥客戶端，無論您是創建新文檔還是編輯PDF，都可以直接保存到巴別鳥。編輯時自動鎖定的機制防止其他人和你同時編輯造成衝突。巴別鳥app還支持在安卓設備上調取第三方應用來編輯文件，編輯完成後也能自動作為新版本保存至巴別鳥。",
  4458: "可選在特定設備上使用",
  4459: "巴別鳥可以開啟僅支持客戶端或移動設備訪問的設定，配合獨家的mac地址和賬號綁定功能您就可以做到讓某個用戶只能在公司的設備上使用巴別鳥而不能在私人設備上使用。大幅提高系統安全性。",
  4460: "增量上傳",
  4461: "增量上傳技術可以在同步文件時只上傳文件的更改部分，大幅節約上傳時間和版本存儲空間。使用增量上傳技術後，一個500MB的psd文件經過一次修改後可能只需要上傳5MB的文件，節約您大量上傳時間，並讓大文件的快速多版本保存成為可能。",
  4462: "全平台",
  4463: "我們幾乎可以在所有設備上使用巴別鳥，我們不僅有windows和mac客戶端和手機移動端，我們還有為iPad和大屏電視量身定製的巴別鳥版本",
  4464: "客戶端根據他們的需求多次迭代",
  4465: "感謝這些客戶在客戶端的開發過程中積極提出建議和需求，伴隨我們成長。正因為他們專業的建議和可落地的使用場景讓巴別鳥客戶端如此強大。我們客戶也能享受到更多的經過實踐有效的功能。",
  4466: "下載巴別鳥客戶端",
  4467: "自動化工作",
  4468: "簡化您的流程",
  4469: "立即試用",
  4470: "聯繫我們",
  4471: "基於文件生命周期管理而設計",
  4472: "巴別鳥致力於文件整個生命周期的管理。從文件的創建、修改、協同、共享、審批、分發、歸檔、到銷毀的整個生命周期，巴別都有相應的功能及流程進行管理，並可進行流程定製或解決方案搭建。充分運用巴別鳥可簡化您的關鍵且經常耗時的任務，提高業務速度。",
  4473: "可預設審批流程",
  4474: "在企業管理後臺可以按需求預設一批各類審批流程，不同的部門可以按需選擇自己需要的審批流程及流程使用規則。",
  4475: "功能強大的審批",
  4476: "支持多種審批方式，從最基礎的並行多人、順序多人到分組、加權、抄送、跨部門、跨公司，巴別鳥支持快速搭建幾乎所有的審批方式。並且，巴別鳥可以直接在文檔內容上以批注或手繪的形式提出審批意見。提高來回評審修改稿件的效率。",
  4477: "快速收集文件",
  4478: "巴別鳥特別的文件收集箱功能能保證稿件提交者在看不到其他提交者提交的文件的前提下管理和修改自己提交的稿件，並可設截止日期，自動通知，結果統計，提交者管理。是教師收作業（論文）、企業收集標書、政府收集材料的有力幫手。",
  4479: "一目瞭然的工作管理",
  4480: "不論是審批流程、收件記錄、還是歸檔管理，巴別鳥都有特別的管理界面來統一管理。並可以把管理界面自定義在工作台列表中。同時，通知和動態會把所有和您相關的信息組合在一起供你快速查看和使用。",
  4481: "及提醒關注",
  4482: "來分配任務給同事，或者提醒他看一下文章的某個章節或圖紙的某個細節。提醒關注功能可以讓某人同時關注某個文件或文件夾，並主動把文件或文件夾加入他的關注列表中。",
  4483: "管理您的項目",
  4484: "巴別鳥還可以極其方便的創建及管理項目，組建一個項目團隊，指定一名項目經理，由項目經理進行項目的管理。項目支持轉交，可以在項目開展的過程中根據需要轉交給不同的人或不同的部門。",
  4485: "歸檔及檔案管理",
  4486: "巴別鳥有整套獨立的檔案管理模塊。歸檔的文件會自動導入檔案庫，由檔案管理員分配。檔案庫有自己的搜索、借閱、和管理，文件不可修改，並具有極高的安全設定。",
  4487: "他們也關注流程",
  4488: "在線協同編輯",
  4489: "在線協同編輯（可選）",
  4490: "項目及文件收集箱",
  4491: "檔案庫",
  4492: "單個文件上傳最大支持10G",
  4493: "單個文件上傳大小可自定義",
  4494: "可設定文件密級和部門密級",
  4495: "分享審批",
  4496: "登錄設備限制",
  4497: "IP策略控制",
  4498: "水印及下載帶水印PDF",
  4499: "",
  4500: "運維管理員",
  4501: "運維管理員可以登錄企業管理後臺，主要負責部門的建立和各個部門的成員管理，以及審批流程，分組管理等等運營維護",
  4502: "添加運維管理員",
  4503: "管理運維管理員",
  4504: "確認刪除{-user-}的運維管理員身份",
  4505: "不限分組",
  4506: "點擊此處刷新動態",
  4507: "邀請人員信息輸入無效：",
  4508: "過濾了以下無效輸入人員：",
  4509: "當前列表中有的文件權限發生了改變，請點擊確定刷新文件列表",
  4510: "開發者賬號",
  4511: "如果需要在第三方通過 API 訪問您在巴別鳥上的數據，請在此處",
  4512: "申請開發者賬戶",
  4513: "回調URL",
  4514: "http url - 我們將通過這個 url 返回認證結果給您",
  4515: "開發者 id",
  4516: "開發者秘鑰",
  4517: "您的開發者賬號申請正在等待處理...",
  4520: "工作台",
  4521: "發佈時間",
  4522: "我最近訪問",
  4523: "我最近上傳",
  4524: "部門最近上傳文件",
  4525: "部門活躍文件",
  4526: "團隊最近上傳文件",
  4527: "團隊活躍文件",
  4528: "更多",
  4529: "本欄目暫無內容",
  4530: "最近企業消息",
  4531: "分類過濾",
  4532: "輸入文件名或分享人，回車搜索",
  4533: "順序",
  4534: "創建新的工作台欄目",
  4535: "卡片名稱",
  4536: "請輸入卡片名稱",
  4537: "對應的企業發佈文件夾",
  4538: "",
  4539: "暫無企業自定義的工作台欄目",
  4540: "編輯工作台欄目",
  4541: "欄目名",
  4542: "可自由定義審批流程",
  4543: "審批組",
  4550: "編輯工作台",
  4551: "選擇要顯示的圖表",
  4552: "我關注的",
  4553: "我打開的鏈接分享",
  4554: "我邀請人員加入分享的文件",
  4555: "我評論或批注過的文件",
  4556: "我的項目",
  4557: "部門最近活躍文件",
  4558: "標籤雲圖",
  4559: "文檔關係圖",
  4560: "備選圖表",
  4561: "自定義新圖表",
  4562: "對應的文件夾",
  4563: "選擇要展示的文件夹",
  4564: "該文件沒有相關文件",
  4565: "從該文件的相關文件中選擇",
  4566: "（文件最多保存10天）",
  4567: "處理結果",
  4568: "處理人",
  4569: "處理時間",
  4570: '<span class="rmb">￥</span>2,000<span class="yearly"> / 年</span>',
  4571: '￥2,000/年',
  4573: '￥35/人/ 月',
  4574: "单个文件上传最大支持1024G",
  4575: "单个文件上传最大支持2048G",
  4600: "本階段是否可以強行越過？",
  4601: "審批通過的比例限制：",
  4602: "本階段通過後是否就可以標記文檔定稿？（後繼階段只是推送通知）",
  4603: "階段名稱不能為空",
  4604: "階段",
  4605: "選擇審批流程",
  4606: "企業預制流程",
  4607: "個人預制流程",
  4608: "保存到個人審批流程",
  4609: "暫無預制流程<br>管理員可在“企業控制台-文件配置”欄目添加審批流程",
  4610: "暫無",
  4611: "向上移動",
  4612: "向下移動",
  4613: "角色",
  4614: "沒有審批流程",
  4615: "提示：沒有審批流程信息",
  4616: "保存失敗，請選擇評審人員",
  4617: "保存失敗，{-title-}中所選的角色沒有相對應的人員",
  // 4618: '根目錄數據錯誤，請聯繫客服人員', 
  4618: "網絡超時，請刷新後重試！",
  4619: "暫無預制流程",
  4700: "申請打開文件鏈接分享",
  4701: "申請邀請人員加入分享",
  4702: "{-name-}申請文件權限",
  4703: "{-name-}同意了申請",
  4704: "{-name-}否決了申請",
  4705: "{-name-}提醒你關注文件",
  4706: "{-name-}at你",
  4707: "{-name-}邀請你審批文件",
  4708: "{-name-}通過了審批",
  4709: "企業消息：文件通過了審批",
  4710: "企業消息：文件被駁回",
  4711: "巴別鳥通知： 系統更新",
  4712: "邀請你加入團隊",
  4713: "邀請您共同管理文件收集箱",
  4714: "{-name-}處理了你的打開文件鏈接分享請求",
  4715: "{-name-}處理了你的邀請人員加入分享請求",
  4716: "{-name-}給你發送了文件",
  4717: "系統消息：你所購買的巴別鳥服務即將到期",
  4718: "{-name-}開啟了文件演播",
  4719: "{-name-}發佈了企業通知",
  4720: "權限不足",
  4721: "你沒有此權限，你可以填寫你希望修改的名字發送請求給文件負責人或部門經理",
  4722: "需要的權限：",
  4723: "申請的理由：",
  4724: "發送申請",
  4725: "相關文件已刪除，本條消息已失效",
  4726: "自定義權限",
  4727: "新建空白權限",
  4728: "複製一個已有權限去編輯",
  4729: "正在生成預覽文件，不能進行此操作",
  4730: "登錄系統過於頻繁，請稍後重試",
  4731: "是否確定取消同步？取消同步後，該文件夾將不再同步到本地，您仍可通過雲橋模式或網頁進行訪問。",
  4732: "你沒有此權限，你可以填寫你希望移動到的目錄發送請求給文件負責人或部門經理",
  4733: "下載",
  4734: "打印為PDF",
  4735: "你沒有此權限，你可以選擇你希望修改的權限發送請求給文件負責人或部門經理",
  //****************** 8.1 *************** 

  4736: "驗證碼",
  4737: "獲取驗證碼",
  /**************8.2***************/

  4738: "項目助理",
  4739: "點擊選擇項目助理",
  4740: "選擇項目助理",
  4741: "項目經理和項目助理不能是同一個",
  4742: "添加項目助理",
  4743: "權限",
  //Authority 
  4744: "如何使用檔案庫？",
  4745: "檔案庫由檔案管理員進行管理，超級管理員可以指定一名或多名企業成員為檔案管理員。",
  4746: "歸檔的文件都在檔案庫根目錄，需要檔案管理員建立閱覽室（“新建”-“閱覽室”），並把檔案庫根目錄的文件移入閱覽室後其他企業成員才可以借閱。（選擇要移入的文件，點擊右鍵，選擇移動）",
  4747: "請使用客戶端預覽和批注DWG文件",
  4748: "（設置的權限優先級是：部門人員權限大於角色權限，角色權限大於部門內所有人權限）",
  4749: "保存中...",
  4750: "選擇查詢條件後點擊“搜索”查詢日誌",
  4751: "文件收集箱主要用於收集文件，讓投件人上傳文件到文件收集箱中",
  4752: "開放式收集",
  4753: "組織內收集",
  4754: "開放式文件收集箱會產生一個連結，您可以将連結發放出去，凡知道此連結的人不需要註冊就可以上傳文件",
  4755: "此種文件收集箱需要你指定企業內投件人名單，這些人在自動收到郵件和站內通知後進行文件上傳，不支持名單外人員投件",
  4756: "創建開放式文件收集箱",
  4757: "要求投件人填報的信息：",
  4758: "姓名",
  4759: "請輸入您的{-name-}",
  4760: "添加信息",
  4761: "這裡輸入信息填寫項的標題",
  4762: "這裡輸入信息填寫項的暗文",
  4763: "投件人填寫信息預覽",
  4764: "請填寫以下信息：",
  4765: "收集人：",
  4766: "發佈日期：",
  4767: "你可以將此連結地址發放出去，投件人訪問此連結即可上傳文件",
  4768: "用戶輸入項",
  4769: "暫無需要輸入的信息",
  4770: "未知ip",
  4771: "在這裡你可以自定義投件人上傳文件時需要填報的信息，使用修改或添加信息按鈕修改或增加條目。投件人點開投件連結後會出現信息填寫表單。",
  4772: "全部檔案",
  ////////////////*********8.3***************/ 

  4773: "僅查看分享及邀請",
  4774: "暫未開通在線編輯模塊",
  4775: "項目助理可以增加和刪除項目成員，為項目成員分配權限。但項目助理不能轉交和刪除項目。",
  ////////////////*********8.4***************/ 

  4776: "我的項目",
  4777: "暫無項目文件",
  4778: "暫無個人文件",
  4779: "請選擇次級目錄",
  4780: "請選擇目標文件夾",
  4781: "推送通知設置",
  4782: "我關注的文件",
  4783: "選擇該選項後，關注的文件夾或文件內容更新，新版本上傳都會收到系統推送通知。",
  4784: "當前目錄不允許上傳新文件",
  /////////////////*************9.0*******************/ 
  4785: "系統配置",
  4786: "郵件服務器",
  4787: "第三方賬號認證",
  4788: "存儲配置",
  4789: "郵箱服務器地址",
  4790: "請輸入郵箱服務器地址",
  4791: "端口",
  4792: "請輸入端口",
  4793: "授權碼",
  4794: "請輸入授權碼",
  4795: "是否使用smtp協議",
  4796: "放棄",
  4797: "是否開啟第三方認證",
  4798: "是否開啟第三方賬號同步",
  4799: "第三方認證方式",
  4800: "AD域認證",
  4801: "企業微信",
  4802: "釘釘",
  4803: "域",
  4804: "請輸入域名，如domain.com",
  4805: "路徑",
  4806: "如：DC=molasync,DC=cc",
  4807: "賬號",
  4808: "請輸入賬號",
  4809: "企業ID",
  4810: "請輸入CorpID",
  4811: "應用ID",
  4812: "請輸入Agent ID",
  4813: "應用秘鑰",
  4814: "請輸入secret",
  4815: "通訊錄秘鑰",
  4816: "請輸入address secret",
  4817: "移動端schema",
  4818: "請輸入移動端schema",
  4819: "應用鍵值",
  4820: "請輸入移動端AppKey",
  4821: "掃碼應用ID",
  4822: "請輸入掃碼AppId",
  4823: "掃碼應用秘鑰",
  4824: "請輸入掃碼AppSecret",
  4825: "網盤移動端應用ID",
  4826: "網盤移動端秘鑰",
  4827: "本地存儲",
  4828: "S3存儲",
  4829: "請將存儲盤映射到文件夾：",
  4830: "Secret",
  4831: "請輸入secret key",
  4832: "Access",
  4833: "請輸入access key",
  4834: "Server",
  4835: "請輸入server url",
  4836: "Bucket",
  4837: "請輸入bucket name",
  4838: "工號模式",
  4839: "打開此選項，將使用工號作為用戶的登錄賬號",
  4840: "高強度密碼",
  4841: "打開此選項，企業成員需設置10-20位包含大小寫字母、特殊字符及數字的組合作為密碼",
  4842: "此配置項僅在私有化部署的版本中有效，當前版本不支持",
  4843: "請輸入當前用戶登錄密碼",
  4844: "異常行為報警",
  4845: "24小時內下載文件數量超過",
  4846: "個",
  4847: "24小時內下載流量超過",
  4848: "GB",
  4849: "部門成員有反常的大規模下載將通知部門經理及管理員",
  4850: "是否需要進行登錄認證",
  4851: "加密方式",
  4852: "測試",
  4853: "請輸入接收方郵箱，我們將發送測試郵件到這個郵箱。點擊確定，調用接口進行發送，並返回測試結果",
  4854: "導出用戶參與文件列表",
  4855: "正在生成文件列表",
  4856: "請選擇接收人",
  4857: "請輸入1~99之間的整數",
  4858: "使用默認設置",
  4859: "僅名稱",
  4860: "正在向巴別鳥雲端網盤編輯文件。如果您離開此頁面，編輯內容無法保存。",
  4861: "文件夾和文件混排",
  4864: "文件夾下載的兩種方式：利用客戶端下載，或者在登錄狀態下進行下載",
  4865: "該文件支持在登錄狀態下進行下載",
  4900: "使用情況統計",
  4901: "企業稅號",
  4902: "公司發票必填此項",
  4903: "聯繫人電話"
};
var _default = exports["default"] = localString_cn_part1;

},{"1454":1454}],1155:[function(require,module,exports){
"use strict";

require(1461);
require(1503);
require(1415);
require(1463);
require(1456);
require(1418);
require(1537);
require(1457);
require(1453);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require(1180));
var _localString_en_part = _interopRequireDefault(require(1156));
var _localString_en_part2 = _interopRequireDefault(require(1157));
var _localString_en_part3 = _interopRequireDefault(require(1158));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var localString_en = _objectSpread(_objectSpread(_objectSpread({}, _localString_en_part["default"]), _localString_en_part2["default"]), _localString_en_part3["default"]);
var _default = exports["default"] = localString_en;

},{"1156":1156,"1157":1157,"1158":1158,"1180":1180,"1184":1184,"1415":1415,"1418":1418,"1453":1453,"1454":1454,"1456":1456,"1457":1457,"1461":1461,"1463":1463,"1503":1503,"1537":1537}],1158:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var localString_en_part3 = {
  //******************************* 初始化密码界面 */
  11001: "Initialization password",
  11002: "The first time you log in, you need to reinitialize your password",
  //////////////**************9.1.4 *****************************/
  11003: "Status",
  11004: "Export Record",
  11005: "Export Page",
  11006: "Search Exporter",
  11007: "Request time",
  11008: "Export time",
  11009: "Export file",
  11010: "Exporter",
  11011: "Reminder: Due to the large size of the exported file, in order to provide you with a safe and efficient download experience, your file export request will be temporarily stored on the cloud server after it takes effect and will automatically expire after three days.",
  11012: "Member report",
  11013: "Generating",
  11014: "Generated",
  11015: "Generation failed",
  11016: "There are currently no export records",
  11017: "Operation successful! Please go to the <span class=\"main-color\">\"Export Records\"</span> page to download and view. ",
  11018: "All statuses",
  11019: "This record has expired",
  11020: "Failed to obtain export record",
  11021: "Enterprise member information",
  11022: "User participation file",
  11100: "Nest AI",
  11101: "Nest AI Settings",
  11102: "Babel Assistant",
  11103: "Customize Your AI Assistant",
  11104: "BabelNest AI Assistant can use the files specified by the company for learning, becoming your company's exclusive AI assistant. For relevant information and questions about the company, you can directly have a conversation with Intelligence Nest in the form of a question, and can provide answers within the scope of permissions according to people with different permissions.",
  11105: "Historical Questions",
  11106: "New Questions",
  11107: "Rigorous",
  11108: "General",
  11109: "Creativity",
  11110: "Connect your enterprise document library to BabelNest AI",
  11111: "BabelNest AI Assistant can use the files specified by the company for learning, becoming your company's exclusive AI assistant. For relevant information and questions about the company, you can directly have a conversation with Intelligence Nest in the form of a question, and can provide answers within the scope of permissions according to people with different permissions.",
  11112: "After a successful purchase, you can choose the range of documents that need to be learned by BabelNest AI. After patiently waiting for BabelNest AI to complete its learning, you will have an exclusive AI assistant",
  11113: "AI learning requires a large amount of CPU resources, so connecting to BabelNest AI requires additional activation fees. Please choose the service package that suits you",
  11114: "There is no limit to the number of AI assistants created, and each assistant can learn up to 10000 documents. Service validity period: 10000 yuan/year effective within one year from now",
  11115: "Can create 5 AI assistants, each assistant can learn up to 5000 documents. Service validity period: effective within one year from now, 5000 yuan/year",
  11116: "Can create 2 AI assistants, each assistant can learn up to 1000 documents. Service validity period: effective within one year from now, 2000 yuan/year",
  11117: "Create Exclusive AI Assistant",
  11118: "Assistant Name",
  11119: "Please select the range of documents to learn:",
  11120: "Add AI Assistant",
  11121: "Support check",
  11122: "My AI Assistant:",
  11123: "Remove",
  11124: "Create external chain code:",
  11125: "BabelNest AI Assistant can also become the only customer service for your own products and services. As long as you create a new AI Assistant and select the learning materials required by online customer service, the AI can be used as an intelligent customer service to answer user questions. You can choose a specific AI Assistant to create a code snippet and paste it onto your website, and you will have a fully automatic exclusive AI to answer user questions",
  11126: "Select the AI assistant to publish",
  11127: "Create",
  11128: "BabelNest AI",
  11129: "Cannot send blank information",
  11130: "At present, BabelNest AI also needs to separately fine tune the data and usage scenarios of each enterprise to generate enterprise specific AI models",
  11131: "If you need to purchase \"BabelNest AI\" assistant, please contact our sales personnel (online customer service) or call 4009204020, You can also send an email to: huangfu@molasync.com",
  11133: "Got it",
  11134: "Clear History",
  11135: "Unleashing the Value of Enterprise Content",
  11136: "Use AI",
  11137: "Answer all questions about the document",
  11138: "By using AI to analyze the rich knowledge in document content, Zhichao AI can answer all questions about the content of the document. From summarizing the document to revealing key findings from lengthy research. With AI driven content insights, you can make critical task decisions faster and more confidently. This means that you don't have to personally read a document of hundreds of pages, but directly hand it over to AI to understand. You can ask AI the questions you are concerned about . Can significantly improve work efficiency.",
  11139: "Customizing AI Assistants Belonging to Your Enterprise",
  11140: "The biggest problem with existing AI systems is that they cannot accurately answer questions based on your company's exclusive content, making them unusable. The BabelNest AI Assistant Team will help companies prepare training sets, adjust parameters, and train enterprise specific AI models based on the company's information, in order to achieve usable AI assistants. For enterprise related information and questions, you can directly have a conversation with Intelligence Nest in the form of questions. It can also be provided by people with different permissions Answers within the scope of authority. You can even use Zhichao to generate code blocks attached to your website to quickly build your company's external intelligent customer service system",
  11141: "Building Our Own Customer Service Platform",
  11142: "Customer service training often takes up a lot of energy and manpower in enterprises, and renting or purchasing customer service robots is not cost-effective and not satisfactory. Using BabelNest AI makes it possible to build low-cost AI customer service platforms, allowing small and medium-sized enterprises to have intelligent customer service platforms comparable to large enterprises. BabelNest AI teams can optimize existing customer service training materials, Q&A sets, manuals, and other materials to form corpus to train AI And conduct AI reference based on your industry, ultimately building an AI customer service system suitable for your enterprise. ",
  11143: "Help you create content and answer questions",
  11144: "Content creation should be easy and interesting, rather than spending time pondering sentences. Zhichao AI has the fundamental capabilities of all big models, whether you are drafting press releases, writing personalized sales emails, or outlining action items in meetings, you can use content intelligence to accelerate work speed, freeing up time to focus on customers and innovation. As you work in Babel, intelligent content management requires All tools are already built-in, just find Zhichao AI directly.",
  11145: "Secure, Reliable, and Private Enterprise Level Artificial Intelligence",
  11146: "How to prevent artificial intelligence from talking blindly? How to prevent artificial intelligence from pretending to understand (being able to speak without knowing) ? How to keep artificial intelligence confidential? These are important indicators for evaluating the quality of an artificial intelligence system. Zhichao AI not only significantly improves accuracy, but also automatically matches Babe Bird's permission system. If a user asks questions beyond their permission range, Zhichao AI will answer 'I don't know'. Meanwhile, all documents participating in the training are specified and agreed upon by the user. ",
  11147: "Bringing unlimited possibilities to your business",
  11148: "Generating Data Analysis Reports Using Enterprise Content",
  11149: "Using enterprise corpus to train AI customer service and automatically answer customer questions",
  11150: "Automatically generate marketing emails, job descriptions, and other text",
  11151: "Easily and accurately translate reports or documents into various languages",
  11152: "AI assisted reading, quickly finding key points and knowledge points in articles, improving efficiency",
  11153: "Create an enterprise specific Q&A knowledge base based on enterprise documents",
  11154: "Possessing Intelligence Nest AI",
  11155: "Do  you want to use Babel Bird Intelligence Nest AI to improve enterprise production efficiency or provide better service to your customers? Babel Bird Enterprise Edition users can now directly use Zhichao AI. If you don't have an enterprise version account, hurry up and register one!",
  11156: "At the same time, we also provide exclusive AI training services for enterprises, allowing artificial intelligence to help them develop rapidly.",
  11157: "Please improve your application information and become the first batch of people to open the Smart Nest",
  11158: "No account ?",
  11159: "register Enterprise Edition",
  11160: "Your enterprise login account (phone) *",
  11161: "Contact name *",
  11162: "Contact phone number *",
  11163: "get code",
  11164: "Verification code *",
  11165: "Submit application",
  11166: "Please enter the enterprise version account",
  11167: "Please enter the correct phone number",
  1168: "Thank you for your support. Your application has been submitted, please wait for notification,",
  11169: "Please enter the contact name",
  11170: "Please enter the correct enterprise login account",
  11171: "*Because AI computing requires a large amount of GPU resources, only a limited number of testing modules are open every week",
  11172: "Let's talk to Zhichao",
  11173: "This is the Zhichao Babel Bird Assistant, and you can ask it about any problems encountered during the use of Babel Bird through chat",
  11174: "What is the difference between Babel Bird's projects and departments",
  11175: "I have a file that I don't want to show to department members. How do I handle it",
  11176: "I want to send a file to everyone in the company, but I don't want them to download it. How do I proceed",
  11177: "What are the similarities and differences between client editing and online editing",
  11178: "This is the Zhichao Document Assistant, you can ask it any questions about this document through chat",
  11179: "Help me create an outline of this document",
  11180: "What is the central idea of this document",
  11181: "Can you briefly describe this document",
  11182: "Sending a message",
  11183: "Message sending failed, please try again later",
  11184: "The answer to this question is quite lengthy. Let me think about it and reply to you within one minute.",
  11185: "AI Reading Assistant",
  11186: "Login to Enterprise Edition",
  /*******************9.3.6********************** */
  11300: "After setting the signature, you can use it when previewing the document",
  11301: "Signature Settings",
  11302: "Add handwritten signature",
  11303: "Upload signature image file",
  11304: "Stamp Setting",
  11305: "Upload stamp image file",
  11306: "Current stamp in use",
  11307: "Set default stamp",
  11308: "The supported image types for uploading are PNG, JPG, and JPEG, with a file size not exceeding 2MB",
  11309: "Drag the image into the area to create a new signature",
  11310: "Or",
  11311: "Select file...",
  11312: "Upload signature image file",
  11313: "Please upload images in PNG, JPG, or JPEG format",
  11314: "The file size cannot exceed 2MB",
  11315: "Drag the image into the area to create a new signature",
  11316: "White to Transparent",
  11317: "Add stamp",
  11318: "Sign",
  11319: "Save as signed PDF",
  11320: "Save to current directory",
  11321: "Download PDF file",
  11322: "Failed to obtain signature information",
  11323: "Upload failed",
  11324: "Generating PDF, please wait",
  11325: "PDF generation failed, please try again later",
  11326: "Signed document",
  11327: "{-somebody-} has generated a signed PDF file for file {-file-}",
  11328: "Signature authentication",
  11329: "Upload the signed PDF file generated on the cloud storage here, which can verify the source of the signature and whether the signature was generated by our system to determine the authenticity of the signed file. ",
  11330: "Click or drag PDF file upload",
  11331: "Please upload PDF file",
  11332: "{-user-} generated a signed PDF file '{-fileName-}' for the file '{-file-}' at {-time-}",
  11333: "Signed document generator",
  11334: "Date of signing document generation",
  11335: "Validity of signature",
  11336: "No information found for the signed document",
  11337: "Effective",
  11338: "Signatory",
  11339: "This file has already generated a signature (seal) PDF. You can download the existing signature PDF (recommended), or click the button below to generate a new signature (seal) PDF file",
  11340: "Invalid",
  11341: "Generate again",
  11342: "切换语言",
  11343: "{-somesomebody-} removed the signature from file {-file-}",
  11344: "Please select a picture file",
  11345: "There are no available departments in the directory where the project is located",
  11346: "Generating signature file...",
  11347: "All subordinate departments/folders inherit this permission",
  11348: "All subordinate departments/folders will inherit this permission setting, and the personnel/roles in this setting will clear their permission settings in subordinate departments/folders to inherit this permission setting. This operation is irreversible",
  11349: "Click on the enterprise file to directly enter your department",
  11350: "After opening, clicking on the enterprise file channel will directly take you to your department",
  11351: "Your professional version has expired. In order not to affect your normal use, please upgrade as soon as possible,",
  11251: "Upgrade account {-somebody-} to the Professional Edition.",
  11252: "Babel Bird Professional Edition Service",
  11253: "The Professional Edition service is valid until",
  11254: "Total service fees to be paid",
  11255: "The current account has been upgraded to the professional version",
  11256: "If you have any questions, please contact customer service",
  11257: "Return to homepage",
  11258: "Enterprise Tax Number",
  11259: "This field is required for company invoices",
  11260: "Select historical shipping information",
  11261: "Shipping Address",
  11262: "Order Number",
  11263: "Payment Method",
  11264: "Download Contract",
  11265: "Payment deadline",
  11266: "Transactions will be closed if overdue",
  11267: "Before completing the payment, please do not close this payment verification window. After the payment is completed, please click the button below according to your situation",
  11268: "Payment in progress",
  11269: "Payment successful",
  11270: "Payment failed",
  11271: "Re-Pay",
  //////////////**************9.1.5*************//////////////// */
  12100: "Advanced Settings",
  12101: "File upload whitelist",
  12102: "File upload blacklist",
  12103: "Only file types that have been added to the whitelist can be uploaded",
  12104: "The priority of the whitelist is higher than that of the blacklist, and the file types in the whitelist do not take effect on the blacklist",
  12105: "Click to enter the file extension to add to the whitelist. For example: jpg;PNG(case insensitive)",
  12106: "Multiple extensions can be separated by \";\", such as jpg; PNG; Doc",
  12107: "File types added to the blacklist are prohibited from uploading",
  12108: "Click to enter the file extension to add to the blacklist. For example: jpg;PNG(case insensitive)",
  12109: "Bidirectional binding",
  12110: "After enabling bidirectional binding, only the bound account can log in to the device bound to the MAC address.(Unrestricted on the web side)",
  12111: "Can edit office files online",
  12112: "Turn off the modification option. The department office files will not be available for online editing.",
  12113: "Prohibit external sharing of departmental documents",
  12114: "When this option is turned on, all department members are unable to share files with external users of the enterprise and cannot share files through links",
  12115: "Will this setting be applied to all sub departments of the current department?",
  12116: "Sharing of departmental documents is prohibited",
  12117: "Online editing of departmental documents is prohibited",
  12118: "Department options",
  12119: "The priority of the blacklist set by the department or project is higher than that of this blacklist",
  12120: "Direct members are classified by role and can be edited and managed.",
  12121: "No permission to view link sharing",
  12122: "Unknown role",
  12123: "Started a new approval stage for file {-file-}",
  12130: "Message has expired",
  ////////////////////9.1.6//////////////////

  12200: "Failed to obtain file password",
  12201: "Display enterprise abbreviation in the system title bar",
  12202: "Special characters are not allowed to be entered",
  12203: "Role names do not allow special characters to be entered",
  12204: "Special characters are not allowed in policy names",
  12205: "Special characters are not allowed for group names",
  12206: "Sending file approval not approved",
  12207: "Approval for sending documents has been granted",
  12220: "The number of attempts is too frequent. Please try again in 10 minutes.",
  12221: "Password error",
  12222: "Member List",
  12223: "When this option is turned off, the top title bar will only display the company logo",
  ////////////////////9.1.7//////////////////

  12300: "Click",
  12301: "Set snapshot",
  12302: "Click to select the person in charge. If the person in charge is not changed, this option can be left blank",
  12303: "Files without download permission do not display thumbnails",
  12304: "Turn on this option, if the user does not have download permission for the file, the thumbnail of the file will not be displayed. Prevent users from intercepting thumbnails and leaking files",
  12305: "Cannot reuse old password",
  12306: "You do not have upload permission for this file",
  12307: "The number of files exceeds {-max-}, please use the client synchronization function!",
  ////////////////////9.1.7//////////////////

  12400: "Flowchart drawio",
  12401: "Search results",
  12402: "File Content",
  12403: "Strictly check permissions when searching",
  12404: "Strictly checking permissions may reduce search efficiency, and non strictly checking permissions may result in inaccessible files in special circumstances, but even if they are found, access will be denied.",
  12405: "Filtered no access",
  /////////////////////9.2.0///////////////////////
  12500: "Material Library",
  12501: "Can only be used after administrator initialization",
  12502: "The material library function has not been enabled yet. Do you want to enable it now?",
  12503: "Material library enabled successfully",
  12504: "Allow access to material library",
  12505: "After closing, there will be no material library entrance on the user interface, and the user will not be able to access the material library.",
  12506: "Batch management of column access permissions",
  12507: "Create Category",
  12508: "Enter the category name to create a category. Files cannot be uploaded under the category, but you can create a material library or create a new category under the category.",
  12509: "Enter the name of the category",
  12510: "Classification visibility",
  12511: "Category Manager",
  12512: "New Material Library",
  12513: "You do not have permission to create categories, but you can apply to the category manager to create categories. After the application is approved, the categories will be automatically created.",
  12514: "Apply to create category",
  12515: "Classification Management",
  12516: "Enter the name of the material library",
  12517: "Material Library Assistant",
  12518: "Add Material Library Assistant",
  12519: "Material Library Visibility",
  12520: "Downloading this material library file requires approval",
  12521: "Restricted department disclosure",
  12522: "Restricted departments require approval",
  12523: "Access requires application",
  12524: "Internal (Confidential)",
  12525: "Anyone who can access the superior category can access it",
  12526: "Members accessing the sub library need to apply to the sub library manager for approval before they can access it.",
  12527: "Only material managers and library members can access",
  12528: "This material library does not display thumbnails",
  12529: "Material library visitors without download permission do not display thumbnails",
  12530: "All visitors except for administrators need approval to download",
  12531: "Visibility validity period internal (confidential)",
  12532: "Convert to' after expiration",
  12533: "Approval is required after the expiration date to change visibility",
  12534: "Material Library Assistant",
  12535: "Members of the material library are not affected by the visibility of the material library and its categories, and can access the material library according to their permissions(Restricted by download approval settings in Internal material library).",
  12536: "The material library assistant can add and remove material library members, and assign permissions to material library members.'. But the material library assistant cannot move or delete the material library",
  12537: "Material Library Member",
  12538: "Please select administrator",
  12539: "Management Classification",
  12540: "Manage Material Library",
  12541: "Classification",
  12542: "Apply to create a sub material library",
  12543: "Apply for Access",
  12544: "Application",
  12545: 'Application for Access Classification "{-file-}"',
  12546: 'Apply to access the material library "{-file-}"',
  12547: "Access Request",
  12548: "Apply to download the following files from {-file-}",
  12549: "Apply to download the following file",
  12550: "Download applicant",
  12551: "Manage applicants",
  12552: "You have set the current library to no longer require a download request, and there is historical data in the library that requires a download request. Do you want to clear this data",
  12553: "Clear",
  12554: "Maintain",
  12555: "You do not have permission to create a sub material library, but you can apply to the administrator to create a material library. After the application is approved, the material library will be automatically created",
  12556: "You have already applied to create a material library under this directory. Only one material library can be created per directory at a time",
  12557: "Select material library members",
  12558: "Please select a limited department",
  12559: "View the list of authorized applicants",
  12560: "Authorized access personnel",
  12561: "Authorized to download files",
  12562: "View authorized downloaders",
  12563: "Authorized Information",
  12564: "After deletion, the user will not be able to access the current material library",
  12565: "After deletion, the user will not be able to download the current file",
  12566: "Invalid Login Credentials",
  12567: "Your previous application has not been approved yet. You can only submit a new application after your previous one has been approved.",
  12568: "You cannot directly upload files under the category. You can create a new sub material library under the category and upload files in the material library",
  12569: "The current category is empty",
  12570: "The current material library is empty",
  12571: "Batch setting",
  12572: "Batch setting",
  12573: "Batch settings'{-name1-}''{-name2-}' Waiting for {-len-} categories",
  12574: "Batch set 2 categories for'{-name1-}'and'{-name2-}'.",
  12575: "After saving, the settings information of the selected category will be overwritten",
  12576: "Batch settings' {-name1-}' '{- name2-}' Waiting for {-len-} material libraries",
  12577: "Batch set up two material libraries,'{-name1-} 'and'{-name2-}'.",
  12578: "If this is empty, no responsible person will be set in bulk, and the original responsible person will be retained",
  12579: "After saving, the settings information of the selected material library will be overwritten",
  12580: "If this field is empty, no batch administrator settings will be made and the original administrators will be retained",
  12581: "After deletion, this user will not be able to access the current category",
  12582: "Enter file name to filter corresponding files",
  12583: "Do not hide the confidential material library (non confidential material library members can also see the material library)",
  12584: "Apply to join",
  12585: "Apply to join",
  12586: "You are applying to become a member of the {-name-} material library",
  12587: "Enter user name to filter ",
  12588: "New client for Windows",
  /*******************ocr******************* */
  12600: 'Image Text (OCR)',
  12601: 'Supports up to one file upload, with a maximum of 20M per file.',
  12602: 'Supports uploading {-exts-} formats',
  12603: 'Only supports uploading {-exts-} files under 20MB',
  12604: 'Only supports uploading a single file',
  12605: 'OCR again',
  12606: 'Recognition result',
  12607: 'Export as document',
  12608: ' OCR recognition result ',
  12609: 'OCR Recognition of Image Text',
  12610: 'Under recognition...',
  12611: 'You can click and paste the image here',
  12612: 'retry',
  12613: 'Save as Document',
  12614: 'We have been using the Babel Bird Enterprise Cloud for almost three years, and important documents and design drafts are all on Babel Bird. We have also collaborated with the Babel Bird team to develop a material library function to unify the management of materials and designs for our various IPs.',
  12615: '--Bubble Mart IT Manager: Liu Junli',
  /////////////////************ai tag***************//////////////////// */

  12650: 'AI tagging',
  12651: "12651: 'AI automatic tagging can automatically match the tags closest to the current file based on the preset tags in the tag library. You can also select multiple files and use AI automatic tagging in bulk. ',",
  12652: 'After successful marking, each file will be deducted 1 smart point computing power value',
  12653: 'There are no tags in your tag library yet',
  12654: 'AI automatic tagging can automatically match the closest tags to the current file based on the preset tags in your or your enterprise tag library. You can first add a batch of labels, and then use the automatic labeling function to label the file. ',
  12655: 'Go add tags',
  12656: 'Do not display this reminder again next time',
  12657: 'This type of file currently does not support AI automatic tagging',
  12658: "Do you hope for future support?'? Click 'Close and Submit Wish",
  12659: 'The current account does not have enough remaining smart points. Please purchase and continue to use.',
  12660: 'Supports selecting up to {-num-} files',
  12661: 'Batch labeling in progress, please come back later to check',
  12662: "切换语言",
  12663: "The file is locked and the operation cannot be completed. It's possible that someone is currently using the client to edit this file. You'll need to wait until they finish editing before attempting this operation again.",
  /***************************9.3.0*********************************/
  13000: 'Smart Nest AI',
  13001: 'Your remaining SmartPoint quantity',
  13002: 'Number of SmartPoints used',
  13003: 'Purchase SmartPoint',
  13004: 'Conducting an AI search will consume approximately 1000 SmartPoints, while a regular full-text search will not consume SmartPoints.',
  13005: 'Conducting an AI image search will consume approximately 10000 SmartPoints',
  13006: ' The AI assistant will consume 3k-1W SmartPoints for each question depending on the answer',
  13007: 'View usage details',
  13008: 'Enjoy the changes brought by AI from today on',
  13009: 'Bill',
  13010: 'Purchase Account',
  13011: 'Valid until',
  13012: "Do you need an invoice? Click on 'Enter'",
  13013: 'Invoice Information',
  13014: 'Purchased Products',
  13015: 'Purchase of Babel Bird AI SmartPoint Package',
  13016: 'Valid until',
  13017: 'One year',
  13018: 'Total price',
  13019: 'Pay Now',
  13020: 'Quantity of purchased SmartPoints',
  13021: 'Validity period',
  13022: "Please fill in the correct email address. After the invoice is issued, it will be sent to that email address",
  13023: 'Invoice required',
  13024: 'Operation time',
  13025: '+ / -',
  13026: 'Remaining',
  13027: ' SmartPoint usage details',
  13028: 'User',
  13029: 'Allow the use of AI',
  13030: 'After closing, the AI function entrance on this user interface will not be displayed and only AI customer service can be used.',
  13031: "Go pay",
  13032: "BabelNest AI Apps:",
  13033: "Search Image",
  13034: "AI search",
  13035: "Agent:",
  13036: "Babel Bird Online Customer Service",
  13037: 'BabelNest',
  13038: 'Your exclusive corporate assistant, answer any questions related to your company',
  13039: 'AI Search',
  13040: 'AI Search Images',
  13041: 'Enter your question, such as: How do I proceed with the reimbursement process',
  13042: 'Create Agent',
  13043: 'Create an intelligent customer service representative',
  13044: 'Intelligent agents that can provide customer service to external parties',
  13045: 'Create a knowledge base robot',
  13046: 'A robot that answers specific questions',
  13047: 'Ask all questions about the Babel',
  13048: 'In internal testing Coming soon, stay tuned!',
  13049: 'Drag the image here or click',
  13050: 'Sorry, the file you uploaded is not in image format. Please ',
  13051: ' Re-upload',
  13052: 'Only supports {-exts-} format files under 10MB',
  13053: 'Uploading image...',
  13054: 'Local Upload',
  13055: 'Click here to find pictures through description',
  13056: 'Click here to find similar images through image matching',
  13057: 'Enter a description of the image or paste the image , supporting mixed text and image search',
  13058: 'Image search',
  13059: 'Upload completed',
  13060: 'There are currently no image files that meet the criteria',
  13061: 'See more',
  13062: 'Sorry, the file size you uploaded is too large, please ',
  13063: 'Intelligent Knowledge Base',
  13064: 'Try again',
  13065: ' SmartPoint billing rules',
  13066: 'Billing Items (per occurrence)',
  13067: 'Deduct SmartPoint Count',
  13068: 'View SmartPoint Deduction Rules',
  13069: 'Ten thousand',
  13070: 'Thousand',
  13071: 'Reference source',
  13072: 'Copy successful',
  13073: 'Open',
  13074: 'The required SmartPoints for AI search are insufficient. Please purchase and continue using them',
  13075: 'Please wait...',
  13076: 'Enable AI search',
  13077: 'Enter a description of the image to search for',
  //*************hotfix****************/

  //****************************excel ai********************* */
  13078: "Excel Data Assistant",
  13079: "File Preview",
  13080: "Analysis Results",
  13081: "Click or drag file upload",
  13082: "Select my cloud drive files",
  13083: "Requirements for uploading files",
  13084: "Supports uploading up to three files, with a maximum size of 10M per file <br> Supports uploading CSV, XLS, and XLSX formats",
  13085: "Currently only supports processing the first five valid sheets of the table",
  13086: "Attempt to input an analysis request for the document",
  13087: "Please select a file",
  13088: "Save as Image",
  13089: "Image saving",
  13090: "Saved successfully",
  13091: "Save failed, please try again later",
  13092: "New conversation",
  13093: "Hello! Welcome to Excel Data Assistant. After uploading the document, you can try asking: ",
  13094: "Help me calculate the average value of XXX",
  13095: "Compare and analyze XXX table and XXX table",
  13096: "Analyze the traffic trend of XXX",
  13097: "Sort out the grades of students with scores higher than XXX",
  13098: "Extract XXX data to generate a bar chart",
  13099: "Analyze sales data for July and August",
  13100: "Data growth and temporal correlation in various regions from 2014 to 2024",
  13101: "Calculate the cash income of XXX as XXX",
  13102: "BabelNest AI",
  13103: "let your",
  13104: "work",
  13105: "BabelNest Power by:&nbsp;",
  13106: "AI Search",
  13107: "Learn from cloud disk files and support permission-based search, queries, retrieval, Q&A, and article writing.",
  13108: "LLM Agent",
  13109: "A custom AI agent that learns, updates, and handles tasks like customer service and file processing.",
  13110: "Dedicated AI Assistant",
  13111: "Your enterprise's AI assistant serves based on user permissions. Answers questions, and writes articles.",
  13112: "Image Search ",
  13113: "Search for related images via descriptions or example images. ",
  13114: "Knowledge Base",
  13115: " Learns from files for knowledge Q&A. Supports custom knowledge sources and multiple knowledge base creation.",
  13116: "Data Analysis Assistant",
  13117: "Analyzes structured data and offers analysis, charting, querying, and classification.",
  13118: 'Please upload files with suffixes xls, xlsx, and csv',
  13119: 'Please select an Excel file first',
  13120: 'You do not have permission to upload files in your personal directory',
  13200: "My AI Tool (Agent)",
  13201: "My AI Tool",
  13202: "Created by Me",
  13203: "Published",
  13204: "Unpublished",
  13205: "Search for Items",
  13206: "Select Agent Type",
  13207: "Knowledge Base Bot",
  13208: "Answer questions within a specific scope with simple configuration",
  13209: "A knowledge base bot that can serve as an instruction manual",
  13210: "Long Text Generation",
  13211: "An AI assistant for writing articles and text generation tasks",
  13212: "Smart Customer Service",
  13213: "A bot that can be embedded in your webpage to answer product questions for your customers",
  13214: "Workflow",
  13215: "Automate the processing of files in a folder according to certain requirements",
  13216: "Created by {-name-}",
  13217: "Agent Name & Icon",
  13218: "Give your agent a name",
  13219: "Description",
  13220: "(Optional)",
  13221: "Enter application description",
  13222: "Change Icon",
  13223: "Upload Icon",
  13224: "Icon Preview",
  13225: "Agent name cannot contain special characters",
  13226: "Please enter an agent name",
  13227: "Unpublished",
  13228: "Published Successfully",
  13229: "Agent Settings",
  13230: "Publish Agent",
  13231: "Knowledge Base",
  13232: "Persona & Response Logic",
  13233: "Please enter persona and response logic",
  13234: "Knowledge Source",
  13235: "Are you sure you want to delete the folder 《{-name-}》 from the knowledge source?",
  13236: "Opening Remarks",
  13237: "Please enter your opening remarks",
  13238: "Background Image",
  13239: "Debug & Preview",
  13240: "Monitoring",
  13241: "Edit Agent",
  13242: "Updated Successfully",
  13243: "Update Failed",
  13244: "Add a conversation background image to your agent for a more immersive experience during conversations",
  13245: "Add knowledge sources to your intelligent agent, which are the information sources used by the knowledge base to read files. Multiple knowledge sources can be added. After adding a knowledge source, it takes up to 30 minutes for it to be stored.",
  13246: "Visibility",
  13247: "Public to Everyone",
  13248: "Visible to Those with the Link",
  13249: "Private",
  13250: "Publish Update",
  13251: "Run",
  13252: "Embed in Website (Public to Everyone)",
  13253: "Published Successfully",
  13254: "Unpublished",
  13255: "No knowledge source found in the knowledge base, please add a knowledge source",
  13256: "You have followed this agent",
  13257: "You have unfollowed this agent",
  13258: "Clear",
  13259: "Copy Link",
  13260: "Failed to obtain the link. Please try again later.",
  13261: "Delete Agent",
  13262: "Recently Used",
  13263: "You have successfully removed this agent",
  13264: "Agent Data Error",
  13265: "Copy Link",
  13266: "The link has been copied. Share it with your friends!",
  13267: "No knowledge source found in the knowledge base, please add a knowledge source",
  15000: "Are you sure you want to recover all files?",
  // ****************************** 7.9.5
  20000: "Your account has logged in elsewhere",
  20001: "Multiple login of account",
  20002: "You have no right to manage sharing, please contact the sharing initiator.If you want to get the link address, you can right-click the file to get the link address	",
  20003: "Enterprises are forbidden to upload this type of file!",
  // ****************************** 8.0
  20010: "Personal version does not support online preview of this type of file, please upgrade",
  20011: "You can spread this link through email or QQ and other third-party communication means, and the people who get this link can access the file through this link.",
  20012: "Office online editing needs to purchase online editing license. You can try it for 30 days for free. If you need to continue to use it after expiration, please contact our sales staff to purchase the license",
  20013: "The file does not exist in the place",
  // ***************************** transmittal
  20020: "Dear {-name-}:",
  20021: "{-somebody-} sends files in the {-file-} project, and the sending number is {-transmittal-}",
  20022: "The transmittal does not exist",
  20023: "No file in the folder",
  20024: "Welcome to use the document control management system, as long as you visit this link, you can use your email and Guard code to view the documents sent to you. It is strongly recommended to save this link for convenient query at any time",
  20025: "TRANSMITTAL NO. cannot be NULL",
  20026: "File list connot be empty",
  20027: "Documents received",
  20028: "Receiving history",
  20029: "REV.",
  // 对应大写版本号
  20030: "Receiver name, email are required",
  20031: "The recipient did not set up a mailbox",
  20032: "Are you sure you want to delete the {-num-} transmittal(s) ?",
  20033: "Click to select email",
  20034: "Get captcha",
  20035: "The following file names already exist. This operation automatically renamed them:",
  20036: "{-oldName-} --> {-newName-}",
  20037: "Old name",
  20038: "New name",
  20040: "<p>Your client version is too low to normally use cloud bridge, synchronization and other functions, please go to the official website to download the latest version of the client.</p><p>Download Address\uFF1A<a style=\"margin-left: 0;\" href=\"https://www.babel.cc/p/download.do\" target=\"_blank\" >https://www.babel.cc/p/download.do</a></p>",
  20041: "Failed to create the folder path '{-folder-}' Please try again later",
  20042: "Session is invalid!",
  // ***************************** release 8.2
  20050: "",
  20051: "There is not enough free space. Maybe the target folder you uploaded is limited. Please contact the administrator.",
  20052: ", {-fileNum-} files",
  20053: "You do not have permission to create a folder",
  20054: "Tips for use",
  20055: "It is detected that you are using the enterprise wechat to open the network disk. In order to get a better use experience, it is recommended to use the browser to access",
  20056: 'Click the "browser open" icon in the upper right corner of the enterprise wechat window to access it through the browser',
  20057: "It has expired, cannot upload file",
  20058: "File exception, please retry later or upload this file again",
  // *****************************  release 8.3
  20100: 'The file "{-fileName-}" already exists in the destination folder!',
  20101: "Click reset password to set a password in the background  ",
  20102: "This user already exists but is in dormant state. Click OK to activate it and join the enterprise",
  // *****************************  release8.4
  20147: "Please open the corresponding department and upload the file",
  20148: "Uploading files is not supported in the current file directory",
  20149: "View more messages",
  20150: "Department In ",
  20151: "Department",
  20152: "Project",
  20153: "Folder",
  20154: "Share link {-file-} was out of date, closed!",
  20155: "Share link was out of date, closed!",
  20156: "Project administrators cannot be assistants at the same time!",
  20157: "Click to get",
  20158: "Last visited folder",
  20159: "Operating",
  20160: "Detecting for duplicate files",
  20161: "Last selected",
  20162: "The same folder already exists on the server. Please rename it!",
  20163: "The data is incomplete, please report this problem",
  20170: "Deletion",
  20171: "Video files cannot be accessed anonymously. Please log in to view them",
  20172: "Push message receiving Settings",
  20173: "The project recently uploaded files",
  20174: "Report being generated, please wait",
  21000: "Ignore and continue uploading",
  21001: "If the number of files to be uploaded exceeds 500, the system may respond slowly and the upload may fail. You are advised to use the client synchronization function to upload files in batches.",
  21002: '* After installing the client, right-click on the folder you want to upload and choose "Babel Bird - Sync folder"',
  21003: "Please fill in the email address or mobile phone number you used to log in to get the verification code to reset the new password. If you are using an employee id, contact your administrator to reset the password.",
  21100: "To display the most recently uploaded files in the specified folder",
  // *********************************  release8.5.1
  21200: "Sending file {-file-} requires your review",
  21201: "The file {-file-} you sent was approved and has been sent successfully",
  21202: "The file {-file-} you sent was not approved, sending failed",
  21203: "The sharing of file {-file-} involves the confidentiality department and needs your approval",
  21204: "Classified operation",
  21205: "The initiator {-user-} has withdrawn the request and this message has expired",
  21206: "The project {-file-} involves the confidentiality department and needs your approval",
  21207: "The link you visited does not exist, or the file has been cancelled to share, or you do not have permission to view the file!	",
  21208: "Joining the sharing requires the approval of the enterprise's confidential member or administrator. The request has been sent to relevant personnel, please wait for approval!	",
  21209: "Your request to join the share {-file-} has been approved",
  21210: "Your request to join the share {-file-} was rejected	",
  21211: "As the personnel of the confidentiality department are involved, further approval by the enterprise management personnel is required. Please wait for the approval result",
  21212: "Member initiated sharing ",
  21213: "Members join shares and projects ",
  21214: "Member sends file ",
  21215: "Approver ",
  21216: "Multi-department member sends files ",
  21217: "Approval required ",
  21218: "Security Keeper or Super Administrator ",
  21219: "The approver is a security keeper or super administrator ",
  21220: "No approval required ",
  21221: "Supervisor ",
  21222: "Sharing with other department personnel requires approval ",
  21223: "When sharing or projects invite confidential department personnel to join, security keeper or super administrator approval is required. ",
  21224: "Anonymous uploads are not allowed for link sharing for enterprises with confidential departments; Creating an open inbox is not allowed. ",
  21225: 'Only the "public" policy supports link sharing, other policies only support invitation sharing; ',
  21226: "Top Secret Document: the default is not visible to anyone outside the door except the creator, project leader, document leader and department manager. Sharing this document must be authorized by the security guard. ",
  21227: "Restricted file: Read only for general personnel and must be authorized by superior to share this file; ",
  21228: "Internal document: The sharing of this document with persons outside the department must be authorized by the superior; ",
  21229: "Top secret files, restricted files, general personnel are not allowed to move/copy/upload new version/download/rename/view version, only superior supervisors and personnel with department file management permission. ",
  21230: "The operation failed because the file has been reported!",
  21231: "The user is not allowed to upload files at the current IP address",
  // ***************************************  release8.5.3
  21300: "{-somebody-} created snapshot share for {-file-}",
  21301: "snapshot",
  21302: "You can not check the snapshot for the file",
  21303: "Application approval",
  21304: "You have reached a conclusion on the permission applied for file {-file-}. Conclusion: {-result-}",
  21305: "The latest version of the file is still being edited, and the old version is currently displayed",
  21306: "The latest version of the file is still being edited, and the current download is still the old version",
  21307: "Download old version",
  // **************************************  release8.5.4
  21400: "Uploaded today:",
  21401: "Downloaded today:",
  21402: "The operation failed. The top secret department or its personnel cannot be included",
  21403: "The current number of enterprises has exceeded the authorized number. Please deal with it as soon as possible to avoid affecting the login and use of ordinary personnel",
  21404: "Unlocking failed. The file has been locked by others !",
  21405: "Operation failed, file being locked by others！",
  21406: "Search for archive, press Enter to confirm",
  ///////////////////////////////////////////////////////9.0.2/////////////////////////////////////

  21500: "Duplicate policy name, saving failed",
  21501: "Share with external members",
  21502: "Share with non project members",
  21503: "{- somebody -} created a new project {- folder -} in {- parentFolder -}",
  21504: "{- somebody -} created a new document control project {- folder -} in {- parentFolder -}",
  21505: "Project from {user}",
  21506: "You can view this file in  My Project ",
  21507: "You can view this file in my msbox",
  21508: "A folder with the name {-name-} already exists in the current folder. The folder upload failed. Please modify the file name and upload again",
  21509: "Next folders with the same name ignore this prompt (folders with the same name are not uploaded by default)",
  21510: "Found folder with the same name",
  21511: "Departments",
  21512: "The number of files exceeds {-limit-}, snapshot sharing is not supported, please use the regular sharing function",
  21513: "Statistical Usage",
  21514: "Calculating, please wait",
  21515: "Enterprise occupies space  ",
  21516: "After deleting the department template folder, it will not enter the recycle bin and will be deleted directly. Are you sure you want to delete it",
  21517: "BabelBird White Paper.pdf",
  21518: "The department I joined",
  21519: "At present, the public cloud version does not support online playback of this format of video. You can download and play it, or contact customer service to choose private deployment",
  //********************CAD **********************************************/
  21520: "Folder only",
  21521: "Trash",
  21522: "Enterprise deleted file management",
  21523: "Department ",
  21524: "Delete auditing department",
  21525: "Theme Colors",
  21526: "Consistent with the system",
  21527: "Dark",
  21528: "Light",
  //21529: "Your corporate identity has changed, new corporate identity: {-name-}",

  21529: "Your corporate identity has changed!",
  21530: "Local Editing",
  21531: "Local read-only open",
  21532: "Members",
  21550: "Preparing to preview data",
  21551: "The server is transcoding, please try again later",
  21552: "Drawing download failed",
  21553: "Loading",
  // ************************************* release 8.7.1
  21601: "View login history",
  21602: "View participating shares	",
  21603: "IP",
  21604: "Device type",
  21605: "Device name",
  21606: "This account is currently logged in from another location, ip:{-ip-}. If it is not your own operation, please change the password as soon as possible and kick it out in the personal Settings -> Device Manager interface ",
  21607: "None data",
  21608: "This person has never logged into this system",
  21609: "Special permission files",
  21610: "There are currently no access control files in which the user participate",
  21611: "Share joined",
  21612: "Projects joined",
  21613: "Participated in sharing file list",
  21614: "Sharing without participation at the moment",
  21615: "There are currently no participating projects",
  21616: "List of participating project files",
  21617: "When somebody exceeding the quantity limit, the enterprise manager will receive an email or SMS reminder",
  //////////////////////////**************9.0.5******************///////////////// */
  21650: "All tags",
  21700: "The client version is too low. Please download the latest client to complete the download",
  // ************************************************* release 9.0.5
  21800: "Enterprise tag",
  21801: "Personal tag",
  21802: "The system only supports up to {-maxTerminals-} devices online simultaneously",
  /////////////////////////////************Release9.0.6************///////////////////////////////

  21900: "Union",
  21901: "Intersection",
  21902: "symmetric difference",
  21903: "Untagged",
  21904: "Minute",
  21905: "Hour",
  21906: "Heaven",
  21907: "Week",
  21908: "Month",
  21909: "Recently",
  21910: "Exceeding",
  21911: "Before",
  21912: "Until now",
  21913: "Recently {-time-} {-unit-}",
  21914: "Before {-time-} {-unit-} ",
  21915: "From {-start-} to {-end-} ",
  21916: "Between",
  21917: "And",
  21918: "",
  21919: "Files I deleted",
  21920: "Files deleted by others",
  21921: "Access is only allowed for personnel within the enterprise",
  21922: "Setting Approval for Sharing",
  21923: "File operations that require approval",
  21924: "Share files",
  21925: "Sending Files",
  21926: "Approval personnel",
  21927: "Add Approval Personnel",
  21928: "Clearing configuration items",
  21929: "{-user-} set to {-time-}",
  21930: "Apply for permission to grant file {-file-} {-roleName-}",
  21931: "Sending files requires your approval",
  21932: "Administrators can add approval processes in the\" Enterprise Console - File Configuration \"section.",
  21933: "No location",
  21934: "For any files in the current folder, if there is a need for confidentiality, it can be set here to notify relevant personnel for review when the files are shared or sent.",
  21935: "After passing this stage, file location:",
  21936: "Current location (not moving files)",
  21937: "Move to selected folder",
  21938: "The end of this stage file has been moved to:",
  21939: "File whitelist",
  21940: "File whitelist, also known as file type whitelist, will only allow file types on the whitelist to be uploaded. Enter the file extension you want to upload to the list below.",
  21941: "Please enter the file extension to be added to the whitelist, such as jpg",
  21942: "Whitelist",
  21943: "The whitelist has a higher priority than the blacklist. If there are file types in the whitelist, the blacklist will not take effect. The whitelist set by the department or project has a higher priority than the whitelist here.",
  21944: "Please select a security policy",
  21945: "The file sent this time needs to be reviewed, and once approved, it will be automatically sent.",
  21946: "The CAD online preview module is not installed. If you need to preview DWG files, please contact your enterprise administrator.",
  21947: "Current location (not moving files)",
  21948: "The target folder has been deleted",
  ///////////////////////////////////////9.1.2****************************/

  21950: "Batch renaming",
  21951: "Number of files",
  21952: "Renaming method",
  21953: "Custom",
  21954: "Replace",
  21955: "Insert",
  21956: "Delete",
  21957: "Renaming by Time",
  21958: "New file name",
  21959: "Case conversion",
  21960: "unchanged",
  21961: "All uppercase",
  21962: "All lowercase",
  21963: "Initial capitalized",
  21964: "Initial lowercase",
  21965: "Please enter a new file name",
  21966: "Number Setting",
  21967: "Start",
  21968: "First digit number",
  21969: "Increment",
  21970: "Increased number",
  21971: "Number of digits",
  21972: "How many digits in total are there in the number?",
  21973: "Start batch renaming",
  21974: "Original file name",
  21975: "New file name",
  21976: "Status",
  21977: "Source of Name",
  21978: "File creation time",
  21979: "File modification time",
  21980: "Current time",
  21981: "Time Style",
  21982: "yyyy-MM-dd hh:mm ",
  21983: "Time insertion position",
  21984: "File header",
  21985: "End of file name",
  21986: "Remove file name",
  21987: "Remove file name and add number",
  21988: "yyyy-MM-dd hh:mm",
  21989: "Insertion position",
  21990: "Insertion type",
  21991: "Custom Content",
  21992: "Number",
  21993: "Insert content",
  21994: "Find content",
  21995: "Replace content",
  21996: "By file name and location",
  21997: "Space in file name",
  21998: "Numbers in file names",
  21999: "Quotes in file names",
  22000: "Delete type",
  22001: "Start position",
  22002: "Length",
  22003: "Delete content",
  22004: "File Properties",
  22005: "File Creator",
  22006: "Document Manager",
  22007: "Last version modified by",
  22008: "Insert File Properties",
  22009: "To be operated",
  22010: "File renaming started, please wait",
  22011: "File renaming completed",
  22012: "File name too long",
  22013: "You can right-click to use local preview CAD <br> If you need online preview, you need to purchase an online preview CAD module.",
  22014: "View logged in devices",
  22015: "The current directory file has changed. Do you want to refresh the interface?",
  22016: ',You can use the" Local Editing "function by right clicking to open the preview.',
  22017: "Download failed",
  22018: "The file is currently undergoing online editing",
  22019: "Old version Win client",
  22020: "Client Linux version",
  22021: "Ubuntu, Tongxin UOS, Kirin",
  22022: "Contact customer",
  //************9.1.3*/
  22050: "View shared files",
  22051: "Load failed",
  22052: "No shared files yet",
  22053: "All shared files in the folder",
  22054: "There are no shared files (folders) open in the current folder",
  22055: "Closing sharing...",
  22056: "Add folder",
  //************9.1.7 */
  23000: "Force update",
  //************9.2.0 */
  24000: "Material Library Message",
  24001: "Apply to create category {-file-} in the material library",
  24002: "Apply to create a sub material library {-file-} in the material library",
  24003: "{-name-} applies to create the following categories in {-type-} {-file-}",
  24004: "{-result-} created your application for classification {-file-}",
  24005: "{-result-} Your request to create a sub material library {-file-}",
  24006: "{-name-} applies to create the following material library in {-type-} {-file-}",
  24007: "{-name-} applies to access {-type-} {-file-}",
  24010: "The time set for the original visibility ({-accessType-}) of the material library '{-name-}' has expired, and the visibility will be automatically set to ({-nextAccessType-}) according to the preset. Your approval is required",
  24011: "The original visibility setting time for the material library '{-name-}' has expired, and the visibility has been automatically set to ({-accessType-}) according to the preset",
  24012: "Apply to download files (folders) such as' {-name-} 'from the material library",
  24013: "You have applied to download files (folders) such as' {-name-} 'from the material library, and they have been approved by the administrator {-result-}",
  24014: "{-result-} Your application to access category '{-file-}'",
  24015: "{-result-} has applied for your access to the sub material library '{-file-}'",
  24016: "The online editing has been completed and submitted.<br/> Would you like to refresh and view the latest version？",
  24017: "Created category {-file-} in the material library",
  24018: "Created sub material library {-file-} in the material library",
  24019: "Modified department《{-file-}》",
  24020: "Material category",
  24021: "Sub material library",
  24022: "Online preview of this type of file is not supported",
  24023: "Apply to join 《{-name-}》",
  24024: "{-result-} your request to join《{-file-}》",
  24025: "Apply to join the material library",
  24026: "Name",
  // ************9.3.0 */
  'AI_SEARCH': "AI Search",
  'WORD_S_IMAGE': "Search Image By words",
  'IMAGE_S_IMAGE': "Search Image By Image",
  'AI_TALK': "AI Dialogue",
  'IMAGE_OCR': "Image OCR",
  'DOC_ASSISTANT': "Document Assistant",
  'SPREAD_SHEETS': "Sheets Dialogue",
  'DEEP_SEARCH': "Deep think(Deepseek-R1)",
  'ONLINE_SERCH': "Online search",
  'DEEP_RESEARCH': "Deep research",
  24100: "Back to Current ver",
  24101: 'You can describe the image you want to search for here, for example, "The background is blue sky and white clouds”',
  24102: 'Does your company need AI to learn and process old data immediately?',
  24103: "Do you need AI to learn and process your personal old data immediately?",
  24104: "Personal file processing in progress...",
  24105: "Enterprise document processing...",
  24106: "Personal file processing completed<br>",
  24107: "Enterprise file processing completed",
  24108: "Personal files awaiting processing:{-count-}<br>",
  24109: "Enterprise files awaiting processing:{-count-}",
  24110: "AI Processing historical data",
  24111: "Processing completed",
  24112: 'Enterprise remaining SmartPoint',
  24113: 'Copy as markdown',
  //************9.3.0 new*/
  25000: "Add authorized personnel",
  25001: "View only signin",
  26000: "Help me write an article on official account",
  26001: "What can Smart Nest do",
  26002: "Summary of the 'White Paper",
  26003: "What are the onboarding processes",
  26004: "Search for all pictures of the ocean",
  26005: "What are the main products of our company",
  26006: "Hello! You can ask me",
  26007: "Try entering a question to start a conversation",
  26008: "Deep thinking",
  26009: "Internet Search",
  26010: "Thinking",
  26011: "Deep thinking, in seconds ({-num-})",
  26012: "New conversation",
  26013: "Deep thinking",
  26014: "End of answer, take {-num-} seconds",
  26015: "End of answer",
  26016: "Response timed out, please try again later",
  26017: "Briefly describe this picture",
  26018: "Please display the text that appears in the image",
  26019: "{-num-} sources have been searched",
  26020: "Quick Search",
  26021: "Adapt to each query",
  26022: "In depth research",
  26023: "In depth report on complex topics",
  26024: "Search for historical conversations",
  26025: "Today",
  26026: "This week",
  26027: "This month",
  26028: "This year",
  26029: "Monday",
  26030: "Tuesday",
  26031: "Wednesday",
  26032: "Thursday",
  26033: "Friday",
  26034: "Saturday",
  26035: "Sunday",
  26036: "Historical conversations",
  26037: "Searching, please wait",
  26038: 'Remaining SmartPoint {-num-}',
  26039: "SmartPoint",
  26040: 'Only supports CSV, XLS, XLSX format files below 10MB',
  26050: 'Deep search takes a long time. Have a cup of coffee, leave everything else to Zhichao, wait a few minutes and then return to this interface...',
  26051: "Search started, please wait",
  26052: "Search for similarities",
  26053: "Search for similar images",
  /****************9.3.0.1******************* */
  27000: "Create Link File",
  27001: "Link",
  27002: "Name",
  27003: "Thumbnails",
  27004: "Failed to create link file",
  27005: "Open Link",
  27006: "Successfully created link file",
  27007: "Approval is required for visitors other than administrators to create sub material libraries",
  27008: "Enter a link address",
  27009: "Specify a name for the linked file",
  27010: "Link format error",
  27011: "Edit Link File",
  27012: "Display subfolders contents",
  27013: "Successfully edited link file",
  27014: "The file size exceeds the 5MB limit, please choose a smaller file",
  27015: "Editing link file failed",
  27016: "Link file does not support download",
  27017: "Encrypt Folder",
  27018: "Create encrypted folder",
  27019: "The Babel Bird encrypted folder uses asymmetric encryption technology, and the password you set is the only way to open the folder",
  27020: "Please fill in the name",
  27021: "Click here to enter folder name",
  27022: "Please keep your password safe",
  27023: "Unable to retrieve lost password! And also unable to recover files in this folder after lost password",
  27024: "Click here to enter your password",
  27025: "Enter your password again",
  27026: "The password requirement is a combination of 6-20 uppercase and lowercase letters or numbers",
  27027: "The files inside the encrypted folder cannot be synchronized or accessed on the mapping disk",
  27028: "Please enter a combination of 6-20 characters containing uppercase and lowercase letters or numbers",
  27029: "Please enter the password for the Encrypt Folder",
  27030: "'{-name-}' password",
  27100: "Set the retention time for enterprise file versions to {-time-} days",
  27101: "Set the retention number of enterprise file versions to {-num-}",
  //********Automated tasks ******/
  28000: "Automated tasks",
  28001: "View existing task list",
  28002: "Auto Clean",
  28003: "Auto Rename",
  28004: "Auto Convert to PDF",
  28005: "Auto Organize",
  28006: "Auto-delete files in specific folders by rule",
  28007: "Auto-rename uploads in specific folders by rules.",
  28008: "Auto-generate PDF copies for uploads in specific folders.",
  28009: "Categorize and organize files in specific folders by preset rules.",
  28010: "Task",
  28011: "Automatically clear folders",
  28012: "Create a new automatic cleaning folder",
  28013: "Select target folder",
  28014: "Click to select a folder",
  28015: "Including files in all subfolders",
  28016: "If the subfolders are also set with cleaning tasks, the cleaning tasks will be stacked",
  28017: "Select Cleanup Trigger Condition",
  28018: "Pull down menu prompt: Select trigger condition",
  28019: "Change Folder",
  28020: "After the task is established",
  28021: "Enter the file into this folder (after file upload)",
  28022: "Number of Files",
  28023: "Folder Size",
  28024: "Delete only files, not subfolders",
  28025: "Select trigger condition",
  28026: "Select timing method",
  28027: "Fixed time interval",
  28028: "By cycle",
  28029: "All Files (Default)",
  28030: "Specific size",
  28031: "Specific file types",
  28032: "Keywords",
  28033: "Duplicate Files",
  28034: "Automatically delete this file",
  28035: "Every",
  28036: "Select file range for deletion",
  28037: "Automatically clear folder",
  28038: "Delete files with file names containing the following keywords",
  28039: "Only keep one file with consistent content",
  28040: "Fill in the file type extension that needs to be removed here, separating multiple extensions with\", \"for example: jpg, png, mp4 (case insensitive)",
  28041: 'Fill in the keywords contained in the file name that needs to be deleted here, separated by","',
  28042: "Automatically delete files of specific sizes",
  28043: "Delete Size",
  28044: "Arrived",
  28045: "The file",
  28046: "Automatically delete files with extensions",
  28047: "Every day",
  28048: "Every Sunday",
  28049: "Clear frequency",
  28050: "First Sunday of each month",
  28051: "December 31st every year",
  28052: "Select Time",
  28053: "Time",
  28054: "Contains files in subfolders",
  28055: "The total number of files exceeds",
  28056: "Fill in the trigger condition number, minimum 1, maximum 99999",
  28057: "The total file size exceeds",
  28058: "Please select the cleaning trigger condition",
  28059: "Edit Auto Cleanup",
  28060: "seconds",
  28061: "Year",
  28062: "Target folder",
  28063: "Cancel this task",
  28064: "No automation tasks currently available",
  28065: "Automated Task List",
  28066: "Folder Name (Task Name)",
  28067: "Task type",
  28068: "Automatic Cleaning",
  28069: "Do you want to cancel this automated task and no longer execute it",
  28070: "Automation",
  28071: "Create automatic renaming task",
  28072: "Auto Rename",
  28073: "Automatically rename files after adding them to the following folder",
  28074: "Apply to existing files",
  28075: "Not applicable if the number of files exceeds 1000",
  28076: "Example file name",
  28077: "Not all rules or metadata are applicable or usable for every file or file type",
  28078: "Selection Rules",
  28079: "Standard Options",
  28080: "Number",
  28081: "Custom Content",
  28082: "File uploader",
  28083: "Document Manager",
  28084: "Superior folder",
  28085: "Upload time",
  28086: "Media metadata",
  28087: "Shooting date",
  28088: "Camera Manufacturer",
  28089: "Camera model",
  28090: "Lens model",
  28091: "Size",
  28092: "dots per inch (DPI)",
  28093: "Points per centimeter (DPCM)",
  28094: "Add Rule",
  28095: "Choose to modify file name rules",
  28096: "Replace Content",
  28097: "Delete Content",
  28098: "Delete characters",
  28099: "Original file name",
  28100: "Enter the keyword to replace",
  28101: "Enter replacement content",
  28102: "Enter the content to be deleted",
  28103: "Spaces in file names",
  28104: "Numbers in file names",
  28105: "Quotation marks in file names",
  28106: "Dash and underline in file name",
  28107: "Starting:",
  28108: "Increment:",
  28109: "Number of digits:",
  28110: "Start: represents the first digit number. Increment: the number of digits added. Number of digits: the number of digits in the number",
  28111: "Click to fill in custom content",
  28112: "Year Month Day",
  28113: "Year Month",
  28114: "Year Month Day",
  28115: "Year Month Day Hour Minute",
  28116: "Year Month Day Hour Minute",
  28117: "Month Day Hour Minute Second",
  28118: "Replace the date detected in the file name",
  28119: "Case conversion",
  28120: "Initial capital letters",
  28121: "Lowercase first letter",
  28122: "All capitalized",
  28123: "All lowercase",
  28124: "Word delimiter",
  28125: "Space",
  28126: "underline",
  28127: "dash",
  28128: "Edit automatic renaming task",
  28129: "New automatic sorting",
  28130: "Organize files",
  28131: "Edit automatic sorting tasks",
  28132: "Choose sorting rules",
  28133: "Monthly classification",
  28134: "Create a folder based on the month added to the cloud storage and move files to the new folder",
  28135: "Classified by year",
  28136: "Create a folder based on the year it was added to the cloud storage and move files to the new folder",
  28137: "Keyword classification",
  28138: "Move files to a specific folder based on specific keywords contained in the file name",
  28139: "Classify files according to the keywords contained in their file names and process them in the order of keyword tasks",
  28140: "Add keyword classification",
  28141: "Move files to",
  28142: "Select folder",
  28143: "Enter keywords",
  28144: "Folder name",
  28145: "Please select a folder",
  28146: "Keywords cannot be repeated",
  28147: "After adding files to the selected directory, they can be automatically converted to PDF files",
  28148: "New automatic PDF conversion",
  28149: "Edit to PDF automatically",
  28150: "Choose the file type for converting to PDF",
  28151: "All supported files",
  28152: "Convert to PDF",
  28153: "Files over 30M will not be converted",
  28154: "Delete the original file after successful conversion",
  28155: "Image category",
  28156: "Document class",
  28157: "Graphic category",
  28158: "Cancel All Selection",
  28159: "Selected {-exts-} {-num-} file types",
  28160: "Selected {-exts-}... and other {-num-} file types",
  28161: "Please select the file type for converting to PDF",
  28162: "Apply to new upload folder",
  28163: "Enter the file name to search for in the current directory",
  28164: "Keep two decimal places",
  28165: "You do not have permission to move files from the current folder to the target folder",
  28166: "You can select any one or multiple approvers below to approve your sharing request. Once any one of them approves your request, the system will automatically send an invitation.",
  28167: "The sharer you invited has external users, and sharing can only be done after approval. You can fill in the proposed invitees to send the invitation request.",
  28168: "",
  28169: "",
  28170: "Create a seal",
  28171: "You can stamp and sign files on the cloud drive, supporting multiple file types. The signed files can be exported as PDFs",
  28172: "How to use the seal?",
  28173: "Click to view the seal tutorial",
  28174: "Batch create folders",
  28175: "Batch create folders by importing Excel file as required",
  28176: "Select the target directory where you want to batch create folders. Project files can only be created in department folders and the root directory of personal files",
  28177: "Select the type of folder to create",
  28178: "Import a list of folder names",
  28179: "Folder names are separated by line breaks, with one folder name per line. Supported file types for import are xls, xlsx, with a maximum limit of 5000 lines",
  28180: "Project folders",
  28181: "After downloading the template, fill it in as required. If the project leader is left blank, the creator will be set as the default project leader. Project folder names are separated by line breaks, with one folder name per line. The project leader can be an email address or phone number. Supported file types for import are xls, xlsx, and csv, with a maximum limit of 5000 lines",
  28182: "Click here to download the template for batch creating project folders",
  28183: "Click here to download the template for batch creating folders",
  28184: "Click or drag files to upload",
  28185: "Enable sensitive content detection",
  28186: "List of files containing sensitive content",
  28187: "Custom sensitive words",
  28188: "Enter the sensitive words you need to detect here",
  28189: "Sensitive content detection",
  28190: "Enter the sensitive words you need to detect above, up to 500 words, with each word not exceeding 10 characters. Separate them using commas or spaces",
  28191: "Upload a sensitive word library",
  28192: "Click the upload button to upload the sensitive word library. It will take effect within 30 minutes after upload",
  28193: "The file should be in TXT format, with up to 500 words, and each word not exceeding 10 characters. The file size should be within 100KB, encoded in UTF-8 (without BOM), and separated by commas, spaces, or line breaks",
  28194: "Handling strategy for files containing sensitive words",
  28195: "Mark only (mark files containing sensitive words)",
  28196: "Prohibit viewing and editing (replace with a sensitive word warning screen)",
  28197: "Prohibit sharing (sharing of files containing sensitive words will be automatically disabled)",
  28198: "List of files containing sensitive words",
  28199: "Please enter the file name or keyword to search",
  28200: "Not uploaded",
  28201: "Delete file",
  28202: "File owner",
  28203: "No files containing sensitive words found",
  28204: "Please upload a .txt file!",
  28205: "Re-upload",
  28206: "The sensitive word library you uploaded does not meet the system requirements. Please organize it as required and re-upload",
  28207: "External sharing does not require approval",
  28208: "After enabling, you can enter email addresses and phone numbers of non-enterprise members for invitation sharing and enable external link sharing",
  28209: "External sharing requires approval",
  28210: "To add approvers that can be selected for external sharing by users, click 'Add Approver'.",
  28211: "Click to add approvers",
  28212: "List of approvers",
  28213: "Are you sure you want to remove this user from the approvers list?",
  28214: "Select approvers",
  28215: "Allow departments to share externally",
  28216: "The approvers list can accommodate up to 5 members",
  28217: "You can select any one or more approvers below to approve your sharing request. Once any one of them approves your request, the system will automatically send an invitation",
  28218: "The shared person you invited includes external users and needs to be approved before sharing",
  28219: "Please upload the required template file first",
  28220: "Template file parsing failed",
  28221: "Parsing template file",
  28222: "Imported folder names",
  28223: "A total of {-total-} folders were imported, of which {-num-} folders failed to be imported due to non-compliant file names",
  28224: "Start creating",
  28225: "This file is a sensitive file and has been restricted",
  28226: "Enterprise release",
  28227: "Please select approvers",
  28228: "Management tools",
  28229: "After link sharing is turned off, re-enabling it requires file management approval. Are you sure you want to turn off this link sharing?",
  28230: "Unnamed node (right-click to rename)",
  28231: "You can right-click on a file directory node to open the menu and perform operations such as creating new items, deleting, and renaming. If creation fails, you can edit and try to recreate it",
  28232: "Creation in progress, please wait for completion and try again",
  28233: "(Ignored)",
  28234: "Are you sure you want to ignore this file? This operation is irreversible",
  28235: "Are you sure you want to delete this file?",
  28236: "The custom sensitive words have changed. Do you want to save them to the server?",
  28237: "Please upload .xlsx or .xls files",
  28238: "The uploaded directory structure is empty. Please edit it and upload again.",
  28239: "The custom sensitive words contain special symbols",
  28240: "Sharing with external parties is not allowed",
  28241: "Users are prohibited from modifying their personal information themselves.",
  28242: "Turn on this option, and enterprise members will not be able to change their personal information through the settings interface.",
  28243: 'After setting this option, the configuration here will override the enterprise setting of "prohibiting sharing files to external users" for user personal file sharing',
  28244: "(Enterprise allowed)",
  28245: "(Not allowed by the enterprise)",
  28246: "(Inherit from superior department settings)",
  28247: "Enterprises are prohibited from modifying this information",
  28248: "The file contains sensitive words set by the administrator, access is prohibited",
  28249: "This feature is only supported in the Enterprise Edition",
  28250: "This feature is not supported in the free version. You can upgrade to the professional or enterprise version to use this feature",
  28300: "Select watermark type",
  28301: "Horizontal Tile",
  28302: "Center Single",
  28303: "Enter custom text as watermark content, supports synchronized display across multiple terminals.",
  28304: "Uploading PNG images with transparent background yields the best effect. Please control the original image size.",
  28305: "Use graphic (vector) watermark",
  28306: "Uses graphical vector encoding to carry Hex feature codes. Screenshots can still be traced back through development and encoding tables.",
  28307: "Feature code (Hex, 8 digits)",
  28308: "Anti-morphing engine",
  28309: "Natural Recognizable Series",
  28310: "Anti-AI Concealment Protection Series",
  28311: "Test Mode",
  28312: "Light-dark adaptive (high performance)",
  28313: "Light-dark contrast dual stroke dots",
  28314: "Gray-white relief dots (low disturbance)",
  28315: "Deep sea blue stroke dots",
  28316: "Warm gold stroke dots",
  28317: "Texture camouflage probe (low visibility)",
  28318: "Residual redundancy fragments (development priority)",
  28319: "Subject-coupled texture (anti-recognition)",
  28320: "Black-white high contrast test",
  28321: "AI removal protection statement (screenshot preserved)",
  28322: "Explicit layer: can be overlaid with encoding. If the model still attempts to process the watermark, the statement layer is exposed first. Anti-AI graphic encoding should continue to disguise within image textures and can be traced through development.",
  28323: "Leak tracking development entry",
  28324: "Return to graphic (vector) watermark settings",
  28325: "After uploading a suspected leak screenshot, the system will reduce background interference according to the current watermark mode and enhance areas close to the watermark color, strokes, and local disturbances, making it easier to identify feature codes against the encoding table.",
  28326: "Encoding reference table",
  28327: "Upload leak screenshot (start development)",
  28328: "Development optimization mode",
  28329: "Brightness-contrast adaptive",
  28330: "Gray-white relief dots (low disturbance)",
  28331: "Development purification strictness",
  28332: "No image uploaded. After uploading, you can view the development result on the right. First find the 3-point sync position, then read the Hex encoding according to the 3x3 dot cluster and the encoding table.",
  28333: "Code query",
  28334: "Enter code fragment, wildcard, file name or sharer",
  28335: "Fuzzy query supported: at least 2 encoding characters identified can be queried. In wildcards, * represents any number of unknown characters, ? represents 1 unknown character, e.g. *A?2 or *A*2*; also supports fuzzy query by file name, sharer, receiver. Current is interface sample data.",
  28336: "Development encoding reference table",
  28337: "Please drag image here or click to select",
  28338: "Select image",
  28339: "Developed view",
  28340: "Original view",
  28341: "Fit",
  28342: "Please drag leak screenshot here or click to select",
  28343: "Select leak screenshot",
  28344: "Upload suspected leak screenshot and perform development purification to facilitate identification of Hex feature codes in graphic (vector) watermarks.",
  28345: "Watermark density",
  28346: "Physical scale (short edge ratio)",
  28347: "Scatter randomness",
  28348: "Anti-removal disturbance strength",
  28349: "Graphic watermarks use module grid layout.",
  28350: "Update Watermark Settings",
  28351: "Query failed, please try again later.",
  28352: "No matching records found. Try entering a shorter code fragment.",
  28353: "Current Preview User",
  28354: "User ID: ",
  28355: "Sharer",
  28356: "Code ",
  28357: "File ID: ",
  28358: "Allow users to customize shared file watermark",
  28359: "When enabled, users cannot customize watermark settings when sharing files",
  28360: "Watermark display scope",
  28361: "Preview only",
  28362: "All pages",
  28363: "Watermark display scope saved successfully",
  28364: "Failed to save watermark display scope, please try again later",
  "27102.0": " in the enterprise backend {-Prohibited_allowed-} Sharing personal private files",
  27102.1: " in the enterprise backend {-Open_close-} Display assembly structure",
  27102.2: " in the enterprise backend {-Prohibited_allowed-}  Share files externally",
  27102.3: " in the enterprise backend {-Open_close-} Enterprise Release Folder",
  27102.4: " in the enterprise backend {-Open_close-} The function of automatically disabling the enterprise file sharing link enabled by the user is disabled",
  27102.5: " in the enterprise backend {-Prohibited_allowed-} Anonymous sharing",
  27102.6: " in the enterprise backend {-Open_close-} Dynamic notification function",
  27102.7: " in the enterprise backend {-Prohibited_allowed-} Use default sharing permissions",
  27102.8: " in the enterprise backend {-Open_close-} The function of bidirectional binding of MAC addresses",
  27102.9: " in the enterprise backend {-Open_close-} The function of displaying the abbreviation of the enterprise",
  "27102.10": " in the enterprise backend {-Open_close-} Disable the function of displaying thumbnails for users without download permissions",
  27102.11: " in the enterprise backend {-Open_close-} The function of regularly forcing the modification of old passwords",
  27102.12: " in the enterprise backend {-Open_close-} Calculating search permissions",
  27102.13: " in the enterprise backend {-Open_close-} Automatic unlocking",
  27102.15: " in the enterprise backend  {-Open_close-} The function of customizing personal information",
  27102.16: " in the enterprise backend {-Open_close-} Video preview function",
  27102.17: " in the enterprise backend {-Open_close-} Custom share watermark function",
  27102.18: " in the enterprise backend {-Open_close-} Full-page watermark function",
  "27103.0": " in the enterprise {-Open_close-} Display function of Co-publishing folder",
  27103.1: " in the enterprise {-Open_close-} The function of hiding organizational structure",
  27103.2: " in the enterprise {-Open_close-} Allowing users to upload personal files",
  27103.3: " in the enterprise {-Open_close-} Allowing users to share personal files",
  27103.4: " in the enterprise {-Open_close-} Sending email notifications",
  27103.5: " in the enterprise {-Open_close-} The function of hiding administrator logs",
  "Open_close.0": "OPENED",
  "Open_close.1": "CLOSED",
  "Prohibited_allowed.0": "ALLOWED",
  "Prohibited_allowed.1": "PROHIBITED",
  27104.1: "{-somebody-} changed material category {-files-} setting as follows:{-fileChanges-}",
  27104.2: "{-somebody-} changed sub material library {-files-} setting as follows:{-fileChanges-}",
  MATERIAL_OP_NAME: {
    1: "Access type",
    2: "Options",
    4: "Add Assistant",
    8: "Add Member",
    16: "Add Authorized personnel",
    32: "Modify Restricted Department List",
    64: "Modify Manager List",
    128: "Modify Blacklist/Whitelist",
    256: "Remove Member",
    512: "Remove Authorized personnel"
  },
  27105: "{-somebody-} changed settings of link file {-file-}",
  27106: "Link files are not supported for download, download has ignored all link files",
  /***************tiptap******* */
  30000: "Babel office",
  /*************9.3.2*************/ /////////// */
  40000: "Recommended for you",
  40001: "Suggestions based on your activity content",
  40002: "Recently Visited",
  40003: "Recently followed",
  40004: "No recommended content at the moment",
  40005: "Click to preview",
  40006: "Addendum: ",
  40007: "Turn off intelligent recommendation",
  40008: "After turning off, smart recommendations will not be displayed in this area. You can turn on smart recommendations again in the settings interface",
  40009: "Please enter the password for the encrypted folder",
  40010: "Got it",
  40011: "Go to Settings",
  40012: "export",
  40020: "The following settings have been made for the company name，{-nameChanges-}",
  40021: "Auto-unlock",
  40022: "If this option is disabled, the lock can only be automatically unlocked after the user finishes editing, or manually unlocked by an administrator. Turning this on will automatically unlock the lock after it has been locked for more than 2 hours",
  set_ent_name: "Change the full name to:{-name-}",
  set_ent_short_name: "Change the abbreviation to:{-name-}",
  40050: "{-count-} Items",
  40051: "The directory where the project is located has no selectable projects.",
  //////////////////////////**************9.3.4***********/
  40061: "Swipe right to complete verification",
  40052: "have been downloaded",
  40053: "have been deleted",
  40054: "have been uploaded",
  40055: "ave been printed",
  ////////////////////////////////***********9.4.2-group************** */

  40070: "Prohibit users from previewing video files online",
  40071: "Turn on this option, enterprise members cannot preview video files online",
  40072: "Our company has banned online preview of video files. Please contact the administrator",
  40073: "Allow client synchronization",
  40074: "Turn on this option, this member can synchronize files using the client",
  40075: "Our company has prohibited client file synchronization. Please contact the administrator",
  40076: "Enter group name",
  40077: "Search group name",
  40078: "There are currently {-num-} groups in total",
  40079: "Enter nickname, email, phone number, or group name",
  40080: "Enter nickname, email, phone number, department or group name",
  ////////////////////////////////***********9.4.2-group2************** */
  40090: "Are you sure to remove this group from the approvers?",
  40091: "The external sharing of files by enterprises is controlled, and individual grouping is temporarily not allowed",
  40092: "Failed to obtain approval information, you do not have permission to view the approval",
  40093: "comments",
  /**************************9.4.3************************** */

  50000: "API Key",
  50001: "API Quick Start",
  50002: "Create API Key",
  50003: "Key",
  50004: "APP",
  50005: "APP Name",
  50006: "API Access URL",
  50007: "File and Folder Permissions",
  50008: "Permissions for API to view and manage files and folders",
  50009: "View and edit Babbler files and folders you have permission to",
  50010: "View Babbler files and folders you have permission to",
  50011: "Edit content of Babbler files and folders",
  50012: "View content of Babbler files and folders",
  50013: "Create your API Key",
  50014: "Creating and using an API key allows third-party AI applications (e.g.: openclaw, Cursor) to quickly connect to your Babbler, access files and connect to Babbler AI knowledge base, and even store files. You can click the button above to create a new API key.",
  50015: "Learn More",
  50016: "Create New APP",
  50017: "Name your APP",
  50018: "Please enter APP name",
  50019: "Select the type of access permissions you need",
  50020: "Application folder - access a single folder created specifically for your application.",
  50021: "Full - access all files and folders in Babbler that you have permission to access",
  50022: "Create Key",
  50023: "Application Folder",
  50024: "Full Access",
  50025: "Rename APP",
  50026: "Remove APP",
  50027: "Are you sure you want to remove this APP?",
  50028: "API Key Details",
  50029: "Access URL",
  50030: "Copy Key",
  50031: "Copy successful",
  50032: "Copy failed, please manually select the text to copy",
  50033: "Authorization (OAuth 2)",
  50034: "Redirect URI (OAuth 2)",
  50035: "Access Token (Access Token)",
  50036: "Get Token",
  50037: "Click to show",
  50038: "Accessible Scope",
  50039: "For AI agent access",
  50040: "Reset Key",
  50041: "AI Onboarding Prompt",
  50042: "Copy this prompt to your AI agent to connect to MCP automatically",
  50043: "Advanced Options:",
  50044: "I need to connect to Babel MCP. The MCP URL is {0}, and the API Key is: {1} After configuration, list the available tools and run a read-only connection test.",
  ////////////////9.4.4////////////////////////
  40100: "Folder icon",
  40101: "Change folder icon",
  40102: "Select icon replacement",
  40103: "Upload custom icon",
  40104: "Apply to subfolders",
  40105: "Apply to the same type of folder (only for super management)",
  40106: "Example folder",
  40107: "Supports PNG, SVG, JPG",
  40108: "The image resolution is higher than 60 * 60PX, with a maximum of 2MB",
  40109: "Custom icon",
  40110: "Effect Preview",
  40111: "Are you sure you want to delete this custom file icon",
  40112: "Restore default icon",
  40113: "Are you sure you want to restore the default file icon",
  40114: "Please enter a custom watermark",
  40115: "Custom watermark setting successful",
  40116: "Use default watermark",
  40117: "Custom Watermark",
  40118: "Get download address",
  40119: "Generate download link for {- name -}",
  40120: "<strong>Security Tip:</strong>This link is a direct access link, and anyone who obtains this link can directly download or read this file without logging in. Please share with caution. ",
  40121: "File download link:",
  40122: "Link configuration:",
  40123: "Link Validity Period",
  40124: "Maximum number of downloads",
  40125: "Valid for 7 days",
  40126: "Valid for 30 days",
  40127: "Enter valid days",
  40128: "Unrestricted",
  40129: "10 times",
  40130: "50 times",
  40131: "100 times",
  40132: "Enter valid number of times",
  40133: "Customize...",
  40134: "Link copied successfully",
  40135: "Failed to obtain link, this file does not support anonymous download!",
  40136: "Are you sure you want to restore the corresponding folder icon to the system default icon",
  40137: "Downloaded",
  40138: "The effective download count is 0, and the link has expired",
  40139: "Watermark Text",
  40140: "Diagonal tiling",
  40141: "You can right-click on the directory to create a new folder",
  40142: "Archive",
  40143: "Archive Index",
  40144: "Classification Index",
  40145: "Common Entrance",
  40146: "Unclassified",
  40147: "Maximum Access",
  40148: "Latest Archive",
  40149: "Document Classification Approval",
  40150: "Apply to create category",
  40151: "Edit Category",
  40153: "New Subcategory",
  40154: "Delete Category",
  40155: "Are you sure you want to delete this category",
  40156: "Classification Name",
  40157: "Classification Path",
  40158: "Please enter the category name",
  40159: "Set classification for files",
  40160: "Approval Classification Request",
  40161: "List of Application Classification Documents",
  40162: "Classification application without archives",
  40163: "Classification cannot be empty",
  40164: "{-somebody-} created category {-sub-} in archive library {-parent-}",
  40165: "Search classification...",
  40166: "Search folder...",
  40167: "Clear search",
  40168: "Please enter other keywords or clear the search box to view all",
  40169: "No classification found containing {-name-}",
  40201: "Search custom metadata name, keywords...",
  40223: "Are you sure you want to delete the custom metadata <span class=\"main-color\">{-name-}</span>?",
  40225: "Options",
  40226: "Fields marked with an asterisk must be filled in",
  40227: "{-num-} matching metadata entries found",
  40228: "No matches found, showing all metadata",
  40229: "--Please select--",
  40230: "Supports Chinese, English, numbers and underscores, max 50 characters",
  40231: "Format: YYYY-MM-DD",
  40232: "Please enter a number (can include decimal)",
  40233: "e.g.: 3.14 or 2.0",
  40234: "Please enter a number",
  40235: "e.g.: -1 or 1",
  40236: "Changes will be automatically saved to the backend",
  40237: "Custom Metadata",
  40238: "Saving...",
  40239: "Please enter up to {-num-} characters",
  40240: "Please enter up to {-num-} characters (excluding \" and ;)",
  40241: "Input contains invalid characters",
  40242: "Search custom metadata only",
  40243: "Apply to modify file custom metadata",
  40244: "The category <span class=\"main-color\">{-name-}</span> you created for the archive has been deleted by the administrator",
  40245: "Review Result",
  40246: "Reviewer",
  40247: "Review Time",
  40248: "The administrator has saved your submitted files {-files-} into the following categories: {-classifications-}",
  40249: "The administrator has processed your classification request for files {-fileName-}{-etc-}, ",
  40250: "etc.",
  40251: "File List",
  40252: "Added Categories",
  40253: "Removed Categories",
  40254: "File Classification Request Details",
  40255: "The administrator has processed your file classification request, results are as follows:",
  40256: "Your file metadata modification request has been reviewed by {-reviewerName-}, result: {-status-}",
  40257: "Custom Metadata Filter",
  40258: "Clear",
  // Metadata search cascader related
  40260: "OK",
  40261: "From",
  40262: "To",
  40263: "Please select",
  40264: "Range",
  40265: "Text",
  40266: "Single Select",
  40267: "Multi Select",
  40268: "No sub-options",
  40269: "Enter keyword",
  40270: "Please enter content",
  40271: "Please enter a valid number",
  40272: "Please enter a valid integer",
  40273: "Please select metadata",
  40274: "{-num-} items selected",
  40275: "Sender",
  40276: "File Name",
  40277: "Search criteria unchanged",
  40278: "Search failed, please try again later",
  40279: "Failed to load next page, please try again later",
  40280: "Minimum value cannot be greater than maximum value",
  40281: "Please enter a valid date",
  40282: "No file metadata defined. Please go to the enterprise admin console to set it up.",
  40283: "No file metadata defined. To use custom metadata, please contact your administrator to configure it in the enterprise admin console.",
  40284: "Go to Admin Console",
  40285: "{-applicantName-} applied to set custom metadata for the following files",
  48287: "Public cloud does not support this feature yet. This watermark is only available in on-premises deployment. Please contact customer service.",
  42888: "Click to view full path",
  42889: "No custom metadata",
  //"没有自定义元数据",
  42890: "Tip: The enterprise has not set up file custom metadata yet",
  //"提示 : 企业还没有设置文件自定义元数据",
  // 50000 起的编号已被 mcp 分支占用，问卷（Formbricks）文案改用 50100 起
  50100: "Create survey",
  50101: "Create a new Formbricks survey",
  50102: "Copy and edit",
  50103: "Copy and edit is not available yet",
  50104: "Survey test data created: {-name-}",
  50105: "Survey",
  50106: "New survey",
  50107: "Draft",
  50108: "Close survey",
  50109: "View form",
  50110: "Draft",
  50111: "In progress",
  50112: "Paused",
  50113: "Completed",
  50114: "Select where to save the survey",
  50115: "Survey name",
  50116: "Please enter the survey name",
  50117: "Surveys",
  50118: "My files",
  // 9.4.7 强制备份（Managed Backup）
  50120: "View backup policies only",
  // 强制备备主面板（MEForceBackupPanelView）
  50121: "Managed Backup",
  50122: "Enterprise backup policies and endpoint management",
  50123: "Refresh status",
  50125: "Backup policies",
  50126: "Members & clients",
  50127: "Backup files",
  50128: "Operation logs",
  50129: "The enterprise backup root folder is not available yet. Please try again later.",
  50130: "Open the backup root folder?",
  50131: "The enterprise scan backup root folder will open in a new tab.",
  50132: "Active policies",
  50134: "{-num-} drafts",
  50135: "Managed devices",
  50136: "/ {-num-}",
  50137: "Abnormal devices",
  50138: "",
  50139: "{-num-} files pending",
  50140: "Total backup files",
  50142: "{-size-} securely retained",
  50143: "{-num-} devices have backup errors and {-num2-} files were not uploaded successfully. Completed cloud backups are not affected.",
  50144: "View errors",
  50145: "Dismiss",
  50146: "Loading statistics…",
  // 强制备份 - 策略详情弹窗（MEForceBackupPolicyDetailWinView）
  50150: "Policy details",
  50151: "Policy not found",
  50152: "Policy No.",
  50153: "Scope",
  50154: "(including all sub-departments)",
  50155: "Accounts & devices",
  50156: "{-users-} accounts · {-assigned-} assigned devices · {-waiting-} accounts not connected",
  50157: "Later connections",
  50158: "Applies only to the selected devices, not to other computers of the account",
  50159: "Windows devices connected later by the selected accounts will match this policy automatically",
  50160: "Backup folder",
  50161: "Disks to scan",
  50162: "All local fixed disks",
  50163: "{-drives-}",
  50165: "{-list-}, files without extension",
  50166: "How it runs",
  50167: "Real-time backup · scan on startup · daily verification at {-time-}",
  50168: "Upload limit",
  50169: "{-bw-} MB/s · {-size-} MB per file",
  50170: "Last updated",
  50175: "Revocation pending",
  50176: "v{-ver-} in effect",
  50177: "Waiting for v{-ver-} acknowledgment",
  50178: "Waiting for client connection",
  50179: "No clients yet",
  50180: "Target devices",
  50181: "Version acknowledged",
  50183: "Backup configuration",
  50184: "Employees cannot pause or exit the executor",
  50185: "Deleted locally, kept in the cloud",
  50186: "Employees cannot delete cloud backups",
  50187: "Revocation receipts",
  50188: "Deployment receipts",
  50189: "This policy has not been deployed to any device.",
  50190: "Accounts without clients ({-num-})",
  50191: "Edit policy",
  // 强制备份 - 备份策略列表（MEForceBackupPolicyPanelView）
  50250: "All statuses",
  50251: "Active",
  50253: "Pending on clients",
  50256: "Search policy name, file type or scope",
  50258: "{-num-} policies in total",
  50259: "Export policy list?",
  50260: "{-num-} policy records matching the current filters will be exported (CSV file).",
  50261: "Confirm export",
  50266: "Accounts",
  50267: "Devices",
  50268: "Extension whitelist",
  50271: "Managed Backup-Policies",
  50272: "Export list",
  50273: "Policy list",
  50274: "Exported {-num-} records with current filters",
  50275: "Exported {-num-} records",
  50276: "Duplicate as new policy",
  50277: "Deactivate policy",
  50278: "Delete draft",
  50279: "Delete policy",
  50280: "Deactivate this backup policy?",
  50281: "After deactivation, this policy will no longer perform new backups. Uploaded files and historical versions are all retained and enterprise cloud data is not deleted.",
  50282: "Uploaded files and historical versions are all retained. Enterprise cloud data is not deleted.",
  50283: "Keep backing up",
  50284: "Confirm deactivation",
  50285: "The policy has been deactivated. Cloud backups are retained.",
  50286: "Failed to deactivate. Please try again later.",
  50287: "The deactivation command has been recorded and is awaiting device confirmation. Cloud backups are retained.",
  50288: "Delete the unpublished draft?",
  50289: "Delete the deactivated policy?",
  50290: "{-name-} has not been deployed. Clients and cloud backups are not affected.",
  50291: "{-name-} is deactivated. After deletion, the policy configuration cannot be recovered. Backed-up files and historical versions are all retained.",
  50292: "Draft deleted",
  50293: "Policy deleted",
  50294: "Failed to delete. Please try again later.",
  // 强制备份 - 策略表格（MEForceBackupPolicyTableView / MEForceBackupPolicyTableRowView）
  50400: "No policies found",
  50401: "Adjust the filters, or create a new backup policy.",
  50404: "Backup file types",
  50405: "Policy status",
  50406: "Device receipts",
  50409: "Enterprise files/backup folder",
  50411: "Enterprise files / {-target-}",
  50413: "{-users-} accounts · {-devices-} devices",
  50414: "incl. sub-departments",
  50415: "{-num-} accounts waiting for client connection",
  50416: "No extension",
  50417: "Only selected types are uploaded",
  50418: "{-num-} in effect",
  50419: "No devices, not deployed",
  50420: "Not deployed",
  50421: "{-num-} awaiting revocation confirmation",
  50423: "Publish",
  50425: "More actions",
  // 强制备份 - 策略向导（MEForceBackupPolicyWizardWinView）
  50551: "Backup content",
  50553: "Confirm deployment",
  50554: "Edit backup policy",
  50555: "New backup policy",
  50556: "Configured by admin · executed by managed clients",
  50557: "Discard changes?",
  50558: "Your changes are not saved and will be lost if you exit.",
  50559: "Keep editing",
  50560: "Discard and exit",
  50562: "e.g. Continuous R&D document backup",
  50563: "Cloud backup folder",
  50564: "Select folder",
  50565: "Published policies do not migrate historical folders. To change the target folder, create a new policy.",
  50566: "Only folders managed by the enterprise can be selected. Employees have no permission to delete, move or share them externally.",
  50567: "Folder structure: account + device name",
  50568: "Account (account ID)",
  50569: "Device name (device ID)",
  50570: "C: / Users / original path / files",
  50571: "Single-device and multi-device deployments use the same folder rules. Computers of the same account are stored separately, and devices with the same name are distinguished by device ID. Existing historical backups are not migrated.",
  50572: "Remark (optional)",
  50573: "Policy purpose or management notes",
  50574: "Upload backup only",
  50576: "Employees cannot disable it",
  50577: "Scan scope",
  50579: "Specific drives",
  50580: "Drive {-disk-}",
  50581: "Portable drives, mapped network drives and the Babel virtual drive are excluded. System, recycle bin and client cache folders are skipped automatically.",
  50582: "File types to back up",
  50583: "(extension whitelist)",
  50584: "Other extensions, e.g. cad, tar.gz",
  50586: "Only selected extensions are backed up. Unselected types are not uploaded. Case-insensitive, compound extensions supported.",
  50587: "Also back up files without extension",
  50588: "File matching test",
  50589: "annual-contract.docx",
  50591: "Run settings",
  50592: "Upload speed limit (MB/s)",
  50593: "Max file size (MB)",
  50594: "Daily off-peak verification",
  50595: "Real-time watching and startup scanning are always on. Files in use or offline are kept in the queue and uploaded after recovery.",
  50596: "Click to remove",
  50597: "{-num-} selected:",
  50598: "Loading accounts…",
  50599: "No matching accounts",
  50600: "Loading departments…",
  50601: "No matches",
  50602: "Loading groups…",
  50604: "Expand sub-departments",
  50605: "Join with parent department",
  50606: "{-num-} members",
  50609: "Has policy",
  50610: "Unassigned",
  50611: "departments",
  50612: "accounts",
  50613: "groups",
  50614: "devices",
  50615: "Select backup accounts or devices",
  50616: "By department",
  50617: "By account",
  50618: "By group",
  50619: "By device",
  50621: "Search name or account",
  50622: "Search groups",
  50623: "Search account or device name",
  50624: "Include all sub-departments of the selected departments",
  50625: "Applies only to the selected devices. Other devices of the same account are not included automatically.",
  50626: "The account scope covers all Windows devices of the accounts, including devices connected later.",
  50627: "Not filled in",
  50628: "Number of accounts",
  50629: "Number of devices",
  50630: "Later devices",
  50631: "Selected devices only",
  50632: "New Windows devices of the accounts match automatically",
  50633: "Scope size",
  50634: "Cloud folder",
  50635: "Account / device name (device ID) / drive / original path",
  50637: "{-disks-}",
  50639: "Files without extension",
  50640: "Real-time watching · startup scan · daily verification at {-time-}",
  50641: "Resource limits",
  50642: "{-bandwidth-} MB/s · {-size-} MB per file",
  50643: "Publish version",
  50644: "Built-in protection rules",
  50645: "Only matching files are uploaded. Empty folders are not created",
  50646: "Local deletion or renaming does not delete cloud originals",
  50647: "Employees cannot pause, modify or release the backup",
  50648: "Signing out from the web does not stop the backup task",
  50649: "Versions are retained and the data belongs to the enterprise",
  50650: "Files of multiple devices of the same account are stored separately",
  50651: "After publishing, the policy enters the deployment queue and takes effect when Windows clients in scope connect.",
  50652: "Save draft",
  50653: "Confirm publish and deploy",
  50654: "Draft saved. It has not been deployed to clients.",
  50655: "Policy v{-version-} has joined the deployment queue and is waiting for client confirmation.",
  50656: "The account policy has been saved and is waiting for a Windows client to connect. It is not in effect yet.",
  50657: "The enterprise backup root folder is not available. Please refresh the page and try again.",
  50658: "The policy has been created and published, waiting for client confirmation.",
  50659: "The policy has been updated and published, waiting for client confirmation.",
  50660: "Failed to save. Please try again later.",
  50662: "Enter an extension to back up",
  50663: "Enter a valid extension such as docx or tar.gz. Do not use * wildcards.",
  50664: "Enter a file name",
  50665: "Matches the whitelist. Files of this type will be backed up.",
  50666: "Does not match the whitelist. Not uploaded, and no cloud folder is created for it.",
  50667: "Select enterprise backup folder",
  50668: "Select a specific enterprise folder",
  // 强制备份 - 人员与客户端面板（MEForceBackupClientsPanelView）
  50850: "All connection statuses",
  50851: "Client online",
  50852: "All clients offline",
  50853: "No client connected",
  50854: "One account, multiple devices",
  50855: "All backup statuses",
  50856: "Backed up normally",
  50857: "Backing up",
  50858: "Backup errors",
  50859: "Waiting to take effect",
  50861: "No policy assigned",
  50865: "Search name, account or device name",
  50866: "Export members",
  50867: "\"Not connected\" means no Windows client record yet. It does not mean the account is disabled or the device is offline.",
  50868: "Enterprise accounts",
  50870: "Connected to Windows client",
  50871: "members / {-num-} devices",
  50872: "All departments",
  50873: "Export devices",
  50874: "Account ID",
  50878: "Client connection",
  50879: "Connected devices",
  50880: "Online",
  50881: "Device list",
  50883: "Device No.",
  50885: "Member",
  50886: "Client connection",
  50887: "Backup status",
  50888: "Uploaded files",
  50889: "Uploaded bytes",
  50890: "Last successful backup",
  50891: "Managed Backup-{-type-}.csv",
  50893: "Devices",
  50895: "Member list",
  50899: "Connected devices",
  50900: "{-num-} Windows devices · {-num2-} online",
  50903: "Account backup folder",
  50904: "Client {-ver-}",
  50905: "Last heartbeat {-time-}",
  50906: "{-num-} files · {-size-}",
  50907: "Device details",
  50908: "No Windows client connected yet",
  50909: "This account has no Windows client registration record. Using the web only does not create device backup tasks.",
  50910: "The account policy has been configured and will be deployed when a client connects.",
  50911: "Accounts & clients",
  50912: "Windows clients of this account",
  50913: "This account has multiple devices. Each device executes, acknowledges and retains independently. Devices are not replaced by the last signed-in one.",
  50914: "Devices are counted only after a client registers and links to this enterprise account. \"Not connected\" does not mean offline, nor does it indicate whether the software was ever installed.",
  50915: "Folder and device mapping",
  50916: "Device name (device ID) / C: / original path",
  50917: "The device name is for identification. Account ID and device ID are used for stable mapping. Computers with the same name still keep separate backups. Existing historical folders are not moved automatically.",
  50918: "{-num-} (current: {-id-})",
  50919: "Device ID",
  50920: "Device backup folder",
  50921: "OS",
  50922: "Applied policy",
  50923: "(target v{-ver-} / confirmed v{-ver2-})",
  50924: "No policy assigned",
  50925: "Last heartbeat",
  50926: "Last backup",
  50927: "Endpoint details",
  50928: "Backed-up files",
  50930: "Files pending upload",
  50931: "{-cmd-}. The result is subject to the next client receipt.",
  50932: "Pending errors",
  50933: "{-num-} files",
  50934: "The document is locked by another program. The client will retry automatically after the program is closed. You can also send a retry request.",
  50935: "The executor cannot read a restricted folder. Ask the endpoint administrator to check access permissions, then retry the backup.",
  50936: "Task protection",
  50937: "Employees cannot modify or release the policy",
  50938: "Signing out of the web does not stop managed tasks",
  50939: "Upload only, local deletions are not synced",
  50940: "Cloud folders belong to the enterprise",
  50941: "This is a managed client task. Protection against local administrators forcibly ending the process or uninstalling still requires Windows services and enterprise endpoint control.",
  50943: "Rescan files",
  50944: "Retry failed files",
  50945: "The selected devices have no failed files to retry.",
  50946: "Rescans can only be sent to managed devices with an assigned policy.",
  50947: "Rescan backup files",
  50948: "Send {-type-} request to {-num-} devices.",
  50950: "Rescan",
  50951: "Retry failed files only. Completed files are not uploaded again.",
  50952: "Rescan by the extension whitelist of the current policy. Cloud files are not deleted.",
  50953: "{-num-} devices are offline. The requests will be processed after reconnection.",
  50954: "Confirm send",
  50955: "Request recorded, waiting for the client execution receipt.",
  // 强制备份 - 客户端表格/账号行/设备行（MEForceBackupClientsTableView 等）
  51050: "No matching accounts or devices",
  51051: "Name / account",
  51053: "Windows client",
  51055: "Last client heartbeat",
  51056: "Backup coverage",
  51058: "Account / device name",
  51061: "Backed up",
  51063: "{-online-} online / {-total-} connected",
  51064: "No Windows device registration record",
  51065: "No connected devices",
  51066: "{-managed-} / {-total-} managed",
  51068: "No policy configured",
  51069: "No heartbeat",
  51071: "Assign policy",
  51072: "Multiple devices per account",
  51075: "Heartbeat",
  51076: "{-count-} files",
  51077: "{-count-} · {-size-}",
  51078: "Last backup {-time-}",
  51080: "Confirmed v{-applied-} / target v{-target-}",
  // 强制备份 - 数据层（ForceBackupFormat）
  51200: "No records yet",
  // 强制备份 - 数据层（ForceBackupModel / ForceBackupStore）
  51301: "Client online",
  51302: "Client offline",
  51303: "Enterprise files / Managed Backup",
  51304: "",
  51305: "({-text-})",
  51306: "Office documents",
  51307: "Design source files",
  51308: "R&D files",
  51321: "Enter a policy name.",
  51322: "This policy name already exists. Use a different name.",
  51323: "Select a backup folder owned by the enterprise.",
  51324: "Select at least one extension to back up.",
  51325: "Invalid extension format. Use docx, pdf or tar.gz. Do not use wildcards.",
  51326: "Select at least one fixed disk.",
  51327: "Enter an upload speed limit between 1 and 1024 MB/s.",
  51328: "Enter a max file size between 1 and 2048 MB.",
  51329: "Select a daily verification time.",
  51330: "Select at least one account, department or group.",
  51331: "Success",
  51332: "Revoke policy, waiting for device receipt",
  51333: "Policy v{-ver-} pending confirmation",
  51334: "Publish policy",
  51335: "Published v{-ver-}, covering {-count-} accounts; {-dev-} devices awaiting receipt, {-wait-} accounts awaiting client connection",
  51336: "Policies already in effect must be published as a new version and cannot be overwritten as a draft.",
  51338: "Not deployed to clients yet",
  51341: "Stop new backups; revocation pending client confirmation. Cloud files and historical versions are all retained",
  51342: "Account not found",
  51343: "Enter a device name",
  51344: "This account has a policy conflict that requires administrator handling",
  51346: "Matched policy {-name-}, waiting for client confirmation",
  51347: "Account linked, no policy assigned",
  51348: "Policy {-id-}",
  51351: "Delete undeployed or deactivated policies",
  51352: "{-name-} - Copy",
  51353: "Retry failed files pending",
  51354: "Rescan files pending",
  51355: "Retry request",
  51356: "Rescan request",
  51357: "Request recorded, waiting for client execution. Existing backup results are unchanged",
  51358: "Pending",
  51359: "Enterprise files / Backup restore / ",
  51360: "Restore request",
  51361: "Request to restore v{-ver-} of {-dev-} to {-path-}. The original backup is unchanged",
  51362: "No scope selected",
  51363: "All Windows devices",
  51364: "This feature is available only in private-cloud deployment. Only saving drafts is supported on the public cloud.",
  51365: "Your enterprise has not purchased this module. Only saving drafts is currently supported.",
  51366: "Ordinary members use the first valid setting in order: <strong>member-specific → role-specific → everyone in the department → base department-role permissions</strong>",
  51367: "Permissions are not stacked; when one expires, the next level applies. Members with the \"Department file management\" permission are not restricted by the settings below.",
  51368: "Applies to ordinary members without a valid member-specific or role-specific setting",
  51369: "How file permissions are applied",
  51370: "<p>First the system checks the \"Department file management\" permission; members with it are not restricted by the settings below.</p><ol><li><b>Member-specific:</b> if a valid setting exists, it applies.</li><li><b>By role:</b> if the member has no valid individual setting, the system checks whether a file permission is set for the group using the member's role. If so, that file permission applies — not the role's base permissions.</li><li><b>Everyone in the department:</b> applies when the two levels above have no valid setting.</li><li><b>Base department-role permissions:</b> used only when none of the three levels above has a valid setting.</li></ol><p>The first valid setting applies and permissions are not stacked. A higher priority does not mean more permissions.</p>",
  51371: "Who \"Everyone in the department\" applies to",
  51372: "<p>This is the general setting for ordinary members. Those with a valid member-specific or role-specific setting use their specific setting first.</p><p>Members with the \"Department file management\" permission are never restricted.</p>",
  51373: "\"Not set separately\" does not mean no permission",
  51374: "<p>Choosing \"Not set separately\" means the system keeps checking the next level, not that access is denied.</p><p>Choosing \"Invisible\" is a valid setting; once applied, lower-priority levels are not checked.</p><p>Permission presets come from the enterprise's custom file permission list; actual operations depend on the enterprise configuration.</p>",
  51375: "Got it",
  51380: "Allows viewing comments in files created or uploaded by other members, including comments added by you and others.",
  51381: "Allows adding comments to files created or uploaded by other members without modifying the file content.",
  51382: "Allows deleting comments added by other members. \"Others\" refers to the comment author, regardless of who created or uploaded the file.",
  51383: "Allows seeing sub-departments under the current department and viewing files in them. When disabled, sub-departments are hidden.",
  51384: "Allows printing files you created or uploaded, or downloading a watermarked PDF. Downloading the original file requires the \"Download own files\" permission.",
  51385: "Allows printing files created or uploaded by other members, or downloading a watermarked PDF. Downloading the original file requires the \"Download others' files\" permission.",
  51386: "Allows viewing operation logs of files you created or uploaded, showing who did what and when.",
  51387: "Allows viewing operation logs of files created or uploaded by other members, showing who did what and when.",
  51388: "Allows files you have no permission to view to appear in the list, without being able to open them.",
  51389: "Allows editing the content of files you created or uploaded online.",
  51390: "Allows editing the content of files created or uploaded by other members online.",
  51391: "For managing the current department's files; see the management items below.",
  51392: "Includes permissions to create, delete and modify sub-departments under the current department.",
  51393: "Allows configuring which members can access files and which actions they can perform.",
  51394: "Allows setting or adjusting the confidentiality level of files.",
  51395: "Allows reviewing file sharing requests and deciding whether to approve them.",
  51396: "Allows transferring the file owner to another member. Transferring does not change who created or uploaded the file."
};
var _default = exports["default"] = localString_en_part3;

},{"1454":1454}],1157:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require(1180));
var _localString_en_part;
var localString_en_part2 = (_localString_en_part = {
  /////////////////////////////**************************8.7.1***************************//
  5000: "signature settings",
  5001: "Report-form",
  5002: "document countersigned",
  5003: "drawing review",
  5004: "add an attachment",
  5005: "You can customize the sharing permission, project optional permission and file access control permission of this enterprise file here. The permissions defined here will appear in the permission selection list of the above functions",
  5006: "search for the name of the file permission",
  5307: "The receiver is not set in this project, and it is not supported to send files temporarily. If you want to send files, please contact the project administrator",
  //----------------6.6-------------

  5007: "After the employee accounts deleted, its file of the account will be removed, do so with caution",
  5008: "invited to visit record",
  5009: "invited time",
  5010: "Personal Files ",
  5011: "Name",
  5012: "black background",
  5013: "white background",
  5014: "default background",
  5015: "rotation 90",
  5016: "Add Signature",
  5017: "Changing the background color is only effective for works with transparent background!",
  5018: "Do not prompt",
  5019: "Confirm to recove account - <strong> {-userName-} </ strong>?",
  5020: "Confirm to disable Account - <strong> {-userName-} </ strong>?",
  5021: "After setting a signature, you can preview your document for approval by using the signature",
  5022: "Please enter your signature in the following field and click on Save",
  5023: "Are you sure to delete this signature? ",
  5024: "The signature is already in use can not be deleted",
  5025: "signature currently in use",
  5026: "Use this",
  5027: "Update failed! ",
  5028: "Sharing Settings",
  5029: "drawn concern to the file ",
  5030: "File Properties",
  5031: "Add",
  5032: "file has been completely deleted",
  5033: "file deletion failed, please try again later",
  5034: "file has been restored to its original position",
  5035: "File restore failed, please try again later",
  5036: "The new version must be consistent with the old version of the file type",
  5037: "if a download file ",
  5038: "give up",
  5039: "opens in the {-type-}",
  5040: "Use browser to open",
  5041: "communication functions with a slightly top right ",
  // 5042: "This share is only allowed to invite users to access, please log in to your mailbox to receive an invitation! ",
  5042: "This file does not support anonymous access. Please log in",
  5043: "sharers have to close the current share, you can no longer browse the document!",
  5044: "Are you sure you want to quit share",
  5045: "The current number of more than 30 people selected, whether to continue",
  5046: "You are not authorized to view the member companies! ",
  5047: "Please enter a combination of 6-20 digits including upper and lower case letters and numbers",
  5048: "Your account has been frozen Enterprise Administrator",
  5049: "You have been out of business administrator of the enterprise",
  5050: "Sorry, {-str-}, click to confirm exit",
  5051: "The current network is not available, please check whether your network condition is normal",
  5052: "Anonymous users do not have access! ",
  5053: "Failed to move file",
  5054: "the destination folder does not support creating folders",
  5055: "create subfolders",
  5056: "Failed to load the file directory ",
  5057: "grouping delete failed",
  5058: "network does not seem clear, please refresh the page and try again",
  5059: "Free Preview does not support this type of file, if necessary, please upgrade version",
  5060: "Enter the password to open the PDF file. ",
  5061: "author",
  5062: "keywords",
  5063: "Date Modified",
  5064: "producer",
  5065: "pages",
  5066: "Preparing to print a document ...",
  5067: "Open file failed",
  5068: "File not allowed to access",
  5069: "does not support a preview of the file",
  5070: "Exit editor",
  5071: "delete the associated",
  5072: "Are you sure you want to delete this file associations do? ",
  5073: "lock fails, you can not edit, error code: ",
  5074: "approval to join",
  5075: "refused to join",
  5076: "Are you sure you delete the member",
  5077: "manager",
  5078: "(I)",
  5079: "Team description",
  5080: "not joined",
  5081: "awaiting approval",
  5082: "Unknown server error, please try again later",
  5083: "team name (less than 40 words)",
  5084: "team name can not be empty",
  5085: "Team description (less than 100 characters)",
  5086: "Update failed! ",
  5087: "Quit team",
  5088: "Delete failed, try again later",
  5089: "Update failed! ",
  5090: "not yet joined",
  5091: "picture there is an error, not normally open! ",
  5092: "show failed, the version has been removed",
  5093: "Note: The version you are currently viewing is not the latest version! ",
  5094: "annotation points have been deleted",
  5095: "Save hand-painted failed, please try again later",
  5096: "This will lead to exit the current studio, whether to exit the studio and continue? ",
  5097: "Close studio failed, please try again later",
  5098: "Quit studio failed, please try again later",
  5099: "Your browser session has expired, you need to log in again",
  5100: "user password is reset, click OK to exit",
  5101: "administrator has restricted the mac address you log in, click OK to exit",
  5102: "You have been force to logout, click OK to exit",
  5103: "Your account has been frozen, restore the account, please contact customer service, click OK to exit",
  5104: "Your login has expired, please login again",
  5105: "there is some connection failure, refresh the page just fine. ",
  5106: "refresh",
  5107: "join fails, team members have reached the limit! ",
  5108: "the contents of the file has been modified, select:",
  5109: "do not save",
  5110: "Enter the file contents",
  5111: "length",
  5112: "All",
  5113: "Your browser version is too low, it is recommended that you upgrade to IE11 and above",
  5114: "You need to sign",
  5115: "you want to delete this team? <br> This will automatically delete all its files, and can not be restored! ",
  5116: "you sure you want to leave this team? ",
  5117: "parameter error",
  5118: "Wait timeout",
  5119: "Unable to preview the file, please download View",
  5120: "Conversion failed, cannot display",
  5121: "This is an encrypted document. If you want to browse and edit, please download!",
  5122: "file is corrupt or incomplete information file, please download View",
  5123: "The file is too large to support generating previewable files temporarily",
  5124: "presentation is empty",
  5125: "An unknown error, please contact the administrator ",
  5126: "server is processing",
  5127: "This member limit the amount of personal space",
  5128: " This may be a member of the account is not limited in the amount of space occupied by the amount of available space within the range of department",
  5129: "This member department to set the amount of space available",
  5130: "This member has space",
  5131: "personal account space restrictions",
  5132: "sector of space limitations",
  5133: "There are no inboxes for you to drop in",
  5134: "You have not created Inbox",
  5135: "New password:",
  5136: "Confirm new password:",
  5137: "Confirm new password:",
  5138: "password",
  5139: "password modification fails",
  5140: "understanding of the identity of employees",
  5141: "Employees space constraints",
  5142: "is set equal to the value of occupied space, will not be able to upload new content",
  5143: "the use of rubber can not delete other people draw the line! ",
  5144: "The columns added here will be displayed in the workspace of each enterprise user",
  5145: "approval of the views Add",
  5146: "rectangle approval of the views",
  5147: "Round approval of the views",
  5148: "arrow approval of the views",
  5149: "Text approval of the views",
  5150: " Failed to download file ",
  5151: "has informed",
  5152: "to be received",
  5153: "I did a graphic mark, click below to see",
  5154: "message has been withdrawn",
  5155: "File upload failed",
  5156: "File Comments",
  5157: "Failed to download the document ",
  5158: "Click here to enter comment content",
  5159: "Text Search",
  5160: "Use the mouse to select text in a document establishing endorsement",
  5161: "fit",
  5162: "version of the list",
  5163: "Please use the micro-channel function of the upper right corner: Use a browser to open",
  5164: "a annotation",
  5165: "latest version",
  5166: "Current version",
  5167: "version of {-v-}",
  5168: "can not participate in the assessment Started",
  5169: "This person is already reviewers",
  5170: "approval progress",
  5171: "approval of an additional person",
  5172: "points here to go directly to the next stage of approval",
  5173: "the point where the end of the approval",
  5174: "dep. file manager",
  5175: "is not qualified 3D file format",
  5176: "operation fails, check the network connections",
  5177: "",
  5178: "",
  5179: "",
  5180: "",
  5181: "",
  5182: "packing folder, please wait",
  5183: "You have selected {-multiFilesCount-} + files，or  {-multiFilesSize-} + files, please use client",
  5184: "",
  5200: "Downloads Please enter a positive integer",
  5201: "Select project type",
  5202: "Creating a normal project",
  5203: "Create a DCC project",
  5204: "Create a separate project sharing space, assigned project members by the designated project manager, can invite other departments and even external users to join the work",
  5205: "It is specially designed for project document control management. The staff of document control can send documents to Party A and Party B. Every time the documents are sent, strict records will be kept and the sending list will be automatically generated, and the inquiry can be managed",
  5206: "DCC manager",
  5207: "Click Select Project Secretary",
  5208: "DCC members",
  5209: "Click to select staff of the company",
  5210: "Other members",
  5211: "Version No. rule",
  5212: "Input the prefix",
  5213: "Input the information that will be displayed on the TRANSMITTAL, such as contact information, address, phone number, etc.",
  5214: "Click to select other members",
  5215: "ABC alphabetical order",
  5216: "123 Number order",
  5217: "Recipient",
  5218: "Enter the recipient's name",
  5219: "input mailbox, english semicolons is uesd  to separate multiple mail boxes",
  5220: "Click on the input",
  5221: "TRANSMITTAL NO. Rule",
  5222: "Selective coding rule",
  5223: "1-2-3 numerical order",
  5224: "A-B-C alphabetical order",
  5225: "Example of date plus number: 20200123001",
  5226: "Enter text",
  5227: "null",
  5228: "The contractor",
  5229: "The party",
  5230: "New addition party",
  5231: "Create",
  5232: "Transmittals",
  5233: "Manage",
  5234: "Sync",
  5235: "Cancel the synchronization",
  5236: "Search for waybill number or sender",
  5237: "{-name-} Project file transfer list（TRANSMITTAL List）",
  5238: "There is no transmittal",
  5239: "No transmittal is qualified",
  5240: "Transmittal NO.",
  5241: "Receiving state",
  5242: "Did not receive",
  5243: "Have received",
  5244: "send again",
  5245: "Basic information",
  5246: "Basic Project Information",
  5247: "This project has a total of recipients {-num-} ",
  5248: "Manage",
  5249: "Members of the project",
  5250: "Set",
  // 'Manage the project leader',
  5251: "Add",
  // a project secretary
  5252: "Add",
  // the staff of the document control
  5253: "Add",
  // other member

  5254: "Project management of the company",
  5255: "Copy to",
  5256: "Submission File Type",
  5257: "ORIGINAL",
  5258: "COPY",
  5259: "TRANSPARENCY",
  5260: "LINEN",
  5261: "DOCUMENT NO.",
  5262: "DESCRIPTION",
  5263: "ACTION",
  5264: "Acknowledged by",
  5265: "Prepared & submitted by",
  5266: "Default is the sender",
  5267: "Enter the postscript in the message",
  5268: "Send files",
  5269: "Send files",
  5270: "For archiving",
  5271: "For reference",
  5272: "For the revision",
  5273: "For approval",
  5274: "Click Enter Description",
  5275: "Send a date",
  5276: "The attachment list",
  5277: "Transmittal",
  5278: "Export to PDF",
  5279: "Transmittal No.",
  5280: "waybill number",
  5281: "We are pleased to submit the following documents:",
  5282: "Prepared & submitted by",
  5283: "Sign & Stamp",
  5284: "Designation",
  5285: "transmittla info",
  5286: "File sending history",
  5287: "File sending history",
  5288: "Review the aging",
  5289: "version: {-ver-}",
  5290: "The date of the order",
  5291: "Type",
  5292: "Please enter correctly transmittal Number",
  5293: "Please enter a mailbox, separated by quotation marks",
  5294: "send successfully",
  5295: "If the documents have been sent successfully, would you please check the details of the documents TRANSMITTAL",
  5296: "Transmittal NO.",
  5297: "The sender",
  5298: "Sending date",
  5299: "Send a version",
  5300: "Version No.",
  5301: "view TRANSMITTAL",
  5302: "enter transmittal Number",
  5303: "files",
  5304: "viewed",
  5305: "Not viewed",
  5306: "files {-num-}, size {-size-}"
}, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, "5307", "There is no receiver set in this project, so sending files is not supported. If you need to send files, please contact the document control manager"), 5308, "001, 002 postponed"), 5309, "0001、0002 postponed"), 5310, "Please select a person"), 5311, "Format error, please enter the correct mailbox, delimited by quotation marks"), 5312, "REV."), 5313, "S/N"), 5314, "Online edit"), 5315, "The administrator"), 5316, "Restore all"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 5317, "Restore Current Folder"), 5318, "Permanently Delete Current Folder"), 5400, "click to join as prompted to log in please enter your user name password, if not registered Babel birds, please click on "), 5401, "enter the label name, and press Enter or click on the right button to select the tag label"), 5402, "Please enter a label name"), 5403, "Create Folder"), 5404, "Create file"), 5405, "You can not invite yourself to join to share"), 5406, "whether subfolders covering security level? "), 5407, "coverage"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 5408, "not covered"), 5409, ' "coverage" means If the confidentiality of the sub file is higher than this confidentiality, the sub file will use this confidentiality'), 5410, "The approval process has not been set yet"), 5411, "Document control project"), 5412, "Apply this setting for all subsequent files"), 5413, "Batch sets whether to allow selected users to have personal private files"), 5414, "Download our case study"), 5415, "Qr code has been copied to clipboard"), 5416, "Copy the QR code to the clipboard"), 5417, "Scan to open the connection"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 5418, "Please use the HTTPS protocol in Google Chrome to use this feature"), 5419, "select a document to be approved"), 5450, "request to send files to the following persons"), 5451, "file to be sent"), 5452, "view enterprise members and groups"), 5453, "the file no longer exists"), 5454, "select the synchronization mode of the folder"), 5455, "bidirectional synchronization mode"), 5456, "local and cloud files are consistent, local updates will be synchronized to the cloud, and cloud updates will be synchronized to the local"), 5457, "downlink synchronization mode"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 5458, "local updates will not be synchronized to the cloud, but cloud updates will be synchronized to the local"), 5459, "Global Default sort"), 5460, "After setting, all folders will use the selected sorting method as the default sorting, but after changing the sorting in different folder lists, the system will remember the last sorting method used"), 5461, "please wait patiently"), 5462, "Audit failed"), 5463, "Pending approval..."), 5464, "Confidential department personnel {-user-} want to join {-dep-} department share {-file-}, do you agree"), 5465, "Private sector personnel {-user-} want to add personal share {-file-}, do you agree?"), 5466, "Private sector {-user-} wants to join {-dep-} sector share {-file-}, do you agree"), 5467, "Private sector {-user-} wants to add private share {-file-}, do you agree? "), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 5468, "register enterprise Public Cloud edition"), 5469, "the personnel of the confidentiality Department {-user-} are joining the project {-file-} of the {-dep-} department, do you agree?"), 5470, "the personnel of the confidentiality Department {-user-} are joining the project {-file-}, do you agree?"), 5471, "The confidential Department {-user-} is joining the project {-file-} of {-dep-} department. Do you agree?"), 5472, "The confidential Department {-user-} is joining the project {-file-}. Do you agree?"), 5473, "getting preview data"), 5474, "You do not have permission to access this file"), 5475, "View only confidential approval records"), 5476, "You can revoke this approval and set it to"), 5500, "IP Policy List "), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 5501, "No customized IP policy for the enterprise "), 5502, "Applicable IP segment "), 5503, "Policy type "), 5504, "Add download policy "), 5505, "Give the policy a name for ease of use "), 5506, "Policy type "), 5507, "Download prohibited "), 5508, "Download allowed "), 5509, "Edit download policy "), 5510, "If you select Allow download, devices in the unexpected POLICY IP segment will not be able to download files after the policy takes effect "), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 5511, "Department personnel Strategy "), 5512, "Strategy "), 5513, "Please select policy "), 5514, "New policy "), 5515, "New Policy "), 5516, "Add IP"), 5517, "License "), 5518, "start IP"), 5519, "Terminate IP"), 5520, "priority "), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 5521, "scope of application"), 5522, "Permit authorization "), 5523, "Refuse authorization "), 5524, "Modifier "), 5525, "All members "), 5526, "Management "), 5527, "Ordinary Member "), 5528, "No department personnel policy at present "), 5529, "Example: 192.168.2.5"), 5530, "Example: 192.168.2.98"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 5531, "enter 1~ 100,1 is the highest priority "), 5532, "Please enter a positive integer from 1 to 100 "), 5533, "Please enter a valid IP address "), 5534, "IP policy already exists in this department "), 5535, "If you want to remove this policy, please delete the department using this policy first "), 5536, "File history version retention period "), 5537, "Setting 0 to permanently store history "), 5538, "Number of historical versions saved "), 5539, "Note: The number of versions of historical records can be freely changed to 1-999, 0 is permanent."), 5540, "Please enter version number "), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 5541, "Please add IP policy "), 5542, "This user is not allowed to download files at the current IP address "), 5543, "Online preview of this type of file is not supported in personal edition. Please upgrade to professional edition or enterprise edition for preview"), 5544, "Complaint "), 5545, "Display "), 5546, "Hide "), 5547, "Are you sure this share contains illegal information and would like to report this to the site manager? "), 5548, "Complaint successful "), 5549, "failed to obtain user information"), 5550, "Save to web disk "), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 5551, "If client is installed "), 5552, "If client is not installed "), 5553, "Enterprise Collaborative Web Disk"), 5554, "Download now "), 5555, "Download Babel Bird APP"), 5556, "direction"), 5557, "download and upload"), 5558, "This user is not allowed to upload files at the current IP address "), 5559, "Deleted"), 5560, "number of external collaborators 10"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 5561, "Unlimited number of external collaborators"), 5562, "Expires in {-day-} days"), 5563, "Expires in {-hour-} hours"), 5564, "Unlimited team users"), 5565, "Small team file sharing and collaboration, unlimited members"), 6000, "to be received"), 6001, "received"), 6002, "bounced"), 6003, "document processing"), 6004, "is received"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6005, "Return"), 6006, "Disposition"), 6007, "operator"), 6008, "document status"), 6009, "{-somebody-} received document {-file-}, along with the words: {-comment-}"), 6010, "{-somebody-} rejected articles {-file-}, along with the words: {-comment-}"), 6011, "finalization date"), 6012, "receives the Drop your {-file-}, along with the words: {-comment-}"), 6013, "rejected your vote member {-file-}, along with the words: {-comment-}"), 6014, "A new version was uploaded on {-file-} in the folder {-parent-}"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6015, "A new file uploaded in the  {-parent-}"), 6016, "access to the file list"), 6017, "download file list"), 6018, "The upload file list"), 6019, "annotation file list"), 6020, "review the file list"), 6021, "Inbox information"), 6022, "No menu available columns"), 6023, "View related documents"), 6024, "Correlation"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6025, "department members can customize the approval process and approver when opening approval"), 6026, "department members can choose  all approval processes which were preseted in the enterprise management background"), 6027, "select several approval processes as departments process"), 6028, "use the approval process settings used by the parent department"), 6029, "removing cards"), 6030, "project members set"), 6031, "Everyone within the project"), 6032, "All is not provided within the project additional permissions ordinary members"), 6033, "file permissions apply"), 6034, "apply for"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6035, "Management Recycle Bin"), 6036, "{-user-} invite you to participate in the project"), 6037, "Location"), 6038, "transfer"), 6039, "transferred to the project personnel"), 6040, "Select project leader"), 6041, "the comments made man"), 6042, "opinions description"), 6043, "Opinions treatment"), 6044, "review comments list"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6045, "approval of the views list"), 6046, "approval operation"), 6047, "submitted for approval"), 6048, "countersigned"), 6049, "approval documents "), 6050, "Dear user, your account space usage has reached {-per-} "), 6051, "Dear User, your enterprise space usage has reached {-per-}"), 6052, "back to the free version"), 6053, "Are you sure you want to downgrade to ordinary users? This will lead to reduce your space and enjoy the service! "), 6054, "share of personnel involved"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6055, "Rotate"), 6056, "Online Preview does not support the file is open with local application? "), 6057, "Delete fails, the server error"), 6058, "Confirm To disable external employees - {-name-} - account yet? "), 6059, "confirm the removal of external employees - {-name-} - account yet? "), 6060, "remove"), 6061, "You do not have permission to move files to the destination folder"), 6062, "PS"), 6063, "yet to join other teams"), 6064, "Add from favorites"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6065, "invitee phone input (Press Enter or Tab acknowledgment), one can add more"), 6066, "Please enter the phone"), 6067, "Co-publishing folder"), 6068, "If this option is selected, the joint publishing folder is displayed in the enterprise file channel of the enterprise owner. All enterprise members can upload files in this folder, and the super administrator has the permission to manage files"), 6069, "submitted"), 6070, "uncommitted"), 6071, "Total"), 6072, ""), 6073, "submission status"), 6074, "Receiving statistics"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6075, "No Drop"), 6076, "has been cast pieces"), 6077, "No Drop information"), 6078, "The current account login password is set yet, you can sign in by phone to verify the code, set the password. go with"), 6079, "re-login"), 6080, "Get invitation link address"), 6081, "Copy this link"), 6082, "Link copied to clipboard"), 6083, "issuing this link to register to the relevant personnel, Click here or login to join the team after application, after review by an administrator to successfully enter the team"), 6084, "Only enterprise security officer can set the file security policy of the enterprise"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6085, "{-sign-} of your {-typeStr-} - {-fileName-} of Application"), 6086, " Join {-type-}  {-file-}"), 6087, "Join {-type-}"), 6088, "Wait administrator audit"), 6089, "No permission to access the file, waiting for administrator review"), 6090, "Open Babel birds"), 6091, 'You can view the file in the "I joined to share" in the'), 6092, "yet set security policies"), "6092", "the head of departments"), 6093, "this link distributed to relevant personnel, click here to register or log in after application to join the project, you can if approved by the project leader"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6094, "team name"), 6095, "Name"), 6096, "Wait audit project leader"), 6097, "Project Manager "), 6098, "No permission to access the file, waiting for the audit project leader"), 6099, "The one {-file-} {-comment-} to {-finish-}"), 6100, "Share the link is down"), 6111, "approval of the name"), 6112, "File List"), 6113, "copying files"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6114, "Copy Complete"), 6115, "Show file copy progress"), 6116, "joined the project"), 6117, "The company did not purchase your approval module, this feature is temporarily unavailable"), 6118, "The company did not buy your privacy module, this feature is temporarily unavailable"), 6119, "The company did not purchase your archive module, this feature is temporarily unavailable"), 6120, "An invitation has been sent, please be patient feedback"), 6121, "enterprise Remarks"), 6122, "Modify the enterprise nickname"), 6123, "This operation is irreversible. Are you sure you want to delete this notice?"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6124, "&nbsp;invites you to join the enterprise &nbsp;"), 6125, "After Click here to join, you will join the company, you Personal Edition will be canceled, the original file is automatically transferred to this company"), 6126, "Babel birds do not support the uploading of hidden files"), 6127, "Under the current directory, you do not have permission to upload files"), 6128, "Click Add File description"), 6129, "click Add Imprint"), 6130, "You have selected 100 + files，please use the client to download them"), 6131, "(synchronous faster yo)"), 6132, "you select multiple folders, use the client to download"), 6133, "file list is empty"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6134, "invites you to join the company {-name-}"), 6135, "you can directly annotate the content of the file to the sharer "), 6136, "Double click the left mouse button where you want to comment"), 6137, "target company"), 6138, "invitation to join the enterprise"), 6139, " discussion group, the entire project items can be discussed here"), 6140, "Only security personnel can set the overall security policy of the enterprise or department，The security officer can approve all sharing requests"), 6141, ""), 6142, "{-somebody-} invited you to share {-file-}"), 6143, "Get approval information fails, the approval has been withdrawn"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6144, "The file size of this type exceeds {-size-} M, the number of lines or Excel or pages of more than 2000 not more than 600 support"), 6145, "file does not exist or has been damaged"), 6146, "After registering and logging in"), 6147, "{-somebody-} out of your share {-file-}"), 6148, "In the place you want to annotate annotate finger long press"), 6149, "The file is currently being edited or updated, and the preview is not the latest version"), 6150, "No setting"), 6151, "You do not have permission to add a link to the file sharing"), 6152, "For comments, please log in"), 6153, "After binding the mobile phone number, you can directly log in with the mobile phone number."), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6154, "skip"), 6156, "Dear users, thank you for trying our network disk system, which has delayed your time. You are welcome to leave your valuable comments and suggestions or the reasons for abandoning them"), 6157, "{-somebody-} invited you to join the project {-file-}"), 6158, "invited you to join the project {-file-}"), 6200, "Click"), 6201, "Set department approval process strategy"), 6202, "departmental file usage management"), 6203, "statistics department to share files"), 6204, "View and share the management of all open"), 6205, "Open to share the file list"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6206, "Open the file permissions"), 6207, "View and manage the department had set up a separate file permissions of files and folders"), 6208, "Open confidentiality file list"), 6209, "View and manage files with confidentiality set"), 6210, "Open file access log"), 6211, "View access log file sector"), 6212, "the use of members"), 6213, "Open use"), 6214, "View file usage of Sector Members"), 6215, "the department set up"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6216, "limit downloads"), 6217, "Set fails, enter the correct downloads"), 6218, "administrator bind mac address is not valid, it will be automatically filtered when binding"), 6219, "file line excessive number or the number of pages, we recommend using the client editing features open"), 6220, "downloads after setting, the same user within half an hour to download repetition, only calculated once"), 6221, "If it is newly uploaded files, please wait up to 30 minutes, until the server updates the full-text search index"), 6222, 'Due to policy reasons, Babel personal and professional versions do not support anonymous access to shared video files. You can sign up and log in to preview or download the video in the column "Shared To Me" '), 6223, "This is an encrypted document. If you want to browse and edit, please download"), 6224, "departmental file belonging to the department, file transfer ownership does not affect the department's files that users upload"), 6225, "The uploaded file in the department"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6226, "departmental file belonging to the department. Delete, disable users, file transfer does not affect the department files"), 6227, "Name can not be empty"), 6228, "or"), 6229, "Are you sure you want to delete the label? "), 6300, "Long press where you want to annotate annotate"), 6301, "Clear Local Cache"), 6302, "multi-file for approval "), 6310, "mobile terminal App"), 6311, "the current file name"), 6312, "After modifying the file name"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6313, " Apply to rename file"), 6314, " Apply to move files"), 6315, "archive, please wait"), 6316, "the current directory"), 6317, "destination directory"), 6318, 'Request to rename file {-file-} to "{-newName-}""'), 6319, '&nbsp;Request to move file {-file-} from "{-source-}" to "{-target-}"'), 6320, "&nbsp;{-sign-} your file rename request {-fileName-}"), 6321, "&nbsp;{-sign-} your request to  move the file {-fileName-}"), 6322, "&nbsp;{-sign-} your requests for files {-fileName-}"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6323, "The operation failed, the original directory has no such documents"), 6324, "business owners can not be deactivated"), 6325, "you can not disable your current login account"), 6326, "destination can not be the root directory"), 6327, "Attention"), 6328, "Allow anonymous access"), 6329, "Please enter at least 6 characters"), 6340, "snapshot sharing"), 6341, "The content of the snapshot share will remain at the time you created the snapshot link and will not be updated with the content of the file. The person who receives this link can use it to access the file at the time the snapshot was created. Multiple snapshots can be created."), 6342, "create"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6343, "You can click the button on the right to create a new file snapshot"), 6344, "Select file snapshot"), 6345, "File snapshot -- "), 6346, "Historical Snapshot "), 6347, "snapshot date"), 6348, "Delete this snapshot "), 6349, "Allows users to share private files by default "), 6350, "Filter files need to load all files, please wait "), 6351, "If the number of files in this directory is greater than 500, do you want to load all files immediately?"), 6352, "Load all files "), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6353, "Filter current file "), 6354, "Download speed limit "), 6355, "Maximum download rate "), 6356, "Note: The limit input 0 means that the download speed is not limited "), 6357, "Please enter a integer between 100 and 20480 "), 6358, "Enter the file name to filter and press enter to confirm"), 6359, "Sharing: "), 6360, "Snapshot Sharing: "), 6361, "Mind mapping"), 6362, "Hiding organizational structure"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6363, "When this option is turned on, all members of the enterprise cannot select enterprise members based on the organizational structure when sharing invitations, establishing projects, adding personnel, adding approvers, adding message recipients, adding senders, grouping personnel, or adding users from internal members to departments. However, they can be added by searching for user names, email addresses, or phone numbers. (This is not valid for administrators)"), 6364, "View uploaded files"), 6365, "Upload file list"), 6366, "You can enter user name / mobile number / email to search for members of the enterprise"), 6367, "Copy to clipboard"), 6368, "The picture has been copied to the clipboard"), 6369, "It only supports copying pictures under HTTPS protocol"), 6370, "Do not share files with external users"), 6371, "If this option is enabled, enterprise members cannot share files with external enterprise users or share files through links"), 6372, "Hide toolbar"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6373, "Show toolbar"), 6400, "Shortcut menu"), 6450, "The email has been registered as Babel Bird account"), 6451, "The phone has been registered as Babel Bird account"), 6552, "Monthly Upload"), 6553, "Upload the number"), 6554, "month"), 6555, "About Babelbird"), 6556, "Babelbird network disk"), 6557, "All Projects"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6558, "Traffic Statistics"), 6559, "Traffic Statistics (unit: MB)"), 6560, "Enterprise Release folder"), 6561, "If this option is selected, the enterprise release folder is displayed in the enterprise file channel of the enterprise owner. Only the super administrator, security guard, and archive administrator can upload files in this folder. The super administrator has file management rights"), 6562, "Disable The user automatically disables the enterprise file sharing link enabled by the user"), 6563, "If this option is enabled, deactivating a user  will automatically close the user's enterprise file sharing link. If this option is turned off, enterprise file sharing links opened by disabled users can still be used."), 6564, "Export the mind map"), 6565, "KityMinder format. (km)"), 6566, "Outline text (.txt)"), 6567, "Markdown/GFM format. (md)"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6568, "SVG Vector Diagram (.svg)"), 6569, "PNG image (PNG)"), 6570, "XMind format (. XMind)"), 6571, "The enterprise has a confidential department, do not allow anonymous upload files"), 6572, "Update failed because the mailbox already exists"), 6573, "The mailbox already exists"), 6574, "The mobile number already exists"), 6575, "Monthly upload statistics (unit: pieces)"), 6576, 'It is not allowed end of "."'), 6577, "Personal file sharing link accounts will be closed upon deactivation."), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6578, "Mobile phone number and email address cannot be empty at the same time"), 6579, "The administrator disables the access to the enterprise release folder, but the file directory fails to be obtained"), 6580, "Failed to obtain the file directory. Procedure"), 6581, "Are you sure to delete the role"), 6582, "File permissions name"), 6600, "Create from template"), 6601, "There is no template available at present."), 6602, "Create template"), 6603, "File template"), 6604, "Folder template"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6605, "The administrator can upload the template file (folder) in the Department under this folder"), 6606, "Create template"), 6607, "Upload template"), 6608, "There is no template available at present"), 6609, "Creation progress"), 6610, "Create the file"), 6611, "Complete"), 6612, "After turning off this option, all users will not be able to share files in their personal files and will not be able to create projects in their personal files"), 6613, "Flow statistics"), 6614, "Export traffic statistics report"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6615, ""), 6616, ""), 6617, ""), 6618, ""), 6619, ""), 6620, ""), 6621, ""), 6622, ""), 6623, ""), 6624, ""), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6625, ""), 6626, ""), 6627, ""), 6628, ""), 6629, ""), 6630, ""), 6631, ""), 6632, ""), 6633, ""), 6650, "Coding method"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6651, "Convert to project"), 6652, "Prohibit anonymous sharing"), 6653, "When this option is turned on, anonymous people are not allowed to access when sharing files through links"), 6654, "The enterprise has set that anonymous access is not allowed"), 6655, "Login expiration time"), 6656, "Note: entering 0 means that the browser will be invalid once the login is closed"), 6657, "Uploaded a new version {-file-} in your personal file"), 6658, "Uploaded a new file in your personal file"), 6659, "hour"), 6660, "Please enter a positive integer"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6700, "Illegal characters in file name"), 6701, "Number of used authorizations / number of authorizations : {-cur-}/{-count-}"), 6702, "Please select from the Department list"), 6703, "Click to register for Personal Edition"), 6704, "Please improve your enterprise information"), 6705, "Contact name"), 6706, "Contact email"), 6707, "Enter a secondary domain name as your enterprise's exclusive access address. It is recommended to use more than 4 English letters"), 6708, "Launch Babel Enterprise Edition"), 6750, "Start uploading"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6751, "Pause uploading"), 6752, "Paused"), 6753, "Download client"), 6754, "An error occurred in online editing. Failed to save the document. It has been automatically restored to the latest available document"), 6755, "After you agree to join the enterprise, you will become the enterprise user and cancel your original personal version"), 6756, "Ignore & retransmit"), 6757, "After the handover, the current project leader becomes a project Assistant"), 6758, "Ordinary members"), 6759, "Please select another encoding method and try to open it"), 6760, "The upper limit of personal private file space has been set successfully. \n {-number-} people in the enterprise have customized the space size. Do you want to modify the space size uniformly"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6761, "{-somebody-} invited you to join the project {-file-}"), 6762, "{-somebody-} invited the following people {-user-} to join the project {-file-}"), 6763, "The data has expired, please click the button again to export the list"), 6764, "Export exception, please contact the administrator"), 6765, "A log report is being exported. Please try again later"), 6766, "Log report Download succeeded"), 6767, "Log report downloading, please wait"), 6768, "Download complete"), 6800, "You can select a project member as the new project leader"), 6801, "There are no project members, please add project members before transferring the project"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6802, "The file size of this type exceeds {-size-} M, please download and open"), 6803, "There are no eligible project members, please change the search criteria"), 6804, "Local archive"), 6805, "The archived file remains in the current folder, and new versions cannot be uploaded. Keep the original permission of the file and do not need to borrow it when reading"), 6806, "Archived"), 6807, "You do not have permission to upload this file and cannot edit it online"), 6810, "Failed to generate preview file. Do you want to try again?"), 6811, "Retry"), 6812, "The project has expired, and ordinary project members can no longer access the project."), 6813, "Expired"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6814, "The file size of this type exceeds {-size-} M, please download and open"), 6815, "Clear all permissions of this account"), 6816, "Clear"), 6817, "After clearing, user can only access personal files. The opened sharing will be closed, and the user will also exit from the departments, groups, shares, and projects the user has joined"), 6818, "Are you sure you want to clear {-name-} account？"), 6819, "This operation is irreversible. All permissions of {-name-} will become invalid after clearing"), 6820, "Space proportion"), 6821, "Click to hide"), 6822, "Send file list"), 6823, "No sending file"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6824, ", 5 entries at most"), 6825, "Monitoring and warning"), 6826, "Enterprise monitoring list"), 6827, "Add monitoring item"), 6830, "The enterprise has not set monitoring items"), 6831, "Quantity limit"), 6832, "Failed to obtain monitoring information"), 6833, "Monitoring item"), 6834, "Are you sure you want to delete the current monitoring item?"), 6835, "duplicate upload"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6836, "The number of {-opType-} department files on the network disk exceeds the limit. Currently,  {-currentNum-} files {-operation-}, The set threshold is {-threshhold-}"), 6837, "More than 5 people, Cannot use the send file function"), 6838, "More than 5 files, Cannot use the send file function"), 6839, "Sending document control documents"), 6840, "Please select the receiver"), 6841, "Relevant files have been deleted, please contact the sender"), 6842, "Customize shortcut menu"), 6843, "Shortcut menu is displayed in the left column"), 6844, "Optional shortcut menu"), 6845, "This shortcut can be removed from the left column by double clicking, and can be sorted by dragging"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6846, "Add folder to shortcut menu"), 6847, "You can add this shortcut to the left column display by double clicking"), 6848, "No shortcut menu"), 6849, "No shortcut menu is available"), 6850, "Please select a folder"), 6851, "Please select a folder in the subdirectory"), 6852, "The file inherits the upper level access control"), 6853, "Up to 20 shortcut menus can be added"), 6854, "All monitoring items have been added"), 6855, "Transfer file configuration"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6856, "Receive port"), 6857, "Send port"), 6858, "Refill"), 6859, "{-somebody-} send {-file-} to {-targetNames-}"), 6860, 'Your mobile phone number has been registered with Babel. Are you sure you want to upgrade this account to the enterprise version? Select "Yes" to upgrade. This operation is irreversible and may cause data loss. Please pay attention to backup data. If you do not want to upgrade the account, please select "No" and change your phone number to register the enterprise version.'), 6861, "It is detected that your mobile phone number is already a Babel corporate user, please change your mobile phone number to register"), 6862, "More options"), 6863, "Clipping"), 6864, "Paste"), 6865, "Inbox only supports receiving {-str-} files"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6866, "Port description"), 6867, "Port number"), 6868, "Are you sure you want to delete the current port?"), 6869, "Port name"), 6870, "The name already exists"), 6871, "New"), 6872, "Please enter the port name and description"), 6873, "Receiver"), 6874, "Edit port"), 6875, "Create a new port"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6876, "Receiving personnel list"), 6877, "You can select the receiver of the mailbox here"), 6878, "No receiver"), 6879, "Add personnel"), 6880, "Are you sure you want to move this person out of the receiver?"), 6881, "Are you sure you want to move this department out of the receiver?"), 6882, "Click to display token"), 6883, "Sender name"), 6884, "Receiver name"), 6885, "Domain name of receiver"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6886, "e.g.: http://www.babel.cc "), 6887, "Receiver token"), 6888, "Sender"), 6889, "Send personnel list"), 6890, "Are you sure you want to move this person out of the sender?"), 6891, "Are you sure you want to move this department out of the sender?"), 6892, "No sender"), 6893, "Transfer file"), 6894, "You can select the configured port for file transfer"), 6895, "Submit the file {-fileName-} to the enterprise sending box {-identifier-} to apply for sending files, please"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6896, "Approve"), 6897, "The system inbox {-identifier-} received the file {-fileName-} sent to you,"), 6898, "Click here to view the details"), 6899, "Your request to send the file {-fileName-} through the enterprise sending box {-identifier-} has been approved by the administrator"), 6900, "The system inbox {-identifier-} received the file {-fileName-}, please"), 6901, "File {-fileName-} received from system inbox {-identifier-}, approved"), 6902, "The enterprise has no sending port or no port available to you. Please contact the administrator"), 6903, "Copying a folder to its subdirectory is not supported temporarily"), 6904, "Moving a folder to its subdirectory is not supported temporarily"), 6905, "Please enter the quantity limit"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6906, "folder"), 6907, "(The department is in the Trash)"), 6908, "Download to:"), 6909, "Browse"), 6910, "Set as default path"), 6911, "Empty end date"), 6912, "Not receiving notifications by default"), 6913, "When this option is enabled, the system turns off user push notifications by default. If users need to receive notifications, they can open the types of notifications they want to receive in settings"), 6914, "Copy link address"), 6915, "Link copied"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 6916, "Use the client to access sharing links"), 6917, " Pass"), 6918, " Reject"), 7000, "file can not be transferred within the same members, select members of other targets"), 7001, "Your card is too old, the current browser can not drive"), 7002, "You can try an older version of the browser or upgrade the video card"), 7003, "Your browser version is too low"), 7004, "Please use the latest version"), 7005, "Dear User, Enterprise Edition service from your deadline"), 7006, "Dear user, your Enterprise service has expired, if necessary, please contact customer service, we will be happy to serve you. "), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7007, "fewer than"), 7008, "hours"), 7009, "days"), 7010, " In order not to affect your usage, please contact customer service as soon as possible for hope! "), 7011, "and not found&nbsp;"), 7012, "&nbsp;matching query"), 7013, "custom folders"), 7014, "approval of the views created successfully"), 7015, "error message format"), 7016, "Wrong-mail or phone number"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7017, "uncheck restrictions"), 7018, "the department"), 7019, "departments deletion failed, please try again"), 7020, "maximum space limit "), 7021, "Set the space"), 7022, "Enter maximum space value (Unit: G)"), 7023, "no limit"), 7024, "Upload business logo"), 7025, "logo preview"), 7026, "Please add a postscript"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7027, "Network error, please try again later "), 7028, "This person already belongs to {-name-} enterprise, invite the officer to exit the business"), 7029, "This user has registered，you can send an invitation to him. After the user agrees, he can automatically join the enterprise"), 7030, "Send invitation"), 7031, "can not be sent in one hour"), 7032, "The server returned an error "), 7033, "disabled users"), 7034, "not provided"), 7035, "foundation"), 7036, "archive"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7037, "notification"), 7038, "Phase 1"), 7039, "not registered"), 7040, "Never logged in"), 7041, "Free 30-day trial"), 7042, "do not have access"), 7043, "You do not have permission to open the source file"), 7044, "Pictures"), 7045, "office document"), 7046, "Adobe document"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7047, "CAD files"), 7048, "Other"), 7049, "all the time"), 7050, "within 3 days"), 7051, "within 1 week"), 7052, "within 1 month"), 7053, "Within 6 months"), 7054, "full size"), 7055, "0 ~ 100 bytes"), 7056, "100 byte ~ 1K"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7057, "10G above"), 7058, "The voice annotation does not exist"), 7059, " tag"), 7060, "marked with graphics (see separate)"), 7061, "uploaded files (see separate)"), 7062, "version history"), 7063, "Old"), 7064, "adoption"), 7065, "like"), 7066, "You are not logged in, you need to log in"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7067, "to register"), 7068, "No account"), 7069, "login prompt"), 7070, "After setting the mailbox can receive mail file sharing-related notice, the proposed <br> immediately open the personal settings interface to bind the mailbox"), 7071, "Open your personal settings"), 7072, "later"), 7073, "birds do not use the guide bar"), 7074, "Thank you for using Babel birds, we guide you how to quickly use"), 7075, "Click the Create button, you can upload files or create folders"), 7076, "Here you can view all the files and folders you create"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7077, "department Folder"), 7078, "You can view the files department here"), 7079, "Here you can view and manage all you create or join a team"), 7080, "Here you can view and manage all your shared files or folders out"), 7081, "Here you can view and manage all share the file or folder you join"), 7082, "Add all concerned documents will appear in this"), 7083, "You need to manage the submission of contributions or local"), 7084, "document approval"), 7085, "Your approval documents will be displayed in this"), 7086, "All deleted files are temporarily stored in the Recycle Bin"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7087, "Navigation"), 7088, "here may switch <em> File </ em>, <em> dynamic </ em>"), 7089, "function button"), 7090, "You can see the file details on this or sort the files"), 7091, "Use boot"), 7092, "Welcome to Babel birds for document annotation! The following are introduced one by one to the main tool "), 7093, "annotation point list"), 7094, "You can view all the annotation points in the document"), 7095, "Click view file navigation chart - you can see all documents in the same folder"), 7096, "rotating current document"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7097, "Select the file or version compared with the current file"), 7098, "Online Print this file"), 7099, "You can share documents to others"), 7100, "View document version history"), 7101, "download file"), 7102, "annotation display control"), 7103, "hide, show comment"), 7104, "full-screen display of the current page"), 7105, "Click avatar to select"), 7106, ", you can enter the enterprise management background to manage the departments and personnel of the enterprise and make the required configuration."), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7107, "You have no right to reply"), 7108, "You have no right to reply, reply please login"), 7109, "general comment"), 7110, "Geometry annotation"), 7111, "word mark"), 7112, "annotation content is empty, you can not send"), 7113, "Enter text"), 7114, "Download iOS App"), 7115, "Babel birds to participate in the discussion"), 7116, "Enter"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7117, "send new message"), 7118, "No file (folder)"), 7119, "Tip: Recycle Bin reserved file (folder) within 10 days for you to delete"), 7120, "Open the following schematic operation"), 7121, "Babel Birds App"), 7122, "Step 1"), 7123, 'top right, click "More" button'), 7124, "Step 2"), 7125, "Open selected by Safari"), 7126, "opens in the App"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7127, "Click here to fill postscript"), 7128, "set up a "), 7129, '. Please fill in the postscript information, or click the "Join" button to join this '), 7130, "added"), 7131, "Through the dynamic, you can learn all about your collaborators and {-str-}, and quickly enter the discussion document"), 7132, "Reply to success"), 7133, "You do not have permission to reply"), 7134, "reply fails, the file has been deleted! "), 7135, "reply failed comment has been deleted! "), 7136, "reply failed, please try again later"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7137, "reply fails, you do not have permission to view the version where the annotation"), 7138, "reply fails, the file has been deleted! "), 7139, "reply failed"), 7140, "review success"), 7141, "You do not have permission to comment"), 7142, "review failed, please try again later"), 7143, "Your browser does not support HTML5 video tag"), 7144, "Downloading"), 7145, "unsaved data"), 7146, "Your edit data stored in the server is not completely"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7147, "Close to continue"), 7148, "Telephone"), 7149, "Press ⌘ + C Link "), 7150, "Please press Ctrl + C to copy the link"), 7151, "weld site"), 7152, "around the weld"), 7153, "File name"), 7154, 'on <b id = "fileNo" class = "top"> 0 </ b> files, total <b id = "fileCount" class = "top"> 100 </ b> files'), 7155, "The operation failed, please try again later"), 7156, "near the end of the approval of this document, you want to set the approval status of the file:"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7157, "does not start approval (approval delete the existing record"), 7158, "list is empty"), 7159, "filtered existing approver"), 7160, "No new version of the file can not be opened approval"), 7161, "View Reports"), 7162, "No new version of the file can not be opened approval"), 7163, "Show approval list"), 7164, "filter from the current user preset list"), 7165, "originator can not be involved in the assessment, deleted"), 7166, "click refresh"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7167, "Select the destination folders"), 7168, "move to"), 7169, "the currently selected file is included in the folder inside"), 7170, "the currently selected file is contained in the folder"), 7171, "File move failed, please try again shut down file-sharing"), 7172, "File successfully moved"), 7173, "upload"), 7174, "is concerned"), 7175, "You do not belong to any department, any department or do not have permission to view the document"), 7176, "anonymous visitors"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7177, "I share the participants"), 7178, " document participants"), 7179, "No access to records"), 7180, "summary statistics"), 7181, "locked"), 7182, "the log file is empty"), 7183, "workload statistics"), 7184, "No packet art"), 7185, "public packet is empty"), 7186, "individual packets is empty"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7187, "participating share"), 7188, "Access record"), 7189, "Expand"), 7190, "No workers"), 7191, "search tag"), 7192, "You have not joined other file sharing"), 7193, "Note: All share links you've visited in the file (folder) appears here"), 7194, "Sorry, can not find a file or folder with a selection label"), 7195, "Make sure"), 7196, "added team members"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7197, "Please select target path"), 7198, "file name can not be empty"), 7199, "file name can not be more than 100 characters"), 7200, "select a destination folder"), 7201, "the gray folders are folders without upload permissions"), 7202, "large files, use multiple file synchronization client"), 7203, "full-featured client has"), 7204, "real-time synchronization"), 7205, "push message"), 7206, "Upload Folder"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7207, "other powerful features"), 7208, "Download for Windows"), 7209, "download for Mac"), 7210, "After downloaded, please open the client to use the function"), 7211, "To purchase office online collaborative editing authorization, please contact customer service"), 7212, "This feature is only supported in the client"), 7213, "Your memory is full, you can delete the unused portion of the file, or click the button below to purchase with more storage space"), 7214, ""), 7215, "extended storage space"), 7216, "is full"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7217, "Someone is editing this file on the web page. You can select \"online editing\" in the menu to join the collaborative editing"), 7218, "service permissions error of judgment"), 7219, " file(s)/folder(s)"), 7220, "Dislike"), 7221, "small"), 7222, "middle"), 7223, "large"), 7224, "standard"), 7225, "simple"), 7226, "R"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7227, "This is your invite others to participate in the share"), 7228, "I invite"), 7229, "Set file access control"), 7230, "Confidential files"), 7231, "Restricted files"), 7232, "Internal files"), 7233, "external file does not belong to the current business, is the file you add people outside companies to share or teams, etc."), 7234, "You have been concerned about this file, you want to cancel concern? "), 7235, "Stay tuned"), 7236, 'Displayed in "R" is the file remarks. The file remarks can help you mark the file. You can modify the remarks for any file you have edit permission in the file property panel'), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7237, "do you want to cancel this top? "), 7238, "remains sticky"), 7239, "file is locked by {-userName-}"), 7240, "Other people need to wait for the editor to complete the locked state can relieve"), 7241, "file is locked, you want to unlock it? "), 7242, "Note: forced to unlock the lock may cause people to upload the edited version with the version of other people from overwriting each other resulting in the loss of version"), 7243, "unlock"), 7244, "Close"), 7245, "The file has been locked, you can not edit"), 7246, "At the bottom of the list"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7247, "Watch Date"), 7248, "foreign business contacts"), 7249, "departments are viewing files as administrator"), 7250, "being viewed as an administrator {-user-} files"), 7251, "After the upgrade to Professional Edition, the current account enjoyed functional free version, will receive the upgrade:"), 7252, "account of space expanded to 1TB"), 7253, "packages available capacity for more space"), 7254, "Single File Versioning limited"), 7255, "New Any number of teams"), 7256, "unlimited CAD file preview"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7257, "Unlimited Preview 3D file"), 7258, "Share tab"), 7259, "document collaboration"), 7260, "Learn Professional Edition"), 7261, "Copy progress"), 7262, "Please enter a new name"), 7263, "People like too"), 7264, "You are not concerned about the file (folder)"), 7265, 'Tip: You can follow the file in the "All Files" (Folder)'), 7266, "You have not shared the file (folder)"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7267, 'Tip: You can share files in the "All Files" (Folder)'), 7268, "Add people"), 7269, "Creating a project is complete, add people"), 7270, "Get Permissions list failed"), 7271, "The application status has changed, please refresh the view"), 7272, "document relationship diagram"), 7273, "you have not recently accessed files"), 7274, "Tip: You recently opened files will appear here"), 7275, "Add Card"), 7276, "No company outsiders"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7277, "You are not authorized to view a list of people outside the enterprise! "), 7278, "No outside person or company not authorized to view"), 7279, "file address:"), 7280, 'The person you add here will get the right to access the file. If the other party is a registered user of Babel, the file will automatically appear in the "Share I joined" column of the other party. Whether registered or not, they will receive email or SMS notification, and the system will conduct security verification according to the email or mobile phone number of the person you added to ensure that the person is your designated visitor'), 7281, "Click the button below to open the link to share, you will get a link address, you can use this link address to spread via e-mail or QQ and other third-party means of communication, access to staff this link, that link can access the file. In order to increase privacy, you can set a password, and you can also set a deadline, and the expired link will automatically expire"), 7282, "list of invitees"), 7283, "link address"), 7284, "The access address of this file is restricted to authorized personnel only"), 7285, "Send link"), 7286, "external users"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7287, "View Log"), 7288, "Remove this user"), 7289, "send this link by email or SMS"), 7290, "Immediately send the link"), 7291, "file address:"), 7292, "members of the authority table"), 7293, "request to invite users to share files "), 7294, "invited to share"), 7295, "link sharing"), 7296, "Get Permissions list failed"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7297, "label filtering"), 7298, "You have not created or joined a team"), 7299, "Unknown error, please try again later"), 7300, "files retain up to 10 days"), 7301, "dynamic search, press Enter to confirm"), 7302, "password 1-20 letters, numbers"), 7303, "not joined department"), 7304, "there is no discussion groups"), 7305, "Profile is modified "), 7306, "Create a folder"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7307, "invitation to participate in the discussion"), 7308, "System Message"), 7309, "failure to increase members"), 7310, "input invitees mail address, separated by commas (or press Enter to confirm), the transmission time up to 10"), 7311, "Enter the phone number or e-mail invitees"), 7312, "Enter the e-mail address and phone number invitees"), 7313, "added <em> {-num-} </ em> a"), 7314, "invitation sent successfully"), 7315, "I am not a member of the enterprise"), 7316, "has joined"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7317, "invitation has failed"), 7318, "teams to create success. "), 7319, "phone number changed successfully"), 7320, "mailbox modifications success"), 7321, "I'm sorry, Babel birds free version can only create two teams, to create a more team, please upgrade to the Professional Edition"), 7322, "Account Settings"), 7323, "resend "), 7324, "Please fill your mailbox to send the Guard code"), 7325, "Please fill in your phone to send the Guard code"), 7326, "The new phone is registered accounts can be verified by phone to complete the initialization code password"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7327, "Please fill in your {-type-} to send the Guard code"), 7328, "Remove tag"), 7329, "label filtering"), 7330, "label delete failed"), 7331, "Label modified successfully"), 7332, "references "), 7333, "Team name:"), 7334, "team name (40 words or less)"), 7335, "Team description:"), 7336, "description of the team, less than 100 words. "), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7337, "The team name already exists"), 7338, "name is available,"), 7339, "team name is too long"), 7340, "creation"), 7341, "Please enter a team name"), 7342, "team name can not be more than 40 characters"), 7343, "not more than 100 characters Description"), 7344, "You have not created a team"), 7345, "Note: After you create a team, you can add the relevant corporate officers as team members"), 7346, "Note: After you create a team, you can add the relevant corporate officers as team members"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7347, "You have not joined a team"), 7348, "I am not a member of the enterprise"), 7349, "has joined"), 7350, "Failed to add "), 7351, "invitation has failed"), 7352, "No member <br> not for sale! "), 7353, "was not created team"), 7354, "I joined the team"), 7355, "has joined"), 7356, "The team match is not found"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7357, "The point data annotation errors! "), 7358, "Note: You have to switch to the version of history"), 7359, "has switched to the current version! "), 7360, "Downloading ..."), 7361, "format"), 7362, "Please enter your password synergy"), 7363, "next page"), 7364, "previous page"), 7365, "Turn right"), 7366, "left turn"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7367, "abnormal network link, check the network! "), 7368, "No permission to delete"), 7369, "annotation point data error! "), 7370, "Get display file error! "), 7371, "File {-fileName-} - print preparation "), 7372, "your file"), 7373, "! Failed documents with a password, remove the password and try again!"), 7374, "document conversion failed"), 7375, "Save file failed"), 7376, "network busy, try again later! "), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7377, "An unknown error"), 7378, "network error or server error! "), 7379, "network connection error"), 7380, "Invitation failed, invite the largest free version limited to 30 people are welcome to upgrade to the unlimited Pro! "), 7381, "failed to send the largest number of people to send free version limited to 30 people are welcome to upgrade to the unlimited Pro! "), 7382, "Please wait ..."), 7383, "Enter the file name"), 7384, "Please enter a file name ..."), 7385, "more"), 7386, "Related files"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7387, "other login:"), 7388, "nickname can not be empty"), 7389, "nickname is not correct"), 7390, "Please enter a 6-20 digit combination of upper and lower case letters and numbers"), 7391, "password can not be empty"), 7392, "Please enter a 6-20 digit combination of upper and lower case letters and numbers"), 7393, "nickname does not exist"), 7394, "wrong password"), 7395, "E-mail format is incorrect"), 7396, "E-mail can not be empty"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7397, "image Guard code can not be empty"), 7398, "image Guard code error"), 7399, "mailbox does not exist"), 7400, "passwords do not match"), 7401, "passwords do not match"), 7402, "phone number can not be empty"), 7403, "phone number format error"), 7404, "phone Guard code can not be empty"), 7405, "Error codes"), 7406, "Please enter mailbox or phone number"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7407, "phone number is not yet bound"), 7408, "user does not exist"), 7409, "Code expired"), 7410, "This account has been frozen, banned from"), 7411, "E-mail or phone number format error"), 7412, "Please enter registered mailbox or phone number"), 7413, "Error codes"), 7414, "codes can not be empty"), 7415, "You are not the business users"), 7416, "Please select identity"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7417, "Enter the company name"), 7418, "Please enter the contact name"), 7419, "Please enter the contact email"), 7420, "Please enter the domain name"), 7421, "company name can not be all digital"), 7422, "only supports input letters and numbers"), 7423, "Please enter a 6-20 digit combination of upper and lower case letters and numbers"), 7424, "Forget Password"), 7425, "Please fill in your registered mail or cell-phone number"), 7426, "Get a new Guard code to reset the password"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7427, "password has been set"), 7428, "Did not receive the email to get the Guard code?"), 7429, "Check-mail address is correct"), 7430, "Check your mail trash"), 7431, "It may be that our mail system is busy or out of order. Please try again later"), 7432, "If you have not received the confirmation, please try sending it again"), 7433, "Enter the new password"), 7434, "Confirm New Password"), 7435, "file(s)"), 7436, "folder(s)"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7437, "Failed to send. Please confirm email address or mobile phone number and try again"), 7438, "role"), 7439, "team"), 7440, "Are you sure you want to delete the selected file? The deleted file cannot be recovered"), 7441, 'It is detected that you are not logged in, please <a class="link" href="/account/login.do">login</a>'), 7442, "The link you visited does not exist or the file has been unshared"), 7443, "You can do it:"), 7444, "Back to home page:"), 7445, "Return to previous page:"), 7446, "Now join Babel"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7447, "Open enterprise cloud office with high efficiency"), 7448, "Open enterprise cloud office with high efficiency"), 7449, "Babel is a registered trademark of Shanghai Huaqing Information Technology Co., Ltd. Shanghai Huaqing was founded in 2012, headquartered in Shanghai and set up a branch in Beijing in 2016. Babel is a technology led team. Its founders are all from founder of Peking University and have strong graphics and image technology of domestic entrepreneurial team. At present, Babel has completed a round of investment, the number of users is close to 400000, and the amount of document data has exceeded 1000tb."), 7450, "The painstaking efforts in the field of graphics and images, the unremitting exploration of efficient working methods, and the ultimate pursuit of product user experience have created the Babel knowledge management platform. You can use Babel to store and manage working documents, quickly share enterprise knowledge, and directly collaborate on various formats of documents through any device."), 7451, "The story of Babel bird"), 7452, "The name of Babel bird comes from the Babel Tower in the Bible. It is said that ancient human beings had the same language, the same ideas and the same values. Therefore, human beings were so powerful that they could gather the strength of all human beings to build a towering tower in Babylon, Cuba. The tower grew higher and higher. God felt the concerted efforts of human beings and united to challenge his authority, so he pushed down the tower of Babel Human beings speak different languages and produce different ideas. Since then, human beings have fallen into the chaos and endless war caused by the inconsistency of ideas, and there is no way to build a tower. Babel bird is a kind of bird which is responsible for communicating all aspects in the construction process of Babel Tower. It can quickly convey all kinds of cooperation details in the huge project of Babel Tower. Now, Babel has come back to life. It exists on the Internet. It makes us communicate more closely and makes us stronger."), 7453, "Company profile"), 7454, "Customer service hotline"), 7455, "Company address"), 7456, "corporate name：上海画擎信息科技有限公司"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7457, "Address: 上海市嘉定区平城路1055号"), 7458, "Postcode:201821 "), 7459, "Tel：400-9204020（8:00 ～ 20:00）"), 7460, "Media and promotion, complaints and suggestions"), 7461, "Contacts：皇甫珊欣"), 7462, "Phone：13564686107"), 7463, "wechat number：MolaSync"), 7464, "Product bug and improvement suggestions"), 7465, "E-mail： support@molasync.com"), 7466, "QQ: 512728617"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7467, "Training and consultation"), 7468, "Contacts： 张拥军"), 7469, "Phone：13261256900"), 7470, "wechat number：zhangyjluck"), 7471, "unzip All"), 7472, "unzip to"), 7473, "unzip"), 7474, "Watermark color"), 7475, "Preview file has not been generated successfully! Please click again in a minute to try!"), 7476, "Shanghai Headquarters"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7477, "Address: 7F, Building 8, No.4 Xinye Future Center, Lane 762 Huancheng Road, Shanghai"), 7478, "Shanghai R&D Center"), 7479, "Address: 1801, No.488 South Wuning Road, Shanghai"), 7480, "Tel: 13584686107"), 7481, "Beijing Branch"), 7482, "Address: Zone B, 3Q Galaxy SOHO, Chaoyangmen, Dongcheng District, Beijing"), 7483, "Chengdu Branch"), 7484, "Address: 9F, Tower C, Guanghua Center, Qingyang District, Chengdu"), 7485, "Contact: Wang Yujie"), 7486, "Tel: 13982493667"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7487, "BabelBird (Hong Kong) International"), 7488, "Address: 8F, Tower 2, Admiralty Centre, No.18 Harcourt Road, Central & Western District, Hong Kong SAR"), 7489, "Contact: Shi Yunqing"), 7490, "Tel: 852-69968224"), 7500, "Cannot upload more than 100 files in one action, Please try Folder Synchronizer in App Client！"), 7501, "You can change the security level in file property panel."), 7502, "The so-called private file refers to the file that is not placed in the department or the publish folder of the enterprise. This kind of file belongs to the personal private, which can not be seen or accessed by others"), 7503, "This is a required field"), 7504, "You can enter up to {0} characters"), 7505, "Please enter a number"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7506, 'The file name cannot contain any of the following characters:  \\ / : * ? " < > |'), 7507, "MAC address format error"), 7508, "Please fill in the correct mobile phone number"), 7509, "Please fill in the correct telephone number"), 7510, "Please fill in Chinese"), 7511, "Please fill in the correct postcode"), 7512, "The user name must be a 2-20 bit string"), 7513, "Please enter a combination of 6-20 digits including upper and lower case letters and numbers"), 7514, "Please fill in the correct letters"), 7515, "Role name"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7516, "This is a required option"), 7517, "The approval personnel cannot be the current user"), 7518, "Please enter a valid date"), 7519, "Do not move files across enterprises!"), 7520, "{-somebody-} moved {-file-} into the folder {-folder-}"), 7521, "{-somebody-} sets the access rights of {-file-} to {-role-}"), 7522, " shared the document {-file-} with you"), 7523, "signature"), 7524, "The destination folder owner does not have enough space"), 7525, "Contains sub items, cannot be deleted"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 7526, "The message has been deleted"), 7527, "The enterprise owner must be an administrator"), 8000, "customize yours Babel birds"), 8001, "core business services is a service business, in order to provide more detailed services to businesses. We launched Babel birds custom development. Help enterprises to lift the limitations of standardized products, a substantial increase in productivity "), 8002, "contact us"), 8003, "From product design products to help you start thinking"), 8004, "Different industries have different work processes and habits, needs and at the same time among the final product often separated by a deep chasm. Only demand does not tend to make a good product design project delays in landing. In order to better apply to your usage scenario, our professional product manager led Babel care team for your business to customize your own solutions and secondary development support. "), 8005, "strong research and development"), 8006, "We have a 10-person team to support custom development, the core R & D staff members are mainly birds of Babel system. From Peking University, Jiaotong University, and Chengdu University of Technology. We support a variety of languages ​​and custom development work for various platforms. In the database, cloud computing, graphics and video aspects it has its own core technologies, especially good at arithmetic. It has a large R & D experience in various types of systems. "), 8007, "When fine estimation management"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8008, "We have worked at Founder's fine when assessed management system, to manage the development of an accurate assessment, improve project success rate and efficiency of landing. Clear and well documented when the project is estimated to effectively reduce business costs and improve efficiency. "), 8009, "transparent project follow-up and acceptance"), 8010, "At every stage of the project, we have a full-time project manager and product manager for follow-up. Ensure project progress and acceptance criteria. And we can open our jira (project management tool) to you, so you always know the progress and time-consuming project. "), 8011, "transparent, professional, responsible"), 8012, "responsibility is to our customers the most and the highest rating. In the project maintenance period, we will be standing business point of view, the corresponding bug fixes and timely completion adjustments. To provide enterprises with long-term sustainable maintenance services. "), 8013, " Babel birds custom development system to solve the problems we automatically submit visa documents and unified management now, visa materials submitted by the user can be a safe and orderly unified management and rapid inquiry in our system..  "), 8014, "They are using our custom system"), 8015, "Let's all-powerful integration"), 8016, "online consultation"), 8017, "Download API documentation"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8018, "no need to reinvent the wheel "), 8019, "We have entered the era of open platform. Use Babel birds API, you can use Babel birds in your system almost all abilities. And build custom applications and integration in the cloud, without having to build and maintain their own content management services. Meanwhile, Babel birds can also be integrated with electronic signatures, advanced CAD management, office, character recognition pattern recognition and other third-party services to address the needs of your issue. "), 8020, "interfaces of a system-wide"), 8021, "Babel almost all the features of the bird can be called through the API interface, with a single sign-on can quickly integrate. Our development team can also provide technical support to help you quickly docking Babel birds. Allows sharing of digital information easy, and provides a safe way for your customers and team to directly access your own custom applications, annotate, share and collaborate on content. "), 8022, "The productivity and collaboration in the first place "), 8023, "work tends to expand around the document to the document management integration for the entry of various products that you can not or frequent switching software platform seamlessly enjoy all kinds of SAAS services. Babel birds can access on demand only office, Evermore office, office365, cad, iWork, Rhino 3D, Hao Chen CAD, days Rui Green Shield productivity suite and other large applications. So you do in between each application copy files, switch accounts to meet the collaboration and editing needs. "), 8024, "a commercial license"), 8025, "I want to offer your customers a greater variety of services? Secure content storage management, data show sales, offer management contracts, agency document management, knowledge management, archive, annotate discussion system ... using Babel birds commercial license service, your business can Babel birds on the basis of the system develop their own business applications and sales (support privatization), allow enterprises to quickly have a cloud service offerings. "), 8026, " We combine the basis of Babel birds on Evermore office launched Evermore Youyun let our online office system with enterprise-class document management capabilities, available to our customers better than office365 corporate office solutions. . "), 8027, "now begin to integrate Babel birds to your system"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8029, "tailored for the enterprise"), 8030, "to the technical application, Zhihanggeyi"), 8031, "file storage"), 8032, "collaboration and editing"), 8033, "mobile office"), 8034, "enterprise back-office"), 8035, "Data security"), 8036, "strong and advanced file storage system"), 8037, "Help you quickly build a cloud working environment"), 8038, "Use of Babel Bird file storage system of the client (Mac, windows) and APP (Android, iOS), you can quickly and other functional teams and enterprises build file-sharing environment, and the working file synchronization to you and you each device colleagues, teams and individuals to ensure that the work content at any time up to date. You can put Babel birds client as your work entrance, open cloud file on the client directly edited and saved to the cloud. Your colleagues new and updated files you can also receive the first time and discussed on Babel birds. From then on, your data files will be properly stored in the cloud, you and your co-worker file folder contents will be consistent, and you can use full-text search to quickly find the files you need. "), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8039, "Click here to download the Excel version of the detailed feature list"), 8040, "File Storage detailed feature list"), 8041, "cross-platform, multi-terminal"), 8042, "PC, MAC, mobile phones and tablet clients, H5 web version"), 8043, "automatic backup, synchronize"), 8044, "specify any folder bidirectional synchronization (cloud-to-local, local to the cloud) <br> support real-time synchronization, manual synchronization with the Synchronization Manager <br> version control solution to the conflict"), 8045, "fast transfer of files point to point"), 8046, "the right mouse button to quickly send a file to any local user"), 8047, "transfer large files in seconds"), 8048, "the same content transfer large files quickly seconds"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8049, "HTTP"), 8050, "network outages may continue to re-connect the original schedule transmission"), 8051, "Enhanced file management"), 8052, "preview icon, multi-dimensional sort, drag upload, file attributes, top, copy move delete, lock ... ..."), 8053, "tree"), 8054, "support tree displays files and folders, similar to the Explorer and the visit of experience"), 8055, "Log file"), 8056, "can a single view any log files, all log files to understand the life cycle"), 8057, "access statistics"), 8058, "Open the file number, the number of visits, number of downloads, number of comments, visitor list"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8059, "CDN acceleration and network optimization"), 8060, "anywhere in the world are adapting nearest node to quickly open"), 8061, "Online Preview"), 8062, "support nearly 200 online preview format, in addition to general office documents and image files, support for Apple office (iWork) and 3D models, vector design draft, CAD artwork, PSD, AI and other specialized formats. Support for audio and video files online play "), 8063, "File Lock"), 8064, "you are editing files automatically locked, others can not be edited. You can also manually lock a file, preventing others from tampering "), 8065, "oversized pictures online preview"), 8066, "5K 10K big picture even directly open the original online preview. patented technology"), 8067, "endorsement online discussion"), 8068, "can annotate directly on the file preview, painted circle, even voice content discussion paper"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8069, "online edit"), 8070, "online editing and collaborative editing of documents, at the end app can also edit online"), 8071, "Local editing automatically upload"), 8072, "support direct calls a local program to edit files online, automatically upload the edited result"), 8073, "documents concern"), 8074, "can remind corporate members are interested in a certain file, and concern themselves with a file, automatic update prompt"), 8075, "Inbox, drop box"), 8076, "the summary document, collection operations, authority controlled special folder"), 8077, "business documents and personal files separate management"), 8078, "enterprises and departments to distinguish between private folders and folders"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8079, "version control"), 8080, "an infinite number of historical versions of files, you can manage, download, delete, set to the current version, supported versions log"), 8081, "Share tab"), 8082, "folder can be set as documents and multiple labels to quickly find and label GM, privileged members can call"), 8083, "in the left column label list"), 8084, "list of tags that can be added to the left side bar, fast classification, locate the file"), 8085, "unread reminders"), 8086, "unread documents state reminded, the other members of the newly uploaded file not to be missed"), 8087, "multi-stage Recycle Bin"), 8088, "the effective time (the administrator can set) ordinary members of the deleted files superiors business can be restored or completely deleted by level and so on. "), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8089, "full text search"), 8090, "can search documents and text in vector artwork, you can search tab and search documents within a specified range"), 8091, "file permissions"), 8092, "enterprise file permissions can be added, fine-grained control of any file (folder) personnel have access to the shared participation for that file, edit, annotate, print, download, and other valid authority"), 8093, "File-level security classification and security"), 8094, "four levels, can strictly control the spread of files"), 8095, "multilingual"), 8096, "Chinese version and English version "), 8097, "landmark collaboration"), 8098, "Make communication easier and more efficient"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8099, "collaborative editing and detailed list of features"), 8100, "departments and teams"), 8101, "can be established by organizational structure of departments, and departments have the appropriate file and affiliation with rights management"), 8102, "temporary business team"), 8103, "By creating a project, member companies can quickly assemble freely cross-sectoral, with people from different sectors of the project will be organized, the project can also be handed over cross-sectoral"), 8104, "Enterprise Shared Folders"), 8105, "entire enterprise (except limited staff) can access public space"), 8106, "member companies to share files automatically by setting"), 8107, "Sector Members do not need to remind automatically get the latest version of the file and dynamically inform, and direct access shared folders"), 8108, "file sharing links"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8109, "Right file sharing directly open the link, the link can be set expiration date, password and a variety of access and sharing through micro-channel and e-mail"), 8110, "File invitation"), 8111, "file sharing to collaborate by inviting people to a specific, non-invited account can not enter the file permissions invitees can be adjusted separately"), 8112, "invitation to share and authorization mechanisms"), 8113, "No invitation / users to share access can send an authorization request to share privileged users"), 8114, "mail system"), 8115, "The new file uploads, new annotations and discussion, invite and send the file to the user's mailbox can be sent via email and can be viewed and used directly in the mailbox"), 8116, "access log"), 8117, "collaborative annotation discussion"), 8118, "On the contents of the file can create annotations directly communicate in real-time discussions, collaborative discuss the issue. Support for text, hand-painted, voice, attachments, etc. discuss ways. Discussions can show and hide by permission. "), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8119, "3D annotation"), 8120, "in the 3D model can be established based on the discussion of the three-dimensional coordinates comment, click the annotation can point back to the user on the establishment of perspective when the annotation"), 8121, "File Comments"), 8122, "and the list of dynamic quick reply. "), 8123, "Activity"), 8124, "teams with information and documents related to the user's own summary of the discussion remarks platform information, you can navigate directly to the file view in a dynamic, fast or comment and reply comment. By dynamic and team collaboration, simpler and more direct. "), 8125, "messages and reminders"), 8126, "remind concerned, it is important to inform, invite and will be authorized to operate in a manner other important message notification service. Help users abandon noise, focus on the most important thing "), 8127, "external cooperation"), 8128, "Brothers and customers to build and or collaboration. Internal documents and external files separate identity, external members alone management, mail phone number quickly invitation. Safe and efficient "), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8129, "departments, project teams and group chat"), 8130, "Like micro-channel group chat by department, project and team-based discussion groups, support for attachments transmission"), 8131, "and accessories"), 8132, "Members and transmission accessories, make work more focused"), 8133, "approval and approval process"), 8134, "supporting documents for approval, the approval process can be preset, both groups are supported approval or approval of the order. After approval files directly finalized can not be changed "), 8135, "finalization of the document"), 8136, "approval documents shall be finalized by file, finalized documents can not be modified to facilitate the development and production departments to determine and left credentials. "), 8137, "Announcement"), 8138, "simple and fast publish corporate announcements, quickly communicated to the member companies"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8139, "Collaboration members of management"), 8140, "all the file-sharing collaboration can quickly manage members to participate in collaborative change member permissions, delete the increased participation of members. "), 8141, "Structure-based collaborative"), 8142, "collaboration within the enterprise organizational structure can be imported, you can quickly build synergies and assign privileges based on affiliation organizational structure"), 8143, "online collaborative editing"), 8144, "support online collaborative editing office documents, clearly marked modify points together to accomplish a document"), 8145, "total screen presentation"), 8146, "total support for teleconferencing screen presentation, after opening the perspective of participants and presenters consistent, using a brush and light gun marked the key elements"), 8147, "handy nothing restraint"), 8148, "Pad and using a mobile phone will be able to complete most of the work"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8149, "Babel birds full-featured mobile end, not only has all the features of web end, as well as voice annotation, high-quality touch screen with handwritten comments and other mobile device-specific features. Let you anywhere can open as many as 200 kinds of file formats and discussed above and teams. No need to install any other application can edit office documents online. For the iPad screen, Babel birds more optimized experience, design and dynamic content file structure on the left to the right side of the document so that the use of mobile experience better. Support win10 clients can also make your surface even more powerful. Babel birds using mobile end, you can put the entire enterprise document and team wisdom with me, you can check at any time under the newly made plan, the transfer of the latest design draft to the client, a remote presentation PPT, approved by the latest budget. Of course, we support the micro letter. "), 8150, "Mobile office detailed feature list"), 8151, "Andrews, iOS platform, full coverage of the micro-channel 0"), 8152, "support for Android devices, iPhone and iPad is customized pad version. Support H5 "), 8153, "windows10 and Mac"), 8154, "On the surface flat and Apple laptops can use the client and synchronization"), 8155, "the APP native, higher efficiency"), 8156, "Babel birds mobile terminal are written specifically for the target system native APP, non-nested pages"), 8157, "all functions of the mobile terminal"), 8158, "Whether client or mobile terminal, all features are supported web version"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8159, "born to move"), 8160, "mobile terminal supports the creation of voice annotation, upload your camera, camera accessories direct"), 8161, "customizable interface for the iPad, god-level interactions"), 8162, "Babel iPad excellent birds on experience, horizontal screen file list displayed on the left, right of the file content, fast switching efficient collaboration. IPad use it to start work "), 8163, "Open the document from another App"), 8164, "micro letters and QQ documents and other app can open and upload birds Babel"), 8165, "mobile downloads files and forward"), 8166, "Babel birds mobile terminal downloaded files can be forwarded directly to the micro-channel"), 8167, "file sharing mobile terminal"), 8168, "mobile terminal directly through the micro-channel may also be sent directly to the file sharing circle of friends"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8169, "online edit"), 8170, "mobile terminal can open edit office documents online, without having to install additional software"), 8171, "Online Preview"), 8172, "Most of the files can preview the web version of the mobile terminal can preview (except 3D file nearly 200 species)"), 8173, "direct endorsement discussion"), 8174, "click, you can directly comment on the discussion Babel birds moving end open files, and managing annotation point"), 8175, "watermark display"), 8176, "mobile terminal also supports open file watermark"), 8177, "ultimate quick browse files"), 8178, "flip up and down, left and right switches files, fast switching between multiple files, more in line with the mobile terminal usage"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8179, "painted, more preferably movable end"), 8180, "mobile device with a touch screen, hand-painted trapping can be discussed at the Babel birds APP open files, and experience better. "), 8181, "full text search"), 8182, "mobile terminal can quickly search the full text of all jurisdictions can be found in the file, without having to rummage"), 8183, "label attention, a lot of comments"), 8184, "real full-function, all functions in the mobile terminal is also a lot more powerful"), 8185, "departments and team group chat"), 8186, "Close and micro-channel group chat experience more in line with user habits"), 8187, "Log Viewer"), 8188, "the same mobile terminal can view the log management"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8189, "Notification Center"), 8190, "mobile terminal can receive information at any time to chat and file update notification, real-time understanding team dynamics"), 8191, "Privatization can also use APP"), 8192, "the simple configuration, the mobile terminal may provide services to users privatization "), 8193, "for the born"), 8194, "compliance with corporate governance requirements of the enterprise management background details, unified management of the entire enterprise"), 8195, "corporate logo to replace"), 8196, "From the login screen to open the page using the interface and can be used to share user company logo, unified professional, taking into account the corporate image"), 8197, "independently two domain"), 8198, "Every business has its own separate entrance, not be confused with more professional"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8199, "Company Profile"), 8200, "show at a glance the use of business space occupancy"), 8201, "multi-level administrators"), 8202, "business owners account, enterprise administrators, archivists, operation and maintenance administrators, security staff, auditors and other security administrator, meticulous assign administrative rights, do leak"), 8203, "default security policy"), 8204, "five kinds of optional security policy, assign permissions to protect the data flow from the enterprise"), 8205, "Structure"), 8206, "according to the organizational structure of the distribution department and file structure, different departments may use different security policy"), 8207, "sector management"), 8208, "detailed management and use of space, staff, managers, sub-departments, security policy"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8209, "administrator decentralization"), 8210, "decentralized to department administrators, by the department to manage their own usage, and specify the department administrator. Maintenance staff to share the work. "), 8211, "member management"), 8212, "can manage all members, both internal and external members of the enterprise"), 8213, "batch add, batch edit"), 8214, "can add bulk import business members quickly set up an account, e-mail automatically notify members"), 8215, "a key transfer"), 8216, "leave a key member of the file transfer of a key transfer to other members"), 8217, "Rapid Suspension"), 8218, "can quickly disable a particular batch employee accounts"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8219, "search and selection"), 8220, "powerful search and filtering tools for quick management members"), 8221, "space constraints"), 8222, "can limit the private memory space for each user, to optimize space allocation"), 8223, "roles and rights management"), 8224, "customizable roles and appropriate authority, up to 40 optional permissions and adjust the details"), 8225, "tag management"), 8226, "new management or enterprise-wide sharing tab and check the label usage"), 8227, "approval of management"), 8228, "pre-approval process, management has approval process and view usage"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8229, "Group Management"), 8230, "member companies can quickly assemble freely, set up temporary project team. And manage existing groups, add or delete members of the grouping "), 8231, "Watermark Settings"), 8232, "Support text watermark, see the user ID watermark, image watermark. Manage watermark scope used, the display mode information and transparency "), 8233, "mac address binding"), 8234, "mac address pool set up so that employees can access specific business Babel birds on a specific device"), 8235, "access log"), 8236, "a detailed record of the entire enterprise of Babel birds use logs to be investigated in detail. Search filter support and a variety of ways. Exportable. "), 8237, "confidential business customized security system"), 8238, "assigned from the rights to use, to the transmission from memory. Babel birds provide the most professional security "), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8239, "each file separate access control"), 8240, "be able to view and manage access control independent of each file, and add or change access permissions"), 8241, "file security level"), 8242, "sets the security level of any one company file open, internal, restricted, confidential optional four levels, different levels corresponding to different security policies. From file-level guarantee the security document "), 8243, "each independently check the log file"), 8244, "fine grain size to the log file, each can view the detailed access log file"), 8245, "with the comment, only to see but also to complete the communication"), 8246, "Babel Bird supports preview most files, and can be directly comment on the comments to discuss the contents of the file, which means as long as the file is not an editor, without having to open the download permission to complete the work. Use Babel birds can turn off download rights, to ensure maximum file is not compromised "), 8247, "File visitor stats"), 8248, "whether it is internal or external members and even members of anonymous users, visitors can document and view statistics (anonymous users to display IP) in the file properties"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8249, "fresh water mark"), 8250, "different from network disk interface displayed in the foreground watermark, birds Babel watermark embedded document, and can open the viewer ID is provided as a watermark, can effectively ensure screenshot file is not propagated. "), 8251, "Share permissions and encryption "), 8252, "Right file sharing directly open the link, the link can be set expiration date, password and a variety of access control"), 8253, "safe way to invite collaboration"), 8254, "file sharing to collaborate by inviting people to a specific, non-invited account can not enter the file permissions invitees can be adjusted separately"), 8255, "invitation to share and to authorize"), 8256, "invitation to share and be open license to conduct share important documents can be managed"), 8257, "sharing behavior management"), 8258, "accurate to the file sharing behavior control, records management can view all shared files and folders"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8259, "former employees a key handover"), 8260, "former employee files a key handover to transfer people, while retaining the former employees of chat and annotation data"), 8261, "internal documents and external documents distinguish"), 8262, "Babel birds can distinguish internal documents (personal files and staff of the enterprise) and external file (or other business partners, uploaded files) to ensure that the source file"), 8263, "version control"), 8264, "file changes are permanently saved the old version, file cover to prevent errors caused"), 8265, "Recycle Bin Control "), 8266, "the effective time (the administrator can set) ordinary members of the deleted files superiors business can be restored or completely deleted by level and so on. "), 8267, "Multi-administrator structure"), 8268, "to prevent excessive or administrator privileges are not familiar with traffic safety hazard. Babel birds from overall management to the manager, file management, security management is divided into various aspects of the Administrator Administrator enterprise administrators, archivists, operation and maintenance administrators, security staff, security auditors and so on. Adapt to different business needs"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8269, "file is owned by departments and enterprises"), 8270, "Babel birds files owned by departments and enterprises, departments and enterprises have the highest authority"), 8271, "Security Policy"), 8272, "five kinds of optional security policy, assign permissions to protect data from process to enterprises, different departments can set different security policies, only the security and confidentiality of staff department in order to set security policy"), 8273, "Detailed Log Viewer"), 8274, "a detailed record of the entire enterprise of Babel birds using the log (operating records), can be exported as credentials. Screening can see visits of a particular member "), 8275, "secondary verification"), 8276, "can be a secondary account verification via SMS"), 8277, "Restricted member"), 8278, "limited access to the corporate members of the public folder is not available, unacceptable News"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8279, "external members of the management"), 8280, "can be managed separately from non-corporate members, external members understand visits, delete, or change the external members of the authority"), 8281, "detailed management role and authority"), 8282, "support for custom roles, and as many as 40 optional management role permissions"), 8283, "members use the space control"), 8284, "precise control available space of each member"), 8285, "mac address binding"), 8286, "may bind to a certain user account or mac address mac address pool, define a particular user can only access a particular device"), 8287, "transmission link encryption memory full"), 8288, "file upload and download using HTTPS as the transport protocol, the file transfer process itself AES CTR 256 secondary flow block encryption algorithm, to ensure that the cloud eventually stored in the file storage system are encrypted, and stored in the transmission It may be stolen during prevent "), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8289, "the highest level of EV"), 8290, "the highest level of certification EV SSL transport access to foreign third-party evaluation agencies Qualys A + safety assessment"), 8291, "multiple backups"), 8292, "Ali OSS use public cloud storage services, the same data distributed storage nodes in four optional private cloud using a distributed storage and raid array for data backup, to ensure that no data is lost hardware damage"), 8293, "MD5 hash check"), 8294, "files are stored on the server side hash MD5 checksum, a file unique to ensure against tampering"), 8295, "memory fragmentation"), 8296, "file is broken stored in different servers, ensure that the hard way not to get a complete copy of the data to ensure safe"), 8297, "ward off DR"), 8298, "Ali provided a public cloud disaster recovery services based misfortunes, powerful remote backup function, data can be quickly switched without affecting the user's files and quickly restore user data in emergency situations"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8299, "distributed database"), 8300, "distributed database to ensure the stability and safety of the read and write rates database, can quickly restore the database in case of damage"), 8301, "protective shield cloud"), 8302, "the use of public cloud Ali cloud shield of protection against hacking and DDOS attacks"), 8303, "Data Migration"), 8304, "to provide data migration, and data services to move out"), 8305, "Multi-server array"), 8306, "functions and services distributed across multiple servers, ensures that no single server error does not affect other functional modules"), 8307, "Multi monitoring platform"), 8308, "Use Ali, wisdom and many other third-party cloud monitoring platform to monitor the functioning of the whole system, abnormal timely warning SMS notification, operation and maintenance personnel 7 * 24 hours a day, to ensure a stable platform. "), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8309, "third-party security scanning"), 8310, "the use of third-party platforms such as Qualys regularly scan, looking for loopholes, and timely remedy"), 8311, "Big peak access disaster recovery"), 8312, "Public Cloud large peak burst access server can automatically increase the amount of computation, and limiting the bandwidth of a single user, ensure access to enterprise users"), 8313, "the use of public cloud Enterprise Edition, more efficient, more detailed management"), 8314, "Free Trial"), 8315, "Babel birds can not install any applications to directly open and preview more than 200 file formats. Even better, Babel birds can click to establish comment on the contents of the open file, when you finish all your annotations build partnership can be notified and involved discuss the details of the file together. Whether it is a prototype drawing, or a speech, all participants have permission can be in the form of voice, hand-painted, characters express their views on it, and support for attachments. At the same time, and all changes and discuss your work-related documents in time you can see and respond directly to support 'in the dynamic"), 8316, "Whether it is a link to share (anonymous access to the IP address), or in the invitation to visit and departments, all operations have logs can view and manage"), 8317, "business execution must rely on discipline"), 8318, "to make rules for the full range of enterprise storage and collaboration"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8319, "Birds of Babel Enterprise has a strong business management background, where you can not only use the allocated space for each member to understand the amount of space. And can quickly lead member companies to establish authority and organizational structure, management members, the default security policy. You can also set the approval process, management labels and restrictions on equipment used by the user. Various types of preset administrator and decentralized management while reducing the maintenance workload iT staff to enhance the security of the system. Up to 40 optional roles privileges can clearly control responsibilities and authority of each member of the role. It can be said, Babel birds have a domestic network disk system the most powerful tunable backstage management system to help enterprises fine management. "), 8320, "enterprise back-office functions detailed list"), 8321, "confidential business customized security system"), 8322, "Babel birds can provide the most professional security"), 8323, "We know that data security is important to the enterprise, but also the security on the basis of the position of the entire system. Each new a feature, whether it is a vulnerable primary consideration, the impact on system security. For security invisible to the user, we would rather sacrifice some performance, the most troublesome development mode, to pay more costs. Of course, we also paid off, Bobby birds get A + rating Qualys Security Evaluation, the highest score of domestic enterprises network disk. While seeking to extremely high data security requirements for confidential business orders. Assign from the rights to use, from transport to storage, Babel birds can provide the most professional security! "), 8324, "Data security detailed features list"), 8325, "file access security policy"), 8326, "data transmission and storage security"), 8327, "operation and maintenance of the security policy"), 8328, "Member and Department security policy"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8329, "Please select the version you want to register"), 8330, "Personal Edition"), 8331, "personal files, quickly join the collaboration"), 8332, "Free"), 8333, "to meet basic personal needs. Simple, convenient and safe. Professional Edition can be upgraded to get more storage space and greater functionality. "), 8334, "Sign up now"), 8335, "Public Cloud Enterprise Edition"), 8336, "fine management company members, focusing SMEs"), 8337, "/ person / month"), 8338, "plenty of storage space, strong management background and authority management and control system, independent of the access domain for enterprises to create exclusive cloud service. "), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8339, "30 day free trial "), 8340, "to understand the differences in each version"), 8341, "Authentication"), 8342, "Authentication is required to join the invitation"), 8343, "{-time-} post"), 8344, '”After several rounds of product selection, we finally chose Babel as our data storage core. The reason for our choice is the meticulous service and comprehensive products. "'), 8345, "- director Xia of China Japan Friendship Hospital"), 8346, "/Person / month"), 8347, "It is detected that your mobile phone number has registered with Babel professional edition. If you want to upgrade your account to enterprise version, please contact customer service."), 8348, "<p>Your mobile phone number has been registered with Babel. Are you sure you want to upgrade this account to enterprise version?</p>\n<p>Select \"yes\" to upgrade. This operation is irreversible and may cause data loss. Please pay attention to backup data.</p>\n<p>If you don't want to upgrade the account, please choose \"no\" and change your mobile phone number to register the enterprise version</p>"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8349, "You can add your own account number"), 8350, "File not exist or deleted by owner"), 8351, "Failed, the phone duplicated!"), 8352, "This mobile number has not been registered with Babel. Click To register and we will jump to the registration page. If you have other Babel accounts, you can log in with other accounts and bind your mobile phone number in the settings."), 8353, "Log in with another account"), 8354, "To register"), 8355, "This document was created"), 8356, "Permission  denied or the file configuration does not support this operation"), 8500, "Submit the file {-fileName-} to the enterprise sending box {-identifier-} to apply for sending the file, which has been approved"), 8501, "Send list"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8502, "Receive list"), 8503, "Submission date"), 8504, "Approval date"), 8505, "Audit date"), 8506, "Waiting for sending"), 8507, "Received time"), 8508, "The enterprise has not set the sending port"), 8509, "The enterprise has not set the receive port"), 8510, "Transfers"), 8511, "Sync"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8512, "All dynamic"), 8513, "File annotation"), 8514, "Click to go back"), 8515, "Click to move forward"), 8516, "Operation failed, you do not have permission to clear all permissions of this account"), 8517, "Advanced"), 8518, "Advanced"), 8519, "Enter the keywords to search for, multiple keywords separated by spaces"), 8520, "Display only search results containing all keywords"), 8521, "Search keyword"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8522, "Search by creation time or shooting time"), 8523, "Limit the file update time to search"), 8524, "File format"), 8525, "Select the file type to search"), 8526, "Uploader"), 8527, "Search scope"), 8528, "Select search folder manually"), 8529, "Search type"), 8530, "File content (full text)"), 8531, "Click to select members"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8532, "Select uploader"), 8533, "Shooting time"), 8534, "Size"), 8535, "Resolution"), 8536, "Equipment model"), 8537, "Color space"), 8538, "Location"), 8539, "More information (metadata)"), 8540, "All dimensions"), 8541, "Large size (4K+)"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8542, "Medium size (1080P)"), 8543, "Small size"), 8544, "Up to 5 uploaders can be specified"), 8545, "office documents (including wps documents)"), 8546, "PDF document"), 8547, "Picture file"), 8548, "Audio and video files"), 8549, "Enter the extension, and multiple extensions are separated by ','"), 8550, "Custom type"), 8551, "Please enter the search keyword"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8552, "Please select search type"), 8553, "Last visited time"), 8554, "Please select a department"), 8555, "Enterprise new file statistics"), 8556, "Cancel filtering"), 8557, "Shooting location"), 8558, "(save files up to 30 days),"), 8559, "Loading picture metadata"), 8560, "Empty failed, you do not have permission to clear the remaining files"), 8561, "{-cur-}/{-total-} executed"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8562, "{-cur-} executed"), 8563, "Please select the folder you want to search"), 8564, "View only move and copy"), 8565, "The receiving status is confirmed by the recipient. After the recipient receives it, the sender cannot change the uploaded file."), 8566, "View only department changes"), 8567, "This function requires SMS channel support, please contact customer service personnel"), 8568, "Can edit your own files"), 8570, "Create from selected template"), 8571, "View who can access the current file"), 8572, "Personnel source"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8573, "Read file name"), 8574, "This project"), 8575, "Sharing participants"), 8576, "Use only custom permissions"), 8577, "You do not have permission to preview this file"), 8578, "Operation failed, you do not have permission to create folders or files in this directory"), 8579, "Label settings"), 8580, "Style settings"), 8581, "Example"), 8582, "Icon size"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8583, "background"), 8584, "Label content"), 8585, "Use default settings"), 8588, "No background"), 8589, "Dark Grey"), 8590, "Yin Hong"), 8591, "Deep Blue"), 8592, "Purple Red"), 8593, "Bright yellow"), 8594, "Light green"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8595, "Light gray"), 8596, "Light blue"), 8597, "Pure Black"), 8600, "The file is being downloaded, please wait"), 8601, "File download in progress..."), 8602, "Download completed"), 8603, "Download completed"), 8604, "Download successful"), 8605, "Pause download"), 8606, "Redownload"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 8607, "To be downloaded"), 8650, "Exporting"), 8651, "Exporting, please wait"), 8660, "Opening method"), 8661, "Sharing"), 8662, "Organize"), 8663, "Clear History"), 8664, "Clear History"), 8665, "Delete this record"), 9500, "field synchronization control"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 9501, "domain account management"), 9502, "domain server configuration"), 9503, "synchronous domain account"), 9504, "Jia Ruba other birds"), 9505, "Everyone will import the birds of Babel"), 9506, "username"), 9507, "Organization Name"), 9508, "yet synchronize any domain account"), 9509, "No qualifying results"), 9510, "Name (E-mail)"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 9511, "Are birds Babel account"), 9512, "domain server address"), 9513, "login account"), 9514, "Password"), 9515, "Link Test"), 9516, "successful connection"), 9517, "... import"), 9518, "import was successful"), 9519, "Import failed, please try again later "), 9520, "sync ..."), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 9521, "Connection failed. Please try again modify the parameters"), 9522, "No domain account"), 9600, "Sorry, we do not support more than 100 file or folder size exceeds 500MB download package. You can download a single file open the folder, or contact administrator for the client to download "), 9900, "Click to change the image Guard code"), 9901, "Private Cloud"), 9902, "Login with mailbox or mobile phone password"), 9904, "Login to the private cloud"), 9905, "Please enter the domain name of your enterprise"), 9906, "enterprise domain"), 9907, "I have read and accepted"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_en_part, 9908, "Attetion: The uploaded files will be automatically identified by AI. Any accounts uploading obscene or pornographic information will be automatically blocked and reported to police	"), 9909, "Set a password"), 9950, "ignore"), 9951, "The current page has been updated"), 9952, "region"), 9953, "Resetting..."));
var _default = exports["default"] = localString_en_part2;

},{"1180":1180,"1184":1184,"1454":1454}],1156:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var localString_en_part1 = {
  0: "Babelbird",
  1: "Files",
  2: "Activities",
  3: "Conversation",
  4: "Conversation",
  5: "Settings",
  6: "Sign out",
  7: "New",
  8: "Folder",
  9: "Upload",
  10: "Parent",
  11: "All Files",
  12: "Directory",
  13: "Share",
  14: "Details",
  15: "Sort by",
  16: "Press Enter to search",
  17: "My Group",
  18: "Department Folder",
  19: "My Share",
  20: "Shared To Me",
  21: "Starred",
  22: "Recycle bin",
  23: "Tag",
  24: "Tag setting",
  25: "Visitors",
  26: "Last modified",
  27: "Size",
  28: "New version",
  29: "Download",
  30: "Rename",
  31: "Move",
  32: "Remove",
  33: "Copy to",
  34: "Add star",
  35: "Manage versions",
  36: "Top",
  37: "More",
  38: "Preview",
  39: "Get access url",
  40: "View details",
  41: " created at ",
  42: "Comment",
  43: "Unread comments",
  44: "Like",
  45: "Tag setting",
  46: "Click {-tagMgr-} to set the tag to show here",
  // {-variable-} 这一部分是将来被替换的变量
  47: "Upgrade",
  48: "Network Error",
  49: "File name",
  50: "My Account",
  51: "Profiles",
  52: "Change Password",
  53: "Forget Password",
  54: "Storage",
  55: "My Storage",
  56: "Used",
  57: "Remaining",
  58: "Personal Usage",
  59: "Team Used",
  60: "Shared Used",
  61: "User type",
  62: "Free",
  63: "Notifications",
  64: "Get all updates about Babelbird items via email",
  65: "Team management",
  66: "New team",
  67: "Remove",
  68: "creator",
  69: "me",
  70: "Team member",
  71: "Add members",
  72: "Administrator",
  73: "Settings",
  74: "Back",
  75: "Link sharing",
  76: "Anyone with the link can comment",
  77: "Anyone with the link can edit",
  78: "Anyone with the link can comment & download",
  79: "Anyone with the link can view",
  80: "Copy link",
  81: "Learn more",
  82: "Access this link requires password",
  83: "Invite people",
  84: "Enter names or email addresses",
  85: "Can edit",
  86: "Can comment & download",
  87: "Can comment",
  88: "Can view",
  89: "Done",
  90: "Advanced",
  91: "{-curCount-} people entered, up to {-maxCount-} people",
  92: "Once you have opened the Share, you can separately control and manage the access for each invited Sharer",
  93: "Prevent editors from changing access and adding new people",
  94: "",
  95: "Access by link",
  96: "Close link sharing",
  97: "Invited",
  98: "Search invited",
  99: "Sharing time",
  100: "Show Tag in left column",
  101: "There is no tag in the left column, you can click {-newTag-} again or drag the tag from {-allTag-} to add to the left column label",
  102: "All Tag",
  103: "I used",
  104: "Sharing tag",
  105: "No tag，click {-addTag-}",
  106: "Add tag",
  107: "Drag to add the tag to {-leftTag-}",
  108: "Generating preview file, please try again later",
  109: "Text comment",
  110: "Version Information",
  111: "Hide comments",
  112: "Full screen",
  113: "{-num-} comments",
  114: "Current documents",
  115: "Current document unread comments",
  116: "All comments",
  117: "Unread",
  118: "Enter the comment",
  119: "Done",
  120: "delete",
  121: "{-second-}S",
  122: "Click Add Reply",
  123: "Enter quickly reply",
  124: "Reply",
  125: "CLS",
  126: "You added a graphic mark",
  128: "Review",
  129: "Voice comment",
  130: "Draw comment",
  131: "COMP.",
  132: "Undone",
  133: "Pass",
  134: "Reject",
  135: "Root",
  136: "Open the directory",
  137: "The file I uploaded",
  138: "Search tag",
  139: "Professional Edition",
  140: "Feedback",
  141: "Download iOS App",
  142: "Download Android App",
  143: "Download Desktop version",
  144: "My Concern",
  145: "My Inbox",
  146: "My Approval",
  147: "Tag added ",
  148: "Tags added failed, please try again later",
  149: "Removed tag successfully",
  150: "Failed to remove tag,  Please try again later",
  151: "File has been unshared or you are no longer sharing this file",
  152: "Insufficient permissions",
  153: "You do not have this permission for the current folder",
  154: "OK",
  155: "Cancel",
  156: "Close",
  157: "You receive the new message",
  158: "Name",
  159: "The directory",
  160: "The current folder is empty",
  161: "Tip: You can",
  162: " or ",
  163: "Create folder",
  164: "No results found for this search in your file or folder",
  165: "Please try other search criteria",
  166: "Unread",
  167: "You do not have permission to open this file",
  168: "The action failed, please refresh the page and try again",
  169: "You have lost access to this file and this page is about to close",
  170: "Attention",
  171: "Drap here to move to the current directory",
  172: "Drag here to upload to the current directory",
  173: "Temporarily only support file upload",
  174: "{-count-}comments",
  175: "{-count-}Unread",
  176: "Deadline",
  177: "None",
  178: "Outside file",
  179: "Click to view the visitors",
  180: "Postbox setting",
  181: "Start approval",
  182: "View approval",
  183: "Cancel topping",
  184: "topping",
  185: "Group",
  186: "Management team",
  187: "View the team",
  188: "The file has been locked by me",
  189: "The file has been locked by {-user-}",
  190: "by {-user-}",
  191: "Shared",
  192: "Invitation opened",
  193: "Opened link share",
  194: "Share from {-user-}",
  195: "Link sharing is closed",
  196: "Get shareable link",
  197: "Please enter the folder to select one of the files to view!",
  198: "Personal Edition does not support the postbox, please upgrade to the Enterprise Edition!",
  199: "Only Enterprise Edition supports file approval, you can open the Enterprise Edition to use this feature",
  200: "The discussion group only allows designated people to enter, please contact the administrator",
  201: "You did not join the sharing , please click “Get shareable link”, enter through the link",
  202: "Members",
  203: "Edit",
  204: "Inner",
  205: "Outside",
  206: "On line",
  207: "Detail",
  208: "Manager",
  209: "Edit",
  210: "Archivist",
  211: "Enterprise owner",
  212: "add",
  213: "Edit managers",
  214: "Account",
  215: "Contact",
  216: "Role",
  217: "Act",
  218: "Add",
  219: "Edit file managers",
  220: "Attention",
  221: "Are you sure to delete the manager role of {-user-}",
  222: "Are you sure to delete the archivist role of {-user-}",
  223: "Cannot del file in current channel!",
  224: "Synchronise",
  225: "Encryption uploading...",
  226: "Upload finished",
  227: "Closing the window will cancel the uploading，sure to close?",
  228: "Wating...",
  229: "Reupload",
  230: "Uploaded，coding...",
  231: "Cancelled",
  232: "Failed",
  233: "Beyond the space limit",
  234: "Uploaded successfully",
  235: "Coment list",
  236: "Full screen",
  237: "Hide comments",
  238: "Edit",
  239: "Showing",
  240: "Share",
  241: "Please do understand",
  242: "Who like",
  243: "Cancel concern",
  244: "Draw concern",
  245: "Display more",
  246: "Tag deleted",
  247: "Tag added",
  248: "Like",
  249: "Tag name",
  250: "Tag has existed",
  251: "Whose concern to draw ",
  252: "Input opinion",
  253: "All",
  254: "No discussion",
  255: "No right to discuss",
  256: "Approval",
  257: "Permanently Delete",
  258: "Mark readed",
  259: "Start approval",
  260: "Restart approval",
  261: "Approving(see schedule)",
  262: "Edit permission",
  263: "Lock",
  264: "Unlock",
  265: "Parent folder",
  266: "Open local folder",
  267: "Synchronize",
  268: "Cancel synchronization",
  269: "New Text",
  270: "New Word",
  271: "New Excel",
  272: "New PPT",
  273: "New markdown",
  274: "File",
  275: "Total space",
  276: "Please select single file",
  277: "Common",
  278: "Remarks",
  279: "Type",
  280: "Deleted by",
  281: "Deleted time",
  282: "Version",
  283: "{-index-}",
  284: "View versions",
  285: "Being locked",
  286: "Followers",
  287: "Access",
  288: "File log",
  289: "Comments",
  290: "Downloads",
  291: "Open",
  292: "Access",
  293: "Viewer",
  294: "Include",
  295: "Calculating",
  296: "Created",
  297: "Modified",
  298: "No right to list version!",
  299: "Current",
  300: "To be current",
  301: "Remarks",
  302: "HTML file not support to view old version, you can set current version and reopen again！",
  303: "Cannot delete version of finalized file",
  304: "Are you sure to delete the version?",
  305: "Deleted",
  306: "Failed to delete",
  307: "In approval，please stop the approval！",
  308: "Operation successfully",
  309: "Operation failed",
  310: "No right to change the verison",
  311: "Can not update the version of finalized file",
  312: "Sure to delete the comment?",
  313: "All",
  314: "@me",
  315: "Recently",
  316: "{-num-}m ago",
  317: "{-num-}h ago",
  318: "{-num-}d ago",
  319: "Yesterday",
  320: "Before yesterday",
  321: "{-num-}weeks ago",
  322: "{-num-}months ago",
  323: "{-num-}years ago",
  324: "5 years ago",
  325: "Transfer file",
  326: "Send message",
  327: "Make newline",
  328: "Sure to delete the file",
  329: "Tip: deleted files may remain in trash for 10 days (except the share you joined)",
  330: "The folder is empty",
  331: "Downloading, please wait...",
  332: "Team files",
  333: "Belongs to team",
  334: "Departments Files",
  335: "Belongs to enterprise",
  336: "Enterprise Public",
  337: "Enterprise Files",
  338: "Share settings",
  339: "Clear all",
  340: "No new notifications",
  341: " apply to invite {-num-} people to join {-file-}",
  342: "Refuse",
  343: "File not exists or be deleted",
  344: " apply to open link",
  345: " invite you to examine postbox",
  346: "Accept",
  347: "Notice has been deleted",
  348: "Babel Notice",
  349: "Enterprise Notice",
  350: "System Notice",
  351: " apply to join team",
  352: " open the postbox",
  353: "expect you to deliver file haste",
  354: " invite you to approve the file ",
  355: " draw your concern to file ",
  356: "@ you at {-object-} in file {-name-}",
  357: "content",
  358: "start showing {-name-}",
  359: "Service expired at {-endTime-},please pay haste",
  360: "open the approval of file {-name-}, and copy to you",
  361: "remarks:",
  362: "Return to up folder",
  363: "Search",
  364: "Totally {-num-} ",
  365: "Press Return to search",
  366: "Word ",
  367: "Excel ",
  368: "PPT ",
  369: "Text",
  370: "Postbox",
  371: "Cannot create file in this channel",
  372: "Rrid",
  373: "List",
  374: "File detail",
  375: "Team detail",
  376: "Folder tree",
  377: "View participants",
  378: "Clear trash",
  379: "Files will be permanently deleted, press OK to proceed",
  380: "Attention: this operation cannot be withdrawn!",
  381: "Manage The Enterprise",
  382: "Outside members",
  383: "Recently Accessed",
  384: "Access",
  385: "Draw your concern",
  386: "Share to you",
  387: "All folders",
  388: "Private folders",
  389: "Share from {-user-}",
  390: "Save to My Babelbird",
  391: "Please enter the share password",
  392: "File saved successfully",
  393: "Please login or input the share password",
  394: "Password",
  395: "Password not correct, try again",
  396: "Owner",
  397: "Our enterprise",
  398: "Other enterprise",
  399: "Personal",
  400: "View the participants",
  401: "No right to invite users, but you can send an apply to the owner to do so",
  402: "Invited",
  403: "...etc {-num-} people",
  404: "Failed to get the invitees",
  405: "Invitee must use the seem mail to login",
  406: "Send",
  407: "Participants",
  408: "Open the share to let others to view the file",
  409: "Link",
  410: "Link and password were copied to the clipboard",
  411: "Link was copied to the clipboard",
  412: "Press ⌘+C  to copy",
  413: "Press Ctrl+C to copy",
  414: "Failed to set private share",
  415: "Scan the QR Code to join",
  416: "Scan the QR Code to join",
  417: "Open the wechat",
  418: "click bottom “find”",
  419: "use “scan QR Code”",
  420: "open the BabelBird",
  421: "click the bottom “all file”",
  422: "use the lefttop “scan”",
  423: "the owner do not open the share link",
  424: "apply to open",
  425: "leave message to tell the owner to open the share link ",
  426: "leave message",
  427: " {-num-} letters left",
  428: " send apply",
  429: " apply share link",
  430: " apply to open share link for {-file-}",
  431: "Message",
  432: "Waitting",
  433: "Finalized",
  434: "Approving",
  435: "Parameter not defined",
  436: "Normal",
  437: "Not support the file",
  438: "File in converting",
  439: "Converting failed",
  440: "File has password, please erase the password and reupload",
  441: "File damaged",
  442: "Too big to convert",
  443: "PPT file is empty",
  444: 'To remove tag from the left panel by drag to "all tag"',
  445: "No tags，you can click here to ",
  446: ' or to drag tag to here from "all tags" to display the tag in left panel',
  447: "Drag and drop here to dispay it in left panel",
  448: "Drag and drop here to remove the tag from left panel",
  449: "Duplicated file name",
  450: "There is file named {-fileName-}!",
  451: "Cancel",
  452: "Auto renamed to upload",
  453: "Upload as a new version",
  454: "Attention：cannot upload file which size is bigger than {-size-}",
  455: "Size cannot beyond",
  456: "In uploading! leave the page will stop the uploading",
  457: "Personal edtion do not support upload folder",
  458: "Input the tag name",
  459: "Create comment",
  460: "Everyone can see",
  461: "Only enterpise member can see",
  462: "Only myself can see",
  463: "Graph mark added",
  464: "Finished",
  465: "Failed to send file",
  466: "Scribble",
  467: "Rect",
  468: "Segment",
  469: "Arrow",
  470: "Text",
  471: "Color",
  472: "Line width",
  473: "Font size",
  474: "Undo",
  475: "Redo",
  476: "Input comment here or scribble in the image bellow",
  477: "Load more",
  478: "Select the reviewers",
  479: "My groups",
  480: "Frequent contacts",
  481: "Title",
  482: "Publisher",
  483: "Sign in",
  484: "Sign up",
  485: "Email or Mobile number",
  486: "Sign in - BabelBird",
  487: "Sign in with phone",
  488: "Phone",
  489: "Guard code",
  490: "Sign in by mail or phone",
  491: "Sign by other way:",
  492: "Wechat",
  493: "Forget password?",
  494: "Sign in enterprise edition",
  495: "Input the enterprise domain",
  496: "Enterprise domain name",
  497: "To sign in",
  498: "←Personal edition",
  499: "Sign up - BabelBird",
  500: "Press to agree with our",
  501: "Privacy policy",
  502: "And",
  503: "Service policy",
  504: "Input Guard code to continue",
  505: "Image code",
  506: "Edit department members",
  507: "Sorry, the free edition only support not more than 2 teams ",
  508: "Approval list",
  509: "Committer",
  510: "Failed to get approval information",
  511: "Target file",
  512: "Approval information changed",
  513: "Directly finalized file, no approver",
  514: "Passed",
  515: "Not started",
  516: "In approving...",
  517: "Be rejected",
  518: "Was rejected, you can upload new version and restart the approval",
  519: "Cannot review in current phase",
  520: "Reviewed",
  521: "Be rejrected, approval ended",
  522: "Approval finished",
  523: "Copy to",
  524: "End approval",
  525: "Reenter the approval opinion",
  526: "My opinion",
  527: "Opinion",
  528: "Set up approval",
  529: "After approval passed, the file will be finalized. File finalized or approving cannot be edit or upload new version",
  530: "Directly finalize file",
  531: "Commit to start approval",
  532: "Add approval",
  533: "approver",
  534: "Copy to",
  535: "Predefined",
  536: "approver",
  537: "If do not review orderly, put all approver to approval 1",
  538: "Select approval schedule",
  539: "In approval schedule, after approval 1 passed, approver in approval 2 should receive information, etc",
  540: "The approver can see all the comments in file",
  541: "The approval schedule can be used to quickly set up file approval ",
  542: "Named for approval schedule",
  543: "Edit schedule",
  544: "Duplicated schedule name",
  545: "Faile to save，try again",
  546: "Team conversation is group by team, member can exchange instant information",
  547: "New Team",
  548: "Tip: department instant message is null",
  549: "File not exist",
  550: "Cannot open folder in Bin",
  551: "File not exist, may be moved away.",
  552: "File be deleted",
  553: "Open target folder",
  554: "Created department",
  555: " became department member",
  556: " was renamed as ",
  557: "Space limit was set to",
  558: "The department was set to",
  559: "was moved out of department",
  560: " role was set to be",
  561: "&nbsp;joined the team",
  562: "&nbsp;refused to join team",
  563: "&nbsp;was kicked out of conversation",
  564: "&nbsp;quit the team",
  565: "&nbsp;apply to join team",
  566: "&nbsp;invited&nbsp;",
  567: "&nbsp;removed&nbsp;",
  568: "file alerady in approval！",
  569: "Unapproved",
  570: "To do",
  571: "File activities",
  572: "Public message",
  573: "Reply",
  574: "Enterprise internal message",
  575: "Participants",
  576: "Group",
  577: "User",
  578: "The user already in list",
  579: "Search name/mail/phone",
  580: "Enterprise group",
  581: "Edit",
  582: "No enterprise group",
  583: "Mo private group",
  584: "Input folder name",
  585: "Folder name cannot be null",
  586: "Folder name cannot be longer than 100 letters ",
  587: "Basic service",
  588: "will expire",
  589: "expired",
  590: "Please {-pay-} in time. ",
  591: "view order",
  592: "Enterprise edition",
  593: "The {-edition-} service is valid until {-date-}",
  594: "Renew Service",
  595: "The Renewals include",
  596: "Services",
  597: "Unit(RMB)",
  598: "Count",
  599: "Amount(RMB)",
  600: "Please select the time (year)",
  601: "The time selected",
  602: "years",
  603: "{-edition-} will be renewed to {-date-}",
  604: "Need to pay the total cost",
  605: "yuan",
  606: "I need invoice",
  607: "Submit order",
  608: "Pay",
  609: "Renew Service",
  610: "Professional edition service management",
  611: "Enterprise edition service management",
  612: "Personal orders",
  613: "Enterprise orders",
  614: "All orders",
  615: "Submit time",
  616: "Start time",
  617: "End time",
  618: "Name",
  619: "Years",
  620: "Satus",
  621: "All",
  622: "Upgrade account",
  623: "Extend space",
  624: "Renew account",
  625: "Y",
  626: "Unpaid",
  627: "Unverified",
  628: "Paid",
  629: "Are you sure to delete the order",
  630: "Order No.",
  631: "Order content",
  632: "Delete Order",
  633: "Are you sure to cancel the order",
  634: "Cancel Order",
  635: "Uprade to professional edition",
  636: "Enterprise Edition space extention",
  637: "Professional Edition space extention",
  638: "Enterprise Edition renew",
  639: "Professional Edition renew",
  640: "Enterprise account",
  641: "Personal account",
  642: "The order can only be deleted by the creator",
  643: "To view more, click {-more-}",
  644: "Service runs until",
  645: "Invoice title",
  646: "Mail information",
  647: "If you have any question, please contact us. mail：support@molasync.com phone：400-9204020",
  648: "Logout",
  649: "Can add at most {-max-}, now {-num-}",
  650: "The operation is invalid to the user who is Enterprise owner or yourself",
  651: "Are you sure to {-act-} the selected users?",
  652: "Previous",
  653: "Online",
  654: "Users selected",
  655: "Batch resetting password",
  656: "Batch setting maximum personal space",
  657: "input the upper space",
  658: "Batch managing account",
  659: "Batch changing department and role",
  660: "Company",
  661: "Share belongs to",
  662: "Inviter",
  663: "Attention: no outside member",
  664: "Add outside member",
  665: "Please input Name",
  666: "The mail has been the inner member",
  667: "The mail has been the outside member",
  668: "The mail has been the Babelbird accout, you can input the left information",
  669: "The new member should receive an invited message",
  670: "Can change the password after login",
  671: "Add Enterprise member",
  672: "Department cannot be null",
  673: "This account has been in the Enterprise",
  674: "Authority setting",
  675: "Select role",
  676: "All roles",
  677: "Select user",
  678: "Finalized (Detail)",
  679: "Rejected (Detail)",
  680: "Cannot upload new version",
  681: "Are you sure to close the share?",
  682: "Attention: after closing, the share link will be invalid.",
  683: "Locked file can only be uploaded version by yourself",
  684: "Failed, locked by others",
  685: "Restoring",
  686: "Restored successfully",
  687: 'Restored, but it\'s parent folder "{-folder-}" is in Bin<br>',
  688: "Failed, the parent was deleted forever",
  689: "Sure to delete file forever?",
  690: "Deleting",
  691: "Successfully locked",
  692: "The file is locked by others, cannot edit!",
  693: "Thers is error trying to lock file <br> please try later",
  694: "There is file in sharing, please close the share at first.",
  695: "No tag",
  696: "Drag or double click tag to add it to display in left bar",
  697: "Post",
  698: "Receive",
  699: "Receiver",
  700: "Ent Doc sharing platform",
  701: "In process",
  702: "Ended",
  703: "Created by me",
  704: "No files",
  705: "Tip: You can free space by clearing Bin",
  706: "Please select file or folder",
  707: "Please input text...",
  708: "Enable watermark",
  709: "Please input name, mail, phone",
  710: "Unregisted",
  711: "Sending",
  712: "{-somebody-} is in the same department, can see the file, do you need to set to draw their concern ？",
  713: 'Close share link for "{-file-}" ',
  714: "After closing the share link, the URL of the link become invalid.<br> All the sub link will be close also",
  715: 'Close the share inivitation of "{-file-}"',
  716: "Share link not open",
  717: "To open",
  718: "After closing the invitation, the invited participants will be removed.<br>All the sub share will be close also",
  719: "The owner do not open the share link",
  720: "Send application",
  721: "Close invitation",
  722: "Anonymous",
  723: "Registered",
  724: "Reset password",
  725: "Everyone using this link can {-do-}",
  726: "Set share end time",
  727: "Push message to the participants",
  728: "Share will be closed after 7 days",
  729: "Password",
  730: "Print",
  731: "Invisible",
  732: "Accessed",
  733: "",
  734: "",
  735: "",
  736: "",
  737: "",
  738: "",
  739: "",
  740: "",
  741: "Open in new tab",
  742: "too big to display, please download!",
  743: "I have a registered ID",
  744: "to login",
  745: "set",
  746: "Compare",
  747: "External personnel",
  748: "Create",
  749: "Select Tags",
  750: "filter panel",
  751: "layers",
  752: "The permissions set here will be automatically applied to all sub files and sub folders",
  753: "upload dennied in this folder!",
  754: "Personal space",
  755: "File Manager is responsible for managing files for approval to borrow",
  756: "Security staff can see and manage all department files at the front desk, and log in to the enterprise management background. But in the background of the enterprise, it is limited to the following powers: to formulate the company's security policy (the exclusive authority of the security guard), to manage the organizational structure, to manage the members, and to manage the authority",
  757: "Security Auditor can log on business management background, but only the following rights in the corporate background: view corporate security policy, organizational structure view, View members permission to see rights management, access log file to see",
  // 755: '档案管理员负责管理审批档案借阅，不可以登录企业管理后台，但可以在前台看到所有部门的所有文件，并有权对文件的访问权限进行设置管理',
  // 756: '安全保密员可以在前台看到所有部门的所有文件，可以登录企业管理后台，但在企业后台中仅限以下权利：制定公司安全策略(安全保密员独有权限)，管理组织结构，成员管理，权限管理',
  // 757: '安全审计员可以登录企业管理后台，但在企业后台中仅限以下权利：查看企业安全策略，查看组织结构，查看成员权限，查看权限管理，查看文件访问日志',
  758: "Archive to archives",
  // 759: '文件归档后，将不允许修改和删除，文件只能到档案管理界面进行访问',
  759: "After the file is archived, it will be moved to the exclusive archive management office, which is not allowed to be modified or deleted, and the archive can only be accessed in the archive management interface",
  760: "Enterprise Archive ",
  761: "Archive enterprise valuable files",
  762: "this is an archived file, to view it, please click OK to jump to Enterprise Archive",
  763: "Read online",
  764: "Apply for download",
  765: "Apply for copy",
  766: "Application sended, please check result in your application channel",
  767: "Applying",
  768: "Borrowed",
  769: "Borrow",
  // 770: '借阅档案需要相关人员审批，审批通过后档案即可出现在“我的借阅”频道中',
  770: 'Borrowing archives need to be approved by relevant personnel. After approval, the files can appear in the "my borrowed" channel',
  771: "Borrow",
  772: "Commit",
  773: "Read",
  774: "Reason",
  775: "Archive Folder",
  776: "Archive Folder",
  777: "Folder name cannot be empty",
  // 778: '你要下载的是归档文件，需要到档案库去下载，点击确定转到档案库',
  778: 'What you want to download is an archive. You need to download it in the archive. Click "OK" to go to the archive',
  779: "You have new borrow applications to review!",
  780: "Your borrow has been passed!",
  781: "Your borrow has been refused!",
  782: "The archive should be applied to borrow!",
  783: "Edit department",
  784: "Cannot delete department that has sub departments",
  785: "Cannot delete department that has archives",
  786: "The file shortcut pointed cannot be downloaded!",
  787: "Pen",
  788: "Modified",
  // 789: '←登录公有云',
  // 790: '推荐邀请以下人员访问',
  // 791: '部门及项目',
  // 792: '你确定要从团队中移除该用户吗',
  // 793: '移除成员',
  // 794: '项目所属',
  // 795: '上传文件限定',
  // 796: '限定方式',
  // 797: '限定内容',
  // 798: '不限定',
  // 799: '限定扩展名',
  // 800: '限定文件全名',
  // 801: '请输入限定内容，以逗号隔开。如：jpg,jpeg',
  // 802: '请输入限定文件名。如：example.jpg',
  // 803: '管理部门人员',
  789: " sign in the public cloud",
  790: " recommends to invite the following people to visit",
  791: "departments and projects",
  792: "Are you sure you want to remove this user from the team",
  793: "removing members",
  794: "Owner",
  795: "Upload File defined",
  796: "defined mode",
  797: "defined content",
  798: "not limited",
  799: "defined Extension",
  800: "defined full file name",
  801: "Please enter a limited content, separated by commas. Such as: jpg,jpeg ",
  802: "Please enter the file name is defined. Such as: example.jpg ",
  803: "management personnel",
  804: "0 or empty mean all",
  805: "Input evaluations",
  806: "Accept",
  807: "Accepted",
  808: "Rejected",
  809: "Evaluation",
  810: "Sure to delete the opinion?",
  811: "Reject it",
  812: "Waiting processing",
  813: "Evaluation list",
  814: "{-num-} evaluation opnions",
  815: " evaluation opinion（audio）",
  816: " evaluation opinion（scribbles）",
  817: " accepted the  {-evaluation-} made by {-somebody-} in file {-file-}",
  818: " rejected the  {-evaluation-} made by {-somebody-} in file {-file-}",
  // 819: '{-somebody-}已经在文件{-file-}中签名',
  819: "{-somebody-} has been signed in the file {-file-}",
  820: "Enter the storage space you want to add to user's existing storage space",
  821: "To create a folder, please log in",
  822: "Click upload file or drag the content to upload to this area to complete the upload",
  823: "For real name upload or create folder, please log in",
  824: "If it is a newly uploaded file, please wait up to 30 minutes for the server to update the full-text search index",
  825: "Share a file (folder) to you [{-name-}], and click the link to view it;",
  826: "Drop box from {-user-}",
  827: "This feature is only supported for professional and enterprise editions",
  828: " expiration",
  829: "Please enter at least 5 mobile phone numbers",
  830: "The enterprise role of the enterprise owner is not allowed to change",
  831: "If you change your corporate role, you will lose the super administrator privileges. Are you sure to change?",
  832: "File storage",
  833: "This file does not support comments",
  // dashboard，
  // 其中 {-  -} 所包含的内容是将来要替换变量内容
  // 以第 1000 条为例，定义对象如下
  //  var param = {
  //		'somebody'    : '李平',
  //		'parentFolder': '历史文件夹',
  //   	'folder'      : '明朝那些事'
  //  }
  //  var s = MDLocalString.getLocalString(1000, param);
  //  s 的值为
  // 		'李平 在 历史文件夹 中新建了文件夹 明朝那些事'
  //
  1000: "{-somebody-} created folder {-folder-} in {-parentFolder-}",
  1001: "{-somebody-} uploaded {-fileEdition-}{-file-} in {-parentFolder-}",
  1002: "{-somebody-} renamed {-fileOrFolder-}{-oldName-} to {-newName-}",
  1003: " new file",
  1004: " new verison",
  1005: "etc. files",
  1006: "{-somebody-} move {-fileOrFolder-}{-file-} from {-sourceFolder-} to {-targetFolder-}中",
  1007: "{-somebody-} deleted {-file-} from {-folder-}",
  1008: "{-somebody-} uploaded {-file-}",
  1009: "{-somebody-} deleted {-file-}",
  1010: " a version of {-file-}",
  1011: "{-somebody-} restored {-file-} from trash",
  1012: "{-somebody-} moved {-file-} into {-folder-}",
  1013: "{-somebody-} moved  {-file-} out of {-folder-}",
  1014: "{-somebody-} set current version for  {-file-} ",
  1015: "{-somebody-} copied {-file-} into  {-folder-} ",
  1016: "{-somebody-} set like for {-file-}",
  1017: "{-somebody-} canel the like for {-file-}",
  1018: "{-somebody-} made a {-review-} for {-file-}",
  1019: "{-somebody-} drew your concern to {-file-}",
  1020: "{-somebody-} clear your concern to {-file-}",
  1021: "{-somebody-} joined the share {-file-}",
  1022: "{-somebody-} was removed from the share {-file-}",
  1023: "{-somebody-} quit the share {-file-}",
  1024: "{-somebody-} closed the share {-file-}",
  1025: "{-somebody-} removed {-user-} from share {-file-}",
  1026: "{-somebody-} opened the share link of {-file-}",
  1027: "{-somebody-} changed below users role from {-oldRole-} to {-newRole-} in share {-file-}",
  1028: "{-somebody-} closed the share link of {-file-} ",
  // 1029: '{-somebody-} changed the share link {-file-} role from {-oldRole-} to {-newRole-}',
  1029: "{-somebody-} changed {-file-} link role from {-oldRole-} to {-newRole-}",
  1030: "{-somebody-} added {-comment-} in {-file-}",
  1031: "{-somebody-} replied {-comment-} in {-file-}",
  1032: "{-somebody-} uploaded file in the comment in {-file-}",
  1033: "{-somebody-} deleted a {-commentType-} in {-file-}",
  1034: "{-somebody-} set {-comment-} to {-finish-} in {-file-}",
  1035: "{-somebody-} set the {-No.-}th version remarks to {-remark-} in {-file-}",
  1036: "{-somebody-} opened the postbox {-file-}",
  1037: "please deliver haste, deadline is {-time-}",
  1038: "{-somebody-} update postbox {-file-} settings",
  1039: "{-somebody-} invite you to approve {-file-}",
  1040: "leave message：{-comment-}",
  1041: "{-file-} was approved",
  1042: "{-file-} was rejected！",
  1043: "{-somebody-} did {-pass-}{-file-}",
  1044: "{-somebody-} invited {-user-} to join {-file-}",
  1045: "{-somebody-} uploaded {-file-} in {-folder-}",
  1046: "{-somebody-} uploaded a version for {-file-} in {-folder-}",
  1047: "{-somebody-} add referrence to {-destinationFile-} for {-file-}",
  1048: "etc. {-count-} files(folders)",
  1049: "{-somebody-} archived file {-file-}",
  1050: '<p class="title">Are you sure to delete department：{-department-}？</p><p class="mgt-20 Cred">Reminder: all documents and department membership will be deleted</p>',
  1051: "{-somebody-} archived file {-file-} in department {-depName-}",
  // 1052: ', 并留言：{-leaveMessage-}',
  1052: ", and a message: {-leaveMessage-}",
  1053: "Manager",
  1054: "Withdraw",
  1055: "Withdraw will remove all approvations of this file，to withdraw it？",
  // 1056: '{-somebody-} 撤销了{-file-} 的评审流程',
  // 1057: '{-somebody-} 在 {-parentFolder-} 中新建了档案夹 {-folder-}',
  1056: "{-somebody-} revoked review process of the {-file-} ",
  1057: "{-somebody-} built an archive folder {-folder-} in {-parentFolder-}",
  1058: "{-somebody-} Change the permissions of the following users from project assistant to regular member in {-file-}, with the permission {-newRole-}",
  // web browser message
  1500: " said:",
  1501: " sended a file",
  1502: " sended a scribble",
  1503: " sended an audio message",
  1504: " created folder {-fileName-}",
  1505: " uploaded {-fileEdition-}:{-fileName-}",
  1506: " renamed {-file-} to {-newName-}",
  1507: " joined the discussion",
  1508: " quit the team: {-teamName-}",
  1509: " remove {-user-} from team {-teamName-}",
  1510: " quit the discussion",
  1511: "you were removed from team {-teamName-}",
  1512: "you were removed from share {-shareName-}",
  1513: " shared {-file-}",
  1514: " closed the team {-teamName-}",
  1515: " changed the member {-user-} role from {-oldRole-} to {-newRole-} in team {-file-}",
  1516: " changed the participant {-user-} role from {-oldRole-} to {-newRole-} in share{-file-}",
  1517: "@you:",
  1518: " added a comment in {-file-}",
  1519: " added ",
  1520: " replied",
  1521: " uploade a file in comment ",
  1522: " set a comment to be finished in {-file-}",
  1523: " set a comment to be unfinished in {-file-}",
  1524: " moved a file {-file-} in",
  1525: " moved a file {-file-} out",
  1526: " you were kicked out form {-department-}",
  1527: " move {-user-} out of {-department-}",
  1528: " you were added into {-department-}",
  1529: " added {-user-} into department {-department-}",
  1530: " invited you to join team {-team-}",
  1531: " invited you to join share {-file-}",
  1532: " remove you out of the invitee list of {-file-}",
  1533: " set {-file-} version remarks to be {-remark-}",
  // 1534: ' 将{-file-}移入了{-folder-}',
  1534: " moved {-file-} into the {-folder-}",
  1535: " move project {-project-} to {-department-}",
  1536: " hand over to：{-user-}",
  // 1537: '创建了档案夹{-fileName-}',
  // 1538: '(下载)',
  // 1539: '将项目{-project-}负责人改为了{-user-}',
  1537: " created an arcive folders {-fileName-}",
  1538: "(download)",
  1539: "The person in charge of the project {-project-} instead of {-user-}",
  1540: "Loaded {-num-} of {-total-}",
  1541: "All loaded, total {-total-}",
  1542: "Loading",
  1543: "Turn the project {-project-} into a parent project",
  //-------------------------------------- 分享等 alert 提示

  2000: "Your role in department {-depName-} was set to {-role-}",
  2001: "Current department was moved, the page will be closed",
  2002: "Our role was changed to {-role-}",
  2003: "Default role",
  2004: "View file",
  2005: "View",
  2006: "Upload",
  2007: "Only upload",
  2008: "Show comment",
  2009: "Pre",
  2010: "File navigator",
  2011: "the {-fileNo-}th file of {-fileCount-} files",
  2012: "Next",
  2013: "On showing",
  2014: "Showing",
  2015: "While showing，this showing audience's file position will be synchronized with yours",
  2016: "Sure to abandon follwing？",
  2017: "Close the showing？",
  2018: "Sending",
  2019: "Failed sending",
  2020: "The showing was closed",
  2021: "Others aplly to you to set up a voice call , but local device not ready",
  2022: "No audio device",
  2023: "Mo security",
  2024: "User deny the voice require",
  2025: "Failed to set voice call, it needs https protocol",
  2026: "Others want have a voice call with you, but your audio device closed",
  2027: "Add comment",
  2028: "Rect comment",
  2029: "Circle comment",
  2030: "Arrow comment",
  2031: "Tag comment",
  2032: "Start showing",
  2033: "Speaker",
  2034: "Change speaker",
  2035: "Close showing",
  2036: "Watch",
  2037: "Stop watch",
  2038: "Input message",
  2039: "Audience",
  2040: "Pen",
  2041: "Eraser",
  2042: "The administrator modifies the operation permissions for this file",
  2043: "Files",
  2044: "Number of files in subunit",
  2045: "No file uploaded",
  2046: "He(she) uploaded nothing in the department",
  2047: "He(she) uploaded nothing in the folder",
  2048: "Files Uploaded",
  2049: "List his files ",
  2050: "List his files",
  // 2051: '各部门文件数量统计',

  // 2052: '确定要删除这些笔画吗？',
  // 2053: '确定要删除此人的所有笔画吗？',
  // 2054: '无效的输入值',
  // 2055: '该目录下没有符合搜索条件的文件！',
  // 2056: '全部用户',

  2051: "number of documents of various departments statistics",
  2052: "Are you sure you want to delete these strokes do? ",
  2053: "Are you sure you want to remove all strokes this person do? ",
  2054: "invalid input value",
  2055: "No files that match the search criteria in the directory! ",
  2056: "All Users",
  // -------------------------------- 前台设置
  2300: "Account information",
  2301: "Set password",
  2302: "Set notification",
  2303: "Basic service for professional version",
  2304: "About to expire",
  2305: "Expired",
  2306: "Renew",
  2307: "Please {-dosomething-} in time.",
  2308: "User of enterprise version",
  2309: "User of personal version",
  2310: "User of professional version",
  2311: "Expiry date",
  2312: "Order details",
  2313: "Effective days",
  2314: "Change the portrait",
  2315: "Mobile",
  2316: "Unbinded",
  2317: "Bind",
  2318: "No email has been bound, and you might not be able to receive any notification from babel",
  2319: "Nickname",
  2320: "You are not allowed to update online for now. Please contact us for support.",
  2321: "Failed to get the storage information",
  2322: "Upload the portrat",
  2323: "Bind the mobile phone",
  2324: "The mobile is bound successfully",
  2325: "Please input the mobile phone number",
  2326: "Bad mobile phone number format",
  2327: "please input the Guard code",
  2328: "Please input the password",
  2329: "The password must be between 6 and 20 characters or numbers",
  2330: "Change the nickname",
  2331: "Please input the nickname",
  2332: "Change the email",
  2333: "Please input the new email",
  2334: "Change the mobile phone",
  2335: "Please input the new mobile phone",
  2336: "Guard code",
  2337: "email Guard code",
  2338: "Bind the email",
  2339: "Please input the email",
  2340: "Bad email format",
  2341: "You have not bound any email or mobile phone. Please bind one, so you can login babel with Guard code",
  2342: "Old password",
  2343: "New password",
  2344: "Confirm password",
  2345: "Reset",
  2346: "Done",
  2347: "Wrong password",
  2348: "You are not logged in yet.",
  2349: "Something is wrong with the internet, please try it latter.",
  2350: "Please input the old password",
  2351: "Please input the new password",
  2352: "Please input comfirmation password",
  2353: "Your password and confirmation password do not match",
  2354: "Please tick the message type you want",
  2355: "Upload",
  2356: "Comment",
  2357: "Participation of shared files/folders",
  2358: "You have not bound any email yet, so there might be problems to receive our notifications.Please bind an email.",
  2359: "Go bind",
  2360: "Please initialize the password for login",
  2361: "Please input the Guard code",
  2362: "Public group",
  2363: "Create a group",
  2364: "No group yet",
  2365: "Personal private group",
  2366: "Failed to get group information.Please try it later.",
  2367: "Are you sure to delete this group？",
  2368: "The group name field can not be left empty",
  2369: "Are you sure to remove this guy out of this group？",
  2370: "Group name",
  2371: "Group member",
  2372: "The group member field is empty",
  2373: "Please input the group name.",
  2374: "First",
  2375: "Prev",
  2376: "Next",
  2377: "Last",
  2378: "pages",
  2379: "jump to {-no.-}",
  2380: "items",
  2381: "Create a postbox",
  2382: "Postbox setting",
  2383: "Add from the enterprise member list",
  2384: "Personal group",
  2385: "Get captcha",
  2386: "Failed to get the user information",
  2387: "There is no file",
  2388: "All roles",
  2389: "Dep. edit",
  2390: "Not joined",
  2391: "Input username or filename",
  2392: "Selection of text watermark",
  2393: "Sharer name",
  2394: "Use user ID watermark",
  2395: "After using the user ID watermark, the watermark of the file is displayed as the viewer's registered account. Anonymous users see the sharer's watermark.",
  2396: "mail,phone or user name",
  // 2397: '保密档案，除了创建者和部门经理外其他人不可见',
  // 2398: '限制档案，除了创建者和本部门经理外其他人不能借阅',
  // 2399: '内部档案，只有档案所在部门内人员可以借阅',

  2397: "Confidential files, in addition to the founders and managers are not visible to other people",
  2398: "Restricted files, in addition to the creator and manager of the department can not borrow someone else",
  2399: "Internal files, only files within the department where staff can borrow",
  // 2400: '文件目录',
  // 2401: '访问次数',
  // 2402: '次',

  2400: "directory",
  2401: "visits",
  2402: "times",
  2403: "It's not a file belongs you. You don't have permission to delete it completely",
  2404: "Add from enterprise member list",
  2405: "Are you sure you want to move this department out of the group?",
  //-------------------------------------- 胡继超新增

  2500: "Sender",
  2501: "{-somebody-} kicked off the Review&Approval process of {-file-}，and forwarded you",
  2502: "Expired",
  2503: "Edit",
  2504: "Current folder",
  2505: "File type",
  2506: "Everything",
  2507: "Filename only",
  2508: "Department",
  2509: "Basic",
  2510: "Add permissions",
  2511: "Deadline",
  2512: "Click view file access control",
  // 2513: 'mac地址绑定',
  // 2514: '开启mac地址绑定',
  // 2515: '开启mac地址绑定后，绑定mac地址的账号无法在其他mac地址上访问客户端。',
  // 2516: '绑定列表',
  // 2517: 'mac地址池',
  // 2518: '新增绑定',
  // 2519: '没有绑定记录',
  2513: "mac address binding",
  2514: "Open the mac address binding",
  2515: "When you turn on mac address binding, binding mac address of the account can not access the client on the other mac address.(Unrestricted on the web side)",
  2516: "binding list",
  2517: "mac address pool",
  2518: "new binding",
  2519: "No binding record",
  // 2520: '提示: 当前没有mac地址绑定记录,你可以通过点击“新增绑定”按钮,绑定员工的mac地址',
  // 2521: '没有符合条件的绑定记录',
  // 2522: '提示: 你可以更改搜索条件,重新进行搜索',
  // 2523: '绑定的mac地址',
  // 2524: '绑定的mac地址池',
  // 2525: '客户端在线状况',
  // 2526: '当前mac地址',
  // 2527: '绑定mac地址',
  2520: 'Note: There are currently no mac address binding record, you can click on the "Add Binding" button, binding mac address employees',
  2521: "do not meet the conditions of the binding record",
  2522: "Tip: You can change the search criteria, re-searching",
  2523: "Binding mac address",
  2524: "mac address binding pool",
  2525: "Client online status",
  2526: "Current mac address",
  2527: "Binding mac address",
  // 2528: '最多添加{-max-}个,已添加{-num-}个',
  // 2529: '输入绑定的mac地址',
  // 2530: 'Department member',
  // 2531: 'Group member',
  // 2532: '多个地址用空格键或者逗号分隔,留空为不绑定（AA:AA:AA:AA:AA:AA）',
  // 2533: '选择mac地址池',
  // 2534: '新建一个mac地址池',
  // 2535: 'mac地址池是事先设定好的mac地址组合，以实现快捷管理。如果没有设定，可以点击“{-text-}”建立一个，选择“无”表示不绑定mac地址池',
  // 2536: '新增',
  // 2537: '警告： 批量编辑将清空之前的绑定记录，按新的规则进行mac地址的重新绑定',

  2528: "add up to a {-max-}, {-num-} has been added a",
  2529: "Enter Binding mac address",
  2530: "Department member",
  2531: "Group member",
  2532: "a plurality of addresses or comma-separated by spaces, is not bound blank (AA: AA: AA: AA: AA: AA)",
  2533: "mac address selected pool",
  2534: "a new mac address pool",
  2535: 'mac address pool is pre-configured mac address combinations, in order to achieve quick management. If no, click "{-text-}" to establish a select "None" indicates no binding mac address pool ',
  2536: "New",
  2537: "Warning: binding record will clear the previous batch editing, re-bind mac address under the new rules",
  // 2538: "内含mac地址个数",
  // 2539: "客户端在线数量",
  // 2540: "编辑mac地址池",
  // 2541: "mac地址池名称",
  // 2542: "编辑mac地址",
  // 2543: "输入需要增加的mac地址",
  // 2544: "多个地址用空格键，换行或者逗号分隔",
  // 2545: "创建mac地址池",
  // 2546: "输入mac地址池名称：此处不允许重名",
  // 2547: "输入mac地址",
  // 2548: "新增mac地址池",

  2538: "mac address containing the number",
  2539: "Client number of online",
  2540: "edit mac address pool",
  2541: "mac address pool name",
  2542: "edit mac address",
  2543: "Enter need to increase the mac address",
  2544: "a plurality of address by a space, a comma-separated or newline",
  2545: "Creating a mac address pool",
  2546: "Enter the mac address pool name: the same name is not allowed here",
  2547: "Enter the mac address",
  2548: "new mac address pool",
  // 2549: "解除绑定",
  // 2550: "绑定当前地址",
  // 2551: "名称已存在",
  // 2552: "你的输入的地址中{-msg-}不符合mac地址的格式，提交后会被过滤，是否继续此操作",
  // 2553: '暂无mac地址，请点击”批量增加地址“向该地址池中添加mac地址',
  // 2554: '批量增加新地址',
  // 2555: '请选择mac地址池',
  // 2556: '了解安全级别',
  // 2557: '保密文件，<span class="gray">默认除了创建者、项目负责人、文件负责人和部门经理外部门内其他人不可见，分享该文件必须获得安全保密员授权</span>',
  // 2558: '限制文件，<span class="gray">一般人员只读，分享该文件必须获得上级主管授权</span>',
  // 2559: '内部文件，<span class="gray">分享该文件给部门外人员，必须获得上级主管授权</span>',

  2549: "unbind",
  2550: "Bind current address",
  2551: "name already exists",
  2552: "Address your input {-msg-} does not conform to the format mac address, will be filtered after the submission, whether to continue the operation",
  2553: 'No mac address, click "Batch Add Address" add addresses to the address pool mac',
  2554: "Batch add a new address",
  2555: "Please select mac address pool",
  2556: "understanding of the level of security",
  2557: 'Confidential files, <span class = "gray"> by default, the files are invisible except for the creator, project leader, document leader and department manager, and the sharing of the document must be authorized by the security officer. </ span> ',
  2558: 'Restricted files, <span class = "gray"> which are read-only by general personnel, and must be authorized by superior supervisor to share the file. </ span>',
  2559: 'Internal files, <span class = "gray"> to share the document to the personnel outside the Department, the authority of the superior must be obtained. </ span>',
  // 2560: '以上三种文件，不支持链接分享',
  // 2561: '提示: 当前没有mac地址池,你可以通过点击“新增mac地址池”按钮,添加mac地址池',
  // 2562: '设备管理',
  // 2563: '于',
  // 2564: '在线设备',
  // 2565: '当前设备',
  // 2566: '退出',
  // 2567: '你确定退出该设备的登录吗',
  // 2568: '巴别鸟客户端',
  2560: "The above three files do not support link sharing, only support invitation sharing.",
  2561: 'Note: There are currently no mac address pool, you can click on the "new mac address pool" button to add mac address pool.',
  2562: "Device Manager",
  2563: "on",
  2564: "Online equipment",
  2565: "current",
  2566: "Exit",
  2567: "Are you sure you log out of the device",
  2568: "Babel birds client",
  // 2569: '巴别鸟网页',
  // 2570: '给你发送了文件',
  // 2571: '点击此处下载',
  // 2572: '该文件已被删除',
  // 2573: '你邀请的人员中包含部门外部人员，需要上级主管审批，申请已经发送，请等待审批结果',
  // 2574: '{-sign-}了你对文件{-fileName-}的分享请求',
  // 2575: '开放级别',
  // 2576: '所限部门',
  // 2577: '保密文件，限制文件，一般人员不能移动，上级主管和有部门文件管理权限的人员才可以移动',
  2569: "Babel birds page",
  2570: "send you the file ",
  2571: "Click here to download",
  2572: "The file has been deleted",
  2573: "The file is under internal protection, and the invited person needs approval from the department head of the file. The application has been sent, please be patient",
  2574: " {-sign-} {-fileName-} you of requests for file sharing",
  2575: "Open level",
  2576: "limited sector",
  2577: "Confidential files, restricted files, the general staff can not move , copy , upload the new version , download , rename , view the version. Only the superior supervisor and the personnel with the authority of document management of the Department can.",
  2578: "Click to view group members",
  // 2600: '快速发送文件',
  // 2601: '选择或输入文件接受者邮箱地址',
  // 2602: '邮件代收',
  // 2603: '使用巴别鸟代收我的邮件',
  // 2604: '域名',
  // 2605: '请输入要代收邮箱的域名',
  // 2606: '端口号',
  // 2607: '请输入要代收邮箱端口号',
  // 2608: '同步邮件',
  // 2609: '同步邮件可能需要花费几分钟时间，你可以离开此页面继续其他工作',
  2600: "quickly send a file",
  2601: "Select the file or enter the recipients email address",
  2602: "Mail collection",
  2603: "Babel birds use my mail collection",
  2604: "domain",
  2605: "Please enter the domain name to the collection of mailbox",
  2606: "port number",
  2607: "Please enter the port number you want to collect mail",
  2608: "sync messages",
  2609: "Synchronization message may take a few minutes, you can leave this page and continue with other work",
  // 2610: '大窗口显示',
  // 2611: '全选',
  // 2612: '请输入代收邮箱的账号',
  // 2613: '追加文件权限',
  // 2614: '文件权限设置统计',
  // 2615: '控',
  // 2616: '设置邮箱',
  // 2617: '部门中进行过权限限制的文件将出现在这里',
  // 2618: '非本企业部门人员',
  // 2619: '你没有查看该文件的权限',
  // 2620: '巴别鸟可以代收你设定的邮箱邮件及附件，打开邮件代收按钮后设置需要代收的邮箱，你的邮件及附件将会保存在“我的邮箱”目录中',
  // 2621: '访问控制',
  // 2622: '暂无内容',
  2610: "large window",
  2611: "Select All",
  2612: "Please enter collection account mailbox",
  2613: "add file permissions",
  2614: "File permissions statistics",
  2615: "Control",
  2616: "Set mailbox",
  2617: 'Babel can manage file access rights in department files. Right click on department files and select "file access control" to change file access permissions. After changing the access rights, the files and folders can be managed uniformly here',
  2618: "non-personnel department of the enterprise",
  2619: "You do not have permission to view the document",
  2620: 'Babel birds can collect your mail messages and attachments set, open the message after collecting buttons to set the required collection of mail, your messages and attachments will be saved in the "my mailbox" directory',
  2621: "Access Control",
  2622: "There is no content",
  2623: "Create Shortcut",
  2624: "Output file list",
  2625: "Shortcut",
  2626: "Synchronizing...",
  2627: "Zoom in",
  2628: "Zoom out",
  2629: "Fit Screen",
  // 2630: '设置邮箱成功后，点击“同步邮件”开始接收',
  // 2631: '授权码',
  // 2632: '请输入授权码（登录QQ邮箱，设置--账户，开启POP3服务，生成授权码）',
  // 2633: '拉选放大',
  // 2634: "提示 : 没有在线的外部员工",
  // 2635: '该账号已经注册为巴别鸟账号，请输入其他邮箱或手机',
  // 2640: '端口号只允许输入数字',
  // 2650: '企业管理员',
  // 2651: '部门经理',

  2630: 'After setting mailbox is successful, click "Synchronize Mail" to start receiving ',
  2631: "authorization code",
  2632: "Please enter authorization code (login QQ mailbox settings - accounts, open the POP3 service, authorization code)",
  2633: "La is selected to enlarge",
  2634: "Tip: external staff online",
  2635: "The account has been registered as a bird Babel account, enter a different mailbox or mobile phone",
  2640: "Digital input only port number",
  2650: "Enterprise Administrators",
  2651: "manager",
  2652: "Read online",
  // 在线阅读
  2653: "Copy",
  // 2654: '文件统计',
  // 2655: '活跃文件',
  // 2656: '系统活跃度',
  // 2657: '部门范围',
  // 2658: '时间范围',
  // 2659: '请选择文件类型',
  // 2660: '全部类型',
  // 2661: '该部门暂无文件',
  // 2662: '本周',
  // 2663: '本月',
  // 2664: '本季度',
  // 2665: '本年',
  // 2666: '一年内',
  // 2667: '两年内',
  // 2668: '文件活跃度统计',
  // 2669: '访问次数',
  // 2670: '请选择时间范围',
  2654: "file statistics",
  2655: "active documents",
  2656: "The system activity",
  2657: "sector scope",
  2658: "time",
  2659: "Please select the file type",
  2660: "all types",
  2661: "No document in the sector",
  2662: "This week",
  2663: "this month",
  2664: "This quarter",
  2665: "year",
  2666: "within a year",
  2667: "within two years",
  2668: "file activity statistics",
  2669: "visits",
  2670: "Please select time",
  // 2671: '各部门文件个数',
  // 2672: '级部门',
  // 2673: '部门文件与文件夹访问人次',
  // 2674: '部门文件访问人次',
  // 2675: '显示手绘笔迹列表',
  // 2676: '文件说明',
  // 2677: '回收站设置',
  // 2678: '企业文件在回收站的保留时间',
  // 2679: '请输入天数',
  // 2680: '注：企业文件在回收站的留时间可以自由修改为1 - 999 天',
  // 2681: '天',
  // 2682: '在文档中查找…',
  // 2683: '查找词语上一次出现的位置',
  2671: "The number of documents of various departments",
  2672: "level department",
  2673: "Folder access times",
  2674: "File access times",
  2675: "Show list of hand-drawn stroke",
  2676: "File Description",
  2677: "Recycle Bin settings",
  2678: "Retention time of files in Recycle Bin",
  2679: "Please enter the number of days",
  2680: "Note: The retention time of files in the recycle bin can be freely modified to 1 - 999 days.",
  2681: "day",
  2682: "Find in the document ...",
  2683: "Find a position on the first occurrence of the words",
  // 2684: '查找词语后一次出现的位置',
  // 2685: '上一处',
  // 2686: '下一处',
  // 2687: '查找',
  // 2688: '高亮显示',
  // 2689: '整词匹配',
  // 2690: '区分大小写',
  // 2691: '{-somebody-} 将文件（夹）{-file-} 的负责人由 {-from-} 改为 {-to-}',
  // 2692: '该分组名已存在',
  // 2693: '给你分享了文件',
  // 2694: '设置截止日期',
  // 2695: '去除截止日期',
  2684: "location after finding the first occurrence of the word",
  2685: "on a",
  2686: "at the next",
  2687: "Find",
  2688: "highlighted",
  2689: "whole word matching",
  2690: "case-sensitive",
  2691: "{-somebody-} file (folder) {-file-} head changed from {-from-} {-to-}",
  2692: "name already exists in the packet",
  2693: " for you to share files",
  2694: "Set deadline",
  2695: "remove deadline",
  //----------------2700  归档
  2700: "Archives",
  2701: "My applications",
  2702: "Borrowing Approval",
  2703: "Modified",
  2704: "Archived by",
  2705: "Empty",
  // 没有归档文件(夹)
  2706: "Archives",
  2707: "untreated",
  //未处理
  2708: "At",
  2709: "Require",
  // 申请内容
  2710: "Status",
  // 审批状态
  2711: "approver",
  // 审批人
  2712: "Review",
  2713: "Time",
  2714: "Todo(dropdown)",
  // 未审批(下拉选择)
  2715: "My borrowed",
  // 我的借阅
  2716: "Empty",
  // 没有借阅文件(夹)
  2717: "Empty",
  // 没有文件(夹)的借阅申请
  2718: "department review",
  // 部门审批状态
  2719: "manager review",
  // 企业审批状态
  2720: "Applicant",
  //申请人
  2721: "Purpose",
  // 申请理由
  2722: "Dep review",
  2723: "Ent review",
  2724: "Return",
  // 归还
  2725: "Are you sure to return the archive？",
  2726: "{-somebody-} apply to {-type-} the archive {-file-}，for：{-comment-}",
  2727: "Your application for {-file-} has been passed",
  2728: "Your application for {-file-} has been refused",
  2729: "Location",
  2730: "You cannot read it without authorization",
  2731: "Borrow history",
  2732: "return",
  2733: "Search applicant，press Enter to do",
  2734: "Search archive Enter to do",
  2735: "Starting and ending date",
  //----手绘
  // 2736: '隐藏手绘笔迹',
  // 2737: '手绘列表',
  // 2738: '查看手绘笔迹',
  // 2739: '{-somebody-} 在文件(夹){-file-}中添加了手绘笔迹',
  // 2740: '{-somebody-} 在文件(夹){-file-}中删除了手绘笔迹',

  2736: "hidden hand-painted handwriting",
  2737: "a list of hand-painted",
  2738: "View hand-painted handwriting",
  2739: "{-somebody-} file (folder) {-file-} painted added handwriting",
  2740: "{-somebody-} file (folder) {-file-} deleted painted handwriting",
  //------图形工具
  // 2741: '图形工具',
  // 2742: '基本',
  // 2743: '选择你需要插入的图形，在图纸相应位置点击即可插入',
  // 2744: '保存焊接图标',
  // 2745: '{-somebody-} 在文件(夹){-file-}中添加了焊接图标',
  // 2746: '{-somebody-} 在文件(夹){-file-}中删除了焊接图标',
  2741: "graphical tool",
  2742: "basic",
  2743: "Select the graphic you want to insert, you can insert the corresponding position in the drawing click",
  2744: "Save welding icon",
  2745: "{-somebody-} file (folder) {-file-} welded added icon",
  2746: "{-somebody-} file (folder) {-file-} welded deleted icon",
  //------
  // 2747: '文件负责人',
  // 2748: '转换负责人',
  // 2749: '设置文件负责人',
  // 2750: '搜索用户名或邮箱',

  // 2800: '部门内所有人',
  // 2801: '部门内所有未设置追加权限的普通成员',
  // 2802: '请输入附言',
  // 2803: '（继承）',
  // 2804: '子文件中有设置附加权限，是否要覆盖原有设置？（覆盖后，所有子文件的追加权限都会重置为当前追加权限）',
  // 2805: '覆盖',
  // 2806: '追加',
  2747: "Responsible",
  2748: "change",
  2749: "Set file person in charge",
  2750: "search for a user name or mailbox",
  2800: "Everyone in the department",
  2801: "All ordinary members in the Department who have not set additional permission",
  2802: "Please enter postscript",
  2803: "unset ({-name-}-inherited)",
  2804: "sub-file has set additional permissions, whether you want to overwrite the original settings? (Rear cover, all subfolders additional permissions are reset to the current privilege added) ",
  2805: "coverage",
  2806: "add",
  2810: "New Project",
  2811: "New sub",
  2812: "Project Information",
  2813: "Please enter the project name",
  2814: "Leader",
  2815: "Click to select the person in charge",
  2816: "Project staff",
  2817: "Select project leader",
  2818: "Select the project members",
  2819: 'No project members, you can click the "Add person" individually invite members to join the project. You can click the OK button to complete the new project, right-click on the "Project Management" click "Get invitation link address" in the project management panel address and obtain a copy (scan code) distributed to people or groups you want to join ',
  2820: "forward the item",
  2821: "The current department",
  2822: "manager",
  2823: "target Dir",
  2824: "target manager",
  2825: "transfer",
  2826: "Project Type",
  2827: "Project",
  2828: "sub",
  2829: "into subprojects",
  2830: "into the parent project",
  2831: "target item",
  2832: "Select target project",
  2833: "Project Management",
  2834: "Please select target item",
  2835: "Project Information Incomplete",
  2836: "Please invite people to join the sharing of file (folder) {-file-}",
  2837: "No permission to create projects in the sector",
  2838: "select target sectors (project)",
  2839: "contained in the sub program, the operation fails! ",
  2840: "Click here to share in the sector",
  2841: "click to see additional file list",
  2842: "Manage shared files",
  2843: "Note: Here show all files containing the additional privileges within the department, excluding sub-department! ",
  2844: "No current department is set to file access control",
  2845: "View Shares",
  2846: "Close Share",
  2847: "Sharer",
  2848: "The folder",
  2849: "within the department to share",
  2850: "All share files within the department",
  2851: "current directory did not open file sharing (folder)",
  2852: "Confidentiality",
  2853: "Confidentiality file statistics",
  2854: "No special confidentiality of documents within the department",
  2855: "All confidentiality files  within the department",
  2856: "Confidentiality file statistics",
  2857: "Message Cancel failed (timed out)",
  2858: "Message Cancel failed (please refresh and try again)",
  2859: "Within this sector contains {-count-} a shared file sharing is turned off? ",
  2860: "E-mail notification settings",
  2861: "Dynamic receiving settings",
  2862: "receives the notification",
  2863: "My works",
  2864: "Notification",
  2865: "weak notification",
  2866: "About files I uploaded.",
  2867: "About files I commented.",
  2868: "About the documents I'm drawing concern",
  2869: "Share I joined.",
  2870: "Department document.",
  2871: "sub-sector documents",
  2872: 'File "{-name-}" contains the following illegal characters, please re-upload renamed: "{-str-}"',
  2873: 'File "{-fileName-}" upload failed, Inbox "{-name-}" upload only allows the extension "{-str-}" file ',
  2874: 'File "{-fileName-}" upload failed, Inbox "{-name-}" is only allowed to upload a file named "{-str-}" file ',
  2875: "Members setting",
  2876: "Role setting",
  2877: "Add file access to department roles (only valid for this file or folder and its subfile)",
  2878: "Authorized Number: {-count-}",
  2879: "Service Authorization",
  2880: "Your personal space occupancy rate is more than 90%. You can contact the administrator to expand the space",
  2881: "Contact phone",
  //------------------------------------- 企业后台

  3000: "Setting",
  3001: "Configuration",
  3002: "Structure",
  3003: "Members",
  3004: "Permission",
  3005: "Tags",
  3006: "Review&Approvals",
  3007: "Bulletins",
  3008: "Groups",
  3009: "Watermark",
  3010: "NO.",
  3011: "Verified",
  3012: "Unverified",
  3013: "Basic information",
  3014: "Contact",
  3015: "Logo",
  3016: "Domain",
  3017: "Storage",
  3018: "Increase",
  3019: "Batch modify personal space limit of members",
  3020: "Members",
  3021: "Email notifications",
  3022: "Turn this off, and the user will not receive any notification.",
  3023: "Abbr.",
  3024: "The enterprise abbreviation can be displayed in the top title bar and is also the name of the root department of the enterprise",
  3025: "Enterprise name",
  3026: "The full name of the enterprise can be filled in and will be displayed on the login interface",
  3027: "Register mailbox",
  3028: "Bind a mobile",
  3029: "name",
  3030: "email",
  3031: "mobile",
  3032: "Select a picture",
  3033: "image files of jpg, jpeg, png, bmp formats, and with size less than 5MB.",
  3034: "Enterprise address",
  3035: "Babel enterprise space",
  3036: "This enterprise service runs until",
  3037: "Create",
  3038: "Search in department",
  3039: "Check the access log in this enterprise",
  3040: "Directly subordinate members are classified in terms of role, which can be edited. If you want to check the information about the members of a subordinate member, go click the corresponding review button.",
  3041: "Role/Structure",
  3042: "Move this department",
  3043: "New department",
  3044: "Delete this department",
  3045: "-A brief description on the department function-",
  3046: "Superior department",
  3047: "Creator",
  3048: "Create date",
  3049: "Branch",
  3050: "Member",
  3051: "Storage allocation for company",
  3052: "Storage allocation for department",
  3053: "Used",
  3054: "Browse the department files",
  3055: "Remaining space",
  3056: "Members",
  3057: "Members",
  3058: "Account management",
  3059: "Change the owner",
  3060: "Move to",
  3061: "The administrator has the permission to move the files of one employee to another",
  3062: "disable the account",
  3063: "Restore",
  3064: "Disable",
  3065: "Disable this account,so the user is not allowed to login this enterprise(recoverable).",
  3066: "Delete the account",
  3067: "The files belong to an account will be deleted as well when the account is removed. Please be very carefully",
  3068: "Last login",
  3069: "Permission management",
  3070: "Change",
  3071: "Enterprise-role",
  3072: "Personal used",
  3073: "name",
  3074: "gender",
  3075: "male",
  3076: "female",
  3077: "phone",
  3078: "employed",
  3079: "remarks",
  3080: "Save",
  3081: "Cancel",
  3082: "disabled",
  3083: "change password",
  3084: "email",
  3085: "department",
  3086: "Role",
  3087: "create",
  3088: "Babel allows one person to use different roles in different departments",
  3089: "personal quota",
  3090: "personal files",
  3091: "You can manage the permissions of all the roles in this company, you can also create new roles with specific permissions. (Others' files are files uploaded by other members in the department; your own files are files uploaded by yourself in the department)",
  3092: "department permission management",
  3093: "move to",
  3094: "name",
  3095: "description",
  3096: "OK",
  3097: "Select a department",
  3098: "Please select the parent department",
  3099: "Please input the department name",
  3100: "The same department name has already existed",
  3101: "All departments",
  3102: "Limit the storage allocation for this department",
  3103: "When disable this,The usable space for this department(subordinate department include) is not limited",
  3104: "Space can be used",
  3105: "Used space for the department",
  3106: "Storage limitation ",
  3107: "Access log",
  3108: "Check vistors",
  3109: "Search user Or file name...",
  3110: "Check all records",
  3111: "Access log only",
  3112: "Upload/download only",
  3113: "Anonymous users only",
  3114: "File",
  3115: "Shares",
  3116: "File log",
  3117: "The department/role of following {-length-} members will be changed",
  3118: "Batch changing department",
  3119: "Commit",
  3120: "used",
  3121: "Online",
  3122: "Offline",
  3123: "Freeze",
  3124: "No employee",
  3125: "Tip : No employee in this department",
  3126: "There are no qualified employees",
  3127: "Tip : You can change the search option",
  3128: "Name(Account)",
  3129: "",
  3130: "Employee management",
  3131: "Select employee",
  3132: "Are you sure to delete it from the department?",
  3133: "You are not allowed to delete accounts created by others!",
  3134: "The account has been deleted",
  3135: "Are you sure to {-prompt-} the selected account?",
  3136: "Upload employee list",
  3137: "Initialize password",
  3138: "Begin importing",
  3139: "Next",
  3140: "Upload",
  3141: "Please upload the files about employee information",
  3142: "Only excel files less than 2M are supported &nbsp;",
  3143: "Download the template",
  3144: "Random password",
  3145: "There will be a notification to change the initial password when the user logs in.",
  3146: "Importing",
  3147: "Done",
  3148: "Unknown error",
  3149: "Internet error",
  3150: "Failed to import",
  3151: "Issue an enterprise bulletin",
  3152: "Issue a bulletin",
  3153: "Check enterprise bulletins",
  3154: "Please input receivers",
  3155: "Internal bulletin, which can be delivered to everyone or designated one",
  3156: "Title",
  3157: "Please input title",
  3158: "Content",
  3159: "Please input content here",
  3160: "",
  3161: "characters left",
  3162: "Receiver",
  3163: "Please select receivers",
  3164: "Please input email",
  3165: "Add an issuer",
  3166: "Remove an issuer",
  3167: "Details",
  3168: "No bulletin",
  3169: "Tip : No old bulletins",
  3170: "Issuer",
  3171: "Topic",
  3172: "Time",
  3173: "Manage the issuers",
  3174: "",
  3175: "Search the bulletin topic",
  3176: "Check the bulletins",
  3177: "Please select members",
  3178: "Employee",
  3179: "Are you sure to delete the template {-name-}",
  3180: "No issuer",
  3181: "name(account)",
  3182: "Department-role",
  3183: "Tip : No information about the issuers",
  3184: "Failed to get the issuer's information",
  3185: "R&A process",
  3186: "Create a R&A process",
  3187: "Are you sure to delete the template {-name-} ",
  3188: "No R&A",
  3189: "Tip : No information about Review&Approval",
  3190: "Process name",
  3191: "approver",
  3192: "Usage count",
  3193: "Create a group",
  3194: "Are you sure to delete group {-name-}?",
  3195: "This group has been deleted",
  3196: "Failed to delete this group",
  3197: "No groups",
  3198: "Tip:No group information",
  3199: "Group name",
  3200: "Members included",
  3201: "Creator",
  3202: "Select a user",
  3203: "filter",
  3204: "Batch set the user's storage quota",
  3205: "Please input a number in the field, and click the save button. The storage quota of all the selected users will be changed, If the input number is 0, there is no limit",
  3206: "Batch increase the user's storage quota",
  3207: "Increase",
  3208: "This operation extends the users' storage quota in batch",
  3209: "Example: the upper limit of user a's space is 20G, and the upper limit of user B's space is 50G. Select them to add 50G of storage space in batch. After clicking the \"increase\" button, the upper space limit of user A is adjusted to 70G, and that of user B is adjusted to 100G.",
  3210: "",
  3211: "We have found {-totalNum-} members，with {-onlineNum-} members online.You can process them in batch on the right panel.",
  3212: "Batch edit",
  3213: "Name(account)",
  3214: "Login time",
  3215: "Department",
  3216: "",
  3217: "Online users",
  3218: "Advance options",
  3219: "retract",
  3220: "Please select posters",
  3221: "Please select other receivers",
  3222: "The postbox name field cannot be left empty",
  3223: "The additional comments field cannot be left empty",
  3224: "The closing date field cannot be left empty",
  3225: "The poster can upload documents to the post box, and manage them, but is not allowed to access the documents of other posters",
  3226: "Name",
  3227: "Other receivers",
  3228: "The other receivers can review and comment all the stuff in the postbox as well.",
  3229: "Create",
  3230: "Please select posters",
  3231: "Please choose the date",
  3232: "Use watermark",
  3233: "When watermark is enabled and configured, files with watermark will display the watermark during preview",
  3234: "Close the watermark",
  3235: "Select watermark scope",
  3236: "Show the watermark for each file",
  3237: "Show the watermark for shared files to outsiders",
  3238: "Decided by the sharer whether to show the watermark",
  3239: "Use text watermark",
  3240: "Custom text",
  3241: "Display position of watermark",
  3242: "Tile along the diagonal line",
  3243: "In the middle of document",
  3244: "At the head and tail of document",
  3245: "Watermark opacity",
  3246: "Effect preview",
  3247: "png files are supported. A resolution of 200*300 would be best",
  3248: "Use image watermark",
  3249: "Upload watermark image (PNG)",
  3250: "Bottom right corner",
  3251: "Loading",
  3252: "Statistics about members",
  3253: "Are you sure to delete this file permissions",
  3254: "Watermark image",
  3255: "Watermark preview",
  3256: "Tip : No internal employee",
  3257: "Department-Role",
  3258: "Succeed to change the upper limit of user storage",
  3259: "Failed to change because of some internet error",
  3260: "Failed to change the administrator's permission, because of some internet error",
  3261: ",The name field can not be left empty",
  3262: "Already in this department",
  3263: "Are you sure to remove the account of - <span class='f-emph'> {-name-} </span> -？",
  3264: "The files of this employee will be deleted as well",
  3265: "Are you sure to disable the account of - <span class='f-emph'> {-name-} </span> -？",
  3266: "Succeed to change the role",
  3267: "Failed to change the role. Please try it later.",
  3268: "Add a member",
  3269: "",
  3270: "Add from employee list",
  3271: "delete this account",
  3272: "Remove from the department",
  3273: "Batch importing members",
  3274: "Warning!",
  3275: "This operation will move all the account's files to another account, and clear everything of the account. Please be in mind that this operation is not revertable, and the owner of all the files will be changed for ever.",
  3276: "Owner",
  3277: "File type",
  3278: "File size",
  3279: "Please input a member's name/email",
  3280: "",
  3281: "Add from employee list",
  3282: "File information",
  3283: "Are you sure to delete this department?",
  3284: "The files in this department will also be DELETED when the department is deleted.",
  3285: "Dep.-role",
  3286: "Date",
  3287: "Save path",
  3288: "Change path",
  3289: "Select folder",
  3290: "Download file &nbsp;",
  3291: "Hide",
  3292: "Are you sure to cancel  download {-name-}",
  3293: "Undo",
  3294: "Enter the content",
  3295: "You have successfully created comments",
  3296: "Creating annotation fails, check the network or refreshing the page",
  3297: "Reply to comment fails, check the network or refreshing the page",
  3298: "Get list of comments fails, check the network or refreshing the page",
  3299: "Get file failed, please try refreshing the page",
  3300: "Space selection fails, please try again later",
  3301: "Space selection fails, can only be changed within 24 hours, please try again later",
  3302: "Keep those shared files can not quit!",
  3303: "Submission",
  3304: "A password is required to access this link",
  3305: "Cancel password failed, please try again later",
  3306: "Password setting success",
  3307: "Failed to set the password, please try again later",
  3308: "Please enter the name of the tab",
  3309: "The same name tag already exists",
  3310: "Edit",
  3311: "<strong>{-quoteNum-}</strong>Files use this tab",
  3312: "Only update the file reference I created",
  3313: "Update all file references using the label in the enterprise",
  3314: "Upload failed",
  3315: "Open the discussion group",
  3316: "Manage member",
  3317: "New",
  3318: "{-name-}  is an unregistered user, whether it is confirmed to invite the person to join the share？",
  3319: "Comparison",
  3320: "Compare or merge documents",
  3321: "Please select a file to compare or merge content",
  3322: "Original file",
  3323: "Select document",
  3324: "Select other files",
  3325: "There are no other versions of the file at the moment",
  3326: "You can {-other-} to compare or merge",
  3327: "Select from the other versions of the file",
  3328: "Document comparison",
  3329: "Document merging",
  3330: "Select a local file",
  3331: "Open",
  3332: "Reject",
  3333: "Do you confirm that the review status of this folder is set to 'Reject'?",
  3334: "Confidential",
  3335: "Restricted",
  3336: "Internal",
  3337: "Security level",
  3338: "Enterprise file security strategy",
  3339: "what is security strategy?",
  3340: "Inheriting the security policy of the parent department",
  3341: "Policy name",
  3342: "Default level of uploading files",
  3343: "Do all the shares have to be approved?",
  3344: "Approver",
  3345: "Default policy",
  3346: "Top-secret",
  3347: "1st-confidentiality ",
  3348: "2nd-confidentiality",
  3349: "Ordinary",
  3350: "Open",
  3351: "Confidential",
  3352: "Restricted",
  3353: "Internal",
  3354: "Open",
  3355: "Yes",
  3356: "No",
  3357: "security officer",
  3358: "Supervisor",
  3359: "Default",
  3360: "Department file security strategy",
  3361: "Add security officer",
  3362: "Management security officer",
  3363: "Confirm the identity of the security officer of the deletion of {-user-}",
  3364: "Security Auditor",
  3365: "Add security Auditor",
  3366: "Management security Auditor",
  3367: "Confirm the identity of the Security Auditor for the deletion of {-user-}",
  3368: "Hint：",
  3369: "Are you sure to delete",
  3370: "Company",
  3380: "Uploading department personnel files",
  3381: "",
  3382: "Image watermark does not support diagonal tiling",
  3383: "中文版",
  ///不翻译

  3384: "client-only access",
  3385: "Bind user mac address, can only access the client, APP and can not access the web client",
  3386: "Only here can create tag",
  3387: "Reset Password",
  3388: "Reset",
  3389: "Click to send reset link by email",
  3390: "Email sended!",
  3391: "Select version or file to compare",
  3392: " {-name-} is unregistered，are you sure to send the share link to him(her)？",
  3393: "No operation log",
  3394: "Attention：Nobody operate file",
  3395: "Found no operation log",
  3396: "You can {-other-} to compare",
  3397: "Hide administrator access logs",
  3398: "After this item is opened, ordinary personnel will not be able to see the administrator's access records in the logs",
  3399: "Statistical Analysis",
  3400: "Click here to display the file was uploaded by someone within the department",
  3401: "Click here to display the file was uploaded by someone in the team",
  3402: "Upload log",
  3403: "Click here to display the file was uploaded by someone within the project",
  3404: "Number of folders accessed",
  3405: "Number of files accessed",
  3406: "Number of people accessing folder",
  3407: "Number of people accessing file",
  3408: "Personal file occupation",
  3410: "Create sub-sector",
  3411: "Delete sub-sector",
  3412: "Modify sub-sector",
  3413: "Management Recycle Bin",
  3414: "managing file access control",
  3415: "archive",
  3416: "document security classification management",
  3417: "instructions sharing request",
  3418: "convert files person in charge",
  3419: "approval of management",
  3420: "Upload new versions of your own files",
  3421: "Rename your own files",
  3422: "Upload versions of other people's files",
  3423: "Rename the file of others",
  3424: "management staff within the department",
  3425: "Mode of person in charge of documents",
  3426: "When this mode is enabled, the person in charge of the file should be fully responsible for the file in his / her charge, that is, he / she has the right to manage the file automatically without being affected by his / her role in the Department. However, for files that are not responsible for themselves, their permissions are still limited by their own department roles. By default, the file (folder) that you upload to the Department is the person in charge, but if you upload it to the folder that someone else is responsible for, the person in charge of the file is not himself. The person in charge and the management members of the Department have the right to convert the document. If this mode is turned off, the authority of the person in charge of the file is completely limited by the role of the Department as ordinary people.",
  3427: "Department list of roles",
  // 3419: '',
  // 3419: '',
  // 3419: '',
  // 3419: '',
  3428: "operator",
  3429: "Are you sure you want to close share these files do? ",
  3430: "field can not be blank",
  3431: "department approval process",
  3432: "The current approval process strategy",
  3433: "editorial changes",
  3434: "Set up approval process",
  3435: "Set how to use the approval process when members of the Department initiate approval",
  3436: "No limitations",
  3437: "Restricted specific approval process",
  3438: "the same restrictions as the parent department",
  3439: "The group of at least",
  3440: "by people, the assessment can pass",
  3441: "there is no alternative approval process template",
  3442: "to create",
  3443: "Workspace push",
  3444: "Select members from the list below",
  //----------	5.8*-------------
  3445: "reading",
  3446: "Create a reading room",
  3447: "into the reading room only files and folders can be seen by ordinary people and borrow",
  3448: "Open level",
  3449: "defined sector",
  3450: "Enter the department name",
  3451: "Edit Reading Room",
  3452: "Add documents",
  3453: "a list of related documents",
  3454: "No documents",
  3455: "Add the corporate sector from the list",
  3456: "No members",
  3457: "No",
  3458: "Effect subfile containing",
  3459: "Download finalized PDF",
  3460: "download a watermarked PDF",
  3461: "Export Report",
  3462: "under the current filter criteria, you need to export the log number of more than 2000, the system will only export before 2000, determined to continue to export it? ",
  3463: "Export",
  3464: "{-somebody-} application {-type-} archive file (folder){-file-}, along with the words:{-comment-}",
  //-------------------5.9-------------

  3465: "Reporting",
  3466: "corresponding to the directory does not exist, open failure ",
  3467: "full-text search, press Enter",
  3468: "search for a file name, press Enter",
  3469: "Any person can be invited to join the project folder, and the default creator is the project leader (you can assign a new person in charge by transferring the project); after the current project phase is completed, the project leader can choose to transfer the project to the person in charge of the next stage, so that the folder can be transferred across departments. ",
  //---------------6.0------------------

  3470: "No account is frozen",
  3471: "need to borrow",
  3472: "can borrow within department",
  3473: "open within department",
  3474: "Reading Room in the file visible to everyone, users can directly within the Reading file for viewing, downloading and other operations",
  3475: "Reading Room in the file visible to everyone, users need to borrow in order to file for viewing in the reading, downloading and other operations",
  3476: "designated public sector staff within the department within visible, users can directly within the Reading file for viewing, downloading and other operations",
  3477: "Reading Room specify only visible within departments, users need to borrow in order to file for viewing in the reading, downloading and other operations",
  3478: "Project Manager",
  3479: "Allow anonymous uploads (online editing)",
  3480: "Allow anonymous upload later, if someone anonymously upload illegal files in the folder, share the responsibility borne by the originator",
  3481: "Need to set deadline",
  3482: "to set",
  3483: "Your account has been frozen, restore the account, please contact customer service, click OK to exit",
  //------------------6.1------------------

  3484: "personal work",
  3485: "No qualified users",
  3486: "File access statistics",
  3487: "people",
  3488: "total",
  3489: "read file",
  3490: "endorsement discussion",
  3491: "search",
  3492: "No qualifying results",
  3493: "has been spent {-days-} days",
  3494: "only the remaining {-days-} days",
  3495: "{-days-} days Expired",
  3496: "When using {-days-} days",
  3497: "Please select the default role of selected members",
  3498: "Whole folders",
  3499: "Current Date",
  /***************** 错误提示 *********************/
  3500: "Failed to add, please try later",
  3501: "Failed to get dep. info.",
  3502: "Dep. updated successfully",
  3503: "Failed to update space",
  3504: "set value equal to the occupied space, you will not be able to upload new content",
  3505: "role changed successfully",
  3506: "the role of modification failed, please try again later",
  3507: "added successfully",
  3508: "Adding personnel failed, please try again later",
  3509: "remove members from the department",
  3510: "removal failed, please try again later",
  3511: "Confirm delete this account?",
  3512: "Account is disabled",
  3513: "Deactivate Account failed",
  3514: "Account has been restored",
  3515: "Failed to restore the account",
  3516: "Publishing Success",
  3517: "failed to publish, please try again",
  3518: "Publisher has been deleted",
  3519: "OK to delete the selected publisher",
  3520: "Deleting failed, please try again",
  3521: "History Bulletin acquisition failure",
  3522: "Delete failed, server-side error",
  3523: "Failed to obtain approval information",
  3524: "Adding Grouping success",
  3525: "group information acquisition failure",
  3526: "The server side error, the administrator failed to obtain",
  3527: "Confirm to delete the administrator identity of- <strong> {-name-} </ strong>",
  3528: "Increasing storage limit success",
  3529: "Increasing storage limit failure",
  3530: "modify the storage limit success",
  3531: "modify the storage limit failure",
  3532: "internal staff online access to information failure",
  3533: "Online access to information external employees failed",
  3534: "link to access does not exist, returns management",
  3535: "Create Inbox failed!",
  3536: "Failed to modify or no permission",
  3537: "Failed to obtain information about the role of",
  3538: "Add Role failed, please try again later",
  3539: "Failed to modify role information, please try again later",
  3540: "Delete role information failed, please try again later",
  3541: "The role name can not have duplicate names",
  3542: "Getting enterprise watermark information failed, please try again later",
  3543: "Watermark range setting success",
  3544: "Watermark range setting failed, please try again later",
  3545: "text watermark setting success",
  3546: "text watermark setting failed, please try again later",
  3547: "image watermark setting success",
  3548: "image watermark setting failed, please try again later",
  3549: "Watermark successfully closed",
  3550: "Watermark close failed, please try again later",
  3551: "Selected",
  3552: "Update image",
  3553: "Upload image",
  3554: "Corporate information acquisition failed, please try again later",
  3555: "Enterprise user information acquisition failed, please try again later '",
  3556: "Saved successfully",
  3557: "Information format error, please try again",
  3558: "Sorry, you do not have permission to operate",
  3559: "Save failed, please try again later",
  3560: "Corporate logo upload failed, please try again later",
  3561: "Open the e-mail alert failed, please try again later",
  3562: "Off-mail alert failed, please try again later",
  3563: "internal staff access to information failure",
  3564: "Replace roles",
  3565: "Replace the role in whole enterprise",
  3566: "Old role",
  3567: "",
  3568: "",
  3569: "Replace with",
  3570: "Replaced successfully",
  3571: "Faile to replace，try again",
  3572: "Please select",
  3573: "Create a new role",
  3574: "Copy from old role",
  3575: "System logs",
  3576: "Download failed",
  3577: "View file",
  3578: "Progress",
  3579: "Select image",
  3580: "Preview avatar",
  3581: "Size is bigger than {-size-}MB, try a new file again",
  3582: "File tyep error",
  3583: "Only support png",
  3584: "Not shared",
  3585: "<span> {-folderCount-} folder(s) </ span> <span class = 'mgl-10'> {-fileCount-} file(s) </ span>",
  3586: "Created successfully",
  3587: "Tag being deleted",
  3588: "Failed to delete，no authority",
  3589: "Failed to delete，unknown error",
  3590: "Tag withraw successed",
  3591: "Tag withraw failed",
  3592: "Copying",
  3593: "Copy sucessed",
  3594: "Copy failed，unknown error",
  3595: "Copy failed, no space",
  3596: "Withdraw successfully",
  3597: "Withdraw failed",
  3598: "Folder created",
  3599: "Faile to create folder",
  3600: "Deleted successfully",
  3601: "Failed to delete",
  3602: "Failed to delete, try later",
  3603: "Failed because of having sharing in it",
  3604: "Known",
  3605: "Restored successfully",
  3606: "Failed to restore",
  3607: "Error code",
  3608: "Renamed successfully",
  3609: "Failed to rename,try later",
  3610: "Restored successfully",
  3611: "Failed to restore",
  3612: "Moving",
  3613: "Moved successfully",
  3614: "Include sharing",
  3615: "Cannot move file out of department",
  3616: "No authority to move in",
  3617: "Failed to move",
  3618: "Restored successfully",
  3619: "Failed to restore",
  3620: "Personal files",
  3621: "Search roles",
  3622: "File confidentiality setting failed, please try again later",
  3623: "Set watermark position success",
  3624: "Set watermark position fail",
  3625: "Set the watermark opacity success",
  3626: "Set watermark transparency fail",
  3627: "Set the user name watermark success",
  3628: "Set the user name watermark failure",
  3629: "Set the current successful business strategy",
  3630: "Set the current policy department of success",
  3631: "Get the address pool information failed, please try again later",
  3632: "Get mac address binding information failed, please try again later",
  3633: "The number of teams has reached the line, added Failed",
  3634: "User can upload personal files",
  3635: "If this option is turned off, users will not be allowed to upload personal private files, and the uploaded personal private files will be retained. Note: the administrator can make special treatment on whether a specific user owns personal private files in the member management function; files other than department folder and enterprise shared folder belong to personal private files",
  3636: "Entprise Setting",
  3637: "Not allow",
  3638: "Allow",
  3639: "Note: The upper input 0 means no space restrictions,",
  3640: 'Inbox "{-name-}" is only allowed to upload a file named "{-str-}" file ',
  3641: "you are already a member of the team",
  3700: "Department list of permissions",
  3701: "File permissions list",
  3702: "file sharing permissions",
  3703: 'Application of documents {-file-} "{-roleName-}" permission ',
  3704: "Postscript:",
  3705: " application file permissions",
  3706: "Send message",
  3707: "Choose file",
  3708: "From an existing file",
  3709: "upload new files",
  3710: "Accessories",
  3711: "post attachments",
  3712: "sends you a message",
  3713: "View History Messages",
  3714: "as a message attachments",
  3715: "sender",
  3716: "forward",
  3717: "You have a new notification system Bobby Bird, click View Details",
  3718: "department",
  3719: "Delete the enterprise",
  3720: "dissolution",
  3721: "Delete the enterprise will delete all the files of the enterprise, and the enterprise members will automatically become personal users. This is an irrecoverable operation. You need to enter the administrator password to perform this operation",
  3722: "Delete this account",
  3723: "Deleting this account will result in the loss of all files. This operation cannot be recovered and should be careful! You need to enter a password to perform this operation",
  3724: "After this operation, the enterprise owner will become the selected target user, and the current user will no longer be the enterprise owner. Please enter the current user password to continue this operation",
  3725: "You can also upload files by dragging them here",
  3726: "File configuration",
  3727: "File blacklist",
  3728: "File blacklist, i.e. file type blacklist. File types added to the blacklist will not be allowed to be uploaded. Enter the file extension you want to block to the list below",
  3729: "Please enter the file extension for blacklist, For example: jpg",
  3730: "Blacklist list",
  3731: "Extension for search",
  3732: "The extension already exists in the blacklist",
  3733: "No common labels",
  3734: "The number of application documents should not exceed 10",
  3735: "After the project expires, only the project manager can access and manage the project. This value can be null.",
  3736: "The extension already exists in the whitelist",
  ///////////////////////////首页

  4000: "Function",
  4001: "Price",
  4002: "Solutions",
  4003: "Enterprise edition public cloud",
  4004: "blog",
  4005: "innovative document management platform, shared collaborate more effectively",
  4006: "more efficient management and more fine",
  4007: "free trial",
  4008: "Babel Bird's corporate network disk client on the line",
  4009: "Windows + Mac dual platform release",
  4010: "Synchronization specify any files with ease",
  4011: "Babel Bird's corporate network disk",
  4012: "free download",
  4013: "Document Content VCN disk",
  4014: "Free sign Up",
  4015: "or log",
  4016: "Babel line on the bird's corporate network disk Professional Edition",
  4017: "Beyond' Personal Edition ', more powerful space",
  4018: "Use your documents anywhere, anytime, seamless collaboration",
  4019: "Now you can not only end login page, or by using a smart phone Babel Bird",
  4020: "At the same time, you can directly edit office documents online, without having to install office software,",
  4021: "Babel download Bird client",
  4022: 'direct discussions on the contents of the file, <br class="hidden-xs"> work together more editable',
  4023: "click on the place want to communicate, to open the discussion can even use voice and hand-painted circles painted, make communication more efficient and vivid, adding that all members can share real-time response, mobile end exchange more smoothly, office document click on the Edit button more can be modified online and automatically generate a new version. ",
  4024: "do not have to purchase additional software, <br> to view most of the documents",
  4025: "Supporting nearly 200 file formats without downloading any application, regardless of the commonly used office, Apple's own iWork, can be opened directly in Babel birds even design a dedicated PS, AI and even AutoCAD, Solidworks and other professional 3D. format, but also light preview loose collaborative discussion. after downloading the client, more calls on a PC and Mac native application to edit the contents of the cloud and automatically synchronizes, the real cloud work together seamlessly. ",
  4026: "Specify any folder automatically synchronize <br> share the latest information at any time",
  4027: "After the designated sync folder, any updates can be synchronized via synchronization to the end of each platform <br> need to re-download, upload, and need not be set manually, automatically by synchronizing shared file folder <br> team file. real-time updates, share the latest information easy. ",
  4028: "Learn more",
  4029: "by the security authorities QUALYS A",
  // 4030: "The most secure system of domestic SaaS",
  4030: "",
  4031: "Babel birds can control the access behavior of each and every member of the file, and leave detailed access log, you can understand the work of every member of the dynamic at the same time, Babel birds use the highest security level EV. SSL authentication, encrypted transmission bank-level, multi-room distributed multi-server backup. Make sure your data is secure. ",
  4032: "<br> tailored for the enterprise to solve all the needs of the document uses",
  4033: "For companies launched a large number of management capabilities to support a total of panel meetings, version management, document approval, members of the management, distribution of competences, large file transfers, large storage space can replace the mail and OA systems, and can even save business office and CAD and so on. professional software procurement costs. Babel birds is not just a corporate network disk <br> support public cloud and private cloud deployment, comprehensive solution to your document management problems. ",
  4034: "Understanding the bird Babel Enterprise Services",
  4035: "product",
  4036: "Team",
  4037: "Support",
  4038: "function",
  4039: "Pricing",
  4040: "Trial Enterprise Edition",
  4041: "Terms of Service",
  4042: "Privacy Policy",
  4043: "Company",
  4044: "Contact us",
  4045: "Join us",
  4046: "Birds on iOS Download Babel",
  4047: "Birds Download Android version of Babel",
  4048: "Babel Bird product brochures",
  4049: "advice and recommendations",
  4050: "From the document, efficient collaboration",
  4051: "Our work often revolves around various documents and ends around various documents. Whether it's planning an interesting outdoor trip or building a spectacular project, we need to deal with a lot of documentation. From a word document to a 3D design drawing of a dam, you can directly discuss the content of the document by dragging it into the Babel and inviting team members to join. Web, IOS, Android full platform real-time collaboration. It's a real way to manage and manage files.",
  4052: "Babel download product brochures Bird",
  4053: "Documents",
  4054: "Our work plan and work product",
  4055: "The document is the basic unit of Babel birds management, but also teamwork, knowledge sharing and creative communication core of all business documents can be placed on different categories of Babel Babel birds birds will give you a well ordered sequence work environment, you can easily find and distribute the work required documentation, you can quickly access to specially formatted documents, but also to discuss freely and team members based on document content. ",
  4056: "Our common space",
  4057: 'and you are familiar with network disk to use as convenient, but more suitable companions use with click." New "button, you can create folders, and folders are named according to actual needs, by creating different folders categorized manage documents. you and partners can share a folder and share documents more easily. ',
  4058: "We can direct dialogue on the content of the document",
  4059: 'You can carry out and team members together on Babel birds to discuss the establishment directly on the document." Annotations "depth discussions for specific details, and unified management can quickly navigate to the content discussion, keep the discussion around the theme yet coke. ',
  4060: "Discussion",
  4061: "Organized to more efficient",
  4062: "You can create and manage teams, and team members share knowledge team file folder is automatically shared with every member and can manage privileges for each member of the team is a discussion group at the same time, you can even put. when the WeChat team group with. ",
  4063: "Format",
  4064: "There is no form to let fly thinking",
  4065: "Using Babel birds, you almost do not have to worry about a document open Babel bird is support for opening up the majority of network disk network disk format can not preview special formats, such as PSD, Ai, DWG and so on, with a. Babel birds can easily review and discussion without having to purchase and install additional applications. ",
  4066: "Permission",
  4067: "security guarantee",
  4068: "Babel birds can control the user's permissions, document permissions, various privileges program allows you to choose a safe and secure on the flexible use and the use of H5 to display documents, the bird Babel can effectively protect your source. access files, and can track the file and open the case, the document is open, preview, discussion, download, forward, edit the permissions you can control. ",
  4069: "Client",
  4070: "collaborate more effectively doubled",
  4071: "Clients can work as an entrance, after opening can view all your files on Babel bird, agency matters most dynamic and exciting sector members is that the client can use the transfer of local application directly. Pakistan edit files on other birds, the editing process is automatically locked, automatically generate a new version after editing. this means that you can modify the same team members and office documents, or 3D models, CAD design draft. need to upload the whole team work in the cloud. ",
  4072: "anytime, anywhere",
  4073: "Whether it is a mobile phone APP, or use a computer or the web version of the client, Babel birds can directly edit office documents, truly collaborative work anywhere you can easily modify your presentation using a mobile phone on the subway. PPT, can be at the airport proofread sales data reports, modify the terms of the contract and do not need to send your e-mail will modify real-time notification to your team members or customers with client uses, even the transfer of your AutoCad editing you do in Pakistan drawings, seamless experience on the bird more to enhance the efficiency of up to 300 ",
  4074: "I have you you have me",
  4075: "If you already have OA, ERP or even other document management systems, it does not matter you can enjoy Babel birds of service, as long as the use of Babel birds interfaces, wherever there is a document that appears we can use Babel birds complete turn code and discussion, and enjoy the convenience brought by birds Babel and efficiency gains. ",
  4076: "Babel birds - efficient document collaboration system",
  4077: "Now experience",
  4078: "Reducing the meeting",
  4079: "Using Babel birds we can discuss the contents of the file directly support voice intercom, handwriting, etc. (need to meet Babel Birds app use) all discussions can be unified management, to-do and follow up the implementation. results farewell meeting disorganized, improve work efficiency. ",
  4080: "Revision Management",
  4081: "Babel birds can easily manage various historical versions of files, and can easily switch between the various versions compare similarities and differences.",
  4082: "controllable security",
  4083: "fortress is from within is often compromised, birds Babel Enterprise Edition is technically the use of industry-standard RSA + AES 128-bit encryption algorithm (bank-level encryption is legendary) but the most important thing is the design, Pakistan the birds do not use a separate preview files and source files approach, with H5 page preview and manipulate files, not the transfer of the source file use, rights management + without downloading method used to the maximum extent possible to protect the security of your data. because the use of web preview, so all files can be usage tracking, security can control. ",
  4084: "Monitoring and analysis",
  4085: "Babel Birds use the web dissemination and discussion papers means that we can understand our shared file usage by Babel birds we can know whom we share the file is opened, when opened, looked at how many pages remain. the length of time and other information to help us understand the use of the file and make a decision. ",
  4086: "personalized",
  4087: "Babel customization birds Enterprise Edition supports logo and interface, in the background you can easily replace the logo, to create exclusive enterprise applications, improve their sense of belonging.",
  4088: "Customizable store",
  4089: "Using Babel birds Enterprise Edition we have to worry about running out of space, you can choose from an initial capacity to 500G unlimited storage space.",
  4090: "Privatization deployment",
  4091: "All the data stored in the internal private network server, any external staff (including birds Babel official) can not be accessed In addition, the deployment of a network of excellent network performance, fast file synchronization speed, maximize and improve efficiency..",
  4092: "Mobile Commerce",
  4093: "Babel birds Enterprise Edition can use a dedicated APP, and whether it can have a web version of the same user experience and features on your phone or iPad so that you can use anytime, anywhere file and efficiently complete the work..",
  4094: "Online editing",
  4095: "Babel Birds mobile phone APP and web version of the online editing office documents, can automatically lock to prevent conflicts and edit, edit completion of the new version automatically generated using Babel birds client but also the transfer of local applications to edit online files.",
  4096: "improve efficiency",
  4097: "Babel birds allow the company to share the same storage space, members of the copies of the same document collaboration, enterprises can significantly reduce storage costs while eliminating the need for mailing back and forth discussions and complex approval process, a document has to change personnel. will be able to instantly receive correspondence promptly notified. after testing, the system can enhance the birds Babel knowledge-based enterprises 300 ",
  4098: "Open Interface API",
  4099: "Dependent Interface (API) Babel birds Enterprise Edition open storage, analysis and discussion of the document, according to their business needs, develop a variety of applications, can also be integrated with existing enterprise systems In addition, the unified support of Babel birds. certified interface, easy docking enterprise authentication system, unified management of users. ",
  4100: "peace of mind service",
  4101: "Babel bird's growing need your support, we will provide peace of mind to make the most of your service to understand your needs and improve our products, on-site training of your employees, 7 * 24-hour telephone support, remote debugging ... ... all this only hope of Babel birds can create more and more value, change the way people use the file. ",
  4102: "Using Babel birds, more efficient teamwork",
  4103: "Personal Edition",
  4104: "Personal document storage, to quickly complete cooperation",
  4105: "free",
  4106: "to meet basic personal needs simple, convenient and safe..",
  4107: "immediately",
  4108: "2G storage space",
  4109: "Supporting Team 2",
  4110: "https encryption",
  4111: "a single file to save up to 10 historical versions",
  4112: "single file upload maximum support 5G",
  4113: "Support to discuss the document annotation content",
  4114: "Support private comment",
  4115: "Support batch download file",
  4116: "Support file permissions management",
  4117: "preview CAD file",
  4118: "preview 3D file",
  4119: "1: 1 large picture preview mode",
  4120: "online play video",
  4121: "Customizable need to file preview format",
  4122: "Sharing tab",
  4123: "Tag Management",
  4124: "File Reading state statistics",
  4125: "File cooperation and approval",
  4126: "Enterprise organization and management structure",
  4127: "Powerful Administrator Tools",
  4128: "detailed permission settings",
  4129: "customizable Logo and corporate name",
  4130: "exclusive UI interface",
  4131: "a unique enterprise domain logon",
  4132: "independent user system",
  4133: "Privatization deployment",
  4134: "Support synchronization client",
  4135: "APP supports the use of client access",
  4136: "dedicated account manager",
  4137: "Small team file sharing and collaboration",
  4138: '<span class="rmb">￥</span>2,000<span class="yearly"> / year</span>',
  4139: 'including" Personal Edition "All features, more storage space and greater functionality.',
  4140: "Buy Now",
  4141: "1T storage space,",
  4142: "New team limited number of",
  4143: "History is not limited to a single file save version",
  4144: "Unlimited Preview CAD file",
  4145: "Unlimited Preview 3D file",
  4146: "Enterprise edition public cloud",
  4147: "Any number of users for SMEs",
  4148: "Plenty of storage space, strong management background and authority management and control system, independent of the access domain for enterprises to create exclusive cloud service",
  4149: "Try to apply",
  4150: "2T storage space (flexible expansion),",
  4151: "Infinite established department",
  4152: "bank grade encryption protection",
  4153: "proprietary log entry",
  4154: "account can log on simultaneously Enterprise Edition and Personal Edition",
  4155: "Enterprise Private Cloud Edition",
  4156: "Custom, strong security, government and enterprises and institutions of choice",
  4157: "tailored",
  4158: 'including" enterprise public cloud version of "All features, providing customized and privatization deployment services.',
  4159: "on-demand storage space unlimited custom",
  4160: "optional encryption protection",
  4161: "They use",
  4162: "Choose for business users of Babel birds Enterprise Edition",
  4163: "more professional, more efficient, and safer",
  4164: "Industry Solutions",
  4165: "Every industry uses more or less the file has a unique point <br> demand for specific needs of different industries, birds Babel offers a range of industry solutions to help businesses more efficient use of Babel bird",
  4166: "engineering and manufacturing",
  4167: "Support for drawings and professionally formatted",
  4168: "Science and Education",
  4169: "courseware management and knowledge management thesis",
  4170: "publishing",
  4171: "Three trial three schools manuscript management",
  4172: "Advertising & Design",
  4173: "design draft management, ps, ai support, quick points, direct discussion on design draft",
  4174: "Internet company",
  4175: "From the demand solutions, prototypes to finished design draft, the team knowledge base market",
  4176: "multinational",
  4177: "File sharing, remote meeting to discuss international network optimization, transmission rate",
  4178: "More industry",
  4179: "If your industry have special needs Babel birds need improvement, please contact us <br> We will send representatives to contact you, understand your needs and workflow for your industry to launch products <br>.. <strong> * the first user of each industry we will provide one year of free service. </ strong> ",
  4180: "efficient document collaboration system",
  4181: "for enterprises born",
  4182: "File storage, teamwork and organizational management trinity",
  4183: "Enterprise public clouds for the enterprise edition What benefits?",
  4184: "In addition to enjoy all the features of Personal Edition and Professional Edition, but also can enjoy the following privileges",
  4185: "super basic space, meet the massive storage",
  4186: "provide the basis for a large 2TB storage space, over 100,000 documents for the enterprise storage business no matter how many people can work together harmoniously unified..",
  4187: "※ (1TB ≈ 1048576M, each file is estimated by 10M)",
  4188: "Free Preview more specialized file format, you can annotate privacy",
  4189: "Enterprise Public Cloud Edition users can annotate a free preview additional file formats, and an unlimited number, unlimited private preview can also annotate, exchange more flexible, convenient and establish collaborative platform for all corporate staff positions..",
  4190: "Super enterprise organizational structure, management easier,",
  4191: "for enterprises to build a perfect match for the line of business organization and management structure,",
  4192: "Staff on-line easier cross-sectoral butt.",
  4193: "Powerful administrator function, batch invite employees, set up different identities role.",
  4194: "Detailed logging operations, traceable.",
  4195: "Employee turnover, promotion, a key file transfer migration",
  4196: "an independent domain login, custom corporate image",
  4197: "Enterprise Public Cloud Edition users can log in using an independent domain name constituted by the enterprise, Custom Logo and corporate name, set up a unified internal image of the logo, to further shape the corporate image; Externally, strengthen corporate image, enhance corporate. professionalism. ",
  4198: "Client Access, employee entrance",
  4199: "Using Babel birds client, each employee will have a unified work entrance, look, depending on permissions \
<br> to a different file, agency matters and dynamic sector members, the most exciting is the use of client \
<br> can be retrieved native application directly edit files on a piece of Babel birds, the editing process automatic lock \
<br> set, automatically generate a new version after editing. This means that you can modify the same team members and \
<br> a office document or 3D models, CAD design draft, without having to upload the work of the whole team \
<br> are in the cloud. ",
  4200: "custom watermarks to protect files from being spread malicious",
  4201: "Babel birds business users can use the watermark feature custom enterprise can \
<br> logo, images, and even employees work number as a watermark, and you can set the watermark \
<br> the use of even a watermark embedded in the PDF file downloads to maximize \
<br> protect corporate intellectual property ",
  4202: "More business proprietary features help enterprises efficient office",
  4203: "approval, a total screen presentation, Inbox, sub-department file permissions, oversized picture branch \
<br> holders, etc. Enterprise Edition specific features to meet business users when the document is to use the \
<br> most problems, Babel birds can solve enterprise development process has encountered or \
The vast majority of problems encountered in the forthcoming document <br> management. ",
  4204: "Why do birds Babel business users trust worthy?",
  4205: "There are three anti-File Security \
<br> anti-phishing, anti-delete, anti-download ",
  4206: "Protecting enterprise document security is our top priority \
<br> To this end, we have established strict safety mechanism. Encrypted file sharing, prevent files from being leaked. \
<br> file backup, logging background operation, to prevent malicious file is deleted and traceable. \
<br> flexible file permissions, you can control the operating authority of others, only when it is allowed to download. ",
  4207: "preview format variety \
<br> documents, audio and video, 2D and 3D graphics ",
  4208: "file preview and annotation features are our most prominent features, the number of files we support preview in the industry almost no match covers both daily office contacted the Office, iWork, PDF, etc., but also covers a number of professionals. professional contacts file format, such as .psd, .dwg, .ai, .indd, and even a 3D file formats such as .dae, .obj format. ",
  4209: "High efficiency communication and collaboration \
<br> comments, discussion, multiport synchronization in one ",
  4210: "We not only provide enterprises with storage, file sharing services, \
<br> can also provide internal and external communication and collaboration services. ",
  4211: "the user through the online comments, group discussions, multiport synchronization, and other functions across platforms, \
<br> can improve work efficiency, improve the quality of work. ",
  4212: "Artificial fast and good service \
<br> provide uninterrupted service answering problem-solving Weekly",
  4213: "exclusive consultant for enterprises to provide one to one service manual, \
<br> seven days a week in response to the needs of business users, \
<br> solve immediate business questions about products and services ",
  4214: "Stay tuned for more features",
  4215: "Dynamic Filter",
  4216: 'dynamic filtering mechanism that allows" dynamic "more humane, just noticeable \
<br> files and shows users relevant, dynamic team discussion. ',
  4217: "",
  4218: "Using client and Babel birds systems with business users \
<br> encrypt all files on a computer is not authorized, \
<br> even get the file can not be opened. Ensure corporate culture \
Spread <br> fully controllable pieces, cut losses due to leakage caused by file. ",
  4219: "global encryption",
  4220: "Archive",
  4221: "Archiving feature allows companies more orderly important files properly \
<br> when the save and ensure the file can not be changed, convenience query \
<br> and management. It is the best solution for companies to establish file archives. ",
  4222: "Using Enterprise edition public cloud, more efficient, more detailed management",
  4223: "Babel can be used anytime, anywhere",
  4224: "You can not only use Babel on your computer in the office, but also use the Babel app on your smart phone or iPad. The function of the Babel app is even more powerful than that on the web",
  4225: "iOS-class version",
  4226: "download",
  4227: "Android version",
  4228: "download",
  4229: "Client for Windows",
  4230: "Win10 and above",
  4231: "Client Mac X64",
  4232: "Support macOS 10.8 or later",
  4233: "direct scan two-dimensional code <br> attention Babel Birds micro-channel public number",
  4234: "direct scan two-dimensional code <br> attention Babel birds official microblogging",
  4235: "Babel manual .pdf",
  4236: "Babel introduced .pdf",
  4237: "Babel deployment Installation Guide .pdf",
  4238: "Stay tuned immediately launched",
  4239: "Unable to delete. There are still sub departments under the current department.",
  4240: "Copyright © 2013-2019 Shanghai Information Technology Co., Ltd. Qing painting",
  4241: "Shanghai ICP prepared 31010102003859  沪ICP备14029220号-3",
  4242: "Designed for office building, turned simple tasks",
  4243: "Babel Bird View detailed feature list",
  4244: "The daily sharing flow of the shared file owner has exceeded the limit, and the file download failed.",
  4245: "cannot remove tag added by others",
  4246: "Products",
  4247: "Personal Edition",
  4248: "applies to individual users",
  4249: "Professional",
  4250: "small team use, unlimited number of participants",
  4251: "Enterprise Public Cloud Edition",
  4252: "SME sub-rights management",
  4253: "Enterprise Private Cloud Edition",
  4254: "large enterprises, government agencies, schools of choice",
  4255: "IT and management",
  4256: "management and use across the enterprise",
  4257: "Security and Compliance",
  4258: "comprehensive protection for your digital assets",
  4259: "Babel birds client",
  4260: "edit documents, maps and disk synchronization",
  4261: "workflow support",
  4262: "discussion and approval, streamline workflow",
  4263: "customized service",
  4264: "Babel customize your own birds",
  4265: "API interface to integrate applications",
  4266: "can integrate a number of applications, so network disk omnipotent",
  4267: "Security collaboration anytime, anywhere, on any device and anyone",
  4268: "Surprisingly so useful!",
  4269: "Unified Management of Enterprise Documents",
  4270: "Collaborative Work",
  4271: "Data Security",
  4272: "Getting started",
  4273: "preparing for designers waterfalls flow material management functions",
  4274: "PSD, AI, DWG can easily control",
  4275: "Explorer integration",
  4276: "The new Explorer integration (Cloud Bridge) function on line",
  4277: "the same as using a local disk access across the enterprise network disk have permission to view all files",
  4278: "immediately download the latest client experience",
  4279: "What problems do we solve?",
  4280: "Document storage is confusing and difficult to manage",
  4281: "According to the organization structure and member permissions, unified management of files and full-text fast search can be achieved.",
  4282: "Mail work is inefficiency",
  4283: "Keep consistent versions across all devices. Share files with partners and work together.",
  4284: "Waste much time to discuss back and forth",
  4285: "Be able to open files of most formats and directly create comments on the contents of the files in real time.",
  4286: "Difficult to edit files in different places",
  4287: "Be able to edit online files directly from Office to CAD, and complete cooperation efficiently.",
  4288: "No permission is unsafe",
  4289: "The permissions of roles, behaviors, departments, and files can be customized, which is more divisional management.",
  4290: "OA approval is too rigid",
  4291: "Various approval processes and export reports can be customized according to business requirements, and a handwritten signature is supported.",
  4292: "The high cost of file management",
  4293: "Built-in knowledge management and file management module to meet professional file storage and borrowing management.",
  4294: "System training costs manpower",
  4295: "Simple use does not require the change of using habits. It can be embedded in the Windows Explorer and accessed directly.",
  4296: "Learn more about Babel Bird's corporate network disk more features",
  4297: "Open the new way of working",
  4298: "for enterprises to build",
  4299: "Life Cycle",
  4300: "Safety",
  4301: "personal services",
  4302: "Babel birds use enterprise network drive, all the files in your team's assets (documents, images, video, etc.) are stored securely in the cloud, each member of the team can be accessed from different devices easy editing , share and comment. Assist you in enterprise-class security to protect the efficient completion of all the work to make your business fast and efficient upgrade to Office cloud era. ",
  4303: "communication efficiency and unity of knowledge determines the competitiveness of enterprises",
  4304: "- 稻盛 Kazuo",
  4305: "Discussion - Edit - Audit - collaboration - management - archiving",
  4306: "Communication from the draft and discuss the outline, create, modify and team document collaboration, document review to distribute, to finalize the audit partner collaboration, and ultimately archiving, loan, storage. Babel Bird is committed to all aspects of the life cycle management of the entire file. Make your business more efficient, safe and more secure, knowledge to be deposited. ",
  4307: "Safety is the key to business! Babel birds from product design to architecture to build and manage server security are a priority, and includes many important security features. You can control access to the behavior of each and every member of the file, add watermark files, view access logs. Archives can maximize the protection of important digital assets. Meanwhile, Babel birds use the highest EV SSL authentication, encryption, transmission security rating bank-level, multi-room distributed backup, make sure your data is secure. These initiatives so that the birds of Babel enterprise network drive to obtain the authority QUALYS A + security certification ",
  4308: "* Babel birds use Ali cloud data center, ensuring 99.9% availability",
  4309: "Communication from the draft and discuss the outline, create, modify and team document collaboration, document review to distribute, to finalize the audit partner collaboration, and ultimately archiving, loan, storage. Babel Bird is committed to all aspects of the life cycle management of the entire file. Make your business more efficient, safe and more secure, knowledge to be deposited. ",
  4310: "Babel bird is a business service products, the nature of the enterprise service is a service business, and we want to grow with our customers. In addition to providing first-class products, we also offer expert personal service you are unimaginable. We can provide the team, tools and experience for you, to help your business quickly on the cloud. Babel care team to depth business research needs and provide solutions for your business the way they operate, set up your system, training and even secondary development API access according to business needs. Allowing you to efficiently complete the worry lines on the target system. ",
  4311: "Don't change your habits, just get started",
  4312: "direct endorsement discussion",
  4313: "Synchronization and Cloud Bridge",
  4314: "open most files",
  4315: "all platforms",
  4316: "open enterprise network disk files directly click in place want to communicate, you can create annotation point of open discussion in the area clicked. You can even use voice and hand-painted circle paintings make communication more lively and efficient corporate network disk sharing by joining all members can see your comment and respond to real-time, end mobile communication more smoothly. All comments point can be structured to manage, and support @ uploading and accessories. Truly content discussions and assignments manageable. ",
  4317: "Use of Babel birds client that allows you to operate without changing the habits of the birds can enjoy Babel cloud services. Can automatically sync files on Babel birds enterprise network synchronized to a local disk, files are automatically locked when editing automatically upload after editing. Cloud bridge function embedded in windows explorer, as you can access the local file storage in the cloud file access, and direct the Explorer and collaboration with colleagues. Saving traffic and seamless operation. Babel Bird enterprise private cloud drives also support client access. ",
  4318: "want to see the file? No need to download, just click to! No need to install any application, you will be able to open more than 200 file formats directly on Babel birds. From the usual office, Apple's own iWork, pictures or videos to design a dedicated PS, AI and even AutoCAD, Solidworks and other professional 3D format, can easily preview collaborative discussion. After downloading the client, more calls on a PC and Mac native application to edit the contents of the cloud and automatically synchronizes, the real cloud work together seamlessly. ",
  4319: "anytime, anywhere viewing themselves and their team files, multiple participants to discuss and edit",
  4320: "Now you can not only the web logs, or through smart phones and windows, mac client to use Babel birds. Also, you can directly edit office documents online, without having to install office software ",
  4321: "the use of enterprise private cloud disk users can also enjoy full-service platform",
  4322: "for team collaboration was born",
  4323: "departments and projects",
  4324: "strong approval of management",
  4325: "meticulous rights management",
  4326: "true collaboration",
  4327: "Babel birds have a strong business management background, support the establishment of import or organizational structure. Supports windows domain controller. In Babel birds, you can sub-sector management, each department uses different permissions and security settings even different department administrator. You can also quickly create a project, coordinating the various departments staff, sharing project documents and track project progress. ",
  4328: "file is different from the OA approval, Babel birds may provide a more powerful tool for the approval of the specific content of the document. Administrators can pre-approval process and free weights reviewers, ordinary users can also customize a variety of forms for approval, and even invite external members to participate in the approval document. Approval results can export the report to print archive. ",
  4329: "From the file permissions, the human rights department of the authority, the role of authority, sharing permissions. Babel Bird enterprise network drive provides multiple dimensions of rights management in many ways. Basically covering all the required permissions enterprise configuration. Security to balance between ease of use, system administrators can also be adjusted in accordance with the needs of business and management background department. ",
  4330: "In addition to basic file sharing and process management, Babel also provides a bird table, department discussions, dynamic, file comments, the document annotation, file content approval, collaboration tools such as document co-editing multi-dimensional. Really can combine business and usage scenarios to complete work on a system of Babel birds. Version management and locking mechanism to avoid conflict or multiple versions of files are merged. After using Babel birds, teams can avoid the cumbersome multiple e-mail communication, OA's toss back and forth. The real focus on the work rather than management. ",
  4331: "solutions to enterprise network drive powerful and professional",
  4332: "industry-oriented solutions",
  4333: "Workflow custom development",
  4334: "privatized services",
  4335: "Open API",
  4336: "From the medical industry-specific markers discussed Dicom format to use collaborative project and review the CAD file, and then annotate details of 3D models, classification of information stored visa, compared to reviewers AI file. Babel Bird offers a solution for users of the industry for users of different industries. At the same time we do not know for industry, Babel care team of experts will go into the enterprise, and users together to build together for the user to use the system and the birds of Babel Babel birds enterprise private cloud disk according to business needs and our product experience. ",
  4337: "Our Babel care team to work closely with you to understand how your organization, including your company's culture and ways of working. This helps us find use cases and difficult to customize your workflow on the basis of Babel birds on the system to meet your unique needs, so that each team can work together seamlessly. From drawing management system to submit a visa, we have helped a large number of customers to develop custom workflows and custom development enterprise private cloud disk. ",
  4338: "We offer a variety of flexible deployment of the privatization program, from the traditional server cluster, the ultra-fusion system, hybrid cloud, SD-wan. Our engineers will give a privatization plan based on your existing hardware systems, maximize the use of your current hardware resources to build your enterprise private cloud disk. ",
  4339: "Babel birds open platform for custom development and support docking system on Babel birds systems. For private cloud users we provide a higher level API authorization code and business licensing business. You can build on the basis of Babel birds belong to the system on your own enterprise systems. Quick enterprise cloud service capabilities. ",
  4340: "Use Babel birds build their own cloud systems",
  4341: "Babel birds commercial license service",
  4342: "I want to offer your customers a greater variety of services? Display sales data, offer management contracts, agency document management, knowledge management ... Babel birds commercial license to use the service, your business can develop their own business applications in the system, based on the bird Babel, allow enterprises to quickly have a cloud service offerings . ",
  4343: '" Babel bird is a sophisticated rights management and compliance with the safety requirements of our product their powerful and professional service impressed me.. " ',
  4344: "- Qian high space laboratory director Mr Gao",
  4345: '" Babel birds can build our business processes of our review system drawings and records management system in a very low-cost dramatically improved our information process.. " ',
  4346: "- CH-Auto Information Manager Yao Zhiqiang",
  4347: '" project more than a year, we chose the Babel birds, in addition to excellent products, their custom development services to solve my worries. " ',
  4348: "- pure Technology iT manager ZhuangJia",
  4349: "They are also using birds of Babel",
  4350: "understanding of Babel birds business services",
  4351: "service",
  4352: "main function",
  4353: "IT and management",
  4354: "Download Babel birds client",
  4355: "Babel birds product brochures",
  4356: "Links:",
  4357: "Fine management of enterprise members, 10 people to order",
  4358: "Abundant storage space, powerful background management and authority control system, independent access domain name, create exclusive cloud services for enterprises.",
  4359: "5G high-speed download traffic per day",
  4360: "10G high-speed download traffic per day",
  4361: "Increase 10g daily traffic for each additional member",
  4362: "	Unlimited flow",
  4363: "The most economical solution for enterprise network drive",
  4364: "click to buy Pro Babel birds",
  4365: "low-cost rapid build enterprise network disk",
  4366: "Use of Babel birds Professional Edition, you only need to purchase an account can be infinitely set up the team, and invite an unlimited number of users to join the Pro form teams share up to 1TB of expandable storage and management team members in the team access. And does not limit the number of file versions. ",
  4367: "to add and manage your team members",
  4368: "Pro can add unlimited teams and team members, members simply register free of Babel Birds Personal Edition can join the team of professionally created, the shared Professional Edition of storage space, and team members to share files and work together. Professional Edition can manage the account team members access to the team file. Buy only a professional account you can enjoy over other enterprise network drive Enterprise account functional experience. ",
  4369: "unlimited save a new version of the file",
  4370: "The number of new version of Babel birds Pro Unlimited file saved with incremental upload technology can store large amounts of new version of the file in a limited space. Powerful version management version can be downloaded at any time, and can roll back to any version of the current version of history. Whether synchronization, client edit, or mapped disk (Cloud Bridge) files can be edited automatically save the new version. ",
  4371: "3D CAD files and preview support",
  4372: "Babel birds Pro 3D supports multiple formats to preview documents and CAD files (.dwg) and endorsed the establishment of discussion points. Meanwhile Babel bird 3D file annotation is based on a 3D space, it can visually discuss 3D files. ",
  4373: "annotation, dynamic, group chat are a lot",
  4374: "whether it is based on any discussion document annotation, or dynamic lists, team discussion space, other users ... @ function Pro version of these enterprises have also all have.",
  4375: "synchronization map disc (Cloud Bridge)",
  4376: "Pro can enjoy the full functionality of the client, whether it is synchronize any folder, multiplayer online file editing, or the latest maps disk function. Just install Babel birds clients, these features Pro users can enjoy ",
  4377: "cascade",
  4378: "Using Pro you can also use the cascade effect preview your documents and picture material, intuitive and fast to find the required documents during review of pleasing. ",
  4379: "all platforms",
  4380: "Pro uses the same full support platform, you can use almost Babel birds Pro on all devices, we not only have windows and mac client and the mobile phone side, we have a custom interface for the iPad interaction and UI. ",
  4381: "Get started now Babel Bird Pro",
  4382: "click to buy Pro Babel birds",
  4383: "Babel birds enterprise private cloud network disk",
  4384: "cost savings, the idea of ​​flying",
  4385: "can be tailored according to the demand of enterprises",
  4386: "contact us",
  4387: "After the test of public cloud systems hundreds of thousands of users",
  4388: "Birds of Babel public cloud network disk system need to include 60 million users, including users free to provide continuous uninterrupted service, to block the public Internet attacks, we must continue to improve the efficiency of the system in order to reduce the high public cloud servers cost. Up to 6 years of uninterrupted service experience in the public cloud Babel tried and tested system of birds. Babel birds private cloud system is in the public Babel birds developed a system on the basis of cloud, inherits all the features and characteristics of public cloud Babel birds, provide you with other private network disk can not match the high stability and high availability. ",
  4389: "private cloud first to support online office",
  4390: "collaborative editing open era",
  4391: "multiplayer online real-time editing",
  4392: "compatible with all office document format",
  4393: "real-time review",
  4394: "flexible deployment",
  4395: "finer than public cloud custom settings",
  4396: "Whether it is a single-server, multi-server, cluster, ultra-integration of systems, distributed systems, third-party cloud platform deployment Docker even the way we all support. Our deployment team can work together to develop a deployment plan based on your needs and you. At the same time because the private cloud characteristics only serve a single enterprise, we can provide optional custom settings far more than the public cloud system, from the interface to the operating rights to the process can be adjusted according to your needs. ",
  4397: "Babel care professional product-level customer service team",
  4398: "custom-developed industry solutions and services",
  4399: "Different industries have different work processes and habits, in order to better apply to your usage scenario, we have led by a professional team of product managers Babel care for your business to customize your own solutions and secondary development support. Make your business and industry-specific custom system on the basis of Babel on birds. We have helped automakers achieve Drawing Review system, to help construction companies to build collaborative design system to help the company complete the automatic travel visa system ... ",
  4400: "support more features open api",
  4401: "Babel birds private cloud system to get rid of the constraints imposed by standardized products, providing API support outside the range of far more than public cloud system, the entire system of all functions can be API, so that it can be perfectly integrated into your existing system or the system to be developed. Babel birds commercial license enables you to develop your own system based on the system of Babel birds, white card authorization way to get a bird's ability to Babel. ",
  4402: '" We spent a whole year to find time to meet the requirements of our system, and ultimately the privatization of Babel birds API for custom development system to solve our problems Brief Encounter. " ',
  4403: "- Manager Xu Ding Technology Co., Ltd. Shenzhen Mao",
  4404: "contact us",
  4405: "Want to know more? Please call 4009204020 and our sales consultants talk about your needs",
  4406: "You can also call our product manager 13,564,686,107 and direct dialogue",
  4407: "Babel birds using private cloud system to enjoy more birds Babel online office than the public cloud systems, whether word, or excel, ppt can be the perfect support. No need to install software to the phone side, end pages directly online editing office documents. Multiplayer online real-time edit the same document. (This feature is currently only supports private cloud systems, public clouds not yet open) ",
  4408: "complete control of your business",
  4409: "strong management background and customer support to ensure the smooth operations of your works",
  4410: "Try it now",
  4411: "contact us",
  4412: "to promote business development and IT planning landing",
  4413: "We fully understand the pressures faced by IT departments, and we need to assume responsibility for selecting. Because of this, we provide a powerful management tools and customer service to help IT staff to calmly deal with a variety of ever-changing business needs. Meanwhile, the multi administrators and divisional management functions can significantly reduce the burden on IT staff and maintenance difficulty. Our free initialization and training services also helps IT managers to quickly use and landing systems. ",
  4414: "Powerful and comprehensive management background",
  4415: "In order for IT staff can better manage business, we provide independent management background and strong management tool. Easily members from multiple dimensions, file, department, project, document sharing and collaboration to manage the enterprise. ",
  4416: "to easily manage your users",
  4417: "Whether it is corporate member or third-party partners or short-term intern, Babel birds can be managed in many ways. Competence at a glance, employee turnover a key handover, the independent members of management departments. AD domain controller supports both docking and single sign-on. ",
  4418: "roles with administrative user rights",
  4419: "unified management roles by default initial user permissions more convenient and efficient and less error prone. It supports the same user has different roles in different sectors. Roles can be customized, up to 30 a few details privileges optional ",
  4420: "control of all content",
  4421: "From the approval settings to control the behavior of sharing, file permissions fine adjustment, watermark control, members of usage logs ... .. Babel birds gives you total control members to use the content. And supports mac address binding, so that only specific members to use Babel birds in a particular device. ",
  4422: "hierarchical management of enterprises",
  4423: "Given the complexity and effort of large enterprise rights management, Babel support different birds and a variety of multi-level management responsibilities administrator. In addition to the super administrator privileges also supports four different administrators structure to support each department independently manages its own members and documents. ",
  4424: "logs and statistics, allowing more efficient management",
  4425: "In addition to using the log file, log departments, members of the logs, system logs, the Babel birds also supports statistics and data visualization. And supports export a report, make use of the entire enterprise at a glance. ",
  4426: "connect to your system",
  4427: "Babel birds provide a sound secondary development API interfaces and middleware support, fast and efficiently your existing docking systems, so that the birds become Babel file storage and management platform your old system. In addition to traditional Weaver OA, office365, E-mail, we also support and PDM, BIM systems and micro letter Enterprise Integration. You also can secondary development on birds Babel platform for your customers to deliver better products. ",
  4428: "Now we begin to experience the power of Babel brought the bird",
  4429: "all-round protection for your digital assets",
  4430: "Babel download data security policies birds",
  4431: "as security-oriented system design",
  4432: "Safety is the key to business! Babel birds from product design to architecture to build and manage server security are a priority, and includes many important security features. ",
  4433: "fine access control",
  4434: "fortress is often compromised from within, the primary consideration is the safety of the user to prevent leakage. Babel birds cut from the file permissions, human rights, rights of three departments refined rights management system to meet the needs of the vast majority of permission configuration, the Babel of birds can be more secure and orderly to protect important data. ",
  4435: "may formulate security policy",
  4436: "Babel birds unique 'security and confidentiality of members' businesses can formulate security policy management background, the independent control of the security level for each department. Let's get important sector data properly protected. ",
  4437: "bank level encryption transmission",
  4438: "Babel birds use the highest level of security EV SSL authentication, file upload and download using HTTPS as the transport protocol, file transfer process itself was secondary AES CTR 256 block encryption algorithm flow, ensure that the final stored in the cloud file storage system are encrypted, to prevent possible stolen in transit and storage. ",
  4439: "fragmented storage to protect your data",
  4440: "Babel birds using fragmented storage technology, the file is broken up into several fragments are stored in different disk or server, even if the server is compromised, the attacker can not get the complete file fragments to obtain the file. At the same time, support the privatization of Babel birds deployment, so that data stored in a safer place. ",
  4441: "Compliance of safety",
  4442: "Babel birds by more than a third-party testing authority, and we regularly conduct safety compliance review. We also received security QUALYS A + certification, is currently the only A + certified enterprise network disk ",
  4443: "and manufacturers to introduce more security services",
  4444: "Whether it is a comprehensive online antivirus, anti-phishing, or downloaded file, or corporate firewalls. Babel birds and a number of other security vendors in the field of long-term relationship. You can seamlessly integrate other vendors' security products to provide you with a more comprehensive security guarantees. ",
  4445: "They also focus on safety",
  4446: "Now we begin to experience the power of Babel brought the bird",
  4447: "Babel download data security policies birds",
  4448: "The new Babel birds client",
  4449: "more powerful, more convenient",
  4450: "Let's corporate network disk and no one can",
  4451: "Babel birds client actually consists of three modules. File management module, synchronized end, mapping disk (Cloud Bridge), using the client can not change the habits and easier editing of files and maintain synchronization and team. At the same time, also has automatically upload the new version, incremental upload, automatic lock file, mac address binding, right quickly share files and other functions, is by far the most powerful enterprise network disk client. ",
  4452: "synchronize all the devices for all",
  4453: "with a project file folder or department, the company's mac and home PC, as well as your mobile device. Yes, birds Babel supports simultaneous multiple users of data between these devices. Advanced conflict management judgment mechanism can effectively prevent the file version conflict. You can not change the location of any folder to synchronize birds Babel, Babel can also synchronize your birds have the right to download any file to a local folder. ",
  4454: "inexhaustible hard disk space",
  4455: "more practical than synchronous mapping of Babel birds disc (Cloud Bridge) function, you can put Babel and visit the bird in windows explorer as a disk drive. You can use just like a remote hard drive to use it to access and edit all your files within the purview can handle. Is different from the synchronization function, mapping the disk does not occupy too much local storage space, which means you can access the data and store much larger than your local hard disk. Also has enterprise-class security to protect everything you have done. ",
  4456: "seamlessly create and edit all files",
  4457: "Babel birds client, whether you are creating a new document or edit PDF, can be saved directly to the Babel birds. Automatic locking mechanism to prevent other people when you edit edit cause conflicts. Babel Birds app also supports Android devices increases take third-party applications to edit files after editing can be automatically saved as a new version of Babel to the birds. ",
  4458: "optional use on a specific device",
  4459: "Babel birds can be opened only supports setting client or mobile device access, with exclusive mac address and account binding function you can do to let a user can only use the Babel birds on the company's equipment It can not be used on private devices. Significantly improve system security. ",
  4460: "Incremental upload",
  4461: "Incremental upload technology can upload only changed portions of files when synchronizing files to upload significant savings in time and version storage space. After uploading incremental technology, psd file a 500MB after a modification you may only need 5MB upload files, saving you a lot of time to upload and make quick multiple versions of large files to save possible. ",
  4462: "all platforms",
  4463: "We can use almost all devices on the birds of Babel, we not only have windows and mac client and the mobile phone side, we have a tailor-made version of the other birds and Pakistan for the iPad large screen TV",
  4464: "clients according to their needs several iterations",
  4465: "thank these customers in the development process of the client positive suggestions and demands, we grew up. Because of their professional advice and landing usage scenarios so that the birds of Babel client so strong. Our customers can enjoy proven more effective function. ",
  4466: "Download Babel birds client",
  4467: "automation",
  4468: "simplify your processes",
  4469: "Try it now",
  4470: "contact us",
  4471: "life-cycle management and file-based design",
  4472: "Babel Bird is committed to the entire document management life cycle. From the file was created, modified, collaboration, sharing, approval, distribution, archiving, to destroy the entire life cycle, Babel has a corresponding functions and processes to manage, and can be customized process solutions or build. Make full use of Babel birds simplify your critical and often time-consuming tasks to improve the speed of business. ",
  4473: "can be pre-approval process",
  4474: "background in business management can preset number of examination and approval procedures according to the needs of different departments can demand approval process and selection process uses the rules they need. ",
  4475: "Powerful approval",
  4476: "approval supports a variety of ways, from the most basic parallel people, order people to the packet, weighted, Cc, cross-sectoral, cross-company, Babel birds quickly build support for almost all of the processing methods. Also, Babel birds may propose approval of the views directly on the document content in the form of endorsement or hand-painted. Improve the efficiency of back and forth review of the manuscript. ",
  4477: "Quick Collect File",
  4478: "Babel birds, especially Inbox function to ensure the manuscript submitter look at the premise managed file less than other submissions and submitted the manuscript you submitted, the deadline can be set to automatically notify the result statistics, submitted by management. Teachers receive job (paper), companies collect the tender, the government collected a powerful helper materials. ",
  4479: "clear work management",
  4480: "whether the approval process, the recipient records, or archive management, Babel birds have special management interface for unified management. And can manage the custom interface in the table list. At the same time, notifications and updates will all combinations of information relevant to you and together for you to quickly view and use. ",
  4481: "attention and remind",
  4482: "to assign tasks to colleagues, or remind him to look at a detail drawing of a chapter or article. Watch feature lets remind someone at the same time focus on a file or folder, and take the initiative to a file or folder to join his Watchlist. ",
  4483: "Manage your projects",
  4484: "Babel birds can also be very easy to create and manage projects, set up a project team to appoint a project manager, project managed by the project manager. Project support care can be transferred to different people or different departments as needed in the course of the project carried out in. ",
  4485: "archives and records management",
  4486: "Babel birds have a separate set of file management module. Archived files are automatically import the archive file assigned by the administrator. Archives have their own search, borrow, and management, file can not be modified, and has a very high security settings. ",
  4487: "They are also concerned about the process",
  4488: "Online co-editing",
  4489: "Online co-editing (optional)",
  4490: "Projects and Inbox",
  4491: "Archives",
  4492: "single file upload maximum support 5G",
  4493: "The upload size of a single file can be customized",
  4494: "Can set the file secret level and department secret level",
  4495: "Share approval",
  4496: "Logon device restrictions ",
  4497: "IP Policy Control",
  4498: "Watermark and Download PDF with Watermark ",
  4500: "operation and maintenance administrator",
  4501: "the establishment of various departments and personnel management administrator is responsible for operation and maintenance department, and approval process, group management, operation and maintenance, etc.",
  4502: "add operation and maintenance administrator",
  4503: "operation and maintenance management administrator",
  4504: "Confirm Delete {-user-} of operation and maintenance administrator",
  4505: "No group",
  4506: "click here to refresh dashboard",
  4507: "Invalid input:",
  4508: "Filter invalid mail：",
  4509: "File permission changed, press OK to refresh",
  4510: "Develop ID",
  4511: "If you want to access babelbird by API , you should ",
  4512: "apply developer ID",
  4513: "call back URL",
  4514: "http url - 我们将通过这个 url 返回认证结果给您",
  4515: "Develop id",
  4516: "Develop key",
  4517: "Your application is in processing...",
  4520: "Workplace",
  4521: "Time",
  4522: "Readed",
  4523: "Uploaded",
  4524: "Uploaded In Dep.",
  4525: "Hot in Dep.",
  4526: "Uploaded in Team",
  4527: "Hot in Team",
  4528: "more",
  4529: "No datum",
  4530: "Recently Notice",
  4531: "filter",
  4532: "input file or user name and ENTER",
  4533: "Order",
  4534: "Create",
  4535: "Name",
  4536: "input column name",
  4537: "Enterprise public folder",
  4538: "",
  4539: "There is no customized workspace column for the enterprise",
  4540: "Edit",
  4541: "Column name",
  4542: "Process can be defined freely",
  4543: "Review group",
  4550: "Edit",
  4551: "Select chat",
  4552: "Focused",
  4553: "My share links",
  4554: "My invitations",
  4555: "Files I commented",
  4556: "My project",
  4557: "Active file in Dep.",
  4558: "Tag cloud",
  4559: "File relations",
  4560: "Alternatively Chart",
  4561: "Custom chart new",
  4562: "corresponding folder",
  4563: "Select the folder you want to display",
  4564: "The file does not have the relevant documents",
  4565: "select the relevant file from the file",
  4566: "(save files up to 10 days),",
  4567: "processing result",
  4568: "deal with people",
  4569: "processing time",
  4580: "New Client Mac ARM",
  4581: "Supports macOS 11.0 or later",
  4582: "Supports Windows 10 or later",
  4570: '<span class="rmb">￥</span>2,000<span class="yearly"> / year</span>',
  4571: '￥2,000/year',
  4573: '￥35/Person/month',
  4574: "The maximum supported size for a single file upload is 1024G",
  4575: "The maximum supported size for a single file upload is 2048G",
  4600: "at this stage whether the force crossed? ",
  4601: "limits approved by the ratio of:",
  4602: "whether the document will be finalized after this stage marked by? (Subsequent stage just push notifications) ",
  4603: "stage name can not be empty",
  4604: "stage ",
  4605: "Select approval process",
  4606: "pre-enterprise processes",
  4607: "individual pre-process",
  4608: "Save the personal approval process",
  4609: "No pre-process<br>Administrators can add approval processes in the \"Enterprise Console - File Configuration\" section",
  4610: "No",
  4611: "moves upward",
  4612: "moves downward",
  4613: "roles",
  4614: "there is no approval process",
  4615: "Note: there is no approval process information",
  4616: "Save fails, select reviewers",
  4617: "save failed, {-title-} role corresponding to the selected person does not",
  4618: "a network timeout. Please refresh retry! ",
  4619: "No pre-process",
  4700: " application to open a file link to share",
  4701: " invitation to apply to join to share",
  4702: "{-name-} application file permissions",
  4703: "{-name-} agreed to application",
  4704: "{-name-} rejected application",
  4705: "{-name-} remind you concerning files",
  4706: "{-name-} at you",
  4707: "{-name-} has invited you to file for approval",
  4708: "{-name-} approval by",
  4709: "Enterprise Message: file through the approval",
  4710: "Enterprise Message: File was rejected",
  4711: "Babel Bird notice: System Update",
  4712: " invites you to join the team",
  4713: " invites you to manage your inbox",
  4714: "{-name-} process your request to open the file share link",
  4715: "{-name-} process your invitation to join sharing request",
  4716: "{-name-} sent you a file",
  4717: "system message: You have purchased the service is about to expire birds Babel",
  4718: "{-name-} opened file telecast",
  4719: "{-name-} issued a notice enterprise",
  4720: "insufficient permissions",
  4721: "You don't have this permission. You can fill in the name you want to modify and send the request to the person in charge of the document or the Department Manager",
  4722: "required permissions:",
  4723: "reasons for application:",
  4724: "Send Request",
  4725: "Relevant files have been deleted, and this message has expired",
  4726: "customize",
  4727: "New Blank authority",
  4728: "Copy an existing permission to edit",
  4729: "Generating preview file, unable to perform this operation",
  4730: "login system too frequently, please try again later",
  4731: "Are you sure to cancel sync? After canceling the synchronization, the folder will not be synchronized to the local, you can still be accessed through the cloud bridge mode or page. ",
  4732: "You don't have this permission. You can fill in the directory you want to move to and send the request to the person in charge of the file or the Department Manager",
  4733: "Downloads",
  4734: "Print as PDF",
  4735: "You do not have this permission. You can select the permission you want to modify and send the request to the person in charge of the document or the Department Manager",
  //****************** 8.1 ***************

  4736: "Guard code",
  4737: "Get code",
  /**************8.2***************/

  4738: "Assistant",
  4739: "Click to select assistant",
  4740: "Select Project Assistant",
  4741: "The project manager and the project assistant cannot be the same",
  4742: "Add Project Assistant",
  4743: "Authority",
  4744: "How to use the archives?",
  4745: "The archive is managed by an archivist, and a super administrator may designate one or more enterprise members as archivists.",
  4746: 'Ordinary personnel need to submit an application to access archived files, and only after the application is approved by the archivist can they access the archived files.',
  4747: "Use the client side to preview and comment the DWG file",
  4748: "(Set the privilege priority as: department staff privilege is greater than role privilege, and role privilege is greater than everyone in the department privilege)",
  4749: "save...",
  4750: 'Select the query condition and click "Search" to freeze the query log',
  4751: "The Inbox is mainly used to collect files and let the sender upload files to the Inbox",
  4752: "Open collection",
  4753: "Intra-tissue collection",
  4754: "This inbox generates a link that you can send out, and anyone who knows the link can upload the file without registering",
  4755: "This type of inbox requires you to specify a list of people within the enterprise who will upload their files when they receive the email automatically and receive in-site notifications. Out-listed people are not supported",
  4756: "Creating an open inbox",
  4757: "Information to be provided by the sender:",
  4758: "The name",
  4759: "{-name-}",
  4760: "Add information",
  4761: "Enter the title of the information field here",
  4762: "Enter the placeholder for the information entry here",
  4763: "The sender fills in the information and previews",
  4764: "Please fill in the following information:",
  4765: "Collection:",
  4766: "Date of Issue:",
  4767: "You can send out this link address, the sender can visit this link to upload the file",
  4768: "User entry",
  4769: "There is no information to be entered",
  4770: "unknown IP",
  4771: "here you can customize the information that the contributor needs to fill in when uploading a file, and use the modify or add information button to modify or add entries. After the contributor clicks the link, the information will appear and fill in the form. ",
  4772: "All archives",
  4773: "View share and invitation only",
  4774: "The online editing module has not been opened yet",
  4775: "Project assistant can add and delete project members, and assign permissions to project members. However, the project assistant cannot transfer and delete projects.",
  ////////////////*********8.4***************/

  4776: "My Project",
  4777: "None projects",
  4778: "None personal files",
  4779: "Please select secondary directory",
  4780: "Please select the destination folder",
  4781: "Push Notification Settings",
  4782: "I followed the file",
  4783: "After you select this option, you will receive system push notifications when the contents of folders or files that you care about are updated and the new version is uploaded.",
  4784: "New files cannot be uploaded to the current directory",
  /////////////////*************9.0*******************/
  4785: "configuration",
  4786: "Mail server",
  4787: "Third-party Account Authentication",
  4788: "Storage configuration",
  4789: "Email Server Address",
  4790: "Enter the email server address",
  4791: "port",
  4792: "Please enter the port",
  4793: "Authorization code",
  4794: "Please enter the authorization code",
  4795: "Whether to use SMTP",
  4796: "To give up",
  4797: "Whether to enable third-party authentication",
  4798: "Whether to enable third-party account synchronization",
  4799: "Third-party Authentication",
  4800: "The AD domain authentication",
  4801: "Enterprise WeChat",
  4802: "DingTalk",
  4803: "The domain",
  4804: "Enter a domain name, for example, domain.com",
  4805: "The path",
  4806: "Such as: DC=molasync,DC=cc",
  4807: "account",
  4808: "Please enter account number",
  4809: "Enterprise ID",
  4810: "Please enter the CorpID",
  4811: "app ID",
  4812: "Please enter the Agent ID",
  4813: "App secret",
  4814: "Please enter the secret",
  4815: "Address secret",
  4816: "Please enter the address secret",
  4817: "App schema",
  4818: "Please enter the schema",
  4819: "App Key",
  4820: "Please enter the App Key",
  4821: "Scan code application ID",
  4822: "Please enter the scan code AppId",
  4823: "Scan code to apply the secret key",
  4824: "Please enter scan code AppSecret",
  4825: "Mobile application ID",
  4826: "Mobile Secret",
  4827: "The local store",
  4828: "S3 storage",
  4829: "Map the storage disk to a folder:",
  4830: "Secret",
  4831: "Please enter the secret key",
  4832: "Access",
  4833: "Please enter the access key",
  4834: "Server",
  4835: "Please enter the server url",
  4836: "Bucket",
  4837: "Please enter the bucket name",
  4838: "Working mode",
  4839: "When this option is turned on, the employee ID will be used as the login account for the user",
  4840: "High strength cipher",
  4841: "If this option is enabled, enterprise members need to set a password consisting of 10 to 20 characters including uppercase and lowercase letters, special characters, and digits",
  4842: "This configuration item is only valid in the version of privatization deployment, and the current version does not support it",
  4843: "Please enter the current user login password",
  4844: "Abnormal behavior alarm",
  4845: "The number of downloaded files exceeds within 24 hours",
  4846: "pieces",
  4847: "Download traffic exceeded within 24 hours",
  4848: "GB",
  4849: "Abnormal large-scale downloads by department members will be notified to department managers and administrators.",
  4850: "Need smtp auth",
  4851: "Encryption method",
  4852: "Testing",
  4853: "Please enter the recipient email, and we will send a test email to this email. Click OK to call the interface to send and return the test results",
  4854: "Export user participation file list",
  4855: "Generating file list",
  4856: "Please select recipient",
  4857: "Please enter an integer between 1 and 99",
  4858: "Use default settings",
  4859: "Name only",
  4860: "Editing files to Babel Bird Cloud online disk. If you leave this page, the edited content cannot be saved",
  4861: "Mixed sort",
  4864: "There are two ways to download folders: using the client to download, or downloading while logged in",
  4865: "This file supports downloading in login mode",
  4900: "Usage Statistics",
  4901: "Tax number",
  4902: "Required for company invoices",
  4903: "Telephone"
};
var _default = exports["default"] = localString_en_part1;

},{"1454":1454}],1151:[function(require,module,exports){
"use strict";

require(1461);
require(1503);
require(1415);
require(1463);
require(1456);
require(1418);
require(1537);
require(1457);
require(1453);
require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require(1180));
var _localString_cn_part = _interopRequireDefault(require(1152));
var _localString_cn_part2 = _interopRequireDefault(require(1153));
var _localString_cn_part3 = _interopRequireDefault(require(1154));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*
 * @Author: hujichao@molasync.com hujichao@molasync.com
 * @Date: 2018-03-14 00:24:52
 * @LastEditors: hujichao@molasync.com hujichao@molasync.com
 * @LastEditTime: 2023-07-14 17:21:53
 * @FilePath: \WebContent\local-strings\cn_parts\localString_cn.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
var localString_cn = _objectSpread(_objectSpread(_objectSpread({}, _localString_cn_part["default"]), _localString_cn_part2["default"]), _localString_cn_part3["default"]);
var _default = exports["default"] = localString_cn;

},{"1152":1152,"1153":1153,"1154":1154,"1180":1180,"1184":1184,"1415":1415,"1418":1418,"1453":1453,"1454":1454,"1456":1456,"1457":1457,"1461":1461,"1463":1463,"1503":1503,"1537":1537}],1503:[function(require,module,exports){
// TODO: Remove this module from `core-js@4` since it's split to modules listed below
require(1499);
require(1501);
require(1504);
require(1441);
require(1459);

},{"1441":1441,"1459":1459,"1499":1499,"1501":1501,"1504":1504}],1504:[function(require,module,exports){
var $ = require(1270);
var hasOwn = require(1288);
var isSymbol = require(1310);
var tryToString = require(1394);
var shared = require(1366);
var NATIVE_SYMBOL_REGISTRY = require(1378);

var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(tryToString(sym) + ' is not a symbol');
    if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  }
});

},{"1270":1270,"1288":1288,"1310":1310,"1366":1366,"1378":1378,"1394":1394}],1501:[function(require,module,exports){
var $ = require(1270);
var getBuiltIn = require(1282);
var hasOwn = require(1288);
var toString = require(1393);
var shared = require(1366);
var NATIVE_SYMBOL_REGISTRY = require(1378);

var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  'for': function (key) {
    var string = toString(key);
    if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = getBuiltIn('Symbol')(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  }
});

},{"1270":1270,"1282":1282,"1288":1288,"1366":1366,"1378":1378,"1393":1393}],1378:[function(require,module,exports){
var NATIVE_SYMBOL = require(1376);

/* eslint-disable es/no-symbol -- safe */
module.exports = NATIVE_SYMBOL && !!Symbol['for'] && !!Symbol.keyFor;

},{"1376":1376}],1499:[function(require,module,exports){
'use strict';
var $ = require(1270);
var global = require(1287);
var call = require(1278);
var uncurryThis = require(1281);
var IS_PURE = require(1308);
var DESCRIPTORS = require(1251);
var NATIVE_SYMBOL = require(1376);
var fails = require(1271);
var hasOwn = require(1288);
var isPrototypeOf = require(1335);
var anObject = require(1209);
var toIndexedObject = require(1384);
var toPropertyKey = require(1391);
var $toString = require(1393);
var createPropertyDescriptor = require(1244);
var nativeObjectCreate = require(1326);
var objectKeys = require(1337);
var getOwnPropertyNamesModule = require(1331);
var getOwnPropertyNamesExternal = require(1330);
var getOwnPropertySymbolsModule = require(1332);
var getOwnPropertyDescriptorModule = require(1329);
var definePropertyModule = require(1328);
var definePropertiesModule = require(1327);
var propertyIsEnumerableModule = require(1338);
var defineBuiltIn = require(1247);
var shared = require(1366);
var sharedKey = require(1364);
var hiddenKeys = require(1289);
var uid = require(1400);
var wellKnownSymbol = require(1408);
var wrappedWellKnownSymbolModule = require(1407);
var defineWellKnownSymbol = require(1406);
var defineSymbolToPrimitive = require(1377);
var setToStringTag = require(1363);
var InternalStateModule = require(1298);
var $forEach = require(1220).forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';

var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);

var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
var TypeError = global.TypeError;
var QObject = global.QObject;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var push = uncurryThis([].push);

var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var WellKnownSymbolsStore = shared('wks');

// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (hasOwn(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = call(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P]
    ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
  });
  return result;
};

var $getOwnPropertySymbols = function (O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
      push(result, AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (isPrototypeOf(SymbolPrototype, this)) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
      if (hasOwn(this, HIDDEN) && hasOwn(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  SymbolPrototype = $Symbol[PROTOTYPE];

  defineBuiltIn(SymbolPrototype, 'toString', function toString() {
    return getInternalState(this).tag;
  });

  defineBuiltIn($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  definePropertiesModule.f = $defineProperties;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty(SymbolPrototype, 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      defineBuiltIn(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames
});

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;

},{"1209":1209,"1220":1220,"1244":1244,"1247":1247,"1251":1251,"1270":1270,"1271":1271,"1278":1278,"1281":1281,"1287":1287,"1288":1288,"1289":1289,"1298":1298,"1308":1308,"1326":1326,"1327":1327,"1328":1328,"1329":1329,"1330":1330,"1331":1331,"1332":1332,"1335":1335,"1337":1337,"1338":1338,"1363":1363,"1364":1364,"1366":1366,"1376":1376,"1377":1377,"1384":1384,"1391":1391,"1393":1393,"1400":1400,"1406":1406,"1407":1407,"1408":1408}],1406:[function(require,module,exports){
var path = require(1344);
var hasOwn = require(1288);
var wrappedWellKnownSymbolModule = require(1407);
var defineProperty = require(1328).f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};

},{"1288":1288,"1328":1328,"1344":1344,"1407":1407}],1407:[function(require,module,exports){
var wellKnownSymbol = require(1408);

exports.f = wellKnownSymbol;

},{"1408":1408}],1377:[function(require,module,exports){
var call = require(1278);
var getBuiltIn = require(1282);
var wellKnownSymbol = require(1408);
var defineBuiltIn = require(1247);

module.exports = function () {
  var Symbol = getBuiltIn('Symbol');
  var SymbolPrototype = Symbol && Symbol.prototype;
  var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

  if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) {
    // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    defineBuiltIn(SymbolPrototype, TO_PRIMITIVE, function (hint) {
      return call(valueOf, this);
    }, { arity: 1 });
  }
};

},{"1247":1247,"1278":1278,"1282":1282,"1408":1408}],1330:[function(require,module,exports){
/* eslint-disable es/no-object-getownpropertynames -- safe */
var classof = require(1233);
var toIndexedObject = require(1384);
var $getOwnPropertyNames = require(1331).f;
var arraySlice = require(1226);

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return arraySlice(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && classof(it) == 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};

},{"1226":1226,"1233":1233,"1331":1331,"1384":1384}],1459:[function(require,module,exports){
var $ = require(1270);
var NATIVE_SYMBOL = require(1376);
var fails = require(1271);
var getOwnPropertySymbolsModule = require(1332);
var toObject = require(1387);

// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FORCED = !NATIVE_SYMBOL || fails(function () { getOwnPropertySymbolsModule.f(1); });

// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$({ target: 'Object', stat: true, forced: FORCED }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    var $getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject(it)) : [];
  }
});

},{"1270":1270,"1271":1271,"1332":1332,"1376":1376,"1387":1387}],1441:[function(require,module,exports){
var $ = require(1270);
var getBuiltIn = require(1282);
var apply = require(1274);
var call = require(1278);
var uncurryThis = require(1281);
var fails = require(1271);
var isArray = require(1300);
var isCallable = require(1302);
var isObject = require(1307);
var isSymbol = require(1310);
var arraySlice = require(1227);
var NATIVE_SYMBOL = require(1376);

var $stringify = getBuiltIn('JSON', 'stringify');
var exec = uncurryThis(/./.exec);
var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var replace = uncurryThis(''.replace);
var numberToString = uncurryThis(1.0.toString);

var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL || fails(function () {
  var symbol = getBuiltIn('Symbol')();
  // MS Edge converts symbol values to JSON as {}
  return $stringify([symbol]) != '[null]'
    // WebKit converts symbol values to JSON as null
    || $stringify({ a: symbol }) != '{}'
    // V8 throws on boxed symbols
    || $stringify(Object(symbol)) != '{}';
});

// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

var stringifyWithSymbolsFix = function (it, replacer) {
  var args = arraySlice(arguments);
  var $replacer = replacer;
  if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
  if (!isArray(replacer)) replacer = function (key, value) {
    if (isCallable($replacer)) value = call($replacer, this, key, value);
    if (!isSymbol(value)) return value;
  };
  args[1] = replacer;
  return apply($stringify, null, args);
};

var fixIllFormed = function (match, offset, string) {
  var prev = charAt(string, offset - 1);
  var next = charAt(string, offset + 1);
  if ((exec(low, match) && !exec(hi, next)) || (exec(hi, match) && !exec(low, prev))) {
    return '\\u' + numberToString(charCodeAt(match, 0), 16);
  } return match;
};

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  $({ target: 'JSON', stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice(arguments);
      var result = apply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace(result, tester, fixIllFormed) : result;
    }
  });
}

},{"1227":1227,"1270":1270,"1271":1271,"1274":1274,"1278":1278,"1281":1281,"1282":1282,"1300":1300,"1302":1302,"1307":1307,"1310":1310,"1376":1376}],1461:[function(require,module,exports){
var $ = require(1270);
var toObject = require(1387);
var nativeKeys = require(1337);
var fails = require(1271);

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});

},{"1270":1270,"1271":1271,"1337":1337,"1387":1387}],1457:[function(require,module,exports){
var $ = require(1270);
var DESCRIPTORS = require(1251);
var ownKeys = require(1343);
var toIndexedObject = require(1384);
var getOwnPropertyDescriptorModule = require(1329);
var createProperty = require(1245);

// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});

},{"1245":1245,"1251":1251,"1270":1270,"1329":1329,"1343":1343,"1384":1384}],1456:[function(require,module,exports){
var $ = require(1270);
var fails = require(1271);
var toIndexedObject = require(1384);
var nativeGetOwnPropertyDescriptor = require(1329).f;
var DESCRIPTORS = require(1251);

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetOwnPropertyDescriptor(1); });
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});

},{"1251":1251,"1270":1270,"1271":1271,"1329":1329,"1384":1384}],1453:[function(require,module,exports){
var $ = require(1270);
var DESCRIPTORS = require(1251);
var defineProperties = require(1327).f;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
$({ target: 'Object', stat: true, forced: Object.defineProperties !== defineProperties, sham: !DESCRIPTORS }, {
  defineProperties: defineProperties
});

},{"1251":1251,"1270":1270,"1327":1327}],1154:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require(1180));
var _localString_cn_part;
var localString_cn_part3 = (_localString_cn_part = {
  //******************************* 初始化密码界面 */
  11001: "初始化密码",
  11002: "首次登录，您需要重新初始化密码",
  //////////////**************9.1.4*************//////////////// */
  11003: '导出状态',
  11004: '导出记录',
  11005: '导出页面',
  11006: '搜索导出者',
  11007: '请求时间',
  11008: '导出时间',
  11009: '导出文件',
  11010: '导出人',
  11011: '提示：由于导出文件过大，为了给您提供安全、高效的下载体验，您的文件导出请求生效后会暂存在云服务器上，三天后自动失效',
  11012: '成员报表',
  11013: '生成中',
  11014: '已生成',
  11015: '生成失败',
  11016: '暂无导出记录',
  11017: '操作成功!请稍后至“<span class="main-color">导出记录</span>”页面下载查看。',
  11018: '全部状态',
  11019: '本条记录已过期',
  11020: '获取导出记录失败',
  11021: '企业成员信息',
  11022: '用户参与文件',
  /**********************ai******************* */
  11100: "智巢AI",
  11101: "智巢设置",
  11102: "巴别鸟助手",
  11103: "定制属于你的AI助理",
  11104: "巴别鸟智巢AI助理可以使用企业指定的文件进行学习，成为你企业的专属AI助理，对于企业的相关资料及问题可以直接以提问的形式和智巢进行对话，并能根据不同权限的人给出权限范围内的回答。",
  11105: "历史提问",
  11106: "新提问",
  11107: "严谨",
  11108: "常规",
  11109: "创意",
  11110: "把您的企业文档库接入智巢",
  11111: "巴别鸟智巢AI助理可以使用企业指定的文件进行学习，成为你企业的专属AI助理，对于企业的相关资料及问题可以直接以提问的形式和智巢进行对话，并能根据不同权限的人给出权限范围内的回答。",
  11112: "购买成功后，你可以选择需要智巢学习的文档范围。耐心等待智巢学习完成后，你将拥有一个专属AI助理",
  11113: "AI学习需要占用大量CPU资源，所以接入智巢需要另行支付开通费用，请选择适合你的服务套餐",
  11114: "不限制创建AI助理数，每个助理最高可学习1万个文档。服务有效期：即日起一年内生效         10000元/年",
  11115: "可创建5个AI助理，每个助理最高可学习5000个文档。服务有效期：即日起一年内生效         5000元/年",
  11116: "可创建2个AI助理，每个助理最高可学习1000个文档。服务有效期：即日起一年内生效         2000元/年",
  11117: "创建专属AI助理",
  11118: "助理名称",
  11119: "请选择学习的文档范围：",
  11120: "新增AI助理",
  11121: "支持复选",
  11122: "我的AI助理:",
  11123: "移除",
  11124: "创建外链代码：",
  11125: "巴别鸟智巢AI助理也可以成为你自己产品和服务的只能客服哦，只要新建AI助理，并选择在线客服所需的学习材料，AI学习完毕后就能作为智能客服回答用户问题。可以选择特定的AI助理创建一个代码片段，粘贴到你的网站，你就拥有一个全自动回答用户疑问的专属AI",
  11126: "选择需要发布的AI助理",
  11127: "创建",
  11128: "智巢",
  11129: "不能发送空白信息",
  11130: "目前，智巢AI还需要单独为每个企业的数据和使用场景进行微调，生成企业专属的AI模型",
  11131: "如需购买“智巢”AI助理，请联系我们的销售人员（在线客服），或拨打4009204020",
  11132: "你也可以发送邮件至： huangfu@molasync.com",
  11133: "知道了",
  11134: "清空历史记录",
  11135: "释放企业内容价值",
  11136: "即刻使用智巢AI",
  11137: "回答关于文档的一切问题",
  11138: "通过使用AI分析文档内容中的丰富知识，智巢AI能回答关于该文档内容的一切问题。从文档总结到揭示冗长研究中的关键发现。借助人工智能驱动的内容洞察，您可以更快、更自信地做出关键任务决策。这意味着，一篇上百页的文档你不用亲自去读，而是直接交给AI去读懂，你向AI询问你关注的问题即可。能大幅提高工作效率。",
  11139: "定制属于你企业的AI助理",
  11140: "现有的AI系统最大的问题是没法根据你企业的专属内容准确的进行问题回答以致于不可用。巴别鸟智巢AI助理团队会根据企业的资料帮助企业准备训练集、调参、训练企业专属的AI模型，以实现可用的AI助理。对于企业的相关资料及问题可以直接以提问的形式和智巢进行对话。并能根据不同权限的人给出权限范围内的回答。甚至可以使用智巢生成代码块附在你的网站上快速搭建你企业的对外智能客服系统",
  11141: "打造企业自己的客服平台",
  11142: "客服培训往往占用企业大量精力和人力，租用或购买客服机器人成本不低效果也不尽人意。使用巴别鸟智巢AI让低成本搭建AI客服平台成为可能，让中小企业也能拥有媲美大型企业的智能客服平台。巴别鸟智巢AI团队可以利用企业现有的客服培训材料、问答集、说明书等材料进行优化，形成语料来训练AI，并且根据你所在行业进行AI调参，最终搭建出适合你企业的AI客服系统。",
  11143: "帮助你创建内容、回答问题",
  11144: "内容创建应该轻松有趣，而不是把时间花在斟酌语句上。智巢AI拥有所有大模型具有的基础能力，无论你是起草新闻稿、撰写个性化销售电子邮件，还是在会议中概述行动项目，你都可以利用内容智能加快工作速度，从而腾出时间专注于客户和创新。由于你是在巴别鸟中工作，因此智能内容管理所需的所有工具都已内置，直接找智巢AI就可以。",
  11145: "安全、可靠且私密的企业级人工智能",
  11146: "如何让人工智能不瞎说话？如何让人工智能不要不懂装懂（会说不知道）？如何让人工智能不泄密？这些是评价一个人工智能系统好坏的重要指标。智巢AI不仅在准确度上有大幅提升，还会自动匹配巴别鸟的权限体系，如果用户询问他权限范围外的问题，智巢AI会回答不知道。同时，所有参与训练的文档都是由用户指定并同意的。",
  11147: "为你的企业带来无限可能",
  11148: "使用企业的内容生成数据分析报告",
  11149: "使用企业的语料训练AI客服，自动回答客户问题",
  11150: "自动生成营销邮件、职位说明等文本",
  11151: "轻松准确将报告或文档翻译成各国语言",
  11152: "AI辅助阅读，快速找到文章重点及知识点，提升效率",
  11153: "根据企业文档创建企业专属问答知识库",
  11154: "拥有智巢AI",
  11155: "你想使用巴别鸟智巢AI来提高企业生产效率、或是给你的客户提供更好的服务么？巴别鸟企业版用户现在就能直接使用智巢AI了。如果没有企业版账号就赶紧注册一个吧！",
  11156: "同时，我们也提供企业专属AI训练服务，让人工智能帮助企业高速发展。",
  11157: "请完善你的申请信息，成为第一批开启智巢的人",
  11158: "没有账号？",
  11159: "点击注册巴别鸟企业版",
  11160: "你的企业登录账号（手机号）*",
  11161: "联系人姓名*",
  11162: "联系人手机号*",
  11163: "获取验证码",
  11164: "验证码*",
  11165: "提交申请",
  11166: "请输入企业版账号",
  11167: "请输入正确的手机号账户",
  11168: "感谢您对我们的支持，您的申请已经提交，请您等待通知。",
  11169: "请输入联系人姓名",
  11170: "请输入正确的企业登录账号",
  11171: "*因为AI计算需要占用大量GPU资源，所以每周仅开放数量有限的测试模块",
  11172: "和智巢聊聊吧",
  11173: "这是智巢巴别鸟助手，你可以用聊天的形式询问它关于巴别鸟使用中遇到的任何问题",
  11174: "巴别鸟的项目和部门有什么区别？",
  11175: "我有个文件不想给部门成员看，怎么操作？",
  11176: "我想发个文件给公司所有人，但不想让他们下载，如何操作？",
  11177: "客户端编辑和在线编辑有什么异同？",
  11178: "这是智巢文档助手，你可以用聊天的形式询问它关于此文档的任何问题",
  11179: "帮我列一个这篇文档的大纲",
  11180: "这篇文档的中心思想是什么？",
  11181: "简述一下这篇文档？",
  11182: "发送一个消息",
  11183: "消息发送失败，请稍后重试",
  11184: "这个问题回答比较长，容我思考下，一分钟内回复你哦",
  11185: "智巢阅读助手",
  11186: "登录巴别鸟企业版",
  11187: "",
  11188: "",
  11189: "",
  11190: "",
  11191: "",
  11192: "",
  11193: "",
  11194: "",
  11195: "",
  11196: "",
  11197: "",
  11198: "",
  11199: "",
  11200: "",
  11201: "",
  11202: "",
  11203: "",
  11204: "",
  11205: "",
  11206: "",
  11207: "",
  11208: "",
  11209: "",
  11210: "",
  11211: "",
  /*******************9.3.6********************** */
  11300: "设置签章后，你可以在预览文档时使用签章",
  11301: "签名设置",
  11302: "添加手写签名",
  11303: "上传签名图片文件",
  11304: "图章设置",
  11305: "上传图章图片文件",
  11306: "当前使用的图章",
  11307: "设置默认图章",
  11308: "支持上传的图片类型为png、jpg、jpeg，文件大小不超过2MB",
  11309: "拖入图片到区域中新建签名",
  11310: "或",
  11311: "选择文件...",
  11312: "上传签名图片文件",
  11313: "请上传 png、jpg 或 jpeg 格式的图片",
  11314: "文件大小不能超过 2MB",
  11315: "拖入图片到区域中新建图章",
  11316: "白色转为透明",
  11317: "添加图章",
  11318: "签署",
  11319: "保存为签署PDF",
  11320: "保存到当前目录",
  11321: "下载PDF文件",
  11322: "获取签章信息失败",
  11323: "上传失败",
  11324: "正在生成PDF，请稍候",
  11325: "PDF生成失败，请稍后重试",
  11326: "已签署文件",
  11327: "{-somebody-}生成了文件{-file-}的签署pdf文件",
  11328: "签章认证",
  11329: "在这里上传在网盘生成的签章PDF文件，可以认证签章出处及签章是否是由本系统生成以确定签署文件的真实性。",
  11330: "点击或拖拽 PDF 文件上传",
  11331: "请上传pdf文件",
  11332: "{-user-}在{-time-}生成了文件《{-file-}》的签署pdf文件《{-sealedFileName-}》",
  11333: "签署文件生成者",
  11334: "签署文件生成日期",
  11335: "签署有效性",
  11336: "未查询到该签署文件信息",
  11337: "有效",
  11338: "签署人",
  11339: "该文件已经生成了签名（章）pdf，<br>您可以下载已有的签章pdf(推荐），<br>也可以点击下方按钮再次生成新的签名（章）pdf 文件",
  11340: "无效",
  11341: "生成新的签章文件",
  11342: "Language",
  11343: "{-somebody-}从文件{-file-}中删除了签名（章）",
  11344: "请选择图片文件",
  11345: "项目所在目录没有可选部门",
  11346: "正在生成签名文件...",
  11347: "所有下级子部门/文件夹继承该权限",
  11348: "所有下级子部门/文件夹将继承该权限设置，该设置中的人员/角色在下级部门/文件夹的权限设置将清空以继承该权限设置，此操作不可逆。",
  11349: "点击企业文件直接进入所在部门",
  11350: "打开后，点击企业文件频道会直接进入所在部门",
  11351: "您的专业版已过期，为了不影响您的正常使用，请您尽快升级。",
  11251: "将账户 {-somebody-} 升级为专业版",
  11252: "巴别鸟专业版服务",
  11253: "专业版服务有效期至",
  11254: "需支付服务费用合计",
  11255: "当前账户已升级为专业版",
  11256: "如您有任何疑问，请联系客服",
  11257: "返回主页",
  11258: "企业税号",
  11259: "公司发票必填此项",
  11260: "选择历史寄送信息",
  11261: "寄送地址",
  11262: "订单编号",
  11263: "选择支付方式",
  11264: "下载合同",
  11265: "支付截止时间",
  11266: "逾期将会关闭交易",
  11267: "支付完成前, 请不要关闭此支付验证窗口, 支付完成后, 请根据您的情况点击下面按钮",
  11268: "正在支付",
  11269: "支付成功",
  11270: "支付遇到问题",
  11271: "重新支付",
  //////////////**************9.1.5*************//////////////// */
  12100: "高级设置",
  12101: "文件上传白名单",
  12102: "文件上传黑名单",
  12103: "只有加入白名单的文件类型才可以上传",
  12104: "白名单优先级高于黑名单，白名单中的文件类型，黑名单不生效",
  12105: "点击输入加入白名单的文件扩展名。例如：jpg;png(不区分大小写)",
  12106: "多个扩展名可用“;”分隔，如jpg;png;doc",
  12107: "加入黑名单的文件类型禁止上传",
  12108: "点击输入加入黑名单的文件扩展名。例如：jpg;png(不区分大小写)",
  12109: "双向绑定",
  12110: "开启双向绑定后，绑定mac地址的设备只有绑定的账号可以登录（网页端不受限制）",
  12111: "可在线编辑office文件",
  12112: "关闭该选项该部门office文件将不可使用在线编辑",
  12113: "禁止部门文件对外分享",
  12114: "打开此选项，所有部门成员无法将文件分享给企业外部用户，同时无法通过链接分享文件",
  12115: "是否将此设置应用到当前部门的所有子部门",
  12116: "本部门文件禁止分享",
  12117: "本部门文件禁止在线编辑",
  12118: "部门选项",
  12119: "部门或项目设置的黑名单优先级高于此处的黑名单",
  12120: "直属成员按角色分类，可编辑管理。",
  12121: "没有查看链接分享的权限",
  12122: "未知角色",
  12123: "将文件 {-file-} 开启了新的审批阶段",
  12130: "消息已过期",
  ////////////////////9.1.6//////////////////

  12200: "获取文件密码失败",
  12201: "在系统标题栏显示企业简称",
  12202: "不允许输入特殊字符",
  12203: "角色名不允许输入特殊字符",
  12204: "策略名不允许输入特殊字符",
  12205: "分组名不允许输入特殊字符",
  12206: "发送文件的申请审批未获通过",
  12207: "发送文件的申请审批获得通过",
  12220: "尝试次数过于频繁，请 10 分钟后再试",
  12221: "密码错误",
  12222: "成员列表",
  12223: "关闭此选项后，顶部标题栏仅显示企业logo",
  ////////////////////9.1.7//////////////////

  12300: "点击",
  12301: "设置快照",
  12302: "点击选择负责人，如果不更换负责人，此项可以为空",
  12303: "没有下载权限的文件不显示缩略图",
  12304: "打开此选项，如果用户没有文件的下载权限将不会显示该文件的缩略图。防止用户截取缩略图泄露文件",
  12305: "不能重复使用旧密码",
  12306: "你在该文件没有上传权限",
  12307: "文件数量多于 {-max-} 个，请使用客户端同步功能！",
  ////////////////////9.1.8//////////////////

  12400: "流程图drawio",
  12401: "搜索结果",
  12402: "文件内容",
  12403: "搜索时严格检测权限",
  12404: "严格检测权限搜索效率会降低，非严格检测权限可能特殊情况下搜到不可访问文件，但即使搜到也拒绝访问",
  12405: "已过滤无权访问文件",
  /////////////////////9.2.0///////////////////////

  12500: "素材库",
  12501: "管理员初始化后才可以使用",
  12502: "素材库功能还未启用，是否现在启用？",
  12503: "素材库启用成功",
  12504: "允许访问素材库",
  12505: "关闭后，该用户界面上将没有素材库入口，该用户无法访问素材库",
  12506: "批量管理栏目访问权限",
  12507: "创建分类",
  12508: "输入分类名字可以创建分类，分类下并不能上传文件，但可以在分类下创建素材库或创建新的分类",
  12509: "输入分类的名字",
  12510: "分类可见性",
  12511: "分类管理员",
  12512: "新建素材库",
  12513: "你没有权限创建分类，但你可以向分类管理者申请创建分类，申请通过后，分类会自动创建。",
  12514: "申请创建分类",
  12515: "分类管理",
  12516: "输入素材库名称",
  12517: "素材库助理",
  12518: "添加素材库助理",
  12519: "素材库可见性",
  12520: "下载该素材库文件需要审批",
  12521: "限定部门公开",
  12522: "限定部门需要审批",
  12523: "访问需要申请",
  12524: "内部（保密）",
  12525: "能访问上级分类的所有人都可以访问",
  12526: "访问子库的成员需要向子库管理者申请，申请通过后才能访问",
  12527: "仅有素材管理者及素材库成员可以访问",
  12528: "该素材库不显示缩略图",
  12529: "没有下载权限的素材库访问者不显示缩略图",
  12530: "除管理员外的所有访问者下载都需要审批",
  12531: "可见性有效期  内部（保密）",
  12532: "到期后转为",
  12533: "有效期后需要审批通过才能改变可见性",
  12534: "素材库助理",
  12535: "素材库成员不受素材库可见性和分类可见性影响，都可以按权限访问素材库（受内部素材库下载需要审批设置的限制）",
  12536: "素材库助理可以增加和删除素材库成员，为素材库成员分配权限。但素材库助理不能移动和删除素材库。",
  12537: "素材库成员",
  12538: "请选择负责人",
  12539: "管理分类",
  12540: "管理素材库",
  12541: "分类",
  12542: "申请创建子素材库",
  12543: "申请访问",
  12544: "申请",
  12545: "申请访问分类《{-file-}》",
  12546: "申请访问素材库《{-file-}》",
  12547: "访问申请",
  12548: "申请下载{-file-}中的以下文件",
  12549: "申请下载以下文件",
  12550: "申请下载人员",
  12551: "管理申请人员",
  12552: "你将当前库设置为下载不再需要申请，而该库中有申请下载的历史数据，是否清除这些数据？",
  12553: "清除",
  12554: "保持",
  12555: "你没有权限创建子素材库，但你可以向管理者申请创建素材库，申请通过后，素材库会自动创建。",
  12556: "你已经在该目录下申请过创建素材库，一个目录一次只能申请创建一个素材库",
  12557: "选择素材库成员",
  12558: "请选择限定的部门",
  12559: "查看已授权申请人员名单",
  12560: "已授权访问人员",
  12561: "已授权下载文件",
  12562: "查看已授权下载人员",
  12563: "已授权信息",
  12564: "删除后，该用户将无法访问当前素材库",
  12565: "删除后，该用户将无法下载当前文件",
  12566: "用户名或密码错误，请核对后重新输入",
  12567: "你上一个申请还没通过，只有上一个申请通过后你才能提交新申请",
  12568: "分类下无法直接上传文件，你可以在分类下新建子素材库后在素材库上传文件",
  12569: "当前分类为空",
  12570: "当前素材库为空",
  12571: "批量设置分类",
  12572: "批量设置子素材库",
  12573: '批量设置"{-name1-}""{-name2-}"..等{-len-}个分类',
  12574: '批量设置"{-name1-}""{-name2-}"2个分类',
  12575: "保存后将覆盖所选分类的设置信息",
  12576: '批量设置"{-name1-}""{-name2-}"..等{-len-}个素材库',
  12577: '批量设置"{-name1-}""{-name2-}"2个素材库',
  12578: "此处为空则不批量设置负责人，保留原有负责人",
  12579: "保存后将覆盖所选素材库的设置信息",
  12580: "此处为空则不批量设置管理员，保留原有管理员",
  12581: "删除后，该用户将无法访问当前分类",
  12582: "输入文件名筛选对应文件",
  12583: "不隐藏保密素材库(非保密素材库成员也能看到该素材库)",
  12584: "申请成为成员",
  12585: "申请成为素材库成员",
  12586: "你正在申请成为{-name-}素材库的成员",
  12587: '输入用户名进行筛选',
  12588: "新客户端评估版",
  // 11116: '打开分享失败，请联系管理员',
  //*************hotfix****************/

  /*******************ocr******************* */
  12600: '提取图片文字（OCR）',
  12601: '最多支持一个文件上传，单个文件最大为20M',
  12602: '支持上传{-exts-}格式',
  12603: '仅支持上传20M以下{-exts-}文件',
  12604: '仅支持上传单个文件',
  12605: '再次OCR',
  12606: '识别结果',
  12607: '导出为文档',
  12608: 'OCR识别结果',
  12609: '识别图片文字（OCR）',
  12610: '正在识别中...',
  12611: '你可以点击并粘贴图片到此处',
  12612: '重试',
  12613: '另存为文档',
  12614: '“我们使用巴别鸟企业网盘快三年了，重要文件和设计稿件都在巴别鸟上，并且我们和巴别鸟团队一起合作开发了素材库功能来统一管理我们各个IP的素材和设计”',
  12615: '—— 泡泡玛特IT负责人：刘俊利',
  /////////////////************ai tag***************//////////////////// */

  12650: 'AI自动打标签',
  12651: 'AI自动打标签可以根据标签库里的预设标签自动匹配和当前文件最接近的标签，你也可以选择多个文件，批量使用AI自动标签。',
  12652: '打标成功后，每个文件将扣除1智点算力值',
  12653: '你的标签库里还没有任何标签',
  12654: 'AI自动打标签可以根据你或企业标签库里预设的标签自动匹配和当前文件最接近的标签。你可以先添加一批标签，然后用自动打标签功能为文件打标签。',
  12655: '去添加标签',
  12656: '下次不再显示该提醒',
  12657: '该类型文件目前还不支持AI自动打标签',
  12658: '希望以后支持？点击关闭并提交心愿',
  12659: '当前账号剩余智点数量不足，请购买后继续使用',
  12660: '最多支持选择{-num-}个文件',
  12661: '正在批量打标签，请稍后回来查看',
  12662: "Language",
  12663: "文件被锁定，无法完成操作，可能有人正在使用客户端编辑此文件，需要等待其编辑完成后，再尝试此操作",
  /***************************9.3.0*********************************/
  13000: '智巢AI',
  13001: '你剩余的智点数量',
  13002: '已使用的智点数量',
  13003: '购买智点',
  13004: '进行一次AI搜索大约会耗费1000个智点、普通全文搜索不会消耗智点',
  13005: '进行一次AI图搜图大约会耗费1万个智点',
  13006: 'AI助理根据回答的问题不同每个问题会耗费3k-1W 智点',
  13007: '查看使用详情',
  13008: '从今天开始享受AI带来的变革',
  13009: '账单',
  13010: '购买账号',
  13011: '有效期至',
  13012: '需要开票？点击输入',
  13013: '开票信息',
  13014: '所购产品',
  13015: '巴别鸟AI 智点套餐购买',
  13016: '有效期至',
  13017: '一年',
  13018: '总价',
  13019: '立即支付',
  13020: '购买智点数量',
  13021: '有效期',
  13022: "请填写正确邮箱地址，发票开具后将发送至该邮箱",
  13023: '需要发票',
  13024: '操作时间',
  13025: '收入/支出',
  13026: '剩余',
  13027: '智点使用详情',
  13028: '使用者',
  13029: '允许使用AI',
  13030: '关闭后，该用户界面上的AI功能入口不显示，仅可使用AI客服',
  13031: "去支付",
  13032: "智巢AI应用:",
  13033: "智能AI搜图",
  13034: "智能AI搜索",
  13035: "智体:",
  13036: "巴别鸟在线客服",
  13037: '智巢',
  13038: '你的专属企业助理，回答和你企业相关的任何问题',
  13039: 'AI搜索',
  13040: 'AI搜图',
  13041: '输入你的问题，例如“报销流程怎么走？”',
  13042: '创建智体',
  13043: '创建一个智能客服',
  13044: '可以对外提供客服的智能体',
  13045: '创建一个知识库机器人',
  13046: '一个回答特定问题的机器人',
  13047: '询问关于巴别鸟的一切问题',
  13048: '内测中...即将推出，敬请期待！',
  13049: '拖拽图片到此处或点击',
  13050: '抱歉，您上传的文件不是图片格式，请',
  13051: '重新上传',
  13052: '仅支持10M以下的{-exts-}格式文件',
  13053: '正在上传图片...',
  13054: '本地上传',
  13055: '点此通过描述寻找图片',
  13056: '点此通过图片匹配寻找相似图片',
  13057: '输入对图片的描述或粘贴图片到此处，支持文字和图片混合搜索',
  13058: '图片搜索',
  13059: '上传完成',
  13060: '暂无符合条件的图片文件',
  13061: '查看更多',
  13062: '抱歉，您上传的文件过大，请',
  13063: '智能知识库',
  13064: '再试一次',
  13065: '智点计费规则',
  13066: '计费项目（每次）',
  13067: '扣除智点数',
  13068: '查看智点扣费规则',
  13069: '万',
  13070: '千',
  13071: '参考来源',
  13072: '复制成功',
  13073: '开启',
  13074: 'ai搜索所需智点已不足，请购买后继续使用',
  13075: '请稍候...',
  13076: '启用智能搜索',
  13077: '输入对图片的描述进行搜索',
  //****************************excel ai********************* */
  13078: "Excel数据助理",
  13079: "文件预览",
  13080: "分析结果",
  13081: "点击或拖拽文件上传",
  13082: "选择我的云盘文件",
  13083: "上传文件要求说明",
  13084: "最多支持三个文件上传，单个文件最大为10M<br>支持上传csv、xls、xlsx格式",
  13085: "目前仅支持处理表格前三个有效sheet",
  13086: "试着输入对文档的分析请求",
  13087: "请选择文件",
  13088: "保存成图片",
  13089: "图片保存中",
  13090: "保存成功",
  13091: "保存失败，请稍后重试",
  13092: "新对话",
  13093: "Hello！欢迎使用Excel数据助理，上传文档后你可以试着问：",
  13094: "帮我计算XXX的平均值",
  13095: "对比XXX表和XXX表并分析",
  13096: "分析XXX的流量趋势",
  13097: "整理分数高于XXX的学生成绩",
  13098: "提取XXX数据生成一个柱状图",
  13099: "分析7月和8月的销售数据",
  13100: "2014至2024各地区数据增长和时间相关性",
  13101: "统计下XXX为XXX的现金收益",
  13102: "巴别鸟智巢&nbsp;AI&nbsp;网盘",
  13103: "让你",
  13104: "上工作",
  13105: "巴别鸟智巢已全线接入",
  13106: "AI搜索",
  13107: "学习网盘中存储的文件，根据文件内容、图像内容构建知识图谱，按权限搜索、查询、检索、问问题、写文章。",
  13108: "智体&nbsp;LLM&nbsp;Agent",
  13109: "定制化的智能体，可选择网盘中的内容学习并自动更新，按需完成如客服、信息收集、文件处理…等各种任务。",
  13110: "企业专属AI助理",
  13111: "了解你企业的AI助理，根据使用者权限来提供服务。接入DeepSeek回答企业问题，查找文件，撰写文章。",
  13112: "图搜图&nbsp;文搜图",
  13113: "通过描述或者示范图片搜索相关图片，按使用者权限提供不同结果。",
  13114: "AI&nbsp;知识库",
  13115: "学习企业文件提供知识问答，可自定义知识源，支持创建多个知识库。",
  13116: "数据分析助理",
  13117: "分析excel、csv等结构化数据，提供准确的数据分析、图表生成、数据查询、数据分类等服务，支持多表格交叉比对。",
  13118: '请上传后缀名为xls、xls、csv的文件',
  13119: '请先选择Excel文件',
  13120: '个人目录下，你没有上传文件的权限',
  //****************ai agent**************** */

  13200: "我的AI工具（智能体）",
  13201: "我的AI工具",
  13202: "我创建的",
  13203: "已发布",
  13204: "未发布",
  13205: "搜索智体",
  13206: "选择智体类型",
  13207: "知识库机器人",
  13208: "简单配置就可以回答特定范围问题",
  13209: "知识库机器人，可以当说明书",
  13210: "长文本生成",
  13211: "用于写文章，文本生成任务的AI助手",
  13212: "智能客服",
  13213: "可以嵌入你的网页，为你的客户回答产品问题的机器人",
  13214: "工作流",
  13215: "把某个文件夹的文件按一定要求自动化处理",
  13216: "{-name-}创建",
  13217: "智体名称&图标",
  13218: "给你的智体起个名字",
  13219: "描述",
  13220: "（可选）",
  13221: "输入应用描述",
  13222: "更改图标",
  13223: "上传图标",
  13224: "图标预览",
  13225: "智体名称不能含有特殊字符",
  13226: "请输入智体名称",
  13227: "未发布",
  13228: "发布成功",
  13229: "智体设置",
  13230: "发布智体",
  13231: "知识库",
  13232: "人设与回复逻辑",
  13233: "请输入人设与回复逻辑",
  13234: "知识源",
  13235: "你确定要从知识源中删除文件夹《{-name-}》吗？",
  13236: "开场白",
  13237: "请输入你的开场白文案",
  13238: "背景图",
  13239: "调试与预览",
  13240: "监测",
  13241: "编辑智体",
  13242: "更新成功",
  13243: "更新失败",
  13244: "为你的智能体增加对话背景图片，对话时更加沉浸",
  13245: "为你的智能体增加知识源，知识源是知识库读取文件的信息源，知识源可以添加多个。添加知识源后最多需要等待30分钟进行入库。",
  13246: "可见性",
  13247: "向所有人公开",
  13248: "收到链接的人可见",
  13249: "私密",
  13250: "发布更新",
  13251: "运行",
  13252: "嵌入网站（向所有人公开）",
  13253: "发布成功",
  13254: "未发布",
  13255: "没有找到知识库的知识源，请添加知识源",
  13256: "你已关注该智能体",
  13257: "你已取消关注该智能体",
  13258: "开启新对话",
  13259: "复制链接",
  13260: "获取链接失败，请稍后重试",
  13261: "删除智体",
  13262: "最近使用",
  13263: "你已成功移除该智体",
  13264: "智体数据错误",
  13265: "复制链接",
  13266: "已复制链接，分享给好友吧！",
  13267: "没有找到知识库的知识源，请添加知识源",
  //*************hotfix****************/

  15000: "确定要恢复所有文件吗？",
  // ****************************** 7.9.5
  20000: "发现您的账号在其他地方登录：",
  20001: "账号多地登录",
  20002: "您无权管理分享，请和分享发起者联系！如果您想获得链接地址，可以通过右键菜单中点击获取链接地址",
  20003: "企业禁止上传此类型文件！",
  // ****************************** 8.0
  20010: "个人版不支持此类型文件在线预览，敬请升级",
  20011: "此处的链接地址，您可以将其通过邮件或者QQ等第三方通信手段进行传播，获得此链接的人员即可以通过此链接访问文件。",
  20012: "office 在线编辑需要购买在线编辑授权，您可以免费试用30天，到期后如果还需要继续使用请联系我们销售人员购买授权。",
  20013: "文件在指定的位置不存在",
  // ***************************** transmittal
  20020: "亲爱的 {-name-}:",
  20021: "{-somebody-} 在项目{-file-}中对外发送了文件，发送单号为{-transmittal-}",
  20022: "该文件发送单已被删除",
  20023: "文件夹里没有文件",
  20024: "欢迎使用文控管理系统，只要访问这个链接就可以使用你的邮箱和验证码查看发送给您的文件，强烈建议保存此链接，方便随时查询",
  20025: "发送单号(Transmittal NO.)不能为空",
  20026: "文件列表不能为空",
  20027: "本次收到的文件",
  20028: "历史接收记录",
  20029: "版本",
  // 对应大写版本号
  20030: "接收人和邮箱都为必填项",
  20031: "接收人没有设置邮箱",
  20032: "确信要删除这 {-num-} 个传送单吗？",
  20033: "点击选择登录的邮箱",
  20034: "获取邮箱验证码",
  20035: "发现下列文件名已经存在，本次操作自动进行了重命名:",
  20036: "{-oldName-} --> {-newName-}",
  20037: "旧名字",
  20038: "新名字",
  20040: "<p>\u60A8\u7684\u5BA2\u6237\u7AEF\u7248\u672C\u8FC7\u4F4E\uFF0C\u65E0\u6CD5\u6B63\u5E38\u4F7F\u7528\u4E91\u6865\u3001\u540C\u6B65\u7B49\u529F\u80FD\uFF0C\u8BF7\u53BB\u5B98\u7F51\u4E0B\u8F7D\u6700\u65B0\u7248\u672C\u7684\u5BA2\u6237\u7AEF\u3002</p><p>\u4E0B\u8F7D\u5730\u5740\uFF1A<a style=\"margin-left: 0;\" href=\"https://www.babel.cc/p/download.do\" target=\"_blank\" >https://www.babel.cc/p/download.do</a></p>",
  20041: '文件夹路径 "{-folder-}" 创建失败，请稍后重试',
  20042: "session 数据失效!",
  // ***************************** release 8.2
  20050: "",
  20051: "可用空间不足，有可能你上传的目标文件夹做了空间限制，请联系管理员。",
  20052: ", 共{-fileNum-}个文件",
  20053: "您没有创建文件夹的权限",
  20054: "使用提示",
  20055: "检测到您正在使用企业微信打开网盘，为了获得更好的使用体验，建议使用浏览器访问。",
  20056: "在企业微信窗口右上角点击“浏览器打开”图标，即可通过浏览器访问",
  20057: "该文件收集箱已过期，不可上传文件",
  20058: "文件异常，请稍后重试，或者重新上传此文件",
  // *****************************  release 8.3
  20100: '目标文件夹下该文件"{-fileName-}"已经存在,请刷新文件列表查看!  ',
  20101: "点击重置密码可以在后台设置一个密码  ",
  20102: "此用户已存在但出于休眠状态，点击确定将其激活并加入本企业",
  // *****************************  release8.4
  20147: "请打开相应的部门再上传文件",
  20148: "当前文件目录下不支持上传文件",
  20149: "查看更多消息",
  20150: "部门范围",
  20151: "创建部门",
  20152: "创建项目",
  20153: "创建文件夹",
  20154: "分享 {-file-} 已到期, 已自动关闭。",
  20155: "分享已经到期，已自动关闭!",
  20156: "项目负责人不能同时兼任助理!",
  20157: "点击进行统计",
  20158: "上次访问的文件夹",
  20159: "正在操作",
  20160: "正在检测重名文件",
  20161: "上次选择的文件夹",
  20162: "服务器已经存在相同文件夹，请重新命名!",
  20163: "数据不完整，请汇报此问题",
  20170: "仅查看删除记录",
  20171: "视频文件不允许匿名访问，请登录后查看",
  20172: "推送消息接收设置",
  20173: "项目最近上传文件",
  20174: "正在生成报表，请稍后",
  21000: "忽略并继续上传",
  21001: "您需要上传的文件数量超过500个，容易造成系统响应缓慢导致上传失败。建议使用客户端同步功能批量上传文件。",
  21002: "*安装客户端后在需要上传的文件夹上右键点击，选择“巴别鸟-同步文件夹”即可",
  21003: "请填写您用来登录的邮箱地址或手机号获取验证码来重新设置新密码。如果您是使用工号登录，请联系管理员重置密码。",
  21100: "用于显示指定文件夹内的最近上传文件列表",
  // *********************************  release8.5.1
  21200: "发送文件{-file-}需要您的审批",
  21201: "您发送文件{-file-}获得批准，已经发送成功",
  21202: "您发送文件{-file-}未获得批准，发送失败",
  21203: "分享文件{-file-}的参与者涉及到了保密部门人员，需要您的审批",
  21204: "涉密操作",
  21205: "发起方{-user-}已经撤回该请求，此消息已经失效",
  21206: "项目{-file-}的参与者涉及到了保密部门人员，需要您的审批",
  21207: "您访问的链接不存在或文件已取消分享或你无权查看该文件！",
  21208: "加入分享需要获得企业保密员或者管理员的批准，该请求已经发送给相关人员，请等待审核！",
  21209: "您加入分享{-file-}的请求已经获得批准",
  21210: "您加入分享{-file-}的请求被否决",
  21211: "由于涉及到保密部门人员，需要企业管理人员进一步审批<br>请等待审批结果</br>",
  21212: "成员发起分享",
  21213: "成员加入分享及项目",
  21214: "成员发送文件",
  21215: "审批人",
  21216: "多部门成员发送文件",
  21217: "需要审批",
  21218: "安全保密员或超级管理员",
  21219: "审批人为安全保密员或超级管理员",
  21220: "无需审批",
  21221: "上级主管",
  21222: "分享给其他部门人员需要审批",
  21223: "分享或项目邀请保密部门人员加入时，需要安全保密员或超级管理员的审批。",
  21224: "有保密部门的企业，链接分享不允许匿名上传；不允许创建开放式文件收集箱。",
  21225: "只有“公开”策略下的部门支持链接分享，其他策略都仅支持邀请分享；",
  21226: "绝密文件：默认除了创建者、项目负责人、文件负责人和部门经理外部门内其他人不可见，分享该文件必须获得安全保密员授权；",
  21227: "限制文件：一般人员只读，分享该文件必须获得上级主管授权；",
  21228: "内部文件：分享该文件给部门外人员，必须获得上级主管授权；",
  21229: "绝密文件，限制文件，一般人员不能移动/复制/上传新版本/下载/重命名/查看版本，上级主管和有部门文件管理权限的人员才可以。",
  21230: "操作失败,因该文件已被举报!",
  21231: "该用户不允许在当前IP地址上传文件",
  21232: "",
  // ***************************************  release8.5.3
  21300: "{-somebody-} 为 {-file-} 创建了快照分享",
  21301: "快照",
  21302: "您无权查看此文件的快照分享",
  21303: "权限申请批复",
  21304: "您对文件{-file-}申请的权限已获得批复结果，结论：{-result-}",
  21305: "该文件的最新版本还在编辑处理中，当前显示的还是旧版本",
  21306: "该文件的最新版本还在编辑处理中，当前下载的还是旧版本",
  21307: "下载旧版本",
  // **************************************  release8.5.4
  21400: "今日上传:",
  21401: "今日下载:",
  21402: "操作失败，不能含有绝密部门或其人员",
  21403: "当前企业人数已经超过了授权人数，请尽快处理，以免影响普通人员的登录和使用",
  21404: "解锁失败，文件已被他人锁定!",
  21405: "删除失败，文件被他人锁定！",
  21406: "搜索档案库,按回车键确认",
  ///////////////////////////////////////////////////////9.0.2/////////////////////////////////////

  21500: "策略名称重复，保存失败",
  21501: "分享给部门外成员",
  21502: "分享给项目外成员",
  21503: "{-somebody-} 在 {-parentFolder-} 中新建了项目{-folder-}",
  21504: "{-somebody-} 在 {-parentFolder-} 中新建了文控项目{-folder-}",
  21505: "来自{-user-}的项目",
  21506: "您可以在“我的项目”中查看该文件",
  21507: "您可以在“文件收集箱”中查看该文件",
  21508: "当前文件夹已存在名称为 {-name-} 的文件夹，该文件夹上传失败，请修改文件名后再次上传",
  21509: "接下来的同名文件夹忽略该提示（同名文件夹默认不上传）",
  21510: "发现同名文件夹",
  21511: "管理部门",
  21512: "文件数量超过了 {-limit-}，快照分享不支持， 请使用普通分享功能",
  21513: "统计用量",
  21514: "正在计算中，请稍后",
  21515: "企业占用空间  ",
  21516: "部门模板文件夹删除后，不会进入回收站，会直接删除，你是否确定删除？",
  21517: "巴别鸟白皮书.pdf",
  21518: "我加入的部门",
  21519: "目前公有云版本不支持在线播放此格式视频，您可以下载后播放，或联系客服选择私有化部署",
  21520: "仅文件夹",
  21521: "回收站",
  21522: "企业已删除文件管理",
  21523: "文件所属部门",
  21524: "删除审核部门",
  21525: "主题色",
  21526: "和系统一致",
  21527: "深色",
  21528: "浅色",
  21529: "你的企业身份发生了改变，新的企业身份：{-name-}",
  // 21529: "你的企业身份发生了改变！",
  21530: "本地编辑",
  21531: "本地只读打开",
  21532: "部门成员",
  // 21525: "",
  // 21525: "",
  // 21525: "",

  //********************cad************************************** */
  21550: "正在准备预览数据",
  21551: "服务器正在转码，请稍候重试",
  21552: "图纸下载失败",
  21553: "正在载入",
  // ************************************* release 8.7.1
  21601: "查看登录历史",
  21602: "查看参与的分享",
  21603: "IP",
  21604: "设备类型",
  21605: "设备名",
  21606: "本账号正在其他地点登录, ip:{-ip-}，如果不是你本人所为，请尽快修改密码，并在个人设置-设备管理界面中将其踢出",
  21607: "没有登录历史",
  21608: "提示：此人从未登录过本系统",
  21609: "查看参与的特设文件",
  21610: "暂无参与的特设访问控制的文件",
  21611: "查看参与的分享",
  21612: "查看参与的项目",
  21613: "参与分享文件列表",
  21614: "暂无参与的分享",
  21615: "暂无参与的项目",
  21616: "参与项目文件列表"
}, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, "21611", "查看参与的分享"), "21612", "查看参与的项目"), "21613", "参与分享文件列表"), "21614", "暂无参与的分享"), "21615", "暂无参与的项目"), "21616", "参与项目文件列表"), 21617, "超过数量限制，超级管理员将收到邮件或短信提醒"), 21650, "所有标签"), 21700, "客户端版本太低，请下载最新客户端来完成下载"), 21800, "企业标签"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 21801, "个人标签"), 21802, "系统仅支持最多{-maxTerminals-}个设备同时在线"), 21900, "并集"), 21901, "交集"), 21902, "对称差集"), 21903, "无标签"), 21904, "分钟"), 21905, "小时"), 21906, "天"), 21907, "周"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 21908, "月"), 21909, "最近"), 21910, "超过"), 21911, "之前"), 21912, "至今"), 21913, "最近{-time-}{-unit-}"), 21914, "{-time-}{-unit-}之前"), 21915, "{-start-}至{-end-}"), 21916, "在"), 21917, "和"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 21918, "之间"), 21919, "我删除的文件"), 21920, "他人删除的文件"), 21921, "仅允许企业内人员访问"), 21922, "设置分享的审核"), 21923, "需要审核的文件操作"), 21924, "分享文件"), 21925, "发送文件"), 21926, "审核人员"), 21927, "新增审核人员"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 21928, "清除配置项"), 21929, "{-user-}设置于{-time-}"), 21930, "申请将文件{-file-}的”{-roleName-}“权限"), 21931, "发送文件需要您的审核"), 21932, "管理员可在“企业控制台-文件配置”栏目添加审批流程"), 21933, "无地点"), 21934, "针对当前文件夹内的任何文件，如果有保密的需要，可以在此设置当其中的文件进行分享或发送时需要通知相关人员进行审核"), 21935, "本阶段通过后，文件位置："), 21936, "当前位置（不移动文件）"), 21937, "移动到所选文件夹"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 21938, "本阶段结束文件移动至："), 21939, "文件白名单"), 21940, "文件白名单,即文件类型白名单，加入白名单的文件类型将只允许白名单内文件类型上传，输入您想上传的文件扩展名到下面的列表即可"), 21941, "请输入加入白名单的文件扩展名，例如jpg"), 21942, "白名单列表"), 21943, "白名单优先级高于黑名单，白名单列表里有文件类型的话，黑名单不生效。部门或项目设置的白名单优先级高于此处的白名单。"), 21944, "请选择安全策略"), 21945, "本次发送文件需要审核，审核通过后会自动执行发送"), 21946, "未安装CAD在线预览模块。如需预览DWG文件，请联系企业管理员"), 21947, "当前位置（不移动文件）"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 21948, "目标文件夹已被删除"), 21949, "（网页端不受限制）"), 21950, "批量重命名"), 21951, "文件数"), 21952, "重命名方式"), 21953, "自定义"), 21954, "替换"), 21955, "插入"), 21956, "删除"), 21957, "按时间重命名"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 21958, "新文件名"), 21959, "大小写转换"), 21960, "不变"), 21961, "全部大写"), 21962, "全部小写"), 21963, "首字母大写"), 21964, "首字母小写"), 21965, "请输入新文件名"), 21966, "编号设置"), 21967, "起始"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 21968, "第一位编号"), 21969, "增量"), 21970, "增加的数字"), 21971, "位数"), 21972, "编号一共有几位"), 21973, "开始批量重命名"), 21974, "原文件名"), 21975, "新文件名"), 21976, "状态"), 21977, "名称来源"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 21978, "文件创建时间"), 21979, "文件修改时间"), 21980, "当前时间"), 21981, "时间样式"), 21982, "yyyy年mm月dd日HH时mm分"), 21983, "时间插入位置"), 21984, "文件名头"), 21985, "文件名尾"), 21986, "去除文件名"), 21987, "去除文件名并增加编号"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 21988, "yyyy年MM月dd日HH时mm分"), 21989, "插入位置"), 21990, "插入类型"), 21991, "自定义内容"), 21992, "编号"), 21993, "插入内容"), 21994, "查找内容"), 21995, "替换内容"), 21996, "按文件名位置"), 21997, "文件名中的空格"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 21998, "文件名中的数字"), 21999, "文件名中的引号"), 22000, "删除类型"), 22001, "开始位置"), 22002, "长度"), 22003, "删除内容"), 22004, "文件属性"), 22005, "文件创建者"), 22006, "文件负责人"), 22007, "最近版本修改者"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 22008, "插入文件属性"), 22009, "待操作"), 22010, "文件开始重命名，请稍后"), 22011, "文件重命名完成"), 22012, "文件名过长"), 22013, "你可以右键使用本地预览CAD<br/>如需在线预览需要购买在线预览CAD模块"), 22014, "查看登录的设备"), 22015, "当前文件列表的服务器数据发生改变<br/>是否刷新界面查看最新数据？"), 22016, "，可使用右键“本地编辑”功能打开预览"), 22017, "下载失败"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 22018, "文件正在进行在线编辑"), 22019, "老版本Win客户端"), 22020, "客户端Linux版"), 22021, "Ubuntu,统信UOS, 麒麟"), 22022, "联系客服试用"), 22050, "查看分享文件"), 22051, "加载失败"), 22052, "暂无分享文件"), 22053, "文件夹内所有分享文件"), 22054, "当前文件夹没有打开分享的文件(夹)"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 22055, "正在关闭分享..."), 22056, "新增文件夹"), 23000, "强制更新密码"), 24000, "素材库消息"), 24001, "申请在素材库中创建分类《{-file-}》"), 24002, "申请在素材库中创建子素材库《{-file-}》"), 24003, "{-name-}  申请在  {-type-} 《{-file-}》 中创建以下分类"), 24004, "{-result-}了你创建分类《{-file-}》的申请"), 24005, "{-result-}了你创建子素材库《{-file-}》的申请"), 24006, "{-name-}  申请在  {-type-} 《{-file-}》 中创建以下素材库"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 24007, "{-name-}  申请访问{-type-} 《{-file-}》"), 24010, "素材库 《{-name-}》 原可见性({-accessType-})设定的时间已到期，可见性根据预设将自动设定为({-nextAccessType-})，需要您的审批"), 24011, "素材库 《{-name-}》 原可见性设定的时间已到期，可见性根据预设已经自动设定为({-accessType-})"), 24012, "申请下载素材库中的文件（夹）《{-name-}》等文件"), 24013, "您申请下载素材库中的文件（夹）《{-name-}》等文件，已被管理员{-result-}"), 24014, "{-result-}了你访问分类《{-file-}》的申请"), 24015, "{-result-}了你访问子素材库《{-file-}》的申请"), 24016, "在线编辑已经完成并提交了，<br/>是否刷新查看最新版本？"), 24017, "在素材库中创建了分类《{-file-}》"), 24018, "在素材库中创建了子素材库《{-file-}》"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 24019, "修改了部门设置《{-file-}》"), 24020, "素材分类"), 24021, "子素材库"), 24022, "不支持此种类型的文件在线预览"), 24023, "申请加入子素材库《{-name-}》"), 24024, "{-result-}了你加入子素材库《{-file-}》的申请"), 24025, "申请加入素材库"), 24026, "素材库"), 'AI_SEARCH', "AI搜索"), 'WORD_S_IMAGE', "以文搜图"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 'IMAGE_S_IMAGE', "以图搜图"), 'AI_TALK', "AI对话"), 'IMAGE_OCR', "图片 OCR"), 'DOC_ASSISTANT', "文档助手"), 'SPREAD_SHEETS', "表格问答"), 'buy tokens', "购买智点"), 'DEEP_SEARCH', "深度思考(Deepseek-R1)"), 'ONLINE_SERCH', "联网搜索"), 'DEEP_RESEARCH', "深度研究"), 24100, "回到最新版本"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 24101, '可以在这里描述要搜索的图片，例如“背景是蓝天白云”'), 24102, '你所在企业有旧数据需要 AI 进行学习处理，是否立即处理？'), 24103, "你个人有旧数据需要 AI 进行学习处理，是否立即处理？"), 24104, "个人文件处理中..."), 24105, "企业文件处理中..."), 24106, "个人文件处理完毕<br>"), 24107, "企业文件处理完毕"), 24108, "等待处理的个人文件：{-count-}个<br>"), 24109, "等待处理的企业文件：{-count-}个"), 24110, "AI 处理历史数据"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 24111, "处理完毕"), 24112, '企业剩余的智点数量'), 24113, '复制为markdown'), 25000, "添加授权人员"), 25001, "仅查看登录"), 26000, "帮我写一篇公众号文章"), 26001, "智巢能做什么"), 26002, '总结一下"白皮书"'), 26003, "入职流程有哪些"), 26004, "搜索有大海的所有图片"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 26005, "我司产品主要有哪些"), 26006, "Hello! 你可以问我"), 26007, "试着输入问题开启对话"), 26008, "深度思考"), 26009, "联网搜索"), 26010, "思考中"), 26011, "已深度思考，用时（{-num-}）秒"), 26012, "新对话"), 26013, "已深度思考"), 26014, "回答结束，用时（{-num-}）秒"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 26015, "回答结束"), 26016, "回答超时，请稍后重试"), 26017, "简单描述一下这张图片"), 26018, "请显示出图片中出现的文字"), 26019, "已搜索到{-num-}个来源"), 26020, "快速搜索"), 26021, "适应每个查询"), 26022, "深度研究"), 26023, "关于复杂主题的深入报告"), 26024, "搜索历史会话"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 26025, "今天"), 26026, "本周"), 26027, "本月"), 26028, "本年"), 26029, "星期一"), 26030, "星期二"), 26031, "星期三"), 26032, "星期四"), 26033, "星期五"), 26034, "星期六"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 26035, "星期日"), 26036, "历史会话"), 26037, "正在搜索，请稍候"), 26038, '剩余智点数  {-num-}'), 26040, '仅支持10M以下的csv、xls、xlsx格式文件'), 26039, '智点'), "26040", '仅支持10M以下的csv、xls、xlsx格式文件'), 26050, '深度搜索时间较长，来杯咖啡，其他的事情交给智巢，等几分钟再回到这个界面...'), 26051, "开始搜索，请稍候"), 26052, "搜相似"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 26053, "搜索相似图片"), "25000", "添加授权人员"), "25001", "仅查看登录"), 27000, "创建链接文件"), 27001, "链接"), 27002, "名称"), 27003, "缩略图"), 27004, "创建链接文件失败"), 27005, "打开链接"), 27006, "创建链接文件成功"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 27007, "除管理员外的访问者创建子素材库需要审批"), 27008, "输入一个链接地址"), 27009, "为链接文件指定个名字"), 27010, "链接格式错误"), 27011, "编辑链接文件"), 27012, "显示子文件夹内容"), 27013, "编辑链接文件成功"), 27014, "文件大小超过5MB限制，请选择较小的文件"), 27015, "编辑链接文件失败"), 27016, "链接文件不支持下载"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 27017, "加密文件夹"), 27018, "创建加密文件夹"), 27019, "巴别鸟加密文件夹采用非对称加密技术，你设定的密码是唯一打开该文件夹的方式。"), 27020, "请填写名称"), 27021, "点此输入文件夹名称"), 27022, "请妥当保管好你的密码"), 27023, "密码丢失后无法找回！并且密码丢失后也无法恢复该文件夹里的文件"), 27024, "点此输入你的密码"), 27025, "再次输入你的密码"), 27026, "密码要求为6-20位大小写字母或数字的组合"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 27027, "*文件夹加密后里面的文件不能同步或者在映射盘访问"), 27028, "请输入6-20位包含大小写字母或数字的组合"), 27029, "请输入加密文件夹密码"), 27030, "请输入加密文件夹《{-name-}》密码"), 27031, ""), 27032, ""), 27033, ""), 27100, "将企业文件版本保留时间设置为 {-time-} 天"), 27101, "将企业文件版本保留个数设置为 {-num-} 个"), 28000, "自动化任务"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 28001, "查看现有任务列表"), 28002, "自动清理文件"), 28003, "自动重命名"), 28004, "自动转PDF"), 28005, "自动整理文件"), 28006, "可设定任务，按特定规则删除指定文件夹中的文件。"), 28007, "上传到指定文件夹中的文件自动按照设定的规则自动重命名。"), 28008, "上传到指定文件夹中的文件可自动生成PDF副本。"), 28009, "在指定的文件夹中按预置的规则分类及整理文件。"), 28010, "任务"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 28011, "自动清理文件夹"), 28012, "新建自动清理文件夹"), 28013, "选择目标文件夹"), 28014, "点击选择一个文件夹"), 28015, "包括所有子文件夹中的文件"), 28016, "如子文件夹也设定了清理任务，则清理任务叠加"), 28017, "选择清理触发条件"), 28018, "下拉菜单提示：选择触发条件"), 28019, "更改文件夹"), 28020, "该任务建立后"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 28021, "文件进入该文件夹（文件上传后）"), 28022, "文件数量"), 28023, "文件夹大小"), 28024, "仅删除文件，不删除子文件夹"), 28025, "选择触发条件"), 28026, "选择定时方式"), 28027, "固定时间间隔"), 28028, "按周期"), 28029, "全部文件（默认）"), 28030, "特定大小"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 28031, "特定文件类型"), 28032, "关键字"), 28033, "重复文件"), 28034, "自动删除该文件"), 28035, "每隔"), 28036, "选择删除文件范围"), 28037, "自动清空文件夹"), 28038, "删除文件名包含以下关键字的文件"), 28039, "内容一致的文件只保留一个"), 28040, "在此处填写需要删除文件类型的扩展名，多个扩展名之间以“,”分隔         例如：jpg,png,mp4 （不区分大小写）"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 28041, "在此处填写需要删除文件的文件名所包含的关键字，以“,”分隔"), 28042, "自动删除特定大小的文件"), 28043, "删除大小"), 28044, "到"), 28045, "的文件"), 28046, "自动删除以下扩展名的文件"), 28047, "每天"), 28048, "每周日"), 28049, "清除频率"), 28050, "每月第一个周日"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 28051, "每年12月31日"), 28052, "选择时间"), 28053, "时间"), 28054, "包含子文件夹中的文件"), 28055, "文件总数量超过"), 28056, "填写触发条件数字，最小1最大99999"), 28057, "文件总大小超过"), 28058, "请选择清理触发条件"), 28059, "编辑自动清理"), 28060, "秒"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 28061, "年"), 28062, "目标文件夹"), 28063, "取消该任务"), 28064, "暂无自动化任务"), 28065, "自动化任务列表"), 28066, "文件夹名称（任务名）"), 28067, "任务类型"), 28068, "自动清理"), 28069, "你是否要取消该自动化任务，不再执行"), 28070, "自动化"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 28071, "创建自动重命名任务"), 28072, "自动重命名"), 28073, "文件添加到以下文件夹后自动重命名"), 28074, "应用于已有文件"), 28075, "如果文件超过1000个，则不适用"), 28076, "示例文件名"), 28077, "并非所有规则或元数据都适用于或可用于每个文件或文件类型。"), 28078, "选择规则"), 28079, "标准选项"), 28080, "编号"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 28081, "自定义内容"), 28082, "文件上传者"), 28083, "文件负责人"), 28084, "上级文件夹"), 28085, "上传时间"), 28086, "媒体元数据"), 28087, "拍摄日期"), 28088, "相机制造商"), 28089, "相机型号"), 28090, "镜头型号"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 28091, "尺寸"), 28092, "每英寸点数（DPI）"), 28093, "每厘米点数（DPCM）"), 28094, "添加规则"), 28095, "选择修改文件名规则"), 28096, "替换内容"), 28097, "删除内容"), 28098, "删除字符"), 28099, "原始文件名"), 28100, "输入要替换的关键字"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 28101, "输入替换的内容"), 28102, "输入要删除的内容"), 28103, "文件名中的空格"), 28104, "文件名中的数字"), 28105, "文件名中的引号"), 28106, "文件名中的破折号及下划线"), 28107, "起始:"), 28108, "增量:"), 28109, "位数:"), 28110, "起始：表示第一位编号 \n 增量：增加的数字\n位数：编号的位数"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 28111, "点击填写自定义内容"), 28112, "年-月-日"), 28113, "年-月"), 28114, "年月日"), 28115, "年-月-日-小时.分钟"), 28116, "年月日-小时.分钟"), 28117, "月-日-小时.分钟.秒"), 28118, "替换在文件名中检测到的日期"), 28119, "大小写转换"), 28120, "首字母大写"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 28121, "首字母小写"), 28122, "全部大写"), 28123, "全部小写"), 28124, "字词分隔符"), 28125, "空格"), 28126, "下划线"), 28127, "破折号"), 28128, "编辑自动重命名任务"), 28129, "新建自动整理"), 28130, "进行文件整理"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 28131, "编辑自动整理任务"), 28132, "选择整理规则"), 28133, "按月分类"), 28134, "按添加到网盘的月份创建文件夹并移动文件到改文件夹"), 28135, "按年分类"), 28136, "按添加到网盘的年份创建文件夹并移动文件到改文件夹"), 28137, "关键字分类"), 28138, "根据文件名中包含的特定关键字移动文件到特定文件夹"), 28139, "按文件名中包含的关键字把文件进行分类，按关键字任务先后顺序进行处理"), 28140, "添加关键字分类"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 28141, "将文件移动至"), 28142, "选择文件夹"), 28143, "输入关键字"), 28144, "文件夹名字"), 28145, "请选择文件夹"), 28146, "关键字不能重复"), 28147, "文件添加到选定的目录后可以自动转换为PDF文件"), 28148, "新建自动转PDF"), 28149, "编辑自动转PDF"), 28150, "选择转PDF的文件类型"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 28151, "所有支持的文件"), 28152, "转为PDF"), 28153, "超过30M的文件将不会转换"), 28154, "转换成功后删除原文件"), 28155, "图片类"), 28156, "文档类"), 28157, "图形类"), 28158, "取消全选"), 28159, "选择了{-exts-}{-num-}种文件类型"), 28160, "选择了{-exts-}...等{-num-}种文件类型"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 28161, "请选择转PDF的文件类型"), 28162, "应用于新的上传文件"), 28163, "输入当前目录要搜索的文件名"), 28164, "保留两位小数"), 28165, "你没有权限将当前文件夹中的文件移入目标文件夹"), 28166, "你可以选择下面任意一名或多名审批人来审批你的分享请求，其中任意一名通过你的请求后系统后会自动发送邀请"), 28167, "你邀请的共享人有外部用户，需要通过审批后才能分享。你可以填写拟邀请人员来发送邀请请求"), 28168, ""), 28169, ""), 28170, "创建签章"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 28171, "可以在网盘上盖章签署文件，支持多种文件类型，签章文件可导出为PDF"), 28172, "如何使用签章？"), 28173, "点击查看签章教程"), 28174, "批量创建文件夹"), 28175, "按要求导入excel模板文件批量创建文件夹"), 28176, "选择要批量创建文件夹的目标目录，项目只能创建于部门文件夹及个人文件根目录下"), 28177, "选择创建的文件夹类型"), 28178, "导入文件夹名列表"), 28179, "文件夹名以换行分隔，一行一个文件夹名。支持导入的文件类型为 xls、xlsx，最大限制 5000 行"), 28180, "项目文件夹"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 28181, "下载模版后按模版填写，项目负责人为空默认创建者为项目负责人，项目文件夹名以换行分隔，一行一个文件夹名。项目负责人为邮箱及手机号，支持导入的文件类型为 xls、xlsx、csv，最大限制 5000 行。"), 28182, "点击此处下载批量创建项目文件夹模版"), 28183, "点击此处下载批量创建文件夹模版"), 28184, "点击或拖拽文件上传"), 28185, "开启敏感内容识别"), 28186, "含敏感内容文件列表"), 28187, "自定义敏感词"), 28188, "在此输入你需要识别的敏感词"), 28189, "敏感内容识别"), 28190, "在上方输入你需要识别的敏感词，500个词及以内，每个词不超过10个字符，使用“,”或空格进行分隔"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 28191, "上传敏感词库"), 28192, "点击上传按钮上传敏感词库，上传后30分钟内生效。"), 28193, "文件为TXT格式，500个词及以内，每个词不超过10个字符，文件大小100KB以内，UTF-8(无BOM)编码，使用“,”或空格、换行进行分隔。"), 28194, "含敏感词文件处理策略"), 28195, "仅标记（把含敏感词的文件进行标记）"), 28196, "禁止查看及编辑（替换为敏感词警告画面）"), 28197, "禁止分享（含敏感词文件的分享将会被自动关闭）"), 28198, "含敏感词文件列表"), 28199, "请输入文件名称或关键词进行查询"), 28200, "未上传"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 28201, "删除文件"), 28202, "文件所属"), 28203, "暂无包含敏感词的文件"), 28204, "请上传 .txt 文件！"), 28205, "重新上传"), 28206, "你上传的敏感词库不符合系统要求，请按要求整理后重新上传"), 28207, "对外分享不需要审批"), 28208, "开启后邀请分享可以输入企业成员外邮箱及手机号，并开启外链分享"), 28209, "对外分享需要审批"), 28210, "添加用户对外分享时可以选择的审批人，点击添加审批人员"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 28211, "点击添加审批人员"), 28212, "审批人员列表"), 28213, "确定从审批人员中移除该用户？"), 28214, "选择审批人"), 28215, "允许部门对外分享"), 28216, "审批人员列表最多可以容纳5名成员"), 28217, "你可以选择下面任意一名或多名审批人来审批你的分享请求，其中任意一名通过你的请求后系统后会自动发送邀请"), 28218, "你邀请的共享人有外部用户，需要通过审批后才能分享。"), 28219, "请先上传创建所需模板文件"), 28220, "模板文件解析失败"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 28221, "正在解析模板文件"), 28222, "导入的文件夹名"), 28223, "共导入了{-total-}个文件夹，其中有{-num-}个文件夹因为文件名不符合要求导入失败"), 28224, "开始创建"), 28225, "该文件为敏感文件，已被限制"), 28226, "企业发布"), 28227, "请选择审批人"), 28228, "管理工具"), 28229, "链接分享关闭后，再次开启需要经过文件管理审批，你确定关闭此链接分享吗？"), 28230, "未命名节点(可右键重命名)"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 28231, "你可以在文件目录节点上右键打开菜单项，进行新建，删除，重命名操作，创建失败的可以编辑后尝试重新创建"), 28232, "正在创建中，请等待完成后重试"), 28233, "（已忽略）"), 28234, "确定忽略该文件？该操作不可逆。"), 28235, "确定要删除该文件吗?"), 28236, "自定义敏感词发生了变化，是否保存到服务器"), 28237, "请上传.xlsx, .xls文件"), 28238, "上传的目录结构是空的，请编辑后重新上传"), 28239, "自定义敏感词中含有特殊符号"), 28240, "不允许对外分享"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 28241, "禁止用户自己修改个人信息"), 28242, "打开此选项，企业成员无法通过设置界面自己更改个人信息"), 28243, '设置此选项后，对于用户个人文件分享，这里的配置将会覆盖掉企业设置的"禁止分享文件给企业外用户"配置结果'), 28244, "(企业允许)"), 28245, "(企业不允许)"), 28246, "(继承上级部门设置)"), 28247, "企业禁止修改此项信息"), 28248, "文件包含管理员设定的敏感词，禁止访问"), 28249, "仅企业版支持此功能"), 28250, "免费版不支持此功能。可升级至专业版或企业版使用此功能"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 28300, "选择水印类型"), 28301, "水平平铺"), 28302, "居中单幅"), 28303, "输入自定义文字作为水印内容，支持多终端同步展现。"), 28304, "上传透明背景的PNG图片效果最佳，请注意控制原图尺寸。"), 28305, "使用图形（矢量）水印"), 28306, "使用图形化矢量编码承载 Hex 特征码，截图后仍可通过显影和编码表回溯识别。"), 28307, "特征码(Hex，8位)"), 28308, "对抗形态引擎"), 28309, "自然可识别系列"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 28310, "Anti-AI 隐蔽防护系列"), 28311, "测试模式"), 28312, "明暗反差自适应（高性能）"), 28313, "明暗对比双描边点"), 28314, "灰白浮雕点（低打扰）"), 28315, "深海蓝描边点"), 28316, "暖金描边点"), 28317, "纹理伪装探针（低可见）"), 28318, "残留冗余碎片（显影优先）"), 28319, "主体耦合纹理（抗识别）"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 28320, "黑白高对比测试"), 28321, "AI 去除防护声明（截图保留）"), 28322, "明示层：可与编码叠加。若模型仍尝试处理水印，优先暴露的是声明层，Anti-AI 图形编码应继续伪装在画面纹理中并可通过显影追踪。"), 28323, "泄漏追踪显影入口"), 28324, "返回图形（矢量）水印设置"), 28325, "上传疑似泄漏截图后，系统会按当前水印模式降低背景干扰，并增强接近水印配色、描边和局部扰动的区域，便于对照编码表识别特征码。"), 28326, "编码对应表"), 28327, "上传泄漏截图 (开始显影)"), 28328, "显影优化方式"), 28329, "明暗反差自适应"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 28330, "灰白浮雕点（低打扰）"), 28331, "显影提纯严苛度"), 28332, "未上传图片。上传后可在右侧查看显影结果，并先找 3 点同步位，再按其后的 3x3 点簇对照编码表读取 Hex 编码。"), 28333, "编码查询"), 28334, "输入编码片段、通配符、文件名或分享人"), 28335, "支持模糊查询：识别出至少 2 个编码字符即可查。通配符中 * 代表任意多位未知字符，? 代表 1 位未知字符，例如 *A?2 或 *A*2*；也支持文件名、分享人、接收方模糊查询。当前为界面示例数据。"), 28336, "显影编码对应表"), 28337, "请拖拽图片到此处，或点击选择"), 28338, "选择图片"), 28339, "显影图"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 28340, "原图"), 28341, "适应"), 28342, "请拖拽泄漏截图到此处，或点击选择"), 28343, "选择泄漏截图"), 28344, "上传疑似泄漏截图并进行显影提纯，便于识别图形（矢量）水印中的 Hex 特征码。"), 28345, "水印密度"), 28346, "物理缩放（短边比例）"), 28347, "散布随机度"), 28348, "抗去除扰动强度"), 28349, "图形水印采用模块格子排布。"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 28350, "更新水印设置"), 28351, "查询失败，请稍后重试。"), 28352, "未找到匹配记录。可尝试输入更短的编码片段。"), 28353, "当前预览人员"), 28354, "用户ID："), 28355, "分享者"), 28356, "编码 "), 28357, "文件ID："), 28358, "允许用户自定义分享文件水印"), 28359, "开启后，用户在分享文件时无法自定义水印设置"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 28360, "水印显示范围"), 28361, "仅预览模式"), 28362, "所有页面"), 28363, "水印显示范围设置成功"), 28364, "水印显示范围设置失败，请稍后重试"), "27102.0", " 在企业后台 {-Prohibited_allowed-} 分享个人私有文件"), 27102.1, " 在企业后台 {-Open_close-} 显示组装结构"), 27102.2, " 在企业后台 {-Prohibited_allowed-} 对外分享文件"), 27102.3, " 在企业后台 {-Open_close-} 企业发布文件夹"), 27102.4, " 在企业后台 {-Open_close-} 用户停用自动关闭该用户开启的企业文件分享链接的功能"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 27102.5, " 在企业后台 {-Prohibited_allowed-} 匿名分享"), 27102.6, " 在企业后台 {-Open_close-} 动态通知功能"), 27102.7, " 在企业后台 {-Prohibited_allowed-} 使用系统分享权限"), 27102.8, " 在企业后台 {-Open_close-} mac 地址双向绑定的功能"), 27102.9, " 在企业后台 {-Open_close-} 显示企业简称的功能"), "27102.10", " 在企业后台 {-Open_close-} 对没有下载权限的用户关闭显示缩略图的功能"), 27102.11, " 在企业后台 {-Open_close-} 定期强制修改旧密码的功能"), 27102.12, " 在企业后台 {-Open_close-} 计算搜索权限"), 27102.13, " 在企业后台 {-Open_close-} 自动解锁"), 27102.15, " 在企业后台 {-Open_close-} 自定义个人信息功能"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 27102.16, " 在企业后台 {-Open_close-} 视频预览功能"), 27102.17, " 在企业后台 {-Open_close-} 分享水印自定义功能"), 27102.18, " 在企业后台 {-Open_close-} 全页面水印功能"), "27103.0", "在企业后台 {-Open_close-} 共同发布文件夹的显示功能"), 27103.1, "在企业后台 {-Open_close-} 隐藏组织结构的功能"), 27103.2, "在企业后台 {-Open_close-} 允许用户上传个人文件的配置项"), 27103.3, "在企业后台 {-Open_close-} 允许用户分享个人文件的配置项"), 27103.4, "在企业后台 {-Open_close-} 发送邮箱通知的配置项"), 27103.5, "在企业后台 {-Open_close-} 隐藏管理员日志的功能"), "Open_close.0", "开启了"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, "Open_close.1", "关闭了"), "Prohibited_allowed.0", "禁止了"), "Prohibited_allowed.1", "允许了"), 27104.1, "{-somebody-} 在素材库中修改了分类 {-files-} 如下设置:{-fileChanges-}"), 27104.2, "{-somebody-} 在素材库中修改了子库 {-files-} 如下设置:{-fileChanges-}"), "MATERIAL_OP_NAME", {
  1: "修改可见性",
  2: "修改访问规则",
  4: "添加助理",
  8: "添加成员",
  16: "添加授权人员",
  32: "修改限定部门名单",
  64: "修改管理员名单",
  128: "修改文件黑/白名单",
  256: "移除成员",
  512: "移除授权人员"
}), 27105, "{-somebody-} 修改了链接文件 {-file-} 的属性"), 27106, "链接文件不支持下载，下载已忽略所有链接文件"), 30000, "轻文档"), 40000, "为您推荐"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 40001, "根据您的活动内容建议"), 40002, "最近访问"), 40003, "最近关注"), 40004, "暂无推荐内容"), 40005, "点击预览"), 40006, "附言："), 40007, "关闭智能推荐"), 40008, "关闭后，将不会在该区域显示智能推荐，你可以在设置界面再次打开智能推荐"), 40009, "请输入加密文件夹密码"), 40010, "知道了"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 40011, "去设置"), 40012, "导出为word"), 40020, "对企业名称进行了如下设置，{-nameChanges-}"), 40021, "自动解锁"), 40022, "如果关闭此项，该锁只能等待用户编辑结束自动解锁，或者管理员强制手动解锁。打开此项，则超过 2 个小时的锁会自动解锁"), "set_ent_name", "全称修改为: {-name-}"), "set_ent_short_name", "简称修改为: {-name-}"), 40050, "{-count-}个文件"), 40051, "项目所在目录没有可选项目"), 40061, "向右滑动完成验证"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 40052, "目前已下载"), 40053, "目前已删除"), 40054, "目前已上传"), 40055, "目前已打印"), 40070, "禁止用户在线预览视频文件"), 40071, "打开此选项，企业成员无法在线预览视频文件"), 40072, "本企业禁止了在线预览视频文件，请联系管理员"), 40073, "允许使用客户端同步"), 40074, "打开此选项，该成员可以使用客户端同步文件"), 40075, "本企业禁止了客户端同步文件，请联系管理员"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 40076, "输入分组名称"), 40077, "搜索分组名称"), 40078, "当前共有{-num-}个分组"), 40079, "输入昵称,邮箱,手机号,或分组名"), 40080, "输入昵称,邮箱,手机号,部门或分组名"), 40090, "确定从审批人员中移除该分组？"), 40091, "企业对外分享文件受控，暂不允许选择个人分组"), 40092, "获取审批信息失败,你没有查看该审批的权限"), 40093, "查看附言"), 40100, "文件夹图标"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 40101, "更改文件夹图标"), 40102, "选择图标替换"), 40103, "上传自定义图标"), 40104, "应用到子文件夹"), 40105, "应用到相同类型文件夹（仅超管）"), 40106, "示例文件夹"), 40107, "支持PNG、SVG、JPG"), 40108, "图片分辨率高于60*60PX,最大为2MB"), 40109, "自定义icon"), 40110, "效果预览"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 40111, "你确定要删除该自定义文件图标吗？"), 40112, "恢复默认图标"), 40113, "你确定要恢复默认的文件图标吗？"), 40114, "请输入自定义水印"), 40115, "自定义水印设置成功"), 40116, "使用默认水印"), 40117, "自定义水印"), 40118, "获取下载地址"), 40119, "生成{-name-}的下载链接"), 40120, "<strong>安全提示：</strong>此链接为直接访问链接，任何人获取该链接后均可直接下载或读取此文件，无需登录。请谨慎分享。"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 40121, "文件下载链接："), 40122, "链接配置："), 40123, "链接有效期"), 40124, "最大下载次数"), 40125, "7天有效"), 40126, "30天有效"), 40127, "输入有效天数"), 40128, "不限制"), 40129, "10次"), 40130, "50次"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 40131, "100次"), 40132, "输入有效次数"), 40133, "自定义..."), 40134, "链接复制成功"), 40135, "获取链接失败，该文件不支持匿名下载！"), 40136, "你确定要将对应文件夹图标恢复至系统默认图标吗？"), 40137, "已下载"), 40138, "有效下载次数为0，该链接已失效"), 40139, "水印文字"), 40140, "斜角平铺"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 40141, "你可以在目录上右键创建新的文件夹"), 40142, "档案库"), 40143, "档案索引"), 40144, "分类索引"), 40145, "常用入口"), 40146, "未分类"), 40147, "最多访问"), 40148, "最新归档"), 40149, "文档分类审批"), 40150, "申请创建分类"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 40151, "编辑分类"), 40153, "新建子分类"), 40154, "删除分类"), 40155, "你确定要删除该分类吗？"), 40156, "分类名称"), 40157, "分类路径"), 40158, "请输入分类名称"), 40159, "为档案设置分类"), 40160, "审批分类请求"), 40161, "申请分类文件列表"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 40162, "没有档案的分类申请"), 40163, "分类不能为空"), 40164, "{-somebody-}在档案库{-parent-}中创建了分类{-sub-}"), 40165, "搜索分类..."), 40166, "搜索文件夹..."), 40167, "清空搜索"), 40168, "请输入其他关键词或清空搜索框查看全部"), 40169, "未找到包含{-name-}的分类"), 40170, ""), 40171, ""), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 40172, ""), 40173, ""), 50000, "API秘钥"), 50001, "API快速入门"), 50002, "创建API密钥"), 50003, "密钥"), 50004, "APP"), 50005, "APP名称"), 50006, "API访问URL"), 50007, "文件和文件夹权限"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50008, "允许API查看和管理文件及文件夹的权限"), 50009, "查看和编辑你有权限的巴别鸟文件和文件夹信息"), 50010, "查看你有权限的巴别鸟文件和文件夹信息"), 50011, "编辑巴别鸟文件和文件夹的内容"), 50012, "查看巴别鸟文件和文件夹的内容"), 50013, "创建你的API密钥"), 50014, "创建并使用API密钥，可以让第三方AI应用（如：openclaw、Cursor）快速连接你的巴别鸟，获取文件及连接巴别鸟AI知识库，甚至存储文件。你可以点击上方按钮创建新的API密钥"), 50015, "了解详情"), 50016, "创建新APP"), 50017, "为你的APP命名"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50018, "请输入APP名称"), 50019, "选择你需要访问的权限类型"), 50020, "应用程序文件夹-访问专门为您的应用创建的单个文件夹。"), 50021, "完整-访问你权限下巴别鸟中可访问的所有文件及文件夹"), 50022, "创建密钥"), 50023, "应用程序文件夹"), 50024, "完整访问权限"), 50025, "重命名APP"), 50026, "移除APP"), 50027, "确定要移除该APP吗？"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50028, "API密钥详细信息"), 50029, "接入URL"), 50030, "复制密钥"), 50031, "复制成功"), 50032, "复制失败，请手动选择文本复制"), 50033, "授权（OAuth 2）"), 50034, "重定向 URI（OAuth 2）"), 50035, "访问凭证（Access Token）"), 50036, "获取凭证"), 50037, "点击显示"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50038, "可访问范围"), 50039, "用于AI智能体接入"), 50040, "重置 Key"), 50041, "AI接入提示词"), 50042, "可直接复制提示词给AI智能体实现自动接入MCP"), 50043, "高级选项："), 50044, "我需要接入巴别鸟MCP，该MCP的访问URL是 {0}，API Key 为：{1} 配置完成后列出可用工具，并执行一次只读连接测试。"), 50045, ""), 50046, ""), 50047, ""), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50048, ""), 50049, ""), 50050, ""), 50051, ""), 50052, ""), 50053, ""), 50054, ""), 50055, ""), 50056, ""), 50057, ""), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50058, ""), 50059, ""), 40200, "自定义文件元数据"), 40201, "搜索自定义元数据名称、关键字..."), 40202, "新建自定义元数据"), 40203, "当前共有{-num-}个自定义元数据"), 40204, "自定义元数据名称"), 40205, "是否必填项"), 40206, "元数据类型"), 40207, "设置自定义元数据"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 40208, "类型"), 40209, "字符型"), 40210, "浮点型"), 40211, "整数型"), 40212, "日期型"), 40213, "单选框"), 40214, "多选框"), 40215, "请输入待选项"), 40216, "请输入内容，回车键确认"), 40217, "暂无输入项"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 40218, "当前输入项不能为空"), 40219, "输入内容不符合要求"), 40220, "该条目已存在"), 40221, "已达到最大条目数"), 40222, "请至少添加一个条目"), 40223, "你确定要删除自定义元数据<span class=\"main-color\">{-name-}</span>吗"), 40224, "当前共有{-num-}个自定义元数据"), 40225, "待选项"), 40226, "标记为必填的字段必须填写"), 40227, "共找到{-num-}个匹配元数据"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 40228, "未找到匹配项，已显示全部元数据"), 40229, "--请选择内容--"), 40230, "支持中英文、数字及下划线，长度不超过50字符"), 40231, "格式：YYYY-MM-DD"), 40232, "请输入数字（可包含小数）"), 40233, "例如：3.14 或 2.0"), 40234, "请输入数字"), 40235, "例如：-1 或 1"), 40236, "设置项更改后会自动保存到后台"), 40237, "自定义元数据"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 40238, "保存中..."), 40239, "请输入长度不超过{-num-}的字符"), 40240, "请输入长度不超过{-num-}的字符(\";\"除外)"), 40241, "输入内容包含非法字符"), 40242, "仅搜索自定义元数据"), 40243, "申请修改文件自定义元数据"), 40244, "你为档案库创建的分类 <span class=\"main-color\">{-name-}</span> 已被管理员删除"), 40245, "审核结果"), 40246, "审核人"), 40247, "审核时间"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 40248, "管理员将你提交的文件{-files-}最终保存到如下分类中：{-classifications-}"), 40249, "管理员处理了你提交的{-fileName-}{-etc-}文件的分类请求，"), 40250, "等"), 40251, "文件列表"), 40252, "新增的分类"), 40253, "删除的分类"), 40254, "文件分类请求详情"), 40255, "管理员处理了你的文件分类申请，结果如下："), 40256, "你的文件元数据修改申请已被{-reviewerName-}审核，结果：{-status-}"), 40257, "自定义元数据筛选"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 40258, "清除"), 40260, "确定"), 40261, "从"), 40262, "到"), 40263, "请选择"), 40264, "区间"), 40265, "文本"), 40266, "单选"), 40267, "多选"), 40268, "暂无子选项"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 40269, "输入关键字"), 40270, "请输入内容"), 40271, "请输入有效的数字"), 40272, "请输入有效的整数"), 40273, "请选择元数据"), 40274, "已选 {-num-} 项"), 40275, "发送人"), 40276, "文件名"), 40277, "搜索条件未变更"), 40278, "搜索失败，请稍后重试"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 40279, "加载下一页失败，请稍后重试"), 40280, "最小值不能大于最大值"), 40281, "请输入有效的日期"), 40282, "企业目前未定义文件元数据，请到企业后台进行设置"), 40283, "企业目前未定义文件元数据，如果需要自定义元数据，请联系管理员在企业后台设置"), 40284, "去后台设置"), 40285, "{-applicantName-}申请对以下文件设置自定义元数据"), 48285, "原路径"), 48286, "暂未设置自定义元数据"), 48287, "公有云暂不支持此功能，该水印目前仅支持私有化部署，欢迎垂询客服人员。"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 42888, "点击查看完整路径"), 42889, "没有自定义元数据"), 42890, "提示 : 企业还没有设置文件自定义元数据"), 50100, "创建问卷"), 50101, "创建一个新的 Formbricks 问卷"), 50102, "复制并编辑"), 50103, "复制并编辑接口尚未接入"), 50104, "问卷测试数据已创建：{-name-}"), 50105, "问卷"), 50106, "新建问卷"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50107, "待发布"), 50108, "关闭问卷"), 50109, "查看表单"), 50110, "草稿"), 50111, "进行中"), 50112, "已暂停"), 50113, "已完成"), 50114, "选择问卷的保存位置"), 50115, "问卷名称"), 50116, "请输入问卷名称"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50117, "调查问卷"), 50118, "我的文件"), 50120, "仅查看备份策略"), 50121, "强制备份"), 50122, "企业备份策略与终端管理"), 50123, "刷新状态"), 50125, "备份策略"), 50126, "人员与客户端"), 50127, "备份文件"), 50128, "操作日志"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50129, "尚未获取到企业备份根目录，请稍后重试。"), 50130, "打开备份根目录？"), 50131, "即将在新的标签页打开「企业扫描备份根目录」。"), 50132, "执行中的策略"), 50134, "{-num-} 项草稿"), 50135, "受管设备"), 50136, "/ {-num-} 台"), 50137, "异常设备"), 50138, "台"), 50139, "{-num-} 个文件待处理"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50140, "累计备份文件"), 50142, "{-size-} 已安全留存"), 50143, "{-num-} 台设备备份异常，{-num2-} 个文件尚未成功上传。已完成的云端备份不受影响。"), 50144, "查看异常"), 50145, "关闭提醒"), 50146, "统计加载中…"), 50150, "策略详情"), 50151, "策略不存在"), 50152, "策略编号"), 50153, "执行范围"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50154, "（含全部子部门）"), 50155, "账号与设备"), 50156, "{-users-} 个账号 · {-assigned-} 台已分配设备 · {-waiting-} 个账号未接入"), 50157, "后续接入"), 50158, "仅针对所选设备，不自动覆盖该账号其他电脑"), 50159, "所选账号后续接入的 Windows 设备自动匹配此策略"), 50160, "备份目录"), 50161, "扫描磁盘"), 50162, "所有本机固定磁盘"), 50163, "{-drives-} 盘"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50165, "{-list-}、无扩展名文件"), 50166, "执行方式"), 50167, "实时备份 · 开机补扫 · 每日 {-time-} 校验"), 50168, "上传限制"), 50169, "{-bw-} MB/s · 单文件 {-size-} MB"), 50170, "最近更新"), 50175, "撤销待确认"), 50176, "v{-ver-} 已生效"), 50177, "等待 v{-ver-} 回执"), 50178, "待客户端接入"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50179, "尚无客户端"), 50180, "目标设备"), 50181, "版本已确认"), 50183, "备份配置"), 50184, "员工不可暂停或退出执行器"), 50185, "本地删除，云端保留"), 50186, "员工无权删除云端备份"), 50187, "撤销回执"), 50188, "下发回执"), 50189, "尚未向设备下发此策略。"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50190, "未接入客户端的账号（{-num-}）"), 50191, "编辑策略"), 50250, "全部状态"), 50251, "执行中"), 50253, "待客户端生效"), 50256, "搜索策略名称、文件类型或执行范围"), 50258, "共 {-num-} 项策略"), 50259, "导出策略清单？"), 50260, "将按当前筛选条件导出 {-num-} 条策略记录（CSV 文件）。"), 50261, "确认导出"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50266, "账号数"), 50267, "设备数"), 50268, "扩展名白名单"), 50271, "强制备份-策略"), 50272, "导出清单"), 50273, "策略列表"), 50274, "导出当前筛选的 {-num-} 条记录"), 50275, "已导出 {-num-} 条记录"), 50276, "复制为新策略"), 50277, "停用策略"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50278, "删除草稿"), 50279, "删除策略"), 50280, "停用此备份策略？"), 50281, "停用后该策略不再执行新的备份。已上传文件与历史版本全部保留，不删除企业云端数据。"), 50282, "已上传文件与历史版本全部保留，不删除企业云端数据。"), 50283, "继续备份"), 50284, "确认停用"), 50285, "策略已停用；云端备份继续保留。"), 50286, "停用失败，请稍后重试。"), 50287, "停用指令已记录，等待设备确认；云端备份继续保留。"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50288, "删除未发布的草稿？"), 50289, "删除已停用的策略？"), 50290, "{-name-} 尚未下发，不影响客户端和云端备份。"), 50291, "{-name-} 已停用，删除后策略配置不可恢复；已备份文件与历史版本全部保留。"), 50292, "草稿已删除"), 50293, "策略已删除"), 50294, "删除失败，请稍后重试。"), 50400, "没有找到策略"), 50401, "调整筛选条件，或新建一项备份策略。"), 50404, "备份文件类型"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50405, "策略状态"), 50406, "设备回执"), 50409, "企业文件/备份文件夹"), 50411, "企业文件 / {-target-}"), 50413, "{-users-} 个账号 · {-devices-} 台设备"), 50414, "含子部门"), 50415, "{-num-} 个账号待客户端接入"), 50416, "无扩展名"), 50417, "仅上传所选类型"), 50418, "{-num-} 台已生效"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50419, "暂无设备，未下发"), 50420, "尚未下发"), 50421, "{-num-} 台待撤销确认"), 50423, "发布"), 50425, "更多操作"), 50551, "备份内容"), 50553, "确认下发"), 50554, "编辑备份策略"), 50555, "新建备份策略"), 50556, "管理员配置 · 客户端受管执行"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50557, "放弃修改？"), 50558, "当前修改尚未保存，退出后将丢失。"), 50559, "继续编辑"), 50560, "放弃修改并退出"), 50562, "例如：研发文档持续备份"), 50563, "云端备份目录"), 50564, "选择目录"), 50565, "已发布策略不迁移历史目录；调整目标目录请新建策略。"), 50566, "仅可选择企业管理的目录，员工无删除、移动及对外分享权限。"), 50567, "目录结构：账号 + 设备名"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50568, "账号（账号 ID）"), 50569, "设备名（设备 ID）"), 50570, "C盘 / Users / 原始路径 / 文件"), 50571, "单设备、多设备使用相同目录规则；同账号的不同电脑分开留存，同名设备以设备 ID 区分。已有历史备份不迁移。"), 50572, "备注（选填）"), 50573, "策略用途或管理说明"), 50574, "仅上传备份"), 50576, "员工不可停用"), 50577, "扫描范围"), 50579, "指定盘符"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50580, "{-disk-}盘"), 50581, "不包含移动硬盘、网络映射盘和巴别鸟虚拟盘；自动跳过系统、回收站及客户端缓存目录。"), 50582, "需要备份的文件类型"), 50583, "（扩展名白名单）"), 50584, "其他扩展名，例如 cad、tar.gz"), 50586, "只备份已选扩展名，未选类型不上传；不区分大小写，支持复合扩展名。"), 50587, "同时备份无扩展名文件"), 50588, "文件匹配测试"), 50589, "年度合同.docx"), 50591, "运行设置"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50592, "上传限速（MB/s）"), 50593, "单文件上限（MB）"), 50594, "每日低峰校验"), 50595, "实时监听与开机补扫始终开启；文件占用或离线时保留队列，恢复后继续上传。"), 50596, "点击移除"), 50597, "已选 {-num-} 个："), 50598, "正在加载账号…"), 50599, "没有匹配的账号"), 50600, "正在加载部门…"), 50601, "没有匹配结果"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50602, "正在加载分组…"), 50604, "展开子部门"), 50605, "随父部门加入"), 50606, "{-num-} 人"), 50609, "已有策略"), 50610, "未分配"), 50611, "个部门"), 50612, "个账号"), 50613, "个分组"), 50614, "台设备"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50615, "选择备份账号或设备"), 50616, "按部门"), 50617, "按账号"), 50618, "按分组"), 50619, "按设备"), 50621, "搜索姓名或账号"), 50622, "搜索分组"), 50623, "搜索账号或设备名"), 50624, "包含所选部门的全部子部门"), 50625, "仅对所选设备生效，不自动纳入同账号其他设备。"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50626, "按账号范围覆盖名下全部 Windows 设备，包括后续接入的新设备。"), 50627, "尚未填写"), 50628, "账号数量"), 50629, "设备数量"), 50630, "后续设备"), 50631, "仅所选设备"), 50632, "账号下新接入的 Windows 设备自动匹配"), 50633, "范围数量"), 50634, "云端目录"), 50635, "账号 / 设备名（设备 ID） / 盘符 / 原始路径"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50637, "{-disks-} 盘"), 50639, "无扩展名文件"), 50640, "实时监听 · 开机补扫 · {-time-} 每日校验"), 50641, "资源限制"), 50642, "{-bandwidth-} MB/s · 单文件 {-size-} MB"), 50643, "发布版本"), 50644, "固定保护规则"), 50645, "仅上传命中文件，不生成空目录"), 50646, "本地删除或改名不删除云端原件"), 50647, "员工不能暂停、修改或解除备份"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50648, "前台退出账号不停止备份任务"), 50649, "保留版本，数据归企业所有"), 50650, "同账号多设备的文件独立留存"), 50651, "发布后策略进入下发队列，执行范围内的 Windows 客户端接入后生效。"), 50652, "保存草稿"), 50653, "确认发布并下发"), 50654, "草稿已保存，尚未向客户端下发。"), 50655, "策略 v{-version-} 已加入下发队列，等待客户端确认。"), 50656, "账号策略已保存，等待 Windows 客户端接入，尚未生效。"), 50657, "未获取到企业备份根目录，请刷新页面后重试。"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50658, "策略已创建并发布，等待客户端确认。"), 50659, "策略已更新并发布，等待客户端确认。"), 50660, "保存失败，请稍后重试。"), 50662, "请输入需要备份的扩展名"), 50663, "请输入有效扩展名，例如 docx 或 tar.gz，不使用 * 通配符。"), 50664, "请输入文件名称"), 50665, "命中白名单，将备份此类型文件。"), 50666, "未命中白名单，不上传，也不因此创建云端目录。"), 50667, "选择企业备份目录"), 50668, "请选择具体的企业文件夹"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50850, "全部接入状态"), 50851, "有客户端在线"), 50852, "客户端全部离线"), 50853, "未接入客户端"), 50854, "一个账号多台设备"), 50855, "全部备份状态"), 50856, "备份正常"), 50857, "正在备份"), 50858, "备份异常"), 50859, "等待生效"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50861, "未分配策略"), 50865, "搜索姓名、账号或设备名称"), 50866, "导出人员"), 50867, "未接入表示暂无 Windows 客户端记录，不等同于账号停用或设备离线。"), 50868, "企业账号"), 50870, "已接入 Windows 客户端"), 50871, "人 / {-num-} 台设备"), 50872, "全部部门"), 50873, "导出设备"), 50874, "账号标识"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50878, "客户端接入"), 50879, "关联设备数"), 50880, "在线数"), 50881, "设备列表"), 50883, "设备编号"), 50885, "员工"), 50886, "客户端连接"), 50887, "备份状态"), 50888, "已上传文件"), 50889, "已上传字节"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50890, "最近成功备份"), 50891, "强制备份-{-type-}.csv"), 50893, "设备"), 50895, "人员列表"), 50899, "关联设备"), 50900, "{-num-} 台 Windows 设备 · {-num2-} 台在线"), 50903, "账号备份目录"), 50904, "客户端 {-ver-}"), 50905, "最近心跳 {-time-}"), 50906, "{-num-} 个文件 · {-size-}"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50907, "设备详情"), 50908, "尚未接入 Windows 客户端"), 50909, "当前账号没有 Windows 客户端注册记录。仅使用网页端不会生成设备备份任务。"), 50910, "账号策略已配置，等待客户端接入后下发。"), 50911, "账号与客户端"), 50912, "此账号的 Windows 客户端"), 50913, "此账号有多台设备。各设备独立执行、回执和留存，不以最后登录设备替换其他设备。"), 50914, "客户端注册并关联此企业账号后才计入设备；未接入不等于离线，也不能据此判断是否安装过软件。"), 50915, "目录与设备归属"), 50916, "设备名（设备 ID） / C盘 / 原始路径"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50917, "设备名称用于识别，账号 ID 与设备 ID 用于稳定关联；同名电脑仍分别保留备份。已有历史目录不自动移动。"), 50918, "{-num-} 台（当前为 {-id-}）"), 50919, "设备标识"), 50920, "设备备份目录"), 50921, "操作系统"), 50922, "执行策略"), 50923, "（目标 v{-ver-} / 已确认 v{-ver2-}）"), 50924, "尚未分配策略"), 50925, "最近心跳"), 50926, "最近备份"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50927, "终端设备详情"), 50928, "已备份文件"), 50930, "待上传文件"), 50931, "{-cmd-}。执行结果以客户端下一次回执为准。"), 50932, "待处理异常"), 50933, "{-num-} 个文件"), 50934, "文档被其他程序独占。关闭占用程序后客户端将自动重试，也可发送重试请求。"), 50935, "执行器无法读取受限目录。请先由终端管理员检查访问权限，再重试备份。"), 50936, "任务保护"), 50937, "员工不能修改或解除策略"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50938, "前台登出不停止受管任务"), 50939, "仅上传，不回传本地删除"), 50940, "云端目录归企业所有"), 50941, "此方案为客户端受管任务。针对本机管理员强行结束进程或卸载的防护，仍需配合 Windows 服务及企业终端管控。"), 50943, "补扫文件"), 50944, "重试失败文件"), 50945, "所选设备没有可重试的失败文件。"), 50946, "仅可向已分配策略的受管设备发起补扫。"), 50947, "补扫备份文件"), 50948, "向 {-num-} 台设备发送{-type-}请求。"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 50950, "补扫"), 50951, "只重试失败文件，不重复上传已完成文件。"), 50952, "按当前策略的扩展名白名单重新扫描，云端文件不会被删除。"), 50953, "{-num-} 台设备离线，请求将在重新连接后处理。"), 50954, "确认发送"), 50955, "请求已记录，等待客户端执行回执。"), 51050, "没有符合条件的账号或设备"), 51051, "姓名 / 账号"), 51053, "Windows 客户端"), 51055, "最近客户端心跳"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 51056, "备份覆盖"), 51058, "账号 / 设备名"), 51061, "已备份"), 51063, "{-online-} 台在线 / {-total-} 台已接入"), 51064, "无 Windows 设备注册记录"), 51065, "尚无关联设备"), 51066, "{-managed-} / {-total-} 台受管"), 51068, "尚未配置策略"), 51069, "尚无心跳"), 51071, "配置策略"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 51072, "同账号多设备"), 51075, "心跳"), 51076, "{-count-} 个文件"), 51077, "{-count-} 个 · {-size-}"), 51078, "最近备份 {-time-}"), 51080, "已确认 v{-applied-} / 目标 v{-target-}"), 51200, "尚无记录"), 51301, "客户端在线"), 51302, "客户端离线"), 51303, "企业文件 / 强制备份"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 51304, "盘"), 51305, "（{-text-}）"), 51306, "办公文档"), 51307, "设计源文件"), 51308, "研发文件"), 51321, "请输入策略名称。"), 51322, "策略名称已存在，请使用不同名称。"), 51323, "请选择企业拥有的备份目录。"), 51324, "请至少选择一个需要备份的扩展名。"), 51325, "扩展名格式不正确，请填写 docx、pdf 或 tar.gz，不使用通配符。"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 51326, "请至少选择一个固定磁盘。"), 51327, "上传限速请输入 1 至 1024 MB/s。"), 51328, "单文件上限请输入 1 至 2048 MB。"), 51329, "请选择每日校验时间。"), 51330, "请选择至少一个账号、部门或分组。"), 51331, "成功"), 51332, "撤销策略，等待设备回执"), 51333, "策略 v{-ver-} 待确认"), 51334, "发布策略"), 51335, "发布 v{-ver-}，覆盖 {-count-} 个账号；{-dev-} 台设备待回执，{-wait-} 个账号待客户端接入"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 51336, "已生效策略请发布新版本，不能直接覆盖为草稿。"), 51338, "尚未向客户端下发"), 51341, "停止新增备份；撤销待客户端确认，云端文件与历史版本全部保留"), 51342, "账号不存在"), 51343, "请输入设备名称"), 51344, "此账号存在策略冲突，需要管理员处理"), 51346, "已匹配策略 {-name-}，等待客户端确认"), 51347, "已关联账号，尚未分配策略"), 51348, "策略 {-id-}"), 51351, "删除未下发的策略或已停用策略"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 51352, "{-name-} - 副本"), 51353, "重试失败文件待执行"), 51354, "补扫文件待执行"), 51355, "重试请求"), 51356, "补扫请求"), 51357, "已记录请求，等待客户端执行；未更改现有备份结果"), 51358, "待执行"), 51359, "企业文件 / 备份恢复 / "), 51360, "恢复申请"), 51361, "申请恢复 {-dev-} 的 v{-ver-} 至 {-path-}，原备份保持不变"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 51362, "待选择执行范围"), 51363, "全部 Windows 设备"), 51364, "该功能仅支持私有化部署，公有云仅支持保存草稿"), 51365, "企业未购买此模块，当前仅支持保存草稿"), 51366, "普通成员按顺序采用第一条有效设置：<strong>成员专属 → 角色专属 → 部门内所有人 → 部门角色基础权限</strong>"), 51367, "权限不叠加；到期后继续查下一层。有“部门文件管理”权限的成员不受以下设置限制。"), 51368, "无有效成员或角色专属设置的普通成员使用此设置"), 51369, "文件权限的采用顺序"), 51370, "<p>先判断是否拥有“部门文件管理”权限；有此权限的成员不受以下设置限制。</p><ol><li><b>成员专属：</b>有有效设置，就采用此设置。</li><li><b>按角色设置：</b>成员没有有效的单独设置时，检查是否为其所属角色这组成员设置了文件权限。有则采用这里设置的文件权限，不是该角色本身的基础权限。</li><li><b>部门内所有人：</b>前两层没有有效设置时，采用这里的设置。</li><li><b>部门角色基础权限：</b>前三层均无有效设置时，使用该角色原有权限。</li></ol><p>采用第一条有效设置，不叠加。优先级高不代表操作权限更多。</p>"), 51371, "“部门内所有人”适用于谁"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 51372, "<p>这是普通成员的通用设置。已有有效成员专属或角色专属设置的人，优先使用其专属设置。</p><p>有“部门文件管理”权限的人始终不受限制。</p>"), 51373, "“不单独设置”不等于没有权限"), 51374, "<p>选择“不单独设置”，系统会继续检查下一层，而不是禁止访问。</p><p>选择“不可见”是一条明确且有效的设置，系统采用后就不再查更低优先级。</p><p>权限方案来自企业自定义文件权限列表，具体操作以企业实际配置为准。</p>"), 51375, "我知道了"), 51380, "允许查看其他成员创建或上传的文件中的批注，包括您自己和他人添加的批注。"), 51381, "允许在其他成员创建或上传的文件中添加批注，不会修改文件正文。"), 51382, "允许删除其他成员添加的批注。“别人”指批注作者，与文件由谁创建或上传无关。"), 51383, "允许看到当前部门下的子部门，并查看其中的文件。未开启时，用户看不到子部门。"), 51384, "允许打印自己创建或上传的文件，或下载带水印的 PDF 版本。下载原文件需有“下载自己的文件”权限。"), 51385, "允许打印其他成员创建或上传的文件，或下载带水印的 PDF 版本。下载原文件需有“下载别人的文件”权限。"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 51386, "允许查看自己创建或上传的文件的操作记录，了解操作人、操作时间和操作内容。"), 51387, "允许查看其他成员创建或上传的文件的操作记录，了解操作人、操作时间和操作内容。"), 51388, "允许在列表中看到无权查看的文件，但不能查看文件内容。"), 51389, "允许在线修改自己创建或上传的文件内容。"), 51390, "允许在线修改其他成员创建或上传的文件内容。"), 51391, "用于管理当前部门的文件，相关操作见下列管理项。"), 51392, "包含创建、删除和修改当前部门下子部门的权限。"), 51393, "允许设置哪些成员可以访问文件，以及可以执行哪些操作。"), 51394, "允许设置或调整文件的保密等级。"), 51395, "允许审核文件分享申请，决定是否同意分享。"), (0, _defineProperty2["default"])(_localString_cn_part, 51396, "允许将文件负责人变更为其他成员。变更负责人不改变文件创建者或上传者的认定。"));

//私有云专属字段 80000 */
var _default = exports["default"] = localString_cn_part3;

},{"1180":1180,"1184":1184,"1454":1454}],1153:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require(1180));
var _localString_cn_part;
var localString_cn_part2 = (_localString_cn_part = {
  /////////////////////////////**************************8.7.1***************************//

  5000: "签章设置",
  5001: "报表类型",
  5002: "文件会签",
  5003: "图纸审核",
  5004: "添加附件",
  5005: "您可以在这里自定义本企业文件的分享权限、项目可选权限及文件访问控制权限。此处定义的权限会出现在上述功能的权限选择列表中",
  5006: "搜索文件权限的名称",
  //----------------6.6-------------

  5007: "账户删除后，其账户下的文件也将移除，执行此操作请慎重",
  5008: "受邀访问记录",
  5009: "受邀时间",
  5010: "个人文件",
  5011: "昵称",
  5012: "黑色背景",
  5013: "白色背景",
  5014: "默认背景",
  5015: "旋转90",
  5016: "添加签名",
  5017: "改变背景颜色仅对透明背景的作品有效!",
  5018: "不再提示",
  5019: "确认恢复账户-<strong>{-userName-}</strong>?",
  5020: "确认停用账户-<strong>{-userName-}</strong>?",
  5021: "设置签名后，可以在预览您审批通过的文档时使用签名",
  5022: "请在下面的区域内输入您的签名，然后点击保存",
  5023: "确定删除这个签名？",
  5024: "该签名已被使用，不能删除",
  5025: "当前使用的签名",
  5026: "设置为当前使用签名",
  5027: "更新失败！",
  5028: "分享设置",
  5029: "提醒关注文件",
  5030: "文件属性",
  5031: "添加",
  5032: "文件已彻底删除",
  5033: "文件删除失败,请稍后重试",
  5034: "文件已恢复到原有位置",
  5035: "文件恢复失败,请稍后重试",
  5036: "新版本必须与旧版本使用一致的文件类型",
  5037: "是否下载文件",
  5038: "放弃",
  5039: "在 {-type-} 中打开",
  5040: "选择“在浏览器打开”",
  5041: "请使用右上角微信“更多”功能",
  // 5042: "该分享仅允许被邀请的用户访问，请使用您接收邀请的邮箱登录！",
  5042: "该文件不支持匿名访问，请登录后继续访问！",
  5043: "分享者已经关闭当前分享，您不能再对文档进行浏览了!",
  5044: "确定要退出分享吗",
  5045: "当前选中人数超过30人，是否继续",
  5046: "您无权查看企业成员！",
  5047: "请输入6-20位包含大小写字母及数字的组合",
  5048: "您已经被超级管理员冻结账户",
  5049: "您已经被超级管理员移出该企业",
  5050: "抱歉，{-str-}，点击确认退出",
  5051: "当前网络不可用，请检查您的网络情况是否正常",
  5052: "匿名用户无权访问！",
  5053: "移动文件失败",
  5054: "目标文件夹不支持创建文件夹",
  5055: "创建子文件夹",
  5056: "文件目录加载失败",
  5057: "分组删除失败",
  5058: "网络似乎不通畅，请刷新一下网页后重试",
  5059: "免费版暂不支持预览此类文件，如果需要请升级版本",
  5060: "输入密码以打开此 PDF 文件。",
  5061: "作者",
  5062: "关键词",
  5063: "修改日期",
  5064: "制作者",
  5065: "页数",
  5066: "正在准备打印文档...",
  5067: "打开文件失败",
  5068: "文件不允许访问",
  5069: "暂不支持预览该文件",
  5070: "退出编辑",
  5071: "删除关联",
  5072: "确定要删除这个文件关联吗？",
  5073: "锁定失败，不能编辑，错误码:",
  5074: "批准加入",
  5075: "拒绝加入",
  5076: "确定删除该成员吗",
  5077: "管理者",
  5078: "(我)",
  5079: "团队描述",
  5080: "未加入",
  5081: "等待批准",
  5082: "服务器未知错误，请稍后重试",
  5083: "团队名称（小于40字）",
  5084: "团队名称不能为空",
  5085: "团队描述（小于100字）",
  5086: "更新失败！",
  5087: "退出团队",
  5088: "删除失败，稍后重试",
  5089: "更新失败！",
  5090: "尚未加入",
  5091: "图片有错误，不能正常打开！",
  5092: "您无权查看该批注所在版本",
  5093: "注意：您当前查看的版本不是最新版本！",
  5094: "批注点已删除",
  5095: "保存手绘失败，请稍后重试",
  5096: "此操作将导致退出当前的演播，是否退出演播并继续？",
  5097: "关闭演播失败，请稍后重试",
  5098: "退出演播失败，请稍后重试",
  5099: "您的浏览器会话已失效，需要重新登录",
  5100: "用户密码被重置，点击确认退出",
  5101: "管理员限制了你登录的mac地址，点击确认退出",
  5102: "你已被退出当前登录，点击确认退出",
  5103: "你的账户已被系统冻结，恢复账号请联系客服人员，点击确认退出",
  5104: "你的登录已过期，请重新登录",
  5105: "😞😞😞 连接出了点故障，刷新一下页面就好了。",
  5106: "刷新",
  5107: "加入失败，团队人员已达到上限！",
  5108: "文件内容已经修改，请选择：",
  5109: "不保存",
  5110: "请输入文件内容",
  5111: "长度",
  5112: "显示全部",
  5113: "您的浏览器版本过低，建议您升级到IE11及以上版本",
  5114: "您需要登录",
  5115: "确认要删除这个团队吗？<br>这将自动删除其所有文件，且不能恢复！",
  5116: "确认要离开这个团队吗？",
  5117: "参数错误",
  5118: "等待超时",
  5119: "无法预览该文件，请下载查看",
  5120: "文件处理失败，暂不支持预览",
  5121: "此为加密文档，如需浏览编辑，敬请下载操作",
  5122: "文件已损坏或者文件信息不完整，请下载查看",
  5123: "文件太大，暂不支持生成可预览文件",
  5124: "演示文稿是空的",
  5125: "发生未知错误，请联系管理员",
  5126: "服务器正在处理",
  5127: "限制此成员个人空间用量",
  5128: "则此成员账户可占用空间量在其所属部门可用空间量范围内不受限制",
  5129: "此成员所属部门可供设置空间总量",
  5130: "此成员已占用空间",
  5131: "个人账户空间限制",
  5132: "部门空间限制",
  5133: "没有需要您投件的文件收集箱",
  5134: "您没有创建过文件收集箱",
  5135: "新密码：",
  5136: "确认新密码：",
  5137: "确认新密码：",
  5138: "的密码",
  5139: "密码修改失败",
  5140: "了解成员身份",
  5141: "员工空间限制",
  5142: "设定值等于已占用空间, 将无法上传新内容",
  5143: "使用橡皮不能删除其他人绘制的线条！",
  5144: "此处添加的栏目，会显示在每个企业用户的工作台中",
  5145: "添加审批意见",
  5146: "矩形框审批意见",
  5147: "圆形审批意见",
  5148: "箭头审批意见",
  5149: "文字审批意见",
  5150: "下载文件失败",
  5151: "已通知",
  5152: "待接收",
  5153: "我做了图形标记，点击下图查看",
  5154: "消息已被撤回",
  5155: "文件上传失败",
  5156: "文件评论",
  5157: "下载文档失败",
  5158: "点击此处输入批注内容",
  5159: "文字搜索",
  5160: "使用鼠标选中文档中的文本建立批注",
  5161: "适合",
  5162: "版本列表",
  5163: "请使用右上角微信功能：使用浏览器打开",
  5164: "个批注",
  5165: "最新版本",
  5166: "当前版本",
  5167: "第{-v-}版本",
  5168: "发起者不能参与评审",
  5169: "此人已是评审人",
  5170: "审批进度",
  5171: "追加审批人",
  5172: "点此处直接进入下一审批阶段",
  5173: "点此处结束审批",
  5174: "文件权限管理者",
  5175: "不是合格的 3D 文件格式",
  5176: "操作失败，请检查网络连接",
  5177: "",
  5178: "",
  5179: "",
  5180: "",
  5181: "",
  5182: "正在打包文件夹，请稍后",
  5183: "超过{-multiFilesCount-}个文件或大小超过{-multiFilesSize-}的文件夹请使用客户端下载",
  5184: "",
  5200: "下载次数请输入正整数",
  /*********************HQSM*************************/

  5201: "选择项目类型",
  5202: "创建普通项目",
  5203: "创建文控管理项目",
  5204: "创建一个独立的项目共享空间，由指定的项目管理者分配项目成员权限，可邀请其他部门甚至外部用户加入一起工作",
  5205: "专为项目文控管理设计，文控人员可向甲乙方发送文件，每次发件都有严格的记录并自动生成发送单，并可管理查询",
  5206: "文控经理",
  5207: "点击选择文控经理",
  5208: "文控人员",
  5209: "点击选择文控人员",
  5210: "其他成员",
  5211: "版本号规则",
  5212: "输入前缀",
  5213: "输入需要显示在传送单（TRANSMITTAL）上的信息，如联系方式、地址、电话等。",
  5214: "点击选择其他成员",
  5215: "ABC字母顺序",
  5216: "123数字顺序",
  5217: "收件方信息",
  5218: "输入收件方名字",
  5219: "输入邮箱，多个邮箱用英文分号隔开",
  5220: "点击输入",
  5221: "运单号规则",
  5222: "选择编码规则",
  5223: "1-2-3数字顺序",
  5224: "a-b-c字母顺序",
  5225: "日期加数字 例：20200123001",
  5226: "输入文字",
  5227: "空",
  5228: "承包方",
  5229: "发包方",
  5230: "新增收件方",
  5231: "新增项目",
  5232: "发送单列表",
  5233: "管理项目",
  5234: "同步该文件夹",
  5235: "取消同步",
  5236: "搜索运单号或发件人，按回车键确认",
  5237: "{-name-}文控项目文件传送列表（TRANSMITTAL List）",
  5238: "该项目暂未产生传送单",
  5239: "没有符合条件的传送单",
  5240: "传送单号（Transmittal NO.）",
  5241: "接收状态",
  5242: "未接收",
  5243: "已接收",
  5244: "再次发送",
  5245: "基础信息",
  5246: "项目基本信息",
  5247: "本项目共有收件人{-num-}个",
  5248: "管理项目收件人",
  5249: "项目成员",
  5250: "管理项目负责人",
  5251: "添加文控经理",
  5252: "添加文控人员",
  5253: "添加其他人员",
  5254: "文控项目管理",
  5255: "抄送",
  5256: "提交文件类型",
  5257: "原件",
  5258: "扫描复印件",
  5259: "TRANSPARENCY",
  5260: "LINEN",
  5261: "文件编号",
  5262: "描述",
  5263: "处理方式",
  5264: "确认人",
  5265: "编制和提交人",
  5266: "默认为发件人",
  5267: "输入邮件中的附言",
  5268: "发送文件",
  5269: "发送文件",
  5270: "供归档",
  5271: "供查阅",
  5272: "供修订",
  5273: "供审批",
  5274: "点击输入描述",
  5275: "发件日期",
  5276: "附件列表",
  5277: "文件传送单",
  5278: "导出为PDF",
  5279: "传送单号",
  5280: "运单号",
  5281: "我们很高兴提交以下文件：",
  5282: "编制人",
  5283: "签字",
  5284: "职务",
  5285: "transmittla info",
  5286: "文件发送记录",
  5287: "查看文件发送记录",
  5288: "审核时效",
  5289: "版本号： {-ver-}",
  5290: "日期顺序",
  5291: "收件方类型",
  5292: "请输入正确的transmittal Number",
  5293: "请输入邮箱，以分号分隔",
  5294: "发送成功",
  5295: "文件发送成功，是否去查看文件传送单（TRANSMITTAL）详情",
  5296: "Transmittal NO.",
  5297: "发送人",
  5298: "发送日期",
  5299: "发送版本",
  5300: "版本号",
  5301: "查看文件传送单",
  5302: "输入文件传送单号",
  5303: "文件数量",
  5304: "已查看",
  5305: "未查看",
  5306: "文件数量{-num-} 占用空间{-size-}",
  5307: "本项目未设置接收方，暂不支持发送文件，如需发送文件，请联系文控经理",
  5308: "001、002数字顺延",
  5309: "0001、0002数字顺延",
  5310: "请选择人员",
  5311: "格式错误，请输入正确的邮箱，以引号分隔",
  5312: "版本",
  //hqsm 版本
  5313: "编号",
  5314: "在线编辑",
  5315: "管理人员",
  5316: "恢复所有文件",
  5317: "恢复当前文件夹",
  5318: "永久删除当前文件夹",
  5400: "点击加入后如提示登录请输入账户密码登录，如果没有注册巴别鸟，请点击",
  5401: "输入标签名，按回车键确认或点击右侧标签按钮选择标签",
  5402: "请输入标签名",
  5403: "创建文件夹",
  5404: "创建文件",
  5405: "你不能邀请自己加入分享",
  5406: "是否覆盖子文件安全级别？",
  5407: "覆盖",
  5408: "不覆盖",
  5409: "“覆盖”指的是子文件密级高于此密级的，子文件使用此密级",
  5410: "暂未设置审批流程",
  5411: "文控项目",
  /************8.5*******************/
  5412: "为接下来所有文件应用此设置",
  5413: "批量设定是否允许所选用户拥有个人私有文件",
  5414: "下载我们的案例",
  5415: "二维码已拷贝到剪贴板",
  5416: "复制二维码到剪切板",
  5417: "扫码打开链接",
  5418: "请在谷歌浏览器中使用https协议使用此功能",
  5419: "选择待审批文件",
  /*****************8.5.1***************/
  5450: "请求发送文件给以下人员",
  5451: "待发送的文件",
  5452: "查看企业成员与分组",
  5453: "文件已经不存在了",
  5454: "选择该文件夹的同步模式",
  5455: "双向同步模式",
  5456: "本地和云端文件一致，本地的更新会同步到云端，云端的更新会同步到本地",
  5457: "下行同步模式",
  5458: "本地的更新不会同步到云端，但云端的更新会同步到本地",
  5459: "全局默认排序",
  5460: "设置后，所有文件夹将使用选择的排序方式作为默认排序，但在不同文件夹列表更改排序后，系统会记住最后一次所使用的的排序方式",
  5461: "已生成列表数据，请耐心等待",
  5462: "审核未通过",
  5463: "等待审核...",
  5464: "保密部门人员{-user-}要加入{-dep-}部门分享{-file-}，是否同意？",
  5465: "保密部门人员{-user-}要加入分享{-file-}，是否同意？",
  5466: "保密部门{-user-}要加入{-dep-}部门分享{-file-}，是否同意？",
  5467: "保密部门{-user-}要加入分享{-file-}，是否同意？",
  5468: "点此注册企业公有云版",
  5469: "保密部门人员{-user-}正在加入{-dep-}部门的项目{-file-}，是否同意？",
  5470: "保密部门人员{-user-}正在加入项目{-file-}，是否同意？",
  5471: "保密部门{-user-}正在加入{-dep-}部门的项目{-file-}，是否同意？",
  5472: "保密部门{-user-}正在加入项目{-file-}，是否同意？",
  5473: "正在获取预览数据",
  5474: "你没有访问该文件的权限",
  5475: "仅查看保密审批记录",
  5476: "您可以撤销这个审批，将其设置为",
  /*****************8.5.2***************/

  5500: "IP 策略列表",
  5501: "暂无企业自定义的IP策略",
  5502: "适用IP段",
  5503: "策略类型",
  5504: "添加下载策略",
  5505: "为策略取个名字，方便使用",
  5506: "策略类型",
  5507: "禁止下载",
  5508: "允许下载",
  5509: "编辑下载策略",
  5510: "若选择允许下载，策略生效后策略IP段意外的设备将不能下载文件",
  5511: "部门人员策略",
  5512: "策略",
  5513: "请选择策略",
  5514: "新建策略",
  5515: "新建策略",
  5516: "增加IP",
  5517: "授权",
  5518: "开始IP",
  5519: "终止IP",
  5520: "优先级",
  5521: "适用范围",
  5522: "允许授权",
  5523: "拒绝授权",
  5524: "修改人",
  5525: "全体成员",
  5526: "管理人员",
  5527: "普通成员",
  5528: "暂无部门人员策略",
  5529: "例：192.168.2.5",
  5530: "例：192.168.2.98",
  5531: "输入1~100，1为最高优先级",
  5532: "请输入1~100的正整数",
  5533: "请输入合法IP",
  5534: "该部门已存在IP策略",
  5535: "如果需要移除该策略，请先删除使用该策略部门",
  5536: "文件历史版本保存有效期",
  5537: "设定0表示永久保存历史记录",
  5538: "文件历史版本保存版本数",
  5539: "注：历史记录保存版本数可以自由修改为1-999个，0为永久保存",
  5540: "请输入版本数",
  5541: "请添加IP策略",
  5542: "该用户不允许在当前IP地址下载文件",
  5543: "个人版不支持此类型文件在线预览，如需预览请升级为专业版或企业版",
  5544: "举报",
  5545: "显示",
  5546: "隐藏",
  5547: "你是否确定此分享含有非法信息，要将此反映给网站管理者？",
  5548: "举报成功",
  5549: "获取用户信息失败",
  5550: "保存到网盘",
  5551: "若已安装客户端",
  5552: "若未安装客户端",
  5553: "企业协同网盘",
  5554: "立即下载",
  5555: "下载巴别鸟APP",
  5556: "方向",
  5557: "下载及上传",
  5558: "该用户不允许在当前IP地址上传文件",
  5559: "已删除",
  5560: "外部协作人员数10",
  5561: "无限外部协作人员数",
  5562: "{-day-}天后过期",
  5563: "{-hour-}小时后过期",
  5564: "无限团队用户数",
  5565: "小团队文件共享协作，不限成员",
  //--------------------6.2---------------
  6000: "待接收",
  6001: "已接收",
  6002: "已退回",
  6003: "处理稿件",
  6004: "接收",
  6005: "退回",
  6006: "处理意见",
  6007: "操作者",
  6008: "稿件状态",
  6009: "{-somebody-}接收了稿件{-file-}，并附言：{-comment-}",
  6010: "{-somebody-}拒绝了稿件{-file-}，并附言：{-comment-}",
  6011: "定稿日期",
  6012: "接收了你的投件{-file-}，并附言：{-comment-}",
  6013: "拒绝了你的投件{-file-}，并附言：{-comment-}",
  6014: "为文件夹{-parent-}中的{-file-}上传了一个新版本",
  6015: "在文件夹{-parent-}中上传了一个新文件",
  6016: "访问文件列表",
  6017: "下载文件列表",
  6018: "上传文件列表",
  6019: "批注文件列表",
  6020: "评论文件列表",
  6021: "文件收集箱信息",
  6022: "暂无可用菜单栏目",
  6023: "查看相关文件",
  6024: "相关度",
  //****************6.3******
  6025: "部门成员开启审批时可自定义审批的流程和审批人",
  6026: "部门成员开启审批时可以选择在管理后台中预设所有的审批流程",
  6027: "在管理后台预设流程中选择几个作为部门使用的审批流程",
  6028: "使用上一级部门所使用的审批流程设置",
  /*****  6.4  *****/
  6029: "移除卡片",
  6030: "项目成员设置",
  6031: "项目内所有人",
  6032: "项目内所有未设置追加权限的普通成员",
  6033: "文件权限申请",
  6034: "申请权限",
  6035: "管理回收站",
  6036: "{-user-}邀请你参与以下项目",
  6037: "项目位置",
  6038: "转交项目",
  6039: "转交给项目人员",
  6040: "选择项目负责人",
  6041: "意见提出人",
  6042: "意见描述",
  6043: "意见处理",
  6044: "评审意见列表",
  6045: "审批意见列表",
  6046: "审批操作",
  6047: "提交审批",
  6048: "会签",
  6049: "审批文件",
  6050: "尊敬的用户， 您的账户空间使用量已达到{-per-}",
  6051: "尊敬的用户， 您的企业空间使用量已达到{-per-}",
  6052: "恢复到免费版",
  6053: "您确信要降级为普通用户吗？这样将导致您的空间和享受服务的降低！",
  6054: "参与分享的人员",
  6055: "旋转",
  6056: "暂不支持在线预览该文件，是否用本地应用程序打开？",
  6057: "删除失败，服务器错误",
  6058: "确认要停用外部人员- {-name-} - 的账号吗？",
  6059: "确认要删除外部人员- {-name-} - 的账号吗？",
  6060: "移除",
  6061: "你没有移入文件到目标文件夹的权限",
  6062: "附言",
  /**6.6*************/
  6063: "暂未加入其它团队",
  6064: "从常用联系人中添加",
  6065: "输入被邀请者手机（按Enter或Tab键确认），一次可添加多个",
  6066: "请输入手机号",
  /***************6.7************/

  6067: "共同发布文件夹",
  6068: "打开此选项，会在企业所有人企业文件频道显示出共同发布文件夹，企业成员均可在此文件夹内上传文件，超级管理员拥有此文件管理权限",
  6069: "已经提交",
  6070: "未提交",
  6071: "总计",
  6072: "人",
  6073: "提交状态",
  6074: "收件统计",
  6075: "未投件",
  6076: "已投件",
  6077: "暂无投件信息",
  6078: "当前账户暂未设置登录密码,你可以通过短信验证码登录后,设置登录密码。去",
  6079: "重新登录",
  6080: "获取邀请链接地址",
  6081: "复制此链接	",
  6082: "链接已拷贝到剪贴板",
  6083: "将此链接发放给相关人员，点此链接进行注册或登录后即申请加入本团队，由管理员审核后即可成功进入团队",
  6084: "仅有企业安全保密员可以设置企业的文件安全策略",
  6085: "{-sign-}了你对{-typeStr-}{-fileName-}的申请",
  6086: "申请加入{-type-}{-file-}",
  6087: "申请加入{-type-}",
  6088: "等待管理员审核",
  6089: "暂无访问该文件权限，等待管理员审核",
  6090: "在巴别鸟中打开",
  6091: "您可以在”我加入的分享“中查看该文件",
  6092: "暂未设置安全策略"
}, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, "6092", "根部门"), 6093, "将此链接发放给相关人员，点此进行注册或登录后即申请加入本项目，由项目负责人审核后即可通过"), 6094, "团队名称"), 6095, "项目名称"), 6096, "等待项目负责人审核"), 6097, "项目负责人"), 6098, "暂无访问该文件权限，等待项目负责人审核"), 6099, "将 {-file-} 中的一个 {-comment-} 设置为 {-finish-}"), 6100, "链接分享已关闭"), 6111, "审批名称"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6112, "文件列表"), 6113, "复制文件"), 6114, "复制完成"), 6115, "显示复制文件进度"), 6116, "加入了项目"), 6117, "您所在的企业没有购买审批模块，暂时无法使用此功能"), 6118, "您所在的企业没有购买保密模块，暂时无法使用此功能"), 6119, "您所在的企业没有购买存档模块，暂时无法使用此功能"), 6120, "邀请已发送，请耐心等待反馈"), 6121, "企业内备注"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6122, "修改企业内备注"), 6123, "此操作不可逆，确认删除该条通知吗？"), 6124, "邀请你加入企业"), 6125, "点此加入后，你将加入该企业，你个人版将注销，原有文件自动转移到此企业"), 6126, "巴别鸟不支持隐藏文件的上传"), 6127, "当前目录下，你没有上传文件的权限"), 6128, "点击添加文件说明"), 6129, "点击添加版本说明"), 6130, "您已选择100+个文件请使用客户端下载"), 6131, "（同步更快哟）"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6132, "您选择了多个文件夹请使用客户端下载"), 6133, "文件列表为空"), 6134, "邀请你加入了企业 {-name-} "), 6135, "点击查看可以在预览文件内容上进行批注！"), 6136, "在要批注的地方鼠标左键双击进行批注"), 6137, "目标企业"), 6138, "邀请加入企业"), 6139, "项目的讨论组，整个项目都可以在这里讨论"), 6140, "仅有安全保密员可以设定企业或部门的整体安全策略"), 6141, "安全保密员可以审批所有的分享请求"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6142, "{-somebody-} 邀请你加入了分享 {-file-}"), 6143, "获取审批信息失败,该审批已被撤回"), 6144, "目前不支持预览文件大小超过 {-size-} M，或者Excel行数超过2000行或者页数超过600页的文件。请下载后打开"), 6145, "文件不存在或已损坏"), 6146, "注册并登录后"), 6147, "{-somebody-} 将你移出了分享 {-file-}"), 6148, "在要批注的地方手指长按进行批注"), 6149, "该文件正在被编辑或更新中，现在预览的不是最新版本"), 6150, "不设置"), 6151, "你没有加入该文件链接分享的权限"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6152, "如需要批注，请登录"), 6153, "绑定手机号后可以直接用手机号登录"), 6154, "跳过"), 6156, "尊敬的用户，感谢您使用我们的网盘系统，耽误您点儿时间，欢迎您留下宝贵的意见和建议或者弃用的原因："), 6157, "{-somebody-} 将你加入了项目{-file-}"), 6158, "将你加入了项目{-file-}"), 6200, "点击"), 6201, "设置部门审批流程策略"), 6202, "部门文件使用管理"), 6203, "部门分享文件统计"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6204, "查看并管理部门中所有开启的分享"), 6205, "打开分享文件列表"), 6206, "打开文件权限设置"), 6207, "查看并管理部门中单独设置过文件权限的文件及文件夹"), 6208, "打开密级文件列表"), 6209, "查看并管理设置过文件密级的文件"), 6210, "打开文件访问日志"), 6211, "查看部门中的文件访问日志"), 6212, "成员使用情况"), 6213, "打开使用情况"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6214, "查看部门成员的文件使用情况"), 6215, "部门设置"), 6216, "限制下载次数"), 6217, "设置失败，请输入正确的下载次数"), 6218, "管理员绑定mac地址无效，绑定时会被自动过滤"), 6219, "文件行数或页数过多，建议使用客户端编辑功能打开"), 6220, "设置下载次数后，同一用户半小时内重复下载，仅计算一次"), 6221, "如果是新上传的文件，请等待最长30分钟，待服务器更新全文搜索索引"), 6222, "因政策原因，巴别鸟个人版和专业版不支持匿名访问分享的视频文件。你可以注册并登录后，在我加入的分享中预览或下载该视频。"), 6223, "此为加密文档，如需浏览编辑，敬请下载操作！"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6224, "部门文件归属于部门，转移文件归属并不影响该用户上传的部门文件"), 6225, "在部门中上传的文件"), 6226, "部门文件归属于部门。删除、停用用户、转移文件不影响部门文件"), 6227, "名称不能为空"), 6228, "或"), 6229, "你确定要删除该标签吗？"), 6300, "长按要批注的地方进行批注"), 6301, "清除本地缓存"), 6302, "多文件审批"), 6310, "移动端 App"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6311, "当前文件名"), 6312, "修改后文件名"), 6313, "申请重命名文件"), 6314, "申请移动文件"), 6315, "归档中，请稍候"), 6316, "当前目录"), 6317, "目标目录"), 6318, "申请将文件{-file-}重命名为“{-newName-}”"), 6319, "申请将文件{-file-}从“{-source-}”移动到“{-target-}”"), 6320, "{-sign-}了你对文件{-fileName-}的重命名请求"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6321, "{-sign-}了你对文件{-fileName-}的移动请求"), 6322, "{-sign-}了你对文件{-fileName-}的请求"), 6323, "操作失败，原目录已无此文件"), 6324, "企业拥有者不能被停用"), 6325, "当前登录账号不能停用自己"), 6326, "目标位置不能是根目录"), 6327, "我关注的通知"), 6328, "允许匿名访问"), 6329, "请至少输入6个字符"), 6340, "快照分享"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6341, "快照分享的内容会停留在你建立快照链接的时间，不会随文件内容的更新而更新。获得此链接的人员可以通过此链接访问建立快照时的文件。支持建立多个快照。"), 6342, "新建文件快照"), 6343, "暂无文件快照，你可以点击右侧按钮，新建一个快照"), 6344, "请选择文件快照"), 6345, "文件快照——"), 6346, "历史快照"), 6347, "快照日期"), 6348, "删除此快照"), 6349, "默认允许用户分享个人私有文件"), 6350, "筛选文件需要加载所有文件，请稍候"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6351, "筛选文件仅支持筛选已加载文件，该目录下文件数量大于500，是否立即加载所有文件"), 6352, "加载全部文件"), 6353, "筛选当前文件"), 6354, "下载限速"), 6355, "下载最高速率"), 6356, "注意：输入0表示不限制其下载速度"), 6357, "请输入100~20480的数"), 6358, "输入文件名，回车确认"), 6359, "分享文件(夹)："), 6360, "快照分享文件(夹)："), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6361, "思维导图"), 6362, "隐藏组织结构"), 6363, "打开此选项，企业所有成员无法在分享邀请/建立项目加人/添加审批人员/添加消息接收人/添加投件人/分组加人/从内部成员添加用户到部门时按组织结构选择企业成员，但可以通过搜索用户名，邮箱或手机号的方式添加。（对管理员无效）"), 6364, "查看上传文件"), 6365, "上传文件列表"), 6366, "你可以输入用户名/手机号/邮箱搜索本企业成员"), 6367, "复制到剪切板"), 6368, "图片已经复制到剪切板"), 6369, "仅支持https协议下复制图片"), 6370, "禁止分享文件给企业外用户"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6371, "打开此选项，企业成员无法将文件分享给企业外部用户，同时无法通过链接分享文件"), 6372, "隐藏工具栏"), 6373, "显示工具栏"), 6400, "快捷菜单"), 6450, "该邮箱已经注册为巴别鸟账号"), 6451, "该手机号已经注册为巴别鸟账号"), 6552, "每月上传统计"), 6553, "上传个数"), 6554, "月份"), 6555, "关于巴别鸟"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6556, "巴比鸟网盘"), 6557, "所有项目"), 6558, "流量统计"), 6559, "流量统计（单位MB）"), 6560, "企业发布文件夹"), 6561, "打开此选项，会在企业所有人企业文件频道显示出企业发布文件夹，仅超级管理员、安全保密员、档案管理员可在此文件夹上传文件，超级管理员拥有文件管理权限"), 6562, "用户停用自动关闭该用户开启的企业文件分享链接"), 6563, "开启此项，停用用户会自动关闭该用户的企业文件分享链接。如关闭此选项，停用用户开启的企业文件分享链接也能照常使用。"), 6564, "导出思维导图"), 6565, "KityMinder 格式 (.km)"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6566, "大纲文本 (.txt)"), 6567, "Markdown/GFM 格式 (.md)"), 6568, "SVG 矢量图 (.svg)"), 6569, "PNG 图片 (.png)"), 6570, "XMind 格式 (.xmind)"), 6571, "本企业有保密部门，不允许匿名上传文件"), 6572, "更新失败，该邮箱已经存在"), 6573, "该邮箱已存在"), 6574, "该手机号已存在"), 6575, "每月上传统计（单位：个）"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6576, "不允许以“.”结尾"), 6577, "个人文件分享链接账户停用即关闭。"), 6578, "手机号和邮箱不能同时为空"), 6579, "管理员设置了禁止访问企业发布文件夹，文件目录获取失败"), 6580, "文件目录获取失败"), 6581, "确认删除角色"), 6582, "文件权限名称"), 6583, ""), 6584, ""), 6585, ""), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6600, "从模板创建"), 6601, "没有可用模板"), 6602, "创建模板"), 6603, "文件模板"), 6604, "文件夹模板"), 6605, "管理员可在此文件夹下上传部门内的模板文件（夹）"), 6606, "新建模板"), 6607, "上传模板"), 6608, "没有可用模板"), 6609, "创建进度"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6610, "创建文件"), 6611, "创建完成"), 6612, "关闭此选项后，所有用户将无法分享个人文件里的文件，并且不能在个人文件里创建项目"), 6613, "流量统计"), 6614, "导出流量统计报表"), 6615, ""), 6616, ""), 6617, ""), 6618, ""), 6619, ""), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6620, ""), 6621, ""), 6622, ""), 6623, ""), 6624, ""), 6625, ""), 6626, ""), 6627, ""), 6628, ""), 6629, ""), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6630, ""), 6631, ""), 6632, ""), 6633, ""), 6650, "编码方式"), 6651, "转为项目"), 6652, "禁止匿名分享"), 6653, "打开此选项，通过链接分享文件时，不允许匿名人员访问"), 6654, "企业设置了不允许匿名访问"), 6655, "登录失效时间"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6656, "注：输入0表示浏览器关闭时登录即失效"), 6657, "在个人文件中上传了一个新版本{-file-}"), 6658, "在个人文件中上传了一个新文件"), 6659, "小时"), 6660, "请输入正整数"), 6661, "在个人文件中新增了文件夹{-file-}"), 6700, "文件名中含有非法字符"), 6701, "已用授权用户数/授权用户数：{-cur-}/{-count-}"), 6702, "请从部门列表中选择"), 6703, "点此注册个人版"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6704, "请完善您的企业信息"), 6705, "联系人姓名"), 6706, "联系人邮箱"), 6707, "输入一个二级域名作为您的企业专属访问地址，推荐使用4个以上英文字母"), 6708, "开通巴别鸟企业版"), 6750, "开始上传"), 6751, "暂停上传"), 6752, "已暂停"), 6753, "下载客户端"), 6754, "在线编辑发生错误保存文档失败，已自动恢复为最近的可用文档"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6755, "您同意加入企业后将成为该企业用户，同时取消你原来的个人版/专业版账号，是否同意？"), 6756, "忽略并重传"), 6757, "转交后当前项目负责人成为项目助理"), 6758, "普通成员"), 6759, "请选择其他编码方式尝试打开"), 6760, "个人私有文件空间上限设置成功 \n企业中有{-number-}人已自定义空间大小，是否需要统一修改空间大小"), 6761, "{-somebody-} 邀请你加入了项目 {-file-}"), 6762, "{-somebody-} 邀请以下人员 {-user-} 加入了项目 {-file-}"), 6763, "数据已经过期，请重新点击按钮导出列表"), 6764, "导出出现异常，请联系管理员"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6765, "有一个日志报表正在导出中，请稍后重试"), 6766, "日志报表下载成功了"), 6767, "日志报表下载中，请稍后"), 6768, "下载完成"), 6800, "你可以选择一个项目成员作为新的项目负责人"), 6801, "暂无项目成员，请添加项目成员后再转交项目"), 6802, "目前不支持预览大小超过 {-size-} M 的该类型文件，请下载后打开"), 6803, "暂无符合条件项目成员，请更换搜索条件"), 6804, "本地归档"), 6805, "归档后的文件保留在当前文件夹，不能再上传新版本，保留其他原有文件权限，阅读时不需要借阅"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6806, "已归档"), 6807, "你没有此文件的上传权限，不能进行在线编辑"), 6810, "生成预览文件失败，是否需要再次尝试？"), 6811, "重试"), 6812, "项目已经过期，普通项目成员已不能访问本项目。"), 6813, "已过期"), 6814, "目前不支持编辑大小超过 {-size-} M 的该类型文件，请下载后打开"), 6815, "清空该账户所有权限"), 6816, "清空"), 6817, "清空后用户仅能访问个人文件， 开启的分享将被关闭，也将从加入的部门、分组、分享、项目中退出"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6818, "你确定要清空{-name-}账户么？"), 6819, "此操作不可逆，清空后{-name-}的所有权限将会失效"), 6820, "空间占比"), 6821, "点击隐藏"), 6822, "发送文件列表"), 6823, "暂无发送文件"), 6824, "，最多输入5个"), 6825, "监控预警"), 6826, "企业监控列表"), 6827, "添加监控项"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6830, "企业暂未设置监控项"), 6831, "数量限制"), 6832, "监控信息获取失败"), 6833, "请选择监控项"), 6834, "你确定要删除当前监控项吗？"), 6835, "重复上传"), 6836, "在网盘中{-opType-}部门文件数量超标, {-operation-} {-currentNum-} 个, 设定的阈值是 {-threshhold-}"), 6837, "超过5个人员，不能使用发送文件功能"), 6838, "超过5个文件，不能使用发送文件功能"), 6839, "发送文控文件"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6840, "请选择接收人员"), 6841, "相关文件已被删除，请联系发送者"), 6842, "自定义快捷菜单"), 6843, "左侧栏显示快捷菜单"), 6844, "可选快捷菜单"), 6845, "可通过双击将此快捷方式从左侧栏移除，可通过拖拽进行排序"), 6846, "添加文件夹至快捷菜单"), 6847, "可通过双击将此快捷方式添加至左侧栏显示"), 6848, "暂无快捷菜单"), 6849, "暂无可选快捷菜单"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6850, "请选择文件夹"), 6851, "请在子目录中选择文件夹"), 6852, "文件继承了上一级的访问控制"), 6853, "最多可添加20个快捷菜单"), 6854, "所有监控项都已添加"), 6855, "传送文件配置"), 6856, "接收端口"), 6857, "发送端口"), 6858, "重填"), 6859, "{-somebody-} 将 {-file-} 发送给 {-targetNames-}"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6860, "您的手机号已经注册了巴别鸟，请确定是否把该账号升级为企业版？选”是“将进行升级操作，此操作不可逆并有可能造成数据丢失，请注意备份数据。如果您不想升级该账号，请选”否“后换个手机号注册企业版。"), 6861, "检测到您的手机号已经是巴别鸟企业用户，请换个手机号注册"), 6862, "更多选项"), 6863, "剪切"), 6864, "粘贴"), 6865, "文件收集箱仅支持收取{-str-}文件"), 6866, "端口说明"), 6867, "端口号"), 6868, "你确定要删除当前端口吗？"), 6869, "端口名称"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6870, "该名称已存在"), 6871, "新建"), 6872, "请输入端口名称及说明"), 6873, "接收者"), 6874, "编辑端口"), 6875, "新建端口"), 6876, "接收人员列表"), 6877, "你可以在这里选择该端口的成员"), 6878, "暂无接收人员"), 6879, "添加人员"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6880, "确定要将此人移出接收人员？"), 6881, "确定要将此部门移出接收人员？"), 6882, "点击显示token"), 6883, "发送端名称"), 6884, "接收端名称"), 6885, "接收端域名"), 6886, "如：http://www.babel.cc"), 6887, "接收端token"), 6888, "发送者"), 6889, "发送人员列表"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6890, "确定要将此人移出发送人员？"), 6891, "确定要将此部门移出发送人员？"), 6892, "暂无发送人员"), 6893, "传送文件"), 6894, "你可以选择配置好的端口进行文件传送"), 6895, "将文件{-fileName-}提交到企业发送端口{-identifier-}，申请发送文件，请"), 6896, "审核"), 6897, "系统接收端口{-identifier-}收到发送给你的文件{-fileName-}, "), 6898, "点击此处查看详情"), 6899, "你申请通过企业发送箱{-identifier-}发送文件{-fileName-}的请求,已被管理员 "), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6900, "系统接收端口{-identifier-}收到文件{-fileName-},请"), 6901, "系统接收端口{-identifier-}收到文件{-fileName-},已审核"), 6902, "企业未设置发送端口或没有您可用的端口，请联系管理员"), 6903, "暂不支持将文件夹复制到它的子目录"), 6904, "暂不支持将文件夹移动到它的子目录"), 6905, "请输入数量限制"), 6906, "文件夹专用"), 6907, "（部门在回收站中）"), 6908, "下载到:"), 6909, "浏览"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 6910, "设为默认路径"), 6911, "清空结束日期"), 6912, "默认不接收通知"), 6913, "打开此选项后，系统默认关闭用户推送通知，用户需要接收通知可以在设置中自行打开需要接收的通知类型"), 6914, "复制链接地址"), 6915, "链接已复制"), 6916, "使用客户端访问分享链接"), 6917, "通过"), 6918, "驳回"), 7000, "文件不能在同一成员中转移，请选择其他目标成员"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7001, "您的显卡太旧了，当前浏览器不能驱动"), 7002, "您可以尝试旧版本的浏览器或者升级显卡"), 7003, "您的浏览器版本太低了"), 7004, "请使用最新版本"), 7005, "尊敬的用户，您的企业版服务距离最后截止日期"), 7006, "尊敬的用户，您的企业版服务已经到期，如有需要请联系客服，我们将竭诚为您服务。"), 7007, "只剩下不到"), 7008, "小时了"), 7009, "天了"), 7010, "为了不影响您的使用，请尽快联系客服为盼！"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7011, "未找到与"), 7012, "匹配的查询"), 7013, "自定义文件夹"), 7014, "审批意见创建成功"), 7015, "错误的邮件格式"), 7016, "错误的邮箱或者手机号 "), 7017, "取消勾选限制"), 7018, "本部门"), 7019, "部门删除失败,请重试"), 7020, "最大空间限制"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7021, "设置空间限制"), 7022, "请输入最大空间值（单位:G）"), 7023, "不限制"), 7024, "上传企业logo"), 7025, "logo预览"), 7026, "请添加附言"), 7027, "网络错误，请稍后重试"), 7028, "该人员已经属于{-name-}企业，请该人员先退出该企业"), 7029, "此用户已注册，可发送邀请给他，该用户同意后即可自动加入本企业"), 7030, "发送邀请"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7031, "1 小时内不能重复发送"), 7032, "服务器返回错误"), 7033, "已停用用户"), 7034, "未设置"), 7035, "基础"), 7036, "存档"), 7037, "通知"), 7038, "阶段1"), 7039, "未注册"), 7040, "从未登录"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7041, "免费试用30天"), 7042, "无权访问"), 7043, "没有打开源文件的权限"), 7044, "图片"), 7045, "office 文档"), 7046, "Adobe 文档"), 7047, "CAD 文件"), 7048, "其他"), 7049, "全部时间"), 7050, "3日内"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7051, "1周内"), 7052, "1月内"), 7053, "6月内"), 7054, "全部大小"), 7055, "0 ~ 100字节"), 7056, "100字节 ~ 1K"), 7057, "10G以上"), 7058, "该语音批注已不存在"), 7059, "《标签》"), 7060, "做了图形标记（另行查看）"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7061, "上传了文件（另行查看）"), 7062, "历史版本"), 7063, "旧"), 7064, "采纳"), 7065, "等"), 7066, "您尚未登录，需要先登录"), 7067, "去注册"), 7068, "没有账号"), 7069, "登录提示"), 7070, "设置邮箱后，可以接收共享文件有关的邮件通知，建议<br>马上打开个人设置界面去绑定邮箱"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7071, "打开个人设置"), 7072, "以后再说"), 7073, "巴别鸟使用引导"), 7074, "欢迎您使用巴别鸟，我们引导您如何快速使用"), 7075, "点击创建按钮，您可以上传文件或者创建文件夹"), 7076, "在这里您可以查看所有您创建的文件及文件夹"), 7077, "部门文件夹"), 7078, "您可以在这里查看所属部门的文件"), 7079, "您可以在这里查看并管理所有您创建或已加入的团队"), 7080, "您可以在这里查看并管理所有您分享出去的文件或文件夹"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7081, "您可以在这里查看并管理所有您加入的分享文件或文件夹"), 7082, "所有添加关注的文件都会显示在此"), 7083, "需要您投稿或者管理投稿的地方"), 7084, "文件审批"), 7085, "您的审批文件会显示在此"), 7086, "所有删除的文件都会暂存在回收站"), 7087, "导航"), 7088, "在这里可以切换<em>文件</em>，<em>动态</em>"), 7089, "功能按钮"), 7090, "您可以在此查看文件详情或对文件排序"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7091, "使用引导"), 7092, "欢迎使用巴别鸟进行文档批注！下面逐条对主要工具进行介绍"), 7093, "批注点列表"), 7094, "可以查看文档中所有批注点"), 7095, "点击查看文件导航图 - 可以看到同一个文件夹中的所有文档"), 7096, "旋转当前文档"), 7097, "选择文件或版本与当前文件进行对比"), 7098, "在线打印当前文件"), 7099, "可以将文档分享给他人"), 7100, "查看文档的历史版本"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7101, "下载文档"), 7102, "批注显示控制"), 7103, "隐藏、显示批注"), 7104, "全屏显示当前页面"), 7105, "点击头像选择"), 7106, "，就可以进入企业管理后台，可针对本企业进行部门及人员管理，并进行所需配置。"), 7107, "您无权回复"), 7108, "您无权回复,请登录后进行回复"), 7109, "普通批注"), 7110, "几何批注"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7111, "文字标记"), 7112, "批注内容为空，不能发送"), 7113, "请输入文字内容"), 7114, "下载iOS App"), 7115, "来巴别鸟，参与讨论"), 7116, "请输入"), 7117, "发送新消息"), 7118, "无文件（夹）"), 7119, "提示 : 回收站为您保留10天内删除的文件（夹）"), 7120, "请按照下面的示意图操作打开"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7121, "巴别鸟App"), 7122, "第1步"), 7123, "点击右上角的「更多」按钮"), 7124, "第2步"), 7125, "选择用Safari打开"), 7126, "在App中打开"), 7127, "点击此处填写附言"), 7128, "在巴别鸟中组建了"), 7129, "，请填写附言信息或直接点击“加入”按钮加入此"), 7130, "加入"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7131, "通过动态你可以了解你的协作者及{-str-}的所有情况，并快速进入讨论的文件"), 7132, "回复成功"), 7133, "您没有回复的权限"), 7134, "回复失败，文件已被删除！"), 7135, "回复失败，批注已被删除！"), 7136, "回复失败，请稍后重试"), 7137, "回复失败，您无权查看该批注所在版本"), 7138, "回复失败，文件已被删除！"), 7139, "回复失败"), 7140, "评论成功"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7141, "您没有评论的权限"), 7142, "评论失败，请稍后重试"), 7143, "您的浏览器不支持 HTML5 video 标签"), 7144, "正在下载"), 7145, "有数据未保存"), 7146, "您编辑的数据没有完全保存的服务器"), 7147, "继续关闭"), 7148, "电话"), 7149, "请按⌘ + C拷贝链接"), 7150, "请按Ctrl + C拷贝链接"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7151, "现场焊缝"), 7152, "周围焊缝"), 7153, "文件名称"), 7154, '第<b id="fileNo" class="top">0</b>个文件,共<b id="fileCount" class="top">100</b>个文件'), 7155, "操作失败，请稍后重试"), 7156, "即将结束本文件的审批，您希望将文件的审批状态设置为："), 7157, "未启动审批（删除已有审批记录"), 7158, "列表为空"), 7159, "过滤了已有的审批人"), 7160, "文件没有新版本，不能开启审批"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7161, "查看报表"), 7162, "文件没有新版本，不能开启审批"), 7163, "显示审批列表"), 7164, "从预设名单中过滤了当前用户"), 7165, "发起者不能参与评审，已删除"), 7166, "点击刷新"), 7167, "选择目标档案夹"), 7168, "移动到"), 7169, "当前选中文件已包含在该文件夹内部"), 7170, "无法将选中文件夹{-title-}文件夹自己内部"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7171, "文件移动失败，请关闭文件分享后重试"), 7172, "文件移动成功"), 7173, "上传到"), 7174, "已关注"), 7175, "您目前不属于任何部门，或者无权查看任何部门文件"), 7176, "匿名访问者"), 7177, "我的分享参与者"), 7178, "文件参与者"), 7179, "暂无访问记录"), 7180, "统计汇总"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7181, "锁定"), 7182, "文件日志为空"), 7183, "工作量统计"), 7184, "暂无分组人员"), 7185, "公共分组为空"), 7186, "个人分组为空"), 7187, "参与的分享"), 7188, "访问记录"), 7189, "展开"), 7190, "暂无人员"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7191, "搜索标签"), 7192, "您还没有加入其它分享的文件"), 7193, "提示 : 所有您浏览过的分享链接中的文件(夹)都会显示在此处"), 7194, "抱歉，找不到带有选择标签的文件或文件夹"), 7195, "请确认"), 7196, "添加团队成员"), 7197, "请选择目标路径"), 7198, "文件名不能为空"), 7199, "文件名称长度不能超过100个字符"), 7200, "选择目标文件夹"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7201, "灰色的文件夹是没有上传权限的文件夹"), 7202, "大文件多文件请使用客户端同步功能"), 7203, "全功能客户端拥有"), 7204, "实时同步"), 7205, "消息推送"), 7206, "上传文件夹"), 7207, "等强大功能"), 7208, "Windows版下载"), 7209, "Mac版下载"), 7210, "若已下载，请打开客户端使用该功能"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7211, "如需购买office在线协作编辑授权，请联系客服人员"), 7212, "该功能仅在客户端中支持"), 7213, "您的存储空间已满, 可以删掉部分不用的文件, 或点击下方按钮购买跟多存储空间"), 7214, ""), 7215, "扩展存储空间"), 7216, "空间已满"), 7217, "有人正在网页上编辑该文件，你可以选择菜单中的“在线编辑”加入协同编辑"), 7218, "服务权限判断错误"), 7219, "个文件(夹)"), 7220, "取消赞"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7221, "小图标"), 7222, "中图标"), 7223, "大图标"), 7224, "标准"), 7225, "简洁"), 7226, "注"), 7227, "这是您邀请其他人参与的分享"), 7228, "我的邀请"), 7229, "文件设置了访问控制"), 7230, "保密文件"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7231, "限制文件"), 7232, "内部文件"), 7233, "外部文件不属于当前企业，是您加入的企业外部人员的文件分享或者团队等"), 7234, "你已经关注了这个文件，是否想取消关注？"), 7235, "继续关注"), 7236, '"注"中显示的是文件说明，文件说明可以起到帮助您标记文件的作用，您可以在文件详情面板中对任何您有编辑权限的文件，修改文件说明的内容'), 7237, "您想要取消这个置顶吗？"), 7238, "保持置顶"), 7239, "文件已被{-userName-}锁定"), 7240, "其他人需要等待其编辑完成锁定状态才能解除"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7241, "文件已被锁定，您想解锁吗？"), 7242, "注意：强行解锁可能会造成加锁人上传的版本与其他人的编辑版本相互覆盖从而造成版本丢失"), 7243, "解锁"), 7244, "关闭窗口"), 7245, "该文件已经被人锁定，您不能编辑"), 7246, "已到列表底部"), 7247, "关注的日期"), 7248, " 企业外联系人"), 7249, "正在以管理员身份查看部门文件"), 7250, "正在以管理员身份查看{-user-}的文件"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7251, "升级至专业版后, 当前账户所享有的免费版功能, 将获得以下提升:"), 7252, "账户空间容量扩展至1TB"), 7253, "可购买容量套餐获取更多空间"), 7254, "单个文件保存历史版本不限"), 7255, "新建团队个数不限"), 7256, "无限预览CAD文件"), 7257, "无限预览3D文件"), 7258, "共享标签"), 7259, "文件协作"), 7260, "了解专业版"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7261, "复制进度"), 7262, "请输入新的名称"), 7263, "人赞过"), 7264, "您还没有关注的文件(夹)"), 7265, '提示 : 您可以在"全部文件"中关注文件(夹)'), 7266, "您还没有分享过文件(夹)"), 7267, '提示 : 您可以在"全部文件"中分享文件(夹)'), 7268, "添加成员"), 7269, "创建项目完毕，请添加人员"), 7270, "获取权限列表失败"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7271, "该申请状态已经改变，请刷新后查看"), 7272, "文档关联关系图"), 7273, "您最近没有访问过文件"), 7274, "提示 : 您最近打开的文件会出现在这里"), 7275, "添加卡片"), 7276, "暂无企业外部人员"), 7277, "您无权查看企业外部人员列表！"), 7278, "暂无企业外部人员或无权查看"), 7279, "文件地址："), 7280, "您在此处添加的人员会获得访问文件的权利，如果对方是巴别鸟注册用户则该文件会自动出现在对方的“我加入的分享”栏目中。无论是否注册用户他们都将收到邮件或者短信通知，并且系统将根据您添加的人员邮箱或手机号进行安全验证，确保该人是您指定的访问者"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7281, "点击下面的按钮打开链接分享，您将获得一个链接地址，您可以将此链接地址通过邮件或者QQ等第三方通信手段进行传播，获得此链接的人员即可以通过此链接访问文件。为了增加保密性，你可以设置口令密码，此外也可以设置截止日期，到期链接自动失效。"), 7282, "被邀请人列表"), 7283, "链接地址"), 7284, "此文件的访问地址仅限于有权限的人访问"), 7285, "发送链接"), 7286, "外部用户"), 7287, "查看日志"), 7288, "移除此用户"), 7289, "通过邮件或短信发送此链接"), 7290, "立刻发送此链接"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7291, "文件地址："), 7292, "成员权限表"), 7293, "请求邀请用户共享文件"), 7294, "邀请分享"), 7295, "链接分享"), 7296, "获取权限列表失败"), 7297, "标签过滤"), 7298, "您还没有创建或加入过团队"), 7299, "未知错误，请稍后重试"), 7300, "文件最多保留10天"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7301, "搜索动态，按回车确认"), 7302, "密码为1到20位字母，数字组成"), 7303, "未加入部门"), 7304, "没有讨论组"), 7305, "简介被修改为"), 7306, "创建了文件夹"), 7307, "邀请参加讨论"), 7308, "系统消息"), 7309, "增加成员失败"), 7310, "输入被邀请者的邮件地址，以逗号分隔(或按Enter键确认)，一次最多发送10个"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7311, "输入被邀请者邮件或手机号"), 7312, "输入被邀请者邮件地址和手机号"), 7313, "已添加 <em>{-num-}</em> 个"), 7314, "邀请发送成功"), 7315, "不是企业成员"), 7316, "已加入"), 7317, "邀请发送失败"), 7318, "团队创建成功。"), 7319, "手机号修改成功"), 7320, "邮箱修改成功"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7321, "很抱歉, 巴别鸟免费版只能创建2个团队, 要创建更多团队, 请升级至专业版"), 7322, "账户设置"), 7323, "重新发送"), 7324, "请填写发到您邮箱里的验证码"), 7325, "请填写发到您手机的验证码"), 7326, "新的手机注册账户可以通过短信验证码来完成初始化密码设置"), 7327, "请填写发到您{-type-}的验证码"), 7328, "删除标签"), 7329, "标签过滤"), 7330, "标签删除失败"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7331, "标签修改成功"), 7332, "引用"), 7333, "团队名称："), 7334, "团队名称（40个字以内)"), 7335, "团队描述："), 7336, "团队描述，一百字以内。"), 7337, "该团队名称已存在"), 7338, "名称可用"), 7339, "团队名称过长"), 7340, "创建中"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7341, "请输入团队名称"), 7342, "团队名称不能超过40个字符"), 7343, "描述不超过100个字符"), 7344, "您还没有创建团队"), 7345, "提示 ：创建团队后您可以将相关企业人员添加为团队成员"), 7346, "提示 ：创建团队后您可以将相关企业人员添加为团队成员"), 7347, "您还没有加入过团队"), 7348, "不是企业成员"), 7349, "已加入"), 7350, "添加失败"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7351, "邀请发送失败"), 7352, "没有成员<br>无法转让！"), 7353, "未创建团队"), 7354, "我加入的团队"), 7355, "已加入"), 7356, "未找到匹配的团队"), 7357, "该批注点数据有错误！"), 7358, "注意：已经切换到历史版本"), 7359, "已经切换到当前版本！"), 7360, "下载中..."), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7361, "格式文件"), 7362, "请输入协同密码"), 7363, "下一页面"), 7364, "上一页面"), 7365, "向右转"), 7366, "向左转"), 7367, "网络链接异常，请检查网络！"), 7368, "没有删除权限"), 7369, "批注点数据错误！"), 7370, "获取显示文件错误！"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7371, "文件{-fileName-}-打印准备中"), 7372, "您的文件"), 7373, "失败! 文档含有密码，请去除密码后再试!"), 7374, "生成预览文件失败"), 7375, "保存文件失败"), 7376, "网络繁忙，稍后再试！"), 7377, "发生未知错误"), 7378, "网络错误或者服务器错误！"), 7379, "网络连接有错误"), 7380, "邀请失败，免费版的最大邀请限制 30 人，欢迎升级到不受限的专业版！"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7381, "发送失败，免费版的最大发送人数限制 30 人，欢迎升级到不受限的专业版！"), 7382, "请等待..."), 7383, "输入文件名"), 7384, "请输入文件名..."), 7385, "了解更多"), 7386, "相关文件"), 7387, "其他方式登录:"), 7388, "昵称不能为空"), 7389, "昵称不正确"), 7390, "请输入6-20位包含大小写字母及数字的组合"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7391, "密码不能为空"), 7392, "请输入6-20位包含大小写字母及数字的组合"), 7393, "昵称不存在"), 7394, "密码错误"), 7395, "邮箱格式不正确"), 7396, "邮箱不能为空"), 7397, "图片验证码不能为空"), 7398, "图片验证码错误"), 7399, "邮箱不存在"), 7400, "密码不匹配"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7401, "两次输入的密码不一致"), 7402, "手机号不能为空"), 7403, "手机号格式错误"), 7404, "短信验证码不能为空"), 7405, "验证码错误"), 7406, "请输入邮箱或手机号"), 7407, "手机号尚未绑定"), 7408, "用户不存在"), 7409, "验证码已过期"), 7410, "此账户已冻结，禁止登录"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7411, "邮箱或手机号格式错误"), 7412, "请输入注册的邮箱或手机号"), 7413, "验证码错误"), 7414, "验证码不能为空"), 7415, "您不是该企业的用户"), 7416, "请选择身份"), 7417, "请输入企业名称"), 7418, "请输入联系人昵称"), 7419, "请输入联系人邮箱"), 7420, "请输入域名"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7421, "企业名称不能全是数字"), 7422, "仅支持输入字母及数字"), 7423, "请输入6-20位包含大小写字母及数字的组合"), 7424, "找回密码"), 7425, "请填写您用来登录的邮箱地址或手机号"), 7426, "获取验证码来重新设置新密码"), 7427, "密码设置成功"), 7428, "没有收到获取验证码邮件？"), 7429, "请检查邮箱地址是否正确"), 7430, "检查您的邮件垃圾箱"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7431, "可能是本站的邮件系统繁忙或者故障，请稍候再试"), 7432, "若仍未收到确认，请尝试重新发送"), 7433, "输入新密码"), 7434, "确认新密码"), 7435, "文件"), 7436, "文件夹"), 7437, "发送失败,请确认邮箱地址或手机号并重试"), 7438, "权限"), 7439, "团队"), 7440, "确定要删除选中的档案文件吗，档案文件删除后不可恢复?"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7441, '检测到您还未登录，请先<a class="link" href="/account/login.do">登录</a>'), 7442, "你访问的链接不存在或文件已取消分享!"), 7443, "您还可以:"), 7444, "返回首页:"), 7445, "返回上一个页面:"), 7446, "现在加入巴别鸟"), 7447, "开启企业高效云办公"), 7448, "用技术改变工作和生活方式"), 7449, "巴别鸟是上海画擎信息科技有限公司的注册商标，上海画擎成立于2012年，总部位于上海，2016年于北京设立分公司。巴别鸟是一个以技术为主导的团队，创始人均来自北大方正，拥有国内创业团队较强的图形图像技术。目前，巴别鸟已经完成了A轮投资，用户数接近40万，文档数据量已突破1000TB。"), 7450, "图形图像领域的孜孜耕耘，高效工作方式的不懈探索，以及对产品用户体验的极致追求，造就了巴别鸟知识管理平台。你可以用巴别鸟存储和管理工作文档，快速共享企业知识，并能通过任意设备，直接在各种格式的文档上协作讨论。"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7451, "关于<span>巴别鸟</span>的小故事"), 7452, "巴别鸟的名字源于圣经中的巴别塔，传说古代人类拥有统一的语言，一致的想法，一样的价值观，所以人类很强大以至于能集合全人类的力量在古巴比伦修建一座通天高塔，塔越修越高，上帝感到人类的齐心协力，统一强大会挑战他的权威，所以推倒了巴别塔，让人类说不同的语言，产生不一样的思想，从此人类陷入了思想不一致造成的混乱和无息的战争中，再也没有办法修筑高塔。巴别鸟是巴别塔修建过程中负责沟通各个环节的一种小鸟，能快速传达巴别塔这浩大工程中的各种协作细节。现在，巴别鸟复活了，它存在于互联网，它让我们的沟通更紧密，也让我们更加强大。"), 7453, "公司介绍"), 7454, "客服热线"), 7455, "公司地址"), 7456, "公司名称：上海画擎信息科技有限公司"), 7457, "地址： 上海市嘉定区平城路1055号"), 7458, "邮编：201821 "), 7459, "电话：400-9204020（周一至周日 8:00 ～ 20:00）"), 7460, "媒体及推广、投诉及建议"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7461, "联系人：皇甫珊欣"), 7462, "手机：13564686107"), 7463, "微信号：MolaSync"), 7464, "产品Bug及改进建议"), 7465, "电子邮件： support@molasync.com"), 7466, "官方QQ交流群： 512728617"), 7467, "培训及咨询"), 7468, "联系人： 张拥军"), 7469, "手机：13261256900"), 7470, "微信号：zhangyjluck"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7471, "全部解压"), 7472, "解压到"), 7473, "解压"), 7474, "水印颜色"), 7475, "预览文件还未成功生成！请一分钟后重新点击尝试！"), 7476, "上海总部"), 7477, "地址：上海市环城路762弄信业未来中心4号楼8栋7楼"), 7478, "上海研发中心"), 7479, "地址：上海市武宁南路488号1801"), 7480, "电话：13584686107"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7481, "北京分公司"), 7482, "地址：北京市东城区朝阳门银河SOHO 3Q B区"), 7483, "成都分公司"), 7484, "地址：成都市青羊区光华中心C座 9楼"), 7485, "联系人：汪宇杰"), 7486, "电话：13982493667"), 7487, "巴别鸟（香港）国际"), 7488, "地址：香港特别行政区中西区夏悫道18号海富中心第二座写字楼8F层"), 7489, "联系人：石芸青"), 7490, "电话：852-69968224"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7500, "网页上传一次不能超过 100 个文件（夹），请使用客户端的同步文件夹功能进行同步！"), 7501, "请在文件详情面板修改文件的安全级别"), 7502, "所谓私有文件，是指没有放在部门里或者企业公共文件夹中的文件，这种文件就属于个人私有，其他人看不见，更不能访问"), 7503, "这是必填字段"), 7504, "最多可以输入 {0} 个字符"), 7505, "请输入数字"), 7506, '文件名不能包含下列任何字符： \\ / : * ? " < > |'), 7507, "mac地址格式错误"), 7508, "请填写正确的手机号码"), 7509, "请填写正确的电话号码"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7510, "请填写中文"), 7511, "请填写正确的邮编"), 7512, "昵称必须为2-20位的字符串"), 7513, "请输入6-20位包含大小写字母及数字的组合"), 7514, "请填写正确的字母"), 7515, "角色名称"), 7516, "这是必选项"), 7517, "审批人员不能为当前用户"), 7518, "请输入有效的日期"), 7519, "禁止跨企业移动文件！"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 7520, "{-somebody-}将{-file-}移进了文件夹{-folder-}"), 7521, "{-somebody-}将{-file-}的访问权限设置为{-role-}"), 7522, "给你分享了文件{-file-}"), 7523, "签名"), 7524, "目标文件夹所有者的空间不足"), 7525, "含有子项目，不允许删除"), 7526, "消息已被删除"), 7527, "企业拥有者必须是管理员"), 8000, "定制属于您的巴别鸟"), 8001, "企业服务的核心是服务企业，为了向企业提供更细致的服务。我们推出了巴别鸟定制开发业务。帮助企业解除标准化产品的局限，大幅提高生产效率"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8002, "联系我们"), 8003, "从产品思维出发帮助您设计产品"), 8004, "不同行业有不同的工作流程及使用习惯，同时需求和最终的产品间往往也隔着很深的鸿沟。只有需求没有好的产品设计往往会使项目迟迟无法落地。为了更好的适用于您的使用场景，我们职业产品经理带队的Babel care团队会为您的企业定制属于你的解决方案及二次开发支持。"), 8005, "强大的研发实力"), 8006, "我们拥有一个10人的定制开发支持团队，主要成员均为巴别鸟系统的核心研发人员。来自于北大、交大、及成都理工大学。我们支持各种语言及各种平台的定制开发工作。在数据库、云计算、图形图像方面有自己的核心技术，尤其擅长算法。拥有大量各类系统的研发经验。"), 8007, "精细化估时管理"), 8008, "我们拥有曾服务于北大方正的精细化估时管理体系，能精确的进行开发估时管理，提高项目成功率及落地效率。项目估时清晰有据可查，有效降低企业成本并提高效率。"), 8009, "透明的项目跟进及验收"), 8010, "在项目的每一个阶段，我们都有专职项目经理和产品经理跟进。确保项目进度及验收标准。并且我们可以开放我们的jira（项目管理工具）给您，让您随时了解到项目的进度及耗时。"), 8011, "透明、专业、负责"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8012, "负责，是客户给我们最多的和最高的评价。在项目维护期内，我们会站在企业角度考虑，及时对应修正bug并完成功能调整。为企业提供长期可持续的维护服务。"), 8013, "“巴别鸟定制开发系统解决了我们签证文件自动提交并统一管理的问题。现在，用户提交的签证材料都可以安全有序的在我们系统中统一管理及快速查询。”"), 8014, "他们在使用我们的定制系统"), 8015, "整合 让我们无所不能"), 8016, "线上咨询"), 8017, "下载API文档"), 8018, "无需重新发明轮子"), 8019, "我们已经进入了开放平台的时代。使用巴别鸟API，您可以在您的系统中使用巴别鸟的几乎所有能力。并在云中构建自定义应用程序和集成，而无需构建和维护自己的内容管理服务。同时，巴别鸟也可以集成如电子签名、高级CAD管理、office、文字识别图形识别等第三方服务来解决您遇到的需求问题。"), 8020, "全系统接口化"), 8021, "巴别鸟的几乎所有功能都可以通过API接口进行调用，配合单点登录可以快速实现整合。我们的开发团队也能提供相应的技术支持，帮助您快速对接巴别鸟。使得共享数字信息变得容易，并为您的客户和团队提供了一种安全的方式来直接在您自己的自定义应用程序中访问，批注，共享和协作内容。"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8022, "将生产力和协作放在首位"), 8023, "工作往往围绕着文档展开，以文档管理为入口整合各类产品就可以不用频繁切换软件或平台无缝享受各类SAAS服务。 巴别鸟可以按需接入only office、永中office、office365、cad、iWork、犀牛3D、浩辰CAD、天锐绿盾等大量生产力套件及应用程序。让您不用在各个应用程序间copy文件、切换账号即可满足协作及编辑需求。"), 8024, "商业授权"), 8025, "想为您的客户提供更多样的服务？安全的内容存储管理、销售资料的展示、合同报价管理、代理商文件管理、企业知识管理、档案库、批注讨论系统…使用巴别鸟商业授权服务，您的企业可以在巴别鸟系统基础上开发自己的商业应用并进行销售（支持私有化），让企业快速拥有云服务产品。"), 8026, "“我们在巴别鸟的基础上结合永中office推出了永中优云。让我们的在线office系统具备了企业级文件管理功能，提供给我们客户比office365更优的企业office解决方案。”"), 8027, "现在开始整合巴别鸟到您的系统"), 8028, "查看巴别鸟详细功能列表"), 8029, "为企业量身定制"), 8030, "从技术到应用，知行合一"), 8031, "文件存储"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8032, "协作及编辑"), 8033, "移动办公"), 8034, "企业后台管理"), 8035, "数据安全"), 8036, "强大先进的文件存储系统"), 8037, "帮助您快速搭建云端工作环境"), 8038, "使用巴别鸟文件存储系统的客户端（Mac、windows）及APP（安卓、iOS），你可以快速和团队及企业的其他部门建立文件共享环境，并且把工作文件同步到你及你同事的各个设备，保证团队和个人的工作内容随时保持最新。你可以把巴别鸟客户端当做你的工作入口，在客户端上直接打开云端文件进行编辑并保存至云端。你同事新建及更新的文件你也可以第一时间收到并在巴别鸟上进行讨论。从此，你的文件数据将在云端得到妥当保存，你和你同事的文件夹内容将保持一致，并且可以使用全文搜索快速找到你所需的文件。"), 8039, "点此下载Excel版本详细功能列表"), 8040, "文件存储详细功能列表"), 8041, "跨平台，多终端"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8042, "PC、MAC、手机及平板客户端，H5网页版"), 8043, "自动备份，同步"), 8044, "指定任意文件夹双向同步（云端到本地，本地到云端）<br>支持实时同步、手动同步<br>版本控制配合同步管理解决冲突"), 8045, "文件点对点快速传输"), 8046, "鼠标右键快速发送本地文件给任意用户"), 8047, "大文件秒传"), 8048, "内容相同的大文件快速秒传"), 8049, "断点续传"), 8050, "网络中断可重连继续原有进度传输"), 8051, "增强型文件管理"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8052, "预览图标、多维度排序、拖动上传、文件属性、置顶、复制移动删除、锁定…..."), 8053, "树状目录"), 8054, "支持树状目录显示文件及文件夹，类似资源管理器和访达的使用体验"), 8055, "文件日志"), 8056, "可单独查看任一文件的日志，了解文件生命周期的所有记录"), 8057, "访问统计"), 8058, "文件打开次数，访问人数，下载次数，批注数目，访问者列表"), 8059, "CDN加速及网络优化"), 8060, "在全球任何地方都适配最近的节点以快速打开"), 8061, "在线预览"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8062, "支持近200种格式的在线预览，除普通office文件及图片文件以外，支持苹果office（iWork）及3D模型、矢量设计稿、CAD图稿、PSD、AI等专业格式。支持音视频文件在线播放"), 8063, "文件锁定"), 8064, "正在编辑的文件自动锁定，其他人不可编辑。也可手动锁定某个文件，防止他人篡改"), 8065, "超大图片在线预览"), 8066, "5K甚至10K的大图片直接在线打开原图预览。专利技术"), 8067, "在线批注讨论"), 8068, "可以在文件预览上直接批注、圈画、甚至语音讨论文件内容"), 8069, "在线编辑"), 8070, "文件的在线编辑及协同编辑，在app端也可以在线编辑"), 8071, "本地编辑自动上传"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8072, "支持直接调用本地程序编辑在线的文件，编辑结果自动上传"), 8073, "文件关注"), 8074, "可以提醒企业成员关注某文件及自己关注某文件，更新自动提示"), 8075, "文件收集箱，投件箱"), 8076, "汇总文档、收取作业、权限可控的特殊文件夹"), 8077, "企业文件及个人文件分开管理"), 8078, "企业及部门文件夹及私人文件夹的区分"), 8079, "版本控制"), 8080, "无限多的文件历史版本，可管理、下载、删除、设为当前版本，支持版本log"), 8081, "共享标签"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8082, "可为文件及文件夹设置多个标签，快速查找，并且标签通用，有权限的成员都可以调用"), 8083, "左侧栏标签列表"), 8084, "可添加标签列表至左侧栏，快速分类、定位文件"), 8085, "未读文件提醒"), 8086, "未读文件状态提醒，其他成员新上传文件不被遗漏"), 8087, "多级回收站"), 8088, "有效时间内（管理员可设）普通成员删除的企业文件上级领导可还原或彻底删除，按级别类推。"), 8089, "全文检索"), 8090, "可搜索文档及矢量图稿中的文字内容，可搜索标签及搜索指定范围内的文件"), 8091, "文件权限"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8092, "可增设企业文件权限，细粒度的控制任意文件（文件夹）针对该文件参与共享人员所拥有的访问、编辑、批注、打印、下载、有效期等权限"), 8093, "文件密级及安全级别"), 8094, "四个级别，可严格控制文件传播"), 8095, "多语言"), 8096, "中文版及英文版"), 8097, "划时代的协作方式"), 8098, "让沟通更简单、更高效"), 8099, "协作及编辑详细功能列表"), 8100, "部门及团队"), 8101, "可以按组织结构建立部门、并拥有相应从属关系及带权限管理的部门文件"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8102, "企业临时组队"), 8103, "通过创建项目，企业的成员可以实现跨部门随意快速组合，用项目将不同部门的人组织起来，项目还可以进行跨部门移交"), 8104, "企业共享文件夹"), 8105, "整个企业（除受限人员）都可以访问的公共空间"), 8106, "企业成员按设定自动共享文件"), 8107, "部门成员无需提醒可自动获得最新的文件版本及动态通知，并可直接使用共享文件夹"), 8108, "文件链接分享"), 8109, "文件右键直接开启链接分享，可设定链接有效期、密码及多种访问权限，并可通过微信及邮件分享"), 8110, "文件邀请"), 8111, "通过邀请分享文件给特定的人进行协作，非邀请账号无法进入文件，被邀请者的使用权限可分别任意调整"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8112, "分享及邀请授权机制"), 8113, "没有邀请/分享权限的用户可以向有权限的用户发送进行分享的授权请求"), 8114, "邮件系统"), 8115, "新文件上传、新批注及讨论、邀请及文件发送都可通过邮件发送到用户邮箱，并可在邮箱中直接查看及使用"), 8116, "访问日志"), 8117, "协同批注讨论"), 8118, "在文件内容上可以直接建立批注进行实时沟通讨论，协同探讨问题。支持文字、手绘、语音、附件等讨论方式。讨论内容可以按权限显示及隐藏。"), 8119, "3D批注"), 8120, "在3D模型中可以建立基于三维坐标的批注进行讨论，点击批注点可回到用户建立批注时的视角上"), 8121, "文件评论"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8122, "和动态列表中快速回复。"), 8123, "动态"), 8124, "跟用户本人相关的团队信息及文件讨论批注信息的汇总平台，在动态中可直接导航至相应文件查看，或快速回复批注及评论。通过动态和团队协同，更直接更简单。"), 8125, "消息及提醒"), 8126, "、提醒关注、重要通知、邀请及授权等重要操作将会以消息通知的方式送达。帮助用户摒弃杂音，关注最重要的事"), 8127, "对外协作"), 8128, "和兄弟公司或者和客户建立协作。内部文件及外部文件分开标识、外部成员单独管理、邮件手机号快速邀请。安全又高效"), 8129, "部门、项目及团队群聊"), 8130, "类似微信群聊的以部门、项目及团队为基础的讨论群，支持附件传输"), 8131, "及附件"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8132, "成员及传输附件，让工作更专注"), 8133, "审批及审批流程"), 8134, "支持文件审批，可预设审批流程，无论是分组审批还是顺序审批都支持。审批后文件直接定稿不可更改"), 8135, "文件定稿"), 8136, "审批通过的文件即为定稿文件，定稿文件不可修改，方便开发及生产部门确定并留下凭据。"), 8137, "企业公告"), 8138, "简单快速发表企业公告，快速传达给企业成员"), 8139, "协作成员管理"), 8140, "所有的文件分享协作都可以快捷管理参与协作的成员，改变成员权限、增加删除参与成员。"), 8141, "基于组织结构的协同"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8142, "企业内部协作可以导入组织结构，可以根据组织结构的从属关系快速建立协同关系及分配权限"), 8143, "在线协同编辑"), 8144, "支持office文档的在线协同编辑，清晰标示修改点，共同完成一个文档"), 8145, "共屏演示"), 8146, "针对远程会议支持共屏演示，开启后参与者视角和演示者一致，可使用画笔及光枪标注重点内容"), 8147, "得心应手无所束缚"), 8148, "用手机和Pad就能完成大多数工作"), 8149, "巴别鸟全功能移动端，不仅具有web端所有功能，还有语音批注、配合触摸屏的优质手写批注等移动设备专属功能。让你随时随地都可以打开多达200种格式的文件并在上面和团队讨论。无需安装任何其他应用程序就可以在线编辑office文档。针对iPad屏幕，巴别鸟更优化了体验，左边文件结构和动态右边文件内容的设计让移动端的使用体验更佳。支持win10的客户端还可以让你的surface如虎添翼。使用巴别鸟移动端，你可以把整个企业的文件和团队的智慧带在身上，可以随时随地检查下属刚做好的方案、调取最新的设计稿给客户、远程演示一个PPT、审批通过最新的预算。当然，我们支持微信。"), 8150, "移动办公详细功能列表"), 8151, "安卓、iOS平台、微信0全覆盖"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8152, "支持安卓设备，iPhone及为iPad定制的pad版本。支持H5"), 8153, "windows10及Mac"), 8154, "在surface平板及苹果笔记本上可以使用客户端并同步"), 8155, "原生APP，执行效率更高"), 8156, "巴别鸟移动端都是专门为目标系统编写的原生APP，非嵌套网页"), 8157, "全功能移动端"), 8158, "无论是客户端还是移动端，都支持web版的所有功能"), 8159, "为移动而生"), 8160, "移动端支持创建语音批注、相机拍照上传、直接拍照附件"), 8161, "为iPad定制的界面，神级交互"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8162, "巴别鸟在iPad上体验极佳，横屏左侧显示文件列表，右侧文件内容，快速切换高效协作。使用iPad开始办公吧"), 8163, "从其他App打开文档"), 8164, "微信和QQ等app的文档可以用巴别鸟打开并上传"), 8165, "移动端下载文件并转发"), 8166, "在巴别鸟移动端下载的文件可以直接转发至微信"), 8167, "用移动端分享文件"), 8168, "移动端可以直接通过微信分享文件还可以直接发朋友圈"), 8169, "在线编辑"), 8170, "移动端可以打开office文档进行在线编辑，无需安装其他软件"), 8171, "在线预览"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8172, "网页版能预览的大多数文件在移动端也能预览（除3D文件以外的近200种）"), 8173, "直接批注讨论"), 8174, "在巴别鸟移动端打开的文件上单击就可以直接批注讨论，并管理批注点"), 8175, "水印显示"), 8176, "移动端打开的文件也支持水印"), 8177, "极致快速浏览文件"), 8178, "上下翻页，左右切换文件，多个文件间快速切换，更符合移动端使用习惯"), 8179, "手绘，移动端更佳"), 8180, "配合移动设备的触摸屏，在巴别鸟APP打开的文件上可手绘圈住讨论，体验更佳。"), 8181, "全文搜索"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8182, "移动端也可以快速全文搜索所有权限内可查阅文件，无需翻找"), 8183, "标签、关注、评论一个不少"), 8184, "真正全功能，所有功能在移动端一个不少还更强大"), 8185, "部门及团队群聊"), 8186, "和微信接近的群聊体验，更符合用户使用习惯"), 8187, "日志查看"), 8188, "在移动端同样可以查看日志，进行管理"), 8189, "通知中心"), 8190, "使用移动端可以随时接收到聊天信息及文件更新通知，实时了解团队动态"), 8191, "私有化也可以使用APP"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8192, "简单配置后，移动端也可以为私有化用户提供服务"), 8193, "为企业而生"), 8194, "符合企业管理细节要求的企业管理后台，统一管理整个企业"), 8195, "企业logo替换"), 8196, "从登录界面到使用界面及分享开启页面都可使用用户企业logo，统一专业，兼顾企业形象"), 8197, "独立二级域名"), 8198, "每个企业拥有自己的独立入口，不易混淆更专业"), 8199, "企业概况"), 8200, "一目了然显示企业的使用情况，空间占用情况"), 8201, "多级管理员"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8202, "企业拥有者账号、企业管理员、档案管理员、运维管理员、安全保密员、安全审计员等多种管理员身份，精细化分配管理权限，做到滴水不漏"), 8203, "预设安全策略"), 8204, "5种安全策略可选，从流程到权限分配保护企业的数据"), 8205, "组织结构"), 8206, "按组织结构分配部门及文件结构，不同部门可以选用不同的安全策略"), 8207, "部门管理"), 8208, "详细管理部门的空间使用、人员、管理者、子部门、安全策略"), 8209, "管理员分权"), 8210, "管理员可分权至部门，由部门管理自己的使用情况，并指定部门管理员。为IT维护人员分担工作。"), 8211, "成员管理"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8212, "可管理企业所有成员，内部及外部成员"), 8213, "批量添加、批量编辑"), 8214, "可批量添加导入企业成员，快速建立账号，邮件自动通知成员"), 8215, "一键转移"), 8216, "离职成员文件一键转移一键交接给其他成员"), 8217, "快速停用"), 8218, "可批量快速停用特定员工账户"), 8219, "搜索及筛选"), 8220, "强大的搜索及筛选工具，方便快速管理成员"), 8221, "空间限制"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8222, "可以限制每个用户的私人存储空间，以优化空间分配"), 8223, "角色及权限管理"), 8224, "可定制角色及相应的权限，多达40种细节权限可选并调整"), 8225, "标签管理"), 8226, "管理或新建整个企业的共享标签，并查看标签使用情况"), 8227, "审批管理"), 8228, "预设审批流程，管理已有审批流程并查看使用情况"), 8229, "分组管理"), 8230, "企业的成员可以随意快速组合，临时组建项目小组。并管理已有分组，在分组中增删成员"), 8231, "水印设置"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8232, "支持文字水印、查看者用户ID水印、图片水印。能管理水印的适用范围、使用方式、显示方式及透明度等信息"), 8233, "mac地址绑定"), 8234, "设立mac地址池，让企业特定员工在特定的设备上才能访问巴别鸟"), 8235, "访问日志"), 8236, "详细记录了整个企业的巴别鸟使用日志，详细可查。支持搜索及多种筛选方式。可导出。"), 8237, "为保密企业定制的安全系统"), 8238, "从权限分配到使用，从传输到存储。巴别鸟提供最专业的安全保护"), 8239, "每个文件独立的访问控制"), 8240, "能独立查看及管理每个文件的访问控制，并追加或改变访问权限"), 8241, "文件安全级别设置"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8242, "可设置任意一个企业文件的安全级别，公开、内部、限制、保密四个级别可选，不同级别对应不同的安全策略。从文件级保证文件的安全"), 8243, "每个文件独立可查的日志"), 8244, "日志粒度细到文件，可以查看每个文件的详细访问日志"), 8245, "配合批注，仅可查看也能完成沟通"), 8246, "巴别鸟支持大多数文件的预览，并且可以在文件内容上直接批注提意见讨论，意味着只要不是文件编辑者，无需开启下载权限即可完成工作。使用巴别鸟可以关闭下载权限，最大限度保证文件不外泄"), 8247, "文件访问者统计"), 8248, "不管是内部成员还是外部成员甚至匿名用户，文件的访问者都能在文件属性中统计及查看（匿名用户显示IP）"), 8249, "真水印"), 8250, "不同于一般网盘在前台界面显示的水印，巴别鸟的水印是嵌入文件的，并且能设置开启查看者的ID作为水印，能有效的保证文件不被截屏传播。"), 8251, "分享权限及加密"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8252, "文件右键直接开启链接分享，可设定链接有效期、密码及多种访问权限控制"), 8253, "安全的邀请方式协作"), 8254, "通过邀请分享文件给特定的人进行协作，非邀请账号无法进入文件，被邀请者的使用权限可分别任意调整"), 8255, "分享及邀请可授权"), 8256, "分享及邀请可开启授权，让重要文件的分享行为可以管理"), 8257, "分享行为管理"), 8258, "精确到文件的分享行为管控，可查看管理文件及文件夹的所有分享记录"), 8259, "离职员工一键交接"), 8260, "离职员工文件一键交接给交接人，同时保留离职员工的聊天及批注数据"), 8261, "内部文件及外部文件区分"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8262, "巴别鸟能区分内部文件（企业的文件及员工的私人文件）及外部文件（其他企业或合作伙伴上传的文件）保证文件的来源"), 8263, "版本控制"), 8264, "文件改动都永久保存老版本，防止失误造成的文件覆盖"), 8265, "回收站控制"), 8266, "有效时间内（管理员可设）普通成员删除的企业文件上级领导可还原或彻底删除，按级别类推。"), 8267, "多管理员结构"), 8268, "防止管理员权限过大或不熟悉业务造成安全隐患。巴别鸟从全盘管理到管理人、管理文件、管理安全几个方面把管理员分为企业管理员、档案管理员、运维管理员、安全保密员、安全审计员等多种管理员身份。适应不同企业需求"), 8269, "文件拥有者是部门及企业"), 8270, "巴别鸟的文件拥有者是部门及企业，部门及企业拥有最高权限"), 8271, "安全策略"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8272, "5种安全策略可选，从流程到权限分配保护企业的数据，不同部门可以设定不同的安全策略，仅有安全保密员才可设定部门安全策略"), 8273, "详细日志查看"), 8274, "详细记录了整个企业的巴别鸟使用日志（操作记录），可导出作为凭据。可以筛选查看特定成员的访问情况"), 8275, "二次验证"), 8276, "可以通过手机短信进行账号二次验证"), 8277, "受限成员"), 8278, "受限成员不可访问企业公共文件夹，不可接收企业动态"), 8279, "外部成员管理"), 8280, "可以分开管理非企业成员，了解外部成员访问情况，删除或更改外部成员权限"), 8281, "角色及权限细化管理"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8282, "支持自定义角色，及多达40项角色权限的可选管理"), 8283, "成员使用空间控制"), 8284, "精确的控制每个成员的可用空间"), 8285, "mac地址绑定"), 8286, "可以绑定用户账号到某一mac地址或mac地址池，限定特定用户仅可在特定设备访问"), 8287, "传输存储全链路加密"), 8288, "文件上传下载使用HTTPS作为传输协议，传输过程中对文件本身进行了二次AES CTR 256算法流式分块加密，确保最终保存在云存储系统的文件均为密文，在传输以及存储过程中杜绝被窃取可能"), 8289, "最高级别的EV"), 8290, "使用最高级别的EV SSL传输认证 获得国外第三方评测机构Qualys A+安全评定"), 8291, "多重备份"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8292, "公有云使用阿里OSS存储服务，同一份数据分布式存储于4个节点私有云可选采用分布式存储及raid阵列进行数据备份，确保硬件损伤不丢失数据"), 8293, "MD5哈希校验"), 8294, "存储文件在服务器端均进行MD5哈希校验，确保文件独一无二，防止篡改"), 8295, "碎片化存储"), 8296, "文件被打碎存储在不同的服务器中，确保硬盘copy的方式无法获得完整的数据以保证安全"), 8297, "容灾消灾"), 8298, "公有云基于阿里提供的容灾消灾服务，强大的异地容灾备份功能，可快速完成数据切换而不影响用户的文件使用，紧急情况下迅速对用户数据进行还原"), 8299, "分布式数据库"), 8300, "分布式数据库保证数据库的稳定安全及读写速率，可在数据库受损的情况下快速还原"), 8301, "云盾防护"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8302, "公有云使用阿里云盾防护，防止黑客入侵及DDOS攻击"), 8303, "数据迁移"), 8304, "提供数据迁入及数据迁出服务"), 8305, "多服务器阵列"), 8306, "功能及服务分布在多台服务器上，确保单一服务器出错不影响其他功能模块"), 8307, "多监控平台"), 8308, "使用阿里、云智慧等多个第三方监控平台监控整个系统的运作情况，异常及时短信通知预警，运维人员7*24小时待命，确保平台稳定。"), 8309, "第三方安全扫描"), 8310, "使用Qualys等第三方平台定期扫描，寻找漏洞，并及时补救"), 8311, "大峰值访问灾备"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8312, "公有云突发大峰值访问能自动增加服务器运算量，并限制单用户带宽，确保企业用户的可访问性"), 8313, "使用企业公有云版，效率更高，管理更细"), 8314, "免费试用"), 8315, "巴别鸟可以不安装任何应用直接打开并预览200多种格式的文件。更妙的是，巴别鸟可以在打开的文件内容上直接点击建立批注，当你建立完批注后你的所有协作伙伴都能收到通知并参与进来一起讨论文件中的细节。无论是一个产品原型图，还是一个演讲稿，所有有权限的参与者都能在上面用语音、手绘、文字的形式各抒己见，并支持附件。同时，所有和你相关的工作文件的变动及讨论你都可以在动态中及时看到并直接回复，支持"), 8316, "无论是链接分享（匿名访问显示IP地址）、还是邀请及部门内访问，所有操作都有日志可以查看及管理"), 8317, "企业的执行力靠的就是纪律"), 8318, "全方位的为企业存储及协作制订规则"), 8319, "巴别鸟企业版拥有一个强大的企业管理后台，在这里，你不仅能为每一个使用成员分配空间，了解空间用量。并且能快速导入企业成员及建立组织结构、管理成员的权限、预设安全策略。还可以设置审批流程，管理标签及限制用户使用的设备。多种类型的管理员预设及分权管理在降低iT人员维护工作量的同时提升了系统安全性。多达40种可选角色权限能清晰的控制每个成员角色的责任及权限。可以说，巴别鸟拥有了目前国内网盘系统中最为强大可调的后台管理系统，帮助企业实现精细化管理。"), 8320, "企业后台管理详细功能列表"), 8321, "为保密企业定制的安全系统"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8322, "巴别鸟能提供最专业的安全保护"), 8323, "我们深知数据安全对企业的重要，也把安全放在整个系统的基础位置上。每新增一项功能，首要考虑的就是它是否有安全漏洞，对系统安全有何影响。为了用户看不见的安全，我们宁可牺牲部分系统性能，使用最麻烦的开发方式，付出更多成本。当然我们也获得了回报，巴比鸟在Qualys安全测评中获得A+评级，是国内企业网盘中得分最高的。同时争取到了对数据安全要求极高的保密企业订单。从权限分配到使用，从传输到存储，巴别鸟能提供最专业的安全保护!"), 8324, "数据安全详细功能列表"), 8325, "文件访问安全策略"), 8326, "数据传输及存储安全"), 8327, "运维安全策略 "), 8328, "成员及部门安全策略"), 8329, "请选择你想要注册的版本"), 8330, "个人版"), 8331, "个人文件存储、快速加入协作"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8332, "免费"), 8333, "满足个人基本的使用需求。简单、方便、安全。可升级至专业版获得更大存储空间及更强功能。"), 8334, "立即注册"), 8335, "企业公有云版"), 8336, "精细管理企业成员，聚焦中小企业"), 8337, "/人/月"), 8338, "充裕的存储空间，强大的后台管理及权限管控体系，独立的访问域名，为企业打造专属云服务。"), 8339, "30天免费试用"), 8340, "了解各版本差异"), 8341, "身份验证"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8342, "需要身份验证后才能加入邀请"), 8343, "于{-time-}投件"), 8344, "”经过多轮产品筛选后我们最终选择了巴别鸟作为我们数据存储核心，细致的服务和功能全面的产品是我们做出选择的原因。“"), 8345, "—中日友好医院 夏主任"), 8346, "/人/月"), 8347, "检测到您的手机号已经注册了巴别鸟专业版，若您想升级您的账户为企业版，请联系客服。"), 8348, "<p>\u60A8\u7684\u624B\u673A\u53F7\u5DF2\u7ECF\u6CE8\u518C\u4E86\u5DF4\u522B\u9E1F\uFF0C\u8BF7\u786E\u5B9A\u662F\u5426\u628A\u8BE5\u8D26\u53F7\u5347\u7EA7\u4E3A\u4F01\u4E1A\u7248\uFF1F</p>\n<p>\u9009\u201D\u662F\u201C\u5C06\u8FDB\u884C\u5347\u7EA7\u64CD\u4F5C\uFF0C\u6B64\u64CD\u4F5C\u4E0D\u53EF\u9006\u5E76\u6709\u53EF\u80FD\u9020\u6210\u6570\u636E\u4E22\u5931\uFF0C\u8BF7\u6CE8\u610F\u5907\u4EFD\u6570\u636E\u3002</p>\n<p>\u5982\u679C\u60A8\u4E0D\u60F3\u5347\u7EA7\u8BE5\u8D26\u53F7\uFF0C\u8BF7\u9009\u201D\u5426\u201C\u540E\u6362\u4E2A\u624B\u673A\u53F7\u6CE8\u518C\u4F01\u4E1A\u7248\u3002</p>"), 8349, "可自己添加企业成员账号"), 8350, "您所操作的文件不存在或者已经被删除了"), 8351, "更新失败，该手机号已经存在"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8352, "这个手机号没有注册过巴别鸟，点击去注册我们将跳转到注册页面。如过您还有其他巴别鸟账号，可以使用其他账号登录，在设置里绑定手机号进行登录。"), 8353, "使用其他账号登录"), 8354, "去注册"), 8355, "创建了本文件"), 8356, "你没有权限或者该文件配置不支持此操作"), 8500, "将文件{-fileName-}提交到企业发送端口{-identifier-}，申请发送文件，已审核"), 8501, "发送列表"), 8502, "接收列表"), 8503, "提交日期"), 8504, "审核日期"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8505, "审核日期"), 8506, "等待发送中"), 8507, "接收日期"), 8508, "企业未设置发送端口"), 8509, "企业未设置接收端口"), 8510, "传输"), 8511, "同步"), 8512, "全部动态"), 8513, "文件批注"), 8514, "点击可后退"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8515, "点击可前进"), 8516, "操作失败，你没有权限清空该账户所有权限"), 8517, "高级"), 8518, "高级搜索"), 8519, "输入要搜索的关键字，多个关键字用空格分割"), 8520, "只显示包含全部关键字的搜索结果"), 8521, "搜索关键字"), 8522, "按创建时间或拍摄时间进行搜索"), 8523, "限定要搜索的文件更新时间"), 8524, "文件格式"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8525, "选择要搜索的文件类型"), 8526, "上传者"), 8527, "搜索范围"), 8528, "手动选择搜索文件夹"), 8529, "搜索类型"), 8530, "文件内容（全文）"), 8531, "点击选择成员"), 8532, "选择上传者"), 8533, "拍摄时间"), 8534, "尺寸"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8535, "分辨率"), 8536, "设备型号"), 8537, "色彩空间"), 8538, "地点"), 8539, "更多信息（元数据）"), 8540, "全部尺寸"), 8541, "大尺寸（4K+）"), 8542, "中尺寸（1080P）"), 8543, "小尺寸"), 8544, "最多可指定5个上传者"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8545, "office文档（包括wps文档）"), 8546, "PDF文档"), 8547, "图片文件"), 8548, "音视频文件"), 8549, "输入扩展名,多个用','隔开"), 8550, "自定义类型"), 8551, "请输入搜索关键字"), 8552, "请选择搜索类型"), 8553, "最近访问时间"), 8554, "请选择部门"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8555, "企业新建文件统计"), 8556, "取消筛选"), 8557, "拍摄地点"), 8558, "（文件最多保存30天）"), 8559, "正在加载图片元数据"), 8560, "清空失败，你没有清除剩余文件的权限"), 8561, "已执行{-cur-}/{-total-}"), 8562, "已执行{-cur-}"), 8563, "请选择您要搜索的文件夹"), 8564, "仅查看移动及复制"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8565, "接收状态由收件人确认，收件人接收后，发件人将不能更改上传的文件。"), 8566, "仅查看部门变更"), 8567, "此功能需要有短信通道支持，请联系客服人员"), 8568, "可编辑自己的文件"), 8569, ""), 8570, "从已选模板中创建"), 8571, "查看可访问当前文件（夹）的人"), 8572, "人员来源"), 8573, "仅查看文件名"), 8574, "本项目"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8575, "分享参与者"), 8576, "仅使用自定义权限"), 8577, "你没有预览该文件的权限"), 8578, "操作失败，你在该目录下没有权限创建文件夹或文件"), 8579, "标签设置"), 8580, "样式设置"), 8581, "示例"), 8582, "图标大小"), 8583, "标签背景颜色"), 8584, "标签内容"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8585, "使用默认设置"), 8588, "无背景"), 8589, "深灰"), 8590, "殷红"), 8591, "深蓝"), 8592, "紫红"), 8593, "亮黄"), 8594, "浅绿"), 8595, "浅灰"), 8596, "淡蓝"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8597, "纯黑"), 8600, "文件下载中，请稍后"), 8601, "文件下载中..."), 8602, "下载完成"), 8603, "下载完毕"), 8604, "下载成功"), 8605, "暂停下载"), 8606, "重新下载"), 8607, "待下载"), 8650, "正在导出"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 8651, "正在导出,请稍后"), 8660, "打开方式"), 8661, "共享及协作"), 8662, "整理"), 8663, "清空历史记录"), 8664, "清空历史记录"), 8665, "删除此记录"), 9500, "域控同步"), 9501, "域账号管理"), 9502, "域服务器配置"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 9503, "同步域账号"), 9504, "加入巴别鸟"), 9505, "将所有人导入巴别鸟"), 9506, "昵称"), 9507, "组织名称"), 9508, "暂未同步任何域账号"), 9509, "暂无符合条件的查询结果"), 9510, "昵称（邮箱）"), 9511, "是否巴别鸟账号"), 9512, "域服务器地址"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 9513, "登录账号"), 9514, "登录密码"), 9515, "链接测试"), 9516, "连接成功"), 9517, "导入中..."), 9518, "导入成功"), 9519, "导入失败，请稍后重试"), 9520, "同步中..."), 9521, "连接失败，请修改参数后重试"), 9522, "暂无域账号"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 9600, "很抱歉，我们不支持超过100个文件或大小超过500MB的文件夹打包下载。您可以打开文件夹单个下载文件，或联系超级管理员获取客户端进行下载"), 9900, "点击更换图片验证码"), 9901, "私有云入口"), 9902, "使用邮箱或手机密码登录"), 9904, "登录私有云"), 9905, "请输入您所在企业的域名"), 9906, "企业域名"), 9907, "我已阅读并接受"), 9908, "巴别鸟积极响应国家净网行动号召，将大力整治系统中的非法内容。用户所有上传内容都将经过AI自动鉴别，有淫秽色情信息内容的账号一律自动封号，并向公安机关报备"), 9909, "设置一个密码"), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_localString_cn_part, 9950, "忽略"), 9951, "当前页面已经更新"), 9952, "区域"), 9953, "正在重置..."));
var _default = exports["default"] = localString_cn_part2;

},{"1180":1180,"1184":1184,"1454":1454}],1152:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var localString_cn_part1 = {
  0: "巴别鸟",
  1: "文件",
  2: "动态",
  3: "团队讨论",
  4: "部门讨论",
  5: "设置",
  6: "退出登录",
  7: "新建",
  8: "文件夹",
  9: "上传文件",
  10: "上级目录",
  11: "全部文件",
  12: "目录",
  13: "分享",
  14: "详情",
  15: "排序",
  16: "搜索文件，按回车确认",
  17: "我的团队",
  18: "部门及项目",
  19: "我的分享",
  20: "我加入的分享",
  21: "星标文件",
  22: "回收站",
  23: "标签",
  24: "标签管理",
  25: "访问者",
  26: "最近修改",
  27: "大小",
  28: "上传新版本",
  29: "下载",
  30: "重命名",
  31: "移动",
  32: "删除",
  33: "复制到",
  34: "添加星标",
  35: "查看版本",
  36: "置顶",
  37: "更多",
  38: "预览",
  39: "获取访问链接",
  40: "查看详情",
  41: "创建于",
  42: "批注",
  43: "未读批注",
  44: "点赞",
  45: "标签管理",
  46: "点击{-tagMgr-}可设置标签在此处显示",
  // {-variable-} 这一部分是将来被替换的变量
  47: "升级至专业版",
  48: "网络不通畅",
  49: "文件名",
  50: "账户管理",
  51: "个人资料",
  52: "更改密码",
  53: "忘记密码",
  54: "存储空间",
  55: "我的空间",
  56: "已用空间",
  57: "剩余空间",
  58: "个人私有文件占用空间",
  59: "团队占用空间",
  60: "参与分享占用空间",
  61: "用户类型",
  62: "免费版用户",
  63: "个人通知",
  64: "接受巴别鸟发送邮件到我的邮箱",
  65: "团队管理",
  66: "创建团队",
  67: "删除团队",
  68: "创建者",
  69: "我",
  70: "团队成员",
  71: "添加成员",
  72: "超级管理员",
  73: "设置",
  74: "返回",
  75: "开放式链接分享",
  76: "知道此链接的任何人都可以批注",
  77: "知道此链接的任何人都可以编辑",
  78: "知道此链接的任何人都可以批注并下载",
  79: "知道此链接的人都可以查看",
  80: "复制链接",
  81: "了解权限",
  82: "访问此链接需要输入密码",
  83: "邀请共享人",
  84: "输入昵称或电子邮件",
  85: "可以编辑",
  86: "可批注并下载",
  87: "可以批注",
  88: "可以查看",
  89: "完成",
  90: "管理参与者",
  91: "已输入 {-curCount-} 人，最多 {-maxCount-} 人",
  92: "打开分享链接和邀请分享后，可以分别控制和管理每个受邀共享者的访问权限",
  93: "禁止编辑者修改权限和添加新用户",
  94: "",
  95: "查看通过链接访问的人员",
  96: "关闭链接分享",
  97: "邀请共享用户",
  98: "查找受邀用户",
  99: "分享时间",
  100: "左侧栏显示标签",
  101: "左侧栏暂无标签显示，可再次点击 {-newTag-} 或从“{-allTag-}”中拖拽标签至此添加到左侧栏标签",
  102: "全部标签",
  103: "我使用过的标签",
  104: "他人共享的标签",
  105: "暂无标签，可点击{-addTag-}",
  106: "添加标签",
  107: "可通过拖拽将标签添加至{-leftTag-}",
  108: "正在生成预览文件，请稍后再试",
  109: "文字批注",
  110: "版本信息",
  111: "隐藏批注",
  112: "全屏",
  113: "共{-num-}个批注",
  114: "当前文档批注",
  115: "当前文档未读批注",
  116: "全部批注",
  117: "未读批注",
  118: "输入批注内容",
  119: "设置为完成",
  120: "删除",
  // ---- 删除批注调用
  121: "{-second-}秒前",
  122: "点击添加回复",
  123: "回车快速回复",
  124: "回复",
  125: "清屏",
  126: "你添加了图文批注",
  128: "评论",
  129: "语音批注",
  130: "手绘批注",
  131: "已完成",
  132: "未完成",
  133: "通过",
  134: "驳回",
  135: "根目录",
  136: "打开所在目录",
  137: "我上传的",
  138: "仅标签",
  139: "专业版",
  140: "反馈",
  141: "下载iOS App",
  142: "下载安卓App",
  143: "下载桌面版",
  144: "我的关注",
  145: "文件收集箱",
  146: "我的审批",
  147: "标签添加成功",
  148: "标签添加失败，请稍后重试",
  149: "移除标签成功",
  150: "移除标签失败，请稍后重试",
  151: "文件已取消分享或您已经不在此分享中",
  152: "权限不足",
  153: "针对当前文件夹，您没有此操作权限!",
  154: "确定",
  155: "取消",
  156: "关闭",
  157: "您收到新的消息",
  158: "名称",
  159: "所在目录",
  160: "当前文件夹为空",
  161: "提示：你可以在此",
  162: "或者",
  163: "新建文件夹",
  164: "在您的文件或文件夹中，找不到与此搜索条件相符的结果",
  165: "请尝试其它搜索条件",
  166: "未读",
  167: "您没有打开该文件的权限",
  168: "操作失败，请检查网络或者F5刷新页面后重试",
  169: "您已失去对该文件的操作权限，此页面即将关闭",
  170: "提示",
  171: "拖放至此立即移动到当前目录",
  172: "拖放至此立即上传到当前目录",
  173: "暂时只支持文件上传",
  174: "共{-count-}个批注",
  175: "{-count-}个未读",
  176: "截止日期",
  177: "无",
  178: "外部文件",
  179: "点击查看访问者",
  180: "设置文件收集箱",
  181: "启动审批",
  182: "查看审批",
  183: "取消置顶",
  184: "将文件置顶",
  185: "讨论组",
  186: "管理团队",
  187: "查看团队",
  188: "文件已被我锁定",
  189: "文件已被 {-user-} 锁定",
  190: "分享人 {-user-}",
  191: "已分享",
  192: "已打开邀请分享",
  193: "已打开链接分享",
  194: "分享自{-user-}",
  195: "链接分享已关闭",
  196: "获取分享链接地址",
  197: "请进入文件夹选择其中的文件进行查看！",
  198: "个人版不支持文件收集箱，请升级到企业版！",
  199: "只有企业版支持文件审批功能，您可以开启企业版使用此功能",
  200: "该讨论组只允许指定的人进入，请联系管理员",
  201: "你并没有加入该分享讨论组，请点击分享获取分享链接，通过链接进入",
  202: "企业成员",
  203: "管理成员",
  204: "内部成员",
  205: "外部人员",
  206: "在线用户",
  207: "查看详情",
  208: "超级管理员",
  209: "管理",
  210: "档案管理员",
  211: "企业拥有者",
  212: "添加超级管理员",
  213: "管理超级管理员",
  214: "账户",
  215: "联系方式",
  216: "身份",
  217: "操作",
  218: "添加档案管理员",
  219: "管理档案管理员",
  220: "警告",
  221: "确认删除{-user-}的超级管理员身份",
  222: "确认删除{-user-}的档案管理员身份",
  223: "不能在当前频道创建文件!",
  224: "同步管理",
  225: "文件加密上传中...",
  226: "上传完毕",
  227: "窗口关闭后，文件会取消上传，确认关闭吗?",
  228: "待上传...",
  229: "重传",
  230: "上传完毕，正在生产预览文件...",
  231: "已取消",
  232: "上传失败",
  233: "空间超限",
  234: "上传成功",
  235: "批注列表",
  236: "全屏",
  237: "隐藏批注",
  238: "编辑文件",
  239: "演播",
  240: "分享文件",
  241: "请了解",
  242: "查看点赞人员",
  243: "取消关注",
  244: "提醒关注",
  245: "显示更多标签",
  246: "标签删除成功",
  247: "标签添加成功",
  248: "赞",
  249: "请填写标签名",
  250: "同名标签已存在",
  251: "选择要提醒的人或直接输入",
  252: "输入评论",
  253: "所有人",
  254: "暂时没有评论",
  255: "无权评论该文件",
  256: "审批",
  257: "永久删除",
  258: "标记已读",
  259: "开启审批",
  260: "重新开启审批",
  261: "审批中(点击查看进度)",
  262: "文件访问控制",
  263: "锁定文件",
  264: "解锁文件",
  265: "打开所在文件夹",
  266: "打开本地文件夹",
  267: "同步到本地",
  268: "取消同步",
  269: "新建文本文件",
  270: "新建 Word 文档",
  271: "新建 Excel 文档",
  272: "新建 PPT 文档",
  273: "markdown文件",
  274: "文件(夹)",
  275: "总占用空间",
  276: "请选择单个文件或文件夹，查看详细信息",
  277: "通用",
  278: "说明",
  279: "类型",
  280: "删除人",
  281: "删除时间",
  282: "版本",
  283: "第{-index-}个版本",
  284: "查看历史版本",
  285: "文件已锁定",
  286: "关注者",
  287: "访问统计",
  288: "查看文件日志",
  289: "批注数量",
  290: "下载次数",
  291: "访问次数",
  292: "访问人数",
  293: "访问人员",
  294: "包含",
  295: "正在计算",
  296: "创建时间",
  297: "修改时间",
  298: "无版本信息!",
  299: "当前",
  300: "设置为当前版本",
  301: "版本说明",
  302: "HTML 文件不支持点击此处查看历史版本，您可以通过修改当前版本后重新打开文件！",
  303: "该文件已定稿，不能删除版本",
  304: "确定要删除选中的版本吗?",
  305: "删除成功",
  306: "删除失败",
  307: "文件正在审批，请先结束审批！",
  308: "操作成功",
  309: "操作失败",
  310: "您没有设置当前版本的权利",
  311: "当前文档已定稿，不允许修改版本",
  312: "确定删除该批注点？",
  313: "全部",
  314: "@我",
  315: "刚刚",
  316: "{-num-}分钟前",
  317: "{-num-}小时前",
  318: "{-num-}天前",
  319: "昨天",
  320: "前天",
  321: "{-num-}周前",
  322: "{-num-}个月前",
  323: "{-num-}年前",
  324: "5年前",
  325: "文件传输",
  326: "回复信息, Shift+Enter 换行",
  327: "换行",
  328: "确定要删除选中的文件吗",
  329: "提示:文件删除后将在回收站中保留10天，分享文件会直接删除。",
  330: "这个目录是空的",
  331: "文件下载中，请耐心等待...",
  332: "团队文件",
  333: "隶属于团队",
  334: "部门文件",
  335: "隶属于部门",
  336: "企业共享文件夹",
  337: "企业文件",
  338: "查看分享设置",
  339: "清除所有",
  340: "暂时没有新消息",
  341: "请求邀请{-num-}人加入{-file-}",
  342: "拒绝",
  343: "文件已删除或不存在",
  344: "请求打开链接分享",
  345: "邀请您共同管理文件收集箱",
  346: "同意",
  347: "消息已删除",
  348: "巴别鸟系统通知",
  349: "消息通知",
  350: "我收到的消息",
  351: "请求加入团队",
  352: "开启了文件收集箱",
  353: "请您尽快投件",
  354: "邀请你去审批文件",
  355: "提醒你关注文件(夹)",
  356: "在文件 {-name-} 的 {-object-} 中@了你",
  357: "内容",
  358: "开启了文件 {-name-} 的演播",
  359: "您所购买的巴别鸟服务于{-endTime-}到期,请及时续费,以免影响您的使用，谢谢。",
  360: "对文件 {-name-} 发起了审批，并抄送给你",
  361: "附言:",
  362: "返回上一级目录",
  363: "搜索",
  364: "共 {-num-} 个",
  365: "搜索文件，按回车键确认",
  366: "Word 文档",
  367: "Excel 文档",
  368: "PPT 文档",
  369: "文本文件",
  370: "文件收集箱",
  371: "当前频道不支持创建文件",
  372: "平铺",
  373: "列表",
  374: "文件详情",
  375: "团队详情",
  376: "文件夹目录",
  377: "查看参与我分享的人",
  378: "清空回收站",
  379: "回收站中的文件将会永久删除，确认要清空吗?",
  380: "警告:此行为无法撤销!",
  381: "企业控制台",
  382: "外部人员",
  383: "最近访问文件",
  384: "访问",
  385: "提醒你关注",
  386: "分享给你",
  387: "全部文件夹",
  388: "个人私有文件夹",
  389: "来自{-user-}的分享",
  390: "保存到巴别鸟",
  391: "请先输入分享文件的密码",
  392: "文件已成功保存到您的巴别鸟中",
  393: "请先登录或输入打开分享文件的密码",
  394: "密码",
  395: "您输入的密码不对，请重新输入",
  396: "所有者",
  397: "本公司",
  398: "外部公司",
  399: "个人",
  400: "查看参与者",
  401: "你没有邀请用户加入分享的权限，但你可以填写拟邀请人员，系统会发送请求给该文件的管理者来进行邀请",
  402: "已邀请",
  403: "...等{-num-}人。",
  404: "获取邀请人失败",
  405: "被邀请者必须使用邀请邮箱注册才能查看内容",
  406: "发送",
  407: "参与者",
  408: "打开分享以允许其他人查看此文件",
  409: "链接",
  410: "链接和密码已拷贝到剪贴板",
  411: "链接已拷贝到剪贴板",
  412: "请按 ⌘+C  拷贝链接",
  413: "请按 Ctrl+C 拷贝链接",
  414: "设置私密分享失败，请稍后重试",
  415: "扫描二维码快速加入",
  416: "扫描二维码加入",
  417: "打开微信",
  418: "点击底部的“发现”",
  419: "使用“扫一扫”",
  420: "打开巴别鸟",
  421: "点击底部的“全部文件”",
  422: "使用右上角加号中的“扫码加入”",
  423: "所有者未开启此文件链接分享",
  424: "请求开启",
  425: "留言请求有分享权限的人开启链接分享，即可获得此文件的分享链接地址。",
  426: "添加留言",
  427: "还可以输入 {-num-} 个字",
  428: "发送请求",
  429: "请求链接分享",
  430: "请求打开 {-file-} 的链接分享",
  431: "留言",
  432: "待启动",
  433: "定稿",
  434: "审批中",
  435: "服务器没有设置该值",
  436: "正常",
  437: "暂不支持该文档",
  438: "正在生成预览文件，请稍后再试",
  439: "生成预览失败！",
  440: "文档有密码，请解除密码再次上传",
  441: "文件损坏或者文件不完整",
  442: "文件非常大，拒绝生成预览文件",
  443: "演示文稿中是空的，没有任何一页幻灯片",
  444: "可通过双击将此标签从左侧栏移除，或拖拽放回到“全部标签”",
  445: "左侧栏暂无标签显示，可在此点击",
  446: '或从"全部标签"中拖拽标签至此添加到左侧栏标签',
  447: "拖放至此添加至左侧栏",
  448: "拖放至此从左侧栏移除此标签",
  449: "发现同名文件",
  450: "当前文件夹已存在名称为 {-fileName-} 的文件！",
  451: "取消上传",
  452: "自动重命名继续上传",
  453: "作为该文件的新版本上传",
  454: "提示：暂不支持大小超过 {-size-} 的文件上传",
  455: "文件大小不得超过",
  456: "正在向巴别鸟云端网盘上传文件。如果您离开此页面，某些文件可能会无法上传。",
  457: "个人版暂不支持文件夹上传，请升级",
  458: "请输入要搜索的或要新建的标签名称",
  459: "建立批注",
  460: "此批注所有分享参与人可见",
  461: "此批注仅企业内部参与人可见",
  462: "此批注仅自己可见",
  463: "你附加了图文批注",
  464: "设为已完成",
  465: "文件发送失败",
  466: "手绘线条",
  467: "矩形框",
  468: "直线",
  469: "箭头",
  470: "文本",
  471: "颜色",
  472: "线宽",
  473: "字号",
  474: "撤销",
  475: "重做",
  476: "在此输入批注，也可以手绘下面的图片",
  477: "加载更多",
  478: "请选择审批人员",
  479: "我的分组",
  480: "常用联系人",
  481: "消息主题",
  482: "发布人昵称",
  483: "登录",
  484: "注册",
  485: "邮箱或手机号",
  486: "登录 - 巴别鸟",
  487: "使用短信验证码登录",
  488: "手机号",
  489: "短信验证码",
  490: "使用邮箱或手机密码登录",
  491: "其它方式登录:",
  492: "微信登录",
  493: "忘记密码?",
  494: "登录企业版",
  495: "请输入您所在企业的域名",
  496: "企业域名",
  497: "去登录",
  498: "←登录个人版",
  499: "注册 - 巴别鸟",
  500: "确认表示您同意我们的",
  501: "隐私政策",
  502: "和",
  503: "服务条款",
  504: "请输入验证码以继续",
  505: "图片验证码",
  506: "部门成员管理",
  507: "很抱歉，巴别鸟免费版只能创建2个团队，要创建更多团队，请升级至专业版",
  508: "审批列表",
  509: "发起人",
  510: "获取审批信息失败",
  511: "审批文件",
  512: "审批信息已改变",
  513: "该文件为直接定稿文件，无审批人员",
  514: "已通过",
  515: "未开始",
  516: "正在审批中...",
  517: "已驳回",
  518: "该文件已被驳回，可通过上传新版本重新开启审批",
  519: "当前阶段您还不能进行审批",
  520: "已审批",
  521: "文件已驳回，审批结束",
  522: "审批已完成",
  523: "抄送者",
  524: "结束审批",
  525: "重新填写审批结论",
  526: "我的结论",
  527: "审批结论",
  528: "发起审批",
  529: "审批通过后的文件状态为定稿，审批中和定稿后的文件不能编辑及上传新版本",
  530: "不审批直接定稿",
  531: "提交开启审批",
  532: "新增审批阶段",
  533: "审批组",
  534: "抄送组",
  535: "预设流程",
  536: "审批人员",
  537: "如不需要按顺序审批(会签方式)，可将全部审批人员添加到阶段1",
  538: "请选择审批流程",
  539: "审批分阶段进行，阶段1完成后阶段2的人员才能收到审批通知，以此类推",
  540: "审批者可以看到参与讨论的成员信息及文件上所有批注",
  541: "添加的审批流程在文件审批时可以直接选择，并快速开启审批",
  542: "为流程取个名字，方便使用",
  543: "修改审批流程",
  544: "模板名已存在",
  545: "保存失败，请重试",
  546: "团队讨论是以团队为单位的群组，在这里大家可以展开讨论，协同工作。",
  547: "新建团队",
  548: "提示: 部门消息为空。",
  549: "文件不存在！",
  550: "文件夹在回收站中，不能打开！",
  551: "文件不存在，可能已经被移走！",
  552: "文件已被删除！",
  553: "打开目标文件夹",
  554: "创建了部门",
  555: "成为部门新成员",
  556: "被更名为",
  557: "最大空间被修改为",
  558: "所属部门被修改为",
  559: "被移出了部门",
  560: "角色 被设置为",
  561: "加入了团队",
  562: "拒绝加入团队",
  563: "被踢出讨论",
  564: "退出了团队",
  565: "申请加入团队",
  566: "邀请了",
  567: "移除了",
  568: "文件已经开启过审批！",
  569: "未审批",
  570: "待审批",
  571: "文件动态",
  572: "此回复所有人可见",
  573: "回复批注",
  574: "此回复仅企业内人员可见",
  575: "共享成员",
  576: "分组",
  577: "用户",
  578: "重复添加，此人已在列表中",
  579: "搜索昵称/邮箱/手机",
  580: "企业分组",
  581: "编辑分组",
  582: "企业分组为空",
  583: "个人分组为空",
  584: "请填写名称",
  585: "名称不能为空",
  586: "名称长度不能超过100个字符",
  587: "企业版基础服务",
  588: "即将到期",
  589: "已经过期",
  590: "请及时{-pay-}",
  591: "查看订单",
  592: "企业版",
  593: "当前{-edition-}服务有效期至{-date-}",
  594: "服务续费",
  595: "续费服务内容包括",
  596: "服务内容",
  597: "单位（元）",
  598: "数量",
  599: "金额（元）",
  600: "请选择续费时长（按年计算）",
  601: "已选续费时长",
  602: "年",
  603: "{-edition-}续费服务内容有效期至{-date-}",
  604: "需支付服务费用合计",
  605: "元",
  606: "需要发票",
  607: "提交订单",
  608: "支付",
  609: "升级服务",
  610: "专业版服务管理",
  611: "企业版服务管理",
  612: "个人订单",
  613: "企业订单",
  614: "全部订单",
  615: "提交时间",
  616: "开始日期",
  617: "结束日期",
  618: "订单名称",
  619: "年数",
  620: "状态",
  621: "全部项目",
  622: "账户升级",
  623: "空间扩展",
  624: "账户续费",
  625: "年",
  626: "未支付",
  627: "待验证",
  628: "已支付",
  629: "确定删除此订单?",
  630: "订单号",
  631: "订单内容",
  632: "删除订单",
  633: "确定取消以下订单记录",
  634: "取消订单",
  635: "升级为专业版账户",
  636: "企业版扩展空间服务",
  637: "专业版扩展空间服务",
  638: "企业版续费服务",
  639: "专业版续费服务",
  640: "企业账户",
  641: "个人账户",
  642: "取消订单失败，非订单创建者不能取消订单",
  643: "更多订单查询，请点击{-more-}",
  644: "服务有效期至",
  645: "发票抬头",
  646: "发票寄送信息",
  647: "如您有任何疑问， 请立即联系客服或销售人员。邮箱：support@molasync.com 电话：400-9204020",
  648: "安全退出",
  649: "最多添加{-max-}个，已添加{-num-}个",
  650: "此操作不会对已选择的企业拥有者及用户自身生效",
  651: "确认{-act-}已选中账户?",
  652: "上一步",
  653: "在线人数",
  654: "已选用户",
  655: "批量重置密码",
  656: "批量设定个人存储空间上限",
  657: "输入存储空间上限，用户存储超过限制将无法上传",
  658: "批量管理账户",
  659: "批量更改部门和权限",
  660: "公司",
  661: "访问文件所属部门",
  662: "邀请人",
  663: "提示 : 没有外部人员",
  664: "添加外部人员",
  665: "请输入昵称",
  666: "该邮箱已经是本企业内部成员",
  667: "该邮箱已经是本企业外部成员",
  668: "该邮箱已经注册为巴别鸟账号，可以输入余下信息，确认添加",
  669: "新增成员将在邮箱或手机中收到注册信息",
  670: "登录成功后可以修改密码",
  671: "新增企业用户",
  672: "部门不能为空",
  673: "该账户已经在本企业中",
  674: "权限设置",
  675: "选择角色",
  676: "所有角色",
  677: "请选择用户",
  678: "已定稿（点击查看结果）",
  679: "已驳回（点击查看结果）",
  680: "不能上传新版本",
  681: "确定取消分享吗?",
  682: "提示:取消分享后，分享链接将失效。",
  683: "锁定文件将只允许自己上传新版本",
  684: "锁定失败，已被他人锁定",
  685: "文件恢复中",
  686: "文件已经恢复至原处",
  687: '文件已经恢复，但是其所在父文件夹 "{-folder-}" 还在回收站中<br>',
  688: "恢复失败，该文件的上级文件夹已经被永久删除",
  689: "文件删除后将无法恢复,确定要删除吗?",
  690: "文件删除中",
  691: "加锁成功",
  692: "文件已被 {-userName-} 锁定，您不能编辑!",
  693: "我们在试图锁定文档的时候发生了错误<br>请稍后再试",
  694: "含有共享文件(夹)的，请先关闭其分享",
  695: "尚未添加任何标签",
  696: "可通过拖拽或双击将标签添加至左侧栏显示",
  697: "投件",
  698: "收件",
  699: "收件人",
  700: "企业在线办公平台",
  701: "进行中",
  702: "已结束",
  703: "我发起的",
  704: "没有任何文件(夹)",
  705: "提示 : 您可以清空回收站来释放空间",
  706: "请选择文件或文件夹，查看详细信息",
  707: "输入文字标记...",
  708: "开启水印",
  709: "输入昵称,邮箱,或手机号",
  710: "未注册用户",
  711: "发送中...",
  712: "{-somebody-}是该文件所在部门的成员，无需邀请即可以直接访问该文件，你是否想要提醒他们关注该文件？",
  713: '关闭"{-file-}“的链接分享',
  714: "关闭链接分享后，知道该链接的人将无法访问，<br>同时所有该目录下的子链接也将关闭",
  715: '关闭"{-file-}"的邀请分享',
  716: "链接分享未开启",
  717: "前往开启",
  718: "关闭邀请分享后，受邀用户将全部移除。<br>文件本身及其子目录内容也将从受邀用户账号移除",
  719: "所有者未开启链接分享",
  720: "发送请求",
  721: "关闭邀请分享",
  722: "匿名用户",
  723: "注册用户",
  724: "重置密码",
  725: "知道此链接的任何人都可以{-do-}",
  726: "设置分享截止日期",
  727: "发送分享参与动态信息给通过链接加入者",
  728: "成功设置7天后自动关闭！",
  729: "访问密码",
  730: "打印",
  731: "不可见",
  732: "访问时间",
  733: "",
  734: "",
  735: "",
  736: "",
  737: "",
  738: "",
  739: "",
  740: "",
  741: "在新的标签页打开",
  742: "文件太大不支持预览，请下载查看！",
  743: "我有注册账号",
  744: "去登录",
  745: "添加日期",
  746: "文件对比",
  747: "外部人员",
  748: "创建标签",
  749: "选择标签",
  750: "筛选面板",
  751: "图层列表",
  752: "此处所设置的权限会自动应用到所有子文件和子文件夹",
  753: "在这个文件夹中您没有权限上传！",
  754: "个人私有文件空间设置",
  755: "档案管理员负责审批档案借阅，不可以登录企业管理后台",
  756: "安全保密员可以在前台看到并管理所有部门的文件，可以登录企业管理后台。但在企业后台中仅限以下权力：制定公司安全策略(安全保密员独有权限)、管理组织结构、成员管理、权限管理",
  757: "安全审计员可以登录企业管理后台，但在企业后台中仅限以下权利：查看企业安全策略，查看组织结构，查看成员权限，查看权限管理，查看文件访问日志",
  758: "归档至档案库",
  759: "文件归档后，将移动到专有档案管理处，不允许修改和删除，并且文件只能到档案库界面进行访问",
  760: "企业档案库",
  761: "保存企业历史文档",
  762: "你要查看的是归档文件，需要到档案库去查看，点击确定转到档案库",
  763: "申请在线查看",
  764: "申请下载",
  765: "申请复制",
  766: "申请已经发送，请在您的申请频道关注审批结果",
  767: "申请中",
  768: "已借阅",
  769: "借阅档案",
  770: "借阅档案需要相关人员审批，审批通过后档案即可出现在“我的借阅”频道中",
  771: "申请借阅",
  772: "提交申请",
  773: "阅读方式",
  774: "借阅理由",
  775: "档案夹",
  776: "新建档案夹",
  777: "档案夹名不能为空",
  778: "你要下载的是归档文件，需要到档案库去下载，点击确定转到档案库",
  779: "有新的档案阅读申请需要您审批!",
  780: "您的档案阅读申请已审批通过!",
  781: "您的档案阅读申请已被驳回!",
  782: "归档文件需要借阅后才能查看!",
  783: "编辑部门",
  784: "部门含有子部门时不允许删除",
  785: "含有归档文件的部门不能删除",
  786: "快捷方式所指向的文件不允许下载",
  787: "手绘笔",
  788: "最近版本",
  789: "←登录公有云",
  790: "推荐邀请以下人员访问",
  791: "部门及项目",
  792: "你确定要从团队中移除该用户吗",
  793: "移除成员",
  794: "项目所属",
  795: "上传文件限定",
  796: "限定方式",
  797: "限定内容",
  798: "不限定",
  799: "限定扩展名",
  800: "限定文件全名",
  801: "请输入限定内容，以逗号隔开。如：jpg,jpeg",
  802: "请输入限定文件名。如：example.jpg",
  803: "管理部门成员",
  804: "0或不输入时需要所有人",
  805: "输入审批意见",
  806: "采纳此意见",
  807: "已采纳",
  808: "已拒绝",
  809: "意见",
  810: "确定删除该意见？",
  811: "拒绝此意见",
  812: "等待作者处理",
  813: "意见列表",
  814: "共{-num-}个审批意见",
  815: "意见（语音）",
  816: "意见（手绘）",
  817: "在文件 {-file-} 中采纳了 {-somebody-} 提出的 {-evaluation-}",
  818: "在文件 {-file-} 中拒绝了 {-somebody-} 提出的 {-evaluation-}",
  819: "{-somebody-}已经在文件{-file-}中签名（章）",
  820: "输入想在用户现有存储空间基础上增加的存储空间",
  821: "如需创建文件夹请登录",
  822: "点击上传文件或拖动要上传的内容到此区域完成上传",
  823: "如需实名上传或创建文件夹请登录",
  824: "如果是新上传的文件，请等待最长30分钟，待服务器更新全文搜索索引",
  825: "分享一个文件（夹）给你【{-name-}】，点击链接查看;",
  826: "来自{-user-}的投件箱",
  827: "仅专业版和企业版支持此功能",
  828: "后过期",
  829: "请输入至少5位手机号",
  830: "不允许更改企业拥有者的企业角色",
  831: "如果你修改自己的企业角色，你将失去超级管理员的权限，是否确认修改？",
  832: "文件用量",
  833: "该文件不支持批注",
  // dashboard，
  // 其中 {-  -} 所包含的内容是将来要替换变量内容
  // 以第 1000 条为例，定义对象如下
  //  var param = {
  //		'somebody'    : '李平',
  //		'parentFolder': '历史文件夹',
  //   	'folder'      : '明朝那些事'
  //  }
  //  var s = MDLocalString.getLocalString(1000, param);
  //  s 的值为
  // 		'李平 在 历史文件夹 中新建了文件夹 明朝那些事'
  //
  1000: "{-somebody-} 在 {-parentFolder-} 中新建了文件夹 {-folder-}",
  1001: "{-somebody-} 在 {-parentFolder-} 中上传了 {-fileEdition-}{-file-}",
  1002: "{-somebody-} 将 {-fileOrFolder-}{-oldName-} 的名称修改为 {-newName-}",
  1003: "新文件",
  1004: "新版本",
  1005: "等文件",
  1006: "{-somebody-} 将 {-fileOrFolder-}{-file-} 从 {-sourceFolder-} 移动到了 {-targetFolder-}中",
  1007: "{-somebody-} 从 {-folder-} 中删除了 {-file-}",
  1008: "{-somebody-} 上传了 {-file-}",
  1009: "{-somebody-} 删除了 {-file-}",
  1010: "{-file-} 的一个版本",
  1011: "{-somebody-} 从回收站中恢复了 {-file-}",
  1012: "{-somebody-} 在 {-folder-} 中移入了 {-file-}",
  1013: "{-somebody-} 从 {-folder-}  中移出了  {-file-}",
  1014: "{-somebody-}  设置了 {-file-}  的当前版本",
  1015: "{-somebody-} 将以下文件 {-file-} 复制到了  {-folder-} 中",
  1016: "{-somebody-} 对 {-file-} 点了赞",
  1017: "{-somebody-} 取消了对 {-file-} 的点赞",
  1018: "{-somebody-} 对 {-file-} 进行了 {-review-}",
  1019: "{-somebody-} 提醒你关注 {-file-}",
  1020: "{-somebody-} 取消了你对 {-file-} 的关注",
  1021: "{-somebody-} 加入了分享 {-file-}",
  1022: "{-somebody-} 从分享 {-file-} 中被移出",
  1023: "{-somebody-} 退出了分享 {-file-}",
  1024: "{-somebody-} 关闭了分享 {-file-}",
  1025: "{-somebody-} 将以下人员 {-user-} 移出了分享 {-file-}",
  1026: "{-somebody-} 打开了 {-file-} 的分享链接",
  1027: "{-somebody-} 在 {-file-} 中将以下用户的权限由 {-oldRole-} 改为 {-newRole-}",
  1028: "{-somebody-} 关闭了 {-file-} 的分享链接",
  // 1029: '{-somebody-} 将 {-file-} 的分享链接权限由 {-oldRole-} 改为 {-newRole-}',
  1029: "{-somebody-} 将 {-file-} 的链接分享权限由 {-oldRole-} 改为 {-newRole-}",
  1030: "{-somebody-} 在 {-file-} 中添加了 {-comment-}",
  1031: "{-somebody-} 在 {-file-} 中回复了 {-comment-}",
  1032: "{-somebody-} 在 {-file-} 的批注中上传了文件",
  1033: "{-somebody-} 从 {-file-} 中删除了一个 {-commentType-}",
  1034: "{-somebody-} 将 {-file-} 中的一个 {-comment-} 设置为 {-finish-}",
  1035: "{-somebody-} 将 {-file-} 的第 {-No.-} 号版本的版本说明修改为 {-remark-}",
  1036: "{-somebody-} 开放了文件收集箱 {-file-}",
  1037: "请您尽快投递文件，截止日期 {-time-}",
  1038: "{-somebody-} 更新了文件收集箱 {-file-} 的设置",
  1039: "{-somebody-} 邀请你去审批 {-file-}",
  1040: "并附言：{-comment-}",
  1041: "{-file-} 已经审批通过",
  1042: "{-file-} 没有通过审批，已被驳回！",
  1043: "{-somebody-} 已经 {-pass-}{-file-}",
  1044: "{-somebody-} 邀请以下人员 {-user-} 加入了分享 {-file-}",
  1045: "{-somebody-} 在 {-folder-} 中上传了 {-file-}",
  1046: "{-somebody-} 在 {-folder-} 中上传了 {-file-} 的一个新版本",
  1047: "{-somebody-} 给 {-file-} 添加了相关文件 {-destinationFile-}",
  1048: "等 {-count-} 个文件（夹）",
  1049: "{-somebody-} 对 {-file-} 进行了归档",
  1050: '<p class="title">确定要删除部门：{-department-}  ？</p><p class="mgt-20 Cred">提醒：部门内文件及部门成员关系将全部删除</p>',
  1051: "{-somebody-} 对部门 {-depName-}中的文档 {-file-} 进行了归档",
  1052: "，并留言：{-leaveMessage-}",
  1053: "管理员",
  1054: "撤回审批",
  1055: "撤回审批会清除该文件所有审批记录，是否确认撤回审批？",
  1056: "{-somebody-} 撤销了{-file-} 的审批流程",
  1057: "{-somebody-} 在 {-parentFolder-} 中新建了档案夹 {-folder-}",
  1058: "{-somebody-} 在 {-file-} 中将以下用户的权限由项目助理改为普通成员，权限是 {-newRole-}",
  // web browser message
  1500: "说:",
  1501: "发送了一个文件",
  1502: "绘制了一条手绘批注",
  1503: "发送了一条语音批注",
  1504: "创建了文件夹{-fileName-}",
  1505: "上传了{-fileEdition-}:{-fileName-}",
  1506: "将{-file-}重命名为{-newName-}",
  1507: "加入了讨论",
  1508: "退出了团队: {-teamName-}",
  1509: "将 {-user-} 移出了团队：{-teamName-}",
  1510: "退出了讨论",
  1511: "你已被移出团队 {-teamName-}",
  1512: "你已被移出分享 {-shareName-}",
  1513: "分享了 {-file-}",
  1514: "关闭了团队 {-teamName-}",
  1515: "将团队{-file-}的成员{-user-}的角色由{-oldRole-} 改为 {-newRole-}",
  1516: "将分享{-file-}的参与者{-user-}的角色由{-oldRole-} 改为 {-newRole-}",
  1517: "@你:",
  1518: "在文件{-file-}上添加了一个批注",
  1519: "添加了",
  1520: "回复了",
  1521: "在批注中上传了一个参考文件",
  1522: "将文件{-file-}中的一个批注设置为完成",
  1523: "将文件{-file-}中的一个批注设置为未完成",
  1524: "移入了文件{-file-}",
  1525: "移出了文件{-file-}",
  1526: "你被移出了部门 {-department-}",
  1527: "将 {-user-} 移出了部门 {-department-}",
  1528: "你被添加到了部门 {-department-}",
  1529: "将 {-user-} 添加到了部门 {-department-}",
  1530: " 邀请你加入团队 {-team-}",
  1531: " 邀请你加入分享 {-file-}",
  1532: " 将你从分享邀请{-file-}中移出了",
  1533: " 将文件{-file-}的版本说明修改为{-remark-}",
  1534: " 将{-file-}移入了{-folder-}",
  1535: "将项目{-project-}移交到了{-department-}中",
  1536: "新的项目负责人：{-user-}",
  1537: "创建了档案夹{-fileName-}",
  1538: "(下载)",
  1539: "将项目{-project-}负责人改为了{-user-}",
  1540: "已加载{-num-}个，共{-total-}个",
  1541: "已全部加载，共{-total-}个",
  1542: "正在加载中",
  1543: "将项目{-project-}转为父项目",
  //-------------------------------------- 分享等 alert 提示

  2000: "管理员修改了您在{-depName-}中的角色为 {-role-}",
  2001: "当前部门已被转移，此页面即将关闭",
  2002: "管理员修改了您对此文件的操作权限，您当前权限为 {-role-}",
  2003: "默认权限",
  2004: "查看文件",
  2005: "查看",
  2006: "上传",
  2007: "仅上传",
  2008: "显示批注",
  2009: "上一篇",
  2010: "文件导航",
  2011: "第{-fileNo-}个文件，共{-fileCount-}个文件",
  2012: "下一篇",
  2013: "正在演播",
  2014: "演播模式",
  2015: "发起演播后，当前文档的围观的观众的屏幕显示文档的内容将与您同步",
  2016: "确认要放弃围观？",
  2017: "确认要关闭演播？",
  2018: "正在发送",
  2019: "发送失败",
  2020: "当前演播已被关闭",
  2021: "有人向你发送语音请求，但是本地环境没准备好",
  2022: "用户机器没有语音设备",
  2023: "no security",
  2024: "用户禁止了语音请求",
  2025: "启动语音失败，语音通话需要 https 协议",
  2026: "有人想和你进行语音通话，但是你并没有打开语音",
  2027: "添加批注",
  2028: "矩形框批注",
  2029: "圆形批注",
  2030: "箭头批注",
  2031: "标签标注",
  2032: "开启演播",
  2033: "主讲人",
  2034: "转换主讲人",
  2035: "关闭演播",
  2036: "围观",
  2037: "不再围观",
  2038: "请输入聊天信息",
  2039: "观众",
  2040: "粉笔",
  2041: "板擦",
  2042: "管理员修改了您对此文件的操作权限",
  2043: "文件总数",
  2044: "下属部门文件数量统计",
  2045: "没有上传文件",
  2046: "提示：此人在当前部门没有上传任何文件",
  2047: "提示：此人在当前文件夹没有上传任何文件",
  2048: "上传文件列表",
  2049: "查看此人在部门内上传的文件",
  2050: "查看此人在分享中上传的文件",
  2051: "各部门文件数量统计",
  2052: "确定要删除这些笔画吗",
  2053: "确定要删除此人的所有笔画吗？",
  2054: "无效的输入值",
  2055: "该目录下没有符合搜索条件的文件！",
  2056: "全部用户",
  // -------------------------------- 前台设置
  2300: "账户信息",
  2301: "密码设置",
  2302: "通知设置",
  2303: "专业版基础服务",
  2304: "即将到期",
  2305: "已经过期",
  2306: "续费",
  2307: "请及时{-dosomething-}。",
  2308: "企业版用户",
  2309: "个人版用户",
  2310: "专业版用户",
  2311: "到期时间",
  2312: "订单详情",
  2313: "有效天数",
  2314: "修改头像",
  2315: "手机",
  2316: "未绑定",
  2317: "绑定",
  2318: "绑定邮箱后，可及时收到通知",
  2319: "昵称",
  2320: "暂不支持在线升级,请联系客服：",
  2321: "获取空间信息失败",
  2322: "上传头像",
  2323: "绑定手机号",
  2324: "手机号绑定成功",
  2325: "请输入手机号",
  2326: "手机号格式错误",
  2327: "验证码不能为空",
  2328: "请输入密码",
  2329: "请输入6-20位包含大小写字母及数字的组合",
  2330: "修改昵称",
  2331: "请输入昵称",
  2332: "修改邮箱",
  2333: "请输入新邮箱",
  2334: "修改手机号",
  2335: "请输入新手机号",
  2336: "短信验证码",
  2337: "邮箱验证码",
  2338: "绑定邮箱",
  2339: "请输入邮箱",
  2340: "邮箱格式错误",
  2341: "您尚未绑定邮箱或手机号，绑定后您可以以邮箱(手机号)加密码的方式登录。",
  2342: "旧密码",
  2343: "新密码",
  2344: "确认密码",
  2345: "重置",
  2346: "密码修改成功",
  2347: "旧密码错误",
  2348: "您还未登录",
  2349: "网络拥塞,请稍后重试",
  2350: "请输入旧密码",
  2351: "请输入新密码",
  2352: "请输入确认密码",
  2353: "两次输入的密码不一致",
  2354: "请勾选您想接收的消息类型",
  2355: "文件上传",
  2356: "文件批注",
  2357: "分享的人员管理",
  2358: "您目前尚未绑定邮箱，可能无法收到通知，请尽快绑定您的邮箱。",
  2359: "去绑定",
  2360: "初始化登录密码",
  2361: "请输入验证码",
  2362: "企业公共分组",
  2363: "新建分组",
  2364: "暂无分组",
  2365: "个人私有分组",
  2366: "获取分组信息失败，请稍后重试",
  2367: "确定要删除此分组？",
  2368: "分组名称不能为空",
  2369: "确定要将此成员移出分组？",
  2370: "分组名",
  2371: "分组成员",
  2372: "分组成员为空",
  2373: "请输入分组名称",
  2374: "首页",
  2375: "上一页",
  2376: "下一页",
  2377: "尾页",
  2378: "页",
  2379: "跳转到 {-no.-} 页",
  2380: "项",
  2381: "创建文件收集箱",
  2382: "设置文件收集箱",
  2383: "从企业成员列表或者分组中添加",
  2384: "个人分组",
  2385: "获取短信验证码",
  2386: "获取用户空间信息获取失败",
  2387: "没有需要被转移的文件",
  2388: "所有角色",
  2389: "修改部门",
  2390: "暂未加入部门",
  2391: "输入昵称或文件名",
  2392: "选择文字水印方式",
  2393: "分享者的名字",
  2394: "使用注册账户水印",
  2395: "使用注册账户水印后，文件的水印显示为查看者的注册账户，匿名用户访问显示分享者水印。",
  2396: "请输入邮箱、手机号或者昵称",
  2397: "保密档案，除了创建者和部门经理外其他人不可见",
  2398: "限制档案，除了创建者和本部门经理外其他人不能借阅",
  2399: "内部档案，只有档案所在部门内人员可以借阅",
  2400: "文件目录",
  2401: "访问次数",
  2402: "次",
  2403: "文件所有权不属于你，无权彻底删除",
  2404: "从企业成员列表中添加",
  2405: "确定要将此部门移出分组？",
  //-------------------------------------- 胡继超新增

  2500: "投件人",
  2501: "{-somebody-} 开启了文件{-file-}的审批，并抄送给你",
  2502: "已到期",
  2503: "编辑",
  2504: "当前文件夹",
  2505: "文件类型",
  2506: "全文搜索",
  2507: "仅文件名",
  2508: "部门管理",
  2509: "基础权限",
  2510: "文件权限设置",
  2511: "文件权限截止日期",
  2512: "点击查看文件访问控制",
  2513: "地址绑定",
  2514: "开启mac地址绑定",
  2515: "开启mac地址绑定后，绑定mac地址的账号无法在其他mac地址上访问客户端。（网页端不受限制）",
  2516: "绑定列表",
  2517: "mac地址池",
  2518: "新增绑定",
  2519: "没有绑定记录",
  2520: "提示: 当前没有mac地址绑定记录,你可以通过点击“新增绑定”按钮,绑定员工的mac地址",
  2521: "没有符合条件的绑定记录",
  2522: "提示: 你可以更改搜索条件,重新进行搜索",
  2523: "绑定的mac地址",
  2524: "绑定的mac地址池",
  2525: "客户端在线状况",
  2526: "当前mac地址",
  2527: "绑定mac地址",
  2528: "最多添加{-max-}个,已添加{-num-}个",
  2529: "输入绑定的mac地址",
  2530: "部门人员",
  2531: "分组人员",
  2532: "多个地址用空格键或者逗号分隔,留空为不绑定（AA:AA:AA:AA:AA:AA）",
  2533: "选择mac地址池",
  2534: "新建一个mac地址池",
  2535: "mac地址池是事先设定好的mac地址组合，以实现快捷管理。如果没有设定，可以点击“{-text-}”建立一个。选择“无”表示不绑定mac地址池",
  2536: "新增",
  2537: "警告： 批量编辑将清空之前的绑定记录，按新的规则进行mac地址的重新绑定",
  2538: "内含mac地址个数",
  2539: "客户端在线数量",
  2540: "编辑mac地址池",
  2541: "mac地址池名称",
  2542: "编辑mac地址",
  2543: "输入需要增加的mac地址",
  2544: "多个地址用空格键，换行或者逗号分隔",
  2545: "创建mac地址池",
  2546: "输入mac地址池名称：此处不允许重名",
  2547: "输入mac地址",
  2548: "新增mac地址池",
  2549: "解除绑定",
  2550: "绑定当前地址",
  2551: "名称已存在",
  2552: "你的输入的地址中{-msg-}不符合mac地址的格式，提交后会被过滤，是否继续此操作",
  2553: "暂无mac地址，请点击”批量增加地址“向该地址池中添加mac地址",
  2554: "批量增加新地址",
  2555: "请选择mac地址池",
  2556: "了解安全级别",
  2557: '绝密文件，<span class="gray">默认除了创建者、项目负责人、文件负责人和部门经理外部门内其他人不可见，分享该文件必须获得安全保密员授权</span>',
  2558: '限制文件，<span class="gray">一般人员只读，分享该文件必须获得上级主管授权</span>',
  2559: '内部文件，<span class="gray">分享该文件给部门外人员，必须获得上级主管授权</span>',
  2560: "以上三种文件，不支持链接分享仅支持邀请分享",
  2561: "提示: 当前没有mac地址池,你可以通过点击“新增mac地址池”按钮,添加mac地址池",
  2562: "设备管理",
  2563: "于",
  2564: "在线设备",
  2565: "当前设备",
  2566: "退出",
  2567: "你确定退出该设备的登录吗",
  2568: "巴别鸟客户端",
  2569: "巴别鸟网页",
  2570: "给你发送了文件",
  2571: "点击此处下载",
  2572: "该文件已被删除",
  2573: "文件受内部保护，被邀请人员需要该文件部门负责人审批，申请已经发送，请耐心等待",
  2574: "{-sign-}了你对文件{-fileName-}的分享请求",
  2575: "开放级别",
  2576: "所限部门",
  2577: "绝密文件，限制文件，一般人员不能移动/复制/上传新版本/下载/重命名/查看版本，上级主管和有部门文件管理权限的人员才可以",
  2578: "点击查看分组人员",
  2600: "快速发送文件",
  2601: "选择或输入文件接受者邮箱地址",
  2602: "邮件存储",
  2603: "使用巴别鸟存储我的邮件",
  2604: "域名",
  2605: "请输入要代收邮箱的域名",
  2606: "端口号",
  2607: "请输入要代收邮箱端口号",
  2608: "同步邮件",
  2609: "同步邮件可能需要花费几分钟时间，你可以离开此页面继续其他工作",
  2610: "大窗口显示",
  2611: "全选",
  2612: "请输入代收邮箱的账号",
  2613: "追加文件权限",
  2614: "文件权限设置统计",
  2615: "控",
  2616: "设置邮箱",
  2617: "巴别鸟可以在部门文件中管理文件访问权限，右键点击部门文件选择“文件访问控制”可以更改文件的访问权限。更改访问权限后的文件及文件夹可以在这里统一管理",
  2618: "非本企业部门人员",
  2619: "你没有查看该文件的权限",
  2620: "巴别鸟可以存储你设定的邮箱邮件及附件，打开邮件存储按钮后设置需要存储的邮箱，你的邮件及附件将会保存在“我的邮箱”目录中",
  2621: "访问控制",
  2622: "暂无内容",
  2623: "创建快捷方式",
  2624: "导出文件列表",
  2625: "快捷方式",
  2626: "同步中",
  2627: "放大",
  2628: "缩小",
  2629: "适应屏幕",
  2630: "设置邮箱成功后，点击“同步邮件”开始接收",
  2631: "授权码",
  2632: "请输入授权码（登录QQ邮箱，设置--账户，开启POP3服务，生成授权码）",
  2633: "拉选放大",
  2634: "提示 : 没有在线的外部人员",
  2635: "该账户已经注册为巴别鸟账号，请输入其他邮箱或手机",
  2640: "端口号只允许输入数字",
  2650: "超级管理员",
  2651: "部门经理",
  2652: "在线阅读",
  2653: "复制",
  2654: "文件统计",
  2655: "活跃文件",
  2656: "系统活跃度",
  2657: "部门范围",
  2658: "时间范围",
  2659: "请选择文件类型",
  2660: "全部类型",
  2661: "该部门暂无文件",
  2662: "本周",
  2663: "本月",
  2664: "本季度",
  2665: "本年",
  2666: "一年内",
  2667: "两年内",
  2668: "文件活跃度统计",
  2669: "访问次数",
  2670: "请选择时间范围",
  2671: "各部门文件个数",
  2672: "级部门",
  2673: "文件夹访问人次",
  2674: "文件访问人次",
  2675: "显示手绘笔迹列表",
  2676: "文件说明",
  2677: "回收站设置",
  2678: "文件在回收站的保留时间",
  2679: "请输入天数",
  2680: "注：文件在回收站的保留时间可以自由修改为1 - 999 天",
  2681: "天",
  2682: "在文档中查找…",
  2683: "查找词语上一次出现的位置",
  2684: "查找词语后一次出现的位置",
  2685: "上一处",
  2686: "下一处",
  2687: "查找",
  2688: "高亮显示",
  2689: "整词匹配",
  2690: "区分大小写",
  2691: "{-somebody-} 将文件（夹）{-file-} 的负责人由 {-from-} 改为 {-to-}",
  2692: "该分组名已存在",
  2693: "给你分享了文件",
  2694: "设置截止日期",
  2695: "去除截止日期",
  //----------------2700  归档
  2700: "档案",
  2701: "我的访问申请",
  2702: "借阅审批",
  2703: "最近修改日期",
  2704: "归档人",
  2705: "没有归档文件(夹)",
  2706: "企业档案",
  2707: "未处理",
  2708: "申请日期",
  2709: "申请内容",
  2710: "审批状态",
  2711: "审批人",
  2712: "审批",
  2713: "审批日期",
  2714: "未审批(下拉选择)",
  2715: "我的借阅",
  2716: "没有借阅文件(夹)",
  2717: "没有文件(夹)的借阅申请",
  2718: "部门审批状态",
  2719: "企业审批状态",
  2720: "申请人",
  2721: "申请理由",
  2722: "部门审批",
  2723: "企业审批",
  2724: "归还",
  2725: "你确定归还此文件吗？",
  2726: "{-somebody-} 申请{-type-} {-depName-} 中的档案文件(夹){-file-}，并附言：{-comment-}",
  2727: "{-somebody-} 通过了你对文件档案文件(夹){-file-} 的借阅申请",
  2728: "{-somebody-} 拒绝了你对文件档案文件(夹){-file-} 的借阅申请",
  2729: "所在目录",
  2730: "你没有权限借阅该文件",
  2731: "档案查看记录",
  2732: "归还日期",
  2733: "搜索申请人，回车键确认",
  2734: "搜索文件名，回车键确认",
  2735: "申请起止日期",
  //----手绘

  2736: "隐藏手绘笔迹",
  2737: "手绘列表",
  2738: "查看手绘笔迹",
  2739: "{-somebody-} 在文件(夹){-file-}中添加了手绘笔迹",
  2740: "{-somebody-} 在文件(夹){-file-}中删除了手绘笔迹",
  //------图形工具
  2741: "图形工具",
  2742: "基本",
  2743: "选择你需要插入的图形，在图纸相应位置点击即可插入",
  2744: "保存焊接图标",
  2745: "{-somebody-} 在文件(夹){-file-}中添加了焊接图标",
  2746: "{-somebody-} 在文件(夹){-file-}中删除了焊接图标",
  //------
  2747: "文件负责人",
  2748: "转换负责人",
  2749: "设置文件负责人",
  2750: "搜索昵称或邮箱",
  2800: "部门内所有人",
  2801: "部门内所有未设置追加权限的普通成员",
  2802: "请输入附言",
  2803: "不设置({-name-}-继承)",
  2804: "子文件中有设置附加权限，是否要覆盖原有设置？（覆盖后，所有子文件的追加权限都会重置为当前追加权限）",
  2805: "覆盖",
  2806: "追加",
  2810: "新建项目",
  2811: "新建子项目",
  2812: "项目信息",
  2813: "请输入项目名称",
  2814: "负责人",
  2815: "点击选择负责人",
  2816: "项目成员",
  2817: "选择项目负责人",
  2818: "选择项目成员",
  2819: "暂无项目成员，您可以点击“添加人员”逐个邀请成员加入项目。也可以点击确定按钮新建项目完成后右键点击“管理项目”在项目管理面板中点击“获取邀请链接地址”获得一个地址并复制（扫码）分发给想要加入的人或群组",
  2820: "项目转交",
  2821: "当前所属部门",
  2822: "当前负责人",
  2823: "目标部门",
  2824: "目标负责人",
  2825: "转交",
  2826: "项目类型",
  2827: "项目",
  2828: "子项目",
  2829: "转为子项目",
  2830: "转为父项目",
  2831: "目标项目",
  2832: "选择目标项目",
  2833: "管理项目",
  2834: "请选择目标项目",
  2835: "项目信息填写不完整",
  2836: "请求邀请人员加入文件（夹）{-file-}的分享",
  2837: "在该部门没有创建项目的权限",
  2838: "选择目标部门（项目）",
  2839: "该项目中含有子项目，操作失败！",
  // 2332: '目标项目',
  // 2603: '请输入要代收的邮箱',

  2840: "部门内的分享",
  2841: "部门内追加权限文件",
  2842: "管理分享文件",
  2843: "注：此处显示部门内设置了访问控制的所有文件",
  2844: "当前部门暂无文件被设置访问控制",
  2845: "查看分享",
  2846: "关闭分享",
  2847: "分享人",
  2848: "所在文件夹",
  2849: "部门内的分享",
  2850: "部门内所有分享文件",
  2851: "当前目录没有打开分享的文件(夹)",
  2852: "密级",
  2853: "密级文件统计",
  2854: "部门内没有特殊密级的文件",
  2855: "部门内所有密级文件",
  2856: "密级文件统计",
  2857: "消息取消失败，（已超时）",
  2858: "消息取消失败，（请刷新后重试）",
  2859: "该部门内含有 {-count-} 个分享文件，是否关闭分享？",
  2860: "邮件通知设置",
  2861: "动态接收设置",
  2862: "接收以下通知",
  2863: "密切相关通知",
  2864: "相关通知",
  2865: "弱相关通知",
  2866: "我上传的文件",
  2867: "我评论过的文件",
  2868: "我关注的文件",
  2869: "我参与分享的文件",
  2870: "同一个部门的文件",
  2871: "子部门文件",
  2872: '文件"{-name-}"中含有以下非法字符，请改名后重新上传： "{-str-}"',
  2873: '文件"{-fileName-}"上传失败，文件收集箱"{-name-}"仅允许上传扩展名为"{-str-}"的文件',
  2874: '文件"{-fileName-}"上传失败，文件收集箱"{-name-}"仅允许上传文件名为"{-str-}"的文件',
  2875: "按成员设置权限",
  2876: "按角色设置权限",
  2877: "给部门角色追加文件访问权限（仅对该文件或文件夹及其子文件生效）",
  2878: "授权人数：{-count-}",
  2879: "服务授权",
  2880: "你的个人空间占用率已超过90%，可以联系超级管理员扩容空间",
  2881: "联系手机",
  //------------------------------------- 企业后台

  3000: "企业设置",
  3001: "企业配置",
  3002: "组织结构",
  3003: "成员管理",
  3004: "权限管理",
  3005: "标签管理",
  3006: "审批管理",
  3007: "企业通知",
  3008: "分组管理",
  3009: "水印设置",
  3010: "企业编号",
  3011: "已认证",
  3012: "未认证",
  3013: "基本信息",
  3014: "企业联系人",
  3015: "企业logo",
  3016: "域名管理",
  3017: "企业空间",
  3018: "扩展空间",
  3019: "批量修改成员个人空间限制",
  3020: "企业用户",
  3021: "邮件通知",
  3022: "关闭此项，即禁止企业版邮件提醒功能",
  3023: "企业简称",
  3024: "企业简称可显示于顶部标题栏，同时也是企业根部门名称",
  3025: "企业名称",
  3026: "企业名称可填写企业全称，会显示于登录界面",
  3027: "注册邮箱",
  3028: "绑定手机",
  3029: "昵称",
  3030: "邮箱",
  3031: "手机",
  3032: "选择图片",
  3033: "支持上传jpg，jpeg，png，bmp格式并小于 5MB的图片。",
  3034: "域名地址",
  3035: "巴别鸟企业空间",
  3036: "企业版服务有效期至",
  3037: "添加部门",
  3038: "搜索部门",
  3039: "查看部门文件访问日志",
  3040: "直属成员按角色分类，可编辑管理。下级分属成员请点击查看，到相应的位置管理",
  3041: "角色/组织",
  3042: "移动此部门",
  3043: "添加子部门",
  3044: "删除此部门",
  3045: "-对部门职能的简要说明-",
  3046: "上级部门",
  3047: "部门创建人",
  3048: "创建日期",
  3049: "子部门",
  3050: "成员",
  3051: "企业空间配置",
  3052: "部门空间配置",
  3053: "已占用",
  3054: "查看部门文件",
  3055: "剩余空间",
  3056: "企业成员配置",
  3057: "部门成员配置",
  3058: "管理账户",
  3059: "转移文件归属",
  3060: "转移至",
  3061: "管理员有权将成员账号文件转移至另一成员",
  3062: "停用账户",
  3063: "恢复",
  3064: "停用",
  3065: "停用账户使其不能登录本企业(可恢复)",
  3066: "删除账户",
  3067: "账户删除后，其个人文件也将移除（在部门中的文件会保留），执行此操作请慎重",
  3068: "上次登录",
  3069: "权限管理",
  3070: "修改",
  3071: "成员身份",
  3072: "私有文件用量",
  3073: "昵称",
  3074: "性别",
  3075: "男",
  3076: "女",
  3077: "联系方式",
  3078: "入职时间",
  3079: "备注",
  3080: "保存",
  3081: "取消",
  3082: "已停用",
  3083: "修改密码",
  3084: "邮箱",
  3085: "所属部门",
  3086: "角色",
  3087: "新增角色",
  3088: "巴别鸟允许一个人在多个部门使用不同角色",
  3089: "个人私有文件空间上限",
  3090: "个人私有文件",
  3091: "您可以在这里管理企业内部所有角色的权限，并且新增特定的角色，选择权限后点击确定即时生效。（别人的文件是指部门内别人上传的文件，自己的文件是指部门内自己上传的文件）",
  3092: "部门管理权限",
  3093: "移动至",
  3094: "部门名称",
  3095: "部门描述",
  3096: "确认",
  3097: "选择部门",
  3098: "请选择上级部门",
  3099: "请填写部门名称",
  3100: "该部门名称已存在",
  3101: "所有部门",
  3102: "限制此部门空间用量",
  3103: "取消勾选限制,则此部门可占用空间量在其所属部门可用空间量范围内不受限制",
  3104: "可供设置空间总量",
  3105: "此部门已占用空间",
  3106: "空间限制 ",
  3107: "文件访问日志",
  3108: "查看访问者",
  3109: "搜索昵称或文件...",
  3110: "查看所有记录",
  3111: "仅查看访问记录",
  3112: "仅查看上传下载",
  3113: "仅查看匿名用户",
  3114: "部门内文件",
  3115: "开启分享文件",
  3116: "文件日志",
  3117: "将修改以下 {-length-} 个员工部门和角色",
  3118: "批量修改部门",
  3119: "提交",
  3120: "占用",
  3121: "在线",
  3122: "离线",
  3123: "冻结",
  3124: "没有员工",
  3125: "提示 : 当前部门没有内部成员",
  3126: "没有符合条件的员工",
  3127: "提示 : 您可以更改条件重新搜索",
  3128: "昵称(账户)",
  3129: "文件归属",
  3130: "员工管理",
  3131: "选择成员",
  3132: "确认从该部门下移除?",
  3133: "您不能删除其他人创建的账号!",
  3134: "账号已经删除",
  3135: "确认{-prompt-}已选中账户?",
  3136: "上传企业成员文件",
  3137: "设置初始密码",
  3138: "执行导入",
  3139: "下一步",
  3140: "点击上传",
  3141: "上传填写好的成员信息",
  3142: "仅支持 excel 文件，大小不要超过2M ",
  3143: "下载模板",
  3144: "随机密码",
  3145: "用户登录时系统会提示修改密码",
  3146: "正在执行导入...",
  3147: "导入完成",
  3148: "未知错误",
  3149: "网络错误",
  3150: "导入失败",
  3151: "发送消息",
  3152: "发送消息",
  3153: "查看消息",
  3154: "请输入消息接收人",
  3155: "企业内消息，可以发送给企业全体成员或者指定成员",
  3156: "标题",
  3157: "请输入标题",
  3158: "消息内容",
  3159: "请输入消息内容",
  3160: "还可输入",
  3161: "字",
  3162: "接收人",
  3163: "请选择接收人",
  3164: "请输入邮箱",
  3165: "新增发布人",
  3166: "删除发布人",
  3167: "点击查看详情",
  3168: "没有公告",
  3169: "提示 : 没有历史公告信息",
  3170: "发布人",
  3171: "主题",
  3172: "时间",
  3173: "发布人管理",
  3174: "",
  3175: "搜索消息主题",
  3176: "查看消息",
  3177: "请选择成员",
  3178: "成员",
  3179: "确认删除审批模板 {-name-} ",
  3180: "没有发布人",
  3181: "昵称(账户)",
  3182: "所属部门-角色",
  3183: "提示 : 没有发布人信息",
  3184: "发布人信息获取失败",
  3185: "审批流程",
  3186: "添加审批流程",
  3187: "确认删除审批模板 {-name-}",
  3188: "没有审批",
  3189: "提示 : 没有审批信息",
  3190: "流程名称",
  3191: "审批者",
  3192: "使用次数",
  3193: "添加分组",
  3194: "确认删除分组 {-name-}",
  3195: "分组已删除",
  3196: "删除分组失败",
  3197: "没有分组",
  3198: "提示 : 没有分组信息",
  3199: "分组名",
  3200: "包含人员个数",
  3201: "创建人",
  3202: "选择用户",
  3203: "筛选",
  3204: "批量设定所选用户空间上限",
  3205: "输入想设定的存储空间大小后点击保存按钮，所有所选用户的存储空间上限将会重置为你输入的数字,输入数字为0表示不限制。",
  3206: "批量增加所选用户的存储上限",
  3207: "增加",
  3208: "增加用户存储空间操作可以在用户现有空间基础上为用户增加额外的存储空间以扩展用户的存储空间上限。",
  3209: "实例：A用户空间上限为20G，B用户空间上限为50G，选择AB两用户批量增加50G存储空间，点击“增加”按钮后A用户的空间上限调整为70G，B用户的空间上限调整为100G。",
  3210: "符合",
  3211: "的用户共{-totalNum-}名，{-onlineNum-}人目前在线。可在右侧列表进行批量处理。",
  3212: "批量编辑",
  3213: "昵称(账户)",
  3214: "本次登录时间",
  3215: "部门",
  3216: "",
  3217: "企业在线用户",
  3218: "高级选项",
  3219: "收起",
  3220: "请选择投件人",
  3221: "请选择其他收件人",
  3222: "文件收集箱名称不能为空",
  3223: "文件收集箱附言不能为空",
  3224: "截止日期不能为空",
  3225: "文件收集箱主要用于收集文件，让投件人上传文件到文件收集箱中，你可以在文件收集箱名称和附言中说明此次文件收集的目的和注意事项",
  3226: "文件收集箱名称",
  3227: "其他收件人",
  3228: "其他收件人和您一样，可以查看批注文件收集箱内的所有投件",
  3229: "创建",
  3230: "请选择投件人",
  3231: "请选择日期",
  3232: "使用水印",
  3233: "打开水印功能并设置后，指定带水印的文件在预览时都会显示水印",
  3234: "关闭水印",
  3235: "选择水印使用范围",
  3236: "所有文件",
  3237: "所有对外分享文件",
  3238: "由文件分享者设定",
  3239: "使用文字水印",
  3240: "自定义文字",
  3241: "水印展现位置",
  3242: "斜角平铺",
  3243: "文件中部",
  3244: "文件头尾",
  3245: "水印不透明度",
  3246: "效果预览",
  3247: "支持*.png文件，推荐分辨率200*300",
  3248: "使用图片水印",
  3249: "上传水印图片 (PNG)",
  3250: "右下角",
  3251: "加载中",
  3252: "角色成员数量统计",
  3253: "确认删除文件权限",
  3254: "水印图片",
  3255: "水印预览",
  3256: "提示 : 没有内部成员",
  3257: "所属部门-角色",
  3258: "用户空间上限修改成功",
  3259: "修改失败，服务器端错误",
  3260: "管理员权限修改失败，服务器端错误",
  3261: "昵称不能为空",
  3262: "部门重复",
  3263: "确认要删除员工- <span class='f-emph'> {-name-} </span> - 的账号吗？",
  3264: "该员工的所有个人文件会一并清除",
  3265: "确认要停用员工- <span class='f-emph'> {-name-} </span> - 的账号吗？",
  3266: "企业角色更改成功",
  3267: "企业角色更改失败，请稍后重试",
  3268: "新增成员",
  3269: "",
  3270: "从内部成员添加",
  3271: "删除账号",
  3272: "从该部门移除",
  3273: "批量导入成员",
  3274: "警告!",
  3275: "该操作将把所有者的文件转移到其他用户的巴别鸟账户中，并清空所有者企业账号中的所有个人文件。此操作不可逆，文件转移后，文件所有者将变更为转入对象。",
  3276: "所有者",
  3277: "文件分类",
  3278: "文件大小",
  3279: "点击选择一名员工",
  3280: "的账户",
  3281: "从内部成员列表添加",
  3282: "文件信息",
  3283: "确认删除部门",
  3284: "删除该部门后部门下的文件也会一并被删除",
  3285: "部门-角色",
  3286: "日期",
  3287: "保存位置",
  3288: "其他位置",
  3289: "选择文件夹",
  3290: "下载文件",
  3291: "隐藏",
  3292: "你确认取消文件的{-name-}下载吗",
  3293: "撤销此操作",
  3294: "请输入内容",
  3295: "你已成功创建批注",
  3296: "创建批注失败，请检查网络或者重新刷新页面",
  3297: "回复批注失败，请检查网络或者重新刷新页面",
  3298: "获取批注列表失败，请检查网络或者重新刷新页面",
  3299: "获取文件失败，请重新刷新页面尝试",
  3300: "空间选择失败，请稍后再试",
  3301: "空间选择失败，24小时内只能改变一次，请稍后再试",
  3302: "保留了那些不能退出的分享文件！",
  3303: "提交中",
  3304: "访问此链接需要输入密码",
  3305: "取消密码失败，请稍后重试",
  3306: "密码设置成功",
  3307: "设置密码失败，请稍后重试",
  3308: "请输入标签名称",
  3309: "同名标签已存在",
  3310: "编辑标签",
  3311: "共有<strong>{-quoteNum-}</strong>个文件引用此标签",
  3312: "仅更新我创建的文件引用",
  3313: "更新企业里所有使用该标签的文件引用",
  3314: "上传文件失败",
  3315: "打开讨论组",
  3316: "部门成员",
  3317: "新增部门",
  3318: "用户 {-name-} 是未注册用户，是否确认邀请该人加入分享？",
  3319: "比较",
  3320: "比较或合并文档",
  3321: "请选择文件进行内容比较或合并",
  3322: "原文档",
  3323: "选择文档",
  3324: "选择其他文件",
  3325: "该文件目前还没有其他版本",
  3326: "您可以{-other-}进行比较或合并",
  3327: "从该文件的其他版本中选择",
  3328: "进行文档比较",
  3329: "进行文档合并",
  3330: "选择本地文件",
  3331: "打开",
  3332: "设置为未通过",
  3333: "你确认将此文件夹的审批状态设置为‘未通过’吗？",
  3334: "密",
  3335: "限",
  3336: "内",
  3337: "安全级别",
  3338: "企业文件安全策略",
  3339: "了解安全策略",
  3340: "继承父部门安全策略",
  3341: "策略名称",
  3342: "上传文件的默认级别",
  3343: "是否所有分享都要审批",
  3344: "分享的审批人",
  3345: "是否默认策略",
  3346: "绝密",
  3347: "一级保密",
  3348: "二级保密",
  3349: "普通",
  3350: "公开",
  3351: "保密",
  3352: "限制",
  3353: "内部",
  3354: "公开",
  3355: "是",
  3356: "否",
  3357: "安全保密员",
  3358: "上级主管",
  3359: "默认",
  3360: "部门文件安全策略",
  3361: "添加安全保密员",
  3362: "管理安全保密员",
  3363: "确认删除{-user-}的安全保密员身份",
  3364: "安全审计员",
  3365: "添加安全审计员",
  3366: "管理安全审计员",
  3367: "确认删除{-user-}的安全审计员身份",
  3368: "提示：",
  3369: "你确定要删除当前地址池吗",
  3370: "",
  3380: "上传部门成员文件",
  3381: "",
  3382: "图片水印不支持斜角平铺",
  3383: "English",
  3384: "仅客户端访问",
  3385: "绑定mac地址的用户，只能访问客户端，不能访问APP和网页端",
  3386: "只允许企业控制台创建和管理标签",
  3387: "重置密码",
  3388: "重置",
  3389: "点击发送重置密码的链接地址到用户的邮箱",
  3390: "重置密码的邮件已发送至用户邮箱",
  3391: "请选择文件进行内容查看比较",
  3392: "用户 {-name-} 是未注册用户，是否确认给此人发送分享链接？",
  3393: "没有操作日志",
  3394: "提示：还没有人访问文件",
  3395: "没有符合条件的操作日志",
  3396: "您可以{-other-}进行查看比较",
  3397: "隐藏管理员访问日志",
  3398: "打开此项后，前台文件的访问记录中非管理员将不能看到管理员的访问记录",
  3399: "统计分析",
  3400: "点击显示此人在部门内上传的文件",
  3401: "点击显示此人在团队中上传的文件",
  3402: "上传日志",
  3403: "点击显示此人在项目内上传的文件",
  3404: "被访问的文件夹数量",
  3405: "被访问的文件数量",
  3406: "访问文件夹的人数",
  3407: "访问文件的人数",
  3408: "个人文件占用",
  3410: "创建子部门",
  3411: "删除子部门",
  3412: "修改子部门",
  3413: "回收站管理",
  3414: "管理文件访问控制",
  3415: "归档文件	",
  3416: "文件密级管理",
  3417: "批示分享请求",
  3418: "转换文件负责人",
  3419: "审批管理",
  3420: "给自己文件上传新版本",
  3421: "给自己文件重命名",
  3422: "给别人文件上传新版本",
  3423: "给别人文件重命名",
  3424: "部门内成员管理",
  3425: "文件负责人模式",
  3426: "启用该模式，文件的负责人要对自己负责的文件负全责，即自动拥有管理该文件的权利，而不受自己在部门角色的影响。但是对于非自己负责的文件来说，权限仍然受自己的部门角色限制。默认自己上传到部门中的文件（夹）自己就是负责人，但是如果上传到别人负责的文件夹中，则文件的负责人就不是自己了。负责人自己和部门管理成员有权转换文件的负责人。如果关闭该模式，则文件负责人的权限和普通人一样，完全受部门角色限制。",
  3427: "部门角色列表",
  // 3419: '',
  // 3419: '',
  // 3419: '',
  // 3419: '',
  3428: "操作人",
  3429: "你确定要关闭这些文件的分享吗？",
  3430: "字段不能为空",
  3431: "部门审批流程",
  3432: "当前审批流程策略",
  3433: "编辑修改",
  3434: "部门审批流程设置",
  3435: "设置本部门的成员发起审批时如何使用审批流程",
  3436: "可选全部预制审批流程",
  3437: "限用特定审批流程",
  3438: "与父部门限制相同",
  3439: "本组至少有",
  3440: "人通过，审批才可以通过",
  3441: "没有备选的审批流程模板",
  3442: "去创建",
  3443: "工作台推送",
  3444: "从下方列表选取成员",
  //----------	5.8*-------------
  3445: "阅览室",
  3446: "创建阅览室",
  3447: "只有放到阅览室的档案和档案夹才能被普通成员看到并借阅",
  3448: "开放级别",
  3449: "限定部门",
  3450: "请输入部门名称",
  3451: "编辑阅览室",
  3452: "添加相关文件",
  3453: "相关文件列表",
  3454: "暂无相关文件",
  3455: "从企业部门列表中添加",
  3456: "暂无成员",
  3457: "暂无",
  3458: "阅览室含有子文件",
  3459: "下载定稿PDF",
  3460: "下载带水印PDF",
  3461: "导出报表",
  3462: "当前筛选条件下，需要导出日志条数超过2000条，系统仅会导出前2000条，确定继续导出吗？",
  3463: "导出",
  3464: "{-somebody-} 申请{-type-} 档案文件(夹){-file-}，并附言：{-comment-}",
  //-------------------5.9-------------

  3465: "下载成员报表",
  3466: "对应目录不存在，打开失败",
  3467: "全文搜索，按回车键确认",
  3468: "搜索文件名，按回车键确认",
  3469: "可以邀请任意人员加入该项目文件夹，默认创建者为项目负责人（可以通过转交项目指定新的负责人）；当前项目阶段完成后，项目负责人可以选择转交该项目给下一个阶段的负责人，使得该文件夹可以跨越部门进行流转",
  //---------------6.0------------------

  3470: "暂无被冻结账户",
  3471: "需要借阅",
  3472: "限定部门内可借阅",
  3473: "限定部门内公开",
  3474: "阅览室内文件所有人可见，用户可直接对阅览室内文件进行查看、下载等操作",
  3475: "阅览室内文件所有人可见，用户需要借阅后，才能对阅览室内文件进行查看、下载等操作",
  3476: "部门内公开指定部门内成员可见，用户可直接对阅览室内文件进行查看、下载等操作",
  3477: "阅览室仅指定部门内成员可见，用户需要借阅后，才能对阅览室内文件进行查看、下载等操作",
  3478: "项目负责人",
  3479: "允许匿名上传（在线编辑）",
  3480: "允许匿名上传后，如果有人在该文件夹下匿名上传违规文件，责任由分享发起者担负",
  3481: "需要设置截止日期",
  3482: "去设置",
  3483: "你的账户已被系统冻结，恢复账号请联系客服人员，点击确认退出",
  //------------------6.1------------------

  3484: "企业上传统计",
  3485: "暂无符合条件的用户",
  3486: "文件访问统计",
  3487: "人员",
  3488: "总量",
  3489: "阅读文件",
  3490: "批注讨论",
  3491: "查询",
  3492: "暂无符合条件的查询结果",
  3493: "已用去{-days-}天",
  3494: "仅剩余{-days-}天",
  3495: "已过期{-days-}天",
  3496: "用时{-days-}天",
  3497: "请选择所选成员的默认角色",
  3498: "企业所有文件夹",
  3499: "当前日期",
  /***************** 错误提示 *********************/
  3500: "添加失败，请稍后重试",
  3501: "获取部门信息失败",
  3502: "部门空间修改成功",
  3503: "部门空间修改失败，请稍后重试",
  3504: "设定值等于已占用空间，将无法上传新内容",
  3505: "角色修改成功",
  3506: "角色修改失败，请稍后重试",
  3507: "添加成功",
  3508: "添加人员失败，请稍后重试",
  3509: "成员已从该部门移除",
  3510: "移除失败，请稍后重试",
  3511: "确认删除该账号?",
  3512: "账户已停用",
  3513: "停用账户失败",
  3514: "账户已恢复",
  3515: "恢复账户失败",
  3516: "发布成功",
  3517: "发布失败，请重试",
  3518: "发布人已删除",
  3519: "确认删除已选中发布人",
  3520: "删除失败，请重试",
  3521: "历史公告获取失败",
  3522: "删除失败，服务器端错误",
  3523: "审批信息获取失败",
  3524: "添加分组成功",
  3525: "分组信息获取失败",
  3526: "服务器端错误，获取管理员失败",
  3527: "确认删除-<strong>{-name-}</strong>的管理员身份",
  3528: "增加存储空间上限成功",
  3529: "增加存储空间上限失败",
  3530: "修改存储空间上限成功",
  3531: "修改存储空间上限失败",
  3532: "在线内部成员信息获取失败",
  3533: "在线外部人员信息获取失败",
  3534: "访问的链接不存在，返回管理",
  3535: "创建文件收集箱失败！",
  3536: "修改失败或者无权限",
  3537: "获取角色信息失败",
  3538: "添加角色失败，请稍后重试",
  3539: "修改角色信息失败，请稍后重试",
  3540: "删除角色信息失败，请稍后重试",
  3541: "角色名不能和已有名称重复",
  3542: "获取企业水印信息失败，请稍后重试",
  3543: "水印范围设置成功",
  3544: "水印范围设置失败，请稍后重试",
  3545: "文字水印设置成功",
  3546: "文字水印设置失败，请稍后重试",
  3547: "图片水印设置成功",
  3548: "图片水印设置失败，请稍后重试",
  3549: "水印关闭成功",
  3550: "水印关闭失败，请稍后重试",
  3551: "已选择",
  3552: "重新上传图片",
  3553: "上传图片",
  3554: "企业信息获取失败，请稍后重试",
  3555: "企业用户信息获取失败，请稍后重试'",
  3556: "保存成功",
  3557: "信息格式错误，请重试",
  3558: "对不起，您没有权限操作",
  3559: "保存失败，请稍后重试",
  3560: "企业logo上传失败，请稍后重试",
  3561: "打开邮件提醒失败，请稍后重试",
  3562: "关闭邮件提醒失败，请稍后重试",
  3563: "内部成员信息获取失败",
  3564: "角色替换",
  3565: "将企业内所有人拥有的某个角色替换为新角色",
  3566: "旧有角色",
  3567: "",
  3568: "",
  3569: "替换为",
  3570: "角色替换成功",
  3571: "角色替换失败，请稍后重试",
  3572: "请选择",
  3573: "建立一个新角色",
  3574: "从已有角色复制",
  3575: "访问日志",
  3576: "下载失败",
  3577: "查看文件",
  3578: "下载进度",
  3579: "选择图片",
  3580: "头像预览",
  3581: "文件大小超过{-size-}MB，请重新选择",
  3582: "文件类型错误",
  3583: "图片水印只支持png格式",
  3584: "未分享",
  3585: "<span> {-folderCount-} 个文件夹</span><span class='mgl-10'> {-fileCount-} 个文件</span>",
  3586: "文件收集箱创建成功",
  3587: "标签删除中",
  3588: "删除失败，你没有删除权限",
  3589: "删除失败，未知错误",
  3590: "标签撤销成功",
  3591: "标签撤销失败",
  3592: "文件复制中",
  3593: "文件复制成功",
  3594: "文件复制失败，未知错误",
  3595: "文件复制失败，您的空间不足",
  3596: "文件撤销成功",
  3597: "文件撤销失败",
  3598: "文件夹创建成功",
  3599: "文件夹创建失败,请稍后重试",
  3600: "文件删除成功",
  3601: "文件删除失败",
  3602: "删除失败，请刷新页面后重试！",
  3603: "含有共享文件(夹)，请先关闭其分享！",
  3604: "知道了",
  3605: "恢复文件成功",
  3606: "恢复文件失败",
  3607: "错误码",
  3608: "重命名成功",
  3609: "重命名失败,稍后重试",
  3610: "恢复名称成功",
  3611: "文件恢复失败",
  3612: "移动文件",
  3613: "文件移动成功",
  3614: "含有分享文件",
  3615: "部门文件不允许移动到非部门的文件夹",
  3616: "部门文件不允许移入到个人私有文件夹",
  3617: "移动失败",
  3618: "文件恢复成功",
  3619: "文件恢复失败",
  3620: "私有文件",
  3621: "搜索角色名称",
  3622: "文件密级设置失败，请稍后重试",
  3623: "设置水印位置成功",
  3624: "设置水印位置失败",
  3625: "设置水印透明度成功",
  3626: "设置水印透明度失败",
  3627: "设置注册账户水印成功",
  3628: "设置注册账户水印失败",
  3629: "设置企业当前策略成功",
  3630: "设置部门当前策略成功",
  3631: "获取地址池信息失败，请稍后重试",
  3632: "获取mac地址绑定信息失败，请稍后重试",
  3633: "团队人数已达上线，加入失败",
  3634: "默认允许用户上传个人私有文件",
  3635: "关闭该选项，将不允许用户上传个人私有文件，已上传的个人私有文件予以保留。注：管理员可以在成员管理功能中对特定用户是否拥有个人私有文件进行特殊处理；部门文件夹以及企业共享文件夹以外的文件属于个人私有文件。",
  3636: "企业默认",
  3637: "不允许",
  3638: "允许",
  3639: "注意：上限输入 0 表示不限制其个人私有文件空间",
  3640: '文件收集箱"{-name-}"仅收取"{-str-}"文件',
  3641: "你已经是团队成员了",
  3700: "部门权限列表",
  3701: "文件权限列表",
  3702: "文件分享权限",
  3703: "申请文件{-file-}的”{-roleName-}“权限",
  3704: "并附言：",
  3705: "申请文件权限",
  3706: "发送消息",
  3707: "请选择文件",
  3708: "从现有文件选择",
  3709: "上传新文件",
  3710: "附件",
  3711: "上传附件",
  3712: "给你发送了一条消息",
  3713: "查看历史消息",
  3714: "作为消息的附件",
  3715: "发件人",
  3716: "转发",
  3717: "你有一条新的巴别鸟系统通知，点击查看详情",
  3718: "部门",
  3719: "删除本企业",
  3720: "解散",
  3721: "删除企业将删除企业所有文件，企业成员将自动变成个人版用户，这是一个不可恢复的操作，你需要输入管理员密码来执行这个操作",
  3722: "删除本账户",
  3723: "删除此账号将导致所有文件丢失，此操作不可恢复，需要慎重！你需要输入密码来执行此操作",
  3724: "进行此操作后，企业拥有者将会变为选定的目标用户，当前用户将不再是企业拥有者，请输入当前用户密码以继续此操作",
  3725: "直接拖拽文件到此处也可以上传哦",
  3726: "文件配置",
  3727: "文件黑名单",
  3728: "文件黑名单,即文件类型黑名单，加入黑名单的文件类型将不允许上传，输入您想屏蔽的文件扩展名到下面的列表即可",
  3729: "请输入加入黑名单的文件扩展名，例如jpg",
  3730: "黑名单列表",
  3731: "搜索的扩展名",
  3732: "该扩展名在黑名单中已经存在",
  3733: "暂无常用标签",
  3734: "申请文件个数不能超过10个",
  3735: "项目到期后，仅项目管理员可访问及管理该项目，如无需截止日期此项可以留空。",
  3736: "该扩展名在白名单中已经存在",
  ///////////////////////////首页

  4000: "功能",
  4001: "价格",
  4002: "解决方案",
  4003: "企业公有云版",
  4004: "资源",
  4005: "创新的企业文件管理平台，共享协作更高效",
  4006: "效率更高管理更细",
  4007: "免费试用",
  4008: "巴别鸟企业网盘，客户端上线",
  4009: "Windows+Mac双平台发布",
  4010: "同步任意文件 轻松指定",
  4011: "巴别鸟企业网盘",
  4012: "免费下载",
  4013: "文档内容协同网盘",
  4014: "免费注册",
  4015: "或 登录",
  4016: "巴别鸟企业网盘专业版上线",
  4017: '超越"个人版" ，空间更大功能更强',
  4018: "随时随地使用你的文档，协作无间",
  4019: "现在你不仅能在网页端登录，也可以通过智能手机使用巴别鸟",
  4020: "同时，你可以直接在线编辑office文档，无需安装office软件",
  4021: "下载巴别鸟客户端",
  4022: '在文件内容上直接讨论，<br class="hidden-xs">协同工作，更可编辑',
  4023: "在想交流的地方直接点击，即可开启讨论甚至可以使用语音及手绘圈画，让交流更生动高效，所有加入分享的成员可以实时回复，移动端交流更顺畅，office文档点击编辑按钮更可在线修改并自动生成新版本。",
  4024: "不必另外购买软件，<br>即可查看大多数文件",
  4025: "支持近200种格式的文件无需下载任何应用程序，无论常用的office，苹果专属的iWork，在巴别鸟中都能直接打开。连设计专用的PS、AI甚至AutoCAD，Solidworks等专业3D格式，也能轻预览松协同讨论。下载客户端后，更能在PC及Mac上调用本地应用程序编辑云端内容并自动同步，真正实现云端工作无缝协同。",
  4026: "指定任意文件夹自动同步<br>随时共享最新资料",
  4027: "指定同步文件夹后，任何更新内容通过同步端都可以同步至各平台<br>无需反复下载、上传，也无需手动设置，自动完成。通过同步共享文<br>件夹，团队文件实时更新，共享最新资料轻松实现。",
  4028: "了解更多",
  4029: "获权威机构QUALYS安全性A",
  // 4030: "目前国内最安全的SaaS系统",
  4030: "",
  4031: "巴别鸟可以控制每一个文件及每一位成员的访问行为，并留有详细的访问日志，可以了解每一位成员的工作动态。同时，巴别鸟使用了安全等级最高的EV  SSL认证，银行级别的加密传输，多服务器多机房分布式备份。确保你的数据安全无忧。",
  4032: "为企业量身定制<br>解决文档使用的所有需求",
  4033: "针对企业推出大量管理功能，支持共屏会议、版本管理、文稿审批、成员管理、权限分配、大文件传输，超大存储空间。可代替邮件及OA系统，甚至能节约企业office及CAD等专业软件的采购成本。巴别鸟不仅仅是个企业网盘<br>支持公有云及私有云部署方案，全面解决你的文件管理问题。",
  4034: "了解巴别鸟企业服务",
  4035: "产品",
  4036: "团队",
  4037: "支持",
  4038: "功能",
  4039: "定价",
  4040: "试用企业版",
  4041: "服务条款",
  4042: "隐私政策",
  4043: "公司介绍",
  4044: "联系我们",
  4045: "加入我们",
  4046: "下载巴别鸟iOS版",
  4047: "下载巴别鸟安卓版",
  4048: "巴别鸟产品说明书",
  4049: "意见及建议",
  4050: "从文档出发，高效协作",
  4051: "我们的工作往往围绕着各种文档展开又围绕着各种文档结束。无论是策划一场有趣的户外旅行，或是建造一项壮观的工程，我们都需要和大量的文档打交道。小到一个word文档大到一个水坝的3D设计图纸，你只要把文件拖拽入巴别鸟并邀请团队成员加入就可以直接在文件的内容上协作讨论。Web、iOS、Android 全平台实时协作。协作、存储、讨论、文件归档，人员管理、权限控制，随时随地.....使用巴别鸟，体会真正的高效。",
  4052: "下载巴别鸟产品说明书",
  4053: "文档",
  4054: "我们的工作计划和工作成果",
  4055: "文档是巴别鸟管理的基本单元，也是团队协作、知识共享和创意沟通的核心。所有的工作文档都可以分门别类地放在巴别鸟上。巴别鸟将提供给你一个井然有序的工作环境，你可以便捷地查找和分发工作所需文档，也可以快速查阅特殊格式文档，还能和团队成员基于文档内容自由地讨论。",
  4056: "我们共同的空间",
  4057: "和你熟悉的网盘使用起来一样方便，但更适合和同伴一起使用。点击“新建”按钮，你可以创建文件夹，并根据实际需要为文件夹命名，通过创建不同的文件夹分门别类管理文档。你和伙伴可以共同使用一个文件夹，共享文档更方便。",
  4058: "我们能在文档内容上直接对话",
  4059: "你可以和团队成员一起在巴别鸟上开展讨论。在文档上直接建立“批注”针对具体细节深入探讨，并可以统一管理，快速定位到讨论的内容上，让讨论围绕主题不失焦。",
  4060: "讨论",
  4061: "有组织才能更高效",
  4062: "你可以创建和管理团队，和团队成员共享知识。团队文件夹的文件会自动共享给每一位成员。并且可以管理每个成员的权限，同时团队也是一个讨论组，你甚至可以把团队当微信群用。",
  4063: "格式",
  4064: "没有格式才能让思维飞",
  4065: "使用巴别鸟，你几乎不用担心文档打不开的问题。巴别鸟是支持打开格式最多的网盘。大多数网盘无法预览的特殊格式，比如PSD、Ai、DWG等，用巴别鸟都能轻松查阅和讨论。无需购买和安装其他应用程序。",
  4066: "权限",
  4067: "安全的保证",
  4068: "巴别鸟可以控制使用者的权限，文档的权限，多种权限方案让你能在灵活使用和安全稳妥上进行选择。由于使用H5来显示文档，巴别鸟可以有效保护你的源文件，并且可以追踪文件的访问和打开情况，文档的打开、预览、讨论、下载、转发、编辑权限你都可以控制。",
  4069: "客户端",
  4070: "协作效率翻倍",
  4071: "客户端可以作为一个工作入口，开启后可以查看你在巴别鸟上的所有文件，代办事项及部门成员动态。最令人振奋的是，使用客户端可以调取本地的应用程序直接编辑巴别鸟上的文件，编辑过程中自动锁定，编辑完成后自动生成新的版本。这意味着，你可以和团队成员修改同一个office文档，或者3D模型，CAD设计稿。无需上传，整个团队的工作都在云端。",
  4072: "随时随地",
  4073: "无论是用手机APP，还是使用网页版或者是电脑客户端，巴别鸟都可以直接编辑office文档，真正做到随时随地的协同工作。你可以在地铁上用手机轻松修改你的演讲PPT，可以在机场校对销售数据报表，修改合同条款。并且无需发送邮件你的修改就会实时通知到你的团队成员或客户。配合客户端使用，甚至能调取你的AutoCad编辑你在巴别鸟上的图纸，无缝的体验更能提升工作效率高达300",
  4074: "我中有你你中有我",
  4075: "如果你已经拥有OA，ERP甚至其他文档管理系统，没关系！你也能享受巴别鸟的服务，只要使用巴别鸟接口，任何有文档出现的地方我们都可以用巴别鸟完成转码和讨论，享受巴别鸟带来的便捷和效率提升。",
  4076: "巴别鸟—高效的文档协同系统",
  4077: "现在体验",
  4078: "减少会议",
  4079: "使用巴别鸟我们可以直接在文件内容上讨论，支持语音对讲，手写等方式(需要配合巴别鸟app使用)。所有的讨论还可统一管理，生成待办事项并跟进执行结果。告别杂乱无章的会议，提高工作效率。",
  4080: "版本管理",
  4081: "巴别鸟可以方便管理文件各个历史版本，并可在各个版本间随意切换对比异同。",
  4082: "可控的安全",
  4083: "堡垒往往是从内部被攻破的，巴别鸟企业版在技术上使用了业界标准RSA+AES 128位加密算法(就是传说中的银行级加密）但最重要的是在设计上，巴别鸟使用了预览文件和源文件分开的办法，用H5页面预览和操作文件，使用时并不调取源文件，权限管理+无需下载即可使用的方式最大程度上保护了你数据的安全。因为使用网页预览，所以文件的所有使用情况都能被跟踪，安全可掌控。",
  4084: "监控及分析",
  4085: "巴别鸟使用网页传播和讨论文件意味着我们可以了解到我们分享的文件使用情况。通过巴别鸟我们可以知道我们分享的文件被谁打开、什么时候打开、看了多少页、停留时间长短等信息，方便我们了解文件的使用情况并做出决策。",
  4086: "个性化",
  4087: "巴别鸟企业版支持logo及界面的个性化定制，在后台就可以轻松替换logo，打造企业的专属应用，提高员工归属感。",
  4088: "可定制的存储",
  4089: "使用巴别鸟企业版我们不用担心空间不够用，从初始500G容量到无限的存储空间你都可以选择。",
  4090: "私有化部署",
  4091: "所有数据存储在内网私有服务器中，任何外部人员（包括巴别鸟官方）都无法访问。此外，内网部署网络性能优秀，文件同步速度快，最大化提高工作效率。",
  4092: "移动商务",
  4093: "巴别鸟企业版可以使用专属的APP，无论在手机或iPad都能拥有和网页版一样的用户体验及功能。让你随时随地可以使用文件并高效完成工作。",
  4094: "在线编辑",
  4095: "巴别鸟手机APP及web版可以在线编辑office文档，并且编辑时能自动锁定防止冲突，编辑完成自动生成新版本。使用巴别鸟客户端更可以调取本地应用编辑在线文件",
  4096: "提升效率",
  4097: "巴别鸟让公司共用同一个存储空间，成员在同一个文件副本上协作，可以大幅降低企业存储成本。同时免去了邮件来回讨论问题及复杂的审批流程，文档一有更改相关人员就能即时收到通知迅速对应。经测试，巴别鸟系统能提升知识型企业300",
  4098: "开放接口API",
  4099: "巴别鸟企业版开放存储、解析及文件讨论的相关接口（API），企业可根据自己的需求，开发各种应用，也可与企业已有系统集成。此外，巴别鸟支持统一认证接口，轻松对接企业认证系统，统一管理用户。",
  4100: "安心的服务",
  4101: "巴别鸟的成长需要你的支持，所以我们会提供让你最为安心的服务。了解你的需求并改进产品，上门培训你的员工，7*24小时电话支持，远程调试 …..这一切只希望巴别鸟能创造越来越多的价值，改变人们使用文件的方式。",
  4102: "使用巴别鸟，团队协作更高效",
  4103: "个人版",
  4104: "个人文档存储，快速完成协作",
  4105: "免费",
  4106: "满足个人基本的使用需求。简单、方便、安全。",
  4107: "立即使用",
  4108: "2G存储空间",
  4109: "支持建立团队2个",
  4110: "https加密保护",
  4111: "单个文件最多保存10个历史版本",
  4112: "单个文件上传最大支持5G",
  4113: "支持批注讨论文档内容",
  4114: "支持私密批注",
  4115: "支持文件批量下载",
  4116: "支持文件权限管理",
  4117: "可预览CAD文件",
  4118: "可预览3D文件",
  4119: "1:1模式预览超大图片",
  4120: "可在线播放视频",
  4121: "可定制需要的文件预览格式",
  4122: "共享标签",
  4123: "标签管理",
  4124: "文件阅读状态统计",
  4125: "文件协作与审批",
  4126: "企业组织管理架构",
  4127: "强大的管理员工具",
  4128: "细致权限设置",
  4129: "可自定义企业Logo和名称",
  4130: "专属UI界面",
  4131: "企业独有的域名登录",
  4132: "独立的用户体系",
  4133: "私有化部署",
  4134: "支持同步客户端",
  4135: "支持APP端访问使用",
  4136: "专属客户经理",
  4137: "小团队文件共享协作",
  4138: '<span class="rmb">￥</span>2,000<span class="yearly"> / 年</span>',
  4139: "包含“个人版”所有功能，更大的存储空间，更强的功能。",
  4140: "立即购买",
  4141: "1T存储空间",
  4142: "新建团队个数不限",
  4143: "单个文件保存历史版本不限",
  4144: "无限预览CAD文件",
  4145: "无限预览3D文件",
  4146: "企业公有云版",
  4147: "使用人数不限，适用中小企业",
  4148: "充裕的存储空间，强大的后台管理及权限管控体系，独立的访问域名，为企业打造专属云服务。",
  4149: "申请试用",
  4150: "2T存储空间（可灵活扩容）",
  4151: "无限建立部门",
  4152: "银行级加密保护",
  4153: "专有的登录入口",
  4154: "账号可同时登录企业版和个人版",
  4155: "企业私有云版",
  4156: "定制，安全性强，机构及政企首选",
  4157: "量身定制",
  4158: "包含“企业公有云版”所有功能，为企业提供定制化及私有化部署服务",
  4159: "按需无限定制存储空间",
  4160: "可选加密保护方式",
  4161: "他们在使用",
  4162: "选择针对企业用户设计的巴别鸟企业版",
  4163: "更专业，更高效，也更安全",
  4164: "行业解决方案",
  4165: "每个行业对文件的使用或多或少都有独特的需求点<br>针对不同行业的特殊需求，巴别鸟提供了一系列行业解决方案，帮助企业能更高效的使用巴别鸟",
  4166: "工程及制造",
  4167: "对图纸和专业格式的支持",
  4168: "科学与教育",
  4169: "课件管理及论文答辩 知识库管理",
  4170: "出版发行",
  4171: "三审三校 稿件管理",
  4172: "广告及设计",
  4173: "设计稿管理，ps，ai支持，快速分法，设计稿上直接讨论",
  4174: "互联网公司",
  4175: "从需求方案，产品原型，到成品设计稿，市场团队知识库",
  4176: "跨国企业",
  4177: "文件共享，远程会议讨论，国际网络优化，传输速率",
  4178: "更多行业",
  4179: "如果你所在的行业有特殊需求需要巴别鸟改进，请联系我们。<br>我们会派代表联系你们，深入了解你们的需求和工作流程，推出适合你所在行业的产品。<br><strong>* 每个行业的第一个用户我们会提供一年的免费服务。</strong>",
  4180: "高效的文档协同系统",
  4181: "为企业而生",
  4182: "文件存储、团队协作和组织管理三位一体",
  4183: "企业公有云版为企业带来哪些好处？",
  4184: "除了享有个人版及专业版的所有功能外，还能享受以下特权",
  4185: "超大的基础空间，满足海量存储",
  4186: "提供2TB超大基础存储空间，可为企业储存超100000 份文件。无论企业多少人，都可以统一协调地一起工作。",
  4187: "※（1TB ≈ 1048576M，每份文件按10M估计）",
  4188: "免费预览更多专业文件格式，可私密批注",
  4189: "企业公有云版用户可免费预览批注更多文件格式，并且不受数量限制，无限量预览。还可私密批注，交流方式更灵活，为企业的各岗位员工建立便捷的协作平台。",
  4190: "超强的企业组织架构，管理更轻松",
  4191: "为企业构建一个完美匹配线下的企业组织管理架构，",
  4192: "员工在线上更容易跨部门对接。",
  4193: "强大的管理员功能，可批量邀请员工，设置不同身份角色。",
  4194: "详细的操作日志记录，可追踪。",
  4195: "员工离职、升迁，文件一键交接迁移。",
  4196: "拥有独立的登录域名，自定义企业形象",
  4197: "企业公有云版用户，可以使用由企业名构成的独立登录域名，自定义企业Logo和名称，设置统一的形象标识。对内，进一步塑造企业形象；对外，强化企业形象，提升企业的专业度。",
  4198: "客户端访问，员工工作入口",
  4199: "使用巴别鸟客户端，每个员工将拥有统一的工作入口，根据权限的不同看\
                        <br>到不同的文件、代办事项及部门成员动态，最令人振奋的是，使用客户端\
                        <br> 可以调取本地的应用程序直接编辑巴别鸟上的文件件，编辑过程中自动锁\
                        <br>定，编辑完成后自动生成新的版本。这意味着，你可以和团队成员修改同\
                        <br>一个office文档，或者3D模型，CAD设计稿，无需上传，整个团队的工作\
                        <br>都在云端。",
  4200: "自定义水印，保护文件不被恶意传播",
  4201: "巴别鸟企业用户可以使用自定义的水印功能，可以以企业\
                      <br>logo、图片、甚至员工的工号作为水印，并且可以设定水印\
                      <br>的使用范围甚至在下载的PDF文件上内嵌水印，最大限度\
                      <br>的保护企业知识产权",
  4202: "更多企业专有功能助力企业高效办公",
  4203: "审批、共屏演示、文件收集箱、部门文件分权限、超大图片支\
                        <br>持等企业版特有功能，满足企业用户在文档使用时越到的\
                        <br>大多数问题，巴别鸟能解决企业发展过程中已经遇到或者\
                        <br>即将遇到的绝大多数文档管理时的问题。",
  4204: "为什么巴别鸟值得企业用户信赖？",
  4205: "文件安全有三防\
         <br> 防泄密、防删除、防下载",
  4206: "保护企业的文件安全是我们的首要任务。\
                        <br>为此，我们建立了严格的安全机制。文件加密分享，防止文件被泄密。\
                        <br>文件备份、后台操作日志记录，防止文件被恶意删除并可追踪。\
                        <br>灵活的文件权限设置，可控制其他人的操作权限，仅当被允许时才能下载。",
  4207: "预览格式种类多\
                        <br> 文档、音视频、2D和3D图形",
  4208: "文件预览及批注功能是我们最突出的特性，我们所支持预览的文件数量在行业内几无匹敌。既覆盖了日常办公所接触的Office、iWork、PDF等，也涵盖了一些专业人员接触的专业文件格式，如.psd、.dwg、.ai、.indd等，甚至是3D文件格式如.dae、.obj格式。",
  4209: "                        沟通协作效率高\
                        <br> 批注、讨论、多端同步于一身",
  4210: "我们不仅仅为企业提供存储、共享文件的服务，\
                            <br> 还提供可内、外部协作的沟通服务。",
  4211: "用户通过在线批注、团队讨论、多端同步、跨平台使用等功能，\
                        <br> 可提升工作效率，改善工作质量。",
  4212: "人工服务快又好\
                        <br>  每周不间断提供答疑解难服务",
  4213: "专属顾问为企业提供一对一的人工服务，\
                        <br>每周7天不间断响应企业用户的需求，\
                        <br>即时解决企业关于产品及服务的任何问题",
  4214: "更多功能敬请期待",
  4215: "动态筛选",
  4216: "动态筛选机制让“动态”更人性化，只显\
                <br>示和用户相关的文件、团队讨论动态。",
  4217: "",
  4218: "使用客户端和巴别鸟系统配合企业用户可以\
                <br>加密所有文件，在没有获得授权的电脑上，\
                <br>既使获得了文件也无法开启。确保企业文\
                <br>件的传播完全可控，切断因文件泄露造成的损失。",
  4219: "全局加密",
  4220: "归档",
  4221: "归档功能可以使企业的重要文件更为有序妥\
                <br>当的保存并确保文件的不可更改性，方便查询\
                <br>及管理。是企业建立文件档案的最佳解决方案。",
  4222: "使用企业公有云版，效率更高，管理更细",
  4223: "随时随地都可以使用巴别鸟",
  4224: "你不仅可以在办公室用电脑使用巴别鸟，<br class='hidden-xs'>也可以在智能手机或iPad上使用巴别鸟APP，<br class='hidden-xs'>功能甚至比网页端还强大",
  4225: "iOS通用版",
  4226: "App Store 下载",
  4227: "Android版",
  4228: "点击下载",
  4229: "客户端Windows版",
  4230: "Win10及以上版本 X64",
  4231: "客户端Mac X64",
  4232: "支持macOS 10.8以上版本",
  4233: "直接扫描二维码<br>关注巴别鸟微信公众号",
  4234: "直接扫描二维码<br>关注巴别鸟官方微博",
  4235: "巴别鸟说明书.pdf",
  4236: "巴别鸟介绍.pdf",
  4237: "巴别鸟部署安装指南.pdf",
  4238: "马上推出 敬请期待",
  4239: "无法删除，当前部门下仍有子部门",
  4240: "Copyright © 2013-2019 上海画擎信息科技有限公司",
  4241: "沪公安网备31010102003859  沪ICP备14029220号-3    本站关键词: <strong>企业网盘</strong>",
  4242: "专为办公打造，开启简单工作",
  4243: "查看巴别鸟详细功能列表",
  4244: "该共享文件拥有者的日共享流量已经超过限制,文件下载失败！",
  4245: "你无权删除其他人的标签",
  4246: "产品",
  4247: "企业网盘个人版",
  4248: "适用于个人用户",
  4249: "企业网盘专业版",
  4250: "小团队使用，加入人数不限",
  4251: "企业公有云版",
  4252: "中小企业分权限管理",
  4253: "企业私有云盘",
  4254: "大企业、政府机构、学校首选",
  4255: "IT及企业文档管理",
  4256: "管理整个企业的使用情况",
  4257: "安全与合规",
  4258: "全面保护您的数字资产",
  4259: "巴别鸟客户端",
  4260: "编辑线上文件、同步及映射盘",
  4261: "工作流支持",
  4262: "讨论及审批，简化工作流程",
  4263: "定制服务",
  4264: "定制您自己的巴别鸟",
  4265: "API接口与整合应用",
  4266: "可整合多家应用，让网盘无所不能",
  4267: "随时随地在任何设备和任何人进行安全协作",
  4268: "竟然如此好用!",
  4269: "企业文件统一管理",
  4270: "协同工作",
  4271: "数据安全",
  4272: "开始使用",
  4273: "为设计师准备的瀑布流素材管理功能",
  4274: "PSD、AI、DWG也能轻松驾驭",
  4275: "资源管理器集成",
  4276: "全新资源管理器集成（云桥）功能上线",
  4277: "像使用本地磁盘一样访问整个企业网盘中有权限查看的所有文件",
  4278: "立即下载最新客户端体验",
  4279: "巴别鸟企业网盘能为您的企业做什么",
  4280: "文档集中管理",
  4281: "根据组织结构及成员权限统一管理文件，全文搜索快速查找",
  4282: "实时同步备份",
  4283: "文件在所有设备版本一致。与伙伴同步文件，协同工作",
  4284: "批注讨论协作",
  4285: "打开大多数格式文件，在文件内容上直接建立批注实时讨论",
  4286: "在线编辑文件",
  4287: "巴别鸟可以直接编辑在线文件<br>从office到CAD。高效完成协作",
  4288: "细化权限管理",
  4289: "角色、行为、部门、文件的权限<br>都可自定义。更可分部门管理",
  4290: "自定审批流程",
  4291: "可按业务需求自定义各种审批流程并导出报表，支持手写签名",
  4292: "知识档案管理",
  4293: "内置知识管理及档案管理模块<br>满足专业的档案存储及借阅管理",
  4294: "不改变使用习惯",
  4295: "可内嵌于windows资源管理器<br>直接访问网盘，更方便更安全",
  4296: "进一步了解巴别鸟企业网盘更多功能",
  4297: "开启新的工作方式",
  4298: "为企业打造",
  4299: "文件生命周期",
  4300: "安全",
  4301: "贴身服务",
  4302: "使用巴别鸟企业网盘，您团队的所有文件资产（文档，图像，视频等）都安全地存储在云中，团队中的每位成员都可以从不同设备轻松的进行访问、编辑、共享和评论。在企业级的安全性保障下协助您高效的完成所有工作，让您的企业快速升级到高效云办公时代。",
  4303: "沟通效率及知识统一度决定了企业的竞争力",
  4304: "——稻盛和夫",
  4305: "讨论-编辑-审核-协同-管理-归档",
  4306: "从草稿和提纲的沟通讨论，文档的创建、修改及团队协作，到文件评审分发，给合作伙伴审核定稿，直至最终的归档、借阅、存储。巴别鸟致力于整个文件生命周期各个环节的管理。让您的企业效率更高，安全更有保障，知识得以沉淀。",
  4307: "安全是业务的关键！巴别鸟从产品设计到架构搭建及服务器管理都优先考虑安全性，并且包含了许多重要的安全功能。您可以控制每个文件及每位成员的访问行为，添加文件水印，查看访问日志。档案库可以最大限度保护重要数字资产。同时，巴别鸟使用了安全等级最高的EV SSL认证，银行级的加密传输，多机房分布式备份，确保你的数据安全无忧。这些举措使巴别鸟企业网盘获得了权威机构QUALYS安全性A+认证",
  4308: "*巴别鸟使用阿里云数据中心，保证99.9%可用性",
  4309: "从草稿和提纲的沟通讨论，文档的创建、修改及团队协作，到文件评审分发，给合作伙伴审核定稿，直至最终的归档、借阅、存储。巴别鸟致力于整个文件生命周期各个环节的管理。让您的企业效率更高，安全更有保障，知识得以沉淀。",
  4310: "巴别鸟是一个企业服务类产品，企业服务的本质是服务企业，我们希望和我们的用户一起成长。除了提供一流的产品，我们也提供您难以想象的专家贴身服务。我们能为您提供团队，工具和经验，帮助您的企业快速上云。Babel care团队能深入企业调研需求并根据您的业务运营方式提供解决方案、搭建您的系统、进行培训甚至能根据业务需求进行二次开发及API接入。让您高效无忧的完成系统上线目标。",
  4311: "不改变习惯，简单上手",
  4312: "直接批注讨论",
  4313: "同步及云桥",
  4314: "打开大多数文件",
  4315: "全平台",
  4316: "打开企业网盘中的文件后在想交流的地方直接点击，即可在点击的区域建立批注点开启讨论。您甚至可以使用语音及手绘圈画让交流更生动高效，企业网盘中所有加入分享的成员都可以实时看到您的批注并回复，移动端交流更顺畅。所有的批注点都可以结构化管理，并且支持@及附件上传。真正做到可管理的内容讨论及任务分配。",
  4317: "使用巴别鸟客户端，可以让您无需改变操作习惯即可享受巴别鸟的云服务。同步功能可以自动把巴别鸟企业网盘上的文件同步到本地，文件编辑时自动锁定，编辑后自动上传。云桥功能内嵌于windows资源管理器中，您可以像访问本地文件一样访问存储在云端的文件，并可直接在资源管理器中和同事协作。节约流量并且无缝操作。巴别鸟企业私有云盘也支持客户端访问。",
  4318: "想查看文件？无需下载，直接点击即可！无需安装任何应用程序，您就能在巴别鸟上直接打开200多种格式的文件。从常用的office，苹果专属的iWork，图片或视频到设计专用的PS、AI甚至AutoCAD，Solidworks等专业3D格式，也能轻松预览协同讨论。下载客户端后，更能在PC及Mac上调用本地应用程序编辑云端内容并自动同步，真正实现云端工作无缝协同。",
  4319: "随时随地查看自己和团队的文件，多人协同讨论及编辑",
  4320: "现在您不仅能在网页端登录，也可以通过智能手机及windows，mac客户端来使用巴别鸟。同时，您可以直接在线编辑office文档，无需安装office软件",
  4321: "使用企业私有云盘的用户也可以享受全平台服务",
  4322: "为团队协作而生",
  4323: "部门及项目",
  4324: "强大的审批管理",
  4325: "细致的权限管理",
  4326: "真正的协作",
  4327: "巴别鸟拥有一个强大的企业管理后台，支持建立或导入组织结构。同时支持windows域控。在巴别鸟中，您可以分部门管理，每个部门使用不同的权限及安全设置甚至不同的部门管理员。您也可以快速创建项目，协调各个部门人手，共享项目文件及跟踪项目进度。",
  4328: "不同于OA的文件审批，巴别鸟提供了更为强大的可针对文件具体内容的审批工具。管理员可以自由预设审批流程及评审者权重，普通用户也可以自定义多种审批形式，甚至可以邀请外部成员参与文件的审批。审批结果可导出报表打印存档。",
  4329: "从文件的权限、人的权限到部门的权限、角色的权限、分享的权限。巴别鸟企业网盘提供了多个维度多种方式的权限管理。基本覆盖了企业所需的所有权限配置。安全性到使用便捷性之间的平衡，系统管理员也可以在管理后台根据业务及部门的需求任意调节。",
  4330: "除了最基本的文件共享及流程管理，巴别鸟还提供了工作台、部门讨论、动态、文件评论、文件内容批注、文件内容审批、文件共同编辑等多维度的协同工具。真正可以结合业务及使用场景在巴别鸟一个系统上完成工作。版本管理及锁定机制能避免多个版本冲突或文件合并。使用巴别鸟后，团队可以避免繁琐的邮件多次沟通，OA的来回折腾。真正把工作重心放在工作中而不是管理中。",
  4331: "企业网盘解决方案强大及专业",
  4332: "面向行业的解决方案",
  4333: "工作流定制开发",
  4334: "私有化服务",
  4335: "开放API",
  4336: "从医疗行业专用的Dicom格式的标记讨论，到工程使用CAD文件的协作及评审，再到3D模型细节的批注，签证信息的分类储存，AI文件的对比审稿。巴别鸟针对不同行业的用户提供了适用于用户所在行业的解决方案。同时对于我们不了解的行业，Babel care专家团队会深入企业，和用户一起根据企业需求和我们的产品经验一起搭建适合用户使用的巴别鸟系统及巴别鸟企业私有云盘。",
  4337: "我们的Babel care团队能与您密切合作，深入了解您的组织的运作方式，包括您的公司文化和工作方式。这有助于我们发现用例和难点，在巴别鸟系统的基础上定制您的工作流以满足您独特的需求，以便每个团队可以无缝协作。从图纸管理到签证提交系统，我们已经帮助大量客户实现了工作流程的定制开发及企业私有云盘定制开发。",
  4338: "我们能提供多种灵活的私有化部署方案，从传统的服务器集群，到超融合系统、混合云、SD-wan。我们的工程师会根据您现有的硬件系统给出私有化方案，最大限度的利用您目前的硬件资源搭建您的企业私有云盘。",
  4339: "巴别鸟开放平台支持在巴别鸟系统上的定制开发及系统对接。针对私有云用户我们提供了API授权及更高级别的代码商务授权业务。您可以在巴别鸟系统的基础上打造属于您企业自己的系统。快速实现企业云服务能力。",
  4340: "使用巴别鸟，搭建自己的云系统",
  4341: "巴别鸟商业授权服务",
  4342: "想为您的客户提供更多样的服务？销售资料的展示、合同报价管理、代理商文件管理、企业知识管理…使用巴别鸟商业授权服务，您的企业可以在巴别鸟系统基础上开发自己的商业应用，让企业快速拥有云服务产品。",
  4343: "“巴别鸟是一个权限管理精细并符合我们安全要求的产品。他们强大的功能和专业的服务让我印象深刻。”",
  4344: "— 钱学森空间实验室  高主任",
  4345: "“巴别鸟能根据我们的业务流程搭建我们的图纸评审系统及档案管理系统。以很低成本极大提高了我们信息化进程。”",
  4346: "— 长城华冠信息部经理  姚志强",
  4347: "“立项了一年多时间，我们最终选择了巴别鸟，除了产品优秀外，他们的定制化开发服务解决了我的后顾之忧。”",
  4348: "—— 至纯科技 iT经理 庄稼",
  4349: "他们也在使用巴别鸟",
  4350: "了解巴别鸟企业服务",
  4351: "服务",
  4352: "主要功能",
  4353: "IT及管理",
  4354: "下载巴别鸟客户端",
  4355: "巴别鸟产品说明书",
  4356: "友情链接:",
  4357: "精细管理企业成员，10人起订",
  4358: "充裕的存储空间，强大的后台管理及权限管控体系，独立的访问域名，为企业打造专属云服务。",
  4359: "每日5G高速下载流量",
  4360: "每日10G高速下载流量",
  4361: "每增加一名成员增加10G日流量",
  4362: "不限流量",
  4363: "最经济的企业网盘解决方案",
  4364: "点击购买巴别鸟专业版",
  4365: "低成本快速搭建企业网盘",
  4366: "使用巴别鸟专业版，您只需要购买一个账号就可以无限组建团队，并邀请无限多的用户加入专业版组建的团队中共享高达1TB的可扩容存储空间并管理团队成员在团队中的访问权限。并且不限制文件版本数量。",
  4367: "添加和管理你的团队成员",
  4368: "专业版可以无限添加团队及团队成员，成员只要注册免费的巴别鸟个人版就可以加入专业创建的团队中，共享专业版的存储空间，并和团队成员共享文件协同工作。专业版账号可以管理团队中成员对团队文件的访问权限。仅购买一个专业账号就可以享受到超过其他企业网盘企业版账号的功能体验。",
  4369: "无限保存文件新版本",
  4370: "巴别鸟专业版不限制文件保存的新版本数量，配合增量上传技术可以在有限的空间内存储大量的文件新版本。强大的版本管理可以下载任意时段的版本，并可回滚当前版本到任意历史版本。无论是同步、客户端编辑、还是映射盘（云桥）上编辑的文件都能自动保存新版本。",
  4371: "3D和CAD文件预览支持",
  4372: "巴别鸟专业版支持多种3D格式文件及CAD文件（.dwg)的预览及建立批注点讨论。同时巴别鸟的3D文件批注是建立在3D空间上的，可以直观讨论3D文件。",
  4373: "批注、动态、群聊一个都不少",
  4374: "不管是在任意文件上建立批注讨论，还是动态列表、团队讨论空间、@其他用户….这些企业版才有的功能专业版也统统拥有",
  4375: "同步、映射盘（云桥）",
  4376: "专业版可以享受客户端的全部功能，无论是任意文件夹的同步，多人编辑在线文件，或是最新推出的映射盘功能。只要安装巴别鸟客户端，这些功能专业版用户均能享受",
  4377: "瀑布流",
  4378: "使用专业版你也可以使用瀑布流效果预览您的图片素材和文件，在赏心悦目的查看过程中直观快速的找到需要的文件。",
  4379: "全平台",
  4380: "专业版一样支持全平台的使用，几乎可以在所有设备上使用巴别鸟专业版，我们不仅有windows和mac客户端和手机移动端，我们还有为iPad界面定制的交互及UI。",
  4381: "现在就开始使用巴别鸟专业版",
  4382: "点击购买巴别鸟专业版",
  4383: "巴别鸟企业网盘 私有云",
  4384: "节约成本，放飞想法",
  4385: "可根据企业的需求量身定制",
  4386: "联系我们",
  4387: "经过公有云数十万用户考验的系统",
  4388: "巴别鸟公有云网盘系统需要同时为包含免费用户在内的60万用户提供持续不间断服务、要挡住公网上的各种攻击、要不断提高系统效率以降低高昂的公有云服务器成本。多达6年的公有云不间断服务经验使巴别鸟系统久经考验。巴别鸟私有云系统是在巴别鸟公有云系统基础上发展起来的，继承了公有云巴别鸟的所有功能及特性，提供给您其他私有网盘无法比拟的高稳定性及高可用性。",
  4389: "私有云率先支持在线office",
  4390: "开启协同编辑时代",
  4391: "多人实时在线编辑",
  4392: "兼容各格式office文档",
  4393: "实时评论",
  4394: "灵活的部署方式",
  4395: "比公有云更细的自定义设置",
  4396: "无论是单服务器、多服务器、集群、超融合系统、分布式系统、第三方云平台甚至Docker方式的部署我们都支持。我们的部署团队可以根据你的需求和你共同制定部署方案。同时因为私有云只服务于单一企业的特性，我们可提供远超公有云系统的可选自定义设置，从界面操作到流程到权限都可以根据你的需求调整。",
  4397: "Babel care 专业的产品级客服团队",
  4398: "定制开发及行业解决方案服务",
  4399: "不同行业有不同的工作流程及使用习惯，为了更好的适用于您的使用场景，我们有由职业产品经理带队的Babel care团队为您的企业定制属于你的解决方案及二次开发支持。在巴别鸟的基础上做出专属您所在企业及行业的定制系统。我们曾帮助汽车厂商实现图纸评审系统、帮建筑企业打造设计协同系统、帮旅行公司完成自动签证系统…",
  4400: "支持更多功能的开放api",
  4401: "巴别鸟私有云系统能破除标准化产品带来的限制，提供远超公有云系统支持范围外的API，整个系统所有功能都可以API化，使之可以完美融入您现有的系统或待开发的系统中。巴别鸟商业授权支持您在巴别鸟系统的基础上开发您自己的系统，以白牌授权的方式获得巴别鸟的能力。",
  4402: "“我们花了1整年时间寻找能满足我们要求的系统，最终巴别鸟私有化系统的API定制开发解决了我们的问题。相见恨晚”",
  4403: "——  许经理  深圳市卯丁技术有限公司",
  4404: "联系我们",
  4405: "想了解更多？请拨打 4009204020 和我们销售顾问聊聊您的需求",
  4406: "你也可以拨打13564686107 和我们的产品经理直接对话",
  4407: "使用巴别鸟私有云系统可以比公有云系统更先享受巴别鸟在线office，无论是word、还是excel、ppt都能完美支持。无需安装软件即可在手机端，网页端直接在线编辑office文档。支持多人实时在线编辑同一个文档。（此功能目前仅私有云系统支持，公有云暂未开放）",
  4408: "全面掌握您的企业",
  4409: "强大的管理后台及客服支持确保您的工作顺利开展",
  4410: "立即试用",
  4411: "联系我们",
  4412: "推动业务发展和IT规划落地",
  4413: "我们充分理解IT部门面临的压力，和选择我们需要承担的责任。正因为如此，我们提供了强大的管理工具及客户服务帮助IT人员从容应对企业各种瞬息万变的需求。同时，多管理员及分部门管理功能也能大幅降低IT人员的负担及维护难度。我们的免费初始化及培训服务也能帮助IT管理人员快速使用及落地系统。",
  4414: "强大的全面的管理后台",
  4415: "为了让IT人员能更好的管理企业，我们提供了独立的管理后台及强大的管理工具。轻松从成员、文件、部门、项目、分享等多个维度来管理企业的文件及协作。",
  4416: "轻松管理您的用户",
  4417: "无论是企业成员还是第三方合作伙伴或是短期实习生，巴别鸟都能以多种方式进行管理。权限范围一目了然，员工离职一键交接，部门可独立管理部门成员。同时支持AD域控对接及单点登录。",
  4418: "用角色来管理用户权限",
  4419: "通过预设角色来统一管理用户的初始权限更加方便高效且不易出错。支持同一个用户在不同部门拥有不同的角色。角色可自定义，高达30几项细节权限可选",
  4420: "控制所有内容",
  4421: "从审批设置到分享行为控制、文件权限精细化调整、水印控制、成员使用情况日志…..巴别鸟可以让您完全控制成员使用内容的方式。并且支持mac地址绑定，让特定成员仅能在特定设备使用巴别鸟。",
  4422: "分层级管理企业",
  4423: "考虑到大型企业权限管理的复杂性和工作量，巴别鸟支持多层级管理和多种职责不同的管理员设置。除超级管理员外还支持4种权限各不相同的管理员结构、支持每个部门独立管理自己的成员及文件。",
  4424: "日志及统计，让管理更高效",
  4425: "除了文件使用日志、部门使用日志、成员日志、系统日志外，巴别鸟还支持数据统计及数据可视化。并支持导出报表，让整个企业的使用情况一目了然。",
  4426: "连接您的系统",
  4427: "巴别鸟提供完善的API接口及中间件二次开发支持，能高效快速的和您现有的系统对接，让巴别鸟成为您旧系统的文件存储及管理平台。除了传统的泛微OA、office365、企业邮箱、我们还支持和PDM、BIM系统及微信企业号集成。同时你还可以在巴别鸟平台上进行二次开发，为您的客户推出更好的产品。",
  4428: "现在就开始体验巴别鸟带来的强大功能",
  4429: "全方位保护您的数字资产",
  4430: "下载巴别鸟数据安全策略",
  4431: "以安全为核心的系统设计",
  4432: "安全是业务的关键！巴别鸟从产品设计到架构搭建及服务器管理都优先考虑安全性，并且包含了许多重要的安全功能。",
  4433: "精细的权限控制",
  4434: "堡垒往往是从内部攻破的，安全的首要考虑是防止使用者泄露。巴别鸟从文件的权限、人的权限、部门的权限三方面切入的精细化权限管理系统能满足绝大多数权限配置需求，使巴别鸟能更安全有序的保护重要数据。",
  4435: "可制定安全策略",
  4436: "巴别鸟独有的“安全保密员”可以在管理后台中制定企业的安全策略，独立控制每个部门的安全等级。让重要部门的数据得到妥当保护。",
  4437: "银行级的加密传输",
  4438: "巴别鸟使用了安全等级最高的EV SSL认证，文件上传下载使用HTTPS作为传输协议，传输过程中对文件本身进行了二次AES CTR 256算法流式分块加密，确保最终保存在云存储系统的文件均为密文，在传输以及存储过程中杜绝被窃取可能 。",
  4439: "碎片化存储保护您的数据",
  4440: "巴别鸟采用碎片化存储技术，文件被打散成若干碎片后分别存储于不同的磁盘或服务器中，即使服务器被攻破，攻击者也无法获得完整的文件碎片以获得文件。同时，巴别鸟支持私有化部署，让数据存储在更加安全的场所。",
  4441: "合规的安全",
  4442: "巴别鸟通过了多个权威机构的第三方检测，并且我们定期会进行安全合规检查。我们也获得了QUALYS安全性A+认证，是目前国内唯一获得A+认证的企业网盘",
  4443: "与安全厂商联合推出更多服务",
  4444: "无论是全盘在线杀毒，还是已下载文件防泄密，或者企业级防火墙。巴别鸟和多家其他领域的安全厂商有长期合作关系。可以无缝整合其他厂商的安全产品以提供您更加全面的安全保证。",
  4445: "他们同样注重安全",
  4446: "现在就开始体验巴别鸟带来的强大功能",
  4447: "下载巴别鸟数据安全策略",
  4448: "全新巴别鸟客户端",
  4449: "更强大、更方便",
  4450: "让企业网盘无人能及",
  4451: "巴别鸟客户端其实包含了3个模块。文件管理模块、同步端、映射盘（云桥），使用客户端可以不改变使用习惯更方便的编辑文件并和团队保持同步。同时，还拥有自动上传新版本、增量上传、自动锁定文件、mac地址绑定、右键快速分享文件等功能，是迄今为止最强大的企业网盘客户端。",
  4452: "同步、所有人所有设备",
  4453: "同一个项目或部门的文件夹、公司的mac和家里的PC、还有您的移动设备。是的，巴别鸟支持在这些设备间同步多个用户的数据。先进的冲突管理判断机制能有效防止文件版本冲突发生。你可以不改变位置同步任意文件夹到巴别鸟，也可以同步巴别鸟上你有权力下载的任意文件夹到本地。",
  4454: "永远用不完的硬盘空间",
  4455: "比同步更实用的巴别鸟映射盘（云桥）功能，可以把巴别鸟作为一个磁盘驱动器并在windows资源管理器中访问。您可以就像用一块远程硬盘一样用它，访问及编辑您权限范围内可以处理的全部文件。不同于同步功能，映射盘并不会占用太多本地存储空间，这意味着你可以访问和存储比你本地硬盘大得多的数据。同时拥有企业级安全性来保护您所做的一切。",
  4456: "无缝创建及编辑所有文件",
  4457: "在巴别鸟客户端，无论您是创建新文档还是编辑PDF，都可以直接保存到巴别鸟。编辑时自动锁定的机制防止其他人和你同时编辑造成冲突。巴别鸟app还支持在安卓设备上调取第三方应用来编辑文件，编辑完成后也能自动作为新版本保存至巴别鸟。",
  4458: "可选在特定设备上使用",
  4459: "巴别鸟可以开启仅支持客户端或移动设备访问的设定，配合独家的mac地址和账号绑定功能您就可以做到让某个用户只能在公司的设备上使用巴别鸟而不能在私人设备上使用。大幅提高系统安全性。",
  4460: "增量上传",
  4461: "增量上传技术可以在同步文件时只上传文件的更改部分，大幅节约上传时间和版本存储空间。使用增量上传技术后，一个500MB的psd文件经过一次修改后可能只需要上传5MB的文件，节约您大量上传时间，并让大文件的快速多版本保存成为可能。",
  4462: "全平台",
  4463: "我们几乎可以在所有设备上使用巴别鸟，我们不仅有windows和mac客户端和手机移动端，我们还有为iPad和大屏电视量身定制的巴别鸟版本",
  4464: "客户端根据他们的需求多次迭代",
  4465: "感谢这些客户在客户端的开发过程中积极提出建议和需求，伴随我们成长。正因为他们专业的建议和可落地的使用场景让巴别鸟客户端如此强大。我们客户也能享受到更多的经过实践有效的功能。",
  4466: "下载巴别鸟客户端",
  4467: "自动化工作",
  4468: "简化您的流程",
  4469: "立即试用",
  4470: "联系我们",
  4471: "基于文件生命周期管理而设计",
  4472: "巴别鸟致力于文件整个生命周期的管理。从文件的创建、修改、协同、共享、审批、分发、归档、到销毁的整个生命周期，巴别都有相应的功能及流程进行管理，并可进行流程定制或解决方案搭建。充分运用巴别鸟可简化您的关键且经常耗时的任务，提高业务速度。",
  4473: "可预设审批流程",
  4474: "在企业管理后台可以按需求预设一批各类审批流程，不同的部门可以按需选择自己需要的审批流程及流程使用规则。",
  4475: "功能强大的审批",
  4476: "支持多种审批方式，从最基础的并行多人、顺序多人到分组、加权、抄送、跨部门、跨公司，巴别鸟支持快速搭建几乎所有的审批方式。并且，巴别鸟可以直接在文档内容上以批注或手绘的形式提出审批意见。提高来回评审修改稿件的效率。",
  4477: "快速收集文件",
  4478: "巴别鸟特别的文件收集箱功能能保证稿件提交者在看不到其他提交者提交的文件的前提下管理和修改自己提交的稿件，并可设截止日期，自动通知，结果统计，提交者管理。是教师收作业（论文）、企业收集标书、政府收集材料的有力帮手。",
  4479: "一目了然的工作管理",
  4480: "不论是审批流程、收件记录、还是归档管理，巴别鸟都有特别的管理界面来统一管理。并可以把管理界面自定义在工作台列表中。同时，通知和动态会把所有和您相关的信息组合在一起供你快速查看和使用。",
  4481: "及提醒关注",
  4482: "来分配任务给同事，或者提醒他看一下文章的某个章节或图纸的某个细节。提醒关注功能可以让某人同时关注某个文件或文件夹，并主动把文件或文件夹加入他的关注列表中。",
  4483: "管理您的项目",
  4484: "巴别鸟还可以极其方便的创建及管理项目，组建一个项目团队，指定一名项目经理，由项目经理进行项目的管理。项目支持转交，可以在项目开展的过程中根据需要转交给不同的人或不同的部门。",
  4485: "归档及档案管理",
  4486: "巴别鸟有整套独立的档案管理模块。归档的文件会自动导入档案库，由档案管理员分配。档案库有自己的搜索、借阅、和管理，文件不可修改，并具有极高的安全设定。",
  4487: "他们也关注流程",
  4488: "在线协同编辑",
  4489: "在线协同编辑（可选）",
  4490: "项目及文件收集箱",
  4491: "档案库",
  4492: "单个文件上传最大支持10G",
  4493: "单个文件上传大小可自定义",
  4494: "可设定文件密级和部门密级",
  4495: "分享审批",
  4496: "登录设备限制",
  4497: "IP策略控制",
  4498: "水印及下载带水印PDF",
  4499: "",
  4500: "运维管理员",
  4501: "运维管理员可以登录企业管理后台，主要负责部门的建立和各个部门的成员管理，以及审批流程，分组管理等等运营维护",
  4502: "添加运维管理员",
  4503: "管理运维管理员",
  4504: "确认删除{-user-}的运维管理员身份",
  4505: "不限分组",
  4506: "点击此处刷新动态",
  4507: "邀请人员信息输入无效：",
  4508: "过滤了以下无效输入人员：",
  4509: "当前列表中有的文件权限发生了改变，请点击确定刷新文件列表",
  4510: "开发者账号",
  4511: "如果需要在第三方通过 API 访问您在巴别鸟上的数据，请在此处",
  4512: "申请开发者账户",
  4513: "回调URL",
  4514: "http url - 我们将通过这个 url 返回认证结果给您",
  4515: "开发者 id",
  4516: "开发者秘钥",
  4517: "您的开发者账号申请正在等待处理...",
  4520: "工作台",
  4521: "发布时间",
  4522: "我最近访问",
  4523: "我最近上传",
  4524: "部门最近上传文件",
  4525: "部门活跃文件",
  4526: "团队最近上传文件",
  4527: "团队活跃文件",
  4528: "更多",
  4529: "本栏目暂无内容",
  4530: "最近企业消息",
  4531: "分类过滤",
  4532: "输入文件名或分享人，回车搜索",
  4533: "顺序",
  4534: "创建新的工作台栏目",
  4535: "卡片名称",
  4536: "请输入卡片名称",
  4537: "对应的企业发布文件夹",
  4538: "",
  4539: "暂无企业自定义的工作台栏目",
  4540: "编辑工作台栏目",
  4541: "栏目名",
  4542: "可自由定义审批流程",
  4543: "审批组",
  4550: "编辑工作台",
  4551: "选择要显示的图表",
  4552: "我关注的",
  4553: "我打开的链接分享",
  4554: "我邀请人员加入分享的文件",
  4555: "我评论或批注过的文件",
  4556: "我的项目",
  4557: "部门最近活跃文件",
  4558: "标签云图",
  4559: "文档关系图",
  4560: "备选图表",
  4561: "自定义新图表",
  4562: "对应的文件夹",
  4563: "选择要展示的文件夹",
  4564: "该文件没有相关文件",
  4565: "从该文件的相关文件中选择",
  4566: "（文件最多保存10天）",
  4567: "处理结果",
  4568: "处理人",
  4569: "处理时间",
  4580: "新客户端Mac ARM",
  4581: "支持macOS11.0以上版本",
  4582: "支持Windows 10以上系统",
  4570: '<span class="rmb">￥</span>2,000<span class="yearly"> / 年</span>',
  4571: '￥2,000/年',
  4573: '￥35/人/ 月',
  4574: "单个文件上传最大支持1024G",
  4575: "单个文件上传最大支持2048G",
  4600: "本阶段是否可以强行越过？",
  4601: "审批通过的比例限制：",
  4602: "本阶段通过后是否就可以标记文档定稿？（后继阶段只是推送通知）",
  4603: "阶段名称不能为空",
  4604: "阶段",
  4605: "选择审批流程",
  4606: "企业预制流程",
  4607: "个人预制流程",
  4608: "保存到个人审批流程",
  4609: "暂无预制流程<br>管理员可在“企业控制台-文件配置”栏目添加审批流程",
  4610: "暂无",
  4611: "向上移动",
  4612: "向下移动",
  4613: "角色",
  4614: "没有审批流程",
  4615: "提示：没有审批流程信息",
  4616: "保存失败，请选择评审人员",
  4617: "保存失败，{-title-}中所选的角色没有相对应的人员",
  // 4618: '根目录数据错误，请联系客服人员',
  4618: "网络超时，请刷新后重试！",
  4619: "暂无预制流程",
  4700: "申请打开文件链接分享",
  4701: "申请邀请人员加入分享",
  4702: "{-name-}申请文件权限",
  4703: "{-name-}同意了申请",
  4704: "{-name-}否决了申请",
  4705: "{-name-}提醒你关注文件",
  4706: "{-name-}at你",
  4707: "{-name-}邀请你审批文件",
  4708: "{-name-}通过了审批",
  4709: "企业消息：文件通过了审批",
  4710: "企业消息：文件被驳回",
  4711: "巴别鸟通知： 系统更新",
  4712: "邀请你加入团队",
  4713: "邀请您共同管理文件收集箱",
  4714: "{-name-}处理了你的打开文件链接分享请求",
  4715: "{-name-}处理了你的邀请人员加入分享请求",
  4716: "{-name-}给你发送了文件",
  4717: "系统消息：你所购买的巴别鸟服务即将到期",
  4718: "{-name-}开启了文件演播",
  4719: "{-name-}发布了企业通知",
  4720: "权限不足",
  4721: "你没有此权限，你可以填写你希望修改的名字发送请求给文件负责人或部门经理",
  4722: "需要的权限：",
  4723: "申请的理由：",
  4724: "发送申请",
  4725: "相关文件已删除，本条消息已失效",
  4726: "自定义权限",
  4727: "新建空白权限",
  4728: "复制一个已有权限去编辑",
  4729: "正在生成预览文件，不能进行此操作",
  4730: "登录系统过于频繁，请稍后重试",
  4731: "是否确定取消同步？取消同步后，该文件夹将不再同步到本地，您仍可通过云桥模式或网页进行访问。",
  4732: "你没有此权限，你可以填写你希望移动到的目录发送请求给文件负责人或部门经理",
  4733: "下载",
  4734: "打印为PDF",
  4735: "你没有此权限，你可以选择你希望修改的权限发送请求给文件负责人或部门经理",
  //****************** 8.1 ***************

  4736: "验证码",
  4737: "获取验证码",
  /**************8.2***************/

  4738: "项目助理",
  4739: "点击选择项目助理",
  4740: "选择项目助理",
  4741: "项目经理和项目助理不能是同一个",
  4742: "添加项目助理",
  4743: "权限",
  //Authority
  4744: "如何使用档案库？",
  4745: "档案库由档案管理员进行管理，超级管理员可以指定一名或多名企业成员为档案管理员。",
  4746: "归档文件普通人员访问需要提出申请，档案管理员审核通过后才能访问归档文件。",
  4747: "请使用客户端预览和批注DWG文件",
  4748: "（设置的权限优先级是：部门人员权限大于角色权限，角色权限大于部门内所有人权限）",
  4749: "保存中...",
  4750: "选择查询条件后点击“搜索”查询日志",
  4751: "文件收集箱主要用于收集文件，让投件人上传文件到文件收集箱中",
  4752: "开放式收集",
  4753: "组织内收集",
  4754: "开放式文件收集箱会产生一个链接，您可以将链接发放出去，凡知道此链接的人不需要注册就可以上传文件",
  4755: "此种文件收集箱需要你指定企业内投件人名单，这些人在自动收到邮件和站内通知后进行文件上传，不支持名单外人员投件",
  4756: "创建开放式文件收集箱",
  4757: "要求投件人填报的信息：",
  4758: "姓名",
  4759: "请输入您的{-name-}",
  4760: "添加信息",
  4761: "这里输入信息填写项的标题",
  4762: "这里输入信息填写项的暗文",
  4763: "投件人填写信息预览",
  4764: "请填写以下信息：",
  4765: "收集人：",
  4766: "发布日期：",
  4767: "你可以将此链接地址发放出去，投件人访问此链接即可上传文件",
  4768: "用户输入项",
  4769: "暂无需要输入的信息",
  4770: "未知ip",
  4771: "在这里你可以自定义投件人上传文件时需要填报的信息，使用修改或添加信息按钮修改或增加条目。投件人点开投件链接后会出现信息填写表单。",
  4772: "全部档案",
  ////////////////*********8.3***************/

  4773: "仅查看分享及邀请",
  4774: "暂未开通在线编辑模块",
  4775: "项目助理可以增加和删除项目成员，为项目成员分配权限。但项目助理不能转交和删除项目。",
  ////////////////*********8.4***************/

  4776: "我的项目",
  4777: "暂无项目文件",
  4778: "暂无个人文件",
  4779: "请选择次级目录",
  4780: "请选择目标文件夹",
  4781: "推送通知设置",
  4782: "我关注的文件",
  4783: "选择该选项后，关注的文件夹或文件内容更新，新版本上传都会收到系统推送通知。",
  4784: "当前目录不允许上传新文件",
  /////////////////*************9.0*******************/
  4785: "系统配置",
  4786: "邮件服务器",
  4787: "第三方账号认证",
  4788: "存储配置",
  4789: "邮箱服务器地址",
  4790: "请输入邮箱服务器地址",
  4791: "端口",
  4792: "请输入端口",
  4793: "授权码",
  4794: "请输入授权码",
  4795: "是否使用smtp协议",
  4796: "放弃",
  4797: "是否开启第三方认证",
  4798: "是否开启第三方账号同步",
  4799: "第三方认证方式",
  4800: "AD域认证",
  4801: "企业微信",
  4802: "钉钉",
  4803: "域",
  4804: "请输入域名，如domain.com",
  4805: "路径",
  4806: "如：DC=molasync,DC=cc",
  4807: "账号",
  4808: "请输入账号",
  4809: "企业ID",
  4810: "请输入CorpID",
  4811: "应用ID",
  4812: "请输入Agent ID",
  4813: "应用秘钥",
  4814: "请输入secret",
  4815: "通讯录秘钥",
  4816: "请输入address secret",
  4817: "移动端schema",
  4818: "请输入移动端schema",
  4819: "应用键值",
  4820: "请输入移动端AppKey",
  4821: "扫码应用ID",
  4822: "请输入扫码AppId",
  4823: "扫码应用秘钥",
  4824: "请输入扫码AppSecret",
  4825: "网盘移动端应用ID",
  4826: "网盘移动端秘钥",
  4827: "本地存储",
  4828: "S3存储",
  4829: "请将存储盘映射到文件夹：",
  4830: "Secret",
  4831: "请输入secret key",
  4832: "Access",
  4833: "请输入access key",
  4834: "Server",
  4835: "请输入server url",
  4836: "Bucket",
  4837: "请输入bucket name",
  4838: "工号模式",
  4839: "打开此选项，将使用工号作为用户的登录账号",
  4840: "高强度密码",
  4841: "打开此选项，企业成员需设置10-20位包含大小写字母、特殊字符及数字的组合作为密码",
  4842: "此配置项仅在私有化部署的版本中有效，当前版本不支持",
  4843: "请输入当前用户登录密码",
  4844: "异常行为报警",
  4845: "24小时内下载文件数量超过",
  4846: "个",
  4847: "24小时内下载流量超过",
  4848: "GB",
  4849: "部门成员有反常的大规模下载将通知部门经理及管理员",
  4850: "是否需要进行登录认证",
  4851: "加密方式",
  4852: "测试",
  4853: "请输入接收方邮箱，我们将发送测试邮件到这个邮箱。点击确定，调用接口进行发送，并返回测试结果",
  4854: "导出用户参与文件列表",
  4855: "正在生成文件列表",
  4856: "请选择接收人",
  4857: "请输入1~99之间的整数",
  4858: "使用默认设置",
  4859: "仅名称",
  4860: "正在向巴别鸟云端网盘编辑文件。如果您离开此页面，编辑内容无法保存。",
  4861: "文件夹和文件混排",
  4864: "文件夹下载的两种方式：利用客户端下载，或者在登录状态下进行下载",
  4865: "该文件支持在登录状态下进行下载",
  4900: "使用情况统计",
  4901: "企业税号",
  4902: "公司发票必填此项",
  4903: "联系人电话"
};
var _default = exports["default"] = localString_cn_part1;

},{"1454":1454}],811:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _size = _interopRequireDefault(require(837));
var _TextAlignment = _interopRequireDefault(require(819));
/**
 *
 */

function MMBasicData() {
  return this;
}
;
MMBasicData.backgroundcolor = "#ffffff";
MMBasicData.pageSize = new _size["default"](15, 20);
MMBasicData.toStringAlignment = function (alignment) {
  var strAlign = 'left';
  if (alignment == _TextAlignment["default"].Center) {
    strAlign = 'center';
  }
  if (alignment == _TextAlignment["default"].Right) {
    strAlign = 'right';
  }
  return strAlign;
};
var mola = {};
mola.Common = MMBasicData;
MMBasicData.getPdfStartlayerZ_index = function () {
  return 1;
};
MMBasicData.getMaxPdflayerZ_index = function () {
  return 100000000;
};
MMBasicData.getCanvasStartZ_index = function () {
  return 1 * MMBasicData.getMaxPdflayerZ_index();
};
MMBasicData.getTextStartlayerZ_index = function () {
  return 2 * MMBasicData.getMaxPdflayerZ_index();
};
MMBasicData.getCommentStartlayerZ_index = function () {
  return 3 * MMBasicData.getMaxPdflayerZ_index();
};
MMBasicData.getEditorMaxZ_index = function () {
  return 4 * MMBasicData.getMaxPdflayerZ_index();
};
MMBasicData.getO2OStartLayerZ_index = function () {
  return 5 * MMBasicData.getMaxPdflayerZ_index();
};
MMBasicData.getO2OCommentStartlayerZ_index = function () {
  return 6 * MMBasicData.getMaxPdflayerZ_index();
};
MMBasicData.getO2OMaxLayerZ_index = function () {
  return 7 * MMBasicData.getMaxPdflayerZ_index();
};
MMBasicData.getO2OTopLayerZ_index = function () {
  return 8 * MMBasicData.getMaxPdflayerZ_index();
};
var _default = exports["default"] = MMBasicData;

},{"1184":1184,"1454":1454,"819":819,"837":837}],837:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
var _goog = _interopRequireDefault(require(823));
/**
 * Created by mashx on 16-7-27.
 */

// Copyright 2007 The Closure Library Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS-IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

/**
 * @fileoverview A utility class for representing two-dimensional sizes.
 */

/**
 * Class for representing sizes consisting of a width and height. Undefined
 * width and height support is deprecated and results in compiler warning.
 * @param {number} width Width.
 * @param {number} height Height.
 * @constructor
 */

function Size(width, height) {
  /**
   * Width
   * @type {number}
   */
  this.width = width;

  /**
   * Height
   * @type {number}
   */
  this.height = height;
}
;

/**
 * Compares sizes for equality.
 * @param {Size} a A Size.
 * @param {Size} b A Size.
 * @return {boolean} True iff the sizes have equal widths and equal
 *     heights, or if both are null.
 */
Size.equals = function (a, b) {
  if (a == b) {
    return true;
  }
  if (!a || !b) {
    return false;
  }
  return a.width == b.width && a.height == b.height;
};

/**
 * @return {!Size} A new copy of the Size.
 */
Size.prototype.clone = function () {
  return new Size(this.width, this.height);
};
if (_goog["default"].DEBUG) {
  /**
   * Returns a nice string representing size.
   * @return {string} In the form (50 x 73).
   * @override
   */
  Size.prototype.toString = function () {
    return '(' + this.width + ' x ' + this.height + ')';
  };
}

/**
 * @return {number} The longer of the two dimensions in the size.
 */
Size.prototype.getLongest = function () {
  return Math.max(this.width, this.height);
};

/**
 * @return {number} The shorter of the two dimensions in the size.
 */
Size.prototype.getShortest = function () {
  return Math.min(this.width, this.height);
};

/**
 * @return {number} The area of the size (width * height).
 */
Size.prototype.area = function () {
  return this.width * this.height;
};

/**
 * @return {number} The perimeter of the size (width + height) * 2.
 */
Size.prototype.perimeter = function () {
  return (this.width + this.height) * 2;
};

/**
 * @return {number} The ratio of the size's width to its height.
 */
Size.prototype.aspectRatio = function () {
  return this.width / this.height;
};

/**
 * @return {boolean} True if the size has zero area, false if both dimensions
 *     are non-zero numbers.
 */
Size.prototype.isEmpty = function () {
  return !this.area();
};

/**
 * Clamps the width and height parameters upward to integer values.
 * @return {!Size} This size with ceil'd components.
 */
Size.prototype.ceil = function () {
  this.width = Math.ceil(this.width);
  this.height = Math.ceil(this.height);
  return this;
};

/**
 * @param {!Size} target The target size.
 * @return {boolean} True if this Size is the same size or smaller than the
 *     target size in both dimensions.
 */
Size.prototype.fitsInside = function (target) {
  return this.width <= target.width && this.height <= target.height;
};

/**
 * Clamps the width and height parameters downward to integer values.
 * @return {!Size} This size with floored components.
 */
Size.prototype.floor = function () {
  this.width = Math.floor(this.width);
  this.height = Math.floor(this.height);
  return this;
};

/**
 * Rounds the width and height parameters to integer values.
 * @return {!Size} This size with rounded components.
 */
Size.prototype.round = function () {
  this.width = Math.round(this.width);
  this.height = Math.round(this.height);
  return this;
};

/**
 * Scales this size by the given scale factors. The width and height are scaled
 * by {@code sx} and {@code opt_sy} respectively.  If {@code opt_sy} is not
 * given, then {@code sx} is used for both the width and height.
 * @param {number} sx The scale factor to use for the width.
 * @param {number=} opt_sy The scale factor to use for the height.
 * @return {!Size} This Size object after scaling.
 */
Size.prototype.scale = function (sx, opt_sy) {
  var sy = _goog["default"].isNumber(opt_sy) ? opt_sy : sx;
  this.width *= sx;
  this.height *= sy;
  return this;
};

/**
 * Uniformly scales the size to fit inside the dimensions of a given size. The
 * original aspect ratio will be preserved.
 *
 * This function assumes that both Sizes contain strictly positive dimensions.
 * @param {!Size} target The target size.
 * @return {!Size} This Size object, after optional scaling.
 */
Size.prototype.scaleToFit = function (target) {
  var s = this.aspectRatio() > target.aspectRatio() ? target.width / this.width : target.height / this.height;
  return this.scale(s);
};
var _default = exports["default"] = Size;

},{"1184":1184,"1437":1437,"1454":1454,"1463":1463,"1478":1478,"823":823}],823:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
require(1432);
var _typeof2 = _interopRequireDefault(require(1197));
// Copyright 2006 The Closure Library Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS-IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

/**
 * @fileoverview Bootstrap for the Google JS Library (Closure).
 *
 * In uncompiled mode base.js will write out Closure's deps file, unless the
 * global <code>CLOSURE_NO_DEPS</code> is set to true.  This allows projects to
 * include their own deps file(s) from different locations.
 *
 * Avoid including base.js more than once. This is strictly discouraged and not
 * supported. goog.require(...) won't work properly in that case.
 *
 * @author arv@google.com (Erik Arvidsson)
 *
 * @provideGoog
 */

/**
 * @define {boolean} Overridden to true by the compiler when
 *     --process_closure_primitives is specified.
 */
var COMPILED = false;

/**
 * Base namespace for the Closure library.  Checks to see goog is already
 * defined in the current scope before assigning to prevent clobbering if
 * base.js is loaded more than once.
 *
 * @const
 */
var goog = goog || {};

/**
 * Reference to the global context.  In most cases this will be 'window'.
 */
goog.global = Window;

/**
 * Returns true if the specified value is not undefined.
 * WARNING: Do not use this to test if an object has a property. Use the in
 * operator instead.
 *
 * @param {?} val Variable to test.
 * @return {boolean} Whether variable is defined.
 */
goog.isDef = function (val) {
  // void 0 always evaluates to undefined and hence we do not need to depend on
  // the definition of the global variable named 'undefined'.
  return val !== void 0;
};

// NOTE(nnaze): The debug DOM loader was included in base.js as an original way
// to do "debug-mode" development.  The dependency system can sometimes be
// confusing, as can the debug DOM loader's asynchronous nature.
//
// With the DOM loader, a call to goog.require() is not blocking -- the script
// will not load until some point after the current script.  If a namespace is
// needed at runtime, it needs to be defined in a previous script, or loaded via
// require() with its registered dependencies.
//
// User-defined namespaces may need their own deps file. For a reference on
// creating a deps file, see:
// Externally: https://developers.google.com/closure/library/docs/depswriter
//
// Because of legacy clients, the DOM loader can't be easily removed from
// base.js.  Work is being done to make it disableable or replaceable for
// different environments (DOM-less JavaScript interpreters like Rhino or V8,
// for example). See bootstrap/ for more information.

/**
 * @define {boolean} Whether to enable the debug loader.
 *
 * If enabled, a call to goog.require() will attempt to load the namespace by
 * appending a script tag to the DOM (if the namespace has been registered).
 *
 * If disabled, goog.require() will simply assert that the namespace has been
 * provided (and depend on the fact that some outside tool correctly ordered
 * the script).
 */
goog.DEBUG = false;

/**
 * @param {string} msg
 * @private
 */
goog.logToConsole_ = function (msg) {
  if (goog.global.console) {
    goog.global.console['error'](msg);
  }
};

/**
 * Implements a system for the dynamic resolution of dependencies that works in
 * parallel with the BUILD system. Note that all calls to goog.require will be
 * stripped by the JSCompiler when the --process_closure_primitives option is
 * used.
 * @see goog.provide
 * @param {string} name Namespace to include (as was given in goog.provide()) in
 *     the form "goog.package.part".
 * @return {?} If called within a goog.module file, the associated namespace or
 *     module otherwise null.
 */
goog.require = function (name) {
  // If the object already exists we do not need do do anything.
  if (!COMPILED) {
    if (goog.ENABLE_DEBUG_LOADER && goog.IS_OLD_IE_) {
      goog.maybeProcessDeferredDep_(name);
    }
    if (goog.isProvided_(name)) {
      if (goog.isInModuleLoader_()) {
        return goog.module.getInternal_(name);
      }
    } else if (goog.ENABLE_DEBUG_LOADER) {
      var path = goog.getPathFromDeps_(name);
      if (path) {
        goog.writeScripts_(path);
      } else {
        var errorMessage = 'goog.require could not find: ' + name;
        goog.logToConsole_(errorMessage);
        throw Error(errorMessage);
      }
    }
    return null;
  }
};

/**
 * Path for included scripts.
 * @type {string}
 */
goog.basePath = '';

/**
 * A hook for overriding the base path.
 * @type {string|undefined}
 */
goog.global.CLOSURE_BASE_PATH;

/**
 * Whether to write out Closure's deps file. By default, the deps are written.
 * @type {boolean|undefined}
 */
goog.global.CLOSURE_NO_DEPS;

/**
 * A function to import a single script. This is meant to be overridden when
 * Closure is being run in non-HTML contexts, such as web workers. It's defined
 * in the global scope so that it can be set before base.js is loaded, which
 * allows deps.js to be imported properly.
 *
 * The function is passed the script source, which is a relative URI. It should
 * return true if the script was imported, false otherwise.
 * @type {(function(string): boolean)|undefined}
 */
goog.global.CLOSURE_IMPORT_SCRIPT;

/**
 * Null function used for default values of callbacks, etc.
 * @return {void} Nothing.
 */
goog.nullFunction = function () {};

/**
 * When defining a class Foo with an abstract method bar(), you can do:
 * Foo.prototype.bar = goog.abstractMethod
 *
 * Now if a subclass of Foo fails to override bar(), an error will be thrown
 * when bar() is invoked.
 *
 * Note: This does not take the name of the function to override as an argument
 * because that would make it more difficult to obfuscate our JavaScript code.
 *
 * @type {!Function}
 * @throws {Error} when invoked to indicate the method should be overridden.
 */
goog.abstractMethod = function () {
  throw Error('unimplemented abstract method');
};

/**
 * Adds a {@code getInstance} static method that always returns the same
 * instance object.
 * @param {!Function} ctor The constructor for the class to add the static
 *     method to.
 */
goog.addSingletonGetter = function (ctor) {
  // instance_ is immediately set to prevent issues with sealed constructors
  // such as are encountered when a constructor is returned as the export object
  // of a goog.module in unoptimized code.
  ctor.instance_ = undefined;
  ctor.getInstance = function () {
    if (ctor.instance_) {
      return ctor.instance_;
    }
    if (goog.DEBUG) {
      // NOTE: JSCompiler can't optimize away Array#push.
      goog.instantiatedSingletons_[goog.instantiatedSingletons_.length] = ctor;
    }
    return ctor.instance_ = new ctor();
  };
};

/**
 * All singleton classes that have been instantiated, for testing. Don't read
 * it directly, use the {@code goog.testing.singleton} module. The compiler
 * removes this variable if unused.
 * @type {!Array<!Function>}
 * @private
 */
goog.instantiatedSingletons_ = [];

//==============================================================================
// Language Enhancements
//==============================================================================

/**
 * This is a "fixed" version of the typeof operator.  It differs from the typeof
 * operator in such a way that null returns 'null' and arrays return 'array'.
 * @param {?} value The value to get the type of.
 * @return {string} The name of the type.
 */
goog.typeOf = function (value) {
  var s = (0, _typeof2["default"])(value);
  if (s == 'object') {
    if (value) {
      // Check these first, so we can avoid calling Object.prototype.toString if
      // possible.
      //
      // IE improperly marshals typeof across execution contexts, but a
      // cross-context object will still return false for "instanceof Object".
      if (value instanceof Array) {
        return 'array';
      } else if (value instanceof Object) {
        return s;
      }

      // HACK: In order to use an Object prototype method on the arbitrary
      //   value, the compiler requires the value be cast to type Object,
      //   even though the ECMA spec explicitly allows it.
      var className = Object.prototype.toString.call( /** @type {!Object} */
      value);
      // In Firefox 3.6, attempting to access iframe window objects' length
      // property throws an NS_ERROR_FAILURE, so we need to special-case it
      // here.
      if (className == '[object Window]') {
        return 'object';
      }

      // We cannot always use constructor == Array or instanceof Array because
      // different frames have different Array objects. In IE6, if the iframe
      // where the array was created is destroyed, the array loses its
      // prototype. Then dereferencing val.splice here throws an exception, so
      // we can't use goog.isFunction. Calling typeof directly returns 'unknown'
      // so that will work. In this case, this function will return false and
      // most array functions will still work because the array is still
      // array-like (supports length and []) even though it has lost its
      // prototype.
      // Mark Miller noticed that Object.prototype.toString
      // allows access to the unforgeable [[Class]] property.
      //  15.2.4.2 Object.prototype.toString ( )
      //  When the toString method is called, the following steps are taken:
      //      1. Get the [[Class]] property of this object.
      //      2. Compute a string value by concatenating the three strings
      //         "[object ", Result(1), and "]".
      //      3. Return Result(2).
      // and this behavior survives the destruction of the execution context.
      if (className == '[object Array]' ||
      // In IE all non value types are wrapped as objects across window
      // boundaries (not iframe though) so we have to do object detection
      // for this edge case.
      typeof value.length == 'number' && typeof value.splice != 'undefined' && typeof value.propertyIsEnumerable != 'undefined' && !value.propertyIsEnumerable('splice')) {
        return 'array';
      }
      // HACK: There is still an array case that fails.
      //     function ArrayImpostor() {}
      //     ArrayImpostor.prototype = [];
      //     var impostor = new ArrayImpostor;
      // this can be fixed by getting rid of the fast path
      // (value instanceof Array) and solely relying on
      // (value && Object.prototype.toString.vall(value) === '[object Array]')
      // but that would require many more function calls and is not warranted
      // unless closure code is receiving objects from untrusted sources.

      // IE in cross-window calls does not correctly marshal the function type
      // (it appears just as an object) so we cannot use just typeof val ==
      // 'function'. However, if the object has a call property, it is a
      // function.
      if (className == '[object Function]' || typeof value.call != 'undefined' && typeof value.propertyIsEnumerable != 'undefined' && !value.propertyIsEnumerable('call')) {
        return 'function';
      }
    } else {
      return 'null';
    }
  } else if (s == 'function' && typeof value.call == 'undefined') {
    // In Safari typeof nodeList returns 'function', and on Firefox typeof
    // behaves similarly for HTML{Applet,Embed,Object}, Elements and RegExps. We
    // would like to return object for those and we can detect an invalid
    // function by making sure that the function object has a call method.
    return 'object';
  }
  return s;
};

/**
 * Returns true if the specified value is null.
 * @param {?} val Variable to test.
 * @return {boolean} Whether variable is null.
 */
goog.isNull = function (val) {
  return val === null;
};

/**
 * Returns true if the specified value is defined and not null.
 * @param {?} val Variable to test.
 * @return {boolean} Whether variable is defined and not null.
 */
goog.isDefAndNotNull = function (val) {
  // Note that undefined == null.
  return val != null;
};

/**
 * Returns true if the specified value is an array.
 * @param {?} val Variable to test.
 * @return {boolean} Whether variable is an array.
 */
goog.isArray = function (val) {
  return goog.typeOf(val) == 'array';
};

/**
 * Returns true if the object looks like an array. To qualify as array like
 * the value needs to be either a NodeList or an object with a Number length
 * property. As a special case, a function value is not array like, because its
 * length property is fixed to correspond to the number of expected arguments.
 * @param {?} val Variable to test.
 * @return {boolean} Whether variable is an array.
 */
goog.isArrayLike = function (val) {
  var type = goog.typeOf(val);
  // We do not use goog.isObject here in order to exclude function values.
  return type == 'array' || type == 'object' && typeof val.length == 'number';
};

/**
 * Returns true if the object looks like a Date. To qualify as Date-like the
 * value needs to be an object and have a getFullYear() function.
 * @param {?} val Variable to test.
 * @return {boolean} Whether variable is a like a Date.
 */
goog.isDateLike = function (val) {
  return goog.isObject(val) && typeof val.getFullYear == 'function';
};

/**
 * Returns true if the specified value is a string.
 * @param {?} val Variable to test.
 * @return {boolean} Whether variable is a string.
 */
goog.isString = function (val) {
  return typeof val == 'string';
};

/**
 * Returns true if the specified value is a boolean.
 * @param {?} val Variable to test.
 * @return {boolean} Whether variable is boolean.
 */
goog.isBoolean = function (val) {
  return typeof val == 'boolean';
};

/**
 * Returns true if the specified value is a number.
 * @param {?} val Variable to test.
 * @return {boolean} Whether variable is a number.
 */
goog.isNumber = function (val) {
  return typeof val == 'number';
};

/**
 * Returns true if the specified value is a function.
 * @param {?} val Variable to test.
 * @return {boolean} Whether variable is a function.
 */
goog.isFunction = function (val) {
  return goog.typeOf(val) == 'function';
};

/**
 * Returns true if the specified value is an object.  This includes arrays and
 * functions.
 * @param {?} val Variable to test.
 * @return {boolean} Whether variable is an object.
 */
goog.isObject = function (val) {
  var type = (0, _typeof2["default"])(val);
  return type == 'object' && val != null || type == 'function';
  // return Object(val) === val also works, but is slower, especially if val is
  // not an object.
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * Usage:
 * <pre>
 * function ParentClass(a, b) { }
 * ParentClass.prototype.foo = function(a) { };
 *
 * function ChildClass(a, b, c) {
 *   ChildClass.base(this, 'constructor', a, b);
 * }
 * goog.inherits(ChildClass, ParentClass);
 *
 * var child = new ChildClass('a', 'b', 'see');
 * child.foo(); // This works.
 * </pre>
 *
 * @param {!Function} childCtor Child class.
 * @param {!Function} parentCtor Parent class.
 */
goog.inherits = function (childCtor, parentCtor) {
  /** @constructor */
  function tempCtor() {}
  if (!parentCtor) {
    console.log('parentCtor is undefined');
  }
  tempCtor.prototype = parentCtor.prototype;
  childCtor.superClass_ = parentCtor.prototype;
  childCtor.prototype = new tempCtor();
  /** @override */
  childCtor.prototype.constructor = childCtor;

  /**
   * Calls superclass constructor/method.
   *
   * This function is only available if you use goog.inherits to
   * express inheritance relationships between classes.
   *
   * NOTE: This is a replacement for goog.base and for superClass_
   * property defined in childCtor.
   *
   * @param {!Object} me Should always be "this".
   * @param {string} methodName The method name to call. Calling
   *     superclass constructor can be done with the special string
   *     'constructor'.
   * @param {...*} var_args The arguments to pass to superclass
   *     method/constructor.
   * @return {*} The return value of the superclass method/constructor.
   */
  childCtor.base = function (me, methodName, var_args) {
    // Copying using loop to avoid deop due to passing arguments object to
    // function. This is faster in many JS engines as of late 2014.
    var args = new Array(arguments.length - 2);
    for (var i = 2; i < arguments.length; i++) {
      args[i - 2] = arguments[i];
    }
    return parentCtor.prototype[methodName].apply(me, args);
  };
};

/*
 * To support uncompiled, strict mode bundles that use eval to divide source
 * like so:
 *    eval('someSource;//# sourceUrl sourcefile.js');
 * We need to export the globally defined symbols "goog" and "COMPILED".
 * Exporting "goog" breaks the compiler optimizations, so we required that
 * be defined externally.
 * NOTE: We don't use goog.exportSymbol here because we don't want to trigger
 * extern generation when that compiler option is enabled.
 */
if (!COMPILED) {
  goog.global['COMPILED'] = COMPILED;
}
var _default = exports["default"] = goog;

},{"1184":1184,"1197":1197,"1432":1432,"1437":1437,"1454":1454,"1463":1463,"1478":1478}],819:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var TextAlignment = {
  Left: 0,
  Center: 1,
  Right: 2
};
var _default = exports["default"] = TextAlignment;

},{"1454":1454}],325:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require(1180));
var _keyMirror2 = _interopRequireDefault(require(103));
/**
 * Events type for mola disk app
 * Created by manjun.han
 * 2015.9.1
 */

var MDEvents = (0, _keyMirror2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({
  trashRemove: null,
  TaskCreated: null,
  RefreshOnlineOfficeEditor: null,
  FileListLoadStateChanged: null,
  SortIndex: null,
  SharePermissionChangedNew: null,
  Goto_Evaluation: null,
  undo_chat: null,
  addFileInCurrentFolder: null,
  ClientShowSnackBar: null,
  refreshPenList: null,
  refreshMyFocusFiles: null,
  RefreshReceiveArchivePanel: null,
  OpenFolderInArchivePanelFromOtherChannel: null,
  RefreshCurFolder: null,
  Connect_Ready: null,
  Move_toolbar_clicked: null,
  Remove_comment_toolbar: null,
  /**
   *  Current file table row selection changed,
   *  used for dynamic show actionToolbar
   */
  mailMouseMove: null,
  CloseSettingWin: null,
  RowSelection_Changed: null,
  FilePath_Changed: null,
  Set_CurrentFileInfor: null,
  ShowInforPanel: null,
  showVerListPanel: null,
  DISPLAY_PDF_BAR: null,
  DISPLAY_ZOOM_BAR: null,
  HIDE_ZOOM_BAR: null,
  DISP_PAGE_FINISH: null,
  RENDER_OBJ_FINISH: null,
  AppTab_Changed: null,
  UnreadMsgCountChangedTo: null,
  NewMsgReceived: null,
  NewDashboardMsg: null,
  SharesChanged: null,
  ShareChanged: null,
  ShareClosed: null,
  ShareClosed_board: null,
  SharePermissionChanged: 'share permission changed',
  ShareStatusChanged: 'open or close share',
  ShareToAllChanged: 'is share to all?',
  VersionListChanged: 'version list change',
  POMELO_DISCONNECT: null,
  POMELO_RECONNECT: null,
  /**
   * parameter is an Array, of information about deleted files.
   * if the version is defined, not the file, but that version was deleted
   * the information contains
   *  fileName, fileId, fileVersion
   */
  SOME_SHARE_DELETE: null,
  Mouse_up: null,
  Comment_changed: null,
  Comment_State_Sync: null,
  DispVersionChanged: null,
  SHOW_COMMENTS: null,
  TextComment_status: 'text comment status',
  OrderCount: 'order unpaid count',
  TeamKick: 'TeamKick',
  RemovedBeforeJoin: null,
  LoginInEditor: 'LoginInEditor',
  UserLogined: null,
  TeamCreated: null,
  StarmarkChanged: null,
  // Sync for fileInfo

  FileInfo_Changed: null,
  OpenFile: null,
  //
  // Editor Action
  //
  EditorPageIndexChanged: null,
  ZOOM_CHANGED: null,
  //
  // events for keep sync with treePanel
  //
  FolderCreated: null,
  FolderDeleted: null,
  FolderRenamed: null,
  FolderCopied: null,
  FolderMoved: null,
  FolderCreatedByOther: null,
  FileUploadedByOther: null,
  FilesUploadedByOther: null,
  SwicthToHomeAndOpenFile: null,
  REFRESH_VERSIONS: null,
  TeamRemoved: null,
  TeamJoined: null,
  CloseLink: null,
  commentsPerChanged: null,
  FileCopy: null,
  FileMoveIn: null,
  FileMoveOut: null,
  FileMove: null,
  Department_addMem: null,
  Department_update: null,
  Department_updateMem: null,
  Department_removeMem: null,
  Department_removed: null,
  Department_created: null,
  Department_openInfo: null,
  //// tag

  //
  Tag_Add_To_File: null,
  Tag_Remove_From_File: null,
  TagInfo_Changed: null,
  Tag_Remove_From_Search: null,
  Tag_Delete_From_File: null,
  Clear_Tag_Selection: null,
  OpenFolderFromOtherChannel: null,
  Payment_message: null,
  RowSelection_Closed: null,
  TapOnWhiteSpaceInDoc: null,
  NewEditVersionUploaded: null,
  RefreshZoomDisp: null,
  ClearCheckAll: null,
  OpenEvalListPanel: null,
  OpenEvalToolbar: null,
  FileOperationUndo: null,
  Disable3DWheel: null,
  Enable3DWheel: null,
  MeiqiaServiceLoaded: null,
  evaluationChangedInEvaluationPanel: null,
  WindowScrolled: null,
  evaluationChanged: null,
  ChatMessageSendSuccess: null,
  ChatMessageSendFailed: null,
  NewNotificationRecived: null,
  //右上角消息通知

  FileListIconSizeChanged: null,
  GroupAdded: null,
  GroupDeleted: null,
  GroupEdited: null,
  Salon_op_null: null,
  Salon_op_rect: null,
  Obj_Selected: null,
  Null_Selected: null,
  RelayoutActionToolbar: null,
  FolderOpenedChanged: null,
  StickOnTop: null,
  CancelStickOnTop: null,
  FileSyncStateChanged: null,
  beforeChangeToNextFile: null,
  afterChangeToNextFile: null,
  toolbarChanged: null,
  salonStatusChanged: null,
  CommentToolChangedNotByClick: null,
  UpdateChannleUnreadNum: null,
  // ----------------- 更新

  UpdateArchiveUnreadNum: null,
  // ----------------- 更新

  ClientUpload_Start: null,
  ClientUpload_Progress: null,
  ClientUpload_Finished: null,
  ClientUpload_Error: null,
  ClientDown_Start: null,
  ClientDown_Progress: null,
  ClientDown_Finished: null,
  ClientDown_Error: null,
  ClientDown_Cancel: null,
  ClientShare_LocalFile: null,
  DelFileFormCurFolder: null,
  CurFileChanged: null,
  SwicthLeftPanel: null,
  AddMacPool: null,
  // A ----------------------------------------------------------- A
  AUDIO_ENDED: "AUDIO ENDED",
  AttrSearch_Cleared: null,
  AttrSearch_ItemRemoved: null,
  AttrSearch_Refresh: null,
  // B ----------------------------------------------------------- B
  BEFORE_CLOSED: "beforeClosed",
  BEFORE_OPENED: "beforeOpened",
  BEFORE_UPLOAD: "BEFORE_UPLOAD",
  BEFORE_CREATING_TASKBOARD: "BEFORE_CREATING_TASKBOARD",
  BLUR: "blur",
  // C ----------------------------------------------------------- C
  CHANGED: "changed",
  channelTab_Changed: null,
  CLEAR_UNREADED_MESSAGE: "clearUnreadedMessage",
  CLICK: "click",
  CLICK_SHARE_SLIDE_POPUP: "click.shareSlidePopup",
  CLOSE: "close",
  CLOSED: "closed",
  CLOSE_PANELS: "closePanels",
  COMMENT_CLICKED: "COMMENT_CLICKED",
  COMMENT_MOVE_TO_OFFSET: "COMMENT_MOVE_TO_OFFSET",
  COMMENT_NUMBER_CHANGED: "COMMENT_NUMBER_CHANGED",
  COMMIT_ROUND: "commitRound",
  COMMENT_CREATE: "CommentCreate",
  COMMENT_REMOVE: "CommentRemove",
  // D ----------------------------------------------------------- D
  DATA_INDEX_READY: "dataIndexReady",
  DATA_DATA_READY: "dataDataReady",
  DATA_READY: "dataReady",
  DISABLE_BUTTON: "disableButton",
  DISPLAY_IMG_FULLSCREEN: "DISPLAY_IMG_FULLSCREEN",
  DISCUSSION_PANEL_OPENED: "DiscussionPanelOpened",
  DISCUSSION_PANEL_CLOSED: "DiscussionPanelClosed",
  DOUBLE_TAP: "doubletap",
  DROPZONE_ERROR: "DROPZONE_ERROR",
  DOWNLOAD_PROGRESS: "Download_Progress",
  // E ----------------------------------------------------------- E
  ERROR: "ERROR",
  // F ----------------------------------------------------------- F
  FileChanged: "FileChanged",
  FILETYPE_ERROR: "FILETYPE_ERROR",
  FOCUS: "focus",
  FAIL: "FAIL",
  // H ----------------------------------------------------------- H
  HEIGHT_CHANGED: "HEIGHT_CHANGED",
  HAS_VIRUS: "HAS_VIRUS",
  // I ----------------------------------------------------------- I
  IMG_FULLSCREEN_END: "IMG_FULLSCREEN_END",
  // L ----------------------------------------------------------- L
  LONG_PRESS: "longpress",
  LOCK_FILE: null,
  // M ----------------------------------------------------------- M
  MARK_READY: 'MARK_READY',
  MOUSE_CLICK_LOG_POS: 'mouse_click_logic_position',
  // N ----------------------------------------------------------- N
  NULL_OPERATION: "NULL_OPERATION",
  NEW_MESSAGE: "newMessage",
  NEW_ROUND: "newRound",
  NEXT_COMMENT: "nextComment",
  // O ----------------------------------------------------------- O
  OPENED: "opened",
  OPERATION_CHANGED: "OPERATION_CHANGED",
  ORIENTATION_CHANGED: "OrientationChanged",
  // P ----------------------------------------------------------- P
  PAN: "pan",
  PAN_END: "panend",
  PAN_START: "panstart",
  PARTICIPANT_ENTER: "ParticipantEnter",
  PARTICIPANT_LEFT: "ParticipantLeft",
  //传入参数:function(stringUserId)

  PINCH: "pinch",
  PINCH_END: "pinchend",
  PINCH_START: "pinchstart",
  PLAY: "PLAY",
  ROGRESS2: "ROGRESS2",
  PREVIOUS_COMMENT: "previousComment",
  // R ----------------------------------------------------------- R
  ROW_COUNT_CHANGED: "ROW_COUNT_CHANGED",
  // S ----------------------------------------------------------- S

  // -------------- salon
  SALON_MESSAGE: "Salon_message",
  SELECT_COMMENT_OPERATION: "SELECT_COMMENT_OPERATION",
  SELECT_DRAW_OPERATION: "SELECT_DRAW_OPERATION",
  SELECT_RECT_OPERATION: "SELECT_RECT_OPERATION",
  SELECT_LINE_OPERATION: "SELECT_LINE_OPERATION",
  SELECT_ERASER_OPERATION: "SELECT_ERASER_OPERATION",
  SELECT_MENU_ITEM: "selectMenutItem",
  SELECT_MOVE_OPERATION: "SELECT_MOVE_OPERATION",
  SELECT_SCALE_OPERATION: "SELECT_SCALE_OPERATION",
  SELECT_TAG_OPERATION: "SELECT_TAG_OPERATION",
  SELECT_NULL_OPERATION: "NULL_OPERATION",
  SELECT_TEXT_MARK_OPERATION: "SELECT_TEXT_MARK_OPERATION",
  SELECT_GRAPH_OPERATION: "SELECT_GRAPH_OPERATION",
  SELECT_SALON_PEN: "SELECT_SALON_PEN",
  SELECT_SALON_ERASER: "SELECT_SALON_ERASER",
  SEND_TEXT: "sendText",
  SET_OBJECT_SELECTION: "SET_OBJECT_SELECTION",
  SET_PAGE_INDEX: "SET_PAGE_INDEX",
  SET_SCALE: "SET_SCALE",
  SCALE_CHANGED: "SCALE_CHANGED",
  SCALE_ARRAY: "SCALE_ARRAY",
  SWIPE: "swipe",
  SWIPE_LEFT: "swipeleft",
  SWIPE_DOWN: "swipedown",
  SWIPE_RIGHT: "swiperight",
  SWIPE_UP: "swipeup",
  SALON_PEN_ADD: "salonpenadd",
  SALON_EARASER: "salonearaser",
  // T ----------------------------------------------------------- T
  TAP: "tap",
  TASK_BOARD_STROLLING: "TaskBoardStrolling",
  TASK_BOARD_CREATED: "TASKBOARD_CREATED",
  TASK_BOARD_CREATE_ERROR: "TASKBOARD_CREATE_ERROR",
  THROW: "throw",
  THROW_LEFT: "throwleft",
  THROW_RIGHT: "throwright",
  THROW_UP: "throwup",
  THROW_DOWN: "throwdown",
  TIME_UPDATE: "TIME_UPDATE",
  touchend: "touchend",
  touchmove: "touchmove",
  touchstart: "touchstart",
  TOGGEL_DISCUSSION_PANEL: "TOGGEL_DISCUSSION_PANEL",
  TreePanelToggle: null,
  THUMBNAIL_OK: "ThumbnailOk",
  // U ----------------------------------------------------------- U
  UPLOAD_FILE_ADDED: "UPLOAD_FILE_ADDED",
  UPLOAD_COMPLETE: "UPLOAD_COMPLETE",
  UPLOAD_ERROR: "UPLOAD_ERROR",
  UPLOAD_PROGRESS: "UPLOAD_PROGRESS",
  UPLOAD_SUCCESS: "UPLOAD_SUCCESS",
  UNDO_REDO: "UNDO_REDO",
  UPLOAD_FINISHED: "UPLOADFINISHED",
  UNLOCK_FILE: null,
  // V ----------------------------------------------------------- V
  VIEW_DID_RENDERED: "viewDidRendered",
  VIEW_DID_UNRENDERED: "viewDidUnRendered",
  VIEW_WILL_RENDERED: "viewWillRendered",
  VIEW_WILL_UNRENDERED: "viewWillUnRendered",
  // W ----------------------------------------------------------- W
  WHITEBOARD_CLOSED: "WHITEBOARD_CLOSED",
  SELF_CREATEL: "self_create",
  SELF_NEW_VERSION: "self_new_version",
  SELF_DELETE: "self_delete",
  FileReviewAdded: null,
  SearchDashBoard: null,
  SearchFilter_changed: null,
  TileRenderProgress: null,
  HideZoomRectLayer: null,
  FileArchived: null,
  PenCommentCreated: null,
  Mouse_over_toolbar: null,
  Search_pdf_text_cliked: null,
  Refresh_dashboard: null,
  weldMarkInserted: null,
  FilterTags: null,
  SignatureFrameChanged: null,
  FileSignatureChanged: null,
  fileSealChanged: null,
  FileListDispTypeChanged: null,
  VersionChangedByComment: null,
  updateFilterCondition: null,
  EnterOtherMenuItem: null,
  FileLoadedInBin: null,
  currentUserInfoLoaded: null,
  DOWNLOAD_FINISHED: null,
  DOWNLOAD_ADDED: null,
  DownloadInit: null,
  FileTableRowChanged: null,
  SearchFileListLoadStateChanged: null,
  DisplayOldVersion: null,
  DisplayCurVersion: null,
  excelAiUploaded: null,
  ToggleAIChat: null,
  tiptopUploadFile: null,
  aiUploadFile: null,
  OcrFile: null,
  closeFileOcrPanel: null,
  closeFileAIPanel: null
}, "tiptopUploadFile", null), "CloseEdit", null), "AgentCreate", null), "AgentDel", null), "agentRefresh", null), "agentKnowledgeRefresh", null), "RefreshIcon", null), "RefreshArchiveTable", null), "RefreshClassifyTreeNode", null));
window.MDEvents = MDEvents;
var _default = exports["default"] = MDEvents;

},{"103":103,"1180":1180,"1184":1184,"1454":1454}],1180:[function(require,module,exports){
var toPropertyKey = require(1196);
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"1196":1196}],1196:[function(require,module,exports){
var _typeof = require(1197)["default"];
var toPrimitive = require(1195);
function _toPropertyKey(arg) {
  var key = toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"1195":1195,"1197":1197}],1195:[function(require,module,exports){
var _typeof = require(1197)["default"];
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"1197":1197}],1197:[function(require,module,exports){
function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],103:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1422);
/**
 * Copyright 2013-2014 Facebook, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */

//"use strict";

/**
 * Constructs an enumeration with keys equal to their value.
 *
 * For example:
 *
 *   var COLORS = keyMirror({blue: null, red: null});
 *   var myColor = COLORS.blue;
 *   var isColorValid = !!COLORS[myColor];
 *
 * The last line could not be performed if the values of the generated enum were
 * not equal to their keys.
 *
 *   Input:  {key1: val1, key2: val2}
 *   Output: {key1: key1, key2: key2}
 *
 * @param {object} obj
 * @return {object}
 */
var keyMirror = function keyMirror(obj) {
  var ret = {};
  var key;
  if (!(obj instanceof Object && !Array.isArray(obj))) {
    throw new Error('keyMirror(...): Argument must be an object.');
  }
  for (key in obj) {
    if (obj.hasOwnProperty(key)) {
      ret[key] = key;
    }
  }
  return ret;
};
var _default = exports["default"] = keyMirror; //module.exports = keyMirror;

},{"1422":1422,"1454":1454}],1422:[function(require,module,exports){
var $ = require(1270);
var isArray = require(1300);

// `Array.isArray` method
// https://tc39.es/ecma262/#sec-array.isarray
$({ target: 'Array', stat: true }, {
  isArray: isArray
});

},{"1270":1270,"1300":1300}],73:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * @enum {number}
 */
var SnackbarSide = {
  TopLeft: 0,
  TopRight: 1,
  TopCenter: 2,
  BottomLeft: 3,
  BottomRight: 4,
  BottomCenter: 5
};
var _default = exports["default"] = SnackbarSide;

},{"1454":1454}],22:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1477);
require(1454);
require(1489);
require(1430);
require(1463);
require(1421);
require(1412);
require(1432);
require(1416);
require(1415);
require(1426);
require(1417);
require(1429);
require(1438);
var _Render = _interopRequireDefault(require(24));
var _RenderProxy = _interopRequireDefault(require(25));
var _Reflect_ = _interopRequireDefault(require(23));
var _MMBackboneExtend = _interopRequireDefault(require(19));
var _Dispatcher = _interopRequireDefault(require(18));
/**
*
*  Super class for the custom View , inherits from Backbone.View.
*  In addition , the class can also deal with the View's hierarchy management which
*  isn't provided by Backbone.View .
*
*  Create by manjun.han
*  2014.12.30
*/

/**
 * Base view for Backbonejs's view management. Here we see Backbone.View as the MVC pattern's C and
 * the Backbone.View.el as V That is we use Backbone.View as the Controller , we can also call it ViewController.
 * It will control the view's render action .Besides , the MMViewBase class as the super class of our app's
 * custom view , it defines many methods for the hierarchy management of the controllers , so that
 * we can resolve the problem of the communication among the objects.
 *
 * As we know , when our application become more complicated , we may create more and more controller
 * objects to complete the interaction.And with the viewRendered,view*UnRendered methods ,
 * we can also deal with the view's lifecycle , with these method we can remove the event listeners ,
 * custom some style property of the view.
 *
 * To prevent memeory leak , we must keep synchronous between the controller hiberarchy and the view hiberarchy.
 * When the view is removed from the page , the corresponding controller must be removed from the
 * controller hiberarchy.
 */

var MMViewBase = Backbone.View.extend({
  /**
   * Reference to the superView .
   */
  superView: null,
  /**
   * The subviews of current view.
   * @type {Array}
   */
  subViews: [],
  relationCache: [],
  /**
   * Used for create the view's html template fragment.
   * The property can be a string including the html stirng , or a
   * function that return the html string.We can use _.result(this , "tmpl") to
   * get the final html string.
   *
   * @type {String||Function}
   */
  tmpl: "",
  _compiler: null,
  /**
   * Define class name for view.el
   * @return {String|Function} 符合css className规范的字符串
   */
  className: function className() {
    return '';
  },
  /**
   * Delegate event handlers to current view.Sub class can overwrite this method ,
   * and add own custom event delegate . If you want to keep the super view's event delegate,
   * you should mixin super view's events listeners at the same time , as following
   *
   * events:function(){
   *        var subViewEvents = {
   *            "click .button":"buttonClickHandler"
   *        }
   *
   *        var superEvents = superClass.ptototype.events;
   *        // superEvents may be an event object or a function return an event object
   *        superEvents = _.isFunction(superEvents) ? superEvents.call(this) : superEvents ;
   *
   *        var result = _.extend({},superEvents,subViewEvents);
   *        return result ;
   * }
   * @returns {Object|Function}
   */
  events: function events() {
    return {};
  },
  router: null,
  /**
   * @typedef {Object} RouterObject
   * @property {string}              path     the path string of the router
   * @property {function|MMViewBase} handler  the handler of the router
   */
  /**
   * view routers
   * @type {RouterObject[]}
   */
  routers: null,
  /**
   * route change handler
   * @param  {string} path - route path
   * @return {boolean} - 是否成功处理route
   */
  dispatchRoute: function dispatchRoute(path) {
    var self = this;
    var routers = _.isFunction(this.routers) ? this.routers() : this.routers;
    var checked = 0;
    if (routers && !_.isEmpty(routers)) {
      for (var i = 0; i < routers.length; i++) {
        var router = routers[i];
        var routerPath = router.path;
        var handler = router.handler;
        var routerPathReg = Backbone.Router.prototype._routeToRegExp.call(null, routerPath);
        if (routerPathReg.test(path)) {
          if (handler instanceof MMViewBase) {
            self.removeSubViews();
            var subView = handler;
            self.addSubView(subView);
            checked |= subView.dispatchRoute(path);
          } else if (_.isFunction(handler)) {
            var params = Backbone.Router.prototype._extractParameters(routerPathReg, path);
            var handleSuccess = handler.apply(null, params);
            checked = _.isBoolean(handleSuccess) ? handleSuccess : true;
          }
          break;
        }
      }
      if (!checked) {
        this.eachSubViews(function (subView) {
          checked |= subView.dispatchRoute(path);
        });
      }
    } else {
      this.eachSubViews(function (subView) {
        checked |= subView.dispatchRoute(path);
      });
    }
    return !!checked;
  },
  /**
   * 设置组件的默认全局默认设置，全局设置属性在组件的initProps方法中定义时，值必须是undefined，
   * 否则无法获得全局默认设置。
   *
   * 鉴于不是所有的组件都要全局设置，改方法在组件的决堤实现中根据具体情况在合适的位置调用此方法，
   * 此方法通常在initialize方法后调用
   *
   * @example
   *
   * // 组件的initPorps方法
   * initProps:function(){
   *   zIndex: undefined, // 正确
   *
   *   width: 0 // 错误，不会得到默认值，因为不是undefined
   * }
   *
   * // defaults对象
   * var defaults = {
   *   zIndex: 0,
   *
   *   width: 400
   * }
   *
   * this.setDefaults(defaults);
   *
   * @protected
   * @param {object} defaults - 全局默认设置对象
   */
  setDefaults: function setDefaults(defaults) {
    var self = this;
    _.each(defaults, function (value, key) {
      if (_.isUndefined(self[key])) {
        self[key] = value;
      }
    });
  },
  /**
   * Add namespace to the event name , used by jquery event or event delegate .
   *
   * @returns {Function}
   */
  $nsEventName: function $nsEventName(eventName) {
    return eventName + "." + this.cid;
  },
  prefixedName: function prefixedName(name, splitor) {
    splitor = splitor || '-';
    return this.cid + splitor + name;
  },
  /**
   * 添加View自己的构造器，实现对象私有属性的初始化，避免因继承带来的原型属性的共用问题
   *
   * Add constructor of MMViewBase , and when create a new View object ,
   * we need to initialize the object's own property , avoid sharing the same
   * property from the prorotype of super class.
   *
   * @param  {Option} opt
   *
   */
  constructor: function constructor(opt) {
    opt = opt || {};
    this.subViews = [];
    this.relationCache = [];
    var _reservedKeys = this._reservedKeys();
    this._tmplHolder = _.pick(opt, _reservedKeys);
    this.initReadonlyProperty();
    this.eventPenetrateSubView = _.isUndefined(opt.eventPenetrateSubView) ? true : opt.eventPenetrateSubView;
    Backbone.View.call(this, _.omit(opt, _reservedKeys));
    this._reMount();
  },
  /**
   * 可以在initialize方法中构建Backbone View的对象层级关系，
   * 之后在render方法中构建DOM视图
   * 避免在initialize中的opt对象中设置className,events等属性，请使用类的方法形式使用它们
   *
   * @param opt {Option}  The option object passed to the initialize method .
   *
   * @return {MMViewBase} Current view object .
   */
  initialize: function initialize(opt) {
    this.winId = MMViewBase.winId++;
    var initProps = this.initProps(opt);
    if (!_.isObject(initProps)) {
      throw new Error('initProps method must return an object.');
    }
    this._check(initProps);
    opt = _.extend(this, initProps, opt);
    this.$el.addClass(_.result(this, 'className'));
    var data = opt.data || {};
    this.render(data);
    return this;
  },
  initReadonlyProperty: function initReadonlyProperty() {
    var props = ['navigationView', 'navigationWindowView'];
    _.each(props, this.defineReadOnlyProperty, this);
  },
  defineReadOnlyProperty: function defineReadOnlyProperty(key) {
    Object.defineProperty(this, key, {
      get: function get() {
        return this.getReadonlyProp(key);
      },
      set: function set(newValue) {
        throw new Error(key + ' property is readonly property');
      },
      enumerable: true,
      configurable: false
    });
  },
  getReadonlyProp: function getReadonlyProp(name) {
    switch (name) {
      case "navigationView":
        return this._navigationView_;
      case "navigationWindowView":
        return this._navigationWindowView_;
    }
    return null;
  },
  /**
   * 初始化当前类的property，此处用以存放当前类的属性，增加可读性，虽然js允许灵活为每个对象添加属性和方法
   * 但这种灵活性牺牲了一部分代码可读性，因为在定义完一个类之后，在这种灵活添加对象属性的情形下，我们无法得知这个类
   * 到底一共有多少属性，这不利于在JS中以OOP方式进行编码。此外，js是以原型链形式实现继承，定义在类的prototype对象上属性
   * 是被这个类的所有实例共享的，这容易引起访问冲突。鉴于此，我们定义一个该方法，定义并返回与类相关的所有属性，同时
   * 进行初始化，这样所有类的对象都有自己的属性。
   *
   * 注意： 不要返回与原型链上同名的选项，这会造成原型属性被覆盖的bug，如className。
   * 默认所有对象的属性，都可以从外部以option传入，所以建议内部私有属性以'_'开头，如'_privateProp'
   *
   * @protected
   */
  initProps: function initProps(opt) {
    return {
      eventPenetrateSubView: true
    };
  },
  /**
   * 覆盖 Backbone.View 的 delegateEvents 方法，支持控制事件是否穿透到子组件
   * @param {Object} events - 事件对象
   */
  delegateEvents: function delegateEvents(events) {
    var self = this;
    events = events || _.result(this, 'events');
    if (!events) {
      return this;
    }
    var penetrate = this.eventPenetrateSubView;
    if (_.isUndefined(penetrate)) {
      penetrate = true;
    }
    if (penetrate) {
      Backbone.View.prototype.delegateEvents.call(this, events);
      return this;
    }
    this.undelegateEvents();
    _.each(events, function (method, key) {
      if (!_.isFunction(method)) {
        method = self[method];
      }
      if (!_.isFunction(method)) {
        return;
      }
      var match = key.match(/^(\S+)\s*(.*)$/);
      var eventName = match[1];
      var selector = match[2];
      self.$el.on(eventName + '.' + self.cid, selector, function (e) {
        var target = e.target;
        var isInSubView = self.subViews.some(function (subView) {
          return subView.el.contains(target);
        });
        if (isInSubView) {
          return;
        }
        return method.call(self, e);
      });
    });
    return this;
  },
  /**
   * Render the data to the tmplate string , and then append the result to the el property.
   *
   * @param data {Object}  The template's render data .
   * @returns {MMViewBase}
   */
  render: function render(data) {
    var htmlView = this.template(data);
    this.$el.append(htmlView);
    return this;
  },
  refresh: function refresh(data) {
    this.removeSubViews();
    this.$el.empty();
    this.render(data);
  },
  _reservedKeys: function _reservedKeys() {
    return ['className', 'events', 'attributes'];
  },
  _reMount: function _reMount() {
    var self = this;
    _.each(this._tmplHolder, function (value, key) {
      switch (key) {
        case 'className':
          self.$el.addClass(_.result(self._tmplHolder, key));
          break;
        case 'attributes':
          self.$el.attr(_.result(self._tmplHolder, key));
      }
    });
    delete this._tmplHolder;
  },
  _check: function _check(initProps) {
    // 为了支持组件的继承，通常这三个属性需要使用方法形式定义
    var _reservedKeys = this._reservedKeys();
    _.each(_reservedKeys, function (propName) {
      if (_.has(initProps, propName)) {
        throw new Error('property name illegal: ' + propName);
      }
    });
  },
  /**
   * The view's custom template function based on Underscore's _.tmeplate() function.
   * The view's must has a tmpl property .
   *
   * @param  {Object} data Template's param object for rendering the HTML view .
   * @return {String}  The generated html string .
   */
  template: function template(data) {
    data = _.isUndefined(data) || _.isNull(data) ? {} : data;
    // if (!this._compiler) {
    this._compiler = _.template(this._tmplateString());
    // }
    return this._compiler(data);
  },
  /**
   * Get current view's rendering template string .
   *
   * @returns {String} The template html string .
   * @private
   */
  _tmplateString: function _tmplateString() {
    var htmlView = null;
    if (_.isFunction(this.tmpl)) {
      htmlView = this.tmpl();
    } else {
      htmlView = this.tmpl;
    }
    return htmlView;
  },
  /**
   * If the view's element has been add to DOM
   * @returns {Boolean}
   */
  isViewRendered: function isViewRendered() {
    var node = this.el;
    return node == document || node == document.body || node == document.documentElement || document.body.contains(node);
  },
  getViewEl: function getViewEl() {
    return this.el;
  },
  getView$El: function getView$El() {
    return this.$el;
  },
  getSuperView: function getSuperView() {
    return this.superView;
  },
  getSubViewAt: function getSubViewAt(index) {
    if (!this.subViews) {
      return null;
    }
    var length = this.subViews.length;
    if (index < 0 || index >= length) {
      throw new Error("getSubViewAt : index out of bounds : " + index);
    }
    return this.subViews[index];
  },
  getSubViewIndex: function getSubViewIndex(subView) {
    if (!this.subViews) {
      return null;
    }
    var length = this.subViews.length;
    return _.indexOf(this.subViews, subView);
  },
  /**
   * Get all the subviews .
   *
   * @returns {Array}
   */
  getSubViews: function getSubViews() {
    var array = [];
    if (this.subViews) {
      return array.concat(this.subViews);
    } else {
      return array;
    }
  },
  /**
   * 添加子View到最后一个位置
   *
   * @param {MMViewBase} subView    [description]
   * @param {HTMLElement} opt_parent [description]
   * @param {Boolean} opt_slot   如果为true，那么opt_parent为slot元素
   *
   * @example
   *
   * var subView = new MMViewBase();
   * parentView.addSubView(subView)
   *
   * @example
   *
   * var subView = new MMViewBase();
   * parentView.addSubView(subView , parentView.$('.parent-el'))
   *
   * @example
   *
   * var subView = new MMViewBase();
   * parentView.addSubView(subView , parentView.$('slot-el') , true)
   *
   * @example
   *
   * var subView = new MMViewBase();
   * parentView.addSubView(subView , function(subViewEl){
   *
   *   parentView.$el.append(subViewEl);
   *   parentView.$el.prepend(subViewEl);
   *   parentView.$('slot-el').replace(subViewEl);
   *
   * })
   *
   *
   */
  addSubView: function addSubView(subView, opt_parent, opt_slot, opt_silentRender) {
    if (!subView) {
      this.log("addSubView", "subView must be passed.");
      return;
    }
    this.subViews = this.subViews || [];
    this.addSubViewAt(subView, this.subViews.length, opt_parent, opt_slot, opt_silentRender);
  },
  addSubViewAfter: function addSubViewAfter(newSubView, refSubView, opt_parent) {
    if (!this.containSubView(refSubView)) {
      throw new Error("Ref subview doesn't belong to the super view");
    }
    var index = this.indexOfSubView(refSubView);
    index++;
    this.addSubViewAt(newSubView, index, opt_parent);
  },
  addSubViewBefore: function addSubViewBefore(newSubView, refSubView, opt_parent) {
    if (!this.containSubView(refSubView)) {
      throw new Error("Ref subview doesn't belong to the super view");
    }
    var index = this.indexOfSubView(refSubView);
    this.addSubViewAt(newSubView, index, opt_parent);
  },
  /**
   * 保证在每个view中都能获取所在的navigationView的引用
   *
   * @private
   * @see {@link MDNavigationView}
   * @param  {MMViewBase} view
   */
  _keepNavigationView: function _keepNavigationView(view) {
    var _navigationView_ = null;
    if (this._isNavigationView || this._navigationView_) {
      _navigationView_ = this._isNavigationView ? this : this._navigationView_;
    }
    var subViewClass = view.getClassName();
    if (subViewClass != "MDNavigationView" && _navigationView_) {
      view._navigationView_ = _navigationView_; // 关键赋值语句， _navigationView_ 最初是 this（一个 MDNavigationView)
      // 这里的遍历赋值，主要完成的就是将 MDNavigationView 的每一个子 view 的 _navigationView_ 指向这个 MDNavigationView
      view.eachSubViews(function (subView) {
        view._keepNavigationView(subView);
      });
    }
  },
  _keepNavigationWindow: function _keepNavigationWindow(view) {
    var _navigationWindowView_ = null;
    if (this._isNavigationWindowView || this._navigationWindowView_) {
      _navigationWindowView_ = this._isNavigationWindowView ? this : this._navigationWindowView_;
    }
    var subViewClass = view.getClassName();
    if (subViewClass != "MDNavigationWindowView" && _navigationWindowView_) {
      view._navigationWindowView_ = _navigationWindowView_;
      view.eachSubViews(function (subView) {
        view._keepNavigationWindow(subView);
      });
    }
  },
  /**
   * 按照索引位置添加subView
   *
   * @param subView {Object} new subView object.
   * @param index {Number} the index to add the subview
   */
  addSubViewAt: function addSubViewAt(subView, index, opt_parent, opt_slot, opt_silentRender) {
    var self = this;
    if (!subView) {
      this.log("addSubViewAt", "subView must not be null");
    }
    //
    // remove the previous view reference
    //
    var preSuperView = subView.getSuperView();
    if (preSuperView && preSuperView != this) {
      preSuperView.removeSubView(subView);
    }
    this.subViews = this.subViews || [];
    var length = this.subViews.length;
    index = _.isNumber(index) ? index : this.subViews.length;
    index = index < 0 ? 0 : index;
    index = index >= length ? length : index;
    for (var i = 0; i < this.subViews.length;) {
      if (this.subViews[i] == subView) {
        this.subViews.splice(i, 1);
      } else {
        i++;
      }
    }
    ;
    subView.superView = this;
    this.subViews.splice(index, 0, subView);
    var parent = opt_parent || this.el;
    this._keepNavigationView(subView);
    this._keepNavigationWindow(subView);

    //
    // If the app has been started , then when new subView is added ,
    // begin start the lifecycle
    //
    if (_Render["default"].booted && this.isViewRendered()) {
      if ((_.isElement(parent) || parent.jquery) && !!!opt_slot) {
        var $parent = $(parent);
        (0, _RenderProxy["default"])(subView, function () {
          var $pre = $parent.children().eq(index);
          if ($pre.length == 0) {
            $parent.append(subView.$el);
          } else {
            $pre.before(subView.$el);
          }
        }, opt_silentRender);
      } else if (_.isFunction(parent)) {
        (0, _RenderProxy["default"])(subView, function () {
          parent.call(this, subView.$el);
          if (!subView.isViewRendered()) {
            // console.warn('addSubView error , insert function failed .');
          }
        }, opt_silentRender);
      } else if (!!opt_slot) {
        (0, _RenderProxy["default"])(subView, function () {
          var $slot = $(parent);
          $slot.replaceWith(subView.el);
          if (!subView.isViewRendered()) {
            console.warn('addSubView error , insert failed , slot error .');
          }
        }, opt_silentRender);
      } else {
        throw new Error('addSubView error , insert action failed');
      }
    } else {
      this.relationCache = _.isArray(this.relationCache) ? this.relationCache : [];
      this.relationCache.push({
        subView: subView,
        parent: parent,
        index: index,
        slot: opt_slot
      });
    }
  },
  replaceSubView: function replaceSubView(newSubView, refSubView, opt_parent) {
    if (!this.containSubView(refSubView)) {
      console.warn("Ref subview doesn't belong to the super view");
    }
    var index = this.indexOfSubView(refSubView);
    this.removeSubViewAt(index);
    this.addSubViewAt(newSubView, index, opt_parent);
  },
  /**
   * Append current view to given superView
   * @param superView {Object} The superView which current view will be appended to .
   * @returns {Object}
   */
  appendToSupView: function appendToSupView(superView) {
    if (superView == this) {
      this.log("appendToSupView", "SuperView can't be self");
    }
    superView.addSubView(this);
    return this;
  },
  removeFromSuperView: function removeFromSuperView(opt_detach) {
    if (this.superView) {
      this.superView.removeSubView(this, opt_detach);
    } else {
      console.warn("removeFromSuperView: Cur view hasn't a superView,please check.");
    }
    return this;
  },
  removeSubViewAt: function removeSubViewAt(index, opt_detach) {
    if (!this.subViews || this.subViews.length == 0) {
      return null;
    }
    if (index < 0 || index > this.subViews.length) {
      this.log("removeSubViewAt", "Index out of bounds.");
      return;
    }
    var subView = this.subViews[index];
    if (_.isBoolean(opt_detach) && opt_detach) {
      this.detachSubView(subView);
    } else {
      subView.remove();
      this.subViews.splice(index, 1);
      subView.superView = null;
    }
    return subView;
  },
  removeSubView: function removeSubView(subView, opt_detach) {
    var self = this;
    if (!subView) {
      this.log("removeSubView", "subView isn't specified .");
    } else if (subView == this) {
      this.log("removeSubView", "subView can't be the view itself.");
    } else if (_.isArray(subView)) {
      var subViews = subView;
      this.eachSubViews(subViews, function (subView) {
        self.removeSubView(subView);
      });
    } else if (!this.containSubView(subView)) {
      this.log("removeSubView", "Can not find subView");
    } else {
      var index = this.indexOfSubView(subView);
      return this.removeSubViewAt(index, opt_detach);
    }
    return this;
  },
  removeSubViews: function removeSubViews(classname) {
    var self = this;
    // create a subview buffer
    var subViews = [].concat(self.subViews);
    _.each(subViews, function (subView, index) {
      if (!classname || classname && subView instanceof classname) {
        subView.remove();
        subView.superView = null;
      }
    });
    this.subViews = [];
    return this;
  },
  changeSubViewIndex: function changeSubViewIndex(subView, index) {
    var i = _.findIndex(this.subViews, function (subV) {
      return subV == subView;
    });
    if (i != -1) {
      this.subViews.splice(i, 1);
      this.subViews.splice(index, 0, subView);
    }
    ;
  },
  /**
   * 将view的DOM从页面上移除，与detachSubView执行反响操作，此处有一个bug，对于navigationPageView
   * viewWillRendered和viewDidRendered方法中添加subView
   *
   * @param  {MMViewBase} view - 重装的view
   */
  detachSubView: function detachSubView(view) {
    var index = 0;
    var i = 0;
    if (view.superView) {
      if (_.isFunction(view.viewWillUnRendered)) {
        view.viewWillUnRendered();
      }
      view.eachSubViews(function (subView) {
        view.detachSubView(subView);
      });
      //
      // 保存dom的挂载点
      //
      view.$el.data('parentEl', view.$el.parent()[0]);
      view.$el.detach();
      if (_.isFunction(view.viewDidUnRendered)) {
        view.viewDidUnRendered();
      }
    }
  },
  /**
   * 重装view，与detachSubView执行反响操作，此处有一个bug，对于navigationPageView
   * viewWillRendered和viewDidRendered方法中添加subView
   *
   * @param  {MMViewBase} view - 重装的view
   * @param  {function} opt_renderProxy - 可选渲染代理函数
   */
  assembleView: function assembleView(view, opt_renderProxy) {
    var index = 0;
    var i = 0;
    var subViews = [];
    //
    // 延迟处理，防止阻塞，会不会有bug ?
    //
    // _.delay(function() {
    if (_.isFunction(view.viewWillRendered)) {
      view.viewWillRendered();
    }
    // }, 0)

    if (_.isFunction(opt_renderProxy)) {
      opt_renderProxy();
    } else {
      var parentEl = view.$el.data('parentEl');
      var patent = parentEl ? parentEl : this.el;
      $(patent).append(view.el);
    }
    view.eachSubViews(function (subView) {
      view.assembleView(subView);
    });
    //
    // 延迟处理，防止阻塞，会不会有bug ?
    //
    // _.delay(function() {
    if (_.isFunction(view.viewDidRendered)) {
      view.viewDidRendered();
    }
    // }, 0)
  },
  /**
   * Return if the current view has its sub views.
   * @return {Boolean}
   */
  hasSubView: function hasSubView() {
    return this.subViews && this.subViews.length !== 0;
  },
  containSubView: function containSubView(subView) {
    return subView && subView.superView == this && this.indexOfSubView(subView) !== -1;
  },
  getSubViewCount: function getSubViewCount() {
    return this.subViews ? this.subViews.length : 0;
  },
  indexOfSubView: function indexOfSubView(subView) {
    return _.indexOf(this.subViews, subView);
  },
  eachSubViews: function eachSubViews(iterator) {
    if (this.hasSubView() && _.isFunction(iterator)) {
      _.each(this.subViews, function (subView, index, subViews) {
        iterator(subView, index, subViews);
      });
    }
  },
  filterSubViews: function filterSubViews(iterator) {
    if (this.hasSubView() && _.isFunction(iterator)) {
      return _.filter(this.subViews, iterator);
    }
    return [];
  },
  mapSubViews: function mapSubViews(iterator) {
    return _.map(this.subViews, iterator);
  },
  findSubView: function findSubView(iterator) {
    return _.find(this.subViews, iterator);
  },
  siblingViews: function siblingViews() {
    var siblings = [];
    if (this.superView) {
      var self = this;
      siblings = _.reject(this.superView.getSubViews(), function (element) {
        return element == self;
      });
    }
    return siblings;
  },
  previousSiblingView: function previousSiblingView() {
    var superView = this.superView;
    if (!superView) {
      return null;
    } else {
      var index = superView.indexOfSubView(this);
      if (index == 0) {
        return null;
      } else {
        return superView.getSubViewAt(index - 1);
      }
    }
  },
  previousSiblingViews: function previousSiblingViews() {
    var siblings = [];
    if (this.superView) {
      var subViews = this.superView.getSubViews();
      var index = this.superView.indexOfSubView(this);
      siblings = Array.prototype.slice.call(subViews, 0, index);
    }
    return siblings;
  },
  nextSiblingViews: function nextSiblingViews() {
    var siblings = [];
    if (this.superView) {
      var subViews = this.superView.getSubViews();
      var index = this.superView.indexOfSubView(this);
      var count = index + 1;
      siblings = Array.prototype.slice.call(subViews, index + 1);
    }
    return siblings;
  },
  nextSiblingView: function nextSiblingView() {
    var superView = this.superView;
    if (!superView) {
      return null;
    } else {
      var index = superView.indexOfSubView(this);
      if (index == superView.getSubViewCount() - 1) {
        return null;
      } else {
        return superView.getSubViewAt(index + 1);
      }
    }
  },
  /**
   * Render current view's el to parent DOM element.
   * Note: make sure to invoke this method after the super view's el has been append to page.
   *
   * @param parent {HTMLElement} Parent DOM element for current view's el to append
   */
  renderTo: function renderTo(parent) {
    var self = this;
    (0, _RenderProxy["default"])(this, function () {
      parent = parent || document.body;
      $(parent).append(self.el);
    });
  },
  renderBeforeTo: function renderBeforeTo(el) {
    var self = this;
    (0, _RenderProxy["default"])(this, function () {
      $(el).before(self.el);
    });
  },
  renderAfterTo: function renderAfterTo(el) {
    var self = this;
    (0, _RenderProxy["default"])(this, function () {
      $(el).after(self.el);
    });
  },
  renderToSlot: function renderToSlot(slotEl) {
    var self = this;
    (0, _RenderProxy["default"])(this, function () {
      $(slotEl).replaceWith(self.el);
    });
  },
  /**
   * Method called before the View's el element is appended to the HTML page.
   * In this method the el object has exist , but hasn't been append to the DOM tree .
   * Sub class can override this method to do something .
   */
  viewWillRendered: function viewWillRendered() {},
  /**
   * Method called after the View's el element is appended to the HTML page.
   * In this method the el object been append to the DOM tree .
   * Sub class can override this method to do something .
   */
  viewDidRendered: function viewDidRendered() {},
  /**
   * Method called before the View's el element is removed from the HTML page.
   * In this method the el object is still in the DOM tree .
   * Sub class can override this method to do something .
   */
  viewWillUnRendered: function viewWillUnRendered() {},
  /**
   * Method called after the View's el element is removed from the HTML page.
   * In this method the el object has been removed from the DOM tree .
   * Sub class can override this method to do something .
   */
  viewDidUnRendered: function viewDidUnRendered() {},
  /**
   * Method called when the view is shown.
   * Override this method , so that you can perform some view layout operation here.
   *
   */
  viewDidShow: function viewDidShow() {},
  /**
   * Used to iterator call method in current view tree.
   *
   * @param methodName  {string}  The method name to be called .
   * @private
   */
  _iterator: function _iterator(methodName) {
    if (!methodName) {
      console.warn(methodName);
    }
    this[methodName]();
    this.eachSubViews(function (subView) {
      subView._iterator(methodName);
    });
  },
  /**
   * Method called when the view is hided
   */
  viewDidHide: function viewDidHide() {},
  /**
   *  Called when current view is removed from its superView.
   *  You custom view can override this method if you want to react to
   *  being removed from superView.This method is called automatically
   *  by its superView , and the view's property 'superView' has been set to null.
   */
  didRemovedFromSuperView: function didRemovedFromSuperView() {},
  /**
   *
   * 覆盖Backbone.View的原生实现，支持View层次的递归删除
   *
   * Overrides the remove method inherited from Backbone.View , in order to
   * deal with the management of View's hierarchy.When the el element of the view is removed from the HTML page,
   * we need to keep synchronization of our custom Views, that is breaking the cycle reference between superView and its
   * subViews .
   *
   * If the current view has been add to a super view , and after calling this method in the current view directly ,
   * we must remove the it from superView's subViews property by ourselvers , or its super view will still keep its reference in the subViews property.
   * As following :
   *
   *  var currentView = new MMViewBase();
   *  var superView = new MMViewBase();
   *  superView.addSubView(currentView);
   *
   *  currentView.remove();
   *  superView.removeSubView(currentView); // should call this method to remove reference from super view.
   *
   *  So the better way the remove sub view is call removeSubView method of its super view , or call removeFromSuperView of the sub view.
   *
   *  if(currentView.superView){
   *    currentView.removeFromSuperView();
   *  }else{
   *    currentView.remove();
   *  }
   * 尽量避免直接调用此方法
   *
   *
   */
  remove: function remove(opt_removeRef) {
    if (this.superView && opt_removeRef) {
      var subViews = this.superView.getSubViews();
      var index = this.superView.indexOfSubView(this);
      subViews.splice(index, 1);
    }
    if (_.isFunction(this.viewWillUnRendered)) {
      this.viewWillUnRendered();
    }

    // this._removeViewHierarchyReference();
    //
    _.each(this.subViews, function (subView, index) {
      try {
        subView.remove();
      } catch (e) {
        console.log('remove error');
      }
    });
    this.superView = null; // remove cycle reference
    this.subViews = [];
    Backbone.View.prototype.remove.call(this);
    if (_.isFunction(this.viewDidUnRendered)) {
      this.viewDidUnRendered();
    }
    this.off();
    _Dispatcher["default"].off(null, null, this);
  },
  _removeViewHierarchyReference: function _removeViewHierarchyReference() {
    _.each(this.subViews, function (subView, index) {
      subView.remove();
    });
    this.superView = null; // remove cycle reference
    this.subViews = [];
    this.didRemovedFromSuperView();
  },
  slideUp: function slideUp() {
    this.$el && this.$el.slideUp();
  },
  slideDown: function slideDown() {
    this.$el && this.$el.slideDown();
  },
  show: function show() {
    if (this.$el) {
      this.$el.show();
      var viewDidShowName = (0, _Reflect_["default"])(this.viewDidShow, this);
      this._iterator(viewDidShowName);
    }
  },
  hide: function hide() {
    if (this.$el) {
      this.$el.hide();
      var viewDidHideName = (0, _Reflect_["default"])(this.viewDidHide, this);
      this._iterator(viewDidHideName);
    }
  },
  isVisible: function isVisible() {
    // dom hasn't been created
    if (!this.el) {
      return false;
    }
    var node = this.el;
    while (node && node.nodeType == 1) {
      if (node.style.display == 'none') {
        return false;
      }
      node = node.parentNode;
    }
    return true;
  },
  toggle: function toggle() {
    this.$el && this.$el.toggle();
  },
  fadeIn: function fadeIn() {
    this.$el && this.$el.fadeIn();
  },
  fadeOut: function fadeOut() {
    this.$el && this.$el.fadeOut();
  },
  liveHide: function liveHide() {
    var curTop = this.$el.css('top');
    var curBottom = this.$el.css('bottom');
    var shown = this.$el.data('liveShown');
    if (!_.isBoolean(shown) || shown) {
      this.$el.data({
        'preTop': curTop,
        'preBottom': curBottom
      }).data('liveShown', false).css({
        top: -100000,
        bottom: 'auto'
      });
      var viewDidHideName = (0, _Reflect_["default"])(this.viewDidHide, this);
      this._iterator(viewDidHideName);
    }
  },
  liveToggle: function liveToggle() {
    var liveShown = this.$el.data('liveShown');
    if (_.isBoolean(liveShown) && liveShown) {
      this.liveHide();
    } else {
      this.liveShow();
    }
  },
  liveShow: function liveShow() {
    var curTop = this.$el.data('preTop');
    var curBottom = this.$el.data('preBottom');
    this.$el.css({
      top: curTop,
      bottom: curBottom
    }).data('liveShown', true);
    var viewDidShowName = (0, _Reflect_["default"])(this.viewDidShow, this);
    this._iterator(viewDidShowName);
  },
  /**
   * Bind method context to the current object self.
   *
   * @param opt {String|Array} The method's name or method name array
   */
  bindSelf: function bindSelf() {
    var self = this;
    var args = arguments;
    var methods = _.flatten(Array.prototype.slice.call(args, 0));
    _.each(methods, function (method) {
      if (_.isString(method)) {
        self[method] = _.bind(self[method], self);
      } else if (_.isFunction(method)) {
        for (var k in self) {
          if (self[k] === method) {
            self[k] = _.bind(method, self);
          }
        }
      }
    });
    return this;
  },
  setPosition: function setPosition(pos) {
    this.$el.css({
      'top': pos.top + 'px',
      'position': "absolute",
      'left': pos.left + 'px'
    });
  }
}, {
  className: "MMViewBase",
  winId: 0
});
(function () {
  _.each(_MMBackboneExtend["default"], function (value, key) {
    MMViewBase.prototype[key] = _MMBackboneExtend["default"][key];
  });
})();
var _default = exports["default"] = MMViewBase;

},{"1184":1184,"1412":1412,"1415":1415,"1416":1416,"1417":1417,"1421":1421,"1426":1426,"1429":1429,"1430":1430,"1432":1432,"1438":1438,"1454":1454,"1463":1463,"1477":1477,"1489":1489,"18":18,"19":19,"23":23,"24":24,"25":25}],1489:[function(require,module,exports){
'use strict';
var call = require(1278);
var fixRegExpWellKnownSymbolLogic = require(1272);
var anObject = require(1209);
var isNullOrUndefined = require(1306);
var toLength = require(1386);
var toString = require(1393);
var requireObjectCoercible = require(1359);
var getMethod = require(1285);
var advanceStringIndex = require(1207);
var regExpExec = require(1352);

// @@match logic
fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, MATCH);
      return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = toString(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});

},{"1207":1207,"1209":1209,"1272":1272,"1278":1278,"1285":1285,"1306":1306,"1352":1352,"1359":1359,"1386":1386,"1393":1393}],1430:[function(require,module,exports){
'use strict';
var $ = require(1270);
var $some = require(1220).some;
var arrayMethodIsStrict = require(1223);

var STRICT_METHOD = arrayMethodIsStrict('some');

// `Array.prototype.some` method
// https://tc39.es/ecma262/#sec-array.prototype.some
$({ target: 'Array', proto: true, forced: !STRICT_METHOD }, {
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

},{"1220":1220,"1223":1223,"1270":1270}],1429:[function(require,module,exports){
'use strict';
var $ = require(1270);
var isArray = require(1300);
var isConstructor = require(1303);
var isObject = require(1307);
var toAbsoluteIndex = require(1381);
var lengthOfArrayLike = require(1317);
var toIndexedObject = require(1384);
var createProperty = require(1245);
var wellKnownSymbol = require(1408);
var arrayMethodHasSpeciesSupport = require(1222);
var nativeSlice = require(1227);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var $Array = Array;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = lengthOfArrayLike(O);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (isConstructor(Constructor) && (Constructor === $Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === $Array || Constructor === undefined) {
        return nativeSlice(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? $Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});

},{"1222":1222,"1227":1227,"1245":1245,"1270":1270,"1300":1300,"1303":1303,"1307":1307,"1317":1317,"1381":1381,"1384":1384,"1408":1408}],1426:[function(require,module,exports){
'use strict';
var $ = require(1270);
var $map = require(1220).map;
var arrayMethodHasSpeciesSupport = require(1222);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

},{"1220":1220,"1222":1222,"1270":1270}],1417:[function(require,module,exports){
'use strict';
var $ = require(1270);
var $find = require(1220).find;
var addToUnscopables = require(1206);

var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);

},{"1206":1206,"1220":1220,"1270":1270}],1416:[function(require,module,exports){
'use strict';
var $ = require(1270);
var $findIndex = require(1220).findIndex;
var addToUnscopables = require(1206);

var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);

},{"1206":1206,"1220":1220,"1270":1270}],1415:[function(require,module,exports){
'use strict';
var $ = require(1270);
var $filter = require(1220).filter;
var arrayMethodHasSpeciesSupport = require(1222);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

},{"1220":1220,"1222":1222,"1270":1270}],24:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Render;
var _RenderProxy = _interopRequireDefault(require(25));
var AppRouter = Backbone.Router.extend({
  rootView: null,
  routes: function routes() {
    return {
      '*splat': this.onRouteChanged
    };
  },
  setRootView: function setRootView(rootView) {
    this.rootView = rootView;
    rootView.router = this;
  },
  onRouteChanged: function onRouteChanged() {
    var path = Backbone.history.getFragment();
    this.rootView.dispatchRoute(path);
  },
  silentNavigateToPath: function silentNavigateToPath(path) {
    this.navigate("/" + path, {
      trigger: false
    });
  }
});

/**
 * This is the main entry to start the single application.
 * During the life cycle of the application , this function can only be called once .
 *
 * @param {MMViewBase} view - The application object.
 * @param {DOMElement} opt_parent - The parent dom that the application appended.Note:
 *                                  if the el DOM object is setted from the page , you must not pass this param.
 * @param {boolean} [opt_innerRooter] - if need inner app router
 *
 * @return {function} the Render function itself.
 */
function Render(view, opt_parent, opt_innerRooter) {
  if (!view.isViewRendered() && !opt_parent) {
    throw new Error("Render: you must specify the parentNode ");
    return;
  }
  if (view.isViewRendered() && opt_parent) {
    throw new Error("Render: the view has already rendered");
    return;
  }
  if (opt_innerRooter) {
    var appRouter = new AppRouter();
    appRouter.setRootView(view);
    window.appRouter = appRouter;
  }
  Render.booted = true;
  (0, _RenderProxy["default"])(view, function () {
    if (!view.isViewRendered()) {
      var parent = opt_parent || document.body;
      parent.appendChild(view.el);
    }
  });

  // The flag used for specify the boot state of the app
  // Render.booted = true;
}

},{"1184":1184,"1454":1454,"25":25}],25:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Reflect_ = _interopRequireDefault(require(23));
function viewWillRendered(view) {
  var subViews = view.getSubViews();
  _.each(subViews, function (subView, index) {
    viewWillRendered(subView);
  });
  view.viewWillRendered();
}
function viewDidRendered(view) {
  var subViews = view.getSubViews();
  _.each(subViews, function (subView, index) {
    viewDidRendered(subView);
  });
  view.viewDidRendered();
}
function buildViewDom(view) {
  var subView = null;
  var item = null;
  var parent = null;
  var caches = view.relationCache || [];
  var l = caches.length;
  for (var i = 0; i < l; i++) {
    item = caches[i];
    subView = item.subView;
    parent = item.parent || view.el;
    if ((_.isElement(parent) || parent.jquery) && !!!item.slot) {
      $(parent).append(subView.el);
    } else if (_.isFunction(parent)) {
      parent.call(view, subView.$el);
    } else if (!!item.slot) {
      $(parent).replaceWith(subView.el);
    } else {
      var className = subView.constructor.className;
      throw new Error('View render error,className : ' + className + ' you must insert you view.el to domcument .');
    }
    buildViewDom(subView);
  }
  view.relationCache = null;
}
function RenderProxy(view, insertFn, opt_silent) {
  opt_silent = opt_silent || false;
  !opt_silent && viewWillRendered(view);
  buildViewDom(view);
  if (!view.isViewRendered()) {
    insertFn();
  }
  !opt_silent && viewDidRendered(view);
  if (!opt_silent) {
    var viewDidShowName = (0, _Reflect_["default"])(view.viewDidShow, view);
    view._iterator(viewDidShowName);
  }
}
RenderProxy.viewDidRendered = viewDidRendered;
RenderProxy.buildViewDom = buildViewDom;
RenderProxy.viewWillRendered = viewWillRendered;
var _default = exports["default"] = RenderProxy;

},{"1184":1184,"1454":1454,"23":23}],23:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Reflect;
/**
 * Get the property name in the object , according to the prop's reference.
 *
 * @param propRef {Object} The reference of the obj's property .
 * @param obj     {Object} The obj which the propRef belong .
 */
function Reflect(propRef, obj) {
  for (var name in obj) {
    if (obj[name] == propRef) {
      return name;
    }
  }
  return null;
}

},{"1454":1454}],19:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1477);
require(1498);
require(1432);
require(1492);
require(1421);
require(1437);
require(1438);
require(1436);
require(1546);
/**
 *  Backbone功能扩展对象，此对象的所有属性会添加到MMViewBase,MMModelBase,MMCollectionBase类中
 *  该类不能直接调用，此处全部属性和方法为prototype属性
 *  Create by manjun.han
 *  2014.12.30
 */
var _default = exports["default"] = {
  /**
   * application 的基准URL
   */
  appBaseAddress: function () {
    var protocol = location.protocol,
      host = location.host;
    var baseURL = protocol + '//' + host;
    return baseURL;
  }(),
  /**
   * application的action的基准URL，如果指定应用名称，如site，则
   * appBaseAddress+site = baseURL ;
   */
  baseURL: "",
  /**
   * 当前model请求的xhr
   */
  curJQXhr: null,
  /**
   * 工具类，用以调试输出log
   * @param func
   * @param message
   */
  log: function log(func, message) {
    var className = this.getClassName();
    var error = 'Error : [class:' + className + ']-->[func:' + func + '] --> ' + message;
    throw new Error(error);
  },
  isString: function isString(obj) {
    return $.type(obj) === 'string';
  },
  isEmptyString: function isEmptyString(obj) {
    return /^[\s\xa0]*$/.test(obj);
  },
  isNotEmptyString: function isNotEmptyString(obj) {
    if (this.isString(obj) && !this.isEmptyString(obj)) {
      return true;
    }
    return false;
  },
  trim: function trim(obj) {
    return $.trim(obj);
  },
  isNumeric: function isNumeric(obj) {
    return $.isNumeric(obj);
  },
  isArray: function isArray(obj) {
    return $.type(obj) === 'array';
  },
  isFunction: function isFunction(obj) {
    return $.type(obj) === 'function';
  },
  isNull: function isNull(obj) {
    return obj === null;
  },
  isUndefined: function isUndefined(obj) {
    return obj == undefined;
  },
  isBoolean: function isBoolean(obj) {
    return $.type(obj) === "boolean";
  },
  result: function result(property) {
    return this.isFunction(this[property]) ? this[property]() : this[property];
  },
  /**
   * Get the object's class constructor
   *
   * @returns
   */
  getClass: function getClass() {
    return this.constructor;
  },
  /**
   *
   * Get the super class
   *
   * @returns
   */
  getSupperClass: function getSupperClass() {
    return this.getClass().__super__.constructor;
  },
  /**
   * Get the class's name string.
   *
   * @returns
   */
  getClassName: function getClassName() {
    return this.getClass().className;
  },
  /**
   * Get the class's static ptoperty value
   *
   * @param {String} propertyName  Name of the peroperty
   * @returns
   */
  getStaticPropertyValue: function getStaticPropertyValue(propertyName) {
    var cls = this.getClass();
    return cls[propertyName];
  },
  /**
   * 调用类的静态方法，所谓的静态方法是指添加到function函数对象上的方法
   * @param methodName {String}
   * @returns
   */
  invokeStaticMethod: function invokeStaticMethod(methodName) {
    var cls = this.getClass();
    if (this.isString(methodName)) {
      var method = cls[methodName];
      if (this.isFunction(method)) {
        var args = [].splice.call(arguments, 1);
        return method(args);
      }
    }
    throw this.log("invokeStaticMethod", "method name not exist");
  },
  urlEncode: function urlEncode(str) {
    return encodeURIComponent(String(str));
  },
  urlDecode: function urlDecode(str) {
    return decodeURIComponent(str.replace(/\+/g, ' '));
  },
  /**
   * 构建基于App的请求全路径
   * @param path {String}
   * @param params {Object|String}
   * @returns
   */
  buildAppRequestURL: function buildAppRequestURL(path, params) {
    var requestURL = this.getAppBaseURL();
    requestURL += path;
    params = params || {};
    var queryString = !this.isString(params) ? this.objectToQueryString(params) : params;
    if (requestURL.indexOf("?") === -1 && this.isNotEmptyString(queryString)) {
      requestURL += "?";
    }
    requestURL += queryString;
    return requestURL;
  },
  /**
   * 请求字符串转换为对象
   * @param queryString {String}
   * @returns {Object}
   */
  queryStringToObject: function queryStringToObject(queryString) {
    if (this.isNotEmptyString(queryString)) {
      var result = {};
      var k = "";
      var v = "";
      var tmp = null;
      var self = this;
      var pairs = queryString.split("&");
      $.each(pairs, function (index, pair) {
        // queryString = "" || "a=c&"
        if (!pair) {
          return true;
        }
        pair = pair.split("=");
        k = pair[0];
        v = decodeURIComponent(pair[1] || "");
        if (result[k]) {
          // queryString = "" || "a=c&a=b"
          if (!self.isArray(result[k])) {
            tmp = result[k];
            result[k] = [];
            result[k].push(tmp);
            result[k].push(v);
          } else {
            result[k].push(v);
          }
        } else {
          result[k] = v;
        }
      });
      return result;
    }
    return {};
  },
  /**
   * 转换对象值为请求字符串
   * @param param {Object}
   * @returns {String}
   */
  objectToQueryString: function objectToQueryString(param) {
    param = param || {};
    return $.param(param);
  },
  /**
   * 取消当前对象正在与server端进行的通信
   */
  abortRequest: function abortRequest() {
    if (!this.isNull(this.curJQXhr)) {
      this.curJQXhr.abort();
    }
  },
  /**
   * 以Get形式与后台server端通信，此处为了避免与Backbone原生Model中的get方法命名冲突
   *
   * @param url {String}
   * @param opt {Options} 参见request
   */
  httpGet: function httpGet(url, opt) {
    opt = opt || {};
    opt.method = "get";
    this.request(url, opt);
  },
  /**
   * 以Post形式与后台server端通信
   *
   * @param url {String}
   * @param opt {Options} 参见request
   */
  httpPost: function httpPost(url, opt) {
    opt = opt || {};
    opt.method = "post";
    this.request(url, opt);
  },
  /**
   * 与server端Ajax通信接口
   *
   * @param url {String} server端URL
   * @param opt {Options} 选项，提供请求回调
   *          opt.onBeforeRequest {Function} 请求前调用 function onBeforeRequest(jqXhr)
   *        opt.onSuccess {Function}  请求成功 function onSuccess(data, textStatus, jqXhr)
   *        opt.onError {Function}    请求失败 function onError(jqXhr)
   *        opt.onComplete {Function} 通信完成后的回调，不管成功与否 function onComplete(jqXhr , textStatus)
   *        opt.method {String[post]} 请求方法
   *        opt.data   {Object}     请求参数
   *        opt.dataType {String[undefined]} 请求数据的类型 , "json"||"xml"||"html"||"script"
   */
  request: function request(url, opt) {
    if (!this.isFullURL(url)) {
      url = this.getAppBaseURL() + url;
    }
    opt.method = opt.method || "post";
    opt.dataType = opt.dataType || undefined;
    opt.data = opt.data || {};
    var self = this;
    this.curJQXhr = $.ajax({
      url: url,
      type: opt.method,
      data: opt.data,
      method: opt.method,
      dataType: opt.dataType,
      beforeSend: function beforeSend(jqXhr) {
        if (self.isFunction(opt.onBeforeRequest)) {
          opt.onBeforeRequest(jqXhr);
        }
      },
      success: function success(data, textStatus, jqXhr) {
        if (self.isFunction(opt.onSuccess)) {
          if (self.isString(data)) {
            data = self.trim(data);
          }
          opt.onSuccess(data, textStatus, jqXhr);
        }
      },
      complete: function complete(jqXhr, textStatus) {
        switch (textStatus) {
          case "success":
            break;
          case "notmodified":
            break;
          case "error":
            break;
          case "timeout":
            break;
          case "abort":
            break;
          case "parsererror":
            break;
        }

        //        console.log("complete -- " + textStatus);

        if (self.isFunction(opt.onComplete)) {
          opt.onComplete(jqXhr, textStatus);
        }
        self.curJQXhr = null;
      },
      error: function error(jqXhr, textStatus, errorThrown) {
        switch (textStatus) {
          case "error":
            break;
          case "timeout":
            break;
          case "abort":
            break;
          case "parsererror":
            break;
        }
        //        console.log("error -- " + textStatus);
        if (self.isFunction(opt.onError)) {
          opt.onError(jqXhr);
        }
      }
    });
  },
  /**
   * 判断URL是否是全路径
   * @param url {String} url字符串
   * @returns {Boolean}
   */
  isFullURL: function isFullURL(url) {
    if (!this.isString(url)) {
      return false;
    }
    if (url.indexOf("http") !== 0 && url.indexOf("https") !== 0) {
      return false;
    }
    return true;
  },
  /**
   * 获取app的基准URL
   * @returns {String}
   */
  getAppBaseURL: function getAppBaseURL() {
    return this.baseURL;
  },
  /**
   * 构建随机uid，可定制前缀
   * @param prefix {String}{defauls:"mm"} uid的前缀,
   * @returns
   */
  buildRandomUID: function buildRandomUID(prefix) {
    prefix = prefix || "mm-";
    var uid = prefix + new Date().getTime();
    return uid;
  },
  /**
   *
   * @param methods {String|Array}
   */
  bind: function bind(methods) {
    if (this.isString(methods)) {
      this[methods] = _.bind(this[methods], this);
    } else if (this.isArray(methods)) {
      _.bindAll(this, methods);
    }
  },
  toJSON: function toJSON() {
    var attrs = this.attributes,
      results = {};
    for (var prop in attrs) {
      if (Object.prototype.hasOwnProperty.call(attrs, prop)) {
        if (attrs[prop] instanceof Backbone.Collection) {
          results[prop] = attrs[prop].toJSON();
        } else {
          results[prop] = attrs[prop];
        }
      }
    }
    return results;
  },
  copyToClass: function copyToClass(classPrototype) {
    var self = this;
    _.each(this, function (value, key) {
      classPrototype[key] = self[key];
    });
  }
};

},{"1421":1421,"1432":1432,"1436":1436,"1437":1437,"1438":1438,"1454":1454,"1477":1477,"1492":1492,"1498":1498,"1546":1546}],1546:[function(require,module,exports){
'use strict';
var $ = require(1270);
var call = require(1278);

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$({ target: 'URL', proto: true, enumerable: true }, {
  toJSON: function toJSON() {
    return call(URL.prototype.toString, this);
  }
});

},{"1270":1270,"1278":1278}],1498:[function(require,module,exports){
'use strict';
var $ = require(1270);
var $trim = require(1375).trim;
var forcedStringTrimMethod = require(1374);

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});

},{"1270":1270,"1374":1374,"1375":1375}],1374:[function(require,module,exports){
var PROPER_FUNCTION_NAME = require(1279).PROPER;
var fails = require(1271);
var whitespaces = require(1409);

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};

},{"1271":1271,"1279":1279,"1409":1409}],1438:[function(require,module,exports){
// TODO: Remove from `core-js@4`
var $ = require(1270);
var bind = require(1277);

// `Function.prototype.bind` method
// https://tc39.es/ecma262/#sec-function.prototype.bind
$({ target: 'Function', proto: true, forced: Function.bind !== bind }, {
  bind: bind
});

},{"1270":1270,"1277":1277}],1277:[function(require,module,exports){
'use strict';
var uncurryThis = require(1281);
var aCallable = require(1203);
var isObject = require(1307);
var hasOwn = require(1288);
var arraySlice = require(1227);
var NATIVE_BIND = require(1276);

var $Function = Function;
var concat = uncurryThis([].concat);
var join = uncurryThis([].join);
var factories = {};

var construct = function (C, argsLength, args) {
  if (!hasOwn(factories, argsLength)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    factories[argsLength] = $Function('C,a', 'return new C(' + join(list, ',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
module.exports = NATIVE_BIND ? $Function.bind : function bind(that /* , ...args */) {
  var F = aCallable(this);
  var Prototype = F.prototype;
  var partArgs = arraySlice(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = concat(partArgs, arraySlice(arguments));
    return this instanceof boundFunction ? construct(F, args.length, args) : F.apply(that, args);
  };
  if (isObject(Prototype)) boundFunction.prototype = Prototype;
  return boundFunction;
};

},{"1203":1203,"1227":1227,"1276":1276,"1281":1281,"1288":1288,"1307":1307}],1436:[function(require,module,exports){
'use strict';
var $ = require(1270);
var fails = require(1271);
var toObject = require(1387);
var toPrimitive = require(1390);

var FORCED = fails(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
});

// `Date.prototype.toJSON` method
// https://tc39.es/ecma262/#sec-date.prototype.tojson
$({ target: 'Date', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O, 'number');
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});

},{"1270":1270,"1271":1271,"1387":1387,"1390":1390}],1432:[function(require,module,exports){
'use strict';
var $ = require(1270);
var toObject = require(1387);
var toAbsoluteIndex = require(1381);
var toIntegerOrInfinity = require(1385);
var lengthOfArrayLike = require(1317);
var setArrayLength = require(1225);
var doesNotExceedSafeInteger = require(1254);
var arraySpeciesCreate = require(1230);
var createProperty = require(1245);
var deletePropertyOrThrow = require(1250);
var arrayMethodHasSpeciesSupport = require(1222);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');

var max = Math.max;
var min = Math.min;

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
    }
    doesNotExceedSafeInteger(len + insertCount - actualDeleteCount);
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow(O, to);
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) deletePropertyOrThrow(O, k - 1);
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow(O, to);
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    setArrayLength(O, len - actualDeleteCount + insertCount);
    return A;
  }
});

},{"1222":1222,"1225":1225,"1230":1230,"1245":1245,"1250":1250,"1254":1254,"1270":1270,"1317":1317,"1381":1381,"1385":1385,"1387":1387}],1225:[function(require,module,exports){
'use strict';
var DESCRIPTORS = require(1251);
var isArray = require(1300);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

module.exports = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
    throw $TypeError('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};

},{"1251":1251,"1300":1300}],1421:[function(require,module,exports){
'use strict';
/* eslint-disable es/no-array-prototype-indexof -- required for testing */
var $ = require(1270);
var uncurryThis = require(1280);
var $indexOf = require(1219).indexOf;
var arrayMethodIsStrict = require(1223);

var nativeIndexOf = uncurryThis([].indexOf);

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / nativeIndexOf([1], 1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('indexOf');

// `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof
$({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || !STRICT_METHOD }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    var fromIndex = arguments.length > 1 ? arguments[1] : undefined;
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf(this, searchElement, fromIndex) || 0
      : $indexOf(this, searchElement, fromIndex);
  }
});

},{"1219":1219,"1223":1223,"1270":1270,"1280":1280}],18:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * 消息中心
 */
var Dispatcher = _.extend({}, Backbone.Events);
window.Dispatcher = Dispatcher;
var _default = exports["default"] = Dispatcher;

},{"1454":1454}],1036:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var CommentStatus = {
  Comment_unread: 0,
  // 未读
  Comment_read: 1,
  // 已读
  Comment_newReply: 2 // 有新的回复
  //Comment_read:undefined
};
var _default = exports["default"] = CommentStatus;

},{"1454":1454}],821:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1412);
require(1418);
require(1463);
require(1537);
/**
 * Created by mashx on 16-7-27.
 */

/**
 * Class for Hash Map datastructure.
 * @param {*=} opt_map Map or Object to initialize the map with.
 * @param {...*} var_args If 2 or more arguments are present then they
 *     will be used as key-value pairs.
 * @constructor
 * @template K, V
 */
function Map(opt_map, var_args) {
  /**
   * Underlying JS object used to implement the map.
   * @private {!Object}
   */
  this.map_ = {};

  /**
   * An array of keys. This is necessary for two reasons:
   *   1. Iterating the keys using for (var key in this.map_) allocates an
   *      object for every key in IE which is really bad for IE6 GC perf.
   *   2. Without a side data structure, we would need to escape all the keys
   *      as that would be the only way we could tell during iteration if the
   *      key was an internal key or a property of the object.
   *
   * This array can contain deleted keys so it's necessary to check the map
   * as well to see if the key is still in the map (this doesn't require a
   * memory allocation in IE).
   * @private {!Array.<string>}
   */
  this.keys_ = [];

  /**
   * The number of key value pairs in the map.
   * @private {number}
   */
  this.count_ = 0;

  /**
   * Version used to detect changes while iterating.
   * @private {number}
   */
  this.version_ = 0;
  var argLength = arguments.length;
  if (argLength > 1) {
    if (argLength % 2) {
      throw Error('Uneven number of arguments');
    }
    for (var i = 0; i < argLength; i += 2) {
      this.set(arguments[i], arguments[i + 1]);
    }
  }
}
;

/**
 * @return {number} The number of key-value pairs in the map.
 */
Map.prototype.getCount = function () {
  return this.count_;
};

/**
 * Returns the values of the map.
 * @return {!Array.<V>} The values in the map.
 */
Map.prototype.getValues = function () {
  this.cleanupKeysArray_();
  var rv = [];
  for (var i = 0; i < this.keys_.length; i++) {
    var key = this.keys_[i];
    rv.push(this.map_[key]);
  }
  return rv;
};

/**
 * Returns the keys of the map.
 * @return {!Array.<string>} Array of string values.
 */
Map.prototype.getKeys = function () {
  this.cleanupKeysArray_();
  return /** @type {!Array.<string>} */this.keys_.concat();
};

/**
 * Whether the map contains the given key.
 * @param {*} key The key to check for.
 * @return {boolean} Whether the map contains the key.
 */
Map.prototype.containsKey = function (key) {
  return Map.hasKey_(this.map_, key);
};

/**
 * Whether the map contains the given value. This is O(n).
 * @param {V} val The value to check for.
 * @return {boolean} Whether the map contains the value.
 */
Map.prototype.containsValue = function (val) {
  for (var i = 0; i < this.keys_.length; i++) {
    var key = this.keys_[i];
    if (Map.hasKey_(this.map_, key) && this.map_[key] == val) {
      return true;
    }
  }
  return false;
};

/**
 * Whether this map is equal to the argument map.
 * @param {ds.Map} otherMap The map against which to test equality.
 * @param {function(V, V): boolean=} opt_equalityFn Optional equality function
 *     to test equality of values. If not specified, this will test whether
 *     the values contained in each map are identical objects.
 * @return {boolean} Whether the maps are equal.
 */
Map.prototype.equals = function (otherMap, opt_equalityFn) {
  if (this === otherMap) {
    return true;
  }
  if (this.count_ != otherMap.getCount()) {
    return false;
  }
  var equalityFn = opt_equalityFn || Map.defaultEquals;
  this.cleanupKeysArray_();
  for (var key, i = 0; key = this.keys_[i]; i++) {
    if (!equalityFn(this.get(key), otherMap.get(key))) {
      return false;
    }
  }
  return true;
};

/**
 * Default equality test for values.
 * @param {*} a The first value.
 * @param {*} b The second value.
 * @return {boolean} Whether a and b reference the same object.
 */
Map.defaultEquals = function (a, b) {
  return a === b;
};

/**
 * @return {boolean} Whether the map is empty.
 */
Map.prototype.isEmpty = function () {
  return this.count_ == 0;
};

/**
 * Removes all key-value pairs from the map.
 */
Map.prototype.clear = function () {
  this.map_ = {};
  this.keys_.length = 0;
  this.count_ = 0;
  this.version_ = 0;
};

/**
 * Removes a key-value pair based on the key. This is O(logN) amortized due to
 * updating the keys array whenever the count becomes half the size of the keys
 * in the keys array.
 * @param {*} key  The key to remove.
 * @return {boolean} Whether object was removed.
 */
Map.prototype.remove = function (key) {
  if (Map.hasKey_(this.map_, key)) {
    delete this.map_[key];
    this.count_--;
    this.version_++;

    // clean up the keys array if the threshhold is hit
    if (this.keys_.length > 2 * this.count_) {
      this.cleanupKeysArray_();
    }
    return true;
  }
  return false;
};

/**
 * Cleans up the temp keys array by removing entries that are no longer in the
 * map.
 * @private
 */
Map.prototype.cleanupKeysArray_ = function () {
  if (this.count_ != this.keys_.length) {
    // First remove keys that are no longer in the map.
    var srcIndex = 0;
    var destIndex = 0;
    while (srcIndex < this.keys_.length) {
      var key = this.keys_[srcIndex];
      if (Map.hasKey_(this.map_, key)) {
        this.keys_[destIndex++] = key;
      }
      srcIndex++;
    }
    this.keys_.length = destIndex;
  }
  if (this.count_ != this.keys_.length) {
    // If the count still isn't correct, that means we have duplicates. This can
    // happen when the same key is added and removed multiple times. Now we have
    // to allocate one extra Object to remove the duplicates. This could have
    // been done in the first pass, but in the common case, we can avoid
    // allocating an extra object by only doing this when necessary.
    var seen = {};
    var srcIndex = 0;
    var destIndex = 0;
    while (srcIndex < this.keys_.length) {
      var key = this.keys_[srcIndex];
      if (!Map.hasKey_(seen, key)) {
        this.keys_[destIndex++] = key;
        seen[key] = 1;
      }
      srcIndex++;
    }
    this.keys_.length = destIndex;
  }
};

/**
 * Returns the value for the given key.  If the key is not found and the default
 * value is not given this will return {@code undefined}.
 * @param {*} key The key to get the value for.
 * @param {DEFAULT=} opt_val The value to return if no item is found for the
 *     given key, defaults to undefined.
 * @return {V|DEFAULT} The value for the given key.
 * @template DEFAULT
 */
Map.prototype.get = function (key, opt_val) {
  if (Map.hasKey_(this.map_, key)) {
    return this.map_[key];
  }
  return opt_val;
};

/**
 * Adds a key-value pair to the map.
 * @param {*} key The key.
 * @param {V} value The value to add.
 * @return {*} Some subclasses return a value.
 */
Map.prototype.set = function (key, value) {
  if (!Map.hasKey_(this.map_, key)) {
    this.count_++;
    this.keys_.push(key);
    // Only change the version if we add a new key.
    this.version_++;
  }
  this.map_[key] = value;
};

/**
 * Calls the given function on each entry in the map.
 * @param {function(this:T, V, K, Map.<K,V>)} f
 * @param {T=} opt_obj The value of "this" inside f.
 * @template T
 */
Map.prototype.forEach = function (f, opt_obj) {
  var keys = this.getKeys();
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var value = this.get(key);
    f.call(opt_obj, value, key, this);
  }
};

/**
 * Clones a map and returns a new map.
 * @return {!ds.Map} A new map with the same key-value pairs.
 */
Map.prototype.clone = function () {
  return new Map(this);
};

/**
 * @return {!Object} Object representation of the map.
 */
Map.prototype.toObject = function () {
  this.cleanupKeysArray_();
  var obj = {};
  for (var i = 0; i < this.keys_.length; i++) {
    var key = this.keys_[i];
    obj[key] = this.map_[key];
  }
  return obj;
};

/**
 * Safe way to test for hasOwnProperty.  It even allows testing for
 * 'hasOwnProperty'.
 * @param {Object} obj The object to test for presence of the given key.
 * @param {*} key The key to check for.
 * @return {boolean} Whether the object has the key.
 * @private
 */
Map.hasKey_ = function (obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
};
var _default = exports["default"] = Map;

},{"1412":1412,"1418":1418,"1454":1454,"1463":1463,"1537":1537}],1537:[function(require,module,exports){
var global = require(1287);
var DOMIterables = require(1255);
var DOMTokenListPrototype = require(1256);
var forEach = require(1216);
var createNonEnumerableProperty = require(1243);

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  if (DOMIterables[COLLECTION_NAME]) {
    handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
  }
}

handlePrototype(DOMTokenListPrototype);

},{"1216":1216,"1243":1243,"1255":1255,"1256":1256,"1287":1287}],1256:[function(require,module,exports){
// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = require(1253);

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;

},{"1253":1253}],1255:[function(require,module,exports){
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

},{}],1418:[function(require,module,exports){
'use strict';
var $ = require(1270);
var forEach = require(1216);

// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
$({ target: 'Array', proto: true, forced: [].forEach != forEach }, {
  forEach: forEach
});

},{"1216":1216,"1270":1270}],1216:[function(require,module,exports){
'use strict';
var $forEach = require(1220).forEach;
var arrayMethodIsStrict = require(1223);

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;

},{"1220":1220,"1223":1223}],1412:[function(require,module,exports){
'use strict';
var $ = require(1270);
var fails = require(1271);
var isArray = require(1300);
var isObject = require(1307);
var toObject = require(1387);
var lengthOfArrayLike = require(1317);
var doesNotExceedSafeInteger = require(1254);
var createProperty = require(1245);
var arraySpeciesCreate = require(1230);
var arrayMethodHasSpeciesSupport = require(1222);
var wellKnownSymbol = require(1408);
var V8_VERSION = require(1267);

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        doesNotExceedSafeInteger(n + len);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        doesNotExceedSafeInteger(n + 1);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});

},{"1222":1222,"1230":1230,"1245":1245,"1254":1254,"1267":1267,"1270":1270,"1271":1271,"1300":1300,"1307":1307,"1317":1317,"1387":1387,"1408":1408}],1254:[function(require,module,exports){
var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

module.exports = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};

},{}],1222:[function(require,module,exports){
var fails = require(1271);
var wellKnownSymbol = require(1408);
var V8_VERSION = require(1267);

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};

},{"1267":1267,"1271":1271,"1408":1408}],951:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
var _int = _interopRequireDefault(require(820));
var _OBJ_ID = _interopRequireDefault(require(818));
var MMIdManager = new function MMIdManager() {
  /**
   * get or generate the locatorID, and save it to the local storage,
   * if it is already in the local storage, load this.
   */
  this.locator = _int["default"].createRandom();
  if (window.localStorage !== undefined) {
    var devId = localStorage.getItem("deviceID");
    if (devId === null) {
      localStorage.setItem("deviceID", this.locator.toDecString());
    } else {
      this.locator = new _int["default"](devId);
    }
  }
  this.m_nextid = new _int["default"](new Date().getTime().toString(16)).leftShift32();

  /**
   * creating a new unique objectID
   * @return {OBJ_ID()} a new usable ObjectId
   */
  this.getNewId = function () {
    var out = new _OBJ_ID["default"]();
    out.m_localIndex = this.m_nextid.increaseByOne().clone();
    out.m_macAddr = this.locator;
    return out;
  };
}();
var _default = exports["default"] = MMIdManager;

},{"1184":1184,"1437":1437,"1454":1454,"1463":1463,"1478":1478,"818":818,"820":820}],818:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1424);
require(1437);
require(1463);
require(1478);
var _int = _interopRequireDefault(require(820));
function OBJ_ID() {
  /**
   * m_mac_addr
   * @type {Int64}
   */
  this.m_localIndex = new _int["default"](-1);
  /**
   * m_local_index
   * @type {Int64}
   */
  this.m_macAddr = new _int["default"](-1);
}
;
function padLeft(word, n, str) {
  return Array(n - word.length + 1).join(str || ' ') + word;
}
OBJ_ID.prototype.fromString = function (strId_) {
  var _parts = strId_.split('-');
  console.assert(_parts.length);
  this.m_localIndex = new _int["default"](_parts[0]);
  this.m_macAddr = new _int["default"](_parts[1]);
};
OBJ_ID.prototype.toString = function () {
  // when the value is 0 toOCtetString returns an empty string. but when "new Int64" the behavior is differnet in different platforms.
  return padLeft(this.m_localIndex.toOctetString(), 16, '0') + '-' + padLeft(this.m_macAddr.toOctetString(), 16, '0');
};

/**
 *
 * @param otherId {OBJ_ID} compares both, by using toString
 */
OBJ_ID.prototype.isEqualTo = function (otherId) {
  if (!(otherId instanceof OBJ_ID)) throw "can only compare with other OBJ_ID";
  return this.toString() == otherId.toString();
};
OBJ_ID.prototype.isBlank = function () {
  return this.m_macAddr.toString() == new _int["default"](-1).toString() && this.m_localIndex.toString() == new _int["default"](-1).toString();
};
var _default = exports["default"] = OBJ_ID;

},{"1184":1184,"1424":1424,"1437":1437,"1454":1454,"1463":1463,"1478":1478,"820":820}],820:[function(require,module,exports){
"use strict";

require(1454);
var _interopRequireDefault = require(1184);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
require(1446);
require(1424);
require(1428);
require(1423);
require(1411);
require(1530);
require(1505);
require(1506);
require(1507);
require(1508);
require(1510);
require(1509);
require(1512);
require(1513);
require(1514);
require(1516);
require(1517);
require(1518);
require(1519);
require(1521);
require(1520);
require(1522);
require(1523);
require(1524);
require(1525);
require(1526);
require(1527);
require(1528);
require(1529);
require(1477);
require(1492);
require(1466);
require(1410);
var _BigNumber = _interopRequireDefault(require(825));
/**
 * Support for handling 64-bit int numbers in Javascript (node.js)
 *
 * JS Numbers are IEEE-754 binary double-precision floats, which limits the
 * range of values that can be represented with integer precision to:
 *
 * 2^^53 <= N <= 2^53
 *
 * Int64 objects wrap a node Buffer that holds the 8-bytes of int64 data.  These
 * objects operate directly on the buffer which means that if they are created
 * using an existing buffer then setting the value will modify the Buffer, and
 * vice-versa.
 *
 * Internal Representation
 *
 * The internal buffer format is Big Endian.  I.e. the most-significant byte is
 * at buffer[0], the least-significant at buffer[7].  For the purposes of
 * converting to/from JS native numbers, the value is assumed to be a signed
 * integer stored in 2's complement form.
 *
 * For details about IEEE-754 see:
 * http://en.wikipedia.org/wiki/Double_precision_floating-point_format
 */

// Useful masks and values for bit twiddling
var MASK31 = 0x7fffffff,
  VAL31 = 0x80000000;
var MASK32 = 0xffffffff,
  VAL32 = 0x100000000;

// Map for converting hex octets to strings
var _HEX = [];
for (var i = 0; i < 256; i++) {
  _HEX[i] = (i > 0xF ? '' : '0') + i.toString(16);
}
var addBigNumber = function addBigNumber(num1_, num2_) {
  console.assert(typeof num1_ == 'string' && typeof num2_ == 'string');
  var _result = "";
  var _extra = 0;
  var _num1length = num1_.length;
  var _num2length = num2_.length;
  var _length = Math.min(_num1length, _num2length);
  for (var i = 0; i < _length; i++) {
    var _temp = Number(num1_[_num1length - 1 - i]) + Number(num2_[_num2length - 1 - i]) + _extra;
    _result += _temp % 10;
    _extra = _temp >= 10 ? 1 : 0;
  }
  for (var i = _length; i < _num1length; i++) {
    var _temp = Number(num1_[_num1length - 1 - i]) + _extra;
    _result += _temp % 10;
    _extra = _temp >= 10 ? 1 : 0;
  }
  for (var i = _length; i < _num2length; i++) {
    var _temp = Number(num2_[_num2length - 1 - i]) + _extra;
    _result += _temp % 10;
    _extra = _temp >= 10 ? 1 : 0;
  }
  if (_extra > 0) {
    _result += _extra;
  }
  return _result.split("").reverse().join("");
};

/*
53:9007199254740992
54:18014398509481984
55:36028797018963968
56:72057594037927936
57:144115188075855872
58:288230376151711744
59:576460752303423488
60:1152921504606846976
61:2305843009213693952
62:4611686018427387904
63:-9223372036854775808
*/

//
// Int64
//

/**
 * Constructor accepts any of the following argument types:
 *
 * new Int64(buffer[, offset=0]) - Existing Buffer with byte offset
 * new Int64(string)             - Hex string (throws if n is outside int64 range)
 * new Int64(number)             - Number (throws if n is outside int64 range)
 * new Int64(hi, lo)             - Raw bits as two 32-bit values
 */
var Int64 = function Int64(a1, a2) {
  this.offset = 0;
  if (a1 instanceof Uint8Array) {
    this.buffer = new Array(8);
    this.buffer[0] = a1[0];
    this.buffer[1] = a1[1];
    this.buffer[2] = a1[2];
    this.buffer[3] = a1[3];
    this.buffer[4] = a1[4];
    this.buffer[5] = a1[5];
    this.buffer[6] = a1[6];
    this.buffer[7] = a1[7];
  } else {
    this.buffer = new Array(8);
    this.setValue.apply(this, arguments);
  }
  this.str = null; //added by jiang, 2014-6-25
};
/**
 * returns an Int64 object with random value.
 * @returns {Int64}
 */
Int64.createRandom = function randomInt64() {
  var out = new Int64();
  for (var i = 7; i >= 0; i--) {
    out.buffer[i] = Math.round(Math.random() * 255);
  }
  return out;
};
Int64.increaseByOne = function increaseInt64byOne(input) {
  for (var i = 7; i >= 0; i--) {
    if (input.buffer[i] == 255) {
      input.buffer[i] = 0;
    } else {
      input.buffer[i]++;
      return input;
    }
  }
  return input;
};

// Max integer value that JS can accurately represent
Int64.MAX_INT = Math.pow(2, 53);

// Min integer value that JS can accurately represent
Int64.MIN_INT = -Math.pow(2, 53);
Int64.prototype = {
  /**
   * Do in-place 2's compliment.  See
   * http://en.wikipedia.org/wiki/Two's_complement
   */
  _2scomp: function _2scomp() {
    var b = this.buffer,
      o = this.offset,
      carry = 1;
    for (var i = o + 7; i >= o; i--) {
      var v = (b[i] ^ 0xff) + carry;
      b[i] = v & 0xff;
      carry = v >> 8;
    }
  },
  /**
   * Set the value. Takes any of the following arguments:
   *
   * setValue(string) - A hexidecimal string
   * setValue(number) - Number (throws if n is outside int64 range)
   * setValue(hi, lo) - Raw bits as two 32-bit values
   */
  setValue: function setValue(hi, lo) {
    var negate = false;
    if (arguments.length == 1) {
      if (typeof hi == 'number') {
        // Simplify bitfield retrieval by using abs() value.  We restore sign
        // later
        negate = hi < 0;
        hi = Math.abs(hi);
        lo = hi % VAL32;
        hi = hi / VAL32;
        if (hi > VAL32) throw new RangeError(hi + ' is outside Int64 range');
        hi = hi | 0;
      } else if (typeof hi == 'string') {
        hi = (hi + '').replace(/^0x/, '');
        lo = hi.substr(-8);
        hi = hi.length > 8 ? hi.substr(0, hi.length - 8) : '';
        hi = parseInt(hi, 16);
        lo = parseInt(lo, 16);
      } else {
        throw new Error(hi + ' must be a Number or String');
      }
    }

    // Technically we should throw if hi or lo is outside int32 range here, but
    // it's not worth the effort. Anything past the 32'nd bit is ignored.

    // Copy bytes to buffer
    var b = this.buffer,
      o = this.offset;
    for (var i = 7; i >= 0; i--) {
      b[o + i] = lo & 0xff;
      lo = i == 4 ? hi : lo >>> 8;
    }

    // Restore sign of passed argument
    if (negate) this._2scomp();
    this.str = null; // added by jiang, 2014-6-25
  },
  /**
   * Convert to a native JS number.
   *
   * WARNING: Do not expect this value to be accurate to integer precision for
   * large (positive or negative) numbers!
   *
   * @param allowImprecise If true, no check is performed to verify the
   * returned value is accurate to integer precision.  If false, imprecise
   * numbers (very large positive or negative numbers) will be forced to +/-
   * Infinity.
   */
  toNumber: function toNumber(allowImprecise) {
    var b = this.buffer,
      o = this.offset;

    // Running sum of octets, doing a 2's complement
    var negate = b[0] & 0x80,
      x = 0,
      carry = 1;
    for (var i = 7, m = 1; i >= 0; i--, m *= 256) {
      var v = b[o + i];

      // 2's complement for negative numbers
      if (negate) {
        v = (v ^ 0xff) + carry;
        carry = v >> 8;
        v = v & 0xff;
      }
      x += v * m;
    }

    // Return Infinity if we've lost integer precision
    if (!allowImprecise && x >= Int64.MAX_INT) {
      return negate ? -Infinity : Infinity;
    }
    return negate ? -x : x;
  },
  /**
   * Convert to a JS Number. Returns +/-Infinity for values that can't be
   * represented to integer precision.
   */
  valueOf: function valueOf() {
    return this.toNumber(false);
  },
  /**
   * Return string value
   *
   * @param radix Just like Number#toString()'s radix
   */
  toString: function toString(radix) {
    //    return this.valueOf().toString(radix || 10);

    //  if (this.buffer[0]==0&&this.buffer[1]<32) {
    //      return this.valueOf().toString(10) ;
    //  } else if (this.buffer[0]==0&&this.buffer[1]<64){
    //      var _temp64 = new Int64() ;
    //      return  addBigNumber("9007199254740992",);
    //  }
    return this.toDecString();
  },
  /**
   * Return a string showing the buffer octets, with MSB on the left.
   *
   * @param sep separator string. default is '' (empty string)
   */
  toOctetString: function toOctetString(sep) {
    //        var out = new Array(8);
    //        var b = this.buffer,
    //            o = this.offset;
    //        for (var i = 0; i < 8; i++) {
    //            out[i] = _HEX[b[o + i]];
    //        }
    //        return out.join(sep || '');

    var out = new Array(8);
    var b = this.buffer,
      o = this.offset;
    for (var i = 0; i < 8; i++) {
      out[i] = _HEX[b[o + i]];
    }
    var cout = out.join(sep || '');
    var i = 0;
    while (cout[i] == '0') {
      i++;
    }
    return cout.substr(i, cout.length - i);
  },
  isEqualTo: function isEqualTo(other) {
    if (typeof other == "string") other = new Int64(other);
    if (!(other instanceof Int64)) throw "can only compare to Int64 or octetStrings representing a Int64";
    return this.toOctetString() == other.toOctetString();
  },
  toDecString: function toDecString() {
    if (this.str == null) {
      var bigNum = new _BigNumber["default"](0, 0);
      for (var i = 0; i < 8; i++) {
        var v = this.buffer[i];
        var temBig = new _BigNumber["default"](v);
        for (var k = 1; k < 8 - i; k++) {
          temBig.multiplay(256);
        }
        bigNum.addBigNumber(temBig);
      }
      this.str = bigNum.toString();
    }
    return this.str;
  },
  /**
   * Pretty output in console.log
   */
  inspect: function inspect() {
    return '[Int64 value:' + this + ' octets:' + this.toOctetString(' ') + ']';
  },
  leftShift16: function leftShift16() {
    var _buffer = new ArrayBuffer(2);
    var _view = new Uint8Array(_buffer);
    _view[0] = 0;
    _view[1] = 0;
    this.buffer[0] = this.buffer[2];
    this.buffer[1] = this.buffer[3];
    this.buffer[2] = this.buffer[4];
    this.buffer[3] = this.buffer[5];
    this.buffer[4] = this.buffer[6];
    this.buffer[5] = this.buffer[7];
    this.buffer[6] = _view[0];
    this.buffer[7] = _view[0];
    return this;
  },
  clone: function clone() {
    return new Int64(this.toOctetString());
  },
  /**
   * @return {Int64} a new Int64 Object, with shifted Values
   */
  leftShift32: function int64LeftShift32() {
    return this.leftShift16().leftShift16();
  },
  /**
   * takes an int64 and increase its value by one.
   * returns the input.
   */
  increaseByOne: function increaseInt64byOne() {
    return Int64.increaseByOne(this);
  }
};
window.Int64 = Int64; // msgpack在用
var _default = exports["default"] = Int64;

},{"1184":1184,"1410":1410,"1411":1411,"1423":1423,"1424":1424,"1428":1428,"1437":1437,"1446":1446,"1454":1454,"1463":1463,"1466":1466,"1477":1477,"1478":1478,"1492":1492,"1505":1505,"1506":1506,"1507":1507,"1508":1508,"1509":1509,"1510":1510,"1512":1512,"1513":1513,"1514":1514,"1516":1516,"1517":1517,"1518":1518,"1519":1519,"1520":1520,"1521":1521,"1522":1522,"1523":1523,"1524":1524,"1525":1525,"1526":1526,"1527":1527,"1528":1528,"1529":1529,"1530":1530,"825":825}],1530:[function(require,module,exports){
var createTypedArrayConstructor = require(1395);

// `Uint8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint8', function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"1395":1395}],1395:[function(require,module,exports){
'use strict';
var $ = require(1270);
var global = require(1287);
var call = require(1278);
var DESCRIPTORS = require(1251);
var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = require(1396);
var ArrayBufferViewCore = require(1212);
var ArrayBufferModule = require(1213);
var anInstance = require(1208);
var createPropertyDescriptor = require(1244);
var createNonEnumerableProperty = require(1243);
var isIntegralNumber = require(1305);
var toLength = require(1386);
var toIndex = require(1383);
var toOffset = require(1388);
var toPropertyKey = require(1391);
var hasOwn = require(1288);
var classof = require(1234);
var isObject = require(1307);
var isSymbol = require(1310);
var create = require(1326);
var isPrototypeOf = require(1335);
var setPrototypeOf = require(1339);
var getOwnPropertyNames = require(1331).f;
var typedArrayFrom = require(1398);
var forEach = require(1220).forEach;
var setSpecies = require(1362);
var definePropertyModule = require(1328);
var getOwnPropertyDescriptorModule = require(1329);
var InternalStateModule = require(1298);
var inheritIfRequired = require(1295);

var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var enforceInternalState = InternalStateModule.enforce;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var round = Math.round;
var RangeError = global.RangeError;
var ArrayBuffer = ArrayBufferModule.ArrayBuffer;
var ArrayBufferPrototype = ArrayBuffer.prototype;
var DataView = ArrayBufferModule.DataView;
var NATIVE_ARRAY_BUFFER_VIEWS = ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;
var TYPED_ARRAY_TAG = ArrayBufferViewCore.TYPED_ARRAY_TAG;
var TypedArray = ArrayBufferViewCore.TypedArray;
var TypedArrayPrototype = ArrayBufferViewCore.TypedArrayPrototype;
var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
var isTypedArray = ArrayBufferViewCore.isTypedArray;
var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
var WRONG_LENGTH = 'Wrong length';

var fromList = function (C, list) {
  aTypedArrayConstructor(C);
  var index = 0;
  var length = list.length;
  var result = new C(length);
  while (length > index) result[index] = list[index++];
  return result;
};

var addGetter = function (it, key) {
  nativeDefineProperty(it, key, { get: function () {
    return getInternalState(this)[key];
  } });
};

var isArrayBuffer = function (it) {
  var klass;
  return isPrototypeOf(ArrayBufferPrototype, it) || (klass = classof(it)) == 'ArrayBuffer' || klass == 'SharedArrayBuffer';
};

var isTypedArrayIndex = function (target, key) {
  return isTypedArray(target)
    && !isSymbol(key)
    && key in target
    && isIntegralNumber(+key)
    && key >= 0;
};

var wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
  key = toPropertyKey(key);
  return isTypedArrayIndex(target, key)
    ? createPropertyDescriptor(2, target[key])
    : nativeGetOwnPropertyDescriptor(target, key);
};

var wrappedDefineProperty = function defineProperty(target, key, descriptor) {
  key = toPropertyKey(key);
  if (isTypedArrayIndex(target, key)
    && isObject(descriptor)
    && hasOwn(descriptor, 'value')
    && !hasOwn(descriptor, 'get')
    && !hasOwn(descriptor, 'set')
    // TODO: add validation descriptor w/o calling accessors
    && !descriptor.configurable
    && (!hasOwn(descriptor, 'writable') || descriptor.writable)
    && (!hasOwn(descriptor, 'enumerable') || descriptor.enumerable)
  ) {
    target[key] = descriptor.value;
    return target;
  } return nativeDefineProperty(target, key, descriptor);
};

if (DESCRIPTORS) {
  if (!NATIVE_ARRAY_BUFFER_VIEWS) {
    getOwnPropertyDescriptorModule.f = wrappedGetOwnPropertyDescriptor;
    definePropertyModule.f = wrappedDefineProperty;
    addGetter(TypedArrayPrototype, 'buffer');
    addGetter(TypedArrayPrototype, 'byteOffset');
    addGetter(TypedArrayPrototype, 'byteLength');
    addGetter(TypedArrayPrototype, 'length');
  }

  $({ target: 'Object', stat: true, forced: !NATIVE_ARRAY_BUFFER_VIEWS }, {
    getOwnPropertyDescriptor: wrappedGetOwnPropertyDescriptor,
    defineProperty: wrappedDefineProperty
  });

  module.exports = function (TYPE, wrapper, CLAMPED) {
    var BYTES = TYPE.match(/\d+$/)[0] / 8;
    var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + TYPE;
    var SETTER = 'set' + TYPE;
    var NativeTypedArrayConstructor = global[CONSTRUCTOR_NAME];
    var TypedArrayConstructor = NativeTypedArrayConstructor;
    var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
    var exported = {};

    var getter = function (that, index) {
      var data = getInternalState(that);
      return data.view[GETTER](index * BYTES + data.byteOffset, true);
    };

    var setter = function (that, index, value) {
      var data = getInternalState(that);
      if (CLAMPED) value = (value = round(value)) < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
      data.view[SETTER](index * BYTES + data.byteOffset, value, true);
    };

    var addElement = function (that, index) {
      nativeDefineProperty(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };

    if (!NATIVE_ARRAY_BUFFER_VIEWS) {
      TypedArrayConstructor = wrapper(function (that, data, offset, $length) {
        anInstance(that, TypedArrayConstructorPrototype);
        var index = 0;
        var byteOffset = 0;
        var buffer, byteLength, length;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new ArrayBuffer(byteLength);
        } else if (isArrayBuffer(data)) {
          buffer = data;
          byteOffset = toOffset(offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - byteOffset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + byteOffset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (isTypedArray(data)) {
          return fromList(TypedArrayConstructor, data);
        } else {
          return call(typedArrayFrom, TypedArrayConstructor, data);
        }
        setInternalState(that, {
          buffer: buffer,
          byteOffset: byteOffset,
          byteLength: byteLength,
          length: length,
          view: new DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });

      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
      TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = create(TypedArrayPrototype);
    } else if (TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS) {
      TypedArrayConstructor = wrapper(function (dummy, data, typedArrayOffset, $length) {
        anInstance(dummy, TypedArrayConstructorPrototype);
        return inheritIfRequired(function () {
          if (!isObject(data)) return new NativeTypedArrayConstructor(toIndex(data));
          if (isArrayBuffer(data)) return $length !== undefined
            ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES), $length)
            : typedArrayOffset !== undefined
              ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES))
              : new NativeTypedArrayConstructor(data);
          if (isTypedArray(data)) return fromList(TypedArrayConstructor, data);
          return call(typedArrayFrom, TypedArrayConstructor, data);
        }(), dummy, TypedArrayConstructor);
      });

      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
      forEach(getOwnPropertyNames(NativeTypedArrayConstructor), function (key) {
        if (!(key in TypedArrayConstructor)) {
          createNonEnumerableProperty(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
        }
      });
      TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
    }

    if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, 'constructor', TypedArrayConstructor);
    }

    enforceInternalState(TypedArrayConstructorPrototype).TypedArrayConstructor = TypedArrayConstructor;

    if (TYPED_ARRAY_TAG) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
    }

    var FORCED = TypedArrayConstructor != NativeTypedArrayConstructor;

    exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;

    $({ global: true, constructor: true, forced: FORCED, sham: !NATIVE_ARRAY_BUFFER_VIEWS }, exported);

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructor)) {
      createNonEnumerableProperty(TypedArrayConstructor, BYTES_PER_ELEMENT, BYTES);
    }

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, BYTES_PER_ELEMENT, BYTES);
    }

    setSpecies(CONSTRUCTOR_NAME);
  };
} else module.exports = function () { /* empty */ };

},{"1208":1208,"1212":1212,"1213":1213,"1220":1220,"1234":1234,"1243":1243,"1244":1244,"1251":1251,"1270":1270,"1278":1278,"1287":1287,"1288":1288,"1295":1295,"1298":1298,"1305":1305,"1307":1307,"1310":1310,"1326":1326,"1328":1328,"1329":1329,"1331":1331,"1335":1335,"1339":1339,"1362":1362,"1383":1383,"1386":1386,"1388":1388,"1391":1391,"1396":1396,"1398":1398}],1398:[function(require,module,exports){
var bind = require(1275);
var call = require(1278);
var aConstructor = require(1204);
var toObject = require(1387);
var lengthOfArrayLike = require(1317);
var getIterator = require(1284);
var getIteratorMethod = require(1283);
var isArrayIteratorMethod = require(1299);
var isBigIntArray = require(1301);
var aTypedArrayConstructor = require(1212).aTypedArrayConstructor;
var toBigInt = require(1382);

module.exports = function from(source /* , mapfn, thisArg */) {
  var C = aConstructor(this);
  var O = toObject(source);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var i, length, result, thisIsBigIntArray, value, step, iterator, next;
  if (iteratorMethod && !isArrayIteratorMethod(iteratorMethod)) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    O = [];
    while (!(step = call(next, iterator)).done) {
      O.push(step.value);
    }
  }
  if (mapping && argumentsLength > 2) {
    mapfn = bind(mapfn, arguments[2]);
  }
  length = lengthOfArrayLike(O);
  result = new (aTypedArrayConstructor(C))(length);
  thisIsBigIntArray = isBigIntArray(result);
  for (i = 0; length > i; i++) {
    value = mapping ? mapfn(O[i], i) : O[i];
    // FF30- typed arrays doesn't properly convert objects to typed array values
    result[i] = thisIsBigIntArray ? toBigInt(value) : +value;
  }
  return result;
};

},{"1204":1204,"1212":1212,"1275":1275,"1278":1278,"1283":1283,"1284":1284,"1299":1299,"1301":1301,"1317":1317,"1382":1382,"1387":1387}],1301:[function(require,module,exports){
var classof = require(1234);
var uncurryThis = require(1281);

var slice = uncurryThis(''.slice);

module.exports = function (it) {
  return slice(classof(it), 0, 3) === 'Big';
};

},{"1234":1234,"1281":1281}],1299:[function(require,module,exports){
var wellKnownSymbol = require(1408);
var Iterators = require(1316);

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};

},{"1316":1316,"1408":1408}],1284:[function(require,module,exports){
var call = require(1278);
var aCallable = require(1203);
var anObject = require(1209);
var tryToString = require(1394);
var getIteratorMethod = require(1283);

var $TypeError = TypeError;

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
  throw $TypeError(tryToString(argument) + ' is not iterable');
};

},{"1203":1203,"1209":1209,"1278":1278,"1283":1283,"1394":1394}],1283:[function(require,module,exports){
var classof = require(1234);
var getMethod = require(1285);
var isNullOrUndefined = require(1306);
var Iterators = require(1316);
var wellKnownSymbol = require(1408);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};

},{"1234":1234,"1285":1285,"1306":1306,"1316":1316,"1408":1408}],1396:[function(require,module,exports){
/* eslint-disable no-new -- required for testing */
var global = require(1287);
var fails = require(1271);
var checkCorrectnessOfIteration = require(1232);
var NATIVE_ARRAY_BUFFER_VIEWS = require(1212).NATIVE_ARRAY_BUFFER_VIEWS;

var ArrayBuffer = global.ArrayBuffer;
var Int8Array = global.Int8Array;

module.exports = !NATIVE_ARRAY_BUFFER_VIEWS || !fails(function () {
  Int8Array(1);
}) || !fails(function () {
  new Int8Array(-1);
}) || !checkCorrectnessOfIteration(function (iterable) {
  new Int8Array();
  new Int8Array(null);
  new Int8Array(1.5);
  new Int8Array(iterable);
}, true) || fails(function () {
  // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
  return new Int8Array(new ArrayBuffer(2), 1, undefined).length !== 1;
});

},{"1212":1212,"1232":1232,"1271":1271,"1287":1287}],1232:[function(require,module,exports){
var wellKnownSymbol = require(1408);

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

},{"1408":1408}],1305:[function(require,module,exports){
var isObject = require(1307);

var floor = Math.floor;

// `IsIntegralNumber` abstract operation
// https://tc39.es/ecma262/#sec-isintegralnumber
// eslint-disable-next-line es/no-number-isinteger -- safe
module.exports = Number.isInteger || function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};

},{"1307":1307}],1529:[function(require,module,exports){
'use strict';
var exportTypedArrayMethod = require(1212).exportTypedArrayMethod;
var fails = require(1271);
var global = require(1287);
var uncurryThis = require(1281);

var Uint8Array = global.Uint8Array;
var Uint8ArrayPrototype = Uint8Array && Uint8Array.prototype || {};
var arrayToString = [].toString;
var join = uncurryThis([].join);

if (fails(function () { arrayToString.call({}); })) {
  arrayToString = function toString() {
    return join(this);
  };
}

var IS_NOT_ARRAY_METHOD = Uint8ArrayPrototype.toString != arrayToString;

// `%TypedArray%.prototype.toString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tostring
exportTypedArrayMethod('toString', arrayToString, IS_NOT_ARRAY_METHOD);

},{"1212":1212,"1271":1271,"1281":1281,"1287":1287}],1528:[function(require,module,exports){
'use strict';
var global = require(1287);
var apply = require(1274);
var ArrayBufferViewCore = require(1212);
var fails = require(1271);
var arraySlice = require(1227);

var Int8Array = global.Int8Array;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $toLocaleString = [].toLocaleString;

// iOS Safari 6.x fails here
var TO_LOCALE_STRING_BUG = !!Int8Array && fails(function () {
  $toLocaleString.call(new Int8Array(1));
});

var FORCED = fails(function () {
  return [1, 2].toLocaleString() != new Int8Array([1, 2]).toLocaleString();
}) || !fails(function () {
  Int8Array.prototype.toLocaleString.call([1, 2]);
});

// `%TypedArray%.prototype.toLocaleString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tolocalestring
exportTypedArrayMethod('toLocaleString', function toLocaleString() {
  return apply(
    $toLocaleString,
    TO_LOCALE_STRING_BUG ? arraySlice(aTypedArray(this)) : aTypedArray(this),
    arraySlice(arguments)
  );
}, FORCED);

},{"1212":1212,"1227":1227,"1271":1271,"1274":1274,"1287":1287}],1527:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require(1212);
var toLength = require(1386);
var toAbsoluteIndex = require(1381);
var typedArraySpeciesConstructor = require(1399);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.subarray` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.subarray
exportTypedArrayMethod('subarray', function subarray(begin, end) {
  var O = aTypedArray(this);
  var length = O.length;
  var beginIndex = toAbsoluteIndex(begin, length);
  var C = typedArraySpeciesConstructor(O);
  return new C(
    O.buffer,
    O.byteOffset + beginIndex * O.BYTES_PER_ELEMENT,
    toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - beginIndex)
  );
});

},{"1212":1212,"1381":1381,"1386":1386,"1399":1399}],1526:[function(require,module,exports){
'use strict';
var global = require(1287);
var uncurryThis = require(1280);
var fails = require(1271);
var aCallable = require(1203);
var internalSort = require(1228);
var ArrayBufferViewCore = require(1212);
var FF = require(1257);
var IE_OR_EDGE = require(1261);
var V8 = require(1267);
var WEBKIT = require(1268);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var Uint16Array = global.Uint16Array;
var nativeSort = Uint16Array && uncurryThis(Uint16Array.prototype.sort);

// WebKit
var ACCEPT_INCORRECT_ARGUMENTS = !!nativeSort && !(fails(function () {
  nativeSort(new Uint16Array(2), null);
}) && fails(function () {
  nativeSort(new Uint16Array(2), {});
}));

var STABLE_SORT = !!nativeSort && !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 74;
  if (FF) return FF < 67;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 602;

  var array = new Uint16Array(516);
  var expected = Array(516);
  var index, mod;

  for (index = 0; index < 516; index++) {
    mod = index % 4;
    array[index] = 515 - index;
    expected[index] = index - 2 * mod + 3;
  }

  nativeSort(array, function (a, b) {
    return (a / 4 | 0) - (b / 4 | 0);
  });

  for (index = 0; index < 516; index++) {
    if (array[index] !== expected[index]) return true;
  }
});

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (y !== y) return -1;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (x !== x) return 1;
    if (x === 0 && y === 0) return 1 / x > 0 && 1 / y < 0 ? 1 : -1;
    return x > y;
  };
};

// `%TypedArray%.prototype.sort` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort
exportTypedArrayMethod('sort', function sort(comparefn) {
  if (comparefn !== undefined) aCallable(comparefn);
  if (STABLE_SORT) return nativeSort(this, comparefn);

  return internalSort(aTypedArray(this), getSortCompare(comparefn));
}, !STABLE_SORT || ACCEPT_INCORRECT_ARGUMENTS);

},{"1203":1203,"1212":1212,"1228":1228,"1257":1257,"1261":1261,"1267":1267,"1268":1268,"1271":1271,"1280":1280,"1287":1287}],1268:[function(require,module,exports){
var userAgent = require(1266);

var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

module.exports = !!webkit && +webkit[1];

},{"1266":1266}],1261:[function(require,module,exports){
var UA = require(1266);

module.exports = /MSIE|Trident/.test(UA);

},{"1266":1266}],1257:[function(require,module,exports){
var userAgent = require(1266);

var firefox = userAgent.match(/firefox\/(\d+)/i);

module.exports = !!firefox && +firefox[1];

},{"1266":1266}],1228:[function(require,module,exports){
var arraySlice = require(1226);

var floor = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    array,
    mergeSort(arraySlice(array, 0, middle), comparefn),
    mergeSort(arraySlice(array, middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;

  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = (lindex < llength && rindex < rlength)
      ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
      : lindex < llength ? left[lindex++] : right[rindex++];
  } return array;
};

module.exports = mergeSort;

},{"1226":1226}],1525:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require(1212);
var $some = require(1220).some;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.some` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.some
exportTypedArrayMethod('some', function some(callbackfn /* , thisArg */) {
  return $some(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});

},{"1212":1212,"1220":1220}],1524:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require(1212);
var typedArraySpeciesConstructor = require(1399);
var fails = require(1271);
var arraySlice = require(1227);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

var FORCED = fails(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  new Int8Array(1).slice();
});

// `%TypedArray%.prototype.slice` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.slice
exportTypedArrayMethod('slice', function slice(start, end) {
  var list = arraySlice(aTypedArray(this), start, end);
  var C = typedArraySpeciesConstructor(this);
  var index = 0;
  var length = list.length;
  var result = new C(length);
  while (length > index) result[index] = list[index++];
  return result;
}, FORCED);

},{"1212":1212,"1227":1227,"1271":1271,"1399":1399}],1227:[function(require,module,exports){
var uncurryThis = require(1281);

module.exports = uncurryThis([].slice);

},{"1281":1281}],1523:[function(require,module,exports){
'use strict';
var global = require(1287);
var call = require(1278);
var ArrayBufferViewCore = require(1212);
var lengthOfArrayLike = require(1317);
var toOffset = require(1388);
var toIndexedObject = require(1387);
var fails = require(1271);

var RangeError = global.RangeError;
var Int8Array = global.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var $set = Int8ArrayPrototype && Int8ArrayPrototype.set;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

var WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS = !fails(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  var array = new Uint8ClampedArray(2);
  call($set, array, { length: 1, 0: 3 }, 1);
  return array[1] !== 3;
});

// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var TO_OBJECT_BUG = WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS && ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS && fails(function () {
  var array = new Int8Array(2);
  array.set(1);
  array.set('2', 1);
  return array[0] !== 0 || array[1] !== 2;
});

// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
exportTypedArrayMethod('set', function set(arrayLike /* , offset */) {
  aTypedArray(this);
  var offset = toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
  var src = toIndexedObject(arrayLike);
  if (WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS) return call($set, this, src, offset);
  var length = this.length;
  var len = lengthOfArrayLike(src);
  var index = 0;
  if (len + offset > length) throw RangeError('Wrong length');
  while (index < len) this[offset + index] = src[index++];
}, !WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS || TO_OBJECT_BUG);

},{"1212":1212,"1271":1271,"1278":1278,"1287":1287,"1317":1317,"1387":1387,"1388":1388}],1388:[function(require,module,exports){
var toPositiveInteger = require(1389);

var $RangeError = RangeError;

module.exports = function (it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES) throw $RangeError('Wrong offset');
  return offset;
};

},{"1389":1389}],1389:[function(require,module,exports){
var toIntegerOrInfinity = require(1385);

var $RangeError = RangeError;

module.exports = function (it) {
  var result = toIntegerOrInfinity(it);
  if (result < 0) throw $RangeError("The argument can't be less than 0");
  return result;
};

},{"1385":1385}],1522:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require(1212);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var floor = Math.floor;

// `%TypedArray%.prototype.reverse` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reverse
exportTypedArrayMethod('reverse', function reverse() {
  var that = this;
  var length = aTypedArray(that).length;
  var middle = floor(length / 2);
  var index = 0;
  var value;
  while (index < middle) {
    value = that[index];
    that[index++] = that[--length];
    that[length] = value;
  } return that;
});

},{"1212":1212}],1521:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require(1212);
var $reduce = require(1224).left;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.reduce` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduce
exportTypedArrayMethod('reduce', function reduce(callbackfn /* , initialValue */) {
  var length = arguments.length;
  return $reduce(aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
});

},{"1212":1212,"1224":1224}],1520:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require(1212);
var $reduceRight = require(1224).right;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.reduceRight` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduceright
exportTypedArrayMethod('reduceRight', function reduceRight(callbackfn /* , initialValue */) {
  var length = arguments.length;
  return $reduceRight(aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
});

},{"1212":1212,"1224":1224}],1224:[function(require,module,exports){
var aCallable = require(1203);
var toObject = require(1387);
var IndexedObject = require(1294);
var lengthOfArrayLike = require(1317);

var $TypeError = TypeError;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw $TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

module.exports = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};

},{"1203":1203,"1294":1294,"1317":1317,"1387":1387}],1519:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require(1212);
var $map = require(1220).map;
var typedArraySpeciesConstructor = require(1399);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.map` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.map
exportTypedArrayMethod('map', function map(mapfn /* , thisArg */) {
  return $map(aTypedArray(this), mapfn, arguments.length > 1 ? arguments[1] : undefined, function (O, length) {
    return new (typedArraySpeciesConstructor(O))(length);
  });
});

},{"1212":1212,"1220":1220,"1399":1399}],1518:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require(1212);
var apply = require(1274);
var $lastIndexOf = require(1221);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.lastindexof
exportTypedArrayMethod('lastIndexOf', function lastIndexOf(searchElement /* , fromIndex */) {
  var length = arguments.length;
  return apply($lastIndexOf, aTypedArray(this), length > 1 ? [searchElement, arguments[1]] : [searchElement]);
});

},{"1212":1212,"1221":1221,"1274":1274}],1221:[function(require,module,exports){
'use strict';
/* eslint-disable es/no-array-prototype-lastindexof -- safe */
var apply = require(1274);
var toIndexedObject = require(1384);
var toIntegerOrInfinity = require(1385);
var lengthOfArrayLike = require(1317);
var arrayMethodIsStrict = require(1223);

var min = Math.min;
var $lastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO = !!$lastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('lastIndexOf');
var FORCED = NEGATIVE_ZERO || !STRICT_METHOD;

// `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
module.exports = FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
  // convert -0 to +0
  if (NEGATIVE_ZERO) return apply($lastIndexOf, this, arguments) || 0;
  var O = toIndexedObject(this);
  var length = lengthOfArrayLike(O);
  var index = length - 1;
  if (arguments.length > 1) index = min(index, toIntegerOrInfinity(arguments[1]));
  if (index < 0) index = length + index;
  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : $lastIndexOf;

},{"1223":1223,"1274":1274,"1317":1317,"1384":1384,"1385":1385}],1517:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require(1212);
var uncurryThis = require(1281);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $join = uncurryThis([].join);

// `%TypedArray%.prototype.join` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.join
exportTypedArrayMethod('join', function join(separator) {
  return $join(aTypedArray(this), separator);
});

},{"1212":1212,"1281":1281}],1516:[function(require,module,exports){
'use strict';
var global = require(1287);
var fails = require(1271);
var uncurryThis = require(1281);
var ArrayBufferViewCore = require(1212);
var ArrayIterators = require(1423);
var wellKnownSymbol = require(1408);

var ITERATOR = wellKnownSymbol('iterator');
var Uint8Array = global.Uint8Array;
var arrayValues = uncurryThis(ArrayIterators.values);
var arrayKeys = uncurryThis(ArrayIterators.keys);
var arrayEntries = uncurryThis(ArrayIterators.entries);
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var TypedArrayPrototype = Uint8Array && Uint8Array.prototype;

var GENERIC = !fails(function () {
  TypedArrayPrototype[ITERATOR].call([1]);
});

var ITERATOR_IS_VALUES = !!TypedArrayPrototype
  && TypedArrayPrototype.values
  && TypedArrayPrototype[ITERATOR] === TypedArrayPrototype.values
  && TypedArrayPrototype.values.name === 'values';

var typedArrayValues = function values() {
  return arrayValues(aTypedArray(this));
};

// `%TypedArray%.prototype.entries` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.entries
exportTypedArrayMethod('entries', function entries() {
  return arrayEntries(aTypedArray(this));
}, GENERIC);
// `%TypedArray%.prototype.keys` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.keys
exportTypedArrayMethod('keys', function keys() {
  return arrayKeys(aTypedArray(this));
}, GENERIC);
// `%TypedArray%.prototype.values` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.values
exportTypedArrayMethod('values', typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, { name: 'values' });
// `%TypedArray%.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype-@@iterator
exportTypedArrayMethod(ITERATOR, typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, { name: 'values' });

},{"1212":1212,"1271":1271,"1281":1281,"1287":1287,"1408":1408,"1423":1423}],1514:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require(1212);
var $indexOf = require(1219).indexOf;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.indexof
exportTypedArrayMethod('indexOf', function indexOf(searchElement /* , fromIndex */) {
  return $indexOf(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});

},{"1212":1212,"1219":1219}],1513:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require(1212);
var $includes = require(1219).includes;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.includes` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.includes
exportTypedArrayMethod('includes', function includes(searchElement /* , fromIndex */) {
  return $includes(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});

},{"1212":1212,"1219":1219}],1512:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require(1212);
var $forEach = require(1220).forEach;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.forEach` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.foreach
exportTypedArrayMethod('forEach', function forEach(callbackfn /* , thisArg */) {
  $forEach(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});

},{"1212":1212,"1220":1220}],1510:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require(1212);
var $find = require(1220).find;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.find` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.find
exportTypedArrayMethod('find', function find(predicate /* , thisArg */) {
  return $find(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});

},{"1212":1212,"1220":1220}],1509:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require(1212);
var $findIndex = require(1220).findIndex;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.findindex
exportTypedArrayMethod('findIndex', function findIndex(predicate /* , thisArg */) {
  return $findIndex(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});

},{"1212":1212,"1220":1220}],1508:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require(1212);
var $filter = require(1220).filter;
var fromSpeciesAndList = require(1397);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.filter` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.filter
exportTypedArrayMethod('filter', function filter(callbackfn /* , thisArg */) {
  var list = $filter(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  return fromSpeciesAndList(this, list);
});

},{"1212":1212,"1220":1220,"1397":1397}],1397:[function(require,module,exports){
var arrayFromConstructorAndList = require(1217);
var typedArraySpeciesConstructor = require(1399);

module.exports = function (instance, list) {
  return arrayFromConstructorAndList(typedArraySpeciesConstructor(instance), list);
};

},{"1217":1217,"1399":1399}],1399:[function(require,module,exports){
var ArrayBufferViewCore = require(1212);
var speciesConstructor = require(1367);

var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;

// a part of `TypedArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#typedarray-species-create
module.exports = function (originalArray) {
  return aTypedArrayConstructor(speciesConstructor(originalArray, getTypedArrayConstructor(originalArray)));
};

},{"1212":1212,"1367":1367}],1217:[function(require,module,exports){
var lengthOfArrayLike = require(1317);

module.exports = function (Constructor, list) {
  var index = 0;
  var length = lengthOfArrayLike(list);
  var result = new Constructor(length);
  while (length > index) result[index] = list[index++];
  return result;
};

},{"1317":1317}],1507:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require(1212);
var $fill = require(1215);
var toBigInt = require(1382);
var classof = require(1234);
var call = require(1278);
var uncurryThis = require(1281);
var fails = require(1271);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var slice = uncurryThis(''.slice);

// V8 ~ Chrome < 59, Safari < 14.1, FF < 55, Edge <=18
var CONVERSION_BUG = fails(function () {
  var count = 0;
  // eslint-disable-next-line es/no-typed-arrays -- safe
  new Int8Array(2).fill({ valueOf: function () { return count++; } });
  return count !== 1;
});

// `%TypedArray%.prototype.fill` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill
exportTypedArrayMethod('fill', function fill(value /* , start, end */) {
  var length = arguments.length;
  aTypedArray(this);
  var actualValue = slice(classof(this), 0, 3) === 'Big' ? toBigInt(value) : +value;
  return call($fill, this, actualValue, length > 1 ? arguments[1] : undefined, length > 2 ? arguments[2] : undefined);
}, CONVERSION_BUG);

},{"1212":1212,"1215":1215,"1234":1234,"1271":1271,"1278":1278,"1281":1281,"1382":1382}],1382:[function(require,module,exports){
var toPrimitive = require(1390);

var $TypeError = TypeError;

// `ToBigInt` abstract operation
// https://tc39.es/ecma262/#sec-tobigint
module.exports = function (argument) {
  var prim = toPrimitive(argument, 'number');
  if (typeof prim == 'number') throw $TypeError("Can't convert number to bigint");
  // eslint-disable-next-line es/no-bigint -- safe
  return BigInt(prim);
};

},{"1390":1390}],1506:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require(1212);
var $every = require(1220).every;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.every` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.every
exportTypedArrayMethod('every', function every(callbackfn /* , thisArg */) {
  return $every(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});

},{"1212":1212,"1220":1220}],1220:[function(require,module,exports){
var bind = require(1275);
var uncurryThis = require(1281);
var IndexedObject = require(1294);
var toObject = require(1387);
var lengthOfArrayLike = require(1317);
var arraySpeciesCreate = require(1230);

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};

},{"1230":1230,"1275":1275,"1281":1281,"1294":1294,"1317":1317,"1387":1387}],1275:[function(require,module,exports){
var uncurryThis = require(1280);
var aCallable = require(1203);
var NATIVE_BIND = require(1276);

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

},{"1203":1203,"1276":1276,"1280":1280}],1230:[function(require,module,exports){
var arraySpeciesConstructor = require(1229);

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};

},{"1229":1229}],1229:[function(require,module,exports){
var isArray = require(1300);
var isConstructor = require(1303);
var isObject = require(1307);
var wellKnownSymbol = require(1408);

var SPECIES = wellKnownSymbol('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};

},{"1300":1300,"1303":1303,"1307":1307,"1408":1408}],1505:[function(require,module,exports){
'use strict';
var uncurryThis = require(1281);
var ArrayBufferViewCore = require(1212);
var $ArrayCopyWithin = require(1214);

var u$ArrayCopyWithin = uncurryThis($ArrayCopyWithin);
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.copywithin
exportTypedArrayMethod('copyWithin', function copyWithin(target, start /* , end */) {
  return u$ArrayCopyWithin(aTypedArray(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
});

},{"1212":1212,"1214":1214,"1281":1281}],1214:[function(require,module,exports){
'use strict';
var toObject = require(1387);
var toAbsoluteIndex = require(1381);
var lengthOfArrayLike = require(1317);
var deletePropertyOrThrow = require(1250);

var min = Math.min;

// `Array.prototype.copyWithin` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
// eslint-disable-next-line es/no-array-prototype-copywithin -- safe
module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = lengthOfArrayLike(O);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else deletePropertyOrThrow(O, to);
    to += inc;
    from += inc;
  } return O;
};

},{"1250":1250,"1317":1317,"1381":1381,"1387":1387}],1250:[function(require,module,exports){
'use strict';
var tryToString = require(1394);

var $TypeError = TypeError;

module.exports = function (O, P) {
  if (!delete O[P]) throw $TypeError('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
};

},{"1394":1394}],1212:[function(require,module,exports){
'use strict';
var NATIVE_ARRAY_BUFFER = require(1210);
var DESCRIPTORS = require(1251);
var global = require(1287);
var isCallable = require(1302);
var isObject = require(1307);
var hasOwn = require(1288);
var classof = require(1234);
var tryToString = require(1394);
var createNonEnumerableProperty = require(1243);
var defineBuiltIn = require(1247);
var defineProperty = require(1328).f;
var isPrototypeOf = require(1335);
var getPrototypeOf = require(1333);
var setPrototypeOf = require(1339);
var wellKnownSymbol = require(1408);
var uid = require(1400);
var InternalStateModule = require(1298);

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var Int8Array = global.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var Uint8ClampedArray = global.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray && Uint8ClampedArray.prototype;
var TypedArray = Int8Array && getPrototypeOf(Int8Array);
var TypedArrayPrototype = Int8ArrayPrototype && getPrototypeOf(Int8ArrayPrototype);
var ObjectPrototype = Object.prototype;
var TypeError = global.TypeError;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var TYPED_ARRAY_TAG = uid('TYPED_ARRAY_TAG');
var TYPED_ARRAY_CONSTRUCTOR = 'TypedArrayConstructor';
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var NATIVE_ARRAY_BUFFER_VIEWS = NATIVE_ARRAY_BUFFER && !!setPrototypeOf && classof(global.opera) !== 'Opera';
var TYPED_ARRAY_TAG_REQUIRED = false;
var NAME, Constructor, Prototype;

var TypedArrayConstructorsList = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
};

var BigIntArrayConstructorsList = {
  BigInt64Array: 8,
  BigUint64Array: 8
};

var isView = function isView(it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return klass === 'DataView'
    || hasOwn(TypedArrayConstructorsList, klass)
    || hasOwn(BigIntArrayConstructorsList, klass);
};

var getTypedArrayConstructor = function (it) {
  var proto = getPrototypeOf(it);
  if (!isObject(proto)) return;
  var state = getInternalState(proto);
  return (state && hasOwn(state, TYPED_ARRAY_CONSTRUCTOR)) ? state[TYPED_ARRAY_CONSTRUCTOR] : getTypedArrayConstructor(proto);
};

var isTypedArray = function (it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return hasOwn(TypedArrayConstructorsList, klass)
    || hasOwn(BigIntArrayConstructorsList, klass);
};

var aTypedArray = function (it) {
  if (isTypedArray(it)) return it;
  throw TypeError('Target is not a typed array');
};

var aTypedArrayConstructor = function (C) {
  if (isCallable(C) && (!setPrototypeOf || isPrototypeOf(TypedArray, C))) return C;
  throw TypeError(tryToString(C) + ' is not a typed array constructor');
};

var exportTypedArrayMethod = function (KEY, property, forced, options) {
  if (!DESCRIPTORS) return;
  if (forced) for (var ARRAY in TypedArrayConstructorsList) {
    var TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && hasOwn(TypedArrayConstructor.prototype, KEY)) try {
      delete TypedArrayConstructor.prototype[KEY];
    } catch (error) {
      // old WebKit bug - some methods are non-configurable
      try {
        TypedArrayConstructor.prototype[KEY] = property;
      } catch (error2) { /* empty */ }
    }
  }
  if (!TypedArrayPrototype[KEY] || forced) {
    defineBuiltIn(TypedArrayPrototype, KEY, forced ? property
      : NATIVE_ARRAY_BUFFER_VIEWS && Int8ArrayPrototype[KEY] || property, options);
  }
};

var exportTypedArrayStaticMethod = function (KEY, property, forced) {
  var ARRAY, TypedArrayConstructor;
  if (!DESCRIPTORS) return;
  if (setPrototypeOf) {
    if (forced) for (ARRAY in TypedArrayConstructorsList) {
      TypedArrayConstructor = global[ARRAY];
      if (TypedArrayConstructor && hasOwn(TypedArrayConstructor, KEY)) try {
        delete TypedArrayConstructor[KEY];
      } catch (error) { /* empty */ }
    }
    if (!TypedArray[KEY] || forced) {
      // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
      try {
        return defineBuiltIn(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && TypedArray[KEY] || property);
      } catch (error) { /* empty */ }
    } else return;
  }
  for (ARRAY in TypedArrayConstructorsList) {
    TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
      defineBuiltIn(TypedArrayConstructor, KEY, property);
    }
  }
};

for (NAME in TypedArrayConstructorsList) {
  Constructor = global[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
  else NATIVE_ARRAY_BUFFER_VIEWS = false;
}

for (NAME in BigIntArrayConstructorsList) {
  Constructor = global[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
}

// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!NATIVE_ARRAY_BUFFER_VIEWS || !isCallable(TypedArray) || TypedArray === Function.prototype) {
  // eslint-disable-next-line no-shadow -- safe
  TypedArray = function TypedArray() {
    throw TypeError('Incorrect invocation');
  };
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME], TypedArray);
  }
}

if (!NATIVE_ARRAY_BUFFER_VIEWS || !TypedArrayPrototype || TypedArrayPrototype === ObjectPrototype) {
  TypedArrayPrototype = TypedArray.prototype;
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME].prototype, TypedArrayPrototype);
  }
}

// WebKit bug - one more object in Uint8ClampedArray prototype chain
if (NATIVE_ARRAY_BUFFER_VIEWS && getPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype) {
  setPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype);
}

if (DESCRIPTORS && !hasOwn(TypedArrayPrototype, TO_STRING_TAG)) {
  TYPED_ARRAY_TAG_REQUIRED = true;
  defineProperty(TypedArrayPrototype, TO_STRING_TAG, { get: function () {
    return isObject(this) ? this[TYPED_ARRAY_TAG] : undefined;
  } });
  for (NAME in TypedArrayConstructorsList) if (global[NAME]) {
    createNonEnumerableProperty(global[NAME], TYPED_ARRAY_TAG, NAME);
  }
}

module.exports = {
  NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS,
  TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQUIRED && TYPED_ARRAY_TAG,
  aTypedArray: aTypedArray,
  aTypedArrayConstructor: aTypedArrayConstructor,
  exportTypedArrayMethod: exportTypedArrayMethod,
  exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
  getTypedArrayConstructor: getTypedArrayConstructor,
  isView: isView,
  isTypedArray: isTypedArray,
  TypedArray: TypedArray,
  TypedArrayPrototype: TypedArrayPrototype
};

},{"1210":1210,"1234":1234,"1243":1243,"1247":1247,"1251":1251,"1287":1287,"1288":1288,"1298":1298,"1302":1302,"1307":1307,"1328":1328,"1333":1333,"1335":1335,"1339":1339,"1394":1394,"1400":1400,"1408":1408}],1492:[function(require,module,exports){
'use strict';
var apply = require(1274);
var call = require(1278);
var uncurryThis = require(1281);
var fixRegExpWellKnownSymbolLogic = require(1272);
var fails = require(1271);
var anObject = require(1209);
var isCallable = require(1302);
var isNullOrUndefined = require(1306);
var toIntegerOrInfinity = require(1385);
var toLength = require(1386);
var toString = require(1393);
var requireObjectCoercible = require(1359);
var advanceStringIndex = require(1207);
var getMethod = require(1285);
var getSubstitution = require(1286);
var regExpExec = require(1352);
var wellKnownSymbol = require(1408);

var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;
var concat = uncurryThis([].concat);
var push = uncurryThis([].push);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = isNullOrUndefined(searchValue) ? undefined : getMethod(searchValue, REPLACE);
      return replacer
        ? call(replacer, searchValue, O, replaceValue)
        : call(nativeReplace, toString(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject(this);
      var S = toString(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        push(results, result);
        if (!global) break;

        var matchStr = toString(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString(result[0]);
        var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
          var replacement = toString(apply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + stringSlice(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

},{"1207":1207,"1209":1209,"1271":1271,"1272":1272,"1274":1274,"1278":1278,"1281":1281,"1285":1285,"1286":1286,"1302":1302,"1306":1306,"1352":1352,"1359":1359,"1385":1385,"1386":1386,"1393":1393,"1408":1408}],1352:[function(require,module,exports){
var call = require(1278);
var anObject = require(1209);
var isCallable = require(1302);
var classof = require(1233);
var regexpExec = require(1353);

var $TypeError = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = call(exec, R, S);
    if (result !== null) anObject(result);
    return result;
  }
  if (classof(R) === 'RegExp') return call(regexpExec, R, S);
  throw $TypeError('RegExp#exec called on incompatible receiver');
};

},{"1209":1209,"1233":1233,"1278":1278,"1302":1302,"1353":1353}],1286:[function(require,module,exports){
var uncurryThis = require(1281);
var toObject = require(1387);

var floor = Math.floor;
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice(str, 0, position);
      case "'": return stringSlice(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

},{"1281":1281,"1387":1387}],1274:[function(require,module,exports){
var NATIVE_BIND = require(1276);

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});

},{"1276":1276}],1272:[function(require,module,exports){
'use strict';
// TODO: Remove from `core-js@4` since it's moved to entry points
require(1477);
var uncurryThis = require(1280);
var defineBuiltIn = require(1247);
var regexpExec = require(1353);
var fails = require(1271);
var wellKnownSymbol = require(1408);
var createNonEnumerableProperty = require(1243);

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

module.exports = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};

},{"1243":1243,"1247":1247,"1271":1271,"1280":1280,"1353":1353,"1408":1408,"1477":1477}],1207:[function(require,module,exports){
'use strict';
var charAt = require(1369).charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};

},{"1369":1369}],1369:[function(require,module,exports){
var uncurryThis = require(1281);
var toIntegerOrInfinity = require(1385);
var toString = require(1393);
var requireObjectCoercible = require(1359);

var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};

},{"1281":1281,"1359":1359,"1385":1385,"1393":1393}],1477:[function(require,module,exports){
'use strict';
var $ = require(1270);
var exec = require(1353);

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});

},{"1270":1270,"1353":1353}],1353:[function(require,module,exports){
'use strict';
/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call = require(1278);
var uncurryThis = require(1281);
var toString = require(1393);
var regexpFlags = require(1354);
var stickyHelpers = require(1356);
var shared = require(1366);
var create = require(1326);
var getInternalState = require(1298).get;
var UNSUPPORTED_DOT_ALL = require(1357);
var UNSUPPORTED_NCG = require(1358);

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt = uncurryThis(''.charAt);
var indexOf = uncurryThis(''.indexOf);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call(nativeExec, re1, 'a');
  call(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice(match.input, charsAdded);
        match[0] = stringSlice(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

module.exports = patchedExec;

},{"1278":1278,"1281":1281,"1298":1298,"1326":1326,"1354":1354,"1356":1356,"1357":1357,"1358":1358,"1366":1366,"1393":1393}],1358:[function(require,module,exports){
var fails = require(1271);
var global = require(1287);

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

},{"1271":1271,"1287":1287}],1357:[function(require,module,exports){
var fails = require(1271);
var global = require(1287);

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});

},{"1271":1271,"1287":1287}],1356:[function(require,module,exports){
var fails = require(1271);
var global = require(1287);

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = global.RegExp;

var UNSUPPORTED_Y = fails(function () {
  var re = $RegExp('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y || fails(function () {
  return !$RegExp('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y || fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

module.exports = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y
};

},{"1271":1271,"1287":1287}],1466:[function(require,module,exports){
var $ = require(1270);
var $parseInt = require(1324);

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$({ global: true, forced: parseInt != $parseInt }, {
  parseInt: $parseInt
});

},{"1270":1270,"1324":1324}],1324:[function(require,module,exports){
var global = require(1287);
var fails = require(1271);
var uncurryThis = require(1281);
var toString = require(1393);
var trim = require(1375).trim;
var whitespaces = require(1409);

var $parseInt = global.parseInt;
var Symbol = global.Symbol;
var ITERATOR = Symbol && Symbol.iterator;
var hex = /^[+-]?0x/i;
var exec = uncurryThis(hex.exec);
var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR && !fails(function () { $parseInt(Object(ITERATOR)); }));

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
module.exports = FORCED ? function parseInt(string, radix) {
  var S = trim(toString(string));
  return $parseInt(S, (radix >>> 0) || (exec(hex, S) ? 16 : 10));
} : $parseInt;

},{"1271":1271,"1281":1281,"1287":1287,"1375":1375,"1393":1393,"1409":1409}],1446:[function(require,module,exports){
'use strict';
var $ = require(1270);
var IS_PURE = require(1308);
var DESCRIPTORS = require(1251);
var global = require(1287);
var path = require(1344);
var uncurryThis = require(1281);
var isForced = require(1304);
var hasOwn = require(1288);
var inheritIfRequired = require(1295);
var isPrototypeOf = require(1335);
var isSymbol = require(1310);
var toPrimitive = require(1390);
var fails = require(1271);
var getOwnPropertyNames = require(1331).f;
var getOwnPropertyDescriptor = require(1329).f;
var defineProperty = require(1328).f;
var thisNumberValue = require(1380);
var trim = require(1375).trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var PureNumberNamespace = path[NUMBER];
var NumberPrototype = NativeNumber.prototype;
var TypeError = global.TypeError;
var stringSlice = uncurryThis(''.slice);
var charCodeAt = uncurryThis(''.charCodeAt);

// `ToNumeric` abstract operation
// https://tc39.es/ecma262/#sec-tonumeric
var toNumeric = function (value) {
  var primValue = toPrimitive(value, 'number');
  return typeof primValue == 'bigint' ? primValue : toNumber(primValue);
};

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, 'number');
  var first, third, radix, maxCode, digits, length, index, code;
  if (isSymbol(it)) throw TypeError('Cannot convert a Symbol value to a number');
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = charCodeAt(it, 0);
    if (first === 43 || first === 45) {
      third = charCodeAt(it, 2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (charCodeAt(it, 1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = stringSlice(it, 2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = charCodeAt(digits, index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

var FORCED = isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'));

var calledWithNew = function (dummy) {
  // includes check on 1..constructor(foo) case
  return isPrototypeOf(NumberPrototype, dummy) && fails(function () { thisNumberValue(dummy); });
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
var NumberWrapper = function Number(value) {
  var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
  return calledWithNew(this) ? inheritIfRequired(Object(n), this, NumberWrapper) : n;
};

NumberWrapper.prototype = NumberPrototype;
if (FORCED && !IS_PURE) NumberPrototype.constructor = NumberWrapper;

$({ global: true, constructor: true, wrap: true, forced: FORCED }, {
  Number: NumberWrapper
});

// Use `internal/copy-constructor-properties` helper in `core-js@4`
var copyConstructorProperties = function (target, source) {
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(source) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (hasOwn(source, key = keys[j]) && !hasOwn(target, key)) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

if (IS_PURE && PureNumberNamespace) copyConstructorProperties(path[NUMBER], PureNumberNamespace);
if (FORCED || IS_PURE) copyConstructorProperties(path[NUMBER], NativeNumber);

},{"1251":1251,"1270":1270,"1271":1271,"1281":1281,"1287":1287,"1288":1288,"1295":1295,"1304":1304,"1308":1308,"1310":1310,"1328":1328,"1329":1329,"1331":1331,"1335":1335,"1344":1344,"1375":1375,"1380":1380,"1390":1390}],1380:[function(require,module,exports){
var uncurryThis = require(1281);

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
module.exports = uncurryThis(1.0.valueOf);

},{"1281":1281}],1375:[function(require,module,exports){
var uncurryThis = require(1281);
var requireObjectCoercible = require(1359);
var toString = require(1393);
var whitespaces = require(1409);

var replace = uncurryThis(''.replace);
var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString(requireObjectCoercible($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};

},{"1281":1281,"1359":1359,"1393":1393,"1409":1409}],1409:[function(require,module,exports){
// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

},{}],1344:[function(require,module,exports){
var global = require(1287);

module.exports = global;

},{"1287":1287}],1295:[function(require,module,exports){
var isCallable = require(1302);
var isObject = require(1307);
var setPrototypeOf = require(1339);

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};

},{"1302":1302,"1307":1307,"1339":1339}],1428:[function(require,module,exports){
'use strict';
var $ = require(1270);
var uncurryThis = require(1281);
var isArray = require(1300);

var nativeReverse = uncurryThis([].reverse);
var test = [1, 2];

// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$({ target: 'Array', proto: true, forced: String(test) === String(test.reverse()) }, {
  reverse: function reverse() {
    // eslint-disable-next-line no-self-assign -- dirty hack
    if (isArray(this)) this.length = this.length;
    return nativeReverse(this);
  }
});

},{"1270":1270,"1281":1281,"1300":1300}],1300:[function(require,module,exports){
var classof = require(1233);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};

},{"1233":1233}],1424:[function(require,module,exports){
'use strict';
var $ = require(1270);
var uncurryThis = require(1281);
var IndexedObject = require(1294);
var toIndexedObject = require(1384);
var arrayMethodIsStrict = require(1223);

var nativeJoin = uncurryThis([].join);

var ES3_STRINGS = IndexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
  join: function join(separator) {
    return nativeJoin(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});

},{"1223":1223,"1270":1270,"1281":1281,"1294":1294,"1384":1384}],1223:[function(require,module,exports){
'use strict';
var fails = require(1271);

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};

},{"1271":1271}],1423:[function(require,module,exports){
'use strict';
var toIndexedObject = require(1384);
var addToUnscopables = require(1206);
var Iterators = require(1316);
var InternalStateModule = require(1298);
var defineProperty = require(1328).f;
var defineIterator = require(1314);
var createIterResultObject = require(1242);
var IS_PURE = require(1308);
var DESCRIPTORS = require(1251);

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  if (kind == 'keys') return createIterResultObject(index, false);
  if (kind == 'values') return createIterResultObject(target[index], false);
  return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
  defineProperty(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

},{"1206":1206,"1242":1242,"1251":1251,"1298":1298,"1308":1308,"1314":1314,"1316":1316,"1328":1328,"1384":1384}],1314:[function(require,module,exports){
'use strict';
var $ = require(1270);
var call = require(1278);
var IS_PURE = require(1308);
var FunctionName = require(1279);
var isCallable = require(1302);
var createIteratorConstructor = require(1313);
var getPrototypeOf = require(1333);
var setPrototypeOf = require(1339);
var setToStringTag = require(1363);
var createNonEnumerableProperty = require(1243);
var defineBuiltIn = require(1247);
var wellKnownSymbol = require(1408);
var Iterators = require(1316);
var IteratorsCore = require(1315);

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};

},{"1243":1243,"1247":1247,"1270":1270,"1278":1278,"1279":1279,"1302":1302,"1308":1308,"1313":1313,"1315":1315,"1316":1316,"1333":1333,"1339":1339,"1363":1363,"1408":1408}],1313:[function(require,module,exports){
'use strict';
var IteratorPrototype = require(1315).IteratorPrototype;
var create = require(1326);
var createPropertyDescriptor = require(1244);
var setToStringTag = require(1363);
var Iterators = require(1316);

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};

},{"1244":1244,"1315":1315,"1316":1316,"1326":1326,"1363":1363}],1316:[function(require,module,exports){
arguments[4][1289][0].apply(exports,arguments)
},{"1289":1289}],1315:[function(require,module,exports){
'use strict';
var fails = require(1271);
var isCallable = require(1302);
var isObject = require(1307);
var create = require(1326);
var getPrototypeOf = require(1333);
var defineBuiltIn = require(1247);
var wellKnownSymbol = require(1408);
var IS_PURE = require(1308);

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};

},{"1247":1247,"1271":1271,"1302":1302,"1307":1307,"1308":1308,"1326":1326,"1333":1333,"1408":1408}],1242:[function(require,module,exports){
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function (value, done) {
  return { value: value, done: done };
};

},{}],1206:[function(require,module,exports){
var wellKnownSymbol = require(1408);
var create = require(1326);
var defineProperty = require(1328).f;

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

},{"1326":1326,"1328":1328,"1408":1408}],1326:[function(require,module,exports){
/* global ActiveXObject -- old IE, WSH */
var anObject = require(1209);
var definePropertiesModule = require(1327);
var enumBugKeys = require(1269);
var hiddenKeys = require(1289);
var html = require(1291);
var documentCreateElement = require(1253);
var sharedKey = require(1364);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

},{"1209":1209,"1253":1253,"1269":1269,"1289":1289,"1291":1291,"1327":1327,"1364":1364}],1327:[function(require,module,exports){
var DESCRIPTORS = require(1251);
var V8_PROTOTYPE_DEFINE_BUG = require(1403);
var definePropertyModule = require(1328);
var anObject = require(1209);
var toIndexedObject = require(1384);
var objectKeys = require(1337);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};

},{"1209":1209,"1251":1251,"1328":1328,"1337":1337,"1384":1384,"1403":1403}],1337:[function(require,module,exports){
var internalObjectKeys = require(1336);
var enumBugKeys = require(1269);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};

},{"1269":1269,"1336":1336}],1291:[function(require,module,exports){
var getBuiltIn = require(1282);

module.exports = getBuiltIn('document', 'documentElement');

},{"1282":1282}],1411:[function(require,module,exports){
'use strict';
var $ = require(1270);
var uncurryThis = require(1280);
var fails = require(1271);
var ArrayBufferModule = require(1213);
var anObject = require(1209);
var toAbsoluteIndex = require(1381);
var toLength = require(1386);
var speciesConstructor = require(1367);

var ArrayBuffer = ArrayBufferModule.ArrayBuffer;
var DataView = ArrayBufferModule.DataView;
var DataViewPrototype = DataView.prototype;
var nativeArrayBufferSlice = uncurryThis(ArrayBuffer.prototype.slice);
var getUint8 = uncurryThis(DataViewPrototype.getUint8);
var setUint8 = uncurryThis(DataViewPrototype.setUint8);

var INCORRECT_SLICE = fails(function () {
  return !new ArrayBuffer(2).slice(1, undefined).byteLength;
});

// `ArrayBuffer.prototype.slice` method
// https://tc39.es/ecma262/#sec-arraybuffer.prototype.slice
$({ target: 'ArrayBuffer', proto: true, unsafe: true, forced: INCORRECT_SLICE }, {
  slice: function slice(start, end) {
    if (nativeArrayBufferSlice && end === undefined) {
      return nativeArrayBufferSlice(anObject(this), start); // FF fix
    }
    var length = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    var result = new (speciesConstructor(this, ArrayBuffer))(toLength(fin - first));
    var viewSource = new DataView(this);
    var viewTarget = new DataView(result);
    var index = 0;
    while (first < fin) {
      setUint8(viewTarget, index++, getUint8(viewSource, first++));
    } return result;
  }
});

},{"1209":1209,"1213":1213,"1270":1270,"1271":1271,"1280":1280,"1367":1367,"1381":1381,"1386":1386}],1367:[function(require,module,exports){
var anObject = require(1209);
var aConstructor = require(1204);
var isNullOrUndefined = require(1306);
var wellKnownSymbol = require(1408);

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES]) ? defaultConstructor : aConstructor(S);
};

},{"1204":1204,"1209":1209,"1306":1306,"1408":1408}],1204:[function(require,module,exports){
var isConstructor = require(1303);
var tryToString = require(1394);

var $TypeError = TypeError;

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a constructor');
};

},{"1303":1303,"1394":1394}],1303:[function(require,module,exports){
var uncurryThis = require(1281);
var fails = require(1271);
var isCallable = require(1302);
var classof = require(1234);
var getBuiltIn = require(1282);
var inspectSource = require(1296);

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

},{"1234":1234,"1271":1271,"1281":1281,"1282":1282,"1296":1296,"1302":1302}],1280:[function(require,module,exports){
var classofRaw = require(1233);
var uncurryThis = require(1281);

module.exports = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis(fn);
};

},{"1233":1233,"1281":1281}],1410:[function(require,module,exports){
'use strict';
var $ = require(1270);
var global = require(1287);
var arrayBufferModule = require(1213);
var setSpecies = require(1362);

var ARRAY_BUFFER = 'ArrayBuffer';
var ArrayBuffer = arrayBufferModule[ARRAY_BUFFER];
var NativeArrayBuffer = global[ARRAY_BUFFER];

// `ArrayBuffer` constructor
// https://tc39.es/ecma262/#sec-arraybuffer-constructor
$({ global: true, constructor: true, forced: NativeArrayBuffer !== ArrayBuffer }, {
  ArrayBuffer: ArrayBuffer
});

setSpecies(ARRAY_BUFFER);

},{"1213":1213,"1270":1270,"1287":1287,"1362":1362}],1362:[function(require,module,exports){
'use strict';
var getBuiltIn = require(1282);
var definePropertyModule = require(1328);
var wellKnownSymbol = require(1408);
var DESCRIPTORS = require(1251);

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

},{"1251":1251,"1282":1282,"1328":1328,"1408":1408}],1213:[function(require,module,exports){
'use strict';
var global = require(1287);
var uncurryThis = require(1281);
var DESCRIPTORS = require(1251);
var NATIVE_ARRAY_BUFFER = require(1210);
var FunctionName = require(1279);
var createNonEnumerableProperty = require(1243);
var defineBuiltIns = require(1248);
var fails = require(1271);
var anInstance = require(1208);
var toIntegerOrInfinity = require(1385);
var toLength = require(1386);
var toIndex = require(1383);
var IEEE754 = require(1293);
var getPrototypeOf = require(1333);
var setPrototypeOf = require(1339);
var getOwnPropertyNames = require(1331).f;
var defineProperty = require(1328).f;
var arrayFill = require(1215);
var arraySlice = require(1226);
var setToStringTag = require(1363);
var InternalStateModule = require(1298);

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length';
var WRONG_INDEX = 'Wrong index';
var NativeArrayBuffer = global[ARRAY_BUFFER];
var $ArrayBuffer = NativeArrayBuffer;
var ArrayBufferPrototype = $ArrayBuffer && $ArrayBuffer[PROTOTYPE];
var $DataView = global[DATA_VIEW];
var DataViewPrototype = $DataView && $DataView[PROTOTYPE];
var ObjectPrototype = Object.prototype;
var Array = global.Array;
var RangeError = global.RangeError;
var fill = uncurryThis(arrayFill);
var reverse = uncurryThis([].reverse);

var packIEEE754 = IEEE754.pack;
var unpackIEEE754 = IEEE754.unpack;

var packInt8 = function (number) {
  return [number & 0xFF];
};

var packInt16 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF];
};

var packInt32 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF, number >> 16 & 0xFF, number >> 24 & 0xFF];
};

var unpackInt32 = function (buffer) {
  return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
};

var packFloat32 = function (number) {
  return packIEEE754(number, 23, 4);
};

var packFloat64 = function (number) {
  return packIEEE754(number, 52, 8);
};

var addGetter = function (Constructor, key) {
  defineProperty(Constructor[PROTOTYPE], key, { get: function () { return getInternalState(this)[key]; } });
};

var get = function (view, count, index, isLittleEndian) {
  var intIndex = toIndex(index);
  var store = getInternalState(view);
  if (intIndex + count > store.byteLength) throw RangeError(WRONG_INDEX);
  var bytes = getInternalState(store.buffer).bytes;
  var start = intIndex + store.byteOffset;
  var pack = arraySlice(bytes, start, start + count);
  return isLittleEndian ? pack : reverse(pack);
};

var set = function (view, count, index, conversion, value, isLittleEndian) {
  var intIndex = toIndex(index);
  var store = getInternalState(view);
  if (intIndex + count > store.byteLength) throw RangeError(WRONG_INDEX);
  var bytes = getInternalState(store.buffer).bytes;
  var start = intIndex + store.byteOffset;
  var pack = conversion(+value);
  for (var i = 0; i < count; i++) bytes[start + i] = pack[isLittleEndian ? i : count - i - 1];
};

if (!NATIVE_ARRAY_BUFFER) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, ArrayBufferPrototype);
    var byteLength = toIndex(length);
    setInternalState(this, {
      bytes: fill(Array(byteLength), 0),
      byteLength: byteLength
    });
    if (!DESCRIPTORS) this.byteLength = byteLength;
  };

  ArrayBufferPrototype = $ArrayBuffer[PROTOTYPE];

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, DataViewPrototype);
    anInstance(buffer, ArrayBufferPrototype);
    var bufferLength = getInternalState(buffer).byteLength;
    var offset = toIntegerOrInfinity(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    setInternalState(this, {
      buffer: buffer,
      byteLength: byteLength,
      byteOffset: offset
    });
    if (!DESCRIPTORS) {
      this.buffer = buffer;
      this.byteLength = byteLength;
      this.byteOffset = offset;
    }
  };

  DataViewPrototype = $DataView[PROTOTYPE];

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, 'byteLength');
    addGetter($DataView, 'buffer');
    addGetter($DataView, 'byteLength');
    addGetter($DataView, 'byteOffset');
  }

  defineBuiltIns(DataViewPrototype, {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined)) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 23);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 52);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packFloat32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packFloat64, value, arguments.length > 2 ? arguments[2] : undefined);
    }
  });
} else {
  var INCORRECT_ARRAY_BUFFER_NAME = PROPER_FUNCTION_NAME && NativeArrayBuffer.name !== ARRAY_BUFFER;
  /* eslint-disable no-new -- required for testing */
  if (!fails(function () {
    NativeArrayBuffer(1);
  }) || !fails(function () {
    new NativeArrayBuffer(-1);
  }) || fails(function () {
    new NativeArrayBuffer();
    new NativeArrayBuffer(1.5);
    new NativeArrayBuffer(NaN);
    return NativeArrayBuffer.length != 1 || INCORRECT_ARRAY_BUFFER_NAME && !CONFIGURABLE_FUNCTION_NAME;
  })) {
    /* eslint-enable no-new -- required for testing */
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, ArrayBufferPrototype);
      return new NativeArrayBuffer(toIndex(length));
    };

    $ArrayBuffer[PROTOTYPE] = ArrayBufferPrototype;

    for (var keys = getOwnPropertyNames(NativeArrayBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) {
        createNonEnumerableProperty($ArrayBuffer, key, NativeArrayBuffer[key]);
      }
    }

    ArrayBufferPrototype.constructor = $ArrayBuffer;
  } else if (INCORRECT_ARRAY_BUFFER_NAME && CONFIGURABLE_FUNCTION_NAME) {
    createNonEnumerableProperty(NativeArrayBuffer, 'name', ARRAY_BUFFER);
  }

  // WebKit bug - the same parent prototype for typed arrays and data view
  if (setPrototypeOf && getPrototypeOf(DataViewPrototype) !== ObjectPrototype) {
    setPrototypeOf(DataViewPrototype, ObjectPrototype);
  }

  // iOS Safari 7.x bug
  var testView = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = uncurryThis(DataViewPrototype.setInt8);
  testView.setInt8(0, 2147483648);
  testView.setInt8(1, 2147483649);
  if (testView.getInt8(0) || !testView.getInt8(1)) defineBuiltIns(DataViewPrototype, {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8(this, byteOffset, value << 24 >> 24);
    }
  }, { unsafe: true });
}

setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);

module.exports = {
  ArrayBuffer: $ArrayBuffer,
  DataView: $DataView
};

},{"1208":1208,"1210":1210,"1215":1215,"1226":1226,"1243":1243,"1248":1248,"1251":1251,"1271":1271,"1279":1279,"1281":1281,"1287":1287,"1293":1293,"1298":1298,"1328":1328,"1331":1331,"1333":1333,"1339":1339,"1363":1363,"1383":1383,"1385":1385,"1386":1386}],1383:[function(require,module,exports){
var toIntegerOrInfinity = require(1385);
var toLength = require(1386);

var $RangeError = RangeError;

// `ToIndex` abstract operation
// https://tc39.es/ecma262/#sec-toindex
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toIntegerOrInfinity(it);
  var length = toLength(number);
  if (number !== length) throw $RangeError('Wrong length or index');
  return length;
};

},{"1385":1385,"1386":1386}],1363:[function(require,module,exports){
var defineProperty = require(1328).f;
var hasOwn = require(1288);
var wellKnownSymbol = require(1408);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn(target, TO_STRING_TAG)) {
    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};

},{"1288":1288,"1328":1328,"1408":1408}],1339:[function(require,module,exports){
/* eslint-disable no-proto -- safe */
var uncurryThis = require(1281);
var anObject = require(1209);
var aPossiblePrototype = require(1205);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

},{"1205":1205,"1209":1209,"1281":1281}],1205:[function(require,module,exports){
var isCallable = require(1302);

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw $TypeError("Can't set " + $String(argument) + ' as a prototype');
};

},{"1302":1302}],1333:[function(require,module,exports){
var hasOwn = require(1288);
var isCallable = require(1302);
var toObject = require(1387);
var sharedKey = require(1364);
var CORRECT_PROTOTYPE_GETTER = require(1240);

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};

},{"1240":1240,"1288":1288,"1302":1302,"1364":1364,"1387":1387}],1240:[function(require,module,exports){
var fails = require(1271);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

},{"1271":1271}],1293:[function(require,module,exports){
// IEEE754 conversions based on https://github.com/feross/ieee754
var $Array = Array;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;

var pack = function (number, mantissaLength, bytes) {
  var buffer = $Array(bytes);
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var rt = mantissaLength === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
  var index = 0;
  var exponent, mantissa, c;
  number = abs(number);
  // eslint-disable-next-line no-self-compare -- NaN check
  if (number != number || number === Infinity) {
    // eslint-disable-next-line no-self-compare -- NaN check
    mantissa = number != number ? 1 : 0;
    exponent = eMax;
  } else {
    exponent = floor(log(number) / LN2);
    c = pow(2, -exponent);
    if (number * c < 1) {
      exponent--;
      c *= 2;
    }
    if (exponent + eBias >= 1) {
      number += rt / c;
    } else {
      number += rt * pow(2, 1 - eBias);
    }
    if (number * c >= 2) {
      exponent++;
      c /= 2;
    }
    if (exponent + eBias >= eMax) {
      mantissa = 0;
      exponent = eMax;
    } else if (exponent + eBias >= 1) {
      mantissa = (number * c - 1) * pow(2, mantissaLength);
      exponent = exponent + eBias;
    } else {
      mantissa = number * pow(2, eBias - 1) * pow(2, mantissaLength);
      exponent = 0;
    }
  }
  while (mantissaLength >= 8) {
    buffer[index++] = mantissa & 255;
    mantissa /= 256;
    mantissaLength -= 8;
  }
  exponent = exponent << mantissaLength | mantissa;
  exponentLength += mantissaLength;
  while (exponentLength > 0) {
    buffer[index++] = exponent & 255;
    exponent /= 256;
    exponentLength -= 8;
  }
  buffer[--index] |= sign * 128;
  return buffer;
};

var unpack = function (buffer, mantissaLength) {
  var bytes = buffer.length;
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var nBits = exponentLength - 7;
  var index = bytes - 1;
  var sign = buffer[index--];
  var exponent = sign & 127;
  var mantissa;
  sign >>= 7;
  while (nBits > 0) {
    exponent = exponent * 256 + buffer[index--];
    nBits -= 8;
  }
  mantissa = exponent & (1 << -nBits) - 1;
  exponent >>= -nBits;
  nBits += mantissaLength;
  while (nBits > 0) {
    mantissa = mantissa * 256 + buffer[index--];
    nBits -= 8;
  }
  if (exponent === 0) {
    exponent = 1 - eBias;
  } else if (exponent === eMax) {
    return mantissa ? NaN : sign ? -Infinity : Infinity;
  } else {
    mantissa = mantissa + pow(2, mantissaLength);
    exponent = exponent - eBias;
  } return (sign ? -1 : 1) * mantissa * pow(2, exponent - mantissaLength);
};

module.exports = {
  pack: pack,
  unpack: unpack
};

},{}],1248:[function(require,module,exports){
var defineBuiltIn = require(1247);

module.exports = function (target, src, options) {
  for (var key in src) defineBuiltIn(target, key, src[key], options);
  return target;
};

},{"1247":1247}],1226:[function(require,module,exports){
var toAbsoluteIndex = require(1381);
var lengthOfArrayLike = require(1317);
var createProperty = require(1245);

var $Array = Array;
var max = Math.max;

module.exports = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = $Array(max(fin - k, 0));
  for (var n = 0; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};

},{"1245":1245,"1317":1317,"1381":1381}],1245:[function(require,module,exports){
'use strict';
var toPropertyKey = require(1391);
var definePropertyModule = require(1328);
var createPropertyDescriptor = require(1244);

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};

},{"1244":1244,"1328":1328,"1391":1391}],1215:[function(require,module,exports){
'use strict';
var toObject = require(1387);
var toAbsoluteIndex = require(1381);
var lengthOfArrayLike = require(1317);

// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = lengthOfArrayLike(O);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};

},{"1317":1317,"1381":1381,"1387":1387}],1210:[function(require,module,exports){
// eslint-disable-next-line es/no-typed-arrays -- safe
module.exports = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';

},{}],1208:[function(require,module,exports){
var isPrototypeOf = require(1335);

var $TypeError = TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw $TypeError('Incorrect invocation');
};

},{"1335":1335}],1184:[function(require,module,exports){
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],825:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1437);
require(1463);
require(1478);
/**
 * 大整数，将整数分为两部分，百亿部分在高端整数部分存储，低于百亿部分在低端存储，这样便于形成字符串
 * @author jiang
 */
var LOW_MAX = 10000000000;
function BigNumber(low, high) {
  this.low = low;
  this.high = high || 0;
}
;
BigNumber.prototype.multiplay = function (mul) {
  this.high *= mul;
  this.low *= mul;
  this.adjust();
};
BigNumber.prototype.add = function (num) {
  this.low += num;
  this.adjust();
};
BigNumber.prototype.addBigNumber = function (bigN) {
  this.high += bigN.high;
  this.low += bigN.low;
  this.adjust();
};
BigNumber.prototype.adjust = function () {
  if (this.low >= LOW_MAX) {
    var overflow = Math.floor(this.low / LOW_MAX);
    this.high += overflow;
    this.low -= overflow * LOW_MAX;
  }
};
BigNumber.prototype.toString = function () {
  var str = "" + this.low;
  var len = str.length;
  if (this.high != 0) {
    var hstr = "" + this.high;
    for (var i = 0; i < 10 - len; i++) {
      str = "0" + str;
    }
    str = hstr + str;
  }
  return str;
};
var _default = exports["default"] = BigNumber;

},{"1437":1437,"1454":1454,"1463":1463,"1478":1478}],1478:[function(require,module,exports){
'use strict';
var PROPER_FUNCTION_NAME = require(1279).PROPER;
var defineBuiltIn = require(1247);
var anObject = require(1209);
var $toString = require(1393);
var fails = require(1271);
var getRegExpFlags = require(1355);

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}

},{"1209":1209,"1247":1247,"1271":1271,"1279":1279,"1355":1355,"1393":1393}],1355:[function(require,module,exports){
var call = require(1278);
var hasOwn = require(1288);
var isPrototypeOf = require(1335);
var regExpFlags = require(1354);

var RegExpPrototype = RegExp.prototype;

module.exports = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype) && !hasOwn(R, 'flags') && isPrototypeOf(RegExpPrototype, R)
    ? call(regExpFlags, R) : flags;
};

},{"1278":1278,"1288":1288,"1335":1335,"1354":1354}],1354:[function(require,module,exports){
'use strict';
var anObject = require(1209);

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

},{"1209":1209}],1463:[function(require,module,exports){
var TO_STRING_TAG_SUPPORT = require(1392);
var defineBuiltIn = require(1247);
var toString = require(1341);

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  defineBuiltIn(Object.prototype, 'toString', toString, { unsafe: true });
}

},{"1247":1247,"1341":1341,"1392":1392}],1341:[function(require,module,exports){
'use strict';
var TO_STRING_TAG_SUPPORT = require(1392);
var classof = require(1234);

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};

},{"1234":1234,"1392":1392}],1437:[function(require,module,exports){
// TODO: Remove from `core-js@4`
var uncurryThis = require(1281);
var defineBuiltIn = require(1247);

var DatePrototype = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var nativeDateToString = uncurryThis(DatePrototype[TO_STRING]);
var thisTimeValue = uncurryThis(DatePrototype.getTime);

// `Date.prototype.toString` method
// https://tc39.es/ecma262/#sec-date.prototype.tostring
if (String(new Date(NaN)) != INVALID_DATE) {
  defineBuiltIn(DatePrototype, TO_STRING, function toString() {
    var value = thisTimeValue(this);
    // eslint-disable-next-line no-self-compare -- NaN check
    return value === value ? nativeDateToString(this) : INVALID_DATE;
  });
}

},{"1247":1247,"1281":1281}],1:[function(require,module,exports){
"use strict";

require(1454);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require(1497);
// MD3DCommentPosCalculator.js
// jiang
// 2016-8-19

function MD3DCommentPosCalculator(winW, winH, camera) {
  this.winSize = {
    width: winW,
    height: winH
  };
  this.camera = camera;
}
MD3DCommentPosCalculator.prototype = {
  constructor: MD3DCommentPosCalculator,
  intersects: function intersects(posInWin, objects) {
    var vector = new THREE.Vector3();
    var dvPos = posInWin;
    vector.set(dvPos.x / this.winSize.width * 2 - 1, -(dvPos.y / this.winSize.height) * 2 + 1, 0.5);
    vector.unproject(this.camera);
    var raycaster = new THREE.Raycaster(this.camera.position, vector.sub(this.camera.position).normalize());
    var allObjs = objects;
    var intersects = raycaster.intersectObjects(allObjs, true);
    var visibleIntersects = [];
    for (var i = 0; i < intersects.length; i++) {
      if (intersects[i].distance >= 1) {
        visibleIntersects.push(intersects[i]);
      }
    }
    ;
    return visibleIntersects;
  },
  objInfoAtScreenPos: function objInfoAtScreenPos(posInWin, objects) {
    var intersects = this.intersects(posInWin, objects);
    console.log('click objects:', intersects.length);
    var commentPosInfo = null;
    if (intersects.length > 0) {
      var firsInter = intersects[0];
      console.log('----> normal:', firsInter.face.normal.x, ',', firsInter.face.normal.y, ',', firsInter.face.normal.z);
      var lgPos = firsInter.point;
      var face = firsInter.face;
      var vertices = firsInter.object.geometry.vertices;
      var pts = [vertices[face.a].clone(), vertices[face.b].clone(), vertices[face.c].clone()];
      var rotation = new THREE.Matrix4();
      // rotation.makeRotationFromEuler(firsInter.object.rotation);
      rotation = firsInter.object.matrixWorld;
      for (var i = pts.length - 1; i >= 0; i--) {
        pts[i].applyMatrix4(rotation);
      }
      ;
      var v = [pts[0].clone().sub(pts[1]), pts[1].clone().sub(pts[2]), pts[2].clone().sub(pts[0])];
      var ptIndexes = [];
      var max1, max2;
      if (v[0].lengthSq() > v[1].lengthSq()) {
        if (v[2].lengthSq() > v[0].lengthSq()) {
          max1 = 2;
          max2 = 0;
          ptIndexes = [2, 0, 1];
        } else if (v[2].lengthSq() > v[1].lengthSq()) {
          max1 = 2;
          max2 = 0;
          ptIndexes = [2, 0, 1];
        } else {
          max1 = 0;
          max2 = 1;
          ptIndexes = [0, 1, 2];
        }
      } else {
        if (v[2].lengthSq() > v[1].lengthSq()) {
          max1 = 1;
          max2 = 2;
          ptIndexes = [1, 2, 0];
        } else if (v[2].lengthSq() > v[0].lengthSq()) {
          max1 = 1;
          max2 = 2;
          ptIndexes = [1, 2, 0];
        } else {
          max1 = 0;
          max2 = 1;
          ptIndexes = [0, 1, 2];
        }
      }
      var V1 = v[max1];
      var V2 = v[max2].negate();
      var V3 = lgPos.clone().sub(pts[max2]);
      var k1 = 1,
        k2 = 1;
      if (Math.abs(V1.x * V2.y - V2.x * V1.y) < 0.0001) {
        if (Math.abs(V1.y * V2.z - V2.y * V1.z) < 0.0001) {
          k1 = (V3.x * V2.z - V2.x * V3.z) / (V1.x * V2.z - V2.x * V1.z);
          k2 = (V1.x * V3.z - V3.x * V1.z) / (V1.x * V2.z - V2.x * V1.z);
        } else {
          k1 = (V3.y * V2.z - V2.y * V3.z) / (V1.y * V2.z - V2.y * V1.z);
          k2 = (V1.y * V3.z - V3.y * V1.z) / (V1.y * V2.z - V2.y * V1.z);
        }
      } else {
        k1 = (V3.x * V2.y - V2.x * V3.y) / (V1.x * V2.y - V2.x * V1.y);
        k2 = (V1.x * V3.y - V3.x * V1.y) / (V1.x * V2.y - V2.x * V1.y);
      }
      commentPosInfo = firsInter;
      commentPosInfo.k1 = k1;
      commentPosInfo.k2 = k2;
      commentPosInfo.ptIndexes = ptIndexes;
      console.log('cliked on object id:', firsInter.object.id);
    }
    ;
    return commentPosInfo;
  },
  calcuVertexPosForSkinMesh: function calcuVertexPosForSkinMesh(skinMesh) {
    var newVertexes = [];
    for (var i = 0; i < skinMesh.geometry.vertices.length; i++) {
      var v = skinMesh.geometry.vertices[i];
      var skinIndex = skinMesh.geometry.skinIndices[i];
      var skinWeight = skinMesh.geometry.skinWeights[i];
      var indexes = ['x', 'y', 'z', 'w'];
      var fv = new THREE.Vector3(0, 0, 0);
      for (var k = 0; k < 4; k++) {
        var boneIndex = skinIndex[indexes[k]];
        var w = skinWeight[indexes[k]];
        if (boneIndex < skinMesh.skeleton.bones.length && w) {
          var boneM = skinMesh.skeleton.bones[boneIndex].matrixWorld.clone();
          var boneMInverse = skinMesh.skeleton.boneInverses[boneIndex].clone();
          // boneMInverse.getInverse(mesh.skeleton.boneInverses[boneIndex]);
          boneM.multiply(boneMInverse);
          var vk = v.clone().applyMatrix4(boneM.multiplyScalar(w));
          fv.add(vk);
        }
        if (boneIndex == 1) {
          // console.log("bone x:", bone.position.x, " y:", bone.position.y, " z:", bone.position.z);
          var tem = 0;
        }
        ;
      }
      ;
      newVertexes.push(fv);
    }
    ;
  },
  updateWinSize: function updateWinSize(w, h) {
    this.winSize = {
      width: w,
      height: h
    };
  }
};
var _default = exports["default"] = MD3DCommentPosCalculator;

},{"1454":1454,"1497":1497}],1497:[function(require,module,exports){
'use strict';
var $ = require(1270);
var createHTML = require(1241);
var forcedStringHTMLMethod = require(1368);

// `String.prototype.sub` method
// https://tc39.es/ecma262/#sec-string.prototype.sub
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('sub') }, {
  sub: function sub() {
    return createHTML(this, 'sub', '', '');
  }
});

},{"1241":1241,"1270":1270,"1368":1368}],1368:[function(require,module,exports){
var fails = require(1271);

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
module.exports = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};

},{"1271":1271}],1241:[function(require,module,exports){
var uncurryThis = require(1281);
var requireObjectCoercible = require(1359);
var toString = require(1393);

var quot = /"/g;
var replace = uncurryThis(''.replace);

// `CreateHTML` abstract operation
// https://tc39.es/ecma262/#sec-createhtml
module.exports = function (string, tag, attribute, value) {
  var S = toString(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + replace(toString(value), quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};

},{"1281":1281,"1359":1359,"1393":1393}],1393:[function(require,module,exports){
var classof = require(1234);

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};

},{"1234":1234}],1234:[function(require,module,exports){
var TO_STRING_TAG_SUPPORT = require(1392);
var isCallable = require(1302);
var classofRaw = require(1233);
var wellKnownSymbol = require(1408);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};

},{"1233":1233,"1302":1302,"1392":1392,"1408":1408}],1392:[function(require,module,exports){
var wellKnownSymbol = require(1408);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';

},{"1408":1408}],1454:[function(require,module,exports){
var $ = require(1270);
var DESCRIPTORS = require(1251);
var defineProperty = require(1328).f;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
// eslint-disable-next-line es/no-object-defineproperty -- safe
$({ target: 'Object', stat: true, forced: Object.defineProperty !== defineProperty, sham: !DESCRIPTORS }, {
  defineProperty: defineProperty
});

},{"1251":1251,"1270":1270,"1328":1328}],1270:[function(require,module,exports){
var global = require(1287);
var getOwnPropertyDescriptor = require(1329).f;
var createNonEnumerableProperty = require(1243);
var defineBuiltIn = require(1247);
var defineGlobalProperty = require(1249);
var copyConstructorProperties = require(1238);
var isForced = require(1304);

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};

},{"1238":1238,"1243":1243,"1247":1247,"1249":1249,"1287":1287,"1304":1304,"1329":1329}],1304:[function(require,module,exports){
var fails = require(1271);
var isCallable = require(1302);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;

},{"1271":1271,"1302":1302}],1247:[function(require,module,exports){
var isCallable = require(1302);
var definePropertyModule = require(1328);
var makeBuiltIn = require(1318);
var defineGlobalProperty = require(1249);

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

},{"1249":1249,"1302":1302,"1318":1318,"1328":1328}],1318:[function(require,module,exports){
var fails = require(1271);
var isCallable = require(1302);
var hasOwn = require(1288);
var DESCRIPTORS = require(1251);
var CONFIGURABLE_FUNCTION_NAME = require(1279).CONFIGURABLE;
var inspectSource = require(1296);
var InternalStateModule = require(1298);

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (String(name).slice(0, 7) === 'Symbol(') {
    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');

},{"1251":1251,"1271":1271,"1279":1279,"1288":1288,"1296":1296,"1298":1298,"1302":1302}],1298:[function(require,module,exports){
var NATIVE_WEAK_MAP = require(1405);
var global = require(1287);
var isObject = require(1307);
var createNonEnumerableProperty = require(1243);
var hasOwn = require(1288);
var shared = require(1365);
var sharedKey = require(1364);
var hiddenKeys = require(1289);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

},{"1243":1243,"1287":1287,"1288":1288,"1289":1289,"1307":1307,"1364":1364,"1365":1365,"1405":1405}],1405:[function(require,module,exports){
var global = require(1287);
var isCallable = require(1302);

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));

},{"1287":1287,"1302":1302}],1364:[function(require,module,exports){
var shared = require(1366);
var uid = require(1400);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

},{"1366":1366,"1400":1400}],1296:[function(require,module,exports){
var uncurryThis = require(1281);
var isCallable = require(1302);
var store = require(1365);

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;

},{"1281":1281,"1302":1302,"1365":1365}],1279:[function(require,module,exports){
var DESCRIPTORS = require(1251);
var hasOwn = require(1288);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

},{"1251":1251,"1288":1288}],1243:[function(require,module,exports){
var DESCRIPTORS = require(1251);
var definePropertyModule = require(1328);
var createPropertyDescriptor = require(1244);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

},{"1244":1244,"1251":1251,"1328":1328}],1238:[function(require,module,exports){
var hasOwn = require(1288);
var ownKeys = require(1343);
var getOwnPropertyDescriptorModule = require(1329);
var definePropertyModule = require(1328);

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

},{"1288":1288,"1328":1328,"1329":1329,"1343":1343}],1343:[function(require,module,exports){
var getBuiltIn = require(1282);
var uncurryThis = require(1281);
var getOwnPropertyNamesModule = require(1331);
var getOwnPropertySymbolsModule = require(1332);
var anObject = require(1209);

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};

},{"1209":1209,"1281":1281,"1282":1282,"1331":1331,"1332":1332}],1332:[function(require,module,exports){
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;

},{}],1331:[function(require,module,exports){
var internalObjectKeys = require(1336);
var enumBugKeys = require(1269);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};

},{"1269":1269,"1336":1336}],1336:[function(require,module,exports){
var uncurryThis = require(1281);
var hasOwn = require(1288);
var toIndexedObject = require(1384);
var indexOf = require(1219).indexOf;
var hiddenKeys = require(1289);

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};

},{"1219":1219,"1281":1281,"1288":1288,"1289":1289,"1384":1384}],1289:[function(require,module,exports){
module.exports = {};

},{}],1219:[function(require,module,exports){
var toIndexedObject = require(1384);
var toAbsoluteIndex = require(1381);
var lengthOfArrayLike = require(1317);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

},{"1317":1317,"1381":1381,"1384":1384}],1381:[function(require,module,exports){
var toIntegerOrInfinity = require(1385);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};

},{"1385":1385}],1317:[function(require,module,exports){
var toLength = require(1386);

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};

},{"1386":1386}],1386:[function(require,module,exports){
var toIntegerOrInfinity = require(1385);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

},{"1385":1385}],1385:[function(require,module,exports){
var trunc = require(1319);

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

},{"1319":1319}],1319:[function(require,module,exports){
var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};

},{}],1269:[function(require,module,exports){
// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

},{}],1329:[function(require,module,exports){
var DESCRIPTORS = require(1251);
var call = require(1278);
var propertyIsEnumerableModule = require(1338);
var createPropertyDescriptor = require(1244);
var toIndexedObject = require(1384);
var toPropertyKey = require(1391);
var hasOwn = require(1288);
var IE8_DOM_DEFINE = require(1292);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};

},{"1244":1244,"1251":1251,"1278":1278,"1288":1288,"1292":1292,"1338":1338,"1384":1384,"1391":1391}],1384:[function(require,module,exports){
// toObject with fallback for non-array-like ES3 strings
var IndexedObject = require(1294);
var requireObjectCoercible = require(1359);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};

},{"1294":1294,"1359":1359}],1294:[function(require,module,exports){
var uncurryThis = require(1281);
var fails = require(1271);
var classof = require(1233);

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : $Object(it);
} : $Object;

},{"1233":1233,"1271":1271,"1281":1281}],1233:[function(require,module,exports){
var uncurryThis = require(1281);

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};

},{"1281":1281}],1338:[function(require,module,exports){
'use strict';
var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

},{}],1244:[function(require,module,exports){
module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

},{}],1328:[function(require,module,exports){
var DESCRIPTORS = require(1251);
var IE8_DOM_DEFINE = require(1292);
var V8_PROTOTYPE_DEFINE_BUG = require(1403);
var anObject = require(1209);
var toPropertyKey = require(1391);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

},{"1209":1209,"1251":1251,"1292":1292,"1391":1391,"1403":1403}],1403:[function(require,module,exports){
var DESCRIPTORS = require(1251);
var fails = require(1271);

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

},{"1251":1251,"1271":1271}],1391:[function(require,module,exports){
var toPrimitive = require(1390);
var isSymbol = require(1310);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

},{"1310":1310,"1390":1390}],1390:[function(require,module,exports){
var call = require(1278);
var isObject = require(1307);
var isSymbol = require(1310);
var getMethod = require(1285);
var ordinaryToPrimitive = require(1342);
var wellKnownSymbol = require(1408);

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

},{"1278":1278,"1285":1285,"1307":1307,"1310":1310,"1342":1342,"1408":1408}],1408:[function(require,module,exports){
var global = require(1287);
var shared = require(1366);
var hasOwn = require(1288);
var uid = require(1400);
var NATIVE_SYMBOL = require(1376);
var USE_SYMBOL_AS_UID = require(1402);

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var symbolFor = Symbol && Symbol['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};

},{"1287":1287,"1288":1288,"1366":1366,"1376":1376,"1400":1400,"1402":1402}],1400:[function(require,module,exports){
var uncurryThis = require(1281);

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};

},{"1281":1281}],1366:[function(require,module,exports){
var IS_PURE = require(1308);
var store = require(1365);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.27.0',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.27.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

},{"1308":1308,"1365":1365}],1365:[function(require,module,exports){
var global = require(1287);
var defineGlobalProperty = require(1249);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;

},{"1249":1249,"1287":1287}],1249:[function(require,module,exports){
var global = require(1287);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};

},{"1287":1287}],1308:[function(require,module,exports){
module.exports = false;

},{}],1342:[function(require,module,exports){
var call = require(1278);
var isCallable = require(1302);
var isObject = require(1307);

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw $TypeError("Can't convert object to primitive value");
};

},{"1278":1278,"1302":1302,"1307":1307}],1285:[function(require,module,exports){
var aCallable = require(1203);
var isNullOrUndefined = require(1306);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};

},{"1203":1203,"1306":1306}],1203:[function(require,module,exports){
var isCallable = require(1302);
var tryToString = require(1394);

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a function');
};

},{"1302":1302,"1394":1394}],1394:[function(require,module,exports){
var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};

},{}],1278:[function(require,module,exports){
var NATIVE_BIND = require(1276);

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};

},{"1276":1276}],1310:[function(require,module,exports){
var getBuiltIn = require(1282);
var isCallable = require(1302);
var isPrototypeOf = require(1335);
var USE_SYMBOL_AS_UID = require(1402);

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};

},{"1282":1282,"1302":1302,"1335":1335,"1402":1402}],1402:[function(require,module,exports){
/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = require(1376);

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

},{"1376":1376}],1376:[function(require,module,exports){
/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = require(1267);
var fails = require(1271);

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

},{"1267":1267,"1271":1271}],1267:[function(require,module,exports){
var global = require(1287);
var userAgent = require(1266);

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;

},{"1266":1266,"1287":1287}],1266:[function(require,module,exports){
var getBuiltIn = require(1282);

module.exports = getBuiltIn('navigator', 'userAgent') || '';

},{"1282":1282}],1335:[function(require,module,exports){
var uncurryThis = require(1281);

module.exports = uncurryThis({}.isPrototypeOf);

},{"1281":1281}],1282:[function(require,module,exports){
var global = require(1287);
var isCallable = require(1302);

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};

},{"1287":1287,"1302":1302}],1292:[function(require,module,exports){
var DESCRIPTORS = require(1251);
var fails = require(1271);
var createElement = require(1253);

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

},{"1251":1251,"1253":1253,"1271":1271}],1253:[function(require,module,exports){
var global = require(1287);
var isObject = require(1307);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};

},{"1287":1287,"1307":1307}],1287:[function(require,module,exports){
(function (global){(function (){
var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],1209:[function(require,module,exports){
var isObject = require(1307);

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw $TypeError($String(argument) + ' is not an object');
};

},{"1307":1307}],1307:[function(require,module,exports){
var isCallable = require(1302);
var $documentAll = require(1252);

var documentAll = $documentAll.all;

module.exports = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};

},{"1252":1252,"1302":1302}],1302:[function(require,module,exports){
var $documentAll = require(1252);

var documentAll = $documentAll.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = $documentAll.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};

},{"1252":1252}],1252:[function(require,module,exports){
var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;

module.exports = {
  all: documentAll,
  IS_HTMLDDA: IS_HTMLDDA
};

},{}],1288:[function(require,module,exports){
var uncurryThis = require(1281);
var toObject = require(1387);

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};

},{"1281":1281,"1387":1387}],1387:[function(require,module,exports){
var requireObjectCoercible = require(1359);

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};

},{"1359":1359}],1359:[function(require,module,exports){
var isNullOrUndefined = require(1306);

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw $TypeError("Can't call method on " + it);
  return it;
};

},{"1306":1306}],1306:[function(require,module,exports){
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};

},{}],1281:[function(require,module,exports){
var NATIVE_BIND = require(1276);

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};

},{"1276":1276}],1276:[function(require,module,exports){
var fails = require(1271);

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

},{"1271":1271}],1251:[function(require,module,exports){
var fails = require(1271);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

},{"1271":1271}],1271:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

},{}]},{},[]);
